
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("cGZ2T", function(module, exports) {
$parcel$export(module.exports, "getSpaRoutes", () => $944610ff6034f8ed$export$10439de9ce871f28);
/*
 * This file is generated. Do not modify manually
 * If you are adding or deleting a route, please run "yarn dev routes:generate-route-assets"
 * to re-generate this SPA route map and RouteName/RouteGroup types then commit the changes.
 * @generated SignedSource<<60c77bb1cd8a8095fba9363b5bd212bc>>
 * @codegen-command: yarn dev routes:generate-route-map --filter spa
 */ 
var $11dzU = parcelRequire("11dzU");

var $lfMhu = parcelRequire("lfMhu");

var $ee1nh = parcelRequire("ee1nh");

var $krjBK = parcelRequire("krjBK");

var $4gGhz = parcelRequire("4gGhz");

var $5ia5u = parcelRequire("5ia5u");

var $6dcTd = parcelRequire("6dcTd");

var $f1v24 = parcelRequire("f1v24");

var $fJYOn = parcelRequire("fJYOn");

var $aqyuv = parcelRequire("aqyuv");

var $z4Vlj = parcelRequire("z4Vlj");

var $3Yc1O = parcelRequire("3Yc1O");

var $59Sas = parcelRequire("59Sas");

var $5amE5 = parcelRequire("5amE5");

var $Ae6y0 = parcelRequire("Ae6y0");

var $60s4z = parcelRequire("60s4z");

var $59pT0 = parcelRequire("59pT0");

var $2a44M = parcelRequire("2a44M");

var $VL8fh = parcelRequire("VL8fh");

var $iGEun = parcelRequire("iGEun");

var $1EaRu = parcelRequire("1EaRu");

var $sXwqJ = parcelRequire("sXwqJ");

var $jGn6O = parcelRequire("jGn6O");

var $3FQW7 = parcelRequire("3FQW7");

var $e8JLL = parcelRequire("e8JLL");

var $7Txn7 = parcelRequire("7Txn7");

var $d9CZt = parcelRequire("d9CZt");

var $46xzL = parcelRequire("46xzL");

var $29RF5 = parcelRequire("29RF5");

var $5c8XY = parcelRequire("5c8XY");

var $1XPY3 = parcelRequire("1XPY3");

var $lVbe0 = parcelRequire("lVbe0");

var $7zRXQ = parcelRequire("7zRXQ");

var $ehmfE = parcelRequire("ehmfE");

var $47pCb = parcelRequire("47pCb");

var $j20Cx = parcelRequire("j20Cx");

var $9UEdj = parcelRequire("9UEdj");

var $hiWBS = parcelRequire("hiWBS");

var $aS2Q3 = parcelRequire("aS2Q3");

var $lvNEg = parcelRequire("lvNEg");

var $dHwrc = parcelRequire("dHwrc");

var $gM6QF = parcelRequire("gM6QF");

var $5bC3H = parcelRequire("5bC3H");

var $bkh9V = parcelRequire("bkh9V");

var $gzEKj = parcelRequire("gzEKj");

var $8It8d = parcelRequire("8It8d");

var $2OdJy = parcelRequire("2OdJy");

var $1mi9U = parcelRequire("1mi9U");

var $dTOhd = parcelRequire("dTOhd");

var $fXfmE = parcelRequire("fXfmE");

var $KwSsA = parcelRequire("KwSsA");

var $8UPVQ = parcelRequire("8UPVQ");

var $fjjEb = parcelRequire("fjjEb");

var $cN9Dp = parcelRequire("cN9Dp");

var $1ImkA = parcelRequire("1ImkA");

var $adRjZ = parcelRequire("adRjZ");

var $bycrh = parcelRequire("bycrh");

var $jJYmM = parcelRequire("jJYmM");

var $abM4d = parcelRequire("abM4d");

var $6Vpfk = parcelRequire("6Vpfk");

var $4B97A = parcelRequire("4B97A");

var $jKJAa = parcelRequire("jKJAa");

var $9JJN0 = parcelRequire("9JJN0");

var $iMUwg = parcelRequire("iMUwg");

var $hq8Us = parcelRequire("hq8Us");

var $bQFcP = parcelRequire("bQFcP");

var $epwzI = parcelRequire("epwzI");

var $lSD2k = parcelRequire("lSD2k");

var $5dv8e = parcelRequire("5dv8e");

var $eEbPJ = parcelRequire("eEbPJ");

var $pX0Lb = parcelRequire("pX0Lb");

var $7YisL = parcelRequire("7YisL");

var $l5plY = parcelRequire("l5plY");

var $hz0Io = parcelRequire("hz0Io");

var $jKGqh = parcelRequire("jKGqh");

var $lGX8C = parcelRequire("lGX8C");

var $9HrlX = parcelRequire("9HrlX");

var $9HdUU = parcelRequire("9HdUU");

var $2g81E = parcelRequire("2g81E");

var $jzbS2 = parcelRequire("jzbS2");

var $e4FF2 = parcelRequire("e4FF2");

var $iTMvW = parcelRequire("iTMvW");

var $7tU8P = parcelRequire("7tU8P");

var $3dCUd = parcelRequire("3dCUd");

var $hNTUt = parcelRequire("hNTUt");

var $jHnnR = parcelRequire("jHnnR");

var $deexU = parcelRequire("deexU");

var $9OOVl = parcelRequire("9OOVl");

var $dHEBg = parcelRequire("dHEBg");

var $3imAc = parcelRequire("3imAc");

var $48hVA = parcelRequire("48hVA");

var $eCgFr = parcelRequire("eCgFr");

var $dQEuk = parcelRequire("dQEuk");

var $znXcS = parcelRequire("znXcS");

var $1zdWe = parcelRequire("1zdWe");

var $jdODC = parcelRequire("jdODC");

var $eYoel = parcelRequire("eYoel");

var $llrpu = parcelRequire("llrpu");

var $fv3de = parcelRequire("fv3de");

var $iAxPI = parcelRequire("iAxPI");

var $15xtU = parcelRequire("15xtU");

var $kIBbg = parcelRequire("kIBbg");

var $dHEQJ = parcelRequire("dHEQJ");

var $fQwjt = parcelRequire("fQwjt");

var $8yLn2 = parcelRequire("8yLn2");

var $47JK3 = parcelRequire("47JK3");

var $bFdfN = parcelRequire("bFdfN");

var $38RVN = parcelRequire("38RVN");

var $hUFuU = parcelRequire("hUFuU");

var $igvH2 = parcelRequire("igvH2");

var $eBdZD = parcelRequire("eBdZD");

var $1Vf8Q = parcelRequire("1Vf8Q");

var $3GtBH = parcelRequire("3GtBH");

var $ceOvr = parcelRequire("ceOvr");

var $fHE3O = parcelRequire("fHE3O");

var $ky4fW = parcelRequire("ky4fW");

var $fLdTj = parcelRequire("fLdTj");

var $31aCF = parcelRequire("31aCF");

var $jtStO = parcelRequire("jtStO");

var $hEHYT = parcelRequire("hEHYT");

var $6uGHB = parcelRequire("6uGHB");

var $3ssEl = parcelRequire("3ssEl");

var $cjjH8 = parcelRequire("cjjH8");

var $jBwQs = parcelRequire("jBwQs");

var $asE3T = parcelRequire("asE3T");

var $dbws7 = parcelRequire("dbws7");

var $adv8s = parcelRequire("adv8s");

var $3gpmo = parcelRequire("3gpmo");

var $6uOxh = parcelRequire("6uOxh");

var $frSu6 = parcelRequire("frSu6");

var $67hGn = parcelRequire("67hGn");

var $5GDxf = parcelRequire("5GDxf");

var $979NP = parcelRequire("979NP");

var $5PmmP = parcelRequire("5PmmP");

var $jyQEq = parcelRequire("jyQEq");

var $7sPfV = parcelRequire("7sPfV");

var $4qitY = parcelRequire("4qitY");

var $4h98W = parcelRequire("4h98W");

var $lf8kK = parcelRequire("lf8kK");

var $7nJMb = parcelRequire("7nJMb");

var $VMFYy = parcelRequire("VMFYy");

var $ex20g = parcelRequire("ex20g");

var $egvB1 = parcelRequire("egvB1");

var $4PqDp = parcelRequire("4PqDp");

var $3GrQ7 = parcelRequire("3GrQ7");

var $lzHoK = parcelRequire("lzHoK");

var $koyMU = parcelRequire("koyMU");

var $i0RFn = parcelRequire("i0RFn");

var $eidt5 = parcelRequire("eidt5");

var $7C3ge = parcelRequire("7C3ge");

var $4LA4D = parcelRequire("4LA4D");

var $1wKev = parcelRequire("1wKev");

var $cQX3l = parcelRequire("cQX3l");

var $9NBqm = parcelRequire("9NBqm");

var $7zQip = parcelRequire("7zQip");

var $539KO = parcelRequire("539KO");

var $4jDe2 = parcelRequire("4jDe2");

var $30sWD = parcelRequire("30sWD");

var $d7pXC = parcelRequire("d7pXC");

var $dYo5g = parcelRequire("dYo5g");

var $cnYCZ = parcelRequire("cnYCZ");

var $0r9on = parcelRequire("0r9on");

var $4wYea = parcelRequire("4wYea");

var $71iCS = parcelRequire("71iCS");

var $3TNYf = parcelRequire("3TNYf");

var $iuPZI = parcelRequire("iuPZI");

var $3GLXX = parcelRequire("3GLXX");

var $jxFtK = parcelRequire("jxFtK");

var $40MXz = parcelRequire("40MXz");

var $3FsXl = parcelRequire("3FsXl");

var $iLYrw = parcelRequire("iLYrw");

var $iz2Yc = parcelRequire("iz2Yc");

var $eKz3o = parcelRequire("eKz3o");

var $cNKzQ = parcelRequire("cNKzQ");

var $cMk4h = parcelRequire("cMk4h");

var $5ODMu = parcelRequire("5ODMu");

var $gfTDK = parcelRequire("gfTDK");

var $40AJ4 = parcelRequire("40AJ4");

var $KJMPg = parcelRequire("KJMPg");

var $6RjSU = parcelRequire("6RjSU");

var $5o6W5 = parcelRequire("5o6W5");

var $9fj3k = parcelRequire("9fj3k");

var $2eUNm = parcelRequire("2eUNm");

var $dJeUf = parcelRequire("dJeUf");

var $2FXYc = parcelRequire("2FXYc");

var $bPuPn = parcelRequire("bPuPn");

var $5VrQ2 = parcelRequire("5VrQ2");

var $bDwmW = parcelRequire("bDwmW");

var $effIZ = parcelRequire("effIZ");

var $9gv99 = parcelRequire("9gv99");

var $lNHO4 = parcelRequire("lNHO4");

var $4vy2X = parcelRequire("4vy2X");

var $dYZBt = parcelRequire("dYZBt");

var $7NvQX = parcelRequire("7NvQX");

var $edGnQ = parcelRequire("edGnQ");

var $9Jj26 = parcelRequire("9Jj26");

var $aV7rM = parcelRequire("aV7rM");

var $6m8PU = parcelRequire("6m8PU");

var $fOrIK = parcelRequire("fOrIK");

var $3gQSV = parcelRequire("3gQSV");

var $imspb = parcelRequire("imspb");

var $49q2u = parcelRequire("49q2u");

var $jswqy = parcelRequire("jswqy");

var $6nKGg = parcelRequire("6nKGg");

var $kvwgI = parcelRequire("kvwgI");

var $cFf23 = parcelRequire("cFf23");

var $iuMQY = parcelRequire("iuMQY");

var $6Dohh = parcelRequire("6Dohh");

var $fJVg1 = parcelRequire("fJVg1");

var $SDmDy = parcelRequire("SDmDy");

var $aL0Nn = parcelRequire("aL0Nn");

var $l1Fco = parcelRequire("l1Fco");

var $jlZ27 = parcelRequire("jlZ27");

var $ucY9k = parcelRequire("ucY9k");

var $gX0iW = parcelRequire("gX0iW");

var $90t7w = parcelRequire("90t7w");

var $3nRWh = parcelRequire("3nRWh");

var $aSN2a = parcelRequire("aSN2a");

var $jTbdr = parcelRequire("jTbdr");

var $doFbY = parcelRequire("doFbY");

var $fWzFt = parcelRequire("fWzFt");

var $9vtbm = parcelRequire("9vtbm");

var $1ctLf = parcelRequire("1ctLf");

var $ex4qh = parcelRequire("ex4qh");

var $gueFU = parcelRequire("gueFU");

var $dQVsZ = parcelRequire("dQVsZ");

var $6JUWC = parcelRequire("6JUWC");

var $bPj2c = parcelRequire("bPj2c");

var $lX8j4 = parcelRequire("lX8j4");

var $7IvSo = parcelRequire("7IvSo");

var $bs4Dp = parcelRequire("bs4Dp");

var $cjarc = parcelRequire("cjarc");

var $eoMSY = parcelRequire("eoMSY");

var $ewhVC = parcelRequire("ewhVC");

var $ezBBh = parcelRequire("ezBBh");

var $3omKb = parcelRequire("3omKb");

var $fSv9U = parcelRequire("fSv9U");

var $g3ZQl = parcelRequire("g3ZQl");

var $9WyQi = parcelRequire("9WyQi");

var $2Wapk = parcelRequire("2Wapk");

var $b829t = parcelRequire("b829t");

var $8FLFs = parcelRequire("8FLFs");

var $6368z = parcelRequire("6368z");

var $dL4cN = parcelRequire("dL4cN");

var $WtQtU = parcelRequire("WtQtU");

var $98WKd = parcelRequire("98WKd");

var $21UpQ = parcelRequire("21UpQ");

var $6IPAd = parcelRequire("6IPAd");

var $exdpX = parcelRequire("exdpX");

var $arNsV = parcelRequire("arNsV");

var $3ENn5 = parcelRequire("3ENn5");

var $uQst0 = parcelRequire("uQst0");

var $hr37Z = parcelRequire("hr37Z");

var $hlKdK = parcelRequire("hlKdK");

var $4ctNm = parcelRequire("4ctNm");

var $g8xCO = parcelRequire("g8xCO");

var $hAZdW = parcelRequire("hAZdW");

var $fnBKt = parcelRequire("fnBKt");

var $hkkWR = parcelRequire("hkkWR");

var $6Je0z = parcelRequire("6Je0z");

var $3nqiL = parcelRequire("3nqiL");

var $ha5bJ = parcelRequire("ha5bJ");

var $jTZk2 = parcelRequire("jTZk2");

var $nK9GP = parcelRequire("nK9GP");

var $3vNqj = parcelRequire("3vNqj");

var $5LoRz = parcelRequire("5LoRz");

var $jYUJK = parcelRequire("jYUJK");

var $avx7c = parcelRequire("avx7c");

var $38q9i = parcelRequire("38q9i");

var $hda6p = parcelRequire("hda6p");

var $2BCjc = parcelRequire("2BCjc");

var $aFBIC = parcelRequire("aFBIC");

var $6Thsk = parcelRequire("6Thsk");

var $f5nHW = parcelRequire("f5nHW");

var $6REob = parcelRequire("6REob");

var $30CEL = parcelRequire("30CEL");

var $1i3Ly = parcelRequire("1i3Ly");

var $dCSf1 = parcelRequire("dCSf1");

var $6a25y = parcelRequire("6a25y");

var $H15ro = parcelRequire("H15ro");

var $eI7S7 = parcelRequire("eI7S7");

var $eQJy2 = parcelRequire("eQJy2");

var $dVpN0 = parcelRequire("dVpN0");

var $hZMof = parcelRequire("hZMof");

var $9Gg1F = parcelRequire("9Gg1F");

var $2yOeJ = parcelRequire("2yOeJ");

var $6jRt0 = parcelRequire("6jRt0");

var $ij9Oa = parcelRequire("ij9Oa");

var $73GfK = parcelRequire("73GfK");

var $guOXW = parcelRequire("guOXW");

var $kLcj1 = parcelRequire("kLcj1");

var $cxIS4 = parcelRequire("cxIS4");

var $iDLuu = parcelRequire("iDLuu");

var $15dwL = parcelRequire("15dwL");

var $gyHjd = parcelRequire("gyHjd");

var $g8j6S = parcelRequire("g8j6S");

var $hJOuW = parcelRequire("hJOuW");

var $hxZix = parcelRequire("hxZix");

var $bnYNC = parcelRequire("bnYNC");

var $4CIaD = parcelRequire("4CIaD");

var $5NZLw = parcelRequire("5NZLw");

var $aCb3M = parcelRequire("aCb3M");

var $5FbjP = parcelRequire("5FbjP");

var $d3C53 = parcelRequire("d3C53");

var $dEfbu = parcelRequire("dEfbu");

var $7NyWg = parcelRequire("7NyWg");

var $gYR3D = parcelRequire("gYR3D");

var $8N41I = parcelRequire("8N41I");

var $LrcKp = parcelRequire("LrcKp");

var $l7tPZ = parcelRequire("l7tPZ");

var $3rrWW = parcelRequire("3rrWW");

var $j9fZa = parcelRequire("j9fZa");

var $1Uc3N = parcelRequire("1Uc3N");

var $b3kdA = parcelRequire("b3kdA");

var $76As8 = parcelRequire("76As8");

var $9F5gK = parcelRequire("9F5gK");

var $jSGFY = parcelRequire("jSGFY");

var $3I3w7 = parcelRequire("3I3w7");

var $kWaDE = parcelRequire("kWaDE");

var $2YBdr = parcelRequire("2YBdr");

var $lxwe8 = parcelRequire("lxwe8");

var $5tx3g = parcelRequire("5tx3g");

var $bZnet = parcelRequire("bZnet");

var $9pVk4 = parcelRequire("9pVk4");

var $etuKr = parcelRequire("etuKr");

var $1A3Ru = parcelRequire("1A3Ru");

var $4Jkh6 = parcelRequire("4Jkh6");

var $4Haw9 = parcelRequire("4Haw9");

var $aXz6t = parcelRequire("aXz6t");

var $lkewN = parcelRequire("lkewN");

var $figDu = parcelRequire("figDu");

var $iTCvp = parcelRequire("iTCvp");

var $7npnA = parcelRequire("7npnA");

var $56dYq = parcelRequire("56dYq");

var $QGZql = parcelRequire("QGZql");

var $bBBkV = parcelRequire("bBBkV");

var $hKZO1 = parcelRequire("hKZO1");

var $6KpYG = parcelRequire("6KpYG");

var $dwoYZ = parcelRequire("dwoYZ");

var $cbPm4 = parcelRequire("cbPm4");

var $6IdT3 = parcelRequire("6IdT3");

var $3mG0v = parcelRequire("3mG0v");

var $2yyrl = parcelRequire("2yyrl");

var $5iCME = parcelRequire("5iCME");

var $7gg2B = parcelRequire("7gg2B");

var $5w386 = parcelRequire("5w386");

var $1MRQH = parcelRequire("1MRQH");

var $3HY5k = parcelRequire("3HY5k");

var $4HAfX = parcelRequire("4HAfX");

var $eUWpI = parcelRequire("eUWpI");

var $aze16 = parcelRequire("aze16");

var $c9rAZ = parcelRequire("c9rAZ");

var $kHwre = parcelRequire("kHwre");

var $ejKE2 = parcelRequire("ejKE2");

var $4JzGG = parcelRequire("4JzGG");

var $5j4hU = parcelRequire("5j4hU");

var $VpjMH = parcelRequire("VpjMH");

var $i2Yzm = parcelRequire("i2Yzm");

var $lpgz5 = parcelRequire("lpgz5");

var $8OFru = parcelRequire("8OFru");

var $kya75 = parcelRequire("kya75");

var $cpKx3 = parcelRequire("cpKx3");

var $bfuFe = parcelRequire("bfuFe");

var $8u2Ns = parcelRequire("8u2Ns");

var $hSdYi = parcelRequire("hSdYi");

var $1srm4 = parcelRequire("1srm4");

var $lUnDC = parcelRequire("lUnDC");

var $G2OkG = parcelRequire("G2OkG");

var $5I7GX = parcelRequire("5I7GX");

var $3O97K = parcelRequire("3O97K");

var $hjRvB = parcelRequire("hjRvB");

var $6gY16 = parcelRequire("6gY16");

var $f5SC3 = parcelRequire("f5SC3");

var $80MOq = parcelRequire("80MOq");

var $eWRDs = parcelRequire("eWRDs");

var $kBu1n = parcelRequire("kBu1n");

var $7ch29 = parcelRequire("7ch29");

var $cSfj2 = parcelRequire("cSfj2");

var $bytv6 = parcelRequire("bytv6");

var $ki0Kw = parcelRequire("ki0Kw");

var $4q4hj = parcelRequire("4q4hj");

var $adYD6 = parcelRequire("adYD6");

var $F88dL = parcelRequire("F88dL");

var $4AhEY = parcelRequire("4AhEY");

var $9VX8H = parcelRequire("9VX8H");

var $gd2CR = parcelRequire("gd2CR");

var $gAPvJ = parcelRequire("gAPvJ");

var $dHOWY = parcelRequire("dHOWY");

var $hCocS = parcelRequire("hCocS");

var $8HcaY = parcelRequire("8HcaY");

var $2vc0R = parcelRequire("2vc0R");

var $cIgeF = parcelRequire("cIgeF");

var $5FEz6 = parcelRequire("5FEz6");

var $7855X = parcelRequire("7855X");

var $d9EEX = parcelRequire("d9EEX");

var $4TdbT = parcelRequire("4TdbT");

var $dSDGg = parcelRequire("dSDGg");

var $eZca2 = parcelRequire("eZca2");

var $4yVjT = parcelRequire("4yVjT");

var $iw2x7 = parcelRequire("iw2x7");

var $hfHFu = parcelRequire("hfHFu");

var $eZYyu = parcelRequire("eZYyu");

var $2VKyb = parcelRequire("2VKyb");

var $1lT1j = parcelRequire("1lT1j");

var $eb3ne = parcelRequire("eb3ne");

var $fflqE = parcelRequire("fflqE");

var $gLnPj = parcelRequire("gLnPj");

var $3aM5P = parcelRequire("3aM5P");

var $j6et5 = parcelRequire("j6et5");

var $8d4Pa = parcelRequire("8d4Pa");

var $gW2I6 = parcelRequire("gW2I6");

var $32FNJ = parcelRequire("32FNJ");

var $68BYI = parcelRequire("68BYI");

var $1nenU = parcelRequire("1nenU");

var $i6yvS = parcelRequire("i6yvS");

var $6EC2N = parcelRequire("6EC2N");

var $8Iamy = parcelRequire("8Iamy");

var $1ZZjB = parcelRequire("1ZZjB");

var $bckOF = parcelRequire("bckOF");

var $8JjPR = parcelRequire("8JjPR");

var $ccbVD = parcelRequire("ccbVD");

var $3i3Pz = parcelRequire("3i3Pz");

var $cqwf2 = parcelRequire("cqwf2");

var $92Eq3 = parcelRequire("92Eq3");

var $3GJk3 = parcelRequire("3GJk3");

var $6k2Ti = parcelRequire("6k2Ti");

var $7yRej = parcelRequire("7yRej");

var $gDjnr = parcelRequire("gDjnr");

var $giPrt = parcelRequire("giPrt");

var $iEsMS = parcelRequire("iEsMS");

var $lGgL6 = parcelRequire("lGgL6");

var $iZwgi = parcelRequire("iZwgi");

var $br5Fp = parcelRequire("br5Fp");

var $cgIlc = parcelRequire("cgIlc");

var $fVlxG = parcelRequire("fVlxG");

var $2rAKo = parcelRequire("2rAKo");

var $3HyYd = parcelRequire("3HyYd");

var $kaJTo = parcelRequire("kaJTo");

var $2uYIw = parcelRequire("2uYIw");

var $gPrfx = parcelRequire("gPrfx");

var $fBDjl = parcelRequire("fBDjl");

var $3uXTj = parcelRequire("3uXTj");

var $7iUmd = parcelRequire("7iUmd");

var $2OFgC = parcelRequire("2OFgC");

var $2krk1 = parcelRequire("2krk1");

var $dKGsB = parcelRequire("dKGsB");

var $eqqZn = parcelRequire("eqqZn");

var $a83iJ = parcelRequire("a83iJ");

var $edvvt = parcelRequire("edvvt");

var $6RUKV = parcelRequire("6RUKV");

var $99ERU = parcelRequire("99ERU");

var $mpFVB = parcelRequire("mpFVB");

var $aEn8k = parcelRequire("aEn8k");

var $eZnvl = parcelRequire("eZnvl");

var $5RdXl = parcelRequire("5RdXl");

var $69S3K = parcelRequire("69S3K");

var $65JjX = parcelRequire("65JjX");

var $b0YFc = parcelRequire("b0YFc");

var $1JT7t = parcelRequire("1JT7t");

var $53HKz = parcelRequire("53HKz");

var $3R4tv = parcelRequire("3R4tv");

var $6zgxN = parcelRequire("6zgxN");

var $g5T7e = parcelRequire("g5T7e");

var $cbovl = parcelRequire("cbovl");

var $a4ljM = parcelRequire("a4ljM");

var $k9FZd = parcelRequire("k9FZd");

var $6tnzy = parcelRequire("6tnzy");

var $hVFyq = parcelRequire("hVFyq");

var $eoAAr = parcelRequire("eoAAr");

var $7ydol = parcelRequire("7ydol");

var $kgTjJ = parcelRequire("kgTjJ");

var $9C3lY = parcelRequire("9C3lY");

var $9lQYl = parcelRequire("9lQYl");

var $fKGT4 = parcelRequire("fKGT4");

var $gWFAG = parcelRequire("gWFAG");

var $edcP1 = parcelRequire("edcP1");

var $e0XiB = parcelRequire("e0XiB");

var $7ZEak = parcelRequire("7ZEak");

var $j333x = parcelRequire("j333x");

var $3dAlK = parcelRequire("3dAlK");

var $2mJeL = parcelRequire("2mJeL");

var $aczJL = parcelRequire("aczJL");

var $bY5oW = parcelRequire("bY5oW");

var $8FSAl = parcelRequire("8FSAl");

var $c2gkm = parcelRequire("c2gkm");

var $72ryD = parcelRequire("72ryD");

var $2eHyY = parcelRequire("2eHyY");

var $5Fsvc = parcelRequire("5Fsvc");

var $dF5Xf = parcelRequire("dF5Xf");

var $heQeQ = parcelRequire("heQeQ");

var $1tTym = parcelRequire("1tTym");

var $eIaFf = parcelRequire("eIaFf");

var $ilfAR = parcelRequire("ilfAR");

var $kbDih = parcelRequire("kbDih");

var $4w93k = parcelRequire("4w93k");

var $duDjv = parcelRequire("duDjv");

var $2rntA = parcelRequire("2rntA");

var $iLBBF = parcelRequire("iLBBF");

var $dLdOX = parcelRequire("dLdOX");

var $5Me2r = parcelRequire("5Me2r");

var $6Q9Qz = parcelRequire("6Q9Qz");

var $hYH27 = parcelRequire("hYH27");

var $3i8l7 = parcelRequire("3i8l7");

var $9OFk5 = parcelRequire("9OFk5");

var $3BaOY = parcelRequire("3BaOY");

var $lFxv2 = parcelRequire("lFxv2");

var $inMYN = parcelRequire("inMYN");

var $gylEl = parcelRequire("gylEl");

var $lSwir = parcelRequire("lSwir");

var $8H7Ue = parcelRequire("8H7Ue");

var $cCKmJ = parcelRequire("cCKmJ");

var $lDzvD = parcelRequire("lDzvD");

var $1VlQT = parcelRequire("1VlQT");

var $dglDe = parcelRequire("dglDe");

var $dbmnC = parcelRequire("dbmnC");

var $7XljJ = parcelRequire("7XljJ");

var $3kVWl = parcelRequire("3kVWl");

var $kvhzN = parcelRequire("kvhzN");

var $2z0UX = parcelRequire("2z0UX");

var $8VSx6 = parcelRequire("8VSx6");

var $c8g3O = parcelRequire("c8g3O");

var $lcKg0 = parcelRequire("lcKg0");

var $dtdCX = parcelRequire("dtdCX");

var $1tycn = parcelRequire("1tycn");

var $8zCHa = parcelRequire("8zCHa");

var $dV8H2 = parcelRequire("dV8H2");

var $5GznM = parcelRequire("5GznM");

var $kyWXG = parcelRequire("kyWXG");

var $b3uRO = parcelRequire("b3uRO");

var $lEfPj = parcelRequire("lEfPj");

var $ivTip = parcelRequire("ivTip");

var $3asJu = parcelRequire("3asJu");

var $gvVUq = parcelRequire("gvVUq");

var $dRyuZ = parcelRequire("dRyuZ");

var $l4LiH = parcelRequire("l4LiH");

var $48F6g = parcelRequire("48F6g");

var $9dVUe = parcelRequire("9dVUe");

var $50cDU = parcelRequire("50cDU");

var $lF5CE = parcelRequire("lF5CE");

var $eKtdo = parcelRequire("eKtdo");

var $5RWf0 = parcelRequire("5RWf0");

var $cqxXO = parcelRequire("cqxXO");

var $kgEJd = parcelRequire("kgEJd");

var $7e242 = parcelRequire("7e242");

var $cMh2i = parcelRequire("cMh2i");

var $kEnic = parcelRequire("kEnic");

var $lJx7q = parcelRequire("lJx7q");

var $2d9Eg = parcelRequire("2d9Eg");

var $ihd7R = parcelRequire("ihd7R");

var $gFWMW = parcelRequire("gFWMW");

var $dPuQX = parcelRequire("dPuQX");

var $bRLRA = parcelRequire("bRLRA");

var $04hqt = parcelRequire("04hqt");

var $loWOs = parcelRequire("loWOs");

var $i4KDV = parcelRequire("i4KDV");

var $f8zsk = parcelRequire("f8zsk");

var $hZaNO = parcelRequire("hZaNO");

var $4mwuU = parcelRequire("4mwuU");

var $7oxJi = parcelRequire("7oxJi");

var $5kwpg = parcelRequire("5kwpg");

var $evIjb = parcelRequire("evIjb");

var $iX5mh = parcelRequire("iX5mh");

var $2gWR9 = parcelRequire("2gWR9");

var $9xJlI = parcelRequire("9xJlI");

var $djfrw = parcelRequire("djfrw");

var $34MGU = parcelRequire("34MGU");

var $hdSuz = parcelRequire("hdSuz");

var $9iB0A = parcelRequire("9iB0A");

var $iQOGT = parcelRequire("iQOGT");

var $b7Kc2 = parcelRequire("b7Kc2");

var $e4QbX = parcelRequire("e4QbX");

var $jEYsQ = parcelRequire("jEYsQ");

var $5585C = parcelRequire("5585C");

var $e2Vn0 = parcelRequire("e2Vn0");

var $i3U1i = parcelRequire("i3U1i");

var $26XVI = parcelRequire("26XVI");

var $3miVG = parcelRequire("3miVG");

var $7s5cL = parcelRequire("7s5cL");

var $2bFMJ = parcelRequire("2bFMJ");

var $cQYgq = parcelRequire("cQYgq");

var $YxSwf = parcelRequire("YxSwf");

var $9hYXu = parcelRequire("9hYXu");

var $dBvp1 = parcelRequire("dBvp1");

var $3ryog = parcelRequire("3ryog");

var $dGozg = parcelRequire("dGozg");

var $ciUor = parcelRequire("ciUor");

var $bItbu = parcelRequire("bItbu");

var $fGHom = parcelRequire("fGHom");

var $kiC9A = parcelRequire("kiC9A");

var $kJYkR = parcelRequire("kJYkR");

var $gWiov = parcelRequire("gWiov");

var $6LIr6 = parcelRequire("6LIr6");

var $cDdFQ = parcelRequire("cDdFQ");

var $fCMtp = parcelRequire("fCMtp");

var $l1koB = parcelRequire("l1koB");

var $hz1Ci = parcelRequire("hz1Ci");

var $4Nxur = parcelRequire("4Nxur");

var $k9sOB = parcelRequire("k9sOB");

var $bRlx8 = parcelRequire("bRlx8");

var $krZyW = parcelRequire("krZyW");

var $g6qas = parcelRequire("g6qas");

var $69TKs = parcelRequire("69TKs");

var $5HpuX = parcelRequire("5HpuX");

var $8TKap = parcelRequire("8TKap");

var $fbMJX = parcelRequire("fbMJX");

var $j1cF8 = parcelRequire("j1cF8");

var $6f0V1 = parcelRequire("6f0V1");

var $7oChK = parcelRequire("7oChK");

var $xpd8X = parcelRequire("xpd8X");

var $j42ZP = parcelRequire("j42ZP");

var $5RPQd = parcelRequire("5RPQd");

var $eGqTw = parcelRequire("eGqTw");

var $8fN46 = parcelRequire("8fN46");

var $5rviH = parcelRequire("5rviH");

var $3cktz = parcelRequire("3cktz");

var $ara35 = parcelRequire("ara35");

var $g8c5T = parcelRequire("g8c5T");

var $fy0kN = parcelRequire("fy0kN");

var $aS8vp = parcelRequire("aS8vp");

var $1K6EX = parcelRequire("1K6EX");

var $lYrMg = parcelRequire("lYrMg");

var $hi76j = parcelRequire("hi76j");

var $6RvaF = parcelRequire("6RvaF");

var $fuD4B = parcelRequire("fuD4B");

var $9tg6g = parcelRequire("9tg6g");

var $dtmY2 = parcelRequire("dtmY2");

var $2hoxk = parcelRequire("2hoxk");

var $4582u = parcelRequire("4582u");

var $g6TjH = parcelRequire("g6TjH");

var $b5ssb = parcelRequire("b5ssb");

var $b8gZR = parcelRequire("b8gZR");

var $fT2sm = parcelRequire("fT2sm");

var $40LXp = parcelRequire("40LXp");

var $kPc3m = parcelRequire("kPc3m");

var $gbXZ8 = parcelRequire("gbXZ8");

var $5uZd0 = parcelRequire("5uZd0");

var $f54pi = parcelRequire("f54pi");

var $33XKG = parcelRequire("33XKG");

var $9hnc9 = parcelRequire("9hnc9");

var $9fAvh = parcelRequire("9fAvh");

var $eGobt = parcelRequire("eGobt");

var $b5AFk = parcelRequire("b5AFk");

var $kxhpa = parcelRequire("kxhpa");

var $dgOkS = parcelRequire("dgOkS");

var $bNEGg = parcelRequire("bNEGg");

var $fVNdp = parcelRequire("fVNdp");

var $iCE0X = parcelRequire("iCE0X");

var $7DLur = parcelRequire("7DLur");

var $fQEuo = parcelRequire("fQEuo");

var $b19s3 = parcelRequire("b19s3");

var $9CrBu = parcelRequire("9CrBu");

var $3IwUO = parcelRequire("3IwUO");

var $5bNjI = parcelRequire("5bNjI");

var $62WWj = parcelRequire("62WWj");

var $hu05Z = parcelRequire("hu05Z");

var $aXjIq = parcelRequire("aXjIq");

var $vZN7a = parcelRequire("vZN7a");

var $1e3lG = parcelRequire("1e3lG");

var $6zpko = parcelRequire("6zpko");

var $krUFs = parcelRequire("krUFs");

var $6Lrmn = parcelRequire("6Lrmn");

var $2h2AR = parcelRequire("2h2AR");

var $cc4sb = parcelRequire("cc4sb");

var $2EIyD = parcelRequire("2EIyD");

var $gUUEu = parcelRequire("gUUEu");

var $eb42n = parcelRequire("eb42n");

var $2GE6d = parcelRequire("2GE6d");

var $1dNif = parcelRequire("1dNif");

var $XHO18 = parcelRequire("XHO18");

var $hcYkM = parcelRequire("hcYkM");

var $cerux = parcelRequire("cerux");

var $d8Os7 = parcelRequire("d8Os7");

var $7O20s = parcelRequire("7O20s");

var $ajJlg = parcelRequire("ajJlg");

var $c6fhT = parcelRequire("c6fhT");

var $1Y7s6 = parcelRequire("1Y7s6");

var $6UzoR = parcelRequire("6UzoR");

var $hq3sr = parcelRequire("hq3sr");

var $gJH3P = parcelRequire("gJH3P");

var $kp1Tx = parcelRequire("kp1Tx");

var $yRwJU = parcelRequire("yRwJU");

var $l7fta = parcelRequire("l7fta");

var $h002s = parcelRequire("h002s");

var $aIBbH = parcelRequire("aIBbH");

var $38IAb = parcelRequire("38IAb");

var $fop9Z = parcelRequire("fop9Z");

var $16IWv = parcelRequire("16IWv");

var $7rcYw = parcelRequire("7rcYw");

var $70Vv8 = parcelRequire("70Vv8");

var $1F2VA = parcelRequire("1F2VA");

var $gUpP3 = parcelRequire("gUpP3");

var $gOMGi = parcelRequire("gOMGi");

var $d5nAU = parcelRequire("d5nAU");

var $aXFPR = parcelRequire("aXFPR");

var $ichNm = parcelRequire("ichNm");

var $2ZddW = parcelRequire("2ZddW");

var $g3Nmy = parcelRequire("g3Nmy");

var $jLs9s = parcelRequire("jLs9s");

var $9neNF = parcelRequire("9neNF");

var $7mDLx = parcelRequire("7mDLx");

var $oULj4 = parcelRequire("oULj4");

var $52pe0 = parcelRequire("52pe0");

var $hsPLz = parcelRequire("hsPLz");

var $kega6 = parcelRequire("kega6");

var $iuKWj = parcelRequire("iuKWj");

var $e0xiU = parcelRequire("e0xiU");

var $hZVFb = parcelRequire("hZVFb");

var $jhbBi = parcelRequire("jhbBi");

var $co4G4 = parcelRequire("co4G4");

var $kR1nP = parcelRequire("kR1nP");

var $lRd9M = parcelRequire("lRd9M");

var $5hPVZ = parcelRequire("5hPVZ");

var $hzYpr = parcelRequire("hzYpr");

var $jwXSg = parcelRequire("jwXSg");

var $3cRQJ = parcelRequire("3cRQJ");

var $ejsPt = parcelRequire("ejsPt");

var $koZPz = parcelRequire("koZPz");

var $52tSp = parcelRequire("52tSp");

var $2lNQx = parcelRequire("2lNQx");

var $8tNhS = parcelRequire("8tNhS");

var $1pbab = parcelRequire("1pbab");

var $3PfFy = parcelRequire("3PfFy");

var $dv5SV = parcelRequire("dv5SV");

var $koL9q = parcelRequire("koL9q");

var $k3KhI = parcelRequire("k3KhI");

var $4kOsL = parcelRequire("4kOsL");

var $8jTrX = parcelRequire("8jTrX");

var $lB4o7 = parcelRequire("lB4o7");

var $fanIl = parcelRequire("fanIl");

var $joaaH = parcelRequire("joaaH");

var $i4GHr = parcelRequire("i4GHr");

var $j3bhm = parcelRequire("j3bhm");

var $dtL5L = parcelRequire("dtL5L");

var $jC0nD = parcelRequire("jC0nD");

var $izbEh = parcelRequire("izbEh");

var $2mw5U = parcelRequire("2mw5U");

var $GfsW7 = parcelRequire("GfsW7");

var $OYqNs = parcelRequire("OYqNs");

var $iQ9bp = parcelRequire("iQ9bp");

var $5skqi = parcelRequire("5skqi");

var $dXpAT = parcelRequire("dXpAT");

var $aLAep = parcelRequire("aLAep");

var $gSkfR = parcelRequire("gSkfR");

var $2qIgp = parcelRequire("2qIgp");

var $dGEFm = parcelRequire("dGEFm");

var $lLfhz = parcelRequire("lLfhz");

var $9e6Vx = parcelRequire("9e6Vx");

var $iXxvM = parcelRequire("iXxvM");

var $7vjYA = parcelRequire("7vjYA");

var $huTOz = parcelRequire("huTOz");

var $1vzE5 = parcelRequire("1vzE5");

var $de0Ix = parcelRequire("de0Ix");

var $7bi6n = parcelRequire("7bi6n");

var $9B0aY = parcelRequire("9B0aY");

var $gJDfg = parcelRequire("gJDfg");

var $ioh4Q = parcelRequire("ioh4Q");

var $jFJKp = parcelRequire("jFJKp");

var $fUfB9 = parcelRequire("fUfB9");

var $54Pxb = parcelRequire("54Pxb");

var $fJNsm = parcelRequire("fJNsm");

var $d4Kv4 = parcelRequire("d4Kv4");

var $h9tcg = parcelRequire("h9tcg");

var $6IQcp = parcelRequire("6IQcp");

var $ctRYW = parcelRequire("ctRYW");

var $hlYPF = parcelRequire("hlYPF");

var $4PE7M = parcelRequire("4PE7M");

var $1nIbC = parcelRequire("1nIbC");

var $dQ7Zd = parcelRequire("dQ7Zd");

var $9qcOI = parcelRequire("9qcOI");

var $2LaFd = parcelRequire("2LaFd");

var $l2mgI = parcelRequire("l2mgI");

var $lGA0k = parcelRequire("lGA0k");

var $uFd6W = parcelRequire("uFd6W");

var $cs4H2 = parcelRequire("cs4H2");

var $lJ0vE = parcelRequire("lJ0vE");

var $6cVAZ = parcelRequire("6cVAZ");

var $ka3fH = parcelRequire("ka3fH");

var $7Vt7A = parcelRequire("7Vt7A");

var $j16Nz = parcelRequire("j16Nz");

var $1iV3F = parcelRequire("1iV3F");

var $78blt = parcelRequire("78blt");

var $inZ6Z = parcelRequire("inZ6Z");

var $jXBS2 = parcelRequire("jXBS2");

var $lW5D3 = parcelRequire("lW5D3");

var $arMEr = parcelRequire("arMEr");

var $9dduz = parcelRequire("9dduz");

var $6OpnH = parcelRequire("6OpnH");

var $hJy28 = parcelRequire("hJy28");

var $fPKcH = parcelRequire("fPKcH");

var $cgZW8 = parcelRequire("cgZW8");

var $7BVmS = parcelRequire("7BVmS");

var $fX7zq = parcelRequire("fX7zq");

var $bZjzP = parcelRequire("bZjzP");

var $3Op65 = parcelRequire("3Op65");

var $cw7Gw = parcelRequire("cw7Gw");

var $hO2gx = parcelRequire("hO2gx");

var $7iRmA = parcelRequire("7iRmA");

var $clUFS = parcelRequire("clUFS");

var $6E9wb = parcelRequire("6E9wb");

var $kHXh3 = parcelRequire("kHXh3");

var $7zkj7 = parcelRequire("7zkj7");

var $7feYc = parcelRequire("7feYc");

var $3prgj = parcelRequire("3prgj");

var $5Bwf9 = parcelRequire("5Bwf9");

var $hC17e = parcelRequire("hC17e");

var $8VnOK = parcelRequire("8VnOK");

var $dTKEk = parcelRequire("dTKEk");

var $9m1kX = parcelRequire("9m1kX");

var $eMB1E = parcelRequire("eMB1E");

var $crkYO = parcelRequire("crkYO");

var $jCOMd = parcelRequire("jCOMd");

var $kZ0yx = parcelRequire("kZ0yx");

var $8rJFK = parcelRequire("8rJFK");

var $iycSK = parcelRequire("iycSK");

var $716o6 = parcelRequire("716o6");

var $7yKoP = parcelRequire("7yKoP");

var $l0NQn = parcelRequire("l0NQn");

var $2Q23O = parcelRequire("2Q23O");

var $cjH5d = parcelRequire("cjH5d");

var $3UOiI = parcelRequire("3UOiI");

var $7vLTx = parcelRequire("7vLTx");

var $gIZVO = parcelRequire("gIZVO");

var $3z5oR = parcelRequire("3z5oR");

var $4tHqE = parcelRequire("4tHqE");

var $6rfJS = parcelRequire("6rfJS");

var $buBeq = parcelRequire("buBeq");

var $7LBLF = parcelRequire("7LBLF");

var $gpSI4 = parcelRequire("gpSI4");

var $7NX0d = parcelRequire("7NX0d");

var $4C3e4 = parcelRequire("4C3e4");

var $jhLPO = parcelRequire("jhLPO");

var $1tbMh = parcelRequire("1tbMh");

var $hwzvQ = parcelRequire("hwzvQ");

var $hCiGE = parcelRequire("hCiGE");

var $crO1B = parcelRequire("crO1B");

var $5EYUQ = parcelRequire("5EYUQ");

var $9l8dE = parcelRequire("9l8dE");

var $38HPm = parcelRequire("38HPm");

var $9qWPj = parcelRequire("9qWPj");

var $hMYmt = parcelRequire("hMYmt");

var $7muqP = parcelRequire("7muqP");

var $9a57v = parcelRequire("9a57v");

var $g4jM1 = parcelRequire("g4jM1");

var $gh7H7 = parcelRequire("gh7H7");

var $7J2Tk = parcelRequire("7J2Tk");

var $4KxZu = parcelRequire("4KxZu");

var $9sZlR = parcelRequire("9sZlR");

var $c1OMN = parcelRequire("c1OMN");

var $kmqxP = parcelRequire("kmqxP");

var $cDP2z = parcelRequire("cDP2z");

var $gSK8t = parcelRequire("gSK8t");

var $31KZb = parcelRequire("31KZb");

var $4nWrk = parcelRequire("4nWrk");

var $9OXJj = parcelRequire("9OXJj");

var $g0u6h = parcelRequire("g0u6h");

var $6dCix = parcelRequire("6dCix");

var $eJhl7 = parcelRequire("eJhl7");

var $hPa8K = parcelRequire("hPa8K");

var $j0nUp = parcelRequire("j0nUp");

var $dKwf4 = parcelRequire("dKwf4");

var $kR7ka = parcelRequire("kR7ka");

var $dMhXs = parcelRequire("dMhXs");

var $d7hDG = parcelRequire("d7hDG");

var $kIN2F = parcelRequire("kIN2F");

var $fMtz0 = parcelRequire("fMtz0");

var $eBxih = parcelRequire("eBxih");

var $b3UlM = parcelRequire("b3UlM");

var $1yXFq = parcelRequire("1yXFq");

var $jsoqu = parcelRequire("jsoqu");

var $gAkge = parcelRequire("gAkge");

var $b91Hq = parcelRequire("b91Hq");

var $4bMc3 = parcelRequire("4bMc3");

var $2aySF = parcelRequire("2aySF");
const $944610ff6034f8ed$export$10439de9ce871f28 = ()=>[
        (0, $11dzU.adminPagesAuditLogsRouteEntry),
        (0, $lfMhu.adminPagesGlobalAccessManagementRouteEntry),
        (0, $ee1nh.aiAnswersRouteEntry),
        (0, $krjBK.aiFirstCreateRouteEntry),
        (0, $4gGhz.aiSurveyCreateRouteEntry),
        (0, $5ia5u.alertPoliciesRouteEntry),
        (0, $6dcTd.applinksAdministrationEditRouteEntry),
        (0, $f1v24.applinksAdministrationListRouteEntry),
        (0, $fJYOn.applinksExtraAuthHealthcheckRouteEntry),
        (0, $aqyuv.appRequestsRouteEntry),
        (0, $z4Vlj.archivedIssuesRedirectRouteEntry),
        (0, $3Yc1O.archivedPlansRouteEntry),
        (0, $59Sas.archivedProjectDirectLinkRouteEntry),
        (0, $5amE5.archivedProjectsDirectoryRouteEntry),
        (0, $Ae6y0.archivedWorkItemsJsmRouteEntry),
        (0, $60s4z.archivedWorkItemsJswCompanyRouteEntry),
        (0, $59pT0.archivedWorkItemsJswRouteEntry),
        (0, $2a44M.archivedWorkItemsJwmRouteEntry),
        (0, $VL8fh.arjCalendarEmbedRouteEntry),
        (0, $iGEun.arjDependenciesEmbedRouteEntry),
        (0, $1EaRu.arjIncrementEmbedRouteEntry),
        (0, $sXwqJ.arjSettingsDependenciesLegacyRedirectRouteEntry),
        (0, $jGn6O.arjSettingsDependenciesRouteEntry),
        (0, $3FQW7.arjSettingsFinancialYearPageRouteEntry),
        (0, $e8JLL.arjSettingsLoadingLimitsLegacyRedirectRouteEntry),
        (0, $7Txn7.arjSettingsLoadingLimitsRouteEntry),
        (0, $d9CZt.arjSettingsPermissionsRouteEntry),
        (0, $46xzL.arjSettingsPermissionsRouteLegacyRedirectRouteEntry),
        (0, $29RF5.arjSummaryEmbedRouteEntry),
        (0, $5c8XY.arjTimelineEmbedRouteEntry),
        (0, $1XPY3.assetsAnalyticsDataViewCreateRouteEntry),
        (0, $lVbe0.assetsAnalyticsDataViewDetailsRouteEntry),
        (0, $7zRXQ.assetsAnalyticsDataViewListRouteEntry),
        (0, $ehmfE.assetsConfigurationRouteEntry),
        (0, $47pCb.assetsDashboardsDetailRouteEntry),
        (0, $j20Cx.assetsDashboardsRouteEntry),
        (0, $9UEdj.assetsDataManagerDataDictionaryGroupRouteEntry),
        (0, $hiWBS.assetsDataManagerDataDictionaryIssuesRouteEntry),
        (0, $aS2Q3.assetsDataManagerDataSourceRouteEntry),
        (0, $lvNEg.assetsDataManagerDiscoverRouteEntry),
        (0, $dHwrc.assetsDataManagerGettingStartedRouteEntry),
        (0, $gM6QF.assetsDataManagerObjectClassesRouteEntry),
        (0, $5bC3H.assetsDataManagerObjectClassesSettingsRouteEntry),
        (0, $bkh9V.assetsDataManagerObjectClassSettingsRouteEntry),
        (0, $gzEKj.assetsDataManagerObjectClassViewRouteEntry),
        (0, $8It8d.assetsDataManagerObjectDetailViewRouteEntry),
        (0, $2OdJy.assetsForYouRouteEntry),
        (0, $1mi9U.assetsObjectRouteEntry),
        (0, $dTOhd.assetsObjectTypeConfigurationRouteEntry),
        (0, $fXfmE.assetsReportsRouteEntry),
        (0, $KwSsA.assetsReportsTemplateRouteEntry),
        (0, $8UPVQ.assetsReportsUnsubscribeRouteEntry),
        (0, $fjjEb.assetsRouteEntry),
        (0, $cN9Dp.assetsSchemaConfigurationRouteEntry),
        (0, $1ImkA.assetsSchemaRouteEntry),
        (0, $adRjZ.assetsSchemasRouteEntry),
        (0, $bycrh.assetsSearchRouteEntry),
        (0, $jJYmM.availabilityRouteEntry),
        (0, $abM4d.boardsDirectoryRedirectRouteEntry),
        (0, $6Vpfk.boardsDirectoryRouteEntry),
        (0, $4B97A.browseConversationsRouteEntry),
        (0, $jKJAa.browseIntentsRouteEntry),
        (0, $9JJN0.browseIssueEmbedRouteEntry),
        (0, $iMUwg.browseIssueRouteEntry),
        (0, $hq8Us.browseProjectRedirectRouteEntry),
        (0, $bQFcP.browseStandardFlowsRouteEntry),
        (0, $epwzI.capacityRouteEntry),
        (0, $lSD2k.classicBusinessProformaIssueFormsDirectEmbedRouteEntry),
        (0, $5dv8e.classicBusinessProformaIssueFormsDirectRouteEntry),
        (0, $eEbPJ.classicBusinessProjectApprovalsRouteEntry),
        (0, $pX0Lb.classicBusinessProjectFormBuilderRouteEntry),
        (0, $7YisL.classicBusinessProjectFormRouteEntry),
        (0, $l5plY.classicBusinessProjectFormSubmitEmbedRouteEntry),
        (0, $hz0Io.classicBusinessProjectFormSubmitPublicRouteEntry),
        (0, $jKGqh.classicBusinessProjectFormSubmitRouteEntry),
        (0, $lGX8C.classicBusinessProjectPagesRouteEntry),
        (0, $9HrlX.classicBusinessProjectShortcutRouteEntry),
        (0, $9HdUU.classicBusinessProjectViewNotFoundRouteEntry),
        (0, $2g81E.classicProjectSettingsCoreFieldsRouteEntry),
        (0, $jzbS2.classicProjectSettingsDataClassificationsRouteEntry),
        (0, $e4FF2.classicProjectSettingsDetailsRouteEntry),
        (0, $iTMvW.classicProjectSettingsFeaturesRouteEntry),
        (0, $7tU8P.classicProjectSettingsIssueLayoutRouteEntry),
        (0, $3dCUd.classicProjectSettingsOpsgenieRouteEntry),
        (0, $hNTUt.classicProjectSettingsServiceDeskFieldsRouteEntry),
        (0, $jHnnR.classicProjectSettingsSoftwareFieldsRouteEntry),
        (0, $deexU.classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $9OOVl.classicProjectSettingsSoftwareProformaEditFormsRouteEntry),
        (0, $dHEBg.classicProjectSettingsSoftwareProformaFormsRouteEntry),
        (0, $3imAc.classicProjectSettingsSoftwareRedirectRouteEntry),
        (0, $48hVA.classicProjectSettingsToolchainRouteEntry),
        (0, $eCgFr.classicSoftwareBacklogEmbedRouteEntry),
        (0, $dQEuk.classicSoftwareBacklogRouteEntry),
        (0, $znXcS.classicSoftwareBoardEmbedRouteEntry),
        (0, $1zdWe.classicSoftwareBoardRouteEntry),
        (0, $jdODC.classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry),
        (0, $eYoel.classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry),
        (0, $llrpu.classicSoftwareBoardSettingsRouteEntry),
        (0, $fv3de.classicSoftwareTimelineCustomEmbedRouteEntry),
        (0, $iAxPI.classicSoftwareTimelineEmbedRouteEntry),
        (0, $15xtU.cmpAverageIssueAgeBoardlessRouteEntry),
        (0, $kIBbg.cmpAverageIssueAgeRouteEntry),
        (0, $dHEQJ.cmpCreatedVsResolvedBoardlessRouteEntry),
        (0, $fQwjt.cmpCreatedVsResolvedRouteEntry),
        (0, $8yLn2.cmpRecentlyCreatedBoardlessRouteEntry),
        (0, $47JK3.cmpRecentlyCreatedRouteEntry),
        (0, $bFdfN.cmpVelocityRouteEntry),
        (0, $38RVN.communicationsStakeholderGroupsRouteEntry),
        (0, $hUFuU.communicationsStakeholdersRouteEntry),
        (0, $igvH2.communicationsStatusPageConfigurationRouteEntry),
        (0, $eBdZD.communicationsStatusPageCreateRouteEntry),
        (0, $1Vf8Q.communicationsStatusPageDetailsRouteEntry),
        (0, $3GtBH.communicationsStatusPagePreviewRouteEntry),
        (0, $ceOvr.communicationsStatusPageRouteEntry),
        (0, $fHE3O.compassProductSettingsRouteEntry),
        (0, $ky4fW.connectGeneralInvalidRouteEntry),
        (0, $fLdTj.connectGeneralRouteEntry),
        (0, $31aCF.connectGeneralServiceDeskProjectRouteEntry),
        (0, $jtStO.connectProjectRouteEntry),
        (0, $hEHYT.createProjectRouteEntry),
        (0, $6uGHB.csmCustomerDetailsRouteEntry),
        (0, $3ssEl.csmCustomersRouteEntry),
        (0, $cjjH8.csmCustomIssueRouteEntry),
        (0, $jBwQs.csmCustomQueueRouteEntry),
        (0, $asE3T.csmExperienceAgentStudioRouteEntry),
        (0, $dbws7.csmExperienceArticlesRouteEntry),
        (0, $adv8s.csmExperienceBrandingRouteEntry),
        (0, $3gpmo.csmExperienceChatConfigurationRouteEntry),
        (0, $6uOxh.csmExperienceCustomerAccessRouteEntry),
        (0, $frSu6.csmExperienceCustomerNotificationsRouteEntry),
        (0, $67hGn.csmExperienceDetailsRouteEntry),
        (0, $5GDxf.csmExperienceEmailRouteEntry),
        (0, $979NP.csmExperienceEmbeddedWidgetsRouteEntry),
        (0, $5PmmP.csmExperienceFormEditRouteEntry),
        (0, $jyQEq.csmExperienceFormsRouteEntry),
        (0, $7sPfV.csmExperienceGetStartedRouteEntry),
        (0, $4qitY.csmExperienceMessagingAppsRouteEntry),
        (0, $4h98W.csmExperiencePhoneConfigurationRouteEntry),
        (0, $lf8kK.csmExperiencesRouteEntry),
        (0, $7nJMb.csmExperienceSupportWebsiteEditRouteEntry),
        (0, $VMFYy.csmExperienceSupportWebsiteOverviewRouteEntry),
        (0, $ex20g.csmExperienceSupportWebsitePagesRouteEntry),
        (0, $egvB1.csmExperienceWidgetConfigurationCustomizeRouteEntry),
        (0, $4PqDp.csmExperienceWidgetConfigurationInstallRouteEntry),
        (0, $3GrQ7.csmGetStartedRouteEntry),
        (0, $lzHoK.csmLiveConversationsRouteEntry),
        (0, $koyMU.csmOrganizationDetailsRouteEntry),
        (0, $i0RFn.csmOrganizationsRouteEntry),
        (0, $eidt5.csmProductsRouteEntry),
        (0, $7C3ge.csmProjectCustomerNotificationsRuleRouteEntry),
        (0, $4LA4D.csmProjectCustomerNotificationsTemplateRouteEntry),
        (0, $1wKev.csmQueuesEditRouteEntry),
        (0, $cQX3l.csmQueuesLandingRouteEntry),
        (0, $9NBqm.csmQueuesManageViewRouteEntry),
        (0, $7zQip.csmQueuesNewRouteEntry),
        (0, $539KO.customerServiceCustomerDetailsRouteEntry),
        (0, $4jDe2.customerServiceCustomersRouteEntry),
        (0, $30sWD.customerServiceEscalationsRouteEntry),
        (0, $d7pXC.customerServiceGetStartedRouteEntry),
        (0, $dYo5g.customerServiceLiveConversationsRouteEntry),
        (0, $cnYCZ.customerServiceOrganizationDetailsRouteEntry),
        (0, $0r9on.customerServiceOrganizationsRouteEntry),
        (0, $4wYea.customerServiceProductsRouteEntry),
        (0, $71iCS.customerServiceProjectSettingsRedirectRouteEntry),
        (0, $3TNYf.customIssueRouteEntry),
        (0, $iuPZI.customJourneyTypeRouteEntry),
        (0, $3GLXX.customPracticeQueueBoardRouteEntry),
        (0, $jxFtK.customPracticeQueueCalendarRouteEntry),
        (0, $40MXz.customPracticeQueueRouteEntry),
        (0, $3FsXl.customQueueBoardRouteEntry),
        (0, $iLYrw.customQueueCalendarRouteEntry),
        (0, $iz2Yc.customQueueRouteEntry),
        (0, $eKz3o.dashboardEditRouteEntry),
        (0, $cNKzQ.dashboardRouteEntry),
        (0, $cMk4h.dashboardsDirectoryRedirectRouteEntry),
        (0, $5ODMu.dashboardsDirectoryRouteEntry),
        (0, $gfTDK.dashboardViewEmbedRouteEntry),
        (0, $40AJ4.dashboardViewRouteEntry),
        (0, $KJMPg.dashboardWallboardRouteEntry),
        (0, $6RjSU.devopsConnectedProjectRouteEntry),
        (0, $5o6W5.digestsNotificationsPersonalSettingsRouteEntry),
        (0, $9fj3k.emailNotificationsLogAccessRouteEntry),
        (0, $2eUNm.eocAlertIssueSyncingCreateRouteEntry),
        (0, $dJeUf.eocAlertIssueSyncingDetailRouteEntry),
        (0, $2FXYc.eocAlertIssueSyncingRouteEntry),
        (0, $bPuPn.eocApiKeyManagementRouteEntry),
        (0, $5VrQ2.eocAssignCustomRolesRouteEntry),
        (0, $bDwmW.eocAutomationsRouteEntry),
        (0, $effIZ.eocChangesRouteEntry),
        (0, $9gv99.eocCustomRolesRouteEntry),
        (0, $lNHO4.eocGlobalAlertListRedirectRouteEntry),
        (0, $4vy2X.eocGlobalAlertListRouteEntry),
        (0, $dYZBt.eocGlobalAlertsDetailRouteEntry),
        (0, $7NvQX.eocGlobalGroupDetailRouteEntry),
        (0, $edGnQ.eocGlobalHeartbeatsRouteEntry),
        (0, $9Jj26.eocGlobalMaintenanceRouteEntry),
        (0, $aV7rM.eocGlobalReportsHomePageNav4RouteEntry),
        (0, $6m8PU.eocGlobalReportsNav4RouteEntry),
        (0, $fOrIK.eocGlobalReportsNewRouteEntry),
        (0, $3gQSV.eocGroupPolicyRouteEntry),
        (0, $imspb.eocHeartbeatsRouteEntry),
        (0, $49q2u.eocIncidentsRouteEntry),
        (0, $jswqy.eocMaintenanceRouteEntry),
        (0, $6nKGg.eocOnCallRedirectRouteEntry),
        (0, $kvwgI.eocOnCallRouteEntry),
        (0, $cFf23.eocOverviewAllTeamsRouteEntry),
        (0, $iuMQY.eocOverviewRouteEntry),
        (0, $6Dohh.eocPermissionsRouteEntry),
        (0, $fJVg1.eocReportsTeamRedirectRouteEntry),
        (0, $SDmDy.eocReportsTeamRouteEntry),
        (0, $aL0Nn.eocReportsUnsubscribeRouteEntry),
        (0, $l1Fco.eocScheduleGlobalRouteEntry),
        (0, $jlZ27.eocTeamAlertDetailRouteEntry),
        (0, $ucY9k.eocTeamAlertIssueSyncingCreateRouteEntry),
        (0, $gX0iW.eocTeamAlertIssueSyncingDetailRouteEntry),
        (0, $90t7w.eocTeamAlertIssueSyncingRouteEntry),
        (0, $3nRWh.eocTeamAlertListRouteEntry),
        (0, $aSN2a.eocTeamCustomerLogsDownloadRouteEntry),
        (0, $jTbdr.eocTeamCustomerLogsRouteEntry),
        (0, $doFbY.eocTeamGroupDetailRouteEntry),
        (0, $fWzFt.eocUserNotificationsRouteEntry),
        (0, $9vtbm.errorsGenericNotFoundRouteEntry),
        (0, $1ctLf.errorsNotFoundRouteEntry),
        (0, $ex4qh.externalImportRouteEntry),
        (0, $gueFU.filtersDirectoryRedirectRouteEntry),
        (0, $dQVsZ.filtersDirectoryRouteEntry),
        (0, $6JUWC.findAppsRouteEntry),
        (0, $bPj2c.forgeAdminRouteEntry),
        (0, $lX8j4.forgeAdminSettingsRouteEntry),
        (0, $7IvSo.forgeFieldContextualConfigurationRouteEntry),
        (0, $bs4Dp.forgeGlobalRouteEntry),
        (0, $cjarc.forgePersonalSettingsRouteEntry),
        (0, $eoMSY.forgeProjectRouteEntry),
        (0, $ewhVC.forgeProjectServicedeskRouteEntry),
        (0, $ezBBh.forgeServicedeskQueueRouteEntry),
        (0, $3omKb.generalPersonalSettingsRouteEntry),
        (0, $fSv9U.globalEscalationsRouteEntry),
        (0, $g3ZQl.globalIncomingCallDetailRouteEntry),
        (0, $9WyQi.globalIncomingCallRouteEntry),
        (0, $2Wapk.globalIntegrationCreateRouteEntry),
        (0, $b829t.globalIntegrationDetailRouteEntry),
        (0, $8FLFs.globalIntegrationListRouteEntry),
        (0, $6368z.globalIntegrationLogRouteEntry),
        (0, $dL4cN.globalIntegrationsRouteEntry),
        (0, $WtQtU.globalIssueNavigatorBrowseIssueRedirectRouteEntry),
        (0, $98WKd.globalMailSettingsRouteEntry),
        (0, $21UpQ.globalPoliciesRouteEntry),
        (0, $6IPAd.globalSettingsContactAdministratorRouteEntry),
        (0, $exdpX.globalSettingsCustomFieldsRouteEntry),
        (0, $arNsV.globalSettingsEditPermissionSchemesRouteEntry),
        (0, $3ENn5.globalSettingsFieldSchemeSelfConversionRouteEntry),
        (0, $uQst0.globalSettingsFormDataConnectionsRouteEntry),
        (0, $hr37Z.globalSettingsGlobalPermissionsRouteEntry),
        (0, $hlKdK.globalSettingsIssueFieldSchemeRouteEntry),
        (0, $4ctNm.globalSettingsIssueFieldSchemesConfigRouteEntry),
        (0, $g8xCO.globalSettingsIssueFieldSchemesRouteEntry),
        (0, $hAZdW.globalSettingsIssueFieldScreensRouteEntry),
        (0, $fnBKt.globalSettingsIssueFieldsManagementRouteEntry),
        (0, $hkkWR.globalSettingsIssueHierarchyRedirectRouteEntry),
        (0, $6Je0z.globalSettingsIssueHierarchyRouteEntry),
        (0, $3nqiL.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $ha5bJ.globalSettingsIssuesNewIssueSearchRouteEntry),
        (0, $jTZk2.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $nK9GP.globalSettingsIssuesPrioritySchemesRouteEntry),
        (0, $3vNqj.globalSettingsIssueTypesRouteEntry),
        (0, $5LoRz.globalSettingsIssueTypesSchemesRouteEntry),
        (0, $jYUJK.globalSettingsIssueTypesScreenSchemesRouteEntry),
        (0, $avx7c.globalSettingsIssueWorkflow1RouteEntry),
        (0, $38q9i.globalSettingsIssueWorkflowEditRouteEntry),
        (0, $hda6p.globalSettingsLegacyFieldLayoutRouteEntry),
        (0, $2BCjc.globalSettingsOptimizeCFOptionsRouteEntry),
        (0, $aFBIC.globalSettingsOptimizeFieldConfigurationSchemeRouteEntry),
        (0, $6Thsk.globalSettingsOptimizeFieldSchemeRouteEntry),
        (0, $f5nHW.globalSettingsOptimizeIssueSecurityLevelSchemeRouteEntry),
        (0, $6REob.globalSettingsOptimizePermissionSchemeRouteEntry),
        (0, $30CEL.globalSettingsOptimizeWorkTypeSchemeRouteEntry),
        (0, $1i3Ly.globalSettingsPerformanceCustomFieldCleanupRouteEntry),
        (0, $dCSf1.globalSettingsPerformanceCustomFieldOptionProjectLimitRouteEntry),
        (0, $6a25y.globalSettingsPerformanceCustomFieldProjectLimitRouteEntry),
        (0, $H15ro.globalSettingsPerformanceCustomFieldRouteEntry),
        (0, $eI7S7.globalSettingsPerformanceDashboardRouteEntry),
        (0, $eQJy2.globalSettingsPerformanceIssueArchivalRouteEntry),
        (0, $dVpN0.globalSettingsPerformanceIssueSecurityLevelProjectLimitRouteEntry),
        (0, $hZMof.globalSettingsPerformanceMetricDetailRouteEntry),
        (0, $9Gg1F.globalSettingsPerformanceOverviewRouteEntry),
        (0, $2yOeJ.globalSettingsPerformanceProjectCleanupRouteEntry),
        (0, $6jRt0.globalSettingsPerformanceProjectRoleActorRouteEntry),
        (0, $ij9Oa.globalSettingsPerformanceUserSetupInsightsRouteEntry),
        (0, $73GfK.globalSettingsPerformanceWorkTypeProjectLimitRouteEntry),
        (0, $guOXW.globalSettingsPerformanceWorkTypeRouteEntry),
        (0, $kLcj1.globalSettingsPermissionSchemesRouteEntry),
        (0, $cxIS4.globalSettingsSystemBulkMailRouteEntry),
        (0, $iDLuu.globalSettingsSystemLabsRouteEntry),
        (0, $15dwL.globalSettingsSystemUiAnnouncementBannerRouteEntry),
        (0, $gyHjd.governanceProjectsDirectoryRouteEntry),
        (0, $g8j6S.helpCenterSettingsAgentStudioRouteEntry),
        (0, $hJOuW.helpCenterSettingsAnalyticsRouteEntry),
        (0, $hxZix.helpCenterSettingsArticlesRouteEntry),
        (0, $bnYNC.helpCenterSettingsArticlesViewArticleRouteEntry),
        (0, $4CIaD.helpCenterSettingsBrandingRouteEntry),
        (0, $5NZLw.helpCenterSettingsChatConfigurationRouteEntry),
        (0, $aCb3M.helpCenterSettingsCreateArticleRouteEntry),
        (0, $5FbjP.helpCenterSettingsCustomerAccessRouteEntry),
        (0, $d3C53.helpCenterSettingsCustomerNotificationsRouteEntry),
        (0, $dEfbu.helpCenterSettingsDetailsRouteEntry),
        (0, $7NyWg.helpCenterSettingsEmailRouteEntry),
        (0, $gYR3D.helpCenterSettingsEmbeddedWidgetsRouteEntry),
        (0, $8N41I.helpCenterSettingsFormEditRouteEntry),
        (0, $LrcKp.helpCenterSettingsFormsRouteEntry),
        (0, $l7tPZ.helpCenterSettingsGetStartedRouteEntry),
        (0, $3rrWW.helpCenterSettingsMessagingAppsRouteEntry),
        (0, $j9fZa.helpCenterSettingsNotFoundRouteEntry),
        (0, $1Uc3N.helpCenterSettingsPhoneConfigurationRouteEntry),
        (0, $b3kdA.helpCenterSettingsServiceHubsRouteEntry),
        (0, $76As8.helpCenterSettingsSupportWebsiteEditRouteEntry),
        (0, $9F5gK.helpCenterSettingsSupportWebsiteOverviewRouteEntry),
        (0, $jSGFY.helpCenterSettingsSupportWebsitePagesRouteEntry),
        (0, $3I3w7.helpCenterSettingsWidgetConfigurationCustomizeRouteEntry),
        (0, $kWaDE.helpCenterSettingsWidgetConfigurationInstallRouteEntry),
        (0, $2YBdr.homeOnboardingRedirectRouteEntry),
        (0, $lxwe8.homeRedirectRouteEntry),
        (0, $5tx3g.issueCreateEmbedRouteEntry),
        (0, $bZnet.issueCreateRedirectRouteEntry),
        (0, $9pVk4.issueNavigatorGlobalIssueListEmbedRouteEntry),
        (0, $etuKr.issueNavigatorGlobalJiraRouteEntry),
        (0, $1A3Ru.issueNavigatorGlobalRouteEntry),
        (0, $4Jkh6.issueNavigatorProjectBusinessCustomEmbedRouteEntry),
        (0, $4Haw9.issueNavigatorProjectBusinessEmbedRouteEntry),
        (0, $aXz6t.issueNavigatorProjectBusinessRouteEntry),
        (0, $lkewN.issueNavigatorProjectClassicCustomEmbedRouteEntry),
        (0, $figDu.issueNavigatorProjectClassicEmbedRouteEntry),
        (0, $iTCvp.issueNavigatorProjectClassicRouteEntry),
        (0, $7npnA.issueNavigatorProjectListServicedeskRouteEntry),
        (0, $56dYq.issueNavigatorProjectServicedeskRouteEntry),
        (0, $QGZql.issueNavigatorProjectSoftwareCustomEmbedRouteEntry),
        (0, $bBBkV.issueNavigatorProjectSoftwareEmbedRouteEntry),
        (0, $hKZO1.issueNavigatorProjectSoftwareRouteEntry),
        (0, $6KpYG.itamAiInsightsPreviewRouteEntry),
        (0, $dwoYZ.itamRouteEntry),
        (0, $cbPm4.itamSettingsRouteEntry),
        (0, $6IdT3.jiraBusinessAgentContextRouteEntry),
        (0, $3mG0v.jiraBusinessAttachmentsRouteEntry),
        (0, $2yyrl.jiraBusinessAverageIssueAgeRouteEntry),
        (0, $5iCME.jiraBusinessBoardCustomEmbedRouteEntry),
        (0, $7gg2B.jiraBusinessBoardEmbedRouteEntry),
        (0, $5w386.jiraBusinessBoardRouteEntry),
        (0, $1MRQH.jiraBusinessCalendarCustomEmbedRouteEntry),
        (0, $3HY5k.jiraBusinessCalendarEmbedRouteEntry),
        (0, $4HAfX.jiraBusinessCalendarRouteEntry),
        (0, $eUWpI.jiraBusinessCapacityPeopleEmbedRouteEntry),
        (0, $aze16.jiraBusinessCapacityRouteEntry),
        (0, $c9rAZ.jiraBusinessCapacityWorkEmbedRouteEntry),
        (0, $kHwre.jiraBusinessCreatedVsResolvedRouteEntry),
        (0, $ejKE2.jiraBusinessListCustomEmbedRouteEntry),
        (0, $4JzGG.jiraBusinessListEmbedRouteEntry),
        (0, $5j4hU.jiraBusinessListRouteEntry),
        (0, $VpjMH.jiraBusinessProjectRedirectRouteEntry),
        (0, $i2Yzm.jiraBusinessRecentlyCreatedRouteEntry),
        (0, $lpgz5.jiraBusinessReportsOverviewRouteEntry),
        (0, $8OFru.jiraBusinessSummaryEmbedRouteEntry),
        (0, $kya75.jiraBusinessSummaryRouteEntry),
        (0, $cpKx3.jiraBusinessTimelineCustomEmbedRouteEntry),
        (0, $bfuFe.jiraBusinessTimelineEmbedRouteEntry),
        (0, $8u2Ns.jiraBusinessTimelineRouteEntry),
        (0, $hSdYi.jiraHomeRouteEntry),
        (0, $1srm4.jiraSearchRouteEntry),
        (0, $lUnDC.journeysListRouteEntry),
        (0, $G2OkG.jsmBoardRouteEntry),
        (0, $5I7GX.jsmKbAiFirstCreateEmbedRouteEntry),
        (0, $3O97K.jsmWorkItemBrowseRouteEntry),
        (0, $hjRvB.jsmWorkItemEmbedRouteEntry),
        (0, $6gY16.jsmWorkItemIncidentRouteEntry),
        (0, $f5SC3.jsmWorkItemPreventionCenterRouteEntry),
        (0, $80MOq.jsmWorkItemRouteEntry),
        (0, $eWRDs.jsmWorkItemServiceRequestRouteEntry),
        (0, $kBu1n.knowledgeHubAllArticlesRouteEntry),
        (0, $7ch29.knowledgeHubArticleEmbedEditorRouteEntry),
        (0, $cSfj2.knowledgeHubArticleInCategoryRouteEntry),
        (0, $bytv6.knowledgeHubBrowseAllArticlesRouteEntry),
        (0, $ki0Kw.knowledgeHubBrowseAllCategoriesRouteEntry),
        (0, $4q4hj.knowledgeHubBrowseViewArticleRouteEntry),
        (0, $adYD6.knowledgeHubCategoryPageRouteEntry),
        (0, $F88dL.knowledgeHubCategoryRouteEntry),
        (0, $4AhEY.knowledgeHubDraftsRouteEntry),
        (0, $9VX8H.knowledgeHubLandingRouteEntry),
        (0, $gd2CR.knowledgeHubSearchRouteEntry),
        (0, $gAPvJ.knowledgeHubSetupRouteEntry),
        (0, $dHOWY.knowledgeHubSuggestedArticlesRouteEntry),
        (0, $hCocS.landingPageRouteEntry),
        (0, $8HcaY.legacyPlanPageRedirectRouteEntry),
        (0, $2vc0R.legacyPlanReportPageRedirectRouteEntry),
        (0, $cIgeF.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $5FEz6.legacyProjectReleasesNoteRouteEntry),
        (0, $7855X.legacyRapidBoardRouteEntry),
        (0, $d9EEX.legacyRedirectRouteEntry),
        (0, $4TdbT.listRouteEntry),
        (0, $dSDGg.loginEmbedRouteEntry),
        (0, $eZca2.lookAndFeelRouteEntry),
        (0, $4yVjT.manageProjectsDirectoryRouteEntry),
        (0, $iw2x7.mergeTeamsRouteEntry),
        (0, $hfHFu.newRovoSearchRouteEntry),
        (0, $eZYyu.notificationLogsRouteEntry),
        (0, $2VKyb.notificationsPersonalSettingsRouteEntry),
        (0, $1lT1j.oldJiraHomeRouteEntry),
        (0, $eb3ne.opsgenieScheduleRedirectRouteEntry),
        (0, $fflqE.opsgenieScheduleRouteEntry),
        (0, $gLnPj.opsNotificationsPersonalSettingsRouteEntry),
        (0, $3aM5P.pendingJourneysRouteEntry),
        (0, $j6et5.peopleProfilesRouteEntry),
        (0, $8d4Pa.performanceRouteEntry),
        (0, $gW2I6.personalSettingsRouteEntry),
        (0, $32FNJ.piCreateIssueEmbedRouteEntry),
        (0, $68BYI.piEditIssueEmbedRouteEntry),
        (0, $1nenU.planExportPageRouteEntry),
        (0, $i6yvS.planIncrementRouteEntry),
        (0, $6EC2N.planIncrementsRouteEntry),
        (0, $8Iamy.planPageRouteEntry),
        (0, $1ZZjB.planPageWithoutScenarioIdRouteEntry),
        (0, $bckOF.planReportPageRouteEntry),
        (0, $8JjPR.plansDirectoryRouteEntry),
        (0, $ccbVD.planSetupPageRouteEntry),
        (0, $3i3Pz.planViewNotFoundRouteEntry),
        (0, $cqwf2.polarisCollectionsRouteEntry),
        (0, $92Eq3.polarisIdeasRouteEntry),
        (0, $3GJk3.polarisOnboardingRouteEntry),
        (0, $6k2Ti.polarisProjectSettingsPoliciesRouteEntry),
        (0, $7yRej.polarisSettingsAccessRouteEntry),
        (0, $gDjnr.polarisSettingsDatesRouteEntry),
        (0, $giPrt.polarisSettingsEarlyAccessFeaturesRouteEntry),
        (0, $iEsMS.polarisSettingsGlobalFieldsRouteEntry),
        (0, $lGgL6.polarisSettingsGlobalViewsDetailsRouteEntry),
        (0, $iZwgi.polarisSettingsGlobalViewsListRouteEntry),
        (0, $br5Fp.polarisSettingsViewBlueprintsRouteEntry),
        (0, $cgIlc.polarisShareViewRouteEntry),
        (0, $fVlxG.polarisUnlicensedRouteEntry),
        (0, $2rAKo.productsCsmChatRouteEntry),
        (0, $3HyYd.productsJcsCustomerAccessRouteEntry),
        (0, $kaJTo.productsJcsStorageManagementRouteEntry),
        (0, $2uYIw.productsJsmAiGovernanceNativeAiCapabilitiesRouteEntry),
        (0, $gPrfx.productsJsmAuthenticationSettingsRouteEntry),
        (0, $fBDjl.productsJsmChatopsAndVideosToolsRouteEntry),
        (0, $3uXTj.productsJsmChatopsSlackAppSelectorRouteEntry),
        (0, $7iUmd.productsJsmComplianceRouteEntry),
        (0, $2OFgC.productsJsmConfigurationRouteEntry),
        (0, $2krk1.productsJsmCustomerAccessRouteEntry),
        (0, $dKGsB.productsJsmEmailRequestsRouteEntry),
        (0, $eqqZn.productsJsmFeatureUsageRouteEntry),
        (0, $a83iJ.productsJsmGlobalOpsReportsRedirectRouteEntry),
        (0, $edvvt.productsJsmGlobalOpsReportsRouteEntry),
        (0, $6RUKV.productsJsmIncidentManagementToolsRouteEntry),
        (0, $99ERU.productsJsmKbPermissionsRouteEntry),
        (0, $mpFVB.productsJsmOrganizationsDetailsRouteEntry),
        (0, $aEn8k.productsJsmOrganizationsRouteEntry),
        (0, $eZnvl.productsJsmStorageManagementRouteEntry),
        (0, $5RdXl.productsJsmWorkforceSkillsRouteEntry),
        (0, $69S3K.productsJswConfigurationRouteEntry),
        (0, $65JjX.productsJswStorageManagementRouteEntry),
        (0, $b0YFc.productsOnboardingHubCreateRouteEntry),
        (0, $1JT7t.productsOnboardingHubEditRouteEntry),
        (0, $53HKz.productsOnboardingHubRouteEntry),
        (0, $3R4tv.proformaExportRouteEntry),
        (0, $6zgxN.proformaIssueFormsGeneralRouteEntry),
        (0, $g5T7e.projectComponentsRedirectRouteEntry),
        (0, $cbovl.projectComponentsRouteEntry),
        (0, $a4ljM.projectDirectoryRedirectRouteEntry),
        (0, $k9FZd.projectIssueNavigatorRouteEntry),
        (0, $6tnzy.projectNotFoundRouteEntry),
        (0, $hVFyq.projectPagesLegacyRouteEntry),
        (0, $eoAAr.projectPagesRouteEntry),
        (0, $7ydol.projectsDirectoryLegacyPathRedirectRouteEntry),
        (0, $kgTjJ.projectsDirectoryManageRedirectRouteEntry),
        (0, $9C3lY.projectsDirectoryManageRootRedirectRouteEntry),
        (0, $9lQYl.projectsDirectoryRedirectRouteEntry),
        (0, $fKGT4.projectsDirectoryRouteEntry),
        (0, $gWFAG.projectServiceDeskRouteEntry),
        (0, $edcP1.projectSettingsAutomationCRouteEntry),
        (0, $e0XiB.projectSettingsAutomationRouteEntry),
        (0, $7ZEak.projectSettingsComponentsRouteEntry),
        (0, $j333x.projectSettingsCoreAccessRedirectRouteEntry),
        (0, $3dAlK.projectSettingsCoreAccessRouteEntry),
        (0, $2mJeL.projectSettingsCoreApprovalsRouteEntry),
        (0, $aczJL.projectSettingsCoreAppsFieldsRouteEntry),
        (0, $bY5oW.projectSettingsCoreAppsRouteEntry),
        (0, $8FSAl.projectSettingsCoreAutomationRouteEntry),
        (0, $c2gkm.projectSettingsCoreAutomationV2RouteEntry),
        (0, $72ryD.projectSettingsCoreDataClassificationsRouteEntry),
        (0, $2eHyY.projectSettingsCoreDefaultRedirectRouteEntry),
        (0, $5Fsvc.projectSettingsCoreDetailsRouteEntry),
        (0, $dF5Xf.projectSettingsCoreFieldsRouteEntry),
        (0, $heQeQ.projectSettingsCoreForgeAppsRouteEntry),
        (0, $1tTym.projectSettingsCoreIssueTypesRouteEntry),
        (0, $eIaFf.projectSettingsCoreIssueTypesWorkflowRouteEntry),
        (0, $ilfAR.projectSettingsCoreNotificationsEmailRouteEntry),
        (0, $kbDih.projectSettingsCoreNotificationsIssueLogsRouteEntry),
        (0, $4w93k.projectSettingsCoreNotificationsRouteEntry),
        (0, $duDjv.projectSettingsCorePoliciesRouteEntry),
        (0, $2rntA.projectSettingsCoreProformaJiraFormBuilderRouteEntry),
        (0, $iLBBF.projectSettingsCoreProformaProjectFormsRouteEntry),
        (0, $dLdOX.projectSettingsCustomerServiceCannedResponsesRouteEntry),
        (0, $5Me2r.projectSettingsCustomerServiceDetailsRouteEntry),
        (0, $6Q9Qz.projectSettingsCustomerServiceFeaturesRouteEntry),
        (0, $hYH27.projectSettingServicedeskEmployeeOnboardingConfigurationRouteEntry),
        (0, $3i8l7.projectSettingServicedeskResolutionManagementRouteEntry),
        (0, $9OFk5.projectSettingServicedeskRovoServiceRouteEntry),
        (0, $3BaOY.projectSettingServicedeskSelfServiceSetupRouteEntry),
        (0, $lFxv2.projectSettingsForgeAppsNextgenRouteEntry),
        (0, $inMYN.projectSettingsForgeAppsRouteEntry),
        (0, $gylEl.projectSettingsOpsgenieRouteEntry),
        (0, $lSwir.projectSettingsServicedeskAccessRedirectRouteEntry),
        (0, $8H7Ue.projectSettingsServicedeskAccessRouteEntry),
        (0, $cCKmJ.projectSettingsServicedeskAppsFieldsRouteEntry),
        (0, $lDzvD.projectSettingsServicedeskAppsRouteEntry),
        (0, $1VlQT.projectSettingsServicedeskAutomationCopyRuleRouteEntry),
        (0, $dglDe.projectSettingsServicedeskAutomationCreateRouteEntry),
        (0, $dbmnC.projectSettingsServicedeskAutomationEditRuleRouteEntry),
        (0, $7XljJ.projectSettingsServicedeskAutomationRouteEntry),
        (0, $3kVWl.projectSettingsServicedeskAutomationSummaryRouteEntry),
        (0, $kvhzN.projectSettingsServicedeskAutomationViewLogRouteEntry),
        (0, $2z0UX.projectSettingsServicedeskCaseNotesEditRouteEntry),
        (0, $8VSx6.projectSettingsServicedeskCaseNotesRouteEntry),
        (0, $c8g3O.projectSettingsServicedeskChangeManagementRouteEntry),
        (0, $lcKg0.projectSettingsServicedeskChannelsChatRouteEntry),
        (0, $dtdCX.projectSettingsServicedeskChannelsEmailNextGenRouteEntry),
        (0, $1tycn.projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry),
        (0, $8zCHa.projectSettingsServicedeskChannelsPortalRouteEntry),
        (0, $dV8H2.projectSettingsServicedeskChannelsRouteEntry),
        (0, $5GznM.projectSettingsServicedeskChannelsWidgetRouteEntry),
        (0, $kyWXG.projectSettingsServicedeskChatRouteEntry),
        (0, $b3uRO.projectSettingsServicedeskCustomerNotificationsRouteEntry),
        (0, $lEfPj.projectSettingsServicedeskCustomerPermissionsRouteEntry),
        (0, $ivTip.projectSettingsServicedeskDataClassificationsRouteEntry),
        (0, $3asJu.projectSettingsServicedeskDetailsRouteEntry),
        (0, $gvVUq.projectSettingsServicedeskEmailRouteEntry),
        (0, $dRyuZ.projectSettingsServicedeskExternalLinksRouteEntry),
        (0, $l4LiH.projectSettingsServicedeskFeedbackRouteEntry),
        (0, $48F6g.projectSettingsServicedeskFieldsRouteEntry),
        (0, $9dVUe.projectSettingsServicedeskForgeAppsRouteEntry),
        (0, $50cDU.projectSettingsServicedeskIncidentManagementRouteEntry),
        (0, $lF5CE.projectSettingsServicedeskInternalNotificationsNextGenRouteEntry),
        (0, $eKtdo.projectSettingsServicedeskIssuetypesRouteEntry),
        (0, $5RWf0.projectSettingsServicedeskIssuetypesWorkflowRouteEntry),
        (0, $cqxXO.projectSettingsServicedeskItsmFeaturesRouteEntry),
        (0, $kgEJd.projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry),
        (0, $7e242.projectSettingsServicedeskItsmTicketTypesConfigRouteEntry),
        (0, $cMh2i.projectSettingsServicedeskJourneyConfigurationEditRouteEntry),
        (0, $kEnic.projectSettingsServicedeskJourneyConfigurationRouteEntry),
        (0, $lJx7q.projectSettingsServicedeskJourneysRouteEntry),
        (0, $2d9Eg.projectSettingsServicedeskKbRouteEntry),
        (0, $ihd7R.projectSettingsServicedeskLanguageKeyRouteEntry),
        (0, $gFWMW.projectSettingsServicedeskLanguageRouteEntry),
        (0, $dPuQX.projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry),
        (0, $bRLRA.projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry),
        (0, $04hqt.projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry),
        (0, $loWOs.projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry),
        (0, $i4KDV.projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry),
        (0, $f8zsk.projectSettingsServicedeskLiveChatRouteEntry),
        (0, $hZaNO.projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry),
        (0, $4mwuU.projectSettingsServicedeskNotificationsEmailRouteEntry),
        (0, $7oxJi.projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry),
        (0, $5kwpg.projectSettingsServicedeskNotificationsNotificationEmailRouteEntry),
        (0, $evIjb.projectSettingsServicedeskNotificationsRouteEntry),
        (0, $iX5mh.projectSettingsServicedeskPoliciesRouteEntry),
        (0, $2gWR9.projectSettingsServicedeskPortalSettingsRouteEntry),
        (0, $9xJlI.projectSettingsServicedeskProactiveServiceManagementRouteEntry),
        (0, $djfrw.projectSettingsServicedeskProformaJiraFormBuilderRouteEntry),
        (0, $34MGU.projectSettingsServicedeskProformaProjectFormsRouteEntry),
        (0, $hdSuz.projectSettingsServicedeskRedirectRouteEntry),
        (0, $9iB0A.projectSettingsServicedeskRovoOpsRouteEntry),
        (0, $iQOGT.projectSettingsServicedeskRovoRouteEntry),
        (0, $b7Kc2.projectSettingsServicedeskRovoServiceAgentRouteEntry),
        (0, $e4QbX.projectSettingsServicedeskTicketTypeFieldsRouteEntry),
        (0, $jEYsQ.projectSettingsServicedeskTicketTypesConfigRouteEntry),
        (0, $5585C.projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry),
        (0, $e2Vn0.projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry),
        (0, $i3U1i.projectSettingsServicedeskWidgetRouteEntry),
        (0, $26XVI.projectSettingsServicedeskWorkforceOptimizationRouteEntry),
        (0, $3miVG.projectSettingsSoftwareAccessRedirectRouteEntry),
        (0, $7s5cL.projectSettingsSoftwareAccessRouteEntry),
        (0, $2bFMJ.projectSettingsSoftwareAppsFieldsRouteEntry),
        (0, $cQYgq.projectSettingsSoftwareAppsRouteEntry),
        (0, $YxSwf.projectSettingsSoftwareAutomationRouteEntry),
        (0, $9hYXu.projectSettingsSoftwareBoardsCardRouteEntry),
        (0, $dBvp1.projectSettingsSoftwareBoardsCsmRouteEntry),
        (0, $3ryog.projectSettingsSoftwareBoardsCustomFiltersRouteEntry),
        (0, $dGozg.projectSettingsSoftwareBoardsRedirectRouteEntry),
        (0, $ciUor.projectSettingsSoftwareBoardsRoadmapRouteEntry),
        (0, $bItbu.projectSettingsSoftwareBoardsTimelineRouteEntry),
        (0, $fGHom.projectSettingsSoftwareDataClassificationsRouteEntry),
        (0, $kiC9A.projectSettingsSoftwareDetailsRouteEntry),
        (0, $kJYkR.projectSettingsSoftwareFieldsRouteEntry),
        (0, $gWiov.projectSettingsSoftwareIssuetypesRouteEntry),
        (0, $6LIr6.projectSettingsSoftwareIssuetypesWorkflowRouteEntry),
        (0, $cDdFQ.projectSettingsSoftwareNextGenFeaturesRouteEntry),
        (0, $fCMtp.projectSettingsSoftwareNotificationEmailCRouteEntry),
        (0, $l1koB.projectSettingsSoftwareNotificationEmailRouteEntry),
        (0, $hz1Ci.projectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $4Nxur.projectSettingsSoftwareNotificationsRouteEntry),
        (0, $k9sOB.projectSettingsSoftwarePoliciesRouteEntry),
        (0, $bRlx8.projectSettingsSoftwareProformaJiraFormBuilderRouteEntry),
        (0, $krZyW.projectSettingsSoftwareProformaProjectFormsRouteEntry),
        (0, $g6qas.projectSettingsSoftwareRedirectRouteEntry),
        (0, $69TKs.projectSettingsToolchainRouteEntry),
        (0, $5HpuX.projectSettingsVersionsRouteEntry),
        (0, $8TKap.projectsNotFoundRouteEntry),
        (0, $fbMJX.projectsRedirectRouteEntry),
        (0, $j1cF8.projectVersionsRouteEntry),
        (0, $6f0V1.promotionsRouteEntry),
        (0, $7oChK.rapidboardBacklog1RouteEntry),
        (0, $xpd8X.rapidboardLastVisitedProjectRedirectRouteEntry),
        (0, $j42ZP.rapidboardReport1RouteEntry),
        (0, $5RPQd.rapidboardReportRouteEntry),
        (0, $eGqTw.rapidboardUserBacklogRouteEntry),
        (0, $8fN46.rapidboardUserReportRouteEntry),
        (0, $5rviH.rapidboardUserReportsOverviewRouteEntry),
        (0, $3cktz.roleBasedNotificationDetailRouteEntry),
        (0, $ara35.roleBasedNotificationsRouteEntry),
        (0, $g8c5T.rovoSearchRouteEntry),
        (0, $fy0kN.sandboxBundlerRouteEntry),
        (0, $aS8vp.sandboxRelayEchoPageUsingEntryPointRouteEntry),
        (0, $1K6EX.sandboxRelayEchoPageUsingRLLRouteEntry),
        (0, $lYrMg.sandboxRelayJiraPageRouteEntry),
        (0, $hi76j.schedulesRouteEntry),
        (0, $6RvaF.secureFiltersDirectoryRedirectRouteEntry),
        (0, $fuD4B.selectedDashboardRouteEntry),
        (0, $9tg6g.servicedeskAtlassianAnalyticsRouteEntry),
        (0, $dtmY2.servicedeskCalendarRouteEntry),
        (0, $2hoxk.servicedeskChangeCalendarRouteEntry),
        (0, $4582u.servicedeskChannelsRouteEntry),
        (0, $g6TjH.servicedeskCmdbAssetsAnalyticsDataViewCreateRouteEntry),
        (0, $b5ssb.servicedeskCmdbAssetsAnalyticsDataViewDetailsRouteEntry),
        (0, $b8gZR.servicedeskCmdbAssetsAnalyticsDataViewListRouteEntry),
        (0, $fT2sm.servicedeskCmdbAssetsDashboardsDetailRouteEntry),
        (0, $40LXp.servicedeskCmdbAssetsDashboardsRouteEntry),
        (0, $kPc3m.servicedeskCmdbAssetsGlobalConfigurationRouteEntry),
        (0, $gbXZ8.servicedeskCmdbAssetsObjectRouteEntry),
        (0, $5uZd0.servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry),
        (0, $f54pi.servicedeskCmdbAssetsObjectSchemaRouteEntry),
        (0, $33XKG.servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry),
        (0, $9hnc9.servicedeskCmdbAssetsReportsRouteEntry),
        (0, $9fAvh.servicedeskCmdbAssetsReportsTemplateRouteEntry),
        (0, $eGobt.servicedeskCmdbAssetsReportsUnsubscribeRouteEntry),
        (0, $b5AFk.servicedeskCmdbAssetsSchemasRouteEntry),
        (0, $kxhpa.servicedeskCmdbInsightConfigureGlobalRouteEntry),
        (0, $dgOkS.servicedeskCmdbInsightConfigureRouteEntry),
        (0, $bNEGg.servicedeskCmdbInsightObject4RouteEntry),
        (0, $fVNdp.servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry),
        (0, $iCE0X.servicedeskCmdbInsightObjectSchemaRouteEntry),
        (0, $7DLur.servicedeskCmdbInsightObjectTypeConfigurationRouteEntry),
        (0, $fQEuo.servicedeskCmdbInsightRouteEntry),
        (0, $b19s3.servicedeskConnectProjectRouteEntry),
        (0, $9CrBu.servicedeskCreateProjectRouteEntry),
        (0, $3IwUO.servicedeskCustomerDetailsRouteEntry),
        (0, $5bNjI.servicedeskCustomersV2RouteEntry),
        (0, $62WWj.servicedeskGettingStartedHubsRouteEntry),
        (0, $hu05Z.servicedeskGettingStartedQueueCreateRouteEntry),
        (0, $aXjIq.servicedeskGettingStartedQueueEditRouteEntry),
        (0, $vZN7a.servicedeskGettingStartedQueuesRouteEntry),
        (0, $1e3lG.servicedeskGettingStartedRequestFormRouteEntry),
        (0, $6zpko.servicedeskGettingStartedRequestTypesRouteEntry),
        (0, $krUFs.servicedeskGettingStartedRouteEntry),
        (0, $6Lrmn.servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRouteEntry),
        (0, $2h2AR.servicedeskGettingStartedSlaEditRouteEntry),
        (0, $cc4sb.servicedeskGettingStartedSlaNewRouteEntry),
        (0, $2EIyD.servicedeskGettingStartedSlaRouteEntry),
        (0, $gUUEu.servicedeskGettingStartedSlaViewRouteEntry),
        (0, $eb42n.servicedeskIssueRouteEntry),
        (0, $2GE6d.servicedeskItsmSampleSpaceRouteEntry),
        (0, $1dNif.servicedeskKbRequestsReports2RouteEntry),
        (0, $XHO18.servicedeskKbRequestsReportsIssueRouteEntry),
        (0, $hcYkM.servicedeskKbRequestsReportsTimeScaleRouteEntry),
        (0, $cerux.servicedeskLiveChatMyChatsRouteEntry),
        (0, $d8Os7.servicedeskOncallScheduleRouteEntry),
        (0, $7O20s.servicedeskOrganizationDetailsRouteEntry),
        (0, $ajJlg.servicedeskOrganizationsRouteEntry),
        (0, $c6fhT.servicedeskOrganizationV2RouteEntry),
        (0, $1Y7s6.servicedeskPlaybooksEditDedicatedRouteEntry),
        (0, $6UzoR.servicedeskPlaybooksEditRouteEntry),
        (0, $hq3sr.servicedeskPlaybooksListOnlyRouteEntry),
        (0, $gJH3P.servicedeskPlaybooksLogsRouteEntry),
        (0, $kp1Tx.servicedeskPlaybooksTemplateCreateRouteEntry),
        (0, $yRwJU.servicedeskPlaybooksTemplatesRouteEntry),
        (0, $l7fta.servicedeskPracticeEditRouteEntry),
        (0, $h002s.servicedeskPracticeIssueRouteEntry),
        (0, $aIBbH.servicedeskPracticeLandingRouteEntry),
        (0, $38IAb.servicedeskPracticeManageViewRouteEntry),
        (0, $fop9Z.servicedeskPracticeNewRouteEntry),
        (0, $16IWv.servicedeskPracticeViewsConfigRouteEntry),
        (0, $7rcYw.servicedeskProactiveSupportAuditLogRouteEntry),
        (0, $70Vv8.servicedeskProactiveSupportDashboardRouteEntry),
        (0, $1F2VA.servicedeskProactiveSupportDevicesRouteEntry),
        (0, $gUpP3.servicedeskProactiveSupportOpenIssuesRouteEntry),
        (0, $gOMGi.servicedeskProactiveSupportRouteEntry),
        (0, $d5nAU.serviceDeskProductsRouteEntry),
        (0, $aXFPR.servicedeskProformaIssueFormsDirectEmbedRouteEntry),
        (0, $ichNm.servicedeskProformaIssueFormsDirectRouteEntry),
        (0, $2ZddW.servicedeskProjectSummaryRouteEntry),
        (0, $g3Nmy.servicedeskQueuesAddonRouteEntry),
        (0, $jLs9s.servicedeskQueuesEditRouteEntry),
        (0, $9neNF.servicedeskQueuesIssueRouteEntry),
        (0, $7mDLx.servicedeskQueuesLandingRouteEntry),
        (0, $oULj4.servicedeskQueuesManageViewRouteEntry),
        (0, $52pe0.servicedeskQueuesNewRouteEntry),
        (0, $hsPLz.servicedeskQueuesViewsConfigRouteEntry),
        (0, $kega6.servicedeskRcaInvestigationRouteEntry),
        (0, $iuKWj.servicedeskReports1RouteEntry),
        (0, $e0xiU.servicedeskReportsCustom4RouteEntry),
        (0, $hZVFb.servicedeskReportsCustomCreateRouteEntry),
        (0, $jhbBi.servicedeskReportsCustomEditRouteEntry),
        (0, $co4G4.servicedeskReportsCustomIssueRouteEntry),
        (0, $kR1nP.servicedeskReportsCustomTimeScaleRouteEntry),
        (0, $lRd9M.servicedeskReportsSatisfaction2RouteEntry),
        (0, $5hPVZ.servicedeskReportsSatisfactionIssueRouteEntry),
        (0, $hzYpr.servicedeskReportsSatisfactionTimeScaleRouteEntry),
        (0, $jwXSg.servicedeskReportsTypeRouteEntry),
        (0, $3cRQJ.servicedeskReportsWorkloadRouteEntry),
        (0, $ejsPt.servicedeskServiceDetailsRouteEntry),
        (0, $koZPz.serviceDeskServiceDetailsWithoutProjectRouteEntry),
        (0, $52tSp.serviceDeskServiceListRouteEntry),
        (0, $2lNQx.servicedeskServiceModalEditRouteEntry),
        (0, $8tNhS.servicedeskServiceModalNewRouteEntry),
        (0, $1pbab.servicedeskServicesRouteEntry),
        (0, $3PfFy.serviceDeskServicesWithoutProjectRouteEntry),
        (0, $dv5SV.servicedeskSlaSettingsRouteEntry),
        (0, $koL9q.servicedeskSurveysRouteEntry),
        (0, $k3KhI.servicedeskWorkflowConfigRouteEntry),
        (0, $4kOsL.settingsAutomationRouteEntry),
        (0, $8jTrX.settingsCmdbFieldConfigRouteEntry),
        (0, $lB4o7.settingsOauthCredentialsRouteEntry),
        (0, $fanIl.settingsRouteEntry),
        (0, $joaaH.skillsRouteEntry),
        (0, $i4GHr.softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry),
        (0, $j3bhm.softwareAgentContextClassicRouteEntry),
        (0, $dtL5L.softwareAgentContextRouteEntry),
        (0, $jC0nD.softwareAiPlanningClassicPlanRouteEntry),
        (0, $izbEh.softwareAiPlanningClassicRouteEntry),
        (0, $2mw5U.softwareAiPlanningPlanRouteEntry),
        (0, $GfsW7.softwareAiPlanningRouteEntry),
        (0, $OYqNs.softwareBacklogEmbedRouteEntry),
        (0, $iQ9bp.softwareBacklogRouteEntry),
        (0, $5skqi.softwareBoardEmbedRouteEntry),
        (0, $dXpAT.softwareBoardRouteEntry),
        (0, $aLAep.softwareBoardViewNotFoundClassicRouteEntry),
        (0, $gSkfR.softwareBoardViewNotFoundRouteEntry),
        (0, $2qIgp.softwareCalendarClassicCustomEmbedRouteEntry),
        (0, $dGEFm.softwareCalendarClassicEmbedRouteEntry),
        (0, $lLfhz.softwareCalendarClassicRouteEntry),
        (0, $9e6Vx.softwareCalendarCustomEmbedRouteEntry),
        (0, $iXxvM.softwareCalendarEmbedRouteEntry),
        (0, $7vjYA.softwareCalendarRouteEntry),
        (0, $huTOz.softwareCapacityClassicPeopleEmbedRouteEntry),
        (0, $1vzE5.softwareCapacityClassicRouteEntry),
        (0, $de0Ix.softwareCapacityClassicWorkEmbedRouteEntry),
        (0, $7bi6n.softwareCapacityPeopleEmbedRouteEntry),
        (0, $9B0aY.softwareCapacityRouteEntry),
        (0, $gJDfg.softwareCapacityWorkEmbedRouteEntry),
        (0, $ioh4Q.softwareClassicProformaIssueFormsDirectEmbedRouteEntry),
        (0, $jFJKp.softwareClassicProformaIssueFormsDirectRouteEntry),
        (0, $fUfB9.softwareCodeClassicRouteEntry),
        (0, $54Pxb.softwareCodeRouteEntry),
        (0, $fJNsm.softwareCompanyManagedAgentsRouteEntry),
        (0, $d4Kv4.softwareDeploymentsClassicRouteEntry),
        (0, $h9tcg.softwareDeploymentsNextGenRouteEntry),
        (0, $6IQcp.softwareFormBuilderClassicRouteEntry),
        (0, $ctRYW.softwareFormBuilderRouteEntry),
        (0, $hlYPF.softwareFormClassicRouteEntry),
        (0, $4PE7M.softwareFormRouteEntry),
        (0, $1nIbC.softwareFormSubmitClassicPublicRouteEntry),
        (0, $dQ7Zd.softwareFormSubmitClassicRouteEntry),
        (0, $9qcOI.softwareFormSubmitEmbedClassicRouteEntry),
        (0, $2LaFd.softwareFormSubmitEmbedRouteEntry),
        (0, $l2mgI.softwareFormSubmitPublicRouteEntry),
        (0, $lGA0k.softwareFormSubmitRouteEntry),
        (0, $uFd6W.softwareGoalsClassicRouteEntry),
        (0, $cs4H2.softwareGoalsRouteEntry),
        (0, $lJ0vE.softwareInboxClassicRouteEntry),
        (0, $6cVAZ.softwareInboxNextGenRouteEntry),
        (0, $ka3fH.softwareIncidentsClassicRouteEntry),
        (0, $7Vt7A.softwareIncidentsNextGenRouteEntry),
        (0, $j16Nz.softwareListClassicRouteEntry),
        (0, $1iV3F.softwareListCustomEmbedClassicRouteEntry),
        (0, $78blt.softwareListCustomEmbedRouteEntry),
        (0, $inZ6Z.softwareListEmbedClassicRouteEntry),
        (0, $jXBS2.softwareListEmbedRouteEntry),
        (0, $lW5D3.softwareListRouteEntry),
        (0, $arMEr.softwareNextgenRedirectRouteEntry),
        (0, $9dduz.softwareOnboardingRouteEntry),
        (0, $6OpnH.softwarePeriscopeClassicRouteEntry),
        (0, $hJy28.softwarePeriscopeNextGenRouteEntry),
        (0, $fPKcH.softwarePlanCalendarRouteEntry),
        (0, $cgZW8.softwarePlanDependenciesRouteEntry),
        (0, $7BVmS.softwarePlannerClassicPlanRouteEntry),
        (0, $fX7zq.softwarePlannerClassicRouteEntry),
        (0, $bZjzP.softwarePlannerPlanRouteEntry),
        (0, $3Op65.softwarePlannerRouteEntry),
        (0, $cw7Gw.softwarePlanReleasesRouteEntry),
        (0, $hO2gx.softwarePlanSettingsAutoSchedulerRouteEntry),
        (0, $7iRmA.softwarePlanSettingsCustomFieldsRouteEntry),
        (0, $clUFS.softwarePlanSettingsExclusionRulesRouteEntry),
        (0, $6E9wb.softwarePlanSettingsFeaturesRouteEntry),
        (0, $kHXh3.softwarePlanSettingsFindYourIssueRouteEntry),
        (0, $7zkj7.softwarePlanSettingsIssueSourcesRouteEntry),
        (0, $7feYc.softwarePlanSettingsPermissionsRouteEntry),
        (0, $3prgj.softwarePlanSettingsPlanInfoRouteEntry),
        (0, $5Bwf9.softwarePlanSettingsProgramBoardsRouteEntry),
        (0, $hC17e.softwarePlanSettingsRemovedIssuesRouteEntry),
        (0, $8VnOK.softwarePlanSettingsSavedViewsRouteEntry),
        (0, $dTKEk.softwarePlanSettingsScenariosRouteEntry),
        (0, $9m1kX.softwarePlanSettingsSchedulingRouteEntry),
        (0, $eMB1E.softwarePlanSummaryRouteEntry),
        (0, $crkYO.softwarePlanTeamsRouteEntry),
        (0, $jCOMd.softwarePlanTimelineRouteEntry),
        (0, $kZ0yx.softwareProformaIssueFormsDirectEmbedRouteEntry),
        (0, $8rJFK.softwareProformaIssueFormsDirectRouteEntry),
        (0, $iycSK.softwareReleaseNotesRouteEntry),
        (0, $716o6.softwareReportsBurndownRouteEntry),
        (0, $7yKoP.softwareReportsBurnupRouteEntry),
        (0, $l0NQn.softwareReportsControlRouteEntry),
        (0, $2Q23O.softwareReportsCumulativeRouteEntry),
        (0, $cjH5d.softwareReportsCycleTimeClassicBoardRouteEntry),
        (0, $3UOiI.softwareReportsCycleTimeClassicRouteEntry),
        (0, $7vLTx.softwareReportsCycleTimeRouteEntry),
        (0, $gIZVO.softwareReportsDeploymentFrequencyClassicBoardRouteEntry),
        (0, $3z5oR.softwareReportsDeploymentFrequencyClassicRouteEntry),
        (0, $4tHqE.softwareReportsDeploymentFrequencyRouteEntry),
        (0, $6rfJS.softwareReportsOverviewBoardlessRouteEntry),
        (0, $buBeq.softwareReportsOverviewRouteEntry),
        (0, $7LBLF.softwareReportsRouteEntry),
        (0, $gpSI4.softwareReportsVelocityRouteEntry),
        (0, $7NX0d.softwareRoadmapClassicRouteEntry),
        (0, $4C3e4.softwareRoadmapRedirectRouteEntry),
        (0, $jhLPO.softwareRoadmapRouteEntry),
        (0, $1tbMh.softwareSecurityClassicRouteEntry),
        (0, $hwzvQ.softwareSecurityNextGenRouteEntry),
        (0, $hCiGE.softwareSummaryClassicRouteEntry),
        (0, $crO1B.softwareSummaryEmbedClassicRouteEntry),
        (0, $5EYUQ.softwareSummaryEmbedRouteEntry),
        (0, $9l8dE.softwareSummaryRouteEntry),
        (0, $38HPm.softwareTeamManagedAgentsRouteEntry),
        (0, $9qWPj.softwareTimelineClassicRouteEntry),
        (0, $hMYmt.softwareTimelineCustomEmbedRouteEntry),
        (0, $7muqP.softwareTimelineEmbedRouteEntry),
        (0, $9a57v.softwareTimelineRouteEntry),
        (0, $g4jM1.softwareVersionDetailEmbedRouteEntry),
        (0, $gh7H7.softwareVersionDetailLegacyRedirectRouteEntry),
        (0, $7J2Tk.softwareVersionDetailNoTabPathRedirectRouteEntry),
        (0, $4KxZu.softwareVersionDetailRouteEntry),
        (0, $9sZlR.softwareViewNotFoundClassicRouteEntry),
        (0, $c1OMN.softwareViewNotFoundRouteEntry),
        (0, $kmqxP.syncWaitRouteEntry),
        (0, $cDP2z.systemConfigurationRedirectRouteEntry),
        (0, $gSK8t.systemConfigurationRouteEntry),
        (0, $31KZb.systemDashboardEditRouteEntry),
        (0, $4nWrk.teamIntegrationCreateRouteEntry),
        (0, $9OXJj.teamIntegrationDetailRouteEntry),
        (0, $g0u6h.teamIntegrationListRouteEntry),
        (0, $6dCix.teamIntegrationLogRouteEntry),
        (0, $eJhl7.teamIntegrationsRouteEntry),
        (0, $hPa8K.trashedPlanDirectLinkRouteEntry),
        (0, $j0nUp.trashPlansRouteEntry),
        (0, $dKwf4.trashProjectsDirectoryRedirectRouteEntry),
        (0, $kR7ka.trashProjectsDirectoryRouteEntry),
        (0, $dMhXs.unlockOperationsRouteEntry),
        (0, $d7hDG.userBoardRouteEntry),
        (0, $kIN2F.userBoardSettingsRouteEntry),
        (0, $fMtz0.userBoardVelocityRouteEntry),
        (0, $eBxih.userBoardViewNotFoundRouteEntry),
        (0, $b3UlM.userSegmentationRouteEntry),
        (0, $1yXFq.viewIntentRouteEntry),
        (0, $jsoqu.viewStandardFlowRouteEntry),
        (0, $gAkge.whoIsOnCallRouteEntry),
        (0, $b91Hq.workforceOptimizationRouteEntry),
        (0, $4bMc3.workItemEmbedRouteEntry),
        (0, $2aySF.workItemRouteEntry)
    ];

});
parcelRegister("11dzU", function(module, exports) {
$parcel$export(module.exports, "adminPagesAuditLogsRouteEntry", () => $6ac42bc23635de62$export$40663d71b8c2af1e);

var $dCWYg = parcelRequire("dCWYg");

var $2U7yh = parcelRequire("2U7yh");



var $iSoIx = parcelRequire("iSoIx");

var $45Itd = parcelRequire("45Itd");

var $9Q50z = parcelRequire("9Q50z");

var $dUAVJ = parcelRequire("dUAVJ");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $qPIzk = parcelRequire("qPIzk");
const $6ac42bc23635de62$var$adminPagesAuditLogsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $dCWYg.auditLogsEntryPoint)
});
const $6ac42bc23635de62$export$40663d71b8c2af1e = (0, $fdS54.createEntry)((0, $2U7yh.adminPagesAuditLogsRoute), ()=>({
        group: 'global-settings',
        layout: (0, $qPIzk.auditLogsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $9Q50z.jiraSpaPageContainerResource)
        ],
        entryPoint: ()=>{
            return (0, $i860n.fg)('jira_frontend_eal_admin_audit_log') ? $6ac42bc23635de62$var$adminPagesAuditLogsPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@jira/router-routes__admin-pages-audit-logs-entries',
                whichExportToUse: 'adminPagesAuditLogsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dCWYg", function(module, exports) {
$parcel$export(module.exports, "auditLogsEntryPoint", () => $96f0b6c9ff9dd65c$export$17a383268b4336e0);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $96f0b6c9ff9dd65c$export$17a383268b4336e0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("17s0C")), {
        moduleId: "2bcc33aa",
        moduleName: "AuditLogs",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("17s0C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("603ec")
]).then(()=>parcelRequire('adkuo'));

});


parcelRegister("2U7yh", function(module, exports) {
$parcel$export(module.exports, "adminPagesAuditLogsRoute", () => $5c4582de16344aa2$export$810bbf94115cd86b);
const $5c4582de16344aa2$export$810bbf94115cd86b = {
    name: 'global-settings-system-audit-logs',
    path: '/jira/settings/system/audit-logs',
    exact: true
};

});

const $57a8d3ee2467d6bc$export$1b6b909295618bea = 'SETTINGS';

const $1b7637cabf39cd90$export$e03d9e7e646baacb = 'GLOBAL_SYSTEM_SETTINGS';

parcelRegister("iSoIx", function(module, exports) {
$parcel$export(module.exports, "notFoundPageEntrypoint", () => $bf9d31cbc4b999a0$export$eb748b014da0ac9a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4lWtN = parcelRequire("4lWtN");

var $dTa0V = parcelRequire("dTa0V");
const $bf9d31cbc4b999a0$export$eb748b014da0ac9a = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4lWtN.notFoundEntrypoint)
});

});
parcelRegister("4lWtN", function(module, exports) {
$parcel$export(module.exports, "notFoundEntrypoint", () => $87bcdebf6bebb970$export$7fdee4826a30b643);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $87bcdebf6bebb970$export$7fdee4826a30b643 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("eFaFV")), {
        moduleId: "65f95f24",
        moduleName: "notFoundRelayRoot",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("b3tU7", function(module, exports) {
$parcel$export(module.exports, "JSResourceForUserVisible", () => $6fd5d7caa3883d90$export$58f934f3d33a84b6);

var $jW8UK = parcelRequire("jW8UK");

var $hkiLZ = parcelRequire("hkiLZ");

var $bCiN9 = parcelRequire("bCiN9");
const $6fd5d7caa3883d90$var$cache = (0, $jW8UK.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $6fd5d7caa3883d90$var$RUNTIME_STRING_ERROR = "JSResourceForUserVisible was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $6fd5d7caa3883d90$export$58f934f3d33a84b6(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$6fd5d7caa3883d90$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $6fd5d7caa3883d90$var$cache.get(opts.moduleId, ()=>(0, $hkiLZ.PreloadableJSResource)(()=>(0, $bCiN9.postTask)(loaderOrPath, {
                priority: 'user-blocking'
            }), opts));
}

});

parcelRegister("eFaFV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("dM3Dq")
]).then(()=>parcelRequire('hNz2l'));

});


parcelRegister("dTa0V", function(module, exports) {
$parcel$export(module.exports, "createChromelessEntryPoint", () => $fcf73773d0f21be7$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $fcf73773d0f21be7$export$955a7619d2679b4c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6kcj4 = parcelRequire("6kcj4");


var $i860n = parcelRequire("i860n");

var $53DCS = parcelRequire("53DCS");
const $fcf73773d0f21be7$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    ...(0, $i860n.fg)('jpx-463-spa-relay-query') ? {
                        [(0, $b666e36d39b806ff$export$22ce74854c620e75)]: {
                            entryPoint: (0, $6kcj4.spaEntryPoint),
                            entryPointParams: entryPointParams,
                            options: {
                                fetchPolicy: 'store-or-network'
                            }
                        }
                    } : undefined,
                    [(0, $b666e36d39b806ff$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $fcf73773d0f21be7$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    ...(0, $i860n.fg)('jpx-463-spa-relay-query') ? {
                        [(0, $b666e36d39b806ff$export$22ce74854c620e75)]: {
                            entryPoint: (0, $6kcj4.spaEntryPoint),
                            entryPointParams: entryPointParams,
                            options: {
                                fetchPolicy: 'store-or-network'
                            }
                        }
                    } : undefined,
                    [(0, $b666e36d39b806ff$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $b666e36d39b806ff$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $53DCS.topNavEntryPoint),
                        entryPointParams: entryPointParams
                    },
                    ...page.leftSidebar ? {
                        [(0, $b666e36d39b806ff$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $fcf73773d0f21be7$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.previewPanel && (0, $i860n.fg)('nin_glance_panel_technical_changes') ? {
                        [(0, $b666e36d39b806ff$export$a9102b57dfd6b2a3)]: {
                            entryPoint: page.previewPanel,
                            entryPointParams: entryPointParams
                        }
                    } : undefined,
                    ...page.horizontalNavigation ? {
                        [(0, $b666e36d39b806ff$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $b666e36d39b806ff$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined,
                    ...page.redirect ? {
                        [(0, $b666e36d39b806ff$export$5ef29550cd5a8266)]: {
                            entryPoint: page.redirect,
                            entryPointParams: entryPointParams
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $fcf73773d0f21be7$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
parcelRegister("6kcj4", function(module, exports) {
$parcel$export(module.exports, "spaEntryPoint", () => $6a052eb4040a0840$export$e280f2842b7ca512);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6IHMU = parcelRequire("6IHMU");

const $6a052eb4040a0840$export$e280f2842b7ca512 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8oBMU")), {
        moduleId: "78c6e385",
        moduleName: "JiraSpaPageContainerEntry",
        priority: "userVisible",
        /* eslint-disable-line jira/entry-fs/restrict-shell-only-to-navigation-apps */ includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (props)=>({
            queries: {
                queryReference: {
                    parameters: (0, $6IHMU.default),
                    variables: {
                        cloudId: props?.tenantContext?.cloudId
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("6IHMU", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ed0f2f29414fc4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb3b4dedbc154c45c4338ef30525bfbd>>
 * @relayHash e0f06b3a0f9d0dc350a88d69c22d4ee2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11a77c767341aa2ca2480103f304a876a2c3b469f1174a8b1d9f157305f7a780

var $dBGHL = parcelRequire("dBGHL");

var $lIGkE = parcelRequire("lIGkE");
const $64ed0f2f29414fc4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JiraSpaPageContainerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "BannerContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "JiraSpaPageContainerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraAnnouncementBanner",
                                    "kind": "LinkedField",
                                    "name": "announcementBanner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDismissible"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "visibility"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "11a77c767341aa2ca2480103f304a876a2c3b469f1174a8b1d9f157305f7a780",
            "metadata": {},
            "name": "JiraSpaPageContainerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider": (0, $dBGHL.default)
            }
        }
    };
}();
$64ed0f2f29414fc4$var$node.hash = "cceab149c27c13616adc23f0556d61ac";
(0, $lIGkE.PreloadableQueryRegistry).set($64ed0f2f29414fc4$var$node.params.id, $64ed0f2f29414fc4$var$node);
var $64ed0f2f29414fc4$export$2e2bcd8739ae039 = $64ed0f2f29414fc4$var$node;

});
parcelRegister("dBGHL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9e5c8fe0202f01$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $ad9e5c8fe0202f01$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jpx-459-announcement-banner-via-spa-query');
    }
};

});


parcelRegister("8oBMU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("gZgW8"))('navx_onboarding_universal_create_in_jira', function() {
        return Promise.all([
            $4cvLQ("27fFF")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("hJyTq")
        ]);
    }),
    (parcelRequire("gZgW8"))('navx-global-side-nav', function() {
        return Promise.all([
            $4cvLQ("7FBcr"),
            $4cvLQ("4Smn9"),
            $4cvLQ("hc93Z")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("54wGu"),
            $4cvLQ("4Smn9"),
            $4cvLQ("hc93Z")
        ]);
    }),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("5qC72"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("laS8v")
]).then(()=>parcelRequire('29s1c'));

});
parcelRegister("gZgW8", function(module, exports) {
"use strict";

var $li7pP = parcelRequire("li7pP");
var $c5df7b177d94760d$require$getBundleURL = $li7pP.getBundleURL;

var $96thM = parcelRequire("96thM");
var $c5df7b177d94760d$require$resolve = $96thM.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($c5df7b177d94760d$require$resolve(id), $c5df7b177d94760d$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("li7pP", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $f80107ff082ec675$export$bdfd709ae4826697, (v) => $f80107ff082ec675$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f80107ff082ec675$export$5a759dc7a1cfb72a;
var $f80107ff082ec675$export$bdfd709ae4826697;
var $f80107ff082ec675$export$c9e73fbda7da57b6;
"use strict";
const $f80107ff082ec675$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $f80107ff082ec675$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $f80107ff082ec675$var$getBundleURLCached(id, inputError) {
    let value = $f80107ff082ec675$var$bundleURL[id];
    if (!value) {
        value = $f80107ff082ec675$var$getBundleURL(inputError);
        $f80107ff082ec675$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $f80107ff082ec675$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $f80107ff082ec675$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($f80107ff082ec675$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f80107ff082ec675$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $f80107ff082ec675$var$getOrigin(url) {
    return new URL(url).origin;
}
$f80107ff082ec675$export$5a759dc7a1cfb72a = $f80107ff082ec675$var$getOrigin;
$f80107ff082ec675$export$bdfd709ae4826697 = $f80107ff082ec675$var$getBundleURLCached;
$f80107ff082ec675$export$c9e73fbda7da57b6 = $f80107ff082ec675$var$getBaseURL;

});




/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $b666e36d39b806ff$export$a9102b57dfd6b2a3 = '__pageLayoutPreviewPanel';
const $b666e36d39b806ff$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $b666e36d39b806ff$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $b666e36d39b806ff$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $b666e36d39b806ff$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $b666e36d39b806ff$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
const $b666e36d39b806ff$export$5ef29550cd5a8266 = '___pageLayoutRedirect';
const $b666e36d39b806ff$export$22ce74854c620e75 = '__pageLayoutSpaContent';

parcelRegister("53DCS", function(module, exports) {
$parcel$export(module.exports, "topNavEntryPoint", () => $d7b4c25e134b447c$export$461b9b579186dbbc);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $d7b4c25e134b447c$export$461b9b579186dbbc = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("gCmql"))), {
        moduleId: "36cb82fe",
        moduleName: "TopNavigation",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("45Itd", function(module, exports) {
$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $f202873aee649285$export$44e7ad3c66a3f25f);

var $5lH6b = parcelRequire("5lH6b");

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
const $f202873aee649285$var$RESOURCE_TYPE_NAVIGATION_SIDEBAR_GLOBAL = 'NAVIGATION_SIDEBAR_GLOBAL';
const $f202873aee649285$export$44e7ad3c66a3f25f = (0, $7edbf.createResource)({
    type: $f202873aee649285$var$RESOURCE_TYPE_NAVIGATION_SIDEBAR_GLOBAL,
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, _storeContext)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $5lH6b.fetchSidebarConfig)(scope);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("5lH6b", function(module, exports) {
$parcel$export(module.exports, "fetchSidebarConfig", () => $c3c8b844bc55a7ef$export$d1d13c4b972a22f1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");
const $c3c8b844bc55a7ef$export$94e808b2557f52e = (requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `/rest/navigation/${version}/${path}?${queryString}`;
};
const $c3c8b844bc55a7ef$export$d1d13c4b972a22f1 = async (requestQuery, queryParams)=>{
    const sidebarUrl = $c3c8b844bc55a7ef$export$94e808b2557f52e(requestQuery, undefined, queryParams);
    return (0, $4fhEY.default)(sidebarUrl);
};

});
parcelRegister("4fhEY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab6fbefc5abd05ec$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $eRSGV = parcelRequire("eRSGV");

var $ff8AH = parcelRequire("ff8AH");

var $75sVW = parcelRequire("75sVW");

var $jVTHL = parcelRequire("jVTHL");

var $5cVSt = parcelRequire("5cVSt");

var $xhPWB = parcelRequire("xhPWB");
/**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param url - to fetch the JSON from
 * @param options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // the `@typescript-eslint/no-unnecessary-type-constraint` rule is disabled because otherwise syntax highlighting breaks with a trailing comma,
// other rules should be fixed ideally.
// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
const $ab6fbefc5abd05ec$var$fetchJson = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, (0, $eRSGV.merge)((0, $ff8AH.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $xhPWB.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $75sVW.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $75sVW.default)(response.status, undefined, undefined, response);
        }
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return response.json();
    });
var $ab6fbefc5abd05ec$export$2e2bcd8739ae039 = $ab6fbefc5abd05ec$var$fetchJson;

});
parcelRegister("jVTHL", function(module, exports) {
$parcel$export(module.exports, "getReroutableURL", () => $4a7a8e9de9f4b016$export$23769875e8eebaf6);
/* eslint-disable jira/filename-case */ 
var $8BCi4 = parcelRequire("8BCi4");

var $dJ3NQ = parcelRequire("dJ3NQ");
function $4a7a8e9de9f4b016$export$23769875e8eebaf6(pathOrURL) {
    // For local development environment only, otherwise removed during the bundling process
    if (false ? (0, $dJ3NQ.default)() : false) try {
        const localUrl = new URL((0, $8BCi4.getLocalUrl)());
        const u = new URL(pathOrURL, localUrl.href);
        u.host = localUrl.host;
        u.protocol = localUrl.protocol;
        return u.href;
    } catch (e) {
        // When the URL constructor has `base` set, and `pathOrUrl` is always a string,
        // no string can trigger this catch block.
        // Just in case, log the error to help with debugging.
        // eslint-disable-next-line no-console
        console.error('Failed to parse URL: ', pathOrURL, e);
    }
    return pathOrURL;
}

});
parcelRegister("8BCi4", function(module, exports) {
$parcel$export(module.exports, "getLocalUrl", () => $47790d2a63d67da2$export$e049a61beee18f8c);
/* eslint-disable jira/filename-case */ 
var $4g6Ut = parcelRequire("4g6Ut");

var $fA7uA = parcelRequire("fA7uA");

var $7Il9x = parcelRequire("7Il9x");

var $aFXYr = parcelRequire("aFXYr");
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ function $47790d2a63d67da2$var$getDevHostname() {
    const envDns = false ? (0, $fA7uA.default)() : undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
}
function $47790d2a63d67da2$var$getProxyServerPort() {
    const serverPort = false ? (0, $4g6Ut.default)() : undefined;
    return serverPort ? parseInt(serverPort, 10) : 9000;
}
function $47790d2a63d67da2$export$e049a61beee18f8c() {
    if (false) {
        const overridden = (0, $aFXYr.default)();
        return overridden ?? `${(0, $7Il9x.default)() ? 'https' : 'http'}://${$47790d2a63d67da2$var$getDevHostname()}:${$47790d2a63d67da2$var$getProxyServerPort()}`;
    }
    return `${'http'}://${$47790d2a63d67da2$var$getDevHostname()}:${$47790d2a63d67da2$var$getProxyServerPort()}`;
}

});
parcelRegister("4g6Ut", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd40f3f086af816a$export$2e2bcd8739ae039);
// oxlint-disable-next-line typescript/ban-ts-comment
// @ts-ignore - process.env types are cursed
const $dd40f3f086af816a$var$proxyServerPort = undefined;
function $dd40f3f086af816a$export$2e2bcd8739ae039() {
    return(// oxlint-disable-next-line typescript/consistent-type-assertions
    globalThis.localDevContext?.__PILLAR_PROXY_SERVER_PORT ?? $dd40f3f086af816a$var$proxyServerPort);
}

});

parcelRegister("fA7uA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae9a4f923335faba$export$2e2bcd8739ae039);
function $ae9a4f923335faba$export$2e2bcd8739ae039() {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return globalThis.localDevContext?.RDE_DNS;
}

});

parcelRegister("aFXYr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6863d638a96e4b7$export$2e2bcd8739ae039);
function $e6863d638a96e4b7$export$2e2bcd8739ae039() {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return globalThis.localDevContext?.LOCAL_URL_OVERRIDE;
}

});



parcelRegister("xhPWB", function(module, exports) {
$parcel$export(module.exports, "getTraceId", () => $d14322710f49cbc9$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $d14322710f49cbc9$export$b569b31eebca952d);
/* eslint-disable jira/filename-case */ 
var $hnaxl = parcelRequire("hnaxl");
const $d14322710f49cbc9$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $hnaxl.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $d14322710f49cbc9$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $hnaxl.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("hnaxl", function(module, exports) {
$parcel$export(module.exports, "TRACE_ID_HEADER", () => $aaa0bbd80c4e5899$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $aaa0bbd80c4e5899$export$830a89e935012abe);
/* eslint-disable jira/filename-case */ const $aaa0bbd80c4e5899$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $aaa0bbd80c4e5899$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $aaa0bbd80c4e5899$export$830a89e935012abe = [
    $aaa0bbd80c4e5899$export$4b69438fb7c7b9b2,
    $aaa0bbd80c4e5899$var$TRACE_ID_HEADER_MICROS
];

});




parcelRegister("i0CFV", function(module, exports) {
$parcel$export(module.exports, "getProjectKeyFromProjectOrIssueKey", () => $503014fd6157231b$export$b8279232e05563cb);
$parcel$export(module.exports, "getProjectKey", () => $503014fd6157231b$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectIdOrKey", () => $503014fd6157231b$export$c072f183553fb7ea);
$parcel$export(module.exports, "getProjectKeyId", () => $503014fd6157231b$export$1f7213d0f9054f06);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");
const $503014fd6157231b$export$89040d072f281f85 = (query)=>query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
const $503014fd6157231b$export$b8279232e05563cb = (projectKey, issueKey)=>projectKey || (issueKey || '').split('-')[0];
const $503014fd6157231b$export$667f2a0f99c75faa = (match, query)=>$503014fd6157231b$export$b8279232e05563cb(match?.params.projectKey || query?.projectKey || query?.['project.key'], (match.params?.issueKey || '').split('-')[0] || ((0, $i860n.fg)('handle_context_panel_issue_navigator_path') ? query?.selectedIssue?.split('-')[0] : ''));
const $503014fd6157231b$export$c072f183553fb7ea = (match, query)=>$503014fd6157231b$export$89040d072f281f85(query) || $503014fd6157231b$export$667f2a0f99c75faa(match, query);
const $503014fd6157231b$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = $503014fd6157231b$export$89040d072f281f85(query);
    const projectKey = $503014fd6157231b$export$667f2a0f99c75faa(match, query);
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});


parcelRegister("9Q50z", function(module, exports) {
$parcel$export(module.exports, "jiraSpaPageContainerResource", () => $4c91d9061e775812$export$880427900755c3d5);

var $htsFl = parcelRequire("htsFl");

var $6IHMU = parcelRequire("6IHMU");
const $4c91d9061e775812$export$880427900755c3d5 = (0, $htsFl.createRelayResource)({
    type: 'JIRA_SPA_STATE_RELAY',
    getQuery: (_, context)=>{
        const cloudId = context?.tenantContext?.cloudId || '';
        return {
            parameters: (0, $6IHMU.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    captureErrors: true,
    isCritical: true
});

});
parcelRegister("htsFl", function(module, exports) {
$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $0e4716a5c6288b83$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $0e4716a5c6288b83$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $0e4716a5c6288b83$export$42ca7b248c7aaee);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $n67Vb = parcelRequire("n67Vb");

var $lIGkE = parcelRequire("lIGkE");

var $6xuJS = parcelRequire("6xuJS");

var $aI7em = parcelRequire("aI7em");

var $lMoch = parcelRequire("lMoch");

var $5SJ3N = parcelRequire("5SJ3N");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $511Fu = parcelRequire("511Fu");
const $0e4716a5c6288b83$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $0e4716a5c6288b83$var$getData = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds, skip: skip })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6xuJS.setMark)(startMark);
    // If the resource has opted out via the `skip` predicate, short-circuit
    // before invoking `getQuery` / `loadQuery` so no network request is made.
    if (skip?.(routerContext, customContext)) {
        (0, $6xuJS.setMark)(endMark);
        (0, $6xuJS.setMeasure)(measureName, startMark, endMark);
        return null;
    }
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6xuJS.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $n67Vb.loadQuery)((0, $aI7em.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $6xuJS.setMark)(endMark);
            (0, $6xuJS.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $lMoch.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $511Fu.startCapturingTraceIds)(queryReference.name);
            // oxlint-disable-next-line typescript/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $5SJ3N.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6xuJS.setMark)(endMark);
        (0, $6xuJS.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $lMoch.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $511Fu.startCapturingTraceIds)(queryReference.name);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return queryReference;
};
const $0e4716a5c6288b83$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false, isCritical: isCritical = false, skip: skip })=>(0, $7edbf.createResource)({
        type: `${$0e4716a5c6288b83$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            // When skipped, use a stable sentinel key so all skipped invocations
            // dedupe to a single cache slot and never invoke `getQuery`.
            if (skip?.(routerContext, customContext)) return '__skipped__';
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $lIGkE.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            return $0e4716a5c6288b83$var$getData({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds,
                skip: skip
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly,
        isCritical: isCritical
    });
const $0e4716a5c6288b83$export$1cc887c62079ea32 = $0e4716a5c6288b83$var$createRelayResourceImpl;
const $0e4716a5c6288b83$export$bbe949b85c06f763 = $0e4716a5c6288b83$var$createRelayResourceImpl;
const $0e4716a5c6288b83$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $k6ufm.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});
parcelRegister("aI7em", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e88d98d95dc8978$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2CHGS = parcelRequire("2CHGS");

var $67QWT = parcelRequire("67QWT");

var $edGGR = parcelRequire("edGGR");
const $2e88d98d95dc8978$var$sharedRelayEnvironmentConfig = {
    log: (0, $67QWT.default),
    relayFieldLogger: (0, $67QWT.requiredFieldLogger),
    networkOptions: (0, $2CHGS.getNetworkOptions)()
};
const $2e88d98d95dc8978$var$platformRelayEnvironment = (0, $edGGR.createRelayEnvironment)($2e88d98d95dc8978$var$sharedRelayEnvironmentConfig);
function $2e88d98d95dc8978$var$getPlatformRelayEnvironment() {
    return $2e88d98d95dc8978$var$platformRelayEnvironment;
}
var $2e88d98d95dc8978$export$2e2bcd8739ae039 = $2e88d98d95dc8978$var$getPlatformRelayEnvironment;

});
parcelRegister("2CHGS", function(module, exports) {
$parcel$export(module.exports, "getNetworkOptions", () => $b1656aadbf408383$export$6e239ba29de50840);

var $75sVW = parcelRequire("75sVW");

var $h2wCv = parcelRequire("h2wCv");

var $jVTHL = parcelRequire("jVTHL");

var $lMoch = parcelRequire("lMoch");

var $eaO9F = parcelRequire("eaO9F");

var $8yIUg = parcelRequire("8yIUg");

var $gXtG2 = parcelRequire("gXtG2");

var $i860n = parcelRequire("i860n");

var $6Kdw4 = parcelRequire("6Kdw4");

var $5ToWk = parcelRequire("5ToWk");

var $1p9Al = parcelRequire("1p9Al");

var $cGqKz = parcelRequire("cGqKz");
function $b1656aadbf408383$var$fireUnauthenticatedResponseAnalytics({ request: request, response: response }) {
    if (!(0, $i860n.fg)('relay_fetch_unauthenticated_response_analytics')) return;
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'unauthenticatedGraphqlResponse',
            attributes: {
                operation: request.name,
                operationKind: request.operationKind,
                hasData: Boolean(response.data)
            },
            source: 'jiraRelayFetch'
        });
    });
}
function $b1656aadbf408383$var$validateResponse(request, response) {
    const errors = 'errors' in response ? response.errors : undefined;
    if (errors != null) {
        const requestId = response?.extensions?.gateway?.request_id;
        if (!(0, $cGqKz.blocklist).includes(request.name)) (0, $1p9Al.getLoggingAndMetricsHelper)({
            queryName: request.name,
            operationKind: request.operationKind
        }).logNonBreakingErrors(errors, requestId);
        // @ts-expect-error -- AGGError.path has a type of `string[]`, whereas PayloadError.path has a type of `(string | number)[]`
        (0, $lMoch.captureErrors)(errors, {
            operationName: request.name,
            requestId: requestId
        });
        // @ts-expect-error -- AGGError.path has a type of `string[]`, whereas PayloadError.path has a type of `(string | number)[]`
        if ((0, $lMoch.isUnauthenticated)(errors)) {
            $b1656aadbf408383$var$fireUnauthenticatedResponseAnalytics({
                request: request,
                response: response
            });
            return false;
        }
    }
    return true;
}
function $b1656aadbf408383$var$onInvalidResponse(request, _response) {
    //  Short circuit operation and handle the unauthorized errors.
    (0, $5ToWk.showUnauthenticatedFlag)(request.name);
}
/**
 * @deprecated Use getHeaders instead.
 */ function $b1656aadbf408383$var$setOptions({ endpoint: endpoint, options: options }) {
    return (0, $cGqKz.generateOptions)(options, endpoint);
}
function $b1656aadbf408383$var$getHeaders({ endpoint: endpoint, options: options }) {
    const generatedOptions = (0, $cGqKz.generateOptions)(options, endpoint);
    return generatedOptions.headers || {};
}
function $b1656aadbf408383$var$didPreflightAuthenticationCheckTriggerRedirect(_request, _variables, _cacheConfig) {
    // `checkAuthentication` returns true when Jira is already redirecting or when it detects an
    // unauthenticated user and starts the login redirect. Relay-fetch uses that true result to skip
    // the network request and leave the observable pending while navigation takes over.
    return (0, $cGqKz.checkAuthentication)();
}
const $b1656aadbf408383$var$earlyScriptPromise = (request, variables)=>!false && (0, $8yIUg.claimEarlyScriptPromise)((0, $8yIUg.getEarlyScriptPromiseKey)(request, variables)) || undefined;
const $b1656aadbf408383$var$handleAbort = (request, reason)=>{
    // We didn't receive everything!
    const err = new (0, $75sVW.default)(424, `Incomplete handover for relay fetch: ${reason}`);
    err.name = 'ServerToClientError';
    (0, $1p9Al.getLoggingAndMetricsHelper)({
        queryName: request.name,
        operationKind: request.operationKind
    }).logError(err);
};
let $b1656aadbf408383$var$abortSignal = null;
const $b1656aadbf408383$export$18207bd33202e4f6 = (newAbortSignal)=>{
    $b1656aadbf408383$var$abortSignal = newAbortSignal;
};
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $b1656aadbf408383$var$abortSignal = null;
});
const $b1656aadbf408383$export$6e239ba29de50840 = ()=>({
        withErrorHandling: $h2wCv.withErrorHandling,
        getLoggingAndMetricsHelper: $1p9Al.getLoggingAndMetricsHelper,
        setEndpoint: (0, $jVTHL.getReroutableURL),
        didPreflightAuthenticationCheckTriggerRedirect: $b1656aadbf408383$var$didPreflightAuthenticationCheckTriggerRedirect,
        validateResponse: $b1656aadbf408383$var$validateResponse,
        onInvalidResponse: $b1656aadbf408383$var$onInvalidResponse,
        setOptions: // @deprecated Use getHeaders instead
        $b1656aadbf408383$var$setOptions,
        getHeaders: $b1656aadbf408383$var$getHeaders,
        earlyScriptPromise: $b1656aadbf408383$var$earlyScriptPromise,
        handleAbort: $b1656aadbf408383$var$handleAbort,
        queryResponseCache: (0, $eaO9F.getQueryResponseCache)(),
        getAbortSignal: ()=>$b1656aadbf408383$var$abortSignal,
        isServer: false
    });

});
parcelRegister("h2wCv", function(module, exports) {
$parcel$export(module.exports, "transformValidationErrorFromServer", () => $e4328c75419adf57$export$8e9baed7697e4959);
$parcel$export(module.exports, "withErrorHandling", () => $e4328c75419adf57$export$c874c20f7c9f97c);
$parcel$export(module.exports, "performGetRequest", () => $e4328c75419adf57$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $e4328c75419adf57$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $e4328c75419adf57$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $e4328c75419adf57$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $e4328c75419adf57$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $e4328c75419adf57$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $e4328c75419adf57$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $e4328c75419adf57$export$a5717cbee13f28b7);
$parcel$export(module.exports, "performDeleteRequestWithRetry", () => $e4328c75419adf57$export$6d01bf1146815b9b);
$parcel$export(module.exports, "performPatchRequestWithRetry", () => $e4328c75419adf57$export$560989ee94ad2a20);
/* eslint-disable jira/filename-case */ // Stryker disable all


var $k11SN = parcelRequire("k11SN");

var $atcQv = parcelRequire("atcQv");

var $ff8AH = parcelRequire("ff8AH");

var $75sVW = parcelRequire("75sVW");

var $jVTHL = parcelRequire("jVTHL");

var $5cVSt = parcelRequire("5cVSt");

var $xhPWB = parcelRequire("xhPWB");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $e4328c75419adf57$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $e4328c75419adf57$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $e4328c75419adf57$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $75sVW.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $e4328c75419adf57$var$putOptions = {
    ...(0, $ff8AH.defaultOptions),
    method: 'PUT'
};
const $e4328c75419adf57$var$postOptions = {
    ...(0, $ff8AH.defaultOptions),
    method: 'POST'
};
const $e4328c75419adf57$var$deleteOptions = {
    ...(0, $ff8AH.defaultOptions),
    method: 'DELETE'
};
const $e4328c75419adf57$var$patchOptions = {
    ...(0, $ff8AH.defaultOptions),
    method: 'PATCH'
};
function $e4328c75419adf57$export$c874c20f7c9f97c(source) {
    return source.then($e4328c75419adf57$export$1e36de371b2e3d5a).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
}
const $e4328c75419adf57$export$b47ad9bdf9122b88 = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $e4328c75419adf57$export$1e36de371b2e3d5a = (response)=>{
    const traceId = (0, $xhPWB.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $8f860a533cc71fca$export$9de493bcd9b1d977) === response.status || (0, $8f860a533cc71fca$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $e4328c75419adf57$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $75sVW.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $75sVW.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $e4328c75419adf57$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $8f860a533cc71fca$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $e4328c75419adf57$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$e4328c75419adf57$export$e174dc943a170ff(fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $k11SN.default)('platform_fetch_retries')) return executeRequest();
    return (0, $atcQv.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $e4328c75419adf57$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...(0, $ff8AH.defaultOptions),
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...$e4328c75419adf57$var$putOptions,
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$692a4d9808143175 = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...$e4328c75419adf57$var$postOptions,
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...$e4328c75419adf57$var$deleteOptions,
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...$e4328c75419adf57$var$patchOptions,
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$659b5ee69e6eb976 = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...(0, $ff8AH.defaultOptions),
        ...options
    });
const $e4328c75419adf57$export$d7b48b2904a5d812 = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...$e4328c75419adf57$var$putOptions,
        ...options
    });
const $e4328c75419adf57$export$a5717cbee13f28b7 = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...$e4328c75419adf57$var$postOptions,
        ...options
    });
const $e4328c75419adf57$export$6d01bf1146815b9b = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...$e4328c75419adf57$var$deleteOptions,
        ...options
    });
const $e4328c75419adf57$export$560989ee94ad2a20 = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...$e4328c75419adf57$var$patchOptions,
        ...options
    }); /* eslint-enable @typescript-eslint/no-unnecessary-type-constraint */ 

});
/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;


parcelRegister("lMoch", function(module, exports) {
$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $26acccd61b6ebb30$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $26acccd61b6ebb30$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $26acccd61b6ebb30$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $26acccd61b6ebb30$export$1724ecfee73c4768);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $7TA2J = parcelRequire("7TA2J");

var $gXtG2 = parcelRequire("gXtG2");
const $26acccd61b6ebb30$var$errorCollector = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $26acccd61b6ebb30$var$errorCollector.clear();
});
const $26acccd61b6ebb30$export$da396ad2a542b095 = 120000; // 2min
const $26acccd61b6ebb30$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $26acccd61b6ebb30$var$errorCollector.delete(key);
    }, $26acccd61b6ebb30$export$da396ad2a542b095);
};
const $26acccd61b6ebb30$export$c211170518c6d0f6 = (key = (0, $7TA2J.v4)())=>{
    $26acccd61b6ebb30$var$errorCollector.set(key, []);
    $26acccd61b6ebb30$var$scheduleCleanup(key);
    return key;
};
const $26acccd61b6ebb30$export$e0491a0d974dadfa = (key)=>{
    const errors = $26acccd61b6ebb30$var$errorCollector.get(key);
    $26acccd61b6ebb30$var$errorCollector.delete(key);
    return errors || [];
};
const $26acccd61b6ebb30$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $26acccd61b6ebb30$var$errorCollector.forEach((value, key)=>{
        $26acccd61b6ebb30$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $26acccd61b6ebb30$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("eaO9F", function(module, exports) {
$parcel$export(module.exports, "getQueryResponseCache", () => $17b7348dd2090005$export$3233e692a93c0cfd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $srxic = parcelRequire("srxic");

var $cY22M = parcelRequire("cY22M");

var $emCaV = parcelRequire("emCaV");

var $lIGkE = parcelRequire("lIGkE");

var $6CfY5 = parcelRequire("6CfY5");

var $75sVW = parcelRequire("75sVW");

var $icLG0 = parcelRequire("icLG0");
function $17b7348dd2090005$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $lIGkE.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $17b7348dd2090005$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $17b7348dd2090005$export$da2711d74cd28aed = [
    'doFetchWithGraphQLErrorsTrackingQuery'
];
class $17b7348dd2090005$export$be21c283b097d175 extends (0, $lIGkE.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((_response, key)=>{
            const queryID = $17b7348dd2090005$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$17b7348dd2090005$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $icLG0.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $75sVW.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $6CfY5.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($srxic)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $17b7348dd2090005$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
$17b7348dd2090005$export$be21c283b097d175.displayName = "SSRQueryResponseCache";
const $17b7348dd2090005$export$3233e692a93c0cfd = (0, $emCaV.default)(()=>{
    return new $17b7348dd2090005$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    });
});
const $17b7348dd2090005$export$94e535e06b7ade61 = ()=>$17b7348dd2090005$export$3233e692a93c0cfd().serialize();

});
parcelRegister("icLG0", function(module, exports) {
$parcel$export(module.exports, "UnusedRelayResponseError", () => $b9250ea1829886a6$export$8431e42d062de453);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $b9250ea1829886a6$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}
$b9250ea1829886a6$export$8431e42d062de453.displayName = "UnusedRelayResponseError";

});


parcelRegister("8yIUg", function(module, exports) {
$parcel$export(module.exports, "EarlyScriptQueryPromisesMap", () => $5ebbaf7b8ee8ccbd$export$6d670d323806bb37);
$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $5ebbaf7b8ee8ccbd$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $5ebbaf7b8ee8ccbd$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $5ebbaf7b8ee8ccbd$export$e1336d32be02faf4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $5ebbaf7b8ee8ccbd$export$b5fbc1430cbfd6e1 = (value)=>value;
const $5ebbaf7b8ee8ccbd$export$6d670d323806bb37 = new Map();
const $5ebbaf7b8ee8ccbd$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $5ebbaf7b8ee8ccbd$export$828ac0325bce4536 = (key)=>{
    const result = $5ebbaf7b8ee8ccbd$export$6d670d323806bb37.get(key);
    if (result != null) $5ebbaf7b8ee8ccbd$export$6d670d323806bb37.delete(key);
    return result;
};
const $5ebbaf7b8ee8ccbd$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$5ebbaf7b8ee8ccbd$export$6d670d323806bb37.has(key)) $5ebbaf7b8ee8ccbd$export$6d670d323806bb37.set(key, promise);
};

});

parcelRegister("5ToWk", function(module, exports) {
$parcel$export(module.exports, "showUnauthenticatedFlag", () => $c118599c7904f5bf$export$758fcc357484571e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iQPOZ = parcelRequire("iQPOZ");

var $6Kdw4 = parcelRequire("6Kdw4");

var $7eNDO = parcelRequire("7eNDO");
const $c118599c7904f5bf$var$title = (0, $7eNDO.defineMessage)({
    id: "relay-fetch.services.error-flags.title",
    defaultMessage: "Something's gone wrong"
});
const $c118599c7904f5bf$var$description = (0, $7eNDO.defineMessage)({
    id: "relay-fetch.services.error-flags.description",
    defaultMessage: "Looks like you've been signed out. Try logging in again. "
});
const $c118599c7904f5bf$var$login = (0, $7eNDO.defineMessage)({
    id: "relay-fetch.services.error-flags.login",
    defaultMessage: "Log in"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $c118599c7904f5bf$var$reloadPage = ()=>window.location.reload();
const $c118599c7904f5bf$var$sendAnalyticEvent = (operationName)=>{
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $c118599c7904f5bf$var$sendLoginClickEvent = (operationName)=>{
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'loginButton',
            attributes: {
                operation: operationName,
                source: globalThis.window?.location?.pathname ?? '',
                referrer: globalThis.document?.referrer ?? '',
                timestamp: new Date().toISOString(),
                userAgent: globalThis.navigator?.userAgent ?? ''
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $c118599c7904f5bf$export$758fcc357484571e = (operationName)=>{
    (0, $iQPOZ.showFlag)({
        type: 'error',
        title: $c118599c7904f5bf$var$title,
        description: $c118599c7904f5bf$var$description,
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: $c118599c7904f5bf$var$login,
                onClick: ()=>{
                    $c118599c7904f5bf$var$sendLoginClickEvent(operationName);
                    $c118599c7904f5bf$var$reloadPage();
                }
            }
        ]
    });
    $c118599c7904f5bf$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("iQPOZ", function(module, exports) {
$parcel$export(module.exports, "showFlag", () => $c715a3c03f6bb33e$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $c715a3c03f6bb33e$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $c715a3c03f6bb33e$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $c715a3c03f6bb33e$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $c715a3c03f6bb33e$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $c715a3c03f6bb33e$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $c715a3c03f6bb33e$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $c715a3c03f6bb33e$export$c126d8b307b8ab86);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d7Utd = parcelRequire("d7Utd");

var $iIEGg = parcelRequire("iIEGg");

var $cSP6q = parcelRequire("cSP6q");

var $acwzf = parcelRequire("acwzf");
const $c715a3c03f6bb33e$export$e12b2cc6b75b006b = (0, $iIEGg.default)((0, $cSP6q.store).dispatch);
const $c715a3c03f6bb33e$export$900a08a292ad23cd = (0, $d7Utd.default)((0, $cSP6q.store).dispatch);
const $c715a3c03f6bb33e$var$dismissFlagById = (id)=>{
    $c715a3c03f6bb33e$export$900a08a292ad23cd((0, $d7Utd.dismissFlag)(id));
};
const $c715a3c03f6bb33e$var$hasFlag = (id)=>Boolean((0, $cSP6q.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $c715a3c03f6bb33e$export$dbb055af53fd81a0 = {
    showFlag: $c715a3c03f6bb33e$export$e12b2cc6b75b006b,
    dismissFlag: $c715a3c03f6bb33e$export$900a08a292ad23cd
};
const $c715a3c03f6bb33e$export$eee61a1aafe3884 = ()=>({
        showFlag: $c715a3c03f6bb33e$export$e12b2cc6b75b006b,
        dismissFlag: $c715a3c03f6bb33e$var$dismissFlagById,
        hasFlag: $c715a3c03f6bb33e$var$hasFlag
    });
const $c715a3c03f6bb33e$export$dc4f8132c3090b32 = ()=>$c715a3c03f6bb33e$export$dbb055af53fd81a0;
const $c715a3c03f6bb33e$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $acwzf.DISMISS_COMMAND);
const $c715a3c03f6bb33e$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $c715a3c03f6bb33e$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $c715a3c03f6bb33e$export$63ffd7d99470afd4 = (flag)=>!$c715a3c03f6bb33e$export$14b1864d9cf0809f(flag) && !$c715a3c03f6bb33e$export$d84ce5adcee46025(flag) && !$c715a3c03f6bb33e$export$cd5f9f2b991b82d9(flag);
const $c715a3c03f6bb33e$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("d7Utd", function(module, exports) {
$parcel$export(module.exports, "dismissFlag", () => $d7bad03e6e860bfc$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $d7bad03e6e860bfc$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux

var $1BZNH = parcelRequire("1BZNH");

var $acwzf = parcelRequire("acwzf");
const $d7bad03e6e860bfc$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $acwzf.DISMISS_COMMAND),
        id: flagId
    });
const $d7bad03e6e860bfc$var$dismissFlagService = (dispatch)=>(action)=>{
        dispatch((0, $1BZNH.dismissFlagAction)(action.id));
    };
var $d7bad03e6e860bfc$export$2e2bcd8739ae039 = $d7bad03e6e860bfc$var$dismissFlagService;

});
parcelRegister("1BZNH", function(module, exports) {
$parcel$export(module.exports, "SHOW", () => $3730007a671a8090$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $3730007a671a8090$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $3730007a671a8090$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $3730007a671a8090$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $3730007a671a8090$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $3730007a671a8090$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $3730007a671a8090$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $3730007a671a8090$export$aad8462122ac592b);
/* eslint-disable jira/filename-case */ const $3730007a671a8090$export$9d04158a25ce4cd = 'state.SHOW';
const $3730007a671a8090$export$57bf213be019eeb0 = (payload)=>({
        type: $3730007a671a8090$export$9d04158a25ce4cd,
        payload: payload
    });
const $3730007a671a8090$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $3730007a671a8090$export$abf286bbe7073aba = (payload)=>({
        type: $3730007a671a8090$export$b31a07d2e6382678,
        payload: payload
    });
const $3730007a671a8090$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $3730007a671a8090$export$4818b3c52448050d = (payload)=>({
        type: $3730007a671a8090$export$1eb56620df104bf,
        payload: payload
    });
const $3730007a671a8090$export$4a991c87e640ef77 = 'state.RESET';
const $3730007a671a8090$export$aad8462122ac592b = ()=>({
        type: $3730007a671a8090$export$4a991c87e640ef77
    });

});

parcelRegister("acwzf", function(module, exports) {
$parcel$export(module.exports, "DISMISS_COMMAND", () => $4cfc2e0cc9b4c567$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $4cfc2e0cc9b4c567$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $4cfc2e0cc9b4c567$export$188cdb77b72629d7);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
const $4cfc2e0cc9b4c567$export$e705274c5e156b93 = 'DISMISS';
const $4cfc2e0cc9b4c567$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $4cfc2e0cc9b4c567$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("iIEGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $294c1084b02a9c27$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux

var $7TA2J = parcelRequire("7TA2J");

var $hIRki = parcelRequire("hIRki");

var $i860n = parcelRequire("i860n");

var $1BZNH = parcelRequire("1BZNH");

var $acwzf = parcelRequire("acwzf");
const $294c1084b02a9c27$var$showFlagService = (dispatch)=>(flag)=>{
        if ((0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion')) return undefined;
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $1BZNH.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $acwzf.toFlagId)((0, $7TA2J.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $1BZNH.show)(newFlag));
        return flagId;
    };
var $294c1084b02a9c27$export$2e2bcd8739ae039 = $294c1084b02a9c27$var$showFlagService;

});
parcelRegister("hIRki", function(module, exports) {
$parcel$export(module.exports, "isStableUIEnabledForTests", () => $8acfc2aa9431b148$export$c0b9078f666b1acf);

var $i860n = parcelRequire("i860n");

var $k11SN = parcelRequire("k11SN");

var $cX0n9 = parcelRequire("cX0n9");
const $8acfc2aa9431b148$export$c0b9078f666b1acf = ()=>{
    if (!(0, $i860n.fg)('jpx-870-stable-ui-for-criterion')) return false;
    if ((0, $k11SN.default)('jira_stable_ui_for_tests')) return false;
    return (0, $cX0n9.getLocationSearch)().includes('stableUI=1');
};

});
parcelRegister("cX0n9", function(module, exports) {
$parcel$export(module.exports, "getLocationSearch", () => $9489181b1a13707e$export$c0166938e4a3a33f);
const $9489181b1a13707e$export$c0166938e4a3a33f = ()=>{
    if (typeof globalThis?.location?.search !== 'string') return '';
    return globalThis.location.search;
};

});



parcelRegister("cSP6q", function(module, exports) {
$parcel$export(module.exports, "store", () => $a767f88668de071f$export$6f57813fe9f31bf9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jKB1k = parcelRequire("jKB1k");
const $a767f88668de071f$export$6f57813fe9f31bf9 = (0, $jKB1k.createStore)();

});
parcelRegister("jKB1k", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $e28a517437b973ed$export$f51a9068ac82ea43);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6772o = parcelRequire("6772o");

var $40Cu7 = parcelRequire("40Cu7");
const $e28a517437b973ed$export$f51a9068ac82ea43 = (rootEpic)=>(0, $6772o.default)({
        appName: 'flags',
        rootReducer: $40Cu7.default,
        rootEpic: rootEpic
    });

});
parcelRegister("6772o", function(module, exports) {
$parcel$export(module.exports, "default", () => $206aba5680d8b56f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ /// <reference types="node" />

var $euxye = parcelRequire("euxye");

var $13ZYC = parcelRequire("13ZYC");

var $bnMP4 = parcelRequire("bnMP4");

var $esROC = parcelRequire("esROC");

var $itL0K = parcelRequire("itL0K");

var $h1n3S = parcelRequire("h1n3S");

var $hqEQV = parcelRequire("hqEQV");

/**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ const $206aba5680d8b56f$var$initiateStore = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $hqEQV.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $itL0K.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // oxlint-disable-next-line typescript/no-require-imports, typescript/no-var-requires
        const { logger: logger } = (parcelRequire("cuwfX"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $esROC.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $13ZYC.createStore)((0, $bnMP4.enableBatching)(rootReducer), initialState, (0, $h1n3S.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $euxye.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $13ZYC.compose)(...enhancers, (0, $13ZYC.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};
var $206aba5680d8b56f$export$2e2bcd8739ae039 = $206aba5680d8b56f$var$initiateStore;

});
parcelRegister("itL0K", function(module, exports) {
$parcel$export(module.exports, "debugEnabled", () => $7bf95b7e5c6147de$export$342c99cc1e9bc5c6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $7bf95b7e5c6147de$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("h1n3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c7c11ba70b1a486$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux

var $13ZYC = parcelRequire("13ZYC");
// An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $9c7c11ba70b1a486$var$composeWithDevtools = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $13ZYC.compose;
};
var $9c7c11ba70b1a486$export$2e2bcd8739ae039 = $9c7c11ba70b1a486$var$composeWithDevtools;

});

parcelRegister("hqEQV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8aad5e8fcb03b108$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
class $8aad5e8fcb03b108$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}
$8aad5e8fcb03b108$export$2e2bcd8739ae039.displayName = "ActionListenerMiddleware";

});


parcelRegister("40Cu7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b840c6258163f263$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hTfsm = parcelRequire("hTfsm");

var $7TA2J = parcelRequire("7TA2J");

var $1BZNH = parcelRequire("1BZNH");
const $b840c6258163f263$var$defaultState = {
    flags: []
};
/**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ const $b840c6258163f263$var$rootReducer = (state = $b840c6258163f263$var$defaultState, action)=>{
    switch(action.type){
        case 0, $1BZNH.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($hTfsm)))([
                    {
                        id: (0, $7TA2J.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $1BZNH.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $1BZNH.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $1BZNH.RESET:
            return $b840c6258163f263$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $b840c6258163f263$export$2e2bcd8739ae039 = $b840c6258163f263$var$rootReducer;

});





parcelRegister("1p9Al", function(module, exports) {
$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $1498db7084b1b1bc$export$726e1df8186bb981);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $srxic = parcelRequire("srxic");

var $cY22M = parcelRequire("cY22M");

var $WqSvO = parcelRequire("WqSvO");

var $6CfY5 = parcelRequire("6CfY5");

var $75sVW = parcelRequire("75sVW");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");
const $1498db7084b1b1bc$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $1498db7084b1b1bc$var$LOG_NAMESPACE_INFO = 'relay.AGG.info.logQueryFallbackToPost';
const $1498db7084b1b1bc$var$errorLogFn = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jira_relay_fetch_use_log_unsafe'), (0, $6CfY5.default).unsafeErrorWithCustomerData, (0, $6CfY5.default).safeErrorWithoutCustomerData);
const $1498db7084b1b1bc$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    const logErrorRetry = (error, retryAttempt)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
            'statusCode'
        ], null);
        const errorType = error instanceof (0, $75sVW.default) ? 'network' : 'unknown';
        // Log any errors even in SSR
        $1498db7084b1b1bc$var$errorLogFn($1498db7084b1b1bc$var$LOG_NAMESPACE, `[${errorType} error]`, {
            message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($srxic)))(errorType)} error]: ${error?.message ?? ''}`,
            errorType: errorType,
            statusCode: statusCode,
            queryName: queryName,
            operationKind: operationKind,
            errorName: (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
                'name'
            ], null),
            retryAttempt: retryAttempt
        });
    };
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && $1498db7084b1b1bc$var$errorLogFn($1498db7084b1b1bc$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: logErrorRetry,
        logErrorRetry: logErrorRetry,
        logQueryFallbackToPost: (reason)=>{
            if (false && reason === 'SSR') return;
            (0, $6CfY5.default).safeInfoWithoutCustomerData($1498db7084b1b1bc$var$LOG_NAMESPACE_INFO, 'logQueryFallbackToPost', {
                queryName: queryName,
                operationKind: operationKind,
                reason: reason
            });
        }
    };
};

});

parcelRegister("cGqKz", function(module, exports) {
$parcel$export(module.exports, "checkAuthentication", () => $fcad345e0835e49b$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $fcad345e0835e49b$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "generateOptions", () => $fcad345e0835e49b$export$c21133b4499f5374);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $WqSvO = parcelRequire("WqSvO");

var $6Fltw = parcelRequire("6Fltw");

var $6RG3D = parcelRequire("6RG3D");

var $i8gMT = parcelRequire("i8gMT");

var $75sVW = parcelRequire("75sVW");

var $ff8AH = parcelRequire("ff8AH");

var $atcQv = parcelRequire("atcQv");

var $9CNRl = parcelRequire("9CNRl");

var $8nMDY = parcelRequire("8nMDY");

var $6bEm8 = parcelRequire("6bEm8");

var $2zU0a = parcelRequire("2zU0a");
let $fcad345e0835e49b$var$redirecting = false;
const $fcad345e0835e49b$export$ae8f795c4c44d494 = ()=>{
    $fcad345e0835e49b$var$redirecting = false;
};
const $fcad345e0835e49b$var$markAsRedirecting = ()=>{
    $fcad345e0835e49b$var$redirecting = true;
};
if (typeof window !== 'undefined') // Mark as redirecting, when we're unloading the page to prevent double/unwatend redirection.
window.addEventListener('beforeunload', ()=>{
    $fcad345e0835e49b$var$markAsRedirecting();
});
const $fcad345e0835e49b$var$redirect = ()=>{
    const identity = (0, $6RG3D.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $fcad345e0835e49b$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$fcad345e0835e49b$var$redirecting) {
        const heartbeatService = (0, $i8gMT.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            if (!$fcad345e0835e49b$var$redirecting) $fcad345e0835e49b$var$redirect();
            // Set flag to prevent multiple redirects
            $fcad345e0835e49b$var$markAsRedirecting();
        }
    }
    return $fcad345e0835e49b$var$redirecting;
};
const $fcad345e0835e49b$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $fcad345e0835e49b$export$9dec0f42cc67f6ab = (_queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $atcQv.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $fcad345e0835e49b$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // oxlint-disable-next-line typescript/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
const $fcad345e0835e49b$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $9CNRl.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    const cloudId = (0, $6bEm8.default)('ajs-cloud-id');
    const activationId = (0, $6bEm8.default)('ajs-activation-id');
    const atlWorkspaceId = `ari:cloud:jira:${cloudId}:workspace/${activationId}`;
    const atlAttribution = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: cloudId,
        product: 'Atlassian Jira',
        service: 'afm-frontend'
    };
    const siteAri = cloudId ? (0, $2zU0a.createAri)({
        resourceOwner: 'platform',
        resourceType: 'site',
        resourceId: cloudId
    }) : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $ff8AH.getDefaultOptions)(url),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $8nMDY.getRelayExperimentalApis)().join(','),
            'atl-attribution': JSON.stringify(atlAttribution),
            // required for Unified Graph Store requests
            'X-Query-Context': siteAri,
            ...csrfTokenHeader
        }
    });
};
const $fcad345e0835e49b$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $75sVW.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});
parcelRegister("2zU0a", function(module, exports) {
$parcel$export(module.exports, "isAri", () => $a7f581f6cd190f0d$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $a7f581f6cd190f0d$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $a7f581f6cd190f0d$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $a7f581f6cd190f0d$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $a7f581f6cd190f0d$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $a7f581f6cd190f0d$export$3d8d7031a11613fd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $a7f581f6cd190f0d$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $a7f581f6cd190f0d$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $a7f581f6cd190f0d$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $a7f581f6cd190f0d$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $a7f581f6cd190f0d$export$8e68286aef4c3a8b = (ari)=>$a7f581f6cd190f0d$var$ARI_REG_EXP.test(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_WORKSPACE.test(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_ACTIVATION.test(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $a7f581f6cd190f0d$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $a7f581f6cd190f0d$export$24b47820a324e614 = (ari)=>{
    if ($a7f581f6cd190f0d$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $a7f581f6cd190f0d$export$e2789192113e8b07 = (ari, defaultValue = '')=>$a7f581f6cd190f0d$export$24b47820a324e614(ari) ?? defaultValue;
const $a7f581f6cd190f0d$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($a7f581f6cd190f0d$export$8e68286aef4c3a8b(ari)) {
        const parts = $a7f581f6cd190f0d$var$ARI_REG_EXP.exec(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $a7f581f6cd190f0d$export$3d8d7031a11613fd = (ari)=>{
    const config = $a7f581f6cd190f0d$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});



parcelRegister("67QWT", function(module, exports) {
$parcel$export(module.exports, "requiredFieldLogger", () => $2c00263bfcdf66fa$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $2c00263bfcdf66fa$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $siTdT = parcelRequire("siTdT");

var $6CfY5 = parcelRequire("6CfY5");

var $k11SN = parcelRequire("k11SN");
const $2c00263bfcdf66fa$var$RELAY_CLIENT_ID = 'AGG';
const $2c00263bfcdf66fa$var$LOG_NAMESPACE = `relay.${$2c00263bfcdf66fa$var$RELAY_CLIENT_ID}.error.graphql`;
const $2c00263bfcdf66fa$var$requests = {};
const $2c00263bfcdf66fa$var$queries = {};
const $2c00263bfcdf66fa$var$resources = {};
const $2c00263bfcdf66fa$var$executes = {};
const $2c00263bfcdf66fa$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $2c00263bfcdf66fa$export$1ab8b98d209afe85 = (event)=>{
    (0, $6CfY5.default).safeErrorWithoutCustomerData($2c00263bfcdf66fa$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $2c00263bfcdf66fa$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $2c00263bfcdf66fa$export$2e2bcd8739ae039(event) {
    if ((0, $k11SN.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $2c00263bfcdf66fa$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $2c00263bfcdf66fa$var$queries[name] = newRequestInfo;
                    $2c00263bfcdf66fa$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $2c00263bfcdf66fa$var$requests[networkRequestId];
                        delete $2c00263bfcdf66fa$var$queries[name];
                    }, $2c00263bfcdf66fa$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $2c00263bfcdf66fa$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // oxlint-disable-next-line typescript/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $2c00263bfcdf66fa$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // oxlint-disable-next-line typescript/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $2c00263bfcdf66fa$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $2c00263bfcdf66fa$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $siTdT.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $2c00263bfcdf66fa$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $2c00263bfcdf66fa$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $2c00263bfcdf66fa$var$queries[name] = newRequestInfo;
                        $2c00263bfcdf66fa$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $2c00263bfcdf66fa$var$queries[node.name];
                        }, $2c00263bfcdf66fa$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $2c00263bfcdf66fa$var$resources[event.resourceID];
                    }, $2c00263bfcdf66fa$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $2c00263bfcdf66fa$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // oxlint-disable-next-line typescript/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $2c00263bfcdf66fa$var$executes[event.executeId] = {
                name: event.params.name,
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next.start':
            $2c00263bfcdf66fa$var$executes[event.executeId].start = performance.now();
            break;
        case 'execute.next.end':
            {
                const now = performance.now();
                const duration = now - $2c00263bfcdf66fa$var$executes[event.executeId].start;
                $2c00263bfcdf66fa$var$executes[event.executeId].end = now;
                $2c00263bfcdf66fa$var$executes[event.executeId].duration = duration;
                break;
            }
        case 'execute.async.module':
            break;
        case 'execute.error':
            delete $2c00263bfcdf66fa$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $2c00263bfcdf66fa$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $2c00263bfcdf66fa$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc.start':
            break;
        case 'store.gc.end':
            break;
        case 'store.gc.interrupted':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});




parcelRegister("dUAVJ", function(module, exports) {
$parcel$export(module.exports, "getModernIssueTransitionResources", () => $be6d40025d6de0a0$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $be6d40025d6de0a0$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $be6d40025d6de0a0$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $be6d40025d6de0a0$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $be6d40025d6de0a0$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $be6d40025d6de0a0$export$808691f5a412afa3);
$parcel$export(module.exports, "getNavigationResourcesForWorkItem", () => $be6d40025d6de0a0$export$6fbb399465b8a47f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable import/order, jira/import-whitelist */ 
var $chlbQ = parcelRequire("chlbQ");

var $jyhod = parcelRequire("jyhod");

var $eDOWT = parcelRequire("eDOWT");

var $6RSCO = parcelRequire("6RSCO");

var $hB5dG = parcelRequire("hB5dG");

var $6UbAk = parcelRequire("6UbAk");

var $kJ9Q0 = parcelRequire("kJ9Q0");

var $dQd0z = parcelRequire("dQd0z");

var $fdMbz = parcelRequire("fdMbz");

var $45Itd = parcelRequire("45Itd");

var $i4Cir = parcelRequire("i4Cir");

var $gjifS = parcelRequire("gjifS");

var $edf7u = parcelRequire("edf7u");

var $8Uubk = parcelRequire("8Uubk");

var $ecGij = parcelRequire("ecGij");

var $2NAMr = parcelRequire("2NAMr");

var $6bGyp = parcelRequire("6bGyp");

var $kmdD8 = parcelRequire("kmdD8");

var $8HUuJ = parcelRequire("8HUuJ");

var $35eqr = parcelRequire("35eqr");

var $fjAPO = parcelRequire("fjAPO");

var $4B518 = parcelRequire("4B518");

var $eFqFr = parcelRequire("eFqFr");

var $1IUl9 = parcelRequire("1IUl9");

var $56F5E = parcelRequire("56F5E");

var $3tHVQ = parcelRequire("3tHVQ");

var $iFmc7 = parcelRequire("iFmc7");

var $hEjfV = parcelRequire("hEjfV");

var $5mMCG = parcelRequire("5mMCG");

var $hFYSn = parcelRequire("hFYSn");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $9O6SX = parcelRequire("9O6SX");

var $lxP6a = parcelRequire("lxP6a");
const $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4Resource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('post_office_ssr_jira_side_nav_enabled'), (0, $35eqr.postOfficeJiraSideNavResource));
const $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('enable_ssr_recommendations_in_nav4'), (0, $35eqr.postOfficeNav4ProjectsSectionResource));
const $be6d40025d6de0a0$var$isModernIssueTransitionSettingEnabled = ()=>{
    return (0, $2700E.expVal)('jira_issue_transition_screen_modernisation_toggle', 'value', 'OFF') !== 'OFF';
};
const $be6d40025d6de0a0$var$conditionalGicOptInStatusResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('render_modern_global_issue_create_modal_experience'), (0, $6UbAk.gicOptInStatusResources));
const $be6d40025d6de0a0$var$conditionalIssueTransitionOptInStatusResource = (0, $8HUuJ.resourceWithCondition)($be6d40025d6de0a0$var$isModernIssueTransitionSettingEnabled, (0, $dQd0z.issueTransitionOptInStatusResource));
const $be6d40025d6de0a0$export$e1afa08027b1e44b = ()=>[
        $be6d40025d6de0a0$var$conditionalIssueTransitionOptInStatusResource,
        (0, $kJ9Q0.issueTransitionChangeboardingPreferencesResource)
    ];
const $be6d40025d6de0a0$var$getOperationsJiraSideNavResource = ()=>(0, $6RSCO.getConsolidationStateResource)();
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $be6d40025d6de0a0$var$getDedupableConditionalResources = (isUsingSidebarEntrypoint)=>{
    const resources = [
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('navx-global-side-nav'), (0, $9O6SX.navPlatformRootStateResource)),
        (0, $3tHVQ.sidebarEntryUiStateResource),
        (0, $1IUl9.topNav4UIStateResource),
        $be6d40025d6de0a0$var$getOperationsJiraSideNavResource()
    ];
    if (isUsingSidebarEntrypoint) // We don't want sidebarNav4Resource/navPlatformSidebarResource loaded for entrypoints otherwise
    // we end up with a client side api call when we don't need it as SSR will have loaded the data already.
    return resources;
    resources.push((0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('navx-global-side-nav'), (0, $56F5E.navPlatformSidebarResource), (0, $3tHVQ.sidebarNav4Resource)));
    return resources;
};
const $be6d40025d6de0a0$export$75cffd1aaecf4a2c = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        ...(0, $4B518.jiraSpaResources)(),
        (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('navx-global-side-nav'), (0, $i4Cir.navigationUiStateResource)),
        (0, $eFqFr.navigationPlansVisibilityResource),
        (0, $kmdD8.userHomepageResource),
        $be6d40025d6de0a0$var$conditionalGicOptInStatusResource,
        (0, $eDOWT.consolidationUserStateResource),
        ...$be6d40025d6de0a0$var$getDedupableConditionalResources(isUsingSidebarEntrypoint),
        ...$be6d40025d6de0a0$export$e1afa08027b1e44b(),
        (0, $gjifS.persistentIssueCreateModalViewResource),
        (0, $hB5dG.gicSmartFieldsFeatureResource),
        (0, $6bGyp.rovoEntitlementResource),
        (0, $2NAMr.jpdRecommendationDismissedResource),
        (0, $ecGij.fetchSiteUserTraitsResource),
        (0, $8Uubk.fetchSiteTraitsResource),
        $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4Resource,
        $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource,
        ...(0, $lxP6a.getBannerResources)(),
        (0, $fjAPO.previewPanelStateResource)
    ];
const $be6d40025d6de0a0$export$c57dc1ea7f76f91f = ()=>[
        (0, $5mMCG.staticJSWUserBoardSidebarNavigationResource)
    ];
const $be6d40025d6de0a0$export$af2259a87f79645d = ()=>[
        (0, $hEjfV.staticPlanSidebarNavigationResource)
    ];
const $be6d40025d6de0a0$export$a103e99ad51f7bc3 = ()=>[
        (0, $45Itd.navigationSidebarGlobalResource),
        (0, $6RSCO.getConsolidationStateResource)(),
        (0, $jyhod.checkApiKeyManagementKeysResource)(),
        (0, $chlbQ.nav4SidebarGlobalProductsSettingsResource)
    ];
const $be6d40025d6de0a0$export$808691f5a412afa3 = ()=>[
        (0, $fdMbz.navigationSidebarAutomationLegacyEnabledResource),
        (0, $edf7u.projectContextResourceWithCache),
        (0, $hFYSn.forgeProjectSettingsModuleResource),
        (0, $iFmc7.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];
const $be6d40025d6de0a0$export$6fbb399465b8a47f = ()=>[
        ...(0, $4B518.jiraSpaResources)(),
        // Checks if the Plans menu should appear in the sidebar
        (0, $eFqFr.navigationPlansVisibilityResource),
        // check if we can render the global issue create modal when clicking the Create button.
        $be6d40025d6de0a0$var$conditionalGicOptInStatusResource,
        // ConversationAssistant component on the TopNav
        (0, $6bGyp.rovoEntitlementResource),
        // used in Nav4JiraSideNavRecommendation
        $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4Resource,
        $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource,
        // used in glance panel.
        (0, $fjAPO.previewPanelStateResource),
        // issues related resources -> issue-create modal
        (0, $gjifS.persistentIssueCreateModalViewResource),
        (0, $hB5dG.gicSmartFieldsFeatureResource),
        ...$be6d40025d6de0a0$export$e1afa08027b1e44b(),
        ...$be6d40025d6de0a0$var$getDedupableConditionalResources(false),
        ...(0, $lxP6a.getBannerResources)()
    ];

});
parcelRegister("chlbQ", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarGlobalProductsSettingsResource", () => $3d231041127fbc86$export$48318c24101869b4);

var $htsFl = parcelRequire("htsFl");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $cCjMO = parcelRequire("cCjMO");
const $3d231041127fbc86$var$RESOURCE_TYPE_GLOBAL_PRODUCTS_SETTINGS_SIDEBAR = 'GLOBAL_PRODUCTS_SETTINGS_SIDEBAR';
const $3d231041127fbc86$var$SERVICE_DESK = 'jira-servicedesk';
const $3d231041127fbc86$var$FREE_EDITION = 'FREE_EDITION';
const $3d231041127fbc86$var$STANDARD_EDITION = 'STANDARD_EDITION';
const $3d231041127fbc86$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $3d231041127fbc86$var$hasLicensedServiceDeskAboveStandard = ({ licensedProducts: licensedProducts, serviceDeskEdition: serviceDeskEdition })=>Boolean(licensedProducts?.[$3d231041127fbc86$var$SERVICE_DESK]) && serviceDeskEdition !== undefined && serviceDeskEdition !== $3d231041127fbc86$var$FREE_EDITION && serviceDeskEdition !== $3d231041127fbc86$var$STANDARD_EDITION;
const $3d231041127fbc86$export$48318c24101869b4 = (0, $htsFl.createRelayResource)({
    type: $3d231041127fbc86$var$RESOURCE_TYPE_GLOBAL_PRODUCTS_SETTINGS_SIDEBAR,
    getQuery: (_, { tenantContext: { cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, licensedProducts: licensedProducts } })=>({
            parameters: (0, $cCjMO.default),
            variables: {
                cloudId: cloudId,
                // We can skip the permission check when:
                // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                // 2. Upsell is enabled (because upsell is only available to admins), or
                // 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone)
                skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' || !(0, $i860n.fg)('jira-onboarding-hub-gate'),
                skipSiteWfoStatus: !($3d231041127fbc86$var$hasLicensedServiceDeskAboveStandard({
                    licensedProducts: licensedProducts,
                    serviceDeskEdition: appEditions?.serviceDesk
                }) && $3d231041127fbc86$var$isWorkforceAemEnabled() && (0, $i860n.fg)('jsm_wfo_skills'))
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true,
    isCritical: true
});

});
parcelRegister("cCjMO", function(module, exports) {
$parcel$export(module.exports, "default", () => $3becb4ba570e876e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba159a91674374225c7eb6658b509a93>>
 * @relayHash cb457fe22f3415d160d9c995a7a1d1c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8764a45d0de9f9d95947200f9d2f2d62b99ca49a5036ba89d08934fbe00a18d3

var $lIGkE = parcelRequire("lIGkE");
const $3becb4ba570e876e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipSiteWfoStatus"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalProductsSettingsSidebarQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "skipDelegatedAdminCheck",
                            "variableName": "skipDelegatedAdminCheck"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "DelegatedAdminJiraSection"
                },
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "skipSiteWfoStatus",
                            "variableName": "skipSiteWfoStatus"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalProductsSettingsSidebarQuery",
            "selections": [
                {
                    "condition": "skipDelegatedAdminCheck",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canManageCustomOnboarding",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "MANAGE_CUSTOM_ONBOARDING"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPermission"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skipSiteWfoStatus",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "AgentWorkspaceSiteWfoStatus",
                            "kind": "LinkedField",
                            "name": "agentWorkspace_siteWfoStatus",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasProjectEnabledWfo"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8764a45d0de9f9d95947200f9d2f2d62b99ca49a5036ba89d08934fbe00a18d3",
            "metadata": {},
            "name": "GlobalProductsSettingsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3becb4ba570e876e$var$node.hash = "81ff1f6d7d4bee54d7a26279bb3171ae";
(0, $lIGkE.PreloadableQueryRegistry).set($3becb4ba570e876e$var$node.params.id, $3becb4ba570e876e$var$node);
var $3becb4ba570e876e$export$2e2bcd8739ae039 = $3becb4ba570e876e$var$node;

});


parcelRegister("jyhod", function(module, exports) {
$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $d130c15da436f240$export$b16eaa5246afc9b6);
/* eslint-disable jira/import-whitelist */ // eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.

var $hG5S4 = parcelRequire("hG5S4");

var $i860n = parcelRequire("i860n");

var $jOrx3 = parcelRequire("jOrx3");

var $7edbf = parcelRequire("7edbf");
const $d130c15da436f240$var$ConsolidationState = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};
const $d130c15da436f240$var$CONSOLIDATION_STATE_RESOURCE_TYPE = 'EOC_TENANT';
const $d130c15da436f240$var$CHECK_API_KEY_RESOURCE_TYPE = 'EOC_CHECK_API_KEY';
const $d130c15da436f240$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, opsEnabled, appPermissions)=>{
    if (!opsEnabled || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $hG5S4.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
// eslint-disable-next-line jira/router/no-daisy-chaining-resources
const $d130c15da436f240$var$resource = (0, $7edbf.createResource)({
    type: $d130c15da436f240$var$CHECK_API_KEY_RESOURCE_TYPE,
    getKey: ()=>'check-api-key-management-keys',
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const tenantInfo = await dependencies[$d130c15da436f240$var$CONSOLIDATION_STATE_RESOURCE_TYPE]?.promise;
        const opsEnabled = (0, $jOrx3.checkIsTransitioning)(tenantInfo) || (0, $jOrx3.checkIsTransitioned)(tenantInfo) && (0, $i860n.fg)('api_key_management_open_for_transitioned_users');
        return $d130c15da436f240$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, opsEnabled, appPermissions);
    },
    maxAge: Infinity,
    isBrowserOnly: true,
    depends: [
        $d130c15da436f240$var$CONSOLIDATION_STATE_RESOURCE_TYPE
    ],
    isCritical: true
});
const $d130c15da436f240$export$b16eaa5246afc9b6 = ()=>$d130c15da436f240$var$resource;

});
parcelRegister("hG5S4", function(module, exports) {
$parcel$export(module.exports, "eocFetch", () => $fd54832073eb5503$export$212b9c60150b5a0a);

var $egspI = parcelRequire("egspI");

var $anDmR = parcelRequire("anDmR");

var $siTdT = parcelRequire("siTdT");

var $6LoxL = parcelRequire("6LoxL");

var $7nxyA = parcelRequire("7nxyA");
const $fd54832073eb5503$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') {
        input = (0, $7nxyA.withPrefix)(input, init);
        if ((0, $egspI.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $anDmR.getActiveTraceHttpRequestHeaders)(input),
            ...headers
        };
    } else {
        input = {
            ...input,
            url: (0, $7nxyA.withPrefix)(input.url, init)
        };
        if ((0, $egspI.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $anDmR.getActiveTraceHttpRequestHeaders)(input.url),
            ...headers
        };
    }
    const errorTransformer = init?.errorTransformer ?? (0, $7nxyA.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $6LoxL.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $6LoxL.HTTPError)(response);
        const sanitizedUrl = (0, $7nxyA.sanitizeUrlString)((0, $7nxyA.getRequestUrl)(input));
        (0, $siTdT.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $6LoxL.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("6LoxL", function(module, exports) {
$parcel$export(module.exports, "NetworkError", () => $f6240e1fe220a54e$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $f6240e1fe220a54e$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $f6240e1fe220a54e$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $f6240e1fe220a54e$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $f6240e1fe220a54e$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $f6240e1fe220a54e$export$4f52fcea95c8f97d);

var $kMCB5 = parcelRequire("kMCB5");
class $f6240e1fe220a54e$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $f6240e1fe220a54e$export$aa9d629c530f62a7 extends $f6240e1fe220a54e$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $kMCB5.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $f6240e1fe220a54e$export$c30b5b02747d791c extends $f6240e1fe220a54e$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $kMCB5.ERROR_NAMES).StreamedHTTPError;
    }
}
const $f6240e1fe220a54e$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $f6240e1fe220a54e$export$aa9d629c530f62a7 || [
        (0, $kMCB5.ERROR_NAMES).HTTPError,
        (0, $kMCB5.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $f6240e1fe220a54e$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $f6240e1fe220a54e$export$bae979e68e4dc802 || [
        (0, $kMCB5.ERROR_NAMES).NetworkError,
        (0, $kMCB5.ERROR_NAMES).HTTPError,
        (0, $kMCB5.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $f6240e1fe220a54e$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $f6240e1fe220a54e$export$c30b5b02747d791c || candidate?.name === (0, $kMCB5.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("kMCB5", function(module, exports) {
$parcel$export(module.exports, "ERROR_NAMES", () => $3f6f47ddf966e40e$export$daceac3b97803ce1);
var $3f6f47ddf966e40e$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("7nxyA", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $59452b36ca7b4501$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $59452b36ca7b4501$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $59452b36ca7b4501$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $59452b36ca7b4501$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $59452b36ca7b4501$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $59452b36ca7b4501$export$ceb09b958e605eff);

var $1eOxf = parcelRequire("1eOxf");

var $6LoxL = parcelRequire("6LoxL");

let $59452b36ca7b4501$var$metaCloudId;
let $59452b36ca7b4501$var$isJSMAvailable = true;
function $59452b36ca7b4501$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $1eOxf.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($59452b36ca7b4501$var$metaCloudId) return $59452b36ca7b4501$var$metaCloudId;
    if ($59452b36ca7b4501$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $59452b36ca7b4501$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $59452b36ca7b4501$var$isJSMAvailable = !!$59452b36ca7b4501$var$metaCloudId;
    }
    return $59452b36ca7b4501$var$metaCloudId;
}
function $59452b36ca7b4501$export$5a75f4aeb58ba80f(id) {
    $59452b36ca7b4501$var$metaCloudId = id;
}
function $59452b36ca7b4501$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $59452b36ca7b4501$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $af3634021fc4cc54$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $59452b36ca7b4501$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $59452b36ca7b4501$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $6LoxL.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $59452b36ca7b4501$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $6LoxL.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $6LoxL.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $59452b36ca7b4501$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $6LoxL.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $59452b36ca7b4501$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $6LoxL.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $6LoxL.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $59452b36ca7b4501$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $59452b36ca7b4501$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("1eOxf", function(module, exports) {
$parcel$export(module.exports, "isServer", () => $c1f03e55d377e243$export$6acf61af03e62db);
const $c1f03e55d377e243$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $af3634021fc4cc54$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("jOrx3", function(module, exports) {
$parcel$export(module.exports, "checkShouldUseJSM", () => $0334a769fc74f9a3$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $0334a769fc74f9a3$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $0334a769fc74f9a3$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $0334a769fc74f9a3$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $0334a769fc74f9a3$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $0334a769fc74f9a3$export$cd227238525e8d57);
$parcel$export(module.exports, "checkIsOpsAdmin", () => $0334a769fc74f9a3$export$66a96ac2f07f6730);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4Hqzm = parcelRequire("4Hqzm");

const $0334a769fc74f9a3$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $4Hqzm.ConsolidationState).NOT_CONSOLIDATED;
};
const $0334a769fc74f9a3$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $4Hqzm.ConsolidationState).TRANSITIONING;
};
const $0334a769fc74f9a3$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $4Hqzm.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $4Hqzm.ConsolidationState).CONSOLIDATED;
};
const $0334a769fc74f9a3$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $4Hqzm.ConsolidationState).TRANSITIONED;
};
const $0334a769fc74f9a3$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $4Hqzm.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $22af9b38fb39bbda$export$650f6934db1290c1);
};
const $0334a769fc74f9a3$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $4Hqzm.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $22af9b38fb39bbda$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $22af9b38fb39bbda$export$a101f3562b5f0742));
};
const $0334a769fc74f9a3$export$66a96ac2f07f6730 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
};

});
parcelRegister("4Hqzm", function(module, exports) {
$parcel$export(module.exports, "ConsolidationState", () => $f7bb6fc78fe3f4fe$export$9ef498b0a11fd37d);
/* eslint-disable jira/filename-case */ const $f7bb6fc78fe3f4fe$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

/* eslint-disable jira/filename-case */ const $22af9b38fb39bbda$export$650f6934db1290c1 = 'cohort3';
const $22af9b38fb39bbda$export$a101f3562b5f0742 = 'cohort3.5';



parcelRegister("eDOWT", function(module, exports) {
$parcel$export(module.exports, "consolidationUserStateResource", () => $7ca33878ff27a3ca$export$4b870505c49999ef);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $7edbf = parcelRequire("7edbf");

var $kJh74 = parcelRequire("kJh74");
const $7ca33878ff27a3ca$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $7ca33878ff27a3ca$export$4b870505c49999ef = (0, $7edbf.createResource)({
    type: $7ca33878ff27a3ca$var$RESOURCE_KEY,
    getKey: ()=>$7ca33878ff27a3ca$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $kJh74.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity,
    isCritical: true
});

});
parcelRegister("kJh74", function(module, exports) {
$parcel$export(module.exports, "getOgConsolidationUserState", () => $cbf353c609a4e7a4$export$df7594d56c9ebe57);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $5hdVX = parcelRequire("5hdVX");
const $cbf353c609a4e7a4$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $5hdVX.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $kM0go.getUserProperty)(accountId, (0, $5hdVX.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $75sVW.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $75sVW.default) && error.statusCode === 404) return 0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("kM0go", function(module, exports) {
$parcel$export(module.exports, "getUserPropertiesUrl", () => $a798a89cb8e924a7$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $a798a89cb8e924a7$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $a798a89cb8e924a7$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "deleteUserProperty", () => $a798a89cb8e924a7$export$4c4183b491dea321);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $75sVW = parcelRequire("75sVW");

var $5xrGf = parcelRequire("5xrGf");

var $jVTHL = parcelRequire("jVTHL");
const $a798a89cb8e924a7$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $a798a89cb8e924a7$var$getUserPropertiesUrlWithReroute = (accountId, propertyKey)=>{
    const path = $a798a89cb8e924a7$export$f474e53c8191800a(accountId, propertyKey);
    return (0, $jVTHL.getReroutableURL)(path);
};
const $a798a89cb8e924a7$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>{
    const url = $a798a89cb8e924a7$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $5xrGf.getDefaultOptions)(url),
        method: 'PUT',
        body: data
    });
};
const $a798a89cb8e924a7$export$b3126db2ef6e34ed = (accountId, propertyKey)=>{
    const url = $a798a89cb8e924a7$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, (0, $5xrGf.getDefaultOptions)(url)).then((res)=>{
        if (!res) throw new (0, $75sVW.default)(0, 'Fetch returned an undefined response');
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $75sVW.default)(res.status, errResp);
        });
    }).then((data)=>data.value);
};
const $a798a89cb8e924a7$export$4c4183b491dea321 = (accountId, propertyKey)=>{
    const url = $a798a89cb8e924a7$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $5xrGf.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});
parcelRegister("5xrGf", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $caeae6ff53216f59$export$430a3269e24b912e);
/* eslint-disable jira/filename-case */ 
var $5cVSt = parcelRequire("5cVSt");

var $99tc1 = parcelRequire("99tc1");
function $caeae6ff53216f59$export$430a3269e24b912e(url) {
    let options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ],
            ...false ? {
                // Needed for call to monolith
                'x-ssr-asap-audience': 'jira'
            } : {}
        }
    };
    options = url ? (0, $5cVSt.applyObservabilityHeaders)(url, options) : options;
    if (false) options = (0, $99tc1.applySsrFetchConfigOverrideHeaders)(options);
    return options;
}
const $caeae6ff53216f59$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ],
        ...false ? {
            // Needed for call to monolith
            'x-ssr-asap-audience': 'jira'
        } : {}
    }
};

});


parcelRegister("5hdVX", function(module, exports) {
$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $7ab74033cbcc03fb$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $7ab74033cbcc03fb$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $7ab74033cbcc03fb$export$23da4710c3a29eae);
/* eslint-disable jira/filename-case */ const $7ab74033cbcc03fb$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $7ab74033cbcc03fb$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $7ab74033cbcc03fb$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("6RSCO", function(module, exports) {
$parcel$export(module.exports, "getConsolidationStateResource", () => $d107e0eee5bae101$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.

var $dJ3NQ = parcelRequire("dJ3NQ");

var $hG5S4 = parcelRequire("hG5S4");

var $7edbf = parcelRequire("7edbf");

var $jVTHL = parcelRequire("jVTHL");

var $4Hqzm = parcelRequire("4Hqzm");

const $d107e0eee5bae101$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, isAnonymous, appPermissions)=>{
    let url = '/internal/v1/users/ops-user-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false || isAnonymous) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $4Hqzm.ConsolidationState).NOT_CONSOLIDATED,
                isAdmin: false
            });
        });
        return promise;
    }
    url = `${url}/${atlassianAccountId}`;
    if (false && !(0, $dJ3NQ.default)()) promise = (0, $hG5S4.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': 'og-apps-user-int-api'
        }
    });
    else {
        const clientUrl = '/v1/users/ops-user-info';
        promise = (0, $hG5S4.eocFetch)((0, $jVTHL.getReroutableURL)(`/gateway/api/jsm/ops/web/${cloudId}${clientUrl}`), {
            exactUrl: true
        }).then(({ data: data })=>data);
    }
    return promise;
};
const $d107e0eee5bae101$var$getConsolidationStateResourceFactory = (forceBrowser = false)=>(0, $7edbf.createResource)({
        type: (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>$d107e0eee5bae101$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, isAnonymous, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser,
        isCritical: true
    });
const $d107e0eee5bae101$var$consolidationResourceForceBrowser = $d107e0eee5bae101$var$getConsolidationStateResourceFactory(true);
const $d107e0eee5bae101$var$consolidationResourceDontForceBrowser = $d107e0eee5bae101$var$getConsolidationStateResourceFactory(false);
const $d107e0eee5bae101$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>{
    /**
	 * This needs to return the same resource instance each time (based on args) or else we end up with many unnecessary re-renders
	 */ return forceBrowser ? $d107e0eee5bae101$var$consolidationResourceForceBrowser : $d107e0eee5bae101$var$consolidationResourceDontForceBrowser;
};

});
/* eslint-disable jira/filename-case */ const $3ec8eeeab0e63d24$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("hB5dG", function(module, exports) {
$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $dafecd381926ee5b$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $dafecd381926ee5b$export$3870b1ff1b155c73);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $fNXFu = parcelRequire("fNXFu");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $dafecd381926ee5b$export$ee94bb1f59b07e35 = (0, $7edbf.createResource)({
    type: (0, $d80bd56b7b683e61$export$6f0555de4f60e84e),
    getKey: ()=>(0, $d80bd56b7b683e61$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $fNXFu.userPreferenceAPI).get((0, $d80bd56b7b683e61$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            return data;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $d80bd56b7b683e61$export$b8b9d90f9e5bd72b),
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false,
            hasUserDismissedGicOnboarding: false
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $dafecd381926ee5b$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $k6ufm.useResource)($dafecd381926ee5b$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const currentDismissedGicOnboarding = typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false;
    const dismissReadMore = (0, $euxye.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true,
                ...previousData?.hasUserDismissedGicOnboarding ? {
                    hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                } : {
                    hasUserDismissedGicOnboarding: false
                }
            }));
    }, [
        update
    ]);
    const dismissGicOnboarding = (0, $euxye.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                ...previousData?.hasUserDismissedReadMore ? {
                    hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                } : {
                    hasUserDismissedReadMore: false
                },
                hasUserDismissedGicOnboarding: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
        dismissReadMore: dismissReadMore,
        dismissGicOnboarding: dismissGicOnboarding,
        loading: loading
    };
};

});
parcelRegister("fNXFu", function(module, exports) {
$parcel$export(module.exports, "userPreferenceAPI", () => $cb7161d45afb1952$export$4f7929ca6b50a436);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $h2wCv = parcelRequire("h2wCv");
const $cb7161d45afb1952$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $cb7161d45afb1952$var$get = async (key)=>{
    try {
        const result = await (0, $h2wCv.performGetRequest)($cb7161d45afb1952$var$url(key));
        return result?.value;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $cb7161d45afb1952$var$set = (key, value)=>(0, $h2wCv.performPutRequest)($cb7161d45afb1952$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $cb7161d45afb1952$var$remove = (key)=>(0, $h2wCv.performDeleteRequest)($cb7161d45afb1952$var$url(key));
const $cb7161d45afb1952$export$4f7929ca6b50a436 = {
    get: $cb7161d45afb1952$var$get,
    set: $cb7161d45afb1952$var$set,
    remove: $cb7161d45afb1952$var$remove
};

});

/* eslint-disable jira/filename-case */ const $d80bd56b7b683e61$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $d80bd56b7b683e61$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $d80bd56b7b683e61$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $d80bd56b7b683e61$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("6UbAk", function(module, exports) {
$parcel$export(module.exports, "gicOptInStatusResources", () => $27f8bb0fea4e185b$export$14c89b6b6a261524);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

const $27f8bb0fea4e185b$export$14c89b6b6a261524 = (0, $7edbf.createResource)({
    type: (0, $18427a9ed43dc52e$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            if ((0, $i860n.fg)('issue-create-stop-using-preference-api')) gicOptInStatus = {
                isEnabled: true
            };
            else gicOptInStatus = await (0, $h2wCv.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $6CfY5.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
/* eslint-disable jira/filename-case */ const $18427a9ed43dc52e$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("kJ9Q0", function(module, exports) {
$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $7cbd1f9e6e076c91$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $7cbd1f9e6e076c91$export$e21c345b2538e96e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6Tcej = parcelRequire("6Tcej");

var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $adi4M = parcelRequire("adi4M");
const $7cbd1f9e6e076c91$export$1b6468a6eb7d9b09 = (0, $7edbf.createResource)({
    type: (0, $adi4M.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $adi4M.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $h2wCv.performGetRequest)((0, $adi4M.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $hFtK7.fireErrorAnalytics)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    },
    isCritical: true
});
const $7cbd1f9e6e076c91$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $k6ufm.useResource)($7cbd1f9e6e076c91$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $euxye.useState)(()=>{
        if ((0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $adi4M.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $euxye.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $euxye.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $euxye.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $i860n.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $h2wCv.performPutRequest)((0, $adi4M.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $euxye.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("6Tcej", function(module, exports) {

var $lpdoW = parcelRequire("lpdoW");

var $kLB1e = parcelRequire("kLB1e");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $50415db9cad4fc4c$var$has(object, path) {
    return object != null && $kLB1e(object, path, $lpdoW);
}
module.exports = $50415db9cad4fc4c$var$has;

});
parcelRegister("lpdoW", function(module, exports) {
/** Used for built-in method references. */ var $f95653fd27b3c347$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f95653fd27b3c347$var$hasOwnProperty = $f95653fd27b3c347$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f95653fd27b3c347$var$baseHas(object, key) {
    return object != null && $f95653fd27b3c347$var$hasOwnProperty.call(object, key);
}
module.exports = $f95653fd27b3c347$var$baseHas;

});


parcelRegister("adi4M", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $781fbaa1009107c7$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $781fbaa1009107c7$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $781fbaa1009107c7$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $781fbaa1009107c7$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $781fbaa1009107c7$export$9ccdfd91f2512a27);
/* eslint-disable jira/filename-case */ const $781fbaa1009107c7$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $781fbaa1009107c7$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $781fbaa1009107c7$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $781fbaa1009107c7$export$91880069e7e73b18 = -1;
const $781fbaa1009107c7$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("dQd0z", function(module, exports) {
$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $587b61a739f479c7$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $587b61a739f479c7$export$bc11d4816053db5c);

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


var $6AvEG = parcelRequire("6AvEG");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $587b61a739f479c7$var$fetchGetIssueTransitionOptInState = async ()=>(0, $h2wCv.performGetRequest)((0, $38435de89b8286ba$export$466b1c60da56c8ca));
const $587b61a739f479c7$export$5fbcf4d7a6d9c477 = (0, $7edbf.createResource)({
    type: (0, $38435de89b8286ba$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $38435de89b8286ba$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isFedRampSrbFallback = (0, $i860n.fg)('aem_migration_jira') ? !(0, $41FAq.isFeatureEnabled)('jira', 'issue-transition-customisation-for-srb') : (0, $l1vE2.isFedRamp)();
        const isModernIssueTransitionSRBCohort = (0, $i860n.fg)('issue-transition-customisation-for-srb') || isFedRampSrbFallback;
        if (!(0, $i860n.fg)('render-modern-issue-transition')) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $587b61a739f479c7$var$fetchGetIssueTransitionOptInState();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $6AvEG.default)()
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $587b61a739f479c7$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $h2wCv.performPutRequest)((0, $38435de89b8286ba$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $587b61a739f479c7$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $k6ufm.useResource)($587b61a739f479c7$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $euxye.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $6AvEG.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $euxye.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $euxye.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $euxye.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $587b61a739f479c7$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $euxye.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
/* eslint-disable jira/filename-case */ const $38435de89b8286ba$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $38435de89b8286ba$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $38435de89b8286ba$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $38435de89b8286ba$export$880a78695d76498e = 8;

parcelRegister("6AvEG", function(module, exports) {
$parcel$export(module.exports, "default", () => $eac7de0d6a604131$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud

var $l1vE2 = parcelRequire("l1vE2");

var $41FAq = parcelRequire("41FAq");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");
const $eac7de0d6a604131$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    if (!(0, $i860n.fg)('render-modern-issue-transition')) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isFedRampSrbFallback = (0, $i860n.fg)('aem_migration_jira') ? !(0, $41FAq.isFeatureEnabled)('jira', 'issue-transition-customisation-for-srb') : (0, $l1vE2.isFedRamp)();
    const isModernIssueTransitionSRBCohort = (0, $i860n.fg)('issue-transition-customisation-for-srb') || isFedRampSrbFallback;
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    return (0, $2700E.expValEquals)('jira_issue_transition_screen_modernisation_toggle', 'value', 'BY_DEFAULT_USER_OPT_OUT') ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $eac7de0d6a604131$export$2e2bcd8739ae039 = $eac7de0d6a604131$var$getDefaultIssueTransitionLabsOptInState;

});
parcelRegister("2700E", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $5174c3419b46017c$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $5174c3419b46017c$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $5174c3419b46017c$export$677f9fa2e1ae6fec);
/* eslint-disable jira/filename-case, max-classes-per-file, jira/naming/disallow-filenames */ 
var $4LDqh = parcelRequire("4LDqh");

var $j3gY5 = parcelRequire("j3gY5");

var $hbvZL = parcelRequire("hbvZL");

var $fEmTm = parcelRequire("fEmTm");

var $hjhet = parcelRequire("hjhet");

var $gXtG2 = parcelRequire("gXtG2");
class $5174c3419b46017c$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // 1 - checkIfExperimentExists
            // 2 - a caller
            this.stack = [
                ...stackLines.slice(2)
            ].join('\n');
        }
    }
}
$5174c3419b46017c$var$ErrorPointingUp.displayName = "ErrorPointingUp";
const $5174c3419b46017c$var$checkedExperiments = new Set();
const $5174c3419b46017c$var$checkIfExperimentExists = (experimentName)=>{
    // perform early exist to minimize performance impact
    if ($5174c3419b46017c$var$checkedExperiments.has(experimentName)) return;
    $5174c3419b46017c$var$checkedExperiments.add(experimentName);
    if ((0, $4LDqh.default).checkGate('jfp_magma_jira-report-incorrect-experiments', {
        fireGateExposure: false
    })) {
        if (!(0, $4LDqh.default).isExperimentExists(experimentName)) {
            const error = new $5174c3419b46017c$var$ErrorPointingUp(`Experiment ${experimentName} does not exist`);
            (0, $fEmTm.captureException)('FeatureGates.isExperimentExists', error);
            // eslint-disable-next-line no-console
            console.error(`Experiment ${experimentName} does not exist`);
        }
    }
};
function $5174c3419b46017c$var$readExpVal(experimentName, param, defaultValue) {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    /**
	 * On server: These overrides are set by the server-side code in jira/src/entry-fs
	 * On client: Check SSR overrides on client-side for shareable debug URLs
	 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.configs?.[experimentName]?.[param] !== undefined) {
        const value = globalVar.__SSR_STATSIG_OVERRIDES__.configs[experimentName][param];
        // Still record the access so overridden experiments remain observable (e.g. SSR smoke-test
        // bisect relies on __SSR_FEATURE_FLAGS_ACCESSED__ to see which experiments a route evaluated).
        // oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return value;
    }
    if (false) {
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allExpValTrue) {
            if (param === 'isEnabled' && typeof defaultValue === 'boolean') {
                // oxlint-disable-next-line typescript/consistent-type-assertions
                (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${param}`, true);
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return true;
            }
        }
        if (typeof globalVar.__SSR_SYNC_READ_EXP_VAL__ === 'function' && // if global variable is ready, then don't reach out to native
        // API, stay within js runtime is faster
        !globalVar._statsigValuesReady) try {
            const value = globalVar.__SSR_SYNC_READ_EXP_VAL__(experimentName, param, defaultValue);
            // oxlint-disable-next-line typescript/consistent-type-assertions
            (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
            // oxlint-disable-next-line typescript/consistent-type-assertions
            return value;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(JSON.stringify({
                // oxlint-disable-next-line typescript/consistent-type-assertions
                message: error.message,
                // oxlint-disable-next-line typescript/consistent-type-assertions
                stack: error.stack
            }));
        }
    }
    // Check if the CRITERION override mechanism is available
    if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
        const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(experimentName, param);
        if (overrideValue !== undefined && overrideValue !== null) {
            (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // oxlint-disable-next-line typescript/consistent-type-assertions
            return overrideValue;
        }
    }
    // Handle vendorless scripts use of gates
    (0, $hjhet.UNSAFE_initIfNeeded)();
    const value = (0, $4LDqh.default).getExperimentValue(experimentName, param, defaultValue);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return value;
}
function $5174c3419b46017c$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    const experiment = $5174c3419b46017c$var$readExpVal(experimentName, param, defaultValue);
    $5174c3419b46017c$var$checkIfExperimentExists(experimentName);
    return experiment;
}
function $5174c3419b46017c$export$45abdb3f977b5b14(experimentName, param, comparatorValue, defaultValue = null) {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (false) {
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allExpValTrue) {
            // `allExpValTrue` forces the comparison to behave as if the parameter equals the comparator,
            // so the effective value read for this experiment is `comparatorValue`. Record the access so
            // overridden experiments remain observable (e.g. SSR smoke-test bisect relies on
            // __SSR_FEATURE_FLAGS_ACCESSED__ to see which experiments a route evaluated).
            // oxlint-disable-next-line typescript/consistent-type-assertions
            (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${param}`, comparatorValue);
            return defaultValue !== comparatorValue;
        }
    }
    const experiment = $5174c3419b46017c$var$readExpVal(experimentName, param, defaultValue);
    $5174c3419b46017c$var$checkIfExperimentExists(experimentName);
    return experiment === comparatorValue;
}
class $5174c3419b46017c$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
            const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $hbvZL.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, overrideValue);
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $hbvZL.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return value;
    }
}
$5174c3419b46017c$var$ExperimentConfig.displayName = "ExperimentConfig";
const $5174c3419b46017c$var$cache = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $5174c3419b46017c$var$checkedExperiments.clear();
    $5174c3419b46017c$var$cache.clear();
});
function $5174c3419b46017c$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $5174c3419b46017c$var$cache.get(experimentName);
    const fireExposure = ()=>(0, $4LDqh.default).manuallyLogExperimentExposure(experimentName);
    if (instance == null) {
        if (false) {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const globalVar = typeof window !== 'undefined' ? window : globalThis;
            if (typeof globalVar.__SSR_SYNC_DYNAMIC_CONFIG_VALUE__ === 'function' && // if global variable is ready, then don't reach out to native
            // API, stay within js runtime is faster
            !globalVar._statsigValuesReady) // Handle vendorless scripts use of gates
            try {
                const config = globalVar.__SSR_SYNC_DYNAMIC_CONFIG_VALUE__(experimentName);
                if (typeof config !== 'undefined') {
                    config.get = (key)=>{
                        // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        const value = config.value[key];
                        return value;
                    };
                    instance = [
                        // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        new $5174c3419b46017c$var$ExperimentConfig(experimentName, (0, $j3gY5.DynamicConfig).fromExperiment(config)),
                        fireExposure
                    ];
                    $5174c3419b46017c$var$cache.set(experimentName, instance);
                    return instance;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(JSON.stringify({
                    // oxlint-disable-next-line typescript/consistent-type-assertions
                    message: error.message,
                    // oxlint-disable-next-line typescript/consistent-type-assertions
                    stack: error.stack
                }));
            }
        }
        (0, $hjhet.UNSAFE_initIfNeeded)();
        const config = (0, $4LDqh.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        instance = [
            new $5174c3419b46017c$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $5174c3419b46017c$var$cache.set(experimentName, instance);
    }
    return instance;
}

});



parcelRegister("fdMbz", function(module, exports) {
$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $f3deef9fd00ecd22$export$fa191d7d71460a98);

var $2HuOR = parcelRequire("2HuOR");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $f3deef9fd00ecd22$var$RESOURCE_TYPE_AUTOMATION_IS_LEGACY_ENABLED = 'AUTOMATION_IS_LEGACY_ENABLED';
const $f3deef9fd00ecd22$export$fa191d7d71460a98 = (0, $7edbf.createResource)({
    type: $f3deef9fd00ecd22$var$RESOURCE_TYPE_AUTOMATION_IS_LEGACY_ENABLED,
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $2HuOR.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $h2wCv.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity,
    isCritical: true
});

});

parcelRegister("i4Cir", function(module, exports) {
$parcel$export(module.exports, "navigationUiStateResource", () => $870b9559cf95db3f$export$14c178691841b423);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $emCaV = parcelRequire("emCaV");

var $7edbf = parcelRequire("7edbf");

var $1xJGF = parcelRequire("1xJGF");
const $870b9559cf95db3f$var$getNavigationUiStateMemoized = (0, $emCaV.default)((atlassianAccountId)=>(0, $1xJGF.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $870b9559cf95db3f$export$14c178691841b423 = (0, $7edbf.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$870b9559cf95db3f$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity,
    isCritical: true
});

});
parcelRegister("1xJGF", function(module, exports) {
$parcel$export(module.exports, "getNavigationUiState", () => $b34201b711a82cf4$export$29999268b070c9bd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $kM0go = parcelRequire("kM0go");


var $k0465 = parcelRequire("k0465");
const $b34201b711a82cf4$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $k0465.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $kM0go.getUserProperty)(accountId, (0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $k0465.updateLocalStorageData)(uiState);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
/* eslint-disable jira/filename-case */ const $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $8ae9cd5461c89f8d$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("k0465", function(module, exports) {
$parcel$export(module.exports, "queryLocalStorage", () => $80d7db7658a30aa0$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $80d7db7658a30aa0$export$ec13c725e067146a);
/* eslint-disable jira/filename-case, jira/import-whitelist, jira/naming/disallow-filenames */ 
var $fcq2N = parcelRequire("fcq2N");

var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");

var $6CfY5 = parcelRequire("6CfY5");

const $80d7db7658a30aa0$export$e7db3fa51c63bc5c = ()=>{
    // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    };
};
const $80d7db7658a30aa0$var$queryLocalStorageSync = ()=>{
    const localStorage = $80d7db7658a30aa0$export$e7db3fa51c63bc5c();
    const item = (0, $i860n.fg)('jfp-vulcan-browser-storage-migration') ? (0, $4fPPi.AtlBrowserStorageLocal).getItem((0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8)) : localStorage.getItem((0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData((0, $8ae9cd5461c89f8d$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $80d7db7658a30aa0$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $80d7db7658a30aa0$var$queryLocalStorageSync();
        resolve(item);
    });
const $80d7db7658a30aa0$export$ec13c725e067146a = (data)=>{
    const localStorage = $80d7db7658a30aa0$export$e7db3fa51c63bc5c();
    if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) // @browser-storage setter
    (0, $4fPPi.AtlBrowserStorageLocal).setStrictlyNecessaryItem((0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8), JSON.stringify(data));
    else // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    localStorage.setItem((0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});



parcelRegister("gjifS", function(module, exports) {
$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $d56cf720cf78b9c9$export$266a039a005e8314);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");


const $d56cf720cf78b9c9$export$266a039a005e8314 = (0, $7edbf.createResource)({
    type: (0, $197033e503119526$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("fQJPW")),
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
/* eslint-disable jira/filename-case */ const $197033e503119526$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $197033e503119526$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $197033e503119526$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("fQJPW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eGZYW").then(()=>parcelRequire('gM3Bu'));

});


parcelRegister("edf7u", function(module, exports) {
$parcel$export(module.exports, "projectContextResource", () => $a8df5aa948631878$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $a8df5aa948631878$export$d75816e37af81473);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");


const $a8df5aa948631878$export$27ad0d75c619be68 = (0, $7edbf.createResource)({
    type: (0, $feef523243843e2f$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>(0, $i0CFV.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getDataLoader: ()=>(parcelRequire("lmISU")),
    maxAge: 1800000,
    isCritical: true
});
const $a8df5aa948631878$export$d75816e37af81473 = $a8df5aa948631878$export$27ad0d75c619be68;

});
/* eslint-disable jira/filename-case */ const $feef523243843e2f$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("lmISU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eYRct").then(()=>parcelRequire('KPhmg'));

});


parcelRegister("8Uubk", function(module, exports) {
$parcel$export(module.exports, "fetchSiteTraitsResource", () => $a8c0f468fea1f6bc$export$379923e7c903a55d);
$parcel$export(module.exports, "useFetchSiteTraitsResource", () => $a8c0f468fea1f6bc$export$2a942e8a56081cd7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $g3pW6 = parcelRequire("g3pW6");


const $a8c0f468fea1f6bc$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const response = false ? (await (0, $h2wCv.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $g3pW6.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        if (response) return response;
        return null;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: (0, $54cbde7df2381fb0$export$7f111648ca05f056),
                packageName: (0, $13b17fb956c06fec$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $a8c0f468fea1f6bc$export$379923e7c903a55d = (0, $7edbf.createResource)({
    type: (0, $54cbde7df2381fb0$export$6f0555de4f60e84e),
    getKey: ()=>(0, $54cbde7df2381fb0$export$7e7d7930e22ba39f),
    getData: $a8c0f468fea1f6bc$var$getData,
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
function $a8c0f468fea1f6bc$export$2a942e8a56081cd7() {
    return (0, $k6ufm.useResource)($a8c0f468fea1f6bc$export$379923e7c903a55d);
}

});
parcelRegister("g3pW6", function(module, exports) {
$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $dde7ec78fa02f90d$export$671fb03be30194c3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $5pyRb = parcelRequire("5pyRb");

var $4fhEY = parcelRequire("4fhEY");
const $dde7ec78fa02f90d$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $dde7ec78fa02f90d$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $4fhEY.default)($dde7ec78fa02f90d$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $dde7ec78fa02f90d$export$671fb03be30194c3 = (0, $emCaV.default)($dde7ec78fa02f90d$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $dde7ec78fa02f90d$export$58982988039b926f = ()=>(0, $5pyRb.useService)($dde7ec78fa02f90d$export$671fb03be30194c3);

});
parcelRegister("5pyRb", function(module, exports) {
$parcel$export(module.exports, "useService", () => $a2ef56181771ca79$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $a2ef56181771ca79$export$c963713a27525aaf);

var $euxye = parcelRequire("euxye");
const $a2ef56181771ca79$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $euxye.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $euxye.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $a2ef56181771ca79$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $euxye.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $a2ef56181771ca79$export$6de4685a6c88b4e9(request, initialState);
    (0, $euxye.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


/* eslint-disable jira/filename-case */ const $13b17fb956c06fec$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

/* eslint-disable jira/filename-case */ const $54cbde7df2381fb0$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $54cbde7df2381fb0$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $54cbde7df2381fb0$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';


parcelRegister("ecGij", function(module, exports) {
$parcel$export(module.exports, "fetchSiteUserTraitsResource", () => $b881a5733320634d$export$2d7b0f7f663da130);
$parcel$export(module.exports, "useFetchSiteUserTraitsResource", () => $b881a5733320634d$export$4264f22c98fde8ba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $kTLO3 = parcelRequire("kTLO3");


const $b881a5733320634d$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId ?? '';
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? (await (0, $h2wCv.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $kTLO3.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: accountId
        });
        if (response) return response;
        return null;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: (0, $70cc2ca928ae0bf3$export$7f111648ca05f056),
                packageName: (0, $13b17fb956c06fec$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $b881a5733320634d$export$2d7b0f7f663da130 = (0, $7edbf.createResource)({
    type: (0, $70cc2ca928ae0bf3$export$6f0555de4f60e84e),
    getKey: ()=>(0, $70cc2ca928ae0bf3$export$7e7d7930e22ba39f),
    getData: $b881a5733320634d$var$getData,
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
function $b881a5733320634d$export$4264f22c98fde8ba() {
    return (0, $k6ufm.useResource)($b881a5733320634d$export$2d7b0f7f663da130);
}

});
parcelRegister("kTLO3", function(module, exports) {
$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $cb54ea9751a408c2$export$de93ec54b11be450);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $5pyRb = parcelRequire("5pyRb");

var $4fhEY = parcelRequire("4fhEY");
const $cb54ea9751a408c2$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $cb54ea9751a408c2$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $4fhEY.default)($cb54ea9751a408c2$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $cb54ea9751a408c2$export$de93ec54b11be450 = (0, $emCaV.default)($cb54ea9751a408c2$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $cb54ea9751a408c2$export$8dc79ff315095801 = ()=>(0, $5pyRb.useService)($cb54ea9751a408c2$export$de93ec54b11be450);

});

/* eslint-disable jira/filename-case */ const $70cc2ca928ae0bf3$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $70cc2ca928ae0bf3$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $70cc2ca928ae0bf3$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';


parcelRegister("2NAMr", function(module, exports) {
$parcel$export(module.exports, "jpdRecommendationDismissedResource", () => $f1a0a032bbf40d1b$export$5db7c4562b672f52);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");


const $f1a0a032bbf40d1b$export$5db7c4562b672f52 = (0, $7edbf.createResource)({
    type: (0, $5cb5bfd5d2ee8d50$export$6f0555de4f60e84e),
    getKey: ()=>(0, $5cb5bfd5d2ee8d50$export$7e7d7930e22ba39f),
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return {
                hasDismissed: true
            };
            const accountId = tenantContext.atlassianAccountId;
            const response = await (0, $h2wCv.performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
            return {
                hasDismissed: response?.value ?? false
            };
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, they have never dismissed.
					 */ return {
                hasDismissed: false
            };
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: (0, $5cb5bfd5d2ee8d50$export$7f111648ca05f056),
                    packageName: (0, $13b17fb956c06fec$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */ return {
            hasDismissed: true
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
/* eslint-disable jira/filename-case */ const $5cb5bfd5d2ee8d50$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $5cb5bfd5d2ee8d50$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $5cb5bfd5d2ee8d50$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';


parcelRegister("6bGyp", function(module, exports) {
$parcel$export(module.exports, "rovoEntitlementResource", () => $60791d78ff843db9$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $60791d78ff843db9$export$b9cee3799212b85a);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $60791d78ff843db9$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $60791d78ff843db9$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $74cc6705a5fdb0de$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldIncludeBetaAiFeatures: true,
                    shouldIncludeRovoEnablementStatus: (0, $i860n.fg)('improve_rovo_enablement_check_through_new_apis')
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        const isRovoLLMEnabled = response.data?.jira_isRovoLLMEnabled ?? null;
        const isBetaAiFeaturesEnabled = response.data?.jira_isBetaAiFeaturesEnabled ?? null;
        const rovoEnablementStatus = response.data?.jira_rovoEnablementStatus ?? null;
        return {
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled,
            isBetaAiFeaturesEnabled: isBetaAiFeaturesEnabled,
            rovoEnablementStatus: rovoEnablementStatus
        };
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error instanceof Error ? error : new Error(String(error)),
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined,
        isBetaAiFeaturesEnabled: undefined,
        rovoEnablementStatus: null
    };
};
const $60791d78ff843db9$export$a0974cf24d16bc5d = (0, $7edbf.createResource)({
    type: $60791d78ff843db9$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$60791d78ff843db9$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$60791d78ff843db9$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity,
    isCritical: true
});
const $60791d78ff843db9$export$b9cee3799212b85a = ()=>(0, $k6ufm.useResource)($60791d78ff843db9$export$a0974cf24d16bc5d);

});
/* eslint-disable jira/filename-case */ const $74cc6705a5fdb0de$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldIncludeBetaAiFeatures: Boolean!, $shouldIncludeRovoEnablementStatus: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	jira_isBetaAiFeaturesEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldIncludeBetaAiFeatures)
	jira_rovoEnablementStatus(cloudId: $cloudId)@optIn(to: "JiraRovoEnablementStatus") @include(if: $shouldIncludeRovoEnablementStatus) {
		isRovoEntitlementEnabledForTenant
		isRovoAiFeaturesEnabledInAnyJiraProducts {
			isEnabled
			disabledReason
		}
		rovoAiFeaturesEnabledJiraProducts
	}
}
`;


parcelRegister("kmdD8", function(module, exports) {
$parcel$export(module.exports, "userHomepageResource", () => $f61e9d6e1a88b6b8$export$16320dd0d1e6c145);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $f61e9d6e1a88b6b8$var$RESOURCE_TYPE_USER_HOMEPAGE = 'USER_HOMEPAGE';
const $f61e9d6e1a88b6b8$export$16320dd0d1e6c145 = (0, $7edbf.createResource)({
    type: $f61e9d6e1a88b6b8$var$RESOURCE_TYPE_USER_HOMEPAGE,
    getKey: ()=>'state',
    getData: async (_dataContext, _storeContext)=>{
        const { homepagePreference: homepagePreference } = await (0, $h2wCv.performGetRequest)('/rest/internal/3/homepage/');
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity,
    isCritical: true
});

});

parcelRegister("8HUuJ", function(module, exports) {
$parcel$export(module.exports, "safeCloneResource", () => $bcffcdc520e6a229$export$fbf6681b373be4c4);
$parcel$export(module.exports, "resourceWithCondition", () => $bcffcdc520e6a229$export$cac04afc5a06c544);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $bcffcdc520e6a229$export$5284559c6d2f1a7b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $bcffcdc520e6a229$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // oxlint-disable-next-line typescript/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $bcffcdc520e6a229$export$cac04afc5a06c544 = (conditionGetter, itemTrue, itemFalse = $bcffcdc520e6a229$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $bcffcdc520e6a229$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});

parcelRegister("35eqr", function(module, exports) {
$parcel$export(module.exports, "postOfficeJiraSideNavResource", () => $6b7332bba9d080f0$export$5fd5ab86e70497f7);
$parcel$export(module.exports, "postOfficeJiraYourWorkResource", () => $6b7332bba9d080f0$export$5969dfe9b3b29cd3);
$parcel$export(module.exports, "postOfficeJiraTopBannerResource", () => $6b7332bba9d080f0$export$af242b8c8ffaab42);
$parcel$export(module.exports, "conditionalPostOfficeJiraTopBannerResource", () => $6b7332bba9d080f0$export$d1df0b3b482d298d);
$parcel$export(module.exports, "postOfficeNav4ProjectsSectionResource", () => $6b7332bba9d080f0$export$3f8e412b85cb402b);
$parcel$export(module.exports, "postOfficeAssetsMenuItemFreeUsersPlacementResource", () => $6b7332bba9d080f0$export$b3f8f7e30d409756);
$parcel$export(module.exports, "postOfficeAssetsSideNavUpsellDashboardsPlacementResource", () => $6b7332bba9d080f0$export$c3cdc6310ca9e561);
$parcel$export(module.exports, "postOfficeAssetsSideNavUpsellDataManagerPlacementResource", () => $6b7332bba9d080f0$export$60d00956f847a);
/* eslint-disable jira/import-whitelist */ 
var $8HUuJ = parcelRequire("8HUuJ");

var $cr9yX = parcelRequire("cr9yX");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");
const $6b7332bba9d080f0$export$fd097948b42db8d3 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__SCREEN_SPACE_FLAGS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('screen-space-flags', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$export$5fd5ab86e70497f7 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_SIDE_NAV',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-side-nav', tenantContext);
    },
    maxAge: Infinity,
    isCritical: true
});
const $6b7332bba9d080f0$export$5969dfe9b3b29cd3 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_YOUR_WORK',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-your-work', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$export$af242b8c8ffaab42 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_TOP_BANNER',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isSiteAdmin) return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-top-banner', tenantContext);
        return null;
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$export$d1df0b3b482d298d = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jira-issue-term-refresh-banner'), $6b7332bba9d080f0$export$af242b8c8ffaab42);
const $6b7332bba9d080f0$export$1d4ef0f14729d528 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_SECTION',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('nav-4-section', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$var$nav4ProjectsSectionEnabledGroup = new Set([
    'classic-business',
    'classic-software',
    'home',
    'issue',
    'issue-navigator',
    'legacy',
    'polaris',
    'servicedesk',
    'software',
    'software-reports-boardless'
]);
const $6b7332bba9d080f0$export$3f8e412b85cb402b = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_PROJECTS_SECTION',
    getKey: ()=>'state',
    getData: async ({ route: { group: group } }, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        if (!group || !$6b7332bba9d080f0$var$nav4ProjectsSectionEnabledGroup.has(group)) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('nav-4-projects-section', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$var$FREE_EDITION = 'FREE_EDITION';
const $6b7332bba9d080f0$export$b3f8f7e30d409756 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__ASSETS_MENU_ITEM_FREE_USERS_PLACEMENT',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { appEditions: appEditions, isSiteAdmin: isSiteAdmin } = tenantContext;
        if (!isSiteAdmin || appEditions?.serviceDesk !== $6b7332bba9d080f0$var$FREE_EDITION) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-navbar-assets-app-section', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$var$STANDARD_EDITION = 'STANDARD_EDITION';
const $6b7332bba9d080f0$export$c3cdc6310ca9e561 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__ASSETS_SIDE_NAV_UPSELL_DASHBOARDS_PLACEMENT',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = tenantContext;
        if (!isSiteAdmin || appEditions?.serviceDesk !== $6b7332bba9d080f0$var$STANDARD_EDITION) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jsm-assets-app-navbar-dashboards-section', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$export$60d00956f847a = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__ASSETS_SIDE_NAV_UPSELL_DATA_MANAGER_PLACEMENT',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = tenantContext;
        if (!isSiteAdmin || appEditions?.serviceDesk !== 'STANDARD_EDITION') return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jsm-assets-app-navbar-data-manager-section', tenantContext);
    },
    maxAge: Infinity
});

});
parcelRegister("cr9yX", function(module, exports) {
$parcel$export(module.exports, "usePlacementSSRFetch", () => $0ec44b4e01b4dba6$export$420f2f91a928b3b6);
$parcel$export(module.exports, "usePlacementPreloadedData", () => $0ec44b4e01b4dba6$export$17b92961ead3f211);
$parcel$export(module.exports, "preloadPostOfficePlacementWithTenantContext", () => $0ec44b4e01b4dba6$export$65b5eab182e1ca6f);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dJ3NQ = parcelRequire("dJ3NQ");

var $hIRki = parcelRequire("hIRki");

var $h2wCv = parcelRequire("h2wCv");

var $2yTew = parcelRequire("2yTew");

var $3MAu1 = parcelRequire("3MAu1");

var $k6ufm = parcelRequire("k6ufm");

var $i860n = parcelRequire("i860n");

var $aYGh8 = parcelRequire("aYGh8");
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $0ec44b4e01b4dba6$var$preloadPostOfficePlacement = async (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const jiraFetcherWithS2SHeaders = async (url)=>{
        let hostEnv = 'prod';
        if (environment.currentEnv !== 'production') hostEnv = 'staging';
        const fetchHeaders = {
            'x-ssr-service-name': 'post-office',
            'x-ssr-service-env': hostEnv
        };
        return (0, $h2wCv.performGetRequest)(url.replace('gateway/api/post-office/', ''), {
            headers: fetchHeaders
        });
    };
    return (0, $3MAu1.requestInitialData)(placementId, postOfficeContext, false && !(0, $dJ3NQ.default)() ? jiraFetcherWithS2SHeaders : (0, $h2wCv.performGetRequest), (0, $2yTew.buildBasePath)(environment.currentEnv, environment.envConfigs));
};
const $0ec44b4e01b4dba6$export$420f2f91a928b3b6 = (resource)=>{
    const { data: data } = (0, $k6ufm.useResource)(resource);
    return (0, $euxye.useCallback)(()=>{
        if (data) {
            /**
			 * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
			 * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
			 */ const init = {
                status: 200,
                statusText: 'ok!'
            };
            return Promise.resolve(new Response(JSON.stringify(data), init));
        }
    }, [
        data
    ]);
};
const $0ec44b4e01b4dba6$export$17b92961ead3f211 = (resource)=>{
    const { data: data, clear: clear } = (0, $k6ufm.useResource)(resource);
    return [
        data,
        clear
    ];
};
const $0ec44b4e01b4dba6$export$65b5eab182e1ca6f = async (placementId, preloadedTenantContext)=>{
    if ((0, $i860n.fg)('jpx-870-stable-ui-for-criterion')) {
        if ((0, $hIRki.isStableUIEnabledForTests)()) return Promise.resolve(null);
    }
    return $0ec44b4e01b4dba6$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $aYGh8.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $aYGh8.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});
parcelRegister("2yTew", function(module, exports) {
$parcel$export(module.exports, "buildBasePath", () => $4bd74d1d620d3a33$export$e8b30f9c4a80230f);


var $fgdQf = parcelRequire("fgdQf");
const $4bd74d1d620d3a33$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $fgdQf.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $da770e4947af19bb$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
const $da770e4947af19bb$export$5ca004be156a127a = 'http://localhost:4224';
const $da770e4947af19bb$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $da770e4947af19bb$export$1e9fed4c0197724c = 'http://localhost:8081';
const $da770e4947af19bb$export$919a9569bce66f17 = '/api/v1/placements/';
const $da770e4947af19bb$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $da770e4947af19bb$export$67be2569ef5d7666 = 'http://localhost:9009';
const $da770e4947af19bb$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $da770e4947af19bb$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
const $da770e4947af19bb$export$a2ac4fea250cfcb6 = 'https://post-office-rml-frontend.stg.frontend.cdn.atlassian-us-gov-mod.com';
const $da770e4947af19bb$export$4db578e7ea13bd1b = 'https://post-office-rml-frontend.frontend.cdn.atlassian-us-gov-mod.com';

parcelRegister("fgdQf", function(module, exports) {
$parcel$export(module.exports, "buildDefaultEnvironmentValues", () => $2e77d01e0cd0ee89$export$5dba87a2097d7fb2);
$parcel$export(module.exports, "defaultEnvironmentValues", () => $2e77d01e0cd0ee89$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $2e77d01e0cd0ee89$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $2e77d01e0cd0ee89$export$877b97169cc75e8b);

var $euxye = parcelRequire("euxye");

const $2e77d01e0cd0ee89$export$5dba87a2097d7fb2 = (isFedRampCompliantUrlsEnabled = false)=>{
    return {
        currentEnv: 'local',
        envConfigs: {
            'test-server': {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $da770e4947af19bb$export$5ca004be156a127a),
                    pathname: (0, $da770e4947af19bb$export$5ca004be156a127a),
                    searchParams: undefined
                }
            },
            test: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $da770e4947af19bb$export$1e9fed4c0197724c),
                    pathname: (0, $da770e4947af19bb$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $da770e4947af19bb$export$1e9fed4c0197724c),
                    pathname: (0, $da770e4947af19bb$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $da770e4947af19bb$export$1e9fed4c0197724c),
                    pathname: (0, $da770e4947af19bb$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $da770e4947af19bb$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $da770e4947af19bb$export$a2ac4fea250cfcb6) : (0, $da770e4947af19bb$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $da770e4947af19bb$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $da770e4947af19bb$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $da770e4947af19bb$export$4db578e7ea13bd1b) : (0, $da770e4947af19bb$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $da770e4947af19bb$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            }
        }
    };
};
const $2e77d01e0cd0ee89$export$b4ede87479bfcf09 = $2e77d01e0cd0ee89$export$5dba87a2097d7fb2();
const $2e77d01e0cd0ee89$export$fceca2c399b32565 = (0, $euxye.createContext)($2e77d01e0cd0ee89$export$b4ede87479bfcf09);
const $2e77d01e0cd0ee89$export$604607f913ef367c = $2e77d01e0cd0ee89$export$fceca2c399b32565.Provider;
const $2e77d01e0cd0ee89$export$877b97169cc75e8b = ()=>(0, $euxye.useContext)($2e77d01e0cd0ee89$export$fceca2c399b32565);

});


parcelRegister("3MAu1", function(module, exports) {
$parcel$export(module.exports, "requestInitialData", () => $7289bb8c05aa9759$export$c4c39037cc4b06ab);
const $7289bb8c05aa9759$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $7289bb8c05aa9759$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $7289bb8c05aa9759$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("aYGh8", function(module, exports) {
$parcel$export(module.exports, "tenantToPostOfficeContext", () => $657335a6a5ada935$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $657335a6a5ada935$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $657335a6a5ada935$export$cfacfecb20987ff1);
$parcel$export(module.exports, "useSubproduct", () => $657335a6a5ada935$export$9554712c4f0a714e);
/* eslint-disable jira/filename-case */ 
var $hIRki = parcelRequire("hIRki");

var $fDVI0 = parcelRequire("fDVI0");

var $i860n = parcelRequire("i860n");

var $f2wVS = parcelRequire("f2wVS");

var $7EMaG = parcelRequire("7EMaG");

var $2700E = parcelRequire("2700E");
const $657335a6a5ada935$var$JIRA_PRODUCT = 'jira';
const $657335a6a5ada935$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $657335a6a5ada935$var$JIRA_PRODUCT,
    locale: 'en'
};
const $657335a6a5ada935$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $fDVI0.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $657335a6a5ada935$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale, isAdmin: isAdmin } = tenantData;
    const workspaceAri = $657335a6a5ada935$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$657335a6a5ada935$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        isAdmin: isAdmin,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined,
        disableAllPlacements: (0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') ? true : undefined
    };
};
const $657335a6a5ada935$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'service_desk':
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $657335a6a5ada935$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};
const $657335a6a5ada935$export$9554712c4f0a714e = (projectType)=>{
    const isOpsRoute = (0, $f2wVS.useIsActiveRoute)((0, $7EMaG.operationsConverter).routes);
    const [jsmgrowth466Star] = (0, $2700E.UNSAFE_noExposureExp)('jsmgrowth466_star');
    return projectType ?? (isOpsRoute && jsmgrowth466Star.get('cohort', 'not-enrolled') === 'variation' ? 'service_desk' : undefined);
};

});
parcelRegister("7EMaG", function(module, exports) {
$parcel$export(module.exports, "operationsConverter", () => $70dac5b32a6b6f77$export$7fc92455d5020e1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");

var $5IkoH = parcelRequire("5IkoH");
const $70dac5b32a6b6f77$var$routes = new Set([
    'eoc-automations',
    'eoc-custom-roles',
    'eoc-global-alerts',
    'eoc-global-alerts-redirect',
    'eoc-global-alert-detail',
    'eoc-global-group-detail',
    'eoc-global-reports',
    'eoc-global-reports-new',
    'eoc-global-report-dashboard',
    'eoc-group-policy',
    'eoc-heartbeats',
    'eoc-global-heartbeats',
    'eoc-maintenance',
    'eoc-on-call',
    'eoc-on-call-redirect',
    'eoc-overview',
    'eoc-overview-all-teams',
    'eoc-permissions',
    'eoc-reports',
    'eoc-reports-team',
    'eoc-reports-unsubscribe',
    'eoc-schedules',
    'eoc-team-alerts',
    'eoc-team-alert-detail',
    'eoc-team-alert-issue-syncing',
    'eoc-team-alert-issue-syncing-create',
    'eoc-team-alert-issue-syncing-detail',
    'eoc-team-group-detail',
    'eoc-team-integrations',
    'eoc-team-integration-create',
    'eoc-team-integration-detail',
    'eoc-team-integration-list',
    'eoc-team-integration-log',
    'eoc-team-policies',
    'eoc-who-is-on-call',
    'eoc-global-escalations',
    'communications-status-page',
    'communications-status-page-configuration',
    'communications-status-page-create',
    'communications-status-page-details',
    'communications-status-page-preview',
    'communications-stakeholder-groups',
    'communications-stakeholders',
    'eoc-merge-teams',
    'servicedesk-service-list',
    'eoc-changes',
    'eoc-incidents'
]);
function $70dac5b32a6b6f77$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_OPERATIONS)
    ];
    return $70dac5b32a6b6f77$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $70dac5b32a6b6f77$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_OPERATIONS)
    ];
    return $70dac5b32a6b6f77$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $70dac5b32a6b6f77$var$convertRouteToPath(args) {
    const { routeName: routeName, query: query, path: path } = args;
    switch(routeName){
        case 'eoc-who-is-on-call':
            path.push((0, $5IkoH.MENU_ID_OPS_ON_CALL));
            break;
        case 'eoc-changes':
            path.push((0, $5IkoH.MENU_ID_OPS_CHANGES));
            break;
        case 'eoc-incidents':
            path.push((0, $5IkoH.MENU_ID_OPS_INCIDENTS));
            break;
        case 'eoc-global-alerts':
        case 'eoc-global-alerts-redirect':
        case 'eoc-global-alert-detail':
            {
                path.push((0, $5IkoH.MENU_ID_OPS_ALERTS));
                const { query: alarmQueue = '', view: view, filter: savedSearchId } = query;
                view && path.push((0, $5IkoH.ENTITY_ID).ALARM_QUEUE(savedSearchId || alarmQueue));
                break;
            }
        case 'eoc-global-reports':
        case 'eoc-global-report-dashboard':
        case 'eoc-reports-unsubscribe':
            path.push((0, $5IkoH.MENU_ID_OPS_REPORTS));
            break;
        case 'eoc-global-reports-new':
            if ((0, $i860n.fg)('platform_avp_jira_ops_reporting')) path.push((0, $5IkoH.MENU_ID_OPS_REPORTS_NEW));
            break;
        case 'communications-status-page':
        case 'communications-status-page-configuration':
        case 'communications-status-page-create':
        case 'communications-status-page-details':
            path.push((0, $5IkoH.MENU_ID_OPS_STATUS_PAGES));
            break;
        case 'eoc-automations':
        case 'eoc-global-group-detail':
        case 'eoc-group-policy':
        case 'eoc-heartbeats':
        case 'eoc-maintenance':
        case 'eoc-permissions':
        case 'eoc-on-call':
        case 'eoc-on-call-redirect':
        case 'eoc-overview':
        case 'eoc-overview-all-teams':
        case 'eoc-reports':
        case 'eoc-reports-team':
        case 'eoc-schedules':
        case 'eoc-team-group-detail':
        case 'eoc-team-alerts':
        case 'eoc-team-alert-detail':
        case 'eoc-team-policies':
        case 'eoc-team-alert-issue-syncing':
        case 'eoc-team-alert-issue-syncing-create':
        case 'eoc-team-alert-issue-syncing-detail':
        case 'eoc-team-integrations':
        case 'eoc-team-integration-create':
        case 'eoc-team-integration-detail':
        case 'eoc-team-integration-list':
        case 'eoc-team-integration-log':
            path.push((0, $5IkoH.MENU_ID_OPS_OVERVIEW));
            break;
        case 'communications-stakeholder-groups':
            path.push((0, $5IkoH.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        case 'communications-stakeholders':
            path.push((0, $5IkoH.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        case 'servicedesk-service-list':
            path.push((0, $5IkoH.MENU_ID_OPS_SERVICES));
            break;
        default:
            break;
    }
    return path;
}
const $70dac5b32a6b6f77$export$7fc92455d5020e1 = {
    routes: $70dac5b32a6b6f77$var$routes,
    convert: $70dac5b32a6b6f77$var$convert,
    convertNew: $70dac5b32a6b6f77$var$convertNew
};

});
parcelRegister("5IkoH", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $1115372cb5af13eb$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID_TO_APS_KEY", () => $1115372cb5af13eb$export$3b4ca8d4d769a311);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $1115372cb5af13eb$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $1115372cb5af13eb$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $1115372cb5af13eb$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $1115372cb5af13eb$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $1115372cb5af13eb$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $1115372cb5af13eb$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_FOR_YOU", () => $1115372cb5af13eb$export$5115ccb493164b9);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $1115372cb5af13eb$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $1115372cb5af13eb$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $1115372cb5af13eb$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $1115372cb5af13eb$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $1115372cb5af13eb$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $1115372cb5af13eb$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $1115372cb5af13eb$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $1115372cb5af13eb$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $1115372cb5af13eb$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $1115372cb5af13eb$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $1115372cb5af13eb$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $1115372cb5af13eb$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $1115372cb5af13eb$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $1115372cb5af13eb$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS_NEW", () => $1115372cb5af13eb$export$49ea157903a0ab1);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $1115372cb5af13eb$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OPS_SERVICES", () => $1115372cb5af13eb$export$846b10f022fceb32);
$parcel$export(module.exports, "MENU_ID_OPS_CHANGES", () => $1115372cb5af13eb$export$775e96337e8fc123);
$parcel$export(module.exports, "MENU_ID_OPS_INCIDENTS", () => $1115372cb5af13eb$export$cd895f354efca243);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $1115372cb5af13eb$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $1115372cb5af13eb$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $1115372cb5af13eb$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $1115372cb5af13eb$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $1115372cb5af13eb$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $1115372cb5af13eb$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $1115372cb5af13eb$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $1115372cb5af13eb$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $1115372cb5af13eb$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $1115372cb5af13eb$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $1115372cb5af13eb$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $1115372cb5af13eb$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $1115372cb5af13eb$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL", () => $1115372cb5af13eb$export$6350780de45cdb54);
$parcel$export(module.exports, "MENU_ID_CUSTOMERS", () => $1115372cb5af13eb$export$7ded421b1395251e);
$parcel$export(module.exports, "MENU_ID_ITAM", () => $1115372cb5af13eb$export$bd6aaea9c871e469);
$parcel$export(module.exports, "MENU_ID_FOR_YOU", () => $1115372cb5af13eb$export$c68b73f0d8c14f41);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $1115372cb5af13eb$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $1115372cb5af13eb$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_COMMUNICATIONS_STAKEHOLDERS", () => $1115372cb5af13eb$export$784c436fb3f51c19);
$parcel$export(module.exports, "MENU_ID_OPS_STATUS_PAGES", () => $1115372cb5af13eb$export$151c003f483b38);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_CONFLUENCE", () => $1115372cb5af13eb$export$c093b87743053085);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_LOOM", () => $1115372cb5af13eb$export$e316a54b33dbe500);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_PROJECTS", () => $1115372cb5af13eb$export$8ceb414d866f12fc);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_TEAMS", () => $1115372cb5af13eb$export$804187987544d0f8);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_OPSGENIE", () => $1115372cb5af13eb$export$83352ab9064f1723);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $1115372cb5af13eb$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $1115372cb5af13eb$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_QUEUES", () => $1115372cb5af13eb$export$761304893631082c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $1115372cb5af13eb$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $1115372cb5af13eb$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $1115372cb5af13eb$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $1115372cb5af13eb$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $1115372cb5af13eb$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $1115372cb5af13eb$export$100a1a639a0db980);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_WORKFORCE_OPTIMIZATION", () => $1115372cb5af13eb$export$5325154bd81736de);
/* eslint-disable jira/filename-case */ const $1115372cb5af13eb$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets',
    // Global App Shortcuts for Platform Component
    GLOBAL_APP_CONFLUENCE: 'jira.sidebar.globalApp.confluence',
    GLOBAL_APP_LOOM: 'jira.sidebar.globalApp.loom',
    GLOBAL_APP_PROJECTS: 'jira.sidebar.globalApp.projects',
    GLOBAL_APP_TEAMS: 'jira.sidebar.globalApp.teams',
    GLOBAL_APP_OPSGENIE: 'jira.sidebar.globalApp.opsgenie'
};
const $1115372cb5af13eb$export$3b4ca8d4d769a311 = {
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_CONFLUENCE]: 'CONFLUENCE',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_LOOM]: 'LOOM',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_GOALS]: 'GOALS',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_PROJECTS]: 'PROJECTS',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_TEAMS]: 'TEAMS',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_OPSGENIE]: 'OPSGENIE'
};
const $1115372cb5af13eb$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    CUSTOMERS: 'jira.sidebar.customers',
    ITAM: 'jira.sidebar.itam',
    ...$1115372cb5af13eb$export$1bb3d16bc95080e3
};
const $1115372cb5af13eb$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_WORKFORCE_OPTIMIZATION: (projectKey)=>`proj-${projectKey}-workforce-optimization`,
    PROJECT_WORKFORCE_OPTIMIZATION_SCHEDULES: (projectKey)=>`proj-${projectKey}-wfo-schedules`,
    PROJECT_WORKFORCE_OPTIMIZATION_CAPACITY: (projectKey)=>`proj-${projectKey}-wfo-capacity`,
    PROJECT_WORKFORCE_OPTIMIZATION_AVAILABILITY: (projectKey)=>`proj-${projectKey}-wfo-availability`,
    PROJECT_WORKFORCE_OPTIMIZATION_SKILLS: (projectKey)=>`proj-${projectKey}-wfo-skills`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_JCS_GET_STARTED: (projectKey)=>`proj-${projectKey}-jcs-gtst`,
    PROJECT_AGENT_CONTEXT: (projectKey)=>`proj-${projectKey}-agent-context`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_CHANNELS: (projectKey)=>`proj-${projectKey}-channels`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_DASHBOARDS: (projectKey)=>`proj-${projectKey}-dashboards`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_PROACTIVE_SUPPORT: (projectKey)=>`proj-${projectKey}-proactive-support`,
    SURVEYS: (projectKey)=>`proj-${projectKey}-surveys`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    PROJECT_LIVE_CHAT: (projectKey)=>`proj-${projectKey}-live-chat`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    SUBSPACE: (id)=>`subspace_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    ARCHIVED_WORK_ITEMS: (id)=>`archived_work_items_${id}`,
    PROJECT_ROVO_AGENT: (projectKey)=>`proj-${projectKey}-rovo-agent`,
    PROJECT_JOURNEYS: (projectKey)=>`proj-${projectKey}-journeys`,
    PROJECT_LIVE_CONVERSATIONS: (projectKey)=>`proj-${projectKey}-live-conversations`,
    CUSTOMER_EXPERIENCE: (projectKey)=>`customer-experiences-${projectKey}`,
    CUSTOMER_EXPERIENCES_CHANNELS: (projectKey)=>`customer-experiences-channels-${projectKey}`,
    CUSTOMER_EXPERIENCE_MENU_ITEM: (helpCenterId, itemName)=>`customer-experiences-${helpCenterId}-${itemName}`,
    CHANGE: (id)=>`chng_${id}`,
    INCIDENT: (id)=>`incd_${id}`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $1115372cb5af13eb$export$441cd608ea3204f4 = $1115372cb5af13eb$export$7838b734e4cd5e8d.APPS;
const $1115372cb5af13eb$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $1115372cb5af13eb$export$75c65bfc98b3a6e1 = $1115372cb5af13eb$export$7838b734e4cd5e8d.ASSETS;
const $1115372cb5af13eb$export$8a0af92d49f1d13d = 'asst_schm';
const $1115372cb5af13eb$export$5115ccb493164b9 = 'asst_for_you';
const $1115372cb5af13eb$export$a09300d15acc958a = 'asst_rprt';
const $1115372cb5af13eb$export$4d718fbd418eef5c = 'board-view-all';
const $1115372cb5af13eb$export$dd009509c2dabb5e = $1115372cb5af13eb$export$7838b734e4cd5e8d.DASHBOARDS;
const $1115372cb5af13eb$export$d3da0455b4200fb2 = 'dash-view';
const $1115372cb5af13eb$export$b9dd2b5309d19763 = 'dash-view-starred';
const $1115372cb5af13eb$export$3d81af172a8e3c57 = $1115372cb5af13eb$export$7838b734e4cd5e8d.FILTERS;
const $1115372cb5af13eb$export$1e2599eaf0039a97 = 'filt-search';
const $1115372cb5af13eb$export$53d274d993c9d5b5 = 'filt-view-all';
const $1115372cb5af13eb$export$7661ea763be69cfa = 'filt-view-starred';
const $1115372cb5af13eb$export$47c6ce6a83a59eab = $1115372cb5af13eb$export$7838b734e4cd5e8d.GOALS;
const $1115372cb5af13eb$export$ef89639b7d9c162a = $1115372cb5af13eb$export$7838b734e4cd5e8d.OPERATIONS;
const $1115372cb5af13eb$export$af4ab6d4e920522a = 'ops-alrt';
const $1115372cb5af13eb$export$25c40acb2c53a294 = 'ops-over';
const $1115372cb5af13eb$export$c7d8892f1628b844 = 'ops-rprt';
const $1115372cb5af13eb$export$49ea157903a0ab1 = 'ops-rprt-new';
const $1115372cb5af13eb$export$bb19a52e3df99541 = 'ops-oncl';
const $1115372cb5af13eb$export$846b10f022fceb32 = 'ops-srvc';
const $1115372cb5af13eb$export$775e96337e8fc123 = 'ops-chng';
const $1115372cb5af13eb$export$cd895f354efca243 = 'ops-incd';
const $1115372cb5af13eb$export$f2533da33c749933 = $1115372cb5af13eb$export$7838b734e4cd5e8d.PLANS;
const $1115372cb5af13eb$export$8468c5b6648f4f1f = 'plan-view-all';
const $1115372cb5af13eb$export$fed17b4c0866b97d = 'proj-app';
const $1115372cb5af13eb$export$9c5278bd360a285 = $1115372cb5af13eb$export$7838b734e4cd5e8d.PROJECTS;
const $1115372cb5af13eb$export$85389c606bb641dd = 'proj-view-all';
const $1115372cb5af13eb$export$4a1974b63c858e9c = 'proj-view-starred';
const $1115372cb5af13eb$export$692b796030a796f3 = $1115372cb5af13eb$export$7838b734e4cd5e8d.RECENT;
const $1115372cb5af13eb$export$cdc80d4b5ce0c6a = $1115372cb5af13eb$export$7838b734e4cd5e8d.ROADMAPS;
const $1115372cb5af13eb$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $1115372cb5af13eb$export$5637ca42a4d77f32 = $1115372cb5af13eb$export$7838b734e4cd5e8d.STARRED;
const $1115372cb5af13eb$export$d4f6fcf571f9c50 = $1115372cb5af13eb$export$7838b734e4cd5e8d.TEAMS;
const $1115372cb5af13eb$export$11fcdf33179ef88e = $1115372cb5af13eb$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $1115372cb5af13eb$export$1d260f51eeaab73d = $1115372cb5af13eb$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $1115372cb5af13eb$export$6350780de45cdb54 = 'customer-experiences-view-all';
const $1115372cb5af13eb$export$7ded421b1395251e = $1115372cb5af13eb$export$7838b734e4cd5e8d.CUSTOMERS;
const $1115372cb5af13eb$export$bd6aaea9c871e469 = $1115372cb5af13eb$export$7838b734e4cd5e8d.ITAM;
const $1115372cb5af13eb$export$c68b73f0d8c14f41 = 'for-you';
const $1115372cb5af13eb$export$5aa3e4dd37f372d5 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $1115372cb5af13eb$export$7986b535c183c592 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $1115372cb5af13eb$export$b3b2df3daae04417 = 'comm';
const $1115372cb5af13eb$export$784c436fb3f51c19 = 'comm-stkhldr';
const $1115372cb5af13eb$export$205988f610130417 = 'comm-stkhldr-grp';
const $1115372cb5af13eb$export$151c003f483b38 = 'ops-status-pages';
const $1115372cb5af13eb$export$c093b87743053085 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_CONFLUENCE;
const $1115372cb5af13eb$export$e316a54b33dbe500 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_LOOM;
const $1115372cb5af13eb$export$8ceb414d866f12fc = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_PROJECTS;
const $1115372cb5af13eb$export$804187987544d0f8 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_TEAMS;
const $1115372cb5af13eb$export$83352ab9064f1723 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_OPSGENIE;
const $1115372cb5af13eb$export$79c15668ed799a1b = 'sd-sett-acc';
const $1115372cb5af13eb$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $1115372cb5af13eb$export$761304893631082c = 'sd-sett-queues';
const $1115372cb5af13eb$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $1115372cb5af13eb$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $1115372cb5af13eb$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $1115372cb5af13eb$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $1115372cb5af13eb$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $1115372cb5af13eb$export$100a1a639a0db980 = 'sd-sett-ops';
const $1115372cb5af13eb$export$5325154bd81736de = 'sd-sett-wfo';

});





parcelRegister("fjAPO", function(module, exports) {
$parcel$export(module.exports, "previewPanelStateResource", () => $e3b0fba53e715ea5$export$c2ef0c3db4ecdea3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $htsFl = parcelRequire("htsFl");

var $3rR8c = parcelRequire("3rR8c");
const $e3b0fba53e715ea5$export$c2ef0c3db4ecdea3 = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_PREVIEW_PANEL`,
    // oxlint-disable-next-line no-explicit-any
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $3rR8c.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true,
    isBrowserOnly: false
});

});
parcelRegister("3rR8c", function(module, exports) {
$parcel$export(module.exports, "default", () => $5aed9609d88e567f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13a67e098546aefb12c81c3e0e532bef>>
 * @relayHash b395f613968319e8a511c65e3f1ee5fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2
const $5aed9609d88e567f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "concreteType": "JiraPreviewPanelState",
        "kind": "LinkedField",
        "name": "previewPanel",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2",
            "metadata": {},
            "name": "PreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5aed9609d88e567f$var$node.hash = "7327e4b44435e860a8ce1fbd4e39a463";
var $5aed9609d88e567f$export$2e2bcd8739ae039 = $5aed9609d88e567f$var$node;

});


parcelRegister("4B518", function(module, exports) {
$parcel$export(module.exports, "jiraSpaResources", () => $6e55983249e4938b$export$f242b830889fd508);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8HUuJ = parcelRequire("8HUuJ");

var $7Zyu5 = parcelRequire("7Zyu5");

var $i860n = parcelRequire("i860n");

var $9Q50z = parcelRequire("9Q50z");
const $6e55983249e4938b$export$f242b830889fd508 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jpx-463-spa-relay-query'), (0, $9Q50z.jiraSpaPageContainerResource)),
        (0, $7Zyu5.themePreferenceResource)
    ];

});
parcelRegister("7Zyu5", function(module, exports) {
$parcel$export(module.exports, "themePreferenceResource", () => $5198e2436cb830c2$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $5198e2436cb830c2$export$3416635c8aeb5bab);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $8I8y6 = parcelRequire("8I8y6");

var $CXcYw = parcelRequire("CXcYw");

var $1M80L = parcelRequire("1M80L");

const $5198e2436cb830c2$export$e5a423d1eb1cf1d0 = (0, $7edbf.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("ilTfh")),
    maxAge: 300000,
    isCritical: true
});
// TODO (DST): Should be deleted along with shared-user-preferences cleanup
/**
 * Original implementation of useThemePreference (pre shared-user-preferences feature)
 */ const $5198e2436cb830c2$var$useThemePreferenceOld = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $k6ufm.useResource)($5198e2436cb830c2$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $euxye.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $8I8y6.THEME_PREFERENCES_ANALYTICS_ACTION),
            actionSubject: (0, $8I8y6.THEME_PREFERENCES_ANALYTICS_SUBJECT)
        });
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $euxye.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $CXcYw.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};
const $5198e2436cb830c2$var$useThemePreferenceCombined = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $i860n.fg)('shared-user-preferences'), ()=>(0, $1M80L.useThemePreference)($5198e2436cb830c2$export$e5a423d1eb1cf1d0), $5198e2436cb830c2$var$useThemePreferenceOld);
const $5198e2436cb830c2$export$3416635c8aeb5bab = ()=>{
    return $5198e2436cb830c2$var$useThemePreferenceCombined();
};

});
parcelRegister("8I8y6", function(module, exports) {
$parcel$export(module.exports, "THEME_PREFERENCE_KEY", () => $022db685d19a6057$export$40bd77e1c9f49c27);
$parcel$export(module.exports, "THEME_PREFERENCES_ANALYTICS_SUBJECT", () => $022db685d19a6057$export$9e2cc65718a61846);
$parcel$export(module.exports, "THEME_PREFERENCES_ANALYTICS_ACTION", () => $022db685d19a6057$export$89c5cf64ad15c3ea);
$parcel$export(module.exports, "themeColorModes", () => $022db685d19a6057$export$83993de8eb66733);
$parcel$export(module.exports, "DEFAULT_COLOR_MODE", () => $022db685d19a6057$export$854b45b62d1eb6d4);
/* eslint-disable jira/filename-case */ const $022db685d19a6057$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $022db685d19a6057$export$9e2cc65718a61846 = 'themePreference';
const $022db685d19a6057$export$89c5cf64ad15c3ea = 'changed';
const $022db685d19a6057$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $022db685d19a6057$export$854b45b62d1eb6d4 = 'auto';

});

parcelRegister("CXcYw", function(module, exports) {
$parcel$export(module.exports, "setThemePreference", () => $0d65de2975f04394$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $0d65de2975f04394$export$2f7a12048d96237);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $fNXFu = parcelRequire("fNXFu");

var $gfzbQ = parcelRequire("gfzbQ");

var $8I8y6 = parcelRequire("8I8y6");
const $0d65de2975f04394$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $fNXFu.userPreferenceAPI).set((0, $8I8y6.THEME_PREFERENCE_KEY), theme);
    promise.catch((error)=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $0d65de2975f04394$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $fNXFu.userPreferenceAPI).get((0, $8I8y6.THEME_PREFERENCE_KEY));
    promise.catch((error)=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        if (theme && !(0, $gfzbQ.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return theme && (0, $gfzbQ.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("gfzbQ", function(module, exports) {
$parcel$export(module.exports, "ThemeOptions", () => $bb4e6cab7a7e53ed$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $bb4e6cab7a7e53ed$export$2faeed762aac6741);
/* eslint-disable jira/filename-case */ // This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $bb4e6cab7a7e53ed$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $bb4e6cab7a7e53ed$export$2faeed762aac6741 = 'light';

});


parcelRegister("1M80L", function(module, exports) {
$parcel$export(module.exports, "useThemePreference", () => $3b5dab09f64a4178$export$3416635c8aeb5bab);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $k6ufm = parcelRequire("k6ufm");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $3GN2r = parcelRequire("3GN2r");

var $8I8y6 = parcelRequire("8I8y6");

var $eHBZS = parcelRequire("eHBZS");
const $3b5dab09f64a4178$export$3416635c8aeb5bab = (themePreferenceResource)=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $k6ufm.useResource)(themePreferenceResource);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // Get tenant context using hooks
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const accountId = (0, $3GN2r.useAccountId)();
    const fireThemeAnalytics = (0, $euxye.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $8I8y6.THEME_PREFERENCES_ANALYTICS_ACTION),
            actionSubject: (0, $8I8y6.THEME_PREFERENCES_ANALYTICS_SUBJECT)
        });
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $euxye.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $eHBZS.setThemePreference)(theme, cloudId, activationId, accountId);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics,
        cloudId,
        activationId,
        accountId
    ]);
    return {
        theme: data?.theme ?? (0, $8I8y6.DEFAULT_COLOR_MODE),
        setTheme: setTheme
    };
};

});
parcelRegister("kt86l", function(module, exports) {
$parcel$export(module.exports, "useCloudId", () => $2bfc45038d77637a$export$9da0f7c65f28ed16);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $2bfc45038d77637a$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("h3LJR", function(module, exports) {
$parcel$export(module.exports, "useActivationId", () => $c2dc38b8355b1878$export$43686faa787c943);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $c2dc38b8355b1878$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("3GN2r", function(module, exports) {
$parcel$export(module.exports, "useAccountId", () => $9f2e6f8168ebe10a$export$e72033e0f5baa3e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $9f2e6f8168ebe10a$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("eHBZS", function(module, exports) {
$parcel$export(module.exports, "setThemePreference", () => $9c2360be3f5e8123$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $9c2360be3f5e8123$export$2f7a12048d96237);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $fDVI0 = parcelRequire("fDVI0");

var $aI7em = parcelRequire("aI7em");

var $iCK9i = parcelRequire("iCK9i");

var $8I8y6 = parcelRequire("8I8y6");
const $9c2360be3f5e8123$var$handleThemePreferenceError = (error, operation, additionalAttributes)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const err = error;
    (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            id: 'ThemePreferenceCRUD',
            packageName: 'jiraRouterResourcesThemePreference'
        },
        error: err,
        attributes: {
            op: operation,
            errName: String(err.name),
            statusCode: err.statusCode,
            ...additionalAttributes
        }
    });
};
const $9c2360be3f5e8123$export$a6b84eebd33787e2 = async (colorMode, cloudId, activationId, accountId)=>{
    try {
        // Create workspace ARI only when feature flag is enabled
        const workspaceAri = (0, $fDVI0.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        if (!accountId) // Shared theming is supported for logged in users only
        return;
        // Use platform package for GraphQL operations
        await (0, $iCK9i.updateWorkspaceThemePreference)((0, $aI7em.default)(), workspaceAri, accountId, {
            colorMode: colorMode
        });
    } catch (error) {
        $9c2360be3f5e8123$var$handleThemePreferenceError(error, 'put', {
            param: `to:${colorMode}`
        });
        throw error;
    }
};
const $9c2360be3f5e8123$export$2f7a12048d96237 = async (cloudId, activationId, accountId)=>{
    if (!cloudId || !activationId || !accountId) // Shared theming is supported for logged in users only. CloudId and ActicationId should be always present but are left nullable to simplify the caller function
    return 0, $8I8y6.DEFAULT_COLOR_MODE;
    try {
        let colorMode;
        // Create workspace ARI only when feature flag is enabled
        const workspaceAri = (0, $fDVI0.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        // Use platform package for GraphQL operations
        const themeState = await (0, $iCK9i.getWorkspaceThemePreference)((0, $aI7em.default)(), workspaceAri, accountId);
        colorMode = themeState?.colorMode;
        // Validate theme value
        if (colorMode && !(0, $8I8y6.themeColorModes).includes(colorMode)) {
            // very unlikely but…
            $9c2360be3f5e8123$var$handleThemePreferenceError(new Error('Unrecognized theme!'), 'get', {
                theme: colorMode,
                errName: 'unrecognized value!'
            });
            colorMode = (0, $8I8y6.DEFAULT_COLOR_MODE);
        }
        return colorMode ?? (0, $8I8y6.DEFAULT_COLOR_MODE);
    } catch (error) {
        $9c2360be3f5e8123$var$handleThemePreferenceError(error, 'get');
        throw error;
    }
};

});


parcelRegister("ilTfh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Oynj").then(()=>parcelRequire('gRoWq'));

});



parcelRegister("eFqFr", function(module, exports) {
$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $c2a7fa4ff8044e80$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $c2a7fa4ff8044e80$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $c2a7fa4ff8044e80$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $c2a7fa4ff8044e80$export$525db876ed776e0d);

var $6CfY5 = parcelRequire("6CfY5");

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $c2a7fa4ff8044e80$var$RESOURCE_TYPE_NAVIGATION_PLANS_VISIBILITY = 'NAVIGATION_PLANS_VISIBILITY';
const $c2a7fa4ff8044e80$var$LOCATION = 'portfolio.services.plan-item-visibility';
const $c2a7fa4ff8044e80$export$fa475a9581133779 = (0, $7edbf.createResource)({
    type: $c2a7fa4ff8044e80$var$RESOURCE_TYPE_NAVIGATION_PLANS_VISIBILITY,
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $4fhEY.default)('/rest/jpo/1.0/navigation/simple');
            return response;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData($c2a7fa4ff8044e80$var$LOCATION, 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity,
    isCritical: true
});
const $c2a7fa4ff8044e80$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($c2a7fa4ff8044e80$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $c2a7fa4ff8044e80$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($c2a7fa4ff8044e80$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $c2a7fa4ff8044e80$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($c2a7fa4ff8044e80$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $c2a7fa4ff8044e80$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($c2a7fa4ff8044e80$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});

parcelRegister("1IUl9", function(module, exports) {
$parcel$export(module.exports, "topNav4UIStateResource", () => $c8cf71c84b45b52e$export$2d81c2e40eea9fba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $fLTsc = parcelRequire("fLTsc");

var $izdWD = parcelRequire("izdWD");

var $i860n = parcelRequire("i860n");

var $htsFl = parcelRequire("htsFl");

var $2700E = parcelRequire("2700E");

var $9xzYB = parcelRequire("9xzYB");
const $c8cf71c84b45b52e$var$hasOnlyJSMAndCSMAccess = (appPermissions)=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasSoftwareAccess: hasSoftwareAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = appPermissions;
    return hasServiceDeskAccess && hasCustomerServiceAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess;
};
const $c8cf71c84b45b52e$export$2d81c2e40eea9fba = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
    getQuery: ({ match: match, route: route }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, appEditions: appEditions } })=>{
        const collabContextRoutingAri = (0, $i860n.fg)('post-office_enable_routing_workspace_id_prop') ? (0, $9xzYB.PlatformSiteAri).create({
            siteId: cloudId
        }).toString() : undefined;
        const issueKey = match.params.issueKey ?? '';
        const projectKey = match.params.projectKey ?? '';
        const projectIdOrKey = (0, $fLTsc.getProjectKeyOrId)(match);
        const isCsmRoute = match.path.startsWith('/jira/customer-service-management') || match.path.startsWith('/jira/helpcenter') || // note: remove when cleaning csm_appification_standalone_navigation
        match.path.startsWith('/jira/customer-service'); // note: remove when cleaning csm_appification_standalone_navigation
        return {
            parameters: (0, $izdWD.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                atlassianAccountId: atlassianAccountId ?? '',
                isNavStateQuerySkipped: isAnonymous || (0, $i860n.fg)('navx-global-side-nav') || (0, $2700E.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false),
                issueKey: issueKey ?? '',
                shouldCheckProjectTypeForIssue: route.group === 'issue' && Boolean(issueKey) && $c8cf71c84b45b52e$var$hasOnlyJSMAndCSMAccess(appPermissions),
                projectKey: projectKey ?? '',
                shouldCheckProjectType: Boolean(projectKey) && $c8cf71c84b45b52e$var$hasOnlyJSMAndCSMAccess(appPermissions),
                projectIdOrKey: projectIdOrKey,
                shouldFetchProjectTypeForSettingsAndEA: Boolean(projectIdOrKey),
                // we can SSR csmLiveChatAgent status indicator
                shouldFetchCSMLiveChatAgent: appPermissions.hasCustomerServiceAccess && appEditions.customerService === (0, $d8LhJ.PREMIUM_EDITION) && isCsmRoute && (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget'),
                // we can't SSR csmLiveChatAgent
                // let's get the project type to check if we should mount csmLiveChatAgent status indicator
                // note: remove when cleaning csm_appification_standalone_navigation
                shouldFetchProjectType: appPermissions.hasCustomerServiceAccess && appEditions.customerService === (0, $d8LhJ.PREMIUM_EDITION) && Boolean(projectIdOrKey) && !isCsmRoute && (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget'),
                skipHelpButtonRelayRead: isAnonymous,
                collabContextRoutingAri: collabContextRoutingAri
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});

});
parcelRegister("fLTsc", function(module, exports) {
$parcel$export(module.exports, "getProjectKeyOrId", () => $f82a43c9ed6457bf$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $f82a43c9ed6457bf$export$b87af5b274141bd6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");
const $f82a43c9ed6457bf$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $f82a43c9ed6457bf$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});

parcelRegister("izdWD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ab27db49fc92476$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a8f4a68c21be4bc97b109cdb5fb25ec7>>
 * @relayHash 46d327b5cf3aabe15e51855caa8c10d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e5a6aeb84e4a1ae97747000b485a23aa901812c07c911e791156de66d2521b7
const $8ab27db49fc92476$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collabContextRoutingAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNavStateQuerySkipped"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckProjectType"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckProjectTypeForIssue"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldFetchCSMLiveChatAgent"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldFetchProjectType"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldFetchProjectTypeForSettingsAndEA"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipHelpButtonRelayRead"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "collabContextRoutingAri",
            "variableName": "collabContextRoutingAri"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "atlassianAccountId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        v18 /*: any*/ 
    ], v22 = [
        {
            "args": [
                v14 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "idOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": v21 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TopNavigationQuery",
            "selections": [
                {
                    "condition": "isNavStateQuerySkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ProfileNew"
                        },
                        {
                            "args": v17 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ProductHomeWithQuery"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "EditionAwareness_query"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SettingsAction_query"
                },
                {
                    "condition": "skipHelpButtonRelayRead",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "HelpButton_query"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v12 /*: any*/ ,
                v11 /*: any*/ ,
                v10 /*: any*/ ,
                v13 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TopNavigationQuery",
            "selections": [
                {
                    "condition": "isNavStateQuerySkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                v19 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "shouldFetchProjectType",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v22 /*: any*/ 
                        },
                        {
                            "condition": "shouldFetchCSMLiveChatAgent",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v19 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ],
                                    "kind": "LinkedField",
                                    "name": "csm_liveChatAgent",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "liveChatActivity"
                                                },
                                                {
                                                    "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                                                    "kind": "LinkedField",
                                                    "name": "liveChatActivitiesBySpace",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CustomerServiceSpaceLiveChatActivity",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "activityStatus"
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceLiveChatAgent"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "identifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v17 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "shouldCheckProjectTypeForIssue",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "issueKey"
                                        }
                                    ],
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldCheckProjectType",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "projectKey"
                                        }
                                    ],
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v21 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldFetchProjectTypeForSettingsAndEA",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": v22 /*: any*/ 
                },
                {
                    "condition": "skipHelpButtonRelayRead",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "propertyKey",
                                            "value": "help_button_ui_state"
                                        }
                                    ],
                                    "concreteType": "JiraEntityPropertyJSON",
                                    "kind": "LinkedField",
                                    "name": "jsonUserProperty",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jsonValue"
                                        },
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5e5a6aeb84e4a1ae97747000b485a23aa901812c07c911e791156de66d2521b7",
            "metadata": {},
            "name": "TopNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8ab27db49fc92476$var$node.hash = "8d481c6de979b25970dce425f785d3a2";
var $8ab27db49fc92476$export$2e2bcd8739ae039 = $8ab27db49fc92476$var$node;

});


parcelRegister("56F5E", function(module, exports) {
$parcel$export(module.exports, "navPlatformSidebarResource", () => $a875254d4baa2f3a$export$b22e51bad3fbae1b);

var $5IkoH = parcelRequire("5IkoH");

var $bkBsT = parcelRequire("bkBsT");

var $aK5Al = parcelRequire("aK5Al");

var $htsFl = parcelRequire("htsFl");

var $bZhC2 = parcelRequire("bZhC2");

var $2NSbF = parcelRequire("2NSbF");

var $fDVI0 = parcelRequire("fDVI0");

var $1hxzM = parcelRequire("1hxzM");

var $c1zHX = parcelRequire("c1zHX");

var $i860n = parcelRequire("i860n");
const $a875254d4baa2f3a$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM = 'RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM';
const $a875254d4baa2f3a$export$b22e51bad3fbae1b = (0, $htsFl.createRelayResource)({
    type: $a875254d4baa2f3a$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM,
    // Anonymous users must not trigger this GSN GraphQL query. Use the
    // resource-level `skip` predicate so `loadQuery` is never invoked for them —
    // `getQuery` will not run when `skip` returns `true`.
    skip: (_, { tenantContext: { isAnonymous: isAnonymous } })=>{
        return isAnonymous;
    },
    getQuery: (routerContext, { tenantContext: { activationId: activationId, atlassianAccountId: atlassianAccountId, cloudId: cloudId } })=>{
        const initialSelectedPath = (0, $bkBsT.getInitialSelectedPath)(routerContext);
        const ownerAri = atlassianAccountId && (0, $2NSbF.IdentityUserAri).create({
            userId: atlassianAccountId
        }).toString();
        const fetchPolicy = 'store-or-network';
        return {
            parameters: (0, $c1zHX.default),
            variables: {
                cloudId: cloudId,
                entityAriApps: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'apps'
                }).toString(),
                entityAriFilters: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'filters'
                }).toString(),
                entityAriPlans: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'plans'
                }).toString(),
                ...(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe') ? {
                    entityAriRoadmaps: (0, $bZhC2.JiraNavigationSettingsAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        navigationSettingScope: 'collections'
                    }).toString()
                } : {},
                entityAriUserSideNavSettings: (0, $fDVI0.JiraWorkspaceAri).create({
                    siteId: cloudId,
                    activationId: activationId
                }).toString(),
                isAppsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_APPS)),
                isFiltersExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_OPERATIONS)),
                navPlatMenuDataEntityAri: (0, $1hxzM.buildNavigationAriForMenuData)({
                    activationId: activationId,
                    firstPartyApp: 'jira',
                    siteId: cloudId
                }),
                navPlatSidebarDataEntityAri: (0, $1hxzM.buildNavigationAriForSidebarData)({
                    activationId: activationId,
                    firstPartyApp: 'jira',
                    siteId: cloudId
                }),
                ownerAri: ownerAri,
                isRoadmapUpsellEnabled: (0, $i860n.fg)('jpd-roadmaps-in-jira'),
                fetchGlobalShortcutsAvailableProducts: Boolean(cloudId && ownerAri && (0, $i860n.fg)('navx-4515-jira-gsn-gas-ssr'))
            },
            options: {
                fetchPolicy: fetchPolicy
            }
        };
    },
    isCritical: true
});

});
parcelRegister("bkBsT", function(module, exports) {
$parcel$export(module.exports, "getInitialSelectedPath", () => $41c914737e98669c$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $5vPx9 = parcelRequire("5vPx9");

var $k0Ro9 = parcelRequire("k0Ro9");
const $41c914737e98669c$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($5vPx9)))((0, $k0Ro9.routeToSelectedPath));

});
parcelRegister("k0Ro9", function(module, exports) {
$parcel$export(module.exports, "routeToSelectedPath", () => $65eaef1c7bb4857f$export$a92474c098a1fd13);
$parcel$export(module.exports, "useRouteToSelectedPath", () => $65eaef1c7bb4857f$export$a086f1986cac3253);

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $i860n = parcelRequire("i860n");

var $f2wVS = parcelRequire("f2wVS");

var $dc42p = parcelRequire("dc42p");

var $51yTx = parcelRequire("51yTx");

var $k6Eu2 = parcelRequire("k6Eu2");

var $9hmST = parcelRequire("9hmST");

var $g9lLz = parcelRequire("g9lLz");

var $7EMaG = parcelRequire("7EMaG");

var $aYgRR = parcelRequire("aYgRR");

var $6A53W = parcelRequire("6A53W");

var $lK3fV = parcelRequire("lK3fV");

var $eHCSD = parcelRequire("eHCSD");

var $6vVvT = parcelRequire("6vVvT");

var $hw9Bj = parcelRequire("hw9Bj");

var $cCvQD = parcelRequire("cCvQD");
function $65eaef1c7bb4857f$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $aYgRR.topLevelConverter).routes.has(routeName)) return (0, $aYgRR.topLevelConverter).convert(routeContext);
    if ((0, $dc42p.appsConverter).routes.has(routeName)) return (0, $dc42p.appsConverter).convert(routeContext);
    if ((0, $51yTx.assetsConverter).routes.has(routeName)) return (0, $51yTx.assetsConverter).convert(routeContext);
    if ((0, $k6Eu2.dashboardsConverter).routes.has(routeName)) return (0, $k6Eu2.dashboardsConverter).convert(routeContext);
    if ((0, $9hmST.filtersConverter).routes.has(routeName)) return (0, $9hmST.filtersConverter).convert(routeContext);
    if ((0, $g9lLz.itamConverter).routes.has(routeName) && (0, $i860n.fg)('itam_ftw')) return (0, $g9lLz.itamConverter).convert(routeContext);
    if ((0, $7EMaG.operationsConverter).routes.has(routeName)) return (0, $7EMaG.operationsConverter).convert(routeContext);
    if ((0, $6A53W.plansConverter).routes.has(routeName)) return (0, $6A53W.plansConverter).convert(routeContext);
    if ((0, $lK3fV.projectsConverter).routes.has(routeName)) return (0, $lK3fV.projectsConverter).convert(routeContext);
    if ((0, $eHCSD.roadmapsConverter).routes.has(routeName)) return (0, $eHCSD.roadmapsConverter).convert(routeContext);
    if ((0, $6vVvT.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $6vVvT.serviceManagementProjectSettingsConverter).convert(routeContext);
    if ((0, $hw9Bj.customerServiceConverter).routes.has(routeName)) return (0, $hw9Bj.customerServiceConverter).convert(routeContext);
    if ((0, $cCvQD.customerExperiencesConverter).routes.has(routeName)) return (0, $cCvQD.customerExperiencesConverter).convert(routeContext);
    return [];
}
function $65eaef1c7bb4857f$export$216c13b87ae41e0b(state) {
    const routeName = state.route.name;
    const match = state.match;
    const query = state.query;
    if ((0, $aYgRR.topLevelConverter).routes.has(routeName)) return (0, $aYgRR.topLevelConverter).convertNew({
        routeName: routeName
    });
    if ((0, $dc42p.appsConverter).routes.has(routeName)) return (0, $dc42p.appsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $51yTx.assetsConverter).routes.has(routeName)) return (0, $51yTx.assetsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $k6Eu2.dashboardsConverter).routes.has(routeName)) return (0, $k6Eu2.dashboardsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $9hmST.filtersConverter).routes.has(routeName)) return (0, $9hmST.filtersConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $g9lLz.itamConverter).routes.has(routeName) && (0, $i860n.fg)('itam_ftw')) return (0, $g9lLz.itamConverter).convertNew({
        routeName: routeName
    });
    if ((0, $7EMaG.operationsConverter).routes.has(routeName)) return (0, $7EMaG.operationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $6A53W.plansConverter).routes.has(routeName)) return (0, $6A53W.plansConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $lK3fV.projectsConverter).routes.has(routeName)) return (0, $lK3fV.projectsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $eHCSD.roadmapsConverter).routes.has(routeName)) return (0, $eHCSD.roadmapsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $6vVvT.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $6vVvT.serviceManagementProjectSettingsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $hw9Bj.customerServiceConverter).routes.has(routeName)) return (0, $hw9Bj.customerServiceConverter).convertNew({
        routeName: routeName
    });
    if ((0, $cCvQD.customerExperiencesConverter).routes.has(routeName)) return (0, $cCvQD.customerExperiencesConverter).convertNew({
        routeName: routeName,
        match: match
    });
    return [];
}
function $65eaef1c7bb4857f$export$8eb45058a3aef67f() {
    return (0, $euxye.useState)(()=>{
        const selectedPath = $65eaef1c7bb4857f$export$216c13b87ae41e0b((0, $f2wVS.getRouterState)());
        return {
            initialSelectedPath: selectedPath,
            selectedPath: selectedPath
        };
    });
}
function $65eaef1c7bb4857f$export$a086f1986cac3253() {
    const [selectedPathData, setSelectedPathData] = $65eaef1c7bb4857f$export$8eb45058a3aef67f();
    (0, $euxye.useEffect)(()=>(0, $f2wVS.addRouteListener)((state)=>{
            const nextSelectedPath = $65eaef1c7bb4857f$export$216c13b87ae41e0b(state);
            setSelectedPathData((prev)=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(nextSelectedPath, prev.selectedPath)) return prev;
                return {
                    initialSelectedPath: prev.initialSelectedPath,
                    selectedPath: nextSelectedPath
                };
            });
        }), // addRouteListener is a stable module-level function and setSelectedPathData
    // is the stable React useState setter — neither ever changes, so this effect
    // runs exactly once on mount and unsubscribes on unmount.
    [
        setSelectedPathData
    ]);
    return selectedPathData;
}

});
parcelRegister("dc42p", function(module, exports) {
$parcel$export(module.exports, "appsConverter", () => $cf96724268377701$export$d017a63045c88c47);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
// TODO: verify these routes
const $cf96724268377701$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'legacy-connect-project',
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ 'connect-general-service-desk-project',
    'connect-project'
];
const $cf96724268377701$var$CERTAIN_APPS_SECTION_ROUTES = [
    'forge-spa-global',
    'marketplace-index',
    'forge-spa-personal-settings'
];
const $cf96724268377701$export$66b32f6f30eb4b4 = new Set([
    ...$cf96724268377701$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$cf96724268377701$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $cf96724268377701$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_APPS)
    ];
    return $cf96724268377701$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $cf96724268377701$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_APPS)
    ];
    return $cf96724268377701$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $cf96724268377701$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'marketplace-index':
            path.push((0, $5IkoH.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 'connect-general':
        case 'connect-general-invalid':
        case 'forge-spa-global':
        case 'forge-spa-personal-settings':
        case 'legacy-connect-general':
            path.push((0, $5IkoH.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 'connect-project':
        case 'legacy-connect-project':
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $5IkoH.MENU_ID_PROJECTS),
                    (0, $5IkoH.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 'connect-general-service-desk-project':
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $5IkoH.MENU_ID_PROJECTS),
                    (0, $5IkoH.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $cf96724268377701$export$d017a63045c88c47 = {
    routes: $cf96724268377701$export$66b32f6f30eb4b4,
    convert: $cf96724268377701$var$convert,
    convertNew: $cf96724268377701$var$convertNew
};

});

parcelRegister("51yTx", function(module, exports) {
$parcel$export(module.exports, "assetsConverter", () => $022e9e869b8d8a84$export$6cfeba0849032a84);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $022e9e869b8d8a84$var$routes = new Set([
    'assets',
    'assets-configure',
    'assets-data-manager-getting-started',
    'assets-data-manager-object-classes',
    'assets-data-manager-object-classes-settings',
    'assets-data-manager-object-class-settings',
    'assets-data-manager-data-dictionary-group',
    'assets-data-manager-data-source',
    'assets-data-manager-object-class-view',
    'assets-data-manager-object-detail-view',
    'assets-data-manager-data-dictionary-issues',
    'assets-data-manager-discover',
    'assets-object',
    'assets-schema',
    'assets-for-you',
    'assets-schema-configuration',
    'assets-object-type-configuration',
    'assets-reports',
    'assets-reports-default-redirect',
    'assets-reports-unsubscribe',
    'assets-analytics-data-view-create',
    'assets-analytics-data-view-details',
    'assets-analytics-data-view-list',
    'assets-dashboards',
    'assets-dashboards-detail',
    'servicedesk-cmdb-assets',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-reports',
    'servicedesk-cmdb-assets-reports-default-redirect',
    'servicedesk-cmdb-assets-reports-unsubscribe',
    'servicedesk-cmdb-insight',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-analytics-data-view-create',
    'servicedesk-cmdb-assets-analytics-data-view-details',
    'servicedesk-cmdb-assets-analytics-data-view-list',
    'servicedesk-cmdb-assets-dashboards',
    'servicedesk-cmdb-assets-dashboards-detail'
]);
function $022e9e869b8d8a84$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $5IkoH.MENU_ID_ASSETS)
    ];
    return $022e9e869b8d8a84$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $022e9e869b8d8a84$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [
        (0, $5IkoH.MENU_ID_ASSETS)
    ];
    return $022e9e869b8d8a84$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $022e9e869b8d8a84$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'assets-for-you':
            path.push((0, $5IkoH.MENU_ID_ASSETS_FOR_YOU));
            break;
        case 'servicedesk-cmdb-assets':
        case 'servicedesk-cmdb-object':
        case 'servicedesk-cmdb-object-schema':
        case 'servicedesk-cmdb-object-schema-configuration':
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $5IkoH.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        // eslint-disable-next-line no-duplicate-case
        case 'servicedesk-cmdb-object':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema-configuration':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $5IkoH.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 'servicedesk-cmdb-assets-reports':
        case 'servicedesk-cmdb-assets-reports-default-redirect':
        case 'servicedesk-cmdb-assets-reports-unsubscribe':
        case 'servicedesk-cmdb-assets-analytics-data-view-create':
        case 'servicedesk-cmdb-assets-analytics-data-view-details':
        case 'servicedesk-cmdb-assets-analytics-data-view-list':
        case 'servicedesk-cmdb-assets-dashboards':
        case 'servicedesk-cmdb-assets-dashboards-detail':
            path.push((0, $5IkoH.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $022e9e869b8d8a84$export$6cfeba0849032a84 = {
    routes: $022e9e869b8d8a84$var$routes,
    convert: $022e9e869b8d8a84$var$convert,
    convertNew: $022e9e869b8d8a84$var$convertNew
};

});

parcelRegister("k6Eu2", function(module, exports) {
$parcel$export(module.exports, "dashboardsConverter", () => $b4de285fedbbc6ad$export$6468819b4be328b1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $b4de285fedbbc6ad$var$routes = new Set([
    'dashboards-directory',
    'dashboard-edit',
    'dashboard-view',
    'dashboard-wallboard'
]);
function $b4de285fedbbc6ad$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_DASHBOARDS)
    ];
    return $b4de285fedbbc6ad$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $b4de285fedbbc6ad$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_DASHBOARDS)
    ];
    return $b4de285fedbbc6ad$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $b4de285fedbbc6ad$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'dashboards-directory':
            path.push((0, $5IkoH.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 'dashboard-wallboard':
            query.dashboardId && path.push((0, $5IkoH.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $5IkoH.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $5IkoH.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $b4de285fedbbc6ad$export$6468819b4be328b1 = {
    routes: $b4de285fedbbc6ad$var$routes,
    convert: $b4de285fedbbc6ad$var$convert,
    convertNew: $b4de285fedbbc6ad$var$convertNew
};

});

parcelRegister("9hmST", function(module, exports) {
$parcel$export(module.exports, "filtersConverter", () => $0c1d282f44306910$export$6e91331b5debb7c8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $0c1d282f44306910$var$routes = new Set([
    'filters-directory',
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect',
    'issue',
    'legacy-gin',
    'legacy-gin-issue',
    'legacy-gin-subscriptions',
    'work-item'
]);
function $0c1d282f44306910$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_FILTERS)
    ];
    return $0c1d282f44306910$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $0c1d282f44306910$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_FILTERS)
    ];
    return $0c1d282f44306910$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $0c1d282f44306910$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'filters-directory':
            path.push((0, $5IkoH.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 'work-item':
        case 'issue':
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $5IkoH.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $5IkoH.MENU_ID_PROJECTS),
                        (0, $5IkoH.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $5IkoH.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $5IkoH.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $0c1d282f44306910$export$6e91331b5debb7c8 = {
    routes: $0c1d282f44306910$var$routes,
    convert: $0c1d282f44306910$var$convert,
    convertNew: $0c1d282f44306910$var$convertNew
};

});

parcelRegister("g9lLz", function(module, exports) {
$parcel$export(module.exports, "itamConverter", () => $e1fb2e0e8309ffcf$export$3421e67b06fa0e65);

var $5IkoH = parcelRequire("5IkoH");
const $e1fb2e0e8309ffcf$var$routes = new Set([
    'itam',
    'itam-ai-insights-preview',
    'itam-settings'
]);
function $e1fb2e0e8309ffcf$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $e1fb2e0e8309ffcf$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $e1fb2e0e8309ffcf$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $e1fb2e0e8309ffcf$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $e1fb2e0e8309ffcf$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'itam':
        case 'itam-ai-insights-preview':
        case 'itam-settings':
            path.push((0, $5IkoH.MENU_ID_ITAM));
            break;
        default:
    }
    return path;
}
const $e1fb2e0e8309ffcf$export$3421e67b06fa0e65 = {
    routes: $e1fb2e0e8309ffcf$var$routes,
    convert: $e1fb2e0e8309ffcf$var$convert,
    convertNew: $e1fb2e0e8309ffcf$var$convertNew
};

});

parcelRegister("aYgRR", function(module, exports) {
$parcel$export(module.exports, "topLevelConverter", () => $cb5a78336a6e45ec$export$a33f2d74a674bf8a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2700E = parcelRequire("2700E");

var $5IkoH = parcelRequire("5IkoH");
const $cb5a78336a6e45ec$var$routes = new Set([
    'for-you',
    'people-index'
]);
function $cb5a78336a6e45ec$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $cb5a78336a6e45ec$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $cb5a78336a6e45ec$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $cb5a78336a6e45ec$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $cb5a78336a6e45ec$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'for-you':
            path.push((0, $5IkoH.MENU_ID_FOR_YOU));
            if ((0, $2700E.expVal)('uxissue-1664-autoexpand-spaces', 'isEnabled', false)) {
                path.push((0, $5IkoH.MENU_ID_PROJECTS));
                path.push((0, $5IkoH.MENU_ID_PROJECTS_VIEW_ALL));
            }
            break;
        case 'people-index':
            path.push((0, $5IkoH.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $cb5a78336a6e45ec$export$a33f2d74a674bf8a = {
    routes: $cb5a78336a6e45ec$var$routes,
    convert: $cb5a78336a6e45ec$var$convert,
    convertNew: $cb5a78336a6e45ec$var$convertNew
};

});

parcelRegister("6A53W", function(module, exports) {
$parcel$export(module.exports, "plansConverter", () => $6125d8bf7da84098$export$3bde637b58016d1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $6125d8bf7da84098$var$routes = new Set([
    'plans-directory',
    'software-advanced-roadmaps',
    'software-advanced-roadmaps-getting-started-redirect',
    'software-advanced-roadmaps-setup',
    'software-plan-calendar',
    'software-plan-dependencies',
    'software-plan-increment',
    'software-plan-increments',
    'software-plan-releases',
    'software-plan-summary',
    'software-plan-teams',
    'software-plan-timeline',
    'trashed-plan-direct-link'
]);
function $6125d8bf7da84098$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_PLANS)
    ];
    return $6125d8bf7da84098$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $6125d8bf7da84098$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $5IkoH.MENU_ID_PLANS)
    ];
    return $6125d8bf7da84098$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $6125d8bf7da84098$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'plans-directory':
        case 'software-advanced-roadmaps-getting-started-redirect':
            path.push((0, $5IkoH.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 'trashed-plan-direct-link':
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $5IkoH.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $6125d8bf7da84098$export$3bde637b58016d1 = {
    routes: $6125d8bf7da84098$var$routes,
    convert: $6125d8bf7da84098$var$convert,
    convertNew: $6125d8bf7da84098$var$convertNew
};

});

parcelRegister("lK3fV", function(module, exports) {
$parcel$export(module.exports, "projectsConverter", () => $e140d91e9c549f73$export$c41b724886e5872b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJDWs = parcelRequire("aJDWs");

var $i860n = parcelRequire("i860n");

var $5IkoH = parcelRequire("5IkoH");
const $e140d91e9c549f73$var$routes = new Set([
    'browse-project-redirect',
    'legacy-all-reports',
    'projects-directory',
    'issue-navigator',
    'issue-navigator-core',
    'project-components',
    'project-not-found',
    'project-versions',
    'software-version-detail',
    'software-version-detail-no-tab-path',
    'forge-spa-project',
    'forge-spa-project-servicedesk',
    'forge-spa-servicedesk-queue',
    'polaris-ideas',
    'polaris-onboarding',
    'opsgenie-schedule',
    'issue-navigator-classic',
    'project-pages',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'software-backlog',
    'software-ai-planning',
    'software-ai-planning-classic',
    'software-ai-planning-classic-plan',
    'software-ai-planning-plan',
    'software-planner',
    'software-planner-classic',
    'software-planner-classic-plan',
    'software-planner-plan',
    'software-boards',
    'software-calendar',
    'software-calendar-classic',
    'software-capacity',
    'software-capacity-classic',
    'software-capacity-people-embed',
    'software-capacity-work-embed',
    'software-capacity-classic-people-embed',
    'software-capacity-classic-work-embed',
    'classic-software-proforma-issue-forms-direct',
    'software-code',
    'software-code-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-form',
    'software-form-classic',
    'software-form-builder',
    'software-form-builder-classic',
    'software-form-submit',
    'software-form-submit-classic',
    'software-form-submit-embed',
    'software-form-submit-public',
    'software-form-submit-classic-embed',
    'software-form-submit-classic-public',
    'software-goals',
    'software-goals-classic',
    'software-incidents',
    'software-incidents-classic',
    'software-issue-navigator',
    'software-list',
    'software-list-classic',
    'software-periscope',
    'software-periscope-classic',
    'software-reports',
    'software-reports-boardless',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-cycle-time',
    'software-reports-cycle-time-classic',
    'software-reports-deployment-frequency',
    'software-reports-deployment-frequency-classic',
    'software-reports-velocity',
    'software-reports-velocity-cmp',
    'software-reports-average-issue-age-cmp',
    'software-reports-average-issue-age-cmp-boardless',
    'software-reports-created-vs-resolved-cmp',
    'software-reports-created-vs-resolved-cmp-boardless',
    'software-reports-recently-created-cmp',
    'software-reports-recently-created-cmp-boardless',
    'software-security',
    'software-security-classic',
    'software-summary',
    'software-summary-embed',
    'software-summary-classic',
    'software-summary-classic-embed',
    'software-timeline',
    'software-timeline-classic',
    'software-view-not-found',
    'software-view-not-found-classic',
    'software-agent-context',
    'software-agent-context-classic',
    'software-board-view-not-found',
    'software-board-view-not-found-classic',
    'knowledge-hub-all-articles',
    'kb-article-embed-editor',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-all-categories',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-suggested-topics',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'notification-logs',
    'servicedesk-atlassian-analytics',
    'servicedesk-boards',
    'servicedesk-calendar',
    'servicedesk-project-summary',
    'servicedesk-surveys',
    'servicedesk-proactive-support',
    'servicedesk-proactive-support-dashboard',
    'servicedesk-proactive-support-open-issues',
    'servicedesk-proactive-support-devices',
    'servicedesk-proactive-support-audit-log',
    'servicedesk-change-calendar',
    'servicedesk-channels',
    'servicedesk-connect-project',
    'servicedesk-customers-v2',
    'servicedesk-customer-details',
    'servicedesk-customer-service-escalations',
    'servicedesk-customer-service-products',
    'servicedesk-getting-started-page',
    'servicedesk-getting-started-queue-create',
    'servicedesk-getting-started-queue-edit',
    'servicedesk-getting-started-queues',
    'servicedesk-getting-started-request-types',
    'servicedesk-getting-started-request-form',
    'servicedesk-getting-started-sla',
    'servicedesk-getting-started-sla-new',
    'servicedesk-getting-started-sla-view',
    'servicedesk-getting-started-sla-edit',
    'servicedesk-getting-started-rovo-service-agent-self-service-setup',
    'jsm-work-item',
    'jsm-work-item-incident',
    'jsm-work-item-prevention-center',
    'jsm-work-item-service-request',
    'jsm-work-item-browse',
    'servicedesk-issue',
    'servicedesk-issues',
    'journeys',
    'journey-type',
    'jsm-journeys-list',
    'jsm-list-nin',
    'servicedesk-list',
    'servicedesk-availability',
    'servicedesk-capacity',
    'servicedesk-schedules',
    'servicedesk-skills',
    'servicedesk-workforce-optimization',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-live-chat-my-chats',
    'servicedesk-organizations',
    'servicedesk-organization-details',
    'servicedesk-organization_v2',
    'servicedesk-queues-practice-custom-board',
    'servicedesk-queues-practice-custom-calendar',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-manage-view',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-board',
    'servicedesk-queues-custom-calendar',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-queues-edit',
    'servicedesk-practice-views-config',
    'servicedesk-queues-views-config',
    'servicedesk-queues-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-queues-new',
    'csm-queues-custom-view',
    'csm-queues-custom-issue-detail',
    'csm-queues-new',
    'csm-queues-edit',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-services',
    'servicedesk-service-details',
    'servicedesk-rca-investigation',
    'customer-service-get-started',
    'customer-service-live-conversations',
    'csm-get-started',
    'csm-live-conversations',
    'classic-business-approvals',
    'classic-business-attachments',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-capacity',
    'classic-business-capacity-people-embed',
    'classic-business-capacity-work-embed',
    'classic-business-form',
    'classic-business-form-builder',
    'classic-business-form-submit',
    'classic-business-form-submit-public',
    'classic-business-list',
    'classic-business-shortcut',
    'classic-business-summary',
    'classic-business-timeline',
    'business-agent-context',
    'classic-business-view-not-found',
    'classic-business-redirect',
    'inbox',
    'inbox-classic',
    'archived-issues-directory',
    'classic-business-archived-work-items',
    'servicedesk-archived-work-items',
    'software-archived-work-items-classic',
    'software-archived-work-items'
]);
// TODO remove routes from routes when cleaning up jsm_manage_queues_in_space_settings
const $e140d91e9c549f73$var$routesNoManageQueuesRoute = new Set($e140d91e9c549f73$var$routes);
$e140d91e9c549f73$var$routesNoManageQueuesRoute.delete('servicedesk-practice-manage-view');
$e140d91e9c549f73$var$routesNoManageQueuesRoute.delete('servicedesk-queues-manage-view');
function $e140d91e9c549f73$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_PROJECTS)
    ];
    return $e140d91e9c549f73$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e140d91e9c549f73$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_PROJECTS)
    ];
    return $e140d91e9c549f73$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e140d91e9c549f73$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'polaris-onboarding':
            break;
        case 'projects-directory':
            path.push((0, $5IkoH.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 'forge-spa-project':
        case 'forge-spa-project-servicedesk':
        case 'forge-spa-servicedesk-queue':
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $5IkoH.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $5IkoH.ENTITY_ID).APP(appId));
                break;
            }
        case 'software-agent-context':
        case 'software-agent-context-classic':
        case 'business-agent-context':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_AGENT_CONTEXT(projectKey));
                break;
            }
        case 'knowledge-hub-all-articles':
        case 'kb-article-embed-editor':
        case 'knowledge-hub-article-in-category':
        case 'knowledge-hub-browse-all-articles':
        case 'knowledge-hub-browse-all-categories':
        case 'knowledge-hub-browse-view-article':
        case 'knowledge-hub-category':
        case 'knowledge-hub-category-page':
        case 'knowledge-hub-drafts':
        case 'knowledge-hub-suggested-topics':
        case 'knowledge-hub-landing':
        case 'knowledge-hub-search':
        case 'knowledge-hub-setup':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 'servicedesk-getting-started-page':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 'servicedesk-getting-started-request-types':
        case 'servicedesk-getting-started-request-form':
        case 'servicedesk-getting-started-queue-create':
        case 'servicedesk-getting-started-queue-edit':
        case 'servicedesk-getting-started-queues':
        case 'servicedesk-getting-started-sla':
        case 'servicedesk-getting-started-sla-new':
        case 'servicedesk-getting-started-sla-view':
        case 'servicedesk-getting-started-sla-edit':
        case 'servicedesk-getting-started-rovo-service-agent-self-service-setup':
            if ((0, $i860n.fg)('solution_composer_master')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
            }
            break;
        case 'customer-service-get-started':
        case 'csm-get-started':
            {
                if (routeName === 'csm-get-started' && !(0, $i860n.fg)('csm_appification_standalone_navigation')) break;
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_JCS_GET_STARTED(projectKey));
                break;
            }
        case 'csm-live-conversations':
            if ((0, $i860n.fg)('csm_appification_standalone_navigation')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_LIVE_CONVERSATIONS(projectKey));
            }
            break;
        case 'customer-service-live-conversations':
            if ((0, $i860n.fg)('csm-omni-channel-live-chat-in-widget')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_LIVE_CONVERSATIONS(projectKey));
            }
            break;
        case 'notification-logs':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 'servicedesk-project-summary':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 'servicedesk-proactive-support':
        case 'servicedesk-proactive-support-dashboard':
        case 'servicedesk-proactive-support-open-issues':
        case 'servicedesk-proactive-support-devices':
        case 'servicedesk-proactive-support-audit-log':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_PROACTIVE_SUPPORT(projectKey));
                break;
            }
        case 'servicedesk-surveys':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).SURVEYS(projectKey));
                break;
            }
        case 'servicedesk-boards':
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $5IkoH.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 'servicedesk-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-list':
            if ((0, $i860n.fg)('jsm_list_view_milestone_1')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_VIEWS(projectKey));
            }
            break;
        case 'servicedesk-workforce-optimization':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
            }
            break;
        case 'servicedesk-schedules':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION_SCHEDULES(projectKey));
            }
            break;
        case 'servicedesk-capacity':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION_CAPACITY(projectKey));
            }
            break;
        case 'servicedesk-availability':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION_AVAILABILITY(projectKey));
            }
            break;
        case 'servicedesk-skills':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION_SKILLS(projectKey));
            }
            break;
        case 'servicedesk-change-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-channels':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_CHANNELS(projectKey));
                break;
            }
        case 'servicedesk-organizations':
        case 'servicedesk-organization-details':
        case 'servicedesk-organization_v2':
        case 'servicedesk-customers-v2':
        case 'servicedesk-customer-details':
        case 'servicedesk-customer-service-products':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 'servicedesk-customer-service-escalations':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 'servicedesk-kb-requests-reports':
        case 'servicedesk-kb-requests-reports-time-scale-issue':
        case 'servicedesk-kb-requests-reports-time-scale':
        case 'servicedesk-reports':
        case 'servicedesk-reports-custom':
        case 'servicedesk-reports-custom-create':
        case 'servicedesk-reports-custom-edit':
        case 'servicedesk-reports-custom-time-scale-issue':
        case 'servicedesk-reports-custom-time-scale':
        case 'servicedesk-reports-satisfaction':
        case 'servicedesk-reports-satisfaction-time-scale-issue':
        case 'servicedesk-reports-satisfaction-time-scale':
        case 'servicedesk-reports-type':
        case 'servicedesk-reports-workload':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 'journeys':
        case 'journey-type':
        case 'jsm-journeys-list':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_JOURNEYS(projectKey));
                break;
            }
        case 'servicedesk-oncall-schedule':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 'servicedesk-live-chat-my-chats':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_LIVE_CHAT(projectKey));
                break;
            }
        case 'servicedesk-issues':
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $5IkoH.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $5IkoH.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 'servicedesk-queues-practice-custom-board':
        case 'servicedesk-queues-practice-custom-calendar':
        case 'servicedesk-practice-custom-and-issue':
        case 'servicedesk-practice-edit':
        case 'servicedesk-practice-issue':
        case 'servicedesk-practice-landing':
        case 'servicedesk-practice-manage-view':
        case 'servicedesk-practice-views-config':
        case 'servicedesk-practice-new':
            {
                // TODO remove servicedesk-practice-manage-view case when cleaning up jsm_manage_queues_in_space_settings
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $5IkoH.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $5IkoH.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-rca-investigation':
            if ((0, $i860n.fg)('aiops_rca_v2_ui')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, 'incidents'));
            }
            break;
        case 'servicedesk-queues-addon':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-custom-calendar':
        case 'servicedesk-queues-custom-view':
        case 'servicedesk-queues-edit':
        case 'servicedesk-queues-issue':
        case 'servicedesk-queues-manage-view':
        case 'servicedesk-queues-views-config':
        case 'servicedesk-queues-new':
        case 'csm-queues-custom-view':
        case 'csm-queues-new':
        case 'csm-queues-edit':
            {
                if ((routeName === 'csm-queues-custom-view' || routeName === 'csm-queues-new' || routeName === 'csm-queues-edit') && !(0, $i860n.fg)('csm_appification_standalone_navigation')) break;
                // TODO remove servicedesk-queues-manage-view case when cleaning up jsm_manage_queues_in_space_settings
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $5IkoH.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-custom-issue-detail':
        case 'csm-queues-custom-issue-detail':
            {
                if (routeName === 'csm-queues-custom-issue-detail' && !(0, $i860n.fg)('csm_appification_standalone_navigation')) break;
                const { projectKey: projectKey, queueId: queueId, issueKey: issueKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $5IkoH.ENTITY_ID).QUEUE(queueId));
                issueKey && path.push((0, $5IkoH.ENTITY_ID).ISSUE(issueKey));
                break;
            }
        case 'servicedesk-services':
        case 'servicedesk-service-details':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, formId: formId, subspaceId: subspaceId } = match.params;
                let { boardId: boardId } = match.params;
                const rapidViewBoard = query.rapidView ? query.rapidView : null;
                boardId = rapidViewBoard || boardId || null;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                if ((0, $aJDWs.isProjectsInJiraM2Enabled)()) subspaceId && path.push((0, $5IkoH.ENTITY_ID).SUBSPACE(subspaceId));
                boardId && path.push((0, $5IkoH.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $5IkoH.ENTITY_ID).FORM(formId));
            }
    }
    const { projectKey: projectKey } = match.params;
    if ((routeName === 'servicedesk-change-calendar' || routeName === 'servicedesk-services' || routeName === 'servicedesk-service-details') && projectKey) path.push((0, $5IkoH.ENTITY_ID).PROJECT_OPERATIONS(projectKey));
    return path;
}
const $e140d91e9c549f73$export$c41b724886e5872b = {
    get routes () {
        if ((0, $i860n.fg)('jsm_manage_queues_in_space_settings')) return $e140d91e9c549f73$var$routesNoManageQueuesRoute;
        return $e140d91e9c549f73$var$routes;
    },
    convert: $e140d91e9c549f73$var$convert,
    convertNew: $e140d91e9c549f73$var$convertNew
};

});
parcelRegister("aJDWs", function(module, exports) {
$parcel$export(module.exports, "isProjectsInJiraM0Enabled", () => $bd5c8689a51d6499$export$94631b1b0fb7667a);
$parcel$export(module.exports, "isProjectsInJiraM1Enabled", () => $bd5c8689a51d6499$export$c9b7b1f678a7708a);
$parcel$export(module.exports, "isProjectsInJiraM2Enabled", () => $bd5c8689a51d6499$export$b9aea93c53bbd03c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2700E = parcelRequire("2700E");
const $bd5c8689a51d6499$export$94631b1b0fb7667a = ()=>{
    if ((0, $2700E.expVal)('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 0) return true;
    return false;
};
const $bd5c8689a51d6499$export$c9b7b1f678a7708a = ()=>{
    if ((0, $2700E.expVal)('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 1) return true;
    return false;
};
const $bd5c8689a51d6499$export$b9aea93c53bbd03c = ()=>{
    if ((0, $2700E.expVal)('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 2) return true;
    return false;
};

});


parcelRegister("eHCSD", function(module, exports) {
$parcel$export(module.exports, "roadmapsConverter", () => $fb325acae8a0428a$export$5761942b1e0c2dd0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $fb325acae8a0428a$var$routes = new Set([
    'polaris-collections'
]);
function $fb325acae8a0428a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_ROADMAPS)
    ];
    return $fb325acae8a0428a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $fb325acae8a0428a$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $5IkoH.MENU_ID_ROADMAPS)
    ];
    return $fb325acae8a0428a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $fb325acae8a0428a$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'polaris-collections':
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $5IkoH.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $5IkoH.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $fb325acae8a0428a$export$5761942b1e0c2dd0 = {
    routes: $fb325acae8a0428a$var$routes,
    convert: $fb325acae8a0428a$var$convert,
    convertNew: $fb325acae8a0428a$var$convertNew
};

});

parcelRegister("6vVvT", function(module, exports) {
$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $855c1b653e8e8eef$export$dd307ede503fe0e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h0W3N = parcelRequire("h0W3N");

var $2FrmZ = parcelRequire("2FrmZ");

var $g8IkD = parcelRequire("g8IkD");

var $3KBxc = parcelRequire("3KBxc");

var $ftcBv = parcelRequire("ftcBv");

var $bdBcq = parcelRequire("bdBcq");

var $bpTrq = parcelRequire("bpTrq");

var $7jmvy = parcelRequire("7jmvy");

var $6YA1Z = parcelRequire("6YA1Z");

var $jPEBm = parcelRequire("jPEBm");

var $lNLqY = parcelRequire("lNLqY");

var $78BYB = parcelRequire("78BYB");

var $9pf2j = parcelRequire("9pf2j");

var $90PZX = parcelRequire("90PZX");

var $828bw = parcelRequire("828bw");

var $oAUzG = parcelRequire("oAUzG");

var $82QrG = parcelRequire("82QrG");

var $2FyRg = parcelRequire("2FyRg");

var $cjgSr = parcelRequire("cjgSr");

var $8zrjl = parcelRequire("8zrjl");

var $7Xo5b = parcelRequire("7Xo5b");

var $bMs72 = parcelRequire("bMs72");

var $gALT7 = parcelRequire("gALT7");

var $gHXQv = parcelRequire("gHXQv");

var $ljzmU = parcelRequire("ljzmU");

var $bDLxo = parcelRequire("bDLxo");

var $anfeT = parcelRequire("anfeT");

var $e4hT2 = parcelRequire("e4hT2");

var $rCDsK = parcelRequire("rCDsK");

var $9xkF6 = parcelRequire("9xkF6");

var $7e9U7 = parcelRequire("7e9U7");

var $6YTGM = parcelRequire("6YTGM");

var $e4x7w = parcelRequire("e4x7w");

var $hwLlH = parcelRequire("hwLlH");

var $ffvhw = parcelRequire("ffvhw");

var $1DnrG = parcelRequire("1DnrG");

var $49hTN = parcelRequire("49hTN");

var $7sodi = parcelRequire("7sodi");

var $iCRAQ = parcelRequire("iCRAQ");

var $hDsXI = parcelRequire("hDsXI");

var $6dumt = parcelRequire("6dumt");

var $c5IPX = parcelRequire("c5IPX");

var $az1fH = parcelRequire("az1fH");

var $lkngp = parcelRequire("lkngp");

var $5yfEX = parcelRequire("5yfEX");

var $aPX9C = parcelRequire("aPX9C");

var $97uvA = parcelRequire("97uvA");

var $7GKTa = parcelRequire("7GKTa");

var $i860n = parcelRequire("i860n");

var $5IkoH = parcelRequire("5IkoH");
const $855c1b653e8e8eef$var$routes = new Set([
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'project-settings-servicedesk-rovo-ops',
    'project-settings-servicedesk-rovo',
    'project-settings-servicedesk-rovo-service-agent',
    (0, $lkngp.projectSettingsServicedeskWorkforceOptimizationRoute).name,
    'project-settings-servicedesk-employee-onboarding-configuration',
    'project-setting-servicedesk-resolution-management',
    'project-setting-servicedesk-rovo-service',
    'project-setting-servicedesk-self-service-setup',
    'servicedesk-sla-settings',
    (0, $bdBcq.projectSettingsServicedeskAutomationSummaryRoute).name,
    (0, $bpTrq.projectSettingsServicedeskAccessRoute).name,
    (0, $lNLqY.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $828bw.projectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $2FyRg.projectSettingsServicedeskFeedbackRoute).name,
    (0, $cjgSr.projectSettingsServicedeskFieldsRoute).name,
    (0, $2FrmZ.projectSettingsServicedeskPoliciesRoute).name,
    (0, $anfeT.projectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $e4hT2.projectSettingsServicedeskItsmTicketTypesConfigRoute).name,
    (0, $90PZX.projectSettingsServicedeskChatRoute).name,
    (0, $oAUzG.projectSettingsServicedeskEmailRoute).name,
    (0, $82QrG.projectSettingsServicedeskExternalLinksRoute).name,
    (0, $bDLxo.projectSettingsServicedeskPortalSettingsRoute).name,
    (0, $rCDsK.projectSettingsServicedeskWidgetRoute).name,
    (0, $6YA1Z.projectSettingsServicedeskChangeManagementRoute).name,
    (0, $8zrjl.projectSettingsServicedeskIncidentManagementRoute).name,
    (0, $jPEBm.projectSettingsServicedeskChannelsChatRoute).name,
    (0, $9pf2j.projectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $3KBxc.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $ftcBv.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $ljzmU.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $7jmvy.projectSettingsServicedeskAppsFieldsRoute).name,
    (0, $7sodi.projectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $iCRAQ.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $hDsXI.projectSettingsServicedeskCaseNotesEditRoute).name,
    (0, $6dumt.projectSettingsServicedeskCaseNotesRoute).name,
    (0, $c5IPX.projectSettingsServicedeskKbRoute).name,
    (0, $5yfEX.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $aPX9C.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $7GKTa.servicedeskWorkflowConfigRoute).name,
    (0, $gHXQv.projectSettingsServicedeskIssuetypesRoute).name,
    (0, $78BYB.projectSettingsServicedeskChannelsPortalRoute).name,
    (0, $g8IkD.projectSettingsServicedeskAutomationRoute).name,
    (0, $az1fH.servicedeskSlaSettingsRoute).name,
    (0, $gALT7.projectSettingsServicedeskInternalNotificationsNextGenRoute).name,
    (0, $7e9U7.landingPageRoute).name,
    (0, $6YTGM.browseConversationsRoute).name,
    (0, $e4x7w.browseIntentsRoute).name,
    (0, $hwLlH.browseStandardFlowsRoute).name,
    (0, $9xkF6.virtualAgentSettingsRoute).name,
    (0, $h0W3N.projectSettingsServicedeskLiveChatRoute).name,
    (0, $97uvA.projectSettingsServicedeskProactiveServiceManagementRoute).name
]);
// TODO move routes to routes when cleaning up jsm_manage_queues_in_space_settings
const $855c1b653e8e8eef$var$routesWithManageQueuesRoute = new Set($855c1b653e8e8eef$var$routes);
$855c1b653e8e8eef$var$routesWithManageQueuesRoute.add((0, $7Xo5b.servicedeskQueuesManageViewRoute).name).add((0, $bMs72.servicedeskPracticeManageViewRoute).name);
function $855c1b653e8e8eef$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $855c1b653e8e8eef$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $855c1b653e8e8eef$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $855c1b653e8e8eef$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $855c1b653e8e8eef$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        // Access Menu
        case 'legacy-project-settings-people':
        case (0, $bpTrq.projectSettingsServicedeskAccessRoute).name:
        case (0, $828bw.projectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $lNLqY.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 'legacy-project-settings-permissions':
        case 'legacy-project-settings-issue-security':
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $e4hT2.projectSettingsServicedeskItsmTicketTypesConfigRoute).name:
        case (0, $aPX9C.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management -> Queues menu
        case (0, $7Xo5b.servicedeskQueuesManageViewRoute).name:
        case (0, $bMs72.servicedeskPracticeManageViewRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $5IkoH.MENU_ID_SD_SETTINGS_QUEUES));
            break;
        // Request Mangagement (case-notes behind FG)
        case (0, $hDsXI.projectSettingsServicedeskCaseNotesEditRoute).name:
        case (0, $6dumt.projectSettingsServicedeskCaseNotesRoute).name:
            if ((0, $i860n.fg)('jsm-case-management-settings')) {
                path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
                break;
            }
            break;
        // Request Management
        case (0, $5yfEX.projectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $anfeT.projectSettingsServicedeskProformaProjectFormsRoute).name:
        case 'legacy-project-settings-workflows':
        case (0, $7GKTa.servicedeskWorkflowConfigRoute).name:
        case 'legacy-project-settings-workflows-associate':
        case 'servicedesk-sla-settings':
        case (0, $az1fH.servicedeskSlaSettingsRoute).name:
        case (0, $2FyRg.projectSettingsServicedeskFeedbackRoute).name:
        case 'legacy-project-settings-issue-types':
        case (0, $gHXQv.projectSettingsServicedeskIssuetypesRoute).name:
        case 'legacy-project-settings-fields':
        case (0, $cjgSr.projectSettingsServicedeskFieldsRoute).name:
        case (0, $2FrmZ.projectSettingsServicedeskPoliciesRoute).name:
        case 'legacy-project-settings-screens':
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Workforce Optimization
        case (0, $lkngp.projectSettingsServicedeskWorkforceOptimizationRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_WORKFORCE_OPTIMIZATION));
            break;
        // Automation
        case 'project-settings-automation':
        case (0, $bdBcq.projectSettingsServicedeskAutomationSummaryRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $bDLxo.projectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $78BYB.projectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $oAUzG.projectSettingsServicedeskEmailRoute).name:
        case (0, $h0W3N.projectSettingsServicedeskLiveChatRoute).name:
        case (0, $90PZX.projectSettingsServicedeskChatRoute).name:
        case (0, $rCDsK.projectSettingsServicedeskWidgetRoute).name:
        case (0, $c5IPX.projectSettingsServicedeskKbRoute).name:
        case (0, $82QrG.projectSettingsServicedeskExternalLinksRoute).name:
        case (0, $jPEBm.projectSettingsServicedeskChannelsChatRoute).name:
        case (0, $9pf2j.projectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $9xkF6.virtualAgentSettingsRoute).name:
        case (0, $7e9U7.landingPageRoute).name:
        case (0, $6YTGM.browseConversationsRoute).name:
        case (0, $e4x7w.browseIntentsRoute).name:
        case (0, $hwLlH.browseStandardFlowsRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $6YA1Z.projectSettingsServicedeskChangeManagementRoute).name:
        case (0, $8zrjl.projectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 'legacy-project-settings-notifications':
        case (0, $7sodi.projectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $ljzmU.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $iCRAQ.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $3KBxc.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $ftcBv.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $gALT7.projectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $7jmvy.projectSettingsServicedeskAppsFieldsRoute).name:
        case 'project-settings-servicedesk-rovo-ops':
        case 'project-settings-servicedesk-rovo':
        case 'project-settings-servicedesk-rovo-service-agent':
        case 'project-settings-servicedesk-employee-onboarding-configuration':
        case (0, $ffvhw.projectSettingServicedeskResolutionManagementRoute).name:
        case (0, $1DnrG.projectSettingServicedeskRovoServiceRoute).name:
        case (0, $49hTN.projectSettingServicedeskSelfServiceSetupRoute).name:
            // ADD rest of the apps here
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $855c1b653e8e8eef$export$dd307ede503fe0e = {
    get routes () {
        return (0, $i860n.fg)('jsm_manage_queues_in_space_settings') ? $855c1b653e8e8eef$var$routesWithManageQueuesRoute : $855c1b653e8e8eef$var$routes;
    },
    convert: $855c1b653e8e8eef$var$convert,
    convertNew: $855c1b653e8e8eef$var$convertNew
};

});
parcelRegister("h0W3N", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLiveChatRoute", () => $1ec9c7b521d5ec45$export$ed8d8807e3f83d4c);
const $1ec9c7b521d5ec45$export$ed8d8807e3f83d4c = {
    name: 'project-settings-servicedesk-live-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/live-chat',
    exact: true
};

});

parcelRegister("2FrmZ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskPoliciesRoute", () => $1a9de8069e48e095$export$b417bc9ce074cf0a);
const $1a9de8069e48e095$export$b417bc9ce074cf0a = {
    name: 'project-settings-servicedesk-policies',
    path: '/jira/servicedesk/projects/:projectKey/settings/policies',
    exact: true
};

});

parcelRegister("g8IkD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $e87f87f46d80b9a9$export$1a2228d5e07202a0);
const $e87f87f46d80b9a9$export$1a2228d5e07202a0 = {
    name: 'project-settings-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automate'
};

});

parcelRegister("3KBxc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $9d6e4047ee25b2a4$export$1f37a1aff4f594af);
const $9d6e4047ee25b2a4$export$1f37a1aff4f594af = {
    name: 'project-settings-servicedesk-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
    exact: true
};

});

parcelRegister("ftcBv", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $8e0747872c1b44d6$export$40539cb16771014e);
const $8e0747872c1b44d6$export$40539cb16771014e = {
    name: 'project-settings-servicedesk-notifications-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("bdBcq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRoute", () => $13cbc92acf6654b8$export$165d82a2618e4d99);
const $13cbc92acf6654b8$export$165d82a2618e4d99 = {
    name: 'project-settings-servicedesk-automation-summary',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation'
};

});

parcelRegister("bpTrq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRoute", () => $d4558d478f4c25ec$export$6473a81f1ee460ef);
const $d4558d478f4c25ec$export$6473a81f1ee460ef = {
    name: 'project-settings-servicedesk-access',
    path: '/jira/servicedesk/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("7jmvy", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRoute", () => $1c69b3ec9e1db0cb$export$bb46672b3fb14eec);
const $1c69b3ec9e1db0cb$export$bb46672b3fb14eec = {
    name: 'project-settings-servicedesk-apps-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("6YA1Z", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRoute", () => $ff1316a6705eab0a$export$1444ee3eb63a2ffc);
const $ff1316a6705eab0a$export$1444ee3eb63a2ffc = {
    name: 'project-settings-servicedesk-change-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
    exact: true
};

});

parcelRegister("jPEBm", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRoute", () => $2628352749c18a68$export$be5ad475040cd044);
const $2628352749c18a68$export$be5ad475040cd044 = {
    name: 'project-settings-servicedesk-channels-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
    exact: true
};

});

parcelRegister("lNLqY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $60d1d10040e6c21d$export$5fb39a9d3820886c);
const $60d1d10040e6c21d$export$5fb39a9d3820886c = {
    name: 'project-settings-servicedesk-channels-permissions-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
    exact: true
};

});

parcelRegister("78BYB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRoute", () => $cc0dafb4d740950d$export$8f4234e4e79e03);
const $cc0dafb4d740950d$export$8f4234e4e79e03 = {
    name: 'project-settings-servicedesk-channels-portal',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
    exact: true
};

});

parcelRegister("9pf2j", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRoute", () => $9a519c2e7e29cacd$export$c66db54872d3b51c);
const $9a519c2e7e29cacd$export$c66db54872d3b51c = {
    name: 'project-settings-servicedesk-channels-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
    exact: true
};

});

parcelRegister("90PZX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChatRoute", () => $a832dcfc2b1eb687$export$b22ac188582d1dbd);
const $a832dcfc2b1eb687$export$b22ac188582d1dbd = {
    name: 'project-settings-servicedesk-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/chat',
    exact: true
};

});

parcelRegister("828bw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRoute", () => $9149a4dba45e82f4$export$d8ed4a1eb0c01b5a);
const $9149a4dba45e82f4$export$d8ed4a1eb0c01b5a = {
    name: 'project-settings-servicedesk-customer-permissions',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
    exact: true
};

});

parcelRegister("oAUzG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskEmailRoute", () => $653e75b9d48efbca$export$d7d111417bfcd900);
const $653e75b9d48efbca$export$d7d111417bfcd900 = {
    name: 'project-settings-servicedesk-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/email',
    exact: true
};

});

parcelRegister("82QrG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRoute", () => $e5ef12d58499b5a2$export$2ec1a0d49a1f6ac2);
const $e5ef12d58499b5a2$export$2ec1a0d49a1f6ac2 = {
    name: 'project-settings-servicedesk-external-links',
    path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
    exact: true
};

});

parcelRegister("2FyRg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRoute", () => $ef0d67a57199590c$export$f21485e31d7839aa);
const $ef0d67a57199590c$export$f21485e31d7839aa = {
    name: 'project-settings-servicedesk-feedback',
    path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings'
};

});

parcelRegister("cjgSr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFieldsRoute", () => $72f52d1fa9e60c8f$export$44f665a50373c681);
const $72f52d1fa9e60c8f$export$44f665a50373c681 = {
    name: 'project-settings-servicedesk-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("8zrjl", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRoute", () => $45d4bcb9785fe43c$export$f91bd0bb0d4783ff);
const $45d4bcb9785fe43c$export$f91bd0bb0d4783ff = {
    name: 'project-settings-servicedesk-incident-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
    exact: true
};

});

parcelRegister("7Xo5b", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesManageViewRoute", () => $0be0acf66c593668$export$7f30d40b906894c5);
const $0be0acf66c593668$export$7f30d40b906894c5 = {
    name: 'servicedesk-queues-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};

});

parcelRegister("bMs72", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeManageViewRoute", () => $96ddb2a4bcdfb780$export$125e0ab662806584);
const $96ddb2a4bcdfb780$export$125e0ab662806584 = {
    name: 'servicedesk-practice-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};

});

parcelRegister("gALT7", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRoute", () => $7460d6964c53f3e0$export$5db62792327950b4);
const $7460d6964c53f3e0$export$5db62792327950b4 = {
    name: 'project-settings-servicedesk-internal-notifications-nextGen',
    path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications'
};

});

parcelRegister("gHXQv", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRoute", () => $ba0f03999f2ba336$export$2ffcb2e92bb4950b);
const $ba0f03999f2ba336$export$2ffcb2e92bb4950b = {
    name: 'project-settings-servicedesk-issuetypes',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("ljzmU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $20eee863412a1b1c$export$5108e41f558ecf03);
const $20eee863412a1b1c$export$5108e41f558ecf03 = {
    name: 'project-settings-servicedesk-notifications-internal-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications'
};

});

parcelRegister("bDLxo", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRoute", () => $4aac91bc975986d6$export$7593a7e4a6fc0aaf);
const $4aac91bc975986d6$export$7593a7e4a6fc0aaf = {
    name: 'project-settings-servicedesk-portal-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
    exact: true
};

});

parcelRegister("anfeT", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRoute", () => $9b8fd8515700a332$export$ee87e5f9754e3600);
const $9b8fd8515700a332$export$ee87e5f9754e3600 = {
    name: 'project-settings-servicedesk-proforma-project-forms',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("e4hT2", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRoute", () => $3dd8cbad4a398945$export$52596d9b432829c);
const $3dd8cbad4a398945$export$52596d9b432829c = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice'
};

});

parcelRegister("rCDsK", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskWidgetRoute", () => $a387b39e2ad52e33$export$ac674ffd39608325);
const $a387b39e2ad52e33$export$ac674ffd39608325 = {
    name: 'project-settings-servicedesk-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/widget',
    exact: true
};

});

parcelRegister("9xkF6", function(module, exports) {
$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $f93f7db6dd1a58a8$export$80422a49e17dfd6b);
const $f93f7db6dd1a58a8$export$80422a49e17dfd6b = {
    name: 'project-settings-servicedesk-virtual-agent-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
    exact: true
};

});

parcelRegister("7e9U7", function(module, exports) {
$parcel$export(module.exports, "landingPageRoute", () => $304a31532c3cf664$export$8c051c399fd812a5);
const $304a31532c3cf664$export$8c051c399fd812a5 = {
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: 'project-settings-servicedesk-virtualagentonboarding',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
};

});

parcelRegister("6YTGM", function(module, exports) {
$parcel$export(module.exports, "browseConversationsRoute", () => $94fa863326d7b1ca$export$c8ff4cf64e5540ec);
const $94fa863326d7b1ca$export$c8ff4cf64e5540ec = {
    name: 'project-settings-servicedesk-virtualagent-browseconversations',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
};

});

parcelRegister("e4x7w", function(module, exports) {
$parcel$export(module.exports, "browseIntentsRoute", () => $b8fddeb865707c03$export$3e227412713bc57f);
const $b8fddeb865707c03$export$3e227412713bc57f = {
    name: 'project-settings-servicedesk-virtualagent-browse-intents',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
};

});

parcelRegister("hwLlH", function(module, exports) {
$parcel$export(module.exports, "browseStandardFlowsRoute", () => $9ebf2def4c3a1609$export$fd091ba8fa858397);
const $9ebf2def4c3a1609$export$fd091ba8fa858397 = {
    name: 'project-settings-servicedesk-virtualagent-standard-flows',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
};

});

parcelRegister("ffvhw", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskResolutionManagementRoute", () => $a4ad1e4aee51f882$export$4958935819dc764d);
const $a4ad1e4aee51f882$export$4958935819dc764d = {
    name: 'project-setting-servicedesk-resolution-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent/resolution-management',
    exact: true
};

});

parcelRegister("1DnrG", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskRovoServiceRoute", () => $a824e30eaf8de69f$export$c4284c089f2e0f05);
const $a824e30eaf8de69f$export$c4284c089f2e0f05 = {
    name: 'project-setting-servicedesk-rovo-service',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo/rovo-service',
    exact: true
};

});

parcelRegister("49hTN", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskSelfServiceSetupRoute", () => $3d5f0381c579ec0d$export$5fed0d3d970ca29f);
const $3d5f0381c579ec0d$export$5fed0d3d970ca29f = {
    name: 'project-setting-servicedesk-self-service-setup',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent/self-service-setup',
    exact: true
};

});

parcelRegister("7sodi", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRoute", () => $5cf05f327f941ccf$export$176d388c5b23978e);
const $5cf05f327f941ccf$export$176d388c5b23978e = {
    name: 'project-settings-servicedesk-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications'
};

});

parcelRegister("iCRAQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $4f115c221cac3a9f$export$6ce57d409e1934f2);
const $4f115c221cac3a9f$export$6ce57d409e1934f2 = {
    name: 'project-settings-servicedesk-notifications-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications'
};

});

parcelRegister("hDsXI", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCaseNotesEditRoute", () => $5141d4a2c695f5c8$export$66b8c334438b08a);
const $5141d4a2c695f5c8$export$66b8c334438b08a = {
    name: 'project-settings-servicedesk-case-notes-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/case-management/case-notes/:caseNoteId/edit',
    exact: true
};

});

parcelRegister("6dumt", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCaseNotesRoute", () => $01d5f90cfa34cf16$export$6f1941af80f214c7);
const $01d5f90cfa34cf16$export$6f1941af80f214c7 = {
    name: 'project-settings-servicedesk-case-notes',
    path: '/jira/servicedesk/projects/:projectKey/settings/case-management/case-notes',
    exact: true
};

});

parcelRegister("c5IPX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskKbRoute", () => $03db0fa48f58f2c8$export$725fadff9ae82302);
const $03db0fa48f58f2c8$export$725fadff9ae82302 = {
    name: 'project-settings-servicedesk-kb',
    path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
    exact: true
};

});

parcelRegister("az1fH", function(module, exports) {
$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $3d3fe9e19d19729f$export$bfbf66468910573e);
const $3d3fe9e19d19729f$export$bfbf66468910573e = {
    name: 'servicedesk-sla-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("lkngp", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskWorkforceOptimizationRoute", () => $c907fb9f11bbff11$export$466c28184167cc6);
const $c907fb9f11bbff11$export$466c28184167cc6 = {
    name: 'project-settings-servicedesk-workforce-optimization',
    path: '/jira/servicedesk/projects/:projectKey/settings/workforce-optimization',
    exact: true
};

});

parcelRegister("5yfEX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRoute", () => $722120a4eb65adfa$export$31f95ad4356ce017);
const $722120a4eb65adfa$export$31f95ad4356ce017 = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types'
};

});

parcelRegister("aPX9C", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $94355b7214644a8d$export$8c897f53ff36fa6b);
const $94355b7214644a8d$export$8c897f53ff36fa6b = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned'
};

});

parcelRegister("97uvA", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProactiveServiceManagementRoute", () => $ff845027306db0aa$export$c4ccb1b63c867038);
const $ff845027306db0aa$export$c4ccb1b63c867038 = {
    name: 'project-settings-servicedesk-proactive-service-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/proactive-service-management',
    exact: true
};

});

parcelRegister("7GKTa", function(module, exports) {
$parcel$export(module.exports, "servicedeskWorkflowConfigRoute", () => $89ccab8a4d079211$export$ecc771c0ee86ccb8);
const $89ccab8a4d079211$export$ecc771c0ee86ccb8 = {
    name: 'project-settings-servicedesk-workflow-scheme-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});


parcelRegister("hw9Bj", function(module, exports) {
$parcel$export(module.exports, "customerServiceConverter", () => $990e5978b0b2e12a$export$8e632ccd3e33c9f1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $990e5978b0b2e12a$var$routes = new Set([
    'customer-service-helpcenter',
    'csm-experiences',
    'customer-service-helpcenter-analytics',
    'customer-service-customers',
    'csm-customers',
    'customer-service-customer-details',
    'csm-customer-details',
    'customer-service-organizations',
    'csm-organizations',
    'customer-service-organization-details',
    'csm-organization-details',
    'customer-service-products',
    'csm-products'
]);
function $990e5978b0b2e12a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $990e5978b0b2e12a$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $990e5978b0b2e12a$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $990e5978b0b2e12a$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $990e5978b0b2e12a$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'customer-service-helpcenter':
        case 'csm-experiences':
            path.push((0, $5IkoH.MENU_ID_CUSTOMER_SERVICE));
            path.push((0, $5IkoH.MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL));
            break;
        case 'customer-service-helpcenter-analytics':
            // Analytics appears nested under dashboards
            path.push((0, $5IkoH.MENU_ID_DASHBOARDS));
            path.push((0, $5IkoH.MENU_ID_CUSTOMER_SERVICE_ANALYTICS));
            break;
        case 'customer-service-customers':
        case 'csm-customers':
        case 'customer-service-customer-details':
        case 'csm-customer-details':
        case 'customer-service-organizations':
        case 'csm-organizations':
        case 'customer-service-organization-details':
        case 'csm-organization-details':
        case 'customer-service-products':
        case 'csm-products':
            path.push((0, $5IkoH.MENU_ID_CUSTOMERS));
            break;
        default:
    }
    return path;
}
const $990e5978b0b2e12a$export$8e632ccd3e33c9f1 = {
    routes: $990e5978b0b2e12a$var$routes,
    convert: $990e5978b0b2e12a$var$convert,
    convertNew: $990e5978b0b2e12a$var$convertNew
};

});

parcelRegister("cCvQD", function(module, exports) {
$parcel$export(module.exports, "customerExperiencesConverter", () => $01f0a9f56570bcd5$export$2b9c03d8ca92d1a1);
/* eslint-disable jira/filename-case */ 
var $5IkoH = parcelRequire("5IkoH");
const $01f0a9f56570bcd5$var$routes = new Set([
    'helpcenter-settings-get-started',
    'csm-experience-get-started',
    'helpcenter-settings-details',
    'csm-experience-details',
    'helpcenter-settings-forms',
    'helpcenter-settings-form-edit',
    'csm-experience-forms',
    'csm-experience-form-edit',
    'helpcenter-settings-articles',
    'csm-experience-articles',
    'helpcenter-settings-articles-view-article',
    'helpcenter-settings-create-article',
    'helpcenter-settings-branding',
    'csm-experience-branding',
    'helpcenter-settings-support-website-details-edit',
    'csm-experience-support-website-edit',
    'helpcenter-settings-support-website-details-overview',
    'csm-experience-support-website-overview',
    'helpcenter-settings-support-website-details-pages',
    'csm-experience-support-website-pages',
    'helpcenter-settings-email',
    'csm-experience-email',
    'helpcenter-settings-widget-configuration-customize',
    'csm-experience-widget-configuration-customize',
    'helpcenter-settings-widget-configuration-install',
    'csm-experience-widget-configuration-install',
    'helpcenter-settings-embedded-widgets',
    'csm-experience-embedded-widgets',
    'helpcenter-settings-phone-configuration',
    'csm-experience-phone-configuration',
    'helpcenter-settings-messaging-apps',
    'csm-experience-messaging-apps',
    'helpcenter-settings-chat-configuration',
    'csm-experience-chat-configuration',
    'helpcenter-settings-customer-access',
    'csm-experience-customer-access',
    'helpcenter-settings-agent-studio',
    'csm-experience-agent-studio',
    'helpcenter-settings-customer-notifications',
    'csm-experience-customer-notifications',
    'csm-project-customer-notifications-rule',
    'csm-project-customer-notifications-template'
]);
function $01f0a9f56570bcd5$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $5IkoH.MENU_ID_CUSTOMER_SERVICE)
    ];
    return $01f0a9f56570bcd5$var$convertRouteToPath({
        routeName: routeName,
        path: path,
        match: routeContext.match
    });
}
function $01f0a9f56570bcd5$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $5IkoH.MENU_ID_CUSTOMER_SERVICE)
    ];
    return $01f0a9f56570bcd5$var$convertRouteToPath({
        routeName: routeName,
        path: path,
        match: match
    });
}
function $01f0a9f56570bcd5$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    const { projectKey: projectKey } = match.params;
    projectKey && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE(projectKey));
    switch(routeName){
        case 'helpcenter-settings-get-started':
        case 'csm-experience-get-started':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'get-started'));
                break;
            }
        case 'helpcenter-settings-details':
        case 'csm-experience-details':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'details'));
                break;
            }
        case 'helpcenter-settings-forms':
        case 'helpcenter-settings-form-edit':
        case 'csm-experience-forms':
        case 'csm-experience-form-edit':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'forms'));
                break;
            }
        case 'helpcenter-settings-articles':
        case 'csm-experience-articles':
        case 'helpcenter-settings-articles-view-article':
        case 'helpcenter-settings-create-article':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'articles'));
                break;
            }
        case 'helpcenter-settings-branding':
        case 'csm-experience-branding':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'branding'));
                break;
            }
        case 'helpcenter-settings-support-website-details-edit':
        case 'csm-experience-support-website-edit':
        case 'helpcenter-settings-support-website-details-overview':
        case 'csm-experience-support-website-overview':
        case 'helpcenter-settings-support-website-details-pages':
        case 'csm-experience-support-website-pages':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'support-website'));
                break;
            }
        case 'helpcenter-settings-email':
        case 'csm-experience-email':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'email'));
                break;
            }
        case 'helpcenter-settings-widget-configuration-customize':
        case 'csm-experience-widget-configuration-customize':
        case 'helpcenter-settings-widget-configuration-install':
        case 'csm-experience-widget-configuration-install':
        case 'helpcenter-settings-embedded-widgets':
        case 'csm-experience-embedded-widgets':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'embed'));
                break;
            }
        case 'helpcenter-settings-phone-configuration':
        case 'csm-experience-phone-configuration':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'phone'));
                break;
            }
        case 'helpcenter-settings-messaging-apps':
        case 'csm-experience-messaging-apps':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'messaging-apps'));
                break;
            }
        case 'helpcenter-settings-chat-configuration':
        case 'csm-experience-chat-configuration':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'chat'));
                break;
            }
        case 'helpcenter-settings-customer-access':
        case 'csm-experience-customer-access':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'customer-access'));
                break;
            }
        case 'helpcenter-settings-agent-studio':
        case 'csm-experience-agent-studio':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'agent'));
                break;
            }
        case 'helpcenter-settings-customer-notifications':
        case 'csm-experience-customer-notifications':
        case 'csm-project-customer-notifications-rule':
        case 'csm-project-customer-notifications-template':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'customer-notifications'));
                break;
            }
        default:
    }
    return path;
}
const $01f0a9f56570bcd5$export$2b9c03d8ca92d1a1 = {
    routes: $01f0a9f56570bcd5$var$routes,
    convert: $01f0a9f56570bcd5$var$convert,
    convertNew: $01f0a9f56570bcd5$var$convertNew
};

});



parcelRegister("aK5Al", function(module, exports) {
$parcel$export(module.exports, "isSelectedPath", () => $6ad0eae82bb762d0$export$cdcd6885320eec31);

var $1xxzH = parcelRequire("1xxzH");
function $6ad0eae82bb762d0$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $1xxzH.isMenuIdList)(menuId) ? (0, $1xxzH.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("1xxzH", function(module, exports) {
$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $4f2c6c86923061dd$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $4f2c6c86923061dd$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $4f2c6c86923061dd$export$d8e017f58178e379);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $4f2c6c86923061dd$var$MENU_ID_DELIM = '   '; // Three spaces
function $4f2c6c86923061dd$export$253323efd0c41e72(menuIds) {
    return menuIds.join($4f2c6c86923061dd$var$MENU_ID_DELIM);
}
function $4f2c6c86923061dd$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($4f2c6c86923061dd$var$MENU_ID_DELIM) !== -1;
}
function $4f2c6c86923061dd$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($4f2c6c86923061dd$var$MENU_ID_DELIM);
}

});


parcelRegister("bZhC2", function(module, exports) {
$parcel$export(module.exports, "JiraNavigationSettingsAri", () => $8ba30daed24b906b$export$d53f27b41a9a02bb);

var $1kWQk = parcelRequire("1kWQk");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/navigation-settings/manifest.ts
var $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1kWQk.JiraNavigationSettingsAriResourceOwner),
    resourceType: (0, $1kWQk.JiraNavigationSettingsAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationSettingScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationSettingScope: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/navigation-settings/index.ts
var $8ba30daed24b906b$export$d53f27b41a9a02bb = class _JiraNavigationSettingsAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationSettingScope = opts.resourceIdSegmentValues.navigationSettingScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationSettingScope() {
        return this._navigationSettingScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts.qualifier,
            platformQualifier: $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts.resourceOwner,
            resourceType: $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationSettingScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationSettingScope: opts.navigationSettingScope
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationSettingScope: this.navigationSettingScope
        };
    }
};

});
parcelRegister("1kWQk", function(module, exports) {
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceOwner", () => $0f954db24823d60e$export$a71eb7f052c3a8f1);
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceType", () => $0f954db24823d60e$export$8c9eb6c30d1db6dc);
// src/jira/navigation-settings/types.ts
var $0f954db24823d60e$export$a71eb7f052c3a8f1 = "jira", $0f954db24823d60e$export$8c9eb6c30d1db6dc = "navigation-settings";

});


parcelRegister("2NSbF", function(module, exports) {
$parcel$export(module.exports, "IdentityUserAri", () => $20aa30d2bf848e8f$export$1e9d09c2be53e55e);

var $200Ah = parcelRequire("200Ah");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/identity/user/manifest.ts
var $20aa30d2bf848e8f$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $200Ah.IdentityUserAriResourceOwner),
    resourceType: (0, $200Ah.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $20aa30d2bf848e8f$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $20aa30d2bf848e8f$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $20aa30d2bf848e8f$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $20aa30d2bf848e8f$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $20aa30d2bf848e8f$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $20aa30d2bf848e8f$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $20aa30d2bf848e8f$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
};

});
parcelRegister("200Ah", function(module, exports) {
$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $174c08d8cfa575c4$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $174c08d8cfa575c4$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $174c08d8cfa575c4$export$b4c14c54282a779d = "identity", $174c08d8cfa575c4$export$e9b50e20f4fbfb71 = "user";

});


parcelRegister("c1zHX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e7f49666e75cd13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c0b573960f9a5e2e973596b02ba6a20c>>
 * @relayHash 9326633a33cb342f866254dba4746e6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4049555abdda8d1eb636d943b68c96a9d803ead368e6d0be1173c00a117c10bd

var $e8Yi7 = parcelRequire("e8Yi7");

var $25bhx = parcelRequire("25bhx");

var $fpAD9 = parcelRequire("fpAD9");

var $kSjiz = parcelRequire("kSjiz");

var $1ezSH = parcelRequire("1ezSH");

var $fT916 = parcelRequire("fT916");
const $9e7f49666e75cd13$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriApps"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriPlans"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriRoadmaps"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriUserSideNavSettings"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchGlobalShortcutsAvailableProducts"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRoadmapUpsellEnabled"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navPlatMenuDataEntityAri"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navPlatSidebarDataEntityAri"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v16 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v17 = [
        {
            "concreteType": "SettingsMenuItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "menuId"
                },
                {
                    "kind": "ScalarField",
                    "name": "visible"
                }
            ]
        }
    ], v18 = {
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v19 = [
        {
            "concreteType": "SettingsDisplayProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "__relay_internal__pv__getpagesizevaluerelayproviderts"
        }
    ], v22 = [
        {
            "args": v21 /*: any*/ ,
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": v17 /*: any*/ 
        },
        {
            "args": v21 /*: any*/ ,
            "concreteType": "SettingsDisplayPropertyConnection",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": v19 /*: any*/ 
        },
        v20 /*: any*/ 
    ], v23 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v24 = [
        v23 /*: any*/ 
    ], v25 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v27 = {
        "kind": "ScalarField",
        "name": "label"
    }, v28 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v29 = {
        "kind": "ScalarField",
        "name": "url"
    }, v30 = {
        "order": "DESC"
    }, v31 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v32 = {
        "kind": "ScalarField",
        "name": "title"
    }, v33 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v34 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v20 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v36 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v26 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v20 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "collectionId"
                        },
                        v32 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "emoji"
                        },
                        v34 /*: any*/ 
                    ],
                    "type": "JiraProductDiscoveryCollection"
                },
                v35 /*: any*/ 
            ]
        }
    ], v37 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v38 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v39 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v40 = [
        v18 /*: any*/ ,
        v20 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v42 = {
        "kind": "ScalarField",
        "name": "name"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v44 = [
        v20 /*: any*/ ,
        v42 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ], v45 = [
        v29 /*: any*/ 
    ], v46 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v26 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v20 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        v32 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        v34 /*: any*/ ,
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v26 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v45 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v35 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v35 /*: any*/ 
            ]
        }
    ], v47 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v48 = {
        "kind": "ScalarField",
        "name": "status"
    }, v49 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v50 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v52 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v45 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v35 /*: any*/ 
        ]
    }, v53 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v54 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v55 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v56 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v57 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": "subspaceCount",
                        "kind": "ScalarField",
                        "name": "subspaceCount_cse"
                    }
                ]
            }
        ]
    }, v58 = [
        v20 /*: any*/ ,
        v47 /*: any*/ ,
        v48 /*: any*/ ,
        v49 /*: any*/ ,
        v50 /*: any*/ ,
        v42 /*: any*/ ,
        v51 /*: any*/ ,
        v33 /*: any*/ ,
        v52 /*: any*/ ,
        v53 /*: any*/ ,
        v54 /*: any*/ ,
        v55 /*: any*/ ,
        v56 /*: any*/ ,
        v57 /*: any*/ 
    ], v59 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v58 /*: any*/ 
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GSNQueryPreloaderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "GSNForContentSidebarEntryPoint"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GSNForOtherSidebars"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v9 /*: any*/ ,
                v14 /*: any*/ ,
                v13 /*: any*/ ,
                v15 /*: any*/ ,
                v12 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__getpagesizevaluerelayproviderts"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx"
                }
            ],
            "kind": "Operation",
            "name": "GSNQueryPreloaderQuery",
            "selections": [
                {
                    "alias": "userSideNavSettings",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriUserSideNavSettings"
                        },
                        v16 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ ,
                        {
                            "concreteType": "SettingsDisplayPropertyConnection",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v19 /*: any*/ 
                        },
                        v20 /*: any*/ 
                    ]
                },
                {
                    "alias": "navPlatL1MenuData",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "navPlatMenuDataEntityAri"
                        },
                        v16 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                },
                {
                    "alias": "navPlatSidebarData",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "navPlatSidebarDataEntityAri"
                        },
                        v16 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v28 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v29 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsFiltersExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsProjectsExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v23 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "alias": "roadmapFavourites",
                            "args": [
                                v23 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": v30 /*: any*/ ,
                                        "type": "JPD_COLLECTION"
                                    }
                                },
                                v31 /*: any*/ 
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v36 /*: any*/ 
                                },
                                v37 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "roadmapRecents",
                            "args": [
                                v23 /*: any*/ ,
                                v38 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "JPD_COLLECTION"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v36 /*: any*/ 
                                },
                                v37 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsPlansExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v24 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isRoadmapUpsellEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "accountId",
                                            "variableName": "ownerAri"
                                        },
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "propertyKey",
                                            "value": "jpd-roadmaps-upsell.dismissed"
                                        }
                                    ],
                                    "concreteType": "JiraEntityPropertyString",
                                    "kind": "LinkedField",
                                    "name": "stringUserProperty",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "stringValue"
                                        },
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "fetchGlobalShortcutsAvailableProducts",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v24 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "appSwitcher_availableProductsBySite",
                            "plural": false,
                            "selections": [
                                v26 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "products",
                                            "plural": true,
                                            "selections": [
                                                v26 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ],
                                                    "type": "AppSwitcherSingleUrlProduct"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "concreteType": "AppSwitcherProductSite",
                                                            "kind": "LinkedField",
                                                            "name": "sites",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "siteId"
                                                                },
                                                                v29 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "AppSwitcherSiteScopedProduct"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "AppSwitcherAvailableProductsBySite"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAppsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "appsOrder",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "entityAri",
                                    "variableName": "entityAriApps"
                                },
                                v16 /*: any*/ 
                            ],
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v30 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v31 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v35 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v37 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v23 /*: any*/ ,
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        v43 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v35 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v37 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "filtersOrder",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "entityAri",
                                    "variableName": "entityAriFilters"
                                },
                                v16 /*: any*/ 
                            ],
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "starred",
                                            "plural": true,
                                            "selections": v44 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v44 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v44 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v30 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v31 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v46 /*: any*/ 
                                        },
                                        v37 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v23 /*: any*/ ,
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v46 /*: any*/ 
                                        },
                                        v37 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "plansOrder",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "entityAri",
                                    "variableName": "entityAriPlans"
                                },
                                v16 /*: any*/ 
                            ],
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v24 /*: any*/ ,
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v58 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v42 /*: any*/ ,
                                        v51 /*: any*/ ,
                                        v52 /*: any*/ ,
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        v55 /*: any*/ ,
                                        v56 /*: any*/ ,
                                        v57 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v31 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v59 /*: any*/ ,
                                        v37 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v38 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": [
                                        v59 /*: any*/ ,
                                        v37 /*: any*/ 
                                    ],
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v20 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "roadmapsOrder",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "entityAri",
                                    "variableName": "entityAriRoadmaps"
                                },
                                v16 /*: any*/ 
                            ],
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4049555abdda8d1eb636d943b68c96a9d803ead368e6d0be1173c00a117c10bd",
            "metadata": {},
            "name": "GSNQueryPreloaderQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__getpagesizevaluerelayproviderts": (0, $e8Yi7.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $1ezSH.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $fpAD9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": (0, $25bhx.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $fT916.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx": (0, $kSjiz.default)
            }
        }
    };
}();
$9e7f49666e75cd13$var$node.hash = "e04e7f9dcdc7a54e32514670e5989064";
var $9e7f49666e75cd13$export$2e2bcd8739ae039 = $9e7f49666e75cd13$var$node;

});
parcelRegister("e8Yi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $da7ed56708de7e8b$export$2e2bcd8739ae039);
// Query page size for navigation items
// This is a COPY of packages/navigation/global-side-navigation/src/common/constants.ts
const $da7ed56708de7e8b$export$5716e8bcb003888d = 100;
var $da7ed56708de7e8b$export$2e2bcd8739ae039 = {
    get () {
        return $da7ed56708de7e8b$export$5716e8bcb003888d;
    }
};

});

parcelRegister("25bhx", function(module, exports) {
$parcel$export(module.exports, "default", () => $7df3d164ac8a95e0$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $7df3d164ac8a95e0$var$JsmEnableActionMenuAddPeopleSpotlightIdRelayProvider = {
    get () {
        return (0, $i860n.fg)('jsm_enable_action-menu-add-people-spotlight-id');
    }
};
var $7df3d164ac8a95e0$export$2e2bcd8739ae039 = $7df3d164ac8a95e0$var$JsmEnableActionMenuAddPeopleSpotlightIdRelayProvider;

});

parcelRegister("fpAD9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d2f188932190fa1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $aJDWs = parcelRequire("aJDWs");
var $7d2f188932190fa1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $aJDWs.isProjectsInJiraM2Enabled)();
    }
};

});

parcelRegister("kSjiz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8600ed717448654$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $a8600ed717448654$var$isJpdRoadmapsRecentsEnabled = {
    get () {
        return (0, $i860n.fg)('jpd-enable-roadmaps-recents-fe');
    }
};
var $a8600ed717448654$export$2e2bcd8739ae039 = $a8600ed717448654$var$isJpdRoadmapsRecentsEnabled;

});

parcelRegister("1ezSH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad67d8d002fc7b64$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $ad67d8d002fc7b64$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('allow_end_users_to_access_custom_templates');
    }
};

});

parcelRegister("fT916", function(module, exports) {
$parcel$export(module.exports, "default", () => $64432bdc9ca9b8fb$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $64432bdc9ca9b8fb$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jsm_aiiy_for_nav_item_sidebar');
    }
};

});



parcelRegister("3tHVQ", function(module, exports) {
$parcel$export(module.exports, "sidebarNav4Resource", () => $8e10782b8905f14f$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarEntryUiStateResource", () => $8e10782b8905f14f$export$b1f2e154e7288dba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $kZ1Cr = parcelRequire("kZ1Cr");

var $5IkoH = parcelRequire("5IkoH");

var $bkBsT = parcelRequire("bkBsT");

var $aK5Al = parcelRequire("aK5Al");

var $htsFl = parcelRequire("htsFl");

var $bZhC2 = parcelRequire("bZhC2");

var $2NSbF = parcelRequire("2NSbF");

var $i860n = parcelRequire("i860n");

var $7Cxzw = parcelRequire("7Cxzw");
const $8e10782b8905f14f$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $8e10782b8905f14f$export$7648dc6f76f4f83d = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${$8e10782b8905f14f$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const initialSelectedPath = (0, $bkBsT.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $7Cxzw.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_APPS)),
                isFiltersExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_OPERATIONS)),
                entityAriFilters: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'filters'
                }).toString(),
                entityAriApps: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'apps'
                }).toString(),
                entityAriPlans: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'plans'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $2NSbF.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString(),
                isAnonymous: isAnonymous,
                isRoadmapUpsellEnabled: (0, $i860n.fg)('jpd-roadmaps-in-jira')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});
const $8e10782b8905f14f$export$b1f2e154e7288dba = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_SIDEBAR_ENTRY_UI_STATE_RELAY`,
    // oxlint-disable-next-line no-explicit-any
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $kZ1Cr.default),
            variables: {
                cloudId: cloudId,
                isSkipped: (0, $i860n.fg)('navx-global-side-nav')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("kZ1Cr", function(module, exports) {
$parcel$export(module.exports, "default", () => $af4e608c01d24387$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df8975edc6a95699766c219153934e33>>
 * @relayHash 9009ab4bb003c0459c2cba07315e1bc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bb284ff808561eda6128044dee841ec03fef5f2c5d2d899e6db8b5360e3d04e
const $af4e608c01d24387$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSkipped"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SidebarEntryNavigationUIStateQuery",
            "selections": [
                {
                    "condition": "isSkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SidebarEntryNavigationUIStateQuery",
            "selections": [
                {
                    "condition": "isSkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4bb284ff808561eda6128044dee841ec03fef5f2c5d2d899e6db8b5360e3d04e",
            "metadata": {},
            "name": "SidebarEntryNavigationUIStateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$af4e608c01d24387$var$node.hash = "4d82a3dc44121fcaa8a9d81d1eb197ad";
var $af4e608c01d24387$export$2e2bcd8739ae039 = $af4e608c01d24387$var$node;

});

parcelRegister("7Cxzw", function(module, exports) {
$parcel$export(module.exports, "default", () => $5472bed1609a0601$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba4a67b9f1437011af7c6c324371d804>>
 * @relayHash 0ed1b9cf5f7e0ff2ee5c14a3c293a76b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 61e76570610758f3316b9249962969d0d11c98b3f11f004c3374d8b8980b5803

var $25bhx = parcelRequire("25bhx");

var $fpAD9 = parcelRequire("fpAD9");

var $kSjiz = parcelRequire("kSjiz");

var $1ezSH = parcelRequire("1ezSH");

var $fT916 = parcelRequire("fT916");
const $5472bed1609a0601$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriApps"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriPlans"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriRoadmaps"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRoadmapUpsellEnabled"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v13 = {
        "kind": "ScalarField",
        "name": "menuId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "label"
    }, v20 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v21 = {
        "kind": "ScalarField",
        "name": "url"
    }, v22 = {
        "order": "DESC"
    }, v23 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v24 = {
        "kind": "ScalarField",
        "name": "title"
    }, v25 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v26 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v28 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "collectionId"
                        },
                        v24 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "emoji"
                        },
                        v26 /*: any*/ 
                    ],
                    "type": "JiraProductDiscoveryCollection"
                },
                v27 /*: any*/ 
            ]
        }
    ], v29 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v30 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v31 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v32 = {
        "kind": "ScalarField",
        "name": "status"
    }, v33 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v34 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "name"
    }, v36 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v37 = [
        v21 /*: any*/ 
    ], v38 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v37 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v27 /*: any*/ 
        ]
    }, v39 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v40 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v41 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v42 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v43 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": "subspaceCount",
                        "kind": "ScalarField",
                        "name": "subspaceCount_cse"
                    }
                ]
            }
        ]
    }, v44 = [
        v14 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v25 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v41 /*: any*/ ,
        v42 /*: any*/ ,
        v43 /*: any*/ 
    ], v45 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v44 /*: any*/ 
            }
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v18 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v14 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v48 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v49 = [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v13 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        },
        v14 /*: any*/ 
    ], v50 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        v24 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        v26 /*: any*/ ,
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v37 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v27 /*: any*/ 
            ]
        }
    ], v51 = [
        v14 /*: any*/ ,
        v35 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ConfigurableMenuItems"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v8 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v12 /*: any*/ ,
                v5 /*: any*/ ,
                v11 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx"
                }
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudID",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "navKey",
                                            "value": "NAV_SIDEBAR"
                                        }
                                    ],
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraConfigurableNavigationItem",
                                            "kind": "LinkedField",
                                            "name": "navItems",
                                            "plural": true,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVisible"
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isProjectsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsProjectsExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "shouldDisplay",
                                            "args": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isFiltersExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsFiltersExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isAppsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v16 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "globalAppNavigationItems",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v19 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appType"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "settingsUrl"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "roadmapFavourites",
                                    "args": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v22 /*: any*/ ,
                                                "type": "JPD_COLLECTION"
                                            }
                                        },
                                        v23 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v28 /*: any*/ 
                                        },
                                        v29 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "roadmapRecents",
                                    "args": [
                                        v15 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "JPD_COLLECTION"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v28 /*: any*/ 
                                        },
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isPlansExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsPlansExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                                    "kind": "LinkedField",
                                    "name": "advancedRoadmapsNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasEditPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasCreateSamplePlanPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasGlobalPlansAdminPermissions"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v16 /*: any*/ ,
                                            "concreteType": "JiraWorkManagementLicensing",
                                            "kind": "LinkedField",
                                            "name": "jwmLicensing",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "currentUserSeatEdition"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecent",
                                            "plural": false,
                                            "selections": v44 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecentFromHistory",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                v43 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v23 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v29 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v30 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": [
                                                v45 /*: any*/ ,
                                                v29 /*: any*/ 
                                            ],
                                            "storageKey": "recents(first:20)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "favouriteLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "recentLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayMode"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteFilters",
                                            "args": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v22 /*: any*/ ,
                                                        "type": "FILTER"
                                                    }
                                                },
                                                v23 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        v46 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v47 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentFilters",
                                            "args": [
                                                v15 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "FILTER"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v25 /*: any*/ ,
                                                                                v47 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraFilter",
                                                                            "abstractKey": "__isJiraFilter"
                                                                        }
                                                                    ],
                                                                    "type": "JiraCustomFilter"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v16 /*: any*/ ,
                                            "concreteType": "JiraSystemFilterConnection",
                                            "kind": "LinkedField",
                                            "name": "systemFilters",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilterEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSystemFilter",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v47 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "filtersOrder",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriFilters"
                                        },
                                        v48 /*: any*/ 
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": v49 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouritePlans",
                                            "args": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v22 /*: any*/ ,
                                                        "type": "PLAN"
                                                    }
                                                },
                                                v23 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v50 /*: any*/ 
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentPlans",
                                            "args": [
                                                v15 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "PLAN"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v50 /*: any*/ 
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "plansOrder",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriPlans"
                                        },
                                        v48 /*: any*/ 
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": v49 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "appsOrder",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriApps"
                                        },
                                        v48 /*: any*/ 
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": v49 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "isOperationsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieQuery",
                                    "kind": "LinkedField",
                                    "name": "opsgenie",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v16 /*: any*/ ,
                                            "concreteType": "OpsgenieSavedSearches",
                                            "kind": "LinkedField",
                                            "name": "savedSearches",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "starred",
                                                    "plural": true,
                                                    "selections": v51 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "sharedWithMe",
                                                    "plural": true,
                                                    "selections": v51 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "createdByMe",
                                                    "plural": true,
                                                    "selections": v51 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "roadmapsOrder",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriRoadmaps"
                                        },
                                        v48 /*: any*/ 
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": v49 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "isRoadmapUpsellEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "accountId",
                                                    "variableName": "ownerAri"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "propertyKey",
                                                    "value": "jpd-roadmaps-upsell.dismissed"
                                                }
                                            ],
                                            "concreteType": "JiraEntityPropertyString",
                                            "kind": "LinkedField",
                                            "name": "stringUserProperty",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "stringValue"
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "61e76570610758f3316b9249962969d0d11c98b3f11f004c3374d8b8980b5803",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $1ezSH.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $fpAD9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": (0, $25bhx.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $fT916.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx": (0, $kSjiz.default)
            }
        }
    };
}();
$5472bed1609a0601$var$node.hash = "aee78ecbeb949c9d5475f3964d54649e";
var $5472bed1609a0601$export$2e2bcd8739ae039 = $5472bed1609a0601$var$node;

});


parcelRegister("iFmc7", function(module, exports) {
$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $f2b28d7a7c984760$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $f2b28d7a7c984760$export$2d5a704ae6f6b050);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $fpjIq = parcelRequire("fpjIq");
const $f2b28d7a7c984760$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $f2b28d7a7c984760$export$e4bf33528101348c = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>$f2b28d7a7c984760$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $f2b28d7a7c984760$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $fpjIq.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $f2b28d7a7c984760$export$2d5a704ae6f6b050 = ()=>(0, $k6ufm.useResource)($f2b28d7a7c984760$export$e4bf33528101348c);

});
parcelRegister("fpjIq", function(module, exports) {
$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $99d66a22d26a4061$export$b15f9f5cf6db359e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $99d66a22d26a4061$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("hEjfV", function(module, exports) {
$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $6069c1dca9b3f6f8$export$e7e6c1b9d8d5ea7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $7edbf = parcelRequire("7edbf");

var $gOgV5 = parcelRequire("gOgV5");
const $6069c1dca9b3f6f8$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $6069c1dca9b3f6f8$export$e7e6c1b9d8d5ea7 = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match })=>$6069c1dca9b3f6f8$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $gOgV5.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("gOgV5", function(module, exports) {
$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $b9a4d9dc2df27da7$export$a49729698cfc5310);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $b9a4d9dc2df27da7$var$requestSideBarInfo = (planId, scenarioId)=>(0, $h2wCv.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $b9a4d9dc2df27da7$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $b9a4d9dc2df27da7$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("5mMCG", function(module, exports) {
$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $cb2692bab8e860db$export$5839dd8142de842e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8S1Gc = parcelRequire("8S1Gc");

var $6CfY5 = parcelRequire("6CfY5");

var $7edbf = parcelRequire("7edbf");

var $89zJM = parcelRequire("89zJM");
const $cb2692bab8e860db$export$5839dd8142de842e = (0, $7edbf.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8S1Gc.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8S1Gc.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $89zJM.fetchUserBoardNavigationData)(boardId);
            return response;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("8S1Gc", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $03960f7c3aed5593$export$557c2f222778cea6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $03960f7c3aed5593$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("89zJM", function(module, exports) {
$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $a053a2773fabb588$export$306fb49fca60b34);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $a053a2773fabb588$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("hFYSn", function(module, exports) {
$parcel$export(module.exports, "forgeAdminModuleResource", () => $df04ebf59eda0adf$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $df04ebf59eda0adf$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $df04ebf59eda0adf$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $df04ebf59eda0adf$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $df04ebf59eda0adf$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $df04ebf59eda0adf$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $df04ebf59eda0adf$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $df04ebf59eda0adf$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $df04ebf59eda0adf$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $df04ebf59eda0adf$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $df04ebf59eda0adf$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $df04ebf59eda0adf$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $df04ebf59eda0adf$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $df04ebf59eda0adf$export$e6be2f0ca0849869);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fLTsc = parcelRequire("fLTsc");

var $kIxv5 = parcelRequire("kIxv5");

var $aHmTX = parcelRequire("aHmTX");

var $A82xh = parcelRequire("A82xh");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $aaubd = parcelRequire("aaubd");
const $df04ebf59eda0adf$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $aHmTX.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $aHmTX.CUSTOMER_SERVICE_MANAGEMENT_QUEUE_PAGE_MODULE),
        (0, $aHmTX.PROJECT_PAGE_MODULE),
        (0, $aHmTX.PROJECT_SETTINGS_PAGE_MODULE)
    ] // oxlint-disable-next-line typescript/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $fLTsc.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $df04ebf59eda0adf$export$b9489d8c5c5e3626 = (0, $7edbf.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    // oxlint-disable-next-line no-explicit-any
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.ADMIN_PAGE_MODULE], (0, $aaubd.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$dcc98f4b36ce9223 = ()=>[
        $df04ebf59eda0adf$export$b9489d8c5c5e3626
    ];
const $df04ebf59eda0adf$export$72db683c2914a65e = (0, $7edbf.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.PROJECT_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $df04ebf59eda0adf$export$7523db37432ba090 = (0, $7edbf.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_ROUTER)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.BACKLOG_ACTION_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$cfd99f451b423d3a = (0, $7edbf.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_ROUTER)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.BOARD_ACTION_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$7b639f33f086f9f1 = (0, $7edbf.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_ROUTER)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.SPRINT_ACTION_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$8a5aed164e925eb6 = (0, $7edbf.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.PERSONAL_SETTINGS_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$ec3265610584f9ce = ()=>[
        $df04ebf59eda0adf$export$8a5aed164e925eb6
    ];
const $df04ebf59eda0adf$export$7a928d209faf75f = (0, $7edbf.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.PROJECT_SETTINGS_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $df04ebf59eda0adf$export$e81e11bbc3239153 = ()=>(0, $k6ufm.useResource)($df04ebf59eda0adf$export$7a928d209faf75f);
const $df04ebf59eda0adf$export$97b0827022fdafe3 = (0, $7edbf.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.GLOBAL_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$80b2f91dabb3dd65 = ()=>[
        $df04ebf59eda0adf$export$97b0827022fdafe3
    ];
const $df04ebf59eda0adf$export$ebf5369e4dcfad00 = (0, $7edbf.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$e6be2f0ca0849869 = (0, $7edbf.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_NAVIGATION)
        }).then(// oxlint-disable-next-line typescript/consistent-type-assertions
        (modules)=>modules[0, $aHmTX.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $df04ebf59eda0adf$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $kIxv5.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("kIxv5", function(module, exports) {
$parcel$export(module.exports, "alphabeticalSort", () => $613bd8b41bbd57c4$export$89a1f01f2a7cb2a1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");
const $613bd8b41bbd57c4$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $6CfY5.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("aHmTX", function(module, exports) {
$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $ff63b09d5a67ee89$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $ff63b09d5a67ee89$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $ff63b09d5a67ee89$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $ff63b09d5a67ee89$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $ff63b09d5a67ee89$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $ff63b09d5a67ee89$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $ff63b09d5a67ee89$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $ff63b09d5a67ee89$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $ff63b09d5a67ee89$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $ff63b09d5a67ee89$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $ff63b09d5a67ee89$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $ff63b09d5a67ee89$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $ff63b09d5a67ee89$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $ff63b09d5a67ee89$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $ff63b09d5a67ee89$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $ff63b09d5a67ee89$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $ff63b09d5a67ee89$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $ff63b09d5a67ee89$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $ff63b09d5a67ee89$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $ff63b09d5a67ee89$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $ff63b09d5a67ee89$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $ff63b09d5a67ee89$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $ff63b09d5a67ee89$export$353acf28daa75c79);
$parcel$export(module.exports, "GLOBAL_BACKGROUND_SCRIPT_MODULE", () => $ff63b09d5a67ee89$export$4384c2fafce7b6f1);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $ff63b09d5a67ee89$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $ff63b09d5a67ee89$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $ff63b09d5a67ee89$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $ff63b09d5a67ee89$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $ff63b09d5a67ee89$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $ff63b09d5a67ee89$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $ff63b09d5a67ee89$export$842eb4236828ac9);
$parcel$export(module.exports, "CUSTOMER_SERVICE_MANAGEMENT_QUEUE_PAGE_MODULE", () => $ff63b09d5a67ee89$export$b900a1f2aedd7046);
$parcel$export(module.exports, "CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE", () => $ff63b09d5a67ee89$export$f9b837fd8b10f776);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $ff63b09d5a67ee89$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $ff63b09d5a67ee89$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $ff63b09d5a67ee89$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $ff63b09d5a67ee89$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $ff63b09d5a67ee89$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $ff63b09d5a67ee89$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $ff63b09d5a67ee89$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $ff63b09d5a67ee89$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $ff63b09d5a67ee89$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $ff63b09d5a67ee89$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $ff63b09d5a67ee89$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $ff63b09d5a67ee89$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $ff63b09d5a67ee89$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $ff63b09d5a67ee89$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $ff63b09d5a67ee89$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $ff63b09d5a67ee89$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $ff63b09d5a67ee89$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $ff63b09d5a67ee89$export$d719bb340dc354e4);
$parcel$export(module.exports, "SOURCE_GLOBAL_EXTENSIONS", () => $ff63b09d5a67ee89$export$e29a293ebc8123e3);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $ff63b09d5a67ee89$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $ff63b09d5a67ee89$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $ff63b09d5a67ee89$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CSM", () => $ff63b09d5a67ee89$export$3b981417f94a136f);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $ff63b09d5a67ee89$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $ff63b09d5a67ee89$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $ff63b09d5a67ee89$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $ff63b09d5a67ee89$export$51ab2784839ce348);
/* eslint-disable jira/filename-case */ const $ff63b09d5a67ee89$export$9af0088c49bdedb = 'PRODUCTION';
const $ff63b09d5a67ee89$export$71acbd662c478c42 = 'STAGING';
const $ff63b09d5a67ee89$export$978072fd3fd149 = 'DEVELOPMENT';
const $ff63b09d5a67ee89$export$ebc15d9cebfd6063 = 'default';
const $ff63b09d5a67ee89$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $ff63b09d5a67ee89$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $ff63b09d5a67ee89$export$cfb15d127f20a01f = 'jira:sprintAction';
const $ff63b09d5a67ee89$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $ff63b09d5a67ee89$export$65ebd2e1f63d2992 = 'jira:command';
const $ff63b09d5a67ee89$export$259bab989b0129d0 = 'jira:issueGlance';
const $ff63b09d5a67ee89$export$75f224942f595e13 = 'jira:issueContext';
const $ff63b09d5a67ee89$export$ba0968f9752844 = 'jira:issuePanel';
const $ff63b09d5a67ee89$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $ff63b09d5a67ee89$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $ff63b09d5a67ee89$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $ff63b09d5a67ee89$export$811b7f067a43b422 = 'jira:uiModifications';
const $ff63b09d5a67ee89$export$e3887d6bafe8a17 = 'jira:customField';
const $ff63b09d5a67ee89$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $ff63b09d5a67ee89$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $ff63b09d5a67ee89$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $ff63b09d5a67ee89$export$151b03356f566603 = 'jira:projectPage';
const $ff63b09d5a67ee89$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $ff63b09d5a67ee89$export$31ac745ab2add7cc = 'jira:globalPage';
const $ff63b09d5a67ee89$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $ff63b09d5a67ee89$export$4384c2fafce7b6f1 = 'jira:globalBackgroundScript';
const $ff63b09d5a67ee89$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $ff63b09d5a67ee89$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $ff63b09d5a67ee89$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $ff63b09d5a67ee89$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $ff63b09d5a67ee89$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $ff63b09d5a67ee89$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $ff63b09d5a67ee89$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $ff63b09d5a67ee89$export$b900a1f2aedd7046 = 'customerServiceManagement:queuePage';
const $ff63b09d5a67ee89$export$f9b837fd8b10f776 = 'customerServiceManagement:crmImport';
const $ff63b09d5a67ee89$export$9b1a91242ce2a1b7 = [
    $ff63b09d5a67ee89$export$516a8fb49ad5d50e,
    $ff63b09d5a67ee89$export$65ebd2e1f63d2992,
    $ff63b09d5a67ee89$export$6cc3a1f2111dee11,
    $ff63b09d5a67ee89$export$cfb15d127f20a01f,
    $ff63b09d5a67ee89$export$fcc4a18f46f80f16,
    $ff63b09d5a67ee89$export$259bab989b0129d0,
    $ff63b09d5a67ee89$export$75f224942f595e13,
    $ff63b09d5a67ee89$export$7e2136b4285d29f5,
    $ff63b09d5a67ee89$export$ba0968f9752844,
    $ff63b09d5a67ee89$export$cc20a5638825fbb0,
    $ff63b09d5a67ee89$export$9069d4b945c3d532,
    $ff63b09d5a67ee89$export$811b7f067a43b422,
    $ff63b09d5a67ee89$export$e3887d6bafe8a17,
    $ff63b09d5a67ee89$export$7b7866c04a2ad947,
    $ff63b09d5a67ee89$export$52e4945e96bd2aa0,
    $ff63b09d5a67ee89$export$a8cd23a3cbda9d58,
    $ff63b09d5a67ee89$export$151b03356f566603,
    $ff63b09d5a67ee89$export$ea0d6ac082b0d636,
    $ff63b09d5a67ee89$export$31ac745ab2add7cc,
    $ff63b09d5a67ee89$export$353acf28daa75c79,
    $ff63b09d5a67ee89$export$25627f012b21b0b9,
    $ff63b09d5a67ee89$export$8af4cb794979f60d,
    $ff63b09d5a67ee89$export$b900a1f2aedd7046,
    $ff63b09d5a67ee89$export$f9b837fd8b10f776,
    $ff63b09d5a67ee89$export$5592ab836d562168,
    $ff63b09d5a67ee89$export$842eb4236828ac9,
    $ff63b09d5a67ee89$export$42d6a8740fd42e58,
    $ff63b09d5a67ee89$export$a7186e5a73395db4,
    $ff63b09d5a67ee89$export$8fbcfe84dc845d17,
    $ff63b09d5a67ee89$export$4384c2fafce7b6f1
];
const $ff63b09d5a67ee89$export$2b8aeda236486576 = 'edit';
const $ff63b09d5a67ee89$export$c41ce1ec1ea6e73d = 'view';
const $ff63b09d5a67ee89$export$b37d58c3ed77c139 = 'create';
const $ff63b09d5a67ee89$export$ab94dbd1d02ac251 = 'contextConfig';
const $ff63b09d5a67ee89$export$b6a67a3131c6c48d = 'none';
const $ff63b09d5a67ee89$export$b75dc2bfd20898fe = 5;
const $ff63b09d5a67ee89$export$8e96118a698216cb = 'native';
const $ff63b09d5a67ee89$export$9b72a8e9b92658fb = 'basic';
const $ff63b09d5a67ee89$export$2d6539e7d0553ae7 = 'blank';
const $ff63b09d5a67ee89$export$ecbd7135d66cb322 = 'unknownSource';
const $ff63b09d5a67ee89$export$61d882aa7aba51c = 'global-issue-create';
const $ff63b09d5a67ee89$export$46cb92762d68a048 = 'issue-view';
const $ff63b09d5a67ee89$export$fe90e46aea58e30b = 'navigation';
const $ff63b09d5a67ee89$export$c5ccbdb9893f2a6a = 'full-page-app';
const $ff63b09d5a67ee89$export$eae46a3c13473a8d = 'router';
const $ff63b09d5a67ee89$export$ac11ee191d09688f = 'legacy';
const $ff63b09d5a67ee89$export$4346e4e240c84319 = 'organization-panel';
const $ff63b09d5a67ee89$export$d719bb340dc354e4 = 'assets-import-type';
const $ff63b09d5a67ee89$export$e29a293ebc8123e3 = 'global-extensions';
const $ff63b09d5a67ee89$export$4b6228758e800433 = 'jira';
const $ff63b09d5a67ee89$export$70495c8cc141a7a4 = 'jsm';
const $ff63b09d5a67ee89$export$bc3d408418fdf9d2 = 'cmdb';
const $ff63b09d5a67ee89$export$3b981417f94a136f = 'csm';
const $ff63b09d5a67ee89$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    customerServiceManagementQueuePage: [],
    customerServiceManagementCrmImport: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: [],
    jiraGlobalBackgroundScript: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $ff63b09d5a67ee89$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$ff63b09d5a67ee89$export$a48dade1864725a
};
const $ff63b09d5a67ee89$export$218a328f66b86f7d = ()=>({
        ...$ff63b09d5a67ee89$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $ff63b09d5a67ee89$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $ff63b09d5a67ee89$export$df7774a415710cce = 'com.atlassian.forge:';
const $ff63b09d5a67ee89$export$51ab2784839ce348 = `${$ff63b09d5a67ee89$export$df7774a415710cce}${$ff63b09d5a67ee89$export$3193d714ab54ee26}`;

});

parcelRegister("A82xh", function(module, exports) {
$parcel$export(module.exports, "fetchModules", () => $e5591989ed7509da$export$24d8e11b15325c53);

var $7BEjM = parcelRequire("7BEjM");

var $n67Vb = parcelRequire("n67Vb");

var $0Us5k = parcelRequire("0Us5k");

var $l64dz = parcelRequire("l64dz");

var $lz4O3 = parcelRequire("lz4O3");

var $5iMdl = parcelRequire("5iMdl");

var $aHmTX = parcelRequire("aHmTX");

var $aI7em = parcelRequire("aI7em");

var $4wDMb = parcelRequire("4wDMb");

var $5UxXz = parcelRequire("5UxXz");

var $bh8EG = parcelRequire("bh8EG");
const $e5591989ed7509da$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, source: source = (0, $aHmTX.SOURCE_UNKNOWN) } = params;
    if (!(0, $4wDMb.canFetchForgeModules)({
        cloudId: cloudId
    })) return (0, $5UxXz.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $l64dz.measureExecutionTimeMetrics)(()=>$e5591989ed7509da$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $lz4O3.FORGE_SAMPLING_RATE)) (0, $5iMdl.fireInitializationFetchFinishedEvent)(source);
        return (0, $5UxXz.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $0Us5k.getErrorType)(error);
        (0, $5iMdl.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($e5591989ed7509da$export$458cbcb6374269d2.includes(errorType)) return (0, $5UxXz.toMappedExtensions)(types, []);
        throw error;
    }
};
function $e5591989ed7509da$export$9f9fdbce0829073d(props) {
    // includeScopes is true by default to enable decoupling scopes from forge app
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = true } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $7BEjM.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $bh8EG.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $7BEjM.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                // oxlint-disable-next-line typescript/consistent-type-assertions
                const responseExtensions = response.jira?.forge?.extensions;
                extensions = responseExtensions?.concat().map((ext)=>({
                        ...ext,
                        moduleId: ext.moduleId ?? null
                    })) || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $e5591989ed7509da$export$458cbcb6374269d2 = [
    (0, $0Us5k.FAILED_TO_FETCH),
    (0, $0Us5k.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $0Us5k.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("7BEjM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c405c00ed2ad545$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9cb9fc7f62f506f9cf4cd4db01ae3f8>>
 * @relayHash 8383cbbd005e5e1490a936a0bd3be323
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad70478e3f5086c7ec25ad7789c1120e0d47807a62ed2bf0cd99feab932f4845
const $6c405c00ed2ad545$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "concreteType": "JiraUserAppAccess",
                                    "kind": "LinkedField",
                                    "name": "userAccess",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasAccess"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "ad70478e3f5086c7ec25ad7789c1120e0d47807a62ed2bf0cd99feab932f4845",
            "metadata": {},
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c405c00ed2ad545$var$node.hash = "288e42a4ff5a1ea53eaacf3efbacf31a";
var $6c405c00ed2ad545$export$2e2bcd8739ae039 = $6c405c00ed2ad545$var$node;

});

parcelRegister("0Us5k", function(module, exports) {
$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $cce82b8ad97a481b$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $cce82b8ad97a481b$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $cce82b8ad97a481b$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $cce82b8ad97a481b$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $cce82b8ad97a481b$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $cce82b8ad97a481b$export$e19f9f08a6d79fd2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $lCetP = parcelRequire("lCetP");

var $flXCN = parcelRequire("flXCN");

var $8dImz = parcelRequire("8dImz");
const $cce82b8ad97a481b$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $cce82b8ad97a481b$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $cce82b8ad97a481b$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $cce82b8ad97a481b$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $cce82b8ad97a481b$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $cce82b8ad97a481b$export$89a175d4190df42e = 'Invoke value functions failed:';
const $cce82b8ad97a481b$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $cce82b8ad97a481b$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $8dImz.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $cce82b8ad97a481b$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $cce82b8ad97a481b$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    // Tracked GraphQL errors contain useful info about internal errors like status codes
    // We want to categorize them more precisely, because some error types aren't SLO critical.
    if (error instanceof (0, $flXCN.TrackedGraphQLError)) {
        if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $cce82b8ad97a481b$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
        return 'TRACKED_GRAPHQL_ERROR';
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $cce82b8ad97a481b$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.') || /Extension ".*" could not be invoked as it does not reference a function or an endpoint/i.test(message)) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($cce82b8ad97a481b$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($cce82b8ad97a481b$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $8f860a533cc71fca$export$9de493bcd9b1d977);
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $8f860a533cc71fca$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $cce82b8ad97a481b$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($cce82b8ad97a481b$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    if (isTimeoutError('NAVIGATION_SIDEBAR_JIRA_PROJECT')) return 'TIMEOUT_NAVIGATION_SIDEBAR_JIRA_PROJECT';
    const entry = Object.entries($cce82b8ad97a481b$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $lCetP.isClientFetchError)(error)) return $cce82b8ad97a481b$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("flXCN", function(module, exports) {
$parcel$export(module.exports, "TrackedGraphQLError", () => $c42fe2021078d22a$export$f2062ad173e74c75);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $c42fe2021078d22a$export$f2062ad173e74c75 extends Error {
    constructor(errorMessage, errors, traceIds){
        super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
        this.errors = errors;
        // Get first trace id
        this.traceId = traceIds?.[0];
        // Get first status code
        this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
        // Combine error messages
        this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
    }
}
$c42fe2021078d22a$export$f2062ad173e74c75.displayName = "TrackedGraphQLError";

});


parcelRegister("l64dz", function(module, exports) {
$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $f21e4601dfeeea0e$export$a859f6866f4653e0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7TA2J = parcelRequire("7TA2J");

var $lz4O3 = parcelRequire("lz4O3");

var $82B9c = parcelRequire("82B9c");
const $f21e4601dfeeea0e$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $7TA2J.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $lz4O3.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $82B9c.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $82B9c.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $82B9c.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});
parcelRegister("lz4O3", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $4c397319c2eeae2d$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $4c397319c2eeae2d$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $4c397319c2eeae2d$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $4c397319c2eeae2d$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $4c397319c2eeae2d$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $4c397319c2eeae2d$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $4c397319c2eeae2d$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $4c397319c2eeae2d$export$2af0438304d7c4b2);
/* eslint-disable jira/filename-case */ // TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $4c397319c2eeae2d$export$f892f621fb508154 = 'jiraForgeUi';
const $4c397319c2eeae2d$export$273f5980517336e2 = 'jiraforgeui';
const $4c397319c2eeae2d$export$ed63b053e04e26df = 'trigger';
const $4c397319c2eeae2d$export$725bacc669333eef = 'extension';
const $4c397319c2eeae2d$export$d920cee73ec094d0 = 10;
const $4c397319c2eeae2d$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$4c397319c2eeae2d$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$4c397319c2eeae2d$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$4c397319c2eeae2d$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $4c397319c2eeae2d$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    PIN_UNPIN_CLICKED: 'pin-unpin clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $4c397319c2eeae2d$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    SUCCEEDED: 'succeeded',
    CALLED: 'called',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $4c397319c2eeae2d$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("82B9c", function(module, exports) {
$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $3864647873529089$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $3864647873529089$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $3864647873529089$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $3864647873529089$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $3864647873529089$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $3864647873529089$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $3864647873529089$export$a318f99472db73c8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvGCa = parcelRequire("jvGCa");

var $fDxFn = parcelRequire("fDxFn");

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $lz4O3 = parcelRequire("lz4O3");
const $3864647873529089$export$c3d8833fbea3e976 = (0, $jvGCa.metrics).concurrent.custom({
    key: (0, $lz4O3.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $3864647873529089$export$292f3b557281044f = (0, $jvGCa.metrics).concurrent.custom({
    key: (0, $lz4O3.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $3864647873529089$export$89ace7e2bb7d7685 = new (0, $jkqqC.UFOExperience)((0, $lz4O3.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
});
async function $3864647873529089$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $fDxFn.default).getEntriesByName(startMark).length > 0 || (0, $fDxFn.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $fDxFn.default).mark(startMark);
    const result = await fn();
    (0, $fDxFn.default).mark(endMark);
    return result;
}
const $3864647873529089$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $fDxFn.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $fDxFn.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $fDxFn.default).clearMarks(name);
    });
};
const $3864647873529089$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $jvGCa.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $lz4O3.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $lz4O3.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $3864647873529089$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $jvGCa.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("5iMdl", function(module, exports) {
$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $4049f1dfc8f58584$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $4049f1dfc8f58584$export$b5ca88b1053f1ad0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aoZbr = parcelRequire("aoZbr");

var $cXwmT = parcelRequire("cXwmT");
const $4049f1dfc8f58584$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $4049f1dfc8f58584$export$917d0643b0111a02 = (0, $aoZbr.toEventId)('issueViewInitialization');
const $4049f1dfc8f58584$export$43e875fd63e64525 = (0, $aoZbr.toEventId)('fetchModulesInitialization');
const $4049f1dfc8f58584$export$132ca822850e455f = (source, attributes)=>(0, $cXwmT.fireInitializationEvent)($4049f1dfc8f58584$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $4049f1dfc8f58584$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $4049f1dfc8f58584$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $cXwmT.fireInitializationEvent)($4049f1dfc8f58584$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $4049f1dfc8f58584$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $4049f1dfc8f58584$export$e914f7df1e4ad79b = (source, attributes)=>(0, $cXwmT.fireInitializationEvent)($4049f1dfc8f58584$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $4049f1dfc8f58584$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $4049f1dfc8f58584$export$b274c658390b491b = (source, attributes)=>(0, $cXwmT.fireInitializationEvent)($4049f1dfc8f58584$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $4049f1dfc8f58584$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("aoZbr", function(module, exports) {
$parcel$export(module.exports, "toEventId", () => $4bc9fc24c90d436b$export$75e84ef5a3771f9a);
/* eslint-disable jira/filename-case */ const $4bc9fc24c90d436b$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("cXwmT", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $9426bcbfbb8cc76e$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $9426bcbfbb8cc76e$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $9426bcbfbb8cc76e$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $9426bcbfbb8cc76e$export$390a62413962e4f0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Kdw4 = parcelRequire("6Kdw4");

var $lz4O3 = parcelRequire("lz4O3");

var $9x0Ea = parcelRequire("9x0Ea");

var $4gbkQ = parcelRequire("4gbkQ");

var $3gu1w = parcelRequire("3gu1w");
const $9426bcbfbb8cc76e$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $lz4O3.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $9x0Ea.createAttributes)(attributes),
        source: source,
        action: action
    });
const $9426bcbfbb8cc76e$var$getAnalyticsClient = async ()=>(await (0, $6Kdw4.getAnalyticsWebClientPromise)()).getInstance();
const $9426bcbfbb8cc76e$var$sendOperationalEvent = async (props)=>(await $9426bcbfbb8cc76e$var$getAnalyticsClient()).sendOperationalEvent($9426bcbfbb8cc76e$var$createAnalyticsProps(props));
const $9426bcbfbb8cc76e$var$sendUiEvent = async (props)=>(await $9426bcbfbb8cc76e$var$getAnalyticsClient()).sendUIEvent($9426bcbfbb8cc76e$var$createAnalyticsProps(props));
const $9426bcbfbb8cc76e$var$sendTrackEvent = async (props)=>(await $9426bcbfbb8cc76e$var$getAnalyticsClient()).sendTrackEvent($9426bcbfbb8cc76e$var$createAnalyticsProps(props));
const $9426bcbfbb8cc76e$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$9426bcbfbb8cc76e$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $9x0Ea.parseSource)(source),
        action: action
    });
const $9426bcbfbb8cc76e$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$9426bcbfbb8cc76e$var$sendUiEvent({
        ...eventProps,
        source: (0, $9x0Ea.parseSource)(source),
        action: action
    });
const $9426bcbfbb8cc76e$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$9426bcbfbb8cc76e$var$sendTrackEvent({
        ...eventProps,
        source: (0, $9x0Ea.parseSource)(source),
        action: action
    });
const $9426bcbfbb8cc76e$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $9426bcbfbb8cc76e$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $4gbkQ.logError)((0, $4gbkQ.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $3gu1w.isSynthetic)().toString()}, id=${id}, source=${(0, $9x0Ea.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("9x0Ea", function(module, exports) {
$parcel$export(module.exports, "parseSource", () => $cff89dbd60a53710$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $cff89dbd60a53710$export$c7c9603a6b1fd815);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5dNz8 = parcelRequire("5dNz8");

var $6bEm8 = parcelRequire("6bEm8");

var $7YQ9C = parcelRequire("7YQ9C");

var $0Us5k = parcelRequire("0Us5k");

var $3gu1w = parcelRequire("3gu1w");
const $cff89dbd60a53710$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $cff89dbd60a53710$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $cff89dbd60a53710$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $3gu1w.isSynthetic)(),
        isOverridingFragments: (0, $7YQ9C.isOverridingFragments)(),
        isSSR: false,
        shard: (0, $6bEm8.default)('ajs-shard') || '',
        region: (0, $6bEm8.default)('ajs-region') || ''
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $cff89dbd60a53710$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $cff89dbd60a53710$export$78c6267359db7e73(error);
            attributes.errorType = (0, $0Us5k.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5dNz8)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("5dNz8", function(module, exports) {

var $3zZZC = parcelRequire("3zZZC");

var $czB45 = parcelRequire("czB45");
/** `Object#toString` result references. */ var $3cd49d585e6c4841$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $3cd49d585e6c4841$var$isBoolean(value) {
    return value === true || value === false || $czB45(value) && $3zZZC(value) == $3cd49d585e6c4841$var$boolTag;
}
module.exports = $3cd49d585e6c4841$var$isBoolean;

});

parcelRegister("7YQ9C", function(module, exports) {
$parcel$export(module.exports, "isOverridingFragments", () => $be4c523d0fe4caf2$export$1d1321d2b374d697);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $be4c523d0fe4caf2$export$1d1321d2b374d697 = ()=>{
    const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
    const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
    return buildKey ? re.test(buildKey) : false;
};

});

parcelRegister("3gu1w", function(module, exports) {
$parcel$export(module.exports, "isSynthetic", () => $4e277eb3950a6435$export$947749d756ccb0a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");
const $4e277eb3950a6435$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $6bEm8.default)('ajs-is-synthetic') === 'true' || (0, $i860n.fg)('forge_ui_synthetic_check');

});


parcelRegister("4gbkQ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_UTIL", () => $653d8bdb0a683163$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $653d8bdb0a683163$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $653d8bdb0a683163$export$58da9968c3170cb1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");

var $lz4O3 = parcelRequire("lz4O3");
const $653d8bdb0a683163$export$e31edcd35abe3bb1 = 'environment-mapping';
const $653d8bdb0a683163$export$d1e4f308040bb0d5 = 'analytics';
const $653d8bdb0a683163$export$36f315a5c6daf40b = 'custom-field-object-type';
const $653d8bdb0a683163$export$6ee8198f29fffdb4 = {
    [$653d8bdb0a683163$export$d1e4f308040bb0d5]: `${(0, $lz4O3.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$653d8bdb0a683163$export$e31edcd35abe3bb1]: `${(0, $lz4O3.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$653d8bdb0a683163$export$36f315a5c6daf40b]: `${(0, $lz4O3.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $653d8bdb0a683163$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $6CfY5.default).safeErrorWithoutCustomerData($653d8bdb0a683163$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("4wDMb", function(module, exports) {
$parcel$export(module.exports, "canFetchForgeModules", () => $2ca4c69ee06ae886$export$bb3a4a3b8e654c08);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $2ca4c69ee06ae886$export$bb3a4a3b8e654c08 = ({ cloudId: cloudId })=>{
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    /**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */ if (!false && $2ca4c69ee06ae886$export$489a82a1efc4cd04().endsWith('.atl-test.space')) return false;
    return true;
};
const $2ca4c69ee06ae886$export$489a82a1efc4cd04 = ()=>window.location.hostname;

});

parcelRegister("5UxXz", function(module, exports) {
$parcel$export(module.exports, "toMappedExtensions", () => $b01c395d3d666b25$export$e073e0c0d1c23345);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ function $b01c395d3d666b25$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    const extensions = $b01c395d3d666b25$export$acd8ca2c14bd2aa4(returnedExtensions);
    extensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return result;
}
function $b01c395d3d666b25$export$acd8ca2c14bd2aa4(extensions) {
    return extensions.map(({ moduleId: moduleId, ...rest })=>({
            ...rest,
            id: moduleId ?? rest.id.replace(/-+\d+$/, ''),
            moduleId: moduleId
        }));
}

});

parcelRegister("bh8EG", function(module, exports) {
$parcel$export(module.exports, "trackGraphQLErrors", () => $62ec1cd3678f149b$export$a5c00ff206a4c88b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lMoch = parcelRequire("lMoch");

var $flXCN = parcelRequire("flXCN");

var $511Fu = parcelRequire("511Fu");
function $62ec1cd3678f149b$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $lMoch.startCaptureGraphQlErrors)();
    (0, $511Fu.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $511Fu.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$62ec1cd3678f149b$var$getGraphQLError(queryId, operationName)
    };
}
function $62ec1cd3678f149b$var$getGraphQLError(key, operationName) {
    const errors = (0, $lMoch.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $flXCN.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $511Fu.getTraceIds)(operationName));
    return undefined;
}

});


parcelRegister("aaubd", function(module, exports) {
$parcel$export(module.exports, "uniqueExtensionsFilter", () => $c54033b9af986964$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $c54033b9af986964$export$1eefd1d9cde49fd5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gpG7K = parcelRequire("gpG7K");

var $awsUf = parcelRequire("awsUf");
const $c54033b9af986964$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($gpG7K)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $awsUf.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $c54033b9af986964$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$c54033b9af986964$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$c54033b9af986964$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$c54033b9af986964$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("gpG7K", function(module, exports) {

var $9JUaE = parcelRequire("9JUaE");

var $8pFpK = parcelRequire("8pFpK");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $bf2fa8141aa269a6$var$uniqBy(array, iteratee) {
    return array && array.length ? $8pFpK(array, $9JUaE(iteratee, 2)) : [];
}
module.exports = $bf2fa8141aa269a6$var$uniqBy;

});

parcelRegister("awsUf", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $c9f84a4e2699e41c$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $c9f84a4e2699e41c$export$a92b17288693d366);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $c9f84a4e2699e41c$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $c9f84a4e2699e41c$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});



parcelRegister("9O6SX", function(module, exports) {
$parcel$export(module.exports, "navPlatformRootStateResource", () => $d4b8ce19e56fdc95$export$68f863693687087c);

var $htsFl = parcelRequire("htsFl");

var $2NSbF = parcelRequire("2NSbF");

var $1hxzM = parcelRequire("1hxzM");

var $2tave = parcelRequire("2tave");
const $d4b8ce19e56fdc95$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM = 'NAV_PLATFORM_SIDEBAR_UI_STATE';
const $d4b8ce19e56fdc95$export$68f863693687087c = (0, $htsFl.createRelayResource)({
    type: $d4b8ce19e56fdc95$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM,
    // Anonymous users must not trigger this GSN GraphQL query. Use the
    // resource-level `skip` predicate so `loadQuery` is never invoked for them —
    // `getQuery` will not run when `skip` returns `true`.
    skip: (_, { tenantContext: { isAnonymous: isAnonymous } })=>{
        return isAnonymous;
    },
    getQuery: (_, { tenantContext: { activationId: activationId, atlassianAccountId: atlassianAccountId, cloudId: cloudId } })=>{
        return {
            parameters: (0, $2tave.default),
            variables: {
                navPlatSidebarDataEntityAri: (0, $1hxzM.buildNavigationAriForSidebarData)({
                    activationId: activationId,
                    firstPartyApp: 'jira',
                    siteId: cloudId
                }),
                ownerAri: atlassianAccountId && (0, $2NSbF.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString(),
                isAnonymous: false
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isCritical: true
});

});
parcelRegister("2tave", function(module, exports) {
$parcel$export(module.exports, "default", () => $41ac12933a01fd94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5ef89a2a2823b6f1e3708daa8547fe2>>
 * @relayHash e24a74e08fc090b4efa5675eb1650a9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29370c9da22d47da3e920ab70da55f287e06357d65fcb8cfbf0e1674d867cd4d
const $41ac12933a01fd94$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navPlatSidebarDataEntityAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "navPlatSidebarDataEntityAri"
        },
        {
            "kind": "Variable",
            "name": "ownerAri",
            "variableName": "ownerAri"
        }
    ], v4 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "LayoutManagerQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "navPlatSidebarData",
                            "args": v3 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "LayoutManagerQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "navPlatSidebarData",
                            "args": v3 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "29370c9da22d47da3e920ab70da55f287e06357d65fcb8cfbf0e1674d867cd4d",
            "metadata": {},
            "name": "LayoutManagerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$41ac12933a01fd94$var$node.hash = "461831cc5edab2101d4bf2283d2c5fcf";
var $41ac12933a01fd94$export$2e2bcd8739ae039 = $41ac12933a01fd94$var$node;

});


parcelRegister("lxP6a", function(module, exports) {
$parcel$export(module.exports, "getBannerResources", () => $80f1fc445c8fc0b5$export$cc6a6a8372f2ef22);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $iV0kf = parcelRequire("iV0kf");

var $hDZQt = parcelRequire("hDZQt");

var $2VqX7 = parcelRequire("2VqX7");
const $80f1fc445c8fc0b5$export$cc6a6a8372f2ef22 = ()=>[
        (0, $hDZQt.getConsentBannerUserPreferencesResource)(),
        (0, $iV0kf.announcementBannerSettingsV4Resource),
        (0, $2VqX7.incomingMailServerExpiryStatusResource)
    ];

});
parcelRegister("iV0kf", function(module, exports) {
$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $db114ff901bcaf1d$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $db114ff901bcaf1d$export$6fb72f4a0c177494);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $hVpdC = parcelRequire("hVpdC");

var $ae0dQ = parcelRequire("ae0dQ");

var $bgRsZ = parcelRequire("bgRsZ");
function $db114ff901bcaf1d$export$190f48575cfcbb2e(isAnonymous, settings, hashIdLastDimissed) {
    if (isAnonymous || !settings?.isDismissable) return false;
    return settings?.hashId === hashIdLastDimissed;
}
const $db114ff901bcaf1d$var$announcementBannerSettingsResource = (0, $7edbf.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $ae0dQ.get)(),
            (0, $bgRsZ.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: $db114ff901bcaf1d$export$190f48575cfcbb2e(isAnonymous, settings, hashIdLastDimissed)
        };
    },
    maxAge: 900000
});
const $db114ff901bcaf1d$export$8fbe7f8de07afffd = (0, $7edbf.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $hVpdC.get)(),
            (0, $bgRsZ.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: $db114ff901bcaf1d$export$190f48575cfcbb2e(isAnonymous, settings, hashIdLastDimissed)
        };
    },
    maxAge: 900000,
    isCritical: true
});
const $db114ff901bcaf1d$export$43d4950a3e443fd3 = ()=>(0, $k6ufm.useResource)($db114ff901bcaf1d$var$announcementBannerSettingsResource);
const $db114ff901bcaf1d$export$6fb72f4a0c177494 = ()=>(0, $k6ufm.useResource)($db114ff901bcaf1d$export$8fbe7f8de07afffd);

});
parcelRegister("hVpdC", function(module, exports) {
$parcel$export(module.exports, "get", () => $d05f272c339b4774$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $d05f272c339b4774$export$adaa4cf7ef1b65be);

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");
const $d05f272c339b4774$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $h2wCv.performGetRequest)('/rest/internal/4/announcement-banner');
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $d05f272c339b4774$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $h2wCv.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $d05f272c339b4774$export$4eb85e00a747e2c7 = {
    get: $d05f272c339b4774$export$3988ae62b71be9a3,
    set: $d05f272c339b4774$export$adaa4cf7ef1b65be
};

});

parcelRegister("ae0dQ", function(module, exports) {
$parcel$export(module.exports, "get", () => $e91d3062d0235a0d$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e91d3062d0235a0d$export$adaa4cf7ef1b65be);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

const $e91d3062d0235a0d$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $h2wCv.performGetRequest)('/rest/internal/3/announcement-banner');
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $e91d3062d0235a0d$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $h2wCv.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b = '@jira/admin-pages__system-announcement-banner-resources';
const $dfdeaef3480c99cf$export$5e0c0e8c940630f8 = 'private';
const $dfdeaef3480c99cf$export$1d5a5b6462188eb3 = 'public';


parcelRegister("bgRsZ", function(module, exports) {
$parcel$export(module.exports, "get", () => $0116657701f3a327$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $0116657701f3a327$export$adaa4cf7ef1b65be);

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

const $0116657701f3a327$var$key = 'announcementBannerDismissedLast';
const $0116657701f3a327$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $kM0go.getUserProperty)(accoundId, $0116657701f3a327$var$key)).hashId : null;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $0116657701f3a327$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $kM0go.setUserProperties)(accoundId, $0116657701f3a327$var$key, JSON.stringify({
            hashId: hashId
        }));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $0116657701f3a327$export$acb5b4af626ec776 = {
    get: $0116657701f3a327$export$3988ae62b71be9a3,
    set: $0116657701f3a327$export$adaa4cf7ef1b65be
};

});


parcelRegister("hDZQt", function(module, exports) {
$parcel$export(module.exports, "getConsentBannerUserPreferencesResource", () => $ef0eb8708b9f84a6$export$a40d52e504d1db7c);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $ef0eb8708b9f84a6$export$5bc7e83e85567fb4);

var $dJ3NQ = parcelRequire("dJ3NQ");

var $41FAq = parcelRequire("41FAq");

var $jOWFe = parcelRequire("jOWFe");

var $gXrrn = parcelRequire("gXrrn");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $2HuOR = parcelRequire("2HuOR");

const $ef0eb8708b9f84a6$var$consentBannerUserPreferencesResource = (0, $7edbf.createResource)({
    type: (0, $493cfa73c2f8856e$export$f0cdd7d2fbfd00ff),
    getKey: ()=>(0, $493cfa73c2f8856e$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $gXrrn.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_COOKIE_KEY), true);
        const fallbackConsentToken = (0, $gXrrn.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), true);
        const shouldShowBannerBit = (0, $gXrrn.getCookie)((0, $jOWFe.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), true);
        const shouldShowBanner = shouldShowBannerBit !== undefined && shouldShowBannerBit !== null ? !!Number(shouldShowBannerBit) : undefined;
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            shouldShowBanner: shouldShowBanner
        };
        if (!(0, $41FAq.isFeatureEnabled)('consent-platform', 'consenthub')) return {};
        /**
		 * On server we need to request the api using a server to server api (atl-preferences-center-elb)
		 * otherwise the request will not be authenticated correctly.
		 *
		 * However Pillar does not support ASAP, so we need to use the client side api call in local development.
		 *
		 * See https://atlassian.slack.com/archives/C017Y3EPAQ4/p1754626460768439?thread_ts=1754601759.549879&cid=C017Y3EPAQ4
		 */ if (false && !(0, $dJ3NQ.default)()) {
            const userId = (0, $2HuOR.getAtlassianAccountId)();
            if (userId) {
                const data = await (0, $h2wCv.performGetRequest)(`/rest/user/${userId}/consents/cookies`, {
                    credentials: 'include',
                    headers: {
                        'x-ssr-service-name': 'atl-preferences-center'
                    }
                });
                return data;
            }
        }
        const data = await (0, $h2wCv.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: false,
    isCritical: true
});
const $ef0eb8708b9f84a6$export$a40d52e504d1db7c = ()=>$ef0eb8708b9f84a6$var$consentBannerUserPreferencesResource;
const $ef0eb8708b9f84a6$export$5bc7e83e85567fb4 = ()=>(0, $k6ufm.useResource)($ef0eb8708b9f84a6$export$a40d52e504d1db7c());

});
parcelRegister("gXrrn", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $24384ab96ef9de88$export$4be65e66cfa2648a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $37LBQ = parcelRequire("37LBQ");

var $gToGk = parcelRequire("gToGk");
function $24384ab96ef9de88$export$4be65e66cfa2648a(key, ssr) {
    if (false) {
        if (ssr) {
            if ((0, $gToGk.getSsrStatus)() === 'static') return key ? (0, $37LBQ.getCookie)(key) : undefined;
            // Defined here jira/src/entry-fs/utils/single-spa-route.tsx
            return globalThis?.__GET_COOKIE__?.(key);
        }
        return;
    }
    return key ? (0, $37LBQ.getCookie)(key) : (0, $37LBQ.getCookie)();
}

});

/* eslint-disable jira/filename-case */ const $493cfa73c2f8856e$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $493cfa73c2f8856e$export$f0cdd7d2fbfd00ff = 'CONSENT_BANNER_USER_PREFERENCES_SSR';
const $493cfa73c2f8856e$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("2VqX7", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $0477c8ac2607811a$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $0477c8ac2607811a$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $0477c8ac2607811a$export$283aa034b7d4e2a0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $0477c8ac2607811a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $h2wCv.performGetRequest)((0, $319c00148020036c$export$5bf8eb915287f5f4));
const $0477c8ac2607811a$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $0477c8ac2607811a$export$369caf52ed1ad2b1 = (0, $7edbf.createResource)({
    type: (0, $319c00148020036c$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $319c00148020036c$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $0477c8ac2607811a$var$fetchGetIncomingMailServerExpiryStatus();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'thor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0477c8ac2607811a$export$32d9db53927095d3
        };
    },
    maxAge: 3600000,
    isCritical: true
});
const $0477c8ac2607811a$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $k6ufm.useResource)($0477c8ac2607811a$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $euxye.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $0477c8ac2607811a$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $euxye.useState)('not started');
    (0, $euxye.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
/* eslint-disable jira/filename-case */ const $319c00148020036c$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $319c00148020036c$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $319c00148020036c$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';




parcelRegister("fdS54", function(module, exports) {
$parcel$export(module.exports, "createEntry", () => $03ea87c69fa8acf1$export$344b9c9ab5e66c9a);

var $4s81o = parcelRequire("4s81o");
const $03ea87c69fa8acf1$export$344b9c9ab5e66c9a = (0, $4s81o.createRouteEntry);

});
parcelRegister("4s81o", function(module, exports) {
$parcel$export(module.exports, "createRouteEntry", () => $b039d3173ab8f298$export$136cc45b1cabb43);
/**
 * Create route entry with entrypoint, resources, etc. override
 *
 * @param baseRoute Base route object that contains matching info
 * @param opts Route definition to fill and override
 */ function $b039d3173ab8f298$export$136cc45b1cabb43(baseRoute, opts) {
    // @ts-expect-error Re-using baseRoute to become the full route Object allows us to optimize
    // route transitions as RRR can directly use the route instead of comparing a separate InvariantRoute
    // against the full route list
    // eslint-disable-next-line no-param-reassign
    baseRoute.lazyOpts = opts;
    // @ts-expect-error TODO
    return baseRoute;
}

});


parcelRegister("qPIzk", function(module, exports) {
$parcel$export(module.exports, "auditLogsLayout", () => $c0d36c8ab1ad492a$export$96317e889101e865);

var $9mpjO = parcelRequire("9mpjO");

var $QhQu4 = parcelRequire("QhQu4");

var $ju22D = parcelRequire("ju22D");
const $c0d36c8ab1ad492a$export$96317e889101e865 = (0, $QhQu4.composeLayouts)((0, $ju22D.globalSettingsLayout), {
    rightSidebars: [
        (0, $9mpjO.AuditLogRightSidebarAsync)
    ]
});
var $c0d36c8ab1ad492a$export$2e2bcd8739ae039 = $c0d36c8ab1ad492a$export$96317e889101e865;

});
parcelRegister("9mpjO", function(module, exports) {
$parcel$export(module.exports, "AuditLogRightSidebarAsync", () => $3b278275baca27c1$export$8c0a7ac1cfd2bd59);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $jepRN = parcelRequire("jepRN");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b278275baca27c1$var$LazyAuditLogRightSidebar = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2N9Xb")).then((m)=>m.AuditLogRightSidebar), {
    ssr: false,
    moduleId: "./src/packages/admin-pages/audit-logs/src/AuditLogRightSidebar.tsx"
});
function $3b278275baca27c1$var$AsyncAuditLogRightSidebarInner() {
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "audit-log-right-sidebar",
            packageName: "jiraAdminPagesAuditLogs",
            teamName: "Audit-Log Platform",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "async-audit-log-right-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3b278275baca27c1$var$LazyAuditLogRightSidebar, null)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
$3b278275baca27c1$var$AsyncAuditLogRightSidebarInner.displayName = "AsyncAuditLogRightSidebarInner";
const $3b278275baca27c1$export$8c0a7ac1cfd2bd59 = (0, $jepRN.componentWithFG)('jira_frontend_eal_admin_audit_log', $3b278275baca27c1$var$AsyncAuditLogRightSidebarInner, ()=>null);
$3b278275baca27c1$export$8c0a7ac1cfd2bd59.displayName = 'AuditLogRightSidebarAsync';
var $3b278275baca27c1$export$2e2bcd8739ae039 = $3b278275baca27c1$export$8c0a7ac1cfd2bd59;

});
parcelRegister("jepRN", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $efd2d875c00406ea$export$cf56d0f54cfcce4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");
const $efd2d875c00406ea$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>// eslint-disable-next-line jira/ff/static-feature-flags
    (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)(gateName), ComponentTrue, ComponentFalse);

});

parcelRegister("2N9Xb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("70FRp").then(()=>parcelRequire('dSMDJ'));

});


parcelRegister("QhQu4", function(module, exports) {
$parcel$export(module.exports, "renderGlobalComponents", () => $b6e10e5d03aa726e$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $b6e10e5d03aa726e$export$3dd437ade36ede40);
$parcel$export(module.exports, "preloadComponents", () => $b6e10e5d03aa726e$export$6ae808826fa58f6d);
$parcel$export(module.exports, "composeLayouts", () => $b6e10e5d03aa726e$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $b6e10e5d03aa726e$export$e97a7da67a5b8ce4);

var $euxye = parcelRequire("euxye");

var $dQn1l = parcelRequire("dQn1l");

var $XssJM = parcelRequire("XssJM");

var $a8EUd = parcelRequire("a8EUd");

var $bKPo4 = parcelRequire("bKPo4");
/**
 * @deprecated Unneeded, and complicates code readability as it's not a standard language method and therefore is unknown to most of developers.
 * Use `str || str2` instead of `coalesce(str) ?? str2`
 */ const $b6e10e5d03aa726e$var$coalesce = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $b6e10e5d03aa726e$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const placeholderName = ($b6e10e5d03aa726e$var$coalesce(displayName) ?? $b6e10e5d03aa726e$var$coalesce(name) ?? String(i)).replaceAll('/', '_');
        const key = (0, $dQn1l.uid)(Component);
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: String(placeholderName),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, null)));
    });
const $b6e10e5d03aa726e$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], preloadComponents: preloadComponents, isChromeless: isChromeless = false } = {})=>{
    const layout = {
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars)),
        preloadComponents: Array.from(new Set(preloadComponents))
    };
    return layout;
};
const $b6e10e5d03aa726e$export$6ae808826fa58f6d = (layout)=>{
    layout.preloadComponents?.forEach((component)=>{
        component.preload?.();
    });
};
const $b6e10e5d03aa726e$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $b6e10e5d03aa726e$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $b6e10e5d03aa726e$export$3dd437ade36ede40(layout);
};
const $b6e10e5d03aa726e$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $b6e10e5d03aa726e$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $b6e10e5d03aa726e$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $b6e10e5d03aa726e$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $b6e10e5d03aa726e$export$e97a7da67a5b8ce4 = (// oxlint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $XssJM.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, null);
    };
    const name = $b6e10e5d03aa726e$var$coalesce(Component.displayName) ?? $b6e10e5d03aa726e$var$coalesce(Component.name) ?? 'Component';
    const prefix = $b6e10e5d03aa726e$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("dQn1l", function(module, exports) {
$parcel$export(module.exports, "uid", () => $a141fd23a492e6bd$export$e2a22331486dcca0);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $a141fd23a492e6bd$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $a141fd23a492e6bd$export$e2a22331486dcca0 = $a141fd23a492e6bd$export$bdbb4cbb3078e58d();

});

parcelRegister("XssJM", function(module, exports) {
$parcel$export(module.exports, "useProject", () => $0efca82aea2045c9$export$51b1383ef8844a7);

var $e7boj = parcelRequire("e7boj");

var $4bRaD = parcelRequire("4bRaD");

var $8ANUF = parcelRequire("8ANUF");
const $0efca82aea2045c9$export$51b1383ef8844a7 = (customContext)=>{
    const $ = (0, $e7boj.c)(6);
    const { data: data, loading: loading, error: error } = (0, $8ANUF.useProjectSidebarNavigation)(customContext);
    let t0;
    if ($[0] !== data) {
        t0 = data && (0, $4bRaD.extractData)(data);
        $[0] = data;
        $[1] = t0;
    } else t0 = $[1];
    const project = t0;
    let t1;
    if ($[2] !== error || $[3] !== loading || $[4] !== project) {
        t1 = {
            data: project,
            loading: loading,
            error: error
        };
        $[2] = error;
        $[3] = loading;
        $[4] = project;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};

});
parcelRegister("4bRaD", function(module, exports) {
$parcel$export(module.exports, "getStyle", () => $2473348817a5d097$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $2473348817a5d097$export$9df5fa0a366163d2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $i860n = parcelRequire("i860n");
const $2473348817a5d097$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $f99M0.ProjectStyle).NEXT_GEN : (0, $f99M0.ProjectStyle).CLASSIC;
const $2473348817a5d097$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $2473348817a5d097$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey,
        ...typeof project.isLiveTemplate === 'boolean' && (0, $i860n.fg)('jira_custom_templates_ux') && {
            isLiveTemplate: project.isLiveTemplate
        }
    });
const $2473348817a5d097$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $2473348817a5d097$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $2473348817a5d097$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $2473348817a5d097$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $2473348817a5d097$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});
parcelRegister("f99M0", function(module, exports) {
$parcel$export(module.exports, "CORE_PROJECT", () => $d446c821a6c23064$export$4b79f735ed858abe);
$parcel$export(module.exports, "SOFTWARE_PROJECT", () => $d446c821a6c23064$export$417275bac62d38d2);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT", () => $d446c821a6c23064$export$9c9c9eaf8c092006);
$parcel$export(module.exports, "CUSTOMER_SERVICE_PROJECT", () => $d446c821a6c23064$export$320625d747692f94);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT_ANALYTICS", () => $d446c821a6c23064$export$d579a2a17bd742af);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PROJECT", () => $d446c821a6c23064$export$e9fe9a39cc7f5103);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CORE_PROJECT", () => $d446c821a6c23064$export$490d3686b662c315);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SOFTWARE_PROJECT", () => $d446c821a6c23064$export$1242aa4e670b910e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT", () => $d446c821a6c23064$export$bb467c3bc8f8620e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT", () => $d446c821a6c23064$export$610dddac4d185bf8);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT", () => $d446c821a6c23064$export$76412127fb3089d6);
$parcel$export(module.exports, "JIRA_PROJECT_STATUS_ARCHIVED", () => $d446c821a6c23064$export$c02e05d1bee347e5);
$parcel$export(module.exports, "COMPANY_MANAGED_PROJECT", () => $d446c821a6c23064$export$6933c64814be01d9);
$parcel$export(module.exports, "TEAM_MANAGED_PROJECT", () => $d446c821a6c23064$export$e569d8a168a85f48);
$parcel$export(module.exports, "JIRA_PROJECT_TYPES", () => $d446c821a6c23064$export$be0978435d251eb);
$parcel$export(module.exports, "JIRA_PROJECT_STYLES", () => $d446c821a6c23064$export$caed6d9b39712cc7);
$parcel$export(module.exports, "ProjectStyle", () => $d446c821a6c23064$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectStyleCmpNotation", () => $d446c821a6c23064$export$bde8ccac2f23fd0f);
$parcel$export(module.exports, "PROJECT_TYPES", () => $d446c821a6c23064$export$9482030bf1904b0);
$parcel$export(module.exports, "toProjectType", () => $d446c821a6c23064$export$cfdcd9ead66e4329);
$parcel$export(module.exports, "convertToProjectType", () => $d446c821a6c23064$export$aa8444e79de3a8b6);
$parcel$export(module.exports, "convertToJiraProjectType", () => $d446c821a6c23064$export$5a8b6164d1baba87);
$parcel$export(module.exports, "toAnalyticsProjectType", () => $d446c821a6c23064$export$5afb6f76b5af0167);
$parcel$export(module.exports, "projectTypeToCanonicalId", () => $d446c821a6c23064$export$e25a1ee2478a61d6);
/* eslint-disable jira/filename-case */ 
var $74oEx = parcelRequire("74oEx");

var $8HVfB = parcelRequire("8HVfB");
const $d446c821a6c23064$export$4b79f735ed858abe = 'business';
const $d446c821a6c23064$export$417275bac62d38d2 = 'software';
const $d446c821a6c23064$export$9c9c9eaf8c092006 = 'service_desk';
const $d446c821a6c23064$export$320625d747692f94 = 'customer_service';
const $d446c821a6c23064$export$d579a2a17bd742af = 'serviceDesk';
const $d446c821a6c23064$export$e9fe9a39cc7f5103 = 'product_discovery';
const $d446c821a6c23064$export$490d3686b662c315 = 'BUSINESS';
const $d446c821a6c23064$export$1242aa4e670b910e = 'SOFTWARE';
const $d446c821a6c23064$export$bb467c3bc8f8620e = 'SERVICE_DESK';
const $d446c821a6c23064$export$610dddac4d185bf8 = 'CUSTOMER_SERVICE';
const $d446c821a6c23064$export$76412127fb3089d6 = 'PRODUCT_DISCOVERY';
const $d446c821a6c23064$export$1b784afd50592d26 = 'ACTIVE';
const $d446c821a6c23064$export$c02e05d1bee347e5 = 'ARCHIVED';
const $d446c821a6c23064$export$8b2d8efe30253ab3 = 'DELETED';
const $d446c821a6c23064$export$6933c64814be01d9 = 'COMPANY_MANAGED_PROJECT';
const $d446c821a6c23064$export$e569d8a168a85f48 = 'TEAM_MANAGED_PROJECT';
const $d446c821a6c23064$export$be0978435d251eb = {
    [$d446c821a6c23064$export$490d3686b662c315]: $d446c821a6c23064$export$490d3686b662c315,
    [$d446c821a6c23064$export$1242aa4e670b910e]: $d446c821a6c23064$export$1242aa4e670b910e,
    [$d446c821a6c23064$export$bb467c3bc8f8620e]: $d446c821a6c23064$export$bb467c3bc8f8620e,
    [$d446c821a6c23064$export$610dddac4d185bf8]: $d446c821a6c23064$export$610dddac4d185bf8,
    [$d446c821a6c23064$export$76412127fb3089d6]: $d446c821a6c23064$export$76412127fb3089d6
};
const $d446c821a6c23064$export$caed6d9b39712cc7 = {
    COMPANY_MANAGED_PROJECT: $d446c821a6c23064$export$6933c64814be01d9,
    TEAM_MANAGED_PROJECT: $d446c821a6c23064$export$e569d8a168a85f48
};
const $d446c821a6c23064$export$1f66f9f05afa05a8 = {
    CLASSIC: 'classic',
    NEXT_GEN: 'next-gen'
};
const $d446c821a6c23064$export$bde8ccac2f23fd0f = {
    COMPANY_MANAGED: 'companyManaged',
    TEAM_MANAGED: 'teamManaged'
};
const $d446c821a6c23064$export$9482030bf1904b0 = [
    $d446c821a6c23064$export$4b79f735ed858abe,
    $d446c821a6c23064$export$417275bac62d38d2,
    $d446c821a6c23064$export$9c9c9eaf8c092006,
    $d446c821a6c23064$export$320625d747692f94,
    $d446c821a6c23064$export$e9fe9a39cc7f5103
];
const $d446c821a6c23064$export$cfdcd9ead66e4329 = (value)=>$d446c821a6c23064$export$9482030bf1904b0.find((projectType)=>projectType === value);
function $d446c821a6c23064$export$aa8444e79de3a8b6(jiraProjectType) {
    switch(jiraProjectType){
        case $d446c821a6c23064$export$490d3686b662c315:
            return $d446c821a6c23064$export$4b79f735ed858abe;
        case $d446c821a6c23064$export$1242aa4e670b910e:
            return $d446c821a6c23064$export$417275bac62d38d2;
        case $d446c821a6c23064$export$bb467c3bc8f8620e:
            return $d446c821a6c23064$export$9c9c9eaf8c092006;
        case $d446c821a6c23064$export$610dddac4d185bf8:
            return $d446c821a6c23064$export$320625d747692f94;
        case $d446c821a6c23064$export$76412127fb3089d6:
            return $d446c821a6c23064$export$e9fe9a39cc7f5103;
        default:
            throw new Error(`Invalid JiraProjectType: ${jiraProjectType}`);
    }
}
function $d446c821a6c23064$export$959e77de8f16519c(jiraProjectType) {
    const convertedProjectType = $d446c821a6c23064$export$aa8444e79de3a8b6(jiraProjectType);
    if (convertedProjectType === $d446c821a6c23064$export$9c9c9eaf8c092006) // 'Service Desk' is old branding
    return (0, (/*@__PURE__*/$parcel$interopDefault($8HVfB)))('Service Management');
    return (0, (/*@__PURE__*/$parcel$interopDefault($8HVfB)))(convertedProjectType);
}
const $d446c821a6c23064$export$5a8b6164d1baba87 = (projectType)=>{
    switch(projectType){
        case $d446c821a6c23064$export$417275bac62d38d2:
            return $d446c821a6c23064$export$1242aa4e670b910e;
        case $d446c821a6c23064$export$9c9c9eaf8c092006:
            return $d446c821a6c23064$export$bb467c3bc8f8620e;
        case $d446c821a6c23064$export$320625d747692f94:
            return $d446c821a6c23064$export$610dddac4d185bf8;
        case $d446c821a6c23064$export$4b79f735ed858abe:
            return $d446c821a6c23064$export$490d3686b662c315;
        case $d446c821a6c23064$export$e9fe9a39cc7f5103:
            return $d446c821a6c23064$export$76412127fb3089d6;
        default:
            throw new Error(`Invalid ProjectType: ${projectType}`);
    }
};
const $d446c821a6c23064$export$5afb6f76b5af0167 = (projectType)=>{
    switch(projectType){
        case $d446c821a6c23064$export$9c9c9eaf8c092006:
            return $d446c821a6c23064$export$d579a2a17bd742af;
        case $d446c821a6c23064$export$320625d747692f94:
            return $d446c821a6c23064$export$320625d747692f94;
        case $d446c821a6c23064$export$417275bac62d38d2:
            return $d446c821a6c23064$export$417275bac62d38d2;
        case $d446c821a6c23064$export$e9fe9a39cc7f5103:
            return $d446c821a6c23064$export$e9fe9a39cc7f5103;
        case $d446c821a6c23064$export$4b79f735ed858abe:
            return $d446c821a6c23064$export$4b79f735ed858abe;
        default:
            return undefined;
    }
};
const $d446c821a6c23064$var$getFullProjectTypeKey = (style, projectType)=>(0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(`${style}_${projectType}`);
const $d446c821a6c23064$export$241adb8e9255b93c = $d446c821a6c23064$var$getFullProjectTypeKey($d446c821a6c23064$export$1f66f9f05afa05a8.CLASSIC, $d446c821a6c23064$export$4b79f735ed858abe);
const $d446c821a6c23064$export$e932928a4bf564b7 = $d446c821a6c23064$var$getFullProjectTypeKey($d446c821a6c23064$export$1f66f9f05afa05a8.NEXT_GEN, $d446c821a6c23064$export$417275bac62d38d2);
const $d446c821a6c23064$export$e25a1ee2478a61d6 = (projectType)=>{
    switch(projectType){
        case $d446c821a6c23064$export$4b79f735ed858abe:
            return 'jira-core';
        case $d446c821a6c23064$export$417275bac62d38d2:
            return 'jira-software';
        case $d446c821a6c23064$export$9c9c9eaf8c092006:
            return 'jira-servicedesk';
        case $d446c821a6c23064$export$320625d747692f94:
            return 'jira-customer-service';
        case $d446c821a6c23064$export$e9fe9a39cc7f5103:
            return 'jira-product-discovery';
        default:
            return 'jira';
    }
};

});


parcelRegister("8ANUF", function(module, exports) {
$parcel$export(module.exports, "useProjectSidebarNavigation", () => $7c539f48b5e422bb$export$5a85006c180fb373);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $7c539f48b5e422bb$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $7c539f48b5e422bb$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $7c539f48b5e422bb$export$5cf90b625d0e1248);

var $e7boj = parcelRequire("e7boj");

var $g1yQ7 = parcelRequire("g1yQ7");

var $4Rvd7 = parcelRequire("4Rvd7");

var $ihrBs = parcelRequire("ihrBs");

var $iFmc7 = parcelRequire("iFmc7");

var $idDnR = parcelRequire("idDnR");

var $d7dm3 = parcelRequire("d7dm3");

var $k6ufm = parcelRequire("k6ufm");

var $36bRl = parcelRequire("36bRl");
const $7c539f48b5e422bb$export$5a85006c180fb373 = (customContext)=>{
    const $ = (0, $e7boj.c)(14);
    const t0 = (0, $d7dm3.useResourceWithCustomRouterContext)((0, $idDnR.staticProjectSidebarNavigationResource), customContext);
    let clearAll;
    let error;
    let loading;
    let navResponse;
    let refresh;
    let rest;
    if ($[0] !== t0) {
        ({ data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = t0);
        $[0] = t0;
        $[1] = clearAll;
        $[2] = error;
        $[3] = loading;
        $[4] = navResponse;
        $[5] = refresh;
        $[6] = rest;
    } else {
        clearAll = $[1];
        error = $[2];
        loading = $[3];
        navResponse = $[4];
        refresh = $[5];
        rest = $[6];
    }
    const memoizedResponse = navResponse;
    (0, $36bRl.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    const t1 = memoizedResponse != null ? false : loading;
    let t2;
    if ($[7] !== clearAll || $[8] !== error || $[9] !== memoizedResponse || $[10] !== refresh || $[11] !== rest || $[12] !== t1) {
        t2 = {
            data: memoizedResponse,
            loading: t1,
            refresh: refresh,
            clearAll: clearAll,
            error: error,
            ...rest
        };
        $[7] = clearAll;
        $[8] = error;
        $[9] = memoizedResponse;
        $[10] = refresh;
        $[11] = rest;
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};
const $7c539f48b5e422bb$export$2bed15cd7d167db5 = ()=>{
    return (0, $k6ufm.useResource)((0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource));
};
const $7c539f48b5e422bb$export$a9d05fc2c1d94895 = ()=>{
    return (0, $k6ufm.useResource)((0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource));
};
const $7c539f48b5e422bb$export$d48e3c3556894533 = ()=>{
    return (0, $k6ufm.useResource)((0, $iFmc7.staticProjectSettingsSidebarConnectAddonsNavigationResource));
};
const $7c539f48b5e422bb$export$24a781cd863077aa = ()=>{
    return (0, $k6ufm.useResource)((0, $g1yQ7.staticJSMProjectConnectAddonsNavigationResource));
};
const $7c539f48b5e422bb$export$e16ecd2512eb0dc7 = ()=>{
    const $ = (0, $e7boj.c)(6);
    const t0 = $7c539f48b5e422bb$export$5a85006c180fb373();
    let data;
    let rest;
    if ($[0] !== t0) {
        ({ data: data, ...rest } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = rest;
    } else {
        data = $[1];
        rest = $[2];
    }
    const response = data?.jiraWorkManagementNavData || null;
    let t1;
    if ($[3] !== response || $[4] !== rest) {
        t1 = {
            data: response,
            ...rest
        };
        $[3] = response;
        $[4] = rest;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $7c539f48b5e422bb$export$68dc0ecbea8211d2 = ()=>{
    const $ = (0, $e7boj.c)(6);
    const t0 = $7c539f48b5e422bb$export$5a85006c180fb373();
    let data;
    let rest;
    if ($[0] !== t0) {
        ({ data: data, ...rest } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = rest;
    } else {
        data = $[1];
        rest = $[2];
    }
    const response = data?.jiraSoftwareNavData || null;
    let t1;
    if ($[3] !== response || $[4] !== rest) {
        t1 = {
            data: response,
            ...rest
        };
        $[3] = response;
        $[4] = rest;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $7c539f48b5e422bb$export$5cf90b625d0e1248 = (customContext)=>{
    const $ = (0, $e7boj.c)(6);
    const t0 = $7c539f48b5e422bb$export$5a85006c180fb373(customContext);
    let data;
    let rest;
    if ($[0] !== t0) {
        ({ data: data, ...rest } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = rest;
    } else {
        data = $[1];
        rest = $[2];
    }
    const response = data?.jiraServiceManagementNavData || null;
    let t1;
    if ($[3] !== response || $[4] !== rest) {
        t1 = {
            data: response,
            ...rest
        };
        $[3] = response;
        $[4] = rest;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $7c539f48b5e422bb$export$d63d92edebe543d9 = ()=>{
    const $ = (0, $e7boj.c)(6);
    const t0 = $7c539f48b5e422bb$export$5a85006c180fb373();
    let data;
    let rest;
    if ($[0] !== t0) {
        ({ data: data, ...rest } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = rest;
    } else {
        data = $[1];
        rest = $[2];
    }
    const response = data?.jiraProductDiscoveryNavData || null;
    let t1;
    if ($[3] !== response || $[4] !== rest) {
        t1 = {
            data: response,
            ...rest
        };
        $[3] = response;
        $[4] = rest;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};

});
parcelRegister("g1yQ7", function(module, exports) {
$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $952a23c1938fab53$export$fab84295e18e9246);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $fpjIq = parcelRequire("fpjIq");
const $952a23c1938fab53$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $952a23c1938fab53$export$fab84295e18e9246 = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>$952a23c1938fab53$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $952a23c1938fab53$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $fpjIq.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("4Rvd7", function(module, exports) {
$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $ac8ba5e1522d5931$export$b8c6e2666f12f4bb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $fpjIq = parcelRequire("fpjIq");
const $ac8ba5e1522d5931$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $ac8ba5e1522d5931$export$b8c6e2666f12f4bb = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>$ac8ba5e1522d5931$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $ac8ba5e1522d5931$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $fpjIq.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000,
    isCritical: true
});

});

parcelRegister("ihrBs", function(module, exports) {
$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $6df5bc03c65a4784$export$b662f3f877add30d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $fpjIq = parcelRequire("fpjIq");
const $6df5bc03c65a4784$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $6df5bc03c65a4784$export$b662f3f877add30d = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>$6df5bc03c65a4784$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $6df5bc03c65a4784$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $fpjIq.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("idDnR", function(module, exports) {
$parcel$export(module.exports, "getIdentifier", () => $8505ad5439e8eb76$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $8505ad5439e8eb76$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $8505ad5439e8eb76$export$b692cfadccf4e047);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8S1Gc = parcelRequire("8S1Gc");

var $i0CFV = parcelRequire("i0CFV");

var $i860n = parcelRequire("i860n");

var $dBdbP = parcelRequire("dBdbP");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $41moy = parcelRequire("41moy");
const $8505ad5439e8eb76$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === 'servicedesk-boards' || routeName === 'servicedesk-calendar' || query['servicedesk.serviceDeskId'] || (routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-custom-calendar' || routeName === 'servicedesk-queues-practice-custom-board' || routeName === 'servicedesk-queues-practice-custom-calendar' || routeName === 'servicedesk-queues-views-config' || routeName === 'servicedesk-practice-views-config') && (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') || routeName === 'servicedesk-list' && (0, $i860n.fg)('jsm_list_view_milestone_1')) {
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        return (0, $dBdbP.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    const boardId = (0, $8S1Gc.getBoardId)(match, query);
    return (0, $dBdbP.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $8505ad5439e8eb76$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $8505ad5439e8eb76$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $8505ad5439e8eb76$export$f2dfc0f7b2d92691 = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    // oxlint-disable-next-line typescript/consistent-type-assertions
    getKey: ({ match: match, query: query, route: { name: name } })=>$8505ad5439e8eb76$var$getRouterKey(name, match, query),
    /**
		 * is called on resource's init fetch, or .refresh()
		 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const scopeIdentifier = $8505ad5439e8eb76$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $41moy.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $8505ad5439e8eb76$export$b692cfadccf4e047 = ()=>(0, $k6ufm.useResource)($8505ad5439e8eb76$export$f2dfc0f7b2d92691);

});
parcelRegister("dBdbP", function(module, exports) {
$parcel$export(module.exports, "getScopeIdentifier", () => $53cd72122149125e$export$68278f7cf66944f9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
const $53cd72122149125e$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $f0e9a194674bc930$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $f0e9a194674bc930$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $f0e9a194674bc930$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
/* eslint-disable jira/filename-case */ const $f0e9a194674bc930$export$b5a308a17bc991f3 = 'projectKey';
const $f0e9a194674bc930$export$929d50f83189406c = 'boardId';
const $f0e9a194674bc930$export$da6f46390e1a426f = 'projectId';


parcelRegister("41moy", function(module, exports) {
$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $95a3ae077b1371df$export$8a51470472777e11);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2700E = parcelRequire("2700E");

var $h2wCv = parcelRequire("h2wCv");
const $95a3ae077b1371df$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    if ((0, $2700E.expVal)('frontier-guided-autonomy-eap', 'isEnabled', false)) {
        const params = new URLSearchParams();
        switch(identifierType){
            case 'boardId':
                params.set('boardId', identifierValue);
                break;
            case 'projectKey':
            case 'projectId':
                params.set('projectIdOrKey', identifierValue);
                break;
            default:
                break;
        }
        params.set('includePolicyStatus', 'true');
        return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/sidebar?${params.toString()}`);
    }
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("d7dm3", function(module, exports) {
$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $4a636ba60d80a383$export$61dad767cf446185);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7bJ0J = parcelRequire("7bJ0J");
var $k6ufm = parcelRequire("k6ufm");

var $1zsZc = parcelRequire("1zsZc");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $4a636ba60d80a383$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
function $4a636ba60d80a383$export$61dad767cf446185(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $4a636ba60d80a383$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $7bJ0J.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $k6ufm.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $1zsZc.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}

});
parcelRegister("1zsZc", function(module, exports) {
$parcel$export(module.exports, "usePrefetchableResource", () => $36801649fdfaecae$export$99f17ace416cfe75);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
function $36801649fdfaecae$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $euxye.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("36bRl", function(module, exports) {
$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $3f1d8c84de71c48d$export$780174995da89d60);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $idDnR = parcelRequire("idDnR");

var $7bJ0J = parcelRequire("7bJ0J");
var $f2wVS = parcelRequire("f2wVS");
var $k6ufm = parcelRequire("k6ufm");
const $3f1d8c84de71c48d$export$90dbde7e33e6e21 = ()=>null;
const $3f1d8c84de71c48d$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $7bJ0J.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $3f1d8c84de71c48d$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $3f1d8c84de71c48d$export$19001bab9e4b7f8f = (projectKey)=>{
    const $ = (0, $e7boj.c)(7);
    let t0;
    if ($[0] !== projectKey) {
        t0 = $3f1d8c84de71c48d$export$d647718555c2fdd8(projectKey);
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            routerContext: t0
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const { data: data, update: update } = (0, $k6ufm.useResource)((0, $idDnR.staticProjectSidebarNavigationResource), t1);
    let t2;
    if ($[4] !== data || $[5] !== update) {
        t2 = {
            data: data,
            update: update
        };
        $[4] = data;
        $[5] = update;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $3f1d8c84de71c48d$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $7bJ0J.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $3f1d8c84de71c48d$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $3f1d8c84de71c48d$export$e2bb7877e6cec3eb = (boardId)=>{
    const $ = (0, $e7boj.c)(7);
    let t0;
    if ($[0] !== boardId) {
        t0 = $3f1d8c84de71c48d$export$23dc6491016cabdc(boardId);
        $[0] = boardId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            routerContext: t0
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const { data: data, update: update } = (0, $k6ufm.useResource)((0, $idDnR.staticProjectSidebarNavigationResource), t1);
    let t2;
    if ($[4] !== data || $[5] !== update) {
        t2 = {
            data: data,
            update: update
        };
        $[4] = data;
        $[5] = update;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $3f1d8c84de71c48d$var$useIsOnBoardBasedRoute = (0, $f2wVS.createRouterSelector)(({ route: route, query: query, match: match })=>(0, $idDnR.getIdentifier)(route.name, match, query)?.identifierType === 'boardId');
const $3f1d8c84de71c48d$export$780174995da89d60 = (latestNavInfo)=>{
    const $ = (0, $e7boj.c)(9);
    const isOnBoardBasedRoute = $3f1d8c84de71c48d$var$useIsOnBoardBasedRoute();
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $3f1d8c84de71c48d$export$19001bab9e4b7f8f(pKey);
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $3f1d8c84de71c48d$export$e2bb7877e6cec3eb(boardId);
    let t0;
    let t1;
    if ($[0] !== boardRouteNavInfo || $[1] !== isOnBoardBasedRoute || $[2] !== isSoftwareCMP || $[3] !== latestNavInfo || $[4] !== projectRouteNavInfo || $[5] !== updateBoardRoute || $[6] !== updateProjectRoute) {
        t0 = ()=>{
            if (latestNavInfo != null && isSoftwareCMP) {
                if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
                else if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
            }
        };
        t1 = [
            isOnBoardBasedRoute,
            latestNavInfo,
            updateProjectRoute,
            updateBoardRoute,
            projectRouteNavInfo,
            boardRouteNavInfo,
            isSoftwareCMP
        ];
        $[0] = boardRouteNavInfo;
        $[1] = isOnBoardBasedRoute;
        $[2] = isSoftwareCMP;
        $[3] = latestNavInfo;
        $[4] = projectRouteNavInfo;
        $[5] = updateBoardRoute;
        $[6] = updateProjectRoute;
        $[7] = t0;
        $[8] = t1;
    } else {
        t0 = $[7];
        t1 = $[8];
    }
    (0, $euxye.useEffect)(t0, t1);
};

});



parcelRegister("bKPo4", function(module, exports) {
$parcel$export(module.exports, "layoutWithCondition", () => $ec1fd26b8d3c8821$export$c5db53e93ba35c0f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $ec1fd26b8d3c8821$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});


parcelRegister("ju22D", function(module, exports) {
$parcel$export(module.exports, "globalSettingsLayout", () => $ee169f5a4b3d1877$export$e6aef6083548e882);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2tgz = parcelRequire("h2tgz");

var $QhQu4 = parcelRequire("QhQu4");
const $ee169f5a4b3d1877$export$e6aef6083548e882 = (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout));

});
parcelRegister("h2tgz", function(module, exports) {
$parcel$export(module.exports, "globalLayout", () => $35899f3de8992888$export$929cb72e7acb7fd9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");
const $35899f3de8992888$var$rightSidebars = ()=>[];
const $35899f3de8992888$export$929cb72e7acb7fd9 = (0, $QhQu4.createLayout)({
    rightSidebars: $35899f3de8992888$var$rightSidebars()
});

});




parcelRegister("lfMhu", function(module, exports) {
$parcel$export(module.exports, "adminPagesGlobalAccessManagementRouteEntry", () => $92d04fd8cf10ff1f$export$a136c79b2046d51c);

var $bhY2E = parcelRequire("bhY2E");

var $gdFot = parcelRequire("gdFot");



var $iSoIx = parcelRequire("iSoIx");

var $45Itd = parcelRequire("45Itd");

var $9Q50z = parcelRequire("9Q50z");

var $dUAVJ = parcelRequire("dUAVJ");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $2700E = parcelRequire("2700E");
const $92d04fd8cf10ff1f$var$adminPagesGlobalAccessManagementPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bhY2E.globalAccessManagementEntryPoint)
});
const $92d04fd8cf10ff1f$export$a136c79b2046d51c = (0, $fdS54.createEntry)((0, $gdFot.adminPagesGlobalAccessManagementRoute), ()=>({
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $9Q50z.jiraSpaPageContainerResource)
        ],
        entryPoint () {
            return (0, $2700E.expValEquals)('jira_global_access_management_page_exp', 'isEnabled', true, false) ? $92d04fd8cf10ff1f$var$adminPagesGlobalAccessManagementPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@jira/router-routes__admin-pages-global-access-management-entries',
                whichExportToUse: 'adminPagesGlobalAccessManagementRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bhY2E", function(module, exports) {
$parcel$export(module.exports, "globalAccessManagementEntryPoint", () => $c215c5f8e5b0a36a$export$e405b5fa3fa034a5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $utcJ0 = parcelRequire("utcJ0");
/**
 * ⚠️ Keep in sync with `DEFAULT_FILTERS` and `mapFiltersToInput` in
 * `mapFiltersToInput.tsx`. If the default filter state or mapping changes, update
 * this value too.
 */ const $c215c5f8e5b0a36a$var$DEFAULT_PRELOAD_FILTERS = [
    {
        filterType: 'PROJECT_STYLE',
        values: [
            'COMPANY_MANAGED_PROJECT'
        ]
    }
];

const $c215c5f8e5b0a36a$export$e405b5fa3fa034a5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7A7T0")), {
        moduleId: "13862d09",
        moduleName: "GlobalAccessManagementPageRoot",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, isAdmin: isAdmin } })=>({
            queries: {
                globalAccessManagement: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $utcJ0.default,
                    variables: {
                        cloudId: cloudId,
                        filters: $c215c5f8e5b0a36a$var$DEFAULT_PRELOAD_FILTERS
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                isAdmin: isAdmin
            }
        })
});

});
parcelRegister("utcJ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $441ef37a76681c83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<451caaf5d387ff0e1bd72b5c6d397bb7>>
 * @relayHash 9ff0164f691a0cacd00cfdc1420b0637
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6273c87c071f9520d41ac422175b91e089daa04f688233b11e5c561dba5f9a00
const $441ef37a76681c83$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6273c87c071f9520d41ac422175b91e089daa04f688233b11e5c561dba5f9a00",
        "metadata": {},
        "name": "GlobalAccessManagementPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $441ef37a76681c83$export$2e2bcd8739ae039 = $441ef37a76681c83$var$node;

});

parcelRegister("7A7T0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5REGF").then(()=>parcelRequire('ax2IP'));

});


parcelRegister("gdFot", function(module, exports) {
$parcel$export(module.exports, "adminPagesGlobalAccessManagementRoute", () => $ade390014957b83a$export$742328d02dc1b828);
const $ade390014957b83a$export$742328d02dc1b828 = {
    name: 'global-settings-system-access-management',
    path: '/jira/settings/system/access-management',
    exact: true
};

});


parcelRegister("ee1nh", function(module, exports) {
$parcel$export(module.exports, "aiAnswersRouteEntry", () => $2cf45b7d09b91880$export$7aab6c3a99455d30);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 


var $2cgVv = parcelRequire("2cgVv");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jAJ0w = parcelRequire("jAJ0w");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $66JI4 = parcelRequire("66JI4");

var $74h93 = parcelRequire("74h93");

var $frFzI = parcelRequire("frFzI");

var $dTa0V = parcelRequire("dTa0V");

var $1lV4Z = parcelRequire("1lV4Z");
const $2cf45b7d09b91880$var$aiAnswersPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2cgVv.aiAnswersEntryPoint)
});
const $2cf45b7d09b91880$export$7aab6c3a99455d30 = (0, $fdS54.createEntry)((0, $66JI4.aiAnswersRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_sd_virtual_agent') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-virtual-service-agent') : (0, $l1vE2.isFedRamp)()) return undefined;
            return $2cf45b7d09b91880$var$aiAnswersPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1lV4Z.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $frFzI.VirtualAgentAiAnswersSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $jAJ0w.servicedeskVirtualAgentAiAnswersKbResource)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $0c5c27da6f710ef9$export$8f36d687159615f5 = 'PROJECTS';

const $28266b9d90f7c617$export$624732ab55954dd9 = 'PROJECT_SETTINGS';

parcelRegister("2cgVv", function(module, exports) {
$parcel$export(module.exports, "aiAnswersEntryPoint", () => $ceb95168ac3f8bf4$export$5dcf9a7e1076ac6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $fVaxI = parcelRequire("fVaxI");

const $ceb95168ac3f8bf4$export$5dcf9a7e1076ac6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("krshR")), {
        moduleId: "36edf3a5",
        moduleName: "VirtualAgentAiAnswers",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $fVaxI.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("fVaxI", function(module, exports) {
$parcel$export(module.exports, "default", () => $9533442cc60b426a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfff04ed76657b520c7a03d6720bd8ed>>
 * @relayHash a4b44c4077246f8e7c4b202a8d2b77c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8a1083218f4ae1925ebc7293cffe005d4c27fd510a81ec3ed29391dcca35855

var $k49ny = parcelRequire("k49ny");

var $lIGkE = parcelRequire("lIGkE");
const $9533442cc60b426a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v2 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "isAiEnabledInAdminHub"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "VirtualAgentAiAnswersSrcQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
                                    },
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "virtualAgentConfiguration",
                                        "plural": false,
                                        "selections": [
                                            v6 /*: any*/ ,
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "VirtualAgentAiAnswers731BadPattern"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "VirtualAgentAiAnswers"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "VirtualAgentFeatures",
                                    "kind": "LinkedField",
                                    "name": "virtualAgentEntitlements",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "VirtualAgentAiAnswers165BadPattern"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "VirtualAgentAiAnswersSrcQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAiResponsesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "defaultJiraRequestTypeId"
                                                }
                                            ],
                                            "type": "VirtualAgentConfiguration"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v4 /*: any*/ ,
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBaseArticlesCount",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                }
                                            ],
                                            "type": "KnowledgeBaseArticleCountSource"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isVirtualAgentAvailable"
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v10 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e8a1083218f4ae1925ebc7293cffe005d4c27fd510a81ec3ed29391dcca35855",
            "metadata": {},
            "name": "VirtualAgentAiAnswersSrcQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
            }
        }
    };
}();
$9533442cc60b426a$var$node.hash = "e474422ad56268d77b819344f295767a";
(0, $lIGkE.PreloadableQueryRegistry).set($9533442cc60b426a$var$node.params.id, $9533442cc60b426a$var$node);
var $9533442cc60b426a$export$2e2bcd8739ae039 = $9533442cc60b426a$var$node;

});
parcelRegister("k49ny", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c051c109ad92aab$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $4c051c109ad92aab$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});


parcelRegister("krshR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cMNoX").then(()=>parcelRequire('3Nzw2'));

});


parcelRegister("lbxXL", function(module, exports) {
$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $64facb858b050d93$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $64facb858b050d93$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $64facb858b050d93$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $64facb858b050d93$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $64facb858b050d93$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $64facb858b050d93$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getTriageButtonPermissionResource", () => $64facb858b050d93$export$425007869b82cef8);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $64facb858b050d93$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $64facb858b050d93$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $64facb858b050d93$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $64facb858b050d93$export$54079077c6768752);
$parcel$export(module.exports, "getIssueViewResources", () => $64facb858b050d93$export$590e911b4187f266);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 
var $41FAq = parcelRequire("41FAq");

var $8ycTI = parcelRequire("8ycTI");

var $6RSCO = parcelRequire("6RSCO");

var $34Jgy = parcelRequire("34Jgy");

var $4TFaG = parcelRequire("4TFaG");

var $5adCU = parcelRequire("5adCU");

var $hRSPo = parcelRequire("hRSPo");

var $cDLVA = parcelRequire("cDLVA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $koA6h = parcelRequire("koA6h");

var $iyqMX = parcelRequire("iyqMX");

var $ble5H = parcelRequire("ble5H");

var $j0qHc = parcelRequire("j0qHc");

var $dkOZx = parcelRequire("dkOZx");

var $cpnl1 = parcelRequire("cpnl1");

var $c6i4p = parcelRequire("c6i4p");

var $kqhKu = parcelRequire("kqhKu");

var $lEPfS = parcelRequire("lEPfS");

var $hWEkS = parcelRequire("hWEkS");

var $8HUuJ = parcelRequire("8HUuJ");

var $2DCyG = parcelRequire("2DCyG");

var $4pLi9 = parcelRequire("4pLi9");

var $35eqr = parcelRequire("35eqr");

var $53xPq = parcelRequire("53xPq");

var $dk0Ly = parcelRequire("dk0Ly");

var $9MeJD = parcelRequire("9MeJD");

var $862Zj = parcelRequire("862Zj");

var $idDnR = parcelRequire("idDnR");

var $ihrBs = parcelRequire("ihrBs");

var $4Rvd7 = parcelRequire("4Rvd7");

var $aS6zs = parcelRequire("aS6zs");

var $g1yQ7 = parcelRequire("g1yQ7");

var $hFYSn = parcelRequire("hFYSn");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $l1vE2 = parcelRequire("l1vE2");
const $64facb858b050d93$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $64facb858b050d93$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $dUAVJ.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $hWEkS.incidentExperimentTraitResource),
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $862Zj.staticSidebarShortcutsResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$64facb858b050d93$export$41a9145ddbba28e5(),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_gp_announcements_banner'), (0, $4pLi9.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_gp_announcements_banner'), (0, $4pLi9.jsmGracePeriodAnnouncementGpEndDateResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('sqa-2098-assets-nav-upsell-jsm-free-nav'), (0, $35eqr.postOfficeAssetsMenuItemFreeUsersPlacementResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('grw-214_jsm_jpd_simplified_nav_bar_killswitch'), (0, $dkOZx.isSimplifiedNavResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control feature resource preloading when the parent feature is off.
            $64facb858b050d93$var$isWorkforceAemEnabled() && (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false), (0, $dk0Ly.jsmFeaturesEnabledResource))
    ];
const $64facb858b050d93$export$41a9145ddbba28e5 = ()=>[
        // projectContextResource is a dependency to the priorityGroupsResource
        (0, $edf7u.projectContextResource),
        (0, $cpnl1.queueNav4SidebarSelectionResource),
        (0, $cpnl1.queueSidebarQueuesCategoryStateResource),
        ...$64facb858b050d93$export$9c1c5e389bd00e56(),
        ...$64facb858b050d93$export$2c543d6accc1eb9b()
    ];
const $64facb858b050d93$export$9c1c5e389bd00e56 = ()=>[
        (0, $cpnl1.priorityGroupByProjectIdResourceSsr),
        (0, $lEPfS.featuresResource),
        (0, $aS6zs.staticSidebarJsmReportsResource),
        (0, $6RSCO.getConsolidationStateResource)(),
        (0, $ble5H.servicedeskIsItsmProjectResource),
        (0, $c6i4p.nav3QueueGroupsStateResource)
    ];
const $64facb858b050d93$export$2c543d6accc1eb9b = ()=>[
        (0, $cpnl1.queuesNavigationItems),
        (0, $dkOZx.requiredProjectProperties),
        (0, $dkOZx.requiredFrontendProperties),
        (0, $hFYSn.forgeServiceDeskQueueModuleResource),
        (0, $g1yQ7.staticJSMProjectConnectAddonsNavigationResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $edf7u.projectContextResourceWithCache),
        (0, $dkOZx.firstProjectResource),
        (0, $9MeJD.jsmProjectMenuContentSidebarResource)
    ];
const $64facb858b050d93$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $dUAVJ.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $hWEkS.incidentExperimentTraitResource),
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $862Zj.staticSidebarShortcutsResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
        (0, $j0qHc.servicedeskPracticesResource),
        (0, $iyqMX.serviceDeskContextResource),
        (0, $koA6h.serviceDeskAnalyticsContextResource),
        (0, $dkOZx.firstProjectResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('grw-214_jsm_jpd_simplified_nav_bar_killswitch'), (0, $dkOZx.isSimplifiedNavResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('aem_migration_jira') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent') : !(0, $l1vE2.isFedRamp)(), (0, $kqhKu.virtualAgentOnboardingResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control feature resource preloading when the parent feature is off.
            $64facb858b050d93$var$isWorkforceAemEnabled() && (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false) || (0, $i860n.fg)('jsm_wfo_agent_presence'), (0, $dk0Ly.jsmFeaturesEnabledResource))
    ];
const $64facb858b050d93$export$a8b852f03a310dc0 = ()=>[
        (0, $edf7u.projectContextResourceWithCache),
        (0, $iyqMX.serviceDeskContextResource),
        (0, $koA6h.serviceDeskAnalyticsContextResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_gp_announcements_banner'), (0, $4pLi9.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_gp_announcements_banner'), (0, $4pLi9.jsmGracePeriodAnnouncementGpEndDateResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('sqa-2098-assets-nav-upsell-jsm-free-nav'), (0, $35eqr.postOfficeAssetsMenuItemFreeUsersPlacementResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control feature resource preloading when the parent feature is off.
            $64facb858b050d93$var$isWorkforceAemEnabled() && (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false) || (0, $i860n.fg)('jsm_wfo_agent_presence'), (0, $dk0Ly.jsmFeaturesEnabledResource))
    ];
const $64facb858b050d93$export$70b97995f4d5ef9f = ()=>[
        ...$64facb858b050d93$export$a8b852f03a310dc0(),
        ...$64facb858b050d93$export$bc0bd65e6da57c1f(),
        (0, $cDLVA.getCalendarFilterFieldsResource)()
    ];
const $64facb858b050d93$export$425007869b82cef8 = ()=>[
        (0, $cpnl1.triageButtonPermissionResource)
    ];
const $64facb858b050d93$export$ed87d3b71544c4ef = ()=>[
        (0, $34Jgy.kbConfluenceContextResource)
    ];
const $64facb858b050d93$export$9e0cf1fab0581096 = ()=>[
        (0, $8ycTI.workspaceResource)
    ];
const $64facb858b050d93$export$5f7bcaa978a3e51 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $edf7u.projectContextResource))
    ];
const $64facb858b050d93$export$54079077c6768752 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $hRSPo.getEditModelResource)()),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $4TFaG.getBoardDetailsResource)()),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $edf7u.projectContextResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $2DCyG.uifBoardResource)),
        ...(0, $5adCU.getRapidboardResources)().map((resource)=>(0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];
const $64facb858b050d93$export$590e911b4187f266 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $53xPq.issueCollapsibleGroupDataResource))
    ];

});
parcelRegister("8ycTI", function(module, exports) {
$parcel$export(module.exports, "workspaceResource", () => $ccd5616b1e2a7c59$export$2f02c3f971168d17);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $bOYO0 = parcelRequire("bOYO0");
const $ccd5616b1e2a7c59$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $ccd5616b1e2a7c59$export$2f02c3f971168d17 = (0, $7edbf.createResource)({
    type: $ccd5616b1e2a7c59$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $bOYO0.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("bOYO0", function(module, exports) {
$parcel$export(module.exports, "getUserJsmLicenceState", () => $ab62535975dc2e60$export$65bf73aad2afa39);
$parcel$export(module.exports, "hasAssetsEntitlement", () => $ab62535975dc2e60$export$7bb18d2d90127035);
$parcel$export(module.exports, "isPremiumInstance", () => $ab62535975dc2e60$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isPremiumAssetsInstance", () => $ab62535975dc2e60$export$9e950299c4afea2c);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $ab62535975dc2e60$export$d7b4c32773b1c643);
$parcel$export(module.exports, "isAssetsUser", () => $ab62535975dc2e60$export$752303d076a5ceed);
$parcel$export(module.exports, "useCheckAssetsUser", () => $ab62535975dc2e60$export$c18e70f2beb75f);
$parcel$export(module.exports, "default", () => $ab62535975dc2e60$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $d8LhJ = parcelRequire("d8LhJ");


var $hFtK7 = parcelRequire("hFtK7");

var $d0iX2 = parcelRequire("d0iX2");

var $9FW2d = parcelRequire("9FW2d");

var $eh7eP = parcelRequire("eh7eP");

var $eBpdw = parcelRequire("eBpdw");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $bVqQI = parcelRequire("bVqQI");
const $ab62535975dc2e60$export$530f260cc76f04ff = ()=>'/rest/servicedesk/cmdb/latest/workspace';
const $ab62535975dc2e60$export$65bf73aad2afa39 = (tenantContext)=>{
    const { licensedProducts: licensedProducts, appPermissions: appPermissions } = tenantContext;
    const hasJsmLicence = licensedProducts && licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61];
    const isJsmLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('aurum-997-license-kill-switch')) return {
        userLicensed: tenantContext?.isLicensedAssetsUser === true,
        siteHasJsmInstalled: true,
        siteIsPremium: true
    };
    if (!hasJsmLicence) return {
        siteHasJsmInstalled: false
    };
    return {
        siteHasJsmInstalled: true,
        siteIsPremium: $ab62535975dc2e60$export$abb609d3bcbb74f6(tenantContext),
        userLicensed: isJsmLicensedUser
    };
};
const $ab62535975dc2e60$export$7bb18d2d90127035 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const containsAssetsEntitlement = licensedProducts && licensedProducts[0, $eb8cfa569eede1a9$export$a310f85340477585];
    return containsAssetsEntitlement;
};
const $ab62535975dc2e60$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremiumInstanceEdition = serviceDeskAppEdition === (0, $d8LhJ.PREMIUM_EDITION);
    return isPremiumInstanceEdition;
};
const $ab62535975dc2e60$export$9e950299c4afea2c = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremiumInstanceEdition = serviceDeskAppEdition === (0, $d8LhJ.PREMIUM_EDITION);
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('aurum-997-license-kill-switch')) return true;
    return isPremiumInstanceEdition;
};
const $ab62535975dc2e60$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $ab62535975dc2e60$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $ab62535975dc2e60$export$752303d076a5ceed = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $ab62535975dc2e60$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedJsmUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('aurum-997-license-kill-switch')) return tenantContext?.isLicensedAssetsUser === true;
    return isPremium && isLicensedJsmUser;
};
const $ab62535975dc2e60$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? ids[0].id : null;
};
const $ab62535975dc2e60$var$ERROR_META = {
    id: 'checkIfAssetsUser',
    packageName: 'jiraServicedeskInsightCommonWorkspaceContext',
    teamName: 'astral'
};
const $ab62535975dc2e60$var$INITIAL_LOADING_STATE = {
    isLoading: true,
    isAssetsAdmin: false,
    error: null,
    isValidAssetsUser: null
};
const $ab62535975dc2e60$var$getPermissionSource = (tenantContext)=>{
    // Units path is controlled directly by the workspace-host resolver gate and
    // must not be blocked by legacy JSM kill-switch branching.
    if ((0, $i860n.fg)('astral_units_workspace_host_resolver')) return 'units';
    if (!(0, $i860n.fg)('aurum-997-license-kill-switch')) return 'jsm';
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('jsm_assets_use_assets_resource_for_permissions')) return 'assets';
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext)) return 'combined';
    return 'jsm';
};
const $ab62535975dc2e60$var$getJSMPermissions = (tenantContext)=>({
        isLoading: false,
        isAssetsAdmin: tenantContext.isAdmin,
        error: null,
        isValidAssetsUser: $ab62535975dc2e60$export$d7b4c32773b1c643(tenantContext)
    });
const $ab62535975dc2e60$export$e16b096a3b46294d = async (tenantContext, cmdbSiteCloudId)=>{
    const validation = (0, $bVqQI.validateTenantContext)(tenantContext);
    if (!validation.isValid) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: $ab62535975dc2e60$var$ERROR_META,
            error: validation.error
        });
        return (0, $bVqQI.createDefaultResponse)(validation?.error ?? null);
    }
    const permissionSource = $ab62535975dc2e60$var$getPermissionSource(tenantContext);
    if (permissionSource === 'jsm') return (0, $bVqQI.createSuccessResponse)(false, false);
    try {
        const { isValidAssetsUser: isValidAssetsUser, isAssetsAdmin: isAssetsAdmin } = await (0, $bVqQI.fetchUserPermissions)(tenantContext, cmdbSiteCloudId);
        return (0, $bVqQI.createSuccessResponse)(isValidAssetsUser, isAssetsAdmin);
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: $ab62535975dc2e60$var$ERROR_META,
            error: error instanceof Error ? error : new Error(String(error))
        });
        return (0, $bVqQI.createDefaultResponse)(new Error('Error while fetching user permissions'));
    }
};
const $ab62535975dc2e60$export$c18e70f2beb75f = (tenantContext)=>{
    const productContext = (0, $9FW2d.getProductContext)(tenantContext);
    const { isPending: isResolverPending, isIdle: isResolverIdle, resolvedWorkspaceId: unitAwareWorkspaceId, resolvedCmdbSiteCloudId: resolvedCmdbSiteCloudId } = (0, $d0iX2.useAssetsWorkspaceHost)({
        cloudId: tenantContext.cloudId ?? '',
        productContext: productContext,
        skip: !(0, $i860n.fg)('astral_units_workspace_host_resolver')
    });
    const permissionSource = $ab62535975dc2e60$var$getPermissionSource(tenantContext);
    const shouldFetchFromAPI = permissionSource !== 'jsm';
    // Hook is always called; result is only used when gate is ON and source is 'units'.
    const isUnitsResolverEnabled = permissionSource === 'units';
    const isResolverPendingOrIdle = isResolverPending || isResolverIdle;
    const cmdbSiteCloudId = isUnitsResolverEnabled ? resolvedCmdbSiteCloudId : null;
    const [permissions, setPermissions] = (0, $euxye.useState)($ab62535975dc2e60$var$INITIAL_LOADING_STATE);
    (0, $euxye.useEffect)(()=>{
        // Wait for resolver to settle before firing the permissions API (units path only).
        if (!shouldFetchFromAPI || isUnitsResolverEnabled && isResolverPendingOrIdle) return;
        let isStale = false;
        $ab62535975dc2e60$export$e16b096a3b46294d(tenantContext, cmdbSiteCloudId).then((result)=>{
            if (isStale) return;
            if (permissionSource === 'assets' || isUnitsResolverEnabled) setPermissions({
                ...result,
                unitAwareWorkspaceId: unitAwareWorkspaceId ?? null
            });
            else {
                const jsmPermissions = $ab62535975dc2e60$var$getJSMPermissions(tenantContext);
                setPermissions({
                    ...result,
                    isValidAssetsUser: jsmPermissions.isValidAssetsUser || result.isValidAssetsUser,
                    isAssetsAdmin: jsmPermissions.isAssetsAdmin || result.isAssetsAdmin,
                    unitAwareWorkspaceId: unitAwareWorkspaceId ?? null
                });
            }
        }).catch((error)=>{
            if (isStale) return;
            setPermissions({
                isLoading: false,
                isAssetsAdmin: false,
                error: error instanceof Error ? error : new Error('Unknown error'),
                isValidAssetsUser: null,
                unitAwareWorkspaceId: null
            });
        });
        return ()=>{
            isStale = true;
        };
    }, [
        shouldFetchFromAPI,
        permissionSource,
        tenantContext,
        isUnitsResolverEnabled,
        isResolverPendingOrIdle,
        cmdbSiteCloudId,
        unitAwareWorkspaceId
    ]);
    if (!shouldFetchFromAPI) return $ab62535975dc2e60$var$getJSMPermissions(tenantContext);
    return permissions;
};
const $ab62535975dc2e60$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    const isNotLicensedAssetsUser = (0, $i860n.fg)('aurum-997-license-kill-switch') ? $ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) === false : $ab62535975dc2e60$export$d7b4c32773b1c643(tenantContext) === false;
    if (isNotLicensedAssetsUser || !(0, $eBpdw.isCMDBEnabledInEnvironment)()) return null;
    return (0, $eh7eP.performCmdbGetRequest)($ab62535975dc2e60$export$530f260cc76f04ff()).then($ab62535975dc2e60$var$transformResponse).catch((error)=>{
        (0, $6CfY5.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $ab62535975dc2e60$export$2e2bcd8739ae039 = $ab62535975dc2e60$export$e1d718dfe6dad973;

});
/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

parcelRegister("d0iX2", function(module, exports) {
$parcel$export(module.exports, "useAssetsWorkspaceHost", () => $a9172152a93fe17d$export$1e3c46d4aa45bd29);

var $euxye = parcelRequire("euxye");

var $4PfqE = parcelRequire("4PfqE");

var $4zCiM = parcelRequire("4zCiM");

var $4UF5e = parcelRequire("4UF5e");

var $5PMfa = parcelRequire("5PMfa");

var $f20Ih = parcelRequire("f20Ih");
const $a9172152a93fe17d$var$IDLE_RESULT = {
    status: (0, $4UF5e.AssetsWorkspaceHostStatus).Idle,
    data: null,
    error: null
};
const $a9172152a93fe17d$var$absoluteUrlFn = (path)=>path;
const $a9172152a93fe17d$export$1e3c46d4aa45bd29 = (options)=>{
    const cloudId = options.cloudId;
    const isOnlyWorkspace = options.isOnlyWorkspace === true;
    const productContext = options.productContext ?? (0, $4zCiM.DEFAULT_PRODUCT_CONTEXT);
    const skip = options.skip === true;
    const subscribeForCloudId = (0, $euxye.useCallback)((listener)=>(0, $f20Ih.subscribe)(cloudId, listener), [
        cloudId
    ]);
    const getSnapshotForCloudId = (0, $euxye.useCallback)(()=>(0, $f20Ih.getSnapshot)(cloudId), [
        cloudId
    ]);
    const state = (0, $4PfqE.useSyncExternalStore)(subscribeForCloudId, getSnapshotForCloudId, (0, $f20Ih.getServerSnapshot));
    (0, $euxye.useEffect)(()=>{
        if (skip) return;
        // Trigger fetch on mount, on cloudId change, or when the cached value
        // has gone stale. The fetcher itself is single-flight so multiple
        // hooks won't fan out into multiple network calls.
        //
        // On a cold mount the first paint sees `idle`; the effect synchronously
        // flips the store to `pending` (via `setPending` inside
        // `fetchAssetsWorkspaceHost`) before the network resolves, so the next
        // render reflects in-flight state. Errors land in the store via the
        // fetcher itself; the trailing `.catch` is purely there to avoid an
        // unhandled rejection.
        if (state.status === (0, $4UF5e.AssetsWorkspaceHostStatus).Idle || state.status === (0, $4UF5e.AssetsWorkspaceHostStatus).Success && (0, $f20Ih.isStale)(cloudId)) (0, $5PMfa.fetchAssetsWorkspaceHost)({
            cloudId: cloudId,
            isOnlyWorkspace: isOnlyWorkspace,
            productContext: productContext
        }).catch(()=>{
        // no-op — store already reflects the failure
        });
    }, [
        cloudId,
        isOnlyWorkspace,
        productContext,
        skip,
        state.status
    ]);
    const refetch = (0, $euxye.useCallback)(()=>{
        if (skip) return;
        // `refetch` must never throw — errors are surfaced through the
        // store-driven re-render as `status: 'error' | 'unavailable'`. The
        // IIFE + try/catch guarantees no unhandled rejection escapes into
        // consumers.
        (async ()=>{
            try {
                await (0, $5PMfa.fetchAssetsWorkspaceHost)({
                    cloudId: cloudId,
                    force: true,
                    isOnlyWorkspace: isOnlyWorkspace,
                    productContext: productContext
                });
            } catch  {
            // no-op — store already reflects the failure
            }
        })();
    }, [
        cloudId,
        isOnlyWorkspace,
        productContext,
        skip
    ]);
    return (0, $euxye.useMemo)(()=>{
        const baseState = skip ? $a9172152a93fe17d$var$IDLE_RESULT : state;
        const isSuccess = baseState.status === (0, $4UF5e.AssetsWorkspaceHostStatus).Success;
        const isPending = baseState.status === (0, $4UF5e.AssetsWorkspaceHostStatus).Pending;
        const isIdle = baseState.status === (0, $4UF5e.AssetsWorkspaceHostStatus).Idle;
        return {
            ...baseState,
            refetch: refetch,
            isIdle: isIdle,
            isPending: isPending,
            isSuccess: isSuccess,
            resolvedCmdbSiteCloudId: isSuccess ? baseState.data.cmdbSiteCloudId : null,
            resolvedWorkspaceId: isSuccess ? baseState.data.workspaceId : null,
            toResolvedAbsoluteUrl: isSuccess ? baseState.data.toAbsoluteUrl : $a9172152a93fe17d$var$absoluteUrlFn
        };
    }, [
        skip,
        state,
        refetch
    ]);
};

});
parcelRegister("4zCiM", function(module, exports) {
$parcel$export(module.exports, "ASSETS_WORKSPACE_RESOLVER_URL", () => $3a02860d01e914bd$export$d5944064da6b5466);
$parcel$export(module.exports, "ASSETS_INTERNAL_WORKSPACE_RESOLVER_URL", () => $3a02860d01e914bd$export$4414d2256b85c776);
$parcel$export(module.exports, "PRODUCT_CONTEXTS", () => $3a02860d01e914bd$export$de8c184a7b9b6f88);
$parcel$export(module.exports, "DEFAULT_PRODUCT_CONTEXT", () => $3a02860d01e914bd$export$793674351b5effd0);
$parcel$export(module.exports, "ASSETS_WORKSPACE_HOST_FG", () => $3a02860d01e914bd$export$2a50651233d48dee);
$parcel$export(module.exports, "ASSETS_WORKSPACE_HOST_TTL_MS", () => $3a02860d01e914bd$export$12d07f49ca1cf24e);
/**
 * Resolver endpoint when the caller is content with the canonical Assets
 * workspace (no product context, no Units topology lookup). Returns
 * `WorkspaceLatestResponse { workspaceId, site? }`.
 *
 * Override at call-sites (e.g. for `perms-picker.jira-dev.com`) via the
 * `endpoint` option on `fetchAssetsWorkspaceHost`.
 */ const $3a02860d01e914bd$export$d5944064da6b5466 = '/assets/workspace';
const $3a02860d01e914bd$export$4414d2256b85c776 = '/assets/internal/workspace';
const $3a02860d01e914bd$export$de8c184a7b9b6f88 = {
    JIRA: 'jira',
    JSM: 'jsm',
    CONF: 'confluence'
};
const $3a02860d01e914bd$export$793674351b5effd0 = $3a02860d01e914bd$export$de8c184a7b9b6f88.JSM;
const $3a02860d01e914bd$export$2a50651233d48dee = 'astral_units_workspace_host_resolver';
const $3a02860d01e914bd$export$12d07f49ca1cf24e = 900000;

});

parcelRegister("4UF5e", function(module, exports) {
$parcel$export(module.exports, "AssetsWorkspaceHostStatus", () => $6e32f5e5708895a8$export$6bc692995f96ee11);
/**
 * Resolved Assets workspace coordinates for a tenant.
 *
 * `host === null` means "stay on the current site" (i.e. the BE indicated the
 * Assets UI lives on the same site the user is currently visiting). Consumers
 * should render relative `/jira/assets/...` links in that case.
 *
 * `host === 'foo.atlassian.net'` means consumers must navigate to that host;
 * use `toAbsoluteUrl` to assemble the redirect URL.
 *
 * `relativePath` is typed as `string` (not the template literal
 * `` `/jira/assets/${string}` ``) so that callers passing a router-derived
 * path don't have to cast on every site. The `/jira/assets/` prefix is
 * enforced at runtime by `buildAbsoluteAssetsUrl`.
 *
 * `cmdbSiteCloudId === null` means the BE did not return a Units-aware Assets
 * site cloud id for this tenant (legacy / non-Units site, or BE rollout not
 * yet enabled). When non-null, consumers can use it as the canonical
 * `cloudId` for any per-tenant Assets API call that must target the Assets
 * site explicitly (rather than the current browsing site).
 */ const $6e32f5e5708895a8$export$6bc692995f96ee11 = Object.freeze({
    Idle: 'idle',
    Pending: 'pending',
    Success: 'success',
    Error: 'error',
    Unavailable: 'unavailable'
});

});

parcelRegister("5PMfa", function(module, exports) {
$parcel$export(module.exports, "fetchAssetsWorkspaceHost", () => $e35a3ad0b7c37c15$export$7613e58413f3ecc4);

var $egspI = parcelRequire("egspI");

var $4zCiM = parcelRequire("4zCiM");

var $f20Ih = parcelRequire("f20Ih");

var $1oJAD = parcelRequire("1oJAD");
class $e35a3ad0b7c37c15$export$d8bff91413d1edd8 extends Error {
    constructor(message){
        super(message);
        this.name = 'AssetsWorkspaceHostUnavailableError';
    }
}
const $e35a3ad0b7c37c15$var$toResolvedHost = (response)=>{
    const host = response.site ?? null;
    return Object.freeze({
        workspaceId: response.workspaceId,
        host: host,
        cmdbSiteCloudId: response.cmdbSiteCloudId ?? null,
        toAbsoluteUrl: (relativePath)=>(0, $1oJAD.buildAbsoluteAssetsUrl)(host, relativePath)
    });
};
const $e35a3ad0b7c37c15$var$performFetch = async (cloudId, endpoint)=>{
    let response;
    try {
        response = await fetch(endpoint, {
            method: 'GET',
            credentials: 'include',
            headers: {
                accept: 'application/json',
                'x-atlassian-cloud-id': cloudId
            }
        });
    } catch (networkError) {
        const wrapped = networkError instanceof Error ? networkError : new Error('Network request failed');
        (0, $f20Ih.setError)(cloudId, wrapped);
        throw wrapped;
    }
    if (response.status === 401 || response.status === 403 || response.status === 404) {
        // 401/403 = no entitlement; 404 = tenant has no Assets workspace at all.
        // In every case the consumer should treat Assets as unavailable on this
        // site and fall back to current-site links / hide CTAs.
        (0, $f20Ih.setUnavailable)(cloudId);
        throw new $e35a3ad0b7c37c15$export$d8bff91413d1edd8(`Assets workspace resolver returned ${response.status}`);
    }
    if (!response.ok) {
        const error = new Error(`Assets workspace resolver returned ${response.status}`);
        (0, $f20Ih.setError)(cloudId, error);
        throw error;
    }
    let parsed;
    try {
        parsed = await response.json();
    } catch (parseError) {
        const wrapped = parseError instanceof Error ? parseError : new Error('Failed to parse response');
        (0, $f20Ih.setError)(cloudId, wrapped);
        throw wrapped;
    }
    if (!parsed?.workspaceId) {
        const error = new Error('Assets workspace resolver returned no workspaceId');
        (0, $f20Ih.setError)(cloudId, error);
        throw error;
    }
    const resolved = $e35a3ad0b7c37c15$var$toResolvedHost(parsed);
    (0, $f20Ih.setSuccess)(cloudId, resolved);
    return resolved;
};
const $e35a3ad0b7c37c15$export$a18226397bb190d3 = (isOnlyWorkspace, productContext, endpointOverride)=>{
    if (endpointOverride) return endpointOverride;
    if (isOnlyWorkspace) return 0, $4zCiM.ASSETS_WORKSPACE_RESOLVER_URL;
    return `${0, $4zCiM.ASSETS_INTERNAL_WORKSPACE_RESOLVER_URL}?productContext=${encodeURIComponent(productContext)}`;
};
const $e35a3ad0b7c37c15$export$7613e58413f3ecc4 = async (options)=>{
    const { cloudId: cloudId } = options;
    const isOnlyWorkspace = options.isOnlyWorkspace === true;
    const productContext = options.productContext ?? (0, $4zCiM.DEFAULT_PRODUCT_CONTEXT);
    const endpoint = $e35a3ad0b7c37c15$export$a18226397bb190d3(isOnlyWorkspace, productContext, options.endpoint);
    const force = options.force === true;
    if (!(0, $egspI.fg)('astral_units_workspace_host_resolver')) {
        (0, $f20Ih.setUnavailable)(cloudId);
        throw new $e35a3ad0b7c37c15$export$d8bff91413d1edd8(`Feature gate ${(0, $4zCiM.ASSETS_WORKSPACE_HOST_FG)} is disabled`);
    }
    if (!force) {
        const inFlight = (0, $f20Ih.getInFlight)(cloudId);
        if (inFlight) return inFlight;
        const snapshot = (0, $f20Ih.getSnapshot)(cloudId);
        if (snapshot.status === 'success' && !(0, $f20Ih.isStale)(cloudId)) return snapshot.data;
    }
    const promise = $e35a3ad0b7c37c15$var$performFetch(cloudId, endpoint);
    (0, $f20Ih.setPending)(cloudId, promise);
    return promise;
};

});
parcelRegister("f20Ih", function(module, exports) {
$parcel$export(module.exports, "subscribe", () => $ccb007b9e54c37d1$export$ec068583843480e7);
$parcel$export(module.exports, "getSnapshot", () => $ccb007b9e54c37d1$export$ab60d92959c37070);
$parcel$export(module.exports, "getServerSnapshot", () => $ccb007b9e54c37d1$export$49cf9391e7b62e1c);
$parcel$export(module.exports, "isStale", () => $ccb007b9e54c37d1$export$df02c0d2ad8eb344);
$parcel$export(module.exports, "getInFlight", () => $ccb007b9e54c37d1$export$f3439ec52e93836e);
$parcel$export(module.exports, "setPending", () => $ccb007b9e54c37d1$export$d795f724e6e0026b);
$parcel$export(module.exports, "setSuccess", () => $ccb007b9e54c37d1$export$eb22f9fe6aa0528e);
$parcel$export(module.exports, "setError", () => $ccb007b9e54c37d1$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "setUnavailable", () => $ccb007b9e54c37d1$export$f8b8927805defd0a);

var $4zCiM = parcelRequire("4zCiM");

var $4UF5e = parcelRequire("4UF5e");
const $ccb007b9e54c37d1$var$cache = new Map();
const $ccb007b9e54c37d1$var$subscribers = new Map();
const $ccb007b9e54c37d1$var$PENDING_STATE = {
    status: (0, $4UF5e.AssetsWorkspaceHostStatus).Pending,
    data: null,
    error: null
};
const $ccb007b9e54c37d1$var$IDLE_STATE = {
    status: (0, $4UF5e.AssetsWorkspaceHostStatus).Idle,
    data: null,
    error: null
};
const $ccb007b9e54c37d1$var$notify = (cloudId)=>{
    const listeners = $ccb007b9e54c37d1$var$subscribers.get(cloudId);
    if (!listeners) return;
    listeners.forEach((listener)=>{
        listener();
    });
};
const $ccb007b9e54c37d1$export$ec068583843480e7 = (cloudId, listener)=>{
    let listeners = $ccb007b9e54c37d1$var$subscribers.get(cloudId);
    if (!listeners) {
        listeners = new Set();
        $ccb007b9e54c37d1$var$subscribers.set(cloudId, listeners);
    }
    listeners.add(listener);
    return ()=>{
        listeners?.delete(listener);
        if (listeners && listeners.size === 0) $ccb007b9e54c37d1$var$subscribers.delete(cloudId);
    };
};
const $ccb007b9e54c37d1$export$ab60d92959c37070 = (cloudId)=>{
    const entry = $ccb007b9e54c37d1$var$cache.get(cloudId);
    return entry ? entry.state : $ccb007b9e54c37d1$var$IDLE_STATE;
};
const $ccb007b9e54c37d1$export$49cf9391e7b62e1c = ()=>$ccb007b9e54c37d1$var$PENDING_STATE;
const $ccb007b9e54c37d1$export$df02c0d2ad8eb344 = (cloudId, now = Date.now())=>{
    const entry = $ccb007b9e54c37d1$var$cache.get(cloudId);
    if (!entry || entry.state.status !== (0, $4UF5e.AssetsWorkspaceHostStatus).Success) return true;
    return now - entry.resolvedAt > (0, $4zCiM.ASSETS_WORKSPACE_HOST_TTL_MS);
};
const $ccb007b9e54c37d1$export$f3439ec52e93836e = (cloudId)=>{
    return $ccb007b9e54c37d1$var$cache.get(cloudId)?.inFlight ?? null;
};
const $ccb007b9e54c37d1$export$d795f724e6e0026b = (cloudId, inFlight)=>{
    const previous = $ccb007b9e54c37d1$var$cache.get(cloudId);
    $ccb007b9e54c37d1$var$cache.set(cloudId, {
        // Preserve the previously-cached success value (if any) so consumers
        // keep rendering the last-known answer while a background refresh is
        // in flight. Only switch to `pending` on a true cold start.
        state: previous && previous.state.status === (0, $4UF5e.AssetsWorkspaceHostStatus).Success ? previous.state : $ccb007b9e54c37d1$var$PENDING_STATE,
        resolvedAt: previous?.resolvedAt ?? 0,
        inFlight: inFlight
    });
    $ccb007b9e54c37d1$var$notify(cloudId);
};
const $ccb007b9e54c37d1$export$eb22f9fe6aa0528e = (cloudId, data, now = Date.now())=>{
    $ccb007b9e54c37d1$var$cache.set(cloudId, {
        state: {
            status: (0, $4UF5e.AssetsWorkspaceHostStatus).Success,
            data: data,
            error: null
        },
        resolvedAt: now,
        inFlight: null
    });
    $ccb007b9e54c37d1$var$notify(cloudId);
};
const $ccb007b9e54c37d1$export$b8d0bb2aa0adefe5 = (cloudId, error)=>{
    $ccb007b9e54c37d1$var$cache.set(cloudId, {
        state: {
            status: (0, $4UF5e.AssetsWorkspaceHostStatus).Error,
            data: null,
            error: error
        },
        resolvedAt: Date.now(),
        inFlight: null
    });
    $ccb007b9e54c37d1$var$notify(cloudId);
};
const $ccb007b9e54c37d1$export$f8b8927805defd0a = (cloudId)=>{
    $ccb007b9e54c37d1$var$cache.set(cloudId, {
        state: {
            status: (0, $4UF5e.AssetsWorkspaceHostStatus).Unavailable,
            data: null,
            error: null
        },
        resolvedAt: Date.now(),
        inFlight: null
    });
    $ccb007b9e54c37d1$var$notify(cloudId);
};
const $ccb007b9e54c37d1$export$bde446d0140e5218 = (cloudId)=>{
    if (cloudId === undefined) {
        const keys = Array.from($ccb007b9e54c37d1$var$cache.keys());
        $ccb007b9e54c37d1$var$cache.clear();
        keys.forEach($ccb007b9e54c37d1$var$notify);
        return;
    }
    $ccb007b9e54c37d1$var$cache.delete(cloudId);
    $ccb007b9e54c37d1$var$notify(cloudId);
};
const $ccb007b9e54c37d1$export$472c62b7703c58cb = ()=>{
    $ccb007b9e54c37d1$var$cache.clear();
    $ccb007b9e54c37d1$var$subscribers.clear();
};

});

parcelRegister("1oJAD", function(module, exports) {
$parcel$export(module.exports, "buildAbsoluteAssetsUrl", () => $250d6c690f3e68a1$export$13280a0d91d84f3e);
/**
 * Assemble an absolute (or relative) Assets URL given the resolved host.
 *
 * - `host === null` (same-site)            → returns the relative `path`
 * - `host === 'foo.atlassian.net'`         → returns `https://foo.atlassian.net${path}`
 * - `host === 'localhost:8080'` + opts     → returns `http://localhost:8080${path}` when
 *                                            `protocol: 'http'` is passed (test/dev only)
 *
 * The `relativePath` must start with `/jira/assets/...`. This is enforced at
 * runtime (see the guard below) rather than at the type level so that callers
 * passing a router-derived `string` don't have to cast every time. A
 * mismatched prefix throws synchronously, surfacing the bug immediately.
 *
 * `protocol` defaults to `'https'` and is **only** intended as an escape hatch
 * for localhost / `*.jira-dev.com` test environments. Production call-sites
 * should never pass it.
 */ const $250d6c690f3e68a1$export$13280a0d91d84f3e = (host, relativePath, options = {})=>{
    if (host === null || host === '') return relativePath;
    // Strip any accidental scheme the caller may have included so we never
    // produce a `https://https://...` URL when the caller is lazy.
    const normalisedHost = host.replace(/^https?:\/\//, '');
    const protocol = options.protocol ?? 'https';
    return `${protocol}://${normalisedHost}${relativePath}`;
};

});



parcelRegister("9FW2d", function(module, exports) {
$parcel$export(module.exports, "getProductContext", () => $d8ccfa179adff4d8$export$3da3a958bc7f4396);

var $4zCiM = parcelRequire("4zCiM");
const $d8ccfa179adff4d8$export$3da3a958bc7f4396 = (tenantContext)=>{
    const appPermissions = tenantContext.appPermissions ?? {};
    // Jira Software access (with or without JSM) resolves to the Jira product context.
    if (appPermissions.hasSoftwareAccess) return (0, $4zCiM.PRODUCT_CONTEXTS).JIRA;
    if (appPermissions.hasServiceDeskAccess) return (0, $4zCiM.PRODUCT_CONTEXTS).JSM;
};

});

parcelRegister("eh7eP", function(module, exports) {
$parcel$export(module.exports, "performCmdbGetRequest", () => $2dcbf58202cde5a1$export$a252413f43ec7247);
$parcel$export(module.exports, "performCmdbPostRequest", () => $2dcbf58202cde5a1$export$d68a9f67166d25a2);
$parcel$export(module.exports, "performCmdbPutRequest", () => $2dcbf58202cde5a1$export$326b7407f501f98b);
$parcel$export(module.exports, "performCmdbDeleteRequest", () => $2dcbf58202cde5a1$export$b198eb14f22c12e6);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");

var $ff8AH = parcelRequire("ff8AH");

var $h2wCv = parcelRequire("h2wCv");
const $2dcbf58202cde5a1$export$d5e211a0106aa636 = {
    'X-Request-Source': 'cmdb-frontend'
};
const $2dcbf58202cde5a1$export$a252413f43ec7247 = (url, options)=>(0, $h2wCv.performGetRequest)(url, $2dcbf58202cde5a1$export$235b7fc70b9fc359(url, options));
const $2dcbf58202cde5a1$export$d68a9f67166d25a2 = (url, options)=>(0, $h2wCv.performPostRequest)(url, $2dcbf58202cde5a1$export$235b7fc70b9fc359(url, options));
const $2dcbf58202cde5a1$export$326b7407f501f98b = (url, options)=>(0, $h2wCv.performPutRequest)(url, $2dcbf58202cde5a1$export$235b7fc70b9fc359(url, options));
const $2dcbf58202cde5a1$export$b198eb14f22c12e6 = (url, options)=>(0, $h2wCv.performDeleteRequest)(url, $2dcbf58202cde5a1$export$235b7fc70b9fc359(url, options));
const $2dcbf58202cde5a1$export$235b7fc70b9fc359 = (url, options)=>{
    const defaultOptions = (0, $ff8AH.getDefaultOptions)(url);
    return (0, $i860n.fg)('fly-2529-cmdb-client-send-request-source-header') ? {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers,
            ...$2dcbf58202cde5a1$export$d5e211a0106aa636
        }
    } : options;
};

});

parcelRegister("eBpdw", function(module, exports) {
$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $565c236a412fbde8$export$6dbfb62369f79a64);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $565c236a412fbde8$export$6dbfb62369f79a64 = ()=>true;

});

parcelRegister("bVqQI", function(module, exports) {
$parcel$export(module.exports, "validateTenantContext", () => $39124c3aa5c640b7$export$798f02752f5df48d);
$parcel$export(module.exports, "createDefaultResponse", () => $39124c3aa5c640b7$export$aea1b9db44368b56);
$parcel$export(module.exports, "createSuccessResponse", () => $39124c3aa5c640b7$export$58e6f0371860b4f0);
$parcel$export(module.exports, "fetchUserPermissions", () => $39124c3aa5c640b7$export$9a9b8ec4992a97eb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");
const $39124c3aa5c640b7$var$PERMISSIONS_BULK_PERMITTED_URL = '/gateway/api/permissions/bulk/permitted';
const $39124c3aa5c640b7$var$ERROR_META = {
    packageName: 'jiraServicedeskInsightCommonWorkspaceContext',
    teamName: 'astral'
};
const $39124c3aa5c640b7$export$3edf18358e7f92f5 = (userId, cloudId)=>{
    if (!userId || !cloudId) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: new Error('User ID or cloud ID is missing in getPermissionsRequestPayload'),
            meta: {
                ...$39124c3aa5c640b7$var$ERROR_META,
                id: 'getPermissionsRequestPayload'
            }
        });
        return [];
    }
    return [
        {
            resourceId: `ari:cloud:cmdb::site/${cloudId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'write'
        },
        {
            resourceId: `ari:cloud:cmdb::site/${cloudId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage'
        }
    ];
};
const $39124c3aa5c640b7$export$873112f149f60559 = (response)=>{
    return {
        isValidAssetsUser: response.some((permission)=>permission.permissionId === 'write' && permission.permitted),
        isAssetsAdmin: response.some((permission)=>permission.permissionId === 'manage' && permission.permitted)
    };
};
const $39124c3aa5c640b7$export$798f02752f5df48d = (tenantContext)=>{
    if (!tenantContext) return {
        isValid: false,
        error: new Error('Tenant context is missing')
    };
    if (!tenantContext.atlassianAccountId || !tenantContext.cloudId) return {
        isValid: false,
        error: new Error('Tenant context is missing required fields (atlassianAccountId or cloudId)')
    };
    return {
        isValid: true
    };
};
const $39124c3aa5c640b7$export$aea1b9db44368b56 = (error)=>{
    return {
        isValidAssetsUser: null,
        isAssetsAdmin: false,
        error: error ?? new Error('Error while fetching user permissions'),
        isLoading: false
    };
};
const $39124c3aa5c640b7$export$58e6f0371860b4f0 = (isValidAssetsUser, isAssetsAdmin)=>{
    return {
        isValidAssetsUser: isValidAssetsUser,
        isAssetsAdmin: isAssetsAdmin,
        error: null,
        isLoading: false
    };
};
const $39124c3aa5c640b7$export$9a9b8ec4992a97eb = async (tenantContext, cmdbSiteCloudId)=>{
    const resolvedCloudId = cmdbSiteCloudId && (0, $i860n.fg)('astral_units_workspace_host_resolver') ? cmdbSiteCloudId : tenantContext.cloudId ?? '';
    const payload = $39124c3aa5c640b7$export$3edf18358e7f92f5(tenantContext.atlassianAccountId ?? '', resolvedCloudId);
    if (payload.length === 0) throw new Error('Failed to create permissions request payload');
    const response = await (0, $h2wCv.performPostRequest)($39124c3aa5c640b7$var$PERMISSIONS_BULK_PERMITTED_URL, {
        body: JSON.stringify(payload)
    });
    if (!Array.isArray(response)) throw new Error('Invalid response format from permissions API');
    return $39124c3aa5c640b7$export$873112f149f60559(response);
};

});



parcelRegister("34Jgy", function(module, exports) {
$parcel$export(module.exports, "kbConfluenceContextResource", () => $300c6488016ddc3c$export$8b58be1423986d17);

var $7edbf = parcelRequire("7edbf");
const $300c6488016ddc3c$var$RESOURCE_TYPE_KB_CONFLUENCE_CONTEXT = 'KB_CONFLUENCE_CONTEXT';

const $300c6488016ddc3c$export$8b58be1423986d17 = (0, $7edbf.createResource)({
    type: $300c6488016ddc3c$var$RESOURCE_TYPE_KB_CONFLUENCE_CONTEXT,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("gawmn")),
    maxAge: Infinity
});

});
parcelRegister("gawmn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dTcpy").then(()=>parcelRequire('2cLFW'));

});


parcelRegister("4TFaG", function(module, exports) {
$parcel$export(module.exports, "boardDetailsResource", () => $b92da9ff748cae7e$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $b92da9ff748cae7e$export$b67eabcfc08e7c62);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");

var $5hHWs = parcelRequire("5hHWs");
const $b92da9ff748cae7e$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $4fhEY.default)(`/rest/agile/1.0/board/${boardId}`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $b92da9ff748cae7e$export$6c6984c55b171c5d = (0, $7edbf.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $5hHWs.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $5hHWs.getConfigFromRouterContext)(routerContext)) return $b92da9ff748cae7e$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $b92da9ff748cae7e$export$b67eabcfc08e7c62 = ()=>$b92da9ff748cae7e$export$6c6984c55b171c5d;

});
parcelRegister("5hHWs", function(module, exports) {
$parcel$export(module.exports, "buildAllDataQueryParams", () => $bb4fb1cba6fa8636$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $bb4fb1cba6fa8636$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $bb4fb1cba6fa8636$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $bb4fb1cba6fa8636$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $bb4fb1cba6fa8636$export$1705c550e5b835bf);

var $RX0OA = parcelRequire("RX0OA");
const $bb4fb1cba6fa8636$var$RAPID_VIEW_ROUTE_CONFIG = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $RX0OA.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $RX0OA.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $RX0OA.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};
const $bb4fb1cba6fa8636$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $bb4fb1cba6fa8636$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $bb4fb1cba6fa8636$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $bb4fb1cba6fa8636$var$cleanUpInlineScript(dataName);
        return null;
    }
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $bb4fb1cba6fa8636$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $bb4fb1cba6fa8636$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $bb4fb1cba6fa8636$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values($bb4fb1cba6fa8636$var$RAPID_VIEW_ROUTE_CONFIG)){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return $bb4fb1cba6fa8636$var$RAPID_VIEW_ROUTE_CONFIG.DEFAULT;
};
const $bb4fb1cba6fa8636$export$7bff98a3d459b1b8 = (view)=>{
    if (view) {
        const routeConfig = $bb4fb1cba6fa8636$export$62c86c4062215346(view);
        return [
            ...(0, $RX0OA.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...routeConfig.resources
        ];
    }
    return [
        ...(0, $RX0OA.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...$bb4fb1cba6fa8636$var$RAPID_VIEW_ROUTE_CONFIG.DEFAULT.resources
    ];
};
function $bb4fb1cba6fa8636$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("RX0OA", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $b233c81a617d544c$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $b233c81a617d544c$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $b233c81a617d544c$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $b233c81a617d544c$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $b233c81a617d544c$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $b233c81a617d544c$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $b233c81a617d544c$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $b233c81a617d544c$export$1f599d2eef0a7281);
/* eslint-disable jira/filename-case */ const $b233c81a617d544c$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $b233c81a617d544c$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $b233c81a617d544c$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $b233c81a617d544c$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $b233c81a617d544c$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $b233c81a617d544c$export$ccd0929652c235de = [];
const $b233c81a617d544c$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $b233c81a617d544c$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});



parcelRegister("5adCU", function(module, exports) {
$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $222c9dc31eea423b$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $222c9dc31eea423b$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $222c9dc31eea423b$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $222c9dc31eea423b$export$ee826506b3baa13a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5zPGY = parcelRequire("5zPGY");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $lWWxm = parcelRequire("lWWxm");

var $lTx7u = parcelRequire("lTx7u");

var $gUW7f = parcelRequire("gUW7f");
const $222c9dc31eea423b$export$d8d4641986a9ac7f = ()=>!false;
const $222c9dc31eea423b$export$462ca08d6ce67848 = ()=>!$222c9dc31eea423b$export$d8d4641986a9ac7f();
const $222c9dc31eea423b$export$3a5e56bd5231a56b = ()=>[
        (0, $gUW7f.wrmBundleResource),
        (0, $8HUuJ.resourceWithCondition)($222c9dc31eea423b$export$462ca08d6ce67848, (0, $lTx7u.rapidboardResource))
    ];
const $222c9dc31eea423b$export$1c63de7f548f965f = ()=>(0, $lWWxm.boardDataResource);
const $222c9dc31eea423b$export$ee826506b3baa13a = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira_backlog_use_agg_data') && ($222c9dc31eea423b$export$d8d4641986a9ac7f() || (0, $i860n.fg)('enable_ssr_for_cmp_backlog')), (0, $5zPGY.uifBacklogResource))
    ];

});
parcelRegister("5zPGY", function(module, exports) {
$parcel$export(module.exports, "uifBacklogResource", () => $550d684f0cbd80fe$export$c182dffb98985208);
$parcel$export(module.exports, "backlogCMPViewSettingsResource", () => $550d684f0cbd80fe$export$c55e28f9f40a34b6);
/* eslint-disable jira/import-whitelist */ 
var $84hrb = parcelRequire("84hrb");

var $7edbf = parcelRequire("7edbf");

var $htsFl = parcelRequire("htsFl");

var $hOmct = parcelRequire("hOmct");


const $550d684f0cbd80fe$export$c182dffb98985208 = (0, $7edbf.createResource)({
    type: (0, $905d27e2ee248454$export$9e8bdcc0a845183c),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("hJ3D1")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});
const $550d684f0cbd80fe$var$getQuery = ({ match: match }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const viewId = (0, $hOmct.JiraViewAri).create({
        activationId: activationId,
        siteId: cloudId,
        scopeId: `${Number(match.params.boardId)}/backlog`,
        scopeType: 'board'
    }).toString();
    return {
        options: {
            fetchPolicy: 'network-only'
        },
        parameters: $84hrb.default,
        variables: {
            input: {
                jiraBacklogViewQueryInput: {
                    viewId: viewId
                }
            }
        }
    };
};
const $550d684f0cbd80fe$export$c55e28f9f40a34b6 = (0, $htsFl.createRelayResource)({
    type: 'BACKLOG_CMP_VIEW_SETTINGS_RESOURCE',
    getQuery: $550d684f0cbd80fe$var$getQuery
});

});
parcelRegister("84hrb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8f16d119b0669f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b686725359e6473097e7aaa93b5bcda>>
 * @relayHash d81b863e337bab456d5583fcb5186c7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52f63102e665a99d7b9761662b5902255ab4f3a7c4b177db295a3c0d8f178b54
const $d8f16d119b0669f5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52f63102e665a99d7b9761662b5902255ab4f3a7c4b177db295a3c0d8f178b54",
        "metadata": {},
        "name": "ViewSettingsDataResolverQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d8f16d119b0669f5$export$2e2bcd8739ae039 = $d8f16d119b0669f5$var$node;

});

parcelRegister("hOmct", function(module, exports) {
$parcel$export(module.exports, "JiraViewAri", () => $cf7853b109db3a1d$export$259cce321cdbcc);

var $6yms7 = parcelRequire("6yms7");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/view/manifest.ts
var $cf7853b109db3a1d$var$jiraViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $6yms7.JiraViewAriResourceOwner),
    resourceType: (0, $6yms7.JiraViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{scopeType}/{scopeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        scopeType: /(global|project|board|subcontainer)/,
        scopeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/view/index.ts
var $cf7853b109db3a1d$export$259cce321cdbcc = class _JiraViewAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._scopeType = opts.resourceIdSegmentValues.scopeType, this._scopeId = opts.resourceIdSegmentValues.scopeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get scopeType() {
        return this._scopeType;
    }
    get scopeId() {
        return this._scopeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cf7853b109db3a1d$var$jiraViewAriStaticOpts.qualifier,
            platformQualifier: $cf7853b109db3a1d$var$jiraViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $cf7853b109db3a1d$var$jiraViewAriStaticOpts.resourceOwner,
            resourceType: $cf7853b109db3a1d$var$jiraViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.scopeType}/${opts.scopeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                scopeType: opts.scopeType,
                scopeId: opts.scopeId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $cf7853b109db3a1d$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $cf7853b109db3a1d$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            scopeType: this.scopeType,
            scopeId: this.scopeId
        };
    }
};

});
parcelRegister("6yms7", function(module, exports) {
$parcel$export(module.exports, "JiraViewAriResourceOwner", () => $4c5755a48e69ab9a$export$c63cbf12e88f62b6);
$parcel$export(module.exports, "JiraViewAriResourceType", () => $4c5755a48e69ab9a$export$4b456bf9436bd47e);
// src/jira/view/types.ts
var $4c5755a48e69ab9a$export$c63cbf12e88f62b6 = "jira", $4c5755a48e69ab9a$export$4b456bf9436bd47e = "view";

});


/* eslint-disable jira/filename-case */ const $905d27e2ee248454$export$9e8bdcc0a845183c = 'NEXTGEN_BACKLOG_REST';

parcelRegister("hJ3D1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fhD9").then(()=>parcelRequire('jVUT1'));

});


parcelRegister("lWWxm", function(module, exports) {
$parcel$export(module.exports, "boardDataResource", () => $5a48fa90b00fc065$export$138fa635416978f7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $RX0OA = parcelRequire("RX0OA");

var $2ch02 = parcelRequire("2ch02");

const $5a48fa90b00fc065$export$138fa635416978f7 = (0, $7edbf.createResource)({
    type: (0, $RX0OA.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $2ch02.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $2ch02.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("d0KZV")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("2ch02", function(module, exports) {
$parcel$export(module.exports, "isBoardRoute", () => $856113e2bdd02c3c$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $856113e2bdd02c3c$export$bcb853db5e3e8054);
/* eslint-disable jira/filename-case */ const $856113e2bdd02c3c$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $856113e2bdd02c3c$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("d0KZV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("exhQO").then(()=>parcelRequire('4YDvZ'));

});


parcelRegister("lTx7u", function(module, exports) {
$parcel$export(module.exports, "rapidboardResource", () => $6a78f08fbabc4d0d$export$d0f42a55e7c5752c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $RX0OA = parcelRequire("RX0OA");

const $6a78f08fbabc4d0d$export$d0f42a55e7c5752c = (0, $7edbf.createResource)({
    type: (0, $RX0OA.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("k0Mx1")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("k0Mx1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7n8kc").then(()=>parcelRequire('iSNNe'));

});


parcelRegister("gUW7f", function(module, exports) {
$parcel$export(module.exports, "wrmBundleResource", () => $f65c7e4505601184$export$f199d15b7cd18df1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $RX0OA = parcelRequire("RX0OA");

var $5hHWs = parcelRequire("5hHWs");

const $f65c7e4505601184$export$f199d15b7cd18df1 = (0, $7edbf.createResource)({
    type: (0, $RX0OA.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>(0, $5hHWs.getRapidViewConfigFromRouteName)(route.name).stateKey,
    getDataLoader: ()=>(parcelRequire("eKqgA")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("eKqgA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gB0Sj").then(()=>parcelRequire('hC2wB'));

});



parcelRegister("hRSPo", function(module, exports) {
$parcel$export(module.exports, "editModelResource", () => $45f37c70ca8c3966$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $45f37c70ca8c3966$export$5b9bac2cc4bf4511);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");

var $5hHWs = parcelRequire("5hHWs");
const $45f37c70ca8c3966$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $4fhEY.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $45f37c70ca8c3966$export$ab9a4786826fd2d = (0, $7edbf.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $5hHWs.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $5hHWs.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $45f37c70ca8c3966$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $45f37c70ca8c3966$export$5b9bac2cc4bf4511 = ()=>$45f37c70ca8c3966$export$ab9a4786826fd2d;

});

parcelRegister("cDLVA", function(module, exports) {
$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $75e9ce1b7278a590$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $75e9ce1b7278a590$export$70361b748d216408);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i0CFV = parcelRequire("i0CFV");

var $lCetP = parcelRequire("lCetP");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $i860n = parcelRequire("i860n");

var $gZTDI = parcelRequire("gZTDI");


var $7EAfq = parcelRequire("7EAfq");
const $75e9ce1b7278a590$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $408078b2e2b06241$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return 0, $gZTDI.DEFAULT_CALENDAR_FILTER_FIELDS;
        return [
            {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate.key,
                fieldType: requestTypeField.type
            },
            ...(0, $gZTDI.DEFAULT_CALENDAR_FILTER_FIELDS)
        ];
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $lCetP.isHttpClientErrorResponse)(error)) (0, $7EAfq.reportError)(error);
        return 0, $gZTDI.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $75e9ce1b7278a590$var$filterFieldsResource = (0, $7edbf.createResource)({
    type: (0, $gZTDI.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $i860n.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $gZTDI.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $gZTDI.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$75e9ce1b7278a590$var$fetchFilterFields(cloudId),
    maxAge: Infinity
});
const $75e9ce1b7278a590$export$5f02bf5f04197ed7 = ()=>$75e9ce1b7278a590$var$filterFieldsResource;
const $75e9ce1b7278a590$export$70361b748d216408 = ({ isSimplified: isSimplified })=>{
    const resource = (0, $k6ufm.useResource)($75e9ce1b7278a590$var$filterFieldsResource);
    (0, $euxye.useEffect)(()=>{
        if (!isSimplified && !resource.loading && !resource.error && !resource.data?.find((field)=>typeof field === 'object' && Object.values(field).includes((0, $7EAfq.TARGET_FILTER_TYPE)))) (0, $7EAfq.reportError)(new Error('Unable to prefetch request type'));
    }, [
        isSimplified,
        resource.data,
        resource.error,
        resource.loading
    ]);
    return resource;
};

});
parcelRegister("gZTDI", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $ae29b70ba5b511f0$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $ae29b70ba5b511f0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $ae29b70ba5b511f0$export$d57b6b390e78d90f);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $ae29b70ba5b511f0$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $ae29b70ba5b511f0$export$2912f30d4328fc00);
/* eslint-disable jira/filename-case */ const $ae29b70ba5b511f0$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $ae29b70ba5b511f0$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $ae29b70ba5b511f0$export$d57b6b390e78d90f = 'jsd-shield';
const $ae29b70ba5b511f0$export$2c388650eabddf5e = 'request type';
const $ae29b70ba5b511f0$export$2fcf90614ee15858 = 'service desk origin';
const $ae29b70ba5b511f0$export$43482ff574598f59 = 'cf[10010]';
const $ae29b70ba5b511f0$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $ae29b70ba5b511f0$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

/* eslint-disable jira/filename-case */ const $408078b2e2b06241$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;

parcelRegister("7EAfq", function(module, exports) {
$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $a3e2de59b921b526$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $a3e2de59b921b526$export$b33b857ad1d9900e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $gZTDI = parcelRequire("gZTDI");
const $a3e2de59b921b526$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $a3e2de59b921b526$export$b33b857ad1d9900e = (error)=>{
    (0, $hFtK7.fireErrorAnalytics)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $gZTDI.RESOURCE_TYPE_NAME),
            packageName: (0, $gZTDI.PACKAGE_NAME),
            teamName: (0, $gZTDI.TEAM_NAME)
        }
    });
};

});


parcelRegister("koA6h", function(module, exports) {
$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $8c7bb5af7a76d850$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $8c7bb5af7a76d850$export$bc2de1c42df30b10);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fLTsc = parcelRequire("fLTsc");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $8c7bb5af7a76d850$var$RESOURCE_TYPE_SERVICEDESK_ANALYTICS_CONTEXT = 'SERVICEDESK_ANALYTICS_CONTEXT';
const $8c7bb5af7a76d850$var$ONE_DAY_IN_MILLIS = 86400000;

const $8c7bb5af7a76d850$export$d6f4f0483916919f = (0, $7edbf.createResource)({
    type: $8c7bb5af7a76d850$var$RESOURCE_TYPE_SERVICEDESK_ANALYTICS_CONTEXT,
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("herA5")),
    maxAge: $8c7bb5af7a76d850$var$ONE_DAY_IN_MILLIS
});
const $8c7bb5af7a76d850$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)($8c7bb5af7a76d850$export$d6f4f0483916919f);
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $euxye.useMemo)(()=>({
            data: data,
            loading: loading,
            // oxlint-disable-next-line typescript/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("herA5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jLvTw").then(()=>parcelRequire('dScyL'));

});


parcelRegister("iyqMX", function(module, exports) {
$parcel$export(module.exports, "serviceDeskContextResource", () => $635b5a7dad57b894$export$5eaaf465969a9171);

var $fLTsc = parcelRequire("fLTsc");

var $7edbf = parcelRequire("7edbf");


const $635b5a7dad57b894$export$5eaaf465969a9171 = (0, $7edbf.createResource)({
    type: (0, $6fa60b97ba7ac716$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $fLTsc.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: ()=>Promise.resolve((parcelRequire("jeR8Z"))),
    maxAge: Infinity
});

});
/* eslint-disable jira/filename-case */ const $6fa60b97ba7ac716$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';


parcelRegister("ble5H", function(module, exports) {
$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $20cf5a8b9c0403fa$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $20cf5a8b9c0403fa$export$7bb46948fb84f164);

var $euxye = parcelRequire("euxye");

var $fLTsc = parcelRequire("fLTsc");

var $d7dm3 = parcelRequire("d7dm3");

var $7edbf = parcelRequire("7edbf");
const $20cf5a8b9c0403fa$var$RESOURCE_TYPE_SERVICEDESK_IS_ITSM_PROJECT = 'SERVICEDESK_IS_ITSM_PROJECT';
const $20cf5a8b9c0403fa$var$ONE_DAY_IN_MILLIS = 86400000;

const $20cf5a8b9c0403fa$export$920308cef4e291b1 = (0, $7edbf.createResource)({
    type: $20cf5a8b9c0403fa$var$RESOURCE_TYPE_SERVICEDESK_IS_ITSM_PROJECT,
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("7Zw1N")),
    maxAge: $20cf5a8b9c0403fa$var$ONE_DAY_IN_MILLIS
});
const $20cf5a8b9c0403fa$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $d7dm3.useResourceWithCustomRouterContext)($20cf5a8b9c0403fa$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $euxye.useMemo)(()=>({
            data: data,
            loading: loading,
            // oxlint-disable-next-line typescript/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("7Zw1N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3q3gW").then(()=>parcelRequire('htsLT'));

});


parcelRegister("j0qHc", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticesResource", () => $9633aed328faaa05$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $9633aed328faaa05$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $9633aed328faaa05$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $9633aed328faaa05$export$4d46346ef0bdc6b9);

var $euxye = parcelRequire("euxye");

var $fLTsc = parcelRequire("fLTsc");

var $fqOOj = parcelRequire("fqOOj");

var $i860n = parcelRequire("i860n");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $9633aed328faaa05$var$RESOURCE_TYPE_SERVICEDESK_PRACTICES = 'SERVICEDESK_PRACTICES';
const $9633aed328faaa05$var$ONE_DAY_IN_MILLIS = 86400000;

const $9633aed328faaa05$export$2ae319305481e7de = (0, $7edbf.createResource)({
    type: $9633aed328faaa05$var$RESOURCE_TYPE_SERVICEDESK_PRACTICES,
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("9nTzD")),
    maxAge: $9633aed328faaa05$var$ONE_DAY_IN_MILLIS
});
const $9633aed328faaa05$var$getQueuesOrder = ()=>{
    return (0, $i860n.fg)('jsm-case-management') ? (0, $fqOOj.WORK_CATEGORIES_QUEUE_SUPPORTED) : (0, $fqOOj.WORK_CATEGORIES_QUEUE_SUPPORTED).filter((p)=>p !== (0, $fqOOj.CASES));
};
const $9633aed328faaa05$var$getWorkCategoryOrder = ()=>[
        ...$9633aed328faaa05$var$getQueuesOrder(),
        (0, $fqOOj.DEVELOPER_ESCALATION)
    ];
const $9633aed328faaa05$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    const queuesOrder = $9633aed328faaa05$var$getQueuesOrder();
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    return queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9633aed328faaa05$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    const workCategoryOrder = $9633aed328faaa05$var$getWorkCategoryOrder();
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    return workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9633aed328faaa05$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $k6ufm.useResource)($9633aed328faaa05$export$2ae319305481e7de);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const error = resource.error;
    return (0, $euxye.useMemo)(()=>({
            data: $9633aed328faaa05$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9633aed328faaa05$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $k6ufm.useResource)($9633aed328faaa05$export$2ae319305481e7de);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const error = resource.error;
    return (0, $euxye.useMemo)(()=>({
            data: $9633aed328faaa05$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9633aed328faaa05$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $k6ufm.useResource)($9633aed328faaa05$export$2ae319305481e7de);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const error = resource.error;
    (0, $euxye.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $euxye.useMemo)(()=>({
            data: $9633aed328faaa05$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("fqOOj", function(module, exports) {
$parcel$export(module.exports, "CHANGES", () => $67682c415f41e977$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $67682c415f41e977$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $67682c415f41e977$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $67682c415f41e977$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $67682c415f41e977$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $67682c415f41e977$export$81e62964cc725098);
$parcel$export(module.exports, "CASES", () => $67682c415f41e977$export$ddbef7dfaa374d2d);
$parcel$export(module.exports, "NO_CATEGORY", () => $67682c415f41e977$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $67682c415f41e977$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $67682c415f41e977$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $67682c415f41e977$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $67682c415f41e977$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $67682c415f41e977$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $67682c415f41e977$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $67682c415f41e977$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "SHORT_FORM_CASES", () => $67682c415f41e977$export$2863e7d432d9b3f5);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $67682c415f41e977$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $67682c415f41e977$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $67682c415f41e977$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $67682c415f41e977$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $67682c415f41e977$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $67682c415f41e977$export$6c24c440228eac9c);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $67682c415f41e977$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $67682c415f41e977$export$b78213db77524b5b);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $8ENSY = parcelRequire("8ENSY");
const $67682c415f41e977$var$queues = (0, $7eNDO.defineMessage)({
    id: "work-category.common.queues",
    defaultMessage: "Queues"
});
const $67682c415f41e977$var$serviceRequests = (0, $7eNDO.defineMessage)({
    id: "work-category.common.service-requests",
    defaultMessage: "Service requests"
});
const $67682c415f41e977$var$incidents = (0, $7eNDO.defineMessage)({
    id: "work-category.common.incidents",
    defaultMessage: "Incidents"
});
const $67682c415f41e977$var$changes = (0, $7eNDO.defineMessage)({
    id: "work-category.common.changes",
    defaultMessage: "Changes"
});
const $67682c415f41e977$var$problems = (0, $7eNDO.defineMessage)({
    id: "work-category.common.problems",
    defaultMessage: "Problems"
});
const $67682c415f41e977$var$postIncidentReviews = (0, $7eNDO.defineMessage)({
    id: "work-category.common.post-incident-reviews",
    defaultMessage: "Post-incident reviews"
});
const $67682c415f41e977$var$developerEscalation = (0, $7eNDO.defineMessage)({
    id: "work-category.common.developer-escalation",
    defaultMessage: "Developer escalations"
});
const $67682c415f41e977$var$cases = (0, $7eNDO.defineMessage)({
    id: "work-category.common.cases",
    defaultMessage: "Cases"
});
const $67682c415f41e977$var$noCategory = (0, $7eNDO.defineMessage)({
    id: "work-category.common.no-category",
    defaultMessage: "General"
});
const $67682c415f41e977$var$queuesLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.queues-lower",
    defaultMessage: "queues"
});
const $67682c415f41e977$var$serviceRequestsLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.service-requests-lower",
    defaultMessage: "service requests"
});
const $67682c415f41e977$var$incidentsLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.incidents-lower",
    defaultMessage: "incidents"
});
const $67682c415f41e977$var$changesLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.changes-lower",
    defaultMessage: "changes"
});
const $67682c415f41e977$var$problemsLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.problems-lower",
    defaultMessage: "problems"
});
const $67682c415f41e977$var$postIncidentReviewsLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.post-incident-reviews-lower",
    defaultMessage: "post-incident reviews"
});
const $67682c415f41e977$var$noCategoryLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.no-category-lower",
    defaultMessage: "general"
});
const $67682c415f41e977$var$developerEscalationLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.developer-escalation-lower",
    defaultMessage: "developer escalations"
});
const $67682c415f41e977$var$casesLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.cases-lower",
    defaultMessage: "cases"
});
const $67682c415f41e977$export$8598196f74460271 = 'change-management';
const $67682c415f41e977$export$a50b49a533b5f7bc = 'incident-management';
const $67682c415f41e977$export$ceba70db1edb1def = 'problem-management';
const $67682c415f41e977$export$3d1cda9bd50505e8 = 'service-request';
const $67682c415f41e977$export$6ebf7b6bf1c580f = 'post-incident-review';
const $67682c415f41e977$export$81e62964cc725098 = 'developer-escalation';
const $67682c415f41e977$export$ddbef7dfaa374d2d = 'case-management';
const $67682c415f41e977$export$485b1216c42d8d4 = 'no-category';
const $67682c415f41e977$var$NO_CATEGORY_NEW = 'no-category-new';
const $67682c415f41e977$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $67682c415f41e977$export$a50185c8e9fb007e = 'changes';
const $67682c415f41e977$export$a54a30a3c3cce634 = 'incidents';
const $67682c415f41e977$export$354f3a4c6ac0c903 = 'problems';
const $67682c415f41e977$export$335d3ac0c367f03f = 'service-requests';
const $67682c415f41e977$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $67682c415f41e977$export$cb41b99ca54e6bd = 'developer-escalations';
const $67682c415f41e977$export$2863e7d432d9b3f5 = 'cases';
const $67682c415f41e977$export$a613d808168c7b25 = [
    $67682c415f41e977$export$8598196f74460271,
    $67682c415f41e977$export$a50b49a533b5f7bc,
    $67682c415f41e977$export$ceba70db1edb1def,
    $67682c415f41e977$export$3d1cda9bd50505e8,
    $67682c415f41e977$export$6ebf7b6bf1c580f,
    $67682c415f41e977$export$81e62964cc725098,
    $67682c415f41e977$export$ddbef7dfaa374d2d
]; // /!\ defines WorkCategoryApiResource type
const $67682c415f41e977$export$a2b1f8f055150f02 = [
    $67682c415f41e977$export$3d1cda9bd50505e8,
    $67682c415f41e977$export$a50b49a533b5f7bc,
    $67682c415f41e977$export$ceba70db1edb1def,
    $67682c415f41e977$export$8598196f74460271,
    $67682c415f41e977$export$6ebf7b6bf1c580f,
    $67682c415f41e977$export$ddbef7dfaa374d2d
]; // /!\ defines WorkCategoryQueueSupported type
const $67682c415f41e977$export$5a9122a4028fb8ef = [
    ...$67682c415f41e977$export$a2b1f8f055150f02,
    $67682c415f41e977$export$485b1216c42d8d4
];
const $67682c415f41e977$export$f1b813cd23817ade = [
    $67682c415f41e977$export$a50185c8e9fb007e,
    $67682c415f41e977$export$a54a30a3c3cce634,
    $67682c415f41e977$export$354f3a4c6ac0c903,
    $67682c415f41e977$export$335d3ac0c367f03f,
    $67682c415f41e977$export$7ffd7f2c2ae96b6f,
    $67682c415f41e977$export$cb41b99ca54e6bd,
    $67682c415f41e977$export$2863e7d432d9b3f5
]; // /!\ defines WorkCategoryShortForm type
const $67682c415f41e977$export$56c57f7ad650c45c = {
    [$67682c415f41e977$export$8598196f74460271]: $67682c415f41e977$export$a50185c8e9fb007e,
    [$67682c415f41e977$export$a50b49a533b5f7bc]: $67682c415f41e977$export$a54a30a3c3cce634,
    [$67682c415f41e977$export$ceba70db1edb1def]: $67682c415f41e977$export$354f3a4c6ac0c903,
    [$67682c415f41e977$export$3d1cda9bd50505e8]: $67682c415f41e977$export$335d3ac0c367f03f,
    [$67682c415f41e977$export$6ebf7b6bf1c580f]: $67682c415f41e977$export$7ffd7f2c2ae96b6f,
    [$67682c415f41e977$export$ddbef7dfaa374d2d]: $67682c415f41e977$export$2863e7d432d9b3f5,
    [$67682c415f41e977$export$485b1216c42d8d4]: $67682c415f41e977$var$NO_CATEGORY_NEW
};
const $67682c415f41e977$export$fbf0dfd01228e38d = {
    [$67682c415f41e977$export$8598196f74460271]: $67682c415f41e977$var$changes,
    [$67682c415f41e977$export$3d1cda9bd50505e8]: $67682c415f41e977$var$serviceRequests,
    [$67682c415f41e977$export$ceba70db1edb1def]: $67682c415f41e977$var$problems,
    [$67682c415f41e977$export$a50b49a533b5f7bc]: $67682c415f41e977$var$incidents,
    [$67682c415f41e977$export$6ebf7b6bf1c580f]: $67682c415f41e977$var$postIncidentReviews,
    [$67682c415f41e977$export$485b1216c42d8d4]: $67682c415f41e977$var$queues,
    [$67682c415f41e977$export$81e62964cc725098]: $67682c415f41e977$var$developerEscalation,
    [$67682c415f41e977$export$ddbef7dfaa374d2d]: $67682c415f41e977$var$cases,
    [$67682c415f41e977$export$52bf3f16b7812704]: $67682c415f41e977$var$noCategory
};
const $67682c415f41e977$export$45ba5f49e9509c4d = {
    [$67682c415f41e977$export$8598196f74460271]: $67682c415f41e977$var$changesLower,
    [$67682c415f41e977$export$3d1cda9bd50505e8]: $67682c415f41e977$var$serviceRequestsLower,
    [$67682c415f41e977$export$ceba70db1edb1def]: $67682c415f41e977$var$problemsLower,
    [$67682c415f41e977$export$a50b49a533b5f7bc]: $67682c415f41e977$var$incidentsLower,
    [$67682c415f41e977$export$6ebf7b6bf1c580f]: $67682c415f41e977$var$postIncidentReviewsLower,
    [$67682c415f41e977$export$485b1216c42d8d4]: $67682c415f41e977$var$queuesLower,
    [$67682c415f41e977$export$81e62964cc725098]: $67682c415f41e977$var$developerEscalationLower,
    [$67682c415f41e977$export$ddbef7dfaa374d2d]: $67682c415f41e977$var$casesLower,
    [$67682c415f41e977$export$52bf3f16b7812704]: $67682c415f41e977$var$noCategoryLower
};
const $67682c415f41e977$export$45952424a7f29b99 = (0, $8ENSY.getTypedKeys)($67682c415f41e977$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $67682c415f41e977$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $67682c415f41e977$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// oxlint-disable-next-line typescript/consistent-type-assertions
}, {});
const $67682c415f41e977$export$6c24c440228eac9c = 'Changes';
const $67682c415f41e977$export$5b65d27ec2d28d18 = 'Incidents';
const $67682c415f41e977$var$PROBLEMS_JQL_NAME = 'Problems';
const $67682c415f41e977$var$SERVICE_REQUEST_JQL_NAME = 'Service requests';
const $67682c415f41e977$var$POST_INCIDENT_REVIEWS_JQL_NAME = 'Post-incident reviews';
const $67682c415f41e977$export$3f757c5e00588ffd = 'Developer escalation';
const $67682c415f41e977$export$66e62df67c842469 = 'Cases';
const $67682c415f41e977$export$b78213db77524b5b = {
    [$67682c415f41e977$export$8598196f74460271]: $67682c415f41e977$export$6c24c440228eac9c,
    [$67682c415f41e977$export$a50b49a533b5f7bc]: $67682c415f41e977$export$5b65d27ec2d28d18,
    [$67682c415f41e977$export$ceba70db1edb1def]: $67682c415f41e977$var$PROBLEMS_JQL_NAME,
    [$67682c415f41e977$export$3d1cda9bd50505e8]: $67682c415f41e977$var$SERVICE_REQUEST_JQL_NAME,
    [$67682c415f41e977$export$6ebf7b6bf1c580f]: $67682c415f41e977$var$POST_INCIDENT_REVIEWS_JQL_NAME,
    [$67682c415f41e977$export$81e62964cc725098]: $67682c415f41e977$export$3f757c5e00588ffd,
    [$67682c415f41e977$export$ddbef7dfaa374d2d]: $67682c415f41e977$export$66e62df67c842469
};

});
parcelRegister("8ENSY", function(module, exports) {
$parcel$export(module.exports, "hasProp", () => $7d9fa4bc3da3da6f$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $7d9fa4bc3da3da6f$export$5206d47972fefe20);
/* eslint-disable jira/filename-case */ /**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $7d9fa4bc3da3da6f$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $7d9fa4bc3da3da6f$export$5206d47972fefe20 = (obj)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return Object.keys(obj);
};

});


parcelRegister("9nTzD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3Zizf").then(()=>parcelRequire('bGyEV'));

});


parcelRegister("dkOZx", function(module, exports) {
$parcel$export(module.exports, "requiredProjectProperties", () => $d62e2c1b9979d4b2$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $d62e2c1b9979d4b2$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $d62e2c1b9979d4b2$export$f620cebb7e8eeeae);
$parcel$export(module.exports, "isSimplifiedNavResource", () => $d62e2c1b9979d4b2$export$dd8a962d5821a6f0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cY22M = parcelRequire("cY22M");

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
const $d62e2c1b9979d4b2$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0];

const $d62e2c1b9979d4b2$export$fbeae45a65f4a5a6 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $d62e2c1b9979d4b2$var$getKey,
    getDataLoader: ()=>(parcelRequire("hj5lJ")),
    maxAge: 300000
});
const $d62e2c1b9979d4b2$var$ONE_DAY_IN_MILLIS = 86400000;

const $d62e2c1b9979d4b2$export$47241956725e3029 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $d62e2c1b9979d4b2$var$getKey,
    getDataLoader: ()=>(parcelRequire("i9gyI")),
    maxAge: $d62e2c1b9979d4b2$var$ONE_DAY_IN_MILLIS
});
const $d62e2c1b9979d4b2$var$TWELVE_HOURS_IN_MILLIS = 43200000;

const $d62e2c1b9979d4b2$export$f620cebb7e8eeeae = (0, $7edbf.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: ()=>(parcelRequire("gxQNy")),
    maxAge: $d62e2c1b9979d4b2$var$TWELVE_HOURS_IN_MILLIS
});
const $d62e2c1b9979d4b2$var$TWENTY_FOUR_HOURS_IN_MILLIS = 86400000;
const $d62e2c1b9979d4b2$var$SIMPLIFIED_NAV_PROPERTY_KEY = 'jsm.isSimplifiedNav';

const $d62e2c1b9979d4b2$export$dd8a962d5821a6f0 = (0, $7edbf.createResource)({
    type: 'JSM_IS_SIMPLIFIED_NAV_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        return `${projectKey}___${$d62e2c1b9979d4b2$var$SIMPLIFIED_NAV_PROPERTY_KEY}`;
    },
    getDataLoader: ()=>(parcelRequire("8APw8")),
    maxAge: $d62e2c1b9979d4b2$var$TWENTY_FOUR_HOURS_IN_MILLIS
});

});
parcelRegister("hj5lJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i9ARW").then(()=>parcelRequire('dXxfd'));

});

parcelRegister("i9gyI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jn9xT").then(()=>parcelRequire('5WcYM'));

});

parcelRegister("gxQNy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1jSQ2").then(()=>parcelRequire('68WxG'));

});

parcelRegister("8APw8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9yjJE").then(()=>parcelRequire('joVKB'));

});


parcelRegister("cpnl1", function(module, exports) {
$parcel$export(module.exports, "queuesNavigationItems", () => $4376fb9968d89e9c$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $4376fb9968d89e9c$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $4376fb9968d89e9c$export$b55fde45b61f13f4);
$parcel$export(module.exports, "priorityGroupCrossProjectResource", () => $4376fb9968d89e9c$export$ce17a222de842d7c);
$parcel$export(module.exports, "issueListSsrResource", () => $4376fb9968d89e9c$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueNav4SidebarSelectionResource", () => $4376fb9968d89e9c$export$dead630ba04fdfe4);
$parcel$export(module.exports, "queueSidebarQueuesCategoryStateResource", () => $4376fb9968d89e9c$export$9e9033d678058efa);
$parcel$export(module.exports, "triageButtonPermissionResource", () => $4376fb9968d89e9c$export$11d6dc3c9b9c69ec);

var $cY22M = parcelRequire("cY22M");

var $hFtK7 = parcelRequire("hFtK7");

var $i0CFV = parcelRequire("i0CFV");

var $kM0go = parcelRequire("kM0go");

var $7edbf = parcelRequire("7edbf");

var $5PVNo = parcelRequire("5PVNo");

var $e6DgO = parcelRequire("e6DgO");

var $cqRR9 = parcelRequire("cqRR9");
const $4376fb9968d89e9c$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.queueId', '')}`;
const $4376fb9968d89e9c$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0]}`;

const $4376fb9968d89e9c$export$4fed8be571897bef = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getDataLoader: ()=>(parcelRequire("1BkmR")),
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});

const $4376fb9968d89e9c$export$1f9ab301771fe42e = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getDataLoader: ()=>(parcelRequire("8CQWr")),
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS),
    /**
		 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
		 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
		 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
		 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
		 */ isBrowserOnly: true
});
const $4376fb9968d89e9c$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query })=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdStart',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        if (!projectKey) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectKey',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return (0, $e6DgO.getPriorityGroupDataByProjectId)(undefined, projectKey);
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
};
const $4376fb9968d89e9c$export$b55fde45b61f13f4 = (0, $7edbf.createResource)($4376fb9968d89e9c$var$priorityGroupByProjectIdResourcePayload);
const $4376fb9968d89e9c$export$ce17a222de842d7c = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query })=>{
        const projectKey = (0, $i0CFV.getProjectKeyId)(match, query).projectKey;
        try {
            const projectId = match.params.projectId ? +match.params.projectId : undefined;
            return (0, $e6DgO.getPriorityGroupDataByProjectId)(projectId, projectKey);
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'priorityGroupCrossProjectNoProjectId',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $e6DgO.getPriorityGroupDataByProjectId)(undefined, projectKey);
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true
});


const $4376fb9968d89e9c$export$3d03cbaac8581e65 = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $4376fb9968d89e9c$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: ()=>Promise.resolve((parcelRequire("2QxLf"))),
    // getData below is deliberately set up to load in a sync'd way only in SSR in hope it will execute faster without any delays
    // In CSR we use async data loader above, to not increase jira-spa bundle size for every route
    // oxlint-disable-next-line typescript/no-require-imports, typescript/no-var-requires
    getData: false ? (parcelRequire("2QxLf")).default : null,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $4376fb9968d89e9c$export$5b6f88b653545aa1 = (0, $7edbf.createResource)({
    type: (0, $5PVNo.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $4376fb9968d89e9c$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $kM0go.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});
const $4376fb9968d89e9c$export$dead630ba04fdfe4 = (0, $7edbf.createResource)({
    type: (0, $5PVNo.SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $kM0go.getUserProperty)(atlassianAccountId, (0, $5PVNo.LOCAL_STORAGE_KEY_NAV_LOCATION));
            return response;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'fetchQueueNav4SidebarSelectionResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});
const $4376fb9968d89e9c$export$9e9033d678058efa = (0, $7edbf.createResource)({
    type: (0, $5PVNo.SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $kM0go.getUserProperty)(atlassianAccountId, (0, $5PVNo.LOCAL_STORAGE_KEY_CATEGORY));
            return response;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'fetchJsmQueueSidebarQueuesCategoryStateResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});
const $4376fb9968d89e9c$export$11d6dc3c9b9c69ec = (0, $7edbf.createResource)({
    type: (0, $cqRR9.RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION),
    getKey: ()=>(0, $cqRR9.RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION),
    getData: async ()=>{
        return (0, $cqRR9.getTriageButtonPermission)();
    },
    maxAge: (0, $5PVNo.ONE_HOUR_IN_MILLIS)
});

});
parcelRegister("5PVNo", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $d73d2906133d5d50$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $d73d2906133d5d50$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $d73d2906133d5d50$export$2733615da5b906f0);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE", () => $d73d2906133d5d50$export$f510a6e9fec0630a);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $d73d2906133d5d50$export$94bda82b7db2173c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION", () => $d73d2906133d5d50$export$7e07da72de89b61c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY", () => $d73d2906133d5d50$export$5b3a0c7c3b3456f);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $d73d2906133d5d50$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $d73d2906133d5d50$export$9b99689db482a6bb);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $d73d2906133d5d50$export$5a00268156ea5027);
$parcel$export(module.exports, "ONE_HOUR_IN_MILLIS", () => $d73d2906133d5d50$export$86e172ab3db1a556);
/* eslint-disable jira/filename-case */ const $d73d2906133d5d50$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $d73d2906133d5d50$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $d73d2906133d5d50$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $d73d2906133d5d50$export$f510a6e9fec0630a = 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';
const $d73d2906133d5d50$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $d73d2906133d5d50$export$7e07da72de89b61c = 'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';
const $d73d2906133d5d50$export$5b3a0c7c3b3456f = 'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';
const $d73d2906133d5d50$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $d73d2906133d5d50$export$9b99689db482a6bb = 'queues-category-state';
const $d73d2906133d5d50$export$5a00268156ea5027 = 86400000;
const $d73d2906133d5d50$export$86e172ab3db1a556 = 3600000;

});

parcelRegister("e6DgO", function(module, exports) {
$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $7e8cafe60a525750$export$cf2bd2ec601ed920);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i4emW = parcelRequire("i4emW");

var $4fhEY = parcelRequire("4fhEY");
const $7e8cafe60a525750$var$fetchGroupByKeyViaJira = async (projectKey, projectId)=>{
    const queryParams = projectId ? `projectId=${projectId}` : `projectKey=${projectKey}`;
    return (0, $4fhEY.default)(`/rest/servicedesk/latest/servicedesk/queue-group/groups?${queryParams}&operation=fetchPriorityGroups`);
};
const $7e8cafe60a525750$export$cf2bd2ec601ed920 = async (projectId, projectKey)=>{
    const data = await $7e8cafe60a525750$var$fetchGroupByKeyViaJira(projectKey, projectId);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($i4emW)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return processedData;
};

});
parcelRegister("i4emW", function(module, exports) {

var $fOh92 = parcelRequire("fOh92");

var $4cz3P = parcelRequire("4cz3P");
/** Used for built-in method references. */ var $d273bf1e16d87cd5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d273bf1e16d87cd5$var$hasOwnProperty = $d273bf1e16d87cd5$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $d273bf1e16d87cd5$var$groupBy = $4cz3P(function(result, value, key) {
    if ($d273bf1e16d87cd5$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $fOh92(result, key, [
        value
    ]);
});
module.exports = $d273bf1e16d87cd5$var$groupBy;

});


parcelRegister("cqRR9", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION", () => $9e582d8b880be49f$export$e79aee80d521b352);
$parcel$export(module.exports, "getTriageButtonPermission", () => $9e582d8b880be49f$export$6a9c765d370d71c8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $lCetP = parcelRequire("lCetP");
const $9e582d8b880be49f$export$e79aee80d521b352 = 'triage-button-permission';
const $9e582d8b880be49f$export$6a9c765d370d71c8 = async ()=>{
    const permissionsUrl = '/rest/api/3/mypermissions?permissions=MOVE_ISSUES%2CEDIT_ISSUES%2CBULK_CHANGE';
    const aiStatusUrl = '/rest/latest/aiconfig/optin/jira-servicedesk';
    try {
        const [permissions, aiStatus] = await Promise.all([
            (0, $h2wCv.performGetRequest)(permissionsUrl),
            (0, $h2wCv.performGetRequest)(aiStatusUrl)
        ]);
        return {
            hasPermission: permissions.permissions.MOVE_ISSUES?.havePermission && permissions.permissions.EDIT_ISSUES?.havePermission && permissions.permissions.BULK_CHANGE?.havePermission,
            hasAiEnabled: aiStatus.isEnabled
        };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $lCetP.isHttpClientErrorResponse)(error)) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'fetchTriageButtonPermissionError',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        // Return default values on error
        return {
            hasPermission: false,
            hasAiEnabled: false
        };
    }
};

});

parcelRegister("1BkmR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l5nB1").then(()=>parcelRequire('luTQQ'));

});

parcelRegister("8CQWr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gTIkZ").then(()=>parcelRequire('eIwyV'));

});

parcelRegister("2QxLf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d8b4c8f0e2b44565$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable jira/import-whitelist */ 
var $bdEst = parcelRequire("bdEst");

var $i0CFV = parcelRequire("i0CFV");

var $siTdT = parcelRequire("siTdT");

var $h2wCv = parcelRequire("h2wCv");

var $cDZzl = parcelRequire("cDZzl");

var $9dxuE = parcelRequire("9dxuE");
const $d8b4c8f0e2b44565$var$fetchIssueListData = async ({ match: match, query: query })=>{
    const projectKeyOrId = (0, $i0CFV.getProjectKeyId)(match, query).projectKey;
    const queueId = match.params && match.params.queueId || undefined;
    const category = match.params && match.params.practiceType || 'no-category';
    if (!queueId) throw (0, $bdEst.createResourceError)({
        component: 'spa.view.routes.servicedesk.queues.fetchIssueListSsrData',
        message: 'QueueId is undefined',
        name: 'ResourceError',
        skipSentry: false
    });
    const bodyWithCategory = {
        columnTypesAsJson: (0, $9dxuE.getFieldTypesEligibleForJsonData)(),
        issuesPerPage: (0, $cDZzl.FETCH_SIZE_IN_INITIAL_LOAD),
        category: category
    };
    const url = `/rest/servicedesk/1/servicedesk/${projectKeyOrId}/issuelist/ssr/${queueId}/jis?operation=fetchIssueListSsr`;
    const fetchStartTime = performance.now();
    const data = await (0, $h2wCv.performPostRequest)(url, {
        body: JSON.stringify(bodyWithCategory)
    }).catch(()=>undefined);
    (0, $siTdT.addSpanToAll)('fetch', '/rest/servicedesk/1/servicedesk/projectKey/issuelist/ssr/queueId/jis', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    return data;
};
var $d8b4c8f0e2b44565$export$2e2bcd8739ae039 = $d8b4c8f0e2b44565$var$fetchIssueListData;

});
parcelRegister("bdEst", function(module, exports) {
$parcel$export(module.exports, "createResourceError", () => $cec0bd4f375e6b3e$export$13487d18466bc8a5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");
class $cec0bd4f375e6b3e$var$ResourceErrorClass extends Error {
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
$cec0bd4f375e6b3e$var$ResourceErrorClass.displayName = "ResourceErrorClass";
const $cec0bd4f375e6b3e$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $6CfY5.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $cec0bd4f375e6b3e$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("cDZzl", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_COLUMNS", () => $2d774bff2465a9d8$export$50c19f60b9c144f7);
$parcel$export(module.exports, "DEFAULT_QUEUE_ID", () => $2d774bff2465a9d8$export$e78379cc32bff512);
$parcel$export(module.exports, "FETCH_BATCH_SIZE_OLD", () => $2d774bff2465a9d8$export$987477cbd7054df);
$parcel$export(module.exports, "FETCH_SIZE_IN_INITIAL_LOAD", () => $2d774bff2465a9d8$export$4ee65d92b7b81b6b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $2d774bff2465a9d8$export$50c19f60b9c144f7 = [
    'issuetype',
    'issuekey',
    'summary',
    'reporter',
    'assignee',
    'status',
    'created'
];
const $2d774bff2465a9d8$export$e78379cc32bff512 = Number.MIN_VALUE;
const $2d774bff2465a9d8$export$987477cbd7054df = 100;
const $2d774bff2465a9d8$export$4ee65d92b7b81b6b = 30;

});

parcelRegister("9dxuE", function(module, exports) {
$parcel$export(module.exports, "getFieldTypesEligibleForJsonData", () => $e89f51d5e7758dfd$export$e2bd4328395b4df7);
$parcel$export(module.exports, "getFieldTypesEligibleForJsonDataAsSet", () => $e89f51d5e7758dfd$export$740140e54d80c734);

var $k4FO8 = parcelRequire("k4FO8");

var $dAmGh = parcelRequire("dAmGh");

var $emCaV = parcelRequire("emCaV");

var $i860n = parcelRequire("i860n");
const $e89f51d5e7758dfd$var$getFieldTypesFromFeatureFlagMap = (featureFlagMap)=>(0, (/*@__PURE__*/$parcel$interopDefault($k4FO8)))((0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))(featureFlagMap, (isAlwaysJsonOrFFKey)=>{
        if (typeof isAlwaysJsonOrFFKey === 'boolean') return isAlwaysJsonOrFFKey;
        // eslint-disable-next-line jira/ff/static-feature-flags
        return (0, $i860n.fg)(isAlwaysJsonOrFFKey);
    }));
const $e89f51d5e7758dfd$export$c394db035bb5cf7d = {
    assignee: true,
    'com.atlassian.servicedesk:sd-sla-field': true,
    status: true,
    issuetype: true,
    reporter: true,
    priority: true,
    summary: true,
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': true,
    labels: true,
    'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team': 'jsm_queue_inline_team_update',
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': true,
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': true,
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': 'jsm_unscreenable_field_phase_2_fg',
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': true,
    'com.atlassian.servicedesk:sd-request-participants': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': true,
    'com.atlassian.servicedesk.sentiment:sd-sentiment': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-organization': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-source-channel': 'csm_omni_source_channel_cf_fe',
    // Queue view: request additional REST-aware columns as JSON when enabled.
    created: true,
    updated: true,
    duedate: true,
    lastViewed: true,
    resolutiondate: true,
    // Queue view: next set of columns to request as JSON when enabled.
    timespent: true,
    aggregatetimespent: true,
    timeoriginalestimate: true,
    resolution: true,
    'com.atlassian.jira.plugin.system.customfieldtypes:select': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:datepicker': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:userpicker': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:labels': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:url': true,
    'com.atlassian.servicedesk:vp-origin': true,
    'com.atlassian.servicedesk:sd-customer-organizations': true,
    issuelinks: true,
    components: true,
    creator: true,
    security: true,
    subtasks: true,
    parent: true
};
const $e89f51d5e7758dfd$export$e2bd4328395b4df7 = (0, $emCaV.default)(()=>$e89f51d5e7758dfd$var$getFieldTypesFromFeatureFlagMap($e89f51d5e7758dfd$export$c394db035bb5cf7d));
const $e89f51d5e7758dfd$export$740140e54d80c734 = (0, $emCaV.default)(()=>new Set($e89f51d5e7758dfd$export$e2bd4328395b4df7()));
const $e89f51d5e7758dfd$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS = {
    issuekey: true,
    statusCategory: true
};
const $e89f51d5e7758dfd$export$8e81e0bb2e4fc09e = (0, $emCaV.default)(()=>$e89f51d5e7758dfd$var$getFieldTypesFromFeatureFlagMap($e89f51d5e7758dfd$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS));
const $e89f51d5e7758dfd$export$dacb9fc482fbe93 = (0, $emCaV.default)(()=>new Set($e89f51d5e7758dfd$export$8e81e0bb2e4fc09e()));

});



parcelRegister("c6i4p", function(module, exports) {
$parcel$export(module.exports, "nav3QueueGroupsStateResource", () => $2932efda711816d6$export$53d0e5294221581);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cY22M = parcelRequire("cY22M");

var $hFtK7 = parcelRequire("hFtK7");

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $5PVNo = parcelRequire("5PVNo");

var $asIGs = parcelRequire("asIGs");
const $2932efda711816d6$var$getProjectKey = ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
    (0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0];
const $2932efda711816d6$export$53d0e5294221581 = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE),
    getKey: $2932efda711816d6$var$getProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        if (!atlassianAccountId) return undefined;
        const projectKey = $2932efda711816d6$var$getProjectKey({
            match: match,
            query: query
        });
        try {
            return await (0, $asIGs.getQueueGroupsStateFromUserProperty)(projectKey, atlassianAccountId);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'getQueueGroupsStateInUserPropertyResourceError'
                }
            });
            return undefined;
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("asIGs", function(module, exports) {
$parcel$export(module.exports, "setQueueGroupsStateInUserProperty", () => $a65ddd85a962a1bd$export$e316bbc9b5e5100d);
$parcel$export(module.exports, "getQueueGroupsStateFromUserProperty", () => $a65ddd85a962a1bd$export$87bc602eb5671315);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");
const $a65ddd85a962a1bd$export$bb10a02fc2feb574 = 'jsm-queue-groups-state-selected-group-id';
const $a65ddd85a962a1bd$export$e316bbc9b5e5100d = async (projectKey, value, accountId)=>{
    try {
        (0, $kM0go.setUserProperties)(accountId, `${$a65ddd85a962a1bd$export$bb10a02fc2feb574}_${projectKey}`, JSON.stringify(value));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'setQueueGroupsStateInUserPropertyError'
            }
        });
        throw error;
    }
};
const $a65ddd85a962a1bd$export$87bc602eb5671315 = async (projectKey, accountId)=>{
    try {
        return await (0, $kM0go.getUserProperty)(accountId, `${$a65ddd85a962a1bd$export$bb10a02fc2feb574}_${projectKey}`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getQueueGroupsStateFromUserPropertyError'
            }
        });
        throw error;
    }
};

});


parcelRegister("kqhKu", function(module, exports) {
$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $6218fceba85bb85d$export$d39827c053fda3aa);

var $i860n = parcelRequire("i860n");

var $htsFl = parcelRequire("htsFl");

var $k49ny = parcelRequire("k49ny");
const $6218fceba85bb85d$var$QUERY = {
    kind: 'PreloadableConcreteRequest',
    params: {
        id: 'f8d8b9eec1994f8c7411bb76dc10be0eab8514a591963f4d58e52f323d48b997',
        metadata: {},
        name: 'VirtualAgentSidebarQuery',
        operationKind: 'query',
        text: null,
        providedVariables: {
            __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider: (0, $k49ny.default)
        }
    }
};
const $6218fceba85bb85d$export$d39827c053fda3aa = (0, $htsFl.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: $6218fceba85bb85d$var$QUERY,
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $i860n.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});

parcelRegister("lEPfS", function(module, exports) {
$parcel$export(module.exports, "featuresResource", () => $31fe7140dff95848$export$16f81cc9da2c6c47);

var $cY22M = parcelRequire("cY22M");

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
const $31fe7140dff95848$var$RESOURCE_TYPE_SERVICEDESK_FEATURES = 'SERVICEDESK_FEATURES';
const $31fe7140dff95848$var$ONE_DAY_IN_MILLIS = 86400000;

const $31fe7140dff95848$export$16f81cc9da2c6c47 = (0, $7edbf.createResource)({
    type: $31fe7140dff95848$var$RESOURCE_TYPE_SERVICEDESK_FEATURES,
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: ()=>(parcelRequire("3Yjff")),
    maxAge: $31fe7140dff95848$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("3Yjff", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hXVRn").then(()=>parcelRequire('6jMUS'));

});


parcelRegister("hWEkS", function(module, exports) {
$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $c1167e8712e72bb4$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $c1167e8712e72bb4$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $c1167e8712e72bb4$export$31c6945718067be3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENTS_PAGE_INITIAL_CHECKS = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENTS_PAGE_CUSTOM_FIELD_ID = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENT_EXPERIMENT_TRAITS = 'INCIDENT_EXPERIMENT_TRAITS';

const $c1167e8712e72bb4$export$b2b94ce8ba590cc8 = (0, $7edbf.createResource)({
    type: $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENTS_PAGE_INITIAL_CHECKS,
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("3ULYE"))
});

const $c1167e8712e72bb4$export$e81d7afef87ae597 = (0, $7edbf.createResource)({
    type: $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENTS_PAGE_CUSTOM_FIELD_ID,
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("k51oD"))
});

const $c1167e8712e72bb4$export$31c6945718067be3 = (0, $7edbf.createResource)({
    type: $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENT_EXPERIMENT_TRAITS,
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("IH5QI")),
    maxAge: Number.MAX_SAFE_INTEGER
});

});
parcelRegister("3ULYE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fHVqC").then(()=>parcelRequire('5n23s'));

});

parcelRegister("k51oD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("tdvMA").then(()=>parcelRequire('4OA8l'));

});

parcelRegister("IH5QI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3qLak").then(()=>parcelRequire('3Odah'));

});


parcelRegister("2DCyG", function(module, exports) {
$parcel$export(module.exports, "uifBoardResource", () => $6000f176d5258e3f$export$b65bcbbccad354ac);
$parcel$export(module.exports, "boardViewSettingsResource", () => $6000f176d5258e3f$export$e44870e1afdd6b0a);
/* eslint-disable jira/import-whitelist */ 
var $gPris = parcelRequire("gPris");

var $7edbf = parcelRequire("7edbf");

var $htsFl = parcelRequire("htsFl");

var $hOmct = parcelRequire("hOmct");
const $6000f176d5258e3f$var$RESOURCE_TYPE_UIF_BOARD = 'UIF_BOARD';

const $6000f176d5258e3f$export$b65bcbbccad354ac = (0, $7edbf.createResource)({
    type: $6000f176d5258e3f$var$RESOURCE_TYPE_UIF_BOARD,
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("7uolo")),
    maxAge: 0
});
const $6000f176d5258e3f$var$getQuery = ({ match: match }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const viewId = (0, $hOmct.JiraViewAri).create({
        activationId: activationId,
        siteId: cloudId,
        scopeId: `${Number(match.params.boardId)}/board`,
        scopeType: 'board'
    }).toString();
    return {
        options: {
            fetchPolicy: 'network-only'
        },
        parameters: $gPris.default,
        variables: {
            input: {
                viewId: viewId
            }
        }
    };
};
const $6000f176d5258e3f$export$e44870e1afdd6b0a = (0, $htsFl.createRelayResource)({
    type: 'BOARD_CMP_VIEW_SETTINGS_RESOURCE',
    getQuery: $6000f176d5258e3f$var$getQuery
});

});
parcelRegister("gPris", function(module, exports) {
$parcel$export(module.exports, "default", () => $c45275387f5292f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<baf0b0742d6d8408de9e0e05064029ba>>
 * @relayHash 2eec6b3ac944870a7beffe63dd43e213
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edefa586383073d18e29ae310cfd9d8eec687f473b49547ddb5d562c5012fdec
const $c45275387f5292f8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "edefa586383073d18e29ae310cfd9d8eec687f473b49547ddb5d562c5012fdec",
        "metadata": {},
        "name": "BoardViewSettingsDataResolverQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c45275387f5292f8$export$2e2bcd8739ae039 = $c45275387f5292f8$var$node;

});

parcelRegister("7uolo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("tsfSo").then(()=>parcelRequire('3qRBz'));

});


parcelRegister("4pLi9", function(module, exports) {
$parcel$export(module.exports, "jsmGracePeriodAnnouncementDisplayStateResource", () => $d221fdaca3820e2c$export$9c4218ae35fac02e);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementDisplayStateResource", () => $d221fdaca3820e2c$export$fed541e4e6eb934c);
$parcel$export(module.exports, "jsmGracePeriodAnnouncementGpEndDateResource", () => $d221fdaca3820e2c$export$ee26341514033dab);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementGpEndDateResource", () => $d221fdaca3820e2c$export$6b1dcceb1bcecc4c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $aJ81Y = parcelRequire("aJ81Y");

var $kEKdX = parcelRequire("kEKdX");

const $d221fdaca3820e2c$export$9c4218ae35fac02e = (0, $7edbf.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getDataLoader: ()=>(parcelRequire("6D5AT")),
    maxAge: Infinity,
    isCritical: true
});
const $d221fdaca3820e2c$var$getNewAnnouncementDismissState = (bannerType, baseDisplayState, useNewT90State)=>{
    const getHideBannerKey = (warning, T90State)=>{
        if (warning === 'T90' && T90State) return 'hideT90BannerNew';
        return `hide${warning}Banner`;
    };
    const updatedState = {
        ...baseDisplayState,
        [getHideBannerKey(bannerType, useNewT90State)]: true
    };
    return updatedState;
};
const $d221fdaca3820e2c$export$fed541e4e6eb934c = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $k6ufm.useResource)($d221fdaca3820e2c$export$9c4218ae35fac02e);
    const loadingRef = (0, $euxye.useRef)(false);
    const errorRef = (0, $euxye.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $euxye.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $euxye.useCallback)((baseState, bannerType, analyticsEvent, useNewT90State)=>{
        update(()=>$d221fdaca3820e2c$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Seqouia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $kM0go.setUserProperties)(accountId, (0, $kEKdX.JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify($d221fdaca3820e2c$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State))).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Sequoia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                // SQA-804: Add more typeOfUserEngagement attributes when we release the banner to low engaged GPC
                (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'dismissJsmGracePeriodBanner', {
                    source: 'jsmGracePeriodBanner',
                    bannerType: bannerType,
                    typeOfUserEngagement: 'high'
                });
                loadingRef.current = false;
            });
        }
    }, [
        update,
        accountId
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $euxye.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            loading: loading,
            displayState: {
                hideT7Banner: true,
                hideT30Banner: true,
                hideT90Banner: true,
                hideT90BannerNew: true
            },
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            displayState: data,
            loading: loading,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

const $d221fdaca3820e2c$export$ee26341514033dab = (0, $7edbf.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getDataLoader: ()=>(parcelRequire("85yJH")),
    maxAge: Infinity,
    isCritical: true,
    isBrowserOnly: true
});
const $d221fdaca3820e2c$export$6b1dcceb1bcecc4c = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)($d221fdaca3820e2c$export$ee26341514033dab);
    const errorRef = (0, $euxye.useRef)();
    errorRef.current = error;
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $euxye.useMemo)(()=>{
        if (errorRef.current || loading) return {
            loading: loading
        };
        return {
            gpEndDateDetails: data?.gpEndDateDetails,
            gpEndDate: data?.gracePeriodEndDate,
            loading: loading
        };
    }, [
        loading,
        data
    ]);
};

});
parcelRegister("kEKdX", function(module, exports) {
$parcel$export(module.exports, "JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $ca8565d09f8f1ce5$export$7d5b09dea0d101b7);
$parcel$export(module.exports, "DEFAULT_ANNOUNCEMENT_BANNER_DISPLAY_STATE", () => $ca8565d09f8f1ce5$export$3751c4ee78cb739a);
$parcel$export(module.exports, "FALLBACK_GP_END_DATE", () => $ca8565d09f8f1ce5$export$a50854eacfeb5c82);
/* eslint-disable jira/filename-case */ const $ca8565d09f8f1ce5$export$7d5b09dea0d101b7 = 'jsm-grace-period-announcement-dismiss-state';
const $ca8565d09f8f1ce5$export$3751c4ee78cb739a = {};
const $ca8565d09f8f1ce5$export$a50854eacfeb5c82 = new Date('10/16/2025');

});

parcelRegister("6D5AT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bdtKN").then(()=>parcelRequire('hjL1f'));

});

parcelRegister("85yJH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7d0ZI").then(()=>parcelRequire('kkyev'));

});


parcelRegister("53xPq", function(module, exports) {
$parcel$export(module.exports, "issueCollapsibleGroupDataResource", () => $81e85875ae392d60$export$36e5daae4cc63ce1);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist


var $i0CFV = parcelRequire("i0CFV");

var $bdEst = parcelRequire("bdEst");

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $81e85875ae392d60$var$getKey = ({ match: match, query: query })=>{
    const projectKey = (0, $i0CFV.getProjectKey)(match, query);
    return `issue.collapsible-group.${projectKey}`;
};
const $81e85875ae392d60$export$36e5daae4cc63ce1 = (0, $7edbf.createResource)({
    type: 'ISSUE_COLLAPSIBLE_GROUP_DATA',
    getKey: $81e85875ae392d60$var$getKey,
    getData: async ({ match: match, query: query })=>{
        const key = $81e85875ae392d60$var$getKey({
            match: match,
            query: query
        });
        const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
        try {
            return await (0, $h2wCv.performGetRequest)(requestUrl);
        } catch (error) {
            if (!!error && typeof error === 'object' && 'statusCode' in error && error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) return;
            throw (0, $bdEst.createResourceError)({
                component: 'spa.view.routes.issue-view.collapsible-group.getData',
                message: 'An error was thrown while prefetching issue collapsible group data'
            }, error);
        }
    }
});

});

parcelRegister("dk0Ly", function(module, exports) {
$parcel$export(module.exports, "jsmFeaturesEnabledResource", () => $518a3042f2e08002$export$c0dc1da2e81e91b4);

var $7edbf = parcelRequire("7edbf");

const $518a3042f2e08002$var$ONE_HOUR_MS = 3600000;

const $518a3042f2e08002$export$c0dc1da2e81e91b4 = (0, $7edbf.createResource)({
    type: (0, $0ec5a7f900257a97$export$72b898553bf6a17d),
    // Cross-project / site-wide — projectKey not required
    getKey: ()=>'jsm-features-enabled',
    getDataLoader: ()=>(parcelRequire("geXZg")),
    maxAge: $518a3042f2e08002$var$ONE_HOUR_MS
});

});
const $0ec5a7f900257a97$export$72b898553bf6a17d = 'JSM_FEATURES_ENABLED';

parcelRegister("geXZg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9I8z7").then(()=>parcelRequire('4coGV'));

});


parcelRegister("9MeJD", function(module, exports) {
$parcel$export(module.exports, "jsmProjectMenuContentSidebarResource", () => $75f85dce1fbb1bba$export$c7d29d5f00e667f5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $htsFl = parcelRequire("htsFl");

var $3mbAZ = parcelRequire("3mbAZ");

var $c4rhk = parcelRequire("c4rhk");
const $75f85dce1fbb1bba$export$71eec30d9db46a56 = ({ match: match, query: query }, resourceContext)=>{
    const cloudId = resourceContext?.tenantContext?.cloudId ?? '';
    let { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $3mbAZ.default),
        variables: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
};
const $75f85dce1fbb1bba$export$c7d29d5f00e667f5 = (0, $c4rhk.withGiraAggAnonSsrFix)((0, $htsFl.createRelayResource)({
    type: 'JSM_PROJECT_MENU_CONTENT_SIDEBAR_QUERY',
    getQuery: $75f85dce1fbb1bba$export$71eec30d9db46a56
}));

});
parcelRegister("3mbAZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $92cc07f255fbbd03$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9dc76a0ea05c88ee38cdd4d09db1b634>>
 * @relayHash 8dd5b06fa5bc2d9ff4de6b64c4af3db1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5814336fa93e71dd8b822b81d36d3d15b1166a15ff61ecfa37f53dea0958da24
const $92cc07f255fbbd03$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "itemId"
    }, v5 = {
        "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
        "kind": "LinkedField",
        "name": "hiddenMenuItems",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProjectLevelSidebarMenuItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v4 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jira_projectLevelSidebarMenuCustomization",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                                    "kind": "LinkedField",
                                    "name": "renamedMenuItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "JsmProjectMenuContent_renamedMenuItems"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraProjectLevelSidebarMenuCustomization"
                        },
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jira_projectLevelSidebarMenuCustomization",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                                    "kind": "LinkedField",
                                    "name": "renamedMenuItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectLevelSidebarRenamedMenuItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectLevelSidebarRenamedMenuItem",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renamedMenuItemName"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ],
                            "type": "JiraProjectLevelSidebarMenuCustomization"
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "5814336fa93e71dd8b822b81d36d3d15b1166a15ff61ecfa37f53dea0958da24",
            "metadata": {},
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$92cc07f255fbbd03$var$node.hash = "3edea9079a7d67e96cfc0889fb336b98";
var $92cc07f255fbbd03$export$2e2bcd8739ae039 = $92cc07f255fbbd03$var$node;

});

parcelRegister("c4rhk", function(module, exports) {
$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $9656216ca152d3e3$export$f4b29e78f4c0a526);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $9656216ca152d3e3$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});


parcelRegister("862Zj", function(module, exports) {
$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $843f6f02eaf41eb8$export$4847c29b4786b3b4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $cjlpE = parcelRequire("cjlpE");
const $843f6f02eaf41eb8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $843f6f02eaf41eb8$export$4847c29b4786b3b4 = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>$843f6f02eaf41eb8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $843f6f02eaf41eb8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $cjlpE.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("cjlpE", function(module, exports) {
$parcel$export(module.exports, "fetchShortcuts", () => $bb861d5f782e4a97$export$49d696bf2525d700);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");
const $bb861d5f782e4a97$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $4fhEY.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("aS6zs", function(module, exports) {
$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $7a3bd88a1eea5a02$export$ec28065a31cce4ce);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $fAjxN = parcelRequire("fAjxN");
const $7a3bd88a1eea5a02$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $7a3bd88a1eea5a02$export$ec28065a31cce4ce = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>$7a3bd88a1eea5a02$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $7a3bd88a1eea5a02$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $fAjxN.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("fAjxN", function(module, exports) {
$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $059cddf34e8fb97f$export$c1dd51127051647d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $059cddf34e8fb97f$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});



parcelRegister("jAJ0w", function(module, exports) {
$parcel$export(module.exports, "servicedeskVirtualAgentAiAnswersKbResource", () => $a3f299026551438d$export$6aecd43ca01da0d9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

const $a3f299026551438d$export$6aecd43ca01da0d9 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("go0DA")),
    isBrowserOnly: true
});

});
parcelRegister("go0DA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("xiTfU").then(()=>parcelRequire('lsgeV'));

});


parcelRegister("6pofw", function(module, exports) {
$parcel$export(module.exports, "APP_NAMES", () => $ce36512d2acb680d$export$4116f3d0d9d6bed7);
$parcel$export(module.exports, "toPackageName", () => $ce36512d2acb680d$export$f31a652635bd75fe);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $ce36512d2acb680d$export$4116f3d0d9d6bed7 = {
    ACCOUNTS: 'servicedesk.accounts',
    ROVO_SERVICE_AGENT_SETTINGS: 'servicedesk.rovo-service-agent.settings',
    ROVO_SETTINGS: 'servicedesk.rovo.settings',
    ROVO_OPS_SETTINGS: 'servicedesk.rovo-ops.settings',
    RESOLUTION_MANAGEMENT: 'servicedesk.resolution-management',
    ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
    AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
    AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
    AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
    BOARD: 'servicedesk.board',
    BOARD_SETTINGS: 'servicedesk.board-settings',
    CALENDAR: 'servicedesk.calendar',
    LIST: 'servicedesk.list',
    PROJECT_SUMMARY: 'servicedesk.project-summary',
    AVAILABILITY: 'servicedesk.availability',
    CAPACITY: 'servicedesk.capacity',
    SKILLS: 'servicedesk.skills',
    WORKFORCE_OPTIMIZATION_SETTINGS: 'servicedesk.workforce-optimization.settings',
    SCHEDULES: 'servicedesk.schedules',
    SURVEYS: 'servicedesk.surveys',
    CHANGE_CALENDAR: 'servicedesk.change-calendar',
    CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
    CREATE_PROJECT: 'servicedesk.create-project',
    CSAT_CONFIG: 'servicedesk.csat-configuration',
    CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
    CONTACTS: 'servicedesk.contacts',
    CUSTOMERS: 'servicedesk.customers',
    CHANNELS: 'servicedesk.channels',
    CUSTOMER_DETAILS: 'servicedesk.customer-details',
    CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
    CUSTOMER_SERVICE_GET_STARTED: 'servicedesk.customer-service-get-started',
    CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
    CUSTOMER_SERVICE_HELP_CENTER: 'servicedesk.customer-service-help-center',
    INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
    ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
    ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
    ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
    JOURNEYS: 'servicedesk.journeys',
    JOURNEY_CONFIG: 'servicedesk.journey-config',
    CUSTOM_JOURNEY_TYPE: 'servicedesk.custom-journey-type',
    PENDING_JOURNEYS: 'servicedesk.pending-journeys',
    GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
    SOLUTION_COMPOSER: 'servicedesk.solution-composer',
    LIVE_CHAT_MY_CHATS: 'servicedesk.live-chat.my-chats',
    KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
    KB_CATEGORY: 'servicedesk.knowledge-base.category',
    KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
    KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
    KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
    KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
    KB_LANDING: 'servicedesk.knowledge-base.landing',
    KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
    KB_SEARCH: 'servicedesk.knowledge-base.search',
    KB_SETTINGS: 'servicedesk.knowledge.settings',
    KB_SETUP: 'servicedesk.knowledge-base.setup',
    KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
    ORGANIZATION: 'servicedesk.organization',
    ORGANIZATIONS: 'servicedesk.organizations',
    ORGANIZATION_DETAILS: 'servicedesk.organization-details',
    PORTAL_SETTINGS: 'servicedesk.portal-settings',
    PROACTIVE_SUPPORT: 'servicedesk.proactive-support',
    QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
    QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
    QUEUES_MAIN: 'servicedesk.queues.main',
    REPORTS_CUSTOM: 'servicedesk.reports.custom',
    REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
    REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
    REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
    REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
    REPORTS_WORKLOAD: 'servicedesk.reports.workload',
    REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
    REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
    SLA_SETTINGS: 'servicedesk.sla-settings',
    VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
    VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
    VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
    VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
    VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
    VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
    VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
    VIRTUAL_AGENT_AI_ANSWERS: 'servicedesk.virtual-agent.ai-answers',
    VIRTUAL_AGENT_PERFORMANCE: 'servicedesk.virtual-agent.performance',
    PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
    RCA_INVESTIGATION: 'servicedesk.rca-investigation',
    CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
    UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
    LANGUAGE_SETTINGS: 'servicedesk.language-settings',
    LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
    INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
    INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
    INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE: 'servicedesk.insight-cmdb-assets_dashboards_list_page',
    INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE: 'servicedesk.insight-cmdb-assets_dashboards_detail_page',
    INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
    INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
    INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
    INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
    INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
    INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
    INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
    CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
    CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
    CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
    CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
    CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
    SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
    SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
    WIDGET_SETTINGS: 'servicedesk.widget-settings',
    ASSETS_APP_SEARCH_RESULTS: 'assets-app.search-results-page',
    ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE: 'assets-app.data-manager.getting-started-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE: 'assets-app.data-manager.object-classes-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE: 'assets-app.data-manager.object-detail-view',
    ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE: 'assets-app.data-manager.data-source',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE: 'assets-app.data-manager.object-class-view',
    ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE: 'assets-app.analytics.data-view.create',
    ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE: 'assets-app.analytics.data-view.details',
    ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE: 'assets-app.analytics.data-view.list',
    ASSETS_APP_FOR_YOU_PAGE: 'assets-app.for-you-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_SETTINGS_PAGE: 'assets-app.data-manager.object-classes-settings-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_SETTINGS_PAGE: 'assets-app.data-manager.object-class-settings-page',
    ASSETS_APP_DATA_MANAGER_ISSUES_PAGE: 'assets-app.data-manager.issues-page',
    ASSETS_APP_DATA_MANAGER_DATA_DICTIONARY_GROUP_PAGE: 'assets-app.data-manager.data-dictionary-group',
    SETTINGS_LIVE_CHAT: 'servicedesk.settings.live-chat',
    WORKFORCE_OPTIMIZATION: 'servicedesk.workforce-optimization',
    PROACTIVE_SERVICE_MANAGEMENT_SETTINGS: 'servicedesk.proactive-service-management-settings'
};
// To match the FE error analytics pipeline convention
const $ce36512d2acb680d$var$ANALYTICS_PACKAGE_NAMES = {
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ROVO_SERVICE_AGENT_SETTINGS]: 'servicedeskRovoServiceAgentSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ROVO_SETTINGS]: 'servicedeskRovoSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ROVO_OPS_SETTINGS]: 'servicedeskRovoOpsSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.RESOLUTION_MANAGEMENT]: 'servicedeskResolutionManagement',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.LIST]: 'servicedeskList',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.AVAILABILITY]: 'servicedeskAvailability',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CAPACITY]: 'servicedeskCapacity',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.SKILLS]: 'servicedeskSkills',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.WORKFORCE_OPTIMIZATION_SETTINGS]: 'servicedeskWorkforceOptimizationSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.SCHEDULES]: 'servicedeskSchedules',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.SURVEYS]: 'servicedeskSurveys',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CHANNELS]: 'servicedeskChannels',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_GET_STARTED]: 'servicedeskCustomerServiceGetStarted',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_HELP_CENTER]: 'servicedeskCustomerServiceHelpCenter',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOM_JOURNEY_TYPE]: 'servicedeskCustomJourneyType',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.PENDING_JOURNEYS]: 'servicedeskPendingJourneys',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.PROACTIVE_SUPPORT]: 'servicedeskProactiveSupport',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_AI_ANSWERS]: 'servicedeskVirtualAgentAiAnswers',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_PERFORMANCE]: 'servicedeskVirtualAgentPerformance',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.RCA_INVESTIGATION]: 'servicedeskRcaInvestigation',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE]: 'servicedeskAssetsDashboardsListPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE]: 'servicedeskAssetsDashboardsDetailPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.SOLUTION_COMPOSER]: 'servicedeskSolutionComposer',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.LIVE_CHAT_MY_CHATS]: 'servicedeskLiveChatMyChats',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_SEARCH_RESULTS]: 'assetsAppSearchResultsPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE]: 'assetsAppDataManagerGettingStartedPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE]: 'assetsAppDataManagerObjectClassesPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE]: 'assetsAppDataManagerDataSource',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE]: 'assetsAppDataManagerObjectClassView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE]: 'assetsAppDataManagerObjectDetailView',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE]: 'assetsAppAnalyticsDataViewCreatePage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE]: 'assetsAppAnalyticsDataViewDetailsPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE]: 'assetsAppAnalyticsDataViewListPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_FOR_YOU_PAGE]: 'assetsAppForYouPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_SETTINGS_PAGE]: 'assetsAppDataManagerObjectClassesSettingsPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_SETTINGS_PAGE]: 'assetsAppDataManagerObjectClassSettingsPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_ISSUES_PAGE]: 'assetsAppDataManagerIssuesPage',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_DATA_DICTIONARY_GROUP_PAGE]: 'assetsAppDataManagerDataDictionaryGroup',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.SETTINGS_LIVE_CHAT]: 'servicedeskSettingsLiveChat',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.WORKFORCE_OPTIMIZATION]: 'servicedeskWorkforceOptimization',
    [$ce36512d2acb680d$export$4116f3d0d9d6bed7.PROACTIVE_SERVICE_MANAGEMENT_SETTINGS]: 'servicedeskProactiveServiceManagementSettings'
};
const $ce36512d2acb680d$export$f31a652635bd75fe = (appName)=>$ce36512d2acb680d$var$ANALYTICS_PACKAGE_NAMES[appName];

});

parcelRegister("66JI4", function(module, exports) {
$parcel$export(module.exports, "aiAnswersRoute", () => $8f9a7927ae440dd8$export$57dc115194d72385);
const $8f9a7927ae440dd8$export$57dc115194d72385 = {
    name: 'project-settings-servicedesk-virtualagent-ai-answers',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/ai-answers'
};

});

parcelRegister("74h93", function(module, exports) {
$parcel$export(module.exports, "serviceProjectLayout", () => $44fa6fd16185f126$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $44fa6fd16185f126$export$820f9bb834280408);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $i860n = parcelRequire("i860n");

var $aWliK = parcelRequire("aWliK");

var $h2tgz = parcelRequire("h2tgz");

var $dllN1 = parcelRequire("dllN1");

var $2HVE2 = parcelRequire("2HVE2");

var $lVzKq = parcelRequire("lVzKq");

var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

var $jepRN = parcelRequire("jepRN");

var $2GQ8g = parcelRequire("2GQ8g");

var $lp24J = parcelRequire("lp24J");

var $geeJ4 = parcelRequire("geeJ4");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $44fa6fd16185f126$var$withServiceProjectContext = (Component)=>(0, $QhQu4.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $f99M0.SERVICE_DESK_PROJECT)
        }
    });
const $44fa6fd16185f126$var$AdaptiveLanguageGlobalGated = (0, $jepRN.componentWithFG)('jsm_adaptive_language_enabled', $44fa6fd16185f126$var$withServiceProjectContext((0, $2HVE2.AdaptiveLanguageGlobal)), ()=>null);
$44fa6fd16185f126$var$AdaptiveLanguageGlobalGated.displayName = 'AdaptiveLanguageGlobalGated';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $44fa6fd16185f126$var$ProjectBuilder = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("4CmB9")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $44fa6fd16185f126$var$HrSpaceProjectOverlay = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("5gqRZ")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-service-project-layout/src/ui/hr-space-overlay/HrSpaceOverlay.tsx"
});
const $44fa6fd16185f126$var$HrSpaceProjectOverlayWhenGateOff = ()=>null;
$44fa6fd16185f126$var$HrSpaceProjectOverlayWhenGateOff.displayName = 'HrSpaceProjectOverlayWhenGateOff';
const $44fa6fd16185f126$var$GatedHrSpaceProjectOverlay = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('is-hrsm-space-enabled'), $44fa6fd16185f126$var$withServiceProjectContext($44fa6fd16185f126$var$HrSpaceProjectOverlay), $44fa6fd16185f126$var$HrSpaceProjectOverlayWhenGateOff);
$44fa6fd16185f126$var$GatedHrSpaceProjectOverlay.displayName = 'GatedHrSpaceProjectOverlay';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $44fa6fd16185f126$var$Onboarding = (0, $l8G1z.lazy)(()=>(parcelRequire("9ZZ9z")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $44fa6fd16185f126$var$RightSidebars = (0, $l8G1z.lazy)(()=>(parcelRequire("4lLiV")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $44fa6fd16185f126$var$OnboardingWithPreload = ()=>{
    const shouldRender = (0, $lp24J.useOnboardingPreload)($44fa6fd16185f126$var$Onboarding);
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($44fa6fd16185f126$var$Onboarding, null) : null;
};
$44fa6fd16185f126$var$OnboardingWithPreload.displayName = "OnboardingWithPreload";
const $44fa6fd16185f126$var$OnboardingWithStatus = (0, $jepRN.componentWithFG)('servicedesk_onboarding_quickstart_enabled', $44fa6fd16185f126$var$OnboardingWithPreload, $44fa6fd16185f126$var$Onboarding);
$44fa6fd16185f126$var$OnboardingWithStatus.displayName = 'Lazy(ui/onboarding/index.tsx)';
const $44fa6fd16185f126$var$RightSidebarsWithPreload = ()=>{
    const shouldRender = (0, $geeJ4.useJsmRightSidebarsPreload)($44fa6fd16185f126$var$RightSidebars);
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($44fa6fd16185f126$var$RightSidebars, null) : null;
};
$44fa6fd16185f126$var$RightSidebarsWithPreload.displayName = "RightSidebarsWithPreload";
const $44fa6fd16185f126$var$RightSidebarsWithStatus = (0, $jepRN.componentWithFG)('servicedesk_onboarding_quickstart_enabled', $44fa6fd16185f126$var$RightSidebarsWithPreload, $44fa6fd16185f126$var$RightSidebars);
$44fa6fd16185f126$var$RightSidebarsWithStatus.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';
const $44fa6fd16185f126$export$e321cb31c875d1ba = (0, $QhQu4.composeLayouts)((0, $lVzKq.projectLayout), {
    globalComponents: [
        $44fa6fd16185f126$var$withServiceProjectContext($44fa6fd16185f126$var$OnboardingWithStatus),
        $44fa6fd16185f126$var$withServiceProjectContext((0, $dllN1.AsyncJsmCustomDomainChangeBoardingFlag)),
        $44fa6fd16185f126$var$ProjectBuilder,
        (0, $2GQ8g.default),
        $44fa6fd16185f126$var$GatedHrSpaceProjectOverlay,
        $44fa6fd16185f126$var$AdaptiveLanguageGlobalGated
    ],
    rightSidebars: [
        $44fa6fd16185f126$var$withServiceProjectContext($44fa6fd16185f126$var$RightSidebarsWithStatus)
    ]
});
const $44fa6fd16185f126$export$820f9bb834280408 = (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), {
    rightSidebars: [
        $44fa6fd16185f126$var$RightSidebars
    ]
});

});
parcelRegister("dllN1", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $b6730699956f1b3a$export$b1ef5e3da6e1959d);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gDou3 = parcelRequire("gDou3");

var $jWDKp = parcelRequire("jWDKp");

var $h8QGu = parcelRequire("h8QGu");

var $i860n = parcelRequire("i860n");

var $aWliK = parcelRequire("aWliK");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $Jpr33 = parcelRequire("Jpr33");

const $b6730699956f1b3a$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("gqr8X")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/JsmCustomDomainChangeBoardingFlag.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b6730699956f1b3a$var$LazyJsmCustomDomainChangeBoardingFlagNew = (0, $l8G1z.lazy)(()=>(parcelRequire("gqr8X")).then((exportedModule)=>exportedModule.JsmCustomDomainChangeBoardingFlagNew), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/JsmCustomDomainChangeBoardingFlag.tsx"
});
const $b6730699956f1b3a$var$MILLISECONDS_IN_A_DAY = 1440000;
const $b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagOld = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b6730699956f1b3a$var$LazyJsmCustomDomainChangeBoardingFlag, null)));
};
$b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagOld.displayName = "AsyncJsmCustomDomainChangeBoardingFlagOld";
const $b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagNew = ()=>{
    const currentTime = Date.now();
    const [{ userSeenFlagDate: userSeenFlagDate, showFlagUpdateStartDate: showFlagUpdateStartDate, helpCenterUrls: helpCenterUrls, customDomainStatus: customDomainStatus }, { updateUserProperty: updateUserProperty, fetchApplicationProperty: fetchApplicationProperty, fetchSeenFlagDateProperty: fetchSeenFlagDateProperty }] = (0, $Jpr33.useProperties)();
    const fetchPropertiesRef = (0, $euxye.useRef)(()=>Promise.resolve([]));
    (0, $euxye.useEffect)(()=>{
        fetchPropertiesRef.current = ()=>Promise.all([
                fetchApplicationProperty(),
                fetchSeenFlagDateProperty()
            ]);
    }, [
        fetchApplicationProperty,
        fetchSeenFlagDateProperty
    ]);
    (0, $euxye.useEffect)(()=>{
        const fetchProperties = ()=>{
            Promise.resolve(fetchPropertiesRef.current()).catch(()=>undefined);
        };
        fetchProperties();
        const pollInterval = setInterval(fetchProperties, $b6730699956f1b3a$var$MILLISECONDS_IN_A_DAY);
        return ()=>clearInterval(pollInterval);
    }, []);
    if (helpCenterUrls === undefined || customDomainStatus === undefined) return null;
    if (userSeenFlagDate === (0, $Jpr33.NOT_LOADED) || showFlagUpdateStartDate === (0, $Jpr33.NOT_LOADED)) return null;
    if (showFlagUpdateStartDate === (0, $Jpr33.NO_VALUE)) return null;
    if ((0, $jWDKp.default)(new Date(currentTime), new Date(showFlagUpdateStartDate))) return null;
    if (userSeenFlagDate !== (0, $Jpr33.NO_VALUE) && (0, $gDou3.default)(new Date(userSeenFlagDate), new Date(showFlagUpdateStartDate))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b6730699956f1b3a$var$LazyJsmCustomDomainChangeBoardingFlagNew, {
        helpCenterUrls: helpCenterUrls,
        customDomainStatus: customDomainStatus,
        onUpdateUserProperty: updateUserProperty
    })));
};
$b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagNew.displayName = "AsyncJsmCustomDomainChangeBoardingFlagNew";
const $b6730699956f1b3a$export$b1ef5e3da6e1959d = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('ttai_fix_jsm_custom_domain_change_boarding_flag'), $b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagNew, $b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagOld);

});
parcelRegister("Jpr33", function(module, exports) {
$parcel$export(module.exports, "NOT_LOADED", () => $c01a0696a0f882e4$export$256d135b6d6cdabe);
$parcel$export(module.exports, "NO_VALUE", () => $c01a0696a0f882e4$export$d5a265bcf7e0ecc1);
$parcel$export(module.exports, "useProperties", () => $c01a0696a0f882e4$export$b003fb77901c7fe3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $siTdT = parcelRequire("siTdT");

var $kM0go = parcelRequire("kM0go");

var $h2wCv = parcelRequire("h2wCv");

var $eijVy = parcelRequire("eijVy");
const $c01a0696a0f882e4$var$USER_SEEN_FLAG_PROPERTY_KEY = 'jsm.custom.domain.flag.seen.date';
const $c01a0696a0f882e4$var$PACKAGE_NAME = 'jiraHelpCenterCustomDomainChangeBoarding';
const $c01a0696a0f882e4$var$TEAM_NAME = 'jsm-banana';
const $c01a0696a0f882e4$var$FETCH_USER_PROPERTY_ERROR_ID = 'fetchUserProperty';
const $c01a0696a0f882e4$var$UPDATE_USER_PROPERTY_ERROR_ID = 'updateUserProperty';
const $c01a0696a0f882e4$var$GET_SHOW_FLAG_DATE_ERROR_ID = 'getShowFlagDate';
const $c01a0696a0f882e4$export$256d135b6d6cdabe = 'NOT_LOADED';
const $c01a0696a0f882e4$export$d5a265bcf7e0ecc1 = 'NO_VALUE';
const $c01a0696a0f882e4$var$EXPECTED_ERROR_STATUS = [
    403,
    404
];
const $c01a0696a0f882e4$export$b003fb77901c7fe3 = ()=>{
    const currentTime = Date.now();
    const [loading, setLoading] = (0, $euxye.useState)(false);
    const [error, setError] = (0, $euxye.useState)(null);
    const [showFlagUpdateStartDate, setShowFlagUpdateStartDate] = (0, $euxye.useState)($c01a0696a0f882e4$export$256d135b6d6cdabe);
    const [helpCenterUrls, setHelpcenterUrls] = (0, $euxye.useState)(undefined);
    const [customDomainStatus, setCustomDomainStatus] = (0, $euxye.useState)(undefined);
    const [userSeenFlagDate, setUserSeenFlagDate] = (0, $euxye.useState)($c01a0696a0f882e4$export$256d135b6d6cdabe);
    const { atlassianAccountId: atlassianAccountId } = (0, $eijVy.useTenantContext)();
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const handleErrorLogging = (0, $euxye.useCallback)((operation, e)=>{
        setLoading(false);
        if (e.name === 'FetchError' && !$c01a0696a0f882e4$var$EXPECTED_ERROR_STATUS.includes(e.statusCode)) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: operation,
                    packageName: $c01a0696a0f882e4$var$PACKAGE_NAME,
                    teamName: $c01a0696a0f882e4$var$TEAM_NAME
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(e);
        }
    }, []);
    const fetchSeenFlagDateProperty = (0, $euxye.useCallback)(async ()=>{
        if (loading) return;
        if (atlassianAccountId && userSeenFlagDate === $c01a0696a0f882e4$export$256d135b6d6cdabe) {
            setLoading(true);
            try {
                const response = await (0, $kM0go.getUserProperty)(atlassianAccountId, $c01a0696a0f882e4$var$USER_SEEN_FLAG_PROPERTY_KEY);
                setLoading(false);
                setUserSeenFlagDate(Number(response));
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setUserSeenFlagDate($c01a0696a0f882e4$export$d5a265bcf7e0ecc1);
                handleErrorLogging($c01a0696a0f882e4$var$FETCH_USER_PROPERTY_ERROR_ID, e);
            }
        }
    }, [
        atlassianAccountId,
        handleErrorLogging,
        loading,
        userSeenFlagDate
    ]);
    const updateUserProperty = (0, $euxye.useCallback)(async ()=>{
        if (loading) return;
        if (atlassianAccountId) {
            setLoading(true);
            try {
                await (0, $kM0go.setUserProperties)(atlassianAccountId, $c01a0696a0f882e4$var$USER_SEEN_FLAG_PROPERTY_KEY, currentTime.toString());
                setLoading(false);
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                handleErrorLogging($c01a0696a0f882e4$var$UPDATE_USER_PROPERTY_ERROR_ID, e);
            }
        }
    }, [
        atlassianAccountId,
        currentTime,
        handleErrorLogging,
        loading
    ]);
    const fetchApplicationProperty = (0, $euxye.useCallback)(async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            const fetchStartTime = performance.now();
            const response = await (0, $h2wCv.performGetRequest)('/rest/servicedesk/1/customdomain');
            (0, $siTdT.addSpanToAll)('fetch', 'rest/servicedesk/1/customdomain', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            const { startDate: startDate, newUrl: newUrl, oldUrl: oldUrl, status: status } = response;
            setLoading(false);
            setShowFlagUpdateStartDate(startDate);
            setHelpcenterUrls({
                newUrl: newUrl,
                oldUrl: oldUrl
            });
            setCustomDomainStatus(status);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setShowFlagUpdateStartDate($c01a0696a0f882e4$export$d5a265bcf7e0ecc1);
            handleErrorLogging($c01a0696a0f882e4$var$GET_SHOW_FLAG_DATE_ERROR_ID, e);
        }
    }, [
        handleErrorLogging,
        loading
    ]);
    const memoisedData = (0, $euxye.useMemo)(()=>({
            userSeenFlagDate: userSeenFlagDate,
            showFlagUpdateStartDate: showFlagUpdateStartDate,
            helpCenterUrls: helpCenterUrls,
            customDomainStatus: customDomainStatus,
            loading: loading,
            error: error
        }), [
        userSeenFlagDate,
        showFlagUpdateStartDate,
        loading,
        error,
        helpCenterUrls,
        customDomainStatus
    ]);
    return [
        memoisedData,
        {
            fetchSeenFlagDateProperty: fetchSeenFlagDateProperty,
            updateUserProperty: updateUserProperty,
            fetchApplicationProperty: fetchApplicationProperty
        }
    ];
};

});

parcelRegister("gqr8X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("Rnxvl")
]).then(()=>parcelRequire('eEuZo'));

});


parcelRegister("2HVE2", function(module, exports) {
$parcel$export(module.exports, "AdaptiveLanguageGlobal", () => $e6d544b71691d628$export$55c0af67636fff35);

var $euxye = parcelRequire("euxye");

var $h2wCv = parcelRequire("h2wCv");

var $kt86l = parcelRequire("kt86l");

var $2b39L = parcelRequire("2b39L");

var $ggu1H = parcelRequire("ggu1H");
const $e6d544b71691d628$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $e6d544b71691d628$var$GLOSSARY_QUERY = `
  query jsmAdaptiveLanguageGlossary($projectAri: ID!) {
    jsmAdaptiveLanguage {
      glossaryForProject(projectAri: $projectAri) {
        glossary {
          domain
          compiledGlossary
        }
      }
    }
  }
`;
function $e6d544b71691d628$export$55c0af67636fff35() {
    const cloudId = (0, $kt86l.useCloudId)();
    const { data: projectContext } = (0, $2b39L.useProjectContext)();
    const projectId = projectContext?.projectId;
    const abortRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!projectId || !cloudId) {
            (0, $ggu1H.adaptiveLanguageStore).reset();
            return;
        }
        // Abort any in-flight request from previous project navigation
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
        (0, $ggu1H.adaptiveLanguageStore).setState({
            domain: null,
            glossary: null,
            status: 'loading'
        });
        (0, $h2wCv.performPostRequest)($e6d544b71691d628$var$GRAPHQL_ENDPOINT, {
            body: JSON.stringify({
                query: $e6d544b71691d628$var$GLOSSARY_QUERY,
                variables: {
                    projectAri: projectAri
                }
            }),
            signal: controller.signal
        }).then((json)=>{
            const glossaryData = json.data?.jsmAdaptiveLanguage?.glossaryForProject?.glossary;
            if (!glossaryData?.domain) {
                (0, $ggu1H.adaptiveLanguageStore).setState({
                    domain: null,
                    glossary: null,
                    status: 'ready'
                });
                return;
            }
            let glossary = null;
            try {
                glossary = glossaryData.compiledGlossary ? JSON.parse(glossaryData.compiledGlossary) : null;
            } catch  {
                glossary = null;
            }
            (0, $ggu1H.adaptiveLanguageStore).setState({
                domain: glossaryData.domain,
                glossary: glossary,
                status: 'ready'
            });
        }).catch((err)=>{
            if (err.name === 'AbortError') return;
            (0, $ggu1H.adaptiveLanguageStore).setState({
                domain: null,
                glossary: null,
                status: 'error'
            });
        });
        return ()=>{
            controller.abort();
        };
    }, [
        projectId,
        cloudId
    ]);
    // Headless — renders nothing
    return null;
}
$e6d544b71691d628$export$55c0af67636fff35.displayName = "AdaptiveLanguageGlobal";

});
parcelRegister("2b39L", function(module, exports) {
$parcel$export(module.exports, "useProjectContext", () => $0f8c1b9d3f2c872d$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0f8c1b9d3f2c872d$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0f8c1b9d3f2c872d$export$a85f6b5857d2176);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $d7dm3 = parcelRequire("d7dm3");

var $edf7u = parcelRequire("edf7u");
const $0f8c1b9d3f2c872d$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $d7dm3.useResourceWithCustomRouterContext)((0, $edf7u.projectContextResourceWithCache), customContext);
    const updateCache = (0, $euxye.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0f8c1b9d3f2c872d$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0f8c1b9d3f2c872d$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0f8c1b9d3f2c872d$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0f8c1b9d3f2c872d$export$8f31c2503e1efa93();
    return children(projectContext);
};
$0f8c1b9d3f2c872d$export$a85f6b5857d2176.displayName = "ProjectContextProvider";

});

parcelRegister("ggu1H", function(module, exports) {
$parcel$export(module.exports, "adaptiveLanguageStore", () => $a1ee7a551cc7d14b$export$d5fa697e09a2cf83);

var $euxye = parcelRequire("euxye");

var $gXtG2 = parcelRequire("gXtG2");
const $a1ee7a551cc7d14b$var$DEFAULT_STATE = {
    domain: null,
    glossary: null,
    status: 'idle'
};
let $a1ee7a551cc7d14b$var$state = $a1ee7a551cc7d14b$var$DEFAULT_STATE;
const $a1ee7a551cc7d14b$var$listeners = new Set();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $a1ee7a551cc7d14b$var$state = $a1ee7a551cc7d14b$var$DEFAULT_STATE;
    $a1ee7a551cc7d14b$var$listeners.clear();
});
function $a1ee7a551cc7d14b$var$emitChange() {
    $a1ee7a551cc7d14b$var$listeners.forEach((listener)=>listener());
}
const $a1ee7a551cc7d14b$export$d5fa697e09a2cf83 = {
    getState () {
        return $a1ee7a551cc7d14b$var$state;
    },
    setState (next) {
        $a1ee7a551cc7d14b$var$state = next;
        $a1ee7a551cc7d14b$var$emitChange();
    },
    reset () {
        $a1ee7a551cc7d14b$var$state = $a1ee7a551cc7d14b$var$DEFAULT_STATE;
        $a1ee7a551cc7d14b$var$emitChange();
    },
    subscribe (listener) {
        $a1ee7a551cc7d14b$var$listeners.add(listener);
        return ()=>$a1ee7a551cc7d14b$var$listeners.delete(listener);
    }
};
function $a1ee7a551cc7d14b$export$6eed6b0c7ec891c3() {
    const [, forceUpdate] = (0, $euxye.useReducer)((x)=>x + 1, 0);
    (0, $euxye.useEffect)(()=>{
        // Re-subscribe on mount, unsubscribe on unmount
        return $a1ee7a551cc7d14b$export$d5fa697e09a2cf83.subscribe(forceUpdate);
    }, []);
    return $a1ee7a551cc7d14b$export$d5fa697e09a2cf83.getState();
}

});


parcelRegister("lVzKq", function(module, exports) {
$parcel$export(module.exports, "projectLayout", () => $d5aa3103333b69ed$export$204149bac601d20c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gBYjj = parcelRequire("gBYjj");

var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $d5aa3103333b69ed$var$withAnyProjectContext = (Component)=>(0, $QhQu4.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d5aa3103333b69ed$var$ProjectTrackers = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("khWHB")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-project-layout/src/ui/trackers/index.tsx"
});
const $d5aa3103333b69ed$var$rightSidebars = ()=>[];
const $d5aa3103333b69ed$var$globalComponents = [
    $d5aa3103333b69ed$var$withAnyProjectContext($d5aa3103333b69ed$var$ProjectTrackers),
    $d5aa3103333b69ed$var$withAnyProjectContext((0, $gBYjj.ProjectRouteListener))
];
const $d5aa3103333b69ed$export$204149bac601d20c = (0, $QhQu4.createLayout)({
    globalComponents: $d5aa3103333b69ed$var$globalComponents,
    rightSidebars: $d5aa3103333b69ed$var$rightSidebars()
});

});
parcelRegister("gBYjj", function(module, exports) {
$parcel$export(module.exports, "ProjectRouteListener", () => $0e06a4aa3ba79161$export$159f09d701320911);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $edf7u = parcelRequire("edf7u");

var $fNgVF = parcelRequire("fNgVF");

var $k6ufm = parcelRequire("k6ufm");

var $lpBPi = parcelRequire("lpBPi");
const $0e06a4aa3ba79161$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $fNgVF.useIsAdmin)();
    const { data: data, loading: loading } = (0, $k6ufm.useResource)((0, $edf7u.projectContextResource));
    (0, $euxye.useEffect)(()=>{
        if (isSiteAdmin) (0, $lpBPi.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $lpBPi.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $lpBPi.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $euxye.useEffect)(()=>()=>(0, $lpBPi.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};
$0e06a4aa3ba79161$export$159f09d701320911.displayName = "ProjectRouteListener";

});
parcelRegister("fNgVF", function(module, exports) {
$parcel$export(module.exports, "useIsAdmin", () => $dd6cfe4a659f4b74$export$99a5e4bc80d231ca);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $dd6cfe4a659f4b74$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("lpBPi", function(module, exports) {
$parcel$export(module.exports, "getIsProjectAdmin", () => $32b051f0f25deea4$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $32b051f0f25deea4$export$d53e6d79d3fa5f31);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ let $32b051f0f25deea4$var$projectAdmin = null;
const $32b051f0f25deea4$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($32b051f0f25deea4$var$projectAdmin == null || !$32b051f0f25deea4$var$projectAdmin.loading && $32b051f0f25deea4$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($32b051f0f25deea4$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($32b051f0f25deea4$var$projectAdmin.isProjectAdmin);
};
const $32b051f0f25deea4$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $32b051f0f25deea4$var$projectAdmin = projectAdminState;
};

});


parcelRegister("khWHB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i1n0f").then(()=>parcelRequire('8FSF0'));

});


parcelRegister("2GQ8g", function(module, exports) {
$parcel$export(module.exports, "default", () => $eba9e48bd1147a92$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $2ffUK = parcelRequire("2ffUK");
var $bc9Gj = parcelRequire("bc9Gj");

var $fAcHb = parcelRequire("fAcHb");
const $eba9e48bd1147a92$var$CROSS_FLOW_SOURCE_QUERY_PARAM = 'source';
const $eba9e48bd1147a92$var$CROSS_FLOW_SOURCE_VALUE = 'cross-flow';
const $eba9e48bd1147a92$var$ProjectBuilderCrossFlowSourceTrigger = ()=>{
    const [sourceQueryParam, setSourceQueryParam] = (0, $2ffUK.useQueryParam)($eba9e48bd1147a92$var$CROSS_FLOW_SOURCE_QUERY_PARAM);
    const [{ route: route }] = (0, $bc9Gj.useRouter)();
    const [, actions] = (0, $fAcHb.useProjectBuilder)();
    (0, $euxye.useEffect)(()=>{
        if (sourceQueryParam === $eba9e48bd1147a92$var$CROSS_FLOW_SOURCE_VALUE && (route.name === 'servicedesk-queues-landing' || route.name === 'servicedesk-getting-started-page')) {
            if ((0, $2700E.expVal)('sequoia_jsmgrowth-219_bring_forwaed_request_types', 'isEnabled', false)) actions.showProjectBuilder();
            setSourceQueryParam(undefined);
        }
    }, [
        actions,
        sourceQueryParam,
        route.name,
        setSourceQueryParam
    ]);
    return null;
};
$eba9e48bd1147a92$var$ProjectBuilderCrossFlowSourceTrigger.displayName = "ProjectBuilderCrossFlowSourceTrigger";
var $eba9e48bd1147a92$export$2e2bcd8739ae039 = $eba9e48bd1147a92$var$ProjectBuilderCrossFlowSourceTrigger;

});
parcelRegister("fAcHb", function(module, exports) {
$parcel$export(module.exports, "useProjectBuilder", () => $1a0de1ec2fcd4675$export$5891129c2551a3c0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $1a0de1ec2fcd4675$var$ProjectBuilderStore = (0, $5QDqc.createStore)({
    initialState: {
        isProjectBuilderOpen: false
    },
    actions: {
        hideProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: false
                });
            },
        showProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: true
                });
            }
    },
    name: 'projectBuilder'
});
const $1a0de1ec2fcd4675$export$5891129c2551a3c0 = (0, $3h1FP.createHook)($1a0de1ec2fcd4675$var$ProjectBuilderStore);

});


parcelRegister("lp24J", function(module, exports) {
$parcel$export(module.exports, "useOnboardingPreload", () => $139f17533551418f$export$6d623864be1040dc);

var $euxye = parcelRequire("euxye");

var $bt7h8 = parcelRequire("bt7h8");

var $2b39L = parcelRequire("2b39L");
const $139f17533551418f$export$6d623864be1040dc = (target)=>{
    const hasPreloadedRef = (0, $euxye.useRef)(false);
    const projectContext = (0, $2b39L.useProjectContext)();
    const projectContextData = projectContext?.data;
    const canShowExperience = (0, $bt7h8.useQuickstart)(projectContextData);
    (0, $euxye.useEffect)(()=>{
        if (canShowExperience && !hasPreloadedRef.current) {
            target.preload?.();
            hasPreloadedRef.current = true;
        }
    }, [
        canShowExperience,
        target
    ]);
    return canShowExperience;
};

});
parcelRegister("bt7h8", function(module, exports) {
$parcel$export(module.exports, "useQuickstart", () => $f10f337df5b8cae6$export$eee715064db7b785);

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $gapGE = parcelRequire("gapGE");


var $eki8y = parcelRequire("eki8y");

var $4hGfa = parcelRequire("4hGfa");

var $62Xqf = parcelRequire("62Xqf");

var $i860n = parcelRequire("i860n");
const $f10f337df5b8cae6$export$eee715064db7b785 = (projectContextData, containerType = 'project')=>{
    const [{ data: containerContext }] = (0, $gapGE.useContainerContext)();
    const spaStatePageReady = (0, $62Xqf.useSpaStatePageReady)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $eki8y.useJsmOnboardingType)();
    const [projectState] = (0, $4hGfa.useProjectState)();
    const projectId = projectContextData?.projectId ?? projectState?.projectId;
    const projectType = projectContextData?.projectType ?? projectState?.projectType;
    (0, $euxye.useEffect)(()=>{
        fetchOnboardingType(projectId, projectType);
    }, [
        jsmOnboardingData,
        fetchOnboardingType,
        projectId,
        projectType
    ]);
    if (containerType === 'project' && projectType != null && projectType !== (0, $f99M0.SOFTWARE_PROJECT) && projectType !== (0, $f99M0.CORE_PROJECT) && projectType !== (0, $f99M0.SERVICE_DESK_PROJECT)) // If containerType is project and projectContext is present and it is not software, core or service management, don't render
    return false;
    // Scope Type in classic -- scrum/kanban/undefined(non-scrum/kanban) & next-gen -- simple
    const isProjectScopeAvailable = containerContext && containerContext.scope && containerContext.scope.type;
    const isProjectScopeAndSpaPageReady = Boolean(isProjectScopeAvailable) && spaStatePageReady;
    const showJswExperience = (0, $i860n.fg)('jira-fix-quickstart-not-showing') ? containerType === 'project' && projectType === (0, $f99M0.SOFTWARE_PROJECT) && spaStatePageReady : isProjectScopeAndSpaPageReady;
    const showJwmExperience = (0, $i860n.fg)('jira-fix-quickstart-not-showing') ? containerType === 'project' && projectType === (0, $f99M0.CORE_PROJECT) : containerContext?.contextType === 'project' && projectType === (0, $f99M0.CORE_PROJECT);
    const showJsmExperience = (0, $i860n.fg)('jira-fix-quickstart-not-showing') ? containerType === 'project' && projectType === (0, $f99M0.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $77d3ca58d1d4a14f$export$6f454e69bce3a691) : containerContext?.contextType === 'project' && projectType === (0, $f99M0.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $77d3ca58d1d4a14f$export$6f454e69bce3a691);
    const showPlanExperience = containerType === 'plan';
    const canShowExperience = showJwmExperience || showJsmExperience || showJswExperience || showPlanExperience;
    return canShowExperience;
};

});
parcelRegister("gapGE", function(module, exports) {
$parcel$export(module.exports, "useContainerContext", () => $55966eaed0cd6835$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $55966eaed0cd6835$export$5b87a78c45d5dd17);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $5mMCG = parcelRequire("5mMCG");

var $idDnR = parcelRequire("idDnR");

var $k6ufm = parcelRequire("k6ufm");

var $dLrrn = parcelRequire("dLrrn");
const $55966eaed0cd6835$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)((0, $idDnR.staticProjectSidebarNavigationResource));
    const projectContext = (0, $euxye.useMemo)(()=>data && (0, $dLrrn.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $55966eaed0cd6835$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)((0, $5mMCG.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $euxye.useMemo)(()=>data && (0, $dLrrn.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $55966eaed0cd6835$export$c7066c2d215990cf = ()=>{
    const projectContext = $55966eaed0cd6835$var$useProjectContext();
    const userBoardContext = $55966eaed0cd6835$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $55966eaed0cd6835$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $55966eaed0cd6835$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$55966eaed0cd6835$export$5b87a78c45d5dd17.displayName = "ContainerContextSubscriber";
$55966eaed0cd6835$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("dLrrn", function(module, exports) {
$parcel$export(module.exports, "getUserContext", () => $b2705ab280d68d72$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $b2705ab280d68d72$export$d17fffd59c7b3c60);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $4bRaD = parcelRequire("4bRaD");
const $b2705ab280d68d72$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $b2705ab280d68d72$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $b2705ab280d68d72$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $f99M0.CORE_PROJECT;
        case 'software':
            return 0, $f99M0.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $f99M0.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $f99M0.PRODUCT_DISCOVERY_PROJECT;
        case 'customer_service':
            return 0, $f99M0.CUSTOMER_SERVICE_PROJECT;
        default:
            return null;
    }
};
const $b2705ab280d68d72$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $4bRaD.extractData)(projectNavInfo);
    const scope = $b2705ab280d68d72$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $b2705ab280d68d72$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $4bRaD.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});


/* eslint-disable jira/filename-case */ const $77d3ca58d1d4a14f$export$6f454e69bce3a691 = 'business';
const $77d3ca58d1d4a14f$export$e6952b12ade67489 = 'default';

parcelRegister("eki8y", function(module, exports) {
$parcel$export(module.exports, "useJsmOnboardingType", () => $3a3e5b3f8c56a77c$export$5daaa68c3a578af9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $gFlri = parcelRequire("gFlri");
const $3a3e5b3f8c56a77c$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $3a3e5b3f8c56a77c$var$Store = (0, $5QDqc.createStore)({
    initialState: $3a3e5b3f8c56a77c$export$d4c72bab9d6cc13a,
    actions: $gFlri.actions,
    name: 'JSMOnboardingType'
});
const $3a3e5b3f8c56a77c$export$5daaa68c3a578af9 = (0, $3h1FP.createHook)($3a3e5b3f8c56a77c$var$Store);

});
parcelRegister("gFlri", function(module, exports) {
$parcel$export(module.exports, "actions", () => $918af6075d609ea1$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $wrNtr = parcelRequire("wrNtr");
const $918af6075d609ea1$export$e324594224ef24da = {
    fetchOnboardingType: $wrNtr.fetchOnboardingType
};

});
parcelRegister("wrNtr", function(module, exports) {
$parcel$export(module.exports, "fetchOnboardingType", () => $7608fb574ec31e5c$export$ea62467635172b55);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $4fhEY = parcelRequire("4fhEY");
const $7608fb574ec31e5c$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $7608fb574ec31e5c$export$ea62467635172b55 = // oxlint-disable-next-line @typescript-eslint/no-explicit-any
(projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $f99M0.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $4fhEY.default)($7608fb574ec31e5c$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("4hGfa", function(module, exports) {
$parcel$export(module.exports, "useJswOnboarding", () => $6a01d2fc90f5432a$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $6a01d2fc90f5432a$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $6a01d2fc90f5432a$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $6a01d2fc90f5432a$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $6a01d2fc90f5432a$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $6a01d2fc90f5432a$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $6a01d2fc90f5432a$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $6a01d2fc90f5432a$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $6a01d2fc90f5432a$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $6a01d2fc90f5432a$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $6a01d2fc90f5432a$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $6a01d2fc90f5432a$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $6a01d2fc90f5432a$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $6a01d2fc90f5432a$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $6a01d2fc90f5432a$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $6a01d2fc90f5432a$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $6a01d2fc90f5432a$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useHasNudgeActive", () => $6a01d2fc90f5432a$export$521909e3dc7ab811);
$parcel$export(module.exports, "useIsOpenedViaButton", () => $6a01d2fc90f5432a$export$2317d3c684b416ec);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("5ZtCQ")).QUICKSTART_UI_STATUS);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $lc0xf = parcelRequire("lc0xf");

var $8ZIK8 = parcelRequire("8ZIK8");

var $ia7JZ = parcelRequire("ia7JZ");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $6a01d2fc90f5432a$export$390f32400eaf98c9 = (0, $5QDqc.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $ia7JZ.initialState,
    actions: $lc0xf.actions
});
const $6a01d2fc90f5432a$export$1cbc60d8dd921852 = (0, $iGu4q.createSubscriber)($6a01d2fc90f5432a$export$390f32400eaf98c9);
const $6a01d2fc90f5432a$export$7d91c0af4772787a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9);
const $6a01d2fc90f5432a$export$638bfcfce1254bb8 = (0, $dB6ay.createContainer)($6a01d2fc90f5432a$export$390f32400eaf98c9, {});
const $6a01d2fc90f5432a$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $1n5q3.getQuickstartTypeSelector)(state)] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $6a01d2fc90f5432a$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $6a01d2fc90f5432a$export$594f006fa6a1b2e5 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$ea14030920a5d8e6
});
const $6a01d2fc90f5432a$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $6a01d2fc90f5432a$export$c5e63e44ad178ae8 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$a943afa434e9487a
});
const $6a01d2fc90f5432a$export$2c3cd14fff9d6e43 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: null
});
const $6a01d2fc90f5432a$export$b0db7e46e369e1d9 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$9d731f44f82af09f
});
const $6a01d2fc90f5432a$export$71de79653346a1ea = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $6a01d2fc90f5432a$export$61185a9266f1f57a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $8ZIK8.USER_ROLE).JIRA_ADMIN || userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $6a01d2fc90f5432a$export$ef4747ba36826d6a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $6a01d2fc90f5432a$export$522993b46d9f8266 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $1DyW0.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $6a01d2fc90f5432a$export$aa4ba29241532382 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $6a01d2fc90f5432a$export$ed5c755b733bf2b1 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $6a01d2fc90f5432a$export$35fe0366802512dd = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $1n5q3.getQuickstartTypeSelector)(state)];
        return visibility === (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $6a01d2fc90f5432a$export$a41ee0d3b6938099 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $6a01d2fc90f5432a$export$4ae7b465b076be9 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $6a01d2fc90f5432a$export$bf6e646c0476acad = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $6a01d2fc90f5432a$export$6b706bff94798d11 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $6a01d2fc90f5432a$export$c98db656edc5b3e1 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $6a01d2fc90f5432a$export$521909e3dc7ab811 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $6a01d2fc90f5432a$export$f4a2be940259bf95 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $6a01d2fc90f5432a$export$6db1f59c8ab54061 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.quickstartButtonRef
});
const $6a01d2fc90f5432a$export$2317d3c684b416ec = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isOpenedViaButton
});
const $6a01d2fc90f5432a$export$a57f80e92714bb45 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.containerType
});

});
parcelRegister("5ZtCQ", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $e9ca6c00748e0698$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $e9ca6c00748e0698$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $e9ca6c00748e0698$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $e9ca6c00748e0698$export$b580da85daad7757);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $e9ca6c00748e0698$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $e9ca6c00748e0698$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $e9ca6c00748e0698$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $e9ca6c00748e0698$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $e9ca6c00748e0698$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $e9ca6c00748e0698$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $e9ca6c00748e0698$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $e9ca6c00748e0698$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $e9ca6c00748e0698$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $e9ca6c00748e0698$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $e9ca6c00748e0698$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $e9ca6c00748e0698$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $e9ca6c00748e0698$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "PLAN_TEAM_CAPACITY_TASK", () => $e9ca6c00748e0698$export$d324bd587f924f18);
$parcel$export(module.exports, "PLAN_PROGRAM_BOARD_TASK", () => $e9ca6c00748e0698$export$a253dd77ea687e0a);
$parcel$export(module.exports, "PLAN_RELEASE_MANAGEMENT_TASK", () => $e9ca6c00748e0698$export$bffdfa5c4de9d4b);
$parcel$export(module.exports, "PLAN_DEPENDENCY_TRACKING_TASK", () => $e9ca6c00748e0698$export$31928f71f777342f);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $e9ca6c00748e0698$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $e9ca6c00748e0698$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $e9ca6c00748e0698$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $e9ca6c00748e0698$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $e9ca6c00748e0698$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $e9ca6c00748e0698$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $e9ca6c00748e0698$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $e9ca6c00748e0698$export$3380e677209260fe);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $e9ca6c00748e0698$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $e9ca6c00748e0698$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $e9ca6c00748e0698$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $e9ca6c00748e0698$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $e9ca6c00748e0698$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $e9ca6c00748e0698$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $e9ca6c00748e0698$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $e9ca6c00748e0698$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $e9ca6c00748e0698$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $e9ca6c00748e0698$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $e9ca6c00748e0698$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $e9ca6c00748e0698$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $e9ca6c00748e0698$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $e9ca6c00748e0698$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $e9ca6c00748e0698$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $e9ca6c00748e0698$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $e9ca6c00748e0698$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $e9ca6c00748e0698$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $e9ca6c00748e0698$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $e9ca6c00748e0698$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $e9ca6c00748e0698$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $e9ca6c00748e0698$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $e9ca6c00748e0698$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $e9ca6c00748e0698$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $e9ca6c00748e0698$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $e9ca6c00748e0698$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $e9ca6c00748e0698$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $e9ca6c00748e0698$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $e9ca6c00748e0698$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $e9ca6c00748e0698$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $e9ca6c00748e0698$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $e9ca6c00748e0698$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $e9ca6c00748e0698$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $e9ca6c00748e0698$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $e9ca6c00748e0698$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $e9ca6c00748e0698$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $e9ca6c00748e0698$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $e9ca6c00748e0698$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $e9ca6c00748e0698$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $e9ca6c00748e0698$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $e9ca6c00748e0698$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $e9ca6c00748e0698$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $e9ca6c00748e0698$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $e9ca6c00748e0698$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $e9ca6c00748e0698$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $e9ca6c00748e0698$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $e9ca6c00748e0698$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $e9ca6c00748e0698$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $e9ca6c00748e0698$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $e9ca6c00748e0698$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $e9ca6c00748e0698$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $e9ca6c00748e0698$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $e9ca6c00748e0698$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $e9ca6c00748e0698$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $e9ca6c00748e0698$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $e9ca6c00748e0698$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $e9ca6c00748e0698$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $e9ca6c00748e0698$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $e9ca6c00748e0698$export$c8ab6996f562d0db);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $e9ca6c00748e0698$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $e9ca6c00748e0698$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $e9ca6c00748e0698$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $e9ca6c00748e0698$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $e9ca6c00748e0698$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $e9ca6c00748e0698$export$5980f41aa657f9c7);
/* eslint-disable jira/filename-case */ const $e9ca6c00748e0698$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completePlanTaskName = (taskId)=>`plan-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $e9ca6c00748e0698$export$2b3151a089bc8780 = 'jlove-makkuro';
const $e9ca6c00748e0698$export$6826d33e9a2c0119 = 320;
const $e9ca6c00748e0698$export$b580da85daad7757 = 'root';
const $e9ca6c00748e0698$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $e9ca6c00748e0698$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $e9ca6c00748e0698$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $e9ca6c00748e0698$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $e9ca6c00748e0698$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $e9ca6c00748e0698$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $e9ca6c00748e0698$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $e9ca6c00748e0698$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $e9ca6c00748e0698$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $e9ca6c00748e0698$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $e9ca6c00748e0698$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $e9ca6c00748e0698$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $e9ca6c00748e0698$export$63b0e55f9c6454ac = $e9ca6c00748e0698$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $e9ca6c00748e0698$export$d324bd587f924f18 = $e9ca6c00748e0698$var$completePlanTaskName('team-capacity-task');
const $e9ca6c00748e0698$export$a253dd77ea687e0a = $e9ca6c00748e0698$var$completePlanTaskName('program-board-task');
const $e9ca6c00748e0698$export$bffdfa5c4de9d4b = $e9ca6c00748e0698$var$completePlanTaskName('release-management-task');
const $e9ca6c00748e0698$export$31928f71f777342f = $e9ca6c00748e0698$var$completePlanTaskName('dependency-tracking-task');
const $e9ca6c00748e0698$export$77071b77e2801b18 = $e9ca6c00748e0698$var$completeJwmTaskName('jwm-create-project-task');
const $e9ca6c00748e0698$export$d37415ffddcf2142 = $e9ca6c00748e0698$var$completeJwmTaskName('build-form-task');
const $e9ca6c00748e0698$export$2aa6e7b6e24a04f5 = $e9ca6c00748e0698$var$completeJwmTaskName('calendar-task');
const $e9ca6c00748e0698$export$f3b53199b07af2a1 = $e9ca6c00748e0698$var$completeJwmTaskName('timeline-task');
const $e9ca6c00748e0698$export$b52a7c936684cfc5 = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-import');
const $e9ca6c00748e0698$export$b5555f24061f9fb = $e9ca6c00748e0698$var$completeJwmTaskName('summary-and-reports-task');
const $e9ca6c00748e0698$export$ff25449f34b8abf = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $e9ca6c00748e0698$export$3380e677209260fe = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-key-differences');
const $e9ca6c00748e0698$export$da23b72d32bfad9e = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $e9ca6c00748e0698$export$4b064659282e0238 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $e9ca6c00748e0698$export$3ab51851f6d823e = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $e9ca6c00748e0698$export$e4a1a37a9a1350ad = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $e9ca6c00748e0698$export$b7f7da5e795f0327 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $e9ca6c00748e0698$export$80a401c1aa47a377 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $e9ca6c00748e0698$export$934ac7a251b26dc7 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $e9ca6c00748e0698$export$4634f6395df3ebbe = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $e9ca6c00748e0698$export$768fb41107a1e8d7 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $e9ca6c00748e0698$export$d797a81bace17184 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $e9ca6c00748e0698$export$746102c94db9df1f = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $e9ca6c00748e0698$export$5f1efd797d65e349 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $e9ca6c00748e0698$export$cccc812ccafbf11f = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $e9ca6c00748e0698$export$64822db87abd8a47 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $e9ca6c00748e0698$export$64f764d8be495c82 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $e9ca6c00748e0698$export$24eae23dc1c68bbd = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $e9ca6c00748e0698$export$50fa92eba6f82feb = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $e9ca6c00748e0698$export$4155d22fe3f14cd6 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $e9ca6c00748e0698$export$76813cbead887191 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $e9ca6c00748e0698$export$90aab2ff89daf770 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $e9ca6c00748e0698$export$a2bc0cbad2e6e605 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $e9ca6c00748e0698$export$f90872a1280728bb = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $e9ca6c00748e0698$export$bce644e96518cbd2 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $e9ca6c00748e0698$export$241aaebffac0a3e5 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $e9ca6c00748e0698$export$f9dfc43b5b31c4b7 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $e9ca6c00748e0698$export$79759e9e62fb9312 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $e9ca6c00748e0698$export$992d1e0dce255d19 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $e9ca6c00748e0698$export$d28c1b0e5b3e768 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $e9ca6c00748e0698$export$ca714ee197bed4ec = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $e9ca6c00748e0698$export$faae55ceea4b6073 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $e9ca6c00748e0698$export$200bc24cd120667e = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $e9ca6c00748e0698$export$a0d784a48b4e886c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $e9ca6c00748e0698$export$baf5bd09b4b33b8a = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $e9ca6c00748e0698$export$4702007eedbca8ab = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $e9ca6c00748e0698$export$aa9d2d635ea63898 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $e9ca6c00748e0698$export$2ea449225c1f6cac = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $e9ca6c00748e0698$export$deb8b557e735e26a = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $e9ca6c00748e0698$export$d45754df44e4c309 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $e9ca6c00748e0698$export$78b2913b550edbb = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $e9ca6c00748e0698$export$71243272608c58ab = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $e9ca6c00748e0698$export$39a08f215c33bc39 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $e9ca6c00748e0698$export$d2377f6a6fa3b49c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $e9ca6c00748e0698$export$befa8f6533309779 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $e9ca6c00748e0698$export$736b40db8701ba6c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $e9ca6c00748e0698$export$11eff6ae2f70b67b = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $e9ca6c00748e0698$export$fb2d23e5315a67a9 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $e9ca6c00748e0698$export$32e794bb49d60b6 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $e9ca6c00748e0698$export$fed256238b27db06 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $e9ca6c00748e0698$export$132eecb4d35a590d = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $e9ca6c00748e0698$export$2579c51cadd45eca = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $e9ca6c00748e0698$export$4b1a0cefa966ea0 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $e9ca6c00748e0698$export$f6558daacc312a65 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $e9ca6c00748e0698$export$925efa2e24e86b88 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $e9ca6c00748e0698$export$40454d3e062dcd44 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $e9ca6c00748e0698$export$99b0e09ff6f00490 = $e9ca6c00748e0698$var$completeJsmTaskName('customize-your-request-types-task');
const $e9ca6c00748e0698$export$2a82344eb273eeff = $e9ca6c00748e0698$var$completeJsmTaskName('review-your-channels-task');
const $e9ca6c00748e0698$export$1de5766b7e640d6b = $e9ca6c00748e0698$var$completeJsmTaskName('invite-your-team-task');
const $e9ca6c00748e0698$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $e9ca6c00748e0698$export$c8ab6996f562d0db = 'accountId';
const $e9ca6c00748e0698$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $e9ca6c00748e0698$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $e9ca6c00748e0698$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $e9ca6c00748e0698$export$38fbac7a5bf4aa33 = [
    $e9ca6c00748e0698$export$2a82344eb273eeff,
    $e9ca6c00748e0698$export$99b0e09ff6f00490,
    $e9ca6c00748e0698$export$1de5766b7e640d6b
];
const $e9ca6c00748e0698$export$7578902c7f420a3 = [
    $e9ca6c00748e0698$export$63b0e55f9c6454ac,
    $e9ca6c00748e0698$export$77071b77e2801b18,
    $e9ca6c00748e0698$export$d37415ffddcf2142,
    $e9ca6c00748e0698$export$b52a7c936684cfc5,
    $e9ca6c00748e0698$export$b5555f24061f9fb,
    $e9ca6c00748e0698$export$ff25449f34b8abf,
    $e9ca6c00748e0698$export$3380e677209260fe,
    $e9ca6c00748e0698$export$da23b72d32bfad9e,
    $e9ca6c00748e0698$export$4b064659282e0238,
    $e9ca6c00748e0698$export$3ab51851f6d823e,
    $e9ca6c00748e0698$export$e4a1a37a9a1350ad,
    $e9ca6c00748e0698$export$b7f7da5e795f0327,
    $e9ca6c00748e0698$export$80a401c1aa47a377,
    $e9ca6c00748e0698$export$934ac7a251b26dc7,
    $e9ca6c00748e0698$export$4634f6395df3ebbe,
    $e9ca6c00748e0698$export$768fb41107a1e8d7,
    $e9ca6c00748e0698$export$d797a81bace17184,
    $e9ca6c00748e0698$export$746102c94db9df1f,
    $e9ca6c00748e0698$export$5f1efd797d65e349,
    $e9ca6c00748e0698$export$cccc812ccafbf11f,
    $e9ca6c00748e0698$export$64822db87abd8a47,
    $e9ca6c00748e0698$export$64f764d8be495c82,
    $e9ca6c00748e0698$export$24eae23dc1c68bbd,
    $e9ca6c00748e0698$export$50fa92eba6f82feb,
    $e9ca6c00748e0698$export$4155d22fe3f14cd6,
    $e9ca6c00748e0698$export$76813cbead887191,
    $e9ca6c00748e0698$export$90aab2ff89daf770,
    $e9ca6c00748e0698$export$a2bc0cbad2e6e605,
    $e9ca6c00748e0698$export$f90872a1280728bb,
    $e9ca6c00748e0698$export$bce644e96518cbd2,
    $e9ca6c00748e0698$export$241aaebffac0a3e5,
    $e9ca6c00748e0698$export$f9dfc43b5b31c4b7,
    $e9ca6c00748e0698$export$79759e9e62fb9312,
    $e9ca6c00748e0698$export$992d1e0dce255d19,
    $e9ca6c00748e0698$export$d28c1b0e5b3e768,
    $e9ca6c00748e0698$export$ca714ee197bed4ec,
    $e9ca6c00748e0698$export$faae55ceea4b6073,
    $e9ca6c00748e0698$export$200bc24cd120667e,
    $e9ca6c00748e0698$export$a0d784a48b4e886c,
    $e9ca6c00748e0698$export$baf5bd09b4b33b8a,
    $e9ca6c00748e0698$export$4702007eedbca8ab,
    $e9ca6c00748e0698$export$aa9d2d635ea63898,
    $e9ca6c00748e0698$export$2ea449225c1f6cac,
    $e9ca6c00748e0698$export$deb8b557e735e26a,
    $e9ca6c00748e0698$export$d45754df44e4c309,
    $e9ca6c00748e0698$export$78b2913b550edbb,
    $e9ca6c00748e0698$export$71243272608c58ab,
    $e9ca6c00748e0698$export$39a08f215c33bc39,
    $e9ca6c00748e0698$export$d2377f6a6fa3b49c,
    $e9ca6c00748e0698$export$befa8f6533309779,
    $e9ca6c00748e0698$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $e9ca6c00748e0698$export$11eff6ae2f70b67b,
    $e9ca6c00748e0698$export$fb2d23e5315a67a9,
    $e9ca6c00748e0698$export$32e794bb49d60b6,
    $e9ca6c00748e0698$export$fed256238b27db06,
    $e9ca6c00748e0698$export$132eecb4d35a590d,
    $e9ca6c00748e0698$export$2579c51cadd45eca,
    $e9ca6c00748e0698$export$4b1a0cefa966ea0,
    $e9ca6c00748e0698$export$f6558daacc312a65,
    $e9ca6c00748e0698$export$925efa2e24e86b88,
    $e9ca6c00748e0698$export$40454d3e062dcd44
];
const $e9ca6c00748e0698$export$5980f41aa657f9c7 = [
    'SAM1'
];

});

parcelRegister("lc0xf", function(module, exports) {
$parcel$export(module.exports, "actions", () => $95098241613986c7$export$e324594224ef24da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lshfi = parcelRequire("lshfi");

var $eahz5 = parcelRequire("eahz5");

var $4sdAq = parcelRequire("4sdAq");

var $k2hbg = parcelRequire("k2hbg");

var $2viaa = parcelRequire("2viaa");

var $agR3I = parcelRequire("agR3I");

var $3riN6 = parcelRequire("3riN6");

var $2yI5h = parcelRequire("2yI5h");

var $7925l = parcelRequire("7925l");

var $2eU4H = parcelRequire("2eU4H");

var $6zJVJ = parcelRequire("6zJVJ");

var $8qaqK = parcelRequire("8qaqK");

var $4BoSU = parcelRequire("4BoSU");

var $gJ2q6 = parcelRequire("gJ2q6");

var $agOGQ = parcelRequire("agOGQ");

var $ljq2N = parcelRequire("ljq2N");

var $2wjIB = parcelRequire("2wjIB");

var $1XEDt = parcelRequire("1XEDt");

var $lhMTU = parcelRequire("lhMTU");

var $ktOmH = parcelRequire("ktOmH");

var $3slnW = parcelRequire("3slnW");

var $hOXkl = parcelRequire("hOXkl");

var $jJY2t = parcelRequire("jJY2t");

var $bNXf6 = parcelRequire("bNXf6");

var $2D5ku = parcelRequire("2D5ku");

var $adLxs = parcelRequire("adLxs");
const $95098241613986c7$export$e324594224ef24da = {
    changeTaskGroupParent: $lshfi.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $lshfi.nextGoBackToPreviousTaskGroup,
    setIsOpen: $eahz5.setIsOpen,
    refreshAppState: $4sdAq.refreshAppState,
    setNudgeStep: $k2hbg.setNudgeStep,
    addMountedNudge: $2viaa.addMountedNudge,
    removeMountedNudge: $2viaa.removeMountedNudge,
    setShouldRenderComponent: $agR3I.setShouldRenderComponent,
    setProjectState: $3riN6.setProjectState,
    setHasNudgeActive: $2yI5h.setHasNudgeActive,
    forceHideNudge: $7925l.forceHideNudge,
    setHasEverSeenRoute: $2eU4H.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $6zJVJ.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $6zJVJ.setRoadmapIsListEmpty,
    openNextTask: $8qaqK.openNextTask,
    resetIsQuickstartLoaded: $4BoSU.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $gJ2q6.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $agOGQ.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $ljq2N.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $2wjIB.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $1XEDt.nextSetChecklistIsOpen,
    nextOpenTask: $lhMTU.nextOpenTask,
    nextAutoExpand: $ktOmH.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $3slnW.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $hOXkl.nextGetTasks,
    syncVisibilityWithLocal: $jJY2t.syncVisibilityWithLocal,
    universalDispatch: $bNXf6.universalDispatch,
    setContainerType: $2D5ku.setContainerType,
    setQuickstartButtonRef: $adLxs.setQuickstartButtonRef,
    setIsOpenedViaButton: $adLxs.setIsOpenedViaButton,
    focusQuickstartButton: $adLxs.focusQuickstartButton
};

});
parcelRegister("lshfi", function(module, exports) {
$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $daa1afacdb588798$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $daa1afacdb588798$export$57534cbc400a434c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $daa1afacdb588798$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $daa1afacdb588798$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($daa1afacdb588798$var$setTaskGroup(taskGroup));
    };
const $daa1afacdb588798$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $5ZtCQ.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
        const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
        const taskGroup = {
            previousTaskGroupParents: newPreviousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        dispatch($daa1afacdb588798$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
    };

});
parcelRegister("kRAaT", function(module, exports) {
$parcel$export(module.exports, "pushToBackend", () => $fe5c7f55be2b2016$export$583b2d2422a6757f);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

var $2HuOR = parcelRequire("2HuOR");

var $75sVW = parcelRequire("75sVW");
const $fe5c7f55be2b2016$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $fe5c7f55be2b2016$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $kM0go.setUserProperties)($fe5c7f55be2b2016$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $75sVW.default)(response.status, response.statusText);
    });
const $fe5c7f55be2b2016$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $fe5c7f55be2b2016$var$setRemoteUserProperties(props);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $fe5c7f55be2b2016$export$583b2d2422a6757f = async (props)=>{
    const success = await $fe5c7f55be2b2016$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $fe5c7f55be2b2016$var$trySetUserProperties(props, 2);
};

});


parcelRegister("eahz5", function(module, exports) {
$parcel$export(module.exports, "setIsOpen", () => $08569e867f217dd5$export$dcf23146e0a40195);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");
const $08569e867f217dd5$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN),
            value: isOpen
        });
    };
var $08569e867f217dd5$export$2e2bcd8739ae039 = $08569e867f217dd5$export$dcf23146e0a40195;

});
parcelRegister("1n5q3", function(module, exports) {
$parcel$export(module.exports, "getQuickstartTypeSelector", () => $9ce6b193d3030c6f$export$eae834ce0286017a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $9ce6b193d3030c6f$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);
const $9ce6b193d3030c6f$export$eae834ce0286017a = (state)=>{
    if ($9ce6b193d3030c6f$export$6f17f2cb816105eb(state)) return (0, $5ZtCQ.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $5ZtCQ.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("4sdAq", function(module, exports) {
$parcel$export(module.exports, "refreshAppState", () => $09503d60e1c07774$export$797c35e2e1d0d014);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");


var $5ZtCQ = parcelRequire("5ZtCQ");

var $cXK8c = parcelRequire("cXK8c");

var $3gWPd = parcelRequire("3gWPd");

var $j4vHl = parcelRequire("j4vHl");

var $7rCTA = parcelRequire("7rCTA");

var $1DyW0 = parcelRequire("1DyW0");

var $2wjIB = parcelRequire("2wjIB");
const $09503d60e1c07774$var$allTasks = [
    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
    ...(0, $5ZtCQ.JSM_BUSINESS_TASKS)
];
const $09503d60e1c07774$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // oxlint-disable-next-line typescript/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).map((type)=>(0, $5ZtCQ.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $5ZtCQ.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $cXK8c.pollBackend)({
            keys: [
                (0, $5ZtCQ.KEY_OPEN),
                (0, $5ZtCQ.KEY_DISMISSED),
                (0, $5ZtCQ.KEY_OPEN_TASK),
                (0, $5ZtCQ.KEY_TASK_GROUP),
                (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $5ZtCQ.KEY_JSW_ONBOARDING),
                (0, $5ZtCQ.KEY_PREMIUM_TRIAL_REOPENED),
                ...$09503d60e1c07774$var$allTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $5ZtCQ.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $5ZtCQ.getBackendVisibilityKey)(type)];
                else if ((0, $5ZtCQ.KEY_DISMISSED) in backendState && backendState[0, $5ZtCQ.KEY_DISMISSED]) updatedState.visibility[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $5ZtCQ.KEY_OPEN] ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $1DyW0.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $5ZtCQ.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $5ZtCQ.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $5ZtCQ.KEY_OPEN];
            if ((0, $5ZtCQ.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $5ZtCQ.KEY_OPEN_TASK];
            if ((0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $5ZtCQ.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $5ZtCQ.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] !== null && (0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe) in backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING][0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $5ZtCQ.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $7rCTA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $2wjIB.nextSetChecklistIsDismissed)(true));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3gWPd.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $j4vHl.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $d8LhJ.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
/* eslint-disable jira/filename-case */ // Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $99cb2e6a234d7a1f$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $99cb2e6a234d7a1f$export$e3884212029f7bef = 'should-show-welcome-modal';
const $99cb2e6a234d7a1f$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $99cb2e6a234d7a1f$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $99cb2e6a234d7a1f$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $99cb2e6a234d7a1f$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $99cb2e6a234d7a1f$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $99cb2e6a234d7a1f$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $99cb2e6a234d7a1f$export$6e69f8dc03075ef8 = 'team-type';
const $99cb2e6a234d7a1f$export$c06666264cd35603 = 'team-type-shorthand';
const $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $99cb2e6a234d7a1f$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $99cb2e6a234d7a1f$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $99cb2e6a234d7a1f$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $99cb2e6a234d7a1f$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $99cb2e6a234d7a1f$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $99cb2e6a234d7a1f$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $99cb2e6a234d7a1f$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $99cb2e6a234d7a1f$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $99cb2e6a234d7a1f$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $99cb2e6a234d7a1f$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $99cb2e6a234d7a1f$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $99cb2e6a234d7a1f$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99cb2e6a234d7a1f$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $99cb2e6a234d7a1f$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $99cb2e6a234d7a1f$export$468488291ccd988 = 'timelineAddItemNudge';
const $99cb2e6a234d7a1f$export$7a33548109ac931d = 'createFormNudge';
const $99cb2e6a234d7a1f$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $99cb2e6a234d7a1f$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $99cb2e6a234d7a1f$export$594d3436316492be = 'summaryViewNudge';
const $99cb2e6a234d7a1f$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $99cb2e6a234d7a1f$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99cb2e6a234d7a1f$export$699265ec8ad9a740 = 'Software Development';
const $99cb2e6a234d7a1f$export$e07d1fa2da8ed874 = 'Customer Service';
const $99cb2e6a234d7a1f$export$76dcec3f438d9e56 = 'IT Support';
const $99cb2e6a234d7a1f$export$9a574c301f67ba30 = 'Human Resources';
const $99cb2e6a234d7a1f$export$363ec144a94029c8 = 'Finance';
const $99cb2e6a234d7a1f$export$df0fb32d68ae1e78 = 'Legal';
const $99cb2e6a234d7a1f$export$d9c0e3e59442fb4 = 'Marketing';
const $99cb2e6a234d7a1f$export$27dbc7d7ce66e6e3 = 'Operations';
const $99cb2e6a234d7a1f$export$a5dce388adf922bd = 'Sales';
const $99cb2e6a234d7a1f$export$e1473b31a257caff = 'Data Science';
const $99cb2e6a234d7a1f$export$85657457db93c2c2 = 'Product Management';
const $99cb2e6a234d7a1f$export$c0c2d1dfaeba89dd = 'Project Management';
const $99cb2e6a234d7a1f$export$2e6a7ad3ab9c82a3 = 'Design';
const $99cb2e6a234d7a1f$export$7b60378c3b4372e9 = 'Other or Personal';
const $99cb2e6a234d7a1f$export$572242e58bd07594 = 'CS';
const $99cb2e6a234d7a1f$export$d7de553940261eba = 'ITS';
const $99cb2e6a234d7a1f$export$4c29d0d04c15e55d = 'HR';
const $99cb2e6a234d7a1f$export$3950f7f841bf94b6 = 'FNC';
const $99cb2e6a234d7a1f$export$881249b988b6030f = 'LGL';
const $99cb2e6a234d7a1f$export$e4824f74b9879164 = 'MKT';
const $99cb2e6a234d7a1f$export$4f3cb0844009af52 = 'OPS';
const $99cb2e6a234d7a1f$export$1a65d50c4a641bb4 = 'SAL';
const $99cb2e6a234d7a1f$export$9ee64e8fbd8b03a2 = 'DS';
const $99cb2e6a234d7a1f$export$b8b1ac856ba1434b = 'DEV';
const $99cb2e6a234d7a1f$export$4f54a09a24fd1d74 = 'PDM';
const $99cb2e6a234d7a1f$export$79685802e8ff1098 = 'PJM';
const $99cb2e6a234d7a1f$export$e5c438b7501b5a24 = 'DES';
const $99cb2e6a234d7a1f$export$cbc0e551d91a692d = 'OTR';

parcelRegister("cXK8c", function(module, exports) {
$parcel$export(module.exports, "pollBackend", () => $ce9f9ff38f6815c9$export$8420ef0cee98de);
/* eslint-disable jira/filename-case */ 
var $kklcL = parcelRequire("kklcL");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $ce9f9ff38f6815c9$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $kklcL.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $5ZtCQ.PACKAGE_NAME),
            teamName: (0, $5ZtCQ.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("kklcL", function(module, exports) {
$parcel$export(module.exports, "get", () => $564bc4e4a83234d6$export$3988ae62b71be9a3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cZa0l = parcelRequire("cZa0l");

var $dTOvG = parcelRequire("dTOvG");

var $hFtK7 = parcelRequire("hFtK7");

var $lCetP = parcelRequire("lCetP");

var $h2wCv = parcelRequire("h2wCv");

var $6Kdw4 = parcelRequire("6Kdw4");

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");
let $564bc4e4a83234d6$var$ufoExperiencesMap = {};
const $564bc4e4a83234d6$var$getUfoExperience = (key)=>{
    if (!$564bc4e4a83234d6$var$ufoExperiencesMap[key]) $564bc4e4a83234d6$var$ufoExperiencesMap[key] = new (0, $jkqqC.UFOExperience)(key, {
        type: (0, $ipvkO.ExperienceTypes).Operation,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
    });
    return $564bc4e4a83234d6$var$ufoExperiencesMap[key];
};
const $564bc4e4a83234d6$export$c907f169d33b2e25 = ()=>{
    $564bc4e4a83234d6$var$ufoExperiencesMap = {};
};
const $564bc4e4a83234d6$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $564bc4e4a83234d6$var$patchProperties = (response, propertiesPath)=>response && (0, (/*@__PURE__*/$parcel$interopDefault($cZa0l)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $564bc4e4a83234d6$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $564bc4e4a83234d6$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($dTOvG)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($dTOvG)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $564bc4e4a83234d6$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $h2wCv.performGetRequest)(url);
        if (response === null) (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $564bc4e4a83234d6$var$patchProperties(response, 'user');
        $564bc4e4a83234d6$var$patchProperties(response, 'instance');
        $564bc4e4a83234d6$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response || {
            user: {},
            instance: {},
            project: {}
        };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $lCetP.isClientFetchError)(error) && (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});
parcelRegister("cZa0l", function(module, exports) {

var $27HF8 = parcelRequire("27HF8");

var $73ZOi = parcelRequire("73ZOi");

var $kqlzk = parcelRequire("kqlzk");

var $jOlpf = parcelRequire("jOlpf");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $9742f1375e9cf33c$var$forEach(collection, iteratee) {
    var func = $jOlpf(collection) ? $27HF8 : $73ZOi;
    return func(collection, $kqlzk(iteratee));
}
module.exports = $9742f1375e9cf33c$var$forEach;

});
parcelRegister("kqlzk", function(module, exports) {

var $eSVkV = parcelRequire("eSVkV");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $03d64e5056515773$var$castFunction(value) {
    return typeof value == 'function' ? value : $eSVkV;
}
module.exports = $03d64e5056515773$var$castFunction;

});


parcelRegister("dTOvG", function(module, exports) {

var $f6GKc = parcelRequire("f6GKc");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $a1e797a3f8950159$var$kebabCase = $f6GKc(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $a1e797a3f8950159$var$kebabCase;

});



parcelRegister("3gWPd", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $65a2bdf7de0b5c67$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $65a2bdf7de0b5c67$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $65a2bdf7de0b5c67$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $65a2bdf7de0b5c67$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $65a2bdf7de0b5c67$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $65a2bdf7de0b5c67$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $65a2bdf7de0b5c67$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $65a2bdf7de0b5c67$export$6ccbe54cd3a5a12);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $aJ81Y = parcelRequire("aJ81Y");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $e1PBH = parcelRequire("e1PBH");
const $65a2bdf7de0b5c67$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $5ZtCQ.ACTION_SUBJECT_ID), attributes);
};
const $65a2bdf7de0b5c67$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $65a2bdf7de0b5c67$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $65a2bdf7de0b5c67$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $65a2bdf7de0b5c67$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $e1PBH.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $65a2bdf7de0b5c67$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $hFtK7.fireErrorAnalytics)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $65a2bdf7de0b5c67$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $65a2bdf7de0b5c67$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("e1PBH", function(module, exports) {
$parcel$export(module.exports, "getProductType", () => $f6fc132b152c4d81$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $f6fc132b152c4d81$export$3b914201960fa7a6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $74oEx = parcelRequire("74oEx");

var $f99M0 = parcelRequire("f99M0");
const $f6fc132b152c4d81$export$d64a7dd8c7cd80e0 = {
    [(0, $f99M0.CORE_PROJECT)]: 'workManagement',
    [(0, $f99M0.SOFTWARE_PROJECT)]: 'software',
    [(0, $f99M0.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $f6fc132b152c4d81$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $f6fc132b152c4d81$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(projectType);
    return null;
};
const $f6fc132b152c4d81$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(taskId.split('.').pop());
};

});


parcelRegister("j4vHl", function(module, exports) {
$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $85be8d50a9cdd4b5$export$7f2186c37a3d095d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $aJ81Y = parcelRequire("aJ81Y");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $rNOHK = parcelRequire("rNOHK");
const $85be8d50a9cdd4b5$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $85be8d50a9cdd4b5$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $85be8d50a9cdd4b5$var$ONE_DAY = 86400000;
const $85be8d50a9cdd4b5$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$85be8d50a9cdd4b5$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $h2wCv.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $i860n.fg)('is_synthetic_tenant')
        });
        return result;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $5ZtCQ.PACKAGE_NAME),
                teamName: (0, $5ZtCQ.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $i860n.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $85be8d50a9cdd4b5$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $rNOHK.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $85be8d50a9cdd4b5$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $i860n.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $85be8d50a9cdd4b5$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $85be8d50a9cdd4b5$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("rNOHK", function(module, exports) {
$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ff998122ab90c822$export$99f3e48748c2a8c3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cBnIS = parcelRequire("cBnIS");

const $ff998122ab90c822$var$crossProjectBoardTraitSessionProvider = (0, $cBnIS.createSessionExpirableStorageProvider)((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a));
const $ff998122ab90c822$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        // @browser-storage setter
        $ff998122ab90c822$var$crossProjectBoardTraitSessionProvider.set((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a), toPersist);
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const get = ()=>$ff998122ab90c822$var$crossProjectBoardTraitSessionProvider.get((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
parcelRegister("cBnIS", function(module, exports) {
$parcel$export(module.exports, "createSessionStorageProvider", () => $7db48d4913ef2f1f$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $7db48d4913ef2f1f$export$e0a2e9a062c6a695);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aUPBc = parcelRequire("aUPBc");

var $71vEP = parcelRequire("71vEP");

var $aAuyI = parcelRequire("aAuyI");

var $j0I8T = parcelRequire("j0I8T");

var $563ld = parcelRequire("563ld");
const $7db48d4913ef2f1f$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((appPrefix)=>(0, $aAuyI.createStorageProvider)((0, $j0I8T.WebStorageType).SessionStorage, appPrefix, (0, $563ld.makeSessionStore)()));
const $7db48d4913ef2f1f$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $71vEP.createExpirableStorageProvider)((0, $j0I8T.WebStorageType).SessionStorage, appPrefix, (0, $563ld.makeSessionExpirableStore)());
});

});
parcelRegister("71vEP", function(module, exports) {
$parcel$export(module.exports, "createExpirableStorageProvider", () => $97afd86ad436cf65$export$b793a81cf479272a);

var $6CfY5 = parcelRequire("6CfY5");

var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");

var $36m40 = parcelRequire("36m40");

var $j0I8T = parcelRequire("j0I8T");

var $2xgrt = parcelRequire("2xgrt");
const $97afd86ad436cf65$var$LOG_LOCATION = 'platform.browser-storage-providers.create-expirable-storage-provider';
// Keyless operations carry no UGC, so they use the privacy-safe logger.
const $97afd86ad436cf65$var$logError = (operation, error)=>{
    if ((0, $i860n.fg)('jfp-vulcan-browser-storage-error-logs')) (0, $6CfY5.default).safeErrorWithoutCustomerData($97afd86ad436cf65$var$LOG_LOCATION, `Failed to ${operation}`, error instanceof Error ? error : undefined);
    else // eslint-disable-next-line no-console
    console.error(`Failed to ${operation}`, error);
};
// Storage keys may contain UGC (issue/project keys), so keyed operations use the
// customer-data logger, which routes to the restricted frontend-exception pipeline.
const $97afd86ad436cf65$var$logKeyedError = (operation, key, error)=>{
    if ((0, $i860n.fg)('jfp-vulcan-browser-storage-error-logs')) (0, $6CfY5.default).unsafeErrorWithCustomerData($97afd86ad436cf65$var$LOG_LOCATION, `Failed to ${operation} (key: ${key})`, error instanceof Error ? error : undefined);
    else // eslint-disable-next-line no-console
    console.error(`Failed to ${operation} (key: ${key})`, error);
};
const $97afd86ad436cf65$export$b793a81cf479272a = (storageType, appPrefix, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const namespacedStore = store.namespace(appPrefix);
    // Uses the same key format as store.js: '__storejs_' + namespace + '_' + key
    const getKeyWithPrefix = (key)=>`${0, $36m40.STOREJS_KEY_PREFIX}${appPrefix}_${key}`;
    // Uses the same expiration key format as store.js expirePlugin:
    // Sub-store namespace = __storejs_{appPrefix}_expire_mixin
    // Sub-store prefix = __storejs_ + sub-store namespace + _ = __storejs___storejs_{appPrefix}_expire_mixin_
    const getExpireKeyWithPrefix = (key)=>`${0, $36m40.STOREJS_KEY_PREFIX}${0, $36m40.STOREJS_KEY_PREFIX}${appPrefix}_expire_mixin_${key}`;
    const storageAPI = storageType === (0, $j0I8T.WebStorageType).LocalStorage ? (0, $4fPPi.AtlBrowserStorageLocal) : (0, $4fPPi.AtlBrowserStorageSession);
    const browserStorage = storageType === (0, $j0I8T.WebStorageType).LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    const remove = (key)=>{
        try {
            if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                storageAPI.removeItem(getKeyWithPrefix(key));
                storageAPI.removeItem(getExpireKeyWithPrefix(key));
            }
            // Remove from old store as well, or the only store if FG is off
            namespacedStore.remove(key);
        } catch (error) {
            $97afd86ad436cf65$var$logKeyedError('remove item', key, error);
        }
    };
    return {
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                // Matches store.js behavior: set(key, undefined) calls remove(key)
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    const prefixedKey = getKeyWithPrefix(key);
                    const expireKey = getExpireKeyWithPrefix(key);
                    storageAPI.setItem(prefixedKey, JSON.stringify(value)).then((setItemResult)=>{
                        if (setItemResult.status !== 'SUCCESS') {
                            storageAPI.removeItem(expireKey);
                            return;
                        }
                        // Matches store.js: set(key, val) without expiration clears any existing expiration
                        if (expiration !== undefined) storageAPI.setStrictlyNecessaryItem(expireKey, JSON.stringify(expiration));
                        else storageAPI.removeItem(expireKey);
                    }, (error)=>{
                        $97afd86ad436cf65$var$logKeyedError('set item', key, error);
                    });
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                $97afd86ad436cf65$var$logKeyedError('set item', key, error);
            }
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        setAsync: async (key, value, expiration)=>{
            try {
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    const prefixedKey = getKeyWithPrefix(key);
                    const setItemResult = await storageAPI.setItem(prefixedKey, JSON.stringify(value));
                    if (setItemResult !== undefined) {
                        if (setItemResult.status === 'BLOCKED') {
                            storageAPI.removeItem(prefixedKey);
                            throw new Error('write was blocked by storage or consent preferences.');
                        }
                        if (setItemResult.status !== 'SUCCESS') throw new Error('write failed');
                    }
                    const expireKey = getExpireKeyWithPrefix(key);
                    if (expiration !== undefined) storageAPI.setStrictlyNecessaryItem(expireKey, JSON.stringify(expiration));
                    else storageAPI.removeItem(expireKey);
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                $97afd86ad436cf65$var$logKeyedError('set item', key, error);
                throw error;
            }
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                // Matches store.js behavior: set(key, undefined) calls remove(key)
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, JSON.stringify(value));
                    // Matches store.js: set(key, val) without expiration clears any existing expiration
                    const expireKey = getExpireKeyWithPrefix(key);
                    if (expiration !== undefined) storageAPI.setStrictlyNecessaryItem(expireKey, JSON.stringify(expiration));
                    else storageAPI.removeItem(expireKey);
                } else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value, expiration);
            } catch (error) {
                $97afd86ad436cf65$var$logKeyedError('set strictly necessary item', key, error);
            }
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return undefined;
                    // Matches store.js expirePlugin: check expiration before reading value
                    const expireKey = getExpireKeyWithPrefix(key);
                    const expirationStr = storageAPI.getItem(expireKey);
                    if (expirationStr) {
                        const expiration = JSON.parse(expirationStr);
                        if (expiration < Date.now()) {
                            // Expired: remove both value and expiration keys
                            storageAPI.removeItem(getKeyWithPrefix(key));
                            storageAPI.removeItem(expireKey);
                            return;
                        }
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    const itemStr = storageAPI.getItem(prefixedKey);
                    if (typeof itemStr === 'string') return JSON.parse(itemStr);
                } else return namespacedStore.get(key);
            } catch (error) {
                $97afd86ad436cf65$var$logKeyedError('get item', key, error);
            }
        },
        getExpiration: (key)=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return undefined;
                    // Matches store.js expirePlugin: expirations.get(key) — returns raw timestamp
                    const expireKey = getExpireKeyWithPrefix(key);
                    const expirationStr = storageAPI.getItem(expireKey);
                    if (typeof expirationStr === 'string') return JSON.parse(expirationStr);
                    return undefined;
                }
                return namespacedStore.getExpiration(key);
            } catch (error) {
                $97afd86ad436cf65$var$logKeyedError('get expiration for item', key, error);
                return undefined;
            }
        },
        remove: remove,
        removeExpiredKeys: ()=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    const expirePrefix = `${(0, $36m40.STOREJS_KEY_PREFIX)}${(0, $36m40.STOREJS_KEY_PREFIX)}`;
                    const expireSuffix = '_expire_mixin_';
                    for(let i = storageAPI.length() - 1; i >= 0; i--){
                        const storageKey = storageAPI.key(i);
                        const suffixIndex = storageKey ? storageKey.indexOf(expireSuffix) : -1;
                        if (storageKey && storageKey.startsWith(expirePrefix) && suffixIndex !== -1) {
                            const expirationStr = storageAPI.getItem(storageKey);
                            if (expirationStr) {
                                const expiration = JSON.parse(expirationStr);
                                if (expiration < Date.now()) {
                                    // Derive the value key: __storejs_ + namespace + _ + originalKey
                                    const namespace = storageKey.substring(expirePrefix.length, suffixIndex);
                                    const originalKey = storageKey.substring(suffixIndex + expireSuffix.length);
                                    const valueKey = `${(0, $36m40.STOREJS_KEY_PREFIX)}${namespace}_${originalKey}`;
                                    storageAPI.removeItem(valueKey);
                                    storageAPI.removeItem(storageKey);
                                }
                            }
                        }
                    }
                    namespacedStore.removeExpiredKeys(); // clean up old keys too
                } else namespacedStore.removeExpiredKeys();
            } catch (error) {
                $97afd86ad436cf65$var$logError('remove expired keys', error);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                $97afd86ad436cf65$var$logError('clear storage', err);
            }
        },
        length: ()=>{
            try {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) return 0;
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                $97afd86ad436cf65$var$logError('get storage length', err);
                return 0;
            }
        },
        key: (index)=>{
            try {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) return null;
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.key(index);
                return browserStorage?.key(index) ?? null;
            } catch (err) {
                $97afd86ad436cf65$var$logError('get key at index', err);
                return null;
            }
        }
    };
};

});
parcelRegister("36m40", function(module, exports) {
$parcel$export(module.exports, "STOREJS_KEY_PREFIX", () => $e8eb94185a42a3fe$export$d9143877213d8e0a);
$parcel$export(module.exports, "NAMESPACE", () => $e8eb94185a42a3fe$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $e8eb94185a42a3fe$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $e8eb94185a42a3fe$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $e8eb94185a42a3fe$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $e8eb94185a42a3fe$export$ea28dfd9333cda2d);
/* eslint-disable jira/filename-case */ /** Same prefix as store.js namespaced keys: `__storejs_` + namespace + `_` + key */ const $e8eb94185a42a3fe$export$d9143877213d8e0a = '__storejs_';
const $e8eb94185a42a3fe$export$6aad947bda0f3f46 = 'timestamps';
const $e8eb94185a42a3fe$export$8187f416f1cc43d8 = 604800000;
const $e8eb94185a42a3fe$export$6e952fa7d47190cf = 4 * $e8eb94185a42a3fe$export$8187f416f1cc43d8;
const $e8eb94185a42a3fe$export$da99ebca8f453abd = 22;
const $e8eb94185a42a3fe$export$ea28dfd9333cda2d = 1014;

});

parcelRegister("j0I8T", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $5029131229abdad6$export$259e3a861f28589b);
/* eslint-disable jira/filename-case */ const $5029131229abdad6$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};

});

parcelRegister("2xgrt", function(module, exports) {
$parcel$export(module.exports, "isStorageAPIAvailable", () => $1933fc72e1f9c1bd$export$cec05f68a314ce01);
/**
 * Checks if window and storage APIs are available (e.g. not in SSR).
 * Similar to @atlassian/browser-storage-controls isSSR + isStorageAvailable logic.
 * Returns false when window/document are undefined or storage throws (SSR, private browsing).
 */ const $1933fc72e1f9c1bd$export$cec05f68a314ce01 = ()=>{
    try {
        const isMissingBrowserUtils = typeof globalThis.document === 'undefined' || typeof globalThis.window === 'undefined' || typeof document === 'undefined' || typeof window === 'undefined' || typeof globalThis.localStorage === 'undefined' || typeof globalThis.sessionStorage === 'undefined' || typeof localStorage === 'undefined' || typeof sessionStorage === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
        if (isMissingBrowserUtils) return false;
        return true;
    } catch  {
        return false;
    }
};

});


parcelRegister("aAuyI", function(module, exports) {
$parcel$export(module.exports, "createStorageProvider", () => $91bd9b44433364f9$export$8441605555fbd60c);

var $6CfY5 = parcelRequire("6CfY5");

var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");

var $36m40 = parcelRequire("36m40");

var $j0I8T = parcelRequire("j0I8T");

var $2xgrt = parcelRequire("2xgrt");
const $91bd9b44433364f9$var$LOG_LOCATION = 'platform.browser-storage-providers.create-storage-provider';
// Keyless operations carry no UGC, so they use the privacy-safe logger.
const $91bd9b44433364f9$var$logError = (operation, error)=>{
    if ((0, $i860n.fg)('jfp-vulcan-browser-storage-error-logs')) (0, $6CfY5.default).safeErrorWithoutCustomerData($91bd9b44433364f9$var$LOG_LOCATION, `Failed to ${operation}`, error instanceof Error ? error : undefined);
    else // eslint-disable-next-line no-console
    console.error(`Failed to ${operation}`, error);
};
// Storage keys may contain UGC (issue/project keys), so keyed operations use the
// customer-data logger, which routes to the restricted frontend-exception pipeline.
const $91bd9b44433364f9$var$logKeyedError = (operation, key, error)=>{
    if ((0, $i860n.fg)('jfp-vulcan-browser-storage-error-logs')) (0, $6CfY5.default).unsafeErrorWithCustomerData($91bd9b44433364f9$var$LOG_LOCATION, `Failed to ${operation} (key: ${key})`, error instanceof Error ? error : undefined);
    else // eslint-disable-next-line no-console
    console.error(`Failed to ${operation} (key: ${key})`, error);
};
const $91bd9b44433364f9$export$8441605555fbd60c = (storageType, appPrefix, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    const normalizedAppPrefix = appPrefix ?? '';
    const namespacedStore = store.namespace(normalizedAppPrefix);
    // Uses the same key format as store.js: namespace ? '__storejs_' + namespace + '_' + key : key
    const getKeyWithPrefix = (key)=>normalizedAppPrefix.trim().length ? `${0, $36m40.STOREJS_KEY_PREFIX}${normalizedAppPrefix}_${key}` : key;
    const storageAPI = storageType === (0, $j0I8T.WebStorageType).LocalStorage ? (0, $4fPPi.AtlBrowserStorageLocal) : (0, $4fPPi.AtlBrowserStorageSession);
    const browserStorage = storageType === (0, $j0I8T.WebStorageType).LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    const remove = (key)=>{
        try {
            if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                const prefixedKey = getKeyWithPrefix(key);
                storageAPI.removeItem(prefixedKey); // remove data from new store
                namespacedStore.remove(key); // remove data from old store as well
            } else namespacedStore.remove(key);
        } catch (err) {
            $91bd9b44433364f9$var$logKeyedError('remove item', key, err);
        }
    };
    return {
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                // Matches store.js behavior: set(key, undefined) calls remove(key)
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.setItem(prefixedKey, JSON.stringify(value)).then((setItemResult)=>{
                        if (setItemResult?.status === 'BLOCKED') storageAPI.removeItem(prefixedKey);
                    });
                } else namespacedStore.set(key, value);
            } catch (err) {
                $91bd9b44433364f9$var$logKeyedError('set item', key, err);
            }
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        setAsync: async (key, value)=>{
            try {
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    const prefixedKey = getKeyWithPrefix(key);
                    const setItemResult = await storageAPI.setItem(prefixedKey, JSON.stringify(value));
                    if (setItemResult !== undefined) {
                        if (setItemResult.status === 'BLOCKED') {
                            storageAPI.removeItem(prefixedKey);
                            throw new Error('write was blocked by storage or consent preferences.');
                        }
                        if (setItemResult.status !== 'SUCCESS') throw new Error('write failed');
                    }
                } else namespacedStore.set(key, value);
            } catch (err) {
                $91bd9b44433364f9$var$logKeyedError('set item', key, err);
                throw err;
            }
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                // Matches store.js behavior: set(key, undefined) calls remove(key)
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, JSON.stringify(value));
                } else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value);
            } catch (err) {
                $91bd9b44433364f9$var$logKeyedError('set strictly necessary item', key, err);
            }
        },
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return undefined;
                    const prefixedKey = getKeyWithPrefix(key);
                    const item = storageAPI.getItem(prefixedKey);
                    if (typeof item === 'string') return JSON.parse(item);
                } else return namespacedStore.get(key);
            } catch (err) {
                $91bd9b44433364f9$var$logKeyedError('get item', key, err);
            }
        },
        remove: remove,
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) return;
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                $91bd9b44433364f9$var$logError('clear storage', err);
            }
        },
        length: ()=>{
            try {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) return 0;
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                $91bd9b44433364f9$var$logError('get storage length', err);
                return 0;
            }
        },
        key: (index)=>{
            try {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) return null;
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.key(index);
                return browserStorage?.key(index) ?? null;
            } catch (err) {
                $91bd9b44433364f9$var$logError('get key at index', err);
                return null;
            }
        }
    };
};

});

parcelRegister("563ld", function(module, exports) {
$parcel$export(module.exports, "makeSessionStore", () => $7e4ef50df9165a25$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $7e4ef50df9165a25$export$a8f626c8ded9a06c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /// <reference path="../../store.d.ts" />

var $jvDG2 = parcelRequire("jvDG2");

var $jd9DX = parcelRequire("jd9DX");

var $ef3Gs = parcelRequire("ef3Gs");

var $5oLFf = parcelRequire("5oLFf");

var $c7VES = parcelRequire("c7VES");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $5l7hq = parcelRequire("5l7hq");
const $7e4ef50df9165a25$var$getPluginsWithCondition = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfp-vulcan-browser-storage-disable-auto-cleanup'), ()=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2)))
    ], ()=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2))),
        (0, $5l7hq.default)
    ]);
const $7e4ef50df9165a25$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ef3Gs))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c7VES))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5oLFf)))
    ], $7e4ef50df9165a25$var$getPluginsWithCondition());
const $7e4ef50df9165a25$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ef3Gs))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c7VES))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5oLFf)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jd9DX)))
    ]);

});
parcelRegister("5l7hq", function(module, exports) {
$parcel$export(module.exports, "default", () => $f665d84c6e161163$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $36m40 = parcelRequire("36m40");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
function $f665d84c6e161163$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $36m40.NAMESPACE));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $36m40.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $36m40.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $36m40.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $36m40.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $36m40.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $36m40.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $36m40.ONE_WEEK) >= (0, $36m40.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $36m40.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $f665d84c6e161163$export$2e2bcd8739ae039 = $f665d84c6e161163$var$cleanUpPlugin;

});



/* eslint-disable jira/filename-case */ const $cf3747d320ece5f0$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("7rCTA", function(module, exports) {
$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $a2d25f665e97755b$export$980c26b6f100081d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $a2d25f665e97755b$export$980c26b6f100081d = ()=>(0, $h2wCv.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("1DyW0", function(module, exports) {
$parcel$export(module.exports, "getNextNonCompleteTask", () => $c23f851187752075$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $c23f851187752075$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $c23f851187752075$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $c23f851187752075$export$93d719890ad66653);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iXN50 = parcelRequire("iXN50");

var $b10Xz = parcelRequire("b10Xz");
const $c23f851187752075$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $b10Xz.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $c23f851187752075$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $b10Xz.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $c23f851187752075$var$store = (0, $iXN50.createLocalStorageProvider)('quickstart');
const $c23f851187752075$export$5aa524d86254b4f = (key, value)=>{
    // @browser-storage setter
    $c23f851187752075$var$store.set(key, value);
};
const $c23f851187752075$export$93d719890ad66653 = (key)=>$c23f851187752075$var$store.get(key);

});
parcelRegister("iXN50", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageProvider", () => $4e87a16ccd12b673$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $4e87a16ccd12b673$export$59acef2b3ab1df90);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aUPBc = parcelRequire("aUPBc");

var $71vEP = parcelRequire("71vEP");

var $aAuyI = parcelRequire("aAuyI");

var $j0I8T = parcelRequire("j0I8T");

var $fMHoz = parcelRequire("fMHoz");
const $4e87a16ccd12b673$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((appPrefix)=>(0, $aAuyI.createStorageProvider)((0, $j0I8T.WebStorageType).LocalStorage, appPrefix, (0, $fMHoz.makeLocalStore)()));
const $4e87a16ccd12b673$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((appPrefix)=>{
    return (0, $71vEP.createExpirableStorageProvider)((0, $j0I8T.WebStorageType).LocalStorage, appPrefix, (0, $fMHoz.makeLocalExpirableStore)());
});

});
parcelRegister("fMHoz", function(module, exports) {
$parcel$export(module.exports, "makeLocalStore", () => $d4a9fcb144d0bbbc$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $d4a9fcb144d0bbbc$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $d4a9fcb144d0bbbc$export$cf816b43e73de947);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /// <reference path="../../store.d.ts" />

var $jvDG2 = parcelRequire("jvDG2");

var $jd9DX = parcelRequire("jd9DX");

var $ef3Gs = parcelRequire("ef3Gs");

var $byYuq = parcelRequire("byYuq");

var $5oLFf = parcelRequire("5oLFf");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $5l7hq = parcelRequire("5l7hq");
const $d4a9fcb144d0bbbc$var$getPluginsWithCondition = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfp-vulcan-browser-storage-disable-auto-cleanup'), ()=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2)))
    ], ()=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2))),
        (0, $5l7hq.default)
    ]);
const $d4a9fcb144d0bbbc$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ef3Gs))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($byYuq))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5oLFf)))
    ], $d4a9fcb144d0bbbc$var$getPluginsWithCondition());
const $d4a9fcb144d0bbbc$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $d4a9fcb144d0bbbc$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ef3Gs))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($byYuq))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5oLFf)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jd9DX)))
    ]);

});
parcelRegister("byYuq", function(module, exports) {

var $8rZnz = parcelRequire("8rZnz");
var $86b1caac14a65c23$var$Global = $8rZnz.Global;
module.exports = {
    name: 'localStorage',
    read: $86b1caac14a65c23$var$read,
    write: $86b1caac14a65c23$var$write,
    each: $86b1caac14a65c23$var$each,
    remove: $86b1caac14a65c23$var$remove,
    clearAll: $86b1caac14a65c23$var$clearAll
};
function $86b1caac14a65c23$var$localStorage() {
    return $86b1caac14a65c23$var$Global.localStorage;
}
function $86b1caac14a65c23$var$read(key) {
    return $86b1caac14a65c23$var$localStorage().getItem(key);
}
function $86b1caac14a65c23$var$write(key, data) {
    return $86b1caac14a65c23$var$localStorage().setItem(key, data);
}
function $86b1caac14a65c23$var$each(fn) {
    for(var i = $86b1caac14a65c23$var$localStorage().length - 1; i >= 0; i--){
        var key = $86b1caac14a65c23$var$localStorage().key(i);
        fn($86b1caac14a65c23$var$read(key), key);
    }
}
function $86b1caac14a65c23$var$remove(key) {
    return $86b1caac14a65c23$var$localStorage().removeItem(key);
}
function $86b1caac14a65c23$var$clearAll() {
    return $86b1caac14a65c23$var$localStorage().clear();
}

});



parcelRegister("b10Xz", function(module, exports) {
$parcel$export(module.exports, "getTaskIndex", () => $1c91ec05f437a692$export$9ba3adcb1954c00);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $1c91ec05f437a692$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};

});


parcelRegister("2wjIB", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $b10962e0ec92b529$export$f24c05f83b880547);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $b10962e0ec92b529$export$f24c05f83b880547 = (isDismissed)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED : (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        await (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1DyW0.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
    };

});


parcelRegister("k2hbg", function(module, exports) {
$parcel$export(module.exports, "setNudgeStep", () => $f2eed325adbc91e3$export$4debc323813b6997);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f2eed325adbc91e3$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $f2eed325adbc91e3$export$2e2bcd8739ae039 = $f2eed325adbc91e3$export$4debc323813b6997;

});

parcelRegister("2viaa", function(module, exports) {
$parcel$export(module.exports, "addMountedNudge", () => $181780d386438a22$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $181780d386438a22$export$748f4cda8ab98c91);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $181780d386438a22$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $181780d386438a22$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("agR3I", function(module, exports) {
$parcel$export(module.exports, "setShouldRenderComponent", () => $21faee8cd07c7826$export$1f9c6770ed938b6e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $21faee8cd07c7826$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $21faee8cd07c7826$export$2e2bcd8739ae039 = $21faee8cd07c7826$export$1f9c6770ed938b6e;

});

parcelRegister("3riN6", function(module, exports) {
$parcel$export(module.exports, "setProjectState", () => $8be844875c197b4c$export$1ba498e440c0a1e4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $8be844875c197b4c$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $8be844875c197b4c$export$2e2bcd8739ae039 = $8be844875c197b4c$export$1ba498e440c0a1e4;

});

parcelRegister("2yI5h", function(module, exports) {
$parcel$export(module.exports, "setHasNudgeActive", () => $cb36e2a712e94de8$export$497c281e6eb0786e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cb36e2a712e94de8$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $cb36e2a712e94de8$export$2e2bcd8739ae039 = $cb36e2a712e94de8$export$497c281e6eb0786e;

});

parcelRegister("7925l", function(module, exports) {
$parcel$export(module.exports, "forceHideNudge", () => $27c0283352888859$export$6d1ed97b83a62e8e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $27c0283352888859$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("2eU4H", function(module, exports) {
$parcel$export(module.exports, "setHasEverSeenRoute", () => $eed870853487f8ba$export$28e0a4314a1ce52f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $eed870853487f8ba$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $eed870853487f8ba$export$2e2bcd8739ae039 = $eed870853487f8ba$export$28e0a4314a1ce52f;

});

parcelRegister("6zJVJ", function(module, exports) {
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $2924f9407820ccff$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $2924f9407820ccff$export$932967764e7a0b31);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2924f9407820ccff$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $2924f9407820ccff$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("8qaqK", function(module, exports) {
$parcel$export(module.exports, "openNextTask", () => $828ec87dd11f6c94$export$867dbb6d61569ae9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1DyW0 = parcelRequire("1DyW0");

var $lhMTU = parcelRequire("lhMTU");
const $828ec87dd11f6c94$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $1DyW0.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $lhMTU.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("lhMTU", function(module, exports) {
$parcel$export(module.exports, "nextOpenTask", () => $5acbe4b4d2edaa6b$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $5acbe4b4d2edaa6b$export$cc5f3544a6cb2922);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $k2hbg = parcelRequire("k2hbg");

var $2yI5h = parcelRequire("2yI5h");
const $5acbe4b4d2edaa6b$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $5acbe4b4d2edaa6b$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($5acbe4b4d2edaa6b$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $2yI5h.setHasNudgeActive)(false, taskId));
        else dispatch((0, $2yI5h.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        dispatch((0, $k2hbg.setNudgeStep)(''));
    };
const $5acbe4b4d2edaa6b$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($5acbe4b4d2edaa6b$var$openTask(taskId));
        dispatch((0, $2yI5h.setHasNudgeActive)(false, taskId));
        dispatch((0, $k2hbg.setNudgeStep)(''));
    };

});


parcelRegister("4BoSU", function(module, exports) {
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $9832d8441f0ceec4$export$bda085a823763e5a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $1n5q3 = parcelRequire("1n5q3");
const $9832d8441f0ceec4$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("gJ2q6", function(module, exports) {
$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $b3410c869ae99198$export$87fe8079a4ed9766);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $5ZtCQ = parcelRequire("5ZtCQ");

var $cXK8c = parcelRequire("cXK8c");

var $3gWPd = parcelRequire("3gWPd");

var $7rCTA = parcelRequire("7rCTA");

var $2wjIB = parcelRequire("2wjIB");
const $b3410c869ae99198$export$87fe8079a4ed9766 = ({ taskList: taskList, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // oxlint-disable-next-line typescript/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).map((type)=>(0, $5ZtCQ.getBackendVisibilityKey)(type));
        const backendState = await (0, $cXK8c.pollBackend)({
            keys: [
                (0, $5ZtCQ.KEY_OPEN),
                (0, $5ZtCQ.KEY_DISMISSED),
                (0, $5ZtCQ.KEY_OPEN_TASK),
                (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $5ZtCQ.KEY_JSW_ONBOARDING),
                ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $5ZtCQ.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $5ZtCQ.getBackendVisibilityKey)(type)];
                else if ((0, $5ZtCQ.KEY_DISMISSED) in backendState && backendState[0, $5ZtCQ.KEY_DISMISSED]) updatedState.visibility[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $5ZtCQ.KEY_OPEN] ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $5ZtCQ.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $5ZtCQ.KEY_DISMISSED];
            if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $5ZtCQ.KEY_OPEN];
            if ((0, $5ZtCQ.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $5ZtCQ.KEY_OPEN_TASK];
            if ((0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $5ZtCQ.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $5ZtCQ.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] !== null && (0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe) in backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING][0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $5ZtCQ.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $7rCTA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $2wjIB.nextSetChecklistIsDismissed)(true));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3gWPd.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("agOGQ", function(module, exports) {
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $8ffbc9dfb3f298b8$export$d6628d41a3bec42d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kRAaT = parcelRequire("kRAaT");
const $8ffbc9dfb3f298b8$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $kRAaT.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});

parcelRegister("ljq2N", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $4dc8711b425ff774$export$4eac017dcde0be8f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $4dc8711b425ff774$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $5ZtCQ.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("1XEDt", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $0532a026145990a5$export$4249eabbb34e2e69);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $0532a026145990a5$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $1DyW0.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("ktOmH", function(module, exports) {
$parcel$export(module.exports, "nextAutoExpand", () => $a4785549688c9665$export$3d24e97d30cfd09e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $wtuZr = parcelRequire("wtuZr");

var $1DyW0 = parcelRequire("1DyW0");

var $lhMTU = parcelRequire("lhMTU");
const $a4785549688c9665$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $wtuZr.localStorageProvider)().get({
            accountId: (0, $5ZtCQ.ACCOUNT_ID),
            key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $1DyW0.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if (openTask === currentTriggerForTaskGroupParent) return;
        dispatch((0, $lhMTU.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("wtuZr", function(module, exports) {
$parcel$export(module.exports, "localStorageProvider", () => $65ddfd76edbdbdc9$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $65ddfd76edbdbdc9$export$f2666fae743fa5f);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $cBnIS = parcelRequire("cBnIS");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $65ddfd76edbdbdc9$var$DAYS_BEFORE_EXPIRY = 1;
const $65ddfd76edbdbdc9$var$DAY = 86400000;
const $65ddfd76edbdbdc9$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $65ddfd76edbdbdc9$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $65ddfd76edbdbdc9$var$DAYS_BEFORE_EXPIRY * $65ddfd76edbdbdc9$var$DAY;
};
let $65ddfd76edbdbdc9$var$localStorage;
const $65ddfd76edbdbdc9$export$aa821bfb3308a1f5 = ()=>{
    if ($65ddfd76edbdbdc9$var$localStorage) // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return $65ddfd76edbdbdc9$var$localStorage;
    const provider = (0, $cBnIS.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>// @browser-storage setter
        provider.set($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }), value, $65ddfd76edbdbdc9$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }));
    $65ddfd76edbdbdc9$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return $65ddfd76edbdbdc9$var$localStorage;
};
const $65ddfd76edbdbdc9$export$f2666fae743fa5f = (value)=>{
    $65ddfd76edbdbdc9$export$aa821bfb3308a1f5().set({
        accountId: (0, $5ZtCQ.ACCOUNT_ID),
        key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("3slnW", function(module, exports) {
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $990f321ad1af71ae$export$6f336ccb6432fcd0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $wtuZr = parcelRequire("wtuZr");

var $2yI5h = parcelRequire("2yI5h");
const $990f321ad1af71ae$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $5ZtCQ.ACCOUNT_ID),
            key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $wtuZr.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $2yI5h.setHasNudgeActive)(true));
            (0, $wtuZr.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("hOXkl", function(module, exports) {
$parcel$export(module.exports, "nextGetTasks", () => $bb46770c873ac15c$export$15d877e1f3abf489);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kApfL = parcelRequire("kApfL");

var $lhMTU = parcelRequire("lhMTU");
const $bb46770c873ac15c$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { taskList: taskList, completedTaskList: completedTaskList, openTask: openTask, isQuickstartLoaded: isQuickstartLoaded } = getState();
        const tasks = (0, $kApfL.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
        // Auto-open the first incomplete task if no task is currently open
        // Note: nextGetTasks and refreshAppState can in theory happen in any order
        // Only do this if the quickstart is fully loaded (isQuickstartLoaded = true)
        // This ensures backend state has been restored before we auto-open
        if (tasks?.items && tasks.items.length > 0 && isQuickstartLoaded) {
            const firstIncompleteTask = tasks.items.find((taskId)=>!completedTaskList.includes(taskId));
            // If we found a first incomplete task and no task is currently open, open it
            if (firstIncompleteTask && !openTask) dispatch((0, $lhMTU.nextOpenTask)(firstIncompleteTask));
        }
    };

});
parcelRegister("kApfL", function(module, exports) {
$parcel$export(module.exports, "getAllTasks", () => $22017e3d8b39c720$export$d1f442602a91e7cc);

var $41FAq = parcelRequire("41FAq");

var $lG3WD = parcelRequire("lG3WD");

var $2700E = parcelRequire("2700E");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $8ZIK8 = parcelRequire("8ZIK8");

var $9URGr = parcelRequire("9URGr");

var $jrlyX = parcelRequire("jrlyX");

var $cBvJ0 = parcelRequire("cBvJ0");

var $er8Op = parcelRequire("er8Op");

var $dX7f5 = parcelRequire("dX7f5");

var $gehxg = parcelRequire("gehxg");

var $dvbnR = parcelRequire("dvbnR");

var $jXUhc = parcelRequire("jXUhc");
const $22017e3d8b39c720$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    // Removed jira_rt_quickstart_m1 feature flag - serving true case (no reverse trial task list)
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $5ZtCQ.ROOT_TASK];
    return {
        title: title,
        items: (0, $er8Op.getTasks)(variants, taskVariants, items)
    };
};
const $22017e3d8b39c720$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType })=>{
    return $22017e3d8b39c720$export$568bd601466cd235({
        taskGroupParent: taskGroupParent,
        teamType: teamType,
        projectState: projectState,
        taskList: taskList
    });
};
const $22017e3d8b39c720$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $9URGr.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $9URGr.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).JIRA_ADMIN) variants.push((0, $9URGr.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN) variants.push((0, $9URGr.JSM).userRole.siteAdmin);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $9URGr.JSM).taskVariants,
        taskList: (0, $9URGr.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$var$createPlanTasks = (taskGroupParent, features)=>{
    const variants = [];
    if (features?.hasPlanDependencies) variants.push((0, $dvbnR.Feature).hasPlanDependencies);
    if (features?.hasPlanProgram) variants.push((0, $dvbnR.Feature).hasPlanProgram);
    if (features?.hasPlanReleases) variants.push((0, $dvbnR.Feature).hasPlanReleases);
    if (features?.hasPlanTeams) variants.push((0, $dvbnR.Feature).hasPlanTeams);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $cBvJ0.PLAN).taskVariants,
        taskList: (0, $cBvJ0.PLAN).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, permissions)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $dvbnR.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $dvbnR.Feature).hasSprint);
    if (features?.hasSummaryPage) variants.push((0, $dvbnR.Feature).hasSummaryPage);
    if (features?.hasRoadmap) variants.push((0, $dvbnR.Feature).hasRoadmap);
    if (features?.hasList) variants.push((0, $dvbnR.Feature).hasList);
    if (features?.hasCalendar) variants.push((0, $dvbnR.Feature).hasCalendar);
    if ((0, $2700E.expVal)('jira_hide_connect_your_code_in_isolated_cloud', 'isEnabled', false) ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-development-tab') && features?.hasCode : features?.hasCode) variants.push((0, $dvbnR.Feature).hasCode);
    if (features?.hasForms) variants.push((0, $dvbnR.Feature).hasForms);
    if (features?.hasPages) variants.push((0, $dvbnR.Feature).hasPages);
    if (!(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages')) variants.push((0, $dvbnR.Experience).fedRamp);
    if (permissions?.canCreateIssue) variants.push((0, $dvbnR.Permissions).canCreateIssue);
    variants.push((0, $dvbnR.FeatureGate).removeInitialProjectTemplateName);
    if (teamType && (0, $lG3WD.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $gehxg.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
        taskList: (0, $gehxg.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $lG3WD.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if (!(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages')) variants.push((0, $dvbnR.Experience).fedRamp);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $gehxg.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $gehxg.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$568bd601466cd235 = ({ taskGroupParent: taskGroupParent, teamType: teamType, projectState: projectState, taskList: taskList })=>{
    const variants = [];
    // When cleaning up M2 and consolidating configs, this team type check should just be updated to include MKT & OPS
    if (teamType && (0, $lG3WD.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if (projectState?.isTrelloCrossflow) variants.push((0, $jrlyX.JWM).experiments.trelloCrossflow);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN) variants.push((0, $jrlyX.JWM).userRole.siteAdmin);
    if (!(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages')) variants.push((0, $dvbnR.Experience).fedRamp);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $jXUhc.TAILORED_ONBOARDING_BUSINESS_CONFIG),
        // This should be cleaned up when M2 is cleaned up. Currently it's like this because M2 populates taskList via the BE
        // and then the FE uses it here, ideally M2 cards are in the business config following conventions so they don't get extra priority bypassing other stuff in the config
        // For now there is also an extra check here to show the trello task list for Trello Crossflow users over M2 https://atlassian.slack.com/archives/C082QR7B16Z/p1755066367960509?thread_ts=1755064885.015779&cid=C082QR7B16Z
        taskList: !projectState?.isTrelloCrossflow && taskList ? taskList : (0, $gehxg.TAILORED_ONBOARDING_BUSINESS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, features: features, containerType: containerType, permissions: permissions })=>{
    if (containerType === 'plan') return $22017e3d8b39c720$var$createPlanTasks(taskGroupParent, features);
    if ((0, $dX7f5.isJwmProject)(projectState)) return $22017e3d8b39c720$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $dX7f5.isJsmProject)(projectState)) return $22017e3d8b39c720$var$createJsmTasks(projectState, taskGroupParent);
    // Implicitly JSW
    const tailoredOnboardingTasks = $22017e3d8b39c720$export$d9d83c8e96505820(taskGroupParent, teamType, features, permissions);
    return tailoredOnboardingTasks;
};

});
parcelRegister("lG3WD", function(module, exports) {
$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $d75906a9b0d008ac$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $d75906a9b0d008ac$export$26c385918d734203);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9tKPh = parcelRequire("9tKPh");
const $d75906a9b0d008ac$export$b924c0b3ec4d268e = (teamType)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $9tKPh.tailoredTeamTypes).includes(teamType);
};
const $d75906a9b0d008ac$export$26c385918d734203 = (teamType)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $9tKPh.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("9tKPh", function(module, exports) {
$parcel$export(module.exports, "tailoredTeamTypes", () => $55524e5bf5684c10$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $55524e5bf5684c10$export$52c5394d6e6cfcf3);
/* eslint-disable jira/filename-case */ 
const $55524e5bf5684c10$export$a1fbb7d965e15a39 = [
    (0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24),
    (0, $99cb2e6a234d7a1f$export$d7de553940261eba),
    (0, $99cb2e6a234d7a1f$export$e4824f74b9879164),
    (0, $99cb2e6a234d7a1f$export$4f3cb0844009af52),
    (0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d),
    (0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74),
    (0, $99cb2e6a234d7a1f$export$79685802e8ff1098),
    (0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)
];
const $55524e5bf5684c10$export$52c5394d6e6cfcf3 = [
    (0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24),
    (0, $99cb2e6a234d7a1f$export$d7de553940261eba),
    (0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d),
    (0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74),
    (0, $99cb2e6a234d7a1f$export$79685802e8ff1098),
    (0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)
];

});


parcelRegister("8ZIK8", function(module, exports) {
$parcel$export(module.exports, "USER_ROLE", () => $00acda1fb13631fd$export$8eeb199b23203523);
/* eslint-disable jira/filename-case */ const $00acda1fb13631fd$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("9URGr", function(module, exports) {
$parcel$export(module.exports, "JSM", () => $964fea8378454aec$export$63f289f2da861d35);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvANo = parcelRequire("jvANo");
const $964fea8378454aec$export$63f289f2da861d35 = {
    taskList: (0, $jvANo.JSM_TASK_LIST),
    taskVariants: (0, $jvANo.JSM_TASK_VARIANTS),
    userRole: (0, $jvANo.UserRole),
    experiments: (0, $jvANo.Experiments)
};

});
parcelRegister("jvANo", function(module, exports) {
$parcel$export(module.exports, "JSM_TASK_LIST", () => $330594c6136585e6$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $330594c6136585e6$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $330594c6136585e6$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $330594c6136585e6$export$5b68aef408c932d9);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $330594c6136585e6$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $330594c6136585e6$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: $330594c6136585e6$var$rootTitle,
        items: [
            (0, $5ZtCQ.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $5ZtCQ.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $5ZtCQ.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $330594c6136585e6$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $330594c6136585e6$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $330594c6136585e6$export$5b68aef408c932d9 = {
    [(0, $5ZtCQ.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $5ZtCQ.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $5ZtCQ.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});


parcelRegister("jrlyX", function(module, exports) {
$parcel$export(module.exports, "JWM", () => $7467b6c089b3897b$export$3ff26c80cb588e12);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5gtk6 = parcelRequire("5gtk6");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");
const $7467b6c089b3897b$export$3ff26c80cb588e12 = {
    taskList: (0, $5gtk6.TASK_LIST),
    taskVariants: (0, $5gtk6.TASK_VARIANTS),
    userRole: (0, $fWmos.UserRole),
    experiments: (0, $eFRe9.Experiments)
};

});
parcelRegister("5gtk6", function(module, exports) {
$parcel$export(module.exports, "TASK_LIST", () => $2beaab971a6492fd$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "OPS_TAILORED_ONBOARDING_TASK_VARIANTS", () => $2beaab971a6492fd$export$db06b8e338ba9c65);
$parcel$export(module.exports, "MKT_TAILORED_ONBOARDING_TASK_VARIANTS", () => $2beaab971a6492fd$export$bda7075f98246874);
$parcel$export(module.exports, "TASK_VARIANTS", () => $2beaab971a6492fd$export$36f4d47dfe11b613);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");
const $2beaab971a6492fd$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $2beaab971a6492fd$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: $2beaab971a6492fd$var$rootTitle,
        items: [
            (0, $5ZtCQ.JWM_CREATE_PROJECT_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)
        ]
    }
});
const $2beaab971a6492fd$export$db06b8e338ba9c65 = {
    [(0, $5ZtCQ.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $2beaab971a6492fd$export$bda7075f98246874 = {
    [(0, $5ZtCQ.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $2beaab971a6492fd$export$36f4d47dfe11b613 = {
    ...$2beaab971a6492fd$export$db06b8e338ba9c65,
    ...$2beaab971a6492fd$export$bda7075f98246874,
    [(0, $5ZtCQ.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow,
                        (0, $fWmos.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("dvbnR", function(module, exports) {
$parcel$export(module.exports, "TeamType", () => $885860f3e92ee151$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $885860f3e92ee151$export$6e91cf7616333d5);
$parcel$export(module.exports, "FeatureGate", () => $885860f3e92ee151$export$d4ba9a3e7000cca8);
$parcel$export(module.exports, "Permissions", () => $885860f3e92ee151$export$2d41982586bbb6be);
$parcel$export(module.exports, "Experience", () => $885860f3e92ee151$export$c90b54e658fc4d7c);
/* eslint-disable jira/filename-case */ 
const $885860f3e92ee151$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $99cb2e6a234d7a1f$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $99cb2e6a234d7a1f$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $99cb2e6a234d7a1f$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $99cb2e6a234d7a1f$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $885860f3e92ee151$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint',
    hasSummaryPage: 'feature.hasSummaryPage',
    hasRoadmap: 'feature.hasRoadmap',
    hasList: 'feature.hasList',
    hasCalendar: 'feature.hasCalendar',
    hasCode: 'feature.hasCode',
    hasForms: 'feature.hasForms',
    hasPages: 'feature.hasPages',
    hasPlanDependencies: 'feature.hasPlanDependencies',
    hasPlanProgram: 'feature.hasPlanProgram',
    hasPlanReleases: 'feature.hasPlanReleases',
    hasPlanTeams: 'feature.hasPlanTeams'
};
const $885860f3e92ee151$export$d4ba9a3e7000cca8 = {
    removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name'
};
const $885860f3e92ee151$export$2d41982586bbb6be = {
    canCreateIssue: 'permissions.canCreateIssue'
};
const $885860f3e92ee151$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $885860f3e92ee151$export$c90b54e658fc4d7c = {
    fedRamp: 'experience.fedRamp'
};

});

parcelRegister("eFRe9", function(module, exports) {
$parcel$export(module.exports, "Experiments", () => $f67fafb607dbc7c0$export$c8d6ffd15214553a);
/* eslint-disable jira/filename-case */ const $f67fafb607dbc7c0$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("fWmos", function(module, exports) {
$parcel$export(module.exports, "UserRole", () => $17521fafdbc867e0$export$eb3485a690c2f0b8);
/* eslint-disable jira/filename-case */ const $17521fafdbc867e0$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("cBvJ0", function(module, exports) {
$parcel$export(module.exports, "PLAN", () => $bfac3d2456178e37$export$c303e491e026ebc6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i6G5g = parcelRequire("i6G5g");
const $bfac3d2456178e37$export$c303e491e026ebc6 = {
    taskList: (0, $i6G5g.PLAN_TASK_LIST),
    taskVariants: (0, $i6G5g.PLAN_TASK_VARIANTS)
};

});
parcelRegister("i6G5g", function(module, exports) {
$parcel$export(module.exports, "PLAN_TASK_LIST", () => $1ab7c646a72e5fed$export$6ddf1195a65583de);
$parcel$export(module.exports, "PLAN_TASK_VARIANTS", () => $1ab7c646a72e5fed$export$73c2f09f0994be4f);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $1ab7c646a72e5fed$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "onboarding-quickstart-core.services.tasks.config.plan.root-title",
    defaultMessage: "Quickstart"
});
const $1ab7c646a72e5fed$export$6ddf1195a65583de = Object.freeze({
    root: {
        title: $1ab7c646a72e5fed$var$rootTitle,
        items: [
            (0, $5ZtCQ.PLAN_TEAM_CAPACITY_TASK),
            (0, $5ZtCQ.PLAN_PROGRAM_BOARD_TASK),
            (0, $5ZtCQ.PLAN_RELEASE_MANAGEMENT_TASK),
            (0, $5ZtCQ.PLAN_DEPENDENCY_TRACKING_TASK)
        ]
    }
});
const $1ab7c646a72e5fed$export$73c2f09f0994be4f = {
    [(0, $5ZtCQ.PLAN_TEAM_CAPACITY_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanTeams
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_PROGRAM_BOARD_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanProgram
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_RELEASE_MANAGEMENT_TASK)]: {
        position: {
            default: 20
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanReleases
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_DEPENDENCY_TRACKING_TASK)]: {
        position: {
            default: 30
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanDependencies
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("er8Op", function(module, exports) {
$parcel$export(module.exports, "getTasks", () => $078ea27c308f9d74$export$20b82b4a32771893);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $akVgl = parcelRequire("akVgl");
const $078ea27c308f9d74$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $akVgl.getConditional)(visibility, variants) : true;
const $078ea27c308f9d74$var$getTaskPosition = (variants, position)=>(0, $akVgl.getConditional)(position, variants);
const $078ea27c308f9d74$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$078ea27c308f9d74$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$078ea27c308f9d74$var$getTaskPosition(variants, taskVariants[taskA].position) - $078ea27c308f9d74$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("akVgl", function(module, exports) {
$parcel$export(module.exports, "getConditional", () => $eb2f3313899aa233$export$fe3161cde0106bba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $eb2f3313899aa233$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("dX7f5", function(module, exports) {
$parcel$export(module.exports, "isJwmProject", () => $9eb7081466bad82f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $9eb7081466bad82f$export$a972ed853ed1d469);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");
const $9eb7081466bad82f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $f99M0.CORE_PROJECT);
const $9eb7081466bad82f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);

});

parcelRegister("gehxg", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $781ea1b3868534c8$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $781ea1b3868534c8$export$eb17ad7838835d2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS", () => $781ea1b3868534c8$export$fe6b8880a507b306);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $hsVn2 = parcelRequire("hsVn2");

var $9W3eX = parcelRequire("9W3eX");

var $eyABc = parcelRequire("eyABc");

var $cHxES = parcelRequire("cHxES");

var $foPEo = parcelRequire("foPEo");

var $aTf9A = parcelRequire("aTf9A");

var $cPgA9 = parcelRequire("cPgA9");

var $kF6m8 = parcelRequire("kF6m8");
const $781ea1b3868534c8$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $781ea1b3868534c8$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BACKLOG),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $781ea1b3868534c8$export$83849aa73c0a20db = {
    taskList: $781ea1b3868534c8$export$2757f7b23d120b9b,
    taskVariants: (0, $kF6m8.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $781ea1b3868534c8$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $781ea1b3868534c8$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74:
            return 0, $9W3eX.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$79685802e8ff1098:
            return 0, $hsVn2.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24:
            return 0, $eyABc.DESIGN_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$d7de553940261eba:
            return 0, $cHxES.IT_SUPPORT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d:
            return 0, $foPEo.OTHER_PERSONAL_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b:
            return 0, $cPgA9.SOFTWARE_VARIANTS;
        default:
            return 0, $aTf9A.EVERYTHING_ELSE_VARIANTS;
    }
};
const $781ea1b3868534c8$export$cb2285c4be67df48 = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            // JWM Trello Crossflow Tasks
            (0, $5ZtCQ.JWM_CREATE_PROJECT_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $5ZtCQ.JWM_BUILD_FORM_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            // JSW Tailored Onboarding Tasks
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)
        ]
    }
});
const $781ea1b3868534c8$export$eb17ad7838835d2a = {
    taskList: $781ea1b3868534c8$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $781ea1b3868534c8$export$3c409334669aec75
};
const $781ea1b3868534c8$export$fe6b8880a507b306 = {
    taskList: $781ea1b3868534c8$export$cb2285c4be67df48
};

});
parcelRegister("hsVn2", function(module, exports) {
$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $56d54c062d4173ad$export$bdd338c80f8962df);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $56d54c062d4173ad$export$bdd338c80f8962df = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9W3eX", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $39f1fbf4259ebcca$export$b07ea6a2d29f9c08);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $39f1fbf4259ebcca$export$b07ea6a2d29f9c08 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("eyABc", function(module, exports) {
$parcel$export(module.exports, "DESIGN_VARIANTS", () => $a7a546fbc840a986$export$a3c4cd8e420f13a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $a7a546fbc840a986$export$a3c4cd8e420f13a = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("cHxES", function(module, exports) {
$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $8453a6ca22fbb130$export$a25e809b52945082);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $8453a6ca22fbb130$export$a25e809b52945082 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("foPEo", function(module, exports) {
$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $eb4ebd50ad83e801$export$916be3c140ae8c0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $eb4ebd50ad83e801$export$916be3c140ae8c0 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("aTf9A", function(module, exports) {
$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $f40aa275376d9c93$export$7a0daeb069f34de3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $f40aa275376d9c93$export$7a0daeb069f34de3 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("cPgA9", function(module, exports) {
$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $609157f95a04c4bd$export$76a143792cc73994);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $609157f95a04c4bd$export$76a143792cc73994 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("kF6m8", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $bd1d4f54dcaf47e5$export$64855550cee11b78);
/* eslint-disable jira/filename-case */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $bd1d4f54dcaf47e5$export$64855550cee11b78 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Permissions).canCreateIssue
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasCode
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("jXUhc", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS_CONFIG", () => $c62fd069dca23e40$export$474323a35aa36586);
/* eslint-disable jira/filename-case */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");

var $5gtk6 = parcelRequire("5gtk6");
const $c62fd069dca23e40$export$474323a35aa36586 = {
    ...(0, $5gtk6.OPS_TAILORED_ONBOARDING_TASK_VARIANTS),
    ...(0, $5gtk6.MKT_TAILORED_ONBOARDING_TASK_VARIANTS),
    // Trello Crossflow Cards - These take priority when trelloCrossflow experiment is active
    [(0, $5ZtCQ.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow,
                        (0, $fWmos.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    // Regular Tailored Onboarding Cards - These are hidden when trelloCrossflow is active
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});



parcelRegister("jJY2t", function(module, exports) {
$parcel$export(module.exports, "syncVisibilityWithLocal", () => $6da4c253db4092e5$export$4aab9a98fc53b894);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $6da4c253db4092e5$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $1DyW0.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("bNXf6", function(module, exports) {
$parcel$export(module.exports, "universalDispatch", () => $e4798fb7ab0be54b$export$efe980271ca9cc08);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e4798fb7ab0be54b$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});

parcelRegister("2D5ku", function(module, exports) {
$parcel$export(module.exports, "setContainerType", () => $11a6776765b237a2$export$24889c6c4e904da4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $11a6776765b237a2$export$24889c6c4e904da4 = (containerType)=>({ getState: getState, setState: setState })=>{
        const { containerType: currentContainerType } = getState();
        if (containerType === currentContainerType) // if state has not been updated we just return
        return;
        setState({
            containerType: containerType
        });
    };
var $11a6776765b237a2$export$2e2bcd8739ae039 = $11a6776765b237a2$export$24889c6c4e904da4;

});

parcelRegister("adLxs", function(module, exports) {
$parcel$export(module.exports, "setQuickstartButtonRef", () => $9773b9b971c00e4a$export$8119a14b79738a24);
$parcel$export(module.exports, "setIsOpenedViaButton", () => $9773b9b971c00e4a$export$8b7fa399fb8c07f);
$parcel$export(module.exports, "focusQuickstartButton", () => $9773b9b971c00e4a$export$8f1aa3f8d2941465);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $9773b9b971c00e4a$export$8119a14b79738a24 = (quickstartButtonRef)=>({ setState: setState })=>{
        setState({
            quickstartButtonRef: quickstartButtonRef
        });
    };
const $9773b9b971c00e4a$export$8b7fa399fb8c07f = (isOpenedViaButton)=>({ setState: setState })=>{
        setState({
            isOpenedViaButton: isOpenedViaButton
        });
    };
// Since the button is visible after 220ms and requestAnimationFrame is called 60 times per second,
// to be safe we can wait for 15 frames (220/1000 * 60)
const $9773b9b971c00e4a$var$MAX_FOCUS_RETRIES = 15;
const $9773b9b971c00e4a$export$8f1aa3f8d2941465 = ()=>({ setState: setState, getState: getState })=>{
        let retryCount = 0;
        const tryFocus = ()=>{
            const { quickstartButtonRef: quickstartButtonRef, isOpenedViaButton: isOpenedViaButton } = getState();
            if (quickstartButtonRef && isOpenedViaButton) {
                quickstartButtonRef.focus({
                    preventScroll: true
                });
                setState({
                    isOpenedViaButton: false
                });
            } else if (!quickstartButtonRef && retryCount < $9773b9b971c00e4a$var$MAX_FOCUS_RETRIES) {
                // If ref not available yet due to button animation delay, try again
                retryCount++;
                requestAnimationFrame(tryFocus);
            }
        };
        // Uses requestAnimationFrame to wait until the ref is available
        requestAnimationFrame(tryFocus);
    };

});


parcelRegister("ia7JZ", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $d4bfa53efccc0000$export$d4c72bab9d6cc13a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");
const $d4bfa53efccc0000$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $5ZtCQ.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $5ZtCQ.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $5ZtCQ.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED
    },
    quickstartButtonRef: null,
    isOpenedViaButton: false
};

});


parcelRegister("62Xqf", function(module, exports) {
$parcel$export(module.exports, "useSpaStatePageReady", () => $07d52b79c17de633$export$ea2491906b753456);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $b9Jox = parcelRequire("b9Jox");

var $6Bw3S = parcelRequire("6Bw3S");
const $07d52b79c17de633$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $07d52b79c17de633$var$useSpaStatePageReadyStateHook = (0, $3h1FP.createHook)((0, $6Bw3S.default), {
    selector: $07d52b79c17de633$export$e6897aa59ee7aee5
});
function $07d52b79c17de633$export$ea2491906b753456() {
    const isClientReady = (0, $b9Jox.useIsClientReady)();
    const [{ isReady: isReady }] = $07d52b79c17de633$var$useSpaStatePageReadyStateHook();
    return isClientReady && isReady;
}

});
parcelRegister("b9Jox", function(module, exports) {
$parcel$export(module.exports, "useIsClientReady", () => $5a808a6751bb4871$export$d2ab98824add97fa);
// eslint-disable-next-line jira/filename-case, jira/restricted/react-18

var $euxye = parcelRequire("euxye");
const $5a808a6751bb4871$export$d2ab98824add97fa = ()=>(0, $euxye.useSyncExternalStore)(()=>()=>{
        // empty
        }, ()=>true, ()=>false);

});

parcelRegister("6Bw3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $4833019c6808a1a6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $7TA2J = parcelRequire("7TA2J");

var $5QDqc = parcelRequire("5QDqc");

var $44S8S = parcelRequire("44S8S");
const $4833019c6808a1a6$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, $7TA2J.v4)(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $4833019c6808a1a6$var$store = (0, $5QDqc.createStore)({
    name: 'spa-state',
    initialState: $4833019c6808a1a6$export$d4c72bab9d6cc13a,
    actions: $44S8S
});
var $4833019c6808a1a6$export$2e2bcd8739ae039 = $4833019c6808a1a6$var$store;

});
parcelRegister("44S8S", function(module, exports) {
$parcel$export(module.exports, "setAppStart", () => (parcelRequire("eRZzB")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("eRZzB")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("eRZzB")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("eRZzB")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("eRZzB")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("eRZzB")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("eRZzB")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("eRZzB")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("eRZzB")).setResourceMetrics);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $eRZzB = parcelRequire("eRZzB");

});
parcelRegister("eRZzB", function(module, exports) {
$parcel$export(module.exports, "resetCurrentPage", () => $c773413dc6d09e62$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $c773413dc6d09e62$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $c773413dc6d09e62$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $c773413dc6d09e62$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $c773413dc6d09e62$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $c773413dc6d09e62$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $c773413dc6d09e62$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $c773413dc6d09e62$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $c773413dc6d09e62$export$8ad155d489dcf34d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7TA2J = parcelRequire("7TA2J");

var $1pIYN = parcelRequire("1pIYN");

var $9yf7o = parcelRequire("9yf7o");

var $41zzZ = parcelRequire("41zzZ");

var $ehOO1 = parcelRequire("ehOO1");
const $c773413dc6d09e62$export$7bd623b29ec8e1eb = 10000;
const $c773413dc6d09e62$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $9yf7o.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $1pIYN.default)(nextRouteUfoName, nextRouteName);
        (0, $ehOO1.GlobalPageLoadExperience).abort({
            force: true
        });
        (0, $ehOO1.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, $7TA2J.v4)(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $c773413dc6d09e62$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $c773413dc6d09e62$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($c773413dc6d09e62$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $c773413dc6d09e62$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($c773413dc6d09e62$export$8a98548dad2fa97b(appId));
            }, $c773413dc6d09e62$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $41zzZ.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $c773413dc6d09e62$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($c773413dc6d09e62$export$9d528722f2ff2999(appId, startTime));
    };
const $c773413dc6d09e62$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $c773413dc6d09e62$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($c773413dc6d09e62$export$6a25429a42d30f9a(appId, endTime));
    };
const $c773413dc6d09e62$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $c773413dc6d09e62$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});






parcelRegister("geeJ4", function(module, exports) {
$parcel$export(module.exports, "useJsmRightSidebarsPreload", () => $394ada2765c94604$export$6b7fcb392555b342);

var $euxye = parcelRequire("euxye");

var $2b39L = parcelRequire("2b39L");


var $eki8y = parcelRequire("eki8y");

var $4Onaa = parcelRequire("4Onaa");

var $9mRNC = parcelRequire("9mRNC");
const $394ada2765c94604$export$6b7fcb392555b342 = (target)=>{
    const hasPreloadedRef = (0, $euxye.useRef)(false);
    const projectContext = (0, $2b39L.useProjectContext)();
    const projectContextData = projectContext?.data;
    const route = (0, $4Onaa.useCurrentRoute)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $eki8y.useJsmOnboardingType)();
    (0, $euxye.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData
    ]);
    const shouldRender = jsmOnboardingData?.onboardingType === (0, $77d3ca58d1d4a14f$export$6f454e69bce3a691) && (0, $9mRNC.shouldRouteShowQuickstartOnboarding)(route.name) || (0, $9mRNC.shouldRenderRequestTypesTableViewSettings)(route.name);
    (0, $euxye.useEffect)(()=>{
        if (shouldRender && !hasPreloadedRef.current) {
            target.preload?.();
            hasPreloadedRef.current = true;
        }
    }, [
        shouldRender,
        target
    ]);
    return shouldRender;
};

});
parcelRegister("4Onaa", function(module, exports) {
$parcel$export(module.exports, "useCurrentRoute", () => $7cf4e26bcc1acd8b$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $7cf4e26bcc1acd8b$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $7cf4e26bcc1acd8b$export$1e5fb68306bd0b92);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f2wVS = parcelRequire("f2wVS");
var $bc9Gj = parcelRequire("bc9Gj");

var $41zzZ = parcelRequire("41zzZ");
const $7cf4e26bcc1acd8b$export$c4b7ea2942f2d0e = (0, $f2wVS.createRouterSelector)((state)=>state.route);
const $7cf4e26bcc1acd8b$export$d69a946e2d0a1c12 = (0, $f2wVS.createRouterSelector)((state, routeName)=>// oxlint-disable-next-line typescript/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $7cf4e26bcc1acd8b$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $7cf4e26bcc1acd8b$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $bc9Gj.useRouter)();
    return (0, $41zzZ.getPreviousRouterState)();
};

});

parcelRegister("9mRNC", function(module, exports) {
$parcel$export(module.exports, "shouldRouteShowQuickstartOnboarding", () => $eb01f8499a125646$export$25ddf6cfdf6af9c5);
$parcel$export(module.exports, "shouldRenderRequestTypesTableViewSettings", () => $eb01f8499a125646$export$2b8029e8db91a531);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7Odw0 = parcelRequire("7Odw0");

var $5yfEX = parcelRequire("5yfEX");

var $e4hT2 = parcelRequire("e4hT2");

var $aPX9C = parcelRequire("aPX9C");

var $73kzk = parcelRequire("73kzk");
const $eb01f8499a125646$var$REQUEST_TYPE_PAGE_ROUTES = [
    (0, $5yfEX.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $e4hT2.projectSettingsServicedeskItsmTicketTypesConfigRoute).name,
    (0, $aPX9C.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $73kzk.servicedeskGettingStartedRequestTypesRoute).name
];
const $eb01f8499a125646$export$25ddf6cfdf6af9c5 = (routeName)=>{
    if ((0, $7Odw0.isSupportedUserAgent)()) return false;
    const allowedRoutes = [
        'servicedesk-queues-landing',
        'servicedesk-queues-custom-view',
        'legacy-project-settings-edit',
        'legacy-project-settings-people',
        'project-settings-servicedesk-customer-notifications',
        'project-settings-servicedesk-email',
        'project-settings-servicedesk-portal-settings',
        'project-settings-servicedesk-ticket-types-config',
        'project-settings-servicedesk-chat'
    ];
    return allowedRoutes.includes(routeName);
};
const $eb01f8499a125646$export$2b8029e8db91a531 = (routeName)=>$eb01f8499a125646$var$REQUEST_TYPE_PAGE_ROUTES.includes(routeName);

});
parcelRegister("73kzk", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRequestTypesRoute", () => $9254de181856af95$export$efc8e94c428c4dc3);
const $9254de181856af95$export$efc8e94c428c4dc3 = {
    name: 'servicedesk-getting-started-request-types',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/request-types',
    exact: true
};

});



parcelRegister("4CmB9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bHeRd").then(()=>parcelRequire('klUPL'));

});

parcelRegister("5gqRZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("jXORD")
]).then(()=>parcelRequire('kZHqX'));

});

parcelRegister("9ZZ9z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("8Ugzq")
]).then(()=>parcelRequire('dEtEX'));

});

parcelRegister("4lLiV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("7pJmj")
]).then(()=>parcelRequire('lgpDF'));

});


parcelRegister("frFzI", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentAiAnswersSkeleton", () => $48dbb7ebdf508549$export$5fe1280883d32350);
/* VirtualAgentAiAnswersSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $1rvLI = parcelRequire("1rvLI");
const $48dbb7ebdf508549$var$customCssStyles = null;
const $48dbb7ebdf508549$export$5fe1280883d32350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1rvLI))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$48dbb7ebdf508549$export$5fe1280883d32350.displayName = "VirtualAgentAiAnswersSkeleton";

});
parcelRegister("d5ps5", function(module, exports) {
$parcel$export(module.exports, "AppSkeletonImage", () => $82b7ce1fc1675e95$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.38.1 */ /// <reference types="node" />

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2D2gW = parcelRequire("2D2gW");


var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $ubti7 = parcelRequire("ubti7");
const $82b7ce1fc1675e95$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "skeletons.common.loading",
    defaultMessage: "Loading"
});
const $82b7ce1fc1675e95$var$skeletonImageStyles = null;
const $82b7ce1fc1675e95$var$skeletonImageBorderlessStyles = null;
const $82b7ce1fc1675e95$export$45b107c5dc7b51a5 = /*#__PURE__*/ (0, $euxye.memo)(({ src: src, className: className, hideBorder: hideBorder = false, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($82b7ce1fc1675e95$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage($82b7ce1fc1675e95$var$loadingMessage)}...`,
        className: (0, $4jQY2.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            hideBorder && "_uwhkidpf _hr4jidpf _1docidpf _t6vdidpf _l82tidpf _j7o0idpf",
            className
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ubti7.FallbackIndicator), null));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82b7ce1fc1675e95$var$SkeletonWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ubti7", function(module, exports) {
$parcel$export(module.exports, "FallbackIndicator", () => $b1c3a507e5d69d86$export$e975518239643357);

var $b8Dvw = parcelRequire("b8Dvw");

var $k5P9q = parcelRequire("k5P9q");
const $b1c3a507e5d69d86$var$pushSSRFailureDisplay = (failureProps)=>{
    (0, $b8Dvw.registerEvent)({
        id: 'ssr-failure-display',
        name: 'onSSRFailureDisplay',
        args: [
            failureProps
        ]
    });
};
const $b1c3a507e5d69d86$export$e975518239643357 = ({ reportToSlackChannel: reportToSlackChannel, fallbackId: fallbackId, displayErrorInStaging: displayErrorInStaging, isCookieCircuitBreakerFailure: isCookieCircuitBreakerFailure, cookieKey: cookieKey })=>{
    const isStagingOrDevOrLocal = (0, $k5P9q.useIsStagingOrDevOrLocal)();
    // eslint-disable-next-line jira/jira-ssr/no-server-variable
    if (false) {
        if (displayErrorInStaging && isStagingOrDevOrLocal) $b1c3a507e5d69d86$var$pushSSRFailureDisplay({
            reportToSlackChannel: reportToSlackChannel,
            fallbackId: fallbackId,
            displayErrorInStaging: displayErrorInStaging,
            isCookieCircuitBreakerFailure: isCookieCircuitBreakerFailure,
            cookieKey: cookieKey
        });
    }
    return null;
};
$b1c3a507e5d69d86$export$e975518239643357.displayName = "FallbackIndicator";

});
parcelRegister("k5P9q", function(module, exports) {
$parcel$export(module.exports, "useEnvironment", () => $cf4e80e005198d32$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $cf4e80e005198d32$export$b0d8f74f433a09c9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $cf4e80e005198d32$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $cf4e80e005198d32$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext?.environment || $cf4e80e005198d32$var$ENVIRONMENT.PROD;
};
const $cf4e80e005198d32$export$b0d8f74f433a09c9 = ()=>{
    const env = $cf4e80e005198d32$export$ea7ed2425832167d();
    return env === $cf4e80e005198d32$var$ENVIRONMENT.STAGING || env === $cf4e80e005198d32$var$ENVIRONMENT.DEV || env === $cf4e80e005198d32$var$ENVIRONMENT.LOCAL;
};

});



parcelRegister("1rvLI", function(module, exports) {
module.exports = new URL("virtual-agent-ai-answers-app-skeleton.tpl.283eb0a3.svg", import.meta.url).toString();

});


parcelRegister("1lV4Z", function(module, exports) {
$parcel$export(module.exports, "FedRAMPFallbackRedirectToProjectSettings", () => $f2d22f639ec2fbcf$export$3b12aad1f47d85f8);
/* eslint-disable jira/naming/disallow-filenames */ 
var $1UpS5 = parcelRequire("1UpS5");
const $f2d22f639ec2fbcf$export$3b12aad1f47d85f8 = (0, $1UpS5.defaultRedirectForSettings)((0, $1UpS5.SERVICE_DESK_PRODUCT));

});
parcelRegister("1UpS5", function(module, exports) {
$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $086466a3c7efdb43$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $086466a3c7efdb43$export$c9b0516439c55d7a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $086466a3c7efdb43$export$5575497f0592ee94 = 'servicedesk';
const $086466a3c7efdb43$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});



parcelRegister("krjBK", function(module, exports) {
$parcel$export(module.exports, "aiFirstCreateRouteEntry", () => $b8d7063898a9ba7c$export$71ab6d11c27a9714);

var $j2vDj = parcelRequire("j2vDj");

var $cLdvY = parcelRequire("cLdvY");

var $fdS54 = parcelRequire("fdS54");

var $fDrUA = parcelRequire("fDrUA");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");
const $b8d7063898a9ba7c$var$AIFCEmbedPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $j2vDj.aiFirstCreateEntryPoint)
});
const $b8d7063898a9ba7c$export$71ab6d11c27a9714 = (0, $fdS54.createEntry)(// baseRoute refers to the static route definition above
(0, $fDrUA.aiFirstCreateRoute), ()=>({
        group: 'aifc',
        ufoName: 'jira-ai-first-create.embed-view',
        layout: (0, $byMD7.chromelessLayout),
        entryPoint: ()=>$b8d7063898a9ba7c$var$AIFCEmbedPageEntryPoint,
        resources: [
            (0, $cLdvY.aiEntitlementResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("j2vDj", function(module, exports) {
$parcel$export(module.exports, "aiFirstCreateEntryPoint", () => $cb16d2e647ffd1f2$export$fa2e9ac39dfac6e1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7edt8 = parcelRequire("7edt8");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $cb16d2e647ffd1f2$export$fa2e9ac39dfac6e1 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2c3Ls")), {
        moduleId: "935fa074",
        moduleName: "AIFirstCreateComponent",
        priority: "interaction"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = String(context.query?.projectIdOrKey ?? '');
        let theme = 'light';
        if (context.query?.theme === 'dark') theme = 'dark';
        return {
            queries: {
                firstCreateQueryRef: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $7edt8.default),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                projectIdOrKey: projectIdOrKey,
                theme: theme
            }
        };
    }
});

});
parcelRegister("7edt8", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaec1ff95df1d59d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c9472411adcfa17f8f4333348b44bfb>>
 * @relayHash eb7ad2588ded6f5778b3afbee07ab479
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6abe3e3c13793441b7438b6bf4af79feab5429c91c6902c0f785da6f786c4054
const $eaec1ff95df1d59d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6abe3e3c13793441b7438b6bf4af79feab5429c91c6902c0f785da6f786c4054",
        "metadata": {},
        "name": "FirstCreateScreenQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eaec1ff95df1d59d$export$2e2bcd8739ae039 = $eaec1ff95df1d59d$var$node;

});

parcelRegister("2c3Ls", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8sNFz").then(()=>parcelRequire('kbNsq'));

});


parcelRegister("cLdvY", function(module, exports) {
$parcel$export(module.exports, "aiEntitlementResource", () => $6526ea3b19c64722$export$1d7e36ec4890154f);
$parcel$export(module.exports, "useAiEntitlementResource", () => $6526ea3b19c64722$export$58958385d85a6e72);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $hU1LR = parcelRequire("hU1LR");
const $6526ea3b19c64722$var$RESOURCE_TYPE_AI_ENTITLEMENT = 'AI_ENTITLEMENT';
const $6526ea3b19c64722$export$1d7e36ec4890154f = (0, $7edbf.createResource)({
    type: $6526ea3b19c64722$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getKey: ()=>$6526ea3b19c64722$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getData: ()=>(0, $hU1LR.fetchAiEnablement)(),
    maxAge: 3600000
});
const $6526ea3b19c64722$export$58958385d85a6e72 = ()=>(0, $k6ufm.useResource)($6526ea3b19c64722$export$1d7e36ec4890154f);

});
parcelRegister("hU1LR", function(module, exports) {
$parcel$export(module.exports, "fetchAiEnablement", () => $fadaba68c62d2a33$export$ad4105850d0ce824);

var $4fhEY = parcelRequire("4fhEY");
const $fadaba68c62d2a33$var$JIRA_SOFTWARE_AI_ENABLED_URL = '/rest/api/1/aiconfig/ai-enabled/jira-software';
const $fadaba68c62d2a33$export$ad4105850d0ce824 = async ()=>{
    // We could check for other jira products / confluence when we need to
    // Not doing that right now as it adds complexity & we need software only now
    // See `@jira/platform__utils-react-hooks-use-is-admin-hub-ai-enabled`
    const entitlementData = {
        isAiEnabledForJiraSoftware: null
    };
    try {
        const response = await (0, $4fhEY.default)($fadaba68c62d2a33$var$JIRA_SOFTWARE_AI_ENABLED_URL, {
            method: 'GET'
        });
        entitlementData.isAiEnabledForJiraSoftware = response.isEnabled;
    } catch (_) {
        entitlementData.isAiEnabledForJiraSoftware = null;
    }
    return entitlementData;
};

});


parcelRegister("fDrUA", function(module, exports) {
$parcel$export(module.exports, "aiFirstCreateRoute", () => $2605a83753385ba3$export$26b67ee2546d8cb5);
const $2605a83753385ba3$export$26b67ee2546d8cb5 = {
    name: 'ai-first-create-embed',
    path: '/jira/ai-first-create/embed',
    exact: true,
    query: [
        'conversationChannelId',
        'projectIdOrKey',
        'theme?'
    ]
};

});

parcelRegister("byMD7", function(module, exports) {
$parcel$export(module.exports, "chromelessLayout", () => $e8c0ef1c4e289e14$export$17e73ed8c35891cb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");
const $e8c0ef1c4e289e14$export$17e73ed8c35891cb = (0, $QhQu4.createLayout)({
    isChromeless: true
});

});


parcelRegister("4gGhz", function(module, exports) {
$parcel$export(module.exports, "aiSurveyCreateRouteEntry", () => $67268d332a7b558a$export$7216537471078a1e);

var $iSoIx = parcelRequire("iSoIx");

var $cLdvY = parcelRequire("cLdvY");

var $fdS54 = parcelRequire("fdS54");

var $e8yd8 = parcelRequire("e8yd8");

var $i860n = parcelRequire("i860n");

var $byMD7 = parcelRequire("byMD7");

var $pICJV = parcelRequire("pICJV");
const $67268d332a7b558a$export$7216537471078a1e = (0, $fdS54.createEntry)((0, $e8yd8.aiSurveyCreateRoute), ()=>({
        group: 'aifc',
        ufoName: 'jsm.ai-create-survey',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            (0, $cLdvY.aiEntitlementResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('surveys-aifc') ? (0, $pICJV.aiSurveyCreatePageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e8yd8", function(module, exports) {
$parcel$export(module.exports, "aiSurveyCreateRoute", () => $f0e8f9fac13f8d17$export$f3a6643850d23846);
const $f0e8f9fac13f8d17$export$f3a6643850d23846 = {
    path: '/jira/servicedesk/ai-create-survey',
    name: 'ai-survey-create',
    exact: true,
    query: [
        'parentProduct',
        'conversationChannelId',
        'projectId',
        'theme?',
        'messageId?'
    ]
};

});

parcelRegister("pICJV", function(module, exports) {
$parcel$export(module.exports, "aiSurveyCreatePageEntryPoint", () => $b33874c27b0d983f$export$bc04ee7e885b9038);

var $dArmM = parcelRequire("dArmM");

var $dTa0V = parcelRequire("dTa0V");
const $b33874c27b0d983f$export$bc04ee7e885b9038 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $dArmM.surveysEntryPoint)
});

});
parcelRegister("dArmM", function(module, exports) {
$parcel$export(module.exports, "surveysEntryPoint", () => $a71cd0bbb1fce0e9$export$afe6a4612d77e23e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $a71cd0bbb1fce0e9$export$afe6a4612d77e23e = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("h9oEj")), {
        moduleId: "d80a88ad",
        moduleName: "SmartSurveyCreate",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                context: context
            }
        })
});

});
parcelRegister("h9oEj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("834qq").then(()=>parcelRequire('gujGl'));

});




parcelRegister("5ia5u", function(module, exports) {
$parcel$export(module.exports, "alertPoliciesRouteEntry", () => $a5616e9911e775fd$export$eb1e2324ca2031e2);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $asdh0 = parcelRequire("asdh0");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $j0VPn = parcelRequire("j0VPn");

var $coId9 = parcelRequire("coId9");
const $a5616e9911e775fd$export$eb1e2324ca2031e2 = (0, $fdS54.createEntry)((0, $j0VPn.alertPoliciesRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $coId9.AlertPoliciesComponent),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $asdh0.resources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $coId9.LazyAlertPolicies),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $c2089d0a2d032c78$export$18c48dc6584a0abb = 'PEOPLE';

parcelRegister("2PaMI", function(module, exports) {
$parcel$export(module.exports, "LazyHorizontalOperationsNav", () => $c275eec0cf2ee7c5$export$409c821653bbc63b);
$parcel$export(module.exports, "LazyHorizontalOperationsOverviewNav", () => $c275eec0cf2ee7c5$export$82108adf6887e32e);
$parcel$export(module.exports, "AsyncHorizontalOperationsNav", () => $c275eec0cf2ee7c5$export$1eb785f071697cc5);
$parcel$export(module.exports, "AsyncHorizontalOperationsOverviewNav", () => $c275eec0cf2ee7c5$export$27e50c09ebb514f);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $c275eec0cf2ee7c5$export$409c821653bbc63b = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gHCCx")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-operations-container/src/ui/index.tsx"
});

const $c275eec0cf2ee7c5$export$82108adf6887e32e = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gHCCx")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-operations-container/src/ui/index.tsx"
});
const $c275eec0cf2ee7c5$export$1eb785f071697cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c275eec0cf2ee7c5$export$409c821653bbc63b, null)));
$c275eec0cf2ee7c5$export$1eb785f071697cc5.displayName = "AsyncHorizontalOperationsNav";
const $c275eec0cf2ee7c5$export$27e50c09ebb514f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-operations-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "asyncHorizontalOperationsOverviewNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c275eec0cf2ee7c5$export$82108adf6887e32e, null)));
$c275eec0cf2ee7c5$export$27e50c09ebb514f.displayName = "AsyncHorizontalOperationsOverviewNav";

});
parcelRegister("gHCCx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eMBdA").then(()=>parcelRequire('7Wqhg'));

});


parcelRegister("asdh0", function(module, exports) {
$parcel$export(module.exports, "teamPolicyResource", () => $1dcb74895ac6bcdb$export$10d7fa513f08ef83);
$parcel$export(module.exports, "notificationPolicyResource", () => $1dcb74895ac6bcdb$export$6d5f23d9118ad678);
$parcel$export(module.exports, "globalPolicyResource", () => $1dcb74895ac6bcdb$export$7aed80da979a5112);
$parcel$export(module.exports, "resources", () => $1dcb74895ac6bcdb$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $9dBqm = parcelRequire("9dBqm");
const $1dcb74895ac6bcdb$export$10d7fa513f08ef83 = (0, $7edbf.createResource)({
    type: 'teamPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-policy/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        // if there is no teamId, this means that we are on the global policy page.
        // so we can return null directly, instead of sending fetch request.
        if (!teamId) return null;
        return (0, $9dBqm.getTeamPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $1dcb74895ac6bcdb$export$6d5f23d9118ad678 = (0, $7edbf.createResource)({
    type: 'notificationPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `notification-policy/${teamId}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (!teamId) return;
        return (0, $9dBqm.getNotificationPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $1dcb74895ac6bcdb$export$7aed80da979a5112 = (0, $7edbf.createResource)({
    type: 'globalPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (teamId) return `global-policy/${teamId}`;
        return 'global-policy';
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $9dBqm.getGlobalPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $1dcb74895ac6bcdb$export$4cb385c2db8b1e99 = (0, $7edbf.createResource)({
    type: 'policyMaintenanceRightsResource',
    getKey: ()=>'policy-maintenance-rights-resource',
    getData: async ()=>{
        return (0, $9dBqm.getPolicyMaintenanceRights)();
    },
    isBrowserOnly: true
});
const $1dcb74895ac6bcdb$export$bc99aaabaf7b70a7 = ()=>[
        $1dcb74895ac6bcdb$export$10d7fa513f08ef83,
        $1dcb74895ac6bcdb$export$7aed80da979a5112,
        $1dcb74895ac6bcdb$export$4cb385c2db8b1e99,
        $1dcb74895ac6bcdb$export$6d5f23d9118ad678
    ];

});
parcelRegister("9dBqm", function(module, exports) {
$parcel$export(module.exports, "getTeamPolicies", () => $490317d69bf0676b$export$fead0944caa1c797);
$parcel$export(module.exports, "getGlobalPolicies", () => $490317d69bf0676b$export$17fc7fbef061a8c3);
$parcel$export(module.exports, "getNotificationPolicies", () => $490317d69bf0676b$export$342525d9423e55ad);
$parcel$export(module.exports, "getPolicyMaintenanceRights", () => $490317d69bf0676b$export$f630cbf5586dce0a);
$parcel$export(module.exports, "updateUIPreferenceEndpoint", () => $490317d69bf0676b$export$6a437b43ab11275d);
$parcel$export(module.exports, "changePolicyOrderEndpoint", () => $490317d69bf0676b$export$57186d786c96b52a);
$parcel$export(module.exports, "enablePolicyEndpoint", () => $490317d69bf0676b$export$6fecd226d8e55346);
$parcel$export(module.exports, "disablePolicyEndpoint", () => $490317d69bf0676b$export$8c0cd218e00b7d9b);
$parcel$export(module.exports, "deletePolicyEndpoint", () => $490317d69bf0676b$export$f9feac6c1dcc516f);
$parcel$export(module.exports, "createPolicyEndpoint", () => $490317d69bf0676b$export$b0108c51b962e788);
$parcel$export(module.exports, "updatePolicyEndpoint", () => $490317d69bf0676b$export$8eabce250a2dd205);

var $hG5S4 = parcelRequire("hG5S4");
const $490317d69bf0676b$export$fead0944caa1c797 = (teamId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
};
const $490317d69bf0676b$export$17fc7fbef061a8c3 = (teamId)=>{
    if (teamId) return (0, $hG5S4.eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
    return (0, $hG5S4.eocFetch)(`/v1/alerts/policies`);
};
const $490317d69bf0676b$export$342525d9423e55ad = (teamId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
};
const $490317d69bf0676b$export$f630cbf5586dce0a = ()=>{
    return (0, $hG5S4.eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
const $490317d69bf0676b$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
    let url = `/v1/alerts/ui-preferences/policies`;
    if (teamId) url = `${url}?teamId=${teamId}`;
    return (0, $hG5S4.eocFetch)(url, {
        method: 'PATCH',
        body: payload,
        responseType: 'headers'
    });
};
const $490317d69bf0676b$export$57186d786c96b52a = (payload)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
        method: 'PATCH',
        body: {
            after: payload.after
        },
        responseType: 'headers'
    });
};
const $490317d69bf0676b$export$6fecd226d8e55346 = (payload)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $490317d69bf0676b$export$8c0cd218e00b7d9b = (payload)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $490317d69bf0676b$export$f9feac6c1dcc516f = (payload)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $490317d69bf0676b$export$b0108c51b962e788 = (payload)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
        method: 'POST',
        body: payload
    });
};
const $490317d69bf0676b$export$8eabce250a2dd205 = (payload)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("7EF5l", function(module, exports) {
$parcel$export(module.exports, "teamResource", () => $27d65cf9e7c02507$export$87453d709b90ccdf);
$parcel$export(module.exports, "sidebarRightsResource", () => $27d65cf9e7c02507$export$3b3b9a5b0eddde66);
$parcel$export(module.exports, "resources", () => $27d65cf9e7c02507$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $1Dmlw = parcelRequire("1Dmlw");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $2eC9P = parcelRequire("2eC9P");
const $27d65cf9e7c02507$export$87453d709b90ccdf = (0, $7edbf.createResource)({
    type: 'teamResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
        return (0, $2eC9P.getTeamByIdEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    maxAge: 300000,
    isBrowserOnly: true
});
const $27d65cf9e7c02507$export$3b3b9a5b0eddde66 = (0, $7edbf.createResource)({
    type: 'sidebarRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
        return (0, $2eC9P.getSidebarRightsEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $27d65cf9e7c02507$export$bc99aaabaf7b70a7 = ()=>[
        $27d65cf9e7c02507$export$87453d709b90ccdf,
        $27d65cf9e7c02507$export$3b3b9a5b0eddde66,
        (0, $1Dmlw.groupCustomizationFeatureStateResource)
    ];

});
parcelRegister("1Dmlw", function(module, exports) {
$parcel$export(module.exports, "groupCustomizationFeatureStateResource", () => $0e72d7287cb31e2a$export$f4121e3844322d38);

var $7edbf = parcelRequire("7edbf");

var $bCpX8 = parcelRequire("bCpX8");
const $0e72d7287cb31e2a$export$f4121e3844322d38 = (0, $7edbf.createResource)({
    type: 'groupCustomizationFeatureStateResource',
    getKey: ()=>`groupCustomizationFeatureStateResource`,
    getData: async ()=>{
        try {
            const response = await (0, $bCpX8.getGroupCustomizationFeatureState)();
            return response;
        } catch  {
            return {
                isEnabled: false
            };
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("bCpX8", function(module, exports) {
$parcel$export(module.exports, "getGroupCustomizationFeatureState", () => $0f6aad37d3ac84c9$export$caed39de03daeaee);

var $lFnrZ = parcelRequire("lFnrZ");

var $hG5S4 = parcelRequire("hG5S4");
const $0f6aad37d3ac84c9$export$caed39de03daeaee = ()=>{
    return (0, $hG5S4.eocFetch)((0, $lFnrZ.withAIOpsDomainPrefix)('/v1/aiops/feature-state?featureName=alert-group-customization'), {
        exactUrl: true
    });
};

});
parcelRegister("lFnrZ", function(module, exports) {
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $48ec5aca90ba8e1e$export$81c70e0016508593);

var $7nxyA = parcelRequire("7nxyA");
const $48ec5aca90ba8e1e$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $7nxyA.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("7Ljuo", function(module, exports) {
$parcel$export(module.exports, "assert", () => $74115108c9b52c1d$export$a7a9523472993e97);

var $jpT5w = parcelRequire("jpT5w");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $74115108c9b52c1d$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("jpT5w", function(module, exports) {
$parcel$export(module.exports, "AssertionError", () => $200613c788ada549$export$7750cdfb4db2c3d);
class $200613c788ada549$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`), this.id = id;
    }
}

});


parcelRegister("2eC9P", function(module, exports) {
$parcel$export(module.exports, "getTeamByIdEndpoint", () => $2327057184c908a4$export$bcb25b347f39b3f3);
$parcel$export(module.exports, "getSidebarRightsEndpoint", () => $2327057184c908a4$export$6f1f62156c62eb91);

var $hG5S4 = parcelRequire("hG5S4");
const $2327057184c908a4$export$bcb25b347f39b3f3 = (teamId)=>(0, $hG5S4.eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
const $2327057184c908a4$export$6f1f62156c62eb91 = (teamId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/teams/${teamId}/menu-rights`);
};

});


parcelRegister("jEYuY", function(module, exports) {
$parcel$export(module.exports, "LazyAtlassianNavigation", () => $50d63b4e483e128d$export$4caed23aa0274abb);
/* eslint-disable jira/filename-case */ 
var $lhWE3 = parcelRequire("lhWE3");

var $iLktG = parcelRequire("iLktG");

var $l8G1z = parcelRequire("l8G1z");

const $50d63b4e483e128d$export$4caed23aa0274abb = (0, $l8G1z.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("gCmql"))).then(({ TopNavigation: TopNavigation })=>TopNavigation);
    if (!false) bundleReady.then(()=>{
        (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $lhWE3.JS_EVAL_START))) {
            (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/TopNavigation.tsx"
});

});
parcelRegister("iLktG", function(module, exports) {
$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $68817ce7e8900032$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $68817ce7e8900032$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $68817ce7e8900032$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $68817ce7e8900032$export$de1b4cf109d9ab65);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9dSZE = parcelRequire("9dSZE");

var $9yf7o = parcelRequire("9yf7o");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $68817ce7e8900032$var$safeMeasure = (name, start, stop)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.measure(name, start, stop);
    // eslint-disable-next-line no-empty
    } catch (_err) {} // oxlint-disable-line @typescript-eslint/no-explicit-any
};
const $68817ce7e8900032$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $68817ce7e8900032$var$safeMeasure(name, start, stop);
    (0, $9yf7o.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $9dSZE.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $68817ce7e8900032$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $68817ce7e8900032$var$safeMeasure(name, start, stopMark);
    (0, $9yf7o.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $9dSZE.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $68817ce7e8900032$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $68817ce7e8900032$var$safeMeasure(name, startMark, stopMark);
    (0, $9yf7o.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $9dSZE.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $68817ce7e8900032$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $9yf7o.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $9dSZE.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $68817ce7e8900032$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $68817ce7e8900032$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});
parcelRegister("9dSZE", function(module, exports) {
$parcel$export(module.exports, "addTimingFromPerformanceMark", () => $a40b4fb087d923e9$export$758b9a33800fa436);
$parcel$export(module.exports, "getTimings", () => $a40b4fb087d923e9$export$6d488733a547304);
const $a40b4fb087d923e9$var$timings = [];
function $a40b4fb087d923e9$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $a40b4fb087d923e9$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $a40b4fb087d923e9$export$6d488733a547304() {
    const reportedTimingsObj = {};
    $a40b4fb087d923e9$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});



parcelRegister("jyp1t", function(module, exports) {
$parcel$export(module.exports, "LazyTeamDashboardSidebar", () => $200cbe9f26f96da3$export$a1b7c53ff39475a6);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $aTk1I = parcelRequire("aTk1I");

var $cz8BN = parcelRequire("cz8BN");

var $l8G1z = parcelRequire("l8G1z");

const $200cbe9f26f96da3$export$a1b7c53ff39475a6 = (0, $l8G1z.lazyForPaint)(()=>{
    (0, $cz8BN.setPerformanceMarkLoadStart)();
    return (parcelRequire("5koXb")).then((bundle)=>{
        (0, $cz8BN.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar-eoc-team-dashboard/src/index.tsx"
});
const $200cbe9f26f96da3$var$TeamDashboardSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aTk1I.SidebarBoundary), {
        id: "eocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($200cbe9f26f96da3$export$a1b7c53ff39475a6, null));
$200cbe9f26f96da3$var$TeamDashboardSidebar.displayName = "TeamDashboardSidebar";
$200cbe9f26f96da3$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
var $200cbe9f26f96da3$export$2e2bcd8739ae039 = $200cbe9f26f96da3$var$TeamDashboardSidebar;

});
parcelRegister("aTk1I", function(module, exports) {
$parcel$export(module.exports, "SidebarBoundary", () => $5c9a1d20667abc09$export$1edc778464f08256);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $2D2gW = parcelRequire("2D2gW");

var $3Fe8l = parcelRequire("3Fe8l");

var $hiFKm = parcelRequire("hiFKm");

var $a8EUd = parcelRequire("a8EUd");

var $gDdYI = parcelRequire("gDdYI");

var $76BtG = parcelRequire("76BtG");

var $eiI8p = parcelRequire("eiI8p");

var $hp8UB = parcelRequire("hp8UB");
const $5c9a1d20667abc09$export$1edc778464f08256 = (t0)=>{
    const $ = (0, $e7boj.c)(11);
    const { children: children, id: id } = t0;
    const onFail = (0, $eiI8p.useSidebarFail)();
    const onSuccess = (0, $eiI8p.useSidebarSuccess)();
    let t1;
    if ($[0] !== onFail || $[1] !== onSuccess) {
        t1 = (location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
            else onFail(location, error);
        };
        $[0] = onFail;
        $[1] = onSuccess;
        $[2] = t1;
    } else t1 = $[2];
    const onError = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hiFKm.NavSidebarPerformanceMark), {
            metricKey: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderAttempt
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
            name: "nav-sidebar-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hp8UB.Skeleton), {
            isFull: true
        }));
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
            name: "nav-sidebar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "nav-sidebar",
            fallback: t3
        }, children));
        $[5] = children;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== id || $[8] !== onError || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $76BtG.SidebarErrorBoundary), {
            id: id,
            packageName: "jiraSpaAppsSidebarCommon",
            onError: onError
        }, t2, t4);
        $[7] = id;
        $[8] = onError;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};
$5c9a1d20667abc09$export$1edc778464f08256.displayName = "SidebarBoundary";

});
parcelRegister("3Fe8l", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $e37dc83e04f5b0ac$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $e37dc83e04f5b0ac$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $e37dc83e04f5b0ac$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $e37dc83e04f5b0ac$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $e37dc83e04f5b0ac$export$1d10ee0c85c3cb21);
/* eslint-disable jira/filename-case */ const $e37dc83e04f5b0ac$export$6635720e40ea7a7a = 'navigation.top';
const $e37dc83e04f5b0ac$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $e37dc83e04f5b0ac$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $e37dc83e04f5b0ac$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $e37dc83e04f5b0ac$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});

parcelRegister("hiFKm", function(module, exports) {
$parcel$export(module.exports, "pageSegmentStore", () => $71bd22fa50e94592$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $71bd22fa50e94592$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $71bd22fa50e94592$export$a018e347341b3640);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $cY22M = parcelRequire("cY22M");

var $jvGCa = parcelRequire("jvGCa");

var $41zzZ = parcelRequire("41zzZ");

var $7RqDz = parcelRequire("7RqDz");

var $3Fe8l = parcelRequire("3Fe8l");

const $71bd22fa50e94592$var$createTopNavPageSegment = ()=>(0, $jvGCa.metrics).pageSegmentLoad({
        key: (0, $3Fe8l.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $3Fe8l.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $3Fe8l.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $3Fe8l.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $3Fe8l.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $3Fe8l.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $3Fe8l.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $3Fe8l.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $3Fe8l.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $71bd22fa50e94592$export$8df02628d98cae7e = {
    ADDONS: (0, $jvGCa.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $71bd22fa50e94592$var$createSidebarPageSegment = ()=>(0, $jvGCa.metrics).pageSegmentLoad({
        key: (0, $3Fe8l.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $71bd22fa50e94592$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $3Fe8l.NAVIGATION_TOP_SEGMENT_NAME)]: $71bd22fa50e94592$var$createTopNavPageSegment,
        [(0, $3Fe8l.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $71bd22fa50e94592$var$createSidebarPageSegment
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $71bd22fa50e94592$export$906025848d54198d = (segmentKey = (0, $3Fe8l.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $euxye.useRef)(false);
    const segment = (0, $euxye.useRef)($71bd22fa50e94592$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $euxye.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $3Fe8l.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))((0, $7RqDz.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $71bd22fa50e94592$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $71bd22fa50e94592$export$906025848d54198d(segmentKey);
    (0, $euxye.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
$71bd22fa50e94592$var$NavigationPerformanceMark.displayName = "NavigationPerformanceMark";
const $71bd22fa50e94592$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $71bd22fa50e94592$export$906025848d54198d(segmentKey);
    (0, $euxye.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $41zzZ.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
$71bd22fa50e94592$var$NavigationPerformanceReport.displayName = "NavigationPerformanceReport";
const $71bd22fa50e94592$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($71bd22fa50e94592$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $3Fe8l.NAVIGATION_TOP_SEGMENT_NAME)
    });
$71bd22fa50e94592$export$b7f4caa65b0906fc.displayName = "NavTopPerformanceMark";
const $71bd22fa50e94592$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($71bd22fa50e94592$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $3Fe8l.NAVIGATION_TOP_SEGMENT_NAME)
    });
$71bd22fa50e94592$export$c64b31449a6177d.displayName = "NavTopPerformanceReport";
const $71bd22fa50e94592$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($71bd22fa50e94592$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $3Fe8l.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
$71bd22fa50e94592$export$35b2aeea5cbc963e.displayName = "NavSidebarPerformanceMark";
const $71bd22fa50e94592$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($71bd22fa50e94592$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $3Fe8l.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
$71bd22fa50e94592$export$a018e347341b3640.displayName = "NavSidebarPerformanceReport";

});
parcelRegister("7RqDz", function(module, exports) {
$parcel$export(module.exports, "RenderTracerMark", () => $7832ebcfc8c38e63$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $7832ebcfc8c38e63$export$345f21b0287f67e5);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1RSwr = parcelRequire("1RSwr");

var $cY22M = parcelRequire("cY22M");

var $rRglf = parcelRequire("rRglf");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

const $7832ebcfc8c38e63$var$initialState = {
    start: undefined,
    traces: {}
};
let $7832ebcfc8c38e63$var$currentTraces = {};
const $7832ebcfc8c38e63$export$2365ecd8218e21c7 = ()=>$7832ebcfc8c38e63$var$currentTraces;
const $7832ebcfc8c38e63$export$5c757eaa1990d0d7 = (key)=>{
    if ($7832ebcfc8c38e63$var$currentTraces[key]) return;
    $7832ebcfc8c38e63$var$currentTraces[key] = {
        startTime: (0, $rRglf.performance).now()
    };
};
const $7832ebcfc8c38e63$export$16854dc18f8d976 = (key)=>{
    if (!$7832ebcfc8c38e63$var$currentTraces[key] || $7832ebcfc8c38e63$var$currentTraces[key].duration != null) return;
    $7832ebcfc8c38e63$var$currentTraces[key].duration = (0, $rRglf.performance).now() - $7832ebcfc8c38e63$var$currentTraces[key].startTime;
};
const $7832ebcfc8c38e63$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($1RSwr)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($1RSwr)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $7832ebcfc8c38e63$var$currentTraces = Object.assign($7832ebcfc8c38e63$var$currentTraces, getState().traces);
        }
};
const $7832ebcfc8c38e63$var$Store = (0, $5QDqc.createStore)({
    name: 'jira-render-tracer',
    initialState: $7832ebcfc8c38e63$var$initialState,
    actions: $7832ebcfc8c38e63$var$actions
});
const $7832ebcfc8c38e63$var$RenderTracerActions = (0, $iGu4q.createSubscriber)($7832ebcfc8c38e63$var$Store, {
    selector: null
});
const $7832ebcfc8c38e63$export$719a95758870be58 = (0, $3h1FP.createHook)($7832ebcfc8c38e63$var$Store, {
    selector: null
});
const $7832ebcfc8c38e63$var$RenderTracerContainerBase = (0, $dB6ay.createContainer)($7832ebcfc8c38e63$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $rRglf.performance).now()
                    }
                }
            });
        }
});
const $7832ebcfc8c38e63$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7832ebcfc8c38e63$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7832ebcfc8c38e63$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
$7832ebcfc8c38e63$export$37d31bee41ca1401.displayName = "RenderTracerContainer";
const $7832ebcfc8c38e63$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7832ebcfc8c38e63$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $rRglf.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $rRglf.performance).now());
        return null;
    });
$7832ebcfc8c38e63$export$54c89059bb435049.displayName = "RenderTracerMark";
const $7832ebcfc8c38e63$export$cba8addc8743389c = (appName = 'unknown', traces = $7832ebcfc8c38e63$var$currentTraces)=>({
        [(0, $1006d3854e46ef50$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $7832ebcfc8c38e63$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $1006d3854e46ef50$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("1RSwr", function(module, exports) {

var $7b634 = parcelRequire("7b634");

var $8b2ec = parcelRequire("8b2ec");

var $luC8x = parcelRequire("luC8x");

var $dWb9x = parcelRequire("dWb9x");

var $hWHnZ = parcelRequire("hWHnZ");

var $k4FO8 = parcelRequire("k4FO8");
/** Used for built-in method references. */ var $15c508a5c5cc83e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $15c508a5c5cc83e8$var$hasOwnProperty = $15c508a5c5cc83e8$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $15c508a5c5cc83e8$var$assign = $luC8x(function(object, source) {
    if ($hWHnZ(source) || $dWb9x(source)) {
        $8b2ec(source, $k4FO8(source), object);
        return;
    }
    for(var key in source)if ($15c508a5c5cc83e8$var$hasOwnProperty.call(source, key)) $7b634(object, key, source[key]);
});
module.exports = $15c508a5c5cc83e8$var$assign;

});

parcelRegister("rRglf", function(module, exports) {
$parcel$export(module.exports, "performance", () => $a5952164a465e9de$export$f2d2284f5fec51f8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $a5952164a465e9de$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $a5952164a465e9de$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $a5952164a465e9de$var$now();
    }
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    now() {
        if (false) return $a5952164a465e9de$var$now() - this.startAt;
        return $a5952164a465e9de$var$now();
    }
    constructor(){
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        this.startAt = $a5952164a465e9de$var$now();
    }
}
$a5952164a465e9de$export$9a0dbed22cbf63be.displayName = "RuntimePerformance";
const $a5952164a465e9de$export$f2d2284f5fec51f8 = new $a5952164a465e9de$export$9a0dbed22cbf63be();

});

/* eslint-disable jira/filename-case */ const $1006d3854e46ef50$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';



parcelRegister("gDdYI", function(module, exports) {
$parcel$export(module.exports, "UFOThirdPartySegment", () => $0bb9ab57306dfa21$export$5f6fe75c46d0124e);
$parcel$export(module.exports, "UFOSegment", () => $0bb9ab57306dfa21$export$2c976980ee6932e3);
$parcel$export(module.exports, "default", () => $0bb9ab57306dfa21$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $4FR7Y = parcelRequire("4FR7Y");

var $siTdT = parcelRequire("siTdT");

var $3BBB7 = parcelRequire("3BBB7");
var $8DG7p = parcelRequire("8DG7p");

var $gQRLr = parcelRequire("gQRLr");

var $i860n = parcelRequire("i860n");

var $jepRN = parcelRequire("jepRN");

var $f4iA6 = parcelRequire("f4iA6");

var $j92Gr = parcelRequire("j92Gr");
/** A portion of the page we apply measurement to */ function $0bb9ab57306dfa21$var$JiraUFOSegmentWrapper({ children: children }) {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const interactionContext = (0, $4FR7Y.useInteractionContext)();
    const relayProfilerContext = (0, $euxye.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $euxye.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $i860n.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $siTdT.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $i860n.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $i860n.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $siTdT.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    // Moved the SsrRenderProfiler to the platform version of UFO segment
    if ((0, $i860n.fg)('platform_ufo_ssr_render_profiler')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gQRLr.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j92Gr.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gQRLr.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
$0bb9ab57306dfa21$var$JiraUFOSegmentWrapper.displayName = "JiraUFOSegmentWrapper";
function $0bb9ab57306dfa21$var$JiraUFOSegment({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3BBB7.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0bb9ab57306dfa21$var$JiraUFOSegmentWrapper, null, children));
}
$0bb9ab57306dfa21$var$JiraUFOSegment.displayName = "JiraUFOSegment";
const $0bb9ab57306dfa21$var$WrappedUFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', 'data-path': dataPath })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3BBB7.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f4iA6.DEBUGUFOSegmentHighlight), {
        name: segmentName,
        "data-path": dataPath
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0bb9ab57306dfa21$var$JiraUFOSegmentWrapper, null, children)));
};
$0bb9ab57306dfa21$var$WrappedUFOSegment.displayName = "WrappedUFOSegment";
const $0bb9ab57306dfa21$var$WrappedThirdPartyUFOSegment = ({ name: segmentName, children: children, 'data-path': dataPath })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f4iA6.DEBUGUFOSegmentHighlight), {
        name: segmentName,
        isThirdPartySegment: true,
        "data-path": dataPath
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8DG7p.UFOThirdPartySegment), {
        name: segmentName
    }, children));
};
$0bb9ab57306dfa21$var$WrappedThirdPartyUFOSegment.displayName = "WrappedThirdPartyUFOSegment";
const $0bb9ab57306dfa21$export$5f6fe75c46d0124e = (0, $jepRN.componentWithFG)('jira_highlight_ufo_segments', $0bb9ab57306dfa21$var$WrappedThirdPartyUFOSegment, (0, $8DG7p.UFOThirdPartySegment));
const $0bb9ab57306dfa21$export$2c976980ee6932e3 = (0, $jepRN.componentWithFG)('jira_highlight_ufo_segments', $0bb9ab57306dfa21$var$WrappedUFOSegment, $0bb9ab57306dfa21$var$JiraUFOSegment);
var $0bb9ab57306dfa21$export$2e2bcd8739ae039 = $0bb9ab57306dfa21$export$2c976980ee6932e3;

});
parcelRegister("f4iA6", function(module, exports) {
$parcel$export(module.exports, "DEBUGUFOSegmentHighlight", () => $1dbc22bd4fdc867b$export$b40753685e6a8303);
/* DEBUGUFOSegmentHighlight.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $l6bTn = parcelRequire("l6bTn");
const $1dbc22bd4fdc867b$export$b40753685e6a8303 = (props)=>{
    const [showUFOSegments] = (0, $l6bTn.useShowUFOSegmentsState)();
    // Always add data-boundary when FG is on, but only show visual highlights when showUFOSegments is true
    if (!showUFOSegments) {
        if (props.isThirdPartySegment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1dbc22bd4fdc867b$var$ThirdPartyUfoSegmentWrapperWithBoundary, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1dbc22bd4fdc867b$var$UfoSegmentWrapperWithBoundary, props);
    }
    if (props.isThirdPartySegment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1dbc22bd4fdc867b$var$ThirdPartyUfoSegmentWrapperWithHighlight, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1dbc22bd4fdc867b$var$UfoSegmentWrapperWithHighlight, props);
};
$1dbc22bd4fdc867b$export$b40753685e6a8303.displayName = "DEBUGUFOSegmentHighlight";
/**
 * used only on staging with jira_highlight_ufo_segments fg to add data-boundary without visual styling
 * Uses display: contents to avoid layout impact
 */ const $1dbc22bd4fdc867b$var$ThirdPartyUfoSegmentWrapperWithBoundary = ({ children: children, name: name, 'data-path': dataPath })=>{
    const containerRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!containerRef.current) return;
        const parent = containerRef.current.parentElement;
        const hasPageLayoutRoot = parent?.matches('[id="unsafe-design-system-page-layout-root"]');
        if (!hasPageLayoutRoot) return;
        // Whatever we render, if it is a immediate child of PageLayout (Root), it needs to have
        // the data-layout-slot attribute for it to be visible.
        containerRef.current.setAttribute('data-layout-slot', 'true');
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-boundary": "true",
        "data-ufo-segment": name,
        "data-third-party-segment": "true",
        "data-path": dataPath,
        ref: containerRef,
        className: (0, $4jQY2.default)([
            "_1e0c1bgi"
        ])
    }, children);
};
$1dbc22bd4fdc867b$var$ThirdPartyUfoSegmentWrapperWithBoundary.displayName = "ThirdPartyUfoSegmentWrapperWithBoundary";
/**
 * used only on staging with jira_highlight_ufo_segments fg to add data-boundary without visual styling
 * Uses display: contents to avoid layout impact
 */ const $1dbc22bd4fdc867b$var$UfoSegmentWrapperWithBoundary = ({ children: children, name: name, 'data-path': dataPath })=>{
    const containerRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!containerRef.current) return;
        const parent = containerRef.current.parentElement;
        const hasPageLayoutRoot = parent?.matches('[id="unsafe-design-system-page-layout-root"]');
        if (!hasPageLayoutRoot) return;
        // Whatever we render, if it is a immediate child of PageLayout (Root), it needs to have
        // the data-layout-slot attribute for it to be visible.
        containerRef.current.setAttribute('data-layout-slot', 'true');
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-boundary": "true",
        "data-ufo-segment": name,
        "data-path": dataPath,
        ref: containerRef,
        className: (0, $4jQY2.default)([
            "_1e0c1bgi"
        ])
    }, children);
};
$1dbc22bd4fdc867b$var$UfoSegmentWrapperWithBoundary.displayName = "UfoSegmentWrapperWithBoundary";
/**
 * used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 */ const $1dbc22bd4fdc867b$var$ThirdPartyUfoSegmentWrapperWithHighlight = ({ children: children, name: name, 'data-path': dataPath })=>{
    const thirdPartySegmentName = `thirdPartySegment ${name}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $1dbc22bd4fdc867b$var$borderStylesBlack,
        "data-boundary": "true",
        "data-ufo-segment": name,
        "data-third-party-segment": "true",
        "data-path": dataPath
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
        className: (0, $4jQY2.default)([
            "_kqswh2mm _syazi7uo _1e0c1txw _1bah1h6o"
        ])
    }, thirdPartySegmentName), children);
};
$1dbc22bd4fdc867b$var$ThirdPartyUfoSegmentWrapperWithHighlight.displayName = "ThirdPartyUfoSegmentWrapperWithHighlight";
/**
 * used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 */ const $1dbc22bd4fdc867b$var$UfoSegmentWrapperWithHighlight = ({ children: children, name: name, 'data-path': dataPath })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $1dbc22bd4fdc867b$var$borderStylesBlue,
        "data-boundary": "true",
        "data-ufo-segment": name,
        "data-path": dataPath
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
        className: (0, $4jQY2.default)([
            "_kqswh2mm _syaz16jw _1e0c1txw _1bah1h6o"
        ])
    }, name), children);
};
$1dbc22bd4fdc867b$var$UfoSegmentWrapperWithHighlight.displayName = "UfoSegmentWrapperWithHighlight";
const $1dbc22bd4fdc867b$var$textStylesBlue = null;
const $1dbc22bd4fdc867b$var$borderStylesBlue = (0, $fbAgj.xcss)({
    border: `${"var(--ds-border-width-selected, 2px)"} solid blue`,
    borderRadius: 'radius.small',
    padding: 'space.100'
});
const $1dbc22bd4fdc867b$var$textStylesBlack = null;
const $1dbc22bd4fdc867b$var$borderStylesBlack = (0, $fbAgj.xcss)({
    border: `${"var(--ds-border-width-selected, 2px)"} solid black`,
    borderRadius: 'radius.small',
    padding: 'space.100'
});
// CSS for invisible wrapper (no layout impact)
const $1dbc22bd4fdc867b$var$invisibleWrapperStyles = null;

});
parcelRegister("l6bTn", function(module, exports) {
$parcel$export(module.exports, "useShowUFOSegmentsState", () => $95c9794ebf50bdff$export$99730ac308228c00);

var $euxye = parcelRequire("euxye");
// Singleton state manager for UFO segments
// This file should never be included in production code, do not add production code here
class $95c9794ebf50bdff$var$UFODebugState {
    static getInstance() {
        if (!$95c9794ebf50bdff$var$UFODebugState.instance) $95c9794ebf50bdff$var$UFODebugState.instance = new $95c9794ebf50bdff$var$UFODebugState();
        return $95c9794ebf50bdff$var$UFODebugState.instance;
    }
    getState() {
        return this.state;
    }
    setState(newState) {
        if (this.state !== newState) {
            this.state = newState;
            this.notifyListeners();
        }
    }
    subscribe(listener) {
        this.listeners.add(listener);
        // Set up global methods only once
        if (!this.globalMethodsSet) {
            this.setupGlobalMethods();
            this.globalMethodsSet = true;
        }
        // Return unsubscribe function
        return ()=>{
            this.listeners.delete(listener);
        };
    }
    notifyListeners() {
        this.listeners.forEach((listener)=>listener(this.state));
    }
    setupGlobalMethods() {
        // @ts-expect-error This file should never be included in production code so we dont want to type globalThis as it shouldnt know about it
        globalThis.showUfoSegments = ()=>{
            this.setState(true);
            return 'Showing ufo segments';
        };
        // @ts-expect-error This file should never be included in production code so we dont want to type globalThis as it shouldnt know about it
        globalThis.hideUFOSegments = ()=>{
            this.setState(false);
            return 'Hiding ufo segments';
        };
    }
    constructor(){
        this.state = false;
        this.listeners = new Set();
        this.globalMethodsSet = false;
    }
}
$95c9794ebf50bdff$var$UFODebugState.displayName = "UFODebugState";
function $95c9794ebf50bdff$export$99730ac308228c00() {
    const manager = $95c9794ebf50bdff$var$UFODebugState.getInstance();
    const [state, setState] = (0, $euxye.useState)(manager.getState());
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = manager.subscribe(setState);
        return ()=>{
            unsubscribe();
        };
    }, [
        manager
    ]);
    return [
        state,
        setState
    ];
}

});


parcelRegister("j92Gr", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbd4639faa9a81d5$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $siTdT = parcelRequire("siTdT");

var $gXtG2 = parcelRequire("gXtG2");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $bbd4639faa9a81d5$var$startTimes = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $bbd4639faa9a81d5$var$startTimes.clear();
});
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $bbd4639faa9a81d5$var$lastActiveInteraction;
function $bbd4639faa9a81d5$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $siTdT.getActiveInteraction)()?.id;
    if (!!$bbd4639faa9a81d5$var$lastActiveInteraction && $bbd4639faa9a81d5$var$lastActiveInteraction !== activeInteractionId) $bbd4639faa9a81d5$var$startTimes.clear();
    $bbd4639faa9a81d5$var$lastActiveInteraction = activeInteractionId;
}
const $bbd4639faa9a81d5$var$onStartRender = (id)=>{
    if (!$bbd4639faa9a81d5$var$startTimes.has(id)) $bbd4639faa9a81d5$var$startTimes.set(id, []);
    $bbd4639faa9a81d5$var$startTimes.get(id)?.push(performance.now());
};
const $bbd4639faa9a81d5$var$ProfilerMarker = ({ onRender: onRender })=>{
    if (false) onRender?.();
    return null;
};
const $bbd4639faa9a81d5$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $euxye.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    $bbd4639faa9a81d5$var$checkActiveInteractionAndResetStartMarksIfSet();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bbd4639faa9a81d5$var$ProfilerMarker, {
        onRender: ()=>$bbd4639faa9a81d5$var$onStartRender(reactProfilerId)
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bbd4639faa9a81d5$var$ProfilerMarker, {
        onRender: ()=>{
            const startTimesForId = $bbd4639faa9a81d5$var$startTimes.get(reactProfilerId);
            if (startTimesForId?.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', actualDuration, baseDuration, firstStartTime, endTime);
            }
        }
    }));
};
$bbd4639faa9a81d5$export$b8bd105b650b1c1e.displayName = "SsrRenderProfilerInner";
const $bbd4639faa9a81d5$var$SsrRenderProfiler = (props)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bbd4639faa9a81d5$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bbd4639faa9a81d5$var$ProfilerMarker, null), props.children);
};
$bbd4639faa9a81d5$var$SsrRenderProfiler.displayName = "SsrRenderProfiler";
var $bbd4639faa9a81d5$export$2e2bcd8739ae039 = $bbd4639faa9a81d5$var$SsrRenderProfiler;

});


parcelRegister("76BtG", function(module, exports) {
$parcel$export(module.exports, "SidebarErrorBoundary", () => $74ed6d651d9d9907$export$62853c5766dad0c4);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $41zzZ = parcelRequire("41zzZ");

var $8W7iT = parcelRequire("8W7iT");
const $74ed6d651d9d9907$export$62853c5766dad0c4 = (props)=>{
    const $ = (0, $e7boj.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $41zzZ.getUserLocation)();
        $[0] = t0;
    } else t0 = $[0];
    const userLocation = t0;
    let t1;
    if ($[1] !== props.extraEventData) {
        t1 = {
            ...props.extraEventData,
            userLocation: userLocation
        };
        $[1] = props.extraEventData;
        $[2] = t1;
    } else t1 = $[2];
    const extraEventData = t1;
    const fallback = $74ed6d651d9d9907$var$_temp;
    let t2;
    if ($[3] !== extraEventData || $[4] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            ...props,
            extraEventData: extraEventData,
            fallback: fallback
        });
        $[3] = extraEventData;
        $[4] = props;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
$74ed6d651d9d9907$export$62853c5766dad0c4.displayName = "SidebarErrorBoundary";
function $74ed6d651d9d9907$var$_temp(t0) {
    const { error: error } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8W7iT.Fallback), {
        error: error
    });
}

});
parcelRegister("8W7iT", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $53f87941ff586a2f$export$fb8d7f40caaeea67);

var $e7boj = parcelRequire("e7boj");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $eXdAp = parcelRequire("eXdAp");

var $2iotI = parcelRequire("2iotI");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $k1NiR = parcelRequire("k1NiR");
const $53f87941ff586a2f$var$errorHeading = (0, $7eNDO.defineMessage)({
    id: "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Something went wrong"
});
const $53f87941ff586a2f$var$errorBody = (0, $7eNDO.defineMessage)({
    id: "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Try refreshing or navigating to another page."
});
const $53f87941ff586a2f$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rkowr30 _11c8wadc _syaz1rpy _bfhk7qp0 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $53f87941ff586a2f$export$fb8d7f40caaeea67 = (props)=>{
    const $ = (0, $e7boj.c)(19);
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $4jQY2.default)([
            $53f87941ff586a2f$var$styles.wrapper
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("img", {
            alt: "",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($k1NiR))),
            className: (0, $4jQY2.default)([
                $53f87941ff586a2f$var$styles.image
            ])
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage($53f87941ff586a2f$var$errorHeading);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
            size: "xsmall"
        }, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage($53f87941ff586a2f$var$errorBody);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t4);
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $4jQY2.default)([
            $53f87941ff586a2f$var$styles.error
        ]);
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== error) {
        t7 = (0, $eXdAp.getErrorHash)(error);
        $[11] = error;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("code", {
            className: t6
        }, "ERROR: ", t7);
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t3 || $[16] !== t5 || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
            className: t0
        }, t1, t3, t5, t8);
        $[15] = t3;
        $[16] = t5;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
};
$53f87941ff586a2f$export$fb8d7f40caaeea67.displayName = "Fallback";

});
parcelRegister("k1NiR", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});



parcelRegister("eiI8p", function(module, exports) {
$parcel$export(module.exports, "SidebarRenderStart", () => $c859158f09e2bd72$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $c859158f09e2bd72$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $c859158f09e2bd72$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $c859158f09e2bd72$export$ddb17534fdfb7dc6);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $3Fe8l = parcelRequire("3Fe8l");

var $hiFKm = parcelRequire("hiFKm");

var $cUnrZ = parcelRequire("cUnrZ");

var $dtDO2 = parcelRequire("dtDO2");

var $lTQTl = parcelRequire("lTQTl");

var $dHWda = parcelRequire("dHWda");

var $4Onaa = parcelRequire("4Onaa");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $2yVPv = parcelRequire("2yVPv");

var $bc9Gj = parcelRequire("bc9Gj");

var $joEdY = parcelRequire("joEdY");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $c859158f09e2bd72$var$useSidebarId } = (0, $dHWda.createValueController)('sidebar-id');
const $c859158f09e2bd72$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $joEdY.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $c859158f09e2bd72$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $bc9Gj.useRouter)();
    const pageId = (0, $2yVPv.usePageId)();
    const startRef = (0, $euxye.useRef)(Date.now());
    const onStartExperience = (0, $dtDO2.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $joEdY.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $euxye.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
$c859158f09e2bd72$export$6738d1299dc79710.displayName = "SidebarStart";
const $c859158f09e2bd72$export$ba19e3624956e66 = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hiFKm.NavSidebarPerformanceMark), {
            metricKey: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderStart
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$c859158f09e2bd72$export$ba19e3624956e66.displayName = "SidebarRenderStart";
const $c859158f09e2bd72$export$a06ecbbe5820282 = (t0)=>{
    const $ = (0, $e7boj.c)(20);
    const { id: id } = t0;
    const [, setSidebarId] = $c859158f09e2bd72$var$useSidebarId();
    const route = (0, $4Onaa.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? "UNKNOWN";
    const onSuccess = (0, $lTQTl.useExperienceSuccess)($c859158f09e2bd72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    let t1;
    let t2;
    if ($[0] !== id || $[1] !== setSidebarId) {
        t1 = ()=>{
            setSidebarId(id);
            return ()=>setSidebarId();
        };
        t2 = [
            setSidebarId,
            id
        ];
        $[0] = id;
        $[1] = setSidebarId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $euxye.useEffect)(t1, t2);
    let t3;
    if ($[4] !== onSuccess || $[5] !== route.isRedirect) {
        t3 = ()=>{
            if (route.isRedirect ?? false) return;
            onSuccess();
        };
        $[4] = onSuccess;
        $[5] = route.isRedirect;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== onSuccess || $[8] !== route) {
        t4 = [
            onSuccess,
            route
        ];
        $[7] = onSuccess;
        $[8] = route;
        $[9] = t4;
    } else t4 = $[9];
    (0, $euxye.useLayoutEffect)(t3, t4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    let t5;
    let t6;
    if ($[10] !== createAnalyticsEvent || $[11] !== routeName) {
        t5 = ()=>{
            window.__POLLINATOR__ = {
                ...window.__POLLINATOR__,
                routeName: routeName
            };
            const event = createAnalyticsEvent({
                action: "ready",
                actionSubject: "sidebar",
                meta: {
                    teamName: "endeavour"
                }
            });
            (0, $aJ81Y.fireUIAnalytics)(event, "Sidebar Ready", {
                route: routeName
            });
        };
        t6 = [
            createAnalyticsEvent,
            routeName
        ];
        $[10] = createAnalyticsEvent;
        $[11] = routeName;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $euxye.useEffect)(t5, t6);
    let t7;
    if ($[14] !== id || $[15] !== routeName) {
        t7 = {
            route: routeName,
            sidebarId: id
        };
        $[14] = id;
        $[15] = routeName;
        $[16] = t7;
    } else t7 = $[16];
    const customData = t7;
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hiFKm.NavSidebarPerformanceMark), {
            metricKey: (0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).renderEnd
        });
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== customData) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hiFKm.NavSidebarPerformanceReport), {
            customData: customData
        }));
        $[18] = customData;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
};
$c859158f09e2bd72$export$a06ecbbe5820282.displayName = "SidebarReady";
const $c859158f09e2bd72$export$661ed14c8f75da9f = ()=>{
    const $ = (0, $e7boj.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            experience: (0, $joEdY.SIDEBAR_EXPERIENCE)
        };
        $[0] = t0;
    } else t0 = $[0];
    const onFail = (0, $cUnrZ.useExperienceFail)(t0);
    let t1;
    if ($[1] !== onFail) {
        t1 = (location, error)=>{
            onFail(location, error);
        };
        $[1] = onFail;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $c859158f09e2bd72$export$ddb17534fdfb7dc6 = ()=>{
    return (0, $lTQTl.useExperienceSuccess)($c859158f09e2bd72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
};

});
parcelRegister("cUnrZ", function(module, exports) {
$parcel$export(module.exports, "useExperienceFail", () => $85e9bbc4c2fc8179$export$606da7704d8eaf06);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $lCetP = parcelRequire("lCetP");

var $8dImz = parcelRequire("8dImz");

var $6bEm8 = parcelRequire("6bEm8");

var $a5nxD = parcelRequire("a5nxD");

var $i860n = parcelRequire("i860n");

var $UlW5d = parcelRequire("UlW5d");
const $85e9bbc4c2fc8179$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const self = (0, $euxye.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $euxye.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $8dImz.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $lCetP.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $6bEm8.default)('ajs-shard'),
            region: (0, $6bEm8.default)('ajs-region')
        };
        let holdoutAttributes = {};
        if ((0, $i860n.fg)('add_holdout_attribute_to_jira_experience_tracker')) holdoutAttributes = {
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                ...holdoutAttributes,
                location: location
            }
        });
    }, // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
    [
        self
    ]);
};

});
parcelRegister("UlW5d", function(module, exports) {
$parcel$export(module.exports, "useExperienceContext", () => $f5296fb50921e62f$export$be8ec22ac9208049);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $3QaCr = parcelRequire("3QaCr");
const $f5296fb50921e62f$export$be8ec22ac9208049 = ()=>{
    const context = (0, $euxye.useContext)((0, $3QaCr.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("dtDO2", function(module, exports) {
$parcel$export(module.exports, "useExperienceStart", () => $fee085d39a3804e6$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $fee085d39a3804e6$export$f20b867e738a222c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4Onaa = parcelRequire("4Onaa");

var $UlW5d = parcelRequire("UlW5d");
/**
 * Initializes and manages a user experience tracking session based on the user's current route and
 * provided properties. It prepares the session with all necessary parameters and returns a function
 * that, when called, begins tracking the user's experience with these configured settings. This
 * setup is crucial for collecting and analyzing user interaction data in a structured manner.
 */ const $fee085d39a3804e6$var$collectDefault = ()=>undefined;
const $fee085d39a3804e6$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const effectiveCollect = collect ?? $fee085d39a3804e6$var$collectDefault;
    const route = (0, $4Onaa.useCurrentRoute)();
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $euxye.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = effectiveCollect;
    return (0, $euxye.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
    }, [
        self
    ]);
};
const $fee085d39a3804e6$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $fee085d39a3804e6$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $euxye.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};
$fee085d39a3804e6$export$f20b867e738a222c.displayName = "ExperienceStart";

});

parcelRegister("lTQTl", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $c52f7ca5d7a37e94$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $c52f7ca5d7a37e94$export$4962f3898bd5c829);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4Onaa = parcelRequire("4Onaa");

var $6bEm8 = parcelRequire("6bEm8");

var $a5nxD = parcelRequire("a5nxD");

var $i860n = parcelRequire("i860n");

var $UlW5d = parcelRequire("UlW5d");
const $c52f7ca5d7a37e94$var$STABLE_EMPTY_OBJECT = {};
const $c52f7ca5d7a37e94$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $c52f7ca5d7a37e94$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const route = (0, $4Onaa.useCurrentRoute)();
    const self = (0, $euxye.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $euxye.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        const shardAndRegionAttributes = {
            shard: (0, $6bEm8.default)('ajs-shard'),
            region: (0, $6bEm8.default)('ajs-region')
        };
        let holdoutAttributes = {};
        if ((0, $i860n.fg)('add_holdout_attribute_to_jira_experience_tracker')) holdoutAttributes = {
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout
        };
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                ...holdoutAttributes
            }
        });
    }, // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
    [
        self
    ]);
};
const $c52f7ca5d7a37e94$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $c52f7ca5d7a37e94$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $c52f7ca5d7a37e94$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $euxye.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $euxye.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};
$c52f7ca5d7a37e94$export$4962f3898bd5c829.displayName = "ExperienceSuccess";

});

parcelRegister("dHWda", function(module, exports) {
$parcel$export(module.exports, "createValueController", () => $2d7b39235f214b78$export$ff0ab9dd4ceb4a93);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $2d7b39235f214b78$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $5QDqc.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $dB6ay.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $3h1FP.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("2yVPv", function(module, exports) {
$parcel$export(module.exports, "usePageId", () => $4699ea095602d395$export$3434ba5eadb360dc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $6Bw3S = parcelRequire("6Bw3S");
const $4699ea095602d395$var$useSweetStatePageId = (0, $3h1FP.createHook)((0, $6Bw3S.default), {
    selector: (state)=>state.currentPage.uuid
});
const $4699ea095602d395$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $4699ea095602d395$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("joEdY", function(module, exports) {
$parcel$export(module.exports, "REPO_TYPE", () => $801d21e3e83376ab$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $801d21e3e83376ab$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $801d21e3e83376ab$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $801d21e3e83376ab$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $801d21e3e83376ab$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $801d21e3e83376ab$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $801d21e3e83376ab$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $801d21e3e83376ab$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $801d21e3e83376ab$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $801d21e3e83376ab$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $801d21e3e83376ab$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $801d21e3e83376ab$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $801d21e3e83376ab$export$dde074e512e80dff);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $801d21e3e83376ab$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $801d21e3e83376ab$export$f57650e6e7be03dc);
/* eslint-disable jira/filename-case */ const $801d21e3e83376ab$export$399c7e6858236b4 = 'source.code.link';
const $801d21e3e83376ab$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $801d21e3e83376ab$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $801d21e3e83376ab$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $801d21e3e83376ab$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $801d21e3e83376ab$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $801d21e3e83376ab$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $801d21e3e83376ab$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $801d21e3e83376ab$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $801d21e3e83376ab$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $801d21e3e83376ab$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $801d21e3e83376ab$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $801d21e3e83376ab$export$dde074e512e80dff = 'global-create-spotlight';
const $801d21e3e83376ab$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $801d21e3e83376ab$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $801d21e3e83376ab$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
];

});


parcelRegister("hp8UB", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $1139fc5419831fde$export$8f31e4c4a37b8e9c);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2D2gW = parcelRequire("2D2gW");

var $f6euu = parcelRequire("f6euu");

var $kC8n7 = parcelRequire("kC8n7");
const $1139fc5419831fde$export$8f31e4c4a37b8e9c = (t0)=>{
    const $ = (0, $e7boj.c)(7);
    const { isFull: t1 } = t0;
    const isFull = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isFull) {
        t2 = isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1139fc5419831fde$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kC8n7.default), {
            hasIcon: true
        }));
        $[0] = isFull;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== isFull) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f6euu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kC8n7.default), {
            hasIcon: isFull
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kC8n7.default), {
            hasIcon: isFull
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kC8n7.default), {
            hasIcon: isFull
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kC8n7.default), {
            hasIcon: isFull
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kC8n7.default), {
            hasIcon: isFull
        }));
        $[2] = isFull;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
            name: "sidebar-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1139fc5419831fde$var$BackgroundedWrapper, null, t2, t3));
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
$1139fc5419831fde$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1139fc5419831fde$var$BackgroundedWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $e7boj.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $4jQY2.default)([
            "_4t3i1tem _ca0qidpf _u5f31ejb _n3tdidpf _19bvu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1139fc5419831fde$var$HeadingWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $e7boj.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $4jQY2.default)([
            "_ca0q1f4h _u5f3idpf _n3tdpxbi _19bvidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

});
parcelRegister("f6euu", function(module, exports) {
$parcel$export(module.exports, "default", () => $5574f594dd6447a8$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $g36LP = parcelRequire("g36LP");

var $foENF = parcelRequire("foENF");
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $5574f594dd6447a8$var$Section = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $foENF.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g36LP.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $5574f594dd6447a8$export$2e2bcd8739ae039 = $5574f594dd6447a8$var$Section;

});
parcelRegister("foENF", function(module, exports) {
$parcel$export(module.exports, "useShouldNestedElementRender", () => $be26cf2e9a36d858$export$37e8646a1abfc3e6);

var $euxye = parcelRequire("euxye");

var $5PJIT = parcelRequire("5PJIT");
const $be26cf2e9a36d858$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $euxye.useContext)((0, $5PJIT.NestedContext));
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});
parcelRegister("5PJIT", function(module, exports) {
$parcel$export(module.exports, "NestedContext", () => $a161422cf38be968$export$46b2c2071c8c725a);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $euxye = parcelRequire("euxye");
const $a161422cf38be968$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});



parcelRegister("kC8n7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e79f5ab7131d8b07$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $kENFC = parcelRequire("kENFC");

var $foENF = parcelRequire("foENF");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $e79f5ab7131d8b07$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $foENF.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {
        isSideNavSkeleton: true,
        ...props
    });
};
$e79f5ab7131d8b07$var$SkeletonItem.displayName = "SkeletonItem";
var $e79f5ab7131d8b07$export$2e2bcd8739ae039 = $e79f5ab7131d8b07$var$SkeletonItem;

});



parcelRegister("cz8BN", function(module, exports) {
$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $1e91f9132edacd0e$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $1e91f9132edacd0e$export$edbd543f308bbef5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3Fe8l = parcelRequire("3Fe8l");

var $hiFKm = parcelRequire("hiFKm");
const $1e91f9132edacd0e$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $hiFKm.pageSegmentStore).getSegment((0, $3Fe8l.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $1e91f9132edacd0e$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $hiFKm.pageSegmentStore).getSegment((0, $3Fe8l.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $3Fe8l.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("5koXb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gO3qD")
]).then(()=>parcelRequire('90fXo'));

});


parcelRegister("iQGmB", function(module, exports) {
$parcel$export(module.exports, "opsTeamLayout", () => $7c90bc256999af7d$export$53dd27149810df73);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7c90bc256999af7d$var$RightSidebars = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("3S8Ay")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-ops-team-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7c90bc256999af7d$var$Onboarding = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("1V1yB")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-ops-team-layout/src/ui/onboarding/index.tsx"
});
const $7c90bc256999af7d$export$53dd27149810df73 = (0, $QhQu4.createLayout)({
    get globalComponents () {
        return [
            $7c90bc256999af7d$var$Onboarding
        ];
    },
    rightSidebars: [
        $7c90bc256999af7d$var$RightSidebars
    ]
});

});
parcelRegister("3S8Ay", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7uQsT").then(()=>parcelRequire('dRnEK'));

});

parcelRegister("1V1yB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dxGIg").then(()=>parcelRequire('j7Edz'));

});


parcelRegister("j0VPn", function(module, exports) {
$parcel$export(module.exports, "alertPoliciesRoute", () => $5922449a40e71b25$export$eab7ea9e54b67f16);
const $5922449a40e71b25$export$eab7ea9e54b67f16 = {
    name: 'eoc-team-policies',
    path: '/jira/ops/teams/:teamId/policies',
    exact: true
};

});

parcelRegister("coId9", function(module, exports) {
$parcel$export(module.exports, "LazyAlertPolicies", () => $41e92421d0411400$export$3079046c31ee50f7);
$parcel$export(module.exports, "AlertPoliciesComponent", () => $41e92421d0411400$export$882bdfb7e45bd440);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $41e92421d0411400$export$3079046c31ee50f7 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9vpXb")), {
    moduleId: "./src/packages/eoc/policies/src/index.tsx"
});
const $41e92421d0411400$export$882bdfb7e45bd440 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $41e92421d0411400$export$3079046c31ee50f7,
        pageId: "async-jira-eoc-alert-policies",
        shouldShowSpinner: false
    });
$41e92421d0411400$export$882bdfb7e45bd440.displayName = "AlertPoliciesComponent";

});
parcelRegister("8bf4L", function(module, exports) {
$parcel$export(module.exports, "LazyPage", () => $92108d58e2529401$export$a18c9c3dd309b8e6);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6DfNt = parcelRequire("6DfNt");

var $6CfY5 = parcelRequire("6CfY5");

var $a8EUd = parcelRequire("a8EUd");

var $4Onaa = parcelRequire("4Onaa");

var $E85Qr = parcelRequire("E85Qr");

var $f99wD = parcelRequire("f99wD");

var $bzSUP = parcelRequire("bzSUP");
const $92108d58e2529401$var$LOCATION = 'lazy-page';
const $92108d58e2529401$export$fb85bbdbfb3e6869 = ()=>null;
const $92108d58e2529401$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $6DfNt.default) : $92108d58e2529401$export$fb85bbdbfb3e6869);
    (0, $euxye.useEffect)(()=>{
        if (route.isRedirect) (0, $6CfY5.default).safeWarnWithoutCustomerData($92108d58e2529401$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, route.bifrost?.bifrostGroup !== 'shell-only' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "LazyPage",
        ignoreWhenCircuitOpen: true,
        displayErrorInStaging: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Skeleton, null));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $E85Qr.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "lazy_page",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Page, null)))));
};
$92108d58e2529401$export$a18c9c3dd309b8e6.displayName = "LazyPage";

});
parcelRegister("6DfNt", function(module, exports) {
$parcel$export(module.exports, "default", () => $0463e7c2a383a946$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2D2gW = parcelRequire("2D2gW");

var $abhF2 = parcelRequire("abhF2");
function $0463e7c2a383a946$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0463e7c2a383a946$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0463e7c2a383a946$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: "large",
        testId: testId
    }))));
}
$0463e7c2a383a946$export$2e2bcd8739ae039.displayName = "Spinner";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0463e7c2a383a946$var$Container = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $0463e7c2a383a946$var$Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("E85Qr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4e5512e8682cc52$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7jZTu = parcelRequire("7jZTu");

var $6xuJS = parcelRequire("6xuJS");

var $gp4ma = parcelRequire("gp4ma");

var $lCfDe = parcelRequire("lCfDe");

var $cYVlc = parcelRequire("cYVlc");


var $5BIfJ = parcelRequire("5BIfJ");

var $jgUTL = parcelRequire("jgUTL");
class $b4e5512e8682cc52$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BIfJ.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gp4ma.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args), this.customMarks = [], this.onStart = ()=>{
            (0, $7jZTu.default)((0, $07aa4ba62fd6dab4$export$56940a9488e85199));
            (0, $6xuJS.setMark)((0, $07aa4ba62fd6dab4$export$45c4b6bf7935c69a));
        }, this.onCustomMark = (markName)=>{
            (0, $6xuJS.setMark)((0, $jgUTL.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $cYVlc.isAutomaticExposureCollectionEnabled)()) (0, $lCfDe.stopLowPriorityEventDelay)();
        };
    }
}
$b4e5512e8682cc52$export$2e2bcd8739ae039.displayName = "Provider";

});
parcelRegister("7jZTu", function(module, exports) {
$parcel$export(module.exports, "default", () => $659c9fba925216f6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $fDxFn = parcelRequire("fDxFn");
/*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ const $659c9fba925216f6$var$clearMarksWithPrefix = (prefix)=>{
    if ((0, $fDxFn.default) && (0, $fDxFn.default).getEntries && (0, $fDxFn.default).clearMarks) return (0, $fDxFn.default).getEntries().filter((mark)=>mark.name.startsWith(prefix)).map((mark)=>{
        (0, $fDxFn.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};
var $659c9fba925216f6$export$2e2bcd8739ae039 = $659c9fba925216f6$var$clearMarksWithPrefix;

});

parcelRegister("gp4ma", function(module, exports) {
$parcel$export(module.exports, "default", () => $34327f454b0f147e$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");
// eslint-disable-next-line jira/react/no-class-components
class $34327f454b0f147e$var$OpTrigger extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
$34327f454b0f147e$var$OpTrigger.displayName = "OpTrigger";
var $34327f454b0f147e$export$2e2bcd8739ae039 = $34327f454b0f147e$var$OpTrigger;

});

parcelRegister("lCfDe", function(module, exports) {
$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $9709dda8586372c0$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $9709dda8586372c0$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $9709dda8586372c0$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7jZTu = parcelRequire("7jZTu");

var $6xuJS = parcelRequire("6xuJS");

var $WLMyp = parcelRequire("WLMyp");

var $6Kdw4 = parcelRequire("6Kdw4");

var $kPvQe = parcelRequire("kPvQe");

var $cYVlc = parcelRequire("cYVlc");

const $9709dda8586372c0$var$STOP_DELAY_TIMEOUT = 10000;
let $9709dda8586372c0$var$stopDelayTimeout;
let $9709dda8586372c0$var$lastDelayActionPromise = (0, $6Kdw4.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $9709dda8586372c0$export$a928755af449867 = ()=>{
    $9709dda8586372c0$var$lastDelayActionPromise = $9709dda8586372c0$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $WLMyp.isEventDelayActive)()) return client;
        clearTimeout($9709dda8586372c0$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6xuJS.setMark)((0, $0c827fe198b93e52$export$2d91d3eed1108e72));
        (0, $WLMyp.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $9709dda8586372c0$export$8bb8df5a93e9525 = ()=>{
    $9709dda8586372c0$var$lastDelayActionPromise = $9709dda8586372c0$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $WLMyp.isEventDelayActive)()) {
            (0, $7jZTu.default)((0, $0c827fe198b93e52$export$358721a9d6125914));
            (0, $6xuJS.setMark)((0, $0c827fe198b93e52$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $WLMyp.setEventDelayActive)(true);
        clearTimeout($9709dda8586372c0$var$stopDelayTimeout);
        $9709dda8586372c0$var$stopDelayTimeout = setTimeout($9709dda8586372c0$export$a928755af449867, $9709dda8586372c0$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $9709dda8586372c0$export$778ebe2a4fab1ba7 = ()=>$9709dda8586372c0$var$lastDelayActionPromise;
const $9709dda8586372c0$var$EventDelayController = ()=>{
    const [loadedState] = (0, $kPvQe.default)();
    (0, $euxye.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $cYVlc.isAutomaticExposureCollectionEnabled)()) $9709dda8586372c0$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
$9709dda8586372c0$var$EventDelayController.displayName = "EventDelayController";
var $9709dda8586372c0$export$2e2bcd8739ae039 = $9709dda8586372c0$var$EventDelayController;

});
parcelRegister("WLMyp", function(module, exports) {
$parcel$export(module.exports, "setEventDelayActive", () => $d63f81c93066405d$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $d63f81c93066405d$export$3536b0184fa98d19);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ let $d63f81c93066405d$var$eventDelayActive = false;
const $d63f81c93066405d$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $d63f81c93066405d$var$eventDelayActive = isEventDelayActive;
};
const $d63f81c93066405d$export$3536b0184fa98d19 = ()=>$d63f81c93066405d$var$eventDelayActive;

});

parcelRegister("kPvQe", function(module, exports) {
$parcel$export(module.exports, "default", () => $fba6ab5a4776495b$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");


var $6Bw3S = parcelRequire("6Bw3S");
const $fba6ab5a4776495b$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $70e36d23224a09de$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $70e36d23224a09de$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $fba6ab5a4776495b$var$usePageLoadedSubscriber = (0, $3h1FP.createHook)((0, $6Bw3S.default), {
    selector: $fba6ab5a4776495b$export$4a361c7505f72f5c
});
var $fba6ab5a4776495b$export$2e2bcd8739ae039 = $fba6ab5a4776495b$var$usePageLoadedSubscriber;

});
/* eslint-disable jira/filename-case */ const $70e36d23224a09de$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $70e36d23224a09de$export$2ee9e5a3556c1e43 = 'SIDEBAR';


parcelRegister("cYVlc", function(module, exports) {
$parcel$export(module.exports, "isAutomaticExposureCollectionEnabled", () => $9545f666dfc9ddc1$export$cf2aaf3c58e46848);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // code-reaper-ignore - file is referenced as "browser" entry in package.json
// eslint-disable-next-line jira/jira-ssr/no-server-variable
const $9545f666dfc9ddc1$export$c9c75778ebadb3f1 = ()=>false ? 0 : 100;
const $9545f666dfc9ddc1$export$cf2aaf3c58e46848 = ()=>!false;

});

/* eslint-disable jira/filename-case */ const $0c827fe198b93e52$export$358721a9d6125914 = 'event-delay-controller.';
const $0c827fe198b93e52$export$b2122dce85a27912 = `${$0c827fe198b93e52$export$358721a9d6125914}start`;
const $0c827fe198b93e52$export$2d91d3eed1108e72 = `${$0c827fe198b93e52$export$358721a9d6125914}end`;


/* eslint-disable jira/filename-case */ const $07aa4ba62fd6dab4$export$56940a9488e85199 = 'jira.fe.spa-';
const $07aa4ba62fd6dab4$export$45c4b6bf7935c69a = `${$07aa4ba62fd6dab4$export$56940a9488e85199}start`;
const $07aa4ba62fd6dab4$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $07aa4ba62fd6dab4$export$ff834eccc35b9089 = 'appBundleReady';
const $07aa4ba62fd6dab4$export$86b05e34d462ead8 = 'prefetchApiReady';
const $07aa4ba62fd6dab4$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $07aa4ba62fd6dab4$export$3ae43cc1782d058f = 'jswRenderStart';
const $07aa4ba62fd6dab4$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $07aa4ba62fd6dab4$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $07aa4ba62fd6dab4$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $07aa4ba62fd6dab4$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $07aa4ba62fd6dab4$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $07aa4ba62fd6dab4$export$99c08ec92759c71c = 'tti-raf-mark';
const $07aa4ba62fd6dab4$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("5BIfJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $459c9aef7d8e5f61$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
const $459c9aef7d8e5f61$var$contextName = 'SpaApdexAnalytics';
const $459c9aef7d8e5f61$var$spaApdexAnalyticsContext = /*#__PURE__*/ (0, $euxye.createContext)($459c9aef7d8e5f61$var$contextName);
var $459c9aef7d8e5f61$export$2e2bcd8739ae039 = $459c9aef7d8e5f61$var$spaApdexAnalyticsContext;

});

parcelRegister("jgUTL", function(module, exports) {
$parcel$export(module.exports, "getPrefixedMarkName", () => $2df815ffc6a1236e$export$c8f0e9837e7e9425);
/* eslint-disable jira/filename-case */ 
const $2df815ffc6a1236e$export$c8f0e9837e7e9425 = (name)=>`${0, $07aa4ba62fd6dab4$export$56940a9488e85199}${name}`;

});


parcelRegister("f99wD", function(module, exports) {
$parcel$export(module.exports, "SpaStateContainer", () => $9f40a6f98028a48e$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $9f40a6f98028a48e$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $9f40a6f98028a48e$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $9f40a6f98028a48e$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $9f40a6f98028a48e$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $9f40a6f98028a48e$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $9f40a6f98028a48e$export$6e9ab893e97cccef);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f2wVS = parcelRequire("f2wVS");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $ciIbx = parcelRequire("ciIbx");

var $OPiBr = parcelRequire("OPiBr");

var $6Bw3S = parcelRequire("6Bw3S");
const $9f40a6f98028a48e$export$e9a92b877fe80e80 = (0, $dB6ay.createContainer)((0, $6Bw3S.default));
const $9f40a6f98028a48e$export$d18dd27183a635c = ()=>{
    const startRef = (0, $euxye.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $OPiBr.useSpaState)();
    (0, $euxye.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
$9f40a6f98028a48e$export$d18dd27183a635c.displayName = "SpaStateAppStart";
const $9f40a6f98028a48e$var$useRouterMatchSelector = (0, $f2wVS.createRouterSelector)((state)=>state.match);
const $9f40a6f98028a48e$var$useSpaStatePagesCount = (0, $3h1FP.createHook)((0, $6Bw3S.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $9f40a6f98028a48e$export$95a2912d76fb5433 = ()=>{
    const match = $9f40a6f98028a48e$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $9f40a6f98028a48e$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9f40a6f98028a48e$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
$9f40a6f98028a48e$export$95a2912d76fb5433.displayName = "SpaStateAppStartWithMatchCheck";
function $9f40a6f98028a48e$export$c34439f945fccbdf() {
    const { setAppReady: setAppReady } = (0, $OPiBr.useSpaStateActions)();
    (0, $euxye.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady
    ]);
    return null;
}
$9f40a6f98028a48e$export$c34439f945fccbdf.displayName = "SpaStatePageReady";
function $9f40a6f98028a48e$export$41e70078eeddaddc({ updateKey: updateKey }) {
    const { setAppReady: setAppReady } = (0, $OPiBr.useSpaStateActions)();
    (0, $euxye.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady,
        updateKey
    ]);
    return null;
}
$9f40a6f98028a48e$export$41e70078eeddaddc.displayName = "SpaStatePageReadyOnUpdate";
function $9f40a6f98028a48e$export$2583aa269898885c() {
    const { setAppErrorReady: setAppErrorReady } = (0, $OPiBr.useSpaStateActions)();
    (0, $euxye.useEffect)(()=>{
        setAppErrorReady();
    }, [
        setAppErrorReady
    ]);
    return null;
}
$9f40a6f98028a48e$export$2583aa269898885c.displayName = "SpaStatePageErrorReady";
class $9f40a6f98028a48e$export$ada7e0ec445851a2 extends (0, $euxye.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
$9f40a6f98028a48e$export$ada7e0ec445851a2.displayName = "SpaStateAppStartChild";
const $9f40a6f98028a48e$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $ciIbx.defaultRegistry).getStore((0, $6Bw3S.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});
parcelRegister("OPiBr", function(module, exports) {
$parcel$export(module.exports, "useSpaState", () => $445053e25dd421f1$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $445053e25dd421f1$export$b134752525935b78);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $6Bw3S = parcelRequire("6Bw3S");
const $445053e25dd421f1$export$a57865516f6345d1 = (0, $3h1FP.createHook)((0, $6Bw3S.default));
const $445053e25dd421f1$export$b134752525935b78 = (0, $3h1FP.createActionsHook)((0, $6Bw3S.default));

});


parcelRegister("bzSUP", function(module, exports) {
$parcel$export(module.exports, "ReportSSRFailOnUse", () => $6627cacbaaf3d1be$export$daa3f09a96683b19);
$parcel$export(module.exports, "DisableSSRFailDetection", () => $6627cacbaaf3d1be$export$420f5a45dbda6a67);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ed8N8 = parcelRequire("ed8N8");

var $ldgHZ = parcelRequire("ldgHZ");

var $f2wVS = parcelRequire("f2wVS");

var $hNjtc = parcelRequire("hNjtc");

var $2qS33 = parcelRequire("2qS33");

var $aMROb = parcelRequire("aMROb");
// oxlint-disable-next-line typescript/no-invalid-void-type
const $6627cacbaaf3d1be$export$c35f8a10548d98f7 = (0, $f2wVS.createRouterSelector)((state)=>state.route?.bifrost?.circuitBreakerConfig);
const $6627cacbaaf3d1be$export$daa3f09a96683b19 = ({ ignoreWhenCircuitOpen: ignoreWhenCircuitOpen, pageId: pageId, UNSAFE__forceReporting: UNSAFE__forceReporting = false, reportToSlackChannel: reportToSlackChannel, fallbackId: fallbackId, displayErrorInStaging: displayErrorInStaging })=>{
    const circuitBreakerConfig = $6627cacbaaf3d1be$export$c35f8a10548d98f7();
    const isCircuitOpenValue = (0, $ed8N8.isCircuitOpen)(circuitBreakerConfig);
    const isCookieCircuitBreakerOpen = ignoreWhenCircuitOpen && isCircuitOpenValue && circuitBreakerConfig?.isCircuitBreakerEnabled;
    const isIgnored = isCookieCircuitBreakerOpen || (0, $ldgHZ.isStreamingEnabled)();
    const shouldReport = (0, $euxye.useContext)((0, $aMROb.detectionBoundary)) || UNSAFE__forceReporting;
    (0, $euxye.useMemo)(()=>{
        if (!false) // This component only reports in SSR
        return;
        // do not report when cb is open and this failure is to do with the resources not being loaded.
        // However, still show circuit breaker message when appropriate
        if (isIgnored) return;
        if (shouldReport) {
            // eslint-disable-next-line no-console
            console.error({
                error: `SSR ended rendering a fallback (${fallbackId}) on page ${pageId}`,
                message: 'Top level suspense boundary was triggered. This is not expected to happen',
                pageId: pageId
            });
            (0, $hNjtc.markSSRFailure)(fallbackId);
        } else // eslint-disable-next-line no-console
        console.warn(`SSR ended rendering a non-top-level fallback (${fallbackId}) on page ${pageId}`);
    }, [
        isIgnored,
        shouldReport,
        fallbackId,
        pageId
    ]);
    if (isIgnored && !isCookieCircuitBreakerOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2qS33.FallbackIndicator), {
        reportToSlackChannel: reportToSlackChannel,
        fallbackId: fallbackId,
        displayErrorInStaging: displayErrorInStaging,
        isCookieCircuitBreakerFailure: isCookieCircuitBreakerOpen,
        cookieKey: circuitBreakerConfig?.cookieKey
    });
};
$6627cacbaaf3d1be$export$daa3f09a96683b19.displayName = "ReportSSRFailOnUse";
const $6627cacbaaf3d1be$export$420f5a45dbda6a67 = ({ children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aMROb.detectionBoundary).Provider, {
        value: false
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
$6627cacbaaf3d1be$export$420f5a45dbda6a67.displayName = "DisableSSRFailDetection";

});
parcelRegister("ed8N8", function(module, exports) {
$parcel$export(module.exports, "isCircuitOpen", () => $7b3174e9f3dd0826$export$f528a0ba25e4d432);
/* eslint-disable jira/filename-case */ 
var $gQale = parcelRequire("gQale");
function $7b3174e9f3dd0826$export$f528a0ba25e4d432(config) {
    // circuit will never be open if isSetCookieEnabled is false
    if (config?.isSetCookieEnabled) {
        const circuitBreaker = (0, $gQale.getCookieCircuitBreaker)(config);
        return circuitBreaker?.getState().state === 'OPEN';
    }
    return false;
}

});
parcelRegister("gQale", function(module, exports) {
$parcel$export(module.exports, "getCookieCircuitBreaker", () => $b1286dc2cfd79bf4$export$c696b1ba9d4ab97);
/* eslint-disable jira/filename-case */ 
var $3Nfah = parcelRequire("3Nfah");
let $b1286dc2cfd79bf4$var$circuitBreaker;
function $b1286dc2cfd79bf4$export$c696b1ba9d4ab97(config) {
    if (config?.isSetCookieEnabled) {
        if ($b1286dc2cfd79bf4$var$circuitBreaker) return $b1286dc2cfd79bf4$var$circuitBreaker;
        $b1286dc2cfd79bf4$var$circuitBreaker = new (0, $3Nfah.CookieCircuitBreaker)(config);
        return $b1286dc2cfd79bf4$var$circuitBreaker;
    }
}

});
parcelRegister("3Nfah", function(module, exports) {
$parcel$export(module.exports, "CookieCircuitBreaker", () => $7fb7b9ad2c8cd2b3$export$e15350ade5fb9457);
/* eslint-disable jira/filename-case */ 
var $fg6Qq = parcelRequire("fg6Qq");
var $cyWbF = parcelRequire("cyWbF");

var $gXrrn = parcelRequire("gXrrn");
class $7fb7b9ad2c8cd2b3$export$e15350ade5fb9457 {
    constructor({ cookieKey: cookieKey, windowSize: windowSize = 15, threshold: threshold = 0.1, keepOpenCount: keepOpenCount = 100, halfOpenForCount: halfOpenForCount = 10, version: // version is only required when setting the cookie (i.e client side)
    version = 0 }){
        this.cookieKey = cookieKey;
        this.windowSize = windowSize > 29 ? 29 : windowSize;
        // eslint-disable-next-line no-bitwise
        this.windowMask = (1 << this.windowSize) - 1;
        this.threshold = threshold;
        this.halfOpenForCount = halfOpenForCount;
        this.keepOpenCount = keepOpenCount;
        this.version = version;
        const existingCookie = (0, $gXrrn.getCookie)(`cb_${cookieKey}`, true);
        if (existingCookie) this.cookieData = this.parseCookieData(existingCookie);
        else this.cookieData = {
            numberRepresentation: 0,
            counter: 0,
            windowLength: 0,
            version: version
        };
    }
    parseCookieData(cookieValue) {
        try {
            const [encodedWindow, stringWindowLength, stringCount, stringVersion] = cookieValue.split('|');
            const parsedNumberRepresentation = Number.parseInt(encodedWindow ?? '', 36);
            const numberRepresentation = !Number.isNaN(parsedNumberRepresentation) ? parsedNumberRepresentation : 0;
            const parsedCounter = Number.parseInt(stringCount ?? '', 36);
            const counter = !Number.isNaN(parsedCounter) ? parsedCounter : 0;
            const parsedWindowLength = Number.parseInt(stringWindowLength ?? '', 36);
            const windowLength = !Number.isNaN(parsedWindowLength) ? parsedWindowLength : 0;
            const parsedVersion = Number.parseInt(stringVersion ?? '', 36);
            const version = !Number.isNaN(parsedVersion) ? parsedVersion : 0;
            return {
                numberRepresentation: numberRepresentation,
                counter: counter,
                windowLength: windowLength,
                version: version
            };
        } catch (error) {
            // Return default data if parsing fails
            return {
                numberRepresentation: 0,
                counter: 0,
                windowLength: 0,
                version: this.version
            };
        }
    }
    serializeForCookie() {
        const encodedWindow = this.cookieData.numberRepresentation.toString(36);
        const stringCount = this.cookieData.counter.toString(36);
        const windowLength = this.cookieData.windowLength.toString(36);
        const version = this.cookieData.version.toString(36);
        return `${encodedWindow}|${windowLength}|${stringCount}|${version}`;
    }
    saveToCookie() {
        (0, $cyWbF.setStrictlyNecessaryCookie)(`cb_${this.cookieKey}`, this.serializeForCookie(), {
            expires: 14,
            secure: true,
            sameSite: 'strict'
        });
    }
    resetCookieIfVersionMismatch() {
        if (this.cookieData.version !== this.version) {
            (0, $fg6Qq.deleteCookie)(`cb_${this.cookieKey}`);
            this.cookieData = {
                numberRepresentation: 0,
                counter: 0,
                windowLength: 0,
                version: this.version
            };
            return true;
        }
        return false;
    }
    addResultToWindow(result) {
        // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation <<= 1; // Shift left by 1
        /**
		 * For PASS, we bitwise OR with 1 to "add" 1 to the least-significant bit
		 * For FAIL, we bitwise OR with 0 which will be no-op - the LSB will already be 0 after the shift left above
		 */ // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation |= result === 'PASS' ? 1 : 0;
        /**
		 * Truncate to the window size using bitwise AND
		 *
		 * This is the equivalent operation to this (if it was an array):
		 *
		 * ```
		 * if (numberRepresentationAsArray.length > this.windowSize) {
		 * 	   // in this analogy, the end of the array is the most significant bit.
		 *     numberRepresentationAsArray.pop();
		 * }
		 * ```
		 */ // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation &= this.windowMask;
        /**
		 * Only increase the windowLength if it is under the windowSize
		 *
		 * We don't increase when it is equal because the truncation we just did above
		 * will keep it at windowLength = windowSize.
		 *
		 * We need to keep track of windowLength separately because we cannot derive it
		 * from the numberRepresentation when the oldest value in the window is 0.
		 * i.e the numeric representation of 00000001 is the same as 1 - but they have a different
		 * meaning here.
		 */ if (this.cookieData.windowLength < this.windowSize) this.cookieData.windowLength++;
        else this.cookieData.windowLength = this.windowSize;
    }
    incrementOrResetOpenCounter() {
        if (this.cookieData.counter >= this.keepOpenCount + this.halfOpenForCount) this.cookieData.counter = 0;
        else this.cookieData.counter++;
    }
    recordFailure() {
        return this.recordResult('FAIL');
    }
    recordPass() {
        return this.recordResult('PASS');
    }
    recordResult(result) {
        const state = this.getState();
        switch(state.state){
            case 'CLOSED':
                this.addResultToWindow(result);
                // reset the counter when circuit is closed
                this.cookieData.counter = 0;
                break;
            case 'OPEN':
                this.cookieData.counter++;
                break;
            case 'HALF_OPEN':
                this.incrementOrResetOpenCounter();
                this.addResultToWindow(result);
                break;
            default:
                throw new Error(`Unknown state: ${state}`);
        }
        this.saveToCookie();
        return state;
    }
    getWindowSize() {
        return this.windowSize;
    }
    getKey() {
        return this.cookieKey;
    }
    isAtWindowSize() {
        return this.cookieData.windowLength === this.windowSize;
    }
    getState() {
        /**
		 * To count the number of passes, we convert the number to a base 2 string and count the number of 1s.
		 *
		 * This is a simple way of doing it, and should be pretty quick because it uses a regexp literal
		 * it is only called once per page load regardless.
		 */ const onesAndZeroes = this.cookieData.numberRepresentation.toString(2);
        const pass = onesAndZeroes.match(/1/g)?.length ?? 0;
        const fail = this.cookieData.windowLength - pass;
        const ratio = this.cookieData.windowLength > 0 ? pass / this.cookieData.windowLength : 1;
        let state = 'CLOSED';
        if (this.isAtWindowSize() && ratio < 1 - this.threshold) {
            if (this.cookieData.counter > this.keepOpenCount && this.cookieData.counter <= this.keepOpenCount + this.halfOpenForCount) state = 'HALF_OPEN';
            else state = 'OPEN';
        }
        return {
            state: state,
            pass: pass,
            fail: fail,
            ratio: ratio,
            count: this.cookieData.counter,
            version: this.cookieData.version
        };
    }
}
$7fb7b9ad2c8cd2b3$export$e15350ade5fb9457.displayName = "CookieCircuitBreaker";

});
parcelRegister("fg6Qq", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $53fa58ab0b608b2e$export$b43e45590305ffaa);

var $lO5Ez = parcelRequire("lO5Ez");

var $egspI = parcelRequire("egspI");

var $2rFtA = parcelRequire("2rFtA");

var $j1sAG = parcelRequire("j1sAG");
const $53fa58ab0b608b2e$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $egspI.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, $lO5Ez.default).remove(key, attributes);
    else try {
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $lO5Ez.default).remove(key, attributes);
    } catch (e) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});




parcelRegister("hNjtc", function(module, exports) {
$parcel$export(module.exports, "markSSRFailure", () => $147ae87059e38260$export$d4ee68e1ba090b4a);
/* eslint-disable jira/filename-case */ 
var $gXtG2 = parcelRequire("gXtG2");
let $147ae87059e38260$var$ssrFailedMarker = false;
let $147ae87059e38260$var$failedMarkers = new Set();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $147ae87059e38260$var$ssrFailedMarker = false;
    $147ae87059e38260$var$failedMarkers = new Set();
});
const $147ae87059e38260$export$d4ee68e1ba090b4a = (fallbackId)=>{
    $147ae87059e38260$var$ssrFailedMarker = true;
    if (fallbackId != null) $147ae87059e38260$var$failedMarkers.add(fallbackId);
};
const $147ae87059e38260$export$cd0770bef9153db4 = ()=>$147ae87059e38260$var$ssrFailedMarker;
const $147ae87059e38260$export$72a2677536e2f0c1 = ()=>$147ae87059e38260$var$failedMarkers;

});

parcelRegister("2qS33", function(module, exports) {
$parcel$export(module.exports, "FallbackIndicator", () => $436e5bc4aaa0ed33$export$e975518239643357);

var $k5P9q = parcelRequire("k5P9q");

var $1fGeu = parcelRequire("1fGeu");
const $436e5bc4aaa0ed33$export$e975518239643357 = ({ reportToSlackChannel: reportToSlackChannel, fallbackId: fallbackId, displayErrorInStaging: displayErrorInStaging, isCookieCircuitBreakerFailure: isCookieCircuitBreakerFailure, cookieKey: cookieKey })=>{
    const isStagingOrDevOrLocal = (0, $k5P9q.useIsStagingOrDevOrLocal)();
    if (false) {
        if (displayErrorInStaging && isStagingOrDevOrLocal) (0, $1fGeu.pushSSRFailureDisplay)({
            reportToSlackChannel: reportToSlackChannel,
            fallbackId: fallbackId,
            displayErrorInStaging: displayErrorInStaging,
            isCookieCircuitBreakerFailure: isCookieCircuitBreakerFailure,
            cookieKey: cookieKey
        });
    }
    return null;
};
$436e5bc4aaa0ed33$export$e975518239643357.displayName = "FallbackIndicator";
$436e5bc4aaa0ed33$export$e975518239643357.displayName = 'FallbackIndicator';

});
parcelRegister("1fGeu", function(module, exports) {
$parcel$export(module.exports, "pushSSRFailureDisplay", () => $bbdf60648954b795$export$b6724ee8b0fffc36);
$parcel$export(module.exports, "useServerEventsSSRFailureDisplays", () => $bbdf60648954b795$export$bd8e8aad41319c32);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $b8Dvw = parcelRequire("b8Dvw");

var $hfZ0x = parcelRequire("hfZ0x");
const $bbdf60648954b795$var$SSR_EVENT = 'ssr-failure-display';
const $bbdf60648954b795$export$b6724ee8b0fffc36 = (failureProps)=>{
    (0, $b8Dvw.registerEvent)({
        id: $bbdf60648954b795$var$SSR_EVENT,
        name: 'onSSRFailureDisplay',
        args: [
            failureProps
        ]
    });
};
const $bbdf60648954b795$export$bd8e8aad41319c32 = ()=>{
    const [ssrFailureDisplays, setSSRFailureDisplays] = (0, $euxye.useState)(new Map());
    const onSSRFailureDisplay = (0, $euxye.useCallback)((failureProps)=>{
        setSSRFailureDisplays((prev)=>{
            if (failureProps.fallbackId) {
                const newMap = new Map(prev);
                newMap.set(failureProps.fallbackId, failureProps);
                return newMap;
            }
            return prev;
        });
    }, []);
    (0, $euxye.useEffect)(()=>{
        (0, $hfZ0x.getClientDispatcher)().register($bbdf60648954b795$var$SSR_EVENT, onSSRFailureDisplay);
        return ()=>{
            (0, $hfZ0x.getClientDispatcher)().unregister($bbdf60648954b795$var$SSR_EVENT);
        };
    }, [
        onSSRFailureDisplay
    ]);
    return ssrFailureDisplays;
};

});


parcelRegister("aMROb", function(module, exports) {
$parcel$export(module.exports, "detectionBoundary", () => $85ef9244b61a3095$export$1b1634ba80d39e40);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
const $85ef9244b61a3095$export$1b1634ba80d39e40 = /*#__PURE__*/ (0, $euxye.createContext)(true);

});



parcelRegister("9vpXb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ZTyDs").then(()=>parcelRequire('6SOUk'));

});



parcelRegister("6dcTd", function(module, exports) {
$parcel$export(module.exports, "applinksAdministrationEditRouteEntry", () => $712e3163e374ba4c$export$2bedce19ce74cc31);



var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $35eqr = parcelRequire("35eqr");

var $ixwb2 = parcelRequire("ixwb2");

var $80mKf = parcelRequire("80mKf");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");
const $712e3163e374ba4c$export$2bedce19ce74cc31 = (0, $fdS54.createEntry)((0, $80mKf.applinksAdministrationEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-administration',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ixwb2.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $92d0e44258fe76a3$export$e8aa2912a0792727 = 'GLOBAL_PRODUCTS_SETTINGS';

parcelRegister("ixwb2", function(module, exports) {
$parcel$export(module.exports, "default", () => $087efdbb1188c20f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $7xLLk = parcelRequire("7xLLk");

var $f99wD = parcelRequire("f99wD");

var $gDdYI = parcelRequire("gDdYI");

var $e2Tle = parcelRequire("e2Tle");

var $3hvbE = parcelRequire("3hvbE");
const $087efdbb1188c20f$var$EditPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "applinks-administration-edit-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7xLLk.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3hvbE.default), {
        id: props.match.params.applinkId ?? null,
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStatePageReady), null)));
$087efdbb1188c20f$var$EditPage.displayName = "EditPage";
const $087efdbb1188c20f$var$Edit = (0, $e2Tle.withRouter)($087efdbb1188c20f$var$EditPage);
var $087efdbb1188c20f$export$2e2bcd8739ae039 = $087efdbb1188c20f$var$Edit;

});
parcelRegister("7xLLk", function(module, exports) {
$parcel$export(module.exports, "AuthenticationCheck", () => $c434cb84e9c69cfb$export$e9b9096e887386fe);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fOKvg = parcelRequire("fOKvg");

var $eijVy = parcelRequire("eijVy");

var $aj6PJ = parcelRequire("aj6PJ");
const $c434cb84e9c69cfb$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eijVy.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ((0, $fOKvg.checkAuthentication)(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aj6PJ.RedirectToLoginPage), null);
    });
$c434cb84e9c69cfb$export$e9b9096e887386fe.displayName = "AuthenticationCheck";

});
parcelRegister("fOKvg", function(module, exports) {
$parcel$export(module.exports, "checkAuthentication", () => $b51b021afa1deb17$export$b8dbb7d6029c5413);
/**
 * Imperative Authorisation Check
 */ const $b51b021afa1deb17$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);

});

parcelRegister("aj6PJ", function(module, exports) {
$parcel$export(module.exports, "RedirectToLoginPage", () => $3f9a36d1b8046bea$export$938182bd3fddc3a8);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2ffUK = parcelRequire("2ffUK");
var $bc9Gj = parcelRequire("bc9Gj");
var $55BnK = parcelRequire("55BnK");

var $gDMcP = parcelRequire("gDMcP");
const $3f9a36d1b8046bea$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$3f9a36d1b8046bea$export$3da29de62ed7a388.displayName = "InlineRedirect";
$3f9a36d1b8046bea$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $3f9a36d1b8046bea$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $bc9Gj.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $2ffUK.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let link = `${pathname.slice(0, -6)}?${searchParams}`;
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) link = '/jira/your-work?createissue=true';
        const loginEmbedQueryParams = new URLSearchParams([
            [
                'destination',
                redirectUrl
            ],
            [
                'link',
                link
            ],
            [
                'parentProduct',
                parentProduct || ''
            ]
        ]);
        path = `/jira-login/embed?${loginEmbedQueryParams}`;
        // Embeds are generally served inside iframes, and that means our frame-ancestors
        // CSP policy can cause issues if we perform a full page reload when on a custom domain
        // Namely, the referrer for the login page (used to derive dynamic CSP) will be the page
        // triggering the redirection, instead of the custom domain that embedded the iframe.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3f9a36d1b8046bea$var$ClientSideRedirect, {
            url: path
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDMcP.default), {
        url: path
    });
};
$3f9a36d1b8046bea$export$938182bd3fddc3a8.displayName = "RedirectToLoginPage";
function $3f9a36d1b8046bea$var$ClientSideRedirect({ url: url }) {
    const { push: push } = (0, $55BnK.useRouterActions)();
    (0, $euxye.useEffect)(()=>{
        push(url);
    }, [
        push,
        url
    ]);
    return null;
}
$3f9a36d1b8046bea$var$ClientSideRedirect.displayName = "ClientSideRedirect";

});
parcelRegister("gDMcP", function(module, exports) {
$parcel$export(module.exports, "default", () => $27b9deb4e6df3b6e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $1uH7N = parcelRequire("1uH7N");
const $27b9deb4e6df3b6e$var$FullPageRedirect = ({ url: url })=>{
    (0, $1uH7N.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};
var $27b9deb4e6df3b6e$export$2e2bcd8739ae039 = $27b9deb4e6df3b6e$var$FullPageRedirect;

});



parcelRegister("3hvbE", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ac796b06b31b588$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $e2Tle = parcelRequire("e2Tle");

var $6CfY5 = parcelRequire("6CfY5");

var $drATu = parcelRequire("drATu");

var $6GVua = parcelRequire("6GVua");
const $9ac796b06b31b588$export$c2248d8896966a26 = (props)=>{
    const [state, setState] = (0, $euxye.useState)({
        applinkStatus: null,
        applinkEditPageData: null,
        isLoading: true
    });
    const doRefreshStatus = (0, $euxye.useCallback)(()=>{
        setState((prev)=>({
                ...prev,
                applinkStatus: null
            }));
        if (props.id) (0, $drATu.fetchApplinkStatus)(props.id).then((status)=>{
            setState((prev)=>({
                    ...prev,
                    applinkStatus: status
                }));
        }).catch((err)=>{
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.edit.refreshStatus', 'Failed to refresh applink status when requested by the edit form.', maybeError);
        });
    }, [
        props.id
    ]);
    (0, $euxye.useEffect)(()=>{
        const loadAllData = async ()=>{
            if (props.id === null) {
                (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.edit.loadAllData', 'Edit form was loaded but no applink id was provided');
                setState((prev)=>({
                        ...prev,
                        applinkEditPageData: null,
                        isLoading: false
                    }));
                return;
            }
            setState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            try {
                // Load applink data and status in parallel
                const [applinkData, status] = await Promise.all([
                    (0, $drATu.fetchApplink)(props.id),
                    (0, $drATu.fetchApplinkStatus)(props.id).catch((err)=>{
                        const maybeError = err instanceof Error ? err : undefined;
                        (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.edit.loadAllData', 'Failed to fetch applink status (as part of initial form load)', maybeError);
                        return null;
                    })
                ]);
                let pageData = null;
                if (applinkData.system) pageData = {
                    kind: 'ERROR',
                    err: 'NOT_EDITABLE'
                };
                else if (applinkData.data.isOAuth2) try {
                    const configInfo = await (0, $drATu.getOAuth2ConfigInfo)(applinkData.id);
                    pageData = {
                        kind: 'OAUTH2',
                        applink: applinkData,
                        oauth2ConfigInfo: configInfo
                    };
                } catch (err) {
                    const maybeError = err instanceof Error ? err : undefined;
                    (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.edit.loadAllData', 'Failed to fetch OAuth 2.0 config info (as part of initial form load)', maybeError);
                    pageData = {
                        kind: 'OAUTH2',
                        applink: applinkData,
                        oauth2ConfigInfo: null
                    };
                }
                else pageData = {
                    kind: 'OAUTH1',
                    applink: applinkData
                };
                setState({
                    applinkStatus: status,
                    applinkEditPageData: pageData,
                    isLoading: false
                });
            } catch (err) {
                const maybeError = err instanceof Error ? err : undefined;
                (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.edit.loadAllData', 'Failed to fetch applink data with miscellaneous error (as part of initial form load)', maybeError);
                setState((prev)=>({
                        ...prev,
                        applinkEditPageData: null,
                        isLoading: false
                    }));
            }
        };
        loadAllData();
    }, [
        props.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6GVua.default), {
        isLoading: state.isLoading,
        data: state.applinkEditPageData,
        status: state.applinkStatus,
        onRequestStatusRefresh: doRefreshStatus
    });
};
$9ac796b06b31b588$export$c2248d8896966a26.displayName = "ApplinksPage";
const $9ac796b06b31b588$var$Edit = (0, $e2Tle.withRouter)($9ac796b06b31b588$export$c2248d8896966a26);
var $9ac796b06b31b588$export$2e2bcd8739ae039 = $9ac796b06b31b588$var$Edit;

});
parcelRegister("drATu", function(module, exports) {
$parcel$export(module.exports, "fetchApplinks", () => $80ed225ce4ec1d7c$export$7d33a91e6040b0be);
$parcel$export(module.exports, "fetchApplink", () => $80ed225ce4ec1d7c$export$83c7eee86d1c94d8);
$parcel$export(module.exports, "putApplinkOAuthOne3LOProvider", () => $80ed225ce4ec1d7c$export$3dacb27b68ab90a0);
$parcel$export(module.exports, "putApplinkOAuthOne2LOProvider", () => $80ed225ce4ec1d7c$export$5c11b39b43a73f24);
$parcel$export(module.exports, "fetchApplinkStatus", () => $80ed225ce4ec1d7c$export$c2ced85273a49248);
$parcel$export(module.exports, "putApplinkOAuth1Config", () => $80ed225ce4ec1d7c$export$6d608f63c710962a);
$parcel$export(module.exports, "fetchApplinkManifestForUrl", () => $80ed225ce4ec1d7c$export$5c23e2a46ea336ab);
$parcel$export(module.exports, "fetchThisManifest", () => $80ed225ce4ec1d7c$export$48b19736241944be);
$parcel$export(module.exports, "putApplink", () => $80ed225ce4ec1d7c$export$a125e209bab7ab22);
$parcel$export(module.exports, "deleteApplink", () => $80ed225ce4ec1d7c$export$feb8ae153e366f15);
$parcel$export(module.exports, "createOAuth2Applink", () => $80ed225ce4ec1d7c$export$66ba448fdbc72aae);
$parcel$export(module.exports, "updateApplinkV3", () => $80ed225ce4ec1d7c$export$56336a061718f25b);
$parcel$export(module.exports, "getOAuth2ConfigInfo", () => $80ed225ce4ec1d7c$export$5647ab3ff2444637);
$parcel$export(module.exports, "putOAuth2ConfigInfo", () => $80ed225ce4ec1d7c$export$d1898e36341527c0);
$parcel$export(module.exports, "autoConfigureApplinkConsumer", () => $80ed225ce4ec1d7c$export$9e76392093878436);

var $4fhEY = parcelRequire("4fhEY");

var $h2wCv = parcelRequire("h2wCv");

var $i860n = parcelRequire("i860n");

var $1b6Nh = parcelRequire("1b6Nh");
const $80ed225ce4ec1d7c$export$7d33a91e6040b0be = ()=>(0, $4fhEY.default)((0, $1b6Nh.APPLINKS_V3_QUERY_URL));
const $80ed225ce4ec1d7c$export$83c7eee86d1c94d8 = (id)=>(0, $4fhEY.default)((0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') ? (0, $1b6Nh.APPLINKS_V3_CLOUD_CONNECTOR_QUERY_SINGULAR_URL)(id) : (0, $1b6Nh.APPLINKS_V3_QUERY_SINGULAR_URL)(id));
const $80ed225ce4ec1d7c$var$putApplinkProvider = (id, provider)=>(0, $4fhEY.default)(`/rest/applinks/3.0/applicationlink/${id}/authentication/provider`, {
        method: 'PUT',
        body: JSON.stringify({
            config: {},
            provider: provider
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$3dacb27b68ab90a0 = (id)=>$80ed225ce4ec1d7c$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.OAuthAuthenticationProvider');
const $80ed225ce4ec1d7c$export$5c11b39b43a73f24 = (id)=>$80ed225ce4ec1d7c$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.TwoLeggedOAuthAuthenticationProvider');
const $80ed225ce4ec1d7c$export$c2ced85273a49248 = (id)=>(0, $4fhEY.default)(`/rest/applinks/3.0/status/${id}`);
const $80ed225ce4ec1d7c$export$6d608f63c710962a = (id, oauthStatus)=>(0, $h2wCv.performPutRequest)(`/rest/applinks/3.0/status/${id}/oauth`, {
        body: JSON.stringify(oauthStatus),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$5c23e2a46ea336ab = (url)=>(0, $4fhEY.default)(`/rest/applinks/3.0/applicationlinkForm/manifest.json?url=${encodeURIComponent(url)}`);
const $80ed225ce4ec1d7c$export$48b19736241944be = ()=>(0, $4fhEY.default)('/rest/applinks/3.0/manifest.json');
const $80ed225ce4ec1d7c$export$a125e209bab7ab22 = (entity)=>(0, $4fhEY.default)('/rest/applinks/3.0/applicationlink', {
        method: 'PUT',
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$feb8ae153e366f15 = (id)=>(0, $4fhEY.default)(`/rest/applinks/3.0/applicationlink/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$66ba448fdbc72aae = (entity)=>(0, $4fhEY.default)('/rest/applinks/3.0/applinks', {
        method: 'POST',
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$56336a061718f25b = (id, entity)=>(0, $h2wCv.performPutRequest)(`/rest/applinks/3.0/applinks/${id}`, {
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$5647ab3ff2444637 = (id)=>(0, $4fhEY.default)(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$d1898e36341527c0 = (id, config)=>(0, $h2wCv.performPutRequest)(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
        body: JSON.stringify(config),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$9e76392093878436 = (id)=>(0, $4fhEY.default)(`/rest/applinks-oauth/1.0/applicationlink/${id}/authentication/consumer?autoConfigure=true`, {
        method: 'PUT',
        body: JSON.stringify({
            twoLOAllowed: true,
            executingTwoLOUser: null,
            twoLOImpersonationAllowed: false
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });

});
parcelRegister("1b6Nh", function(module, exports) {
$parcel$export(module.exports, "THIS_PRODUCT_NAME_STRING", () => $50e72a457c8c13e5$export$cb011d75c76c2448);
$parcel$export(module.exports, "APPLINKS_V3_QUERY_URL", () => $50e72a457c8c13e5$export$cb3573e4866c43b5);
$parcel$export(module.exports, "APPLINKS_V3_QUERY_SINGULAR_URL", () => $50e72a457c8c13e5$export$1f3cdd5be8767e2d);
$parcel$export(module.exports, "APPLINKS_V3_CLOUD_CONNECTOR_QUERY_SINGULAR_URL", () => $50e72a457c8c13e5$export$2927ddab97d46c37);
$parcel$export(module.exports, "APPLINKS_LIST_PAGE_URL_LEGACY", () => $50e72a457c8c13e5$export$2802d3ce755ebd3d);
$parcel$export(module.exports, "APPLINKS_LIST_PAGE_URL", () => $50e72a457c8c13e5$export$4b42a32ba8ad826e);
$parcel$export(module.exports, "APPLINKS_EDIT_PAGE_URL_FOR_ID", () => $50e72a457c8c13e5$export$d55239c5fe633298);
$parcel$export(module.exports, "APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK", () => $50e72a457c8c13e5$export$2b004bc5d3a0b021);
const $50e72a457c8c13e5$export$cb011d75c76c2448 = 'Jira';
const $50e72a457c8c13e5$export$cb3573e4866c43b5 = '/rest/applinks/3.0/applinks?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems';
const $50e72a457c8c13e5$export$1f3cdd5be8767e2d = (id)=>`/rest/applinks/3.0/applinks/${id}?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems`;
const $50e72a457c8c13e5$export$2927ddab97d46c37 = (id)=>`${$50e72a457c8c13e5$export$1f3cdd5be8767e2d(id)}&property=CLOUD_CONNECTOR_PRODUCT_CONNECTION_ID`;
const $50e72a457c8c13e5$export$2802d3ce755ebd3d = '/plugins/servlet/applinks/listApplicationLinks';
const $50e72a457c8c13e5$export$4b42a32ba8ad826e = '/jira/settings/applinks';
const $50e72a457c8c13e5$export$d55239c5fe633298 = (id)=>`/jira/settings/applinks/${id}/edit`;
const $50e72a457c8c13e5$export$2b004bc5d3a0b021 = 'com.atlassian.applinks.api.auth.types.ThreeLeggedOAuth2AuthenticationProvider';

});


parcelRegister("6GVua", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b85c48c79875fac$export$2e2bcd8739ae039);
/* ApplinksEditPageContents.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $h8QGu = parcelRequire("h8QGu");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $abhF2 = parcelRequire("abhF2");

var $j26jU = parcelRequire("j26jU");

var $9ufM9 = parcelRequire("9ufM9");

var $1aFF7 = parcelRequire("1aFF7");

var $jooSv = parcelRequire("jooSv");

var $8LNQ0 = parcelRequire("8LNQ0");

var $bwVQC = parcelRequire("bwVQC");

var $fnihK = parcelRequire("fnihK");

var $3mYdc = parcelRequire("3mYdc");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $cFFXQ = parcelRequire("cFFXQ");

var $5T7Xn = parcelRequire("5T7Xn");

var $1b6Nh = parcelRequire("1b6Nh");

var $4Sn7I = parcelRequire("4Sn7I");

var $9xWqG = parcelRequire("9xWqG");

var $6bB9L = parcelRequire("6bB9L");

var $5BRzv = parcelRequire("5BRzv");

var $1gtXf = parcelRequire("1gtXf");
const $5b85c48c79875fac$var$applicationLinksTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Application links",
    id: "applinks.administration.ui.application-links-title"
});
const $5b85c48c79875fac$var$seeAllApplinksButtonMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "See all application links",
    id: "applinks.administration.ui.edit.see-all-application-links-button"
});
const $5b85c48c79875fac$var$applinkNotFoundHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Application link not found",
    id: "applinks.administration.ui.edit.applink-not-found-header"
});
const $5b85c48c79875fac$var$applinkNotFoundDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "The application link you're trying to edit does not exist or has been deleted.",
    id: "applinks.administration.ui.edit.applink-not-found-description"
});
const $5b85c48c79875fac$var$applinkNotEditableHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Non-editable system link",
    id: "applinks.administration.ui.edit.applink-not-editable-header"
});
const $5b85c48c79875fac$var$editMainTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Edit application link",
    id: "applinks.administration.ui.edit.main.title"
});
const $5b85c48c79875fac$var$securedByMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Secured by {authMethod}",
    id: "applinks.administration.ui.edit.secured-by-message"
});
const $5b85c48c79875fac$var$productCardHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Linked application",
    id: "applinks.administration.ui.edit.product-card-header"
});
const $5b85c48c79875fac$var$errorFlagTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Failed to update application link",
    id: "applinks.administration.ui.edit.error-flag-title"
});
const $5b85c48c79875fac$var$systemLinkDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.system-link-description",
    defaultMessage: "This is an internal link created automatically by the system. System internal links are read-only and cannot be edited."
});
const $5b85c48c79875fac$var$styles = {
    applinksPageContents: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f5o3v _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $5b85c48c79875fac$var$DisplayError = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $5b85c48c79875fac$var$styles.applinksPageContents
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        header: props.header,
        description: props.description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
            href: "/plugins/servlet/applinks/listApplicationLinks",
            appearance: "primary"
        }, formatMessage($5b85c48c79875fac$var$seeAllApplinksButtonMessage))
    }));
};
$5b85c48c79875fac$var$DisplayError.displayName = "DisplayError";
const $5b85c48c79875fac$var$ApplinksEditPageContents = (props)=>{
    const [errorFlags, setErrorFlags] = (0, $euxye.useState)([]);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const breadcrumbs = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1aFF7.default), {
            onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jooSv.default), {
            text: formatMessage($5b85c48c79875fac$var$applicationLinksTitleMessage),
            key: "Application Links",
            href: (0, $1b6Nh.APPLINKS_LIST_PAGE_URL)
        })), [
        formatMessage
    ]);
    const addFlag = (0, $euxye.useCallback)((err)=>{
        const newFlags = errorFlags.slice();
        newFlags.splice(0, 0, err);
        setErrorFlags(newFlags);
    }, [
        errorFlags
    ]);
    const handleDismiss = ()=>{
        setErrorFlags(errorFlags.slice(1));
    };
    const renderStatusError = (0, $euxye.useCallback)(()=>{
        if (props.status && !props.status.working) {
            if ((0, $i860n.fg)('olympus-1101-fix-disabled-error')) {
                const matchedError = props.status.error && props.status.error.type in (0, $9xWqG.ERRORS) ? (0, $9xWqG.ERRORS)[props.status.error.type] : (0, $9xWqG.ERRORS).UNKNOWN; // Don't show a status message for a "disabled" error state
                if (matchedError === (0, $9xWqG.ERRORS).DISABLED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4Sn7I.ErrorStatusSectionMessage), {
                    err: matchedError,
                    context: props.status
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4Sn7I.ErrorStatusSectionMessage), {
                err: props.status.error ? (0, $9xWqG.ERRORS)[props.status.error.type] : (0, $9xWqG.ERRORS).UNKNOWN,
                context: props.status
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
    }, [
        props.status
    ]);
    const renderContents = (0, $euxye.useCallback)(()=>{
        if (props.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
            alignInline: "center",
            space: "space.100",
            xcss: $5b85c48c79875fac$var$styles.applinksPageContents
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), null));
        if (props.data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5b85c48c79875fac$var$DisplayError, {
            header: formatMessage($5b85c48c79875fac$var$applinkNotFoundHeaderMessage),
            description: formatMessage($5b85c48c79875fac$var$applinkNotFoundDescriptionMessage)
        });
        if (props.data.kind === 'ERROR') {
            props.data.err;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5b85c48c79875fac$var$DisplayError, {
                header: formatMessage($5b85c48c79875fac$var$applinkNotEditableHeaderMessage),
                description: formatMessage($5b85c48c79875fac$var$systemLinkDescriptionMessage)
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            grow: "fill",
            xcss: $5b85c48c79875fac$var$styles.applinksPageContents
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bwVQC.default), {
            breadcrumbs: breadcrumbs()
        }, formatMessage($5b85c48c79875fac$var$editMainTitleMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8LNQ0))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($5b85c48c79875fac$var$securedByMessage, {
            authMethod: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                as: "strong"
            }, props.data.applink.data.isOAuth2 ? 'OAuth 2.0' : 'OAuth 1.0')
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default), {
            applicationType: (0, $5T7Xn.lookupTypeByTypeId)(props.data.applink.type, false),
            displayUrl: props.data.applink.displayUrl,
            heading: formatMessage($5b85c48c79875fac$var$productCardHeaderMessage),
            statusLozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozengeV3), {
                status: props.status
            })
        }), renderStatusError()), props.data.kind === 'OAUTH2' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BRzv.default), {
            applink: props.data.applink,
            oauth2ConfigInfo: props.data.oauth2ConfigInfo,
            onDisplayError: addFlag,
            onRequestStatusRefresh: props.onRequestStatusRefresh
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1gtXf.default), {
            applink: props.data.applink,
            status: props.status,
            onDisplayError: addFlag
        }));
    }, [
        addFlag,
        breadcrumbs,
        formatMessage,
        props.data,
        props.isLoading,
        props.onRequestStatusRefresh,
        props.status,
        renderStatusError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "applinks-administration-edit-page",
        teamName: "olympus",
        packageName: "applinksAdministrationEditPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fnihK.ModalContextProvider), null, renderContents()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.FlagGroup), {
        onDismissed: handleDismiss
    }, errorFlags.map((err, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.ErrorFlag), {
            id: `flag-${idx}`,
            testId: `applinks-administration.ui.edit.error-flag-${idx}`,
            key: `flag-${idx}`,
            title: formatMessage($5b85c48c79875fac$var$errorFlagTitleMessage),
            description: err
        });
    }))));
};
$5b85c48c79875fac$var$ApplinksEditPageContents.displayName = "ApplinksEditPageContents";
var $5b85c48c79875fac$export$2e2bcd8739ae039 = $5b85c48c79875fac$var$ApplinksEditPageContents;

});
parcelRegister("1aFF7", function(module, exports) {
$parcel$export(module.exports, "default", () => $95fbafcb472c4a39$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $aZBDA = parcelRequire("aZBDA");

var $u9iDa = parcelRequire("u9iDa");

var $ljVHR = parcelRequire("ljVHR");

var $2oRWW = parcelRequire("2oRWW");

var $egspI = parcelRequire("egspI");

var $dOHRe = parcelRequire("dOHRe");

var $h8uaa = parcelRequire("h8uaa");

var $3VQeg = parcelRequire("3VQeg");

var $4FlWq = parcelRequire("4FlWq");

var $gZYsx = parcelRequire("gZYsx");

var $cvARM = parcelRequire("cvARM");
const $95fbafcb472c4a39$var$defaultMaxItems = 8;
const $95fbafcb472c4a39$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $95fbafcb472c4a39$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $95fbafcb472c4a39$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children;
const $95fbafcb472c4a39$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $95fbafcb472c4a39$var$noop = (0, $2oRWW.default);
const $95fbafcb472c4a39$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $95fbafcb472c4a39$var$breadcrumbStylesOld = null;
const $95fbafcb472c4a39$var$breadcrumbStylesNew = null;
const $95fbafcb472c4a39$var$navStylesNew = null;
const $95fbafcb472c4a39$var$ellipsisItemWrapperStyles = null; // items will get collapsed into ellipsis dropdown
// therefore they are no longer rendered in the DOM
// they need to be passed in to the dropdown
function $95fbafcb472c4a39$var$getItemProps(child) {
    const { text: text, href: href, onClick: onClick, target: target } = child.props;
    const wrappedOnClick = onClick ? (event)=>{
        // Collapsed dropdown items can be activated via keyboard, but the
        // original BreadcrumbsItem onClick contract is mouse-based.
        if ('button' in event) onClick(event);
    } : undefined;
    return {
        text: text ?? '',
        href: href,
        onClick: wrappedOnClick,
        target: target
    };
}
function $95fbafcb472c4a39$var$cloneBreadcrumbChild(child, index, itemCount, registerItem) {
    const isLast = index === itemCount - 1;
    const isCurrentItem = child.type === (0, $dOHRe.default);
    return(// eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(child, {
        key: child.key ?? index,
        _overflowRef: registerItem(index),
        ...isLast && !isCurrentItem ? {
            'aria-current': 'page'
        } : {}
    }));
}
const $95fbafcb472c4a39$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    if ((0, $egspI.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $e79Pd.jsx)($95fbafcb472c4a39$var$InnerBreadcrumbsNew, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($95fbafcb472c4a39$var$InnerBreadcrumbsOld, {
        ...props,
        ref: ref
    });
});
const $95fbafcb472c4a39$var$InnerBreadcrumbsOld = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $95fbafcb472c4a39$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $95fbafcb472c4a39$var$noop, analyticsContext: analyticsContext, label: label = $95fbafcb472c4a39$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $95fbafcb472c4a39$var$defaultEllipsisLabel, size: size = 'medium' } = props;
    const [expanded, setExpanse] = (0, $euxye.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $euxye.useState)(false);
    const wrapperRef = (0, $euxye.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $95fbafcb472c4a39$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $euxye.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($95fbafcb472c4a39$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $gZYsx.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $u9iDa.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$95fbafcb472c4a39$var$analyticsAttributes
    });
    const childrenArray = $95fbafcb472c4a39$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $h8uaa.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3VQeg.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("nav", {
            "aria-label": label,
            ref: (0, $ljVHR.default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)("ol", {
                "data-testid": testId,
                className: (0, $4jQY2.default)([
                    "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
                ]),
                children: breadcrumbsItems
            })
        })
    });
});
const $95fbafcb472c4a39$var$InnerBreadcrumbsNew = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { children: children = [], testId: testId, analyticsContext: analyticsContext, label: label = $95fbafcb472c4a39$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $95fbafcb472c4a39$var$defaultEllipsisLabel, size: size = 'medium', createAnalyticsEvent: _createAnalyticsEvent } = props;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).isValidElement(child));
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $cvARM.default)(itemCount);
    const handleOverflowExpansion = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: $95fbafcb472c4a39$var$noop,
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$95fbafcb472c4a39$var$analyticsAttributes
    });
    const collapsedItems = Array.from(collapsedIndices).sort((a, b)=>a - b).map((i)=>$95fbafcb472c4a39$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child, index)=>{
        const isCollapsed = collapsedIndices.has(index);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                    className: (0, $4jQY2.default)([
                        "_1e0c1txw _vchhusvi _4cvr1h6o _2lx2vrvc _1o9zidpf _1wpz1h6o _1pfhze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1h6o _14rn1rpy _aetr1n76 _8yoa1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4FlWq.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($95fbafcb472c4a39$var$cloneBreadcrumbChild(child, index, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child, index)=>$95fbafcb472c4a39$var$cloneBreadcrumbChild(child, index, itemCount, registerItem)) : null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3VQeg.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: (0, $4jQY2.default)([
                "_1reo15vq _18m915vq _1ul9idpf"
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)("ol", {
                "data-testid": testId,
                ref: registerContainer,
                className: (0, $4jQY2.default)([
                    "_1reo15vq _18m915vq _1e0c1txw _1ul9idpf _4cvr1q9y _1n261q9c _2mzuglyw _6rthidpf _1pfhidpf _12l2idpf _ahbqidpf _85i5idpf _1q51idpf _y4tiidpf _bozgidpf"
                ]),
                children: naturalWidthsReady ? renderedItems : measureItems
            })
        })
    });
});
const $95fbafcb472c4a39$var$Breadcrumbs = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $e79Pd.jsx)($95fbafcb472c4a39$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        size: size,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $95fbafcb472c4a39$export$2e2bcd8739ae039 = $95fbafcb472c4a39$var$Breadcrumbs;

});
parcelRegister("dOHRe", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1364121608a9216$export$2e2bcd8739ae039);
/* breadcrumbs-current-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $m9iwH = parcelRequire("m9iwH");

var $ljVHR = parcelRequire("ljVHR");

var $2oRWW = parcelRequire("2oRWW");

var $67bq1 = parcelRequire("67bq1");

var $egspI = parcelRequire("egspI");

var $hZDXn = parcelRequire("hZDXn");

var $lSd15 = parcelRequire("lSd15");

var $hgd7R = parcelRequire("hgd7R");
const $c1364121608a9216$var$COPY_RESET_DELAY_MS = 2000;
const $c1364121608a9216$var$ICON_WIDTH_ESTIMATE = 24;
const $c1364121608a9216$var$VAR_CURRENT_ITEM_TRUNCATION_WIDTH = '--breadcrumbs-current-item-max-width';
const $c1364121608a9216$var$unboundedStyles = {
    container: "_zulp1b66 _2rko12b0 _1rjcv77o _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k8s _1ql7kb7n",
    interactiveContainer: "_zulp1b66 _4bfu18uv _1hmsglyw _ajmmnqa1 _11c8fhey _1e0c116y _4cvr1h6o _vchhusvi _syazi7uo _9oik18uv _1bnx8stv _jf4cnqa1 _30l3i7uo _9h8hi7uo",
    interactiveContainerSmall: "_11c8wadc",
    interactiveContainerLegacy: "_4t3i1k8s",
    interactiveContainerWithTruncation: "_1ul9idpf _p12fmvrb _1o9zkb7n",
    itemWrapper: "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _1wpz1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
    copyButtonWrapper: "_1e0c116y _tzy4idpf _gwqekb7n _1mygkb7n",
    iconWrapper: "_syaz1cv2",
    iconWrapperSmall: "_w8l57vkz _17527vkz"
};
const $c1364121608a9216$var$styles = {
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperExternal: "_12l2v77o",
    iconWrapperExternalSmall: "_12l2ze3t",
    text: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textSmall: "_11c8wadc _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
const $c1364121608a9216$var$BreadcrumbsCurrentItem = /*#__PURE__*/ (0, $euxye.memo)(({ text: text, href: href, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef })=>{
    const isSmall = (0, $lSd15.useBreadcrumbsSize)() === 'small';
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $euxye.useState)(false);
    const [linkElement, setLinkElement] = (0, $euxye.useState)(null);
    const resetTimerRef = (0, $euxye.useRef)(null);
    const setLinkRef = (0, $euxye.useCallback)((element)=>{
        setLinkElement(element);
    }, []);
    const [, shouldShowTooltip] = (0, $hgd7R.default)(truncationWidth, linkElement, (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') ? 0 : resolvedElemBefore ? $c1364121608a9216$var$ICON_WIDTH_ESTIMATE : 0);
    const handleCopy = (0, $euxye.useCallback)(()=>{
        if (!navigator.clipboard) return;
        const url = new URL(href, window.location.href).href;
        navigator.clipboard.writeText(url).then(()=>{
            setCopied(true);
            onCopyLink?.();
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            resetTimerRef.current = setTimeout(()=>{
                setCopied(false);
            }, $c1364121608a9216$var$COPY_RESET_DELAY_MS);
        }, (0, $2oRWW.default));
    }, [
        href,
        onCopyLink
    ]);
    (0, $euxye.useEffect)(()=>()=>{
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        }, []);
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $4jQY2.default)([
            $c1364121608a9216$var$styles.iconWrapper,
            $c1364121608a9216$var$unboundedStyles.iconWrapper,
            (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && $c1364121608a9216$var$styles.iconWrapperExternal,
            isSmall && $c1364121608a9216$var$styles.iconWrapperExternalSmall,
            isSmall && $c1364121608a9216$var$unboundedStyles.iconWrapperSmall
        ]),
        children: resolvedElemBefore
    });
    const textElement = /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            isSmall && $c1364121608a9216$var$styles.textSmall,
            !isSmall && $c1364121608a9216$var$styles.text,
            truncationWidth && $c1364121608a9216$var$styles.textWithTruncation
        ]),
        children: text
    });
    const renderLink = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ (0, $e79Pd.jsxs)("a", {
            href: href,
            "aria-current": "page",
            "data-testid": testId,
            ref: tooltipRef ? (0, $ljVHR.default)([
                setLinkRef,
                tooltipRef
            ]) : setLinkRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: truncationWidth ? {
                '--breadcrumbs-current-item-max-width': `${truncationWidth}px`
            } : undefined,
            ...tooltipTriggerProps,
            className: (0, $4jQY2.default)([
                $c1364121608a9216$var$unboundedStyles.interactiveContainer,
                !(0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && $c1364121608a9216$var$unboundedStyles.interactiveContainerLegacy,
                isSmall && $c1364121608a9216$var$unboundedStyles.interactiveContainerSmall,
                truncationWidth && $c1364121608a9216$var$unboundedStyles.interactiveContainerWithTruncation
            ]),
            children: [
                !(0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                textElement
            ]
        });
    };
    const copyButton = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: copied ? 'Copied!' : 'Copy link',
        position: "bottom",
        children: (tooltipProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $4jQY2.default)([
                    $c1364121608a9216$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($67bq1))),
                    isTooltipDisabled: true,
                    label: copied ? 'Link copied' : 'Copy link',
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
        ref: _overflowRef,
        "data-breadcrumbs-current-item": true,
        className: (0, $4jQY2.default)([
            $c1364121608a9216$var$unboundedStyles.itemWrapper
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
            className: (0, $4jQY2.default)([
                $c1364121608a9216$var$unboundedStyles.container
            ]),
            children: [
                (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                shouldShowTooltip ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                    content: text,
                    position: "bottom",
                    onShow: onTooltipShown,
                    children: renderLink
                }) : renderLink(),
                copyButton
            ]
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c1364121608a9216$export$2e2bcd8739ae039 = $c1364121608a9216$var$BreadcrumbsCurrentItem;

});
parcelRegister("67bq1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $473c41060d98e515$var$_react = $473c41060d98e515$var$_interopRequireDefault((parcelRequire("euxye")));

var $473c41060d98e515$var$_baseNew = $473c41060d98e515$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $473c41060d98e515$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $473c41060d98e515$var$LinkIcon = (props)=>/*#__PURE__*/ $473c41060d98e515$var$_react.default.createElement($473c41060d98e515$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$473c41060d98e515$var$LinkIcon.displayName = 'LinkIcon';
var $473c41060d98e515$var$_default = module.exports.default = $473c41060d98e515$var$LinkIcon;

});

parcelRegister("lSd15", function(module, exports) {
$parcel$export(module.exports, "useBreadcrumbsSize", () => $507d474913b97b7a$export$c60a2bbc99661fa2);

var $euxye = parcelRequire("euxye");

var $lDaik = parcelRequire("lDaik");
function $507d474913b97b7a$export$c60a2bbc99661fa2() {
    return (0, $euxye.useContext)((0, $lDaik.default));
}

});
parcelRegister("lDaik", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3465735936cf075$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
/**
 * Shared breadcrumbs size context for the primitives API and refreshed composed breadcrumbs.
 */ const $f3465735936cf075$var$BreadcrumbsSizeContext = /*#__PURE__*/ (0, $euxye.createContext)('medium');
var $f3465735936cf075$export$2e2bcd8739ae039 = $f3465735936cf075$var$BreadcrumbsSizeContext;

});


parcelRegister("hgd7R", function(module, exports) {
$parcel$export(module.exports, "default", () => $d50f235172957737$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $d50f235172957737$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $euxye.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $euxye.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $euxye.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("h8uaa", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ab0321adfab3b4a$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1MNmN = parcelRequire("1MNmN");

var $2oRWW = parcelRequire("2oRWW");

var $6mEZn = parcelRequire("6mEZn");

var $lSd15 = parcelRequire("lSd15");
const $4ab0321adfab3b4a$var$noop = (0, $2oRWW.default);
const $4ab0321adfab3b4a$var$itemWrapperStyles = null;
const $4ab0321adfab3b4a$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk1w7a _syaz1rpy _1e0c116y _4cvr1h6o _1wpz1h6o _1pfhze3t _1a3b18uv _4fprglyw _5goinqa1 _f8pj1rpy _9oik18uv _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc"
};
const $4ab0321adfab3b4a$var$EllipsisItem = /*#__PURE__*/ (0, $euxye.memo)(({ label: label, onClick: onClick = $4ab0321adfab3b4a$var$noop, testId: testId })=>{
    const breadcrumbsSize = (0, $lSd15.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    return /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
        className: (0, $4jQY2.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
            "aria-label": label,
            onClick: onClick,
            xcss: (0, $1MNmN.cx)($4ab0321adfab3b4a$var$styles.root, isSmall && $4ab0321adfab3b4a$var$styles.rootSmall),
            testId: testId,
            children: "\u2026"
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ab0321adfab3b4a$export$2e2bcd8739ae039 = $4ab0321adfab3b4a$var$EllipsisItem;

});

parcelRegister("3VQeg", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbsSizeProvider", () => $36782288d9bead52$export$2295e777093f3940);

var $lDaik = parcelRequire("lDaik");
const $36782288d9bead52$export$2295e777093f3940 = (0, $lDaik.default).Provider;

});

parcelRegister("4FlWq", function(module, exports) {
$parcel$export(module.exports, "default", () => $7181e661cc5aaf13$export$2e2bcd8739ae039);
/* ellipsis-popup.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $m9iwH = parcelRequire("m9iwH");

var $jaPl6 = parcelRequire("jaPl6");
var $2YPKP = parcelRequire("2YPKP");
var $2Xkyn = parcelRequire("2Xkyn");

var $7Fzpe = parcelRequire("7Fzpe");
const $7181e661cc5aaf13$var$groupWrapperStyles = null;
function $7181e661cc5aaf13$export$2e2bcd8739ae039({ collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jaPl6.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps })=>{
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        },
        placement: "bottom-start",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            className: (0, $4jQY2.default)([
                "_p12f1y37"
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2Xkyn.default), {
                children: collapsedItems.map((item, i)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
                        href: item.href,
                        target: item.target,
                        onClick: item.onClick,
                        children: item.text
                    }, i))
            })
        })
    });
}
$7181e661cc5aaf13$export$2e2bcd8739ae039.displayName = "EllipsisPopup";

});

parcelRegister("gZYsx", function(module, exports) {
$parcel$export(module.exports, "useOnRevealed", () => $bc047036a98d796c$export$e9c4922b2ecf808a);

var $euxye = parcelRequire("euxye");

var $gQ56h = parcelRequire("gQ56h");
function $bc047036a98d796c$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $gQ56h.default)(isExpanded);
    (0, $euxye.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});

parcelRegister("cvARM", function(module, exports) {
$parcel$export(module.exports, "default", () => $be2d36a27ff4b27e$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
// The ellipsis trigger is a compact IconButton (24px) plus the trailing separator (24px).
const $be2d36a27ff4b27e$var$ELLIPSIS_WIDTH_ESTIMATE = 48;
// Measurements need layout timing in the browser, but should be a no-op for SSR.
const $be2d36a27ff4b27e$var$useLayoutEffect = typeof window === 'undefined' ? (0, $euxye.useEffect) : (0, $euxye.useLayoutEffect);
function $be2d36a27ff4b27e$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const v of a){
        if (!b.has(v)) return false;
    }
    return true;
}
function $be2d36a27ff4b27e$var$getMiddleOutCollapseOrder(itemCount) {
    const lastIndex = itemCount - 1;
    const middleIndex = Math.floor((itemCount - 1) / 2);
    const collapseOrder = [];
    if (middleIndex > 0 && middleIndex < lastIndex) collapseOrder.push(middleIndex);
    for(let distance = 1; distance < itemCount; distance++){
        const leftIndex = middleIndex - distance;
        const rightIndex = middleIndex + distance;
        if (leftIndex > 0) collapseOrder.push(leftIndex);
        if (rightIndex < lastIndex) collapseOrder.push(rightIndex);
    }
    return collapseOrder;
}
function $be2d36a27ff4b27e$export$2e2bcd8739ae039(itemCount) {
    const itemRefs = (0, $euxye.useRef)([]);
    const containerRef = (0, $euxye.useRef)(null);
    const naturalWidths = (0, $euxye.useRef)([]);
    const naturalWidthsReady = (0, $euxye.useRef)(false);
    const [naturalWidthsReadyState, setNaturalWidthsReadyState] = (0, $euxye.useState)(false);
    const [collapsedIndices, setCollapsedIndices] = (0, $euxye.useState)(new Set());
    // Intentionally runs after each render until refs have committed and natural widths are measured.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $be2d36a27ff4b27e$var$useLayoutEffect(()=>{
        if (naturalWidthsReady.current) return;
        const widths = itemRefs.current.map((el)=>el?.offsetWidth ?? 0);
        if (widths.some((w)=>w > 0)) {
            naturalWidths.current = widths;
            naturalWidthsReady.current = true;
            setNaturalWidthsReadyState(true);
        }
    });
    const recalculate = (0, $euxye.useCallback)(()=>{
        const container = containerRef.current;
        if (!container || !naturalWidthsReady.current) return;
        const availableWidth = container.offsetWidth;
        const widths = naturalWidths.current;
        if (itemCount <= 2) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0);
        if (totalWidth <= availableWidth) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        let usedWidth = totalWidth;
        const newCollapsed = new Set();
        for (const index of $be2d36a27ff4b27e$var$getMiddleOutCollapseOrder(itemCount)){
            if (newCollapsed.size === 0) usedWidth += $be2d36a27ff4b27e$var$ELLIPSIS_WIDTH_ESTIMATE;
            newCollapsed.add(index);
            usedWidth -= widths[index] ?? 0;
            if (usedWidth <= availableWidth) break;
        }
        // At the smallest sizes, even first + ellipsis + last may not fit.
        // In that case, also collapse the first item so only ellipsis + last is shown.
        // Note: this branch is only reachable when itemCount > 2 (the early return above
        // handles itemCount <= 2), so collapsing index 0 here always leaves at least one
        // visible item (the last) plus the ellipsis trigger.
        if (usedWidth > availableWidth) newCollapsed.add(0);
        setCollapsedIndices((prev)=>$be2d36a27ff4b27e$var$setsEqual(prev, newCollapsed) ? prev : newCollapsed);
    }, [
        itemCount
    ]);
    const registerItem = (0, $euxye.useCallback)((index)=>(el)=>{
            itemRefs.current[index] = el;
        }, []);
    const observerRef = (0, $euxye.useRef)(null);
    const registerContainer = (0, $euxye.useCallback)((el)=>{
        // Disconnect any existing observer
        observerRef.current?.disconnect();
        containerRef.current = el;
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') return;
        // Set up ResizeObserver immediately when container mounts
        const observer = new ResizeObserver(()=>{
            recalculate();
        });
        observer.observe(el);
        observerRef.current = observer;
    }, [
        recalculate
    ]);
    (0, $euxye.useEffect)(()=>{
        if (naturalWidthsReadyState) recalculate();
    }, [
        naturalWidthsReadyState,
        recalculate
    ]);
    // Cleanup observer on unmount
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    (0, $euxye.useEffect)(()=>{
        naturalWidthsReady.current = false;
        naturalWidths.current = [];
        setNaturalWidthsReadyState(false);
        setCollapsedIndices(new Set());
    }, [
        itemCount
    ]);
    return {
        collapsedIndices: collapsedIndices,
        naturalWidthsReady: naturalWidthsReadyState,
        registerItem: registerItem,
        registerContainer: registerContainer
    };
}

});


parcelRegister("jooSv", function(module, exports) {
$parcel$export(module.exports, "default", () => $1183f3b16e7bcf3b$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");

var $hZDXn = parcelRequire("hZDXn");

var $cHuIm = parcelRequire("cHuIm");

var $dtG5Q = parcelRequire("dtG5Q");

var $4sio5 = parcelRequire("4sio5");

var $hgd7R = parcelRequire("hgd7R");
const $1183f3b16e7bcf3b$var$itemWrapperStyles = null;
const $1183f3b16e7bcf3b$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $1183f3b16e7bcf3b$var$ICON_WIDTH_ESTIMATE = 24;
const $1183f3b16e7bcf3b$var$staticItemStyles = null;
const $1183f3b16e7bcf3b$var$staticItemWithTruncationStyles = null;
const $1183f3b16e7bcf3b$var$staticItemWithoutTruncationStyles = null;
const $1183f3b16e7bcf3b$var$BreadcrumbsItem = /*#__PURE__*/ (0, $euxye.memo)(({ analyticsContext: analyticsContext, component: component, // Analytics event creation comes from context via usePlatformLeafEventHandler.
// Strip this prop so it cannot leak onto DOM-backed controls.
createAnalyticsEvent: _createAnalyticsEvent, href: href, elemBefore: elemBefore, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, // This is overridden by the `buttonRef` below
ref: _ref, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, _overflowRef: _overflowRef, ...rest })=>{
    const [stepElement, setStepElement] = (0, $euxye.useState)(null);
    const setStepRef = (0, $euxye.useCallback)((element)=>{
        setStepElement(element);
    }, []);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    let iconWidthAllowance = 0;
    if (resolvedElemBefore) iconWidthAllowance += $1183f3b16e7bcf3b$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $1183f3b16e7bcf3b$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, shouldShowTooltip] = (0, $hgd7R.default)(truncationWidth, stepElement, (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') ? 0 : iconWidthAllowance);
    if (!component && (0, $egspI.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cHuIm.default), {
        ref: _overflowRef,
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        elemBefore: resolvedElemBefore,
        href: href,
        // TODO(CAT-2913): Remove `iconAfter` from the refresh path once Jira stops depending on deprecated
        // `BreadcrumbsItem.iconAfter` in `src/packages/polaris/component-ideas-idea-view/tests/IssueKey.test.tsx`
        // and `src/packages/polaris/component-ideas-idea-view/tests/IssueBreadcrumbs.test.tsx`.
        // Those consumers need to move the copy-link affordance out of `BreadcrumbsItem` first.
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        onTooltipShown: onTooltipShown,
        shouldShowTooltip: shouldShowTooltip,
        stepRef: setStepRef,
        target: target,
        testId: testId,
        text: text,
        title: title,
        truncationWidth: truncationWidth,
        "aria-current": ariaCurrent
    });
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$1183f3b16e7bcf3b$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dtG5Q.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        truncationWidth: truncationWidth,
        ...rest,
        children: text
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4sio5.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: resolvedElemBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        ...rest,
        className: (0, $4jQY2.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
        ref: _overflowRef,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _4cvr1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1183f3b16e7bcf3b$export$2e2bcd8739ae039 = $1183f3b16e7bcf3b$var$BreadcrumbsItem;

});
parcelRegister("cHuIm", function(module, exports) {
$parcel$export(module.exports, "default", () => $bac610f7cf9fa8d9$export$2e2bcd8739ae039);
/* breadcrumbs-item-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ljVHR = parcelRequire("ljVHR");

var $hZDXn = parcelRequire("hZDXn");

var $dtG5Q = parcelRequire("dtG5Q");
const $bac610f7cf9fa8d9$var$itemWrapperStyles = null;
const $bac610f7cf9fa8d9$var$BreadcrumbsItemBase = /*#__PURE__*/ (0, $euxye.forwardRef)(({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const renderStep = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dtG5Q.default), {
            ref: tooltipRef ? (0, $ljVHR.default)([
                stepRef,
                tooltipRef
            ]) : stepRef,
            analyticsContext: analyticsContext,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-current": ariaCurrent,
            elemBefore: resolvedElemBefore,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            target: target,
            testId: testId,
            title: title,
            triggerProps: triggerProps ? tooltipTriggerProps : undefined,
            truncationWidth: truncationWidth,
            children: text
        });
    };
    const step = renderStep();
    return /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required for public xcss passthrough
        className: (0, $4jQY2.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _2lx2vrvc _1wpz1h6o _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1q9y _14rn1rpy _aetr1n76 _8yoa1h6o",
            xcss
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bac610f7cf9fa8d9$export$2e2bcd8739ae039 = $bac610f7cf9fa8d9$var$BreadcrumbsItemBase;

});
parcelRegister("dtG5Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $80bd2e5fae3d76d3$export$2e2bcd8739ae039);
/* step.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $aZBDA = parcelRequire("aZBDA");

var $1MNmN = parcelRequire("1MNmN");

var $2oRWW = parcelRequire("2oRWW");

var $egspI = parcelRequire("egspI");

var $9MWap = parcelRequire("9MWap");
var $6mEZn = parcelRequire("6mEZn");

var $lSd15 = parcelRequire("lSd15");
const $80bd2e5fae3d76d3$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $80bd2e5fae3d76d3$var$noop = (0, $2oRWW.default);
const $80bd2e5fae3d76d3$var$styles = {
    root: "_11c8fhey _19itglyw _zulp1b66 _2rko12b0 _4bfu18uv _1hmsglyw _ajmmnqa1 _18zrze3t _bfhk1w7a _syaz1rpy _1e0c116y _4cvr1h6o _1a3b18uv _4fprglyw _5goinqa1 _f8pj1rpy _9oik18uv _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc",
    rootRefresh: "_vchhusvi _4t3i1k8s",
    rootT26Shape: "_2rkolb4i",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    withTruncation: "_1ul9idpf",
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperExternal: "_12l2v77o",
    iconWrapperExternalSmall: "_12l2ze3t",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
const $80bd2e5fae3d76d3$var$unboundedStyles = {
    iconWrapperSmall: "_w8l57vkz _17527vkz",
    iconWrapper: "_syaz1cv2"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $80bd2e5fae3d76d3$var$Step = /*#__PURE__*/ (0, $euxye.forwardRef)(({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $80bd2e5fae3d76d3$var$noop, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, 'aria-describedby': ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $lSd15.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    const handleClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$80bd2e5fae3d76d3$var$analyticsAttributes
    });
    const handleTriggerClick = (event)=>{
        triggerProps?.onClick?.(event);
        handleClick(event);
    };
    const controlRef = (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') ? ref : undefined;
    const textRef = (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') ? undefined : ref;
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $4jQY2.default)([
            $80bd2e5fae3d76d3$var$styles.iconWrapper,
            $80bd2e5fae3d76d3$var$unboundedStyles.iconWrapper,
            (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && $80bd2e5fae3d76d3$var$styles.iconWrapperExternal,
            isSmall && $80bd2e5fae3d76d3$var$styles.iconWrapperExternalSmall,
            isSmall && $80bd2e5fae3d76d3$var$unboundedStyles.iconWrapperSmall
        ]),
        children: resolvedElemBefore
    });
    const content = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            !(0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && !isSmall && resolvedElemBefore,
            !(0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && isSmall && iconElement,
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                ref: textRef,
                className: (0, $4jQY2.default)([
                    $80bd2e5fae3d76d3$var$styles.text,
                    truncationWidth != null && (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && $80bd2e5fae3d76d3$var$styles.textWithTruncation
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.default), {
                ...rest,
                ref: controlRef,
                "aria-current": ariaCurrent,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                href: href,
                onClick: handleTriggerClick,
                onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
                onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
                onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
                onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
                onFocus: triggerProps?.onFocus ?? onFocus,
                onBlur: triggerProps?.onBlur ?? onBlur,
                "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
                target: target,
                testId: testId,
                title: title,
                xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
                (0, $1MNmN.cx)($80bd2e5fae3d76d3$var$styles.root, isSmall && $80bd2e5fae3d76d3$var$styles.rootSmall, (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && $80bd2e5fae3d76d3$var$styles.rootRefresh, truncationWidth != null && (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && $80bd2e5fae3d76d3$var$styles.withTruncation, truncationWidth == null && $80bd2e5fae3d76d3$var$styles.withoutTruncation, (0, $egspI.fg)('platform-dst-shape-theme-default') && $80bd2e5fae3d76d3$var$styles.rootT26Shape),
                style: {
                    maxWidth: truncationWidth
                },
                children: content
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
                ...rest,
                ref: controlRef,
                "aria-current": ariaCurrent,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                onClick: handleTriggerClick,
                onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
                onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
                onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
                onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
                onFocus: triggerProps?.onFocus ?? onFocus,
                onBlur: triggerProps?.onBlur ?? onBlur,
                "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
                testId: testId,
                title: title,
                xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
                (0, $1MNmN.cx)($80bd2e5fae3d76d3$var$styles.root, isSmall && $80bd2e5fae3d76d3$var$styles.rootSmall, (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && $80bd2e5fae3d76d3$var$styles.rootRefresh, truncationWidth != null && (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') && $80bd2e5fae3d76d3$var$styles.withTruncation, truncationWidth == null && $80bd2e5fae3d76d3$var$styles.withoutTruncation, (0, $egspI.fg)('platform-dst-shape-theme-default') && $80bd2e5fae3d76d3$var$styles.rootT26Shape),
                style: {
                    maxWidth: truncationWidth
                },
                children: content
            })
        ]
    });
});
var $80bd2e5fae3d76d3$export$2e2bcd8739ae039 = $80bd2e5fae3d76d3$var$Step;

});


parcelRegister("4sio5", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a2bc9e70c5d250f$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $aZBDA = parcelRequire("aZBDA");

var $4qNCE = parcelRequire("4qNCE");

var $2oRWW = parcelRequire("2oRWW");

var $egspI = parcelRequire("egspI");
const $4a2bc9e70c5d250f$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4a2bc9e70c5d250f$var$noop = (0, $2oRWW.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $4a2bc9e70c5d250f$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $4a2bc9e70c5d250f$var$noop, target: target, testId: testId, ...props }, ref)=>{
    const handleClicked = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4a2bc9e70c5d250f$var$analyticsAttributes
    });
    const resolvedIconAfter = (0, $egspI.fg)('platform_dst_breadcrumbs-refresh') ? undefined : hasOverflow ? undefined : iconAfter;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: resolvedIconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $4a2bc9e70c5d250f$export$2e2bcd8739ae039 = $4a2bc9e70c5d250f$var$StepOld;

});


parcelRegister("8LNQ0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66295f419e82180e$var$_react = $66295f419e82180e$var$_interopRequireDefault((parcelRequire("euxye")));

var $66295f419e82180e$var$_baseNew = $66295f419e82180e$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $66295f419e82180e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66295f419e82180e$var$LockLockedIcon = (props)=>/*#__PURE__*/ $66295f419e82180e$var$_react.default.createElement($66295f419e82180e$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$66295f419e82180e$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $66295f419e82180e$var$_default = module.exports.default = $66295f419e82180e$var$LockLockedIcon;

});

parcelRegister("bwVQC", function(module, exports) {
$parcel$export(module.exports, "default", () => $b94280e6445047b0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $gtfI4 = parcelRequire("gtfI4");
const $b94280e6445047b0$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gtfI4.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b94280e6445047b0$var$ActionsWrapper, null, actions) : null
    });
$b94280e6445047b0$var$PageHeader.displayName = "PageHeader";
var $b94280e6445047b0$export$2e2bcd8739ae039 = $b94280e6445047b0$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b94280e6445047b0$var$ActionsWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gtfI4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b972dfa8f32165a$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eMw11 = parcelRequire("eMw11");

var $35Kzw = parcelRequire("35Kzw");

var $gAJEi = parcelRequire("gAJEi");

var $anfpg = parcelRequire("anfpg");

var $dBJ9j = parcelRequire("dBJ9j");

var $cba0H = parcelRequire("cba0H");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $1b972dfa8f32165a$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $gAJEi.default), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $cba0H.default), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dBJ9j.default), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $anfpg.default), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eMw11.default), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $35Kzw.default), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
$1b972dfa8f32165a$var$PageHeader.displayName = "PageHeader";
var $1b972dfa8f32165a$export$2e2bcd8739ae039 = $1b972dfa8f32165a$var$PageHeader;

});
parcelRegister("eMw11", function(module, exports) {
$parcel$export(module.exports, "default", () => $086a638273ee4270$export$2e2bcd8739ae039);
/* actions-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $086a638273ee4270$var$actionStyles = null;
/**
 * __Actions wrapper__.
 *
 * An actions wrapper is a wrapper for the actions, which appear on the top right of the PageHeader component.
 *
 */ const $086a638273ee4270$var$ActionsWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
$086a638273ee4270$var$ActionsWrapper.displayName = "ActionsWrapper";
var $086a638273ee4270$export$2e2bcd8739ae039 = $086a638273ee4270$var$ActionsWrapper;

});

parcelRegister("35Kzw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac4c1fdbcf6d6317$export$2e2bcd8739ae039);
/* bottom-bar.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
const $ac4c1fdbcf6d6317$var$styles = {
    bottomBar: "_1pfhpxbi"
};
/**
 * __Bottom bar__.
 *
 * A bottom bar is a wrapper for the bottom bar, which appears at the bottom of the PageHeader component.
 *
 */ const $ac4c1fdbcf6d6317$var$BottomBar = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $ac4c1fdbcf6d6317$var$styles.bottomBar,
        children: children
    });
};
$ac4c1fdbcf6d6317$var$BottomBar.displayName = "BottomBar";
var $ac4c1fdbcf6d6317$export$2e2bcd8739ae039 = $ac4c1fdbcf6d6317$var$BottomBar;

});

parcelRegister("gAJEi", function(module, exports) {
$parcel$export(module.exports, "default", () => $6def5e03640c6a28$export$2e2bcd8739ae039);
/* outer-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $6def5e03640c6a28$var$outerStyles = null;
/**
 * __Outer wrapper__.
 *
 * An outer wrapper that is the outermost component of the PageHeader component. It wraps around the PageHeader, its Actions,
 * the BottomBar and its Breadcrumbs.
 *
 */ const $6def5e03640c6a28$var$OuterWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
$6def5e03640c6a28$var$OuterWrapper.displayName = "OuterWrapper";
var $6def5e03640c6a28$export$2e2bcd8739ae039 = $6def5e03640c6a28$var$OuterWrapper;

});

parcelRegister("anfpg", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d1b5c07fca8c8ee$export$2e2bcd8739ae039);
/* title.tsx generated by @compiled/babel-plugin v0.38.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");
const $7d1b5c07fca8c8ee$var$truncateStyles = null;
const $7d1b5c07fca8c8ee$var$titleStyles = null;
/**
 * __Styled title wrapper__.
 *
 * A styled title wrapper is a wrapper around the title that controls its the styles exclusively.
 *
 */ const $7d1b5c07fca8c8ee$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $4jQY2.default)([
            "_11c810sd _12ji1r31 _1qu2glyw _12y31o36 _syazi7uo _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
var $7d1b5c07fca8c8ee$export$2e2bcd8739ae039 = $7d1b5c07fca8c8ee$var$Title;

});

parcelRegister("dBJ9j", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d603b8c2911e29a$export$2e2bcd8739ae039);
/* title-container.tsx generated by @compiled/babel-plugin v0.38.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $0d603b8c2911e29a$var$titleContainerStyles = null;
const $0d603b8c2911e29a$var$titleContainerTruncateStyles = null;
/**
 * Title container.
 *
 * A title container is a container that wraps around the title and its styles (if applied).
 *
 */ const $0d603b8c2911e29a$var$TitleContainer = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc _1i4q1hna",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
$0d603b8c2911e29a$var$TitleContainer.displayName = "TitleContainer";
var $0d603b8c2911e29a$export$2e2bcd8739ae039 = $0d603b8c2911e29a$var$TitleContainer;

});

parcelRegister("cba0H", function(module, exports) {
$parcel$export(module.exports, "default", () => $274d848363c5a650$export$2e2bcd8739ae039);
/* title-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $274d848363c5a650$var$titleWrapperStyles = null;
const $274d848363c5a650$var$titleWrapperTruncateStyles = null;
/**
 * __Title wrapper__.
 *
 * A title wrapper is a wrapper around the title and the actions.
 *
 */ const $274d848363c5a650$var$TitleWrapper = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4cvr1y6m _1n261q9c",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
$274d848363c5a650$var$TitleWrapper.displayName = "TitleWrapper";
var $274d848363c5a650$export$2e2bcd8739ae039 = $274d848363c5a650$var$TitleWrapper;

});



parcelRegister("3mYdc", function(module, exports) {
$parcel$export(module.exports, "CommonFlag", () => $9ecfb55d7f5c8e8b$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $9ecfb55d7f5c8e8b$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $9ecfb55d7f5c8e8b$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $9ecfb55d7f5c8e8b$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $9ecfb55d7f5c8e8b$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $9ecfb55d7f5c8e8b$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $9ecfb55d7f5c8e8b$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $9ecfb55d7f5c8e8b$export$a2c3479950310d7d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $bafqJ = parcelRequire("bafqJ");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ecfb55d7f5c8e8b$var$ForPaintJiraCommonFlag = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2Twak")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ecfb55d7f5c8e8b$var$AfterPaintJiraCommonFlag = (0, $l8G1z.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("2Twak")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $9ecfb55d7f5c8e8b$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$ForPaintJiraCommonFlag, props);
$9ecfb55d7f5c8e8b$var$CommonFlagImpl.displayName = "CommonFlagImpl";

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ecfb55d7f5c8e8b$var$ForPaintFlagGroup = (0, $l8G1z.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aGnrh")), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ecfb55d7f5c8e8b$var$AfterPaintFlagGroup = (0, $l8G1z.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aGnrh")), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $9ecfb55d7f5c8e8b$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$ForPaintFlagGroup, props);
$9ecfb55d7f5c8e8b$var$FlagGroupImpl.displayName = "FlagGroupImpl";
const $9ecfb55d7f5c8e8b$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, props));
$9ecfb55d7f5c8e8b$export$13d73238a031436b.displayName = "CommonFlag";
const $9ecfb55d7f5c8e8b$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
$9ecfb55d7f5c8e8b$export$518ba8e0e60f145f.displayName = "ErrorFlag";
const $9ecfb55d7f5c8e8b$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
$9ecfb55d7f5c8e8b$export$3f75672bb90a4431.displayName = "ErrorAutoDismissFlag";
const $9ecfb55d7f5c8e8b$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
$9ecfb55d7f5c8e8b$export$6a55b52e74c1e48e.displayName = "InfoFlag";
const $9ecfb55d7f5c8e8b$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
$9ecfb55d7f5c8e8b$export$74a3c0748aa31355.displayName = "SuccessAutoDismissFlag";
const $9ecfb55d7f5c8e8b$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
$9ecfb55d7f5c8e8b$export$93bd4963a1d00fd5.displayName = "SuccessFlag";
const $9ecfb55d7f5c8e8b$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
$9ecfb55d7f5c8e8b$export$23695d8281998f27.displayName = "WarningFlag";
const $9ecfb55d7f5c8e8b$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$FlagGroupImpl, props));
$9ecfb55d7f5c8e8b$export$a2c3479950310d7d.displayName = "FlagGroup";

});
parcelRegister("bafqJ", function(module, exports) {
$parcel$export(module.exports, "FlagsBoundary", () => $eecc65a0424ab243$export$8b4a0fffcddd96f4);

var $euxye = parcelRequire("euxye");

var $cCE2Z = parcelRequire("cCE2Z");

var $a8EUd = parcelRequire("a8EUd");
const $eecc65a0424ab243$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName, teamName: teamName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "flags",
        packageName: packageName,
        teamName: teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null)
    }, children));
$eecc65a0424ab243$export$8b4a0fffcddd96f4.displayName = "FlagsBoundary";

});

parcelRegister("2Twak", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("k0TqB")
]).then(()=>parcelRequire('498Ku'));

});

parcelRegister("aGnrh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4FwAF").then(()=>parcelRequire('f9iDp'));

});


parcelRegister("cFFXQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f1c1dc01a89e8a6$export$2e2bcd8739ae039);
/* ProductCard.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $8Sdzy = parcelRequire("8Sdzy");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $2iotI = parcelRequire("2iotI");
const $9f1c1dc01a89e8a6$var$styles = {
    productCard: "_2rko12b0 _1h6d1l7x _1dqonqa1 _189ee4h9 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $9f1c1dc01a89e8a6$var$ProductCard = (props)=>{
    const { applicationType: applicationType, displayUrl: displayUrl, heading: heading } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $9f1c1dc01a89e8a6$var$styles.productCard,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xxsmall",
        as: "h2"
    }, heading), props.statusLozenge), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.100",
        alignBlock: "center"
    }, applicationType.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, displayUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        color: "color.text.subtle",
        size: "small"
    }, applicationType.name))));
};
$9f1c1dc01a89e8a6$var$ProductCard.displayName = "ProductCard";
var $9f1c1dc01a89e8a6$export$2e2bcd8739ae039 = $9f1c1dc01a89e8a6$var$ProductCard;

});

parcelRegister("5T7Xn", function(module, exports) {
$parcel$export(module.exports, "TypeIdMap", () => $961361b165f32887$export$7b493295b4541cf7);
$parcel$export(module.exports, "lookupType", () => $961361b165f32887$export$dd5c4190ef79bf3f);
$parcel$export(module.exports, "lookupTypeByTypeId", () => $961361b165f32887$export$2d290ec50c4200c5);
$parcel$export(module.exports, "lookupTypeFromV3Data", () => $961361b165f32887$export$2e1f91665918e370);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $kHMXB = parcelRequire("kHMXB");
const $961361b165f32887$export$7b493295b4541cf7 = {
    jira: {
        name: 'Jira',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.JiraIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Jira Cloud"
        }),
        category: 'cloud'
    },
    confluence: {
        name: 'Confluence',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.ConfluenceIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Confluence Cloud"
        }),
        category: 'cloud'
    },
    'jira-dc': {
        name: 'Jira DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.JiraDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Jira DC"
        }),
        category: 'dc'
    },
    'confluence-dc': {
        name: 'Confluence DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.ConfluenceDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Confluence DC"
        }),
        category: 'dc'
    },
    bitbucket: {
        name: 'Bitbucket DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.BitbucketDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Bitbucket DC"
        }),
        category: 'dc'
    },
    bamboo: {
        name: 'Bamboo',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.BambooIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Bamboo"
        }),
        category: 'dc'
    },
    generic: {
        name: 'External Application',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kHMXB))), {
            label: "External Application"
        }),
        category: 'generic'
    }
};
const $961361b165f32887$export$dd5c4190ef79bf3f = (dcAwareTypeId)=>{
    return $961361b165f32887$export$7b493295b4541cf7[dcAwareTypeId] || $961361b165f32887$export$7b493295b4541cf7.generic;
};
const $961361b165f32887$export$2d290ec50c4200c5 = (typeid, isDataCenter)=>{
    // Handle stash=bitbucket alias
    if (typeid === 'stash') return $961361b165f32887$export$dd5c4190ef79bf3f('bitbucket');
    // Handle DC types
    if ((typeid === 'jira' || typeid === 'confluence') && isDataCenter) return $961361b165f32887$export$dd5c4190ef79bf3f(`${typeid}-dc`);
    return $961361b165f32887$export$dd5c4190ef79bf3f(typeid);
};
const $961361b165f32887$export$2e1f91665918e370 = (link)=>{
    const type = link.type;
    // TODO: We can determine if it's DC, but how?
    // if (link.data.applicationVersion !== undefined) {
    // 	type += '-dc';
    // }
    return $961361b165f32887$export$2d290ec50c4200c5(type, false);
};

});
parcelRegister("kHMXB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc410b5a6f105623fd92b95efc5298a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12dcd5274151988$var$_react = $f12dcd5274151988$var$_interopRequireDefault((parcelRequire("euxye")));

var $f12dcd5274151988$var$_baseNew = $f12dcd5274151988$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $f12dcd5274151988$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12dcd5274151988$var$AppIcon = (props)=>/*#__PURE__*/ $f12dcd5274151988$var$_react.default.createElement($f12dcd5274151988$var$_baseNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$f12dcd5274151988$var$AppIcon.displayName = 'AppIcon';
var $f12dcd5274151988$var$_default = module.exports.default = $f12dcd5274151988$var$AppIcon;

});


parcelRegister("4Sn7I", function(module, exports) {
$parcel$export(module.exports, "ErrorStatusSectionMessage", () => $361ab66f181d243b$export$8edf5e699a4a50c7);
$parcel$export(module.exports, "default", () => $361ab66f181d243b$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $aybNy = parcelRequire("aybNy");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $hzWaA = parcelRequire("hzWaA");

var $jRJcI = parcelRequire("jRJcI");

var $ahSro = parcelRequire("ahSro");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $5T7Xn = parcelRequire("5T7Xn");

var $4JQqO = parcelRequire("4JQqO");
const $361ab66f181d243b$var$cloudConnectorAwaitingDcResponseTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.cloud-connector-awaiting-dc-response-status-title",
    defaultMessage: "Awaiting DC response"
});
const $361ab66f181d243b$var$cloudConnectorAwaitingDcResponseDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.cloud-connector-awaiting-dc-response-status-description",
    defaultMessage: "This application link is managed by cloud connector, and is awaiting admin response from <link>{applicationName}</link>."
});
const $361ab66f181d243b$var$connectionRefusedTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.connection-refused-title",
    defaultMessage: "The remote application is not responding"
});
const $361ab66f181d243b$var$connectionRefusedDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.connection-refused-description",
    defaultMessage: "The connection to <code>{rpcUrl}</code> was refused. <link>{applicationName}</link> may be down or blocked by a firewall. Alternatively, the Application URL for the remote application may be incorrect or may have changed recently."
});
const $361ab66f181d243b$var$unknownHostTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.unknown-host-title",
    defaultMessage: "Unable to reach the remote application"
});
const $361ab66f181d243b$var$unknownHostDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.unknown-host-description",
    defaultMessage: "We couldn't resolve the hostname at <code>{rpcUrl}</code>. There may be a DNS configuration problem, or the Application URL for the remote application may be incorrect or may have changed recently."
});
const $361ab66f181d243b$var$sslUntrustedTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.ssl-untrusted-title",
    defaultMessage: "The remote certificate can't be trusted"
});
const $361ab66f181d243b$var$sslUntrustedDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.ssl-untrusted-description",
    defaultMessage: "<link>{applicationName}</link> may be using a self-signed SSL certificate or a certificate that was issued by a certificate authority that isn't known locally."
});
const $361ab66f181d243b$var$sslHostnameUnmatchedTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.ssl-hostname-unmatched-title",
    defaultMessage: "The remote certificate doesn't match the remote host name"
});
const $361ab66f181d243b$var$sslHostnameUnmatchedDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.ssl-hostname-unmatched-description",
    defaultMessage: "The SSL certificate used by <link>{applicationName}</link> can't be trusted because the certificate's host name doesn't match the URL {rpcUrl}."
});
const $361ab66f181d243b$var$sslUnmatchedTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.ssl-unmatched-title",
    defaultMessage: "Unable to verify remote certificate details"
});
const $361ab66f181d243b$var$sslUnmatchedDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.ssl-unmatched-description",
    defaultMessage: "The SSL certificate used by <link>{applicationName}</link> can't be trusted because details inside the certificate can't be verified. Check that the remote certificate has the correct details."
});
const $361ab66f181d243b$var$oauthProblemTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.oauth-problem-title",
    defaultMessage: "OAuth problem"
});
const $361ab66f181d243b$var$oauthProblemDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.oauth-problem-description",
    defaultMessage: "There is an issue with the OAuth configuration of the connection to <link>{applicationName}</link>."
});
const $361ab66f181d243b$var$oauthTimestampRefusedTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.oauth-timestamp-refused-title",
    defaultMessage: "The system clocks are not synchronized"
});
const $361ab66f181d243b$var$oauthTimestampRefusedDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.oauth-timestamp-refused-description",
    defaultMessage: "This server has a different system time from <link>{applicationName}</link>, which prevents the applications from authenticating."
});
const $361ab66f181d243b$var$oauthSignatureInvalidTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.oauth-signature-invalid-title",
    defaultMessage: "Invalid OAuth signature"
});
const $361ab66f181d243b$var$oauthSignatureInvalidDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.oauth-signature-invalid-description",
    defaultMessage: "We couldn't connect to <link>{applicationName}</link>, possibly because that instance is behind a mis-configured proxy."
});
const $361ab66f181d243b$var$unexpectedResponseTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.unexpected-response-title",
    defaultMessage: "Unexpected response"
});
const $361ab66f181d243b$var$unexpectedResponseDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.unexpected-response-description",
    defaultMessage: "We received an unexpected response from <link>{applicationName}</link>. If the remote application is behind a proxy, check that the application is operational. Troubleshoot this for other possible causes."
});
const $361ab66f181d243b$var$creationFailedTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.creation-failed-status-title",
    defaultMessage: "Creation failed"
});
const $361ab66f181d243b$var$creationFailedDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.creation-failed-status-description",
    defaultMessage: "This application link failed to create an OAuth 2.0 client. Delete it and create a new one."
});
const $361ab66f181d243b$var$configurationIncompleteTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.configuration-incomplete-status-title",
    defaultMessage: "Configuration incomplete"
});
const $361ab66f181d243b$var$configurationIncompleteDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.configuration-incomplete-status-description",
    defaultMessage: "This application link is missing a remote client ID and remote client secret. Add these details to complete configuration."
});
const $361ab66f181d243b$var$inProgressTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.in-progress-status-title",
    defaultMessage: "In progress"
});
const $361ab66f181d243b$var$inProgressDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.in-progress-status-description",
    defaultMessage: "We're still configuring the application link."
});
const $361ab66f181d243b$var$submissionFailedTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.submission-failed-status-title",
    defaultMessage: "Submission failed"
});
const $361ab66f181d243b$var$submissionFailedDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.submission-failed-status-description",
    defaultMessage: "Resubmit this application link to complete configuration."
});
const $361ab66f181d243b$var$configurationCompleteTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.configuration-complete-status-title",
    defaultMessage: "Configuration complete"
});
const $361ab66f181d243b$var$configurationCompleteDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.configuration-complete-status-description",
    defaultMessage: "The configuration for your application link is complete. Try using it to confirm that everything works."
});
const $361ab66f181d243b$var$authLevelMismatchTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-title",
    defaultMessage: "OAuth mismatch"
});
const $361ab66f181d243b$var$noRemoteApplinkTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.no-remote-applink-title",
    defaultMessage: "No remote application link"
});
const $361ab66f181d243b$var$noRemoteApplinkDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.no-remote-applink-description",
    defaultMessage: "We can't connect with <link>{applicationName}</link>  because a reciprocal application link is missing on that server. You'll need to delete and then re-create this application link."
});
const $361ab66f181d243b$var$remoteVersionIncompatibleTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.remote-version-incompatible-title",
    defaultMessage: "Unable to retrieve status"
});
const $361ab66f181d243b$var$remoteVersionIncompatibleDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.remote-version-incompatible-description",
    defaultMessage: "We're unable to determine the status of this link, because the version of {applicationName} is a little too old. The link may actually be good. You can upgrade <link>{applicationName}</link> to the latest version of {applicationType} to get status and diagnostic capabilities."
});
const $361ab66f181d243b$var$noOutgoingAuthTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.no-outgoing-auth-title",
    defaultMessage: "No outgoing authentication"
});
const $361ab66f181d243b$var$noOutgoingAuthDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.no-outgoing-auth-description",
    defaultMessage: "We can't display the status for this application link, because outgoing authentication is disabled. You can enable outgoing authentication to see the status."
});
const $361ab66f181d243b$var$genericLinkTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.generic-link-title",
    defaultMessage: "Link to external third party"
});
const $361ab66f181d243b$var$genericLinkDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.generic-link-description",
    defaultMessage: "This is an application link to an external third party. We are unable to retrieve the status to third parties. If you are experiencing any problems with your connection ensure that your OAuth configuration is correct."
});
const $361ab66f181d243b$var$nonAtlassianTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.non-atlassian-title",
    defaultMessage: "Link to external third party"
});
const $361ab66f181d243b$var$nonAtlassianDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.non-atlassian-description",
    defaultMessage: "This is an application link to an external third party. We are unable to retrieve the status to third parties, so if you are experiencing any problems with your connection reach out to the third party directly."
});
const $361ab66f181d243b$var$systemLinkTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.system-link-title",
    defaultMessage: "Internal System Link"
});
const $361ab66f181d243b$var$systemLinkDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.system-link-description",
    defaultMessage: "This is an internal link created automatically by the system. System internal links are read-only and cannot be edited."
});
const $361ab66f181d243b$var$authLevelUnsupportedTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-unsupported-title",
    defaultMessage: "Unsupported OAuth level"
});
const $361ab66f181d243b$var$authLevelUnsupportedDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-unsupported-description",
    defaultMessage: "The current OAuth configuration prevents integrations from working. You need to update your configuration to OAuth or OAuth with impersonation."
});
const $361ab66f181d243b$var$legacyUpdateTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.legacy-update-title",
    defaultMessage: "Deprecated authentication type"
});
const $361ab66f181d243b$var$legacyUpdateDescription1Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.legacy-update-description-1",
    defaultMessage: "This application link uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated."
});
const $361ab66f181d243b$var$legacyUpdateDescription2Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.legacy-update-description-2",
    defaultMessage: "You should update this link to use OAuth authentication, the industry standard."
});
const $361ab66f181d243b$var$legacyRemovalTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.legacy-removal-title",
    defaultMessage: "Deprecated authentication type"
});
const $361ab66f181d243b$var$legacyRemovalDescription1Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.legacy-removal-description-1",
    defaultMessage: "As well as OAuth, this application link still uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated."
});
const $361ab66f181d243b$var$legacyRemovalDescription2Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.legacy-removal-description-2",
    defaultMessage: "You should update this link to use OAuth authentication, the industry standard."
});
const $361ab66f181d243b$var$manualLegacyUpdateTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.manual-legacy-update-title",
    defaultMessage: "Deprecated authentication type"
});
const $361ab66f181d243b$var$manualLegacyUpdateDescription1Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.manual-legacy-update-description-1",
    defaultMessage: "This application link uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated."
});
const $361ab66f181d243b$var$manualLegacyUpdateDescription2Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.manual-legacy-update-description-2",
    defaultMessage: "You should manually update this link to use OAuth authentication, the industry standard."
});
const $361ab66f181d243b$var$manualLegacyRemovalTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.manual-legacy-removal-title",
    defaultMessage: "Deprecated authentication type"
});
const $361ab66f181d243b$var$manualLegacyRemovalDescription1Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.manual-legacy-removal-description-1",
    defaultMessage: "This application link uses a deprecated authentication type."
});
const $361ab66f181d243b$var$manualLegacyRemovalDescription2Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.manual-legacy-removal-description-2",
    defaultMessage: "You should click <bold>Update locally</bold> to move to OAuth authentication. Doing this will remove Trusted Applications authentication from this end of the link."
});
const $361ab66f181d243b$var$manualLegacyRemovalDescription3Message = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.manual-legacy-removal-description-3",
    defaultMessage: "You'll then need to manually remove Trusted Applications authentication from the <link>{applicationName}</link> end of the link."
});
const $361ab66f181d243b$var$unknownTitleMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.unknown-title",
    defaultMessage: "Network error"
});
const $361ab66f181d243b$var$unknownDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.unknown-description",
    defaultMessage: "We couldn't connect to {applicationName} at {rpcUrl}. This might have been caused by a network error or another configuration error."
});
const $361ab66f181d243b$var$messages = {
    cloudConnectorAwaitingDcResponseTitle: $361ab66f181d243b$var$cloudConnectorAwaitingDcResponseTitleMessage,
    cloudConnectorAwaitingDcResponseDescription: $361ab66f181d243b$var$cloudConnectorAwaitingDcResponseDescriptionMessage,
    connectionRefusedTitle: $361ab66f181d243b$var$connectionRefusedTitleMessage,
    connectionRefusedDescription: $361ab66f181d243b$var$connectionRefusedDescriptionMessage,
    unknownHostTitle: $361ab66f181d243b$var$unknownHostTitleMessage,
    unknownHostDescription: $361ab66f181d243b$var$unknownHostDescriptionMessage,
    sslUntrustedTitle: $361ab66f181d243b$var$sslUntrustedTitleMessage,
    sslUntrustedDescription: $361ab66f181d243b$var$sslUntrustedDescriptionMessage,
    sslHostnameUnmatchedTitle: $361ab66f181d243b$var$sslHostnameUnmatchedTitleMessage,
    sslHostnameUnmatchedDescription: $361ab66f181d243b$var$sslHostnameUnmatchedDescriptionMessage,
    sslUnmatchedTitle: $361ab66f181d243b$var$sslUnmatchedTitleMessage,
    sslUnmatchedDescription: $361ab66f181d243b$var$sslUnmatchedDescriptionMessage,
    oauthProblemTitle: $361ab66f181d243b$var$oauthProblemTitleMessage,
    oauthProblemDescription: $361ab66f181d243b$var$oauthProblemDescriptionMessage,
    oauthTimestampRefusedTitle: $361ab66f181d243b$var$oauthTimestampRefusedTitleMessage,
    oauthTimestampRefusedDescription: $361ab66f181d243b$var$oauthTimestampRefusedDescriptionMessage,
    oauthSignatureInvalidTitle: $361ab66f181d243b$var$oauthSignatureInvalidTitleMessage,
    oauthSignatureInvalidDescription: $361ab66f181d243b$var$oauthSignatureInvalidDescriptionMessage,
    unexpectedResponseTitle: $361ab66f181d243b$var$unexpectedResponseTitleMessage,
    unexpectedResponseDescription: $361ab66f181d243b$var$unexpectedResponseDescriptionMessage,
    creationFailedTitle: $361ab66f181d243b$var$creationFailedTitleMessage,
    creationFailedDescription: $361ab66f181d243b$var$creationFailedDescriptionMessage,
    configurationIncompleteTitle: $361ab66f181d243b$var$configurationIncompleteTitleMessage,
    configurationIncompleteDescription: $361ab66f181d243b$var$configurationIncompleteDescriptionMessage,
    inProgressTitle: $361ab66f181d243b$var$inProgressTitleMessage,
    inProgressDescription: $361ab66f181d243b$var$inProgressDescriptionMessage,
    submissionFailedTitle: $361ab66f181d243b$var$submissionFailedTitleMessage,
    submissionFailedDescription: $361ab66f181d243b$var$submissionFailedDescriptionMessage,
    configurationCompleteTitle: $361ab66f181d243b$var$configurationCompleteTitleMessage,
    configurationCompleteDescription: $361ab66f181d243b$var$configurationCompleteDescriptionMessage,
    authLevelMismatchTitle: $361ab66f181d243b$var$authLevelMismatchTitleMessage,
    noRemoteApplinkTitle: $361ab66f181d243b$var$noRemoteApplinkTitleMessage,
    noRemoteApplinkDescription: $361ab66f181d243b$var$noRemoteApplinkDescriptionMessage,
    remoteVersionIncompatibleTitle: $361ab66f181d243b$var$remoteVersionIncompatibleTitleMessage,
    remoteVersionIncompatibleDescription: $361ab66f181d243b$var$remoteVersionIncompatibleDescriptionMessage,
    noOutgoingAuthTitle: $361ab66f181d243b$var$noOutgoingAuthTitleMessage,
    noOutgoingAuthDescription: $361ab66f181d243b$var$noOutgoingAuthDescriptionMessage,
    genericLinkTitle: $361ab66f181d243b$var$genericLinkTitleMessage,
    genericLinkDescription: $361ab66f181d243b$var$genericLinkDescriptionMessage,
    nonAtlassianTitle: $361ab66f181d243b$var$nonAtlassianTitleMessage,
    nonAtlassianDescription: $361ab66f181d243b$var$nonAtlassianDescriptionMessage,
    systemLinkTitle: $361ab66f181d243b$var$systemLinkTitleMessage,
    systemLinkDescription: $361ab66f181d243b$var$systemLinkDescriptionMessage,
    authLevelUnsupportedTitle: $361ab66f181d243b$var$authLevelUnsupportedTitleMessage,
    authLevelUnsupportedDescription: $361ab66f181d243b$var$authLevelUnsupportedDescriptionMessage,
    legacyUpdateTitle: $361ab66f181d243b$var$legacyUpdateTitleMessage,
    legacyUpdateDescription1: $361ab66f181d243b$var$legacyUpdateDescription1Message,
    legacyUpdateDescription2: $361ab66f181d243b$var$legacyUpdateDescription2Message,
    legacyRemovalTitle: $361ab66f181d243b$var$legacyRemovalTitleMessage,
    legacyRemovalDescription1: $361ab66f181d243b$var$legacyRemovalDescription1Message,
    legacyRemovalDescription2: $361ab66f181d243b$var$legacyRemovalDescription2Message,
    manualLegacyUpdateTitle: $361ab66f181d243b$var$manualLegacyUpdateTitleMessage,
    manualLegacyUpdateDescription1: $361ab66f181d243b$var$manualLegacyUpdateDescription1Message,
    manualLegacyUpdateDescription2: $361ab66f181d243b$var$manualLegacyUpdateDescription2Message,
    manualLegacyRemovalTitle: $361ab66f181d243b$var$manualLegacyRemovalTitleMessage,
    manualLegacyRemovalDescription1: $361ab66f181d243b$var$manualLegacyRemovalDescription1Message,
    manualLegacyRemovalDescription2: $361ab66f181d243b$var$manualLegacyRemovalDescription2Message,
    manualLegacyRemovalDescription3: $361ab66f181d243b$var$manualLegacyRemovalDescription3Message,
    unknownTitle: $361ab66f181d243b$var$unknownTitleMessage,
    unknownDescription: $361ab66f181d243b$var$unknownDescriptionMessage
};
const $361ab66f181d243b$export$8edf5e699a4a50c7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const buildErrorContents = (0, $euxye.useCallback)(()=>{
        if ((0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs')) // FG tidy note: merge it to the main switch clause below
        switch(props.err.type){
            case 'CLOUD_CONNECTOR_AWAITING_DC_RESPONSE':
                {
                    const dcCloudConnectorTabUrl = `${props.context.link.displayUrl}/plugins/servlet/applinks/listApplicationLinks#tabs-cloud-connections`;
                    return {
                        title: formatMessage($361ab66f181d243b$var$messages.cloudConnectorAwaitingDcResponseTitle),
                        description: formatMessage($361ab66f181d243b$var$messages.cloudConnectorAwaitingDcResponseDescription, {
                            applicationName: props.context.link.name,
                            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                    href: dcCloudConnectorTabUrl,
                                    target: "_blank"
                                }, chunks)
                        })
                    };
                }
            default:
        }
        switch(props.err.type){
            case 'CONNECTION_REFUSED':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.connectionRefusedTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.connectionRefusedDescription, {
                        rpcUrl: props.context.link.rpcUrl,
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks),
                        code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jRJcI.default), null, chunks)
                    }),
                    action: 'edit'
                };
            case 'UNKNOWN_HOST':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.unknownHostTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.unknownHostDescription, {
                        rpcUrl: props.context.link.rpcUrl,
                        code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jRJcI.default), null, chunks)
                    }),
                    action: 'edit'
                };
            case 'SSL_UNTRUSTED':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.sslUntrustedTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.sslUntrustedDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'SSL_HOSTNAME_UNMATCHED':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.sslHostnameUnmatchedTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.sslHostnameUnmatchedDescription, {
                        applicationName: props.context.link.name,
                        rpcUrl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jRJcI.default), null, props.context.link.rpcUrl),
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'SSL_UNMATCHED':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.sslUnmatchedTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.sslUnmatchedDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'OAUTH_PROBLEM':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.oauthProblemTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.oauthProblemDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'OAUTH_TIMESTAMP_REFUSED':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.oauthTimestampRefusedTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.oauthTimestampRefusedDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'OAUTH_SIGNATURE_INVALID':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.oauthSignatureInvalidTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.oauthSignatureInvalidDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'UNEXPECTED_RESPONSE':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.unexpectedResponseTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.unexpectedResponseDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'UNEXPECTED_RESPONSE_STATUS':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.unexpectedResponseTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.unexpectedResponseDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'CREATION_FAILED':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.creationFailedTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.creationFailedDescription)
                };
            case 'CONFIGURATION_INCOMPLETE':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.configurationIncompleteTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.configurationIncompleteDescription)
                };
            case 'IN_PROGRESS':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.inProgressTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.inProgressDescription)
                };
            case 'SUBMISSION_FAILED':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.submissionFailedTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.submissionFailedDescription)
                };
            case 'CONFIGURATION_COMPLETE':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.configurationCompleteTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.configurationCompleteDescription)
                };
            case 'AUTH_LEVEL_MISMATCH':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.authLevelMismatchTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4JQqO.default), {
                        status: props.context
                    }),
                    action: 'edit'
                };
            case 'NO_REMOTE_APPLINK':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.noRemoteApplinkTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.noRemoteApplinkDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'INSUFFICIENT_REMOTE_PERMISSION':
            case 'REMOTE_VERSION_INCOMPATIBLE':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.remoteVersionIncompatibleTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.remoteVersionIncompatibleDescription, {
                        applicationName: props.context.link.name,
                        // TODO: Try determine whether the link is DC or not (it doesn't strictly matter, as it'll still say "Confluence", etc)
                        applicationType: (0, $5T7Xn.lookupTypeByTypeId)(props.context.link.type, false).name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'NO_OUTGOING_AUTH':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.noOutgoingAuthTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.noOutgoingAuthDescription)
                };
            case 'GENERIC_LINK':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.genericLinkTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.genericLinkDescription)
                };
            case 'NON_ATLASSIAN':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.nonAtlassianTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.nonAtlassianDescription)
                };
            case 'SYSTEM_LINK':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.systemLinkTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.systemLinkDescription)
                };
            case 'AUTH_LEVEL_UNSUPPORTED':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.authLevelUnsupportedTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.authLevelUnsupportedDescription),
                    action: 'edit'
                };
            case 'LEGACY_UPDATE':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.legacyUpdateTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.legacyUpdateDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.legacyUpdateDescription2))),
                    action: 'update'
                };
            case 'LEGACY_REMOVAL':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.legacyRemovalTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.legacyRemovalDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.legacyRemovalDescription2))),
                    action: 'update'
                };
            case 'MANUAL_LEGACY_UPDATE':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.manualLegacyUpdateTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.manualLegacyUpdateDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.manualLegacyUpdateDescription2)))
                };
            case 'MANUAL_LEGACY_REMOVAL':
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.manualLegacyRemovalTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.manualLegacyRemovalDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.manualLegacyRemovalDescription2, {
                        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                                as: "strong"
                            }, chunks)
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($361ab66f181d243b$var$messages.manualLegacyRemovalDescription3, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    }))),
                    action: 'update'
                };
            case 'UNKNOWN':
            default:
                return {
                    title: formatMessage($361ab66f181d243b$var$messages.unknownTitle),
                    description: formatMessage($361ab66f181d243b$var$messages.unknownDescription, {
                        applicationName: props.context.link.name,
                        rpcUrl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jRJcI.default), null, props.context.link.rpcUrl)
                    }),
                    action: 'edit'
                };
        }
    }, [
        props.err,
        props.context,
        formatMessage
    ]);
    const buildActions = (0, $euxye.useCallback)(()=>{
        switch(buildErrorContents().action){
            case 'edit':
                // We don't show edit actions on the edit page
                // However when this class is extended to support popups on the list page, we'll show it there
                return [];
            case 'update':
                return [];
            default:
                return [];
        }
    }, [
        buildErrorContents
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aybNy.default), {
        appearance: "error",
        title: buildErrorContents().title,
        actions: buildActions()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, buildErrorContents().description), props.context.error && props.context.error.details && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ahSro.default), {
        text: props.context.error.details
    })));
};
$361ab66f181d243b$export$8edf5e699a4a50c7.displayName = "ErrorStatusSectionMessage";
var $361ab66f181d243b$export$2e2bcd8739ae039 = $361ab66f181d243b$export$8edf5e699a4a50c7;

});
parcelRegister("aybNy", function(module, exports) {
$parcel$export(module.exports, "default", () => $aae6f5a9ea231e17$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $m9iwH = parcelRequire("m9iwH");

var $2iotI = parcelRequire("2iotI");

var $i68tN = parcelRequire("i68tN");

var $egspI = parcelRequire("egspI");

var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");

var $bD5lq = parcelRequire("bD5lq");
const $aae6f5a9ea231e17$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
const $aae6f5a9ea231e17$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $aae6f5a9ea231e17$var$SectionMessage = /*#__PURE__*/ (0, $euxye.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, headingLevel: headingLevel = 'h2', icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $euxye.useState)(false);
    const handleDismiss = (0, $euxye.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $bD5lq.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $euxye.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $euxye.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $e79Pd.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $4jQY2.default)([
            $aae6f5a9ea231e17$var$sectionMessageStyles.container,
            (0, $egspI.fg)('platform-dst-shape-theme-default') && $aae6f5a9ea231e17$var$sectionMessageStyles.containerT26Shape,
            $aae6f5a9ea231e17$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $aae6f5a9ea231e17$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $aae6f5a9ea231e17$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                            as: headingLevel,
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                            className: (0, $4jQY2.default)([
                                $aae6f5a9ea231e17$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $aae6f5a9ea231e17$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $aae6f5a9ea231e17$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$aae6f5a9ea231e17$var$SectionMessage.displayName = 'SectionMessage';
var $aae6f5a9ea231e17$export$2e2bcd8739ae039 = $aae6f5a9ea231e17$var$SectionMessage;

});
parcelRegister("bD5lq", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $77a1a9ade7a31998$export$e9b82d2e21ac0c1f);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $5dxEd = parcelRequire("5dxEd");

var $ah9qo = parcelRequire("ah9qo");

var $bgJDP = parcelRequire("bgJDP");

var $8Qvei = parcelRequire("8Qvei");

var $8QmUu = parcelRequire("8QmUu");
const $77a1a9ade7a31998$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bgJDP))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8QmUu))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5dxEd))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $77a1a9ade7a31998$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $77a1a9ade7a31998$var$appearanceIconSchema[appearance] || $77a1a9ade7a31998$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ primaryColor: primaryColor })=>/*#__PURE__*/ (0, $e79Pd.jsx)(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("5dxEd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc8445d7755f30f$var$_react = $3cc8445d7755f30f$var$_interopRequireDefault((parcelRequire("euxye")));

var $3cc8445d7755f30f$var$_baseNew = $3cc8445d7755f30f$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $3cc8445d7755f30f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc8445d7755f30f$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $3cc8445d7755f30f$var$_react.default.createElement($3cc8445d7755f30f$var$_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$3cc8445d7755f30f$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $3cc8445d7755f30f$var$_default = module.exports.default = $3cc8445d7755f30f$var$StatusDiscoveryIcon;

});



parcelRegister("jRJcI", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fa8830d0b91cdd1$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $iDZQS = parcelRequire("iDZQS");

var $6oFfP = parcelRequire("6oFfP");
const $3fa8830d0b91cdd1$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $3fa8830d0b91cdd1$var$Code = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $e79Pd.jsx)($3fa8830d0b91cdd1$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $4jQY2.default)([
            $3fa8830d0b91cdd1$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $3fa8830d0b91cdd1$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $6oFfP.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $iDZQS.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($3fa8830d0b91cdd1$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($3fa8830d0b91cdd1$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
        children: replacedChildren
    });
}
$3fa8830d0b91cdd1$var$RenderCodeChildrenWithBidiWarnings.displayName = "RenderCodeChildrenWithBidiWarnings";
function $3fa8830d0b91cdd1$var$isReactElement(child) {
    return !!child.type;
}
$3fa8830d0b91cdd1$var$Code.displayName = 'Code';
var $3fa8830d0b91cdd1$export$2e2bcd8739ae039 = $3fa8830d0b91cdd1$var$Code;

});
parcelRegister("iDZQS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec19a1143acfcf49$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hZDXn = parcelRequire("hZDXn");

var $7xcDT = parcelRequire("7xcDT");
function $ec19a1143acfcf49$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: label,
        tag: $ec19a1143acfcf49$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7xcDT.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7xcDT.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
$ec19a1143acfcf49$export$2e2bcd8739ae039.displayName = "BidiWarning";
const $ec19a1143acfcf49$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("7xcDT", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $8b37923a5cfdea42$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $apUrw = parcelRequire("apUrw");
const $8b37923a5cfdea42$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $8b37923a5cfdea42$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $8b37923a5cfdea42$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $4jQY2.default)([
                    $8b37923a5cfdea42$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
$8b37923a5cfdea42$export$a592b67c93d52467.displayName = "Decorator";
function $8b37923a5cfdea42$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("6oFfP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca665731a3a0db5c$export$2e2bcd8739ae039);

var $a80to = parcelRequire("a80to");
function $ca665731a3a0db5c$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll((0, $a80to.bidiCharacterRegex))
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});
parcelRegister("a80to", function(module, exports) {
$parcel$export(module.exports, "bidiCharacterRegex", () => $c0849c5afe74040f$export$ecb256e6a1f5ee7e);
const $c0849c5afe74040f$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;

});



parcelRegister("ahSro", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f645e96059f1330$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $glbdM = parcelRequire("glbdM");

var $1qU3G = parcelRequire("1qU3G");

var $egspI = parcelRequire("egspI");

var $2E2Gj = parcelRequire("2E2Gj");

var $2767r = parcelRequire("2767r");

var $aFw1x = parcelRequire("aFw1x");

var $kMyNx = parcelRequire("kMyNx");
const $2f645e96059f1330$var$getCodeBlockStyles = {
    rootT26Shape: "_2rko1mok",
    root: "_11c819w5 _2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhk187e _syazi7uo _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1j08 _1vbw1j08 _1v9c1j08 _1srnt0uh _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gsb9t _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909i8nm _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgc124n _bu7z124n _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3wu06 _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eihtd5cb _t9zbd5cb _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t36i7uo _137bh55r _1k7di7uo _97li16jw _12nh9lu1 _1g0517qg _i2igqmo9 _326zi7uo _113p1rpy _1n6t16jw _tgu817qg _1k4716jw _g0lxi7uo _ys4e1rpy _7gp8h55r _1yvqqmo9 _1vwwqmo9 _1rjuqmo9 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o6qmo9 _kxov17qg _1np517qg _m2f517qg _1b9t16jw _1tq616jw _1rd216jw _1pbk16jw _k3li16jw _13zt1rpy _2g12fb2s _k86bqmo9 _b5iy1rpy _gti31rpy _1f0g16jw _9d3e17qg _qdia16jw _72uv16jw",
    showLineNumbers: "_1707bror _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $2f645e96059f1330$var$CodeBlock = /*#__PURE__*/ (0, $euxye.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $euxye.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $euxye.useState)(false);
    // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $2767r.getLineNumWidth)(numLines) : 0;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $euxye.useEffect)(()=>{
        const schedule = (0, $1qU3G.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $2E2Gj.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $euxye.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $euxye.useMemo)(()=>(0, $aFw1x.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kMyNx.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $4jQY2.default)([
            $2f645e96059f1330$var$getCodeBlockStyles.root,
            (0, $egspI.fg)('platform-dst-shape-theme-default') && $2f645e96059f1330$var$getCodeBlockStyles.rootT26Shape,
            shouldWrapLongLines ? $2f645e96059f1330$var$getCodeBlockStyles.shouldWrapLongLines : $2f645e96059f1330$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $2f645e96059f1330$var$getCodeBlockStyles.showLineNumbers : $2f645e96059f1330$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $2f645e96059f1330$export$2e2bcd8739ae039 = $2f645e96059f1330$var$CodeBlock;

});
parcelRegister("2E2Gj", function(module, exports) {
$parcel$export(module.exports, "useHighlightLines", () => $315b73259a054470$export$84415a200bdf33ed);

var $euxye = parcelRequire("euxye");
const $315b73259a054470$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $315b73259a054470$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$315b73259a054470$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $315b73259a054470$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $315b73259a054470$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $euxye.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $euxye.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $315b73259a054470$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$315b73259a054470$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $315b73259a054470$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("2767r", function(module, exports) {
$parcel$export(module.exports, "getLineNumWidth", () => $41f9d678a00cfe68$export$cb7aec0206b595d2);
const $41f9d678a00cfe68$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("aFw1x", function(module, exports) {
$parcel$export(module.exports, "normalizeLanguage", () => $8890448de8bf5119$export$f38728011c178796);

var $emCaV = parcelRequire("emCaV");

var $kaNnc = parcelRequire("kaNnc");
const $8890448de8bf5119$export$f38728011c178796 = (0, $emCaV.default)((language)=>{
    if (!language) return '';
    const match = (0, $kaNnc.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("kaNnc", function(module, exports) {
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $5fa5f4b2c73e2eba$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $5fa5f4b2c73e2eba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];

});


parcelRegister("kMyNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc3cdeff6ee99af3$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $aymFe = parcelRequire("aymFe");
var $dc3cdeff6ee99af3$export$2e2bcd8739ae039 = (0, $aymFe.default);

});
parcelRegister("aymFe", function(module, exports) {
$parcel$export(module.exports, "default", () => $14daeeb825f89a76$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5CYN6 = parcelRequire("5CYN6");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $14daeeb825f89a76$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $5CYN6.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $e79Pd.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $14daeeb825f89a76$var$asyncGenerator = $14daeeb825f89a76$var$generator({
    loader: ()=>(parcelRequire("czUi3")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $14daeeb825f89a76$export$2e2bcd8739ae039 = $14daeeb825f89a76$var$asyncGenerator;

});
parcelRegister("5CYN6", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7a3f16c209dd1f0$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $l0wpG = parcelRequire("l0wpG");

var $opOff = parcelRequire("opOff");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $f7a3f16c209dd1f0$var$Highlight = /*#__PURE__*/ (0, $euxye.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $l0wpG.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $opOff.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $f7a3f16c209dd1f0$export$2e2bcd8739ae039 = $f7a3f16c209dd1f0$var$Highlight;

});
parcelRegister("l0wpG", function(module, exports) {
$parcel$export(module.exports, "default", () => $babf311a7f864b46$export$2e2bcd8739ae039);

var $iTxjC = parcelRequire("iTxjC");

var $40DFJ = parcelRequire("40DFJ");

var $kZqCA = parcelRequire("kZqCA");

var $1WvN5 = parcelRequire("1WvN5");
const $babf311a7f864b46$var$newLineRegex = /\n/g;
function $babf311a7f864b46$var$getNewLines(str) {
    return str.match($babf311a7f864b46$var$newLineRegex);
}
function $babf311a7f864b46$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $1WvN5.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $iTxjC.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $kZqCA.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $babf311a7f864b46$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $40DFJ.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $40DFJ.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("iTxjC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecc3428763186fb1$export$2e2bcd8739ae039);

var $40DFJ = parcelRequire("40DFJ");

var $gM7kA = parcelRequire("gM7kA");
function $ecc3428763186fb1$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $40DFJ.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $gM7kA.default)(lineNumber));
            return children;
        }
    };
}
var $ecc3428763186fb1$export$2e2bcd8739ae039 = $ecc3428763186fb1$var$createLineGenerator;

});
parcelRegister("40DFJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $54685ac5f5a720f5$export$2e2bcd8739ae039);

var $gM7kA = parcelRequire("gM7kA");
function $54685ac5f5a720f5$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $gM7kA.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $gM7kA.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("gM7kA", function(module, exports) {
$parcel$export(module.exports, "default", () => $89aee3d8f83a17e8$export$2e2bcd8739ae039);
function $89aee3d8f83a17e8$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("kZqCA", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ec7a72e58863c36$export$2e2bcd8739ae039);

var $egspI = parcelRequire("egspI");

var $40DFJ = parcelRequire("40DFJ");
function $7ec7a72e58863c36$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $40DFJ.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            // If this node is a re-highlighted fenced code-block wrapper (added by
            // rehighlightFencedBlocks in get-code-tree.tsx), reset the accumulated
            // class list instead of concatenating onto ancestors.  Without this,
            // every token inside the fenced block inherits all ancestor classes
            // (e.g. "token code token code-block language-jsx token plain-text").
            const nodeClasses = node.properties.className || [];
            const isCodeBlock = (0, $egspI.fg)('platform-code-highlight-markdown-safe') && nodeClasses.includes('code-block');
            // When entering a re-highlighted fenced code-block wrapper, reset the
            // accumulated ancestor classes to empty so children only carry their
            // own token classes (not the full ancestor chain).
            const classNames = isCodeBlock ? [] : className.concat(nodeClasses);
            $7ec7a72e58863c36$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("1WvN5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f265199868961edd$export$2e2bcd8739ae039);

var $egspI = parcelRequire("egspI");
/**
 * Extract the plain text content from a list of RefractorNodes.
 */ function $f265199868961edd$var$extractText(nodes) {
    return nodes.map((n)=>{
        if (n.type === 'text') return n.value;
        return n.children ? $f265199868961edd$var$extractText(n.children) : '';
    }).join('');
}
/**
 * Walk the safe-highlighted AST and, for every fenced code block (a `token code`
 * span), replace the raw text child with a properly highlighted `token code-block
 * language-{lang}` span so that inner tokens carry the correct classes.
 */ function $f265199868961edd$var$rehighlightFencedBlocks(nodes, astGenerator) {
    const refractorLike = astGenerator;
    return nodes.map((node)=>{
        if (node.type !== 'element') return node;
        const classes = node.properties?.className ?? [];
        const isCodeToken = classes.includes('token') && classes.includes('code');
        if (!isCodeToken || !node.children) return {
            ...node,
            children: $f265199868961edd$var$rehighlightFencedBlocks(node.children ?? [], astGenerator)
        };
        // Find the code-language child to determine which sub-language to use.
        const langNode = node.children.find((c)=>c.type === 'element' && c.properties?.className?.includes('code-language'));
        const subLang = langNode && langNode.type === 'element' ? $f265199868961edd$var$extractText(langNode.children ?? []).trim() : null;
        // Find the raw text child that holds the fenced block content (after the
        // opening ``` line and before the closing ```).
        const children = node.children.map((child)=>{
            // This is the raw code content
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            const rawContent = 'value' in child ? child.value : undefined;
            if (!subLang || !rawContent) return child;
            // Only re-highlight when the sub-language is registered with refractor to
            // avoid an uncaught exception.
            const isRegistered = typeof refractorLike.registered === 'function' ? refractorLike.registered(subLang) : Boolean(refractorLike.languages?.[subLang]);
            if (!isRegistered) return child;
            let highlighted;
            try {
                highlighted = astGenerator.highlight(rawContent, subLang);
            } catch  {
                return child;
            }
            // Wrap in a `token code-block language-{lang}` span to match what the
            // normal (non-safe) markdown highlight would produce.
            const codeBlockNode = {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: [
                        'token',
                        'code-block',
                        `language-${subLang}`
                    ]
                },
                children: highlighted
            };
            return codeBlockNode;
        });
        return {
            ...node,
            children: children
        };
    });
}
function $f265199868961edd$var$highlightMarkdownSafely(code, astGenerator) {
    const refractorLike = astGenerator;
    const markdownCodeToken = refractorLike.languages?.markdown?.code;
    const fencedToken = Array.isArray(markdownCodeToken) ? markdownCodeToken[1] : undefined;
    const originalInside = fencedToken?.inside;
    const canDisableEmbeddedCodeBlock = originalInside && 'code-block' in originalInside;
    if (canDisableEmbeddedCodeBlock) {
        const patchedInside = {
            ...originalInside
        };
        delete patchedInside['code-block'];
        fencedToken.inside = patchedInside;
    }
    let result;
    try {
        result = astGenerator.highlight(code, 'markdown');
    } finally{
        if (canDisableEmbeddedCodeBlock) fencedToken.inside = originalInside;
    }
    // Re-highlight inner fenced code blocks so tokens carry proper classes.
    return $f265199868961edd$var$rehighlightFencedBlocks(result, astGenerator);
}
function $f265199868961edd$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        if (language === 'markdown' && (0, $egspI.fg)('platform-code-highlight-markdown-safe')) return $f265199868961edd$var$highlightMarkdownSafely(code, astGenerator);
        return astGenerator.highlight(code, language);
    } catch  {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("opOff", function(module, exports) {
$parcel$export(module.exports, "default", () => $e191eddd5c966911$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $6gBs7 = parcelRequire("6gBs7");
function $e191eddd5c966911$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $6gBs7.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}
$e191eddd5c966911$export$2e2bcd8739ae039.displayName = "ReactRenderer";

});
parcelRegister("6gBs7", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a0f762e76b970a4$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iDZQS = parcelRequire("iDZQS");

var $6oFfP = parcelRequire("6oFfP");

var $aKC6k = parcelRequire("aKC6k");
function $4a0f762e76b970a4$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $4a0f762e76b970a4$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $6oFfP.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $iDZQS.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $aKC6k.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $4a0f762e76b970a4$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("aKC6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe2c77ca8ac6249a$export$2e2bcd8739ae039);

var $6gBs7 = parcelRequire("6gBs7");
function $fe2c77ca8ac6249a$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $6gBs7.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("czUi3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7NVS2").then(()=>parcelRequire('2PnWa'));

});




parcelRegister("4JQqO", function(module, exports) {
$parcel$export(module.exports, "default", () => $947e2445775a1307$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $hzWaA = parcelRequire("hzWaA");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $iTHno = parcelRequire("iTHno");
const $947e2445775a1307$var$authLevelMismatchIncomingMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-incoming",
    defaultMessage: "incoming"
});
const $947e2445775a1307$var$authLevelMismatchOutgoingMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-outgoing",
    defaultMessage: "outgoing"
});
const $947e2445775a1307$var$authTypeImpersonationMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-impersonation",
    defaultMessage: "OAuth with impersonation"
});
const $947e2445775a1307$var$authTypeDisabledMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-disabled",
    defaultMessage: "Disabled"
});
const $947e2445775a1307$var$authLevelMismatchUnknownDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-unknown-description",
    defaultMessage: "We couldn't detect the authentication method for this application link. Make sure both the local and remote connections use the same authentication type."
});
const $947e2445775a1307$var$authLevelMismatchDisabledOauthDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-disabled-oauth-description",
    defaultMessage: "The local {direction} connection is disabled, however <link>{applicationName}</link> uses {remoteAuthType}."
});
const $947e2445775a1307$var$authLevelMismatchOauthOauthDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-oauth-oauth-description",
    defaultMessage: "The local {direction} connection uses {localAuthType}, however <link>{applicationName}</link> uses {remoteAuthType}."
});
const $947e2445775a1307$var$authLevelMismatchOauthDisabledDescriptionMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-oauth-disabled-description",
    defaultMessage: "The local {direction} connection uses {localAuthType}, however it's disabled on <link>{applicationName}</link>."
});
const $947e2445775a1307$var$messages = {
    authLevelMismatchIncoming: $947e2445775a1307$var$authLevelMismatchIncomingMessage,
    authLevelMismatchOutgoing: $947e2445775a1307$var$authLevelMismatchOutgoingMessage,
    authTypeImpersonation: $947e2445775a1307$var$authTypeImpersonationMessage,
    authTypeDisabled: $947e2445775a1307$var$authTypeDisabledMessage,
    authLevelMismatchUnknownDescription: $947e2445775a1307$var$authLevelMismatchUnknownDescriptionMessage,
    authLevelMismatchDisabledOauthDescription: $947e2445775a1307$var$authLevelMismatchDisabledOauthDescriptionMessage,
    authLevelMismatchOauthOauthDescription: $947e2445775a1307$var$authLevelMismatchOauthOauthDescriptionMessage,
    authLevelMismatchOauthDisabledDescription: $947e2445775a1307$var$authLevelMismatchOauthDisabledDescriptionMessage
};
const $947e2445775a1307$var$PerDirectionDescription = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const buildDescriptionForMismatchState = (0, $euxye.useCallback)((direction)=>{
        const directionString = direction === 'incoming' ? formatMessage($947e2445775a1307$var$messages.authLevelMismatchIncoming) : formatMessage($947e2445775a1307$var$messages.authLevelMismatchOutgoing);
        switch(props.mismatchState){
            case 'disabled-oauth':
            case 'disabled-impersonation':
                {
                    const remoteAuthTypeString = props.mismatchState === 'disabled-oauth' ? formatMessage($947e2445775a1307$var$messages.authTypeDisabled) : formatMessage($947e2445775a1307$var$messages.authTypeImpersonation);
                    return formatMessage($947e2445775a1307$var$messages.authLevelMismatchDisabledOauthDescription, {
                        direction: directionString,
                        applicationName: props.name,
                        remoteAuthType: remoteAuthTypeString,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.displayUrl,
                                target: "_blank"
                            }, chunks)
                    });
                }
            case 'oauth-disabled':
            case 'impersonation-disabled':
                {
                    const localAuthTypeString = props.mismatchState === 'oauth-disabled' ? 'OAuth' // not translated, technical term
                     : formatMessage($947e2445775a1307$var$messages.authTypeImpersonation);
                    return formatMessage($947e2445775a1307$var$messages.authLevelMismatchOauthDisabledDescription, {
                        direction: directionString,
                        applicationName: props.name,
                        localAuthType: localAuthTypeString,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.displayUrl,
                                target: "_blank"
                            }, chunks)
                    });
                }
            case 'oauth-impersonation':
            case 'impersonation-oauth':
                {
                    const localAuthTypeString = props.mismatchState === 'oauth-impersonation' ? 'OAuth' // not translated, technical term
                     : formatMessage($947e2445775a1307$var$messages.authTypeImpersonation);
                    const remoteAuthTypeString = props.mismatchState === 'oauth-impersonation' ? formatMessage($947e2445775a1307$var$messages.authTypeImpersonation) : 'OAuth'; // not translated, technical term
                    return formatMessage($947e2445775a1307$var$messages.authLevelMismatchOauthOauthDescription, {
                        direction: directionString,
                        applicationName: props.name,
                        localAuthType: localAuthTypeString,
                        remoteAuthType: remoteAuthTypeString,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                                href: props.displayUrl,
                                target: "_blank"
                            }, chunks)
                    });
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
        }
    }, [
        formatMessage,
        props.displayUrl,
        props.mismatchState,
        props.name
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), null, buildDescriptionForMismatchState(props.direction));
};
$947e2445775a1307$var$PerDirectionDescription.displayName = "PerDirectionDescription";
const $947e2445775a1307$var$determineMismatchState = (status, direction)=>{
    const local = (0, $iTHno.getAuthLevel)(status.localAuthentication?.[direction]);
    const remote = (0, $iTHno.getAuthLevel)(status.remoteAuthentication?.[direction]);
    if (local === (0, $iTHno.AUTH_UNKNOWN) || remote === (0, $iTHno.AUTH_UNKNOWN)) return 'unknown';
    if (local === (0, $iTHno.AUTH_DISABLED) && remote === (0, $iTHno.AUTH_OAUTH1)) return 'disabled-oauth';
    if (local === (0, $iTHno.AUTH_DISABLED) && remote === (0, $iTHno.AUTH_OAUTH1_IMPERSONATION)) return 'disabled-impersonation';
    if (local === (0, $iTHno.AUTH_OAUTH1) && remote === (0, $iTHno.AUTH_DISABLED)) return 'oauth-disabled';
    if (local === (0, $iTHno.AUTH_OAUTH1_IMPERSONATION) && remote === (0, $iTHno.AUTH_DISABLED)) return 'impersonation-disabled';
    if (local === (0, $iTHno.AUTH_OAUTH1_IMPERSONATION) && remote === (0, $iTHno.AUTH_DISABLED)) return 'impersonation-disabled';
    if (local === (0, $iTHno.AUTH_OAUTH1_IMPERSONATION) && remote === (0, $iTHno.AUTH_OAUTH1)) return 'impersonation-oauth';
    return 'no-mismatch';
};
const $947e2445775a1307$export$9be1d088165ebfc0 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (props.incomingMismatch === 'unknown' || props.outgoingMismatch === 'unknown') return formatMessage($947e2445775a1307$var$messages.authLevelMismatchUnknownDescription);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($947e2445775a1307$var$PerDirectionDescription, {
        direction: "incoming",
        mismatchState: props.incomingMismatch,
        displayUrl: props.displayUrl,
        name: props.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($947e2445775a1307$var$PerDirectionDescription, {
        direction: "outgoing",
        mismatchState: props.outgoingMismatch,
        displayUrl: props.displayUrl,
        name: props.name
    }));
};
$947e2445775a1307$export$9be1d088165ebfc0.displayName = "InnerDescription";
const $947e2445775a1307$var$AuthLevelMismatchDescription = (props)=>{
    const incomingMismatch = $947e2445775a1307$var$determineMismatchState(props.status, 'incoming');
    const outgoingMismatch = $947e2445775a1307$var$determineMismatchState(props.status, 'outgoing');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($947e2445775a1307$export$9be1d088165ebfc0, {
        incomingMismatch: incomingMismatch,
        outgoingMismatch: outgoingMismatch,
        displayUrl: props.status.link.displayUrl,
        name: props.status.link.name
    });
};
$947e2445775a1307$var$AuthLevelMismatchDescription.displayName = "AuthLevelMismatchDescription";
var $947e2445775a1307$export$2e2bcd8739ae039 = $947e2445775a1307$var$AuthLevelMismatchDescription;

});
parcelRegister("iTHno", function(module, exports) {
$parcel$export(module.exports, "AUTH_OAUTH1_IMPERSONATION", () => $c2c12651ce24a3bf$export$ff126983aa810326);
$parcel$export(module.exports, "AUTH_OAUTH1", () => $c2c12651ce24a3bf$export$6ddd0a1beee0fc1f);
$parcel$export(module.exports, "AUTH_DISABLED", () => $c2c12651ce24a3bf$export$644a184fdd45756d);
$parcel$export(module.exports, "AUTH_UNKNOWN", () => $c2c12651ce24a3bf$export$7ca14fced66a01c9);
$parcel$export(module.exports, "AUTH_OAUTH2", () => $c2c12651ce24a3bf$export$c02e0077ab5a238d);
$parcel$export(module.exports, "getAuthLevel", () => $c2c12651ce24a3bf$export$59daaa60b235e641);
const $c2c12651ce24a3bf$export$ff126983aa810326 = 'oauthWithImpersonation';
const $c2c12651ce24a3bf$export$6ddd0a1beee0fc1f = 'oauth';
const $c2c12651ce24a3bf$export$644a184fdd45756d = 'disabled';
const $c2c12651ce24a3bf$export$7ca14fced66a01c9 = 'unknown';
const $c2c12651ce24a3bf$export$c02e0077ab5a238d = 'oauth2ThreeLo';
const $c2c12651ce24a3bf$export$59daaa60b235e641 = (config)=>{
    if (!config) return $c2c12651ce24a3bf$export$7ca14fced66a01c9;
    if (config.enabled && config.twoLoEnabled && config.twoLoImpersonationEnabled) return $c2c12651ce24a3bf$export$ff126983aa810326;
    if (config.enabled && !config.twoLoImpersonationEnabled) return $c2c12651ce24a3bf$export$6ddd0a1beee0fc1f;
    if (config.oAuth2ThreeLoEnabled) return $c2c12651ce24a3bf$export$c02e0077ab5a238d;
    if (!config.enabled && !config.twoLoEnabled && !config.twoLoImpersonationEnabled && !config.oAuth2ThreeLoEnabled) return $c2c12651ce24a3bf$export$644a184fdd45756d;
    return $c2c12651ce24a3bf$export$7ca14fced66a01c9;
};

});



parcelRegister("9xWqG", function(module, exports) {
$parcel$export(module.exports, "ERRORS", () => $f21763ad558f7970$export$4fd720569787ab6f);
/* eslint-disable jira/filename-case */ const $f21763ad558f7970$export$4fd720569787ab6f = {
    // Network errors
    CONNECTION_REFUSED: {
        type: 'CONNECTION_REFUSED',
        category: 'NETWORK_ERROR'
    },
    UNKNOWN_HOST: {
        type: 'UNKNOWN_HOST',
        category: 'NETWORK_ERROR'
    },
    SSL_UNTRUSTED: {
        type: 'SSL_UNTRUSTED',
        category: 'NETWORK_ERROR'
    },
    SSL_HOSTNAME_UNMATCHED: {
        type: 'SSL_HOSTNAME_UNMATCHED',
        category: 'NETWORK_ERROR'
    },
    SSL_UNMATCHED: {
        type: 'SSL_UNMATCHED',
        category: 'NETWORK_ERROR'
    },
    OAUTH_PROBLEM: {
        type: 'OAUTH_PROBLEM',
        category: 'NETWORK_ERROR'
    },
    OAUTH_TIMESTAMP_REFUSED: {
        type: 'OAUTH_TIMESTAMP_REFUSED',
        category: 'NETWORK_ERROR'
    },
    OAUTH_SIGNATURE_INVALID: {
        type: 'OAUTH_SIGNATURE_INVALID',
        category: 'NETWORK_ERROR'
    },
    UNEXPECTED_RESPONSE: {
        type: 'UNEXPECTED_RESPONSE',
        category: 'NETWORK_ERROR'
    },
    UNEXPECTED_RESPONSE_STATUS: {
        type: 'UNEXPECTED_RESPONSE_STATUS',
        category: 'NETWORK_ERROR'
    },
    // Configuration state errors
    CREATION_FAILED: {
        type: 'CREATION_FAILED',
        category: 'CREATION_FAILED'
    },
    CONFIGURATION_INCOMPLETE: {
        type: 'CONFIGURATION_INCOMPLETE',
        category: 'CONFIGURATION_INCOMPLETE'
    },
    CLOUD_CONNECTOR_AWAITING_DC_RESPONSE: {
        type: 'CLOUD_CONNECTOR_AWAITING_DC_RESPONSE',
        category: 'CONFIGURATION_INCOMPLETE'
    },
    IN_PROGRESS: {
        type: 'IN_PROGRESS',
        category: 'IN_PROGRESS'
    },
    SUBMISSION_FAILED: {
        type: 'SUBMISSION_FAILED',
        category: 'SUBMISSION_FAILED'
    },
    CONFIGURATION_COMPLETE: {
        type: 'CONFIGURATION_COMPLETE',
        category: 'CONFIGURATION_COMPLETE'
    },
    // Configuration errors
    AUTH_LEVEL_MISMATCH: {
        type: 'AUTH_LEVEL_MISMATCH',
        category: 'CONFIG_ERROR'
    },
    NO_REMOTE_APPLINK: {
        type: 'NO_REMOTE_APPLINK',
        category: 'CONFIG_ERROR'
    },
    // Access errors
    LOCAL_AUTH_TOKEN_REQUIRED: {
        type: 'LOCAL_AUTH_TOKEN_REQUIRED',
        category: 'ACCESS_ERROR'
    },
    REMOTE_AUTH_TOKEN_REQUIRED: {
        type: 'REMOTE_AUTH_TOKEN_REQUIRED',
        category: 'ACCESS_ERROR'
    },
    INSUFFICIENT_REMOTE_PERMISSION: {
        type: 'INSUFFICIENT_REMOTE_PERMISSION',
        category: 'ACCESS_ERROR'
    },
    // Incompatibility errors
    REMOTE_VERSION_INCOMPATIBLE: {
        type: 'REMOTE_VERSION_INCOMPATIBLE',
        category: 'INCOMPATIBLE'
    },
    NO_OUTGOING_AUTH: {
        type: 'NO_OUTGOING_AUTH',
        category: 'INCOMPATIBLE'
    },
    // Non-Atlassian errors
    GENERIC_LINK: {
        type: 'GENERIC_LINK',
        category: 'NON_ATLASSIAN'
    },
    NON_ATLASSIAN: {
        type: 'NON_ATLASSIAN',
        category: 'NON_ATLASSIAN'
    },
    // System errors
    SYSTEM_LINK: {
        type: 'SYSTEM_LINK',
        category: 'SYSTEM'
    },
    // Disabled errors
    DISABLED: {
        type: 'DISABLED',
        category: 'DISABLED'
    },
    // Deprecated functionality errors
    AUTH_LEVEL_UNSUPPORTED: {
        type: 'AUTH_LEVEL_UNSUPPORTED',
        category: 'DEPRECATED'
    },
    LEGACY_UPDATE: {
        type: 'LEGACY_UPDATE',
        category: 'DEPRECATED'
    },
    LEGACY_REMOVAL: {
        type: 'LEGACY_REMOVAL',
        category: 'DEPRECATED'
    },
    MANUAL_LEGACY_UPDATE: {
        type: 'MANUAL_LEGACY_UPDATE',
        category: 'DEPRECATED'
    },
    MANUAL_LEGACY_REMOVAL: {
        type: 'MANUAL_LEGACY_REMOVAL',
        category: 'DEPRECATED'
    },
    // Unknown errors
    UNKNOWN: {
        type: 'UNKNOWN',
        category: 'UNKNOWN'
    }
};

});

parcelRegister("6bB9L", function(module, exports) {
$parcel$export(module.exports, "StatusLozenge", () => $446311e5e8f2d1c6$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeV3", () => $446311e5e8f2d1c6$export$e8df9076d0ccd87c);

var $euxye = parcelRequire("euxye");

var $2EFuW = parcelRequire("2EFuW");

var $abhF2 = parcelRequire("abhF2");

var $hzWaA = parcelRequire("hzWaA");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9xWqG = parcelRequire("9xWqG");
const $446311e5e8f2d1c6$var$connectedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.connected-status",
    defaultMessage: "Connected"
});
const $446311e5e8f2d1c6$var$notConnectedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.not-connected-status",
    defaultMessage: "Not Connected"
});
const $446311e5e8f2d1c6$var$accessDeniedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.access-denied-status",
    defaultMessage: "Access denied"
});
const $446311e5e8f2d1c6$var$authTokenRequiredMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-token-required-title",
    defaultMessage: "Authenticate to see status"
});
const $446311e5e8f2d1c6$var$cloudConnectorAwaitingDcResponseStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.cloud-connector-awaiting-dc-response-status",
    defaultMessage: "Awaiting DC response"
});
const $446311e5e8f2d1c6$var$incompatibleStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.incompatible-status",
    defaultMessage: "Status unavailable"
});
const $446311e5e8f2d1c6$var$nonAtlassianStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.non-atlassian-status",
    defaultMessage: "Non-Atlassian"
});
const $446311e5e8f2d1c6$var$systemStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.system-status",
    defaultMessage: "System"
});
const $446311e5e8f2d1c6$var$networkErrorStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.network-error-status",
    defaultMessage: "Network error"
});
const $446311e5e8f2d1c6$var$creationFailedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.creation-failed-status",
    defaultMessage: "Creation failed"
});
const $446311e5e8f2d1c6$var$configurationIncompleteStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.configuration-incomplete-status",
    defaultMessage: "Configuration incomplete"
});
const $446311e5e8f2d1c6$var$inProgressStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.in-progress-status",
    defaultMessage: "In progress"
});
const $446311e5e8f2d1c6$var$configurationCompleteMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.configuration-complete-status",
    defaultMessage: "Configuration complete"
});
const $446311e5e8f2d1c6$var$submissionFailedMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.submission-failed-status",
    defaultMessage: "Submission failed"
});
const $446311e5e8f2d1c6$var$deprecatedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.deprecated-status",
    defaultMessage: "Deprecated"
});
const $446311e5e8f2d1c6$var$disabledStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.disabled-status",
    defaultMessage: "Disabled"
});
const $446311e5e8f2d1c6$var$configErrorStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.config-error-status",
    defaultMessage: "Config error"
});
const $446311e5e8f2d1c6$var$messages = {
    connectedStatus: $446311e5e8f2d1c6$var$connectedStatusMessage,
    notConnectedStatus: $446311e5e8f2d1c6$var$notConnectedStatusMessage,
    accessDeniedStatus: $446311e5e8f2d1c6$var$accessDeniedStatusMessage,
    authTokenRequired: $446311e5e8f2d1c6$var$authTokenRequiredMessage,
    cloudConnectorAwaitingDcResponseStatus: $446311e5e8f2d1c6$var$cloudConnectorAwaitingDcResponseStatusMessage,
    incompatibleStatus: $446311e5e8f2d1c6$var$incompatibleStatusMessage,
    nonAtlassianStatus: $446311e5e8f2d1c6$var$nonAtlassianStatusMessage,
    systemStatus: $446311e5e8f2d1c6$var$systemStatusMessage,
    networkErrorStatus: $446311e5e8f2d1c6$var$networkErrorStatusMessage,
    creationFailedStatus: $446311e5e8f2d1c6$var$creationFailedStatusMessage,
    configurationIncompleteStatus: $446311e5e8f2d1c6$var$configurationIncompleteStatusMessage,
    inProgressStatus: $446311e5e8f2d1c6$var$inProgressStatusMessage,
    configurationComplete: $446311e5e8f2d1c6$var$configurationCompleteMessage,
    submissionFailed: $446311e5e8f2d1c6$var$submissionFailedMessage,
    deprecatedStatus: $446311e5e8f2d1c6$var$deprecatedStatusMessage,
    disabledStatus: $446311e5e8f2d1c6$var$disabledStatusMessage,
    configErrorStatus: $446311e5e8f2d1c6$var$configErrorStatusMessage
};
const $446311e5e8f2d1c6$export$f72db4ad1e9b3e6d = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (props.kind === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: "small"
    });
    if (props.kind === 'working') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: "success",
        isBold: true
    }, formatMessage($446311e5e8f2d1c6$var$messages.connectedStatus));
    if (props.kind === 'not-connected') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        isBold: true
    }, formatMessage($446311e5e8f2d1c6$var$messages.notConnectedStatus));
    if (props.kind === 'error') {
        const { err: err } = props;
        if (err.category === 'ACCESS_ERROR') {
            if (err.type === 'INSUFFICIENT_REMOTE_PERMISSION') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                appearance: "moved",
                isBold: true
            }, formatMessage($446311e5e8f2d1c6$var$messages.accessDeniedStatus));
            // Authenticated status API -> prompt user to do OAuth dance
            if (props.authorisationUri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                href: props.authorisationUri
            }, formatMessage($446311e5e8f2d1c6$var$messages.authTokenRequired));
            // Fallback for ACCESS_ERROR cases that don't match above conditions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                appearance: "removed",
                isBold: true
            }, formatMessage($446311e5e8f2d1c6$var$messages.accessDeniedStatus));
        }
        if ((0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs')) // FG tidy note: merge it to the main switch clause below
        switch(err.type){
            case 'CLOUD_CONNECTOR_AWAITING_DC_RESPONSE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.cloudConnectorAwaitingDcResponseStatus));
            default:
        }
        switch(err.type){
            case 'INCOMPATIBLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.incompatibleStatus));
            case 'NON_ATLASSIAN':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.nonAtlassianStatus));
            case 'SYSTEM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.systemStatus));
            case 'NETWORK_ERROR':
            case 'UNKNOWN':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.networkErrorStatus));
            case 'CREATION_FAILED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.creationFailedStatus));
            case 'CONFIGURATION_INCOMPLETE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.configurationIncompleteStatus));
            case 'IN_PROGRESS':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "moved",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.inProgressStatus));
            case 'CONFIGURATION_COMPLETE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "inprogress",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.configurationComplete));
            case 'SUBMISSION_FAILED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.submissionFailed));
            case 'DEPRECATED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "inprogress",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.deprecatedStatus));
            case 'DISABLED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.disabledStatus));
            case 'CONFIG_ERROR':
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.configErrorStatus));
        }
    }
};
$446311e5e8f2d1c6$export$f72db4ad1e9b3e6d.displayName = "StatusLozenge";
const $446311e5e8f2d1c6$export$e8df9076d0ccd87c = (props)=>{
    const wrapWithV3Status = (0, $euxye.useCallback)(()=>{
        if (!props.status) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($446311e5e8f2d1c6$export$f72db4ad1e9b3e6d, {
            kind: "loading"
        });
        if (props.status.working) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($446311e5e8f2d1c6$export$f72db4ad1e9b3e6d, {
            kind: "working"
        });
        const err = props.status.error ?? (0, $9xWqG.ERRORS).UNKNOWN;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($446311e5e8f2d1c6$export$f72db4ad1e9b3e6d, {
            kind: "error",
            err: err
        });
    }, [
        props.status
    ]);
    return wrapWithV3Status();
};
$446311e5e8f2d1c6$export$e8df9076d0ccd87c.displayName = "StatusLozengeV3";

});
parcelRegister("2EFuW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8b8592b101d1a34$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");

var $3nvjS = parcelRequire("3nvjS");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $d8b8592b101d1a34$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhk1w7a",
    'bg.subtle.inprogress': "_bfhk1w7a",
    'bg.subtle.moved': "_bfhk1w7a",
    'bg.subtle.new': "_bfhk1w7a",
    'bg.subtle.removed': "_bfhk1w7a",
    'bg.subtle.success': "_bfhk1w7a",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $d8b8592b101d1a34$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $d8b8592b101d1a34$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $d8b8592b101d1a34$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $d8b8592b101d1a34$var$LegacyLozenge = /*#__PURE__*/ (0, $euxye.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $euxye.useMemo)(()=>$d8b8592b101d1a34$var$appearanceTypes.includes(appearance) || $d8b8592b101d1a34$var$newSemanticColors.includes(appearance) ? $d8b8592b101d1a34$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $d8b8592b101d1a34$var$styles.container,
            $d8b8592b101d1a34$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $d8b8592b101d1a34$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $d8b8592b101d1a34$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $4jQY2.default)([
                $d8b8592b101d1a34$var$styles.text,
                (0, $egspI.fg)('platform-lozenge-custom-letterspacing') && $d8b8592b101d1a34$var$styles.customLetterspacing,
                $d8b8592b101d1a34$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$d8b8592b101d1a34$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ const $d8b8592b101d1a34$var$LozengeWrapper = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    if ((0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3nvjS.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($d8b8592b101d1a34$var$LegacyLozenge, {
        ...props
    });
});
$d8b8592b101d1a34$var$LozengeWrapper.displayName = 'Lozenge';
var $d8b8592b101d1a34$export$2e2bcd8739ae039 = $d8b8592b101d1a34$var$LozengeWrapper;

});
parcelRegister("3nvjS", function(module, exports) {
$parcel$export(module.exports, "default", () => $67b40f7b3829f7ce$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $klhLt = parcelRequire("klhLt");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $67b40f7b3829f7ce$var$Lozenge = ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $klhLt.default), {
        ...baseProps,
        children: children
    });
};
$67b40f7b3829f7ce$var$Lozenge.displayName = "Lozenge";
$67b40f7b3829f7ce$var$Lozenge.displayName = 'Lozenge';
var $67b40f7b3829f7ce$export$2e2bcd8739ae039 = $67b40f7b3829f7ce$var$Lozenge;

});
parcelRegister("klhLt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3faaeb4e176c8744$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $e3neg = parcelRequire("e3neg");

var $1MNmN = parcelRequire("1MNmN");

var $ld25x = parcelRequire("ld25x");

var $92a3Y = parcelRequire("92a3Y");

var $egspI = parcelRequire("egspI");

var $jYEcG = parcelRequire("jYEcG");

var $abhF2 = parcelRequire("abhF2");

var $gGNug = parcelRequire("gGNug");

var $50oxN = parcelRequire("50oxN");

var $gPZy0 = parcelRequire("gPZy0");
// Get the pressed background color for the selected lozenge dropdown trigger
const $3faaeb4e176c8744$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $3faaeb4e176c8744$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d3acm _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $3faaeb4e176c8744$var$LozengeBase = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, $euxye.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, $92a3Y.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    const isInitialRender = (0, $euxye.useRef)(true);
    const isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $gPZy0.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $gGNug.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $gPZy0.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style?.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $euxye.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $egspI.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $4jQY2.default)([
            $3faaeb4e176c8744$var$styles.content,
            spacing === 'spacious' && $3faaeb4e176c8744$var$styles.contentSpacious,
            isLoading && $3faaeb4e176c8744$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $3faaeb4e176c8744$var$styles.maxWidth
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $50oxN.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                style: {
                    // The text fills 100% of the inner content wrapper. The container's
                    // own max-width (set on the container via commonStyleOverrides) handles
                    // the actual size constraint, so the text just needs to fill the available
                    // space and truncate when it overflows.
                    maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style?.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $4jQY2.default)([
                    $3faaeb4e176c8744$var$styles.text,
                    enableMotionFG && resizing && !maxWidth ? $3faaeb4e176c8744$var$styles.textClip : $3faaeb4e176c8744$var$styles.textEllipsis,
                    spacing === 'spacious' && $3faaeb4e176c8744$var$styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && `${testId}--metric`,
                className: (0, $4jQY2.default)([
                    $3faaeb4e176c8744$var$styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e3neg.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $jYEcG.default), {
        ref: ref,
        xcss: (0, $1MNmN.cx)($3faaeb4e176c8744$var$styles.container, (0, $egspI.fg)('platform-dst-motion-uplift') && $3faaeb4e176c8744$var$styles.motionContainer, spacing === 'spacious' && $3faaeb4e176c8744$var$styles.containerSpacious, !isSelected && $3faaeb4e176c8744$var$styles.iconBorderFilter, $3faaeb4e176c8744$var$styles[colorStyleKey], !isLoading && $3faaeb4e176c8744$var$styles[interactiveStyleKey], hasTrailingMetric && $3faaeb4e176c8744$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $3faaeb4e176c8744$var$styles.containerBadgeNeutralAppearance),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $3faaeb4e176c8744$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        ...isSelected && {
            'data-selected': 'true'
        },
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $3faaeb4e176c8744$var$styles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $3faaeb4e176c8744$var$styles.container,
            spacing === 'spacious' && $3faaeb4e176c8744$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $3faaeb4e176c8744$var$styles.containerBadgePadding,
            $3faaeb4e176c8744$var$styles[colorStyleKey],
            $3faaeb4e176c8744$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $3faaeb4e176c8744$var$styles.containerBadgeNeutralAppearance
        ]),
        children: innerContent
    });
}));
var $3faaeb4e176c8744$export$2e2bcd8739ae039 = $3faaeb4e176c8744$var$LozengeBase;

});
parcelRegister("92a3Y", function(module, exports) {
$parcel$export(module.exports, "useResizing", () => $118e3e559949fdce$export$a300664a1a230956);

var $euxye = parcelRequire("euxye");

var $bG844 = parcelRequire("bG844");

var $DxsCA = parcelRequire("DxsCA");

var $dxDNV = parcelRequire("dxDNV");

var $23KBv = parcelRequire("23KBv");

var $3bcsJ = parcelRequire("3bcsJ");

var $8SBzz = parcelRequire("8SBzz");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $118e3e559949fdce$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $118e3e559949fdce$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $118e3e559949fdce$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $118e3e559949fdce$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $euxye.useRef)();
    const [element, setElementRef] = (0, $DxsCA.useElementRef)();
    const setTimeout = (0, $3bcsJ.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $23KBv.useRequestAnimationFrame)();
    (0, $8SBzz.useSnapshotBeforeUpdate)(()=>{
        if ((0, $bG844.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dxDNV.useLayoutEffect)(()=>{
        if ((0, $bG844.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$118e3e559949fdce$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $118e3e559949fdce$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $118e3e559949fdce$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("DxsCA", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $958f86e68cfa7424$export$ff879f35a69d56b7);

var $euxye = parcelRequire("euxye");
const $958f86e68cfa7424$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $euxye.useRef)(null);
    const setRef = (0, $euxye.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("23KBv", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $f0c1db887ba444d9$export$1775f27e7c8051ca);

var $euxye = parcelRequire("euxye");
const $f0c1db887ba444d9$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f0c1db887ba444d9$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $euxye.useRef)([]);
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f0c1db887ba444d9$var$getHookDeps(opts));
    return (0, $euxye.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("8SBzz", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $96af143d05808ac5$export$9e95200239cd148b);

var $euxye = parcelRequire("euxye");

var $dxDNV = parcelRequire("dxDNV");
const $96af143d05808ac5$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $euxye.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dxDNV.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("gGNug", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $d4c8d18968527ec3$export$a3fc04b8551e006a);
const $d4c8d18968527ec3$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("50oxN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e718e55264f9758e$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const $e718e55264f9758e$var$getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const $e718e55264f9758e$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
}; /**
    * Icon renderer for lozenge components
    * Handles proper sizing and color theming for icons
    */ 
const $e718e55264f9758e$var$IconRenderer = ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $e718e55264f9758e$var$getIconColor(color);
    return (0, $egspI.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $e718e55264f9758e$var$styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
$e718e55264f9758e$var$IconRenderer.displayName = "IconRenderer";
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e718e55264f9758e$export$2e2bcd8739ae039 = $e718e55264f9758e$var$IconRenderer;

});

parcelRegister("gPZy0", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $0cbf84f8cb80cf72$export$acf5d2b7dc999bda);

// Map legacy appearance to new color values
const $0cbf84f8cb80cf72$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $0cbf84f8cb80cf72$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $0cbf84f8cb80cf72$var$legacyAppearanceMap[appearance] ?? appearance;
};

});





parcelRegister("5BRzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $1398e74ef3807235$export$2e2bcd8739ae039);
/* ApplinksOAuth2EditPageContents.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $fWb5q = parcelRequire("fWb5q");

var $hiKld = parcelRequire("hiKld");

var $2kZKn = parcelRequire("2kZKn");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $9ufM9 = parcelRequire("9ufM9");

var $aybNy = parcelRequire("aybNy");

var $55BnK = parcelRequire("55BnK");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $6CfY5 = parcelRequire("6CfY5");

var $fhcP0 = parcelRequire("fhcP0");

var $drATu = parcelRequire("drATu");

var $1b6Nh = parcelRequire("1b6Nh");

var $kjKdI = parcelRequire("kjKdI");

var $aRJMv = parcelRequire("aRJMv");
const $1398e74ef3807235$var$linkDetailsSectionHeadingMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Link details",
    id: "applinks.administration.ui.edit.link-details-section-heading"
});
const $1398e74ef3807235$var$formCancelButtonTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Cancel",
    id: "applinks.administration.ui.edit.form-cancel-button-text"
});
const $1398e74ef3807235$var$formSaveButtonTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Save",
    id: "applinks.administration.ui.edit.form-save-button-text"
});
const $1398e74ef3807235$var$continueLinkingTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Continue linking to the external application",
    id: "applinks.administration.ui.edit.continue-linking.title"
});
const $1398e74ef3807235$var$continueLinkingDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "In order to complete the link, enter the credentials for the incoming and outgoing links below.",
    id: "applinks.administration.ui.edit.continue-linking.description"
});
const $1398e74ef3807235$var$oauth2ConfigLoadFailedTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Failed to load the OAuth 2.0 configuration",
    id: "applinks.administration.ui.edit.oauth2-config-load-failed-title"
});
const $1398e74ef3807235$var$oauth2ConfigLoadFailedDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We couldn't load the OAuth 2.0 configuration for this app. This may be because the target app is inaccessible.",
    id: "applinks.administration.ui.edit.oauth2-config-load-failed-description"
});
const $1398e74ef3807235$var$unknownErrorTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We encountered an unknown error.",
    id: "applinks.administration.ui.unknown-error"
});
const $1398e74ef3807235$var$styles = {
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _19pkpxbi",
    formSectionInner: "_19pkpxbi"
};
const $1398e74ef3807235$var$ApplinksOAuth2EditPageContents = (props)=>{
    const { push: push } = (0, $55BnK.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getListPageUrl = (0, $euxye.useCallback)(()=>{
        if ((0, $i860n.fg)('applinks-933-experimental-list-page')) return 0, $1b6Nh.APPLINKS_LIST_PAGE_URL;
        return 0, $1b6Nh.APPLINKS_LIST_PAGE_URL_LEGACY;
    }, []);
    const onFormSubmit = (0, $euxye.useCallback)(async (data)=>{
        try {
            const applinkUpdate = {
                id: props.applink.id,
                type: props.applink.type,
                system: props.applink.system,
                primary: props.applink.primary,
                isExtraAuthRequired: props.applink.isExtraAuthRequired,
                rpcUrl: props.applink.rpcUrl,
                // Only change these properties:
                name: data.displayName,
                displayUrl: data.displayUrl
            };
            await (0, $drATu.updateApplinkV3)(props.applink.id, applinkUpdate);
            if (props.oauth2ConfigInfo !== null) {
                const scopes = data.remoteApplicationSupportedScopes ? data.remoteApplicationSupportedScopes.map((scope)=>scope.value) : [];
                const hasChanges = (0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') ? data.applicationClientId || data.applicationClientSecret || data.redirectUrl || scopes.length > 0 // only include scope checkes if feature gate is enabled
                 : data.applicationClientId || data.applicationClientSecret || data.redirectUrl;
                if (hasChanges) {
                    const oauth2ConfigUpdate = {
                        remoteClientId: data.applicationClientId,
                        remoteClientSecret: data.applicationClientSecret,
                        remoteRedirectUrl: data.redirectUrl,
                        outboundScopes: scopes
                    };
                    await (0, $drATu.putOAuth2ConfigInfo)(props.applink.id, oauth2ConfigUpdate);
                }
            }
            push(getListPageUrl());
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined; // If you see this error:
            // - partially linked variant = outgoing credentials are inline
            // - normal variant = outgoing credentials are submitted via a separate modal (outgoing-credentials-modal)
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.edit.oauth2.submitEditForm', `Failed to update OAuth 2.0 applink ${props.partiallyLinkedMode ? 'using partially linked variant' : 'using normal variant'} of the edit form`, maybeError);
            if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onDisplayError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($1398e74ef3807235$var$unknownErrorTextMessage)));
            else props.onDisplayError(maybeError ? maybeError.message : formatMessage($1398e74ef3807235$var$unknownErrorTextMessage));
            return err;
        }
    }, [
        formatMessage,
        getListPageUrl,
        props,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.default), {
            title: formatMessage($1398e74ef3807235$var$linkDetailsSectionHeadingMessage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.200",
            xcss: $1398e74ef3807235$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fhcP0.DisplayName), {
            name: "displayName",
            defaultName: props.applink.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fhcP0.DisplayUrl), {
            name: "displayUrl",
            defaultUrl: props.applink.displayUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fhcP0.ApplicationUrl), {
            name: "rpcUrl",
            defaultUrl: props.applink.rpcUrl,
            disabled: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("hr", {
            role: "presentation",
            className: (0, $4jQY2.default)([
                $1398e74ef3807235$var$styles.dividerStyle
            ])
        }), props.partiallyLinkedMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aybNy.default), {
            title: formatMessage($1398e74ef3807235$var$continueLinkingTitleMessage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($1398e74ef3807235$var$continueLinkingDescriptionMessage))), props.oauth2ConfigInfo !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aRJMv.default), {
            ...props,
            oauth2ConfigInfo: props.oauth2ConfigInfo,
            onRequestStatusRefresh: props.onRequestStatusRefresh
        }), !props.oauth2ConfigInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aybNy.default), {
            appearance: "error",
            title: formatMessage($1398e74ef3807235$var$oauth2ConfigLoadFailedTitleMessage)
        }, formatMessage($1398e74ef3807235$var$oauth2ConfigLoadFailedDescriptionMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hiKld.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
            href: getListPageUrl(),
            appearance: "subtle"
        }, formatMessage($1398e74ef3807235$var$formCancelButtonTextMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            testId: "applinks-administration.ui.edit.oauth2.submit-button",
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, formatMessage($1398e74ef3807235$var$formSaveButtonTextMessage))))))));
};
$1398e74ef3807235$var$ApplinksOAuth2EditPageContents.displayName = "ApplinksOAuth2EditPageContents";
var $1398e74ef3807235$export$2e2bcd8739ae039 = $1398e74ef3807235$var$ApplinksOAuth2EditPageContents;

});
parcelRegister("fWb5q", function(module, exports) {
$parcel$export(module.exports, "default", () => $7076ccab54f0973c$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $bnT8S = parcelRequire("bnT8S");

var $5fdMm = parcelRequire("5fdMm");

var $lGUEP = parcelRequire("lGUEP");

var $lpQqY = parcelRequire("lpQqY");

var $ljVHR = parcelRequire("ljVHR");

var $edeJn = parcelRequire("edeJn");

var $iV868 = parcelRequire("iV868");

var $k5Y8Z = parcelRequire("k5Y8Z");
const $7076ccab54f0973c$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $euxye.useRef)(null);
    const onSubmitRef = (0, $euxye.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $euxye.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $bnT8S.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($lGUEP)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($lGUEP)))(values, name, value);
                    }
                }
            }
        });
        (0, $5fdMm.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $k5Y8Z.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $euxye.useState)({
        dirty: false,
        submitting: false
    });
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $euxye.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $euxye.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $euxye.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $ljVHR.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $e79Pd.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $edeJn.FormContext).Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iV868.IsDisabledContext).Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
$7076ccab54f0973c$var$FormBase.displayName = "FormBase";
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $7076ccab54f0973c$var$Form = (0, $lpQqY.default)($7076ccab54f0973c$var$FormBase);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7076ccab54f0973c$export$2e2bcd8739ae039 = $7076ccab54f0973c$var$Form;

});
parcelRegister("bnT8S", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $849c9dc486c6c0b4$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $849c9dc486c6c0b4$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $849c9dc486c6c0b4$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $849c9dc486c6c0b4$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $849c9dc486c6c0b4$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $849c9dc486c6c0b4$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $849c9dc486c6c0b4$export$f681a8129d2e9d28);

var $jimAf = parcelRequire("jimAf");

var $2rVEs = parcelRequire("2rVEs");
//      
var $849c9dc486c6c0b4$var$charCodeOfDot = ".".charCodeAt(0);
var $849c9dc486c6c0b4$var$reEscapeChar = /\\(\\)?/g;
var $849c9dc486c6c0b4$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $849c9dc486c6c0b4$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $849c9dc486c6c0b4$var$charCodeOfDot) result.push("");
    string.replace($849c9dc486c6c0b4$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($849c9dc486c6c0b4$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $849c9dc486c6c0b4$var$keysCache = {};
var $849c9dc486c6c0b4$var$keysRegex = /[.[\]]+/;
var $849c9dc486c6c0b4$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($849c9dc486c6c0b4$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $849c9dc486c6c0b4$var$keysCache[key] = key.split($849c9dc486c6c0b4$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $849c9dc486c6c0b4$var$keysCache[key] = $849c9dc486c6c0b4$var$stringToPath(key);
    }
    return $849c9dc486c6c0b4$var$keysCache[key];
};
//      
var $849c9dc486c6c0b4$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $849c9dc486c6c0b4$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $849c9dc486c6c0b4$var$_toPropertyKey(arg) {
    var key = $849c9dc486c6c0b4$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $849c9dc486c6c0b4$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $849c9dc486c6c0b4$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $2rVEs.default)(current, [
                key
            ].map($849c9dc486c6c0b4$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $jimAf.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $849c9dc486c6c0b4$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $849c9dc486c6c0b4$var$setInRecursor(state, 0, $849c9dc486c6c0b4$var$toPath(key), value1, destroyArrays);
};
var $849c9dc486c6c0b4$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $849c9dc486c6c0b4$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $849c9dc486c6c0b4$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $849c9dc486c6c0b4$export$c52e5867d5879e24(values, name);
    var error = $849c9dc486c6c0b4$export$c52e5867d5879e24(errors, name);
    if (error && error[$849c9dc486c6c0b4$export$735bebc8ffabf28a]) error = error[$849c9dc486c6c0b4$export$735bebc8ffabf28a];
    var submitError = submitErrors && $849c9dc486c6c0b4$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $849c9dc486c6c0b4$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($849c9dc486c6c0b4$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $849c9dc486c6c0b4$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $849c9dc486c6c0b4$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $849c9dc486c6c0b4$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$849c9dc486c6c0b4$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $849c9dc486c6c0b4$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $849c9dc486c6c0b4$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $849c9dc486c6c0b4$var$subscriptionFilter(result, state, previousState, subscription, $849c9dc486c6c0b4$export$41e855cb628c1b55, $849c9dc486c6c0b4$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $849c9dc486c6c0b4$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $849c9dc486c6c0b4$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $849c9dc486c6c0b4$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $849c9dc486c6c0b4$var$subscriptionFilter(result, state, previousState, subscription, $849c9dc486c6c0b4$export$f1ff97b9d1c7a3c3, $849c9dc486c6c0b4$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $849c9dc486c6c0b4$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$849c9dc486c6c0b4$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $849c9dc486c6c0b4$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $849c9dc486c6c0b4$export$83d89fbfd8236492 = "4.20.10";
var $849c9dc486c6c0b4$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $849c9dc486c6c0b4$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $849c9dc486c6c0b4$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $849c9dc486c6c0b4$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $849c9dc486c6c0b4$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $849c9dc486c6c0b4$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $849c9dc486c6c0b4$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $849c9dc486c6c0b4$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($849c9dc486c6c0b4$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $849c9dc486c6c0b4$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $jimAf.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $jimAf.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $jimAf.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $jimAf.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $jimAf.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $849c9dc486c6c0b4$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $849c9dc486c6c0b4$export$e6bdf135a54e021b,
                    shallowEqual: $849c9dc486c6c0b4$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $jimAf.default)({}, state.formState.values)); // clone to avoid writing
            if ($849c9dc486c6c0b4$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $849c9dc486c6c0b4$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $849c9dc486c6c0b4$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $jimAf.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $jimAf.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $849c9dc486c6c0b4$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $849c9dc486c6c0b4$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $849c9dc486c6c0b4$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$849c9dc486c6c0b4$export$735bebc8ffabf28a]) {
                    var existing = $849c9dc486c6c0b4$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$849c9dc486c6c0b4$export$735bebc8ffabf28a] = error[$849c9dc486c6c0b4$export$735bebc8ffabf28a];
                    merged = $849c9dc486c6c0b4$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$849c9dc486c6c0b4$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$849c9dc486c6c0b4$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $jimAf.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $849c9dc486c6c0b4$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $849c9dc486c6c0b4$var$notify(fieldSubscriber, fieldState, lastFieldState, $849c9dc486c6c0b4$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $849c9dc486c6c0b4$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $jimAf.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, key), $849c9dc486c6c0b4$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, key), $849c9dc486c6c0b4$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$849c9dc486c6c0b4$var$hasAnyError(formState.errors) && !(formState.submitErrors && $849c9dc486c6c0b4$var$hasAnyError(formState.submitErrors));
        var nextFormState = $849c9dc486c6c0b4$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $849c9dc486c6c0b4$var$notify(state.subscribers, nextFormState, lastFormState, $849c9dc486c6c0b4$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $jimAf.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $jimAf.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $jimAf.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, key), $849c9dc486c6c0b4$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $849c9dc486c6c0b4$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $849c9dc486c6c0b4$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, name) === $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $jimAf.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $jimAf.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $jimAf.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $849c9dc486c6c0b4$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$849c9dc486c6c0b4$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $jimAf.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $849c9dc486c6c0b4$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $849c9dc486c6c0b4$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $849c9dc486c6c0b4$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $849c9dc486c6c0b4$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("5fdMm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d190aab65da16cf$export$2e2bcd8739ae039);

var $bnT8S = parcelRequire("bnT8S");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3d190aab65da16cf$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3d190aab65da16cf$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3d190aab65da16cf$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3d190aab65da16cf$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $bnT8S.getIn)(errors, input.name);
    });
};
//      
var $3d190aab65da16cf$var$noop = function noop() {};
var $3d190aab65da16cf$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3d190aab65da16cf$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3d190aab65da16cf$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3d190aab65da16cf$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3d190aab65da16cf$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3d190aab65da16cf$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3d190aab65da16cf$export$2e2bcd8739ae039 = $3d190aab65da16cf$var$createDecorator;

});

parcelRegister("lGUEP", function(module, exports) {

var $9QIfm = parcelRequire("9QIfm");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $fca978341a2a3489$var$set(object, path, value) {
    return object == null ? object : $9QIfm(object, path, value);
}
module.exports = $fca978341a2a3489$var$set;

});

parcelRegister("edeJn", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $c43813f70010d7c1$export$c24727297075ec6a);

var $euxye = parcelRequire("euxye");
const $c43813f70010d7c1$export$c24727297075ec6a = /*#__PURE__*/ (0, $euxye.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

});

parcelRegister("iV868", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $eb347834e1ddd675$export$c17cf6b332a82dbc);

var $euxye = parcelRequire("euxye");
const $eb347834e1ddd675$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $euxye.createContext)(false);

});

parcelRegister("k5Y8Z", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $e3c82af3a57208e4$export$fc06342dc8588d3b);

var $bnT8S = parcelRequire("bnT8S");
const $e3c82af3a57208e4$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $bnT8S.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $bnT8S.getIn)(errors, input.name);
    });
};

});


parcelRegister("hiKld", function(module, exports) {
$parcel$export(module.exports, "default", () => $037f4a53d03118c6$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $037f4a53d03118c6$var$formFooterWrapperStyles = null;
const $037f4a53d03118c6$var$justifyContentStyles = null;
function $037f4a53d03118c6$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("footer", {
        className: (0, $4jQY2.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}
$037f4a53d03118c6$export$2e2bcd8739ae039.displayName = "FormFooter";

});

parcelRegister("2kZKn", function(module, exports) {
$parcel$export(module.exports, "default", () => $def0b751cc8285bf$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2iotI = parcelRequire("2iotI");
const $def0b751cc8285bf$var$formSectionDescriptionStyles = null;
const $def0b751cc8285bf$var$formSectionWrapperStyles = null;
const $def0b751cc8285bf$var$FormSectionWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
$def0b751cc8285bf$var$FormSectionWrapper.displayName = "FormSectionWrapper";
const $def0b751cc8285bf$var$FormSectionDescription = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
$def0b751cc8285bf$var$FormSectionDescription.displayName = "FormSectionDescription";
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $def0b751cc8285bf$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)($def0b751cc8285bf$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $e79Pd.jsx)($def0b751cc8285bf$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
$def0b751cc8285bf$var$FormSection.displayName = "FormSection";
var $def0b751cc8285bf$export$2e2bcd8739ae039 = $def0b751cc8285bf$var$FormSection;

});

parcelRegister("fhcP0", function(module, exports) {
$parcel$export(module.exports, "CopyableApplicationClientID", () => $753a107deadb6590$export$933c655d375093bb);
$parcel$export(module.exports, "CopyableApplicationClientSecret", () => $753a107deadb6590$export$eeaa05b78b5f2773);
$parcel$export(module.exports, "RemoteApplicationScopeMultiSelect", () => $753a107deadb6590$export$e6ea1c895768a29c);
$parcel$export(module.exports, "ApplicationClientId", () => $753a107deadb6590$export$c8399aae3a726af3);
$parcel$export(module.exports, "ApplicationClientSecret", () => $753a107deadb6590$export$f137c4dc8b585189);
$parcel$export(module.exports, "RedirectUrl", () => $753a107deadb6590$export$e0ad63dba68d8cca);
$parcel$export(module.exports, "DisplayName", () => $753a107deadb6590$export$101fbca3a406e1fd);
$parcel$export(module.exports, "DisplayUrl", () => $753a107deadb6590$export$b07e64a5c70fbd11);
$parcel$export(module.exports, "ApplicationUrl", () => $753a107deadb6590$export$5c4f409b6c929d7a);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $3PC9r = parcelRequire("3PC9r");

var $hO3zy = parcelRequire("hO3zy");
var $bEwPd = parcelRequire("bEwPd");

var $1W2Av = parcelRequire("1W2Av");

var $7aCqr = parcelRequire("7aCqr");

var $ioVrz = parcelRequire("ioVrz");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kjKdI = parcelRequire("kjKdI");

var $1b6Nh = parcelRequire("1b6Nh");

var $8RhC5 = parcelRequire("8RhC5");
const $753a107deadb6590$var$clientIdLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "App client ID",
    id: "applinks.administration.ui.common.fields.client-id.label"
});
const $753a107deadb6590$var$clientSecretLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "App client secret",
    id: "applinks.administration.ui.common.fields.client-secret.label"
});
const $753a107deadb6590$var$remoteApplicationScopesLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Remote app scopes",
    id: "applinks.administration.ui.common.fields.remote-application-scopes.label"
});
const $753a107deadb6590$var$remoteApplicationScopesPlaceholder = (0, $7eNDO.defineMessage)({
    defaultMessage: "Use the same scopes as the remote app",
    id: "applinks.administration.ui.common.fields.remote-application-scopes.placeholder"
});
const $753a107deadb6590$var$redirectUrlLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Redirect URL",
    id: "applinks.administration.ui.common.fields.redirect-url.label"
});
const $753a107deadb6590$var$displayNameLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Display name",
    id: "applinks.administration.ui.common.fields.display-name.label"
});
const $753a107deadb6590$var$displayNamePlaceholder = (0, $7eNDO.defineMessage)({
    defaultMessage: "Name for the application link",
    id: "applinks.administration.ui.common.fields.display-name.placeholder"
});
const $753a107deadb6590$var$displayNameHelperMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Enter a unique name for the link, for example the name of your external app.",
    id: "applinks.administration.ui.common.fields.display-name.helper-message"
});
const $753a107deadb6590$var$displayUrlLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Display URL",
    id: "applinks.administration.ui.common.fields.display-url.label"
});
const $753a107deadb6590$var$displayUrlPlaceholder = (0, $7eNDO.defineMessage)({
    defaultMessage: "URL for the application link",
    id: "applinks.administration.ui.common.fields.display-url.placeholder"
});
const $753a107deadb6590$var$displayUrlHelperMessage = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
    defaultMessage: "This is the URL that we'll display to users in  {productName}.",
    id: "applinks.administration.ui.common.fields.display-url.helper-message"
});
const $753a107deadb6590$var$applicationUrlLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Application URL",
    id: "applinks.administration.ui.common.fields.application-url.label"
});
const $753a107deadb6590$var$applicationUrlPlaceholder = (0, $7eNDO.defineMessage)({
    defaultMessage: "Application URL for the application link",
    id: "applinks.administration.ui.common.fields.application-url.placeholder"
});
const $753a107deadb6590$var$applicationUrlHelperMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "This is the URL that {productName} will use to communicate with the external app.",
    id: "applinks.administration.ui.common.fields.application-url.helper-message"
});
const $753a107deadb6590$export$933c655d375093bb = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.clientId,
        label: formatMessage($753a107deadb6590$var$clientIdLabel),
        isDisabled: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.copyable-application-client-id",
            isReadOnly: true,
            type: "password",
            ...fieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8RhC5.default), {
                label: formatMessage($753a107deadb6590$var$clientIdLabel),
                value: props.clientId
            })
        }));
};
$753a107deadb6590$export$933c655d375093bb.displayName = "CopyableApplicationClientID";
const $753a107deadb6590$export$eeaa05b78b5f2773 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.clientSecret,
        label: formatMessage($753a107deadb6590$var$clientSecretLabel),
        isDisabled: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.copyable-application-client-secret",
            isReadOnly: true,
            type: "password",
            ...fieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8RhC5.default), {
                label: formatMessage($753a107deadb6590$var$clientSecretLabel),
                value: props.clientSecret
            })
        }));
};
$753a107deadb6590$export$eeaa05b78b5f2773.displayName = "CopyableApplicationClientSecret";
const $753a107deadb6590$export$e6ea1c895768a29c = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        label: formatMessage($753a107deadb6590$var$remoteApplicationScopesLabel),
        defaultValue: props.defaultSelected,
        validate: (chosenScopes)=>(0, $kjKdI.validateSupportedScopes)(chosenScopes ? chosenScopes.map((scope)=>scope.value) : [], props.supportedScopes),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioVrz.default), {
            testId: "applinks-administration.ui.common.fields.remote-application-scope-multi-select",
            placeholder: formatMessage($753a107deadb6590$var$remoteApplicationScopesPlaceholder),
            ...fieldProps,
            options: props.supportedScopes.map((scope)=>({
                    label: scope,
                    value: scope
                }))
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, error)));
};
$753a107deadb6590$export$e6ea1c895768a29c.displayName = "RemoteApplicationScopeMultiSelect";
const $753a107deadb6590$export$c8399aae3a726af3 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        label: formatMessage($753a107deadb6590$var$clientIdLabel),
        isRequired: props.isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.application-client-id",
            type: "password",
            placeholder: formatMessage($753a107deadb6590$var$clientIdLabel),
            ...fieldProps
        }));
};
$753a107deadb6590$export$c8399aae3a726af3.displayName = "ApplicationClientId";
const $753a107deadb6590$export$f137c4dc8b585189 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        label: formatMessage($753a107deadb6590$var$clientSecretLabel),
        isRequired: props.isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.application-client-secret",
            type: "password",
            placeholder: formatMessage($753a107deadb6590$var$clientSecretLabel),
            ...fieldProps
        }));
};
$753a107deadb6590$export$f137c4dc8b585189.displayName = "ApplicationClientSecret";
const $753a107deadb6590$export$e0ad63dba68d8cca = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.defaultRedirectUrl,
        label: formatMessage($753a107deadb6590$var$redirectUrlLabel),
        validate: (redirectUrl)=>(0, $kjKdI.validateURLField)(redirectUrl, true, true),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.redirect-url",
            placeholder: formatMessage($753a107deadb6590$var$redirectUrlLabel),
            ...fieldProps
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, error)));
};
$753a107deadb6590$export$e0ad63dba68d8cca.displayName = "RedirectUrl";
const $753a107deadb6590$export$101fbca3a406e1fd = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.defaultName,
        label: formatMessage($753a107deadb6590$var$displayNameLabel),
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.display-name",
            placeholder: formatMessage($753a107deadb6590$var$displayNamePlaceholder),
            ...fieldProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($753a107deadb6590$var$displayNameHelperMessage))));
};
$753a107deadb6590$export$101fbca3a406e1fd.displayName = "DisplayName";
const $753a107deadb6590$export$b07e64a5c70fbd11 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.defaultUrl,
        label: formatMessage($753a107deadb6590$var$displayUrlLabel),
        isRequired: true,
        validate: (defaultUrl)=>(0, $kjKdI.validateURLField)(defaultUrl, true, false)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.display-url",
            placeholder: formatMessage($753a107deadb6590$var$displayUrlPlaceholder),
            ...fieldProps
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($753a107deadb6590$var$displayUrlHelperMessage, {
            productName: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING)
        })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, error)));
};
$753a107deadb6590$export$b07e64a5c70fbd11.displayName = "DisplayUrl";
const $753a107deadb6590$export$5c4f409b6c929d7a = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.defaultUrl,
        label: formatMessage($753a107deadb6590$var$applicationUrlLabel),
        isDisabled: props.disabled,
        isRequired: !props.disabled,
        validate: (redirectUrl)=>(0, $kjKdI.validateURLField)(redirectUrl, true, true)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.application-url",
            placeholder: formatMessage($753a107deadb6590$var$applicationUrlPlaceholder),
            ...fieldProps
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($753a107deadb6590$var$applicationUrlHelperMessage, {
            productName: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING)
        })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, error)));
};
$753a107deadb6590$export$5c4f409b6c929d7a.displayName = "ApplicationUrl";

});
parcelRegister("hO3zy", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $47c6f25278256f63$export$915e9e7bd4f0f96d);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $77m19 = parcelRequire("77m19");

var $h6Szh = parcelRequire("h6Szh");
const $47c6f25278256f63$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $77m19.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $h6Szh.default), {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
$47c6f25278256f63$export$915e9e7bd4f0f96d.displayName = "ErrorMessage";

});
parcelRegister("77m19", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $f65efbba82082874$export$3c4232819458a302);

var $euxye = parcelRequire("euxye");
const $f65efbba82082874$export$3c4232819458a302 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("h6Szh", function(module, exports) {
$parcel$export(module.exports, "default", () => $6688ec9f1e2016e0$export$2e2bcd8739ae039);
/* message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ah9qo = parcelRequire("ah9qo");

var $8Qvei = parcelRequire("8Qvei");

var $bGCD7 = parcelRequire("bGCD7");
const $6688ec9f1e2016e0$var$messageStyles = null;
const $6688ec9f1e2016e0$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $6688ec9f1e2016e0$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $6688ec9f1e2016e0$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            $6688ec9f1e2016e0$var$iconWrapperStyles.root
        ]),
        children: children
    });
$6688ec9f1e2016e0$var$IconWrapper.displayName = "IconWrapper";
const $6688ec9f1e2016e0$var$messageIcons = {
    error: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
/**
 * __Message__
 *
 * A message component for displaying messages in a form.
 */ const $6688ec9f1e2016e0$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $6688ec9f1e2016e0$var$messageIcons[appearance];
    const messageRef = (0, $euxye.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $euxye.useState)(false);
    const { isWrapper: isWrapper } = (0, $euxye.useContext)((0, $bGCD7.MessageWrapperContext));
    (0, $euxye.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $4jQY2.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $6688ec9f1e2016e0$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $e79Pd.jsx)($6688ec9f1e2016e0$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
$6688ec9f1e2016e0$var$Message.displayName = "Message";
var $6688ec9f1e2016e0$export$2e2bcd8739ae039 = $6688ec9f1e2016e0$var$Message;

});
parcelRegister("bGCD7", function(module, exports) {
$parcel$export(module.exports, "MessageWrapperContext", () => $a6c189033ee3c435$export$579aef2c392a54d4);

var $euxye = parcelRequire("euxye");
const $a6c189033ee3c435$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $euxye.createContext)({
    isWrapper: false
});

});



parcelRegister("bEwPd", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $82314cebc02df24a$export$8fbe3c7d0ed2c683);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $77m19 = parcelRequire("77m19");

var $h6Szh = parcelRequire("h6Szh");
const $82314cebc02df24a$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $77m19.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $h6Szh.default), {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
$82314cebc02df24a$export$8fbe3c7d0ed2c683.displayName = "HelperMessage";

});

parcelRegister("1W2Av", function(module, exports) {
$parcel$export(module.exports, "default", () => $7aec763f8417c8d8$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $gUxVT = parcelRequire("gUxVT");

var $hO3zy = parcelRequire("hO3zy");

var $77m19 = parcelRequire("77m19");

var $edeJn = parcelRequire("edeJn");

var $bEwPd = parcelRequire("bEwPd");

var $iV868 = parcelRequire("iV868");

var $ezcIL = parcelRequire("ezcIL");

var $ej7cp = parcelRequire("ej7cp");

var $dIqcw = parcelRequire("dIqcw");

var $fIwNV = parcelRequire("fIwNV");
const $7aec763f8417c8d8$var$fieldWrapperStyles = null;
function $7aec763f8417c8d8$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7aec763f8417c8d8$var$isFunction(x) {
    return typeof x === 'function';
}
function $7aec763f8417c8d8$var$usePreviousRef(current) {
    const ref = (0, $euxye.useRef)(current);
    // will be updated on the next render
    (0, $euxye.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7aec763f8417c8d8$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7aec763f8417c8d8$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $euxye.useContext)((0, $edeJn.FormContext));
    const isDisabled = (0, $euxye.useContext)((0, $iV868.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7aec763f8417c8d8$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7aec763f8417c8d8$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7aec763f8417c8d8$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $euxye.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7aec763f8417c8d8$var$usePreviousRef(state);
    (0, $euxye.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7aec763f8417c8d8$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7aec763f8417c8d8$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $gUxVT.useId)();
    const fieldId = (0, $euxye.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $4jQY2.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ezcIL.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dIqcw.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $77m19.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ej7cp.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bEwPd.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hO3zy.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fIwNV.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}
$7aec763f8417c8d8$export$2e2bcd8739ae039.displayName = "Field";

});
parcelRegister("ezcIL", function(module, exports) {
$parcel$export(module.exports, "Label", () => $dc9a4c530423281d$export$b04be29aa201d4f5);
/* label.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $dc9a4c530423281d$var$fieldsetLabelStyles = null;
const $dc9a4c530423281d$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
$dc9a4c530423281d$export$b04be29aa201d4f5.displayName = "Label";

});

parcelRegister("ej7cp", function(module, exports) {
$parcel$export(module.exports, "MessageWrapper", () => $2982e572658bc45a$export$ec445f12f63100a5);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $bGCD7 = parcelRequire("bGCD7");
const $2982e572658bc45a$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bGCD7.MessageWrapperContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};
$2982e572658bc45a$export$ec445f12f63100a5.displayName = "MessageWrapper";

});

parcelRegister("dIqcw", function(module, exports) {
$parcel$export(module.exports, "default", () => $06ba5f63b58a65ea$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $06ba5f63b58a65ea$var$requiredIndicatorStyles = null;
function $06ba5f63b58a65ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $4jQY2.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}
$06ba5f63b58a65ea$export$2e2bcd8739ae039.displayName = "RequiredAsterisk";

});

parcelRegister("fIwNV", function(module, exports) {
$parcel$export(module.exports, "ValidMessage", () => $c589a24263be832e$export$5505afb209a532c8);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $77m19 = parcelRequire("77m19");

var $h6Szh = parcelRequire("h6Szh");
const $c589a24263be832e$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $77m19.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $h6Szh.default), {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
$c589a24263be832e$export$5505afb209a532c8.displayName = "ValidMessage";

});


parcelRegister("ioVrz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fd4b8baed5098b7$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3AZnn = parcelRequire("3AZnn");

var $baIdH = parcelRequire("baIdH");
const $3fd4b8baed5098b7$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $euxye.useMemo)(()=>({
            ...components,
            Option: (0, $3AZnn.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $baIdH.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
$3fd4b8baed5098b7$var$CheckboxSelectInternal.displayName = "CheckboxSelectInternal";
const $3fd4b8baed5098b7$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo($3fd4b8baed5098b7$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3fd4b8baed5098b7$export$2e2bcd8739ae039 = $3fd4b8baed5098b7$var$CheckboxSelect;

});
parcelRegister("3AZnn", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $34fd87ec406bdfca$export$d40cc97ecda916f9);
/* checkbox-option.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $kFp4L = parcelRequire("kFp4L");
const $34fd87ec406bdfca$var$svgStyles = null;
const $34fd87ec406bdfca$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $4jQY2.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
$34fd87ec406bdfca$var$CheckboxIcon.displayName = "CheckboxIcon";
const $34fd87ec406bdfca$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $kFp4L.ControlOption), {
        Icon: $34fd87ec406bdfca$var$CheckboxIcon,
        ...props
    });
$34fd87ec406bdfca$export$d40cc97ecda916f9.displayName = "CheckboxOption";

});
parcelRegister("kFp4L", function(module, exports) {
$parcel$export(module.exports, "ControlOption", () => $cea4c71a2e68be4f$export$e41f7c07e51665da);
/* control-option.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");
const $cea4c71a2e68be4f$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e126o",
    disabled: "_syaz1gmx",
    motion: "_v5641x7n _1gglpoum"
};
// the primary color represents the outer or background element
const $cea4c71a2e68be4f$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
const $cea4c71a2e68be4f$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $cea4c71a2e68be4f$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $cea4c71a2e68be4f$var$baseIconStyles = null;
const $cea4c71a2e68be4f$var$baseOptionStyles = null;
const $cea4c71a2e68be4f$export$e41f7c07e51665da = (props)=>{
    const [isActive, setIsActive] = (0, $euxye.useState)(false);
    const onMouseDown = (0, $euxye.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $euxye.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $euxye.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            $cea4c71a2e68be4f$var$optionStyles.default,
            !isDisabled && (0, $egspI.fg)('platform-dst-motion-uplift-list-item') && $cea4c71a2e68be4f$var$optionStyles.motion,
            isFocused && $cea4c71a2e68be4f$var$optionStyles.focused,
            isDisabled && $cea4c71a2e68be4f$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $cea4c71a2e68be4f$var$iconStyles.inherit : $cea4c71a2e68be4f$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                    label: "",
                    primaryColor: $cea4c71a2e68be4f$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $cea4c71a2e68be4f$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
$cea4c71a2e68be4f$export$e41f7c07e51665da.displayName = "ControlOption";

});


parcelRegister("baIdH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f90e0e93b375b93$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $flpE4 = parcelRequire("flpE4");
var $kY2zM = parcelRequire("kY2zM");
var $kTviw = parcelRequire("kTviw");

var $cpyLF = parcelRequire("cpyLF");
const $0f90e0e93b375b93$var$packageName = "platform-pkg";
const $0f90e0e93b375b93$var$packageVersion = "0.0.0-use.local";
const $0f90e0e93b375b93$var$createAndFireEventOnAtlaskit = (0, $flpE4.default)('atlaskit');
const $0f90e0e93b375b93$var$Select = (0, $kY2zM.default)({
    componentName: 'select',
    packageName: $0f90e0e93b375b93$var$packageName,
    packageVersion: $0f90e0e93b375b93$var$packageVersion
})((0, $kTviw.default)({
    onChange: $0f90e0e93b375b93$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $0f90e0e93b375b93$var$packageName,
            packageVersion: $0f90e0e93b375b93$var$packageVersion
        }
    })
})((0, $cpyLF.SelectWithoutAnalytics)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0f90e0e93b375b93$export$2e2bcd8739ae039 = $0f90e0e93b375b93$var$Select;

});
parcelRegister("cpyLF", function(module, exports) {
$parcel$export(module.exports, "SelectWithoutAnalytics", () => $7ff48a6d83abaad9$export$d1de3b251ccaa8a3);

var $36lJ8 = parcelRequire("36lJ8");

var $c0vzW = parcelRequire("c0vzW");
const $7ff48a6d83abaad9$export$d1de3b251ccaa8a3 = (0, $c0vzW.default)((0, $36lJ8.default));

});
parcelRegister("36lJ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $03a7fd0dcadaa381$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $e2muV = parcelRequire("e2muV");

var $8k7pc = parcelRequire("8k7pc");

var $8LfFe = parcelRequire("8LfFe");
const $03a7fd0dcadaa381$var$AsyncSelect = /*#__PURE__*/ (0, $euxye.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $8k7pc.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $8LfFe.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e2muV.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$03a7fd0dcadaa381$export$2e2bcd8739ae039 = $03a7fd0dcadaa381$var$AsyncSelect;

});
parcelRegister("e2muV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6609dcf7cd81add0$export$2e2bcd8739ae039);
/* select.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $glbdM = parcelRequire("glbdM");

var $j4xZq = parcelRequire("j4xZq");

var $bWvjc = parcelRequire("bWvjc");

var $2oRWW = parcelRequire("2oRWW");

var $egspI = parcelRequire("egspI");

var $25GTd = parcelRequire("25GTd");
var $eRXjC = parcelRequire("eRXjC");
var $bk0jE = parcelRequire("bk0jE");
var $crta0 = parcelRequire("crta0");

var $3xX0E = parcelRequire("3xX0E");

var $12siX = parcelRequire("12siX");

var $5sF5y = parcelRequire("5sF5y");

var $jgG0E = parcelRequire("jgG0E");

var $87lhX = parcelRequire("87lhX");

var $hbudu = parcelRequire("hbudu");

var $369bp = parcelRequire("369bp");

var $8fbe0 = parcelRequire("8fbe0");

var $23Cor = parcelRequire("23Cor");

var $FKmXz = parcelRequire("FKmXz");

var $dxId9 = parcelRequire("dxId9");

var $BytXA = parcelRequire("BytXA");

var $8Sn9q = parcelRequire("8Sn9q");

var $6q2Ac = parcelRequire("6q2Ac");

var $2dGma = parcelRequire("2dGma");

var $hjDA7 = parcelRequire("hjDA7");

var $dC0e5 = parcelRequire("dC0e5");
const $6609dcf7cd81add0$var$noop = (0, $2oRWW.default);
function $6609dcf7cd81add0$var$notNullish(item) {
    return item != null;
}
function $6609dcf7cd81add0$var$scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $6q2Ac.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $6q2Ac.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $6609dcf7cd81add0$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
function $6609dcf7cd81add0$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ const $6609dcf7cd81add0$var$filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const $6609dcf7cd81add0$var$elemBeforeCSS = null;
const $6609dcf7cd81add0$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $6609dcf7cd81add0$var$isTouchCapable(),
    captureMenuScroll: !$6609dcf7cd81add0$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $87lhX.createFilter)(),
    formatGroupLabel: (0, $25GTd.formatGroupLabel),
    getOptionLabel: (0, $eRXjC.getOptionLabel),
    getOptionValue: (0, $bk0jE.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $crta0.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$6609dcf7cd81add0$var$isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $6609dcf7cd81add0$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $6609dcf7cd81add0$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $6609dcf7cd81add0$var$isOptionSelected(props, option, selectValue);
    const label = $6609dcf7cd81add0$var$getOptionLabel(props, option);
    const value = $6609dcf7cd81add0$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $6609dcf7cd81add0$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$6609dcf7cd81add0$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$6609dcf7cd81add0$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $6609dcf7cd81add0$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $6609dcf7cd81add0$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($6609dcf7cd81add0$var$notNullish);
}
function $6609dcf7cd81add0$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $6609dcf7cd81add0$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $6609dcf7cd81add0$var$buildFocusableOptions(props, selectValue) {
    return $6609dcf7cd81add0$var$buildFocusableOptionsFromCategorizedOptions($6609dcf7cd81add0$var$buildCategorizedOptions(props, selectValue));
}
function $6609dcf7cd81add0$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$6609dcf7cd81add0$var$shouldHideSelectedOptions(props) || !isSelected) && $6609dcf7cd81add0$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $6609dcf7cd81add0$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $6609dcf7cd81add0$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $6609dcf7cd81add0$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $6609dcf7cd81add0$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $6609dcf7cd81add0$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $6609dcf7cd81add0$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $6609dcf7cd81add0$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $6609dcf7cd81add0$var$getOptionValue(props, option);
    return selectValue.some((i)=>$6609dcf7cd81add0$var$getOptionValue(props, i) === candidate);
}
function $6609dcf7cd81add0$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $6609dcf7cd81add0$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $6609dcf7cd81add0$var$instanceId = 1;
class $6609dcf7cd81add0$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    static{
        this.defaultProps = $6609dcf7cd81add0$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Cleanup for a pending document `pointerup` listener registered by
        // `openMenuAfterPointerUp`. See that method for the full rationale.
        this.deferredOpenMenuCleanup = null, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
            // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (this.state.controlElement !== ref && (0, $egspI.fg)('platform-dst-top-layer')) this.setState({
                controlElement: ref
            });
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $FKmXz.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $FKmXz.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $hjDA7.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $hjDA7.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $dC0e5.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $dC0e5.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $dC0e5.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $6609dcf7cd81add0$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $6609dcf7cd81add0$var$buildFocusableOptionsWithIds($6609dcf7cd81add0$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $hbudu.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $6609dcf7cd81add0$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $6609dcf7cd81add0$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return $6609dcf7cd81add0$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $3xX0E.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$6609dcf7cd81add0$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$6609dcf7cd81add0$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenuAfterPointerUp('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenuAfterPointerUp('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $8fbe0.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer past
                // pointerup. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (this.openAfterFocus) this.openMenuAfterPointerUp('first');
                else this.openMenu('first');
            }
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $egspI.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $6609dcf7cd81add0$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$6609dcf7cd81add0$var$instanceId);
        this.state.selectValue = (0, $369bp.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $6609dcf7cd81add0$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $369bp.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $6609dcf7cd81add0$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $6609dcf7cd81add0$var$buildFocusableOptionsWithIds($6609dcf7cd81add0$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $6609dcf7cd81add0$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $6609dcf7cd81add0$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $6609dcf7cd81add0$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $dC0e5.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $6609dcf7cd81add0$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            $6609dcf7cd81add0$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        this.cancelDeferredOpenMenu();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    /**
   * Whether to defer the menu open past the in-flight pointer gesture.
   * Any renderer that drives a `popover="auto"` element must, otherwise
   * the browser's light-dismiss runs on the matching `pointerup` and
   * closes the menu immediately. Today only the top-layer path needs it.
   */ shouldDeferOpenPastPointerUp() {
        return (0, $egspI.fg)('platform-dst-top-layer');
    }
    /**
   * Open the menu after the current pointer gesture, instead of
   * synchronously inside `mousedown`.
   *
   * On the top-layer path the menu is a `popover="auto"` element. The
   * browser captures the pointerdown target before the popover exists, so
   * opening synchronously gets immediately light-dismissed on pointerup
   * (and the matching `beforetoggle: closed` is not cancellable). Deferring
   * to the next `pointerup` avoids that.
   *
   * We listen for `pointerup` rather than `click` because `pointerup` is
   * the exact event the browser uses for light-dismiss (earliest safe
   * moment), always fires (`click` requires same down/up target), is hard
   * to lose to upstream `stopPropagation`, and is uniform across input
   * types. Off the top-layer path we open synchronously as before.
   */ openMenuAfterPointerUp(focusOption) {
        if (!this.shouldDeferOpenPastPointerUp()) {
            this.openMenu(focusOption);
            return;
        }
        // A second pointerdown can land before the queued pointerup if the
        // user releases and re-clicks very quickly. Replace any pending
        // deferred open with the latest one so we never stack listeners.
        this.cancelDeferredOpenMenu();
        const handlePointerUp = ()=>{
            this.deferredOpenMenuCleanup = null;
            this.openMenu(focusOption);
        };
        this.deferredOpenMenuCleanup = (0, $glbdM.bind)(document, {
            type: 'pointerup',
            listener: handlePointerUp,
            options: {
                capture: true,
                once: true
            }
        });
    }
    cancelDeferredOpenMenu() {
        if (this.deferredOpenMenuCleanup) {
            this.deferredOpenMenuCleanup();
            this.deferredOpenMenuCleanup = null;
        }
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $bWvjc.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $6609dcf7cd81add0$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $6609dcf7cd81add0$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $6609dcf7cd81add0$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !this.props.components?.Option && (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                    className: (0, $4jQY2.default)([
                        "_zulpu2gc _1e0c1txw _4cvr1h6o"
                    ]),
                    children: [
                        elemBefore,
                        /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                            children: label
                        })
                    ]
                });
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const isDisabledA11yFixEnabled = (0, $egspI.fg)('platform_dst_select_disabled_a11y_fix');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $egspI.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && !(0, $egspI.fg)('select_issearchable_aria-readonly_fix') && {
                'aria-readonly': true
            },
            // Using aria-disabled so the element remains in the a11y tree.
            ...isDisabledA11yFixEnabled && {
                'aria-disabled': isDisabled || undefined
            },
            ...this.calculateDescription()
        };
        const effectiveTabIndex = isDisabledA11yFixEnabled && isDisabled ? -1 : tabIndex;
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $12siX.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: $6609dcf7cd81add0$var$noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: effectiveTabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $e79Pd.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: effectiveTabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $euxye.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $euxye.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $e79Pd.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value'),
                // Hide from AT so the value is only announced via aria-describedby on the combobox.
                ...isDisabled && (0, $egspI.fg)('platform_dst_select_disabled_a11y_fix') && {
                    'aria-hidden': true
                }
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            // Always hidden: DropdownIndicator hoists aria-hidden onto consumer-supplied
            // children only, keeping the voice-control button visible to AT.
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $euxye.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $euxye.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $e79Pd.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $e79Pd.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jgG0E.default), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $e79Pd.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sn9q.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $e79Pd.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $bWvjc.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // On the top-layer path the menu always portals (into the top layer)
        // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
        // flag we keep the legacy "portal only when needed" behaviour.
        const shouldPortal = (0, $egspI.fg)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
        if (!shouldPortal) return menuElement;
        // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
        // when the anchor attaches; legacy path keeps the direct ref read.
        const controlElementForPortal = (0, $egspI.fg)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
        const menuPortal = /*#__PURE__*/ (0, $e79Pd.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: controlElementForPortal,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        });
        // The Provider plumbs the close signal to MenuPortalTopLayer; not
        // needed on the legacy path.
        if (!(0, $egspI.fg)('platform-dst-top-layer')) return menuPortal;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $23Cor.MenuPortalCloseContext).Provider, {
            value: this.handleOpenLayerObserverCloseSignal,
            children: menuPortal
        });
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $BytXA.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5sF5y.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2dGma.SelectGetStylesContext).Provider, {
            value: this.getStyles,
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)(SelectContainer, {
                ...commonProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown,
                    ...testId && {
                        'data-testid': testId && `${testId}-select--container`
                    }
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                children: [
                    this.renderLiveRegion(),
                    commonProps.isMulti && this.renderMultiselectMessage(),
                    /*#__PURE__*/ (0, $e79Pd.jsxs)(Control, {
                        ...commonProps,
                        innerRef: this.getControlRef,
                        innerProps: {
                            onMouseDown: this.onControlMouseDown,
                            onTouchEnd: this.onControlTouchEnd,
                            ...testId && {
                                'data-testid': `${testId}-select--control`
                            }
                        },
                        appearance: appearance,
                        isInvalid: isInvalid,
                        isDisabled: isDisabled,
                        isFocused: isFocused,
                        menuIsOpen: menuIsOpen,
                        isCompact: isCompact,
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsxs)(ValueContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                isCompact: isCompact,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--value-container`
                                    },
                                    ...commonProps.isMulti && commonProps.hasValue && !(0, $j4xZq.isAppleDevice)() && {
                                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                        // DST Accessibility.
                                        role: 'application'
                                    }
                                },
                                children: [
                                    this.renderPlaceholderOrValue(),
                                    this.renderInput()
                                ]
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsxs)(IndicatorsContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--indicators-container`
                                    }
                                },
                                children: [
                                    this.renderClearIndicator(),
                                    this.renderLoadingIndicator(),
                                    this.renderDropdownIndicator()
                                ]
                            })
                        ]
                    }),
                    this.renderMenu(),
                    this.renderFormField(),
                    !(0, $egspI.fg)('platform-dst-top-layer') && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dxId9.NotifyOpenLayerObserver), {
                        isOpen: this.props.menuIsOpen,
                        onClose: this.handleOpenLayerObserverCloseSignal
                    })
                ]
            })
        });
    }
}
$6609dcf7cd81add0$export$2e2bcd8739ae039.displayName = "Select";

});
parcelRegister("j4xZq", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $9c1c33c2f4cc9f1c$export$e1865c3bedcd822b);
function $9c1c33c2f4cc9f1c$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $9c1c33c2f4cc9f1c$var$isIPhone() {
    return $9c1c33c2f4cc9f1c$var$testPlatform(/^iPhone/i);
}
function $9c1c33c2f4cc9f1c$var$isIPad() {
    return $9c1c33c2f4cc9f1c$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $9c1c33c2f4cc9f1c$var$isMac() && navigator.maxTouchPoints > 1;
}
function $9c1c33c2f4cc9f1c$var$isMac() {
    return $9c1c33c2f4cc9f1c$var$testPlatform(/^Mac/i);
}
function $9c1c33c2f4cc9f1c$var$isIOS() {
    return $9c1c33c2f4cc9f1c$var$isIPhone() || $9c1c33c2f4cc9f1c$var$isIPad();
}
function $9c1c33c2f4cc9f1c$export$e1865c3bedcd822b() {
    return $9c1c33c2f4cc9f1c$var$isMac() || $9c1c33c2f4cc9f1c$var$isIOS();
}

});

parcelRegister("25GTd", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", () => $5c027cb24e24aaf7$export$f4da216a6ca54656);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $5c027cb24e24aaf7$export$f4da216a6ca54656 = (group)=>group.label;

});

parcelRegister("eRXjC", function(module, exports) {
$parcel$export(module.exports, "getOptionLabel", () => $d41fb02be616e05e$export$dac6ace3020563ca);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $d41fb02be616e05e$export$dac6ace3020563ca = (option)=>option.label;

});

parcelRegister("bk0jE", function(module, exports) {
$parcel$export(module.exports, "getOptionValue", () => $a2a8d322af395130$export$40be908210c5a79c);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $a2a8d322af395130$export$40be908210c5a79c = (option)=>option.value;

});

parcelRegister("crta0", function(module, exports) {
$parcel$export(module.exports, "isOptionDisabled", () => $af6c1be5081bf754$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $af6c1be5081bf754$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("3xX0E", function(module, exports) {
$parcel$export(module.exports, "components", () => $c290426c61766514$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $c290426c61766514$export$71abc632aa29e6fe);

var $i9ANO = parcelRequire("i9ANO");

var $i9Bbv = parcelRequire("i9Bbv");

var $2lBHp = parcelRequire("2lBHp");

var $51GPB = parcelRequire("51GPB");

var $ciPuz = parcelRequire("ciPuz");

var $5I9wI = parcelRequire("5I9wI");

var $hiRDE = parcelRequire("hiRDE");

var $5QfBS = parcelRequire("5QfBS");

var $6cU1U = parcelRequire("6cU1U");

var $3sanG = parcelRequire("3sanG");

var $aLA2f = parcelRequire("aLA2f");

var $3af9u = parcelRequire("3af9u");

var $9tUjk = parcelRequire("9tUjk");

var $7kJy5 = parcelRequire("7kJy5");

var $d1Wul = parcelRequire("d1Wul");

var $jvVlo = parcelRequire("jvVlo");

var $6PGkv = parcelRequire("6PGkv");

var $9FFa6 = parcelRequire("9FFa6");

var $hvkNV = parcelRequire("hvkNV");

var $gaXx9 = parcelRequire("gaXx9");

var $03ZGj = parcelRequire("03ZGj");

var $80vrn = parcelRequire("80vrn");
const $c290426c61766514$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $5QfBS.ClearIndicator),
    Control: (0, $ciPuz.default),
    DropdownIndicator: (0, $6cU1U.DropdownIndicator),
    Group: (0, $5I9wI.default),
    GroupHeading: (0, $hiRDE.GroupHeading),
    IndicatorsContainer: (0, $i9ANO.IndicatorsContainer),
    Input: (0, $aLA2f.default),
    LoadingIndicator: (0, $3sanG.LoadingIndicator),
    Menu: (0, $3af9u.default),
    MenuList: (0, $9tUjk.MenuList),
    MenuPortal: (0, $jvVlo.MenuPortal),
    LoadingMessage: (0, $7kJy5.LoadingMessage),
    NoOptionsMessage: (0, $d1Wul.NoOptionsMessage),
    MultiValue: (0, $6PGkv.default),
    MultiValueContainer: (0, $i9Bbv.MultiValueContainer),
    MultiValueLabel: (0, $9FFa6.MultiValueLabel),
    MultiValueRemove: (0, $hvkNV.MultiValueRemove),
    Option: (0, $gaXx9.default),
    Placeholder: (0, $03ZGj.default),
    SelectContainer: (0, $2lBHp.SelectContainer),
    SingleValue: (0, $80vrn.default),
    ValueContainer: (0, $51GPB.ValueContainer)
};
const $c290426c61766514$export$71abc632aa29e6fe = (props)=>({
        ...$c290426c61766514$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("i9ANO", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $59f7516fd4ecc183$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $59f7516fd4ecc183$var$indicatorContainerStyles = null;
const $59f7516fd4ecc183$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $9S1b6.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};
$59f7516fd4ecc183$export$d0ffd7e649cab6f.displayName = "IndicatorsContainer";

});
parcelRegister("fnGzU", function(module, exports) {
$parcel$export(module.exports, "getStyleProps", () => $db45b67db8b2d20c$export$26417cabd806a658);
const $db45b67db8b2d20c$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};

});


parcelRegister("i9Bbv", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $b90e13612fd49799$export$cf9cf2a30a59265c);
/* multi-value-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");
const $b90e13612fd49799$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up53acm _1xdnnqa1"
};
const $b90e13612fd49799$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $b90e13612fd49799$var$multiValueStyles.root,
            isDisabled && $b90e13612fd49799$var$multiValueStyles.disabled,
            isFocused && $b90e13612fd49799$var$multiValueStyles.focused,
            (0, $9S1b6.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};
$b90e13612fd49799$export$cf9cf2a30a59265c.displayName = "MultiValueContainer";

});

parcelRegister("2lBHp", function(module, exports) {
$parcel$export(module.exports, "SelectContainer", () => $1ef5ecd52502323d$export$446eebadefe1123b);
/* select-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $1ef5ecd52502323d$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
const $1ef5ecd52502323d$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $fnGzU.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $1ef5ecd52502323d$var$containerStyles.default,
            isRtl && $1ef5ecd52502323d$var$containerStyles.rtl,
            isDisabled && $1ef5ecd52502323d$var$containerStyles.disabled,
            (0, $9S1b6.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
$1ef5ecd52502323d$export$446eebadefe1123b.displayName = "SelectContainer";

});

parcelRegister("51GPB", function(module, exports) {
$parcel$export(module.exports, "ValueContainer", () => $2418c4bb85caea65$export$4dc9f58ad9a1a000);
/* value-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");
const $2418c4bb85caea65$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
const $2418c4bb85caea65$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const ffTagUplifts = (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const tagUpliftMultiVertical = ffTagUplifts && isMulti;
    const tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $2418c4bb85caea65$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $2418c4bb85caea65$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $2418c4bb85caea65$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $2418c4bb85caea65$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $2418c4bb85caea65$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $2418c4bb85caea65$var$valueContainerStyles.flex,
            tagUpliftChipRow && $2418c4bb85caea65$var$valueContainerStyles.flexWithGap,
            (0, $9S1b6.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
$2418c4bb85caea65$export$4dc9f58ad9a1a000.displayName = "ValueContainer";

});

parcelRegister("ciPuz", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2fc32bd72c2d779$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");
const $e2fc32bd72c2d779$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123b1h4p _d0altlke _irr3l4ek _1oglgxqn",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $e2fc32bd72c2d779$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $e2fc32bd72c2d779$var$styles.default,
            (0, $egspI.fg)('platform-dst-shape-theme-default') && $e2fc32bd72c2d779$var$styles.defaultT26Shape,
            isDisabled && $e2fc32bd72c2d779$var$styles.disabled,
            isInvalid && $e2fc32bd72c2d779$var$styles.invalid,
            isCompact && $e2fc32bd72c2d779$var$styles.compact,
            appearance === 'subtle' && $e2fc32bd72c2d779$var$styles.subtle,
            appearance === 'subtle' && isFocused && $e2fc32bd72c2d779$var$styles.subtleFocused,
            isFocused && $e2fc32bd72c2d779$var$styles.focused,
            appearance === 'none' && $e2fc32bd72c2d779$var$styles.none,
            (0, $9S1b6.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": (0, $egspI.fg)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined,
        children: children
    });
};
$e2fc32bd72c2d779$var$Control.displayName = "Control";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e2fc32bd72c2d779$export$2e2bcd8739ae039 = $e2fc32bd72c2d779$var$Control;

});

parcelRegister("5I9wI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cd439e1a7d4e0e3$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $7cd439e1a7d4e0e3$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
const $7cd439e1a7d4e0e3$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $7cd439e1a7d4e0e3$var$styles.root,
            (0, $9S1b6.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $e79Pd.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                children: children
            })
        ]
    });
};
$7cd439e1a7d4e0e3$var$Group.displayName = "Group";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7cd439e1a7d4e0e3$export$2e2bcd8739ae039 = $7cd439e1a7d4e0e3$var$Group;

});

parcelRegister("hiRDE", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $a6c6d115389052f5$export$85c8b41a3cd87edc);
/* group-heading.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");

var $vndoX = parcelRequire("vndoX");
const $a6c6d115389052f5$var$headingStyles = null;
const $a6c6d115389052f5$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $vndoX.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $9S1b6.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
$a6c6d115389052f5$export$85c8b41a3cd87edc.displayName = "GroupHeading";

});
parcelRegister("vndoX", function(module, exports) {
$parcel$export(module.exports, "cleanCommonProps", () => $accead48f11d2927$export$8e9fd4287627890c);
// Clean Common Props
// ==============================
const $accead48f11d2927$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};

});


parcelRegister("5QfBS", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $0da1934925ba673e$export$ecf9cf59142dd54a);
/* clear-indicator.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $9qT28 = parcelRequire("9qT28");

var $6mEZn = parcelRequire("6mEZn");

var $fnGzU = parcelRequire("fnGzU");
const $0da1934925ba673e$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
const $0da1934925ba673e$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
const $0da1934925ba673e$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $0da1934925ba673e$var$clearIndicatorStyles.default,
            isCompact && $0da1934925ba673e$var$clearIndicatorStyles.compact,
            (0, $9S1b6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
            xcss: $0da1934925ba673e$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
};
$0da1934925ba673e$export$ecf9cf59142dd54a.displayName = "ClearIndicator";

});

parcelRegister("6cU1U", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $f114c35a40074cce$export$ec98719d3db7f2e4);
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $ld25x = parcelRequire("ld25x");

var $egspI = parcelRequire("egspI");

var $defJG = parcelRequire("defJG");
var $6mEZn = parcelRequire("6mEZn");

var $fnGzU = parcelRequire("fnGzU");
const $f114c35a40074cce$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
const $f114c35a40074cce$var$voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk18uv _1e0c1txw _4cvr1h6o"
};
const $f114c35a40074cce$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
const $f114c35a40074cce$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps = {}, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    const { 'aria-hidden': ariaHidden, ...restInnerProps } = innerProps;
    const isVoiceControlAccessible = (0, $egspI.fg)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    const wrapperTestId = restInnerProps['data-testid'] ? `${restInnerProps['data-testid']}-children` : undefined;
    const voiceControlAccessibleIndicator = children ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId,
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $f114c35a40074cce$var$voiceControlPressableStyles.root,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
            as: "span",
            xcss: $f114c35a40074cce$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $f114c35a40074cce$var$dropdownStyles.default,
            isDisabled && $f114c35a40074cce$var$dropdownStyles.disabled,
            isCompact && $f114c35a40074cce$var$dropdownStyles.compact,
            (0, $9S1b6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...restInnerProps,
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden,
        children: isVoiceControlAccessible ? voiceControlAccessibleIndicator : children ?? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
            as: "span",
            xcss: $f114c35a40074cce$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
};
$f114c35a40074cce$export$ec98719d3db7f2e4.displayName = "DropdownIndicator";

});

parcelRegister("3sanG", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $3878b2fe38501b4a$export$7c20be4c1d342248);
/* loading-indicator.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $abhF2 = parcelRequire("abhF2");

var $fnGzU = parcelRequire("fnGzU");
const $3878b2fe38501b4a$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
const $3878b2fe38501b4a$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $3878b2fe38501b4a$var$loadingIndicatorStyles.default,
            isCompact && $3878b2fe38501b4a$var$loadingIndicatorStyles.compact,
            (0, $9S1b6.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
            size: "small"
        })
    });
};
$3878b2fe38501b4a$export$7c20be4c1d342248.displayName = "LoadingIndicator";

});

parcelRegister("aLA2f", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfe319ebdcdf95aa$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");

var $vndoX = parcelRequire("vndoX");
const $cfe319ebdcdf95aa$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $cfe319ebdcdf95aa$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $cfe319ebdcdf95aa$var$nativeInputStylesOld = null;
const $cfe319ebdcdf95aa$var$nativeInputStyles = null;
const $cfe319ebdcdf95aa$var$hidden = null;
const $cfe319ebdcdf95aa$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss, isMulti: isMulti } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $vndoX.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'input', {
        'input-container': true
    });
    const ffTagUplifts = (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $egspI.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $cfe319ebdcdf95aa$var$inputStyles.root,
            isMulti && ffTagUplifts && $cfe319ebdcdf95aa$var$inputStyles.labellingFFStyles,
            isDisabled && $cfe319ebdcdf95aa$var$inputStyles.disabled,
            (0, $9S1b6.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $4jQY2.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $cfe319ebdcdf95aa$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $cfe319ebdcdf95aa$var$inputStylesOld.labellingFFStyles,
            isDisabled && $cfe319ebdcdf95aa$var$inputStylesOld.disabled,
            (0, $9S1b6.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $4jQY2.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
$cfe319ebdcdf95aa$var$Input.displayName = "Input";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cfe319ebdcdf95aa$export$2e2bcd8739ae039 = $cfe319ebdcdf95aa$var$Input;

});

parcelRegister("3af9u", function(module, exports) {
$parcel$export(module.exports, "default", () => $69bc1725a5de5040$export$2e2bcd8739ae039);
/* menu.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");
const $69bc1725a5de5040$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
const $69bc1725a5de5040$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $69bc1725a5de5040$var$menuStyles.root,
            $69bc1725a5de5040$var$menuStyles[placement],
            (0, $egspI.fg)('platform-dst-shape-theme-default') && $69bc1725a5de5040$var$menuStyles.rootT26Shape,
            (0, $9S1b6.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
$69bc1725a5de5040$var$Menu.displayName = "Menu";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69bc1725a5de5040$export$2e2bcd8739ae039 = $69bc1725a5de5040$var$Menu;

});

parcelRegister("9tUjk", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $d193525ad3b791cf$export$d4c4e98c5044dc8);
/* menu-list.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $d193525ad3b791cf$var$menuListStyles = null;
const $d193525ad3b791cf$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $9S1b6.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
$d193525ad3b791cf$export$d4c4e98c5044dc8.displayName = "MenuList";

});

parcelRegister("7kJy5", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $1a42f929bda241bd$export$e928a71d039d3102);
/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $8Sdzy = parcelRequire("8Sdzy");

var $fnGzU = parcelRequire("fnGzU");
const $1a42f929bda241bd$var$noticeStyles = null;
const $1a42f929bda241bd$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $9S1b6.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
$1a42f929bda241bd$export$e928a71d039d3102.displayName = "LoadingMessage";

});

parcelRegister("d1Wul", function(module, exports) {
$parcel$export(module.exports, "NoOptionsMessage", () => $ee2d14b752c2adcb$export$d58b72b7d3c4072c);
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $8Sdzy = parcelRequire("8Sdzy");

var $fnGzU = parcelRequire("fnGzU");
const $ee2d14b752c2adcb$var$noticeStyles = null;
const $ee2d14b752c2adcb$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $9S1b6.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
$ee2d14b752c2adcb$export$d58b72b7d3c4072c.displayName = "NoOptionsMessage";

});

parcelRegister("jvVlo", function(module, exports) {
$parcel$export(module.exports, "MenuPortal", () => $ffd0be9055a7fa14$export$793392f970497feb);
/* menu-portal.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $6XNU4 = parcelRequire("6XNU4");

var $85XPu = parcelRequire("85XPu");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");

var $25rLP = parcelRequire("25rLP");

var $A7F3J = parcelRequire("A7F3J");
function $ffd0be9055a7fa14$var$getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const $ffd0be9055a7fa14$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $ffd0be9055a7fa14$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $ffd0be9055a7fa14$var$MenuPortalLegacy(props) {
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $euxye.useRef)(null);
    const cleanupRef = (0, $euxye.useRef)(null);
    const [placement, setPortalPlacement] = (0, $euxye.useState)($ffd0be9055a7fa14$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $euxye.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $euxye.useState)(null);
    const updateComputedPosition = (0, $euxye.useCallback)(()=>{
        if (!controlElement) return;
        const rect = $ffd0be9055a7fa14$var$getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $euxye.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6XNU4.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $euxye.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $ffd0be9055a7fa14$var$menuPortalStyles.root,
            (0, $9S1b6.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $25rLP.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $85XPu.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
}
$ffd0be9055a7fa14$var$MenuPortalLegacy.displayName = "MenuPortalLegacy";
const $ffd0be9055a7fa14$export$793392f970497feb = (props)=>{
    if ((0, $egspI.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $A7F3J.MenuPortalTopLayer), {
        ...props
    });
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $e79Pd.jsx)($ffd0be9055a7fa14$var$MenuPortalLegacy, {
        ...props
    });
};
$ffd0be9055a7fa14$export$793392f970497feb.displayName = "MenuPortal";

});
parcelRegister("6XNU4", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $511ef68320147845$export$deee3a793edee05f);

var $6p5gj = parcelRequire("6p5gj");
var $a9vMD = parcelRequire("a9vMD");

var $a9vMD = parcelRequire("a9vMD");

var $dmWla = parcelRequire("dmWla");
function $511ef68320147845$var$getCssDimensions(element) {
    const css = (0, $dmWla.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $dmWla.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $a9vMD.round)(width) !== offsetWidth || (0, $a9vMD.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $511ef68320147845$var$unwrapElement(element) {
    return !(0, $dmWla.isElement)(element) ? element.contextElement : element;
}
function $511ef68320147845$var$getScale(element) {
    const domElement = $511ef68320147845$var$unwrapElement(element);
    if (!(0, $dmWla.isHTMLElement)(domElement)) return (0, $a9vMD.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $511ef68320147845$var$getCssDimensions(domElement);
    let x = ($ ? (0, $a9vMD.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $a9vMD.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $511ef68320147845$var$noOffsets = /*#__PURE__*/ (0, $a9vMD.createCoords)(0);
function $511ef68320147845$var$getVisualOffsets(element) {
    const win = (0, $dmWla.getWindow)(element);
    if (!(0, $dmWla.isWebKit)() || !win.visualViewport) return $511ef68320147845$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $511ef68320147845$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $dmWla.getWindow)(element)) return false;
    return isFixed;
}
function $511ef68320147845$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $511ef68320147845$var$unwrapElement(element);
    let scale = (0, $a9vMD.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $dmWla.isElement)(offsetParent)) scale = $511ef68320147845$var$getScale(offsetParent);
        } else scale = $511ef68320147845$var$getScale(element);
    }
    const visualOffsets = $511ef68320147845$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $511ef68320147845$var$getVisualOffsets(domElement) : (0, $a9vMD.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $dmWla.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $dmWla.isElement)(offsetParent) ? (0, $dmWla.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $dmWla.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $511ef68320147845$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $dmWla.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $dmWla.getWindow)(currentIFrame);
            currentIFrame = (0, $dmWla.getFrameElement)(currentWin);
        }
    }
    return (0, $a9vMD.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $511ef68320147845$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $dmWla.getNodeScroll)(element).scrollLeft;
    if (!rect) return $511ef68320147845$var$getBoundingClientRect((0, $dmWla.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $511ef68320147845$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $511ef68320147845$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $511ef68320147845$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $dmWla.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $dmWla.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $a9vMD.createCoords)(1);
    const offsets = (0, $a9vMD.createCoords)(0);
    const isOffsetParentAnElement = (0, $dmWla.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dmWla.getNodeName)(offsetParent) !== 'body' || (0, $dmWla.isOverflowElement)(documentElement)) scroll = (0, $dmWla.getNodeScroll)(offsetParent);
        if ((0, $dmWla.isHTMLElement)(offsetParent)) {
            const offsetRect = $511ef68320147845$var$getBoundingClientRect(offsetParent);
            scale = $511ef68320147845$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $511ef68320147845$var$getHTMLOffset(documentElement, scroll, true) : (0, $a9vMD.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $511ef68320147845$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $511ef68320147845$var$getDocumentRect(element) {
    const html = (0, $dmWla.getDocumentElement)(element);
    const scroll = (0, $dmWla.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $a9vMD.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $a9vMD.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $511ef68320147845$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $dmWla.getComputedStyle)(body).direction === 'rtl') x += (0, $a9vMD.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $511ef68320147845$var$getViewportRect(element, strategy) {
    const win = (0, $dmWla.getWindow)(element);
    const html = (0, $dmWla.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $dmWla.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $511ef68320147845$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $511ef68320147845$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $dmWla.isHTMLElement)(element) ? $511ef68320147845$var$getScale(element) : (0, $a9vMD.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $511ef68320147845$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $511ef68320147845$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $511ef68320147845$var$getDocumentRect((0, $dmWla.getDocumentElement)(element));
    else if ((0, $dmWla.isElement)(clippingAncestor)) rect = $511ef68320147845$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $511ef68320147845$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $a9vMD.rectToClientRect)(rect);
}
function $511ef68320147845$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $dmWla.getParentNode)(element);
    if (parentNode === stopNode || !(0, $dmWla.isElement)(parentNode) || (0, $dmWla.isLastTraversableNode)(parentNode)) return false;
    return (0, $dmWla.getComputedStyle)(parentNode).position === 'fixed' || $511ef68320147845$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $511ef68320147845$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $dmWla.getOverflowAncestors)(element, [], false).filter((el)=>(0, $dmWla.isElement)(el) && (0, $dmWla.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $dmWla.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $dmWla.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $dmWla.isElement)(currentNode) && !(0, $dmWla.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $dmWla.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $dmWla.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $dmWla.isOverflowElement)(currentNode) && !currentNodeIsContaining && $511ef68320147845$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $dmWla.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $511ef68320147845$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $dmWla.isTopLayer)(element) ? [] : $511ef68320147845$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $511ef68320147845$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $a9vMD.max)(rect.top, accRect.top);
        accRect.right = (0, $a9vMD.min)(rect.right, accRect.right);
        accRect.bottom = (0, $a9vMD.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $a9vMD.max)(rect.left, accRect.left);
        return accRect;
    }, $511ef68320147845$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $511ef68320147845$var$getDimensions(element) {
    const { width: width, height: height } = $511ef68320147845$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $511ef68320147845$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $dmWla.isHTMLElement)(offsetParent);
    const documentElement = (0, $dmWla.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $511ef68320147845$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $a9vMD.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dmWla.getNodeName)(offsetParent) !== 'body' || (0, $dmWla.isOverflowElement)(documentElement)) scroll = (0, $dmWla.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $511ef68320147845$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $511ef68320147845$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $511ef68320147845$var$getHTMLOffset(documentElement, scroll) : (0, $a9vMD.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $511ef68320147845$var$isStaticPositioned(element) {
    return (0, $dmWla.getComputedStyle)(element).position === 'static';
}
function $511ef68320147845$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $dmWla.isHTMLElement)(element) || (0, $dmWla.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $dmWla.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $511ef68320147845$var$getOffsetParent(element, polyfill) {
    const win = (0, $dmWla.getWindow)(element);
    if ((0, $dmWla.isTopLayer)(element)) return win;
    if (!(0, $dmWla.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $dmWla.getParentNode)(element);
        while(svgOffsetParent && !(0, $dmWla.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $dmWla.isElement)(svgOffsetParent) && !$511ef68320147845$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $dmWla.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $511ef68320147845$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $dmWla.isTableElement)(offsetParent) && $511ef68320147845$var$isStaticPositioned(offsetParent))offsetParent = $511ef68320147845$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $dmWla.isLastTraversableNode)(offsetParent) && $511ef68320147845$var$isStaticPositioned(offsetParent) && !(0, $dmWla.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $dmWla.getContainingBlock)(element) || win;
}
const $511ef68320147845$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $511ef68320147845$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $511ef68320147845$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $511ef68320147845$var$isRTL(element) {
    return (0, $dmWla.getComputedStyle)(element).direction === 'rtl';
}
const $511ef68320147845$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $511ef68320147845$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $dmWla.getDocumentElement,
    getClippingRect: $511ef68320147845$var$getClippingRect,
    getOffsetParent: $511ef68320147845$var$getOffsetParent,
    getElementRects: $511ef68320147845$var$getElementRects,
    getClientRects: $511ef68320147845$var$getClientRects,
    getDimensions: $511ef68320147845$var$getDimensions,
    getScale: $511ef68320147845$var$getScale,
    isElement: $dmWla.isElement,
    isRTL: $511ef68320147845$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $511ef68320147845$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $dmWla.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $a9vMD.floor)(top);
        const insetRight = (0, $a9vMD.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $a9vMD.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $a9vMD.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $a9vMD.max)(0, (0, $a9vMD.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $511ef68320147845$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $511ef68320147845$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $dmWla.getOverflowAncestors)(referenceEl) : [],
        ...(0, $dmWla.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $511ef68320147845$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $511ef68320147845$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $511ef68320147845$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $511ef68320147845$export$37b6bde19b108ecc = (0, $6p5gj.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $511ef68320147845$export$cc800923e997bb8 = (0, $6p5gj.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $511ef68320147845$export$91fb6ecbd551914 = (0, $6p5gj.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $511ef68320147845$export$fba63a578e423eb = (0, $6p5gj.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $511ef68320147845$export$8a83211c878a3f1f = (0, $6p5gj.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $511ef68320147845$export$346677f925de839c = (0, $6p5gj.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $511ef68320147845$export$fe8985bb6374093c = (0, $6p5gj.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $511ef68320147845$export$f2120bbfa5450bd2 = (0, $6p5gj.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $511ef68320147845$export$18c8ad048e32c7d5 = (0, $6p5gj.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $511ef68320147845$export$7bf07e38f3dc4b69 = (0, $6p5gj.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $511ef68320147845$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $511ef68320147845$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $6p5gj.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("6p5gj", function(module, exports) {
$parcel$export(module.exports, "computePosition", () => $4a9928d31988e649$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $4a9928d31988e649$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $4a9928d31988e649$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $4a9928d31988e649$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $4a9928d31988e649$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $4a9928d31988e649$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $4a9928d31988e649$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $4a9928d31988e649$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $4a9928d31988e649$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $4a9928d31988e649$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $4a9928d31988e649$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("a9vMD")).rectToClientRect);

var $a9vMD = parcelRequire("a9vMD");
function $4a9928d31988e649$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $a9vMD.getSideAxis)(placement);
    const alignmentAxis = (0, $a9vMD.getAlignmentAxis)(placement);
    const alignLength = (0, $a9vMD.getAxisLength)(alignmentAxis);
    const side = (0, $a9vMD.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $a9vMD.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $4a9928d31988e649$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $4a9928d31988e649$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $4a9928d31988e649$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $4a9928d31988e649$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $a9vMD.evaluate)(options, state);
    const paddingObject = (0, $a9vMD.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $a9vMD.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $a9vMD.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4a9928d31988e649$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $a9vMD.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $a9vMD.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $a9vMD.getAlignmentAxis)(placement);
            const length = (0, $a9vMD.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $a9vMD.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $a9vMD.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $a9vMD.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $a9vMD.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $4a9928d31988e649$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $a9vMD.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $a9vMD.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $a9vMD.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $a9vMD.getAlignment)(placement) === alignment || (autoAlignment ? (0, $a9vMD.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4a9928d31988e649$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $a9vMD.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $a9vMD.placements) ? $4a9928d31988e649$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $a9vMD.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $a9vMD.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $a9vMD.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $a9vMD.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4a9928d31988e649$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $a9vMD.getSide)(placement);
            const initialSideAxis = (0, $a9vMD.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $a9vMD.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $a9vMD.getOppositePlacement)(initialPlacement)
            ] : (0, $a9vMD.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $a9vMD.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $a9vMD.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $a9vMD.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $4a9928d31988e649$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $4a9928d31988e649$var$isAnySideFullyClipped(overflow) {
    return (0, $a9vMD.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4a9928d31988e649$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $4a9928d31988e649$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $4a9928d31988e649$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $4a9928d31988e649$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $4a9928d31988e649$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4a9928d31988e649$var$getBoundingRect(rects) {
    const minX = (0, $a9vMD.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $a9vMD.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $a9vMD.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $a9vMD.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $4a9928d31988e649$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $a9vMD.rectToClientRect)($4a9928d31988e649$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4a9928d31988e649$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $a9vMD.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $4a9928d31988e649$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $a9vMD.rectToClientRect)($4a9928d31988e649$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $a9vMD.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $a9vMD.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $a9vMD.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $a9vMD.getSide)(placement) === 'left';
                    const maxRight = (0, $a9vMD.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $a9vMD.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $4a9928d31988e649$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $a9vMD.getSide)(placement);
    const alignment = (0, $a9vMD.getAlignment)(placement);
    const isVertical = (0, $a9vMD.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $a9vMD.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4a9928d31988e649$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $4a9928d31988e649$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4a9928d31988e649$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $a9vMD.getSideAxis)((0, $a9vMD.getSide)(placement));
            const mainAxis = (0, $a9vMD.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $a9vMD.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $a9vMD.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4a9928d31988e649$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $a9vMD.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $a9vMD.getSideAxis)(placement);
            const mainAxis = (0, $a9vMD.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $a9vMD.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $a9vMD.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4a9928d31988e649$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $a9vMD.getSide)(placement);
            const alignment = (0, $a9vMD.getAlignment)(placement);
            const isYAxis = (0, $a9vMD.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $a9vMD.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $a9vMD.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $a9vMD.max)(overflow.left, 0);
                const xMax = (0, $a9vMD.max)(overflow.right, 0);
                const yMin = (0, $a9vMD.max)(overflow.top, 0);
                const yMax = (0, $a9vMD.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $a9vMD.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $a9vMD.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("a9vMD", function(module, exports) {
$parcel$export(module.exports, "sides", () => $7643662995a7351a$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $7643662995a7351a$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $7643662995a7351a$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $7643662995a7351a$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $7643662995a7351a$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $7643662995a7351a$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $7643662995a7351a$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $7643662995a7351a$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $7643662995a7351a$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $7643662995a7351a$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $7643662995a7351a$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $7643662995a7351a$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $7643662995a7351a$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $7643662995a7351a$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $7643662995a7351a$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $7643662995a7351a$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $7643662995a7351a$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $7643662995a7351a$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $7643662995a7351a$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $7643662995a7351a$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $7643662995a7351a$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $7643662995a7351a$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $7643662995a7351a$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $7643662995a7351a$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $7643662995a7351a$export$803cd8101b6c182b = /*#__PURE__*/ $7643662995a7351a$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $7643662995a7351a$export$27b07d8a310ed8b5[0], side + "-" + $7643662995a7351a$export$27b07d8a310ed8b5[1]), []);
const $7643662995a7351a$export$96ec731ed4dcb222 = Math.min;
const $7643662995a7351a$export$8960430cfd85939f = Math.max;
const $7643662995a7351a$export$2077e0241d6afd3c = Math.round;
const $7643662995a7351a$export$a3fe094919f356fd = Math.floor;
const $7643662995a7351a$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $7643662995a7351a$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $7643662995a7351a$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $7643662995a7351a$export$7d15b64cf5a3a4c4(start, value, end) {
    return $7643662995a7351a$export$8960430cfd85939f(start, $7643662995a7351a$export$96ec731ed4dcb222(value, end));
}
function $7643662995a7351a$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $7643662995a7351a$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $7643662995a7351a$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $7643662995a7351a$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $7643662995a7351a$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $7643662995a7351a$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($7643662995a7351a$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $7643662995a7351a$export$2b57e0052a6d6d4c(placement) {
    return $7643662995a7351a$export$8a000a963141ac32($7643662995a7351a$export$f28e8f882010718a(placement));
}
function $7643662995a7351a$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $7643662995a7351a$export$f0989780f32bfcda(placement);
    const alignmentAxis = $7643662995a7351a$export$2b57e0052a6d6d4c(placement);
    const length = $7643662995a7351a$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $7643662995a7351a$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $7643662995a7351a$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $7643662995a7351a$export$496432a3699e50b1(placement) {
    const oppositePlacement = $7643662995a7351a$export$9c5e28bad23365fa(placement);
    return [
        $7643662995a7351a$export$2b182c584985588b(placement),
        oppositePlacement,
        $7643662995a7351a$export$2b182c584985588b(oppositePlacement)
    ];
}
function $7643662995a7351a$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$7643662995a7351a$var$oppositeAlignmentMap[alignment]);
}
function $7643662995a7351a$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $7643662995a7351a$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $7643662995a7351a$export$f0989780f32bfcda(placement);
    let list = $7643662995a7351a$var$getSideList($7643662995a7351a$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($7643662995a7351a$export$2b182c584985588b));
    }
    return list;
}
function $7643662995a7351a$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$7643662995a7351a$var$oppositeSideMap[side]);
}
function $7643662995a7351a$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $7643662995a7351a$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $7643662995a7351a$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $7643662995a7351a$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("dmWla", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $9bba959dc6b189e2$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $9bba959dc6b189e2$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $9bba959dc6b189e2$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $9bba959dc6b189e2$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $9bba959dc6b189e2$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $9bba959dc6b189e2$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $9bba959dc6b189e2$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $9bba959dc6b189e2$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $9bba959dc6b189e2$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $9bba959dc6b189e2$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $9bba959dc6b189e2$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $9bba959dc6b189e2$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $9bba959dc6b189e2$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $9bba959dc6b189e2$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $9bba959dc6b189e2$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $9bba959dc6b189e2$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $9bba959dc6b189e2$export$7bf1f8740e3e34af);
function $9bba959dc6b189e2$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $9bba959dc6b189e2$export$651544f548703224(node) {
    if ($9bba959dc6b189e2$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $9bba959dc6b189e2$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $9bba959dc6b189e2$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($9bba959dc6b189e2$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $9bba959dc6b189e2$export$8ee0fc9ee280b4ee(value) {
    if (!$9bba959dc6b189e2$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $9bba959dc6b189e2$export$38b2d434cce3ea22(value).Node;
}
function $9bba959dc6b189e2$export$45a5e7f76e0caa8d(value) {
    if (!$9bba959dc6b189e2$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $9bba959dc6b189e2$export$38b2d434cce3ea22(value).Element;
}
function $9bba959dc6b189e2$export$1b3bfaa9684536aa(value) {
    if (!$9bba959dc6b189e2$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $9bba959dc6b189e2$export$38b2d434cce3ea22(value).HTMLElement;
}
function $9bba959dc6b189e2$export$af51f0f06c0f328a(value) {
    if (!$9bba959dc6b189e2$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $9bba959dc6b189e2$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $9bba959dc6b189e2$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $9bba959dc6b189e2$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $9bba959dc6b189e2$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($9bba959dc6b189e2$export$651544f548703224(element));
}
function $9bba959dc6b189e2$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $9bba959dc6b189e2$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $9bba959dc6b189e2$export$78551043582a6a98();
    const css = $9bba959dc6b189e2$export$45a5e7f76e0caa8d(elementOrCss) ? $9bba959dc6b189e2$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $9bba959dc6b189e2$export$940d8225183e1404(element) {
    let currentNode = $9bba959dc6b189e2$export$4e12058fc4d51d56(element);
    while($9bba959dc6b189e2$export$1b3bfaa9684536aa(currentNode) && !$9bba959dc6b189e2$export$d1162fb0b6d4cd51(currentNode)){
        if ($9bba959dc6b189e2$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($9bba959dc6b189e2$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $9bba959dc6b189e2$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $9bba959dc6b189e2$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $9bba959dc6b189e2$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($9bba959dc6b189e2$export$651544f548703224(node));
}
function $9bba959dc6b189e2$export$3735103072e4a80(element) {
    return $9bba959dc6b189e2$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $9bba959dc6b189e2$export$dc8fc79fa2800137(element) {
    if ($9bba959dc6b189e2$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $9bba959dc6b189e2$export$4e12058fc4d51d56(node) {
    if ($9bba959dc6b189e2$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $9bba959dc6b189e2$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $9bba959dc6b189e2$export$e495491855dc5418(node);
    return $9bba959dc6b189e2$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $9bba959dc6b189e2$export$7cd01a57c8ca906c(node) {
    const parentNode = $9bba959dc6b189e2$export$4e12058fc4d51d56(node);
    if ($9bba959dc6b189e2$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($9bba959dc6b189e2$export$1b3bfaa9684536aa(parentNode) && $9bba959dc6b189e2$export$989e911fa9af580a(parentNode)) return parentNode;
    return $9bba959dc6b189e2$export$7cd01a57c8ca906c(parentNode);
}
function $9bba959dc6b189e2$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $9bba959dc6b189e2$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $9bba959dc6b189e2$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $9bba959dc6b189e2$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $9bba959dc6b189e2$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $9bba959dc6b189e2$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $9bba959dc6b189e2$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $9bba959dc6b189e2$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("25rLP", function(module, exports) {
$parcel$export(module.exports, "PortalPlacementContext", () => $7e25d9966f01409c$export$e001f626511a0ead);

var $euxye = parcelRequire("euxye");
const $7e25d9966f01409c$export$e001f626511a0ead = /*#__PURE__*/ (0, $euxye.createContext)(null);

});

parcelRegister("A7F3J", function(module, exports) {
$parcel$export(module.exports, "MenuPortalTopLayer", () => $b0bbbd895e0be877$export$1f5427c7f5364d0b);
/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $9fOPQ = parcelRequire("9fOPQ");

var $Yce2Z = parcelRequire("Yce2Z");

var $fEJPe = parcelRequire("fEJPe");

var $jNSP2 = parcelRequire("jNSP2");

var $fnGzU = parcelRequire("fnGzU");

var $23Cor = parcelRequire("23Cor");
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $b0bbbd895e0be877$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
const $b0bbbd895e0be877$var$menuPortalStyles = {
    root: "_ofie1496"
};
function $b0bbbd895e0be877$export$1f5427c7f5364d0b(props) {
    const { children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    const closeSelect = (0, $euxye.useContext)((0, $23Cor.MenuPortalCloseContext));
    const popoverRef = (0, $euxye.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    const anchorRef = (0, $euxye.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    const isAnchored = controlElement !== null;
    // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $fEJPe.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $b0bbbd895e0be877$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $jNSP2.useWidthFromAnchor)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    const handlePopoverClose = (0, $euxye.useCallback)(()=>{
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]);
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    const { className: className } = (0, $fnGzU.getStyleProps)({
        ...props,
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }, 'menuPortal', {
        'menu-portal': true
    });
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="manual"` opts out of native light-dismiss: react-select already
    // owns outside-click and Escape via its own handlers, and the combobox
    // trigger lives in a separate DOM subtree that the spec algorithm cannot
    // see. Matches the pattern in `@atlaskit/datetime-picker`'s MenuTopLayer.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
        ref: popoverRef,
        mode: "manual",
        isOpen: isAnchored,
        onClose: handlePopoverClose,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            // `className` carries consumer `styles.menuPortal({...})` output,
            // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
            // is a legacy selector hook kept for parity with MenuPortalLegacy.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
            className: (0, $4jQY2.default)([
                $b0bbbd895e0be877$var$menuPortalStyles.root,
                (0, $9S1b6.cx)(className, xcss, '-MenuPortal')
            ]),
            ...innerProps,
            children: children
        })
    });
}
$b0bbbd895e0be877$export$1f5427c7f5364d0b.displayName = "MenuPortalTopLayer";

});
parcelRegister("23Cor", function(module, exports) {
$parcel$export(module.exports, "MenuPortalCloseContext", () => $82059878714b7407$export$a0d5b29fa9affc38);

var $euxye = parcelRequire("euxye");
const $82059878714b7407$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});



parcelRegister("6PGkv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf4bae41707f246$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $d0F9p = parcelRequire("d0F9p");

var $fnGzU = parcelRequire("fnGzU");

var $eamWe = parcelRequire("eamWe");

var $i9Bbv = parcelRequire("i9Bbv");

var $9FFa6 = parcelRequire("9FFa6");
const $2bf4bae41707f246$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
const $2bf4bae41707f246$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
const $2bf4bae41707f246$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const $2bf4bae41707f246$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhk1w7a _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up53acm _1xdnnqa1"
};
const $2bf4bae41707f246$var$getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data?.label;
    return typeof label === 'string' ? label : '';
};
const $2bf4bae41707f246$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const labelText = $2bf4bae41707f246$var$getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const ffTagUplifts = (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const { css: containerCss, className: containerClassName } = (0, $fnGzU.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $fnGzU.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $fnGzU.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, $9FFa6.MultiValueLabel);
    const hasCustomContainer = Container !== (0, $i9Bbv.MultiValueContainer);
    const selectStyles = selectProps.styles;
    const hasCustomMultiValueStyles = Boolean(selectStyles?.multiValue || selectStyles?.multiValueLabel || selectStyles?.multiValueRemove);
    const selectClassNames = selectProps.classNames;
    const hasCustomMultiValueClassNames = Boolean(selectClassNames?.multiValue || selectClassNames?.multiValueLabel || selectClassNames?.multiValueRemove);
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    const selectGetStyles = (0, $eamWe.useSelectGetStyles)();
    const hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    const hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        const { elemBefore: elemBefore, color: tagColor } = data ?? {};
        return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $4jQY2.default)([
                $2bf4bae41707f246$var$multiValueTagWrapperStyles.root,
                (0, $9S1b6.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d0F9p.default), {
                text: labelText,
                isRemovable: !isDisabled,
                removeButtonLabel: `${labelText}, remove`,
                onBeforeRemoveAction: ()=>{
                    removeProps.onClick?.({});
                    return false;
                },
                color: tagColor ?? 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        });
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        const colorKey = data?.color;
        return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
            "data-multi-value-tag-like": "true",
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $4jQY2.default)([
                $2bf4bae41707f246$var$multiValueTagLikeStyles.root,
                $2bf4bae41707f246$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $2bf4bae41707f246$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $2bf4bae41707f246$var$tagLikeColorStyles.green,
                colorKey === 'red' && $2bf4bae41707f246$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $2bf4bae41707f246$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $2bf4bae41707f246$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $2bf4bae41707f246$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $2bf4bae41707f246$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $2bf4bae41707f246$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $2bf4bae41707f246$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $2bf4bae41707f246$var$multiValueTagLikeStyles.disabled,
                isFocused && $2bf4bae41707f246$var$multiValueTagLikeStyles.focused,
                (0, $9S1b6.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $2bf4bae41707f246$var$multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: labelClassName,
                        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)(Remove, {
                    data: data,
                    innerProps: {
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': `${labelText || 'option'}, remove`,
                        ...removeProps
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        });
    }
    // FF off → default styles
    return /*#__PURE__*/ (0, $e79Pd.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${labelText || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
$2bf4bae41707f246$var$MultiValue.displayName = "MultiValue";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2bf4bae41707f246$export$2e2bcd8739ae039 = $2bf4bae41707f246$var$MultiValue;

});
parcelRegister("d0F9p", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5a3e95da952baa7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $fgfJr = parcelRequire("fgfJr");

var $ljVHR = parcelRequire("ljVHR");

var $2oRWW = parcelRequire("2oRWW");

var $2EFuW = parcelRequire("2EFuW");

var $8L2z6 = parcelRequire("8L2z6");
var $3Yz9F = parcelRequire("3Yz9F");

var $egspI = parcelRequire("egspI");

var $la3d7 = parcelRequire("la3d7");

var $9vn1I = parcelRequire("9vn1I");

var $jSAa8 = parcelRequire("jSAa8");

var $dFqSD = parcelRequire("dFqSD");

var $3cgD8 = parcelRequire("3cgD8");

var $7LsQQ = parcelRequire("7LsQQ");

var $6mgpN = parcelRequire("6mgpN");

var $7Qoad = parcelRequire("7Qoad");
const $a5a3e95da952baa7$var$textLinkCssVar = '--ds-ctl';
const $a5a3e95da952baa7$var$textDefaultCssVar = '--ds-ct';
const $a5a3e95da952baa7$var$textActiveCssVar = '--ds-ctp';
const $a5a3e95da952baa7$var$backgroundHoverCssVar = '--ds-cbh';
const $a5a3e95da952baa7$var$backgroundActiveCssVar = '--ds-cba';
var $a5a3e95da952baa7$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($a5a3e95da952baa7$var$TagStatus || {});
const $a5a3e95da952baa7$var$packageName = "platform-pkg";
const $a5a3e95da952baa7$var$packageVersion = "0.0.0-use.local";
const $a5a3e95da952baa7$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $a5a3e95da952baa7$var$removingStyles = null;
const $a5a3e95da952baa7$var$RemovableTagComponent = /*#__PURE__*/ (0, $euxye.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $a5a3e95da952baa7$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $2oRWW.default), linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, hasMargin: hasMargin = true, swatchBefore: swatchBefore, ...rest }, ref)=>{
    const [status, setStatus] = (0, $euxye.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $euxye.useState)(false);
    const normalizedText = (0, $jSAa8.getTagText)(text);
    const onAfterRemoveActionWithAnalytics = (0, $fgfJr.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $a5a3e95da952baa7$var$packageName,
            packageVersion: $a5a3e95da952baa7$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $euxye.useCallback)(()=>{
        setStatus("removed");
    }, []);
    const handleRemoveRequest = (0, $euxye.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    const onKeyPress = (0, $euxye.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $euxye.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $euxye.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $euxye.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $euxye.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7Qoad.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${normalizedText}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined; // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $7LsQQ.getLozengeAppearance)(color);
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2EFuW.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest,
            children: normalizedText
        });
    } // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $9vn1I.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $la3d7.default), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        });
    } // Original implementation
    const content = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mgpN.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$a5a3e95da952baa7$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$a5a3e95da952baa7$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$a5a3e95da952baa7$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$a5a3e95da952baa7$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$a5a3e95da952baa7$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3Yz9F.default), {
            onFinish: handleRemoveComplete,
            children: (motion)=>{
                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dFqSD.default), {
                    ref: (0, $ljVHR.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3cgD8.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $4jQY2.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        }, "atlaskit-removable-tag-legacy-shrink-out")
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $a5a3e95da952baa7$var$RemovableTag = /*#__PURE__*/ (0, $euxye.memo)($a5a3e95da952baa7$var$RemovableTagComponent);
var $a5a3e95da952baa7$export$2e2bcd8739ae039 = $a5a3e95da952baa7$var$RemovableTag;

});
parcelRegister("3Yz9F", function(module, exports) {
$parcel$export(module.exports, "default", () => $4542881332362b9b$export$2e2bcd8739ae039);

var $9VFAH = parcelRequire("9VFAH");

var $bG844 = parcelRequire("bG844");

var $DxsCA = parcelRequire("DxsCA");

var $dxDNV = parcelRequire("dxDNV");

var $23KBv = parcelRequire("23KBv");

var $3bcsJ = parcelRequire("3bcsJ");

var $8L2z6 = parcelRequire("8L2z6");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $4542881332362b9b$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $DxsCA.useElementRef)();
    const exiting = (0, $8L2z6.useExitingPersistence)();
    const requestAnimationFrame = (0, $23KBv.useRequestAnimationFrame)();
    const setTimeout = (0, $3bcsJ.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $dxDNV.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $bG844.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $9VFAH.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $9VFAH.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
$4542881332362b9b$var$ShrinkOut.displayName = "ShrinkOut";
var $4542881332362b9b$export$2e2bcd8739ae039 = $4542881332362b9b$var$ShrinkOut;

});

parcelRegister("la3d7", function(module, exports) {
$parcel$export(module.exports, "TagDropdownTriggerComponent", () => $64ef0c5e1a9fd431$export$aba6bd1190e79361);
$parcel$export(module.exports, "default", () => $64ef0c5e1a9fd431$export$2e2bcd8739ae039);
/* tag-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $ld25x = parcelRequire("ld25x");

var $6mEZn = parcelRequire("6mEZn");

var $abhF2 = parcelRequire("abhF2");

var $9vn1I = parcelRequire("9vn1I");

var $jSAa8 = parcelRequire("jSAa8");

var $cBgWk = parcelRequire("cBgWk");

var $l6ERj = parcelRequire("l6ERj");

var $j0Sen = parcelRequire("j0Sen");

var $7jp8W = parcelRequire("7jp8W");

var $8cVIY = parcelRequire("8cVIY");

var $2M8pZ = parcelRequire("2M8pZ");

var $33N7D = parcelRequire("33N7D");
const $64ef0c5e1a9fd431$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhk1w7a",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1r81 _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj18uv _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj18uv _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_175018uv _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
const $64ef0c5e1a9fd431$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
const $64ef0c5e1a9fd431$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
const $64ef0c5e1a9fd431$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
const $64ef0c5e1a9fd431$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ const $64ef0c5e1a9fd431$var$TagNewComponent = /*#__PURE__*/ (0, $euxye.forwardRef)(function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other }, ref) {
    const normalizedText = (0, $jSAa8.getTagText)(text);
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $33N7D.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $euxye.useCallback)(()=>{
        onAfterRemoveAction?.(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $8cVIY.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $7jp8W.useButtonInteraction)();
    const removeButton = (0, $2M8pZ.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const tagContent = /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
        ...other,
        ref: ref,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $4jQY2.default)([
            $64ef0c5e1a9fd431$var$styles.baseStyles,
            !hasMargin && $64ef0c5e1a9fd431$var$styles.noMarginStyles,
            $64ef0c5e1a9fd431$var$colorStyles[color],
            $64ef0c5e1a9fd431$var$borderIconFilterStyles.root,
            isLink && $64ef0c5e1a9fd431$var$styles.interactiveBaseStyles,
            isLink && $64ef0c5e1a9fd431$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $64ef0c5e1a9fd431$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $64ef0c5e1a9fd431$var$styles.interactiveHoverStyles,
            isRemovable && $64ef0c5e1a9fd431$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $64ef0c5e1a9fd431$var$styles.childFocusRingStyles,
            !isRemovable && trailingMetric != null && trailingMetric !== '' && $64ef0c5e1a9fd431$var$styles.trailingMetricEndPadding
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $cBgWk.LinkWrapper), {
                isLink: isLink,
                href: href,
                LinkComponent: LinkComponent,
                testId: testId,
                linkHandlers: linkHandlers,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j0Sen.default), {
                        colorKey: color,
                        swatchBefore: swatchBefore
                    }),
                    elemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.beforeStyles
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.textStyles
                        ]),
                        children: normalizedText
                    }),
                    trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-testid": testId && `${testId}--metric`,
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.trailingMetric
                        ]),
                        children: trailingMetric
                    })
                ]
            }),
            removeButton && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $64ef0c5e1a9fd431$var$styles.afterStyles
                ]),
                children: removeButton
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l6ERj.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: tagContent
    });
});
const $64ef0c5e1a9fd431$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $euxye.forwardRef)(function TagDropdownTrigger({ color: color = 'gray', text: text, elemBefore: elemBefore, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, isSelected: isSelected = false, isLoading: isLoading = false, analyticsContext: _analyticsContext, hasChevron: hasChevron = true, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other }, ref) {
    const resolvedColor = (0, $9vn1I.colorMapping)[color] || 'gray';
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $6mEZn.default), {
        ref: ref,
        // @ts-expect-error paddingInline is 0.1875rem
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $9S1b6.cx)($64ef0c5e1a9fd431$var$styles.baseStyles, !hasMargin && $64ef0c5e1a9fd431$var$styles.noMarginStyles, $64ef0c5e1a9fd431$var$colorStyles[resolvedColor], $64ef0c5e1a9fd431$var$borderIconFilterStyles.root, $64ef0c5e1a9fd431$var$dropdownStyles.interactive, $64ef0c5e1a9fd431$var$styles.focusRingStyles, $64ef0c5e1a9fd431$var$borderIconInteractiveFilterStyles.root, isSelected && $64ef0c5e1a9fd431$var$dropdownStyles.selected, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $64ef0c5e1a9fd431$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        },
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        testId: testId,
        ...other,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
                className: (0, $4jQY2.default)([
                    $64ef0c5e1a9fd431$var$dropdownStyles.content,
                    isLoading && $64ef0c5e1a9fd431$var$dropdownStyles.loadingContent
                ]),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j0Sen.default), {
                        colorKey: resolvedColor,
                        swatchBefore: swatchBefore
                    }),
                    elemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.beforeStyles,
                            isSelected && $64ef0c5e1a9fd431$var$styles.beforeStylesSelected
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.textStyles,
                            isSelected && $64ef0c5e1a9fd431$var$styles.textStylesSelected
                        ]),
                        children: (0, $jSAa8.getTagText)(text)
                    }),
                    trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-testid": testId && `${testId}--metric`,
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.trailingMetric
                        ]),
                        children: trailingMetric
                    }),
                    hasChevron && /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                        label: "",
                        size: "small",
                        color: 'currentColor',
                        testId: testId && `${testId}--chevron`
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $64ef0c5e1a9fd431$var$dropdownStyles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
                    size: 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
});
/**
 * __Tag new__
 */ const $64ef0c5e1a9fd431$var$TagNew = /*#__PURE__*/ (0, $euxye.memo)($64ef0c5e1a9fd431$var$TagNewComponent);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$64ef0c5e1a9fd431$export$2e2bcd8739ae039 = $64ef0c5e1a9fd431$var$TagNew;

});
parcelRegister("9vn1I", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $16f60e789105a82b$export$3351a8d90bcc13aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $16f60e789105a82b$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

});

parcelRegister("jSAa8", function(module, exports) {
$parcel$export(module.exports, "getTagText", () => $156259ed412b526a$export$7d100de1166870f6);
// Intentionally scoped to the UI-uplifted TagNew implementation.
const $156259ed412b526a$export$7d100de1166870f6 = (text)=>Array.isArray(text) ? text.join('') : text;

});

parcelRegister("cBgWk", function(module, exports) {
$parcel$export(module.exports, "LinkWrapper", () => $cdf2db0ef62f0311$export$ce4b6a469c26f53f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $cdf2db0ef62f0311$export$ce4b6a469c26f53f({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, $e79Pd.jsx)(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers?.onMouseEnter,
        onMouseLeave: linkHandlers?.onMouseLeave,
        onMouseDown: linkHandlers?.onMouseDown,
        onFocus: linkHandlers?.onFocus,
        onBlur: linkHandlers?.onBlur,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: children
    });
}
$cdf2db0ef62f0311$export$ce4b6a469c26f53f.displayName = "LinkWrapper";

});

parcelRegister("l6ERj", function(module, exports) {
$parcel$export(module.exports, "RemovableWrapper", () => $a693ff33d060de5b$export$898a500849bb5cf4);
/* removable-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8L2z6 = parcelRequire("8L2z6");
var $3Yz9F = parcelRequire("3Yz9F");

var $5eeJV = parcelRequire("5eeJV");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ const $a693ff33d060de5b$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const $a693ff33d060de5b$var$motionWrapperStyles = null;
function $a693ff33d060de5b$export$898a500849bb5cf4({ isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children }) {
    if (isRemovable) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        children: !(status === (0, $5eeJV.TagStatus).Removed) && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3Yz9F.default), {
            onFinish: onShrinkOutExitComplete ? (phase)=>{
                if (phase === 'exiting') onShrinkOutExitComplete();
            } : undefined,
            children: (motion)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    ref: motion.ref,
                    className: (0, $4jQY2.default)([
                        "_1e0c116y"
                    ]),
                    children: children
                })
        }, $a693ff33d060de5b$var$removableShrinkOutChildKey)
    });
    return children;
}
$a693ff33d060de5b$export$898a500849bb5cf4.displayName = "RemovableWrapper";

});
parcelRegister("5eeJV", function(module, exports) {
$parcel$export(module.exports, "TagStatus", () => $aca759d9f34e091b$export$74452314b63acabc);
// Tag status enum
var $aca759d9f34e091b$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

});


parcelRegister("j0Sen", function(module, exports) {
$parcel$export(module.exports, "default", () => $91c684da65a78c91$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $91c684da65a78c91$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
const $91c684da65a78c91$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $91c684da65a78c91$export$2e2bcd8739ae039({ colorKey: colorKey, swatchBefore: swatchBefore }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            $91c684da65a78c91$var$tagSwatchBeforeStyles.swatch,
            $91c684da65a78c91$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $4jQY2.default)([
            $91c684da65a78c91$var$tagSwatchBeforeStyles.swatch
        ])
    });
}
$91c684da65a78c91$export$2e2bcd8739ae039.displayName = "SwatchBefore";

});

parcelRegister("7jp8W", function(module, exports) {
$parcel$export(module.exports, "useButtonInteraction", () => $cf5751754f5053aa$export$84acd183858d8235);

var $euxye = parcelRequire("euxye");
function $cf5751754f5053aa$export$84acd183858d8235() {
    const [isLinkHovered, setIsLinkHovered] = (0, $euxye.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $euxye.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $euxye.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $euxye.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $euxye.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $euxye.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e?.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $euxye.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

});

parcelRegister("8cVIY", function(module, exports) {
$parcel$export(module.exports, "useLink", () => $0e9110f704a6f810$export$dcf14c9974fe2767);

var $hzWaA = parcelRequire("hzWaA");
function $0e9110f704a6f810$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $hzWaA.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

});

parcelRegister("2M8pZ", function(module, exports) {
$parcel$export(module.exports, "useRemoveButton", () => $29c97f963b62271a$export$97d8be09cd53869b);
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $7Qoad = parcelRequire("7Qoad");
function $29c97f963b62271a$export$97d8be09cd53869b({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $euxye.useCallback)(()=>{
        removingTag();
        buttonHandlers?.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $euxye.useCallback)(()=>{
        showingTag();
        buttonHandlers?.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $euxye.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7Qoad.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers?.onMouseEnter,
            onMouseLeave: buttonHandlers?.onMouseLeave,
            onMouseDown: buttonHandlers?.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

});
parcelRegister("7Qoad", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4f1e0beeada2028$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $i68tN = parcelRequire("i68tN");

var $egspI = parcelRequire("egspI");

var $6mEZn = parcelRequire("6mEZn");
const $e4f1e0beeada2028$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
const $e4f1e0beeada2028$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
        xcss: (0, $1MNmN.cx)($e4f1e0beeada2028$var$removeButtonStyles.root, shape === 'circle' && $e4f1e0beeada2028$var$removeButtonStyles.circle, $e4f1e0beeada2028$var$removeButtonStyles.newIcon, (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && $e4f1e0beeada2028$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    });
};
$e4f1e0beeada2028$var$RemoveButton.displayName = "RemoveButton";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e4f1e0beeada2028$export$2e2bcd8739ae039 = $e4f1e0beeada2028$var$RemoveButton;

});


parcelRegister("33N7D", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $4c1848fea025727b$export$f26019543e9f862f);

var $euxye = parcelRequire("euxye");

var $gbRME = parcelRequire("gbRME");

var $5eeJV = parcelRequire("5eeJV");
function $4c1848fea025727b$export$f26019543e9f862f(onBeforeRemoveAction) {
    const [status, setStatus] = (0, $euxye.useState)((0, $5eeJV.TagStatus).Showing);
    const handleRemoveRequest = (0, $euxye.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? (0, $gbRME.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $5eeJV.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $euxye.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $euxye.useCallback)(()=>setStatus((0, $5eeJV.TagStatus).Removing), []);
    const showingTag = (0, $euxye.useCallback)(()=>setStatus((0, $5eeJV.TagStatus).Showing), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

});
parcelRegister("gbRME", function(module, exports) {
$parcel$export(module.exports, "defaultBeforeRemoveAction", () => $ba03e3d1e3f0a7cc$export$279e7025ed114474);
const $ba03e3d1e3f0a7cc$export$279e7025ed114474 = ()=>true;

});



parcelRegister("dFqSD", function(module, exports) {
$parcel$export(module.exports, "default", () => $814df91cde2dc5e7$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
const $814df91cde2dc5e7$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $814df91cde2dc5e7$var$baseStyles = null;
const $814df91cde2dc5e7$var$interactiveStyles = null;
const $814df91cde2dc5e7$var$focusRingStyles = null;
const $814df91cde2dc5e7$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhk1w7a _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $814df91cde2dc5e7$var$borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$814df91cde2dc5e7$export$2e2bcd8739ae039 = $814df91cde2dc5e7$var$BaseTag;

});

parcelRegister("3cgD8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcb0d169ae3c0576$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $fcb0d169ae3c0576$var$beforeElementStyles = null;
const $fcb0d169ae3c0576$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
$fcb0d169ae3c0576$var$Before.displayName = "Before";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcb0d169ae3c0576$export$2e2bcd8739ae039 = $fcb0d169ae3c0576$var$Before;

});

parcelRegister("7LsQQ", function(module, exports) {
$parcel$export(module.exports, "getLozengeAppearance", () => $440942323f24cbd6$export$4d9e331cafeacb9d);
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ const $440942323f24cbd6$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $440942323f24cbd6$export$4d9e331cafeacb9d(color) {
    return $440942323f24cbd6$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

});

parcelRegister("6mgpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0dc42a9a546a1d8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jSAa8 = parcelRequire("jSAa8");
const $d0dc42a9a546a1d8$var$baseStyles = null;
const $d0dc42a9a546a1d8$var$linkStyles = null;
const $d0dc42a9a546a1d8$var$hasAfterStyles = null;
const $d0dc42a9a546a1d8$var$Content = ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    const normalizedText = (0, $jSAa8.getTagText)(text);
    if (href) return /*#__PURE__*/ (0, $e79Pd.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $4jQY2.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm18uv _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ]),
        children: normalizedText
    });
    else return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ]),
        children: normalizedText
    });
};
$d0dc42a9a546a1d8$var$Content.displayName = "Content";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0dc42a9a546a1d8$export$2e2bcd8739ae039 = $d0dc42a9a546a1d8$var$Content;

});


parcelRegister("eamWe", function(module, exports) {
$parcel$export(module.exports, "useSelectGetStyles", () => $546c826ef5bf3d5a$export$2a533455c10aa11f);
/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $euxye = parcelRequire("euxye");

var $2dGma = parcelRequire("2dGma");
const $546c826ef5bf3d5a$export$2a533455c10aa11f = ()=>(0, $euxye.useContext)((0, $2dGma.SelectGetStylesContext));

});
parcelRegister("2dGma", function(module, exports) {
$parcel$export(module.exports, "SelectGetStylesContext", () => $c6a14a5d5000558b$export$50727c0a52da4015);
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $euxye = parcelRequire("euxye");
const $c6a14a5d5000558b$export$50727c0a52da4015 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});


parcelRegister("9FFa6", function(module, exports) {
$parcel$export(module.exports, "MultiValueLabel", () => $363cb80f354e8e2d$export$544aeea2a5ce08ee);
/* multi-value-label.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");
const $363cb80f354e8e2d$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
const $363cb80f354e8e2d$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $363cb80f354e8e2d$var$multiValueLabelStyles.root,
            isDisabled && $363cb80f354e8e2d$var$multiValueLabelStyles.disabled,
            hasEllipsis && $363cb80f354e8e2d$var$multiValueLabelStyles.ellipsis,
            (0, $9S1b6.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
$363cb80f354e8e2d$export$544aeea2a5ce08ee.displayName = "MultiValueLabel";

});


parcelRegister("hvkNV", function(module, exports) {
$parcel$export(module.exports, "MultiValueRemove", () => $a42c4a691c83fe87$export$8e1fd1a40e7a2f4a);
/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $i68tN = parcelRequire("i68tN");
const $a42c4a691c83fe87$var$disabledStyles = null;
const $a42c4a691c83fe87$var$enabledStyles = null;
const $a42c4a691c83fe87$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $a42c4a691c83fe87$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $a42c4a691c83fe87$var$multiValueRemoveStyles.root,
            isFocused && $a42c4a691c83fe87$var$multiValueRemoveStyles.focused,
            (0, $9S1b6.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $4jQY2.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}
$a42c4a691c83fe87$export$8e1fd1a40e7a2f4a.displayName = "MultiValueRemove";

});

parcelRegister("gaXx9", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f5619184c5272b$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");
const $11f5619184c5272b$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk18uv _16qsglyw _1di618uv _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e126o",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e126o",
    focusedSelected: "_bfhkufnl",
    motion: "_v5641x7n _1gglpoum",
    motionSelected: "_v5641mma"
};
const $11f5619184c5272b$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $11f5619184c5272b$var$optionStyles.root,
            !isDisabled && !isSelected && (0, $egspI.fg)('platform-dst-motion-uplift-list-item') && $11f5619184c5272b$var$optionStyles.motion,
            isFocused && $11f5619184c5272b$var$optionStyles.focused,
            isSelected && $11f5619184c5272b$var$optionStyles.selected,
            isFocused && isSelected && $11f5619184c5272b$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, $egspI.fg)('platform-dst-motion-uplift-list-item') && $11f5619184c5272b$var$optionStyles.motionSelected,
            isDisabled && $11f5619184c5272b$var$optionStyles.disabled,
            (0, $9S1b6.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
$11f5619184c5272b$var$Option.displayName = "Option";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$11f5619184c5272b$export$2e2bcd8739ae039 = $11f5619184c5272b$var$Option;

});

parcelRegister("03ZGj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e752787424d1302$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $2e752787424d1302$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
const $2e752787424d1302$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $2e752787424d1302$var$placeholderStyles.root,
            isDisabled && $2e752787424d1302$var$placeholderStyles.disabled,
            (0, $9S1b6.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
$2e752787424d1302$var$Placeholder.displayName = "Placeholder";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e752787424d1302$export$2e2bcd8739ae039 = $2e752787424d1302$var$Placeholder;

});

parcelRegister("80vrn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd03f6992cacf471$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $fd03f6992cacf471$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
const $fd03f6992cacf471$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $fd03f6992cacf471$var$styles.root,
            isDisabled && $fd03f6992cacf471$var$styles.disalbed,
            (0, $9S1b6.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
$fd03f6992cacf471$var$SingleValue.displayName = "SingleValue";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd03f6992cacf471$export$2e2bcd8739ae039 = $fd03f6992cacf471$var$SingleValue;

});


parcelRegister("12siX", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5cf3b4e57e78f87$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $a5cf3b4e57e78f87$var$removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $a5cf3b4e57e78f87$var$dummyInputStyles = null;
function $a5cf3b4e57e78f87$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = $a5cf3b4e57e78f87$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
        ref: innerRef,
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}
$a5cf3b4e57e78f87$export$2e2bcd8739ae039.displayName = "DummyInput";

});

parcelRegister("5sF5y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d99dbdaf149eee59$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $43oeN = parcelRequire("43oeN");

var $gfpJJ = parcelRequire("gfpJJ");
const $d99dbdaf149eee59$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $euxye.useMemo)(()=>({
            ...(0, $43oeN.defaultAriaLiveMessages),
            ...ariaLiveMessages
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $euxye.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $euxye.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gfpJJ.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gfpJJ.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
$d99dbdaf149eee59$var$LiveRegion.displayName = "LiveRegion";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d99dbdaf149eee59$export$2e2bcd8739ae039 = $d99dbdaf149eee59$var$LiveRegion;

});
parcelRegister("43oeN", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", () => $fc187912ade9a293$export$a7265767c78f9bae);
const $fc187912ade9a293$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("gfpJJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e36b4aa4950150b6$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
// Assistive text to describe visual elements. Hidden for sighted users.
const $e36b4aa4950150b6$var$styles = null;
const $e36b4aa4950150b6$var$A11yText = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
$e36b4aa4950150b6$var$A11yText.displayName = "A11yText";
var $e36b4aa4950150b6$export$2e2bcd8739ae039 = $e36b4aa4950150b6$var$A11yText;

});


parcelRegister("jgG0E", function(module, exports) {
$parcel$export(module.exports, "default", () => $1058914072f3e09a$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $egspI = parcelRequire("egspI");

var $25rLP = parcelRequire("25rLP");
const $1058914072f3e09a$var$noop = (0, $2oRWW.default);
function $1058914072f3e09a$var$getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $1058914072f3e09a$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $1058914072f3e09a$var$normalizedHeight(el) {
    if ($1058914072f3e09a$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $1058914072f3e09a$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($1058914072f3e09a$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $1058914072f3e09a$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $1058914072f3e09a$var$getScrollTop(el) {
    if ($1058914072f3e09a$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $1058914072f3e09a$var$animatedScrollTo(element, to, duration = 200, callback = $1058914072f3e09a$var$noop) {
    const start = $1058914072f3e09a$var$getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $1058914072f3e09a$var$easeOutCubic(currentTime, start, change, duration);
        $1058914072f3e09a$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $1058914072f3e09a$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = $1058914072f3e09a$var$getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : $1058914072f3e09a$var$normalizedHeight(scrollParent);
    const scrollTop = $1058914072f3e09a$var$getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1058914072f3e09a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $1058914072f3e09a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $1058914072f3e09a$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1058914072f3e09a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $1058914072f3e09a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $1058914072f3e09a$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $1058914072f3e09a$var$MenuPlacer = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $euxye.useContext)((0, $25rLP.PortalPlacementContext)) || {};
    const ref = (0, $euxye.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $euxye.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $euxye.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $euxye.useLayoutEffect)(()=>{
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, $egspI.fg)('platform-dst-top-layer')) return;
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $1058914072f3e09a$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $1058914072f3e09a$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
$1058914072f3e09a$var$MenuPlacer.displayName = "MenuPlacer";
var $1058914072f3e09a$export$2e2bcd8739ae039 = $1058914072f3e09a$var$MenuPlacer;

});

parcelRegister("87lhX", function(module, exports) {
$parcel$export(module.exports, "createFilter", () => $c2ab91d201547b95$export$5d81789ff4aeccdf);

var $emCaV = parcelRequire("emCaV");

var $ii2Vi = parcelRequire("ii2Vi");
const $c2ab91d201547b95$var$memoizedStripDiacriticsForInput = (0, $emCaV.default)((0, $ii2Vi.stripDiacritics));
const $c2ab91d201547b95$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $c2ab91d201547b95$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $c2ab91d201547b95$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $c2ab91d201547b95$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $c2ab91d201547b95$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $c2ab91d201547b95$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $c2ab91d201547b95$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $ii2Vi.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("ii2Vi", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", () => $9b377e65d9e4c92e$export$b5bee4b27048330b);
const $9b377e65d9e4c92e$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $9b377e65d9e4c92e$var$anyDiacritic = new RegExp('[' + $9b377e65d9e4c92e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $9b377e65d9e4c92e$var$diacriticToBase = {};
for(let i = 0; i < $9b377e65d9e4c92e$var$diacritics.length; i++){
    let diacritic = $9b377e65d9e4c92e$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$9b377e65d9e4c92e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $9b377e65d9e4c92e$export$b5bee4b27048330b = (str)=>{
    return str.replace($9b377e65d9e4c92e$var$anyDiacritic, (match)=>$9b377e65d9e4c92e$var$diacriticToBase[match]);
};

});


parcelRegister("hbudu", function(module, exports) {
$parcel$export(module.exports, "classNames", () => $fdee712e6698ef88$export$ce4ab0c55987d1ff);
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $fdee712e6698ef88$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $fdee712e6698ef88$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$fdee712e6698ef88$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}

});

parcelRegister("369bp", function(module, exports) {
$parcel$export(module.exports, "cleanValue", () => $e64289349e707ce4$export$33f062f47f21a01);
const $e64289349e707ce4$export$33f062f47f21a01 = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};

});

parcelRegister("8fbe0", function(module, exports) {
$parcel$export(module.exports, "isDocumentElement", () => $85dc30786f7c7973$export$d8a62a489b442872);
function $85dc30786f7c7973$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

});

parcelRegister("FKmXz", function(module, exports) {
$parcel$export(module.exports, "multiValueAsValue", () => $f5ae85341aad2f8b$export$d1ca752ec761b95b);
function $f5ae85341aad2f8b$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}

});

parcelRegister("dxId9", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $7b4450fe6757040d$export$17baa7c95b6ba1b8);

var $9fOPQ = parcelRequire("9fOPQ");
function $7b4450fe6757040d$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}
$7b4450fe6757040d$export$17baa7c95b6ba1b8.displayName = "NotifyOpenLayerObserver";

});

parcelRegister("BytXA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4e96fc16072d65f$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2oRWW = parcelRequire("2oRWW");
const $d4e96fc16072d65f$var$styles = null;
const $d4e96fc16072d65f$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $e79Pd.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $2oRWW.default)
    });
$d4e96fc16072d65f$var$RequiredInput.displayName = "RequiredInput";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d4e96fc16072d65f$export$2e2bcd8739ae039 = $d4e96fc16072d65f$var$RequiredInput;

});

parcelRegister("8Sn9q", function(module, exports) {
$parcel$export(module.exports, "default", () => $17a32e25579e47e7$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $79i7l = parcelRequire("79i7l");

var $h0Vtm = parcelRequire("h0Vtm");
const $17a32e25579e47e7$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $17a32e25579e47e7$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $79i7l.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $h0Vtm.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                onClick: $17a32e25579e47e7$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}
$17a32e25579e47e7$export$2e2bcd8739ae039.displayName = "ScrollManager";

});
parcelRegister("79i7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $88140c9a87a6bb65$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $bY3A7 = parcelRequire("bY3A7");
const $88140c9a87a6bb65$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $88140c9a87a6bb65$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $euxye.useRef)(false);
    const isTop = (0, $euxye.useRef)(false);
    const touchStart = (0, $euxye.useRef)(0);
    const scrollTarget = (0, $euxye.useRef)(null);
    const handleEventDelta = (0, $euxye.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $88140c9a87a6bb65$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $euxye.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $euxye.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $euxye.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $euxye.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $bY3A7.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $euxye.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});
parcelRegister("bY3A7", function(module, exports) {
$parcel$export(module.exports, "supportsPassiveEvents", () => $ee96e2f3e39aacaa$export$b0622a6911dbeaf5);
// ==============================
// Passive Event Detector
// ==============================

var $2oRWW = parcelRequire("2oRWW");
const $ee96e2f3e39aacaa$var$noop = (0, $2oRWW.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $ee96e2f3e39aacaa$var$passiveOptionAccessed = false;
const $ee96e2f3e39aacaa$var$options = {
    get passive () {
        return $ee96e2f3e39aacaa$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $ee96e2f3e39aacaa$var$w = typeof window !== 'undefined' ? window : {};
if ($ee96e2f3e39aacaa$var$w.addEventListener && $ee96e2f3e39aacaa$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $ee96e2f3e39aacaa$var$w.addEventListener('p', $ee96e2f3e39aacaa$var$noop, $ee96e2f3e39aacaa$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $ee96e2f3e39aacaa$var$w.removeEventListener('p', $ee96e2f3e39aacaa$var$noop, false);
}
const $ee96e2f3e39aacaa$export$b0622a6911dbeaf5 = $ee96e2f3e39aacaa$var$passiveOptionAccessed;

});


parcelRegister("h0Vtm", function(module, exports) {
$parcel$export(module.exports, "default", () => $09aba0b9289f6e63$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $09aba0b9289f6e63$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $09aba0b9289f6e63$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $09aba0b9289f6e63$var$preventTouchMove(e) {
    e.preventDefault();
}
function $09aba0b9289f6e63$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $09aba0b9289f6e63$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $09aba0b9289f6e63$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $09aba0b9289f6e63$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $09aba0b9289f6e63$var$activeScrollLocks = 0;
const $09aba0b9289f6e63$var$listenerOptions = {
    capture: false,
    passive: false
};
function $09aba0b9289f6e63$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $euxye.useRef)({});
    const scrollTarget = (0, $euxye.useRef)(null);
    const addScrollLock = (0, $euxye.useCallback)((touchScrollTarget)=>{
        if (!$09aba0b9289f6e63$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $09aba0b9289f6e63$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $09aba0b9289f6e63$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($09aba0b9289f6e63$var$LOCK_STYLES).forEach((key)=>{
                const val = $09aba0b9289f6e63$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $09aba0b9289f6e63$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $09aba0b9289f6e63$var$preventTouchMove, $09aba0b9289f6e63$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $09aba0b9289f6e63$var$preventInertiaScroll, $09aba0b9289f6e63$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $09aba0b9289f6e63$var$allowTouchMove, $09aba0b9289f6e63$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $09aba0b9289f6e63$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $euxye.useCallback)((touchScrollTarget)=>{
        if (!$09aba0b9289f6e63$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $09aba0b9289f6e63$var$activeScrollLocks = Math.max($09aba0b9289f6e63$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $09aba0b9289f6e63$var$activeScrollLocks < 1) $09aba0b9289f6e63$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $09aba0b9289f6e63$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $09aba0b9289f6e63$var$preventTouchMove, $09aba0b9289f6e63$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $09aba0b9289f6e63$var$preventInertiaScroll, $09aba0b9289f6e63$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $09aba0b9289f6e63$var$allowTouchMove, $09aba0b9289f6e63$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("6q2Ac", function(module, exports) {
$parcel$export(module.exports, "scrollTo", () => $fe6f5fbdeaaa5ef5$export$3f99968195accfaf);

var $8fbe0 = parcelRequire("8fbe0");
function $fe6f5fbdeaaa5ef5$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $8fbe0.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

});

parcelRegister("hjDA7", function(module, exports) {
$parcel$export(module.exports, "singleValueAsValue", () => $6a9daebd2af397b8$export$dea4763e29237f4c);
function $6a9daebd2af397b8$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}

});

parcelRegister("dC0e5", function(module, exports) {
$parcel$export(module.exports, "valueTernary", () => $7425f67f20493559$export$40fb9515c784cc3b);
function $7425f67f20493559$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

});


parcelRegister("8k7pc", function(module, exports) {
$parcel$export(module.exports, "default", () => $232bd27fd81cdbed$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $232bd27fd81cdbed$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $232bd27fd81cdbed$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $euxye.useRef)(undefined);
    const mounted = (0, $euxye.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $euxye.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $euxye.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $euxye.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $euxye.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $euxye.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $euxye.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $euxye.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $euxye.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $euxye.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $euxye.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $euxye.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $euxye.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $euxye.useCallback)((newValue, actionMeta)=>{
        const inputValue = $232bd27fd81cdbed$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("8LfFe", function(module, exports) {
$parcel$export(module.exports, "default", () => $52747f11ed96716b$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $52747f11ed96716b$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $euxye.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $euxye.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $euxye.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $euxye.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $euxye.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $euxye.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $euxye.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("c0vzW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8639ea713f9daf6b$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $8639ea713f9daf6b$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $euxye.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $euxye.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $euxye.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $e79Pd.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});




parcelRegister("kjKdI", function(module, exports) {
$parcel$export(module.exports, "formatBackendError", () => $b4bf3ca082c58923$export$8a8af50676b40846);
$parcel$export(module.exports, "validateURLField", () => $b4bf3ca082c58923$export$2ad6818b3d68393f);
$parcel$export(module.exports, "validateSupportedScopes", () => $b4bf3ca082c58923$export$7abf746ed63ce29a);

var $6jLTU = parcelRequire("6jLTU");

var $28XKx = parcelRequire("28XKx");

var $75sVW = parcelRequire("75sVW");
const $b4bf3ca082c58923$export$7cc6bb943616cddf = [
    'http:',
    'https:'
];
const $b4bf3ca082c58923$export$8a8af50676b40846 = (maybeError, fallback)=>{
    if (maybeError && (0, $75sVW.isValidationError)(maybeError)) {
        // Show the first validation error message
        if (maybeError.errors.length > 0) try {
            const firstError = maybeError.errors[0].error;
            // oxlint-disable-next-line typescript/consistent-type-assertions
            return firstError.summary || fallback;
        } catch (e) {
            return fallback;
        }
    }
    if (maybeError instanceof Error) return maybeError.message || fallback;
    return fallback;
};
const $b4bf3ca082c58923$export$2ad6818b3d68393f = (value, isRequired, checkScheme)=>{
    if (!value) return isRequired ? $b4bf3ca082c58923$export$af1e14e964849c8c.empty : undefined;
    const trimmedValue = value?.trim();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(trimmedValue) && isRequired) return $b4bf3ca082c58923$export$af1e14e964849c8c.empty;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(trimmedValue) && !(0, $28XKx.isValidUrl)(value)) return $b4bf3ca082c58923$export$af1e14e964849c8c.urlInvalid;
    if (checkScheme && !$b4bf3ca082c58923$export$7cc6bb943616cddf.some((scheme)=>value.startsWith(scheme))) return $b4bf3ca082c58923$export$af1e14e964849c8c.urlSchemeInvalid;
    return undefined;
};
const $b4bf3ca082c58923$export$7abf746ed63ce29a = (chosenScopes, supportedScopes)=>{
    const invalidScopes = chosenScopes.filter((scope)=>!supportedScopes.includes(scope));
    if (invalidScopes.length > 0) return $b4bf3ca082c58923$export$af1e14e964849c8c.unsupportedScope;
    return undefined;
};
const $b4bf3ca082c58923$export$af1e14e964849c8c = {
    empty: 'This field is required.',
    urlInvalid: 'Enter a valid URL.',
    urlSchemeInvalid: 'The URL must start with http:// or https://.',
    authTypeInvalid: 'Select a valid authentication type.',
    impersonationNotAllowed: '2LO (impersonation) is deprecated. Please choose another authentication type.',
    unsupportedScope: 'One or more selected scopes are not supported.'
};

});
parcelRegister("28XKx", function(module, exports) {
$parcel$export(module.exports, "isValidUrl", () => $08e64bf3c3a28e48$export$bef94a5618bf18bf);
$parcel$export(module.exports, "default", () => $08e64bf3c3a28e48$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $08e64bf3c3a28e48$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $08e64bf3c3a28e48$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $08e64bf3c3a28e48$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $08e64bf3c3a28e48$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $08e64bf3c3a28e48$var$stricterURLRegex.test(string) || $08e64bf3c3a28e48$var$protocolRegex.test(string);
    return $08e64bf3c3a28e48$var$URLStandardRegex.test(string);
}
var $08e64bf3c3a28e48$export$2e2bcd8739ae039 = $08e64bf3c3a28e48$export$bef94a5618bf18bf;

});


parcelRegister("8RhC5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cfd580372744a5f$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $hZDXn = parcelRequire("hZDXn");

var $1Unjk = parcelRequire("1Unjk");

var $kJKna = parcelRequire("kJKna");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $5cfd580372744a5f$var$copyTooltipHover = (0, $7eNDO.defineMessage)({
    defaultMessage: "Copy {itemToCopy}",
    id: "applinks.administration.ui.common.fields.copy-button.copy-tooltip-hover"
});
const $5cfd580372744a5f$var$copyTooltipFeedback = (0, $7eNDO.defineMessage)({
    defaultMessage: "Copied",
    id: "applinks.administration.ui.common.fields.copy-button.copy-tooltip-feedback"
});
const $5cfd580372744a5f$var$TOOLTIP_CONTENT_REFRESH_INTERVAL = 2500;
const $5cfd580372744a5f$var$CopyButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [linkCopied, setLinkCopied] = (0, $euxye.useState)(false);
    const [message, setMessage] = (0, $euxye.useState)(formatMessage($5cfd580372744a5f$var$copyTooltipHover, {
        itemToCopy: props.label
    }));
    const updateTooltip = (0, $euxye.useRef)();
    (0, $euxye.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        message
    ]);
    const copyLink = (0, $euxye.useCallback)(async ()=>{
        if (typeof globalThis !== 'undefined' && globalThis.navigator?.clipboard) try {
            await globalThis.navigator.clipboard.writeText(props.value);
            setLinkCopied(true);
            setMessage(formatMessage($5cfd580372744a5f$var$copyTooltipFeedback));
            setTimeout(()=>{
                setLinkCopied(false);
                setMessage(formatMessage($5cfd580372744a5f$var$copyTooltipHover, {
                    itemToCopy: props.label
                }));
            }, $5cfd580372744a5f$var$TOOLTIP_CONTENT_REFRESH_INTERVAL);
        } catch (error) {
        // TODO: Handle error case where clipboard write fails
        }
    }, [
        formatMessage,
        props.label,
        props.value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return message;
        },
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        appearance: "subtle",
        icon: linkCopied ? (0, (/*@__PURE__*/$parcel$interopDefault($kJKna))) : (0, (/*@__PURE__*/$parcel$interopDefault($1Unjk))),
        label: formatMessage($5cfd580372744a5f$var$copyTooltipHover, {
            itemToCopy: props.label
        }),
        isTooltipDisabled: true,
        onClick: copyLink
    }));
};
$5cfd580372744a5f$var$CopyButton.displayName = "CopyButton";
var $5cfd580372744a5f$export$2e2bcd8739ae039 = $5cfd580372744a5f$var$CopyButton;

});
parcelRegister("1Unjk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46d77f8084efb8562fee77ec5d30fd2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $163d1a70b689d0d2$var$_react = $163d1a70b689d0d2$var$_interopRequireDefault((parcelRequire("euxye")));

var $163d1a70b689d0d2$var$_baseNew = $163d1a70b689d0d2$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $163d1a70b689d0d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $163d1a70b689d0d2$var$CopyIcon = (props)=>/*#__PURE__*/ $163d1a70b689d0d2$var$_react.default.createElement($163d1a70b689d0d2$var$_baseNew.default, Object.assign({
        name: "CopyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$163d1a70b689d0d2$var$CopyIcon.displayName = 'CopyIcon';
var $163d1a70b689d0d2$var$_default = module.exports.default = $163d1a70b689d0d2$var$CopyIcon;

});



parcelRegister("aRJMv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5db588841a44d350$export$2e2bcd8739ae039);
/* CredentialsForm.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $2kZKn = parcelRequire("2kZKn");

var $hzWaA = parcelRequire("hzWaA");

var $d8bZ5 = parcelRequire("d8bZ5");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $8nfKz = parcelRequire("8nfKz");

var $fhcP0 = parcelRequire("fhcP0");

var $l7m8P = parcelRequire("l7m8P");

var $eGbwi = parcelRequire("eGbwi");
const $5db588841a44d350$var$outgoingCredentialsButtonTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Update outgoing link credentials",
    id: "applinks.administration.ui.edit.outgoing-credentials-button-text"
});
const $5db588841a44d350$var$outgoingLinkTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Outgoing link",
    id: "applinks.administration.ui.edit.outgoing-link.title"
});
const $5db588841a44d350$var$outgoingLinkDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Find these details in the external application and enter them below. You may need to ask an admin of the external application for these details.",
    id: "applinks.administration.ui.edit.outgoing-link.description"
});
const $5db588841a44d350$var$incomingLinkTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Incoming link",
    id: "applinks.administration.ui.edit.incoming-link.title"
});
const $5db588841a44d350$var$incomingLinkDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Copy these details to the external application. If you're not an admin of the application, ask an existing admin to make the updates for you.",
    id: "applinks.administration.ui.edit.incoming-link.description"
});
const $5db588841a44d350$var$goToRemoteSiteLinkMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Go to {displayUrl}",
    id: "applinks.administration.ui.edit.go-to-remote-site-link"
});
const $5db588841a44d350$var$styles = {
    growField: "_16jlkb7n",
    formSectionInner: "_19pkpxbi"
};
const $5db588841a44d350$var$OutgoingCredentialsModalButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const entryPointProps = (0, $euxye.useMemo)(()=>({
            applink: props.applink,
            onDisplayError: props.onDisplayError,
            onClose: props.onRequestStatusRefresh
        }), [
        props.applink,
        props.onDisplayError,
        props.onRequestStatusRefresh
    ]);
    return /*#__PURE__*/ $euxye.createElement((0, $8nfKz.ModalButtonTrigger), {
        testId: "applinks-administration.ui.edit.oauth2.credentials-form.outgoing-credentials-modal-button",
        name: "updateOutgoingLinkCredentials",
        entryPoint: (0, $eGbwi.outgoingCredentialsModalEntryPoint),
        entryPointProps: entryPointProps,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($d8bZ5)))
    }, formatMessage($5db588841a44d350$var$outgoingCredentialsButtonTextMessage));
};
$5db588841a44d350$var$OutgoingCredentialsModalButton.displayName = "OutgoingCredentialsModalButton";
const $5db588841a44d350$var$OutgoingScopes = (props)=>{
    if (props.oauth2ConfigInfo.isRemoteApplicationCloud) return null;
    return /*#__PURE__*/ $euxye.createElement((0, $fhcP0.RemoteApplicationScopeMultiSelect), {
        name: "remoteApplicationSupportedScopes",
        supportedScopes: props.oauth2ConfigInfo.remoteApplicationSupportedScopes || [],
        defaultSelected: props.oauth2ConfigInfo.outboundScopes?.map((scope)=>({
                label: scope,
                value: scope
            })) || []
    });
};
$5db588841a44d350$var$OutgoingScopes.displayName = "OutgoingScopes";
const $5db588841a44d350$var$CloudConnectorCredentialsForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), null, /*#__PURE__*/ $euxye.createElement((0, $2kZKn.default), {
        title: formatMessage($5db588841a44d350$var$outgoingLinkTitleMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200",
        xcss: $5db588841a44d350$var$styles.formSectionInner
    }, /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$OutgoingScopes, {
        oauth2ConfigInfo: props.oauth2ConfigInfo
    }))));
};
$5db588841a44d350$var$CloudConnectorCredentialsForm.displayName = "CloudConnectorCredentialsForm";
const $5db588841a44d350$var$StandardCredentialsForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), null, /*#__PURE__*/ $euxye.createElement((0, $2kZKn.default), {
        title: formatMessage($5db588841a44d350$var$incomingLinkTitleMessage),
        description: formatMessage($5db588841a44d350$var$incomingLinkDescriptionMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200",
        xcss: $5db588841a44d350$var$styles.formSectionInner
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.200"
    }, /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $5db588841a44d350$var$styles.growField
    }, /*#__PURE__*/ $euxye.createElement((0, $fhcP0.CopyableApplicationClientID), {
        name: "copyableApplicationClientId",
        clientId: props.oauth2ConfigInfo.inboundOAuthClientId
    })), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $5db588841a44d350$var$styles.growField
    }, /*#__PURE__*/ $euxye.createElement((0, $fhcP0.CopyableApplicationClientSecret), {
        name: "copyableApplicationClientSecret",
        clientSecret: props.oauth2ConfigInfo.inboundOAuthClientSecret
    }))))), /*#__PURE__*/ $euxye.createElement((0, $2kZKn.default), {
        title: formatMessage($5db588841a44d350$var$outgoingLinkTitleMessage),
        description: formatMessage($5db588841a44d350$var$outgoingLinkDescriptionMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200",
        xcss: $5db588841a44d350$var$styles.formSectionInner
    }, props.partiallyLinkedMode && /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200"
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.200"
    }, /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $5db588841a44d350$var$styles.growField
    }, /*#__PURE__*/ $euxye.createElement((0, $fhcP0.ApplicationClientId), {
        name: "applicationClientId"
    })), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $5db588841a44d350$var$styles.growField
    }, /*#__PURE__*/ $euxye.createElement((0, $fhcP0.ApplicationClientSecret), {
        name: "applicationClientSecret"
    })))), !props.oauth2ConfigInfo.isRemoteApplicationCloud && /*#__PURE__*/ $euxye.createElement((0, $fhcP0.RedirectUrl), {
        name: "redirectUrl",
        defaultRedirectUrl: props.oauth2ConfigInfo?.inboundRedirectUrl || ''
    }), /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$OutgoingScopes, {
        oauth2ConfigInfo: props.oauth2ConfigInfo
    }), !props.partiallyLinkedMode && /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), null, /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$OutgoingCredentialsModalButton, {
        applink: props.applink,
        onDisplayError: props.onDisplayError,
        onRequestStatusRefresh: props.onRequestStatusRefresh
    })), /*#__PURE__*/ $euxye.createElement((0, $hzWaA.default), {
        href: (0, $l7m8P.getApplinksAdminUrl)(props.applink.displayUrl, props.applink.type),
        target: "_blank"
    }, formatMessage($5db588841a44d350$var$goToRemoteSiteLinkMessage, {
        displayUrl: props.applink.displayUrl
    })))));
};
$5db588841a44d350$var$StandardCredentialsForm.displayName = "StandardCredentialsForm";
const $5db588841a44d350$var$CredentialsForm = (props)=>{
    const isCloudConnector = !!props.applink.properties?.CLOUD_CONNECTOR_PRODUCT_CONNECTION_ID;
    if (isCloudConnector) return /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$CloudConnectorCredentialsForm, {
        oauth2ConfigInfo: props.oauth2ConfigInfo
    });
    return /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$StandardCredentialsForm, props);
};
$5db588841a44d350$var$CredentialsForm.displayName = "CredentialsForm";
var $5db588841a44d350$export$2e2bcd8739ae039 = $5db588841a44d350$var$CredentialsForm;

});
parcelRegister("d8bZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63ac376f9836d1894f72051899adf679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98f551873407a443$var$_react = $98f551873407a443$var$_interopRequireDefault((parcelRequire("euxye")));

var $98f551873407a443$var$_baseNew = $98f551873407a443$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $98f551873407a443$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98f551873407a443$var$EditIcon = (props)=>/*#__PURE__*/ $98f551873407a443$var$_react.default.createElement($98f551873407a443$var$_baseNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$98f551873407a443$var$EditIcon.displayName = 'EditIcon';
var $98f551873407a443$var$_default = module.exports.default = $98f551873407a443$var$EditIcon;

});

parcelRegister("8nfKz", function(module, exports) {
$parcel$export(module.exports, "ModalButtonTrigger", () => $b0cd71e2bdf6ca70$export$156b5756ed7a09ad);

var $euxye = parcelRequire("euxye");

var $iOfms = parcelRequire("iOfms");

var $ikm5U = parcelRequire("ikm5U");
function $b0cd71e2bdf6ca70$export$156b5756ed7a09ad({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus, loadingText: loadingText, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ikm5U.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        onError: onError,
        preloadOnFocus: preloadOnFocus,
        loadingText: loadingText
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            ref: ref,
            ...buttonProps
        }, children));
}
$b0cd71e2bdf6ca70$export$156b5756ed7a09ad.displayName = "ModalButtonTrigger";

});

parcelRegister("l7m8P", function(module, exports) {
$parcel$export(module.exports, "STATUS_RECIPROCAL_SUCCESS", () => $9359cac0ee435131$export$657b6c684cdb0f25);
$parcel$export(module.exports, "STATUS_RECIPROCAL_INPROGRESS", () => $9359cac0ee435131$export$ebb855fc01c4dac8);
$parcel$export(module.exports, "updateStatusLog", () => $9359cac0ee435131$export$9f0778ce9e00d11);
$parcel$export(module.exports, "getApplinksAdminUrl", () => $9359cac0ee435131$export$78ab2fbb731a208e);
$parcel$export(module.exports, "getDefaultCreationState", () => $9359cac0ee435131$export$c97322013e85b0a3);
$parcel$export(module.exports, "generateApplinksCreationRedirectionUrl", () => $9359cac0ee435131$export$a227964e32a1613e);
$parcel$export(module.exports, "parseCreationStateFromUrl", () => $9359cac0ee435131$export$a3c0d7af5d0c8b3);
// The Applinks Status Log format
// We use this to interchange between the various products
// Refer to `AppLinks.Creation.generateApplinksCreationRedirectionUrl` in
// legacy frontend for more details

var $1b6Nh = parcelRequire("1b6Nh");
const $9359cac0ee435131$export$83a5ccd32faf0509 = 'completed.creation';
const $9359cac0ee435131$export$46ec94e31f2d2bee = 'failed.creation';
const $9359cac0ee435131$export$9c895fb851e899e2 = 'inprogress.creation';
const $9359cac0ee435131$export$4ef4887476a06719 = 'completed.creation.local';
const $9359cac0ee435131$export$657b6c684cdb0f25 = 'completed.creation.reciprocal';
const $9359cac0ee435131$export$ebb855fc01c4dac8 = 'inprogress.creation.reciprocal';
const $9359cac0ee435131$export$a5b9f0b29d12c743 = 'failed.creation.local';
const $9359cac0ee435131$export$151e8c78ee009a44 = 'failed.creation.reciprocal';
const $9359cac0ee435131$export$ce29b766ff657ea1 = 'failed.registerprovider.2loi';
const $9359cac0ee435131$export$a38352a15fd9f0ce = (entries)=>{
    return entries;
};
const $9359cac0ee435131$export$9f0778ce9e00d11 = (statusLog, newEntry)=>{
    return [
        ...statusLog,
        newEntry
    ];
};
const $9359cac0ee435131$export$78ab2fbb731a208e = (remoteBaseUrl, typeId)=>{
    const suffix = typeId === 'confluence' ? '/admin/listapplicationlinks.action' : (0, $1b6Nh.APPLINKS_LIST_PAGE_URL_LEGACY);
    return remoteBaseUrl + suffix;
};
const $9359cac0ee435131$export$c97322013e85b0a3 = (startingUrl, startingTypeId, originalCreatedId)=>{
    return {
        applinkCreationStatusLog: $9359cac0ee435131$export$a38352a15fd9f0ce([
            {
                status: $9359cac0ee435131$export$9c895fb851e899e2
            },
            {
                status: $9359cac0ee435131$export$4ef4887476a06719
            },
            {
                status: $9359cac0ee435131$export$ebb855fc01c4dac8
            }
        ]),
        applinkOriginalCreatedId: originalCreatedId,
        sharedUserbase: false,
        applinkConfigInUserAuth: true,
        applinkConfigInServerAuth: true,
        applinkConfigInPreAuth: true,
        applinkConfigOutUserAuth: true,
        applinkConfigOutServerAuth: true,
        applinkConfigOutPreAuth: true,
        applinkStartingUrl: startingUrl,
        applinkStartingType: startingTypeId,
        creatingReciprocal: true
    };
};
const $9359cac0ee435131$var$generateUrl = (remoteUrl, parametersMap)=>{
    if (!parametersMap || Object.keys(parametersMap).length === 0) return remoteUrl;
    const params = Object.entries(parametersMap).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    return remoteUrl.includes('?') ? `${remoteUrl}&${params}` : `${remoteUrl}?${params}`;
};
const $9359cac0ee435131$export$a227964e32a1613e = (remoteBaseUrl, remoteTypeId, creationState)=>{
    // In the original applinks frontend, the status log was stored as a string. This means in the final URL,
    // the status log is double stringified. This is a hack to maintain compatibility with the legacy frontend.
    const parameterMap = Object.fromEntries(Object.entries(creationState).map(([key, value])=>{
        if (key === 'applinkCreationStatusLog') // Yes, I know it's awful
        return [
            key,
            JSON.stringify(JSON.stringify(creationState.applinkCreationStatusLog))
        ];
        return [
            key,
            JSON.stringify(value)
        ];
    }));
    return $9359cac0ee435131$var$generateUrl($9359cac0ee435131$export$78ab2fbb731a208e(remoteBaseUrl, remoteTypeId), parameterMap);
};
const $9359cac0ee435131$var$getAndDecode = (url, param)=>{
    const value = url.searchParams.get(param);
    if (value !== null) {
        const decodedFieldValue = decodeURIComponent(value);
        try {
            // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
            return value ? JSON.parse(decodedFieldValue) : null;
        } catch  {
            // If parsing fails, we return the decoded value as-is
            return decodedFieldValue;
        }
    }
    return undefined;
};
const $9359cac0ee435131$export$a3c0d7af5d0c8b3 = (url)=>{
    const applinkCreationStatusLog = $9359cac0ee435131$var$getAndDecode(url, 'applinkCreationStatusLog');
    if (!applinkCreationStatusLog) return null; // No creation state found
    const applinkStartingUrl = $9359cac0ee435131$var$getAndDecode(url, 'applinkStartingUrl');
    const applinkStartingType = $9359cac0ee435131$var$getAndDecode(url, 'applinkStartingType');
    const applinkOriginalCreatedId = $9359cac0ee435131$var$getAndDecode(url, 'applinkOriginalCreatedId');
    const sharedUserbase = $9359cac0ee435131$var$getAndDecode(url, 'sharedUserbase') === 'true';
    const applinkConfigInUserAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigInUserAuth') === 'true';
    const applinkConfigInServerAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigInServerAuth') === 'true';
    const applinkConfigInPreAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigInPreAuth') === 'true';
    const applinkConfigOutUserAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigOutUserAuth') === 'true';
    const applinkConfigOutServerAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigOutServerAuth') === 'true';
    const applinkConfigOutPreAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigOutPreAuth') === 'true';
    const creatingReciprocal = $9359cac0ee435131$var$getAndDecode(url, 'creatingReciprocal') === 'true';
    const statusLog = JSON.parse(applinkCreationStatusLog);
    return {
        applinkCreationStatusLog: statusLog,
        applinkOriginalCreatedId: applinkOriginalCreatedId || '',
        sharedUserbase: sharedUserbase,
        applinkConfigInUserAuth: applinkConfigInUserAuth,
        applinkConfigInServerAuth: applinkConfigInServerAuth,
        applinkConfigInPreAuth: applinkConfigInPreAuth,
        applinkConfigOutUserAuth: applinkConfigOutUserAuth,
        applinkConfigOutServerAuth: applinkConfigOutServerAuth,
        applinkConfigOutPreAuth: applinkConfigOutPreAuth,
        applinkStartingUrl: applinkStartingUrl || '',
        applinkStartingType: applinkStartingType || '',
        creatingReciprocal: creatingReciprocal
    };
};

});

parcelRegister("eGbwi", function(module, exports) {
$parcel$export(module.exports, "outgoingCredentialsModalEntryPoint", () => $fe2f911d045dd4f3$export$3db8bdfccb0f1ca5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $fe2f911d045dd4f3$export$3db8bdfccb0f1ca5 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8XzsZ")), {
        moduleId: "5a92c865",
        moduleName: "OutgoingCredentialsModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8XzsZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5P8vn").then(()=>parcelRequire('a8FCq'));

});




parcelRegister("1gtXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $7670dd211d2cec3f$export$2e2bcd8739ae039);
/* ApplinksOAuth1EditPageContents.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $fWb5q = parcelRequire("fWb5q");

var $hiKld = parcelRequire("hiKld");

var $2kZKn = parcelRequire("2kZKn");

var $1W2Av = parcelRequire("1W2Av");

var $iY9aj = parcelRequire("iY9aj");

var $ezcIL = parcelRequire("ezcIL");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $9ufM9 = parcelRequire("9ufM9");

var $baIdH = parcelRequire("baIdH");

var $hzWaA = parcelRequire("hzWaA");

var $abhF2 = parcelRequire("abhF2");

var $hZDXn = parcelRequire("hZDXn");

var $aybNy = parcelRequire("aybNy");

var $i860n = parcelRequire("i860n");

var $55BnK = parcelRequire("55BnK");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $6CfY5 = parcelRequire("6CfY5");

var $fhcP0 = parcelRequire("fhcP0");

var $1b6Nh = parcelRequire("1b6Nh");

var $drATu = parcelRequire("drATu");

var $5T7Xn = parcelRequire("5T7Xn");

var $l7m8P = parcelRequire("l7m8P");

var $iTHno = parcelRequire("iTHno");

var $kjKdI = parcelRequire("kjKdI");

var $kEAND = parcelRequire("kEAND");

var $dxnrJ = parcelRequire("dxnrJ");

var $92zRd = parcelRequire("92zRd");

var $6hqMt = parcelRequire("6hqMt");

var $6U0WK = parcelRequire("6U0WK");

var $9i24S = parcelRequire("9i24S");
const $7670dd211d2cec3f$var$Arrows = {
    incoming: {
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($kEAND))),
        match: (0, (/*@__PURE__*/$parcel$interopDefault($dxnrJ))),
        mismatch: (0, (/*@__PURE__*/$parcel$interopDefault($92zRd)))
    },
    outgoing: {
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($6hqMt))),
        match: (0, (/*@__PURE__*/$parcel$interopDefault($6U0WK))),
        mismatch: (0, (/*@__PURE__*/$parcel$interopDefault($9i24S)))
    }
};
const $7670dd211d2cec3f$var$arrowDisabledHoverTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Authentication is disabled",
    id: "applinks.administration.ui.edit.arrow-disabled-alt-text"
});
const $7670dd211d2cec3f$var$arrowMatchHoverTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Authentication is enabled",
    id: "applinks.administration.ui.edit.arrow-match-alt-text"
});
const $7670dd211d2cec3f$var$arrowMismatchHoverTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Authentication is mismatched between local and remote",
    id: "applinks.administration.ui.edit.arrow-mismatch-alt-text"
});
const $7670dd211d2cec3f$var$authTableRowDirectionIncomingMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Incoming",
    id: "applinks.administration.ui.edit.direction-incoming"
});
const $7670dd211d2cec3f$var$authTableRowDirectionOutgoingMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Outgoing",
    id: "applinks.administration.ui.edit.direction-outgoing"
});
const $7670dd211d2cec3f$var$authTableColumnDirectionHeadingMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Direction",
    id: "applinks.administration.ui.edit.direction-heading"
});
const $7670dd211d2cec3f$var$authTableColumnLocalAuthenticationHeadingMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Local authentication",
    id: "applinks.administration.ui.edit.local-authentication-heading"
});
const $7670dd211d2cec3f$var$authTableColumnRemoteAuthenticationHeadingMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Remote authentication",
    id: "applinks.administration.ui.edit.remote-authentication-heading"
});
const $7670dd211d2cec3f$var$impersonationRemovedTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "OAuth with impersonation is not supported",
    id: "applinks.administration.ui.edit.impersonation-removed-title"
});
const $7670dd211d2cec3f$var$impersonationRemovedDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Support for OAuth with impersonation <link>has been removed</link>. Please select a different authentication method.",
    id: "applinks.administration.ui.edit.impersonation-removed-description"
});
const $7670dd211d2cec3f$var$unsupportedAuthenticationTypeMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Invalid authentication type \"{invalidAuthType}\" used. Please select a different authentication method.",
    id: "applinks.administration.ui.edit.unsupported-authentication-type"
});
const $7670dd211d2cec3f$var$linkDetailsSectionHeadingMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Link details",
    id: "applinks.administration.ui.edit.link-details-section-heading"
});
const $7670dd211d2cec3f$var$connectionsTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connections",
    id: "applinks.administration.ui.edit.connections-section-header"
});
const $7670dd211d2cec3f$var$goToRemoteSiteLinkMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Go to {displayUrl}",
    id: "applinks.administration.ui.edit.go-to-remote-site-link"
});
const $7670dd211d2cec3f$var$applinkStatusLoadingTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Loading application link status",
    id: "applinks.administration.ui.edit.applink-status-loading-text"
});
const $7670dd211d2cec3f$var$formCancelButtonTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Cancel",
    id: "applinks.administration.ui.edit.form-cancel-button-text"
});
const $7670dd211d2cec3f$var$formSaveButtonTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Save",
    id: "applinks.administration.ui.edit.form-save-button-text"
});
const $7670dd211d2cec3f$var$authTypeImpersonationMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-impersonation",
    defaultMessage: "OAuth with impersonation"
});
const $7670dd211d2cec3f$var$authTypeDisabledMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-disabled",
    defaultMessage: "Disabled"
});
const $7670dd211d2cec3f$var$authTypeUnknownMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-unknown",
    defaultMessage: "Unknown"
});
const $7670dd211d2cec3f$var$unknownErrorTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We encountered an unknown error.",
    id: "applinks.administration.ui.unknown-error"
});
const $7670dd211d2cec3f$export$ff9fb46b9505cd2c = [
    (0, $iTHno.AUTH_OAUTH1),
    (0, $iTHno.AUTH_OAUTH1_IMPERSONATION),
    (0, $iTHno.AUTH_DISABLED)
];
const $7670dd211d2cec3f$var$styles = {
    growField: "_16jlkb7n",
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _19pkpxbi",
    formSectionInner: "_19pkpxbi",
    fieldNegativeMargin: "_19pkx0bf",
    colDirection: "_1bsbx19p",
    colOutgoing: "_1bsbhwvj",
    colIncoming: "_1bsbhwvj"
};
const $7670dd211d2cec3f$export$dd490e8ff53d5bdc = (localAuthLevel, remoteAuthLevel)=>{
    if (!localAuthLevel || !remoteAuthLevel) return 'mismatch';
    if (localAuthLevel === remoteAuthLevel) {
        if (localAuthLevel === (0, $iTHno.AUTH_DISABLED)) return 'disabled';
        return 'match';
    }
    return 'mismatch';
};
const $7670dd211d2cec3f$var$ApplinksConnectedArrow = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const formatAltText = (0, $euxye.useCallback)(()=>{
        switch(props.state){
            case 'match':
                return formatMessage($7670dd211d2cec3f$var$arrowMatchHoverTextMessage);
            case 'mismatch':
                return formatMessage($7670dd211d2cec3f$var$arrowMismatchHoverTextMessage);
            case 'disabled':
            default:
                return formatMessage($7670dd211d2cec3f$var$arrowDisabledHoverTextMessage);
        }
    }, [
        formatMessage,
        props.state
    ]); // Render the appropriate arrow icon based on the connection state
    return props.isIncoming ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: formatAltText()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("img", {
        height: "16px",
        src: $7670dd211d2cec3f$var$Arrows.incoming[props.state],
        alt: formatAltText()
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: formatAltText()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("img", {
        height: "16px",
        src: $7670dd211d2cec3f$var$Arrows.outgoing[props.state],
        alt: formatAltText()
    }));
};
$7670dd211d2cec3f$var$ApplinksConnectedArrow.displayName = "ApplinksConnectedArrow";
const $7670dd211d2cec3f$var$buildLocalisedAuthTypes = (formatMessage, selectableOnly)=>{
    const oauthLabel = 'OAuth';
    const impersonationLabel = formatMessage($7670dd211d2cec3f$var$authTypeImpersonationMessage);
    const disabledLabel = formatMessage($7670dd211d2cec3f$var$authTypeDisabledMessage);
    const oauth2Label = 'OAuth 2.0';
    if (selectableOnly) return [
        {
            label: oauthLabel,
            value: (0, $iTHno.AUTH_OAUTH1)
        },
        {
            label: disabledLabel,
            value: (0, $iTHno.AUTH_DISABLED)
        }
    ];
    return [
        {
            label: oauthLabel,
            value: (0, $iTHno.AUTH_OAUTH1)
        },
        {
            label: impersonationLabel,
            value: (0, $iTHno.AUTH_OAUTH1_IMPERSONATION)
        },
        {
            label: disabledLabel,
            value: (0, $iTHno.AUTH_DISABLED)
        },
        {
            label: oauth2Label,
            value: (0, $iTHno.AUTH_OAUTH2)
        }
    ];
};
const $7670dd211d2cec3f$var$LocalAuthDetails = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getAuthOptions = (0, $euxye.useCallback)(()=>{
        return $7670dd211d2cec3f$var$buildLocalisedAuthTypes(formatMessage, true);
    }, [
        formatMessage
    ]);
    const getDefaultOption = (0, $euxye.useCallback)(()=>{
        const options = $7670dd211d2cec3f$var$buildLocalisedAuthTypes(formatMessage);
        const authLevel = (0, $iTHno.getAuthLevel)(props.defaultOAuthConfig);
        return options.find((option)=>option.value === authLevel) || options[0];
    }, [
        formatMessage,
        props.defaultOAuthConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $7670dd211d2cec3f$var$styles.growField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $7670dd211d2cec3f$var$styles.fieldNegativeMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: getDefaultOption()
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $baIdH.default), {
            testId: `applinks-administration.ui.edit.oauth1.local-auth-select.${props.isIncoming ? 'incoming' : 'outgoing'}`,
            ...fieldProps,
            inputId: props.name,
            options: getAuthOptions()
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7670dd211d2cec3f$var$ApplinksConnectedArrow, {
        isIncoming: props.isIncoming,
        state: props.state
    }));
};
$7670dd211d2cec3f$var$LocalAuthDetails.displayName = "LocalAuthDetails";
const $7670dd211d2cec3f$var$RemoteAuthDetails = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getAuthDescription = (0, $euxye.useCallback)(()=>{
        const options = $7670dd211d2cec3f$var$buildLocalisedAuthTypes(formatMessage);
        const authLevel = (0, $iTHno.getAuthLevel)(props.oauthConfig);
        return options.find((option)=>option.value === authLevel);
    }, [
        formatMessage,
        props.oauthConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.100"
    }, props.type.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
        appearance: "subtle",
        href: props.url
    }, props.type.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, getAuthDescription()?.label ?? formatMessage($7670dd211d2cec3f$var$authTypeUnknownMessage)));
};
$7670dd211d2cec3f$var$RemoteAuthDetails.displayName = "RemoteAuthDetails";
const $7670dd211d2cec3f$var$ConfigureAuthTable = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const formState = (0, $iY9aj.useFormState)({
        values: true
    });
    const getApplinkType = (0, $euxye.useCallback)(()=>{
        return (0, $5T7Xn.lookupTypeFromV3Data)(props.applink);
    }, [
        props.applink
    ]);
    const getOutgoingMatchState = (0, $euxye.useCallback)(()=>{
        return $7670dd211d2cec3f$export$dd490e8ff53d5bdc(formState?.values.outgoingAuth?.value ?? undefined, (0, $iTHno.getAuthLevel)(props.remoteAuth?.incoming));
    }, [
        props.remoteAuth,
        formState?.values.outgoingAuth
    ]);
    const getIncomingMatchState = (0, $euxye.useCallback)(()=>{
        return $7670dd211d2cec3f$export$dd490e8ff53d5bdc(formState?.values.incomingAuth?.value ?? undefined, (0, $iTHno.getAuthLevel)(props.remoteAuth?.outgoing));
    }, [
        props.remoteAuth,
        formState?.values.incomingAuth
    ]);
    const showOAuthImpersonationError = (0, $euxye.useCallback)(()=>{
        const isLocalAuthImpersonation = formState?.values.incomingAuth?.value === (0, $iTHno.AUTH_OAUTH1_IMPERSONATION);
        const isRemoteAuthImpersonation = formState?.values.outgoingAuth?.value === (0, $iTHno.AUTH_OAUTH1_IMPERSONATION);
        if (isLocalAuthImpersonation || isRemoteAuthImpersonation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aybNy.default), {
            title: formatMessage($7670dd211d2cec3f$var$impersonationRemovedTitleMessage),
            appearance: "error"
        }, formatMessage($7670dd211d2cec3f$var$impersonationRemovedDescriptionMessage, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                    href: "https://confluence.atlassian.com/jirakb/end-of-support-for-2loi-application-links-950806698.html",
                    target: "_blank"
                }, chunks)
        }));
        return null;
    }, [
        formState?.values.incomingAuth?.value,
        formState?.values.outgoingAuth?.value,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, showOAuthImpersonationError(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("colgroup", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("col", {
        className: (0, $4jQY2.default)([
            $7670dd211d2cec3f$var$styles.colDirection
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("col", {
        className: (0, $4jQY2.default)([
            $7670dd211d2cec3f$var$styles.colOutgoing
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("col", {
        className: (0, $4jQY2.default)([
            $7670dd211d2cec3f$var$styles.colIncoming
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("th", null, formatMessage($7670dd211d2cec3f$var$authTableColumnDirectionHeadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("th", null, formatMessage($7670dd211d2cec3f$var$authTableColumnLocalAuthenticationHeadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("th", null, formatMessage($7670dd211d2cec3f$var$authTableColumnRemoteAuthenticationHeadingMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ezcIL.Label), {
        htmlFor: "outgoingAuth"
    }, formatMessage($7670dd211d2cec3f$var$authTableRowDirectionOutgoingMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7670dd211d2cec3f$var$LocalAuthDetails, {
        isIncoming: false,
        state: getOutgoingMatchState(),
        name: "outgoingAuth",
        defaultOAuthConfig: props.localAuth?.outgoing
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7670dd211d2cec3f$var$RemoteAuthDetails, {
        type: getApplinkType(),
        url: props.applink.displayUrl,
        oauthConfig: props.remoteAuth?.incoming
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ezcIL.Label), {
        htmlFor: "incomingAuth"
    }, formatMessage($7670dd211d2cec3f$var$authTableRowDirectionIncomingMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7670dd211d2cec3f$var$LocalAuthDetails, {
        isIncoming: true,
        state: getIncomingMatchState(),
        name: "incomingAuth",
        defaultOAuthConfig: props.localAuth?.incoming
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7670dd211d2cec3f$var$RemoteAuthDetails, {
        type: getApplinkType(),
        url: props.applink.displayUrl,
        oauthConfig: props.remoteAuth?.outgoing
    }))))));
};
$7670dd211d2cec3f$var$ConfigureAuthTable.displayName = "ConfigureAuthTable";
const $7670dd211d2cec3f$var$buildOAuthConfigFromOption = (option)=>{
    if (option?.value === (0, $iTHno.AUTH_OAUTH1)) return {
        enabled: true,
        twoLoEnabled: true,
        twoLoImpersonationEnabled: false,
        oAuth2ThreeLoEnabled: false
    };
    if (option?.value === (0, $iTHno.AUTH_OAUTH1_IMPERSONATION)) return {
        enabled: true,
        twoLoEnabled: true,
        twoLoImpersonationEnabled: true,
        oAuth2ThreeLoEnabled: false
    };
    return {
        enabled: false,
        twoLoEnabled: false,
        twoLoImpersonationEnabled: false,
        oAuth2ThreeLoEnabled: false
    };
};
const $7670dd211d2cec3f$var$ApplinksOAuth1EditPageContents = (props)=>{
    const { push: push } = (0, $55BnK.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getListPageUrl = (0, $euxye.useCallback)(()=>{
        if ((0, $i860n.fg)('applinks-933-experimental-list-page')) return 0, $1b6Nh.APPLINKS_LIST_PAGE_URL;
        return 0, $1b6Nh.APPLINKS_LIST_PAGE_URL_LEGACY;
    }, []);
    const onFormSubmit = (0, $euxye.useCallback)(async (data)=>{
        try {
            const supportedAuthTypes = $7670dd211d2cec3f$var$buildLocalisedAuthTypes(formatMessage, true);
            const isOutgoingAuthSupported = supportedAuthTypes.some((type)=>type.value === data.outgoingAuth?.value);
            const isIncomingAuthSupported = supportedAuthTypes.some((type)=>type.value === data.incomingAuth?.value);
            if (!isOutgoingAuthSupported) throw new Error(formatMessage($7670dd211d2cec3f$var$unsupportedAuthenticationTypeMessage, {
                invalidAuthType: data.outgoingAuth?.label
            }));
            if (!isIncomingAuthSupported) throw new Error(formatMessage($7670dd211d2cec3f$var$unsupportedAuthenticationTypeMessage, {
                invalidAuthType: data.incomingAuth?.label
            }));
            const applinkUpdate = {
                id: props.applink.id,
                type: props.applink.type,
                system: props.applink.system,
                primary: props.applink.primary,
                isExtraAuthRequired: props.applink.isExtraAuthRequired,
                // Only change these properties:
                name: data.displayName,
                displayUrl: data.displayUrl,
                rpcUrl: data.rpcUrl
            };
            await (0, $drATu.updateApplinkV3)(props.applink.id, applinkUpdate);
            await (0, $drATu.putApplinkOAuth1Config)(props.applink.id, {
                outgoing: $7670dd211d2cec3f$var$buildOAuthConfigFromOption(data.outgoingAuth),
                incoming: $7670dd211d2cec3f$var$buildOAuthConfigFromOption(data.incomingAuth)
            });
            await push(getListPageUrl());
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.edit.oauth1.submitEditForm', 'Failed to update OAuth 1.0 applink', maybeError);
            if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onDisplayError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($7670dd211d2cec3f$var$unknownErrorTextMessage)));
            else props.onDisplayError(maybeError ? maybeError.message : formatMessage($7670dd211d2cec3f$var$unknownErrorTextMessage));
            return err;
        }
    }, [
        formatMessage,
        getListPageUrl,
        props,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.default), {
            title: formatMessage($7670dd211d2cec3f$var$linkDetailsSectionHeadingMessage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.200",
            xcss: $7670dd211d2cec3f$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fhcP0.DisplayName), {
            name: "displayName",
            defaultName: props.applink.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fhcP0.DisplayUrl), {
            name: "displayUrl",
            defaultUrl: props.applink.displayUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fhcP0.ApplicationUrl), {
            name: "rpcUrl",
            defaultUrl: props.applink.rpcUrl,
            disabled: false
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("hr", {
            role: "presentation",
            className: (0, $4jQY2.default)([
                $7670dd211d2cec3f$var$styles.dividerStyle
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.default), {
            title: formatMessage($7670dd211d2cec3f$var$connectionsTitleMessage)
        }, props.status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.200",
            xcss: $7670dd211d2cec3f$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7670dd211d2cec3f$var$ConfigureAuthTable, {
            applink: props.applink,
            localAuth: props.status.localAuthentication,
            remoteAuth: props.status.remoteAuthentication
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
            href: (0, $l7m8P.getApplinksAdminUrl)(props.applink.displayUrl, props.applink.type),
            target: "_blank"
        }, formatMessage($7670dd211d2cec3f$var$goToRemoteSiteLinkMessage, {
            displayUrl: props.applink.displayUrl
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
            space: "space.200",
            xcss: $7670dd211d2cec3f$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($7670dd211d2cec3f$var$applinkStatusLoadingTextMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hiKld.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
            href: getListPageUrl(),
            appearance: "subtle"
        }, formatMessage($7670dd211d2cec3f$var$formCancelButtonTextMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            testId: "applinks-administration.ui.edit.oauth1.submit-button",
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, formatMessage($7670dd211d2cec3f$var$formSaveButtonTextMessage))))))));
};
$7670dd211d2cec3f$var$ApplinksOAuth1EditPageContents.displayName = "ApplinksOAuth1EditPageContents";
var $7670dd211d2cec3f$export$2e2bcd8739ae039 = $7670dd211d2cec3f$var$ApplinksOAuth1EditPageContents;

});
parcelRegister("iY9aj", function(module, exports) {
$parcel$export(module.exports, "useFormState", () => $2a6e5a3979297f0f$export$606f11b2eb45ecc6);

var $euxye = parcelRequire("euxye");

var $edeJn = parcelRequire("edeJn");
// Constantized to avoid a new object reference built every call
const $2a6e5a3979297f0f$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $2a6e5a3979297f0f$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $2a6e5a3979297f0f$export$606f11b2eb45ecc6 = (subscriptionConfig = $2a6e5a3979297f0f$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $euxye.useContext)((0, $edeJn.FormContext));
    const [state, setState] = (0, $euxye.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $euxye.useMemo)(()=>$2a6e5a3979297f0f$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $euxye.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("kEAND", function(module, exports) {
module.exports = new URL("arrow-left-disabled.e64b3d04.svg", import.meta.url).toString();

});

parcelRegister("dxnrJ", function(module, exports) {
module.exports = new URL("arrow-left-match.5ea6990b.svg", import.meta.url).toString();

});

parcelRegister("92zRd", function(module, exports) {
module.exports = new URL("arrow-left-mismatch.14c5dc32.svg", import.meta.url).toString();

});

parcelRegister("6hqMt", function(module, exports) {
module.exports = new URL("arrow-right-disabled.4aa73a65.svg", import.meta.url).toString();

});

parcelRegister("6U0WK", function(module, exports) {
module.exports = new URL("arrow-right-match.0de9f50b.svg", import.meta.url).toString();

});

parcelRegister("9i24S", function(module, exports) {
module.exports = new URL("arrow-right-mismatch.65202d42.svg", import.meta.url).toString();

});





parcelRegister("80mKf", function(module, exports) {
$parcel$export(module.exports, "applinksAdministrationEditRoute", () => $5b4ec1fb1ca2d370$export$25e5ee53e818565e);
const $5b4ec1fb1ca2d370$export$25e5ee53e818565e = {
    name: 'global-settings-products-applinks-administration-edit',
    path: '/jira/settings/applinks/:applinkId/edit',
    exact: true
};

});


parcelRegister("f1v24", function(module, exports) {
$parcel$export(module.exports, "applinksAdministrationListRouteEntry", () => $a8d6f298b448a697$export$3303093eb593ff88);



var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $35eqr = parcelRequire("35eqr");

var $7jRVq = parcelRequire("7jRVq");

var $hDtld = parcelRequire("hDtld");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");
const $a8d6f298b448a697$export$3303093eb593ff88 = (0, $fdS54.createEntry)((0, $hDtld.applinksAdministrationListRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-administration',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7jRVq.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7jRVq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7a63004a475864e$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $7xLLk = parcelRequire("7xLLk");

var $f99wD = parcelRequire("f99wD");

var $gDdYI = parcelRequire("gDdYI");

var $4OR4r = parcelRequire("4OR4r");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $e7a63004a475864e$var$ListPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "applinks-administration-list-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7xLLk.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4OR4r.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStatePageReady), null)));
$e7a63004a475864e$var$ListPage.displayName = "ListPage";
var $e7a63004a475864e$export$2e2bcd8739ae039 = $e7a63004a475864e$var$ListPage;

});
parcelRegister("4OR4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d1009beac787c2f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $e2Tle = parcelRequire("e2Tle");

var $6CfY5 = parcelRequire("6CfY5");

var $drATu = parcelRequire("drATu");

var $9BQM0 = parcelRequire("9BQM0");
const $1d1009beac787c2f$export$c2248d8896966a26 = ()=>{
    const [applinks, setApplinks] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        (0, $drATu.fetchApplinks)().then((data)=>{
            setApplinks(data);
        }).catch((err)=>{
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.loadApplinks', 'Failed to load applinks for the list page', maybeError);
            setApplinks(null);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9BQM0.default), {
        applinks: applinks
    });
};
$1d1009beac787c2f$export$c2248d8896966a26.displayName = "ApplinksPage";
const $1d1009beac787c2f$var$List = (0, $e2Tle.withRouter)($1d1009beac787c2f$export$c2248d8896966a26);
var $1d1009beac787c2f$export$2e2bcd8739ae039 = $1d1009beac787c2f$var$List;

});
parcelRegister("9BQM0", function(module, exports) {
$parcel$export(module.exports, "default", () => $901fd6b1d89aab5c$export$2e2bcd8739ae039);
/* ApplinksPageContents.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $h8QGu = parcelRequire("h8QGu");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $abhF2 = parcelRequire("abhF2");

var $i860n = parcelRequire("i860n");

var $2ffUK = parcelRequire("2ffUK");
var $55BnK = parcelRequire("55BnK");

var $drATu = parcelRequire("drATu");

var $l7m8P = parcelRequire("l7m8P");

var $1b6Nh = parcelRequire("1b6Nh");

var $38r1t = parcelRequire("38r1t");

var $jpNu4 = parcelRequire("jpNu4");

var $5Ol6o = parcelRequire("5Ol6o");

var $aKKFI = parcelRequire("aKKFI");
const $901fd6b1d89aab5c$var$styles = {
    applinksPageContents: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $901fd6b1d89aab5c$var$getOperationFromCreationState = (creationState)=>{
    if (!creationState) return 'operation-list-applinks';
    const statusLog = creationState.applinkCreationStatusLog;
    if (statusLog.filter((entry)=>entry.status === (0, $l7m8P.STATUS_RECIPROCAL_SUCCESS)).length > 0) return 'operation-oauth1-complete-link';
    if (statusLog.filter((entry)=>entry.status === (0, $l7m8P.STATUS_RECIPROCAL_INPROGRESS)).length > 0) return 'operation-oauth1-reciprocal';
    return 'operation-list-applinks';
};
const $901fd6b1d89aab5c$var$PartialApplinksPageContents = ()=>{
    const { push: push } = (0, $55BnK.useRouterActions)();
    const [oauth2RemoteApplicationUrl, _] = (0, $2ffUK.useQueryParam)('oauth2RemoteApplication');
    const [localApplinkManifest, setLocalApplinkManifest] = (0, $euxye.useState)(null);
    const [remoteApplinkManifest, setRemoteApplinkManifest] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        if (oauth2RemoteApplicationUrl) {
            (0, $drATu.fetchApplinkManifestForUrl)(oauth2RemoteApplicationUrl).then((remoteManifest)=>{
                setRemoteApplinkManifest(remoteManifest);
            });
            (0, $drATu.fetchThisManifest)().then((localManifest)=>{
                setLocalApplinkManifest(localManifest);
            });
        }
    }, [
        oauth2RemoteApplicationUrl
    ]);
    const redirectBackToLegacyListPage = (0, $euxye.useCallback)(()=>{
        push((0, $1b6Nh.APPLINKS_LIST_PAGE_URL_LEGACY));
    }, [
        push
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!oauth2RemoteApplicationUrl) redirectBackToLegacyListPage();
    }, [
        oauth2RemoteApplicationUrl,
        redirectBackToLegacyListPage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "applinks-administration-partial-page",
        teamName: "olympus",
        packageName: "applinksAdministrationPartialPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $901fd6b1d89aab5c$var$styles.applinksPageContents
    }, localApplinkManifest && remoteApplinkManifest && oauth2RemoteApplicationUrl !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Ol6o.CreateFlowDialog), {
        isOpen: true,
        onExit: redirectBackToLegacyListPage,
        startingStage: {
            kind: 'review',
            variant: 'OAUTH2.0',
            localManifest: localApplinkManifest,
            remoteManifest: remoteApplinkManifest,
            rpcUrl: oauth2RemoteApplicationUrl
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        interactionName: "load",
        label: "Loading"
    })));
};
$901fd6b1d89aab5c$var$PartialApplinksPageContents.displayName = "PartialApplinksPageContents";
const $901fd6b1d89aab5c$var$FullApplinksPageContents = (props)=>{
    const [createLinkDrawerOpen, setCreateLinkDrawerOpen] = (0, $euxye.useState)(false);
    const [creationState] = (0, $euxye.useState)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = new URL(window.location.href);
        return (0, $l7m8P.parseCreationStateFromUrl)(url);
    });
    const [operation, setOperation] = (0, $euxye.useState)('operation-list-applinks');
    const [thisApplicationManifest, setThisApplicationManifest] = (0, $euxye.useState)(null);
    const [targetApplicationManifest, setTargetApplicationManifest] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        const op = $901fd6b1d89aab5c$var$getOperationFromCreationState(creationState);
        setOperation(op);
    }, [
        creationState
    ]);
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (creationState) {
            // We expect to always have an applinkStartingUrl in the creation state for reciprocal review
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
            if (operation === 'operation-oauth1-reciprocal' && creationState.applinkStartingUrl) {
                (0, $drATu.fetchApplinkManifestForUrl)(creationState.applinkStartingUrl).then((remoteManifest)=>{
                    setTargetApplicationManifest(remoteManifest);
                });
                (0, $drATu.fetchThisManifest)().then((localManifest)=>{
                    setThisApplicationManifest(localManifest);
                });
            }
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
            if (operation === 'operation-oauth1-complete-link') // eslint-disable-next-line react-you-might-not-need-an-effect/no-chain-state-updates
            setCreateLinkDrawerOpen(true);
        }
    }, [
        creationState,
        operation
    ]);
    const [filter, setFilter] = (0, $euxye.useState)(null);
    const [search, setSearch] = (0, $euxye.useState)('');
    const closeDrawer = ()=>{
        setCreateLinkDrawerOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "applinks-administration-list-page",
        teamName: "olympus",
        packageName: "applinksAdministrationListPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $901fd6b1d89aab5c$var$styles.applinksPageContents
    }, operation === 'operation-list-applinks' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpNu4.default), {
        onSearch: setSearch,
        onFilterChange: setFilter,
        onCreateLink: ()=>setCreateLinkDrawerOpen(true),
        filter: filter,
        search: search
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $38r1t.default), {
        applinks: props.applinks,
        filter: filter,
        search: search
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Ol6o.CreateFlowDialog), {
        isOpen: createLinkDrawerOpen,
        onExit: closeDrawer
    }))), operation === 'operation-oauth1-reciprocal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, (!thisApplicationManifest || !targetApplicationManifest) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        interactionName: "load",
        label: "Loading"
    }), thisApplicationManifest && targetApplicationManifest && creationState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aKKFI.default), {
        state: {
            kind: 'reciprocal-review',
            variant: 'OAUTH1.0',
            localManifest: thisApplicationManifest,
            remoteManifest: targetApplicationManifest,
            inboundCreationState: creationState,
            rpcUrl: targetApplicationManifest.url
        },
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        onCancel: closeDrawer,
        // TODO: Handle error
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    })), operation === 'operation-oauth1-complete-link' && creationState?.applinkOriginalCreatedId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Ol6o.CreateFlowDialog), {
        isOpen: createLinkDrawerOpen,
        onExit: closeDrawer,
        startingStage: {
            kind: 'confirmation',
            variant: 'OAUTH1.0',
            confirmationApplinkId: creationState?.applinkOriginalCreatedId
        }
    }))));
};
$901fd6b1d89aab5c$var$FullApplinksPageContents.displayName = "FullApplinksPageContents";
const $901fd6b1d89aab5c$var$ApplinksPageContents = (props)=>{
    if ((0, $i860n.fg)('applinks-933-experimental-list-page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($901fd6b1d89aab5c$var$FullApplinksPageContents, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($901fd6b1d89aab5c$var$PartialApplinksPageContents, null);
};
$901fd6b1d89aab5c$var$ApplinksPageContents.displayName = "ApplinksPageContents";
var $901fd6b1d89aab5c$export$2e2bcd8739ae039 = $901fd6b1d89aab5c$var$ApplinksPageContents;

});
parcelRegister("38r1t", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5b34f01c661830a$export$2e2bcd8739ae039);
/* ApplinksTable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $glYl9 = parcelRequire("glYl9");

var $863Fi = parcelRequire("863Fi");

var $drYNU = parcelRequire("drYNU");

var $k3sNq = parcelRequire("k3sNq");

var $b0KE0 = parcelRequire("b0KE0");

var $kCkhe = parcelRequire("kCkhe");

var $7Fzpe = parcelRequire("7Fzpe");

var $bgJDP = parcelRequire("bgJDP");

var $m9iwH = parcelRequire("m9iwH");

var $1CdDx = parcelRequire("1CdDx");

var $2EFuW = parcelRequire("2EFuW");

var $ceqcm = parcelRequire("ceqcm");

var $cSR11 = parcelRequire("cSR11");

var $g36LP = parcelRequire("g36LP");

var $abhF2 = parcelRequire("abhF2");

var $6CfY5 = parcelRequire("6CfY5");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $drATu = parcelRequire("drATu");

var $1b6Nh = parcelRequire("1b6Nh");

var $5T7Xn = parcelRequire("5T7Xn");

var $4Sn7I = parcelRequire("4Sn7I");

var $9xWqG = parcelRequire("9xWqG");
const $e5b34f01c661830a$var$primary = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.primary",
    defaultMessage: "Primary"
});
const $e5b34f01c661830a$var$extraAuth = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.extra-auth",
    defaultMessage: "Extra Auth"
});
const $e5b34f01c661830a$var$connectedStatus = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.connected-status",
    defaultMessage: "Connected"
});
const $e5b34f01c661830a$var$authTypeUnknown = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-level-mismatch-unknown",
    defaultMessage: "Unknown"
});
const $e5b34f01c661830a$var$remote = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.remote",
    defaultMessage: "Go to remote"
});
const $e5b34f01c661830a$var$edit = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.edit",
    defaultMessage: "Edit"
});
const $e5b34f01c661830a$var$deleteLink = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.delete-link",
    defaultMessage: "Delete"
});
const $e5b34f01c661830a$var$name = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.name",
    defaultMessage: "Name"
});
const $e5b34f01c661830a$var$application = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.application",
    defaultMessage: "Application"
});
const $e5b34f01c661830a$var$linkProperties = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.link-properties",
    defaultMessage: "Link properties"
});
const $e5b34f01c661830a$var$status = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.status",
    defaultMessage: "Status"
});
const $e5b34f01c661830a$var$actions = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-table.actions",
    defaultMessage: "Actions"
});
const $e5b34f01c661830a$var$systemApplinkNonfinal = (0, $7eNDO.defineMessage)({
    defaultMessage: "This is an internal link created automatically by the system. System internal links are read-only and cannot be edited.",
    id: "applinks.administration.ui.common.status.system-link-description"
});
const $e5b34f01c661830a$var$contentStyles = {
    status: "_bozgpxbi _y4tipxbi _1q51pxbi _85i5pxbi _p12fdgin _1ul9nklw",
    menu: "_p12fdgin _1ul9nklw"
};
const $e5b34f01c661830a$var$ApplicationLinkProduct = (props)=>{
    const typeDef = (0, $5T7Xn.lookupTypeFromV3Data)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        alignBlock: "center",
        space: "space.100"
    }, typeDef.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, props.displayUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        color: "color.text.subtle",
        size: "small"
    }, typeDef.name))));
};
$e5b34f01c661830a$var$ApplicationLinkProduct.displayName = "ApplicationLinkProduct";
const $e5b34f01c661830a$var$ApplicationLinkName = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, props.name);
};
$e5b34f01c661830a$var$ApplicationLinkName.displayName = "ApplicationLinkName";
const $e5b34f01c661830a$var$ApplicationLinkType = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const appendLozenges = (isPrimary, isSystem, isExtraAuthRequired)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, isPrimary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            key: "primary"
        }, formatMessage($e5b34f01c661830a$var$primary)), isExtraAuthRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            key: "extra-auth"
        }, formatMessage($e5b34f01c661830a$var$extraAuth)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        alignBlock: "center",
        space: "space.100"
    }, appendLozenges(props.primary, props.system, props.isExtraAuthRequired));
};
$e5b34f01c661830a$var$ApplicationLinkType.displayName = "ApplicationLinkType";
const $e5b34f01c661830a$var$LozengeWithContext = (props)=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: props.appearance
    }, props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1CdDx.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
                xcss: $e5b34f01c661830a$var$contentStyles.status
            }, props.content),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bgJDP))),
                label: `Additional information about ${props.label} status`,
                appearance: "subtle",
                onClick: ()=>setIsOpen(!isOpen)
            })
    }));
};
$e5b34f01c661830a$var$LozengeWithContext.displayName = "LozengeWithContext";
const $e5b34f01c661830a$var$ApplicationLinkStatus = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [applinkStatus, setApplinkStatus] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        // If the applink is a system link, we don't need to fetch its status
        if (props.system) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
            setApplinkStatus('system');
            return;
        } // TODO: Properly mock data
        (0, $drATu.fetchApplinkStatus)(props.id).then((linkStatus)=>{
            setApplinkStatus(linkStatus);
        }).catch((err)=>{
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.fetchApplinkStatus', `Failed to fetch applink status for the table row belonging to applink ${props.id}`, maybeError);
        });
    }, [
        props.id,
        props.system
    ]); // TODO: Pop-ups
    const createLozenge = (contents)=>{
        if (contents === 'system') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5b34f01c661830a$var$LozengeWithContext, {
            appearance: "default",
            label: "System",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($e5b34f01c661830a$var$systemApplinkNonfinal)))
        });
         // First, check if the link is working
        if (contents.working) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
            appearance: "success"
        }, formatMessage($e5b34f01c661830a$var$connectedStatus));
         // Next, check if there is an error
        if (contents.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5b34f01c661830a$var$LozengeWithContext, {
            appearance: "removed",
            label: "Config Error",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4Sn7I.default), {
                err: contents.error ? (0, $9xWqG.ERRORS)[contents.error.type] : (0, $9xWqG.ERRORS).UNKNOWN,
                context: contents
            }))
        });
         // TODO: Others
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), null, formatMessage($e5b34f01c661830a$var$authTypeUnknown));
    };
    return applinkStatus ? createLozenge(applinkStatus) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), null);
};
$e5b34f01c661830a$var$ApplicationLinkStatus.displayName = "ApplicationLinkStatus";
const $e5b34f01c661830a$var$onDeleteButtonClick = (applink)=>{
    (0, $drATu.deleteApplink)(applink.id);
};
const $e5b34f01c661830a$var$ApplicationLinkPopupMenuContent = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $e5b34f01c661830a$var$contentStyles.menu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        href: props.data.displayUrl + (0, $1b6Nh.APPLINKS_LIST_PAGE_URL)
    }, formatMessage($e5b34f01c661830a$var$remote))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
        title: "Manage link",
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cSR11.default), {
        href: (0, $1b6Nh.APPLINKS_EDIT_PAGE_URL_FOR_ID)(props.data.id)
    }, formatMessage($e5b34f01c661830a$var$edit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ceqcm.default), {
        onClick: ()=>$e5b34f01c661830a$var$onDeleteButtonClick(props.data)
    }, formatMessage($e5b34f01c661830a$var$deleteLink)))));
};
$e5b34f01c661830a$var$ApplicationLinkPopupMenuContent.displayName = "ApplicationLinkPopupMenuContent";
const $e5b34f01c661830a$var$ApplicationLinkPopupMenu = (props)=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1CdDx.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5b34f01c661830a$var$ApplicationLinkPopupMenuContent, {
                data: props.data
            }),
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
                ...triggerProps,
                isSelected: isOpen,
                label: "Additional actions",
                onClick: ()=>{
                    setIsOpen(!isOpen);
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe)))
            })
    });
};
$e5b34f01c661830a$var$ApplicationLinkPopupMenu.displayName = "ApplicationLinkPopupMenu";
const $e5b34f01c661830a$var$convertToArray = (applinks)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return applinks.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $e5b34f01c661830a$var$ApplinksTable = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const applinkItems = props.applinks ? $e5b34f01c661830a$var$convertToArray(props.applinks) : undefined;
    const filteredApplinkItems = applinkItems?.filter((item)=>{
        let passesFilter = true;
        if (props.filter) passesFilter = item.content.type === props.filter;
        let passesSearch = true;
        if (props.search && props.search.length > 0) {
            const nameCondition = item.content.name.toLowerCase().includes(props.search.toLowerCase());
            const urlCondition = item.content.displayUrl.toLowerCase().includes(props.search.toLowerCase());
            passesSearch = nameCondition || urlCondition;
        }
        return passesFilter && passesSearch;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $glYl9.default), {
        label: "Application Links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3sNq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $drYNU.default), {
        width: "20%"
    }, formatMessage($e5b34f01c661830a$var$name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $drYNU.default), {
        width: "40%"
    }, formatMessage($e5b34f01c661830a$var$application)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $drYNU.default), {
        width: "15%"
    }, formatMessage($e5b34f01c661830a$var$linkProperties)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $drYNU.default), {
        width: "15%"
    }, formatMessage($e5b34f01c661830a$var$status)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $drYNU.default), {
        width: "10%"
    }, formatMessage($e5b34f01c661830a$var$actions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kCkhe.default), {
        items: filteredApplinkItems,
        render: (item)=>{
            const { content: content } = item;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b0KE0.default), {
                key: item.id,
                itemId: item.id,
                hasChildren: item.hasChildren
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $863Fi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5b34f01c661830a$var$ApplicationLinkName, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $863Fi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5b34f01c661830a$var$ApplicationLinkProduct, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $863Fi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5b34f01c661830a$var$ApplicationLinkType, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $863Fi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5b34f01c661830a$var$ApplicationLinkStatus, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $863Fi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5b34f01c661830a$var$ApplicationLinkPopupMenu, {
                data: item.content
            })));
            return row;
        }
    }));
};
$e5b34f01c661830a$var$ApplinksTable.displayName = "ApplinksTable";
var $e5b34f01c661830a$export$2e2bcd8739ae039 = $e5b34f01c661830a$var$ApplinksTable;

});
parcelRegister("glYl9", function(module, exports) {
$parcel$export(module.exports, "default", () => $12875822b983f94e$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $863Fi = parcelRequire("863Fi");

var $drYNU = parcelRequire("drYNU");

var $k3sNq = parcelRequire("k3sNq");

var $eNso1 = parcelRequire("eNso1");

var $b0KE0 = parcelRequire("b0KE0");

var $kCkhe = parcelRequire("kCkhe");
const $12875822b983f94e$var$emptyColumnWidths = [];
function $12875822b983f94e$var$TableTree({ children: children, columns: columns, columnWidths: defaultColumnWidths = $12875822b983f94e$var$emptyColumnWidths, headers: headers, shouldExpandOnClick: shouldExpandOnClick, items: items, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, label: label, referencedLabel: referencedLabel }) {
    const [columnWidths, setColumnWidths] = (0, $euxye.useState)(defaultColumnWidths);
    const setColumnWidth = (0, $euxye.useCallback)((columnIndex, width)=>{
        if (width === columnWidths[columnIndex]) return;
        setColumnWidths((columnWidths)=>{
            const newColumnWidths = [
                ...columnWidths
            ];
            newColumnWidths[columnIndex] = width;
            return newColumnWidths;
        });
    }, [
        columnWidths
    ]);
    const getColumnWidth = (0, $euxye.useCallback)((columnIndex)=>{
        return columnWidths[columnIndex] || null;
    }, [
        columnWidths
    ]);
    const contextValue = (0, $euxye.useMemo)(()=>({
            setColumnWidth: setColumnWidth,
            getColumnWidth: getColumnWidth
        }), [
        setColumnWidth,
        getColumnWidth
    ]);
    const heads = headers && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k3sNq.default), {
        children: headers.map((header, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $drYNU.default), {
                columnIndex: index,
                width: columnWidths[index],
                children: header
            }, index))
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eNso1.TableTreeContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
            role: "treegrid",
            "aria-readonly": true,
            "aria-label": label,
            "aria-labelledby": referencedLabel,
            children: [
                heads,
                columns && items && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kCkhe.default), {
                    items: items,
                    render: ({ id: id, children: children, content: content })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $b0KE0.default), {
                            itemId: id,
                            items: children,
                            hasChildren: !!children && children.length > 0,
                            shouldExpandOnClick: shouldExpandOnClick,
                            mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel,
                            children: columns.map((CellContent, index)=>{
                                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $863Fi.default), {
                                    columnIndex: index,
                                    width: columnWidths[index],
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(CellContent, {
                                        ...content
                                    })
                                }, `cell-${index}`);
                            })
                        })
                }),
                children
            ]
        })
    });
}
$12875822b983f94e$var$TableTree.displayName = "TableTree";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$12875822b983f94e$export$2e2bcd8739ae039 = $12875822b983f94e$var$TableTree;

});
parcelRegister("863Fi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fc7a8d996336c5d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $jBykC = parcelRequire("jBykC");

var $hevRV = parcelRequire("hevRV");

var $e5zeT = parcelRequire("e5zeT");
const $2fc7a8d996336c5d$var$CellComponent = ({ children: children, singleLine: singleLine, indentLevel: indentLevel, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $jBykC.default), {
        indent: indentLevel ? `calc(${"var(--ds-space-300, 24px)"} * ${indentLevel})` : undefined,
        width: width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ...props,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hevRV.default), {
            isSingleLine: singleLine,
            children: children
        })
    });
$2fc7a8d996336c5d$var$CellComponent.displayName = "CellComponent";
const $2fc7a8d996336c5d$var$Cell = (0, $e5zeT.default)($2fc7a8d996336c5d$var$CellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2fc7a8d996336c5d$export$2e2bcd8739ae039 = $2fc7a8d996336c5d$var$Cell;

});
parcelRegister("jBykC", function(module, exports) {
$parcel$export(module.exports, "default", () => $073f316ff697c15e$export$2e2bcd8739ae039);
/* common-cell.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $073f316ff697c15e$var$commonStyles = null;
/**
 * __Common cell__
 */ const $073f316ff697c15e$var$CommonCell = ({ indent: indent, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "gridcell",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            "_1yt412f9 _11c8fhey _1e0c1txw _vchhusvi _1tke1ylp _kqswh2mm _4cvr1h6o _syazi7uo _ct361wug _1nmz1hna",
            className
        ]),
        ...props,
        style: {
            '--indent': indent,
            width: width
        }
    });
$073f316ff697c15e$var$CommonCell.displayName = "CommonCell";
var $073f316ff697c15e$export$2e2bcd8739ae039 = $073f316ff697c15e$var$CommonCell;

});

parcelRegister("hevRV", function(module, exports) {
$parcel$export(module.exports, "default", () => $421d5dfc9b1c4cc8$export$2e2bcd8739ae039);
/* overflow-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $421d5dfc9b1c4cc8$var$overflowContainerStyles = null;
/**
 * __Overflow container__
 */ const $421d5dfc9b1c4cc8$var$OverflowContainer = ({ isSingleLine: isSingleLine, ...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ...props,
        className: (0, $4jQY2.default)([
            isSingleLine && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    });
$421d5dfc9b1c4cc8$var$OverflowContainer.displayName = "OverflowContainer";
var $421d5dfc9b1c4cc8$export$2e2bcd8739ae039 = $421d5dfc9b1c4cc8$var$OverflowContainer;

});

parcelRegister("e5zeT", function(module, exports) {
$parcel$export(module.exports, "default", () => $85b76ff210573ccf$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $eNso1 = parcelRequire("eNso1");
function $85b76ff210573ccf$export$2e2bcd8739ae039(Cell) {
    return (props)=>{
        const { setColumnWidth: setColumnWidth, getColumnWidth: getColumnWidth } = (0, $euxye.useContext)((0, $eNso1.TableTreeContext));
        const { width: width, columnIndex: columnIndex, ...other } = props;
        (0, $euxye.useEffect)(()=>{
            if (width !== undefined && columnIndex !== undefined) setColumnWidth(columnIndex, width);
        }, [
            width,
            columnIndex,
            setColumnWidth
        ]);
        let columnWidth;
        if (width !== null && width !== undefined) columnWidth = width;
        else if (columnIndex !== undefined) columnWidth = getColumnWidth(columnIndex);
        return /*#__PURE__*/ (0, $e79Pd.jsx)(Cell, {
            width: columnWidth,
            ...other
        });
    };
}

});
parcelRegister("eNso1", function(module, exports) {
$parcel$export(module.exports, "TableTreeContext", () => $6ddc7779c474d0d8$export$662c2d348d8b71af);

var $euxye = parcelRequire("euxye");
const $6ddc7779c474d0d8$export$662c2d348d8b71af = /*#__PURE__*/ (0, $euxye.createContext)({
    setColumnWidth: ()=>{},
    getColumnWidth: ()=>null
});

});



parcelRegister("drYNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $424464236539d518$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jBykC = parcelRequire("jBykC");

var $e5zeT = parcelRequire("e5zeT");
const $424464236539d518$var$headerStyles = null;
const $424464236539d518$var$HeaderComponent = ({ width: width, children: children, onClick: onClick, id: id, role: role = 'columnheader' })=>{
    // TODO: Determine whether proper `th` elements can be used instead of
    // roles (DSP-11588)
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jBykC.default), {
        role: role,
        width: width,
        id: id,
        onClick: onClick,
        className: (0, $4jQY2.default)([
            "_11c8wadc _syazazsu _k48pwu06"
        ]),
        children: children
    });
};
$424464236539d518$var$HeaderComponent.displayName = "HeaderComponent";
const $424464236539d518$var$Header = (0, $e5zeT.default)($424464236539d518$var$HeaderComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$424464236539d518$export$2e2bcd8739ae039 = $424464236539d518$var$Header;

});

parcelRegister("k3sNq", function(module, exports) {
$parcel$export(module.exports, "default", () => $60fdb39393a74a1a$export$2e2bcd8739ae039);
/* headers.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
/* eslint-disable @repo/internal/react/no-clone-element */ const $60fdb39393a74a1a$var$containerStyles = null;
/**
 * __Headers__
 *
 * Headers component for advanced composition of data, allowing custom data structures.
 *
 * - [Examples](https://atlassian.design/components/table-tree/examples#advanced)
 * - [Code](https://atlassian.design/components/table-tree/code#headers-props)
 */ const $60fdb39393a74a1a$var$Headers = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "row",
        className: (0, $4jQY2.default)([
            "_179r1hmg _1e0c1txw"
        ]),
        children: (0, $euxye.Children).map(children, (header, index)=>/*#__PURE__*/ (0, $euxye.cloneElement)(header, {
                key: index,
                columnIndex: index
            }))
    });
$60fdb39393a74a1a$var$Headers.displayName = "Headers";
var $60fdb39393a74a1a$export$2e2bcd8739ae039 = $60fdb39393a74a1a$var$Headers;

});

parcelRegister("b0KE0", function(module, exports) {
$parcel$export(module.exports, "default", () => $56b58e54b95f6e90$export$2e2bcd8739ae039);
/* row.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $aZBDA = parcelRequire("aZBDA");

var $gguhm = parcelRequire("gguhm");

var $30f68 = parcelRequire("30f68");

var $8VpIC = parcelRequire("8VpIC");
const $56b58e54b95f6e90$var$treeRowClickableStyles = null;
const $56b58e54b95f6e90$var$getExtendedLabel = (cellContent, cellIndex, mainColumnForExpandCollapseLabel)=>{
    /**
   * First condition - when we pass data via `items` property in `<TableTree />`
   * Second condition - when we pass data via `<Rows />` as children in `<TableTree />`.
   */ if (cellContent.hasOwnProperty('props')) return cellContent?.props[mainColumnForExpandCollapseLabel?.toLowerCase()];
    else if (cellIndex === mainColumnForExpandCollapseLabel) return cellContent;
    return undefined;
};
function $56b58e54b95f6e90$var$Row({ shouldExpandOnClick: shouldExpandOnClick, hasChildren: hasChildren, depth: depth, renderChildren: renderChildren, isDefaultExpanded: isDefaultExpanded, data: data, onExpand: providedOnExpand, onCollapse: providedOnCollapse, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, expandLabel: expandLabel, collapseLabel: collapseLabel, itemId: itemId, children: children, isExpanded: isProvidedExpanded }) {
    const [isExpandedState, setIsExpandedState] = (0, $euxye.useState)(isDefaultExpanded || false);
    (0, $euxye.useEffect)(()=>{
        if (isProvidedExpanded === undefined && isDefaultExpanded !== undefined) setIsExpandedState(isDefaultExpanded);
    }, [
        isDefaultExpanded,
        isProvidedExpanded
    ]);
    const onExpand = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnExpand && providedOnExpand(value),
        action: 'expanded',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onCollapse = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnCollapse && providedOnCollapse(value),
        action: 'collapsed',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); /**
       * This ensures a user won't trigger a click event and expand the accordion
       * when making a text selection.
       */ 
    const onClickHandler = (e)=>{
        const selection = window.getSelection()?.toString() || '';
        if (selection?.length === 0) onExpandToggle(e);
    };
    const onExpandStateChange = (isExpanded)=>{
        if (data) {
            if (isExpanded && onExpand) onExpand(data);
            else if (!isExpanded && onCollapse) onCollapse(data);
        }
    };
    const onExpandToggle = (e)=>{
        e.stopPropagation();
        if (isProvidedExpanded !== undefined) onExpandStateChange(!isProvidedExpanded);
        else setIsExpandedState((prevState)=>{
            onExpandStateChange(!prevState);
            return !prevState;
        });
    };
    const renderCell = (cell, cellIndex)=>{
        const isFirstCell = cellIndex === 0;
        const indentLevel = isFirstCell ? depth : 0;
        let cellContent = cell.props.children || [];
        const extendedLabel = $56b58e54b95f6e90$var$getExtendedLabel(cellContent, cellIndex, mainColumnForExpandCollapseLabel);
        if (isFirstCell && hasChildren) cellContent = [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $30f68.default), {
                expandLabel: expandLabel,
                collapseLabel: collapseLabel,
                extendedLabel: extendedLabel,
                isExpanded: isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState,
                onExpandToggle: onExpandToggle,
                ariaControls: !!itemId ? (0, $gguhm.default)(itemId) : undefined,
                rowId: !!itemId ? itemId : ''
            }, "chevron")
        ].concat(cellContent);
         // eslint-disable-next-line @repo/internal/react/no-clone-element
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(cell, {
            key: cellIndex,
            columnIndex: cellIndex,
            indentLevel: indentLevel
        }, cellContent);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8VpIC.TreeRowContainer), {
                onClick: hasChildren && shouldExpandOnClick ? onClickHandler : undefined,
                "aria-expanded": hasChildren ? isExpandedState : undefined,
                "aria-level": depth ? depth : undefined,
                className: (0, $4jQY2.default)([
                    hasChildren && shouldExpandOnClick && "_80omtlke"
                ]),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.map(children, (cell, index)=>renderCell(cell, index))
            }),
            hasChildren && (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && renderChildren && renderChildren()
        ]
    });
}
$56b58e54b95f6e90$var$Row.displayName = "Row";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$56b58e54b95f6e90$export$2e2bcd8739ae039 = $56b58e54b95f6e90$var$Row;

});
parcelRegister("gguhm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7918bbb8e66e9c79$export$2e2bcd8739ae039);
function $7918bbb8e66e9c79$export$2e2bcd8739ae039(id) {
    return `tabletreeitem-${id}`.replace(/[^-_a-zA-Z0-9]/g, '');
}

});

parcelRegister("30f68", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0182fdfce0e05bf$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $2oRWW = parcelRequire("2oRWW");

var $ld25x = parcelRequire("ld25x");

var $dUPUc = parcelRequire("dUPUc");

var $jwKXm = parcelRequire("jwKXm");
/**
 * Internal chevron component.
 */ const $a0182fdfce0e05bf$var$Chevron = ({ isExpanded: isExpanded, ariaControls: ariaControls, collapseLabel: collapseLabel = 'Collapse', expandLabel: expandLabel = 'Expand', rowId: rowId, extendedLabel: extendedLabel, onExpandToggle: onExpandToggle = (0, $2oRWW.default) })=>{
    const getLabel = (defaultLabel)=>extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jwKXm.ChevronContainer), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
            appearance: "subtle",
            onClick: onExpandToggle,
            spacing: "compact",
            icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dUPUc))), {
                    ...iconProps,
                    size: "small"
                }),
            "aria-controls": isExpanded ? ariaControls : undefined,
            label: isExpanded ? getLabel(collapseLabel) : getLabel(expandLabel)
        })
    });
};
$a0182fdfce0e05bf$var$Chevron.displayName = "Chevron";
var $a0182fdfce0e05bf$export$2e2bcd8739ae039 = $a0182fdfce0e05bf$var$Chevron;

});
parcelRegister("jwKXm", function(module, exports) {
$parcel$export(module.exports, "ChevronContainer", () => $e9a277f34d67d9e3$export$f25bd028f55b3d30);
/* chevron-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $e9a277f34d67d9e3$var$commonCellElementStyles = null;
const $e9a277f34d67d9e3$var$commonChevronContainerStyles = null;
const $e9a277f34d67d9e3$export$f25bd028f55b3d30 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ...props,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbq1lmg",
            "_1pfhj39m"
        ])
    });
$e9a277f34d67d9e3$export$f25bd028f55b3d30.displayName = "ChevronContainer";

});


parcelRegister("8VpIC", function(module, exports) {
$parcel$export(module.exports, "TreeRowContainer", () => $aff769631256bb6a$export$802d2031792f9e4);
/* tree-row-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $aff769631256bb6a$var$treeRowContainerStyles = null;
const $aff769631256bb6a$export$802d2031792f9e4 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "row",
        ...props,
        className: (0, $4jQY2.default)([
            "_179ria51 _1e0c1txw"
        ])
    });
$aff769631256bb6a$export$802d2031792f9e4.displayName = "TreeRowContainer";

});


parcelRegister("kCkhe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d706835e7c7e66da$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $g1GOE = parcelRequire("g1GOE");
function $d706835e7c7e66da$var$Rows({ items: items, render: render, loadingLabel: loadingLabel = 'Loading' }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g1GOE.default), {
            items: items,
            loadingLabel: loadingLabel,
            render: render
        })
    });
}
$d706835e7c7e66da$var$Rows.displayName = "Rows";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d706835e7c7e66da$export$2e2bcd8739ae039 = $d706835e7c7e66da$var$Rows;

});
parcelRegister("g1GOE", function(module, exports) {
$parcel$export(module.exports, "default", () => $7835149228d390b5$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $8GzRr = parcelRequire("8GzRr");

var $hs3Bt = parcelRequire("hs3Bt");
function $7835149228d390b5$var$Items({ depth: depth = 0, items: items, loadingLabel: loadingLabel, render: render }) {
    const [isLoaderShown, setIsLoaderShown] = (0, $euxye.useState)(false);
    const handleLoaderComplete = ()=>setIsLoaderShown(false);
    return !items || isLoaderShown ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hs3Bt.default), {
        isCompleting: !!(items && items.length),
        onComplete: handleLoaderComplete,
        depth: depth + 1,
        loadingLabel: loadingLabel
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: items.map((data)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8GzRr.default), {
                data: data,
                depth: depth + 1,
                render: render,
                loadingLabel: loadingLabel
            }, data.id))
    });
}
$7835149228d390b5$var$Items.displayName = "Items";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7835149228d390b5$export$2e2bcd8739ae039 = $7835149228d390b5$var$Items;

});
parcelRegister("8GzRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6edcd47590cba530$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-clone-element */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gguhm = parcelRequire("gguhm");

var $g1GOE = parcelRequire("g1GOE");
/**
 * __Item__
 * Internal item component.
 */ function $6edcd47590cba530$var$Item({ depth: depth = 0, data: data, render: render, loadingLabel: loadingLabel }) {
    const renderedRow = render(data);
    if (!renderedRow) return null;
    // itemId exists on RowProps, but not on RowsProps
    const itemId = 'itemId' in renderedRow.props ? renderedRow.props.itemId : undefined;
    const items = renderedRow.props.items;
    return /*#__PURE__*/ (0, $euxye.cloneElement)(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                id: !!itemId ? (0, $gguhm.default)(itemId) : undefined,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g1GOE.default), {
                    depth: depth,
                    items: items,
                    render: render,
                    loadingLabel: loadingLabel
                })
            })
    });
}
$6edcd47590cba530$var$Item.displayName = "Item";
var $6edcd47590cba530$export$2e2bcd8739ae039 = $6edcd47590cba530$var$Item;

});

parcelRegister("hs3Bt", function(module, exports) {
$parcel$export(module.exports, "default", () => $eacd812bffe06cae$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $abhF2 = parcelRequire("abhF2");

var $jBykC = parcelRequire("jBykC");

var $gvviu = parcelRequire("gvviu");

var $8VpIC = parcelRequire("8VpIC");
const $eacd812bffe06cae$var$LoaderItem = ({ depth: depth = 1, loadingLabel: loadingLabel, isCompleting: isCompleting, onComplete: onComplete })=>{
    const [phase, setPhase] = (0, $euxye.useState)('loading');
    (0, $euxye.useEffect)(()=>{
        if (phase === 'loading' && isCompleting) setPhase(()=>{
            onComplete();
            return 'complete';
        });
    }, [
        isCompleting,
        onComplete,
        phase
    ]);
    return phase === 'loading' ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8VpIC.TreeRowContainer), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jBykC.default), {
            indent: `calc(${"var(--ds-space-300, 24px)"} * ${depth})`,
            width: "100%",
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gvviu.LoaderItemContainer), {
                isRoot: depth === 1,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
                    size: "small",
                    testId: "table-tree-spinner",
                    label: loadingLabel
                })
            })
        })
    }) : null;
};
$eacd812bffe06cae$var$LoaderItem.displayName = "LoaderItem";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eacd812bffe06cae$export$2e2bcd8739ae039 = $eacd812bffe06cae$var$LoaderItem;

});
parcelRegister("gvviu", function(module, exports) {
$parcel$export(module.exports, "LoaderItemContainer", () => $be2bedfadc2c1451$export$94ae573de7227397);
/* loader-item-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $be2bedfadc2c1451$var$commonCellElementStyles = null;
const $be2bedfadc2c1451$var$loadingItemContainerStyles = null;
const $be2bedfadc2c1451$var$paddingLeftStyles = null;
const $be2bedfadc2c1451$export$94ae573de7227397 = ({ isRoot: isRoot, ...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ...props,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbq1lmg",
            "_1bsb1osq",
            isRoot && "_bozg1ssb"
        ])
    });
$be2bedfadc2c1451$export$94ae573de7227397.displayName = "LoaderItemContainer";

});






parcelRegister("jpNu4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d90118e76a3d04e$export$2e2bcd8739ae039);
/* ApplinksHeader.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $iOfms = parcelRequire("iOfms");

var $7aCqr = parcelRequire("7aCqr");

var $eAQb7 = parcelRequire("eAQb7");

var $8A8fZ = parcelRequire("8A8fZ");

var $9qT28 = parcelRequire("9qT28");

var $jaPl6 = parcelRequire("jaPl6");

var $2YPKP = parcelRequire("2YPKP");

var $2Xkyn = parcelRequire("2Xkyn");

var $hzWaA = parcelRequire("hzWaA");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $5T7Xn = parcelRequire("5T7Xn");
const $2d90118e76a3d04e$var$allApps = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-header.all-apps",
    defaultMessage: "All Apps"
});
const $2d90118e76a3d04e$var$applicationLinks = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-header.application-links",
    defaultMessage: "Application Links"
});
const $2d90118e76a3d04e$var$createStepName = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.creation-flow-dialog.create-step-name-nonfinal",
    defaultMessage: "Create link"
});
const $2d90118e76a3d04e$var$applicationLinksDescription = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-header.application-links-description",
    defaultMessage: "Application links let you integrate Jira with another Atlassian product or external application so they can exchange information, resources, and functionalities. What exactly is exchanged will depend on the applications you link."
});
const $2d90118e76a3d04e$var$learnMore = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-header.learn-more",
    defaultMessage: "Learn more about application links"
});
const $2d90118e76a3d04e$var$clearSelection = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.applinks-header.clear-selection",
    defaultMessage: "Clear selection"
});
const $2d90118e76a3d04e$var$styles = {
    searchBox: "_16jlidpf _1o9zidpf _i0dl1mjv"
};
const $2d90118e76a3d04e$var$ApplinksHeader = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const createFilteredIconButton = ({ triggerRef: triggerRef, ...triggerProps })=>{
        if (props.filter) {
            const typeDef = (0, $5T7Xn.lookupType)(props.filter);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                ...triggerProps,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))),
                isSelected: true,
                ref: triggerRef
            }, typeDef.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            ...triggerProps,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ))),
            ref: triggerRef
        }, formatMessage($2d90118e76a3d04e$var$allApps));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "large"
    }, formatMessage($2d90118e76a3d04e$var$applicationLinks)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
        appearance: "primary",
        onClick: props.onCreateLink
    }, formatMessage($2d90118e76a3d04e$var$createStepName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($2d90118e76a3d04e$var$applicationLinksDescription), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
        href: "https://support.atlassian.com/jira-cloud-administration/docs/use-applinks-to-link-to-atlassian-products/"
    }, formatMessage($2d90118e76a3d04e$var$learnMore))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $2d90118e76a3d04e$var$styles.searchBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
        placeholder: "Search application links",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
            label: "Search application links"
        }),
        onChange: (e)=>{
            props.onSearch(e.currentTarget.value);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jaPl6.default), {
        trigger: createFilteredIconButton,
        shouldRenderToParent: true
    }, props.filter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Xkyn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2YPKP.default), {
        key: "all",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
            label: "Clear filter"
        }),
        onClick: ()=>props.onFilterChange(null)
    }, formatMessage($2d90118e76a3d04e$var$clearSelection))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Xkyn.default), {
        title: "Cloud"
    }, Object.entries((0, $5T7Xn.TypeIdMap)).filter(([key])=>(0, $5T7Xn.TypeIdMap)[key].category === 'cloud').map(([key, typeDef])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2YPKP.default), {
            key: key,
            elemBefore: typeDef.icon,
            onClick: ()=>props.onFilterChange(key)
        }, typeDef.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Xkyn.default), {
        title: "Data Center"
    }, Object.entries((0, $5T7Xn.TypeIdMap)).filter(([key])=>(0, $5T7Xn.TypeIdMap)[key].category === 'dc').map(([key, typeDef])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2YPKP.default), {
            key: key,
            elemBefore: typeDef.icon,
            onClick: ()=>props.onFilterChange(key)
        }, typeDef.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Xkyn.default), {
        title: "Miscellaneous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2YPKP.default), {
        key: "generic",
        elemBefore: (0, $5T7Xn.TypeIdMap).generic.icon,
        onClick: ()=>props.onFilterChange('generic')
    }, (0, $5T7Xn.TypeIdMap).generic.name))))));
};
$2d90118e76a3d04e$var$ApplinksHeader.displayName = "ApplinksHeader";
var $2d90118e76a3d04e$export$2e2bcd8739ae039 = $2d90118e76a3d04e$var$ApplinksHeader;

});

parcelRegister("5Ol6o", function(module, exports) {
$parcel$export(module.exports, "CreateFlowDialog", () => $200ca586220b410e$export$79c286a92b7787f2);
/* CreateFlowDialog.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $fyJ3d = parcelRequire("fyJ3d");

var $l6OQo = parcelRequire("l6OQo");

var $defJG = parcelRequire("defJG");

var $abhF2 = parcelRequire("abhF2");

var $3mYdc = parcelRequire("3mYdc");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $5KOJz = parcelRequire("5KOJz");

var $aKKFI = parcelRequire("aKKFI");

var $d58Bx = parcelRequire("d58Bx");

var $gjyKl = parcelRequire("gjyKl");

var $7kc1Y = parcelRequire("7kc1Y");
const $200ca586220b410e$var$errorFlagTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Failed to configure application link",
    id: "applinks.administration.ui.creation-flow-dialog.error-flag-title="
});
const $200ca586220b410e$var$DEFAULT_CREATE_STAGE = {
    kind: 'create'
};
const $200ca586220b410e$var$StateMachine = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    switch(props.state.kind){
        case 'create':
        case 'manual-create':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5KOJz.default), {
                onError: props.onDisplayError,
                onSuccess: props.onStateChange,
                onCancel: props.onCancel
            });
        case 'review':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aKKFI.default), {
                state: props.state,
                onSuccess: props.onStateChange,
                onError: props.onDisplayError,
                onCancel: props.onCancel,
                availableConnections: props.availableConnections
            });
        case 'reciprocal-prompt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d58Bx.default), {
                state: props.state
            });
        case 'connect':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7kc1Y.default), {
                state: props.state,
                onSuccess: props.onCancel,
                onError: props.onDisplayError,
                onCancel: props.onCancel
            });
        case 'confirmation':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gjyKl.default), {
                state: props.state
            });
        case 'loading':
            props.state.promise.then((newState)=>{
                props.onStateChange(newState);
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
                alignBlock: "center",
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), null));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
    }
});
const $200ca586220b410e$export$79c286a92b7787f2 = (props)=>{
    // Use the provided starting stage or default to the create stage
    const [flowState, setFlowState] = (0, $euxye.useState)(props.startingStage || $200ca586220b410e$var$DEFAULT_CREATE_STAGE);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const onCancel = ()=>{
        props.onExit();
        const defaultStage = props.startingStage || $200ca586220b410e$var$DEFAULT_CREATE_STAGE;
        setFlowState(defaultStage);
    };
    const [errorFlags, setErrorFlags] = (0, $euxye.useState)([]);
    const addFlag = (0, $euxye.useCallback)((err)=>{
        const newFlags = errorFlags.slice();
        newFlags.splice(0, 0, err);
        setErrorFlags(newFlags);
    }, [
        errorFlags
    ]);
    const handleDismiss = ()=>{
        setErrorFlags(errorFlags.slice(1));
    };
    (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l6OQo.Drawer), {
        testId: "applinks-administration.ui.list.creation-flow-dialog.drawer",
        width: "full",
        onClose: ()=>onCancel(),
        onCloseComplete: props.onCloseComplete,
        isOpen: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fyJ3d.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($200ca586220b410e$var$StateMachine, {
        state: flowState,
        onStateChange: setFlowState,
        onCancel: onCancel,
        onDisplayError: addFlag,
        availableConnections: props.availableConnections
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.FlagGroup), {
        onDismissed: handleDismiss
    }, errorFlags.map((err, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.ErrorFlag), {
            id: `flag-${idx}`,
            key: `flag-${idx}`,
            title: formatMessage($200ca586220b410e$var$errorFlagTitleMessage),
            description: err
        });
    })));
};
$200ca586220b410e$export$79c286a92b7787f2.displayName = "CreateFlowDialog";

});
parcelRegister("fyJ3d", function(module, exports) {
$parcel$export(module.exports, "DrawerContent", () => $236d03e4326b5c61$export$57ca055474bc0056);
/* drawer-content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jr1Vl = parcelRequire("jr1Vl");

var $50OIz = parcelRequire("50OIz");

var $egspI = parcelRequire("egspI");

var $eYpfY = parcelRequire("eYpfY");

var $lcARw = parcelRequire("lcARw");
const $236d03e4326b5c61$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $236d03e4326b5c61$var$DrawerContentBase = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $euxye.useState)(false);
    const ref = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $236d03e4326b5c61$var$styles.default,
            xcss
        ]),
        ref: (0, $50OIz.mergeRefs)([
            ref,
            scrollableRef
        ]),
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $236d03e4326b5c61$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $eYpfY.useEnsureIsInsideDrawer)();
    (0, $lcARw.default)();
    const content = /*#__PURE__*/ (0, $e79Pd.jsx)($236d03e4326b5c61$var$DrawerContentBase, {
        scrollContentLabel: scrollContentLabel,
        xcss: xcss,
        children: children
    });
    // Under the top-layer flag, background scroll is handled by `DialogScrollLock`
    // (rendered by `DrawerTopLayer`), so we skip `react-scrolllock` here to avoid
    // double-locking the body. See the top-layer migration scroll decision.
    if ((0, $egspI.fg)('platform-dst-top-layer')) return content;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jr1Vl))), {
        children: content
    });
};
$236d03e4326b5c61$export$57ca055474bc0056.displayName = "DrawerContent";

});
parcelRegister("eYpfY", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideDrawer", () => $4df8de78c9a1d407$export$780b9799f6bfecd8);

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $3TZRG = parcelRequire("3TZRG");
const $4df8de78c9a1d407$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $euxye.useContext)((0, $3TZRG.EnsureIsInsideDrawerContext));
    (0, $jiTLE.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};

});
parcelRegister("3TZRG", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideDrawerContext", () => $83bace1627bcfb65$export$e3662b8677049786);

var $euxye = parcelRequire("euxye");
const $83bace1627bcfb65$export$e3662b8677049786 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});


parcelRegister("lcARw", function(module, exports) {
$parcel$export(module.exports, "default", () => $be4c93ddac53d205$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $egspI = parcelRequire("egspI");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $be4c93ddac53d205$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $be4c93ddac53d205$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $euxye.useState)(0);
    (0, $euxye.useLayoutEffect)(()=>{
        setScrollTopOffset($be4c93ddac53d205$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $euxye.useCallback)(()=>{
        if ($be4c93ddac53d205$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $euxye.useEffect)(()=>{
        // The top-layer drawer relies on native modality + `DialogScrollLock`; the
        // programmatic-scroll guard is intentionally dropped under the flag.
        if ((0, $egspI.fg)('platform-dst-top-layer')) return;
        return (0, $glbdM.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("l6OQo", function(module, exports) {
$parcel$export(module.exports, "Drawer", () => $22be6b11ab43e2f8$export$4071300121a182f5);
/// <reference types="node" />
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kt9Lz = parcelRequire("kt9Lz");

var $aZBDA = parcelRequire("aZBDA");

var $fLi8o = parcelRequire("fLi8o");
var $g54uT = parcelRequire("g54uT");

var $egspI = parcelRequire("egspI");

var $5PG2M = parcelRequire("5PG2M");

var $4oqVa = parcelRequire("4oqVa");

var $1EOHp = parcelRequire("1EOHp");

var $6yD0E = parcelRequire("6yD0E");
// escape close manager for layering
const $22be6b11ab43e2f8$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $euxye.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $g54uT.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {});
};
$22be6b11ab43e2f8$var$EscapeCloseManager.displayName = "EscapeCloseManager";
const $22be6b11ab43e2f8$var$DrawerBase = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $euxye.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $kt9Lz.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $5PG2M.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4oqVa.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1EOHp.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $fLi8o.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $e79Pd.jsx)($22be6b11ab43e2f8$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};
$22be6b11ab43e2f8$var$DrawerBase.displayName = "DrawerBase";
const $22be6b11ab43e2f8$export$4071300121a182f5 = (props)=>{
    if ((0, $egspI.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- internal implementation component takes the same DrawerProps
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6yD0E.DrawerTopLayer), {
        ...props
    });
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- internal implementation component takes the same DrawerProps
    return /*#__PURE__*/ (0, $e79Pd.jsx)($22be6b11ab43e2f8$var$DrawerBase, {
        ...props
    });
};
$22be6b11ab43e2f8$export$4071300121a182f5.displayName = "Drawer";

});
parcelRegister("4oqVa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f9bcdd54fee8283$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $zLbDw = parcelRequire("zLbDw");

var $8L2z6 = parcelRequire("8L2z6");
var $eCdE8 = parcelRequire("eCdE8");
const $3f9bcdd54fee8283$var$styles = {
    blanket: "_kqswh2mm"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $3f9bcdd54fee8283$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
            /*
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: "large",
            /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $3f9bcdd54fee8283$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $zLbDw.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
$3f9bcdd54fee8283$var$Blanket.displayName = "Blanket";
var $3f9bcdd54fee8283$export$2e2bcd8739ae039 = $3f9bcdd54fee8283$var$Blanket;

});

parcelRegister("1EOHp", function(module, exports) {
$parcel$export(module.exports, "DrawerPanel", () => $fa7ef3c0645aee73$export$96114a266f19b4d0);
/* drawer-panel.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8L2z6 = parcelRequire("8L2z6");
var $5kyyj = parcelRequire("5kyyj");

var $3TZRG = parcelRequire("3TZRG");

var $1u2qL = parcelRequire("1u2qL");

var $8Pzuw = parcelRequire("8Pzuw");
const $fa7ef3c0645aee73$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $fa7ef3c0645aee73$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect4ttxp",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $fa7ef3c0645aee73$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5kyyj.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
$fa7ef3c0645aee73$var$CustomSlideIn.displayName = "CustomSlideIn";
const $fa7ef3c0645aee73$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $euxye.useRef)(null);
    const onFinish = (0, $euxye.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)($fa7ef3c0645aee73$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Pzuw.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $4jQY2.default)([
                            $fa7ef3c0645aee73$var$styles.root,
                            $fa7ef3c0645aee73$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3TZRG.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1u2qL.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};
$fa7ef3c0645aee73$export$96114a266f19b4d0.displayName = "DrawerPanel";

});
parcelRegister("1u2qL", function(module, exports) {
$parcel$export(module.exports, "OnCloseContext", () => $9c3a2c0b3408e9cc$export$7376ab1fc7707bdd);

var $euxye = parcelRequire("euxye");
const $9c3a2c0b3408e9cc$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("8Pzuw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aa7794a9d82fd9e$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $g6TgS = parcelRequire("g6TgS");
/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $3aa7794a9d82fd9e$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g6TgS.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
$3aa7794a9d82fd9e$var$FocusLock.displayName = "FocusLock";
var $3aa7794a9d82fd9e$export$2e2bcd8739ae039 = $3aa7794a9d82fd9e$var$FocusLock;

});


parcelRegister("6yD0E", function(module, exports) {
$parcel$export(module.exports, "DrawerTopLayer", () => $6dcb44a1854b4fb3$export$fe644b936906c1c3);
/* drawer-top-layer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $glbdM = parcelRequire("glbdM");

var $aZBDA = parcelRequire("aZBDA");

var $dTWzO = parcelRequire("dTWzO");
var $l5WnI = parcelRequire("l5WnI");

var $4syWN = parcelRequire("4syWN");

var $3TZRG = parcelRequire("3TZRG");

var $1u2qL = parcelRequire("1u2qL");
const $6dcb44a1854b4fb3$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $6dcb44a1854b4fb3$var$slideInKeyframes = null;
const $6dcb44a1854b4fb3$var$slideOutKeyframes = null;
const $6dcb44a1854b4fb3$var$styles = {
    root: "_j7hqcljl _8ar6ntq4 _156yru3m _aeldru3m _1sbqru3m _1i6zru3m",
    surface: "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _bfhk1bhr _1q1l1bhr _ect4ttxp"
}; // Width presets mirror the legacy `DrawerPanel`. Applied to the `<dialog>` (the
// sized, edge-pinned element) and clamped to the viewport for mobile safety.
const $6dcb44a1854b4fb3$var$WIDTH_MAP = {
    narrow: '360px',
    medium: '480px',
    wide: '600px',
    extended: '95vw',
    full: '100vw'
}; /**
    * Resolve the native `<dialog>` accessible name props. Prefer the consumer's
    * `label`, then their `titleId`. If neither is supplied (legacy allowed this),
    * fall back to a generic name so the dialog is never unlabelled. Note:
    * `@atlaskit/drawer` has no i18n setup, so this fallback is English only;
    * consumers should pass a localised `label` or `titleId`.
    */ 
function $6dcb44a1854b4fb3$var$getAccessibleName({ label: label, titleId: titleId }) {
    if (label) return {
        label: label
    };
    if (titleId) return {
        labelledBy: titleId
    };
    return {
        label: 'Drawer'
    };
} /**
   * **DrawerTopLayer**
   *
   * Top-layer (`platform-dst-top-layer`) implementation of `Drawer`. Renders a
   * native `<dialog>` via `@atlaskit/top-layer`, replacing Portal, Blanket,
   * react-focus-lock, react-scrolllock and `@atlaskit/layering` with native
   * modality, `::backdrop`, focus trap and return, and `DialogScrollLock`.
   *
   * The `Dialog` primitive owns the entry and exit animation lifecycle (it keeps
   * the host element mounted through the exit transition, then fires
   * `onExitFinish`), so no `ExitingPersistence` wrapper is needed: the drawer
   * renders `<Dialog isOpen={isOpen}>` directly. `useDrawerStack` tracks stack
   * depth so only the foreground drawer shows a `::backdrop`.
   *
   * `isFocusLockEnabled` is intentionally unsupported: a native modal `<dialog>`
   * always traps focus, so `isFocusLockEnabled={false}` is a no-op under this gate.
   */ 
function $6dcb44a1854b4fb3$export$fe644b936906c1c3({ width: width = 'narrow', isOpen: isOpen, shouldReturnFocus: shouldReturnFocus = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, titleId: titleId, enterFrom: enterFrom = 'left' }) {
    /**
   * Points to the panel surface. Passed to `onOpenComplete` / `onCloseComplete`.
   */ const contentRef = (0, $euxye.useRef)(null); // Cache the last content element so `onCloseComplete` still receives a node
    // after children unmount (with reduced motion `contentRef` can clear before
    // `onExitFinish` fires).
    const lastContentElRef = (0, $euxye.useRef)(null); // Callback ref runs at commit (not during render), so both refs stay
    // populated without a render-time side effect. `lastContentElRef` only
    // overwrites with a non-null node, preserving it across the unmount.
    const setContentEl = (0, $euxye.useCallback)((el)=>{
        contentRef.current = el;
        if (el) lastContentElRef.current = el;
    }, []); // Analytics-wrapped close handlers, one per legacy trigger.
    const handleEscapeClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleBlanketClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    }); // Bridge the Dialog primitive's `onClose({ reason })` to the legacy
    // `onClose(event, analyticsEvent)` contract via a synthetic event. Drawer
    // has no `shouldCloseOn*` props, so both reasons always forward.
    const handleDialogClose = (0, $euxye.useCallback)(({ reason: reason })=>{
        const event = (0, $dTWzO.createCloseEvent)({
            reason: reason
        });
        if (reason === 'escape') handleEscapeClose(event);
        else handleBlanketClose(event);
    }, [
        handleEscapeClose,
        handleBlanketClose
    ]); // Mirror the legacy window `keydown` listener so `onKeyDown` still fires
    // while the drawer is open.
    const handleKeyDown = (0, $euxye.useCallback)((evt)=>{
        onKeyDown?.(evt);
    }, [
        onKeyDown
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $glbdM.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        isOpen,
        handleKeyDown
    ]); // `onOpenComplete` once the entry animation settles (via `Dialog`'s
    // `onEnterFinish`, which the underlying hook fires for animated,
    // non-animated and reduced-motion paths).
    const handleEnterFinish = (0, $euxye.useCallback)(()=>{
        onOpenComplete?.(contentRef.current);
    }, [
        onOpenComplete
    ]); // `onCloseComplete` once the exit animation settles (via `Dialog`'s
    // `onExitFinish`). This is also where a custom `shouldReturnFocus={ref}` is
    // honoured: native `<dialog>` restores focus to the trigger at the start of
    // close, so the consumer's ref is focused now that the exit is done.
    // `shouldReturnFocus={false}` is a documented best-effort limitation; native
    // always restores focus to the trigger.
    const handleExitFinish = (0, $euxye.useCallback)(()=>{
        onCloseComplete?.(contentRef.current ?? lastContentElRef.current);
        lastContentElRef.current = null;
        if (typeof shouldReturnFocus === 'object' && shouldReturnFocus?.current) shouldReturnFocus.current.focus();
    }, [
        onCloseComplete,
        shouldReturnFocus
    ]);
    const enterFromStyles = {
        left: {
            '--x': '-100%',
            '--y': '0%'
        },
        right: {
            '--x': '100%',
            '--y': '0%'
        },
        top: {
            '--x': '0%',
            '--y': '-100%'
        },
        bottom: {
            '--x': '0%',
            '--y': '100%'
        }
    }; // Pin the `<dialog>` full-height to the inline-start edge (overriding the
    // primitive's centred `margin: auto`); width from the preset, clamped to the
    // viewport. `enterFrom` only drives the slide animation, not the pin edge;
    // it matches the legacy panel, which always pins `inset-inline-start`.
    const dialogStyle = {
        margin: 0,
        insetBlockStart: 0,
        insetInlineStart: 0,
        insetInlineEnd: 'auto',
        height: '100dvh',
        maxHeight: '100dvh',
        width: `min(${$6dcb44a1854b4fb3$var$WIDTH_MAP[width]}, 100vw)`,
        ...enterFromStyles[enterFrom]
    };
    const accessibleName = $6dcb44a1854b4fb3$var$getAccessibleName({
        label: label,
        titleId: titleId
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $l5WnI.Dialog), {
        isOpen: isOpen,
        onClose: handleDialogClose,
        onEnterFinish: handleEnterFinish,
        onExitFinish: handleExitFinish,
        animate: true,
        xcss: $6dcb44a1854b4fb3$var$styles.root,
        testId: testId,
        ...accessibleName,
        style: dialogStyle,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4syWN.DialogScrollLock), {
                isOpen: true
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                ref: setContentEl,
                className: (0, $4jQY2.default)([
                    $6dcb44a1854b4fb3$var$styles.surface
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3TZRG.EnsureIsInsideDrawerContext).Provider, {
                    value: true,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1u2qL.OnCloseContext).Provider, {
                        value: handleBackButtonClose,
                        children: children
                    })
                })
            })
        ]
    });
}
$6dcb44a1854b4fb3$export$fe644b936906c1c3.displayName = "DrawerTopLayer";

});


parcelRegister("5KOJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9414f4189dbcbb3b$export$2e2bcd8739ae039);
/* CreateSubpage.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $hzWaA = parcelRequire("hzWaA");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $fWb5q = parcelRequire("fWb5q");

var $hO3zy = parcelRequire("hO3zy");
var $bEwPd = parcelRequire("bEwPd");

var $1W2Av = parcelRequire("1W2Av");

var $7mtMc = parcelRequire("7mtMc");

var $2kZKn = parcelRequire("2kZKn");

var $dIqcw = parcelRequire("dIqcw");

var $7aCqr = parcelRequire("7aCqr");

var $2AAUS = parcelRequire("2AAUS");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $drATu = parcelRequire("drATu");

var $1b6Nh = parcelRequire("1b6Nh");

var $eiO6t = parcelRequire("eiO6t");

var $kjKdI = parcelRequire("kjKdI");
const $9414f4189dbcbb3b$var$styles = {
    fullContainer: "_4t3i1osq"
};
const $9414f4189dbcbb3b$var$unknownErrorTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We encountered an unknown error.",
    id: "applinks.administration.ui.unknown-error"
});
const $9414f4189dbcbb3b$var$createLinkTypeOAuth2NonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Atlassian product via OAuth 2.0",
    id: "applinks.administration.ui.creation-flow-dialog.create-link-type-oauth2-nonfinal"
});
const $9414f4189dbcbb3b$var$createLinkTypeOAuth1NonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Direct application link via OAuth 1.0",
    id: "applinks.administration.ui.creation-flow-dialog.create-link-type-oauth1-nonfinal"
});
const $9414f4189dbcbb3b$var$createLinkTypeTunnelNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Existing application tunnel",
    id: "applinks.administration.ui.creation-flow-dialog.create-link-type-tunnel-nonfinal"
});
const $9414f4189dbcbb3b$var$requiredFieldsTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Required fields are marked with an asterisk",
    id: "applinks.administration.ui.creation-flow-dialog.required-fields-text"
});
const $9414f4189dbcbb3b$var$cancelButtonTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Cancel",
    id: "applinks.administration.ui.creation-flow-dialog.cancel-form-button-text-nonfinal"
});
const $9414f4189dbcbb3b$var$nextButtonTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Next",
    id: "applinks.administration.ui.creation-flow-dialog.next-form-button-text-nonfinal"
});
const $9414f4189dbcbb3b$var$createApplicationLinkInformationTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "An application link requires an existing application tunnel or the application's URL. We use either one to connect the application to Jira.",
    id: "applinks.administration.ui.creation-flow-dialog.create-application-link-information-text-nonfinal"
});
const $9414f4189dbcbb3b$var$createApplicationLinkHowToLinkTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "How to create an application link",
    id: "appinks.administration.ui.creation-flow-dialog.create-application-link-how-to-text-nonfinal"
});
const $9414f4189dbcbb3b$var$createHeaderTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create an application link",
    id: "applinks.administration.ui.creation-flow-dialog.create-header-text-nonfinal"
});
const $9414f4189dbcbb3b$var$createSupportedLinkTypesHelperMessageNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Check the application's documentation for supported link types",
    id: "applinks.administration.ui.creation-flow-dialog.create-supported-link-types-helper-message-nonfinal"
});
const $9414f4189dbcbb3b$var$createUrlEntryHelperMessageNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Enter the URL for the Atlassian product",
    id: "applinks.administration.ui.creation-flow-dialog.create-url-entry-helper-message-nonfinal"
});
const $9414f4189dbcbb3b$var$createInvalidUrlErrorMessageNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "You must enter a valid URL",
    id: "applinks.administration.ui.creation-flow-dialog.create-invalid-url-error-message-nonfinal"
});
const $9414f4189dbcbb3b$var$CreateSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const createLocalisedRadioOptions = (0, $euxye.useCallback)(()=>{
        const linkTypeRadioOptions = [
            {
                name: 'linkType',
                value: 'OAUTH2.0',
                label: formatMessage($9414f4189dbcbb3b$var$createLinkTypeOAuth2NonfinalMessage)
            },
            {
                name: 'linkType',
                value: 'OAUTH1.0',
                label: formatMessage($9414f4189dbcbb3b$var$createLinkTypeOAuth1NonfinalMessage)
            },
            {
                name: 'linkType',
                value: 'TUNNEL',
                label: formatMessage($9414f4189dbcbb3b$var$createLinkTypeTunnelNonfinalMessage)
            }
        ];
        return linkTypeRadioOptions;
    }, [
        formatMessage
    ]);
    const onFormSubmit = async (data)=>{
        try {
            const remoteManifestPromise = (0, $drATu.fetchApplinkManifestForUrl)(data.remoteUrl);
            const localManifestPromise = (0, $drATu.fetchThisManifest)();
            const remoteManifest = await remoteManifestPromise;
            const localManifest = await localManifestPromise; // Check the remote application supports the selected variant type
            if (data.linkType === 'OAUTH2.0' && !remoteManifest.inboundAuthenticationTypes.includes((0, $1b6Nh.APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK))) // TODO: Better error message - maybe a custom dialogue?
            throw new Error('The remote application does not support OAuth 2.0 authentication. Please select a different link type.');
            props.onSuccess({
                kind: 'review',
                variant: data.linkType,
                localManifest: localManifest,
                remoteManifest: remoteManifest,
                rpcUrl: data.remoteUrl
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            if (data.linkType === 'OAUTH1.0') {
                if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onSuccess({
                    kind: 'manual-create',
                    variant: 'OAUTH1.0',
                    error: (0, $kjKdI.formatBackendError)(maybeError, formatMessage($9414f4189dbcbb3b$var$unknownErrorTextMessage))
                });
                else props.onSuccess({
                    kind: 'manual-create',
                    variant: 'OAUTH1.0',
                    error: maybeError ? maybeError.message : formatMessage($9414f4189dbcbb3b$var$unknownErrorTextMessage)
                });
            } else {
                (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.create.submitCreateForm', 'Failed to submit create form', maybeError);
                if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($9414f4189dbcbb3b$var$unknownErrorTextMessage)));
                else props.onError(maybeError ? maybeError.message : formatMessage($9414f4189dbcbb3b$var$unknownErrorTextMessage));
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: onFormSubmit,
        xcss: $9414f4189dbcbb3b$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
            variant: null,
            kind: "create",
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), {
                label: "Form submit options"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, formatMessage($9414f4189dbcbb3b$var$cancelButtonTextNonfinalMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, formatMessage($9414f4189dbcbb3b$var$nextButtonTextNonfinalMessage))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
                title: formatMessage($9414f4189dbcbb3b$var$createHeaderTextNonfinalMessage)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), null, `${formatMessage($9414f4189dbcbb3b$var$createApplicationLinkInformationTextNonfinalMessage)} `, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                href: "https://support.atlassian.com/jira-cloud-administration/docs/use-applinks-to-link-to-atlassian-products/",
                target: "_blank"
            }, ' ', formatMessage($9414f4189dbcbb3b$var$createApplicationLinkHowToLinkTextNonfinalMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                size: "small"
            }, formatMessage($9414f4189dbcbb3b$var$requiredFieldsTextMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dIqcw.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.default), {
                title: "Application link type"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
                label: "Link type",
                name: "linkType",
                defaultValue: "OAUTH2.0",
                isRequired: true
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2AAUS.default), {
                    ...fieldProps,
                    options: createLocalisedRadioOptions()
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($9414f4189dbcbb3b$var$createSupportedLinkTypesHelperMessageNonfinalMessage))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.default), {
                title: "External application details"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
                name: "remoteUrl",
                label: "Application URL",
                isRequired: true
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
                    autoComplete: "off",
                    placeholder: "https://example.atlassian.net",
                    ...fieldProps
                }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($9414f4189dbcbb3b$var$createUrlEntryHelperMessageNonfinalMessage)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, formatMessage($9414f4189dbcbb3b$var$createInvalidUrlErrorMessageNonfinalMessage))))))
        })));
};
$9414f4189dbcbb3b$var$CreateSubpage.displayName = "CreateSubpage";
var $9414f4189dbcbb3b$export$2e2bcd8739ae039 = $9414f4189dbcbb3b$var$CreateSubpage;

});
parcelRegister("7mtMc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c08823a811af7de4$export$2e2bcd8739ae039);
/* form-header.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2iotI = parcelRequire("2iotI");
const $c08823a811af7de4$var$formHeaderContentStyles = null;
const $c08823a811af7de4$var$formHeaderDescriptionStyles = null;
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $c08823a811af7de4$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};
$c08823a811af7de4$var$FormHeader.displayName = "FormHeader";
var $c08823a811af7de4$export$2e2bcd8739ae039 = $c08823a811af7de4$var$FormHeader;

});

parcelRegister("2AAUS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5696788832bf7c3$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $gUxVT = parcelRequire("gUxVT");

var $jIAwl = parcelRequire("jIAwl");
const $e5696788832bf7c3$var$noOptions = [];
function $e5696788832bf7c3$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $e5696788832bf7c3$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $2oRWW.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $gUxVT.useId)();
    const [selectedValue, setSelectedValue] = (0, $euxye.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $euxye.createElement)((0, $jIAwl.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}
$e5696788832bf7c3$export$2e2bcd8739ae039.displayName = "RadioGroup";

});
parcelRegister("jIAwl", function(module, exports) {
$parcel$export(module.exports, "default", () => $92be7ae6f137f34a$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.38.1 */ /// <reference types="node" />
// for typing `process`

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $aZBDA = parcelRequire("aZBDA");

var $2oRWW = parcelRequire("2oRWW");
const $92be7ae6f137f34a$var$packageName = "platform-pkg";
const $92be7ae6f137f34a$var$packageVersion = "0.0.0-use.local";
const $92be7ae6f137f34a$var$noop = (0, $2oRWW.default);
const $92be7ae6f137f34a$var$labelPaddingStyles = null;
const $92be7ae6f137f34a$var$labelStyles = null;
const $92be7ae6f137f34a$var$labelDisabledStyles = null;
const $92be7ae6f137f34a$var$radioBaseStyles = null;
const $92be7ae6f137f34a$var$radioInteractiveStyles = null;
const $92be7ae6f137f34a$var$radioDisabledStyles = null;
const $92be7ae6f137f34a$var$radioDisabledCheckedStyles = null;
const $92be7ae6f137f34a$var$radioInvalidStyles = null;
const $92be7ae6f137f34a$var$InnerRadio = /*#__PURE__*/ (0, $euxye.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $92be7ae6f137f34a$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $92be7ae6f137f34a$var$packageName,
        packageVersion: $92be7ae6f137f34a$var$packageVersion
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $4jQY2.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            isDisabled && "_syaz1gmx _80om13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $4jQY2.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
                    !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
                    isDisabled && "_80om13gf _1q6q187o _1151bk0g _1s6w2sac",
                    isDisabled && isChecked && "_tqbwt94y",
                    isInvalid && !isDisabled && "_1151s4qr _11jys4qr"
                ])
            }),
            label ? /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $92be7ae6f137f34a$var$Radio = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)($92be7ae6f137f34a$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $92be7ae6f137f34a$export$2e2bcd8739ae039 = $92be7ae6f137f34a$var$Radio;

});


parcelRegister("eiO6t", function(module, exports) {
$parcel$export(module.exports, "SubpageTemplate", () => $09290548e7b73bb7$export$10a563abcf67156);
/* SubpageTemplate.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $4CTxE = parcelRequire("4CTxE");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $7hCmd = parcelRequire("7hCmd");

var $i68tN = parcelRequire("i68tN");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $09290548e7b73bb7$var$styles = {
    container: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _4t3i1osq",
    mainContentInner: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1c3h",
    mainContent: "_16jlkb7n _1o9zidpf _i0dl1wug _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
    footerContent: "_1o9zidpf",
    footerContentInner: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1c3h",
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _19pkpxbi"
};
const $09290548e7b73bb7$var$UNKNOWN_STEP_ORDER = [
    'create',
    'unknown'
];
const $09290548e7b73bb7$var$OAUTH1_STEP_ORDER = [
    'create',
    'review',
    'reciprocal-prompt',
    'confirmation'
];
const $09290548e7b73bb7$var$OAUTH2_STEP_ORDER = [
    'create',
    'review',
    'connect'
];
const $09290548e7b73bb7$var$createStepNameMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create link",
    id: "applinks.administration.ui.creation-flow-dialog.create-step-name"
});
const $09290548e7b73bb7$var$reviewStepNameMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review link",
    id: "applinks.administration.ui.creation-flow-dialog.review-step-name"
});
const $09290548e7b73bb7$var$reciprocalPromptStepNameNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create reciprocal link",
    id: "applinks.administration.ui.creation-flow-dialog.reciprocal-prompt-name"
});
const $09290548e7b73bb7$var$connectStepNameMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Configure link",
    id: "applinks.administration.ui.creation-flow-dialog.connect-step-name"
});
const $09290548e7b73bb7$var$confirmationStepNameNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Confirmation",
    id: "applinks.administration.ui.creation-flow-dialog.confirmation-step-name"
});
const $09290548e7b73bb7$var$unknownStepNameNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Configure link",
    id: "applinks.administration.ui.creation-flow-dialog.unknown-step-name"
});
const $09290548e7b73bb7$var$stepNames = {
    create: $09290548e7b73bb7$var$createStepNameMessage,
    review: $09290548e7b73bb7$var$reviewStepNameMessage,
    'reciprocal-prompt': $09290548e7b73bb7$var$reciprocalPromptStepNameNonfinalMessage,
    connect: $09290548e7b73bb7$var$connectStepNameMessage,
    confirmation: $09290548e7b73bb7$var$confirmationStepNameNonfinalMessage,
    unknown: $09290548e7b73bb7$var$unknownStepNameNonfinalMessage
};
const $09290548e7b73bb7$var$determineStepPercentage = (currentStep, targetStep, sequence)=>{
    if (currentStep === 'manual-create' && targetStep === 'create') return 50; // Special case for manual create step
    const currentIndex = sequence.indexOf(currentStep);
    const targetIndex = sequence.indexOf(targetStep);
    if (currentIndex > targetIndex) return 100;
    if (currentIndex === targetIndex) return 0;
    return 0;
};
const $09290548e7b73bb7$var$determineStepStatus = (currentStep, targetStep, sequence)=>{
    if (currentStep === 'manual-create' && targetStep === 'create') return 'current'; // Special case for manual create step
    const currentIndex = sequence.indexOf(currentStep);
    const targetIndex = sequence.indexOf(targetStep);
    if (currentIndex > targetIndex) return 'disabled';
    if (currentIndex === targetIndex) return 'current';
    return 'unvisited';
};
const $09290548e7b73bb7$var$buildSteps = (step, sequence, formatMessage)=>{
    return sequence.map((s)=>({
            id: s,
            label: formatMessage($09290548e7b73bb7$var$stepNames[s]),
            percentageComplete: $09290548e7b73bb7$var$determineStepPercentage(step, s, sequence),
            status: $09290548e7b73bb7$var$determineStepStatus(step, s, sequence),
            href: '#'
        }));
};
const $09290548e7b73bb7$var$buildProgressTrackerItems = (step, variant, formatMessage)=>{
    if (variant === null) return $09290548e7b73bb7$var$buildSteps(step, $09290548e7b73bb7$var$UNKNOWN_STEP_ORDER, formatMessage);
    switch(variant){
        case 'OAUTH1.0':
            return $09290548e7b73bb7$var$buildSteps(step, $09290548e7b73bb7$var$OAUTH1_STEP_ORDER, formatMessage);
        case 'TUNNEL':
            return $09290548e7b73bb7$var$buildSteps(step, $09290548e7b73bb7$var$OAUTH1_STEP_ORDER, formatMessage);
        // Tunnel uses the same steps as OAUTH1.0
        case 'OAUTH2.0':
            return $09290548e7b73bb7$var$buildSteps(step, $09290548e7b73bb7$var$OAUTH2_STEP_ORDER, formatMessage);
        default:
            return [];
    }
};
const $09290548e7b73bb7$export$8b251419efc915eb = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getItems = (0, $euxye.useCallback)(()=>{
        return $09290548e7b73bb7$var$buildProgressTrackerItems(props.kind, props.variant, formatMessage);
    }, [
        formatMessage,
        props.kind,
        props.variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4CTxE.DrawerCloseButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7hCmd.default), {
        items: getItems(),
        spacing: "comfortable"
    }));
};
$09290548e7b73bb7$export$8b251419efc915eb.displayName = "Header";
const $09290548e7b73bb7$export$a06f1c675e846f6f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $09290548e7b73bb7$var$styles.footerContentInner,
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        alignInline: "end",
        space: "space.050"
    }, props.buttons));
};
$09290548e7b73bb7$export$a06f1c675e846f6f.displayName = "Footer";
const $09290548e7b73bb7$export$10a563abcf67156 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        xcss: $09290548e7b73bb7$var$styles.container,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($09290548e7b73bb7$export$8b251419efc915eb, {
        variant: props.variant,
        kind: props.kind
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("hr", {
        role: "presentation",
        className: (0, $4jQY2.default)([
            $09290548e7b73bb7$var$styles.dividerStyle
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $09290548e7b73bb7$var$styles.mainContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $09290548e7b73bb7$var$styles.mainContentInner
    }, props.content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $09290548e7b73bb7$var$styles.footerContent,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("hr", {
        role: "presentation",
        className: (0, $4jQY2.default)([
            $09290548e7b73bb7$var$styles.dividerStyle
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($09290548e7b73bb7$export$a06f1c675e846f6f, {
        buttons: props.buttons
    })));
$09290548e7b73bb7$export$10a563abcf67156.displayName = "SubpageTemplate";

});
parcelRegister("4CTxE", function(module, exports) {
$parcel$export(module.exports, "DrawerCloseButton", () => $e640051cc21f6b1b$export$d0c3a75c17ac0cab);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $6JMJ2 = parcelRequire("6JMJ2");

var $eYpfY = parcelRequire("eYpfY");

var $8JVZz = parcelRequire("8JVZz");
const $e640051cc21f6b1b$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $eYpfY.useEnsureIsInsideDrawer)();
    const onClose = (0, $8JVZz.useOnClose)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                ...iconProps,
                size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($6JMJ2))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};
$e640051cc21f6b1b$export$d0c3a75c17ac0cab.displayName = "DrawerCloseButton";

});
parcelRegister("8JVZz", function(module, exports) {
$parcel$export(module.exports, "useOnClose", () => $fed5ed966a5d1fa7$export$c2b12c82f332a6fb);

var $euxye = parcelRequire("euxye");

var $1u2qL = parcelRequire("1u2qL");
const $fed5ed966a5d1fa7$export$c2b12c82f332a6fb = ()=>(0, $euxye.useContext)((0, $1u2qL.OnCloseContext));

});


parcelRegister("7hCmd", function(module, exports) {
$parcel$export(module.exports, "default", () => $885ff51302bb8888$export$2e2bcd8739ae039);
/* progress-tracker.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $gR4FD = parcelRequire("gR4FD");

var $kenDo = parcelRequire("kenDo");
const $885ff51302bb8888$var$containerStyles = null;
const $885ff51302bb8888$var$spacingOptions = {
    comfortable: "var(--ds-space-500, 40px)",
    cozy: "var(--ds-space-200, 16px)",
    // @deprecated left for backwards compatibility
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
/**
 * __Progress tracker__
 *
 * A progress tracker displays the steps and progress through a journey.
 *
 * - [Examples](https://atlassian.design/components/progress-tracker/examples)
 * - [Code](https://atlassian.design/components/progress-tracker/code)
 * - [Usage](https://atlassian.design/components/progress-tracker/usage)
 */ const $885ff51302bb8888$var$ProgressTracker = ({ items: items = [], spacing: spacing = 'cozy', render: render = {
    link: ({ item: item })=>// Anchor content is coming from another location
        // eslint-disable-next-line @atlassian/a11y/anchor-has-content
        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gR4FD.default), {
            ...item
        })
}, animated: animated = true, testId: testId, label: label = 'Progress' })=>{
    const prevItems = (0, $euxye.useRef)(items.map((stage)=>({
            ...stage,
            percentageComplete: 0
        })));
    const previousStages = items.map((stage)=>{
        const oldStage = prevItems.current?.find((st)=>st.id === stage.id);
        return !!oldStage ? oldStage : stage;
    });
    (0, $euxye.useEffect)(()=>{
        prevItems.current = items;
    }, [
        items
    ]);
    const progressChanges = items.filter((stage, index)=>stage.percentageComplete !== previousStages[index].percentageComplete).length;
    const totalStepsForward = items.filter((stage, index)=>stage.percentageComplete > previousStages[index].percentageComplete).length;
    const totalStepsBack = items.filter((stage, index)=>stage.percentageComplete < previousStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const progressItems = items.map((stage, index)=>{
        let transitionSpeed = 0;
        let transitionDelay = 0;
        const transitionEasing = progressChanges > 1 ? 'linear' : 'cubic-bezier(0.15,1,0.3,1)';
        if (animated) {
            transitionSpeed = progressChanges > 1 ? 50 : 300;
            if (stage.percentageComplete < previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially in reverse.
         */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                stepsBack -= 1;
            } else if (stage.percentageComplete > previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially.
         */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                stepsForward -= 1;
            }
        }
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kenDo.default), {
            transitionSpeed: transitionSpeed,
            transitionDelay: transitionDelay,
            transitionEasing: transitionEasing,
            item: stage,
            render: render
        }, stage.id);
    });
    const listInlineStyles = {
        gridTemplateColumns: `repeat(${items.length}, 1fr)`,
        ['--ds--pt--sp']: $885ff51302bb8888$var$spacingOptions[spacing],
        maxWidth: 80 * items.length * 2
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)("ol", {
        "data-testid": testId,
        style: listInlineStyles,
        "aria-label": label,
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp6odm _1e0c11p5 _1bsb1osq _2mzuglyw _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _rxvc1jfw"
        ]),
        children: progressItems
    });
};
$885ff51302bb8888$var$ProgressTracker.displayName = "ProgressTracker";
var $885ff51302bb8888$export$2e2bcd8739ae039 = $885ff51302bb8888$var$ProgressTracker;

});
parcelRegister("gR4FD", function(module, exports) {
$parcel$export(module.exports, "default", () => $97a9475842818275$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $9MWap = parcelRequire("9MWap");
const $97a9475842818275$var$styles = {
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _11c81kw7 _2rko12b0 _syazi7uo _1e0c1ule _9oik18uv _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Progress tracker link__
 */ const $97a9475842818275$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.default), {
        xcss: $97a9475842818275$var$styles.anchor,
        // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
        href: href || '',
        onClick: onClick,
        testId: testId,
        children: label
    });
};
$97a9475842818275$var$Link.displayName = "Link";
var $97a9475842818275$export$2e2bcd8739ae039 = $97a9475842818275$var$Link;

});

parcelRegister("kenDo", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e7372e08fb3393d$export$2e2bcd8739ae039);
/* stage.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ihEDU = parcelRequire("ihEDU");

var $cpHkc = parcelRequire("cpHkc");

var $d0SJu = parcelRequire("d0SJu");
const $0e7372e08fb3393d$var$styles = {
    listItemContent: "_1bsb1osq _kqswh2mm"
};
const $0e7372e08fb3393d$var$textColor = {
    unvisited: "_syaz1rpy",
    current: "_syaz1oa5",
    visited: "_syazi7uo",
    disabled: "_syaz1gmx"
};
const $0e7372e08fb3393d$var$fontWeight = {
    unvisited: "_k48pi7a9",
    current: "_k48pwu06",
    visited: "_k48pwu06",
    disabled: "_k48pwu06"
};
const $0e7372e08fb3393d$var$listItemStyles = null;
const $0e7372e08fb3393d$var$fadeAnimationBase = null;
const $0e7372e08fb3393d$var$fadeIn = null;
const $0e7372e08fb3393d$var$fadeAnimationActive = null;
const $0e7372e08fb3393d$var$titleStyles = null;
class $0e7372e08fb3393d$export$2e2bcd8739ae039 extends (0, $euxye.PureComponent) {
    constructor(props){
        super(props), this.onEntered = ()=>{
            this.setState({
                transitioning: false,
                oldPercentageComplete: this.props.item.percentageComplete
            });
        };
        this.state = {
            transitioning: false,
            oldPercentageComplete: 0
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.item.status !== this.props.item.status || prevProps.item.percentageComplete !== this.props.item.percentageComplete) this.startTransition();
    }
    componentWillUnmount() {
        if (this.animationTimeoutId) clearTimeout(this.animationTimeoutId);
    }
    startTransition() {
        if (this.animationTimeoutId) clearTimeout(this.animationTimeoutId);
        this.setState({
            ...this.state,
            transitioning: true
        });
        const timeout = this.props.transitionDelay + this.props.transitionSpeed;
        this.animationTimeoutId = setTimeout(()=>{
            this.onEntered();
        }, timeout);
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && // TODO: `noLink` is unnecessary as we should just be detecting if the `href` is set...
        !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            ['--ds--pt--ts']: `${transitionSpeed}ms`,
            ['--ds--pt--td']: `${transitionDelay}ms`,
            ['--ds--pt--te']: transitionEasing
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: listInlineStyles,
            "aria-current": ariaCurrent,
            className: (0, $4jQY2.default)([
                "_2mzuglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1i4q1hna"
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                xcss: $0e7372e08fb3393d$var$styles.listItemContent,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d0SJu.default), {
                        testId: testId && `${testId}-marker`,
                        status: item.percentageComplete > 0 ? 'visited' : item.status
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        style: {
                            animationPlayState: this.state.transitioning ? 'running' : 'paused',
                            animationDuration: [
                                'visited',
                                'disabled'
                            ].includes(this.props.item.status) ? '0ms' : undefined
                        },
                        className: (0, $4jQY2.default)([
                            "_tzy4kb7n",
                            "_y44v18do _ju251oqq _1y0ctrqk"
                        ]),
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cpHkc.default), {
                            testId: testId && `${testId}-bar`,
                            percentageComplete: item.percentageComplete
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        "data-testid": testId && `${testId}-title`,
                        className: (0, $4jQY2.default)([
                            "_tzy4kb7n",
                            "_11c8fhey _1pfhv47k _y3gn1h6o",
                            $0e7372e08fb3393d$var$textColor[item.status],
                            $0e7372e08fb3393d$var$fontWeight[item.status]
                        ]),
                        children: this.shouldShowLink() ? render.link({
                            item: item
                        }) : item.label
                    })
                ]
            })
        });
    }
}
$0e7372e08fb3393d$export$2e2bcd8739ae039.displayName = "ProgressTrackerStage";

});
parcelRegister("cpHkc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0480631d63a08cb2$export$2e2bcd8739ae039);
/* bar.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $0480631d63a08cb2$var$spacing = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
const $0480631d63a08cb2$var$progressBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar describes the horizontal tracking bar that traverses each individual step.
 *
 */ const $0480631d63a08cb2$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(--ds--pt--sp, ${$0480631d63a08cb2$var$spacing.cosy}) + ${"var(--ds-space-050, 4px)"}))`
        },
        className: (0, $4jQY2.default)([
            "_v564d86a _4t3iu2gc _kqswstnw _bfhk1856 _1ein1cuf _5fbc1cuf _1e021ssb _t9ecymk3 _1lww1oqq"
        ])
    });
$0480631d63a08cb2$var$ProgressBar.displayName = "ProgressBar";
var $0480631d63a08cb2$export$2e2bcd8739ae039 = $0480631d63a08cb2$var$ProgressBar;

});

parcelRegister("d0SJu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f455f93dc395f620$export$2e2bcd8739ae039);
/* marker.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $f455f93dc395f620$var$progressMarkerStyles = null;
const $f455f93dc395f620$var$markerColor = {
    unvisited: "_bfhk1aqn",
    current: "_bfhk1856",
    visited: "_bfhk1856",
    disabled: "_bfhk187o"
};
/**
 * __Progress marker__
 *
 * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
 */ const $f455f93dc395f620$var$ProgressMarker = ({ testId: testId, status: status = 'unvisited' })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_2rkou2gc _v564vc7x _1bsbu2gc _4t3iu2gc _kqswstnw _1e021ssb _t9ec157a",
            $f455f93dc395f620$var$markerColor[status]
        ])
    });
$f455f93dc395f620$var$ProgressMarker.displayName = "ProgressMarker";
var $f455f93dc395f620$export$2e2bcd8739ae039 = $f455f93dc395f620$var$ProgressMarker;

});





parcelRegister("aKKFI", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd0b8a3fbded0234$export$2e2bcd8739ae039);
/* ReviewSubpage.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $fWb5q = parcelRequire("fWb5q");

var $7mtMc = parcelRequire("7mtMc");

var $67bq1 = parcelRequire("67bq1");

var $cdF7h = parcelRequire("cdF7h");

var $fXX7T = parcelRequire("fXX7T");

var $8Sdzy = parcelRequire("8Sdzy");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $01dJR = parcelRequire("01dJR");

var $2ffUK = parcelRequire("2ffUK");
var $55BnK = parcelRequire("55BnK");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $5T7Xn = parcelRequire("5T7Xn");

var $cFFXQ = parcelRequire("cFFXQ");

var $drATu = parcelRequire("drATu");

var $l7m8P = parcelRequire("l7m8P");

var $1b6Nh = parcelRequire("1b6Nh");

var $6bB9L = parcelRequire("6bB9L");

var $9xWqG = parcelRequire("9xWqG");

var $eiO6t = parcelRequire("eiO6t");

var $kjKdI = parcelRequire("kjKdI");
const $fd0b8a3fbded0234$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $fd0b8a3fbded0234$var$unknownErrorTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We encountered an unknown error.",
    id: "applinks.administration.ui.unknown-error"
});
const $fd0b8a3fbded0234$var$unknownConnectionTypeErrorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Unknown connection type selected.",
    id: "applinks.administration.ui.creation-flow-dialog.unknown-connection-type-error"
});
const $fd0b8a3fbded0234$var$localProductCardHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "This application",
    id: "applinks.administration.ui.creation-flow-dialog.local-product-card-header"
});
const $fd0b8a3fbded0234$var$remoteProductCardHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Remote application",
    id: "applinks.administration.ui.creation-flow-dialog.remote-product-card-header"
});
const $fd0b8a3fbded0234$var$formCancelButtonTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Cancel",
    id: "applinks.administration.ui.creation-flow-dialog.form-cancel-button-text"
});
const $fd0b8a3fbded0234$var$reviewOAuth1HeaderNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review OAuth 1.0 link",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-header-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewOAuth2HeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review OAuth 2.0 link",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-2-header"
});
const $fd0b8a3fbded0234$var$reviewTunneledHeaderNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review tunneled link",
    id: "applinks.administration.ui.creation-flow-dialog.review-tunneled-header-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewIncomingLinkHeaderNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review incoming link",
    id: "applinks.administration.ui.creation-flow-dialog.review-incoming-link-header-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewOAuth1DescriptionNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Confirm the details of the application link you are creating. This will allow the remote <strong>{nameOfRemoteProduct}</strong> to access this {nameOfThisProduct} site. You will later be redirected to {nameOfRemoteProduct} to complete the other side of the link.",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-description-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewOAuth2DescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Confirm the details of the application link you're creating. In the next step, you'll exchange credentials to allow the remote <strong>{nameOfRemoteProduct}</strong> to communicate with this {nameOfThisProduct} site.",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-2-description"
});
const $fd0b8a3fbded0234$var$reviewOAuth2SelectConnectionLabelMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Available connections",
    id: "applinks.administration.ui.creation-flow-dialog.select-connection-label"
});
const $fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Public connection",
    id: "applinks.administration.ui.creation-flow-dialog.public-connection-label"
});
const $fd0b8a3fbded0234$var$reviewOAuth2TunnelConnectionDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connect securely via application tunnel",
    id: "applinks.administration.ui.creation-flow-dialog.tunnel-connection-description"
});
const $fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connect directly via public internet",
    id: "applinks.administration.ui.creation-flow-dialog.public-connection-description"
});
const $fd0b8a3fbded0234$var$reviewOAuth1ReciprocalDescriptionNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "The remote <strong>{nameOfRemoteProduct}</strong> application has requested to create a link to this {nameOfThisProduct} site. Review the details below before completing the link. This will allow the remote {nameOfRemoteProduct} to access this site.",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-reciprocal-description-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewFormCompleteLinkButtonNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Complete link",
    id: "applinks.administration.ui.creation-flow-dialog.review-form-complete-link-button-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewFormCreateLinkButtonMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create link",
    id: "applinks.administration.ui.creation-flow-dialog.review-form-create-link-button"
});
const $fd0b8a3fbded0234$var$ReviewSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const [_, setCloudConnectorQueryParam] = (0, $2ffUK.useQueryParam)('cloudConnectorId');
    const reciprocalMode = props.state.kind === 'reciprocal-review';
    const thisApplicationManifest = props.state.localManifest;
    const targetApplicationManifest = props.state.remoteManifest;
    const [targetApplicationRpcUrl, setTargetApplicationRpcUrl] = (0, $euxye.useState)(()=>{
        if ((0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs')) {
            const connections = props.availableConnections?.filter((conn)=>!conn.isDisabled) ?? []; // Favour tunneled connection
            const defaultConnection = connections.find((conn)=>conn.isTunnel) ?? connections[0];
            return defaultConnection?.url ?? props.state.rpcUrl;
        }
        return props.state.rpcUrl;
    }); // TODO: Determine if the type is DC or Cloud
    const thisApplicationType = (0, $5T7Xn.lookupTypeByTypeId)(thisApplicationManifest.typeId, false);
    const targetApplicationType = (0, $5T7Xn.lookupTypeByTypeId)(targetApplicationManifest.typeId, false);
    const onFormSubmitOAuth1 = async ()=>{
        const applinkCreationEntity = {
            id: targetApplicationManifest.id,
            name: targetApplicationManifest.name,
            displayUrl: targetApplicationManifest.url,
            rpcUrl: targetApplicationRpcUrl,
            typeId: targetApplicationManifest.typeId,
            isPrimary: false,
            isSystem: false,
            isOAuth2ThreeLoEnabled: false,
            isCloud: targetApplicationManifest.isCloud ?? false,
            productVersion: targetApplicationManifest.version
        };
        try {
            await (0, $drATu.putApplink)(applinkCreationEntity);
            if (props.state.kind === 'reciprocal-review' && props.state.inboundCreationState.applinkOriginalCreatedId) {
                // Configure OAuth
                await (0, $drATu.putApplinkOAuthOne3LOProvider)(targetApplicationManifest.id);
                await (0, $drATu.autoConfigureApplinkConsumer)(targetApplicationManifest.id);
                await (0, $drATu.putApplinkOAuthOne2LOProvider)(targetApplicationManifest.id); // Update status log
                const updatedApplinkCreationStatusLog = (0, $l7m8P.updateStatusLog)(props.state.inboundCreationState.applinkCreationStatusLog, {
                    status: (0, $l7m8P.STATUS_RECIPROCAL_SUCCESS)
                });
                const newCreationState = {
                    applinkCreationStatusLog: updatedApplinkCreationStatusLog,
                    applinkOriginalCreatedId: props.state.inboundCreationState.applinkOriginalCreatedId,
                    sharedUserbase: props.state.inboundCreationState.sharedUserbase,
                    applinkConfigInPreAuth: true,
                    applinkConfigInServerAuth: true,
                    applinkConfigInUserAuth: true,
                    applinkConfigOutPreAuth: true,
                    applinkConfigOutServerAuth: true,
                    applinkConfigOutUserAuth: true
                };
                const newRedirectionUrl = (0, $l7m8P.generateApplinksCreationRedirectionUrl)(targetApplicationManifest.url, targetApplicationManifest.typeId, newCreationState);
                push(newRedirectionUrl);
                return;
            }
            props.onSuccess({
                kind: 'reciprocal-prompt',
                variant: props.state.variant,
                remoteManifest: targetApplicationManifest,
                localManifest: thisApplicationManifest
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.review.submitOAuth1ReviewForm', 'Failed to create an OAuth 1.0 link after reviewing', maybeError);
            if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($fd0b8a3fbded0234$var$unknownErrorTextMessage)));
            else props.onError(maybeError ? maybeError.message : formatMessage($fd0b8a3fbded0234$var$unknownErrorTextMessage));
            return err;
        }
    };
    const onFormSubmitOAuth2 = async ()=>{
        const applinkCreationEntity = {
            id: targetApplicationManifest.id,
            name: targetApplicationManifest.name,
            displayUrl: targetApplicationManifest.url,
            rpcUrl: targetApplicationRpcUrl,
            typeId: targetApplicationManifest.typeId,
            isPrimary: false,
            isSystem: false,
            isOAuth2ThreeLoEnabled: true,
            isCloud: targetApplicationManifest.isCloud ?? false,
            productVersion: targetApplicationManifest.version
        };
        try {
            await (0, $drATu.createOAuth2Applink)(applinkCreationEntity);
            const oauth2ConfigInfo = await (0, $drATu.getOAuth2ConfigInfo)(targetApplicationManifest.id);
            const newlyCreatedApplink = await (0, $drATu.fetchApplink)(targetApplicationManifest.id);
            setCloudConnectorQueryParam(undefined, 'replace');
            props.onSuccess({
                kind: 'connect',
                variant: props.state.variant,
                applink: newlyCreatedApplink,
                oauth2ConfigInfo: oauth2ConfigInfo
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.review.submitOAuth2ReviewForm', 'Failed to create an OAuth 2.0 link after reviewing', maybeError);
            if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($fd0b8a3fbded0234$var$unknownErrorTextMessage)));
            else props.onError(maybeError ? maybeError.message : formatMessage($fd0b8a3fbded0234$var$unknownErrorTextMessage));
            return err;
        }
    };
    const onFormSubmit = async ()=>{
        switch(props.state.variant){
            case 'OAUTH1.0':
            case 'TUNNEL':
                return onFormSubmitOAuth1();
            case 'OAUTH2.0':
                return onFormSubmitOAuth2();
            default:
                props.onError(formatMessage($fd0b8a3fbded0234$var$unknownConnectionTypeErrorMessage));
        }
    };
    const getVariantProperName = (0, $euxye.useCallback)(()=>{
        switch(props.state.variant){
            case 'OAUTH1.0':
                return formatMessage($fd0b8a3fbded0234$var$reviewOAuth1HeaderNonfinalMessage);
            case 'OAUTH2.0':
                return formatMessage($fd0b8a3fbded0234$var$reviewOAuth2HeaderMessage);
            case 'TUNNEL':
            default:
                return formatMessage($fd0b8a3fbded0234$var$reviewTunneledHeaderNonfinalMessage);
        }
    }, [
        formatMessage,
        props.state.variant
    ]);
    const connectionGroups = (0, $euxye.useMemo)(()=>[
            {
                groupId: 'connections',
                testId: 'connections-list',
                groupAriaLabel: formatMessage($fd0b8a3fbded0234$var$reviewOAuth2SelectConnectionLabelMessage),
                items: (0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') ? props.availableConnections?.map((conn)=>{
                    const isTunnel = conn.isTunnel;
                    return {
                        id: conn.url,
                        title: isTunnel ? conn.name : formatMessage($fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionTitleMessage),
                        description: isTunnel ? formatMessage($fd0b8a3fbded0234$var$reviewOAuth2TunnelConnectionDescriptionMessage) : formatMessage($fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionDescriptionMessage),
                        ariaLabel: isTunnel ? conn.name : formatMessage($fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionTitleMessage),
                        icon: isTunnel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fXX7T))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdF7h))), {
                            label: ""
                        }),
                        isDisabled: conn.isDisabled,
                        isRecommended: isTunnel
                    };
                }) ?? [] : []
            }
        ], [
        formatMessage,
        props.availableConnections
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: onFormSubmit,
        xcss: $fd0b8a3fbded0234$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
            variant: props.state.variant,
            kind: props.state.kind,
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, formatMessage($fd0b8a3fbded0234$var$formCancelButtonTextMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                testId: "applinks-administration.ui.list.creation-flow-dialog.review.submit-button",
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, reciprocalMode ? formatMessage($fd0b8a3fbded0234$var$reviewFormCompleteLinkButtonNonfinalMessage) : formatMessage($fd0b8a3fbded0234$var$reviewFormCreateLinkButtonMessage))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
                title: reciprocalMode ? formatMessage($fd0b8a3fbded0234$var$reviewIncomingLinkHeaderNonfinalMessage) : getVariantProperName()
            }, !reciprocalMode && (props.state.variant === 'OAUTH1.0' || props.state.variant === 'TUNNEL') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($fd0b8a3fbded0234$var$reviewOAuth1DescriptionNonfinalMessage, {
                nameOfThisProduct: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                        as: "strong"
                    }, chunks)
            })), !reciprocalMode && props.state.variant === 'OAUTH2.0' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($fd0b8a3fbded0234$var$reviewOAuth2DescriptionMessage, {
                nameOfThisProduct: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                        as: "strong"
                    }, chunks)
            })), reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($fd0b8a3fbded0234$var$reviewOAuth1ReciprocalDescriptionNonfinalMessage, {
                nameOfThisProduct: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                        as: "strong"
                    }, chunks)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                xcss: $fd0b8a3fbded0234$var$styles.linkDisplay,
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default), {
                applicationType: thisApplicationType,
                displayUrl: thisApplicationManifest.url,
                heading: formatMessage($fd0b8a3fbded0234$var$localProductCardHeaderMessage)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
                space: "space.100",
                alignBlock: "center",
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($67bq1))), {
                label: ""
            }), reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozenge), {
                kind: "error",
                err: (0, $9xWqG.ERRORS).CONFIGURATION_COMPLETE
            }), !reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozenge), {
                kind: "not-connected"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default), {
                applicationType: targetApplicationType,
                displayUrl: targetApplicationManifest.url,
                heading: formatMessage($fd0b8a3fbded0234$var$remoteProductCardHeaderMessage)
            })), (0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $01dJR.default), {
                testId: "applinks-administration.ui.list.creation-flow-dialog.review.connections-list",
                onChange: (e, url)=>setTargetApplicationRpcUrl(url),
                selectedValue: targetApplicationRpcUrl,
                groups: connectionGroups
            })))
        })));
};
$fd0b8a3fbded0234$var$ReviewSubpage.displayName = "ReviewSubpage";
var $fd0b8a3fbded0234$export$2e2bcd8739ae039 = $fd0b8a3fbded0234$var$ReviewSubpage;

});
parcelRegister("cdF7h", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4a75f30383a815136b76433b9d7ec6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e5697ce5234b218$var$_react = $8e5697ce5234b218$var$_interopRequireDefault((parcelRequire("euxye")));

var $8e5697ce5234b218$var$_baseNew = $8e5697ce5234b218$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $8e5697ce5234b218$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e5697ce5234b218$var$GlobeIcon = (props)=>/*#__PURE__*/ $8e5697ce5234b218$var$_react.default.createElement($8e5697ce5234b218$var$_baseNew.default, Object.assign({
        name: "GlobeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$8e5697ce5234b218$var$GlobeIcon.displayName = 'GlobeIcon';
var $8e5697ce5234b218$var$_default = module.exports.default = $8e5697ce5234b218$var$GlobeIcon;

});

parcelRegister("fXX7T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b469831fd3ad0d6dbbee24964a60682>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9fa3af568015ca8$var$_react = $b9fa3af568015ca8$var$_interopRequireDefault((parcelRequire("euxye")));

var $b9fa3af568015ca8$var$_baseNew = $b9fa3af568015ca8$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $b9fa3af568015ca8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9fa3af568015ca8$var$ShieldIcon = (props)=>/*#__PURE__*/ $b9fa3af568015ca8$var$_react.default.createElement($b9fa3af568015ca8$var$_baseNew.default, Object.assign({
        name: "ShieldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.53.22a.75.75 0 0 0-1.06 0C6.172 1.518 4.686 2.41 3.515 2.982a16 16 0 0 1-1.434.615 11 11 0 0 1-.51.174l-.023.007-.005.001A.75.75 0 0 0 1 4.5c0 4.338 1.651 7.176 3.334 8.926.836.87 1.672 1.463 2.304 1.842a9 9 0 0 0 .999.519l.066.027.02.008.006.002.003.001a.76.76 0 0 0 .535 0h.004l.006-.003.02-.008.066-.027q.083-.035.227-.103c.19-.09.456-.226.772-.416a11.3 11.3 0 0 0 2.304-1.842C13.349 11.676 15 8.838 15 4.5a.75.75 0 0 0-.544-.721l-.004-.001-.024-.007-.103-.033a11 11 0 0 1-.406-.141c-.35-.13-.85-.33-1.434-.615C11.314 2.412 9.828 1.518 8.53.22M8 1.783C6.69 2.963 5.286 3.788 4.172 4.33a17 17 0 0 1-1.663.707c.128 3.604 1.532 5.92 2.907 7.35a9.8 9.8 0 0 0 1.993 1.595c.24.144.443.25.591.322.148-.072.35-.178.59-.322a9.8 9.8 0 0 0 1.994-1.596c1.375-1.43 2.779-3.745 2.907-7.349l-.09-.032a17 17 0 0 1-1.573-.675C10.714 3.788 9.31 2.963 8 1.783" clip-rule="evenodd"/>`
    }, props));
$b9fa3af568015ca8$var$ShieldIcon.displayName = 'ShieldIcon';
var $b9fa3af568015ca8$var$_default = module.exports.default = $b9fa3af568015ca8$var$ShieldIcon;

});

parcelRegister("01dJR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee3d04c20faec92c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");

var $jFb8V = parcelRequire("jFb8V");

var $cj3ZG = parcelRequire("cj3ZG");
const $ee3d04c20faec92c$var$styles = {
    groupContainer: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1ul9idpf",
    itemsMargin: "_19pkutpp",
    rowContainer: "_1n261g80 _zkhy1q9c",
    gridContainer: "_zulputpp _1e0c11p5"
};
const $ee3d04c20faec92c$var$SelectListItemsContainer = ({ direction: direction, children: children, gridColumns: gridColumns })=>{
    switch(direction){
        case 'row':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
                space: "space.150",
                alignBlock: "stretch",
                xcss: $ee3d04c20faec92c$var$styles.rowContainer,
                children: children
            });
        case 'column':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
                space: "space.150",
                children: children
            });
        case 'grid':
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic grid columns require inline style
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $ee3d04c20faec92c$var$styles.gridContainer,
                style: {
                    gridTemplateColumns: gridColumns ? `repeat(${gridColumns}, 1fr)` : 'repeat(auto-fill, minmax(200px, 1fr))'
                },
                children: children
            });
    }
};
$ee3d04c20faec92c$var$SelectListItemsContainer.displayName = "SelectListItemsContainer";
const $ee3d04c20faec92c$var$SelectList = (props)=>{
    const { groups: groups, testId: testId = 'select-list', direction: direction = 'column' } = props;
    // Single-select state
    const defaultSelected = !props.isMulti ? props.selectedValue || props.defaultValue : undefined;
    const [selected, setSelected] = (0, $euxye.useState)(defaultSelected);
    // Multi-select state
    const defaultSelectedMulti = props.isMulti ? props.defaultValues || [] : [];
    const [selectedMulti, setSelectedMulti] = (0, $euxye.useState)(defaultSelectedMulti);
    const handleChange = (event, newSelection)=>{
        if (props.isMulti) {
            // props is narrowed to SelectListMultiProps here — no cast needed
            const currentlySelected = selectedMulti.includes(newSelection) ? selectedMulti.filter((v)=>v !== newSelection) : [
                ...selectedMulti,
                newSelection
            ];
            setSelectedMulti(currentlySelected);
            props.onChange(event, currentlySelected);
        } else {
            // props is narrowed to SelectListSingleProps here — no cast needed
            setSelected(newSelection);
            props.onChange(event, newSelection);
        }
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
        space: "space.200",
        testId: testId,
        children: groups.map(({ items: items, groupId: groupId, groupName: groupName, groupDescriptionIcon: groupDescriptionIcon, groupDescription: groupDescription, groupDescriptionInfoLink: groupDescriptionInfoLink, groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage, groupAriaLabel: groupAriaLabel })=>{
            return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                as: "fieldset",
                "aria-label": groupAriaLabel,
                xcss: $ee3d04c20faec92c$var$styles.groupContainer,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cj3ZG.GroupHeading), {
                        testId: testId,
                        groupId: groupId,
                        groupName: groupName,
                        groupDescriptionIcon: groupDescriptionIcon,
                        groupDescription: groupDescription,
                        groupDescriptionInfoLink: groupDescriptionInfoLink,
                        groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                        xcss: $ee3d04c20faec92c$var$styles.itemsMargin,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)($ee3d04c20faec92c$var$SelectListItemsContainer, {
                            direction: direction,
                            gridColumns: props.columns,
                            children: items.map((itemProps, index)=>{
                                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jFb8V.SelectCard), {
                                    testId: `${testId}-card-${index}`,
                                    handleChange: handleChange,
                                    selected: selected,
                                    selectedMulti: props.isMulti ? selectedMulti : undefined,
                                    isMulti: props.isMulti,
                                    direction: direction,
                                    radioGroupName: !props.isMulti ? props.radioGroupName : undefined,
                                    ...itemProps
                                }, itemProps.id);
                            })
                        })
                    })
                ]
            }, groupId);
        })
    });
};
$ee3d04c20faec92c$var$SelectList.displayName = "SelectList";
var $ee3d04c20faec92c$export$2e2bcd8739ae039 = $ee3d04c20faec92c$var$SelectList;

});
parcelRegister("jFb8V", function(module, exports) {
$parcel$export(module.exports, "SelectCard", () => $4440c6912e5d1d71$export$2587035f1fd37910);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $apqVV = parcelRequire("apqVV");

var $6Elhl = parcelRequire("6Elhl");
var $fbAgj = parcelRequire("fbAgj");

var $jIAwl = parcelRequire("jIAwl");

var $9q0zj = parcelRequire("9q0zj");

var $9XEKX = parcelRequire("9XEKX");

var $aBLn9 = parcelRequire("aBLn9");
function $4440c6912e5d1d71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4440c6912e5d1d71$var$styles = (0, $fbAgj.xcss)({
    marginLeft: 'space.200'
});
const $4440c6912e5d1d71$var$contentBaseStyles = {
    name: "rzk3s2",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #6B6E76);margin-left:var(--ds-space-500, 40px);margin-top:var(--ds-space-200, 16px)"
};
const $4440c6912e5d1d71$var$columnContentExpandedStyles = {
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
};
const $4440c6912e5d1d71$var$rowContentStyles = /*#__PURE__*/ (0, $hStPE.css)({
    margin: `${"var(--ds-space-100, 8px)"} 0 0 36px`
});
const $4440c6912e5d1d71$export$2587035f1fd37910 = (props)=>{
    const [isContentExpanded, setIsContentExpanded] = (0, $euxye.useState)(false);
    const { icon: icon, testId: testId, id: id, handleChange: handleChange, selected: selected, selectedMulti: selectedMulti, isMulti: isMulti, title: title, description: description, content: content, contentType: contentType = 'default', contentExpandableLabel: contentExpandableLabel, direction: direction = 'column', image: image, isRecommended: isRecommended = false, radioGroupName: radioGroupName, isDisabled: isDisabled, ariaLabel: ariaLabel } = props;
    const isSelected = isMulti ? selectedMulti?.includes(id) ?? false : selected === id;
    const handleDropdownClicked = ()=>{
        setIsContentExpanded(!isContentExpanded);
    };
    const control = isMulti ? /*#__PURE__*/ (0, $hStPE.jsx)((0, $apqVV.default), {
        value: `${id}`,
        testId: `${testId}-checkbox`,
        isChecked: isSelected,
        onChange: (e)=>{
            handleChange(e, id);
        },
        onClick: (e)=>{
            e.stopPropagation();
        },
        isDisabled: isDisabled,
        "aria-label": ariaLabel || id
    }) : /*#__PURE__*/ (0, $hStPE.jsx)((0, $jIAwl.default), {
        key: id,
        value: `${id}`,
        name: radioGroupName ? radioGroupName : 'radio-default',
        testId: `${testId}-radio-default`,
        isChecked: isSelected,
        tabIndex: 0,
        onChange: (e)=>{
            handleChange(e, id);
        },
        onClick: (e)=>{
            e.stopPropagation();
        },
        isDisabled: isDisabled,
        ariaLabel: ariaLabel || id
    });
    const handleCardContainerClick = (e, id)=>{
        if (isDisabled) {
            e.stopPropagation();
            return;
        }
        handleChange(e, id);
    };
    const columnVariant = /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnLeftContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnTopContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnTopLeftContainer), null, control, icon && /*#__PURE__*/ (0, $hStPE.jsx)((0, $6Elhl.default), {
        xcss: $4440c6912e5d1d71$var$styles
    }, icon), /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.TitleAndDescriptionContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.Title), {
        "data-testid": `${testId}-title`
    }, title), description && /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.Description), {
        "data-testid": `${testId}-description`
    }, description))), /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnTopRightContainer), null, contentType === 'expandable' && /*#__PURE__*/ (0, $hStPE.jsx)((0, $9q0zj.ContentDropdown), {
        testId: testId,
        isExpanded: isContentExpanded,
        onClick: handleDropdownClicked,
        contentExpandableLabel: contentExpandableLabel
    }))), /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), null, contentType === 'expandable' && isContentExpanded && content && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: [
            $4440c6912e5d1d71$var$contentBaseStyles,
            $4440c6912e5d1d71$var$columnContentExpandedStyles
        ]
    }, content), contentType === 'default' && content && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: [
            $4440c6912e5d1d71$var$contentBaseStyles
        ]
    }, content))), image && /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnRightContainer), null, image));
    const rowVariant = /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), null, image && /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowTopContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowImage), null, image)), /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowMidContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowRadioContainer), null, control), icon && /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowIcon), null, icon), /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.Title), null, title)), content && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: [
            $4440c6912e5d1d71$var$contentBaseStyles,
            $4440c6912e5d1d71$var$rowContentStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.CardContainer), {
        "data-testid": testId,
        key: id,
        isSelected: isSelected,
        onClick: (e)=>handleCardContainerClick(e, id),
        direction: direction,
        isDisabled: isDisabled
    }, isRecommended && /*#__PURE__*/ (0, $hStPE.jsx)((0, $9XEKX.RecommendedBadge), {
        testId: `${testId}-recommended-badge`,
        isSelected: isSelected
    }), direction === 'column' || direction === 'grid' ? columnVariant : rowVariant);
};
$4440c6912e5d1d71$export$2587035f1fd37910.displayName = "SelectCard";

});
parcelRegister("9q0zj", function(module, exports) {
$parcel$export(module.exports, "ContentDropdown", () => $edb8bca8c45bf806$export$90094d804b0e3756);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $ld25x = parcelRequire("ld25x");

var $aFpts = parcelRequire("aFpts");

var $jYEcG = parcelRequire("jYEcG");
var $fbAgj = parcelRequire("fbAgj");

var $dsh3V = parcelRequire("dsh3V");
const $edb8bca8c45bf806$var$DROPDOWN_LABEL_LIMIT = 20;
const $edb8bca8c45bf806$var$messages = (0, $7eNDO.defineMessages)({
    showDetails: {
        defaultMessage: 'SHOW DETAILS',
        description: 'the default title of the select list dropdown label',
        id: 'selectList.card.cardDropdown.showDetails'
    },
    expand: {
        defaultMessage: 'Expand {contentExpandableLabel, select, undefined {DETAILS} other {{contentExpandableLabel}}}',
        description: 'The accessible label for the expand dropdown icon, will use the contentExpandableLabel if it is provided',
        id: 'selectList.card.cardDropdown.expand'
    },
    collapse: {
        defaultMessage: 'Collapse {contentExpandableLabel, select, undefined {DETAILS} other {{contentExpandableLabel}}}',
        description: 'The accessible label for the collapse dropdown icon, will use the contentExpandableLabel if it is provided',
        id: 'selectList.card.cardDropdown.collapse'
    }
});
const $edb8bca8c45bf806$var$buttonStyles = (0, $fbAgj.xcss)({
    font: 'font.body.small',
    fontWeight: 'font.weight.semibold',
    paddingInline: 'space.0',
    color: 'color.text.subtle',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $edb8bca8c45bf806$export$90094d804b0e3756 = (props)=>{
    const intl = (0, $1YIbA.default)();
    const { testId: testId, isExpanded: isExpanded, onClick: onClick, contentExpandableLabel: contentExpandableLabel } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $jYEcG.default), {
        onClick: onClick,
        testId: `${testId}-show-expanded-card`,
        backgroundColor: "elevation.surface.overlay",
        xcss: $edb8bca8c45bf806$var$buttonStyles,
        "aria-expanded": isExpanded,
        children: [
            (0, $dsh3V.stringLimiter)($edb8bca8c45bf806$var$DROPDOWN_LABEL_LIMIT, contentExpandableLabel).value || intl.formatMessage($edb8bca8c45bf806$var$messages.showDetails),
            isExpanded ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFpts))), {
                color: "currentColor",
                spacing: "spacious",
                label: intl.formatMessage($edb8bca8c45bf806$var$messages.collapse, {
                    contentExpandableLabel: contentExpandableLabel
                }),
                size: "small"
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                color: "currentColor",
                spacing: "spacious",
                label: intl.formatMessage($edb8bca8c45bf806$var$messages.expand, {
                    contentExpandableLabel: contentExpandableLabel
                }),
                size: "small"
            })
        ]
    });
};
$edb8bca8c45bf806$export$90094d804b0e3756.displayName = "ContentDropdown";

});
parcelRegister("dsh3V", function(module, exports) {
$parcel$export(module.exports, "stringLimiter", () => $c9e58f0d2e753dd7$export$344e89a8b62fe515);
const $c9e58f0d2e753dd7$export$344e89a8b62fe515 = (limit, input)=>{
    if (input && input.length > limit) return {
        value: `${input.substring(0, limit)}...`,
        limit: true
    };
    return {
        value: input,
        limit: false
    };
};

});


parcelRegister("9XEKX", function(module, exports) {
$parcel$export(module.exports, "RecommendedBadge", () => $3e31c2e21b054f80$export$baff9a765d5af60f);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $ai66O = parcelRequire("ai66O");
const $3e31c2e21b054f80$var$messages = (0, $7eNDO.defineMessages)({
    label: {
        defaultMessage: 'Recommended',
        description: 'The default label to show that an option is recommended',
        id: 'selectList.card.recommendedLabel'
    }
});
const $3e31c2e21b054f80$export$baff9a765d5af60f = ({ testId: testId, isSelected: isSelected = false })=>{
    const intl = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ai66O.Container), {
        "data-testid": testId,
        isSelected: isSelected,
        children: intl.formatMessage($3e31c2e21b054f80$var$messages.label)
    });
};
$3e31c2e21b054f80$export$baff9a765d5af60f.displayName = "RecommendedBadge";

});
parcelRegister("ai66O", function(module, exports) {
$parcel$export(module.exports, "Container", () => $61456a149be116b6$export$42a852a2b6b56249);

var $3kknN = parcelRequire("3kknN");
const $61456a149be116b6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "ebjcgwg0"
})((props)=>({
        position: 'absolute',
        top: 0,
        right: 0,
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 653)",
        userSelect: 'none',
        borderBottomLeftRadius: '18px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isSelected ? "var(--ds-text-inverse, #FFFFFF)" : "var(--ds-text-subtle, #44546F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isSelected ? "var(--ds-border-selected, #0C66E4)" : "var(--ds-border, rgba(9, 30, 66, 0.14))",
        transition: 'color 0.1s ease-out 0s, background-color 0.1s ease-out 0s'
    }));

});


parcelRegister("aBLn9", function(module, exports) {
$parcel$export(module.exports, "CardContainer", () => $4317479ef1b094af$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "ColumnContainer", () => $4317479ef1b094af$export$2194471aa3d52446);
$parcel$export(module.exports, "ColumnLeftContainer", () => $4317479ef1b094af$export$6afcc5f02c032bb);
$parcel$export(module.exports, "ColumnRightContainer", () => $4317479ef1b094af$export$176bfb11d924801a);
$parcel$export(module.exports, "ColumnTopContainer", () => $4317479ef1b094af$export$57369bea2c2848c8);
$parcel$export(module.exports, "ColumnTopLeftContainer", () => $4317479ef1b094af$export$8c74f281d6cdd16c);
$parcel$export(module.exports, "ColumnTopRightContainer", () => $4317479ef1b094af$export$b6543c2ab50162f2);
$parcel$export(module.exports, "Title", () => $4317479ef1b094af$export$f99233281efd08a0);
$parcel$export(module.exports, "Description", () => $4317479ef1b094af$export$393edc798c47379d);
$parcel$export(module.exports, "TitleAndDescriptionContainer", () => $4317479ef1b094af$export$864963732df5f68d);
$parcel$export(module.exports, "RowTopContainer", () => $4317479ef1b094af$export$25c6e2e31b0882eb);
$parcel$export(module.exports, "RowMidContainer", () => $4317479ef1b094af$export$23808f5c27ea7690);
$parcel$export(module.exports, "RowRadioContainer", () => $4317479ef1b094af$export$cfa5b3384fac2ab);
$parcel$export(module.exports, "RowImage", () => $4317479ef1b094af$export$270aca14f81154c3);
$parcel$export(module.exports, "RowIcon", () => $4317479ef1b094af$export$7b5f2021d5a86d4a);

var $3kknN = parcelRequire("3kknN");
function $4317479ef1b094af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4317479ef1b094af$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa15"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.direction === 'row' ? 'width: 100%;' : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        cursor: 'pointer',
        position: 'relative',
        maxWidth: '100%',
        overflow: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isDisabled ? "var(--ds-text-disabled, #080F214A)" : "var(--ds-text, #292A2E)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isDisabled ? "var(--ds-background-disabled, #0515240F)" : "var(--ds-surface-overlay, #FFFFFF)",
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.direction === 'row' ? `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-250, 20px)"}` : "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        border: props.isDisabled ? `1px solid ${"var(--ds-border-disabled, #0515240F)"}` : props.isSelected ? `1px solid ${"var(--ds-border-selected, #0C66E4)"}` : `1px solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"}`,
        transition: 'box-shadow 0.1s ease-out 0s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:focus-visible': {
            outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`,
            outlineOffset: "var(--ds-space-025, 2px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            input: {
                outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`,
                outlineOffset: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            boxShadow: `var(--ds-shadow-overlay, ${`0px 8px 12px #091E4226, 0px 0px 1px #091E424F`})`
        }
    }));
const $4317479ef1b094af$export$2194471aa3d52446 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa14"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const $4317479ef1b094af$export$6afcc5f02c032bb = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa13"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const $4317479ef1b094af$export$176bfb11d924801a = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa12"
})({
    name: "pbds0y",
    styles: "margin-left:var(--ds-space-200, 16px)"
});
const $4317479ef1b094af$export$57369bea2c2848c8 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa11"
})({
    name: "1f3egm3",
    styles: "display:flex;flex-wrap:wrap;justify-content:space-between"
});
const $4317479ef1b094af$export$8c74f281d6cdd16c = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa10"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const $4317479ef1b094af$export$b6543c2ab50162f2 = /*#__PURE__*/ (0, $3kknN.default)($4317479ef1b094af$export$8c74f281d6cdd16c, {
    target: "eovabpa9"
})({
    name: "0",
    styles: ""
});
const $4317479ef1b094af$export$f4ffbb233b3ad8b3 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa8"
})({
    name: "1rdkewm",
    styles: "min-width:48px;min-height:48px;background:#F4F5F7;color:#2684FF;display:flex;justify-content:center;align-items:center;margin-left:var(--ds-space-200, 16px);> span > svg{width:36px;height:36px;}"
});
const $4317479ef1b094af$export$f99233281efd08a0 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa7"
})({
    name: "67me99",
    styles: "font:var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500);color:var(--ds-text, #292A2E);white-space:normal;overflow-wrap:anywhere"
});
const $4317479ef1b094af$export$393edc798c47379d = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa6"
})({
    name: "dtw2t0",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #6B6E76)"
});
const $4317479ef1b094af$export$864963732df5f68d = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa5"
})({
    name: "pbds0y",
    styles: "margin-left:var(--ds-space-200, 16px)"
});
const $4317479ef1b094af$export$25c6e2e31b0882eb = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa4"
})({
    name: "4tky7f",
    styles: "margin-bottom:var(--ds-space-400, 32px)"
});
const $4317479ef1b094af$export$23808f5c27ea7690 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa3"
})({
    name: "ql53ha",
    styles: "display:flex;align-items:center;gap:var(--ds-space-150, 12px)"
});
const $4317479ef1b094af$export$cfa5b3384fac2ab = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa2"
})({
    name: "1llo5fb",
    styles: "width:24px"
});
const $4317479ef1b094af$export$270aca14f81154c3 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa1"
})({
    name: "1vkhuup",
    styles: "margin-left:var(--ds-space-500, 36px)"
});
const $4317479ef1b094af$export$7b5f2021d5a86d4a = /*#__PURE__*/ (0, $3kknN.default)($4317479ef1b094af$export$f4ffbb233b3ad8b3, {
    target: "eovabpa0"
})({
    name: "1gz4j9a",
    styles: "margin-left:0"
});

});


parcelRegister("cj3ZG", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $701d7dac92338a8c$export$85c8b41a3cd87edc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $hVEiN = parcelRequire("hVEiN");
function $701d7dac92338a8c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $701d7dac92338a8c$var$cardHeadingContainerStyles = {
    name: "14406a7",
    styles: "font-style:normal;font:var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text, #292A2E);display:flex;gap:var(--ds-space-050, 4px)"
};
const $701d7dac92338a8c$export$85c8b41a3cd87edc = (props)=>{
    const { testId: testId, groupId: groupId, groupName: groupName, groupDescription: groupDescription, groupDescriptionIcon: groupDescriptionIcon, groupDescriptionInfoLink: groupDescriptionInfoLink, groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage } = props;
    if (!groupName) return null;
    return /*#__PURE__*/ (0, $hStPE.jsx)("legend", {
        css: [
            $701d7dac92338a8c$var$cardHeadingContainerStyles
        ],
        "data-testid": `${testId}-${groupId}-title`
    }, groupName, /*#__PURE__*/ (0, $hStPE.jsx)((0, $hVEiN.SelectListCardHeadingInfo), {
        testId: `${testId}-${groupId}-popup-card`,
        groupDescription: groupDescription,
        groupDescriptionInfoLink: groupDescriptionInfoLink,
        groupDescriptionIcon: groupDescriptionIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(groupDescriptionIcon, {
            size: 'small'
        }),
        groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage,
        groupName: groupName
    }));
};
$701d7dac92338a8c$export$85c8b41a3cd87edc.displayName = "GroupHeading";

});
parcelRegister("hVEiN", function(module, exports) {
$parcel$export(module.exports, "SelectListCardHeadingInfo", () => $f2a6dc93cb7c22e8$export$fda6232e318f7915);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1CdDx = parcelRequire("1CdDx");

var $akMu8 = parcelRequire("akMu8");

var $cGixm = parcelRequire("cGixm");

var $3EPP0 = parcelRequire("3EPP0");
const $f2a6dc93cb7c22e8$export$fda6232e318f7915 = ({ testId: testId, groupDescription: groupDescription, groupDescriptionInfoLink: groupDescriptionInfoLink, groupDescriptionIcon: groupDescriptionIcon, groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage, groupName: groupName })=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const intl = (0, $1YIbA.default)();
    const handleTogglePopup = ()=>setIsOpen(!isOpen);
    const handleClosePopup = ()=>setIsOpen(false);
    const popUpContent = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3EPP0.PopupContentWrapper), {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    "data-testid": `${testId}-popup-description`,
                    children: groupDescription
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)("a", {
                    href: groupDescriptionInfoLink,
                    target: "_blank",
                    "data-testid": `${testId}-info-link`,
                    children: groupDescriptionInfoLinkMessage
                })
            ]
        });
    const popUpTrigger = (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $3EPP0.PopupButton), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            onClick: handleTogglePopup,
            testId: `${testId}-description-icon`,
            "aria-label": intl.formatMessage((0, $cGixm.messages).groupInfoButton, {
                groupName: groupName
            }),
            children: groupDescriptionIcon
        });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1CdDx.default), {
        zIndex: (0, $akMu8.layers).modal(),
        placement: "right",
        isOpen: isOpen,
        onClose: handleClosePopup,
        content: popUpContent,
        trigger: popUpTrigger
    });
};
$f2a6dc93cb7c22e8$export$fda6232e318f7915.displayName = "SelectListCardHeadingInfo";

});
parcelRegister("akMu8", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $6E45X = parcelRequire("6E45X");
module.exports = Object.assign({}, $6E45X, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($6E45X.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("cGixm", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5038d3fc2e0c66bb$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $5038d3fc2e0c66bb$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    groupInfoButton: {
        id: 'admin-hub-select-list.group-info-button',
        defaultMessage: 'Info button for {groupName}',
        description: 'Accessible label for the info button associated with a select list group. The placeholder {groupName} is substituted with the name of the group.'
    }
});

});

parcelRegister("3EPP0", function(module, exports) {
$parcel$export(module.exports, "PopupContentWrapper", () => $b1fc3e3af4c9e6ae$export$31d58a3bc8fb5d66);
$parcel$export(module.exports, "PopupButton", () => $b1fc3e3af4c9e6ae$export$d39b0d24481757e7);

var $4qNCE = parcelRequire("4qNCE");

var $3kknN = parcelRequire("3kknN");
function $b1fc3e3af4c9e6ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b1fc3e3af4c9e6ae$export$31d58a3bc8fb5d66 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "e1v6vov31"
})({
    name: "1srmvwn",
    styles: "width:400px;padding:var(--ds-space-300, 24px);display:flex;flex-direction:column;gap:var(--ds-space-100, 8px)"
});
const $b1fc3e3af4c9e6ae$export$d39b0d24481757e7 = /*#__PURE__*/ (0, $3kknN.default)((0, $4qNCE.default), {
    target: "e1v6vov30"
})({
    name: "1uk15if",
    styles: "background:var(--ds-background-neutral-subtle, #00000000);:hover{background:none;}"
});

});





parcelRegister("d58Bx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f0e61614c7e3588$export$2e2bcd8739ae039);
/* ReciprocalPromptSubpage.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $9ufM9 = parcelRequire("9ufM9");

var $fWb5q = parcelRequire("fWb5q");

var $7mtMc = parcelRequire("7mtMc");

var $8Sdzy = parcelRequire("8Sdzy");

var $3PC9r = parcelRequire("3PC9r");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $5T7Xn = parcelRequire("5T7Xn");

var $cFFXQ = parcelRequire("cFFXQ");

var $l7m8P = parcelRequire("l7m8P");

var $6bB9L = parcelRequire("6bB9L");

var $9xWqG = parcelRequire("9xWqG");

var $eiO6t = parcelRequire("eiO6t");
const $9f0e61614c7e3588$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $9f0e61614c7e3588$var$cancelButtonTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Cancel",
    id: "applinks.administration.ui.creation-flow-dialog.cancel-form-button-text-nonfinal"
});
const $9f0e61614c7e3588$var$reciprocalPromptContinueOnButtonTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Continue on {targetApplicationName}",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-reciprocal-description-nonfinal"
});
const $9f0e61614c7e3588$var$reciprocalPromptDescriptionNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "A link from Jira to {targetApplicationName} has been established. You will need to navigate to {targetApplicationName} to complete the link.",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-reciprocal-description-nonfinal"
});
const $9f0e61614c7e3588$var$ReciprocalPromptSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const thisApplicationManifest = props.state.localManifest;
    const targetApplicationManifest = props.state.remoteManifest;
    const targetCloudId = props.state.remoteManifest.id;
    const thisBaseUrl = thisApplicationManifest.url;
    const thisBaseTypeId = thisApplicationManifest.typeId;
    const creationState = (0, $l7m8P.getDefaultCreationState)(thisBaseUrl, thisBaseTypeId, targetCloudId);
    const reciprocalLinkUrl = (0, $l7m8P.generateApplinksCreationRedirectionUrl)(targetApplicationManifest.url, targetApplicationManifest.typeId, creationState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        xcss: $9f0e61614c7e3588$var$styles.fullContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
        variant: props.state.variant,
        kind: props.state.kind,
        buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            appearance: "subtle"
        }, formatMessage($9f0e61614c7e3588$var$cancelButtonTextNonfinalMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
            href: reciprocalLinkUrl,
            appearance: "primary"
        }, formatMessage($9f0e61614c7e3588$var$reciprocalPromptContinueOnButtonTextNonfinalMessage, {
            targetApplicationName: targetApplicationManifest.name
        }))),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
            title: "Create reciprocal link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($9f0e61614c7e3588$var$reciprocalPromptDescriptionNonfinalMessage, {
            targetApplicationName: targetApplicationManifest.name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            xcss: $9f0e61614c7e3588$var$styles.linkDisplay,
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default // TODO: Determine if the type is DC or Cloud
        ), {
            applicationType: (0, $5T7Xn.lookupTypeByTypeId)(targetApplicationManifest.typeId, false),
            displayUrl: targetApplicationManifest.url,
            heading: "Application Link",
            statusLozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozenge), {
                kind: "error",
                err: (0, $9xWqG.ERRORS).CONFIGURATION_COMPLETE
            })
        })))
    }));
};
$9f0e61614c7e3588$var$ReciprocalPromptSubpage.displayName = "ReciprocalPromptSubpage";
var $9f0e61614c7e3588$export$2e2bcd8739ae039 = $9f0e61614c7e3588$var$ReciprocalPromptSubpage;

});

parcelRegister("gjyKl", function(module, exports) {
$parcel$export(module.exports, "default", () => $459c319cb390f56f$export$2e2bcd8739ae039);
/* ConfirmationSubpage.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $fWb5q = parcelRequire("fWb5q");

var $7mtMc = parcelRequire("7mtMc");

var $8Sdzy = parcelRequire("8Sdzy");

var $3PC9r = parcelRequire("3PC9r");

var $abhF2 = parcelRequire("abhF2");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $5T7Xn = parcelRequire("5T7Xn");

var $cFFXQ = parcelRequire("cFFXQ");

var $drATu = parcelRequire("drATu");

var $1b6Nh = parcelRequire("1b6Nh");

var $6bB9L = parcelRequire("6bB9L");

var $eiO6t = parcelRequire("eiO6t");
const $459c319cb390f56f$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $459c319cb390f56f$var$doneButton = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.creation-flow-dialog.confirmation.done-button.non-final-ai",
    defaultMessage: "Done"
});
const $459c319cb390f56f$var$applicationLinkCreated = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.creation-flow-dialog.confirmation.application-link-created.non-final-ai",
    defaultMessage: "The application link has been created."
});
const $459c319cb390f56f$var$ConfirmationSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [status, setStatus] = (0, $euxye.useState)(null);
    const finaliseOAuth1Link = async (confirmationApplinkId)=>{
        await (0, $drATu.putApplinkOAuthOne3LOProvider)(confirmationApplinkId);
        await (0, $drATu.autoConfigureApplinkConsumer)(confirmationApplinkId);
        await (0, $drATu.putApplinkOAuthOne2LOProvider)(confirmationApplinkId);
        setStatus(await (0, $drATu.fetchApplinkStatus)(confirmationApplinkId));
    }; // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $euxye.useEffect)(()=>{
        // TODO: Enforce this using discriminated union types
        if (props.state.variant === 'OAUTH2.0') {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
            setStatus(null);
            return;
        }
        finaliseOAuth1Link(props.state.confirmationApplinkId);
    }, [
        props.state.confirmationApplinkId,
        props.state.variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.href = (0, $1b6Nh.APPLINKS_LIST_PAGE_URL);
        },
        xcss: $459c319cb390f56f$var$styles.fullContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
        variant: props.state.variant,
        kind: props.state.kind,
        buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            type: "submit",
            appearance: "primary",
            isLoading: status === null
        }, formatMessage($459c319cb390f56f$var$doneButton))),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
            title: "Confirmation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($459c319cb390f56f$var$applicationLinkCreated))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            xcss: $459c319cb390f56f$var$styles.linkDisplay,
            space: "space.200"
        }, status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default // TODO: Determine if the type is DC or Cloud
        ), {
            applicationType: (0, $5T7Xn.lookupTypeByTypeId)(status.link.type, false),
            displayUrl: status.link.displayUrl,
            heading: "Application Link",
            statusLozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozengeV3), {
                status: status
            })
        }), status === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
            size: "medium"
        })))
    }));
};
$459c319cb390f56f$var$ConfirmationSubpage.displayName = "ConfirmationSubpage";
var $459c319cb390f56f$export$2e2bcd8739ae039 = $459c319cb390f56f$var$ConfirmationSubpage;

});

parcelRegister("7kc1Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c937e4f29c5dd4$export$2e2bcd8739ae039);
/* ConnectSubpage.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $fWb5q = parcelRequire("fWb5q");

var $7mtMc = parcelRequire("7mtMc");

var $dIqcw = parcelRequire("dIqcw");

var $8Sdzy = parcelRequire("8Sdzy");

var $3PC9r = parcelRequire("3PC9r");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $drATu = parcelRequire("drATu");

var $aRJMv = parcelRequire("aRJMv");

var $eiO6t = parcelRequire("eiO6t");

var $kjKdI = parcelRequire("kjKdI");
const $44c937e4f29c5dd4$var$styles = {
    fullContainer: "_4t3i1osq"
};
const $44c937e4f29c5dd4$var$connectHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connect to the application",
    id: "applinks.administration.ui.creation-flow-dialog.connect-header"
});
const $44c937e4f29c5dd4$var$connectHeaderCloudConnectorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Choose scopes",
    id: "applinks.administration.ui.creation-flow-dialog.connect-header-cloud-connector"
});
const $44c937e4f29c5dd4$var$connectDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Copy and paste the details below between this page and the settings page of the external application where you configure application links. This creates a secure connection.",
    id: "applinks.administration.ui.creation-flow-dialog.connect-description"
});
const $44c937e4f29c5dd4$var$connectDescriptionCloudConnectorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Select the permission scopes that control how your app can interact with the remote DC app.",
    id: "applinks.administration.ui.creation-flow-dialog.connect-description-cloud-connector"
});
const $44c937e4f29c5dd4$var$connectContinueButtonMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connect",
    id: "applinks.administration.ui.creation-flow-dialog.connect-continue-button"
});
const $44c937e4f29c5dd4$var$connectContinueButtonCloudConnectorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Save",
    id: "applinks.administration.ui.creation-flow-dialog.connect-continue-button-cloud-connector"
});
const $44c937e4f29c5dd4$var$connectDoLaterButtonMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Do this later",
    id: "applinks.administration.ui.creation-flow-dialog.connect-do-later-button"
});
const $44c937e4f29c5dd4$var$requiredFieldsTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Required fields are marked with an asterisk",
    id: "applinks.administration.ui.creation-flow-dialog.required-fields-text"
});
const $44c937e4f29c5dd4$var$unknownErrorTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We encountered an unknown error.",
    id: "applinks.administration.ui.unknown-error"
});
const $44c937e4f29c5dd4$var$ConnectSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const isCloudConnector = !!props.state.applink.properties?.CLOUD_CONNECTOR_PRODUCT_CONNECTION_ID;
    const onFormSubmit = async (data)=>{
        const scopes = data.remoteApplicationSupportedScopes ? data.remoteApplicationSupportedScopes.map((scope)=>scope.value) : [];
        const oauth2Config = {
            remoteClientId: data.applicationClientId,
            remoteClientSecret: data.applicationClientSecret,
            remoteRedirectUrl: data.redirectUrl,
            outboundScopes: scopes
        };
        try {
            await (0, $drATu.putOAuth2ConfigInfo)(props.state.applink.id, oauth2Config);
            props.onSuccess(); // Success = close the drawer
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.connect.submitConnectForm', 'Failed to submit credentials form for newly created OAuth 2.0 applink', maybeError);
            if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($44c937e4f29c5dd4$var$unknownErrorTextMessage)));
            else props.onError(maybeError ? maybeError.message : formatMessage($44c937e4f29c5dd4$var$unknownErrorTextMessage));
            return err;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: onFormSubmit,
        xcss: $44c937e4f29c5dd4$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
            variant: props.state.variant,
            kind: props.state.kind,
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, formatMessage($44c937e4f29c5dd4$var$connectDoLaterButtonMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                testId: "applinks-administration.ui.list.creation-flow-dialog.connect.submit-button",
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, formatMessage(isCloudConnector ? $44c937e4f29c5dd4$var$connectContinueButtonCloudConnectorMessage : $44c937e4f29c5dd4$var$connectContinueButtonMessage))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
                title: formatMessage(isCloudConnector ? $44c937e4f29c5dd4$var$connectHeaderCloudConnectorMessage : $44c937e4f29c5dd4$var$connectHeaderMessage)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage(isCloudConnector ? $44c937e4f29c5dd4$var$connectDescriptionCloudConnectorMessage : $44c937e4f29c5dd4$var$connectDescriptionMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                "aria-hidden": "true",
                size: "small"
            }, formatMessage($44c937e4f29c5dd4$var$requiredFieldsTextMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dIqcw.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aRJMv.default), {
                applink: props.state.applink,
                oauth2ConfigInfo: props.state.oauth2ConfigInfo,
                onDisplayError: props.onError,
                onRequestStatusRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
                partiallyLinkedMode: true
            }))
        })));
};
$44c937e4f29c5dd4$var$ConnectSubpage.displayName = "ConnectSubpage";
var $44c937e4f29c5dd4$export$2e2bcd8739ae039 = $44c937e4f29c5dd4$var$ConnectSubpage;

});





parcelRegister("hDtld", function(module, exports) {
$parcel$export(module.exports, "applinksAdministrationListRoute", () => $1068b4a51d3a0832$export$1eaebf5f3954a8b6);
const $1068b4a51d3a0832$export$1eaebf5f3954a8b6 = {
    name: 'global-settings-products-applinks-administration-list',
    path: '/jira/settings/applinks',
    exact: true
};

});


parcelRegister("fJYOn", function(module, exports) {
$parcel$export(module.exports, "applinksExtraAuthHealthcheckRouteEntry", () => $68f775d269b79ed7$export$cd4854d613a2c404);



var $lFLfF = parcelRequire("lFLfF");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $35eqr = parcelRequire("35eqr");

var $e5IEm = parcelRequire("e5IEm");

var $3FKJI = parcelRequire("3FKJI");

var $jEYuY = parcelRequire("jEYuY");

var $jepRN = parcelRequire("jepRN");

var $i860n = parcelRequire("i860n");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");
const $68f775d269b79ed7$export$cd4854d613a2c404 = (0, $fdS54.createEntry)((0, $3FKJI.applinksExtraAuthHealthcheckRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-extra-auth-healthcheck',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jepRN.componentWithFG)('applinks-789-extra-auth-healthcheck-frontend', (0, $e5IEm.default), (0, $lFLfF.default)),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $i860n.fg)('applinks-789-extra-auth-healthcheck-frontend'),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lFLfF", function(module, exports) {
$parcel$export(module.exports, "LazyNotFoundErrorPage", () => $e8caf0e879df9c55$export$57c5c0b5a0cdb5b7);
$parcel$export(module.exports, "default", () => $e8caf0e879df9c55$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $e8caf0e879df9c55$export$57c5c0b5a0cdb5b7 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("grAIU")), {
    moduleId: "./src/packages/spa-apps/error-pages-not-found/src/ErrorPagesNotFoundPage.tsx"
});
const $e8caf0e879df9c55$var$AsyncNotFoundErrorPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e8caf0e879df9c55$export$57c5c0b5a0cdb5b7,
        pageId: "errors-404",
        shouldShowSpinner: false
    });
$e8caf0e879df9c55$var$AsyncNotFoundErrorPage.displayName = "AsyncNotFoundErrorPage";
var $e8caf0e879df9c55$export$2e2bcd8739ae039 = $e8caf0e879df9c55$var$AsyncNotFoundErrorPage;

});
parcelRegister("grAIU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("iBVaq")
]).then(()=>parcelRequire('98cNG'));

});


parcelRegister("e5IEm", function(module, exports) {
$parcel$export(module.exports, "default", () => $efc52106d16744c7$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $7xLLk = parcelRequire("7xLLk");

var $f99wD = parcelRequire("f99wD");

var $gDdYI = parcelRequire("gDdYI");

var $eu7pI = parcelRequire("eu7pI");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $efc52106d16744c7$var$HealthcheckPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "applinks-extra-auth-healthcheck-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7xLLk.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eu7pI.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStatePageReady), null)));
$efc52106d16744c7$var$HealthcheckPage.displayName = "HealthcheckPage";
var $efc52106d16744c7$export$2e2bcd8739ae039 = $efc52106d16744c7$var$HealthcheckPage;

});
parcelRegister("eu7pI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c8c5992592785fa$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $e2Tle = parcelRequire("e2Tle");

var $6CfY5 = parcelRequire("6CfY5");

var $vn7n2 = parcelRequire("vn7n2");

var $4ZjPX = parcelRequire("4ZjPX");
const $5c8c5992592785fa$var$LOG_LOCATION = 'applinks.extra-auth.healthcheck';
const $5c8c5992592785fa$export$7955d5fe058be414 = ()=>{
    const [healthcheck, setHealthcheck] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        (0, $vn7n2.getHealthcheck)().then((data)=>{
            setHealthcheck(data);
        }).catch((err)=>{
            (0, $6CfY5.default).safeErrorWithoutCustomerData($5c8c5992592785fa$var$LOG_LOCATION, 'Failed to fetch healthcheck data', err);
            setHealthcheck(null);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4ZjPX.default), {
        healthcheck: healthcheck
    });
};
$5c8c5992592785fa$export$7955d5fe058be414.displayName = "HealthcheckPage";
const $5c8c5992592785fa$var$HealthcheckPageConnected = (0, $e2Tle.withRouter)($5c8c5992592785fa$export$7955d5fe058be414);
var $5c8c5992592785fa$export$2e2bcd8739ae039 = $5c8c5992592785fa$var$HealthcheckPageConnected;

});
parcelRegister("vn7n2", function(module, exports) {
$parcel$export(module.exports, "getHealthcheck", () => $2da438028ac7d7bb$export$47b0be97eea80dc5);

var $4fhEY = parcelRequire("4fhEY");
const $2da438028ac7d7bb$export$47b0be97eea80dc5 = ()=>(0, $4fhEY.default)('/rest/applinks/latest/applicationlink/extraAuth/healthcheck');

});

parcelRegister("4ZjPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $96d7dad61fd99a48$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $jt9fs = parcelRequire("jt9fs");

var $kZDZA = parcelRequire("kZDZA");
const $96d7dad61fd99a48$var$HealthcheckPageContents = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "applinks-extra-auth-healthcheck-page",
        teamName: "olympus",
        packageName: "applinksExtraAuthHealthcheckPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.200",
        xcss: $96d7dad61fd99a48$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kZDZA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jt9fs.default), {
        title: "Prerequisites",
        description: "Ensure that the following prerequisites are met before beginning the setup process.",
        healthcheckEntries: props.healthcheck?.healthcheckPreconditions ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jt9fs.default), {
        title: "OAuth 2.0 Provider Configuration",
        description: "Extra Authentication uses an external OAuth 2.0 provider, shared by all products within your organization. The provider must be configured correctly before Application Links can be created.",
        healthcheckEntries: props.healthcheck?.healthcheckEntries ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jt9fs.default), {
        title: "Applink Status",
        description: "Once the authentication provider is configured, you can now create Application Links. All links configured to use Extra Authentication for this site are displayed below.",
        healthcheckEntries: props.healthcheck?.healthcheckStatuses ?? null
    })))));
};
$96d7dad61fd99a48$var$HealthcheckPageContents.displayName = "HealthcheckPageContents";
var $96d7dad61fd99a48$export$2e2bcd8739ae039 = $96d7dad61fd99a48$var$HealthcheckPageContents;
const $96d7dad61fd99a48$var$styles = (0, $fbAgj.xcss)({
    padding: 'space.200'
});

});
parcelRegister("jt9fs", function(module, exports) {
$parcel$export(module.exports, "default", () => $b30f5285191ed1d0$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $gNHJ8 = parcelRequire("gNHJ8");

var $fbAgj = parcelRequire("fbAgj");

var $glYl9 = parcelRequire("glYl9");

var $863Fi = parcelRequire("863Fi");

var $drYNU = parcelRequire("drYNU");

var $k3sNq = parcelRequire("k3sNq");

var $b0KE0 = parcelRequire("b0KE0");

var $kCkhe = parcelRequire("kCkhe");

var $8Qvei = parcelRequire("8Qvei");

var $9qT28 = parcelRequire("9qT28");

var $7u3US = parcelRequire("7u3US");

var $2iotI = parcelRequire("2iotI");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9nhhi = parcelRequire("9nhhi");
const $b30f5285191ed1d0$var$statusHeader = (0, $7eNDO.defineMessage)({
    id: "applinks.extra-auth.healthcheck-table.status-header",
    defaultMessage: "Status"
});
const $b30f5285191ed1d0$var$itemHeader = (0, $7eNDO.defineMessage)({
    id: "applinks.extra-auth.healthcheck-table.item-header",
    defaultMessage: "Item"
});
const $b30f5285191ed1d0$var$details = (0, $7eNDO.defineMessage)({
    id: "applinks.extra-auth.healthcheck-table.details",
    defaultMessage: "Details"
});
const $b30f5285191ed1d0$var$HealthcheckIcon = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, props.status.statusType === 'SUCCESS' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: "Success"
    }), props.status.statusType === 'FAILURE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Unsuccessful"
    }), props.status.statusType === 'NOT_TRIED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7u3US))), {
        color: "var(--ds-icon, #292A2E)",
        label: "Not Tried"
    }));
};
$b30f5285191ed1d0$var$HealthcheckIcon.displayName = "HealthcheckIcon";
const $b30f5285191ed1d0$var$getColorFromStatus = (status)=>{
    if (status.statusType === 'NOT_TRIED') return 'color.text.disabled';
    return 'color.text';
};
const $b30f5285191ed1d0$var$HealthcheckTitle = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.default), {
        color: $b30f5285191ed1d0$var$getColorFromStatus(props.status)
    }, props.name);
};
$b30f5285191ed1d0$var$HealthcheckTitle.displayName = "HealthcheckTitle";
const $b30f5285191ed1d0$var$HealthcheckComment = (props)=>{
    const message = 'message' in props.status ? props.status.message : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.default), {
        color: $b30f5285191ed1d0$var$getColorFromStatus(props.status)
    }, message);
};
$b30f5285191ed1d0$var$HealthcheckComment.displayName = "HealthcheckComment";
const $b30f5285191ed1d0$var$convertToArray = (healthcheckEntries)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return healthcheckEntries.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $b30f5285191ed1d0$var$HealthcheckTable = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const healthcheckItems = props.healthcheckEntries ? $b30f5285191ed1d0$var$convertToArray(props.healthcheckEntries) : undefined; // Loading state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "medium"
    }, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNHJ8.default), null, props.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $glYl9.default), {
        label: "Healthcheck Table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3sNq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $drYNU.default), {
        width: "100px"
    }, formatMessage($b30f5285191ed1d0$var$statusHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $drYNU.default), {
        width: "50%"
    }, formatMessage($b30f5285191ed1d0$var$itemHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $drYNU.default), {
        width: "50%"
    }, formatMessage($b30f5285191ed1d0$var$details))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kCkhe.default), {
        items: healthcheckItems,
        render: (item)=>{
            const { content: content } = item;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b0KE0.default), {
                key: item.id,
                itemId: item.id,
                hasChildren: item.hasChildren
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $863Fi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b30f5285191ed1d0$var$HealthcheckIcon, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $863Fi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b30f5285191ed1d0$var$HealthcheckTitle, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $863Fi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b30f5285191ed1d0$var$HealthcheckComment, content)));
            if (content.status.statusType === 'FAILURE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, row, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b0KE0.default), {
                key: `${item.id}-suggested-action`,
                itemId: `${item.id}-suggested-action`,
                hasChildren: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
                xcss: $b30f5285191ed1d0$var$suggestedActionCellStyles,
                role: "cell"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9nhhi.default), {
                error: `Step "${content.name}" failed due to reason: "${content.status.message}".`,
                action: content.suggestedAction ?? null,
                link: content.suggestedActionLink ?? null
            }))));
            return row;
        }
    })));
};
$b30f5285191ed1d0$var$HealthcheckTable.displayName = "HealthcheckTable";
var $b30f5285191ed1d0$export$2e2bcd8739ae039 = $b30f5285191ed1d0$var$HealthcheckTable;
const $b30f5285191ed1d0$var$suggestedActionCellStyles = (0, $fbAgj.xcss)({
    width: '100%',
    padding: 'space.200'
});

});
parcelRegister("7u3US", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::967051479008b6df3057b7f835f26a9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $572e5f782489974a$var$_react = $572e5f782489974a$var$_interopRequireDefault((parcelRequire("euxye")));

var $572e5f782489974a$var$_baseNew = $572e5f782489974a$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $572e5f782489974a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskToDo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for to-do task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $572e5f782489974a$var$TaskToDoIcon = (props)=>/*#__PURE__*/ $572e5f782489974a$var$_react.default.createElement($572e5f782489974a$var$_baseNew.default, Object.assign({
        name: "TaskToDoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.028 1.5H8V0h.034c1.957.008 3.75.72 5.135 1.894L12.2 3.04A6.47 6.47 0 0 0 8.03 1.5m-2.278.4a6.52 6.52 0 0 0-3.395 2.875l-1.302-.746A8.02 8.02 0 0 1 5.23.493zM14.5 8a6.47 6.47 0 0 0-.856-3.227l1.301-.745A7.97 7.97 0 0 1 16 8q0 .727-.126 1.42l-1.476-.264A6.6 6.6 0 0 0 14.5 8M1.593 6.895A6.6 6.6 0 0 0 1.5 8c0 1.194.321 2.31.882 3.27l-1.296.757A7.97 7.97 0 0 1 0 8q.001-.694.115-1.358zm8.605 7.224a6.52 6.52 0 0 0 3.419-2.845l1.295.757a8.02 8.02 0 0 1-4.208 3.5zm-6.344-1.113A6.47 6.47 0 0 0 8 14.5V16a7.97 7.97 0 0 1-5.104-1.84z" clip-rule="evenodd"/>`
    }, props));
$572e5f782489974a$var$TaskToDoIcon.displayName = 'TaskToDoIcon';
var $572e5f782489974a$var$_default = module.exports.default = $572e5f782489974a$var$TaskToDoIcon;

});

parcelRegister("9nhhi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2310799e98d0ac6f$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $aybNy = parcelRequire("aybNy");

var $aSfWc = parcelRequire("aSfWc");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");
const $2310799e98d0ac6f$var$HealthcheckSuggestedAction = (props)=>{
    const actions = props.link ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aSfWc.default), {
            key: "action",
            href: props.link.link
        }, props.link.name)
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aybNy.default), {
        title: "Step Failed",
        appearance: "error",
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, props.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, props.action))));
};
$2310799e98d0ac6f$var$HealthcheckSuggestedAction.displayName = "HealthcheckSuggestedAction";
var $2310799e98d0ac6f$export$2e2bcd8739ae039 = $2310799e98d0ac6f$var$HealthcheckSuggestedAction;

});
parcelRegister("aSfWc", function(module, exports) {
$parcel$export(module.exports, "default", () => $db33c547a8d7e2d8$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4qNCE = parcelRequire("4qNCE");

var $1MNmN = parcelRequire("1MNmN");

var $hzWaA = parcelRequire("hzWaA");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");
var $6mEZn = parcelRequire("6mEZn");
const $db33c547a8d7e2d8$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_syaz13af _k48p1wq8 _bfhk18uv _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz",
    pressableT26Shape: "_2rkolb4i"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $db33c547a8d7e2d8$var$SectionMessageAction = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }, ref) {
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            className: (0, $4jQY2.default)([
                $db33c547a8d7e2d8$var$styles.common,
                $db33c547a8d7e2d8$var$styles.anchor
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target,
                ref: ref,
                children: children
            })
        });
        if (onClick) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $1MNmN.cx)($db33c547a8d7e2d8$var$styles.common, $db33c547a8d7e2d8$var$styles.pressable, (0, $egspI.fg)('platform-dst-shape-theme-default') && $db33c547a8d7e2d8$var$styles.pressableT26Shape),
            ref: ref,
            children: children
        });
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
            as: "span",
            testId: testId,
            xcss: $db33c547a8d7e2d8$var$styles.common,
            ref: ref,
            children: children
        });
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        ref: ref,
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: children
    });
}));
$db33c547a8d7e2d8$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $db33c547a8d7e2d8$export$2e2bcd8739ae039 = $db33c547a8d7e2d8$var$SectionMessageAction;

});



parcelRegister("kZDZA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad7442c0d509d9d8$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $ad7442c0d509d9d8$var$extraAuth = (0, $7eNDO.defineMessage)({
    id: "applinks.extra-auth.healthcheck-header.extra-auth",
    defaultMessage: "Extra Auth Healthcheck"
});
const $ad7442c0d509d9d8$var$statusExtra = (0, $7eNDO.defineMessage)({
    id: "applinks.extra-auth.healthcheck-header.status-extra",
    defaultMessage: "Status of Extra Authenticated Application Links for your Jira Cloud site."
});
const $ad7442c0d509d9d8$var$HealthcheckHeader = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "large"
    }, formatMessage($ad7442c0d509d9d8$var$extraAuth)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($ad7442c0d509d9d8$var$statusExtra))));
};
$ad7442c0d509d9d8$var$HealthcheckHeader.displayName = "HealthcheckHeader";
var $ad7442c0d509d9d8$export$2e2bcd8739ae039 = $ad7442c0d509d9d8$var$HealthcheckHeader;

});




parcelRegister("3FKJI", function(module, exports) {
$parcel$export(module.exports, "applinksExtraAuthHealthcheckRoute", () => $706046968c4468b4$export$c92684a6af97ae19);
const $706046968c4468b4$export$c92684a6af97ae19 = {
    name: 'global-settings-products-applinks-extra-auth',
    path: '/jira/settings/applinks/extra-auth/healthcheck',
    exact: true
};

});


parcelRegister("aqyuv", function(module, exports) {
$parcel$export(module.exports, "appRequestsRouteEntry", () => $42ca27d2a451913a$export$423a1c80bb2f8b9a);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $eeE0z = parcelRequire("eeE0z");

var $khI8v = parcelRequire("khI8v");
const $42ca27d2a451913a$export$423a1c80bb2f8b9a = (0, $fdS54.createEntry)((0, $eeE0z.appRequestsRoute), ()=>({
        group: 'marketplace',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $khI8v.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $khI8v.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $2ab82cb6568ef9ea$export$e20d1bc819761c4c = 'ADDONS';

const $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0 = 'GLOBAL_APPS_SETTINGS';

parcelRegister("eeE0z", function(module, exports) {
$parcel$export(module.exports, "appRequestsRoute", () => $61cad99158c81c5b$export$df12e2a94e0a971b);
const $61cad99158c81c5b$export$df12e2a94e0a971b = {
    name: 'marketplace-app-requests',
    path: '/jira/marketplace/manage/app-requests'
};

});

parcelRegister("khI8v", function(module, exports) {
$parcel$export(module.exports, "LazyMarketplace", () => $7f5fc515bd379ae1$export$5919da4c9ee4707e);
$parcel$export(module.exports, "MarketplaceComponent", () => $7f5fc515bd379ae1$export$f0d733b7012e9031);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7f5fc515bd379ae1$export$5919da4c9ee4707e = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("41Unh"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/marketplace/src/MarketplaceShell.tsx"
});
const $7f5fc515bd379ae1$export$f0d733b7012e9031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7f5fc515bd379ae1$export$5919da4c9ee4707e,
        pageId: "marketplace",
        shouldShowSpinner: true
    });
$7f5fc515bd379ae1$export$f0d733b7012e9031.displayName = "MarketplaceComponent";

});
parcelRegister("jhKsF", function(module, exports) {
$parcel$export(module.exports, "markAsProductBundleReady", () => $5c22b73701ad408c$export$ff83c57004505abd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iLktG = parcelRequire("iLktG");
const $5c22b73701ad408c$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $iLktG.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};

});

parcelRegister("41Unh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("16xv0")
]).then(()=>parcelRequire('gI3Pn'));

});



parcelRegister("z4Vlj", function(module, exports) {
$parcel$export(module.exports, "archivedIssuesRedirectRouteEntry", () => $0254247ec95b161b$export$f7d3667678a21360);


var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $zoPxe = parcelRequire("zoPxe");

var $l8kj3 = parcelRequire("l8kj3");
const $0254247ec95b161b$export$f7d3667678a21360 = (0, $fdS54.createEntry)((0, $zoPxe.archivedIssuesRedirectRoute), ()=>({
        group: 'archive-issues',
        layout: (0, $dvtoW.genericProjectLayout),
        entryPoint: ()=>(0, $l8kj3.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dvtoW", function(module, exports) {
$parcel$export(module.exports, "genericProjectLayout", () => $eabeda6c7471a15b$export$85dad8e9886563f6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fU8CV = parcelRequire("fU8CV");

var $QhQu4 = parcelRequire("QhQu4");

var $74h93 = parcelRequire("74h93");

var $3eysO = parcelRequire("3eysO");

var $dSYOQ = parcelRequire("dSYOQ");
const $eabeda6c7471a15b$export$85dad8e9886563f6 = (0, $QhQu4.composeLayouts)((0, $3eysO.classicSoftwareProjectLayout), (0, $fU8CV.coreProjectLayout), (0, $74h93.serviceProjectLayout), (0, $3eysO.softwareProjectLayout), (0, $dSYOQ.userBoardLayout));

});
parcelRegister("fU8CV", function(module, exports) {
$parcel$export(module.exports, "coreProjectLayout", () => $4e7c66a3c5f62ad5$export$3c06ced9943ca671);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lVzKq = parcelRequire("lVzKq");

var $QhQu4 = parcelRequire("QhQu4");
const $4e7c66a3c5f62ad5$export$3c06ced9943ca671 = (0, $QhQu4.composeLayouts)((0, $lVzKq.projectLayout));

});

parcelRegister("3eysO", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $d9a9eeef91e81aaf$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $d9a9eeef91e81aaf$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $d9a9eeef91e81aaf$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $d9a9eeef91e81aaf$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $d9a9eeef91e81aaf$export$ab7e607e8441dc61);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $lVzKq = parcelRequire("lVzKq");

var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

var $jepRN = parcelRequire("jepRN");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext = (Component)=>(0, $QhQu4.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $f99M0.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d9a9eeef91e81aaf$var$Onboarding = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("1xvlQ")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-software-project-layout/src/ui/onboarding/index.tsx"
});
$d9a9eeef91e81aaf$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d9a9eeef91e81aaf$var$OnboardingCode = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("fg5CY")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d9a9eeef91e81aaf$var$RightSidebars = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("kB97o")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
$d9a9eeef91e81aaf$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d9a9eeef91e81aaf$var$RightSidebarsCode = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("4eVAt")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $d9a9eeef91e81aaf$var$OnboardingWithSoftwareAsExpectedProjectType = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d9a9eeef91e81aaf$var$Onboarding, {
        ...props,
        expectedProjectType: (0, $f99M0.SOFTWARE_PROJECT)
    });
$d9a9eeef91e81aaf$var$OnboardingWithSoftwareAsExpectedProjectType.displayName = "OnboardingWithSoftwareAsExpectedProjectType";
const $d9a9eeef91e81aaf$var$OnboardingCodeWithSoftwareAsExpectedProjectType = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d9a9eeef91e81aaf$var$OnboardingCode, {
        ...props,
        expectedProjectType: (0, $f99M0.SOFTWARE_PROJECT)
    });
$d9a9eeef91e81aaf$var$OnboardingCodeWithSoftwareAsExpectedProjectType.displayName = "OnboardingCodeWithSoftwareAsExpectedProjectType";
const $d9a9eeef91e81aaf$var$SoftWareOnboarding = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $d9a9eeef91e81aaf$var$OnboardingWithSoftwareAsExpectedProjectType, $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext($d9a9eeef91e81aaf$var$Onboarding));
const $d9a9eeef91e81aaf$var$SoftWareOnboardingCode = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $d9a9eeef91e81aaf$var$OnboardingCodeWithSoftwareAsExpectedProjectType, $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext($d9a9eeef91e81aaf$var$OnboardingCode));
const $d9a9eeef91e81aaf$var$nonSettingsRightSidebar = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $d9a9eeef91e81aaf$var$RightSidebars, $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext($d9a9eeef91e81aaf$var$RightSidebars));
$d9a9eeef91e81aaf$var$nonSettingsRightSidebar.displayName = 'NonSettingsRightSidebar';
const $d9a9eeef91e81aaf$var$nonSettingsRightSidebarCode = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $d9a9eeef91e81aaf$var$RightSidebarsCode, $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext($d9a9eeef91e81aaf$var$RightSidebarsCode));
const $d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout = (0, $QhQu4.composeLayouts)((0, $lVzKq.projectLayout), {});
const $d9a9eeef91e81aaf$export$3791efdd32024063 = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout, {
    rightSidebars: [
        $d9a9eeef91e81aaf$var$nonSettingsRightSidebar
    ],
    globalComponents: [
        $d9a9eeef91e81aaf$var$SoftWareOnboarding
    ]
});
const $d9a9eeef91e81aaf$export$9a918616afa3328c = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout, {
    rightSidebars: [
        $d9a9eeef91e81aaf$var$nonSettingsRightSidebar
    ],
    globalComponents: [
        $d9a9eeef91e81aaf$var$SoftWareOnboarding
    ]
});
const $d9a9eeef91e81aaf$export$ada52b1309832862 = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout);
const $d9a9eeef91e81aaf$export$6c1958653c44ba37 = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout);
const $d9a9eeef91e81aaf$export$ab7e607e8441dc61 = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout, {
    rightSidebars: [
        $d9a9eeef91e81aaf$var$nonSettingsRightSidebarCode
    ],
    globalComponents: [
        $d9a9eeef91e81aaf$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("1xvlQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("bHghB")
]).then(()=>parcelRequire('636b7'));

});

parcelRegister("fg5CY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("1QNkz")
]).then(()=>parcelRequire('hKXnV'));

});

parcelRegister("kB97o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("kFYzw")
]).then(()=>parcelRequire('MzwZm'));

});

parcelRegister("4eVAt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("7ccwi")
]).then(()=>parcelRequire('5wMW2'));

});


parcelRegister("dSYOQ", function(module, exports) {
$parcel$export(module.exports, "userBoardLayout", () => $a536ebd15e092fda$export$7092b4ee86ae0b71);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");
const $a536ebd15e092fda$export$7092b4ee86ae0b71 = (0, $QhQu4.createLayout)();

});


parcelRegister("zoPxe", function(module, exports) {
$parcel$export(module.exports, "archivedIssuesRedirectRoute", () => $d1d83ffe4da8227d$export$1bfee70ca366d995);
const $d1d83ffe4da8227d$export$1bfee70ca366d995 = {
    name: 'archived-issues-directory',
    path: '/jira/issues/archive',
    exact: true
};

});

parcelRegister("l8kj3", function(module, exports) {
$parcel$export(module.exports, "archivedIssuesPageEntryPoint", () => $ad642f4c561f5a9a$export$e2fa7de87c15a81d);
$parcel$export(module.exports, "archivedIssuesWithoutHorizontalNavPageEntryPoint", () => $ad642f4c561f5a9a$export$c001d316b1f89101);
$parcel$export(module.exports, "getCommonProjectLayout", () => $ad642f4c561f5a9a$export$3dbe917a4c13b1e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $dWxmy = parcelRequire("dWxmy");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $QhQu4 = parcelRequire("QhQu4");

var $3KSG6 = parcelRequire("3KSG6");
const $ad642f4c561f5a9a$export$e2fa7de87c15a81d = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $dWxmy.archivedIssuesEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $ad642f4c561f5a9a$export$c001d316b1f89101 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $dWxmy.archivedIssuesEntrypoint)
});
const $ad642f4c561f5a9a$export$3dbe917a4c13b1e = ()=>(0, $QhQu4.createLayout)((0, $dvtoW.genericProjectLayout));

});
parcelRegister("dWxmy", function(module, exports) {
$parcel$export(module.exports, "archivedIssuesEntrypoint", () => $2797d9d8817bfb5f$export$3f35189530920ce3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $2797d9d8817bfb5f$export$3f35189530920ce3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3LUvW")), {
        moduleId: "3579e767",
        moduleName: "JiraIssuesArchiveMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3LUvW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ed0Fc").then(()=>parcelRequire('gtjxn'));

});


parcelRegister("3KSG6", function(module, exports) {
$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $46ac1fe9a229c4f5$export$e9ee9fa1097f370e);

var $i0CFV = parcelRequire("i0CFV");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i8BNs = parcelRequire("i8BNs");

var $4afVU = parcelRequire("4afVU");
const $46ac1fe9a229c4f5$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;

const $46ac1fe9a229c4f5$export$e9ee9fa1097f370e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("g9qhn")), {
        moduleId: "ed1d84b7",
        moduleName: "HorizontalNavJiraInner",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true,
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        let boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        if (!boardId) {
            // If there is no boardId in the URL then we should check to see if it is provided as part of
            // the Connect app rapidView query param. This has been added to address JRACLOUD-94629
            const rapidViewBoard = query.rapidView ? query.rapidView : null;
            boardId = rapidViewBoard || boardId || null;
        }
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $i8BNs.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        const containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        // mostRecentlyViewedBoard is only ever rendered as a fallback for company-managed (CMP)
        // software project routes that don't have a board in the URL (the nav header discards it for
        // TMP and whenever a board ARI is known). CMP routes carry a /software/c/ segment in the URL,
        // while TMP routes use /software/projects/; only the CMP board view loses its /c prefix during
        // URL harmonization, and that route always has a board id, so it is still skipped.
        // We only request mostRecentlyViewedBoard for boardless CMP routes.
        const isCMPRoute = match.url.includes('/software/c/');
        const skipMostRecentlyViewedBoard = !(isCMPRoute && !boardAri);
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $4afVU.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        skipMostRecentlyViewedBoard: skipMostRecentlyViewedBoard,
                        first: $46ac1fe9a229c4f5$var$NAVIGATION_ITEMS_PAGE_SIZE
                    }
                }
            }
        };
    }
});

});
parcelRegister("i8BNs", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAri", () => $d3464af9cca8b706$export$75a0a0a7cb0a58ae);

var $9HGCW = parcelRequire("9HGCW");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/project/manifest.ts
var $d3464af9cca8b706$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9HGCW.JiraProjectAriResourceOwner),
    resourceType: (0, $9HGCW.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $d3464af9cca8b706$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d3464af9cca8b706$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $d3464af9cca8b706$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d3464af9cca8b706$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $d3464af9cca8b706$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $d3464af9cca8b706$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $d3464af9cca8b706$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("9HGCW", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $71093215bbc1f5db$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $71093215bbc1f5db$export$736763838d3aa22e);
// src/jira/project/types.ts
var $71093215bbc1f5db$export$99d538a3b04916b1 = "jira", $71093215bbc1f5db$export$736763838d3aa22e = "project";

});


parcelRegister("4afVU", function(module, exports) {
$parcel$export(module.exports, "default", () => $adf699c972aa893b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec5ec7f53e57c7dce8f6ec8d842f7f90>>
 * @relayHash b57c48ee67fc7fc806b3d889d553fe39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d0b03389d85488f872453c2223e10b48ec857d5a78c74e25a9b466b0043f30b6

var $6GEqs = parcelRequire("6GEqs");

var $d3CRd = parcelRequire("d3CRd");
const $adf699c972aa893b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d0b03389d85488f872453c2223e10b48ec857d5a78c74e25a9b466b0043f30b6",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $d3CRd.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": (0, $6GEqs.default)
        }
    }
};
var $adf699c972aa893b$export$2e2bcd8739ae039 = $adf699c972aa893b$var$node;

});
parcelRegister("6GEqs", function(module, exports) {
$parcel$export(module.exports, "default", () => $f00900dc2d128e2c$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");

var $iXN50 = parcelRequire("iXN50");
const $f00900dc2d128e2c$var$GUEST_AWARENESS_STORAGE_NAMESPACE = 'jira-guest-awareness';
const $f00900dc2d128e2c$var$GUEST_AWARENESS_DISMISSED_VALUE = false;
const $f00900dc2d128e2c$var$getProjectKeyFromUrl = ()=>{
    const match = /\/projects\/([^/]+)/.exec(typeof window !== 'undefined' ? window.location.pathname : '');
    return match?.[1] ?? null;
};
const $f00900dc2d128e2c$var$guestAwarenessStorage = (0, $iXN50.createLocalStorageProvider)($f00900dc2d128e2c$var$GUEST_AWARENESS_STORAGE_NAMESPACE);
const $f00900dc2d128e2c$var$hasGuestFlagBeenDismissed = (projectKey)=>$f00900dc2d128e2c$var$guestAwarenessStorage.get(projectKey) === $f00900dc2d128e2c$var$GUEST_AWARENESS_DISMISSED_VALUE;
const $f00900dc2d128e2c$var$JiraExternalGuestsSpaceFlagRelayprovider = {
    get () {
        if (!(0, $i860n.fg)('jira_external_guests_space_flag')) return false;
        if ((0, $i860n.fg)('jira-guest-flag-cache')) {
            const projectKey = $f00900dc2d128e2c$var$getProjectKeyFromUrl();
            if (projectKey !== null && $f00900dc2d128e2c$var$hasGuestFlagBeenDismissed(projectKey)) return false;
        }
        return true;
    }
};
var $f00900dc2d128e2c$export$2e2bcd8739ae039 = $f00900dc2d128e2c$var$JiraExternalGuestsSpaceFlagRelayprovider;

});

parcelRegister("d3CRd", function(module, exports) {
$parcel$export(module.exports, "default", () => $fea17d5c6a228474$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $fea17d5c6a228474$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jira_custom_templates_ux');
    }
};

});


parcelRegister("g9qhn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iwpwq")
]).then(()=>parcelRequire('ghZiw'));

});




parcelRegister("3Yc1O", function(module, exports) {
$parcel$export(module.exports, "archivedPlansRouteEntry", () => $811f31c0841794e7$export$b9921058a8a65710);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $i8War = parcelRequire("i8War");

var $bI5dA = parcelRequire("bI5dA");
const $811f31c0841794e7$export$b9921058a8a65710 = (0, $fdS54.createEntry)((0, $i8War.archivedPlansRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $bI5dA.ArchivedPlansDirectory),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bI5dA.LazyArchivedPlans)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("i8War", function(module, exports) {
$parcel$export(module.exports, "archivedPlansRoute", () => $d423498a5df2d4f9$export$29647353386ad146);
const $d423498a5df2d4f9$export$29647353386ad146 = {
    name: 'archived-plans-directory',
    path: '/jira/plans/settings/archive',
    exact: true
};

});

parcelRegister("bI5dA", function(module, exports) {
$parcel$export(module.exports, "LazyArchivedPlans", () => $ca48499a037f1cb0$export$cf676f47aba10db8);
$parcel$export(module.exports, "ArchivedPlansDirectory", () => $ca48499a037f1cb0$export$ed59bbc59461c00f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $ca48499a037f1cb0$export$cf676f47aba10db8 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("leUjX")).then((module)=>module.ArchivedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages-archived-plans/src/AdminPagesArchivedPlansArchivedPlans.tsx"
});
const $ca48499a037f1cb0$export$ed59bbc59461c00f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ca48499a037f1cb0$export$cf676f47aba10db8,
        pageId: "archived-plans",
        shouldShowSpinner: true
    });
$ca48499a037f1cb0$export$ed59bbc59461c00f.displayName = "ArchivedPlansDirectory";

});
parcelRegister("leUjX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("l8Fon")
]).then(()=>parcelRequire('cWx9E'));

});



parcelRegister("59Sas", function(module, exports) {
$parcel$export(module.exports, "archivedProjectDirectLinkRouteEntry", () => $056b5c36c0e0fde5$export$45e68d450757a753);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $a8mYp = parcelRequire("a8mYp");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $056b5c36c0e0fde5$var$LazyArchivedDirectLink = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)(// eslint-disable-next-line jira/import/file-extension-required
    (parcelRequire("lAbaz"))), {
    moduleId: "./src/packages/project-pages/project-archive-archived-direct-link/src/index.tsx"
});
const $056b5c36c0e0fde5$var$ArchivedProjectDirectLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $056b5c36c0e0fde5$var$LazyArchivedDirectLink,
        pageId: "archived-project-direct-link",
        shouldShowSpinner: false
    });
$056b5c36c0e0fde5$var$ArchivedProjectDirectLink.displayName = "ArchivedProjectDirectLink";
const $056b5c36c0e0fde5$export$45e68d450757a753 = (0, $fdS54.createEntry)((0, $a8mYp.archivedProjectDirectLinkRoute), ()=>({
        group: 'redirects',
        // eslint-disable-next-line no-restricted-syntax
        component: $056b5c36c0e0fde5$var$ArchivedProjectDirectLink,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $056b5c36c0e0fde5$var$LazyArchivedDirectLink
        ],
        ufoName: 'project-archived',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("a8mYp", function(module, exports) {
$parcel$export(module.exports, "archivedProjectDirectLinkRoute", () => $1a58632e7300f489$export$cd3fc26cf9f696e6);
const $1a58632e7300f489$export$cd3fc26cf9f696e6 = {
    name: 'archived-project-direct-link',
    path: '/jira/errors/project-archived',
    exact: true
};

});

parcelRegister("lAbaz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fr7mp").then(()=>parcelRequire('kOGZN'));

});


parcelRegister("5amE5", function(module, exports) {
$parcel$export(module.exports, "archivedProjectsDirectoryRouteEntry", () => $3c81411cbf9d3508$export$dc5f9e3c3931cc36);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $9nsuK = parcelRequire("9nsuK");

var $gEX66 = parcelRequire("gEX66");
const $3c81411cbf9d3508$export$dc5f9e3c3931cc36 = (0, $fdS54.createEntry)((0, $9nsuK.archivedProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gEX66.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $3be6781b85030612$export$e3e768cbcc0eeacd),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gEX66.LazyArchivedProjectsAdmin)
        ],
        ufoName: 'admin.archived-projects',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $3be6781b85030612$export$e3e768cbcc0eeacd = 'GLOBAL_PROJECTS_SETTINGS';

parcelRegister("9nsuK", function(module, exports) {
$parcel$export(module.exports, "archivedProjectsDirectoryRoute", () => $149da50b68947c67$export$b60634d0fa43f719);
const $149da50b68947c67$export$b60634d0fa43f719 = {
    name: 'archived-projects-directory',
    path: '/jira/settings/projects/archive',
    exact: true
};

});

parcelRegister("gEX66", function(module, exports) {
$parcel$export(module.exports, "LazyArchivedProjectsAdmin", () => $43e92d4672233fe9$export$b220ffb582ee39aa);
$parcel$export(module.exports, "default", () => $43e92d4672233fe9$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $43e92d4672233fe9$export$b220ffb582ee39aa = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7yLms"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-archived-projects/src/AdminPagesArchivedProjectsArchivedProjectsAdminType.tsx"
});
const $43e92d4672233fe9$var$AsyncArchivedProjectsAdmin = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $43e92d4672233fe9$export$b220ffb582ee39aa,
        pageId: "archived-projects",
        shouldShowSpinner: true
    });
$43e92d4672233fe9$var$AsyncArchivedProjectsAdmin.displayName = "AsyncArchivedProjectsAdmin";
var $43e92d4672233fe9$export$2e2bcd8739ae039 = $43e92d4672233fe9$var$AsyncArchivedProjectsAdmin;

});
parcelRegister("7yLms", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("8oL6N")
]).then(()=>parcelRequire('2NakO'));

});



parcelRegister("Ae6y0", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJsmRouteEntry", () => $0f0f3abe79f92736$export$cdfe13bfc51ce940);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $bH6uq = parcelRequire("bH6uq");

var $74h93 = parcelRequire("74h93");

var $l8kj3 = parcelRequire("l8kj3");
const $0f0f3abe79f92736$export$cdfe13bfc51ce940 = (0, $fdS54.createEntry)((0, $bH6uq.archivedWorkItemsJsmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectServicedeskRoute from issue-navigator
        layout: (0, $74h93.serviceProjectLayout),
        entryPoint: ()=>(0, $l8kj3.archivedIssuesWithoutHorizontalNavPageEntryPoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bH6uq", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJsmRoute", () => $a4501abec5096a67$export$36e9c9de963d9a4f);
const $a4501abec5096a67$export$36e9c9de963d9a4f = {
    name: 'servicedesk-archived-work-items',
    path: '/jira/servicedesk/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("60s4z", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJswCompanyRouteEntry", () => $9d904a059d255421$export$5555f344b15f5187);


var $75Njg = parcelRequire("75Njg");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $3vXwv = parcelRequire("3vXwv");

var $l8kj3 = parcelRequire("l8kj3");
const $9d904a059d255421$export$5555f344b15f5187 = (0, $fdS54.createEntry)((0, $3vXwv.archivedWorkItemsJswCompanyRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectClassicRoute from issue-navigator
        layout: (0, $l8kj3.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $l8kj3.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("75Njg", function(module, exports) {
$parcel$export(module.exports, "AsyncHorizontalNavJira", () => $29aaa24d6cf5f173$export$ea83697d960a1a23);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $l8G1z = parcelRequire("l8G1z");

var $6yDzo = parcelRequire("6yDzo");

var $a8EUd = parcelRequire("a8EUd");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $29aaa24d6cf5f173$var$LazyHorizontalNavJira = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("eSQ8b")).then((HorizontalNavJira)=>HorizontalNavJira), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jira/src/ui/HorizontalNavJira.tsx"
});
const $29aaa24d6cf5f173$var$AsyncHorizontalNav = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-nav-jira",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6yDzo.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($29aaa24d6cf5f173$var$LazyHorizontalNavJira, null));
$29aaa24d6cf5f173$var$AsyncHorizontalNav.displayName = "AsyncHorizontalNav";
const $29aaa24d6cf5f173$export$ea83697d960a1a23 = $29aaa24d6cf5f173$var$AsyncHorizontalNav;

});
parcelRegister("6yDzo", function(module, exports) {
$parcel$export(module.exports, "TabsSkeleton", () => $8b5a92ba5e4159b0$export$807fef2beb9debc2);
$parcel$export(module.exports, "HorizontalNavSkeleton", () => $8b5a92ba5e4159b0$export$e29d51df5420bf39);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6Elhl = parcelRequire("6Elhl");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $2BUXh = parcelRequire("2BUXh");

var $5BP41 = parcelRequire("5BP41");
const $8b5a92ba5e4159b0$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$tabsWrapperSkeletonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }));
$8b5a92ba5e4159b0$export$807fef2beb9debc2.displayName = "TabsSkeleton";
const $8b5a92ba5e4159b0$export$e29d51df5420bf39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.050",
        alignBlock: "end",
        xcss: $8b5a92ba5e4159b0$var$horizontalNavWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$breadcrumbStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        spread: "space-between",
        xcss: $8b5a92ba5e4159b0$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$projectTitleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$squareStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        space: "space.150",
        xcss: $8b5a92ba5e4159b0$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8b5a92ba5e4159b0$export$807fef2beb9debc2, null));
$8b5a92ba5e4159b0$export$e29d51df5420bf39.displayName = "HorizontalNavSkeleton";
const $8b5a92ba5e4159b0$var$tabsWrapperSkeletonStyles = (0, $fbAgj.xcss)({
    gap: 'space.150',
    height: '32px',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockEnd: 'space.150',
    marginBlockStart: 'space.100',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $8b5a92ba5e4159b0$var$tabSkeletonStyles = (0, $fbAgj.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $8b5a92ba5e4159b0$var$horizontalNavWrapperStyles = (0, $fbAgj.xcss)({
    paddingBlockStart: 'space.150',
    blockSize: '104px'
});
const $8b5a92ba5e4159b0$var$baseSkeletonStyles = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small'
});
const $8b5a92ba5e4159b0$var$breadcrumbStyles = (0, $fbAgj.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '60px',
    marginInlineStart: 'space.300',
    marginBlockEnd: 'space.025'
});
const $8b5a92ba5e4159b0$var$primaryContainerStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $8b5a92ba5e4159b0$var$squareStyles = (0, $fbAgj.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $8b5a92ba5e4159b0$var$headerWrapperStyles = (0, $fbAgj.xcss)({
    marginBlockStart: 'space.050'
});
const $8b5a92ba5e4159b0$var$projectTitleStyles = (0, $fbAgj.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $8b5a92ba5e4159b0$var$actionStyles = (0, $fbAgj.xcss)({
    marginInlineEnd: 'space.300'
});

});
parcelRegister("2BUXh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6c2f4b7feac11ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $fbAgj = parcelRequire("fbAgj");

var $6Elhl = parcelRequire("6Elhl");
const $a6c2f4b7feac11ea$var$flexGrowMap = {
    hug: (0, $fbAgj.xcss)({
        flexGrow: 0
    }),
    fill: (0, $fbAgj.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $a6c2f4b7feac11ea$var$separatorStyles = /*#__PURE__*/ (0, $hStPE.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $a6c2f4b7feac11ea$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $hStPE.jsx)("span", {
        css: $a6c2f4b7feac11ea$var$separatorStyles
    }, children);
$a6c2f4b7feac11ea$var$Separator.displayName = "Separator";
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $a6c2f4b7feac11ea$var$Inline = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $hStPE.jsx)($a6c2f4b7feac11ea$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $euxye.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $a6c2f4b7feac11ea$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $6Elhl.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$a6c2f4b7feac11ea$var$Inline.displayName = 'Inline';
var $a6c2f4b7feac11ea$export$2e2bcd8739ae039 = $a6c2f4b7feac11ea$var$Inline;

});


parcelRegister("eSQ8b", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("lxPzZ")
]).then(()=>parcelRequire('746V9'));

});


parcelRegister("3vXwv", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJswCompanyRoute", () => $fa5a67a42b31c482$export$d370de0c0b8dc61b);
const $fa5a67a42b31c482$export$d370de0c0b8dc61b = {
    name: 'software-archived-work-items-classic',
    path: '/jira/software/c/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("59pT0", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJswRouteEntry", () => $8f0af420b0460144$export$2686cd22a3691dbf);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $2Syi3 = parcelRequire("2Syi3");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $l8kj3 = parcelRequire("l8kj3");
const $8f0af420b0460144$export$2686cd22a3691dbf = (0, $fdS54.createEntry)((0, $2Syi3.archivedWorkItemsJswRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectSoftwareRoute from issue-navigator
        layout: (0, $QhQu4.createLayout)((0, $3eysO.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $l8kj3.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2Syi3", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJswRoute", () => $5297a458a7b75017$export$356fe8859732c01b);
const $5297a458a7b75017$export$356fe8859732c01b = {
    name: 'software-archived-work-items',
    path: '/jira/software/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("2a44M", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJwmRouteEntry", () => $02a455c97088579f$export$a243ee53747084d5);


var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $f1yHr = parcelRequire("f1yHr");

var $l8kj3 = parcelRequire("l8kj3");
const $02a455c97088579f$export$a243ee53747084d5 = (0, $fdS54.createEntry)((0, $f1yHr.archivedWorkItemsJwmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectBusinessRoute from issue-navigator
        layout: (0, $l8kj3.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $l8kj3.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $hdZjx.getBusinessProjectResources)()
        ],
        supportsPreviewPanel: true,
        supportsProjectTheme: 'contoured',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hdZjx", function(module, exports) {
$parcel$export(module.exports, "getBusinessProjectResources", () => $2c831c72ad088c3f$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $2c831c72ad088c3f$export$fcbe882e18ee4a35);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9T5Cr = parcelRequire("9T5Cr");

var $oXLtZ = parcelRequire("oXLtZ");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");
const $2c831c72ad088c3f$export$20e8c2951e444b08 = ()=>[
        // eslint-disable-next-line camelcase
        (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $gZWlI.projectThemeResource)
    ];
const $2c831c72ad088c3f$export$fcbe882e18ee4a35 = ()=>[
        ...$2c831c72ad088c3f$export$20e8c2951e444b08(),
        ...(0, $dUAVJ.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $9T5Cr.fieldsResource)
    ];

});
parcelRegister("9T5Cr", function(module, exports) {
$parcel$export(module.exports, "fieldsResource", () => $6ec3c8291a3541e9$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $6ec3c8291a3541e9$export$c0cd85886917fe89);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable jira/import/no-restricted-import */ 
var $i0CFV = parcelRequire("i0CFV");

var $StYCc = parcelRequire("StYCc");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


var $6O5rx = parcelRequire("6O5rx");

var $ljreg = parcelRequire("ljreg");
const $6ec3c8291a3541e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $6ec3c8291a3541e9$var$handleProjectResponse = async (promise)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $StYCc.GraphQLErrors)(response.errors);
    return (0, $ljreg.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
const $6ec3c8291a3541e9$export$8bca6c1954ae9308 = (0, $7edbf.createResource)({
    type: $6ec3c8291a3541e9$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$6ec3c8291a3541e9$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $6O5rx.fetchFields)((0, $4a700be398578a7a$export$4d41378da3f70f0f), $6ec3c8291a3541e9$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $6ec3c8291a3541e9$export$c0cd85886917fe89 = ()=>(0, $k6ufm.useResource)($6ec3c8291a3541e9$export$8bca6c1954ae9308);

});
parcelRegister("StYCc", function(module, exports) {
$parcel$export(module.exports, "GraphQLErrors", () => $0e4f05b41870975b$export$89c202e66b2de2b6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ejbxN = parcelRequire("ejbxN");

var $jOlpf = parcelRequire("jOlpf");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $0e4f05b41870975b$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jOlpf)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $0e4f05b41870975b$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($ejbxN)))(graphQLErrors) : [];
        this.message = $0e4f05b41870975b$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}
$0e4f05b41870975b$export$89c202e66b2de2b6.displayName = "GraphQLErrors";

});
parcelRegister("ejbxN", function(module, exports) {

var $jOlpf = parcelRequire("jOlpf");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $a6abcb72a26c180b$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $jOlpf(value) ? value : [
        value
    ];
}
module.exports = $a6abcb72a26c180b$var$castArray;

});


/* eslint-disable jira/filename-case */ const $4a700be398578a7a$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("6O5rx", function(module, exports) {
$parcel$export(module.exports, "fetchFields", () => $37fc9d6c8898476b$export$f3ddd735c360919);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");
const $37fc9d6c8898476b$var$PAGE_SIZE = 100;
const $37fc9d6c8898476b$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $37fc9d6c8898476b$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("ljreg", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $b9069189a034716d$export$3ceb62baab058c6b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $b9069189a034716d$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("oXLtZ", function(module, exports) {
$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $9ed210e74349df1f$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $9ed210e74349df1f$export$97def3841413167f);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, camelcase, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $aPBUo = parcelRequire("aPBUo");
const $9ed210e74349df1f$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $9ed210e74349df1f$export$ced53bf9d9551fef = (0, $7edbf.createResource)({
    type: $9ed210e74349df1f$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$9ed210e74349df1f$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        return (0, $aPBUo.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $9ed210e74349df1f$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($9ed210e74349df1f$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};

});
parcelRegister("aPBUo", function(module, exports) {
$parcel$export(module.exports, "fetchProjectDetails", () => $38f4592832348c19$export$78aa221476efa1c6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $i8BNs = parcelRequire("i8BNs");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");


var $1X0iD = parcelRequire("1X0iD");
const $38f4592832348c19$var$EMPTY_VALUE = {};
const $38f4592832348c19$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $h2wCv.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $2f87a16051755ba2$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $i8BNs.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : ''
                }
            })
        });
        return (0, $1X0iD.transformData)(response.data, projectIdOrKey);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $38f4592832348c19$var$EMPTY_VALUE;
};

});
/* eslint-disable jira/filename-case */ const $2f87a16051755ba2$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $2f87a16051755ba2$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${$2f87a16051755ba2$var$PROJECT_FRAGMENT}
`;

parcelRegister("1X0iD", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $72b2cffcecf8972c$export$3ceb62baab058c6b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $72b2cffcecf8972c$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $72b2cffcecf8972c$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        currentProject: $72b2cffcecf8972c$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $72b2cffcecf8972c$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey
    });

});



parcelRegister("gZWlI", function(module, exports) {
$parcel$export(module.exports, "projectThemeResource", () => $cadcc0cfdcafdb09$export$84730adce8987203);

var $5mxNm = parcelRequire("5mxNm");

var $i0CFV = parcelRequire("i0CFV");

var $htsFl = parcelRequire("htsFl");

var $53aLO = parcelRequire("53aLO");
const $cadcc0cfdcafdb09$export$84730adce8987203 = (0, $53aLO.withGiraAggAnonSsrFix)((0, $htsFl.createRelayResource)({
    type: 'JIRA_PROJECT_THEME',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $5mxNm.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectKey ?? projectId ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isCritical: true
}));

});
parcelRegister("5mxNm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f82fed8c2a50914$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b475a3b72a7c7fa2f9506a42451d849>>
 * @relayHash 5986ee15eaf825d6ac511df472f0c72f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 686a1082ef03c8dceddc46ec49b3219866291bfa2005af9b1a4b9a03c1bb576f

var $lIGkE = parcelRequire("lIGkE");
const $7f82fed8c2a50914$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaClientId"
            },
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaExternalEndpointUrl"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThemeSetterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v3 /*: any*/ ,
                    "action": "THROW"
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ThemeSetterBackground"
                                }
                            ]
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "DominantColorPersister_project"
                                    }
                                ],
                                "type": "JiraProject"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "DominantColorPersister_project"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThemeSetterQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorValue"
                                        }
                                    ],
                                    "type": "JiraColorBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "gradientValue"
                                        }
                                    ],
                                    "type": "JiraGradientBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraCustomBackground",
                                            "kind": "LinkedField",
                                            "name": "customBackground",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaApiFileId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "durationInSeconds",
                                                            "value": 900
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "mediaReadToken",
                                                    "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceIdentifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "altText"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dominantColor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "brightness"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraMediaBackground"
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "686a1082ef03c8dceddc46ec49b3219866291bfa2005af9b1a4b9a03c1bb576f",
            "metadata": {},
            "name": "ThemeSetterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7f82fed8c2a50914$var$node.hash = "8b55113c37c39d55d59735942619bbed";
(0, $lIGkE.PreloadableQueryRegistry).set($7f82fed8c2a50914$var$node.params.id, $7f82fed8c2a50914$var$node);
var $7f82fed8c2a50914$export$2e2bcd8739ae039 = $7f82fed8c2a50914$var$node;

});

parcelRegister("53aLO", function(module, exports) {
$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $2346aa5a6a39a249$export$f4b29e78f4c0a526);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $2346aa5a6a39a249$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});



parcelRegister("f1yHr", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJwmRoute", () => $ee53814694b00aad$export$1377e2cf39b3ae6a);
const $ee53814694b00aad$export$1377e2cf39b3ae6a = {
    name: 'classic-business-archived-work-items',
    path: '/jira/core/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("VL8fh", function(module, exports) {
$parcel$export(module.exports, "arjCalendarEmbedRouteEntry", () => $ff4506ef95da237f$export$309ed92381819b04);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $f9udY = parcelRequire("f9udY");

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");


var $lB7xL = parcelRequire("lB7xL");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $4B518 = parcelRequire("4B518");

var $d414Q = parcelRequire("d414Q");

var $jmSzK = parcelRequire("jmSzK");
const $ff4506ef95da237f$var$planCalendarEmbedRouteEntry = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $f9udY.calendarEntryPoint)
});
const $ff4506ef95da237f$export$309ed92381819b04 = (0, $fdS54.createEntry)((0, $d414Q.arjCalendarEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar-embed',
        skeleton: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jmSzK.CalendarSkeleton), null);
        },
        entryPoint () {
            (0, $lB7xL.setCapability)((0, $0ce01f968965dadd$export$f999749ac7a2cd1));
            return $ff4506ef95da237f$var$planCalendarEmbedRouteEntry;
        },
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            ...(0, $4B518.jiraSpaResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        meta: {
            capability: (0, $0ce01f968965dadd$export$f999749ac7a2cd1)
        },
        forPaint: [],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("f9udY", function(module, exports) {
$parcel$export(module.exports, "calendarEntryPoint", () => $54cc4417905e6cb4$export$19cf4b398f638dc6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6ySM3 = parcelRequire("6ySM3");
const $54cc4417905e6cb4$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
const $54cc4417905e6cb4$var$SETTINGS_STORAGE_KEY = 'plans_calendar_view_settings';
function $54cc4417905e6cb4$var$getViewSettings(key) {
    try {
        // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $54cc4417905e6cb4$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $54cc4417905e6cb4$var$getStorageKeyFromScope(context) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
}
function $54cc4417905e6cb4$var$getStorageValueFromScope(key) {
    // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    const storedData = globalThis.localStorage?.getItem(key) || '';
    return storedData;
}
function $54cc4417905e6cb4$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $54cc4417905e6cb4$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $54cc4417905e6cb4$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const { cloudId: cloudId, activationId: activationId } = tenantContext;
    const planScenarioAri = $54cc4417905e6cb4$var$toPlanScenarioAri({
        siteId: cloudId,
        activationId: activationId,
        planId: String(planId),
        scenarioId: String(scenarioId)
    });
    return {
        type: 'plan',
        ids: [
            planScenarioAri
        ]
    };
}
function $54cc4417905e6cb4$var$buildScopeInput(scope) {
    return {
        ids: scope.ids
    };
}
function $54cc4417905e6cb4$var$buildViewId(scope) {
    // plan scenario ARI is the view id
    return scope.ids?.[0] ?? '';
}
function $54cc4417905e6cb4$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $54cc4417905e6cb4$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $54cc4417905e6cb4$var$toCalendarWeekStart(weekStart) {
    switch(weekStart){
        case 'sunday':
            return 'sunday';
        case 'saturday':
            return 'saturday';
        default:
            return 'monday';
    }
}
function $54cc4417905e6cb4$var$toCalendarColorBy(colorBy) {
    switch(colorBy){
        case 'none':
            return 'none';
        case 'status':
            return 'status';
        default:
            return 'status';
    }
}
function $54cc4417905e6cb4$var$toCalendarViewRange(view) {
    switch(view){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $54cc4417905e6cb4$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $54cc4417905e6cb4$var$toMidnightUTCString(selectedDate),
        mode: $54cc4417905e6cb4$var$toViewMode(viewRange),
        weekStart: $54cc4417905e6cb4$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: viewId
    };
}
function $54cc4417905e6cb4$var$buildIssuesSearchInput(storageKey, filter, isEmbed) {
    return {
        additionalFilterQuery: isEmbed === true ? filter ?? '' : filter || $54cc4417905e6cb4$var$getStorageValueFromScope(storageKey)
    };
}
function $54cc4417905e6cb4$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $54cc4417905e6cb4$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $54cc4417905e6cb4$var$buildCalendarCrossProjectVersionsInput() {
    return {
        statuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $54cc4417905e6cb4$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $54cc4417905e6cb4$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorBy, viewRange) {
    if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam || colorBy || viewRange) return {
        hideWeekends: hideWeekends === 'true' || undefined,
        hideSprints: hideSprints === 'true' || undefined,
        hideVersions: hideVersions === 'true' || undefined,
        hideIssues: hideIssues === 'true' || undefined,
        hideIssueKey: hideIssueKey === 'true' || undefined,
        weekStartsOn: $54cc4417905e6cb4$var$toCalendarWeekStart(weekStartsOnQueryParam),
        colorBy: $54cc4417905e6cb4$var$toCalendarColorBy(colorBy),
        viewRange: $54cc4417905e6cb4$var$toCalendarViewRange(viewRange)
    };
    return undefined;
}

const $54cc4417905e6cb4$export$19cf4b398f638dc6 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("85SaO")), {
        moduleId: "86dd1e05",
        moduleName: "CalendarEntryPoint",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $54cc4417905e6cb4$var$createScope(entryPointRouteParams);
        const scopeInput = $54cc4417905e6cb4$var$buildScopeInput(scope);
        const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam, colorBy: colorByQueryParam, viewRange: viewRangeParam } = context.query;
        const selectedDate = $54cc4417905e6cb4$var$toDate(date);
        const hasFilterQueryParam = Boolean(filter);
        const routeName = context.route.name;
        const settingsQueryParams = $54cc4417905e6cb4$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorByQueryParam, viewRangeParam);
        const isEmbed = routeName === $54cc4417905e6cb4$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED;
        const settings = $54cc4417905e6cb4$var$getViewSettings($54cc4417905e6cb4$var$SETTINGS_STORAGE_KEY);
        const viewRange = settingsQueryParams?.viewRange ?? settings?.viewRange ?? 'month';
        const weekStartsOn = settingsQueryParams?.weekStartsOn ?? settings?.weekStartsOn ?? 'monday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const storageKey = $54cc4417905e6cb4$var$getStorageKeyFromScope(context);
        const viewId = $54cc4417905e6cb4$var$buildViewId(scope);
        const filterQuery = $54cc4417905e6cb4$var$buildIssuesSearchInput(storageKey, filter, isEmbed);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $6ySM3.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: scopeInput,
                        configurationInput: $54cc4417905e6cb4$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 50,
                        issuesSearchInput: filterQuery,
                        unscheduledIssuesSearchInput: $54cc4417905e6cb4$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $54cc4417905e6cb4$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $54cc4417905e6cb4$var$buildSprintsSearchInput(),
                        crossProjectVersionsSearchInput: $54cc4417905e6cb4$var$buildCalendarCrossProjectVersionsInput(),
                        viewId: viewId,
                        skipSprintSearch: false,
                        skipPanelIssueSearch: true,
                        skipCrossProjectVersionSearch: false,
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: false,
                        skipUserPreferences: false,
                        isCalendarFilterRefinementEnabled: false,
                        filterScope: null
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                storageKey: storageKey,
                hasFilterQueryParam: hasFilterQueryParam,
                routeName: routeName,
                settingsQueryParams: settingsQueryParams,
                filterQuery: filterQuery.additionalFilterQuery,
                planId: String(context.match.params.planId)
            }
        };
    }
});

});
parcelRegister("6ySM3", function(module, exports) {
$parcel$export(module.exports, "default", () => $953d446ce050c49e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<45a8a3c5445ab8224a14f01c7281091c>>
 * @relayHash 9a1162044fb5be7bc0b3fa5f2605420a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6b681a0510b0cc96a27b5385f89cff530654bcdd8e107313b7f16d2f834c8049
const $953d446ce050c49e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6b681a0510b0cc96a27b5385f89cff530654bcdd8e107313b7f16d2f834c8049",
        "metadata": {},
        "name": "CalendarContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $953d446ce050c49e$export$2e2bcd8739ae039 = $953d446ce050c49e$var$node;

});

parcelRegister("85SaO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("6HdS5")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("1fc7g")
]).then(()=>parcelRequire('kjzOz'));

});
parcelRegister("6IImj", function(module, exports) {
"use strict";

var $5hjMu = parcelRequire("5hjMu");
module.exports = $5hjMu(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("5hjMu", function(module, exports) {
"use strict";
let $3d7de26527ef7bdf$var$cachedBundles = {};
let $3d7de26527ef7bdf$var$cachedPreloads = {};
let $3d7de26527ef7bdf$var$cachedPrefetches = {};
function $3d7de26527ef7bdf$var$getCache(type) {
    switch(type){
        case 'preload':
            return $3d7de26527ef7bdf$var$cachedPreloads;
        case 'prefetch':
            return $3d7de26527ef7bdf$var$cachedPrefetches;
        default:
            return $3d7de26527ef7bdf$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $3d7de26527ef7bdf$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("6ZHVf", function(module, exports) {
$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $959a257e0b330604$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $959a257e0b330604$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $959a257e0b330604$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $959a257e0b330604$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $959a257e0b330604$export$f5b159e1fb19e04e);

var $WqSvO = parcelRequire("WqSvO");

var $fOKvg = parcelRequire("fOKvg");

var $bdEst = parcelRequire("bdEst");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");

const $959a257e0b330604$export$6ca262338f199e4b = (0, $7edbf.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        /**
		 * resource getKey will be called whenever URL changes
		 */ return '';
    },
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/layouts-jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $959a257e0b330604$export$aec847b4ce72891 = (0, $7edbf.createResource)({
    type: (0, $3f8fae8be74ca3ea$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $h2wCv.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $959a257e0b330604$export$7431e46c7ad56c3d = (0, $7edbf.createResource)({
    type: (0, $3f8fae8be74ca3ea$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        if (!(0, $fOKvg.checkAuthentication)(tenantContext)) throw (0, $bdEst.createResourceError)({
            component: 'router-resources.advanced-roadmaps-plan.initial-checks.get-data',
            message: 'Current user is not authenticated',
            name: 'AuthenticationError',
            skipSentry: true
        });
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $h2wCv.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/layouts-jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $959a257e0b330604$export$bf0c5395c73cc255 = (0, $7edbf.createResource)({
    type: (0, $3f8fae8be74ca3ea$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        if (!(0, $fOKvg.checkAuthentication)(tenantContext)) throw (0, $bdEst.createResourceError)({
            component: 'router-resources.advanced-roadmaps-plan.report-initial-checks.get-data',
            message: 'Current user is not authenticated',
            name: 'AuthenticationError',
            skipSentry: true
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $h2wCv.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/layouts-jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $959a257e0b330604$export$f5b159e1fb19e04e = (0, $7edbf.createResource)({
    type: (0, $3f8fae8be74ca3ea$export$179a0d35e95a4d61),
    getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
    getData: async ({ match: match })=>{
        // Sometimes currentPlanId isn't yet ready - we retry a few times to check if it has loaded in before making the request
        const RETRIES = 3;
        const DELAY = 500;
        const attemptFetch = async (remainingRetries)=>{
            const currentPlanId = match.params.planId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(currentPlanId)) {
                const defaultBoardIdResponse = await (0, $h2wCv.performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                if (defaultBoardIdResponse === null) return {
                    boardId: null
                };
                const { id: id } = defaultBoardIdResponse;
                return {
                    boardId: id
                };
            }
            if (remainingRetries > 0) {
                await new Promise((resolve)=>setTimeout(resolve, DELAY));
                return attemptFetch(remainingRetries - 1);
            }
            throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
        };
        return attemptFetch(RETRIES);
    },
    // Invalidation is implemented here: src/packages/platform/layouts-jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});

});
const $3f8fae8be74ca3ea$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $3f8fae8be74ca3ea$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $3f8fae8be74ca3ea$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $3f8fae8be74ca3ea$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';
const $3f8fae8be74ca3ea$export$86e7621b5eb1a48d = 'PLANS_BACKLOG';


parcelRegister("9G2Ea", function(module, exports) {
$parcel$export(module.exports, "plansBacklogResource", () => $abd9bbf25dd5fd68$export$7a03654bb158767d);
$parcel$export(module.exports, "getPlansBacklogResource", () => $abd9bbf25dd5fd68$export$bbeee392b5121545);

var $2700E = parcelRequire("2700E");

var $7edbf = parcelRequire("7edbf");


var $dXgh0 = parcelRequire("dXgh0");
const $abd9bbf25dd5fd68$export$7a03654bb158767d = (0, $7edbf.createResource)({
    type: (0, $3f8fae8be74ca3ea$export$86e7621b5eb1a48d),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: ({ match: match })=>{
        // move this to new resource
        if (!(0, $2700E.expVal)('introduce_resource_loading_on_transition_in_plans', 'isEnabled', false)) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_BACKLOG_PROMISE__) return;
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return (0, $dXgh0.getBacklog)(planId, scenarioId);
    },
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/layouts-jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $abd9bbf25dd5fd68$export$bbeee392b5121545 = ()=>(0, $2700E.expVal)('introduce_resource_loading_on_transition_in_plans', 'isEnabled', false) ? [
        $abd9bbf25dd5fd68$export$7a03654bb158767d
    ] : [];

});
parcelRegister("dXgh0", function(module, exports) {
$parcel$export(module.exports, "getBacklog", () => $8b2ebecc758833fd$export$78352065150b1467);
const $8b2ebecc758833fd$export$78352065150b1467 = (planId, scenarioId)=>{
    const planIdNum = Number.parseFloat(planId || 'NaN');
    const scenarioIdNum = Number.parseFloat(scenarioId || 'NaN');
    if (Number.isNaN(planIdNum)) throw new Error('Plan cannot be loaded without a planId');
    if (Number.isNaN(scenarioIdNum)) throw new Error('Plan cannot be loaded without a scenarioId');
    const backlogRequestBody = {
        planId: planIdNum,
        scenarioId: scenarioIdNum,
        filter: {
            includeCompleted: true,
            includeIssueLinks: true
        },
        supportingDataOptions: {
            assignees: true,
            reporters: true,
            externalTeams: true,
            sprints: true,
            rollups: true
        }
    };
    const url = '/rest/jpo/1.0/backlog/compact?operation=getBacklogCompact';
    return fetch(url, {
        method: 'POST',
        body: JSON.stringify(backlogRequestBody),
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    });
};

});


/* eslint-disable jira/filename-case */ const $0ce01f968965dadd$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $0ce01f968965dadd$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $0ce01f968965dadd$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $0ce01f968965dadd$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $0ce01f968965dadd$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $0ce01f968965dadd$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $0ce01f968965dadd$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $0ce01f968965dadd$export$4695c1a423ffe431 = 'DASHBOARD';
const $0ce01f968965dadd$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $0ce01f968965dadd$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $0ce01f968965dadd$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("d414Q", function(module, exports) {
$parcel$export(module.exports, "arjCalendarEmbedRoute", () => $629f85eaeab2c3be$export$30779cab3c860456);
const $629f85eaeab2c3be$export$30779cab3c860456 = {
    name: 'software-plan-calendar-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
};

});

parcelRegister("jmSzK", function(module, exports) {
$parcel$export(module.exports, "CalendarSkeleton", () => $3b165ce6cdb06766$export$ebc7c47cc535837e);
$parcel$export(module.exports, "CalendarEmbedSkeleton", () => $3b165ce6cdb06766$export$bf543fe31d33292e);
$parcel$export(module.exports, "CalendarNoHeaderSkeleton", () => $3b165ce6cdb06766$export$504e7b05f3c54bf2);
/* CalendarSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $7aB5Z = parcelRequire("7aB5Z");

var $Ap8sb = parcelRequire("Ap8sb");

var $7WaCf = parcelRequire("7WaCf");
const $3b165ce6cdb06766$var$customCssStyles = null;
const $3b165ce6cdb06766$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7aB5Z)))
    });
$3b165ce6cdb06766$export$ebc7c47cc535837e.displayName = "CalendarSkeleton";
const $3b165ce6cdb06766$export$bf543fe31d33292e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ap8sb)))
    });
$3b165ce6cdb06766$export$bf543fe31d33292e.displayName = "CalendarEmbedSkeleton";
const $3b165ce6cdb06766$export$504e7b05f3c54bf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7WaCf))),
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    });
$3b165ce6cdb06766$export$504e7b05f3c54bf2.displayName = "CalendarNoHeaderSkeleton";

});
parcelRegister("7aB5Z", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("Ap8sb", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("7WaCf", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});



parcelRegister("iGEun", function(module, exports) {
$parcel$export(module.exports, "arjDependenciesEmbedRouteEntry", () => $095f9552ed8f3ad3$export$2506a377ba649c46);
/* eslint-disable import/order */ 
var $8tfk1 = parcelRequire("8tfk1");

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $4B518 = parcelRequire("4B518");

var $g43As = parcelRequire("g43As");

var $dTa0V = parcelRequire("dTa0V");

var $l8fI6 = parcelRequire("l8fI6");
const $095f9552ed8f3ad3$var$planDependenciesReportEmbedRouteEntry = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $8tfk1.planDependenciesReportEntryPoint)
});
const $095f9552ed8f3ad3$export$2506a377ba649c46 = (0, $fdS54.createEntry)((0, $g43As.arjDependenciesEmbedRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l8fI6.PlanDependenciesReportEmbedPage),
        entryPoint: ()=>$095f9552ed8f3ad3$var$planDependenciesReportEmbedRouteEntry,
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            ...(0, $4B518.jiraSpaResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $l8fI6.LazyPlanDependenciesReportEmbed)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8tfk1", function(module, exports) {
$parcel$export(module.exports, "planDependenciesReportEntryPoint", () => $ef481dc481edb069$export$e4ba4cc5a2304191);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ef481dc481edb069$export$e4ba4cc5a2304191 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("hVOEo")), {
        moduleId: "87e7f76a",
        moduleName: "PlanDependenciesReportPlanDependenciesReport",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hVOEo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("3NZME")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("k06bc")
]).then(()=>parcelRequire('1iS1t'));

});


parcelRegister("g43As", function(module, exports) {
$parcel$export(module.exports, "arjDependenciesEmbedRoute", () => $6296ad8a80bb8a30$export$96aaf89753980215);
const $6296ad8a80bb8a30$export$96aaf89753980215 = {
    name: 'software-plan-dependencies-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
};

});

parcelRegister("l8fI6", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSummaryEmbed", () => $9bd31f873ba70ac9$export$b0feb6e650be3c8c);
$parcel$export(module.exports, "PlanSummaryEmbedPage", () => $9bd31f873ba70ac9$export$a37f296d90476a73);
$parcel$export(module.exports, "LazyPlanDependenciesReportEmbed", () => $9bd31f873ba70ac9$export$48681ab0b4246654);
$parcel$export(module.exports, "PlanDependenciesReportEmbedPage", () => $9bd31f873ba70ac9$export$4ece7fb6c15037f9);
$parcel$export(module.exports, "LazyPlanIncrementEmbed", () => $9bd31f873ba70ac9$export$51f2083dff1ee684);
$parcel$export(module.exports, "PlanIncrementEmbedPage", () => $9bd31f873ba70ac9$export$a2ae011b90c17927);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9bd31f873ba70ac9$export$b0feb6e650be3c8c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("jox58"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-summary/src/PlanSummaryWithErrorBoundary.tsx"
});
const $9bd31f873ba70ac9$export$a37f296d90476a73 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9bd31f873ba70ac9$export$b0feb6e650be3c8c,
        pageId: "plan-summary-embed-old",
        shouldShowSpinner: true
    });
$9bd31f873ba70ac9$export$a37f296d90476a73.displayName = "PlanSummaryEmbedPage";

const $9bd31f873ba70ac9$export$48681ab0b4246654 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("lt7TE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-dependencies-report/src/PlanDependenciesReport.tsx"
});
const $9bd31f873ba70ac9$export$4ece7fb6c15037f9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9bd31f873ba70ac9$export$48681ab0b4246654,
        pageId: "plan-dependencies-report-embed-old",
        shouldShowSpinner: true
    });
$9bd31f873ba70ac9$export$4ece7fb6c15037f9.displayName = "PlanDependenciesReportEmbedPage";

const $9bd31f873ba70ac9$export$51f2083dff1ee684 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("b7lc0"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-increment/src/PlanIncrement.tsx"
});
const $9bd31f873ba70ac9$export$a2ae011b90c17927 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9bd31f873ba70ac9$export$51f2083dff1ee684,
        pageId: "plan-increment-embed-old",
        shouldShowSpinner: true
    });
$9bd31f873ba70ac9$export$a2ae011b90c17927.displayName = "PlanIncrementEmbedPage";

});
parcelRegister("jox58", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("hLCL0")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("4MwFq")
]).then(()=>parcelRequire('l69ni'));

});

parcelRegister("lt7TE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("dZOTz")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("314lq")
]).then(()=>parcelRequire('bYUp7'));

});

parcelRegister("b7lc0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("f0359")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("afMoM")
]).then(()=>parcelRequire('8CO1T'));

});



parcelRegister("1EaRu", function(module, exports) {
$parcel$export(module.exports, "arjIncrementEmbedRouteEntry", () => $df554c7928ee49b6$export$3feed0b4da010c52);
/* eslint-disable import/order */ 
var $flIfc = parcelRequire("flIfc");

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $4B518 = parcelRequire("4B518");

var $f79N9 = parcelRequire("f79N9");

var $dTa0V = parcelRequire("dTa0V");

var $l8fI6 = parcelRequire("l8fI6");
const $df554c7928ee49b6$var$planProgramEmbedRouteEntry = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $flIfc.planIncrementEntryPoint)
});
const $df554c7928ee49b6$export$3feed0b4da010c52 = (0, $fdS54.createEntry)((0, $f79N9.arjIncrementEmbedRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l8fI6.PlanIncrementEmbedPage),
        entryPoint: ()=>$df554c7928ee49b6$var$planProgramEmbedRouteEntry,
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            ...(0, $4B518.jiraSpaResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $l8fI6.LazyPlanIncrementEmbed)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("flIfc", function(module, exports) {
$parcel$export(module.exports, "planIncrementEntryPoint", () => $710bc45bd17203ac$export$72cc8a7d91a08ace);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $710bc45bd17203ac$export$72cc8a7d91a08ace = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("gXQm9")), {
        moduleId: "30725524",
        moduleName: "PlanIncrementPlanIncrement",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gXQm9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("djkXQ")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("dI3Fa")
]).then(()=>parcelRequire('f02XI'));

});


parcelRegister("f79N9", function(module, exports) {
$parcel$export(module.exports, "arjIncrementEmbedRoute", () => $a90cca274f1ab7ea$export$88913ef2dfa37bc1);
const $a90cca274f1ab7ea$export$88913ef2dfa37bc1 = {
    name: 'software-plan-increment-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
};

});


parcelRegister("sXwqJ", function(module, exports) {
$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRouteEntry", () => $a0b518be87169fac$export$804f2d81dfbdd5c9);
/* eslint-disable import/order */ 

var $cTVz6 = parcelRequire("cTVz6");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $bDuc8 = parcelRequire("bDuc8");

var $dNiK2 = parcelRequire("dNiK2");

var $5GUyB = parcelRequire("5GUyB");
const $a0b518be87169fac$export$804f2d81dfbdd5c9 = (0, $fdS54.createEntry)((0, $bDuc8.arjSettingsDependenciesLegacyRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5GUyB.redirectTo)('/jira/plans/settings/dependencies'),
        isRedirect: true,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $cTVz6.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dNiK2.LazyArjSettingsDependencies)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cTVz6", function(module, exports) {
$parcel$export(module.exports, "issueLinkInformationResource", () => $1a4999709e3abad4$export$8d8544ca08d98837);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $1a4999709e3abad4$var$body = {
    providers: [
        'issueLinks',
        'dependencySettings'
    ]
};
const $1a4999709e3abad4$var$url = '/rest/jpo/1.0/info/query';
const $1a4999709e3abad4$var$fetchIssueLinkInformation = ()=>(0, $h2wCv.performPostRequest)($1a4999709e3abad4$var$url, {
        body: JSON.stringify($1a4999709e3abad4$var$body)
    });
const $1a4999709e3abad4$export$8d8544ca08d98837 = (0, $7edbf.createResource)({
    type: 'ISSUE_LINK_INFORMATION',
    getKey: ()=>'issue-link-information',
    getData: async ()=>$1a4999709e3abad4$var$fetchIssueLinkInformation(),
    maxAge: 0
});

});

parcelRegister("bDuc8", function(module, exports) {
$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRoute", () => $47fadba0ca34990f$export$f96bfb0a2b0ad0f4);
const $47fadba0ca34990f$export$f96bfb0a2b0ad0f4 = {
    name: 'arj-settings-dependencies-redirect',
    path: '/secure/PortfolioDependencySettings.jspa'
};

});

parcelRegister("dNiK2", function(module, exports) {
$parcel$export(module.exports, "LazyArjSettingsDependencies", () => $e06edc05aa53d8aa$export$4fcc3c0f6e792efc);
$parcel$export(module.exports, "ArjSettingsDependencies", () => $e06edc05aa53d8aa$export$d6f045c7c1aaff50);
$parcel$export(module.exports, "LazyArjSettingsLoadingLimits", () => $e06edc05aa53d8aa$export$64761ea1912fdcd9);
$parcel$export(module.exports, "ArjSettingsLoadingLimits", () => $e06edc05aa53d8aa$export$7bb4c0f22b467385);
$parcel$export(module.exports, "LazyArjSettingsPermissions", () => $e06edc05aa53d8aa$export$edb4ae7e85c7908d);
$parcel$export(module.exports, "ArjSettingsPermissions", () => $e06edc05aa53d8aa$export$fa852ea42b98d3de);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $e06edc05aa53d8aa$export$4fcc3c0f6e792efc = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("2ElZ4"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-dependencies-settings/src/ArjSettingsDependencies.tsx"
});
const $e06edc05aa53d8aa$export$d6f045c7c1aaff50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e06edc05aa53d8aa$export$4fcc3c0f6e792efc,
        pageId: "arj-settings-dependencies",
        shouldShowSpinner: true
    });
$e06edc05aa53d8aa$export$d6f045c7c1aaff50.displayName = "ArjSettingsDependencies";

const $e06edc05aa53d8aa$export$64761ea1912fdcd9 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dzw3Y"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-loading-limits-settings/src/LoadingLimits.tsx"
});
const $e06edc05aa53d8aa$export$7bb4c0f22b467385 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e06edc05aa53d8aa$export$64761ea1912fdcd9,
        pageId: "arj-settings-loading-limits",
        shouldShowSpinner: true
    });
$e06edc05aa53d8aa$export$7bb4c0f22b467385.displayName = "ArjSettingsLoadingLimits";

const $e06edc05aa53d8aa$export$edb4ae7e85c7908d = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("15ZyJ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-permissions-settings/src/ArjSettingsPermissions.tsx"
});
const $e06edc05aa53d8aa$export$fa852ea42b98d3de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e06edc05aa53d8aa$export$edb4ae7e85c7908d,
        pageId: "arj-settings-permissions",
        shouldShowSpinner: true
    });
$e06edc05aa53d8aa$export$fa852ea42b98d3de.displayName = "ArjSettingsPermissions";

});
parcelRegister("2ElZ4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("Y44Se")
]).then(()=>parcelRequire('jzHOf'));

});

parcelRegister("dzw3Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("bzzjV")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("dz56X")
]).then(()=>parcelRequire('3caXR'));

});

parcelRegister("15ZyJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4QhQl").then(()=>parcelRequire('9Tycq'));

});


parcelRegister("5GUyB", function(module, exports) {
$parcel$export(module.exports, "redirectTo", () => $73b73d8eaaa242ec$export$2d47ce6f15e624e5);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");
const $73b73d8eaaa242ec$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
            to: redirectUrl
        });

});
parcelRegister("dLVGe", function(module, exports) {
$parcel$export(module.exports, "ScreenRedirect", () => $d5e6f898ef5c8d5d$export$fdd3e60cd227c2f7);

var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $eNr3t = parcelRequire("eNr3t");

var $gNbXR = parcelRequire("gNbXR");
var $bc9Gj = parcelRequire("bc9Gj");
const $d5e6f898ef5c8d5d$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $bc9Gj.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $eNr3t.useSpaStateTransition)();
    const eventRef = (0, $euxye.useRef)(createAnalyticsEvent({}));
    (0, $euxye.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $aJ81Y.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};
$d5e6f898ef5c8d5d$export$fdd3e60cd227c2f7.displayName = "ScreenRedirect";

});
parcelRegister("eNr3t", function(module, exports) {
$parcel$export(module.exports, "useSpaStateTransition", () => $7fadf34014da5aa6$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $7fadf34014da5aa6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fDxFn = parcelRequire("fDxFn");

var $3h1FP = parcelRequire("3h1FP");
var $iGu4q = parcelRequire("iGu4q");

var $6Bw3S = parcelRequire("6Bw3S");
const $7fadf34014da5aa6$var$getNavigationStart = ()=>{
    const timestamp = (0, $fDxFn.default) && (0, $fDxFn.default).timing && (0, $fDxFn.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $7fadf34014da5aa6$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $7fadf34014da5aa6$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $7fadf34014da5aa6$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $7fadf34014da5aa6$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $7fadf34014da5aa6$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $7fadf34014da5aa6$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/spa-state-controller/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $7fadf34014da5aa6$var$SpaStateTransitionStateSubscriber = (0, $iGu4q.createSubscriber)((0, $6Bw3S.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $7fadf34014da5aa6$export$aea217a45095ce11
});
const $7fadf34014da5aa6$export$4d1974344641a2c9 = (0, $3h1FP.createHook)((0, $6Bw3S.default), {
    selector: $7fadf34014da5aa6$export$aea217a45095ce11
});
var $7fadf34014da5aa6$export$2e2bcd8739ae039 = $7fadf34014da5aa6$var$SpaStateTransitionStateSubscriber;

});




parcelRegister("jGn6O", function(module, exports) {
$parcel$export(module.exports, "arjSettingsDependenciesRouteEntry", () => $32e3879da08d9af8$export$70386609aff5ba12);
/* eslint-disable import/order */ 

var $cTVz6 = parcelRequire("cTVz6");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $9sfTY = parcelRequire("9sfTY");

var $dNiK2 = parcelRequire("dNiK2");
const $32e3879da08d9af8$export$70386609aff5ba12 = (0, $fdS54.createEntry)((0, $9sfTY.arjSettingsDependenciesRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dNiK2.ArjSettingsDependencies),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $cTVz6.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dNiK2.LazyArjSettingsDependencies)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9sfTY", function(module, exports) {
$parcel$export(module.exports, "arjSettingsDependenciesRoute", () => $972890127592f159$export$ff9b90f9d680e34);
const $972890127592f159$export$ff9b90f9d680e34 = {
    name: 'arj-settings-dependencies',
    path: '/jira/plans/settings/dependencies'
};

});


parcelRegister("3FQW7", function(module, exports) {
$parcel$export(module.exports, "arjSettingsFinancialYearPageRouteEntry", () => $3f3c61e335d18ca3$export$b6bba25826e621b9);
/* eslint-disable import/order */ 


var $9NUw3 = parcelRequire("9NUw3");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $2QtLL = parcelRequire("2QtLL");

var $95T06 = parcelRequire("95T06");
const $3f3c61e335d18ca3$export$b6bba25826e621b9 = (0, $fdS54.createEntry)((0, $2QtLL.arjSettingsFinancialYearPageRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $95T06.ArjSettingsFinancialYear),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $9NUw3.arjSettingsFinancialYearResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $95T06.LazyArjSettingsFinancialYear)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9NUw3", function(module, exports) {
$parcel$export(module.exports, "arjSettingsFinancialYearResource", () => $6c3f155ddb6f3275$export$da45020eede4a793);

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");
const $6c3f155ddb6f3275$var$RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';
const $6c3f155ddb6f3275$export$da45020eede4a793 = (0, $7edbf.createResource)({
    type: $6c3f155ddb6f3275$var$RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR,
    getKey: ()=>'financial-year-information',
    getData: async ()=>(0, $4fhEY.default)('/rest/jpo/1.0/fiscalYear'),
    maxAge: 0
});

});

parcelRegister("2QtLL", function(module, exports) {
$parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", () => $bfd1b37a908648d1$export$7208300f00a36a5f);
const $bfd1b37a908648d1$export$7208300f00a36a5f = {
    name: 'arj-settings-financial-year',
    path: '/jira/plans/settings/financial-year',
    exact: true
};

});

parcelRegister("95T06", function(module, exports) {
$parcel$export(module.exports, "LazyArjSettingsFinancialYear", () => $9ee96f78a561ec9f$export$dd67c2f01a58231e);
$parcel$export(module.exports, "ArjSettingsFinancialYear", () => $9ee96f78a561ec9f$export$785180185eba7ed9);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9ee96f78a561ec9f$export$dd67c2f01a58231e = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("03nEb")).then((module)=>module.ArjSettingsFinancialYear)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-financial-year-settings/src/ArjSettingsFinancialYear.tsx"
});
const $9ee96f78a561ec9f$export$785180185eba7ed9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9ee96f78a561ec9f$export$dd67c2f01a58231e,
        pageId: "arj-settings-financial-year",
        shouldShowSpinner: true
    });
$9ee96f78a561ec9f$export$785180185eba7ed9.displayName = "ArjSettingsFinancialYear";

});
parcelRegister("03nEb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c7m24").then(()=>parcelRequire('9opx0'));

});



parcelRegister("e8JLL", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRouteEntry", () => $2f2177debede772c$export$9f80102c0f64ad9b);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $9hjKs = parcelRequire("9hjKs");

var $dNiK2 = parcelRequire("dNiK2");

var $5GUyB = parcelRequire("5GUyB");
const $2f2177debede772c$export$9f80102c0f64ad9b = (0, $fdS54.createEntry)((0, $9hjKs.arjSettingsLoadingLimitsLegacyRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5GUyB.redirectTo)('/jira/plans/settings/loading-limits'),
        isRedirect: true,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dNiK2.LazyArjSettingsLoadingLimits)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9hjKs", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRoute", () => $dfe196c28f2ee9f5$export$7c71e235d628daf5);
const $dfe196c28f2ee9f5$export$7c71e235d628daf5 = {
    name: 'arj-settings-loading-limits-redirect',
    path: '/secure/PortfolioLoadingLimits.jspa'
};

});


parcelRegister("7Txn7", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsRouteEntry", () => $4e5f57519f499ac2$export$6786257309f86d8c);
/* eslint-disable import/order */ 

var $1VBey = parcelRequire("1VBey");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $fIbvQ = parcelRequire("fIbvQ");

var $dNiK2 = parcelRequire("dNiK2");
const $4e5f57519f499ac2$export$6786257309f86d8c = (0, $fdS54.createEntry)((0, $fIbvQ.arjSettingsLoadingLimitsRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dNiK2.ArjSettingsLoadingLimits),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $1VBey.arjSettingsLoadingLimitsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dNiK2.LazyArjSettingsLoadingLimits)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1VBey", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsResource", () => $be1da3d285441b88$export$c9e47fa9b57975f5);

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");
const $be1da3d285441b88$var$RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';
const $be1da3d285441b88$export$c9e47fa9b57975f5 = (0, $7edbf.createResource)({
    type: $be1da3d285441b88$var$RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS,
    getKey: ()=>'loading-limits-information',
    getData: async ()=>(0, $4fhEY.default)('/rest/jpo/1.0/configuration'),
    maxAge: 0
});

});

parcelRegister("fIbvQ", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsRoute", () => $f5c37a1c942df606$export$f90dc3a45fadc1e2);
const $f5c37a1c942df606$export$f90dc3a45fadc1e2 = {
    name: 'arj-settings-loading-limits',
    path: '/jira/plans/settings/loading-limits'
};

});


parcelRegister("d9CZt", function(module, exports) {
$parcel$export(module.exports, "arjSettingsPermissionsRouteEntry", () => $f9c035c4ab4a5287$export$4e97658a5cc15eaa);
/* eslint-disable import/order */ 

var $iLYuN = parcelRequire("iLYuN");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $36jO1 = parcelRequire("36jO1");

var $dNiK2 = parcelRequire("dNiK2");
const $f9c035c4ab4a5287$export$4e97658a5cc15eaa = (0, $fdS54.createEntry)((0, $36jO1.arjSettingsPermissionsRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dNiK2.ArjSettingsPermissions),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $iLYuN.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dNiK2.LazyArjSettingsPermissions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iLYuN", function(module, exports) {
$parcel$export(module.exports, "grantedPermissionsResource", () => $3e6c0f09538dd1be$export$aa3daf3280e2a2d7);
$parcel$export(module.exports, "permissionGroupsResource", () => $3e6c0f09538dd1be$export$950060d83722e3bd);
$parcel$export(module.exports, "getGlobalPermissionPageResources", () => $3e6c0f09538dd1be$export$a09a91246a866817);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $3e6c0f09538dd1be$var$fetchGrantedPermissions = ()=>(0, $h2wCv.performPostRequest)('/rest/roadmaps/1.0/info/query', {
        body: JSON.stringify({
            providers: [
                'permissions'
            ]
        })
    });
const $3e6c0f09538dd1be$var$fetchPermissionGroups = ()=>(0, $h2wCv.performPostRequest)('/rest/jpo/1.0/groupsandusers', {
        body: JSON.stringify({
            includeUsers: false,
            excludedGroups: [],
            excludedUsers: [],
            query: ''
        })
    });
const $3e6c0f09538dd1be$export$aa3daf3280e2a2d7 = (0, $7edbf.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
    getKey: ()=>'arj-granted-permissions',
    getData: async ()=>$3e6c0f09538dd1be$var$fetchGrantedPermissions(),
    maxAge: 0
});
const $3e6c0f09538dd1be$export$950060d83722e3bd = (0, $7edbf.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
    getKey: ()=>'arj-permission-groups',
    getData: async ()=>$3e6c0f09538dd1be$var$fetchPermissionGroups(),
    maxAge: 0
});
const $3e6c0f09538dd1be$export$a09a91246a866817 = ()=>[
        $3e6c0f09538dd1be$export$aa3daf3280e2a2d7,
        $3e6c0f09538dd1be$export$950060d83722e3bd
    ];

});

parcelRegister("36jO1", function(module, exports) {
$parcel$export(module.exports, "arjSettingsPermissionsRoute", () => $4728416a94b1f749$export$4501213a8b1d3a10);
const $4728416a94b1f749$export$4501213a8b1d3a10 = {
    name: 'arj-settings-permissions',
    path: '/jira/plans/settings/permissions'
};

});


parcelRegister("46xzL", function(module, exports) {
$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRouteEntry", () => $5a10e39c1fa7c3c2$export$949c8177281fcc39);
/* eslint-disable import/order */ 

var $iLYuN = parcelRequire("iLYuN");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $7Q8Ta = parcelRequire("7Q8Ta");

var $dNiK2 = parcelRequire("dNiK2");

var $5GUyB = parcelRequire("5GUyB");
const $5a10e39c1fa7c3c2$export$949c8177281fcc39 = (0, $fdS54.createEntry)((0, $7Q8Ta.arjSettingsPermissionsRouteLegacyRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5GUyB.redirectTo)('/jira/plans/settings/permissions'),
        isRedirect: true,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $iLYuN.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dNiK2.LazyArjSettingsPermissions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7Q8Ta", function(module, exports) {
$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRoute", () => $00992d710ead6254$export$24bf73f2d1dbf0db);
const $00992d710ead6254$export$24bf73f2d1dbf0db = {
    name: 'arj-settings-permissions-redirect',
    path: '/secure/PortfolioPermissions.jspa'
};

});


parcelRegister("29RF5", function(module, exports) {
$parcel$export(module.exports, "arjSummaryEmbedRouteEntry", () => $f9c6bad268ef1525$export$bdc2c75e02c29d7);
/* eslint-disable import/order */ 
var $4sqdF = parcelRequire("4sqdF");

var $6ZHVf = parcelRequire("6ZHVf");

var $eHM2A = parcelRequire("eHM2A");

var $hSbtM = parcelRequire("hSbtM");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $4B518 = parcelRequire("4B518");

var $aik8w = parcelRequire("aik8w");

var $dTa0V = parcelRequire("dTa0V");

var $l8fI6 = parcelRequire("l8fI6");
const $f9c6bad268ef1525$var$planSummaryEmbedRouteEntry = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $4sqdF.planSummaryEntryPoint)
});
const $f9c6bad268ef1525$export$bdc2c75e02c29d7 = (0, $fdS54.createEntry)((0, $aik8w.arjSummaryEmbedRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l8fI6.PlanSummaryEmbedPage),
        entryPoint: ()=>$f9c6bad268ef1525$var$planSummaryEmbedRouteEntry,
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $eHM2A.advancedRoadmapsSummaryDataResource),
            (0, $hSbtM.summaryPagePreferencesResource),
            ...(0, $4B518.jiraSpaResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $l8fI6.LazyPlanSummaryEmbed)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4sqdF", function(module, exports) {
$parcel$export(module.exports, "planSummaryEntryPoint", () => $2bb3d4ef691b985b$export$82d8368ec1a526b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $2bb3d4ef691b985b$export$82d8368ec1a526b = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("jox58")), {
        moduleId: "167a61d6",
        moduleName: "PlanSummaryWithErrorBoundary",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});

parcelRegister("eHM2A", function(module, exports) {
$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $176a027d657c0d40$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $176a027d657c0d40$export$2dfe99460dae6bc6);

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");

var $brPIm = parcelRequire("brPIm");

var $3HeZt = parcelRequire("3HeZt");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $176a027d657c0d40$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $176a027d657c0d40$export$f9061628830b5175 = (0, $7edbf.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $176a027d657c0d40$export$2dfe99460dae6bc6(params, query, (0, $brPIm.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $176a027d657c0d40$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    const dateRange = (0, $3HeZt.validateDateRange)((0, $3HeZt.parseDateRange)($176a027d657c0d40$var$getQueryParams(query)));
    const data = await (0, $4fhEY.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...dateRange ? {
                dateRange: dateRange
            } : {}
        })
    });
    return dateRange ? {
        ...data,
        customDateRange: dateRange
    } : data;
};

});
parcelRegister("brPIm", function(module, exports) {
$parcel$export(module.exports, "CHART_TYPES", () => $8552ea8c0f166179$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $8552ea8c0f166179$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $8552ea8c0f166179$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $8552ea8c0f166179$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $8552ea8c0f166179$export$38e437924c2adbda);
const $8552ea8c0f166179$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $8552ea8c0f166179$export$79cf9c14f738d70b = [
    $8552ea8c0f166179$export$3251435144ca69e2.statusCategory,
    $8552ea8c0f166179$export$3251435144ca69e2.issueProgress,
    $8552ea8c0f166179$export$3251435144ca69e2.teamProgress,
    $8552ea8c0f166179$export$3251435144ca69e2.teamCapacity,
    $8552ea8c0f166179$export$3251435144ca69e2.blockers,
    $8552ea8c0f166179$export$3251435144ca69e2.highestPriority,
    $8552ea8c0f166179$export$3251435144ca69e2.unassignedIssues,
    $8552ea8c0f166179$export$3251435144ca69e2.overlappingBlockers,
    $8552ea8c0f166179$export$3251435144ca69e2.overdue
];
const $8552ea8c0f166179$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $8552ea8c0f166179$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $8552ea8c0f166179$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});

parcelRegister("3HeZt", function(module, exports) {
$parcel$export(module.exports, "parseDateRange", () => $bda4631a42d7a489$export$1cd7060bc72a318c);
$parcel$export(module.exports, "validateDateRange", () => $bda4631a42d7a489$export$b3e10550232e39db);
/**
 * Most of the code here is duplicated from `@atlassian/portfolio-3-summary-page`. We do not want to depend on all
 * the code from that package, but we want to parse and validate the date range before sending to the backend.
 */ 
var $hWjoa = parcelRequire("hWjoa");
const $bda4631a42d7a489$export$637d8b0948b783c7 = {
    [(0, $hWjoa.DATE_UNITS).DAYS]: 3650,
    [(0, $hWjoa.DATE_UNITS).WEEKS]: 520,
    [(0, $hWjoa.DATE_UNITS).MONTHS]: 120
};
const $bda4631a42d7a489$export$cf70eebe96d0cb07 = (type)=>{
    switch(type){
        case (0, $hWjoa.CUSTOM_TIME_RANGE_TYPES).FIXED:
        case (0, $hWjoa.CUSTOM_TIME_RANGE_TYPES).RELATIVE:
            return type;
        default:
            return undefined;
    }
};
const $bda4631a42d7a489$export$6bf0e8cf8e1d780d = (value)=>{
    if (value === undefined) return undefined;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
const $bda4631a42d7a489$export$c777dd44ece05114 = (unit)=>{
    switch(unit){
        case (0, $hWjoa.DATE_UNITS).DAYS:
        case (0, $hWjoa.DATE_UNITS).WEEKS:
        case (0, $hWjoa.DATE_UNITS).MONTHS:
            return unit;
        default:
            return undefined;
    }
};
const $bda4631a42d7a489$export$1cd7060bc72a318c = (query)=>{
    const { fromDate: fromDate, toDate: toDate, toNow: toNow, fromNow: fromNow, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, dateRangeType: dateRangeType } = query;
    return {
        typeOfCustomDateRange: $bda4631a42d7a489$export$cf70eebe96d0cb07(dateRangeType),
        fromDate: $bda4631a42d7a489$export$6bf0e8cf8e1d780d(fromDate),
        toDate: $bda4631a42d7a489$export$6bf0e8cf8e1d780d(toDate),
        fromNowUnitCount: $bda4631a42d7a489$export$6bf0e8cf8e1d780d(fromNow),
        toNowUnitCount: $bda4631a42d7a489$export$6bf0e8cf8e1d780d(toNow),
        fromNowUnit: $bda4631a42d7a489$export$c777dd44ece05114(fromNowUnit),
        toNowUnit: $bda4631a42d7a489$export$c777dd44ece05114(toNowUnit)
    };
};
const $bda4631a42d7a489$export$68346777682e262 = (count, unit)=>{
    if (count === undefined || unit === undefined) return false;
    return count >= 0 && count <= $bda4631a42d7a489$export$637d8b0948b783c7[unit];
};
const $bda4631a42d7a489$export$1ba31c57b50b4374 = (timestamp)=>{
    if (timestamp === undefined) return false;
    const date = new Date(timestamp);
    return !Number.isNaN(date.getTime());
};
const $bda4631a42d7a489$export$b3e10550232e39db = (dateRange)=>{
    const { fromDate: fromDate, toDate: toDate, toNowUnitCount: toNowUnitCount, toNowUnit: toNowUnit, fromNowUnitCount: fromNowUnitCount, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange } = dateRange;
    if (typeOfCustomDateRange === (0, $hWjoa.CUSTOM_TIME_RANGE_TYPES).RELATIVE && $bda4631a42d7a489$export$68346777682e262(toNowUnitCount, toNowUnit) && $bda4631a42d7a489$export$68346777682e262(fromNowUnitCount, fromNowUnit)) return {
        toNowUnitCount: toNowUnitCount,
        toNowUnit: toNowUnit,
        fromNowUnitCount: fromNowUnitCount,
        fromNowUnit: fromNowUnit,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    if (typeOfCustomDateRange === (0, $hWjoa.CUSTOM_TIME_RANGE_TYPES).FIXED && $bda4631a42d7a489$export$1ba31c57b50b4374(fromDate) && $bda4631a42d7a489$export$1ba31c57b50b4374(toDate)) return {
        fromDate: fromDate,
        toDate: toDate,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    return undefined;
};

});
parcelRegister("hWjoa", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $e20c83f73c2b723a$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DATE_UNITS", () => $e20c83f73c2b723a$export$c99d20cdba4a5739);
$parcel$export(module.exports, "IssueStatus", () => $e20c83f73c2b723a$export$559eb15a98685419);
$parcel$export(module.exports, "BlockType", () => $e20c83f73c2b723a$export$48808c686fe495c4);
const $e20c83f73c2b723a$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $e20c83f73c2b723a$export$c99d20cdba4a5739 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $e20c83f73c2b723a$export$559eb15a98685419 = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE'
};
const $e20c83f73c2b723a$export$de194318c6dccbc1 = {
    INITIATIVE: 'INITIATIVE',
    EPIC: 'EPIC'
};
const $e20c83f73c2b723a$export$48808c686fe495c4 = {
    DELAY_WORK: 'DELAY_WORK',
    CRITICAL_PATH: 'CRITICAL_PATH',
    BLOCK_WORK: 'BLOCK_WORK'
};

});



parcelRegister("hSbtM", function(module, exports) {
$parcel$export(module.exports, "summaryPagePreferencesResource", () => $3ca73575aad8f2ec$export$c5fbbea5be604181);

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");
const $3ca73575aad8f2ec$var$getSummaryPagePreferencesUrl = (planId)=>`/rest/jpo/1.0/plans/${planId}/userProperties/summaryPage`;
const $3ca73575aad8f2ec$export$c5fbbea5be604181 = (0, $7edbf.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_PREFERENCES',
    getKey: ({ match: match })=>match.params.planId ?? 'none',
    getData: async ({ match: match })=>{
        const { planId: planId } = match.params;
        if (planId == null) return null;
        const response = await (0, $4fhEY.default)($3ca73575aad8f2ec$var$getSummaryPagePreferencesUrl(planId), {
            method: 'GET'
        });
        return response.value ?? null;
    },
    maxAge: Infinity,
    isBrowserOnly: true
});

});

parcelRegister("aik8w", function(module, exports) {
$parcel$export(module.exports, "arjSummaryEmbedRoute", () => $7af4d8ef4a2bff8d$export$126053e8fb441b66);
const $7af4d8ef4a2bff8d$export$126053e8fb441b66 = {
    name: 'software-plan-summary-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
};

});


parcelRegister("5c8XY", function(module, exports) {
$parcel$export(module.exports, "arjTimelineEmbedRouteEntry", () => $0eea6d2ac0dd032b$export$a977d398db1904ff);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $l35MP = parcelRequire("l35MP");

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $4B518 = parcelRequire("4B518");

var $laM7V = parcelRequire("laM7V");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $dTa0V = parcelRequire("dTa0V");
const $0eea6d2ac0dd032b$var$planTimelineEmbedRouteEntry = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $l35MP.planTimelineEntryPoint)
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0eea6d2ac0dd032b$var$LazyPlanTimelineEmbed = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("5kKAK"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-timeline/src/ExportedComponent.tsx"
});
const $0eea6d2ac0dd032b$var$PlanTimelineEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0eea6d2ac0dd032b$var$LazyPlanTimelineEmbed,
        pageId: "plan-timeline-embed",
        shouldShowSpinner: true
    });
$0eea6d2ac0dd032b$var$PlanTimelineEmbedPage.displayName = "PlanTimelineEmbedPage";
const $0eea6d2ac0dd032b$export$a977d398db1904ff = (0, $fdS54.createEntry)((0, $laM7V.arjTimelineEmbedRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: $0eea6d2ac0dd032b$var$PlanTimelineEmbedPage,
        entryPoint: ()=>$0eea6d2ac0dd032b$var$planTimelineEmbedRouteEntry,
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            ...(0, $4B518.jiraSpaResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            $0eea6d2ac0dd032b$var$LazyPlanTimelineEmbed
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("l35MP", function(module, exports) {
$parcel$export(module.exports, "planTimelineEntryPoint", () => $0e939b85dd538c15$export$a36e3fca8afefb5b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $0e939b85dd538c15$export$a36e3fca8afefb5b = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("5Tt8r")), {
        moduleId: "1b38630b",
        moduleName: "PlanTimelineEntryPointRoot",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5Tt8r", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("5BYJX")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("1gU0Y")
]).then(()=>parcelRequire('UZOUZ'));

});


parcelRegister("laM7V", function(module, exports) {
$parcel$export(module.exports, "arjTimelineEmbedRoute", () => $4b74fc93793050bc$export$aadc28402ef87b84);
const $4b74fc93793050bc$export$aadc28402ef87b84 = {
    name: 'software-advanced-roadmaps-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
};

});

parcelRegister("5kKAK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("8bMje")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4HwYA")
]).then(()=>parcelRequire('av4ba'));

});


parcelRegister("1XPY3", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewCreateRouteEntry", () => $62be79a92e4ef6f9$export$ee75957829357d5d);

var $6BfVx = parcelRequire("6BfVx");

var $kDEp7 = parcelRequire("kDEp7");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $aZ0NI = parcelRequire("aZ0NI");

var $6pofw = parcelRequire("6pofw");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $1UBSs = parcelRequire("1UBSs");

var $dD11h = parcelRequire("dD11h");
const $62be79a92e4ef6f9$var$assetsAnalyticsDataViewCreatePageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $kDEp7.assetsAnalyticsDataViewCreateEntryPoint)
});
const $62be79a92e4ef6f9$export$ee75957829357d5d = (0, $fdS54.createEntry)((0, $aZ0NI.assetsAnalyticsDataViewCreateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$62be79a92e4ef6f9$var$assetsAnalyticsDataViewCreatePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-create-page',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-create',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6BfVx", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3e346d4333e959$export$2e2bcd8739ae039);
/* SpinnerView.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2D2gW = parcelRequire("2D2gW");

var $abhF2 = parcelRequire("abhF2");
function $ad3e346d4333e959$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ $euxye.createElement((0, $2D2gW.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $ad3e346d4333e959$var$styles.container
        ])
    }, /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $ad3e346d4333e959$var$styles.wrapper
        ])
    }, /*#__PURE__*/ $euxye.createElement((0, $abhF2.default), {
        size: "large",
        testId: testId
    }))));
}
$ad3e346d4333e959$export$2e2bcd8739ae039.displayName = "Spinner";
const $ad3e346d4333e959$var$styles = {
    container: "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
    wrapper: "_1wpz1h6o"
};

});

parcelRegister("kDEp7", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewCreateEntryPoint", () => $6183313b9521cc4d$export$cfa228728b5a63f4);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $6183313b9521cc4d$export$cfa228728b5a63f4 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aweyP")), {
        moduleId: "c4cf8f4a",
        moduleName: "AssetsAnalyticsDataViewCreatePage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aweyP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9x2pM").then(()=>parcelRequire('35gIp'));

});


parcelRegister("aZ0NI", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewCreateRoute", () => $9908e04e3f0bbd14$export$4bdd2b973f5ff912);
const $9908e04e3f0bbd14$export$4bdd2b973f5ff912 = {
    name: 'assets-analytics-data-view-create',
    path: '/jira/assets/analytics/data-view/create',
    exact: true
};

});

parcelRegister("bL4Rw", function(module, exports) {
$parcel$export(module.exports, "LazyAssetsLayout", () => $8cdc24dcd8819d20$export$6d4ed5b3aae01b61);
$parcel$export(module.exports, "AssetsLayout", () => $8cdc24dcd8819d20$export$fc69c032e8242676);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $2D2gW = parcelRequire("2D2gW");

var $l8G1z = parcelRequire("l8G1z");

var $a8EUd = parcelRequire("a8EUd");

const $8cdc24dcd8819d20$export$6d4ed5b3aae01b61 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("80GyX")).then((module)=>module.AssetsLayout), {
    ssr: false,
    moduleId: "./src/packages/assets-app/layout/src/AssetsLayout.tsx"
});
const $8cdc24dcd8819d20$export$fc69c032e8242676 = (t0)=>{
    const $ = (0, $e7boj.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
            name: "assets-layout-async"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "assets-layout-async",
            fallback: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8cdc24dcd8819d20$export$6d4ed5b3aae01b61, null, children));
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
$8cdc24dcd8819d20$export$fc69c032e8242676.displayName = "AssetsLayout";

});
parcelRegister("80GyX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eD17Z").then(()=>parcelRequire('4YmOt'));

});


parcelRegister("1UBSs", function(module, exports) {
$parcel$export(module.exports, "getCmdbResources", () => $2cc29a80caa85baf$export$850433b0663023b8);
$parcel$export(module.exports, "getAssetsAppResources", () => $2cc29a80caa85baf$export$70fc9421fb71e080);

var $iV0kf = parcelRequire("iV0kf");

var $hS4jD = parcelRequire("hS4jD");

var $8ycTI = parcelRequire("8ycTI");

var $7nWmb = parcelRequire("7nWmb");

var $1kh2I = parcelRequire("1kh2I");

var $hDZQt = parcelRequire("hDZQt");

var $dUAVJ = parcelRequire("dUAVJ");

var $8HUuJ = parcelRequire("8HUuJ");

var $4C29G = parcelRequire("4C29G");

var $lbxXL = parcelRequire("lbxXL");

var $4B518 = parcelRequire("4B518");

var $6bGyp = parcelRequire("6bGyp");

var $35eqr = parcelRequire("35eqr");

var $i860n = parcelRequire("i860n");
function $2cc29a80caa85baf$export$850433b0663023b8() {
    return [
        ...(0, $dUAVJ.getNavigationResources)(),
        ...(0, $lbxXL.getServicedeskPageContextResources)(),
        (0, $8ycTI.workspaceResource)
    ];
}
function $2cc29a80caa85baf$export$70fc9421fb71e080() {
    return [
        ...(0, $4B518.jiraSpaResources)(),
        (0, $8ycTI.workspaceResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('aurum-997-license-kill-switch'), (0, $7nWmb.assetsUserPermissionResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('assets-announcement-banner-settings'), (0, $1kh2I.assetsNavigationSettingsResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('assets-announcement-banner-settings'), (0, $1kh2I.assetsBannerSettingsResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('assets-announcement-banner-settings'), (0, $1kh2I.assetsUserSettingsResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('assets-announcement-banner-settings'), (0, $1kh2I.assetsLogoAndFaviconResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('sqa-2098-assets-platform-app-nav-upsells'), (0, $35eqr.postOfficeAssetsSideNavUpsellDashboardsPlacementResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('sqa-2098-assets-platform-app-nav-upsells'), (0, $35eqr.postOfficeAssetsSideNavUpsellDataManagerPlacementResource)),
        (0, $6bGyp.rovoEntitlementResource),
        (0, $hDZQt.getConsentBannerUserPreferencesResource)(),
        (0, $iV0kf.announcementBannerSettingsV4Resource),
        (0, $hS4jD.assetsReportingConfigResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('assets_data_manager_advisory_notifications'), (0, $4C29G.dataManagerAdvisoryNotificationsResource))
    ];
}

});
parcelRegister("hS4jD", function(module, exports) {
$parcel$export(module.exports, "assetsReportingConfigResource", () => $b5953426adc69a39$export$c360946597467d63);
$parcel$export(module.exports, "useAssetsReportingConfigResource", () => $b5953426adc69a39$export$b1e42c980036ab19);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $lBZ5O = parcelRequire("lBZ5O");
const $b5953426adc69a39$export$5d1a75fdfafa821a = 'assets-reporting-config';
const $b5953426adc69a39$export$66cad51fbbd48152 = 'assets.reporting.config';
const $b5953426adc69a39$export$c360946597467d63 = (0, $7edbf.createResource)({
    type: $b5953426adc69a39$export$5d1a75fdfafa821a,
    getKey: ()=>$b5953426adc69a39$export$66cad51fbbd48152,
    getData: async ()=>(0, $lBZ5O.getAssetsReportingConfig)(),
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $b5953426adc69a39$export$b1e42c980036ab19 = ()=>(0, $k6ufm.useResource)($b5953426adc69a39$export$c360946597467d63);

});
parcelRegister("lBZ5O", function(module, exports) {
$parcel$export(module.exports, "getAssetsReportingConfig", () => $bf1a0bb11ea08145$export$2f9afe996941d589);

var $5csC1 = parcelRequire("5csC1");

var $bYonX = parcelRequire("bYonX");

var $h2wCv = parcelRequire("h2wCv");
const $bf1a0bb11ea08145$export$2f9afe996941d589 = async ()=>{
    try {
        const { storeState: storeState } = (0, $bYonX.getResourceStore)();
        const state = storeState.getState();
        const workspaceId = await (0, $5csC1.extractResourceStatePromise)(state.data);
        if (!workspaceId || typeof workspaceId !== 'string') return {
            status: 'error',
            data: {
                isAssetsReportingEnabled: false
            }
        };
        const url = false ? '/api/v1/config' : `/gateway/api/jsm/reporting/assets/workspace/${workspaceId}/config`;
        const mergedOptions = (0, $5csC1.mergeOptionsWithDefaults)(url, {
            headers: {
                'x-ssr-service-name': 'jsm-reporting',
                'atl-workspaceid': workspaceId,
                'atl-workspacetype': 'assets'
            }
        });
        const response = await (0, $h2wCv.performGetRequest)(url, mergedOptions);
        if (!response || typeof response.isAssetsReportingEnabled !== 'boolean') return {
            status: 'error',
            data: {
                isAssetsReportingEnabled: false
            }
        };
        return {
            status: 'success',
            data: response
        };
    } catch  {
        return {
            status: 'error',
            data: {
                isAssetsReportingEnabled: false
            }
        };
    }
};

});
parcelRegister("5csC1", function(module, exports) {
$parcel$export(module.exports, "extractResourceStatePromise", () => $e164ee73c9268a9a$export$5e6c0b0c6c71e3a7);
$parcel$export(module.exports, "mergeOptionsWithDefaults", () => $e164ee73c9268a9a$export$6f47ccd8898bd6b0);
$parcel$export(module.exports, "getAdminSettingsUrl", () => $e164ee73c9268a9a$export$13aeca3ca3499df1);
$parcel$export(module.exports, "getBannerSettingsUrl", () => $e164ee73c9268a9a$export$1e927bbb56fd29f2);
$parcel$export(module.exports, "getUserSettingsUrl", () => $e164ee73c9268a9a$export$8181cb1333632cf2);
$parcel$export(module.exports, "getLogoUrl", () => $e164ee73c9268a9a$export$976f80239b15365);
$parcel$export(module.exports, "getFaviconUrl", () => $e164ee73c9268a9a$export$179f5d628a6b9050);
$parcel$export(module.exports, "getAssetsAdminHeaders", () => $e164ee73c9268a9a$export$d59383f1577b7cb5);
$parcel$export(module.exports, "transformAdminSettingsResponse", () => $e164ee73c9268a9a$export$c8db903c3984d79e);
$parcel$export(module.exports, "transformBannerSettings", () => $e164ee73c9268a9a$export$5221f0c585bc0e45);
$parcel$export(module.exports, "getAssetsTenantContextMetadata", () => $e164ee73c9268a9a$export$bb50dff15b0d8612);

var $ff8AH = parcelRequire("ff8AH");

var $6bEm8 = parcelRequire("6bEm8");

var $57UQ8 = parcelRequire("57UQ8");
const $e164ee73c9268a9a$export$5315eee73d0f8e = 'jsm-cmdb-gateway';
const $e164ee73c9268a9a$var$HEADER_X_SSR_SERVICE_NAME = 'x-ssr-service-name';
const $e164ee73c9268a9a$var$HEADER_ATL_WORKSPACEID = 'atl-workspaceid';
const $e164ee73c9268a9a$var$HEADER_X_SSR_ASAP_AUDIENCE = 'x-ssr-asap-audience';
// Single reference to server variable to minimize ratcheting count
const $e164ee73c9268a9a$var$isServer = false;
function $e164ee73c9268a9a$export$5e6c0b0c6c71e3a7(resourceState) {
    return resourceState?.[0, $57UQ8.RESOURCE_TYPE_WORKSPACE_CONTEXT]?.state?.promise;
}
const $e164ee73c9268a9a$export$6f47ccd8898bd6b0 = (url, options)=>{
    const defaultOptions = (0, $ff8AH.getDefaultOptions)(url);
    return {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers
        }
    };
};
const $e164ee73c9268a9a$export$13aeca3ca3499df1 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/admin/settings';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/settings`;
};
const $e164ee73c9268a9a$export$1e927bbb56fd29f2 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/admin/banner-settings';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/banner-settings`;
};
const $e164ee73c9268a9a$export$8181cb1333632cf2 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/user/settings';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/user/settings`;
};
const $e164ee73c9268a9a$export$976f80239b15365 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/assets-logo';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/assets-logo`;
};
const $e164ee73c9268a9a$export$179f5d628a6b9050 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return '/assets/api/v1/admin/favicon';
    return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/favicon`;
};
const $e164ee73c9268a9a$export$d59383f1577b7cb5 = (workspaceId)=>{
    if ($e164ee73c9268a9a$var$isServer) return {
        [$e164ee73c9268a9a$var$HEADER_X_SSR_ASAP_AUDIENCE]: 'assets-tempeh-archetype'
    };
    return {
        [$e164ee73c9268a9a$var$HEADER_X_SSR_SERVICE_NAME]: $e164ee73c9268a9a$export$5315eee73d0f8e,
        [$e164ee73c9268a9a$var$HEADER_ATL_WORKSPACEID]: workspaceId
    };
};
const $e164ee73c9268a9a$export$c8db903c3984d79e = (response)=>{
    return response.reduce((acc, setting)=>{
        acc[setting.key] = setting;
        return acc;
    }, {});
};
const $e164ee73c9268a9a$export$5221f0c585bc0e45 = (bannerSettings)=>{
    const { content: content, ...rest } = bannerSettings;
    const isContentString = content && typeof content === 'string';
    return {
        ...rest,
        content: isContentString ? JSON.parse(content) : JSON.stringify(content)
    };
};
const $e164ee73c9268a9a$export$bb50dff15b0d8612 = ()=>{
    try {
        const appPermissions = {
            hasSoftwareAccess: (0, $6bEm8.default)('ajs-has-jira-software') === 'true',
            hasServiceDeskAccess: (0, $6bEm8.default)('ajs-has-jira-service-desk') === 'true',
            hasCoreAccess: (0, $6bEm8.default)('ajs-has-jira-core') === 'true'
        };
        const licensedProducts = JSON.parse((0, $6bEm8.default)('ajs-licensed-products') || '{}');
        const appEditions = JSON.parse((0, $6bEm8.default)('ajs-product-editions') || '{}');
        return {
            appPermissions: appPermissions,
            licensedProducts: licensedProducts,
            appEditions: appEditions
        };
    } catch (error) {
        return {};
    }
};

});
parcelRegister("57UQ8", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_ASSETS_NAVIGATION_SETTINGS", () => $200d4a252ac4a668$export$858084c28938b25c);
$parcel$export(module.exports, "RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY", () => $200d4a252ac4a668$export$6c3a7ac5254a8135);
$parcel$export(module.exports, "RESOURCE_ASSETS_BANNER_SETTINGS", () => $200d4a252ac4a668$export$edf7b78eb8890aea);
$parcel$export(module.exports, "RESOURCE_ASSETS_BANNER_SETTINGS_KEY", () => $200d4a252ac4a668$export$9aedc6e738c8bf7f);
$parcel$export(module.exports, "RESOURCE_ASSETS_USER_SETTINGS", () => $200d4a252ac4a668$export$2954db1275a5f9fc);
$parcel$export(module.exports, "RESOURCE_ASSETS_USER_SETTINGS_KEY", () => $200d4a252ac4a668$export$25873f3f095f3e21);
$parcel$export(module.exports, "USER_SETTING_BANNER_DISMISSAL_KEY", () => $200d4a252ac4a668$export$c02653af996e853a);
$parcel$export(module.exports, "DEFAULT_HIGHLIGHT_COLOR", () => $200d4a252ac4a668$export$4b15acc9c405c4bd);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $200d4a252ac4a668$export$617cdcc6afaae4f7);
$parcel$export(module.exports, "NAVIGATION_SETTINGS_KEYS", () => $200d4a252ac4a668$export$8a78e43025de1286);
$parcel$export(module.exports, "DATE_TIME_SETTINGS_KEYS", () => $200d4a252ac4a668$export$ed0afda862e5b236);
$parcel$export(module.exports, "RESOURCE_TYPE_WORKSPACE_CONTEXT", () => $200d4a252ac4a668$export$3f183223d3598a56);
$parcel$export(module.exports, "ASSETS_ADMIN_SETTINGS_MAX_AGE", () => $200d4a252ac4a668$export$ce0c7383fedc84ce);
$parcel$export(module.exports, "emptyNavigationSettingsResponse", () => $200d4a252ac4a668$export$2175e487efc82f9);
$parcel$export(module.exports, "emptyBannerSettingsResponse", () => $200d4a252ac4a668$export$5b68b74d24ac7fdf);
$parcel$export(module.exports, "emptyUserSettingsResponse", () => $200d4a252ac4a668$export$a0651f3901a27441);
$parcel$export(module.exports, "RESOURCE_ASSETS_LOGO_FAVICON", () => $200d4a252ac4a668$export$ad7710b5c24d4d75);
$parcel$export(module.exports, "RESOURCE_ASSETS_LOGO_FAVICON_KEY", () => $200d4a252ac4a668$export$834ed0433343c2f8);
$parcel$export(module.exports, "emptyLogoResponse", () => $200d4a252ac4a668$export$566ad05831bc4e33);
$parcel$export(module.exports, "emptyFaviconResponse", () => $200d4a252ac4a668$export$e9d53d3287e3f0ba);
const $200d4a252ac4a668$export$858084c28938b25c = 'RESOURCE_ASSETS_NAVIGATION_SETTINGS';
const $200d4a252ac4a668$export$6c3a7ac5254a8135 = 'assets-navigation-settings';
const $200d4a252ac4a668$export$edf7b78eb8890aea = 'RESOURCE_ASSETS_BANNER_SETTINGS';
const $200d4a252ac4a668$export$9aedc6e738c8bf7f = 'assets-banner-settings';
const $200d4a252ac4a668$export$2954db1275a5f9fc = 'RESOURCE_ASSETS_USER_SETTINGS';
const $200d4a252ac4a668$export$25873f3f095f3e21 = 'assets-user-settings';
const $200d4a252ac4a668$export$c02653af996e853a = 'shouldShowBanner';
const $200d4a252ac4a668$export$4b15acc9c405c4bd = '#0052CC';
const $200d4a252ac4a668$export$617cdcc6afaae4f7 = '#FFFFFF';
const $200d4a252ac4a668$export$8a78e43025de1286 = {
    BG_COLOR: 'assets.navigation.bgcolour',
    HIGHLIGHT_COLOR: 'assets.navigation.highlightcolour',
    SITE_TITLE: 'assets.shouldShow.title'
};
const $200d4a252ac4a668$export$ed0afda862e5b236 = {
    TIMEZONE: 'assets.timezone'
};
const $200d4a252ac4a668$export$3f183223d3598a56 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $200d4a252ac4a668$export$ce0c7383fedc84ce = 3600000;
const $200d4a252ac4a668$export$2175e487efc82f9 = {
    backgroundColor: '',
    highlightColor: '',
    timezone: '',
    showSiteTitle: false,
    isDefaultBackground: true
};
const $200d4a252ac4a668$export$5b68b74d24ac7fdf = {
    id: '',
    content: {
        version: 1,
        type: 'doc',
        content: []
    },
    isDismissable: false,
    isEnabled: false,
    hashId: '',
    visibility: '',
    bgColor: ''
};
const $200d4a252ac4a668$export$a0651f3901a27441 = {};
const $200d4a252ac4a668$export$ad7710b5c24d4d75 = 'RESOURCE_ASSETS_LOGO_FAVICON';
const $200d4a252ac4a668$export$834ed0433343c2f8 = 'assets-logo-favicon';
const $200d4a252ac4a668$export$566ad05831bc4e33 = {
    workspaceId: '',
    logoUUID: '',
    logoFileName: '',
    isDefaultLogo: true,
    url16: '',
    url48: '',
    url72: '',
    url144: '',
    url288: ''
};
const $200d4a252ac4a668$export$e9d53d3287e3f0ba = {
    workspaceId: '',
    faviconUUID: '',
    faviconFileName: '',
    isDefaultFavicon: true,
    url16: '',
    url32: '',
    url48: '',
    url64: ''
};
const $200d4a252ac4a668$export$d57b6b390e78d90f = 'aurum';
const $200d4a252ac4a668$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesAssetsAdminSettings';

});




parcelRegister("7nWmb", function(module, exports) {
$parcel$export(module.exports, "assetsUserPermissionResource", () => $2e3564d96d02c4f6$export$c773b906583a11f4);
$parcel$export(module.exports, "useAssetsUserPermission", () => $2e3564d96d02c4f6$export$746e02f061868249);
$parcel$export(module.exports, "useAssetsUserPermissionLoading", () => $2e3564d96d02c4f6$export$45bd1b73ae7f62de);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $i860n = parcelRequire("i860n");

var $fC6rO = parcelRequire("fC6rO");

var $5xxvQ = parcelRequire("5xxvQ");
const $2e3564d96d02c4f6$export$c773b906583a11f4 = (0, $7edbf.createResource)({
    type: (0, $fC6rO.RESOURCE_ASSETS_USER_PERMISSION),
    getKey: ()=>(0, $fC6rO.ASSETS_USER_PERMISSION_KEY),
    getData: async (_routerContext, customContext)=>{
        if (!(0, $i860n.fg)('aurum-997-license-kill-switch')) return 0, $fC6rO.emptyAssetsPermissionResponse;
        return (0, $5xxvQ.default)(customContext);
    },
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $2e3564d96d02c4f6$export$746e02f061868249 = ()=>{
    const { data: data } = (0, $k6ufm.useResource)($2e3564d96d02c4f6$export$c773b906583a11f4);
    return data ?? (0, $fC6rO.emptyAssetsPermissionResponse);
};
const $2e3564d96d02c4f6$export$45bd1b73ae7f62de = ()=>{
    const { loading: loading } = (0, $k6ufm.useResource)($2e3564d96d02c4f6$export$c773b906583a11f4);
    return loading ?? false;
};

});
parcelRegister("fC6rO", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_ASSETS_USER_PERMISSION", () => $7137f4db8ab03948$export$9cfbd747cbb4ae58);
$parcel$export(module.exports, "ASSETS_USER_PERMISSION_KEY", () => $7137f4db8ab03948$export$cd8f9faf718d106c);
$parcel$export(module.exports, "emptyAssetsPermissionResponse", () => $7137f4db8ab03948$export$e2a734575cf43186);
const $7137f4db8ab03948$export$9cfbd747cbb4ae58 = 'RESOURCE_ASSETS_USER_PERMISSION';
const $7137f4db8ab03948$export$cd8f9faf718d106c = 'ASSETS_USER_PERMISSION';
const $7137f4db8ab03948$export$e2a734575cf43186 = {
    isAssetsAdmin: false,
    isLicensedAssetsUser: false
};

});

parcelRegister("5xxvQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $58f392f39696d448$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $5csC1 = parcelRequire("5csC1");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");

var $bYonX = parcelRequire("bYonX");

var $iixyn = parcelRequire("iixyn");

var $fC6rO = parcelRequire("fC6rO");
const $58f392f39696d448$var$packageName = 'jiraRouterResourcesAssetsUserPermission';
const $58f392f39696d448$var$teamName = 'astral';
const $58f392f39696d448$export$f449aa4e38ef0dc9 = async ({ tenantContext: tenantContext })=>{
    const { storeState: storeState } = (0, $bYonX.getResourceStore)();
    const state = storeState.getState();
    try {
        const workspaceId = await (0, $5csC1.extractResourceStatePromise)(state.data);
        if (!workspaceId || typeof workspaceId !== 'string') return 0, $fC6rO.emptyAssetsPermissionResponse;
        const { cloudId: cloudId } = tenantContext;
        const response = await (0, $h2wCv.performGetRequest)((0, $iixyn.getAssetsPermissionUrl)(workspaceId), {
            headers: (0, $iixyn.getAssetsPermissionHeaders)(workspaceId, cloudId)
        });
        return (0, $iixyn.transformAssetsPermissionResponse)(response, true);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const tenantContextMetadata = (0, $5csC1.getAssetsTenantContextMetadata)();
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$58f392f39696d448$var$packageName}.checkAssetsUserPermission`, error.message, {
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message,
            tenantContextMetadata: JSON.stringify(tenantContextMetadata || {})
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'checkAssetsUserPermission',
                packageName: $58f392f39696d448$var$packageName,
                teamName: $58f392f39696d448$var$teamName
            },
            error: error
        });
        throw error;
    }
};
var $58f392f39696d448$export$2e2bcd8739ae039 = $58f392f39696d448$export$f449aa4e38ef0dc9;

});
parcelRegister("iixyn", function(module, exports) {
$parcel$export(module.exports, "transformAssetsPermissionResponse", () => $f35e9b04e4df6ea9$export$d41639ea83979d03);
$parcel$export(module.exports, "getAssetsPermissionUrl", () => $f35e9b04e4df6ea9$export$f18fae06ad563eed);
$parcel$export(module.exports, "getAssetsPermissionHeaders", () => $f35e9b04e4df6ea9$export$1f4357abb80d67bb);

var $i860n = parcelRequire("i860n");
const $f35e9b04e4df6ea9$var$HEADER_X_SSR_SERVICE_NAME = 'x-ssr-service-name';
const $f35e9b04e4df6ea9$var$HEADER_ATL_WORKSPACEID = 'atl-workspaceid';
const $f35e9b04e4df6ea9$var$HEADER_X_SSR_ASAP_AUDIENCE = 'x-ssr-asap-audience';
const $f35e9b04e4df6ea9$var$HEADER_ATL_CLOUDID = 'atl-cloudid';
const $f35e9b04e4df6ea9$export$d41639ea83979d03 = (response, apiCallSuccess)=>{
    return {
        isAssetsAdmin: response.isAdmin,
        isLicensedAssetsUser: apiCallSuccess && response.hasAssetsAccess
    };
};
const $f35e9b04e4df6ea9$export$f18fae06ad563eed = (workspaceId)=>{
    // When on client, always use gateway URL
    if (!false) return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/permissions/permitted`;
    // When on server, use hostname routing when new FG is enabled
    if ((0, $i860n.fg)('assets_permission_hostname_routing')) return '/assets/api/v1/permissions/permitted';
    // Default SSR fallback: use gateway internal route
    return '/internal/permissions/permitted';
};
const $f35e9b04e4df6ea9$export$1f4357abb80d67bb = (workspaceId, cloudId)=>{
    // When on client, always use gateway headers
    if (!false) return {
        [$f35e9b04e4df6ea9$var$HEADER_X_SSR_SERVICE_NAME]: 'jsm-cmdb-gateway',
        [$f35e9b04e4df6ea9$var$HEADER_ATL_WORKSPACEID]: workspaceId
    };
    // When on server, use hostname routing headers when new FG is enabled
    if ((0, $i860n.fg)('assets_permission_hostname_routing')) return {
        [$f35e9b04e4df6ea9$var$HEADER_X_SSR_ASAP_AUDIENCE]: 'assets-tempeh-archetype'
    };
    // Default SSR fallback: use gateway headers
    return {
        [$f35e9b04e4df6ea9$var$HEADER_ATL_CLOUDID]: cloudId,
        [$f35e9b04e4df6ea9$var$HEADER_X_SSR_SERVICE_NAME]: 'jsm-cmdb-gateway',
        [$f35e9b04e4df6ea9$var$HEADER_ATL_WORKSPACEID]: workspaceId
    };
};

});



parcelRegister("1kh2I", function(module, exports) {
$parcel$export(module.exports, "assetsNavigationSettingsResource", () => $c14adab7de3a4c32$export$d72c30b62ce96bca);
$parcel$export(module.exports, "useAssetsNavigationSettingsResource", () => $c14adab7de3a4c32$export$59c3c97d1f3b9d94);
$parcel$export(module.exports, "assetsBannerSettingsResource", () => $c14adab7de3a4c32$export$a7ceab321c9806fd);
$parcel$export(module.exports, "useAssetsBannerSettingsResource", () => $c14adab7de3a4c32$export$63ed762dfb6bd31c);
$parcel$export(module.exports, "assetsUserSettingsResource", () => $c14adab7de3a4c32$export$cb3a6ec26240622a);
$parcel$export(module.exports, "useAssetsUserSettingsResource", () => $c14adab7de3a4c32$export$b6d0081d0c94efbd);
$parcel$export(module.exports, "assetsLogoAndFaviconResource", () => $c14adab7de3a4c32$export$d255314520802ff5);
$parcel$export(module.exports, "useAssetsLogoAndFaviconResource", () => $c14adab7de3a4c32$export$a82161c8e2f89ade);

var $i860n = parcelRequire("i860n");

var $7edbf = parcelRequire("7edbf");
var $bYonX = parcelRequire("bYonX");
var $k6ufm = parcelRequire("k6ufm");

var $iuGVF = parcelRequire("iuGVF");

var $57UQ8 = parcelRequire("57UQ8");

var $5csC1 = parcelRequire("5csC1");
const $c14adab7de3a4c32$export$d72c30b62ce96bca = (0, $7edbf.createResource)({
    type: (0, $57UQ8.RESOURCE_ASSETS_NAVIGATION_SETTINGS),
    getKey: ()=>(0, $57UQ8.RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY),
    getData: async ()=>{
        if (!(0, $i860n.fg)('assets-announcement-banner-settings')) return 0, $57UQ8.emptyNavigationSettingsResponse;
        const navigationSettingsRequest = [
            {
                key: (0, $57UQ8.NAVIGATION_SETTINGS_KEYS).BG_COLOR
            },
            {
                key: (0, $57UQ8.NAVIGATION_SETTINGS_KEYS).HIGHLIGHT_COLOR
            },
            {
                key: (0, $57UQ8.DATE_TIME_SETTINGS_KEYS).TIMEZONE
            },
            {
                key: (0, $57UQ8.NAVIGATION_SETTINGS_KEYS).SITE_TITLE
            }
        ];
        const { storeState: storeState } = (0, $bYonX.getResourceStore)();
        const state = storeState.getState();
        const workspaceId = await (0, $5csC1.extractResourceStatePromise)(state.data);
        if (!workspaceId || typeof workspaceId !== 'string') return 0, $57UQ8.emptyNavigationSettingsResponse;
        const navigationSettings = await (0, $iuGVF.getAdminSettingsByKeys)(workspaceId, navigationSettingsRequest);
        const backgroundColorSetting = navigationSettings[(0, $57UQ8.NAVIGATION_SETTINGS_KEYS).BG_COLOR];
        return {
            backgroundColor: backgroundColorSetting?.value,
            highlightColor: navigationSettings[(0, $57UQ8.NAVIGATION_SETTINGS_KEYS).HIGHLIGHT_COLOR]?.value,
            timezone: navigationSettings[(0, $57UQ8.DATE_TIME_SETTINGS_KEYS).TIMEZONE]?.value,
            showSiteTitle: navigationSettings[(0, $57UQ8.NAVIGATION_SETTINGS_KEYS).SITE_TITLE]?.value === 'true',
            isDefaultBackground: backgroundColorSetting?.value === backgroundColorSetting?.defaultValue
        };
    },
    maxAge: (0, $57UQ8.ASSETS_ADMIN_SETTINGS_MAX_AGE)
});
const $c14adab7de3a4c32$export$59c3c97d1f3b9d94 = ()=>{
    return (0, $k6ufm.useResource)($c14adab7de3a4c32$export$d72c30b62ce96bca);
};
const $c14adab7de3a4c32$export$a7ceab321c9806fd = (0, $7edbf.createResource)({
    type: (0, $57UQ8.RESOURCE_ASSETS_BANNER_SETTINGS),
    getKey: ()=>(0, $57UQ8.RESOURCE_ASSETS_BANNER_SETTINGS_KEY),
    getData: async ()=>{
        if (!(0, $i860n.fg)('assets-announcement-banner-settings')) return 0, $57UQ8.emptyBannerSettingsResponse;
        const { storeState: storeState } = (0, $bYonX.getResourceStore)();
        const state = storeState.getState();
        const workspaceId = await (0, $5csC1.extractResourceStatePromise)(state.data);
        if (!workspaceId || typeof workspaceId !== 'string') return 0, $57UQ8.emptyBannerSettingsResponse;
        const bannerSettings = await (0, $iuGVF.getBannerSettings)(workspaceId);
        return bannerSettings;
    },
    maxAge: (0, $57UQ8.ASSETS_ADMIN_SETTINGS_MAX_AGE)
});
const $c14adab7de3a4c32$export$63ed762dfb6bd31c = ()=>{
    return (0, $k6ufm.useResource)($c14adab7de3a4c32$export$a7ceab321c9806fd);
};
const $c14adab7de3a4c32$export$cb3a6ec26240622a = (0, $7edbf.createResource)({
    type: (0, $57UQ8.RESOURCE_ASSETS_USER_SETTINGS),
    getKey: ()=>(0, $57UQ8.RESOURCE_ASSETS_USER_SETTINGS_KEY),
    getData: async ()=>{
        if (!(0, $i860n.fg)('assets-announcement-banner-settings')) return 0, $57UQ8.emptyUserSettingsResponse;
        const { storeState: storeState } = (0, $bYonX.getResourceStore)();
        const state = storeState.getState();
        const workspaceId = await (0, $5csC1.extractResourceStatePromise)(state.data);
        if (!workspaceId || typeof workspaceId !== 'string') return 0, $57UQ8.emptyUserSettingsResponse;
        const userSettings = await (0, $iuGVF.getUserSettings)(workspaceId, (0, $57UQ8.USER_SETTING_BANNER_DISMISSAL_KEY));
        return {
            [(0, $57UQ8.USER_SETTING_BANNER_DISMISSAL_KEY)]: userSettings.value
        };
    },
    maxAge: (0, $57UQ8.ASSETS_ADMIN_SETTINGS_MAX_AGE)
});
const $c14adab7de3a4c32$export$b6d0081d0c94efbd = ()=>{
    return (0, $k6ufm.useResource)($c14adab7de3a4c32$export$cb3a6ec26240622a);
};
const $c14adab7de3a4c32$export$d255314520802ff5 = (0, $7edbf.createResource)({
    type: (0, $57UQ8.RESOURCE_ASSETS_LOGO_FAVICON),
    getKey: ()=>(0, $57UQ8.RESOURCE_ASSETS_LOGO_FAVICON_KEY),
    getData: async ()=>{
        if (!(0, $i860n.fg)('assets-announcement-banner-settings')) return {
            logo: (0, $57UQ8.emptyLogoResponse),
            favicon: (0, $57UQ8.emptyFaviconResponse)
        };
        const { storeState: storeState } = (0, $bYonX.getResourceStore)();
        const state = storeState.getState();
        const workspaceId = await (0, $5csC1.extractResourceStatePromise)(state.data);
        if (!workspaceId || typeof workspaceId !== 'string') return {
            logo: (0, $57UQ8.emptyLogoResponse),
            favicon: (0, $57UQ8.emptyFaviconResponse)
        };
        const [logoResponse, faviconResponse] = await Promise.all([
            (0, $iuGVF.getLogo)(workspaceId).catch(()=>(0, $57UQ8.emptyLogoResponse)),
            (0, $iuGVF.getFavicon)(workspaceId).catch(()=>(0, $57UQ8.emptyFaviconResponse))
        ]);
        return {
            logo: logoResponse,
            favicon: faviconResponse
        };
    },
    maxAge: (0, $57UQ8.ASSETS_ADMIN_SETTINGS_MAX_AGE)
});
const $c14adab7de3a4c32$export$a82161c8e2f89ade = ()=>{
    return (0, $k6ufm.useResource)($c14adab7de3a4c32$export$d255314520802ff5);
};

});
parcelRegister("iuGVF", function(module, exports) {
$parcel$export(module.exports, "getAdminSettingsByKeys", () => $0219854390a8c440$export$55fc3561374ab769);
$parcel$export(module.exports, "getBannerSettings", () => $0219854390a8c440$export$3f3876609dfc8fe2);
$parcel$export(module.exports, "updateBannerSettings", () => $0219854390a8c440$export$f1a5ab84b56daecd);
$parcel$export(module.exports, "getUserSettings", () => $0219854390a8c440$export$bdf060f8502bcfbd);
$parcel$export(module.exports, "updateUserSettings", () => $0219854390a8c440$export$a5f91aa6636f5910);
$parcel$export(module.exports, "updateNavigationSettings", () => $0219854390a8c440$export$6a880189751ac5a3);
$parcel$export(module.exports, "getLogo", () => $0219854390a8c440$export$53f918f2b7d40673);
$parcel$export(module.exports, "getFavicon", () => $0219854390a8c440$export$30c2a0095db95d06);
$parcel$export(module.exports, "uploadLogo", () => $0219854390a8c440$export$fb69568dc4717be9);
$parcel$export(module.exports, "uploadFavicon", () => $0219854390a8c440$export$e28c9b1d0c57b227);
$parcel$export(module.exports, "resetLogoToDefault", () => $0219854390a8c440$export$ea2f01a49b1c6e6f);
$parcel$export(module.exports, "resetFaviconToDefault", () => $0219854390a8c440$export$40db3d7183b70d9e);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");

var $5csC1 = parcelRequire("5csC1");
const $0219854390a8c440$var$packageName = 'jiraRouterResourcesAssetsAdminSettings';
const $0219854390a8c440$var$teamName = 'astral';
const $0219854390a8c440$export$55fc3561374ab769 = async (workspaceId, settingKeys)=>{
    const url = (0, $5csC1.getAdminSettingsUrl)(workspaceId);
    const mergedOptions = (0, $5csC1.mergeOptionsWithDefaults)(url, {
        body: JSON.stringify(settingKeys),
        headers: (0, $5csC1.getAssetsAdminHeaders)(workspaceId)
    });
    try {
        const response = await (0, $h2wCv.performPostRequest)(url, mergedOptions);
        return (0, $5csC1.transformAdminSettingsResponse)(response);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const tenantContextMetadata = (0, $5csC1.getAssetsTenantContextMetadata)();
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.getAdminSettingsByKeys`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message,
            tenantContextMetadata: JSON.stringify(tenantContextMetadata || {})
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getAdminSettingsByKeys',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$3f3876609dfc8fe2 = async (workspaceId)=>{
    const url = (0, $5csC1.getBannerSettingsUrl)(workspaceId);
    const mergedOptions = (0, $5csC1.mergeOptionsWithDefaults)(url, {
        headers: (0, $5csC1.getAssetsAdminHeaders)(workspaceId)
    });
    try {
        const response = await (0, $h2wCv.performGetRequest)(url, mergedOptions);
        return (0, $5csC1.transformBannerSettings)(response);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const tenantContextMetadata = (0, $5csC1.getAssetsTenantContextMetadata)();
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.getBannerSettings`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message,
            tenantContextMetadata: JSON.stringify(tenantContextMetadata || {})
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getBannerSettings',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$f1a5ab84b56daecd = async (workspaceId, bannerId, bannerUpdates)=>{
    const url = `${(0, $5csC1.getBannerSettingsUrl)(workspaceId)}/${bannerId}`;
    try {
        const response = await (0, $h2wCv.performPutRequest)(url, (0, $5csC1.mergeOptionsWithDefaults)(url, {
            body: JSON.stringify((0, $5csC1.transformBannerSettings)(bannerUpdates))
        }));
        return (0, $5csC1.transformBannerSettings)(response);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.updateBannerSettings`, error.message, {
            workspaceId: workspaceId,
            bannerId: bannerId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'updateBannerSettings',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$bdf060f8502bcfbd = async (workspaceId, key)=>{
    const url = `${(0, $5csC1.getUserSettingsUrl)(workspaceId)}?key=${key}`;
    const mergedOptions = (0, $5csC1.mergeOptionsWithDefaults)(url, {
        headers: (0, $5csC1.getAssetsAdminHeaders)(workspaceId)
    });
    try {
        const response = await (0, $h2wCv.performGetRequest)(url, mergedOptions);
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const tenantContextMetadata = (0, $5csC1.getAssetsTenantContextMetadata)();
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.getUserSettings`, error.message, {
            workspaceId: workspaceId,
            key: key,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message,
            tenantContextMetadata: JSON.stringify(tenantContextMetadata || {})
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getUserSettings',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$a5f91aa6636f5910 = async (workspaceId, settings)=>{
    const url = (0, $5csC1.getUserSettingsUrl)(workspaceId);
    try {
        await (0, $h2wCv.performPutRequest)(url, {
            body: JSON.stringify(settings)
        });
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.updateUserSettings`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'updateUserSettings',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$6a880189751ac5a3 = async (workspaceId, navigationUpdates)=>{
    const url = (0, $5csC1.getAdminSettingsUrl)(workspaceId);
    try {
        return await (0, $h2wCv.performPutRequest)(url, {
            body: JSON.stringify(navigationUpdates)
        });
    } catch (error) {
        const err = error instanceof Error ? error : new Error(String(error));
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.updateNavigationSettings`, err.message, {
            workspaceId: workspaceId,
            // @ts-expect-error - statusCode may not exist on Error
            statusCode: err?.statusCode,
            errorName: err?.name,
            // @ts-expect-error - originalResponse may not exist on Error
            description: err?.originalResponse?.message
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'updateNavigationSettings',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: err
        });
        throw err;
    }
};
const $0219854390a8c440$export$53f918f2b7d40673 = async (workspaceId)=>{
    const url = (0, $5csC1.getLogoUrl)(workspaceId);
    const mergedOptions = (0, $5csC1.mergeOptionsWithDefaults)(url, {
        headers: (0, $5csC1.getAssetsAdminHeaders)(workspaceId)
    });
    try {
        const response = await (0, $h2wCv.performGetRequest)(url, mergedOptions);
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const tenantContextMetadata = (0, $5csC1.getAssetsTenantContextMetadata)();
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.getLogo`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message,
            tenantContextMetadata: JSON.stringify(tenantContextMetadata || {})
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getLogo',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$30c2a0095db95d06 = async (workspaceId)=>{
    const url = (0, $5csC1.getFaviconUrl)(workspaceId);
    const mergedOptions = (0, $5csC1.mergeOptionsWithDefaults)(url, {
        headers: (0, $5csC1.getAssetsAdminHeaders)(workspaceId)
    });
    try {
        const response = await (0, $h2wCv.performGetRequest)(url, mergedOptions);
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const tenantContextMetadata = (0, $5csC1.getAssetsTenantContextMetadata)();
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.getFavicon`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message,
            tenantContextMetadata: JSON.stringify(tenantContextMetadata || {})
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getFavicon',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$fb69568dc4717be9 = async (workspaceId, payload)=>{
    try {
        const url = `${(0, $5csC1.getLogoUrl)(workspaceId)}/upload`;
        const formData = new FormData();
        if (payload.file && payload.fileName) {
            formData.append('assets-logo-file', payload.file);
            formData.append('fileName', payload.fileName);
        } else if (payload.imageUrl) formData.append('imageUrl', payload.imageUrl);
        const response = await (0, $h2wCv.performPostRequest)(url, {
            body: formData,
            headers: {}
        });
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.uploadLogo`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'uploadLogo',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$e28c9b1d0c57b227 = async (workspaceId, payload)=>{
    try {
        const url = `${(0, $5csC1.getFaviconUrl)(workspaceId)}/upload`;
        const formData = new FormData();
        if (payload.file && payload.fileName) {
            formData.append('assets-favicon-file', payload.file);
            formData.append('fileName', payload.fileName);
        } else if (payload.imageUrl) formData.append('imageUrl', payload.imageUrl);
        const response = await (0, $h2wCv.performPostRequest)(url, {
            body: formData,
            headers: {}
        });
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.uploadFavicon`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'uploadFavicon',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$ea2f01a49b1c6e6f = async (workspaceId)=>{
    try {
        const url = `${(0, $5csC1.getLogoUrl)(workspaceId)}/reset-to-default`;
        const response = await (0, $h2wCv.performPutRequest)(url);
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.resetLogoToDefault`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'resetLogoToDefault',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};
const $0219854390a8c440$export$40db3d7183b70d9e = async (workspaceId)=>{
    try {
        const url = `${(0, $5csC1.getFaviconUrl)(workspaceId)}/reset-to-default`;
        const response = await (0, $h2wCv.performPutRequest)(url);
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$0219854390a8c440$var$packageName}.resetFaviconToDefault`, error.message, {
            workspaceId: workspaceId,
            statusCode: error?.statusCode,
            errorName: error?.name,
            description: error?.originalResponse?.message
        });
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'resetFaviconToDefault',
                packageName: $0219854390a8c440$var$packageName,
                teamName: $0219854390a8c440$var$teamName
            },
            error: error
        });
        throw error;
    }
};

});


parcelRegister("4C29G", function(module, exports) {
$parcel$export(module.exports, "dataManagerAdvisoryNotificationsResource", () => $f8b7890976ff1822$export$9aa1be1058335296);

var $n67Vb = parcelRequire("n67Vb");

var $aI7em = parcelRequire("aI7em");

var $5csC1 = parcelRequire("5csC1");

var $7edbf = parcelRequire("7edbf");
var $bYonX = parcelRequire("bYonX");

var $foLPK = parcelRequire("foLPK");
const $f8b7890976ff1822$export$31191e3c5f72910f = (routeName)=>typeof routeName === 'string' && routeName.startsWith('assets-data-manager-');
const $f8b7890976ff1822$export$9aa1be1058335296 = (0, $7edbf.createResource)({
    type: 'ASSETS_DM_ADVISORY_NOTIFICATIONS',
    // Key by route group, not a constant — the resource runs on every Assets route, so a constant
    // key lets the `null` cached on a non-DM route be reused after an SPA transition into a DM route
    // (banner never appears). One key per group: fetched once across DM routes, null elsewhere.
    getKey: ({ route: route })=>$f8b7890976ff1822$export$31191e3c5f72910f(route.name) ? 'data-manager' : 'other',
    isBrowserOnly: true,
    maxAge: 300000,
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        if (!$f8b7890976ff1822$export$31191e3c5f72910f(routerContext.route.name)) return null;
        const { storeState: storeState } = (0, $bYonX.getResourceStore)();
        const workspaceId = await (0, $5csC1.extractResourceStatePromise)(storeState.getState().data);
        if (typeof workspaceId !== 'string' || workspaceId === '') return null;
        return (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $foLPK.default), {
            cloudId: tenantContext.cloudId,
            workspaceId: workspaceId
        }, {
            fetchPolicy: 'store-or-network'
        });
    }
});

});
parcelRegister("foLPK", function(module, exports) {
$parcel$export(module.exports, "default", () => $84fc33b590459b87$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36001b42ff46a3fc05355ca3697c3d5a>>
 * @relayHash 4d2491897168f28c5a7445ce3d890969
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eab4de8be77c765639be9c158bfecc7cdc210673c5175259ae9f19a1dc31db95
const $84fc33b590459b87$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceId",
                    "variableName": "workspaceId"
                }
            ],
            "concreteType": "AssetsDMAdvisoryNotificationsResponse",
            "kind": "LinkedField",
            "name": "assetsDM_advisoryNotifications",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AssetsDMAdvisoryNotification",
                    "kind": "LinkedField",
                    "name": "notifications",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "severity"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DataManagerAdvisoryNotificationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DataManagerAdvisoryNotificationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "eab4de8be77c765639be9c158bfecc7cdc210673c5175259ae9f19a1dc31db95",
            "metadata": {},
            "name": "DataManagerAdvisoryNotificationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$84fc33b590459b87$var$node.hash = "12ce548b5ca9c02f15beb06c6f6f99c4";
var $84fc33b590459b87$export$2e2bcd8739ae039 = $84fc33b590459b87$var$node;

});



parcelRegister("dD11h", function(module, exports) {
$parcel$export(module.exports, "AssetsPageConfigContainer", () => $ea275e5fd5af70dd$export$68a74d1b39f069c5);

var $euxye = parcelRequire("euxye");

var $l8G1z = parcelRequire("l8G1z");

var $a8EUd = parcelRequire("a8EUd");

const $ea275e5fd5af70dd$var$LazyAssetsPageConfigContainer = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("j63TE")).then((module)=>module.PageConfigContainer), {
    ssr: false,
    moduleId: "./src/packages/assets-app/page-config-container/src/PageConfigContainer.tsx"
});
const $ea275e5fd5af70dd$export$68a74d1b39f069c5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "assets-page-config-container-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ea275e5fd5af70dd$var$LazyAssetsPageConfigContainer, null, children));
$ea275e5fd5af70dd$export$68a74d1b39f069c5.displayName = "AssetsPageConfigContainer";

});
parcelRegister("j63TE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4zWMh").then(()=>parcelRequire('kDZnX'));

});



parcelRegister("lVbe0", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsRouteEntry", () => $48aaea8988c7185a$export$3a6396cc5491db7c);

var $6BfVx = parcelRequire("6BfVx");

var $gVgMY = parcelRequire("gVgMY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $2JWMy = parcelRequire("2JWMy");

var $6pofw = parcelRequire("6pofw");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $1UBSs = parcelRequire("1UBSs");

var $dD11h = parcelRequire("dD11h");
const $48aaea8988c7185a$var$assetsAnalyticsDataViewDetailsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $gVgMY.assetsAnalyticsDataViewDetailsEntryPoint)
});
const $48aaea8988c7185a$export$3a6396cc5491db7c = (0, $fdS54.createEntry)((0, $2JWMy.assetsAnalyticsDataViewDetailsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$48aaea8988c7185a$var$assetsAnalyticsDataViewDetailsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details-page',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-details',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gVgMY", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsEntryPoint", () => $a7b1f355ab289bf9$export$2ef63d819083574a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $a7b1f355ab289bf9$export$2ef63d819083574a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("4ozyq")), {
        moduleId: "e343801c",
        moduleName: "AssetsAnalyticsDataViewDetailsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4ozyq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("evqBr").then(()=>parcelRequire('fGWPO'));

});


parcelRegister("2JWMy", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsRoute", () => $a5d15276c63617ce$export$745cfa051b349898);
const $a5d15276c63617ce$export$745cfa051b349898 = {
    name: 'assets-analytics-data-view-details',
    path: '/jira/assets/analytics/data-view/:dataViewId',
    exact: true
};

});


parcelRegister("7zRXQ", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewListRouteEntry", () => $420163b1366ae724$export$7d8bada2dd6618e9);

var $6BfVx = parcelRequire("6BfVx");

var $eTy29 = parcelRequire("eTy29");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $cAf6B = parcelRequire("cAf6B");

var $6pofw = parcelRequire("6pofw");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $1UBSs = parcelRequire("1UBSs");

var $dD11h = parcelRequire("dD11h");
const $420163b1366ae724$var$assetsAnalyticsDataViewListPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $eTy29.assetsAnalyticsDataViewListEntryPoint)
});
const $420163b1366ae724$export$7d8bada2dd6618e9 = (0, $fdS54.createEntry)((0, $cAf6B.assetsAnalyticsDataViewListRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$420163b1366ae724$var$assetsAnalyticsDataViewListPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list-page',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-list',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eTy29", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewListEntryPoint", () => $fcacc879612ad805$export$a5faca810df8b234);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $fcacc879612ad805$export$a5faca810df8b234 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("fJT56")), {
        moduleId: "0295d24a",
        moduleName: "AssetsAnalyticsDataViewListPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fJT56", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gnDjQ").then(()=>parcelRequire('W2WLQ'));

});


parcelRegister("cAf6B", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewListRoute", () => $6cfa5ad65095ccf6$export$40ec17d60854071b);
const $6cfa5ad65095ccf6$export$40ec17d60854071b = {
    name: 'assets-analytics-data-view-list',
    path: '/jira/assets/analytics/data-view',
    exact: true
};

});


parcelRegister("ehmfE", function(module, exports) {
$parcel$export(module.exports, "assetsConfigurationRouteEntry", () => $9513c1fcddfbcea3$export$1c86de5db8ff2b58);

var $6BfVx = parcelRequire("6BfVx");

var $kUdDW = parcelRequire("kUdDW");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $75IDI = parcelRequire("75IDI");

var $1UBSs = parcelRequire("1UBSs");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $9513c1fcddfbcea3$var$globalConfigurePageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $kUdDW.assetsGlobalSettingsEntryPoint)
});
const $9513c1fcddfbcea3$export$1c86de5db8ff2b58 = (0, $fdS54.createEntry)((0, $75IDI.assetsConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        ufoName: 'servicedesk-cmdb-assets-configure',
        entryPoint: ()=>$9513c1fcddfbcea3$var$globalConfigurePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'astral'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kUdDW", function(module, exports) {
$parcel$export(module.exports, "assetsGlobalSettingsEntryPoint", () => $94957e362a242ec5$export$2b083e0274144f1b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $1166D = parcelRequire("1166D");

var $i4p1M = parcelRequire("i4p1M");

var $2aOVZ = parcelRequire("2aOVZ");

var $kGR4b = parcelRequire("kGR4b");

var $iRlaL = parcelRequire("iRlaL");

var $nYMSO = parcelRequire("nYMSO");

var $hx0y3 = parcelRequire("hx0y3");

var $6x68B = parcelRequire("6x68B");

var $53fBn = parcelRequire("53fBn");

var $i860n = parcelRequire("i860n");

var $fiVog = parcelRequire("fiVog");

var $7NTte = parcelRequire("7NTte");

const $94957e362a242ec5$export$2b083e0274144f1b = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6Ew19")), {
        moduleId: "73ccb054",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { query: query } })=>{
        if (!(0, $i860n.fg)('aurum_assets_new_settings_page')) return {};
        const { menu: menu } = query;
        const defaultMenu = (0, $i860n.fg)('aurum-677-assets-usage-migration') ? 'app-usage' : 'global-reference-types';
        const targetMenu = menu ?? defaultMenu;
        if (targetMenu === 'data-manager') return {
            entryPoints: {
                dataManagerEntryPoint: {
                    entryPoint: (0, $1166D.dataManagerEntryPoint),
                    entryPointParams: {}
                }
            }
        };
        if (targetMenu === 'app-usage') return {
            entryPoints: {
                appUsageEntryPoint: {
                    entryPoint: (0, $i4p1M.appUsageEntryPoint),
                    entryPointParams: {}
                }
            }
        };
        if (targetMenu === 'global-permissions') return {
            entryPoints: {
                rolesAndPermissionsEntryPoint: {
                    entryPoint: (0, $53fBn.rolesAndPermissionsEntryPoint),
                    entryPointParams: {}
                }
            }
        };
        if (targetMenu === 'announcement-banner') return {
            entryPoints: {
                announcementBannerEntryPoint: {
                    entryPoint: (0, $2aOVZ.announcementBannerEntryPoint),
                    entryPointParams: {}
                }
            }
        };
        if (targetMenu === 'theme') return {
            entryPoints: {
                themeSettingsEntryPoint: {
                    entryPoint: (0, $kGR4b.themeSettingsEntryPoint),
                    entryPointParams: {}
                }
            }
        };
        if (targetMenu === 'global-icons') return {
            entryPoints: {
                iconsPageEntryPoint: {
                    entryPoint: (0, $iRlaL.iconsPageEntryPoint),
                    entryPointParams: {}
                }
            }
        };
        if (targetMenu === 'global-statuses') return {
            entryPoints: {
                statusesPageEntryPoint: {
                    entryPoint: (0, $nYMSO.statusesPageEntryPoint),
                    entryPointParams: {}
                }
            }
        };
        if (targetMenu === 'commonDataModel') {
            if (!(0, $i860n.fg)('assets_common_data_model_settings')) return {};
            return {
                entryPoints: {
                    commonDataModelEntryPoint: {
                        entryPoint: (0, $hx0y3.commonDataModelEntryPoint),
                        entryPointParams: {}
                    }
                }
            };
        }
        if (targetMenu === 'global-reference-types') return {
            entryPoints: {
                referenceTypesPageEntryPoint: {
                    entryPoint: (0, $6x68B.referenceTypesPageEntryPoint),
                    entryPointParams: {}
                }
            }
        };
        return {};
    }
});

});
parcelRegister("1166D", function(module, exports) {
$parcel$export(module.exports, "dataManagerEntryPoint", () => $c4f0e9f020c3daa8$export$65a9d4a49533cc10);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $c4f0e9f020c3daa8$export$65a9d4a49533cc10 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("cqlye")), {
        moduleId: "6c037d09",
        moduleName: "DataManagerMain",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cqlye", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("9OevQ")
]).then(()=>parcelRequire('2eleR'));

});


parcelRegister("i4p1M", function(module, exports) {
$parcel$export(module.exports, "appUsageEntryPoint", () => $db340ace868432c3$export$c4a9b1069d4f866a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $db340ace868432c3$export$c4a9b1069d4f866a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("4MTU8")), {
        moduleId: "49c3ee52",
        moduleName: "AppUsageAppUsage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4MTU8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1wHIK").then(()=>parcelRequire('hV1QK'));

});


parcelRegister("2aOVZ", function(module, exports) {
$parcel$export(module.exports, "announcementBannerEntryPoint", () => $eb2f0b1a17e9dd3f$export$46615e7f36d65d6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $eb2f0b1a17e9dd3f$export$46615e7f36d65d6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("7qe4r")), {
        moduleId: "178e97e9",
        moduleName: "AnnouncementBannerWithFG",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7qe4r", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("20DX4").then(()=>parcelRequire('6th1A'));

});


parcelRegister("kGR4b", function(module, exports) {
$parcel$export(module.exports, "themeSettingsEntryPoint", () => $4b844b59f2b3c887$export$bccd7d6770300935);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $4b844b59f2b3c887$export$bccd7d6770300935 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("i8CUn")), {
        moduleId: "451b8cf9",
        moduleName: "ThemeSettingsMain",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("i8CUn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("depsw").then(()=>parcelRequire('e4DNX'));

});


parcelRegister("iRlaL", function(module, exports) {
$parcel$export(module.exports, "iconsPageEntryPoint", () => $dc08b049bc5abb3d$export$f807170abda23493);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $dc08b049bc5abb3d$export$f807170abda23493 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6pi5V")), {
        moduleId: "42b0043d",
        moduleName: "IconsTabWithFG",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6pi5V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gFvZt").then(()=>parcelRequire('kjM1Q'));

});


parcelRegister("nYMSO", function(module, exports) {
$parcel$export(module.exports, "statusesPageEntryPoint", () => $f1e83fa4ed0e7ea4$export$127a6bfc5a9eed3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $f1e83fa4ed0e7ea4$export$127a6bfc5a9eed3 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("jTyIS")), {
        moduleId: "a5338022",
        moduleName: "StatusesTabWithFG",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jTyIS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6x7EB").then(()=>parcelRequire('gCVrZ'));

});


parcelRegister("hx0y3", function(module, exports) {
$parcel$export(module.exports, "commonDataModelEntryPoint", () => $dee8b5f90e854c0a$export$4efe44d11aa704b6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $dee8b5f90e854c0a$export$4efe44d11aa704b6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("1blGq")), {
        moduleId: "c0728955",
        moduleName: "CommonDataModel",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1blGq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6XX0X").then(()=>parcelRequire('evsad'));

});


parcelRegister("6x68B", function(module, exports) {
$parcel$export(module.exports, "referenceTypesPageEntryPoint", () => $ce4e943c082151d5$export$336f3fdd5a2c5362);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ce4e943c082151d5$export$336f3fdd5a2c5362 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8SLxI")), {
        moduleId: "eba53f1b",
        moduleName: "ReferenceTypesTabWithFG",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8SLxI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8xwrW").then(()=>parcelRequire('fKaeW'));

});


parcelRegister("53fBn", function(module, exports) {
$parcel$export(module.exports, "rolesAndPermissionsEntryPoint", () => $71e4d7b99f1a8eb6$export$4f28f7b274524370);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $71e4d7b99f1a8eb6$export$4f28f7b274524370 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("39LvP")), {
        moduleId: "31401c06",
        moduleName: "RolesAndPermissionsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("39LvP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kb6Zb").then(()=>parcelRequire('7QFIL'));

});


parcelRegister("6Ew19", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("fJgP4")
]).then(()=>parcelRequire('2plS9'));

});


parcelRegister("75IDI", function(module, exports) {
$parcel$export(module.exports, "assetsConfigurationRoute", () => $ce2aae9c55cdfccf$export$266d00c8001d32ab);
const $ce2aae9c55cdfccf$export$266d00c8001d32ab = {
    name: 'assets-configure',
    path: '/jira/assets/configure/global',
    query: [
        'menu?'
    ]
};

});


parcelRegister("47pCb", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsDetailRouteEntry", () => $f0fd18b67b88dd23$export$bb8a1d6ad210e221);

var $7jZQP = parcelRequire("7jZQP");

var $6BfVx = parcelRequire("6BfVx");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");

var $8PHdJ = parcelRequire("8PHdJ");

var $3E5Aa = parcelRequire("3E5Aa");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");

var $6pofw = parcelRequire("6pofw");

var $dTa0V = parcelRequire("dTa0V");
const $f0fd18b67b88dd23$var$assetsDashboardsDetailsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $7jZQP.assetsDashboardsDetailsPageEntryPoint)
});
const $f0fd18b67b88dd23$export$bb8a1d6ad210e221 = (0, $fdS54.createEntry)((0, $3E5Aa.assetsDashboardsDetailRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$f0fd18b67b88dd23$var$assetsDashboardsDetailsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-dashboards-detail-page',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics'), (0, $8PHdJ.assetsDashboardsSemanticModelResource))
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7jZQP", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsDetailsPageEntryPoint", () => $ea8ecd8788dcf250$export$54c6120b40e02f60);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ea8ecd8788dcf250$export$54c6120b40e02f60 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("4QzTg")), {
        moduleId: "cf27f468",
        moduleName: "AssetsDashboardsDetails",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4QzTg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iXMVS").then(()=>parcelRequire('6CA0b'));

});


parcelRegister("8PHdJ", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsSemanticModelResource", () => $3c6b59062b257a0b$export$2f3ad9442d805741);
$parcel$export(module.exports, "useAssetsDashboardsSemanticModel", () => $3c6b59062b257a0b$export$57a8301df88723cf);

var $i860n = parcelRequire("i860n");

var $k6ufm = parcelRequire("k6ufm");

var $2yODD = parcelRequire("2yODD");
const $3c6b59062b257a0b$export$2f3ad9442d805741 = (0, $2yODD.createSemanticModelResource)({
    hostingProduct: 'jsm-cmdb',
    location: 'assets',
    products: ()=>(0, $i860n.fg)('platform_avp_enable_jira_confluence_for_assets') ? [
            'jira',
            'jsm-cmdb',
            'confluence'
        ] : [
            'jsm-cmdb'
        ],
    subProducts: ()=>(0, $i860n.fg)('platform_avp_enable_jira_confluence_for_assets') ? [
            'jsm',
            'csm'
        ] : [],
    // Assets dashboards want `jsm-cmdb` first; rest follow the AVP default
    // order (mirrors the legacy list in `metricField.tsx`). Only applied
    // when `platform_avp_metric_sorting` is ON — see
    // `fetchAvpSemanticModel.tsx`.
    desiredOrder: [
        'jsm-cmdb',
        'jira',
        'goals',
        'devops',
        'xray'
    ]
});
const $3c6b59062b257a0b$export$57a8301df88723cf = ()=>(0, $k6ufm.useResource)($3c6b59062b257a0b$export$2f3ad9442d805741);

});
parcelRegister("2yODD", function(module, exports) {
$parcel$export(module.exports, "createSemanticModelResource", () => $1d44c8b52b927fce$export$9292f09ad89e4e6f);

var $i860n = parcelRequire("i860n");

var $bdEst = parcelRequire("bdEst");

var $7edbf = parcelRequire("7edbf");

var $7GFOO = parcelRequire("7GFOO");
const $1d44c8b52b927fce$var$RESOURCE_TYPE_AVP_SEMANTIC_MODEL = 'AVP_SEMANTIC_MODEL';
const $1d44c8b52b927fce$export$9292f09ad89e4e6f = (args)=>{
    return (0, $7edbf.createResource)({
        type: `${$1d44c8b52b927fce$var$RESOURCE_TYPE_AVP_SEMANTIC_MODEL}_${[
            Object.values(args)
        ].join('_')}`,
        getKey: (_, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>JSON.stringify({
                ...args,
                products: typeof args.products === 'function' ? args.products() : args.products,
                subProducts: typeof args.subProducts === 'function' ? args.subProducts() : args.subProducts,
                activationId: activationId,
                cloudId: cloudId
            }),
        isBrowserOnly: true,
        getData: async (_, { tenantContext: { activationId: activationId, cloudId: cloudId, locale: locale } })=>{
            const __startTime = (0, $i860n.fg)('platform_avp_custom-fetch-spans_dashboard') ? performance.now() : null;
            try {
                if (!activationId) throw new Error('Route config is missing activation ID');
                if (!cloudId) throw new Error('Route config is missing cloud ID');
                const userInfo = {
                    localTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    locale: locale
                };
                const data = await (0, $7GFOO.fetchAvpSemanticModel)({
                    activationId: activationId,
                    cloudId: cloudId,
                    userInfo: userInfo,
                    ...args
                });
                return __startTime ? {
                    ...data,
                    __metadata: {
                        startTime: __startTime,
                        endTime: performance.now()
                    }
                } : data;
            } catch (error) {
                throw (0, $bdEst.createResourceError)({
                    component: 'spa.view.routes.viz-platform.getData',
                    message: 'Error fetching semantic model',
                    name: 'ResourceError'
                }, error);
            }
        },
        maxAge: 60000
    });
};

});
parcelRegister("7GFOO", function(module, exports) {
$parcel$export(module.exports, "fetchAvpSemanticModel", () => $7e29a2cb505df32c$export$791d7148445fcf73);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $8kHEC = parcelRequire("8kHEC");

var $ak704 = parcelRequire("ak704");

var $277Kx = parcelRequire("277Kx");
/**
 * Default `products[]` ordering applied to the `/v3/metrics/semantic_model`
 * response when `platform_avp_metric_sorting` is ON and the caller did not
 * supply its own `desiredOrder`. Matches the legacy AVP order from
 * `chart-library-form/.../metricField.tsx` so non-Assets Jira routes keep
 * the same dropdown order they had before the gate flipped.
 */ const $7e29a2cb505df32c$var$DEFAULT_PRODUCT_ORDER = [
    'jira',
    'goals',
    'devops',
    'xray'
];
/**
 * Sort `data.products` so they appear in `desiredOrder`. Products whose
 * `name` is not in `desiredOrder` are placed at the end and keep their
 * original relative order (`Array.prototype.sort` is stable). Pure (returns
 * a new object; does not mutate input).
 *
 * Consumers pass the FULL ordered list they want
 */ const $7e29a2cb505df32c$var$sortProductsByDesiredOrder = (data, desiredOrder)=>{
    if (!data || !Array.isArray(data.products) || data.products.length === 0) return data;
    if (desiredOrder.length === 0) return data;
    const indexOf = (name)=>{
        if (name == null) return Infinity;
        const i = desiredOrder.indexOf(name);
        return i === -1 ? Infinity : i;
    };
    const products = data.products.slice().sort((a, b)=>indexOf(a?.name) - indexOf(b?.name));
    return {
        ...data,
        products: products
    };
};
async function $7e29a2cb505df32c$export$791d7148445fcf73({ activationId: activationId, cloudId: cloudId, userInfo: userInfo, hostingProduct: hostingProduct, location: location, products: products, subProducts: subProducts, desiredOrder: desiredOrder }) {
    const resolvedProducts = typeof products === 'function' ? products() : products;
    const resolvedSubProducts = typeof subProducts === 'function' ? subProducts() : subProducts;
    const metricsBaseUrl = (0, $8kHEC.getMetricsServiceOwnerBaseUrl)(hostingProduct, cloudId, activationId);
    const url = `${metricsBaseUrl}/v3/metrics/semantic_model`;
    const sharedHeaders = {
        'X-Source-App-Id': (0, $ak704.getSourceAppId)(hostingProduct, location),
        'cloud-id': cloudId,
        'workspace-id': activationId,
        ...(0, $277Kx.getSyntheticTrafficHeader)()
    };
    const params = new URLSearchParams();
    if (location) params.set('locations', location);
    if (resolvedProducts && resolvedSubProducts) {
        if (resolvedProducts.length > 0) params.set('products', resolvedProducts.join(','));
        if (resolvedSubProducts.length > 0) params.set('subProducts', resolvedSubProducts.join(','));
    }
    if (userInfo.localTimeZone) params.set('localTimeZone', userInfo.localTimeZone);
    if (userInfo.locale) params.set('locale', userInfo.locale);
    const queryString = params.toString();
    const getUrl = queryString ? `${url}?${queryString}` : url;
    const response = await fetch(getUrl, {
        method: 'GET',
        headers: sharedHeaders
    });
    if (response.status === 414) (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            id: 'fetchAvpSemanticModelUriTooLong',
            packageName: 'jiraRouterResourcesVizPlatform',
            teamName: 'viz-platform'
        },
        error: new Error('fetchAvpSemanticModel: HTTP 414 URI Too Long on GET request'),
        attributes: {
            urlLength: getUrl.length,
            queryStringLength: queryString.length,
            hostingProduct: hostingProduct,
            location: location ?? ''
        },
        sendToPrivacyUnsafeSplunk: true
    });
    if (!response.ok) throw new Error(`fetchAvpSemanticModel failed: ${response.status}`);
    const data = await response.json();
    if ((0, $i860n.fg)('platform_avp_metric_sorting')) return $7e29a2cb505df32c$var$sortProductsByDesiredOrder(data, desiredOrder ?? $7e29a2cb505df32c$var$DEFAULT_PRODUCT_ORDER);
    return data;
}

});
parcelRegister("8kHEC", function(module, exports) {
$parcel$export(module.exports, "getMetricsServiceOwnerBaseUrl", () => $456c1ac8b3a11770$export$b6371a64acfda6f2);
/**
 * ⚠️⚠️⚠️ DUPLICATED FROM AVP ⚠️⚠️⚠️
 * Mirrored from: `avp/packages/common/api/src/utils.ts` (`getMetricsServiceOwnerBaseUrl`)
 *
 * ⚠️ Any change here MUST also land in the AVP copy to avoid divergence. ⚠️
 *
 * Reason for duplication:
 *   AVP utilities cannot be imported safely into the Jira SPA. The only
 *   public entrypoint (`@atlassian/viz-platform-views`) is a single barrel
 *   `index.ts`; importing even one helper
 *   would add several MB to the Jira SPA bundle.
 *
 * Long-term resolutions to remove this duplication:
 *   1. Local consumption of individual AVP modules (file-level imports).
 *   2. Add an `exports` map to `@atlassian/viz-platform-views`'s
 *      `package.json` and drop the single-barrel `main`.
 *   3. Create a dedicated `entrypoints/` AVP package exposing only the
 *      minimum utilities required for SPA bootstrap.
 */ const $456c1ac8b3a11770$export$b6371a64acfda6f2 = (hostingProduct, cloudId, activationId)=>{
    return `/gateway/api/dxe/metrics/api/owner/${$456c1ac8b3a11770$var$getMetricsServiceAriOwner(hostingProduct)}/${cloudId}/${activationId}`;
};
/**
 * ⚠️⚠️⚠️ DUPLICATED FROM AVP ⚠️⚠️⚠️
 * Mirrored from: `avp/packages/common/api/src/utils.ts` (`getMetricsServiceAriOwner`)
 *
 * ⚠️ Any change here MUST also land in the AVP copy to avoid divergence. ⚠️
 *
 * Reason for duplication:
 *   AVP utilities cannot be imported safely into the Jira SPA. The only
 *   public entrypoint (`@atlassian/viz-platform-views`) is a single barrel
 *   `index.ts`; importing even one helper
 *   would add several MB to the Jira SPA bundle.
 *
 * Long-term resolutions to remove this duplication:
 *   1. Local consumption of individual AVP modules (file-level imports).
 *   2. Add an `exports` map to `@atlassian/viz-platform-views`'s
 *      `package.json` and drop the single-barrel `main`.
 *   3. Create a dedicated `entrypoints/` AVP package exposing only the
 *      minimum utilities required for SPA bootstrap.
 */ const $456c1ac8b3a11770$var$getMetricsServiceAriOwner = (hostingProduct)=>{
    switch(hostingProduct){
        case 'jsm-cmdb':
            return 'cmdb';
        case 'avp':
        case 'townsquare':
        case 'jira':
        case 'compass':
        case 'opsgenie':
        case 'mercury':
        case 'rovo':
            return hostingProduct;
        default:
            throw new Error(`Unsupported hosting product for metrics service owner URL: ${hostingProduct}`);
    }
};

});

parcelRegister("ak704", function(module, exports) {
$parcel$export(module.exports, "getSourceAppId", () => $289e241674cb04dd$export$6e1127cadaa0b116);
/**
 * ⚠️⚠️⚠️ DUPLICATED FROM AVP ⚠️⚠️⚠️
 * Mirrored from: `avp/packages/ajax/src/utils.ts` (`getSourceAppId`)
 *
 * ⚠️ Any change here MUST also land in the AVP copy to avoid divergence. ⚠️
 *
 * Reason for duplication:
 *   AVP utilities cannot be imported safely into the Jira SPA. The only
 *   public entrypoint (`@atlassian/viz-platform-views`) is a single barrel
 *   `index.ts`; importing even one helper
 *   would add several MB to the Jira SPA bundle.
 *
 * Per-util notes:
 *   This copy widens the parameter types from `HostingProduct` / `Location`
 *   to `string` (avoids depending on `@avp/types`) and adds a `jsm-cmdb`
 *   case for assets/itam dashboards. Keep the shared branches
 *   (`townsquare`, `jira/*`, `avp`, default) in sync with the AVP source.
 *
 * Long-term resolutions to remove this duplication:
 *   1. Local consumption of individual AVP modules (file-level imports).
 *   2. Add an `exports` map to `@atlassian/viz-platform-views`'s
 *      `package.json` and drop the single-barrel `main`.
 *   3. Create a dedicated `entrypoints/` AVP package exposing only the
 *      minimum utilities required for SPA bootstrap.
 */ const $289e241674cb04dd$export$6e1127cadaa0b116 = (hostingProduct, location)=>{
    switch(hostingProduct){
        case 'townsquare':
            return 'platform-dashboard/home';
        case 'jira':
            if (!location) return 'platform-dashboard/home';
            switch(location){
                case 'jsm-summary':
                    return 'platform-dashboard/jsm-summary-page';
                case 'jsw-summary':
                    return 'platform-dashboard/jsw-summary-page';
                default:
                    return 'platform-dashboard/home';
            }
        case 'avp':
            return 'platform-dashboard/analytics';
        case 'jsm-cmdb':
            return 'platform-dashboard/jsm-assets';
        default:
            return 'platform-dashboard/home';
    }
};

});

parcelRegister("277Kx", function(module, exports) {
$parcel$export(module.exports, "getSyntheticTrafficHeader", () => $5fb9d15be1c1dcdf$export$a745ca99dde500e4);
// eslint-disable-next-line jira/import-whitelist

var $4fPPi = parcelRequire("4fPPi");
/**
 * ⚠️⚠️⚠️ DUPLICATED FROM AVP ⚠️⚠️⚠️
 * Mirrored from: `avp/packages/common/api/src/utils.ts` (`STORAGE_KEY_SYNTHETIC_TRAFFIC`)
 *
 * ⚠️ Any change here MUST also land in the AVP copy to avoid divergence. ⚠️
 *
 * Reason for duplication:
 *   AVP utilities cannot be imported safely into the Jira SPA. The only
 *   public entrypoint (`@atlassian/viz-platform-views`) is a single barrel
 *   `index.ts`; importing even one helper
 *   would add several MB to the Jira SPA bundle.
 *
 * Long-term resolutions to remove this duplication:
 *   1. Local consumption of individual AVP modules (file-level imports).
 *   2. Add an `exports` map to `@atlassian/viz-platform-views`'s
 *      `package.json` and drop the single-barrel `main`.
 *   3. Create a dedicated `entrypoints/` AVP package exposing only the
 *      minimum utilities required for SPA bootstrap.
 */ const $5fb9d15be1c1dcdf$var$STORAGE_KEY_SYNTHETIC_TRAFFIC = 'avp.synthetic_traffic';
/**
 * ⚠️⚠️⚠️ DUPLICATED FROM AVP ⚠️⚠️⚠️
 * Mirrored from: `avp/packages/common/api/src/utils.ts` (`isSyntheticTraffic`)
 *
 * ⚠️ Any change here MUST also land in the AVP copy to avoid divergence. ⚠️
 *
 * Reason for duplication:
 *   AVP utilities cannot be imported safely into the Jira SPA. The only
 *   public entrypoint (`@atlassian/viz-platform-views`) is a single barrel
 *   `index.ts`; importing even one helper
 *   would add several MB to the Jira SPA bundle.
 *
 * Per-util notes:
 *   This copy reads the flag through `AtlBrowserStorageLocal` instead of
 *   the raw `localStorage` API to satisfy Jira's cookie-platform / browser-
 *   storage-controls policy. Behaviour is otherwise identical; keep the
 *   storage key in sync with the AVP file.
 *
 * Long-term resolutions to remove this duplication:
 *   1. Local consumption of individual AVP modules (file-level imports).
 *   2. Add an `exports` map to `@atlassian/viz-platform-views`'s
 *      `package.json` and drop the single-barrel `main`.
 *   3. Create a dedicated `entrypoints/` AVP package exposing only the
 *      minimum utilities required for SPA bootstrap.
 */ const $5fb9d15be1c1dcdf$var$isSyntheticTraffic = ()=>(0, $4fPPi.AtlBrowserStorageLocal).getItem($5fb9d15be1c1dcdf$var$STORAGE_KEY_SYNTHETIC_TRAFFIC) === 'true';
const $5fb9d15be1c1dcdf$export$a745ca99dde500e4 = ()=>$5fb9d15be1c1dcdf$var$isSyntheticTraffic() ? {
        'x-env-synthetic-traffic': 'true'
    } : {};

});




parcelRegister("3E5Aa", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsDetailRoute", () => $ab4d3c6dc3914f64$export$59a78d0054623414);
const $ab4d3c6dc3914f64$export$59a78d0054623414 = {
    name: 'assets-dashboards-detail',
    path: '/jira/assets/dashboards/:templateId',
    exact: true
};

});


parcelRegister("j20Cx", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsRouteEntry", () => $d1c138f4b4428a51$export$f33c78609ae076c5);

var $6t1HA = parcelRequire("6t1HA");

var $6BfVx = parcelRequire("6BfVx");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");

var $8PHdJ = parcelRequire("8PHdJ");

var $7KD98 = parcelRequire("7KD98");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");

var $dTa0V = parcelRequire("dTa0V");

var $6pofw = parcelRequire("6pofw");
const $d1c138f4b4428a51$var$assetsDashboardsListPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $6t1HA.assetsDashboardsListEntryPoint)
});
const $d1c138f4b4428a51$export$f33c78609ae076c5 = (0, $fdS54.createEntry)((0, $7KD98.assetsDashboardsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$d1c138f4b4428a51$var$assetsDashboardsListPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-dashboards-list-page',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics'), (0, $8PHdJ.assetsDashboardsSemanticModelResource))
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6t1HA", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsListEntryPoint", () => $422f2e871a32f6b1$export$92eba22de7f87140);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $422f2e871a32f6b1$export$92eba22de7f87140 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("iAqbM")), {
        moduleId: "60ace515",
        moduleName: "AssetsDashboardsList",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iAqbM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cvaa8").then(()=>parcelRequire('9ofDD'));

});


parcelRegister("7KD98", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsRoute", () => $a3ad807ff45399b5$export$b656a3df6d4d2e5d);
const $a3ad807ff45399b5$export$b656a3df6d4d2e5d = {
    name: 'assets-dashboards',
    path: '/jira/assets/dashboards',
    exact: true
};

});


parcelRegister("9UEdj", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataDictionaryGroupRouteEntry", () => $bbdede8d0add02a9$export$a58db67dfa95185a);

var $h8tNQ = parcelRequire("h8tNQ");

var $6BfVx = parcelRequire("6BfVx");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $70zBD = parcelRequire("70zBD");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $bbdede8d0add02a9$var$assetsDataManagerDataDictionaryGroupPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $h8tNQ.dataDictionaryGroupsEntryPoint)
});
const $bbdede8d0add02a9$export$a58db67dfa95185a = (0, $fdS54.createEntry)((0, $70zBD.assetsDataManagerDataDictionaryGroupRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-data-dictionary-group',
        pageId: ()=>'spa-apps/assets-data-manager-data-dictionary-group',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $bbdede8d0add02a9$var$assetsDataManagerDataDictionaryGroupPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_DICTIONARY_GROUP_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_DICTIONARY_GROUP_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("h8tNQ", function(module, exports) {
$parcel$export(module.exports, "dataDictionaryGroupsEntryPoint", () => $9e3aff13dc759003$export$2573002a56dbb40c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $9e3aff13dc759003$export$2573002a56dbb40c = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8weDd")), {
        moduleId: "a158855f",
        moduleName: "DataManagerDataDictionaryGroupsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: params } } })=>({
            extraProps: {
                objectClassId: params?.objectClassId || undefined,
                dictionaryId: params?.dictionaryId || undefined
            }
        })
});

});
parcelRegister("8weDd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gSzhN").then(()=>parcelRequire('lvcEe'));

});


parcelRegister("70zBD", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataDictionaryGroupRoute", () => $3ebbc68cbd9c7a93$export$9324275bd13adbfe);
const $3ebbc68cbd9c7a93$export$9324275bd13adbfe = {
    name: 'assets-data-manager-data-dictionary-group',
    path: '/jira/assets/data-manager/object-classes/:objectClassId/settings/data-dictionaries/:dictionaryId',
    exact: true
};

});


parcelRegister("hiWBS", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataDictionaryIssuesRouteEntry", () => $6614c4ba7ecfdd94$export$49956de16110bdc);

var $6Awji = parcelRequire("6Awji");

var $6BfVx = parcelRequire("6BfVx");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $4o2f4 = parcelRequire("4o2f4");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $6614c4ba7ecfdd94$var$assetsDataManagerIssuesPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $6Awji.issuesEntryPoint)
});
const $6614c4ba7ecfdd94$export$49956de16110bdc = (0, $fdS54.createEntry)((0, $4o2f4.assetsDataManagerDataDictionaryIssuesRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-issues',
        pageId: ()=>'spa-apps/assets-data-manager-issues',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $6614c4ba7ecfdd94$var$assetsDataManagerIssuesPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_ISSUES_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_ISSUES_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("6Awji", function(module, exports) {
$parcel$export(module.exports, "issuesEntryPoint", () => $34792493ffd4067d$export$3034154037f16ba7);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $34792493ffd4067d$export$3034154037f16ba7 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("hmSNO")), {
        moduleId: "6c77f1be",
        moduleName: "IssuesPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: params } } })=>({
            extraProps: {
                objectClassId: params?.objectClassId || undefined,
                dictionaryId: params?.dictionaryId || undefined,
                objectAttributeId: params?.objectAttributeId || undefined
            }
        })
});

});
parcelRegister("hmSNO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kiDO0").then(()=>parcelRequire('glZdC'));

});


parcelRegister("4o2f4", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataDictionaryIssuesRoute", () => $62cac4bbafbbf15d$export$4d9fdf9715a61e0);
const $62cac4bbafbbf15d$export$4d9fdf9715a61e0 = {
    name: 'assets-data-manager-data-dictionary-issues',
    path: '/jira/assets/data-manager/object-classes/:objectClassId/settings/data-dictionaries/:dictionaryId/issues/:objectAttributeId',
    exact: true
};

});


parcelRegister("aS2Q3", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataSourceRouteEntry", () => $7dc0fed6d0ca6887$export$3ca446ebb8517896);

var $6BfVx = parcelRequire("6BfVx");

var $JMKib = parcelRequire("JMKib");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $huRlO = parcelRequire("huRlO");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $7dc0fed6d0ca6887$var$assetsDataManagerDataSourcePageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $JMKib.assetsDataManagerDataSourceEntryPoint)
});
const $7dc0fed6d0ca6887$export$3ca446ebb8517896 = (0, $fdS54.createEntry)((0, $huRlO.assetsDataManagerDataSourceRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-data-source',
        pageId: ()=>'spa-apps/assets-data-manager-data-source',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $7dc0fed6d0ca6887$var$assetsDataManagerDataSourcePageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("JMKib", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataSourceEntryPoint", () => $3bf55898c4cb5634$export$bd7cd6f2edc69e5c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $9Z8F4 = parcelRequire("9Z8F4");

var $5z2kH = parcelRequire("5z2kH");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");
const $3bf55898c4cb5634$var$TABS = {
    configuration: (0, $9Z8F4.configurationTabEntryPoint),
    data: (0, $5z2kH.dataTabEntryPoint)
};
const $3bf55898c4cb5634$var$DEFAULT_TAB = 'configuration';
const $3bf55898c4cb5634$var$isValidTab = (tab)=>typeof tab === 'string' && Object.keys($3bf55898c4cb5634$var$TABS).includes(tab);

const $3bf55898c4cb5634$export$bd7cd6f2edc69e5c = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("ipZcR")), {
        moduleId: "7dbe9dda",
        moduleName: "AssetsDataManagerDataSourceSpa",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: params } } })=>{
        const validTab = $3bf55898c4cb5634$var$isValidTab(params?.tab) ? params.tab : $3bf55898c4cb5634$var$DEFAULT_TAB;
        const extraProps = {
            jobId: params?.dataSourceId || ''
        };
        return {
            entryPoints: {
                [validTab]: {
                    entryPoint: $3bf55898c4cb5634$var$TABS[validTab],
                    entryPointParams: {}
                }
            },
            extraProps: extraProps
        };
    }
});

});
parcelRegister("9Z8F4", function(module, exports) {
$parcel$export(module.exports, "configurationTabEntryPoint", () => $2efb4d323982991e$export$ec8b29e0134d3c80);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $2efb4d323982991e$export$ec8b29e0134d3c80 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6RrXH")), {
        moduleId: "8d76c438",
        moduleName: "ConfigurationPanel",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("6RrXH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eZnVF").then(()=>parcelRequire('9T7KZ'));

});


parcelRegister("5z2kH", function(module, exports) {
$parcel$export(module.exports, "dataTabEntryPoint", () => $997854732a97b9d0$export$5b828465e64ab503);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $997854732a97b9d0$export$5b828465e64ab503 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("g2Q7d")), {
        moduleId: "13c3af21",
        moduleName: "DataTab",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("g2Q7d", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1oswh").then(()=>parcelRequire('1pUMU'));

});


parcelRegister("ipZcR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3yj44").then(()=>parcelRequire('ftzoN'));

});


parcelRegister("huRlO", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataSourceRoute", () => $79acc03cb9488051$export$d046531151f2bc80);
const $79acc03cb9488051$export$d046531151f2bc80 = {
    name: 'assets-data-manager-data-source',
    path: '/jira/assets/data-manager/object-classes/data-source/:dataSourceId/:tab(configuration|data|activity)?',
    exact: true
};

});


parcelRegister("lvNEg", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDiscoverRouteEntry", () => $47db226751e4e23c$export$2d9879dc8032bcd8);

var $6BfVx = parcelRequire("6BfVx");

var $fW5VH = parcelRequire("fW5VH");

var $lFLfF = parcelRequire("lFLfF");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $awwX0 = parcelRequire("awwX0");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $47db226751e4e23c$var$assetsDataManagerDiscoverPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $fW5VH.assetsDataManagerDiscoverEntryPoint)
});
const $47db226751e4e23c$export$2d9879dc8032bcd8 = (0, $fdS54.createEntry)((0, $awwX0.assetsDataManagerDiscoverRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-discover',
        ufoName: 'assets-data-manager-discover',
        pageId: ()=>'assets-data-manager-discover',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('sqa-2098-assets-platform-app-nav-upsells') ? $47db226751e4e23c$var$assetsDataManagerDiscoverPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('sqa-2098-assets-platform-app-nav-upsells') ? undefined : (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@jira/router-routes__assets-app-entries/src/assetsDataManagerDiscoverRouteEntry.tsx',
                whichExportToUse: 'assetsDataManagerDiscoverRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fW5VH", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDiscoverEntryPoint", () => $ba830f000847e954$export$d78b3581415a9e46);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $fiVog = parcelRequire("fiVog");

var $7NTte = parcelRequire("7NTte");

const $ba830f000847e954$export$d78b3581415a9e46 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aEMA1")), {
        moduleId: "7708cf76",
        moduleName: "DataManagerDiscoverSpa",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aEMA1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1pZET").then(()=>parcelRequire('2PYgX'));

});


parcelRegister("awwX0", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDiscoverRoute", () => $36d321cb94282d15$export$4d4b09b3d5bd4473);
const $36d321cb94282d15$export$4d4b09b3d5bd4473 = {
    name: 'assets-data-manager-discover',
    path: '/jira/assets/discover/data-manager',
    exact: true
};

});


parcelRegister("dHwrc", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerGettingStartedRouteEntry", () => $4296d651b236f0f2$export$d9a1c48acd35cf03);

var $6BfVx = parcelRequire("6BfVx");

var $jziwm = parcelRequire("jziwm");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $kIzaE = parcelRequire("kIzaE");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $4296d651b236f0f2$var$assetsDataManagerGettingStartedPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $jziwm.assetsDataManagerGettingStartedEntryPoint)
});
const $4296d651b236f0f2$export$d9a1c48acd35cf03 = (0, $fdS54.createEntry)((0, $kIzaE.assetsDataManagerGettingStartedRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-getting-started',
        ufoName: 'assets-data-manager-getting-started',
        pageId: ()=>'spa-apps/assets-data-manager-getting-started',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $4296d651b236f0f2$var$assetsDataManagerGettingStartedPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_data_manager_jira_spa') ? undefined : (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jziwm", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerGettingStartedEntryPoint", () => $16030252e395f955$export$4f270d89a19b2303);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $16030252e395f955$export$4f270d89a19b2303 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("lGPoO")), {
        moduleId: "35f7c842",
        moduleName: "AssetsDataManagerGettingStartedPageSpa",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lGPoO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2VGsk").then(()=>parcelRequire('eZ754'));

});


parcelRegister("kIzaE", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerGettingStartedRoute", () => $1ffaa06d60e3b7f8$export$82de2af972f327f8);
const $1ffaa06d60e3b7f8$export$82de2af972f327f8 = {
    name: 'assets-data-manager-getting-started',
    path: '/jira/assets/data-manager/getting-started',
    exact: true
};

});


parcelRegister("gM6QF", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesRouteEntry", () => $9df756cff656b8ff$export$21baed265eb8be15);

var $6BfVx = parcelRequire("6BfVx");

var $bxr0L = parcelRequire("bxr0L");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $lIjWe = parcelRequire("lIjWe");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $9df756cff656b8ff$var$assetsDataManagerObjectClassesPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $bxr0L.assetsDataManagerObjectClassesEntryPoint)
});
const $9df756cff656b8ff$export$21baed265eb8be15 = (0, $fdS54.createEntry)((0, $lIjWe.assetsDataManagerObjectClassesRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-object-classes',
        pageId: ()=>'spa-apps/assets-data-manager-object-classes',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $9df756cff656b8ff$var$assetsDataManagerObjectClassesPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_data_manager_jira_spa') ? undefined : (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bxr0L", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesEntryPoint", () => $87a81700f922a259$export$c1881c035be68200);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $87a81700f922a259$export$c1881c035be68200 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("d67sh")), {
        moduleId: "faf830c1",
        moduleName: "AssetsDataManagerObjectClasssPageSpa",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("d67sh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7g04g").then(()=>parcelRequire('gZZ5J'));

});


parcelRegister("lIjWe", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesRoute", () => $35d9c033feadb467$export$efbc59a0b92a1a13);
const $35d9c033feadb467$export$efbc59a0b92a1a13 = {
    name: 'assets-data-manager-object-classes',
    path: '/jira/assets/data-manager/object-classes',
    exact: true
};

});


parcelRegister("5bC3H", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesSettingsRouteEntry", () => $aa3810e96b539243$export$56ece6957874bce0);

var $kMgLv = parcelRequire("kMgLv");

var $6BfVx = parcelRequire("6BfVx");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $3bkZL = parcelRequire("3bkZL");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");

var $dTa0V = parcelRequire("dTa0V");
const $aa3810e96b539243$var$assetsDataManagerObjectClassSettingsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $kMgLv.assetsDataManagerObjectClassesSettingsEntryPoint)
});
const $aa3810e96b539243$export$56ece6957874bce0 = (0, $fdS54.createEntry)((0, $3bkZL.assetsDataManagerObjectClassesSettingsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-object-classes-settings',
        ufoName: 'assets-data-manager-object-classes-settings',
        pageId: ({ match: match })=>{
            const settingType = match.params?.settingType;
            return settingType ? `spa-apps/assets-data-manager-object-classes-settings-${settingType}` : 'spa-apps/assets-data-manager-object-classes-settings';
        },
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $aa3810e96b539243$var$assetsDataManagerObjectClassSettingsPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_data_manager_jira_spa') ? undefined : (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_SETTINGS_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_SETTINGS_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kMgLv", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesSettingsEntryPoint", () => $a499bc53cf2afd67$export$ef3a1b9d5f809d09);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $jojLw = parcelRequire("jojLw");

var $faBrE = parcelRequire("faBrE");

var $5fomT = parcelRequire("5fomT");

var $jzgOa = parcelRequire("jzgOa");

var $763SG = parcelRequire("763SG");

var $e3TaV = parcelRequire("e3TaV");

var $hrFkD = parcelRequire("hrFkD");

var $i860n = parcelRequire("i860n");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");
const $a499bc53cf2afd67$var$SETTING_TYPES = [
    'data-source-type',
    'data-source-priorities',
    'attribute-priorities',
    'default-cleansing-rules',
    'cleansing-categories',
    'custom-date-formats',
    'audit-log'
];
// TODO: Import and add entrypoints for each setting type when they are created
const $a499bc53cf2afd67$var$SETTINGS = {
    'attribute-priorities': (0, $jojLw.attributePrioritiesEntryPoint),
    'cleansing-categories': (0, $faBrE.cleansingCategoriesEntryPoint),
    'data-source-type': (0, $jzgOa.dataSourceTypesEntryPoint),
    'default-cleansing-rules': (0, $763SG.defaultCleansingRulesEntryPoint),
    'data-source-priorities': (0, $e3TaV.dataSourcePrioritiesEntryPoint),
    'custom-date-formats': (0, $5fomT.customDateFormatsEntryPoint),
    'audit-log': (0, $hrFkD.auditLogEntryPoint)
};
const $a499bc53cf2afd67$var$isValidSettingType = (settingType)=>{
    if (typeof settingType !== 'string') return false;
    return $a499bc53cf2afd67$var$SETTING_TYPES.some((validType)=>validType === settingType);
};
const $a499bc53cf2afd67$var$getEntryPoint = (settingType)=>{
    if (settingType === 'custom-date-formats' && !(0, $i860n.fg)('assets_data_manager_fast_follow')) return undefined;
    return $a499bc53cf2afd67$var$SETTINGS[settingType];
};

const $a499bc53cf2afd67$export$ef3a1b9d5f809d09 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dwvPk")), {
        moduleId: "6601cad3",
        moduleName: "AssetsDataManagerObjectClassesSettingsPageSpa",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: params } } })=>{
        const validSettingType = $a499bc53cf2afd67$var$isValidSettingType(params?.settingType) ? params.settingType : undefined;
        if (validSettingType) {
            const entryPoint = $a499bc53cf2afd67$var$getEntryPoint(validSettingType);
            if (entryPoint) return {
                entryPoints: {
                    [validSettingType]: {
                        entryPoint: entryPoint,
                        entryPointParams: {}
                    }
                },
                extraProps: {
                    settingType: validSettingType
                }
            };
        }
        return {
            entryPoints: {},
            extraProps: {
                settingType: validSettingType
            }
        };
    }
});

});
parcelRegister("jojLw", function(module, exports) {
$parcel$export(module.exports, "attributePrioritiesEntryPoint", () => $3a7993f27fa0e7cb$export$ace1c3ef0ca7701f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $3a7993f27fa0e7cb$export$ace1c3ef0ca7701f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("7jMcR")), {
        moduleId: "e69eba0f",
        moduleName: "AttributePrioritiesPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("7jMcR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lezDO").then(()=>parcelRequire('juxbL'));

});


parcelRegister("faBrE", function(module, exports) {
$parcel$export(module.exports, "cleansingCategoriesEntryPoint", () => $73a73007559bfb1a$export$218cd4d2586d0426);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $73a73007559bfb1a$export$218cd4d2586d0426 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("eFfIQ")), {
        moduleId: "af165113",
        moduleName: "CleansingCategoriesPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("eFfIQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3YFT8").then(()=>parcelRequire('f1ouK'));

});


parcelRegister("5fomT", function(module, exports) {
$parcel$export(module.exports, "customDateFormatsEntryPoint", () => $7338c5618bc86750$export$49b2d6840c06f792);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $7338c5618bc86750$export$49b2d6840c06f792 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6ZvUr")), {
        moduleId: "db22fc37",
        moduleName: "CustomDateFormatsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("6ZvUr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cbAGL").then(()=>parcelRequire('7vFwj'));

});


parcelRegister("jzgOa", function(module, exports) {
$parcel$export(module.exports, "dataSourceTypesEntryPoint", () => $d81bb4ae948a34b0$export$4f5018889c50a7c7);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $d81bb4ae948a34b0$export$4f5018889c50a7c7 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("fQNQp")), {
        moduleId: "2f0690d2",
        moduleName: "DataSourceTypesPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("fQNQp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1xmAv").then(()=>parcelRequire('edudw'));

});


parcelRegister("763SG", function(module, exports) {
$parcel$export(module.exports, "defaultCleansingRulesEntryPoint", () => $f23deac1bc0d37d9$export$ecc1721f7f53566c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $f23deac1bc0d37d9$export$ecc1721f7f53566c = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("eMzfD")), {
        moduleId: "5ff8d085",
        moduleName: "DefaultCleansingRulesPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("eMzfD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fGgbQ").then(()=>parcelRequire('dFlKA'));

});


parcelRegister("e3TaV", function(module, exports) {
$parcel$export(module.exports, "dataSourcePrioritiesEntryPoint", () => $4265bd856dee1a98$export$30fc57a7999f9795);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $4265bd856dee1a98$export$30fc57a7999f9795 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9Cwsc")), {
        moduleId: "b09e5698",
        moduleName: "DataSourcePrioritiesPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("9Cwsc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dTmhk").then(()=>parcelRequire('h0Rma'));

});


parcelRegister("hrFkD", function(module, exports) {
$parcel$export(module.exports, "auditLogEntryPoint", () => $b35cffa4f43d31de$export$237a6fdbef3fc6c9);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $b35cffa4f43d31de$export$237a6fdbef3fc6c9 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("iHAV4")), {
        moduleId: "82d88161",
        moduleName: "AuditLogPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("iHAV4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Zr0I").then(()=>parcelRequire('4Zrg1'));

});


parcelRegister("dwvPk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1N5XY").then(()=>parcelRequire('988qj'));

});


parcelRegister("3bkZL", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesSettingsRoute", () => $5794552fcd4ffa32$export$137968faca5bbaee);
const $5794552fcd4ffa32$export$137968faca5bbaee = {
    name: 'assets-data-manager-object-classes-settings',
    path: '/jira/assets/data-manager/object-classes/settings/:settingType(data-source-type|data-source-priorities|attribute-priorities|default-cleansing-rules|cleansing-categories|custom-date-formats|audit-log)',
    exact: true
};

});


parcelRegister("bkh9V", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassSettingsRouteEntry", () => $84f7cadd6c556740$export$392516056dfe7aca);

var $eAJs9 = parcelRequire("eAJs9");

var $6BfVx = parcelRequire("6BfVx");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $9s2nb = parcelRequire("9s2nb");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");

var $dTa0V = parcelRequire("dTa0V");
const $84f7cadd6c556740$var$assetsDataManagerObjectClassSettingsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $eAJs9.assetsDataManagerObjectClassSettingsEntryPoint)
});
const $84f7cadd6c556740$export$392516056dfe7aca = (0, $fdS54.createEntry)((0, $9s2nb.assetsDataManagerObjectClassSettingsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-object-class-settings',
        pageId: ()=>'spa-apps/assets-data-manager-object-class-settings',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $84f7cadd6c556740$var$assetsDataManagerObjectClassSettingsPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_data_manager_jira_spa') ? undefined : (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_SETTINGS_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_SETTINGS_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eAJs9", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassSettingsEntryPoint", () => $ce07619beb7da003$export$425175a2bc61f34a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $aqUon = parcelRequire("aqUon");

var $7bJzf = parcelRequire("7bJzf");

var $6MKqd = parcelRequire("6MKqd");

var $cvhVg = parcelRequire("cvhVg");

var $e9cOZ = parcelRequire("e9cOZ");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");
const $ce07619beb7da003$var$SETTING_TYPES = [
    'mapping-matrix',
    'default-attribute-mapping',
    'cleansing-statistics',
    'data-dictionaries',
    'attributes'
];
const $ce07619beb7da003$var$SETTINGS = {
    'mapping-matrix': (0, $aqUon.mappingMatrixEntryPoint),
    'default-attribute-mapping': (0, $6MKqd.defaultAttributeMappingEntryPoint),
    'cleansing-statistics': (0, $7bJzf.cleansingStatisticsEntryPoint),
    'data-dictionaries': (0, $cvhVg.dataDictionariesEntryPoint),
    attributes: (0, $e9cOZ.dataManagerAttributesEntryPoint)
};
const $ce07619beb7da003$var$isValidSettingType = (settingType)=>{
    if (typeof settingType !== 'string') return false;
    return $ce07619beb7da003$var$SETTING_TYPES.some((validType)=>validType === settingType);
};
const $ce07619beb7da003$var$getEntryPoint = (settingType)=>{
    return $ce07619beb7da003$var$SETTINGS[settingType];
};

const $ce07619beb7da003$export$425175a2bc61f34a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("7T7ME")), {
        moduleId: "55451a71",
        moduleName: "AssetsDataManagerObjectClassSettingsPageSpa",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: params } } })=>{
        const validSettingType = $ce07619beb7da003$var$isValidSettingType(params?.settingType) ? params.settingType : undefined;
        const objectClassId = params?.objectClassId || undefined;
        if (validSettingType) {
            const entryPoint = $ce07619beb7da003$var$getEntryPoint(validSettingType);
            if (entryPoint) return {
                entryPoints: {
                    [validSettingType]: {
                        entryPoint: entryPoint,
                        entryPointParams: {}
                    }
                },
                extraProps: {
                    settingType: validSettingType,
                    objectClassId: objectClassId
                }
            };
        }
        return {
            entryPoints: {},
            extraProps: {
                settingType: validSettingType,
                objectClassId: objectClassId
            }
        };
    }
});

});
parcelRegister("aqUon", function(module, exports) {
$parcel$export(module.exports, "mappingMatrixEntryPoint", () => $b885629847141939$export$2e6f233454e4866e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $b885629847141939$export$2e6f233454e4866e = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("505fh")), {
        moduleId: "0cb58ff0",
        moduleName: "MappingMatrixPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("505fh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3T0Qk").then(()=>parcelRequire('8Su7n'));

});


parcelRegister("7bJzf", function(module, exports) {
$parcel$export(module.exports, "cleansingStatisticsEntryPoint", () => $855370ae21183898$export$ce901017ecf07bc8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $855370ae21183898$export$ce901017ecf07bc8 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("35ZBJ")), {
        moduleId: "d67c12d2",
        moduleName: "CleansingStatisticsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("35ZBJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("feC3B").then(()=>parcelRequire('9Zbm0'));

});


parcelRegister("6MKqd", function(module, exports) {
$parcel$export(module.exports, "defaultAttributeMappingEntryPoint", () => $209e6cf32dd092fa$export$f8b73a58a5030245);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $209e6cf32dd092fa$export$f8b73a58a5030245 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("873Yp")), {
        moduleId: "3186b56f",
        moduleName: "DefaultAttributeMappingPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("873Yp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lBUYC").then(()=>parcelRequire('hYxqZ'));

});


parcelRegister("cvhVg", function(module, exports) {
$parcel$export(module.exports, "dataDictionariesEntryPoint", () => $a779a56dddc704a0$export$ed4ae68b1543ed7e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $a779a56dddc704a0$export$ed4ae68b1543ed7e = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9utdi")), {
        moduleId: "946a7653",
        moduleName: "DataManagerDataDictionariesPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("9utdi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("euK0h").then(()=>parcelRequire('bHhVs'));

});


parcelRegister("e9cOZ", function(module, exports) {
$parcel$export(module.exports, "dataManagerAttributesEntryPoint", () => $a49d8c337ec6eb79$export$5042a8f2621990b6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $a49d8c337ec6eb79$export$5042a8f2621990b6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("f29JA")), {
        moduleId: "04903eff",
        moduleName: "DataManagerAttributesPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("f29JA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9kdtt").then(()=>parcelRequire('l6L8g'));

});


parcelRegister("7T7ME", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("enEk3").then(()=>parcelRequire('7xjid'));

});


parcelRegister("9s2nb", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassSettingsRoute", () => $b0f3419cc7dd6374$export$358b5082f3fd77c2);
const $b0f3419cc7dd6374$export$358b5082f3fd77c2 = {
    name: 'assets-data-manager-object-class-settings',
    path: '/jira/assets/data-manager/object-classes/:objectClassId/settings/:settingType(mapping-matrix|cleansing-statistics|data-dictionaries|default-attribute-mapping|attributes)',
    exact: true
};

});


parcelRegister("gzEKj", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassViewRouteEntry", () => $4b5f1e403c88f2a3$export$f4973dfdf4833835);

var $6BfVx = parcelRequire("6BfVx");

var $1OlJz = parcelRequire("1OlJz");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $7Aq3m = parcelRequire("7Aq3m");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $4b5f1e403c88f2a3$var$assetsDataManagerObjectClassViewPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $1OlJz.assetsDataManagerObjectClassViewEntryPoint)
});
const $4b5f1e403c88f2a3$export$f4973dfdf4833835 = (0, $fdS54.createEntry)((0, $7Aq3m.assetsDataManagerObjectClassViewRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-object-class-view',
        pageId: ()=>'spa-apps/assets-data-manager-object-class-view',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $4b5f1e403c88f2a3$var$assetsDataManagerObjectClassViewPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_data_manager_jira_spa') ? undefined : (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1OlJz", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassViewEntryPoint", () => $5a34501e90a7eaf6$export$a02bbc7f46f6a7cc);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $kwAMI = parcelRequire("kwAMI");

var $faF6K = parcelRequire("faF6K");

var $jz53F = parcelRequire("jz53F");

const $5a34501e90a7eaf6$export$a02bbc7f46f6a7cc = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("amK8Q")), {
        moduleId: "47435bb1",
        moduleName: "AssetsDataManagerObjectClassViewSpa",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { query: query } })=>{
        const { tab: tab } = query;
        if (tab === 'saved-search') return {
            entryPoints: {
                savedSearchTabEntryPoint: {
                    entryPoint: (0, $kwAMI.savedSearchTabEntryPoint)
                }
            }
        };
        if (tab === 'tags') return {
            entryPoints: {
                tagsTabEntryPoint: {
                    entryPoint: (0, $faF6K.tagsTabEntryPoint)
                }
            }
        };
        // default to objects tab
        return {
            entryPoints: {
                objectsTabEntryPoint: {
                    entryPoint: (0, $jz53F.objectsTabEntryPoint)
                }
            }
        };
    }
});

});
parcelRegister("kwAMI", function(module, exports) {
$parcel$export(module.exports, "savedSearchTabEntryPoint", () => $d01fe2b419d6c4eb$export$892a185cebc12244);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $d01fe2b419d6c4eb$export$892a185cebc12244 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("Mr2X1")), {
        moduleId: "39b0d817",
        moduleName: "SavedSearchPanel",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("Mr2X1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2qnLA").then(()=>parcelRequire('8Q9gO'));

});


parcelRegister("faF6K", function(module, exports) {
$parcel$export(module.exports, "tagsTabEntryPoint", () => $b2a741a157278e93$export$f5b804ece08cf9c8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $b2a741a157278e93$export$f5b804ece08cf9c8 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("7gsio")), {
        moduleId: "b2a941b0",
        moduleName: "TagsPanel",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("7gsio", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lEe37").then(()=>parcelRequire('jpWrZ'));

});


parcelRegister("jz53F", function(module, exports) {
$parcel$export(module.exports, "objectsTabEntryPoint", () => $cedc77f821ed77e3$export$c56ef5bc8d8eca35);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $cedc77f821ed77e3$export$c56ef5bc8d8eca35 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("lqXDu")), {
        moduleId: "bd4fdd3a",
        moduleName: "ObjectsTab",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("lqXDu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jDHLS").then(()=>parcelRequire('e1T0T'));

});


parcelRegister("amK8Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kMIBO").then(()=>parcelRequire('2s10q'));

});


parcelRegister("7Aq3m", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassViewRoute", () => $e97747bca6f35646$export$88a05b032620e348);
const $e97747bca6f35646$export$88a05b032620e348 = {
    name: 'assets-data-manager-object-class-view',
    path: '/jira/assets/data-manager/object-classes/view/:objectClassId',
    exact: true,
    query: [
        'tab?'
    ]
};

});


parcelRegister("8It8d", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectDetailViewRouteEntry", () => $af0fd22b5c4be941$export$d85e06e8278936eb);

var $6BfVx = parcelRequire("6BfVx");

var $kCTLC = parcelRequire("kCTLC");

var $lFLfF = parcelRequire("lFLfF");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $pkt5D = parcelRequire("pkt5D");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $af0fd22b5c4be941$var$assetsDataManagerObjectDetailViewPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $kCTLC.assetsDataManagerObjectDetailViewEntryPoint)
});
const $af0fd22b5c4be941$export$d85e06e8278936eb = (0, $fdS54.createEntry)((0, $pkt5D.assetsDataManagerObjectDetailViewRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        perfMetricKey: 'assets-data-manager-object-detail-view',
        pageId: ()=>'spa-apps/assets-data-manager-object-detail-view',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $i860n.fg)('assets_data_manager_jira_spa') ? $af0fd22b5c4be941$var$assetsDataManagerObjectDetailViewPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_data_manager_jira_spa') ? undefined : (0, $lFLfF.default),
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kCTLC", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectDetailViewEntryPoint", () => $9480a525953238d2$export$84681f0edd85e05a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $9480a525953238d2$export$84681f0edd85e05a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6B5q6")), {
        moduleId: "d8feed89",
        moduleName: "AssetsDataManagerObjectDetailViewPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6B5q6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dcu5a").then(()=>parcelRequire('ft0ER'));

});


parcelRegister("pkt5D", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectDetailViewRoute", () => $a76638b345e1f6ee$export$ddfe9d50019b3e76);
const $a76638b345e1f6ee$export$ddfe9d50019b3e76 = {
    name: 'assets-data-manager-object-detail-view',
    path: '/jira/assets/data-manager/object-classes/view/:objectClassId/object/:objectId',
    exact: true
};

});


parcelRegister("2OdJy", function(module, exports) {
$parcel$export(module.exports, "assetsForYouRouteEntry", () => $57d68e8d31debada$export$69f5cb89a22780e6);

var $6BfVx = parcelRequire("6BfVx");

var $fdS54 = parcelRequire("fdS54");

var $kzls7 = parcelRequire("kzls7");

var $1UBSs = parcelRequire("1UBSs");

var $dTa0V = parcelRequire("dTa0V");

var $hV1IE = parcelRequire("hV1IE");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");

var $i860n = parcelRequire("i860n");
const $57d68e8d31debada$var$assetsForYouPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $hV1IE.assetsForYouEntryPoint)
});
const $57d68e8d31debada$export$69f5cb89a22780e6 = (0, $fdS54.createEntry)((0, $kzls7.assetsForYouRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>(0, $i860n.fg)('assets_for_you') ? $57d68e8d31debada$var$assetsForYouPageEntryPoint : undefined,
        pageId: ()=>'spa-apps/assets/for-you-page',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-for-you-page',
        ufoName: 'assets-app-for-you-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kzls7", function(module, exports) {
$parcel$export(module.exports, "assetsForYouRoute", () => $0d047411337dbabd$export$ec149f15b6c7930d);
const $0d047411337dbabd$export$ec149f15b6c7930d = {
    name: 'assets-for-you',
    path: '/jira/assets/for-you',
    exact: true
};

});

parcelRegister("hV1IE", function(module, exports) {
$parcel$export(module.exports, "assetsForYouEntryPoint", () => $1a64f9492d9d7cf8$export$3c6977bd1cdb3ef);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $1a64f9492d9d7cf8$export$3c6977bd1cdb3ef = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aIXSY")), {
        moduleId: "a8dad078",
        moduleName: "AssetsForYouPageView",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aIXSY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iTvKg").then(()=>parcelRequire('dp3ZH'));

});



parcelRegister("1mi9U", function(module, exports) {
$parcel$export(module.exports, "assetsObjectRouteEntry", () => $7c5b1c5e3f17641b$export$17871a1fbc6e31db);

var $6BfVx = parcelRequire("6BfVx");

var $5wkMM = parcelRequire("5wkMM");

var $fdS54 = parcelRequire("fdS54");

var $9Nwkz = parcelRequire("9Nwkz");

var $j9qGv = parcelRequire("j9qGv");

var $1UBSs = parcelRequire("1UBSs");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $7c5b1c5e3f17641b$var$assetsObjectPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $5wkMM.assetsObjectViewEntryPoint)
});
const $7c5b1c5e3f17641b$export$17871a1fbc6e31db = (0, $fdS54.createEntry)((0, $j9qGv.assetsObjectRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$7c5b1c5e3f17641b$var$assetsObjectPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-v2',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            (0, $9Nwkz.insightObjectResource)
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'assets-object-view-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5wkMM", function(module, exports) {
$parcel$export(module.exports, "assetsObjectViewEntryPoint", () => $1199629c4617bde0$export$4311ec530d21ec36);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $1199629c4617bde0$export$4311ec530d21ec36 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9Zs43")), {
        moduleId: "8ada5465",
        moduleName: "ConditionalRedirectOrRouteView",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9Zs43", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("eAoL3"),
    $4cvLQ("15ZAZ"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gsLOw")
]).then(()=>parcelRequire('4JqAV'));

});


parcelRegister("9Nwkz", function(module, exports) {
$parcel$export(module.exports, "insightObjectResource", () => $80cfe3d7ecf2449f$export$215464c8085c5e35);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $ahDW6 = parcelRequire("ahDW6");
const $80cfe3d7ecf2449f$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
const $80cfe3d7ecf2449f$export$215464c8085c5e35 = (0, $7edbf.createResource)({
    type: $80cfe3d7ecf2449f$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
    getKey: ({ match: match })=>match.params.objectId || '',
    getData: $ahDW6.default,
    isBrowserOnly: true
});

});
parcelRegister("ahDW6", function(module, exports) {
$parcel$export(module.exports, "default", () => $5787ee29caf5c9bf$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fOKvg = parcelRequire("fOKvg");

var $7cA7G = parcelRequire("7cA7G");

var $5d6a5 = parcelRequire("5d6a5");

var $bOYO0 = parcelRequire("bOYO0");

var $bdEst = parcelRequire("bdEst");

var $6xuJS = parcelRequire("6xuJS");

var $6CfY5 = parcelRequire("6CfY5");

var $4fhEY = parcelRequire("4fhEY");

var $khHvh = parcelRequire("khHvh");
const $5787ee29caf5c9bf$var$fetchInsightObjectDetails = async (routeDataContext, storeContext)=>{
    try {
        const { match: { params: params } } = routeDataContext;
        const { objectId: objectId } = params;
        if (objectId == null) return null;
        const workspaceId = await (0, $bOYO0.default)(routeDataContext, storeContext);
        if (workspaceId == null) return null;
        const data = await (0, $4fhEY.default)((0, $5d6a5.getCmdbObjectByIdUrl)(workspaceId, objectId));
        (0, $6xuJS.setMark)((0, $khHvh.prefetchApiReadyMark));
        return data;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
        (0, $7cA7G.fireCmdbErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskInsightObjectResource',
                packageName: 'jiraSpa'
            },
            error: error
        });
        throw error;
    }
};
const $5787ee29caf5c9bf$var$getData = async (routeDataContext, storeContext)=>{
    const { tenantContext: tenantContext } = storeContext;
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $fOKvg.checkAuthentication)(tenantContext)) throw (0, $bdEst.createResourceError)({
        component: 'spa.view.routes.servicedesk.cmdb-object.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    return $5787ee29caf5c9bf$var$fetchInsightObjectDetails(routeDataContext, storeContext);
};
var $5787ee29caf5c9bf$export$2e2bcd8739ae039 = $5787ee29caf5c9bf$var$getData;

});
parcelRegister("7cA7G", function(module, exports) {
$parcel$export(module.exports, "fireCmdbErrorAnalytics", () => $18ee22d2896124cd$export$50d4fa14efd248c2);

var $hFtK7 = parcelRequire("hFtK7");
const $18ee22d2896124cd$export$50d4fa14efd248c2 = (payload)=>{
    return (0, $hFtK7.fireErrorAnalytics)(payload);
};

});

parcelRegister("5d6a5", function(module, exports) {
$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $3fc421ae916ccaca$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $3fc421ae916ccaca$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $3fc421ae916ccaca$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $3fc421ae916ccaca$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $3fc421ae916ccaca$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $3fc421ae916ccaca$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $3fc421ae916ccaca$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $3fc421ae916ccaca$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $3fc421ae916ccaca$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectAttributeReferenceValuesUrl", () => $3fc421ae916ccaca$export$9ba2c7d66e9b6523);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $3fc421ae916ccaca$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $3fc421ae916ccaca$export$ee74f95a469c4433);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", () => $3fc421ae916ccaca$export$84a34ee3f18e226);
$parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", () => $3fc421ae916ccaca$export$878b627ac685384e);
$parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", () => $3fc421ae916ccaca$export$8eb3a6b36886db0);
$parcel$export(module.exports, "getCmdbAsyncGenerateUaDuplicatesReportUrl", () => $3fc421ae916ccaca$export$54601fa587b1cebb);
$parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", () => $3fc421ae916ccaca$export$b02201bcaeb75291);
$parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", () => $3fc421ae916ccaca$export$f4d68a6f0e3217b5);
$parcel$export(module.exports, "getCmdbAsyncCdmBundleInstantiationUrl", () => $3fc421ae916ccaca$export$ae8f0647f4610496);
/* eslint-disable jira/filename-case */ 
var $bS1iz = parcelRequire("bS1iz");

var $iGhBm = parcelRequire("iGhBm");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $3fc421ae916ccaca$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $3fc421ae916ccaca$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $3fc421ae916ccaca$export$6ef8997552257871(workspaceId, objectId);
    if (!includeExtendedInfo) return `${path}?${(0, $bS1iz.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $3fc421ae916ccaca$export$6ef8997552257871 = (workspaceId, objectId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $3fc421ae916ccaca$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$3fc421ae916ccaca$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $bS1iz.stringify)(queryParams)}`;
const $3fc421ae916ccaca$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$3fc421ae916ccaca$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $3fc421ae916ccaca$export$5044a1e9fc201773 = (workspaceId, objectId)=>{
    return `${$3fc421ae916ccaca$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo?computeOpenIssues=false`;
};
const $3fc421ae916ccaca$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $3fc421ae916ccaca$export$9cdc19e8944d38cf = (workspaceId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/create`;
const $3fc421ae916ccaca$export$bf9c534c2cd21829 = (workspaceId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $3fc421ae916ccaca$export$b35334340ee827fa = (workspaceId)=>`${$3fc421ae916ccaca$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $3fc421ae916ccaca$export$9ba2c7d66e9b6523 = (workspaceId, objectIdOrKey, objectTypeAttributeId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/${objectIdOrKey}/attribute/${objectTypeAttributeId}/referenceValues`;
const $3fc421ae916ccaca$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $bS1iz.stringify)(queryParams)}`;
const $3fc421ae916ccaca$export$ee74f95a469c4433 = (workspaceId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
const $3fc421ae916ccaca$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $bS1iz.stringify)(queryParams)}`;
const $3fc421ae916ccaca$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $bS1iz.stringify)(queryParams)}`;
const $3fc421ae916ccaca$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $bS1iz.stringify)(queryParams)}`;
const $3fc421ae916ccaca$export$878b627ac685384e = (workspaceId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
const $3fc421ae916ccaca$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $bS1iz.stringify)(queryParams)}`;
const $3fc421ae916ccaca$export$54601fa587b1cebb = (workspaceId, objectTypeAttributeId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/${objectTypeAttributeId}/generate-ua-duplicates-report`;
const $3fc421ae916ccaca$export$b02201bcaeb75291 = (workspaceId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
const $3fc421ae916ccaca$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$3fc421ae916ccaca$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;
const $3fc421ae916ccaca$export$ae8f0647f4610496 = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/bundle/instantiate/async`;

});
parcelRegister("bS1iz", function(module, exports) {
$parcel$export(module.exports, "extract", () => $8a45beb58c2751cb$export$f9380c9a627682d3, (v) => $8a45beb58c2751cb$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $8a45beb58c2751cb$export$98e6a39c04603d36, (v) => $8a45beb58c2751cb$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $8a45beb58c2751cb$export$fac44ee5b035f737, (v) => $8a45beb58c2751cb$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $8a45beb58c2751cb$export$7a5253c0f62e0150, (v) => $8a45beb58c2751cb$export$7a5253c0f62e0150 = v);
var $8a45beb58c2751cb$export$f9380c9a627682d3;
var $8a45beb58c2751cb$export$98e6a39c04603d36;
var $8a45beb58c2751cb$export$fac44ee5b035f737;
var $8a45beb58c2751cb$export$7a5253c0f62e0150;
'use strict';

var $cgILL = parcelRequire("cgILL");

var $gjoqw = parcelRequire("gjoqw");

var $e9Lvx = parcelRequire("e9Lvx");
function $8a45beb58c2751cb$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $8a45beb58c2751cb$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $8a45beb58c2751cb$var$encode(key, opts),
                    '[',
                    $8a45beb58c2751cb$var$encode(index, opts),
                    ']=',
                    $8a45beb58c2751cb$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $8a45beb58c2751cb$var$encode(key, opts) : [
                    $8a45beb58c2751cb$var$encode(key, opts),
                    '[]=',
                    $8a45beb58c2751cb$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $8a45beb58c2751cb$var$encode(key, opts) : [
                    $8a45beb58c2751cb$var$encode(key, opts),
                    '=',
                    $8a45beb58c2751cb$var$encode(value, opts)
                ].join('');
            };
    }
}
function $8a45beb58c2751cb$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $8a45beb58c2751cb$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $cgILL(value) : encodeURIComponent(value);
    return value;
}
function $8a45beb58c2751cb$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $8a45beb58c2751cb$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $8a45beb58c2751cb$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $8a45beb58c2751cb$var$parse(str, opts) {
    opts = $gjoqw({
        arrayFormat: 'none'
    }, opts);
    var formatter = $8a45beb58c2751cb$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $e9Lvx(val);
        formatter($e9Lvx(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $8a45beb58c2751cb$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$8a45beb58c2751cb$export$f9380c9a627682d3 = $8a45beb58c2751cb$var$extract;
$8a45beb58c2751cb$export$98e6a39c04603d36 = $8a45beb58c2751cb$var$parse;
$8a45beb58c2751cb$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $gjoqw(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $8a45beb58c2751cb$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $8a45beb58c2751cb$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $8a45beb58c2751cb$var$encode(key, opts) + '=' + $8a45beb58c2751cb$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$8a45beb58c2751cb$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $8a45beb58c2751cb$var$parse($8a45beb58c2751cb$var$extract(str), opts)
    };
};

});
parcelRegister("cgILL", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("gjoqw", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $be015e5147a1edd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $be015e5147a1edd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $be015e5147a1edd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $be015e5147a1edd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $be015e5147a1edd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $be015e5147a1edd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $be015e5147a1edd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($be015e5147a1edd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($be015e5147a1edd6$var$getOwnPropertySymbols) {
            symbols = $be015e5147a1edd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($be015e5147a1edd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("iGhBm", function(module, exports) {
$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $4ac863ef10e91139$export$28b6c003daedf1c2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $4ac863ef10e91139$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});


parcelRegister("khHvh", function(module, exports) {
$parcel$export(module.exports, "appBundleReadyMark", () => $6d3c836afc76de38$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $6d3c836afc76de38$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $6d3c836afc76de38$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $6d3c836afc76de38$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $6d3c836afc76de38$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $6d3c836afc76de38$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $6d3c836afc76de38$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $6d3c836afc76de38$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $6d3c836afc76de38$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $6d3c836afc76de38$export$4eb8d44ddb14424a);
/* eslint-disable jira/filename-case */ 

var $jgUTL = parcelRequire("jgUTL");
const $6d3c836afc76de38$export$7e50945a65dd40e = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$ff834eccc35b9089));
const $6d3c836afc76de38$export$17cbe723d23101d8 = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$86b05e34d462ead8));
const $6d3c836afc76de38$export$887fadb22e7c7735 = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$d6a604a7d9a390fb));
const $6d3c836afc76de38$export$bd099c0a906f4b3f = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$3ae43cc1782d058f));
const $6d3c836afc76de38$export$d23ef9e7633e30e7 = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$363f6703ffa600be));
const $6d3c836afc76de38$export$319da6d901948a6d = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$e87b74567b79c8));
const $6d3c836afc76de38$export$f0b6622cdc5c7e4f = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$99fe642459a8b02));
const $6d3c836afc76de38$export$37e82663aa1e79a8 = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$ab1f5705fc8e0571));
const $6d3c836afc76de38$export$21146514eacceb12 = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$8c3a9046da692c35));
const $6d3c836afc76de38$export$4eb8d44ddb14424a = (0, $jgUTL.getPrefixedMarkName)((0, $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf));

});



parcelRegister("j9qGv", function(module, exports) {
$parcel$export(module.exports, "assetsObjectRoute", () => $e3cd0f5ed3cc0a9b$export$8f0b5215230b6dd1);
const $e3cd0f5ed3cc0a9b$export$8f0b5215230b6dd1 = {
    name: 'assets-object',
    path: '/jira/assets/object/:objectId'
};

});


parcelRegister("dTOhd", function(module, exports) {
$parcel$export(module.exports, "assetsObjectTypeConfigurationRouteEntry", () => $f05827f56560e58f$export$28b088de21f264eb);

var $6BfVx = parcelRequire("6BfVx");

var $kRkwu = parcelRequire("kRkwu");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $gEvcY = parcelRequire("gEvcY");

var $1UBSs = parcelRequire("1UBSs");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $f05827f56560e58f$var$assetsObjectTypeSettingsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $kRkwu.assetsObjectTypeSettingsEntryPoint)
});
const $f05827f56560e58f$export$28b088de21f264eb = (0, $fdS54.createEntry)((0, $gEvcY.assetsObjectTypeConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$f05827f56560e58f$var$assetsObjectTypeSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure-object-type',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'astral'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kRkwu", function(module, exports) {
$parcel$export(module.exports, "assetsObjectTypeSettingsEntryPoint", () => $17e2329eed81cbcb$export$fab2e471b162aafc);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $17e2329eed81cbcb$export$fab2e471b162aafc = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5kOmp")), {
        moduleId: "8fe17350",
        moduleName: "ConditionalRedirectOrRouteView",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5kOmp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("kk0vE")
]).then(()=>parcelRequire('fRfTQ'));

});


parcelRegister("gEvcY", function(module, exports) {
$parcel$export(module.exports, "assetsObjectTypeConfigurationRoute", () => $33d0df2309908e96$export$fe5957039840ffd3);
const $33d0df2309908e96$export$fe5957039840ffd3 = {
    name: 'assets-object-type-configuration',
    path: '/jira/assets/configure/object-type/:objectTypeId'
};

});


parcelRegister("fXfmE", function(module, exports) {
$parcel$export(module.exports, "assetsReportsRouteEntry", () => $daaed178d6e2fd8a$export$dabfe6668c5a0cc4);

var $6BfVx = parcelRequire("6BfVx");

var $kxJPG = parcelRequire("kxJPG");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $9MoWE = parcelRequire("9MoWE");

var $6pofw = parcelRequire("6pofw");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $1UBSs = parcelRequire("1UBSs");

var $dD11h = parcelRequire("dD11h");
const $daaed178d6e2fd8a$var$assetsReportsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $kxJPG.assetsReportsNav4HomeEntryPoint)
});
const $daaed178d6e2fd8a$export$dabfe6668c5a0cc4 = (0, $fdS54.createEntry)((0, $9MoWE.assetsReportsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$daaed178d6e2fd8a$var$assetsReportsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-home-page',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kxJPG", function(module, exports) {
$parcel$export(module.exports, "assetsReportsNav4HomeEntryPoint", () => $dbac737e48fd8cc5$export$1a891b207b85b219);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $dbac737e48fd8cc5$export$1a891b207b85b219 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("cnjYo")), {
        moduleId: "c52aa9e8",
        moduleName: "AssetsReportsNav4HomePage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cnjYo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gtDeX")
]).then(()=>parcelRequire('6HPgn'));

});


parcelRegister("9MoWE", function(module, exports) {
$parcel$export(module.exports, "assetsReportsRoute", () => $789f99eb5667a53d$export$b123ccf7df3854f4);
const $789f99eb5667a53d$export$b123ccf7df3854f4 = {
    name: 'assets-reports-default-redirect',
    path: '/jira/assets/reports',
    exact: true
};

});


parcelRegister("KwSsA", function(module, exports) {
$parcel$export(module.exports, "assetsReportsTemplateRouteEntry", () => $e371955108851f84$export$c69d6dbd8091ce7b);

var $6BfVx = parcelRequire("6BfVx");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ipYai = parcelRequire("ipYai");

var $6pofw = parcelRequire("6pofw");

var $33j7g = parcelRequire("33j7g");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $e371955108851f84$export$c69d6dbd8091ce7b = (0, $fdS54.createEntry)((0, $ipYai.assetsReportsTemplateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $33j7g.AssetsReports),
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout),
            (0, $33j7g.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ipYai", function(module, exports) {
$parcel$export(module.exports, "assetsReportsTemplateRoute", () => $d3b4a4c8aea98b90$export$4255578ec14d83bb);
const $d3b4a4c8aea98b90$export$4255578ec14d83bb = {
    name: 'assets-reports',
    path: '/jira/assets/reports/:templateId',
    exact: true
};

});

parcelRegister("33j7g", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReports", () => $90693170f8884dd8$export$9f75cdfdfe8c8aaa);
$parcel$export(module.exports, "LazyServicedeskCmdbDefaultReportsRedirect", () => $90693170f8884dd8$export$2534c3e9f8e70d0d);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsUnsubscribe", () => $90693170f8884dd8$export$dec85f15dd805ac4);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsNav4HomePage", () => $90693170f8884dd8$export$c56cfef9aa68df09);
$parcel$export(module.exports, "AssetsReports", () => $90693170f8884dd8$export$d45b40d40442434);
$parcel$export(module.exports, "AssetsReportsUnsubscribe", () => $90693170f8884dd8$export$541b39e6d5be07df);
$parcel$export(module.exports, "AssetsReportsNav4HomePage", () => $90693170f8884dd8$export$9d28551695f98cae);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $90693170f8884dd8$export$9f75cdfdfe8c8aaa = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("fxHLE")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-assets-reports/src/CmdbAssetsReports.tsx"
});

const $90693170f8884dd8$export$2534c3e9f8e70d0d = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("fxHLE")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-assets-reports/src/CmdbAssetsReports.tsx"
});

const $90693170f8884dd8$export$dec85f15dd805ac4 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("bOg6v")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-assets-reports-unsubscribe/src/CmdbAssetsReportsUnsubscribe.tsx"
});

const $90693170f8884dd8$export$c56cfef9aa68df09 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("fxHLE")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-assets-reports/src/CmdbAssetsReports.tsx"
});
const $90693170f8884dd8$export$d45b40d40442434 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $90693170f8884dd8$export$9f75cdfdfe8c8aaa,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
        shouldShowSpinner: true
    });
$90693170f8884dd8$export$d45b40d40442434.displayName = "AssetsReports";
const $90693170f8884dd8$export$541b39e6d5be07df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $90693170f8884dd8$export$dec85f15dd805ac4,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
        shouldShowSpinner: true
    });
$90693170f8884dd8$export$541b39e6d5be07df.displayName = "AssetsReportsUnsubscribe";
const $90693170f8884dd8$export$4155da54bfeacf74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $90693170f8884dd8$export$2534c3e9f8e70d0d,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
        shouldShowSpinner: true
    });
$90693170f8884dd8$export$4155da54bfeacf74.displayName = "AssetsReportingDefaultRedirect";
const $90693170f8884dd8$export$9d28551695f98cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $90693170f8884dd8$export$c56cfef9aa68df09,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
        shouldShowSpinner: true
    });
$90693170f8884dd8$export$9d28551695f98cae.displayName = "AssetsReportsNav4HomePage";

});
parcelRegister("fxHLE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("d3tBx")),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jFIi5")
]).then(()=>parcelRequire('2JgE7'));

});

parcelRegister("bOg6v", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("lo1HR")),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("lnB8w")
]).then(()=>parcelRequire('e6MSs'));

});



parcelRegister("8UPVQ", function(module, exports) {
$parcel$export(module.exports, "assetsReportsUnsubscribeRouteEntry", () => $83e1fc93327c1b2e$export$25e4df4267166d6b);

var $6BfVx = parcelRequire("6BfVx");

var $8Nj8R = parcelRequire("8Nj8R");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74pRM = parcelRequire("74pRM");

var $6pofw = parcelRequire("6pofw");

var $dTa0V = parcelRequire("dTa0V");

var $1UBSs = parcelRequire("1UBSs");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $83e1fc93327c1b2e$var$assetsReportsUnsubscribePageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $8Nj8R.assetsReportsUnsubscribeEntryPoint)
});
const $83e1fc93327c1b2e$export$25e4df4267166d6b = (0, $fdS54.createEntry)((0, $74pRM.assetsReportsUnsubscribeRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$83e1fc93327c1b2e$var$assetsReportsUnsubscribePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8Nj8R", function(module, exports) {
$parcel$export(module.exports, "assetsReportsUnsubscribeEntryPoint", () => $2383332b414d276d$export$d827c87e65bb6e47);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $2383332b414d276d$export$d827c87e65bb6e47 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bOg6v")), {
        moduleId: "a1d13fad",
        moduleName: "CmdbAssetsReportsUnsubscribe",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});

parcelRegister("74pRM", function(module, exports) {
$parcel$export(module.exports, "assetsReportsUnsubscribeRoute", () => $375b41f4f85bbbb5$export$2b543c10e2c9e843);
const $375b41f4f85bbbb5$export$2b543c10e2c9e843 = {
    name: 'assets-reports-unsubscribe',
    path: '/jira/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("fjjEb", function(module, exports) {
$parcel$export(module.exports, "assetsRouteEntry", () => $3aed877d65d531a1$export$7069f3fb497264f1);

var $6BfVx = parcelRequire("6BfVx");

var $6jBN6 = parcelRequire("6jBN6");

var $fdS54 = parcelRequire("fdS54");

var $5Yd12 = parcelRequire("5Yd12");

var $1UBSs = parcelRequire("1UBSs");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");

var $jepRN = parcelRequire("jepRN");

var $i860n = parcelRequire("i860n");

var $jbFsN = parcelRequire("jbFsN");
const $3aed877d65d531a1$var$assetsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $6jBN6.landingPageEntryPoint)
});
const $3aed877d65d531a1$export$7069f3fb497264f1 = (0, $fdS54.createEntry)((0, $5Yd12.assetsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        // Use component for conditional redirect when feature gate is enabled
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jepRN.componentWithFG)('assets_for_you', (0, $jbFsN.ConditionalAssetsPage), ()=>null),
        // Only use entryPoint when feature gate is disabled
        entryPoint: ()=>(0, $i860n.fg)('assets_for_you') ? undefined : $3aed877d65d531a1$var$assetsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-landing-page',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
        ufoName: 'assets-app-schemas-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6jBN6", function(module, exports) {
$parcel$export(module.exports, "landingPageEntryPoint", () => $c1d4315c6b277e3e$export$36d88a15c123c06);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $c1d4315c6b277e3e$export$36d88a15c123c06 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("jCEgN")), {
        moduleId: "1a6b1bd4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jCEgN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1F7BK").then(()=>parcelRequire('43axF'));

});


parcelRegister("5Yd12", function(module, exports) {
$parcel$export(module.exports, "assetsRoute", () => $d9f75dddd0fd045c$export$70dab2ea29192797);
const $d9f75dddd0fd045c$export$70dab2ea29192797 = {
    name: 'assets',
    path: '/jira/assets',
    exact: true
};

});

parcelRegister("jbFsN", function(module, exports) {
$parcel$export(module.exports, "ConditionalAssetsPage", () => $80670cb9e7bfb94c$export$a0f76a00c20afc20);

var $euxye = parcelRequire("euxye");

var $bOYO0 = parcelRequire("bOYO0");

var $i860n = parcelRequire("i860n");

var $zbgUa = parcelRequire("zbgUa");

var $dLVGe = parcelRequire("dLVGe");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $jhKsF = parcelRequire("jhKsF");

const $80670cb9e7bfb94c$var$LazyAssetsLandingPage = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("jCEgN"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-landing-page/src/index.tsx"
});
// This component will redirect users from /jira/assets to /jira/assets/for-you
// ScreenRedirect triggers a redirect ui event so we don't need to fire a manual operational event
// We can remove this component once the feature is fully rolled out and frequency of the operational event is 0
const $80670cb9e7bfb94c$var$AssetsForYouRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/assets/for-you"
    });
$80670cb9e7bfb94c$var$AssetsForYouRedirect.displayName = "AssetsForYouRedirect";
const $80670cb9e7bfb94c$export$a0f76a00c20afc20 = ()=>{
    const assetsTenantContext = (0, $zbgUa.useAssetsTenantContext)();
    const hasAssetsEntitlementEnabled = (0, $i860n.fg)('assets_for_you') && (0, $bOYO0.hasAssetsEntitlement)(assetsTenantContext);
    return hasAssetsEntitlementEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($80670cb9e7bfb94c$var$AssetsForYouRedirect, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $80670cb9e7bfb94c$var$LazyAssetsLandingPage,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: false
    });
};
$80670cb9e7bfb94c$export$a0f76a00c20afc20.displayName = "ConditionalAssetsPage";

});
parcelRegister("zbgUa", function(module, exports) {
$parcel$export(module.exports, "useAssetsTenantContext", () => $23aaf6244856386e$export$62e5cc6bee801405);
$parcel$export(module.exports, "useAssetsIsAdmin", () => $23aaf6244856386e$export$b9c4a86cf61f47ec);
$parcel$export(module.exports, "useAssetsIsSiteAdmin", () => $23aaf6244856386e$export$915edea0d2f62b4f);


var $7nWmb = parcelRequire("7nWmb");

var $eijVy = parcelRequire("eijVy");

var $i860n = parcelRequire("i860n");
const $23aaf6244856386e$export$62e5cc6bee801405 = ()=>{
    const [{ tenantContext: tenantContext }] = (0, $eijVy.useTenantContextHook)();
    const { isAssetsAdmin: isAssetsAdmin, isLicensedAssetsUser: isLicensedAssetsUser } = (0, $7nWmb.useAssetsUserPermission)();
    const hasAssetsEntitlement = tenantContext.licensedProducts && tenantContext.licensedProducts[0, $eb8cfa569eede1a9$export$a310f85340477585];
    // Override admin permissions with Assets-specific role when feature gate is enabled
    if (hasAssetsEntitlement && (0, $i860n.fg)('aurum-997-license-kill-switch')) return {
        ...tenantContext,
        isAdmin: !!isAssetsAdmin,
        isSiteAdmin: !!isAssetsAdmin,
        isLicensedAssetsUser: !!isLicensedAssetsUser
    };
    return tenantContext;
};
const $23aaf6244856386e$export$b9c4a86cf61f47ec = ()=>{
    const tenantContext = $23aaf6244856386e$export$62e5cc6bee801405();
    return tenantContext?.isAdmin ?? false;
};
const $23aaf6244856386e$export$915edea0d2f62b4f = ()=>{
    const tenantContext = $23aaf6244856386e$export$62e5cc6bee801405();
    return tenantContext?.isSiteAdmin ?? false;
};

});



parcelRegister("cN9Dp", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaConfigurationRouteEntry", () => $401962946ca5ce8b$export$6c9c29c3048f2e2c);

var $6BfVx = parcelRequire("6BfVx");

var $o22Kz = parcelRequire("o22Kz");

var $oaWSh = parcelRequire("oaWSh");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $4lLno = parcelRequire("4lLno");

var $1UBSs = parcelRequire("1UBSs");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $401962946ca5ce8b$var$assetsSchemaSettingsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $o22Kz.assetsSchemaSettingsEntryPoint)
});
const $401962946ca5ce8b$export$6c9c29c3048f2e2c = (0, $fdS54.createEntry)((0, $4lLno.assetsSchemaConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$401962946ca5ce8b$var$assetsSchemaSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema-configuration',
        resources: [
            ...(0, $1UBSs.getAssetsAppResources)(),
            (0, $oaWSh.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("o22Kz", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaSettingsEntryPoint", () => $627b58d4f55c97b7$export$b012e15a5f6394fc);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $627b58d4f55c97b7$export$b012e15a5f6394fc = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8vihT")), {
        moduleId: "77194817",
        moduleName: "ConditionalRedirectOrRouteView",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8vihT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("60xVs").then(()=>parcelRequire('8Jgay'));

});


parcelRegister("oaWSh", function(module, exports) {
$parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", () => $60e71ed491d0d84f$export$58d2462746e91c7d);

var $7edbf = parcelRequire("7edbf");

const $60e71ed491d0d84f$export$58d2462746e91c7d = (0, $7edbf.createResource)({
    type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
    getKey: ()=>'extensions',
    getDataLoader: ()=>(parcelRequire("l13eG")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("l13eG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1tBni").then(()=>parcelRequire('8MUpQ'));

});


parcelRegister("4lLno", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaConfigurationRoute", () => $eafcfda6d2a5799b$export$f27e51e1e8d78f80);
const $eafcfda6d2a5799b$export$f27e51e1e8d78f80 = {
    name: 'assets-schema-configuration',
    path: '/jira/assets/configure/object-schema/:objectSchemaId'
};

});


parcelRegister("1ImkA", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaRouteEntry", () => $88587b26910e2c8f$export$92c5054123a75324);

var $6BfVx = parcelRequire("6BfVx");

var $glBr3 = parcelRequire("glBr3");

var $fdS54 = parcelRequire("fdS54");

var $3yVLG = parcelRequire("3yVLG");

var $1UBSs = parcelRequire("1UBSs");

var $cioaX = parcelRequire("cioaX");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $88587b26910e2c8f$var$assetsSchemaPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $glBr3.assetsSchemaEntryPoint)
});
const $88587b26910e2c8f$export$92c5054123a75324 = (0, $fdS54.createEntry)((0, $3yVLG.assetsSchemaRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cioaX.ObjectSchemaV2),
        entryPoint: ()=>$88587b26910e2c8f$var$assetsSchemaPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("glBr3", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaEntryPoint", () => $fbedc6e25598204a$export$bbb96f529694d699);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $fbedc6e25598204a$export$bbb96f529694d699 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("3kb7A")), {
        moduleId: "d7618e92",
        moduleName: "ConditionalRedirectOrRouteView",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3kb7A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gHRxW")
]).then(()=>parcelRequire('7ylVN'));

});


parcelRegister("3yVLG", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaRoute", () => $60bdb16041bce2ba$export$9515b8d2f9c8b12d);
const $60bdb16041bce2ba$export$9515b8d2f9c8b12d = {
    name: 'assets-schema',
    path: '/jira/assets/object-schema/:objectSchemaId'
};

});

parcelRegister("cioaX", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaV2", () => $bcf932ada2bb901b$export$1e50d5a65ac4f5fc);
$parcel$export(module.exports, "ObjectSchemaV2", () => $bcf932ada2bb901b$export$f90a4f33c79fd86e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $bcf932ada2bb901b$export$1e50d5a65ac4f5fc = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("3kb7A")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-object-schema-v2/src/ConditionalRedirectOrRouteView.tsx"
});
const $bcf932ada2bb901b$export$f90a4f33c79fd86e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $bcf932ada2bb901b$export$1e50d5a65ac4f5fc,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
        shouldShowSpinner: true
    });
$bcf932ada2bb901b$export$f90a4f33c79fd86e.displayName = "ObjectSchemaV2";
var $bcf932ada2bb901b$export$2e2bcd8739ae039 = $bcf932ada2bb901b$export$f90a4f33c79fd86e;

});


parcelRegister("adRjZ", function(module, exports) {
$parcel$export(module.exports, "assetsSchemasRouteEntry", () => $f3064c53a4c3404e$export$7b81f13129f1add7);

var $6BfVx = parcelRequire("6BfVx");

var $6jBN6 = parcelRequire("6jBN6");

var $fdS54 = parcelRequire("fdS54");

var $6GKPv = parcelRequire("6GKPv");

var $1UBSs = parcelRequire("1UBSs");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $dD11h = parcelRequire("dD11h");
const $f3064c53a4c3404e$var$assetsPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $6jBN6.landingPageEntryPoint)
});
const $f3064c53a4c3404e$export$7b81f13129f1add7 = (0, $fdS54.createEntry)((0, $6GKPv.assetsSchemasRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$f3064c53a4c3404e$var$assetsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-landing-page',
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        perfMetricKey: 'assets-app-schemas-page',
        ufoName: 'assets-app-schemas-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6GKPv", function(module, exports) {
$parcel$export(module.exports, "assetsSchemasRoute", () => $693622cd637e9058$export$326987eddbe389c4);
const $693622cd637e9058$export$326987eddbe389c4 = {
    name: 'assets',
    path: '/jira/assets/schemas',
    exact: true
};

});


parcelRegister("bycrh", function(module, exports) {
$parcel$export(module.exports, "assetsSearchRouteEntry", () => $eae8d679ac547407$export$2a3cf8cc5b9b7e6);

var $6BfVx = parcelRequire("6BfVx");

var $fdS54 = parcelRequire("fdS54");

var $1UBSs = parcelRequire("1UBSs");

var $dTa0V = parcelRequire("dTa0V");

var $bL4Rw = parcelRequire("bL4Rw");

var $50LAm = parcelRequire("50LAm");

var $4EI3Z = parcelRequire("4EI3Z");

var $dD11h = parcelRequire("dD11h");
const $eae8d679ac547407$var$assetsSearchPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $4EI3Z.assetsSearchEntryPoint)
});
const $eae8d679ac547407$export$2a3cf8cc5b9b7e6 = (0, $fdS54.createEntry)((0, $50LAm.assetsSearchRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $bL4Rw.AssetsLayout),
        PageConfigContainerOverride: (0, $dD11h.AssetsPageConfigContainer),
        skeleton: (0, $6BfVx.default),
        entryPoint: ()=>$eae8d679ac547407$var$assetsSearchPageEntryPoint,
        resources: (0, $1UBSs.getAssetsAppResources)(),
        forPaint: [
            (0, $bL4Rw.LazyAssetsLayout)
        ],
        perfMetricKey: 'assets-app.interact-with-search-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("50LAm", function(module, exports) {
$parcel$export(module.exports, "assetsSearchRoute", () => $ccf7f18f7af3a19d$export$6d41f99fb1a055c0);
const $ccf7f18f7af3a19d$export$6d41f99fb1a055c0 = {
    name: 'assets-search-results',
    path: '/jira/assets/search',
    exact: true
};

});

parcelRegister("4EI3Z", function(module, exports) {
$parcel$export(module.exports, "assetsSearchEntryPoint", () => $4836131f5f8bc361$export$5752b60b3fc851fc);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $4836131f5f8bc361$export$5752b60b3fc851fc = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("h5Dnc")), {
        moduleId: "4e35174d",
        moduleName: "AssetsAppSearchEntrypointWrapper",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("h5Dnc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("5qC72"),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("VVJmS")
]).then(()=>parcelRequire('dzpzx'));

});



parcelRegister("jJYmM", function(module, exports) {
$parcel$export(module.exports, "availabilityRouteEntry", () => $da21139fb7551991$export$66ba5d6d0cf200c8);

var $32vup = parcelRequire("32vup");

var $7CXOf = parcelRequire("7CXOf");

var $dJpts = parcelRequire("dJpts");


var $co13a = parcelRequire("co13a");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $6pofw = parcelRequire("6pofw");
const $da21139fb7551991$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $da21139fb7551991$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $32vup.availabilityEntryPoint)
});
const $da21139fb7551991$export$66ba5d6d0cf200c8 = (0, $fdS54.createEntry)((0, $7CXOf.availabilityRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        skeleton: (0, $dJpts.PageSkeleton),
        ufoName: 'jsm-availability',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        resources: [
            (0, $co13a.routingOnboardingFinishedResource),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>{
            if (!$da21139fb7551991$var$isWorkforceAemEnabled() || !(0, $i860n.fg)('jsm_workforce_optimization_main')) return undefined;
            return $da21139fb7551991$var$entryPoint;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).AVAILABILITY,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).AVAILABILITY),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("32vup", function(module, exports) {
$parcel$export(module.exports, "availabilityEntryPoint", () => $247d496a25dcb448$export$5e9572601ae413b8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $gkyRI = parcelRequire("gkyRI");

const $247d496a25dcb448$export$5e9572601ae413b8 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aFDpZ")), {
        moduleId: "0a600080",
        moduleName: "AvailabilityPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = match.params.projectKey ?? '';
        return {
            queries: {
                availabilityPageQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $gkyRI.default,
                    variables: {
                        input: {
                            cloudId: cloudId,
                            projectKey: projectKey,
                            teamARIs: [],
                            agentIds: [],
                            statuses: []
                        },
                        isInitialFetch: true
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
    }
});

});
parcelRegister("gkyRI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a368c2dd560f1216$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4fff563112aca03e5a02a0d8e1aab78c>>
 * @relayHash f012cd6ea0b0e97d790644cd592d7ac5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd7f958d60d0b22d9dded72d13f42c04a9a523af970e1888881c582d046ce936
const $a368c2dd560f1216$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bd7f958d60d0b22d9dded72d13f42c04a9a523af970e1888881c582d046ce936",
        "metadata": {},
        "name": "AvailabilityPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a368c2dd560f1216$export$2e2bcd8739ae039 = $a368c2dd560f1216$var$node;

});

parcelRegister("aFDpZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("fmWTY")
]).then(()=>parcelRequire('goADr'));

});


parcelRegister("7CXOf", function(module, exports) {
$parcel$export(module.exports, "availabilityRoute", () => $4445e0eb9f1ac16c$export$dfa9b4d1312f0994);
const $4445e0eb9f1ac16c$export$dfa9b4d1312f0994 = {
    name: 'servicedesk-availability',
    path: '/jira/servicedesk/projects/:projectKey/availability',
    exact: true
};

});

parcelRegister("dJpts", function(module, exports) {
$parcel$export(module.exports, "PageSkeleton", () => $24fcb6fb1926e965$export$6d7d475dd49a348);
/* PageSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $fUquz = parcelRequire("fUquz");

var $3NRLa = parcelRequire("3NRLa");

var $2XXtG = parcelRequire("2XXtG");

var $ihEDU = parcelRequire("ihEDU");
const $24fcb6fb1926e965$var$styles = {
    container: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    contentContainer: "_19pkoahv"
};
const $24fcb6fb1926e965$export$6d7d475dd49a348 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $24fcb6fb1926e965$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "29px",
        width: "200px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $24fcb6fb1926e965$var$styles.contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fUquz.AvailabilityPageSkeleton), null)));
$24fcb6fb1926e965$export$6d7d475dd49a348.displayName = "PageSkeleton";

});
parcelRegister("fUquz", function(module, exports) {
$parcel$export(module.exports, "AvailabilityPageSkeleton", () => $41b0675dd5d2faf9$export$35422c6e8b480efa);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $3PC9r = parcelRequire("3PC9r");

var $defJG = parcelRequire("defJG");

var $3NRLa = parcelRequire("3NRLa");

var $apUrw = parcelRequire("apUrw");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $tzzBm = parcelRequire("tzzBm");
const $41b0675dd5d2faf9$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-availability.page-skeleton.loading",
    defaultMessage: "Loading availability"
});
const $41b0675dd5d2faf9$export$35422c6e8b480efa = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.400",
        testId: "availability.ui.availability-page-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $apUrw.default), null, formatMessage($41b0675dd5d2faf9$var$loadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "64px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "64px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "64px",
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "35px",
        width: "308px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $tzzBm.AvailableAgentsTableSkeleton), {
        rowCount: 5
    }));
};
$41b0675dd5d2faf9$export$35422c6e8b480efa.displayName = "AvailabilityPageSkeleton";

});
parcelRegister("tzzBm", function(module, exports) {
$parcel$export(module.exports, "AvailableAgentsTableSkeleton", () => $a2251de52d4f3551$export$6581d25e3de87ecb);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $3PC9r = parcelRequire("3PC9r");

var $3NRLa = parcelRequire("3NRLa");

var $apUrw = parcelRequire("apUrw");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $a2251de52d4f3551$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-availability.agents-table-skeleton.loading",
    defaultMessage: "Loading agents"
});
const $a2251de52d4f3551$export$6581d25e3de87ecb = ({ rowCount: rowCount = 6 })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.300",
        testId: "availability.ui.available-agents-table.agents-table-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $apUrw.default), null, formatMessage($a2251de52d4f3551$var$loadingMessage)), Array.from({
        length: rowCount
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            key: index,
            height: "64px",
            width: "100%"
        })));
};
$a2251de52d4f3551$export$6581d25e3de87ecb.displayName = "AvailableAgentsTableSkeleton";

});



parcelRegister("co13a", function(module, exports) {
$parcel$export(module.exports, "routingSetupStatusResource", () => $f0301a7fe10cb69e$export$d7d503ea623fda7d);
$parcel$export(module.exports, "routingOnboardingFinishedResource", () => $f0301a7fe10cb69e$export$2385455487e09260);
$parcel$export(module.exports, "connectTeamsGlobalGroupsResource", () => $f0301a7fe10cb69e$export$d5d701b248f91ca5);

var $7edbf = parcelRequire("7edbf");
const $f0301a7fe10cb69e$export$4d3d031a83a0d985 = 'ROUTING_SETUP_STATUS';
const $f0301a7fe10cb69e$export$8f711a5942f03c30 = 'ROUTING_ONBOARDING_FINISHED';
const $f0301a7fe10cb69e$export$be25cbe04e8f2128 = 'CONNECT_TEAMS_GLOBAL_GROUPS_WFO';
const $f0301a7fe10cb69e$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';

const $f0301a7fe10cb69e$export$d7d503ea623fda7d = (0, $7edbf.createResource)({
    type: $f0301a7fe10cb69e$export$4d3d031a83a0d985,
    getKey: $f0301a7fe10cb69e$var$getKey,
    getDataLoader: ()=>(parcelRequire("f73tW")),
    maxAge: 0
});

const $f0301a7fe10cb69e$export$2385455487e09260 = (0, $7edbf.createResource)({
    type: $f0301a7fe10cb69e$export$8f711a5942f03c30,
    getKey: $f0301a7fe10cb69e$var$getKey,
    getDataLoader: ()=>(parcelRequire("lb8Ma")),
    maxAge: 0
});

const $f0301a7fe10cb69e$export$d5d701b248f91ca5 = (0, $7edbf.createResource)({
    type: $f0301a7fe10cb69e$export$be25cbe04e8f2128,
    getKey: $f0301a7fe10cb69e$var$getKey,
    getDataLoader: ()=>(parcelRequire("lTsBy")),
    maxAge: 0
});

});
parcelRegister("f73tW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kqGJG").then(()=>parcelRequire('12jEb'));

});

parcelRegister("lb8Ma", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("koOna").then(()=>parcelRequire('8KYN0'));

});

parcelRegister("lTsBy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("590Ho").then(()=>parcelRequire('04j5G'));

});



parcelRegister("abM4d", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRedirectRouteEntry", () => $60c75732b752b425$export$2a34d21ecf479c40);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $dujtx = parcelRequire("dujtx");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $5ICnz = parcelRequire("5ICnz");

var $dLVGe = parcelRequire("dLVGe");

var $85jAF = parcelRequire("85jAF");

var $lnXlF = parcelRequire("lnXlF");
const $60c75732b752b425$var$BoardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/boards"
    });
$60c75732b752b425$var$BoardsDirectoryRedirect.displayName = "BoardsDirectoryRedirect";
const $60c75732b752b425$export$2a34d21ecf479c40 = (0, $fdS54.createEntry)((0, $5ICnz.boardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        // eslint-disable-next-line no-restricted-syntax
        component: $60c75732b752b425$var$BoardsDirectoryRedirect,
        skeleton: (0, $85jAF.BoardsDirectorySkeleton),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $dujtx.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lnXlF.LazyBoardsDirectory)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dujtx", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryResource", () => $0ccd11fa796c400c$export$2646f173fa2c14f2);

var $7edbf = parcelRequire("7edbf");
const $0ccd11fa796c400c$var$MIN_MAX_AGE = 5000;
const $0ccd11fa796c400c$var$RESOURCE_TYPE_BOARDS_DIRECTORY = 'BOARDS_DIRECTORY';

const $0ccd11fa796c400c$export$2646f173fa2c14f2 = (0, $7edbf.createResource)({
    type: $0ccd11fa796c400c$var$RESOURCE_TYPE_BOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("lI5EZ")),
    maxAge: $0ccd11fa796c400c$var$MIN_MAX_AGE
});

});
parcelRegister("lI5EZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5nGeq").then(()=>parcelRequire('7Xb8r'));

});


parcelRegister("5ICnz", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $faeefb6b68564ed7$export$a4fba1ebd6ba91ee);
const $faeefb6b68564ed7$export$a4fba1ebd6ba91ee = {
    name: 'boards-directory-redirect',
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("85jAF", function(module, exports) {
$parcel$export(module.exports, "BoardsDirectorySkeleton", () => $65cfc4d61a3bd104$export$8194d6e87709f042);
$parcel$export(module.exports, "DashboardsDirectorySkeleton", () => $65cfc4d61a3bd104$export$75ef2bfed3801fb1);
$parcel$export(module.exports, "FiltersDirectorySkeleton", () => $65cfc4d61a3bd104$export$e76f94817327da1);
$parcel$export(module.exports, "ProjectsDirectorySkeleton", () => $65cfc4d61a3bd104$export$d94befb0e231760c);
$parcel$export(module.exports, "PlansDirectorySkeleton", () => $65cfc4d61a3bd104$export$6cd26a09efd6d158);

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $cKxap = parcelRequire("cKxap");

var $bCzPV = parcelRequire("bCzPV");

var $lsZDN = parcelRequire("lsZDN");

var $7uqxJ = parcelRequire("7uqxJ");
const $65cfc4d61a3bd104$export$8194d6e87709f042 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cKxap)))
    });
$65cfc4d61a3bd104$export$8194d6e87709f042.displayName = "BoardsDirectorySkeleton";
const $65cfc4d61a3bd104$export$75ef2bfed3801fb1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bCzPV)))
    });
$65cfc4d61a3bd104$export$75ef2bfed3801fb1.displayName = "DashboardsDirectorySkeleton";
const $65cfc4d61a3bd104$export$e76f94817327da1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lsZDN)))
    });
$65cfc4d61a3bd104$export$e76f94817327da1.displayName = "FiltersDirectorySkeleton";
const $65cfc4d61a3bd104$export$d94befb0e231760c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7uqxJ)))
    });
$65cfc4d61a3bd104$export$d94befb0e231760c.displayName = "ProjectsDirectorySkeleton";
const $65cfc4d61a3bd104$export$6cd26a09efd6d158 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7uqxJ)))
    });
$65cfc4d61a3bd104$export$6cd26a09efd6d158.displayName = "PlansDirectorySkeleton";

});
parcelRegister("cKxap", function(module, exports) {
module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();

});

parcelRegister("bCzPV", function(module, exports) {
module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();

});

parcelRegister("lsZDN", function(module, exports) {
module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();

});

parcelRegister("7uqxJ", function(module, exports) {
module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();

});


parcelRegister("lnXlF", function(module, exports) {
$parcel$export(module.exports, "LazyBoardsDirectory", () => $1912e44f42f64c02$export$2826049ae45f4cd);
/* eslint-disable jira/naming/disallow-filenames */ 
var $jhKsF = parcelRequire("jhKsF");

var $l8G1z = parcelRequire("l8G1z");

const $1912e44f42f64c02$export$2826049ae45f4cd = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hs86D"))), {
    moduleId: "./src/packages/spa-apps/directories-boards/src/BoardsDirectoryType.tsx"
});

});
parcelRegister("hs86D", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("6L2VP")
]).then(()=>parcelRequire('49SSJ'));

});



parcelRegister("6Vpfk", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRouteEntry", () => $4a47c946103dd3f5$export$e78b34c999194638);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $dujtx = parcelRequire("dujtx");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $fxACG = parcelRequire("fxACG");

var $85jAF = parcelRequire("85jAF");

var $8bf4L = parcelRequire("8bf4L");

var $lnXlF = parcelRequire("lnXlF");
const $4a47c946103dd3f5$var$BoardsDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $lnXlF.LazyBoardsDirectory),
        pageId: "boards-directory",
        shouldShowSpinner: false
    });
$4a47c946103dd3f5$var$BoardsDirectoryComponent.displayName = "BoardsDirectoryComponent";
const $4a47c946103dd3f5$export$e78b34c999194638 = (0, $fdS54.createEntry)((0, $fxACG.boardsDirectoryRoute), ()=>({
        group: 'directories',
        // eslint-disable-next-line no-restricted-syntax
        component: $4a47c946103dd3f5$var$BoardsDirectoryComponent,
        skeleton: (0, $85jAF.BoardsDirectorySkeleton),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $dujtx.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lnXlF.LazyBoardsDirectory)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fxACG", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRoute", () => $aa14dbbbeaf6b0f5$export$f0fc6f4e8be87e85);
const $aa14dbbbeaf6b0f5$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});


parcelRegister("4B97A", function(module, exports) {
$parcel$export(module.exports, "browseConversationsRouteEntry", () => $997b42b5375836de$export$b81210c1c5fc2e86);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 
var $hi6Of = parcelRequire("hi6Of");



var $1zqmx = parcelRequire("1zqmx");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $6YTGM = parcelRequire("6YTGM");

var $74h93 = parcelRequire("74h93");

var $828yb = parcelRequire("828yb");

var $dTa0V = parcelRequire("dTa0V");

var $1lV4Z = parcelRequire("1lV4Z");
const $997b42b5375836de$var$browseConversationsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1zqmx.browseConversationsEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $997b42b5375836de$export$b81210c1c5fc2e86 = (0, $fdS54.createEntry)((0, $6YTGM.browseConversationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_sd_virtual_agent') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-virtual-service-agent') : (0, $l1vE2.isFedRamp)()) return undefined;
            return $997b42b5375836de$var$browseConversationsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1lV4Z.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $828yb.VirtualAgentBrowseConversationsSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hi6Of", function(module, exports) {
$parcel$export(module.exports, "userSegRedirectEntrypoint", () => $74f2dd6313801303$export$6d4ea918c982d275);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $1Ed6E = parcelRequire("1Ed6E");
const $74f2dd6313801303$var$fetchPolicy = 'store-or-network';
/**
 * Cookie name - inlined to avoid importing constants file
 */ const $74f2dd6313801303$var$USER_SEG_REDIRECT_CHECKED_COOKIE = 'user_seg_redirect_checked';
/**
 * Check if redirect check cookie exists in SSR.
 *
 * Note: globalThis.__GET_COOKIE__ is only available in SSR context.
 * Client-side checks are handled in the component itself.
 */ const $74f2dd6313801303$var$hasRedirectCheckCookie = ()=>{
    // Check if the global cookie reader is available (SSR or test environment)
    if (globalThis?.__GET_COOKIE__) {
        const cookie = globalThis.__GET_COOKIE__($74f2dd6313801303$var$USER_SEG_REDIRECT_CHECKED_COOKIE);
        return Boolean(cookie);
    }
    return false;
};

const $74f2dd6313801303$export$6d4ea918c982d275 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hvpjM")), {
        moduleId: "15389eb1",
        moduleName: "UserSegmentationRedirectEntry",
        priority: "userVisible",
        /* eslint-disable-line jira/entry-fs/restrict-shell-only-to-navigation-apps */ includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const shouldSkipQuery = !tenantContext.atlassianAccountId || tenantContext.isAnonymous;
        if (shouldSkipQuery) return {};
        const hasCookie = $74f2dd6313801303$var$hasRedirectCheckCookie();
        if (hasCookie) return {};
        return {
            queries: {
                userSegQueryRef: {
                    parameters: (0, $1Ed6E.default),
                    variables: {
                        accountId: tenantContext.atlassianAccountId || '',
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: $74f2dd6313801303$var$fetchPolicy
                    }
                }
            }
        };
    }
});

});
parcelRegister("1Ed6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5baaaafabbc895b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916730509a2c791ccf785e4193581425>>
 * @relayHash d91677b6bdf2827b223e02fa48634538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134
const $e5baaaafabbc895b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134",
        "metadata": {},
        "name": "UserSegmentationRedirectEntryQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e5baaaafabbc895b$export$2e2bcd8739ae039 = $e5baaaafabbc895b$var$node;

});

parcelRegister("hvpjM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("auwR4").then(()=>parcelRequire('hWh6t'));

});


parcelRegister("1zqmx", function(module, exports) {
$parcel$export(module.exports, "browseConversationsEntryPoint", () => $500de9a8a81e76c1$export$38549013d5d5a440);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $jz9FC = parcelRequire("jz9FC");
const $500de9a8a81e76c1$var$DEFAULT_RANGE_DAYS = 14;

const $500de9a8a81e76c1$export$38549013d5d5a440 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("a99ad")), {
        moduleId: "b529f6cc",
        moduleName: "VirtualAgentBrowseConversations",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const end = new Date();
        const start = new Date(end);
        start.setDate(start.getDate() - $500de9a8a81e76c1$var$DEFAULT_RANGE_DAYS);
        return {
            extraProps: {
                initialDateRange: {
                    start: start,
                    end: end
                }
            },
            queries: {
                page: {
                    parameters: (0, $jz9FC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: start.toISOString(),
                        endDate: end.toISOString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("jz9FC", function(module, exports) {
$parcel$export(module.exports, "default", () => $915db2c9a30d442e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b81c1ed69502d91f5c32c8ec8dde7d82>>
 * @relayHash b623d6a68af775224254c623c2270eb6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 85f0fbe5432a002b73e7c082a41ed92537fb4ffa9f1260ee0a46376e83c3a87d

var $gCce1 = parcelRequire("gCce1");

var $k49ny = parcelRequire("k49ny");
const $915db2c9a30d442e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "85f0fbe5432a002b73e7c082a41ed92537fb4ffa9f1260ee0a46376e83c3a87d",
        "metadata": {},
        "name": "VirtualAgentBrowseConversationsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisconversationfilterenabledrelayprovider": (0, $gCce1.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
        }
    }
};
var $915db2c9a30d442e$export$2e2bcd8739ae039 = $915db2c9a30d442e$var$node;

});
parcelRegister("gCce1", function(module, exports) {
$parcel$export(module.exports, "default", () => $715774b4d7a548a1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $715774b4d7a548a1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('expose_channels_on_va_conversation_history');
    }
};

});


parcelRegister("a99ad", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6WITz").then(()=>parcelRequire('15KXl'));

});


parcelRegister("828yb", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBrowseConversationsSkeleton", () => $72df3af797be2e91$export$4a6267fad85ca589);
/* VirtualAgentBrowseConversationsSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $1GXHz = parcelRequire("1GXHz");
const $72df3af797be2e91$var$customStyles = null;
const $72df3af797be2e91$export$4a6267fad85ca589 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1GXHz))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$72df3af797be2e91$export$4a6267fad85ca589.displayName = "VirtualAgentBrowseConversationsSkeleton";

});
parcelRegister("1GXHz", function(module, exports) {
module.exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();

});



parcelRegister("jKJAa", function(module, exports) {
$parcel$export(module.exports, "browseIntentsRouteEntry", () => $1442204516861ebf$export$da5f3658bd3ecdde);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 
var $hi6Of = parcelRequire("hi6Of");



var $fUKrX = parcelRequire("fUKrX");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $e4x7w = parcelRequire("e4x7w");

var $8yBjW = parcelRequire("8yBjW");

var $90x9Y = parcelRequire("90x9Y");

var $dTa0V = parcelRequire("dTa0V");

var $1lV4Z = parcelRequire("1lV4Z");
const $1442204516861ebf$var$browseIntentsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fUKrX.browseIntentsEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $1442204516861ebf$export$da5f3658bd3ecdde = (0, $fdS54.createEntry)((0, $e4x7w.browseIntentsRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_sd_virtual_agent') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-virtual-service-agent') : (0, $l1vE2.isFedRamp)()) return undefined;
            return $1442204516861ebf$var$browseIntentsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1lV4Z.FedRAMPFallbackRedirectToProjectSettings),
        layout: (0, $8yBjW.browseIntentsLayout),
        skeleton: (0, $90x9Y.VirtualAgentBrowseIntentsSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fUKrX", function(module, exports) {
$parcel$export(module.exports, "browseIntentsEntryPoint", () => $0562f4460a8cbedb$export$f19c213ae2d7940f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $htH5b = parcelRequire("htH5b");

var $eko0J = parcelRequire("eko0J");
// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent-intents-browse-intents/src/ui/index.tsx
const $0562f4460a8cbedb$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $0562f4460a8cbedb$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);

const $0562f4460a8cbedb$export$f19c213ae2d7940f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aeKlr")), {
        moduleId: "e17daf86",
        moduleName: "VirtualAgentBrowseIntents",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $htH5b.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                },
                statistics: {
                    parameters: (0, $eko0J.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $0562f4460a8cbedb$var$formatFetchDate(new Date(Date.now() - $0562f4460a8cbedb$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $0562f4460a8cbedb$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("htH5b", function(module, exports) {
$parcel$export(module.exports, "default", () => $f65189bbf04cae65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9226f9a019ace32038f08769c9f89f6>>
 * @relayHash 49ea5f3caca691e4994e2491a34dc854
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 558abe34c6e079bd8440ac718a3d49179f32b32d912a2f32804f66d056fc8dc6

var $k49ny = parcelRequire("k49ny");
const $f65189bbf04cae65$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "558abe34c6e079bd8440ac718a3d49179f32b32d912a2f32804f66d056fc8dc6",
        "metadata": {},
        "name": "VirtualAgentBrowseIntentsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
        }
    }
};
var $f65189bbf04cae65$export$2e2bcd8739ae039 = $f65189bbf04cae65$var$node;

});

parcelRegister("eko0J", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3a8a705fe1f40f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdcd0699770068cba5d2c9a58262e5e8>>
 * @relayHash ac94eaa66417782eeaa23f43a9b4c831
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d723f1c2c2c102b89a4e96a2bad4b2989a40182d73df128b31fd5bfbabb800f3

var $88pth = parcelRequire("88pth");
const $f3a8a705fe1f40f4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d723f1c2c2c102b89a4e96a2bad4b2989a40182d73df128b31fd5bfbabb800f3",
        "metadata": {},
        "name": "VirtualAgentBrowseIntents788BadPatternQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaenableperformancepagerelayprovider": (0, $88pth.default)
        }
    }
};
var $f3a8a705fe1f40f4$export$2e2bcd8739ae039 = $f3a8a705fe1f40f4$var$node;

});
parcelRegister("88pth", function(module, exports) {
$parcel$export(module.exports, "default", () => $15b4548050cae1c4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $15b4548050cae1c4$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jsm_va_enable_performance_page');
    }
};

});


parcelRegister("aeKlr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("kgp1I")
]).then(()=>parcelRequire('4fD3B'));

});


parcelRegister("8yBjW", function(module, exports) {
$parcel$export(module.exports, "browseIntentsLayout", () => $e0d51314cc5d7715$export$6659f41b213bad05);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $QhQu4 = parcelRequire("QhQu4");

var $74h93 = parcelRequire("74h93");

var $5VDmc = parcelRequire("5VDmc");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $e0d51314cc5d7715$var$withServiceProjectContext = (Component)=>(0, $QhQu4.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $f99M0.SERVICE_DESK_PROJECT)
        }
    });
const $e0d51314cc5d7715$export$6659f41b213bad05 = (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), {
    rightSidebars: [
        $e0d51314cc5d7715$var$withServiceProjectContext((0, $5VDmc.default))
    ]
});

});
parcelRegister("5VDmc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b82bbece809948bf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $413IC = parcelRequire("413IC");

var $2sr6Z = parcelRequire("2sr6Z");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $29eRG = parcelRequire("29eRG");

var $2b39L = parcelRequire("2b39L");

var $jA1Zs = parcelRequire("jA1Zs");

var $kt86l = parcelRequire("kt86l");

var $i860n = parcelRequire("i860n");
const $b82bbece809948bf$var$runtimeProps = {};
const $b82bbece809948bf$export$36ad24b9ac79bdc8 = ()=>{
    const rightSidebarCurrentState = (0, $29eRG.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId ?? '';
    const cloudId = (0, $kt86l.useCloudId)();
    const { data: projectContextData } = (0, $2b39L.useProjectContext)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            key: projectContextData?.projectKey ?? '',
            isHideIntentDiscoveryWhenVaNotConfiguredEnabled: (0, $i860n.fg)('hide_intent_discovery_copy_when_va_not_configured')
        }), [
        cloudId,
        projectContextData
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $413IC.virtualAgentCreateIntentTemplateSidebarEntryPoint), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (panelId === 'intentTemplate') entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        id: "createIntentTemplatesSidebar",
        packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jA1Zs.VirtualAgentIntentTemplateSidebarSkeleton), null),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b82bbece809948bf$var$SideBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2sr6Z.ErrorDisplay), {
                refetch: ()=>window.location.reload()
            })),
        runtimeProps: $b82bbece809948bf$var$runtimeProps
    });
};
$b82bbece809948bf$export$36ad24b9ac79bdc8.displayName = "IntentTemplatesSidebar";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b82bbece809948bf$var$SideBarWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1kl71uh4 _1e0c1txw _2lx21bp4 _bfhk1bhr _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
            __cmplp.className
        ])
    });
});
var $b82bbece809948bf$export$2e2bcd8739ae039 = $b82bbece809948bf$export$36ad24b9ac79bdc8;

});
parcelRegister("413IC", function(module, exports) {
$parcel$export(module.exports, "virtualAgentCreateIntentTemplateSidebarEntryPoint", () => $7cb94f50a67d888a$export$2b1d9dc27ee42f8f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $if3hV = parcelRequire("if3hV");

const $7cb94f50a67d888a$export$2b1d9dc27ee42f8f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("k9ZP8")), {
        moduleId: "3df7f1cf",
        moduleName: "CreateIntentTemplatesSideBar",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, key: key, isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled })=>({
            queries: {
                intentTemplateQueryReference: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: (0, $if3hV.default),
                    variables: {
                        cloudId: cloudId,
                        key: key,
                        isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("if3hV", function(module, exports) {
$parcel$export(module.exports, "default", () => $116915490d44fbdf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<41c111e5ceffa68f598d059560399728>>
 * @relayHash 37691a2ea664ea608db989394f721e35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 407f5fad955448e52028e8ed34ed859ba18b22105591ba90774abd111cde418c
const $116915490d44fbdf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "407f5fad955448e52028e8ed34ed859ba18b22105591ba90774abd111cde418c",
        "metadata": {},
        "name": "CreateIntentTemplatesSideBarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $116915490d44fbdf$export$2e2bcd8739ae039 = $116915490d44fbdf$var$node;

});

parcelRegister("k9ZP8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("dckqH")
]).then(()=>parcelRequire('59eKp'));

});


parcelRegister("2sr6Z", function(module, exports) {
$parcel$export(module.exports, "ErrorDisplay", () => $99a05b18669c924c$export$d56b0569bceb92ae);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4qNCE = parcelRequire("4qNCE");

var $j26jU = parcelRequire("j26jU");

var $42csL = parcelRequire("42csL");

var $l8Dej = parcelRequire("l8Dej");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $99a05b18669c924c$var$errorDisplayHeading = (0, $7eNDO.defineMessage)({
    id: "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
    defaultMessage: "We couldn\u2019t load intent templates"
});
const $99a05b18669c924c$var$errorDisplayDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
    defaultMessage: "Wait a moment and then try reloading."
});
const $99a05b18669c924c$var$reloadNowButtonText = (0, $7eNDO.defineMessage)({
    id: "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
    defaultMessage: "Reload"
});
const $99a05b18669c924c$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        header: formatMessage($99a05b18669c924c$var$errorDisplayHeading),
        description: formatMessage($99a05b18669c924c$var$errorDisplayDescription),
        renderImage: (0, $l8Dej.getAkEmptyStateRenderImageFn)((0, $42csL.default)),
        imageWidth: 160,
        maxImageHeight: 220,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
            onClick: refetch,
            appearance: "link"
        }, formatMessage($99a05b18669c924c$var$reloadNowButtonText))
    });
};
$99a05b18669c924c$export$d56b0569bceb92ae.displayName = "ErrorDisplay";

});
parcelRegister("42csL", function(module, exports) {
$parcel$export(module.exports, "default", () => $9627fb77508a82c8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("8rj41")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3I5X8")))));
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $gboXr = parcelRequire("gboXr");

var $3I5X8 = parcelRequire("3I5X8");

var $8rj41 = parcelRequire("8rj41");
const $9627fb77508a82c8$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8rj41)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3I5X8))
});
var $9627fb77508a82c8$export$2e2bcd8739ae039 = $9627fb77508a82c8$var$Illustration;
// for advanced use only
const $9627fb77508a82c8$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("gboXr", function(module, exports) {
$parcel$export(module.exports, "Illustration", () => $fb47eccb8a624dcd$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $fb47eccb8a624dcd$export$4d00e7be716a0093);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2Puum = parcelRequire("2Puum");
function $fb47eccb8a624dcd$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Puum.AsImg), props);
}
$fb47eccb8a624dcd$export$d43c2e2ca9b2c105.displayName = "Illustration";
function $fb47eccb8a624dcd$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fb47eccb8a624dcd$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("2Puum", function(module, exports) {
$parcel$export(module.exports, "AsImg", () => $5b9c62be954f5950$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4C7HL = parcelRequire("4C7HL");
// Moved to src/packages/illustrations/illustration/src/ui/types.tsx to avoid circular dependency
// export interface AsImgProps extends IllustrationProps, ImgHTMLAttributes<HTMLImageElement>
// suggested defaults, the consumer is free to override
const $5b9c62be954f5950$var$defaultStyles = null;
const $5b9c62be954f5950$var$fillStyles = null;
const $5b9c62be954f5950$var$autoDarkModeStyles = null;
function $5b9c62be954f5950$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    return /*#__PURE__*/ $euxye.createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $4jQY2.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}
$5b9c62be954f5950$export$75e378065cb7d6c0.displayName = "AsImg";

});


parcelRegister("3I5X8", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("8rj41", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("l8Dej", function(module, exports) {
$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $bbba4ff607b9e670$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
var $8w7Yz = parcelRequire("8w7Yz");

var $8Agip = parcelRequire("8Agip");
function $bbba4ff607b9e670$export$ebf64b9217c1b2a3(JiraIllustration = (0, $8Agip.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $8w7Yz.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $8w7Yz.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $4jQY2.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("8Agip", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6acedb2d5723b78$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3sUgu")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("kfedV")))));
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $gboXr = parcelRequire("gboXr");

var $kfedV = parcelRequire("kfedV");

var $3sUgu = parcelRequire("3sUgu");
const $a6acedb2d5723b78$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3sUgu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kfedV))
});
var $a6acedb2d5723b78$export$2e2bcd8739ae039 = $a6acedb2d5723b78$var$Illustration;
// for advanced use only
const $a6acedb2d5723b78$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("kfedV", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("3sUgu", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});




parcelRegister("7nEKi", function(module, exports) {
$parcel$export(module.exports, "JiraEntryPointContainer", () => $a49bf0b6664144c9$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $a49bf0b6664144c9$export$54db9e88249c9162);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3mLKJ = parcelRequire("3mLKJ");

var $4GGtd = parcelRequire("4GGtd");
const $a49bf0b6664144c9$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $3mLKJ.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4GGtd.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
$a49bf0b6664144c9$export$ee1e46af8fa2fb93.displayName = "JiraEntryPointContainer";
const $a49bf0b6664144c9$export$54db9e88249c9162 = (0, $4GGtd.InternalEntryPointContainer);

});
parcelRegister("3mLKJ", function(module, exports) {
$parcel$export(module.exports, "useEntryPointSubscription", () => $cf6048668b53fcac$export$3cd1c81e13390c49);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $cf6048668b53fcac$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $euxye.useState)(subject.getValue);
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed) return null;
    return entryPointReference;
};

});

parcelRegister("4GGtd", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $a92e47b19fd8ee37$export$5d4dc37edd8a3adb);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $i860n = parcelRequire("i860n");

var $aWliK = parcelRequire("aWliK");

var $a8EUd = parcelRequire("a8EUd");

var $gDdYI = parcelRequire("gDdYI");
const $a92e47b19fd8ee37$var$Placeholder = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('jfp_magma_jira-entrypoint-placeholder'), (0, $a8EUd.PlaceholderWithNativeSuspense), (0, $a8EUd.default));
const $a92e47b19fd8ee37$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a92e47b19fd8ee37$var$Placeholder, {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));
$a92e47b19fd8ee37$export$5d4dc37edd8a3adb.displayName = "InternalEntryPointContainer";

});


parcelRegister("jreC0", function(module, exports) {
$parcel$export(module.exports, "useEntryPoint", () => $92634ccd336c368d$export$338256068bc140fb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7Cd1x = parcelRequire("7Cd1x");

var $5be34 = parcelRequire("5be34");

var $khEzo = parcelRequire("khEzo");

var $6tFWc = parcelRequire("6tFWc");

var $36HtH = parcelRequire("36HtH");
const $92634ccd336c368d$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $5be34.DEFAULT_OPTIONS))=>{
    // TODO: break tests on instability (stableEntryPointParams!==entryPointParams)
    // prevents {} from from triggering updates
    const stableEntryPointParams = (0, $7Cd1x.useShallowStableReference)(entryPointParams);
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $6tFWc.useEntryPointLoadManager)(entryPoint, stableEntryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $36HtH.useMetricLogger)(metric);
    const entryPointActions = (0, $khEzo.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $euxye.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("7Cd1x", function(module, exports) {
$parcel$export(module.exports, "useShallowStableReference", () => $95ebc1209abcb44f$export$cb8a85c49e39f60);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* oxlint-disable @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions */ 
var $euxye = parcelRequire("euxye");

var $20zqf = parcelRequire("20zqf");
function $95ebc1209abcb44f$export$cb8a85c49e39f60(props, isEnabled = true) {
    const ref = (0, $euxye.useRef)(props);
    if (!isEnabled) return props;
    if (!(0, $20zqf.default)(props, ref.current)) ref.current = props;
    return ref.current;
}

});
parcelRegister("20zqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ba10175f38c2f63$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $b2vuq = parcelRequire("b2vuq");
/**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @jira/platform__utils-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ const $1ba10175f38c2f63$var$isShallowEqual = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $b2vuq.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $b2vuq.default)(value, nextValue);
    });
    return areValuesEqual;
};
var $1ba10175f38c2f63$export$2e2bcd8739ae039 = $1ba10175f38c2f63$var$isShallowEqual;

});
parcelRegister("b2vuq", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bbe75a77d93bb3f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Returns true if the two given arrays are equal one level deep
 */ const $9bbe75a77d93bb3f$var$isArrayEqual = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var $9bbe75a77d93bb3f$export$2e2bcd8739ae039 = $9bbe75a77d93bb3f$var$isArrayEqual;

});



parcelRegister("5be34", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $84c906ea774906fc$export$93ca5d3f8675ae4c);
/* eslint-disable jira/filename-case */ const $84c906ea774906fc$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    longerPreloadMaxAge: 10000,
    timeToIntent: 200
};

});

parcelRegister("khEzo", function(module, exports) {
$parcel$export(module.exports, "useEntryPointActions", () => $276bc151da7508dc$export$90681c8c3a56f09a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $k11SN = parcelRequire("k11SN");

var $i860n = parcelRequire("i860n");

var $5be34 = parcelRequire("5be34");
const $276bc151da7508dc$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $276bc151da7508dc$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $i860n.fg)('jira_relay_presist_entrypoint_preloaded_data') ? (0, $5be34.DEFAULT_OPTIONS).longerPreloadMaxAge : (0, $5be34.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $5be34.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $euxye.useRef)();
    const preloadMaxAgeTimeout = (0, $euxye.useRef)();
    const preloadLastRequested = (0, $euxye.useRef)(0);
    const cancelPreload = (0, $euxye.useCallback)(()=>{
        if (!(0, $k11SN.default)($276bc151da7508dc$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const updateLastRequested = (0, $euxye.useCallback)(()=>{
        preloadLastRequested.current = 0;
        preloadMaxAgeTimeout.current = undefined;
    }, []);
    const load = (0, $euxye.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-server-variable
        if (false && (0, $i860n.fg)('jfp_magma_jira-entrypoint-actions-load')) // prevent "unconnected" entrypoint loading at SSR
        return;
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        if ((0, $i860n.fg)('jira_relay_presist_entrypoint_preloaded_data') === false) updateLastRequested();
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric,
        updateLastRequested
    ]);
    const preload = (0, $euxye.useCallback)(()=>{
        if ((0, $k11SN.default)($276bc151da7508dc$var$PRELOAD_KILLSWITCH)) return;
        // eslint-disable-next-line jira/jira-ssr/no-server-variable
        if (false && (0, $i860n.fg)('jfp_magma_jira-entrypoint-actions-load')) // prevent "unconnected" entrypoint loading at SSR
        return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            if (typeof preloadMaxAgeTimeout.current === 'number' && preloadMaxAgeTimeout.current > 0 && (0, $i860n.fg)('jira_relay_presist_entrypoint_preloaded_data') === false) return;
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(updateLastRequested, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent,
        updateLastRequested
    ]);
    (0, $euxye.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $euxye.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("6tFWc", function(module, exports) {
$parcel$export(module.exports, "useEntryPointLoadManager", () => $ed9b010c457ebc62$export$bfae318f9651db2f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $55cpN = parcelRequire("55cpN");

var $9a6Rq = parcelRequire("9a6Rq");
const $ed9b010c457ebc62$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $55cpN.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $euxye.useRef)(true);
    const removeInactiveLoadsIdleCallback = (0, $euxye.useRef)(null);
    const entryPointReferenceQueue = (0, $euxye.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $9a6Rq.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $euxye.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        $ed9b010c457ebc62$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
        removeInactiveLoadsIdleCallback.current = $ed9b010c457ebc62$var$callWhenIdle(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $9a6Rq.removeAll)(currentQueue) : (0, $9a6Rq.removeInactiveLoads)(currentQueue);
        });
    }, [
        setEntryPointReference
    ]);
    const load = (0, $euxye.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $9a6Rq.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $euxye.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $euxye.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $euxye.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $ed9b010c457ebc62$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $9a6Rq.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    return {
        entryPointReferenceSubject: (0, $euxye.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $ed9b010c457ebc62$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $ed9b010c457ebc62$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("55cpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1d03da419c09832$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $c1d03da419c09832$export$83fb48644dee72f0);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $aI7em = parcelRequire("aI7em");
function $c1d03da419c09832$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.RelayEnvironmentProvider), {
        environment: (0, $aI7em.default)()
    }, children);
}
$c1d03da419c09832$export$2e2bcd8739ae039.displayName = "JiraRelayEnvironmentProvider";
function $c1d03da419c09832$export$83fb48644dee72f0() {
    const environment = (0, $n67Vb.useRelayEnvironment)();
    return (0, $euxye.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});

parcelRegister("9a6Rq", function(module, exports) {
$parcel$export(module.exports, "removeRedundantPreloads", () => $e07917a0e6c54571$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $e07917a0e6c54571$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $e07917a0e6c54571$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $e07917a0e6c54571$export$322c8997d351da6a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");
const $e07917a0e6c54571$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $e07917a0e6c54571$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $e07917a0e6c54571$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $e07917a0e6c54571$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $euxye.useRef)(null);
    const subscribers = (0, $euxye.useRef)();
    const unsub = (0, $euxye.useRef)(null);
    const subscribe = (0, $euxye.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $euxye.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $85XPu.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($e07917a0e6c54571$var$isReactAsyncJSResourceReference(entryPoint?.root)) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $euxye.useCallback)(()=>value.current, []);
    (0, $euxye.useEffect)(()=>()=>{
            subscribers.current?.clear();
            unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $e07917a0e6c54571$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("36HtH", function(module, exports) {
$parcel$export(module.exports, "useMetricLogger", () => $a17750490e9b3583$export$f291ec7cea728e1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $a17750490e9b3583$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $euxye.useRef)(0);
    const loadStartTime = (0, $euxye.useRef)(0);
    const startMetric = (0, $euxye.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $euxye.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("29eRG", function(module, exports) {
$parcel$export(module.exports, "useActiveRightSidebarState", () => $02f590659d9c8834$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $02f590659d9c8834$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $02f590659d9c8834$export$ebe5e907fb0bb63a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");

var $2ffUK = parcelRequire("2ffUK");

var $l0gQX = parcelRequire("l0gQX");

var $5IRCU = parcelRequire("5IRCU");

var $i860n = parcelRequire("i860n");

var $akbvy = parcelRequire("akbvy");

var $7Sa0x = parcelRequire("7Sa0x");
const $02f590659d9c8834$var$useActiveRightSidebar = (0, $3h1FP.createHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $akbvy.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $02f590659d9c8834$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $02f590659d9c8834$var$useActiveRightSidebar();
    return rightSidebar;
};
const $02f590659d9c8834$var$useRightSidebar = (0, $3h1FP.createHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $02f590659d9c8834$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $02f590659d9c8834$var$useRightSidebar();
    return rightSidebarState;
};
const $02f590659d9c8834$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebarAction, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $7Sa0x.useLayoutStoreActions)();
    let closePreviewPanel;
    let isIssuePreviewPanelOpen = false;
    let setSelectedIssue;
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $i860n.fg)('jira-glance-panel') && (0, $i860n.fg)('jira_preview_panel_m_1_rollout')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [, setSelectedIssueHook] = (0, $2ffUK.useQueryParam)('selectedIssue');
        setSelectedIssue = setSelectedIssueHook;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { close: close } = (0, $l0gQX.usePreviewPanelsActions)();
        closePreviewPanel = close;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const panel = (0, $5IRCU.useCurrentPreviewPanel)();
        isIssuePreviewPanelOpen = panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
    }
    const openRightSidebar = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $i860n.fg)('jira-glance-panel') && (0, $i860n.fg)('jira_preview_panel_m_1_rollout') ? (0, $euxye.useCallback)((panelId, width, isMinimised = false, toTop = false)=>{
        if (panelId !== 'jsw-nux-onboarding-checklist') {
            openRightSidebarAction(panelId, width, isMinimised, toTop);
            if (isIssuePreviewPanelOpen) setSelectedIssue?.(undefined);
            closePreviewPanel?.();
        } else if (!isIssuePreviewPanelOpen) openRightSidebarAction(panelId, width, isMinimised, toTop);
    }, [
        closePreviewPanel,
        isIssuePreviewPanelOpen,
        openRightSidebarAction,
        setSelectedIssue
    ]) : openRightSidebarAction;
    return (0, $euxye.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("akbvy", function(module, exports) {
$parcel$export(module.exports, "selectCurrentRightSidebar", () => $60c1a3d6dc91eb81$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $60c1a3d6dc91eb81$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $60c1a3d6dc91eb81$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $60c1a3d6dc91eb81$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $60c1a3d6dc91eb81$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $60c1a3d6dc91eb81$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $60c1a3d6dc91eb81$export$c8dafe074328c4ca);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bxhpq = parcelRequire("bxhpq");
const $60c1a3d6dc91eb81$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $60c1a3d6dc91eb81$var$dedupe = (stackState = [])=>{
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $60c1a3d6dc91eb81$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $60c1a3d6dc91eb81$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $60c1a3d6dc91eb81$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $60c1a3d6dc91eb81$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $60c1a3d6dc91eb81$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $60c1a3d6dc91eb81$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $60c1a3d6dc91eb81$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $60c1a3d6dc91eb81$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $60c1a3d6dc91eb81$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $60c1a3d6dc91eb81$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("7Sa0x", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $18e682326fd9e1ea$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $18e682326fd9e1ea$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $18e682326fd9e1ea$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $18e682326fd9e1ea$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $18e682326fd9e1ea$export$99e05a60cac05e86);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $4bMsU = parcelRequire("4bMsU");
const $18e682326fd9e1ea$export$539e68c09584883a = 240;
const $18e682326fd9e1ea$export$b92df8810d2fcd01 = 0;
const $18e682326fd9e1ea$export$47a4b4760f306fb9 = 400;
const $18e682326fd9e1ea$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $18e682326fd9e1ea$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false,
            hasUserPreference: false
        },
        rightSidebar: {
            stackState: []
        },
        previewPanel: {
            width: $18e682326fd9e1ea$export$47a4b4760f306fb9
        }
    }
};
const $18e682326fd9e1ea$export$b8cdfd44cddaf07 = (0, $5QDqc.createStore)({
    initialState: $18e682326fd9e1ea$var$initialState,
    actions: $4bMsU.actions,
    name: 'JiraLayoutStore'
});
const $18e682326fd9e1ea$export$6136bc3b9858cff4 = (0, $3h1FP.createHook)($18e682326fd9e1ea$export$b8cdfd44cddaf07, {
    selector: null
});
const $18e682326fd9e1ea$var$detailPanelWidthStore = (0, $5QDqc.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $18e682326fd9e1ea$export$95fd7b6da3b9bbb0 = (0, $3h1FP.createHook)($18e682326fd9e1ea$var$detailPanelWidthStore);
const $18e682326fd9e1ea$export$99e05a60cac05e86 = (0, $3h1FP.createActionsHook)($18e682326fd9e1ea$var$detailPanelWidthStore);

});
parcelRegister("4bMsU", function(module, exports) {
$parcel$export(module.exports, "actions", () => $ac0ad6e4ce29edb5$export$e324594224ef24da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gnA90 = parcelRequire("gnA90");

var $iWhfC = parcelRequire("iWhfC");

var $jA0hD = parcelRequire("jA0hD");

var $gYBPe = parcelRequire("gYBPe");

var $jD8ah = parcelRequire("jD8ah");

var $akbvy = parcelRequire("akbvy");

var $5ANac = parcelRequire("5ANac");
const $ac0ad6e4ce29edb5$export$e324594224ef24da = {
    setIsChromeless: // global
    $jA0hD.setIsChromeless,
    setIsFullscreen: $gYBPe.setIsFullscreen,
    showBanner: // banner
    $gnA90.showBanner,
    dismissCurrentBanner: $gnA90.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $jD8ah.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $akbvy.setRightSidebarState,
    openRightSidebar: $akbvy.openRightSidebar,
    closeRightSidebar: $akbvy.closeRightSidebar,
    closeAllRightSidebar: $akbvy.closeAllRightSidebar,
    closeCurrentRightSidebar: $akbvy.closeCurrentRightSidebar,
    minimiseRightSidebar: $akbvy.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $iWhfC.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $iWhfC.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $iWhfC.removeBottomRightCornerPortal,
    setPreviewPanelState: // preview panel
    $5ANac.setPreviewPanelState
};

});
parcelRegister("gnA90", function(module, exports) {
$parcel$export(module.exports, "showBanner", () => $f71505c918a25f03$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $f71505c918a25f03$export$a45bccc0cc9ac424);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f71505c918a25f03$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $f71505c918a25f03$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($f71505c918a25f03$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("iWhfC", function(module, exports) {
$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $0fbe60a5f74adecc$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $0fbe60a5f74adecc$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $0fbe60a5f74adecc$export$928bf7e228ce06d2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0fbe60a5f74adecc$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $0fbe60a5f74adecc$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $0fbe60a5f74adecc$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("jA0hD", function(module, exports) {
$parcel$export(module.exports, "setIsChromeless", () => $c60e39694e1c455b$export$1998c4816ad37edb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $c60e39694e1c455b$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("gYBPe", function(module, exports) {
$parcel$export(module.exports, "setIsFullscreen", () => $75f88d7c9d721973$export$9c73b2f282069160);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $75f88d7c9d721973$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("jD8ah", function(module, exports) {
$parcel$export(module.exports, "setLeftSidebarState", () => $3c4632f10e899c92$export$3e0fd2d894ef83c8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3c4632f10e899c92$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("5ANac", function(module, exports) {
$parcel$export(module.exports, "setPreviewPanelState", () => $96b35d5ff655cc72$export$ba6353031892dd17);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $96b35d5ff655cc72$export$ba6353031892dd17 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                previewPanel: {
                    ...content.previewPanel,
                    ...newState
                }
            }
        });
    };

});




parcelRegister("jA1Zs", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentIntentTemplateSidebarSkeleton", () => $b2310b4f4a19f61f$export$fa68b26760d5b66f);
/* VirtualAgentIntentTemplateSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $4Smoq = parcelRequire("4Smoq");
const $b2310b4f4a19f61f$var$customCssStyles = null;
const $b2310b4f4a19f61f$export$fa68b26760d5b66f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4Smoq))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$b2310b4f4a19f61f$export$fa68b26760d5b66f.displayName = "VirtualAgentIntentTemplateSidebarSkeleton";

});
parcelRegister("4Smoq", function(module, exports) {
module.exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();

});




parcelRegister("90x9Y", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", () => $cbced077a4badafa$export$444026e4d4f156e4);
$parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", () => $cbced077a4badafa$export$9dca41144a6398d2);
$parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", () => $cbced077a4badafa$export$538762e63d6466fe);
/* VirtualAgentStatisticsSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $a3S4g = parcelRequire("a3S4g");

var $hnNFg = parcelRequire("hnNFg");

var $9oZwi = parcelRequire("9oZwi");
const $cbced077a4badafa$var$customCssStyles = null;
const $cbced077a4badafa$export$444026e4d4f156e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a3S4g))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$cbced077a4badafa$export$444026e4d4f156e4.displayName = "VirtualAgentBrowseIntentsSkeleton";
const $cbced077a4badafa$export$9dca41144a6398d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hnNFg))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$cbced077a4badafa$export$9dca41144a6398d2.displayName = "VirtualAgentIntentsTableSkeleton";
const $cbced077a4badafa$export$538762e63d6466fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9oZwi))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$cbced077a4badafa$export$538762e63d6466fe.displayName = "VirtualAgentStatisticsSkeleton";

});
parcelRegister("a3S4g", function(module, exports) {
module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();

});

parcelRegister("hnNFg", function(module, exports) {
module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();

});

parcelRegister("9oZwi", function(module, exports) {
module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();

});



parcelRegister("9JJN0", function(module, exports) {
$parcel$export(module.exports, "browseIssueEmbedRouteEntry", () => $49a1abadd35679c2$export$e275b3ca0c6ccb5e);

var $8k8Iy = parcelRequire("8k8Iy");

var $jM84B = parcelRequire("jM84B");

var $jFwZ0 = parcelRequire("jFwZ0");

var $6jRoa = parcelRequire("6jRoa");

var $cEVzH = parcelRequire("cEVzH");

var $21fL1 = parcelRequire("21fL1");

var $bLDht = parcelRequire("bLDht");

var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $8ycTI = parcelRequire("8ycTI");


var $byMD7 = parcelRequire("byMD7");

var $3HYSN = parcelRequire("3HYSN");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $fBZs7 = parcelRequire("fBZs7");

var $lTgGU = parcelRequire("lTgGU");

var $dUAVJ = parcelRequire("dUAVJ");

var $4B518 = parcelRequire("4B518");

var $2KHOK = parcelRequire("2KHOK");

var $9KYmb = parcelRequire("9KYmb");

var $8HUuJ = parcelRequire("8HUuJ");

var $edf7u = parcelRequire("edf7u");

var $9dMXV = parcelRequire("9dMXV");

var $U9h5y = parcelRequire("U9h5y");

var $d1wnP = parcelRequire("d1wnP");

var $53xPq = parcelRequire("53xPq");

var $3e0pb = parcelRequire("3e0pb");

var $kI2ll = parcelRequire("kI2ll");

var $2pLyE = parcelRequire("2pLyE");

var $ldGfw = parcelRequire("ldGfw");

var $2700E = parcelRequire("2700E");

var $io0d5 = parcelRequire("io0d5");

var $lqVFL = parcelRequire("lqVFL");

var $gFj7m = parcelRequire("gFj7m");
const $49a1abadd35679c2$export$e275b3ca0c6ccb5e = (0, $fdS54.createEntry)((0, $2KHOK.browseIssueEmbedRoute), ()=>({
        isStrictModeEnabled: (0, $i860n.fg)('kenji-jira-incremental-strict-mode'),
        group: 'issue',
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        analyticsOptions: {
            // CMON-3192 [POC]: emit a SignalFx counter at SSR time for the viewIssue
            // experience (embed variant). Same experience name as the standalone route
            // so CMON aggregates both under "viewIssue".
            // Gate: jfp-cmon-task-start-issue-view controls emission at call site (multi-spa-route.tsx).
            taskStart: {
                experience: 'viewIssue'
            }
        },
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lqVFL.IssueEmbedComponent),
        skeleton: (0, $jM84B.IssueViewSkeleton),
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $dUAVJ.getModernIssueTransitionResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('remove-issueviewinteractivequery-m4'), (0, $lTgGU.issueGiraDataResource)),
            ...(0, $ldGfw.getIssueViewResources)(),
            (0, $fBZs7.issueViewRelayResource),
            (0, $8ycTI.workspaceResource),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('fix_subproduct_on_issue_embed_preview_panel'), // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            ...(0, $9KYmb.getDraftReplyPillsResource)(),
            (0, $9dMXV.projectGlobalComponentsResource),
            (0, $U9h5y.getJsmIssueViewSlaPanelResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_flash_ssr_major_incident_management_fields'), (0, $d1wnP.jsmMIMEntitlementResource)),
            (0, $U9h5y.getJsmIssueViewRelatedArticlesRouteResource)(),
            (0, $U9h5y.getJsmIssueViewPanelMetadataResource)(),
            (0, $2pLyE.issueSelectedTabDataResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $53xPq.issueCollapsibleGroupDataResource)),
            (0, $3e0pb.issueViewRemoteDataResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $2700E.expVal)('attachments-1p-consolidation-experiment', 'isExperimentEnabled', false), (0, $kI2ll.issueViewResourcesDataResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jira-issue-view-3p-attachments'), (0, $8k8Iy.thirdPartyConnectedDataSourceResource)),
            (0, $jFwZ0.currentUserResource),
            (0, $6jRoa.loomPermissionResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jpx-833-smart-links-graphql-provider'), (0, $io0d5.issueDescriptionSmartlinkDataResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('fg-perf-issue-view-confluence-menu-optimisation'), (0, $cEVzH.confluenceUserPermissionsResource)),
            (0, $8HUuJ.resourceWithCondition)((0, $21fL1.isJsmChatOpsEntitlementResourceEnabled), (0, $bLDht.jsmChatOpsEntitlementResource))
        ],
        forPaint: [
            (0, $lqVFL.LazyIssuePage)
        ],
        ufoName: 'issue-view-embed',
        fallbackExperience: 'viewIssue',
        meta: {
            capability: (0, $0ce01f968965dadd$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            manifestName: 'jira-spa-issue-view.json',
            redirects: [
                {
                    key: 'issue-project-context-redirect',
                    timeoutMs: 1000,
                    handler: ({ match: match, url: url, tenantContext: tenantContext })=>(0, $gFj7m.bifrostBrowseRouteRedirectionHandler)({
                            match: match,
                            url: url,
                            tenantContext: tenantContext,
                            isEmbed: true
                        })
                }
            ]
        },
        supportsPreviewPanel: true,
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-iv-embed'),
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("8k8Iy", function(module, exports) {
$parcel$export(module.exports, "thirdPartyConnectedDataSourceResource", () => $e75ece28d676b46b$export$59d77c416f392aa8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

const $e75ece28d676b46b$export$59d77c416f392aa8 = (0, $7edbf.createResource)({
    type: 'ISSUE_VIEW_THIRD_PARTY_CONNECTORS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("8oh3p")),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("8oh3p", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aHJUL").then(()=>parcelRequire('c0sfo'));

});


parcelRegister("jM84B", function(module, exports) {
$parcel$export(module.exports, "IssueViewSkeleton", () => $42c56dc23128b05e$export$49addbcdecb6e6ff);

var $e7boj = parcelRequire("e7boj");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $pMeMq = parcelRequire("pMeMq");

var $e7Yez = parcelRequire("e7Yez");
const $42c56dc23128b05e$var$fullpageStyles = null;
const $42c56dc23128b05e$var$modalStyles = null;
const $42c56dc23128b05e$var$customSpacingStyles = null;
const $42c56dc23128b05e$export$49addbcdecb6e6ff = (t0)=>{
    const $ = (0, $e7boj.c)(5);
    const { isEmbedView: isEmbedView, isModalView: isModalView } = t0;
    isEmbedView !== true && isModalView !== true && $42c56dc23128b05e$var$fullpageStyles;
    isModalView === true && $42c56dc23128b05e$var$modalStyles;
    const t1 = isEmbedView !== true && isModalView !== true && "_uwhk1ejb";
    const t2 = isModalView === true && "_19pk10j7";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = (0, $4jQY2.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            t1,
            t2
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $pMeMq.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($e7Yez))),
            className: t3
        }));
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
};
$42c56dc23128b05e$export$49addbcdecb6e6ff.displayName = "IssueViewSkeleton";

});
parcelRegister("pMeMq", function(module, exports) {
$parcel$export(module.exports, "CompactModeContext", () => $13f1cf3801dbe4e6$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $13f1cf3801dbe4e6$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $13f1cf3801dbe4e6$export$20feb77b5b617e44);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");


var $59xYB = parcelRequire("59xYB");

var $bc9Gj = parcelRequire("bc9Gj");

var $lVdUS = parcelRequire("lVdUS");
const $13f1cf3801dbe4e6$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $euxye.createContext)(false);
const { Provider: $13f1cf3801dbe4e6$var$Provider, Consumer: $13f1cf3801dbe4e6$var$Consumer } = $13f1cf3801dbe4e6$export$37eeac5cc5245b18;
const $13f1cf3801dbe4e6$export$55a90a8e865a39b5 = 700;
const $13f1cf3801dbe4e6$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$13f1cf3801dbe4e6$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $13f1cf3801dbe4e6$var$useRouteKey() {
    const [routeState] = (0, $bc9Gj.useRouter)();
    const { match: t0 } = routeState;
    const { path: path, params: params } = t0;
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? "/hasIssueKey" : ""}`;
}
const $13f1cf3801dbe4e6$export$10cf42790e523b8e = (t0)=>{
    const $ = (0, $e7boj.c)(13);
    const { children: children } = t0;
    const key = $13f1cf3801dbe4e6$var$useRouteKey();
    (0, $lVdUS.invalidateCacheIfRouteChanged)(key);
    let t1;
    if ($[0] !== key) {
        t1 = (0, $lVdUS.getCachedIsCompactValue)(key);
        $[0] = key;
        $[1] = t1;
    } else t1 = $[1];
    let defaultState = t1;
    if (defaultState === undefined) {
        defaultState = (0, $0adc77600a034fe1$export$ee15e0cd1efafcb4);
        (0, $lVdUS.setCachedIsCompactValue)((0, $0adc77600a034fe1$export$ee15e0cd1efafcb4), key);
    }
    const [isCompact, setIsCompact] = (0, $euxye.useState)(defaultState);
    let t2;
    if ($[2] !== key) {
        t2 = (state)=>{
            (0, $lVdUS.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        };
        $[2] = key;
        $[3] = t2;
    } else t2 = $[3];
    const onChange = t2;
    let t3;
    if ($[4] !== defaultState || $[5] !== onChange) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $59xYB.ContainerQueryObserver), {
            query: $13f1cf3801dbe4e6$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
            onChange: onChange,
            defaultState: defaultState
        });
        $[4] = defaultState;
        $[5] = onChange;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== children || $[8] !== isCompact) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($13f1cf3801dbe4e6$var$Provider, {
            value: isCompact
        }, children);
        $[7] = children;
        $[8] = isCompact;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($13f1cf3801dbe4e6$var$StyledWrapper, null, t3, t4);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
$13f1cf3801dbe4e6$export$10cf42790e523b8e.displayName = "CompactModeProvider";
const $13f1cf3801dbe4e6$export$20feb77b5b617e44 = $13f1cf3801dbe4e6$var$Consumer; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13f1cf3801dbe4e6$var$StyledWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $e7boj.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $4jQY2.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

});
const $0adc77600a034fe1$export$ee15e0cd1efafcb4 = false;

parcelRegister("59xYB", function(module, exports) {
$parcel$export(module.exports, "ContainerQueryObserver", () => $ae03d07a7a2eb0ae$export$e9574287678b8467);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $lnVHd = parcelRequire("lnVHd");

var $gXtG2 = parcelRequire("gXtG2");

const $ae03d07a7a2eb0ae$var$QueryContext = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
let $ae03d07a7a2eb0ae$var$currentIdSeed = 0;
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $ae03d07a7a2eb0ae$var$currentIdSeed = 0;
});
function $ae03d07a7a2eb0ae$var$generateAttributeValue() {
    return `indicator-span-${$ae03d07a7a2eb0ae$var$currentIdSeed++}`;
} /**
   * @param query *required* the container query to be observed
   * @param onChange *optional* void callback which takes in the state that was changed to
   * @param defaultState *optional* provides the initial state which the ContainerQueryObserver should detect changes from
   * @example
   * `<ContainerQueryObserver query='(max-width:1020px)'
   *   onChange={(state:boolean) => console.log(state)}/>`
   */ 
function $ae03d07a7a2eb0ae$export$e9574287678b8467(t0) {
    const $ = (0, $e7boj.c)(9);
    const { children: children, query: query, onChange: onChange, defaultState: t1 } = t0;
    const defaultState = t1 === undefined ? (0, $0adc77600a034fe1$export$ee15e0cd1efafcb4) : t1;
    const [active, setActive] = (0, $euxye.useState)(defaultState);
    let t2;
    if ($[0] !== onChange) {
        t2 = (isContainerQueryActive)=>{
            onChange?.(isContainerQueryActive);
            setActive(isContainerQueryActive);
        };
        $[0] = onChange;
        $[1] = t2;
    } else t2 = $[1];
    const handleQueryStatusChange = t2;
    let t3;
    if ($[2] !== handleQueryStatusChange || $[3] !== query) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lnVHd.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae03d07a7a2eb0ae$var$IntersectionIndicator, {
            query: query,
            notifyIntersectionStatusChanged: handleQueryStatusChange
        }));
        $[2] = handleQueryStatusChange;
        $[3] = query;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== active || $[6] !== children || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae03d07a7a2eb0ae$var$QueryContext.Provider, {
            value: active
        }, t3, children);
        $[5] = active;
        $[6] = children;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
}
$ae03d07a7a2eb0ae$export$e9574287678b8467.displayName = "ContainerQueryObserver";
function $ae03d07a7a2eb0ae$export$b66a67697973e01() {
    const currentState = (0, $euxye.useContext)($ae03d07a7a2eb0ae$var$QueryContext);
    if (currentState === undefined) throw new Error("The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState");
    return currentState;
}
function $ae03d07a7a2eb0ae$var$IntersectionIndicator(t0) {
    const $ = (0, $e7boj.c)(10);
    const { notifyIntersectionStatusChanged: handleChange, query: query } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = $ae03d07a7a2eb0ae$var$generateAttributeValue();
        $[0] = t1;
    } else t1 = $[0];
    const attributeValue = t1;
    const spanRef = (0, $euxye.useRef)(null);
    const containerRef = (0, $euxye.useRef)(null);
    const currentState = $ae03d07a7a2eb0ae$export$b66a67697973e01();
    let t2;
    let t3;
    if ($[1] !== currentState || $[2] !== handleChange) {
        t2 = ()=>{
            const queryStatusChangedCallback = (entries)=>{
                if (!containerRef.current || containerRef.current.clientWidth === 0) return;
                if (entries.length > 0) {
                    const isContainerQueryActive = entries[0].isIntersecting;
                    if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
                }
            };
            const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
            const spanElement = spanRef.current;
            spanElement && intersectionObserver.observe(spanElement);
            return ()=>{
                spanElement && intersectionObserver.unobserve(spanElement);
                intersectionObserver.disconnect();
            };
        };
        t3 = [
            currentState,
            handleChange
        ];
        $[1] = currentState;
        $[2] = handleChange;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $euxye.useLayoutEffect)(t2, t3);
    const t4 = `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`;
    let t5;
    if ($[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("style", {
            type: "text/css"
        }, t4);
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
            ref: spanRef,
            "data-container-query-indicator-id": attributeValue
        });
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae03d07a7a2eb0ae$var$ContainerToBeQueried, {
            ref: containerRef
        }, t5, t6);
        $[8] = t5;
        $[9] = t7;
    } else t7 = $[9];
    return t7;
}
$ae03d07a7a2eb0ae$var$IntersectionIndicator.displayName = "IntersectionIndicator";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae03d07a7a2eb0ae$var$ContainerToBeQueried = /*#__PURE__*/ (0, $euxye.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $e7boj.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $4jQY2.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

});
parcelRegister("lnVHd", function(module, exports) {
$parcel$export(module.exports, "RenderOnClient", () => $b005db0cc7f53d61$export$f7ced6922b75ec11);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $b9Jox = parcelRequire("b9Jox");
const $b005db0cc7f53d61$var$RenderWhenReady = ({ children: children })=>{
    const isClientReady = (0, $b9Jox.useIsClientReady)();
    if (isClientReady) return children;
    return null;
};
$b005db0cc7f53d61$var$RenderWhenReady.displayName = "RenderWhenReady";
const $b005db0cc7f53d61$export$f7ced6922b75ec11 = ({ children: children, fg: featureGateName })=>{
    // eslint-disable-next-line jira/ff/static-feature-flags
    if (featureGateName && !(0, $i860n.fg)(featureGateName)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b005db0cc7f53d61$var$RenderWhenReady, null, children);
};
$b005db0cc7f53d61$export$f7ced6922b75ec11.displayName = "RenderOnClient";

});


parcelRegister("lVdUS", function(module, exports) {
$parcel$export(module.exports, "getCachedIsCompactValue", () => $9d7944a04e2f8fc4$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $9d7944a04e2f8fc4$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $9d7944a04e2f8fc4$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $9d7944a04e2f8fc4$var$cachedIsCompactValues = {};
let $9d7944a04e2f8fc4$var$previousRouteKey;
function $9d7944a04e2f8fc4$export$c47621d55d10906c(key) {
    return $9d7944a04e2f8fc4$var$cachedIsCompactValues[key];
}
function $9d7944a04e2f8fc4$export$568b2dd75c2027b4(isCompactValue, key) {
    $9d7944a04e2f8fc4$var$cachedIsCompactValues[key] = isCompactValue;
}
function $9d7944a04e2f8fc4$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $9d7944a04e2f8fc4$var$previousRouteKey) {
        $9d7944a04e2f8fc4$var$previousRouteKey = currentRouteKey;
        delete $9d7944a04e2f8fc4$var$cachedIsCompactValues[$9d7944a04e2f8fc4$var$previousRouteKey];
    }
}

});


parcelRegister("e7Yez", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});


parcelRegister("jFwZ0", function(module, exports) {
$parcel$export(module.exports, "currentUserResource", () => $f8135b9992c3cc9d$export$b99aeb4e0b8e2e2f);
$parcel$export(module.exports, "useCurrentUserResource", () => $f8135b9992c3cc9d$export$3acfbef3abb3d18);
$parcel$export(module.exports, "useCurrentUserResourceIfEligible", () => $f8135b9992c3cc9d$export$40f25d3896d0d626);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $f8135b9992c3cc9d$export$b99aeb4e0b8e2e2f = (0, $7edbf.createResource)({
    type: 'CURRENT_USER',
    getKey: (_routerContext, { tenantContext: tenantContext })=>{
        return tenantContext?.atlassianAccountId ?? 'current-user-key';
    },
    getData: async (_routerContext, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        if (!atlassianAccountId) return null;
        return (0, $h2wCv.performGetRequest)(`/rest/api/2/user?accountId=${atlassianAccountId}`);
    }
});
function $f8135b9992c3cc9d$export$3acfbef3abb3d18() {
    return (0, $k6ufm.useResource)($f8135b9992c3cc9d$export$b99aeb4e0b8e2e2f);
}
function $f8135b9992c3cc9d$export$40f25d3896d0d626(isEligibleToCall) {
    const result = (0, $k6ufm.useResource)($f8135b9992c3cc9d$export$b99aeb4e0b8e2e2f);
    return isEligibleToCall ? result : null;
}

});

parcelRegister("6jRoa", function(module, exports) {
$parcel$export(module.exports, "loomPermissionResource", () => $3af78830bf4dbee8$export$bae1bd489c07a681);
$parcel$export(module.exports, "useLoomPermissionResource", () => $3af78830bf4dbee8$export$9397d1eed02e1b1e);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $n67Vb = parcelRequire("n67Vb");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $aI7em = parcelRequire("aI7em");

var $4GSUS = parcelRequire("4GSUS");
const $3af78830bf4dbee8$export$bae1bd489c07a681 = (0, $7edbf.createResource)({
    type: 'LOOM_USER_PERMISSION',
    getKey: (_routerContext, { tenantContext: tenantContext })=>{
        return tenantContext?.cloudId ?? 'current-cloud-id';
    },
    getData: async (_routerContext, { tenantContext: tenantContext })=>{
        try {
            const cloudId = tenantContext?.cloudId;
            if (!cloudId) return null;
            // fetchQuery is used to ensure that the return type is consistent with what is needed by loom's stores
            const data = await (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), (0, $4GSUS.default), {
                resourceId: `ari:cloud:loom::site/${cloudId}`,
                permissionId: 'write'
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise();
            if (!data) return null;
            return {
                permitted: !!data?.permitted
            };
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchLoomUserPermissions',
                    packageName: 'jiraLoomResource',
                    teamName: 'cross-flow-growth'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return null;
        }
    }
});
function $3af78830bf4dbee8$export$9397d1eed02e1b1e() {
    return (0, $k6ufm.useResource)($3af78830bf4dbee8$export$bae1bd489c07a681);
}

});
parcelRegister("4GSUS", function(module, exports) {
$parcel$export(module.exports, "default", () => $430a42ef3cd70ad4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04e65282b2d7bd6ecc23443845cb3949>>
 * @relayHash a47e1cbd9d1f89df945d0b54740a5a2b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a921844bce3f100ea5912f8d38189a75b0ec84d8fc6d7497d40178c784f86b4
const $430a42ef3cd70ad4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "permissionId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "resourceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "permissionId",
                    "variableName": "permissionId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "kind": "ScalarField",
            "name": "permitted"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LoomPermissionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LoomPermissionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5a921844bce3f100ea5912f8d38189a75b0ec84d8fc6d7497d40178c784f86b4",
            "metadata": {},
            "name": "LoomPermissionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$430a42ef3cd70ad4$var$node.hash = "5025da211da016dbec919be200319dea";
var $430a42ef3cd70ad4$export$2e2bcd8739ae039 = $430a42ef3cd70ad4$var$node;

});


parcelRegister("cEVzH", function(module, exports) {
$parcel$export(module.exports, "confluenceUserPermissionsResource", () => $5ed24f0ce973bda4$export$163ce6d92b00f2f2);
$parcel$export(module.exports, "useConfluenceUserPermissionsResource", () => $5ed24f0ce973bda4$export$8b76631846db8b14);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $n67Vb = parcelRequire("n67Vb");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $aI7em = parcelRequire("aI7em");

var $9yBwJ = parcelRequire("9yBwJ");
const $5ed24f0ce973bda4$export$163ce6d92b00f2f2 = (0, $7edbf.createResource)({
    type: 'CONFLUENCE_USER_PERMISSIONS',
    getKey: (_routerContext, { tenantContext: tenantContext })=>{
        return tenantContext?.cloudId ?? 'current-cloud-id';
    },
    getData: async (_routerContext, { tenantContext: tenantContext })=>{
        try {
            const cloudId = tenantContext?.cloudId;
            if (!cloudId) return null;
            const data = await (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), (0, $9yBwJ.default), {
                resourceId: `ari:cloud:confluence::site/${cloudId}`,
                permissionId: 'write'
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise();
            if (!data) return null;
            return {
                permitted: !!data?.permitted
            };
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'confluenceUserPermissionsResource',
                    packageName: 'jiraConfluenceUserPermissionsResource',
                    teamName: 'confluence-better-together'
                }
            });
            return null;
        }
    }
});
function $5ed24f0ce973bda4$export$8b76631846db8b14() {
    return (0, $k6ufm.useResource)($5ed24f0ce973bda4$export$163ce6d92b00f2f2);
}

});
parcelRegister("9yBwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $adbe298d764cfb21$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb29aba8865d64c87d88782c5a787c46>>
 * @relayHash 0acc5ecd092c0b13730a68d934bf7c62
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ca34dc382fbe12f7e08df67b8085ce95cb28bc98ce1beed3f33150fdb96a679
const $adbe298d764cfb21$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "permissionId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "resourceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "permissionId",
                    "variableName": "permissionId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "kind": "ScalarField",
            "name": "permitted"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConfluenceUserPermissionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConfluenceUserPermissionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "6ca34dc382fbe12f7e08df67b8085ce95cb28bc98ce1beed3f33150fdb96a679",
            "metadata": {},
            "name": "ConfluenceUserPermissionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$adbe298d764cfb21$var$node.hash = "09d3f73fa0f06eb57117244c67f52367";
var $adbe298d764cfb21$export$2e2bcd8739ae039 = $adbe298d764cfb21$var$node;

});


parcelRegister("21fL1", function(module, exports) {
$parcel$export(module.exports, "isJsmChatOpsEntitlementResourceEnabled", () => $919e2c104696b190$export$7514e2d9b6ccca71);

var $i860n = parcelRequire("i860n");
const $919e2c104696b190$export$7514e2d9b6ccca71 = ()=>(0, $i860n.fg)('fg-perf-jsm-issue-view-optimize-ms-teams') || (0, $i860n.fg)('fg-perf-jsm-issue-view-optimize-zoom') || (0, $i860n.fg)('fg-perf-jsm-issue-view-optimize-slack');

});

parcelRegister("bLDht", function(module, exports) {
$parcel$export(module.exports, "jsmChatOpsEntitlementResource", () => $015eef04f732198a$export$e82a16390f786e38);
$parcel$export(module.exports, "useJsmChatOpsEntitlementResource", () => $015eef04f732198a$export$a4fe643050bbad1);

var $e7boj = parcelRequire("e7boj");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $kfVxU = parcelRequire("kfVxU");

const $015eef04f732198a$export$e82a16390f786e38 = (0, $7edbf.createResource)({
    type: 'JSM_CHATOPS_ENTITLEMENT',
    getKey: ({ match: match, query: query })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match);
        if (!issueKey) {
            if (query && query.selectedIssue) return query.selectedIssue || '';
        }
        return issueKey || '';
    },
    getDataLoader: ()=>(parcelRequire("5gcxn")),
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: false
});
function $015eef04f732198a$export$a4fe643050bbad1() {
    const $ = (0, $e7boj.c)(3);
    const { data: data, refresh: refresh } = (0, $k6ufm.useResource)($015eef04f732198a$export$e82a16390f786e38);
    const t0 = data?.chatOpsEntitlementEnabled ?? undefined;
    let t1;
    if ($[0] !== refresh || $[1] !== t0) {
        t1 = {
            chatOpsEntitlementEnabled: t0,
            refresh: refresh
        };
        $[0] = refresh;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}

});
parcelRegister("kfVxU", function(module, exports) {
$parcel$export(module.exports, "getIssueKey", () => $771bf84e631e86da$export$4a030f6192bebe03);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $771bf84e631e86da$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

parcelRegister("5gcxn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fkv4K").then(()=>parcelRequire('iYSDI'));

});


parcelRegister("Jz4MJ", function(module, exports) {
$parcel$export(module.exports, "aiContextPanelResource", () => $389ed263b6937f17$export$8f6224974184ed8d);
$parcel$export(module.exports, "aiContextPanelResourceWithDependencies", () => $389ed263b6937f17$export$70559c909620e4ed);
$parcel$export(module.exports, "getAIContextPanelResources", () => $389ed263b6937f17$export$d5bd1af2f373eac4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $f99M0 = parcelRequire("f99M0");

var $40SbE = parcelRequire("40SbE");


var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");


var $eNYfD = parcelRequire("eNYfD");

var $jDyLT = parcelRequire("jDyLT");

var $dEqv7 = parcelRequire("dEqv7");

var $k4ydi = parcelRequire("k4ydi");
const $389ed263b6937f17$var$SUPPORTED_PRACTICES = new Set([
    (0, $6a18985c64d19567$export$a364d86306d4a6d4),
    (0, $6a18985c64d19567$export$31ffe79c2b019cf)
]);
const $389ed263b6937f17$export$139994f449ff87 = {
    0: [],
    1: []
};
function $389ed263b6937f17$export$aa1ed07cbbb59692(userPreferences) {
    const collapsed = userPreferences[0] ?? [];
    const expanded = userPreferences[1] ?? [];
    const isContextPanelCollapsed = collapsed.includes('ai-context-service');
    const emptyUserPreference = !(collapsed.includes('ai-context-service') || expanded.includes('ai-context-service'));
    return {
        isContextPanelCollapsed: isContextPanelCollapsed,
        emptyUserPreference: emptyUserPreference
    };
}
const $389ed263b6937f17$export$8f6224974184ed8d = (0, $7edbf.createResource)({
    type: (0, $511fbf22fa5e01a8$export$57128ea4767a7885),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { skipChecks: skipChecks, issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale, appEditions: appEditions } = resourceStoreContext.tenantContext;
        const isStandardEdition = appEditions.serviceDesk === 'STANDARD_EDITION';
        const isPremiumEdition = appEditions.serviceDesk === 'PREMIUM_EDITION';
        if (!issueKey) return null;
        if (skipChecks !== '1') {
            // The suggestions panel is available only on service-desk.
            // Hence filtering them out to reduce the number of calls to AGG and features APIs
            if (!(0, $40SbE.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk')) return null;
            const issueDetails = await (0, $k4ydi.getIssueDetails)(issueKey, cloudId, true);
            const { isAIEnabled: isAIEnabled, isAiContextFeatureEnabled: isAiContextFeatureEnabled, projectType: projectType } = issueDetails;
            issueId = issueDetails.issueId;
            projectId = issueDetails.projectId;
            practice = issueDetails.practice;
            const projectKeyFromIssueDetails = issueDetails.projectKey;
            // Check AI enabled and supported practices (or null practice with feature flag)
            if (!isAIEnabled || !$389ed263b6937f17$var$SUPPORTED_PRACTICES.has(practice) && !(practice === undefined && (0, $i860n.fg)('suggestions_panel_null_with_nsynk')) || projectType !== (0, $f99M0.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT)) return null;
            /* (Standard or Premium) + Collapsed Panel -> Skip Context Panel Call */ const reactivePremiumEnabled = isPremiumEdition && (0, $i860n.fg)('enable_reactive_suggestions_for_premium');
            const reactiveStandardEnabled = isStandardEdition && (0, $i860n.fg)('collapsed_context_panel_for_standard');
            if ((reactiveStandardEnabled || reactivePremiumEnabled) && practice === (0, $6a18985c64d19567$export$a364d86306d4a6d4)) {
                let userPreferences;
                try {
                    userPreferences = await (0, $h2wCv.performGetRequest)(`/rest/api/3/mypreferences?key=issue.collapsible-group.${projectKeyFromIssueDetails}`);
                } catch  {
                    userPreferences = $389ed263b6937f17$export$139994f449ff87;
                }
                const { isContextPanelCollapsed: isContextPanelCollapsed, emptyUserPreference: emptyUserPreference } = $389ed263b6937f17$export$aa1ed07cbbb59692(userPreferences);
                /* Panel Collapsed or enabled first time and feature-toggle is OFF */ if (isContextPanelCollapsed || emptyUserPreference && !isAiContextFeatureEnabled) return null;
            } else if (!isAiContextFeatureEnabled) return null;
        }
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $6a18985c64d19567$export$a364d86306d4a6d4) || practice === undefined && (0, $i860n.fg)('suggestions_panel_null_with_nsynk')) return (0, $jDyLT.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $6a18985c64d19567$export$31ffe79c2b019cf) && (0, $i860n.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $dEqv7.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    isBrowserOnly: true
});
const $389ed263b6937f17$export$70559c909620e4ed = (0, $7edbf.createResource)({
    type: (0, $511fbf22fa5e01a8$export$38f892c32d281e99),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResourceWithDependencies-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { skipChecks: skipChecks, issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale, appEditions: appEditions } = resourceStoreContext.tenantContext;
        const isStandardEdition = appEditions.serviceDesk === 'STANDARD_EDITION';
        const isPremiumEdition = appEditions.serviceDesk === 'PREMIUM_EDITION';
        if (!issueKey) return null;
        if (skipChecks !== '1') {
            if (!(0, $40SbE.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk')) return null;
            let issueDetails = (0, $eNYfD.getDependencyData)(routerDataContext.dependencies, (0, $511fbf22fa5e01a8$export$3e1b459cf14e5bcd));
            if (issueDetails instanceof Promise) issueDetails = await issueDetails;
            if (!issueDetails) return null;
            const { isAIEnabled: isAIEnabled, isAiContextFeatureEnabled: isAiContextFeatureEnabled, projectType: projectType } = issueDetails;
            issueId = issueDetails.issueId;
            projectId = issueDetails.projectId;
            practice = issueDetails.practice;
            const projectKeyFromIssueDetails = issueDetails.projectKey;
            if (!isAIEnabled || !$389ed263b6937f17$var$SUPPORTED_PRACTICES.has(practice) && !(practice === undefined && (0, $i860n.fg)('suggestions_panel_null_with_nsynk')) || projectType !== (0, $f99M0.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT)) return null;
            /* (Standard OR Premium) + Collapsed Panel -> Skip Context Panel Call */ const reactivePremiumEnabled = isPremiumEdition && (0, $i860n.fg)('enable_reactive_suggestions_for_premium');
            const reactiveStandardEnabled = isStandardEdition && (0, $i860n.fg)('collapsed_context_panel_for_standard');
            if ((reactiveStandardEnabled || reactivePremiumEnabled) && practice === (0, $6a18985c64d19567$export$a364d86306d4a6d4)) {
                let userPreferenceResult;
                try {
                    userPreferenceResult = await (0, $h2wCv.performGetRequest)(`/rest/api/3/mypreferences?key=issue.collapsible-group.${projectKeyFromIssueDetails}`);
                } catch  {
                    userPreferenceResult = $389ed263b6937f17$export$139994f449ff87;
                }
                const { isContextPanelCollapsed: isContextPanelCollapsed, emptyUserPreference: emptyUserPreference } = $389ed263b6937f17$export$aa1ed07cbbb59692(userPreferenceResult);
                /* Panel Collapsed or enabled first time and feature-toggle is OFF - skip making API call */ if (isContextPanelCollapsed || emptyUserPreference && !isAiContextFeatureEnabled) return null;
            } else if (!isAiContextFeatureEnabled) return null;
        }
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $6a18985c64d19567$export$a364d86306d4a6d4) || practice === undefined && (0, $i860n.fg)('suggestions_panel_null_with_nsynk')) return (0, $jDyLT.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $6a18985c64d19567$export$31ffe79c2b019cf) && (0, $i860n.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $dEqv7.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    depends: [
        (0, $511fbf22fa5e01a8$export$3e1b459cf14e5bcd)
    ],
    isBrowserOnly: true
});
const $389ed263b6937f17$export$d5bd1af2f373eac4 = ()=>{
    return [
        (0, $k4ydi.contextPanelIssueDetailsResource),
        $389ed263b6937f17$export$70559c909620e4ed
    ];
};

});
parcelRegister("40SbE", function(module, exports) {
$parcel$export(module.exports, "checkLicense", () => $648961426ed4fe91$export$fe2591be8b7e59ce);
const $648961426ed4fe91$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $648961426ed4fe91$export$fe2591be8b7e59ce = (tenantContext, type)=>{
    const key = $648961426ed4fe91$var$appPermissionMapper[type];
    return Boolean(tenantContext.appPermissions && tenantContext.appPermissions[key]);
};

});

/* eslint-disable jira/filename-case */ const $6a18985c64d19567$export$b45a36df7873757 = 'alerts';
const $6a18985c64d19567$export$a7952c5a5c371ddd = 'oncall';
const $6a18985c64d19567$export$de0bca182bc46c7f = 'services';
const $6a18985c64d19567$export$ed849d1eb34423e5 = 'similarIssues';
const $6a18985c64d19567$export$d4a1ed8524773042 = 'sentiment-analysis';
const $6a18985c64d19567$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $6a18985c64d19567$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $6a18985c64d19567$export$cae2404f62c0f4d7 = 'change-management';
const $6a18985c64d19567$export$31ffe79c2b019cf = 'incident-management';
const $6a18985c64d19567$export$3a20074cc38cbf69 = 'problem-management';
const $6a18985c64d19567$export$a364d86306d4a6d4 = 'service-request';
const $6a18985c64d19567$export$71f1a79e03f525 = 'post-incident-review';
const $6a18985c64d19567$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $6a18985c64d19567$export$cc2f7f9baa0c29bc = 'csm-live-chat';
const $6a18985c64d19567$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $6a18985c64d19567$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $6a18985c64d19567$export$93b42272f76473c9 = 'jsm-views';
const $6a18985c64d19567$export$1eb399d8c2d53748 = 'jsm-board';
const $6a18985c64d19567$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $6a18985c64d19567$export$c270aafb43a2f7bb = 'jsm-list';
const $6a18985c64d19567$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $6a18985c64d19567$export$d797e2b2eea7f98c = 'jsm-project-summary-new-experience';
const $6a18985c64d19567$export$34136c6420474672 = 'journey-builder';
const $6a18985c64d19567$export$1b91287bba20848e = 'jsm-live-chat';
const $6a18985c64d19567$export$de49b88d88f8a894 = 'surveys';
const $6a18985c64d19567$export$66ede2c1de447f8f = 'developer-escalation';
const $6a18985c64d19567$export$1ee9c534405b9b35 = 'playbooks';
const $6a18985c64d19567$export$ac0832132e8992d7 = 'automation-discoverability';
const $6a18985c64d19567$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $6a18985c64d19567$export$46951aff716c61c8 = 'root-cause-analysis';
const $6a18985c64d19567$export$10f31cbcc30fea0 = 'case-management';
const $6a18985c64d19567$export$6ab5a70f9e0a8f0f = 'jsm-workforce-optimization';
const $6a18985c64d19567$export$d346648782f8f1bb = 'jsm-workday-panel-integration';
const $6a18985c64d19567$export$e927a5d1b72f0b68 = 'ENABLED';
const $6a18985c64d19567$export$8cd212c10b4124d2 = 'DISABLED';

/* eslint-disable jira/filename-case */ const $511fbf22fa5e01a8$export$3e1b459cf14e5bcd = 'CONTEXT_PANEL_ISSUE_DETAILS';
const $511fbf22fa5e01a8$export$57128ea4767a7885 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE';
const $511fbf22fa5e01a8$export$38f892c32d281e99 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE-WITH-DEPENDENCIES';
const $511fbf22fa5e01a8$export$f864fe68374034cd = 'RESOLUTION-PLAN-SSR-RESOURCE-TYPE';
const $511fbf22fa5e01a8$export$d0577c65f7af8359 = 800;

parcelRegister("eNYfD", function(module, exports) {
$parcel$export(module.exports, "getDependencyData", () => $e8ce1f474673bca4$export$c1f67084c4ca42af);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $l8UJH = parcelRequire("l8UJH");
const $e8ce1f474673bca4$export$c1f67084c4ca42af = (dependencies, key)=>{
    if (dependencies[key]?.loading || dependencies[key]?.error) // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $l8UJH.consumeDependency)(dependencies, key);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return dependencies[key]?.data;
};

});
parcelRegister("l8UJH", function(module, exports) {
$parcel$export(module.exports, "consumeDependency", () => $57c99545b9f60fbc$export$a973ef9e17a326f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ async function $57c99545b9f60fbc$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) // oxlint-disable-next-line typescript/consistent-type-assertions
    return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return dependencies[key]?.data;
}

});


parcelRegister("jDyLT", function(module, exports) {
$parcel$export(module.exports, "getServiceSuggestionData", () => $da18e6d93fc81b3e$export$afab700af9f021de);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $k3xF2 = parcelRequire("k3xF2");
const $da18e6d93fc81b3e$export$afab700af9f021de = (issueId, cloudId)=>{
    return (0, $k3xF2.getContextPanelSuggestions)(cloudId, issueId);
};

});
parcelRegister("k3xF2", function(module, exports) {
$parcel$export(module.exports, "getContextPanelSuggestions", () => $771e03dc071fc7f6$export$715f8fbc08922943);

var $jBKVt = parcelRequire("jBKVt");

var $n67Vb = parcelRequire("n67Vb");

var $i860n = parcelRequire("i860n");

var $aI7em = parcelRequire("aI7em");

var $511Fu = parcelRequire("511Fu");

var $7oZxU = parcelRequire("7oZxU");
const $771e03dc071fc7f6$var$OPERATION_NAME = 'graphqlContextPanelQuery';
/**
 * Relay may recycle the `fetchQuery().toPromise()` root after the handler returns; step
 * enrichment runs later in React. Clone now so {@link buildStepEnrichmentRequest} still sees
 * `agentAI_contextPanel` when the POST runs.
 */ function $771e03dc071fc7f6$var$snapshotGraphqlDataForDeferredEnrichment(data) {
    try {
        return structuredClone(data);
    } catch  {
        try {
            const jsonRoundTrip = JSON.parse(JSON.stringify(data));
            return jsonRoundTrip;
        } catch  {
            return data;
        }
    }
}
const $771e03dc071fc7f6$export$cab99d46cba3a3d5 = (0, $jBKVt.default);
const $771e03dc071fc7f6$export$715f8fbc08922943 = async (cloudId, issueId, stepEnrichmentBuildOptions)=>{
    (0, $511Fu.startCapturingTraceIds)($771e03dc071fc7f6$var$OPERATION_NAME);
    const graphQLResponse = await (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), $771e03dc071fc7f6$export$cab99d46cba3a3d5, {
        cloudId: cloudId,
        issueId: issueId
    }).toPromise().then((data)=>{
        const traceIds = (0, $511Fu.getTraceIds)($771e03dc071fc7f6$var$OPERATION_NAME);
        const variables = {
            cloudId: cloudId,
            issueId: issueId
        };
        const result = (0, $7oZxU.handleGraphQLresponse)(data, traceIds);
        if (result.type === 'ServicePanelSuggestions' && data?.agentAI_contextPanel?.__typename === 'AgentAIContextPanelResponse' && (0, $i860n.fg)('jsm_ai_context_panel_step_enrichment')) return {
            ...result,
            stepEnrichmentDeferredInput: {
                graphqlData: $771e03dc071fc7f6$var$snapshotGraphqlDataForDeferredEnrichment(data),
                variables: variables,
                buildOptions: stepEnrichmentBuildOptions
            }
        };
        return result;
    }).catch((error)=>{
        const traceIds = (0, $511Fu.getTraceIds)($771e03dc071fc7f6$var$OPERATION_NAME);
        return (0, $7oZxU.handleGraphQLError)(error, traceIds);
    }).finally(()=>{
        (0, $511Fu.stopCapturingTraceIds)($771e03dc071fc7f6$var$OPERATION_NAME);
    });
    return graphQLResponse;
};

});
parcelRegister("jBKVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $29803a88f2711c6b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40293366a861d7044d181855125663b7>>
 * @relayHash e4e54828251309a9de86334b932053b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d486b68b5d188b9237165eec25fecdb1cc8f665f182dcb05ee298672078077fd
const $29803a88f2711c6b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "summary"
            },
            {
                "kind": "ScalarField",
                "name": "agentSteps"
            },
            {
                "kind": "ScalarField",
                "name": "reporterDetails"
            },
            {
                "concreteType": "AgentAISuggestAction",
                "kind": "LinkedField",
                "name": "suggestedActions",
                "plural": true,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "concreteType": "AgentAISuggestedActionContent",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            }
                        ]
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContext",
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "suggestion"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "currentValue"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "AgentAISuggestedNextSteps",
                "kind": "LinkedField",
                "name": "suggestedNextSteps",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "AgentAICitation",
                        "kind": "LinkedField",
                        "name": "citations",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "sourceId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "sourceType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "sourceUrl"
                            },
                            v4 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "AgentAINextStep",
                        "kind": "LinkedField",
                        "name": "nextSteps",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "content"
                            },
                            {
                                "concreteType": "AgentAIInlineAction",
                                "kind": "LinkedField",
                                "name": "inlineAction",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "concreteType": "AgentAIDraftReplyPillData",
                                        "kind": "LinkedField",
                                        "name": "draftReplyPill",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "category"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "example"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "goal"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "intent"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "pillId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "text"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "triggerSummary"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "AgentAIContextPanelResponse"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d486b68b5d188b9237165eec25fecdb1cc8f665f182dcb05ee298672078077fd",
            "metadata": {},
            "name": "graphqlContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$29803a88f2711c6b$var$node.hash = "ea8e294e11dc4182f22cbc945fd9a47a";
var $29803a88f2711c6b$export$2e2bcd8739ae039 = $29803a88f2711c6b$var$node;

});

parcelRegister("7oZxU", function(module, exports) {
$parcel$export(module.exports, "handleGraphQLresponse", () => $fe550173010f1d2e$export$f09fdc2e4ab145a5);
$parcel$export(module.exports, "handleGraphQLError", () => $fe550173010f1d2e$export$3af48ada790caea5);
/* eslint-disable jira/import-whitelist */ 
var $ah85A = parcelRequire("ah85A");

var $2fTCj = parcelRequire("2fTCj");
const $fe550173010f1d2e$var$mapGraphQlInlineAction = (inlineAction)=>{
    if (!inlineAction || inlineAction.type !== 'DRAFT_REPLY' || !inlineAction.draftReplyPill) return undefined;
    const pill = inlineAction.draftReplyPill;
    return {
        type: 'DRAFT_REPLY',
        draftReplyPill: {
            pillId: pill.pillId,
            text: pill.text,
            category: pill.category,
            ...pill.intent != null && pill.intent !== '' ? {
                intent: pill.intent
            } : {},
            ...pill.goal != null && pill.goal !== '' ? {
                goal: pill.goal
            } : {},
            ...pill.triggerSummary != null && pill.triggerSummary !== '' ? {
                triggerSummary: pill.triggerSummary
            } : {},
            ...pill.example != null && pill.example !== '' ? {
                example: pill.example
            } : {}
        }
    };
};
const $fe550173010f1d2e$var$transformSuggestedNextSteps = (suggestedNextSteps)=>{
    if (!suggestedNextSteps?.citations?.length && !suggestedNextSteps?.nextSteps?.length) return undefined;
    return {
        citations: (suggestedNextSteps?.citations ?? []).flatMap((c)=>c != null ? [
                {
                    id: c.id,
                    sourceType: c.sourceType,
                    sourceId: c.sourceId ?? null,
                    sourceUrl: c.sourceUrl,
                    title: c.title
                }
            ] : []),
        nextSteps: (suggestedNextSteps?.nextSteps ?? []).flatMap((step)=>{
            const content = (0, $2fTCj.parseAdf)(step?.content);
            if (content == null) return [];
            const normalizedInlineAction = $fe550173010f1d2e$var$mapGraphQlInlineAction(step?.inlineAction ?? null);
            return [
                {
                    content: content,
                    ...normalizedInlineAction != null ? {
                        inlineAction: normalizedInlineAction
                    } : {}
                }
            ];
        })
    };
};
const $fe550173010f1d2e$export$716425a07890b235 = (graphQLResponse, traceIds)=>{
    const data = graphQLResponse?.agentAI_contextPanel?.__typename === 'AgentAIContextPanelResponse' ? graphQLResponse?.agentAI_contextPanel : null;
    return {
        type: 'ServicePanelSuggestions',
        traceIds: traceIds,
        summary: (0, $2fTCj.parseAdf)(data?.summary),
        reporterDetails: (0, $2fTCj.parseAdf)(data?.reporterDetails),
        agentSteps: (0, $2fTCj.parseAdf)(data?.agentSteps),
        suggestedNextSteps: $fe550173010f1d2e$var$transformSuggestedNextSteps(data?.suggestedNextSteps),
        suggestedActions: data?.suggestedActions ? data?.suggestedActions?.map((action)=>({
                type: action.type,
                context: {
                    ...action.context,
                    suggestion: action.context?.suggestion
                },
                content: (0, $2fTCj.transformContent)(action?.content)
            })) : []
    };
};
const $fe550173010f1d2e$export$f09fdc2e4ab145a5 = (graphQLResponse, traceIds)=>{
    const responseType = graphQLResponse?.agentAI_contextPanel?.__typename;
    if (responseType === 'AgentAIContextPanelResponse') return $fe550173010f1d2e$export$716425a07890b235(graphQLResponse, traceIds);
    if (responseType === 'QueryError') {
        const errorMessage = graphQLResponse?.agentAI_contextPanel?.message ?? 'Unknown error';
        const errorStatus = graphQLResponse?.agentAI_contextPanel?.extensions?.[0]?.statusCode ?? 500;
        throw new (0, $ah85A.FetchError)(errorStatus, `Error processing graphQL query: ${errorMessage}`, traceIds?.[0]);
    }
    throw new (0, $ah85A.FetchError)(500, 'Failed to fetch data from AGG', traceIds?.[0]);
};
const $fe550173010f1d2e$export$3af48ada790caea5 = (error, traceIds)=>{
    throw new (0, $ah85A.FetchError)(500, `Failed to fetch data from AGG : ${error?.message}`, traceIds?.[0]);
};

});
parcelRegister("ah85A", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $7798157ede1d6081$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7798157ede1d6081$export$895e385291c3b753);
/* eslint-disable jira/filename-case, max-classes-per-file */ class $7798157ede1d6081$var$ExtensibleError extends Error {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
$7798157ede1d6081$var$ExtensibleError.displayName = "ExtensibleError";
class $7798157ede1d6081$export$26e841bcf1aeb894 extends $7798157ede1d6081$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
$7798157ede1d6081$export$26e841bcf1aeb894.displayName = "FetchError";
class $7798157ede1d6081$export$895e385291c3b753 extends $7798157ede1d6081$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}
$7798157ede1d6081$export$895e385291c3b753.displayName = "ResponseNullError";

});

parcelRegister("2fTCj", function(module, exports) {
$parcel$export(module.exports, "transformContent", () => $0192ba411f79ab25$export$b7cb80c25ebba28e);
$parcel$export(module.exports, "parseAdf", () => $0192ba411f79ab25$export$5659c60045974de9);
const $0192ba411f79ab25$export$b7cb80c25ebba28e = (content)=>{
    return {
        title: $0192ba411f79ab25$export$5659c60045974de9(content.title),
        description: $0192ba411f79ab25$export$5659c60045974de9(content.description)
    };
};
const $0192ba411f79ab25$var$normaliseDraftReplyInlineActionFromApi = (inlineAction)=>{
    if (!inlineAction || inlineAction.type !== 'DRAFT_REPLY' || !inlineAction.draftReplyPill) return undefined;
    const p = inlineAction.draftReplyPill;
    const text = p.text != null ? String(p.text).trim() : '';
    const category = p.category != null ? String(p.category).trim() : '';
    // Execution only requires text + category; pillId is schema metadata (may be absent on REST).
    if (text === '' || category === '') return undefined;
    const pillId = p.pillId != null ? String(p.pillId).trim() : '';
    return {
        type: 'DRAFT_REPLY',
        draftReplyPill: {
            pillId: pillId,
            text: text,
            category: category,
            ...p.intent != null && p.intent !== '' ? {
                intent: p.intent
            } : {},
            ...p.goal != null && p.goal !== '' ? {
                goal: p.goal
            } : {},
            ...p.triggerSummary != null && p.triggerSummary !== '' ? {
                triggerSummary: p.triggerSummary
            } : {},
            ...p.example != null && p.example !== '' ? {
                example: p.example
            } : {}
        }
    };
};
const $0192ba411f79ab25$var$transformSuggestedNextSteps = (suggestedNextSteps)=>{
    if (!suggestedNextSteps?.citations?.length && !suggestedNextSteps?.nextSteps?.length) return undefined;
    return {
        citations: (suggestedNextSteps?.citations ?? []).map((c)=>({
                id: c.id,
                sourceType: c.sourceType ?? '',
                sourceId: c.sourceId ?? null,
                sourceUrl: c.sourceUrl,
                title: c.title
            })),
        nextSteps: (suggestedNextSteps?.nextSteps ?? []).flatMap((step)=>{
            const content = $0192ba411f79ab25$export$5659c60045974de9(step?.content);
            if (content == null) return [];
            const normalizedInlineAction = $0192ba411f79ab25$var$normaliseDraftReplyInlineActionFromApi(step?.inlineAction);
            return [
                {
                    content: content,
                    ...normalizedInlineAction != null ? {
                        inlineAction: normalizedInlineAction
                    } : {}
                }
            ];
        })
    };
};
const $0192ba411f79ab25$export$3ceb62baab058c6b = (data)=>({
        type: 'ServicePanelSuggestions',
        summary: $0192ba411f79ab25$export$5659c60045974de9(data.summary),
        reporterDetails: $0192ba411f79ab25$export$5659c60045974de9(data.reporterDetails),
        agentSteps: $0192ba411f79ab25$export$5659c60045974de9(data.agentSteps),
        suggestedNextSteps: $0192ba411f79ab25$var$transformSuggestedNextSteps(data.suggestedNextSteps),
        suggestedActions: data.suggestedActions ? data.suggestedActions.map((action)=>{
            switch(action.type){
                case 'priority':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $0192ba411f79ab25$export$b7cb80c25ebba28e(action.content)
                    };
                case 'comment':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $0192ba411f79ab25$export$b7cb80c25ebba28e(action.content)
                    };
                case 'assignee':
                default:
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $0192ba411f79ab25$export$b7cb80c25ebba28e(action.content)
                    };
            }
        }) : []
    });
const $0192ba411f79ab25$export$5659c60045974de9 = (adfString)=>{
    if (!adfString) return null;
    try {
        return JSON.parse(adfString);
    } catch (_error) {
        return null;
    }
};

});




parcelRegister("dEqv7", function(module, exports) {
$parcel$export(module.exports, "getIncidentSuggestionEndpoint", () => $26f5a415258a7cc5$export$32b63803a24bceaa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");

var $cM4mv = parcelRequire("cM4mv");
const $26f5a415258a7cc5$export$db19de3f154d9918 = ({ cloudId: cloudId, issueId: issueId, projectId: projectId, locale: locale })=>`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;
const $26f5a415258a7cc5$export$32b63803a24bceaa = (reqParams)=>{
    const url = $26f5a415258a7cc5$export$db19de3f154d9918(reqParams);
    return (0, $4fhEY.default)(url, {
        method: 'GET'
    }).then((0, $cM4mv.transformResponseV2));
};

});
parcelRegister("cM4mv", function(module, exports) {
$parcel$export(module.exports, "transformResponseV2", () => $7bf8e52e0c5d89c3$export$deb8fcf4bacae588);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Resource doesn't allow imports of getEmptyADF();
const $7bf8e52e0c5d89c3$var$EMPTY_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
const $7bf8e52e0c5d89c3$var$parseToADF = (adfString)=>{
    try {
        return JSON.parse(adfString);
    } catch (error) {
        return $7bf8e52e0c5d89c3$var$EMPTY_DOCUMENT;
    }
};
const $7bf8e52e0c5d89c3$var$transformContent = (content)=>{
    return {
        title: $7bf8e52e0c5d89c3$var$parseToADF(content.title),
        description: $7bf8e52e0c5d89c3$var$parseToADF(content.description)
    };
};
const $7bf8e52e0c5d89c3$var$transformMultipleSectionContent = (content)=>{
    return {
        title: $7bf8e52e0c5d89c3$var$parseToADF(content.title),
        description: $7bf8e52e0c5d89c3$var$parseToADF(content.description),
        descriptionList: content.descriptionList ? content.descriptionList.map((suggestion)=>({
                id: suggestion.id,
                description: $7bf8e52e0c5d89c3$var$parseToADF(suggestion.description)
            })) : []
    };
};
const $7bf8e52e0c5d89c3$var$exhaustiveCheck = (_)=>null;
const $7bf8e52e0c5d89c3$export$deb8fcf4bacae588 = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $7bf8e52e0c5d89c3$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $7bf8e52e0c5d89c3$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $7bf8e52e0c5d89c3$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $7bf8e52e0c5d89c3$var$transformMultipleSectionContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                    return {
                        ...action,
                        context: action.context,
                        content: $7bf8e52e0c5d89c3$var$transformContent(action.content)
                    };
                case 'MAJOR_INCIDENT':
                    return {
                        ...action,
                        context: action.context,
                        content: $7bf8e52e0c5d89c3$var$transformContent(action.content)
                    };
                case 'PRIORITY':
                    return {
                        ...action,
                        context: action.context,
                        content: $7bf8e52e0c5d89c3$var$transformContent(action.content)
                    };
                case 'RESPONDERS':
                    return {
                        ...action,
                        context: action.context,
                        content: $7bf8e52e0c5d89c3$var$transformMultipleSectionContent(action.content)
                    };
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $7bf8e52e0c5d89c3$var$transformContent(action.content)
                    };
                case 'ASSIGNEE':
                    return {
                        ...action,
                        context: action.context,
                        content: $7bf8e52e0c5d89c3$var$transformMultipleSectionContent(action.content)
                    };
                default:
                    return $7bf8e52e0c5d89c3$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};

});


parcelRegister("k4ydi", function(module, exports) {
$parcel$export(module.exports, "getIssueDetails", () => $5ab464ac799fded4$export$da0733c355d205d6);
$parcel$export(module.exports, "contextPanelIssueDetailsResource", () => $5ab464ac799fded4$export$626ce3b2cb7fb94e);

var $5L2ti = parcelRequire("5L2ti");

var $n67Vb = parcelRequire("n67Vb");

var $40SbE = parcelRequire("40SbE");

var $aI7em = parcelRequire("aI7em");

var $jvGCa = parcelRequire("jvGCa");

var $7edbf = parcelRequire("7edbf");

const $5ab464ac799fded4$var$ISSUE_DETAILS_AGG_METRIC = 'context-panel-issue-details-agg';
const $5ab464ac799fded4$var$issueDetailsAggMetric = (0, $jvGCa.metrics).custom({
    key: $5ab464ac799fded4$var$ISSUE_DETAILS_AGG_METRIC
});
const $5ab464ac799fded4$export$da0733c355d205d6 = async (issueKey, cloudId, includeContextPanelState = false)=>{
    $5ab464ac799fded4$var$issueDetailsAggMetric.start();
    const issueDetails = await (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), (0, $5L2ti.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        includeContextPanelState: includeContextPanelState
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((data)=>{
        $5ab464ac799fded4$var$issueDetailsAggMetric.stop();
        return data;
    }).catch(()=>{
        $5ab464ac799fded4$var$issueDetailsAggMetric.cancel();
        return null; // only returning null instead of throwing error since it polluted overall SSR success rate
    });
    return {
        issueId: issueDetails?.jira?.issueByKey?.issueId ?? undefined,
        practice: issueDetails?.jira?.issueByKey?.fieldByIdOrAlias?.text ?? undefined,
        projectId: issueDetails?.jira?.issueByKey?.projectField?.project?.projectId ?? undefined,
        projectType: issueDetails?.jira?.issueByKey?.projectField?.project?.projectType ?? undefined,
        projectKey: issueDetails?.jira?.issueByKey?.projectField?.project?.key ?? undefined,
        isAIEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAIEnabled ?? undefined,
        ...includeContextPanelState && {
            isAiContextFeatureEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAiContextFeatureEnabled ?? undefined
        }
    };
};
const $5ab464ac799fded4$export$626ce3b2cb7fb94e = (0, $7edbf.createResource)({
    type: (0, $511fbf22fa5e01a8$export$3e1b459cf14e5bcd),
    getKey: ({ match: match, query: query })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        return `contextPanelIssueDetailsResource-${issueKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        const cloudId = tenantContext.cloudId;
        if (!(0, $40SbE.checkLicense)(tenantContext, 'servicedesk')) return null;
        if (!issueKey) /* only returning null instead of throwing error since it polluted overall SSR success rate */ /* until a better is implemented */ return null;
        return $5ab464ac799fded4$export$da0733c355d205d6(issueKey, cloudId, true);
    },
    maxAge: 3600000
});

});
parcelRegister("5L2ti", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ca114f43d864b46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb24b33bcdc4fc75976e61de4734e556>>
 * @relayHash b3cf4e4c05d0e067f2f9893508040771
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8aee3886aedea91dc835b7856906397dc676d3632c927b6d65354ebee56fa0f0
const $2ca114f43d864b46$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeContextPanelState"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "idOrAlias",
            "value": "servicedesk-practices"
        },
        {
            "kind": "Literal",
            "name": "ignoreMissingField",
            "value": true
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isAIEnabled"
    }, v8 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "condition": "includeContextPanelState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAiContextFeatureEnabled"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getIssueDetailsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\",ignoreMissingField:true)"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getIssueDetailsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\",ignoreMissingField:true)"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8aee3886aedea91dc835b7856906397dc676d3632c927b6d65354ebee56fa0f0",
            "metadata": {},
            "name": "getIssueDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2ca114f43d864b46$var$node.hash = "b419209901dbfa9aa3c805dc047fa75f";
var $2ca114f43d864b46$export$2e2bcd8739ae039 = $2ca114f43d864b46$var$node;

});



parcelRegister("ghc7e", function(module, exports) {
$parcel$export(module.exports, "ResolutionPlanSSRResource", () => $a051919d16eb87a8$export$75afc98ddd1588d5);
$parcel$export(module.exports, "getResolutionPlanSSRResource", () => $a051919d16eb87a8$export$2d38ef17a8f3f7a);

var $4lhmQ = parcelRequire("4lhmQ");

var $82pSL = parcelRequire("82pSL");

var $n67Vb = parcelRequire("n67Vb");

var $40SbE = parcelRequire("40SbE");

var $f99M0 = parcelRequire("f99M0");

var $8HUuJ = parcelRequire("8HUuJ");


var $aI7em = parcelRequire("aI7em");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $i8BNs = parcelRequire("i8BNs");

var $jvGCa = parcelRequire("jvGCa");


var $k4ydi = parcelRequire("k4ydi");
const $a051919d16eb87a8$var$NOT_ELIGIBLE = {
    eligible: false,
    projectId: undefined,
    issueId: undefined
};
function $a051919d16eb87a8$var$hasPlanExtras(plan) {
    return !!plan; // Runtime check is trivial, we trust the query shape
}
function $a051919d16eb87a8$var$settle(p) {
    return p.then((value)=>({
            status: 'fulfilled',
            value: value
        }), ()=>({
            status: 'pending'
        }));
}
// Attaches a passive listener to p at creation time so its settled value can be
// read synchronously after a microtask flush — avoids the race between settle()'s
// async .then() and Promise.resolve({pending}) in the deadline snapshot path.
function $a051919d16eb87a8$var$createSettler(p) {
    let result = {
        status: 'pending'
    };
    p.then((value)=>{
        result = {
            status: 'fulfilled',
            value: value
        };
    }, ()=>{
    // remain pending on rejection
    });
    return ()=>result;
}
async function $a051919d16eb87a8$var$raceToDeadline3(deadline, p1, p2, p3) {
    // Attach settlers eagerly so their callbacks are queued as soon as p1/p2 resolve
    const snap1 = $a051919d16eb87a8$var$createSettler(p1);
    const snap2 = $a051919d16eb87a8$var$createSettler(p2);
    const snap3 = $a051919d16eb87a8$var$createSettler(p3);
    return Promise.race([
        // Happy path: both settle before the deadline
        Promise.all([
            $a051919d16eb87a8$var$settle(p1),
            $a051919d16eb87a8$var$settle(p2),
            $a051919d16eb87a8$var$settle(p3)
        ]),
        // Deadline path: read synchronously after one microtask flush
        deadline.then(async ()=>{
            // One tick lets any already-resolved promise callbacks run
            await Promise.resolve();
            return [
                snap1(),
                snap2(),
                snap3()
            ];
        })
    ]);
}
const $a051919d16eb87a8$export$75afc98ddd1588d5 = (0, $7edbf.createResource)({
    type: (0, $511fbf22fa5e01a8$export$f864fe68374034cd),
    getKey: ({ match: match, query: query })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        return `ResolutionPlanSSRResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const resolutionPlanSSRMetric = (0, $jvGCa.metrics).custom({
            key: 'resolution-plan-ssr-resource'
        });
        resolutionPlanSSRMetric.start();
        let succeeded = false;
        let deadlineTimerId;
        try {
            if (!(0, $i860n.fg)('resolution-plan-panel-ssr')) return null;
            // Budget deadline
            const deadlinePromise = new Promise((resolve)=>{
                deadlineTimerId = setTimeout(()=>resolve('deadline'), (0, $511fbf22fa5e01a8$export$d0577c65f7af8359));
            });
            const { issueKey: issueKey } = routerDataContext.match.params;
            const { cloudId: cloudId, appEditions: appEditions } = resourceStoreContext.tenantContext;
            const isStandardEdition = appEditions.serviceDesk === 'STANDARD_EDITION';
            const isPremiumEdition = appEditions.serviceDesk === 'PREMIUM_EDITION';
            // ── Cheap sync guards ──
            if (!issueKey) return null;
            if (!(0, $40SbE.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk')) return null;
            const shouldShowPanel = isStandardEdition && (0, $i860n.fg)('standard-rollout-context-panel') || isPremiumEdition;
            if (!shouldShowPanel) return $a051919d16eb87a8$var$NOT_ELIGIBLE;
            // ── Phase 1: getIssueDetails (must complete before anything else) ──
            const resolutionPlanIssueDetailsMetric = (0, $jvGCa.metrics).custom({
                key: 'resolution-plan-ssr-issue-details'
            });
            resolutionPlanIssueDetailsMetric.start();
            const issueDetails = await (0, $k4ydi.getIssueDetails)(issueKey, cloudId, true);
            resolutionPlanIssueDetailsMetric.stop();
            if (!issueDetails || !issueDetails.issueId) return $a051919d16eb87a8$var$NOT_ELIGIBLE;
            const { isAIEnabled: isAIEnabled, practice: practice, projectType: projectType, issueId: issueId, projectId: projectId } = issueDetails;
            if (projectType !== (0, $f99M0.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT)) return $a051919d16eb87a8$var$NOT_ELIGIBLE;
            if (!isAIEnabled) return $a051919d16eb87a8$var$NOT_ELIGIBLE;
            const isServiceRequest = practice === (0, $6a18985c64d19567$export$a364d86306d4a6d4);
            const isNullPracticeEligible = practice === undefined && (0, $i860n.fg)('enable-resolution-panel-for-null-field-workitem');
            if (!isServiceRequest && !isNullPracticeEligible) return $a051919d16eb87a8$var$NOT_ELIGIBLE;
            if (!(0, $i860n.fg)('enable-esa-jsm-ga')) return $a051919d16eb87a8$var$NOT_ELIGIBLE;
            if (!issueId || !projectId) return $a051919d16eb87a8$var$NOT_ELIGIBLE;
            const projectAri = (0, $i8BNs.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString();
            // ── Phase 2: Fire ESA + Preview mode + Plan in parallel, race against remaining budget ──
            // ESA check
            const esaPromise = (0, $i860n.fg)('show-resolution-panel-when-request-type-validated') ? (0, $h2wCv.performGetRequest)(`/rest/api/3/issue/${issueId}/properties/esaRequestTypeValidated`).then((response)=>({
                    resolved: true,
                    validated: response?.value?.validated === true
                })).catch(()=>({
                    resolved: true,
                    validated: false
                })) : Promise.resolve({
                resolved: true,
                validated: true
            }); // gate OFF = skip
            // Preview mode check — gated by fg('preview_mode_enabled'). When the
            // gate is OFF we resolve to a "not-resolved + disabled" answer so the
            // downstream visibility helper short-circuits this check entirely and
            // no extra network traffic is generated on rollback.
            const previewModePromise = (0, $i860n.fg)('preview_mode_enabled') ? (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), (0, $82pSL.default), {
                jiraProjectAri: projectAri,
                experience: 'EMPLOYEE_SERVICE_AGENT'
            }, {
                fetchPolicy: 'network-only'
            }).toPromise().then((result)=>{
                const node = result?.jsmChannels_isPreviewModeEnabled;
                if (node && node.__typename === 'JsmChannelsPreviewModeConfiguration') return {
                    resolved: true,
                    enabled: node.enabled === true
                };
                return {
                    resolved: false,
                    enabled: false
                };
            }).catch(()=>({
                    resolved: false,
                    enabled: false
                })) : Promise.resolve({
                resolved: false,
                enabled: false
            }); // gate OFF = skip
            // Plan query
            const planPromise = (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), (0, $4lhmQ.default), {
                jiraProjectAri: projectAri,
                ticketId: issueId
            }, {
                fetchPolicy: 'network-only'
            }).toPromise().then((result)=>{
                const node = result?.jsmChannels_getServiceAgentResolutionStateByTicketId;
                if (node && node.__typename === 'JsmChannelsTicketServiceAgentResolutionState') {
                    const plan = node.plan;
                    // Check if plan exists AND satisfy TS that it has these fields via the predicate
                    // Note: We combine the checks to handle null/undefined plan
                    let planWithExtras = null;
                    if (plan && $a051919d16eb87a8$var$hasPlanExtras(plan)) planWithExtras = plan;
                    return {
                        resolved: true,
                        timedOut: false,
                        state: {
                            conversationId: node.conversationId ?? null,
                            isLoading: node.isLoading ?? null,
                            message: node.message ?? null,
                            plan: planWithExtras ? {
                                customPlanNodeAttributes: planWithExtras.customPlanNodeAttributes ? planWithExtras.customPlanNodeAttributes.map((a)=>({
                                        key: a?.key ?? null,
                                        value: a?.value ?? null
                                    })) : null,
                                planId: planWithExtras.planId ?? null,
                                status: planWithExtras.status ?? null,
                                steps: Array.isArray(planWithExtras.steps) ? planWithExtras.steps.map((step)=>{
                                    // Explicitly read fields to satisfy linter
                                    // Using optional chaining because generated types don't exist yet (handled by the cast we added earlier)
                                    const s = step;
                                    return {
                                        title: s?.title,
                                        description: s?.description,
                                        status: s?.status,
                                        assigneeType: s?.assigneeType
                                    };
                                }) : null,
                                runbooks: Array.isArray(planWithExtras.runbooks) ? planWithExtras.runbooks.map((runbook)=>{
                                    const r = runbook;
                                    return {
                                        confidenceScore: r?.confidenceScore,
                                        title: r?.title,
                                        url: r?.url
                                    };
                                }) : null,
                                contentSources: Array.isArray(planWithExtras.contentSources) ? planWithExtras.contentSources.map((source)=>{
                                    const cs = source;
                                    return {
                                        ari: cs?.ari,
                                        confidenceScore: cs?.confidenceScore,
                                        title: cs?.title,
                                        url: cs?.url,
                                        type: cs?.type,
                                        product: cs?.product
                                    };
                                }) : null
                            } : null
                        }
                    };
                }
                return {
                    resolved: true,
                    timedOut: false,
                    state: null
                };
            }).catch(()=>({
                    resolved: true,
                    timedOut: true,
                    state: null
                }));
            const [esaSettled, previewModeSettled, planSettled] = await $a051919d16eb87a8$var$raceToDeadline3(deadlinePromise, esaPromise, previewModePromise, planPromise);
            // ── Build partial result ──
            const esaCheckResolved = esaSettled.status === 'fulfilled';
            const esaValidated = esaCheckResolved ? esaSettled.value.validated : false;
            // If ESA check resolved and user is NOT validated, short-circuit
            if (esaCheckResolved && !esaValidated && (0, $i860n.fg)('show-resolution-panel-when-request-type-validated')) return $a051919d16eb87a8$var$NOT_ELIGIBLE;
            // Preview mode result (only meaningful when fg('preview_mode_enabled') is ON,
            // otherwise the promise resolves to { resolved: false, enabled: false }).
            const previewModeCheckResolved = previewModeSettled.status === 'fulfilled' && previewModeSettled.value.resolved === true;
            const previewModeEnabled = previewModeCheckResolved ? previewModeSettled.value.enabled : false;
            const planResolved = planSettled.status === 'fulfilled';
            succeeded = true;
            return {
                eligible: true,
                projectId: projectId,
                issueId: issueId,
                projectAri: projectAri,
                esaCheckResolved: esaCheckResolved,
                esaValidated: esaValidated,
                previewModeCheckResolved: previewModeCheckResolved,
                previewModeEnabled: previewModeEnabled,
                planQueryResolved: planResolved,
                initialState: planResolved ? planSettled.value.state : null,
                planQueryTimedOut: planResolved ? planSettled.value.timedOut : true
            };
        } finally{
            if (deadlineTimerId !== undefined) clearTimeout(deadlineTimerId);
            if (succeeded) resolutionPlanSSRMetric.stop();
            else resolutionPlanSSRMetric.cancel();
        }
    },
    maxAge: 30000 // 30s — plan data changes with user interactions
});
const $a051919d16eb87a8$export$2d38ef17a8f3f7a = ()=>{
    return [
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('resolution-plan-panel-ssr'), $a051919d16eb87a8$export$75afc98ddd1588d5)
    ];
};

});
parcelRegister("4lhmQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc35bf3b442b84f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47d0beaed867fb6226989760e5bcf9f1>>
 * @relayHash 638bac7b9e0c36f63a93dacf91f49d73
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 47c62643de44eeb465b6457f40828a8c74b43006640566b62fb4b9d776f1b9f3
const $fc35bf3b442b84f8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraProjectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ticketId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "message"
    }, v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "confidenceScore"
    }, v5 = {
        "kind": "ScalarField",
        "name": "url"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "jiraProjectAri",
                    "variableName": "jiraProjectAri"
                },
                {
                    "kind": "Variable",
                    "name": "ticketId",
                    "variableName": "ticketId"
                }
            ],
            "kind": "LinkedField",
            "name": "jsmChannels_getServiceAgentResolutionStateByTicketId",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "conversationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isLoading"
                        },
                        v1 /*: any*/ ,
                        {
                            "concreteType": "JsmChannelsServiceAgentResolutionPlan",
                            "kind": "LinkedField",
                            "name": "plan",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsmChannelsCustomPlanNodeAttribute",
                                    "kind": "LinkedField",
                                    "name": "customPlanNodeAttributes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "planId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JsmChannelsServiceAgentResolutionPlanStep",
                                    "kind": "LinkedField",
                                    "name": "steps",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "assigneeType"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JsmChannelsServiceAgentResolutionRunbook",
                                    "kind": "LinkedField",
                                    "name": "runbooks",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JsmChannelsServiceAgentResolutionContentSource",
                                    "kind": "LinkedField",
                                    "name": "contentSources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "ari"
                                        },
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JsmChannelsTicketServiceAgentResolutionState"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v1 /*: any*/ 
                    ],
                    "type": "QueryError"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ResolutionPlanSSRResourceQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ResolutionPlanSSRResourceQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "47c62643de44eeb465b6457f40828a8c74b43006640566b62fb4b9d776f1b9f3",
            "metadata": {},
            "name": "ResolutionPlanSSRResourceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fc35bf3b442b84f8$var$node.hash = "3fb9f09841646bb9e8481234f2983e57";
var $fc35bf3b442b84f8$export$2e2bcd8739ae039 = $fc35bf3b442b84f8$var$node;

});

parcelRegister("82pSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d16decddfff0548$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<31d037e92fd5b515c4b6fd34e0002f15>>
 * @relayHash 7d32c8336e50d9af2eaa064c10c8459b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c1258f05946117d1c09b0453d98adb138b614c69457279bb38c530c1d837f2d
const $5d16decddfff0548$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "jiraProjectAri",
            "variableName": "jiraProjectAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "enabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ResolutionPlanSSRResourcePreviewModeQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jsmChannels_isPreviewModeEnabled",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ 
                            ],
                            "type": "JsmChannelsPreviewModeConfiguration"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ResolutionPlanSSRResourcePreviewModeQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jsmChannels_isPreviewModeEnabled",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ],
                            "type": "JsmChannelsPreviewModeConfiguration"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c1258f05946117d1c09b0453d98adb138b614c69457279bb38c530c1d837f2d",
            "metadata": {},
            "name": "ResolutionPlanSSRResourcePreviewModeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5d16decddfff0548$var$node.hash = "802bbb6e2d9ff61e2e97406a9418c306";
var $5d16decddfff0548$export$2e2bcd8739ae039 = $5d16decddfff0548$var$node;

});


parcelRegister("3HYSN", function(module, exports) {
$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $2a699ebfd5270b6b$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $2a699ebfd5270b6b$export$ad16a91905cefb0a);
/* eslint-disable jira/filename-case */ const $2a699ebfd5270b6b$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $2a699ebfd5270b6b$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $2a699ebfd5270b6b$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $2a699ebfd5270b6b$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $2a699ebfd5270b6b$export$137d6d169f402a59 = [
    $2a699ebfd5270b6b$var$VENDOR_ASSET_REGEX,
    $2a699ebfd5270b6b$var$PARCEL_VENDOR_ASSET_REGEX
];
const $2a699ebfd5270b6b$export$ad16a91905cefb0a = [
    $2a699ebfd5270b6b$var$VENDOR_ASSET_REGEX,
    $2a699ebfd5270b6b$var$COMMON_ASSET_REGEX,
    $2a699ebfd5270b6b$var$PARCEL_VENDOR_ASSET_REGEX,
    $2a699ebfd5270b6b$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("fBZs7", function(module, exports) {
$parcel$export(module.exports, "issueViewRelayResource", () => $8536dc86bfe8b9ce$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $8536dc86bfe8b9ce$export$252bdba8c8e5f066);
// eslint-disable-next-line jira/import-whitelist

var $40rxp = parcelRequire("40rxp");

var $4zB4T = parcelRequire("4zB4T");

var $bkdOZ = parcelRequire("bkdOZ");

var $kfVxU = parcelRequire("kfVxU");

var $htsFl = parcelRequire("htsFl");

var $36Wqc = parcelRequire("36Wqc");

var $i860n = parcelRequire("i860n");

var $fZuTr = parcelRequire("fZuTr");
const $8536dc86bfe8b9ce$export$55131006e6699c0a = (0, $fZuTr.createRelayResourceDeprecated)({
    type: 'ISSUE_RELAY_DATA',
    captureErrors: true,
    captureTraceIds: !false,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        let issueKey = (0, $kfVxU.getIssueKey)(match);
        if (!issueKey && ((0, $i860n.fg)('nin_glance_panel_technical_changes') || (0, $i860n.fg)('nin_issue_app_conditional_entrypoint'))) issueKey = routerContext.query?.selectedIssue ?? '';
        const projectKey = issueKey ? (0, $40rxp.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey || '',
            projectKey: projectKey
        };
        if (issueKey && (0, $i860n.fg)('jfp-magma-mainissueaggquery-called-more-detector')) (0, $36Wqc.getAggOverfetchDetector)().setInitialIssueKey(issueKey);
        return {
            parameters: (0, $bkdOZ.default),
            variables: {
                ...queryVariables,
                ...(0, $4zB4T.getMainIssueViewAggQueryVariables)(issueKey)
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $4zB4T.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: issueKey || !((0, $i860n.fg)('nin_glance_panel_technical_changes') || (0, $i860n.fg)('nin_issue_app_conditional_entrypoint')) ? 'store-and-network' : 'store-only'
            }
        };
    },
    onFetchComplete: (config)=>{
        if ((0, $i860n.fg)('jfp-magma-mainissueaggquery-called-more-detector')) {
            const issueKey = config?.variables?.issueKey;
            if (issueKey) (0, $36Wqc.getAggOverfetchDetector)().onRouterResourceFetchComplete(issueKey);
        }
    }
});
const $8536dc86bfe8b9ce$export$252bdba8c8e5f066 = (options)=>(0, $htsFl.useRelayResource)($8536dc86bfe8b9ce$export$55131006e6699c0a, options);

});
parcelRegister("40rxp", function(module, exports) {
$parcel$export(module.exports, "extractProjectKey", () => $62e9f23ced24a1d4$export$f1a2e4721b127828);
const $62e9f23ced24a1d4$export$f1a2e4721b127828 = (issueKey)=>issueKey.split('-')[0];

});

parcelRegister("4zB4T", function(module, exports) {
$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $b9b2699de48ea925$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $b9b2699de48ea925$export$5896c8dc13246fe2);
$parcel$export(module.exports, "getCommentQueriesFromURL", () => $b9b2699de48ea925$export$e2c3bddbfc195841);
$parcel$export(module.exports, "getForgeSpecificVariables", () => $b9b2699de48ea925$export$cd553f3939fcf985);
/**
 * @fileOverview
 * All variables that get passed in to the mainIssueAggQuery are defined here.
 * The abstraction is necessary because there are multiple call paths to mainIssueAggQuery,
 * so having a single source of truth for the variables eliminates a vector for
 * bugs and inconsistencies when they are invoked.
 *
 * This file will be removed (and therefore the need for the linting exemption) once we reduce
 * the number of discrete call paths for mainIssueAggQuery to one. That work will be done in
 * https://jira.atlassian.com/browse/JIV-19486.
 *
 * Sorry, Tom.
 *
 * <3 Daz
 */ /* eslint-disable jira/ff/inline-usage */ 
var $7tjnB = parcelRequire("7tjnB");

var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");


var $aJDWs = parcelRequire("aJDWs");

var $jQs8Y = parcelRequire("jQs8Y");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $bS6BF = parcelRequire("bS6BF");

var $87ZgK = parcelRequire("87ZgK");

var $2HuOR = parcelRequire("2HuOR");

var $6bEm8 = parcelRequire("6bEm8");

var $aHmTX = parcelRequire("aHmTX");

var $bkdOZ = parcelRequire("bkdOZ");
// Cloned from @jira/issue-table__issue-table/src/common/constants.tsx
const $b9b2699de48ea925$var$MAX_AMOUNT_OF_COLUMNS = 500;
const $b9b2699de48ea925$var$IS_ISSUE_VIEW_CONTEXT_PANEL_FIELDS_REORDERING_ENABLED = false;
const $b9b2699de48ea925$var$hasActiveJiraSoftwareLicense = ()=>(0, $2HuOR.getLicensedProducts)((0, $6bEm8.default))[(0, $2HuOR.LICENSED_PRODUCTS).JIRA_SOFTWARE] === true && (0, $87ZgK.default)((0, $6bEm8.default)).software === (0, $7tjnB.LICENSE_STATE_ACTIVE);
const $b9b2699de48ea925$var$isTwcEntitlementCheckEnabled = ()=>$b9b2699de48ea925$var$hasActiveJiraSoftwareLicense() && (0, $i860n.fg)('twcg-1399_twc_project_kickoff_workflow_killswitch');
// Gates a backend-sensitive TWC co-use entitlement lookup that requires an active Jira Software
// license, so the fetch does not fire on non-JSW issue views (targeting already restricts the CTA
// to supported Jira Software project/issue types).
const $b9b2699de48ea925$var$isTwcCoUseRovoCheckEnabled = ()=>$b9b2699de48ea925$var$hasActiveJiraSoftwareLicense() && (0, $i860n.fg)('twcg_1846_twc_couse_jira_pt_rovo_create_killswitch');
const $b9b2699de48ea925$var$getMainIssueViewAggProvidedVariables = ()=>{
    const providerVariables = (0, $bkdOZ.default)?.params?.providedVariables ?? {};
    return Object.entries(providerVariables).reduce((acc, [key, provider])=>{
        acc[key] = provider.get();
        return acc;
    }, {});
};
const $b9b2699de48ea925$export$c98339377d1ac124 = ()=>{
    const isAnonymous = (0, $2HuOR.getIsAnonymous)((0, $6bEm8.default));
    return {
        /**
     * Enable the devai_rovodevIssueViewQuery fragment for fetching Rovo Dev entitlements
     * from the main Rovo Dev in Jira panel in the issue view.
     *
     * Fragment: RovodevAgentPanelWithEntitlementCheck
     * Component: RovodevAgentPanelWithEntitlementCheck
     */ issueViewRovoDevAgentsPanelEntitlementEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
        !(0, $i860n.fg)('devai_issue_view_query_separation') && ((0, $i860n.fg)('rovodev-in-jira-panel-is-anonymous-precondition') ? !isAnonymous : true) && (0, $i860n.fg)('boysenberry_rovodev_main_release') && (0, $i860n.fg)('boysenberry_enable_entitlements_check'),
        /**
     * Enable the devai_rovodevIssueViewQuery fragment for fetching Rovo Dev entitlements
     * for the Agents panel/assign to rovo flow in the issue view.
     *
     * Fragment: IssueViewAgentPanel_rovodevQuery
     * Component: IssueViewAgentPanel
     */ isAssignToRovoDevActive: // eslint-disable-next-line jira/ff/no-preconditioning
        !(0, $i860n.fg)('devai_issue_view_query_separation') && ((0, $i860n.fg)('rovodev-in-jira-panel-is-anonymous-precondition') ? !isAnonymous : true) && (0, $i860n.fg)('boysenberry_rovodev_main_release') && (0, $i860n.fg)('devai_assign_to_rovodev_main_release') && (0, $i860n.fg)('boysenberry_enable_entitlements_check')
    };
};
const $b9b2699de48ea925$export$3dd406718c5846c6 = ()=>({
        customFieldConfigurationFlag: (0, $i860n.fg)('issue_view_field_config_edit'),
        isProactiveIssueAISummaryEnabled: (0, $i860n.fg)('proactive_ai_generated_work_item_summary_m1_gate'),
        issueViewUserPreferredLayoutFieldEnabled: (0, $i860n.fg)('issue_view_layout_experiment_feature_gate'),
        issueViewDetailsPanelFieldsReorderingEnabled: (0, $2700E.expValEquals)('jira-work-item-reordering-fields-v2', 'reorderingBehaviour', 'withDragHandler', 'noReordering') || (0, $2700E.expValEquals)('jira-work-item-reordering-fields-v2', 'reorderingBehaviour', 'withoutDragHandler', 'noReordering'),
        // Keep the query shape for the later relay cleanup while forcing this path off in all cohorts.
        issueViewContextPanelFieldsReorderingEnabled: $b9b2699de48ea925$var$IS_ISSUE_VIEW_CONTEXT_PANEL_FIELDS_REORDERING_ENABLED,
        issueViewCoverExperimentEnabled: (0, $i860n.fg)('cover_image_issue_view_experiment_kill_switch') || (0, $i860n.fg)('cover_image_issue_view_ga'),
        includeCappedCommentDataForIssueViewedEvent: (0, $i860n.fg)('thor_add_metadata_for_experiment_learning'),
        isAutomationDiscoverabilityEnabled: (0, $i860n.fg)('automation_discoverability_in_jsm'),
        nikeDfoEcosystemBackgroundScriptsMigration: !(0, $i860n.fg)('nike-dfo-ecosystem-bg-scripts-migration-router'),
        ...$b9b2699de48ea925$export$c98339377d1ac124(),
        mentionedConfluencePageLinksV2PaginationFlag: (0, $i860n.fg)('jiv_confluence_remote_link_critical_query'),
        linkedWorkItemsTableEnabled: (0, $i860n.fg)('jiv_tabular_linked_work_item'),
        issueViewSlackSyncInfoEnabled: (0, $i860n.fg)('jira_issue_view_show_slack_sync_info'),
        issueViewGoalsFieldWithShowAllGoalsFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $i860n.fg)('jira_preview_panel_m_1_rollout') && (0, $i860n.fg)('jira-glance-panel'),
        relayMigrationWebLinksFlag: (0, $i860n.fg)('relay-migration-web-links-fetch'),
        relayMigrationIssueFieldAttachments: (0, $i860n.fg)('relay_migration_issue_field_attachments') && !(0, $2700E.expVal)('attachments-1p-consolidation-experiment', 'isExperimentEnabled', false),
        skipAttachmentsQuery: (0, $i860n.fg)('relay_migration_issue_field_attachments') || (0, $2700E.expVal)('attachments-1p-consolidation-experiment', 'isExperimentEnabled', false),
        relayMigrationChildrenIssuesSectionEnabled: (0, $i860n.fg)('relay_migration_children_issues_section'),
        isWorkItemModernizationEnabled: // eslint-disable-next-line jira/ff/no-work-item-modernization-exp-val
        (0, $2700E.expVal)('work_item_modernization', 'isEnabled', false) || (0, $i860n.fg)('enable_work_item_for_quadratic_release'),
        relayMigrationArchival: (0, $i860n.fg)('relay-migration-archival'),
        issueViewAtlasProjectFieldEnabled: (0, $aJDWs.isProjectsInJiraM0Enabled)(),
        isAiAgentSessionsPanelEnabled: (0, $i860n.fg)('jira_assignable_agent_session_experience'),
        removeIssueViewInteractivequeryM4: (0, $i860n.fg)('remove-issueviewinteractivequery-m4'),
        frontierFormulaFieldD1Flag: (0, $i860n.fg)('frontier-formula-field-d1'),
        frontierFormulaFieldD1TextFlag: (0, $i860n.fg)('frontier-formula-field-d2-d3'),
        frontierFormulaFieldD1DateFlag: (0, $i860n.fg)('frontier-formula-field-d2-d3'),
        prefetchChildIssuesPanelQuery: !(0, $i860n.fg)('jira-issue-view-child-work-items-ssr-fg'),
        // When child work SSR FG is enabled do not prefetch child issues panel query
        relayMigrationCommentCount: (0, $i860n.fg)('relay-migration-comment-count'),
        shouldFetchAppType: (0, $i860n.fg)('jira_ai_agent_avatar_tmp_board'),
        childWorkItemsSSRUIEnabled: (0, $i860n.fg)('jira-issue-view-child-work-items-ssr-fg'),
        isAttachmentsConsolidationEnabled: (0, $2700E.expVal)('attachments-1p-consolidation-experiment', 'isExperimentEnabled', false),
        isRcaV2UiEnabled: (0, $i860n.fg)('aiops_rca_v2_ui'),
        isJourneyExecutionsPanelEnabled: (0, $i860n.fg)('start-3737-journey-panel'),
        isAssignToRovoServiceButtonMainEnabled: (0, $i860n.fg)('separate_component_for_assign_rovo_service_button'),
        isJsmIncidentCommandCenterEnabled: (0, $i860n.fg)('jsm_incident_command_center'),
        isModernisedActivityFeedEnabled: (0, $i860n.fg)('jsm_aiwi_modernised_activity_feed'),
        isGuidedAutonomyEapEnabled: (0, $2700E.expVal)('frontier-guided-autonomy-eap', 'isEnabled', false),
        isCsmAgentWorkspaceEnabled: (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget'),
        isCsmAgentWorkspaceActionsEnabled: (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget'),
        isSmartRepliesV2Enabled: (0, $2700E.expVal)('jira-smart-replies-v2-main-agg-query-change-sprt', 'isEnabled', false),
        // Gates a backend-sensitive TWC entitlement lookup that requires an active Jira Software license.
        isTwcEntitlementCheckEnabled: !(0, $2HuOR.getIsAnonymous)((0, $6bEm8.default)) && $b9b2699de48ea925$var$isTwcEntitlementCheckEnabled(),
        // Enable the 1846-specific Rovo signal query only for the active experiment cohort.
        isTwcCoUseRovoCheckEnabled: !(0, $2HuOR.getIsAnonymous)((0, $6bEm8.default)) && $b9b2699de48ea925$var$isTwcCoUseRovoCheckEnabled(),
        commentsSortBy: {
            field: 'CREATED',
            order: 'DESC'
        },
        isJsmRequestFormsInRequestDetailsEnabled: (0, $i860n.fg)('jsm_request_forms_in_request_details'),
        shouldSkipCmdbSearchUrl: (0, $i860n.fg)('flash-839-remove-searchurl-from-cmdb-field'),
        isChatOpsEntitlementFromAggEnabled: (0, $i860n.fg)('jsm_main_issue_agg_chatops_entitlement'),
        skipAgentSessionsForAnonymous: (0, $i860n.fg)('jira-ai-read-agent-sessions') && (0, $2HuOR.getIsAnonymous)((0, $6bEm8.default))
    });
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $b9b2699de48ea925$var$getURLFromWindow = ()=>new URL(window.location.href);
const $b9b2699de48ea925$export$5896c8dc13246fe2 = (issueKey, url = $b9b2699de48ea925$var$getURLFromWindow())=>({
        // This value must be an insanely large number, otherwise we'll get some serious bugs! Remove once 'jpx-000-shadow-relay-query' experiment is completed.
        limitFields: 99999,
        ...$b9b2699de48ea925$var$getMainIssueViewAggProvidedVariables(),
        ...$b9b2699de48ea925$export$3dd406718c5846c6(),
        ...$b9b2699de48ea925$export$e2c3bddbfc195841(url),
        ...$b9b2699de48ea925$var$getStorageBannerVariables(),
        ...$b9b2699de48ea925$var$getIssueSearchForChildIssueQueryVariables(issueKey),
        ...$b9b2699de48ea925$export$cd553f3939fcf985(),
        ...$b9b2699de48ea925$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables(),
        ...$b9b2699de48ea925$var$getLinkedIssuesTableQueryVariables(issueKey),
        ...$b9b2699de48ea925$var$getStorageHardLimitVariables()
    });
const $b9b2699de48ea925$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables = ()=>{
    if (typeof window !== 'undefined') {
        const pathname = window.location.pathname;
        const pattern = /^\/jira\/software(?:\/c)?\/projects\/[^/]+\/boards\/\d+\/(calendar|timeline)$/;
        return {
            isInTimelineOrCalendarView: pattern.test(pathname)
        };
    }
    return {
        isInTimelineOrCalendarView: false
    };
};
const $b9b2699de48ea925$export$9f8034ef70f20a00 = ()=>{
    /**
   * Default fields we're fetching in child issues:
   * - issuetype: Used to separate base-level and subtasks in epics (see `jira-issue-view-child-issues-panel-merge-subtasks`)
   */ const childIssuesFieldIds = [
        'issuetype'
    ];
    // If we're not fetching the "Include subtasks" timetracking data through Relay
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $i860n.fg)('relay-migration-edit-worklog') && !(0, $i860n.fg)('jpx-93-unship-legacy-timetracking')) childIssuesFieldIds.push('timetracking');
    // If we're not fetching the progress summary status data through Relay,
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $i860n.fg)('jira-issue-view-child-issues-panel-realtime-update')) childIssuesFieldIds.push('status');
    return childIssuesFieldIds;
};
const $b9b2699de48ea925$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        issueSearchInput: (0, $i860n.fg)('jira-issue-view-child-work-items-ssr-fg') ? {
            jql: issueKey ? `parent = ${issueKey}` : ''
        } : {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        childIssuesFieldIds: $b9b2699de48ea925$export$9f8034ef70f20a00(),
        childIssuesAmountOfColumns: $b9b2699de48ea925$var$MAX_AMOUNT_OF_COLUMNS,
        childIssuesFirst: null,
        isInitialLoadQuery: true,
        shouldUseNewChildWorkItemsDatafetcher: (0, $i860n.fg)('jira_child_issues_new_datafetcher')
    });
const $b9b2699de48ea925$var$getLinkedIssuesTableQueryVariables = (issueKey)=>({
        linkedIssuesViewConfigInput: {
            viewInput: {
                namespace: 'LINKED_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        linkedIssuesFieldSetsInput: {
            viewInput: {
                namespace: 'LINKED_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        shouldIncludeRemoteIssues: false,
        isEditableSyncLoadedInIssueLinksTable: (0, $i860n.fg)('jira-issue-table-perf-enabled')
    });
const $b9b2699de48ea925$export$e2c3bddbfc195841 = (url)=>{
    const commentTargetId = (0, $jQs8Y.getPermalinkIdFromURL)((0, $jQs8Y.COMMENTS), url);
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $b9b2699de48ea925$var$getStorageBannerVariables = ()=>({
        issueViewStorageLimitsBannerFlag: (0, $bS6BF.default)((0, $6bEm8.default)).software === (0, $d8LhJ.FREE_EDITION),
        productKey: (0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d),
        changeOfferingOfferingName: 'standard'
    });
const $b9b2699de48ea925$export$cd553f3939fcf985 = (EXCLUDE_MODULES)=>{
    let allModules = [
        (0, $aHmTX.ISSUE_ACTION_MODULE),
        (0, $aHmTX.ISSUE_GLANCE_MODULE),
        (0, $aHmTX.ISSUE_CONTEXT_MODULE),
        (0, $aHmTX.ISSUE_PANEL_MODULE),
        (0, $aHmTX.ISSUE_ACTIVITY_MODULE),
        (0, $aHmTX.CUSTOM_FIELD_MODULE),
        (0, $aHmTX.CUSTOM_FIELD_TYPE_MODULE),
        (0, $aHmTX.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
        (0, $aHmTX.UI_MODIFICATIONS_MODULE)
    ];
    if (EXCLUDE_MODULES) allModules = allModules.filter((module)=>EXCLUDE_MODULES.includes(module));
    return {
        forgeTypes: allModules
    };
};
const $b9b2699de48ea925$var$getStorageHardLimitVariables = ()=>{
    /* ======================================================================================== */ /* To fetch attachmentStorageUsed from JiraQuery, using applicationKey: JIRA_SOFTWARE is appropriate. */ /* The applicationKey is an enum that specifies the application context, and JIRA_SOFTWARE is commonly */ /* used for Jira Software-related queries. */ /* ======================================================================================== */ return {
        applicationKey: (0, $hJL79.JIRA_SOFTWARE),
        issueViewAddAttachmentFlag: (0, $bS6BF.default)((0, $6bEm8.default)).software === (0, $d8LhJ.FREE_EDITION) && (0, $87ZgK.default)((0, $6bEm8.default)).software === (0, $7tjnB.LICENSE_STATE_ACTIVE)
    };
};

});
parcelRegister("jQs8Y", function(module, exports) {
$parcel$export(module.exports, "COMMENTS", () => $c436deb5b36d9683$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "getAllUrlParams", () => $c436deb5b36d9683$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $c436deb5b36d9683$export$87557f913748dcff);

var $1uH7N = parcelRequire("1uH7N");

var $6CfY5 = parcelRequire("6CfY5");
const $c436deb5b36d9683$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $c436deb5b36d9683$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $c436deb5b36d9683$export$df36fc05622c402 = 'WORKLOG';
const $c436deb5b36d9683$var$_diWindow = ()=>{
    (0, $1uH7N.di)(window);
    return window;
};
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $c436deb5b36d9683$export$dca91ad250f6b082 = ()=>{
    // get query string from  window
    let queryString = $c436deb5b36d9683$var$_diWindow().location.search.slice(1);
    // we'll store the parameters here
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $6CfY5.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $c436deb5b36d9683$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$c436deb5b36d9683$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $c436deb5b36d9683$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$c436deb5b36d9683$export$b18d061fc042df1a[targetPermalinkType]];
};
const $c436deb5b36d9683$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $c436deb5b36d9683$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});

parcelRegister("bkdOZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2989c7a6f17f942b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8854061dcceff019740e45e9fd81b9ee>>
 * @relayHash ed742964a280afbc5e2d46ed89589727
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f336be608bb99f13b9191d205f08d9f613b436abc16bc00dc15c48d9f45718af

var $aFVhf = parcelRequire("aFVhf");

var $1D6fx = parcelRequire("1D6fx");

var $i4Eve = parcelRequire("i4Eve");

var $8MXfm = parcelRequire("8MXfm");

var $KUiqF = parcelRequire("KUiqF");

var $efrbL = parcelRequire("efrbL");

var $hNa68 = parcelRequire("hNa68");

var $7yObX = parcelRequire("7yObX");

var $dZY9f = parcelRequire("dZY9f");

var $g1jeD = parcelRequire("g1jeD");

var $6MPPK = parcelRequire("6MPPK");

var $2OiA9 = parcelRequire("2OiA9");

var $7e655 = parcelRequire("7e655");

var $fV3TX = parcelRequire("fV3TX");

var $iCTPX = parcelRequire("iCTPX");

var $7zUJD = parcelRequire("7zUJD");

var $gQsSz = parcelRequire("gQsSz");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $2qgMb = parcelRequire("2qgMb");

var $lFWP3 = parcelRequire("lFWP3");

var $3etdx = parcelRequire("3etdx");

var $gE0jx = parcelRequire("gE0jx");

var $gSEQT = parcelRequire("gSEQT");

var $auBIl = parcelRequire("auBIl");

var $eJbZi = parcelRequire("eJbZi");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $1F2RS = parcelRequire("1F2RS");

var $hj1lc = parcelRequire("hj1lc");

var $18rp2 = parcelRequire("18rp2");

var $gCYbu = parcelRequire("gCYbu");

var $jRbnD = parcelRequire("jRbnD");

var $hLJKB = parcelRequire("hLJKB");

var $6qLgy = parcelRequire("6qLgy");

var $l4q64 = parcelRequire("l4q64");

var $e08II = parcelRequire("e08II");

var $1ZLvK = parcelRequire("1ZLvK");

var $1SctH = parcelRequire("1SctH");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $2XkhF = parcelRequire("2XkhF");

var $6BTmn = parcelRequire("6BTmn");

var $bdOMw = parcelRequire("bdOMw");

var $kyoX6 = parcelRequire("kyoX6");

var $jhYmN = parcelRequire("jhYmN");

var $gk902 = parcelRequire("gk902");

var $egon3 = parcelRequire("egon3");

var $jXd0g = parcelRequire("jXd0g");

var $b3Nht = parcelRequire("b3Nht");

var $lcsWS = parcelRequire("lcsWS");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $gyjgw = parcelRequire("gyjgw");

var $5ZdKP = parcelRequire("5ZdKP");

var $bstvV = parcelRequire("bstvV");

var $1w8Zj = parcelRequire("1w8Zj");

var $fCPPo = parcelRequire("fCPPo");

var $7so7Y = parcelRequire("7so7Y");

var $8bioU = parcelRequire("8bioU");

var $fFz9x = parcelRequire("fFz9x");

var $kdPlB = parcelRequire("kdPlB");

var $1JsCG = parcelRequire("1JsCG");

var $kvHcA = parcelRequire("kvHcA");

var $kkmRO = parcelRequire("kkmRO");

var $2JQfe = parcelRequire("2JQfe");

var $cNoBc = parcelRequire("cNoBc");

var $aIZjN = parcelRequire("aIZjN");

var $gmyGN = parcelRequire("gmyGN");

var $9HheZ = parcelRequire("9HheZ");

var $1A1H9 = parcelRequire("1A1H9");
const $2989c7a6f17f942b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f336be608bb99f13b9191d205f08d9f613b436abc16bc00dc15c48d9f45718af",
        "metadata": {},
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjracloud81233fixdisabledvotingrelayprovider": (0, $kvHcA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx": (0, $lFWP3.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiv22472HasSummaryToMIAQFeatureGate": (0, $1JsCG.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiv22469DevSummaryToMIAQRelayProvider": (0, $kdPlB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsDFOCreateBranchTargetsEnabledRelayProvidertsx": (0, $hNa68.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcimpedimentflagfragmentfetchrelayprovidertsx": (0, $1SctH.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx": (0, $fV3TX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx": (0, $iCTPX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": (0, $1F2RS.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissueviewcontextpanelfieldsreorderingrelayprovider": (0, $gk902.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $gmyGN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccoverimageissueviewgarelayprovider": (0, $jRbnD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmWfoAssigneeRecommendationOnQueuesRelayprovider": (0, $gQsSz.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmissueviewaffectedservicesrelayprovider": (0, $kkmRO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmOmniSourceChannelCfFeRelayProvider": (0, $hLJKB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider": (0, $6qLgy.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUserPickerGuestLozengeRelayprovider": (0, $gSEQT.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcgoalsfieldwithshowallgoalsrelayprovider": (0, $e08II.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraEnableClassificationControlEnforcementRelayprovider": (0, $8bioU.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraenableclassificationorgdefaultfgrelayprovider": (0, $gyjgw.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $gCYbu.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjirarelaymigrationarchivalrelayprovider": (0, $1w8Zj.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissueclonerelaymigrationrelayprovider": (0, $bdOMw.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuedeleterelaymigrationrelayprovider": (0, $kyoX6.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $9HheZ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissueviewlayoutepiccolorfgrelayprovider": (0, $egon3.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraAiDeeplinkInHeaderRelayProvider": (0, $fCPPo.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAiGeneratedWorkItemNextActionsM2RelayProvider": (0, $aFVhf.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiDeeplinkFastFollowsRelayProvidertsx": (0, $6MPPK.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatartmpboardrelayprovider": (0, $lcsWS.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveSimilarIssuesFromLinkedIssuesRelayProvider": (0, $3etdx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCanSetIssueRestrictionFromLinkedIssuesRelayProvider": (0, $2qgMb.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarissueviewcommentsrelayprovider": (0, $jXd0g.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider": (0, $dZY9f.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiLocalAgentSessionsEnabledRelayProvider": (0, $2OiA9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgenticPlanningRelayProvider": (0, $g1jeD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivFixRedirectionIssueKeyRelayProvidertsx": (0, $auBIl.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEnableWorkItemForQuadraticReleaseRelayProvidertsx": (0, $i4Eve.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $5ZdKP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraChildIssuesPaginationRelayProvider": (0, $7so7Y.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": (0, $efrbL.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $2XkhF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider": (0, $hj1lc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider": (0, $18rp2.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFixAiEnablementChecksInIssueViewRelayProvider": (0, $8MXfm.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcactivityPanelModernisationRelayProvider": (0, $eJbZi.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraissueviewshowslacksyncinforelayprovider": (0, $bstvV.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraSmartRepliesV2RelayProvider": (0, $fFz9x.default)
        }
    }
};
var $2989c7a6f17f942b$export$2e2bcd8739ae039 = $2989c7a6f17f942b$var$node;

});
parcelRegister("aFVhf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f66064c2bcb2ad6a$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $f66064c2bcb2ad6a$var$AiGeneratedWorkItemNextActionsM2RelayProvider = {
    get () {
        return (0, $2700E.expVal)('proactive_ai-generated_next_best_actions', 'isEnabled', false);
    }
};
var $f66064c2bcb2ad6a$export$2e2bcd8739ae039 = $f66064c2bcb2ad6a$var$AiGeneratedWorkItemNextActionsM2RelayProvider;

});

parcelRegister("1D6fx", function(module, exports) {
$parcel$export(module.exports, "default", () => $d05252e4b4f62aba$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $d05252e4b4f62aba$var$EmpanadaAssigneeAgentDelegateFixRelayprovider = {
    get () {
        return (0, $2700E.expVal)('empanada_assignee_agent_delegate_fix', 'isEnabled', false);
    }
};
var $d05252e4b4f62aba$export$2e2bcd8739ae039 = $d05252e4b4f62aba$var$EmpanadaAssigneeAgentDelegateFixRelayprovider;

});

parcelRegister("i4Eve", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e539eb45249fc54$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $4e539eb45249fc54$var$EnableWorkItemForQuadraticReleaseRelayProvider = {
    get () {
        return (0, $i860n.fg)('enable_work_item_for_quadratic_release');
    }
};
var $4e539eb45249fc54$export$2e2bcd8739ae039 = $4e539eb45249fc54$var$EnableWorkItemForQuadraticReleaseRelayProvider;

});

parcelRegister("8MXfm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f19458faa11c743$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $3f19458faa11c743$var$FixAiEnablementChecksInIssueViewRelayProvider = {
    get () {
        return (0, $i860n.fg)('fix_ai_enablement_checks_in_issue_view');
    }
};
var $3f19458faa11c743$export$2e2bcd8739ae039 = $3f19458faa11c743$var$FixAiEnablementChecksInIssueViewRelayProvider;

});

parcelRegister("KUiqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4067a9f4b6314a2b$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $4067a9f4b6314a2b$var$FrontierFormulaFieldD2D3Relayprovider = {
    get () {
        return (0, $i860n.fg)('frontier-formula-field-d2-d3');
    }
};
var $4067a9f4b6314a2b$export$2e2bcd8739ae039 = $4067a9f4b6314a2b$var$FrontierFormulaFieldD2D3Relayprovider;

});

parcelRegister("efrbL", function(module, exports) {
$parcel$export(module.exports, "default", () => $967d5970b71defda$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $967d5970b71defda$var$FrontierGuidedAutonomyEapRelayProvider = {
    get () {
        return (0, $2700E.expVal)('frontier-guided-autonomy-eap', 'isEnabled', false);
    }
};
var $967d5970b71defda$export$2e2bcd8739ae039 = $967d5970b71defda$var$FrontierGuidedAutonomyEapRelayProvider;

});

parcelRegister("hNa68", function(module, exports) {
$parcel$export(module.exports, "default", () => $db1d65fa86f99524$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $db1d65fa86f99524$var$IsDFOCreateBranchTargetsEnabledRelayProvider = {
    get () {
        return (0, $i860n.fg)('jpx-818-dfo-create-branch-targets');
    }
};
var $db1d65fa86f99524$export$2e2bcd8739ae039 = $db1d65fa86f99524$var$IsDFOCreateBranchTargetsEnabledRelayProvider;

});

parcelRegister("7yObX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b7063123f37b5ad$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $2b7063123f37b5ad$var$IssueTableDateRangeFieldRelayProvider = {
    get () {
        return (0, $i860n.fg)('issue_table_date_range_field');
    }
};
var $2b7063123f37b5ad$export$2e2bcd8739ae039 = $2b7063123f37b5ad$var$IssueTableDateRangeFieldRelayProvider;

});

parcelRegister("dZY9f", function(module, exports) {
$parcel$export(module.exports, "default", () => $a64edbea71e25eda$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $a64edbea71e25eda$var$JiraAiAgentTeamSessionsEnabledRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira-ai-read-agent-sessions');
    }
};
var $a64edbea71e25eda$export$2e2bcd8739ae039 = $a64edbea71e25eda$var$JiraAiAgentTeamSessionsEnabledRelayProvider;

});

parcelRegister("g1jeD", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f7a3206beb7030b$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $6f7a3206beb7030b$var$JiraAiAgenticPlanningRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira-ai-agentic-planning-technical-changes');
    }
};
var $6f7a3206beb7030b$export$2e2bcd8739ae039 = $6f7a3206beb7030b$var$JiraAiAgenticPlanningRelayProvider;

});

parcelRegister("6MPPK", function(module, exports) {
$parcel$export(module.exports, "default", () => $63842e7487da8d9a$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $63842e7487da8d9a$var$JiraAiDeeplinkFastFollowsRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_ai_deeplink_fast_follows');
    }
};
var $63842e7487da8d9a$export$2e2bcd8739ae039 = $63842e7487da8d9a$var$JiraAiDeeplinkFastFollowsRelayProvider;

});

parcelRegister("2OiA9", function(module, exports) {
$parcel$export(module.exports, "default", () => $538417a3c33d0d59$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $538417a3c33d0d59$var$JiraAiLocalAgentSessionsEnabledRelayProvider = {
    get () {
        return (0, $2700E.expVal)('deliveroo-team-sessions-local-session', 'isEnabled', false);
    }
};
var $538417a3c33d0d59$export$2e2bcd8739ae039 = $538417a3c33d0d59$var$JiraAiLocalAgentSessionsEnabledRelayProvider;

});

parcelRegister("7e655", function(module, exports) {
$parcel$export(module.exports, "default", () => $527efabfdf86c6cf$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $527efabfdf86c6cf$var$JivColouredDueDateUiChangesRelayprovider = {
    get () {
        return (0, $i860n.fg)('jiv-coloured-due-date-ui-changes');
    }
};
var $527efabfdf86c6cf$export$2e2bcd8739ae039 = $527efabfdf86c6cf$var$JivColouredDueDateUiChangesRelayprovider;

});

parcelRegister("fV3TX", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dd9870d26d5fc6c$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $4dd9870d26d5fc6c$var$JsmIncidentCommandCenterIncidentSummaryRelayProvider = {
    get () {
        return (0, $i860n.fg)('jsm_incident_command_center_incident_summary');
    }
};
var $4dd9870d26d5fc6c$export$2e2bcd8739ae039 = $4dd9870d26d5fc6c$var$JsmIncidentCommandCenterIncidentSummaryRelayProvider;

});

parcelRegister("iCTPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcd53642e8cd33d7$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $bcd53642e8cd33d7$var$JsmIncidentCommandCenterIncidentTimelineRelayProvider = {
    get () {
        return (0, $i860n.fg)('jsm_incident_command_center_incident_timeline');
    }
};
var $bcd53642e8cd33d7$export$2e2bcd8739ae039 = $bcd53642e8cd33d7$var$JsmIncidentCommandCenterIncidentTimelineRelayProvider;

});

parcelRegister("7zUJD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3379c273bbb15781$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $3379c273bbb15781$var$JsmSurfaceAgentAssigneeRelayProvider = {
    get () {
        return (0, $i860n.fg)('jsm-surface-agent-assignee');
    }
};
var $3379c273bbb15781$export$2e2bcd8739ae039 = $3379c273bbb15781$var$JsmSurfaceAgentAssigneeRelayProvider;

});

parcelRegister("gQsSz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2161c5032b0c3331$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $2161c5032b0c3331$var$JsmWfoAssigneeRecommendationOnQueuesRelayprovider = {
    get () {
        return (0, $i860n.fg)('jsm-wfo-assignee-recommendation-on-queues');
    }
};
var $2161c5032b0c3331$export$2e2bcd8739ae039 = $2161c5032b0c3331$var$JsmWfoAssigneeRecommendationOnQueuesRelayprovider;

});

parcelRegister("aIPay", function(module, exports) {
$parcel$export(module.exports, "default", () => $6687f96be187cfc1$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $6687f96be187cfc1$var$NinCaterRichTextWithPlainTextRendererRelayProvider = {
    get () {
        return (0, $2700E.expVal)('nin_handle_rich_text_with_plain_text_renderer', 'isEnabled', false);
    }
};
var $6687f96be187cfc1$export$2e2bcd8739ae039 = $6687f96be187cfc1$var$NinCaterRichTextWithPlainTextRendererRelayProvider;

});

parcelRegister("2JgIP", function(module, exports) {
$parcel$export(module.exports, "default", () => $439646cff604f3a6$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $439646cff604f3a6$var$NinFieldCellExtractionRelayProvider = {
    get () {
        return (0, $i860n.fg)('nin_field_cell_extraction');
    }
};
var $439646cff604f3a6$export$2e2bcd8739ae039 = $439646cff604f3a6$var$NinFieldCellExtractionRelayProvider;

});

parcelRegister("qRbQN", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc4b9c3948caa0b5$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $fc4b9c3948caa0b5$var$PrivateGoalsInJiraRelayProvider = {
    get () {
        return (0, $i860n.fg)('private_goals_in_jira');
    }
};
var $fc4b9c3948caa0b5$export$2e2bcd8739ae039 = $fc4b9c3948caa0b5$var$PrivateGoalsInJiraRelayProvider;

});

parcelRegister("2qgMb", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e258a0b9ea9e051$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $1e258a0b9ea9e051$var$RemoveCanSetIssueRestrictionFromLinkedIssuesRelayProvider = {
    get () {
        return (0, $i860n.fg)('flash960_remove_linkedissue_cansetissuerestriction');
    }
};
var $1e258a0b9ea9e051$export$2e2bcd8739ae039 = $1e258a0b9ea9e051$var$RemoveCanSetIssueRestrictionFromLinkedIssuesRelayProvider;

});

parcelRegister("lFWP3", function(module, exports) {
$parcel$export(module.exports, "default", () => $25a1de5a453d7a3e$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $25a1de5a453d7a3e$var$RemoveCtiaqConfigStateRelayProvider = {
    get () {
        return (0, $i860n.fg)('remove_ctiaq_config_state');
    }
};
var $25a1de5a453d7a3e$export$2e2bcd8739ae039 = $25a1de5a453d7a3e$var$RemoveCtiaqConfigStateRelayProvider;

});

parcelRegister("3etdx", function(module, exports) {
$parcel$export(module.exports, "default", () => $558a48a2b71fe078$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $558a48a2b71fe078$var$RemoveSimilarIssuesFromLinkedIssuesRelayProvider = {
    get () {
        return (0, $i860n.fg)('flash-896_remove_similar_issues_from_linked_issues');
    }
};
var $558a48a2b71fe078$export$2e2bcd8739ae039 = $558a48a2b71fe078$var$RemoveSimilarIssuesFromLinkedIssuesRelayProvider;

});

parcelRegister("gE0jx", function(module, exports) {
$parcel$export(module.exports, "default", () => $44992494362283a3$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $44992494362283a3$var$UseNodeIdForRowKeyDisabledRelayProvider = {
    get () {
        return !(0, $i860n.fg)('use_node_id_for_row_key');
    }
};
var $44992494362283a3$export$2e2bcd8739ae039 = $44992494362283a3$var$UseNodeIdForRowKeyDisabledRelayProvider;

});

parcelRegister("gSEQT", function(module, exports) {
$parcel$export(module.exports, "default", () => $eec4d616d2192de4$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $eec4d616d2192de4$var$UserPickerGuestLozengeRelayprovider = {
    get () {
        return (0, $i860n.fg)('user_picker_guest_lozenges');
    }
};
var $eec4d616d2192de4$export$2e2bcd8739ae039 = $eec4d616d2192de4$var$UserPickerGuestLozengeRelayprovider;

});

parcelRegister("auBIl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d51dd90ecbb2b42c$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $d51dd90ecbb2b42c$var$WivFixRedirectionIssueKeyRelayProvider = {
    get () {
        return (0, $i860n.fg)('wiv-fix-redirection-issue-key');
    }
};
var $d51dd90ecbb2b42c$export$2e2bcd8739ae039 = $d51dd90ecbb2b42c$var$WivFixRedirectionIssueKeyRelayProvider;

});

parcelRegister("eJbZi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b43de1430984b6e8$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $b43de1430984b6e8$var$activityPanelModernisationRelayProvider = {
    get () {
        return (0, $i860n.fg)('activity_panel_modernisation');
    }
};
var $b43de1430984b6e8$export$2e2bcd8739ae039 = $b43de1430984b6e8$var$activityPanelModernisationRelayProvider;

});

parcelRegister("aSs0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b1d5ef21f04faa8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $5b1d5ef21f04faa8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('assets_custom_fields_limit_increase') ? 50 : null;
    }
};

});

parcelRegister("1HnQt", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd3cfaf6e6eefcdc$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $aJDWs = parcelRequire("aJDWs");
var $dd3cfaf6e6eefcdc$export$2e2bcd8739ae039 = {
    get () {
        return (0, $aJDWs.isProjectsInJiraM0Enabled)();
    }
};

});

parcelRegister("1F2RS", function(module, exports) {
$parcel$export(module.exports, "default", () => $27fa076626c3bd04$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $27fa076626c3bd04$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('block_attachment_download_segregation');
    }
};

});

parcelRegister("hj1lc", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cab969f02f8103d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $9cab969f02f8103d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('boysenberry_enable_entitlements_check');
    }
};

});

parcelRegister("18rp2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5defa07efa49b081$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/ff/no-preconditioning */ 
var $i860n = parcelRequire("i860n");
var $5defa07efa49b081$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('boysenberry_rovodev_main_release') && (0, $i860n.fg)('automation-generate-code-action');
    }
};

});

parcelRegister("gCYbu", function(module, exports) {
$parcel$export(module.exports, "default", () => $5532b6ead339f205$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $5532b6ead339f205$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('conceal_items_in_meatball_menu_ga_fg');
    }
};

});

parcelRegister("jRbnD", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6600a78f6889e30$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $c6600a78f6889e30$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('cover_image_issue_view_ga');
    }
};

});

parcelRegister("hLJKB", function(module, exports) {
$parcel$export(module.exports, "default", () => $36034711078b5a2c$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $36034711078b5a2c$var$csmOmniSourceChannelCfFeRelayProvider = {
    get () {
        return (0, $i860n.fg)('csm_omni_source_channel_cf_fe');
    }
};
var $36034711078b5a2c$export$2e2bcd8739ae039 = $36034711078b5a2c$var$csmOmniSourceChannelCfFeRelayProvider;

});

parcelRegister("6qLgy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2ece1039e9a2a10$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $a2ece1039e9a2a10$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('frontier-formula-field-d1');
    }
};

});

parcelRegister("l4q64", function(module, exports) {
$parcel$export(module.exports, "default", () => $cae60955b574fc68$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $cae60955b574fc68$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('frontier-formula-field-nin');
    }
};

});

parcelRegister("e08II", function(module, exports) {
$parcel$export(module.exports, "default", () => $246131866e3cbbf1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $246131866e3cbbf1$export$2e2bcd8739ae039 = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $i860n.fg)('jira_preview_panel_m_1_rollout') && (0, $i860n.fg)('jira-glance-panel'));
    }
};

});

parcelRegister("1ZLvK", function(module, exports) {
$parcel$export(module.exports, "default", () => $458420b84926519c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $458420b84926519c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('hexagon-support') ?? false;
    }
};

});

parcelRegister("1SctH", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc2b1e1aa833b31d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $dc2b1e1aa833b31d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('relay-migration-issue-flag-fetch');
    }
};

});

parcelRegister("6fQZA", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe2fbfba66a097d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $1fe2fbfba66a097d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('initialise_virtualiser_state_from_relay_store');
    }
};

});

parcelRegister("i8kHQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fb4a89e3d090277$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $9fb4a89e3d090277$var$isIframePreviewPanelInSubtasksEnabled = {
    get () {
        return (0, $i860n.fg)('issue_preview_panel_issue_view_subtask');
    }
};
var $9fb4a89e3d090277$export$2e2bcd8739ae039 = $9fb4a89e3d090277$var$isIframePreviewPanelInSubtasksEnabled;

});

parcelRegister("1ZafW", function(module, exports) {
$parcel$export(module.exports, "default", () => $82770e1cebf1ba89$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
var $82770e1cebf1ba89$export$2e2bcd8739ae039 = {
    get () {
        return (0, $2700E.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
    }
};

});

parcelRegister("llli9", function(module, exports) {
$parcel$export(module.exports, "default", () => $eda7c58342808c04$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $eda7c58342808c04$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jira_inline_field_config_gate');
    }
};

});

parcelRegister("R0lic", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfdd88d8c77ec94e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $dfdd88d8c77ec94e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jsc_inline_edit_fast_follow_field_types');
    }
};

});

parcelRegister("2XkhF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8471e82060584afa$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $8471e82060584afa$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("6BTmn", function(module, exports) {
$parcel$export(module.exports, "default", () => $6136ce51fb8738f9$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $6136ce51fb8738f9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jira-forge-custom-fields-in-issue-navigator');
    }
};

});

parcelRegister("bdOMw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9eda5fa072e08e4c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $9eda5fa072e08e4c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('issue-clone-relay-migration');
    }
};

});

parcelRegister("kyoX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $65afeab9b0d0d91f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $65afeab9b0d0d91f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('issue-delete-relay-migration-continue');
    }
};

});

parcelRegister("jhYmN", function(module, exports) {
$parcel$export(module.exports, "default", () => $92f748fba261d600$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $92f748fba261d600$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('issue-table-color-field');
    }
};

});

parcelRegister("gk902", function(module, exports) {
$parcel$export(module.exports, "default", () => $037aa49ebffff6b4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
/**
 * Relay provider that checks if the context panel fields reordering experiment is enabled.
 * Used to conditionally fetch fieldOperations.canEdit in field components.
 */ const $037aa49ebffff6b4$var$issueViewContextPanelFieldsReorderingEnabled = {
    get () {
        return (0, $2700E.expValEquals)('jira-work-item-reordering-fields-v2', 'reorderingBehaviour', 'withDragHandler', 'noReordering') || (0, $2700E.expValEquals)('jira-work-item-reordering-fields-v2', 'reorderingBehaviour', 'withoutDragHandler', 'noReordering');
    }
};
var $037aa49ebffff6b4$export$2e2bcd8739ae039 = $037aa49ebffff6b4$var$issueViewContextPanelFieldsReorderingEnabled;

});

parcelRegister("egon3", function(module, exports) {
$parcel$export(module.exports, "default", () => $65d5f5765e5c390d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $65d5f5765e5c390d$var$isEpicColorFGEnabled = {
    get () {
        return (0, $i860n.fg)('issue-view-layout-epic-color-fg');
    }
};
var $65d5f5765e5c390d$export$2e2bcd8739ae039 = $65d5f5765e5c390d$var$isEpicColorFGEnabled;

});

parcelRegister("jXd0g", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1a269790092eb68$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $e1a269790092eb68$var$JiraAiAgentAvatarIssueViewCommentsRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_ai_agent_avatar_issue_view_comments');
    }
};
var $e1a269790092eb68$export$2e2bcd8739ae039 = $e1a269790092eb68$var$JiraAiAgentAvatarIssueViewCommentsRelayProvider;

});

parcelRegister("b3Nht", function(module, exports) {
$parcel$export(module.exports, "default", () => $353879ac97a966d3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $353879ac97a966d3$var$JiraAiAgentAvatarSingleUserPickerRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_ai_agent_avatar_single_user_picker');
    }
};
var $353879ac97a966d3$export$2e2bcd8739ae039 = $353879ac97a966d3$var$JiraAiAgentAvatarSingleUserPickerRelayProvider;

});

parcelRegister("lcsWS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dc39df4fa8aafd9$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $1dc39df4fa8aafd9$var$JiraAiAgentAvatarTmpBoardRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_ai_agent_avatar_tmp_board');
    }
};
var $1dc39df4fa8aafd9$export$2e2bcd8739ae039 = $1dc39df4fa8aafd9$var$JiraAiAgentAvatarTmpBoardRelayProvider;

});

parcelRegister("ch1QC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2403d3f5efe3e10c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $2403d3f5efe3e10c$var$JiraAiShowHumanSupervisorAvatarRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_ai_show_human_supervisor_avatar');
    }
};
var $2403d3f5efe3e10c$export$2e2bcd8739ae039 = $2403d3f5efe3e10c$var$JiraAiShowHumanSupervisorAvatarRelayProvider;

});

parcelRegister("7OGJO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3d4636b9be898b2$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $e3d4636b9be898b2$var$isJiraConfluencePageContentEnabled = {
    get () {
        return (0, $i860n.fg)('jira_preview_panel_m_1_rollout');
    }
};
var $e3d4636b9be898b2$export$2e2bcd8739ae039 = $e3d4636b9be898b2$var$isJiraConfluencePageContentEnabled;

});

parcelRegister("gyjgw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab98f9315ead689f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $ab98f9315ead689f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('enable_classification_org_default');
    }
};

});

parcelRegister("5ZdKP", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c8f0ab16562b0a4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $4c8f0ab16562b0a4$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});

parcelRegister("bstvV", function(module, exports) {
$parcel$export(module.exports, "default", () => $79482dfdc2a4fd74$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $79482dfdc2a4fd74$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jira_issue_view_show_slack_sync_info');
    }
};

});

parcelRegister("1w8Zj", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a14fad14f397b07$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $6a14fad14f397b07$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('relay-migration-archival');
    }
};

});

parcelRegister("fCPPo", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a6df4b310f5fe35$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $1a6df4b310f5fe35$var$jiraAiDeeplinkInHeaderRelayProvider = {
    get () {
        return (0, $2700E.expVal)('jira-ai-deeplink-in-header', 'isEnabled', false);
    }
};
var $1a6df4b310f5fe35$export$2e2bcd8739ae039 = $1a6df4b310f5fe35$var$jiraAiDeeplinkInHeaderRelayProvider;

});

parcelRegister("7so7Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $f364e3f8b9fae3ae$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $f364e3f8b9fae3ae$var$jiraChildIssuesPaginationRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_child_work_items_pagination');
    }
};
var $f364e3f8b9fae3ae$export$2e2bcd8739ae039 = $f364e3f8b9fae3ae$var$jiraChildIssuesPaginationRelayProvider;

});

parcelRegister("8bioU", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0bb74e09ad11cc$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $5a0bb74e09ad11cc$export$b8faf091a7ed028 = {
    get () {
        return (0, $i860n.fg)('enable_classification_control_on_issue_experiences');
    }
};
var $5a0bb74e09ad11cc$export$2e2bcd8739ae039 = $5a0bb74e09ad11cc$export$b8faf091a7ed028;

});

parcelRegister("fFz9x", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e1ab88d5f4037ad$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $2e1ab88d5f4037ad$var$jiraSmartRepliesV2RelayProvider = {
    get () {
        return (0, $2700E.expVal)('jira-smart-replies-v2-main-agg-query-change-sprt', 'isEnabled', false);
    }
};
var $2e1ab88d5f4037ad$export$2e2bcd8739ae039 = $2e1ab88d5f4037ad$var$jiraSmartRepliesV2RelayProvider;

});

parcelRegister("kdPlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $b69b7f265d2d665e$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $b69b7f265d2d665e$var$jiv22469DevSummaryToMIAQRelayProvider = {
    get () {
        return (0, $i860n.fg)('jiv-22469-dev-summary-to-miaq');
    }
};
var $b69b7f265d2d665e$export$2e2bcd8739ae039 = $b69b7f265d2d665e$var$jiv22469DevSummaryToMIAQRelayProvider;

});

parcelRegister("1JsCG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fa67c4c51aacdcc$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $5fa67c4c51aacdcc$var$jiv22472HasSummaryToMIAQFeatureGate = {
    get () {
        return (0, $i860n.fg)('jiv-22472-has-summary-to-miaq');
    }
};
var $5fa67c4c51aacdcc$export$2e2bcd8739ae039 = $5fa67c4c51aacdcc$var$jiv22472HasSummaryToMIAQFeatureGate;

});

parcelRegister("kvHcA", function(module, exports) {
$parcel$export(module.exports, "default", () => $25fe2d77637a21f1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $25fe2d77637a21f1$var$fixDisabledVoting = {
    get () {
        return (0, $i860n.fg)('jracloud-81233-fix-disabled-voting');
    }
};
var $25fe2d77637a21f1$export$2e2bcd8739ae039 = $25fe2d77637a21f1$var$fixDisabledVoting;

});

parcelRegister("kkmRO", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee2140c10060cdbc$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $ee2140c10060cdbc$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('ssring_affected_services_in_issue_view');
    }
};

});

parcelRegister("2JQfe", function(module, exports) {
$parcel$export(module.exports, "default", () => $5589a4a077a4e555$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $5589a4a077a4e555$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('mimic_flatlist_rss_while_uninitialised');
    }
};

});

parcelRegister("cNoBc", function(module, exports) {
$parcel$export(module.exports, "default", () => $cce87e8a5ff91c22$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $cce87e8a5ff91c22$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('nin-strikethrough-resolution-update');
    }
};

});

parcelRegister("aIZjN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1bd4951a2b78b72$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $c1bd4951a2b78b72$var$projectsInJiraGaDropRelayProvider = {
    get () {
        return (0, $i860n.fg)('projects_in_jira_ga_drop');
    }
};
var $c1bd4951a2b78b72$export$2e2bcd8739ae039 = $c1bd4951a2b78b72$var$projectsInJiraGaDropRelayProvider;

});

parcelRegister("gmyGN", function(module, exports) {
$parcel$export(module.exports, "default", () => $716b2474df689241$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $716b2474df689241$var$isIssueViewFieldConfigEditEnabled = {
    get () {
        return (0, $i860n.fg)('issue_view_field_config_edit');
    }
};
var $716b2474df689241$export$2e2bcd8739ae039 = $716b2474df689241$var$isIssueViewFieldConfigEditEnabled;

});

parcelRegister("9HheZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6503226cd6b4f8bf$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $i860n = parcelRequire("i860n");
var $6503226cd6b4f8bf$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("1A1H9", function(module, exports) {
$parcel$export(module.exports, "default", () => $69af079b254cafee$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $69af079b254cafee$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('use_node_id_for_row_key');
    }
};

});



parcelRegister("36Wqc", function(module, exports) {
$parcel$export(module.exports, "getAggOverfetchDetector", () => $0340c5d027747a80$export$5a2305b7a74f6278);

var $hFtK7 = parcelRequire("hFtK7");

var $gXtG2 = parcelRequire("gXtG2");
/**
 * This class helps detect if we are making more network requests than we expect for the mainIssueAggQuery query
 */ class $0340c5d027747a80$var$AggOverfetchDetector {
    /**
   * This is used for when we initially load the page and don't make additional network requests - eg through ssr
   * @param issueKey
   * @param forceSSRFetchSuccess If provided, forces the ssrFetchSuccess value instead of checking the globalThis window variable. This is mainly used for testing
   */ setInitialIssueKey(issueKey, forceSSRFetchSuccess) {
        if (!this.issueKey) {
            this.issueKey = issueKey;
            if (forceSSRFetchSuccess === undefined) {
                if (globalThis?.window?.SPA_STATE?.['ssr/render_status'] === 'success') this.ssrFetchSuccess = Boolean(globalThis?.window?.SPA_STATE?.['ssr/relay_fetch']?.mainIssueAggQuery);
            } else this.ssrFetchSuccess = forceSSRFetchSuccess;
        }
    }
    reset() {
        if (this.issueKey) this.previousIssueKeys.add(this.issueKey);
        this.issueKey = undefined;
        this.isDisabled = false;
        this.routerResourceFetched = false;
        this.relayFetches = 0;
        this.ssrFetchSuccess = false;
    }
    onRouterResourceFetchComplete(issueKey) {
        /**
     * We can't correctly tell if we're fetching again if we're navigating to an issue we've previously seen
     * eg, KAN-1 -> KAN-2 -> KAN-1
     *
     * I believe this is because the router resource will grab the data for the issue from the relay store since it already exists
     * but we then make another fetch outside that to get the correct data
     *
     * We end up detecting it as multiple fetches but we only do 1 network request (from non router resource)
     *
     * So if we are fetching from router resource for an old issue key, the detector ignores it
     */ if (this.previousIssueKeys.has(issueKey)) return;
        if (this.issueKey && this.issueKey !== issueKey) this.reset();
        this.issueKey = issueKey;
        if (this.isDisabled) return;
        this.routerResourceFetched = true;
        this.verifyNoOverfetch();
    }
    onRelayFetchComplete(issueKey) {
        if (this.issueKey && this.issueKey !== issueKey) this.reset();
        this.issueKey = issueKey;
        if (this.isDisabled) return;
        this.relayFetches += 1;
        this.verifyNoOverfetch();
    }
    verifyNoOverfetch() {
        if (this.isDisabled || this.hasSentAnalytics) return;
        const { routerResourceFetched: routerResourceFetched, relayFetches: standardFetches, ssrFetchSuccess: ssrFetchSuccess } = this;
        const totalFetches = (routerResourceFetched ? 1 : 0) + standardFetches + (ssrFetchSuccess ? 1 : 0);
        if (totalFetches > 1) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: new Error('AGG query overfetch detected'),
                meta: {
                    id: 'jiraIssueAggOverfetchDetector',
                    packageName: 'jiraIssueFetchOverfetchDetector',
                    teamName: 'Issue View - Kenji'
                },
                attributes: {
                    routerResourceFetched: routerResourceFetched,
                    standardFetches: standardFetches,
                    totalFetches: totalFetches,
                    ssrFetchSuccess: ssrFetchSuccess
                }
            });
            this.hasSentAnalytics = true;
        }
    }
    /**
   * Disables the overfetch detector for a specific issue key.
   * This is useful for when we know we will be calling mainIssueAggQuery again intentionally, eg for soft refresh after mutations
   * @param issueKey The issue key to disable the detector for.
   */ disableForIssueKey(issueKey) {
        if (this.issueKey === issueKey) this.isDisabled = true;
    }
    constructor(){
        this.previousIssueKeys = new Set();
        this.isDisabled = false;
        this.routerResourceFetched = false;
        this.relayFetches = 0;
        this.ssrFetchSuccess = false;
        this.hasSentAnalytics = false;
    }
}
$0340c5d027747a80$var$AggOverfetchDetector.displayName = "AggOverfetchDetector";
let $0340c5d027747a80$var$aggOverfetchDetector = new $0340c5d027747a80$var$AggOverfetchDetector();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $0340c5d027747a80$var$aggOverfetchDetector = new $0340c5d027747a80$var$AggOverfetchDetector();
});
const $0340c5d027747a80$export$5a2305b7a74f6278 = ()=>$0340c5d027747a80$var$aggOverfetchDetector;

});

parcelRegister("fZuTr", function(module, exports) {
$parcel$export(module.exports, "withResourceEarlyData", () => $e713e096e46a199b$export$22da5fb8c8200986);
$parcel$export(module.exports, "createRelayResourceDeprecated", () => $e713e096e46a199b$export$2e279339bedcd427);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $n67Vb = parcelRequire("n67Vb");

var $lIGkE = parcelRequire("lIGkE");

var $i860n = parcelRequire("i860n");

var $6xuJS = parcelRequire("6xuJS");

var $aI7em = parcelRequire("aI7em");

var $lMoch = parcelRequire("lMoch");

var $5SJ3N = parcelRequire("5SJ3N");

var $7edbf = parcelRequire("7edbf");

var $511Fu = parcelRequire("511Fu");
const $e713e096e46a199b$export$5664a170ac5a9781 = 5000;
const $e713e096e46a199b$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
            const promise = window[type]; // oxlint-disable-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};
const $e713e096e46a199b$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $e713e096e46a199b$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false, isCritical: isCritical = false, onFetchComplete: onFetchComplete })=>(0, $7edbf.createResource)({
        type: `${$e713e096e46a199b$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, storeContext)=>{
            const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, storeContext);
            // There are some variables that we don't want to trigger a reload even if they are changed, by default use 'variables', or you can also pass over
            // specific keyVariables that will trigger the reload
            const variables = keyVariables || queryVariables;
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            if ('kind' in preloadableRequest && preloadableRequest.kind === 'PreloadableConcreteRequest') {
                ({ params: params } = preloadableRequest);
                ({ id: queryId } = params);
            } else {
                // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
                // oxlint-disable-next-line @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $lIGkE.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, storeContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $6xuJS.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, storeContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $6xuJS.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $n67Vb.loadQuery)((0, $aI7em.default)(), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $5SJ3N.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $6xuJS.setMark)(endMark);
                (0, $6xuJS.setMeasure)(measureName, startMark, endMark);
                if ((0, $i860n.fg)('jfp-magma-mainissueaggquery-called-more-detector')) onFetchComplete?.({
                    parameters: parameters,
                    variables: variables,
                    options: options
                });
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $lMoch.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $511Fu.startCapturingTraceIds)(queryReference.name);
            // oxlint-disable-next-line typescript/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly,
        isCritical: isCritical
    });
const $e713e096e46a199b$export$2e279339bedcd427 = $e713e096e46a199b$var$createRelayResourceImpl;

});


parcelRegister("lTgGU", function(module, exports) {
$parcel$export(module.exports, "issueGiraDataResource", () => $5ced4c33c20cac2a$export$37badecd288c49f4);

var $kfVxU = parcelRequire("kfVxU");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

var $fZuTr = parcelRequire("fZuTr");

var $3ZTRC = parcelRequire("3ZTRC");
const $5ced4c33c20cac2a$export$37badecd288c49f4 = (0, $7edbf.createResource)((0, $fZuTr.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: (routerContext)=>{
        let issueKey = (0, $kfVxU.getIssueKey)(routerContext.match);
        if (!issueKey && ((0, $i860n.fg)('nin_glance_panel_technical_changes') || (0, $i860n.fg)('nin_issue_app_conditional_entrypoint'))) issueKey = routerContext.query?.selectedIssue ?? '';
        return issueKey || '';
    },
    getData: (...args)=>(0, $3ZTRC.default)(...args)
}));

});
parcelRegister("3ZTRC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bbdfe6a325374ca$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $8xlBj = parcelRequire("8xlBj");

var $bdEst = parcelRequire("bdEst");

var $kfVxU = parcelRequire("kfVxU");

var $i860n = parcelRequire("i860n");
const $4bbdfe6a325374ca$var$getData = async (routerContext, _storeContext)=>{
    let issueKey = (0, $kfVxU.getIssueKey)(routerContext.match);
    if (!issueKey && ((0, $i860n.fg)('nin_glance_panel_technical_changes') || (0, $i860n.fg)('nin_issue_app_conditional_entrypoint'))) issueKey = routerContext.query?.selectedIssue ?? '';
    if (!issueKey) return null;
    try {
        const data = await (0, $8xlBj.default)(issueKey);
        return data;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $bdEst.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};
var $4bbdfe6a325374ca$export$2e2bcd8739ae039 = $4bbdfe6a325374ca$var$getData;

});
parcelRegister("8xlBj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e1996b07511fbf5$export$2e2bcd8739ae039);

var $40rxp = parcelRequire("40rxp");

var $ko5sX = parcelRequire("ko5sX");

var $eQtEP = parcelRequire("eQtEP");

var $jvGCa = parcelRequire("jvGCa");

var $6bEm8 = parcelRequire("6bEm8");
const $2e1996b07511fbf5$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $2e1996b07511fbf5$var$timeToFetchIssueGiraDataMetric = (0, $jvGCa.metrics).custom({
    key: $2e1996b07511fbf5$var$ISSUE_GIRA_DATA
});
const $2e1996b07511fbf5$var$fetchIssueGiraData = async (issueKey)=>{
    const cloudId = (0, $6bEm8.default)('ajs-cloud-id');
    const projectKey = (0, $40rxp.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey,
        ...cloudId ? {
            cloudId: cloudId
        } : {}
    };
    const payload = {
        query: cloudId ? (0, $ko5sX.buildIssueQueryV2)() : (0, $ko5sX.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $ko5sX.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    const isInSample = (sampleRate = 100)=>Math.random() <= 1 / sampleRate;
    if (isInSample()) $2e1996b07511fbf5$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $eQtEP.getClient)('issue-fetch-service/src/services/issue-gira-data/index').query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $2e1996b07511fbf5$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $2e1996b07511fbf5$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};
var $2e1996b07511fbf5$export$2e2bcd8739ae039 = $2e1996b07511fbf5$var$fetchIssueGiraData;

});
parcelRegister("ko5sX", function(module, exports) {
$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $f7d4a2969f8bad30$export$1780a132c0453fee);
$parcel$export(module.exports, "buildIssueQuery", () => $f7d4a2969f8bad30$export$222ae9aca08830f0);
$parcel$export(module.exports, "buildIssueQueryV2", () => $f7d4a2969f8bad30$export$fd751aee2a193083);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $hOfIn = parcelRequire("hOfIn");

var $hO8eO = parcelRequire("hO8eO");

var $i860n = parcelRequire("i860n");

var $5uzWu = parcelRequire("5uzWu");
const $f7d4a2969f8bad30$export$1780a132c0453fee = 'issueViewInteractiveQuery';
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f7d4a2969f8bad30$var$getURLFromWindow = ()=>new URL(window.location.href);
const $f7d4a2969f8bad30$export$1a35060253e5a6cb = (_ = $f7d4a2969f8bad30$var$getURLFromWindow(), includeForgeQuery = true)=>`
    viewIssue(issueKey: $issueKey) {
        ${(0, $i860n.fg)('remove-issueviewinteractivequery-m4') ? '' : (0, $hO8eO.getEcosystemQuery)(includeForgeQuery)}
        ${(0, $hOfIn.getContentPanelsQuery)()}
	    ${!(0, $i860n.fg)('remove-issueviewinteractivequery-m4') ? (0, $hO8eO.getLegacyRightWebPanelsQuery)() : ''}
        ${(0, $5uzWu.getRemoteLinksQuery)()}
    }
`;
// Need viewIssue for prefetch jira/src/packages/issue/issue-view-app-provider/src/prefetched-data-consumption/index.tsx
const $f7d4a2969f8bad30$var$EMPTY_QUERY = `query ${$f7d4a2969f8bad30$export$1780a132c0453fee}($issueKey: String!) {
	viewIssue(issueKey: $issueKey) {
		__typename
	}
}`;
const $f7d4a2969f8bad30$export$222ae9aca08830f0 = (url)=>(0, $i860n.fg)('remove-issueviewinteractivequery-m4') // For now just making it return nothing to avoid errors - API call to be fully removed in JPX-597
     ? $f7d4a2969f8bad30$var$EMPTY_QUERY : `
query ${$f7d4a2969f8bad30$export$1780a132c0453fee}($issueKey: String!)  {
        ${!(0, $i860n.fg)('remove-issueviewinteractivequery-m4') ? $f7d4a2969f8bad30$export$1a35060253e5a6cb(url) : null}
    }

`;
const $f7d4a2969f8bad30$export$fd751aee2a193083 = (url)=>(0, $i860n.fg)('remove-issueviewinteractivequery-m4') // For now just making it return nothing to avoid errors - API call to be fully removed in JPX-597
     ? $f7d4a2969f8bad30$var$EMPTY_QUERY : `
query ${$f7d4a2969f8bad30$export$1780a132c0453fee}($issueKey: String!)  {
        ${!(0, $i860n.fg)('remove-issueviewinteractivequery-m4') ? $f7d4a2969f8bad30$export$1a35060253e5a6cb(url, /* includeForgeQuery */ false) : null}
    }
`;

});
parcelRegister("hOfIn", function(module, exports) {
$parcel$export(module.exports, "getContentPanelsQuery", () => $8e2d2e47e2717b2e$export$e6f14eac549b679d);

var $i860n = parcelRequire("i860n");
const $8e2d2e47e2717b2e$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $8e2d2e47e2717b2e$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$8e2d2e47e2717b2e$var$getContentPanelNode()}
            }
        }
    }
`;
const $8e2d2e47e2717b2e$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$8e2d2e47e2717b2e$var$getContentPanelNode()}
            }
        }
    }
`;
const $8e2d2e47e2717b2e$export$e6f14eac549b679d = ()=>`
    ${!(0, $i860n.fg)('remove-issueviewinteractivequery-m4') ? $8e2d2e47e2717b2e$var$getContentPanelsConnectionQuery() : ''}
    ${!(0, $i860n.fg)('remove-issueviewinteractivequery-m4') ? $8e2d2e47e2717b2e$var$getLegacyContentPanelsConnectionQuery() : ''}
`;

});

parcelRegister("hO8eO", function(module, exports) {
$parcel$export(module.exports, "getEcosystemQuery", () => $dda3cde387978989$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $dda3cde387978989$export$92c9a3dc7076af51);

var $i860n = parcelRequire("i860n");
const $dda3cde387978989$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $dda3cde387978989$export$edefef8c65e08bd2 = (includeForgeQuery = true)=>`
    ecosystem {
      ${(0, $i860n.fg)('remove-issueviewinteractivequery-m4') ? '' : `activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }`}
       ${(0, $i860n.fg)('remove-issueviewinteractivequery-m4') ? '' : `contextPanels {
            name
            iframe {
              addonKey
              moduleKey
              options
            }
            icon {
              url
            }
            content
            status
            type
          }`}
      ${includeForgeQuery ? $dda3cde387978989$var$getForgeQuery() : ''}
    }
`;
const $dda3cde387978989$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("5uzWu", function(module, exports) {
$parcel$export(module.exports, "getRemoteLinksQuery", () => $a05da821f7fb273d$export$6bbc6b72b0b57f25);

var $i860n = parcelRequire("i860n");
// Because jiv_confluence_remote_link_critical_query is paused, this is not used in issueViewInteractiveQuery
const $a05da821f7fb273d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
    }
`;
const $a05da821f7fb273d$var$getRemoteLinksQueryOld = ()=>'';
const $a05da821f7fb273d$export$6bbc6b72b0b57f25 = ()=>(0, $i860n.fg)('jiv_confluence_remote_link_critical_query') ? $a05da821f7fb273d$var$getRemoteLinksQueryNew() : $a05da821f7fb273d$var$getRemoteLinksQueryOld();

});


parcelRegister("eQtEP", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $3a4614cfd12221e6$export$6bb76d6eba7e258c);

var $gd6Ge = parcelRequire("gd6Ge");
const $3a4614cfd12221e6$var$appendOperationQuery = (operation)=>operation ? `?operation=${operation}` : '';
const $3a4614cfd12221e6$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${$3a4614cfd12221e6$var$appendOperationQuery(operation)}`;
const $3a4614cfd12221e6$var$makeFetchClient = (path)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $gd6Ge.default)($3a4614cfd12221e6$export$aefb19023b2eda55(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            }, path)
    });
let $3a4614cfd12221e6$var$client;
const $3a4614cfd12221e6$export$6bb76d6eba7e258c = (path)=>{
    if (!$3a4614cfd12221e6$var$client) $3a4614cfd12221e6$var$client = $3a4614cfd12221e6$var$makeFetchClient(path);
    return $3a4614cfd12221e6$var$client;
};

});
parcelRegister("gd6Ge", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e5b18af7ca6622f$export$2e2bcd8739ae039);
// Stryker disable all

var $dTLku = parcelRequire("dTLku");

var $4fhEY = parcelRequire("4fhEY");

var $75sVW = parcelRequire("75sVW");

var $i860n = parcelRequire("i860n");

var $dqbUI = parcelRequire("dqbUI");
async function $8e5b18af7ca6622f$export$2e2bcd8739ae039(url, options = {}, path) {
    if (!(0, $i860n.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $4fhEY.default)(url, options);
    const defaultExperienceDescription = {
        experience: (0, $dqbUI.isGiraUrl)(url) ? 'issueGira' : 'issueRest',
        analyticsSource: (0, $dqbUI.isGiraUrl)(url) ? 'issueGira' : 'issueRest',
        application: null,
        edition: null
    };
    try {
        const response = await (0, $4fhEY.default)(url, {
            ...options
        });
        return response;
    } catch (error) {
        if ((0, $75sVW.isFetchError)(error)) {
            const additionalAttributes = {
                statusCode: error.statusCode || 0,
                errorMessage: error.message || 'unknown',
                traceId: error.traceId || 'unknown',
                path: path
            };
            const statusCode = additionalAttributes.statusCode;
            let action = 'taskFail';
            if (statusCode && statusCode >= 400 && statusCode < 500) action = 'taskAbort';
            (0, $dTLku.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: action,
                additionalAttributes: additionalAttributes
            });
        }
        throw error;
    }
}

});
parcelRegister("dTLku", function(module, exports) {
$parcel$export(module.exports, "sendExperienceAnalytics", () => $dfa5311ba5ea8378$export$4a95ada1b8228562);

var $6Fltw = parcelRequire("6Fltw");

var $hbvZL = parcelRequire("hbvZL");

var $iYYeq = parcelRequire("iYYeq");

var $6bEm8 = parcelRequire("6bEm8");
const $dfa5311ba5ea8378$var$isSynthetic = ()=>(0, $6bEm8.default)('ajs-is-synthetic') === 'true';
function $dfa5311ba5ea8378$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $6bEm8.default)('ajs-shard');
    const region = (0, $6bEm8.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $hbvZL.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    const synthetics = {
        additionalAttributes: {
            synthetic: $dfa5311ba5ea8378$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(experienceDescription, synthetics);
    (0, $iYYeq.default)(experienceDescription);
}

});
parcelRegister("iYYeq", function(module, exports) {
$parcel$export(module.exports, "transformApplication", () => $56b30ba810ca3980$export$3b420a9303671264);
$parcel$export(module.exports, "transformEdition", () => $56b30ba810ca3980$export$ead6d3a398a3f5bd);
$parcel$export(module.exports, "default", () => $56b30ba810ca3980$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $6bEm8 = parcelRequire("6bEm8");

var $6Kdw4 = parcelRequire("6Kdw4");

var $a5nxD = parcelRequire("a5nxD");
const $56b30ba810ca3980$export$3b420a9303671264 = (application)=>{
    switch(application){
        case 0, $hJL79.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $hJL79.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $hJL79.JIRA_CORE:
            return 'jira-core';
        case 0, $hJL79.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $hJL79.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $56b30ba810ca3980$export$ead6d3a398a3f5bd = (edition)=>{
    switch(edition){
        case 0, $d8LhJ.FREE_EDITION:
            return 'jedi';
        case 0, $d8LhJ.STANDARD_EDITION:
            return 'standard';
        case 0, $d8LhJ.PREMIUM_EDITION:
            return 'premium';
        case 0, $d8LhJ.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $56b30ba810ca3980$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $56b30ba810ca3980$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $56b30ba810ca3980$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            ...location ? {
                reason: location
            } : {},
            ...field ? {
                field: field
            } : {},
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $56b30ba810ca3980$export$3b420a9303671264(application),
            edition: $56b30ba810ca3980$export$ead6d3a398a3f5bd(edition),
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout,
            ...!false ? {
                shard: (0, $6bEm8.default)('ajs-shard') || '',
                region: (0, $6bEm8.default)('ajs-region') || ''
            } : {}
        }
    });
/**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ const $56b30ba810ca3980$var$sendExperienceAnalytics = (experienceDescription)=>{
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $56b30ba810ca3980$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
var $56b30ba810ca3980$export$2e2bcd8739ae039 = $56b30ba810ca3980$var$sendExperienceAnalytics;

});


parcelRegister("dqbUI", function(module, exports) {
$parcel$export(module.exports, "isGiraUrl", () => $09e3d1d88769717b$export$ea636743f241905c);
const $09e3d1d88769717b$export$ea636743f241905c = (url)=>url.startsWith('/rest/gira/');

});






parcelRegister("2KHOK", function(module, exports) {
$parcel$export(module.exports, "browseIssueEmbedRoute", () => $f56d542b8a51b285$export$240aeec71c480594);
const $f56d542b8a51b285$export$240aeec71c480594 = {
    name: 'issue-embed',
    path: '/browse/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("9KYmb", function(module, exports) {
$parcel$export(module.exports, "draftReplyPillsResource", () => $2a87cc148da490b3$export$32559e5b2301734f);
$parcel$export(module.exports, "getDraftReplyPillsResource", () => $2a87cc148da490b3$export$a9a7e98a0742d55b);

var $40SbE = parcelRequire("40SbE");

var $jeR8Z = parcelRequire("jeR8Z");

var $7edbf = parcelRequire("7edbf");

var $4fhEY = parcelRequire("4fhEY");
const $2a87cc148da490b3$var$RESOURCE_TYPE_DRAFT_REPLY_PILLS = 'DRAFT_REPLY_PILLS_RESOURCE';
const $2a87cc148da490b3$export$32559e5b2301734f = (0, $7edbf.createResource)({
    type: $2a87cc148da490b3$var$RESOURCE_TYPE_DRAFT_REPLY_PILLS,
    getKey: ({ match: match, query: query })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        return `draftReplyPillsResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const issueKey = routerDataContext.match.params.issueKey || routerDataContext.query.selectedIssue || '';
        if (!issueKey) return null;
        // Check if service desk is enabled
        if (!(0, $40SbE.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk')) return null;
        // Serviedesk context call to identify agent permission
        // if role is not agent-project-admin or agent then return null
        const serviceDeskContext = await (0, $jeR8Z.default)(routerDataContext, resourceStoreContext);
        if (!(serviceDeskContext.userRole === 'agent-project-admin' || serviceDeskContext.userRole === 'agent')) return null;
        try {
            const endpoint = `/gateway/api/firebolt/1/agent-response/pills/work-item/${issueKey}`;
            const response = await (0, $4fhEY.default)(endpoint, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response;
        } catch (error) {
            return null;
        }
    },
    maxAge: 0,
    isBrowserOnly: true
});
const $2a87cc148da490b3$export$a9a7e98a0742d55b = ()=>{
    return [];
};

});
parcelRegister("jeR8Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e624c7c024d5e30a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $fLTsc = parcelRequire("fLTsc");

var $6xuJS = parcelRequire("6xuJS");

var $6CfY5 = parcelRequire("6CfY5");

var $4fhEY = parcelRequire("4fhEY");

var $khHvh = parcelRequire("khHvh");

var $i860n = parcelRequire("i860n");
// Sentinel returned ONLY when the servicedesk context API returns 404.
// 404 is a legitimate "this project has no service desk context" signal and
// should not bring down SSR. All permission-gating fields (userRole) are set
// to uninhabited values so every consumer's permission check fails closed.
const $e624c7c024d5e30a$var$SERVICEDESK_CONTEXT_NOT_FOUND_SENTINEL = {
    portalId: 0,
    serviceDeskId: 0,
    userRole: '',
    canSeeNewIssueView: false,
    portalUrl: '',
    customerUrl: ''
};
const $e624c7c024d5e30a$var$getData = async ({ match: match, query: query }, _storeContext)=>{
    const projectKey = (0, $fLTsc.getProjectKeyOrIdFromMatchAndQuery)({
        match: match,
        query: query
    });
    try {
        const data = await (0, $4fhEY.default)(`/rest/servicedesk/1/pages/agent/servicedesk/${projectKey}?operation=getProjectKeyOrIdFromMatchAndQuery`);
        (0, $6xuJS.setMark)((0, $khHvh.prefetchApiReadyMark));
        return data;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskContextResource',
                packageName: 'jiraRouterResourcesServiceDeskContext'
            },
            error: error
        });
        (0, $6CfY5.default).safeErrorWithoutCustomerData('spa.router.resource.sd.servicedesk.context', 'fetchData', error);
        // 404 means the project has no servicedesk context — treat as "no permission"
        // and return a benign sentinel instead of failing SSR. All other errors
        // (5xx, network, auth, etc.) re-throw so consumers/error boundaries handle
        // them as before.
        if (error?.statusCode === 404 && (0, $i860n.fg)('ssr_servicedesk_context_')) return $e624c7c024d5e30a$var$SERVICEDESK_CONTEXT_NOT_FOUND_SENTINEL;
        throw error;
    }
};
var $e624c7c024d5e30a$export$2e2bcd8739ae039 = $e624c7c024d5e30a$var$getData;

});


parcelRegister("9dMXV", function(module, exports) {
$parcel$export(module.exports, "projectGlobalComponentsResource", () => $c42df802e41d1683$export$d2cb7067a31cf873);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $d5fvg = parcelRequire("d5fvg");
const $c42df802e41d1683$export$be79e0677801e96e = 'PROJECT_GLOBAL_COMPONENTS';
const $c42df802e41d1683$export$d2cb7067a31cf873 = (0, $7edbf.createResource)({
    type: $c42df802e41d1683$export$be79e0677801e96e,
    getKey: (matchedRoute)=>(0, $i0CFV.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getData: (...args)=>(0, $d5fvg.getData)(...args)
});

});
parcelRegister("d5fvg", function(module, exports) {
$parcel$export(module.exports, "getData", () => $0cf90ed603eb4eeb$export$7a171f172be0782e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $i0CFV = parcelRequire("i0CFV");

var $h2wCv = parcelRequire("h2wCv");
const $0cf90ed603eb4eeb$export$7a171f172be0782e = async (matchedRoute, _storeContext)=>{
    const projectIdOrKey = (0, $i0CFV.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $0cf90ed603eb4eeb$export$1db3503600a1638e(projectIdOrKey);
};
const $0cf90ed603eb4eeb$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $0cf90ed603eb4eeb$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $0cf90ed603eb4eeb$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $0cf90ed603eb4eeb$var$getProjectId = async (projectKey)=>{
    const project = await (0, $h2wCv.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $0cf90ed603eb4eeb$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$0cf90ed603eb4eeb$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $0cf90ed603eb4eeb$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $0cf90ed603eb4eeb$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $0cf90ed603eb4eeb$var$url(projectId, $0cf90ed603eb4eeb$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $0cf90ed603eb4eeb$var$url(projectKey, $0cf90ed603eb4eeb$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $h2wCv.performGetRequest)(endpoint);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $0cf90ed603eb4eeb$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-pathfinders'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};

});


parcelRegister("U9h5y", function(module, exports) {
$parcel$export(module.exports, "getJsmIssueViewSlaPanelResource", () => $3d34ca23593bc25d$export$31e044b40ecfc470);
$parcel$export(module.exports, "useJsmIssueViewSlaPanelResource", () => $3d34ca23593bc25d$export$cc90b63080792845);
$parcel$export(module.exports, "getJsmIssueViewRelatedArticlesRouteResource", () => $3d34ca23593bc25d$export$21e419f592089b2c);
$parcel$export(module.exports, "useJsmIssueViewRelatedArticlesResource", () => $3d34ca23593bc25d$export$916df522dc3042e5);
$parcel$export(module.exports, "getJsmIssueViewPanelMetadataResource", () => $3d34ca23593bc25d$export$a554940160143ab0);
$parcel$export(module.exports, "useJsmIssueViewPanelMetadataResource", () => $3d34ca23593bc25d$export$31fd4a0106c4b38f);
$parcel$export(module.exports, "getJSDSharedNavigationResources", () => $3d34ca23593bc25d$export$3a69fad68fa70b9);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $kfVxU = parcelRequire("kfVxU");


var $l8UJH = parcelRequire("l8UJH");

var $dkOZx = parcelRequire("dkOZx");

var $8HUuJ = parcelRequire("8HUuJ");

var $4Rvd7 = parcelRequire("4Rvd7");

var $i860n = parcelRequire("i860n");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $4fhEY = parcelRequire("4fhEY");
const $3d34ca23593bc25d$var$wrapResourceWithServiceDeskLicenseCheck = (resource)=>(0, $8HUuJ.safeCloneResource)(resource, {
        getData: async (routerDataContext, resourceStoreContext)=>{
            const { tenantContext: tenantContext } = resourceStoreContext;
            if (tenantContext.appEditions.serviceDesk === 'UNLICENSED') return null;
            try {
                return await resource.getData(routerDataContext, resourceStoreContext);
            } catch (error) {
                if (error instanceof Error && 'statusCode' in error && (error.statusCode === 401 || error.statusCode === 403 || error.statusCode === 404)) return null;
                throw error;
            }
        }
    });
const $3d34ca23593bc25d$var$jsmIssueViewSlaPanelResource = (0, $7edbf.createResource)({
    type: 'JSM_ISSUE_VIEW_SLA_PANEL_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match);
        if (!issueKey) {
            if (query && query.selectedIssue) return query.selectedIssue || '';
        }
        return issueKey || '';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        if (tenantContext.appEditions.serviceDesk === 'UNLICENSED') return null;
        let issueKey = (0, $kfVxU.getIssueKey)(match);
        if (!issueKey) {
            if (query && query.selectedIssue) issueKey = query.selectedIssue;
        }
        if (!issueKey) return null;
        try {
            const url = `/rest/servicedesk/1/servicedesk/sla/issue/${issueKey}?operation=jsmIssueViewSlaPanelResource`;
            const response = await (0, $4fhEY.default)(url, {
                method: 'GET'
            });
            if (!response.errors) return response;
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error instanceof Error ? error : new Error(String(error)),
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    id: 'jsmIssueViewSlaPanelResource',
                    packageName: 'jiraRouterResourcesJsmIssueView',
                    teamName: 'jsd-shield'
                }
            });
        }
        return null;
    }
});
const $3d34ca23593bc25d$export$31e044b40ecfc470 = ()=>$3d34ca23593bc25d$var$jsmIssueViewSlaPanelResource;
const $3d34ca23593bc25d$export$cc90b63080792845 = ()=>{
    return (0, $k6ufm.useResource)($3d34ca23593bc25d$var$jsmIssueViewSlaPanelResource);
};
// eslint-disable-next-line jira/router/no-daisy-chaining-resources
const $3d34ca23593bc25d$var$jsmIssueViewRelatedArticlesResource = (0, $7edbf.createResource)({
    type: 'JSM_ISSUE_VIEW_RELATED_ARTICLES_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match);
        if (!issueKey) {
            if (query && query.selectedIssue) return query.selectedIssue || '';
        }
        return issueKey || '';
    },
    depends: [
        (0, $feef523243843e2f$export$80a60a092d9ab81)
    ],
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: tenantContext })=>{
        if (tenantContext.appEditions.serviceDesk === 'UNLICENSED') return null;
        let issueKey = (0, $kfVxU.getIssueKey)(match);
        if (!issueKey) {
            if (query && query.selectedIssue) issueKey = query.selectedIssue;
        }
        if (!issueKey) return null;
        const consumedDependency = await (0, $l8UJH.consumeDependency)(dependencies, (0, $feef523243843e2f$export$80a60a092d9ab81));
        if (consumedDependency) {
            const { projectType: projectType } = consumedDependency;
            if (projectType !== 'service_desk') return null;
        }
        if (false) {
            const serverUrl = `/api/issue/${issueKey}/articles?operation=jsmIssueViewRelatedArticlesResourceconst `;
            return (0, $4fhEY.default)(serverUrl, {
                method: 'GET',
                headers: {
                    'x-ssr-service-name': 'jsd-apollo',
                    'atl-cloudid': tenantContext.cloudId
                }
            });
        }
        const clientUrl = `/gateway/api/jsd-apollo-stargate/sharded/workspace/${tenantContext.activationId}/api/issue/${issueKey}/articles?operation=jsmIssueViewRelatedArticlesResource`;
        return (0, $4fhEY.default)(clientUrl, {
            method: 'GET'
        });
    }
});
const $3d34ca23593bc25d$export$91bb55791d9e1362 = Object.defineProperties((0, $8HUuJ.safeCloneResource)($3d34ca23593bc25d$var$jsmIssueViewRelatedArticlesResource, {}), {
    skipBrowser: {
        configurable: true,
        enumerable: true,
        get: ()=>(0, $i860n.fg)('jsm_kb_glance_internal_articles')
    },
    isBrowserOnly: {
        configurable: true,
        enumerable: true,
        get: ()=>(0, $i860n.fg)('jsm_kb_glance_internal_articles')
    }
});
const $3d34ca23593bc25d$export$21e419f592089b2c = ()=>$3d34ca23593bc25d$export$91bb55791d9e1362;
const $3d34ca23593bc25d$export$ae254d90098bb89b = ()=>$3d34ca23593bc25d$var$jsmIssueViewRelatedArticlesResource;
const $3d34ca23593bc25d$export$916df522dc3042e5 = ()=>{
    return (0, $k6ufm.useResource)($3d34ca23593bc25d$var$jsmIssueViewRelatedArticlesResource);
};
const $3d34ca23593bc25d$var$jsmIssueViewPanelMetadataResource = (0, $7edbf.createResource)({
    type: 'JSM_ISSUE_VIEW_PANEL_METADATA_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match);
        if (!issueKey) {
            if (query && query.selectedIssue) return query.selectedIssue || '';
        }
        return issueKey || '';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        if (tenantContext.appEditions.serviceDesk === 'UNLICENSED') return null;
        let issueKey = (0, $kfVxU.getIssueKey)(match);
        if (!issueKey) {
            if (query && query.selectedIssue) issueKey = query.selectedIssue;
        }
        if (!issueKey) return null;
        const url = `/rest/servicedesk/1/servicedesk/request/${issueKey}/request-panel-metadata?operation=jsmIssueViewPanelMetadataResource`;
        try {
            return await (0, $4fhEY.default)(url, {
                method: 'GET'
            });
        } catch (error) {
            if (error instanceof Error && 'statusCode' in error && (error.statusCode === 401 || error.statusCode === 403 || error.statusCode === 404)) return null;
            throw error;
        }
    }
});
const $3d34ca23593bc25d$export$a554940160143ab0 = ()=>$3d34ca23593bc25d$var$jsmIssueViewPanelMetadataResource;
const $3d34ca23593bc25d$export$31fd4a0106c4b38f = ()=>{
    return (0, $k6ufm.useResource)($3d34ca23593bc25d$var$jsmIssueViewPanelMetadataResource);
};
const $3d34ca23593bc25d$export$3a69fad68fa70b9 = ()=>{
    return [
        $3d34ca23593bc25d$var$wrapResourceWithServiceDeskLicenseCheck((0, $dkOZx.requiredProjectProperties)),
        $3d34ca23593bc25d$var$wrapResourceWithServiceDeskLicenseCheck((0, $dkOZx.requiredFrontendProperties)),
        $3d34ca23593bc25d$var$wrapResourceWithServiceDeskLicenseCheck((0, $dkOZx.firstProjectResource)),
        $3d34ca23593bc25d$var$wrapResourceWithServiceDeskLicenseCheck((0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource))
    ];
};

});

parcelRegister("d1wnP", function(module, exports) {
$parcel$export(module.exports, "jsmMIMEntitlementResource", () => $c89748f19aa03fa5$export$972b28729379ca5f);
$parcel$export(module.exports, "useJsmMimEntitlementResource", () => $c89748f19aa03fa5$export$db2d9c66103c357c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $c89748f19aa03fa5$export$972b28729379ca5f = (0, $7edbf.createResource)({
    type: 'JSM_MIM_ENTITLEMENT',
    getKey: ()=>'JSM_MIM_ENTITLEMENT',
    getDataLoader: ()=>(parcelRequire("kSQbQ")),
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: false
});
const $c89748f19aa03fa5$export$db2d9c66103c357c = (cloudId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)($c89748f19aa03fa5$export$972b28729379ca5f);
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $euxye.useMemo)(()=>{
        if (error || loading || !data || !cloudId) return {
            isEntitled: false
        };
        const { isEntitled: isEntitled } = data;
        return {
            isEntitled: isEntitled
        };
    }, [
        data,
        loading,
        error,
        cloudId
    ]);
};

});
parcelRegister("kSQbQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eMcIf").then(()=>parcelRequire('2Xirz'));

});


parcelRegister("3e0pb", function(module, exports) {
$parcel$export(module.exports, "issueViewRemoteDataResource", () => $de6036368c6162ba$export$6942f0cc7b5c5ffd);

var $kfVxU = parcelRequire("kfVxU");

var $8HUuJ = parcelRequire("8HUuJ");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

var $jcPlK = parcelRequire("jcPlK");
const $de6036368c6162ba$export$6942f0cc7b5c5ffd = (0, $8HUuJ.browserOnlyResourceWithCondition)(()=>{
    return !(0, $i860n.fg)('dfo_issue_view_remote_data_srr_group');
}, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
(0, $7edbf.createResource)({
    type: 'ISSUE_VIEW_REMOTE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $jcPlK.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("jcPlK", function(module, exports) {
$parcel$export(module.exports, "default", () => $364800448b0c6b63$export$2e2bcd8739ae039);
/* eslint-disable jira/import-whitelist */ 
var $6XHg5 = parcelRequire("6XHg5");

var $l51v2 = parcelRequire("l51v2");

var $1oakV = parcelRequire("1oakV");

var $kfVxU = parcelRequire("kfVxU");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");
const $364800448b0c6b63$var$getIssueViewRemoteData = async ({ match: match }, _storeContext)=>{
    const issueKey = (0, $kfVxU.getIssueKey)(match);
    if (!issueKey) return null;
    // Feature flag to control whether we return data (SSR) or just prefetch (old behavior)
    if ((0, $i860n.fg)('dfo_issue_view_remote_data_srr_group')) {
        // Fetch the remote data and await the result for SSR
        const { tenantContext: tenantContext } = _storeContext;
        const cloudId = tenantContext?.cloudId;
        const promise = (0, $6XHg5.prefetchedRemoteDataManager).fetchTransformAndStore(issueKey, cloudId);
        const remoteData = await promise;
        const [smartlinkResult, weblinksSmartlinkResult] = await Promise.allSettled([
            (0, $l51v2.fetchConfluenceSmartlinkData)(remoteData, cloudId),
            (0, $1oakV.fetchWeblinksSmartlinkData)(remoteData, cloudId)
        ]);
        if (smartlinkResult.status === 'rejected') (0, $6CfY5.default).safeInfoWithoutCustomerData('issue-view-remote-data.get-data', 'An error was thrown while prefetching confluence smart link data');
        if (weblinksSmartlinkResult.status === 'rejected') (0, $6CfY5.default).safeInfoWithoutCustomerData('issue-view-remote-data.get-data', 'An error was thrown while prefetching weblinks smart link data');
        const smartlinkData = smartlinkResult.status === 'fulfilled' ? smartlinkResult.value : null;
        const weblinksSmartlinkData = weblinksSmartlinkResult.status === 'fulfilled' ? weblinksSmartlinkResult.value : null;
        return {
            remoteData: remoteData,
            smartlinkData: smartlinkData,
            weblinksSmartlinkData: weblinksSmartlinkData
        };
    }
    // Old behavior: just prefetch, don't return data
    (0, $6XHg5.prefetchedRemoteDataManager).prefetch(issueKey);
    return null;
};
var $364800448b0c6b63$export$2e2bcd8739ae039 = $364800448b0c6b63$var$getIssueViewRemoteData;

});
parcelRegister("6XHg5", function(module, exports) {
$parcel$export(module.exports, "prefetchedRemoteDataManager", () => $551bba26f72772d0$export$1d81e79fc6260e6d);

var $tFNvz = parcelRequire("tFNvz");
class $551bba26f72772d0$export$b5a5c1dfc61a5193 {
    prefetch(issueKey) {
        const promise = (0, $tFNvz.fetchIssueViewRemoteData)(issueKey);
        this.cache.set(issueKey, promise);
    }
    getOrFetch(issueKey) {
        if (this.cache.has(issueKey)) return this.cache.get(issueKey);
        const promise = (0, $tFNvz.fetchIssueViewRemoteData)(issueKey);
        this.cache.set(issueKey, promise);
        return promise;
    }
    consume(issueKey) {
        const promise = this.getOrFetch(issueKey);
        this.cache.delete(issueKey);
        return promise;
    }
    fetchTransformAndStore(issueKey, cloudId) {
        /**
     * We use this function to fetch and transform the data for SSR,
     * we then store the raw data for follow up calls to avoid duplicate calls
     */ return (0, $tFNvz.fetchIssueViewRemoteDataAndTransform)(issueKey, cloudId, (rawDataPromise)=>this.cache.set(issueKey, rawDataPromise));
    }
    constructor(){
        this.cache = new Map();
    }
}
$551bba26f72772d0$export$b5a5c1dfc61a5193.displayName = "PrefetchedIssueViewRemoteDataManager";
const $551bba26f72772d0$export$1d81e79fc6260e6d = new $551bba26f72772d0$export$b5a5c1dfc61a5193();

});
parcelRegister("tFNvz", function(module, exports) {
$parcel$export(module.exports, "fetchIssueViewRemoteData", () => $f8db2c72b08f2e33$export$35db3378e2f116e4);
$parcel$export(module.exports, "fetchIssueViewRemoteDataAndTransform", () => $f8db2c72b08f2e33$export$a78291fba468aa66);

var $ah1IF = parcelRequire("ah1IF");

var $joGaH = parcelRequire("joGaH");

var $2zU0a = parcelRequire("2zU0a");

var $bJJNE = parcelRequire("bJJNE");
const $f8db2c72b08f2e33$export$35db3378e2f116e4 = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $ah1IF.getIssueRemoteDataQuery)(),
        variables: variables,
        operationName: (0, $ah1IF.ISSUE_VIEW_REMOTE_DATA_QUERY)
    };
    const response = await (0, $bJJNE.getClient)().query(payload);
    return response;
};
const $f8db2c72b08f2e33$export$b270f25ae7166568 = async (issueKey, cloudId)=>{
    const variables = {
        issueKey: issueKey,
        cloudId: cloudId
    };
    const payload = {
        query: (0, $ah1IF.getIssueRemoteDataQueryWithProject)(),
        variables: variables,
        operationName: (0, $ah1IF.ISSUE_VIEW_REMOTE_DATA_QUERY)
    };
    const response = await (0, $bJJNE.getClient)().query(payload);
    return response;
};
const $f8db2c72b08f2e33$var$LOG_LOCATION = 'issue.data-provider.source.issue-express.graphql';
const $f8db2c72b08f2e33$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $f8db2c72b08f2e33$export$a408d29e50d8e026 = 'RemoteJiraIssueLinkResultSuccess';
const $f8db2c72b08f2e33$export$f2b31ecd45935212 = 'RemoteJiraIssueLinkResultError';
const $f8db2c72b08f2e33$var$getIdFromAri = (ari)=>{
    if (typeof ari !== 'string') return 0;
    if (!(0, $2zU0a.isAri)(ari)) return 0;
    try {
        const ariConfig = (0, $2zU0a.getAriConfig)(ari);
        return parseInt(ariConfig.resourceId, 10);
    } catch (err) {
        // unable to parse the ari
        return 0;
    }
};
const $f8db2c72b08f2e33$var$getIssueIdFromGlobalId = (globalId)=>{
    if (typeof globalId !== 'string') return 0;
    const match = globalId.match(/issueId=(\d+)/);
    if (match) return parseInt(match[1], 10);
    return 0;
};
const $f8db2c72b08f2e33$var$applicationDetails = {
    // hard-coded to `com.atlassian.jira` as this is constant in this context
    // and this doesn't make sense providing from the backend.
    // This value doesn't appear used and a separate change can trial removing it.
    applicationType: 'com.atlassian.jira',
    // hard-coded to `Jira` to avoid potential issues
    // and this doesn't make sense providing from the backend.
    // This value doesn't appear used and a separate change can trial removing it.
    applicationName: 'Jira'
};
const $f8db2c72b08f2e33$export$946134440e64f965 = (edges)=>{
    if (!Array.isArray(edges)) return [];
    return edges.map((edge)=>{
        if (!edge?.node?.content) return undefined;
        return $f8db2c72b08f2e33$export$1ab02de3161d1783(edge.node);
    }).filter(Boolean);
};
const $f8db2c72b08f2e33$export$1ab02de3161d1783 = (value)=>{
    if (value.content?.__typename === $f8db2c72b08f2e33$export$f2b31ecd45935212) return {
        preview: {
            id: $f8db2c72b08f2e33$var$getIdFromAri(value.id),
            // In the event of an error this value is not provided.
            issueId: $f8db2c72b08f2e33$var$getIssueIdFromGlobalId(value.globalId),
            globalId: value.globalId,
            href: value.href ?? '',
            ...$f8db2c72b08f2e33$var$applicationDetails,
            relationship: value.relationship ?? '',
            title: value.title ?? ''
        },
        details: {
            error: value.content.errorType ?? 'REMOTE_LINK_MISSING',
            repairLink: value.content.repairLink ? {
                href: value.content.repairLink
            } : null
        }
    };
    return {
        preview: {
            id: $f8db2c72b08f2e33$var$getIdFromAri(value.id),
            issueId: value.content?.issueId ?? $f8db2c72b08f2e33$var$getIssueIdFromGlobalId(value.globalId),
            globalId: value.globalId,
            href: value.href ?? '',
            ...$f8db2c72b08f2e33$var$applicationDetails,
            relationship: value.relationship ?? '',
            title: value.title ?? ''
        },
        details: {
            associatedIssue: {
                issueId: value.content?.issueId ?? 0,
                issueKey: {
                    stringValue: value.content?.key ?? ''
                },
                summary: {
                    textValue: value.content?.summary ?? ''
                },
                status: {
                    statusCategoryId: value.content?.statusCategoryId ?? 0,
                    name: value.content?.statusName ?? '',
                    statusId: (value.content?.statusId ?? 0).toString()
                },
                priority: {
                    iconUrl: value.content?.priorityIconUrl ?? '',
                    name: value.content?.priorityName ?? '',
                    // `sequence` just to satisfy the types.
                    sequence: undefined
                },
                issueType: {
                    iconUrl: value.content?.issueTypeIconUrl ?? '',
                    name: value.content?.issueTypeName ?? ''
                },
                assignee: value.content?.assigneeDisplayName && value.content?.assigneeAvatarUrl ? {
                    userValue: {
                        // `accountId` just to satisfy the types.
                        accountId: '',
                        displayName: value.content?.assigneeDisplayName ?? '',
                        avatarUrl: value.content?.assigneeAvatarUrl ?? ''
                    }
                } : null,
                isResolved: value.content?.isResolved ?? false
            }
        }
    };
};
const $f8db2c72b08f2e33$export$a78291fba468aa66 = async (issueKey, cloudId, storeCallback)=>{
    const promise = $f8db2c72b08f2e33$export$b270f25ae7166568(issueKey, cloudId);
    storeCallback(promise);
    const data = await promise;
    const responseWithIgnoredErrorsRemoved = (0, $joGaH.graphqlErrorHandling).filterOutIgnoredErrors(data, (0, $joGaH.graphqlErrorHandling).isIgnoredError);
    const transformed = (0, $joGaH.graphqlErrorHandling).getGraphQlData($f8db2c72b08f2e33$var$LOG_LOCATION, responseWithIgnoredErrorsRemoved);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '`bentoViewIssue${string}`' can't be used to index type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
    const response = transformed[`${$f8db2c72b08f2e33$var$VIEW_ISSUE_ALIAS}${(0, $ah1IF.getRemoteDataQueryPrefix)()}`];
    const edges = response?.remoteIssueLinks?.edges;
    const remoteLinkedIssues = $f8db2c72b08f2e33$export$946134440e64f965(edges);
    return {
        id: response.issueId,
        remoteLinks: {
            ...response.remoteLinks,
            remoteLinkedIssues: remoteLinkedIssues
        },
        projectType: data.data?.jira?.issueByKey?.projectField?.project?.projectType
    };
};

});
parcelRegister("ah1IF", function(module, exports) {
$parcel$export(module.exports, "getRemoteDataQueryPrefix", () => $7eb231cbd90bf3b2$export$1a164444721ce2fb);
$parcel$export(module.exports, "ISSUE_VIEW_REMOTE_DATA_QUERY", () => $7eb231cbd90bf3b2$export$2761e7caa26df533);
$parcel$export(module.exports, "getIssueRemoteDataQuery", () => $7eb231cbd90bf3b2$export$65f9808f978ee25);
$parcel$export(module.exports, "getIssueRemoteDataQueryWithProject", () => $7eb231cbd90bf3b2$export$7c4bc0e79ee053cb);

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");
const $7eb231cbd90bf3b2$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $7eb231cbd90bf3b2$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
const $7eb231cbd90bf3b2$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$7eb231cbd90bf3b2$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
const $7eb231cbd90bf3b2$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$7eb231cbd90bf3b2$var$getConfluencePagesQueryFragment()}
`;
const $7eb231cbd90bf3b2$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $7eb231cbd90bf3b2$var$getConfluenceDataQueryFragment = ()=>`
    confluencePages {
        linkedPages {
            ${$7eb231cbd90bf3b2$var$getConfluencePageGroupQueryFragment()}
        }
        mentionedPages {
            ${$7eb231cbd90bf3b2$var$getConfluencePageGroupQueryFragment()}
        }
    }
`;
const $7eb231cbd90bf3b2$var$getRemoteDataQueryFragmentOld = ()=>`
    issueId
    remoteLinks {
        isLinkingEnabled
        ${!(0, $2700E.expVal)('attachments-1p-consolidation-experiment', 'isExperimentEnabled', false) ? $7eb231cbd90bf3b2$var$getConfluenceDataQueryFragment() : ''}
        ${$7eb231cbd90bf3b2$export$761fd517f0dda983()}
    }
`;
const $7eb231cbd90bf3b2$var$getRemoteDataQueryFragmentNew = ()=>`
	issueId
	remoteLinks {
		isLinkingEnabled
		${$7eb231cbd90bf3b2$export$761fd517f0dda983()}
    }
`;
const $7eb231cbd90bf3b2$var$getRemoteDataQueryFragment = ()=>(0, $i860n.fg)('jiv_confluence_remote_link_critical_query') ? $7eb231cbd90bf3b2$var$getRemoteDataQueryFragmentNew() : $7eb231cbd90bf3b2$var$getRemoteDataQueryFragmentOld();
const $7eb231cbd90bf3b2$var$getRemoteIssueLinksFragment = ()=>`
	remoteIssueLinks {
		edges {
			node {
				id
				globalId
				title
				relationship
				href
				content {
					__typename
					... on RemoteJiraIssueLinkResultSuccess {
						issueId
						key
						summary
						statusId
						statusName
						statusCategoryId
						isResolved
						issueTypeName
						issueTypeIconUrl
						priorityName
						priorityIconUrl
						assigneeDisplayName
						assigneeAvatarUrl
					}
					... on RemoteJiraIssueLinkResultError {
						errorType
						repairLink
					}
				}
			}
		}
	}
`;
const $7eb231cbd90bf3b2$var$getRemoteDataQueryProjectTypeFragment = ()=>`
    jira {
        issueByKey(key: $issueKey, cloudId: $cloudId) {
            projectField {
                    project {
                        projectType
                }
            }
        }
    }
`;
const $7eb231cbd90bf3b2$export$1a164444721ce2fb = ()=>'_remote_data';
const $7eb231cbd90bf3b2$export$2761e7caa26df533 = 'issueViewRemoteDataQuery';
const $7eb231cbd90bf3b2$export$65f9808f978ee25 = ()=>`
    query ${$7eb231cbd90bf3b2$export$2761e7caa26df533}($issueKey: String!) {
        ${$7eb231cbd90bf3b2$var$VIEW_ISSUE_ALIAS}${$7eb231cbd90bf3b2$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
        	${$7eb231cbd90bf3b2$var$getRemoteIssueLinksFragment()}
            ${$7eb231cbd90bf3b2$var$getRemoteDataQueryFragment()}
        }
    }
`;
const $7eb231cbd90bf3b2$export$7c4bc0e79ee053cb = ()=>`
    query ${$7eb231cbd90bf3b2$export$2761e7caa26df533}($issueKey: String!, $cloudId: ID!) {
        ${$7eb231cbd90bf3b2$var$getRemoteDataQueryProjectTypeFragment()}
        ${$7eb231cbd90bf3b2$var$VIEW_ISSUE_ALIAS}${$7eb231cbd90bf3b2$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
        	${$7eb231cbd90bf3b2$var$getRemoteIssueLinksFragment()}
            ${$7eb231cbd90bf3b2$var$getRemoteDataQueryFragment()}
        }
    }
`;

});

parcelRegister("joGaH", function(module, exports) {
$parcel$export(module.exports, "graphqlErrorHandling", () => $5fc9ef58f56a1f9a$export$dac1cffbb1390a0e);
// Utility functions for handling GraphQL responses
// Moved here to avoid circular dependencies between @jira/issue__fetch-services and @jira/platform__services-issue
const $5fc9ef58f56a1f9a$var$isIgnoredError = (error)=>{
    if (typeof error !== 'object') return false;
    if (error === null) return false;
    if ('message' in error && error.message === 'Application link is missing or not configured properly') return true;
    if ('message' in error && typeof error.message === 'string' && error.message.startsWith('Remote link has globalId with invalid format:')) return true;
    return false;
};
const $5fc9ef58f56a1f9a$var$filterOutIgnoredErrors = (graphQlResponse, isIgnoredErrorFn)=>{
    if (!graphQlResponse.errors || !Array.isArray(graphQlResponse.errors)) return graphQlResponse;
    const nonIgnoredErrors = graphQlResponse.errors.filter((error)=>!isIgnoredErrorFn(error));
    if (nonIgnoredErrors.length > 0) return {
        ...graphQlResponse,
        errors: nonIgnoredErrors
    };
    const { errors: errors, ...responseWithErrorsRemoved } = graphQlResponse;
    return responseWithErrorsRemoved;
};
const $5fc9ef58f56a1f9a$var$getGraphQlData = (logLocation, graphQlResponse)=>{
    if (graphQlResponse.errors) {
        const firstError = graphQlResponse.errors[0];
        // Create a simple error - callers can wrap with ValidationError if needed
        const validationError = new Error(typeof firstError === 'object' && firstError && 'message' in firstError ? String(firstError.message) : 'Unknown GraphQL error');
        // Note: Original implementation in @jira/platform__services-issue used log.safeErrorWithoutCustomerData
        // Callers should handle logging as needed to avoid circular dependencies
        throw validationError;
    }
    return graphQlResponse.data;
};
const $5fc9ef58f56a1f9a$export$dac1cffbb1390a0e = {
    isIgnoredError: $5fc9ef58f56a1f9a$var$isIgnoredError,
    filterOutIgnoredErrors: $5fc9ef58f56a1f9a$var$filterOutIgnoredErrors,
    getGraphQlData: $5fc9ef58f56a1f9a$var$getGraphQlData
};

});

parcelRegister("bJJNE", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $86e97f2db14b235b$export$6bb76d6eba7e258c);

var $7Chch = parcelRequire("7Chch");

var $4fhEY = parcelRequire("4fhEY");
const $86e97f2db14b235b$var$makeFetchClient = ()=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $4fhEY.default)((0, $7Chch.getGiraUrl)(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $86e97f2db14b235b$var$client;
const $86e97f2db14b235b$export$6bb76d6eba7e258c = ()=>{
    if (!$86e97f2db14b235b$var$client) $86e97f2db14b235b$var$client = $86e97f2db14b235b$var$makeFetchClient();
    return $86e97f2db14b235b$var$client;
};

});
parcelRegister("7Chch", function(module, exports) {
$parcel$export(module.exports, "getGiraUrl", () => $3660893eadcb4a3d$export$aefb19023b2eda55);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $aSgfw = parcelRequire("aSgfw");
const $3660893eadcb4a3d$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $3660893eadcb4a3d$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${(0, $aSgfw.appendOperationQuery)(operation)}`;

});
parcelRegister("aSgfw", function(module, exports) {
$parcel$export(module.exports, "appendOperationQuery", () => $a5dcbd76530125ea$export$69694c3add0f6058);
const $a5dcbd76530125ea$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});





parcelRegister("l51v2", function(module, exports) {
$parcel$export(module.exports, "fetchConfluenceSmartlinkData", () => $751379f829e863c8$export$719f088f67c572bf);

var $f99M0 = parcelRequire("f99M0");

var $QAM4a = parcelRequire("QAM4a");
const $751379f829e863c8$var$SMART_LINKS_FIRST = 4;
const $751379f829e863c8$var$FETCH_CONFLUENCE_SMARTLINK_DATA = 'fetch-confluence-smartlink-data';
function $751379f829e863c8$var$extractSmartLinkUrls(remoteIssueGraphqlData) {
    const linkedPages = remoteIssueGraphqlData?.remoteLinks?.confluencePages.linkedPages.pages;
    const mentionedPages = remoteIssueGraphqlData?.remoteLinks?.confluencePages.mentionedPages.pages;
    const smartLinkUrls = [];
    const addUrlFromPage = (page)=>{
        // For failed remote links, check if there's a link href
        if ('link' in page && page.link?.href) smartLinkUrls.push(page.link.href);
        else if ('href' in page && page.href) // For successful confluence pages, use the href
        smartLinkUrls.push(page.href);
    };
    if (linkedPages) linkedPages.forEach(addUrlFromPage);
    if (mentionedPages) mentionedPages.forEach(addUrlFromPage);
    // Remove duplicates and cap at SMART_LINKS_FIRST
    return [
        ...new Set(smartLinkUrls)
    ].slice(0, $751379f829e863c8$var$SMART_LINKS_FIRST);
}
const $751379f829e863c8$export$719f088f67c572bf = async (remoteIssueGraphqlData, cloudId)=>{
    if (!(0, $QAM4a.canCallORS)()) return null;
    const urls = $751379f829e863c8$var$extractSmartLinkUrls(remoteIssueGraphqlData);
    const projectTypeData = remoteIssueGraphqlData?.projectType;
    const projectType = projectTypeData ? (0, $f99M0.convertToProjectType)(projectTypeData) : undefined;
    if (urls.length === 0) return null;
    return (0, $QAM4a.fetchORSDataSSR)(urls, $751379f829e863c8$var$FETCH_CONFLUENCE_SMARTLINK_DATA, projectType, cloudId);
};

});
parcelRegister("QAM4a", function(module, exports) {
$parcel$export(module.exports, "getHostOrigin", () => $2509dd5a7f5b4c80$export$402f711f0e72a740);
$parcel$export(module.exports, "canCallORS", () => $2509dd5a7f5b4c80$export$d25077ee0f004d7e);
$parcel$export(module.exports, "fetchORSDataSSR", () => $2509dd5a7f5b4c80$export$a217a916fbfbde82);

var $dJ3NQ = parcelRequire("dJ3NQ");

var $l1vE2 = parcelRequire("l1vE2");

var $h2wCv = parcelRequire("h2wCv");

var $i860n = parcelRequire("i860n");

var $70AHN = parcelRequire("70AHN");
// SmartLinks URLs
const $2509dd5a7f5b4c80$var$SMART_LINKS_STAGE_URL = 'https://object-resolver.staging.atl-paas.net/resolve/batch';
const $2509dd5a7f5b4c80$var$SMART_LINKS_PROD_URL = 'https://object-resolver.prod.atl-paas.net/resolve/batch';
const $2509dd5a7f5b4c80$export$92162a33dbbd338d = 300;
const $2509dd5a7f5b4c80$export$5fc2ebe451bbe5aa = $2509dd5a7f5b4c80$export$92162a33dbbd338d + 100;
const $2509dd5a7f5b4c80$export$83d9e8edcbcda504 = 1;
const $2509dd5a7f5b4c80$export$c048e241ec0ff835 = 50;
function $2509dd5a7f5b4c80$var$getProductForSmartCardProvider(projectType) {
    switch(projectType){
        case 'software':
            return 'JSW';
        case 'business':
            return 'JWM';
        case 'service_desk':
            return 'JSM';
        case 'product_discovery':
            return 'JPD';
        default:
            return undefined;
    }
}
function $2509dd5a7f5b4c80$export$402f711f0e72a740() {
    // Get the original URL from the request header
    const originalUrl = globalThis.location.origin;
    const url = new URL(originalUrl?.startsWith('http') ? originalUrl : `https://${originalUrl}`);
    const host = url.origin; // This will be "https://abc.jira-dev.com"
    return host;
}
function $2509dd5a7f5b4c80$export$75cfeb169aa2711e(projectType, cloudId) {
    const isLocal = (0, $dJ3NQ.default)();
    const xProduct = $2509dd5a7f5b4c80$var$getProductForSmartCardProvider(projectType);
    // Extract the origin (e.g., https://abc.jira-dev.com)
    const host = $2509dd5a7f5b4c80$export$402f711f0e72a740();
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...host ? {
            Origin: host?.startsWith('http') ? host : `https://${host}`
        } : {},
        ...cloudId ? {
            CloudId: cloudId
        } : {},
        ...xProduct ? {
            'X-Product': xProduct
        } : {},
        ...!isLocal ? {
            'x-ssr-service-name': 'object-resolver-service'
        } : {}
    };
}
function $2509dd5a7f5b4c80$var$toConsumableSmartlinkData(urls, orsResponse) {
    if (!Array.isArray(orsResponse) || urls.length !== orsResponse.length) return null;
    const entries = [];
    for(let i = 0; i < urls.length; i++){
        const item = orsResponse[i];
        if (item?.status === 200 && item?.body) entries.push({
            url: urls[i],
            body: item.body
        });
    }
    return entries.length > 0 ? entries : null;
}
function $2509dd5a7f5b4c80$export$3edd157ccce32820(operationName) {
    const isLocal = (0, $dJ3NQ.default)();
    const isProd = globalThis.ssrContext?.environmentType === 'prod';
    if (isLocal) return `/gateway/api/object-resolver/resolve/batch?operation=${operationName}`;
    if (isProd) return `${$2509dd5a7f5b4c80$var$SMART_LINKS_PROD_URL}?operation=${operationName}`;
    return `${$2509dd5a7f5b4c80$var$SMART_LINKS_STAGE_URL}?operation=${operationName}`;
}
function $2509dd5a7f5b4c80$export$d25077ee0f004d7e() {
    if (!false && (0, $i860n.fg)('dfo_issue_view_remote_data_srr_group')) return false;
    if ((0, $i860n.fg)('jiv_22691_ors_ssr_is_fedramp_check')) return !(0, $l1vE2.isFedRamp)();
    return !globalThis?.ssrContext?.isInFedramp;
}
async function $2509dd5a7f5b4c80$var$fetchORSBatch(batch, headers, orsUrl, batchTimeout) {
    const urls = batch.map(({ resourceUrl: resourceUrl })=>resourceUrl);
    const orsBody = batch.map(({ resourceUrl: resourceUrl })=>({
            resourceUrl: resourceUrl
        }));
    const task = async ()=>{
        try {
            // eslint-disable-next-line jira/js/no-jira-fetch
            const resolved = await (0, $h2wCv.performPostRequest)(orsUrl, {
                headers: headers,
                body: JSON.stringify(orsBody),
                method: 'POST'
            });
            return $2509dd5a7f5b4c80$var$toConsumableSmartlinkData(urls, resolved) ?? [];
        } catch  {
            return [];
        }
    };
    return new Promise((resolve)=>{
        const timer = setTimeout(()=>resolve([]), batchTimeout);
        task().then((result)=>{
            clearTimeout(timer);
            resolve(result);
        });
    });
}
async function $2509dd5a7f5b4c80$export$a217a916fbfbde82(urls, operationName, projectType, cloudId) {
    const smartLinks = urls.map((url)=>({
            resourceUrl: url
        }));
    const headers = $2509dd5a7f5b4c80$export$75cfeb169aa2711e(projectType, cloudId);
    // Pass individual timeout as a hint to ORS on how long it should spend per link
    const orsUrl = `${$2509dd5a7f5b4c80$export$3edd157ccce32820(operationName)}&timeout=${$2509dd5a7f5b4c80$export$92162a33dbbd338d}`;
    let batches = (0, $70AHN.groupSmartLinksByHostname)(smartLinks);
    batches = (0, $70AHN.mergeSmallThirdPartyBatches)(batches, $2509dd5a7f5b4c80$export$83d9e8edcbcda504);
    batches = (0, $70AHN.splitLinksIntoBatches)(batches, $2509dd5a7f5b4c80$export$c048e241ec0ff835);
    // Fire first-party batches before third-party so slow third-party timeouts
    // don't prevent faster first-party links from resolving
    const firstPartyBatches = batches.filter((batch)=>(0, $70AHN.isFirstPartyLink)(batch[0].resourceUrl));
    const thirdPartyBatches = batches.filter((batch)=>!(0, $70AHN.isFirstPartyLink)(batch[0].resourceUrl));
    const orderedBatches = [
        ...firstPartyBatches,
        ...thirdPartyBatches
    ];
    const results = await Promise.all(orderedBatches.map((batch)=>$2509dd5a7f5b4c80$var$fetchORSBatch(batch, headers, orsUrl, $2509dd5a7f5b4c80$export$5fc2ebe451bbe5aa)));
    const allResults = results.flat();
    return allResults.length > 0 ? allResults : null;
}

});
parcelRegister("70AHN", function(module, exports) {
$parcel$export(module.exports, "groupSmartLinksByHostname", () => $10ed69706d4b9c24$export$70b802114e3b3d52);
$parcel$export(module.exports, "mergeSmallThirdPartyBatches", () => $10ed69706d4b9c24$export$3e7fb54d0ef2df07);
$parcel$export(module.exports, "splitLinksIntoBatches", () => $10ed69706d4b9c24$export$9f4b5e6e623e6720);
$parcel$export(module.exports, "isFirstPartyLink", () => $10ed69706d4b9c24$export$8c4674ec524aaf2c);
// Replicated from this location confluence/next/packages/content-smartlinks/src/smartLinkBatchHelpers.ts
const $10ed69706d4b9c24$var$UNKNOWN = 'unknown';
const $10ed69706d4b9c24$export$eb0f795a64547ac0 = {};
function $10ed69706d4b9c24$export$8071740a02e53ce2(link) {
    if (link.includes('/jira/') || link.includes('/servicedesk/') || link.includes('/helpcenter/') || link.includes('/projects/') || link.includes('/browse/')) return 'jira';
    if (link.includes('/wiki/')) return 'confluence';
    if (link.includes('bitbucket')) return 'bitbucket';
    if (link.includes('atlassian') || link.includes('jira-dev')) return 'otherAtlassian';
    return 'thirdParty';
}
function $10ed69706d4b9c24$export$70b802114e3b3d52(smartLinks) {
    return Object.values(smartLinks.reduce((acc, smartLink)=>{
        try {
            const hostname = new URL(smartLink.resourceUrl).hostname;
            if (!acc[hostname]) acc[hostname] = [];
            acc[hostname].push(smartLink);
        } catch (e) {
            if (!acc[$10ed69706d4b9c24$var$UNKNOWN]) acc[$10ed69706d4b9c24$var$UNKNOWN] = [];
            acc[$10ed69706d4b9c24$var$UNKNOWN].push(smartLink);
        }
        return acc;
    }, // oxlint-disable-next-line typescript/consistent-type-assertions
    {}));
}
function $10ed69706d4b9c24$export$3e7fb54d0ef2df07(smartLinksGroups, min) {
    const result = [];
    const smallThirdPartyBatches = [];
    for (const smartLinks of smartLinksGroups)if (smartLinks.length >= min || $10ed69706d4b9c24$export$8071740a02e53ce2(smartLinks[0].resourceUrl) !== 'thirdParty') result.push(smartLinks);
    else smallThirdPartyBatches.push(...smartLinks);
    if (smallThirdPartyBatches.length > 0) result.push(smallThirdPartyBatches);
    return result;
}
function $10ed69706d4b9c24$export$9f4b5e6e623e6720(smartLinksGroups, max) {
    const result = [];
    for (const smartLinks of smartLinksGroups){
        if (smartLinks.length <= max) result.push(smartLinks);
        else for(let i = 0; i < smartLinks.length; i += max)result.push(smartLinks.slice(i, i + max));
    }
    return result;
}
function $10ed69706d4b9c24$export$8c4674ec524aaf2c(resourceUrl) {
    const type = $10ed69706d4b9c24$export$8071740a02e53ce2(resourceUrl);
    switch(type){
        case 'jira':
        case 'confluence':
        case 'bitbucket':
        case 'otherAtlassian':
            return true;
        default:
            return false;
    }
}

});



parcelRegister("1oakV", function(module, exports) {
$parcel$export(module.exports, "fetchWeblinksSmartlinkData", () => $60e69a54ca38da62$export$bfa0a7e19c646807);

var $f99M0 = parcelRequire("f99M0");

var $QAM4a = parcelRequire("QAM4a");
const $60e69a54ca38da62$var$SMART_LINKS_FIRST = 4;
const $60e69a54ca38da62$var$FETCH_WEBLINKS_SMARTLINK_DATA = 'fetch-weblinks-smartlink-data';
function $60e69a54ca38da62$var$extractWebLinkUrls(remoteIssueGraphqlData) {
    const links = remoteIssueGraphqlData?.remoteLinks?.webLinks?.links;
    if (!links) return [];
    return [
        ...new Set(links.map((link)=>link.href).filter(Boolean))
    ].slice(0, $60e69a54ca38da62$var$SMART_LINKS_FIRST);
}
const $60e69a54ca38da62$export$bfa0a7e19c646807 = async (remoteIssueGraphqlData, cloudId)=>{
    if (!(0, $QAM4a.canCallORS)()) return null;
    const urls = $60e69a54ca38da62$var$extractWebLinkUrls(remoteIssueGraphqlData);
    const projectTypeData = remoteIssueGraphqlData?.projectType;
    const projectType = projectTypeData ? (0, $f99M0.convertToProjectType)(projectTypeData) : undefined;
    if (urls.length === 0) return null;
    return (0, $QAM4a.fetchORSDataSSR)(urls, $60e69a54ca38da62$var$FETCH_WEBLINKS_SMARTLINK_DATA, projectType, cloudId);
};

});



parcelRegister("kI2ll", function(module, exports) {
$parcel$export(module.exports, "issueViewResourcesDataResource", () => $c4e55db8f62f638c$export$3aa8ef085659ec23);

var $kfVxU = parcelRequire("kfVxU");

var $7edbf = parcelRequire("7edbf");

var $2jFrU = parcelRequire("2jFrU");
const $c4e55db8f62f638c$export$3aa8ef085659ec23 = (0, $7edbf.createResource)({
    type: 'ISSUE_VIEW_RESOURCES_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $2jFrU.default)(...args),
    isBrowserOnly: true
});

});
parcelRegister("2jFrU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d26846b5823cb6bf$export$2e2bcd8739ae039);

var $n67Vb = parcelRequire("n67Vb");

var $kfVxU = parcelRequire("kfVxU");

var $aI7em = parcelRequire("aI7em");

var $4NAQg = parcelRequire("4NAQg");
const $d26846b5823cb6bf$var$RESOURCES_INTEGRATION = {
    ATTACHMENT: 'ATTACHMENT',
    LOOM: 'LOOM',
    CONFLUENCE: 'CONFLUENCE',
    WHITEBOARD: 'WHITEBOARD',
    GDRIVE: 'GDRIVE'
};
const $d26846b5823cb6bf$var$getResourcesData = async ({ match: match }, _storeContext)=>{
    const issueKey = (0, $kfVxU.getIssueKey)(match);
    const { tenantContext: { cloudId: cloudId } } = _storeContext;
    if (!issueKey) return null;
    const consolidatedResourcesData = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $4NAQg.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        maxResults: 12,
        startAt: '',
        orderField: 'CREATED',
        orderDirection: 'DESC',
        filters: [
            {
                integration: $d26846b5823cb6bf$var$RESOURCES_INTEGRATION.CONFLUENCE
            },
            {
                integration: $d26846b5823cb6bf$var$RESOURCES_INTEGRATION.WHITEBOARD
            },
            {
                integration: $d26846b5823cb6bf$var$RESOURCES_INTEGRATION.LOOM
            },
            {
                integration: $d26846b5823cb6bf$var$RESOURCES_INTEGRATION.ATTACHMENT,
                types: []
            }
        ],
        totalCount: 0,
        totalLinks: 0,
        next: '',
        isLast: false,
        targetPageNumber: 1,
        currentPageNumber: 1
    });
    return consolidatedResourcesData;
};
var $d26846b5823cb6bf$export$2e2bcd8739ae039 = $d26846b5823cb6bf$var$getResourcesData;

});
parcelRegister("4NAQg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a869d87983ed0cb6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1cefbb8c8992a1116043744d797685f3>>
 * @relayHash c12c13cda033d90ffe1a2594e1fea10b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc087fbd81be4ad450b1850cf643e940ddf428978fad8f4930851d1eda8df7dd
const $a869d87983ed0cb6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentPageNumber"
    }, v2 = {
        "defaultValue": [
            {
                "integration": "CONFLUENCE"
            },
            {
                "integration": "LOOM"
            },
            {
                "integration": "WHITEBOARD"
            },
            {
                "integration": "ATTACHMENT",
                "types": []
            }
        ],
        "kind": "LocalArgument",
        "name": "filters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLast"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v5 = {
        "defaultValue": 12,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "next"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderDirection"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderField"
    }, v9 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "startAt"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "targetPageNumber"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "totalCount"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "totalLinks"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "input",
                "value": {
                    "integration": [
                        "ATTACHMENT",
                        "CONFLUENCE",
                        "LOOM",
                        "WHITEBOARD"
                    ]
                }
            }
        ],
        "kind": "ScalarField",
        "name": "getConsolidatedResourcesTotalCount",
        "storageKey": "getConsolidatedResourcesTotalCount(input:{\"integration\":[\"ATTACHMENT\",\"CONFLUENCE\",\"LOOM\",\"WHITEBOARD\"]})"
    }, v15 = {
        "kind": "ScalarField",
        "name": "deletableAttachmentsCount"
    }, v16 = {
        "kind": "ScalarField",
        "name": "totalAttachmentsCount"
    }, v17 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "startAt"
                },
                {
                    "kind": "Variable",
                    "name": "filters",
                    "variableName": "filters"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "maxResults"
                },
                {
                    "kind": "Variable",
                    "name": "orderDirection",
                    "variableName": "orderDirection"
                },
                {
                    "kind": "Variable",
                    "name": "orderField",
                    "variableName": "orderField"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "currentPageNumber",
                            "variableName": "currentPageNumber"
                        },
                        {
                            "kind": "Variable",
                            "name": "isLast",
                            "variableName": "isLast"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageCursor",
                            "variableName": "next"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageNumber",
                            "variableName": "targetPageNumber"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageSize",
                            "variableName": "maxResults"
                        },
                        {
                            "kind": "Literal",
                            "name": "style",
                            "value": "OFFSET"
                        },
                        {
                            "kind": "Variable",
                            "name": "totalCount",
                            "variableName": "totalCount"
                        },
                        {
                            "kind": "Variable",
                            "name": "totalLinks",
                            "variableName": "totalLinks"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "pagination"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "created"
    }, v21 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "contentUrl"
    }, v23 = {
        "kind": "ScalarField",
        "name": "contentType"
    }, v24 = {
        "kind": "ScalarField",
        "name": "fileName"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fileSize"
    }, v26 = {
        "kind": "ScalarField",
        "name": "parent"
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "hasRestrictedParent"
    }, v29 = {
        "kind": "ScalarField",
        "name": "isExternallyLinked"
    }, v30 = {
        "kind": "ScalarField",
        "name": "next"
    }, v31 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v32 = {
        "kind": "ScalarField",
        "name": "deletableCount"
    }, v33 = {
        "kind": "ScalarField",
        "name": "totalLinks"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "consolidatedResourcesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraResourcesResult",
                                    "kind": "LinkedField",
                                    "name": "getConsolidatedResources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraResourceNode",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraResource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "author",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v30 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v2 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "consolidatedResourcesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraResourcesResult",
                                    "kind": "LinkedField",
                                    "name": "getConsolidatedResources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraResourceNode",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraResource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "author",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v19 /*: any*/ ,
                                                                v18 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v30 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fc087fbd81be4ad450b1850cf643e940ddf428978fad8f4930851d1eda8df7dd",
            "metadata": {},
            "name": "consolidatedResourcesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a869d87983ed0cb6$var$node.hash = "4dc26801875053a667498cedf71d28b2";
var $a869d87983ed0cb6$export$2e2bcd8739ae039 = $a869d87983ed0cb6$var$node;

});



parcelRegister("2pLyE", function(module, exports) {
$parcel$export(module.exports, "issueSelectedTabDataResource", () => $906bd54f05da4b11$export$f2f41d6cae2fe7b1);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist


var $i0CFV = parcelRequire("i0CFV");

var $bdEst = parcelRequire("bdEst");

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $906bd54f05da4b11$var$getKey = ({ match: match, query: query })=>{
    const projectKey = (0, $i0CFV.getProjectKey)(match, query);
    return `issue.selected-tab.${projectKey}`;
};
const $906bd54f05da4b11$export$f2f41d6cae2fe7b1 = (0, $7edbf.createResource)({
    type: 'ISSUE_SELECTED_TAB_DATA',
    getKey: $906bd54f05da4b11$var$getKey,
    getData: async ({ match: match, query: query })=>{
        const key = $906bd54f05da4b11$var$getKey({
            match: match,
            query: query
        });
        const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
        try {
            return await (0, $h2wCv.performGetRequest)(requestUrl);
        } catch (error) {
            if (!!error && typeof error === 'object' && 'statusCode' in error && error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) return;
            throw (0, $bdEst.createResourceError)({
                component: 'spa.view.routes.issue-view.selected-tab.getData',
                message: 'An error was thrown while prefetching issue selected tab data'
            }, error);
        }
    }
});

});

parcelRegister("ldGfw", function(module, exports) {
$parcel$export(module.exports, "getIssueViewResources", () => $bb27224da4768e0e$export$590e911b4187f266);

var $lIdjB = parcelRequire("lIdjB");

var $7qOg7 = parcelRequire("7qOg7");

var $8Uubk = parcelRequire("8Uubk");

var $ecGij = parcelRequire("ecGij");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $awVDv = parcelRequire("awVDv");

var $jXFcu = parcelRequire("jXFcu");

var $dfITH = parcelRequire("dfITH");

var $ibD7n = parcelRequire("ibD7n");

var $24uSh = parcelRequire("24uSh");

var $2ngQP = parcelRequire("2ngQP");
const $bb27224da4768e0e$export$590e911b4187f266 = ({ disableShadowQuery: disableShadowQuery = false } = {})=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $2700E.expVal)('jpx-000-shadow-relay-query', 'isEnabled', false) && !disableShadowQuery, (0, $24uSh.shadowIssueViewRelayResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('dfo_connectedtoissueaggquery'), (0, $dfITH.connectedToIssueAggDataResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('devai_issue_view_query_separation'), (0, $awVDv.devaiIssueViewResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('nike-dfo-ecosystem-bg-scripts-migration-router'), (0, $ibD7n.ecosystemConnectBackgroundScriptsResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('devpanel-relay-resource') && !(0, $i860n.fg)('jiv-22469-dev-summary-to-miaq'), (0, $2ngQP.issueViewDevPanelDataResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jira-fix-build-dev-panel-fg'), (0, $jXFcu.rovoDevEntitlementResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('optimise-placeholder-template-cross-flow-section'), (0, $7qOg7.placeholderConfluenceDummyLinkDismissedResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('optimise-placeholder-template-cross-flow-section'), (0, $lIdjB.placeholderConfluenceDummyLinkCoUseDismissedResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('optimise-placeholder-template-cross-flow-section'), (0, $8Uubk.fetchSiteTraitsResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('optimise-placeholder-template-cross-flow-section'), (0, $ecGij.fetchSiteUserTraitsResource))
    ];

});
parcelRegister("lIdjB", function(module, exports) {
$parcel$export(module.exports, "placeholderConfluenceDummyLinkCoUseDismissedResource", () => $d931b41c4b38c936$export$c183d759e865d174);
$parcel$export(module.exports, "usePlaceholderConfluenceDummyLinkCoUseDismissedResource", () => $d931b41c4b38c936$export$1f592f56bb6ce7d3);

var $k6ufm = parcelRequire("k6ufm");

var $fVbAt = parcelRequire("fVbAt");
const $d931b41c4b38c936$export$c183d759e865d174 = (0, $fVbAt.createPlaceholderDismissedResource)('PLACEHOLDER_CONFLUENCE_DUMMY_LINK_COUSE_DISMISSED', 'hasDismissedConfluenceDummyLinkCoUse', 'placeholderConfluenceDummyLinkCoUseDismissedResource');
function $d931b41c4b38c936$export$1f592f56bb6ce7d3() {
    return (0, $k6ufm.useResource)($d931b41c4b38c936$export$c183d759e865d174);
}

});
parcelRegister("fVbAt", function(module, exports) {
$parcel$export(module.exports, "createPlaceholderDismissedResource", () => $0966891b784aa183$export$12272c281fe7c802);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $75sVW = parcelRequire("75sVW");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $0966891b784aa183$var$getUserPropertyUrl = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $0966891b784aa183$var$fetchDismissedFlag = async (accountId, propertyKey, analyticsId)=>{
    try {
        const response = await (0, $h2wCv.performGetRequest)($0966891b784aa183$var$getUserPropertyUrl(accountId, propertyKey));
        return {
            hasDismissed: !!response?.value
        };
    } catch (error) {
        if (error instanceof (0, $75sVW.default)) {
            // 404: API deliberately returns 404 if user property is not found,
            // which implies the property has not been set => not dismissed.
            if (error.statusCode === 404) return {
                hasDismissed: false
            };
            // 401/403: stay conservative and treat as dismissed so we don't
            // flash the placeholder for users that can't read their own props.
            if (error.statusCode === 401 || error.statusCode === 403) return {
                hasDismissed: true
            };
        }
        (0, $hFtK7.fireErrorAnalytics)({
            error: error instanceof Error ? error : undefined,
            meta: {
                id: analyticsId,
                packageName: 'jiraPlaceholderTemplateDismissedResource',
                teamName: 'issue-view-pulsar'
            }
        });
        return null;
    }
};
const $0966891b784aa183$export$12272c281fe7c802 = (type, propertyKey, analyticsId)=>(0, $7edbf.createResource)({
        type: type,
        getKey: (_routerContext, { tenantContext: tenantContext })=>{
            const accountId = tenantContext?.atlassianAccountId ?? 'current-account-id';
            return `${accountId}:${propertyKey}`;
        },
        getData: async (_routerContext, { tenantContext: tenantContext })=>{
            const accountId = tenantContext?.atlassianAccountId;
            if (!accountId || tenantContext?.isAnonymous) return null;
            return $0966891b784aa183$var$fetchDismissedFlag(accountId, propertyKey, analyticsId);
        }
    });

});


parcelRegister("7qOg7", function(module, exports) {
$parcel$export(module.exports, "placeholderConfluenceDummyLinkDismissedResource", () => $a1c3aff41d1fec73$export$2016eaec5c6fe580);
$parcel$export(module.exports, "usePlaceholderConfluenceDummyLinkDismissedResource", () => $a1c3aff41d1fec73$export$d11cf852d9c9ac86);

var $k6ufm = parcelRequire("k6ufm");

var $fVbAt = parcelRequire("fVbAt");
const $a1c3aff41d1fec73$export$2016eaec5c6fe580 = (0, $fVbAt.createPlaceholderDismissedResource)('PLACEHOLDER_CONFLUENCE_DUMMY_LINK_DISMISSED', 'hasDismissedConfluenceDummyLink', 'placeholderConfluenceDummyLinkDismissedResource');
function $a1c3aff41d1fec73$export$d11cf852d9c9ac86() {
    return (0, $k6ufm.useResource)($a1c3aff41d1fec73$export$2016eaec5c6fe580);
}

});

parcelRegister("awVDv", function(module, exports) {
$parcel$export(module.exports, "devaiIssueViewResource", () => $bc43e3bf5753614c$export$f3632f0b2d758700);

var $feWQ6 = parcelRequire("feWQ6");

var $kfVxU = parcelRequire("kfVxU");

var $htsFl = parcelRequire("htsFl");

var $i860n = parcelRequire("i860n");
const $bc43e3bf5753614c$export$f3632f0b2d758700 = (0, $htsFl.createRelayResource)({
    type: 'DEVAI_ISSUE_VIEW_DATA',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match) || query?.selectedIssue || '';
        if (!issueKey || tenantContext?.isAnonymous) return {
            parameters: (0, $feWQ6.default),
            variables: {
                cloudId: '',
                issueKey: '',
                isAiAgentSessionsPanelEnabled: false,
                issueViewRovoDevAgentsPanelEntitlementEnabled: false,
                isAssignToRovoDevActive: false
            },
            options: {
                fetchPolicy: 'store-only'
            }
        };
        const cloudId = tenantContext?.cloudId || '';
        return {
            parameters: (0, $feWQ6.default),
            variables: {
                cloudId: cloudId,
                issueKey: issueKey,
                isAiAgentSessionsPanelEnabled: (0, $i860n.fg)('jira_assignable_agent_session_experience'),
                // These conditions should be included in the conditions for RovodevAgentPanel in content-items-view.tsx
                issueViewRovoDevAgentsPanelEntitlementEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
                ((0, $i860n.fg)('rovodev-in-jira-panel-is-anonymous-precondition') ? !tenantContext?.isAnonymous : true) && (0, $i860n.fg)('boysenberry_rovodev_main_release') && (0, $i860n.fg)('boysenberry_enable_entitlements_check'),
                isAssignToRovoDevActive: // eslint-disable-next-line jira/ff/no-preconditioning
                ((0, $i860n.fg)('rovodev-in-jira-panel-is-anonymous-precondition') ? !tenantContext?.isAnonymous : true) && (0, $i860n.fg)('boysenberry_rovodev_main_release') && (0, $i860n.fg)('devai_assign_to_rovodev_main_release') && (0, $i860n.fg)('boysenberry_enable_entitlements_check')
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isBrowserOnly: false
});

});
parcelRegister("feWQ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $49b595459e4c3073$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d5cc6c3024b2727de7e057a20d918361>>
 * @relayHash c806d2608abd9032f8dbaaa9c5e7d6c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 88f1dd504c735a71f7f33afa541197a22f94cc6d134effc568fe85144d94cd08

var $hj1lc = parcelRequire("hj1lc");

var $18rp2 = parcelRequire("18rp2");

var $lIGkE = parcelRequire("lIGkE");
const $49b595459e4c3073$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAiAgentSessionsPanelEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAssignToRovoDevActive"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueViewRovoDevAgentsPanelEntitlementEnabled"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Literal",
        "name": "ownershipFilter",
        "value": "ALL"
    }, v7 = [
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "DevAiEntitlementCheckResultResponse",
        "kind": "LinkedField",
        "name": "checks",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "entitlementType"
            },
            {
                "kind": "ScalarField",
                "name": "userHasProductAccess"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "isFeatureEnabled"
    }, v10 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v11 = [
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 25
        },
        {
            "kind": "Variable",
            "name": "issueKey",
            "variableName": "issueKey"
        },
        v6 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "sort",
            "value": "DESC"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = [
        {
            "concreteType": "DevAiRovoDevSessionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "DevAiRovoDevSession",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "sessionStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "updatedAt"
                        },
                        {
                            "concreteType": "DevAiRovoDevRepository",
                            "kind": "LinkedField",
                            "name": "repository",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetBranch"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "branchUrl"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "promptAdf"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sessionTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "buildStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "prStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "prUrl"
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "cursor"
                }
            ]
        },
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                }
            ]
        },
        v10 /*: any*/ 
    ], v16 = [
        "issueKey",
        "cloudId",
        "ownershipFilter"
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DevaiIssueViewQuery",
            "selections": [
                {
                    "condition": "isAiAgentSessionsPanelEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "isAssignToRovoDevActive",
                                    "variableName": "isAssignToRovoDevActive"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "IssueViewAgentPanel_rovodevQuery"
                        }
                    ]
                },
                {
                    "condition": "issueViewRovoDevAgentsPanelEntitlementEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v6 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "RovodevAgentPanelWithEntitlementCheck"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "DevaiIssueViewQuery",
            "selections": [
                {
                    "condition": "isAiAgentSessionsPanelEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "condition": "isAssignToRovoDevActive",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "DevAiRovoDevIssueViewResponse",
                                    "kind": "LinkedField",
                                    "name": "devai_rovodevIssueViewQuery",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v10 /*: any*/ 
                    ]
                },
                {
                    "condition": "issueViewRovoDevAgentsPanelEntitlementEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "DevAiRovoDevIssueViewResponse",
                            "kind": "LinkedField",
                            "name": "devai_rovodevIssueViewQuery",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "DevAiRovoDevSessionConnection",
                                            "kind": "LinkedField",
                                            "name": "sessions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevAiRovoDevSessionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "AuthenticationContext",
                                    "kind": "LinkedField",
                                    "name": "me",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "DevAiRovoDevIssueViewResponse",
                                            "kind": "LinkedField",
                                            "name": "devai_rovodevIssueViewQuery",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v11 /*: any*/ ,
                                                    "concreteType": "DevAiRovoDevSessionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "sessions",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ 
                                                },
                                                {
                                                    "args": v11 /*: any*/ ,
                                                    "filters": v16 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "BoysenberryCodePanel__sessions",
                                                    "kind": "LinkedHandle",
                                                    "name": "sessions"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "DevAiRovoDevSessionConnection",
                                            "kind": "LinkedField",
                                            "name": "devai_rovodevSessionsByIssueKey",
                                            "plural": false,
                                            "selections": v15 /*: any*/ 
                                        },
                                        {
                                            "args": v11 /*: any*/ ,
                                            "filters": v16 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "BoysenberryCodePanel__devai_rovodevSessionsByIssueKey",
                                            "kind": "LinkedHandle",
                                            "name": "devai_rovodevSessionsByIssueKey"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "88f1dd504c735a71f7f33afa541197a22f94cc6d134effc568fe85144d94cd08",
            "metadata": {},
            "name": "DevaiIssueViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider": (0, $hj1lc.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider": (0, $18rp2.default)
            }
        }
    };
}();
$49b595459e4c3073$var$node.hash = "97fd34c7e3714ca895e582d83c7110eb";
(0, $lIGkE.PreloadableQueryRegistry).set($49b595459e4c3073$var$node.params.id, $49b595459e4c3073$var$node);
var $49b595459e4c3073$export$2e2bcd8739ae039 = $49b595459e4c3073$var$node;

});


parcelRegister("jXFcu", function(module, exports) {
$parcel$export(module.exports, "rovoDevEntitlementResource", () => $4e01f31c60daf1a4$export$6d5ff04cc1ef547d);

var $g9R2N = parcelRequire("g9R2N");

var $htsFl = parcelRequire("htsFl");
const $4e01f31c60daf1a4$var$QUERY = (0, $g9R2N.default);
const $4e01f31c60daf1a4$var$RESOURCE_TYPE_ROVO_DEV_ENTITLEMENT = 'ROVO_DEV_ENTITLEMENT';
const $4e01f31c60daf1a4$export$6d5ff04cc1ef547d = (0, $htsFl.createRelayResource)({
    type: $4e01f31c60daf1a4$var$RESOURCE_TYPE_ROVO_DEV_ENTITLEMENT,
    getQuery: (_, { tenantContext: tenantContext })=>{
        const cloudId = tenantContext?.cloudId ?? '';
        if (!cloudId || tenantContext?.isAnonymous) return {
            parameters: $4e01f31c60daf1a4$var$QUERY,
            variables: {
                cloudId: ''
            },
            options: {
                fetchPolicy: 'store-only'
            }
        };
        return {
            parameters: $4e01f31c60daf1a4$var$QUERY,
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isBrowserOnly: false // SSR for issue view
});

});
parcelRegister("g9R2N", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0954373ab6f1b5b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<461901de4dd7bc79ad00355560a28bb5>>
 * @relayHash 9739f0f71fb947308ea2e1e934f4c050
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a43ae8c56bfe5af230ff64f69d82c8fc730834d10506cefa66b53c8ac72084c
const $a0954373ab6f1b5b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "DevAiRovoDevIssueViewResponse",
            "kind": "LinkedField",
            "name": "devai_rovodevIssueViewQuery",
            "plural": false,
            "selections": [
                {
                    "concreteType": "DevAiEntitlementCheckResultResponse",
                    "kind": "LinkedField",
                    "name": "checks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "entitlementType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userHasProductAccess"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "isFeatureEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rovoDevEntitlementResourceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rovoDevEntitlementResourceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5a43ae8c56bfe5af230ff64f69d82c8fc730834d10506cefa66b53c8ac72084c",
            "metadata": {},
            "name": "rovoDevEntitlementResourceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a0954373ab6f1b5b$var$node.hash = "6577aea77cf228f78deb22b849b9b1d0";
var $a0954373ab6f1b5b$export$2e2bcd8739ae039 = $a0954373ab6f1b5b$var$node;

});


parcelRegister("dfITH", function(module, exports) {
$parcel$export(module.exports, "connectedToIssueAggDataResource", () => $2f77e99938c36bf7$export$36089449ec3aecd3);

var $1HBXB = parcelRequire("1HBXB");

var $jTPDD = parcelRequire("jTPDD");

var $kfVxU = parcelRequire("kfVxU");

var $htsFl = parcelRequire("htsFl");

var $ieliU = parcelRequire("ieliU");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");
const $2f77e99938c36bf7$export$36089449ec3aecd3 = (0, $htsFl.createRelayResource)({
    type: 'CONNECTED_TO_ISSUE_AGG_DATA',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match) || query?.selectedIssue || '';
        if (!issueKey || tenantContext?.isAnonymous) return {
            parameters: (0, $1HBXB.default),
            variables: {
                cloudId: '',
                issueKey: '',
                siteAri: '',
                isAnonymous: !!tenantContext?.isAnonymous,
                includeDesignPanelData: false,
                includeWhiteboardsCountInAttachmentConsolidation: false,
                includeReleasesPanelDevOpsData: false,
                workItemModernizationEnabled: false,
                isJsmIncidentCommandCenterEnabled: false
            },
            options: {
                fetchPolicy: 'store-only'
            }
        };
        const cloudId = tenantContext?.cloudId || '';
        const siteAri = (0, $ieliU.JiraSiteAri).create({
            siteId: cloudId
        }).toString();
        const workItemModernizationEnabled = (0, $jTPDD.isWorkItemModernizationAllowedForProject)(cloudId, issueKey) && // eslint-disable-next-line jira/ff/no-work-item-modernization-exp-val
        (0, $2700E.expVal)('work_item_modernization', 'isEnabled', false) || (0, $i860n.fg)('enable_work_item_for_quadratic_release');
        return {
            parameters: (0, $1HBXB.default),
            variables: {
                cloudId: tenantContext?.cloudId || '',
                issueKey: issueKey,
                siteAri: siteAri,
                isAnonymous: false,
                consistentRead: (0, $i860n.fg)('design-panel-ags-consistent-read'),
                includeDesignPanelData: true,
                includeWhiteboardsCountInAttachmentConsolidation: (0, $2700E.expVal)('attachments-1p-consolidation-experiment', 'isExperimentEnabled', false),
                includeReleasesPanelDevOpsData: (0, $i860n.fg)('jpx-1073-remove-jswddfetchoperation'),
                workItemModernizationEnabled: workItemModernizationEnabled,
                isJsmIncidentCommandCenterEnabled: (0, $i860n.fg)('jsm_incident_command_center')
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isBrowserOnly: false
});

});
parcelRegister("1HBXB", function(module, exports) {
$parcel$export(module.exports, "default", () => $d91de4d28ca1cca7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<832cb0ca05b4c29680da26b6dca1469f>>
 * @relayHash b4e03b15be6a814c8cff18ca1451d20f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4415d0b1ab234ce7d01399eb3698f9271644ab95605bfc662594739a4f108021

var $iZoUB = parcelRequire("iZoUB");

var $fV3TX = parcelRequire("fV3TX");

var $iCTPX = parcelRequire("iCTPX");

var $lFWP3 = parcelRequire("lFWP3");

var $lIGkE = parcelRequire("lIGkE");
const $d91de4d28ca1cca7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "consistentRead"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeDesignPanelData"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReleasesPanelDevOpsData"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeWhiteboardsCountInAttachmentConsolidation"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJsmIncidentCommandCenterEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workItemModernizationEnabled"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = [
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 900
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v18 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "serviceId"
        },
        v15 /*: any*/ 
    ], v20 = {
        "kind": "ScalarField",
        "name": "descriptionList"
    }, v21 = {
        "kind": "ScalarField",
        "name": "description"
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "category"
    }, v24 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "type"
    }, v26 = {
        "kind": "ScalarField",
        "name": "key"
    }, v27 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "enabled"
    }, v29 = {
        "kind": "ScalarField",
        "name": "url"
    }, v30 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "siteAri"
    }, v31 = [
        v30 /*: any*/ 
    ], v32 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issueByKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v24 /*: any*/ ,
                            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalDeploymentConnection",
                            "kind": "LinkedField",
                            "name": "deployments",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalDeploymentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": "devOpsState",
                                                            "kind": "ScalarField",
                                                            "name": "state"
                                                        },
                                                        {
                                                            "alias": "devOpsLastUpdated",
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdated"
                                                        },
                                                        {
                                                            "concreteType": "DevOpsEnvironment",
                                                            "kind": "LinkedField",
                                                            "name": "environment",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "DeploymentSummary"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": "externalState",
                                                            "kind": "ScalarField",
                                                            "name": "state"
                                                        },
                                                        {
                                                            "alias": "externalLastUpdated",
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdated"
                                                        },
                                                        {
                                                            "concreteType": "ExternalEnvironment",
                                                            "kind": "LinkedField",
                                                            "name": "environment",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "ExternalDeployment"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "deployments(first:100)"
                        },
                        {
                            "args": v24 /*: any*/ ,
                            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalFeatureFlagConnection",
                            "kind": "LinkedField",
                            "name": "featureFlags",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalFeatureFlagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "alias": "devOpsSummary",
                                                            "concreteType": "DevOpsFeatureFlagSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "rolloutPercentage"
                                                                },
                                                                v29 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "DevOpsFeatureFlag"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        {
                                                            "alias": "externalSummary",
                                                            "concreteType": "ExternalFeatureFlagSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ExternalFeatureFlagStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalFeatureFlagRollout",
                                                                            "kind": "LinkedField",
                                                                            "name": "rollout",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "percentage"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "ExternalProvider",
                                                            "kind": "LinkedField",
                                                            "name": "provider",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "ExternalFeatureFlag"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "featureFlags(first:100)"
                        },
                        {
                            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalRemoteLinkConnection",
                            "kind": "LinkedField",
                            "name": "remoteLinks",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "DevOps",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
                {
                    "args": v31 /*: any*/ ,
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsFeatureFlagProvider",
                            "kind": "LinkedField",
                            "name": "featureFlagProviders",
                            "plural": true,
                            "selections": [
                                v12 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "createFeatureFlagTemplateUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "connectFeatureFlagTemplateUrl"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "checkAuth"
    }, v34 = {
        "kind": "ScalarField",
        "name": "getEntityByUrl"
    }, v35 = {
        "kind": "ScalarField",
        "name": "status"
    }, v36 = [
        {
            "concreteType": "DevOpsDesignProvider",
            "kind": "LinkedField",
            "name": "designProviders",
            "plural": true,
            "selections": [
                v12 /*: any*/ ,
                v15 /*: any*/ ,
                {
                    "concreteType": "DevOpsSupportedActions",
                    "kind": "LinkedField",
                    "name": "supportedActions",
                    "plural": false,
                    "selections": [
                        v33 /*: any*/ ,
                        v34 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "handledDomainName"
                },
                {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                v10 /*: any*/ 
                            ],
                            "concreteType": "JiraAppConfigState",
                            "kind": "LinkedField",
                            "name": "configState",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraConfigStateConnection",
                                    "kind": "LinkedField",
                                    "name": "config",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraConfigState",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v35 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "workspaceId"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v37 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ConnectedToIssueAggQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v11 /*: any*/ ,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ConfluenceContentV2Whiteboards"
                                    },
                                    {
                                        "condition": "includeWhiteboardsCountInAttachmentConsolidation",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ResourcesSectionWhiteboardsCount"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "IncidentOverviewTabContent_connectedToIssueFragment"
                                    },
                                    {
                                        "condition": "isJsmIncidentCommandCenterEnabled",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "fragment": {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "IssueLayoutWithIssueLayoutState_shouldShowIncidentCommandCenter"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                "kind": "AliasedInlineFragmentSpread",
                                                "name": "incidentCommandCenterFragment"
                                            },
                                            {
                                                "fragment": {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ChildrenIssuesSection_shouldShowIncidentCommandCenter"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                "kind": "AliasedInlineFragmentSpread",
                                                "name": "statusPagesIncidentCommandCenterFragment"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "condition": "includeReleasesPanelDevOpsData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CompactLayoutItemsSection_connectedToQuery"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "DetailsPanelsSection_connectedToQuery"
                        }
                    ]
                },
                {
                    "condition": "includeDesignPanelData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "DesignSectionDesignPanelWrapper"
                        }
                    ]
                },
                {
                    "condition": "workItemModernizationEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "includeDesignPanelData",
                                    "variableName": "includeDesignPanelData"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "WorkItemLayout_connectedAggData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v9 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx"
                }
            ],
            "kind": "Operation",
            "name": "ConnectedToIssueAggQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "condition": "isAnonymous",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "GraphStoreSimplifiedIssueToWhiteboardConnection",
                                            "kind": "LinkedField",
                                            "name": "whiteboards",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedIssueToWhiteboardEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ConfluenceWhiteboardLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "base"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "webUi"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ConfluenceUserInfo",
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "accountId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "accountStatus"
                                                                                        },
                                                                                        v15 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "picture"
                                                                                        },
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "title"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "whiteboardId"
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        },
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "whiteboards(first:900)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "ConfluenceContentV2Whiteboards__whiteboards",
                                            "kind": "LinkedHandle",
                                            "name": "whiteboards"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeWhiteboardsCountInAttachmentConsolidation",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "isAnonymous",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v13 /*: any*/ ,
                                                    "concreteType": "GraphStoreSimplifiedIssueToWhiteboardConnection",
                                                    "kind": "LinkedField",
                                                    "name": "whiteboards",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphStoreSimplifiedIssueToWhiteboardEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createdAt"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "whiteboards(first:900)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "incidentSuggestion",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "incidentSummaryDescription"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "probableRCADescription"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "suggestedActions",
                                                            "plural": true,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "suggestedProblemTicketSummary"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "suggestedProblemTicketDescription"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "suggestedProblemTicketRootCause"
                                                                        },
                                                                        {
                                                                            "concreteType": "AIOpsIncidentAffectedServiceDetail",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedProblemTicketAffectedServices",
                                                                            "plural": true,
                                                                            "selections": v19 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "AIOpsIncidentSuggestedProblemTicket"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "suggestedIsMajorIncident"
                                                                        }
                                                                    ],
                                                                    "type": "AIOpsIncidentSuggestedMajorIncident"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AIOpsIncidentSuggestedUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedAssignees",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AIOpsIncidentSuggestedAssignees"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "AIOpsIncidentSuggestedUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedResponders",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "ari"
                                                                                },
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "avatarUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AIOpsIncidentSuggestedResponders"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "AIOpsIncidentSuggestedPriorityDetail",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedPriority",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "priorityId"
                                                                                },
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "iconUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AIOpsIncidentSuggestedPriority"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "AIOpsIncidentSuggestedSeverityDetail",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedSeverity",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "severityId"
                                                                                },
                                                                                v15 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AIOpsIncidentSuggestedSeverity"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "AIOpsIncidentSuggestedAutomationRule",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedAutomationRules",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "ruleId"
                                                                                },
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "resourceRuleScopes"
                                                                                },
                                                                                {
                                                                                    "concreteType": "AIOpsAutomationRuleUserPrompt",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "userInputPrompts",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "variableName"
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "inputType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "required"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AIOpsIncidentSuggestedRcaWithAutomation"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AIOpsIncidentAffectedServiceDetail",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedAffectedServices",
                                                                            "plural": true,
                                                                            "selections": v19 /*: any*/ 
                                                                        },
                                                                        v20 /*: any*/ 
                                                                    ],
                                                                    "type": "AIOpsIncidentSuggestedAffectedServices"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "AIOpsIncidentSuggestionResponse"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "limit",
                                                    "value": 5
                                                }
                                            ],
                                            "concreteType": "AIOpsIncidentTimelineIccResponse",
                                            "kind": "LinkedField",
                                            "name": "incidentTimeline",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AIOpsIncidentTimelineIccEntry",
                                                    "kind": "LinkedField",
                                                    "name": "entries",
                                                    "plural": true,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "timestamp"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "incidentTimeline(limit:5)"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isJsmIncidentCommandCenterEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowIncidentCommandCenter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeReleasesPanelDevOpsData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v32 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeDesignPanelData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "DevOps",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v31 /*: any*/ ,
                                            "concreteType": "DevOpsProviders",
                                            "kind": "LinkedField",
                                            "name": "providers",
                                            "plural": false,
                                            "selections": v36 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "providersWithDesignType",
                                            "args": [
                                                v30 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "providerTypes",
                                                    "value": [
                                                        "DESIGN"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "DevOpsProviders",
                                            "kind": "LinkedField",
                                            "name": "providers",
                                            "plural": false,
                                            "selections": v36 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "consistentRead",
                                                    "variableName": "consistentRead"
                                                }
                                            ],
                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignConnection",
                                            "kind": "LinkedField",
                                            "name": "designs",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "liveEmbedUrl"
                                                                        },
                                                                        {
                                                                            "args": v31 /*: any*/ ,
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsSupportedActions",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "supportedActions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v34 /*: any*/ ,
                                                                                                v33 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "DevOpsDesignProvider"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdated"
                                                                        },
                                                                        v35 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v37 /*: any*/ 
                                                                    ],
                                                                    "type": "DevOpsDesign"
                                                                },
                                                                v16 /*: any*/ ,
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        v12 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                v37 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "workItemModernizationEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": v32 /*: any*/ 
                }
            ]
        },
        "params": {
            "id": "4415d0b1ab234ce7d01399eb3698f9271644ab95605bfc662594739a4f108021",
            "metadata": {},
            "name": "ConnectedToIssueAggQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx": (0, $fV3TX.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx": (0, $iCTPX.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx": (0, $iZoUB.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx": (0, $lFWP3.default)
            }
        }
    };
}();
$d91de4d28ca1cca7$var$node.hash = "25be85a918669eed186942dd600736a7";
(0, $lIGkE.PreloadableQueryRegistry).set($d91de4d28ca1cca7$var$node.params.id, $d91de4d28ca1cca7$var$node);
var $d91de4d28ca1cca7$export$2e2bcd8739ae039 = $d91de4d28ca1cca7$var$node;

});
parcelRegister("iZoUB", function(module, exports) {
$parcel$export(module.exports, "default", () => $429ca71817fb4b5c$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $429ca71817fb4b5c$var$IsRemoveJswddFetchOperationEnabledRelayProvider = {
    get () {
        return (0, $i860n.fg)('jpx-1073-remove-jswddfetchoperation');
    }
};
var $429ca71817fb4b5c$export$2e2bcd8739ae039 = $429ca71817fb4b5c$var$IsRemoveJswddFetchOperationEnabledRelayProvider;

});


parcelRegister("jTPDD", function(module, exports) {
$parcel$export(module.exports, "isWorkItemModernizationAllowedForProject", () => $bf5a3dd8018f5ca6$export$584bd65f3d3d2380);

var $2700E = parcelRequire("2700E");

var $6CfY5 = parcelRequire("6CfY5");
/**
 * Project-based dynamic config that scopes the Work Item Modernization (WIV) rollout to
 * specific tenants/projects independently of (and in addition to) the global experiment.
 *
 * The experiment key `work_item_modernization_project_based_config` resolves to a `value`
 * parameter shaped as `string[]`. Each entry has the form `cloudId:PATTERN[,PATTERN…]`,
 * where each `PATTERN` is:
 *   - bare (e.g. `ABC`, `A*`)               — include pattern, opt-in
 *   - `!` prefixed (e.g. `!ABC`, `!ARCHIV*`) — exclude pattern, opt-out
 *
 * Patterns support glob wildcards `*` (any chars) and `?` (single char). Multiple entries for the
 * same `cloudId` are merged (all includes ∪, all excludes ∪).
 *
 * @example
 *   [
 *     '11111111-1111-1111-1111-111111111111:A*,DEV,!ABCDEF,!ARCHIV*',
 *     '22222222-...:FOO,BAR',
 *   ]
 */ const $bf5a3dd8018f5ca6$var$REGEX_SPECIAL_CHARS = /[.+^${}()|[\]\\]/g;
/**
 * Compile a glob pattern (`*`, `?`) into an anchored RegExp. Escapes all other regex
 * meta-characters so a runtime config value can never inject regex syntax.
 */ function $bf5a3dd8018f5ca6$var$compileGlobToRegExp(pattern) {
    const escaped = pattern.replace($bf5a3dd8018f5ca6$var$REGEX_SPECIAL_CHARS, '\\$&');
    const regexBody = escaped.replace(/\*/g, '.*').replace(/\?/g, '.');
    return new RegExp(`^${regexBody}$`);
}
function $bf5a3dd8018f5ca6$var$matchesAnyPattern(patterns, projectKey) {
    for (const pattern of patterns)try {
        if ($bf5a3dd8018f5ca6$var$compileGlobToRegExp(pattern).test(projectKey)) return true;
    } catch  {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('issue.eligibility.is-work-item-modernization-allowed-for-project', 'Unexpectedly failed to compile glob pattern from WIV project-based dynamic config');
    }
    return false;
}
function $bf5a3dd8018f5ca6$var$parseEntry(entry) {
    const [rawCloudId, rawValue] = entry.split(':');
    if (rawValue === undefined) return undefined;
    const cloudId = rawCloudId.trim();
    if (!cloudId) return undefined;
    const includes = [];
    const excludes = [];
    const rawPatterns = rawValue.split(',');
    for (const rawPattern of rawPatterns){
        const trimmed = rawPattern.trim();
        if (trimmed.startsWith('!')) {
            const pattern = trimmed.slice(1).trim();
            if (pattern) excludes.push(pattern);
        } else if (trimmed) includes.push(trimmed);
    }
    return {
        cloudId: cloudId,
        includes: includes,
        excludes: excludes
    };
}
function $bf5a3dd8018f5ca6$var$getConfigEntries(rawConfig) {
    if (!Array.isArray(rawConfig)) return [];
    return rawConfig.filter((entry)=>typeof entry === 'string');
}
function $bf5a3dd8018f5ca6$export$584bd65f3d3d2380(cloudId, issueKey) {
    // eslint-disable-next-line jira/ff/no-work-item-modernization-exp-val
    if (!(0, $2700E.expVal)('work_item_modernization', 'isEnabled', false)) return false;
    const projectKey = issueKey?.split('-')[0];
    if (!cloudId || !projectKey) return true;
    const entries = $bf5a3dd8018f5ca6$var$getConfigEntries(// eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
    (0, $2700E.expVal)('work_item_modernization_project_based_config', 'value', []));
    let cloudIdConfigured = false;
    const includes = [];
    const excludes = [];
    for (const rawEntry of entries){
        const parsed = $bf5a3dd8018f5ca6$var$parseEntry(rawEntry);
        if (parsed && parsed.cloudId === cloudId) {
            cloudIdConfigured = true;
            includes.push(...parsed.includes);
            excludes.push(...parsed.excludes);
        }
    }
    if (!cloudIdConfigured) return true;
    if ($bf5a3dd8018f5ca6$var$matchesAnyPattern(excludes, projectKey)) return false;
    return $bf5a3dd8018f5ca6$var$matchesAnyPattern(includes, projectKey);
}

});

parcelRegister("ieliU", function(module, exports) {
$parcel$export(module.exports, "JiraSiteAri", () => $d45a0f51041d523f$export$6c0f81f222d09301);

var $2AEf7 = parcelRequire("2AEf7");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/site/manifest.ts
var $d45a0f51041d523f$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $2AEf7.JiraSiteAriResourceOwner),
    resourceType: (0, $2AEf7.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $d45a0f51041d523f$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d45a0f51041d523f$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $d45a0f51041d523f$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $d45a0f51041d523f$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $d45a0f51041d523f$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $d45a0f51041d523f$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $d45a0f51041d523f$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("2AEf7", function(module, exports) {
$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $1e2e28eedc1bf7f6$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $1e2e28eedc1bf7f6$export$886165a991f21644);
// src/jira/site/types.ts
var $1e2e28eedc1bf7f6$export$b7d590981b504412 = "jira", $1e2e28eedc1bf7f6$export$886165a991f21644 = "site";

});



parcelRegister("ibD7n", function(module, exports) {
$parcel$export(module.exports, "ecosystemConnectBackgroundScriptsResource", () => $18ccbea17fed939b$export$6ebf16303c9f9d41);

var $5dKJP = parcelRequire("5dKJP");

var $kfVxU = parcelRequire("kfVxU");

var $htsFl = parcelRequire("htsFl");
const $18ccbea17fed939b$export$6ebf16303c9f9d41 = (0, $htsFl.createRelayResource)({
    type: 'ECOSYSTEM_CONNECT_BACKGROUND_SCRIPTS',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match) || query?.selectedIssue || '';
        if (!issueKey) return {
            parameters: (0, $5dKJP.default),
            variables: {
                cloudId: '',
                issueKey: ''
            },
            options: {
                fetchPolicy: 'store-only'
            }
        };
        return {
            parameters: (0, $5dKJP.default),
            variables: {
                cloudId: tenantContext?.cloudId || '',
                issueKey: issueKey
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isBrowserOnly: false
});

});
parcelRegister("5dKJP", function(module, exports) {
$parcel$export(module.exports, "default", () => $09d8d61e8d145ef1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b421905774452b5ce0c307bcb03c96b>>
 * @relayHash 297d8cf766cfae74d2631c06b094a254
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a242eda74a13ae6c0a9260b1a76cf9c5eda3869efbd6ec6f6d696a454094cd38

var $lIGkE = parcelRequire("lIGkE");
const $09d8d61e8d145ef1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EcosystemBackgroundScriptsWithLoaderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "EcosystemBackgroundScripts"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EcosystemBackgroundScriptsWithLoaderQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueConnectBackgroundScriptConnection",
                                    "kind": "LinkedField",
                                    "name": "connectBackgroundScripts",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueConnectBackgroundScriptEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueConnectBackgroundScript",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shouldReloadOnRefresh"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "addonKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moduleKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "options"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a242eda74a13ae6c0a9260b1a76cf9c5eda3869efbd6ec6f6d696a454094cd38",
            "metadata": {},
            "name": "EcosystemBackgroundScriptsWithLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$09d8d61e8d145ef1$var$node.hash = "1451d648926379a040fb01b943af0a46";
(0, $lIGkE.PreloadableQueryRegistry).set($09d8d61e8d145ef1$var$node.params.id, $09d8d61e8d145ef1$var$node);
var $09d8d61e8d145ef1$export$2e2bcd8739ae039 = $09d8d61e8d145ef1$var$node;

});


parcelRegister("24uSh", function(module, exports) {
$parcel$export(module.exports, "shadowIssueViewRelayResource", () => $6013f30d08835504$export$558b7fb677271108);
/* eslint-disable jira/import-whitelist */ 
var $40rxp = parcelRequire("40rxp");

var $4zB4T = parcelRequire("4zB4T");

var $7lx2l = parcelRequire("7lx2l");

var $kfVxU = parcelRequire("kfVxU");

var $htsFl = parcelRequire("htsFl");

var $2700E = parcelRequire("2700E");
const $6013f30d08835504$export$558b7fb677271108 = (0, $htsFl.createRelayResource)({
    type: 'ISSUE_RELAY_DATA_SHADOW',
    isBrowserOnly: true,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $kfVxU.getIssueKey)(match) || routerContext.query?.selectedIssue || '';
        const projectKey = issueKey ? (0, $40rxp.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey,
            projectKey: projectKey
        };
        const limitFields = (0, $2700E.expVal)('jpx-000-shadow-relay-query', 'limitFields', 99999) ?? 99999;
        return {
            parameters: (0, $7lx2l.default),
            variables: {
                ...queryVariables,
                ...(0, $4zB4T.getMainIssueViewAggQueryVariables)(issueKey),
                limitFields: limitFields
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $4zB4T.getMainIssueViewAggQueryFeatureFlagVariables)(),
                limitFields: limitFields
            },
            options: {
                fetchPolicy: issueKey ? 'network-only' : 'store-only'
            }
        };
    }
});

});
parcelRegister("7lx2l", function(module, exports) {
$parcel$export(module.exports, "default", () => $177f6a16ef9cbc05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc462866f9a396e2421840a3f5e9d10f>>
 * @relayHash ed6d27880249e65e68dece1247b7f074
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d049293cf4a93807a3840573cf7d76870feeaceae2a6d4694769cf328fd6318e

var $aFVhf = parcelRequire("aFVhf");

var $1D6fx = parcelRequire("1D6fx");

var $i4Eve = parcelRequire("i4Eve");

var $KUiqF = parcelRequire("KUiqF");

var $efrbL = parcelRequire("efrbL");

var $hNa68 = parcelRequire("hNa68");

var $7yObX = parcelRequire("7yObX");

var $dZY9f = parcelRequire("dZY9f");

var $g1jeD = parcelRequire("g1jeD");

var $6MPPK = parcelRequire("6MPPK");

var $2OiA9 = parcelRequire("2OiA9");

var $7e655 = parcelRequire("7e655");

var $7zUJD = parcelRequire("7zUJD");

var $gQsSz = parcelRequire("gQsSz");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $2qgMb = parcelRequire("2qgMb");

var $3etdx = parcelRequire("3etdx");

var $gE0jx = parcelRequire("gE0jx");

var $gSEQT = parcelRequire("gSEQT");

var $auBIl = parcelRequire("auBIl");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $1F2RS = parcelRequire("1F2RS");

var $hj1lc = parcelRequire("hj1lc");

var $18rp2 = parcelRequire("18rp2");

var $gCYbu = parcelRequire("gCYbu");

var $jRbnD = parcelRequire("jRbnD");

var $hLJKB = parcelRequire("hLJKB");

var $6qLgy = parcelRequire("6qLgy");

var $l4q64 = parcelRequire("l4q64");

var $e08II = parcelRequire("e08II");

var $1ZLvK = parcelRequire("1ZLvK");

var $1SctH = parcelRequire("1SctH");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $2XkhF = parcelRequire("2XkhF");

var $6BTmn = parcelRequire("6BTmn");

var $bdOMw = parcelRequire("bdOMw");

var $kyoX6 = parcelRequire("kyoX6");

var $jhYmN = parcelRequire("jhYmN");

var $gk902 = parcelRequire("gk902");

var $egon3 = parcelRequire("egon3");

var $jXd0g = parcelRequire("jXd0g");

var $b3Nht = parcelRequire("b3Nht");

var $lcsWS = parcelRequire("lcsWS");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $gyjgw = parcelRequire("gyjgw");

var $5ZdKP = parcelRequire("5ZdKP");

var $1w8Zj = parcelRequire("1w8Zj");

var $fCPPo = parcelRequire("fCPPo");

var $7so7Y = parcelRequire("7so7Y");

var $8bioU = parcelRequire("8bioU");

var $kdPlB = parcelRequire("kdPlB");

var $1JsCG = parcelRequire("1JsCG");

var $kvHcA = parcelRequire("kvHcA");

var $kkmRO = parcelRequire("kkmRO");

var $2JQfe = parcelRequire("2JQfe");

var $cNoBc = parcelRequire("cNoBc");

var $aIZjN = parcelRequire("aIZjN");

var $gmyGN = parcelRequire("gmyGN");

var $9HheZ = parcelRequire("9HheZ");

var $1A1H9 = parcelRequire("1A1H9");
const $177f6a16ef9cbc05$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d049293cf4a93807a3840573cf7d76870feeaceae2a6d4694769cf328fd6318e",
        "metadata": {},
        "name": "shadowMainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjracloud81233fixdisabledvotingrelayprovider": (0, $kvHcA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiv22472HasSummaryToMIAQFeatureGate": (0, $1JsCG.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiv22469DevSummaryToMIAQRelayProvider": (0, $kdPlB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsDFOCreateBranchTargetsEnabledRelayProvidertsx": (0, $hNa68.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcimpedimentflagfragmentfetchrelayprovidertsx": (0, $1SctH.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": (0, $1F2RS.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissueviewcontextpanelfieldsreorderingrelayprovider": (0, $gk902.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $gmyGN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccoverimageissueviewgarelayprovider": (0, $jRbnD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmWfoAssigneeRecommendationOnQueuesRelayprovider": (0, $gQsSz.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmissueviewaffectedservicesrelayprovider": (0, $kkmRO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmOmniSourceChannelCfFeRelayProvider": (0, $hLJKB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider": (0, $6qLgy.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUserPickerGuestLozengeRelayprovider": (0, $gSEQT.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcgoalsfieldwithshowallgoalsrelayprovider": (0, $e08II.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraEnableClassificationControlEnforcementRelayprovider": (0, $8bioU.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraenableclassificationorgdefaultfgrelayprovider": (0, $gyjgw.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $gCYbu.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjirarelaymigrationarchivalrelayprovider": (0, $1w8Zj.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissueclonerelaymigrationrelayprovider": (0, $bdOMw.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuedeleterelaymigrationrelayprovider": (0, $kyoX6.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $9HheZ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissueviewlayoutepiccolorfgrelayprovider": (0, $egon3.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraAiDeeplinkInHeaderRelayProvider": (0, $fCPPo.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAiGeneratedWorkItemNextActionsM2RelayProvider": (0, $aFVhf.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiDeeplinkFastFollowsRelayProvidertsx": (0, $6MPPK.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatartmpboardrelayprovider": (0, $lcsWS.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveSimilarIssuesFromLinkedIssuesRelayProvider": (0, $3etdx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCanSetIssueRestrictionFromLinkedIssuesRelayProvider": (0, $2qgMb.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarissueviewcommentsrelayprovider": (0, $jXd0g.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider": (0, $dZY9f.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiLocalAgentSessionsEnabledRelayProvider": (0, $2OiA9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgenticPlanningRelayProvider": (0, $g1jeD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivFixRedirectionIssueKeyRelayProvidertsx": (0, $auBIl.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEnableWorkItemForQuadraticReleaseRelayProvidertsx": (0, $i4Eve.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $5ZdKP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraChildIssuesPaginationRelayProvider": (0, $7so7Y.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": (0, $efrbL.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $2XkhF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryenableentitlementscheckrelayprovider": (0, $hj1lc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcboysenberryissueviewagentspanelrelayprovider": (0, $18rp2.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default)
        }
    }
};
var $177f6a16ef9cbc05$export$2e2bcd8739ae039 = $177f6a16ef9cbc05$var$node;

});


parcelRegister("2ngQP", function(module, exports) {
$parcel$export(module.exports, "issueViewDevPanelDataResource", () => $a1a402e88a67ec8c$export$a675440eeea7472a);
// eslint-disable-next-line jira/import-whitelist

var $83TVw = parcelRequire("83TVw");

var $kfVxU = parcelRequire("kfVxU");

var $htsFl = parcelRequire("htsFl");
const $a1a402e88a67ec8c$export$a675440eeea7472a = (0, $htsFl.createRelayResource)({
    type: 'ISSUE_VIEW_DEV_PANEL_SUMMARY_DATA',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const issueKey = (0, $kfVxU.getIssueKey)(match) || query?.selectedIssue || '';
        if (!issueKey) return {
            parameters: (0, $83TVw.default),
            variables: {
                issueKey: '',
                cloudId: ''
            },
            options: {
                fetchPolicy: 'store-only'
            }
        };
        return {
            parameters: (0, $83TVw.default),
            variables: {
                issueKey: issueKey,
                cloudId: tenantContext?.cloudId
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isBrowserOnly: true
});

});
parcelRegister("83TVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b83775ff2d88f0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef54f6372cef355774421dfd8373e12a>>
 * @relayHash 5f5da1b821db43d4e120cbb1b1fdc016
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 02379d49e10633b453b929c8009fba5f31f720b1654a58b5f3acda7f2aae3dc9
const $4b83775ff2d88f0a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "concreteType": "JiraIssueDevSummaryErrorProviderInstance",
            "kind": "LinkedField",
            "name": "instance",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "baseUrl"
                }
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "count"
    }, v6 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v7 = {
        "concreteType": "JiraIssueDevSummaryByProvider",
        "kind": "LinkedField",
        "name": "summaryByProvider",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            v5 /*: any*/ 
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v9 = {
        "kind": "ScalarField",
        "name": "stateCount"
    }, v10 = {
        "kind": "ScalarField",
        "name": "state"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueViewDevPanelSummaryDataQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraDevOpsIssuePanel",
                                        "kind": "LinkedField",
                                        "name": "devOpsIssuePanel",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "EmptyStatePrompt_jiraDevOpsIssuePanel"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ConnectedDevPanelApp_DevPanelApp"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "DevPanelAnalytics_issue"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueViewDevPanelSummaryDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDevOpsIssuePanel",
                                    "kind": "LinkedField",
                                    "name": "devOpsIssuePanel",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "panelState"
                                        },
                                        {
                                            "concreteType": "JiraIssueDevSummaryResult",
                                            "kind": "LinkedField",
                                            "name": "devSummaryResult",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueDevSummaryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v4 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraIssueDevSummaryError",
                                                    "kind": "LinkedField",
                                                    "name": "configErrors",
                                                    "plural": true,
                                                    "selections": v4 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraIssueDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "devSummary",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "branch",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "overall",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "commit",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "overall",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "pullrequest",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "overall",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "review",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "overall",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                                    "kind": "LinkedField",
                                                                    "name": "summaryByProvider",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "build",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "overall",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "failedBuildCount"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "successfulBuildCount"
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "unknownBuildCount"
                                                                        }
                                                                    ]
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "deploymentEnvironments",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "overall",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueDeploymentEnvironment",
                                                                            "kind": "LinkedField",
                                                                            "name": "topEnvironments",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasBranchCapabilities"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "devOpsIssuePanelBanner"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "02379d49e10633b453b929c8009fba5f31f720b1654a58b5f3acda7f2aae3dc9",
            "metadata": {},
            "name": "issueViewDevPanelSummaryDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4b83775ff2d88f0a$var$node.hash = "1948a34eeb0775d523615543e949f97e";
var $4b83775ff2d88f0a$export$2e2bcd8739ae039 = $4b83775ff2d88f0a$var$node;

});



parcelRegister("io0d5", function(module, exports) {
$parcel$export(module.exports, "issueDescriptionSmartlinkDataResource", () => $d1f15762fd2edb8b$export$122924808887d642);

var $kfVxU = parcelRequire("kfVxU");

var $7edbf = parcelRequire("7edbf");

var $bPlvg = parcelRequire("bPlvg");
const $d1f15762fd2edb8b$export$122924808887d642 = (0, $7edbf.createResource)({
    type: 'ISSUE_DESCRIPTION_SMARTLINK_DATA',
    getKey: ({ match: match })=>(0, $kfVxU.getIssueKey)(match) ?? '',
    getData: (...args)=>(0, $bPlvg.getIssueDescriptionSmartlinkData)(...args)
});

});
parcelRegister("bPlvg", function(module, exports) {
$parcel$export(module.exports, "getIssueDescriptionSmartlinkData", () => $d74bef55855aa95c$export$d5f7eb980753a8e3);
// eslint-disable-next-line jira/import-whitelist

var $9fzea = parcelRequire("9fzea");

var $bdEst = parcelRequire("bdEst");

var $kfVxU = parcelRequire("kfVxU");
const $d74bef55855aa95c$export$d5f7eb980753a8e3 = async (routerContext, storeContext)=>{
    // force smart link fetcher to not fire on client side to prevent CORS policy issues and enable prefetching of all links should SSR resource timeout.
    if (!false) return null;
    const issueKey = (0, $kfVxU.getIssueKey)(routerContext.match);
    const { tenantContext: tenantContext } = storeContext;
    const cloudId = tenantContext?.cloudId;
    if (!issueKey || !cloudId) return null;
    try {
        return await (0, $9fzea.fetchIssueDescriptionSmartlinkData)(issueKey, cloudId);
    } catch (error) {
        throw (0, $bdEst.createResourceError)({
            component: 'spa.view.routes.issue-view.issue-description-smartlink.getIssueDescriptionSmartlinkData',
            message: 'An error was thrown while prefetching issue description smart link data'
        }, error);
    }
};

});
parcelRegister("9fzea", function(module, exports) {
$parcel$export(module.exports, "fetchIssueDescriptionSmartlinkData", () => $33266932a09749d3$export$3c327941e7aead86);

var $4v9Eg = parcelRequire("4v9Eg");

var $n67Vb = parcelRequire("n67Vb");

var $f99M0 = parcelRequire("f99M0");

var $aI7em = parcelRequire("aI7em");

var $lMoch = parcelRequire("lMoch");

var $i860n = parcelRequire("i860n");

var $4v9Eg = parcelRequire("4v9Eg");

var $QAM4a = parcelRequire("QAM4a");
const $33266932a09749d3$var$SMART_LINKS_FIRST = 4;
const $33266932a09749d3$var$FETCH_ISSUE_DESCRIPTION_SMARTLINK_DATA = 'fetch-issue-description-smartlink-data';
const $33266932a09749d3$export$18a0901ee8c7a1ba = (0, $4v9Eg.default).params.name;
function $33266932a09749d3$var$extractSmartLinkUrls(data) {
    const edges = (0, $i860n.fg)('jpx-1321_use_faster_fields_in_fetch_smart_links_2') ? data?.jira?.issueByKey?.description?.adfValue?.smartLinks?.edges ?? [] : data?.jira?.issueByKey?.descriptionField?.richText?.adfValue?.smartLinks?.edges ?? [];
    const urls = [];
    for (const edge of edges){
        const url = edge?.node?.url;
        if (url) urls.push(url);
    }
    return urls;
}
const $33266932a09749d3$export$3c327941e7aead86 = async (issueKey, cloudId)=>{
    if (!(0, $QAM4a.canCallORS)()) return null;
    const captureId = (0, $lMoch.startCaptureGraphQlErrors)();
    const environment = (0, $aI7em.default)();
    const graphqlData = await (0, $n67Vb.fetchQuery)(environment, (0, $4v9Eg.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        first: $33266932a09749d3$var$SMART_LINKS_FIRST,
        after: '',
        useFasterFields: (0, $i860n.fg)('jpx-1321_use_faster_fields_in_fetch_smart_links_2')
    }).toPromise().catch((error)=>{
        throw error;
    });
    (0, $lMoch.stopCaptureGraphQlErrors)(captureId);
    const urls = $33266932a09749d3$var$extractSmartLinkUrls(graphqlData);
    const projectTypeData = (0, $i860n.fg)('jpx-1321_use_faster_fields_in_fetch_smart_links_2') ? graphqlData?.jira?.issueByKey?.project?.projectType : graphqlData?.jira?.issueByKey?.projectField?.project?.projectType;
    const projectType = projectTypeData ? (0, $f99M0.convertToProjectType)(projectTypeData) : undefined;
    if (urls.length === 0) return null;
    return (0, $QAM4a.fetchORSDataSSR)(urls, $33266932a09749d3$var$FETCH_ISSUE_DESCRIPTION_SMARTLINK_DATA, projectType, cloudId);
};
var $33266932a09749d3$export$2e2bcd8739ae039 = $33266932a09749d3$export$3c327941e7aead86;

});
parcelRegister("4v9Eg", function(module, exports) {
$parcel$export(module.exports, "default", () => $bec3c112cdd838e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<159dad237ad111e85e2d5cce6c578ee7>>
 * @relayHash 8509e4b8ffa66998b1d08c152618ae78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 540885f364a3745c4c08cea2f25690339508226d482007bccb96f1ee8619d37a
const $bec3c112cdd838e4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useFasterFields"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "url"
    }, v8 = [
        {
            "concreteType": "JiraADF",
            "kind": "LinkedField",
            "name": "adfValue",
            "plural": false,
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "JiraSmartLinkConnection",
                    "kind": "LinkedField",
                    "name": "smartLinks",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraSmartLinkEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v10 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v9 /*: any*/ 
        ]
    }, v11 = [
        {
            "concreteType": "JiraADF",
            "kind": "LinkedField",
            "name": "adfValue",
            "plural": false,
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "JiraSmartLinkConnection",
                    "kind": "LinkedField",
                    "name": "smartLinks",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraSmartLinkEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v12 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchIssueDescriptionSmartlinkDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "useFasterFields",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraRichTextField",
                                            "kind": "LinkedField",
                                            "name": "descriptionField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraRichText",
                                                    "kind": "LinkedField",
                                                    "name": "richText",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useFasterFields",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraRichText",
                                            "kind": "LinkedField",
                                            "name": "description",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchIssueDescriptionSmartlinkDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "useFasterFields",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraRichTextField",
                                            "kind": "LinkedField",
                                            "name": "descriptionField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraRichText",
                                                    "kind": "LinkedField",
                                                    "name": "richText",
                                                    "plural": false,
                                                    "selections": v11 /*: any*/ 
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useFasterFields",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraRichText",
                                            "kind": "LinkedField",
                                            "name": "description",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "540885f364a3745c4c08cea2f25690339508226d482007bccb96f1ee8619d37a",
            "metadata": {},
            "name": "fetchIssueDescriptionSmartlinkDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bec3c112cdd838e4$var$node.hash = "26ad8f9f656283cf1787ab6aae86abed";
var $bec3c112cdd838e4$export$2e2bcd8739ae039 = $bec3c112cdd838e4$var$node;

});




parcelRegister("lqVFL", function(module, exports) {
$parcel$export(module.exports, "LazyIssuePage", () => $2128b8551c073e3c$export$3e1d7c9fee0b1f1a);
$parcel$export(module.exports, "IssueComponent", () => $2128b8551c073e3c$export$c1a868ace2f38803);
$parcel$export(module.exports, "IssueEmbedComponent", () => $2128b8551c073e3c$export$ef02bcc0eb1d9ded);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $3CqKW = parcelRequire("3CqKW");

var $8xla3 = parcelRequire("8xla3");

var $2b39L = parcelRequire("2b39L");

var $3B1mt = parcelRequire("3B1mt");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $gNbXR = parcelRequire("gNbXR");
var $cZjb4 = parcelRequire("cZjb4");

const $2128b8551c073e3c$export$3e1d7c9fee0b1f1a = (0, $l8G1z.lazyForPaint)(()=>(0, $3B1mt.markAsBentoBundleReady)(// chunk name here MUST be kept in sync with TempLazyIssuePageWithSsrAlwaysDisabled below
    (parcelRequire("9yAxP")).then((module)=>module.IssueView)), {
    moduleId: "./src/packages/spa-apps/issue/src/IssueViewWithRedirect.tsx"
});
const $2128b8551c073e3c$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $2b39L.useProjectContext)();
    const [issueKey] = (0, $cZjb4.usePathParam)('issueKey');
    const pageId = 'spa-issue';
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $2128b8551c073e3c$export$3e1d7c9fee0b1f1a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
$2128b8551c073e3c$export$c1a868ace2f38803.displayName = "IssueComponent";
const $2128b8551c073e3c$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $cZjb4.usePathParam)('issueKey');
    const projectKey = (0, $8xla3.useProjectKey)(issueKey || '');
    const projectType = (0, $8xla3.useProjectType)(projectKey);
    const projectId = (0, $8xla3.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3CqKW.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2128b8551c073e3c$export$c1a868ace2f38803, null));
};
$2128b8551c073e3c$export$ef02bcc0eb1d9ded.displayName = "IssueEmbedComponent";

});
parcelRegister("3CqKW", function(module, exports) {
$parcel$export(module.exports, "EmbedModeContext", () => $8f87f3d27d989091$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $8f87f3d27d989091$export$9daaf42d62e1c430);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");
const $8f87f3d27d989091$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $euxye.createContext)(false);
const { Provider: $8f87f3d27d989091$var$Provider } = $8f87f3d27d989091$export$5eb07b3c7c0b0771;
const $8f87f3d27d989091$var$handleEmbedLinkClick = (e)=>{
    if (e.target instanceof Element) {
        const anchor = e.target.closest('a'); // Find closest parent anchor (including the target itself)
        if (anchor && anchor.target !== '_blank') // link
        anchor.target = '_blank';
    }
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $8f87f3d27d989091$var$DarkModeMonolithStyleOverride = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: "\n                    #jira-frontend {\n                        background: var(--ds-surface-overlay, #FFFFFF);\n                    }\n                "
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$8f87f3d27d989091$var$DarkModeMonolithStyleOverride.displayName = "DarkModeMonolithStyleOverride";
const $8f87f3d27d989091$export$9daaf42d62e1c430 = (t0)=>{
    const $ = (0, $e7boj.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    (0, $euxye.useEffect)($8f87f3d27d989091$var$_temp2, t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8f87f3d27d989091$var$DarkModeMonolithStyleOverride, null);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8f87f3d27d989091$var$Provider, {
            value: true
        }, children));
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
$8f87f3d27d989091$export$9daaf42d62e1c430.displayName = "EmbedModeProvider";
function $8f87f3d27d989091$var$_temp() {
    window.removeEventListener("click", $8f87f3d27d989091$var$handleEmbedLinkClick);
}
function $8f87f3d27d989091$var$_temp2() {
    window.addEventListener("click", $8f87f3d27d989091$var$handleEmbedLinkClick, true);
    return $8f87f3d27d989091$var$_temp;
}

});

parcelRegister("8xla3", function(module, exports) {
$parcel$export(module.exports, "useProjectKey", () => $204482941affc121$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $204482941affc121$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $204482941affc121$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $204482941affc121$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $204482941affc121$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $204482941affc121$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $204482941affc121$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $204482941affc121$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $204482941affc121$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $204482941affc121$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $204482941affc121$export$af19ad68b52fa1a6);

var $e7boj = parcelRequire("e7boj");

var $f99M0 = parcelRequire("f99M0");

var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $eijVy = parcelRequire("eijVy");

var $fZF0r = parcelRequire("fZF0r");

var $1puom = parcelRequire("1puom");
const $204482941affc121$export$f87be37f8e8be65 = (issueKey)=>issueKey.split('-')[0];
const $204482941affc121$export$bd73624ca941f105 = ()=>{
    const $ = (0, $e7boj.c)(5);
    const [, t0] = (0, $fZF0r.useProjectContextActionStore)();
    const { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty } = t0;
    let t1;
    if ($[0] !== mergeProjectProperty || $[1] !== setProjectContext) {
        t1 = {
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        };
        $[0] = mergeProjectProperty;
        $[1] = setProjectContext;
        $[2] = t1;
    } else t1 = $[2];
    const actions = t1;
    let t2;
    if ($[3] !== actions) {
        t2 = [
            null,
            actions
        ];
        $[3] = actions;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $204482941affc121$export$6de29d851c914935 = (projectKey)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== projectKey) {
        t0 = {
            projectKey: projectKey
        };
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    const [projectType] = (0, $fZF0r.useProjectContextProjectTypeStore)(t0);
    return projectType;
};
const $204482941affc121$export$8f31c2503e1efa93 = (projectKey)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== projectKey) {
        t0 = {
            projectKey: projectKey
        };
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    const [projectContext] = (0, $fZF0r.useProjectContextStore)(t0);
    return projectContext;
};
const $204482941affc121$export$aaf75bb403fe1fb5 = (projectKey, t0)=>{
    const $ = (0, $e7boj.c)(2);
    const failSafely = t0 === undefined ? false : t0;
    const projectType = $204482941affc121$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    let t1;
    if ($[0] !== projectType) {
        t1 = (0, $hJL79.getApplicationForProject)(projectType);
        $[0] = projectType;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $204482941affc121$export$d56c02945cf5a9e5 = (projectKey, t0)=>{
    const $ = (0, $e7boj.c)(3);
    const failSafely = t0 === undefined ? false : t0;
    const { appEditions: appEditions } = (0, $eijVy.useTenantContext)();
    const application = $204482941affc121$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return;
    let t1;
    if ($[0] !== appEditions || $[1] !== application) {
        t1 = (0, $d8LhJ.getEdition)(application, appEditions);
        $[0] = appEditions;
        $[1] = application;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $204482941affc121$export$69909c70ce8efefa = (projectStyle)=>{
    return projectStyle === (0, $f99M0.TEAM_MANAGED_PROJECT);
};
const $204482941affc121$export$524ef4f6102ed540 = (projectKey)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== projectKey) {
        t0 = {
            projectKey: projectKey
        };
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    const [projectContext] = (0, $fZF0r.useProjectContextStore)(t0);
    return projectContext?.isSimplified || false;
};
const $204482941affc121$export$e2cf96f40a8867ce = (projectKey)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== projectKey) {
        t0 = {
            projectKey: projectKey
        };
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    const [projectContext] = (0, $fZF0r.useProjectContextStore)(t0);
    return !projectContext?.isSimplified;
};
const $204482941affc121$export$16d1475ed6c26568 = (projectKey)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== projectKey) {
        t0 = {
            projectKey: projectKey
        };
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    const [projectContext] = (0, $fZF0r.useProjectContextStore)(t0);
    return projectContext?.projectId;
};
const $204482941affc121$export$30f16f2782a4113b = (projectKey)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== projectKey) {
        t0 = {
            projectKey: projectKey
        };
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    const [projectContext] = (0, $fZF0r.useProjectContextStore)(t0);
    return projectContext?.projectStatus;
};
const $204482941affc121$export$af19ad68b52fa1a6 = (projectKey)=>{
    const $ = (0, $e7boj.c)(3);
    const projectType = $204482941affc121$export$6de29d851c914935(projectKey);
    const isSimplified = $204482941affc121$export$524ef4f6102ed540(projectKey);
    let t0;
    if ($[0] !== isSimplified || $[1] !== projectType) {
        t0 = (0, $1puom.getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        });
        $[0] = isSimplified;
        $[1] = projectType;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $204482941affc121$export$80bef597b440cf71 = (projectKey)=>{
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== projectKey) {
        t0 = {
            projectKey: projectKey
        };
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    const [issueTypes] = (0, $fZF0r.useProjectContextIssueTypesStore)(t0);
    return issueTypes;
};

});
parcelRegister("fZF0r", function(module, exports) {
$parcel$export(module.exports, "projectContextStore", () => $c91b8fa0a4c525bf$export$c331eb1255fe885e);
$parcel$export(module.exports, "useProjectContextActionStore", () => $c91b8fa0a4c525bf$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $c91b8fa0a4c525bf$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $c91b8fa0a4c525bf$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextJiraProjectStyleStore", () => $c91b8fa0a4c525bf$export$b291cf203d6481a4);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $c91b8fa0a4c525bf$export$f73e9904779f6be5);

var $f99M0 = parcelRequire("f99M0");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $MDMu7 = parcelRequire("MDMu7");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $c91b8fa0a4c525bf$var$initialState = {};
const $c91b8fa0a4c525bf$export$c331eb1255fe885e = (0, $5QDqc.createStore)({
    name: 'project-context',
    initialState: $c91b8fa0a4c525bf$var$initialState,
    actions: $MDMu7
});
const $c91b8fa0a4c525bf$export$9afb89c1fe103bbe = (0, $3h1FP.createHook)($c91b8fa0a4c525bf$export$c331eb1255fe885e, {
    selector: null
});
const $c91b8fa0a4c525bf$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $c91b8fa0a4c525bf$export$8b09478b33186ec = (0, $3h1FP.createHook)($c91b8fa0a4c525bf$export$c331eb1255fe885e, {
    selector: $c91b8fa0a4c525bf$var$getProjectContext
});
const $c91b8fa0a4c525bf$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $c91b8fa0a4c525bf$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $c91b8fa0a4c525bf$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $c91b8fa0a4c525bf$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $f99M0.TEAM_MANAGED_PROJECT) : (0, $f99M0.COMPANY_MANAGED_PROJECT);
};
const $c91b8fa0a4c525bf$export$f2e1ed3b2b4707cb = (0, $3h1FP.createHook)($c91b8fa0a4c525bf$export$c331eb1255fe885e, {
    selector: $c91b8fa0a4c525bf$var$getProjectType
});
const $c91b8fa0a4c525bf$export$b291cf203d6481a4 = (0, $3h1FP.createHook)($c91b8fa0a4c525bf$export$c331eb1255fe885e, {
    selector: $c91b8fa0a4c525bf$var$getJiraProjectStyle
});
const $c91b8fa0a4c525bf$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $c91b8fa0a4c525bf$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $c91b8fa0a4c525bf$export$9469fde70658518 = (0, $3h1FP.createHook)($c91b8fa0a4c525bf$export$c331eb1255fe885e, {
    selector: $c91b8fa0a4c525bf$var$getProjectName
});
const $c91b8fa0a4c525bf$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $c91b8fa0a4c525bf$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $c91b8fa0a4c525bf$export$f73e9904779f6be5 = (0, $3h1FP.createHook)($c91b8fa0a4c525bf$export$c331eb1255fe885e, {
    selector: $c91b8fa0a4c525bf$var$getIssueTypes
});

});
parcelRegister("MDMu7", function(module, exports) {
$parcel$export(module.exports, "setProjectContext", () => $db701a7696373f49$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $db701a7696373f49$export$78f1c6052937615f);
const $db701a7696373f49$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $db701a7696373f49$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // oxlint-disable-next-line typescript/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("1puom", function(module, exports) {
$parcel$export(module.exports, "getIssueConfiguration", () => $f74a864e435443aa$export$902f6c5cc939598a);

var $f99M0 = parcelRequire("f99M0");

var $8tYi8 = parcelRequire("8tYi8");
// Issue actions
const $f74a864e435443aa$var$FLAG_ACTIONS = 'flagActions';
const $f74a864e435443aa$var$CARD_COVER_ACTIONS = 'cardCoverActions';
const $f74a864e435443aa$var$coreConfiguration = ()=>({
        applicationKey: (0, $8tYi8.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $f74a864e435443aa$var$softwareConfiguration = ()=>({
        applicationKey: (0, $8tYi8.default).SOFTWARE_ISSUE,
        issueActions: [
            $f74a864e435443aa$var$FLAG_ACTIONS
        ],
        ecosystemEnabled: true
    });
const $f74a864e435443aa$var$simpleSoftwareBoardConfiguration = ()=>({
        applicationKey: (0, $8tYi8.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $f74a864e435443aa$var$FLAG_ACTIONS,
            $f74a864e435443aa$var$CARD_COVER_ACTIONS
        ],
        ecosystemEnabled: true
    });
const $f74a864e435443aa$var$serviceDeskConfiguration = ()=>({
        applicationKey: (0, $8tYi8.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $f74a864e435443aa$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $f99M0.SOFTWARE_PROJECT:
            if (config.isSimplified) return $f74a864e435443aa$var$simpleSoftwareBoardConfiguration();
            return $f74a864e435443aa$var$softwareConfiguration();
        case 0, $f99M0.CORE_PROJECT:
            return $f74a864e435443aa$var$coreConfiguration();
        case 0, $f99M0.SERVICE_DESK_PROJECT:
            return $f74a864e435443aa$var$serviceDeskConfiguration();
        default:
            // fallback to sofware config
            return $f74a864e435443aa$var$softwareConfiguration();
    }
    return $f74a864e435443aa$var$softwareConfiguration();
};

});
parcelRegister("8tYi8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3033cc780f392b86$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $3033cc780f392b86$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $3033cc780f392b86$export$2e2bcd8739ae039 = $3033cc780f392b86$var$keys;

});



parcelRegister("3B1mt", function(module, exports) {
$parcel$export(module.exports, "markAsBentoBundleReady", () => $a8bb3942c994111e$export$d9ff0b3329728986);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lhWE3 = parcelRequire("lhWE3");

var $iLktG = parcelRequire("iLktG");
let $a8bb3942c994111e$var$reportedBentoBundleReady = false;
const $a8bb3942c994111e$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($a8bb3942c994111e$var$reportedBentoBundleReady) return;
        $a8bb3942c994111e$var$reportedBentoBundleReady = true;
        (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $lhWE3.JS_EVAL_START))) {
            (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("9yAxP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");





module.exports = Promise.all([
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    (parcelRequire("gZgW8"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            $4cvLQ("fuqPu"),
            $4cvLQ("1aRRK"),
            $4cvLQ("faPKS"),
            $4cvLQ("iZe2c")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("eBepx")
        ]);
    }),
    (parcelRequire("gZgW8"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $4cvLQ("8sGaA"),
            $4cvLQ("1aRRK"),
            $4cvLQ("faPKS"),
            $4cvLQ("iZe2c")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("93aeH")
        ]);
    }),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("5qC72"),
    $4cvLQ("eAoL3"),
    $4cvLQ("15ZAZ"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gCScl"),
    $4cvLQ("3xXwt")
]).then(()=>parcelRequire('jc9fY'));

});


parcelRegister("gFj7m", function(module, exports) {
$parcel$export(module.exports, "bifrostBrowseRouteRedirectionHandler", () => $ac2d44279cd7524c$export$b8b88f15c8f1f954);

var $9RVun = parcelRequire("9RVun");

var $75YsU = parcelRequire("75YsU");

var $adMfn = parcelRequire("adMfn");

var $ao3nB = parcelRequire("ao3nB");

var $i860n = parcelRequire("i860n");

var $6CfY5 = parcelRequire("6CfY5");
async function $ac2d44279cd7524c$export$b8b88f15c8f1f954({ match: match, url: url, tenantContext: tenantContext, isEmbed: isEmbed }) {
    if (!(0, $75YsU.isWorkItemModernizationGatesEnabled)() && (!(0, $i860n.fg)('jsm_aniv_routing_phase_1') || !(0, $i860n.fg)('jsm_aniv_route_redirection'))) return undefined;
    if (url.search.includes('disableRedirect=true')) return undefined;
    try {
        const issueKey = match.params.issueKey;
        if (!issueKey) return undefined;
        const projectKey = issueKey.split('-')[0];
        // MWIV-814: prefer the canonical issue key from Jira to handle project key moves/renames.
        const { projectType: projectType, userPreference: userPreference, issueKey: canonicalIssueKey, isCreatedFromAgenticTemplate: isCreatedFromAgenticTemplate, isAgenticWorkItemViewEnabled: isAgenticWorkItemViewEnabled } = (0, $i860n.fg)('wiv-fix-redirection-issue-key') ? await (0, $ao3nB.issueViewSwitchDataFetcher)(projectKey, tenantContext.cloudId, issueKey) : await (0, $ao3nB.issueViewSwitchDataFetcher)(projectKey, tenantContext.cloudId);
        const fromIssueKey = (0, $i860n.fg)('wiv-fix-redirection-issue-key') ? canonicalIssueKey ?? issueKey : issueKey;
        const shouldShowWiv = (0, $adMfn.shouldShowWorkItemView)({
            cloudId: tenantContext.cloudId,
            issueKey: issueKey,
            isIssueViewWivEnabled: userPreference,
            projectType: projectType,
            isCreatedFromAgenticTemplate: isCreatedFromAgenticTemplate,
            isAgenticWorkItemViewEnabled: isAgenticWorkItemViewEnabled
        });
        return (0, $9RVun.getWorkItemRedirectionPath)(fromIssueKey, projectType, url.search, userPreference, isEmbed, shouldShowWiv);
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('issue.router-routes.browse.issue.route.entry', error instanceof Error ? error.message : 'Unable to redirect at SSR');
    }
}

});
parcelRegister("9RVun", function(module, exports) {
$parcel$export(module.exports, "getWorkItemRedirectionPath", () => $32edbc709d64ed3b$export$83849f58c2c0984c);

var $i860n = parcelRequire("i860n");
function $32edbc709d64ed3b$export$83849f58c2c0984c(issueKey, projectType, searchQuery, userPreference = true, isEmbed = false, wivEnabledForProject = true) {
    if (!issueKey || !projectType || searchQuery.includes('disableRedirect=true')) return;
    if ([
        'software',
        'business'
    ].includes(projectType) && userPreference && wivEnabledForProject) {
        const embedPath = isEmbed ? '/embed' : '';
        return `/jira/browse/${issueKey}${embedPath}${searchQuery}`;
    }
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    projectType === 'service_desk' && (0, $i860n.fg)('jsm_aniv_routing_phase_1') && (0, $i860n.fg)('jsm_aniv_route_redirection')) {
        const embedPath = isEmbed ? '/embed' : '';
        return `/browse/jsm-work-item/${issueKey}${embedPath}${searchQuery}`;
    }
}

});

parcelRegister("75YsU", function(module, exports) {
$parcel$export(module.exports, "isWorkItemModernizationGatesEnabled", () => $663dca38b7cf47cc$export$2e38751e1eb18a61);

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");
const $663dca38b7cf47cc$export$2e38751e1eb18a61 = ()=>{
    return (0, $2700E.expVal)('work_item_modernization', 'isEnabled', false) || (0, $i860n.fg)('enable_work_item_for_quadratic_release');
};

});

parcelRegister("adMfn", function(module, exports) {
$parcel$export(module.exports, "shouldShowWorkItemView", () => $ba506275f7922f6d$export$304a92341e917fea);

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $f99M0 = parcelRequire("f99M0");

var $jTPDD = parcelRequire("jTPDD");
function $ba506275f7922f6d$export$304a92341e917fea({ cloudId: cloudId, issueKey: issueKey, isIssueViewWivEnabled: isIssueViewWivEnabled, projectType: projectType, isCreatedFromAgenticTemplate: isCreatedFromAgenticTemplate, isAgenticWorkItemViewEnabled: isAgenticWorkItemViewEnabled }) {
    const isModernizationSupportedProject = projectType === (0, $f99M0.SOFTWARE_PROJECT) || projectType === (0, $f99M0.CORE_PROJECT);
    // Allow WIV only if allowed projectType AND userPreference.isIssueViewWivEnabled is true
    if (!isIssueViewWivEnabled || !isModernizationSupportedProject) return false;
    // Incase project is created using quadratic template we should only check quadratic gate and logic and ignore modernization gates and checks
    if (isCreatedFromAgenticTemplate === true) return isAgenticWorkItemViewEnabled === true && (0, $i860n.fg)('enable_work_item_for_quadratic_release');
    return (0, $jTPDD.isWorkItemModernizationAllowedForProject)(cloudId, issueKey) && // eslint-disable-next-line jira/ff/no-work-item-modernization-exp-val
    (0, $2700E.expVal)('work_item_modernization', 'isEnabled', false);
}

});

parcelRegister("ao3nB", function(module, exports) {
$parcel$export(module.exports, "issueViewSwitchDataFetcher", () => $5ba94aa5cc9a2b44$export$d02a58372a86c5fc);

var $KjEkN = parcelRequire("KjEkN");

var $n67Vb = parcelRequire("n67Vb");

var $f99M0 = parcelRequire("f99M0");

var $aI7em = parcelRequire("aI7em");

var $i860n = parcelRequire("i860n");
async function $5ba94aa5cc9a2b44$export$d02a58372a86c5fc(projectIdOrKey, cloudId, issueKey) {
    const safeIssueKey = issueKey ?? '';
    const result = await (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), (0, $KjEkN.default), {
        cloudId: cloudId,
        projectIdOrKey: projectIdOrKey,
        issueKey: safeIssueKey,
        skipIssueByKey: !safeIssueKey,
        includeAgenticWorkItemData: (0, $i860n.fg)('enable_work_item_for_quadratic_release')
    }, {
        fetchPolicy: 'network-only'
    }).toPromise();
    // Prefer the project resolved from the issue because the project key in the URL may be stale
    // after a project move or rename. If the issue cannot be resolved, fall back to the project
    // lookup so Work Item View eligibility can still be evaluated.
    const projectTypeFromQuery = issueKey && result?.jira?.issueByKey?.project?.projectType !== undefined ? result?.jira?.issueByKey?.project?.projectType : result?.jira_projectByIdOrKey?.projectType;
    const isCreatedFromAgenticTemplateFromQuery = issueKey && result?.jira?.issueByKey?.project?.isCreatedFromAgenticTemplate !== undefined ? result?.jira?.issueByKey?.project?.isCreatedFromAgenticTemplate : result?.jira_projectByIdOrKey?.isCreatedFromAgenticTemplate;
    const isAgenticWorkItemViewEnabledFromQuery = issueKey && result?.jira?.issueByKey?.project?.isAgenticWorkItemViewEnabled !== undefined ? result?.jira?.issueByKey?.project?.isAgenticWorkItemViewEnabled : result?.jira_projectByIdOrKey?.isAgenticWorkItemViewEnabled;
    const issueViewSwitchData = {
        projectType: projectTypeFromQuery ? (0, $f99M0.convertToProjectType)(projectTypeFromQuery) : undefined,
        userPreference: result?.jira?.userPreferences?.isIssueViewWivEnabled ?? true,
        isCreatedFromAgenticTemplate: isCreatedFromAgenticTemplateFromQuery ?? null,
        isAgenticWorkItemViewEnabled: isAgenticWorkItemViewEnabledFromQuery ?? null
    };
    return result?.jira?.issueByKey?.key ? {
        ...issueViewSwitchData,
        issueKey: result.jira.issueByKey.key
    } : issueViewSwitchData;
}

});
parcelRegister("KjEkN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c01085893f923d36$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ed0dbf6384ab6a6bcfd50bc58bb4adbd>>
 * @relayHash d39e5b031406032a7dff6b1b644540dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 785e4a57d525e0253c7efa9ebd6c8bf9033bc904c857b792c83dd3959efef986
const $c01085893f923d36$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeAgenticWorkItemData"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipIssueByKey"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = [
        v5 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v8 = {
        "condition": "includeAgenticWorkItemData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCreatedFromAgenticTemplate"
            },
            {
                "kind": "ScalarField",
                "name": "isAgenticWorkItemViewEnabled"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v10 = {
        "args": [
            v5 /*: any*/ 
        ],
        "concreteType": "JiraUserPreferences",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isIssueViewWivEnabled"
            }
        ]
    }, v11 = [
        v5 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueViewSwitchDataFetcherQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "condition": "skipIssueByKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": v9 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueViewSwitchDataFetcherQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "condition": "skipIssueByKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": v14 /*: any*/ 
                                        },
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "785e4a57d525e0253c7efa9ebd6c8bf9033bc904c857b792c83dd3959efef986",
            "metadata": {},
            "name": "issueViewSwitchDataFetcherQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c01085893f923d36$var$node.hash = "d4e8c877cca03fe9e6778ccbe3afb93a";
var $c01085893f923d36$export$2e2bcd8739ae039 = $c01085893f923d36$var$node;

});




parcelRegister("iMUwg", function(module, exports) {
$parcel$export(module.exports, "browseIssueRouteEntry", () => $f374b6ea3eaa2089$export$cef770e7c16cfcc);

var $8k8Iy = parcelRequire("8k8Iy");

var $5TtQq = parcelRequire("5TtQq");

var $hi6Of = parcelRequire("hi6Of");

var $jM84B = parcelRequire("jM84B");

var $jFwZ0 = parcelRequire("jFwZ0");

var $ed8N8 = parcelRequire("ed8N8");

var $6jRoa = parcelRequire("6jRoa");



var $cEVzH = parcelRequire("cEVzH");

var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $8nusn = parcelRequire("8nusn");

var $8ycTI = parcelRequire("8ycTI");

var $6RSCO = parcelRequire("6RSCO");

var $21fL1 = parcelRequire("21fL1");

var $bLDht = parcelRequire("bLDht");


var $lCetP = parcelRequire("lCetP");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $jEYuY = parcelRequire("jEYuY");


var $3HYSN = parcelRequire("3HYSN");

var $i860n = parcelRequire("i860n");

var $dvtoW = parcelRequire("dvtoW");

var $iYidr = parcelRequire("iYidr");

var $idDnR = parcelRequire("idDnR");

var $862Zj = parcelRequire("862Zj");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $fBZs7 = parcelRequire("fBZs7");

var $lTgGU = parcelRequire("lTgGU");

var $dUAVJ = parcelRequire("dUAVJ");

var $hVfQ3 = parcelRequire("hVfQ3");

var $edf7u = parcelRequire("edf7u");

var $cpnl1 = parcelRequire("cpnl1");

var $gZWlI = parcelRequire("gZWlI");

var $9MeJD = parcelRequire("9MeJD");

var $kkjS7 = parcelRequire("kkjS7");

var $9KYmb = parcelRequire("9KYmb");

var $8HUuJ = parcelRequire("8HUuJ");

var $9dMXV = parcelRequire("9dMXV");

var $U9h5y = parcelRequire("U9h5y");

var $9BxTS = parcelRequire("9BxTS");

var $d1wnP = parcelRequire("d1wnP");

var $dTa0V = parcelRequire("dTa0V");

var $53xPq = parcelRequire("53xPq");

var $io0d5 = parcelRequire("io0d5");

var $3e0pb = parcelRequire("3e0pb");

var $kI2ll = parcelRequire("kI2ll");

var $2pLyE = parcelRequire("2pLyE");

var $ldGfw = parcelRequire("ldGfw");

var $eDEQ5 = parcelRequire("eDEQ5");

var $2700E = parcelRequire("2700E");

var $iYYeq = parcelRequire("iYYeq");

var $8AO0r = parcelRequire("8AO0r");

var $gFj7m = parcelRequire("gFj7m");

var $lqVFL = parcelRequire("lqVFL");

var $iyqMX = parcelRequire("iyqMX");
const $f374b6ea3eaa2089$var$getIssueViewReportingMeta = ()=>{
    return {
        reporting: {
            id: 'routeApp.issue',
            packageName: 'jiraSpa',
            teamName: 'bento',
            // When the gate is on, the platform route error boundary sends the
            // standardized `viewIssue` experience event itself and ignores the custom
            // `onError` below. When off, `experienceName` is undefined and the custom
            // `onError` handler runs as before.
            ...(0, $i860n.fg)('jira_route_error_boundary_experience_event') && {
                experienceName: 'viewIssue'
            },
            onError: (location, error)=>{
                if ((0, $i860n.fg)('bento_suppress_bot_web_crawler')) {
                    if ((0, $lCetP.isWebCrawlerUserAgentWithAppleBot)()) return;
                }
                const errorStack = (0, $i860n.fg)('bento-1705-add-stack-trace') ? (0, $8AO0r.truncateStackTrace)(error?.stack) : undefined;
                const userAgent = (0, $i860n.fg)('bento_suppress_bot_web_crawler') ? globalThis.navigator?.userAgent ?? 'unknown' : undefined;
                const isWebDriver = (0, $i860n.fg)('bento_suppress_bot_web_crawler') ? globalThis.navigator?.webdriver : undefined;
                if ((0, $i860n.fg)('issue_view_ignore_client_error_in_analytics')) {
                    // Network errors (e.g. connection drops during SPA transitions) are not attributable to the product
                    // We want to ignore these errors and not count them towards the SLO
                    if (error && (0, $lCetP.isClientFetchError)(error)) return;
                    const isAbortable = error && (0, $lCetP.isHttpClientErrorResponse)(error);
                    (0, $iYYeq.default)({
                        experience: 'viewIssue',
                        analyticsSource: 'issueViewRoute',
                        action: isAbortable ? (0, $a196702bd494009a$export$aeeb00d0845d24d8) : (0, $a196702bd494009a$export$b48b3d1872522384),
                        wasExperienceSuccesful: false,
                        application: null,
                        edition: null,
                        additionalAttributes: {
                            errorMessage: error?.message ?? 'Unknown error',
                            location: location,
                            ...(0, $i860n.fg)('bento-1705-add-stack-trace') && {
                                errorStack: errorStack
                            },
                            ...userAgent !== undefined && {
                                userAgent: userAgent
                            },
                            ...isWebDriver !== undefined && {
                                isWebDriver: isWebDriver
                            }
                        }
                    });
                } else (0, $iYYeq.default)({
                    experience: 'viewIssue',
                    analyticsSource: 'issueViewRoute',
                    action: (0, $a196702bd494009a$export$b48b3d1872522384),
                    wasExperienceSuccesful: false,
                    application: null,
                    edition: null,
                    additionalAttributes: {
                        errorMessage: error?.message ?? 'Unknown error',
                        location: location,
                        ...(0, $i860n.fg)('bento-1705-add-stack-trace') && {
                            errorStack: errorStack
                        },
                        ...userAgent !== undefined && {
                            userAgent: userAgent
                        },
                        ...isWebDriver !== undefined && {
                            isWebDriver: isWebDriver
                        }
                    }
                });
            }
        }
    };
};
// These resources have been re-ordered. We have a theory that moving the more expensive ones to be first in the list makes them faster in SSR, there some small overhead that compounds over the 30 odd requests that happens.
// Longest poles at the moment are issueViewRelayResource and issueGiraDataResource, so we have moved them to the top of the list.
const $f374b6ea3eaa2089$var$resources = ()=>[
        (0, $fBZs7.issueViewRelayResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('dfo_issue_view_remote_data_srr_group'), (0, $3e0pb.issueViewRemoteDataResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('remove-issueviewinteractivequery-m4'), (0, $lTgGU.issueGiraDataResource)),
        ...(0, $ldGfw.getIssueViewResources)(),
        ...(0, $dUAVJ.getNavigationResources)({
            isUsingSidebarEntrypoint: (0, $i860n.fg)('move-issue-view-to-entrypoint')
        }),
        (0, $edf7u.projectContextResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jira-issue-view-contour-theme-enabled'), (0, $gZWlI.projectThemeResource)),
        (0, $862Zj.staticSidebarShortcutsResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        ...(0, $hVfQ3.getOfferingCatalogueFeaturesResource)(),
        (0, $cpnl1.queuesNavigationItems),
        (0, $8ycTI.workspaceResource),
        (0, $6RSCO.getConsolidationStateResource)(),
        ...(0, $Jz4MJ.getAIContextPanelResources)(),
        ...(0, $ghc7e.getResolutionPlanSSRResource)(),
        ...(0, $9KYmb.getDraftReplyPillsResource)(),
        (0, $9dMXV.projectGlobalComponentsResource),
        (0, $U9h5y.getJsmIssueViewSlaPanelResource)(),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_flash_ssr_major_incident_management_fields'), (0, $d1wnP.jsmMIMEntitlementResource)),
        (0, $U9h5y.getJsmIssueViewRelatedArticlesRouteResource)(),
        (0, $U9h5y.getJsmIssueViewPanelMetadataResource)(),
        (0, $2pLyE.issueSelectedTabDataResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $53xPq.issueCollapsibleGroupDataResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jpx-833-smart-links-graphql-provider'), (0, $io0d5.issueDescriptionSmartlinkDataResource)),
        (0, $9MeJD.jsmProjectMenuContentSidebarResource),
        (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('dfo_issue_view_remote_data_srr_group'), (0, $3e0pb.issueViewRemoteDataResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $2700E.expVal)('attachments-1p-consolidation-experiment', 'isExperimentEnabled', false), (0, $kI2ll.issueViewResourcesDataResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jira-issue-view-3p-attachments'), (0, $8k8Iy.thirdPartyConnectedDataSourceResource)),
        (0, $jFwZ0.currentUserResource),
        ...(0, $U9h5y.getJSDSharedNavigationResources)(),
        (0, $6jRoa.loomPermissionResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('fg-perf-issue-view-confluence-menu-optimisation'), (0, $cEVzH.confluenceUserPermissionsResource)),
        (0, $8HUuJ.resourceWithCondition)((0, $21fL1.isJsmChatOpsEntitlementResourceEnabled), (0, $bLDht.jsmChatOpsEntitlementResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ssr_servicedesk_context_'), (0, $iyqMX.serviceDeskContextResource))
    ];
const $f374b6ea3eaa2089$var$entrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8nusn.issueViewEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $f374b6ea3eaa2089$var$GSNEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8nusn.issueViewEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
/*
 * We inline the early script in the payload even though most of the time it is not used.
 * this function will ensure we only inline the script when it actually does something.
 */ function $f374b6ea3eaa2089$var$getEarlyEntry() {
    // ensure code is removed from client-side bundle
    if (false) {
        const circuitBreakerConfig = (0, $5TtQq.getIssueCircuitBreaker)();
        const shouldFetchWhenSSREnabled = (0, $ed8N8.isCircuitOpen)(circuitBreakerConfig) && circuitBreakerConfig?.isCircuitBreakerEnabled;
        if (!shouldFetchWhenSSREnabled) return [
            'parse-gates-early-entry'
        ];
        return [
            'issue-app-early-entry'
        ];
    }
    return [
        'issue-app-early-entry'
    ];
}
const $f374b6ea3eaa2089$export$cef770e7c16cfcc = (0, $fdS54.createEntry)((0, $kkjS7.browseIssueRoute), ()=>({
        isStrictModeEnabled: (0, $i860n.fg)('kenji-jira-incremental-strict-mode'),
        group: 'issue',
        isHydrateRootEnabled: (projectType)=>{
            switch(projectType){
                case 'service_desk':
                case 'customer_service':
                    return (0, $i860n.fg)('jfp-magma-issue-view-full-page-hydrate-root-jsm');
                default:
                    return true;
            }
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-iv'),
        preloadOptions: {
            earlyChunks: $f374b6ea3eaa2089$var$getEarlyEntry()
        },
        analyticsOptions: {
            // CMON-3192 [POC]: emit a SignalFx counter at SSR time for the viewIssue
            // experience. This lets CMON detect "blind spot" failures (DB down, gateway
            // crash, SPA bootstrap failure) where no taskSuccess/taskFail is fired client-side.
            // Gate: jfp-cmon-task-start-issue-view controls emission at call site (multi-spa-route.tsx).
            taskStart: {
                experience: 'viewIssue'
            }
        },
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('move-issue-view-to-entrypoint') ? undefined : (0, $lqVFL.IssueComponent),
        skeleton: (0, $jM84B.IssueViewSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.fullPageIssuePreloadLayout)),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $i860n.fg)('move-issue-view-to-entrypoint') ? (0, $6cc4c278d90305fc$export$373854fe102ad77c) : undefined
        },
        resources: $f374b6ea3eaa2089$var$resources(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lqVFL.LazyIssuePage)
        ],
        ufoName: 'issue-view',
        fallbackExperience: 'viewIssue',
        meta: {
            capability: (0, $0ce01f968965dadd$export$ef94a84e2990361c),
            ...$f374b6ea3eaa2089$var$getIssueViewReportingMeta()
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            manifestName: 'jira-spa-issue-view.json',
            circuitBreakerConfig: (0, $5TtQq.getIssueCircuitBreaker)(),
            redirects: [
                {
                    key: 'issue-project-context-redirect',
                    handler: (0, $gFj7m.bifrostBrowseRouteRedirectionHandler),
                    timeoutMs: 1000
                }
            ]
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'contoured',
        entryPoint: (0, $i860n.fg)('move-issue-view-to-entrypoint') ? ()=>{
            return (0, $i860n.fg)('navx-global-side-nav') ? $f374b6ea3eaa2089$var$GSNEntrypoint : $f374b6ea3eaa2089$var$entrypoint;
        } : undefined,
        entryPointOptions: (0, $i860n.fg)('jfp-magma-concurrent-entrypoint-router-metric-fix') ? {
            isSSRPlaceholderEnabled: true
        } : undefined,
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("5TtQq", function(module, exports) {
$parcel$export(module.exports, "getIssueCircuitBreaker", () => $9c6f4b8aaf853510$export$96348e7c42d52e4a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $k11SN = parcelRequire("k11SN");
function $9c6f4b8aaf853510$export$96348e7c42d52e4a() {
    return {
        isSetCookieEnabled: true,
        isMonitoringEnabled: true,
        isCircuitBreakerEnabled: !(0, $k11SN.default)('issue-view-cookie-cb'),
        cookieKey: 'iss',
        windowSize: 5,
        threshold: 0.7,
        keepOpenCount: 50,
        halfOpenForCount: 5
    };
}

});

const $6cc4c278d90305fc$export$373854fe102ad77c = 'CONTENT';

parcelRegister("8nusn", function(module, exports) {
$parcel$export(module.exports, "issueViewEntryPoint", () => $51fa7c4260651575$export$c9f081604fc01386);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $51fa7c4260651575$export$c9f081604fc01386 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("9yAxP")), {
        moduleId: "751e3c36",
        moduleName: "IssueViewWithRedirect",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});

/* eslint-disable jira/filename-case */ const $a196702bd494009a$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $a196702bd494009a$export$b48b3d1872522384 = 'taskFail';
const $a196702bd494009a$export$aeeb00d0845d24d8 = 'taskAbort';

parcelRegister("iHNG5", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarContentCoreEntryPoint", () => $659524c497ddb084$export$c5a39ebd1638fa7);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $i0CFV = parcelRequire("i0CFV");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $7Cxzw = parcelRequire("7Cxzw");

var $hoEFU = parcelRequire("hoEFU");

const $659524c497ddb084$export$c5a39ebd1638fa7 = (0, $fiVog.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7Z1Im")), {
        moduleId: "42c4af04",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps (params) {
        const { context: context, tenantContext: tenantContext, entryPoints: entryPoints = {}, isAppsExpanded: isAppsExpanded, isFiltersExpanded: isFiltersExpanded, isPlansExpanded: isPlansExpanded, isProjectsExpanded: isProjectsExpanded, isOperationsExpanded: isOperationsExpanded } = params;
        // The two parameters have been injected by the theme setter, and should
        // not be here. Setting them naively just to be able to use the sidebar entryPoint again.
        const projectAri = '';
        let projectKey = '';
        if (context.match.params?.projectKey) projectKey = context.match.params.projectKey;
        else if (context.match.params?.issueKey && (0, $i860n.fg)('move-issue-view-to-entrypoint')) projectKey = (0, $i0CFV.getProjectKey)(context.match, context.query);
        // Preload the productionisation child entrypoint for authed users in the
        // test cohort. Read the experiment via `UNSAFE_noExposureExp` so control
        // (`isEnabled: false`) skips the extra entrypoint WITHOUT firing an
        // exposure here — the exposure fires in
        // `GlobalShortcutsWithInvitedAppRecommendations.tsx` once recs render.
        const mergedEntryPoints = // eslint-disable-next-line jira/ff/no-preconditioning -- kill-switch gate + cohort read
        !tenantContext.isAnonymous && (0, $i860n.fg)('twcg-460-preload-grs-invited-app-shortcuts-gate') && (0, $2700E.UNSAFE_noExposureExp)('twcg-460-preload-grs-invited-app-shortcuts')[0].get('isEnabled', false) ? {
            ...entryPoints,
            invitedAppShortcutsRecommendations: {
                entryPoint: (0, $hoEFU.invitedAppShortcutsRecommendationsEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId
                }
            }
        } : entryPoints;
        return {
            // Queries your async component uses
            queries: {
                nav4SidebarContentCore: {
                    // generated .graphql
                    parameters: (0, $7Cxzw.default),
                    // variables for your query
                    variables: {
                        cloudId: tenantContext.cloudId,
                        isAppsExpanded: isAppsExpanded,
                        isFiltersExpanded: isFiltersExpanded,
                        isPlansExpanded: isPlansExpanded,
                        isProjectsExpanded: isProjectsExpanded,
                        isOperationsExpanded: isOperationsExpanded,
                        projectAri: projectAri,
                        projectKey: projectKey,
                        entityAriPlans: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/plans`,
                        entityAriFilters: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/filters`,
                        entityAriApps: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/apps`,
                        ...(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe') ? {
                            entityAriRoadmaps: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/collections`
                        } : {},
                        ownerAri: tenantContext.atlassianAccountId && `ari:cloud:identity::user/${tenantContext.atlassianAccountId}`,
                        isAnonymous: tenantContext.isAnonymous,
                        isRoadmapUpsellEnabled: (0, $i860n.fg)('jpd-roadmaps-in-jira')
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: mergedEntryPoints
        };
    }
});

});
parcelRegister("hoEFU", function(module, exports) {
$parcel$export(module.exports, "invitedAppShortcutsRecommendationsEntryPoint", () => $80d51127bf086bfc$export$a1093f3ba27d8de7);
/**
 * Child entrypoint preloading the Invited App Shortcuts recommendations
 * query alongside the parent legacy-nav entrypoint. Cohort gating
 * (kill-switch + experiment) lives in the parent — `.entrypoint.tsx`
 * files cannot import feature-gate APIs. Mirrors the PUMA-2000 GSN
 * child entrypoint, with its own package-scoped Relay artifact.
 */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $ghUVT = parcelRequire("ghUVT");

const $80d51127bf086bfc$export$a1093f3ba27d8de7 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("aBsib")), {
        moduleId: "9e1b9e68",
        moduleName: "GlobalShortcutsInvitedAppShortcutsRecommendations",
        priority: "userVisible"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                recommendations: {
                    parameters: $ghUVT.default,
                    // `rerank: [{ entityId: 'confluence' }]` biases server-side ranking
                    // toward the cross-product target (Jira -> Confluence). Confluence's
                    // equivalent surface uses `[{ entityId: 'jira' }]`. This is an
                    // intentional deviation from the cross-join-nudges README's
                    // "omit rerank in SSR preloaders" guidance, because Invited App
                    // Shortcuts always wants the SSR-preloaded cache reranked for the
                    // cross-product bias.
                    variables: {
                        tenantId: cloudId,
                        product: 'jira',
                        rerank: [
                            {
                                entityId: 'confluence'
                            }
                        ]
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("ghUVT", function(module, exports) {
$parcel$export(module.exports, "default", () => $caa700a4b95f96ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1e53a0cff2853ca5de395ef335ac72d7>>
 * @relayHash 66f73d5ebed1306e2bd2fb29130811c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7f06827b35e104d4daeefb27eaf2c326312096885074c921ff4fa8a7c9d9674
const $caa700a4b95f96ad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "product"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rerank"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "product",
                    "variableName": "product"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "invitedAppShortcuts"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Variable",
            "name": "rerank",
            "variableName": "rerank"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "reasons"
    }, v7 = {
        "kind": "ScalarField",
        "name": "score"
    }, v8 = {
        "concreteType": "GrowthRecContextResult",
        "kind": "LinkedField",
        "name": "context",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "tenantId"
            },
            {
                "kind": "ScalarField",
                "name": "product"
            },
            {
                "kind": "ScalarField",
                "name": "useCase"
            },
            {
                "kind": "ScalarField",
                "name": "sessionId"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v12 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GlobalShortcutsInvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GlobalShortcutsInvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d7f06827b35e104d4daeefb27eaf2c326312096885074c921ff4fa8a7c9d9674",
            "metadata": {},
            "name": "GlobalShortcutsInvitedAppShortcutsRecommendationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$caa700a4b95f96ad$var$node.hash = "48f3e12a6a63a351b70a433eedd0bf5f";
var $caa700a4b95f96ad$export$2e2bcd8739ae039 = $caa700a4b95f96ad$var$node;

});

parcelRegister("aBsib", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dTSsn").then(()=>parcelRequire('jzevD'));

});


parcelRegister("7Z1Im", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ereWs")
]).then(()=>parcelRequire('36eko'));

});


parcelRegister("dBNbj", function(module, exports) {
$parcel$export(module.exports, "nav4ProjectsContentEntryPoint", () => $7e411bd621490ce6$export$a457f9fdcd1ea5d3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $bYKD2 = parcelRequire("bYKD2");

const $7e411bd621490ce6$export$a457f9fdcd1ea5d3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gdFxb")), {
        moduleId: "d341df68",
        moduleName: "Nav4ProjectsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        return {
            queries: {
                projects: {
                    parameters: $bYKD2.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("bYKD2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b251e0d9621b829$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94ecb992ebfe58a3c522d8cc8f8d5b11>>
 * @relayHash dc3578a23c1b5bb6d3cefebeb5aafb0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eb340f5cfbad6b0dd5b73970c0112ba28f0f028cbc2c8b0f5f51efe0dbf02b5f

var $25bhx = parcelRequire("25bhx");

var $fpAD9 = parcelRequire("fpAD9");

var $fT916 = parcelRequire("fT916");

var $lIGkE = parcelRequire("lIGkE");
const $5b251e0d9621b829$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v11 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v3 /*: any*/ 
                ],
                "type": "Node",
                "abstractKey": "__isNode"
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v14 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v15 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v16 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": "subspaceCount",
                        "kind": "ScalarField",
                        "name": "subspaceCount_cse"
                    }
                ]
            }
        ]
    }, v17 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v17 /*: any*/ 
            }
        ]
    }, v19 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "mostRecent",
                            "plural": false,
                            "selections": v17 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "mostRecentFromHistory",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v18 /*: any*/ ,
                                v19 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "recents",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v19 /*: any*/ 
                            ],
                            "storageKey": "recents(first:20)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "favouriteLimit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recentLimit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayMode"
                        },
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "eb340f5cfbad6b0dd5b73970c0112ba28f0f028cbc2c8b0f5f51efe0dbf02b5f",
            "metadata": {},
            "name": "Nav4ProjectsContentViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $fpAD9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": (0, $25bhx.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $fT916.default)
            }
        }
    };
}();
$5b251e0d9621b829$var$node.hash = "81c030f5ee4efc947c27b112f9d8730c";
(0, $lIGkE.PreloadableQueryRegistry).set($5b251e0d9621b829$var$node.params.id, $5b251e0d9621b829$var$node);
var $5b251e0d9621b829$export$2e2bcd8739ae039 = $5b251e0d9621b829$var$node;

});

parcelRegister("gdFxb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ewkq8")
]).then(()=>parcelRequire('6oIAV'));

});


parcelRegister("iYidr", function(module, exports) {
$parcel$export(module.exports, "fullPageIssuePreloadLayout", () => $e8ffce4b0a57e76c$export$98e337c40eb151da);
$parcel$export(module.exports, "embeddedIssuePreloadLayoutBuilder", () => $e8ffce4b0a57e76c$export$7b113174a456921a);
$parcel$export(module.exports, "pageLoadIssuePreloadLayoutBuilder", () => $e8ffce4b0a57e76c$export$682dcbf7cc80ba11);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");

var $3B1mt = parcelRequire("3B1mt");

var $l8G1z = parcelRequire("l8G1z");

var $f2wVS = parcelRequire("f2wVS");
var $gcMkE = parcelRequire("gcMkE");

var $a0gpR = parcelRequire("a0gpR");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e8ffce4b0a57e76c$var$LazyIssuePage = (0, $l8G1z.lazyAfterPaint)(()=>(0, $3B1mt.markAsBentoBundleReady)((parcelRequire("9yAxP"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/IssueViewWithRedirect.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e8ffce4b0a57e76c$var$AsyncIssueAppComponent = (0, $l8G1z.lazyAfterPaint)(()=>(0, $3B1mt.markAsBentoBundleReady)((parcelRequire("16SfS"))).then((module)=>module.IssueAppWithCriticalQueryPreloader), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/IssueAppEntrypoint.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e8ffce4b0a57e76c$var$IssueModal = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("f4Efe")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/IssueModal.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e8ffce4b0a57e76c$var$IssueModalContents = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("9Uu3C")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/IssueViewWithHooks.tsx"
});
const $e8ffce4b0a57e76c$var$imports = {
    fullPage: ()=>$e8ffce4b0a57e76c$var$LazyIssuePage.preload(),
    embedded: ()=>$e8ffce4b0a57e76c$var$AsyncIssueAppComponent.preload(),
    pageLoad: (viewModeToPreload)=>{
        // issue view that opens as a modal
        if (viewModeToPreload === 'MODAL' || viewModeToPreload === 'DEFAULT') {
            $e8ffce4b0a57e76c$var$IssueModal.preload();
            $e8ffce4b0a57e76c$var$IssueModalContents.preload();
        }
        // issue view that opens as a side panel
        if (viewModeToPreload === 'SIDEBAR') $e8ffce4b0a57e76c$var$AsyncIssueAppComponent.preload();
    }
};

const $e8ffce4b0a57e76c$var$PrefetchCBBResourcesComponent = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("8nu6X")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/GetCBBResources.tsx"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const importSupplier = $e8ffce4b0a57e76c$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $e8ffce4b0a57e76c$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $e8ffce4b0a57e76c$var$useParamsSelector = (0, $f2wVS.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $e8ffce4b0a57e76c$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $e8ffce4b0a57e76c$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, $gcMkE.default)(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) (0, $a0gpR.setServerEvaluatedIssuePreload)(identifier);
            else performance.mark($e8ffce4b0a57e76c$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
$e8ffce4b0a57e76c$var$IssuePreloadComponentBuilder.displayName = "IssuePreloadComponentBuilder";
const $e8ffce4b0a57e76c$var$FullPageIssuePreloadComponent = $e8ffce4b0a57e76c$var$IssuePreloadComponentBuilder('fullPage', $e8ffce4b0a57e76c$var$imports.fullPage);
$e8ffce4b0a57e76c$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $e8ffce4b0a57e76c$export$98e337c40eb151da = (0, $QhQu4.createLayout)({
    globalComponents: [
        $e8ffce4b0a57e76c$var$FullPageIssuePreloadComponent,
        $e8ffce4b0a57e76c$var$PrefetchCBBResourcesComponent
    ]
});
const $e8ffce4b0a57e76c$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $e8ffce4b0a57e76c$var$IssuePreloadComponentBuilder('embedded', $e8ffce4b0a57e76c$var$imports.embedded, preloadContract);
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $QhQu4.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};
const $e8ffce4b0a57e76c$export$682dcbf7cc80ba11 = (preloadContract, viewModeToPreload)=>{
    const PageLoadIssuePreloadComponent = $e8ffce4b0a57e76c$var$IssuePreloadComponentBuilder('pageLoad', ()=>$e8ffce4b0a57e76c$var$imports.pageLoad(viewModeToPreload || 'DEFAULT'), preloadContract);
    PageLoadIssuePreloadComponent.displayName = 'PageLoadIssuePreloadComponent';
    return (0, $QhQu4.createLayout)({
        globalComponents: [
            PageLoadIssuePreloadComponent
        ]
    });
};

});
parcelRegister("a0gpR", function(module, exports) {
$parcel$export(module.exports, "setServerEvaluatedIssuePreload", () => $dd3710920b93f8d4$export$d2077b3b0eac1c19);
/* eslint-disable jira/filename-case */ // We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $dd3710920b93f8d4$var$serverIssuePreloadIdentifier = '';
const $dd3710920b93f8d4$export$d2077b3b0eac1c19 = (identifier)=>{
    $dd3710920b93f8d4$var$serverIssuePreloadIdentifier = identifier;
};
const $dd3710920b93f8d4$export$f55e6973062dc859 = ()=>$dd3710920b93f8d4$var$serverIssuePreloadIdentifier;

});

parcelRegister("16SfS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");





module.exports = Promise.all([
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    (parcelRequire("gZgW8"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            $4cvLQ("fuqPu"),
            $4cvLQ("1aRRK"),
            $4cvLQ("faPKS"),
            $4cvLQ("iZe2c")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("eBepx")
        ]);
    }),
    (parcelRequire("gZgW8"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $4cvLQ("8sGaA"),
            $4cvLQ("1aRRK"),
            $4cvLQ("faPKS"),
            $4cvLQ("iZe2c")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("93aeH")
        ]);
    }),
    $4cvLQ("eAoL3"),
    $4cvLQ("15ZAZ"),
    $4cvLQ("5qC72"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gCScl"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iZe2c"),
    $4cvLQ("33ki2")
]).then(()=>parcelRequire('jvx9J'));

});

parcelRegister("f4Efe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    $4cvLQ("i6jCQ")
]).then(()=>parcelRequire('cfaKp'));

});

parcelRegister("9Uu3C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");




module.exports = Promise.all([
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    (parcelRequire("gZgW8"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            $4cvLQ("fuqPu"),
            $4cvLQ("1aRRK"),
            $4cvLQ("faPKS"),
            $4cvLQ("iZe2c")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("eBepx")
        ]);
    }),
    (parcelRequire("gZgW8"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $4cvLQ("8sGaA"),
            $4cvLQ("1aRRK"),
            $4cvLQ("faPKS"),
            $4cvLQ("iZe2c")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("93aeH")
        ]);
    }),
    $4cvLQ("eAoL3"),
    $4cvLQ("15ZAZ"),
    $4cvLQ("5qC72"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gCScl"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("HWydC")
]).then(()=>parcelRequire('5xvT6'));

});

parcelRegister("8nu6X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8DGJh").then(()=>parcelRequire('jFx1A'));

});


parcelRegister("hVfQ3", function(module, exports) {
$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $783162fcd0d6b93b$export$d08a9fee651d30b2);

var $7edbf = parcelRequire("7edbf");
const $783162fcd0d6b93b$var$RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

const $783162fcd0d6b93b$export$ec991c565cf31550 = (0, $7edbf.createResource)({
    type: $783162fcd0d6b93b$var$RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("56s5F")),
    maxAge: 1800000
});
const $783162fcd0d6b93b$export$d08a9fee651d30b2 = ()=>[];

});
parcelRegister("56s5F", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iHLKb").then(()=>parcelRequire('81re1'));

});


parcelRegister("kkjS7", function(module, exports) {
$parcel$export(module.exports, "browseIssueRoute", () => $ad2473f58774b1eb$export$2c9c7e50a88e588b);
const $ad2473f58774b1eb$export$2c9c7e50a88e588b = {
    name: 'issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ]
};

});

parcelRegister("9BxTS", function(module, exports) {
$parcel$export(module.exports, "nav4JSWProjectEntryPoint", () => $f1c17975c8758c5b$export$b1c3a10bbf92ce74);

var $aJDWs = parcelRequire("aJDWs");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i0CFV = parcelRequire("i0CFV");

var $2NSbF = parcelRequire("2NSbF");

var $6fsuc = parcelRequire("6fsuc");

var $18sMq = parcelRequire("18sMq");

var $lDG1P = parcelRequire("lDG1P");
const $f1c17975c8758c5b$var$NO_OF_BOARDS_TO_FETCH = 25;

const $f1c17975c8758c5b$export$b1c3a10bbf92ce74 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("lGA5q")), {
        moduleId: "be754bb2",
        moduleName: "JswExpandableProjectQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId ?? '';
        const accountId = params.tenantContext?.atlassianAccountId;
        const activationId = params.tenantContext?.activationId ?? '';
        if (!accountId && (0, $i860n.fg)('blu-7744_fix_error_flag_for_anon_user')) return {
            extraProps: {
                cloudId: '',
                entityAri: '',
                ownerAri: ''
            }
        };
        let projectKey = '';
        if (params.context?.match.params?.projectKey) projectKey = params.context.match.params.projectKey;
        else if (params.context?.match.params?.issueKey && (0, $i860n.fg)('move-issue-view-to-entrypoint')) projectKey = (0, $i0CFV.getProjectKey)(params.context.match, params.context.query);
        const entityAri = (0, $i860n.fg)('navx-3660-fix-l2-l3-aris') ? (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            siteId: cloudId,
            settingId: `project-${projectKey.toLowerCase()}-subcontainer`
        }).toString() : (0, $6fsuc.AnyAri).create({
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: projectKey,
            resourceOwner: 'jira'
        }).toString();
        const ownerAri = (0, $2NSbF.IdentityUserAri).create({
            userId: accountId || 'UNKNOWN'
        }).toString();
        // Feature gate variables - original query doesn't have entityAri and ownerAri
        const variables = (0, $2700E.expVal)('navx-1453-jsw-cmp-boards-dnd-2', 'isEnabled', false) || (0, $aJDWs.isProjectsInJiraM2Enabled)() ? {
            cloudId: cloudId,
            projectKey: projectKey,
            noOfBoardsToFetch: $f1c17975c8758c5b$var$NO_OF_BOARDS_TO_FETCH,
            ownerAri: ownerAri,
            entityAri: entityAri,
            skipOrderQuery: false
        } : {
            cloudId: cloudId,
            projectKey: projectKey,
            noOfBoardsToFetch: $f1c17975c8758c5b$var$NO_OF_BOARDS_TO_FETCH,
            ownerAri: '',
            entityAri: '',
            skipOrderQuery: true
        };
        return {
            queries: {
                projects: {
                    parameters: $lDG1P.default,
                    variables: variables
                }
            },
            extraProps: {
                cloudId: cloudId,
                entityAri: entityAri,
                ownerAri: ownerAri
            }
        };
    }
});

});
parcelRegister("lDG1P", function(module, exports) {
$parcel$export(module.exports, "default", () => $42fb6f7576e38680$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d7ebf31c83bc8248a077ced9a12c1c0>>
 * @relayHash 382838e0d9a03f82d53ca3c4ff84f473
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ff172a02eccf823631baeca802bb406c0f5202def8904b3bb358415fd619d79b

var $lIGkE = parcelRequire("lIGkE");
const $42fb6f7576e38680$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipOrderQuery"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
    }, v8 = {
        "kind": "Variable",
        "name": "noOfBoardsToFetch",
        "variableName": "noOfBoardsToFetch"
    }, v9 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v10 = [
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v11 = [
        v7 /*: any*/ ,
        v9 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "noOfBoardsToFetch"
        }
    ], v19 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v17 /*: any*/ 
        ]
    }, v20 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v14 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v22 = [
        v12 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "subspaceId"
        },
        v13 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "subspaceUrl"
        },
        v14 /*: any*/ 
    ], v23 = [
        {
            "concreteType": "SubcontainerEdge_CSE",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v16 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ],
                            "type": "JiraBoard"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v22 /*: any*/ ,
                            "type": "JiraSubspace_CSE"
                        },
                        v17 /*: any*/ 
                    ]
                }
            ]
        }
    ], v24 = [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "menuId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        },
        v12 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "args": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "skipOrderQuery",
                            "variableName": "skipOrderQuery"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "SubContainer"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v8 /*: any*/ 
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "JswBoards"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "boardsOrder",
                            "args": v11 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "JswBoards_navigationCustomisation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v13 /*: any*/ ,
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v16 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v18 /*: any*/ ,
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        v21 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "alias": "subspaces",
                                            "concreteType": "JiraSubspaceConnection_CSE",
                                            "kind": "LinkedField",
                                            "name": "subspaces_cse",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSubspaceEdge_CSE",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSubspace_CSE",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "subcontainersMenu",
                                            "concreteType": "JiraSubcontainersSidebarMenu_CSE",
                                            "kind": "LinkedField",
                                            "name": "subcontainersMenu_cse",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v18 /*: any*/ ,
                                                    "concreteType": "SubcontainerConnection_CSE",
                                                    "kind": "LinkedField",
                                                    "name": "favourites",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                },
                                                {
                                                    "args": v18 /*: any*/ ,
                                                    "concreteType": "SubcontainerConnection_CSE",
                                                    "kind": "LinkedField",
                                                    "name": "recents",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "condition": "skipOrderQuery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "boardsOrder",
                            "args": v11 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ff172a02eccf823631baeca802bb406c0f5202def8904b3bb358415fd619d79b",
            "metadata": {},
            "name": "JswExpandableProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$42fb6f7576e38680$var$node.hash = "8d065c186c9efd7cbdab8b8ad93f7ed4";
(0, $lIGkE.PreloadableQueryRegistry).set($42fb6f7576e38680$var$node.params.id, $42fb6f7576e38680$var$node);
var $42fb6f7576e38680$export$2e2bcd8739ae039 = $42fb6f7576e38680$var$node;

});

parcelRegister("lGA5q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("goYqM").then(()=>parcelRequire('64wwf'));

});


parcelRegister("eDEQ5", function(module, exports) {
$parcel$export(module.exports, "gsnSidebarContentEntryPoint", () => $dc17a036c4e27569$export$1b079f037442b5fd);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $18sMq = parcelRequire("18sMq");

var $2NSbF = parcelRequire("2NSbF");

var $fDVI0 = parcelRequire("fDVI0");

var $bZhC2 = parcelRequire("bZhC2");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $c1zHX = parcelRequire("c1zHX");

var $16K9M = parcelRequire("16K9M");

const $dc17a036c4e27569$export$1b079f037442b5fd = (0, $fiVog.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jzWzB")), {
        moduleId: "b6512151",
        moduleName: "GSNForContentSidebarEntryPoint",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps (params) {
        /**
		 * IMPORTANT: The query variables should be the same as in other queries, in order to avoid multiple
		 *   network requests.
		 */ const { tenantContext: { activationId: activationId, atlassianAccountId: atlassianAccountId, cloudId: cloudId, isAnonymous: isAnonymous }, entryPoints: entryPoints = {}, isAppsExpanded: isAppsExpanded, isFiltersExpanded: isFiltersExpanded, isPlansExpanded: isPlansExpanded, isProjectsExpanded: isProjectsExpanded, isOperationsExpanded: isOperationsExpanded } = params;
        if (isAnonymous) // Suppress all network requests for anonymous users
        return {
            queries: {},
            entryPoints: entryPoints
        };
        // Mount the productionisation child entrypoint alongside this parent's own
        // queries for authed users in the test cohort. Read the experiment via
        // `UNSAFE_noExposureExp` so control (`isEnabled: false`) skips the extra
        // entrypoint WITHOUT firing an exposure here — the exposure fires in
        // `GSNForContentSidebarWithInvitedAppRecommendations.tsx` once recs render.
        const mergedEntryPoints = /* eslint-disable-next-line jira/ff/no-preconditioning */ (0, $i860n.fg)('twcg-460-preload-grs-invited-app-shortcuts-gate') && (0, $2700E.UNSAFE_noExposureExp)('twcg-460-preload-grs-invited-app-shortcuts')[0].get('isEnabled', false) ? {
            ...entryPoints,
            invitedAppShortcutsRecommendations: {
                entryPoint: (0, $16K9M.invitedAppShortcutsRecommendationsEntryPoint),
                entryPointParams: {
                    cloudId: cloudId
                }
            }
        } : entryPoints;
        const entityAriUserSideNavSettings = (0, $fDVI0.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        const navPlatMenuDataEntityAri = (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            siteId: cloudId,
            settingId: 'nav-plat-l1-menu-data'
        }).toString();
        const navPlatSidebarDataEntityAri = (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            siteId: cloudId,
            settingId: 'nav-plat-sidebar-data'
        }).toString();
        function entityAri(scope) {
            return (0, $bZhC2.JiraNavigationSettingsAri).create({
                siteId: cloudId,
                activationId: activationId,
                navigationSettingScope: scope
            }).toString();
        }
        const ownerAri = atlassianAccountId && (0, $2NSbF.IdentityUserAri).create({
            userId: atlassianAccountId
        }).toString();
        return {
            // Queries your async component uses
            queries: {
                gsnSidebarContent: {
                    // generated .graphql
                    parameters: (0, $c1zHX.default),
                    // variables for your query
                    variables: {
                        cloudId: cloudId,
                        entityAriApps: entityAri('apps'),
                        entityAriFilters: entityAri('filters'),
                        entityAriPlans: entityAri('plans'),
                        ...(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe') ? {
                            entityAriRoadmaps: entityAri('collections')
                        } : {},
                        entityAriUserSideNavSettings: entityAriUserSideNavSettings,
                        isAppsExpanded: isAppsExpanded,
                        isFiltersExpanded: isFiltersExpanded,
                        isPlansExpanded: isPlansExpanded,
                        isProjectsExpanded: isProjectsExpanded,
                        isOperationsExpanded: isOperationsExpanded,
                        navPlatMenuDataEntityAri: navPlatMenuDataEntityAri,
                        navPlatSidebarDataEntityAri: navPlatSidebarDataEntityAri,
                        ownerAri: ownerAri,
                        isRoadmapUpsellEnabled: (0, $i860n.fg)('jpd-roadmaps-in-jira'),
                        fetchGlobalShortcutsAvailableProducts: Boolean(cloudId && ownerAri && (0, $i860n.fg)('navx-4515-jira-gsn-gas-ssr'))
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            entryPoints: mergedEntryPoints
        };
    }
});

});
parcelRegister("16K9M", function(module, exports) {
$parcel$export(module.exports, "invitedAppShortcutsRecommendationsEntryPoint", () => $29b763cd0667e74c$export$a1093f3ba27d8de7);
/**
 * Child entrypoint that preloads the Invited App Shortcuts recommendations
 * query alongside the parent `gsnSidebarContentEntryPoint`.
 *
 * The renderer (`./InvitedAppShortcutsRecommendations.tsx`) owns the
 * `graphql` template; this file only wires the entrypoint metadata and
 * preload variables.
 *
 * Cohort gating lives in the PARENT entrypoint
 * (`gsnSidebarContentEntryPoint.entrypoint.tsx`) — `.entrypoint.tsx` files
 * here are restricted from importing `@atlassian/jira-feature-experiments`
 * / `@atlassian/jira-feature-gating`. The parent conditionally includes
 * this child in `mergedEntryPoints` only when both:
 *
 *   - `twcg-460-preload-grs-invited-app-shortcuts-gate`     — kill-switch
 *   - `twcg-460-preload-grs-invited-app-shortcuts`          — experiment cohort
 *
 * If either is off, the child preload never fires and the render-side
 * dispatcher in `GSNForContentSidebarEntryPoint.tsx` falls through to the
 * legacy experiment / control branch.
 */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $lVyTP = parcelRequire("lVyTP");

const $29b763cd0667e74c$export$a1093f3ba27d8de7 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("crW9X")), {
        moduleId: "d74a7b75",
        moduleName: "InvitedAppShortcutsRecommendations",
        priority: "userVisible"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                recommendations: {
                    parameters: $lVyTP.default,
                    variables: {
                        tenantId: cloudId,
                        product: 'jira',
                        rerank: [
                            {
                                entityId: 'confluence'
                            }
                        ]
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("lVyTP", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e8d47460036d2c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc59aee64ab0b634adc502b66d707879>>
 * @relayHash 0fd2a3241ae778871c0d927de9905467
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f80da8e1c2e442a9eacf6e4f94a43f08dc7ca662f8c8ba98511c1d789dc8b94c
const $8e8d47460036d2c9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "product"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rerank"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "product",
                    "variableName": "product"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "invitedAppShortcuts"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Variable",
            "name": "rerank",
            "variableName": "rerank"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "reasons"
    }, v7 = {
        "kind": "ScalarField",
        "name": "score"
    }, v8 = {
        "concreteType": "GrowthRecContextResult",
        "kind": "LinkedField",
        "name": "context",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "tenantId"
            },
            {
                "kind": "ScalarField",
                "name": "product"
            },
            {
                "kind": "ScalarField",
                "name": "useCase"
            },
            {
                "kind": "ScalarField",
                "name": "sessionId"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v12 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f80da8e1c2e442a9eacf6e4f94a43f08dc7ca662f8c8ba98511c1d789dc8b94c",
            "metadata": {},
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8e8d47460036d2c9$var$node.hash = "8b93ffadc588af32bf0b948a61c02a0d";
var $8e8d47460036d2c9$export$2e2bcd8739ae039 = $8e8d47460036d2c9$var$node;

});

parcelRegister("crW9X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9kk7V").then(()=>parcelRequire('bcxnZ'));

});


parcelRegister("jzWzB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("fqmCn")
]).then(()=>parcelRequire('9OIox'));

});


parcelRegister("8AO0r", function(module, exports) {
$parcel$export(module.exports, "truncateStackTrace", () => $119eda47cf0fabc5$export$320e9bc1c3d6f023);
const $119eda47cf0fabc5$var$MAX_STACK_TRACE_LENGTH = 1000;
const $119eda47cf0fabc5$export$320e9bc1c3d6f023 = (stack)=>{
    if (!stack) return undefined;
    if (stack.length <= $119eda47cf0fabc5$var$MAX_STACK_TRACE_LENGTH) return stack;
    return `${stack.substring(0, $119eda47cf0fabc5$var$MAX_STACK_TRACE_LENGTH)}\u{2026}`;
};

});


parcelRegister("hq8Us", function(module, exports) {
$parcel$export(module.exports, "browseProjectRedirectRouteEntry", () => $4a89190cdc47e768$export$f9891419b34ab305);


var $hdZjx = parcelRequire("hdZjx");

var $3lEJh = parcelRequire("3lEJh");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $cpnl1 = parcelRequire("cpnl1");

var $aqJpR = parcelRequire("aqJpR");
const $4a89190cdc47e768$export$f9891419b34ab305 = (0, $fdS54.createEntry)((0, $aqJpR.browseProjectRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3lEJh.RedirectToLastVisitedProjectPage),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cpnl1.queuesNavigationItems),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3lEJh", function(module, exports) {
$parcel$export(module.exports, "RedirectToLastVisitedProjectPage", () => $98a6ef06b014729e$export$86041af020f4c959);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $kPggs = parcelRequire("kPggs");
const $98a6ef06b014729e$export$86041af020f4c959 = ()=>// @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kPggs.default), null);
$98a6ef06b014729e$export$86041af020f4c959.displayName = "RedirectToLastVisitedProjectPage";

});
parcelRegister("kPggs", function(module, exports) {
$parcel$export(module.exports, "default", () => $b424dcaf5f62c111$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $e2Tle = parcelRequire("e2Tle");

var $ihOzM = parcelRequire("ihOzM");
const $b424dcaf5f62c111$var$defaultExport = (0, $e2Tle.withRouter)((0, $ihOzM.default));
var $b424dcaf5f62c111$export$2e2bcd8739ae039 = $b424dcaf5f62c111$var$defaultExport;

});
parcelRegister("ihOzM", function(module, exports) {
$parcel$export(module.exports, "default", () => $e80408c6f5115591$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $cY22M = parcelRequire("cY22M");

var $bS1iz = parcelRequire("bS1iz");

var $2D2gW = parcelRequire("2D2gW");

var $lhWE3 = parcelRequire("lhWE3");

var $7jZTu = parcelRequire("7jZTu");

var $2HuOR = parcelRequire("2HuOR");

var $6CfY5 = parcelRequire("6CfY5");

var $4fhEY = parcelRequire("4fhEY");

var $75sVW = parcelRequire("75sVW");

var $i860n = parcelRequire("i860n");

var $kGxJR = parcelRequire("kGxJR");

var $kDJef = parcelRequire("kDJef");
const $e80408c6f5115591$export$724cf91f0594bb16 = (url)=>{
    if (typeof window !== 'undefined') window.location.replace(url);
};
const $e80408c6f5115591$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
const $e80408c6f5115591$var$allowListedSearchParams = [
    (0, $kGxJR.SEARCH_FILTER),
    (0, $kGxJR.SHOW_PROJECT_BUILDER_FILTER)
];
const $e80408c6f5115591$var$redirectForAnonymousUser = (projectKey, startTime, locationReplace, query)=>{
    const segment = (0, $i860n.fg)('jira_list_nin_merge') ? 'list' : 'issues';
    const preservedParams = new URLSearchParams();
    (0, $kGxJR.PRESERVED_ANONYMOUS_REDIRECT_PARAMS).forEach((key)=>{
        if (query[key]) preservedParams.set(key, String(query[key]));
    });
    preservedParams.set('filter', 'allissues');
    const destination = `/projects/${projectKey}/${segment}/?${preservedParams.toString()}`;
    locationReplace(destination);
    // Log success
    (0, $6CfY5.default).safeInfoWithoutCustomerData((0, $kGxJR.LOG_LOCATION), 'History replace correctly triggered for anonymous user', {
        requestTime: (0, $kDJef.getNow)() - startTime,
        destination: destination
    });
};
const $e80408c6f5115591$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$e80408c6f5115591$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $kGxJR.SEARCH_FILTER))));
const $e80408c6f5115591$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
    const queryKeys = new URLSearchParams(searchQuery).toString();
    return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
};
/**
 * Handles the redirection of users to the most recently accessed project page (functional component version).
 * This function checks for the project key in the URL or route parameters, fetches the required project data,
 * and redirects the user accordingly. It also manages error logging for failed redirections and provides
 * a tailored experience for anonymous users.
 */ const $e80408c6f5115591$var$LastVisitedProjectPageRedirect = (props)=>{
    const { history: history, location: location, query: query, match: { params: params } } = props;
    const performRedirect = (0, $euxye.useCallback)(()=>{
        // First time a project is created
        const { initial: initial } = query;
        // Clear the SSR Ready Mark if present
        (0, $7jZTu.default)((0, $lhWE3.SPA_SSR_RENDERED_MARK));
        const startTime = (0, $kDJef.getNow)();
        const projectKey = // @ts-expect-error - TS2345 - Argument of type 'string | {}' is not assignable to parameter of type 'string'.
        params.projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse((0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(location, 'search', {})).projectKey;
        if (!params.projectKey) (0, $6CfY5.default).safeInfoWithoutCustomerData((0, $kGxJR.LOG_LOCATION), 'queryString', {
            duration: (0, $kDJef.getNow)() - startTime
        });
        if (projectKey) {
            // Ensure project keys are uppercase
            const normalizedProjectKey = projectKey.toUpperCase();
            (0, $4fhEY.default)($e80408c6f5115591$var$buildEndpoint(normalizedProjectKey, !!initial)).then((response)=>{
                const endTime = (0, $kDJef.getNow)();
                let searchQueryParams = '';
                const searchQuery = $e80408c6f5115591$export$c79af62ad7a1fe8a(query);
                const queryInitializer = response.data.url.includes('?') ? '&' : '?';
                searchQueryParams = $e80408c6f5115591$export$283f1587d7a5369f(searchQuery, queryInitializer);
                const destination = response.data.url + searchQueryParams;
                history.replace(destination);
                // Log success
                (0, $6CfY5.default).safeInfoWithoutCustomerData((0, $kGxJR.LOG_LOCATION), 'History replace correctly triggered', {
                    requestTime: endTime - startTime,
                    destination: destination
                });
            }, (error)=>{
                const endTime = (0, $kDJef.getNow)();
                const is404 = (0, $75sVW.isFetchError)(error) && error.statusCode === 404;
                if ((0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $e80408c6f5115591$var$redirectForAnonymousUser(normalizedProjectKey, startTime, $e80408c6f5115591$export$724cf91f0594bb16, query);
                else if (is404) // Redirect back to the home page if project not found
                history.replace('/jira/for-you');
                else // Log failures
                (0, $6CfY5.default).safeErrorWithoutCustomerData((0, $kGxJR.LOG_LOCATION), `Error on request. Request time: ${endTime - startTime}`, error);
            });
        }
    }, [
        history,
        location,
        query,
        params
    ]);
    (0, $euxye.useEffect)(()=>{
        performRedirect();
    }, [
        performRedirect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "last-visited-project-page-redirect"
    });
};
$e80408c6f5115591$var$LastVisitedProjectPageRedirect.displayName = "LastVisitedProjectPageRedirect";
var $e80408c6f5115591$export$2e2bcd8739ae039 = $e80408c6f5115591$var$LastVisitedProjectPageRedirect;

});
parcelRegister("kGxJR", function(module, exports) {
$parcel$export(module.exports, "LOG_LOCATION", () => $6631970dedb328ba$export$25a759e49d5049db);
$parcel$export(module.exports, "SEARCH_FILTER", () => $6631970dedb328ba$export$29d3926e3d72cfb);
$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_FILTER", () => $6631970dedb328ba$export$b3233b76460c1e7c);
$parcel$export(module.exports, "PRESERVED_ANONYMOUS_REDIRECT_PARAMS", () => $6631970dedb328ba$export$d59525cfec8e60ab);
/* eslint-disable jira/filename-case */ const $6631970dedb328ba$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $6631970dedb328ba$export$29d3926e3d72cfb = 'search';
const $6631970dedb328ba$export$b3233b76460c1e7c = 'showProjectBuilder';
const $6631970dedb328ba$export$d59525cfec8e60ab = [
    'atlOrigin'
];

});

parcelRegister("kDJef", function(module, exports) {
$parcel$export(module.exports, "getNow", () => $60d6b4f55cc659b9$export$3991332aae1fc754);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $60d6b4f55cc659b9$export$3991332aae1fc754 = ()=>Date.now();

});




/* eslint-disable jira/filename-case */ /**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $156b0b89ff564e71$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';

parcelRegister("aqJpR", function(module, exports) {
$parcel$export(module.exports, "browseProjectRedirectRoute", () => $7d789cd5275df9ae$export$f9cac37753487f39);
const $7d789cd5275df9ae$export$f9cac37753487f39 = {
    name: 'browse-project-redirect',
    path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
    exact: true
};

});


parcelRegister("bQFcP", function(module, exports) {
$parcel$export(module.exports, "browseStandardFlowsRouteEntry", () => $18ead88424ad5487$export$6a572c5bc9ffe9da);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 


var $1xjK3 = parcelRequire("1xjK3");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $hwLlH = parcelRequire("hwLlH");

var $74h93 = parcelRequire("74h93");

var $5g8Zc = parcelRequire("5g8Zc");

var $dTa0V = parcelRequire("dTa0V");

var $1lV4Z = parcelRequire("1lV4Z");
const $18ead88424ad5487$var$browseStandardFlowsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1xjK3.browseStandardFlowsEntryPoint)
});
const $18ead88424ad5487$export$6a572c5bc9ffe9da = (0, $fdS54.createEntry)((0, $hwLlH.browseStandardFlowsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_sd_virtual_agent') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-virtual-service-agent') : (0, $l1vE2.isFedRamp)()) return undefined;
            return $18ead88424ad5487$var$browseStandardFlowsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1lV4Z.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $5g8Zc.VirtualAgentBrowseStandardFlowsSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1xjK3", function(module, exports) {
$parcel$export(module.exports, "browseStandardFlowsEntryPoint", () => $5b97cbf4ec256266$export$f7de8593c7455f1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $8LSvx = parcelRequire("8LSvx");

const $5b97cbf4ec256266$export$f7de8593c7455f1 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("kW2gt")), {
        moduleId: "25c08dca",
        moduleName: "VirtualAgentBrowseStandardFlows",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $8LSvx.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("8LSvx", function(module, exports) {
$parcel$export(module.exports, "default", () => $078d6f71febcb3c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<46ceb5f27d1864e660d150719bab138d>>
 * @relayHash 9ad98f9c176b1595865f5d74268d43ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c961e67f99fd999108e497a76217794af6274f72495c30bec4764392d3f3a8ff

var $k49ny = parcelRequire("k49ny");
const $078d6f71febcb3c4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c961e67f99fd999108e497a76217794af6274f72495c30bec4764392d3f3a8ff",
        "metadata": {},
        "name": "VirtualAgentBrowseStandardFlowsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
        }
    }
};
var $078d6f71febcb3c4$export$2e2bcd8739ae039 = $078d6f71febcb3c4$var$node;

});

parcelRegister("kW2gt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("GMeDO").then(()=>parcelRequire('lfcW2'));

});


parcelRegister("5g8Zc", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBrowseStandardFlowsSkeleton", () => $7ad7a277f9b7a5d2$export$c2bd83dd149452bd);
/* VirtualAgentBrowseStandardFlowsSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $66Rtr = parcelRequire("66Rtr");
const $7ad7a277f9b7a5d2$var$customCssStyles = null;
const $7ad7a277f9b7a5d2$export$c2bd83dd149452bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66Rtr))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$7ad7a277f9b7a5d2$export$c2bd83dd149452bd.displayName = "VirtualAgentBrowseStandardFlowsSkeleton";

});
parcelRegister("66Rtr", function(module, exports) {
module.exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();

});



parcelRegister("epwzI", function(module, exports) {
$parcel$export(module.exports, "capacityRouteEntry", () => $a45055929248f9a8$export$721be00e430c45e);

var $9dFSU = parcelRequire("9dFSU");

var $550Ku = parcelRequire("550Ku");

var $YHU4a = parcelRequire("YHU4a");


var $co13a = parcelRequire("co13a");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $6pofw = parcelRequire("6pofw");
const $a45055929248f9a8$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $a45055929248f9a8$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9dFSU.capacityEntryPoint)
});
const $a45055929248f9a8$export$721be00e430c45e = (0, $fdS54.createEntry)((0, $550Ku.capacityRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        skeleton: (0, $YHU4a.CapacityPageSkeleton),
        ufoName: 'jsm-capacity',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        resources: [
            (0, $co13a.routingOnboardingFinishedResource),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>{
            if (!$a45055929248f9a8$var$isWorkforceAemEnabled() || !(0, $i860n.fg)('jsm_workforce_optimization_main')) return undefined;
            return $a45055929248f9a8$var$entryPoint;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).AVAILABILITY,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).AVAILABILITY),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("9dFSU", function(module, exports) {
$parcel$export(module.exports, "capacityEntryPoint", () => $b7a87a5ef82b5cc0$export$2ea9514c195131bd);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $cRtOL = parcelRequire("cRtOL");

var $5i9cs = parcelRequire("5i9cs");

const $b7a87a5ef82b5cc0$export$2ea9514c195131bd = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("1TBL5")), {
        moduleId: "259f6837",
        moduleName: "CapacityPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = match.params.projectKey ?? '';
        return {
            queries: {
                capacityHeaderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $cRtOL.default),
                    variables: {
                        input: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                },
                capacityTableQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $5i9cs.default),
                    variables: {
                        input: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        },
                        first: 20,
                        after: null,
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey,
                first: 20
            }
        };
    }
});

});
parcelRegister("cRtOL", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e0c7ba804de672$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa88739130f4138c35a8cbd1dbb396a4>>
 * @relayHash 4c538c694c48bd55cf3ba170f6e7210c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a29cf1d6127965d288b5e91813fb3607ff4f38a6781286ddae1de806a315062
const $68e0c7ba804de672$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2a29cf1d6127965d288b5e91813fb3607ff4f38a6781286ddae1de806a315062",
        "metadata": {},
        "name": "CapacityPageHeaderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $68e0c7ba804de672$export$2e2bcd8739ae039 = $68e0c7ba804de672$var$node;

});

parcelRegister("5i9cs", function(module, exports) {
$parcel$export(module.exports, "default", () => $477c37cd5a0ac64c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e436f5cdf2b7e98d359a17a4a837852a>>
 * @relayHash 70b126ef780eee2b40d7efe1f7039c87
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd7e3ba959f96f612e3e7d7f890f8ff65f6967f2bb210a93c416dfcb5c483cc8
const $477c37cd5a0ac64c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fd7e3ba959f96f612e3e7d7f890f8ff65f6967f2bb210a93c416dfcb5c483cc8",
        "metadata": {},
        "name": "CapacityPageTableQuery",
        "operationKind": "query",
        "text": null
    }
};
var $477c37cd5a0ac64c$export$2e2bcd8739ae039 = $477c37cd5a0ac64c$var$node;

});

parcelRegister("1TBL5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("dpg68")
]).then(()=>parcelRequire('6Nk3Q'));

});


parcelRegister("550Ku", function(module, exports) {
$parcel$export(module.exports, "capacityRoute", () => $b7518fdddd28ccbf$export$6adfb1b9204a23a9);
const $b7518fdddd28ccbf$export$6adfb1b9204a23a9 = {
    name: 'servicedesk-capacity',
    path: '/jira/servicedesk/projects/:projectKey/capacity',
    exact: true
};

});

parcelRegister("YHU4a", function(module, exports) {
$parcel$export(module.exports, "CapacityPageSkeleton", () => $d620aa5ab3595751$export$c5601447c766f640);
/* CapacityPageSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $apUrw = parcelRequire("apUrw");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $axuHi = parcelRequire("axuHi");
const $d620aa5ab3595751$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-capacity.capacity-page-skeleton.loading",
    defaultMessage: "Loading capacity page"
});
const $d620aa5ab3595751$var$styles = {
    container: "_1bsb1osq",
    headerSkeleton: "_otyru2gc",
    breadcrumbSkeleton: "_otyrpxbi",
    cardRow: "_1bsb1osq",
    metricCard: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9uuw1 _4t3iys9h"
};
const $d620aa5ab3595751$export$c5601447c766f640 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        padding: "space.300",
        xcss: $d620aa5ab3595751$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $apUrw.default), null, formatMessage($d620aa5ab3595751$var$loadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $d620aa5ab3595751$var$styles.breadcrumbSkeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "200px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $d620aa5ab3595751$var$styles.headerSkeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "120px",
        height: "32px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "100px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "100px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "160px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "90px",
        height: "32px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.200",
        spread: "space-between",
        xcss: $d620aa5ab3595751$var$styles.cardRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $d620aa5ab3595751$var$styles.metricCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "100%",
        height: "100%",
        borderRadius: "var(--ds-radius-large, 8px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $d620aa5ab3595751$var$styles.metricCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "100%",
        height: "100%",
        borderRadius: "var(--ds-radius-large, 8px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $d620aa5ab3595751$var$styles.metricCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        isShimmering: true,
        width: "100%",
        height: "100%",
        borderRadius: "var(--ds-radius-large, 8px)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $axuHi.CapacityListSkeleton), null)));
};
$d620aa5ab3595751$export$c5601447c766f640.displayName = "CapacityPageSkeleton";

});
parcelRegister("axuHi", function(module, exports) {
$parcel$export(module.exports, "CapacityListSkeleton", () => $ba74e6ad2e9c54f0$export$9c7cb5a8eae16058);
/* CapacityListSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $apUrw = parcelRequire("apUrw");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $ba74e6ad2e9c54f0$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-capacity.capacity-list-skeleton.loading",
    defaultMessage: "Loading capacity data"
});
const $ba74e6ad2e9c54f0$var$styles = {
    contentRow: "_1bsb1osq _4t3ivbgk"
};
const $ba74e6ad2e9c54f0$export$9c7cb5a8eae16058 = ({ rowCount: rowCount = 6 })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.200",
        testId: "capacity.ui.capacity-list.capacity-list-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $apUrw.default), null, formatMessage($ba74e6ad2e9c54f0$var$loadingMessage)), Array.from({
        length: rowCount
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
            key: index,
            xcss: $ba74e6ad2e9c54f0$var$styles.contentRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            isShimmering: true,
            width: "100%",
            height: "100%",
            borderRadius: "var(--ds-radius-large, 8px)"
        }))));
};
$ba74e6ad2e9c54f0$export$9c7cb5a8eae16058.displayName = "CapacityListSkeleton";

});



parcelRegister("lSD2k", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRouteEntry", () => $84aff41dbc31ee50$export$99ff9a6f448db95c);

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $edf7u = parcelRequire("edf7u");

var $bky7X = parcelRequire("bky7X");

var $ixLW7 = parcelRequire("ixLW7");
const $84aff41dbc31ee50$export$99ff9a6f448db95c = (0, $fdS54.createEntry)((0, $bky7X.classicBusinessProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-business',
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $edf7u.projectContextResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ixLW7.default),
        forPaint: [
            (0, $ixLW7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bky7X", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRoute", () => $d3024538f6fb1019$export$92c0120052644a60);
const $d3024538f6fb1019$export$92c0120052644a60 = {
    name: 'classic-business-proforma-issue-forms-direct-embed',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("ixLW7", function(module, exports) {
$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $f81b644107896196$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $f81b644107896196$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f81b644107896196$export$22681210aaeb910f = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("bTGU2")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/ProformaJiraIssueFormsDirectEmbedWrapper.tsx"
});
const $f81b644107896196$var$AsyncProformaIssueFormsDirectEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f81b644107896196$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });
$f81b644107896196$var$AsyncProformaIssueFormsDirectEmbed.displayName = "AsyncProformaIssueFormsDirectEmbed";
var $f81b644107896196$export$2e2bcd8739ae039 = $f81b644107896196$var$AsyncProformaIssueFormsDirectEmbed;

});
parcelRegister("bTGU2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("cKNzE")
]).then(()=>parcelRequire('cXg6g'));

});



parcelRegister("5dv8e", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRouteEntry", () => $7ff6e568538be267$export$8aa48763ac761f64);


var $fU8CV = parcelRequire("fU8CV");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $edf7u = parcelRequire("edf7u");

var $dnJFW = parcelRequire("dnJFW");

var $gXJFZ = parcelRequire("gXJFZ");
const $7ff6e568538be267$export$8aa48763ac761f64 = (0, $fdS54.createEntry)((0, $dnJFW.classicBusinessProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-business',
        layout: (0, $fU8CV.coreProjectLayout),
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $edf7u.projectContextResource)
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        entryPoint: ()=>(0, $gXJFZ.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dnJFW", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRoute", () => $56b26cfb732785fd$export$97a413d49241d03b);
const $56b26cfb732785fd$export$97a413d49241d03b = {
    name: 'classic-business-proforma-issue-forms-direct',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("gXJFZ", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $162007ac53e51a2d$export$dc0bb5719ae7aab4);
/* eslint-disable jira/naming/disallow-filenames */ 
var $gb6l3 = parcelRequire("gb6l3");

var $dTa0V = parcelRequire("dTa0V");
const $162007ac53e51a2d$export$dc0bb5719ae7aab4 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $gb6l3.proformaIssueFormsDirectEntryPoint)
});

});
parcelRegister("gb6l3", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsDirectEntryPoint", () => $245ca8bc1d63aa4a$export$2a51bba458da5928);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $245ca8bc1d63aa4a$export$2a51bba458da5928 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("lPkdj")), {
        moduleId: "4746fc20",
        moduleName: "ProformaJiraIssueFormsDirectWrapper",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lPkdj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("5NDCb")
]).then(()=>parcelRequire('84XkY'));

});




parcelRegister("eEbPJ", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectApprovalsRouteEntry", () => $37a257f0494db9a2$export$563b4fef899fe540);

var $9VGNh = parcelRequire("9VGNh");


var $hdZjx = parcelRequire("hdZjx");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $jfBhA = parcelRequire("jfBhA");
const $37a257f0494db9a2$export$563b4fef899fe540 = (0, $fdS54.createEntry)((0, $9VGNh.classicBusinessProjectApprovalsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.approvals-view',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>(0, $jfBhA.approvalsPageEntryPoint),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9VGNh", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectApprovalsRoute", () => $4df122449a5e9bdf$export$3109a183a442a02d);
const $4df122449a5e9bdf$export$3109a183a442a02d = {
    name: 'classic-business-approvals',
    path: '/jira/core/projects/:projectKey/approvals',
    exact: true
};

});

parcelRegister("4iKrU", function(module, exports) {
$parcel$export(module.exports, "businessProjectLayout", () => $cdf36736115ab961$export$dfb0c3e0348f4429);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $lVzKq = parcelRequire("lVzKq");

var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

var $jepRN = parcelRequire("jepRN");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cdf36736115ab961$var$Onboarding = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("8fJ5x")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-business-project-layout/src/ui/onboarding/index.tsx"
});
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $cdf36736115ab961$var$withAnyBusinessProjectContext = (Component)=>(0, $QhQu4.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $f99M0.CORE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cdf36736115ab961$var$RightSidebars = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("28sMe")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-business-project-layout/src/ui/right-sidebars/index.tsx"
});
const $cdf36736115ab961$var$BusinessOnboarding = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $cdf36736115ab961$var$Onboarding, $cdf36736115ab961$var$withAnyBusinessProjectContext($cdf36736115ab961$var$Onboarding));
$cdf36736115ab961$var$BusinessOnboarding.displayName = 'BusinessOnboarding';
const $cdf36736115ab961$var$nonSettingsRightSidebar = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $cdf36736115ab961$var$RightSidebars, $cdf36736115ab961$var$withAnyBusinessProjectContext($cdf36736115ab961$var$RightSidebars));
$cdf36736115ab961$var$nonSettingsRightSidebar.displayName = 'NonSettingsRightSidebar';
const $cdf36736115ab961$var$sharedBusinessProjectLayout = (0, $QhQu4.composeLayouts)((0, $lVzKq.projectLayout));
const $cdf36736115ab961$export$dfb0c3e0348f4429 = (0, $QhQu4.composeLayouts)($cdf36736115ab961$var$sharedBusinessProjectLayout, {
    rightSidebars: [
        $cdf36736115ab961$var$nonSettingsRightSidebar
    ],
    globalComponents: [
        $cdf36736115ab961$var$BusinessOnboarding
    ]
});

});
parcelRegister("8fJ5x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7Wqsz").then(()=>parcelRequire('lndJS'));

});

parcelRegister("28sMe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b0Dl1").then(()=>parcelRequire('h5yWY'));

});


parcelRegister("9EWfZ", function(module, exports) {
$parcel$export(module.exports, "ThemedLazySkeleton", () => $4e69e5110b44282e$export$ddeb5d943c4f17e3);
/* ThemedLazySkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2D2gW = parcelRequire("2D2gW");

var $kPdWO = parcelRequire("kPdWO");
const $4e69e5110b44282e$export$ddeb5d943c4f17e3 = /*#__PURE__*/ (0, $euxye.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4e69e5110b44282e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "themed-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kPdWO.ThemedSpinner), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e69e5110b44282e$var$Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kPdWO", function(module, exports) {
$parcel$export(module.exports, "ThemedSpinner", () => $ec9a7caba1ef6495$export$271c7b154ad6c401);
/* ThemedSpinner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $abhF2 = parcelRequire("abhF2");
const $ec9a7caba1ef6495$export$271c7b154ad6c401 = /*#__PURE__*/ (0, $euxye.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ec9a7caba1ef6495$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: "large",
        ...props,
        testId: "project-theme-components.ui.themed-spinner"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec9a7caba1ef6495$var$Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1xjgvy9e",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jfBhA", function(module, exports) {
$parcel$export(module.exports, "approvalsPageEntryPoint", () => $d1617f1517c93cd5$export$52c40d37705be5fa);
/* eslint-disable jira/naming/disallow-filenames */ 
var $7wUtz = parcelRequire("7wUtz");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $d1617f1517c93cd5$export$52c40d37705be5fa = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7wUtz.approvalsEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7wUtz", function(module, exports) {
$parcel$export(module.exports, "approvalsEntryPoint", () => $480ccb525653fca9$export$25d4a03de93a440e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $8cAdB = parcelRequire("8cAdB");

const $480ccb525653fca9$export$25d4a03de93a440e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("eGHTW")), {
        moduleId: "62270bdf",
        moduleName: "JiraBusinessApprovalsAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $8cAdB.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("8cAdB", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a2bbb5a381e590b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<652e25417edeeb347d61066d58821dad>>
 * @relayHash b4191b2266bb7ed6d095f2ada68fce54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 650b20eeee7be0757386b58e521734bdcf57b15a5601f0010de24eec444f16e3
const $4a2bbb5a381e590b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "650b20eeee7be0757386b58e521734bdcf57b15a5601f0010de24eec444f16e3",
        "metadata": {},
        "name": "JiraBusinessApprovalsAppMemoQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4a2bbb5a381e590b$export$2e2bcd8739ae039 = $4a2bbb5a381e590b$var$node;

});

parcelRegister("eGHTW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jUadY")
]).then(()=>parcelRequire('1EL0P'));

});




parcelRegister("pX0Lb", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormBuilderRouteEntry", () => $ddb4789916c01880$export$9eb15893d080e73b);

var $21WM4 = parcelRequire("21WM4");


var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $277IK = parcelRequire("277IK");
const $ddb4789916c01880$export$9eb15893d080e73b = (0, $fdS54.createEntry)((0, $21WM4.classicBusinessProjectFormBuilderRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-view',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>(0, $277IK.formBuilderPageEntrypoint),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("21WM4", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormBuilderRoute", () => $8f5ba8a0f58ffa54$export$5f684808e671de5);
const $8f5ba8a0f58ffa54$export$5f684808e671de5 = {
    name: 'classic-business-form-builder',
    path: '/jira/core/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("277IK", function(module, exports) {
$parcel$export(module.exports, "formBuilderPageEntrypoint", () => $c557191c0becb77d$export$e0f4bcb9440be5eb);
/* eslint-disable jira/naming/disallow-filenames */ 
var $ccbxr = parcelRequire("ccbxr");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $c557191c0becb77d$export$e0f4bcb9440be5eb = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ccbxr.formBuilderEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("ccbxr", function(module, exports) {
$parcel$export(module.exports, "formBuilderEntrypoint", () => $0246f6124b1a64f6$export$6d3c9fa7232f412c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $357yI = parcelRequire("357yI");

const $0246f6124b1a64f6$export$6d3c9fa7232f412c = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("i2Zlk")), {
        moduleId: "47143700",
        moduleName: "JiraBusinessFormBuilderAppMemo",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $357yI.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("357yI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b7136569ee7cd0b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6236d56145c782615f95d6959701cb81>>
 * @relayHash 04fbf168a3262118564152ceaac9cf66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccbfdc2000afcf6f467604bb74274135ff5abce33df5678e3a06479f30fdf193
const $8b7136569ee7cd0b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ccbfdc2000afcf6f467604bb74274135ff5abce33df5678e3a06479f30fdf193",
        "metadata": {},
        "name": "JiraBusinessFormBuilderAppMemoQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8b7136569ee7cd0b$export$2e2bcd8739ae039 = $8b7136569ee7cd0b$var$node;

});

parcelRegister("i2Zlk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("1YaGs")
]).then(()=>parcelRequire('dq956'));

});




parcelRegister("7YisL", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormRouteEntry", () => $951a9f4c0777673c$export$4798edf139084d2e);

var $c4FDg = parcelRequire("c4FDg");


var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $kjLeb = parcelRequire("kjLeb");
const $951a9f4c0777673c$export$4798edf139084d2e = (0, $fdS54.createEntry)((0, $c4FDg.classicBusinessProjectFormRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-directory-view',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>(0, $kjLeb.formPageEntrypoint),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'contoured',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c4FDg", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormRoute", () => $5ba91893decb52dd$export$e98776bdf96c88ac);
const $5ba91893decb52dd$export$e98776bdf96c88ac = {
    name: 'classic-business-form',
    path: '/jira/core/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("kjLeb", function(module, exports) {
$parcel$export(module.exports, "formPageEntrypoint", () => $0d413422b8b4643f$export$ebaf30a031a61671);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $642bC = parcelRequire("642bC");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $0d413422b8b4643f$export$ebaf30a031a61671 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $642bC.formEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("642bC", function(module, exports) {
$parcel$export(module.exports, "formEntrypoint", () => $d7c61a88d0c1e124$export$b931eb60522f687a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $hQFAR = parcelRequire("hQFAR");

const $d7c61a88d0c1e124$export$b931eb60522f687a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("fGwpQ")), {
        moduleId: "a24bbe8e",
        moduleName: "JiraBusinessFormAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $hQFAR.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("hQFAR", function(module, exports) {
$parcel$export(module.exports, "default", () => $03e13e2e427081fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a1b029fbcf755de86e966161bb716df2>>
 * @relayHash 8159816e590e8998e27034f528353acd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea9349f4dca79a4085cba40608561e0bd671e7dfef19561fdd213fe12fe2921a
const $03e13e2e427081fb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ea9349f4dca79a4085cba40608561e0bd671e7dfef19561fdd213fe12fe2921a",
        "metadata": {},
        "name": "JiraBusinessFormAppMemoQuery",
        "operationKind": "query",
        "text": null
    }
};
var $03e13e2e427081fb$export$2e2bcd8739ae039 = $03e13e2e427081fb$var$node;

});

parcelRegister("fGwpQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i6lKh").then(()=>parcelRequire('7tvAA'));

});




parcelRegister("l5plY", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRouteEntry", () => $b545d0688c4359e3$export$c2f698be6eedea1a);

var $dC061 = parcelRequire("dC061");

var $hdZjx = parcelRequire("hdZjx");

var $byMD7 = parcelRequire("byMD7");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $hajNq = parcelRequire("hajNq");
const $b545d0688c4359e3$export$c2f698be6eedea1a = (0, $fdS54.createEntry)((0, $dC061.classicBusinessProjectFormSubmitEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-embed-view',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>(0, $hajNq.formSubmitEmbedPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dC061", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRoute", () => $8a7078f04481244d$export$7e8fd15fdfa29385);
const $8a7078f04481244d$export$7e8fd15fdfa29385 = {
    name: 'classic-business-form-submit-embed',
    path: '/jira/core/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("hajNq", function(module, exports) {
$parcel$export(module.exports, "formSubmitEmbedPageEntrypoint", () => $8c455d5591891988$export$93f08d580854f4a7);
/* eslint-disable jira/naming/disallow-filenames */ 
var $iu6cR = parcelRequire("iu6cR");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $8c455d5591891988$export$93f08d580854f4a7 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $iu6cR.formSubmitEmbedEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("iu6cR", function(module, exports) {
$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $084a3d8c2563312c$export$4c748d8ca82fc24);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $084a3d8c2563312c$export$4c748d8ca82fc24 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gsjGn")), {
        moduleId: "e0c394a9",
        moduleName: "JiraBusinessFormEmbedAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gsjGn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4Yrkx")
]).then(()=>parcelRequire('jSkcc'));

});




parcelRegister("hz0Io", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRouteEntry", () => $d3a4d8f842548c5d$export$69d2365670c516de);
/* eslint-disable import/order */ 
var $bMVS6 = parcelRequire("bMVS6");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $bUOmx = parcelRequire("bUOmx");
const $d3a4d8f842548c5d$export$69d2365670c516de = (0, $fdS54.createEntry)((0, $bMVS6.classicBusinessProjectFormSubmitPublicRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-public-view',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        // This public route should not include
        // DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
        // remove all usages of projectKey.
        entryPoint: ()=>(0, $bUOmx.formSubmitPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bMVS6", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRoute", () => $28bd4a31fc6aa149$export$865063615075df54);
const $28bd4a31fc6aa149$export$865063615075df54 = {
    name: 'classic-business-form-submit-public',
    path: '/jira/core/form/:formUuid',
    exact: true
};

});

parcelRegister("bUOmx", function(module, exports) {
$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $fbd3add0bec3156f$export$26755d0805847061);
/* eslint-disable jira/naming/disallow-filenames */ 
var $cNpqr = parcelRequire("cNpqr");

var $dTa0V = parcelRequire("dTa0V");
const $fbd3add0bec3156f$export$26755d0805847061 = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $cNpqr.formSubmitPublicEntrypoint)
});

});
parcelRegister("cNpqr", function(module, exports) {
$parcel$export(module.exports, "formSubmitPublicEntrypoint", () => $3e323e251e405501$export$345530940ab03dbd);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $3e323e251e405501$export$345530940ab03dbd = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("fM9uQ")), {
        moduleId: "b73f7c0f",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fM9uQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("a71zY")
]).then(()=>parcelRequire('lAv1G'));

});




parcelRegister("jKGqh", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitRouteEntry", () => $62607585c39a61d3$export$bd59a50eb595d1d5);

var $dVqi4 = parcelRequire("dVqi4");


var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $7mmUn = parcelRequire("7mmUn");
const $62607585c39a61d3$export$bd59a50eb595d1d5 = (0, $fdS54.createEntry)((0, $dVqi4.classicBusinessProjectFormSubmitRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-view',
        layout: (0, $byMD7.chromelessLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>(0, $7mmUn.formSubmitPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dVqi4", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitRoute", () => $e48d59b923415c0f$export$3cd93ff55b29f07f);
const $e48d59b923415c0f$export$3cd93ff55b29f07f = {
    name: 'classic-business-form-submit',
    path: '/jira/core/projects/:projectKey/form/:formId',
    exact: true
};

});

parcelRegister("7mmUn", function(module, exports) {
$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $f9c983354108c4c3$export$26755d0805847061);
/* eslint-disable jira/naming/disallow-filenames */ 
var $dtEeb = parcelRequire("dtEeb");

var $dTa0V = parcelRequire("dTa0V");
const $f9c983354108c4c3$export$26755d0805847061 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $dtEeb.formSubmitEntrypoint)
});

});
parcelRegister("dtEeb", function(module, exports) {
$parcel$export(module.exports, "formSubmitEntrypoint", () => $93ebc896115803c8$export$d33b8db02e0a0cb5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $93ebc896115803c8$export$d33b8db02e0a0cb5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("4Yrfe")), {
        moduleId: "05ddea52",
        moduleName: "JiraBusinessFormAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4Yrfe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("39vxG")
]).then(()=>parcelRequire('3kUoH'));

});




parcelRegister("lGX8C", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectPagesRouteEntry", () => $0425df1bfadfd73c$export$7a55e12f93813823);

var $lpZbz = parcelRequire("lpZbz");


var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $brZoO = parcelRequire("brZoO");
const $0425df1bfadfd73c$export$7a55e12f93813823 = (0, $fdS54.createEntry)((0, $lpZbz.classicBusinessProjectPagesRoute), ()=>({
        group: 'classic-business',
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        ufoName: 'jwm.jwm-pages',
        entryPoint: ()=>(0, $brZoO.pagesPageEntrypoint),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lpZbz", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectPagesRoute", () => $d7655d6f291e4b5a$export$573cc697c2d33124);
const $d7655d6f291e4b5a$export$573cc697c2d33124 = {
    name: 'project-pages',
    path: '/jira/core/projects/:projectKey/pages'
};

});

parcelRegister("brZoO", function(module, exports) {
$parcel$export(module.exports, "pagesPageEntrypoint", () => $7f3ede5b47325f7d$export$4ce394de88f5b54a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $kedXy = parcelRequire("kedXy");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $7f3ede5b47325f7d$export$4ce394de88f5b54a = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kedXy.pagesEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("kedXy", function(module, exports) {
$parcel$export(module.exports, "pagesEntrypoint", () => $e5e80f7fd16c330e$export$49834d404673808c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $e5e80f7fd16c330e$export$49834d404673808c = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("4odFQ")), {
        moduleId: "b311a216",
        moduleName: "JiraBusinessPagesAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4odFQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("g5oeb")
]).then(()=>parcelRequire('p3sb8'));

});




parcelRegister("9HrlX", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectShortcutRouteEntry", () => $2525d54c9f9f9737$export$22248cc626626132);

var $euxye = parcelRequire("euxye");


var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $aWliK = parcelRequire("aWliK");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $8s6Mh = parcelRequire("8s6Mh");

var $2700E = parcelRequire("2700E");

var $gNbXR = parcelRequire("gNbXR");

var $crvZA = parcelRequire("crvZA");
const $2525d54c9f9f9737$var$classicBusinessProjectShortcutRedirect = ({ match: { params: { projectKey: projectKey } } })=>{
    if (projectKey == null) // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    throw Error('projectKey not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/browse/${String(projectKey)}`
    });
};
const $2525d54c9f9f9737$var$NoopComponent = ()=>null;
const $2525d54c9f9f9737$export$22248cc626626132 = (0, $fdS54.createEntry)((0, $8s6Mh.classicBusinessProjectShortcutRoute), ()=>({
        group: 'classic-business',
        isRedirect: (0, $2700E.expValEquals)('jira_redirect_business_shortcuts_to_project', 'isEnabled', true, false),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $2700E.expValEquals)('jira_redirect_business_shortcuts_to_project', 'isEnabled', true, false), $2525d54c9f9f9737$var$classicBusinessProjectShortcutRedirect, $2525d54c9f9f9737$var$NoopComponent),
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>(0, $2700E.expValEquals)('jira_redirect_business_shortcuts_to_project', 'isEnabled', true, false) ? undefined : (0, $crvZA.shortcutsPageEntrypoint),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8s6Mh", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectShortcutRoute", () => $5cb0562408345b2a$export$2dd4e8a37d8ac978);
const $5cb0562408345b2a$export$2dd4e8a37d8ac978 = {
    name: 'classic-business-shortcut',
    path: '/jira/core/projects/:projectKey/shortcuts',
    exact: true
};

});

parcelRegister("crvZA", function(module, exports) {
$parcel$export(module.exports, "shortcutsPageEntrypoint", () => $12b888fa6fbadd1b$export$57a2f1af23fcbb8b);
/* eslint-disable jira/naming/disallow-filenames */ 
var $fOEmB = parcelRequire("fOEmB");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $12b888fa6fbadd1b$export$57a2f1af23fcbb8b = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fOEmB.shortcutsEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("fOEmB", function(module, exports) {
$parcel$export(module.exports, "shortcutsEntrypoint", () => $5d31c27250ad6f77$export$212fd76838eeb6ad);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $1EKwx = parcelRequire("1EKwx");

const $5d31c27250ad6f77$export$212fd76838eeb6ad = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("01N5u")), {
        moduleId: "0bc92ab8",
        moduleName: "JiraBusinessShortcutsAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                shortcutsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1EKwx.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("1EKwx", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bee6eaf50d9d785$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f8af7dc1a15965afa62be4b1b6e1529>>
 * @relayHash eea67e3828c066fddc0cd6e4d1c0726e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 740aae02886ab44cd9cadad175d955c6d9ee801f157ada455ee22f3fd2c6f510
const $1bee6eaf50d9d785$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "740aae02886ab44cd9cadad175d955c6d9ee801f157ada455ee22f3fd2c6f510",
        "metadata": {},
        "name": "JiraBusinessShortcutsAppMemoQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1bee6eaf50d9d785$export$2e2bcd8739ae039 = $1bee6eaf50d9d785$var$node;

});

parcelRegister("01N5u", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("c5DWF")
]).then(()=>parcelRequire('6Kso5'));

});




parcelRegister("9HdUU", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRouteEntry", () => $4d1570065eefd45b$export$e23e06ae81848c38);

var $BF5pg = parcelRequire("BF5pg");


var $hdZjx = parcelRequire("hdZjx");

var $6tkVZ = parcelRequire("6tkVZ");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");
const $4d1570065eefd45b$export$e23e06ae81848c38 = (0, $fdS54.createEntry)((0, $BF5pg.classicBusinessProjectViewNotFoundRoute), ()=>({
        group: 'classic-business',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>(0, $6tkVZ.projectViewNotFoundPageEntrypoint),
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("BF5pg", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRoute", () => $cc501ce3d0503719$export$1194a530fb12fc37);
const $cc501ce3d0503719$export$1194a530fb12fc37 = {
    name: 'classic-business-view-not-found',
    path: '/jira/core/projects/:projectKey/not-found',
    exact: true
};

});

parcelRegister("6tkVZ", function(module, exports) {
$parcel$export(module.exports, "projectViewNotFoundPageEntrypoint", () => $2137f8ef4a359fee$export$31e63eef3cc009c6);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $icoY4 = parcelRequire("icoY4");

const $2137f8ef4a359fee$var$main = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("iHdJJ")), {
        moduleId: "430ac497",
        moduleName: "ProjectViewNotFound",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $icoY4.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});
const $2137f8ef4a359fee$export$31e63eef3cc009c6 = (0, $dTa0V.createPageEntryPoint)({
    main: $2137f8ef4a359fee$var$main,
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("icoY4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2095078161529b84$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9a08656b81123b3a899ed443afd14f3>>
 * @relayHash 4f9cc1b4eefda38b80dcbc5247f75776
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9
const $2095078161529b84$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9",
        "metadata": {},
        "name": "ProjectViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2095078161529b84$export$2e2bcd8739ae039 = $2095078161529b84$var$node;

});

parcelRegister("iHdJJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Dyk1").then(()=>parcelRequire('4zmkw'));

});



parcelRegister("2g81E", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsCoreFieldsRouteEntry", () => $81af5d22aed9685a$export$cfb24dffb66fed60);

var $7rzUk = parcelRequire("7rzUk");

var $exKHi = parcelRequire("exKHi");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6leOq = parcelRequire("6leOq");

var $fdS54 = parcelRequire("fdS54");

var $fU8CV = parcelRequire("fU8CV");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");
const $81af5d22aed9685a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7rzUk.classicProjectFieldsEntryPoint)
});
const $81af5d22aed9685a$export$cfb24dffb66fed60 = (0, $fdS54.createEntry)((0, $exKHi.classicProjectSettingsCoreFieldsRoute), ()=>({
        group: 'project-settings-core',
        ufoName: 'project-settings.fields.core-cmp',
        layout: (0, $fU8CV.coreProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        canTransitionIn: ()=>!(0, $i860n.fg)('mc-nfa-soft-rollback'),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        entryPoint: ()=>{
            if ((0, $i860n.fg)('mc-nfa-soft-rollback')) return undefined;
            return $81af5d22aed9685a$var$pageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        meta: {
            reporting: {
                packageName: 'jiraClassicProjectSettingsProjectFields',
                id: 'project-settings.fields.core-cmp',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("7rzUk", function(module, exports) {
$parcel$export(module.exports, "classicProjectFieldsEntryPoint", () => $bb3dd6c236a2ae79$export$60f98cbd0d82221d);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $hVUiN = parcelRequire("hVUiN");

const $bb3dd6c236a2ae79$export$60f98cbd0d82221d = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2Ve8h")), {
        moduleId: "8e229d6a",
        moduleName: "ClassicProjectFieldsApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('Project key is required for classic project fields page');
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $hVUiN.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        availableOnInput: {
                            schemeOrProject: {
                                projectKey: projectKey
                            }
                        },
                        descriptionsInput: {
                            schemeOrProject: {
                                projectKey: projectKey
                            }
                        },
                        requiredOnInput: {
                            schemeOrProject: {
                                projectKey: projectKey
                            }
                        }
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("hVUiN", function(module, exports) {
$parcel$export(module.exports, "default", () => $03c9387716ff00b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fead545293f3564fd29e7820575b0c28>>
 * @relayHash df1dc856ca78182d690a424ff60de3fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fbdad4ae6c0b946b63a2ab7ff142f49477b7177311383f95962f6cb82714ea49

var $lIGkE = parcelRequire("lIGkE");
const $03c9387716ff00b0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "availableOnInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "descriptionsInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "requiredOnInput"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = [
        v5 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "args": [
            v5 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "jira_isTenantConvertedToNfa"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 40
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "kind": "ScalarField",
        "name": "description"
    }, v14 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v15 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v16 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "workTypes",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            v14 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ 
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "isDefault"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v20 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v21 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v22 = [
        "input"
    ], v23 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v24 = [
        {
            "concreteType": "JiraIssueTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v10 /*: any*/ ,
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ]
        },
        v23 /*: any*/ 
    ], v25 = [
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ClassicProjectFieldsAppQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                v9 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "availableOnInput",
                            "variableName": "availableOnInput"
                        },
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "descriptionsInput",
                            "variableName": "descriptionsInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "requiredOnInput",
                            "variableName": "requiredOnInput"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ClassicProjectFieldsPage_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ClassicProjectFieldsAppQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
                                    "kind": "LinkedField",
                                    "name": "schemeAssociatedFields",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldSchemeAssociatedField",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "field",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldId"
                                                                },
                                                                v12 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFieldLocked"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueFieldConfig",
                                                            "kind": "LinkedField",
                                                            "name": "fieldConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "input",
                                                                            "variableName": "availableOnInput"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraFieldToWorkTypesAssociation",
                                                                    "kind": "LinkedField",
                                                                    "name": "workTypesAssociationV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "availableOnAllWorkTypes"
                                                                        },
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "input",
                                                                            "variableName": "requiredOnInput"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraFieldWorkTypeRequiredCustomization",
                                                                    "kind": "LinkedField",
                                                                    "name": "requiredOnCustomizationsV2",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isRequired"
                                                                        },
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "input",
                                                                            "variableName": "descriptionsInput"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraFieldWorkTypeDescriptionCustomization",
                                                                    "kind": "LinkedField",
                                                                    "name": "descriptionCustomisationsV2",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "workTypes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v10 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                v19 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "schemeAssociatedFields(first:40)"
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "filters": v22 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "classicProjectFieldsAssociatedFieldsTable_schemeAssociatedFields",
                                    "kind": "LinkedHandle",
                                    "name": "schemeAssociatedFields"
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "availableIssueTypes",
                                    "plural": false,
                                    "selections": v24 /*: any*/ 
                                },
                                {
                                    "filters": v22 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "FilterSelectWorkType_project_availableIssueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "availableIssueTypes"
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "requiredOnIssueTypes",
                                    "plural": false,
                                    "selections": v24 /*: any*/ 
                                },
                                {
                                    "filters": v22 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "FilterSelectRequiredOn_project_requiredOnIssueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "requiredOnIssueTypes"
                                },
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "JiraFieldScheme",
                                    "kind": "LinkedField",
                                    "name": "associatedFieldScheme",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectsCount"
                                        },
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "schemeId"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v9 /*: any*/ ,
                {
                    "args": v25 /*: any*/ ,
                    "concreteType": "JiraFieldTypeGroupConnection",
                    "kind": "LinkedField",
                    "name": "jira_fieldTypeGroups",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraFieldTypeGroupEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraFieldTypeGroup",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ 
                    ]
                },
                {
                    "args": v25 /*: any*/ ,
                    "filters": [
                        "cloudId"
                    ],
                    "handle": "connection",
                    "key": "ClassicProjectFieldsFilterSelectFieldTypeCategory_query_jira_fieldTypeGroups",
                    "kind": "LinkedHandle",
                    "name": "jira_fieldTypeGroups"
                }
            ]
        },
        "params": {
            "id": "fbdad4ae6c0b946b63a2ab7ff142f49477b7177311383f95962f6cb82714ea49",
            "metadata": {},
            "name": "ClassicProjectFieldsAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$03c9387716ff00b0$var$node.hash = "653cd9ad76539940aed411cf7beb7cc9";
(0, $lIGkE.PreloadableQueryRegistry).set($03c9387716ff00b0$var$node.params.id, $03c9387716ff00b0$var$node);
var $03c9387716ff00b0$export$2e2bcd8739ae039 = $03c9387716ff00b0$var$node;

});

parcelRegister("2Ve8h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("02Y9c").then(()=>parcelRequire('9T5MK'));

});


parcelRegister("exKHi", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsCoreFieldsRoute", () => $949bcce5d0b07ea4$export$44ec2d35daac41b2);
const $949bcce5d0b07ea4$export$44ec2d35daac41b2 = {
    name: 'classic-project-settings-core-fields',
    path: '/jira/core/c/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("i1PT6", function(module, exports) {
$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $8bfba0fbd1bc2cba$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $8bfba0fbd1bc2cba$export$90749419e9042370);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


var $1UgtU = parcelRequire("1UgtU");
const $8bfba0fbd1bc2cba$export$92c4069b5349d086 = (0, $7edbf.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $1UgtU.fetchLicenseDetails)((0, $be8e573b9be9cc14$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity,
    isCritical: true
});
const $8bfba0fbd1bc2cba$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $k6ufm.useResource)($8bfba0fbd1bc2cba$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
/* eslint-disable jira/filename-case */ const $be8e573b9be9cc14$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("1UgtU", function(module, exports) {
$parcel$export(module.exports, "fetchLicenseDetails", () => $de22e8b1ae29122c$export$ec058a82eccb31e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");
const $de22e8b1ae29122c$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $de22e8b1ae29122c$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $de22e8b1ae29122c$var$EMPTY_RESPONSE;
};

});


parcelRegister("6leOq", function(module, exports) {
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $83358c10d560c4a5$export$808691f5a412afa3);
/* eslint-disable import/order */ 
var $hFYSn = parcelRequire("hFYSn");

var $iFmc7 = parcelRequire("iFmc7");

var $fdMbz = parcelRequire("fdMbz");

var $edf7u = parcelRequire("edf7u");
const $83358c10d560c4a5$export$808691f5a412afa3 = ()=>[
        (0, $fdMbz.navigationSidebarAutomationLegacyEnabledResource),
        (0, $edf7u.projectContextResourceWithCache),
        (0, $hFYSn.forgeProjectSettingsModuleResource),
        (0, $iFmc7.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});


parcelRegister("jzbS2", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRouteEntry", () => $541b3f290cfe61ac$export$5b0670f37204a43d);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $1EHTu = parcelRequire("1EHTu");

var $jp8gj = parcelRequire("jp8gj");
const $541b3f290cfe61ac$export$5b0670f37204a43d = (0, $fdS54.createEntry)((0, $1EHTu.classicProjectSettingsDataClassificationsRoute), ()=>({
        group: 'project-settings-classic',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jp8gj.default),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jp8gj.LazyDataClassificationsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1EHTu", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", () => $1208dc4d1dad2965$export$952eefa1907e877a);
const $1208dc4d1dad2965$export$952eefa1907e877a = {
    name: 'project-settings-classic-data-classifications',
    path: '/plugins/servlet/project-config/:projectKey/data-classifications',
    exact: true
};

});

parcelRegister("jp8gj", function(module, exports) {
$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $d8ec0ee86a6c9210$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $d8ec0ee86a6c9210$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $d8ec0ee86a6c9210$export$b8abcf8aa8f4df56 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("bWcHj"))), {
    moduleId: "./src/packages/spa-apps/project-settings-data-classifications/src/index.tsx"
});
const $d8ec0ee86a6c9210$var$AsyncDataClassificationsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $d8ec0ee86a6c9210$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
$d8ec0ee86a6c9210$var$AsyncDataClassificationsSettings.displayName = "AsyncDataClassificationsSettings";
var $d8ec0ee86a6c9210$export$2e2bcd8739ae039 = $d8ec0ee86a6c9210$var$AsyncDataClassificationsSettings;

});
parcelRegister("bWcHj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("dEdjB")
]).then(()=>parcelRequire('8Z094'));

});



parcelRegister("e4FF2", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsDetailsRouteEntry", () => $0611d144ce22f584$export$9391a147c94081db);



var $98dWy = parcelRequire("98dWy");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $2zTyt = parcelRequire("2zTyt");

var $k2tg5 = parcelRequire("k2tg5");

var $3eysO = parcelRequire("3eysO");

var $dTa0V = parcelRequire("dTa0V");
const $0611d144ce22f584$var$projectSettingsDetailsPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $98dWy.projectDetailsPageEntrypoint)
});
const $0611d144ce22f584$export$9391a147c94081db = (0, $fdS54.createEntry)((0, $2zTyt.classicProjectSettingsDetailsRoute), ()=>({
        group: 'project-settings-software',
        skeleton: (0, $k2tg5.ProjectSettingsDetailsSkeleton),
        layout: (0, $3eysO.softwareProjectLayout),
        entryPoint: ()=>$0611d144ce22f584$var$projectSettingsDetailsPageEntrypoint,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("98dWy", function(module, exports) {
$parcel$export(module.exports, "projectDetailsPageEntrypoint", () => $524e020ca391b27b$export$a2703bbcf53fcb99);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $524e020ca391b27b$export$a2703bbcf53fcb99 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("jzyYH")), {
        moduleId: "853aab68",
        moduleName: "ProjectDetailsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {},
            extraProps: {}
        })
});

});
parcelRegister("jzyYH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("5OQo1")
]).then(()=>parcelRequire('eqK1d'));

});


parcelRegister("2zTyt", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsDetailsRoute", () => $e737f56773d23177$export$37e0dbac44df25b9);
const $e737f56773d23177$export$37e0dbac44df25b9 = {
    name: 'classic-software-details',
    path: '/jira/software/c/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("k2tg5", function(module, exports) {
$parcel$export(module.exports, "ProjectSettingsAccessSkeleton", () => $c02eaf2eb7849c9d$export$e6cc5ccd52c7fd63);
$parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", () => $c02eaf2eb7849c9d$export$bd7fd4005b84aec9);
$parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", () => $c02eaf2eb7849c9d$export$ec1cdd0c8335373c);
/* ProjectSettingsFeaturesSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $EpB8G = parcelRequire("EpB8G");

var $1U3V7 = parcelRequire("1U3V7");

var $2IIAr = parcelRequire("2IIAr");
const $c02eaf2eb7849c9d$var$customCssStyles = null;
const $c02eaf2eb7849c9d$var$listOnlyStyles = null;
const $c02eaf2eb7849c9d$export$e6cc5ccd52c7fd63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($EpB8G))),
        className: (0, $4jQY2.default)([
            "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
$c02eaf2eb7849c9d$export$e6cc5ccd52c7fd63.displayName = "ProjectSettingsAccessSkeleton";
const $c02eaf2eb7849c9d$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1U3V7))),
        className: (0, $4jQY2.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
$c02eaf2eb7849c9d$export$bd7fd4005b84aec9.displayName = "ProjectSettingsDetailsSkeleton";
const $c02eaf2eb7849c9d$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2IIAr))),
        className: (0, $4jQY2.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
$c02eaf2eb7849c9d$export$ec1cdd0c8335373c.displayName = "ProjectSettingsFeaturesSkeleton";

});
parcelRegister("EpB8G", function(module, exports) {
module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();

});

parcelRegister("1U3V7", function(module, exports) {
module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();

});

parcelRegister("2IIAr", function(module, exports) {
module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();

});



parcelRegister("iTMvW", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsFeaturesRouteEntry", () => $4ce25b428d8142cd$export$b623393adc25556a);



var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $ha53D = parcelRequire("ha53D");

var $k2tg5 = parcelRequire("k2tg5");

var $3eysO = parcelRequire("3eysO");

var $9dMXV = parcelRequire("9dMXV");

var $gEhlT = parcelRequire("gEhlT");
const $4ce25b428d8142cd$export$b623393adc25556a = (0, $fdS54.createEntry)((0, $ha53D.classicProjectSettingsFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'classic-features-page',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gEhlT.ClassicFeaturesPage),
        skeleton: (0, $k2tg5.ProjectSettingsFeaturesSkeleton),
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $9dMXV.projectGlobalComponentsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gEhlT.LazySoftwareClassicFeatures)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ha53D", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsFeaturesRoute", () => $5fd28d2b370e6226$export$d4bf23ba6f4199d7);
const $5fd28d2b370e6226$export$d4bf23ba6f4199d7 = {
    name: 'classic-software-features',
    path: '/jira/software/c/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("gEhlT", function(module, exports) {
$parcel$export(module.exports, "LazySoftwareClassicFeatures", () => $bb4a0db4fdc6cc30$export$79fe16f960f3d89f);
$parcel$export(module.exports, "ClassicFeaturesPage", () => $bb4a0db4fdc6cc30$export$8e6f565615e921dd);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $bb4a0db4fdc6cc30$export$79fe16f960f3d89f = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("ggJ1R"))), {
    moduleId: "./src/packages/spa-apps/project-settings-classic-features/src/ProjectSettingsClassicFeatures.tsx"
});
const $bb4a0db4fdc6cc30$export$8e6f565615e921dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $bb4a0db4fdc6cc30$export$79fe16f960f3d89f,
        pageId: "classic-features",
        shouldShowSpinner: true
    });
$bb4a0db4fdc6cc30$export$8e6f565615e921dd.displayName = "ClassicFeaturesPage";

});
parcelRegister("ggJ1R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d3Ob2").then(()=>parcelRequire('jQQtn'));

});



parcelRegister("7tU8P", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRouteEntry", () => $870fd67295ada467$export$47b3bdf88a7d176b);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $8Mxd2 = parcelRequire("8Mxd2");

var $ktM3m = parcelRequire("ktM3m");
const $870fd67295ada467$export$47b3bdf88a7d176b = (0, $fdS54.createEntry)((0, $8Mxd2.classicProjectSettingsIssueLayoutRoute), ()=>({
        group: 'project-settings-classic',
        ufoName: 'project-settings.issue-type.jsw-cmp',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ktM3m.default),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $ktM3m.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8Mxd2", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRoute", () => $a8e18e52b7c490e7$export$c593179674352d0);
const $a8e18e52b7c490e7$export$c593179674352d0 = {
    name: 'project-settings-classic-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout',
    query: [
        'screenId'
    ],
    exact: true
};

});

parcelRegister("ktM3m", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeSettings", () => $185e92667a27fee8$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $185e92667a27fee8$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $185e92667a27fee8$export$36dcfb52d47cb93a = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("foBE1"))), {
    moduleId: "./src/packages/spa-apps/project-settings-issue-type/src/IssueTypePage.tsx"
});
const $185e92667a27fee8$var$AsyncIssueTypeSettings = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $185e92667a27fee8$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
$185e92667a27fee8$var$AsyncIssueTypeSettings.displayName = "AsyncIssueTypeSettings";
var $185e92667a27fee8$export$2e2bcd8739ae039 = $185e92667a27fee8$var$AsyncIssueTypeSettings;

});
parcelRegister("foBE1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jEw8X")
]).then(()=>parcelRequire('aV2Zu'));

});



parcelRegister("3dCUd", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsOpsgenieRouteEntry", () => $198cf98e004d7d5c$export$17e7416abefe91dc);



var $lFLfF = parcelRequire("lFLfF");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $052eo = parcelRequire("052eo");

var $jEYuY = parcelRequire("jEYuY");

var $4Oj6z = parcelRequire("4Oj6z");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $jsrlQ = parcelRequire("jsrlQ");

var $3eysO = parcelRequire("3eysO");

var $5DGGA = parcelRequire("5DGGA");
const $198cf98e004d7d5c$export$17e7416abefe91dc = (0, $fdS54.createEntry)((0, $jsrlQ.classicProjectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4Oj6z.default)((0, $052eo.isDevopsFeatureDisabledInFedRamp), (0, $lFLfF.default), (0, $5DGGA.default)),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5DGGA.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("052eo", function(module, exports) {
$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $04c2ab647ff92a62$export$18bfef4995ec57b7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");
const $04c2ab647ff92a62$export$18bfef4995ec57b7 = ()=>(0, $i860n.fg)('aem_migration_jira') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-devops') : (0, $l1vE2.isFedRamp)();

});

parcelRegister("4Oj6z", function(module, exports) {
$parcel$export(module.exports, "default", () => $c60088b084b98e49$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
/**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @jira/platform__utils-feature-flagging-utils and componentWithCondition instead.
 */ const $c60088b084b98e49$var$componentWithCondition = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};
var $c60088b084b98e49$export$2e2bcd8739ae039 = $c60088b084b98e49$var$componentWithCondition;

});

parcelRegister("jsrlQ", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsOpsgenieRoute", () => $1e4560ea06805bc1$export$4e4a4b8762b611);
const $1e4560ea06805bc1$export$4e4a4b8762b611 = {
    name: 'classic-software-link-opsgenie',
    path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
    exact: true
};

});

parcelRegister("5DGGA", function(module, exports) {
$parcel$export(module.exports, "LazyLinkOpsgeniePage", () => $1cb9b71c9bc58a58$export$ca5dba69148b337);
$parcel$export(module.exports, "default", () => $1cb9b71c9bc58a58$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1cb9b71c9bc58a58$export$ca5dba69148b337 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("3M0PR")), {
    moduleId: "./src/packages/spa-apps/project-settings-link-opsgenie/src/index.tsx"
});
const $1cb9b71c9bc58a58$var$AsyncLinkOpsgeniePage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1cb9b71c9bc58a58$export$ca5dba69148b337,
        pageId: "link-opsgenie-page",
        shouldShowSpinner: false
    });
$1cb9b71c9bc58a58$var$AsyncLinkOpsgeniePage.displayName = "AsyncLinkOpsgeniePage";
var $1cb9b71c9bc58a58$export$2e2bcd8739ae039 = $1cb9b71c9bc58a58$var$AsyncLinkOpsgeniePage;

});
parcelRegister("3M0PR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jXC6e")
]).then(()=>parcelRequire('j7oOp'));

});



parcelRegister("hNTUt", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsServiceDeskFieldsRouteEntry", () => $c571f7480d9ee27d$export$93a0b67807e37a01);

var $7rzUk = parcelRequire("7rzUk");

var $fjcey = parcelRequire("fjcey");



var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $74h93 = parcelRequire("74h93");


var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $lbxXL = parcelRequire("lbxXL");
const $c571f7480d9ee27d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7rzUk.classicProjectFieldsEntryPoint)
});
const $c571f7480d9ee27d$export$93a0b67807e37a01 = (0, $fdS54.createEntry)((0, $fjcey.classicProjectSettingsServiceDeskFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings.fields.jsm-cmp',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        canTransitionIn: ()=>!(0, $i860n.fg)('mc-nfa-soft-rollback'),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>{
            if ((0, $i860n.fg)('mc-nfa-soft-rollback')) return undefined;
            return $c571f7480d9ee27d$var$pageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        meta: {
            reporting: {
                packageName: 'jiraClassicProjectSettingsProjectFields',
                id: 'project-settings.fields.jsm-cmp',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("fjcey", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsServiceDeskFieldsRoute", () => $2dc1dc94d0322c63$export$dceb31a4d45c582f);
const $2dc1dc94d0322c63$export$dceb31a4d45c582f = {
    name: 'classic-project-settings-servicedesk-fields',
    path: '/jira/servicedesk/c/projects/:projectKey/settings/fields',
    exact: true
};

});


parcelRegister("jHnnR", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareFieldsRouteEntry", () => $6a3d947f09d45649$export$768e0206a0d2ae8c);

var $7rzUk = parcelRequire("7rzUk");

var $fItR1 = parcelRequire("fItR1");



var $gyAS0 = parcelRequire("gyAS0");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");
const $6a3d947f09d45649$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7rzUk.classicProjectFieldsEntryPoint)
});
const $6a3d947f09d45649$export$768e0206a0d2ae8c = (0, $fdS54.createEntry)((0, $fItR1.classicProjectSettingsSoftwareFieldsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.fields.jsw-cmp',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        canTransitionIn: ()=>!(0, $i860n.fg)('mc-nfa-soft-rollback'),
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        entryPoint: ()=>{
            if ((0, $i860n.fg)('mc-nfa-soft-rollback')) return undefined;
            return $6a3d947f09d45649$var$pageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        meta: {
            reporting: {
                packageName: 'jiraClassicProjectSettingsProjectFields',
                id: 'project-settings.fields.jsw-cmp',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("fItR1", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareFieldsRoute", () => $5cd75589d7e32824$export$5ee20e4bfcebaed7);
const $5cd75589d7e32824$export$5ee20e4bfcebaed7 = {
    name: 'classic-project-settings-software-fields',
    path: '/jira/software/c/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("gyAS0", function(module, exports) {
$parcel$export(module.exports, "SOFTWARE_PRODUCT", () => $ad8a7907fd169283$export$2954328f6207617a);
$parcel$export(module.exports, "getSettingsNavigationResources", () => $ad8a7907fd169283$export$586756e5c0542a50);
$parcel$export(module.exports, "RedirectForSettings", () => $ad8a7907fd169283$export$fb15a6ba8980fdac);
$parcel$export(module.exports, "RedirectForSettingsForClassicProject", () => $ad8a7907fd169283$export$f9befa0a4925b36d);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $8ANUF = parcelRequire("8ANUF");

var $gNbXR = parcelRequire("gNbXR");
const $ad8a7907fd169283$export$2954328f6207617a = 'software';
const $ad8a7907fd169283$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $ad8a7907fd169283$export$586756e5c0542a50 = ()=>{
    return [
        ...(0, $dUAVJ.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $hWEkS.incidentExperimentTraitResource),
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $ad8a7907fd169283$export$fb15a6ba8980fdac = ({ match: match })=>{
    const { data: data, loading: loading } = (0, $8ANUF.useJiraSoftwareProjectNavigation)();
    // Wait for nav data to be available before deciding where to redirect on cold loads
    if (loading || !data) return null;
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
    // the next three if branches do not make a lot of sense for TMP as you always a project admin in TMP
    // however a wrong link is generated by the nav4 navbar for CMP projects which matches to this redirect logic
    // ex: "/jira/software/projects/JSWCMP1/settings"
    // instead it should be "/jira/software/c/projects/JSWCMP1/settings"
    // which matches to CMP redirect logic defined in RedirectForSettingsForClassicProject
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
};
$ad8a7907fd169283$export$fb15a6ba8980fdac.displayName = "RedirectForSettings";
const $ad8a7907fd169283$export$f9befa0a4925b36d = ({ match: match })=>{
    const { data: data, loading: loading } = (0, $8ANUF.useJiraSoftwareProjectNavigation)();
    // Wait for nav data to be available before deciding where to redirect on cold loads
    if (loading || !data) return null;
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
};
$ad8a7907fd169283$export$f9befa0a4925b36d.displayName = "RedirectForSettingsForClassicProject";

});


parcelRegister("deexU", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $8b6a6380f396b419$export$cdc4e64211a34457);



var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $5wroA = parcelRequire("5wroA");

var $3eysO = parcelRequire("3eysO");

var $E0aBu = parcelRequire("E0aBu");
const $8b6a6380f396b419$export$cdc4e64211a34457 = (0, $fdS54.createEntry)((0, $5wroA.classicProjectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.classic-issue-logs-page',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $E0aBu.SoftwareNotificationsIssueLogs),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $E0aBu.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $E0aBu.emailNotificationsLogEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5wroA", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRoute", () => $1494877f7e2d7edb$export$5e2e0a895d6a14bd);
const $1494877f7e2d7edb$export$5e2e0a895d6a14bd = {
    name: 'classic-software-notifications-issue-logs',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
    query: [
        'projectId'
    ]
};

});

parcelRegister("E0aBu", function(module, exports) {
$parcel$export(module.exports, "emailNotificationsLogEntryPointPage", () => $918068da4238b1cb$export$cd8964bea0e3c2);
$parcel$export(module.exports, "LazySoftwareNotificationsIssueLogs", () => $918068da4238b1cb$export$6960a46ebd209756);
$parcel$export(module.exports, "SoftwareNotificationsIssueLogs", () => $918068da4238b1cb$export$4b75df09cc5b4e8e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $1NFve = parcelRequire("1NFve");

var $dTa0V = parcelRequire("dTa0V");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");
const $918068da4238b1cb$export$cd8964bea0e3c2 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1NFve.notificationsIssueLogsEntryPoint)
});

const $918068da4238b1cb$export$6960a46ebd209756 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("iXjRN"))), {
    moduleId: "./src/packages/spa-apps/project-settings-software-notifications-issue-logs/src/NotificationLogs.tsx"
});
const $918068da4238b1cb$export$4b75df09cc5b4e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $918068da4238b1cb$export$6960a46ebd209756,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });
$918068da4238b1cb$export$4b75df09cc5b4e8e.displayName = "SoftwareNotificationsIssueLogs";

});
parcelRegister("1NFve", function(module, exports) {
$parcel$export(module.exports, "notificationsIssueLogsEntryPoint", () => $d06f1e35c5822b4a$export$97bbdefcbe0571ac);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $htyt9 = parcelRequire("htyt9");

const $d06f1e35c5822b4a$export$97bbdefcbe0571ac = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("iXjRN")), {
        moduleId: "b7205b93",
        moduleName: "NotificationLogs",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $htyt9.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectId: Number(context?.query?.projectId ?? 0),
                        notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        })
});

});
parcelRegister("htyt9", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f82f8705a695ba3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd4746523c651e56ecee740aa726ab3c>>
 * @relayHash f9849ca62d92d5dccd989e12e1008a35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5ee7e920ef5738fb298d664d9c2c5ee8763d21ceced2b7bc2516078b63fe195
const $8f82f8705a695ba3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b5ee7e920ef5738fb298d664d9c2c5ee8763d21ceced2b7bc2516078b63fe195",
        "metadata": {},
        "name": "NotificationLogsPageUiQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8f82f8705a695ba3$export$2e2bcd8739ae039 = $8f82f8705a695ba3$var$node;

});

parcelRegister("iXjRN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i2e2t").then(()=>parcelRequire('4UbQm'));

});




parcelRegister("9OOVl", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRouteEntry", () => $2d5824e6f9ad551e$export$e730b13555ff0c60);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lF0XI = parcelRequire("lF0XI");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");

var $hjNWi = parcelRequire("hjNWi");
const $2d5824e6f9ad551e$export$e730b13555ff0c60 = (0, $fdS54.createEntry)((0, $lF0XI.classicProjectSettingsSoftwareProformaEditFormsRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hjNWi.default),
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hjNWi.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lF0XI", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRoute", () => $c6732958680fd369$export$811ace4fee984f0e);
const $c6732958680fd369$export$811ace4fee984f0e = {
    name: 'project-settings-software-proforma-edit-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("hjNWi", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $eb7d9ba7a934f978$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $eb7d9ba7a934f978$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $eb7d9ba7a934f978$export$a7d63246a10aedd = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("lrE2c")), {
    moduleId: "./src/packages/spa-apps/project-settings-proforma-jira-form-builder/src/ProformaJiraFormBuilderPage.tsx"
});
const $eb7d9ba7a934f978$var$AsyncProjectSettingsProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $eb7d9ba7a934f978$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
$eb7d9ba7a934f978$var$AsyncProjectSettingsProformaJiraFormBuilder.displayName = "AsyncProjectSettingsProformaJiraFormBuilder";
var $eb7d9ba7a934f978$export$2e2bcd8739ae039 = $eb7d9ba7a934f978$var$AsyncProjectSettingsProformaJiraFormBuilder;

});
parcelRegister("lrE2c", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("5ASl5")
]).then(()=>parcelRequire('lQmgB'));

});



parcelRegister("dHEBg", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRouteEntry", () => $814c3e6533c953d1$export$5e67ac6f50ae37e1);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $4EWkX = parcelRequire("4EWkX");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");

var $hcswn = parcelRequire("hcswn");
const $814c3e6533c953d1$export$5e67ac6f50ae37e1 = (0, $fdS54.createEntry)((0, $4EWkX.classicProjectSettingsSoftwareProformaFormsRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hcswn.default),
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hcswn.LazyProjectSettingsProformaProjectForms)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4EWkX", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRoute", () => $9a7177636fa0ed79$export$2313ca001d58ab27);
const $9a7177636fa0ed79$export$2313ca001d58ab27 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("hcswn", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $ae446af5322c62d1$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $ae446af5322c62d1$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $ae446af5322c62d1$export$38414b624a749cec = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("6nXBG")), {
    moduleId: "./src/packages/spa-apps/project-settings-proforma-project-forms/src/ProformaProjectFormsSettingsPage.tsx"
});
const $ae446af5322c62d1$var$AsyncProjectSettingsProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ae446af5322c62d1$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
$ae446af5322c62d1$var$AsyncProjectSettingsProformaProjectForms.displayName = "AsyncProjectSettingsProformaProjectForms";
var $ae446af5322c62d1$export$2e2bcd8739ae039 = $ae446af5322c62d1$var$AsyncProjectSettingsProformaProjectForms;

});
parcelRegister("6nXBG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gN1vJ")
]).then(()=>parcelRequire('fWLti'));

});



parcelRegister("3imAc", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRouteEntry", () => $0fdebdf2792c9c53$export$3c7d008bbb14e2b);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $497sj = parcelRequire("497sj");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");
const $0fdebdf2792c9c53$export$3c7d008bbb14e2b = (0, $fdS54.createEntry)((0, $497sj.classicProjectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gyAS0.RedirectForSettingsForClassicProject),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("497sj", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRoute", () => $4503f265421f6d3c$export$99b695c2b8299b5a);
const $4503f265421f6d3c$export$99b695c2b8299b5a = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'classic-software-redirect',
    path: '/jira/software/c/projects/:projectKey/settings'
};

});


parcelRegister("48hVA", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsToolchainRouteEntry", () => $762eddc5238b5d0a$export$1fe479c54f4d7684);



var $6I9K3 = parcelRequire("6I9K3");

var $lFLfF = parcelRequire("lFLfF");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $052eo = parcelRequire("052eo");

var $jEYuY = parcelRequire("jEYuY");

var $4Oj6z = parcelRequire("4Oj6z");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $l0qxU = parcelRequire("l0qxU");

var $3eysO = parcelRequire("3eysO");

var $5VtgL = parcelRequire("5VtgL");
const $762eddc5238b5d0a$export$1fe479c54f4d7684 = (0, $fdS54.createEntry)((0, $l0qxU.classicProjectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4Oj6z.default)((0, $052eo.isDevopsFeatureDisabledInFedRamp), (0, $lFLfF.default), (0, $5VtgL.default)),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6I9K3.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5VtgL.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6I9K3", function(module, exports) {
$parcel$export(module.exports, "projectSettingsToolchainResource", () => $9e5e27b1ce05d7e5$export$182dfe2bc7c28567);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2Z6ip = parcelRequire("2Z6ip");

var $htsFl = parcelRequire("htsFl");
const $9e5e27b1ce05d7e5$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
const $9e5e27b1ce05d7e5$export$182dfe2bc7c28567 = (0, $htsFl.createRelayResource)({
    type: $9e5e27b1ce05d7e5$export$b8927fea69d9f414,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $2Z6ip.default),
            variables: {
                cloudId: tenantContext?.cloudId || ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("2Z6ip", function(module, exports) {
$parcel$export(module.exports, "default", () => $096a2065e881cca6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ba4a4459b711ca9c690a5549cf61d24>>
 * @relayHash 48253c273e6aab42de7754c1092fc3a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 09eb5c309b93132e17ec19c3a5fdc9e09d9d2320daa0d37c40ac6a46dc998281
const $096a2065e881cca6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "DvcsQuery",
            "kind": "LinkedField",
            "name": "dvcs",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "DvcsBitbucketWorkspaceConnection",
                    "kind": "LinkedField",
                    "name": "bitbucketWorkspacesLinkedToSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DvcsBitbucketWorkspaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ToolchainLayoutQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ToolchainLayoutQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "09eb5c309b93132e17ec19c3a5fdc9e09d9d2320daa0d37c40ac6a46dc998281",
            "metadata": {},
            "name": "ToolchainLayoutQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$096a2065e881cca6$var$node.hash = "810499e5c2abc370d3d44631b8958e5f";
var $096a2065e881cca6$export$2e2bcd8739ae039 = $096a2065e881cca6$var$node;

});


parcelRegister("l0qxU", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsToolchainRoute", () => $d0d9645105508c48$export$7dbc23deac9553d4);
const $d0d9645105508c48$export$7dbc23deac9553d4 = {
    name: 'project-settings-software-toolchain-company-managed',
    path: '/jira/software/c/projects/:projectKey/settings/toolchain',
    exact: true
};

});

parcelRegister("5VtgL", function(module, exports) {
$parcel$export(module.exports, "LazyDevOpsConnectionsSettings", () => $e3a185948fdaca11$export$9d468faf674a5201);
$parcel$export(module.exports, "default", () => $e3a185948fdaca11$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $e3a185948fdaca11$export$9d468faf674a5201 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("3rxI8")), {
    moduleId: "./src/packages/spa-apps/project-settings-connections/src/index.tsx"
});
const $e3a185948fdaca11$var$AsyncDevOpsConnectionsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e3a185948fdaca11$export$9d468faf674a5201,
        pageId: "devops-connections-settings",
        shouldShowSpinner: false
    });
$e3a185948fdaca11$var$AsyncDevOpsConnectionsSettings.displayName = "AsyncDevOpsConnectionsSettings";
var $e3a185948fdaca11$export$2e2bcd8739ae039 = $e3a185948fdaca11$var$AsyncDevOpsConnectionsSettings;

});
parcelRegister("3rxI8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iyCMV")
]).then(()=>parcelRequire('cYtlx'));

});



parcelRegister("eCgFr", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBacklogEmbedRouteEntry", () => $7a9311ec14e88796$export$1a7368427cd23b33);

var $51vnM = parcelRequire("51vnM");

var $jFwZ0 = parcelRequire("jFwZ0");

var $cLdvY = parcelRequire("cLdvY");

var $5adCU = parcelRequire("5adCU");

var $hRSPo = parcelRequire("hRSPo");

var $4TFaG = parcelRequire("4TFaG");

var $5zPGY = parcelRequire("5zPGY");

var $fdS54 = parcelRequire("fdS54");

var $gJhWx = parcelRequire("gJhWx");

var $byMD7 = parcelRequire("byMD7");

var $edf7u = parcelRequire("edf7u");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $i860n = parcelRequire("i860n");

var $loJVV = parcelRequire("loJVV");

var $3bgcx = parcelRequire("3bgcx");

var $cEVzH = parcelRequire("cEVzH");

var $8HUuJ = parcelRequire("8HUuJ");

var $4B518 = parcelRequire("4B518");

var $3HYSN = parcelRequire("3HYSN");

var $dUAVJ = parcelRequire("dUAVJ");

var $2YzXE = parcelRequire("2YzXE");

var $5ANI2 = parcelRequire("5ANI2");
const $7a9311ec14e88796$export$1a7368427cd23b33 = (0, $fdS54.createEntry)((0, $gJhWx.classicSoftwareBacklogEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog-embed',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $5adCU.getUIFBacklogDataResource)(),
            ...(0, $5adCU.getRapidboardResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)(),
            (0, $hFYSn.forgeBacklogModuleResource),
            (0, $hFYSn.forgeSprintModuleResource),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $cLdvY.aiEntitlementResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!false || (0, $i860n.fg)('enable_ssr_for_cmp_backlog'), (0, $loJVV.epicsLiteResource)),
            (0, $5zPGY.backlogCMPViewSettingsResource),
            (0, $jFwZ0.currentUserResource),
            (0, $3bgcx.permissionsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('twcg-992-loom-meeting-notes-sprint-planning-gate'), (0, $cEVzH.confluenceUserPermissionsResource))
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? (0, $5ANI2.GSNClassicBacklogPageEntryPoint) : (0, $5ANI2.classicBacklogPageEntryPoint),
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $2YzXE.classicBacklogCapability)
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        excludeFromWrmDeferredLoading: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-backlog')
    }));

});
parcelRegister("51vnM", function(module, exports) {
$parcel$export(module.exports, "LazyIssueApp", () => $196053fd7ffec679$export$8c70dcc4643464f8);

var $l8G1z = parcelRequire("l8G1z");

const $196053fd7ffec679$export$8c70dcc4643464f8 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("16SfS")).then((module)=>module.IssueAppWithCriticalQueryPreloader), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/IssueAppEntrypoint.tsx"
});

});

parcelRegister("gJhWx", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBacklogEmbedRoute", () => $6d688c77d5e4fb43$export$e6776ef8123b7136);
const $6d688c77d5e4fb43$export$e6776ef8123b7136 = {
    name: 'rapidboard-backlog-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
};

});

parcelRegister("loJVV", function(module, exports) {
$parcel$export(module.exports, "epicsLiteResource", () => $1d016ca0379dbb01$export$39abb8be14c2a1c5);
/* eslint-disable jira/filename-case */ 
var $7edbf = parcelRequire("7edbf");

const $1d016ca0379dbb01$export$39abb8be14c2a1c5 = (0, $7edbf.createResource)({
    type: 'EPICS_LITE_PRELOAD',
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("HrrYQ")),
    maxAge: 0
});

});
parcelRegister("HrrYQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4mEsh").then(()=>parcelRequire('8q1zr'));

});


parcelRegister("3bgcx", function(module, exports) {
$parcel$export(module.exports, "permissionsResource", () => $35c9986b7137a473$export$da3e9c9acc27ae0c);
$parcel$export(module.exports, "usePermissionsResource", () => $35c9986b7137a473$export$7e9478cc9b0580ae);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $6CfY5 = parcelRequire("6CfY5");

var $4fhEY = parcelRequire("4fhEY");
const $35c9986b7137a473$var$permissions = [
    'VIEW_BOARD',
    'ADMINISTER_BOARD',
    'BULK_CHANGE',
    'DELETE_ISSUE',
    'EDIT_ISSUE',
    'CREATE_ISSUE',
    'ASSIGN_ISSUE',
    'TRANSITION_ISSUE',
    'MANAGE_SPRINT',
    'SCHEDULE_ISSUE'
];
const $35c9986b7137a473$export$da3e9c9acc27ae0c = (0, $7edbf.createResource)({
    type: 'BACKLOG_PERMISSIONS',
    getKey: ({ match: match })=>match.params.boardId || '',
    getData: async ({ match: match })=>{
        const boardId = match.params.boardId || '';
        return (0, $4fhEY.default)(`/rest/greenhopper/1.0/xboard/permissions?boardId=${boardId}&permissions=${$35c9986b7137a473$var$permissions.join(',')}`).catch((error)=>{
            (0, $6CfY5.default).safeErrorWithoutCustomerData('backlog.load-permission.failure', 'Failed to fetch permissions for Company-Managed backlog', error);
            return null;
        });
    },
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
});
const $35c9986b7137a473$export$7e9478cc9b0580ae = ()=>(0, $k6ufm.useResource)($35c9986b7137a473$export$da3e9c9acc27ae0c);

});

parcelRegister("2YzXE", function(module, exports) {
$parcel$export(module.exports, "classicBacklogCapability", () => $e3e492a651a2ccb0$export$10a7bb102137d92b);

const $e3e492a651a2ccb0$export$10a7bb102137d92b = !false ? (0, $0ce01f968965dadd$export$571692eec8a399e1) : (0, $0ce01f968965dadd$export$93104dc4eba58ba4);

});

parcelRegister("5ANI2", function(module, exports) {
$parcel$export(module.exports, "classicBacklogPageEntryPoint", () => $79f22385984ecbd8$export$e07cd4fec395c8db);
$parcel$export(module.exports, "GSNClassicBacklogPageEntryPoint", () => $79f22385984ecbd8$export$54efafcb56111a41);
/* eslint-disable jira/naming/disallow-filenames */ 
var $1JQn3 = parcelRequire("1JQn3");

var $dTa0V = parcelRequire("dTa0V");

var $9BxTS = parcelRequire("9BxTS");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $3KSG6 = parcelRequire("3KSG6");

var $eDEQ5 = parcelRequire("eDEQ5");
const $79f22385984ecbd8$export$e07cd4fec395c8db = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1JQn3.nextGenBacklogEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $79f22385984ecbd8$export$54efafcb56111a41 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1JQn3.nextGenBacklogEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1JQn3", function(module, exports) {
$parcel$export(module.exports, "nextGenBacklogEntryPoint", () => $f4ee8e49b6c4c5e9$export$377b23d5a7dc4052);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $gPWfa = parcelRequire("gPWfa");

var $eM0il = parcelRequire("eM0il");

const $f4ee8e49b6c4c5e9$export$377b23d5a7dc4052 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2Fpi0")), {
        moduleId: "d1262226",
        moduleName: "BacklogWrapper",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        // Preload Loom calendars at route entry so the banner can read calendar data
        // synchronously during the same BacklogContent render pass as the card list.
        // Gated so ineligible users don't incur the extra network request.
        // This is independent of backlog-paginated-query — sprint data comes from Redux.
        const loomCalendarsQuery = (0, $i860n.fg)('twcg-992-loom-meeting-notes-sprint-planning-gate') ? {
            parameters: (0, $eM0il.default),
            variables: {
                siteId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        } : undefined;
        if (!(0, $i860n.fg)('backlog-paginated-query')) return loomCalendarsQuery ? {
            queries: {
                loomCalendarsQuery: loomCalendarsQuery
            }
        } : {};
        const viewId = `ari:cloud:jira:${tenantContext.cloudId}:view/activation/${tenantContext.activationId}/board/${context.match.params.boardId}/backlog`;
        const rawQuickFilter = context.query?.quickFilter ?? context.query?.customFilter;
        const quickFilterIds = rawQuickFilter ? String(rawQuickFilter).split(',').filter(Boolean).map(Number).filter(Number.isFinite) : undefined;
        const variables = {
            backlogViewInput: {
                jiraBacklogViewQueryInput: {
                    viewId: viewId
                }
            },
            view: {
                viewId: viewId
            },
            ...quickFilterIds?.length ? {
                quickFilterIds: quickFilterIds
            } : {}
        };
        const backlogDataQuery = {
            parameters: $gPWfa.default,
            variables: variables,
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
        return {
            queries: {
                backlogDataQuery: backlogDataQuery,
                ...loomCalendarsQuery ? {
                    loomCalendarsQuery: loomCalendarsQuery
                } : {}
            }
        };
    }
});

});
parcelRegister("gPWfa", function(module, exports) {
$parcel$export(module.exports, "default", () => $6432c9e7d59ae47e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a14d137edcae9c1982589fd965f2c65>>
 * @relayHash e52128060082408adaecdfb25c536f58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90c47693682b832b0e54d154b0655ad98997a7b531e9ec0a6b459682b9ab70b9
const $6432c9e7d59ae47e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "90c47693682b832b0e54d154b0655ad98997a7b531e9ec0a6b459682b9ab70b9",
        "metadata": {},
        "name": "BacklogMetaAPIConsumerWrapperQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6432c9e7d59ae47e$export$2e2bcd8739ae039 = $6432c9e7d59ae47e$var$node;

});

parcelRegister("eM0il", function(module, exports) {
$parcel$export(module.exports, "default", () => $58a58bb4bedbb530$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f57af0dad91d270dd5debbaa5b059fd9>>
 * @relayHash 23cf7b64de01321e7170c0fa120e85ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 679c77aa946ec0b98347edee8c024c741505aee43363314137e2d7a9f16d84d6
const $58a58bb4bedbb530$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "679c77aa946ec0b98347edee8c024c741505aee43363314137e2d7a9f16d84d6",
        "metadata": {},
        "name": "useLoomConnectedCalendarsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $58a58bb4bedbb530$export$2e2bcd8739ae039 = $58a58bb4bedbb530$var$node;

});

parcelRegister("2Fpi0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("hLlfh")
]).then(()=>parcelRequire('58gLq'));

});




parcelRegister("dQEuk", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBacklogRouteEntry", () => $b32cc4cc529d2f7b$export$568101ebd359b606);

var $51vnM = parcelRequire("51vnM");

var $jFwZ0 = parcelRequire("jFwZ0");



var $cLdvY = parcelRequire("cLdvY");

var $5adCU = parcelRequire("5adCU");

var $hRSPo = parcelRequire("hRSPo");

var $4TFaG = parcelRequire("4TFaG");

var $5zPGY = parcelRequire("5zPGY");

var $fdS54 = parcelRequire("fdS54");

var $5PSyU = parcelRequire("5PSyU");

var $8PWi1 = parcelRequire("8PWi1");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $QhQu4 = parcelRequire("QhQu4");

var $dvtoW = parcelRequire("dvtoW");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $75Njg = parcelRequire("75Njg");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $loJVV = parcelRequire("loJVV");

var $3bgcx = parcelRequire("3bgcx");

var $cEVzH = parcelRequire("cEVzH");

var $jEYuY = parcelRequire("jEYuY");

var $3HYSN = parcelRequire("3HYSN");

var $8HUuJ = parcelRequire("8HUuJ");

var $gZWlI = parcelRequire("gZWlI");

var $5ANI2 = parcelRequire("5ANI2");

var $2YzXE = parcelRequire("2YzXE");

var $6Cpxz = parcelRequire("6Cpxz");
/*
 * Inline the early script in the payload only if SSR is skipped.
 */ const $b32cc4cc529d2f7b$var$getEarlyEntry = ()=>{
    // ensure code is removed from client-side bundle
    if (false) // Legacy SSR does not support reading cookies and will be gone soon
    // this ensures jira-routes.js and static manifest does not change behaviour.
    return false && (0, $i860n.fg)('enable_ssr_for_cmp_backlog') ? [] : [
        'software-cmp-backlog-early-entry'
    ];
    return [
        'software-cmp-backlog-early-entry'
    ];
};
const $b32cc4cc529d2f7b$export$568101ebd359b606 = (0, $fdS54.createEntry)((0, $5PSyU.classicSoftwareBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        skeleton: (0, $8PWi1.NextGenBacklogSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.pageLoadIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ], 'SIDEBAR')),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            ...(0, $ldGfw.getIssueViewResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getUIFBacklogDataResource)(),
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)(),
            (0, $hFYSn.forgeBacklogModuleResource),
            (0, $hFYSn.forgeSprintModuleResource),
            (0, $gZWlI.projectThemeResource),
            (0, $cLdvY.aiEntitlementResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!false || (0, $i860n.fg)('enable_ssr_for_cmp_backlog'), (0, $loJVV.epicsLiteResource)),
            (0, $5zPGY.backlogCMPViewSettingsResource),
            (0, $jFwZ0.currentUserResource),
            (0, $3bgcx.permissionsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('twcg-992-loom-meeting-notes-sprint-planning-gate'), (0, $cEVzH.confluenceUserPermissionsResource))
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6Cpxz.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: $b32cc4cc529d2f7b$var$getEarlyEntry()
        },
        meta: {
            capability: (0, $2YzXE.classicBacklogCapability)
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'backlog-and-board',
            manifestName: 'jira-spa-software-backlog.json',
            fetchTimeout: (0, $2700E.expVal)('increase_ssr_fetching_timeout_for_classic_backlog', 'isEnabled', false) ? 1500 : undefined
        },
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? (0, $5ANI2.GSNClassicBacklogPageEntryPoint) : (0, $5ANI2.classicBacklogPageEntryPoint),
        entryPointOptions: {
            isSSRPlaceholderEnabled: true
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        isHydrateRootEnabled: (0, $i860n.fg)('cmp-backlog-hydrate-root'),
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-backlog'),
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("5PSyU", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBacklogRoute", () => $d5a93195404ab76f$export$9bfa3c0dded1688f);
const $d5a93195404ab76f$export$9bfa3c0dded1688f = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("8PWi1", function(module, exports) {
$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $e311145b4835566d$export$33cd465913cf178f);
/* NextGenBacklogSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $d5ps5 = parcelRequire("d5ps5");

var $TTcqD = parcelRequire("TTcqD");

var $jzKO8 = parcelRequire("jzKO8");
const $e311145b4835566d$export$7f752f2e829d53f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e311145b4835566d$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jzKO8)))
    }));
$e311145b4835566d$export$7f752f2e829d53f6.displayName = "BacklogSkeleton";
const $e311145b4835566d$export$33cd465913cf178f = ()=>{
    const displaySsrPlaceholderAttrs = (0, $TTcqD.useSsrPlaceholders)();
    let ssrPlaceholderProp = {};
    if (displaySsrPlaceholderAttrs) ssrPlaceholderProp = false ? {
        'data-ssr-placeholder': 'software-backlog-skeleton'
    } : {
        'data-ssr-placeholder-replace': 'software-backlog-skeleton'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", ssrPlaceholderProp, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e311145b4835566d$export$7f752f2e829d53f6, null));
};
$e311145b4835566d$export$33cd465913cf178f.displayName = "NextGenBacklogSkeleton";
// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e311145b4835566d$var$Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jzKO8", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("6Cpxz", function(module, exports) {
$parcel$export(module.exports, "LazyBacklogPage", () => $f0bb1d44e95f54fe$export$edb4b8cf67d7d767);

var $l8G1z = parcelRequire("l8G1z");

var $jhKsF = parcelRequire("jhKsF");

const $f0bb1d44e95f54fe$export$edb4b8cf67d7d767 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("2Fpi0"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/BacklogWrapper.tsx"
});

});


parcelRegister("znXcS", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardEmbedRouteEntry", () => $2e9c98af97772628$export$b5558b683e9c45a4);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 
var $51vnM = parcelRequire("51vnM");

var $jFwZ0 = parcelRequire("jFwZ0");

var $4TFaG = parcelRequire("4TFaG");

var $hRSPo = parcelRequire("hRSPo");

var $5adCU = parcelRequire("5adCU");

var $l1vE2 = parcelRequire("l1vE2");

var $41FAq = parcelRequire("41FAq");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $ldGfw = parcelRequire("ldGfw");

var $dUAVJ = parcelRequire("dUAVJ");

var $iEE0R = parcelRequire("iEE0R");

var $edf7u = parcelRequire("edf7u");

var $4B518 = parcelRequire("4B518");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");

var $liEdL = parcelRequire("liEdL");

var $eAaRp = parcelRequire("eAaRp");

var $QhQu4 = parcelRequire("QhQu4");

var $i860n = parcelRequire("i860n");

var $8lVqS = parcelRequire("8lVqS");
const $2e9c98af97772628$export$b5558b683e9c45a4 = (0, $fdS54.createEntry)((0, $liEdL.classicSoftwareBoardEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board-embed',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eAaRp.RapidBoardSpaPage),
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $8HUuJ.resourceWithCondition)((0, $5adCU.shouldLoadUIFBoardResources), (0, $2DCyG.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $5adCU.shouldLoadUIFBoardResources)() && ((0, $i860n.fg)('aem_rr_classic_board') ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-next-best-task') : !(0, $l1vE2.isFedRamp)()), (0, $iEE0R.nextBestTaskFeatureResource)),
            (0, $2DCyG.boardViewSettingsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('board_ssr_missing_element_fix'), (0, $jFwZ0.currentUserResource)),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)(),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $hFYSn.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $eAaRp.UIFBoardSpa)
        ],
        meta: {
            capability: (0, $8lVqS.classicBoardCapability)
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        excludeFromWrmDeferredLoading: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-boards')
    }));

});
parcelRegister("iEE0R", function(module, exports) {
$parcel$export(module.exports, "nextBestTaskFeatureResource", () => $de93edec0a924ede$export$5d472f7d515300ca);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");

const $de93edec0a924ede$export$5d472f7d515300ca = (0, $7edbf.createResource)({
    type: (0, $72aa476e1cf4b9e4$export$6f0555de4f60e84e),
    getKey: ()=>(0, $72aa476e1cf4b9e4$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            return await (0, $h2wCv.performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $72aa476e1cf4b9e4$export$b94951a11282ae6a)}`);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, we auto enroll them and set the initial value to true.
					 */ return {
                hasUserOptedIn: true
            };
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: (0, $72aa476e1cf4b9e4$export$7f111648ca05f056),
                    packageName: (0, $72aa476e1cf4b9e4$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return false,
			 * this ensures if user is in the experiment cohort but later opted out, they don't revert to having the feature enabled */ return {
            hasUserOptedIn: false
        };
    },
    maxAge: Number.MAX_VALUE
});

});
/* eslint-disable jira/filename-case */ const $72aa476e1cf4b9e4$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $72aa476e1cf4b9e4$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key'; // value is global for user
const $72aa476e1cf4b9e4$export$b94951a11282ae6a = 'next-best-task-feature';
const $72aa476e1cf4b9e4$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $72aa476e1cf4b9e4$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';


parcelRegister("liEdL", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $928e427c18220f67$export$122afcef7dfd252);
const $928e427c18220f67$export$122afcef7dfd252 = {
    name: 'rapidboard-board-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("eAaRp", function(module, exports) {
$parcel$export(module.exports, "UIFBoardSpa", () => $e883f9c67c51e865$export$2164de18d39af313);
$parcel$export(module.exports, "RapidBoardSpaPage", () => $e883f9c67c51e865$export$4ceb6cf2934825b2);
$parcel$export(module.exports, "LazyRapidBoard", () => $e883f9c67c51e865$export$9de09057ba255cc4);
$parcel$export(module.exports, "LazyRapidBoardWrmBundleResource", () => $e883f9c67c51e865$export$bcb5bb6438a46dcb);
$parcel$export(module.exports, "LazyRapidBoardDataApiResource", () => $e883f9c67c51e865$export$d4640ceb9bdd4b4);
$parcel$export(module.exports, "LazyRapidBoardConfigApiResource", () => $e883f9c67c51e865$export$c96c36c0cbfb2c16);
$parcel$export(module.exports, "LazyRapidBoardResource", () => $e883f9c67c51e865$export$2ad64ed8eb98d9e);
$parcel$export(module.exports, "LazyRapidBoardApps", () => $e883f9c67c51e865$export$4a8825f3e310b97);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $e883f9c67c51e865$export$2164de18d39af313 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("20xiv")), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/BoardSPAApp.tsx"
});

const $e883f9c67c51e865$export$bcc6315cf211edab = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2Fpi0")), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/BacklogWrapper.tsx"
});

const $e883f9c67c51e865$export$a1c59527bd5131cc = (0, $l8G1z.lazyForPaint)(()=>// eslint-disable-next-line jira/import/file-extension-required
    (parcelRequire("6IW6J")).then((module)=>module.BoardConfigSwitcher), {
    moduleId: "./src/packages/router-routes/software-classic-board-settings-switcher/src/index.tsx"
});
const $e883f9c67c51e865$export$4ceb6cf2934825b2 = (props)=>{
    const { route: route, query: query, match: match } = props;
    const basePageId = route && route.name || 'rapid-board';
    const chartParam = query.chart ? `-${query.chart}` : '';
    const boardId = query.rapidView ?? match.params.boardId;
    const pageId = `${basePageId}-${boardId}${chartParam}`;
    if ([
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e883f9c67c51e865$export$2164de18d39af313,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-backlog-embed'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e883f9c67c51e865$export$bcc6315cf211edab,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board',
        'rapidboard-backlog-embed'
    ].includes(route.name) && query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e883f9c67c51e865$export$a1c59527bd5131cc,
        pageId: pageId,
        shouldShowSpinner: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e883f9c67c51e865$export$9de09057ba255cc4,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
$e883f9c67c51e865$export$4ceb6cf2934825b2.displayName = "RapidBoardSpaPage";

const $e883f9c67c51e865$export$9de09057ba255cc4 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("14H9H")), {
    moduleId: "./src/packages/spa-apps/rapid-board/src/RapidBoardWithHistory.tsx"
});

const $e883f9c67c51e865$export$bcb5bb6438a46dcb = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("eKqgA")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/RapidBoardWrmBundleResourceType.tsx"
});

const $e883f9c67c51e865$export$d4640ceb9bdd4b4 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("d0KZV")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/RapidBoardDataApiType.tsx"
});

const $e883f9c67c51e865$export$c96c36c0cbfb2c16 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("O0B5Y")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/RapidBoardConfigApiType.tsx"
});

const $e883f9c67c51e865$export$2ad64ed8eb98d9e = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("k0Mx1")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/RapidBoardResourceType.tsx"
});

const $e883f9c67c51e865$export$4a8825f3e310b97 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("8yrn4")), {
    moduleId: "./src/packages/software/entry-rapid-board-wrm-apps/src/startApps.tsx"
});

});
parcelRegister("20xiv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("e0E7B")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ajepf")
]).then(()=>parcelRequire('6AzUs'));

});

parcelRegister("6IW6J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("k4xtp")
]).then(()=>parcelRequire('gkOLZ'));

});

parcelRegister("14H9H", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jhzSd").then(()=>parcelRequire('91gyG'));

});

parcelRegister("O0B5Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g1VIH").then(()=>parcelRequire('9SCzG'));

});

parcelRegister("8yrn4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kKiIM").then(()=>parcelRequire('hQT3K'));

});


parcelRegister("8lVqS", function(module, exports) {
$parcel$export(module.exports, "classicBoardCapability", () => $872c0a8437a2ab78$export$a6d9a03b76d2193b);

const $872c0a8437a2ab78$export$a6d9a03b76d2193b = !false ? (0, $0ce01f968965dadd$export$664edf77d4c76110) : (0, $0ce01f968965dadd$export$fc5f182fc9019b1c);

});


parcelRegister("1zdWe", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardRouteEntry", () => $bd90fe427afa46e4$export$f2cd114cf8ab53aa);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 
var $51vnM = parcelRequire("51vnM");

var $fPgZd = parcelRequire("fPgZd");

var $jFwZ0 = parcelRequire("jFwZ0");



var $cLdvY = parcelRequire("cLdvY");

var $4TFaG = parcelRequire("4TFaG");

var $hRSPo = parcelRequire("hRSPo");

var $5adCU = parcelRequire("5adCU");

var $2sB0d = parcelRequire("2sB0d");

var $l1vE2 = parcelRequire("l1vE2");

var $41FAq = parcelRequire("41FAq");

var $jEYuY = parcelRequire("jEYuY");

var $3HYSN = parcelRequire("3HYSN");

var $i860n = parcelRequire("i860n");

var $dvtoW = parcelRequire("dvtoW");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $iEE0R = parcelRequire("iEE0R");

var $edf7u = parcelRequire("edf7u");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");

var $88dL9 = parcelRequire("88dL9");

var $h3aGH = parcelRequire("h3aGH");

var $eAaRp = parcelRequire("eAaRp");

var $fMHoz = parcelRequire("fMHoz");

var $2bC10 = parcelRequire("2bC10");

var $75Njg = parcelRequire("75Njg");

var $gZWlI = parcelRequire("gZWlI");

var $2700E = parcelRequire("2700E");

var $8lVqS = parcelRequire("8lVqS");

var $eFNzz = parcelRequire("eFNzz");
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the board that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for board data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $bd90fe427afa46e4$var$getLayout = ()=>{
    let viewMode = 'DEFAULT';
    if ((0, $fMHoz.isLocalStorageAvailable)()) viewMode = (0, $fPgZd.getViewModeFromLocalStorage)();
    return (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.pageLoadIssuePreloadLayoutBuilder)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ], viewMode));
};
const $bd90fe427afa46e4$var$isColoredLabelsMilestone2ExperimentEnabled = ()=>{
    return (0, $2700E.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) !== false;
};
const $bd90fe427afa46e4$var$getBoardEntryPoint = ()=>{
    if ((0, $i860n.fg)('navx-global-side-nav')) return 0, $eFNzz.GSNClassicBoardPageEntryPoint;
    return 0, $eFNzz.classicBoardPageEntryPoint;
};
const $bd90fe427afa46e4$export$f2cd114cf8ab53aa = (0, $fdS54.createEntry)((0, $h3aGH.classicSoftwareBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $2bC10.ClassicBoardSkeleton),
        layout: $bd90fe427afa46e4$var$getLayout(),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            ...(0, $ldGfw.getIssueViewResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $5adCU.shouldLoadUIFBoardResources)() || (0, $i860n.fg)('enable_ssr_for_cmp_board'), (0, $2DCyG.uifBoardResource)),
            (0, $2DCyG.boardViewSettingsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('board_ssr_missing_element_fix'), (0, $jFwZ0.currentUserResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $5adCU.shouldLoadUIFBoardResources)() && ((0, $i860n.fg)('aem_rr_classic_board') ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-next-best-task') : !(0, $l1vE2.isFedRamp)()), (0, $iEE0R.nextBestTaskFeatureResource)),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)(),
            (0, $hFYSn.forgeBoardModuleResource),
            (0, $gZWlI.projectThemeResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource)),
            (0, $8HUuJ.resourceWithCondition)($bd90fe427afa46e4$var$isColoredLabelsMilestone2ExperimentEnabled, (0, $2sB0d.coloredLabelsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('assign-agents-inline_m2_technical'), (0, $88dL9.boardViewAgentDataResource))
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eAaRp.UIFBoardSpa)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        meta: {
            capability: (0, $8lVqS.classicBoardCapability)
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'backlog-and-board',
            manifestName: 'jira-spa-software-board.json'
        },
        entryPoint: ()=>$bd90fe427afa46e4$var$getBoardEntryPoint(),
        entryPointOptions: {
            isSSRPlaceholderEnabled: true
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        isHydrateRootEnabled: (0, $i860n.fg)('cmp-board-hydrate-root'),
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-boards'),
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("fPgZd", function(module, exports) {
$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $a7270683fa838654$export$cae7c4c591dcc261);

var $dlc9a = parcelRequire("dlc9a");
const $a7270683fa838654$export$cae7c4c591dcc261 = ()=>{
    if (false) return 'DEFAULT';
    return (0, $dlc9a.localStorage).get((0, $dlc9a.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};

});
parcelRegister("dlc9a", function(module, exports) {
$parcel$export(module.exports, "LOG_LOCATION", () => $8dddfe3b925927f1$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $8dddfe3b925927f1$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $8dddfe3b925927f1$export$a13f7f627010bccd);

var $iXN50 = parcelRequire("iXN50");
const $8dddfe3b925927f1$export$25a759e49d5049db = 'issue.issue-context-service';
const $8dddfe3b925927f1$export$c2ed3351cac403d1 = (0, $iXN50.createLocalStorageProvider)('jira_issue_view');
const $8dddfe3b925927f1$export$a13f7f627010bccd = 'view-mode';

});


parcelRegister("2sB0d", function(module, exports) {
$parcel$export(module.exports, "coloredLabelsResource", () => $be299fffae93e2df$export$f0ad3e030e2810cd);

var $hFtK7 = parcelRequire("hFtK7");

var $cBtZ5 = parcelRequire("cBtZ5");

var $htsFl = parcelRequire("htsFl");
const $be299fffae93e2df$var$RESOURCE_TYPE_COLORED_LABELS_RELAY = 'COLORED_LABELS_RELAY';
const $be299fffae93e2df$export$f0ad3e030e2810cd = (0, $htsFl.createRelayResource)({
    type: $be299fffae93e2df$var$RESOURCE_TYPE_COLORED_LABELS_RELAY,
    getQuery: ({ query: query, match: match }, { tenantContext: tenantContext })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        let boardAriId = null;
        try {
            boardAriId = boardId ? `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}` : '';
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'getBoardAriId',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            parameters: (0, $cBtZ5.default),
            variables: {
                boardId: boardAriId || ''
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    },
    isBrowserOnly: true
});

});
parcelRegister("cBtZ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b15cccfce1aa9eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9a30b51b06a9b1ed7110b8860f1ae429>>
 * @relayHash bc2c53da31cb744f70bf8e3145461307
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9b81e112dc7620056e8e86e459ab69d40d9c20dd322dc97c22d3dcd8be160ec
const $0b15cccfce1aa9eb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "colorKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ColoredLabelsUpdaterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "labelsInBoard",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraLabelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabel",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ColoredLabelsUpdaterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "labelsInBoard",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraLabelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabel",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9b81e112dc7620056e8e86e459ab69d40d9c20dd322dc97c22d3dcd8be160ec",
            "metadata": {},
            "name": "ColoredLabelsUpdaterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0b15cccfce1aa9eb$var$node.hash = "2867d5ac097c77c4038ccee242c19efe";
var $0b15cccfce1aa9eb$export$2e2bcd8739ae039 = $0b15cccfce1aa9eb$var$node;

});


parcelRegister("88dL9", function(module, exports) {
$parcel$export(module.exports, "boardViewAgentDataResource", () => $80138063c9a8de6e$export$9195013409a739);

var $7edbf = parcelRequire("7edbf");

const $80138063c9a8de6e$export$9195013409a739 = (0, $7edbf.createResource)({
    type: 'BOARD_VIEW_AGENT_DATA',
    getKey: ({ match: match })=>match.params.projectKey ?? '',
    getDataLoader: ()=>(parcelRequire("iQmWK")),
    maxAge: 300000
});

});
parcelRegister("iQmWK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("heyHO").then(()=>parcelRequire('49WQW'));

});


parcelRegister("h3aGH", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $51f4fc99f9ab16bc$export$131d51ca54849e97);
const $51f4fc99f9ab16bc$export$131d51ca54849e97 = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("2bC10", function(module, exports) {
$parcel$export(module.exports, "ClassicBoardSkeleton", () => $4209afd43a728aa9$export$631611c5fdf027d5);
/* ClassicBoardSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $gTDbt = parcelRequire("gTDbt");
const $4209afd43a728aa9$var$customCssStyles = null;
const $4209afd43a728aa9$export$631611c5fdf027d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gTDbt))),
        className: (0, $4jQY2.default)([
            "_2zz1idpf"
        ])
    });
$4209afd43a728aa9$export$631611c5fdf027d5.displayName = "ClassicBoardSkeleton";

});
parcelRegister("gTDbt", function(module, exports) {
module.exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();

});


parcelRegister("eFNzz", function(module, exports) {
$parcel$export(module.exports, "classicBoardPageEntryPoint", () => $c05024b5766ea2ab$export$b7ca8af848cd7993);
$parcel$export(module.exports, "GSNClassicBoardPageEntryPoint", () => $c05024b5766ea2ab$export$4ceaa5b90ebe6d0b);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $aEPLp = parcelRequire("aEPLp");

var $dTa0V = parcelRequire("dTa0V");

var $9BxTS = parcelRequire("9BxTS");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $3KSG6 = parcelRequire("3KSG6");

var $eDEQ5 = parcelRequire("eDEQ5");
const $c05024b5766ea2ab$export$b7ca8af848cd7993 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $aEPLp.nextGenBoardEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $c05024b5766ea2ab$export$4ceaa5b90ebe6d0b = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $aEPLp.nextGenBoardEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("aEPLp", function(module, exports) {
$parcel$export(module.exports, "nextGenBoardEntryPoint", () => $54ecd0446d21eaed$export$bb3c6f02a735f848);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $54ecd0446d21eaed$export$bb3c6f02a735f848 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("20xiv")), {
        moduleId: "ee1346de",
        moduleName: "BoardSPAApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});



parcelRegister("jdODC", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry", () => $1c24f412e6b80f61$export$9bcdab5e8a786007);

var $9KM7q = parcelRequire("9KM7q");

var $51vnM = parcelRequire("51vnM");


var $4TFaG = parcelRequire("4TFaG");

var $5adCU = parcelRequire("5adCU");

var $jEYuY = parcelRequire("jEYuY");


var $3HYSN = parcelRequire("3HYSN");

var $dvtoW = parcelRequire("dvtoW");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $bsOhQ = parcelRequire("bsOhQ");

var $eAaRp = parcelRequire("eAaRp");

var $8PWi1 = parcelRequire("8PWi1");

var $75Njg = parcelRequire("75Njg");

var $eGCEh = parcelRequire("eGCEh");
const $1c24f412e6b80f61$export$9bcdab5e8a786007 = (0, $fdS54.createEntry)((0, $bsOhQ.classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-backlog-insights',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eGCEh.InsightsSettingsRedirect),
        skeleton: (0, $8PWi1.NextGenBacklogSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $9KM7q.issueHierarchyPageResource),
            (0, $4TFaG.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eAaRp.LazyRapidBoard),
            (0, $eAaRp.LazyRapidBoardApps),
            (0, $eAaRp.LazyRapidBoardDataApiResource),
            (0, $eAaRp.LazyRapidBoardConfigApiResource),
            (0, $eAaRp.LazyRapidBoardWrmBundleResource),
            (0, $eAaRp.LazyRapidBoardResource)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9KM7q", function(module, exports) {
$parcel$export(module.exports, "issueHierarchyPageResource", () => $548b83b5674198ff$export$98d50a2e19509817);

var $htsFl = parcelRequire("htsFl");

var $hDfVL = parcelRequire("hDfVL");
const $548b83b5674198ff$export$98d50a2e19509817 = (0, $htsFl.createRelayResource)({
    type: 'RESOURCE1',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $hDfVL.default),
            variables: {
                cloudId: tenantContext.cloudId
            }
        })
});

});
parcelRegister("hDfVL", function(module, exports) {
$parcel$export(module.exports, "default", () => $96a5e3d19fb6968d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<432d84d8656c5dcc8e15a80175f30075>>
 * @relayHash a7fc4e9c382896a4769627413accc3ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9a641f91a8624f90047b210e0dc40067db21c90ddcca76f463db856927c1088
const $96a5e3d19fb6968d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "level"
    }, v4 = [
        {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchyLevel",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "cmpIssueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v5 = {
        "concreteType": "JiraHierarchyConfigError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "code"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v6 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyConfigurationQuery",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": v4 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "success"
            },
            v5 /*: any*/ 
        ]
    }, v7 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyLimits",
        "kind": "LinkedField",
        "name": "issueHierarchyLimits",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "maxLevels"
            },
            {
                "kind": "ScalarField",
                "name": "nameLength"
            }
        ]
    }, v8 = {
        "args": v1 /*: any*/ ,
        "kind": "ScalarField",
        "name": "lockedIssueTypeIds"
    }, v9 = {
        "concreteType": "JiraIssueHierarchyConfigData",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": true,
        "selections": v4 /*: any*/ 
    }, v10 = {
        "concreteType": "JiraLongRunningTaskProgress",
        "kind": "LinkedField",
        "name": "taskProgress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "progress"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueHierarchyViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SaveButtonSaveButton"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SaveDialog"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueHierarchyViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9a641f91a8624f90047b210e0dc40067db21c90ddcca76f463db856927c1088",
            "metadata": {},
            "name": "IssueHierarchyViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96a5e3d19fb6968d$var$node.hash = "01d8ce6b2a99e8bb6f021090db170c86";
var $96a5e3d19fb6968d$export$2e2bcd8739ae039 = $96a5e3d19fb6968d$var$node;

});


parcelRegister("7tgMD", function(module, exports) {
$parcel$export(module.exports, "horizontalNavJiraResource", () => $362d155fbc7f6957$export$faeb8c89315e20da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $kK0Kk = parcelRequire("kK0Kk");

var $htsFl = parcelRequire("htsFl");

var $i8BNs = parcelRequire("i8BNs");

var $c4rhk = parcelRequire("c4rhk");
const $362d155fbc7f6957$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;
const $362d155fbc7f6957$export$71eec30d9db46a56 = (// oxlint-disable-next-line typescript/no-explicit-any
{ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $i8BNs.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    const containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    // mostRecentlyViewedBoard is only ever rendered as a fallback for company-managed (CMP) software
    // project routes that don't have a board in the URL (the nav header discards it for TMP and
    // whenever a board ARI is known). CMP routes carry a /software/c/ segment in the URL, while TMP
    // routes use /software/projects/; only the CMP board view loses its /c prefix during URL
    // harmonization, and that route always has a board id, so it is still skipped.
    // We only request mostRecentlyViewedBoard for boardless CMP routes.
    const isCMPRoute = match.url.includes('/software/c/');
    const skipMostRecentlyViewedBoard = !(isCMPRoute && !boardAri);
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $kK0Kk.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            skipMostRecentlyViewedBoard: skipMostRecentlyViewedBoard,
            first: $362d155fbc7f6957$var$NAVIGATION_ITEMS_PAGE_SIZE
        }
    };
};
const $362d155fbc7f6957$var$horizontalNavJiraResourceActual = (0, $c4rhk.withGiraAggAnonSsrFix)((0, $htsFl.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $362d155fbc7f6957$export$71eec30d9db46a56
}));
const $362d155fbc7f6957$export$faeb8c89315e20da = $362d155fbc7f6957$var$horizontalNavJiraResourceActual;

});
parcelRegister("kK0Kk", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2529c1a6d2ac242$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c326c561e7ff187ffc8354dbe9f94d0>>
 * @relayHash b57c48ee67fc7fc806b3d889d553fe39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d0b03389d85488f872453c2223e10b48ec857d5a78c74e25a9b466b0043f30b6

var $6GEqs = parcelRequire("6GEqs");

var $d3CRd = parcelRequire("d3CRd");

var $lIGkE = parcelRequire("lIGkE");
const $a2529c1a6d2ac242$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipMostRecentlyViewedBoard"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": "scopedUrl",
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                v19 /*: any*/ ,
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                {
                                    "condition": "skipMostRecentlyViewedBoard",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d0b03389d85488f872453c2223e10b48ec857d5a78c74e25a9b466b0043f30b6",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $d3CRd.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": (0, $6GEqs.default)
            }
        }
    };
}();
$a2529c1a6d2ac242$var$node.hash = "2957badc2547b41d4e2a670b8b1400f4";
(0, $lIGkE.PreloadableQueryRegistry).set($a2529c1a6d2ac242$var$node.params.id, $a2529c1a6d2ac242$var$node);
var $a2529c1a6d2ac242$export$2e2bcd8739ae039 = $a2529c1a6d2ac242$var$node;

});


parcelRegister("bsOhQ", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute", () => $020bc93e9e557b35$export$e43f33a0c1ae830c);
const $020bc93e9e557b35$export$e43f33a0c1ae830c = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
    query: [
        'config=insightsConfig'
    ]
};

});

parcelRegister("eGCEh", function(module, exports) {
$parcel$export(module.exports, "InsightsSettingsRedirect", () => $435fdbff5b49a6d5$export$f7bc2c5799e41684);
/* eslint-disable jira/naming/disallow-filenames */ 
var $90cGC = parcelRequire("90cGC");

var $2ffUK = parcelRequire("2ffUK");
const $435fdbff5b49a6d5$export$f7bc2c5799e41684 = ()=>{
    const { setSelectedConfigTab: setSelectedConfigTab } = (0, $90cGC.useSelectedConfigTab)();
    const [, setConfigParam] = (0, $2ffUK.useQueryParam)('config');
    setSelectedConfigTab('filter');
    setConfigParam('filter');
    return null;
};
$435fdbff5b49a6d5$export$f7bc2c5799e41684.displayName = "InsightsSettingsRedirect";

});
parcelRegister("90cGC", function(module, exports) {
$parcel$export(module.exports, "useSelectedConfigTab", () => $fa270b3f7c50c4d2$export$9b386f1a3e61b385);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");
const $fa270b3f7c50c4d2$export$9b386f1a3e61b385 = ()=>{
    const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
    const getSelectedConfigTab = ()=>{
        if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return (0, $4fPPi.AtlBrowserStorageLocal).getItem(SELECTED_CONFIG_TAB_KEY) || '';
        // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
        return localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
    };
    const setSelectedConfigTab = (newConfigTab)=>{
        if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) // @browser-storage setter
        (0, $4fPPi.AtlBrowserStorageLocal).setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
        else // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
        localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
    };
    return {
        getSelectedConfigTab: getSelectedConfigTab,
        setSelectedConfigTab: setSelectedConfigTab
    };
};

});



parcelRegister("eYoel", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry", () => $8cf2588ca5164f9a$export$d4cb7b5fe9faae5e);

var $9KM7q = parcelRequire("9KM7q");

var $51vnM = parcelRequire("51vnM");


var $4TFaG = parcelRequire("4TFaG");

var $5adCU = parcelRequire("5adCU");

var $jEYuY = parcelRequire("jEYuY");


var $3HYSN = parcelRequire("3HYSN");

var $dvtoW = parcelRequire("dvtoW");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $gbI93 = parcelRequire("gbI93");

var $eAaRp = parcelRequire("eAaRp");

var $2bC10 = parcelRequire("2bC10");

var $75Njg = parcelRequire("75Njg");

var $eGCEh = parcelRequire("eGCEh");
const $8cf2588ca5164f9a$export$d4cb7b5fe9faae5e = (0, $fdS54.createEntry)((0, $gbI93.classicSoftwareBoardSettingsInsightsRapidboardBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-board-insights',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eGCEh.InsightsSettingsRedirect),
        skeleton: (0, $2bC10.ClassicBoardSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $9KM7q.issueHierarchyPageResource),
            (0, $4TFaG.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eAaRp.LazyRapidBoard),
            (0, $eAaRp.LazyRapidBoardApps),
            (0, $eAaRp.LazyRapidBoardDataApiResource),
            (0, $eAaRp.LazyRapidBoardConfigApiResource),
            (0, $eAaRp.LazyRapidBoardWrmBundleResource),
            (0, $eAaRp.LazyRapidBoardResource)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gbI93", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRoute", () => $d424b19e491e1b7c$export$8c2f936709b987ac);
const $d424b19e491e1b7c$export$8c2f936709b987ac = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    query: [
        'config=insightsConfig'
    ]
};

});


parcelRegister("llrpu", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsRouteEntry", () => $acbba0b98688c4bc$export$4e7891e9bba3f679);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 


var $5adCU = parcelRequire("5adCU");

var $4TFaG = parcelRequire("4TFaG");

var $hRSPo = parcelRequire("hRSPo");

var $l1vE2 = parcelRequire("l1vE2");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $2bC10 = parcelRequire("2bC10");

var $i9OtS = parcelRequire("i9OtS");

var $dvtoW = parcelRequire("dvtoW");

var $edf7u = parcelRequire("edf7u");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $8HUuJ = parcelRequire("8HUuJ");

var $2DCyG = parcelRequire("2DCyG");

var $iEE0R = parcelRequire("iEE0R");


var $i860n = parcelRequire("i860n");

var $hO1Vg = parcelRequire("hO1Vg");
const $acbba0b98688c4bc$export$4e7891e9bba3f679 = (0, $fdS54.createEntry)((0, $i9OtS.classicSoftwareBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $2bC10.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? (0, $hO1Vg.GSNBoardSettingsPageEntryPoint) : (0, $hO1Vg.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $98344e6aff454659$export$c97893643d53b8ab)
        },
        layout: (0, $dvtoW.genericProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $8HUuJ.resourceWithCondition)((0, $5adCU.shouldLoadUIFBoardResources), (0, $2DCyG.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $5adCU.shouldLoadUIFBoardResources)() && ((0, $i860n.fg)('aem_rr_classic_board_settings') ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-next-best-task') : !(0, $l1vE2.isFedRamp)()), (0, $iEE0R.nextBestTaskFeatureResource)),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)(),
            (0, $hFYSn.forgeBoardModuleResource)
        ],
        meta: {
            // Inline this statement instead of creating a (circular) dependency by importing
            // { classicBoardCapability } from '@jira/router-routes__software-classic-board-entries/src/common/constants.tsx';
            capability: !false ? (0, $0ce01f968965dadd$export$664edf77d4c76110) : (0, $0ce01f968965dadd$export$fc5f182fc9019b1c)
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $98344e6aff454659$export$c97893643d53b8ab = 'BOARD_SETTINGS';

parcelRegister("i9OtS", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsRoute", () => $aabef7bbb35d3c88$export$c055a8844d0d2f5e);
const $aabef7bbb35d3c88$export$c055a8844d0d2f5e = {
    name: 'rapidboard-board-settings',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});

parcelRegister("hO1Vg", function(module, exports) {
$parcel$export(module.exports, "boardSettingsPageEntryPoint", () => $d69eec2f7292e318$export$e92abb48a4e0c94d);
$parcel$export(module.exports, "GSNBoardSettingsPageEntryPoint", () => $d69eec2f7292e318$export$9ef22b762b398e8e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $dTa0V = parcelRequire("dTa0V");

var $6CXxv = parcelRequire("6CXxv");

var $de4tM = parcelRequire("de4tM");

var $9pZp8 = parcelRequire("9pZp8");
const $d69eec2f7292e318$export$e92abb48a4e0c94d = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9pZp8.classicBoardSettingsEntryPoint),
    leftSidebar: {
        sidebar: (0, $6CXxv.nav4SidebarSettingsBoardEntryPoint)
    }
});
const $d69eec2f7292e318$export$9ef22b762b398e8e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9pZp8.classicBoardSettingsEntryPoint),
    leftSidebar: {
        sidebar: (0, $de4tM.gsnSidebarSettingsBoardEntryPoint)
    }
});

});
parcelRegister("6CXxv", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarSettingsBoardEntryPoint", () => $dab3ca7c0cd0a0f1$export$f4cb88eb97cbdc30);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $dab3ca7c0cd0a0f1$export$f4cb88eb97cbdc30 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hTdlD")), {
        moduleId: "0b7e7228",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps () {
        return {};
    }
});

});
parcelRegister("hTdlD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Ebdo").then(()=>parcelRequire('PpRz1'));

});


parcelRegister("de4tM", function(module, exports) {
$parcel$export(module.exports, "gsnSidebarSettingsBoardEntryPoint", () => $69753de3c2da98e3$export$9beb7890ffe9ccde);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $18sMq = parcelRequire("18sMq");

var $2NSbF = parcelRequire("2NSbF");

var $fDVI0 = parcelRequire("fDVI0");

var $bZhC2 = parcelRequire("bZhC2");

var $i860n = parcelRequire("i860n");

var $c1zHX = parcelRequire("c1zHX");

const $69753de3c2da98e3$export$9beb7890ffe9ccde = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2RFsW")), {
        moduleId: "d96cfeaa",
        moduleName: "BoardSettingsSidebarEntrypoint",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps (params) {
        /**
		 * IMPORTANT: The query variables should be the same as in other queries, in order to avoid multiple
		 *   network requests.
		 */ const { tenantContext: { activationId: activationId, atlassianAccountId: atlassianAccountId, cloudId: cloudId }, entryPoints: entryPoints = {} } = params;
        const entityAriUserSideNavSettings = (0, $fDVI0.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        const navPlatMenuDataEntityAri = (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            siteId: cloudId,
            settingId: 'nav-plat-l1-menu-data'
        }).toString();
        const navPlatSidebarDataEntityAri = (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            siteId: cloudId,
            settingId: 'nav-plat-sidebar-data'
        }).toString();
        function entityAri(scope) {
            return (0, $bZhC2.JiraNavigationSettingsAri).create({
                siteId: cloudId,
                activationId: activationId,
                navigationSettingScope: scope
            }).toString();
        }
        const ownerAri = atlassianAccountId && (0, $2NSbF.IdentityUserAri).create({
            userId: atlassianAccountId
        }).toString();
        return {
            // Queries your async component uses
            queries: {
                gsnSidebarContent: {
                    // generated .graphql
                    parameters: (0, $c1zHX.default),
                    // variables for your query
                    variables: {
                        cloudId: cloudId,
                        entityAriApps: entityAri('apps'),
                        entityAriFilters: entityAri('filters'),
                        entityAriPlans: entityAri('plans'),
                        ...(0, $i860n.fg)('jpd-enable-roadmaps-recents-fe') ? {
                            entityAriRoadmaps: entityAri('collections')
                        } : {},
                        entityAriUserSideNavSettings: entityAriUserSideNavSettings,
                        isAppsExpanded: false,
                        isFiltersExpanded: false,
                        isPlansExpanded: false,
                        isProjectsExpanded: false,
                        isOperationsExpanded: false,
                        navPlatMenuDataEntityAri: navPlatMenuDataEntityAri,
                        navPlatSidebarDataEntityAri: navPlatSidebarDataEntityAri,
                        ownerAri: ownerAri,
                        isRoadmapUpsellEnabled: (0, $i860n.fg)('jpd-roadmaps-in-jira'),
                        fetchGlobalShortcutsAvailableProducts: Boolean(cloudId && ownerAri && (0, $i860n.fg)('navx-4515-jira-gsn-gas-ssr'))
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            entryPoints: entryPoints
        };
    }
});

});
parcelRegister("2RFsW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("fNM8W")
]).then(()=>parcelRequire('lhprO'));

});


parcelRegister("9pZp8", function(module, exports) {
$parcel$export(module.exports, "classicBoardSettingsEntryPoint", () => $e2c4d6adb10de5a2$export$fd11e3f2f113ef67);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $e2c4d6adb10de5a2$export$fd11e3f2f113ef67 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hUAQN")), {
        moduleId: "5cbc83c6",
        moduleName: "BoardSettingsSwitcher",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("hUAQN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iHIyi")
]).then(()=>parcelRequire('8NXyS'));

});




parcelRegister("fv3de", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareTimelineCustomEmbedRouteEntry", () => $bac7febb93c514b1$export$c40e611ec47e058a);

var $iFBvi = parcelRequire("iFBvi");

var $iSoIx = parcelRequire("iSoIx");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dECzl = parcelRequire("dECzl");

var $edf7u = parcelRequire("edf7u");

var $9T5Cr = parcelRequire("9T5Cr");

var $9EWfZ = parcelRequire("9EWfZ");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $8HUuJ = parcelRequire("8HUuJ");
const $bac7febb93c514b1$var$classicSoftwareTimelineCustomEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $iFBvi.softwareTimelineEmbedEntrypoint)
});
const $bac7febb93c514b1$export$c40e611ec47e058a = (0, $fdS54.createEntry)((0, $dECzl.classicSoftwareTimelineCustomEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-software-timeline-embed-view',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: [
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira_software_timeline_perf_improvements'), (0, $9T5Cr.fieldsResource))
        ],
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jira_harmonised_software_timeline_embed') && (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? $bac7febb93c514b1$var$classicSoftwareTimelineCustomEmbedPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        supportsProjectTheme: 'full'
    }));

});
parcelRegister("iFBvi", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineEmbedEntrypoint", () => $a62d31ebb10ad123$export$aa630f56048d0af3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $2700E = parcelRequire("2700E");

var $kIYP9 = parcelRequire("kIYP9");

var $lh6D1 = parcelRequire("lh6D1");

var $6nh3o = parcelRequire("6nh3o");

var $71h0a = parcelRequire("71h0a");

var $TZd32 = parcelRequire("TZd32");
const $a62d31ebb10ad123$var$NAMESPACE = 'TIMELINE';
const $a62d31ebb10ad123$var$TOGGLEABLE_FIELD_SET_IDS = [
    'assignee',
    'status'
];
/**
 * The window used to filter sprints shown on the timeline: from one year before
 * the current date to two years after it. Bounds are ISO date-time strings
 * matching the `JiraDateTimeWindow` input.
 */ const $a62d31ebb10ad123$var$getSprintsActiveWithin = ()=>{
    const now = new Date();
    const start = new Date(now);
    start.setFullYear(start.getFullYear() - 1);
    const end = new Date(now);
    end.setFullYear(end.getFullYear() + 2);
    return {
        start: start.toISOString(),
        end: end.toISOString()
    };
};

const $a62d31ebb10ad123$export$aa630f56048d0af3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("bm3o6")), {
        moduleId: "3b0cfef4",
        moduleName: "JiraSoftwareHarmonisedTimelineEmbed",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointParams)=>{
        const { context: { match: match, route: route }, tenantContext: { cloudId: cloudId } } = entryPointParams;
        const { projectKey: rawProjectKey, boardId: boardId, viewId: viewId } = match.params;
        const projectKey = rawProjectKey ?? '';
        const sourceARI = (0, $6nh3o.JiraSoftwareBoardAri).create({
            siteId: cloudId,
            boardId: String(boardId)
        }).toString();
        const isCMP = route.name === 'classic-software-timeline-embed';
        const issueSearchInput = {
            customInput: {
                jiraTimelineInput: {
                    boardId: String(boardId),
                    useSavedFilters: true
                }
            }
        };
        const today = Date.now();
        const itemId = (0, $2700E.expValEquals)('jira_sw_timeline_saved_views', 'isEnabled', true, false) ? `timeline${viewId ? `/${viewId}` : ''}` : 'timeline';
        const jiraViewQueryInput = {
            boardIdAndItemQuery: {
                cloudId: cloudId,
                itemId: itemId,
                boardId: Number(boardId)
            }
        };
        const filterRefinementScope = {
            backlog: {
                boardId: Number(boardId)
            }
        };
        return {
            extraProps: {
                today: today,
                isTimelineHarmonisationM2Enabled: (0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false),
                isTimelineGroupByEnabled: false,
                isBulkOperationsInTimelineEnabled: (0, $2700E.expValEquals)('bulk_operations_in_timeline', 'isEnabled', true, false),
                jqlParam: '',
                ...(0, $i860n.fg)('timeline-filter-refinement-technical-changes') ? {
                    filterRefinementScope: filterRefinementScope,
                    includeBoardFilters: true
                } : {}
            },
            queries: {
                softwareTimelineQuery: {
                    options: {
                        fetchPolicy: (0, $i860n.fg)('jira_software_timeline_perf_improvements') ? 'store-or-network' : 'store-and-network'
                    },
                    parameters: (0, $TZd32.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        boardId: sourceARI,
                        isCMP: isCMP
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $lh6D1.default),
                    variables: {
                        boardIds: [
                            sourceARI
                        ],
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        ...(0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
                            fieldSetIds: undefined,
                            fieldSetsInput: {
                                viewInput: {
                                    namespace: $a62d31ebb10ad123$var$NAMESPACE,
                                    viewId: 'timeline_default'
                                }
                            }
                        } : {
                            fieldSetIds: [],
                            fieldSetsInput: {
                                fieldSetIds: []
                            }
                        },
                        filterId: null,
                        first: 50,
                        issueSearchInput: issueSearchInput,
                        namespace: $a62d31ebb10ad123$var$NAMESPACE,
                        projectKey: projectKey,
                        settings: {
                            groupBy: null,
                            hideDone: false,
                            hierarchyEnabled: true,
                            jql: null
                        },
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: !(0, $i860n.fg)('jsc_list_expand_all'),
                        shouldQueryHasChildrenWithCount: (0, $i860n.fg)('jsc_list_expand_all'),
                        shouldQueryHasParent: (0, $i860n.fg)('jira_harmonised_timeline_hierarchy_flyout'),
                        scope: (0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
                            operationScope: 'TIMELINE_PROJECT',
                            projectKey: projectKey
                        } : undefined,
                        staticViewInput: {
                            isGroupingEnabled: false,
                            isHideDoneEnabled: false,
                            isHierarchyEnabled: true
                        },
                        viewConfigInput: {
                            staticViewInput: {
                                isGroupingEnabled: false,
                                isHideDoneEnabled: false,
                                isHierarchyEnabled: true
                            }
                        },
                        jiraViewQueryInput: jiraViewQueryInput,
                        // jiraViewQueryInputForIssues is temporary and is used to replace jiraViewQueryInput.
                        // It will be removed when jira_timeline_saved_view_technical is cleaned up.
                        // When cleaning up jira_timeline_saved_view_technical, replace this with jiraViewQueryInput.
                        // Keep this consistent with the business project.
                        jiraViewQueryInputForIssues: (0, $2700E.expValEquals)('jira_sw_timeline_saved_views', 'isEnabled', true, false) ? jiraViewQueryInput : null,
                        timelineViewSettings: {},
                        timelineStaticViewInput: {},
                        viewId: 'timeline_default',
                        ...(0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
                            toggleableFieldSetIds: $a62d31ebb10ad123$var$TOGGLEABLE_FIELD_SET_IDS,
                            isInlineEditingEnabled: true,
                            isTimelineHarmonisationM2Enabled: true
                        } : {
                            isTimelineHarmonisationM2Enabled: false,
                            isInlineEditingEnabled: false
                        },
                        shouldQuerySprints: true,
                        sprintsActiveWithin: $a62d31ebb10ad123$var$getSprintsActiveWithin(),
                        shouldQuerySoftwareProjectSettings: true,
                        shouldQueryLastAppliedFilters: true,
                        shouldQueryReleases: true,
                        shouldQueryBarColor: true,
                        isTimelineGroupByEnabled: false,
                        projectOrBoardInput: {
                            boardId: Number(boardId)
                        }
                    }
                },
                filterRefinementQuery: {
                    options: {
                        fetchPolicy: (0, $i860n.fg)('jira_software_timeline_perf_improvements') ? 'store-or-network' : 'store-and-network'
                    },
                    parameters: (0, $71h0a.default),
                    variables: {
                        cloudId: cloudId,
                        filterRefinementScope: {
                            backlog: {
                                boardId: Number(boardId)
                            }
                        },
                        boardId: sourceARI,
                        includeBoard: true
                    }
                }
            },
            ...(0, $i860n.fg)('jira_software_timeline_perf_improvements') ? {
                entryPoints: {
                    nativeIssueTableEntryPoint: {
                        entryPoint: (0, $kIYP9.nativeIssueTableEntryPoint),
                        entryPointParams: entryPointParams
                    }
                }
            } : {}
        };
    }
});

});
parcelRegister("kIYP9", function(module, exports) {
$parcel$export(module.exports, "nativeIssueTableEntryPoint", () => $d1c6b91b595cdeb0$export$df35b18d762f614);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $fiVog = parcelRequire("fiVog");

var $b3tU7 = parcelRequire("b3tU7");

const $d1c6b91b595cdeb0$export$df35b18d762f614 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("h8ar4")), {
        moduleId: "05191256",
        moduleName: "NativeIssueTableEntryPoint",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("h8ar4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("cmUqP")
]).then(()=>parcelRequire('8YL3u'));

});


parcelRegister("lh6D1", function(module, exports) {
$parcel$export(module.exports, "default", () => $15c8fef5efb69308$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8fda9aa28e1cfcac1d9d1509dfcc14d>>
 * @relayHash 552c82da6cc3c6f95df4e02a69a32c38
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID afeb36197d2f6dd3175a8b2d02aad829dd76dcb3e11fb2ddda84ac94a8f73af8

var $i69Qm = parcelRequire("i69Qm");

var $eP1tz = parcelRequire("eP1tz");

var $1D6fx = parcelRequire("1D6fx");

var $KUiqF = parcelRequire("KUiqF");

var $efrbL = parcelRequire("efrbL");

var $aczA0 = parcelRequire("aczA0");

var $7yObX = parcelRequire("7yObX");

var $hOoOT = parcelRequire("hOoOT");

var $bLaif = parcelRequire("bLaif");

var $2ATDk = parcelRequire("2ATDk");

var $lWQZ4 = parcelRequire("lWQZ4");

var $dJcmz = parcelRequire("dJcmz");

var $5w0An = parcelRequire("5w0An");

var $7e655 = parcelRequire("7e655");

var $dxExZ = parcelRequire("dxExZ");

var $7zUJD = parcelRequire("7zUJD");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $gE0jx = parcelRequire("gE0jx");

var $4OQoB = parcelRequire("4OQoB");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $l4q64 = parcelRequire("l4q64");

var $1ZLvK = parcelRequire("1ZLvK");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $2XkhF = parcelRequire("2XkhF");

var $g3vGh = parcelRequire("g3vGh");

var $6BTmn = parcelRequire("6BTmn");

var $jhYmN = parcelRequire("jhYmN");

var $b3Nht = parcelRequire("b3Nht");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $gWuLf = parcelRequire("gWuLf");

var $5IB1n = parcelRequire("5IB1n");

var $hjvDE = parcelRequire("hjvDE");

var $2JQfe = parcelRequire("2JQfe");

var $cNoBc = parcelRequire("cNoBc");

var $aIZjN = parcelRequire("aIZjN");

var $eoHYr = parcelRequire("eoHYr");

var $1A1H9 = parcelRequire("1A1H9");
const $15c8fef5efb69308$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "afeb36197d2f6dd3175a8b2d02aad829dd76dcb3e11fb2ddda84ac94a8f73af8",
        "metadata": {},
        "name": "JiraTimelineQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiratimelineharmonisationm2relayprovider": (0, $5IB1n.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJqlValidationDecouplingTimelineExperimentRelayProvider": (0, $dxExZ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": (0, $efrbL.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $2XkhF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiratimelineharmonisationm3relayprovider": (0, $hjvDE.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineSavedViewTechnicalRelayprovider": (0, $5w0An.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineIssueSearchErrorBreakdownRelayProvider": (0, $dJcmz.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraSoftwareTimelineHierarchyViewSettingsRelayProvider": (0, $bLaif.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineGroupByRelayprovider": (0, $lWQZ4.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiratimelinebulkoperationsrelayprovider": (0, $gWuLf.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraSprintRollupsRelayprovider": (0, $2ATDk.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrctimelineIncreaseIssueLinksLimitRelayProvider": (0, $eoHYr.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraSoftwareTimelineFastFollowsRelayProvider": (0, $hOoOT.default),
            "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider": (0, $eP1tz.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default),
            "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider": (0, $i69Qm.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider": (0, $4OQoB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsJSCExpandAllChangesEnabledRelayprovider": (0, $aczA0.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $g3vGh.default)
        }
    }
};
var $15c8fef5efb69308$export$2e2bcd8739ae039 = $15c8fef5efb69308$var$node;

});
parcelRegister("i69Qm", function(module, exports) {
$parcel$export(module.exports, "default", () => $538a8ae3713fc59e$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $538a8ae3713fc59e$var$PrivateGoalsInJiraRelayProvider = {
    get () {
        return (0, $i860n.fg)('private_goals_in_jira');
    }
};
var $538a8ae3713fc59e$export$2e2bcd8739ae039 = $538a8ae3713fc59e$var$PrivateGoalsInJiraRelayProvider;

});

parcelRegister("eP1tz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ed87290e6b946f3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $aJDWs = parcelRequire("aJDWs");
const $7ed87290e6b946f3$var$isProjectsInJiraM1RelayProvider = {
    get () {
        return (0, $aJDWs.isProjectsInJiraM1Enabled)();
    }
};
var $7ed87290e6b946f3$export$2e2bcd8739ae039 = $7ed87290e6b946f3$var$isProjectsInJiraM1RelayProvider;

});

parcelRegister("aczA0", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd53cb4dc1a2ad47$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $bd53cb4dc1a2ad47$var$IsJSCExpandAllChangesEnabledRelayprovider = {
    get () {
        return (0, $i860n.fg)('jsc_list_expand_all');
    }
};
var $bd53cb4dc1a2ad47$export$2e2bcd8739ae039 = $bd53cb4dc1a2ad47$var$IsJSCExpandAllChangesEnabledRelayprovider;

});

parcelRegister("hOoOT", function(module, exports) {
$parcel$export(module.exports, "default", () => $195c541805ef996c$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $195c541805ef996c$var$JiraSoftwareTimelineFastFollowsRelayProvider = {
    get () {
        return (0, $2700E.expVal)('jira_software_timeline_fast_follows', 'isEnabled', false);
    }
};
var $195c541805ef996c$export$2e2bcd8739ae039 = $195c541805ef996c$var$JiraSoftwareTimelineFastFollowsRelayProvider;

});

parcelRegister("bLaif", function(module, exports) {
$parcel$export(module.exports, "default", () => $a62cf6c02b30f7ce$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $a62cf6c02b30f7ce$var$JiraSoftwareTimelineHierarchyViewSettingsRelayProvider = {
    get () {
        return (0, $2700E.expVal)('jira_software_timeline_hierarchy_view_settings', 'isEnabled', false);
    }
};
var $a62cf6c02b30f7ce$export$2e2bcd8739ae039 = $a62cf6c02b30f7ce$var$JiraSoftwareTimelineHierarchyViewSettingsRelayProvider;

});

parcelRegister("2ATDk", function(module, exports) {
$parcel$export(module.exports, "default", () => $002660e26bf1b53f$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $002660e26bf1b53f$var$JiraSprintRollupsRelayprovider = {
    get () {
        return (0, $2700E.expVal)('jira_timeline_rollups', 'isEnabled', false);
    }
};
var $002660e26bf1b53f$export$2e2bcd8739ae039 = $002660e26bf1b53f$var$JiraSprintRollupsRelayprovider;

});

parcelRegister("lWQZ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $89fb5d3f646fa846$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $89fb5d3f646fa846$var$JiraTimelineGroupByRelayprovider = {
    get () {
        return (0, $2700E.expVal)('jira_timeline_group_by', 'isEnabled', false);
    }
};
var $89fb5d3f646fa846$export$2e2bcd8739ae039 = $89fb5d3f646fa846$var$JiraTimelineGroupByRelayprovider;

});

parcelRegister("dJcmz", function(module, exports) {
$parcel$export(module.exports, "default", () => $d67af02e56a8db60$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $d67af02e56a8db60$var$JiraTimelineIssueSearchErrorBreakdownRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_timeline_issue_search_error_breakdown');
    }
};
var $d67af02e56a8db60$export$2e2bcd8739ae039 = $d67af02e56a8db60$var$JiraTimelineIssueSearchErrorBreakdownRelayProvider;

});

parcelRegister("5w0An", function(module, exports) {
$parcel$export(module.exports, "default", () => $4078c11cda377617$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $4078c11cda377617$var$JiraTimelineSavedViewTechnicalRelayprovider = {
    get () {
        return (0, $i860n.fg)('jira_timeline_saved_view_technical');
    }
};
var $4078c11cda377617$export$2e2bcd8739ae039 = $4078c11cda377617$var$JiraTimelineSavedViewTechnicalRelayprovider;

});

parcelRegister("dxExZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d256669b5b1e3455$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $d256669b5b1e3455$var$JqlValidationDecouplingTimelineExperimentRelayProvider = {
    get () {
        return (0, $2700E.expVal)('jql_validation_decoupling_timeline_exp', 'isEnabled', false);
    }
};
var $d256669b5b1e3455$export$2e2bcd8739ae039 = $d256669b5b1e3455$var$JqlValidationDecouplingTimelineExperimentRelayProvider;

});

parcelRegister("4OQoB", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d8f70e6377c546a$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $8d8f70e6377c546a$var$additionalFieldsInGroupByProjectHeaderRelayProvider = {
    get () {
        return (0, $2700E.expVal)('additional_fields_in_group_by_project_header_', 'isEnabled', false);
    }
};
var $8d8f70e6377c546a$export$2e2bcd8739ae039 = $8d8f70e6377c546a$var$additionalFieldsInGroupByProjectHeaderRelayProvider;

});

parcelRegister("g3vGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf209630e03f812$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $caf209630e03f812$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("gWuLf", function(module, exports) {
$parcel$export(module.exports, "default", () => $18738e3f974292a8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
var $18738e3f974292a8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $2700E.expVal)('bulk_operations_in_timeline', 'isEnabled', false);
    }
};

});

parcelRegister("5IB1n", function(module, exports) {
$parcel$export(module.exports, "default", () => $c24348a17f29629e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
const $c24348a17f29629e$var$jiraTimelineHarmonisationM2RelayProvider = {
    get () {
        return (0, $2700E.expVal)('timeline_harmonisation_m2', 'isEnabled', false);
    }
};
var $c24348a17f29629e$export$2e2bcd8739ae039 = $c24348a17f29629e$var$jiraTimelineHarmonisationM2RelayProvider;

});

parcelRegister("hjvDE", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc8d26c992a6f09f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $dc8d26c992a6f09f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('timeline_harmonisation_m3_technical');
    }
};

});

parcelRegister("eoHYr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a9a0d4136b32962$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $6a9a0d4136b32962$var$timelineIncreaseIssueLinksLimitRelayProvider = {
    get () {
        return (0, $2700E.expVal)('timeline_increase_issuelinks_limit', 'isEnabled', false) ? 20 : 10;
    }
};
var $6a9a0d4136b32962$export$2e2bcd8739ae039 = $6a9a0d4136b32962$var$timelineIncreaseIssueLinksLimitRelayProvider;

});


parcelRegister("6nh3o", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $01329d655e6a1e83$export$fcd404066e55a7a8);

var $hszWP = parcelRequire("hszWP");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira-software/board/manifest.ts
var $01329d655e6a1e83$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hszWP.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $hszWP.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $01329d655e6a1e83$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01329d655e6a1e83$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $01329d655e6a1e83$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01329d655e6a1e83$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $01329d655e6a1e83$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $01329d655e6a1e83$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $01329d655e6a1e83$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("hszWP", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $cb60efaf14ebdb94$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $cb60efaf14ebdb94$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $cb60efaf14ebdb94$export$d716ba4f5572ec86 = "jira-software", $cb60efaf14ebdb94$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("71h0a", function(module, exports) {
$parcel$export(module.exports, "default", () => $59b60a60cb2e2052$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<529e483d59d804f10934564240a837e2>>
 * @relayHash 257d21373e4fe87ed59a3a372d0ad3b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6d87044c41055192b1347a1397c90c0b7b89e443aefe223a0152689fbe2a769
const $59b60a60cb2e2052$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c6d87044c41055192b1347a1397c90c0b7b89e443aefe223a0152689fbe2a769",
        "metadata": {},
        "name": "FilterRefinementTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $59b60a60cb2e2052$export$2e2bcd8739ae039 = $59b60a60cb2e2052$var$node;

});

parcelRegister("TZd32", function(module, exports) {
$parcel$export(module.exports, "default", () => $77faa2ccd3e93dd8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c78434a9297abdf0132d72ee9d4de479>>
 * @relayHash ebcfefacb7fe243c0159b2b35aec9902
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83eeceaf5a2b8b41c5852f2ee89d342c3f950765d131d3763a939bf14dad1807
const $77faa2ccd3e93dd8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "83eeceaf5a2b8b41c5852f2ee89d342c3f950765d131d3763a939bf14dad1807",
        "metadata": {},
        "name": "JiraSoftwareHarmonisedTimelineEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $77faa2ccd3e93dd8$export$2e2bcd8739ae039 = $77faa2ccd3e93dd8$var$node;

});

parcelRegister("bm3o6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("eQ4y6")
]).then(()=>parcelRequire('1jwwD'));

});


parcelRegister("dECzl", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareTimelineCustomEmbedRoute", () => $77dddf8b2473f6b7$export$50399fc66120721a);
const $77dddf8b2473f6b7$export$50399fc66120721a = {
    name: 'classic-software-timeline-custom-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline/:viewId/embed',
    exact: true
};

});


parcelRegister("iAxPI", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareTimelineEmbedRouteEntry", () => $e78fd41306c91ced$export$a1cb5210578eeff);

var $iFBvi = parcelRequire("iFBvi");

var $iSoIx = parcelRequire("iSoIx");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $eBK0N = parcelRequire("eBK0N");

var $edf7u = parcelRequire("edf7u");

var $9T5Cr = parcelRequire("9T5Cr");

var $9EWfZ = parcelRequire("9EWfZ");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $8HUuJ = parcelRequire("8HUuJ");
const $e78fd41306c91ced$var$classicSoftwareTimelineEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $iFBvi.softwareTimelineEmbedEntrypoint)
});
const $e78fd41306c91ced$export$a1cb5210578eeff = (0, $fdS54.createEntry)((0, $eBK0N.classicSoftwareTimelineEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-software-timeline-embed-view',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: [
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira_software_timeline_perf_improvements'), (0, $9T5Cr.fieldsResource))
        ],
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jira_harmonised_software_timeline_embed') && (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? $e78fd41306c91ced$var$classicSoftwareTimelineEmbedPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        supportsProjectTheme: 'full'
    }));

});
parcelRegister("eBK0N", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareTimelineEmbedRoute", () => $9ba50942a88cfbd1$export$4e7524b6660074ac);
const $9ba50942a88cfbd1$export$4e7524b6660074ac = {
    name: 'classic-software-timeline-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline/embed'
};

});


parcelRegister("15xtU", function(module, exports) {
$parcel$export(module.exports, "cmpAverageIssueAgeBoardlessRouteEntry", () => $7e5c59806544c2c4$export$4d479b4f7926b74b);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $bayv3 = parcelRequire("bayv3");

var $UjGXL = parcelRequire("UjGXL");

var $3eysO = parcelRequire("3eysO");

var $bXFey = parcelRequire("bXFey");
const $7e5c59806544c2c4$export$4d479b4f7926b74b = (0, $fdS54.createEntry)((0, $bayv3.cmpAverageIssueAgeBoardlessRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.average-issue-age',
        entryPoint: ()=>(0, $UjGXL.averageIssueAgeReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, $bXFey.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bayv3", function(module, exports) {
$parcel$export(module.exports, "cmpAverageIssueAgeBoardlessRoute", () => $45a2a91b0ef6f0e9$export$bbc85107b9038b3c);
const $45a2a91b0ef6f0e9$export$bbc85107b9038b3c = {
    name: 'software-reports-average-issue-age-cmp-boardless',
    path: '/jira/software/c/projects/:projectKey/reports/average-age'
};

});

parcelRegister("UjGXL", function(module, exports) {
$parcel$export(module.exports, "averageIssueAgeReportPageEntrypoint", () => $16b0932e4e7abf12$export$9d4b9036ece964c5);

var $9v3JR = parcelRequire("9v3JR");

var $dTa0V = parcelRequire("dTa0V");
const $16b0932e4e7abf12$export$9d4b9036ece964c5 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9v3JR.averageIssueAgeReportEntrypoint)
});

});
parcelRegister("9v3JR", function(module, exports) {
$parcel$export(module.exports, "averageIssueAgeReportEntrypoint", () => $25a01f47ac06efcf$export$309ace4ff7fedda4);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $25a01f47ac06efcf$export$309ace4ff7fedda4 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("6DV6R")), {
        moduleId: "9f444dd5",
        moduleName: "AverageIssueAgeReportPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6DV6R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lM0sS").then(()=>parcelRequire('5vvgF'));

});



parcelRegister("bXFey", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $a9353af51d0396b6$export$8cb713295e6b7204);
$parcel$export(module.exports, "getTMPReportsCommonResource", () => $a9353af51d0396b6$export$f234446c23dc22a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $a9353af51d0396b6$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $a9353af51d0396b6$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("4l4qP", function(module, exports) {
$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $1d1855fc3c6e6cba$export$96cb0eae1b3413f4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


const $1d1855fc3c6e6cba$export$96cb0eae1b3413f4 = (0, $7edbf.createResource)({
    type: (0, $21fa2470c5a45da5$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("he1hn")),
    maxAge: 60000
});
const $1d1855fc3c6e6cba$export$e9adc6103e9ed514 = ()=>(0, $k6ufm.useResource)($1d1855fc3c6e6cba$export$96cb0eae1b3413f4);

});
/* eslint-disable jira/filename-case */ const $21fa2470c5a45da5$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $21fa2470c5a45da5$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $21fa2470c5a45da5$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("he1hn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8wMHS").then(()=>parcelRequire('eL1tw'));

});


parcelRegister("5ivqw", function(module, exports) {
$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $20f244809b35a5af$export$5910307042ab3f6f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8S1Gc = parcelRequire("8S1Gc");

var $7edbf = parcelRequire("7edbf");

var $byDdk = parcelRequire("byDdk");
const $20f244809b35a5af$export$5910307042ab3f6f = (0, $7edbf.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8S1Gc.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8S1Gc.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $byDdk.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("byDdk", function(module, exports) {
$parcel$export(module.exports, "fetchJSWReports", () => $91c22a2498834411$export$a93a577d6971da2c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $91c22a2498834411$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $h2wCv.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});




parcelRegister("kIBbg", function(module, exports) {
$parcel$export(module.exports, "cmpAverageIssueAgeRouteEntry", () => $fb09ef57e2b86dfe$export$60a057f7a3a41d1c);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $98M1i = parcelRequire("98M1i");

var $UjGXL = parcelRequire("UjGXL");

var $3eysO = parcelRequire("3eysO");

var $bXFey = parcelRequire("bXFey");
const $fb09ef57e2b86dfe$export$60a057f7a3a41d1c = (0, $fdS54.createEntry)((0, $98M1i.cmpAverageIssueAgeRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.average-issue-age',
        entryPoint: ()=>(0, $UjGXL.averageIssueAgeReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, $bXFey.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("98M1i", function(module, exports) {
$parcel$export(module.exports, "cmpAverageIssueAgeRoute", () => $47ec10012e659cd1$export$83399e60a0233fa3);
const $47ec10012e659cd1$export$83399e60a0233fa3 = {
    name: 'software-reports-average-issue-age-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/average-age'
};

});


parcelRegister("dHEQJ", function(module, exports) {
$parcel$export(module.exports, "cmpCreatedVsResolvedBoardlessRouteEntry", () => $38994dc25e4e88d0$export$219970d9b5f438);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $lp2i3 = parcelRequire("lp2i3");

var $lfBuh = parcelRequire("lfBuh");

var $3eysO = parcelRequire("3eysO");

var $bXFey = parcelRequire("bXFey");
const $38994dc25e4e88d0$export$219970d9b5f438 = (0, $fdS54.createEntry)((0, $lp2i3.cmpCreatedVsResolvedBoardlessRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.created-vs-resolved',
        entryPoint: ()=>(0, $lfBuh.createdVsResolvedReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, $bXFey.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lp2i3", function(module, exports) {
$parcel$export(module.exports, "cmpCreatedVsResolvedBoardlessRoute", () => $8f27503a91a8937b$export$9c6554ffc8d6c2c1);
const $8f27503a91a8937b$export$9c6554ffc8d6c2c1 = {
    name: 'software-reports-created-vs-resolved-cmp-boardless',
    path: '/jira/software/c/projects/:projectKey/reports/created-vs-resolved'
};

});

parcelRegister("lfBuh", function(module, exports) {
$parcel$export(module.exports, "createdVsResolvedReportPageEntrypoint", () => $b82cb8196149a5d1$export$1dc41e7cf5afd35e);

var $lFPF6 = parcelRequire("lFPF6");

var $dTa0V = parcelRequire("dTa0V");
const $b82cb8196149a5d1$export$1dc41e7cf5afd35e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $lFPF6.createdVsResolvedReportEntrypoint)
});

});
parcelRegister("lFPF6", function(module, exports) {
$parcel$export(module.exports, "createdVsResolvedReportEntrypoint", () => $a5ee49b003027ef9$export$5362c10eed52f60e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $a5ee49b003027ef9$export$5362c10eed52f60e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("laENI")), {
        moduleId: "e48259c8",
        moduleName: "CreatedVsResolvedReportPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("laENI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i9AiC").then(()=>parcelRequire('8AOwl'));

});




parcelRegister("fQwjt", function(module, exports) {
$parcel$export(module.exports, "cmpCreatedVsResolvedRouteEntry", () => $fe6fb374d946e322$export$92c318e7d48df765);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $fvezb = parcelRequire("fvezb");

var $lfBuh = parcelRequire("lfBuh");

var $3eysO = parcelRequire("3eysO");

var $bXFey = parcelRequire("bXFey");
const $fe6fb374d946e322$export$92c318e7d48df765 = (0, $fdS54.createEntry)((0, $fvezb.cmpCreatedVsResolvedRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.created-vs-resolved',
        entryPoint: ()=>(0, $lfBuh.createdVsResolvedReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, $bXFey.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fvezb", function(module, exports) {
$parcel$export(module.exports, "cmpCreatedVsResolvedRoute", () => $86070371a51c8714$export$54a0c04f754c64af);
const $86070371a51c8714$export$54a0c04f754c64af = {
    name: 'software-reports-created-vs-resolved-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/created-vs-resolved'
};

});


parcelRegister("8yLn2", function(module, exports) {
$parcel$export(module.exports, "cmpRecentlyCreatedBoardlessRouteEntry", () => $8cb5d4f85981e40f$export$9ea57dc21393803b);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $c040c = parcelRequire("c040c");

var $a3nmf = parcelRequire("a3nmf");

var $3eysO = parcelRequire("3eysO");

var $bXFey = parcelRequire("bXFey");
const $8cb5d4f85981e40f$export$9ea57dc21393803b = (0, $fdS54.createEntry)((0, $c040c.cmpRecentlyCreatedBoardlessRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.recently-created',
        entryPoint: ()=>(0, $a3nmf.recentlyCreatedReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, $bXFey.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c040c", function(module, exports) {
$parcel$export(module.exports, "cmpRecentlyCreatedBoardlessRoute", () => $3e249b1220e2ad18$export$9c7ead06cef36c9a);
const $3e249b1220e2ad18$export$9c7ead06cef36c9a = {
    name: 'software-reports-recently-created-cmp-boardless',
    path: '/jira/software/c/projects/:projectKey/reports/recently-created'
};

});

parcelRegister("a3nmf", function(module, exports) {
$parcel$export(module.exports, "recentlyCreatedReportPageEntrypoint", () => $3dfdb96f8e15d2f9$export$cd81fde204d792);

var $4eCEo = parcelRequire("4eCEo");

var $dTa0V = parcelRequire("dTa0V");
const $3dfdb96f8e15d2f9$export$cd81fde204d792 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4eCEo.recentlyCreatedReportEntrypoint)
});

});
parcelRegister("4eCEo", function(module, exports) {
$parcel$export(module.exports, "recentlyCreatedReportEntrypoint", () => $a28c413e06f5a130$export$6790dfcb28e08361);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $a28c413e06f5a130$export$6790dfcb28e08361 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jeXur")), {
        moduleId: "3222478e",
        moduleName: "RecentlyCreatedReportPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jeXur", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jprKA").then(()=>parcelRequire('egNwL'));

});




parcelRegister("47JK3", function(module, exports) {
$parcel$export(module.exports, "cmpRecentlyCreatedRouteEntry", () => $17e4de5c5c9e78bd$export$6549b2baa603eeb3);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $7jZTh = parcelRequire("7jZTh");

var $a3nmf = parcelRequire("a3nmf");

var $3eysO = parcelRequire("3eysO");

var $bXFey = parcelRequire("bXFey");
const $17e4de5c5c9e78bd$export$6549b2baa603eeb3 = (0, $fdS54.createEntry)((0, $7jZTh.cmpRecentlyCreatedRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.recently-created-issues',
        entryPoint: ()=>(0, $a3nmf.recentlyCreatedReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, $bXFey.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7jZTh", function(module, exports) {
$parcel$export(module.exports, "cmpRecentlyCreatedRoute", () => $3fca2fcc948deb20$export$9ad868d540b610e7);
const $3fca2fcc948deb20$export$9ad868d540b610e7 = {
    name: 'software-reports-recently-created-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/recently-created'
};

});


parcelRegister("bFdfN", function(module, exports) {
$parcel$export(module.exports, "cmpVelocityRouteEntry", () => $e18ebad3c214239a$export$93315233fc25c1b4);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $3eysO = parcelRequire("3eysO");

var $8I0Za = parcelRequire("8I0Za");

var $elKNf = parcelRequire("elKNf");

var $bXFey = parcelRequire("bXFey");
const $e18ebad3c214239a$export$93315233fc25c1b4 = (0, $fdS54.createEntry)((0, $8I0Za.cmpVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report-cmp',
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $bXFey.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $elKNf.velocityReportPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8I0Za", function(module, exports) {
$parcel$export(module.exports, "cmpVelocityRoute", () => $74105a3948c18b1b$export$1dfb0bd517ec7a8b);
const $74105a3948c18b1b$export$1dfb0bd517ec7a8b = {
    name: 'software-reports-velocity-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/velocity'
};

});

parcelRegister("elKNf", function(module, exports) {
$parcel$export(module.exports, "velocityReportPageEntrypoint", () => $31b5cdb37f019450$export$571ee01f62e186c8);
/* eslint-disable jira/naming/disallow-filenames */ 
var $6fHSL = parcelRequire("6fHSL");

var $dTa0V = parcelRequire("dTa0V");
const $31b5cdb37f019450$export$571ee01f62e186c8 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6fHSL.velocityReportEntrypoint)
});

});
parcelRegister("6fHSL", function(module, exports) {
$parcel$export(module.exports, "velocityReportEntrypoint", () => $c863cb61d6dd6cb1$export$6f6bc731b8a9d27);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $c863cb61d6dd6cb1$export$6f6bc731b8a9d27 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("h0pgc")), {
        moduleId: "bed924a8",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("h0pgc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1xeTX").then(()=>parcelRequire('2o7lA'));

});




parcelRegister("38RVN", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholderGroupsRouteEntry", () => $5a8ba98f95efe7d8$export$f0dd910016653be3);
/* eslint-disable import/order */ 

var $fdS54 = parcelRequire("fdS54");

var $9LHaM = parcelRequire("9LHaM");

var $dUAVJ = parcelRequire("dUAVJ");

var $276kT = parcelRequire("276kT");

var $2egW3 = parcelRequire("2egW3");
const $5a8ba98f95efe7d8$export$f0dd910016653be3 = (0, $fdS54.createEntry)((0, $9LHaM.communicationsStakeholderGroupsRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $3cafecb9c85c7226$export$72f63f1098bc50b5)
        },
        skeleton: (0, $276kT.StakeholdersSkeleton),
        entryPoint: ()=>{
            return 0, $2egW3.stakeholderGroupsPageEntryPoint;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $3cafecb9c85c7226$export$72f63f1098bc50b5 = 'COMMUNICATIONS';

parcelRegister("9LHaM", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholderGroupsRoute", () => $32b37ea4fb89fcdb$export$87043fcbf23f0119);
const $32b37ea4fb89fcdb$export$87043fcbf23f0119 = {
    name: 'communications-stakeholder-groups',
    path: '/jira/communications/stakeholder-groups'
};

});

parcelRegister("276kT", function(module, exports) {
$parcel$export(module.exports, "StakeholdersSkeleton", () => $84f59d802ee79629$export$9315c1a342c9fb32);
/* StakeholdersSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $d5ps5 = parcelRequire("d5ps5");

var $lgbGf = parcelRequire("lgbGf");
const $84f59d802ee79629$var$customCssStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order
const $84f59d802ee79629$var$Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});
const $84f59d802ee79629$export$9315c1a342c9fb32 = ()=>/*#__PURE__*/ $euxye.createElement($84f59d802ee79629$var$Wrapper, null, /*#__PURE__*/ $euxye.createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lgbGf))),
        className: (0, $4jQY2.default)([
            "_2zz1idpf"
        ])
    }));
$84f59d802ee79629$export$9315c1a342c9fb32.displayName = "StakeholdersSkeleton";

});
parcelRegister("lgbGf", function(module, exports) {
module.exports = new URL("stakeholders-skeleton.tpl.a7968e44.svg", import.meta.url).toString();

});


parcelRegister("2egW3", function(module, exports) {
$parcel$export(module.exports, "stakeholderGroupsPageEntryPoint", () => $ef0fd912e13268bd$export$838bd3c623ceac0);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $9MtQc = parcelRequire("9MtQc");

var $dTa0V = parcelRequire("dTa0V");

var $8reyj = parcelRequire("8reyj");
const $ef0fd912e13268bd$export$838bd3c623ceac0 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8reyj.communicationsStakeholderGroupsEntrypoint),
    horizontalNavigation: (0, $9MtQc.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("9MtQc", function(module, exports) {
$parcel$export(module.exports, "communicationsHorizontalNavEntrypoint", () => $9cd7c0964d87c71d$export$6862ea61ceda83f3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $9cd7c0964d87c71d$export$6862ea61ceda83f3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("e5GwS")), {
        moduleId: "11329883",
        moduleName: "HorizontalCommunicationsNav",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("e5GwS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3QLSI").then(()=>parcelRequire('iGKEA'));

});


parcelRegister("8reyj", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholderGroupsEntrypoint", () => $a3ae97fb3d373db4$export$df18143715531ee1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $UUxiA = parcelRequire("UUxiA");

const $a3ae97fb3d373db4$export$df18143715531ee1 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6fglC")), {
        moduleId: "90ba51b1",
        moduleName: "StakeholderGroupsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        return {
            queries: {
                StakeholderGroupsPageQuery: {
                    parameters: (0, $UUxiA.default),
                    variables: {
                        first: 30,
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("UUxiA", function(module, exports) {
$parcel$export(module.exports, "default", () => $887387dd29980f4e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1935ffc34d5b82a21998e9030582286c>>
 * @relayHash f980e6ab0dfaab3c0d5ba9716030fff2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da422666e336f2ab477a2c864a4a67b806ffea029e7c777503fe57cc2ad9d8f0
const $887387dd29980f4e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StakeholderGroupsPageQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "StakeholderGroupPageContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StakeholderGroupsPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersConnection",
                    "kind": "LinkedField",
                    "name": "stakeholderComms_getStakeholderGroupsWithStakeholders",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "StakeholderCommsStakeholderGroupsAndStakeholders",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "StakeholderCommsStakeholderGroup",
                                            "kind": "LinkedField",
                                            "name": "group",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "services"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "StakeholderCommsStakeholder",
                                            "kind": "LinkedField",
                                            "name": "stakeholders",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "avatar"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "aaid"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "StakeholderCommsNotificationPreference",
                                                    "kind": "LinkedField",
                                                    "name": "notificationPreference",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "emailId"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ownerName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ownerAvatar"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "error"
                        },
                        {
                            "concreteType": "StakeholderCommsPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "cloudId"
                    ],
                    "handle": "connection",
                    "key": "StakeholderGroupTableLayout_stakeholderComms_getStakeholderGroupsWithStakeholders",
                    "kind": "LinkedHandle",
                    "name": "stakeholderComms_getStakeholderGroupsWithStakeholders"
                }
            ]
        },
        "params": {
            "id": "da422666e336f2ab477a2c864a4a67b806ffea029e7c777503fe57cc2ad9d8f0",
            "metadata": {},
            "name": "StakeholderGroupsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$887387dd29980f4e$var$node.hash = "bf10647d0e8085c5022d7b5bac2b57d4";
var $887387dd29980f4e$export$2e2bcd8739ae039 = $887387dd29980f4e$var$node;

});

parcelRegister("6fglC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dU5Oa").then(()=>parcelRequire('128WN'));

});




parcelRegister("hUFuU", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholdersRouteEntry", () => $add4029bbbd22f22$export$c12bfa7616ac8400);
/* eslint-disable import/order */ 

var $fdS54 = parcelRequire("fdS54");

var $jCz4u = parcelRequire("jCz4u");

var $dUAVJ = parcelRequire("dUAVJ");

var $276kT = parcelRequire("276kT");

var $fMUMJ = parcelRequire("fMUMJ");
const $add4029bbbd22f22$export$c12bfa7616ac8400 = (0, $fdS54.createEntry)((0, $jCz4u.communicationsStakeholdersRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $3cafecb9c85c7226$export$72f63f1098bc50b5)
        },
        skeleton: (0, $276kT.StakeholdersSkeleton),
        entryPoint: ()=>{
            return 0, $fMUMJ.stakeholdersPageEntrypoint;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jCz4u", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholdersRoute", () => $875582ed243cd378$export$9933513623f14d7f);
const $875582ed243cd378$export$9933513623f14d7f = {
    name: 'communications-stakeholders',
    path: '/jira/communications/stakeholders'
};

});

parcelRegister("fMUMJ", function(module, exports) {
$parcel$export(module.exports, "stakeholdersPageEntrypoint", () => $344a264c6ebc078b$export$24a5b3c3e5dd381e);

var $9MtQc = parcelRequire("9MtQc");

var $dTa0V = parcelRequire("dTa0V");

var $axZuw = parcelRequire("axZuw");
const $344a264c6ebc078b$export$24a5b3c3e5dd381e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $axZuw.communicationsStakeholdersEntrypoint),
    horizontalNavigation: (0, $9MtQc.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("axZuw", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholdersEntrypoint", () => $831e3c49b2b1440f$export$2be0008a269b55af);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $hWCQd = parcelRequire("hWCQd");

const $831e3c49b2b1440f$export$2be0008a269b55af = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("78kDs")), {
        moduleId: "52ac92a7",
        moduleName: "StakeholdersPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const filter = context.query.filter ? JSON.parse(context.query.filter) : null;
        const search = context.query.search ? {
            searchField: 'EMAIL_ID',
            searchValue: context.query.search
        } : null;
        return {
            queries: {
                StakeholdersPageQuery: {
                    parameters: (0, $hWCQd.default),
                    variables: {
                        filter: filter,
                        search: search,
                        first: 30,
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("hWCQd", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab4195903e2251ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6484f7e7b316501823209660cbd9b426>>
 * @relayHash 687fae66bdb112eae10f29089536fe8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 148b48052e78290e2bd9bdd57f768952d26688f78faeb203f683ba7a3656b88a
const $ab4195903e2251ba$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "search"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v5 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "search",
            "variableName": "search"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StakeholdersPageQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "StakeholderPageContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StakeholdersPageQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "StakeholderCommsStakeholderConnection",
                    "kind": "LinkedField",
                    "name": "stakeholderComms_listStakeholders",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "StakeholderCommsStakeholderEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "StakeholderCommsStakeholder",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "aaid"
                                        },
                                        {
                                            "concreteType": "StakeholderCommsNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "notificationPreference",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "emailId"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "concreteType": "StakeholderCommsGroups",
                                            "kind": "LinkedField",
                                            "name": "groups",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "avatar"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "error"
                        },
                        {
                            "concreteType": "StakeholderCommsPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "filters": [
                        "filter",
                        "search",
                        "cloudId"
                    ],
                    "handle": "connection",
                    "key": "StakeholderTableLayout_stakeholderComms_listStakeholders",
                    "kind": "LinkedHandle",
                    "name": "stakeholderComms_listStakeholders"
                }
            ]
        },
        "params": {
            "id": "148b48052e78290e2bd9bdd57f768952d26688f78faeb203f683ba7a3656b88a",
            "metadata": {},
            "name": "StakeholdersPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ab4195903e2251ba$var$node.hash = "a5f07351b622cbddbb59763c3b659564";
var $ab4195903e2251ba$export$2e2bcd8739ae039 = $ab4195903e2251ba$var$node;

});

parcelRegister("78kDs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iuFSK").then(()=>parcelRequire('jrUCL'));

});




parcelRegister("igvH2", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageConfigurationRouteEntry", () => $7b82567f645a4191$export$76b5cdb407565d67);
/* eslint-disable import/order */ 

var $fdS54 = parcelRequire("fdS54");

var $6gcap = parcelRequire("6gcap");

var $i860n = parcelRequire("i860n");

var $dUAVJ = parcelRequire("dUAVJ");

var $6DFFl = parcelRequire("6DFFl");
const $7b82567f645a4191$export$76b5cdb407565d67 = (0, $fdS54.createEntry)((0, $6gcap.communicationsStatusPageConfigurationRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $b4e2db76a88a249e$export$192ecc0035cad18)
        },
        entryPoint: ()=>{
            return (0, $i860n.fg)('communications_status_page_manage_platform') ? (0, $6DFFl.StatusPageConfigurationPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $b4e2db76a88a249e$export$192ecc0035cad18 = 'STATUS_PAGE_MANAGE';

parcelRegister("6gcap", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageConfigurationRoute", () => $06114c0d93cb617d$export$3e17d1189cad068e);
const $06114c0d93cb617d$export$3e17d1189cad068e = {
    name: 'communications-status-page-configuration',
    path: '/jira/communications/status-page/configuration/:pageId'
};

});

parcelRegister("6DFFl", function(module, exports) {
$parcel$export(module.exports, "StatusPageConfigurationPageEntryPoint", () => $dd438354f59d54ed$export$60200b364291da35);

var $lhKGI = parcelRequire("lhKGI");

var $em69b = parcelRequire("em69b");

var $dTa0V = parcelRequire("dTa0V");
const $dd438354f59d54ed$export$60200b364291da35 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $lhKGI.communicationsStatusPageConfigurationsEntrypoint),
    horizontalNavigation: (0, $em69b.horizontalStatusPageNavEntrypoint)
});

});
parcelRegister("lhKGI", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageConfigurationsEntrypoint", () => $3c1fcdf6a65cf484$export$2594f377bc858add);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $kmeaN = parcelRequire("kmeaN");

const $3c1fcdf6a65cf484$export$2594f377bc858add = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("eQUVP")), {
        moduleId: "128898db",
        moduleName: "StatusPageConfigurationPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const pageId = context.match.params.pageId || '';
        // Don't kick off the query without a pageId — Relay would still fire and the
        // server would error.
        if (!pageId) return {};
        return {
            queries: {
                PrivatePageGroupAssignmentsQuery: {
                    parameters: (0, $kmeaN.default),
                    variables: {
                        pageId: pageId,
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        // Warm the Relay store so the layout's imperative `fetchQuery` can
                        // hit the in-memory cache instead of round-tripping the network.
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("kmeaN", function(module, exports) {
$parcel$export(module.exports, "default", () => $12faa9b3e0790976$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<914b2bd232ae9b28a63077caca2e0375>>
 * @relayHash c5661c307a6a6b9452ae52348abb18fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 98c61d1c6f6ca1e27acf0dbdd2d7537553aeea2b103b90d30c139d099696e05f
const $12faa9b3e0790976$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "concreteType": "StakeholderCommsPrivatePageGroupAssignmentListResponse",
            "kind": "LinkedField",
            "name": "stakeholderComms_getPrivatePageGroupAssignmentsByPageId",
            "plural": false,
            "selections": [
                {
                    "concreteType": "StakeholderCommsPrivatePageGroupAssignment",
                    "kind": "LinkedField",
                    "name": "assignments",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "groupId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "groupName"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PrivatePageGroupAssignmentsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PrivatePageGroupAssignmentsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "98c61d1c6f6ca1e27acf0dbdd2d7537553aeea2b103b90d30c139d099696e05f",
            "metadata": {},
            "name": "PrivatePageGroupAssignmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$12faa9b3e0790976$var$node.hash = "584e4cfa07803431ded102f872c5af04";
var $12faa9b3e0790976$export$2e2bcd8739ae039 = $12faa9b3e0790976$var$node;

});

parcelRegister("eQUVP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jzxwv").then(()=>parcelRequire('dsKKY'));

});


parcelRegister("em69b", function(module, exports) {
$parcel$export(module.exports, "horizontalStatusPageNavEntrypoint", () => $3e90f5ee6e8cfbd6$export$6940d30dce6de17b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $3e90f5ee6e8cfbd6$export$6940d30dce6de17b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hAsHh")), {
        moduleId: "ca287088",
        moduleName: "HorizontalStatusPageNav",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hAsHh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cLLfW").then(()=>parcelRequire('4R3DJ'));

});




parcelRegister("eBdZD", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageCreateRouteEntry", () => $9f9005822b9dee8e$export$82c596f9b720f384);
/* eslint-disable import/order */ 

var $fdS54 = parcelRequire("fdS54");

var $l3Mg2 = parcelRequire("l3Mg2");

var $i860n = parcelRequire("i860n");

var $dUAVJ = parcelRequire("dUAVJ");

var $dUT3k = parcelRequire("dUT3k");
const $9f9005822b9dee8e$export$82c596f9b720f384 = (0, $fdS54.createEntry)((0, $l3Mg2.communicationsStatusPageCreateRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $b4e2db76a88a249e$export$192ecc0035cad18)
        },
        entryPoint: ()=>{
            return (0, $i860n.fg)('communications_status_page_manage_platform') ? (0, $dUT3k.StatusPageCreatePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("l3Mg2", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageCreateRoute", () => $05412e7b74da2feb$export$624f9ad34b2a53d8);
const $05412e7b74da2feb$export$624f9ad34b2a53d8 = {
    name: 'communications-status-page-create',
    path: '/jira/communications/status-page/create'
};

});

parcelRegister("dUT3k", function(module, exports) {
$parcel$export(module.exports, "StatusPageCreatePageEntryPoint", () => $f1eb9f0efa51d256$export$110452142f595ae9);

var $bHxLd = parcelRequire("bHxLd");

var $em69b = parcelRequire("em69b");

var $dTa0V = parcelRequire("dTa0V");
const $f1eb9f0efa51d256$export$110452142f595ae9 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bHxLd.communicationsStatusPageCreateEntrypoint),
    horizontalNavigation: (0, $em69b.horizontalStatusPageNavEntrypoint)
});

});
parcelRegister("bHxLd", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageCreateEntrypoint", () => $66a8c12ae0bdb61c$export$d01ad4841fb1a7a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $66a8c12ae0bdb61c$export$d01ad4841fb1a7a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jQGS9")), {
        moduleId: "70c7f721",
        moduleName: "StatusPageCreatePage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("jQGS9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aMvQv").then(()=>parcelRequire('7NTIL'));

});




parcelRegister("1Vf8Q", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageDetailsRouteEntry", () => $2af2419c758f084f$export$7ec231a670ad3d90);
/* eslint-disable import/order */ 

var $fdS54 = parcelRequire("fdS54");

var $idkts = parcelRequire("idkts");

var $i860n = parcelRequire("i860n");

var $dUAVJ = parcelRequire("dUAVJ");

var $hqWQ0 = parcelRequire("hqWQ0");
const $2af2419c758f084f$export$7ec231a670ad3d90 = (0, $fdS54.createEntry)((0, $idkts.communicationsStatusPageDetailsRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $b4e2db76a88a249e$export$192ecc0035cad18)
        },
        entryPoint: ()=>{
            return (0, $i860n.fg)('communications_status_page_manage_platform') ? (0, $hqWQ0.StatusPageDetailsPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("idkts", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageDetailsRoute", () => $6f0c3d373bd287f4$export$e6ce3e0e6a11a357);
const $6f0c3d373bd287f4$export$e6ce3e0e6a11a357 = {
    name: 'communications-status-page-details',
    path: '/jira/communications/status-page/:pageId'
};

});

parcelRegister("hqWQ0", function(module, exports) {
$parcel$export(module.exports, "StatusPageDetailsPageEntryPoint", () => $65f625f0bb8bbc16$export$f50ecd5b433f8302);

var $gj1Iz = parcelRequire("gj1Iz");

var $dTa0V = parcelRequire("dTa0V");
const $65f625f0bb8bbc16$export$f50ecd5b433f8302 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $gj1Iz.communicationsStatusPageDetailsEntrypoint)
});

});
parcelRegister("gj1Iz", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageDetailsEntrypoint", () => $d0234468aa64aaec$export$4bb0d7c5c07a6d39);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $kmeaN = parcelRequire("kmeaN");

var $2eOgO = parcelRequire("2eOgO");

const $d0234468aa64aaec$export$4bb0d7c5c07a6d39 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2THPn")), {
        moduleId: "852f50ca",
        moduleName: "StatuspageDetailsPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const pageId = context.match.params.pageId || '';
        return {
            queries: {
                StatuspageDetailsPageQuery: {
                    parameters: (0, $2eOgO.default),
                    variables: {
                        pageId: pageId,
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                },
                ...pageId && (0, $i860n.fg)('communications_enable_private_status_page') ? {
                    PrivatePageGroupAssignmentsQuery: {
                        parameters: (0, $kmeaN.default),
                        variables: {
                            pageId: pageId,
                            cloudId: tenantContext.cloudId
                        },
                        options: {
                            // Warm the Relay store so the overview's useLazyLoadQuery can
                            // hit the in-memory cache instead of round-tripping the network.
                            fetchPolicy: 'store-and-network'
                        }
                    }
                } : {}
            }
        };
    }
});

});
parcelRegister("2eOgO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f40140dc5f20df35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2eb5752aa12d197e800601e91a441a8f>>
 * @relayHash b324e51b14bf37120851a6b50d917a00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0178641a60d9c78675fa1cb5da90709044fd8859b363ec10502ff5b356241e37
const $f40140dc5f20df35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "error"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "pageStatus"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StatuspageDetailsPageQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "StakeholderCommsPageResponse",
                    "kind": "LinkedField",
                    "name": "stakeholderComms_getPageById",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "StakeholderCommsPage",
                            "kind": "LinkedField",
                            "name": "page",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "StatuspageDetailsPageContent_stakeholderCommsPage"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StatuspageDetailsPageQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "StakeholderCommsPageResponse",
                    "kind": "LinkedField",
                    "name": "stakeholderComms_getPageById",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "StakeholderCommsPage",
                            "kind": "LinkedField",
                            "name": "page",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "pageType"
                                },
                                {
                                    "concreteType": "StakeholderCommsCustomDomainConfig",
                                    "kind": "LinkedField",
                                    "name": "customDomainConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "domain"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "sslStatus"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "domainStatus"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "version"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subdomain"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "timezone"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0178641a60d9c78675fa1cb5da90709044fd8859b363ec10502ff5b356241e37",
            "metadata": {},
            "name": "StatuspageDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f40140dc5f20df35$var$node.hash = "3bdf1bd54425335bc7aa6d063f506c67";
var $f40140dc5f20df35$export$2e2bcd8739ae039 = $f40140dc5f20df35$var$node;

});

parcelRegister("2THPn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iWkMH").then(()=>parcelRequire('9WIp8'));

});




parcelRegister("3GtBH", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPagePreviewRouteEntry", () => $bfcb0a0d5ed2501d$export$97a4c4b425af834b);
/* eslint-disable import/order */ 

var $fdS54 = parcelRequire("fdS54");

var $gQd0y = parcelRequire("gQd0y");

var $dUAVJ = parcelRequire("dUAVJ");

var $b77iH = parcelRequire("b77iH");
const $bfcb0a0d5ed2501d$export$97a4c4b425af834b = (0, $fdS54.createEntry)((0, $gQd0y.communicationsStatusPagePreviewRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $b4e2db76a88a249e$export$192ecc0035cad18)
        },
        // @ts-expect-error - Layout supports isChromeless but type does not
        layout: {
            isChromeless: true
        },
        entryPoint: ()=>{
            return 0, $b77iH.StatusPagePreviewPageEntryPoint;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gQd0y", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPagePreviewRoute", () => $c2f170a96a659b79$export$aadfff118d74b591);
const $c2f170a96a659b79$export$aadfff118d74b591 = {
    name: 'communications-status-page-preview',
    path: '/jira/communications/status-page/preview/:pageId'
};

});

parcelRegister("b77iH", function(module, exports) {
$parcel$export(module.exports, "StatusPagePreviewPageEntryPoint", () => $80ed10d33a3a5d76$export$b56a407be258f1f0);

var $UYqmU = parcelRequire("UYqmU");

var $dTa0V = parcelRequire("dTa0V");
const $80ed10d33a3a5d76$export$b56a407be258f1f0 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $UYqmU.communicationsStatusPagePreviewEntrypoint)
});

});
parcelRegister("UYqmU", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPagePreviewEntrypoint", () => $0996af283093f04a$export$c5e74834b360e555);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $0996af283093f04a$export$c5e74834b360e555 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("3y3pf")), {
        moduleId: "15d79c46",
        moduleName: "StatuspagePreviewPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("3y3pf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6bSkA").then(()=>parcelRequire('cBNrz'));

});




parcelRegister("ceOvr", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageRouteEntry", () => $7030ba8f62d39c27$export$88a2753691734b92);
/* eslint-disable import/order */ 

var $fdS54 = parcelRequire("fdS54");

var $bLO9Z = parcelRequire("bLO9Z");

var $i860n = parcelRequire("i860n");

var $dUAVJ = parcelRequire("dUAVJ");

var $kRr2A = parcelRequire("kRr2A");
const $7030ba8f62d39c27$export$88a2753691734b92 = (0, $fdS54.createEntry)((0, $bLO9Z.communicationsStatusPageRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $b4e2db76a88a249e$export$192ecc0035cad18)
        },
        entryPoint: ()=>{
            return (0, $i860n.fg)('communications_status_page_manage_platform') ? (0, $kRr2A.StatusPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bLO9Z", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageRoute", () => $2786897eabd80a91$export$db69791340a78355);
const $2786897eabd80a91$export$db69791340a78355 = {
    name: 'communications-status-page',
    path: '/jira/communications/status-page'
};

});

parcelRegister("kRr2A", function(module, exports) {
$parcel$export(module.exports, "StatusPageEntryPoint", () => $0dfe2ec071f55d38$export$b2ae424106b2e3d7);

var $hNdmA = parcelRequire("hNdmA");

var $em69b = parcelRequire("em69b");

var $dTa0V = parcelRequire("dTa0V");
const $0dfe2ec071f55d38$export$b2ae424106b2e3d7 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hNdmA.communicationsStatusPageEntrypoint),
    horizontalNavigation: (0, $em69b.horizontalStatusPageNavEntrypoint)
});

});
parcelRegister("hNdmA", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageEntrypoint", () => $868a9f8faf60805f$export$6af3925e2dcbafc5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $868a9f8faf60805f$export$6af3925e2dcbafc5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("bqAQo")), {
        moduleId: "40d27b0f",
        moduleName: "StatusPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("bqAQo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jJgPj").then(()=>parcelRequire('8kFls'));

});




parcelRegister("fHE3O", function(module, exports) {
$parcel$export(module.exports, "compassProductSettingsRouteEntry", () => $8e8f48400f1d65f4$export$703b5090da478c9c);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $4iAm9 = parcelRequire("4iAm9");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $7mY4v = parcelRequire("7mY4v");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $8e8f48400f1d65f4$var$LazyCompassProductSettingsPage = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dnwhT"))), {
    moduleId: "./src/packages/spa-apps/compass-product-settings/src/CompassProductSettingsSPAContainer.tsx"
});
const $8e8f48400f1d65f4$var$CompassProductSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $8e8f48400f1d65f4$var$LazyCompassProductSettingsPage,
        pageId: "async-compass-product-settings",
        shouldShowSpinner: true
    });
$8e8f48400f1d65f4$var$CompassProductSettingsComponent.displayName = "CompassProductSettingsComponent";
const $8e8f48400f1d65f4$export$703b5090da478c9c = (0, $fdS54.createEntry)((0, $7mY4v.compassProductSettingsRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: $8e8f48400f1d65f4$var$CompassProductSettingsComponent,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $4iAm9.compassProductSettingsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $8e8f48400f1d65f4$var$LazyCompassProductSettingsPage
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4iAm9", function(module, exports) {
$parcel$export(module.exports, "compassProductSettingsResource", () => $7d8e624466863a48$export$d18ff068d6c25455);
$parcel$export(module.exports, "useCompassProductSettingsResource", () => $7d8e624466863a48$export$6cbcbd11d26ae36f);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $7d8e624466863a48$export$d18ff068d6c25455 = (0, $7edbf.createResource)({
    type: (0, $709a71a42294fd0b$export$6f0555de4f60e84e),
    getKey: ()=>'state',
    getData: async ()=>{
        try {
            const isCompassEnabledForNewProjects = await (0, $h2wCv.performGetRequest)(`/rest/api/3/application-properties?key=${(0, $709a71a42294fd0b$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
            return {
                isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
            };
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error?.statusCode === 404) return {
                isCompassEnabledForNewProjects: true
            };
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'compassProductSettingsResource',
                    packageName: 'jiraRouterResourcesCompassProductSettings',
                    teamName: 'compass-pathfinders'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});
const $7d8e624466863a48$export$6cbcbd11d26ae36f = ()=>(0, $k6ufm.useResource)($7d8e624466863a48$export$d18ff068d6c25455);

});
/* eslint-disable jira/filename-case */ const $709a71a42294fd0b$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $709a71a42294fd0b$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';


parcelRegister("7mY4v", function(module, exports) {
$parcel$export(module.exports, "compassProductSettingsRoute", () => $21efd0391ad02764$export$48d633ce1d0d2a0e);
const $21efd0391ad02764$export$48d633ce1d0d2a0e = {
    name: 'compass-product-settings',
    path: '/jira/settings/products/compass',
    exact: true
};

});

parcelRegister("dnwhT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2rTLp").then(()=>parcelRequire('3aP2e'));

});


parcelRegister("ky4fW", function(module, exports) {
$parcel$export(module.exports, "connectGeneralInvalidRouteEntry", () => $6f9a439458176f9f$export$d8088cb4e7cc7efd);


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $kIKHG = parcelRequire("kIKHG");

var $b1D1c = parcelRequire("b1D1c");

var $d4Vaw = parcelRequire("d4Vaw");
const $6f9a439458176f9f$export$d8088cb4e7cc7efd = (0, $fdS54.createEntry)((0, $kIKHG.connectGeneralInvalidRoute), ()=>({
        group: 'connect',
        layout: (0, $QhQu4.createLayout)(),
        navigation: {
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $d4Vaw.default),
        resources: (0, $b1D1c.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $d4Vaw.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kIKHG", function(module, exports) {
$parcel$export(module.exports, "connectGeneralInvalidRoute", () => $4a8f6c0745a45a42$export$486ffffd0a2797a5);
const $4a8f6c0745a45a42$export$486ffffd0a2797a5 = {
    name: 'connect-general-invalid',
    path: '/plugins/servlet/ac/:addonKey//:moduleKey',
    // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
    query: [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?'
    ]
};

});

parcelRegister("b1D1c", function(module, exports) {
$parcel$export(module.exports, "getGeneralConnectRouteResources", () => $1cc2c507c5803786$export$2c86c2f79b80cf77);
$parcel$export(module.exports, "getProjectConnectRouteDefaultResources", () => $1cc2c507c5803786$export$4c06110e7d14ab3c);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable import/order */ // eslint-disable-next-line jira/import/no-restricted-import

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $efbPr = parcelRequire("efbPr");

var $lIcLg = parcelRequire("lIcLg");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");
const $1cc2c507c5803786$export$2c86c2f79b80cf77 = ()=>[
        ...(0, $hdZjx.getBusinessProjectResources)(),
        ...(0, $dUAVJ.getNavigationResources)(),
        (0, $45Itd.navigationSidebarGlobalResource),
        ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $hWEkS.incidentExperimentTraitResource),
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
        (0, $efbPr.connectGeneralResources),
        (0, $6RSCO.getConsolidationStateResource)()
    ];
const $1cc2c507c5803786$export$4c06110e7d14ab3c = ()=>[
        ...(0, $hdZjx.getBusinessProjectResources)(),
        ...(0, $dUAVJ.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $hWEkS.incidentExperimentTraitResource),
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
        (0, $lIcLg.connectProjectResources)
    ];

});
parcelRegister("efbPr", function(module, exports) {
$parcel$export(module.exports, "connectGeneralResources", () => $0ab8c2274feecda9$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $0ab8c2274feecda9$export$53479840ec6d4024);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $0ab8c2274feecda9$var$RESOURCE_TYPE_CONNECT_GENERAL = 'CONNECT_GENERAL';

const $0ab8c2274feecda9$export$f34ab0d904621847 = (0, $7edbf.createResource)({
    type: $0ab8c2274feecda9$var$RESOURCE_TYPE_CONNECT_GENERAL,
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("c4d3X"))
});
const $0ab8c2274feecda9$export$53479840ec6d4024 = ()=>(0, $k6ufm.useResource)($0ab8c2274feecda9$export$f34ab0d904621847);

});
parcelRegister("c4d3X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5mJ2M").then(()=>parcelRequire('iFZAj'));

});


parcelRegister("lIcLg", function(module, exports) {
$parcel$export(module.exports, "connectProjectResources", () => $25c665d0f0e23279$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $i06nY = parcelRequire("i06nY");

var $idDnR = parcelRequire("idDnR");

var $7edbf = parcelRequire("7edbf");
const $25c665d0f0e23279$var$RESOURCE_TYPE_CONNECT_PROJECT = 'CONNECT_PROJECT';

const $25c665d0f0e23279$export$7d2d082a4b91a6c7 = (0, $7edbf.createResource)({
    type: $25c665d0f0e23279$var$RESOURCE_TYPE_CONNECT_PROJECT,
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $i06nY.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $idDnR.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("JaDbR"))
}); /* oxlint-enable @typescript-eslint/no-explicit-any */ 

});
parcelRegister("i06nY", function(module, exports) {
$parcel$export(module.exports, "transformResponse", () => $35917c5aa0ac1a8b$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $35917c5aa0ac1a8b$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $35917c5aa0ac1a8b$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $35917c5aa0ac1a8b$export$752ef5ab3d7ab15f);
$parcel$export(module.exports, "buildNotFoundUrl", () => $35917c5aa0ac1a8b$export$f1f213454f5d81b9);
$parcel$export(module.exports, "transformContextToFromUrl", () => $35917c5aa0ac1a8b$export$ca4c8c0a45099ac);
/* eslint-disable jira/filename-case */ 
var $6CfY5 = parcelRequire("6CfY5");

var $aehBZ = parcelRequire("aehBZ");

var $4bRaD = parcelRequire("4bRaD");
const $35917c5aa0ac1a8b$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: true
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height,
            type: 'MODULE'
        };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $6CfY5.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            type: 'MODULE'
        };
    }
};
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $35917c5aa0ac1a8b$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $35917c5aa0ac1a8b$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $35917c5aa0ac1a8b$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $4bRaD.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $aehBZ.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $35917c5aa0ac1a8b$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $35917c5aa0ac1a8b$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $35917c5aa0ac1a8b$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};
const $35917c5aa0ac1a8b$export$f1f213454f5d81b9 = (containerContext)=>{
    if (!containerContext) return null;
    if (containerContext.contextType !== 'project') return null;
    const project = containerContext.project;
    const scope = containerContext.scope;
    const projectKey = project.key;
    const projectType = project.type;
    const scopeId = scope?.id;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/not-found`;
    if (projectType === 'software' && scopeId) return `/jira/software/projects/${projectKey}/boards/${scopeId}/not-found`;
    return null;
};
const $35917c5aa0ac1a8b$export$ca4c8c0a45099ac = (match, query, hash)=>{
    const queryString = new URLSearchParams(query);
    const originalUrl = new URL(`${globalThis.location.origin}${match.url}`);
    queryString.forEach((value, key)=>{
        originalUrl.searchParams.append(key, value);
    });
    originalUrl.hash = hash;
    return originalUrl.href;
};

});
parcelRegister("aehBZ", function(module, exports) {
$parcel$export(module.exports, "extractData", () => $6a13c8f05f6bf6bb$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $6a13c8f05f6bf6bb$export$67db9e2d1b6ed865);
/* eslint-disable jira/filename-case */ const $6a13c8f05f6bf6bb$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $6a13c8f05f6bf6bb$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


parcelRegister("JaDbR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Z4IB").then(()=>parcelRequire('43s2S'));

});



parcelRegister("d4Vaw", function(module, exports) {
$parcel$export(module.exports, "LazyGeneralConnect", () => $b8419d0582407a90$export$c33275abe6c1e577);
$parcel$export(module.exports, "default", () => $b8419d0582407a90$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $b8419d0582407a90$export$c33275abe6c1e577 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("3QRZE"))), {
    moduleId: "./src/packages/spa-apps/jira-connect-general-pages/src/index.tsx"
});
const $b8419d0582407a90$var$AsyncGeneralConnect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $b8419d0582407a90$export$c33275abe6c1e577,
        pageId: "connect",
        shouldShowSpinner: true
    });
$b8419d0582407a90$var$AsyncGeneralConnect.displayName = "AsyncGeneralConnect";
var $b8419d0582407a90$export$2e2bcd8739ae039 = $b8419d0582407a90$var$AsyncGeneralConnect;

});
parcelRegister("3QRZE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fGrw2").then(()=>parcelRequire('f8Z35'));

});



parcelRegister("fLdTj", function(module, exports) {
$parcel$export(module.exports, "connectGeneralRouteEntry", () => $4a439c16e71e77b1$export$46273ee39bcd958b);


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $8WQZ8 = parcelRequire("8WQZ8");

var $b1D1c = parcelRequire("b1D1c");

var $d4Vaw = parcelRequire("d4Vaw");
const $4a439c16e71e77b1$export$46273ee39bcd958b = (0, $fdS54.createEntry)((0, $8WQZ8.connectGeneralRoute), ()=>({
        group: 'connect',
        layout: (0, $QhQu4.createLayout)(),
        navigation: {
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $d4Vaw.default),
        resources: (0, $b1D1c.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $d4Vaw.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8WQZ8", function(module, exports) {
$parcel$export(module.exports, "connectGeneralRoute", () => $9e17e7daa8fcf1f8$export$1fda4850b6314ff0);
const $9e17e7daa8fcf1f8$export$1fda4850b6314ff0 = {
    name: 'connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
    query: [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?'
    ]
};

});


parcelRegister("31aCF", function(module, exports) {
$parcel$export(module.exports, "connectGeneralServiceDeskProjectRouteEntry", () => $d27923684c7f098d$export$487a360459ad1bea);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $iAnqg = parcelRequire("iAnqg");

var $b1D1c = parcelRequire("b1D1c");

var $d4Vaw = parcelRequire("d4Vaw");
const $d27923684c7f098d$export$487a360459ad1bea = (0, $fdS54.createEntry)((0, $iAnqg.connectGeneralServiceDeskProjectRoute), ()=>({
        group: 'connect',
        layout: (0, $QhQu4.createLayout)(),
        navigation: {
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $d4Vaw.default),
        resources: [
            ...(0, $b1D1c.getGeneralConnectRouteResources)(),
            ...(0, $lbxXL.getServiceDeskNavigationSingleResources)()
        ],
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $d4Vaw.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iAnqg", function(module, exports) {
$parcel$export(module.exports, "connectGeneralServiceDeskProjectRoute", () => $c9865b1d444328ff$export$e8a58aee75961b55);
const $c9865b1d444328ff$export$e8a58aee75961b55 = {
    name: 'connect-general-service-desk-project',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?',
        'project.key',
        'servicedesk.serviceDeskId'
    ]
};

});


parcelRegister("jtStO", function(module, exports) {
$parcel$export(module.exports, "connectProjectRouteEntry", () => $c4de5e82b5a985d1$export$96bdc57a01f2ee48);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $dvtoW = parcelRequire("dvtoW");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $jjVkp = parcelRequire("jjVkp");

var $b1D1c = parcelRequire("b1D1c");

var $iDs02 = parcelRequire("iDs02");
const $c4de5e82b5a985d1$export$96bdc57a01f2ee48 = (0, $fdS54.createEntry)((0, $jjVkp.connectProjectRoute), ()=>({
        group: 'connect',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        layout: (0, $dvtoW.genericProjectLayout),
        ufoName: 'jira-connect',
        // Match resources that are fetched for legacyConnectProjectRouteEntry
        // See src/packages/router-routes/legacy-connect-project-entries/src/index.tsx
        resources: [
            ...(0, $b1D1c.getProjectConnectRouteDefaultResources)(),
            ...(0, $lbxXL.getServiceDeskSharedNavigationSingleResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $iDs02.connectProjectsPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jjVkp", function(module, exports) {
$parcel$export(module.exports, "connectProjectRoute", () => $2c8d4266820201a8$export$27e7531864dfb704);
const $2c8d4266820201a8$export$27e7531864dfb704 = {
    name: 'connect-project',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
    ]
};

});

parcelRegister("iDs02", function(module, exports) {
$parcel$export(module.exports, "connectProjectsPageEntrypoint", () => $b3312d5418a02088$export$d7105af2aa9527d0);
$parcel$export(module.exports, "connectProjectsWithoutHorizontalNavPageEntrypoint", () => $b3312d5418a02088$export$8df81c5e9c00a7b4);
/* eslint-disable jira/naming/disallow-filenames */ 
var $eaQX1 = parcelRequire("eaQX1");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $b3312d5418a02088$export$d7105af2aa9527d0 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $eaQX1.connectProjectsEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $b3312d5418a02088$export$8df81c5e9c00a7b4 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $eaQX1.connectProjectsEntrypoint)
});

});
parcelRegister("eaQX1", function(module, exports) {
$parcel$export(module.exports, "connectProjectsEntrypoint", () => $8d0ac692792c1265$export$4ff832a017f5175c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $8d0ac692792c1265$export$4ff832a017f5175c = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8h8Ik")), {
        moduleId: "9a5bbd71",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                query: context.query,
                match: context.match,
                hash: globalThis?.location?.hash || ''
            }
        })
});

});
parcelRegister("8h8Ik", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8kgqQ").then(()=>parcelRequire('2VTji'));

});




parcelRegister("hEHYT", function(module, exports) {
$parcel$export(module.exports, "createProjectRouteEntry", () => $9f71278fdfd389c7$export$28887e2da22c839a);

var $euxye = parcelRequire("euxye");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jfVrP = parcelRequire("jfVrP");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9f71278fdfd389c7$var$LazyCreateProject = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("jJeyg")), {
    moduleId: "./src/packages/spa-apps/create-project/src/CreateProjectSpa.tsx"
});
const $9f71278fdfd389c7$var$CreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9f71278fdfd389c7$var$LazyCreateProject,
        pageId: "spa-apps/create-project",
        shouldShowSpinner: true
    });
$9f71278fdfd389c7$var$CreateProject.displayName = "CreateProject";
const $9f71278fdfd389c7$export$28887e2da22c839a = (0, $fdS54.createEntry)((0, $jfVrP.createProjectRoute), ()=>({
        group: 'components',
        // eslint-disable-next-line no-restricted-syntax
        component: $9f71278fdfd389c7$var$CreateProject,
        layout: (0, $dvtoW.genericProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $9f71278fdfd389c7$var$LazyCreateProject
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jfVrP", function(module, exports) {
$parcel$export(module.exports, "createProjectRoute", () => $8f30f22e00770900$export$5ce9108542315ac8);
const $8f30f22e00770900$export$5ce9108542315ac8 = {
    name: 'create-project',
    path: '/jira/create-project',
    exact: true
};

});

parcelRegister("jJeyg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cQiLj").then(()=>parcelRequire('gImOo'));

});


parcelRegister("6uGHB", function(module, exports) {
$parcel$export(module.exports, "csmCustomerDetailsRouteEntry", () => $1aeef9860bbb0a6b$export$4b9656d90d514db6);



var $423D8 = parcelRequire("423D8");

var $6RvOI = parcelRequire("6RvOI");

var $aMnvf = parcelRequire("aMnvf");

var $aqqTV = parcelRequire("aqqTV");

var $iSoIx = parcelRequire("iSoIx");

var $8JYi9 = parcelRequire("8JYi9");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $lhkth = parcelRequire("lhkth");
const $1aeef9860bbb0a6b$var$csmCustomerDetailsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $423D8.customerServiceCustomerDetailsEntryPoint)
});
const $1aeef9860bbb0a6b$export$4b9656d90d514db6 = (0, $fdS54.createEntry)((0, $8JYi9.csmCustomerDetailsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.csm-customer-details',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $1aeef9860bbb0a6b$var$csmCustomerDetailsPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $aMnvf.CustomerDetailsPageQueryResource),
            (0, $aqqTV.EntitlementsQueryResource),
            (0, $6RvOI.l1CustomersProjectProviderResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $9af5f31dbe9d4be3$export$b5ebf984c5a2d153 = 'CUSTOMER_EXPERIENCES';

const $f11be1b6bfa50d8e$export$1590673d7ba4cdb7 = 'CSM_APP';

parcelRegister("423D8", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomerDetailsEntryPoint", () => $1e4ee9fca3131f56$export$2e8cd0a95d30d16e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $1e4ee9fca3131f56$export$2e8cd0a95d30d16e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("f6KGC")), {
        moduleId: "cc9e8c60",
        moduleName: "CustomerServiceCustomerDetailsSpaApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f6KGC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("56EqI")
]).then(()=>parcelRequire('cdhmw'));

});


parcelRegister("6RvOI", function(module, exports) {
$parcel$export(module.exports, "l1CustomersProjectProviderResource", () => $47342d649bd2e534$export$5859972994597afe);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $dL2hv = parcelRequire("dL2hv");
const $47342d649bd2e534$var$RESOURCE_TYPE_CSM_BASE_URL = 'L1_CUSTOMERS_PROJECT';
const $47342d649bd2e534$export$5859972994597afe = (0, $7edbf.createResource)({
    type: $47342d649bd2e534$var$RESOURCE_TYPE_CSM_BASE_URL,
    getKey: ()=>'l1-customers-project',
    getData: async ()=>(0, $dL2hv.default)(),
    maxAge: 3600000
});

});
parcelRegister("dL2hv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ae6795de4b0e309$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");
const $3ae6795de4b0e309$var$getData = async ()=>{
    try {
        // we check for browse access, which means user must be part of the project.
        // jira admin can Administer projects without being part of the actual project.
        // see https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-projects/#api-rest-api-3-project-search-get
        const data = await (0, $4fhEY.default)('/rest/api/3/project/search?expand=permissions&typeKey=customer_service&action=browse&maxResults=100&startAt=0');
        const projectWhereAdmin = data?.values?.find((project)=>project.permissions.canEdit);
        // includes collaborator
        // collaborator will get 403 on customers and organizations list pages
        const projectWhereUser = data?.values?.find((project)=>!project.permissions.canEdit);
        return projectWhereAdmin || projectWhereUser || null;
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'l1CustomersProjectProvider',
                packageName: 'jiraRouterResourcesCustomerServiceL1CustomersProjectProvider',
                teamName: 'Boysenberry'
            },
            error: error instanceof Error ? error : undefined
        });
        throw error;
    }
};
var $3ae6795de4b0e309$export$2e2bcd8739ae039 = $3ae6795de4b0e309$var$getData;

});


parcelRegister("aMnvf", function(module, exports) {
$parcel$export(module.exports, "CustomerDetailsPageQueryResource", () => $0390bacf3417ee8b$export$b7c13e8503a1c9ab);

var $3FqoK = parcelRequire("3FqoK");

var $htsFl = parcelRequire("htsFl");

var $i860n = parcelRequire("i860n");
const $0390bacf3417ee8b$export$b7c13e8503a1c9ab = (0, $htsFl.createRelayResource)({
    type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $3FqoK.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId,
                csmCustomerNameUpdateMutationEnabled: (0, $i860n.fg)('csm_customer_name_update_mutation')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("3FqoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f6135c53b1c9337$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff8837bfed0b40c4f89e32c942f73757>>
 * @relayHash c289897f1e14277fabf9db0f916cc09d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6c0389bb5e4375145c6e0876f0f6dbc76f0abe1939e45fa57cf30e534bd669cd
const $3f6135c53b1c9337$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6c0389bb5e4375145c6e0876f0f6dbc76f0abe1939e45fa57cf30e534bd669cd",
        "metadata": {},
        "name": "CustomerDetailsCustomerDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3f6135c53b1c9337$export$2e2bcd8739ae039 = $3f6135c53b1c9337$var$node;

});


parcelRegister("aqqTV", function(module, exports) {
$parcel$export(module.exports, "EntitlementsQueryResource", () => $05bf2c330b223075$export$c38ff8a452b9917d);

var $i0pnJ = parcelRequire("i0pnJ");

var $htsFl = parcelRequire("htsFl");
const $05bf2c330b223075$export$c38ff8a452b9917d = (0, $htsFl.createRelayResource)({
    type: 'ENTITLEMENTS_CUSTOMER_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $i0pnJ.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("i0pnJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3bc1dd9a66d7321$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ac85a7670e252a6582acbe7e55dc108>>
 * @relayHash 95a37fafea41f7393615020271b944eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3de52a71d40720a4d9254d54021b84be0832bdb2474555266267ce6bc5edfe19
const $f3bc1dd9a66d7321$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v6 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EntitlementsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": true
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "Entitlement"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW"
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ThrowOnQueryError"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EntitlementsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "CustomerServiceOrganization"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3de52a71d40720a4d9254d54021b84be0832bdb2474555266267ce6bc5edfe19",
            "metadata": {},
            "name": "EntitlementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f3bc1dd9a66d7321$var$node.hash = "a623afca7929af72b6f04d85b8eacf00";
var $f3bc1dd9a66d7321$export$2e2bcd8739ae039 = $f3bc1dd9a66d7321$var$node;

});


parcelRegister("8JYi9", function(module, exports) {
$parcel$export(module.exports, "csmCustomerDetailsRoute", () => $1b939fcbfbb8ea43$export$d246b77e0d14597c);
const $1b939fcbfbb8ea43$export$d246b77e0d14597c = {
    name: 'csm-customer-details',
    path: '/jira/customer-service-management/customers/:customerId',
    exact: true
};

});

parcelRegister("lhkth", function(module, exports) {
$parcel$export(module.exports, "getCustomerServiceL1NavigationResources", () => $3bf0e98cceec4f03$export$4688fbc5a575c91d);
/* eslint-disable jira/import-whitelist */ 
var $i860n = parcelRequire("i860n");

var $1IUl9 = parcelRequire("1IUl9");

var $56F5E = parcelRequire("56F5E");

var $9O6SX = parcelRequire("9O6SX");

var $i4Cir = parcelRequire("i4Cir");

var $4B518 = parcelRequire("4B518");

var $8HUuJ = parcelRequire("8HUuJ");

var $3V9Gd = parcelRequire("3V9Gd");
// Loads classic Jira navigation UI state while Global Side Nav is disabled.
const $3bf0e98cceec4f03$var$conditionalNavigationUiStateResource = (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('navx-global-side-nav'), (0, $i4Cir.navigationUiStateResource));
// Loads the Global Side Nav root layout state when Global Side Nav is enabled.
const $3bf0e98cceec4f03$var$conditionalNavPlatformRootStateResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('navx-global-side-nav'), (0, $9O6SX.navPlatformRootStateResource));
// Loads the Global Side Nav sidebar state when Global Side Nav is enabled.
const $3bf0e98cceec4f03$var$conditionalNavPlatformSidebarResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('navx-global-side-nav'), (0, $56F5E.navPlatformSidebarResource));
function $3bf0e98cceec4f03$export$4688fbc5a575c91d() {
    return [
        // Loads the baseline SPA shell resources required by Jira routes.
        ...(0, $4B518.jiraSpaResources)(),
        // Top navigation
        (0, $1IUl9.topNav4UIStateResource),
        // Left navigation
        (0, $3V9Gd.csmAppSidebarQueryResource),
        // Loads the Nav4 sidebar entry UI state for sidebar selection/rendering.
        $3bf0e98cceec4f03$var$conditionalNavigationUiStateResource,
        $3bf0e98cceec4f03$var$conditionalNavPlatformRootStateResource,
        $3bf0e98cceec4f03$var$conditionalNavPlatformSidebarResource
    ];
}

});
parcelRegister("3V9Gd", function(module, exports) {
$parcel$export(module.exports, "csmAppSidebarQueryResource", () => $c501c1b7657397d3$export$646f7e6c2354d44f);
/* eslint-disable jira/import-whitelist */ 
var $htsFl = parcelRequire("htsFl");

var $5IkoH = parcelRequire("5IkoH");

var $bkBsT = parcelRequire("bkBsT");

var $aK5Al = parcelRequire("aK5Al");

var $8yncd = parcelRequire("8yncd");
const $c501c1b7657397d3$export$646f7e6c2354d44f = (0, $htsFl.createRelayResource)({
    type: 'CSM_APP_SIDEBAR_QUERY_RESOURCE',
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const initialSelectedPath = (0, $bkBsT.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $8yncd.default),
            variables: {
                cloudId: cloudId,
                isProjectsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PROJECTS))
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("8yncd", function(module, exports) {
$parcel$export(module.exports, "default", () => $c464a65700839327$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59a65642f0e745146b4cc89ffb44ec57>>
 * @relayHash d28d9c2231c01a8c455a9e9ef4f1939b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22f524d0d7700ad59533492d8d7e96c84b6f354cebda8aaa090eee8d4c122984

var $1ezSH = parcelRequire("1ezSH");

var $fT916 = parcelRequire("fT916");

var $lIGkE = parcelRequire("lIGkE");
const $c464a65700839327$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v12 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v13 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v13 /*: any*/ 
            }
        ]
    }, v15 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CsmAppSidebarQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "CsmNav4Projects_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "CsmAppSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 20
                                        }
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ],
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "22f524d0d7700ad59533492d8d7e96c84b6f354cebda8aaa090eee8d4c122984",
            "metadata": {},
            "name": "CsmAppSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $1ezSH.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $fT916.default)
            }
        }
    };
}();
$c464a65700839327$var$node.hash = "37b381a4dbb8f64e8c63bba8790c8f21";
(0, $lIGkE.PreloadableQueryRegistry).set($c464a65700839327$var$node.params.id, $c464a65700839327$var$node);
var $c464a65700839327$export$2e2bcd8739ae039 = $c464a65700839327$var$node;

});




parcelRegister("3ssEl", function(module, exports) {
$parcel$export(module.exports, "csmCustomersRouteEntry", () => $bef88dc9c7494ea2$export$edc53d54f68dc45c);

var $lFUuS = parcelRequire("lFUuS");



var $6RvOI = parcelRequire("6RvOI");

var $aS3GY = parcelRequire("aS3GY");

var $SmY74 = parcelRequire("SmY74");

var $7FU4x = parcelRequire("7FU4x");

var $iSoIx = parcelRequire("iSoIx");

var $km8ee = parcelRequire("km8ee");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $lhkth = parcelRequire("lhkth");
const $bef88dc9c7494ea2$var$csmCustomersPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $SmY74.customerServiceCustomersEntryPoint)
});
const $bef88dc9c7494ea2$export$edc53d54f68dc45c = (0, $fdS54.createEntry)((0, $km8ee.csmCustomersRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.csm-customers',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            horizontal: (0, $lFUuS.AsyncCustomersNav),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $bef88dc9c7494ea2$var$csmCustomersPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $6RvOI.l1CustomersProjectProviderResource),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource),
            (0, $7FU4x.customerServiceManagementCrmImportModuleResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lFUuS", function(module, exports) {
$parcel$export(module.exports, "AsyncCustomersNav", () => $e2af4e0fd2ed5d3c$export$a96bad1d85441048);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $e2af4e0fd2ed5d3c$var$LazyCustomersNav = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("epDBA")).then(({ CustomersHorizontalNav: CustomersHorizontalNav })=>CustomersHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-csm-customers/src/ui/index.tsx"
});
const $e2af4e0fd2ed5d3c$export$a96bad1d85441048 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-csm-customers-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e2af4e0fd2ed5d3c$var$LazyCustomersNav, null));
$e2af4e0fd2ed5d3c$export$a96bad1d85441048.displayName = "AsyncCustomersNav";

});
parcelRegister("epDBA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5VTkn").then(()=>parcelRequire('9jBEE'));

});


parcelRegister("aS3GY", function(module, exports) {
$parcel$export(module.exports, "csmCustomerContextTenantMigratedStatusResource", () => $01c5ae5d2f8456e7$export$f89a4294229b7a16);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $1zyBB = parcelRequire("1zyBB");
const $01c5ae5d2f8456e7$export$f89a4294229b7a16 = (0, $7edbf.createResource)({
    type: 'CSM_CUSTOMER_CONTEXT_TENANT_MIGRATED_STATUS',
    getKey: ()=>'csm-customer-context-tenant-migrated-status',
    getData: async ()=>(0, $1zyBB.default)(),
    maxAge: 86400000,
    isBrowserOnly: true
});

});
parcelRegister("1zyBB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e38a1e4459801b2$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $9e38a1e4459801b2$var$getData = async ()=>{
    try {
        const data = await (0, $4fhEY.default)('/gateway/api/jsm/csm/api/v1/migration/customer-context/storage-architecture/status');
        return data.isMigratedToNewStorageArch;
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'csmCustomerContextTenantMigratedStatusResource',
                packageName: 'jiraRouterResourcesServiceDeskCustomerServiceCsmMigratedTenantStatus',
                teamName: 'Boysenberry'
            },
            error: error instanceof Error ? error : undefined
        });
        throw error;
    }
};
var $9e38a1e4459801b2$export$2e2bcd8739ae039 = $9e38a1e4459801b2$var$getData;

});


parcelRegister("SmY74", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomersEntryPoint", () => $6f6ee3c6921256be$export$f9e86fb3be37e94);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $6f6ee3c6921256be$export$f9e86fb3be37e94 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("6HgD6")), {
        moduleId: "e7c2287e",
        moduleName: "CustomerServiceCustomersSpaApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6HgD6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("3fdly")
]).then(()=>parcelRequire('ehXlU'));

});


parcelRegister("7FU4x", function(module, exports) {
$parcel$export(module.exports, "customerServiceManagementCrmImportModuleResource", () => $cb6d3cf2ae48c36a$export$b8f47e33817c324b);

var $aHmTX = parcelRequire("aHmTX");

var $A82xh = parcelRequire("A82xh");

var $7edbf = parcelRequire("7edbf");

var $kIxv5 = parcelRequire("kIxv5");
const $cb6d3cf2ae48c36a$export$b8f47e33817c324b = (0, $7edbf.createResource)({
    type: 'FORGE_CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE',
    getKey: ()=>'csm-crmimport-extensions',
    getData: (_routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: 'crm-import'
        }).then((modules)=>{
            const extensions = modules[0, $aHmTX.CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE] || [];
            return extensions.sort((a, b)=>(0, $kIxv5.alphabeticalSort)(a.properties.title, b.properties.title));
        }),
    maxAge: Number.MAX_SAFE_INTEGER
});

});

parcelRegister("km8ee", function(module, exports) {
$parcel$export(module.exports, "csmCustomersRoute", () => $ffc1093330261a12$export$7a2a93fccf51b432);
const $ffc1093330261a12$export$7a2a93fccf51b432 = {
    name: 'csm-customers',
    path: '/jira/customer-service-management/customers',
    exact: true
};

});


parcelRegister("cjjH8", function(module, exports) {
$parcel$export(module.exports, "csmCustomIssueRouteEntry", () => $7a30a0f20804cff9$export$c1c07a2087c6f442);

var $51vnM = parcelRequire("51vnM");


var $dTa0V = parcelRequire("dTa0V");

var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $i860n = parcelRequire("i860n");

var $lhkth = parcelRequire("lhkth");

var $fdS54 = parcelRequire("fdS54");

var $iSoIx = parcelRequire("iSoIx");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $6dc16 = parcelRequire("6dc16");

var $cpnl1 = parcelRequire("cpnl1");

var $ble5H = parcelRequire("ble5H");

var $6p6qU = parcelRequire("6p6qU");

var $74h93 = parcelRequire("74h93");

var $9KYmb = parcelRequire("9KYmb");

var $U9h5y = parcelRequire("U9h5y");

var $8deB6 = parcelRequire("8deB6");

var $9KM2b = parcelRequire("9KM2b");
const $7a30a0f20804cff9$var$csmCustomIssuePageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8deB6.queuesAgentAndIssueViewEntryPoint),
    horizontalNavigation: (0, $6dc16.horizontalNavQueueEntrypoint)
});
const $7a30a0f20804cff9$export$c1c07a2087c6f442 = (0, $fdS54.createEntry)((0, $6p6qU.csmCustomIssueRoute), ()=>({
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        skeleton: (0, $9KM2b.QueueLoadingSkeleton),
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $cpnl1.issueListSsrResource),
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            ...(0, $lbxXL.getTriageButtonPermissionResource)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $ble5H.servicedeskIsItsmProjectResource),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            ...(0, $9KYmb.getDraftReplyPillsResource)(),
            (0, $U9h5y.getJsmIssueViewRelatedArticlesRouteResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        group: 'customer-service',
        // It is important to keep this component consistent across the routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $7a30a0f20804cff9$var$csmCustomIssuePageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        isHydrateRootEnabled: false,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6dc16", function(module, exports) {
$parcel$export(module.exports, "horizontalNavQueueEntrypoint", () => $af172114c3b4fdf9$export$df9ea493099a3cc4);

var $i0CFV = parcelRequire("i0CFV");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $lC5kV = parcelRequire("lC5kV");

var $3nBDT = parcelRequire("3nBDT");
const $af172114c3b4fdf9$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;

const $af172114c3b4fdf9$export$df9ea493099a3cc4 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7iVE7")), {
        moduleId: "ef41deff",
        moduleName: "HorizontalNavQueueInner",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        projectId = projectId ?? '';
        const projectIdOrKey = projectId || projectKey;
        const queueAri = queueId ? (0, $lC5kV.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const containerNavigationInput = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQueueQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3nBDT.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        containerNavigationInput: containerNavigationInput,
                        first: $af172114c3b4fdf9$var$NAVIGATION_ITEMS_PAGE_SIZE
                    }
                }
            }
        };
    }
});

});
parcelRegister("lC5kV", function(module, exports) {
$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $fbc149501bae8201$export$555c8ae00f64ebff);

var $5aMfC = parcelRequire("5aMfC");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira-servicedesk/queue/manifest.ts
var $fbc149501bae8201$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5aMfC.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $5aMfC.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $fbc149501bae8201$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fbc149501bae8201$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $fbc149501bae8201$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fbc149501bae8201$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $fbc149501bae8201$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $fbc149501bae8201$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $fbc149501bae8201$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("5aMfC", function(module, exports) {
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $3c435090e4617868$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $3c435090e4617868$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $3c435090e4617868$export$704112eeb385ceab = "jira-servicedesk", $3c435090e4617868$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("3nBDT", function(module, exports) {
$parcel$export(module.exports, "default", () => $149842b78c844e40$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce289ab7929998d4b6b7fe005b15c70e>>
 * @relayHash 1892db8bde2fcd0b7e4b90287e429eb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 714123581c6713fe48973e14924da026b82609e0fee221990137782988ca4029
const $149842b78c844e40$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "714123581c6713fe48973e14924da026b82609e0fee221990137782988ca4029",
        "metadata": {},
        "name": "HorizontalNavQueueInnerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $149842b78c844e40$export$2e2bcd8739ae039 = $149842b78c844e40$var$node;

});

parcelRegister("7iVE7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("hqvBt")
]).then(()=>parcelRequire('8rSsF'));

});


parcelRegister("6p6qU", function(module, exports) {
$parcel$export(module.exports, "csmCustomIssueRoute", () => $297adfb9fe9a7e0f$export$792d7278f17e5f0a);
const $297adfb9fe9a7e0f$export$792d7278f17e5f0a = {
    name: 'csm-queues-custom-issue-detail',
    path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId/:issueKey',
    exact: true
};

});

parcelRegister("8deB6", function(module, exports) {
$parcel$export(module.exports, "queuesAgentAndIssueViewEntryPoint", () => $8a80e990bd848016$export$49ef0f61253db246);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $8a80e990bd848016$export$49ef0f61253db246 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("kJiOz")), {
        moduleId: "9fc78191",
        moduleName: "SpaApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kJiOz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("8xkau")
]).then(()=>parcelRequire('c0c4f'));

});


parcelRegister("9KM2b", function(module, exports) {
$parcel$export(module.exports, "QueueLoadingSkeleton", () => $5c6943a299dcbbe8$export$d20068523efc567f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6DfNt = parcelRequire("6DfNt");
const $5c6943a299dcbbe8$export$d20068523efc567f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DfNt.default), null);
};
$5c6943a299dcbbe8$export$d20068523efc567f.displayName = "QueueLoadingSkeleton";

});


parcelRegister("jBwQs", function(module, exports) {
$parcel$export(module.exports, "csmCustomQueueRouteEntry", () => $6bbfff077daa4fb5$export$1d3fffdc134b6d60);

var $51vnM = parcelRequire("51vnM");


var $dTa0V = parcelRequire("dTa0V");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $lhkth = parcelRequire("lhkth");

var $fdS54 = parcelRequire("fdS54");

var $iSoIx = parcelRequire("iSoIx");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $c8hth = parcelRequire("c8hth");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $6dc16 = parcelRequire("6dc16");

var $cpnl1 = parcelRequire("cpnl1");

var $f9tnr = parcelRequire("f9tnr");

var $b6NJA = parcelRequire("b6NJA");

var $ble5H = parcelRequire("ble5H");

var $U9h5y = parcelRequire("U9h5y");

var $8HUuJ = parcelRequire("8HUuJ");

var $PQuix = parcelRequire("PQuix");

var $74h93 = parcelRequire("74h93");

var $cptf3 = parcelRequire("cptf3");

var $8deB6 = parcelRequire("8deB6");

var $9KM2b = parcelRequire("9KM2b");
const $6bbfff077daa4fb5$var$csmCustomQueuePageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8deB6.queuesAgentAndIssueViewEntryPoint),
    horizontalNavigation: (0, $6dc16.horizontalNavQueueEntrypoint)
});
const $6bbfff077daa4fb5$export$1d3fffdc134b6d60 = (0, $fdS54.createEntry)((0, $PQuix.csmCustomQueueRoute), ()=>({
        group: 'customer-service',
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        preloadOptions: {
            earlyChunks: (0, $i860n.fg)('queues-earlyscripts') ? [
                'queues-prefetch-early-entry'
            ] : []
        },
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        skeleton: (0, $9KM2b.QueueLoadingSkeleton),
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $cpnl1.issueListSsrResource),
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            ...(0, $lbxXL.getTriageButtonPermissionResource)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $ble5H.servicedeskIsItsmProjectResource),
            (0, $U9h5y.getJsmIssueViewRelatedArticlesRouteResource)(),
            (0, $c8hth.horizontalNavQueueResource),
            (0, $f9tnr.queuesJqlBuilderHydrationQueryRelayResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $2700E.expVal)('corcap-6777-ai-jqlbuilder-in-queues', 'isEnabled', false), (0, $b6NJA.queuesJqlBuilderAiQueryRelayResource))
        ],
        afterPaint: (0, $i860n.fg)('jsm_remove_queue_bulk_action_bar_from_preloading') ? [
            (0, $51vnM.LazyIssueApp)
        ] : [
            (0, $51vnM.LazyIssueApp),
            (0, $cptf3.AsyncBulkActionToolbarLazy)
        ],
        // It is important to keep this component consistent across the routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $6bbfff077daa4fb5$var$csmCustomQueuePageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        isHydrateRootEnabled: false,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'jira-service-management',
            manifestName: 'jira-spa-jira-service-management.json',
            fetchTimeout: 1500
        }
    }));

});
parcelRegister("c8hth", function(module, exports) {
$parcel$export(module.exports, "horizontalNavQueueResource", () => $94a4f2fbae065316$export$896712202052ca56);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3nBDT = parcelRequire("3nBDT");

var $i0CFV = parcelRequire("i0CFV");

var $htsFl = parcelRequire("htsFl");

var $lC5kV = parcelRequire("lC5kV");

var $c4rhk = parcelRequire("c4rhk");
const $94a4f2fbae065316$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;
const $94a4f2fbae065316$export$71eec30d9db46a56 = (// oxlint-disable-next-line typescript/no-explicit-any
{ match: match, query: query }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const queueId = match.params.queueId;
    let { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const queueAri = queueId ? (0, $lC5kV.JiraServicedeskQueueAri).create({
        siteId: cloudId,
        queueId: queueId || '',
        activationId: activationId
    }).toString() : '';
    const containerNavigationInput = queueAri ? {
        scopeId: queueAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: $3nBDT.default,
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            containerNavigationInput: containerNavigationInput,
            first: $94a4f2fbae065316$var$NAVIGATION_ITEMS_PAGE_SIZE
        }
    };
};
const $94a4f2fbae065316$export$896712202052ca56 = (0, $c4rhk.withGiraAggAnonSsrFix)((0, $htsFl.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_QUEUE_QUERY',
    getQuery: $94a4f2fbae065316$export$71eec30d9db46a56
}));

});

parcelRegister("f9tnr", function(module, exports) {
$parcel$export(module.exports, "queuesJqlBuilderHydrationQueryRelayResource", () => $bd4898e5aaa0d041$export$222b1728cc9334ea);
/* eslint-disable jira/filename-case, jira/import-whitelist, jira/naming/disallow-filenames */ 
var $n67Vb = parcelRequire("n67Vb");

var $aI7em = parcelRequire("aI7em");

var $5SJ3N = parcelRequire("5SJ3N");

var $htsFl = parcelRequire("htsFl");

var $7edbf = parcelRequire("7edbf");

var $2MVij = parcelRequire("2MVij");
const $bd4898e5aaa0d041$export$8d46a2efdf233f05 = 'queues-jql-builder-hydration-relay';
const $bd4898e5aaa0d041$export$222b1728cc9334ea = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${$bd4898e5aaa0d041$export$8d46a2efdf233f05}`,
    getKey: ()=>$bd4898e5aaa0d041$export$8d46a2efdf233f05,
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $2MVij.default), {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            viewContext: null,
            input: {
                jql: ''
            }
        }, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null && (0, $5SJ3N.QueryPromisesMap).get(queryReference.id)) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("2MVij", function(module, exports) {
$parcel$export(module.exports, "default", () => $54720a23b396ef24$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20ece51b36f1c735ebc1f73bb2fc4f56>>
 * @relayHash 239c1af6e002f167e7c60837376bcb5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2c22f01f6190e13082330c0636af5bb6c20b0eaac6a00dd9b56671fc397204a

var $cXQYg = parcelRequire("cXQYg");
const $54720a23b396ef24$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeJira"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUser"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarwithapptypeforjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appType"
                        }
                    ]
                }
            ],
            "type": "AppUser"
        },
        v12 /*: any*/ 
    ], v14 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "kind": "ScalarField",
        "name": "key"
    }, v17 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v12 /*: any*/ 
            ]
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "optionId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useHydrationQueryLoaderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JQLBuilderUI"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "JQLEditorUIWithErrorBoundary"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "QuerySupportedContainerOld"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValuesUtils"
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v9 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v11 /*: any*/ 
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarwithapptypeforjqlrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useHydrationQueryLoaderQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v9 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": true,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraJqlField",
                                                                            "kind": "LinkedField",
                                                                            "name": "field",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraJqlSearchTemplate",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "searchTemplate",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "shouldShowInContext"
                                                                                },
                                                                                {
                                                                                    "args": [
                                                                                        v8 /*: any*/ 
                                                                                    ],
                                                                                    "kind": "ScalarField",
                                                                                    "name": "shouldExcludeInScope"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "type"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "description"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "operators"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraFieldType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v15 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "values",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v14 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "values",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                v14 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "small"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlProjectFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v17 /*: any*/ ,
                                                                                                    "type": "JiraJqlStatusFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v17 /*: any*/ ,
                                                                                                    "type": "JiraJqlStatusCategoryFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypes",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "xsmall"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlIssueTypeFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": v13 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlUserFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlPriorityFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fields",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "text"
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlIssueFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprint",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "sprint",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "state"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "boardName"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlSprintFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "townsquareProject",
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconName"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlTownsquareProjectFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoal",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "goal",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "status"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconKey"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlGoalsFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v15 /*: any*/ ,
                                                                                                                v14 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlCascadingOptionFieldValue"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraJqlQueryHydratedValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v14 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "QueryError",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "error",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraJqlQueryHydratedError"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlQueryHydratedField"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "message"
                                                        }
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b2c22f01f6190e13082330c0636af5bb6c20b0eaac6a00dd9b56671fc397204a",
            "metadata": {},
            "name": "useHydrationQueryLoaderQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarwithapptypeforjqlrelayprovider": (0, $cXQYg.default)
            }
        }
    };
}();
$54720a23b396ef24$var$node.hash = "c4cc5243d170b31970d6708f0d8a9207";
var $54720a23b396ef24$export$2e2bcd8739ae039 = $54720a23b396ef24$var$node;

});
parcelRegister("cXQYg", function(module, exports) {
$parcel$export(module.exports, "default", () => $b39d9b059c16c681$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $b39d9b059c16c681$var$JiraAiAgentAvatarWithApptypeForJqlRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_ai_agent_avatar_with_apptype_for_jql');
    }
};
var $b39d9b059c16c681$export$2e2bcd8739ae039 = $b39d9b059c16c681$var$JiraAiAgentAvatarWithApptypeForJqlRelayProvider;

});



parcelRegister("b6NJA", function(module, exports) {
$parcel$export(module.exports, "queuesJqlBuilderAiQueryRelayResource", () => $192379a4c6a043ce$export$4324f0e2e992948b);
/* eslint-disable jira/import-whitelist -- route resource manually preloads Relay query data for JQLBuilderWithAI */ 
var $n67Vb = parcelRequire("n67Vb");

var $aI7em = parcelRequire("aI7em");

var $5SJ3N = parcelRequire("5SJ3N");

var $htsFl = parcelRequire("htsFl");

var $7edbf = parcelRequire("7edbf");

var $eegqi = parcelRequire("eegqi");
const $192379a4c6a043ce$export$3d6dbedbefe8e4e4 = 'queues-jql-builder-ai-relay';
const $192379a4c6a043ce$export$4324f0e2e992948b = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${$192379a4c6a043ce$export$3d6dbedbefe8e4e4}`,
    getKey: ()=>$192379a4c6a043ce$export$3d6dbedbefe8e4e4,
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $eegqi.default), {
            cloudId: tenantContext.cloudId,
            atlassianIntelligenceProductFeature: 'NATURAL_LANGUAGE_TO_JQL'
        }, {
            fetchPolicy: 'store-or-network'
        });
        const queryPromise = queryReference.id != null ? (0, $5SJ3N.QueryPromisesMap).get(queryReference.id) : undefined;
        if (queryPromise != null) await queryPromise;
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("eegqi", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdf2d7b8b16947f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d29007b7d4ee82309f0574a25db499e0>>
 * @relayHash 8ba23a3033e271b2b70a255a9c8bd6d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ecdeb1bd66cac0bf544316ff4e217802a259049e25937b514d03b94e4485247
const $fdf2d7b8b16947f6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "queuesJqlBuilderAiQueryRelayResourceQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "JQLBuilderWithAIEntryPoint"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "queuesJqlBuilderAiQueryRelayResourceQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3ecdeb1bd66cac0bf544316ff4e217802a259049e25937b514d03b94e4485247",
            "metadata": {},
            "name": "queuesJqlBuilderAiQueryRelayResourceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fdf2d7b8b16947f6$var$node.hash = "d71d8511c413de80c8de2e44a2cc887a";
var $fdf2d7b8b16947f6$export$2e2bcd8739ae039 = $fdf2d7b8b16947f6$var$node;

});


parcelRegister("PQuix", function(module, exports) {
$parcel$export(module.exports, "csmCustomQueueRoute", () => $e2b2d84c5ef805ae$export$4a2ba871bc7f7268);
const $e2b2d84c5ef805ae$export$4a2ba871bc7f7268 = {
    name: 'csm-queues-custom-view',
    path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId',
    exact: true
};

});

parcelRegister("cptf3", function(module, exports) {
$parcel$export(module.exports, "AsyncBulkActionToolbarLazy", () => $9f985c940b7459fc$export$f0945fba2003d80a);
$parcel$export(module.exports, "AsyncBulkActionToolbar", () => $9f985c940b7459fc$export$d53c287f3c6193b2);
/* AsyncBulkActionToolbarLazy.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $ihEDU = parcelRequire("ihEDU");

var $cCE2Z = parcelRequire("cCE2Z");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $i860n = parcelRequire("i860n");
// Match the height of the toolbar
const $9f985c940b7459fc$var$HEIGHT = 24;

const $9f985c940b7459fc$export$f0945fba2003d80a = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("l0E60")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/bulk-actions-toolbar/src/BulkActionToolbar.tsx"
});
const $9f985c940b7459fc$export$d53c287f3c6193b2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "async.jira-servicedesk.bulk-actions.toolbar",
        packageName: "atlassian/jira-servicedesk-bulk-actions-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "servicedesk-bulk-actions-toolbar",
        fallback: (0, $i860n.fg)('jsm_remove_queue_bulk_action_bar_from_preloading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
            xcss: $9f985c940b7459fc$var$styles.skeletonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            height: `${$9f985c940b7459fc$var$HEIGHT}px`,
            width: "60vw",
            isShimmering: true
        })) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9f985c940b7459fc$export$f0945fba2003d80a, props)));
$9f985c940b7459fc$export$d53c287f3c6193b2.displayName = "AsyncBulkActionToolbar";
const $9f985c940b7459fc$var$styles = {
    skeletonContainer: "_1bsbauwl _bfhkvuon _19bvu2gc"
};

});
parcelRegister("l0E60", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ltmeg")
]).then(()=>parcelRequire('b6fvZ'));

});



parcelRegister("asE3T", function(module, exports) {
$parcel$export(module.exports, "csmExperienceAgentStudioRouteEntry", () => $1ae70e7d79fefaa9$export$8d5a60efb8e57e02);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $ksl4b = parcelRequire("ksl4b");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $9hSoa = parcelRequire("9hSoa");
const $1ae70e7d79fefaa9$export$8d5a60efb8e57e02 = (0, $fdS54.createEntry)((0, $ksl4b.csmExperienceAgentStudioRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-agent-studio',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $9hSoa.csmAgentOverviewPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ksl4b", function(module, exports) {
$parcel$export(module.exports, "csmExperienceAgentStudioRoute", () => $b427c002bc1b1f3e$export$95c5d5a4643c20d3);
const $b427c002bc1b1f3e$export$95c5d5a4643c20d3 = {
    name: 'csm-experience-agent-studio',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/agent',
    exact: true
};

});

parcelRegister("5yPS0", function(module, exports) {
$parcel$export(module.exports, "getCsmExperiencesResources", () => $9b9ddc48f3b79595$export$593fefed3e444c33);

var $2nex5 = parcelRequire("2nex5");

var $edf7u = parcelRequire("edf7u");

var $koA6h = parcelRequire("koA6h");

var $iyqMX = parcelRequire("iyqMX");
function $9b9ddc48f3b79595$export$593fefed3e444c33() {
    return [
        (0, $edf7u.projectContextResource),
        (0, $iyqMX.serviceDeskContextResource),
        (0, $koA6h.serviceDeskAnalyticsContextResource),
        (0, $2nex5.customerExperiencesNavigationResource)
    ];
}

});
parcelRegister("2nex5", function(module, exports) {
$parcel$export(module.exports, "customerExperiencesNavigationResource", () => $14757851748a2bcc$export$7abebfa98e3c8a6d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $htsFl = parcelRequire("htsFl");

var $21xuP = parcelRequire("21xuP");
const $14757851748a2bcc$export$7abebfa98e3c8a6d = (0, $htsFl.createRelayResource)({
    type: 'CUSTOMER_EXPERIENCES_NAVIGATION_RESOURCE',
    getQuery (_routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        return {
            parameters: (0, $21xuP.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`
            }
        };
    }
});

});
parcelRegister("21xuP", function(module, exports) {
$parcel$export(module.exports, "default", () => $603a8db457da192d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e6a6f3676cb7170d216f4a85a1fff043>>
 * @relayHash f9b1ea1a3ae84104acb695f184353f7a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d25d292a81cd43d7f2e30b059cfb66ff3c67a1611301e5844916e368344d615
const $603a8db457da192d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        },
        {
            "kind": "Literal",
            "name": "sortOrder",
            "value": "CREATED_DATE_DESCENDING"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomerExperiencesListQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "HelpCenterQueryApi",
                        "kind": "LinkedField",
                        "name": "helpCenter",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "HelpCenterQueryResultConnection",
                                    "kind": "LinkedField",
                                    "name": "customerExperiences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterQueryResultEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW"
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "CustomerExperienceMenuContent_helpCenter"
                                                                }
                                                            ],
                                                            "type": "HelpCenter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomerExperiencesListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "customerExperiences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterName",
                                                            "kind": "LinkedField",
                                                            "name": "name",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "default"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hoistedProjectKey"
                                                        }
                                                    ],
                                                    "type": "HelpCenter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9d25d292a81cd43d7f2e30b059cfb66ff3c67a1611301e5844916e368344d615",
            "metadata": {},
            "name": "CustomerExperiencesListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$603a8db457da192d$var$node.hash = "335974134dfcd6458237b44dca0c611b";
var $603a8db457da192d$export$2e2bcd8739ae039 = $603a8db457da192d$var$node;

});



parcelRegister("9hSoa", function(module, exports) {
$parcel$export(module.exports, "LazyAgentStudioOverviewPage", () => $5c605b24ebb57ae8$export$5fa375047554c75c);
$parcel$export(module.exports, "AgentStudioOverviewPage", () => $5c605b24ebb57ae8$export$3c32337b9e9c89e5);
$parcel$export(module.exports, "csmAgentOverviewPageEntryPoint", () => $5c605b24ebb57ae8$export$64672a53ea64d95b);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fiW7u = parcelRequire("fiW7u");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $dTa0V = parcelRequire("dTa0V");

const $5c605b24ebb57ae8$export$5fa375047554c75c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("i8Uyr"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings-agent-studio/src/AgentOverview.tsx"
});
const $5c605b24ebb57ae8$export$3c32337b9e9c89e5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5c605b24ebb57ae8$export$5fa375047554c75c,
        pageId: "help-center-settings-agent-studio-overview",
        shouldShowSpinner: true
    });
$5c605b24ebb57ae8$export$3c32337b9e9c89e5.displayName = "AgentStudioOverviewPage";
const $5c605b24ebb57ae8$export$64672a53ea64d95b = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fiW7u.csmAgentOverviewEntryPoint)
});

});
parcelRegister("fiW7u", function(module, exports) {
$parcel$export(module.exports, "csmAgentOverviewEntryPoint", () => $212015fa4ef4ee37$export$50a5fd926c9d7bb4);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $ivTJy = parcelRequire("ivTJy");

var $kv308 = parcelRequire("kv308");

const $212015fa4ef4ee37$export$50a5fd926c9d7bb4 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("i8Uyr")), {
        moduleId: "b51ba2b9",
        moduleName: "AgentOverview",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { activationId: activationId } = tenantContext;
        const { helpCenterId: helpCenterId } = context.match.params;
        if (!activationId || activationId === ':activationId') return {};
        if (!helpCenterId || helpCenterId === ':helpCenterId') return {};
        const helpCenterAri = (0, $ivTJy.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        return {
            queries: {
                page: {
                    parameters: (0, $kv308.default),
                    variables: {
                        helpCenterAri: helpCenterAri,
                        cloudId: tenantContext.cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("ivTJy", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAri", () => $d7a65ad0ecca9cae$export$a75f3c98d930b258);

var $2b094 = parcelRequire("2b094");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/help/help-center/manifest.ts
var $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $2b094.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $2b094.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/help-center/index.ts
var $d7a65ad0ecca9cae$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $d7a65ad0ecca9cae$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("2b094", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $195cb8ba47e4f94d$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $195cb8ba47e4f94d$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $195cb8ba47e4f94d$export$a4af98a27b4568ee = "help", $195cb8ba47e4f94d$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("kv308", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba1d799935c0a26c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ff42b0c4f0b32ef58f4dfdab24018c9>>
 * @relayHash 50b4e9c9f7cb5e26f7a233aab172101d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cde8e6d55e08a968a422a60db9774d36880affae57e6e9bbcbb6123cfd9cc2fb
const $ba1d799935c0a26c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "versionType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v9 = [
        {
            "kind": "Literal",
            "name": "entityType",
            "value": "CUSTOMER_HUB"
        },
        {
            "kind": "Variable",
            "name": "helpCenterId",
            "variableName": "helpCenterAri"
        }
    ], v10 = {
        "concreteType": "CustomerServiceBrandingIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AgentOverviewQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agents",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiVersionAgentSummary_AtlassianCsmAgentOverview"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "CsmAiAgentVersionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "versions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "CsmAiAgentVersion",
                                                                "kind": "LinkedField",
                                                                "name": "nodes",
                                                                "plural": true,
                                                                "selections": [
                                                                    v6 /*: any*/ 
                                                                ]
                                                            },
                                                            "action": "THROW"
                                                        }
                                                    ],
                                                    "storageKey": "versions(first:2)"
                                                }
                                            ],
                                            "type": "CsmAiMultiVersionAgent"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                },
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "brandingByEntityType",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v10 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceBranding"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AgentOverviewQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agents",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isCsmAiMultiVersionAgentResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "agentId"
                                                },
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "CsmAiAgentVersionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "versions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CsmAiAgentVersion",
                                                            "kind": "LinkedField",
                                                            "name": "nodes",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionNumber"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "agentIdentityConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                v4 /*: any*/ 
                                                                            ],
                                                                            "type": "CsmAiAgentIdentity"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "message"
                                                                                }
                                                                            ],
                                                                            "type": "QueryError"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "versions(first:2)"
                                                }
                                            ],
                                            "type": "CsmAiMultiVersionAgent"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                },
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "brandingByEntityType",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceBranding"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cde8e6d55e08a968a422a60db9774d36880affae57e6e9bbcbb6123cfd9cc2fb",
            "metadata": {},
            "name": "AgentOverviewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ba1d799935c0a26c$var$node.hash = "0e67e8e175f974c8eae419955c918ad9";
var $ba1d799935c0a26c$export$2e2bcd8739ae039 = $ba1d799935c0a26c$var$node;

});

parcelRegister("i8Uyr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ilwnq")
]).then(()=>parcelRequire('lwNXL'));

});




parcelRegister("dbws7", function(module, exports) {
$parcel$export(module.exports, "csmExperienceArticlesRouteEntry", () => $8e05c782e7180e57$export$e3be9a48681d333f);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $okUqe = parcelRequire("okUqe");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $culYu = parcelRequire("culYu");
const $8e05c782e7180e57$export$e3be9a48681d333f = (0, $fdS54.createEntry)((0, $okUqe.csmExperienceArticlesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-articles',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $culYu.helpCenterSettingArticlesAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("okUqe", function(module, exports) {
$parcel$export(module.exports, "csmExperienceArticlesRoute", () => $db3c0bb7e355197c$export$f995206f9d207aa7);
const $db3c0bb7e355197c$export$f995206f9d207aa7 = {
    name: 'csm-experience-articles',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/articles',
    exact: true
};

});

parcelRegister("culYu", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingArticlesAppPageEntryPoint", () => $29c235a3dc8af533$export$5f683051fd990adb);
/* eslint-disable jira/naming/disallow-filenames */ 
var $la3zP = parcelRequire("la3zP");

var $dTa0V = parcelRequire("dTa0V");
const $29c235a3dc8af533$export$5f683051fd990adb = (0, $dTa0V.createPageEntryPoint)({
    main: $la3zP.HelpCenterSettingsArticlesAppEntryPoint
});

});
parcelRegister("la3zP", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsArticlesAppEntryPoint", () => $97685cbd9560c3db$export$ba888b162abf6368);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $97685cbd9560c3db$export$ba888b162abf6368 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gif9U")), {
        moduleId: "eb5e9b3f",
        moduleName: "HelpCenterSettingsArticlesComponent",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("gif9U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("7VWKk")
]).then(()=>parcelRequire('kFhsB'));

});




parcelRegister("adv8s", function(module, exports) {
$parcel$export(module.exports, "csmExperienceBrandingRouteEntry", () => $6fdec79a8028de2c$export$f51c97e34f77eebf);

var $i860n = parcelRequire("i860n");

var $gO1oK = parcelRequire("gO1oK");



var $QhQu4 = parcelRequire("QhQu4");
var $bKPo4 = parcelRequire("bKPo4");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $4XiGx = parcelRequire("4XiGx");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $aDN0P = parcelRequire("aDN0P");
const $6fdec79a8028de2c$export$f51c97e34f77eebf = (0, $fdS54.createEntry)((0, $4XiGx.csmExperienceBrandingRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-branding',
        layout: (0, $bKPo4.layoutWithCondition)(()=>(0, $i860n.fg)('csm-support-widget-in-csm'), (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $gO1oK.csmWidgetLayout)), (0, $74h93.serviceProjectLayout)),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $aDN0P.helpCenterSettingBrandingAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gO1oK", function(module, exports) {
$parcel$export(module.exports, "csmWidgetLayout", () => $e45c1dc9532f376a$export$5f9c5cd9b865be5c);

var $fLj0q = parcelRequire("fLj0q");
const $e45c1dc9532f376a$export$5f9c5cd9b865be5c = {
    globalComponents: [
        (0, $fLj0q.LazyCsmSupportWidget)
    ],
    rightSidebars: [],
    isChromeless: false
};

});
parcelRegister("fLj0q", function(module, exports) {
$parcel$export(module.exports, "LazyCsmSupportWidget", () => $c4e83f22a8196aa3$export$4a92c4482e7841ff);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $l8G1z = parcelRequire("l8G1z");

var $6x5Yw = parcelRequire("6x5Yw");

const $c4e83f22a8196aa3$var$LazyWidget = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("1oSpG")), {
    moduleId: "./src/packages/customer-service/csm-widget/src/CsmSupportWidget.tsx"
});
const $c4e83f22a8196aa3$export$4a92c4482e7841ff = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "csmSupportWidget",
        packageName: "jiraCustomerServiceCsmSupportWidgetLayout",
        teamName: "csm-ai-exp",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6x5Yw.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c4e83f22a8196aa3$var$LazyWidget, null)));
};
$c4e83f22a8196aa3$export$4a92c4482e7841ff.displayName = "LazyCsmSupportWidget";

});
parcelRegister("1oSpG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jSZGO").then(()=>parcelRequire('dwMc9'));

});



parcelRegister("4XiGx", function(module, exports) {
$parcel$export(module.exports, "csmExperienceBrandingRoute", () => $ef8a49483cdd819d$export$5586b33fd2f75303);
const $ef8a49483cdd819d$export$5586b33fd2f75303 = {
    name: 'csm-experience-branding',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/branding',
    exact: true
};

});

parcelRegister("aDN0P", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingBrandingAppPageEntryPoint", () => $a8990f17cc413af3$export$bb128cb1d0aaba4d);
/* eslint-disable jira/naming/disallow-filenames */ 
var $6Lv3l = parcelRequire("6Lv3l");

var $dTa0V = parcelRequire("dTa0V");
const $a8990f17cc413af3$export$bb128cb1d0aaba4d = (0, $dTa0V.createPageEntryPoint)({
    main: $6Lv3l.helpCenterSettingBrandingAppEntryPoint
});

});
parcelRegister("6Lv3l", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingBrandingAppEntryPoint", () => $752a4f28dcdb80c4$export$f1525531cb4c9a9c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i6vG4 = parcelRequire("i6vG4");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $752a4f28dcdb80c4$export$f1525531cb4c9a9c = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("fxqsN")), {
        moduleId: "024a0202",
        moduleName: "HelpCenterSettingBrandingApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                GlobalBrandingQuery: {
                    parameters: $i6vG4.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("i6vG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f9f080b3c5c0002$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c4435addab79d2cfc85c3b4806295de9>>
 * @relayHash 694c32f0ae1849b6ceb275ad9c327a4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 984a60ac1584464fe481194ea6de6488c49e19c3d0f35d1318d5644340c442aa
const $6f9f080b3c5c0002$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "984a60ac1584464fe481194ea6de6488c49e19c3d0f35d1318d5644340c442aa",
        "metadata": {},
        "name": "GlobalBrandingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6f9f080b3c5c0002$export$2e2bcd8739ae039 = $6f9f080b3c5c0002$var$node;

});

parcelRegister("fxqsN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("czs9H").then(()=>parcelRequire('6pURU'));

});




parcelRegister("3gpmo", function(module, exports) {
$parcel$export(module.exports, "csmExperienceChatConfigurationRouteEntry", () => $cf18d5f766eb78c8$export$c702942602032def);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $6Vg2m = parcelRequire("6Vg2m");

var $iSoIx = parcelRequire("iSoIx");

var $aSRe7 = parcelRequire("aSRe7");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");
const $cf18d5f766eb78c8$var$HelpCenterSettingsChatConfigurationEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: $aSRe7.HelpCenterSettingsChatConfiguration
});
const $cf18d5f766eb78c8$export$c702942602032def = (0, $fdS54.createEntry)((0, $6Vg2m.csmExperienceChatConfigurationRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-chat-configuration',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            if (!(0, $i860n.fg)('csm_appification_standalone_navigation')) return 0, $iSoIx.notFoundPageEntrypoint;
            return (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget') ? $cf18d5f766eb78c8$var$HelpCenterSettingsChatConfigurationEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6Vg2m", function(module, exports) {
$parcel$export(module.exports, "csmExperienceChatConfigurationRoute", () => $4f04462ac409046f$export$db3c855c828a174);
const $4f04462ac409046f$export$db3c855c828a174 = {
    name: 'csm-experience-chat-configuration',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/chat',
    exact: true
};

});

parcelRegister("aSRe7", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsChatConfiguration", () => $ce43ba7bca121cf1$export$afaaaf5686bece50);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ce43ba7bca121cf1$export$afaaaf5686bece50 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("fBVAD")), {
        moduleId: "388ea1a7",
        moduleName: "HelpCenterSettingsChatConfigurationApp",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fBVAD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gG1Bb").then(()=>parcelRequire('bi7eJ'));

});



parcelRegister("6uOxh", function(module, exports) {
$parcel$export(module.exports, "csmExperienceCustomerAccessRouteEntry", () => $930f7f0de91bfab1$export$752d25e8d3d6212d);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $hKTw5 = parcelRequire("hKTw5");

var $imXbM = parcelRequire("imXbM");

var $lhkth = parcelRequire("lhkth");

var $8ER0Y = parcelRequire("8ER0Y");

var $iSoIx = parcelRequire("iSoIx");

var $8HUuJ = parcelRequire("8HUuJ");

var $5yPS0 = parcelRequire("5yPS0");

var $e7Hxd = parcelRequire("e7Hxd");
const $930f7f0de91bfab1$export$752d25e8d3d6212d = (0, $fdS54.createEntry)((0, $8ER0Y.csmExperienceCustomerAccessRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-customer-access',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $e7Hxd.helpCenterSettingsCustomerAccessAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $imXbM.jsmGlobalCustomerAccessSettingsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_customer_access_jsm_separation'), (0, $hKTw5.csmGlobalCustomerAccessSettingsResource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hKTw5", function(module, exports) {
$parcel$export(module.exports, "csmGlobalCustomerAccessSettingsResource", () => $cfefd0fe5d02d353$export$9420139a1092c08);

var $7edbf = parcelRequire("7edbf");

const $cfefd0fe5d02d353$var$ONE_DAY_IN_MILLIS = 86400000;

const $cfefd0fe5d02d353$export$9420139a1092c08 = (0, $7edbf.createResource)({
    type: (0, $e0abe4b4d2233247$export$f80b292a700e111f),
    getKey: ({ match: match })=>`settings-${match.params.projectKey || ''}`,
    getDataLoader: ()=>(parcelRequire("7a2pm")),
    maxAge: $cfefd0fe5d02d353$var$ONE_DAY_IN_MILLIS
});

});
const $e0abe4b4d2233247$export$f80b292a700e111f = 'CSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("7a2pm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bo90j").then(()=>parcelRequire('7CkGo'));

});


parcelRegister("imXbM", function(module, exports) {
$parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", () => $f1b8bdb237d0d28e$export$b1a50ad717b4ca61);

var $7edbf = parcelRequire("7edbf");

const $f1b8bdb237d0d28e$var$ONE_DAY_IN_MILLIS = 86400000;

const $f1b8bdb237d0d28e$export$b1a50ad717b4ca61 = (0, $7edbf.createResource)({
    type: (0, $13b64a53cbc9afb4$export$eb7818fb178a80b4),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("1Z5kZ")),
    maxAge: $f1b8bdb237d0d28e$var$ONE_DAY_IN_MILLIS
});

});
const $13b64a53cbc9afb4$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $13b64a53cbc9afb4$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("1Z5kZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cLGYx").then(()=>parcelRequire('7mhyr'));

});


parcelRegister("8ER0Y", function(module, exports) {
$parcel$export(module.exports, "csmExperienceCustomerAccessRoute", () => $62049e2b2b3e0eb7$export$c5a2c29508b7a80e);
const $62049e2b2b3e0eb7$export$c5a2c29508b7a80e = {
    name: 'csm-experience-customer-access',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/customer-access',
    exact: true
};

});

parcelRegister("e7Hxd", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerAccessAppPageEntryPoint", () => $a318defe1f209d46$export$d9f258bef4ddbfb3);
$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerAccess", () => $a318defe1f209d46$export$2c331ddbdb6fb4ef);
$parcel$export(module.exports, "HelpCenterSettingsCustomerAccess", () => $a318defe1f209d46$export$ab643bb246877df);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $HXImI = parcelRequire("HXImI");

var $dTa0V = parcelRequire("dTa0V");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");
const $a318defe1f209d46$export$d9f258bef4ddbfb3 = (0, $dTa0V.createPageEntryPoint)({
    main: $HXImI.helpCenterSettingsCustomerAccessAppEntryPoint
});

const $a318defe1f209d46$export$2c331ddbdb6fb4ef = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("1BCdB"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings-customer-access/src/HelpCenterSettingsCustomerAccessPage.tsx"
});
const $a318defe1f209d46$export$ab643bb246877df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $a318defe1f209d46$export$2c331ddbdb6fb4ef,
        pageId: "help-center-settings-customer-access",
        shouldShowSpinner: true
    });
$a318defe1f209d46$export$ab643bb246877df.displayName = "HelpCenterSettingsCustomerAccess";

});
parcelRegister("HXImI", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerAccessAppEntryPoint", () => $8ddb226aa77f2b07$export$7542e3646326ae2b);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $8ddb226aa77f2b07$export$7542e3646326ae2b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1BCdB")), {
        moduleId: "a79ec062",
        moduleName: "HelpCenterSettingsCustomerAccessPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1BCdB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("aQIU1")
]).then(()=>parcelRequire('7Qj5w'));

});




parcelRegister("frSu6", function(module, exports) {
$parcel$export(module.exports, "csmExperienceCustomerNotificationsRouteEntry", () => $6588dffe19a36c73$export$d36991257840bc77);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $lhkth = parcelRequire("lhkth");

var $hhO1s = parcelRequire("hhO1s");

var $iSoIx = parcelRequire("iSoIx");

var $5yPS0 = parcelRequire("5yPS0");

var $fU1OC = parcelRequire("fU1OC");
const $6588dffe19a36c73$export$d36991257840bc77 = (0, $fdS54.createEntry)((0, $hhO1s.csmExperienceCustomerNotificationsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-customer-notifications',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $fU1OC.helpCenterSettingsCustomerNotificationsAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hhO1s", function(module, exports) {
$parcel$export(module.exports, "csmExperienceCustomerNotificationsRoute", () => $052212ca8d339e9b$export$cc1ceb9a705f7529);
const $052212ca8d339e9b$export$cc1ceb9a705f7529 = {
    name: 'csm-experience-customer-notifications',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/customer-notifications',
    exact: true
};

});

parcelRegister("fU1OC", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsAppPageEntryPoint", () => $a0a0dca1117d2407$export$2bb06ac54f407f5c);
$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerNotifications", () => $a0a0dca1117d2407$export$b2b6550dec008a98);
$parcel$export(module.exports, "HelpCenterSettingsCustomerNotifications", () => $a0a0dca1117d2407$export$2f2f18f57014444a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gzk0V = parcelRequire("gzk0V");

var $dTa0V = parcelRequire("dTa0V");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $cZjb4 = parcelRequire("cZjb4");
const $a0a0dca1117d2407$export$2bb06ac54f407f5c = (0, $dTa0V.createPageEntryPoint)({
    main: $gzk0V.helpCenterSettingsCustomerNotificationsAppEntryPoint
});

const $a0a0dca1117d2407$export$b2b6550dec008a98 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dePqQ"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings-customer-notifications/src/ExportedComponent.tsx"
});
const $a0a0dca1117d2407$export$2f2f18f57014444a = ()=>{
    const [helpCenterId] = (0, $cZjb4.usePathParam)('helpCenterId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        // Customer notifications page does not handle projectKey change so we're passing the helpCenterId as a key to force a re-render
        key: helpCenterId,
        Page: $a0a0dca1117d2407$export$b2b6550dec008a98,
        pageId: "help-center-settings-customer-notifications",
        shouldShowSpinner: true
    });
};
$a0a0dca1117d2407$export$2f2f18f57014444a.displayName = "HelpCenterSettingsCustomerNotifications";

});
parcelRegister("gzk0V", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsAppEntryPoint", () => $2a60d66652536c1c$export$c7c8befa36621ce1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $2a60d66652536c1c$export$c7c8befa36621ce1 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dePqQ")), {
        moduleId: "b2c7e5d7",
        moduleName: "ExportedComponent",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dePqQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9LWIF").then(()=>parcelRequire('hVYf4'));

});




parcelRegister("67hGn", function(module, exports) {
$parcel$export(module.exports, "csmExperienceDetailsRouteEntry", () => $d6d5f5da0a132e00$export$738dea933980958d);

var $i860n = parcelRequire("i860n");

var $gO1oK = parcelRequire("gO1oK");



var $QhQu4 = parcelRequire("QhQu4");
var $bKPo4 = parcelRequire("bKPo4");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $6rbdo = parcelRequire("6rbdo");

var $lhkth = parcelRequire("lhkth");

var $hVV7V = parcelRequire("hVV7V");

var $iSoIx = parcelRequire("iSoIx");

var $5yPS0 = parcelRequire("5yPS0");

var $bedjq = parcelRequire("bedjq");
const $d6d5f5da0a132e00$export$738dea933980958d = (0, $fdS54.createEntry)((0, $hVV7V.csmExperienceDetailsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-details',
        layout: (0, $bKPo4.layoutWithCondition)(()=>(0, $i860n.fg)('csm-support-widget-in-csm'), (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $gO1oK.csmWidgetLayout)), (0, $74h93.serviceProjectLayout)),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $bedjq.helpCenterSettingDetailsAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $6rbdo.csmHubSetupResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6rbdo", function(module, exports) {
$parcel$export(module.exports, "csmHubSetupResource", () => $e16f8a7d40b2c919$export$23a610c2a49b1040);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $igWj4 = parcelRequire("igWj4");
const $e16f8a7d40b2c919$export$23a610c2a49b1040 = (0, $igWj4.createProjectPropertyResource)({
    propertyKey: 'csmHubSetup.collapsed',
    maxAge: 0
});

});
parcelRegister("igWj4", function(module, exports) {
$parcel$export(module.exports, "createProjectPropertyResource", () => $20bb2f7401e45989$export$e2b8d61222ad9df4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $20bb2f7401e45989$export$e2b8d61222ad9df4 = ({ propertyKey: propertyKey, maxAge: maxAge = 86400000 })=>(0, $7edbf.createResource)({
        type: `CSM_PROJECT_PROPERTIES___${propertyKey}`,
        getKey: ({ match: { params: { projectKey: projectKey } } })=>`${projectKey}___${propertyKey}`,
        getData: async ({ match: { params: { projectKey: projectKey } } })=>(0, $h2wCv.performGetRequest)(`/rest/api/3/project/${projectKey}/properties/${propertyKey}`).then((data)=>data?.value ?? null),
        maxAge: maxAge
    });

});


parcelRegister("hVV7V", function(module, exports) {
$parcel$export(module.exports, "csmExperienceDetailsRoute", () => $ad3a7f6a4b638509$export$14069bf3c105b03d);
const $ad3a7f6a4b638509$export$14069bf3c105b03d = {
    name: 'csm-experience-details',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});

parcelRegister("bedjq", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingDetailsAppPageEntryPoint", () => $e434b1532cfe2e6e$export$c52cb026d0dc8ed7);
/* eslint-disable jira/naming/disallow-filenames */ 
var $6g4th = parcelRequire("6g4th");

var $dTa0V = parcelRequire("dTa0V");
const $e434b1532cfe2e6e$export$c52cb026d0dc8ed7 = (0, $dTa0V.createPageEntryPoint)({
    main: $6g4th.helpCenterSettingDetailsAppEntryPoint
});

});
parcelRegister("6g4th", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingDetailsAppEntryPoint", () => $af5de6f0b67403bd$export$519ec4ef3722cb47);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $8y8u0 = parcelRequire("8y8u0");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $af5de6f0b67403bd$export$519ec4ef3722cb47 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("j7EvM")), {
        moduleId: "ab203fb8",
        moduleName: "HelpCenterSettingDetailsApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, projectKey: projectKey } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: (0, $8y8u0.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        projectIdOrKey: projectKey ?? ''
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("8y8u0", function(module, exports) {
$parcel$export(module.exports, "default", () => $1919ba7a2476b3f9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e465f54490c76f74b32f29c3948bc41>>
 * @relayHash b2d0a7a52dcfc0def29d87a1ae1deedd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8aa006b52c3bed531cf7807c7422a07309a35fca4cc3a50e7a6ab6f0fd7c74be
const $1919ba7a2476b3f9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8aa006b52c3bed531cf7807c7422a07309a35fca4cc3a50e7a6ab6f0fd7c74be",
        "metadata": {},
        "name": "ServiceHubDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1919ba7a2476b3f9$export$2e2bcd8739ae039 = $1919ba7a2476b3f9$var$node;

});

parcelRegister("j7EvM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ibtZ3").then(()=>parcelRequire('kvNvr'));

});




parcelRegister("5GDxf", function(module, exports) {
$parcel$export(module.exports, "csmExperienceEmailRouteEntry", () => $abf0dc351f9d58d2$export$23335850c83570ce);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $lhkth = parcelRequire("lhkth");

var $7MOpx = parcelRequire("7MOpx");

var $iSoIx = parcelRequire("iSoIx");

var $hLtFo = parcelRequire("hLtFo");

var $5yPS0 = parcelRequire("5yPS0");
const $abf0dc351f9d58d2$var$HelpCenterSettingsEmailEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: $hLtFo.HelpCenterSettingsEmailAppEntryPoint
});
const $abf0dc351f9d58d2$export$23335850c83570ce = (0, $fdS54.createEntry)((0, $7MOpx.csmExperienceEmailRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-email',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $abf0dc351f9d58d2$var$HelpCenterSettingsEmailEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7MOpx", function(module, exports) {
$parcel$export(module.exports, "csmExperienceEmailRoute", () => $c6dcca3add317f54$export$2eb494378181b46b);
const $c6dcca3add317f54$export$2eb494378181b46b = {
    name: 'csm-experience-email',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/email',
    exact: true
};

});

parcelRegister("hLtFo", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsEmailAppEntryPoint", () => $d786a161bc25710b$export$3c1d74427fe6ddc);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $d786a161bc25710b$export$3c1d74427fe6ddc = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5abkt")), {
        moduleId: "ffd68cbb",
        moduleName: "HelpCenterSettingsEmail",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5abkt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("hMHDn")
]).then(()=>parcelRequire('85gO8'));

});



parcelRegister("979NP", function(module, exports) {
$parcel$export(module.exports, "csmExperienceEmbeddedWidgetsRouteEntry", () => $6e4345d727c7278c$export$91930533f0ab57f);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $gROqa = parcelRequire("gROqa");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $k76DA = parcelRequire("k76DA");
const $6e4345d727c7278c$export$91930533f0ab57f = (0, $fdS54.createEntry)((0, $gROqa.csmExperienceEmbeddedWidgetsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.csm-experience-embedded-widgets',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $k76DA.HelpCenterSettingsEmbeddedWidgetsAppEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gROqa", function(module, exports) {
$parcel$export(module.exports, "csmExperienceEmbeddedWidgetsRoute", () => $239c28fac8d8fdc9$export$cc225174b59b670d);
const $239c28fac8d8fdc9$export$cc225174b59b670d = {
    name: 'csm-experience-embedded-widgets',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/embed',
    exact: true
};

});

parcelRegister("k76DA", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsEmbeddedWidgetsAppEntryPoint", () => $2a41593773ded15f$export$ce9e3e5c7b8c368e);

var $3oJCz = parcelRequire("3oJCz");

var $dTa0V = parcelRequire("dTa0V");
const $2a41593773ded15f$export$ce9e3e5c7b8c368e = (0, $dTa0V.createPageEntryPoint)({
    main: $3oJCz.embeddedWidgetsEntryPoint
});

});
parcelRegister("3oJCz", function(module, exports) {
$parcel$export(module.exports, "embeddedWidgetsEntryPoint", () => $f67648a134625db5$export$d6742c2113a091b1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $96ZD0 = parcelRequire("96ZD0");

var $dXq5z = parcelRequire("dXq5z");

const $f67648a134625db5$export$d6742c2113a091b1 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("6Nmsk")), {
        moduleId: "ba603b50",
        moduleName: "HelpCenterSettingsEmbeddedWidgetsApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, widgetId: widgetId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                embeddedWidgetsQuery: {
                    parameters: (0, $96ZD0.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        widgetId: widgetId ?? '',
                        skip: (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget')
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                },
                embeddedWidgetsNewQuery: {
                    parameters: (0, $dXq5z.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        skip: !(0, $i860n.fg)('csm-omni-channel-live-chat-in-widget')
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("96ZD0", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca31a4e659e75b5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7cc9a5d2dc8b0115beda559e5c4dddc>>
 * @relayHash 15584b4ffbb9bcbfacd03a809013825a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4a56529c04288388a8109710e43db61d8e7771f7bf2397ed3b08fbaf32a92504

var $lIGkE = parcelRequire("lIGkE");
const $ca31a4e659e75b5a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "csmAi_getAiHubByHelpCenterAri",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "EmbeddedWidgets_AtlassianCsmWidgetConfiguration_EmbeddedWidgets"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "csmAi_getAiHubByHelpCenterAri",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "agents",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "agentId"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "versionType",
                                                                    "value": "LIVE"
                                                                }
                                                            ],
                                                            "concreteType": "CsmAiAgentVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "versions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CsmAiAgentVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "versions(versionType:\"LIVE\")"
                                                        }
                                                    ],
                                                    "type": "CsmAiMultiVersionAgent"
                                                }
                                            ]
                                        },
                                        v3 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "EMBED"
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "widgets",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ],
                                                    "type": "CsmAiWidgetConfig"
                                                }
                                            ],
                                            "storageKey": "widgets(type:\"EMBED\")"
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CsmAiHub"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4a56529c04288388a8109710e43db61d8e7771f7bf2397ed3b08fbaf32a92504",
            "metadata": {},
            "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ca31a4e659e75b5a$var$node.hash = "e257ef6ced6782cdc5424180f1b7874f";
(0, $lIGkE.PreloadableQueryRegistry).set($ca31a4e659e75b5a$var$node.params.id, $ca31a4e659e75b5a$var$node);
var $ca31a4e659e75b5a$export$2e2bcd8739ae039 = $ca31a4e659e75b5a$var$node;

});

parcelRegister("dXq5z", function(module, exports) {
$parcel$export(module.exports, "default", () => $77c4db068a53c21c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2ca6e3060f43bbe3f3f75243a47d8e0>>
 * @relayHash 3014a96ec9501e54a7e7f2801f993a06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e0c37341726962242b1002a9760d27e74bf1e20253453b4401e923deccb3c69

var $lIGkE = parcelRequire("lIGkE");
const $77c4db068a53c21c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HelpCenterSettingsEmbeddedWidgetsAppNewQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "csmAi_getWidgetsWithCsmAiHub",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "EmbeddedWidgetsConfigPage_atlassianCsmWidgetConfiguration"
                                        }
                                    ],
                                    "type": "CsmAiHubWithWidgets"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HelpCenterSettingsEmbeddedWidgetsAppNewQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "csmAi_getWidgetsWithCsmAiHub",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "EMBED"
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "widgets",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ],
                                                    "type": "CsmAiWidgetConfig"
                                                }
                                            ],
                                            "storageKey": "widgets(type:\"EMBED\")"
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CsmAiHubWithWidgets"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2e0c37341726962242b1002a9760d27e74bf1e20253453b4401e923deccb3c69",
            "metadata": {},
            "name": "HelpCenterSettingsEmbeddedWidgetsAppNewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$77c4db068a53c21c$var$node.hash = "756ef65e34543fa92d07e813c83f5c1b";
(0, $lIGkE.PreloadableQueryRegistry).set($77c4db068a53c21c$var$node.params.id, $77c4db068a53c21c$var$node);
var $77c4db068a53c21c$export$2e2bcd8739ae039 = $77c4db068a53c21c$var$node;

});

parcelRegister("6Nmsk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hSpc2").then(()=>parcelRequire('18jjX'));

});




parcelRegister("5PmmP", function(module, exports) {
$parcel$export(module.exports, "csmExperienceFormEditRouteEntry", () => $eb3de8e2e6ec099a$export$1128d4b22ffbd096);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $lQctJ = parcelRequire("lQctJ");

var $au0Qi = parcelRequire("au0Qi");

var $8HUuJ = parcelRequire("8HUuJ");

var $f3FAa = parcelRequire("f3FAa");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $1lXSA = parcelRequire("1lXSA");
const $eb3de8e2e6ec099a$export$1128d4b22ffbd096 = (0, $fdS54.createEntry)((0, $f3FAa.csmExperienceFormEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-form-edit',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $1lXSA.helpCenterSettingFormEditAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $au0Qi.formEditJirafieldsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_conditional_form_fields'), (0, $lQctJ.formEditProformaFormResource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lQctJ", function(module, exports) {
$parcel$export(module.exports, "formEditProformaFormResource", () => $a3aef8546dce168f$export$cbd3262ed3e7346c);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $a3aef8546dce168f$export$cbd3262ed3e7346c = (0, $7edbf.createResource)({
    type: 'FORM_EDIT_PROFORMA_FORM_RESOURCE',
    getKey: ({ match: { params: { helpCenterId: helpCenterId, formId: formId } } })=>`FORM_EDIT_PROFORMA_FORM_${helpCenterId}_${formId}`,
    getData: async ({ match: { params: { helpCenterId: helpCenterId, formId: formId } } }, { tenantContext: { cloudId: cloudId } })=>{
        const response = await (0, $h2wCv.performGetRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/frontend/jira/help-center/${helpCenterId}/admin/forms/${formId}`);
        const form = JSON.parse(JSON.stringify(response));
        // Any response data manipulation here also needs to be mirrored
        // in onFormSaved in src/packages/servicedesk/customer-service-form-edit/src/ui/issue-type-page/IssueTypePage.tsx
        const attachmentKey = Object.values(form.design.questions).find(// FormQuestionType.Attachment = 'at' (@atlassian/proforma-common-core/form-system-models)
        (question)=>question.type === 'at')?.questionKey;
        if (attachmentKey) form.design.questions[attachmentKey].jiraField = 'attachment';
        return form;
    },
    maxAge: 0,
    isBrowserOnly: true
});

});

parcelRegister("au0Qi", function(module, exports) {
$parcel$export(module.exports, "formEditJirafieldsResource", () => $abf773dec799c2e8$export$ca58e1498fd1ff3e);
$parcel$export(module.exports, "useFormEditJirafields", () => $abf773dec799c2e8$export$8a76fadb956ce203);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fLTsc = parcelRequire("fLTsc");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $abf773dec799c2e8$export$ca58e1498fd1ff3e = (0, $7edbf.createResource)({
    type: 'HELP_CENTER_FORM_EDIT_JIRAFIELDS_RESOURCE',
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("3WctW")),
    isBrowserOnly: true
});
const $abf773dec799c2e8$export$8a76fadb956ce203 = ()=>(0, $k6ufm.useResource)($abf773dec799c2e8$export$ca58e1498fd1ff3e);

});
parcelRegister("3WctW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("qlSut").then(()=>parcelRequire('j1pFq'));

});


parcelRegister("f3FAa", function(module, exports) {
$parcel$export(module.exports, "csmExperienceFormEditRoute", () => $2a121d19893ba8ee$export$6383b44b1affc591);
const $2a121d19893ba8ee$export$6383b44b1affc591 = {
    name: 'csm-experience-form-edit',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/forms/:formId',
    exact: true
};

});

parcelRegister("1lXSA", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingFormEditAppPageEntryPoint", () => $08aee8431bca650c$export$2792cba2387cbc5c);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4PtFY = parcelRequire("4PtFY");

var $dTa0V = parcelRequire("dTa0V");
const $08aee8431bca650c$export$2792cba2387cbc5c = (0, $dTa0V.createPageEntryPoint)({
    main: $4PtFY.helpCenterSettingFormEditAppEntryPoint
});

});
parcelRegister("4PtFY", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingFormEditAppEntryPoint", () => $34f51fc2900e68dc$export$262512d610e494f8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7BVKo = parcelRequire("7BVKo");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $34f51fc2900e68dc$export$262512d610e494f8 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("02zdP")), {
        moduleId: "36857aaa",
        moduleName: "HelpCenterSettingFormEditApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, formId: formId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                FormEditQuery: {
                    parameters: $7BVKo.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        templateFormAri: `ari:cloud:jira-customer-service::template-form/activation/${activationId}/${formId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("7BVKo", function(module, exports) {
$parcel$export(module.exports, "default", () => $630a07185b07746e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df2e480c37ecf4f566bbac5d092a7d5e>>
 * @relayHash 20d9cf941bf372501c1c291fc568e8f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bbc2eebecb28bccd13be945dc4fae1dbc3a56cf2111e2cc61f346067f80bd9c
const $630a07185b07746e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4bbc2eebecb28bccd13be945dc4fae1dbc3a56cf2111e2cc61f346067f80bd9c",
        "metadata": {},
        "name": "FormEditQuery",
        "operationKind": "query",
        "text": null
    }
};
var $630a07185b07746e$export$2e2bcd8739ae039 = $630a07185b07746e$var$node;

});

parcelRegister("02zdP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ghf4B")
]).then(()=>parcelRequire('3e1kG'));

});




parcelRegister("jyQEq", function(module, exports) {
$parcel$export(module.exports, "csmExperienceFormsRouteEntry", () => $3a3864975a01e6c8$export$1fdc724c11d6f09e);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $1JN1M = parcelRequire("1JN1M");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $feR6M = parcelRequire("feR6M");
const $3a3864975a01e6c8$export$1fdc724c11d6f09e = (0, $fdS54.createEntry)((0, $1JN1M.csmExperienceFormsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-forms',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $feR6M.helpCenterSettingFormsAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1JN1M", function(module, exports) {
$parcel$export(module.exports, "csmExperienceFormsRoute", () => $d49e3cf1b5efe80a$export$87da964d2cf75511);
const $d49e3cf1b5efe80a$export$87da964d2cf75511 = {
    name: 'csm-experience-forms',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/forms',
    exact: true
};

});

parcelRegister("feR6M", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingFormsAppPageEntryPoint", () => $d93332d73d0f5a5c$export$b50d944f3be2457f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $21B5h = parcelRequire("21B5h");

var $dTa0V = parcelRequire("dTa0V");
const $d93332d73d0f5a5c$export$b50d944f3be2457f = (0, $dTa0V.createPageEntryPoint)({
    main: $21B5h.helpCenterSettingFormsAppEntryPoint
});

});
parcelRegister("21B5h", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingFormsAppEntryPoint", () => $97a8dbadd7bb251e$export$ce8253ab16579f12);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $9ng5F = parcelRequire("9ng5F");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $97a8dbadd7bb251e$export$ce8253ab16579f12 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jJ8Fh")), {
        moduleId: "f9b991a7",
        moduleName: "HelpCenterSettingFormsApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                FormsQuery: {
                    parameters: $9ng5F.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("9ng5F", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c89885e8f7c147e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e6f7cc680efdb3303222fad4e50d1d9>>
 * @relayHash 620017d3eb428f241f754ece571af703
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3286a71f42d694c4f901110034634d94c3baa72003370b2d358c78b96a294aa1
const $0c89885e8f7c147e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "3286a71f42d694c4f901110034634d94c3baa72003370b2d358c78b96a294aa1",
        "metadata": {},
        "name": "FormsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0c89885e8f7c147e$export$2e2bcd8739ae039 = $0c89885e8f7c147e$var$node;

});

parcelRegister("jJ8Fh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kUPbk").then(()=>parcelRequire('bnPYJ'));

});




parcelRegister("7sPfV", function(module, exports) {
$parcel$export(module.exports, "csmExperienceGetStartedRouteEntry", () => $3f8574b6841a2f32$export$dc50599ca4aec38a);

var $i860n = parcelRequire("i860n");



var $fdS54 = parcelRequire("fdS54");

var $5q5DR = parcelRequire("5q5DR");

var $igvpg = parcelRequire("igvpg");

var $dkOZx = parcelRequire("dkOZx");

var $gO1oK = parcelRequire("gO1oK");

var $8HUuJ = parcelRequire("8HUuJ");

var $frSjg = parcelRequire("frSjg");

var $iSoIx = parcelRequire("iSoIx");

var $4A6Co = parcelRequire("4A6Co");

var $lhkth = parcelRequire("lhkth");

var $74h93 = parcelRequire("74h93");

var $QhQu4 = parcelRequire("QhQu4");
var $bKPo4 = parcelRequire("bKPo4");

var $5yPS0 = parcelRequire("5yPS0");

var $2KnY6 = parcelRequire("2KnY6");
const $3f8574b6841a2f32$export$dc50599ca4aec38a = (0, $fdS54.createEntry)((0, $frSjg.csmExperienceGetStartedRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-get-started',
        layout: (0, $bKPo4.layoutWithCondition)(()=>(0, $i860n.fg)('csm-support-widget-in-csm'), (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $gO1oK.csmWidgetLayout)), (0, $74h93.serviceProjectLayout)),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $2KnY6.helpCenterSettingGetStartedAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $dkOZx.firstProjectResource),
            (0, $5q5DR.getStartedPropertyResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_ai_onboarding_tasks'), (0, $4A6Co.csmHubSetupSupportWebsiteResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_ai_onboarding_tasks'), (0, $igvpg.serviceDeskIncomingEmailResource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5q5DR", function(module, exports) {
$parcel$export(module.exports, "PROPERTY_KEY", () => $68615b1c3d3e29c8$export$bb10a02fc2feb574);
$parcel$export(module.exports, "getStartedPropertyResource", () => $68615b1c3d3e29c8$export$5c15beabb6f8df9a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $75sVW = parcelRequire("75sVW");
var $4fhEY = parcelRequire("4fhEY");
const $68615b1c3d3e29c8$export$bb10a02fc2feb574 = 'csmGetStartedCustomerExperienceDisabled';
const $68615b1c3d3e29c8$var$getUrl = (projectKey, key)=>`/rest/api/3/project/${projectKey}/properties/${key}`;
const $68615b1c3d3e29c8$export$5c15beabb6f8df9a = (0, $7edbf.createResource)({
    type: 'CUSTOMER_SERVICE_GET_STARTED_PROPERTY_RESOURCE',
    getKey: ({ match: match })=>`customer-service-get-started-property-${match.params.projectKey}`,
    getData: async ({ match: match })=>{
        try {
            return await (0, $4fhEY.default)($68615b1c3d3e29c8$var$getUrl(match.params.projectKey || '', $68615b1c3d3e29c8$export$bb10a02fc2feb574));
        } catch (error) {
            if (error instanceof (0, $75sVW.default) && error.statusCode === 404) return false;
            throw error;
        }
    },
    maxAge: 86400000
});

});

parcelRegister("igvpg", function(module, exports) {
$parcel$export(module.exports, "serviceDeskIncomingEmailResource", () => $9fe1ba9945abae4b$export$b55a100d3351412a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $9fe1ba9945abae4b$export$b55a100d3351412a = (0, $7edbf.createResource)({
    type: 'SERVICE_DESK_INCOMING_EMAIL',
    getKey: ({ match: { params: { projectKey: projectKey } } })=>{
        return `SERVICE_DESK_INCOMING_EMAIL_${projectKey}`;
    },
    getData: ({ match: { params: { projectKey: projectKey } } })=>(0, $h2wCv.performGetRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/incomingemail`),
    maxAge: 0
});

});

parcelRegister("frSjg", function(module, exports) {
$parcel$export(module.exports, "csmExperienceGetStartedRoute", () => $362ff67e45c397fb$export$d934ac6b2d5788af);
const $362ff67e45c397fb$export$d934ac6b2d5788af = {
    name: 'csm-experience-get-started',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/get-started',
    exact: true
};

});

parcelRegister("4A6Co", function(module, exports) {
$parcel$export(module.exports, "csmHubSetupSupportWebsiteResource", () => $e453e7f86d5b45cb$export$9d55140dbc334180);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $igWj4 = parcelRequire("igWj4");
const $e453e7f86d5b45cb$export$9d55140dbc334180 = (0, $igWj4.createProjectPropertyResource)({
    propertyKey: 'csmHubSetup.supportWebsite',
    maxAge: 0
});

});

parcelRegister("2KnY6", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingGetStartedAppPageEntryPoint", () => $5e389681a3c06021$export$cf7c7e88c0bdb095);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4zllv = parcelRequire("4zllv");

var $dTa0V = parcelRequire("dTa0V");
const $5e389681a3c06021$export$cf7c7e88c0bdb095 = (0, $dTa0V.createPageEntryPoint)({
    main: $4zllv.helpCenterSettingGetStartedAppEntryPoint
});

});
parcelRegister("4zllv", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingGetStartedAppEntryPoint", () => $a7c7def804999d46$export$11bdba03862e4a4b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $a7c7def804999d46$export$11bdba03862e4a4b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("lOMiO")), {
        moduleId: "5019223e",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lOMiO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1pIYV").then(()=>parcelRequire('7vvuh'));

});




parcelRegister("4qitY", function(module, exports) {
$parcel$export(module.exports, "csmExperienceMessagingAppsRouteEntry", () => $4a571eb09ca5860a$export$8499c07fa7916f23);

var $i860n = parcelRequire("i860n");



var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $l5mlv = parcelRequire("l5mlv");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $9h5wj = parcelRequire("9h5wj");
const $4a571eb09ca5860a$export$8499c07fa7916f23 = (0, $fdS54.createEntry)((0, $l5mlv.csmExperienceMessagingAppsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-messaging-apps',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            if (!(0, $i860n.fg)('csm_appification_standalone_navigation')) return 0, $iSoIx.notFoundPageEntrypoint;
            return (0, $i860n.fg)('csm-omni-whatsapp-support') ? (0, $9h5wj.HelpCenterSettingsMessagingAppsEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("l5mlv", function(module, exports) {
$parcel$export(module.exports, "csmExperienceMessagingAppsRoute", () => $de9e1e754b6db566$export$e53875d0d62d775b);
const $de9e1e754b6db566$export$e53875d0d62d775b = {
    name: 'csm-experience-messaging-apps',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/messaging-apps',
    exact: true
};

});

parcelRegister("9h5wj", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsMessagingAppsEntryPoint", () => $0437c8830ed7fe62$export$e5ace69692003a63);

var $1dzA0 = parcelRequire("1dzA0");

var $dTa0V = parcelRequire("dTa0V");
const $0437c8830ed7fe62$export$e5ace69692003a63 = (0, $dTa0V.createPageEntryPoint)({
    main: $1dzA0.helpCenterSettingsMessagingAppsAppEntryPoint
});

});
parcelRegister("1dzA0", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsMessagingAppsAppEntryPoint", () => $c4906661da297ee1$export$9b1387f83e187f35);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $c4906661da297ee1$export$9b1387f83e187f35 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("cdRb7")), {
        moduleId: "f8bb51d2",
        moduleName: "HelpCenterSettingsMessagingAppsApp",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cdRb7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8yIdE").then(()=>parcelRequire('82ZOw'));

});




parcelRegister("4h98W", function(module, exports) {
$parcel$export(module.exports, "csmExperiencePhoneConfigurationRouteEntry", () => $987ada58b687379b$export$180aaa47065412a0);

var $i860n = parcelRequire("i860n");



var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $6Cqzk = parcelRequire("6Cqzk");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $8IaSx = parcelRequire("8IaSx");
const $987ada58b687379b$export$180aaa47065412a0 = (0, $fdS54.createEntry)((0, $6Cqzk.csmExperiencePhoneConfigurationRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-experience-phone-configuration',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $8IaSx.HelpCenterSettingsPhoneConfigurationEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6Cqzk", function(module, exports) {
$parcel$export(module.exports, "csmExperiencePhoneConfigurationRoute", () => $b7d1e76580d01ff4$export$5f85ca5122e8592d);
const $b7d1e76580d01ff4$export$5f85ca5122e8592d = {
    name: 'csm-experience-phone-configuration',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/phone',
    exact: true
};

});

parcelRegister("8IaSx", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsPhoneConfigurationEntryPoint", () => $c7b6bd925627dcad$export$ffff2db5cb526345);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hrC4u = parcelRequire("hrC4u");

var $dTa0V = parcelRequire("dTa0V");
const $c7b6bd925627dcad$export$ffff2db5cb526345 = (0, $dTa0V.createPageEntryPoint)({
    main: $hrC4u.helpCenterSettingsPhoneConfigurationAppEntryPoint
});

});
parcelRegister("hrC4u", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsPhoneConfigurationAppEntryPoint", () => $2a3c97bbeca6cd80$export$ee6038d1660fcdd6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $2a3c97bbeca6cd80$export$ee6038d1660fcdd6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8Zcqf")), {
        moduleId: "83761aad",
        moduleName: "HelpCenterSettingPhoneConfigurationApp",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8Zcqf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dnPzE").then(()=>parcelRequire('dHKM2'));

});




parcelRegister("lf8kK", function(module, exports) {
$parcel$export(module.exports, "csmExperiencesRouteEntry", () => $3101299fd3fe9b1e$export$db5cc5f271943194);

var $2nex5 = parcelRequire("2nex5");



var $3XZ1h = parcelRequire("3XZ1h");

var $iSoIx = parcelRequire("iSoIx");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $a8Xfn = parcelRequire("a8Xfn");

var $i860n = parcelRequire("i860n");

var $lhkth = parcelRequire("lhkth");

var $hMIvE = parcelRequire("hMIvE");
const $3101299fd3fe9b1e$export$db5cc5f271943194 = (0, $fdS54.createEntry)((0, $a8Xfn.csmExperiencesRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.csm-experiences',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $hMIvE.helpCenterSettingsServiceHubsRoutePageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $3XZ1h.csmBaseUrlResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3XZ1h", function(module, exports) {
$parcel$export(module.exports, "csmBaseUrlResource", () => $57ff2200022d9743$export$9c5392bbc049a926);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $gvsVD = parcelRequire("gvsVD");
const $57ff2200022d9743$var$RESOURCE_TYPE_CSM_BASE_URL = 'CSM_SUPPORT_SITE_BASE_URL';
const $57ff2200022d9743$export$9c5392bbc049a926 = (0, $7edbf.createResource)({
    type: $57ff2200022d9743$var$RESOURCE_TYPE_CSM_BASE_URL,
    getKey: ()=>'csm-support-site-base-url',
    getData: async ()=>(0, $gvsVD.default)(),
    maxAge: 0
});

});
parcelRegister("gvsVD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca752fdfc572a2de$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $ca752fdfc572a2de$var$getData = async ()=>{
    try {
        const data = await (0, $4fhEY.default)('/rest/api/latest/serverInfo');
        return data.displayUrlCSMHelpSeeker?.replace(/^https?:\/\//, '');
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'csmBaseUrlResource',
                packageName: 'jiraRouterResourcesServiceDeskCustomerServiceCsmBaseUrl',
                teamName: 'boysenberry'
            },
            error: error instanceof Error ? error : undefined
        });
        throw error;
    }
};
var $ca752fdfc572a2de$export$2e2bcd8739ae039 = $ca752fdfc572a2de$var$getData;

});


parcelRegister("a8Xfn", function(module, exports) {
$parcel$export(module.exports, "csmExperiencesRoute", () => $87a2961df023d823$export$536d88f70c395dde);
const $87a2961df023d823$export$536d88f70c395dde = {
    exact: true,
    name: 'csm-experiences',
    path: '/jira/customer-service-management/experiences'
};

});

parcelRegister("hMIvE", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoutePageEntryPoint", () => $67c976f00f320898$export$3c1cef4845013f95);
/* eslint-disable jira/naming/disallow-filenames */ 
var $a2TnH = parcelRequire("a2TnH");

var $dTa0V = parcelRequire("dTa0V");
const $67c976f00f320898$export$3c1cef4845013f95 = (0, $dTa0V.createPageEntryPoint)({
    main: $a2TnH.helpCenterSettingsServiceHubsAppEntryPoint
});

});
parcelRegister("a2TnH", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsServiceHubsAppEntryPoint", () => $c962dd612286d67f$export$68ab0caf884fe346);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $9xhop = parcelRequire("9xhop");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");
const $c962dd612286d67f$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH = 20;
const $c962dd612286d67f$var$SORT_ORDER = 'CREATED_DATE_DESCENDING';

const $c962dd612286d67f$export$68ab0caf884fe346 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5NB5r")), {
        moduleId: "c50d2ed6",
        moduleName: "HelpCenterSettingServiceHubsAppWithJCSLicenseCheck",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                serviceHubsQuery: {
                    parameters: $9xhop.default,
                    variables: {
                        cloudId: cloudId,
                        workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
                        SORT_ORDER: $c962dd612286d67f$var$SORT_ORDER,
                        NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $c962dd612286d67f$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("9xhop", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e248bc1bb24f0a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<484fa77f161b641690181de080f853af>>
 * @relayHash 1ce8acea6682da39223e50d1097bbd01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5bbf63e1af0eaf86bd47dbfb9b0f08cfb653355c87498b03039cbc350713b1ed
const $0e248bc1bb24f0a8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5bbf63e1af0eaf86bd47dbfb9b0f08cfb653355c87498b03039cbc350713b1ed",
        "metadata": {},
        "name": "ServiceHubsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0e248bc1bb24f0a8$export$2e2bcd8739ae039 = $0e248bc1bb24f0a8$var$node;

});

parcelRegister("5NB5r", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6jXcA").then(()=>parcelRequire('ci25V'));

});




parcelRegister("7nJMb", function(module, exports) {
$parcel$export(module.exports, "csmExperienceSupportWebsiteEditRouteEntry", () => $7e758d544122cd5a$export$fe91ada4ba0a46fd);

var $i860n = parcelRequire("i860n");



var $lU7cf = parcelRequire("lU7cf");

var $idDnR = parcelRequire("idDnR");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $lhkth = parcelRequire("lhkth");

var $4A6Co = parcelRequire("4A6Co");

var $ksJAc = parcelRequire("ksJAc");

var $iSoIx = parcelRequire("iSoIx");

var $5yPS0 = parcelRequire("5yPS0");

var $bXM2d = parcelRequire("bXM2d");
const $7e758d544122cd5a$export$fe91ada4ba0a46fd = (0, $fdS54.createEntry)((0, $ksJAc.csmExperienceSupportWebsiteEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.csm-experience-support-website.edit',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7),
            horizontal: (0, $i860n.fg)('csm_contact_us_rte') ? undefined : (0, $lU7cf.AsyncSupportWebsiteNav)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $bXM2d.SupportWebsiteEditEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4A6Co.csmHubSetupSupportWebsiteResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lU7cf", function(module, exports) {
$parcel$export(module.exports, "AsyncSupportWebsiteNav", () => $6dd89539d5a3a257$export$8887f9c4b5829b78);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $6dd89539d5a3a257$var$LazySupportWebsiteNav = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("eYYZ1")).then(({ SupportWebsiteNavOld: SupportWebsiteNavOld })=>SupportWebsiteNavOld), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-csm-support-website/src/ui/index.tsx"
});
const $6dd89539d5a3a257$export$8887f9c4b5829b78 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-csm-support-site-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6dd89539d5a3a257$var$LazySupportWebsiteNav, null));
$6dd89539d5a3a257$export$8887f9c4b5829b78.displayName = "AsyncSupportWebsiteNav";

});
parcelRegister("eYYZ1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cJYzc").then(()=>parcelRequire('c22ny'));

});


parcelRegister("ksJAc", function(module, exports) {
$parcel$export(module.exports, "csmExperienceSupportWebsiteEditRoute", () => $aa9530f6461b3ebc$export$d5fd4d0b4c15d508);
const $aa9530f6461b3ebc$export$d5fd4d0b4c15d508 = {
    name: 'csm-experience-support-website-edit',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/support-website/edit/:pageId?',
    exact: true
};

});

parcelRegister("bXM2d", function(module, exports) {
$parcel$export(module.exports, "SupportWebsiteEditEntryPoint", () => $2688af07db3b5835$export$eff41ae22c2fa617);

var $gju1Q = parcelRequire("gju1Q");

var $dTa0V = parcelRequire("dTa0V");
const $2688af07db3b5835$export$eff41ae22c2fa617 = (0, $dTa0V.createPageEntryPoint)({
    main: $gju1Q.HelpCenterSettingsSupportWebsiteEditAppEntryPoint
});

});
parcelRegister("gju1Q", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEditAppEntryPoint", () => $6b36e8d343a20a7f$export$d6f4e117cf8f2d94);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $bOLso = parcelRequire("bOLso");

const $6b36e8d343a20a7f$export$d6f4e117cf8f2d94 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bmrG3")), {
        moduleId: "298f4aa6",
        moduleName: "HelpCenterSettingsSupportWebsiteEditComponent",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, pageId: pageId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                customEditQuery: {
                    parameters: (0, $bOLso.default),
                    variables: {
                        cloudId: cloudId,
                        hubAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        pageAri: `ari:cloud:help::page/${activationId}/${pageId || helpCenterId || ''}`,
                        hubEditMode: true
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("bOLso", function(module, exports) {
$parcel$export(module.exports, "default", () => $138574332ae488eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dae1cce7f2ef19460301c2ce05d2f4d0>>
 * @relayHash e9e91bdc41c6aa27ad4d602068d16895
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e336d258a380543df462bd3a25cb41dfa6293e9221f871efa9346b76c8fabd9

var $lIGkE = parcelRequire("lIGkE");
const $138574332ae488eb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "pageAri",
            "variableName": "pageAri"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "cornerRadius"
    }, v14 = {
        "concreteType": "HelpCenterNavigationBar",
        "kind": "LinkedField",
        "name": "navigationBar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "backgroundColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderType"
            },
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "padding"
            },
            {
                "kind": "ScalarField",
                "name": "positionType"
            },
            {
                "kind": "ScalarField",
                "name": "textColor"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "id"
    }, v16 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v17 = [
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": v12 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "pageMediaConfig",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "pageAri"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "hubAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hoistedProjectKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": v12 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "allPages",
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": v17 /*: any*/ 
                                        },
                                        {
                                            "alias": "customPages",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "ids": [],
                                                        "type": "CUSTOM"
                                                    }
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": v17 /*: any*/ ,
                                            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "alias": "currentPage",
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "items": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "ids.0",
                                                                    "variableName": "pageAri"
                                                                }
                                                            ],
                                                            "kind": "ListValue",
                                                            "name": "ids"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "filter"
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterPageLayout",
                                                    "kind": "LinkedField",
                                                    "name": "pageLayout",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterLayoutAdf",
                                                            "kind": "LinkedField",
                                                            "name": "layoutAdf",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterLayoutAdfContentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterLayoutAdfContentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpCenterLayoutAdfContent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "content"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "secondaryColor"
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterBrandingTypography",
                                                    "kind": "LinkedField",
                                                    "name": "typography",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "headingFont"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "bodyFont"
                                                        }
                                                    ]
                                                },
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v15 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0e336d258a380543df462bd3a25cb41dfa6293e9221f871efa9346b76c8fabd9",
            "metadata": {},
            "name": "hubHomeContentWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$138574332ae488eb$var$node.hash = "647b06faa4e451d097f1c1141f02b3ef";
(0, $lIGkE.PreloadableQueryRegistry).set($138574332ae488eb$var$node.params.id, $138574332ae488eb$var$node);
var $138574332ae488eb$export$2e2bcd8739ae039 = $138574332ae488eb$var$node;

});

parcelRegister("bmrG3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("9g0AC")
]).then(()=>parcelRequire('aJ0TT'));

});




parcelRegister("VMFYy", function(module, exports) {
$parcel$export(module.exports, "csmExperienceSupportWebsiteOverviewRouteEntry", () => $9e4cf5d03f8ed0e5$export$a12f75609d73e15c);

var $4A6Co = parcelRequire("4A6Co");

var $idDnR = parcelRequire("idDnR");

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $c7N7m = parcelRequire("c7N7m");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $5XznV = parcelRequire("5XznV");
const $9e4cf5d03f8ed0e5$export$a12f75609d73e15c = (0, $fdS54.createEntry)((0, $c7N7m.csmExperienceSupportWebsiteOverviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.csm-experience-support-website.overview',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $5XznV.HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4A6Co.csmHubSetupSupportWebsiteResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c7N7m", function(module, exports) {
$parcel$export(module.exports, "csmExperienceSupportWebsiteOverviewRoute", () => $265bd5c2444b0e06$export$75868f3c3784de03);
const $265bd5c2444b0e06$export$75868f3c3784de03 = {
    name: 'csm-experience-support-website-overview',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/support-website/overview',
    exact: true
};

});

parcelRegister("5XznV", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $89c765e8330c756a$export$780fd78388c1f1d1);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation", () => $89c765e8330c756a$export$23f7867fc61415d6);
/* eslint-disable jira/naming/disallow-filenames */ 
var $86UZR = parcelRequire("86UZR");

var $dTa0V = parcelRequire("dTa0V");

var $g6jek = parcelRequire("g6jek");
const $89c765e8330c756a$export$780fd78388c1f1d1 = (0, $dTa0V.createPageEntryPoint)({
    main: $86UZR.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint
});
const $89c765e8330c756a$export$23f7867fc61415d6 = (0, $dTa0V.createPageEntryPoint)({
    main: $86UZR.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    horizontalNavigation: (0, $g6jek.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("86UZR", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $81295f9b3809c011$export$780fd78388c1f1d1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $gJvpg = parcelRequire("gJvpg");

var $fVdj2 = parcelRequire("fVdj2");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

const $81295f9b3809c011$export$780fd78388c1f1d1 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3QjpA")), {
        moduleId: "99363e50",
        moduleName: "HelpCenterSettingsSupportWebsiteOverviewApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget') ? (0, $fVdj2.default) : (0, $gJvpg.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("gJvpg", function(module, exports) {
$parcel$export(module.exports, "default", () => $27626bc6ada1feab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfe7fe8ab298d36d3132e86e8a7612c7>>
 * @relayHash 5f80f58c5bfb99ae780f75dc3697d7ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f080e5bf76a096f57c2c5e7a88c2c7a043d88ecf2b123f21f37e5c852a6b9293
const $27626bc6ada1feab$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f080e5bf76a096f57c2c5e7a88c2c7a043d88ecf2b123f21f37e5c852a6b9293",
        "metadata": {},
        "name": "SupportWebsiteOverviewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $27626bc6ada1feab$export$2e2bcd8739ae039 = $27626bc6ada1feab$var$node;

});

parcelRegister("fVdj2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b751e3025262bdc6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4189fb12cc13a30dcdf791a62645e29a>>
 * @relayHash ee3591c22897e766ec477c244c1b1f68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 067ac770c9e81359b4445020b13338260b439942ac378ec776736f49010e2777
const $b751e3025262bdc6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "067ac770c9e81359b4445020b13338260b439942ac378ec776736f49010e2777",
        "metadata": {},
        "name": "SupportWebsiteOverviewNewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b751e3025262bdc6$export$2e2bcd8739ae039 = $b751e3025262bdc6$var$node;

});

parcelRegister("3QjpA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hfVxK").then(()=>parcelRequire('bKUXm'));

});


parcelRegister("g6jek", function(module, exports) {
$parcel$export(module.exports, "horizontalNavigationCsmSupportWebsiteEntryPoint", () => $3e6d8e5dd071802d$export$2ba426f18e0d22f5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $5u1vn = parcelRequire("5u1vn");

const $3e6d8e5dd071802d$export$2ba426f18e0d22f5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("drKfm")), {
        moduleId: "020d5dbe",
        moduleName: "SupportWebsiteNavEntryPoint",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                SupportWebsiteNavEntryPointQuery: {
                    parameters: $5u1vn.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("5u1vn", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffc2ce242a2400b7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c964fdc4db048aa27656ed4d3cedc32>>
 * @relayHash c7d5e8e948efa0a5f4521d77275a114a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID df21ac0704295fb549bc8443e0370ead496e2d268178d86e9d1a286329b37b9d
const $ffc2ce242a2400b7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "df21ac0704295fb549bc8443e0370ead496e2d268178d86e9d1a286329b37b9d",
        "metadata": {},
        "name": "SupportWebsiteNavEntryPointQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ffc2ce242a2400b7$export$2e2bcd8739ae039 = $ffc2ce242a2400b7$var$node;

});

parcelRegister("drKfm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aSbyj").then(()=>parcelRequire('gKWyz'));

});




parcelRegister("ex20g", function(module, exports) {
$parcel$export(module.exports, "csmExperienceSupportWebsitePagesRouteEntry", () => $6dbe749f887a681b$export$efc674d6132c9688);

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $ir5UX = parcelRequire("ir5UX");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $h4KqR = parcelRequire("h4KqR");
const $6dbe749f887a681b$export$efc674d6132c9688 = (0, $fdS54.createEntry)((0, $ir5UX.csmExperienceSupportWebsitePagesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.csm-experience-support-website.pages',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $h4KqR.HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ir5UX", function(module, exports) {
$parcel$export(module.exports, "csmExperienceSupportWebsitePagesRoute", () => $b4ee0ee322f67052$export$49d94fb3de562f94);
const $b4ee0ee322f67052$export$49d94fb3de562f94 = {
    name: 'csm-experience-support-website-pages',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/support-website/pages',
    exact: true
};

});

parcelRegister("h4KqR", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $253ac3e3233dfb43$export$7d51b2b14ae8000f);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation", () => $253ac3e3233dfb43$export$e27663b14f44038e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $kyjSD = parcelRequire("kyjSD");

var $dTa0V = parcelRequire("dTa0V");

var $g6jek = parcelRequire("g6jek");
const $253ac3e3233dfb43$export$7d51b2b14ae8000f = (0, $dTa0V.createPageEntryPoint)({
    main: $kyjSD.HelpCenterSettingsSupportWebsitePagesAppEntryPoint
});
const $253ac3e3233dfb43$export$e27663b14f44038e = (0, $dTa0V.createPageEntryPoint)({
    main: $kyjSD.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    horizontalNavigation: (0, $g6jek.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("kyjSD", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $b161462f94624100$export$7d51b2b14ae8000f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $jyKgL = parcelRequire("jyKgL");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $b161462f94624100$export$7d51b2b14ae8000f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("02PVe")), {
        moduleId: "a19e844c",
        moduleName: "HelpCenterSettingsSupportWebsitePagesComponent",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                customPagesQuery: {
                    parameters: $jyKgL.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        NUMBER_OF_PAGES_INITIAL_FETCH: 300
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("jyKgL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b2a51e73568aeb7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1e4008cf1a810da5a69af68580d2d27c>>
 * @relayHash f13961bf02127962900ef43b1b0957b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0381d6bd7bbe5617a5660feab9ea1ef587bd4c9822f831ab5b078936b0bd4726
const $7b2a51e73568aeb7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0381d6bd7bbe5617a5660feab9ea1ef587bd4c9822f831ab5b078936b0bd4726",
        "metadata": {
            "connection": [
                {
                    "count": "NUMBER_OF_PAGES_INITIAL_FETCH",
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "helpCenter",
                        "helpCenterPages"
                    ]
                }
            ]
        },
        "name": "SupportWebsitePagesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7b2a51e73568aeb7$export$2e2bcd8739ae039 = $7b2a51e73568aeb7$var$node;

});

parcelRegister("02PVe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7r8wS").then(()=>parcelRequire('7lGO8'));

});




parcelRegister("egvB1", function(module, exports) {
$parcel$export(module.exports, "csmExperienceWidgetConfigurationCustomizeRouteEntry", () => $98034bb5be8eb7fc$export$71e2eb03677066a4);

var $3GWKF = parcelRequire("3GWKF");

var $idDnR = parcelRequire("idDnR");

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $62JVW = parcelRequire("62JVW");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $668Am = parcelRequire("668Am");
const $98034bb5be8eb7fc$export$71e2eb03677066a4 = (0, $fdS54.createEntry)((0, $62JVW.csmExperienceWidgetConfigurationCustomizeRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.csm-experience-widget-configuration.customize',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7),
            horizontal: (0, $3GWKF.AsyncWidgetConfigurationNav)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $668Am.HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3GWKF", function(module, exports) {
$parcel$export(module.exports, "AsyncWidgetConfigurationNav", () => $63c2eb9833a0c923$export$c122cfaa5c33f0c5);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $63c2eb9833a0c923$var$LazyWidgetConfigurationHorizontalNav = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1Rq1j")).then(({ WidgetConfigurationHorizontalNav: WidgetConfigurationHorizontalNav })=>WidgetConfigurationHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-csm-widget-configuration/src/ui/horizontal-nav/WidgetConfigurationHorizontalNav.tsx"
});
const $63c2eb9833a0c923$export$c122cfaa5c33f0c5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-csm-widget-configuration-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($63c2eb9833a0c923$var$LazyWidgetConfigurationHorizontalNav, null));
$63c2eb9833a0c923$export$c122cfaa5c33f0c5.displayName = "AsyncWidgetConfigurationNav";

});
parcelRegister("1Rq1j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1nHOn").then(()=>parcelRequire('hhTmu'));

});


parcelRegister("62JVW", function(module, exports) {
$parcel$export(module.exports, "csmExperienceWidgetConfigurationCustomizeRoute", () => $4c9d98fcaf0f4a37$export$876abb8b04bec1cb);
const $4c9d98fcaf0f4a37$export$876abb8b04bec1cb = {
    name: 'csm-experience-widget-configuration-customize',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/embed/:widgetId/customize',
    exact: true
};

});

parcelRegister("668Am", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint", () => $8d9edcce36e5b620$export$797b58b534648b3f);

var $djQjf = parcelRequire("djQjf");

var $eewOx = parcelRequire("eewOx");

var $dTa0V = parcelRequire("dTa0V");
const $8d9edcce36e5b620$export$797b58b534648b3f = (0, $dTa0V.createPageEntryPoint)({
    main: $eewOx.customizeEntryPoint,
    horizontalNavigation: (0, $djQjf.horizontalNavigationCsmWidgetConfigurationEntryPoint)
});

});
parcelRegister("djQjf", function(module, exports) {
$parcel$export(module.exports, "horizontalNavigationCsmWidgetConfigurationEntryPoint", () => $ea921123e6319de5$export$abb65bb7f7663f4d);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $khNUu = parcelRequire("khNUu");

const $ea921123e6319de5$export$abb65bb7f7663f4d = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("9mKnw")), {
        moduleId: "6baa5b1c",
        moduleName: "WidgetConfigurationNavEntryPoint",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, widgetId: widgetId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                WidgetConfigurationNavEntryPointQuery: {
                    parameters: $khNUu.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        widgetId: widgetId ?? ''
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("khNUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $98f0e8d53414328b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7eb8caa9e2d1e2196c5cdec4fd72e277>>
 * @relayHash f06abf01dc4b25e556cc9c4f8841e1d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6c6e609b4c182572eead8c06b423fcc978804165e978a3d9b667418888cd7cd9
const $98f0e8d53414328b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6c6e609b4c182572eead8c06b423fcc978804165e978a3d9b667418888cd7cd9",
        "metadata": {},
        "name": "WidgetConfigurationNavEntryPointQuery",
        "operationKind": "query",
        "text": null
    }
};
var $98f0e8d53414328b$export$2e2bcd8739ae039 = $98f0e8d53414328b$var$node;

});

parcelRegister("9mKnw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("69Mbr").then(()=>parcelRequire('khko2'));

});


parcelRegister("eewOx", function(module, exports) {
$parcel$export(module.exports, "customizeEntryPoint", () => $2b40fe5f4ab09eef$export$7213ac69dc745c32);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $2ghzc = parcelRequire("2ghzc");

const $2b40fe5f4ab09eef$export$7213ac69dc745c32 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hz5n0")), {
        moduleId: "68f9103a",
        moduleName: "HelpCenterSettingsWidgetConfigurationCustomizeApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, widgetId: widgetId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                page: {
                    parameters: (0, $2ghzc.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        widgetId: widgetId ?? '',
                        isConsentFormEnabled: (0, $i860n.fg)('csm_widget_consent_form')
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("2ghzc", function(module, exports) {
$parcel$export(module.exports, "default", () => $795eabcdadf90a55$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<52e55a8726ac79cbfb1172510894a5b6>>
 * @relayHash 77d56fc84b344cc7c86300b4ca381f19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9569496d7f33b9bf3caecfab77ff1558bac1ba1ac5b3dc5fe9834839430b61b2

var $lIGkE = parcelRequire("lIGkE");
const $795eabcdadf90a55$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConsentFormEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "widgetId"
    }, v4 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "widgetId",
            "variableName": "widgetId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        v4 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v11 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "isConsentFormEnabled",
                                            "variableName": "isConsentFormEnabled"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
                                }
                            ],
                            "type": "CsmAiWidgetConfig"
                        }
                    ]
                },
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "allowedDomains"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isAnonymousAccessEnabled"
                                },
                                v10 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "position"
                                },
                                {
                                    "concreteType": "CsmAiWidgetBrandingTheme",
                                    "kind": "LinkedField",
                                    "name": "theme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorVibeVariant"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "radius"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "space"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "chatColor"
                                        },
                                        {
                                            "concreteType": "CsmAiWidgetBrandingAttribution",
                                            "kind": "LinkedField",
                                            "name": "attribution",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "text"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "welcomeMessage"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isConsentFormEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "CsmAiWidgetConsentForm",
                                            "kind": "LinkedField",
                                            "name": "consentForm",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "policy"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "acceptLabel"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "declineLabel"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiWidgetConfig"
                        }
                    ]
                },
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9569496d7f33b9bf3caecfab77ff1558bac1ba1ac5b3dc5fe9834839430b61b2",
            "metadata": {},
            "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$795eabcdadf90a55$var$node.hash = "1e0eaf37f6876d310180100049dc0022";
(0, $lIGkE.PreloadableQueryRegistry).set($795eabcdadf90a55$var$node.params.id, $795eabcdadf90a55$var$node);
var $795eabcdadf90a55$export$2e2bcd8739ae039 = $795eabcdadf90a55$var$node;

});

parcelRegister("hz5n0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4szSV").then(()=>parcelRequire('4SDKh'));

});




parcelRegister("4PqDp", function(module, exports) {
$parcel$export(module.exports, "csmExperienceWidgetConfigurationInstallRouteEntry", () => $72f7cc5621709c4d$export$b13bf25dab752798);

var $3GWKF = parcelRequire("3GWKF");

var $idDnR = parcelRequire("idDnR");

var $4cLgf = parcelRequire("4cLgf");

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $k40Ww = parcelRequire("k40Ww");

var $iSoIx = parcelRequire("iSoIx");

var $lhkth = parcelRequire("lhkth");

var $5yPS0 = parcelRequire("5yPS0");

var $2QlXq = parcelRequire("2QlXq");
const $72f7cc5621709c4d$export$b13bf25dab752798 = (0, $fdS54.createEntry)((0, $k40Ww.csmExperienceWidgetConfigurationInstallRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.csm-experience-widget-configuration.install',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7),
            horizontal: (0, $3GWKF.AsyncWidgetConfigurationNav)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $2QlXq.HelpCenterSettingsWidgetConfigurationInstallEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4cLgf.widgetAnonymousAccessResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4cLgf", function(module, exports) {
$parcel$export(module.exports, "widgetAnonymousAccessResource", () => $a1dd37bdabe84729$export$f5d4265a395e1460);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");

var $ivTJy = parcelRequire("ivTJy");
const $a1dd37bdabe84729$export$f5d4265a395e1460 = (0, $7edbf.createResource)({
    type: 'CSM_WIDGET_ANONYMOUS_ACCESS',
    getKey: ()=>'widget-anonymous-access',
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        const helpCenterId = match.params.helpCenterId;
        const activationId = tenantContext.activationId;
        if (!helpCenterId) throw new Error('Help center ID is not set');
        const helpCenterAri = (0, $ivTJy.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        try {
            const data = await (0, $h2wCv.performGetRequest)(`/gateway/api/assist/csm/v2/widgets/access?helpCenterAri=${helpCenterAri}`, {
                headers: {
                    'x-product': 'csm',
                    'x-experience-id': 'csm-ai'
                },
                // Use 'omit' to make a truly anonymous request without sending cookies
                credentials: 'omit'
            });
            return {
                canWidgetBeAccessedByAnonymousUsers: data.hasAccess
            };
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'widgetAnonymousAccessResource',
                    packageName: 'jiraRouterResourcesWidgetAnonymousAccess',
                    teamName: 'csm-ai'
                },
                error: error instanceof Error ? error : new Error('Failed to check anonymous access')
            });
            throw error;
        }
    },
    isBrowserOnly: true
});

});

parcelRegister("k40Ww", function(module, exports) {
$parcel$export(module.exports, "csmExperienceWidgetConfigurationInstallRoute", () => $2df49b9f5530b963$export$1a09865c6e88fd9a);
const $2df49b9f5530b963$export$1a09865c6e88fd9a = {
    name: 'csm-experience-widget-configuration-install',
    path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/embed/:widgetId/install',
    exact: true
};

});

parcelRegister("2QlXq", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationInstallEntryPoint", () => $bc3b4c161df61757$export$f1b91dfa549d7f2d);

var $djQjf = parcelRequire("djQjf");

var $aVQSV = parcelRequire("aVQSV");

var $dTa0V = parcelRequire("dTa0V");
const $bc3b4c161df61757$export$f1b91dfa549d7f2d = (0, $dTa0V.createPageEntryPoint)({
    main: $aVQSV.installEntryPoint,
    horizontalNavigation: (0, $djQjf.horizontalNavigationCsmWidgetConfigurationEntryPoint)
});

});
parcelRegister("aVQSV", function(module, exports) {
$parcel$export(module.exports, "installEntryPoint", () => $93a4b576c2f1d601$export$a67eb9bb1b8e25ec);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $jpMrS = parcelRequire("jpMrS");

const $93a4b576c2f1d601$export$a67eb9bb1b8e25ec = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("54pp6")), {
        moduleId: "d6ed78a3",
        moduleName: "HelpCenterSettingsWidgetConfigurationInstallApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, widgetId: widgetId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                page: {
                    parameters: (0, $jpMrS.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        widgetId: widgetId ?? ''
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("jpMrS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e66c41a9e9d66b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a2cca8f6369acc0a2199155f1a0fa54>>
 * @relayHash 4d8ae05c2654945ef0cc2b646577df47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba0fbb1bfea45aac126e03879b3623a4f065cc919caa5869502bef4aa359a361

var $lIGkE = parcelRequire("lIGkE");
const $1e66c41a9e9d66b6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "widgetId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "widgetId",
            "variableName": "widgetId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "authType",
            "value": "ANONYMOUS"
        }
    ], v5 = [
        {
            "kind": "Literal",
            "name": "authType",
            "value": "AUTHENTICATED"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v7 = [
        v1 /*: any*/ 
    ], v8 = [
        {
            "kind": "ScalarField",
            "name": "language"
        },
        {
            "kind": "ScalarField",
            "name": "code"
        }
    ], v9 = [
        {
            "concreteType": "CsmAiCodeSnippet",
            "kind": "LinkedField",
            "name": "serverSnippets",
            "plural": true,
            "selections": v8 /*: any*/ 
        },
        {
            "concreteType": "CsmAiCodeSnippet",
            "kind": "LinkedField",
            "name": "clientSnippets",
            "plural": true,
            "selections": v8 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getWidget",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "Install_AtlassianCsmWidgetConfiguration_fragmentRef"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "Install_AtlassianCsmWidgetConfiguration_clientKeysRef"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "standardSnippets",
                                        "args": v4 /*: any*/ ,
                                        "concreteType": "CsmAiWidgetSnippets",
                                        "kind": "LinkedField",
                                        "name": "snippets",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "Install_AtlassianCsmWidgetConfiguration_standardSnippetsRef"
                                            }
                                        ],
                                        "storageKey": "snippets(authType:\"ANONYMOUS\")"
                                    },
                                    "action": "THROW"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "tailoredSnippets",
                                        "args": v5 /*: any*/ ,
                                        "concreteType": "CsmAiWidgetSnippets",
                                        "kind": "LinkedField",
                                        "name": "snippets",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "Install_AtlassianCsmWidgetConfiguration_tailoredSnippetsRef"
                                            }
                                        ],
                                        "storageKey": "snippets(authType:\"AUTHENTICATED\")"
                                    },
                                    "action": "THROW"
                                }
                            ],
                            "type": "CsmAiWidgetConfig"
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v7 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "helpCenterPermissionSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "Install_AtlassianCsmWidgetConfiguration_accessControlDataRef"
                                            }
                                        ],
                                        "type": "HelpCenterPermissionSettings"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getWidget",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "allowedDomains"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "clientKeys",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "CsmAiWidgetClientKeyStatus",
                                                    "kind": "LinkedField",
                                                    "name": "keys",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "clientKeyId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "createdTimestamp"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiWidgetClientKeys"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                {
                                    "alias": "standardSnippets",
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "CsmAiWidgetSnippets",
                                    "kind": "LinkedField",
                                    "name": "snippets",
                                    "plural": false,
                                    "selections": v9 /*: any*/ ,
                                    "storageKey": "snippets(authType:\"ANONYMOUS\")"
                                },
                                {
                                    "alias": "tailoredSnippets",
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "CsmAiWidgetSnippets",
                                    "kind": "LinkedField",
                                    "name": "snippets",
                                    "plural": false,
                                    "selections": v9 /*: any*/ ,
                                    "storageKey": "snippets(authType:\"AUTHENTICATED\")"
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiWidgetConfig"
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPermissionSettings",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "accessControlType"
                                        }
                                    ],
                                    "type": "HelpCenterPermissionSettings"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ba0fbb1bfea45aac126e03879b3623a4f065cc919caa5869502bef4aa359a361",
            "metadata": {},
            "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1e66c41a9e9d66b6$var$node.hash = "134eeb364455426174405957cc2160df";
(0, $lIGkE.PreloadableQueryRegistry).set($1e66c41a9e9d66b6$var$node.params.id, $1e66c41a9e9d66b6$var$node);
var $1e66c41a9e9d66b6$export$2e2bcd8739ae039 = $1e66c41a9e9d66b6$var$node;

});

parcelRegister("54pp6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kfAeY").then(()=>parcelRequire('sLpzG'));

});




parcelRegister("3GrQ7", function(module, exports) {
$parcel$export(module.exports, "csmGetStartedRouteEntry", () => $b47fdb427d91331c$export$508c12bdd1d2c815);



var $iSoIx = parcelRequire("iSoIx");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $74h93 = parcelRequire("74h93");

var $glLzJ = parcelRequire("glLzJ");

var $xmwl9 = parcelRequire("xmwl9");

var $i860n = parcelRequire("i860n");

var $1IAdV = parcelRequire("1IAdV");
const $b47fdb427d91331c$export$508c12bdd1d2c815 = (0, $fdS54.createEntry)((0, $glLzJ.csmGetStartedRoute), ()=>({
        group: 'customer-service',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'customer-service-get-started-page-load',
        skeleton: (0, $xmwl9.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $1IAdV.customerServiceGetStartedPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("t7VsO", function(module, exports) {
$parcel$export(module.exports, "servicedeskIssueTypesResource", () => $48382c87a85bb15c$export$191ce50629f40dbe);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");


const $48382c87a85bb15c$export$191ce50629f40dbe = (0, $7edbf.createResource)({
    type: (0, $8c8e5fe0e5d74de0$export$1ed713fe52212251),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("fibGg"))
});

});
/* eslint-disable jira/filename-case */ const $8c8e5fe0e5d74de0$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';

parcelRegister("fibGg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("725CF").then(()=>parcelRequire('iQfHr'));

});


parcelRegister("glLzJ", function(module, exports) {
$parcel$export(module.exports, "csmGetStartedRoute", () => $40978389491e5661$export$8d6c4d7e31559722);
const $40978389491e5661$export$8d6c4d7e31559722 = {
    name: 'csm-get-started',
    path: '/jira/customer-service-management/projects/:projectKey/get-started',
    exact: true
};

});

parcelRegister("xmwl9", function(module, exports) {
$parcel$export(module.exports, "GettingStartedPageSkeleton", () => $c30e60063f6cc38e$export$525669daa9599ec);
/* GettingStartedPageSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $d5ps5 = parcelRequire("d5ps5");

var $i860n = parcelRequire("i860n");

var $iPTKd = parcelRequire("iPTKd");

var $3Z39h = parcelRequire("3Z39h");
const $c30e60063f6cc38e$var$customCssStyles = null;
const $c30e60063f6cc38e$var$skeletonWrapperStyles = null;
const $c30e60063f6cc38e$export$525669daa9599ec = ()=>{
    if ((0, $i860n.fg)('solution_composer_master')) return /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _bfhkvuon _vchhusvi _1e0c1txw _2lx21bp4 _1bsb1osq _4t3i1osq _p12f1kx0 _18u01wug _2hwx1wug"
        ])
    }, /*#__PURE__*/ $euxye.createElement((0, $3Z39h.GettingStartedSkeletonGrid), null));
    return /*#__PURE__*/ $euxye.createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iPTKd))),
        className: (0, $4jQY2.default)([
            "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
        ])
    });
};
$c30e60063f6cc38e$export$525669daa9599ec.displayName = "GettingStartedPageSkeleton";

});
parcelRegister("iPTKd", function(module, exports) {
module.exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();

});

parcelRegister("3Z39h", function(module, exports) {
$parcel$export(module.exports, "GettingStartedSkeletonGrid", () => $77fce3a1bbe77031$export$5e0d9cb12c7ca11c);
/* GettingStartedSkeletonCards.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $gwWMf = parcelRequire("gwWMf");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $3NRLa = parcelRequire("3NRLa");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $77fce3a1bbe77031$var$styles = {
    card: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _vchhusvi _1bsb1osq _4t3i1wdt _1tke1wdt _bfhkhp5a _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    nextCard: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _vchhusvi _1bsb1osq _4t3i1w81 _1tke1w81 _bfhkhp5a _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    breadcrumbs: "_syaz1rpy",
    nextSection: "_ca0qpxbi",
    rowContainer: "_2rko12b0 _1bsb1osq _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    rowContent: "_1bsb1osq _u5f31ejb",
    bannerContainer: "_1bsb1osq _p12f1cqt _18u01wug _2hwx1wug"
};
const $77fce3a1bbe77031$var$spacesBreadcrumbMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.breadcrumbs.spaces",
    defaultMessage: "Spaces"
});
const $77fce3a1bbe77031$var$gettingStartedBreadcrumbMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.breadcrumbs.getting-started",
    defaultMessage: "Getting started"
});
const $77fce3a1bbe77031$var$SKELETON_CARD_COUNT = 6;
const $77fce3a1bbe77031$var$gridStyles = {
    grid: "_yv0e7me6 _2z051wdt _umai1wdt _1bsb1osq _p12f1cqt _18u01wug _2hwx1wug",
    nextGrid: "_yv0e7me6 _2z051w81 _umai1w81 _1bsb1osq _p12f1cqt _18u01wug _2hwx1wug"
}; /**
    * Renders 6 skeleton card placeholders for the Getting Started page.
    * Shared between the full-page skeleton and the in-grid loading fallback.
    */ 
function $77fce3a1bbe77031$export$4b03e43bf8807280() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, Array.from({
        length: $77fce3a1bbe77031$var$SKELETON_CARD_COUNT
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            key: i,
            xcss: $77fce3a1bbe77031$var$styles.card,
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "100%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($77fce3a1bbe77031$var$SkeletonNavRows, null))));
}
$77fce3a1bbe77031$export$4b03e43bf8807280.displayName = "GettingStartedSkeletonCards";
const $77fce3a1bbe77031$var$containerStyles = {
    container: "_zulppxbi _vchhusvi _1e0c1txw _2lx21bp4 _1bsb1osq _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb"
};
function $77fce3a1bbe77031$var$NextSectionSkeletonCards() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, Array.from({
        length: 3
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            key: i,
            xcss: $77fce3a1bbe77031$var$styles.nextCard,
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "100%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($77fce3a1bbe77031$var$SkeletonNavRows, null))));
}
$77fce3a1bbe77031$var$NextSectionSkeletonCards.displayName = "NextSectionSkeletonCards";
function $77fce3a1bbe77031$var$SkeletonNavRows() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.100"
    }, [
        '70%',
        '55%',
        '60%'
    ].map((width, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
            key: i,
            xcss: $77fce3a1bbe77031$var$styles.rowContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
            alignItems: "center",
            gap: "space.150",
            xcss: $77fce3a1bbe77031$var$styles.rowContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "24px",
            height: "24px",
            borderRadius: "var(--ds-radius-xsmall, 2px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: width,
            height: "14px",
            borderRadius: "var(--ds-radius-small, 4px)"
        })))));
} /**
   * Banner skeleton + 3x2 card grid. Shared between the full-page skeleton
   * and the in-component Suspense fallback in solution-composer.
   *
   * Includes its own padding/gap container so callers get consistent spacing
   * regardless of context.
   */ 
$77fce3a1bbe77031$var$SkeletonNavRows.displayName = "SkeletonNavRows";
function $77fce3a1bbe77031$export$5e0d9cb12c7ca11c() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $77fce3a1bbe77031$var$containerStyles.container,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.100",
        xcss: $77fce3a1bbe77031$var$styles.breadcrumbs
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        size: "medium",
        color: "color.text.subtlest"
    }, formatMessage($77fce3a1bbe77031$var$spacesBreadcrumbMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        size: "medium",
        color: "color.text.subtlest"
    }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        size: "medium",
        color: "color.text.subtlest"
    }, formatMessage($77fce3a1bbe77031$var$gettingStartedBreadcrumbMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $77fce3a1bbe77031$var$styles.bannerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "100%",
        height: "100px",
        borderRadius: "var(--ds-radius-medium, 6px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gwWMf.default), {
        xcss: $77fce3a1bbe77031$var$gridStyles.grid,
        gap: "space.200",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($77fce3a1bbe77031$export$4b03e43bf8807280, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $77fce3a1bbe77031$var$styles.nextSection,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "88px",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "286px",
        height: "14px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gwWMf.default), {
        xcss: $77fce3a1bbe77031$var$gridStyles.nextGrid,
        gap: "space.200",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($77fce3a1bbe77031$var$NextSectionSkeletonCards, null)));
}
$77fce3a1bbe77031$export$5e0d9cb12c7ca11c.displayName = "GettingStartedSkeletonGrid";

});
parcelRegister("gwWMf", function(module, exports) {
$parcel$export(module.exports, "default", () => $607c0b25003632a3$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $607c0b25003632a3$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $607c0b25003632a3$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $607c0b25003632a3$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $607c0b25003632a3$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $607c0b25003632a3$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $607c0b25003632a3$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $607c0b25003632a3$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Box } from '@atlaskit/primitives/compiled'
 * import { Grid } from '@atlaskit/primitives/compiled/grid'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $607c0b25003632a3$var$Grid = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $4jQY2.default)([
            $607c0b25003632a3$var$baseStyles.root,
            gap && $607c0b25003632a3$var$columnGapMap[gap],
            columnGap && $607c0b25003632a3$var$columnGapMap[columnGap],
            gap && $607c0b25003632a3$var$rowGapMap[gap],
            rowGap && $607c0b25003632a3$var$rowGapMap[rowGap],
            alignItems && $607c0b25003632a3$var$alignItemsMap[alignItems],
            alignContent && $607c0b25003632a3$var$alignContentMap[alignContent],
            justifyContent && $607c0b25003632a3$var$justifyContentMap[justifyContent],
            autoFlow && $607c0b25003632a3$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$607c0b25003632a3$var$Grid.displayName = 'Grid';
var $607c0b25003632a3$export$2e2bcd8739ae039 = $607c0b25003632a3$var$Grid;

});



parcelRegister("1IAdV", function(module, exports) {
$parcel$export(module.exports, "customerServiceGetStartedPageEntryPoint", () => $c0a9b503d6f8c72b$export$fdc75e6cf24026f5);
/* eslint-disable jira/naming/disallow-filenames */ 
var $loVWM = parcelRequire("loVWM");

var $dTa0V = parcelRequire("dTa0V");
const $c0a9b503d6f8c72b$export$fdc75e6cf24026f5 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $loVWM.customerServiceGetStartedEntryPoint)
});

});
parcelRegister("loVWM", function(module, exports) {
$parcel$export(module.exports, "customerServiceGetStartedEntryPoint", () => $bf1bffb683f2223d$export$16f9ae4ef5a48d4a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $bf1bffb683f2223d$export$16f9ae4ef5a48d4a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3mZEi")), {
        moduleId: "c153713f",
        moduleName: "CustomerServiceGetStarted",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3mZEi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2CCSi").then(()=>parcelRequire('92djh'));

});




parcelRegister("lzHoK", function(module, exports) {
$parcel$export(module.exports, "csmLiveConversationsRouteEntry", () => $ec586a9c6eeca320$export$1327e5de81187893);

var $fucnc = parcelRequire("fucnc");

var $eTQ9s = parcelRequire("eTQ9s");

var $iSoIx = parcelRequire("iSoIx");

var $8rfXq = parcelRequire("8rfXq");


var $h2tgz = parcelRequire("h2tgz");


var $fdS54 = parcelRequire("fdS54");

var $lhkth = parcelRequire("lhkth");

var $dTa0V = parcelRequire("dTa0V");

var $edf7u = parcelRequire("edf7u");

var $iyqMX = parcelRequire("iyqMX");

var $lEPfS = parcelRequire("lEPfS");

var $i860n = parcelRequire("i860n");
const $ec586a9c6eeca320$var$customerServiceLiveConversationsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fucnc.customerServiceLiveConversationsEntryPoint)
});
const $ec586a9c6eeca320$export$1327e5de81187893 = (0, $fdS54.createEntry)((0, $eTQ9s.csmLiveConversationsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.live-conversations',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $ec586a9c6eeca320$var$customerServiceLiveConversationsPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $iyqMX.serviceDeskContextResource),
            (0, $lEPfS.featuresResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8rfXq.omniSubAccountStatus)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fucnc", function(module, exports) {
$parcel$export(module.exports, "customerServiceLiveConversationsEntryPoint", () => $e60b1fe42782bca6$export$6ccc0205035ae3a3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $c2cG1 = parcelRequire("c2cG1");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $e60b1fe42782bca6$export$6ccc0205035ae3a3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("g34uj")), {
        moduleId: "2d780e07",
        moduleName: "LiveConversationsSpaApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, atlassianAccountId: atlassianAccountId } })=>({
            queries: {
                LiveConversationsAppQuery: {
                    parameters: $c2cG1.default,
                    variables: {
                        cloudId: cloudId,
                        atlassianAccountId: atlassianAccountId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("c2cG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $059165e6e2c01259$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb1b6b590b5ea69c67d6eaf16cbdad2a>>
 * @relayHash 3746bdb44c8e624e3638a3c46fa28355
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5b90daa3e238d64cfb8b2f06745a24ab11f5773fb081ebcd045a7fc1df2b163
const $059165e6e2c01259$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f5b90daa3e238d64cfb8b2f06745a24ab11f5773fb081ebcd045a7fc1df2b163",
        "metadata": {},
        "name": "LiveConversationsAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $059165e6e2c01259$export$2e2bcd8739ae039 = $059165e6e2c01259$var$node;

});

parcelRegister("g34uj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("ay8Nt"),
    $4cvLQ("9oNYt")
]).then(()=>parcelRequire('7Opsv'));

});


parcelRegister("eTQ9s", function(module, exports) {
$parcel$export(module.exports, "csmLiveConversationsRoute", () => $1fa9d77b7dfba239$export$a158d42cea8d96c1);
const $1fa9d77b7dfba239$export$a158d42cea8d96c1 = {
    name: 'csm-live-conversations',
    path: '/jira/customer-service-management/projects/:projectKey/conversations/:issueKey?',
    exact: true
};

});

parcelRegister("8rfXq", function(module, exports) {
$parcel$export(module.exports, "omniSubAccountStatus", () => $46fb673af1e98c5e$export$d0fe54f850b49409);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $46fb673af1e98c5e$export$d0fe54f850b49409 = (0, $7edbf.createResource)({
    type: 'OMNI_SUB_ACCOUNT_STATUS',
    getKey: ()=>'OMNI_SUB_ACCOUNT_STATUS',
    getData: async ()=>(0, $h2wCv.performGetRequest)('/gateway/api/jsm/csm/api/v1/omni/twilio/subaccount/status'),
    maxAge: 0,
    isBrowserOnly: true
});

});


parcelRegister("koyMU", function(module, exports) {
$parcel$export(module.exports, "csmOrganizationDetailsRouteEntry", () => $eca5b9367ba8c09d$export$779dd8ba653d997a);



var $2clbx = parcelRequire("2clbx");

var $6RvOI = parcelRequire("6RvOI");

var $gAOlK = parcelRequire("gAOlK");

var $5hiaJ = parcelRequire("5hiaJ");

var $iSoIx = parcelRequire("iSoIx");

var $6ocxT = parcelRequire("6ocxT");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $jVrUf = parcelRequire("jVrUf");

var $Q5OI6 = parcelRequire("Q5OI6");

var $lhkth = parcelRequire("lhkth");
const $eca5b9367ba8c09d$var$csmOrganizationDetailsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2clbx.customerServiceOrganizationDetailsEntryPoint)
});
const $eca5b9367ba8c09d$export$779dd8ba653d997a = (0, $fdS54.createEntry)((0, $6ocxT.csmOrganizationDetailsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.csm-organization-details',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $eca5b9367ba8c09d$var$csmOrganizationDetailsPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $5hiaJ.OrganizationDetailsPageQueryResource),
            (0, $gAOlK.EntitlementsEntitlementsQueryResource),
            (0, $Q5OI6.productsJsmOrganizationDetailsResource),
            (0, $jVrUf.jsmEmailDomainsListResource),
            (0, $6RvOI.l1CustomersProjectProviderResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2clbx", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationDetailsEntryPoint", () => $ea216582b134c811$export$b6d7904aa0b4dcb4);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ea216582b134c811$export$b6d7904aa0b4dcb4 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("6mS8a")), {
        moduleId: "547d9b85",
        moduleName: "CustomerServiceOrganizationDetailsSpaApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6mS8a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("9XOGV")
]).then(()=>parcelRequire('aTDCT'));

});


parcelRegister("gAOlK", function(module, exports) {
$parcel$export(module.exports, "EntitlementsEntitlementsQueryResource", () => $55d1d93b91434971$export$c1f7620990c1e585);

var $9LjcO = parcelRequire("9LjcO");

var $htsFl = parcelRequire("htsFl");
const $55d1d93b91434971$var$getCustomerServiceOrganizationAri = (organizationId, activationId)=>{
    return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};
const $55d1d93b91434971$export$c1f7620990c1e585 = (0, $htsFl.createRelayResource)({
    type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9LjcO.default),
            variables: {
                organizationId: $55d1d93b91434971$var$getCustomerServiceOrganizationAri(String(match.params.organizationId), tenantContext.activationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("9LjcO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2f58e3f0ce16e5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c0367b1cbb8a22ea03e84faba7e3db59>>
 * @relayHash 3ed6a55d6b39a49ae6a95619ef16ff61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bd6ba9d1b06f3a5def83dee2e069e4810b9ca9e72e61e29df2d401cce168033
const $f2f58e3f0ce16e5c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EntitlementsEntitlementsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v6 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": false
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "Entitlement"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW"
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ThrowOnQueryError"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EntitlementsEntitlementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4bd6ba9d1b06f3a5def83dee2e069e4810b9ca9e72e61e29df2d401cce168033",
            "metadata": {},
            "name": "EntitlementsEntitlementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f2f58e3f0ce16e5c$var$node.hash = "e51e400064a3a88281138b0b26c447f1";
var $f2f58e3f0ce16e5c$export$2e2bcd8739ae039 = $f2f58e3f0ce16e5c$var$node;

});


parcelRegister("5hiaJ", function(module, exports) {
$parcel$export(module.exports, "OrganizationDetailsPageQueryResource", () => $50b4cf633f9d7876$export$3ed29674f0cc8f97);

var $1J8N8 = parcelRequire("1J8N8");

var $htsFl = parcelRequire("htsFl");
const $50b4cf633f9d7876$var$getCustomerServiceOrganizationAri = (organizationId, activationId)=>{
    return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};
const $50b4cf633f9d7876$export$3ed29674f0cc8f97 = (0, $htsFl.createRelayResource)({
    type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $1J8N8.default),
            variables: {
                organizationId: $50b4cf633f9d7876$var$getCustomerServiceOrganizationAri(String(match.params.organizationId), tenantContext.activationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("1J8N8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4fd3e1cd6b07b95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0db9d9c03da5ab31d6bc16ef6bdab7ff>>
 * @relayHash 30f660231100a859a9fcf8b3755c6bdb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 822431a0f5b99b6c4f856504b2719eeccce37fe8f5159e84df6a46691d3fa1fd

var $lIGkE = parcelRequire("lIGkE");
const $c4fd3e1cd6b07b95$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OrganizationDetailsOrganizationDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "CustomDetailsSidebar"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ThrowOnQueryError"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OrganizationDetailsOrganizationDetailsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canEdit"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "822431a0f5b99b6c4f856504b2719eeccce37fe8f5159e84df6a46691d3fa1fd",
            "metadata": {},
            "name": "OrganizationDetailsOrganizationDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c4fd3e1cd6b07b95$var$node.hash = "02ab1420cec6c96b4b269b28d535dcd5";
(0, $lIGkE.PreloadableQueryRegistry).set($c4fd3e1cd6b07b95$var$node.params.id, $c4fd3e1cd6b07b95$var$node);
var $c4fd3e1cd6b07b95$export$2e2bcd8739ae039 = $c4fd3e1cd6b07b95$var$node;

});


parcelRegister("6ocxT", function(module, exports) {
$parcel$export(module.exports, "csmOrganizationDetailsRoute", () => $92a5898ddd7e9fa7$export$705bf8e3d151ff5d);
const $92a5898ddd7e9fa7$export$705bf8e3d151ff5d = {
    name: 'csm-organization-details',
    path: '/jira/customer-service-management/organizations/:organizationId',
    exact: true
};

});

parcelRegister("jVrUf", function(module, exports) {
$parcel$export(module.exports, "jsmEmailDomainsListResource", () => $b940e7fa1596b7b0$export$8e956348e5d47a3c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $b940e7fa1596b7b0$var$JSM_EMAIL_DOMAINS_LIST = 'JSM_EMAIL_DOMAINS_LIST';

const $b940e7fa1596b7b0$export$8e956348e5d47a3c = (0, $7edbf.createResource)({
    type: $b940e7fa1596b7b0$var$JSM_EMAIL_DOMAINS_LIST,
    getKey: ()=>'email-domains-list',
    isBrowserOnly: true,
    getDataLoader: ()=>(parcelRequire("59fdN"))
});

});
parcelRegister("59fdN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("53Wd6").then(()=>parcelRequire('lAu81'));

});


parcelRegister("Q5OI6", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationDetailsResource", () => $5b2634820f3e000c$export$ccda79811a15bf5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $5b2634820f3e000c$var$RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

const $5b2634820f3e000c$export$ccda79811a15bf5 = (0, $7edbf.createResource)({
    type: $5b2634820f3e000c$var$RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("2MaHG"))
});

});
parcelRegister("2MaHG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9mTj2").then(()=>parcelRequire('13Yl8'));

});



parcelRegister("i0RFn", function(module, exports) {
$parcel$export(module.exports, "csmOrganizationsRouteEntry", () => $359b478a2c093573$export$f3fee50a10bf8842);

var $lFUuS = parcelRequire("lFUuS");



var $fzxz4 = parcelRequire("fzxz4");

var $6RvOI = parcelRequire("6RvOI");

var $aS3GY = parcelRequire("aS3GY");

var $7FU4x = parcelRequire("7FU4x");

var $iSoIx = parcelRequire("iSoIx");

var $7zdmO = parcelRequire("7zdmO");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $lhkth = parcelRequire("lhkth");
const $359b478a2c093573$var$csmOrganizationsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fzxz4.customerServiceOrganizationsEntryPoint)
});
const $359b478a2c093573$export$f3fee50a10bf8842 = (0, $fdS54.createEntry)((0, $7zdmO.csmOrganizationsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.csm-organizations',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            horizontal: (0, $lFUuS.AsyncCustomersNav),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $359b478a2c093573$var$csmOrganizationsPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $6RvOI.l1CustomersProjectProviderResource),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource),
            (0, $7FU4x.customerServiceManagementCrmImportModuleResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fzxz4", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationsEntryPoint", () => $156e2052dbcc7726$export$e076da0b42b3d61b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $156e2052dbcc7726$export$e076da0b42b3d61b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7SGW8")), {
        moduleId: "9444c068",
        moduleName: "CustomerServiceOrganizationsSpaApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7SGW8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ilfed")
]).then(()=>parcelRequire('lR7cu'));

});


parcelRegister("7zdmO", function(module, exports) {
$parcel$export(module.exports, "csmOrganizationsRoute", () => $5f14a57bda36f384$export$8ecb9ee1bae2a3f1);
const $5f14a57bda36f384$export$8ecb9ee1bae2a3f1 = {
    name: 'csm-organizations',
    path: '/jira/customer-service-management/organizations',
    exact: true
};

});


parcelRegister("eidt5", function(module, exports) {
$parcel$export(module.exports, "csmProductsRouteEntry", () => $1eae4f6433d009d5$export$e374606a644d1656);

var $lFUuS = parcelRequire("lFUuS");



var $6RvOI = parcelRequire("6RvOI");

var $aS3GY = parcelRequire("aS3GY");

var $3R0xP = parcelRequire("3R0xP");

var $7FU4x = parcelRequire("7FU4x");

var $iSoIx = parcelRequire("iSoIx");

var $5DZKb = parcelRequire("5DZKb");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $lhkth = parcelRequire("lhkth");
const $1eae4f6433d009d5$var$csmProductsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $3R0xP.customerServiceProductsEntryPoint)
});
const $1eae4f6433d009d5$export$e374606a644d1656 = (0, $fdS54.createEntry)((0, $5DZKb.csmProductsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.csm-products',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            horizontal: (0, $lFUuS.AsyncCustomersNav),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            if (!(0, $i860n.fg)('berry-6285-customers-l1')) return 0, $iSoIx.notFoundPageEntrypoint;
            if ((0, $i860n.fg)('csm_appification_standalone_navigation')) return $1eae4f6433d009d5$var$csmProductsPageEntryPoint;
            return 0, $iSoIx.notFoundPageEntrypoint;
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $6RvOI.l1CustomersProjectProviderResource),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource),
            (0, $7FU4x.customerServiceManagementCrmImportModuleResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3R0xP", function(module, exports) {
$parcel$export(module.exports, "customerServiceProductsEntryPoint", () => $fe4231dcadd785e6$export$cbe982d0d183808b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $fc4UW = parcelRequire("fc4UW");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");
const $fe4231dcadd785e6$var$PRODUCTS_PAGE_SIZE = 50;

const $fe4231dcadd785e6$export$cbe982d0d183808b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("9vlCf")), {
        moduleId: "af54f9f0",
        moduleName: "CustomerServiceProductsSpaApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>({
            queries: {
                ProductsAppQuery: {
                    parameters: $fc4UW.default,
                    variables: {
                        cloudId: cloudId,
                        first: $fe4231dcadd785e6$var$PRODUCTS_PAGE_SIZE
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("fc4UW", function(module, exports) {
$parcel$export(module.exports, "default", () => $5322a6467fbd5335$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<698ce2a98471a87410710c3c7c10230d>>
 * @relayHash 2f2525f72b335b5d911e7fb1e6f7b2df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6
const $5322a6467fbd5335$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6",
        "metadata": {},
        "name": "ProductsAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5322a6467fbd5335$export$2e2bcd8739ae039 = $5322a6467fbd5335$var$node;

});

parcelRegister("9vlCf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("lIVvW")
]).then(()=>parcelRequire('lLQPw'));

});


parcelRegister("5DZKb", function(module, exports) {
$parcel$export(module.exports, "csmProductsRoute", () => $eed7a9b1cf8deb2a$export$403d742ce7df21a5);
const $eed7a9b1cf8deb2a$export$403d742ce7df21a5 = {
    name: 'csm-products',
    path: '/jira/customer-service-management/products',
    exact: true
};

});


parcelRegister("7C3ge", function(module, exports) {
$parcel$export(module.exports, "csmProjectCustomerNotificationsRuleRouteEntry", () => $b50061d89e284c98$export$50a20a4b0b77460b);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $lhkth = parcelRequire("lhkth");

var $ieOaO = parcelRequire("ieOaO");

var $iSoIx = parcelRequire("iSoIx");

var $5yPS0 = parcelRequire("5yPS0");

var $fU1OC = parcelRequire("fU1OC");
const $b50061d89e284c98$export$50a20a4b0b77460b = (0, $fdS54.createEntry)((0, $ieOaO.csmProjectCustomerNotificationsRuleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-project-customer-notifications-rule',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $fU1OC.helpCenterSettingsCustomerNotificationsAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ieOaO", function(module, exports) {
$parcel$export(module.exports, "csmProjectCustomerNotificationsRuleRoute", () => $e042ae015e250c3b$export$b032a7ff2e0719ef);
const $e042ae015e250c3b$export$b032a7ff2e0719ef = {
    name: 'csm-project-customer-notifications-rule',
    path: '/jira/customer-service-management/experiences/projects/:projectKey/settings/:helpCenterId/customer-notifications/rule/:ruleSetId',
    exact: true
};

});


parcelRegister("4LA4D", function(module, exports) {
$parcel$export(module.exports, "csmProjectCustomerNotificationsTemplateRouteEntry", () => $1e2f0b14fa88a6d6$export$f32a5273f02a8cc);

var $i860n = parcelRequire("i860n");



var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $lhkth = parcelRequire("lhkth");

var $hFS5c = parcelRequire("hFS5c");

var $iSoIx = parcelRequire("iSoIx");

var $5yPS0 = parcelRequire("5yPS0");

var $fU1OC = parcelRequire("fU1OC");
const $1e2f0b14fa88a6d6$export$f32a5273f02a8cc = (0, $fdS54.createEntry)((0, $hFS5c.csmProjectCustomerNotificationsTemplateRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.csm-project-customer-notifications-template',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $fU1OC.helpCenterSettingsCustomerNotificationsAppPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $5yPS0.getCsmExperiencesResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hFS5c", function(module, exports) {
$parcel$export(module.exports, "csmProjectCustomerNotificationsTemplateRoute", () => $d50bdc9aba2bdf48$export$1d9b76b24b6f6944);
const $d50bdc9aba2bdf48$export$1d9b76b24b6f6944 = {
    name: 'csm-project-customer-notifications-template',
    path: '/jira/customer-service-management/experiences/projects/:projectKey/settings/:helpCenterId/customer-notifications/template',
    exact: true
};

});


parcelRegister("1wKev", function(module, exports) {
$parcel$export(module.exports, "csmQueuesEditRouteEntry", () => $58f33016d4f8de5d$export$862d0bab9a149859);



var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $lhkth = parcelRequire("lhkth");

var $fdS54 = parcelRequire("fdS54");

var $iSoIx = parcelRequire("iSoIx");

var $lbxXL = parcelRequire("lbxXL");

var $cpnl1 = parcelRequire("cpnl1");

var $6wM0W = parcelRequire("6wM0W");

var $74h93 = parcelRequire("74h93");

var $9QD8J = parcelRequire("9QD8J");
const $58f33016d4f8de5d$export$862d0bab9a149859 = (0, $fdS54.createEntry)((0, $6wM0W.csmQueuesEditRoute), ()=>({
        group: 'customer-service',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            (0, $cpnl1.issueListSsrResource),
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $lbxXL.getQueueConfigResource)()
        ],
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? (0, $9QD8J.serviceDeskQueuesConfigPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        ufoName: 'service-management.queues.edit',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6wM0W", function(module, exports) {
$parcel$export(module.exports, "csmQueuesEditRoute", () => $6b4f1a45be01ffa1$export$5ed8cf912437ff00);
const $6b4f1a45be01ffa1$export$5ed8cf912437ff00 = {
    name: 'csm-queues-edit',
    path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});

parcelRegister("9QD8J", function(module, exports) {
$parcel$export(module.exports, "serviceDeskQueuesConfigPageEntryPoint", () => $59a0f533d6ca8b8c$export$2a7296eb9b68414);
/* eslint-disable jira/naming/disallow-filenames */ 
var $7xuxy = parcelRequire("7xuxy");

var $dTa0V = parcelRequire("dTa0V");
const $59a0f533d6ca8b8c$export$2a7296eb9b68414 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7xuxy.queuesConfigEntrypoint)
});

});
parcelRegister("7xuxy", function(module, exports) {
$parcel$export(module.exports, "queuesConfigEntrypoint", () => $582db60dbe5f6527$export$bc016338e2032123);

var $i0CFV = parcelRequire("i0CFV");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $lC5kV = parcelRequire("lC5kV");

var $6n2pY = parcelRequire("6n2pY");
const $582db60dbe5f6527$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;

const $582db60dbe5f6527$export$bc016338e2032123 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hteMO")), {
        moduleId: "7ca9fcf1",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: match, query: query, route: route }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        const queueAri = queueId ? (0, $lC5kV.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const input = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                SettingsContainerContentQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $6n2pY.default),
                    variables: {
                        input: input,
                        first: $582db60dbe5f6527$var$NAVIGATION_ITEMS_PAGE_SIZE
                    }
                }
            },
            extraProps: {
                query: query,
                match: match,
                route: route
            }
        };
    }
});

});
parcelRegister("6n2pY", function(module, exports) {
$parcel$export(module.exports, "default", () => $1df73bf3b0b00904$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a8cb8796445f852713ec8cc019cf5b7>>
 * @relayHash 02d4124590c433b0c9de4e4aa3c91197
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6ae4e96640fd92369f5f9abdc58c10451a3c13851e720cd775c3f1b446b2651
const $1df73bf3b0b00904$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        v6 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SettingsContainerContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        "action": "THROW"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SettingsContainerContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v10 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c6ae4e96640fd92369f5f9abdc58c10451a3c13851e720cd775c3f1b446b2651",
            "metadata": {},
            "name": "SettingsContainerContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1df73bf3b0b00904$var$node.hash = "f661aeee5eaa80513a6a6aee41ee162d";
var $1df73bf3b0b00904$export$2e2bcd8739ae039 = $1df73bf3b0b00904$var$node;

});

parcelRegister("hteMO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("8USJp")
]).then(()=>parcelRequire('4aPKY'));

});




parcelRegister("cQX3l", function(module, exports) {
$parcel$export(module.exports, "csmQueuesLandingRouteEntry", () => $af400c91f07c2c96$export$349a98a9ae403b21);


var $dTa0V = parcelRequire("dTa0V");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $lhkth = parcelRequire("lhkth");

var $fdS54 = parcelRequire("fdS54");

var $iSoIx = parcelRequire("iSoIx");

var $lbxXL = parcelRequire("lbxXL");

var $c4qiC = parcelRequire("c4qiC");

var $74h93 = parcelRequire("74h93");

var $iCF72 = parcelRequire("iCF72");
const $af400c91f07c2c96$var$csmQueuesLandingPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $iCF72.queuesLandingEntryPoint)
});
const $af400c91f07c2c96$export$349a98a9ae403b21 = (0, $fdS54.createEntry)((0, $c4qiC.csmQueuesLandingRoute), ()=>({
        group: 'customer-service',
        isRedirect: true,
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $af400c91f07c2c96$var$csmQueuesLandingPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c4qiC", function(module, exports) {
$parcel$export(module.exports, "csmQueuesLandingRoute", () => $351a35393d35624c$export$e69527cdf51ea025);
const $351a35393d35624c$export$e69527cdf51ea025 = {
    name: 'csm-queues-landing',
    path: '/jira/customer-service-management/projects/:projectKey/queues/(default|custom)?',
    exact: true
};

});

parcelRegister("iCF72", function(module, exports) {
$parcel$export(module.exports, "queuesLandingEntryPoint", () => $d84e52ea901aea57$export$1b272045dcc59c3a);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $d84e52ea901aea57$export$1b272045dcc59c3a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dgX58")), {
        moduleId: "b8070830",
        moduleName: "ExportedDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dgX58", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("iJEVL")
]).then(()=>parcelRequire('1E0Kl'));

});



parcelRegister("9NBqm", function(module, exports) {
$parcel$export(module.exports, "csmQueuesManageViewRouteEntry", () => $587cbaa362740963$export$2af9f998a4c58c63);



var $dTa0V = parcelRequire("dTa0V");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $iSoIx = parcelRequire("iSoIx");

var $lbxXL = parcelRequire("lbxXL");

var $eLjcF = parcelRequire("eLjcF");

var $74h93 = parcelRequire("74h93");

var $ihw3S = parcelRequire("ihw3S");
const $587cbaa362740963$var$csmQueuesManageViewPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ihw3S.queuesManageViewEntryPoint)
});
const $587cbaa362740963$export$2af9f998a4c58c63 = (0, $fdS54.createEntry)((0, $eLjcF.csmQueuesManageViewRoute), ()=>({
        group: 'customer-service',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            ...(0, $lbxXL.getQueuesResources)()
        ],
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $587cbaa362740963$var$csmQueuesManageViewPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eLjcF", function(module, exports) {
$parcel$export(module.exports, "csmQueuesManageViewRoute", () => $a8bc8c10e611f8ef$export$66a8958bc49ea2c7);
const $a8bc8c10e611f8ef$export$66a8958bc49ea2c7 = {
    name: 'csm-queues-manage-view',
    path: '/jira/customer-service-management/projects/:projectKey/queues/queue-settings',
    exact: true
};

});

parcelRegister("ihw3S", function(module, exports) {
$parcel$export(module.exports, "queuesManageViewEntryPoint", () => $e904f638fc23577f$export$a056b75ab500f509);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $e904f638fc23577f$export$a056b75ab500f509 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("buVvx")), {
        moduleId: "6143ebab",
        moduleName: "ExportedDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("buVvx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("57W21")
]).then(()=>parcelRequire('kIAQn'));

});



parcelRegister("7zQip", function(module, exports) {
$parcel$export(module.exports, "csmQueuesNewRouteEntry", () => $4b9c51f791a8f9fc$export$1d134f969b6c3839);



var $dTa0V = parcelRequire("dTa0V");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $lhkth = parcelRequire("lhkth");

var $fdS54 = parcelRequire("fdS54");

var $iSoIx = parcelRequire("iSoIx");

var $lbxXL = parcelRequire("lbxXL");

var $2I5fz = parcelRequire("2I5fz");

var $74h93 = parcelRequire("74h93");

var $l8bmS = parcelRequire("l8bmS");
const $4b9c51f791a8f9fc$var$csmQueuesNewPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8bmS.queuesCreateViewEntryPoint)
});
const $4b9c51f791a8f9fc$export$1d134f969b6c3839 = (0, $fdS54.createEntry)((0, $2I5fz.csmQueuesNewRoute), ()=>({
        group: 'customer-service',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $f11be1b6bfa50d8e$export$1590673d7ba4cdb7)
        },
        resources: [
            ...(0, $lhkth.getCustomerServiceL1NavigationResources)(),
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint () {
            return (0, $i860n.fg)('csm_appification_standalone_navigation') ? $4b9c51f791a8f9fc$var$csmQueuesNewPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        ufoName: 'service-management.queues.new',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2I5fz", function(module, exports) {
$parcel$export(module.exports, "csmQueuesNewRoute", () => $c7d7372dce643411$export$606a9a90a7cff56c);
const $c7d7372dce643411$export$606a9a90a7cff56c = {
    name: 'csm-queues-new',
    path: '/jira/customer-service-management/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});

parcelRegister("l8bmS", function(module, exports) {
$parcel$export(module.exports, "queuesCreateViewEntryPoint", () => $60d31709c05f755d$export$4d531e76e0c8aec0);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $60d31709c05f755d$export$4d531e76e0c8aec0 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("cEYxG")), {
        moduleId: "11438ec0",
        moduleName: "ExportedDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cEYxG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("cuxLh")
]).then(()=>parcelRequire('5gkXq'));

});



parcelRegister("539KO", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomerDetailsRouteEntry", () => $a4074b2ce8530591$export$9dfe67e6e721ca6d);
/* eslint-disable import/order */ 
var $423D8 = parcelRequire("423D8");

var $6RvOI = parcelRequire("6RvOI");

var $aMnvf = parcelRequire("aMnvf");

var $aqqTV = parcelRequire("aqqTV");

var $lFLfF = parcelRequire("lFLfF");

var $hTGTH = parcelRequire("hTGTH");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");
const $a4074b2ce8530591$var$customerServiceCustomerDetailsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $423D8.customerServiceCustomerDetailsEntryPoint)
});
const $a4074b2ce8530591$export$9dfe67e6e721ca6d = (0, $fdS54.createEntry)((0, $hTGTH.customerServiceCustomerDetailsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.customer-details',
        layout: (0, $h2tgz.globalLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return (0, $i860n.fg)('berry-6285-customers-l1') ? $a4074b2ce8530591$var$customerServiceCustomerDetailsPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $aMnvf.CustomerDetailsPageQueryResource),
            (0, $aqqTV.EntitlementsQueryResource),
            (0, $6RvOI.l1CustomersProjectProviderResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hTGTH", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomerDetailsRoute", () => $9f1b405d669d020e$export$465a65a04726e2e6);
const $9f1b405d669d020e$export$465a65a04726e2e6 = {
    name: 'customer-service-customer-details',
    path: '/jira/customer-service/customers/:customerId',
    exact: true
};

});


parcelRegister("4jDe2", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomersRouteEntry", () => $56c516963bcdbbd7$export$18c1302b859e0b5f);
/* eslint-disable import/order */ 
var $lFUuS = parcelRequire("lFUuS");

var $6RvOI = parcelRequire("6RvOI");

var $aS3GY = parcelRequire("aS3GY");

var $SmY74 = parcelRequire("SmY74");

var $7FU4x = parcelRequire("7FU4x");

var $lFLfF = parcelRequire("lFLfF");

var $cqZ9R = parcelRequire("cqZ9R");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");
const $56c516963bcdbbd7$var$customerServiceCustomersPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $SmY74.customerServiceCustomersEntryPoint)
});
const $56c516963bcdbbd7$export$18c1302b859e0b5f = (0, $fdS54.createEntry)((0, $cqZ9R.customerServiceCustomersRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.customers',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            horizontal: (0, $lFUuS.AsyncCustomersNav)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return (0, $i860n.fg)('berry-6285-customers-l1') ? $56c516963bcdbbd7$var$customerServiceCustomersPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RvOI.l1CustomersProjectProviderResource),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource),
            (0, $7FU4x.customerServiceManagementCrmImportModuleResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cqZ9R", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomersRoute", () => $ad00136a2b6489b8$export$2391fb29392d13ce);
const $ad00136a2b6489b8$export$2391fb29392d13ce = {
    name: 'customer-service-customers',
    path: '/jira/customer-service/customers',
    exact: true
};

});


parcelRegister("30sWD", function(module, exports) {
$parcel$export(module.exports, "customerServiceEscalationsRouteEntry", () => $4ed5eb9846273321$export$36a7c374f4474cc1);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $2OMlg = parcelRequire("2OMlg");

var $hTm2Q = parcelRequire("hTm2Q");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7m5cr = parcelRequire("7m5cr");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4ed5eb9846273321$var$LazyServicedeskCustomerServiceEscalations = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dU055"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-customer-service-escalations/src/ServicedeskCustomerServiceEscalations.tsx"
});
const $4ed5eb9846273321$var$ServicedeskCustomerServiceEscalations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4ed5eb9846273321$var$LazyServicedeskCustomerServiceEscalations,
        pageId: "spa-apps/servicedesk/customer-service-escalations",
        shouldShowSpinner: true
    });
$4ed5eb9846273321$var$ServicedeskCustomerServiceEscalations.displayName = "ServicedeskCustomerServiceEscalations";
const $4ed5eb9846273321$export$36a7c374f4474cc1 = (0, $fdS54.createEntry)((0, $7m5cr.customerServiceEscalationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $2OMlg.componentFilterResource),
            (0, $hTm2Q.priorityFilterResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $4ed5eb9846273321$var$ServicedeskCustomerServiceEscalations,
        perfMetricKey: 'jsm-customer-service-escalations-component-load',
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $4ed5eb9846273321$var$LazyServicedeskCustomerServiceEscalations
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                teamName: 'boysenberry'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2OMlg", function(module, exports) {
$parcel$export(module.exports, "componentFilterResource", () => $cedbe0470b27b3fb$export$306e389909032632);
$parcel$export(module.exports, "useComponentFilterResource", () => $cedbe0470b27b3fb$export$e13868d6ab2288af);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fLTsc = parcelRequire("fLTsc");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $cedbe0470b27b3fb$export$306e389909032632 = (0, $7edbf.createResource)({
    type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("aAish"))
});
const $cedbe0470b27b3fb$export$e13868d6ab2288af = ()=>(0, $k6ufm.useResource)($cedbe0470b27b3fb$export$306e389909032632);

});
parcelRegister("aAish", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h6gzv").then(()=>parcelRequire('f1EYI'));

});


parcelRegister("hTm2Q", function(module, exports) {
$parcel$export(module.exports, "priorityFilterResource", () => $446172995a345538$export$ca03c5f9fc44703e);
$parcel$export(module.exports, "usePriorityFilterResource", () => $446172995a345538$export$3654f46b6bb12558);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fLTsc = parcelRequire("fLTsc");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $446172995a345538$export$ca03c5f9fc44703e = (0, $7edbf.createResource)({
    type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("1D7mG"))
});
const $446172995a345538$export$3654f46b6bb12558 = ()=>(0, $k6ufm.useResource)($446172995a345538$export$ca03c5f9fc44703e);

});
parcelRegister("1D7mG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3hwjy").then(()=>parcelRequire('aL9Uc'));

});


parcelRegister("7m5cr", function(module, exports) {
$parcel$export(module.exports, "customerServiceEscalationsRoute", () => $5d9d7250563e58e9$export$51e84b36f828d9ff);
const $5d9d7250563e58e9$export$51e84b36f828d9ff = {
    name: 'servicedesk-customer-service-escalations',
    path: '/jira/servicedesk/projects/:projectKey/escalations',
    exact: true
};

});

parcelRegister("dU055", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gogw7")
]).then(()=>parcelRequire('iZEi0'));

});


parcelRegister("d7pXC", function(module, exports) {
$parcel$export(module.exports, "customerServiceGetStartedRouteEntry", () => $e2bf818cc0cdb573$export$bf3ebc0c2cf4cbf4);


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $74h93 = parcelRequire("74h93");

var $V1kos = parcelRequire("V1kos");

var $xmwl9 = parcelRequire("xmwl9");

var $1IAdV = parcelRequire("1IAdV");
const $e2bf818cc0cdb573$export$bf3ebc0c2cf4cbf4 = (0, $fdS54.createEntry)((0, $V1kos.customerServiceGetStartedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'customer-service-get-started-page-load',
        skeleton: (0, $xmwl9.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return 0, $1IAdV.customerServiceGetStartedPageEntryPoint;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("V1kos", function(module, exports) {
$parcel$export(module.exports, "customerServiceGetStartedRoute", () => $a3cca72c8961d8fe$export$a29b57a3840da142);
const $a3cca72c8961d8fe$export$a29b57a3840da142 = {
    name: 'customer-service-get-started',
    path: '/jira/servicedesk/projects/:projectKey/get-started',
    exact: true
};

});


parcelRegister("dYo5g", function(module, exports) {
$parcel$export(module.exports, "customerServiceLiveConversationsRouteEntry", () => $389f8fc1f3ce8a22$export$a1b2f13e035fad9d);

var $fucnc = parcelRequire("fucnc");

var $5XqaQ = parcelRequire("5XqaQ");

var $iSoIx = parcelRequire("iSoIx");

var $8rfXq = parcelRequire("8rfXq");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");

var $edf7u = parcelRequire("edf7u");

var $iyqMX = parcelRequire("iyqMX");

var $lEPfS = parcelRequire("lEPfS");
const $389f8fc1f3ce8a22$var$customerServiceLiveConversationsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fucnc.customerServiceLiveConversationsEntryPoint)
});
const $389f8fc1f3ce8a22$export$a1b2f13e035fad9d = (0, $fdS54.createEntry)((0, $5XqaQ.customerServiceLiveConversationsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.live-conversations',
        layout: (0, $h2tgz.globalLayout),
        entryPoint () {
            return (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget') ? $389f8fc1f3ce8a22$var$customerServiceLiveConversationsPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $iyqMX.serviceDeskContextResource),
            (0, $lEPfS.featuresResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8rfXq.omniSubAccountStatus)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5XqaQ", function(module, exports) {
$parcel$export(module.exports, "customerServiceLiveConversationsRoute", () => $6984bb055021683b$export$17c91bc5562676a4);
const $6984bb055021683b$export$17c91bc5562676a4 = {
    name: 'customer-service-live-conversations',
    path: '/jira/servicedesk/projects/:projectKey/conversations/:issueKey?',
    exact: true
};

});


parcelRegister("cnYCZ", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationDetailsRouteEntry", () => $d6d6e4dfc8ef9ead$export$90042424f0ac9f60);
/* eslint-disable import/order */ 
var $2clbx = parcelRequire("2clbx");

var $6RvOI = parcelRequire("6RvOI");

var $gAOlK = parcelRequire("gAOlK");

var $5hiaJ = parcelRequire("5hiaJ");

var $lFLfF = parcelRequire("lFLfF");

var $a1mNZ = parcelRequire("a1mNZ");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");

var $jVrUf = parcelRequire("jVrUf");

var $Q5OI6 = parcelRequire("Q5OI6");
const $d6d6e4dfc8ef9ead$var$customerServiceOrganizationDetailsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2clbx.customerServiceOrganizationDetailsEntryPoint)
});
const $d6d6e4dfc8ef9ead$export$90042424f0ac9f60 = (0, $fdS54.createEntry)((0, $a1mNZ.customerServiceOrganizationDetailsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.organization-details',
        layout: (0, $h2tgz.globalLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return (0, $i860n.fg)('berry-6285-customers-l1') ? $d6d6e4dfc8ef9ead$var$customerServiceOrganizationDetailsPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $5hiaJ.OrganizationDetailsPageQueryResource),
            (0, $gAOlK.EntitlementsEntitlementsQueryResource),
            (0, $Q5OI6.productsJsmOrganizationDetailsResource),
            (0, $jVrUf.jsmEmailDomainsListResource),
            (0, $6RvOI.l1CustomersProjectProviderResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("a1mNZ", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationDetailsRoute", () => $cefb19b9f073101e$export$b10e04667ad3ac02);
const $cefb19b9f073101e$export$b10e04667ad3ac02 = {
    name: 'customer-service-organization-details',
    path: '/jira/customer-service/organizations/:organizationId',
    exact: true
};

});


parcelRegister("0r9on", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationsRouteEntry", () => $29549af45869788a$export$9d68d24d39463f80);
/* eslint-disable import/order */ 
var $fzxz4 = parcelRequire("fzxz4");

var $lFUuS = parcelRequire("lFUuS");

var $6RvOI = parcelRequire("6RvOI");

var $aS3GY = parcelRequire("aS3GY");

var $7FU4x = parcelRequire("7FU4x");

var $lFLfF = parcelRequire("lFLfF");

var $djGFH = parcelRequire("djGFH");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");
const $29549af45869788a$var$customerServiceOrganizationsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fzxz4.customerServiceOrganizationsEntryPoint)
});
const $29549af45869788a$export$9d68d24d39463f80 = (0, $fdS54.createEntry)((0, $djGFH.customerServiceOrganizationsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.organizations',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            horizontal: (0, $lFUuS.AsyncCustomersNav)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return (0, $i860n.fg)('berry-6285-customers-l1') ? $29549af45869788a$var$customerServiceOrganizationsPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RvOI.l1CustomersProjectProviderResource),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource),
            (0, $7FU4x.customerServiceManagementCrmImportModuleResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("djGFH", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationsRoute", () => $c269b7ce7f848c49$export$8b935f85541f706d);
const $c269b7ce7f848c49$export$8b935f85541f706d = {
    name: 'customer-service-organizations',
    path: '/jira/customer-service/organizations',
    exact: true
};

});


parcelRegister("4wYea", function(module, exports) {
$parcel$export(module.exports, "customerServiceProductsRouteEntry", () => $d2ed61eff0065d8b$export$8e015e39dbc90d0b);
/* eslint-disable import/order */ 
var $3R0xP = parcelRequire("3R0xP");

var $7FU4x = parcelRequire("7FU4x");

var $lFUuS = parcelRequire("lFUuS");

var $6RvOI = parcelRequire("6RvOI");

var $aS3GY = parcelRequire("aS3GY");

var $lFLfF = parcelRequire("lFLfF");

var $emgSd = parcelRequire("emgSd");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");
const $d2ed61eff0065d8b$var$customerServiceProductsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $3R0xP.customerServiceProductsEntryPoint)
});
const $d2ed61eff0065d8b$export$8e015e39dbc90d0b = (0, $fdS54.createEntry)((0, $emgSd.customerServiceProductsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.products',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            horizontal: (0, $lFUuS.AsyncCustomersNav)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return (0, $i860n.fg)('berry-6285-customers-l1') ? $d2ed61eff0065d8b$var$customerServiceProductsPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RvOI.l1CustomersProjectProviderResource),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource),
            (0, $7FU4x.customerServiceManagementCrmImportModuleResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("emgSd", function(module, exports) {
$parcel$export(module.exports, "customerServiceProductsRoute", () => $f978a877dd46dbce$export$73e241aabf4c9c58);
const $f978a877dd46dbce$export$73e241aabf4c9c58 = {
    name: 'customer-service-products',
    path: '/jira/customer-service/products',
    exact: true
};

});


parcelRegister("71iCS", function(module, exports) {
$parcel$export(module.exports, "customerServiceProjectSettingsRedirectRouteEntry", () => $2817ee164db8fff9$export$f9b37c2e284cd0fa);

var $iSoIx = parcelRequire("iSoIx");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");



var $lgbZq = parcelRequire("lgbZq");

var $ahpBQ = parcelRequire("ahpBQ");

var $74h93 = parcelRequire("74h93");
const $2817ee164db8fff9$var$customerServiceProjectSettingsRedirectPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ahpBQ.customerServiceProjectSettingsRedirectEntrypoint)
});
const $2817ee164db8fff9$export$f9b37c2e284cd0fa = (0, $fdS54.createEntry)((0, $lgbZq.customerServiceProjectSettingsRedirectRoute), ()=>({
        group: 'project-settings-customer-service',
        perfMetricKey: 'customer-service.project-settings',
        layout: (0, $74h93.serviceProjectLayout),
        isRedirect: true,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint: ()=>(0, $i860n.fg)('csm_appification_standalone_navigation') ? $2817ee164db8fff9$var$customerServiceProjectSettingsRedirectPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $edf7u.projectContextResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lgbZq", function(module, exports) {
$parcel$export(module.exports, "customerServiceProjectSettingsRedirectRoute", () => $7a97231d44e6d626$export$c7c1a6f95117cc1c);
const $7a97231d44e6d626$export$c7c1a6f95117cc1c = {
    name: 'customer-service-project-settings',
    path: '/jira/customer-service-management/projects/:projectKey/settings',
    exact: true
};

});

parcelRegister("ahpBQ", function(module, exports) {
$parcel$export(module.exports, "customerServiceProjectSettingsRedirectEntrypoint", () => $9bec1b495ab4f36f$export$4e00e3ec1d13fbe3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $9bec1b495ab4f36f$export$4e00e3ec1d13fbe3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("glnSf")), {
        moduleId: "1555aea6",
        moduleName: "CustomerServiceProjectSettingsRedirect",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({
            queries: {},
            extraProps: {}
        })
});

});
parcelRegister("glnSf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7GNoh").then(()=>parcelRequire('hL8uX'));

});



parcelRegister("3TNYf", function(module, exports) {
$parcel$export(module.exports, "customIssueRouteEntry", () => $3f95218d02d046c3$export$3813414450b75758);

var $51vnM = parcelRequire("51vnM");


var $3nu59 = parcelRequire("3nu59");

var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $cpnl1 = parcelRequire("cpnl1");

var $ble5H = parcelRequire("ble5H");

var $4jfH2 = parcelRequire("4jfH2");

var $74h93 = parcelRequire("74h93");

var $9KYmb = parcelRequire("9KYmb");

var $U9h5y = parcelRequire("U9h5y");

var $aQw4A = parcelRequire("aQw4A");

var $9KM2b = parcelRequire("9KM2b");
const $3f95218d02d046c3$export$3813414450b75758 = (0, $fdS54.createEntry)((0, $4jfH2.customIssueRoute), ()=>({
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            // Keep this consistent with the one in customQueueRouteEntry.tsx, so it won't rerender the queue agent view component
            // when navigating between queues and issues.
            // Rereder could cause problem:
            // 1. Issue view will lose issue navigator component
            // 2. When navigating back to queue, the queue will lose the scroll position.
            horizontal: (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $3nu59.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9KM2b.QueueLoadingSkeleton) : undefined,
        resources: [
            (0, $cpnl1.issueListSsrResource),
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            ...(0, $lbxXL.getTriageButtonPermissionResource)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $ble5H.servicedeskIsItsmProjectResource),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            ...(0, $9KYmb.getDraftReplyPillsResource)(),
            (0, $U9h5y.getJsmIssueViewRelatedArticlesRouteResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aQw4A.CustomQueueRouteComponent),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aQw4A.LazyServicedeskQueuesAgentAndIssueView)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3nu59", function(module, exports) {
$parcel$export(module.exports, "AsyncHorizontalNavQueue", () => $19c6920dc7d5087a$export$5f20c7610c638983);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $6yDzo = parcelRequire("6yDzo");

var $3tN3R = parcelRequire("3tN3R");

var $4jfH2 = parcelRequire("4jfH2");

var $4Onaa = parcelRequire("4Onaa");

var $cZjb4 = parcelRequire("cZjb4");

var $5L5aA = parcelRequire("5L5aA");
const $19c6920dc7d5087a$export$5f20c7610c638983 = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const [issueKey] = (0, $cZjb4.usePathParam)('issueKey');
    const isIssueView = route.name === (0, $4jfH2.customIssueRoute).name || route.name === (0, $3tN3R.customPracticeQueueRoute).name && issueKey;
    const content = !isIssueView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-nav-queue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6yDzo.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5L5aA.LazyHorizontalNavQueueForPaint), null));
    return content;
};
$19c6920dc7d5087a$export$5f20c7610c638983.displayName = "AsyncHorizontalNavQueue";

});
parcelRegister("3tN3R", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueRoute", () => $9bfd8b2616075742$export$59d0bd42aa07faad);
const $9bfd8b2616075742$export$59d0bd42aa07faad = {
    name: 'servicedesk-practice-custom-and-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    exact: true
};

});

parcelRegister("4jfH2", function(module, exports) {
$parcel$export(module.exports, "customIssueRoute", () => $b64df2df2f430a34$export$2c4bc3091ab58cd0);
const $b64df2df2f430a34$export$2c4bc3091ab58cd0 = {
    name: 'servicedesk-queues-custom-issue-detail',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
    exact: true
};

});

parcelRegister("5L5aA", function(module, exports) {
$parcel$export(module.exports, "LazyHorizontalNavQueue", () => $285e67a77481dfd1$export$d5abd8e11ee6080b);
$parcel$export(module.exports, "LazyHorizontalNavQueueForPaint", () => $285e67a77481dfd1$export$59f4434e7363871a);
/* eslint-disable jira/filename-case */ 
var $l8G1z = parcelRequire("l8G1z");

const $285e67a77481dfd1$export$d5abd8e11ee6080b = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("cxhh0")).then((HorizontalNavQueue)=>HorizontalNavQueue), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-queue/src/ui/HorizontalNavQueue.tsx"
});

const $285e67a77481dfd1$export$59f4434e7363871a = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("cxhh0")).then((HorizontalNavQueue)=>HorizontalNavQueue), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-queue/src/ui/HorizontalNavQueue.tsx"
});

});
parcelRegister("cxhh0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("lJvIl")
]).then(()=>parcelRequire('8mful'));

});



parcelRegister("aQw4A", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesAgentAndIssueView", () => $57d76b73491b451e$export$6f01bfb6fc18a06e);
$parcel$export(module.exports, "CustomQueueRouteComponent", () => $57d76b73491b451e$export$59d555419fbaa611);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $i860n = parcelRequire("i860n");

var $jhKsF = parcelRequire("jhKsF");

const $57d76b73491b451e$export$6f01bfb6fc18a06e = (0, $l8G1z.lazyForPaint)(()=>{
    return (0, $jhKsF.markAsProductBundleReady)((parcelRequire("kJiOz")));
}, {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-agent-and-issue-view/src/SpaApp.tsx"
});
const $57d76b73491b451e$var$emptyEntryPointProps = {
    entryPoints: {},
    extraProps: {},
    props: {},
    queries: {}
};
const $57d76b73491b451e$var$LazyServicedeskQueuesAgentAndIssueViewWithSsrError = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($57d76b73491b451e$export$6f01bfb6fc18a06e, $57d76b73491b451e$var$emptyEntryPointProps);
};
$57d76b73491b451e$var$LazyServicedeskQueuesAgentAndIssueViewWithSsrError.displayName = "LazyServicedeskQueuesAgentAndIssueViewWithSsrError";
const $57d76b73491b451e$export$59d555419fbaa611 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    const issueKey = match.params && match.params.issueKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $57d76b73491b451e$var$LazyServicedeskQueuesAgentAndIssueViewWithSsrError,
        pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}`,
        shouldShowSpinner: !(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag')
    });
};
$57d76b73491b451e$export$59d555419fbaa611.displayName = "CustomQueueRouteComponent";

});


parcelRegister("iuPZI", function(module, exports) {
$parcel$export(module.exports, "customJourneyTypeRouteEntry", () => $483dced409de92c9$export$e14a0bef96059ef6);
/* eslint-disable import/order */ 

var $4IgZe = parcelRequire("4IgZe");

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $d0o7a = parcelRequire("d0o7a");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $dTa0V = parcelRequire("dTa0V");
const $483dced409de92c9$var$customJourneyTypePageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4IgZe.customJourneyTypeEntryPoint)
});
const $483dced409de92c9$export$e14a0bef96059ef6 = (0, $fdS54.createEntry)((0, $d0o7a.customJourneyTypeRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.journey-type',
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>null,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$483dced409de92c9$var$customJourneyTypePageEntryPoint,
        meta: {
            reporting: {
                id: 'journey-type',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).JOURNEYS),
                teamName: 'JSM Grape Soju'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4IgZe", function(module, exports) {
$parcel$export(module.exports, "customJourneyTypeEntryPoint", () => $7d6624f36c000a5e$export$bbe72a1ecc254919);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $eiwjA = parcelRequire("eiwjA");

const $7d6624f36c000a5e$export$bbe72a1ecc254919 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("5xSwL")), {
        moduleId: "59ebed5c",
        moduleName: "CustomJourneyTypePage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                jiraJourneyConfiguration: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $eiwjA.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        journeyTypeId: context.match.params.journeyTypeId ?? '',
                        cloudIdAsString: tenantContext.cloudId
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("eiwjA", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e4384edf2bd5cdc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30e0a2a9c8d1afc3c8b23586be23cad0>>
 * @relayHash 06b9fb035af57083d93e14e4ef85a0dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4c7ec1badb095312c7161498c73527249e67a092e06ecbe4b411d6573f4b420

var $eMgaM = parcelRequire("eMgaM");
const $6e4384edf2bd5cdc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d4c7ec1badb095312c7161498c73527249e67a092e06ecbe4b411d6573f4b420",
        "metadata": {},
        "name": "CustomJourneyTypePageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmrovoservicehragentrelayprovider": (0, $eMgaM.default)
        }
    }
};
var $6e4384edf2bd5cdc$export$2e2bcd8739ae039 = $6e4384edf2bd5cdc$var$node;

});
parcelRegister("eMgaM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea26b94251b474c6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $ea26b94251b474c6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('enable-jsm-rovo-service-hr-agent');
    }
};

});


parcelRegister("5xSwL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kAAhb").then(()=>parcelRequire('b2uWK'));

});


parcelRegister("d0o7a", function(module, exports) {
$parcel$export(module.exports, "customJourneyTypeRoute", () => $6be00341dbf7539b$export$36b93b122be539e2);
const $6be00341dbf7539b$export$36b93b122be539e2 = {
    path: '/jira/servicedesk/projects/:projectKey/journeys/pending/:journeyTypeId',
    name: 'journey-type',
    exact: true
};

});


parcelRegister("3GLXX", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueBoardRouteEntry", () => $700ef4f8afb22ed5$export$7b0b0691f8b766cf);
/* eslint-disable import/order */ 

var $5L5aA = parcelRequire("5L5aA");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $5adCU = parcelRequire("5adCU");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");

var $bb2rV = parcelRequire("bb2rV");

var $74h93 = parcelRequire("74h93");

var $562LK = parcelRequire("562LK");
const $700ef4f8afb22ed5$export$7b0b0691f8b766cf = (0, $fdS54.createEntry)((0, $bb2rV.customPracticeQueueBoardRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jsm_views_inside_queues_-_main_flag')) return 0, $562LK.boardPageEntryPoint;
            return undefined;
        },
        layout: (0, $74h93.serviceProjectLayout),
        skeleton: (0, $562LK.BoardSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!false, (0, $2DCyG.uifBoardResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5L5aA.LazyHorizontalNavQueue)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bb2rV", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueBoardRoute", () => $adacf990ca84c741$export$47ae519519dbd803);
const $adacf990ca84c741$export$47ae519519dbd803 = {
    name: 'servicedesk-queues-practice-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("562LK", function(module, exports) {
$parcel$export(module.exports, "boardPageEntryPoint", () => $f3e03c07227c2b2c$export$552f44bed039f041);
$parcel$export(module.exports, "BoardSkeleton", () => $f3e03c07227c2b2c$export$325f821722dfa572);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6dc16 = parcelRequire("6dc16");

var $i1diT = parcelRequire("i1diT");

var $dTa0V = parcelRequire("dTa0V");

var $2bC10 = parcelRequire("2bC10");
const $f3e03c07227c2b2c$export$552f44bed039f041 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $i1diT.boardEntryPoint),
    horizontalNavigation: (0, $6dc16.horizontalNavQueueEntrypoint)
});
const $f3e03c07227c2b2c$export$325f821722dfa572 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2bC10.ClassicBoardSkeleton), null);
$f3e03c07227c2b2c$export$325f821722dfa572.displayName = "BoardSkeleton";

});
parcelRegister("i1diT", function(module, exports) {
$parcel$export(module.exports, "boardEntryPoint", () => $3c36ebc899fa4bb4$export$937ca5a4cdc1a12e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $3c36ebc899fa4bb4$export$937ca5a4cdc1a12e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gLOJk")), {
        moduleId: "06240e2b",
        moduleName: "ServicedeskBoard",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gLOJk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("2wbis")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("d9ELB")
]).then(()=>parcelRequire('l7pk2'));

});




parcelRegister("jxFtK", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueCalendarRouteEntry", () => $140c1fe314b26351$export$8e8d88d3af02e6f7);
/* eslint-disable import/order */ 

var $5L5aA = parcelRequire("5L5aA");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $8ynoL = parcelRequire("8ynoL");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $2DCyG = parcelRequire("2DCyG");

var $cDLVA = parcelRequire("cDLVA");

var $i860n = parcelRequire("i860n");

var $8HUuJ = parcelRequire("8HUuJ");

var $dc8RQ = parcelRequire("dc8RQ");
const $140c1fe314b26351$export$8e8d88d3af02e6f7 = (0, $fdS54.createEntry)((0, $8ynoL.customPracticeQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5L5aA.LazyHorizontalNavQueue)
        ],
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jsm_views_inside_queues_-_main_flag')) return 0, $dc8RQ.calendarPageEntryPoint;
            return undefined;
        },
        skeleton: (0, $dc8RQ.CalendarSkeleton),
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $cDLVA.getCalendarFilterFieldsResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!false, (0, $2DCyG.uifBoardResource))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8ynoL", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueCalendarRoute", () => $46fa04202bb39dce$export$5a0e47b0abcf7c2f);
const $46fa04202bb39dce$export$5a0e47b0abcf7c2f = {
    name: 'servicedesk-queues-practice-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/calendar/:boardId',
    exact: true
};

});

parcelRegister("dc8RQ", function(module, exports) {
$parcel$export(module.exports, "calendarPageEntryPoint", () => $484b30716d51629b$export$eda0c2fb67f7d7e7);
$parcel$export(module.exports, "CalendarSkeleton", () => $484b30716d51629b$export$ebc7c47cc535837e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6dc16 = parcelRequire("6dc16");

var $ard19 = parcelRequire("ard19");

var $dTa0V = parcelRequire("dTa0V");

var $j69FH = parcelRequire("j69FH");
const $484b30716d51629b$export$eda0c2fb67f7d7e7 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ard19.calendarEntryPoint),
    horizontalNavigation: (0, $6dc16.horizontalNavQueueEntrypoint)
});
const $484b30716d51629b$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j69FH.ClassicCalendarSkeleton), null);
$484b30716d51629b$export$ebc7c47cc535837e.displayName = "CalendarSkeleton";

});
parcelRegister("ard19", function(module, exports) {
$parcel$export(module.exports, "calendarEntryPoint", () => $b91fdfc1bc2621ef$export$19cf4b398f638dc6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6ySM3 = parcelRequire("6ySM3");
// This is the key used to store the calendar filters in the local storage
const $b91fdfc1bc2621ef$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
// This is the key used to store the calendar view settings in the local storage
const $b91fdfc1bc2621ef$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
/**
 * Default Day Starts At Time in Calendar View Settings
 */ const $b91fdfc1bc2621ef$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
function $b91fdfc1bc2621ef$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $b91fdfc1bc2621ef$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $b91fdfc1bc2621ef$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $b91fdfc1bc2621ef$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $b91fdfc1bc2621ef$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: [],
        viewId: viewId
    };
}
function $b91fdfc1bc2621ef$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $b91fdfc1bc2621ef$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $b91fdfc1bc2621ef$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $b91fdfc1bc2621ef$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $b91fdfc1bc2621ef$var$toMidnightUTCString(selectedDate),
        mode: $b91fdfc1bc2621ef$var$toViewMode(viewRange),
        weekStart: $b91fdfc1bc2621ef$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: viewId
    };
}
function $b91fdfc1bc2621ef$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
    const viewId = $b91fdfc1bc2621ef$var$buildViewId({
        cloudId: cloudId,
        activationId: activationId,
        boardId: boardId
    });
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
}
function $b91fdfc1bc2621ef$var$getStorageValue(storageKey) {
    // window check is needed because this code is also executed on the SSR
    if (typeof window !== 'undefined') // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return localStorage?.getItem(storageKey) || '';
    return '';
}
function $b91fdfc1bc2621ef$var$buildIssuesSearchInput(storageKey) {
    return {
        additionalFilterQuery: $b91fdfc1bc2621ef$var$getStorageValue(storageKey) || ''
    };
}
function $b91fdfc1bc2621ef$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $b91fdfc1bc2621ef$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $b91fdfc1bc2621ef$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $b91fdfc1bc2621ef$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
    // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aview
    return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
}

const $b91fdfc1bc2621ef$export$19cf4b398f638dc6 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2b5BE")), {
        moduleId: "3b1df807",
        moduleName: "useCalendarFilters",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const { date: date } = context.query;
        const selectedDate = $b91fdfc1bc2621ef$var$toDate(date);
        const { boardId: boardId, projectKey: projectKey } = context.match.params;
        if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
        const viewId = $b91fdfc1bc2621ef$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const scope = $b91fdfc1bc2621ef$var$createScope(entryPointRouteParams, viewId || '');
        const storageKeyForIssueSearchInput = $b91fdfc1bc2621ef$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $b91fdfc1bc2621ef$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
        });
        const storageKeyForViewSettings = $b91fdfc1bc2621ef$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $b91fdfc1bc2621ef$var$VIEW_SETTINGS_STORAGE_KEY
        });
        const defaultViewRange = 'month';
        const storedConfig = $b91fdfc1bc2621ef$var$getStorageValue(storageKeyForViewSettings);
        const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
            viewRange: defaultViewRange,
            weekStartsOn: null,
            dayStartsAt: $b91fdfc1bc2621ef$var$DEFAULT_DAY_STARTS_AT,
            showWeekends: false,
            showIssueKey: true,
            showIn24HourClock: false,
            colorBy: 'status'
        };
        const viewRange = viewSettingsConfig.viewRange ?? 'month';
        const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const colorBy = viewSettingsConfig.colorBy ?? 'status';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const issuesSearchInput = $b91fdfc1bc2621ef$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $6ySM3.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $b91fdfc1bc2621ef$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $b91fdfc1bc2621ef$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $b91fdfc1bc2621ef$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $b91fdfc1bc2621ef$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $b91fdfc1bc2621ef$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        viewId: viewId,
                        skipFieldConfig: false,
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: false,
                        skipUserPreferences: false,
                        filterScope: null,
                        isCalendarFilterRefinementEnabled: false
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                dayStartsAt: viewSettingsConfig.dayStartsAt,
                issueEventFields: issueEventFields,
                projectKey: projectKey,
                storageKeyForViewSettings: storageKeyForViewSettings,
                storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                showWeekends: viewSettingsConfig.showWeekends,
                showIssueKey: viewSettingsConfig.showIssueKey,
                showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                colorBy: colorBy
            }
        };
    }
});

});
parcelRegister("2b5BE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jLpeX")
]).then(()=>parcelRequire('ffQb3'));

});


parcelRegister("j69FH", function(module, exports) {
$parcel$export(module.exports, "ClassicCalendarSkeleton", () => $57b2201ef6b0867e$export$49d3670908a8d8fe);

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $6GmuP = parcelRequire("6GmuP");
const $57b2201ef6b0867e$export$49d3670908a8d8fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6GmuP)))
    });
$57b2201ef6b0867e$export$49d3670908a8d8fe.displayName = "ClassicCalendarSkeleton";

});
parcelRegister("6GmuP", function(module, exports) {
module.exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();

});




parcelRegister("40MXz", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueRouteEntry", () => $f0e31e9d745a5941$export$b43128c9b5db2a5e);

var $51vnM = parcelRequire("51vnM");


var $5L5aA = parcelRequire("5L5aA");

var $3nu59 = parcelRequire("3nu59");

var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $c8hth = parcelRequire("c8hth");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $cpnl1 = parcelRequire("cpnl1");

var $f9tnr = parcelRequire("f9tnr");

var $b6NJA = parcelRequire("b6NJA");

var $8HUuJ = parcelRequire("8HUuJ");

var $3tN3R = parcelRequire("3tN3R");

var $74h93 = parcelRequire("74h93");

var $9KYmb = parcelRequire("9KYmb");

var $cptf3 = parcelRequire("cptf3");

var $aQw4A = parcelRequire("aQw4A");

var $9KM2b = parcelRequire("9KM2b");
const $f0e31e9d745a5941$export$b43128c9b5db2a5e = (0, $fdS54.createEntry)((0, $3tN3R.customPracticeQueueRoute), ()=>({
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aQw4A.CustomQueueRouteComponent),
        isHydrateRootEnabled: false,
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        skeleton: (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9KM2b.QueueLoadingSkeleton) : undefined,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $3nu59.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            (0, $cpnl1.issueListSsrResource),
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getKnowledgeBaseResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            ...(0, $lbxXL.getTriageButtonPermissionResource)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            ...(0, $9KYmb.getDraftReplyPillsResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $c8hth.horizontalNavQueueResource)),
            ...(0, $lbxXL.getIssueViewResources)(),
            (0, $f9tnr.queuesJqlBuilderHydrationQueryRelayResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $2700E.expVal)('corcap-6777-ai-jqlbuilder-in-queues', 'isEnabled', false), (0, $b6NJA.queuesJqlBuilderAiQueryRelayResource))
        ],
        afterPaint: (0, $i860n.fg)('jsm_remove_queue_bulk_action_bar_from_preloading') ? [
            (0, $51vnM.LazyIssueApp)
        ] : [
            (0, $51vnM.LazyIssueApp),
            (0, $cptf3.AsyncBulkActionToolbarLazy)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aQw4A.LazyServicedeskQueuesAgentAndIssueView),
            (0, $5L5aA.LazyHorizontalNavQueueForPaint)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'jira-service-management',
            manifestName: 'jira-spa-jira-service-management.json',
            fetchTimeout: 1500
        }
    }));

});

parcelRegister("3FsXl", function(module, exports) {
$parcel$export(module.exports, "customQueueBoardRouteEntry", () => $90f348d5fea2334f$export$f94102e9d0a3b113);
/* eslint-disable import/order */ 

var $5L5aA = parcelRequire("5L5aA");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $5adCU = parcelRequire("5adCU");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ic2KG = parcelRequire("ic2KG");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");

var $562LK = parcelRequire("562LK");
const $90f348d5fea2334f$export$f94102e9d0a3b113 = (0, $fdS54.createEntry)((0, $ic2KG.customQueueBoardRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jsm_views_inside_queues_-_main_flag')) return 0, $562LK.boardPageEntryPoint;
            return undefined;
        },
        skeleton: (0, $562LK.BoardSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        afterPaint: [
            (0, $5L5aA.LazyHorizontalNavQueue)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!false, (0, $2DCyG.uifBoardResource))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ic2KG", function(module, exports) {
$parcel$export(module.exports, "customQueueBoardRoute", () => $9619c6a7c45592e1$export$5407961894c40126);
const $9619c6a7c45592e1$export$5407961894c40126 = {
    name: 'servicedesk-queues-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/board/:boardId',
    exact: true
};

});


parcelRegister("iLYrw", function(module, exports) {
$parcel$export(module.exports, "customQueueCalendarRouteEntry", () => $b1c869cbd74795b7$export$a6aaa9129c24f852);
/* eslint-disable import/order */ 

var $5L5aA = parcelRequire("5L5aA");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $4rr7K = parcelRequire("4rr7K");

var $74h93 = parcelRequire("74h93");

var $2DCyG = parcelRequire("2DCyG");

var $cDLVA = parcelRequire("cDLVA");

var $i860n = parcelRequire("i860n");

var $8HUuJ = parcelRequire("8HUuJ");

var $dc8RQ = parcelRequire("dc8RQ");
const $b1c869cbd74795b7$export$a6aaa9129c24f852 = (0, $fdS54.createEntry)((0, $4rr7K.customQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jsm_views_inside_queues_-_main_flag')) return 0, $dc8RQ.calendarPageEntryPoint;
            return undefined;
        },
        afterPaint: [
            (0, $5L5aA.LazyHorizontalNavQueue)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        skeleton: (0, $dc8RQ.CalendarSkeleton),
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $cDLVA.getCalendarFilterFieldsResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!false, (0, $2DCyG.uifBoardResource))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4rr7K", function(module, exports) {
$parcel$export(module.exports, "customQueueCalendarRoute", () => $2d91153175a18a94$export$82a97d9fba2cfa9a);
const $2d91153175a18a94$export$82a97d9fba2cfa9a = {
    name: 'servicedesk-queues-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/calendar/:boardId',
    exact: true
};

});


parcelRegister("iz2Yc", function(module, exports) {
$parcel$export(module.exports, "customQueueRouteEntry", () => $3b4676fca10ba9d0$export$54a295e04e6cea33);

var $51vnM = parcelRequire("51vnM");


var $5L5aA = parcelRequire("5L5aA");

var $3nu59 = parcelRequire("3nu59");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $c8hth = parcelRequire("c8hth");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $cpnl1 = parcelRequire("cpnl1");

var $f9tnr = parcelRequire("f9tnr");

var $b6NJA = parcelRequire("b6NJA");

var $ble5H = parcelRequire("ble5H");

var $U9h5y = parcelRequire("U9h5y");

var $8HUuJ = parcelRequire("8HUuJ");

var $3tezj = parcelRequire("3tezj");

var $74h93 = parcelRequire("74h93");

var $cptf3 = parcelRequire("cptf3");

var $aQw4A = parcelRequire("aQw4A");

var $9KM2b = parcelRequire("9KM2b");
const $3b4676fca10ba9d0$export$54a295e04e6cea33 = (0, $fdS54.createEntry)((0, $3tezj.customQueueRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        preloadOptions: {
            earlyChunks: (0, $i860n.fg)('queues-earlyscripts') ? [
                'queues-prefetch-early-entry'
            ] : []
        },
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $3nu59.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9KM2b.QueueLoadingSkeleton) : undefined,
        resources: [
            (0, $cpnl1.issueListSsrResource),
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            ...(0, $lbxXL.getTriageButtonPermissionResource)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $ble5H.servicedeskIsItsmProjectResource),
            (0, $U9h5y.getJsmIssueViewRelatedArticlesRouteResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $c8hth.horizontalNavQueueResource)),
            (0, $f9tnr.queuesJqlBuilderHydrationQueryRelayResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $2700E.expVal)('corcap-6777-ai-jqlbuilder-in-queues', 'isEnabled', false), (0, $b6NJA.queuesJqlBuilderAiQueryRelayResource))
        ],
        afterPaint: (0, $i860n.fg)('jsm_remove_queue_bulk_action_bar_from_preloading') ? [
            (0, $51vnM.LazyIssueApp)
        ] : [
            (0, $51vnM.LazyIssueApp),
            (0, $cptf3.AsyncBulkActionToolbarLazy)
        ],
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aQw4A.CustomQueueRouteComponent),
        isHydrateRootEnabled: false,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aQw4A.LazyServicedeskQueuesAgentAndIssueView),
            (0, $5L5aA.LazyHorizontalNavQueueForPaint)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'jira-service-management',
            manifestName: 'jira-spa-jira-service-management.json',
            fetchTimeout: 1500
        }
    }));

});
parcelRegister("3tezj", function(module, exports) {
$parcel$export(module.exports, "customQueueRoute", () => $24a53bbe06004a75$export$e1fac82ca0b0d637);
const $24a53bbe06004a75$export$e1fac82ca0b0d637 = {
    name: 'servicedesk-queues-custom-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
    exact: true
};

});


parcelRegister("eKz3o", function(module, exports) {
$parcel$export(module.exports, "dashboardEditRouteEntry", () => $0586763af38eb407$export$9b0fdfd6a51a17de);
/* eslint-disable import/order */ 


var $dv1xk = parcelRequire("dv1xk");

var $3TTqW = parcelRequire("3TTqW");


var $3HYSN = parcelRequire("3HYSN");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $iXPKM = parcelRequire("iXPKM");

var $h3uMu = parcelRequire("h3uMu");

var $bd0Ph = parcelRequire("bd0Ph");

var $dTa0V = parcelRequire("dTa0V");

var $iHNG5 = parcelRequire("iHNG5");

var $eDEQ5 = parcelRequire("eDEQ5");

var $i860n = parcelRequire("i860n");

var $cHkmB = parcelRequire("cHkmB");
const $0586763af38eb407$export$9b0fdfd6a51a17de = (0, $fdS54.createEntry)((0, $iXPKM.dashboardEditRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? $0586763af38eb407$var$GSNPageEntryPoint : $0586763af38eb407$var$pageEntryPoint,
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $3TTqW.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)((0, $i860n.fg)('navx-global-side-nav') ? {
                isUsingSidebarEntrypoint: true
            } : undefined),
            ...(0, $cHkmB.dashboardResources)(),
            (0, $dv1xk.gadgetDirectoryResource)
        ],
        forPaint: [
            (0, $cHkmB.LazyForPaintBackgroundScripts),
            (0, $cHkmB.LazyForPaintConnectJsApi)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));
// Page entrypoint, referred to above...
const $0586763af38eb407$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bd0Ph.dashboardEditEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h3uMu.nav4DashboardsContentEntryPoint)
            }
        }
    }
});
const $0586763af38eb407$var$GSNPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bd0Ph.dashboardEditEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h3uMu.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
const $21119304508db966$export$171f31ae1a6b7762 = 'DASHBOARDS';

parcelRegister("dv1xk", function(module, exports) {
$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $fe45862d7a536bd3$export$2853c0e656e89346);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $fe45862d7a536bd3$export$ef3fa55626812fa4);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $fe45862d7a536bd3$export$39804ce8cc42cd04);
$parcel$export(module.exports, "dashboardForgeResource", () => $fe45862d7a536bd3$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $fe45862d7a536bd3$export$36c9632be21fbb06);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aHmTX = parcelRequire("aHmTX");

var $A82xh = parcelRequire("A82xh");

var $7edbf = parcelRequire("7edbf");

var $gPdnf = parcelRequire("gPdnf");

var $9Mlz2 = parcelRequire("9Mlz2");

var $1AzFv = parcelRequire("1AzFv");

var $klCNv = parcelRequire("klCNv");

var $eDauF = parcelRequire("eDauF");

var $chwBs = parcelRequire("chwBs");

var $l7SoO = parcelRequire("l7SoO");
const $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_CONFIG_AND_WRM = 'DASHBOARD_CONFIG_AND_WRM';
const $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_AMD_MODULES = 'DASHBOARD_AMD_MODULES';
const $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_REACT_GADGETS = 'DASHBOARD_REACT_GADGETS';
const $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_FORGE = 'DASHBOARD_FORGE';
const $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_GADGET_DIRECTORY = 'DASHBOARD_GADGET_DIRECTORY';
const $fe45862d7a536bd3$export$2853c0e656e89346 = (0, $7edbf.createResource)({
    type: $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_CONFIG_AND_WRM,
    getKey: $9Mlz2.getKey,
    getData: (0, $klCNv.default),
    maxAge: Infinity
});
const $fe45862d7a536bd3$export$ef3fa55626812fa4 = // eslint-disable-next-line jira/router/no-daisy-chaining-resources
(0, $gPdnf.createDependentResource)({
    type: $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_AMD_MODULES,
    getKey: $9Mlz2.getKey,
    depends: [
        $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_CONFIG_AND_WRM
    ],
    mapToSharedValue: (0, $gPdnf.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $l7SoO.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $gPdnf.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $1AzFv.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $fe45862d7a536bd3$export$39804ce8cc42cd04 = // eslint-disable-next-line jira/router/no-daisy-chaining-resources
(0, $gPdnf.createDependentResource)({
    type: $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_REACT_GADGETS,
    getKey: $9Mlz2.getKey,
    depends: [
        $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_CONFIG_AND_WRM
    ],
    mapToSharedValue: (0, $gPdnf.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $l7SoO.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $gPdnf.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $chwBs.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $fe45862d7a536bd3$export$4e0719e53da01e93 = (0, $7edbf.createResource)({
    type: $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_FORGE,
    getKey: $9Mlz2.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        const modules = await (0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.DASHBOARD_GADGET_MODULE),
                (0, $aHmTX.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_ROUTER)
        });
        return {
            gadgets: modules[0, $aHmTX.DASHBOARD_GADGET_MODULE],
            backgroundScripts: modules[0, $aHmTX.DASHBOARD_BACKGROUND_SCRIPT_MODULE]
        };
    },
    maxAge: Infinity
});
const $fe45862d7a536bd3$export$36c9632be21fbb06 = (0, $7edbf.createResource)({
    type: $fe45862d7a536bd3$var$RESOURCE_TYPE_DASHBOARD_GADGET_DIRECTORY,
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $eDauF.default),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("gPdnf", function(module, exports) {
$parcel$export(module.exports, "withEitherDataOrError", () => $3d000a86455fd641$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $3d000a86455fd641$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $3d000a86455fd641$export$36d5102d613df7c6);
/* eslint-disable jira/filename-case */ 
var $7edbf = parcelRequire("7edbf");
var $hmSNA = parcelRequire("hmSNA");
const $3d000a86455fd641$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $3d000a86455fd641$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $hmSNA.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return resourceSlice.data;
};
const $3d000a86455fd641$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $3d000a86455fd641$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>// eslint-disable-next-line jira/router/no-daisy-chaining-resources
    (0, $7edbf.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $3d000a86455fd641$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$3d000a86455fd641$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // oxlint-disable-next-line typescript/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // oxlint-disable-next-line typescript/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// oxlint-disable-next-line typescript/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $3d000a86455fd641$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}
$3d000a86455fd641$export$36d5102d613df7c6.displayName = "SharedValueAggregateError";

});

parcelRegister("9Mlz2", function(module, exports) {
$parcel$export(module.exports, "getKey", () => $ebb96c3efe2efe9a$export$a47fb462a08de82f);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $eFL00 = parcelRequire("eFL00");
const $ebb96c3efe2efe9a$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === 'system-dashboard-edit') return 0, $eFL00.SYSTEM_DASHBOARD_ID;
    if (route.name === 'dashboard-wallboard') // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("eFL00", function(module, exports) {
$parcel$export(module.exports, "GADGET_DISPLAY", () => $3d52c6ae6aecc347$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $3d52c6ae6aecc347$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $3d52c6ae6aecc347$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $3d52c6ae6aecc347$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $3d52c6ae6aecc347$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $3d52c6ae6aecc347$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $3d52c6ae6aecc347$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $3d52c6ae6aecc347$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "STORAGE_PREFIX", () => $3d52c6ae6aecc347$export$7cc65d02ca2e18ec);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $3d52c6ae6aecc347$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $3d52c6ae6aecc347$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $3d52c6ae6aecc347$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $3d52c6ae6aecc347$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $3d52c6ae6aecc347$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $3d52c6ae6aecc347$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $3d52c6ae6aecc347$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $3d52c6ae6aecc347$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $3d52c6ae6aecc347$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $3d52c6ae6aecc347$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $3d52c6ae6aecc347$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $3d52c6ae6aecc347$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $3d52c6ae6aecc347$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $3d52c6ae6aecc347$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $3d52c6ae6aecc347$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $3d52c6ae6aecc347$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $3d52c6ae6aecc347$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $3d52c6ae6aecc347$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $3d52c6ae6aecc347$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $3d52c6ae6aecc347$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $3d52c6ae6aecc347$export$6c84c6099fed3c23);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $3d52c6ae6aecc347$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $3d52c6ae6aecc347$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $3d52c6ae6aecc347$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $3d52c6ae6aecc347$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $3d52c6ae6aecc347$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $3d52c6ae6aecc347$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $3d52c6ae6aecc347$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $3d52c6ae6aecc347$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $3d52c6ae6aecc347$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $3d52c6ae6aecc347$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $3d52c6ae6aecc347$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $3d52c6ae6aecc347$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $3d52c6ae6aecc347$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $3d52c6ae6aecc347$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $3d52c6ae6aecc347$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $3d52c6ae6aecc347$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $3d52c6ae6aecc347$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $3d52c6ae6aecc347$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $3d52c6ae6aecc347$export$768dad6811159849);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $3d52c6ae6aecc347$export$ada294d471e7dfc3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $3d52c6ae6aecc347$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $3d52c6ae6aecc347$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $3d52c6ae6aecc347$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $3d52c6ae6aecc347$export$f07dac7b8de3bda);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");
const $3d52c6ae6aecc347$var$blue = (0, $7eNDO.defineMessage)({
    id: "dashboard-common.blue",
    defaultMessage: "Blue"
});
const $3d52c6ae6aecc347$var$red = (0, $7eNDO.defineMessage)({
    id: "dashboard-common.red",
    defaultMessage: "Red"
});
const $3d52c6ae6aecc347$var$yellow = (0, $7eNDO.defineMessage)({
    id: "dashboard-common.yellow",
    defaultMessage: "Yellow"
});
const $3d52c6ae6aecc347$var$green = (0, $7eNDO.defineMessage)({
    id: "dashboard-common.green",
    defaultMessage: "Green"
});
const $3d52c6ae6aecc347$var$teal = (0, $7eNDO.defineMessage)({
    id: "dashboard-common.teal",
    defaultMessage: "Teal"
});
const $3d52c6ae6aecc347$var$purple = (0, $7eNDO.defineMessage)({
    id: "dashboard-common.purple",
    defaultMessage: "Purple"
});
const $3d52c6ae6aecc347$var$gray = (0, $7eNDO.defineMessage)({
    id: "dashboard-common.gray",
    defaultMessage: "Gray"
});
const $3d52c6ae6aecc347$var$white = (0, $7eNDO.defineMessage)({
    id: "dashboard-common.white",
    defaultMessage: "White"
});
const $3d52c6ae6aecc347$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $3d52c6ae6aecc347$export$86eaa19ea940a4f5 = 'maximized';
const $3d52c6ae6aecc347$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $3d52c6ae6aecc347$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $3d52c6ae6aecc347$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $3d52c6ae6aecc347$export$50eac80bcbebc737 = '10000';
const $3d52c6ae6aecc347$export$e11ffd0409aa6522 = 80;
const $3d52c6ae6aecc347$export$4d708f4c16ae3a73 = 16;
const $3d52c6ae6aecc347$export$7cc65d02ca2e18ec = 'dashboard';
const $3d52c6ae6aecc347$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $3d52c6ae6aecc347$export$e281465c09f561d4 = 'dashboard-data';
const $3d52c6ae6aecc347$export$46dd0168a7875b47 = 160;
const $3d52c6ae6aecc347$var$COLOR_BLUE = '#2684ff';
const $3d52c6ae6aecc347$var$COLOR_RED = '#ff5630';
const $3d52c6ae6aecc347$var$COLOR_YELLOW = '#ffab00';
const $3d52c6ae6aecc347$var$COLOR_GREEN = '#36b37e';
const $3d52c6ae6aecc347$var$COLOR_TEAL = '#00b8d9';
const $3d52c6ae6aecc347$var$COLOR_PURPLE = '#6554c0';
const $3d52c6ae6aecc347$var$COLOR_GRAY = '#97a0af';
const $3d52c6ae6aecc347$var$COLOR_WHITE = '#ffffff';
const $3d52c6ae6aecc347$export$1468aefba37090f9 = {
    color1: $3d52c6ae6aecc347$var$COLOR_BLUE,
    color2: $3d52c6ae6aecc347$var$COLOR_RED,
    color3: $3d52c6ae6aecc347$var$COLOR_YELLOW,
    color4: $3d52c6ae6aecc347$var$COLOR_GREEN,
    color5: $3d52c6ae6aecc347$var$COLOR_TEAL,
    color6: $3d52c6ae6aecc347$var$COLOR_PURPLE,
    color7: $3d52c6ae6aecc347$var$COLOR_GRAY,
    color8: $3d52c6ae6aecc347$var$COLOR_WHITE
};
const $3d52c6ae6aecc347$export$5d9e688e192a63ae = {
    [$3d52c6ae6aecc347$var$COLOR_BLUE]: $3d52c6ae6aecc347$var$blue,
    [$3d52c6ae6aecc347$var$COLOR_RED]: $3d52c6ae6aecc347$var$red,
    [$3d52c6ae6aecc347$var$COLOR_YELLOW]: $3d52c6ae6aecc347$var$yellow,
    [$3d52c6ae6aecc347$var$COLOR_GREEN]: $3d52c6ae6aecc347$var$green,
    [$3d52c6ae6aecc347$var$COLOR_TEAL]: $3d52c6ae6aecc347$var$teal,
    [$3d52c6ae6aecc347$var$COLOR_PURPLE]: $3d52c6ae6aecc347$var$purple,
    [$3d52c6ae6aecc347$var$COLOR_GRAY]: $3d52c6ae6aecc347$var$gray,
    [$3d52c6ae6aecc347$var$COLOR_WHITE]: $3d52c6ae6aecc347$var$white
};
const $3d52c6ae6aecc347$export$6906a4beef307ac4 = {
    color1: '#FAFBFC',
    color2: '#FAFBFC',
    color3: '#42526E',
    color4: '#FAFBFC',
    color5: '#42526E',
    color6: '#FAFBFC',
    color7: '#FAFBFC',
    color8: '#42526E'
};
const $3d52c6ae6aecc347$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $3d52c6ae6aecc347$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $3d52c6ae6aecc347$export$b0234a47b1a4a515 = 350;
const $3d52c6ae6aecc347$export$9674cd14c20d1c89 = 250;
const $3d52c6ae6aecc347$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $3d52c6ae6aecc347$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $3d52c6ae6aecc347$export$4f74f1f13671c49d = 'delete-dashboard';
const $3d52c6ae6aecc347$export$3853fce65645c557 = 'copy-dashboard';
const $3d52c6ae6aecc347$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $3d52c6ae6aecc347$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $3d52c6ae6aecc347$export$efbab4efa7252143 = 'create-dashboard';
const $3d52c6ae6aecc347$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $3d52c6ae6aecc347$export$f0e105144716a420 = 'view-dashboard-readonly';
const $3d52c6ae6aecc347$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $3d52c6ae6aecc347$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $3d52c6ae6aecc347$export$3b17b4f7f722b1ae = 'add-gadget';
const $3d52c6ae6aecc347$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $3d52c6ae6aecc347$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $3d52c6ae6aecc347$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $3d52c6ae6aecc347$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $3d52c6ae6aecc347$export$7254246f25b4cbc8 = 'change-layout';
const $3d52c6ae6aecc347$export$40c4d345e57fce2d = 'delete-gadget';
const $3d52c6ae6aecc347$export$43fb10a4d8374f1a = 'view-react-gadget';
const $3d52c6ae6aecc347$export$2f961c74af6d8735 = 'dashboardView';
const $3d52c6ae6aecc347$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $3d52c6ae6aecc347$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $3d52c6ae6aecc347$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $3d52c6ae6aecc347$export$eba1a497984af3ae = 'systemDashboardEdit';
const $3d52c6ae6aecc347$export$3578044b625436f9 = 'copyDashboard';
const $3d52c6ae6aecc347$export$48bb59a846d62ea0 = 'automaticRefresh';
const $3d52c6ae6aecc347$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $3d52c6ae6aecc347$export$fabf79b25b44377f = 'duplicateGadget';
const $3d52c6ae6aecc347$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $3d52c6ae6aecc347$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $3d52c6ae6aecc347$export$ada294d471e7dfc3 = 1000;
const $3d52c6ae6aecc347$export$f4280aaeba4d1d08 = 30000;
const $3d52c6ae6aecc347$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $3d52c6ae6aecc347$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $3d52c6ae6aecc347$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];

});


parcelRegister("1AzFv", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dd035e676b2a59c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emmOr = parcelRequire("emmOr");

var $gPdnf = parcelRequire("gPdnf");

var $dVUlj = parcelRequire("dVUlj");
const $1dd035e676b2a59c$var$getAMDModulesData = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $gPdnf.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $dVUlj.loadAmdModules)((0, $emmOr.asyncWrmRequire), moduleNames) ? (0, $dVUlj.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };
var $1dd035e676b2a59c$export$2e2bcd8739ae039 = $1dd035e676b2a59c$var$getAMDModulesData;

});
parcelRegister("emmOr", function(module, exports) {
$parcel$export(module.exports, "asyncWrmRequire", () => $692f2a5a80efff00$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $692f2a5a80efff00$export$3ca0de203efa570e);
/* eslint-disable jira/filename-case, jira/wrm/no-load-bridge */ 
var $3i0O3 = parcelRequire("3i0O3");
var $UC9tJ = parcelRequire("UC9tJ");
const $692f2a5a80efff00$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $3i0O3.wrmRequire)(resourcesToRequire);
const $692f2a5a80efff00$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $UC9tJ.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});
parcelRegister("3i0O3", function(module, exports) {
$parcel$export(module.exports, "wrmRequire", () => $ad614e51c09a2912$export$cc9d8f51375ef66a);
/* eslint-disable jira/filename-case */ 
var $f39gG = parcelRequire("f39gG");

var $1fD9L = parcelRequire("1fD9L");
const $ad614e51c09a2912$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR))=>(0, $f39gG.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});
parcelRegister("f39gG", function(module, exports) {
$parcel$export(module.exports, "loadWrmResources", () => $753a8f7d9232d897$export$6cda16b6eff75f59);
/* eslint-disable jira/filename-case */ 
var $b3AOE = parcelRequire("b3AOE");

var $ktkIs = parcelRequire("ktkIs");

var $8IotF = parcelRequire("8IotF");

var $1fD9L = parcelRequire("1fD9L");
const $753a8f7d9232d897$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $8IotF.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $ktkIs.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $1fD9L.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $b3AOE.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("b3AOE", function(module, exports) {
$parcel$export(module.exports, "safeStringify", () => $575c3794295cd43c$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $575c3794295cd43c$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});

parcelRegister("ktkIs", function(module, exports) {
$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $016f2bde0e3a1ef7$export$93d9db5fbabad1b0);
/* eslint-disable jira/filename-case */ 
var $6Z3wy = parcelRequire("6Z3wy");
let $016f2bde0e3a1ef7$var$isSuperBatchDependenciesLoaded = false;
const $016f2bde0e3a1ef7$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $016f2bde0e3a1ef7$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($016f2bde0e3a1ef7$var$isSuperBatchDependenciesLoaded || $016f2bde0e3a1ef7$var$isOnRapidBoardsPage()) return wrmKeys;
    $016f2bde0e3a1ef7$var$isSuperBatchDependenciesLoaded = true;
    return (0, $6Z3wy.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("6Z3wy", function(module, exports) {
$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $ca21c54a2634c804$export$f14a6b583ce9e077);
/* eslint-disable jira/filename-case */ const $ca21c54a2634c804$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});


parcelRegister("8IotF", function(module, exports) {
$parcel$export(module.exports, "loadBridgeWeak", () => $cba106b8f70516b2$export$3cefda82396756a1);
/* eslint-disable jira/filename-case */ 
var $dWTea = parcelRequire("dWTea");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
let $cba106b8f70516b2$var$pollingSingleton = null;
const $cba106b8f70516b2$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $cba106b8f70516b2$var$pollingSingleton ?? (0, $dWTea.createPollingCollection)((v)=>window.require(v), 100);
    $cba106b8f70516b2$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("dWTea", function(module, exports) {
$parcel$export(module.exports, "createPollingCollection", () => $7de7057d4b7e1c62$export$f163446a982a8077);
/* eslint-disable jira/filename-case */ 
var $1uH7N = parcelRequire("1uH7N");

var $aA3A5 = parcelRequire("aA3A5");
const $7de7057d4b7e1c62$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $1uH7N.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aA3A5.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aA3A5.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aA3A5", function(module, exports) {
$parcel$export(module.exports, "default", () => $abfaf64ce8ef144a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $abfaf64ce8ef144a$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $abfaf64ce8ef144a$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $abfaf64ce8ef144a$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}
$abfaf64ce8ef144a$export$2e2bcd8739ae039.displayName = "Deferred";

});



parcelRegister("1fD9L", function(module, exports) {
$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $31c65cd7c39d7bf1$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $31c65cd7c39d7bf1$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $31c65cd7c39d7bf1$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $31c65cd7c39d7bf1$export$37f20f0ff732fcd7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");
const $31c65cd7c39d7bf1$export$f19a2d31722e3428 = (0, $6CfY5.default).safeErrorWithoutCustomerData;
const $31c65cd7c39d7bf1$export$ea810ce67e3c8eac = (0, $6CfY5.default).safeInfoWithoutCustomerData;
const $31c65cd7c39d7bf1$export$1f86472c1374185a = 40;
const $31c65cd7c39d7bf1$export$7bd623b29ec8e1eb = 500;
const $31c65cd7c39d7bf1$export$37f20f0ff732fcd7 = true;

});



parcelRegister("UC9tJ", function(module, exports) {
$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $73b86a7d365a8248$export$e53a5db19a39ed2f);
/* eslint-disable jira/filename-case */ 
var $f39gG = parcelRequire("f39gG");

var $1fD9L = parcelRequire("1fD9L");
const $73b86a7d365a8248$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR))=>(0, $f39gG.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dVUlj", function(module, exports) {
$parcel$export(module.exports, "loadAmdModules", () => $03f7690d34de8fd8$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $03f7690d34de8fd8$export$d74eab33af9baaea);
/* eslint-disable jira/filename-case */ 
var $6CfY5 = parcelRequire("6CfY5");

var $eFL00 = parcelRequire("eFL00");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $03f7690d34de8fd8$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // oxlint-disable-next-line no-empty-function
    render() {}
    // Replace with lodash/noop
    // oxlint-disable-next-line no-empty-function
    renderEdit() {}
}
$03f7690d34de8fd8$var$ConnectDashboardItem.displayName = "ConnectDashboardItem";
const $03f7690d34de8fd8$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(moduleName);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$03f7690d34de8fd8$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $03f7690d34de8fd8$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $eFL00.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $03f7690d34de8fd8$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $03f7690d34de8fd8$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $eFL00.CONNECT_ITEM_AMD_MODULE) ? $03f7690d34de8fd8$var$ConnectDashboardItem : $03f7690d34de8fd8$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $6CfY5.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $6CfY5.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $6CfY5.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$03f7690d34de8fd8$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $6CfY5.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("klCNv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba402fa40cc29a40$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9HqRX = parcelRequire("9HqRX");

var $6CfY5 = parcelRequire("6CfY5");

var $aa7uJ = parcelRequire("aa7uJ");

var $8HTap = parcelRequire("8HTap");

var $iCS1M = parcelRequire("iCS1M");

var $1irUK = parcelRequire("1irUK");

var $9Mlz2 = parcelRequire("9Mlz2");

var $l7SoO = parcelRequire("l7SoO");
const $ba402fa40cc29a40$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $l7SoO.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $8HTap.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $1irUK.default)(wrmBundleDescriptor) : null,
            (0, $iCS1M.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
const $ba402fa40cc29a40$var$getConfigAndWRMData = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    try {
        const { route: route, query: query } = context;
        const originalConfigs = route.name === 'dashboard-wallboard' ? await (0, $aa7uJ.getDashboardsConfig)(query.dashboardId) : [
            await (0, $aa7uJ.default)((0, $9Mlz2.getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, $9HqRX.mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $ba402fa40cc29a40$var$generateScriptTagAndPreloadedModuleNames(configs);
    } catch (error) {
        (0, $6CfY5.default).unsafeErrorWithCustomerData('spa-apps.dashboard.get-config-and-wrm-data', `Failed to get dashboard configuration and wrm data: route=[${context.route.name}], query=[${JSON.stringify(context.query)}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
var $ba402fa40cc29a40$export$2e2bcd8739ae039 = $ba402fa40cc29a40$var$getConfigAndWRMData;

});
parcelRegister("9HqRX", function(module, exports) {
$parcel$export(module.exports, "mapToReactGadgets", () => $48ecbd6104f77384$export$c90615c5eb218d50);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
const $48ecbd6104f77384$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $2700E.expVal)('endeavour_nin_filter_results_gadget_config', 'value', false) ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $2700E.expVal)('endeavour_nin_assigned_to_me_gadget_config', 'value', false) ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $2700E.expVal)('endeavour_nin_issues_in_progress_gadget_config', 'value', false) ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $2700E.expVal)('endeavour_nin_voted_issues_gadget_config', 'value', false) ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $2700E.expVal)('endeavour_nin_watched_issues_gadget_config', 'value', false) ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("aa7uJ", function(module, exports) {
$parcel$export(module.exports, "getDashboardsConfig", () => $6659df622131c4f1$export$1264b6af3adf5084);
$parcel$export(module.exports, "default", () => $6659df622131c4f1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $4fhEY = parcelRequire("4fhEY");

var $6CfY5 = parcelRequire("6CfY5");
const $6659df622131c4f1$var$getDashboardConfig = async (id)=>{
    try {
        return (0, $4fhEY.default)(`/rest/dashboards/1.0/${id}.json`);
    } catch (error) {
        (0, $6CfY5.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config json with id=[${id}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
const $6659df622131c4f1$export$1264b6af3adf5084 = async (idsCsv)=>{
    try {
        return (0, $4fhEY.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
    } catch (error) {
        (0, $6CfY5.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config with ids=[${idsCsv}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
var $6659df622131c4f1$export$2e2bcd8739ae039 = $6659df622131c4f1$var$getDashboardConfig;

});

parcelRegister("8HTap", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f8125e44304af0$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $eFL00 = parcelRequire("eFL00");

var $4fhEY = parcelRequire("4fhEY");

var $6CfY5 = parcelRequire("6CfY5");
const $95f8125e44304af0$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $95f8125e44304af0$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
const $95f8125e44304af0$var$fetchWrmBundleDescriptor = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $eFL00.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$95f8125e44304af0$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $95f8125e44304af0$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    try {
        return (0, $4fhEY.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    } catch (error) {
        (0, $6CfY5.default).unsafeErrorWithCustomerData('spa-apps.dashboard.wrm-bundle-descriptor', `Failed to fetch wrm bundle with contexts [${contextsToRequire.join(',')}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
var $95f8125e44304af0$export$2e2bcd8739ae039 = $95f8125e44304af0$var$fetchWrmBundleDescriptor;

});

parcelRegister("iCS1M", function(module, exports) {
$parcel$export(module.exports, "default", () => $740833dd5a15e6c7$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $eFL00 = parcelRequire("eFL00");

var $9Cu5L = parcelRequire("9Cu5L");
const $740833dd5a15e6c7$var$generatePreloadLinkTags = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $9Cu5L.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $eFL00.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $eFL00.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};
var $740833dd5a15e6c7$export$2e2bcd8739ae039 = $740833dd5a15e6c7$var$generatePreloadLinkTags;

});
parcelRegister("9Cu5L", function(module, exports) {
$parcel$export(module.exports, "getPrefetches", () => $194879b052240977$export$3144db3718ad5e57);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lwC9g = parcelRequire("lwC9g");
const $194879b052240977$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $lwC9g.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("lwC9g", function(module, exports) {
$parcel$export(module.exports, "getPrefetchDict", () => $3d23d085b69cd879$export$244cea94cab19e07);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");

var $0dyuH = parcelRequire("0dyuH");

var $6eQiu = parcelRequire("6eQiu");

var $2M8nU = parcelRequire("2M8nU");
const $3d23d085b69cd879$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $6eQiu.getActivityStreamPrefetchLink),
            priority: (0, $0dyuH.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $2M8nU.getFilterResultsPrefetchLink),
            priority: (0, $0dyuH.LOADING_PRIORITY).LOW,
            enabled: !(0, $2700E.expVal)('endeavour_nin_filter_results_gadget_config', 'value', false),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("0dyuH", function(module, exports) {
$parcel$export(module.exports, "LOADING_PRIORITY", () => $62669d15dfd286e5$export$cb9b1f2232733c1b);
/* eslint-disable jira/filename-case */ const $62669d15dfd286e5$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("6eQiu", function(module, exports) {
$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $42407c971dcbd4dc$export$360928f5bf059a9e);
/* eslint-disable jira/filename-case */ 
var $bS1iz = parcelRequire("bS1iz");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $42407c971dcbd4dc$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $42407c971dcbd4dc$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $42407c971dcbd4dc$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $42407c971dcbd4dc$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $42407c971dcbd4dc$var$getParamsFromRules = (rules)=>{
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $42407c971dcbd4dc$var$replacer)))?.providers || [];
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $42407c971dcbd4dc$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $42407c971dcbd4dc$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $42407c971dcbd4dc$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(params).replace(/%20/g, '+');
};
const $42407c971dcbd4dc$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $42407c971dcbd4dc$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $42407c971dcbd4dc$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$42407c971dcbd4dc$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("2M8nU", function(module, exports) {
$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $211d9815c5857067$export$947cd90004054337);
/* eslint-disable jira/filename-case */ 
var $bS1iz = parcelRequire("bS1iz");
const $211d9815c5857067$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $211d9815c5857067$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$211d9815c5857067$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("1irUK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3ccad6e29e6e66d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $b3ccad6e29e6e66d$var$generateScriptTags = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};
var $b3ccad6e29e6e66d$export$2e2bcd8739ae039 = $b3ccad6e29e6e66d$var$generateScriptTags;

});

parcelRegister("l7SoO", function(module, exports) {
$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $c90711d7342cfe34$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $c90711d7342cfe34$export$f98787198c197952);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $eFL00 = parcelRequire("eFL00");

var $8RWGq = parcelRequire("8RWGq");
const $c90711d7342cfe34$export$598e0ea2a7525181 = (gadgets)=>gadgets // oxlint-disable-next-line typescript/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $eFL00.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $c90711d7342cfe34$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $8RWGq.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // oxlint-disable-next-line typescript/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("8RWGq", function(module, exports) {
$parcel$export(module.exports, "isReactKey", () => $0f59170d8b486487$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $0f59170d8b486487$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fKtS2 = parcelRequire("fKtS2");

var $iMi5n = parcelRequire("iMi5n");

var $e6LU4 = parcelRequire("e6LU4");
/** This is a gadgets definition file.  */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $0f59170d8b486487$var$GADGETS_DEFINITION = {
    [(0, $e6LU4.REACT_KEY).FILTER_RESULTS]: (0, $iMi5n.FILTER_RESULTS_DEFINITION),
    [(0, $e6LU4.REACT_KEY).ASSIGNED_TO_ME]: (0, $iMi5n.ASSIGNED_TO_ME_DEFINITION),
    [(0, $e6LU4.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $iMi5n.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $e6LU4.REACT_KEY).VOTED_ISSUES]: (0, $iMi5n.VOTED_ISSUES_DEFINITION),
    [(0, $e6LU4.REACT_KEY).WATCHED_ISSUES]: (0, $iMi5n.WATCHED_ISSUES_DEFINITION),
    [(0, $e6LU4.REACT_KEY).CUSTOM_REPORT]: (0, $fKtS2.default)
};
function $0f59170d8b486487$export$6acd06c99f745b49(key) {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return !!(key && Object.values((0, $e6LU4.REACT_KEY)).includes(key));
}
var $0f59170d8b486487$export$2e2bcd8739ae039 = $0f59170d8b486487$var$GADGETS_DEFINITION;

});
parcelRegister("fKtS2", function(module, exports) {
$parcel$export(module.exports, "default", () => $46a1190cd0fa1787$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6MQSK = parcelRequire("6MQSK");

var $aEGD1 = parcelRequire("aEGD1");

var $4KS8K = parcelRequire("4KS8K");
const $46a1190cd0fa1787$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $aEGD1.LazyCustomReportGadgetView),
    componentEdit: (0, $6MQSK.LazyCustomReportGadgetEdit),
    getInitialState: $4KS8K.default,
    preload: $aEGD1.preload
};
var $46a1190cd0fa1787$export$2e2bcd8739ae039 = $46a1190cd0fa1787$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("6MQSK", function(module, exports) {
$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $f4ceb90e7d53e59f$export$475e4a6fb8f40116);
/* eslint-disable jira/filename-case */ 
var $l8G1z = parcelRequire("l8G1z");

const $f4ceb90e7d53e59f$export$475e4a6fb8f40116 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("hmrhN")), {
    moduleId: "./src/packages/global-pages/dashboard-react-gadgets-custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("hmrhN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("5J380")
]).then(()=>parcelRequire('9mKPM'));

});


parcelRegister("aEGD1", function(module, exports) {
$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $38f701676e4f9ba1$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $38f701676e4f9ba1$export$513ccb98c53b8039);
/* eslint-disable jira/filename-case */ 
var $l8G1z = parcelRequire("l8G1z");

const $38f701676e4f9ba1$export$27df795d4f3ff173 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("jpqsU")), {
    moduleId: "./src/packages/global-pages/dashboard-react-gadgets-custom-report-gadget/src/ui/view/main.tsx"
});
const $38f701676e4f9ba1$export$513ccb98c53b8039 = $38f701676e4f9ba1$export$27df795d4f3ff173.preload;

});
parcelRegister("jpqsU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9EDZN").then(()=>parcelRequire('lE8qA'));

});


parcelRegister("4KS8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $5dcba0552f25b53e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $5dcba0552f25b53e$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $5dcba0552f25b53e$export$2e2bcd8739ae039 = $5dcba0552f25b53e$var$getInitialState;

});


parcelRegister("iMi5n", function(module, exports) {
$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $9c9aa7580ac748b4$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $9c9aa7580ac748b4$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $9c9aa7580ac748b4$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $9c9aa7580ac748b4$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $9c9aa7580ac748b4$export$5109728db227eae);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $9D36p = parcelRequire("9D36p");

var $cx5uD = parcelRequire("cx5uD");

var $h4IkJ = parcelRequire("h4IkJ");

var $7fgmr = parcelRequire("7fgmr");

var $6bScT = parcelRequire("6bScT");

var $c7EZx = parcelRequire("c7EZx");

var $dVQUj = parcelRequire("dVQUj");
const $9c9aa7580ac748b4$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $9c9aa7580ac748b4$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $9c9aa7580ac748b4$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $9c9aa7580ac748b4$export$3581891d04da6bb8 = {
    componentView: $9c9aa7580ac748b4$var$componentViewWithAdditionalState((0, $7fgmr.IssueTableGadgetView), $9c9aa7580ac748b4$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $cx5uD.FilterResultsGadgetEdit),
    getInitialState: (0, $dVQUj.default)($9c9aa7580ac748b4$var$FILTER_RESULTS_CONFIG),
    preload: (0, $7fgmr.preload)
};
const $9c9aa7580ac748b4$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $9c9aa7580ac748b4$export$652d5a9cc2c18d2e = {
    componentView: $9c9aa7580ac748b4$var$componentViewWithAdditionalState((0, $7fgmr.IssueTableGadgetView), $9c9aa7580ac748b4$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $9c9aa7580ac748b4$var$componentEditWithAdditionalState((0, $9D36p.AssignedToMeGadgetEdit), $9c9aa7580ac748b4$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $dVQUj.default)($9c9aa7580ac748b4$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $7fgmr.preload)
};
const $9c9aa7580ac748b4$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $9c9aa7580ac748b4$export$54b46348d1ed5d22 = {
    componentView: $9c9aa7580ac748b4$var$componentViewWithAdditionalState((0, $7fgmr.IssueTableGadgetView), $9c9aa7580ac748b4$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $9c9aa7580ac748b4$var$componentEditWithAdditionalState((0, $h4IkJ.IssuesInProgressGadgetEdit), $9c9aa7580ac748b4$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $dVQUj.default)($9c9aa7580ac748b4$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $7fgmr.preload)
};
const $9c9aa7580ac748b4$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $9c9aa7580ac748b4$export$ea96ce30d34ce354 = {
    componentView: $9c9aa7580ac748b4$var$componentViewWithAdditionalState((0, $7fgmr.IssueTableGadgetView), $9c9aa7580ac748b4$var$VOTED_ISSUES_CONFIG),
    componentEdit: $9c9aa7580ac748b4$var$componentEditWithAdditionalState((0, $6bScT.VotedIssuesGadgetEdit), $9c9aa7580ac748b4$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $dVQUj.default)($9c9aa7580ac748b4$var$VOTED_ISSUES_CONFIG),
    preload: (0, $7fgmr.preload)
};
const $9c9aa7580ac748b4$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $9c9aa7580ac748b4$export$5109728db227eae = {
    componentView: $9c9aa7580ac748b4$var$componentViewWithAdditionalState((0, $7fgmr.IssueTableGadgetView), $9c9aa7580ac748b4$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $9c9aa7580ac748b4$var$componentEditWithAdditionalState((0, $c7EZx.WatchedIssuesGadgetEdit), $9c9aa7580ac748b4$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $dVQUj.default)($9c9aa7580ac748b4$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $7fgmr.preload)
};

});
parcelRegister("9D36p", function(module, exports) {
$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $a11bc182d9456257$export$3ae3568d16dc8f35);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $9oNar = parcelRequire("9oNar");

var $l8G1z = parcelRequire("l8G1z");

const $a11bc182d9456257$var$LazyAssignedToMeGadgetEdit = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("20y6t")), {
    moduleId: "./src/packages/global-pages/dashboard-react-gadgets-issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $a11bc182d9456257$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9oNar.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a11bc182d9456257$var$LazyAssignedToMeGadgetEdit, props));
$a11bc182d9456257$export$3ae3568d16dc8f35.displayName = "AssignedToMeGadgetEdit";
const $a11bc182d9456257$export$513ccb98c53b8039 = $a11bc182d9456257$var$LazyAssignedToMeGadgetEdit.preload;

});
parcelRegister("9oNar", function(module, exports) {
$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $d33022f109d0ef21$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $drHKe = parcelRequire("drHKe");
const $d33022f109d0ef21$var$customCssStyles = null;
const $d33022f109d0ef21$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $d33022f109d0ef21$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drHKe))),
        containerStyles: {
            height: $d33022f109d0ef21$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    });
$d33022f109d0ef21$export$e10d91ce257e7374.displayName = "FilterResultsEditSkeleton";

});
parcelRegister("drHKe", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("20y6t", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("8WqgD")
]).then(()=>parcelRequire('54ALP'));

});


parcelRegister("cx5uD", function(module, exports) {
$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $d9d95c3774fe58da$export$6dfceca003c43832);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $9oNar = parcelRequire("9oNar");

var $l8G1z = parcelRequire("l8G1z");

const $d9d95c3774fe58da$var$LazyFilterResultsGadgetEdit = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("bhWlS")), {
    moduleId: "./src/packages/global-pages/dashboard-react-gadgets-issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $d9d95c3774fe58da$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9oNar.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d9d95c3774fe58da$var$LazyFilterResultsGadgetEdit, props));
$d9d95c3774fe58da$export$6dfceca003c43832.displayName = "FilterResultsGadgetEdit";
const $d9d95c3774fe58da$export$513ccb98c53b8039 = $d9d95c3774fe58da$var$LazyFilterResultsGadgetEdit.preload;

});
parcelRegister("bhWlS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("1x5Vo")
]).then(()=>parcelRequire('lCh2h'));

});


parcelRegister("h4IkJ", function(module, exports) {
$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $2322f4559e098d31$export$199fec410a0f70a2);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $9oNar = parcelRequire("9oNar");

var $l8G1z = parcelRequire("l8G1z");

const $2322f4559e098d31$var$LazyIssuesInProgressGadgetEdit = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2JIAV")), {
    moduleId: "./src/packages/global-pages/dashboard-react-gadgets-issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $2322f4559e098d31$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9oNar.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2322f4559e098d31$var$LazyIssuesInProgressGadgetEdit, props));
$2322f4559e098d31$export$199fec410a0f70a2.displayName = "IssuesInProgressGadgetEdit";
const $2322f4559e098d31$export$513ccb98c53b8039 = $2322f4559e098d31$var$LazyIssuesInProgressGadgetEdit.preload;

});
parcelRegister("2JIAV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gDZwk")
]).then(()=>parcelRequire('ew8Du'));

});


parcelRegister("7fgmr", function(module, exports) {
$parcel$export(module.exports, "IssueTableGadgetView", () => $1f571e2ee4190599$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $1f571e2ee4190599$export$513ccb98c53b8039);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eFL00 = parcelRequire("eFL00");

var $a8EUd = parcelRequire("a8EUd");

var $bowfr = parcelRequire("bowfr");

var $l8G1z = parcelRequire("l8G1z");

const $1f571e2ee4190599$var$LazyIssueTableGadgetView = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("dHtjP")), {
    moduleId: "./src/packages/global-pages/dashboard-react-gadgets-issue-table-gadgets/src/ui/view/main.tsx"
});
const $1f571e2ee4190599$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bowfr.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $eFL00.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1f571e2ee4190599$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
$1f571e2ee4190599$export$da0765a3c10e16a3.displayName = "IssueTableGadgetView";
const $1f571e2ee4190599$export$513ccb98c53b8039 = $1f571e2ee4190599$var$LazyIssueTableGadgetView.preload;

});
parcelRegister("bowfr", function(module, exports) {
$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $dc856e5e5971a3ec$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $3TIqQ = parcelRequire("3TIqQ");
const $dc856e5e5971a3ec$var$customCssStyles = null;
const $dc856e5e5971a3ec$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3TIqQ))),
        containerStyles: {
            height: height
        },
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    });
$dc856e5e5971a3ec$export$35d754053deeac73.displayName = "FilterResultsIssueTableSkeleton";

});
parcelRegister("3TIqQ", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("dHtjP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("2lfsA")
]).then(()=>parcelRequire('4j2Cy'));

});


parcelRegister("6bScT", function(module, exports) {
$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $4ac227ff61f9815b$export$7650b85a7a54914);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $9oNar = parcelRequire("9oNar");

var $l8G1z = parcelRequire("l8G1z");

const $4ac227ff61f9815b$var$LazyVotedIssuesGadgetEdit = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("heCI1")), {
    moduleId: "./src/packages/global-pages/dashboard-react-gadgets-issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $4ac227ff61f9815b$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9oNar.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4ac227ff61f9815b$var$LazyVotedIssuesGadgetEdit, props));
$4ac227ff61f9815b$export$7650b85a7a54914.displayName = "VotedIssuesGadgetEdit";
const $4ac227ff61f9815b$export$513ccb98c53b8039 = $4ac227ff61f9815b$var$LazyVotedIssuesGadgetEdit.preload;

});
parcelRegister("heCI1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("7J3Xo")
]).then(()=>parcelRequire('f89hd'));

});


parcelRegister("c7EZx", function(module, exports) {
$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $a08732ff6b13fd22$export$a53864bd0bf8a85f);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $9oNar = parcelRequire("9oNar");

var $l8G1z = parcelRequire("l8G1z");

const $a08732ff6b13fd22$var$LazyWatchedIssuesGadgetEdit = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9ketq")), {
    moduleId: "./src/packages/global-pages/dashboard-react-gadgets-issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $a08732ff6b13fd22$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9oNar.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a08732ff6b13fd22$var$LazyWatchedIssuesGadgetEdit, props));
$a08732ff6b13fd22$export$a53864bd0bf8a85f.displayName = "WatchedIssuesGadgetEdit";
const $a08732ff6b13fd22$export$513ccb98c53b8039 = $a08732ff6b13fd22$var$LazyWatchedIssuesGadgetEdit.preload;

});
parcelRegister("9ketq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("8RPLT")
]).then(()=>parcelRequire('4fZP1'));

});


parcelRegister("dVQUj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7e0a2b979620b70$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $Qgc0A = parcelRequire("Qgc0A");

var $5zOve = parcelRequire("5zOve");

var $drTum = parcelRequire("drTum");

var $fOuVC = parcelRequire("fOuVC");
const $f7e0a2b979620b70$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $fOuVC.transformToValidUserPrefs)((0, $Qgc0A.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $drTum.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $5zOve.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $f7e0a2b979620b70$export$2e2bcd8739ae039 = $f7e0a2b979620b70$var$createGetInitialState;

});
parcelRegister("Qgc0A", function(module, exports) {
$parcel$export(module.exports, "getUserPreferences", () => $cbc4b5e72a8b03dc$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $cbc4b5e72a8b03dc$export$ebdfc6c2778ef8e2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");
const $cbc4b5e72a8b03dc$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $cbc4b5e72a8b03dc$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $cbc4b5e72a8b03dc$export$ae3f5fa351e2f57a = (action)=>(0, $4fhEY.default)(action);
const $cbc4b5e72a8b03dc$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $cbc4b5e72a8b03dc$var$isBooleanString(value) ? $cbc4b5e72a8b03dc$var$stringToBoolean(value) : value
        }), // oxlint-disable-next-line typescript/consistent-type-assertions
    {});

});

parcelRegister("5zOve", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a40a2a4e874af05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9a707ea335bcd0a020dcd1ca14d2378>>
 * @relayHash e4548e308f261d06c076168d41351cf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e3a37de46b3f6e9f3abf6e8bff38faf95a383326955c2a56071c1bb454e1d1d

var $1D6fx = parcelRequire("1D6fx");

var $KUiqF = parcelRequire("KUiqF");

var $7yObX = parcelRequire("7yObX");

var $7e655 = parcelRequire("7e655");

var $7zUJD = parcelRequire("7zUJD");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $gE0jx = parcelRequire("gE0jx");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $1F2RS = parcelRequire("1F2RS");

var $l4q64 = parcelRequire("l4q64");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $6BTmn = parcelRequire("6BTmn");

var $jhYmN = parcelRequire("jhYmN");

var $b3Nht = parcelRequire("b3Nht");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $2JQfe = parcelRequire("2JQfe");

var $cNoBc = parcelRequire("cNoBc");

var $aIZjN = parcelRequire("aIZjN");

var $1A1H9 = parcelRequire("1A1H9");
const $8a40a2a4e874af05$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v17 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v18 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v19 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            v20 /*: any*/ 
        ]
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canBeExported"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canDownloadAttachment"
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    }, v23 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v24 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v25 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "resolutionPlanAssigneeProperty",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "jsm_resolution_plan_property"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "issuePropertyByKey",
                        "storageKey": "issuePropertyByKey(key:\"jsm_resolution_plan_property\")"
                    },
                    {
                        "concreteType": "JiraProjectField",
                        "kind": "LinkedField",
                        "name": "projectField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectType"
                                    },
                                    v10 /*: any*/ 
                                ]
                            },
                            v10 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "delegator",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            v14 /*: any*/ ,
                            v23 /*: any*/ ,
                            v24 /*: any*/ ,
                            v10 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "type"
    }, v27 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "text"
    }, v30 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v31 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            v29 /*: any*/ ,
            v14 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v14 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v14 /*: any*/ ,
                                    v10 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v35 = {
        "kind": "ScalarField",
        "name": "value"
    }, v36 = [
        v35 /*: any*/ ,
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v37 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v36 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v36 /*: any*/ 
                    }
                ]
            },
            v31 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
                    }
                ],
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v39 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v40 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v41 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "args": v39 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v41 /*: any*/ ,
                                    v10 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v31 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v43 = {
        "kind": "ScalarField",
        "name": "date"
    }, v44 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            v43 /*: any*/ ,
            v14 /*: any*/ ,
            v44 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v46 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            v46 /*: any*/ ,
            v14 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v48 = {
        "kind": "ScalarField",
        "name": "formattedText"
    }, v49 = {
        "kind": "ScalarField",
        "name": "number"
    }, v50 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v51 = [
        v14 /*: any*/ 
    ], v52 = [
        v14 /*: any*/ ,
        v10 /*: any*/ 
    ], v53 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v54 = [
        v9 /*: any*/ ,
        v23 /*: any*/ ,
        v14 /*: any*/ ,
        v24 /*: any*/ ,
        v10 /*: any*/ 
    ], v55 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v46 /*: any*/ ,
                    v48 /*: any*/ 
                ],
                "type": "JiraForgeDatetimeField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v43 /*: any*/ ,
                    v48 /*: any*/ 
                ],
                "type": "JiraForgeDateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v49 /*: any*/ ,
                    v48 /*: any*/ 
                ],
                "type": "JiraForgeNumberField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v29 /*: any*/ ,
                    v48 /*: any*/ 
                ],
                "type": "JiraForgeStringField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "args": v39 /*: any*/ ,
                        "concreteType": "JiraLabelConnection",
                        "kind": "LinkedField",
                        "name": "selectedLabelsConnection",
                        "plural": false,
                        "selections": [
                            v50 /*: any*/ ,
                            {
                                "concreteType": "JiraLabelEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraLabel",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v51 /*: any*/ 
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedLabelsConnection(first:1000)"
                    }
                ],
                "type": "JiraForgeStringsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "selectedGroup",
                        "plural": false,
                        "selections": v52 /*: any*/ 
                    }
                ],
                "type": "JiraForgeGroupField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v53 /*: any*/ ,
                                            v14 /*: any*/ ,
                                            v10 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraForgeGroupsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": v54 /*: any*/ 
                    }
                ],
                "type": "JiraForgeUserField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v54 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraForgeUsersField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v48 /*: any*/ 
                ],
                "type": "JiraForgeObjectField"
            }
        ]
    }, v56 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "start"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "end"
                    }
                ],
                "type": "JiraDateRangeField"
            }
        ]
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    v17 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v59 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    v59 /*: any*/ ,
                    v18 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            },
            v21 /*: any*/ 
        ],
        "type": "JiraStatusField"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategoryProgressConnection",
                "kind": "LinkedField",
                "name": "aggregatedStatusCategory",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraStatusCategoryProgressEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraStatusCategoryProgress",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v12 /*: any*/ ,
                                            v10 /*: any*/ 
                                        ]
                                    },
                                    v35 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAggregatedStatusField"
    }, v62 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v10 /*: any*/ 
        ]
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v39 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    v50 /*: any*/ ,
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v14 /*: any*/ ,
                                    v62 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v14 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v64 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v65 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v62 /*: any*/ ,
                            v10 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v64 /*: any*/ ,
                                    v14 /*: any*/ ,
                                    v10 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    v13 /*: any*/ 
                                ]
                            },
                            v10 /*: any*/ ,
                            v28 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v29 /*: any*/ ,
                            v10 /*: any*/ ,
                            v28 /*: any*/ 
                        ]
                    },
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v65 /*: any*/ ,
                    {
                        "concreteType": "JiraStatusField",
                        "kind": "LinkedField",
                        "name": "statusField",
                        "plural": false,
                        "selections": [
                            v10 /*: any*/ ,
                            v28 /*: any*/ ,
                            v19 /*: any*/ 
                        ]
                    }
                ]
            },
            v14 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraParentIssueField"
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v10 /*: any*/ 
                ]
            },
            v14 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    v12 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v52 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v70 = {
        "kind": "ScalarField",
        "name": "state"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v10 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v14 /*: any*/ ,
                                    v70 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v14 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v72 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v73 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isUser"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appType"
            }
        ],
        "type": "AppUser"
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v9 /*: any*/ ,
                    v14 /*: any*/ ,
                    v24 /*: any*/ ,
                    v72 /*: any*/ ,
                    v10 /*: any*/ ,
                    v23 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            v73 /*: any*/ ,
                            v74 /*: any*/ 
                        ]
                    },
                    v74 /*: any*/ 
                ]
            },
            v44 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v76 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "json"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v77 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    v64 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v78 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementOrganizationConnection",
                "kind": "LinkedField",
                "name": "selectedOrganizationsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraServiceManagementOrganizationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraServiceManagementOrganization",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v10 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "organizationName"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraServiceManagementOrganizationField"
    }, v79 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 50
                    }
                ],
                "concreteType": "JiraAgentSessionConnection",
                "kind": "LinkedField",
                "name": "agentSessions",
                "plural": false,
                "selections": [
                    v50 /*: any*/ ,
                    {
                        "concreteType": "JiraAgentSessionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAgentSession",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v9 /*: any*/ ,
                                    v70 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "agent",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v14 /*: any*/ ,
                                            v73 /*: any*/ ,
                                            v24 /*: any*/ ,
                                            v74 /*: any*/ ,
                                            v10 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "agentSessions(first:50)"
            }
        ],
        "type": "JiraAgentSessionsField"
    }, v80 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v50 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v65 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v9 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v18 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v10 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            {
                                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    v16 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v10 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v81 = {
        "kind": "ScalarField",
        "name": "formatStyle"
    }, v82 = {
        "kind": "ScalarField",
        "name": "formatUnit"
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v49 /*: any*/ ,
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    v81 /*: any*/ ,
                    v82 /*: any*/ 
                ]
            },
            v14 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v84 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v50 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v85 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v31 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v86 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v87 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    v62 /*: any*/ ,
                    v10 /*: any*/ ,
                    v86 /*: any*/ 
                ]
            },
            v31 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v88 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v10 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v86 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v31 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v89 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v90 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v89 /*: any*/ 
                        ]
                    }
                ]
            },
            v31 /*: any*/ 
        ],
        "type": "JiraCheckboxesField"
    }, v91 = {
        "concreteType": "JiraUserConnection",
        "kind": "LinkedField",
        "name": "selectedUsersConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            v23 /*: any*/ ,
                            v14 /*: any*/ ,
                            v24 /*: any*/ ,
                            v10 /*: any*/ ,
                            v72 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "email"
                                    }
                                ],
                                "type": "AtlassianAccountUser"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v92 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            v91 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v93 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v31 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v94 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTimeTrackingField",
                        "kind": "LinkedField",
                        "name": "timeTrackingField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "timeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingHoursPerDay"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingDaysPerWeek"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultFormat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultUnit"
                                    }
                                ]
                            },
                            v10 /*: any*/ ,
                            v28 /*: any*/ ,
                            v14 /*: any*/ ,
                            v26 /*: any*/ 
                        ]
                    },
                    v10 /*: any*/ 
                ]
            },
            v31 /*: any*/ 
        ],
        "type": "JiraOriginalTimeEstimateField"
    }, v95 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v10 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            },
            v31 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v96 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "args": v39 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v10 /*: any*/ ,
                                    v14 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v41 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v31 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v97 = [
        v10 /*: any*/ 
    ], v98 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v97 /*: any*/ 
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            v98 /*: any*/ ,
            {
                "args": v39 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v10 /*: any*/ ,
                                    v12 /*: any*/ ,
                                    v14 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "status"
                                    },
                                    {
                                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "isPrivate"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v21 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v20 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v100 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v14 /*: any*/ ,
                    v98 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isLinkEditable"
                    },
                    {
                        "concreteType": "JiraTownsquareProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            v10 /*: any*/ ,
                            {
                                "alias": "atlasProjectName",
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "alias": "atlasProjectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "privateProject"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPermission"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWorkspaceActive"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "iconName"
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isLinkInherited"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isParentLinked"
                            }
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraTownsquareProjectField"
            }
        ]
    }, v101 = {
        "kind": "ScalarField",
        "name": "href"
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "args": v39 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v10 /*: any*/ ,
                                    v101 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    v9 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v101 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v50 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v31 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v103 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v10 /*: any*/ ,
                                    v14 /*: any*/ ,
                                    v53 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v31 /*: any*/ 
        ],
        "type": "JiraMultipleGroupPickerField"
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraFlag",
                "kind": "LinkedField",
                "name": "flag",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFlagged"
                    }
                ]
            }
        ],
        "type": "JiraFlagField"
    }, v105 = {
        "kind": "ScalarField",
        "name": "count"
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraWatch",
                "kind": "LinkedField",
                "name": "watch",
                "plural": false,
                "selections": [
                    v105 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isWatching"
                    }
                ]
            }
        ],
        "type": "JiraWatchesField"
    }, v107 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v14 /*: any*/ ,
                    v49 /*: any*/ ,
                    {
                        "concreteType": "JiraNumberFieldFormatConfig",
                        "kind": "LinkedField",
                        "name": "formatConfig",
                        "plural": false,
                        "selections": [
                            v81 /*: any*/ ,
                            v82 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "durationUnits"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraNumberFormulaField"
            }
        ]
    }, v108 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v14 /*: any*/ ,
                    v29 /*: any*/ 
                ],
                "type": "JiraTextFormulaField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v46 /*: any*/ ,
                    v14 /*: any*/ 
                ],
                "type": "JiraDateFormulaField"
            }
        ]
    }, v109 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isMulti"
                    },
                    v91 /*: any*/ ,
                    v31 /*: any*/ 
                ],
                "type": "JiraPeopleField"
            }
        ]
    }, v110 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v62 /*: any*/ 
                ],
                "type": "JiraColorField"
            }
        ]
    }, v111 = [
        v105 /*: any*/ 
    ], v112 = {
        "kind": "ScalarField",
        "name": "stateCount"
    }, v113 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueDevSummary",
                "kind": "LinkedField",
                "name": "devSummary",
                "plural": false,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "branch",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueBranchDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": v111 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "commit",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueCommitDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": v111 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "pullrequest",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssuePullRequestDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                    v112 /*: any*/ ,
                                    v70 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "open"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "review",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueReviewDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                    v112 /*: any*/ ,
                                    v70 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "build",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueBuildDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                    v105 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "failedBuildCount"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "successfulBuildCount"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "unknownBuildCount"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "deploymentEnvironments",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": v111 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": v97 /*: any*/ 
                    },
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "JiraDevSummaryField"
    }, v114 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "durationInSeconds"
            },
            v29 /*: any*/ 
        ],
        "type": "JiraDurationField"
    }, v115 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementFeedback",
                "kind": "LinkedField",
                "name": "feedback",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "rating"
                    }
                ]
            }
        ],
        "type": "JiraServiceManagementRequestFeedbackField"
    }, v116 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementSla",
                "kind": "LinkedField",
                "name": "sla",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraServiceManagementSlaError",
                        "kind": "LinkedField",
                        "name": "error",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "errorCode"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "goalId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "timeMetricId"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraServiceManagementSlaGoalView",
                        "kind": "LinkedField",
                        "name": "goalView",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "paused"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "active"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "closed"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "failed"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "emergencyLevel"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "remainingTime"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraServiceManagementSlaField"
    }, v117 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v118 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v119 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "IssueTableView"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraListRow"
                                                        },
                                                        v16 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "summary"
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraListRow",
                                                                            "abstractKey": "__isJiraListRow"
                                                                        },
                                                                        v25 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraIssue"
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v25 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraIssue"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isHighlightedIssueRow"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraListRowEdge"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraListRowFieldSetConnection"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraListRowFieldSet"
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                v9 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v32 /*: any*/ ,
                                                                                                        v33 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueField",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                v37 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v42 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                v55 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                v57 /*: any*/ ,
                                                                                                                v58 /*: any*/ ,
                                                                                                                v60 /*: any*/ ,
                                                                                                                v61 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                v68 /*: any*/ ,
                                                                                                                v69 /*: any*/ ,
                                                                                                                v71 /*: any*/ ,
                                                                                                                v75 /*: any*/ ,
                                                                                                                v76 /*: any*/ ,
                                                                                                                v77 /*: any*/ ,
                                                                                                                v78 /*: any*/ ,
                                                                                                                v79 /*: any*/ ,
                                                                                                                v80 /*: any*/ ,
                                                                                                                v83 /*: any*/ ,
                                                                                                                v84 /*: any*/ ,
                                                                                                                v85 /*: any*/ ,
                                                                                                                v87 /*: any*/ ,
                                                                                                                v88 /*: any*/ ,
                                                                                                                v90 /*: any*/ ,
                                                                                                                v92 /*: any*/ ,
                                                                                                                v93 /*: any*/ ,
                                                                                                                v94 /*: any*/ ,
                                                                                                                v95 /*: any*/ ,
                                                                                                                v96 /*: any*/ ,
                                                                                                                v99 /*: any*/ ,
                                                                                                                v100 /*: any*/ ,
                                                                                                                v102 /*: any*/ ,
                                                                                                                v103 /*: any*/ ,
                                                                                                                v104 /*: any*/ ,
                                                                                                                v106 /*: any*/ ,
                                                                                                                v107 /*: any*/ ,
                                                                                                                v108 /*: any*/ ,
                                                                                                                v109 /*: any*/ ,
                                                                                                                v110 /*: any*/ ,
                                                                                                                v113 /*: any*/ ,
                                                                                                                v114 /*: any*/ ,
                                                                                                                v115 /*: any*/ ,
                                                                                                                v116 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraIssueField",
                                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v29 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraRemoteSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "avatarUrl"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "issueTypeName"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraRemoteIssueTypeField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityName"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityIconUrl"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraRemotePriorityField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "userDisplayName"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "avatarSmall"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraRemoteSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v59 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "statusName"
                                                                                                                        },
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraRemoteStatusField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": v51 /*: any*/ ,
                                                                                                                    "type": "JiraRemoteGenericField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraRemoteIssueField",
                                                                                                            "abstractKey": "__isJiraRemoteIssueField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v89 /*: any*/ ,
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v86 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                v79 /*: any*/ ,
                                                                                                                v37 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v42 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v46 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                                },
                                                                                                                v45 /*: any*/ ,
                                                                                                                v55 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                v108 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                v57 /*: any*/ ,
                                                                                                                v32 /*: any*/ ,
                                                                                                                v58 /*: any*/ ,
                                                                                                                v60 /*: any*/ ,
                                                                                                                v61 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                v68 /*: any*/ ,
                                                                                                                v69 /*: any*/ ,
                                                                                                                v71 /*: any*/ ,
                                                                                                                v75 /*: any*/ ,
                                                                                                                v76 /*: any*/ ,
                                                                                                                v77 /*: any*/ ,
                                                                                                                v78 /*: any*/ ,
                                                                                                                v80 /*: any*/ ,
                                                                                                                v83 /*: any*/ ,
                                                                                                                v84 /*: any*/ ,
                                                                                                                v85 /*: any*/ ,
                                                                                                                v87 /*: any*/ ,
                                                                                                                v88 /*: any*/ ,
                                                                                                                v90 /*: any*/ ,
                                                                                                                v92 /*: any*/ ,
                                                                                                                v93 /*: any*/ ,
                                                                                                                v94 /*: any*/ ,
                                                                                                                v95 /*: any*/ ,
                                                                                                                v96 /*: any*/ ,
                                                                                                                v99 /*: any*/ ,
                                                                                                                v100 /*: any*/ ,
                                                                                                                v102 /*: any*/ ,
                                                                                                                v103 /*: any*/ ,
                                                                                                                v104 /*: any*/ ,
                                                                                                                v106 /*: any*/ ,
                                                                                                                v107 /*: any*/ ,
                                                                                                                v109 /*: any*/ ,
                                                                                                                v110 /*: any*/ ,
                                                                                                                v113 /*: any*/ ,
                                                                                                                v114 /*: any*/ ,
                                                                                                                v115 /*: any*/ ,
                                                                                                                v116 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraIssueField",
                                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isJiraListRowFieldConnection"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                v21 /*: any*/ 
                                            ]
                                        },
                                        v117 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "pageSize",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": v118 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v118 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v118 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ 
                                    ],
                                    "type": "JiraListRowConnection",
                                    "abstractKey": "__isJiraListRowConnection"
                                }
                            ]
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetIds",
                                    "variableName": "fieldSetIds"
                                }
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v119 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "aliases"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldSetPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetPreferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "width"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "canBeConfigured"
                                                                                },
                                                                                v28 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isPlaceHolderField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v119 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v50 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v117 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9e3a37de46b3f6e9f3abf6e8bff38faf95a383326955c2a56071c1bb454e1d1d",
            "metadata": {},
            "name": "IssueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": (0, $1F2RS.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default)
            }
        }
    };
}();
$8a40a2a4e874af05$var$node.hash = "78397a7dc374c0a1e5d3b2c5219bdd18";
var $8a40a2a4e874af05$export$2e2bcd8739ae039 = $8a40a2a4e874af05$var$node;

});

parcelRegister("drTum", function(module, exports) {
$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $c8d296442e9d6667$export$700e212b8b5c678f);
/* eslint-disable jira/filename-case */ 
var $n67Vb = parcelRequire("n67Vb");

var $aI7em = parcelRequire("aI7em");

var $5SJ3N = parcelRequire("5SJ3N");

var $1LSE2 = parcelRequire("1LSE2");
async function $c8d296442e9d6667$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await (0, $1LSE2.transformToVariables)({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("1LSE2", function(module, exports) {
$parcel$export(module.exports, "transformToVariables", () => $d6ab99b22d12e563$export$a5cefa50115212b3);
/* eslint-disable jira/filename-case */ 
var $1zTEC = parcelRequire("1zTEC");

var $3U1bG = parcelRequire("3U1bG");

var $5xJGs = parcelRequire("5xJGs");

var $76F67 = parcelRequire("76F67");



const $d6ab99b22d12e563$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $1zTEC.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $3U1bG.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        fieldSetsInput: {
            fieldSetIds: columnNames
        },
        isNotFilterFetch: !filterAri,
        filterAri: filterAri
    };
    let fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
        const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
        fieldToJqlTermMap = result.fieldToJqlTermMap;
        jqlToModify = result.searchJql;
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    // This pulls in over 600KB of code, and if it's not deferred it's eagerly loaded as
    // part of the main jira-spa route map
    const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
        (parcelRequire("6999O")),
        (parcelRequire("8ubI4")),
        (parcelRequire("4mpfy"))
    ]);
    const jqlUtils = new JqlUtils();
    const jqlTermForSortField = (0, $76F67.getJqlTermForField)(sortField, fieldToJqlTermMap);
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $5xJGs.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        // Sometimes, oldPrimarySortField from the JQL has
        // quotations around it which we should include
        const inclusiveAliases = Array.from(new Set([
            ...aliases,
            oldPrimarySortField
        ]));
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = findClauseInAst(jast, 'statusCategory');
            if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};

});
parcelRegister("3U1bG", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $9af52965394d9174$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $9af52965394d9174$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $9af52965394d9174$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $9af52965394d9174$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $9af52965394d9174$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $9af52965394d9174$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $9af52965394d9174$export$83371d6c41a974aa);
$parcel$export(module.exports, "RESTORE_COLUMNS", () => $9af52965394d9174$export$3bfe53b79fc4f6ed);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $9af52965394d9174$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $9af52965394d9174$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $9af52965394d9174$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $9af52965394d9174$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $9af52965394d9174$export$e2bd4c1faded7921);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $9af52965394d9174$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $9af52965394d9174$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $9af52965394d9174$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $9af52965394d9174$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $9af52965394d9174$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $9af52965394d9174$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "COLUMN_ID_TIMELINE", () => $9af52965394d9174$export$244401c8eb936efd);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $9af52965394d9174$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "NON_MOVABLE_COLUMN_IDS", () => $9af52965394d9174$export$e9924824c5c0908c);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $9af52965394d9174$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $9af52965394d9174$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $9af52965394d9174$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $9af52965394d9174$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $9af52965394d9174$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $9af52965394d9174$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $9af52965394d9174$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $9af52965394d9174$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $9af52965394d9174$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $9af52965394d9174$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $9af52965394d9174$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH", () => $9af52965394d9174$export$54fb99171fb48426);
$parcel$export(module.exports, "MINIMUM_MERGED_CELL_COLUMN_WIDTH", () => $9af52965394d9174$export$787e40d1c5baf821);
$parcel$export(module.exports, "COLUMN_WIDTH_ASSIGNEE", () => $9af52965394d9174$export$49f5d64369d40b04);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $9af52965394d9174$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $9af52965394d9174$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $9af52965394d9174$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $9af52965394d9174$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $9af52965394d9174$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $9af52965394d9174$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $9af52965394d9174$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $9af52965394d9174$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $9af52965394d9174$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $9af52965394d9174$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $9af52965394d9174$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $9af52965394d9174$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $9af52965394d9174$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $9af52965394d9174$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $9af52965394d9174$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $9af52965394d9174$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $9af52965394d9174$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $9af52965394d9174$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $9af52965394d9174$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $9af52965394d9174$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $9af52965394d9174$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $9af52965394d9174$export$118b06a03e2c672f);
$parcel$export(module.exports, "INSTRUCTION_BLOCKED", () => $9af52965394d9174$export$71b8539e20744dab);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $9af52965394d9174$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $9af52965394d9174$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $9af52965394d9174$export$f92486d03c064eac);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $9af52965394d9174$export$6ba5aaedfd1b5319);
$parcel$export(module.exports, "SORT_A_TO_Z", () => $9af52965394d9174$export$1bc2edb2aa5e8282);
$parcel$export(module.exports, "SORT_Z_TO_A", () => $9af52965394d9174$export$c7b524b6c48f8273);
$parcel$export(module.exports, "SORT_LOWEST_TO_HIGHEST", () => $9af52965394d9174$export$9c60c93d5e95e80f);
$parcel$export(module.exports, "SORT_HIGHEST_TO_LOWEST", () => $9af52965394d9174$export$476f4bdd6eba4fb2);
$parcel$export(module.exports, "SORT_OLDEST_TO_NEWEST", () => $9af52965394d9174$export$fbcac9f513cf13f4);
$parcel$export(module.exports, "SORT_NEWEST_TO_OLDEST", () => $9af52965394d9174$export$d3c0241ce8ae9a73);
$parcel$export(module.exports, "Z_INDEX_STICKY_COLUMN", () => $9af52965394d9174$export$52078a2fcd02af21);
$parcel$export(module.exports, "SMALL_SCREEN_WIDTH", () => $9af52965394d9174$export$1c20094c5869d61e);
$parcel$export(module.exports, "EXTRA_SPACE_PER_LEVEL", () => $9af52965394d9174$export$107c825dc66c95b7);
$parcel$export(module.exports, "FIXED_POSITION_COLUMN_TYPES", () => $9af52965394d9174$export$a77fc985659ff0d1);
/* eslint-disable jira/filename-case */ 
var $7l6jM = parcelRequire("7l6jM");
const $9af52965394d9174$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $9af52965394d9174$export$d57b6b390e78d90f = 'empanada';
const $9af52965394d9174$export$88956207daf9a17e = 'ASC';
const $9af52965394d9174$export$bc14f97913aaf2a = 'DESC';
const $9af52965394d9174$export$9c424bf3e8ffe64e = 'NONE';
const $9af52965394d9174$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $9af52965394d9174$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $9af52965394d9174$export$3bfe53b79fc4f6ed = 'RESTORE_COLUMNS';
const $9af52965394d9174$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $9af52965394d9174$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $9af52965394d9174$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $9af52965394d9174$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $9af52965394d9174$export$e2bd4c1faded7921 = '1px';
const $9af52965394d9174$export$cdb7fd9d999c7168 = 40;
const $9af52965394d9174$export$88e6c5bab2ff80e8 = 40;
const $9af52965394d9174$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $9af52965394d9174$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $9af52965394d9174$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $9af52965394d9174$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $9af52965394d9174$export$244401c8eb936efd = 'timeline';
const $9af52965394d9174$export$3dbdc5c16825be4d = [
    $9af52965394d9174$export$c3266da279aa6b84,
    $9af52965394d9174$export$de4c02b525d877fa,
    $9af52965394d9174$export$66b2a4a5f67468ac,
    (0, $7l6jM.COLUMN_ID_MERGED_COLUMN)
];
const $9af52965394d9174$export$e9924824c5c0908c = [
    $9af52965394d9174$export$244401c8eb936efd,
    $9af52965394d9174$export$66b2a4a5f67468ac,
    (0, $7l6jM.COLUMN_ID_MERGED_COLUMN),
    $9af52965394d9174$export$de4c02b525d877fa
];
const $9af52965394d9174$export$a1c171a82c45d53f = 24;
const $9af52965394d9174$export$43ff8c492b8a2e1b = 24;
const $9af52965394d9174$export$9c5dd6078b37aac2 = 16;
const $9af52965394d9174$export$a8273d7d48e89fce = 24;
const $9af52965394d9174$export$7ec4af037f372df4 = 500;
const $9af52965394d9174$export$d2372dfbd4e91a11 = 50;
const $9af52965394d9174$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $9af52965394d9174$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $9af52965394d9174$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $9af52965394d9174$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $9af52965394d9174$export$7c3f559e2ca95fa = 170;
const $9af52965394d9174$export$e1a42c2fefb5af25 = 999;
const $9af52965394d9174$export$54fb99171fb48426 = 80;
const $9af52965394d9174$export$787e40d1c5baf821 = 180;
const $9af52965394d9174$export$49f5d64369d40b04 = 204;
const $9af52965394d9174$export$bfe09a9186b98f8f = 400;
const $9af52965394d9174$export$f2540f34b796306d = 300;
const $9af52965394d9174$export$954afb0fcf5a326 = 450;
const $9af52965394d9174$export$93758649595b2d58 = 'reorder';
const $9af52965394d9174$export$cad8c6a0b6e78898 = 'resize';
const $9af52965394d9174$export$5252387dc65db584 = -16;
const $9af52965394d9174$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $9af52965394d9174$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $9af52965394d9174$export$4e8abe16cd1126dd = 'rowReorder';
const $9af52965394d9174$export$6c0a5a77457ca62 = 'COMPACT';
const $9af52965394d9174$export$119d8ab9a5bc4b2 = 'FULL';
const $9af52965394d9174$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $9af52965394d9174$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $9af52965394d9174$export$e03155205bf92428 = 'loadChildItems';
const $9af52965394d9174$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $9af52965394d9174$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $9af52965394d9174$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $9af52965394d9174$export$70f80a241e016093 = 'createIssue';
const $9af52965394d9174$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $9af52965394d9174$export$5eb61e3ff74a4f58 = 'make-child';
const $9af52965394d9174$export$9213b5774112217f = 'reorder-above';
const $9af52965394d9174$export$118b06a03e2c672f = 'reorder-below';
const $9af52965394d9174$export$71b8539e20744dab = 'instruction-blocked';
const $9af52965394d9174$export$5b388ccfa29be01 = -1;
const $9af52965394d9174$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $9af52965394d9174$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $9af52965394d9174$export$6ba5aaedfd1b5319 = 2000;
const $9af52965394d9174$export$1bc2edb2aa5e8282 = 'a_to_z';
const $9af52965394d9174$export$c7b524b6c48f8273 = 'z_to_a';
const $9af52965394d9174$export$9c60c93d5e95e80f = 'lowest_to_highest';
const $9af52965394d9174$export$476f4bdd6eba4fb2 = 'highest_to_lowest';
const $9af52965394d9174$export$fbcac9f513cf13f4 = 'oldest_to_newest';
const $9af52965394d9174$export$d3c0241ce8ae9a73 = 'newest_to_oldest';
const $9af52965394d9174$export$52078a2fcd02af21 = 7;
const $9af52965394d9174$export$8de1f7a70e87463c = 8;
const $9af52965394d9174$export$954a5efb072cec80 = 10;
const $9af52965394d9174$export$1c20094c5869d61e = 1024;
const $9af52965394d9174$export$107c825dc66c95b7 = 4;
const $9af52965394d9174$export$a77fc985659ff0d1 = [
    $9af52965394d9174$export$244401c8eb936efd,
    $9af52965394d9174$export$de4c02b525d877fa
];

});
parcelRegister("7l6jM", function(module, exports) {
$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $3eccb35bbec6248f$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $3eccb35bbec6248f$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $3eccb35bbec6248f$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_MERGED_COLUMN", () => $3eccb35bbec6248f$export$3237751348c4f1b);
$parcel$export(module.exports, "MERGED_COLUMN_TYPES", () => $3eccb35bbec6248f$export$72f66561203b705c);
$parcel$export(module.exports, "MERGED_COLUMN_IDS", () => $3eccb35bbec6248f$export$70f30e260ec270f2);
$parcel$export(module.exports, "MERGED_COLUMN_DEFAULT_WIDTH", () => $3eccb35bbec6248f$export$6aa1d347deb86ef3);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $3eccb35bbec6248f$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $3eccb35bbec6248f$export$39ec48f092f3ea90);
/* eslint-disable jira/filename-case */ const $3eccb35bbec6248f$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    TIMELINE: 'timeline',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    MERGED_COLUMN: '__issuetable_internal_merged_column',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
    ATLAS_PROJECT: 'com.atlassian.jira.plugin.system.customfieldtypes:atlas-project',
    RELATIONSHIP: 'issueLinkRelationshipType'
};
const $3eccb35bbec6248f$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $3eccb35bbec6248f$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $3eccb35bbec6248f$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $3eccb35bbec6248f$export$3237751348c4f1b = '__issuetable_internal_merged_column';
const $3eccb35bbec6248f$export$72f66561203b705c = [
    $3eccb35bbec6248f$export$bbc2e8c301f97f97.ISSUE_TYPE,
    $3eccb35bbec6248f$export$bbc2e8c301f97f97.ISSUE_KEY,
    $3eccb35bbec6248f$export$bbc2e8c301f97f97.SUMMARY
];
const $3eccb35bbec6248f$export$70f30e260ec270f2 = [
    'issuetype',
    'issuekey',
    'summary'
];
const $3eccb35bbec6248f$export$6aa1d347deb86ef3 = 64; // 24 * 2 (two icons) + 8*2 (horizontal padding)
const $3eccb35bbec6248f$export$fae6afe554014a45 = 'NIN_PROJECT';
const $3eccb35bbec6248f$export$39ec48f092f3ea90 = 'NIN_GLOBAL';

});


parcelRegister("5xJGs", function(module, exports) {
$parcel$export(module.exports, "getAliasesForField", () => $43c2f1ab19855c0f$export$94d69942fbe58a01);
/* eslint-disable jira/filename-case */ const $43c2f1ab19855c0f$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("76F67", function(module, exports) {
$parcel$export(module.exports, "getJqlTermForField", () => $893fe518e30d844e$export$ef4e8b2c9bc7bd4d);
/* eslint-disable jira/filename-case */ 
var $czfho = parcelRequire("czfho");
const $893fe518e30d844e$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
    const convertedField = (0, $czfho.convertFieldToJqlTerm)(field);
    const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
    return jqlTermForField;
};

});
parcelRegister("czfho", function(module, exports) {
$parcel$export(module.exports, "convertFieldToJqlTerm", () => $022da4ee34bc8fe0$export$29f734dc2c61ea9d);
/* eslint-disable jira/filename-case */ const $022da4ee34bc8fe0$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});


parcelRegister("6999O", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("htXgU").then(()=>parcelRequire('biOfq'));

});

parcelRegister("8ubI4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l0Um1").then(()=>parcelRequire('aBxYW'));

});

parcelRegister("4mpfy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gXCeo").then(()=>parcelRequire('hSb7W'));

});



parcelRegister("fOuVC", function(module, exports) {
$parcel$export(module.exports, "transformToValidUserPrefs", () => $481640af1dcf866d$export$e9345b021afd3cc3);
/* eslint-disable jira/filename-case */ 
var $lpNha = parcelRequire("lpNha");

var $2CyoQ = parcelRequire("2CyoQ");

var $k8DWc = parcelRequire("k8DWc");
const $481640af1dcf866d$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const fieldSetIds = (0, $lpNha.convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $2CyoQ.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: (0, $k8DWc.isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};

});
parcelRegister("lpNha", function(module, exports) {
$parcel$export(module.exports, "convertUserPrefsToColumnNames", () => $ee7b62aab7bca0b9$export$6e5cdc232ebb20cf);
/* eslint-disable jira/filename-case */ 
var $eFL00 = parcelRequire("eFL00");

const $ee7b62aab7bca0b9$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $8f218d8a51f50a77$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $8f218d8a51f50a77$export$952287cc7aef3a4c), (0, $8f218d8a51f50a77$export$a3d4af30107c4f4d))) : (0, $eFL00.ISSUE_SEARCH_DEFAULT_COLUMNS);

});
/* eslint-disable jira/filename-case */ const $8f218d8a51f50a77$export$dd03181e30c7d559 = 5;
const $8f218d8a51f50a77$export$a3d4af30107c4f4d = '|';
const $8f218d8a51f50a77$export$952287cc7aef3a4c = '%7C';


parcelRegister("2CyoQ", function(module, exports) {
$parcel$export(module.exports, "getSortFieldAndDirection", () => $72980def0cc95d4d$export$e535bb2dfaa4d10b);
/* eslint-disable jira/filename-case */ const $72980def0cc95d4d$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});

parcelRegister("k8DWc", function(module, exports) {
$parcel$export(module.exports, "isFilterId", () => $f97bd5ea97a8a71d$export$23be85030bd58047);
/* eslint-disable jira/filename-case */ // this is copied from NIN https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/jira/src/packages/issue-navigator/actions-common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a
const $f97bd5ea97a8a71d$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});




parcelRegister("e6LU4", function(module, exports) {
$parcel$export(module.exports, "REACT_KEY", () => $40e8e95ea0c272d8$export$e0e89108956f58f6);
/* eslint-disable jira/filename-case */ // React gadget keys
const $40e8e95ea0c272d8$export$c8ae0b83405368ed = 'react/filter-results';
const $40e8e95ea0c272d8$var$REACT_KEY_ASSIGNED_TO_ME = 'react/assigned-to-me';
const $40e8e95ea0c272d8$var$REACT_KEY_ISSUES_IN_PROGRESS = 'react/issues-in-progress';
const $40e8e95ea0c272d8$var$REACT_KEY_VOTED_ISSUES = 'react/voted-issues';
const $40e8e95ea0c272d8$var$REACT_KEY_WATCHED_ISSUES = 'react/watched-issues';
const $40e8e95ea0c272d8$var$REACT_KEY_CUSTOM_REPORT = 'react/custom-report';
const $40e8e95ea0c272d8$export$e0e89108956f58f6 = {
    FILTER_RESULTS: $40e8e95ea0c272d8$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $40e8e95ea0c272d8$var$REACT_KEY_ASSIGNED_TO_ME,
    ISSUES_IN_PROGRESS: $40e8e95ea0c272d8$var$REACT_KEY_ISSUES_IN_PROGRESS,
    VOTED_ISSUES: $40e8e95ea0c272d8$var$REACT_KEY_VOTED_ISSUES,
    WATCHED_ISSUES: $40e8e95ea0c272d8$var$REACT_KEY_WATCHED_ISSUES,
    CUSTOM_REPORT: $40e8e95ea0c272d8$var$REACT_KEY_CUSTOM_REPORT
};

});




parcelRegister("eDauF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c551250e10ecb13$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $1c551250e10ecb13$var$getGadgetDirectoryData = async ()=>(0, $h2wCv.performGetRequest)('/rest/config/1.0/directoryitems.json');
var $1c551250e10ecb13$export$2e2bcd8739ae039 = $1c551250e10ecb13$var$getGadgetDirectoryData;

});

parcelRegister("chwBs", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bf3d8839b261fa9$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $e4bby = parcelRequire("e4bby");

var $8RWGq = parcelRequire("8RWGq");

var $gPdnf = parcelRequire("gPdnf");

var $LGEHY = parcelRequire("LGEHY");
const $0bf3d8839b261fa9$var$getReactGadgetsData = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, storeContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $gPdnf.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $8RWGq.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $e4bby.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $LGEHY.loadReactGadgets)(gadgetsToLoad, storeContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };
var $0bf3d8839b261fa9$export$2e2bcd8739ae039 = $0bf3d8839b261fa9$var$getReactGadgetsData;

});
parcelRegister("e4bby", function(module, exports) {
$parcel$export(module.exports, "isGadgetConfigured", () => $0cc827db1c6c442d$export$b625fae487818738);
/* eslint-disable jira/filename-case */ const $0cc827db1c6c442d$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("LGEHY", function(module, exports) {
$parcel$export(module.exports, "loadReactGadgets", () => $fcbd494d2cca1084$export$7e1a3455761184a2);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $8RWGq = parcelRequire("8RWGq");
const $fcbd494d2cca1084$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $8RWGq.default)[reactKey].preload();
    });
const $fcbd494d2cca1084$export$7e1a3455761184a2 = async (gadgets, storeContext)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $fcbd494d2cca1084$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $8RWGq.default)[reactKey]?.getInitialState(storeContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});



parcelRegister("3TTqW", function(module, exports) {
$parcel$export(module.exports, "dashboardBackgroundScriptsLayout", () => $07e6655c34c094fb$export$f0a12e66953aa38a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");

var $dSGK0 = parcelRequire("dSGK0");
const $07e6655c34c094fb$export$f0a12e66953aa38a = (0, $QhQu4.createLayout)({
    globalComponents: [
        (0, $dSGK0.DashboardBackgroundScripts)
    ]
});

});
parcelRegister("dSGK0", function(module, exports) {
$parcel$export(module.exports, "DashboardBackgroundScripts", () => $2ee275084755c506$export$4095842bb2e8d712);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ergOR = parcelRequire("ergOR");
const $2ee275084755c506$export$4095842bb2e8d712 = (0, $ergOR.LazyForPaintBackgroundScripts);

});
parcelRegister("ergOR", function(module, exports) {
$parcel$export(module.exports, "LazyForPaintBackgroundScripts", () => $311f2d59d26a5488$export$b5c9ccba15f81486);
/* eslint-disable jira/filename-case */ 
var $l8G1z = parcelRequire("l8G1z");

const $311f2d59d26a5488$export$b5c9ccba15f81486 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("99ACO")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard-background-scripts/src/ui/index.tsx"
});

});
parcelRegister("99ACO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ctXeP").then(()=>parcelRequire('kT1ko'));

});




parcelRegister("iXPKM", function(module, exports) {
$parcel$export(module.exports, "dashboardEditRoute", () => $c495aac1bbd7032f$export$b6e00d2cd7369fbd);
const $c495aac1bbd7032f$export$b6e00d2cd7369fbd = {
    name: 'dashboard-edit',
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("h3uMu", function(module, exports) {
$parcel$export(module.exports, "nav4DashboardsContentEntryPoint", () => $ad3b38cedfe1bf31$export$d6e6956d3748383b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $2700E = parcelRequire("2700E");

var $bZhC2 = parcelRequire("bZhC2");

var $2NSbF = parcelRequire("2NSbF");

var $i860n = parcelRequire("i860n");

var $18sMq = parcelRequire("18sMq");

var $3gt6d = parcelRequire("3gt6d");

const $ad3b38cedfe1bf31$export$d6e6956d3748383b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("86Y7Z")), {
        moduleId: "a69e7d05",
        moduleName: "DashboardsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        const activationId = params.tenantContext?.activationId || '';
        const entityAri = (0, $i860n.fg)('navx-3660-fix-l2-l3-aris') ? (0, $18sMq.NavigationSettingAri).create({
            activationId: activationId,
            firstPartyApp: 'jira',
            settingId: 'dashboards',
            siteId: cloudId
        }).toString() : (0, $bZhC2.JiraNavigationSettingsAri).create({
            siteId: cloudId,
            activationId: activationId,
            navigationSettingScope: 'dashboards'
        }).toString();
        const variables = (0, $2700E.expVal)('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false) ? {
            cloudId: cloudId,
            entityAri: entityAri,
            ownerAri: (0, $2NSbF.IdentityUserAri).create({
                userId: params.tenantContext.atlassianAccountId || 'UNKNOWN'
            }).toString(),
            skipOrderQuery: false
        } : {
            cloudId: cloudId,
            entityAri: '',
            ownerAri: '',
            skipOrderQuery: true
        };
        return {
            queries: {
                queryRef: {
                    parameters: $3gt6d.default,
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("3gt6d", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee302eb08d354d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dbd9293ea2c79ee86433f1d2f7015c2f>>
 * @relayHash 311c9dffc02e35e7b4c37a7c8b869632
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 214ce34788d14912ea301df0b8051a7f4bec4b09f0e5726604cfbef225f113c1
const $6ee302eb08d354d3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "214ce34788d14912ea301df0b8051a7f4bec4b09f0e5726604cfbef225f113c1",
        "metadata": {},
        "name": "DashboardsContentViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6ee302eb08d354d3$export$2e2bcd8739ae039 = $6ee302eb08d354d3$var$node;

});

parcelRegister("86Y7Z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lQCfJ").then(()=>parcelRequire('8Yoty'));

});


parcelRegister("bd0Ph", function(module, exports) {
$parcel$export(module.exports, "dashboardEditEntryPoint", () => $663487d814266cb1$export$eb39305ec6fcebf1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $663487d814266cb1$export$eb39305ec6fcebf1 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2o1A8")), {
        moduleId: "17998506",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("2o1A8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5I9Ot").then(()=>parcelRequire('ifBPf'));

});


parcelRegister("cHkmB", function(module, exports) {
$parcel$export(module.exports, "dashboardResources", () => $5213e748fff18e26$export$50d95db618f58349);
$parcel$export(module.exports, "LazyDashboardView", () => $5213e748fff18e26$export$c3bf98706b62de2b);
$parcel$export(module.exports, "LazyDashboardViewEmbed", () => $5213e748fff18e26$export$94d85118d282a15);
$parcel$export(module.exports, "LazySystemDashboardEdit", () => $5213e748fff18e26$export$c8d59d34c3e8f345);
$parcel$export(module.exports, "LazyForPaintBackgroundScripts", () => $5213e748fff18e26$export$b5c9ccba15f81486);
$parcel$export(module.exports, "LazyForPaintConnectJsApi", () => $5213e748fff18e26$export$aba403674a33dc61);
$parcel$export(module.exports, "DashboardViewEmbedPage", () => $5213e748fff18e26$export$86d9f777f9d4e312);
$parcel$export(module.exports, "SystemDashboardEditPage", () => $5213e748fff18e26$export$dcd19a888f8c85c);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dv1xk = parcelRequire("dv1xk");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");
const $5213e748fff18e26$export$50d95db618f58349 = ()=>[
        (0, $dv1xk.dashboardConfigAndWRMResource),
        (0, $dv1xk.dashboardAMDModulesResource),
        (0, $dv1xk.dashboardReactGadgetsResource),
        (0, $dv1xk.dashboardForgeResource)
    ];

const $5213e748fff18e26$export$c3bf98706b62de2b = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)(// eslint-disable-next-line jira/import/file-extension-required
    (parcelRequire("l0wVw"))), {
    moduleId: "./src/packages/global-pages/dashboard-view/src/index.tsx"
});

const $5213e748fff18e26$export$94d85118d282a15 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)(// eslint-disable-next-line jira/import/file-extension-required
    (parcelRequire("j2CqJ"))), {
    moduleId: "./src/packages/global-pages/dashboard-view-embed/src/index.tsx"
});

const $5213e748fff18e26$export$c8d59d34c3e8f345 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("50mzw"))), {
    moduleId: "./src/packages/spa-apps/dashboard-system-dashboard-edit/src/SystemDashboard.tsx"
});

const $5213e748fff18e26$export$b5c9ccba15f81486 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("99ACO")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard-background-scripts/src/ui/index.tsx"
});

const $5213e748fff18e26$export$aba403674a33dc61 = (0, $l8G1z.lazyForPaint)(// oxlint-disable-line @typescript-eslint/no-explicit-any
()=>(parcelRequire("hN4ZQ")), {
    ssr: false,
    moduleId: "./src/packages/platform/connect/src/loader.tsx"
});
const $5213e748fff18e26$export$86d9f777f9d4e312 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5213e748fff18e26$export$94d85118d282a15,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
$5213e748fff18e26$export$86d9f777f9d4e312.displayName = "DashboardViewEmbedPage";
const $5213e748fff18e26$export$dcd19a888f8c85c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5213e748fff18e26$export$c8d59d34c3e8f345,
        pageId: "system-dashboard-edit",
        shouldShowSpinner: false
    });
$5213e748fff18e26$export$dcd19a888f8c85c.displayName = "SystemDashboardEditPage";

});
parcelRegister("l0wVw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gRqt4")
]).then(()=>parcelRequire('eexkR'));

});

parcelRegister("j2CqJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jSAYA").then(()=>parcelRequire('6ixHm'));

});

parcelRegister("50mzw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g2H2p").then(()=>parcelRequire('a4xZ3'));

});

parcelRegister("hN4ZQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Loyv").then(()=>parcelRequire('6vmu6'));

});



parcelRegister("cNKzQ", function(module, exports) {
$parcel$export(module.exports, "dashboardRouteEntry", () => $66b90023ed7b702a$export$9fbbaafb58999ac3);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");


var $3HYSN = parcelRequire("3HYSN");

var $7XVba = parcelRequire("7XVba");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $aFR7D = parcelRequire("aFR7D");

var $lo4Xx = parcelRequire("lo4Xx");

var $cHkmB = parcelRequire("cHkmB");
const $66b90023ed7b702a$export$9fbbaafb58999ac3 = (0, $fdS54.createEntry)((0, $aFR7D.dashboardRoute), ()=>({
        group: 'dashboard',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lo4Xx.DashboardRedirect),
        layout: (0, $7XVba.homepageLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $cHkmB.dashboardResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cHkmB.LazyDashboardView)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7XVba", function(module, exports) {
$parcel$export(module.exports, "homepageLayout", () => $298e0df6805d49eb$export$5b7fb151d60504c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bqxMM = parcelRequire("bqxMM");

var $h2tgz = parcelRequire("h2tgz");

var $QhQu4 = parcelRequire("QhQu4");
const $298e0df6805d49eb$export$5b7fb151d60504c = (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), {
    // both of the components are wrapped with componentWithCondition
    globalComponents: [
        (0, $bqxMM.AsyncTransitionHomeRenderer),
        (0, $bqxMM.AsyncWelcomeModalRenderer)
    ]
});

});
parcelRegister("bqxMM", function(module, exports) {
$parcel$export(module.exports, "AsyncTransitionHomeRenderer", () => $97ca72708e60328c$export$cb38f5a820347580);
$parcel$export(module.exports, "AsyncWelcomeModalRenderer", () => $97ca72708e60328c$export$9cda67d6c86d7b98);
$parcel$export(module.exports, "eocChangeboardingLayout", () => $97ca72708e60328c$export$b8fa7ac7019001bb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

var $jepRN = parcelRequire("jepRN");

const $97ca72708e60328c$export$cb38f5a820347580 = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("htxxN")).then((module)=>module.TransitionHomeRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
});
$97ca72708e60328c$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';

const $97ca72708e60328c$export$9cda67d6c86d7b98 = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("GFrtx")).then((module)=>module.WelcomeModalRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
});
$97ca72708e60328c$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';

const $97ca72708e60328c$export$913f5a2340406083 = (0, $jepRN.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("gE0l9")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$97ca72708e60328c$export$913f5a2340406083.displayName = 'MigrationHubRightSidebar';

const $97ca72708e60328c$export$6d7715b12d3ad17b = (0, $jepRN.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("bqfVH")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$97ca72708e60328c$export$6d7715b12d3ad17b.displayName = 'MigrationHubOnboarding';
const $97ca72708e60328c$export$b8fa7ac7019001bb = (0, $QhQu4.createLayout)({
    get globalComponents () {
        return [
            $97ca72708e60328c$export$cb38f5a820347580,
            $97ca72708e60328c$export$9cda67d6c86d7b98,
            $97ca72708e60328c$export$6d7715b12d3ad17b
        ];
    },
    rightSidebars: [
        $97ca72708e60328c$export$913f5a2340406083
    ]
});

});
parcelRegister("htxxN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("1QRBy")
]).then(()=>parcelRequire('gLbMG'));

});

parcelRegister("GFrtx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("7HLLQ")
]).then(()=>parcelRequire('9n0lx'));

});

parcelRegister("gE0l9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fvsR9").then(()=>parcelRequire('gPnqF'));

});

parcelRegister("bqfVH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gRdRu").then(()=>parcelRequire('aF16G'));

});



parcelRegister("aFR7D", function(module, exports) {
$parcel$export(module.exports, "dashboardRoute", () => $9383b203e5ffc087$export$3bf0ecb39349b6ef);
const $9383b203e5ffc087$export$3bf0ecb39349b6ef = {
    name: 'dashboard',
    path: '/secure/Dashboard.jspa'
};

});

parcelRegister("lo4Xx", function(module, exports) {
$parcel$export(module.exports, "DashboardRedirect", () => $c3b8f2e7c7fcdce4$export$da833ddcffcc38ba);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4Onaa = parcelRequire("4Onaa");

var $dLVGe = parcelRequire("dLVGe");

var $881dx = parcelRequire("881dx");
var $bc9Gj = parcelRequire("bc9Gj");
const $c3b8f2e7c7fcdce4$export$da833ddcffcc38ba = ()=>{
    const [{ query: query, location: { hash: hash } }] = (0, $bc9Gj.useRouter)();
    const { path: path } = (0, $4Onaa.useRouteByName)('dashboard-view') ?? {};
    if (path == null) throw new Error('Dashboard view route not found');
    const { selectPageId: id } = query;
    const idParam = /^\d+$/.test(id) ? id : 'last-visited';
    const generatedPath = (0, $881dx.generatePath)(path, {
        dashboardId: idParam
    });
    const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: pathWithQuery,
        persistSearchParams: false
    });
};
$c3b8f2e7c7fcdce4$export$da833ddcffcc38ba.displayName = "DashboardRedirect";

});


parcelRegister("cMk4h", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRedirectRouteEntry", () => $8031a10ca30e13d9$export$8dae8091f8e43b97);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $4QWXP = parcelRequire("4QWXP");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dvXVH = parcelRequire("dvXVH");

var $dLVGe = parcelRequire("dLVGe");

var $85jAF = parcelRequire("85jAF");

var $bOHd0 = parcelRequire("bOHd0");
const $8031a10ca30e13d9$var$DashboardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/dashboards"
    });
$8031a10ca30e13d9$var$DashboardsDirectoryRedirect.displayName = "DashboardsDirectoryRedirect";
const $8031a10ca30e13d9$export$8dae8091f8e43b97 = (0, $fdS54.createEntry)((0, $dvXVH.dashboardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $4QWXP.dashboardsDirectoryResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: !false ? $8031a10ca30e13d9$var$DashboardsDirectoryRedirect : (0, $bOHd0.DashboardsDirectoryComponent),
        skeleton: (0, $85jAF.DashboardsDirectorySkeleton),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bOHd0.LazyDashboardsDirectory)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4QWXP", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryResource", () => $822b8ccaa5604cfc$export$1cf6c7815471c2a2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $822b8ccaa5604cfc$var$MIN_MAX_AGE = 5000;
const $822b8ccaa5604cfc$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';

const $822b8ccaa5604cfc$export$1cf6c7815471c2a2 = (0, $7edbf.createResource)({
    type: $822b8ccaa5604cfc$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("3rcGe")),
    maxAge: $822b8ccaa5604cfc$var$MIN_MAX_AGE
});

});
parcelRegister("3rcGe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fPstK").then(()=>parcelRequire('iCnvC'));

});


parcelRegister("dvXVH", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $cebc43833b3beb1e$export$b96f6fb3c35a6fe5);
const $cebc43833b3beb1e$export$b96f6fb3c35a6fe5 = {
    name: 'dashboards-directory-secure',
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("bOHd0", function(module, exports) {
$parcel$export(module.exports, "LazyDashboardsDirectory", () => $2646fc2ffb86ab92$export$f2f3fd22cd37e121);
$parcel$export(module.exports, "DashboardsDirectoryComponent", () => $2646fc2ffb86ab92$export$1cc6cc01050e1215);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $2646fc2ffb86ab92$export$f2f3fd22cd37e121 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("aURA3"))), {
    moduleId: "./src/packages/spa-apps/directories-dashboards/src/DashboardsDirectoryType.tsx"
});
const $2646fc2ffb86ab92$export$1cc6cc01050e1215 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $2646fc2ffb86ab92$export$f2f3fd22cd37e121,
        pageId: "dashboards-directory",
        shouldShowSpinner: false
    });
$2646fc2ffb86ab92$export$1cc6cc01050e1215.displayName = "DashboardsDirectoryComponent";

});
parcelRegister("aURA3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("byw7s")
]).then(()=>parcelRequire('eHaLP'));

});



parcelRegister("5ODMu", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $3d1bba25de725a90$export$748e329bd0c282a);
/* eslint-disable import/order */ 
var $hi6Of = parcelRequire("hi6Of");



var $iv3q3 = parcelRequire("iv3q3");

var $4QWXP = parcelRequire("4QWXP");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $2PK8N = parcelRequire("2PK8N");

var $85jAF = parcelRequire("85jAF");

var $dTa0V = parcelRequire("dTa0V");

var $iHNG5 = parcelRequire("iHNG5");

var $h3uMu = parcelRequire("h3uMu");

var $eDEQ5 = parcelRequire("eDEQ5");

var $i860n = parcelRequire("i860n");
const $3d1bba25de725a90$export$748e329bd0c282a = (0, $fdS54.createEntry)((0, $2PK8N.dashboardsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? $3d1bba25de725a90$var$GSNPageEntryPoint : $3d1bba25de725a90$var$pageEntryPoint,
        skeleton: (0, $85jAF.DashboardsDirectorySkeleton),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)((0, $i860n.fg)('navx-global-side-nav') ? {
                isUsingSidebarEntrypoint: true
            } : undefined),
            (0, $4QWXP.dashboardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));
// Page entrypoint, referred to above...
const $3d1bba25de725a90$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $iv3q3.dashboardDirectoryEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h3uMu.nav4DashboardsContentEntryPoint)
            }
        }
    },
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $3d1bba25de725a90$var$GSNPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $iv3q3.dashboardDirectoryEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h3uMu.nav4DashboardsContentEntryPoint)
            }
        }
    },
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("iv3q3", function(module, exports) {
$parcel$export(module.exports, "dashboardDirectoryEntryPoint", () => $2867e531f69b769a$export$3325d832741ebeb3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $2867e531f69b769a$export$3325d832741ebeb3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("aURA3")), {
        moduleId: "43c01393",
        moduleName: "DashboardsDirectoryType",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});

parcelRegister("2PK8N", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $bbf238812ba5326c$export$41bba408475cab16);
const $bbf238812ba5326c$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("gfTDK", function(module, exports) {
$parcel$export(module.exports, "dashboardViewEmbedRouteEntry", () => $ba6fc5e00b39ab29$export$73a377380ff671af);
/* eslint-disable import/order */ 
var $dSGK0 = parcelRequire("dSGK0");


var $3HYSN = parcelRequire("3HYSN");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $4B518 = parcelRequire("4B518");

var $ky5GW = parcelRequire("ky5GW");

var $cHkmB = parcelRequire("cHkmB");
const $ba6fc5e00b39ab29$export$73a377380ff671af = (0, $fdS54.createEntry)((0, $ky5GW.dashboardViewEmbedRoute), ()=>({
        group: 'dashboard',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cHkmB.DashboardViewEmbedPage),
        layout: (0, $QhQu4.createLayout)({
            globalComponents: [
                (0, $dSGK0.DashboardBackgroundScripts)
            ],
            isChromeless: true
        }),
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            ...(0, $cHkmB.dashboardResources)()
        ],
        forPaint: [
            (0, $cHkmB.LazyDashboardViewEmbed),
            (0, $cHkmB.LazyForPaintBackgroundScripts),
            (0, $cHkmB.LazyForPaintConnectJsApi)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ky5GW", function(module, exports) {
$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $18c897a8c4db84a3$export$258b5e3f294617d2);
const $18c897a8c4db84a3$export$258b5e3f294617d2 = {
    name: 'dashboard-view-embed',
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};

});


parcelRegister("40AJ4", function(module, exports) {
$parcel$export(module.exports, "dashboardViewRouteEntry", () => $f2383d4cc37da60a$export$18226b6422149926);
/* eslint-disable import/order */ 
var $hi6Of = parcelRequire("hi6Of");



var $3TTqW = parcelRequire("3TTqW");


var $3HYSN = parcelRequire("3HYSN");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $dLwpZ = parcelRequire("dLwpZ");

var $9WPsD = parcelRequire("9WPsD");

var $dTa0V = parcelRequire("dTa0V");

var $iHNG5 = parcelRequire("iHNG5");

var $eDEQ5 = parcelRequire("eDEQ5");

var $h3uMu = parcelRequire("h3uMu");

var $i860n = parcelRequire("i860n");

var $cHkmB = parcelRequire("cHkmB");
const $f2383d4cc37da60a$export$18226b6422149926 = (0, $fdS54.createEntry)((0, $dLwpZ.dashboardViewRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? $f2383d4cc37da60a$var$GSNPageEntryPoint : $f2383d4cc37da60a$var$pageEntryPoint,
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $3TTqW.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)((0, $i860n.fg)('navx-global-side-nav') ? {
                isUsingSidebarEntrypoint: true
            } : undefined),
            ...(0, $cHkmB.dashboardResources)()
        ],
        forPaint: [
            (0, $cHkmB.LazyForPaintBackgroundScripts),
            (0, $cHkmB.LazyForPaintConnectJsApi)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        ufoName: 'dashboard',
        supportsPreviewPanel: true,
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));
const $f2383d4cc37da60a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9WPsD.dashboardViewEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h3uMu.nav4DashboardsContentEntryPoint)
            }
        }
    },
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $f2383d4cc37da60a$var$GSNPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9WPsD.dashboardViewEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h3uMu.nav4DashboardsContentEntryPoint)
            }
        }
    },
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("dLwpZ", function(module, exports) {
$parcel$export(module.exports, "dashboardViewRoute", () => $1899449aa5df38dd$export$24f1b2ff97b9d3e6);
const $1899449aa5df38dd$export$24f1b2ff97b9d3e6 = {
    name: 'dashboard-view',
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("9WPsD", function(module, exports) {
$parcel$export(module.exports, "dashboardViewEntryPoint", () => $5bf780b81c471d54$export$acd33fbfe610d0e6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $5bf780b81c471d54$export$acd33fbfe610d0e6 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("l0wVw")), {
        moduleId: "9aa1d6bf",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("KJMPg", function(module, exports) {
$parcel$export(module.exports, "dashboardWallboardRouteEntry", () => $d3bce440a9896d93$export$6009dd8e88f1a7de);
/* eslint-disable import/order */ 
var $dSGK0 = parcelRequire("dSGK0");


var $3HYSN = parcelRequire("3HYSN");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $4B518 = parcelRequire("4B518");

var $9ycNa = parcelRequire("9ycNa");

var $dTa0V = parcelRequire("dTa0V");

var $iJwCk = parcelRequire("iJwCk");

var $cHkmB = parcelRequire("cHkmB");
const $d3bce440a9896d93$export$6009dd8e88f1a7de = (0, $fdS54.createEntry)((0, $9ycNa.dashboardWallboardRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$d3bce440a9896d93$var$dashboardWallboardPageEntryPoint,
        layout: (0, $QhQu4.createLayout)({
            globalComponents: [
                (0, $dSGK0.DashboardBackgroundScripts)
            ],
            // we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
            isChromeless: true
        }),
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            ...(0, $cHkmB.dashboardResources)()
        ],
        forPaint: [
            (0, $cHkmB.LazyForPaintBackgroundScripts),
            (0, $cHkmB.LazyForPaintConnectJsApi)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));
const $d3bce440a9896d93$var$dashboardWallboardPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $iJwCk.dashboardWallboardEntryPoint)
});

});
parcelRegister("9ycNa", function(module, exports) {
$parcel$export(module.exports, "dashboardWallboardRoute", () => $5db2fc8b7ff89b9f$export$eaa33c953ab9ca63);
const $5db2fc8b7ff89b9f$export$eaa33c953ab9ca63 = {
    name: 'dashboard-wallboard',
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};

});

parcelRegister("iJwCk", function(module, exports) {
$parcel$export(module.exports, "dashboardWallboardEntryPoint", () => $114e80026e2c70b2$export$99f21964c00b61ef);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $114e80026e2c70b2$export$99f21964c00b61ef = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("bmceC")), {
        moduleId: "689af155",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("bmceC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kbJHj").then(()=>parcelRequire('5rblc'));

});



parcelRegister("6RjSU", function(module, exports) {
$parcel$export(module.exports, "devopsConnectedProjectRouteEntry", () => $06016a2a7e1da1ee$export$ae258fb8ec2c1f86);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $1i6Wj = parcelRequire("1i6Wj");

var $j7TK6 = parcelRequire("j7TK6");
const $06016a2a7e1da1ee$export$ae258fb8ec2c1f86 = (0, $fdS54.createEntry)((0, $1i6Wj.devopsConnectedProjectRoute), ()=>({
        group: 'devops',
        ufoName: 'devops.connected-project',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $j7TK6.default),
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $j7TK6.LazyDevopsConnectedProject)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1i6Wj", function(module, exports) {
$parcel$export(module.exports, "devopsConnectedProjectRoute", () => $d6ff9fc04d44a24a$export$91257312631802bc);
const $d6ff9fc04d44a24a$export$91257312631802bc = {
    name: 'devops-connected-project',
    path: '/jira/devops/connected-project'
};

});

parcelRegister("j7TK6", function(module, exports) {
$parcel$export(module.exports, "LazyDevopsConnectedProject", () => $0352f2f09157c3ed$export$dcd3d20b0038b35c);
$parcel$export(module.exports, "default", () => $0352f2f09157c3ed$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0352f2f09157c3ed$export$dcd3d20b0038b35c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("35NU2"))), {
    moduleId: "./src/packages/spa-apps/devops-connected-project/src/DevopsConnectedProject.tsx"
});
const $0352f2f09157c3ed$var$AsyncDevopsConnectedProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0352f2f09157c3ed$export$dcd3d20b0038b35c,
        pageId: "devops-connected-project",
        shouldShowSpinner: true
    });
$0352f2f09157c3ed$var$AsyncDevopsConnectedProject.displayName = "AsyncDevopsConnectedProject";
var $0352f2f09157c3ed$export$2e2bcd8739ae039 = $0352f2f09157c3ed$var$AsyncDevopsConnectedProject;

});
parcelRegister("35NU2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Mh64").then(()=>parcelRequire('eBQxy'));

});



parcelRegister("5o6W5", function(module, exports) {
$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRouteEntry", () => $ddf05280c062312c$export$6ff00ce079beb0ed);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $4tDbw = parcelRequire("4tDbw");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ddf05280c062312c$var$LazyDigestsNotificationsPersonalSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("fQC9A"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings-digests-notifications/src/ExportedDefault.tsx"
});
const $ddf05280c062312c$var$DigestsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ddf05280c062312c$var$LazyDigestsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
$ddf05280c062312c$var$DigestsNotificationsPersonalSettingsComponent.displayName = "DigestsNotificationsPersonalSettingsComponent";
const $ddf05280c062312c$export$6ff00ce079beb0ed = (0, $fdS54.createEntry)((0, $4tDbw.digestsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: $ddf05280c062312c$var$DigestsNotificationsPersonalSettingsComponent,
        navigation: {
            sidebarId: (0, $f5c10d229cf55438$export$8f20a381b96458f0),
            menuId: (0, $a3b30e449fa4e063$export$75c8a2cf8cfeef9c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $ddf05280c062312c$var$LazyDigestsNotificationsPersonalSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $a3b30e449fa4e063$export$75c8a2cf8cfeef9c = 'PROFILE';

const $f5c10d229cf55438$export$8f20a381b96458f0 = 'PERSONAL_SETTINGS';

parcelRegister("4tDbw", function(module, exports) {
$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRoute", () => $95b5a565d41bcc62$export$36b31d006b9456a1);
const $95b5a565d41bcc62$export$36b31d006b9456a1 = {
    name: 'personal-settings-digests',
    path: '/jira/settings/personal/digests'
};

});

parcelRegister("fQC9A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cCKjZ").then(()=>parcelRequire('7NFCV'));

});


parcelRegister("9fj3k", function(module, exports) {
$parcel$export(module.exports, "emailNotificationsLogAccessRouteEntry", () => $0614c874798e4d2c$export$4d57b993ce36e7b2);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $8niKV = parcelRequire("8niKV");

var $jEYuY = parcelRequire("jEYuY");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $cmvhE = parcelRequire("cmvhE");

var $8jGev = parcelRequire("8jGev");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $35eqr = parcelRequire("35eqr");
const $0614c874798e4d2c$var$emailNotificationsLogEntryPointPage = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8niKV.notificationLogsEntryPoint)
});

const $0614c874798e4d2c$var$LazyNotificationLogsType = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("4FCbx"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-notification-logs/src/NotificationLogs.tsx"
});
const $0614c874798e4d2c$var$NotificationLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0614c874798e4d2c$var$LazyNotificationLogsType,
        pageId: "Notification Logs",
        shouldShowSpinner: false
    });
$0614c874798e4d2c$var$NotificationLogs.displayName = "NotificationLogs";
const $0614c874798e4d2c$export$4d57b993ce36e7b2 = (0, $fdS54.createEntry)((0, $8jGev.emailNotificationsLogAccessRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: $0614c874798e4d2c$var$NotificationLogs,
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $cmvhE.systemConfigurationGeneralResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $0614c874798e4d2c$var$LazyNotificationLogsType
        ],
        pageId: 'admin-settings-email-notifications-log',
        entryPoint () {
            return $0614c874798e4d2c$var$emailNotificationsLogEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8niKV", function(module, exports) {
$parcel$export(module.exports, "notificationLogsEntryPoint", () => $ca7111d7ca67a2ff$export$818d841e00bb3749);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $93dUR = parcelRequire("93dUR");

const $ca7111d7ca67a2ff$export$818d841e00bb3749 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("4FCbx")), {
        moduleId: "82fe9f44",
        moduleName: "NotificationLogs",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $93dUR.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context?.query?.projectId,
                        notificationType: 'INTERNAL_NOTIFICATION',
                        notificationActionType: 'USER_INVITE',
                        recipientId: ''
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("93dUR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4c54a9aa60f3e59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<afee8b34f932c6ee8f2b1c6a9f9ced9e>>
 * @relayHash c3e1d2f1050f72df266cf46d38850c1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8969f4f8a03c4f97fe78e9a71e972476157131fedd518964d9f6d183457b612d

var $lIGkE = parcelRequire("lIGkE");
const $f4c54a9aa60f3e59$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterActionable"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "notificationActionType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "notificationType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "recipientId"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "NotificationLogsPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "UserInvitations"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "AdminEmailAuditPageBanners"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "NotificationLogsPageQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "AquaOutgoingEmailLogsQueryApi",
                    "kind": "LinkedField",
                    "name": "aquaOutgoingEmailLogs",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "filterActionable",
                                    "variableName": "filterActionable"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filters",
                                    "variableName": "filters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationActionType",
                                    "variableName": "notificationActionType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationType",
                                    "variableName": "notificationType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "recipientId",
                                    "variableName": "recipientId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "GetNotificationLogs",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "AquaOutgoingEmailLogConnection",
                                            "kind": "LinkedField",
                                            "name": "logs",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AquaOutgoingEmailLogItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AquaIssueContext",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueContext",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "key"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "webUrl"
                                                                                },
                                                                                v10 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "notificationActionType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "actionTimestamp"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "notificationActionSubType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "deliveryType"
                                                                },
                                                                {
                                                                    "concreteType": "AquaNotificationDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "notificationDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "errorKey"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mailboxMessage"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "hasRecipientJoined"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "recipient",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "email"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "accountId"
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasPreviousPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "logs(first:20)"
                                        },
                                        {
                                            "args": v9 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "aquaOutgoingEmail__logs",
                                            "kind": "LinkedHandle",
                                            "name": "logs"
                                        }
                                    ],
                                    "type": "AquaOutgoingEmailLog"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v10 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraOutgoingEmailSettings",
                            "kind": "LinkedField",
                            "name": "getOutgoingEmailSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "emailSystemSettingsDisabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "spamProtectionOnTenantApplicable"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8969f4f8a03c4f97fe78e9a71e972476157131fedd518964d9f6d183457b612d",
            "metadata": {},
            "name": "NotificationLogsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f4c54a9aa60f3e59$var$node.hash = "a2d58555c4f0737281f92bf9bcba89bb";
(0, $lIGkE.PreloadableQueryRegistry).set($f4c54a9aa60f3e59$var$node.params.id, $f4c54a9aa60f3e59$var$node);
var $f4c54a9aa60f3e59$export$2e2bcd8739ae039 = $f4c54a9aa60f3e59$var$node;

});

parcelRegister("4FCbx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("10DHv").then(()=>parcelRequire('hPuWV'));

});


parcelRegister("cmvhE", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationGeneralResource", () => $65e1427c6778d2a0$export$b622f7400bfafd0d);

var $7edbf = parcelRequire("7edbf");
const $65e1427c6778d2a0$var$RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

const $65e1427c6778d2a0$export$b622f7400bfafd0d = (0, $7edbf.createResource)({
    type: $65e1427c6778d2a0$var$RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("18NVN"))
});

});
parcelRegister("18NVN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1pjmd").then(()=>parcelRequire('jbDne'));

});


parcelRegister("8jGev", function(module, exports) {
$parcel$export(module.exports, "emailNotificationsLogAccessRoute", () => $eda5d67730d7f49d$export$aed294a4a292b909);
const $eda5d67730d7f49d$export$aed294a4a292b909 = {
    name: 'global-admin-helper-email-notifications-log',
    path: '/jira/settings/system/notification-logs',
    exact: true
};

});


parcelRegister("2eUNm", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingCreateRouteEntry", () => $74c174ec8ee636c4$export$92f4b6644eb6cb88);



var $dUAVJ = parcelRequire("dUAVJ");

var $3ZTVj = parcelRequire("3ZTVj");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $gbg6j = parcelRequire("gbg6j");

var $bkrFd = parcelRequire("bkrFd");

var $evYwU = parcelRequire("evYwU");

var $eh3wx = parcelRequire("eh3wx");

var $1NDcF = parcelRequire("1NDcF");
const $74c174ec8ee636c4$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $74c174ec8ee636c4$export$92f4b6644eb6cb88 = (0, $fdS54.createEntry)((0, $gbg6j.eocAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $evYwU.AlertIssueSync),
        slot: (0, $eh3wx.AlertIssueSyncCreate),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $3ZTVj.resources).configuredSyncsResource,
            (0, $3ZTVj.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$74c174ec8ee636c4$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1NDcF.LazyAlertIssueSync)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $69db4b0f28295983$export$e0323f266e5e0bb8 = 'OPERATIONS_GENERAL_CONFIGURATION';

parcelRegister("3ZTVj", function(module, exports) {
$parcel$export(module.exports, "resources", () => $38dad3571831396c$export$bc99aaabaf7b70a7);

var $hPize = parcelRequire("hPize");

var $7QFna = parcelRequire("7QFna");

var $dqXOW = parcelRequire("dqXOW");

var $ipYLu = parcelRequire("ipYLu");
const $38dad3571831396c$export$bc99aaabaf7b70a7 = {
    configuredSyncsResource: $hPize.configuredSyncsResource,
    userAccessRightsResource: $ipYLu.userAccessRightsResource,
    getTeamResource: $dqXOW.getTeamResource,
    isCurrentSiteSyncEnabledResource: $7QFna.isCurrentSiteSyncEnabledResource
};

});
parcelRegister("hPize", function(module, exports) {
$parcel$export(module.exports, "configuredSyncsResource", () => $4e5db9f1a118c58b$export$333c290f4a1ec41c);

var $7edbf = parcelRequire("7edbf");

var $bwPIQ = parcelRequire("bwPIQ");

var $7kkKC = parcelRequire("7kkKC");
const $4e5db9f1a118c58b$export$333c290f4a1ec41c = (0, $7edbf.createResource)({
    type: 'configuredSyncsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const keyword = query['keyword'];
        const type = query['type'];
        const page = query['page'] || '1';
        const status = query['status'];
        return (0, $bwPIQ.UrlHelper)('configuredSyncsResource', {
            page: page,
            keyword: keyword,
            type: type,
            status: status,
            teamId: teamId
        });
    },
    getData: (routerContext)=>(0, $7kkKC.default).getSyncs(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("bwPIQ", function(module, exports) {
$parcel$export(module.exports, "UrlHelper", () => $ab01a102a170fdce$export$bacbc496e850c0a4);
const $ab01a102a170fdce$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    const qs = new URLSearchParams(q).toString();
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("7kkKC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2beee9278220739d$export$2e2bcd8739ae039);

var $hG5S4 = parcelRequire("hG5S4");

var $bwPIQ = parcelRequire("bwPIQ");

const $2beee9278220739d$var$getSyncs = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $c36fa33b65a2869c$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        type: query.type,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $hG5S4.eocFetch)((0, $bwPIQ.UrlHelper)('/v1/entity-sync/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $c36fa33b65a2869c$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $c36fa33b65a2869c$export$31ecae7225aecec6)),
            itemCount: response.data.count
        }));
};
const $2beee9278220739d$var$patchSync = async (syncId, syncType, body, teamId)=>(0, $hG5S4.eocFetch)((0, $bwPIQ.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $2beee9278220739d$var$deleteSync = async (syncId, syncType, teamId)=>(0, $hG5S4.eocFetch)((0, $bwPIQ.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
const $2beee9278220739d$var$_default_1 = {
    getSyncs: $2beee9278220739d$var$getSyncs,
    patchSync: $2beee9278220739d$var$patchSync,
    deleteSync: $2beee9278220739d$var$deleteSync
};
var $2beee9278220739d$export$2e2bcd8739ae039 = $2beee9278220739d$var$_default_1;

});
const $c36fa33b65a2869c$export$31ecae7225aecec6 = 20;



parcelRegister("7QFna", function(module, exports) {
$parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", () => $6bcbc3c6104e9ca3$export$94465df791bf80);

var $7edbf = parcelRequire("7edbf");

var $gMq8l = parcelRequire("gMq8l");
const $6bcbc3c6104e9ca3$export$94465df791bf80 = (0, $7edbf.createResource)({
    type: 'isCurrentSiteSyncEnabledResource',
    getKey: ()=>`isCurrentSiteSyncEnabledResource`,
    getData: (0, $gMq8l.getIsCurrentSiteSyncEnabled),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("gMq8l", function(module, exports) {
$parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", () => $03fb975d2fd6b333$export$93fc09e39edf63d0);

var $hG5S4 = parcelRequire("hG5S4");
const $03fb975d2fd6b333$export$93fc09e39edf63d0 = ()=>(0, $hG5S4.eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);

});


parcelRegister("dqXOW", function(module, exports) {
$parcel$export(module.exports, "getTeamResource", () => $07d2ba51478369df$export$50271c9e7f21f10e);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $h32pL = parcelRequire("h32pL");
const $07d2ba51478369df$export$50271c9e7f21f10e = (0, $7edbf.createResource)({
    type: 'getSyncTeamResource',
    getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
        const result = await (0, $h32pL.getTeam)(teamId);
        return result ?? null;
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("h32pL", function(module, exports) {
$parcel$export(module.exports, "getTeam", () => $5e34c47654113f78$export$491fe77f22ab2b51);

var $hG5S4 = parcelRequire("hG5S4");
const $5e34c47654113f78$export$491fe77f22ab2b51 = (teamId)=>(0, $hG5S4.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));

});


parcelRegister("ipYLu", function(module, exports) {
$parcel$export(module.exports, "userAccessRightsResource", () => $309b5fba36891c81$export$69ddc7cc64ae9a02);

var $7edbf = parcelRequire("7edbf");

var $cJTEO = parcelRequire("cJTEO");
const $309b5fba36891c81$export$69ddc7cc64ae9a02 = (0, $7edbf.createResource)({
    type: 'userAccessRightsResource',
    getKey: ()=>'userAccessRightsResource',
    getData: (routerContext)=>(0, $cJTEO.getUserRights)(routerContext.match.params.teamId),
    maxAge: 600000,
    isBrowserOnly: true
});

});
parcelRegister("cJTEO", function(module, exports) {
$parcel$export(module.exports, "getUserRights", () => $9ee90b3393061645$export$84e2ed279bc4e64e);

var $hG5S4 = parcelRequire("hG5S4");

var $bwPIQ = parcelRequire("bwPIQ");
const $9ee90b3393061645$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $hG5S4.eocFetch)((0, $bwPIQ.UrlHelper)(`/v1/entity-sync/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data.userAccessRights);
};

});



parcelRegister("gbg6j", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingCreateRoute", () => $452d99fc8cd0749f$export$f271eef5f9ec6602);
const $452d99fc8cd0749f$export$f271eef5f9ec6602 = {
    name: 'eoc-alert-issue-syncing-create',
    path: '/jira/settings/products/ops/syncs/create',
    exact: true
};

});

parcelRegister("bkrFd", function(module, exports) {
$parcel$export(module.exports, "LazySidebarContent", () => $2b50cf90c0695032$export$5cb783b45e692ee9);
$parcel$export(module.exports, "default", () => $2b50cf90c0695032$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gVkjO = parcelRequire("gVkjO");

var $jT1ry = parcelRequire("jT1ry");

var $k3x0N = parcelRequire("k3x0N");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $fNgVF = parcelRequire("fNgVF");

var $6HvWM = parcelRequire("6HvWM");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");

var $6RSCO = parcelRequire("6RSCO");

var $i860n = parcelRequire("i860n");

const $2b50cf90c0695032$export$5cb783b45e692ee9 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("i4LHZ")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-operations/src/ui/main.tsx"
});
const $2b50cf90c0695032$var$AsyncSidebar = ()=>{
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const { isOpsAdmin: isOpsAdmin, shouldUseJSM: shouldUseJSM, loading: loading } = (0, $6HvWM.useOgTenantInfo)();
    // On shell-only new tab loads (IC), getConsolidationStateResource starts with
    // data=null, loading=false on the first render — before useEffect triggers refresh().
    // All check fns (checkShouldUseJSM etc.) return false for null data, so without this
    // guard the redirect fires before the resource is even fetched.
    // We always call useResource (rules of hooks) but only use it when the gate is on.
    const { data: tenantInfoData } = (0, $k6ufm.useResource)((0, $6RSCO.getConsolidationStateResource)());
    const hasOperationsGeneralConfiguration = isAdmin || isOpsAdmin;
    // Guard: wait for resource data before redirecting — prevents premature redirect
    // when data=null, loading=false on first render (IC shell-only new tab cold start).
    // On shell-only new tab, getConsolidationStateResource starts with data=null, loading=false
    // before useEffect triggers refresh() — all check fns return false for null data, causing
    // a premature redirect to /jira/for-you before ops-user-info is even fetched.
    if ((loading || tenantInfoData === null) && (0, $i860n.fg)('fix_chatops_access_in_isolated_cloud')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null);
    if (!shouldUseJSM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/jira/for-you"
    });
    if (!hasOperationsGeneralConfiguration) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/jira/ops/overview"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gVkjO.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jT1ry.SidebarContent), {
        currentPageName: "operations",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-operations.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.operations-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $k3x0N.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2b50cf90c0695032$export$5cb783b45e692ee9, null))));
};
$2b50cf90c0695032$var$AsyncSidebar.displayName = "AsyncSidebar";
const $2b50cf90c0695032$var$ExportedComponent = /*#__PURE__*/ (0, $euxye.memo)($2b50cf90c0695032$var$AsyncSidebar);
var $2b50cf90c0695032$export$2e2bcd8739ae039 = $2b50cf90c0695032$var$ExportedComponent;

});
parcelRegister("gVkjO", function(module, exports) {
$parcel$export(module.exports, "SidebarBoundary", () => $92033b3f00f1afee$export$1edc778464f08256);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $868gB = parcelRequire("868gB");

var $cUnrZ = parcelRequire("cUnrZ");

var $41zzZ = parcelRequire("41zzZ");

var $gDdYI = parcelRequire("gDdYI");

var $7ehYC = parcelRequire("7ehYC");

var $7uGDP = parcelRequire("7uGDP");
const $92033b3f00f1afee$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName, ufoName: ufoName = '' })=>{
    const { experience: experience, attributes: attributes } = (0, $7ehYC.useSidebarExperience)();
    const onFail = (0, $cUnrZ.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const onAbort = (0, $868gB.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const userLocation = (0, $41zzZ.getUserLocation)();
    const isNotSSR = !false;
    const extraEventData = (0, $euxye.useMemo)(()=>({
            userLocation: userLocation
        }), [
        userLocation
    ]);
    const fallback = (0, $euxye.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7uGDP.Fallback), {
            error: error
        }), []);
    const handleError = (0, $euxye.useCallback)(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (location, error)=>{
        const { statusCode: statusCode } = error;
        if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
            error: error
        });
        else onFail(location, error);
    }, [
        onAbort,
        onFail
    ]);
    const UFOSegmentORFragment = ufoName ? (0, $gDdYI.default) : (0, $euxye.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(UFOSegmentORFragment, {
        name: ufoName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        extraEventData: extraEventData,
        fallback: fallback,
        teamName: teamName,
        onError: handleError
    }, isNotSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7ehYC.SidebarStart), null), children));
};
$92033b3f00f1afee$export$1edc778464f08256.displayName = "SidebarBoundary";

});
parcelRegister("868gB", function(module, exports) {
$parcel$export(module.exports, "useExperienceAbort", () => $875ac4dcc884f25e$export$cc92b7ce453f4403);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6bEm8 = parcelRequire("6bEm8");

var $i860n = parcelRequire("i860n");

var $a5nxD = parcelRequire("a5nxD");

var $UlW5d = parcelRequire("UlW5d");
const $875ac4dcc884f25e$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const self = (0, $euxye.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $euxye.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        let shardAndRegionAttributes = {};
        shardAndRegionAttributes = {
            shard: (0, $6bEm8.default)('ajs-shard'),
            region: (0, $6bEm8.default)('ajs-region')
        };
        let holdoutAttributes = {};
        if ((0, $i860n.fg)('add_holdout_attribute_to_jira_experience_tracker')) holdoutAttributes = {
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout
        };
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                ...holdoutAttributes
            }
        });
    }, // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
    [
        self
    ]);
};

});

parcelRegister("7ehYC", function(module, exports) {
$parcel$export(module.exports, "useSidebarExperience", () => $bafa0d4d9f99c907$export$d4fa533dfe4d7583);
$parcel$export(module.exports, "SidebarStart", () => $bafa0d4d9f99c907$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarReady", () => $bafa0d4d9f99c907$export$a06ecbbe5820282);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $60MZW = parcelRequire("60MZW");

var $dtDO2 = parcelRequire("dtDO2");

var $lTQTl = parcelRequire("lTQTl");

var $4Onaa = parcelRequire("4Onaa");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $2yVPv = parcelRequire("2yVPv");

var $hYI7R = parcelRequire("hYI7R");
const $bafa0d4d9f99c907$export$d4fa533dfe4d7583 = ()=>{
    const pageId = (0, $2yVPv.usePageId)();
    return (0, $euxye.useMemo)(()=>({
            experience: 'viewSidebarNavigation',
            experienceId: pageId,
            analyticsSource: 'Sidebar',
            attributes: {
                sidebar: 'v4'
            }
        }), [
        pageId
    ]);
};
const $bafa0d4d9f99c907$export$6738d1299dc79710 = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $bafa0d4d9f99c907$export$d4fa533dfe4d7583();
    const onStartExperience = (0, $dtDO2.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource
    });
    (0, $euxye.useEffect)(()=>{
        if (route.isRedirect) return;
        onStartExperience();
    }, [
        onStartExperience,
        route
    ]);
    return null;
};
$bafa0d4d9f99c907$export$6738d1299dc79710.displayName = "SidebarStart";
const $bafa0d4d9f99c907$export$a06ecbbe5820282 = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const { experience: experience, attributes: attributes } = $bafa0d4d9f99c907$export$d4fa533dfe4d7583();
    const onSuccessfulExperience = (0, $lTQTl.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const doNotRunEffects = route.isRedirect || false;
    const sidebarId = route.navigation?.sidebarId ?? 'default';
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $aJ81Y.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        doNotRunEffects,
        routeName
    ]);
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        onSuccessfulExperience();
    }, [
        doNotRunEffects,
        onSuccessfulExperience,
        route
    ]);
    const customData = (0, $euxye.useMemo)(()=>({
            sidebarType: sidebarId
        }), [
        sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $60MZW.default), {
        data: customData
    });
};
$bafa0d4d9f99c907$export$a06ecbbe5820282.displayName = "SidebarReady";

});
parcelRegister("hYI7R", function(module, exports) {
$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $8e1c17f889077a08$export$e44126cd87ea434);

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $jiTLE = parcelRequire("jiTLE");
function $8e1c17f889077a08$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $euxye.useRef)(false);
    const depsRef = (0, $euxye.useRef)(dependencies);
    (0, $euxye.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $jiTLE.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("7uGDP", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $dffddeee08bbad9e$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eXdAp = parcelRequire("eXdAp");

var $2iotI = parcelRequire("2iotI");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $8Sdzy = parcelRequire("8Sdzy");

var $42csL = parcelRequire("42csL");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $dffddeee08bbad9e$var$errorHeading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Something went wrong"
});
const $dffddeee08bbad9e$var$errorBody = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Try refreshing or navigating to another page."
});
const $dffddeee08bbad9e$var$errorHashDetails = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-hash-details",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "ERROR: {errorHash}"
});
const $dffddeee08bbad9e$var$styles = {
    wrapper: "_zulpu2gc _bfhki8nm _syazazsu _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o",
    error: "_2rkolb4i _bfhk7qp0 _syaz1rpy _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
};
const $dffddeee08bbad9e$export$fb8d7f40caaeea67 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $dffddeee08bbad9e$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $42csL.default), {
        width: "40px",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xsmall"
    }, formatMessage($dffddeee08bbad9e$var$errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($dffddeee08bbad9e$var$errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $dffddeee08bbad9e$var$styles.error
    }, formatMessage($dffddeee08bbad9e$var$errorHashDetails, {
        errorHash: (0, $eXdAp.getErrorHash)(error)
    })));
};
$dffddeee08bbad9e$export$fb8d7f40caaeea67.displayName = "Fallback";

});


parcelRegister("jT1ry", function(module, exports) {
$parcel$export(module.exports, "SidebarContent", () => $b937b6b7ef65c6a1$export$49e8f7b58a4df4ea);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $2BUXh = parcelRequire("2BUXh");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $kYJqR = parcelRequire("kYJqR");

var $djYhH = parcelRequire("djYhH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $fTOb9 = parcelRequire("fTOb9");

var $j1hZS = parcelRequire("j1hZS");
const $b937b6b7ef65c6a1$var$heading = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Jira admin settings"
});
const $b937b6b7ef65c6a1$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName, testId: testId = 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content' })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNavHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.200",
        xcss: $b937b6b7ef65c6a1$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        alignBlock: "center",
        grow: "hug",
        space: "space.100",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fTOb9.BackButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "small",
        as: "h2"
    }, formatMessage($b937b6b7ef65c6a1$var$heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j1hZS.AsyncPageSwitcher), {
        currentPageName: currentPageName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNavBody), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $djYhH.MenuList), null, children)));
};
$b937b6b7ef65c6a1$export$49e8f7b58a4df4ea.displayName = "SidebarContent";
const $b937b6b7ef65c6a1$var$headingStyles = (0, $fbAgj.xcss)({
    // 4px of left padding is added to align the back icon with the side nav toggle button
    paddingInlineStart: 'space.050'
});

});
parcelRegister("kYJqR", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $lMW3p = parcelRequire("lMW3p");
module.exports = Object.assign({}, $lMW3p, {
    SideNavContent: $lMW3p.SideNavBody
});
if ($lMW3p.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("fTOb9", function(module, exports) {
$parcel$export(module.exports, "BackButton", () => $73f08893ca32758e$export$e0d897ee21382f67);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $lMezl = parcelRequire("lMezl");

var $6JMJ2 = parcelRequire("6JMJ2");

var $hZDXn = parcelRequire("hZDXn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $hmQJh = parcelRequire("hmQJh");
const $73f08893ca32758e$var$tooltip = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Go back"
});
const $73f08893ca32758e$var$label = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Navigate back to the previous page"
});
function $73f08893ca32758e$export$e0d897ee21382f67() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { previousUrl: previousUrl } = (0, $hmQJh.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: formatMessage($73f08893ca32758e$var$tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lMezl.default), {
        href: previousUrl || '',
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6JMJ2))),
        label: formatMessage($73f08893ca32758e$var$label),
        onClick: ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
        }
    }));
}
$73f08893ca32758e$export$e0d897ee21382f67.displayName = "BackButton";

});
parcelRegister("hmQJh", function(module, exports) {
$parcel$export(module.exports, "useNavigateBack", () => $656e92f92e9e777b$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $656e92f92e9e777b$export$e1e76f4ee7f8174d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3T5IC = parcelRequire("3T5IC");

var $i860n = parcelRequire("i860n");

var $cZjb4 = parcelRequire("cZjb4");

var $eWBug = parcelRequire("eWBug");
const $656e92f92e9e777b$var$STORAGE_KEY = 'back-button-url';
const $656e92f92e9e777b$var$NavigateBackContext = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $656e92f92e9e777b$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $euxye.useContext)($656e92f92e9e777b$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
function $656e92f92e9e777b$export$e1e76f4ee7f8174d({ children: children }) {
    const [projectKey] = (0, $cZjb4.usePathParam)('projectKey');
    const defaultInitialUrl = projectKey ? `/projects/${projectKey}` : (0, $3T5IC.jiraHomeRoute).path;
    const [previousUrl, setPreviousUrl] = (0, $euxye.useState)(()=>(0, $eWBug.storageProvider).get($656e92f92e9e777b$var$STORAGE_KEY) ?? defaultInitialUrl);
    const saveCurrentRoute = (0, $euxye.useCallback)((currentUrl)=>{
        setPreviousUrl(currentUrl);
        if ('setStrictlyNecessaryItem' in (0, $eWBug.storageProvider) && (0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) // @browser-storage setter
        (0, $eWBug.storageProvider).setStrictlyNecessaryItem($656e92f92e9e777b$var$STORAGE_KEY, currentUrl);
        else // @browser-storage setter
        (0, $eWBug.storageProvider).set($656e92f92e9e777b$var$STORAGE_KEY, currentUrl);
    }, []);
    const value = (0, $euxye.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            previousUrl: previousUrl
        }), [
        saveCurrentRoute,
        previousUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($656e92f92e9e777b$var$NavigateBackContext.Provider, {
        value: value
    }, children);
}
$656e92f92e9e777b$export$e1e76f4ee7f8174d.displayName = "NavigateBackProvider";

});
parcelRegister("3T5IC", function(module, exports) {
$parcel$export(module.exports, "jiraHomeRoute", () => $39d9e83b0ce45394$export$11ebbd6d4e57759c);
const $39d9e83b0ce45394$export$11ebbd6d4e57759c = {
    name: 'for-you',
    path: '/jira/for-you'
};

});

parcelRegister("eWBug", function(module, exports) {
$parcel$export(module.exports, "storageProvider", () => $8143dcafb711532e$export$ce7751641b93537d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cBnIS = parcelRequire("cBnIS");
const $8143dcafb711532e$export$ce7751641b93537d = (0, $cBnIS.createSessionStorageProvider)('sidebar-navigation');

});



parcelRegister("j1hZS", function(module, exports) {
$parcel$export(module.exports, "AsyncPageSwitcher", () => $89bbca9ce929bbd1$export$3130bd98029942c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");
const $89bbca9ce929bbd1$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $89bbca9ce929bbd1$var$headingSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $89bbca9ce929bbd1$var$dropdownSkeleton
    }));
$89bbca9ce929bbd1$export$8f31e4c4a37b8e9c.displayName = "Skeleton";

const $89bbca9ce929bbd1$var$LazyPageSwitcher = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gKvzQ")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4-sidebars-settings-global-common/src/common/ui/page-switcher/main.tsx"
});
const $89bbca9ce929bbd1$export$3130bd98029942c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4.sidebar.global-settings.page-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($89bbca9ce929bbd1$export$8f31e4c4a37b8e9c, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($89bbca9ce929bbd1$var$LazyPageSwitcher, props));
$89bbca9ce929bbd1$export$3130bd98029942c.displayName = "AsyncPageSwitcher";
const $89bbca9ce929bbd1$var$headingSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small'
});
const $89bbca9ce929bbd1$var$dropdownSkeleton = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});
parcelRegister("gKvzQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fsN9S").then(()=>parcelRequire('2eFXr'));

});



parcelRegister("k3x0N", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $07a04cb7c4e25139$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");
const $07a04cb7c4e25139$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $07a04cb7c4e25139$var$menuItem
    }));
$07a04cb7c4e25139$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $07a04cb7c4e25139$var$sectionHeading = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'radius.small',
    marginTop: 'space.100'
});
const $07a04cb7c4e25139$var$menuItem = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small'
});

});

parcelRegister("6HvWM", function(module, exports) {
$parcel$export(module.exports, "useOgTenantInfo", () => $d9d7e8890e4efcec$export$990ea9ff15ca04f7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6RSCO = parcelRequire("6RSCO");

var $1KydW = parcelRequire("1KydW");

var $k6ufm = parcelRequire("k6ufm");

var $jOrx3 = parcelRequire("jOrx3");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $d9d7e8890e4efcec$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh
    ]);
};
const $d9d7e8890e4efcec$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $k6ufm.useResource)((0, $6RSCO.getConsolidationStateResource)());
    const applicationPermissions = (0, $1KydW.useApplicationPermissions)();
    $d9d7e8890e4efcec$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $jOrx3.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $jOrx3.checkIsConsolidated)(tenantInfoResource.data),
        isOpsAdmin: (0, $jOrx3.checkIsOpsAdmin)(tenantInfoResource.data),
        isTransitioning: (0, $jOrx3.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $jOrx3.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: applicationPermissions.hasServiceDeskAccess && (0, $jOrx3.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: applicationPermissions.hasServiceDeskAccess && (0, $jOrx3.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});
parcelRegister("1KydW", function(module, exports) {
$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $ee011d0c7908d149$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $ee011d0c7908d149$export$4d9cadb4042acc1b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $a7e1f = parcelRequire("a7e1f");

var $iGu4q = parcelRequire("iGu4q");

var $8GgAm = parcelRequire("8GgAm");

var $eijVy = parcelRequire("eijVy");
const $ee011d0c7908d149$var$selector = (0, $a7e1f.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $ee011d0c7908d149$export$d8c76f7e52d0a856 = (0, $iGu4q.createSubscriber)((0, $8GgAm.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $ee011d0c7908d149$var$selector
});
const $ee011d0c7908d149$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});


parcelRegister("i4LHZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j5V2B").then(()=>parcelRequire('1j5N7'));

});


parcelRegister("evYwU", function(module, exports) {
$parcel$export(module.exports, "AlertIssueSync", () => $91f196bc5abc8eab$export$5a4922ba79d730f4);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $1NDcF = parcelRequire("1NDcF");
const $91f196bc5abc8eab$export$5a4922ba79d730f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $1NDcF.LazyAlertIssueSync),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
$91f196bc5abc8eab$export$5a4922ba79d730f4.displayName = "AlertIssueSync";

});
parcelRegister("1NDcF", function(module, exports) {
$parcel$export(module.exports, "LazyAlertIssueSync", () => $03507532d28d450e$export$dbbcce89c7be1e71);
$parcel$export(module.exports, "LazyAlertIssueSyncCreate", () => $03507532d28d450e$export$ff3e9ed7471eebce);
$parcel$export(module.exports, "LazyAlertIssueSyncDetail", () => $03507532d28d450e$export$75137a2a583918e2);

var $l8G1z = parcelRequire("l8G1z");

const $03507532d28d450e$export$dbbcce89c7be1e71 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("4Hd0z")).then((module)=>module.AlertIssueSync), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $03507532d28d450e$export$ff3e9ed7471eebce = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("4Hd0z")).then((module)=>module.AlertIssueSyncCreate), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $03507532d28d450e$export$75137a2a583918e2 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("4Hd0z")).then((module)=>module.AlertIssueSyncDetail), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

});
parcelRegister("4Hd0z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("66kaO").then(()=>parcelRequire('fjXJ8'));

});



parcelRegister("eh3wx", function(module, exports) {
$parcel$export(module.exports, "AlertIssueSyncCreate", () => $62e664980804fd54$export$a26f24c49385cf3a);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $1NDcF = parcelRequire("1NDcF");
const $62e664980804fd54$export$a26f24c49385cf3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $1NDcF.LazyAlertIssueSyncCreate),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
$62e664980804fd54$export$a26f24c49385cf3a.displayName = "AlertIssueSyncCreate";

});


parcelRegister("dJeUf", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingDetailRouteEntry", () => $35fda2806a5e484a$export$7e604b22ae6e7c1e);



var $dUAVJ = parcelRequire("dUAVJ");

var $3ZTVj = parcelRequire("3ZTVj");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $9jPLl = parcelRequire("9jPLl");

var $bkrFd = parcelRequire("bkrFd");

var $evYwU = parcelRequire("evYwU");

var $9tKCs = parcelRequire("9tKCs");

var $1NDcF = parcelRequire("1NDcF");
const $35fda2806a5e484a$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $35fda2806a5e484a$export$7e604b22ae6e7c1e = (0, $fdS54.createEntry)((0, $9jPLl.eocAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $evYwU.AlertIssueSync),
        slot: (0, $9tKCs.AlertIssueSyncDetail),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $3ZTVj.resources).configuredSyncsResource,
            (0, $3ZTVj.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$35fda2806a5e484a$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1NDcF.LazyAlertIssueSync)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9jPLl", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingDetailRoute", () => $31048cb4f7c06d7e$export$f1b4093ef603b98d);
const $31048cb4f7c06d7e$export$f1b4093ef603b98d = {
    name: 'eoc-alert-issue-syncing-detail',
    path: '/jira/settings/products/ops/syncs/:syncId',
    exact: true
};

});

parcelRegister("9tKCs", function(module, exports) {
$parcel$export(module.exports, "AlertIssueSyncDetail", () => $d2aa91c223cab01b$export$c21f2a7e1aa801a7);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $1NDcF = parcelRequire("1NDcF");
const $d2aa91c223cab01b$export$c21f2a7e1aa801a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $1NDcF.LazyAlertIssueSyncDetail),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
$d2aa91c223cab01b$export$c21f2a7e1aa801a7.displayName = "AlertIssueSyncDetail";

});


parcelRegister("2FXYc", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingRouteEntry", () => $79db41d767cdfebd$export$c63d0942ec0f93c);



var $dUAVJ = parcelRequire("dUAVJ");

var $3ZTVj = parcelRequire("3ZTVj");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $7bOJw = parcelRequire("7bOJw");

var $bkrFd = parcelRequire("bkrFd");

var $1NDcF = parcelRequire("1NDcF");

var $evYwU = parcelRequire("evYwU");
const $79db41d767cdfebd$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $79db41d767cdfebd$export$c63d0942ec0f93c = (0, $fdS54.createEntry)((0, $7bOJw.eocAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $evYwU.AlertIssueSync),
        slot: null,
        basePath: '/jira/settings/products/ops',
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $3ZTVj.resources).configuredSyncsResource,
            (0, $3ZTVj.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$79db41d767cdfebd$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1NDcF.LazyAlertIssueSync)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7Fzs6", function(module, exports) {
$parcel$export(module.exports, "opsSettingsLayout", () => $59af385c5f6b3a0e$export$96d5e7da242cacf9);
$parcel$export(module.exports, "opsMigrationHubLayout", () => $59af385c5f6b3a0e$export$d4e92309ebd00b0f);
$parcel$export(module.exports, "opsNotificationsLayout", () => $59af385c5f6b3a0e$export$5714bc9520dbc6cf);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

var $jepRN = parcelRequire("jepRN");

var $ju22D = parcelRequire("ju22D");

var $h2tgz = parcelRequire("h2tgz");

const $59af385c5f6b3a0e$export$f61c80ac3b95bc7d = (0, $jepRN.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("gE0l9")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$59af385c5f6b3a0e$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';

const $59af385c5f6b3a0e$export$70238cd3868b67c9 = (0, $jepRN.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("bqfVH")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$59af385c5f6b3a0e$export$70238cd3868b67c9.displayName = 'Onboarding';
const $59af385c5f6b3a0e$export$96d5e7da242cacf9 = (0, $QhQu4.composeLayouts)((0, $ju22D.globalSettingsLayout), {
    get globalComponents () {
        return [
            $59af385c5f6b3a0e$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $59af385c5f6b3a0e$export$f61c80ac3b95bc7d
    ]
});
const $59af385c5f6b3a0e$export$d4e92309ebd00b0f = (0, $QhQu4.createLayout)({
    get globalComponents () {
        return [
            $59af385c5f6b3a0e$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $59af385c5f6b3a0e$export$f61c80ac3b95bc7d
    ]
});
const $59af385c5f6b3a0e$export$5714bc9520dbc6cf = (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), {
    get globalComponents () {
        return [
            $59af385c5f6b3a0e$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $59af385c5f6b3a0e$export$f61c80ac3b95bc7d
    ]
});

});

parcelRegister("7bOJw", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingRoute", () => $8f50d0a502ca5565$export$73d6a0dc298aae15);
const $8f50d0a502ca5565$export$73d6a0dc298aae15 = {
    name: 'eoc-alert-issue-syncing',
    path: '/jira/settings/products/ops/syncs',
    exact: true
};

});


parcelRegister("bPuPn", function(module, exports) {
$parcel$export(module.exports, "eocApiKeyManagementRouteEntry", () => $f4aee3aed77e0adc$export$e18a6be3d2ffad71);



var $dUAVJ = parcelRequire("dUAVJ");

var $g0k5q = parcelRequire("g0k5q");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $d5F4O = parcelRequire("d5F4O");

var $bkrFd = parcelRequire("bkrFd");

var $6JGv7 = parcelRequire("6JGv7");
const $f4aee3aed77e0adc$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $f4aee3aed77e0adc$export$e18a6be3d2ffad71 = (0, $fdS54.createEntry)((0, $d5F4O.eocApiKeyManagementRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6JGv7.default),
        layout: (0, $7Fzs6.opsSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$f4aee3aed77e0adc$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $g0k5q.resources)()
        ],
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6JGv7.LazyApiKeyManagement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("g0k5q", function(module, exports) {
$parcel$export(module.exports, "apiKeysResource", () => $cec322ed554cd37d$export$a98d5421eda11f29);
$parcel$export(module.exports, "resources", () => $cec322ed554cd37d$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");
parcelRequire("lrLEP");
var $1OYWB = parcelRequire("1OYWB");

var $66yl6 = parcelRequire("66yl6");
const $cec322ed554cd37d$export$a98d5421eda11f29 = (0, $7edbf.createResource)({
    type: 'api-key-management',
    getKey: ()=>'api-key-management',
    getData: async ({ dependencies: dependencies })=>{
        const data = await dependencies[(0, $1OYWB.eocUserResource).type]?.promise;
        return (0, $66yl6.fetchKeys)(data.accountId);
    },
    isBrowserOnly: true,
    maxCache: 0,
    maxAge: 0,
    depends: [
        (0, $1OYWB.eocUserResource).type
    ]
});
const $cec322ed554cd37d$export$bc99aaabaf7b70a7 = ()=>[
        (0, $1OYWB.eocUserResource),
        $cec322ed554cd37d$export$a98d5421eda11f29
    ];

});
parcelRegister("lrLEP", function(module, exports) {
$parcel$export(module.exports, "eocCommonResources", () => $e401d28ee84c368f$export$8977bbbf2f7167d2);
$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("1OYWB")).eocUserResource);

var $1OYWB = parcelRequire("1OYWB");
const $e401d28ee84c368f$export$8977bbbf2f7167d2 = ()=>[
        (0, $1OYWB.eocUserResource)
    ];

});
parcelRegister("1OYWB", function(module, exports) {
$parcel$export(module.exports, "eocUserResource", () => $014eb0cb6705518d$export$3a08a0bdeef86956);

var $7edbf = parcelRequire("7edbf");

var $a2zLA = parcelRequire("a2zLA");
const $014eb0cb6705518d$export$3a08a0bdeef86956 = (0, $7edbf.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $a2zLA.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("a2zLA", function(module, exports) {
$parcel$export(module.exports, "fetchJsmUserInfo", () => $c3129f3861552fa4$export$7d750310098b5a7);

var $hG5S4 = parcelRequire("hG5S4");
var $7nxyA = parcelRequire("7nxyA");
const $c3129f3861552fa4$var$JSM_BASE_URL = '/rest/api/3/myself';
const $c3129f3861552fa4$export$7d750310098b5a7 = ()=>{
    return (0, $hG5S4.eocFetch)($c3129f3861552fa4$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $7nxyA.jsmErrorTransformer)
    });
};

});



parcelRegister("66yl6", function(module, exports) {
$parcel$export(module.exports, "fetchKeys", () => $13964896d511f6e3$export$a0d93e1b78b8e70b);
$parcel$export(module.exports, "deleteApiKey", () => $13964896d511f6e3$export$d2f8649a375a4113);

var $hG5S4 = parcelRequire("hG5S4");
const $13964896d511f6e3$export$a0d93e1b78b8e70b = async (accountId)=>{
    return (0, $hG5S4.eocFetch)('/api-keys/web?accountId=' + accountId);
};
const $13964896d511f6e3$export$d2f8649a375a4113 = async (key, accountId)=>{
    return (0, $hG5S4.eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
        method: 'DELETE'
    });
};

});


parcelRegister("d5F4O", function(module, exports) {
$parcel$export(module.exports, "eocApiKeyManagementRoute", () => $a1b719a4c398247f$export$84985159d5695f4d);
const $a1b719a4c398247f$export$84985159d5695f4d = {
    name: 'eoc-api-key-management',
    path: '/jira/settings/products/ops/api-key-management',
    exact: true
};

});

parcelRegister("6JGv7", function(module, exports) {
$parcel$export(module.exports, "LazyApiKeyManagement", () => $ac3e12d4e74a6458$export$6ae4b26c31b1b0d2);
$parcel$export(module.exports, "default", () => $ac3e12d4e74a6458$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $ac3e12d4e74a6458$export$6ae4b26c31b1b0d2 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7ifFE")), {
    moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
});
const $ac3e12d4e74a6458$var$AsyncApiKeyManagement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ac3e12d4e74a6458$export$6ae4b26c31b1b0d2,
        pageId: "async-jira-eoc-api-key-management",
        shouldShowSpinner: false
    });
$ac3e12d4e74a6458$var$AsyncApiKeyManagement.displayName = "AsyncApiKeyManagement";
var $ac3e12d4e74a6458$export$2e2bcd8739ae039 = $ac3e12d4e74a6458$var$AsyncApiKeyManagement;

});
parcelRegister("7ifFE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1YyzA").then(()=>parcelRequire('3tmZX'));

});



parcelRegister("5VrQ2", function(module, exports) {
$parcel$export(module.exports, "eocAssignCustomRolesRouteEntry", () => $c830d20d77b1a5d8$export$c51a4ee3e3f1b270);



var $6RSCO = parcelRequire("6RSCO");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $k7SK2 = parcelRequire("k7SK2");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $1n9pp = parcelRequire("1n9pp");

var $bkrFd = parcelRequire("bkrFd");

var $9bADP = parcelRequire("9bADP");
const $c830d20d77b1a5d8$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $c830d20d77b1a5d8$export$c51a4ee3e3f1b270 = (0, $fdS54.createEntry)((0, $1n9pp.eocAssignCustomRolesRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9bADP.default),
        layout: (0, $7Fzs6.opsSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$c830d20d77b1a5d8$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $k7SK2.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9bADP.LazyAssignCustomRoles)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("k7SK2", function(module, exports) {
$parcel$export(module.exports, "rolesResource", () => $b5b6fe38f0845037$export$52e29d5915d5f674);
$parcel$export(module.exports, "resources", () => $b5b6fe38f0845037$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $1Aa0h = parcelRequire("1Aa0h");
const $b5b6fe38f0845037$export$52e29d5915d5f674 = (0, $7edbf.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $1Aa0h.getRolesEndpoint),
    isBrowserOnly: true
});
const $b5b6fe38f0845037$export$bc99aaabaf7b70a7 = ()=>[
        $b5b6fe38f0845037$export$52e29d5915d5f674
    ];

});
parcelRegister("1Aa0h", function(module, exports) {
$parcel$export(module.exports, "getUsersEndpoint", () => $3e7e6249911f450c$export$d372f7d69e481dba);
$parcel$export(module.exports, "getFilteredUsersEndpoint", () => $3e7e6249911f450c$export$d8f86d9603f031c0);
$parcel$export(module.exports, "getRolesEndpoint", () => $3e7e6249911f450c$export$7d0bc1a3c689fc74);
$parcel$export(module.exports, "updateRoleOfUserEndpoint", () => $3e7e6249911f450c$export$a0b296dc0259976f);

var $hG5S4 = parcelRequire("hG5S4");

var $gm9AA = parcelRequire("gm9AA");
const $3e7e6249911f450c$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, query] = queryKey;
    let url = new (0, $gm9AA.URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
    return (0, $hG5S4.eocFetch)(url);
};
const $3e7e6249911f450c$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, ...filters] = queryKey;
    if (filters.length === 0) return Promise.resolve({
        lastEvaluatedToken: '',
        values: []
    });
    return (0, $hG5S4.eocFetch)('/v1/users/roles/filter', {
        method: 'POST',
        body: {
            limit: limit,
            roles: filters,
            offset: lastEvaluatedToken || 0
        }
    });
};
const $3e7e6249911f450c$export$7d0bc1a3c689fc74 = ()=>{
    return (0, $hG5S4.eocFetch)('/v1/users/roles');
};
const $3e7e6249911f450c$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/roles/assign`, {
        method: 'PATCH',
        body: {
            accountId: accountId,
            roleId: roleId
        }
    });
};

});
parcelRegister("gm9AA", function(module, exports) {
$parcel$export(module.exports, "URLBuilder", () => $310cd88ccb974f4f$export$61d2e8db329a11f8);
class $310cd88ccb974f4f$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                key,
                value && value.toString()
            ]);
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams === '') return `${this.url}`;
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("1n9pp", function(module, exports) {
$parcel$export(module.exports, "eocAssignCustomRolesRoute", () => $5efc9839ccbe4822$export$79c37191a61ac94b);
const $5efc9839ccbe4822$export$79c37191a61ac94b = {
    name: 'eoc-assign-custom-roles',
    path: '/jira/settings/products/ops/role-assignment',
    exact: true
};

});

parcelRegister("9bADP", function(module, exports) {
$parcel$export(module.exports, "LazyAssignCustomRoles", () => $28e29ff38ddf2763$export$fb6bafef9453a357);
$parcel$export(module.exports, "default", () => $28e29ff38ddf2763$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $28e29ff38ddf2763$export$fb6bafef9453a357 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("a1oY2")), {
    moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
});
const $28e29ff38ddf2763$var$AsyncAssignCustomRoles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $28e29ff38ddf2763$export$fb6bafef9453a357,
        pageId: "async-eoc-assign-custom-roles",
        shouldShowSpinner: false
    });
$28e29ff38ddf2763$var$AsyncAssignCustomRoles.displayName = "AsyncAssignCustomRoles";
var $28e29ff38ddf2763$export$2e2bcd8739ae039 = $28e29ff38ddf2763$var$AsyncAssignCustomRoles;

});
parcelRegister("a1oY2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3zCCU").then(()=>parcelRequire('dDIW3'));

});



parcelRegister("bDwmW", function(module, exports) {
$parcel$export(module.exports, "eocAutomationsRouteEntry", () => $a7c6e0d962a1d668$export$6ff606556e19e12);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $dRmkz = parcelRequire("dRmkz");

var $bGY6H = parcelRequire("bGY6H");
const $a7c6e0d962a1d668$export$6ff606556e19e12 = (0, $fdS54.createEntry)((0, $dRmkz.eocAutomationsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $bGY6H.default),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bGY6H.LazyOpsTeamAutomation),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dRmkz", function(module, exports) {
$parcel$export(module.exports, "eocAutomationsRoute", () => $5b8884407f8d99aa$export$4a84eb4d8d37c9d4);
const $5b8884407f8d99aa$export$4a84eb4d8d37c9d4 = {
    name: 'eoc-automations',
    path: '/jira/ops/teams/:teamId/automations',
    exact: true
};

});

parcelRegister("bGY6H", function(module, exports) {
$parcel$export(module.exports, "LazyOpsTeamAutomation", () => $d36fb1b1007f6c3f$export$903a0a44cc0933c5);
$parcel$export(module.exports, "default", () => $d36fb1b1007f6c3f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $d36fb1b1007f6c3f$export$903a0a44cc0933c5 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("98hFK")), {
    moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/ExportedDefault.tsx"
});
const $d36fb1b1007f6c3f$var$AsyncOpsTeamAutomation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $d36fb1b1007f6c3f$export$903a0a44cc0933c5,
        pageId: "ops-team-automation",
        shouldShowSpinner: true
    });
$d36fb1b1007f6c3f$var$AsyncOpsTeamAutomation.displayName = "AsyncOpsTeamAutomation";
var $d36fb1b1007f6c3f$export$2e2bcd8739ae039 = $d36fb1b1007f6c3f$var$AsyncOpsTeamAutomation;

});
parcelRegister("98hFK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gy32K").then(()=>parcelRequire('eAzKn'));

});



parcelRegister("effIZ", function(module, exports) {
$parcel$export(module.exports, "eocChangesRouteEntry", () => $e1adee74411cb7f4$export$a2c69e5556f8d65f);

var $cqFwm = parcelRequire("cqFwm");

var $lvcMe = parcelRequire("lvcMe");

var $iSoIx = parcelRequire("iSoIx");

var $dUAVJ = parcelRequire("dUAVJ");

var $6Hiyd = parcelRequire("6Hiyd");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $2700E = parcelRequire("2700E");
const $e1adee74411cb7f4$var$eocChangesPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $lvcMe.eocChangesEntryPoint)
});
const $e1adee74411cb7f4$export$a2c69e5556f8d65f = (0, $fdS54.createEntry)((0, $cqFwm.eocChangesRoute), ()=>({
        group: 'eoc',
        navigation: {
            menuId: 'PROJECTS'
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6Hiyd.eocServicedeskCustomFieldsResource)
        ],
        entryPoint: ()=>(0, $2700E.expValEquals)('changes-and-incidents-under-operations', 'isEnabled', true, false) ? $e1adee74411cb7f4$var$eocChangesPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cqFwm", function(module, exports) {
$parcel$export(module.exports, "eocChangesRoute", () => $c0fd9628bf566327$export$57223732bd0f219);
const $c0fd9628bf566327$export$57223732bd0f219 = {
    name: 'eoc-changes',
    path: '/jira/ops/changes',
    exact: true
};

});

parcelRegister("lvcMe", function(module, exports) {
$parcel$export(module.exports, "eocChangesEntryPoint", () => $ffd1ea57c9a429ce$export$e05147f5c9934bf8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ffd1ea57c9a429ce$export$e05147f5c9934bf8 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("ftRRC")), {
        moduleId: "d3459d24",
        moduleName: "EocChanges",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ftRRC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4fENK")
]).then(()=>parcelRequire('5hDrR'));

});


parcelRegister("6Hiyd", function(module, exports) {
$parcel$export(module.exports, "eocServicedeskCustomFieldsResource", () => $ebf931d56923c168$export$d177c79ff111c3e6);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $ebf931d56923c168$var$ENDPOINT = '/rest/servicedesk/1/servicedesk/fields';
const $ebf931d56923c168$export$d177c79ff111c3e6 = (0, $7edbf.createResource)({
    type: 'EOC_SERVICEDESK_CUSTOM_FIELDS',
    getKey: ()=>'eoc-servicedesk-custom-fields',
    getData: async ()=>{
        try {
            const response = await (0, $h2wCv.performGetRequest)($ebf931d56923c168$var$ENDPOINT);
            const customFields = Object.fromEntries(response.customFields.map((field)=>[
                    field.mappingKey,
                    {
                        id: field.id,
                        primaryJQLClauseName: field.primaryJQLClauseName
                    }
                ]));
            return customFields;
        } catch  {
            // Pages should still load even if this request fails, so swallow errors and return an empty mapping.
            return {};
        }
    }
});

});


parcelRegister("9gv99", function(module, exports) {
$parcel$export(module.exports, "eocCustomRolesRouteEntry", () => $ddacd9ccf3ece5da$export$9c9bab95d425eb6f);



var $6RSCO = parcelRequire("6RSCO");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $9RgZB = parcelRequire("9RgZB");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $jKXYg = parcelRequire("jKXYg");

var $bkrFd = parcelRequire("bkrFd");

var $5hNCX = parcelRequire("5hNCX");
const $ddacd9ccf3ece5da$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $ddacd9ccf3ece5da$export$9c9bab95d425eb6f = (0, $fdS54.createEntry)((0, $jKXYg.eocCustomRolesRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5hNCX.default),
        layout: (0, $7Fzs6.opsSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$ddacd9ccf3ece5da$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $9RgZB.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5hNCX.LazyCustomRoles)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9RgZB", function(module, exports) {
$parcel$export(module.exports, "customRolesResource", () => $73174f31aa8d9a2c$export$7140716a1b1b8e7a);
$parcel$export(module.exports, "resources", () => $73174f31aa8d9a2c$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $cxqKd = parcelRequire("cxqKd");
const $73174f31aa8d9a2c$export$7140716a1b1b8e7a = (0, $7edbf.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $cxqKd.getCustomRolesListEndpoint),
    isBrowserOnly: true
});
const $73174f31aa8d9a2c$export$bc99aaabaf7b70a7 = ()=>[
        $73174f31aa8d9a2c$export$7140716a1b1b8e7a
    ];

});
parcelRegister("cxqKd", function(module, exports) {
$parcel$export(module.exports, "getPermissionsEndpoint", () => $e2eddfbe363e3c98$export$f97b589720c51ce1);
$parcel$export(module.exports, "createCustomRoleEndpoint", () => $e2eddfbe363e3c98$export$5a7187e04c844900);
$parcel$export(module.exports, "editCustomRoleEndpoint", () => $e2eddfbe363e3c98$export$304735a80b86192e);
$parcel$export(module.exports, "deleteCustomRoleEndpoint", () => $e2eddfbe363e3c98$export$e12995ccad013f65);
$parcel$export(module.exports, "getCustomRolesListEndpoint", () => $e2eddfbe363e3c98$export$3619edac53aa59fd);

var $hG5S4 = parcelRequire("hG5S4");
const $e2eddfbe363e3c98$export$f97b589720c51ce1 = ()=>(0, $hG5S4.eocFetch)(`/v1/users/permissions`);
const $e2eddfbe363e3c98$export$5a7187e04c844900 = (newCustomRole)=>(0, $hG5S4.eocFetch)(`/v1/users/roles`, {
        method: 'POST',
        body: newCustomRole
    });
const $e2eddfbe363e3c98$export$304735a80b86192e = (updatedCustomRole)=>{
    const { id: id } = updatedCustomRole;
    return (0, $hG5S4.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'PATCH',
        body: updatedCustomRole
    });
};
const $e2eddfbe363e3c98$export$e12995ccad013f65 = (id)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'DELETE'
    });
};
const $e2eddfbe363e3c98$export$3619edac53aa59fd = ()=>(0, $hG5S4.eocFetch)(`/v1/users/roles`);

});


parcelRegister("jKXYg", function(module, exports) {
$parcel$export(module.exports, "eocCustomRolesRoute", () => $5b9f66f65138e5ac$export$3213a7325ca9911);
const $5b9f66f65138e5ac$export$3213a7325ca9911 = {
    name: 'eoc-custom-roles',
    path: '/jira/settings/products/ops/roles',
    exact: true
};

});

parcelRegister("5hNCX", function(module, exports) {
$parcel$export(module.exports, "LazyCustomRoles", () => $adb074d95044b3bf$export$78ed54710f55f948);
$parcel$export(module.exports, "default", () => $adb074d95044b3bf$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $adb074d95044b3bf$export$78ed54710f55f948 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("hkubu")), {
    moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
});
const $adb074d95044b3bf$var$AsyncCustomRoles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $adb074d95044b3bf$export$78ed54710f55f948,
        pageId: "async-eoc-custom-roles",
        shouldShowSpinner: false
    });
$adb074d95044b3bf$var$AsyncCustomRoles.displayName = "AsyncCustomRoles";
var $adb074d95044b3bf$export$2e2bcd8739ae039 = $adb074d95044b3bf$var$AsyncCustomRoles;

});
parcelRegister("hkubu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4WX3P").then(()=>parcelRequire('ab1Af'));

});



parcelRegister("lNHO4", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRedirectRouteEntry", () => $369cb7c110b4b2ef$export$4fc438c20edc8a6f);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jKCvj = parcelRequire("jKCvj");

var $jEYuY = parcelRequire("jEYuY");

var $bqxMM = parcelRequire("bqxMM");

var $66CK1 = parcelRequire("66CK1");

var $fdS54 = parcelRequire("fdS54");

var $bcxWd = parcelRequire("bcxWd");

var $9TfOO = parcelRequire("9TfOO");
const $369cb7c110b4b2ef$export$4fc438c20edc8a6f = (0, $fdS54.createEntry)((0, $bcxWd.eocGlobalAlertListRedirectRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9TfOO.AlertListComponent),
        layout: (0, $bqxMM.eocChangeboardingLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jKCvj.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9TfOO.LazyAlertList),
            (0, $66CK1.LazyGlobalAlertsSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $b7e3cc368b5225c1$export$5fd2fc81b4f591a3 = 'HOME';

parcelRegister("jKCvj", function(module, exports) {
$parcel$export(module.exports, "resources", () => $41357d07f685ac08$export$bc99aaabaf7b70a7);

var $egspI = parcelRequire("egspI");

var $144ns = parcelRequire("144ns");

var $lrLEP = parcelRequire("lrLEP");

var $e8rYt = parcelRequire("e8rYt");

var $jheql = parcelRequire("jheql");

var $ajQel = parcelRequire("ajQel");
const $41357d07f685ac08$export$bc99aaabaf7b70a7 = ()=>[
        (0, $ajQel.uiPreferencesResource),
        (0, $jheql.savedSearchesResource),
        (0, $144ns.alertGroupingStateResource),
        ...(0, $egspI.fg)('snr-noise-filter') ? [
            (0, $e8rYt.noiseReductionMetricsResource)
        ] : [],
        ...(0, $lrLEP.eocCommonResources)()
    ];

});
parcelRegister("144ns", function(module, exports) {
$parcel$export(module.exports, "alertGroupingStateResource", () => $8c2fc412991e060c$export$722cc8285202ce44);

var $7edbf = parcelRequire("7edbf");

var $d88zO = parcelRequire("d88zO");
const $8c2fc412991e060c$var$emptyAlertGroupingState = {
    isEnabled: false,
    reason: null
};
const $8c2fc412991e060c$export$722cc8285202ce44 = (0, $7edbf.createResource)({
    type: 'alertGroupingStateResource',
    getKey: ()=>'alertGroupingStateResource',
    getData: async ()=>{
        try {
            const response = await (0, $d88zO.getGroupFeatureStatus)();
            return response;
        } catch (e) {
            // Exception handling and to return emptyState
            return $8c2fc412991e060c$var$emptyAlertGroupingState;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("d88zO", function(module, exports) {
$parcel$export(module.exports, "getGroupFeatureStatus", () => $c5c42ed47f0dad63$export$48deee62d9dfb365);

var $lFnrZ = parcelRequire("lFnrZ");

var $4tVyt = parcelRequire("4tVyt");

var $hG5S4 = parcelRequire("hG5S4");
const $c5c42ed47f0dad63$export$48deee62d9dfb365 = ()=>{
    const featureName = 'alert-grouping-web';
    const url = new (0, $4tVyt.URLBuilder)((0, $lFnrZ.withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', featureName).build();
    return (0, $hG5S4.eocFetch)(url, {
        exactUrl: true
    });
};

});
parcelRegister("4tVyt", function(module, exports) {
$parcel$export(module.exports, "URLBuilder", () => $a7c4422cf622a610$export$61d2e8db329a11f8);
class $a7c4422cf622a610$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("e8rYt", function(module, exports) {
$parcel$export(module.exports, "noiseReductionMetricsResource", () => $b75cb4efa7053e07$export$a4ec207266f7912a);

var $7edbf = parcelRequire("7edbf");

var $bUCC9 = parcelRequire("bUCC9");

var $hG5S4 = parcelRequire("hG5S4");

var $9fOfL = parcelRequire("9fOfL");
var $2zmVr = parcelRequire("2zmVr");

var $2SzSq = parcelRequire("2SzSq");

var $1Mmhc = parcelRequire("1Mmhc");
const $b75cb4efa7053e07$var$MULTI_SELECT_VALUE_SEP = ',';
const $b75cb4efa7053e07$var$extractResponderIds = (query)=>{
    if (!query) return [];
    const tokens = (0, $2zmVr.tokenizer)(query);
    // Split tokens into groups by 'AND' and 'OR' operators
    const tokenGroups = tokens.length ? tokens.reduce((acc, token)=>{
        if (token.type === 'LOGICAL_OPERATOR' && (token.value.toLowerCase() === (0, $9fOfL.LOGICAL_OPERATOR_AND).toLowerCase() || token.value.toLowerCase() === (0, $9fOfL.LOGICAL_OPERATOR_OR).toLowerCase())) acc.push([]);
        else acc[acc.length - 1].push(token);
        return acc;
    }, [
        []
    ]) : [];
    // Find ALL token groups that contain responders identifier
    const responderTokenGroups = tokenGroups.filter((tokenGroup)=>tokenGroup.find((token)=>token.type === 'IDENTIFIER' && token.value === (0, $9fOfL.IDENTIFIER_RESPONDERS)));
    if (responderTokenGroups.length === 0) return [];
    // Extract responder IDs from all responder token groups
    const allResponderIds = [];
    for (const responderTokenGroup of responderTokenGroups){
        // Find the value token (STRING_LITERAL or NUMBER_LITERAL) after the responders identifier
        const responderIndex = responderTokenGroup.findIndex((token)=>token.type === 'IDENTIFIER' && token.value === (0, $9fOfL.IDENTIFIER_RESPONDERS));
        const valueToken = responderTokenGroup.slice(responderIndex + 1).find((token)=>token.type === 'STRING_LITERAL' || token.type === 'NUMBER_LITERAL');
        if (valueToken) {
            const responderIds = valueToken.value.split($b75cb4efa7053e07$var$MULTI_SELECT_VALUE_SEP).map((0, $2SzSq.removeQuotes));
            allResponderIds.push(...responderIds);
        }
    }
    // Remove duplicates and return
    return Array.from(new Set(allResponderIds));
};
const $b75cb4efa7053e07$export$a4ec207266f7912a = (0, $7edbf.createResource)({
    type: 'noiseReductionMetricsResource',
    getKey: (routerContext)=>{
        const query = routerContext.query[0, $bUCC9.QUERY_PARAMETER_QUERY_LABEL];
        const responderIds = $b75cb4efa7053e07$var$extractResponderIds(query);
        const responderIdsKey = responderIds.sort().join(',');
        return `noisyAlertsMetricsResource-${responderIdsKey}`;
    },
    getData: async (routerContext)=>{
        const query = routerContext.query[0, $bUCC9.QUERY_PARAMETER_QUERY_LABEL];
        const responderIds = $b75cb4efa7053e07$var$extractResponderIds(query);
        // Filter out team responders by checking if they are teams
        let nonTeamResponderIds = responderIds;
        if (responderIds.length > 0) {
            // Check which responder IDs are teams
            const requestedResponders = responderIds.map((id)=>({
                    id: id,
                    type: 'team'
                }));
            const responderNamesResponse = await (0, $hG5S4.eocFetch)(`/v1/alerts/responders/names`, {
                method: 'POST',
                body: {
                    responders: requestedResponders
                }
            });
            // Get the IDs that matched as teams
            const teamIds = new Set(responderNamesResponse.values.filter((responder)=>responder.type === 'team').map((responder)=>responder.id));
            // Filter out teams - keep only non-team responders
            nonTeamResponderIds = responderIds.filter((id)=>!teamIds.has(id));
        }
        const response = await (0, $1Mmhc.getNoisyReductionMetrics)(nonTeamResponderIds);
        return response;
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("bUCC9", function(module, exports) {
$parcel$export(module.exports, "QUERY_PARAMETER_QUERY_LABEL", () => $e844f3078e35139d$export$19f7845e9b507cf2);
$parcel$export(module.exports, "QUERY_PARAMETER_VIEW_LABEL", () => $e844f3078e35139d$export$8540b2e79718c77f);
$parcel$export(module.exports, "QUERY_PARAMETER_ONLY_ALERTS_LABEL", () => $e844f3078e35139d$export$d0190736add6775e);
$parcel$export(module.exports, "BASE_URL", () => $e844f3078e35139d$export$ca6dda5263526f75);
$parcel$export(module.exports, "ALERT_LIST_SPOTLIGHT_TARGETS", () => $e844f3078e35139d$export$84fe9cd6ee892532);
const $e844f3078e35139d$export$19f7845e9b507cf2 = 'query';
const $e844f3078e35139d$export$8540b2e79718c77f = 'view';
const $e844f3078e35139d$export$d0190736add6775e = 'onlyAlerts';
const $e844f3078e35139d$export$ca6dda5263526f75 = '/jira/ops';
const $e844f3078e35139d$export$84fe9cd6ee892532 = {
    sidebar: 'operations-alert-sidebar-target',
    alertHeader: 'operations-alert-header-target',
    alertActions: 'operations-alert-actions-target',
    alertSources: 'operations-alert-sources-target',
    alertResponders: 'operations-alert-responders-target'
};

});

parcelRegister("9fOfL", function(module, exports) {
$parcel$export(module.exports, "TOKEN_TYPES", () => $af4a99e80de9a632$export$e92b897d610f2aba);
$parcel$export(module.exports, "LEFT_PARENTHESIS", () => $af4a99e80de9a632$export$9ce7f372949a1546);
$parcel$export(module.exports, "RIGHT_PARENTHESIS", () => $af4a99e80de9a632$export$bbbb3f477a9839e0);
$parcel$export(module.exports, "OPERATOR_EQUAL_TO", () => $af4a99e80de9a632$export$ea7497008076d6d2);
$parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", () => $af4a99e80de9a632$export$e75c84803c67e1f4);
$parcel$export(module.exports, "LOGICAL_OPERATOR_AND", () => $af4a99e80de9a632$export$61308b2610174a70);
$parcel$export(module.exports, "LOGICAL_OPERATOR_OR", () => $af4a99e80de9a632$export$1de654320eb3e523);
$parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", () => $af4a99e80de9a632$export$ff7eed6ac2251302);
$parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", () => $af4a99e80de9a632$export$4b436fec6f13b741);
$parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", () => $af4a99e80de9a632$export$8cbc171ac4843075);
$parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", () => $af4a99e80de9a632$export$347c7cb6285a1d61);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", () => $af4a99e80de9a632$export$910131ff5cd3d496);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", () => $af4a99e80de9a632$export$2aa0d26cb4549272);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", () => $af4a99e80de9a632$export$572cec90aa166025);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", () => $af4a99e80de9a632$export$f94109650ec67751);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", () => $af4a99e80de9a632$export$3a3a37e9da45a2a4);
$parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", () => $af4a99e80de9a632$export$9ef3f42fa10fce44);
$parcel$export(module.exports, "NULL_LITERAL", () => $af4a99e80de9a632$export$c2b6d31a7a2d40ba);
$parcel$export(module.exports, "IDENTIFIER_ALIAS", () => $af4a99e80de9a632$export$21c480ed86e9d13);
$parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", () => $af4a99e80de9a632$export$534c195089710c34);
$parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", () => $af4a99e80de9a632$export$4699ad3805947d4d);
$parcel$export(module.exports, "IDENTIFIER_ENTITY", () => $af4a99e80de9a632$export$2a30b5099ba66c99);
$parcel$export(module.exports, "IDENTIFIER_IS_SEEN", () => $af4a99e80de9a632$export$7926b4c2836db847);
$parcel$export(module.exports, "IDENTIFIER_MESSAGE", () => $af4a99e80de9a632$export$5a8895646b1d5248);
$parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", () => $af4a99e80de9a632$export$4047502bdab1e205);
$parcel$export(module.exports, "IDENTIFIER_PRIORITY", () => $af4a99e80de9a632$export$5922c06b76ebb57d);
$parcel$export(module.exports, "IDENTIFIER_COMPONENTS", () => $af4a99e80de9a632$export$1122634b5d555f05);
$parcel$export(module.exports, "IDENTIFIER_SERVICES", () => $af4a99e80de9a632$export$ec912454cd7d858a);
$parcel$export(module.exports, "IDENTIFIER_RESPONDERS", () => $af4a99e80de9a632$export$44673ddac1790242);
$parcel$export(module.exports, "IDENTIFIER_SOURCE", () => $af4a99e80de9a632$export$f250d53474e801dc);
$parcel$export(module.exports, "IDENTIFIER_STATUS", () => $af4a99e80de9a632$export$43181828ba8680e4);
$parcel$export(module.exports, "IDENTIFIER_TAG", () => $af4a99e80de9a632$export$8242733866920892);
$parcel$export(module.exports, "IDENTIFIER_TINY_ID", () => $af4a99e80de9a632$export$c833829cf31052f0);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", () => $af4a99e80de9a632$export$5f1e5c89a704810f);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", () => $af4a99e80de9a632$export$89d93eb7117999c0);
$parcel$export(module.exports, "IDENTIFIER_TEAMS", () => $af4a99e80de9a632$export$a79eb1864dd7b745);
$parcel$export(module.exports, "IDENTIFIER_SNR_CLASSIFICATION", () => $af4a99e80de9a632$export$d21cb4c48fd902e9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", () => $af4a99e80de9a632$export$888a9cda49b5e18c);
$parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", () => $af4a99e80de9a632$export$60745b712d37edf9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", () => $af4a99e80de9a632$export$b38df7dc61d42293);
$parcel$export(module.exports, "splitToTokensRegex", () => $af4a99e80de9a632$export$28041d1d2a85f002);
$parcel$export(module.exports, "isKeywordRegex", () => $af4a99e80de9a632$export$290f3472231a2ca1);
$parcel$export(module.exports, "isModifierRegex", () => $af4a99e80de9a632$export$56079d3966b6b26c);
$parcel$export(module.exports, "isComplexOperatorRegex", () => $af4a99e80de9a632$export$3f6ac43c2355116b);
$parcel$export(module.exports, "isWSRegex", () => $af4a99e80de9a632$export$b1b0fc0dc5c83a12);
$parcel$export(module.exports, "isIdentifierRegex", () => $af4a99e80de9a632$export$218cf3eb73c65394);
$parcel$export(module.exports, "isLogicalOperatorRegex", () => $af4a99e80de9a632$export$a46484930d6fa80f);
$parcel$export(module.exports, "isOperatorRegex", () => $af4a99e80de9a632$export$d48805fc5b137dc9);
/**
 * Token types
 */ const $af4a99e80de9a632$export$e92b897d610f2aba = [
    'WHITE_SPACE',
    'SEPARATOR',
    'IDENTIFIER',
    'MODIFIER',
    'KEYWORD',
    'LOGICAL_OPERATOR',
    'STRING_LITERAL',
    'NUMBER_LITERAL',
    'BOOLEAN_LITERAL',
    'NULL_LITERAL',
    'OPERATOR'
];
const $af4a99e80de9a632$export$9ce7f372949a1546 = '(';
const $af4a99e80de9a632$export$bbbb3f477a9839e0 = ')';
const $af4a99e80de9a632$export$adbc66edc544fda9 = '=';
const $af4a99e80de9a632$export$fbd271ef020db0c = '!=';
const $af4a99e80de9a632$export$ea7497008076d6d2 = ':';
const $af4a99e80de9a632$export$6d44219c9e0c2567 = '!:';
const $af4a99e80de9a632$export$f8636d23c210043c = '<';
const $af4a99e80de9a632$export$1892bd0c818db570 = '<=';
const $af4a99e80de9a632$export$386b1ae18a32d690 = '>';
const $af4a99e80de9a632$export$44a62afa61d82568 = '>=';
const $af4a99e80de9a632$export$e75c84803c67e1f4 = [
    $af4a99e80de9a632$export$adbc66edc544fda9,
    $af4a99e80de9a632$export$f8636d23c210043c,
    $af4a99e80de9a632$export$1892bd0c818db570,
    $af4a99e80de9a632$export$386b1ae18a32d690,
    $af4a99e80de9a632$export$44a62afa61d82568
];
const $af4a99e80de9a632$export$61308b2610174a70 = 'AND';
const $af4a99e80de9a632$export$1de654320eb3e523 = 'OR';
const $af4a99e80de9a632$export$184522872a5410fc = 'not';
const $af4a99e80de9a632$export$ff7eed6ac2251302 = 'true';
const $af4a99e80de9a632$export$4b436fec6f13b741 = 'false';
const $af4a99e80de9a632$export$8cbc171ac4843075 = [
    $af4a99e80de9a632$export$ff7eed6ac2251302,
    $af4a99e80de9a632$export$4b436fec6f13b741
];
const $af4a99e80de9a632$export$347c7cb6285a1d61 = '"';
const $af4a99e80de9a632$export$d84ab70dc909b702 = "'";
const $af4a99e80de9a632$export$910131ff5cd3d496 = `${$af4a99e80de9a632$export$347c7cb6285a1d61}open${$af4a99e80de9a632$export$347c7cb6285a1d61}`;
const $af4a99e80de9a632$export$2aa0d26cb4549272 = `${$af4a99e80de9a632$export$347c7cb6285a1d61}closed${$af4a99e80de9a632$export$347c7cb6285a1d61}`;
const $af4a99e80de9a632$export$572cec90aa166025 = `${$af4a99e80de9a632$export$347c7cb6285a1d61}acknowledged${$af4a99e80de9a632$export$347c7cb6285a1d61}`;
const $af4a99e80de9a632$export$f94109650ec67751 = `${$af4a99e80de9a632$export$347c7cb6285a1d61}snoozed${$af4a99e80de9a632$export$347c7cb6285a1d61}`;
const $af4a99e80de9a632$export$3a3a37e9da45a2a4 = [
    $af4a99e80de9a632$export$910131ff5cd3d496,
    $af4a99e80de9a632$export$2aa0d26cb4549272,
    $af4a99e80de9a632$export$572cec90aa166025,
    $af4a99e80de9a632$export$f94109650ec67751
];
const $af4a99e80de9a632$export$928c1edd572e94f0 = 'P1';
const $af4a99e80de9a632$export$22202070e5f64c55 = 'P2';
const $af4a99e80de9a632$export$537865d58d2072a3 = 'P3';
const $af4a99e80de9a632$export$3d5cfea3feefee83 = 'P4';
const $af4a99e80de9a632$export$fe945cac89cd21a5 = 'P5';
const $af4a99e80de9a632$export$9ef3f42fa10fce44 = [
    $af4a99e80de9a632$export$928c1edd572e94f0,
    $af4a99e80de9a632$export$22202070e5f64c55,
    $af4a99e80de9a632$export$537865d58d2072a3,
    $af4a99e80de9a632$export$3d5cfea3feefee83,
    $af4a99e80de9a632$export$fe945cac89cd21a5
];
const $af4a99e80de9a632$export$c2b6d31a7a2d40ba = 'null';
const $af4a99e80de9a632$export$5a484b762b542c13 = 'actions';
const $af4a99e80de9a632$export$21c480ed86e9d13 = 'alias';
const $af4a99e80de9a632$export$534c195089710c34 = 'closedBy';
const $af4a99e80de9a632$export$4699ad3805947d4d = 'count';
const $af4a99e80de9a632$export$7c3401d7874d69f5 = 'createdAt';
const $af4a99e80de9a632$export$afffcbd5b444e040 = 'description';
const $af4a99e80de9a632$export$e1e61c3bf43fff11 = 'details.key';
const $af4a99e80de9a632$export$aa35da9746edbfe2 = 'details.value';
const $af4a99e80de9a632$export$b620b7163533b409 = 'detailsPair';
const $af4a99e80de9a632$export$2a30b5099ba66c99 = 'entity';
const $af4a99e80de9a632$export$2bfb49435a331d16 = 'integration.name';
const $af4a99e80de9a632$export$feced558810f4b3e = 'integration.type';
const $af4a99e80de9a632$export$7926b4c2836db847 = 'isSeen';
const $af4a99e80de9a632$export$5a8895646b1d5248 = 'message';
const $af4a99e80de9a632$export$4047502bdab1e205 = 'owner';
const $af4a99e80de9a632$export$5922c06b76ebb57d = 'priority';
const $af4a99e80de9a632$export$1122634b5d555f05 = 'components';
const $af4a99e80de9a632$export$ec912454cd7d858a = 'services';
const $af4a99e80de9a632$export$44673ddac1790242 = 'responders';
const $af4a99e80de9a632$export$f250d53474e801dc = 'source';
const $af4a99e80de9a632$export$43181828ba8680e4 = 'status';
const $af4a99e80de9a632$export$a1959e1b76e880dd = 'sync.name';
const $af4a99e80de9a632$export$8417ff61f7a57db6 = 'sync.type';
const $af4a99e80de9a632$export$8242733866920892 = 'tags';
const $af4a99e80de9a632$export$c833829cf31052f0 = 'tinyId';
const $af4a99e80de9a632$export$78d4faf48faf13c2 = 'updatedAt';
const $af4a99e80de9a632$export$5f1e5c89a704810f = 'acknowledged';
const $af4a99e80de9a632$export$89d93eb7117999c0 = 'acknowledgedBy';
const $af4a99e80de9a632$export$1ee0ad656333fc23 = 'aggregatorIds';
const $af4a99e80de9a632$export$d42da2034504d6de = 'alertId';
const $af4a99e80de9a632$export$8464a15b62fb09bb = 'alertType';
const $af4a99e80de9a632$export$2f7ba2848fc019c6 = 'encrypted';
const $af4a99e80de9a632$export$86e4b68c61c8cca5 = 'encryptionId';
const $af4a99e80de9a632$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
const $af4a99e80de9a632$export$8508b76d4c14d7e = 'notify';
const $af4a99e80de9a632$export$e73ddf8d219f28b7 = 'snoozedUntil';
const $af4a99e80de9a632$export$a79eb1864dd7b745 = 'teams';
const $af4a99e80de9a632$export$d21cb4c48fd902e9 = 'snrClassification';
const $af4a99e80de9a632$export$888a9cda49b5e18c = [
    $af4a99e80de9a632$export$5f1e5c89a704810f,
    $af4a99e80de9a632$export$89d93eb7117999c0,
    $af4a99e80de9a632$export$1ee0ad656333fc23,
    $af4a99e80de9a632$export$d42da2034504d6de,
    $af4a99e80de9a632$export$8464a15b62fb09bb,
    $af4a99e80de9a632$export$2f7ba2848fc019c6,
    $af4a99e80de9a632$export$86e4b68c61c8cca5,
    $af4a99e80de9a632$export$cd9dc7ab4d04d11c,
    $af4a99e80de9a632$export$8508b76d4c14d7e,
    $af4a99e80de9a632$export$e73ddf8d219f28b7,
    $af4a99e80de9a632$export$a79eb1864dd7b745,
    $af4a99e80de9a632$export$5a484b762b542c13,
    $af4a99e80de9a632$export$21c480ed86e9d13,
    $af4a99e80de9a632$export$534c195089710c34,
    $af4a99e80de9a632$export$4699ad3805947d4d,
    $af4a99e80de9a632$export$7c3401d7874d69f5,
    $af4a99e80de9a632$export$afffcbd5b444e040,
    $af4a99e80de9a632$export$e1e61c3bf43fff11,
    $af4a99e80de9a632$export$aa35da9746edbfe2,
    $af4a99e80de9a632$export$b620b7163533b409,
    $af4a99e80de9a632$export$2a30b5099ba66c99,
    $af4a99e80de9a632$export$2bfb49435a331d16,
    $af4a99e80de9a632$export$feced558810f4b3e,
    $af4a99e80de9a632$export$7926b4c2836db847,
    $af4a99e80de9a632$export$5a8895646b1d5248,
    $af4a99e80de9a632$export$4047502bdab1e205,
    $af4a99e80de9a632$export$5922c06b76ebb57d,
    $af4a99e80de9a632$export$44673ddac1790242,
    $af4a99e80de9a632$export$1122634b5d555f05,
    $af4a99e80de9a632$export$ec912454cd7d858a,
    $af4a99e80de9a632$export$f250d53474e801dc,
    $af4a99e80de9a632$export$43181828ba8680e4,
    $af4a99e80de9a632$export$a1959e1b76e880dd,
    $af4a99e80de9a632$export$8417ff61f7a57db6,
    $af4a99e80de9a632$export$8242733866920892,
    $af4a99e80de9a632$export$c833829cf31052f0,
    $af4a99e80de9a632$export$78d4faf48faf13c2,
    $af4a99e80de9a632$export$d21cb4c48fd902e9
];
const $af4a99e80de9a632$export$60745b712d37edf9 = [
    $af4a99e80de9a632$export$5f1e5c89a704810f,
    $af4a99e80de9a632$export$7926b4c2836db847
];
const $af4a99e80de9a632$export$b38df7dc61d42293 = [
    ...$af4a99e80de9a632$export$888a9cda49b5e18c
];
/**
 * Regex definitions
 */ // The main regex to split any given query into smaller tokens.
// Please be aware that token order has a meaning here.
const $af4a99e80de9a632$var$splitToTokensCases = [
    // 1. Split single and double quotes
    ...[
        $af4a99e80de9a632$export$d84ab70dc909b702,
        $af4a99e80de9a632$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*?${i})`),
    ...[
        $af4a99e80de9a632$export$d84ab70dc909b702,
        $af4a99e80de9a632$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*)`),
    // 2. Split operators and separators
    ...[
        $af4a99e80de9a632$export$9ce7f372949a1546,
        $af4a99e80de9a632$export$bbbb3f477a9839e0,
        $af4a99e80de9a632$export$adbc66edc544fda9,
        $af4a99e80de9a632$export$fbd271ef020db0c,
        $af4a99e80de9a632$export$ea7497008076d6d2,
        $af4a99e80de9a632$export$6d44219c9e0c2567,
        $af4a99e80de9a632$export$44a62afa61d82568,
        $af4a99e80de9a632$export$386b1ae18a32d690,
        $af4a99e80de9a632$export$1892bd0c818db570,
        $af4a99e80de9a632$export$f8636d23c210043c
    ].map((i)=>`(\\${i})`),
    // 3. Split the exact keywords when it's a known literal
    // Known issue: The word boundary in the beginning does not capture letters except latin chars, digits and underscore, i.e. "+and" results to STRING_LITERAL + BOOLEAN_LITERAL
    ...[
        $af4a99e80de9a632$export$61308b2610174a70,
        $af4a99e80de9a632$export$1de654320eb3e523,
        $af4a99e80de9a632$export$ff7eed6ac2251302,
        $af4a99e80de9a632$export$4b436fec6f13b741,
        $af4a99e80de9a632$export$184522872a5410fc,
        `is\\s*null`,
        `is\\s*not\\s*null`
    ].map((i)=>`(\\b${i}(?=\\s|$))`),
    // 4. Empty spaces
    '(\\s+)'
];
const $af4a99e80de9a632$export$28041d1d2a85f002 = new RegExp($af4a99e80de9a632$var$splitToTokensCases.join('|'), 'gi');
const $af4a99e80de9a632$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
const $af4a99e80de9a632$export$56079d3966b6b26c = /^not$/i;
const $af4a99e80de9a632$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
const $af4a99e80de9a632$export$b1b0fc0dc5c83a12 = /^\s+$/;
const $af4a99e80de9a632$export$218cf3eb73c65394 = new RegExp($af4a99e80de9a632$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
const $af4a99e80de9a632$export$a46484930d6fa80f = /^and$|^or$/i;
const $af4a99e80de9a632$export$d48805fc5b137dc9 = /^[=:<>]$/;

});

parcelRegister("2zmVr", function(module, exports) {
$parcel$export(module.exports, "tokenizer", () => $0121de35b70ec199$export$5f8c09e3ae6f64e1);

var $9fOfL = parcelRequire("9fOfL");
const $0121de35b70ec199$var$isIntegerString = (value)=>{
    const regExp = new RegExp(/^([-]{0,1}[0-9])*$/);
    return typeof value === 'string' && regExp.test(value);
};
const $0121de35b70ec199$export$5f8c09e3ae6f64e1 = (query)=>{
    const items = query.split((0, $9fOfL.splitToTokensRegex)).filter(Boolean);
    return items.map((item)=>{
        if ((0, $9fOfL.isWSRegex).test(item)) return {
            type: 'WHITE_SPACE',
            value: item
        };
        else if ((0, $9fOfL.isLogicalOperatorRegex).test(item)) return {
            type: 'LOGICAL_OPERATOR',
            value: item
        };
        else if ((0, $9fOfL.isComplexOperatorRegex).test(item)) return {
            type: 'OPERATOR',
            value: item
        };
        else if ((0, $9fOfL.isOperatorRegex).test(item)) return {
            type: 'OPERATOR',
            value: item
        };
        else if (item === (0, $9fOfL.LEFT_PARENTHESIS) || item === (0, $9fOfL.RIGHT_PARENTHESIS)) return {
            type: 'SEPARATOR',
            value: item
        };
        else if ((0, $9fOfL.isIdentifierRegex).test(item)) return {
            type: 'IDENTIFIER',
            value: item
        };
        else if ((0, $9fOfL.isModifierRegex).test(item)) return {
            type: 'MODIFIER',
            value: item
        };
        else if ((0, $9fOfL.isKeywordRegex).test(item)) return {
            type: 'KEYWORD',
            value: item
        };
        else if (item.toLowerCase() === (0, $9fOfL.NULL_LITERAL)) return {
            type: 'NULL_LITERAL',
            value: item
        };
        else if ($0121de35b70ec199$var$isIntegerString(item)) return {
            type: 'NUMBER_LITERAL',
            value: item
        };
        else if (item.toLowerCase() === (0, $9fOfL.BOOLEAN_LITERAL_TRUE) || item.toLowerCase() === (0, $9fOfL.BOOLEAN_LITERAL_FALSE)) return {
            type: 'BOOLEAN_LITERAL',
            value: item
        };
        else return {
            type: 'STRING_LITERAL',
            value: item
        };
    });
};

});

parcelRegister("2SzSq", function(module, exports) {
$parcel$export(module.exports, "validateTimeInput", () => $79146ce34efdfc15$export$8880da3ae4274888);
$parcel$export(module.exports, "validateBetweenInput", () => $79146ce34efdfc15$export$57c3e855fbf300fa);
$parcel$export(module.exports, "isInvalidDateValue", () => $79146ce34efdfc15$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "removeQuotes", () => $79146ce34efdfc15$export$dd2bdf5049bf0915);
$parcel$export(module.exports, "withQuote", () => $79146ce34efdfc15$export$8708814d32e406db);
$parcel$export(module.exports, "calculateTimes", () => $79146ce34efdfc15$export$b362bc6892126b7a);
$parcel$export(module.exports, "getDefaultFilterQuery", () => $79146ce34efdfc15$export$16cce822d8159876);
$parcel$export(module.exports, "isResponderAlert", () => $79146ce34efdfc15$export$78656db4ffc3ccd8);
$parcel$export(module.exports, "isGroupAlert", () => $79146ce34efdfc15$export$be2243d4df51c704);
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $79146ce34efdfc15$export$81c70e0016508593);
$parcel$export(module.exports, "getCloudIdForDevEnvironment", () => $79146ce34efdfc15$export$fc6ce7ac2248d7f5);

var $dGdlo = parcelRequire("dGdlo");

var $7cCLc = parcelRequire("7cCLc");

var $9Ctw7 = parcelRequire("9Ctw7");

var $egspI = parcelRequire("egspI");

var $7nxyA = parcelRequire("7nxyA");

var $kFsUA = parcelRequire("kFsUA");
var $9fOfL = parcelRequire("9fOfL");

var $a7bbm = parcelRequire("a7bbm");

var $ev5JY = parcelRequire("ev5JY");
var $2wjE9 = parcelRequire("2wjE9");

var $gIMgJ = parcelRequire("gIMgJ");
const $79146ce34efdfc15$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
    if (!timeDigits) return;
    const timeDigitsNumber = parseInt(timeDigits);
    if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, $a7bbm.default).validNumber);
    if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, $a7bbm.default).hoursNotInRange);
    if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, $a7bbm.default).daysNotInRange);
    if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, $a7bbm.default).weeksNotInRange);
    if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, $a7bbm.default).monthsNotInRange);
    if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, $a7bbm.default).yearsNotInRange);
};
const $79146ce34efdfc15$export$57c3e855fbf300fa = (intl, value)=>{
    if ((0, $egspI.fg)('alx-242-between-filter-strict-validation')) {
        const startDate = value?.startDate ?? '';
        const endDate = value?.endDate ?? '';
        const isStartValid = !!startDate && !$79146ce34efdfc15$export$f18cd4bc58b99a27(startDate);
        const isEndValid = !!endDate && !$79146ce34efdfc15$export$f18cd4bc58b99a27(endDate);
        if (!isStartValid && !isEndValid) return intl.formatMessage((0, $a7bbm.default).validationMessageMissingDate);
        if (isStartValid && isEndValid && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $a7bbm.default).validationMessageBeforeGreaterThanAfter);
        return;
    }
    if (value) {
        const { startDate: startDate, endDate: endDate } = value;
        if (!startDate && !endDate) return;
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $a7bbm.default).validationMessageBeforeGreaterThanAfter);
        if (value && (startDate !== '' && !(0, $dGdlo.default)(new Date(startDate)) || endDate !== '' && !(0, $dGdlo.default)(new Date(endDate)))) return intl.formatMessage((0, $a7bbm.default).validationMessageInvalidDateFormat);
    }
    return;
};
const $79146ce34efdfc15$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $dGdlo.default)((0, $7cCLc.default)(value)) && value !== '';
};
const $79146ce34efdfc15$export$dd2bdf5049bf0915 = (value)=>{
    return value.replace(/^"(.*)"$/, '$1');
};
const $79146ce34efdfc15$export$d4aae9ad13afd6c = (data)=>{
    return {
        ...data,
        label: data.name,
        value: data.id
    };
};
const $79146ce34efdfc15$export$8708814d32e406db = (value)=>{
    if ((0, $kFsUA.hasSpaceRegEx).test(value) || (0, $kFsUA.hasColonRegex).test(value)) {
        if ((0, $kFsUA.hasStartingQuotesRegex).test(value) && (0, $kFsUA.hasEndingQuotesRegex).test(value) && (0, $egspI.fg)('alx-10642-operations-alert-list-search-quotation')) return value;
        return `${0, $9fOfL.STRING_LITERAL_DOUBLE_QUOTE}${value}${0, $9fOfL.STRING_LITERAL_DOUBLE_QUOTE}`;
    } else return value;
};
const $79146ce34efdfc15$export$b362bc6892126b7a = (time)=>{
    if (!time) return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'all') return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'custom') return {
        from: time.from,
        to: time.to
    };
    const now = new Date();
    const subAmount = {
        [time.range]: time.value
    };
    return {
        from: (0, $9Ctw7.default)(now, subAmount).getTime(),
        to: now.getTime()
    };
};
const $79146ce34efdfc15$export$16cce822d8159876 = (query, teamId)=>{
    if (teamId) {
        if (query) return `${0, $9fOfL.IDENTIFIER_RESPONDERS}: ${teamId} ${0, $9fOfL.LOGICAL_OPERATOR_AND} ${query}`;
        return `${0, $9fOfL.IDENTIFIER_RESPONDERS}: ${teamId}`;
    }
    return query;
};
const $79146ce34efdfc15$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
const $79146ce34efdfc15$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
const $79146ce34efdfc15$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $7nxyA.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
const $79146ce34efdfc15$var$isDevEnvironment = ()=>{
    return typeof $gIMgJ !== 'undefined' && ($gIMgJ?.env?.STORYBOOK === 'true' || $gIMgJ?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
};
const $79146ce34efdfc15$export$fc6ce7ac2248d7f5 = ()=>{
    if ($79146ce34efdfc15$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
    return undefined;
};

});
parcelRegister("kFsUA", function(module, exports) {
$parcel$export(module.exports, "TAB_KEY", () => $a8400b5568cdf89d$export$da8c7facc28740b1);
$parcel$export(module.exports, "ENTER_KEY", () => $a8400b5568cdf89d$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $a8400b5568cdf89d$export$728705b4513abbb5);
$parcel$export(module.exports, "SPACE_KEY", () => $a8400b5568cdf89d$export$a47625ee19580f99);
$parcel$export(module.exports, "LEFT_KEY", () => $a8400b5568cdf89d$export$ba950c21a0561bed);
$parcel$export(module.exports, "UP_KEY", () => $a8400b5568cdf89d$export$16859d5882a95fea);
$parcel$export(module.exports, "RIGHT_KEY", () => $a8400b5568cdf89d$export$4b96cad863d88376);
$parcel$export(module.exports, "DOWN_KEY", () => $a8400b5568cdf89d$export$fc0cf2556509233e);
$parcel$export(module.exports, "hasSpaceRegEx", () => $a8400b5568cdf89d$export$a07ca273fbeffcb8);
$parcel$export(module.exports, "hasStartingQuotesRegex", () => $a8400b5568cdf89d$export$a3aaedcec21ac282);
$parcel$export(module.exports, "hasEndingQuotesRegex", () => $a8400b5568cdf89d$export$e5ad519d04ef012a);
$parcel$export(module.exports, "hasNewLinesRegex", () => $a8400b5568cdf89d$export$7645e556e9948ecd);
$parcel$export(module.exports, "EMAIL_REGEX", () => $a8400b5568cdf89d$export$7b7637218245c8a);
$parcel$export(module.exports, "hasColonRegex", () => $a8400b5568cdf89d$export$65a2b373cb60e599);
const $a8400b5568cdf89d$export$da8c7facc28740b1 = 'Tab';
const $a8400b5568cdf89d$export$4162dbd8c730437 = 'Enter';
const $a8400b5568cdf89d$export$728705b4513abbb5 = 'Escape';
const $a8400b5568cdf89d$export$a47625ee19580f99 = ' ';
const $a8400b5568cdf89d$export$ba950c21a0561bed = 'ArrowLeft';
const $a8400b5568cdf89d$export$16859d5882a95fea = 'ArrowUp';
const $a8400b5568cdf89d$export$4b96cad863d88376 = 'ArrowRight';
const $a8400b5568cdf89d$export$fc0cf2556509233e = 'ArrowDown';
const $a8400b5568cdf89d$export$a07ca273fbeffcb8 = /\s/;
const $a8400b5568cdf89d$export$8866d083cd03ffd7 = /^\s|\s$/;
const $a8400b5568cdf89d$export$a3aaedcec21ac282 = /^('|")/;
const $a8400b5568cdf89d$export$e5ad519d04ef012a = /('|")$/;
const $a8400b5568cdf89d$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
const $a8400b5568cdf89d$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $a8400b5568cdf89d$export$65a2b373cb60e599 = /:/;

});

parcelRegister("a7bbm", function(module, exports) {
$parcel$export(module.exports, "default", () => $49733607d15169b2$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $49733607d15169b2$var$messages = (0, $7eNDO.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after`,
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.alert-list.common.utils.validation-message-invalid-date-format`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageMissingDate: {
        id: `eoc.alert-list.common.utils.validation-message-missing-date`,
        defaultMessage: 'Please provide at least one valid date.',
        description: 'Validation message shown in the alert list time filter "Between" mode when neither the from date nor the to date has been provided with a valid value.'
    },
    validNumber: {
        id: `eoc.alert-list.common.utils.validation-not-number`,
        defaultMessage: 'Enter a valid number.',
        description: 'The error message that shown when user write different chars other than numeric chars.'
    },
    hoursNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range`,
        defaultMessage: 'Enter a number between 1-99999.',
        description: 'Message displayed to the user when hours value is not in range'
    },
    daysNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-days-not-in-range`,
        defaultMessage: 'Enter a number between 1-9999.',
        description: 'Message displayed to the user when days value is not in range'
    },
    weeksNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range`,
        defaultMessage: 'Enter a number between 1-999.',
        description: 'Message displayed to the user when weeks value is not in range'
    },
    monthsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-months-not-in-range`,
        defaultMessage: 'Enter a number between 1-99.',
        description: 'Message displayed to the user when months value is not in range'
    },
    yearsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-years-not-in-range`,
        defaultMessage: 'Enter a number between 1-9.',
        description: 'Message displayed to the user when years value is not in range'
    }
});
var $49733607d15169b2$export$2e2bcd8739ae039 = $49733607d15169b2$var$messages;

});

parcelRegister("ev5JY", function(module, exports) {
$parcel$export(module.exports, "useAllActions", () => $fde200b4dbe7c5e5$export$acd577492a98befc);

var $euxye = parcelRequire("euxye");

var $4LDqh = parcelRequire("4LDqh");

var $d5Cgz = parcelRequire("d5Cgz");
const $fde200b4dbe7c5e5$export$acd577492a98befc = ({ alertId: alertId, bulkLoadingState: bulkLoadingState, actionsController: actionsController })=>{
    const { processingBulkIds: processingBulkIds, isBulkSnoozeLoading: isBulkSnoozeLoading, isBulkAssignLoading: isBulkAssignLoading, isBulkCloseLoading: isBulkCloseLoading, isBulkDeleteLoading: isBulkDeleteLoading, isBulkUnacknowledgeLoading: isBulkUnacknowledgeLoading, isBulkAckLoading: isBulkAckLoading, isBulkAddResponderLoading: isBulkAddResponderLoading, isBulkTakeOwnershipLoading: isBulkTakeOwnershipLoading } = bulkLoadingState;
    const { handleAck: handleAck, handleClose: handleClose, handleAssign: handleAssign, handleTakeOwnership: handleTakeOwnership, handleEscalate: handleEscalate, handleAddResponder: handleAddResponder, handleReopen: handleReopen, handleSnooze: handleSnooze, handleDelete: handleDelete, handleUnack: handleUnack, isAssigneeUpdateLoading: isAssigneeUpdateLoading, isRespondersUpdateLoading: isRespondersUpdateLoading, isAckLoading: isAckLoading, isUnackLoading: isUnackLoading, isReopenLoading: isReopenLoading, isDeleteLoading: isDeleteLoading, isSnoozeLoading: isSnoozeLoading, isCloseLoading: isCloseLoading, isEscalateLoading: isEscalateLoading } = actionsController;
    const isBulkProcessing = (0, $euxye.useMemo)(()=>processingBulkIds.includes(alertId), [
        processingBulkIds,
        alertId
    ]);
    const allActions = [
        {
            label: (0, $d5Cgz.default).acknowledge,
            onClick: handleAck,
            actionId: 'acknowledge',
            isLoading: isAckLoading || isBulkProcessing && isBulkAckLoading
        },
        {
            label: (0, $d5Cgz.default).close,
            onClick: handleClose,
            actionId: 'close',
            isLoading: isCloseLoading || isBulkProcessing && isBulkCloseLoading
        },
        ...(0, $4LDqh.default).getExperimentValue('alert-reopen-feature', 'isEnabled', false) ? [
            {
                label: (0, $d5Cgz.default).reopen,
                onClick: handleReopen,
                actionId: 'reopen',
                isLoading: isReopenLoading
            }
        ] : [],
        {
            label: (0, $d5Cgz.default).assign,
            onClick: handleAssign,
            actionId: 'assign',
            isLoading: isAssigneeUpdateLoading || isBulkProcessing && isBulkAssignLoading
        },
        {
            label: (0, $d5Cgz.default).unacknowledge,
            onClick: handleUnack,
            actionId: 'unacknowledge',
            isLoading: isUnackLoading || isBulkProcessing && isBulkUnacknowledgeLoading
        },
        {
            label: (0, $d5Cgz.default).takeOwnership,
            onClick: handleTakeOwnership,
            actionId: 'takeOwnership',
            isLoading: isAssigneeUpdateLoading || isBulkProcessing && isBulkTakeOwnershipLoading
        },
        {
            label: (0, $d5Cgz.default).escalateToNext,
            onClick: handleEscalate,
            actionId: 'escalateToNext',
            isLoading: isEscalateLoading
        },
        {
            label: (0, $d5Cgz.default).addResponder,
            onClick: handleAddResponder,
            actionId: 'addResponder',
            isLoading: isRespondersUpdateLoading || isBulkProcessing && isBulkAddResponderLoading
        },
        {
            label: (0, $d5Cgz.default).snooze,
            onClick: handleSnooze,
            actionId: 'snooze',
            isLoading: isSnoozeLoading || isBulkProcessing && isBulkSnoozeLoading
        },
        {
            label: (0, $d5Cgz.default).delete,
            onClick: handleDelete,
            actionId: 'delete',
            isLoading: isDeleteLoading || isBulkProcessing && isBulkDeleteLoading
        }
    ];
    return allActions;
};

});
parcelRegister("d5Cgz", function(module, exports) {
$parcel$export(module.exports, "default", () => $65a24e2c2d5cc6b6$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $65a24e2c2d5cc6b6$var$messages = (0, $7eNDO.defineMessages)({
    errorTitle: {
        id: 'eoc.alert-list.flag.error-title',
        defaultMessage: 'Error',
        description: 'Title of error message that will be displayed in the flag'
    },
    successTitle: {
        id: 'eoc.alert-list.flag.success-title',
        defaultMessage: 'Success',
        description: 'Title of success message that will be displayed in the flag'
    },
    acknowledge: {
        id: 'eoc.alert-list.actions.acknowledge',
        defaultMessage: 'Ack',
        description: 'Button label to acknowledge an alert in the alert list actions menu.'
    },
    reopen: {
        id: 'eoc.alert-list.actions.reopen',
        defaultMessage: 'Reopen',
        description: 'Button label to reopen a closed alert in the alert list actions menu.'
    },
    unacknowledge: {
        id: 'eoc.alert-list.actions.unacknowledge',
        defaultMessage: 'Open',
        description: 'Unacknowledge(open) action button'
    },
    snooze: {
        id: 'eoc.alert-list.actions.snooze',
        defaultMessage: 'Snooze',
        description: 'Button label to snooze an alert in the alert list actions menu.'
    },
    close: {
        id: 'eoc.alert-list.actions.close',
        defaultMessage: 'Close',
        description: 'Button label to close an alert in the alert list actions menu.'
    },
    delete: {
        id: 'eoc.alert-list.actions.delete',
        defaultMessage: ' Delete',
        description: 'Button label to delete an alert in the alert list actions menu.'
    },
    escalateToNext: {
        id: 'eoc.alert-list.actions.escalateToNext',
        defaultMessage: 'Escalate to next',
        description: 'Escalate to next action button'
    },
    assign: {
        id: 'eoc.alert-list.actions.assign',
        defaultMessage: 'Assign',
        description: 'Button label to assign an alert to a user in the alert list actions menu.'
    },
    addResponder: {
        id: 'eoc.alert-list.actions.add-responder',
        defaultMessage: 'Add responder',
        description: 'Button label to add a responder to an alert in the alert list actions menu.'
    },
    takeOwnership: {
        id: 'eoc.alert-list.actions.takeOwnership',
        defaultMessage: 'Assign to me',
        description: 'Button label to assign an alert to the current user in the alert list actions menu.'
    },
    addTag: {
        id: 'eoc.alert-list.actions.add-tag',
        defaultMessage: 'Add tag',
        description: 'Button label to add a tag to an alert in the alert list actions menu.'
    },
    addNote: {
        id: 'eoc.alert-list.actions.add-note',
        defaultMessage: 'Add note',
        description: 'Button label to add a note to an alert in the alert list actions menu.'
    },
    empty: {
        id: `eoc.alert-list.empty`,
        defaultMessage: "We couldn\u2019t find any alerts matching your search",
        description: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.'
    },
    noAlerts: {
        id: `eoc.alert-list.no-alerts`,
        defaultMessage: "You don\u2019t have any alerts, yet",
        description: 'Message displayed when there is no alerts'
    },
    learnMore: {
        id: `eoc.alert-list.no-alerts.learn-more`,
        defaultMessage: 'Read how alerts are created',
        description: 'Message displayed for redirecting user to alert create docs'
    },
    emptyDescription: {
        id: `eoc.alert-list.no-alerts.description`,
        defaultMessage: 'Adjust your search filters and try again. You can also create an alert to notify your team about anything critical.',
        description: 'Message displayed as description when there is no alerts with given search'
    },
    noAlertsDescription: {
        id: `eoc.alert-list.no-alerts.description`,
        defaultMessage: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.',
        description: 'Message displayed when there is no alerts'
    },
    error: {
        id: `eoc.alert-list.error`,
        defaultMessage: "We couldn\u2019t load the alerts",
        description: 'Message displayed when there is an error on fetching alerts'
    },
    errorDescription: {
        id: `eoc.alert-list.error.description`,
        defaultMessage: 'Something went wrong while we were loading the alerts. Try searching again.',
        description: 'Message displayed as description when there is an error on fetching alerts'
    },
    pageTitle: {
        id: 'eoc.alert-list.page.title',
        defaultMessage: 'Alerts',
        description: 'Page title displayed in the browser tab for the alerts list page.'
    },
    emptyAIViewTitle: {
        id: 'eoc.alert-list.flag.error-title',
        defaultMessage: 'Looking for alerts to group',
        description: 'Title ofthe message that will be displayed when no groups are present'
    },
    emptyAIViewDescription: {
        id: 'eoc.alert-list.flag.success-title',
        defaultMessage: 'Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
        description: 'Description of the message that will be displayed when no groups are present'
    },
    dareAIViewTitle: {
        id: 'eoc.alert-list.flag.dare-title',
        defaultMessage: 'Starting fresh to group alerts',
        description: 'Title of the message that will be displayed when no groups are present because of DaRe'
    },
    dareAIViewDescription: {
        id: 'eoc.alert-list.flag.dare-description',
        defaultMessage: 'Since you changed your data residency location, previous alert groups were deleted. Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
        description: 'Description of the message that will be displayed when no groups are present'
    },
    notEnabledAIViewTitle: {
        id: 'eoc.smart-alert-list.flag.not-enabled',
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for",
        description: 'Title of the message that will be displayed when AI view is not enabled'
    },
    notEnabledAIViewDescription: {
        id: 'eoc.smart-alert-list.flag.not-enabled',
        defaultMessage: "We looked everywhere, but it doesn\u2019t exist.",
        description: 'Description of the message that will be displayed when AI view is not enabled'
    },
    readMoreAlertGrouping: {
        id: 'eoc.alert-list.flag.success-title',
        defaultMessage: 'Read more about alert grouping',
        description: 'Message for read more that will be displayed when no groups are present'
    },
    requiredFieldsInformMessage: {
        id: 'eoc.alert-list.modal.required-fields-inform-message',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Message to give information to users about required fields'
    },
    ariaLiveMessageFilters: {
        id: `eoc.alert-list.filters.aria-live-message`,
        defaultMessage: `{removedValue, select,
      true { Option {label} deselected. {numOfAlerts} matching alerts found. }
      other { Option {label} selected. {numOfAlerts} matching alerts found. }
    }`,
        description: 'The message to be announced when user selects an option from one of the filters.'
    },
    buttonAriaLabelToIndicateTableModification: {
        id: `eoc.alert-list.filters.update-button`,
        defaultMessage: '{buttonText}. The table will be modified.',
        description: 'The message to be announced before user press update filter button.'
    },
    acceptAIPrediction: {
        id: 'eoc.alert-list.unified-bulk-actions.accept-ai-prediction',
        defaultMessage: 'Accept classification',
        description: 'Button label for accepting AI prediction in bulk actions'
    },
    acknowledgeAll: {
        id: 'eoc.unified-list.actions.acknowledge',
        defaultMessage: 'Ack all',
        description: 'The text is shown on a bulk action button in the alert list toolbar that acknowledges all selected alerts at once.'
    },
    snoozeAll: {
        id: 'eoc.unified-list.actions.snooze',
        defaultMessage: 'Snooze all',
        description: 'The text is shown on a bulk action button in the alert list toolbar that snoozes all selected alerts at once.'
    },
    closeAll: {
        id: 'eoc.unified-list.actions.close',
        defaultMessage: 'Close all',
        description: 'The text is shown on a bulk action button in the alert list toolbar that closes all selected alerts at once.'
    },
    deleteAll: {
        id: 'eoc.unified-list.actions.delete',
        defaultMessage: 'Delete all',
        description: 'The text is shown on a bulk action button in the alert list toolbar that deletes all selected alerts at once.'
    },
    assignToMe: {
        id: 'eoc.unified-list.actions.assignToMe',
        defaultMessage: 'Assign to me',
        description: 'The text is shown on a bulk action button in the alert list toolbar that assigns all selected alerts to the currently signed-in user.'
    },
    acceptPrediction: {
        id: 'eoc.unified-list.actions.acceptPrediction',
        defaultMessage: 'Accept classification',
        description: 'The text is shown on a bulk action button in the alert list toolbar that accepts the ML-suggested noise classification for all selected alerts.'
    },
    moreAriaLabel: {
        id: 'eoc.unified-list.actions.more-aria-label',
        defaultMessage: 'More actions for {tinyId}',
        description: 'The text is shown as the aria-label on the "More actions" menu button in each alert list row. The placeholder {tinyId} will be substituted with the short identifier of the alert (e.g. "P-123").'
    },
    summaryMoreAriaLabel: {
        id: 'eoc.alert-list.summary-actions.more-aria-label',
        defaultMessage: 'More actions for alert {tinyId}',
        description: 'Aria label for the more actions button in summary'
    },
    deleteModalTitle: {
        id: 'eoc.alert-list.summary-actions.delete-modal-title',
        defaultMessage: 'Delete alert',
        description: 'The text is shown as the heading of the delete confirmation modal dialog that appears when a user requests to delete an alert from the alert list.'
    },
    deleteModalDescription: {
        id: 'eoc.alert-list.summary-actions.delete-modal-description',
        defaultMessage: 'Are you sure you want to delete this alert? This action cannot be undone.',
        description: 'Description for the delete confirmation modal'
    },
    filterInfo: {
        id: 'eoc.alert-list.header.filter-info',
        defaultMessage: "The results include groups that have alerts matching your filter criteria. The group's overall priority may differ.",
        description: 'Filter info in the alert smart table header'
    },
    snrAdd: {
        id: 'eoc.alert-list.actions.snr-add',
        defaultMessage: 'Classify',
        description: 'The text is shown on an action button in the alert list that opens a dialog to classify an alert using the signal-to-noise ratio (SNR) classification feature.'
    },
    snrAddSignal: {
        id: 'eoc.alert-list.actions.snr-add-signal',
        defaultMessage: 'Classify as signal',
        description: 'SNR Add classification as signal action button'
    },
    snrAddNoise: {
        id: 'eoc.alert-list.actions.snr-add-noise',
        defaultMessage: 'Classify as noise',
        description: 'SNR Add classification as noise action button'
    },
    snrUpdate: {
        id: 'eoc.alert-list.actions.snr-update',
        defaultMessage: 'Update classification',
        description: 'The text is shown on an action button in the alert list that opens a dialog to update an existing SNR noise classification for an alert.'
    },
    snrUpdateSignal: {
        id: 'eoc.alert-list.actions.snr-update-signal',
        defaultMessage: 'Update as signal',
        description: 'SNR Update classification as signal action button'
    },
    snrUpdateNoise: {
        id: 'eoc.alert-list.actions.snr-update-noise',
        defaultMessage: 'Update as noise',
        description: 'SNR Update classification as noise action button'
    },
    snrAccept: {
        id: 'eoc.alert-list.actions.snr-accept',
        defaultMessage: 'Accept classification',
        description: 'The text is shown on an action button in the alert list that accepts the ML-suggested SNR noise classification for a single alert.'
    }
});
var $65a24e2c2d5cc6b6$export$2e2bcd8739ae039 = $65a24e2c2d5cc6b6$var$messages;

});


parcelRegister("2wjE9", function(module, exports) {
$parcel$export(module.exports, "useAllGroupActions", () => $96bf25ad5d236fea$export$8df8e9de2e51cb58);

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $d5Cgz = parcelRequire("d5Cgz");
const $96bf25ad5d236fea$export$8df8e9de2e51cb58 = ({ groupId: groupId, bulkLoadingState: bulkLoadingState, groupActionsController: groupActionsController, snrClassification: snrClassification })=>{
    const { processingBulkIds: processingBulkIds } = bulkLoadingState;
    const { action: action, isCountLoading: isCountLoading, isAckAllLoading: isAckAllLoading, isCloseAllLoading: isCloseAllLoading, isSnoozeAllLoading: isSnoozeAllLoading, isDeleteAllLoading: isDeleteAllLoading, isAssignLoading: isAssignLoading, isAssignToMeLoading: isAssignToMeLoading, isAcceptAIClassificationLoading: isAcceptAIClassificationLoading, initiateAckAll: initiateAckAll, initiateCloseAll: initiateCloseAll, initiateSnoozeAll: initiateSnoozeAll, initiateDeleteAll: initiateDeleteAll, initiateAssign: initiateAssign, initiateAssignToMe: initiateAssignToMe, initiateAcceptAIClassification: initiateAcceptAIClassification, performAckAll: performAckAll, performCloseAll: performCloseAll, performSnoozeAll: performSnoozeAll, performDeleteAll: performDeleteAll, performAssign: performAssign } = groupActionsController;
    const isBulkProcessing = (0, $euxye.useMemo)(()=>processingBulkIds.includes(groupId), [
        processingBulkIds,
        groupId
    ]);
    const baseActions = [
        {
            label: (0, $d5Cgz.default).acknowledgeAll,
            onClick: initiateAckAll,
            actionId: 'acknowledgeAll',
            requiresAlertCount: true,
            isLoading: action === 'acknowledgeAll' && isCountLoading || isAckAllLoading || isBulkProcessing && bulkLoadingState.isBulkAckLoading,
            onSubmit: performAckAll
        },
        {
            label: (0, $d5Cgz.default).closeAll,
            onClick: initiateCloseAll,
            actionId: 'closeAll',
            requiresAlertCount: true,
            isLoading: action === 'closeAll' && isCountLoading || isCloseAllLoading || isBulkProcessing && bulkLoadingState.isBulkCloseLoading,
            onSubmit: performCloseAll
        },
        {
            label: (0, $d5Cgz.default).assign,
            onClick: initiateAssign,
            actionId: 'assign',
            requiresAlertCount: false,
            isLoading: isAssignLoading || isBulkProcessing && bulkLoadingState.isBulkAssignLoading,
            onSubmit: performAssign
        },
        {
            label: (0, $d5Cgz.default).assignToMe,
            onClick: initiateAssignToMe,
            actionId: 'assignToMe',
            requiresAlertCount: false,
            isLoading: isAssignToMeLoading || isBulkProcessing && bulkLoadingState.isBulkAssignToMeLoading,
            onSubmit: undefined
        },
        {
            label: (0, $d5Cgz.default).snoozeAll,
            onClick: initiateSnoozeAll,
            actionId: 'snooze',
            requiresAlertCount: true,
            isLoading: action === 'snooze' && isCountLoading || isSnoozeAllLoading || isBulkProcessing && bulkLoadingState.isBulkSnoozeLoading,
            onSubmit: performSnoozeAll
        },
        {
            label: (0, $d5Cgz.default).deleteAll,
            onClick: initiateDeleteAll,
            actionId: 'delete',
            requiresAlertCount: true,
            isLoading: action === 'delete' && isCountLoading || isDeleteAllLoading || isBulkProcessing && bulkLoadingState.isBulkDeleteLoading,
            onSubmit: performDeleteAll
        }
    ];
    // Add AI prediction action if feature flag is enabled
    if ((0, $egspI.fg)('aiops-uv-snr')) baseActions.push({
        label: (0, $d5Cgz.default).acceptPrediction,
        onClick: ()=>initiateAcceptAIClassification({
                prediction: snrClassification
            }),
        actionId: 'aiPrediction',
        requiresAlertCount: false,
        isLoading: isAcceptAIClassificationLoading || isBulkProcessing && bulkLoadingState.isBulkAcceptAIClassificationLoading,
        onSubmit: undefined
    });
    const allActions = baseActions;
    return allActions;
};

});


parcelRegister("1Mmhc", function(module, exports) {
$parcel$export(module.exports, "getNoisyReductionMetrics", () => $17b0e9ec0d4be390$export$3ac28f9c9578f90a);

var $lFnrZ = parcelRequire("lFnrZ");

var $hG5S4 = parcelRequire("hG5S4");
const $17b0e9ec0d4be390$export$3ac28f9c9578f90a = (responderIds)=>{
    return (0, $hG5S4.eocFetch)((0, $lFnrZ.withAIOpsDomainPrefix)('/v1/alert-insights/snr-filter-view'), {
        exactUrl: true,
        method: 'POST',
        body: {
            responderIds: responderIds ?? []
        }
    });
};

});


parcelRegister("jheql", function(module, exports) {
$parcel$export(module.exports, "savedSearchesResource", () => $7a8a5644d3561dd8$export$d915b849e6dd786b);

var $7edbf = parcelRequire("7edbf");

var $4chZx = parcelRequire("4chZx");
const $7a8a5644d3561dd8$export$d915b849e6dd786b = (0, $7edbf.createResource)({
    type: 'savedSearchesResource',
    getKey: ()=>'savedSearchesResource',
    getData: ()=>(0, $4chZx.getSavedSearchesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("4chZx", function(module, exports) {
$parcel$export(module.exports, "getSavedSearchesEndpoint", () => $144e9eebed253129$export$3b7b44889eb94cd0);
$parcel$export(module.exports, "createSavedSearchEndpoint", () => $144e9eebed253129$export$4976332c0ec66407);
$parcel$export(module.exports, "deleteSearchEndpoint", () => $144e9eebed253129$export$401da4a793944201);

var $hG5S4 = parcelRequire("hG5S4");
const $144e9eebed253129$export$3b7b44889eb94cd0 = ()=>{
    return (0, $hG5S4.eocFetch)('/v1/alerts/saved-searches');
};
const $144e9eebed253129$export$4976332c0ec66407 = (data)=>{
    return (0, $hG5S4.eocFetch)('/v1/alerts/saved-searches', {
        method: 'POST',
        body: data
    });
};
const $144e9eebed253129$export$401da4a793944201 = (id)=>{
    return (0, $hG5S4.eocFetch)(`/v1/alerts/saved-searches/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});


parcelRegister("ajQel", function(module, exports) {
$parcel$export(module.exports, "uiPreferencesResource", () => $0c8e8f47acd9a8d8$export$4e143f0fe4b2e025);

var $7edbf = parcelRequire("7edbf");

var $3IeTW = parcelRequire("3IeTW");
const $0c8e8f47acd9a8d8$export$4e143f0fe4b2e025 = (0, $7edbf.createResource)({
    type: 'uiPreferencesResource',
    getKey: ()=>'uiPreferencesResource',
    getData: ()=>(0, $3IeTW.getUiPreferencesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("3IeTW", function(module, exports) {
$parcel$export(module.exports, "getUiPreferencesEndpoint", () => $9ee3a4164734d769$export$afa4854419ed2fc8);
$parcel$export(module.exports, "updateUiPreferencesEndpoint", () => $9ee3a4164734d769$export$4990793476d8f783);

var $hG5S4 = parcelRequire("hG5S4");
const $9ee3a4164734d769$export$afa4854419ed2fc8 = ()=>{
    return (0, $hG5S4.eocFetch)('/v1/alerts/ui-preferences');
};
const $9ee3a4164734d769$export$4990793476d8f783 = (data)=>{
    return (0, $hG5S4.eocFetch)('/v1/alerts/ui-preferences', {
        method: 'PATCH',
        body: data
    });
};

});



parcelRegister("66CK1", function(module, exports) {
$parcel$export(module.exports, "LazyGlobalAlertsSidebar", () => $884bd036086aa499$export$674fd99c08c90491);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aTk1I = parcelRequire("aTk1I");

var $l8G1z = parcelRequire("l8G1z");

const $884bd036086aa499$export$674fd99c08c90491 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9DIvy")).then((bundle)=>bundle), {
    moduleId: "./src/packages/navigation-apps/sidebar-eoc-global-alerts/src/index.tsx"
});
const $884bd036086aa499$export$a1c034c1031e8711 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aTk1I.SidebarBoundary), {
        id: "eocGlobalAlerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($884bd036086aa499$export$674fd99c08c90491, null));
$884bd036086aa499$export$a1c034c1031e8711.displayName = "AsyncSidebarEocGlobalAlerts";

});
parcelRegister("9DIvy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("4bU6N")
]).then(()=>parcelRequire('iH7V3'));

});


parcelRegister("bcxWd", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRedirectRoute", () => $82dbb037ab9b08b7$export$491d479dc37383e9);
const $82dbb037ab9b08b7$export$491d479dc37383e9 = {
    name: 'eoc-global-alerts-redirect',
    path: '/jira/ops',
    exact: true
};

});

parcelRegister("9TfOO", function(module, exports) {
$parcel$export(module.exports, "LazyAlertList", () => $a2f2883eb34bd3c1$export$f4aafff31d950b6c);
$parcel$export(module.exports, "AlertListComponent", () => $a2f2883eb34bd3c1$export$9333bfa567c9c31);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $a2f2883eb34bd3c1$export$f4aafff31d950b6c = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("i9j0s")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $a2f2883eb34bd3c1$export$9333bfa567c9c31 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $a2f2883eb34bd3c1$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });
$a2f2883eb34bd3c1$export$9333bfa567c9c31.displayName = "AlertListComponent";

});
parcelRegister("i9j0s", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("d4qff")
]).then(()=>parcelRequire('1zWxf'));

});



parcelRegister("4vy2X", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRouteEntry", () => $a685f616e5a842a3$export$851a659e50436cff);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jKCvj = parcelRequire("jKCvj");

var $jEYuY = parcelRequire("jEYuY");

var $bqxMM = parcelRequire("bqxMM");

var $66CK1 = parcelRequire("66CK1");

var $fdS54 = parcelRequire("fdS54");

var $223zC = parcelRequire("223zC");

var $9TfOO = parcelRequire("9TfOO");
const $a685f616e5a842a3$export$851a659e50436cff = (0, $fdS54.createEntry)((0, $223zC.eocGlobalAlertListRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9TfOO.AlertListComponent),
        layout: (0, $bqxMM.eocChangeboardingLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jKCvj.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9TfOO.LazyAlertList),
            (0, $66CK1.LazyGlobalAlertsSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("223zC", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRoute", () => $ebfd48a396613cf9$export$29721341dde2ed3d);
const $ebfd48a396613cf9$export$29721341dde2ed3d = {
    name: 'eoc-global-alerts',
    path: '/jira/ops/alerts',
    exact: true
};

});


parcelRegister("dYZBt", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertsDetailRouteEntry", () => $4092b49f80c12fb7$export$bcb93d8198d511b9);


var $8dcm7 = parcelRequire("8dcm7");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $8HUuJ = parcelRequire("8HUuJ");

var $eRPKt = parcelRequire("eRPKt");

var $jKCvj = parcelRequire("jKCvj");

var $jEYuY = parcelRequire("jEYuY");

var $66CK1 = parcelRequire("66CK1");

var $fdS54 = parcelRequire("fdS54");

var $crj9O = parcelRequire("crj9O");

var $i860n = parcelRequire("i860n");

var $9TfOO = parcelRequire("9TfOO");
const $4092b49f80c12fb7$export$bcb93d8198d511b9 = (0, $fdS54.createEntry)((0, $crj9O.eocGlobalAlertsDetailRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9TfOO.AlertListComponent),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jKCvj.resources)(),
            ...(0, $eRPKt.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('automation_discoverability_in_jsm'), (0, $8dcm7.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9TfOO.LazyAlertList),
            (0, $66CK1.LazyGlobalAlertsSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8dcm7", function(module, exports) {
$parcel$export(module.exports, "getAutomationDiscoveryDismissResource", () => $17727dcd6a87532e$export$3e9b930ef3c80543);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist


var $hFtK7 = parcelRequire("hFtK7");

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $17727dcd6a87532e$var$PROPERTY_KEY = 'jira.user.issue.automation-discoverability.panel.state';
const $17727dcd6a87532e$export$3e9b930ef3c80543 = (0, $7edbf.createResource)({
    type: 'getAutomationDiscoveryDismiss',
    getKey: ()=>'getAutomationDiscoveryDismiss',
    getData: async ()=>{
        try {
            const res = await (0, $h2wCv.performGetRequest)(`/rest/api/3/mypreferences?key=${$17727dcd6a87532e$var$PROPERTY_KEY}`);
            return res;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) return null;
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'getDismissData',
                    teamName: 'ITOps Phantom',
                    packageName: 'jiraEocAutomationDiscovery'
                }
            });
            throw error;
        }
    },
    maxAge: 300000
});

});

parcelRegister("eRPKt", function(module, exports) {
$parcel$export(module.exports, "alertDetailResource", () => $3bd267259cae896e$export$f918335771807ac4);
$parcel$export(module.exports, "logTypesResource", () => $3bd267259cae896e$export$f9c57ab4d5f63686);
$parcel$export(module.exports, "entityRelationTypesResource", () => $3bd267259cae896e$export$a5515392cb45b9f8);
$parcel$export(module.exports, "responderStatesResource", () => $3bd267259cae896e$export$c3b70747662e5932);
$parcel$export(module.exports, "resources", () => $3bd267259cae896e$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $2teGy = parcelRequire("2teGy");

var $dKljx = parcelRequire("dKljx");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $lrLEP = parcelRequire("lrLEP");

var $amiXA = parcelRequire("amiXA");

var $hX74C = parcelRequire("hX74C");
const $3bd267259cae896e$var$ALERT_DETAIL_RESOURCE_TYPE = 'alertDetailResource';
const $3bd267259cae896e$export$f918335771807ac4 = (0, $7edbf.createResource)({
    type: $3bd267259cae896e$var$ALERT_DETAIL_RESOURCE_TYPE,
    getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $7Ljuo.assert)(!!alertId, new (0, $jpT5w.AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
        return (0, $hX74C.getAlertDetail)(alertId);
    },
    isBrowserOnly: true
});
const $3bd267259cae896e$export$f9c57ab4d5f63686 = (0, $7edbf.createResource)({
    type: 'logTypesResource',
    getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
    getData: async ()=>{
        return (0, $hX74C.getAlertLogTypesEndpoint)();
    },
    isBrowserOnly: true
});
const $3bd267259cae896e$export$a5515392cb45b9f8 = (0, $7edbf.createResource)({
    type: 'entityRelationTypesResource',
    getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $7Ljuo.assert)(!!alertId, new (0, $jpT5w.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($2teGy)))(alertId)) {
            const { id: id } = await (0, $amiXA.consumeDependency)(dependencies, $3bd267259cae896e$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $hX74C.getEntityRelationTypesEndpoint)(id);
        }
        return (0, $hX74C.getEntityRelationTypesEndpoint)(alertId);
    },
    depends: [
        $3bd267259cae896e$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $3bd267259cae896e$export$c3b70747662e5932 = (0, $7edbf.createResource)({
    type: 'responderStatesResource',
    getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $7Ljuo.assert)(!!alertId, new (0, $jpT5w.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($2teGy)))(alertId)) {
            const { id: id } = await (0, $amiXA.consumeDependency)(dependencies, $3bd267259cae896e$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $hX74C.getResponderStatesEndpoint)(id);
        }
        return (0, $hX74C.getResponderStatesEndpoint)(alertId);
    },
    depends: [
        $3bd267259cae896e$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $3bd267259cae896e$export$bc99aaabaf7b70a7 = ()=>[
        $3bd267259cae896e$export$f918335771807ac4,
        $3bd267259cae896e$export$f9c57ab4d5f63686,
        $3bd267259cae896e$export$c3b70747662e5932,
        $3bd267259cae896e$export$a5515392cb45b9f8,
        (0, $dKljx.relatedAlertGroupResource),
        ...(0, $lrLEP.eocCommonResources)()
    ];

});
parcelRegister("2teGy", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $3oBOI = parcelRequire("3oBOI");
var $1cc9ae6b33f74681$require$Buffer = $3oBOI.Buffer;
var $1cc9ae6b33f74681$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $1cc9ae6b33f74681$var$_byteToHex = [];
for(var $1cc9ae6b33f74681$var$i = 0; $1cc9ae6b33f74681$var$i < 256; $1cc9ae6b33f74681$var$i++)$1cc9ae6b33f74681$var$_byteToHex[$1cc9ae6b33f74681$var$i] = ($1cc9ae6b33f74681$var$i + 0x100).toString(16).substr(1);
function $1cc9ae6b33f74681$var$unparse(buf, offset) {
    var i = offset || 0, bth = $1cc9ae6b33f74681$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($1cc9ae6b33f74681$require$Buffer.isBuffer(uuid)) parsedUuid = $1cc9ae6b33f74681$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$1cc9ae6b33f74681$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $1cc9ae6b33f74681$var$extractVersion(parsedUuid);
    else if ($1cc9ae6b33f74681$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $1cc9ae6b33f74681$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("dKljx", function(module, exports) {
$parcel$export(module.exports, "relatedAlertGroupResource", () => $9a30705a989b30ea$export$35df14c9f0cfb113);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $9f0uq = parcelRequire("9f0uq");
const $9a30705a989b30ea$export$35df14c9f0cfb113 = (0, $7edbf.createResource)({
    type: 'relatedAlertGroupResource',
    getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $7Ljuo.assert)(!!alertId, new (0, $jpT5w.AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
        return (0, $9f0uq.getRelatedAlertGroup)(alertId);
    },
    isBrowserOnly: true
});

});
parcelRegister("9f0uq", function(module, exports) {
$parcel$export(module.exports, "getRelatedAlertGroup", () => $59310c5ab4a87a6b$export$665e34f20aad273a);

var $hG5S4 = parcelRequire("hG5S4");

var $efzXm = parcelRequire("efzXm");
const $59310c5ab4a87a6b$export$665e34f20aad273a = (alertId)=>(0, $hG5S4.eocFetch)((0, $efzXm.withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
        exactUrl: true
    });

});
parcelRegister("efzXm", function(module, exports) {
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $561a0a9e0faf5207$export$81c70e0016508593);

var $7nxyA = parcelRequire("7nxyA");
const $561a0a9e0faf5207$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $7nxyA.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("amiXA", function(module, exports) {
$parcel$export(module.exports, "consumeDependency", () => $8d6cc42171621b81$export$a973ef9e17a326f);
async function $8d6cc42171621b81$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("hX74C", function(module, exports) {
$parcel$export(module.exports, "getAlertDetail", () => $4e84cd2e9764c7d0$export$436b6d88c1865c54);
$parcel$export(module.exports, "getAlertLogTypesEndpoint", () => $4e84cd2e9764c7d0$export$97200f7e7a7d1479);
$parcel$export(module.exports, "getResponderStatesEndpoint", () => $4e84cd2e9764c7d0$export$498d1a9ea659d430);
$parcel$export(module.exports, "getEntityRelationTypesEndpoint", () => $4e84cd2e9764c7d0$export$8f96130abdd7549d);
$parcel$export(module.exports, "updateAlertSNRDetails", () => $4e84cd2e9764c7d0$export$6439163f7e938696);

var $lFnrZ = parcelRequire("lFnrZ");

var $hG5S4 = parcelRequire("hG5S4");
const $4e84cd2e9764c7d0$export$436b6d88c1865c54 = (alertId)=>(0, $hG5S4.eocFetch)(`/v1/alerts/${alertId}`);
const $4e84cd2e9764c7d0$export$97200f7e7a7d1479 = ()=>(0, $hG5S4.eocFetch)(`/v1/alerts/logs/types`);
const $4e84cd2e9764c7d0$export$498d1a9ea659d430 = (alertId)=>(0, $hG5S4.eocFetch)(`/v1/alerts/${alertId}/responder-states`);
const $4e84cd2e9764c7d0$export$8f96130abdd7549d = (alertId)=>(0, $hG5S4.eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
            relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
        }));
const $4e84cd2e9764c7d0$export$6439163f7e938696 = ({ id: id, prevPrediction: prevPrediction, newPrediction: newPrediction, action: action })=>{
    return (0, $hG5S4.eocFetch)((0, $lFnrZ.withAIOpsDomainPrefix)(`/v1/alert-insights/${id}/snr-details`), {
        method: 'POST',
        body: {
            id: id,
            type: 'alert',
            prevPrediction: prevPrediction,
            newPrediction: newPrediction,
            action: action
        },
        exactUrl: true
    });
};

});


parcelRegister("crj9O", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertsDetailRoute", () => $2e6ad437e666931b$export$d87948ea641004e2);
const $2e6ad437e666931b$export$d87948ea641004e2 = {
    name: 'eoc-global-alert-detail',
    path: '/jira/ops/alerts/:id',
    exact: true
};

});


parcelRegister("7NvQX", function(module, exports) {
$parcel$export(module.exports, "eocGlobalGroupDetailRouteEntry", () => $6b08888cc525b646$export$66928ab349190059);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jKCvj = parcelRequire("jKCvj");

var $4988G = parcelRequire("4988G");

var $jEYuY = parcelRequire("jEYuY");

var $66CK1 = parcelRequire("66CK1");

var $fdS54 = parcelRequire("fdS54");

var $fnbla = parcelRequire("fnbla");

var $1ZnI4 = parcelRequire("1ZnI4");
const $6b08888cc525b646$export$66928ab349190059 = (0, $fdS54.createEntry)((0, $fnbla.eocGlobalGroupDetailRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1ZnI4.default),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $4988G.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $jKCvj.resources)()
        ],
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1ZnI4.LazyGroupDetail),
            (0, $66CK1.LazyGlobalAlertsSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4988G", function(module, exports) {
$parcel$export(module.exports, "groupHeaderResource", () => $4a06fa402b214a96$export$e6ba56f6b67069c8);
$parcel$export(module.exports, "correlationSummaryResource", () => $4a06fa402b214a96$export$a3a832d4d6265613);
$parcel$export(module.exports, "aiSuggestionsResource", () => $4a06fa402b214a96$export$94675faef1d4568b);
$parcel$export(module.exports, "resources", () => $4a06fa402b214a96$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $egspI = parcelRequire("egspI");

var $1Dmlw = parcelRequire("1Dmlw");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $enBwk = parcelRequire("enBwk");
const $4a06fa402b214a96$export$e6ba56f6b67069c8 = (0, $7edbf.createResource)({
    type: 'groupHeaderResource',
    getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $7Ljuo.assert)(!!groupId, new (0, $jpT5w.AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
        return (0, $enBwk.getHeaderDetails)(groupId);
    },
    isBrowserOnly: true
});
const $4a06fa402b214a96$export$a3a832d4d6265613 = (0, $7edbf.createResource)({
    type: 'correlationSummaryResource',
    getKey: (routerContext)=>`correlationSummaryResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $7Ljuo.assert)(!!groupId, new (0, $jpT5w.AssertionError)('correlationSummaryResource', 'groupId should be set to fetch correlation summary'));
        const adfJson = await (0, $enBwk.getCorrelationSummary)(groupId);
        return {
            summary: JSON.parse(adfJson)
        };
    },
    isBrowserOnly: true
});
const $4a06fa402b214a96$export$94675faef1d4568b = (0, $7edbf.createResource)({
    type: 'aiSuggestionsResource',
    getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $7Ljuo.assert)(!!groupId, new (0, $jpT5w.AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
        return (0, $enBwk.getAISuggestions)(groupId);
    },
    isBrowserOnly: true
});
const $4a06fa402b214a96$export$bc99aaabaf7b70a7 = ()=>[
        $4a06fa402b214a96$export$e6ba56f6b67069c8,
        $4a06fa402b214a96$export$94675faef1d4568b,
        (0, $1Dmlw.groupCustomizationFeatureStateResource),
        ...(0, $egspI.fg)('aiops-alert-correlation') ? [
            $4a06fa402b214a96$export$a3a832d4d6265613
        ] : []
    ];

});
parcelRegister("enBwk", function(module, exports) {
$parcel$export(module.exports, "getHeaderDetails", () => $7e48a6d50daae51e$export$c0f2e4bfcbff05d1);
$parcel$export(module.exports, "getCorrelationSummary", () => $7e48a6d50daae51e$export$8ff37948bb38ca5a);
$parcel$export(module.exports, "getAISuggestions", () => $7e48a6d50daae51e$export$34bb7a15a54039a5);
$parcel$export(module.exports, "addGroupAssignee", () => $7e48a6d50daae51e$export$bd5bdebdb6d9abb);
$parcel$export(module.exports, "updateGroupSNRDetails", () => $7e48a6d50daae51e$export$674602d357916b87);

var $hG5S4 = parcelRequire("hG5S4");

var $4zd6P = parcelRequire("4zd6P");
const $7e48a6d50daae51e$export$c0f2e4bfcbff05d1 = (groupId)=>(0, $hG5S4.eocFetch)((0, $4zd6P.withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
        exactUrl: true
    });
const $7e48a6d50daae51e$export$8ff37948bb38ca5a = (groupId)=>(0, $hG5S4.eocFetch)((0, $4zd6P.withAIOpsPrefix)(`/v1/alert-correlation/summary?id=${groupId}&type=group`), {
        exactUrl: true
    });
const $7e48a6d50daae51e$export$34bb7a15a54039a5 = (groupId)=>(0, $hG5S4.eocFetch)((0, $4zd6P.withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
        exactUrl: true
    });
const $7e48a6d50daae51e$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, $hG5S4.eocFetch)((0, $4zd6P.withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
        method: 'PUT',
        exactUrl: true
    });
const $7e48a6d50daae51e$export$674602d357916b87 = ({ id: id, prevPrediction: prevPrediction, newPrediction: newPrediction, action: action })=>{
    return (0, $hG5S4.eocFetch)((0, $4zd6P.withAIOpsPrefix)(`/v1/group-insights/${id}/snr-details`), {
        method: 'POST',
        body: {
            id: id,
            type: 'group',
            prevPrediction: prevPrediction,
            newPrediction: newPrediction,
            action: action
        },
        exactUrl: true
    });
};

});
parcelRegister("4zd6P", function(module, exports) {
$parcel$export(module.exports, "withAIOpsPrefix", () => $a5b8368f0db2190e$export$5ad74397753c99a2);
$parcel$export(module.exports, "formatTimezone", () => $a5b8368f0db2190e$export$26da7aa151b6684c);

var $3T2gC = parcelRequire("3T2gC");

var $b7VBL = parcelRequire("b7VBL");

var $7nxyA = parcelRequire("7nxyA");
const $a5b8368f0db2190e$export$5ad74397753c99a2 = (input)=>{
    const cloudId = (0, $7nxyA.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
function $a5b8368f0db2190e$export$9e555a50010549c1(timezone) {
    const splittedTz = timezone.split('/');
    // EST || EST5EDT
    if (splittedTz.length === 0) return splittedTz;
    // Europe/Amsterdam || Europe/Isle_of_Man || America/North_Dakota/New_Salem
    if (splittedTz.length > 0) {
        const areaName = splittedTz[splittedTz.length - 1];
        return areaName.replace(/_/g, ' ');
    }
    return timezone;
}
function $a5b8368f0db2190e$export$26da7aa151b6684c(timezone) {
    const timeZone = timezone ?? (0, $b7VBL.guessUserTimeZone)();
    return (0, $3T2gC.default)(new Date(), timeZone, `z '${$a5b8368f0db2190e$export$9e555a50010549c1(timeZone)}'`);
}

});
parcelRegister("3T2gC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d48445787d5be67$export$2e2bcd8739ae039);

var $3ZYbY = parcelRequire("3ZYbY");

var $g5Mbl = parcelRequire("g5Mbl");

var $j74cJ = parcelRequire("j74cJ");
function $2d48445787d5be67$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYbY)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $g5Mbl.default)((0, $j74cJ.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("3ZYbY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e95c2858ae0e0f3$var$cloneObject;

var $2e95c2858ae0e0f3$var$_index = $2e95c2858ae0e0f3$var$_interopRequireDefault((parcelRequire("fHsWH")));
function $2e95c2858ae0e0f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2e95c2858ae0e0f3$var$cloneObject(dirtyObject) {
    return (0, $2e95c2858ae0e0f3$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("fHsWH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6e1533353cb74d9$var$assign;
function $b6e1533353cb74d9$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("g5Mbl", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb727cedef1e23c0$export$2e2bcd8739ae039);

var $6CZmd = parcelRequire("6CZmd");

var $3i3Y3 = parcelRequire("3i3Y3");

var $jpWXw = parcelRequire("jpWXw");
var $bb727cedef1e23c0$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $bb727cedef1e23c0$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($bb727cedef1e23c0$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $jpWXw.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $3i3Y3.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CZmd)))(dirtyDate, formatStr, options);
}

});
parcelRegister("6CZmd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d35e2f5a6ba0a09$var$format;

var $4d35e2f5a6ba0a09$var$_index = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("MayBb")));

var $4d35e2f5a6ba0a09$var$_index2 = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("dYR8i")));

var $4d35e2f5a6ba0a09$var$_index3 = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("cTLLr")));

var $4d35e2f5a6ba0a09$var$_index4 = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $4d35e2f5a6ba0a09$var$_index5 = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("bDkKv")));

var $4d35e2f5a6ba0a09$var$_index6 = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("7uHhj")));

var $4d35e2f5a6ba0a09$var$_index7 = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("fKom7")));

var $gRbes = parcelRequire("gRbes");

var $4d35e2f5a6ba0a09$var$_index9 = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("r1m99")));

var $4d35e2f5a6ba0a09$var$_index10 = $4d35e2f5a6ba0a09$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $4d35e2f5a6ba0a09$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4d35e2f5a6ba0a09$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4d35e2f5a6ba0a09$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4d35e2f5a6ba0a09$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4d35e2f5a6ba0a09$var$doubleQuoteRegExp = /''/g;
var $4d35e2f5a6ba0a09$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $4d35e2f5a6ba0a09$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $4d35e2f5a6ba0a09$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $4d35e2f5a6ba0a09$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $4d35e2f5a6ba0a09$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $4d35e2f5a6ba0a09$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $4d35e2f5a6ba0a09$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $4d35e2f5a6ba0a09$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $4d35e2f5a6ba0a09$var$_index4.default)(dirtyDate);
    if (!(0, $4d35e2f5a6ba0a09$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $4d35e2f5a6ba0a09$var$_index7.default)(originalDate);
    var utcDate = (0, $4d35e2f5a6ba0a09$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4d35e2f5a6ba0a09$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $4d35e2f5a6ba0a09$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($4d35e2f5a6ba0a09$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4d35e2f5a6ba0a09$var$cleanEscapedString(substring);
        var formatter = $4d35e2f5a6ba0a09$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $gRbes.isProtectedWeekYearToken)(substring)) (0, $gRbes.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $gRbes.isProtectedDayOfYearToken)(substring)) (0, $gRbes.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4d35e2f5a6ba0a09$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $4d35e2f5a6ba0a09$var$cleanEscapedString(input) {
    return input.match($4d35e2f5a6ba0a09$var$escapedStringRegExp)[1].replace($4d35e2f5a6ba0a09$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("MayBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $090cac37eb8e8000$var$isValid;

var $090cac37eb8e8000$var$_index = $090cac37eb8e8000$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $090cac37eb8e8000$var$_index2 = $090cac37eb8e8000$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $090cac37eb8e8000$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $090cac37eb8e8000$var$isValid(dirtyDate) {
    (0, $090cac37eb8e8000$var$_index2.default)(1, arguments);
    var date = (0, $090cac37eb8e8000$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("g7DLZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bbcc26dfa1c6f8ae$var$toDate;

var $bbcc26dfa1c6f8ae$var$_index = $bbcc26dfa1c6f8ae$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $bbcc26dfa1c6f8ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $bbcc26dfa1c6f8ae$var$toDate(argument) {
    (0, $bbcc26dfa1c6f8ae$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("gwdn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c06a01c56692aa25$var$requiredArgs;
function $c06a01c56692aa25$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("dYR8i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2da1804cd0e0886$var$_index = $a2da1804cd0e0886$var$_interopRequireDefault((parcelRequire("7hahf")));

var $a2da1804cd0e0886$var$_index2 = $a2da1804cd0e0886$var$_interopRequireDefault((parcelRequire("8mwsE")));

var $a2da1804cd0e0886$var$_index3 = $a2da1804cd0e0886$var$_interopRequireDefault((parcelRequire("1YeSC")));

var $a2da1804cd0e0886$var$_index4 = $a2da1804cd0e0886$var$_interopRequireDefault((parcelRequire("7BWmk")));

var $a2da1804cd0e0886$var$_index5 = $a2da1804cd0e0886$var$_interopRequireDefault((parcelRequire("j1iuv")));
function $a2da1804cd0e0886$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $a2da1804cd0e0886$var$locale = {
    code: 'en-US',
    formatDistance: $a2da1804cd0e0886$var$_index.default,
    formatLong: $a2da1804cd0e0886$var$_index2.default,
    formatRelative: $a2da1804cd0e0886$var$_index3.default,
    localize: $a2da1804cd0e0886$var$_index4.default,
    match: $a2da1804cd0e0886$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $a2da1804cd0e0886$var$_default = $a2da1804cd0e0886$var$locale;
module.exports.default = $a2da1804cd0e0886$var$_default;
module.exports = module.exports.default;

});
parcelRegister("7hahf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54c217c49c90a10d$var$formatDistance;
var $54c217c49c90a10d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $54c217c49c90a10d$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $54c217c49c90a10d$var$formatDistanceLocale[token] === 'string') result = $54c217c49c90a10d$var$formatDistanceLocale[token];
    else if (count === 1) result = $54c217c49c90a10d$var$formatDistanceLocale[token].one;
    else result = $54c217c49c90a10d$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("8mwsE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61698eea3ca8ff58$var$_index = $61698eea3ca8ff58$var$_interopRequireDefault((parcelRequire("dZeHa")));
function $61698eea3ca8ff58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $61698eea3ca8ff58$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $61698eea3ca8ff58$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $61698eea3ca8ff58$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $61698eea3ca8ff58$var$formatLong = {
    date: (0, $61698eea3ca8ff58$var$_index.default)({
        formats: $61698eea3ca8ff58$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $61698eea3ca8ff58$var$_index.default)({
        formats: $61698eea3ca8ff58$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $61698eea3ca8ff58$var$_index.default)({
        formats: $61698eea3ca8ff58$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $61698eea3ca8ff58$var$_default = $61698eea3ca8ff58$var$formatLong;
module.exports.default = $61698eea3ca8ff58$var$_default;
module.exports = module.exports.default;

});
parcelRegister("dZeHa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2ec5f0bd6f5b532$var$buildFormatLongFn;
function $a2ec5f0bd6f5b532$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("1YeSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $16f6efe6d2e73aeb$var$formatRelative;
var $16f6efe6d2e73aeb$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $16f6efe6d2e73aeb$var$formatRelative(token, _date, _baseDate, _options) {
    return $16f6efe6d2e73aeb$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("7BWmk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58a94201622590cf$var$_index = $58a94201622590cf$var$_interopRequireDefault((parcelRequire("lPeUO")));
function $58a94201622590cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $58a94201622590cf$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $58a94201622590cf$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $58a94201622590cf$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $58a94201622590cf$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $58a94201622590cf$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $58a94201622590cf$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $58a94201622590cf$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $58a94201622590cf$var$localize = {
    ordinalNumber: $58a94201622590cf$var$ordinalNumber,
    era: (0, $58a94201622590cf$var$_index.default)({
        values: $58a94201622590cf$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $58a94201622590cf$var$_index.default)({
        values: $58a94201622590cf$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $58a94201622590cf$var$_index.default)({
        values: $58a94201622590cf$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $58a94201622590cf$var$_index.default)({
        values: $58a94201622590cf$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $58a94201622590cf$var$_index.default)({
        values: $58a94201622590cf$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $58a94201622590cf$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $58a94201622590cf$var$_default = $58a94201622590cf$var$localize;
module.exports.default = $58a94201622590cf$var$_default;
module.exports = module.exports.default;

});
parcelRegister("lPeUO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe39ee466ff73fa7$var$buildLocalizeFn;
function $fe39ee466ff73fa7$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("j1iuv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd8c743fae7d6e94$var$_index = $dd8c743fae7d6e94$var$_interopRequireDefault((parcelRequire("kFOI0")));

var $dd8c743fae7d6e94$var$_index2 = $dd8c743fae7d6e94$var$_interopRequireDefault((parcelRequire("5w6x3")));
function $dd8c743fae7d6e94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dd8c743fae7d6e94$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $dd8c743fae7d6e94$var$parseOrdinalNumberPattern = /\d+/i;
var $dd8c743fae7d6e94$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $dd8c743fae7d6e94$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $dd8c743fae7d6e94$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $dd8c743fae7d6e94$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $dd8c743fae7d6e94$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $dd8c743fae7d6e94$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $dd8c743fae7d6e94$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $dd8c743fae7d6e94$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $dd8c743fae7d6e94$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $dd8c743fae7d6e94$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $dd8c743fae7d6e94$var$match = {
    ordinalNumber: (0, $dd8c743fae7d6e94$var$_index.default)({
        matchPattern: $dd8c743fae7d6e94$var$matchOrdinalNumberPattern,
        parsePattern: $dd8c743fae7d6e94$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $dd8c743fae7d6e94$var$_index2.default)({
        matchPatterns: $dd8c743fae7d6e94$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd8c743fae7d6e94$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $dd8c743fae7d6e94$var$_index2.default)({
        matchPatterns: $dd8c743fae7d6e94$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd8c743fae7d6e94$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $dd8c743fae7d6e94$var$_index2.default)({
        matchPatterns: $dd8c743fae7d6e94$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd8c743fae7d6e94$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $dd8c743fae7d6e94$var$_index2.default)({
        matchPatterns: $dd8c743fae7d6e94$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd8c743fae7d6e94$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $dd8c743fae7d6e94$var$_index2.default)({
        matchPatterns: $dd8c743fae7d6e94$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dd8c743fae7d6e94$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dd8c743fae7d6e94$var$_default = $dd8c743fae7d6e94$var$match;
module.exports.default = $dd8c743fae7d6e94$var$_default;
module.exports = module.exports.default;

});
parcelRegister("kFOI0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0cef8ab41449167$var$buildMatchPatternFn;
function $f0cef8ab41449167$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("5w6x3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4045020cb727515d$var$buildMatchFn;
function $4045020cb727515d$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $4045020cb727515d$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $4045020cb727515d$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $4045020cb727515d$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $4045020cb727515d$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("cTLLr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $963fac0ef5f1a24e$var$subMilliseconds;

var $963fac0ef5f1a24e$var$_index = $963fac0ef5f1a24e$var$_interopRequireDefault((parcelRequire("r1m99")));

var $963fac0ef5f1a24e$var$_index2 = $963fac0ef5f1a24e$var$_interopRequireDefault((parcelRequire("6asTf")));

var $963fac0ef5f1a24e$var$_index3 = $963fac0ef5f1a24e$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $963fac0ef5f1a24e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $963fac0ef5f1a24e$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $963fac0ef5f1a24e$var$_index3.default)(2, arguments);
    var amount = (0, $963fac0ef5f1a24e$var$_index.default)(dirtyAmount);
    return (0, $963fac0ef5f1a24e$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("r1m99", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0513930b77b115db$var$toInteger;
function $0513930b77b115db$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("6asTf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47da163d5786523d$var$addMilliseconds;

var $47da163d5786523d$var$_index = $47da163d5786523d$var$_interopRequireDefault((parcelRequire("r1m99")));

var $47da163d5786523d$var$_index2 = $47da163d5786523d$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $47da163d5786523d$var$_index3 = $47da163d5786523d$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $47da163d5786523d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $47da163d5786523d$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $47da163d5786523d$var$_index3.default)(2, arguments);
    var timestamp = (0, $47da163d5786523d$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $47da163d5786523d$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("bDkKv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87836e926dbb69c8$var$_index = $87836e926dbb69c8$var$_interopRequireDefault((parcelRequire("2H5Lg")));

var $87836e926dbb69c8$var$_index2 = $87836e926dbb69c8$var$_interopRequireDefault((parcelRequire("eMYzv")));

var $87836e926dbb69c8$var$_index3 = $87836e926dbb69c8$var$_interopRequireDefault((parcelRequire("iEoTf")));

var $87836e926dbb69c8$var$_index4 = $87836e926dbb69c8$var$_interopRequireDefault((parcelRequire("55nti")));

var $87836e926dbb69c8$var$_index5 = $87836e926dbb69c8$var$_interopRequireDefault((parcelRequire("eWPzO")));

var $87836e926dbb69c8$var$_index6 = $87836e926dbb69c8$var$_interopRequireDefault((parcelRequire("aZWID")));

var $87836e926dbb69c8$var$_index7 = $87836e926dbb69c8$var$_interopRequireDefault((parcelRequire("jW8PQ")));
function $87836e926dbb69c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $87836e926dbb69c8$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $87836e926dbb69c8$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $87836e926dbb69c8$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $87836e926dbb69c8$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $87836e926dbb69c8$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $87836e926dbb69c8$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $87836e926dbb69c8$var$_index4.default)(date); // Padding
        return (0, $87836e926dbb69c8$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $87836e926dbb69c8$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $87836e926dbb69c8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $87836e926dbb69c8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $87836e926dbb69c8$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $87836e926dbb69c8$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $87836e926dbb69c8$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $87836e926dbb69c8$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $87836e926dbb69c8$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $87836e926dbb69c8$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $87836e926dbb69c8$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $87836e926dbb69c8$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $87836e926dbb69c8$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $87836e926dbb69c8$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $87836e926dbb69c8$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $87836e926dbb69c8$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $87836e926dbb69c8$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $87836e926dbb69c8$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $87836e926dbb69c8$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $87836e926dbb69c8$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $87836e926dbb69c8$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $87836e926dbb69c8$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $87836e926dbb69c8$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $87836e926dbb69c8$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $87836e926dbb69c8$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $87836e926dbb69c8$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $87836e926dbb69c8$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $87836e926dbb69c8$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $87836e926dbb69c8$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $87836e926dbb69c8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $87836e926dbb69c8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $87836e926dbb69c8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $87836e926dbb69c8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $87836e926dbb69c8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $87836e926dbb69c8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $87836e926dbb69c8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $87836e926dbb69c8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $87836e926dbb69c8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $87836e926dbb69c8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $87836e926dbb69c8$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $87836e926dbb69c8$var$_index7.default)(timestamp, token.length);
    }
};
function $87836e926dbb69c8$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $87836e926dbb69c8$var$_index7.default)(minutes, 2);
}
function $87836e926dbb69c8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $87836e926dbb69c8$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $87836e926dbb69c8$var$formatTimezone(offset, dirtyDelimiter);
}
function $87836e926dbb69c8$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $87836e926dbb69c8$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $87836e926dbb69c8$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $87836e926dbb69c8$var$_default = $87836e926dbb69c8$var$formatters;
module.exports.default = $87836e926dbb69c8$var$_default;
module.exports = module.exports.default;

});
parcelRegister("2H5Lg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f6410fa97812cff$var$_index = $1f6410fa97812cff$var$_interopRequireDefault((parcelRequire("jW8PQ")));
function $1f6410fa97812cff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $1f6410fa97812cff$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $1f6410fa97812cff$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $1f6410fa97812cff$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $1f6410fa97812cff$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $1f6410fa97812cff$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $1f6410fa97812cff$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $1f6410fa97812cff$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $1f6410fa97812cff$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $1f6410fa97812cff$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $1f6410fa97812cff$var$_default = $1f6410fa97812cff$var$formatters;
module.exports.default = $1f6410fa97812cff$var$_default;
module.exports = module.exports.default;

});
parcelRegister("jW8PQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e83a499cd3c70564$var$addLeadingZeros;
function $e83a499cd3c70564$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("eMYzv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac4488a9b6552c6c$var$getUTCDayOfYear;

var $ac4488a9b6552c6c$var$_index = $ac4488a9b6552c6c$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $ac4488a9b6552c6c$var$_index2 = $ac4488a9b6552c6c$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $ac4488a9b6552c6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ac4488a9b6552c6c$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $ac4488a9b6552c6c$var$getUTCDayOfYear(dirtyDate) {
    (0, $ac4488a9b6552c6c$var$_index2.default)(1, arguments);
    var date = (0, $ac4488a9b6552c6c$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $ac4488a9b6552c6c$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("iEoTf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d93f450e8879769f$var$getUTCISOWeek;

var $d93f450e8879769f$var$_index = $d93f450e8879769f$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $d93f450e8879769f$var$_index2 = $d93f450e8879769f$var$_interopRequireDefault((parcelRequire("laptB")));

var $d93f450e8879769f$var$_index3 = $d93f450e8879769f$var$_interopRequireDefault((parcelRequire("jDzIz")));

var $d93f450e8879769f$var$_index4 = $d93f450e8879769f$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $d93f450e8879769f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d93f450e8879769f$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $d93f450e8879769f$var$getUTCISOWeek(dirtyDate) {
    (0, $d93f450e8879769f$var$_index4.default)(1, arguments);
    var date = (0, $d93f450e8879769f$var$_index.default)(dirtyDate);
    var diff = (0, $d93f450e8879769f$var$_index2.default)(date).getTime() - (0, $d93f450e8879769f$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d93f450e8879769f$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("laptB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f68e4b392e36bbd7$var$startOfUTCISOWeek;

var $f68e4b392e36bbd7$var$_index = $f68e4b392e36bbd7$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $f68e4b392e36bbd7$var$_index2 = $f68e4b392e36bbd7$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $f68e4b392e36bbd7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $f68e4b392e36bbd7$var$startOfUTCISOWeek(dirtyDate) {
    (0, $f68e4b392e36bbd7$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $f68e4b392e36bbd7$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("jDzIz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4bd5dabaf83d514$var$startOfUTCISOWeekYear;

var $e4bd5dabaf83d514$var$_index = $e4bd5dabaf83d514$var$_interopRequireDefault((parcelRequire("55nti")));

var $e4bd5dabaf83d514$var$_index2 = $e4bd5dabaf83d514$var$_interopRequireDefault((parcelRequire("laptB")));

var $e4bd5dabaf83d514$var$_index3 = $e4bd5dabaf83d514$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $e4bd5dabaf83d514$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $e4bd5dabaf83d514$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $e4bd5dabaf83d514$var$_index3.default)(1, arguments);
    var year = (0, $e4bd5dabaf83d514$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $e4bd5dabaf83d514$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("55nti", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b3fa059aea667d8$var$getUTCISOWeekYear;

var $3b3fa059aea667d8$var$_index = $3b3fa059aea667d8$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $3b3fa059aea667d8$var$_index2 = $3b3fa059aea667d8$var$_interopRequireDefault((parcelRequire("laptB")));

var $3b3fa059aea667d8$var$_index3 = $3b3fa059aea667d8$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $3b3fa059aea667d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $3b3fa059aea667d8$var$getUTCISOWeekYear(dirtyDate) {
    (0, $3b3fa059aea667d8$var$_index3.default)(1, arguments);
    var date = (0, $3b3fa059aea667d8$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $3b3fa059aea667d8$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $3b3fa059aea667d8$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("eWPzO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae1e7d89053713f8$var$getUTCWeek;

var $ae1e7d89053713f8$var$_index = $ae1e7d89053713f8$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $ae1e7d89053713f8$var$_index2 = $ae1e7d89053713f8$var$_interopRequireDefault((parcelRequire("aFhOT")));

var $ae1e7d89053713f8$var$_index3 = $ae1e7d89053713f8$var$_interopRequireDefault((parcelRequire("1G0x8")));

var $ae1e7d89053713f8$var$_index4 = $ae1e7d89053713f8$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $ae1e7d89053713f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ae1e7d89053713f8$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $ae1e7d89053713f8$var$getUTCWeek(dirtyDate, options) {
    (0, $ae1e7d89053713f8$var$_index4.default)(1, arguments);
    var date = (0, $ae1e7d89053713f8$var$_index.default)(dirtyDate);
    var diff = (0, $ae1e7d89053713f8$var$_index2.default)(date, options).getTime() - (0, $ae1e7d89053713f8$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $ae1e7d89053713f8$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("aFhOT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c3b8e5a9440e4c6$var$startOfUTCWeek;

var $7c3b8e5a9440e4c6$var$_index = $7c3b8e5a9440e4c6$var$_interopRequireDefault((parcelRequire("r1m99")));

var $7c3b8e5a9440e4c6$var$_index2 = $7c3b8e5a9440e4c6$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $7c3b8e5a9440e4c6$var$_index3 = $7c3b8e5a9440e4c6$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $7c3b8e5a9440e4c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $7c3b8e5a9440e4c6$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $7c3b8e5a9440e4c6$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7c3b8e5a9440e4c6$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7c3b8e5a9440e4c6$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $7c3b8e5a9440e4c6$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("1G0x8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $138a209dcbbb9623$var$startOfUTCWeekYear;

var $138a209dcbbb9623$var$_index = $138a209dcbbb9623$var$_interopRequireDefault((parcelRequire("r1m99")));

var $138a209dcbbb9623$var$_index2 = $138a209dcbbb9623$var$_interopRequireDefault((parcelRequire("aZWID")));

var $138a209dcbbb9623$var$_index3 = $138a209dcbbb9623$var$_interopRequireDefault((parcelRequire("aFhOT")));

var $138a209dcbbb9623$var$_index4 = $138a209dcbbb9623$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $138a209dcbbb9623$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $138a209dcbbb9623$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $138a209dcbbb9623$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $138a209dcbbb9623$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $138a209dcbbb9623$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $138a209dcbbb9623$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $138a209dcbbb9623$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("aZWID", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $801d26435f439ab9$var$getUTCWeekYear;

var $801d26435f439ab9$var$_index = $801d26435f439ab9$var$_interopRequireDefault((parcelRequire("r1m99")));

var $801d26435f439ab9$var$_index2 = $801d26435f439ab9$var$_interopRequireDefault((parcelRequire("g7DLZ")));

var $801d26435f439ab9$var$_index3 = $801d26435f439ab9$var$_interopRequireDefault((parcelRequire("aFhOT")));

var $801d26435f439ab9$var$_index4 = $801d26435f439ab9$var$_interopRequireDefault((parcelRequire("gwdn5")));
function $801d26435f439ab9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $801d26435f439ab9$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $801d26435f439ab9$var$_index4.default)(1, arguments);
    var date = (0, $801d26435f439ab9$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $801d26435f439ab9$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $801d26435f439ab9$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $801d26435f439ab9$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $801d26435f439ab9$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("7uHhj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $574ce7e1e121bbd1$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $574ce7e1e121bbd1$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $574ce7e1e121bbd1$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $574ce7e1e121bbd1$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $574ce7e1e121bbd1$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $574ce7e1e121bbd1$var$timeLongFormatter(timePattern, formatLong));
}
var $574ce7e1e121bbd1$var$longFormatters = {
    p: $574ce7e1e121bbd1$var$timeLongFormatter,
    P: $574ce7e1e121bbd1$var$dateTimeLongFormatter
};
var $574ce7e1e121bbd1$var$_default = $574ce7e1e121bbd1$var$longFormatters;
module.exports.default = $574ce7e1e121bbd1$var$_default;
module.exports = module.exports.default;

});

parcelRegister("fKom7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b76e0b74cb6dd4b8$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $b76e0b74cb6dd4b8$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("gRbes", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $c45a4f0deb201c5a$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $c45a4f0deb201c5a$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $c45a4f0deb201c5a$var$throwProtectedError;
var $c45a4f0deb201c5a$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $c45a4f0deb201c5a$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $c45a4f0deb201c5a$var$isProtectedDayOfYearToken(token) {
    return $c45a4f0deb201c5a$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $c45a4f0deb201c5a$var$isProtectedWeekYearToken(token) {
    return $c45a4f0deb201c5a$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $c45a4f0deb201c5a$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("3i3Y3", function(module, exports) {
$parcel$export(module.exports, "default", () => $2656216f488fcde6$export$2e2bcd8739ae039);

var $gffEX = parcelRequire("gffEX");

var $kV5Dq = parcelRequire("kV5Dq");
var $2656216f488fcde6$var$MILLISECONDS_IN_MINUTE = 60000;
var $2656216f488fcde6$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $2656216f488fcde6$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $2656216f488fcde6$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $2656216f488fcde6$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $2656216f488fcde6$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $2656216f488fcde6$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $2656216f488fcde6$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $2656216f488fcde6$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $2656216f488fcde6$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $2656216f488fcde6$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $2656216f488fcde6$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $2656216f488fcde6$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $gffEX.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $gffEX.default)('long', date, options);
        }
    }
};
function $2656216f488fcde6$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $kV5Dq.default)(timeZone, originalDate, true) / $2656216f488fcde6$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $2656216f488fcde6$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $2656216f488fcde6$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $2656216f488fcde6$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $2656216f488fcde6$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $2656216f488fcde6$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $2656216f488fcde6$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $2656216f488fcde6$var$formatTimezone(offset, dirtyDelimeter);
}
function $2656216f488fcde6$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $2656216f488fcde6$var$addLeadingZeros(minutes, 2);
}
var $2656216f488fcde6$export$2e2bcd8739ae039 = $2656216f488fcde6$var$formatters;

});
parcelRegister("gffEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd3a31b6f0858d1b$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $bd3a31b6f0858d1b$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $bd3a31b6f0858d1b$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $bd3a31b6f0858d1b$var$partsTimeZone(dtf, date) : $bd3a31b6f0858d1b$var$hackyTimeZone(dtf, date);
}
function $bd3a31b6f0858d1b$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $bd3a31b6f0858d1b$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $bd3a31b6f0858d1b$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("kV5Dq", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3ad807cf4755172$export$2e2bcd8739ae039);

var $hhMqt = parcelRequire("hhMqt");

var $a24aA = parcelRequire("a24aA");
var $f3ad807cf4755172$var$MILLISECONDS_IN_HOUR = 3600000;
var $f3ad807cf4755172$var$MILLISECONDS_IN_MINUTE = 60000;
var $f3ad807cf4755172$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $f3ad807cf4755172$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $f3ad807cf4755172$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $f3ad807cf4755172$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$f3ad807cf4755172$var$validateTimezone(hours)) return NaN;
        return -(hours * $f3ad807cf4755172$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $f3ad807cf4755172$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$f3ad807cf4755172$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $f3ad807cf4755172$var$MILLISECONDS_IN_HOUR + minutes * $f3ad807cf4755172$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($f3ad807cf4755172$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $f3ad807cf4755172$var$toUtcDate(date);
        var offset = $f3ad807cf4755172$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $f3ad807cf4755172$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $f3ad807cf4755172$var$toUtcDate(date) {
    return (0, $a24aA.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $f3ad807cf4755172$var$calcOffset(date, timezoneString) {
    var tokens = (0, $hhMqt.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $a24aA.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $f3ad807cf4755172$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $f3ad807cf4755172$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $f3ad807cf4755172$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $f3ad807cf4755172$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $f3ad807cf4755172$var$validIANATimezoneCache = {};
function $f3ad807cf4755172$var$isValidTimezoneIANAString(timeZoneString) {
    if ($f3ad807cf4755172$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $f3ad807cf4755172$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("hhMqt", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9599695f6848907$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c9599695f6848907$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c9599695f6848907$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c9599695f6848907$var$partsOffset(dtf, date) : $c9599695f6848907$var$hackyOffset(dtf, date);
}
var $c9599695f6848907$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c9599695f6848907$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c9599695f6848907$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c9599695f6848907$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c9599695f6848907$var$dtfCache = {};
function $c9599695f6848907$var$getDateTimeFormat(timeZone) {
    if (!$c9599695f6848907$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c9599695f6848907$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c9599695f6848907$var$dtfCache[timeZone];
}

});

parcelRegister("a24aA", function(module, exports) {
$parcel$export(module.exports, "default", () => $74dd53551a1b57c1$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $74dd53551a1b57c1$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("jpWXw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e22e162e84dec4bd$export$2e2bcd8739ae039);

var $r1m99 = parcelRequire("r1m99");

var $fKom7 = parcelRequire("fKom7");

var $kV5Dq = parcelRequire("kV5Dq");

var $aqked = parcelRequire("aqked");
var $e22e162e84dec4bd$var$MILLISECONDS_IN_HOUR = 3600000;
var $e22e162e84dec4bd$var$MILLISECONDS_IN_MINUTE = 60000;
var $e22e162e84dec4bd$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $e22e162e84dec4bd$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $aqked.default)
};
function $e22e162e84dec4bd$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $e22e162e84dec4bd$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($r1m99)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e22e162e84dec4bd$var$splitDateString(argument);
    var parseYearResult = $e22e162e84dec4bd$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $e22e162e84dec4bd$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $e22e162e84dec4bd$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $kV5Dq.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($fKom7)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($fKom7)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $e22e162e84dec4bd$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $e22e162e84dec4bd$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $e22e162e84dec4bd$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $e22e162e84dec4bd$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e22e162e84dec4bd$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $e22e162e84dec4bd$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $e22e162e84dec4bd$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $e22e162e84dec4bd$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $e22e162e84dec4bd$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $e22e162e84dec4bd$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $e22e162e84dec4bd$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$e22e162e84dec4bd$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $e22e162e84dec4bd$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$e22e162e84dec4bd$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $e22e162e84dec4bd$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$e22e162e84dec4bd$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $e22e162e84dec4bd$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$e22e162e84dec4bd$var$validateWeekDate(year, week)) return new Date(NaN);
        return $e22e162e84dec4bd$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $e22e162e84dec4bd$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$e22e162e84dec4bd$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e22e162e84dec4bd$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $e22e162e84dec4bd$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $e22e162e84dec4bd$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$e22e162e84dec4bd$var$validateTime(hours)) return NaN;
        return hours % 24 * $e22e162e84dec4bd$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $e22e162e84dec4bd$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$e22e162e84dec4bd$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $e22e162e84dec4bd$var$MILLISECONDS_IN_HOUR + minutes * $e22e162e84dec4bd$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $e22e162e84dec4bd$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$e22e162e84dec4bd$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $e22e162e84dec4bd$var$MILLISECONDS_IN_HOUR + minutes * $e22e162e84dec4bd$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $e22e162e84dec4bd$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $e22e162e84dec4bd$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e22e162e84dec4bd$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e22e162e84dec4bd$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e22e162e84dec4bd$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $e22e162e84dec4bd$var$isLeapYearIndex(year);
        if (isLeapYear && date > $e22e162e84dec4bd$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $e22e162e84dec4bd$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $e22e162e84dec4bd$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $e22e162e84dec4bd$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $e22e162e84dec4bd$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $e22e162e84dec4bd$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("aqked", function(module, exports) {
$parcel$export(module.exports, "default", () => $796c05fcdc472809$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $796c05fcdc472809$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $796c05fcdc472809$export$2e2bcd8739ae039 = $796c05fcdc472809$var$tzPattern;

});



parcelRegister("j74cJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dea1eea918ecce1a$export$2e2bcd8739ae039);

var $kV5Dq = parcelRequire("kV5Dq");

var $jpWXw = parcelRequire("jpWXw");
function $dea1eea918ecce1a$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $jpWXw.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $kV5Dq.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("b7VBL", function(module, exports) {
$parcel$export(module.exports, "guessUserTimeZone", () => $70a02e49d546ff32$export$6fd096fe0456f5b);
$parcel$export(module.exports, "formatDate", () => $70a02e49d546ff32$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getDefaultTimes", () => $70a02e49d546ff32$export$951e947e785c998d);

var $acUJ7 = parcelRequire("acUJ7");
function $70a02e49d546ff32$export$6fd096fe0456f5b() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $70a02e49d546ff32$export$3ae94a2503e890a1(date, timezone = $70a02e49d546ff32$export$6fd096fe0456f5b(), format = 'PP p') {
    return (0, $acUJ7.default)(new Date(date), timezone, format);
}
const $70a02e49d546ff32$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};

});
parcelRegister("acUJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $76e707229d15c410$export$2e2bcd8739ae039);

var $3ZYbY = parcelRequire("3ZYbY");

var $8TTzc = parcelRequire("8TTzc");

var $cmxGd = parcelRequire("cmxGd");
function $76e707229d15c410$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYbY)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $8TTzc.default)((0, $cmxGd.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("8TTzc", function(module, exports) {
$parcel$export(module.exports, "default", () => $67ae902c2bca65e8$export$2e2bcd8739ae039);

var $6CZmd = parcelRequire("6CZmd");

var $bCskr = parcelRequire("bCskr");

var $ijmtJ = parcelRequire("ijmtJ");
var $67ae902c2bca65e8$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $67ae902c2bca65e8$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($67ae902c2bca65e8$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $ijmtJ.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $bCskr.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CZmd)))(dirtyDate, formatStr, options);
}

});
parcelRegister("bCskr", function(module, exports) {
$parcel$export(module.exports, "default", () => $875937d56bf26bc1$export$2e2bcd8739ae039);

var $23yGf = parcelRequire("23yGf");

var $1atkA = parcelRequire("1atkA");
var $875937d56bf26bc1$var$MILLISECONDS_IN_MINUTE = 60000;
var $875937d56bf26bc1$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $875937d56bf26bc1$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $875937d56bf26bc1$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $875937d56bf26bc1$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $875937d56bf26bc1$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $875937d56bf26bc1$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $875937d56bf26bc1$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $875937d56bf26bc1$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $875937d56bf26bc1$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $875937d56bf26bc1$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $875937d56bf26bc1$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $875937d56bf26bc1$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $23yGf.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $23yGf.default)('long', date, options);
        }
    }
};
function $875937d56bf26bc1$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $1atkA.default)(timeZone, originalDate, true) / $875937d56bf26bc1$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $875937d56bf26bc1$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $875937d56bf26bc1$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $875937d56bf26bc1$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $875937d56bf26bc1$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $875937d56bf26bc1$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $875937d56bf26bc1$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $875937d56bf26bc1$var$formatTimezone(offset, dirtyDelimeter);
}
function $875937d56bf26bc1$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $875937d56bf26bc1$var$addLeadingZeros(minutes, 2);
}
var $875937d56bf26bc1$export$2e2bcd8739ae039 = $875937d56bf26bc1$var$formatters;

});
parcelRegister("23yGf", function(module, exports) {
$parcel$export(module.exports, "default", () => $17f6c361f81145fb$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $17f6c361f81145fb$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $17f6c361f81145fb$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $17f6c361f81145fb$var$partsTimeZone(dtf, date) : $17f6c361f81145fb$var$hackyTimeZone(dtf, date);
}
function $17f6c361f81145fb$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $17f6c361f81145fb$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $17f6c361f81145fb$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("1atkA", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d9d7a29cd2c8097$export$2e2bcd8739ae039);

var $gTTXX = parcelRequire("gTTXX");

var $lEqFn = parcelRequire("lEqFn");
var $0d9d7a29cd2c8097$var$MILLISECONDS_IN_HOUR = 3600000;
var $0d9d7a29cd2c8097$var$MILLISECONDS_IN_MINUTE = 60000;
var $0d9d7a29cd2c8097$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $0d9d7a29cd2c8097$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $0d9d7a29cd2c8097$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $0d9d7a29cd2c8097$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$0d9d7a29cd2c8097$var$validateTimezone(hours)) return NaN;
        return -(hours * $0d9d7a29cd2c8097$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $0d9d7a29cd2c8097$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$0d9d7a29cd2c8097$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $0d9d7a29cd2c8097$var$MILLISECONDS_IN_HOUR + minutes * $0d9d7a29cd2c8097$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($0d9d7a29cd2c8097$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $0d9d7a29cd2c8097$var$toUtcDate(date);
        var offset = $0d9d7a29cd2c8097$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $0d9d7a29cd2c8097$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $0d9d7a29cd2c8097$var$toUtcDate(date) {
    return (0, $lEqFn.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $0d9d7a29cd2c8097$var$calcOffset(date, timezoneString) {
    var tokens = (0, $gTTXX.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $lEqFn.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $0d9d7a29cd2c8097$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $0d9d7a29cd2c8097$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $0d9d7a29cd2c8097$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $0d9d7a29cd2c8097$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $0d9d7a29cd2c8097$var$validIANATimezoneCache = {};
function $0d9d7a29cd2c8097$var$isValidTimezoneIANAString(timeZoneString) {
    if ($0d9d7a29cd2c8097$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $0d9d7a29cd2c8097$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("gTTXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4dd3218debce927$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c4dd3218debce927$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c4dd3218debce927$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c4dd3218debce927$var$partsOffset(dtf, date) : $c4dd3218debce927$var$hackyOffset(dtf, date);
}
var $c4dd3218debce927$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c4dd3218debce927$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c4dd3218debce927$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c4dd3218debce927$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c4dd3218debce927$var$dtfCache = {};
function $c4dd3218debce927$var$getDateTimeFormat(timeZone) {
    if (!$c4dd3218debce927$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c4dd3218debce927$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c4dd3218debce927$var$dtfCache[timeZone];
}

});

parcelRegister("lEqFn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc3204c65d21cc9e$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $fc3204c65d21cc9e$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("ijmtJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d54b70172eed06eb$export$2e2bcd8739ae039);

var $r1m99 = parcelRequire("r1m99");

var $fKom7 = parcelRequire("fKom7");

var $1atkA = parcelRequire("1atkA");

var $jv6qc = parcelRequire("jv6qc");
var $d54b70172eed06eb$var$MILLISECONDS_IN_HOUR = 3600000;
var $d54b70172eed06eb$var$MILLISECONDS_IN_MINUTE = 60000;
var $d54b70172eed06eb$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $d54b70172eed06eb$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $jv6qc.default)
};
function $d54b70172eed06eb$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $d54b70172eed06eb$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($r1m99)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $d54b70172eed06eb$var$splitDateString(argument);
    var parseYearResult = $d54b70172eed06eb$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $d54b70172eed06eb$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $d54b70172eed06eb$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $1atkA.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($fKom7)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($fKom7)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $d54b70172eed06eb$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $d54b70172eed06eb$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $d54b70172eed06eb$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $d54b70172eed06eb$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $d54b70172eed06eb$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $d54b70172eed06eb$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $d54b70172eed06eb$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $d54b70172eed06eb$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $d54b70172eed06eb$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $d54b70172eed06eb$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $d54b70172eed06eb$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$d54b70172eed06eb$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $d54b70172eed06eb$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$d54b70172eed06eb$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $d54b70172eed06eb$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$d54b70172eed06eb$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $d54b70172eed06eb$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$d54b70172eed06eb$var$validateWeekDate(year, week)) return new Date(NaN);
        return $d54b70172eed06eb$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $d54b70172eed06eb$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$d54b70172eed06eb$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $d54b70172eed06eb$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $d54b70172eed06eb$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $d54b70172eed06eb$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$d54b70172eed06eb$var$validateTime(hours)) return NaN;
        return hours % 24 * $d54b70172eed06eb$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $d54b70172eed06eb$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$d54b70172eed06eb$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $d54b70172eed06eb$var$MILLISECONDS_IN_HOUR + minutes * $d54b70172eed06eb$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $d54b70172eed06eb$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$d54b70172eed06eb$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $d54b70172eed06eb$var$MILLISECONDS_IN_HOUR + minutes * $d54b70172eed06eb$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $d54b70172eed06eb$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $d54b70172eed06eb$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $d54b70172eed06eb$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $d54b70172eed06eb$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $d54b70172eed06eb$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $d54b70172eed06eb$var$isLeapYearIndex(year);
        if (isLeapYear && date > $d54b70172eed06eb$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $d54b70172eed06eb$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $d54b70172eed06eb$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $d54b70172eed06eb$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $d54b70172eed06eb$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $d54b70172eed06eb$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("jv6qc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e325e4c3eef30c7c$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $e325e4c3eef30c7c$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $e325e4c3eef30c7c$export$2e2bcd8739ae039 = $e325e4c3eef30c7c$var$tzPattern;

});



parcelRegister("cmxGd", function(module, exports) {
$parcel$export(module.exports, "default", () => $9001aa3f2560acb7$export$2e2bcd8739ae039);

var $1atkA = parcelRequire("1atkA");

var $ijmtJ = parcelRequire("ijmtJ");
function $9001aa3f2560acb7$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $ijmtJ.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $1atkA.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});






parcelRegister("fnbla", function(module, exports) {
$parcel$export(module.exports, "eocGlobalGroupDetailRoute", () => $acde19f87e8a7e2d$export$e6569aff8dfd4c1d);
const $acde19f87e8a7e2d$export$e6569aff8dfd4c1d = {
    name: 'eoc-global-group-detail',
    path: '/jira/ops/group-detail/:id',
    exact: true
};

});

parcelRegister("1ZnI4", function(module, exports) {
$parcel$export(module.exports, "LazyGroupDetail", () => $4ce4f6a68c461abf$export$8d4b3992eb19d436);
$parcel$export(module.exports, "default", () => $4ce4f6a68c461abf$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4ce4f6a68c461abf$export$8d4b3992eb19d436 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("6h3R7")), {
    moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
});
const $4ce4f6a68c461abf$var$AsyncGroupDetail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4ce4f6a68c461abf$export$8d4b3992eb19d436,
        pageId: "async-jira-eoc-group-detail",
        shouldShowSpinner: false
    });
$4ce4f6a68c461abf$var$AsyncGroupDetail.displayName = "AsyncGroupDetail";
var $4ce4f6a68c461abf$export$2e2bcd8739ae039 = $4ce4f6a68c461abf$var$AsyncGroupDetail;

});
parcelRegister("6h3R7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("kTnno")
]).then(()=>parcelRequire('h0ZlJ'));

});



parcelRegister("edGnQ", function(module, exports) {
$parcel$export(module.exports, "eocGlobalHeartbeatsRouteEntry", () => $4e1dd1fb0fb3e6b4$export$2d7875aa465a7757);



var $dUAVJ = parcelRequire("dUAVJ");

var $jhoDt = parcelRequire("jhoDt");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $cWOLd = parcelRequire("cWOLd");

var $7Fzs6 = parcelRequire("7Fzs6");

var $bkrFd = parcelRequire("bkrFd");

var $jgg93 = parcelRequire("jgg93");
const $4e1dd1fb0fb3e6b4$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $4e1dd1fb0fb3e6b4$export$2d7875aa465a7757 = (0, $fdS54.createEntry)((0, $cWOLd.eocGlobalHeartbeatsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgg93.HeartbeatsComponent),
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $jhoDt.resources)()
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$4e1dd1fb0fb3e6b4$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jgg93.LazyHeartbeats)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jhoDt", function(module, exports) {
$parcel$export(module.exports, "heartbeatsResource", () => $8dfe8f4a77ba78cc$export$dd38e2aa5cfda9c9);
$parcel$export(module.exports, "heartbeatsUserRightsResource", () => $8dfe8f4a77ba78cc$export$b5d9a0bcdfa848ce);
$parcel$export(module.exports, "resources", () => $8dfe8f4a77ba78cc$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $4gxAn = parcelRequire("4gxAn");
const $8dfe8f4a77ba78cc$export$dd38e2aa5cfda9c9 = (0, $7edbf.createResource)({
    type: 'heartbeatsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $4gxAn.getHeartbeatsEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $8dfe8f4a77ba78cc$export$b5d9a0bcdfa848ce = (0, $7edbf.createResource)({
    type: 'heartbeatsUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $4gxAn.getHeartbeatsUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $8dfe8f4a77ba78cc$export$bc99aaabaf7b70a7 = ()=>[
        $8dfe8f4a77ba78cc$export$dd38e2aa5cfda9c9,
        $8dfe8f4a77ba78cc$export$b5d9a0bcdfa848ce
    ];

});
parcelRegister("4gxAn", function(module, exports) {
$parcel$export(module.exports, "getHeartbeatsEndpoint", () => $505a30db1bb1b677$export$c322dad372dcb08b);
$parcel$export(module.exports, "validateHeartbeatNameEndpoint", () => $505a30db1bb1b677$export$676f6aee59f124b0);
$parcel$export(module.exports, "createHeartbeatEndpoint", () => $505a30db1bb1b677$export$891ea85cc6973b32);
$parcel$export(module.exports, "updateHeartbeatEndpoint", () => $505a30db1bb1b677$export$7311481b59e02e06);
$parcel$export(module.exports, "switchHeartbeatEndpoint", () => $505a30db1bb1b677$export$5df993f1c74d7e8e);
$parcel$export(module.exports, "deleteHeartbeatEndpoint", () => $505a30db1bb1b677$export$716e365975fc2cd1);
$parcel$export(module.exports, "getHeartbeatsUserRights", () => $505a30db1bb1b677$export$26eaca11f3b4e506);
$parcel$export(module.exports, "updateAutoCreationEndpoint", () => $505a30db1bb1b677$export$38097aade6a3b234);

var $hG5S4 = parcelRequire("hG5S4");

var $5B0vq = parcelRequire("5B0vq");
const $505a30db1bb1b677$export$c322dad372dcb08b = (teamId)=>(0, $hG5S4.eocFetch)((0, $5B0vq.generateBaseUrl)(teamId), {
        method: 'GET'
    });
const $505a30db1bb1b677$export$676f6aee59f124b0 = (heartbeatName, teamId)=>(0, $hG5S4.eocFetch)(`${(0, $5B0vq.generateBaseUrl)(teamId)}/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
        method: 'GET',
        responseType: 'headers'
    });
const $505a30db1bb1b677$export$891ea85cc6973b32 = (heartbeat, teamId)=>(0, $hG5S4.eocFetch)((0, $5B0vq.generateBaseUrl)(teamId), {
        method: 'POST',
        body: heartbeat
    });
const $505a30db1bb1b677$export$7311481b59e02e06 = (heartbeat, teamId)=>(0, $hG5S4.eocFetch)((0, $5B0vq.generateBaseUrl)(teamId), {
        method: 'PUT',
        body: heartbeat
    });
const $505a30db1bb1b677$export$5df993f1c74d7e8e = (enable, name, teamId)=>(0, $hG5S4.eocFetch)(`${(0, $5B0vq.generateBaseUrl)(teamId)}/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
        method: 'PATCH'
    });
const $505a30db1bb1b677$export$716e365975fc2cd1 = (name, teamId)=>(0, $hG5S4.eocFetch)(`${(0, $5B0vq.generateBaseUrl)(teamId)}?name=${encodeURIComponent(name)}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
const $505a30db1bb1b677$export$26eaca11f3b4e506 = (teamId)=>{
    return (0, $hG5S4.eocFetch)(`${(0, $5B0vq.generateBaseUrl)(teamId)}/rights`);
};
const $505a30db1bb1b677$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, $hG5S4.eocFetch)(`${(0, $5B0vq.generateBaseUrl)(teamId)}/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
        method: 'POST',
        responseType: 'headers'
    });

});
parcelRegister("5B0vq", function(module, exports) {
$parcel$export(module.exports, "getMaxAvailableEpoch", () => $36ad9d6ca270580c$export$1eaa8fc6df8a5dac);
$parcel$export(module.exports, "generateBaseUrl", () => $36ad9d6ca270580c$export$25e86c63685d7e40);

var $40xRZ = parcelRequire("40xRZ");
const $36ad9d6ca270580c$export$1eaa8fc6df8a5dac = ()=>{
    const today = new Date();
    const futureDate = new Date();
    futureDate.setFullYear(today.getFullYear() * (0, $40xRZ.MAX_INTERVAL_TIME_YEARS));
    const epochTime = futureDate.getTime();
    return epochTime;
};
const $36ad9d6ca270580c$export$25e86c63685d7e40 = (teamId)=>{
    return teamId ? `/v1/teams/${teamId}/heartbeats` : '/v1/heartbeats';
};

});
parcelRegister("40xRZ", function(module, exports) {
$parcel$export(module.exports, "MAX_INTERVAL_TIME_YEARS", () => $a88518cb230192b5$export$c3f9ae43b3ab397c);
$parcel$export(module.exports, "MIN_DATE_SHOWN_EPOCH", () => $a88518cb230192b5$export$f081f690fcb957ce);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $a88518cb230192b5$export$a7c923252528b255);
const $a88518cb230192b5$export$c3f9ae43b3ab397c = 5;
const $a88518cb230192b5$export$f081f690fcb957ce = 946677600;
const $a88518cb230192b5$export$a7c923252528b255 = {
    actions: 'eoc-heartbeats_actions'
};

});




parcelRegister("cWOLd", function(module, exports) {
$parcel$export(module.exports, "eocGlobalHeartbeatsRoute", () => $7b608646d6b459ee$export$48568054c59facbb);
const $7b608646d6b459ee$export$48568054c59facbb = {
    name: 'eoc-global-heartbeats',
    path: '/jira/settings/products/ops/heartbeats',
    exact: true
};

});

parcelRegister("jgg93", function(module, exports) {
$parcel$export(module.exports, "LazyHeartbeats", () => $c9a2e2e2dd2982ee$export$93c9586b023b5aa3);
$parcel$export(module.exports, "HeartbeatsComponent", () => $c9a2e2e2dd2982ee$export$43c2d87bd51ba6ac);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $c9a2e2e2dd2982ee$export$93c9586b023b5aa3 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("6SJGx")), {
    moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
});
const $c9a2e2e2dd2982ee$export$43c2d87bd51ba6ac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c9a2e2e2dd2982ee$export$93c9586b023b5aa3,
        pageId: "async-jira-eoc-heartbeats",
        shouldShowSpinner: false
    });
$c9a2e2e2dd2982ee$export$43c2d87bd51ba6ac.displayName = "HeartbeatsComponent";

});
parcelRegister("6SJGx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4d9uC").then(()=>parcelRequire('hx6Ku'));

});



parcelRegister("9Jj26", function(module, exports) {
$parcel$export(module.exports, "eocGlobalMaintenanceRouteEntry", () => $5aca66adc8822fd3$export$ce2a5648c28a5b48);



var $dUAVJ = parcelRequire("dUAVJ");

var $56YsL = parcelRequire("56YsL");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $hHMGI = parcelRequire("hHMGI");

var $bkrFd = parcelRequire("bkrFd");

var $bLKaY = parcelRequire("bLKaY");
const $5aca66adc8822fd3$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $5aca66adc8822fd3$export$ce2a5648c28a5b48 = (0, $fdS54.createEntry)((0, $hHMGI.eocGlobalMaintenanceRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $bLKaY.MaintenanceComponent),
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $56YsL.resources)()
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$5aca66adc8822fd3$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bLKaY.LazyMaintenance)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("56YsL", function(module, exports) {
$parcel$export(module.exports, "maintenanceResource", () => $b4c992ae1419a825$export$5486c78261efb2c3);
$parcel$export(module.exports, "maintenanceUserRightsResource", () => $b4c992ae1419a825$export$e4c92d8948e3625);
$parcel$export(module.exports, "resources", () => $b4c992ae1419a825$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $lrLEP = parcelRequire("lrLEP");

var $aLjPC = parcelRequire("aLjPC");
const $b4c992ae1419a825$export$5486c78261efb2c3 = (0, $7edbf.createResource)({
    type: 'maintenanceResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $aLjPC.getMaintenance)(teamId);
    },
    isBrowserOnly: true
});
const $b4c992ae1419a825$export$e4c92d8948e3625 = (0, $7edbf.createResource)({
    type: 'maintenanceUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $aLjPC.getMaintenanceUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $b4c992ae1419a825$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $lrLEP.eocCommonResources)(),
        $b4c992ae1419a825$export$5486c78261efb2c3,
        $b4c992ae1419a825$export$e4c92d8948e3625
    ];

});
parcelRegister("aLjPC", function(module, exports) {
$parcel$export(module.exports, "getMaintenance", () => $018aadcba69a9ea5$export$9cc878e1852c5ee1);
$parcel$export(module.exports, "deleteMaintenance", () => $018aadcba69a9ea5$export$f64242288df38e86);
$parcel$export(module.exports, "cancelMaintenance", () => $018aadcba69a9ea5$export$2d4a5362bda1b3c1);
$parcel$export(module.exports, "changeDateAndTime", () => $018aadcba69a9ea5$export$2162fcbd04e23a3d);
$parcel$export(module.exports, "getMaintenanceUserRights", () => $018aadcba69a9ea5$export$60048f3b7e7bf9b9);
$parcel$export(module.exports, "createMaintenance", () => $018aadcba69a9ea5$export$602dd976bd963418);
$parcel$export(module.exports, "updateMaintenance", () => $018aadcba69a9ea5$export$fa55cd063e1b15c2);

var $hG5S4 = parcelRequire("hG5S4");
const $018aadcba69a9ea5$export$9cc878e1852c5ee1 = (teamId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
const $018aadcba69a9ea5$export$f64242288df38e86 = (teamId, id)=>{
    return (0, $hG5S4.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $018aadcba69a9ea5$export$2d4a5362bda1b3c1 = (teamId, id)=>{
    return (0, $hG5S4.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
        method: 'PATCH'
    });
};
const $018aadcba69a9ea5$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
    return (0, $hG5S4.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
        method: 'PATCH',
        body: {
            endDate: endDate
        }
    });
};
const $018aadcba69a9ea5$export$60048f3b7e7bf9b9 = (teamId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
const $018aadcba69a9ea5$export$602dd976bd963418 = (payload, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
    return (0, $hG5S4.eocFetch)(url, {
        method: 'POST',
        body: payload
    });
};
const $018aadcba69a9ea5$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
    return (0, $hG5S4.eocFetch)(url, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("hHMGI", function(module, exports) {
$parcel$export(module.exports, "eocGlobalMaintenanceRoute", () => $7facb5d1581e374f$export$e0665f23a759e78f);
const $7facb5d1581e374f$export$e0665f23a759e78f = {
    name: 'eoc-global-maintenance',
    path: '/jira/settings/products/ops/maintenance',
    exact: true
};

});

parcelRegister("bLKaY", function(module, exports) {
$parcel$export(module.exports, "LazyMaintenance", () => $3f7dcd50021363f0$export$c5c7dc53d976edee);
$parcel$export(module.exports, "MaintenanceComponent", () => $3f7dcd50021363f0$export$76d7c25f72022339);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $3f7dcd50021363f0$export$c5c7dc53d976edee = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("43VuM")), {
    moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
});
const $3f7dcd50021363f0$export$76d7c25f72022339 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3f7dcd50021363f0$export$c5c7dc53d976edee,
        pageId: "async-jira-eoc-maintenance",
        shouldShowSpinner: false
    });
$3f7dcd50021363f0$export$76d7c25f72022339.displayName = "MaintenanceComponent";

});
parcelRegister("43VuM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gEYS2")
]).then(()=>parcelRequire('l1sYq'));

});



parcelRegister("aV7rM", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsHomePageNav4RouteEntry", () => $46cedd4f24585ebc$export$193586b163d4afae);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $5QT4k = parcelRequire("5QT4k");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $fdS54 = parcelRequire("fdS54");

var $3NiwI = parcelRequire("3NiwI");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fAN8Y = parcelRequire("fAN8Y");
const $46cedd4f24585ebc$export$193586b163d4afae = (0, $fdS54.createEntry)((0, $3NiwI.eocGlobalReportsHomePageNav4Route), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fAN8Y.OpsReportsRedirect),
        layout: (0, $7Fzs6.opsMigrationHubLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $5QT4k.resources)(),
            (0, $5QT4k.opsReportsPermissionResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fAN8Y.LazyOpsReportsRedirect),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5QT4k", function(module, exports) {
$parcel$export(module.exports, "opsReportsResource", () => $bb6e6b70ee3d5f11$export$8498311fc7a4ab48);
$parcel$export(module.exports, "opsReportsPermissionResource", () => $bb6e6b70ee3d5f11$export$c432f280d76e2acf);
$parcel$export(module.exports, "resources", () => $bb6e6b70ee3d5f11$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $3xjKM = parcelRequire("3xjKM");

var $atPbM = parcelRequire("atPbM");
const $bb6e6b70ee3d5f11$export$8498311fc7a4ab48 = (0, $7edbf.createResource)({
    type: 'opsReportsResource',
    getKey: ()=>'opsReportsResource',
    getData: async ()=>{
        const settings = await (0, $atPbM.getReportSettings)();
        const api = (0, $atPbM.getDashboards);
        return {
            settings: settings,
            dashboards: settings.showReportingMaintenance ? null : await api()
        };
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $bb6e6b70ee3d5f11$export$c432f280d76e2acf = (0, $7edbf.createResource)({
    type: 'opsReportsPermissionResource',
    getKey: ({ match: match })=>{
        return `opsReportsPermissionResource-${match.params?.teamId}`;
    },
    getData: async (routerContext)=>{
        const isTeamDashboard = (0, $3xjKM.isTeamReportsUrl)(routerContext.match.url);
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!isTeamDashboard || !!teamId, new (0, $jpT5w.AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
        return (0, $atPbM.getReportRights)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $bb6e6b70ee3d5f11$export$bc99aaabaf7b70a7 = ()=>[
        $bb6e6b70ee3d5f11$export$8498311fc7a4ab48,
        $bb6e6b70ee3d5f11$export$c432f280d76e2acf
    ];

});
parcelRegister("3xjKM", function(module, exports) {
$parcel$export(module.exports, "withReportingPrefix", () => $13bb21256a69a984$export$c0f073d636267c44);
$parcel$export(module.exports, "isTeamReportsUrl", () => $13bb21256a69a984$export$f923ac475871fcad);

var $7nxyA = parcelRequire("7nxyA");
function $13bb21256a69a984$export$c0f073d636267c44(input) {
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = (0, $7nxyA.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
    return input;
}
const $13bb21256a69a984$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');

});

parcelRegister("atPbM", function(module, exports) {
$parcel$export(module.exports, "getDashboards", () => $2e2b121b923904c3$export$8e4b6d6c4fec08f3);
$parcel$export(module.exports, "getReportSettings", () => $2e2b121b923904c3$export$9114b8a872caf5d8);
$parcel$export(module.exports, "getSsoEmbedUrlEndpoint", () => $2e2b121b923904c3$export$8384a95746267bd8);
$parcel$export(module.exports, "getReportRights", () => $2e2b121b923904c3$export$f4a61c3c8c619f12);
$parcel$export(module.exports, "getAVPEmbedTokens", () => $2e2b121b923904c3$export$fb46892f83504a42);

var $hG5S4 = parcelRequire("hG5S4");

var $3xjKM = parcelRequire("3xjKM");

var $iHF21 = parcelRequire("iHF21");
const $2e2b121b923904c3$export$8e4b6d6c4fec08f3 = ()=>(0, $hG5S4.eocFetch)((0, $3xjKM.withReportingPrefix)('/v5/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $iHF21.opsReportsErrorTransformer
    });
const $2e2b121b923904c3$export$e69121e90ce0231b = ()=>(0, $hG5S4.eocFetch)((0, $3xjKM.withReportingPrefix)('/v3/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $iHF21.opsReportsErrorTransformer
    });
const $2e2b121b923904c3$export$9114b8a872caf5d8 = ()=>(0, $hG5S4.eocFetch)((0, $3xjKM.withReportingPrefix)('/v3/reports/index'), {
        exactUrl: true,
        errorTransformer: $iHF21.opsReportsErrorTransformer
    });
const $2e2b121b923904c3$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
    const queryParam = teamId ? {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        teamId: teamId,
        // Adding time as queryParam to avoid browser caching
        // Should ideally be handled by "Cache-Control" header from server
        _: Date.now().toString()
    } : {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        _: Date.now().toString()
    };
    const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
    return (0, $hG5S4.eocFetch)((0, $3xjKM.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $iHF21.opsReportsErrorTransformer
    });
};
const $2e2b121b923904c3$export$f4a61c3c8c619f12 = (teamId)=>{
    let url = '/v3/reports/rights';
    if (teamId) url += `?teamId=${teamId}`;
    return (0, $hG5S4.eocFetch)((0, $3xjKM.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $iHF21.opsReportsErrorTransformer
    });
};
const $2e2b121b923904c3$export$fb46892f83504a42 = (dashboardId, teamId)=>{
    let url = '/v3/reports/embed-token';
    return (0, $hG5S4.eocFetch)((0, $3xjKM.withReportingPrefix)(url), {
        exactUrl: true,
        method: 'POST',
        body: {
            dashboardId: dashboardId,
            teamId: teamId
        },
        errorTransformer: $iHF21.opsReportsErrorTransformer
    });
};

});
parcelRegister("iHF21", function(module, exports) {
$parcel$export(module.exports, "opsReportsErrorTransformer", () => $23793aace001a279$export$b170750bd4489531);

var $6LoxL = parcelRequire("6LoxL");
const $23793aace001a279$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
const $23793aace001a279$export$b170750bd4489531 = (e)=>{
    if ((0, $6LoxL.isHTTPError)(e)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $23793aace001a279$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $6LoxL.StreamedHTTPError)(e, data, data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $6LoxL.StreamedHTTPError)(e, message, message));
    }
    return e;
};

});



parcelRegister("3NiwI", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsHomePageNav4Route", () => $240b1835d047afdb$export$e7c62a288f7d3a11);
const $240b1835d047afdb$export$e7c62a288f7d3a11 = {
    name: 'eoc-global-reports',
    path: '/jira/ops/reports',
    exact: true
};

});

parcelRegister("fAN8Y", function(module, exports) {
$parcel$export(module.exports, "LazyOpsReports", () => $abeca502330f549e$export$2404f0e35deca592);
$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $abeca502330f549e$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $abeca502330f549e$export$66850ec5549adba6);
$parcel$export(module.exports, "LazyOpsReportsUnsubscribe", () => $abeca502330f549e$export$5fd77c3bbfb22cbd);
$parcel$export(module.exports, "OpsReportsRedirect", () => $abeca502330f549e$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $abeca502330f549e$export$648ddf2d1f8b1c3f);
$parcel$export(module.exports, "OpsReports", () => $abeca502330f549e$export$87e6a54b4f5dc91e);
$parcel$export(module.exports, "OpsReportsUnsubscribe", () => $abeca502330f549e$export$7f366d77015c286f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $abeca502330f549e$export$2404f0e35deca592 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("leCfb")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $abeca502330f549e$export$d33ea1a773b744e = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("leCfb")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $abeca502330f549e$export$66850ec5549adba6 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("leCfb")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $abeca502330f549e$export$5fd77c3bbfb22cbd = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("leCfb")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $abeca502330f549e$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $abeca502330f549e$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
$abeca502330f549e$export$22253dbadb46d0cf.displayName = "OpsReportsRedirect";
const $abeca502330f549e$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $abeca502330f549e$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
$abeca502330f549e$export$648ddf2d1f8b1c3f.displayName = "GlobalOpsReports";
const $abeca502330f549e$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $abeca502330f549e$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
$abeca502330f549e$export$87e6a54b4f5dc91e.displayName = "OpsReports";
const $abeca502330f549e$export$7f366d77015c286f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $abeca502330f549e$export$5fd77c3bbfb22cbd,
        pageId: "async-jira-eoc-ops-reports-unsubscribe",
        shouldShowSpinner: false
    });
$abeca502330f549e$export$7f366d77015c286f.displayName = "OpsReportsUnsubscribe";

});
parcelRegister("leCfb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("h0YTH")),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("6rIxn")
]).then(()=>parcelRequire('4m6tD'));

});



parcelRegister("6m8PU", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsNav4RouteEntry", () => $34623785218d358b$export$90a73fe101848dd);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $5QT4k = parcelRequire("5QT4k");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $4Izce = parcelRequire("4Izce");

var $fAN8Y = parcelRequire("fAN8Y");
const $34623785218d358b$export$90a73fe101848dd = (0, $fdS54.createEntry)((0, $4Izce.eocGlobalReportsNav4Route), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fAN8Y.GlobalOpsReports),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $5QT4k.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fAN8Y.LazyGlobalOpsReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4Izce", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsNav4Route", () => $63d98b44a07fc058$export$2344cc35fd2eff4e);
const $63d98b44a07fc058$export$2344cc35fd2eff4e = {
    name: 'eoc-global-report-dashboard',
    path: '/jira/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("fOrIK", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsNewRouteEntry", () => $51b219410aa10cc1$export$b03fca5abfa8205e);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $gjbO6 = parcelRequire("gjbO6");

var $7Fzs6 = parcelRequire("7Fzs6");

var $5QT4k = parcelRequire("5QT4k");

var $dE7i5 = parcelRequire("dE7i5");
const $51b219410aa10cc1$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $dE7i5.operationsReportsShellEntrypoint)
});
const $51b219410aa10cc1$export$b03fca5abfa8205e = (0, $fdS54.createEntry)((0, $gjbO6.eocGlobalReportsNewRoute), ()=>({
        group: 'eoc',
        layout: (0, $7Fzs6.opsMigrationHubLayout),
        entryPoint: ()=>$51b219410aa10cc1$var$entryPoint,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $5QT4k.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gjbO6", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsNewRoute", () => $996d57f0111bac74$export$d6484f0a829ce6d1);
const $996d57f0111bac74$export$d6484f0a829ce6d1 = {
    name: 'eoc-global-reports-new',
    path: '/jira/ops/reports-new/:spaceId?/:tabId?',
    exact: true
};

});

parcelRegister("dE7i5", function(module, exports) {
$parcel$export(module.exports, "operationsReportsShellEntrypoint", () => $8d2ac62ca8afb79a$export$e415b2dfc20b3a53);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $8d2ac62ca8afb79a$export$e415b2dfc20b3a53 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1namT")), {
        moduleId: "d1a6267f",
        moduleName: "OperationsReportsShell",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1namT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bbGto").then(()=>parcelRequire('kStEl'));

});



parcelRegister("3gQSV", function(module, exports) {
$parcel$export(module.exports, "eocGroupPolicyRouteEntry", () => $bfdae0c7721d7cc0$export$59d06dc6c11aee83);

var $8yvgC = parcelRequire("8yvgC");

var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $fdS54 = parcelRequire("fdS54");

var $f0RR0 = parcelRequire("f0RR0");

var $iQGmB = parcelRequire("iQGmB");

var $7EF5l = parcelRequire("7EF5l");

var $ccpXk = parcelRequire("ccpXk");

var $dTa0V = parcelRequire("dTa0V");
const $bfdae0c7721d7cc0$var$groupPolicyPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8yvgC.groupPolicyEntrypoint)
});
const $bfdae0c7721d7cc0$export$59d06dc6c11aee83 = (0, $fdS54.createEntry)((0, $f0RR0.eocGroupPolicyRoute), ()=>({
        group: 'eoc',
        layout: (0, $iQGmB.opsTeamLayout),
        entryPoint () {
            return $bfdae0c7721d7cc0$var$groupPolicyPageEntryPoint;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $ccpXk.teamGroupPolicyResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8yvgC", function(module, exports) {
$parcel$export(module.exports, "groupPolicyEntrypoint", () => $fcfcaa33637c2593$export$269c84e688da8dc9);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $fcfcaa33637c2593$export$269c84e688da8dc9 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("f3pNR")), {
        moduleId: "bc31760a",
        moduleName: "GroupPolicyPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f3pNR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7jpZb").then(()=>parcelRequire('4QP14'));

});


parcelRegister("f0RR0", function(module, exports) {
$parcel$export(module.exports, "eocGroupPolicyRoute", () => $060af3e0de42a6f4$export$819e43124f65623c);
const $060af3e0de42a6f4$export$819e43124f65623c = {
    name: 'eoc-group-policy',
    path: '/jira/ops/teams/:teamId/group-policy',
    exact: true
};

});

parcelRegister("ccpXk", function(module, exports) {
$parcel$export(module.exports, "teamGroupPolicyResource", () => $3a3daf82ce575640$export$d85610d22ae9ba7d);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $jVcby = parcelRequire("jVcby");
const $3a3daf82ce575640$export$d85610d22ae9ba7d = (0, $7edbf.createResource)({
    type: 'teamGroupPolicyResource',
    getKey: (routerContext)=>`teamGroupPolicyResource#${routerContext.match.params.teamId}`,
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('teamGroupPolicyResource', 'teamId should be set to fetch team group policy'));
        return (0, $jVcby.getTeamGroupPolicy)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("jVcby", function(module, exports) {
$parcel$export(module.exports, "getTeamGroupPolicy", () => $9ad2abf0e6339dc6$export$5758478a6c54a77c);
$parcel$export(module.exports, "updateTeamGroupPolicy", () => $9ad2abf0e6339dc6$export$55dec3b93902110b);
$parcel$export(module.exports, "createTeamGroupPolicy", () => $9ad2abf0e6339dc6$export$a25df0b5762220a0);

var $lFnrZ = parcelRequire("lFnrZ");

var $hG5S4 = parcelRequire("hG5S4");
const $9ad2abf0e6339dc6$export$5758478a6c54a77c = (teamId)=>{
    return (0, $hG5S4.eocFetch)((0, $lFnrZ.withAIOpsDomainPrefix)(`/v1/policy/alert-groups/team/${teamId}`), {
        exactUrl: true
    });
};
const $9ad2abf0e6339dc6$export$55dec3b93902110b = (teamId, formValues)=>{
    return (0, $hG5S4.eocFetch)((0, $lFnrZ.withAIOpsDomainPrefix)(`/v1/policy/alert-groups/update`), {
        exactUrl: true,
        method: 'PUT',
        body: {
            teamId: teamId,
            ...formValues
        }
    });
};
const $9ad2abf0e6339dc6$export$a25df0b5762220a0 = (teamId, formValues)=>{
    return (0, $hG5S4.eocFetch)((0, $lFnrZ.withAIOpsDomainPrefix)(`/v1/policy/alert-groups/create`), {
        exactUrl: true,
        method: 'POST',
        body: {
            teamId: teamId,
            ...formValues
        }
    });
};

});



parcelRegister("imspb", function(module, exports) {
$parcel$export(module.exports, "eocHeartbeatsRouteEntry", () => $bb95f6735a5d594d$export$2c2d6115c4280a08);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jhoDt = parcelRequire("jhoDt");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $kGxrB = parcelRequire("kGxrB");

var $jgg93 = parcelRequire("jgg93");
const $bb95f6735a5d594d$export$2c2d6115c4280a08 = (0, $fdS54.createEntry)((0, $kGxrB.eocHeartbeatsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgg93.HeartbeatsComponent),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jhoDt.resources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jgg93.LazyHeartbeats),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kGxrB", function(module, exports) {
$parcel$export(module.exports, "eocHeartbeatsRoute", () => $4ba281d43ae236f9$export$71bd833dcb7bd1e9);
const $4ba281d43ae236f9$export$71bd833dcb7bd1e9 = {
    name: 'eoc-heartbeats',
    path: '/jira/ops/teams/:teamId/heartbeats',
    exact: true
};

});


parcelRegister("49q2u", function(module, exports) {
$parcel$export(module.exports, "eocIncidentsRouteEntry", () => $c728132ef4f606f2$export$51830c1e5eb2c051);

var $9OAOk = parcelRequire("9OAOk");

var $krnGE = parcelRequire("krnGE");

var $iSoIx = parcelRequire("iSoIx");

var $dUAVJ = parcelRequire("dUAVJ");

var $6Hiyd = parcelRequire("6Hiyd");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $2700E = parcelRequire("2700E");
const $c728132ef4f606f2$var$eocIncidentsPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9OAOk.eocIncidentsEntryPoint)
});
const $c728132ef4f606f2$export$51830c1e5eb2c051 = (0, $fdS54.createEntry)((0, $krnGE.eocIncidentsRoute), ()=>({
        group: 'eoc',
        navigation: {
            menuId: 'PROJECTS'
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6Hiyd.eocServicedeskCustomFieldsResource)
        ],
        entryPoint: ()=>(0, $2700E.expValEquals)('changes-and-incidents-under-operations', 'isEnabled', true, false) ? $c728132ef4f606f2$var$eocIncidentsPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9OAOk", function(module, exports) {
$parcel$export(module.exports, "eocIncidentsEntryPoint", () => $aaeae1e6c6e32268$export$7e06d829a846460f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $aaeae1e6c6e32268$export$7e06d829a846460f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2rG3Z")), {
        moduleId: "0421ac58",
        moduleName: "EocIncidents",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2rG3Z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("jKDR5")
]).then(()=>parcelRequire('gIDTn'));

});


parcelRegister("krnGE", function(module, exports) {
$parcel$export(module.exports, "eocIncidentsRoute", () => $1d761ceaa13b9cde$export$90099e3647cc6f65);
const $1d761ceaa13b9cde$export$90099e3647cc6f65 = {
    name: 'eoc-incidents',
    path: '/jira/ops/incidents',
    exact: true
};

});


parcelRegister("jswqy", function(module, exports) {
$parcel$export(module.exports, "eocMaintenanceRouteEntry", () => $5cd388a4b20a711b$export$e9c59d0d6bfec8a3);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $56YsL = parcelRequire("56YsL");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $eZYue = parcelRequire("eZYue");

var $bLKaY = parcelRequire("bLKaY");
const $5cd388a4b20a711b$export$e9c59d0d6bfec8a3 = (0, $fdS54.createEntry)((0, $eZYue.eocMaintenanceRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $bLKaY.MaintenanceComponent),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $56YsL.resources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bLKaY.LazyMaintenance),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eZYue", function(module, exports) {
$parcel$export(module.exports, "eocMaintenanceRoute", () => $d5b9cc9845deed08$export$7523f600b27b1b54);
const $d5b9cc9845deed08$export$7523f600b27b1b54 = {
    name: 'eoc-maintenance',
    path: '/jira/ops/teams/:teamId/maintenance',
    exact: true
};

});


parcelRegister("6nKGg", function(module, exports) {
$parcel$export(module.exports, "eocOnCallRedirectRouteEntry", () => $29e558f2ca6d84a5$export$c5c49f69c4fe1ea6);


var $dUAVJ = parcelRequire("dUAVJ");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $e69I5 = parcelRequire("e69I5");

var $l1KW2 = parcelRequire("l1KW2");
const $29e558f2ca6d84a5$export$c5c49f69c4fe1ea6 = (0, $fdS54.createEntry)((0, $e69I5.eocOnCallRedirectRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l1KW2.OnCallRedirect),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e69I5", function(module, exports) {
$parcel$export(module.exports, "eocOnCallRedirectRoute", () => $4afa7f895a05f297$export$d725ece0e087d522);
const $4afa7f895a05f297$export$d725ece0e087d522 = {
    name: 'eoc-on-call-redirect',
    path: '/jira/ops/teams/:teamId',
    exact: true
};

});

parcelRegister("l1KW2", function(module, exports) {
$parcel$export(module.exports, "OnCallRedirect", () => $2a4a77ed15122c50$export$659b7ce11c160b32);
$parcel$export(module.exports, "LazyOnCall", () => $2a4a77ed15122c50$export$772095aa22362f73);
$parcel$export(module.exports, "default", () => $2a4a77ed15122c50$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $gNbXR = parcelRequire("gNbXR");
var $bc9Gj = parcelRequire("bc9Gj");
const $2a4a77ed15122c50$export$659b7ce11c160b32 = ()=>{
    const [routeContext] = (0, $bc9Gj.useRouter)();
    const redirectionUrl = `${routeContext.location.pathname}/on-call`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: redirectionUrl
    });
};
$2a4a77ed15122c50$export$659b7ce11c160b32.displayName = "OnCallRedirect";

const $2a4a77ed15122c50$export$772095aa22362f73 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("54Ekw")), {
    moduleId: "./src/packages/eoc/on-call/src/index.tsx"
});
const $2a4a77ed15122c50$var$AsyncOnCall = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $2a4a77ed15122c50$export$772095aa22362f73,
        pageId: "async-jira-eoc-on-call",
        shouldShowSpinner: false
    });
$2a4a77ed15122c50$var$AsyncOnCall.displayName = "AsyncOnCall";
var $2a4a77ed15122c50$export$2e2bcd8739ae039 = $2a4a77ed15122c50$var$AsyncOnCall;

});
parcelRegister("54Ekw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fUX2s").then(()=>parcelRequire('9jxBF'));

});



parcelRegister("kvwgI", function(module, exports) {
$parcel$export(module.exports, "eocOnCallRouteEntry", () => $6cdf43caf56ad326$export$ac245212b12db871);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $8xuhY = parcelRequire("8xuhY");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $2q6gP = parcelRequire("2q6gP");

var $l1KW2 = parcelRequire("l1KW2");
const $6cdf43caf56ad326$export$ac245212b12db871 = (0, $fdS54.createEntry)((0, $2q6gP.eocOnCallRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l1KW2.default),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            ...(0, $8xuhY.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $l1KW2.LazyOnCall),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8xuhY", function(module, exports) {
$parcel$export(module.exports, "getTeamResource", () => $ca9b5c64b6e5af20$export$50271c9e7f21f10e);
$parcel$export(module.exports, "resources", () => $ca9b5c64b6e5af20$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $3YprA = parcelRequire("3YprA");

var $5gPAu = parcelRequire("5gPAu");

var $2ZHLy = parcelRequire("2ZHLy");
const $ca9b5c64b6e5af20$export$50271c9e7f21f10e = (0, $7edbf.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
        return (0, $2ZHLy.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $ca9b5c64b6e5af20$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $5gPAu.resources)(),
        (0, $3YprA.routingRulesResource),
        $ca9b5c64b6e5af20$export$50271c9e7f21f10e
    ];

});
parcelRegister("3YprA", function(module, exports) {
$parcel$export(module.exports, "routingRulesResource", () => $3d9ae2e90920693a$export$7f38c73dca88500e);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $23wOo = parcelRequire("23wOo");
const $3d9ae2e90920693a$export$7f38c73dca88500e = (0, $7edbf.createResource)({
    type: 'routingRulesResource',
    getKey: ()=>'routingRulesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
        return (0, $23wOo.getRoutingRules)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("23wOo", function(module, exports) {
$parcel$export(module.exports, "getRoutingRules", () => $830240b5b8d7e91b$export$425c24c86196521);

var $hG5S4 = parcelRequire("hG5S4");
const $830240b5b8d7e91b$export$425c24c86196521 = (teamId)=>(0, $hG5S4.eocFetch)(`/v1/teams/${teamId}/routing-rules`);

});


parcelRegister("5gPAu", function(module, exports) {
$parcel$export(module.exports, "getSchedulesResource", () => $710a32ae51a4d8d2$export$6b2b3e2a53cc13e2);
$parcel$export(module.exports, "getUiPreferencesResource", () => $710a32ae51a4d8d2$export$5c6454d866055bdd);
$parcel$export(module.exports, "getScheduleRightsResource", () => $710a32ae51a4d8d2$export$9d9ecb8586783931);
$parcel$export(module.exports, "getScheduleTimeTemplatesResource", () => $710a32ae51a4d8d2$export$90251855f07c54b4);
$parcel$export(module.exports, "resources", () => $710a32ae51a4d8d2$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $egspI = parcelRequire("egspI");

var $lrLEP = parcelRequire("lrLEP");

var $27hU5 = parcelRequire("27hU5");

var $8yqVr = parcelRequire("8yqVr");

var $eftmZ = parcelRequire("eftmZ");

var $69QX0 = parcelRequire("69QX0");

var $gZYDN = parcelRequire("gZYDN");

var $7wNR5 = parcelRequire("7wNR5");
const $710a32ae51a4d8d2$export$6b2b3e2a53cc13e2 = (0, $7edbf.createResource)({
    type: 'getSchedulesResource',
    getKey: ()=>'getSchedulesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $69QX0.endpoints).getScheduleList((0, $8yqVr.getTeamIdFromContext)(routerExtendedContext))
});
const $710a32ae51a4d8d2$export$5c6454d866055bdd = (0, $7edbf.createResource)({
    type: 'getSchedulePreferencesResource',
    getKey: ()=>'getSchedulePreferencesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $gZYDN.endpoints).getUiPreferences((0, $8yqVr.getTeamIdFromContext)(routerExtendedContext))
});
const $710a32ae51a4d8d2$export$9d9ecb8586783931 = (0, $7edbf.createResource)({
    type: 'getScheduleRightsResource',
    getKey: ()=>'getScheduleRightsResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $7wNR5.endpoints).getScheduleRights((0, $8yqVr.getTeamIdFromContext)(routerExtendedContext))
});
const $710a32ae51a4d8d2$var$localScheduleTimeTemplatesResource = (0, $7edbf.createResource)({
    type: 'getScheduleTimeTemplatesResource',
    getKey: ()=>'getScheduleTimeTemplatesResourceurce',
    isBrowserOnly: true,
    getData: async ()=>(0, $eftmZ.endpoints).getScheduleTimeTemplates()
});
const $710a32ae51a4d8d2$export$90251855f07c54b4 = ()=>(0, $egspI.fg)('alx_schedule_deduplication') ? (0, $27hU5.getTimeTemplatesResource) : $710a32ae51a4d8d2$var$localScheduleTimeTemplatesResource;
const $710a32ae51a4d8d2$export$bc99aaabaf7b70a7 = ()=>[
        $710a32ae51a4d8d2$export$6b2b3e2a53cc13e2,
        $710a32ae51a4d8d2$export$5c6454d866055bdd,
        $710a32ae51a4d8d2$export$9d9ecb8586783931,
        ...(0, $egspI.fg)('alx_schedule_deduplication') ? [] : [
            $710a32ae51a4d8d2$var$localScheduleTimeTemplatesResource
        ],
        ...(0, $27hU5.resources)(),
        ...(0, $lrLEP.eocCommonResources)()
    ];

});
parcelRegister("27hU5", function(module, exports) {
$parcel$export(module.exports, "getTimezonesResource", () => $20bf07e20f6762f4$export$7524ea9fda8149c6);
$parcel$export(module.exports, "getTimeTemplatesResource", () => $20bf07e20f6762f4$export$f045bbf39b81240d);
$parcel$export(module.exports, "resources", () => $20bf07e20f6762f4$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $egspI = parcelRequire("egspI");

var $8FxXK = parcelRequire("8FxXK");
const $20bf07e20f6762f4$export$7524ea9fda8149c6 = (0, $7edbf.createResource)({
    type: 'getEocTimezonesResource',
    getKey: ()=>'getEocTimezonesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $8FxXK.endpoints).getTimezones()
});
const $20bf07e20f6762f4$export$f045bbf39b81240d = (0, $7edbf.createResource)({
    type: 'getEocTimeTemplatesResource',
    getKey: ()=>'getEocTimeTemplatesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $8FxXK.endpoints).getTimeTemplates()
});
const $20bf07e20f6762f4$export$bc99aaabaf7b70a7 = ()=>[
        $20bf07e20f6762f4$export$7524ea9fda8149c6,
        ...(0, $egspI.fg)('alx_schedule_deduplication') ? [
            $20bf07e20f6762f4$export$f045bbf39b81240d
        ] : []
    ];

});
parcelRegister("8FxXK", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $f7c6007cf7de0f11$export$3a2536d80ecc00e7);

var $hG5S4 = parcelRequire("hG5S4");

var $bRQRX = parcelRequire("bRQRX");
const $f7c6007cf7de0f11$var$getTimezones = async ()=>{
    const response = await (0, $hG5S4.eocFetch)((0, $bRQRX.urls).customers.timezones.url(), {
        method: 'GET'
    });
    const adjusted = response.timezones.map((timezone)=>({
            ...timezone,
            offset: timezone.offset * 60000,
            currentOffset: timezone.currentOffset * 60000
        }));
    return {
        ...response,
        timezones: adjusted
    };
};
const $f7c6007cf7de0f11$var$getTimeTemplates = ()=>{
    return (0, $hG5S4.eocFetch)((0, $bRQRX.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $f7c6007cf7de0f11$export$3a2536d80ecc00e7 = {
    getTimezones: $f7c6007cf7de0f11$var$getTimezones,
    getTimeTemplates: $f7c6007cf7de0f11$var$getTimeTemplates
};

});
parcelRegister("bRQRX", function(module, exports) {
$parcel$export(module.exports, "urls", () => $d52533f8c75b6a92$export$bcae9ba627f604b6);
const $d52533f8c75b6a92$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            },
            suggested: {
                url: ()=>'/v1/alerts/responders/suggested'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        user: {
            webCalendarUrl: {
                url: ()=>`/v1/schedules/user/web-calendar-url`
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    users: {
        contacts: {
            primary: {
                url: ()=>'/v1/users/contact/primary'
            }
        }
    }
});

});



parcelRegister("8yqVr", function(module, exports) {
$parcel$export(module.exports, "getTeamIdFromContext", () => $9c4a4f9eb6c70cca$export$3ea727bebc3792bb);

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $2QwUZ = parcelRequire("2QwUZ");
const $9c4a4f9eb6c70cca$export$3ea727bebc3792bb = (routerContext)=>{
    const teamId = (0, $2QwUZ.getSafe)(()=>routerContext.match.params.teamId, null);
    (0, $7Ljuo.assert)(!(0, $2QwUZ.isEmpty)(teamId), new (0, $jpT5w.AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
    return teamId;
};

});
parcelRegister("2QwUZ", function(module, exports) {
$parcel$export(module.exports, "getSafe", () => $a46ce7bd024d87a5$export$fedb900c0ea4e699);
$parcel$export(module.exports, "isEmpty", () => $a46ce7bd024d87a5$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $a46ce7bd024d87a5$export$bedb7023a7733221);
$parcel$export(module.exports, "noLeadingOrTrailingSpaces", () => $a46ce7bd024d87a5$export$5fc068d42db64a99);

var $eDrTl = parcelRequire("eDrTl");
const $a46ce7bd024d87a5$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
    try {
        return fn();
    } catch  {
        return defaultValue;
    }
};
const $a46ce7bd024d87a5$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $a46ce7bd024d87a5$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};
const $a46ce7bd024d87a5$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, $eDrTl.messages).nameSpaceValidationError);
        };

});
parcelRegister("eDrTl", function(module, exports) {
$parcel$export(module.exports, "messages", () => $15a4caeafb121a40$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $15a4caeafb121a40$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    /*
   Misc common messages
  */ noOne: {
        id: 'eoc-schedule.common.no-one',
        defaultMessage: 'No one',
        description: 'Text displayed as a placeholder when no user is assigned to an on-call shift in the schedule.'
    },
    error: {
        id: 'eoc-schedule.common.error',
        defaultMessage: 'Error',
        description: 'Heading shown in an error state panel when an operation fails in the schedule component.'
    },
    tryAgain: {
        id: 'eoc-schedule.common.try-again',
        defaultMessage: 'Try again',
        description: 'Label on a button that allows the user to retry a failed action in the schedule component.'
    },
    cancel: {
        id: 'eoc-schedule.common.cancel',
        defaultMessage: 'Cancel',
        description: 'Label on a button that dismisses a modal or dialog without saving changes in the schedule component.'
    },
    confirm: {
        id: 'eoc-schedule.common.confirm',
        defaultMessage: 'Confirm',
        description: 'Label on a button that confirms and submits an action in the schedule component.'
    },
    addOverride: {
        id: 'eoc-schedule.common.add-override',
        defaultMessage: 'Add override',
        description: 'Label on a button or menu item that opens the add override dialog for a schedule shift period.'
    },
    overrideButton: {
        id: 'eoc-schedule.common.override',
        defaultMessage: 'Override',
        description: 'Label on a button that initiates an override action on a schedule shift.'
    },
    saveButton: {
        id: 'eoc-schedule.common.save',
        defaultMessage: 'Save',
        description: 'Label on a button that saves changes made to a schedule or rotation configuration.'
    },
    edit: {
        id: 'eoc-schedule.common.edit',
        defaultMessage: 'Edit',
        description: 'Label on a button that opens the edit view for an on-call schedule.'
    },
    turnOff: {
        id: 'eoc-schedule.common.turn-off',
        defaultMessage: 'Turn off',
        description: 'Label on a button that deactivates an on-call schedule so it stops producing shifts.'
    },
    turnOn: {
        id: 'eoc-schedule.common.turn-on',
        defaultMessage: 'Turn on',
        description: 'Label on a button that reactivates a previously disabled on-call schedule.'
    },
    delete: {
        id: 'eoc-schedule.common.delete',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule.common.duplicate',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    remove: {
        id: 'eoc-schedule.common.remove',
        defaultMessage: 'Remove',
        description: 'Label on a button that removes a participant from a rotation in the schedule editor.'
    },
    start: {
        id: 'eoc-schedule.common.start',
        defaultMessage: 'Start',
        description: 'Label for the field showing the start date and time of an on-call shift or override.'
    },
    end: {
        id: 'eoc-schedule.common.end',
        defaultMessage: 'End',
        description: 'Label for the field showing the end date and time of an on-call shift or override.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time',
        defaultMessage: 'Start time',
        description: 'Label for the time picker field indicating when an on-call shift or override begins.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time',
        defaultMessage: 'End time',
        description: 'Label for the time picker field indicating when an on-call shift or override ends.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date',
        defaultMessage: 'Start date',
        description: 'Label for the date picker field indicating when an on-call shift or override begins.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date',
        defaultMessage: 'End date',
        description: 'Label for the date picker field indicating when an on-call shift or override ends.'
    },
    team: {
        id: 'eoc-schedule.common.team',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule.common.escalation',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule.common.schedule',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    selectionCount: {
        id: 'eoc-schedule.common.selection-count',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule.common.quick-override-title',
        defaultMessage: 'Override',
        description: 'Heading shown on the quick override shift card that allows a user to temporarily replace an on-call assignee.'
    },
    search: {
        id: 'eoc-schedule.common.search',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    replaceWith: {
        id: 'eoc-schedule.common.replace-with',
        defaultMessage: 'Replace with',
        description: 'A button for opening popup for replacing a participant.'
    },
    participants: {
        id: 'eoc-schedule.common.participants',
        defaultMessage: 'Participants',
        description: 'Section label shown above the list of users participating in an on-call rotation.'
    },
    addParticipants: {
        id: 'eoc-schedule.common.add-participants',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule.common.select',
        defaultMessage: 'Select',
        description: 'Label on a button or dropdown option that triggers a selection action in the schedule component.'
    },
    teamDeleted: {
        id: 'eoc-schedule.common.team-deleted',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule.common.deleted-schedule',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule.common.deleted-escalation',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    formerUser: {
        id: 'eoc-schedule.common.former-user',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    discard: {
        id: 'eoc-schedule.common.discard',
        defaultMessage: 'Discard',
        description: 'Label on a button that discards unsaved changes to a schedule or rotation and reverts to the last saved state.'
    },
    confirmProceed: {
        id: 'eoc-schedule.common.confirm-proceed',
        defaultMessage: 'Are you sure to proceed?',
        description: 'Text shown in a confirmation dialog asking the user to verify they want to continue with a potentially destructive action.'
    },
    /*
   Common validation related messages
  */ required: {
        id: 'eoc-schedule.common.required',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule.common.no-space-at-end-or-start',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule.common.max-length',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule.common.max-value',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule.common.min-value',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule.common.time-past',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule.common.start-later-end',
        defaultMessage: 'Start time should be before the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule.common.end-earlier-start',
        defaultMessage: 'End time should be after the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule.common.start-end-same',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule.common.thirty-minute-intervals',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    nameSpaceValidationError: {
        id: 'eoc-schedule.common.name-space-validation-error',
        defaultMessage: 'The name cannot start or end with a space.',
        description: 'Error message for name validation when it starts or ends with a space'
    }
});

});



parcelRegister("eftmZ", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $4b93d841395bf5c2$export$3a2536d80ecc00e7);

var $hG5S4 = parcelRequire("hG5S4");

var $aCCqA = parcelRequire("aCCqA");
const $4b93d841395bf5c2$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.scheduleId.rotations.rotationId.order.url({
        rotationId: rotationId,
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            after: after
        }
    });
};
const $4b93d841395bf5c2$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'GET'
    });
};
const $4b93d841395bf5c2$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'DELETE'
    });
};
const $4b93d841395bf5c2$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.scheduleId.rotations.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            rotationPeriod: rotationPeriod,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $4b93d841395bf5c2$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: id
    }), {
        method: 'PUT',
        body: {
            id: id,
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            rotationPeriod: rotationPeriod,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $4b93d841395bf5c2$var$getScheduleTimeTemplates = ()=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $4b93d841395bf5c2$export$3a2536d80ecc00e7 = {
    deleteRotation: $4b93d841395bf5c2$var$deleteRotation,
    getRotation: $4b93d841395bf5c2$var$getRotation,
    orderRotation: $4b93d841395bf5c2$var$orderRotation,
    addRotation: $4b93d841395bf5c2$var$addRotation,
    editRotation: $4b93d841395bf5c2$var$editRotation,
    getScheduleTimeTemplates: $4b93d841395bf5c2$var$getScheduleTimeTemplates
};

});
parcelRegister("aCCqA", function(module, exports) {
$parcel$export(module.exports, "urls", () => $56a3ab02ca74fcf5$export$bcae9ba627f604b6);
const $56a3ab02ca74fcf5$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        teams: {
            teamId: {
                url: ({ teamId: teamId } = {
                    teamId: ':teamId'
                })=>`/v1/schedules/teams/${teamId}`,
                rights: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}/rights`
                }
            }
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    uiPreference: {
        schedule: {
            team: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                }
            }
        }
    }
});

});


parcelRegister("69QX0", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $2dd0fdc4018119e6$export$3a2536d80ecc00e7);

var $hG5S4 = parcelRequire("hG5S4");

var $aCCqA = parcelRequire("aCCqA");
const $2dd0fdc4018119e6$var$getScheduleList = (teamId)=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.teams.teamId.url({
        teamId: teamId
    }));
};
const $2dd0fdc4018119e6$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone
        }
    });
};
const $2dd0fdc4018119e6$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $2dd0fdc4018119e6$export$3a2536d80ecc00e7 = {
    deleteSchedule: $2dd0fdc4018119e6$var$deleteSchedule,
    getScheduleList: $2dd0fdc4018119e6$var$getScheduleList,
    updateSchedule: $2dd0fdc4018119e6$var$updateSchedule
};

});

parcelRegister("gZYDN", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $aa36fa46019cd62f$export$3a2536d80ecc00e7);

var $hG5S4 = parcelRequire("hG5S4");

var $aCCqA = parcelRequire("aCCqA");
const $aa36fa46019cd62f$var$getUiPreferences = (teamId)=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }));
};
const $aa36fa46019cd62f$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }), {
        method: 'PATCH',
        body: {
            [key]: value
        }
    });
};
const $aa36fa46019cd62f$export$3a2536d80ecc00e7 = {
    getUiPreferences: $aa36fa46019cd62f$var$getUiPreferences,
    updateUiPreferences: $aa36fa46019cd62f$var$updateUiPreferences
};

});

parcelRegister("7wNR5", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $c4fc00396719de9e$export$3a2536d80ecc00e7);

var $hG5S4 = parcelRequire("hG5S4");

var $aCCqA = parcelRequire("aCCqA");
const $c4fc00396719de9e$var$getScheduleRights = (teamId)=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.teams.teamId.rights.url({
        teamId: teamId
    }));
};
const $c4fc00396719de9e$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.url(), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            teamId: teamId,
            timezone: timezone,
            // Created schedules are enabled by default
            enabled: true
        }
    });
};
const $c4fc00396719de9e$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
    return (0, $hG5S4.eocFetch)((0, $aCCqA.urls).schedules.scheduleId.clone.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone,
            teamId: teamId
        }
    });
};
const $c4fc00396719de9e$export$3a2536d80ecc00e7 = {
    createSchedule: $c4fc00396719de9e$var$createSchedule,
    getScheduleRights: $c4fc00396719de9e$var$getScheduleRights,
    cloneSchedule: $c4fc00396719de9e$var$cloneSchedule
};

});


parcelRegister("2ZHLy", function(module, exports) {
$parcel$export(module.exports, "getTeam", () => $161514a98884d98e$export$491fe77f22ab2b51);

var $hG5S4 = parcelRequire("hG5S4");
const $161514a98884d98e$export$491fe77f22ab2b51 = (teamId)=>(0, $hG5S4.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });

});


parcelRegister("2q6gP", function(module, exports) {
$parcel$export(module.exports, "eocOnCallRoute", () => $224fb0a9351874c2$export$5eaa466ae8a4d7d3);
const $224fb0a9351874c2$export$5eaa466ae8a4d7d3 = {
    name: 'eoc-on-call',
    path: '/jira/ops/teams/:teamId/on-call',
    exact: true
};

});


parcelRegister("cFf23", function(module, exports) {
$parcel$export(module.exports, "eocOverviewAllTeamsRouteEntry", () => $e3334a4be83d1937$export$842d7c81068bb64e);


var $2PaMI = parcelRequire("2PaMI");

var $iIMjz = parcelRequire("iIMjz");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $buDbj = parcelRequire("buDbj");

var $lrLEP = parcelRequire("lrLEP");

var $dFZLT = parcelRequire("dFZLT");
const $e3334a4be83d1937$export$842d7c81068bb64e = (0, $fdS54.createEntry)((0, $buDbj.eocOverviewAllTeamsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dFZLT.EocOverviewAllTeamsComponent),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $iIMjz.getTeamsResource),
            ...(0, $lrLEP.eocCommonResources)()
        ],
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsOverviewNav)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2PaMI.LazyHorizontalOperationsOverviewNav),
            (0, $dFZLT.LazyOverviewAllTeamsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iIMjz", function(module, exports) {
$parcel$export(module.exports, "getTeamsResource", () => $ff76e2501e9ff9b4$export$27d854bd39923fc7);
/* eslint-disable jira/import-whitelist */ 
var $kOqHp = parcelRequire("kOqHp");

var $f23sK = parcelRequire("f23sK");

var $7edbf = parcelRequire("7edbf");

var $jOrx3 = parcelRequire("jOrx3");
const $ff76e2501e9ff9b4$var$ConsolidationState = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};
const $ff76e2501e9ff9b4$var$CONSOLIDATION_STATE_RESOURCE_TYPE = 'EOC_TENANT';
const $ff76e2501e9ff9b4$export$27d854bd39923fc7 = (0, $7edbf.createResource)({
    type: (0, $f23sK.getTeamsResource).type,
    getKey: (0, $f23sK.getTeamsResource).getKey,
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
        if (!atlassianAccountId) return null;
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const tenantInfo = await dependencies[$ff76e2501e9ff9b4$var$CONSOLIDATION_STATE_RESOURCE_TYPE]?.promise;
        const isOpsAdmin = (0, $jOrx3.checkIsOpsAdmin)(tenantInfo);
        const shouldSeeAllTeams = isSiteAdmin || isAdmin || isOpsAdmin;
        return (0, $kOqHp.getTeams)({
            queryParams: {
                accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                showAvatar: true,
                includeTeamExternalDetails: true
            }
        });
    },
    isBrowserOnly: true,
    maxAge: 0,
    depends: [
        $ff76e2501e9ff9b4$var$CONSOLIDATION_STATE_RESOURCE_TYPE
    ]
});

});
parcelRegister("kOqHp", function(module, exports) {
$parcel$export(module.exports, "getTeams", () => $15d14b375a1d4d17$export$5a622455e94bac3);
$parcel$export(module.exports, "getGettingStartedPanelData", () => $15d14b375a1d4d17$export$75a3cf367715bb4c);
$parcel$export(module.exports, "completeGettingStartedStep", () => $15d14b375a1d4d17$export$b24dd1c472c69929);
$parcel$export(module.exports, "updateAdvancedState", () => $15d14b375a1d4d17$export$ad4ca5a13e063f87);
$parcel$export(module.exports, "hideGettingStartedStep", () => $15d14b375a1d4d17$export$2f22e28f8d14761a);
$parcel$export(module.exports, "updateGettingStartedCollapsedState", () => $15d14b375a1d4d17$export$3379654c1861addc);
$parcel$export(module.exports, "updateGettingStartedShowCompletedAndHiddenStepsState", () => $15d14b375a1d4d17$export$72e4297791bb4a81);

var $hG5S4 = parcelRequire("hG5S4");
const $15d14b375a1d4d17$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
    const params = new URLSearchParams();
    if (queryParams.keyword) params.append('keyword', queryParams.keyword);
    if (queryParams.size) params.append('size', queryParams.size.toString());
    if (queryParams.offset) params.append('offset', queryParams.offset.toString());
    if (queryParams.accountId) params.append('memberId', queryParams.accountId);
    if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
    if (queryParams.includeTeamExternalDetails) params.append('includeTeamExternalDetails', String(queryParams.includeTeamExternalDetails));
    if (queryParams.migratedTeamsOnly) params.append('migratedTeamsOnly', String(queryParams.migratedTeamsOnly));
    if (url) return (0, $hG5S4.eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
        exactUrl: true
    });
    return (0, $hG5S4.eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
};
const $15d14b375a1d4d17$export$75a3cf367715bb4c = ()=>{
    return (0, $hG5S4.eocFetch)('/v1/users/getting-started');
};
const $15d14b375a1d4d17$export$b24dd1c472c69929 = (stepKey)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/getting-started/${stepKey}/complete`, {
        method: 'PATCH'
    });
};
const $15d14b375a1d4d17$export$ad4ca5a13e063f87 = (advanced)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/getting-started/advanced`, {
        method: 'PATCH',
        body: {
            advanced: advanced
        }
    });
};
const $15d14b375a1d4d17$export$2f22e28f8d14761a = (stepKey)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/getting-started/${stepKey}/hide`, {
        method: 'PATCH'
    });
};
const $15d14b375a1d4d17$export$3379654c1861addc = (collapsed)=>{
    return (0, $hG5S4.eocFetch)('/v1/users/getting-started/collapse', {
        method: 'PATCH',
        body: {
            collapsed: collapsed
        }
    });
};
const $15d14b375a1d4d17$export$72e4297791bb4a81 = (showCompletedAndHiddenSteps)=>{
    return (0, $hG5S4.eocFetch)('/v1/users/getting-started/showCompletedAndHiddenSteps', {
        method: 'PATCH',
        body: {
            showCompletedAndHiddenSteps: showCompletedAndHiddenSteps
        }
    });
};

});

parcelRegister("f23sK", function(module, exports) {
$parcel$export(module.exports, "getTeamsResource", () => $82801c00cf713e4c$export$27d854bd39923fc7);
$parcel$export(module.exports, "getGettingStartedPanelResource", () => $82801c00cf713e4c$export$4679bdf293e86637);

var $7edbf = parcelRequire("7edbf");

var $kOqHp = parcelRequire("kOqHp");
const $82801c00cf713e4c$export$27d854bd39923fc7 = (0, $7edbf.createResource)({
    type: 'getTeamsResource',
    getKey: ()=>'overview',
    getData: async ()=>{
        throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
    },
    isBrowserOnly: true
});
const $82801c00cf713e4c$export$4679bdf293e86637 = (0, $7edbf.createResource)({
    type: 'getGettingStartedPanelResource',
    getKey: ()=>'overview-getting-started-panel-resource',
    getData: async ()=>{
        return (0, $kOqHp.getGettingStartedPanelData)();
    },
    isBrowserOnly: true,
    maxAge: 0
});

});


parcelRegister("buDbj", function(module, exports) {
$parcel$export(module.exports, "eocOverviewAllTeamsRoute", () => $0179a38f1550e5a1$export$dbe53627482b9f0f);
const $0179a38f1550e5a1$export$dbe53627482b9f0f = {
    name: 'eoc-overview-all-teams',
    path: '/jira/ops/overview/teams',
    exact: true
};

});

parcelRegister("dFZLT", function(module, exports) {
$parcel$export(module.exports, "LazyOverviewPage", () => $6c9bf2724266a4dc$export$c7c96cc8d6e9a8f1);
$parcel$export(module.exports, "LazyOverviewAllTeamsPage", () => $6c9bf2724266a4dc$export$9a22ecad8322834e);
$parcel$export(module.exports, "EocOverviewComponent", () => $6c9bf2724266a4dc$export$b22309f0ee469d5c);
$parcel$export(module.exports, "EocOverviewAllTeamsComponent", () => $6c9bf2724266a4dc$export$2713003ebbdbb975);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6c9bf2724266a4dc$export$c7c96cc8d6e9a8f1 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("4dQTD")).then((m)=>m.OverviewPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
});

const $6c9bf2724266a4dc$export$9a22ecad8322834e = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2BwOk")).then((m)=>m.AllTeamsPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
});
const $6c9bf2724266a4dc$export$b22309f0ee469d5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6c9bf2724266a4dc$export$c7c96cc8d6e9a8f1,
        pageId: "async-jira-eoc-overview",
        shouldShowSpinner: false
    });
$6c9bf2724266a4dc$export$b22309f0ee469d5c.displayName = "EocOverviewComponent";
const $6c9bf2724266a4dc$export$2713003ebbdbb975 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6c9bf2724266a4dc$export$9a22ecad8322834e,
        pageId: "async-jira-eoc-overview-all-teams",
        shouldShowSpinner: false
    });
$6c9bf2724266a4dc$export$2713003ebbdbb975.displayName = "EocOverviewAllTeamsComponent";

});
parcelRegister("4dQTD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gpnUT").then(()=>parcelRequire('jPd6h'));

});

parcelRegister("2BwOk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4OQ2A").then(()=>parcelRequire('ho7ib'));

});



parcelRegister("iuMQY", function(module, exports) {
$parcel$export(module.exports, "eocOverviewRouteEntry", () => $5fd79eb8249d2c1c$export$f1a859c727c30be4);


var $2PaMI = parcelRequire("2PaMI");

var $iIMjz = parcelRequire("iIMjz");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $dkOZx = parcelRequire("dkOZx");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $7AoOb = parcelRequire("7AoOb");

var $7Fzs6 = parcelRequire("7Fzs6");

var $lrLEP = parcelRequire("lrLEP");

var $f23sK = parcelRequire("f23sK");

var $2700E = parcelRequire("2700E");

var $dFZLT = parcelRequire("dFZLT");
// firstProjectResource is only consumed by the cross-flow onboarding (XFlowOnboarding + demoSpace),
// which is gated by lumos_ops_template_xflow. Skip the getFirstProject prefetch for non-enrolled
// users. Read WITHOUT exposure (exposure is fired upstream at template selection). Exposed as a
// function spread so the route entry stays a statically-analysable `() => ({})`.
const $5fd79eb8249d2c1c$var$getXflowOnboardingResources = ()=>{
    const [opsXflowExperiment] = (0, $2700E.UNSAFE_noExposureExp)('lumos_ops_template_xflow');
    return opsXflowExperiment.get('isEnabled', false) ? [
        (0, $dkOZx.firstProjectResource)
    ] : [];
};
const $5fd79eb8249d2c1c$export$f1a859c727c30be4 = (0, $fdS54.createEntry)((0, $7AoOb.eocOverviewRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dFZLT.EocOverviewComponent),
        layout: (0, $7Fzs6.opsMigrationHubLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $iIMjz.getTeamsResource),
            (0, $f23sK.getGettingStartedPanelResource),
            ...$5fd79eb8249d2c1c$var$getXflowOnboardingResources(),
            ...(0, $lrLEP.eocCommonResources)()
        ],
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsOverviewNav)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2PaMI.LazyHorizontalOperationsOverviewNav),
            (0, $dFZLT.LazyOverviewPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7AoOb", function(module, exports) {
$parcel$export(module.exports, "eocOverviewRoute", () => $c09c06f236b86b08$export$cb929d46451a5c12);
const $c09c06f236b86b08$export$cb929d46451a5c12 = {
    name: 'eoc-overview',
    path: '/jira/ops/overview',
    exact: true
};

});


parcelRegister("6Dohh", function(module, exports) {
$parcel$export(module.exports, "eocPermissionsRouteEntry", () => $6fa24d7bfb162a06$export$c2ced436a30c60dc);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $5IGuw = parcelRequire("5IGuw");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $1NQUU = parcelRequire("1NQUU");

var $hO7uV = parcelRequire("hO7uV");
const $6fa24d7bfb162a06$export$c2ced436a30c60dc = (0, $fdS54.createEntry)((0, $1NQUU.eocPermissionsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hO7uV.default),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // pageAccessResource should be defined before memberRolesResources since they depend on it
            (0, $5IGuw.pageAccessResource),
            ...(0, $5IGuw.resources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hO7uV.LazyMemberRoles),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5IGuw", function(module, exports) {
$parcel$export(module.exports, "pageAccessResource", () => $bbcc82f48d5488c9$export$b0d36f8262140e35);
$parcel$export(module.exports, "memberRolesResource", () => $bbcc82f48d5488c9$export$5c4885c1f1a535b);
$parcel$export(module.exports, "getTeamResource", () => $bbcc82f48d5488c9$export$50271c9e7f21f10e);
$parcel$export(module.exports, "customTeamRolesResource", () => $bbcc82f48d5488c9$export$ed1eb48699cf7893);
$parcel$export(module.exports, "resources", () => $bbcc82f48d5488c9$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $egspI = parcelRequire("egspI");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $1CEwX = parcelRequire("1CEwX");
const $bbcc82f48d5488c9$var$mapStatus = (status, userAccessLevel)=>{
    if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
    if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
    if (status === 'ACCESS_EXISTS') return 'member';
    if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
    if (status === '' || status === undefined) return 'member';
    return 'invite';
};
const $bbcc82f48d5488c9$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
    let isAuthorizedToSeeMemberRolesPage = false;
    if (dependencies[$bbcc82f48d5488c9$var$PAGE_ACCESS_RESOURCE_TYPE]) {
        const data = await dependencies[$bbcc82f48d5488c9$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
        isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
    }
    return isAuthorizedToSeeMemberRolesPage;
};
const $bbcc82f48d5488c9$var$getMembersPaginated = async (teamId)=>{
    let hasNextPage = true;
    let endCursor = '';
    let members = [];
    while(hasNextPage && endCursor !== null){
        const gqlResponse = await (0, $1CEwX.getMembers)(teamId, endCursor);
        const membersResponse = gqlResponse.data?.team?.teamV2?.members;
        const pageInfo = membersResponse?.pageInfo;
        endCursor = pageInfo?.endCursor ?? '';
        hasNextPage = pageInfo?.hasNextPage ?? false;
        const newMembers = membersResponse?.edges?.map((edge)=>edge.node.member) ?? [];
        if (newMembers) members = [
            ...members,
            ...newMembers
        ];
    }
    return members;
};
const $bbcc82f48d5488c9$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
const $bbcc82f48d5488c9$export$b0d36f8262140e35 = (0, $7edbf.createResource)({
    type: $bbcc82f48d5488c9$var$PAGE_ACCESS_RESOURCE_TYPE,
    getKey: ()=>'pageAccessResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
        return (0, $1CEwX.getMemberRolesPageAccess)(teamId);
    },
    isBrowserOnly: true
});
const $bbcc82f48d5488c9$export$5c4885c1f1a535b = (0, $7edbf.createResource)({
    type: 'memberRolesResource',
    getKey: ()=>'memberRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $bbcc82f48d5488c9$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage && !(0, $egspI.fg)('ops_member_roles_page_access_detailed_rights_2')) return null;
        let members;
        members = await $bbcc82f48d5488c9$var$getMembersPaginated(teamId);
        const memberRoleResponse = await (0, $1CEwX.getRoleAndJSMLicenseInfoEndpoint)({
            platformTeamId: teamId,
            accountIds: members.map((member)=>member.accountId)
        });
        const teamMembers = members.map((user)=>{
            const userWithRole = memberRoleResponse.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
            return {
                ...user,
                role: userWithRole?.roleId || 'user',
                jsmLicense: userWithRole?.jsmLicense || false,
                jiraAdmin: userWithRole?.jiraAdmin || false,
                invitationStatus: 'member'
            };
        });
        const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
        if (!membersWithoutJSMLicense.length) return teamMembers;
        const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
        try {
            const { embeddedValue: embeddedValue } = await (0, $1CEwX.getJSMInvitationStatusInfoEndpoint)({
                accountIds: accountIds
            });
            return teamMembers.map((user)=>{
                const userWithInvitationStatus = embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                return {
                    ...user,
                    invitationStatus: $bbcc82f48d5488c9$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                };
            });
        } catch  {
            return teamMembers;
        }
    },
    isBrowserOnly: true,
    // TODO remove dependency on cleanup ops_member_roles_page_access_detailed_rights_2
    depends: [
        $bbcc82f48d5488c9$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $bbcc82f48d5488c9$export$50271c9e7f21f10e = (0, $7edbf.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
        return (0, $1CEwX.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $bbcc82f48d5488c9$export$ed1eb48699cf7893 = (0, $7edbf.createResource)({
    type: 'customTeamRolesResource',
    getKey: ()=>'customRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $7Ljuo.assert)(!!teamId, new (0, $jpT5w.AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $bbcc82f48d5488c9$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage && !(0, $egspI.fg)('ops_member_roles_page_access_detailed_rights_2')) return null;
        return (0, $1CEwX.getCustomTeamRolesEndpoint)(teamId);
    },
    isBrowserOnly: true,
    // TODO remove dependency on cleanup ops_member_roles_page_access_detailed_rights_2
    depends: [
        $bbcc82f48d5488c9$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $bbcc82f48d5488c9$export$bc99aaabaf7b70a7 = ()=>[
        $bbcc82f48d5488c9$export$5c4885c1f1a535b,
        $bbcc82f48d5488c9$export$50271c9e7f21f10e,
        $bbcc82f48d5488c9$export$ed1eb48699cf7893
    ];

});
parcelRegister("1CEwX", function(module, exports) {
$parcel$export(module.exports, "getMembers", () => $eae5b380241559ba$export$f4931e6f9feb30c5);
$parcel$export(module.exports, "getMemberRolesPageAccess", () => $eae5b380241559ba$export$95d4c4e762437fdd);
$parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", () => $eae5b380241559ba$export$38ab389cb64a5000);
$parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", () => $eae5b380241559ba$export$fd43007da8683026);
$parcel$export(module.exports, "getTeam", () => $eae5b380241559ba$export$491fe77f22ab2b51);
$parcel$export(module.exports, "getCustomTeamRolesEndpoint", () => $eae5b380241559ba$export$ebfa293eb1ef42f5);

var $egspI = parcelRequire("egspI");

var $hG5S4 = parcelRequire("hG5S4");
var $7nxyA = parcelRequire("7nxyA");
const $eae5b380241559ba$var$operationName = 'memberRolesTeamMembersQuery';
const $eae5b380241559ba$var$getMembersParams = (after)=>{
    const firstParam = (0, $egspI.fg)('platform_increase_limit_of_members_query') ? 'first: 300' : 'first: 100';
    const afterParam = after ? `, after: "${after}"` : '';
    return `(${firstParam}${afterParam})`;
};
const $eae5b380241559ba$export$f4931e6f9feb30c5 = (teamId, after)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $7nxyA.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${$eae5b380241559ba$var$getMembersParams(after)}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
					pageInfo {
						endCursor
						hasNextPage
					}
				}
			}
		}
	}
	`;
    return (0, $hG5S4.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $eae5b380241559ba$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $eae5b380241559ba$export$95d4c4e762437fdd = (teamId)=>(0, $hG5S4.eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
const $eae5b380241559ba$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, $hG5S4.eocFetch)(`/v1/teams/members`, {
        method: 'POST',
        body: {
            platformTeamId: platformTeamId,
            accountIds: accountIds
        }
    });
const $eae5b380241559ba$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, $hG5S4.eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
        method: 'GET'
    });
const $eae5b380241559ba$export$491fe77f22ab2b51 = (teamId)=>(0, $hG5S4.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });
const $eae5b380241559ba$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, $hG5S4.eocFetch)(`/v1/teams/${platformTeamId}/roles`);

});


parcelRegister("1NQUU", function(module, exports) {
$parcel$export(module.exports, "eocPermissionsRoute", () => $10e4d947bcf103ba$export$8e6afd724de3be6e);
const $10e4d947bcf103ba$export$8e6afd724de3be6e = {
    name: 'eoc-permissions',
    path: '/jira/ops/teams/:teamId/settings',
    exact: true
};

});

parcelRegister("hO7uV", function(module, exports) {
$parcel$export(module.exports, "LazyMemberRoles", () => $555a71c0b63fe8a3$export$27b4fb95241ab47);
$parcel$export(module.exports, "default", () => $555a71c0b63fe8a3$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $555a71c0b63fe8a3$export$27b4fb95241ab47 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("WjOby")), {
    moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
});
const $555a71c0b63fe8a3$var$AsyncMemberRoles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $555a71c0b63fe8a3$export$27b4fb95241ab47,
        pageId: "async-jira-eoc-member-roles",
        shouldShowSpinner: false
    });
$555a71c0b63fe8a3$var$AsyncMemberRoles.displayName = "AsyncMemberRoles";
var $555a71c0b63fe8a3$export$2e2bcd8739ae039 = $555a71c0b63fe8a3$var$AsyncMemberRoles;

});
parcelRegister("WjOby", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gGvuX")
]).then(()=>parcelRequire('12qX1'));

});



parcelRegister("fJVg1", function(module, exports) {
$parcel$export(module.exports, "eocReportsTeamRedirectRouteEntry", () => $de1255ff6c9f6bb8$export$c5606e8eeca32c0f);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $5QT4k = parcelRequire("5QT4k");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $Qa7MN = parcelRequire("Qa7MN");

var $fAN8Y = parcelRequire("fAN8Y");
const $de1255ff6c9f6bb8$export$c5606e8eeca32c0f = (0, $fdS54.createEntry)((0, $Qa7MN.eocReportsTeamRedirectRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fAN8Y.OpsReportsRedirect),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            ...(0, $5QT4k.resources)(),
            (0, $5QT4k.opsReportsPermissionResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fAN8Y.LazyOpsReportsRedirect),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("Qa7MN", function(module, exports) {
$parcel$export(module.exports, "eocReportsTeamRedirectRoute", () => $e9c182781372ce35$export$26b0a544e6502d55);
const $e9c182781372ce35$export$26b0a544e6502d55 = {
    name: 'eoc-reports',
    path: '/jira/ops/teams/:teamId/reports',
    exact: true
};

});


parcelRegister("SDmDy", function(module, exports) {
$parcel$export(module.exports, "eocReportsTeamRouteEntry", () => $9867d5f3c3ec65b6$export$cd1c1a81e516fec5);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $5QT4k = parcelRequire("5QT4k");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $eZLkf = parcelRequire("eZLkf");

var $fAN8Y = parcelRequire("fAN8Y");
const $9867d5f3c3ec65b6$export$cd1c1a81e516fec5 = (0, $fdS54.createEntry)((0, $eZLkf.eocReportsTeamRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fAN8Y.OpsReports),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            ...(0, $5QT4k.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fAN8Y.LazyOpsReports),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eZLkf", function(module, exports) {
$parcel$export(module.exports, "eocReportsTeamRoute", () => $542ea3e19d2da651$export$c9e0796615c034f3);
const $542ea3e19d2da651$export$c9e0796615c034f3 = {
    name: 'eoc-reports-team',
    path: '/jira/ops/teams/:teamId/reports/:dashboardId',
    exact: true
};

});


parcelRegister("aL0Nn", function(module, exports) {
$parcel$export(module.exports, "eocReportsUnsubscribeRouteEntry", () => $e602890f062a8547$export$6e8d112a548528b5);


var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $cFKmi = parcelRequire("cFKmi");

var $fAN8Y = parcelRequire("fAN8Y");
const $e602890f062a8547$export$6e8d112a548528b5 = (0, $fdS54.createEntry)((0, $cFKmi.eocReportsUnsubscribeRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fAN8Y.OpsReportsUnsubscribe),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fAN8Y.LazyOpsReportsUnsubscribe)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cFKmi", function(module, exports) {
$parcel$export(module.exports, "eocReportsUnsubscribeRoute", () => $ad8ba39cb9745417$export$72cde899ee974e6e);
const $ad8ba39cb9745417$export$72cde899ee974e6e = {
    name: 'eoc-reports-unsubscribe',
    path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("l1Fco", function(module, exports) {
$parcel$export(module.exports, "eocScheduleGlobalRouteEntry", () => $302226e603079a0d$export$831e8756cdaae4ba);

var $euxye = parcelRequire("euxye");



var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $dJCsm = parcelRequire("dJCsm");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $bjGLE = parcelRequire("bjGLE");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $bkrFd = parcelRequire("bkrFd");

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $302226e603079a0d$var$LazyScheduleGlobalPage = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("h3kjs")).then((m)=>m.ScheduleGlobalPage), {
    moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
});
const $302226e603079a0d$var$EocScheduleGlobalComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $302226e603079a0d$var$LazyScheduleGlobalPage,
        pageId: "async-jira-eoc-schedule-global",
        shouldShowSpinner: false
    });
$302226e603079a0d$var$EocScheduleGlobalComponent.displayName = "EocScheduleGlobalComponent";
const $302226e603079a0d$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $302226e603079a0d$export$831e8756cdaae4ba = (0, $fdS54.createEntry)((0, $bjGLE.eocScheduleGlobalRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: $302226e603079a0d$var$EocScheduleGlobalComponent,
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $dJCsm.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$302226e603079a0d$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            $302226e603079a0d$var$LazyScheduleGlobalPage
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dJCsm", function(module, exports) {
$parcel$export(module.exports, "resources", () => $2a6e89f34a86f3b3$export$bc99aaabaf7b70a7);

var $lrLEP = parcelRequire("lrLEP");

var $27hU5 = parcelRequire("27hU5");
const $2a6e89f34a86f3b3$export$bc99aaabaf7b70a7 = ()=>[
        (0, $27hU5.getTimezonesResource),
        (0, $27hU5.getTimeTemplatesResource),
        ...(0, $lrLEP.eocCommonResources)()
    ];

});

parcelRegister("bjGLE", function(module, exports) {
$parcel$export(module.exports, "eocScheduleGlobalRoute", () => $909bbc4778a6e1e9$export$10454dc485142eb6);
const $909bbc4778a6e1e9$export$10454dc485142eb6 = {
    name: 'eoc-schedules',
    path: '/jira/settings/products/ops/schedules',
    exact: true
};

});

parcelRegister("h3kjs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5OrJL").then(()=>parcelRequire('3VYoU'));

});


parcelRegister("jlZ27", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertDetailRouteEntry", () => $afcdd77492f01769$export$94aaa7006da9d63a);


var $8dcm7 = parcelRequire("8dcm7");

var $6RSCO = parcelRequire("6RSCO");

var $8HUuJ = parcelRequire("8HUuJ");

var $dUAVJ = parcelRequire("dUAVJ");

var $eRPKt = parcelRequire("eRPKt");

var $jKCvj = parcelRequire("jKCvj");

var $7EF5l = parcelRequire("7EF5l");

var $i860n = parcelRequire("i860n");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $f4N10 = parcelRequire("f4N10");

var $hgRSr = parcelRequire("hgRSr");
const $afcdd77492f01769$export$94aaa7006da9d63a = (0, $fdS54.createEntry)((0, $f4N10.eocTeamAlertDetailRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hgRSr.default),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            ...(0, $jKCvj.resources)(),
            ...(0, $eRPKt.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('automation_discoverability_in_jsm'), (0, $8dcm7.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hgRSr.LazyAlertList),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("f4N10", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertDetailRoute", () => $21622db4a730ed2e$export$ac102dc13a0f4aff);
const $21622db4a730ed2e$export$ac102dc13a0f4aff = {
    name: 'eoc-team-alert-detail',
    path: '/jira/ops/teams/:teamId/alerts/:id',
    exact: true
};

});

parcelRegister("hgRSr", function(module, exports) {
$parcel$export(module.exports, "LazyAlertList", () => $cc94d56fcc0b11b5$export$f4aafff31d950b6c);
$parcel$export(module.exports, "default", () => $cc94d56fcc0b11b5$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $cc94d56fcc0b11b5$export$f4aafff31d950b6c = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("i9j0s")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $cc94d56fcc0b11b5$var$AsyncAlertList = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $cc94d56fcc0b11b5$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });
$cc94d56fcc0b11b5$var$AsyncAlertList.displayName = "AsyncAlertList";
var $cc94d56fcc0b11b5$export$2e2bcd8739ae039 = $cc94d56fcc0b11b5$var$AsyncAlertList;

});


parcelRegister("ucY9k", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRouteEntry", () => $d786a9509df269bf$export$8c07dc381591dc69);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $3ZTVj = parcelRequire("3ZTVj");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $76SEK = parcelRequire("76SEK");

var $evYwU = parcelRequire("evYwU");

var $eh3wx = parcelRequire("eh3wx");

var $1NDcF = parcelRequire("1NDcF");
const $d786a9509df269bf$export$8c07dc381591dc69 = (0, $fdS54.createEntry)((0, $76SEK.eocTeamAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $evYwU.AlertIssueSync),
        layout: (0, $iQGmB.opsTeamLayout),
        slot: (0, $eh3wx.AlertIssueSyncCreate),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $3ZTVj.resources).configuredSyncsResource,
            (0, $3ZTVj.resources).userAccessRightsResource,
            (0, $3ZTVj.resources).getTeamResource
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1NDcF.LazyAlertIssueSync),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("76SEK", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRoute", () => $5bde2faaef2de285$export$915ef1948fe4650a);
const $5bde2faaef2de285$export$915ef1948fe4650a = {
    name: 'eoc-team-alert-issue-syncing-create',
    path: '/jira/ops/teams/:teamId/syncs/create',
    exact: true
};

});


parcelRegister("gX0iW", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRouteEntry", () => $f9614a8049238427$export$6298ff494c460e75);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $3ZTVj = parcelRequire("3ZTVj");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $hhNHo = parcelRequire("hhNHo");

var $9tKCs = parcelRequire("9tKCs");

var $evYwU = parcelRequire("evYwU");

var $1NDcF = parcelRequire("1NDcF");
const $f9614a8049238427$export$6298ff494c460e75 = (0, $fdS54.createEntry)((0, $hhNHo.eocTeamAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $evYwU.AlertIssueSync),
        layout: (0, $iQGmB.opsTeamLayout),
        slot: (0, $9tKCs.AlertIssueSyncDetail),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $3ZTVj.resources).configuredSyncsResource,
            (0, $3ZTVj.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1NDcF.LazyAlertIssueSync),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hhNHo", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRoute", () => $34d2e89e0f0234a1$export$e91535fc2137c3b);
const $34d2e89e0f0234a1$export$e91535fc2137c3b = {
    name: 'eoc-team-alert-issue-syncing-detail',
    path: '/jira/ops/teams/:teamId/syncs/:syncId',
    exact: true
};

});


parcelRegister("90t7w", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingRouteEntry", () => $bb4696f4526b1605$export$be342a3401146aae);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $3ZTVj = parcelRequire("3ZTVj");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $kLzUx = parcelRequire("kLzUx");

var $evYwU = parcelRequire("evYwU");

var $1NDcF = parcelRequire("1NDcF");
const $bb4696f4526b1605$export$be342a3401146aae = (0, $fdS54.createEntry)((0, $kLzUx.eocTeamAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $evYwU.AlertIssueSync),
        layout: (0, $iQGmB.opsTeamLayout),
        slot: null,
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $3ZTVj.resources).configuredSyncsResource,
            (0, $3ZTVj.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1NDcF.LazyAlertIssueSync),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kLzUx", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingRoute", () => $4658c997b44000e8$export$37ea7624561cbb89);
const $4658c997b44000e8$export$37ea7624561cbb89 = {
    name: 'eoc-team-alert-issue-syncing',
    path: '/jira/ops/teams/:teamId/syncs',
    exact: true
};

});


parcelRegister("3nRWh", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertListRouteEntry", () => $0e8946f622a8bcaf$export$de37dab3b3ed8e5c);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jKCvj = parcelRequire("jKCvj");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $cQi5H = parcelRequire("cQi5H");

var $hgRSr = parcelRequire("hgRSr");
const $0e8946f622a8bcaf$export$de37dab3b3ed8e5c = (0, $fdS54.createEntry)((0, $cQi5H.eocTeamAlertListRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hgRSr.default),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            ...(0, $jKCvj.resources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hgRSr.LazyAlertList),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cQi5H", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertListRoute", () => $0fa1bad3815131a9$export$94efd60f23d97aa5);
const $0fa1bad3815131a9$export$94efd60f23d97aa5 = {
    name: 'eoc-team-alerts',
    path: '/jira/ops/teams/:teamId/alerts',
    exact: true
};

});


parcelRegister("aSN2a", function(module, exports) {
$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRouteEntry", () => $52bcad9f6cc609b4$export$d2ce6f09ef8aa840);

var $6RSCO = parcelRequire("6RSCO");

var $4B518 = parcelRequire("4B518");

var $835qG = parcelRequire("835qG");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $cUVjM = parcelRequire("cUVjM");

var $f2rva = parcelRequire("f2rva");
const $52bcad9f6cc609b4$export$d2ce6f09ef8aa840 = (0, $fdS54.createEntry)((0, $cUVjM.eocTeamCustomerLogsDownloadRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $f2rva.CustomerLogsDownloadPage),
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $835qG.downloadResources)()
        ],
        forPaint: [
            (0, $f2rva.LazyCustomerLogsDownLoad)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("835qG", function(module, exports) {
$parcel$export(module.exports, "resources", () => $2177bfb6739ead18$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "downloadResources", () => $2177bfb6739ead18$export$8571305c82629fe4);

var $lrLEP = parcelRequire("lrLEP");

var $4STdg = parcelRequire("4STdg");

var $8InGo = parcelRequire("8InGo");

var $fALr3 = parcelRequire("fALr3");
const $2177bfb6739ead18$export$bc99aaabaf7b70a7 = ()=>[
        (0, $fALr3.uiSettingsResource),
        (0, $8InGo.logsResource),
        ...(0, $lrLEP.eocCommonResources)()
    ];
const $2177bfb6739ead18$export$8571305c82629fe4 = ()=>[
        (0, $4STdg.downloadAuditLogsResource),
        ...(0, $lrLEP.eocCommonResources)()
    ];

});
parcelRegister("4STdg", function(module, exports) {
$parcel$export(module.exports, "downloadAuditLogsResource", () => $05f5bb2b17bb215b$export$304da75014b88b78);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $iKabd = parcelRequire("iKabd");
const $05f5bb2b17bb215b$export$304da75014b88b78 = (0, $7edbf.createResource)({
    type: 'download-audit-logs-resource',
    getKey: ()=>'download-audit-logs-resource',
    getData: async (routerContext)=>{
        const uniqueKey = routerContext.match.params.exportUniqueKey;
        (0, $7Ljuo.assert)(!!uniqueKey, new (0, $jpT5w.AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
        return (0, $iKabd.fetchDownloadLinkEndpoint)(uniqueKey);
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("iKabd", function(module, exports) {
$parcel$export(module.exports, "fetchDownloadLinkEndpoint", () => $480c19d35b497dd0$export$c8df7e5942ba1d96);

var $hG5S4 = parcelRequire("hG5S4");
const $480c19d35b497dd0$var$getFilenameFromContentDisposition = (contentDisposition)=>{
    if (!contentDisposition) return null;
    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (match && match[1]) return match[1].replace(/['"]/g, '').replace(/\//g, '-');
    return null;
};
const $480c19d35b497dd0$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
    const response = await (0, $hG5S4.eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
        responseType: 'headers'
    });
    const content = await response.text();
    const contentDisposition = response.headers?.get('content-disposition');
    const filenameFromHeader = $480c19d35b497dd0$var$getFilenameFromContentDisposition(contentDisposition);
    const now = new Date();
    const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const timeStr = `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
    const filename = filenameFromHeader ?? `Audit_logs_${dateStr}-${timeStr}.csv`;
    return {
        content: content,
        filename: filename
    };
};

});


parcelRegister("8InGo", function(module, exports) {
$parcel$export(module.exports, "logsResource", () => $f4bb682ecafe91aa$export$fd88b4310d3f52ff);

var $7edbf = parcelRequire("7edbf");

var $gv0eb = parcelRequire("gv0eb");
const $f4bb682ecafe91aa$export$fd88b4310d3f52ff = (0, $7edbf.createResource)({
    type: 'ui-get-logs',
    getKey: (routerContext)=>{
        const integrationId = routerContext.match.params.integrationId;
        const urlParam = new URLSearchParams();
        Object.entries(routerContext.query).forEach(([key, value])=>{
            if (value) urlParam.set(key, value);
        });
        return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
    },
    getData: async (routerContext)=>{
        return (0, $gv0eb.fetchLogs)({
            fromUnit: routerContext.query?.fromUnit,
            fromValue: routerContext.query?.fromValue,
            startTimestamp: routerContext.query?.startTimestamp,
            endTimestamp: routerContext.query?.endTimestamp,
            eventCategories: routerContext.query?.eventCategories,
            levels: routerContext.query?.levels,
            size: routerContext.query?.size ?? 30,
            insertedAt: routerContext.query?.insertedAt,
            searchString: routerContext.query?.searchString,
            pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
            integrationId: routerContext.match.params.integrationId
        });
    },
    maxAge: 60000,
    isBrowserOnly: true
});

});
parcelRegister("gv0eb", function(module, exports) {
$parcel$export(module.exports, "fetchLogs", () => $1f3f794ceea1381e$export$b9fcc8145a518db4);

var $hG5S4 = parcelRequire("hG5S4");

var $672mU = parcelRequire("672mU");
const $1f3f794ceea1381e$export$b9fcc8145a518db4 = async (params)=>{
    const urlParams = (0, $672mU.generateLogParams)(params);
    return (0, $hG5S4.eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, $672mU.postProcessLogsSearch)(urlParams, response));
};

});
parcelRegister("672mU", function(module, exports) {
$parcel$export(module.exports, "isValidTimePeriodFormat", () => $b5c1537de0a37b83$export$2214112898027187);
$parcel$export(module.exports, "getBetweenErrorMessage", () => $b5c1537de0a37b83$export$b29a6f1d6d345720);
$parcel$export(module.exports, "isValidBetweenInput", () => $b5c1537de0a37b83$export$7b619dd534dac336);
$parcel$export(module.exports, "isInvalidDateValue", () => $b5c1537de0a37b83$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "checkQueryIncludesValue", () => $b5c1537de0a37b83$export$792d5c0a6d15a15e);
$parcel$export(module.exports, "parseGroupOptionQuery", () => $b5c1537de0a37b83$export$f344cca10df5ca13);
$parcel$export(module.exports, "parseOptionQuery", () => $b5c1537de0a37b83$export$100c2d7fc380fbfa);
$parcel$export(module.exports, "collectQueryParamsFromOptions", () => $b5c1537de0a37b83$export$4db9080fab1bce85);
$parcel$export(module.exports, "calculateTimeBetween", () => $b5c1537de0a37b83$export$42dac873831f0e2);
$parcel$export(module.exports, "generateLogParams", () => $b5c1537de0a37b83$export$85293a2f3995ddcc);
$parcel$export(module.exports, "fromUnitConverter", () => $b5c1537de0a37b83$export$ae02811946c03a4b);
$parcel$export(module.exports, "createBaseQuery", () => $b5c1537de0a37b83$export$9a8301702bf003c4);
$parcel$export(module.exports, "calculateNewStartAndEndTimestamp", () => $b5c1537de0a37b83$export$b06db0f8b326b929);
$parcel$export(module.exports, "isDetailsSectionEmpty", () => $b5c1537de0a37b83$export$74cb10c4b9924e49);
$parcel$export(module.exports, "generateParamsForOneMonthInterval", () => $b5c1537de0a37b83$export$130612b33e678a37);
$parcel$export(module.exports, "calculateWidthAccordingToLevel", () => $b5c1537de0a37b83$export$e083dc64e00e053b);
$parcel$export(module.exports, "getSourceStringFromUrl", () => $b5c1537de0a37b83$export$c6631e198cf7c0f4);
$parcel$export(module.exports, "makeMarkup", () => $b5c1537de0a37b83$export$59302306c6f78677);
$parcel$export(module.exports, "postProcessLogsSearch", () => $b5c1537de0a37b83$export$9a858fe3837c0be0);
$parcel$export(module.exports, "isObject", () => $b5c1537de0a37b83$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectNotEmpty", () => $b5c1537de0a37b83$export$ef1babdfa24b430e);
$parcel$export(module.exports, "isObjectEmpty", () => $b5c1537de0a37b83$export$23cfe696632d10f4);
$parcel$export(module.exports, "checkSourceExpandedSection", () => $b5c1537de0a37b83$export$994e710d733916ea);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $dyXC5 = parcelRequire("dyXC5");

var $a0DO4 = parcelRequire("a0DO4");

var $dGdlo = parcelRequire("dGdlo");

var $7cCLc = parcelRequire("7cCLc");

var $9Ctw7 = parcelRequire("9Ctw7");

var $6jLTU = parcelRequire("6jLTU");

var $WqSvO = parcelRequire("WqSvO");

var $8Sdzy = parcelRequire("8Sdzy");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $1AMko = parcelRequire("1AMko");

var $9av1a = parcelRequire("9av1a");

var $3Lshc = parcelRequire("3Lshc");

var $fsOFe = parcelRequire("fsOFe");
// jira-frontend/src/packages/jql-builder-basic-datetime/src/ui/utils/time-functions.tsx
const $b5c1537de0a37b83$var$isNumeric = (value)=>/^\d+$/.test(value);
const $b5c1537de0a37b83$export$2214112898027187 = (timeDigits, timeUnit)=>{
    return timeDigits === '' || timeDigits !== undefined && $b5c1537de0a37b83$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, $9av1a.RANGE_OPTIONS).includes(timeUnit);
};
const $b5c1537de0a37b83$export$b29a6f1d6d345720 = (intl, value)=>{
    if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, $fsOFe.default).validationMessageAtLeastOneValue);
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, $fsOFe.default).validationMessageBeforeGreaterThanAfter);
    if (value && (value?.startDate !== '' && !(0, $dGdlo.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $dGdlo.default)(new Date(value?.endDate)))) return intl.formatMessage((0, $fsOFe.default).validationMessageInvalidDateFormat);
    return undefined;
};
const $b5c1537de0a37b83$export$7b619dd534dac336 = (value)=>{
    if (!value?.startDate && !value?.endDate) return false;
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
    if (value && (value?.startDate !== '' && !(0, $dGdlo.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $dGdlo.default)(new Date(value?.endDate)))) return false;
    return true;
};
const $b5c1537de0a37b83$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $dGdlo.default)((0, $7cCLc.default)(value)) && value !== '';
};
const $b5c1537de0a37b83$export$760bb1b75585fb94 = (value)=>{
    return value.map((event)=>event.value).join(',');
};
const $b5c1537de0a37b83$export$792d5c0a6d15a15e = (query, value)=>{
    return query?.includes(value.toString()) ?? false;
};
const $b5c1537de0a37b83$export$f344cca10df5ca13 = (query, options)=>{
    if (!query) return [];
    const labels = [];
    options.map((option)=>{
        option.options.map((item)=>labels.push(item));
    });
    return labels.filter(({ value: value })=>$b5c1537de0a37b83$export$792d5c0a6d15a15e(query, value));
};
const $b5c1537de0a37b83$export$100c2d7fc380fbfa = (query, options)=>{
    if (!query) return [];
    return options.filter((label)=>query.includes(label.value.toString()));
};
const $b5c1537de0a37b83$export$422789958d8174dd = (unit)=>(0, $9av1a.RANGE_OPTIONS).includes(unit);
const $b5c1537de0a37b83$export$4db9080fab1bce85 = (options)=>{
    return options.map((option)=>option.value).join(',');
};
const $b5c1537de0a37b83$var$isTimeQueryParamsValid = (params)=>{
    if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
    else if (params.has('fromUnit') && params.has('fromValue')) return true;
    return false;
};
const $b5c1537de0a37b83$export$42dac873831f0e2 = (params)=>{
    const now = new Date();
    if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
        const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
        switch(params.get('fromUnit')){
            case 'HOUR':
                params.set('endTimestamp', (now.getTime() * (0, $3Lshc.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $9Ctw7.default)(now, {
                    hours: parsedFromValue
                }).getTime() * (0, $3Lshc.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'DAY':
                params.set('endTimestamp', (now.getTime() * (0, $3Lshc.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $9Ctw7.default)(now, {
                    days: parsedFromValue
                }).getTime() * (0, $3Lshc.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'WEEK':
                params.set('endTimestamp', (now.getTime() * (0, $3Lshc.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $9Ctw7.default)(now, {
                    weeks: parsedFromValue
                }).getTime() * (0, $3Lshc.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'MONTH':
                params.set('endTimestamp', (now.getTime() * (0, $3Lshc.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $9Ctw7.default)(now, {
                    months: parsedFromValue
                }).getTime() * (0, $3Lshc.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
        }
        params.delete('fromUnit');
        params.delete('fromValue');
    }
    return params;
};
const $b5c1537de0a37b83$export$85293a2f3995ddcc = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value])=>{
        if (value) urlParams.append(key, decodeURI(value));
    });
    if (!$b5c1537de0a37b83$var$isTimeQueryParamsValid(urlParams)) {
        // Remove time parameters if exists since they were not matched.
        urlParams.delete('fromUnit');
        urlParams.delete('fromValue');
        urlParams.delete('startTimestamp');
        urlParams.delete('endTimestamp');
        urlParams.append('fromUnit', 'DAY');
        urlParams.append('fromValue', '1');
    }
    return $b5c1537de0a37b83$export$42dac873831f0e2(urlParams);
};
const $b5c1537de0a37b83$var$calculateTimeDifference = (startDate, endDate)=>{
    const minutesDiff = (0, $dyXC5.default)(endDate, startDate);
    if (minutesDiff < 60) return {
        hours: 1,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
    };
    const hoursDiff = minutesDiff / 60;
    const daysDiff = minutesDiff / 60 / 24;
    const weeksDiff = minutesDiff / 60 / 24 / 7;
    const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
    return {
        hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
        days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
        weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
        months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
    };
};
const $b5c1537de0a37b83$export$ae02811946c03a4b = (startDate, endDate)=>{
    const parsedStartDate = (0, $7cCLc.default)(startDate);
    const parsedEndDate = (0, $7cCLc.default)(endDate);
    const timeDifference = $b5c1537de0a37b83$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
    if (timeDifference.months > 0) return {
        timeUnit: 'MONTH',
        timeDigits: timeDifference.months.toString()
    };
    else if (timeDifference.weeks > 0) return {
        timeUnit: 'WEEK',
        timeDigits: timeDifference.weeks.toString()
    };
    else if (timeDifference.days > 0) return {
        timeUnit: 'DAY',
        timeDigits: timeDifference.days.toString()
    };
    else return {
        timeUnit: 'HOUR',
        timeDigits: timeDifference.hours.toString()
    };
};
const $b5c1537de0a37b83$export$9a8301702bf003c4 = (query)=>{
    let searchQuery = {};
    if (query.searchString) searchQuery = {
        ...searchQuery,
        searchString: query.searchString
    };
    if (query.startTimestamp && query.endTimestamp) searchQuery = {
        ...searchQuery,
        startTimestamp: query.startTimestamp,
        endTimestamp: query.endTimestamp
    };
    if (query.timeType) searchQuery = {
        ...searchQuery,
        timeType: query.timeType
    };
    if (query.eventCategories) searchQuery = {
        ...searchQuery,
        eventCategories: query.eventCategories
    };
    if (query.levels) searchQuery = {
        ...searchQuery,
        levels: query.levels
    };
    if (query.size) searchQuery = {
        ...searchQuery,
        size: query.size
    };
    return searchQuery;
};
function $b5c1537de0a37b83$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
    const startDateIntValue = parseInt(startTimestamp) / (0, $3Lshc.NANOSECONDS_IN_MILLISECOND);
    const endDateIntValue = parseInt(endTimestamp) / (0, $3Lshc.NANOSECONDS_IN_MILLISECOND);
    const { timeDigits: fromValue, timeUnit: fromUnit } = $b5c1537de0a37b83$export$ae02811946c03a4b((0, $a0DO4.default)(startDateIntValue), (0, $a0DO4.default)(endDateIntValue));
    const params = $b5c1537de0a37b83$export$42dac873831f0e2(new URLSearchParams({
        fromValue: fromValue,
        fromUnit: fromUnit
    }));
    const startTimestampParams = params.get('startTimestamp');
    const endTimestampParams = params.get('endTimestamp');
    (0, $7Ljuo.assert)(!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(startTimestampParams) && !(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(endTimestampParams), new (0, $jpT5w.AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
    return {
        startTimestamp: startTimestampParams,
        endTimestamp: endTimestampParams
    };
}
const $b5c1537de0a37b83$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
    if (!importantField || !raw) return true;
    const parsedImportantField = JSON.parse(importantField);
    const parsedRaw = JSON.parse(raw);
    return ((0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(parsedRaw);
};
const $b5c1537de0a37b83$export$130612b33e678a37 = ()=>{
    const params = $b5c1537de0a37b83$export$42dac873831f0e2(new URLSearchParams({
        fromUnit: 'MONTH',
        fromValue: '1'
    }));
    const startDate = params.get('startTimestamp');
    const endDate = params.get('endTimestamp');
    (0, $7Ljuo.assert)(!!startDate && !!endDate, new (0, $jpT5w.AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
    return {
        dateTimeValue: {
            startDate: startDate,
            endDate: endDate
        },
        timeType: (0, $1AMko.TimeRadioOptions).WITHIN_THE_LAST
    };
};
const $b5c1537de0a37b83$export$e083dc64e00e053b = (level)=>{
    const BASE_OFFSET = 18;
    return `${(0, $3Lshc.DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
};
const $b5c1537de0a37b83$export$c6631e198cf7c0f4 = (search)=>{
    const splittedSearch = search.split(/source=/i);
    if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
    return '';
};
function $b5c1537de0a37b83$export$59302306c6f78677(fragment, key) {
    const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
    if (nodeType === Node.TEXT_NODE) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: textContent
    }, key);
    const children = [];
    childNodes.forEach((childNode, i)=>{
        const markup = $b5c1537de0a37b83$export$59302306c6f78677(childNode, String(i));
        if (markup) children.push(markup);
    });
    switch(nodeName){
        case 'B':
            return /*#__PURE__*/ (0, $e79Pd.jsx)("b", {
                children: children
            }, key);
        case 'I':
            return /*#__PURE__*/ (0, $e79Pd.jsx)("i", {
                children: children
            }, key);
        case 'STRONG':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                weight: "bold",
                children: children
            }, key);
        case 'EM':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                as: "em",
                children: children
            }, key);
        case 'CODE':
            // eslint-disable-next-line @atlaskit/design-system/no-html-code
            return /*#__PURE__*/ (0, $e79Pd.jsx)("code", {
                children: children
            }, key);
    }
    if (children.length === 1) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: children[0]
    }, key);
    if (children.length) return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        children: children
    }, key);
    return null;
}
const $b5c1537de0a37b83$export$9a858fe3837c0be0 = (urlParams, response)=>{
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
        ...response,
        data: {
            ...response.data,
            pagination: {
                ...response.data.pagination,
                calcStartDate: urlParams.get('startTimestamp'),
                calcEndDate: urlParams.get('endTimestamp')
            }
        }
    };
    return response;
};
function $b5c1537de0a37b83$export$a6cdc56e425d0d0a(val) {
    return typeof val === 'object' && val !== null;
}
function $b5c1537de0a37b83$export$ef1babdfa24b430e(object) {
    return !$b5c1537de0a37b83$export$23cfe696632d10f4(object);
}
function $b5c1537de0a37b83$export$23cfe696632d10f4(object) {
    return Object.keys(object).length === 0;
}
const $b5c1537de0a37b83$export$994e710d733916ea = (src)=>Object.values(src).some((value)=>$b5c1537de0a37b83$export$a6cdc56e425d0d0a(value));

});
parcelRegister("1AMko", function(module, exports) {
$parcel$export(module.exports, "TimeRadioOptions", () => $07cedf7dbb8f4a36$export$ff1338756af30600);
var $07cedf7dbb8f4a36$export$ff1338756af30600 = /*#__PURE__*/ function(TimeRadioOptions) {
    TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
    TimeRadioOptions["BETWEEN"] = "between";
    return TimeRadioOptions;
}({});

});

parcelRegister("9av1a", function(module, exports) {
$parcel$export(module.exports, "RANGE_OPTIONS", () => $c2aca97cad31bebf$export$a0f3448347834e6b);
const $c2aca97cad31bebf$export$a0f3448347834e6b = [
    'HOUR',
    'DAY',
    'WEEK',
    'MONTH'
];

});

parcelRegister("3Lshc", function(module, exports) {
$parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", () => $1a77becfa3b8ec56$export$4b254bc84a71033a);
$parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", () => $1a77becfa3b8ec56$export$753f41e31eccb6d7);
$parcel$export(module.exports, "getHeaderWidths", () => $1a77becfa3b8ec56$export$8aa6dbdb947f7df1);
$parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", () => $1a77becfa3b8ec56$export$1220f90483bde21);
const $1a77becfa3b8ec56$export$4b254bc84a71033a = 'size';
const $1a77becfa3b8ec56$export$753f41e31eccb6d7 = 1000000;
const $1a77becfa3b8ec56$export$8aa6dbdb947f7df1 = (params)=>{
    const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH } = params.showEventCategoryField ? {
        // Widths for audit logs page
        DATE_HEADER_WIDTH: 16,
        CATEGORY_HEADER_WIDTH: 16,
        TYPE_HEADER_WIDTH: 10
    } : {
        // Widths for integration-specific log page
        DATE_HEADER_WIDTH: 14,
        CATEGORY_HEADER_WIDTH: 0,
        TYPE_HEADER_WIDTH: 12
    };
    const columnsToShow = [
        DATE_HEADER_WIDTH,
        CATEGORY_HEADER_WIDTH,
        TYPE_HEADER_WIDTH
    ];
    let sum = 0;
    columnsToShow.forEach((width)=>{
        sum += width;
    });
    return {
        DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
        CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
        TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
        CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
    };
};
const $1a77becfa3b8ec56$export$1220f90483bde21 = 250;

});

parcelRegister("fsOFe", function(module, exports) {
$parcel$export(module.exports, "default", () => $45a9ffe25ad95992$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $45a9ffe25ad95992$var$messages = (0, $7eNDO.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: 'Specify a valid time range.',
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageAtLeastOneValue: {
        id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
        defaultMessage: 'Select at least one value.',
        description: 'Message displayed to the user when there is no selected before and end date together'
    }
});
var $45a9ffe25ad95992$export$2e2bcd8739ae039 = $45a9ffe25ad95992$var$messages;

});




parcelRegister("fALr3", function(module, exports) {
$parcel$export(module.exports, "uiSettingsResource", () => $62b81732909b20f1$export$f2b33518cf31cd40);

var $7edbf = parcelRequire("7edbf");

var $4Z7qw = parcelRequire("4Z7qw");
const $62b81732909b20f1$export$f2b33518cf31cd40 = (0, $7edbf.createResource)({
    type: 'ui-settings-resource',
    getKey: ()=>'ui-settings-resource',
    getData: async ()=>(0, $4Z7qw.fetchUiSettingsEndpoint)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("4Z7qw", function(module, exports) {
$parcel$export(module.exports, "fetchUiSettingsEndpoint", () => $c15f1c2fabf00e05$export$ea2f12bcbdce2020);

var $hG5S4 = parcelRequire("hG5S4");
const $c15f1c2fabf00e05$export$ea2f12bcbdce2020 = async ()=>{
    return (0, $hG5S4.eocFetch)('/v1/logs');
};

});



parcelRegister("cUVjM", function(module, exports) {
$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRoute", () => $f0f81f6706e357d8$export$678856ccddc0bc05);
const $f0f81f6706e357d8$export$678856ccddc0bc05 = {
    name: 'eoc-team-customer-logs-download',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
    exact: true
};

});

parcelRegister("f2rva", function(module, exports) {
$parcel$export(module.exports, "LazyCustomerLogs", () => $f1f1ce3ce335ff67$export$6e30e25faf4f6dce);
$parcel$export(module.exports, "LazyCustomerLogsDownLoad", () => $f1f1ce3ce335ff67$export$898c7cb3b28a6104);
$parcel$export(module.exports, "default", () => $f1f1ce3ce335ff67$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CustomerLogsDownloadPage", () => $f1f1ce3ce335ff67$export$a5786cf859b7b457);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f1f1ce3ce335ff67$export$6e30e25faf4f6dce = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("68RgR")), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});

const $f1f1ce3ce335ff67$export$898c7cb3b28a6104 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("68RgR")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});
const $f1f1ce3ce335ff67$var$AsyncCustomerLogsDownLoad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f1f1ce3ce335ff67$export$6e30e25faf4f6dce,
        pageId: "async-jira-eoc-customer-logs",
        shouldShowSpinner: false
    });
$f1f1ce3ce335ff67$var$AsyncCustomerLogsDownLoad.displayName = "AsyncCustomerLogsDownLoad";
var $f1f1ce3ce335ff67$export$2e2bcd8739ae039 = $f1f1ce3ce335ff67$var$AsyncCustomerLogsDownLoad;
const $f1f1ce3ce335ff67$export$a5786cf859b7b457 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f1f1ce3ce335ff67$export$898c7cb3b28a6104,
        pageId: "async-jira-eoc-customer-logs-download",
        shouldShowSpinner: false
    });
$f1f1ce3ce335ff67$export$a5786cf859b7b457.displayName = "CustomerLogsDownloadPage";

});
parcelRegister("68RgR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("b3EnT")
]).then(()=>parcelRequire('5rg55'));

});



parcelRegister("jTbdr", function(module, exports) {
$parcel$export(module.exports, "eocTeamCustomerLogsRouteEntry", () => $8965dfc66d0f2b17$export$42ca979ec2919b23);



var $dUAVJ = parcelRequire("dUAVJ");

var $835qG = parcelRequire("835qG");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $26TzB = parcelRequire("26TzB");

var $bkrFd = parcelRequire("bkrFd");

var $f2rva = parcelRequire("f2rva");
const $8965dfc66d0f2b17$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $8965dfc66d0f2b17$export$42ca979ec2919b23 = (0, $fdS54.createEntry)((0, $26TzB.eocTeamCustomerLogsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $f2rva.default),
        layout: (0, $7Fzs6.opsSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$8965dfc66d0f2b17$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $835qG.resources)()
        ],
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $f2rva.LazyCustomerLogs)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("26TzB", function(module, exports) {
$parcel$export(module.exports, "eocTeamCustomerLogsRoute", () => $b232a2623d72a5b0$export$4b517044f5f7830d);
const $b232a2623d72a5b0$export$4b517044f5f7830d = {
    name: 'eoc-team-customer-logs',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs',
    exact: true
};

});


parcelRegister("doFbY", function(module, exports) {
$parcel$export(module.exports, "eocTeamGroupDetailRouteEntry", () => $acf065ef7671ec49$export$2b25520e20820251);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jKCvj = parcelRequire("jKCvj");

var $4988G = parcelRequire("4988G");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $nGpHJ = parcelRequire("nGpHJ");

var $1ZnI4 = parcelRequire("1ZnI4");
const $acf065ef7671ec49$export$2b25520e20820251 = (0, $fdS54.createEntry)((0, $nGpHJ.eocTeamGroupDetailRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1ZnI4.default),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            ...(0, $4988G.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $jKCvj.resources)()
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1ZnI4.LazyGroupDetail),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("nGpHJ", function(module, exports) {
$parcel$export(module.exports, "eocTeamGroupDetailRoute", () => $c66f2851ddfdcf0d$export$aa8cf61e94739f21);
const $c66f2851ddfdcf0d$export$aa8cf61e94739f21 = {
    name: 'eoc-team-group-detail',
    path: '/jira/ops/teams/:teamId/group-detail/:id',
    exact: true
};

});


parcelRegister("fWzFt", function(module, exports) {
$parcel$export(module.exports, "eocUserNotificationsRouteEntry", () => $23870691096294d3$export$15b42089d01e5917);



var $6RSCO = parcelRequire("6RSCO");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $bnFXJ = parcelRequire("bnFXJ");

var $9BoWi = parcelRequire("9BoWi");

var $42KYp = parcelRequire("42KYp");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $dtTsR = parcelRequire("dtTsR");

var $bkrFd = parcelRequire("bkrFd");

var $iNuQM = parcelRequire("iNuQM");
const $23870691096294d3$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $23870691096294d3$export$15b42089d01e5917 = (0, $fdS54.createEntry)((0, $dtTsR.eocUserNotificationsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $iNuQM.default),
        layout: (0, $7Fzs6.opsSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$23870691096294d3$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $bnFXJ.createContactsResource)(),
            (0, $42KYp.createNotificationPreferencesResource)(),
            (0, $9BoWi.createMuteResource)(),
            (0, $9BoWi.createQuietHoursResource)(),
            (0, $42KYp.createForwardingRulesResource)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $iNuQM.LazyUserNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bnFXJ", function(module, exports) {
$parcel$export(module.exports, "createContactsResource", () => $33adad603c7084ac$export$b9ca444b0be3df97);
$parcel$export(module.exports, "contactsResource", () => $33adad603c7084ac$export$54a06d876c95357d);

var $7edbf = parcelRequire("7edbf");

var $4MB5E = parcelRequire("4MB5E");
const $33adad603c7084ac$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'contactsResource',
        getKey: ()=>'contactsResource',
        getData: async ({ dependencies: dependencies, match: match })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await (0, $4MB5E.getContacts)(match.params?.targetAccountId);
            return data.contacts;
        },
        isBrowserOnly: true,
        depends: depends
    });
const $33adad603c7084ac$export$54a06d876c95357d = $33adad603c7084ac$export$b9ca444b0be3df97();

});
parcelRegister("4MB5E", function(module, exports) {
$parcel$export(module.exports, "getContacts", () => $f888ba9117dd4004$export$70ff9d70e43e8f10);
$parcel$export(module.exports, "addContactEndpoint", () => $f888ba9117dd4004$export$bd596455bda1cd66);
$parcel$export(module.exports, "orderContactEndpoint", () => $f888ba9117dd4004$export$77f16e7683ad08d6);
$parcel$export(module.exports, "updateContactStatusEndpoint", () => $f888ba9117dd4004$export$d50cab05338f8080);
$parcel$export(module.exports, "updateContactVisibleEndpoint", () => $f888ba9117dd4004$export$9c70861fcae2d721);
$parcel$export(module.exports, "setContactPrimaryEndpoint", () => $f888ba9117dd4004$export$2b151c91a5abc2aa);
$parcel$export(module.exports, "deleteContactEndpoint", () => $f888ba9117dd4004$export$59eb3ff38e4cd944);
$parcel$export(module.exports, "editContactEndpoint", () => $f888ba9117dd4004$export$3f8035f77e3aeb9d);
$parcel$export(module.exports, "sendVerificationCodeEndpoint", () => $f888ba9117dd4004$export$74e1bdc56dc32826);
$parcel$export(module.exports, "checkVerificationCodeEndpoint", () => $f888ba9117dd4004$export$fbe80b8d857094de);

var $hG5S4 = parcelRequire("hG5S4");

var $dCwvn = parcelRequire("dCwvn");
const $f888ba9117dd4004$export$70ff9d70e43e8f10 = (targetAccountId)=>(0, $hG5S4.eocFetch)(`/v1/users/contact${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`);
const $f888ba9117dd4004$export$bd596455bda1cd66 = (newAddress, method, targetAccountId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            address: newAddress,
            method: method.toLowerCase()
        }
    });
};
const $f888ba9117dd4004$export$77f16e7683ad08d6 = (contactId, after, targetAccountId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact/order${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            after: after
        }
    });
};
const $f888ba9117dd4004$export$d50cab05338f8080 = (status)=>{
    return status ? $f888ba9117dd4004$var$enableContactEndpoint : $f888ba9117dd4004$var$disableContactEndpoint;
};
const $f888ba9117dd4004$var$enableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact/state/enabled${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f888ba9117dd4004$var$disableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact/state/disabled${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f888ba9117dd4004$export$9c70861fcae2d721 = (visible)=>{
    return visible ? $f888ba9117dd4004$var$setContactVisibleEndpoint : $f888ba9117dd4004$var$setContactHiddenEndpoint;
};
const $f888ba9117dd4004$var$setContactVisibleEndpoint = (contactId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact/state/visible`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f888ba9117dd4004$var$setContactHiddenEndpoint = (contactId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact/state/hidden`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f888ba9117dd4004$export$2b151c91a5abc2aa = (contactId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact/state/primary`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f888ba9117dd4004$export$59eb3ff38e4cd944 = (contactId, targetAccountId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'DELETE',
        body: {
            contactId: contactId
        },
        responseType: 'headers'
    });
};
const $f888ba9117dd4004$export$3f8035f77e3aeb9d = (contactId, newAddress, targetAccountId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            address: newAddress
        }
    });
};
const $f888ba9117dd4004$export$74e1bdc56dc32826 = (phoneNumber, method, targetAccountId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact/verification${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            method: method.toLowerCase()
        }
    });
};
const $f888ba9117dd4004$export$fbe80b8d857094de = (phoneNumber, code, targetAccountId)=>{
    return (0, $hG5S4.eocFetch)(`/v1/users/contact/verification/check${(0, $dCwvn.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            code: code
        },
        responseType: 'headers'
    });
};

});
parcelRegister("dCwvn", function(module, exports) {
$parcel$export(module.exports, "calculateRemainingMinutesAndSeconds", () => $110ed2905d09f365$export$d3f650aeadf07bf8);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $110ed2905d09f365$export$f538d5c43127966b);
const $110ed2905d09f365$export$d3f650aeadf07bf8 = (countDown)=>{
    const minutes = Math.floor(countDown % 3600000 / 60000);
    const seconds = Math.floor(countDown % 60000 / 1000);
    return [
        minutes < 0 ? 0 : minutes,
        seconds < 0 ? 0 : seconds
    ];
};
const $110ed2905d09f365$export$f538d5c43127966b = (targetAccountId)=>{
    return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
};

});



parcelRegister("9BoWi", function(module, exports) {
$parcel$export(module.exports, "createMuteResource", () => $23db96210a87c972$export$c849cfac68bc6e80);
$parcel$export(module.exports, "createQuietHoursResource", () => $23db96210a87c972$export$efc5e8690061f9cc);
$parcel$export(module.exports, "muteResource", () => $23db96210a87c972$export$3c4c16a7c2620c29);
$parcel$export(module.exports, "quietHoursResource", () => $23db96210a87c972$export$9b33012bd34cc225);

var $7edbf = parcelRequire("7edbf");

var $5Xbw4 = parcelRequire("5Xbw4");
const $23db96210a87c972$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'muteResource',
        getKey: ()=>'muteResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $5Xbw4.getMuteDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $23db96210a87c972$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'quietHoursResource',
        getKey: ()=>'quietHoursResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $5Xbw4.getQuietHoursDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $23db96210a87c972$export$3c4c16a7c2620c29 = $23db96210a87c972$export$c849cfac68bc6e80();
const $23db96210a87c972$export$9b33012bd34cc225 = $23db96210a87c972$export$efc5e8690061f9cc();

});
parcelRegister("5Xbw4", function(module, exports) {
$parcel$export(module.exports, "getMuteDetail", () => $db1b19d0ca410cc2$export$80a4e62998a806a6);
$parcel$export(module.exports, "getQuietHoursDetail", () => $db1b19d0ca410cc2$export$44a94c74f358d02f);

var $hG5S4 = parcelRequire("hG5S4");

var $360e0 = parcelRequire("360e0");
const $db1b19d0ca410cc2$export$80a4e62998a806a6 = (targetAccountId)=>(0, $hG5S4.eocFetch)(`/v1/users/notifications/mute${(0, $360e0.getTargetAccountIdSuffix)(targetAccountId)}`);
const $db1b19d0ca410cc2$export$44a94c74f358d02f = (targetAccountId)=>(0, $hG5S4.eocFetch)(`/v1/users/quiet-hours/details${(0, $360e0.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("360e0", function(module, exports) {
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $9663b8d0c04bbfa4$export$f538d5c43127966b);
const $9663b8d0c04bbfa4$export$f538d5c43127966b = (targetAccountId)=>{
    return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
};

});



parcelRegister("42KYp", function(module, exports) {
$parcel$export(module.exports, "createNotificationPreferencesResource", () => $854d4347fced4ae9$export$731980bd233a4797);
$parcel$export(module.exports, "createForwardingRulesResource", () => $854d4347fced4ae9$export$5314dca65b4e5888);

var $7edbf = parcelRequire("7edbf");
parcelRequire("lrLEP");
var $1OYWB = parcelRequire("1OYWB");

var $Rw9Nb = parcelRequire("Rw9Nb");
const $854d4347fced4ae9$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'notificationPreferencesResource',
        getKey: ()=>'notificationPreferencesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $Rw9Nb.getNotificationPreferences)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $854d4347fced4ae9$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'forwardingRulesResource',
        getKey: ()=>'forwardingRulesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $Rw9Nb.getForwardingRules)(targetAccountId).then(({ values: values })=>values);
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("Rw9Nb", function(module, exports) {
$parcel$export(module.exports, "getNotificationPreferences", () => $d1699c9a89fb632f$export$60e139c3026f21bc);
$parcel$export(module.exports, "getForwardingRules", () => $d1699c9a89fb632f$export$2161af98e3d645a5);

var $hG5S4 = parcelRequire("hG5S4");

var $l0hVd = parcelRequire("l0hVd");
const $d1699c9a89fb632f$export$60e139c3026f21bc = (targetAccountId)=>(0, $hG5S4.eocFetch)(`/v1/users/notification-preferences${(0, $l0hVd.getTargetAccountIdSuffix)(targetAccountId)}`);
const $d1699c9a89fb632f$export$2161af98e3d645a5 = (targetAccountId)=>(0, $hG5S4.eocFetch)(`/v1/alerts/notifications/forwarding-rules${(0, $l0hVd.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("l0hVd", function(module, exports) {
$parcel$export(module.exports, "getOperationName", () => $92216aad2e3ac653$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getMatchType", () => $92216aad2e3ac653$export$a8ea0fb63186ef7e);
$parcel$export(module.exports, "formatRestriction", () => $92216aad2e3ac653$export$99bcc87a197977ea);
$parcel$export(module.exports, "getAvailableRuleTypeOptions", () => $92216aad2e3ac653$export$c5259662f509f23f);
$parcel$export(module.exports, "getDefaultTimeOptions", () => $92216aad2e3ac653$export$318d0e67e244d7ff);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $92216aad2e3ac653$export$f538d5c43127966b);

var $8hCqc = parcelRequire("8hCqc");

var $dYbSv = parcelRequire("dYbSv");

var $io1MU = parcelRequire("io1MU");

var $TsgOl = parcelRequire("TsgOl");

var $7neNz = parcelRequire("7neNz");

var $7BmYl = parcelRequire("7BmYl");

var $h3ykY = parcelRequire("h3ykY");
const $92216aad2e3ac653$export$41bca9dc6871dd4e = (id)=>{
    const operation = (0, $7neNz.OPERATIONS).find((operation)=>operation.id === id);
    return operation?.name;
};
const $92216aad2e3ac653$export$a8ea0fb63186ef7e = (conditionMatchType)=>{
    switch(conditionMatchType){
        case 1:
            return 'match-any-condition';
        case 2:
            return 'match-all-conditions';
        default:
            return 'match-all';
    }
};
const $92216aad2e3ac653$export$5f84d4e06c0693c4 = ()=>{
    const firstDOW = (0, $TsgOl.default)(new Date(), {
        weekStartsOn: 0
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $dYbSv.default)((0, $8hCqc.default)(firstDOW, i), 'EEEE'),
            value: i % 7 + 1
        }));
    return weekDays;
};
const $92216aad2e3ac653$export$99bcc87a197977ea = (timeInterval)=>{
    const days = $92216aad2e3ac653$export$5f84d4e06c0693c4();
    const startDay = days.find((day)=>day.value === timeInterval.startDay);
    const endDay = days.find((day)=>day.value === timeInterval.endDay);
    const startTime = (0, $dYbSv.default)((0, $io1MU.default)(new Date(), {
        hours: timeInterval.startHour,
        minutes: timeInterval.startMinute
    }), 'p');
    const endTime = (0, $dYbSv.default)((0, $io1MU.default)(new Date(), {
        hours: timeInterval.endHour,
        minutes: timeInterval.endMinute
    }), 'p');
    if (startDay && endDay) {
        const formattedTime = `${startDay.label} ${startTime} - ${endDay.label} ${endTime}`;
        return formattedTime;
    }
    const formattedTime = `${startTime} - ${endTime}`;
    return formattedTime;
};
const $92216aad2e3ac653$export$c5259662f509f23f = (formatMessage)=>{
    return Object.keys((0, $7BmYl.AVAILABLE_RULE_TYPES)).filter((v)=>isNaN(Number(v))).map((key)=>({
            label: formatMessage((0, $h3ykY.default)[key]),
            value: key
        }));
};
const $92216aad2e3ac653$export$318d0e67e244d7ff = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $92216aad2e3ac653$export$f538d5c43127966b = (targetAccountId)=>{
    return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
};

});
parcelRegister("7neNz", function(module, exports) {
$parcel$export(module.exports, "DATE_FORMAT", () => $881dc1bcb6d7be3c$export$45c85543ba71221d);
$parcel$export(module.exports, "TIME_FORMAT", () => $881dc1bcb6d7be3c$export$c4e1e4e065ff5bd8);
$parcel$export(module.exports, "DATETIME_FORMAT", () => $881dc1bcb6d7be3c$export$ae1dc8cbcf481d8e);
$parcel$export(module.exports, "OPERATIONS", () => $881dc1bcb6d7be3c$export$98ff4de2f070152d);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $881dc1bcb6d7be3c$export$a7c923252528b255);
$parcel$export(module.exports, "defaultTimes", () => $881dc1bcb6d7be3c$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "supportArticles", () => $881dc1bcb6d7be3c$export$f4b848c2437238f9);

var $7BmYl = parcelRequire("7BmYl");
const $881dc1bcb6d7be3c$export$45c85543ba71221d = 'dd/MM/yyyy';
const $881dc1bcb6d7be3c$export$c4e1e4e065ff5bd8 = 'h:mm aaa';
const $881dc1bcb6d7be3c$export$ae1dc8cbcf481d8e = `${$881dc1bcb6d7be3c$export$45c85543ba71221d}; ${$881dc1bcb6d7be3c$export$c4e1e4e065ff5bd8}`;
const $881dc1bcb6d7be3c$export$98ff4de2f070152d = [
    {
        order: 0,
        id: (0, $7BmYl.OperationIds).Matches,
        name: (0, $7BmYl.Operation).Matches
    },
    {
        order: 1,
        id: (0, $7BmYl.OperationIds).Equals,
        name: (0, $7BmYl.Operation).Equals
    },
    {
        order: 2,
        id: (0, $7BmYl.OperationIds).Contains,
        name: (0, $7BmYl.Operation).Contains
    },
    {
        order: 3,
        id: (0, $7BmYl.OperationIds).StartsWith,
        name: (0, $7BmYl.Operation).StartsWith
    },
    {
        order: 4,
        id: (0, $7BmYl.OperationIds).EndsWith,
        name: (0, $7BmYl.Operation).EndsWith
    },
    {
        order: 5,
        id: (0, $7BmYl.OperationIds).ContainsKey,
        name: (0, $7BmYl.Operation).ContainsKey
    },
    {
        order: 6,
        id: (0, $7BmYl.OperationIds).ContainsValue,
        name: (0, $7BmYl.Operation).ContainsValue
    },
    {
        order: 7,
        id: (0, $7BmYl.OperationIds).GreaterThan,
        name: (0, $7BmYl.Operation).GreaterThan
    },
    {
        order: 8,
        id: (0, $7BmYl.OperationIds).LessThan,
        name: (0, $7BmYl.Operation).LessThan
    },
    {
        order: 9,
        id: (0, $7BmYl.OperationIds).IsEmpty,
        name: (0, $7BmYl.Operation).IsEmpty
    },
    {
        order: 10,
        id: (0, $7BmYl.OperationIds).EqualsIgnoreWhitespace,
        name: (0, $7BmYl.Operation).EqualsIgnoreWhitespace
    }
];
const $881dc1bcb6d7be3c$export$a7c923252528b255 = {
    dndTitle: 'eoc-notifications_dnd_title',
    rulesTitle: 'eoc-notifications_rules_title',
    forwardingRulesTitle: 'eoc-notifications_forwarding_rules_title'
};
const $881dc1bcb6d7be3c$export$b42ffb9f09b1861b = [
    ...Array(24).keys()
].map((time)=>{
    let newTime = time.toString();
    if (newTime.length === 1) newTime = `0${time}`;
    return [
        `${newTime}:00`,
        `${newTime}:30`
    ];
}).flatMap((time)=>time);
const $881dc1bcb6d7be3c$export$f4b848c2437238f9 = {
    setUpRoleBasedNotifications: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-role-based-notifications/',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/112066569/Set+up+role-based+notifications/'
    },
    setUpSmsAndVoice: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-sms-and-voice-notifications/#Contact-information',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404235/Set+up+SMS+and+voice+notifications#Contact-information'
    },
    setUpNotificationPreferences: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-notification-preferences',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11469955/Set+up+notification+preferences'
    },
    notificationForwardingRules: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/add-notification-forwarding-rules',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404196/Add+notification+forwarding+rules'
    }
};

});
parcelRegister("7BmYl", function(module, exports) {
$parcel$export(module.exports, "AVAILABLE_RULE_TYPES", () => $e55f8de38ab0bca6$export$a4958d8d5a6aee21);
$parcel$export(module.exports, "OperationIds", () => $e55f8de38ab0bca6$export$9e369e35ea3634d7);
$parcel$export(module.exports, "ReverseOperations", () => $e55f8de38ab0bca6$export$e722854e5571abe4);
$parcel$export(module.exports, "MatchConditionType", () => $e55f8de38ab0bca6$export$dab128282aa7aeee);
$parcel$export(module.exports, "Operation", () => $e55f8de38ab0bca6$export$ab5aad00225c5662);
var $e55f8de38ab0bca6$export$a4958d8d5a6aee21 = /*#__PURE__*/ function(AVAILABLE_RULE_TYPES) {
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["New Alert"] = 0] = "New Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule Start"] = 3] = "Schedule Start";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule End"] = 7] = "Schedule End";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Incoming Call Routing"] = 8] = "Incoming Call Routing";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Acknowledged Alert"] = 1] = "Acknowledged Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Closed Alert"] = 2] = "Closed Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Assigned Alert"] = 5] = "Assigned Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Add Note"] = 6] = "Add Note";
    return AVAILABLE_RULE_TYPES;
}({});
var $e55f8de38ab0bca6$export$9e369e35ea3634d7 = /*#__PURE__*/ function(OperationIds) {
    OperationIds[OperationIds["Matches"] = 0] = "Matches";
    OperationIds[OperationIds["Contains"] = 1] = "Contains";
    OperationIds[OperationIds["StartsWith"] = 3] = "StartsWith";
    OperationIds[OperationIds["EndsWith"] = 4] = "EndsWith";
    OperationIds[OperationIds["Equals"] = 5] = "Equals";
    OperationIds[OperationIds["ContainsKey"] = 6] = "ContainsKey";
    OperationIds[OperationIds["ContainsValue"] = 7] = "ContainsValue";
    OperationIds[OperationIds["GreaterThan"] = 8] = "GreaterThan";
    OperationIds[OperationIds["LessThan"] = 9] = "LessThan";
    OperationIds[OperationIds["IsEmpty"] = 10] = "IsEmpty";
    OperationIds[OperationIds["EqualsIgnoreWhitespace"] = 11] = "EqualsIgnoreWhitespace";
    return OperationIds;
}({});
var $e55f8de38ab0bca6$export$e722854e5571abe4 = /*#__PURE__*/ function(ReverseOperations) {
    ReverseOperations[ReverseOperations["matches"] = 0] = "matches";
    ReverseOperations[ReverseOperations["contains"] = 1] = "contains";
    ReverseOperations[ReverseOperations["starts-with"] = 3] = "starts-with";
    ReverseOperations[ReverseOperations["ends-with"] = 4] = "ends-with";
    ReverseOperations[ReverseOperations["equals"] = 5] = "equals";
    ReverseOperations[ReverseOperations["contains-key"] = 6] = "contains-key";
    ReverseOperations[ReverseOperations["contains-value"] = 7] = "contains-value";
    ReverseOperations[ReverseOperations["greater-than"] = 8] = "greater-than";
    ReverseOperations[ReverseOperations["less-than"] = 9] = "less-than";
    ReverseOperations[ReverseOperations["is-empty"] = 10] = "is-empty";
    ReverseOperations[ReverseOperations["equals-ignore-whitespace"] = 11] = "equals-ignore-whitespace";
    return ReverseOperations;
}({});
var $e55f8de38ab0bca6$export$dab128282aa7aeee = /*#__PURE__*/ function(MatchConditionType) {
    MatchConditionType[MatchConditionType["match-all"] = 0] = "match-all";
    MatchConditionType[MatchConditionType["match-any-condition"] = 1] = "match-any-condition";
    MatchConditionType[MatchConditionType["match-all-conditions"] = 2] = "match-all-conditions";
    return MatchConditionType;
}({});
var $e55f8de38ab0bca6$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["Matches"] = "matches";
    Operation["Contains"] = "contains";
    Operation["StartsWith"] = "starts-with";
    Operation["EndsWith"] = "ends-with";
    Operation["Equals"] = "equals";
    Operation["ContainsKey"] = "contains-key";
    Operation["ContainsValue"] = "contains-value";
    Operation["GreaterThan"] = "greater-than";
    Operation["LessThan"] = "less-than";
    Operation["IsEmpty"] = "is-empty";
    Operation["EqualsIgnoreWhitespace"] = "equals-ignore-whitespace";
    return Operation;
}({});

});


parcelRegister("h3ykY", function(module, exports) {
$parcel$export(module.exports, "default", () => $43b2b4844525b5ea$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $43b2b4844525b5ea$var$messages = (0, $7eNDO.defineMessages)({
    addIconA11y: {
        id: 'eoc.notifications.rules.add-icon-a11y',
        defaultMessage: 'Add rule for {title}',
        description: 'Button label to indicate it is used for adding a new notification rule.'
    },
    'New Alert': {
        id: 'eoc.notifications.ui.notifications.new-alert.no-translate',
        defaultMessage: 'New alert',
        description: 'The title of new alert notifications'
    },
    'Schedule Start': {
        id: 'eoc.notifications.ui.notifications.schedule-start.no-translate',
        defaultMessage: 'Schedule start',
        description: 'The title of schedule start notifications'
    },
    'Schedule End': {
        id: 'eoc.notifications.ui.notifications.schedule-end.no-translate',
        defaultMessage: 'Schedule end',
        description: 'The title of schedule end notifications'
    },
    'Acknowledged Alert': {
        id: 'eoc.notifications.ui.notifications.acknowledged-alert.no-translate',
        defaultMessage: 'Acknowledged alert',
        description: 'The title of acknowledged alert notifications'
    },
    'Closed Alert': {
        id: 'eoc.notifications.ui.notifications.closed-alert.no-translate',
        defaultMessage: 'Closed alert',
        description: 'The title of closed alert notifications'
    },
    'Assigned Alert': {
        id: 'eoc.notifications.ui.notifications.assigned-alert.no-translate',
        defaultMessage: 'Assigned alert',
        description: 'The title of assigned alert notifications'
    },
    'Add Note': {
        id: 'eoc.notifications.ui.notifications.add-note.no-translate',
        defaultMessage: 'Add note',
        description: 'The title of add note notifications'
    },
    'Incoming Call Routing': {
        id: 'eoc.notifications.ui.notifications.incoming-call-routing.no-translate',
        defaultMessage: 'Incoming Call Routing',
        description: 'The title of incoming call rounting notifications'
    },
    addButtonTooltip: {
        id: 'eoc.notifications.common.ui.notification-section.add-button-tooltip.non-final',
        defaultMessage: "A role-based notification is in effect, so adding more rules isn\u2019t possible.",
        description: 'The message to be shown when user tries to add a rule but there is a role-based notification'
    }
});
var $43b2b4844525b5ea$export$2e2bcd8739ae039 = $43b2b4844525b5ea$var$messages;

});




parcelRegister("dtTsR", function(module, exports) {
$parcel$export(module.exports, "eocUserNotificationsRoute", () => $d2b5678a5457b80c$export$f7a15352c90f8063);
const $d2b5678a5457b80c$export$f7a15352c90f8063 = {
    name: 'eoc-user-notifications',
    path: '/jira/settings/products/ops/role-assignment/notifications/:targetAccountId',
    exact: true
};

});

parcelRegister("iNuQM", function(module, exports) {
$parcel$export(module.exports, "LazyUserNotifications", () => $a65f3ae5b4fee7c0$export$a510b3cfe09fad0d);
$parcel$export(module.exports, "default", () => $a65f3ae5b4fee7c0$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable jira/deprecations/no-rll-client-async-experiences */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $a65f3ae5b4fee7c0$export$a510b3cfe09fad0d = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("awZcQ")), {
    ssr: false,
    moduleId: "./src/packages/eoc/user-notifications/src/index.tsx"
});
const $a65f3ae5b4fee7c0$var$LazyUserNotificationsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $a65f3ae5b4fee7c0$export$a510b3cfe09fad0d,
        pageId: "async-eoc-user-notifications",
        shouldShowSpinner: false
    });
$a65f3ae5b4fee7c0$var$LazyUserNotificationsPage.displayName = "LazyUserNotificationsPage";
var $a65f3ae5b4fee7c0$export$2e2bcd8739ae039 = $a65f3ae5b4fee7c0$var$LazyUserNotificationsPage;

});
parcelRegister("awZcQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("51Jo1")
]).then(()=>parcelRequire('fL397'));

});



parcelRegister("9vtbm", function(module, exports) {
$parcel$export(module.exports, "errorsGenericNotFoundRouteEntry", () => $9043398068e5a5d4$export$41ed9f16516fc0a1);

var $lFLfF = parcelRequire("lFLfF");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $9ZO2m = parcelRequire("9ZO2m");
const $9043398068e5a5d4$export$41ed9f16516fc0a1 = (0, $fdS54.createEntry)((0, $9ZO2m.errorsGenericNotFoundRoute), ()=>({
        group: 'errors',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lFLfF.LazyNotFoundErrorPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9ZO2m", function(module, exports) {
$parcel$export(module.exports, "errorsGenericNotFoundRoute", () => $36dacdf10e254cb5$export$f73617a58825759c);
const $36dacdf10e254cb5$export$f73617a58825759c = {
    name: 'errors-generic-not-found',
    path: '/jira/:invalidPath'
};

});


parcelRegister("1ctLf", function(module, exports) {
$parcel$export(module.exports, "errorsNotFoundRouteEntry", () => $e1ff40340386b330$export$c4c012a49b465e94);

var $lFLfF = parcelRequire("lFLfF");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $5Dbox = parcelRequire("5Dbox");
const $e1ff40340386b330$export$c4c012a49b465e94 = (0, $fdS54.createEntry)((0, $5Dbox.errorsNotFoundRoute), ()=>({
        group: 'errors',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lFLfF.LazyNotFoundErrorPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5Dbox", function(module, exports) {
$parcel$export(module.exports, "errorsNotFoundRoute", () => $2dd0af6836885137$export$465fa01c0f3a0551);
const $2dd0af6836885137$export$465fa01c0f3a0551 = {
    name: 'errors-not-found',
    path: '/jira/:projectType(software|servicedesk|core)'
};

});


parcelRegister("ex4qh", function(module, exports) {
$parcel$export(module.exports, "externalImportRouteEntry", () => $027a18369e0118ce$export$d55ce647d8216437);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $aD6BH = parcelRequire("aD6BH");

var $35eqr = parcelRequire("35eqr");

var $eMyPc = parcelRequire("eMyPc");
const $027a18369e0118ce$export$d55ce647d8216437 = (0, $fdS54.createEntry)((0, $aD6BH.externalImportRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eMyPc.default),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aD6BH", function(module, exports) {
$parcel$export(module.exports, "externalImportRoute", () => $b3fc5ee002da3f52$export$17c79100fc4c65a1);
const $b3fc5ee002da3f52$export$17c79100fc4c65a1 = {
    name: 'external-import',
    path: '/jira/settings/system/external-import'
};

});

parcelRegister("eMyPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4f1f1e0c436ec4$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1c4f1f1e0c436ec4$var$LazyExternalImport = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("f4DTV")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/admin-pages-external-import/src/ExternalImport.tsx"
});
const $1c4f1f1e0c436ec4$var$AsyncExternalImport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1c4f1f1e0c436ec4$var$LazyExternalImport,
        pageId: "external-import-general",
        shouldShowSpinner: false
    });
$1c4f1f1e0c436ec4$var$AsyncExternalImport.displayName = "AsyncExternalImport";
var $1c4f1f1e0c436ec4$export$2e2bcd8739ae039 = $1c4f1f1e0c436ec4$var$AsyncExternalImport;

});
parcelRegister("f4DTV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("gCScl"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("3dFBa")
]).then(()=>parcelRequire('LwwYq'));

});



parcelRegister("gueFU", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRedirectRouteEntry", () => $c0fdeb65641a9743$export$41fb3f2a3e68c7c3);
/* eslint-disable import/order */ 

var $b59DA = parcelRequire("b59DA");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $3LAHD = parcelRequire("3LAHD");

var $85jAF = parcelRequire("85jAF");

var $lSyrn = parcelRequire("lSyrn");
const $c0fdeb65641a9743$export$41fb3f2a3e68c7c3 = (0, $fdS54.createEntry)((0, $3LAHD.filtersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $b59DA.filtersDirectoryResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: !false ? (0, $lSyrn.FiltersDirectoryRedirect) : (0, $lSyrn.FiltersDirectoryComponent),
        skeleton: (0, $85jAF.FiltersDirectorySkeleton),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lSyrn.LazyFiltersDirectory)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $bf8b595cdc630add$export$8b2ce873c5336522 = 'FILTERS';

parcelRegister("b59DA", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryResource", () => $4427f91fb706f33c$export$53f99086c62225b6);

var $7edbf = parcelRequire("7edbf");
const $4427f91fb706f33c$var$MIN_MAX_AGE = 5000;
const $4427f91fb706f33c$var$RESOURCE_TYPE_FILTERS_DIRECTORY = 'FILTERS_DIRECTORY';

const $4427f91fb706f33c$export$53f99086c62225b6 = (0, $7edbf.createResource)({
    type: $4427f91fb706f33c$var$RESOURCE_TYPE_FILTERS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("kqo8X")),
    maxAge: $4427f91fb706f33c$var$MIN_MAX_AGE
});

});
parcelRegister("kqo8X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bDUKk").then(()=>parcelRequire('9MRUe'));

});


parcelRegister("3LAHD", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $dc6ced81f0e87a7a$export$f4f86e1ddc30a625);
const $dc6ced81f0e87a7a$export$f4f86e1ddc30a625 = {
    name: 'filters-directory-redirect',
    path: '/ManageFilters.jspa'
};

});

parcelRegister("lSyrn", function(module, exports) {
$parcel$export(module.exports, "FiltersDirectoryRedirect", () => $3229fae130a87e8e$export$c56e739d3bb1fe19);
$parcel$export(module.exports, "LazyFiltersDirectory", () => $3229fae130a87e8e$export$cc133cd5c6f1b69d);
$parcel$export(module.exports, "FiltersDirectoryComponent", () => $3229fae130a87e8e$export$e5d735e83dacb7c7);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");
const $3229fae130a87e8e$export$c56e739d3bb1fe19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/filters"
    });
$3229fae130a87e8e$export$c56e739d3bb1fe19.displayName = "FiltersDirectoryRedirect";

const $3229fae130a87e8e$export$cc133cd5c6f1b69d = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("ki23b"))), {
    moduleId: "./src/packages/spa-apps/directories-filters/src/FiltersDirectoryType.tsx"
});
const $3229fae130a87e8e$export$e5d735e83dacb7c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3229fae130a87e8e$export$cc133cd5c6f1b69d,
        pageId: "filters-directory",
        shouldShowSpinner: false
    });
$3229fae130a87e8e$export$e5d735e83dacb7c7.displayName = "FiltersDirectoryComponent";

});
parcelRegister("ki23b", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("jSG6q")
]).then(()=>parcelRequire('jvn1y'));

});



parcelRegister("dQVsZ", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRouteEntry", () => $a1eba77e877f4154$export$ca77bc660994f51f);
/* eslint-disable import/order */ 

var $b59DA = parcelRequire("b59DA");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $7AmPM = parcelRequire("7AmPM");

var $85jAF = parcelRequire("85jAF");

var $lSyrn = parcelRequire("lSyrn");
const $a1eba77e877f4154$export$ca77bc660994f51f = (0, $fdS54.createEntry)((0, $7AmPM.filtersDirectoryRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $b59DA.filtersDirectoryResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lSyrn.FiltersDirectoryComponent),
        skeleton: (0, $85jAF.FiltersDirectorySkeleton),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lSyrn.LazyFiltersDirectory)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7AmPM", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRoute", () => $cded721d6d923091$export$6350f52c8b40042d);
const $cded721d6d923091$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});


parcelRegister("6JUWC", function(module, exports) {
$parcel$export(module.exports, "findAppsRouteEntry", () => $9974f3a520c98f42$export$422f564c9c56a4f8);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $i6aZK = parcelRequire("i6aZK");

var $khI8v = parcelRequire("khI8v");
const $9974f3a520c98f42$export$422f564c9c56a4f8 = (0, $fdS54.createEntry)((0, $i6aZK.findAppsRoute), ()=>({
        group: 'marketplace',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $khI8v.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $khI8v.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("i6aZK", function(module, exports) {
$parcel$export(module.exports, "findAppsRoute", () => $133d7588e88e971e$export$e264ef643451c60a);
const $133d7588e88e971e$export$e264ef643451c60a = {
    name: 'marketplace-index',
    path: '/jira/marketplace'
};

});


parcelRegister("bPj2c", function(module, exports) {
$parcel$export(module.exports, "forgeAdminRouteEntry", () => $29230bc484881027$export$9e57f00c65d37e11);



var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $9L22N = parcelRequire("9L22N");

var $1Wkij = parcelRequire("1Wkij");
const $29230bc484881027$export$9e57f00c65d37e11 = (0, $fdS54.createEntry)((0, $9L22N.forgeAdminRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1Wkij.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1Wkij.LazyForgeAdminPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9L22N", function(module, exports) {
$parcel$export(module.exports, "forgeAdminRoute", () => $dce0202af2eff755$export$157f97e6454c2a9f);
const $dce0202af2eff755$export$157f97e6454c2a9f = {
    name: 'forge-spa-admin',
    path: '/jira/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("1Wkij", function(module, exports) {
$parcel$export(module.exports, "LazyForgeAdminPage", () => $b18e0e876b7ad66b$export$66ee65dcd4a6458d);
$parcel$export(module.exports, "default", () => $b18e0e876b7ad66b$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $b18e0e876b7ad66b$export$66ee65dcd4a6458d = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("3a69l")), {
    moduleId: "./src/packages/spa-apps/forge-admin/src/ForgeAdminPageShellWithAnalytics.tsx"
});
const $b18e0e876b7ad66b$export$c9e5f500ef472147 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $b18e0e876b7ad66b$export$66ee65dcd4a6458d,
        pageId: "forge-spa-admin",
        shouldShowSpinner: true
    });
$b18e0e876b7ad66b$export$c9e5f500ef472147.displayName = "ForgeAdminPage";
var $b18e0e876b7ad66b$export$2e2bcd8739ae039 = $b18e0e876b7ad66b$export$c9e5f500ef472147;

});
parcelRegister("3a69l", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jv39t").then(()=>parcelRequire('l2AYs'));

});



parcelRegister("lX8j4", function(module, exports) {
$parcel$export(module.exports, "forgeAdminSettingsRouteEntry", () => $f5a57e45e5076b5c$export$ea8439aa1b4afbb2);



var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $i925B = parcelRequire("i925B");

var $1Wkij = parcelRequire("1Wkij");
const $f5a57e45e5076b5c$export$ea8439aa1b4afbb2 = (0, $fdS54.createEntry)((0, $i925B.forgeAdminSettingsRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1Wkij.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1Wkij.LazyForgeAdminPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("i925B", function(module, exports) {
$parcel$export(module.exports, "forgeAdminSettingsRoute", () => $889476645703a807$export$392534a80a0b9b11);
const $889476645703a807$export$392534a80a0b9b11 = {
    name: 'forge-spa-admin-settings',
    path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
};

});


parcelRegister("7IvSo", function(module, exports) {
$parcel$export(module.exports, "forgeFieldContextualConfigurationRouteEntry", () => $4cd2f219ca8b6c77$export$425186ecf36e93c);



var $86HZG = parcelRequire("86HZG");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $bW4EG = parcelRequire("bW4EG");

var $i61Mp = parcelRequire("i61Mp");
const $4cd2f219ca8b6c77$export$425186ecf36e93c = (0, $fdS54.createEntry)((0, $bW4EG.forgeFieldContextualConfigurationRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i61Mp.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hFYSn.forgeCustomFieldTypeResource),
            (0, $86HZG.fieldContextConfigPageResource),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $i61Mp.LazyForgeFieldContextConfigPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $bffa4babd84e5355$export$f298f3c8b46adbeb = 'GLOBAL_ISSUES_SETTINGS';

parcelRegister("86HZG", function(module, exports) {
$parcel$export(module.exports, "fieldContextConfigPageResource", () => $52493de475a55f37$export$686a607053a18611);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $52493de475a55f37$var$RESOURCE_TYPE_FORGE_FIELD_CONTEXTUAL_CONFIG = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

const $52493de475a55f37$export$686a607053a18611 = (0, $7edbf.createResource)({
    type: $52493de475a55f37$var$RESOURCE_TYPE_FORGE_FIELD_CONTEXTUAL_CONFIG,
    getKey: ()=>'data',
    getDataLoader: ()=>(parcelRequire("h6I7o")),
    maxAge: 5000
});

});
parcelRegister("h6I7o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jAAdU").then(()=>parcelRequire('kDMle'));

});


parcelRegister("bW4EG", function(module, exports) {
$parcel$export(module.exports, "forgeFieldContextualConfigurationRoute", () => $e12b4be761b71330$export$2ee4468dd8e9636f);
const $e12b4be761b71330$export$2ee4468dd8e9636f = {
    name: 'forge-spa-field-context-config',
    path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
};

});

parcelRegister("i61Mp", function(module, exports) {
$parcel$export(module.exports, "LazyForgeFieldContextConfigPage", () => $021db6d81b696b3f$export$c53e206c7fd6fb76);
$parcel$export(module.exports, "default", () => $021db6d81b696b3f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $021db6d81b696b3f$export$c53e206c7fd6fb76 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9AnOi")), {
    moduleId: "./src/packages/spa-apps/forge-field-contextual-config/src/ForgeFieldContextConfigPageShellWithAnalytics.tsx"
});
const $021db6d81b696b3f$export$50bd0baee0b2f946 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $021db6d81b696b3f$export$c53e206c7fd6fb76,
        pageId: "forge-spa-field-context-config",
        shouldShowSpinner: true
    });
$021db6d81b696b3f$export$50bd0baee0b2f946.displayName = "ForgeFieldContextConfigPage";
var $021db6d81b696b3f$export$2e2bcd8739ae039 = $021db6d81b696b3f$export$50bd0baee0b2f946;

});
parcelRegister("9AnOi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("72haB").then(()=>parcelRequire('eFTaH'));

});



parcelRegister("bs4Dp", function(module, exports) {
$parcel$export(module.exports, "forgeGlobalRouteEntry", () => $a90369c015cd37cd$export$68b00eede5bc25e6);


var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $eG3bR = parcelRequire("eG3bR");

var $5aaNu = parcelRequire("5aaNu");
const $a90369c015cd37cd$export$68b00eede5bc25e6 = (0, $fdS54.createEntry)((0, $eG3bR.forgeGlobalRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5aaNu.default),
        layout: (0, $QhQu4.createLayout)(),
        navigation: {
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $hFYSn.getNavigationForgeGlobalPageResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5aaNu.LazyForgeGlobalPage)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eG3bR", function(module, exports) {
$parcel$export(module.exports, "forgeGlobalRoute", () => $e4dc2cb7e35434c5$export$4146dba061d1c72d);
const $e4dc2cb7e35434c5$export$4146dba061d1c72d = {
    name: 'forge-spa-global',
    path: '/jira/apps/:appId/:envId/:route?'
};

});

parcelRegister("5aaNu", function(module, exports) {
$parcel$export(module.exports, "LazyForgeGlobalPage", () => $0088f7ed31db35a5$export$332293feb5cffd72);
$parcel$export(module.exports, "default", () => $0088f7ed31db35a5$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0088f7ed31db35a5$export$332293feb5cffd72 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1ZLlU")), {
    moduleId: "./src/packages/spa-apps/forge-global/src/ForgeGlobalPageShellWithAnalytics.tsx"
});
const $0088f7ed31db35a5$export$4c36a7b018e5e5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0088f7ed31db35a5$export$332293feb5cffd72,
        pageId: "forge-spa-global",
        shouldShowSpinner: true
    });
$0088f7ed31db35a5$export$4c36a7b018e5e5cc.displayName = "ForgeGlobalPage";
var $0088f7ed31db35a5$export$2e2bcd8739ae039 = $0088f7ed31db35a5$export$4c36a7b018e5e5cc;

});
parcelRegister("1ZLlU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("844iV").then(()=>parcelRequire('28hEX'));

});



parcelRegister("cjarc", function(module, exports) {
$parcel$export(module.exports, "forgePersonalSettingsRouteEntry", () => $9a73448fde0b46d6$export$bcf4a0e471a2493d);



var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $apTja = parcelRequire("apTja");

var $juQwt = parcelRequire("juQwt");
const $9a73448fde0b46d6$export$bcf4a0e471a2493d = (0, $fdS54.createEntry)((0, $apTja.forgePersonalSettingsRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $juQwt.default),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            sidebarId: (0, $f5c10d229cf55438$export$8f20a381b96458f0),
            menuId: (0, $a3b30e449fa4e063$export$75c8a2cf8cfeef9c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $hFYSn.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $juQwt.LazyForgePersonalSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("apTja", function(module, exports) {
$parcel$export(module.exports, "forgePersonalSettingsRoute", () => $b1256302ff4268ed$export$8cf022892f01dc88);
const $b1256302ff4268ed$export$8cf022892f01dc88 = {
    name: 'forge-spa-personal-settings',
    path: '/jira/settings/personal/apps/:appId/:envId/:route?'
};

});

parcelRegister("juQwt", function(module, exports) {
$parcel$export(module.exports, "LazyForgePersonalSettingsPage", () => $1489373121977414$export$984c6340ff981792);
$parcel$export(module.exports, "default", () => $1489373121977414$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1489373121977414$export$984c6340ff981792 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("5vMYy")), {
    moduleId: "./src/packages/spa-apps/forge-personal-settings/src/ForgePersonalSettingsPageShell.tsx"
});
const $1489373121977414$export$fb659fde7fa91075 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1489373121977414$export$984c6340ff981792,
        pageId: "forge-spa-personal-settings",
        shouldShowSpinner: true
    });
$1489373121977414$export$fb659fde7fa91075.displayName = "ForgePersonalSettingsPage";
var $1489373121977414$export$2e2bcd8739ae039 = $1489373121977414$export$fb659fde7fa91075;

});
parcelRegister("5vMYy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7H8IP").then(()=>parcelRequire('8aV4j'));

});



parcelRegister("eoMSY", function(module, exports) {
$parcel$export(module.exports, "forgeProjectRouteEntry", () => $5496714a41b1456d$export$1ed77617605af86d);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $hWEkS = parcelRequire("hWEkS");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $iMIWM = parcelRequire("iMIWM");

var $3LMw9 = parcelRequire("3LMw9");
const $5496714a41b1456d$export$1ed77617605af86d = (0, $fdS54.createEntry)((0, $iMIWM.forgeProjectRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            ...(0, $lbxXL.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hFYSn.forgeProjectModuleResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResourceWithCache),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $3LMw9.forgeProjectPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iMIWM", function(module, exports) {
$parcel$export(module.exports, "forgeProjectRoute", () => $481c49be258bc894$export$998d01fc8f4c3224);
const $481c49be258bc894$export$998d01fc8f4c3224 = {
    name: 'forge-spa-project',
    path: '/jira/:projectType(software|software/c|core)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("3LMw9", function(module, exports) {
$parcel$export(module.exports, "forgeProjectPageEntrypoint", () => $b61498c1c4ceab0f$export$74e6ff15060a7efe);
/* eslint-disable jira/naming/disallow-filenames */ 
var $9AowY = parcelRequire("9AowY");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $b61498c1c4ceab0f$export$74e6ff15060a7efe = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9AowY.forgeProjectEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("9AowY", function(module, exports) {
$parcel$export(module.exports, "forgeProjectEntrypoint", () => $f05ba8c99992a04e$export$109bb60f5ed960e9);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $f05ba8c99992a04e$export$109bb60f5ed960e9 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7WEhL")), {
        moduleId: "052ec4b6",
        moduleName: "ForgeProjectPageShellWithAnalyticsMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                match: context.match
            }
        })
});

});
parcelRegister("7WEhL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3oLdY").then(()=>parcelRequire('bmiR5'));

});




parcelRegister("ewhVC", function(module, exports) {
$parcel$export(module.exports, "forgeProjectServicedeskRouteEntry", () => $205a736467003f9f$export$6732bea56e68d0b4);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $hWEkS = parcelRequire("hWEkS");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $1cb6M = parcelRequire("1cb6M");

var $kZZX2 = parcelRequire("kZZX2");
const $205a736467003f9f$export$6732bea56e68d0b4 = (0, $fdS54.createEntry)((0, $1cb6M.forgeProjectServicedeskRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hFYSn.forgeProjectModuleResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResourceWithCache),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $kZZX2.forgeProjectServicedeskPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1cb6M", function(module, exports) {
$parcel$export(module.exports, "forgeProjectServicedeskRoute", () => $002934dab21d0893$export$8b83928f9f21e11);
const $002934dab21d0893$export$8b83928f9f21e11 = {
    name: 'forge-spa-project-servicedesk',
    path: '/jira/:projectType(servicedesk)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("kZZX2", function(module, exports) {
$parcel$export(module.exports, "forgeProjectServicedeskPageEntrypoint", () => $e4ce86fb35bca60a$export$eae71fd9c3e0166a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $9AowY = parcelRequire("9AowY");

var $dTa0V = parcelRequire("dTa0V");
const $e4ce86fb35bca60a$export$eae71fd9c3e0166a = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9AowY.forgeProjectEntrypoint)
});

});


parcelRegister("ezBBh", function(module, exports) {
$parcel$export(module.exports, "forgeServicedeskQueueRouteEntry", () => $31e45ab8b703f1bf$export$1486fc4f85c1237);


var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $fLtIt = parcelRequire("fLtIt");

var $74h93 = parcelRequire("74h93");

var $cSnLo = parcelRequire("cSnLo");
const $31e45ab8b703f1bf$export$1486fc4f85c1237 = (0, $fdS54.createEntry)((0, $fLtIt.forgeServicedeskQueueRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $cSnLo.forgeServiceDeskQueuePageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fLtIt", function(module, exports) {
$parcel$export(module.exports, "forgeServicedeskQueueRoute", () => $d6850af070ab7752$export$b77275b989ab42a6);
const $d6850af070ab7752$export$b77275b989ab42a6 = {
    name: 'forge-spa-servicedesk-queue',
    path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
};

});

parcelRegister("cSnLo", function(module, exports) {
$parcel$export(module.exports, "forgeServiceDeskQueuePageEntrypoint", () => $5746d4c77a87bddb$export$e50db2ee9d53508e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $7tIzA = parcelRequire("7tIzA");

var $dTa0V = parcelRequire("dTa0V");
const $5746d4c77a87bddb$export$e50db2ee9d53508e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7tIzA.forgeServiceDeskEntrypoint)
});

});
parcelRegister("7tIzA", function(module, exports) {
$parcel$export(module.exports, "forgeServiceDeskEntrypoint", () => $d591f1193d03dae6$export$5f56161124a4cb21);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $d591f1193d03dae6$export$5f56161124a4cb21 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7ykxy")), {
        moduleId: "c5e480c9",
        moduleName: "ForgeServiceDeskQueuePageShellWithAnalyticsMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7ykxy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Lyah").then(()=>parcelRequire('duIHB'));

});




parcelRegister("3omKb", function(module, exports) {
$parcel$export(module.exports, "generalPersonalSettingsRouteEntry", () => $3d90788bf473bc29$export$e8b7e9281fc3db35);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $lCnEX = parcelRequire("lCnEX");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $kJe84 = parcelRequire("kJe84");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3d90788bf473bc29$var$LazyGeneralPersonalSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("gSiL8"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings-general/src/ExportedDefault.tsx"
});
const $3d90788bf473bc29$var$GeneralPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3d90788bf473bc29$var$LazyGeneralPersonalSettings,
        pageId: "personal-settings-general",
        shouldShowSpinner: true
    });
$3d90788bf473bc29$var$GeneralPersonalSettingsComponent.displayName = "GeneralPersonalSettingsComponent";
const $3d90788bf473bc29$export$e8b7e9281fc3db35 = (0, $fdS54.createEntry)((0, $lCnEX.generalPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: $3d90788bf473bc29$var$GeneralPersonalSettingsComponent,
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            sidebarId: (0, $f5c10d229cf55438$export$8f20a381b96458f0),
            menuId: (0, $a3b30e449fa4e063$export$75c8a2cf8cfeef9c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $kJe84.getLabsResources)(),
            ...(0, $hFYSn.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $3d90788bf473bc29$var$LazyGeneralPersonalSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lCnEX", function(module, exports) {
$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $63dd5e47469842ff$export$7a6c9715a86f906b);
const $63dd5e47469842ff$export$7a6c9715a86f906b = {
    name: 'personal-settings-general',
    path: '/jira/settings/personal/general'
};

});

parcelRegister("kJe84", function(module, exports) {
$parcel$export(module.exports, "getLabsResources", () => $0c010177d61ca5e4$export$18345571aa12a367);
/* eslint-disable import/order */ // eslint-disable-next-line jira/restricted/fedramp-isolated-cloud

var $l1vE2 = parcelRequire("l1vE2");

var $41FAq = parcelRequire("41FAq");

var $i860n = parcelRequire("i860n");

var $iEE0R = parcelRequire("iEE0R");

var $8HUuJ = parcelRequire("8HUuJ");
const $0c010177d61ca5e4$export$18345571aa12a367 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('aem_rr_personal_settings') ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-next-best-task') : !(0, $l1vE2.isFedRamp)(), (0, $iEE0R.nextBestTaskFeatureResource))
    ];

});

parcelRegister("gSiL8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("U5K7m").then(()=>parcelRequire('iEeit'));

});


parcelRegister("fSv9U", function(module, exports) {
$parcel$export(module.exports, "globalEscalationsRouteEntry", () => $fe29130394a45414$export$adde4536d8e5f94c);

var $euxye = parcelRequire("euxye");



var $6RSCO = parcelRequire("6RSCO");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $jNCQB = parcelRequire("jNCQB");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $dfE34 = parcelRequire("dfE34");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $bkrFd = parcelRequire("bkrFd");

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $fe29130394a45414$var$LazyGlobalEscalations = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("l9Ieg")).then((module)=>module.GlobalEscalationsPage), {
    moduleId: "./src/packages/eoc/global-escalations/src/index.tsx"
});
const $fe29130394a45414$var$GlobalEscalationsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $fe29130394a45414$var$LazyGlobalEscalations,
        pageId: "async-jira-eoc-global-escalations",
        shouldShowSpinner: false
    });
$fe29130394a45414$var$GlobalEscalationsComponent.displayName = "GlobalEscalationsComponent";
const $fe29130394a45414$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $fe29130394a45414$export$adde4536d8e5f94c = (0, $fdS54.createEntry)((0, $dfE34.globalEscalationsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: $fe29130394a45414$var$GlobalEscalationsComponent,
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $jNCQB.globalEscalationsListInfoResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$fe29130394a45414$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            $fe29130394a45414$var$LazyGlobalEscalations
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jNCQB", function(module, exports) {
$parcel$export(module.exports, "globalEscalationsListInfoResource", () => $86b46b9883f95d29$export$bffddc002dadaf3a);

var $7edbf = parcelRequire("7edbf");

var $eo575 = parcelRequire("eo575");
const $86b46b9883f95d29$export$bffddc002dadaf3a = (0, $7edbf.createResource)({
    type: 'globalEscalationsListInfoResource',
    getKey: ()=>'globalEscalationsListInfoResource',
    getData: (0, $eo575.getListInfo),
    isBrowserOnly: true
});

});
parcelRegister("eo575", function(module, exports) {
$parcel$export(module.exports, "getEscalations", () => $a054ee4ff36aeaa5$export$300727380b60aeb4);
$parcel$export(module.exports, "getListInfo", () => $a054ee4ff36aeaa5$export$bdc8fe7d9cd263b);

var $hG5S4 = parcelRequire("hG5S4");
const $a054ee4ff36aeaa5$export$300727380b60aeb4 = ({ lastEvaluatedToken: lastEvaluatedToken, queryKey: queryKey })=>{
    const [, filtersString] = queryKey;
    const filters = JSON.parse(filtersString);
    const params = new URLSearchParams({
        ...filters,
        lastEvaluatedToken: lastEvaluatedToken
    });
    return (0, $hG5S4.eocFetch)(`/v1/escalations/search?${params.toString()}`);
};
const $a054ee4ff36aeaa5$export$bdc8fe7d9cd263b = ()=>{
    return (0, $hG5S4.eocFetch)('/v1/escalations/list-info');
};

});


parcelRegister("dfE34", function(module, exports) {
$parcel$export(module.exports, "globalEscalationsRoute", () => $100fe0725a6e28b7$export$9ed12f6fa845edfb);
const $100fe0725a6e28b7$export$9ed12f6fa845edfb = {
    name: 'eoc-global-escalations',
    path: '/jira/settings/products/ops/escalation-policies',
    exact: true
};

});

parcelRegister("l9Ieg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d1biv").then(()=>parcelRequire('b3kBK'));

});


parcelRegister("g3ZQl", function(module, exports) {
$parcel$export(module.exports, "globalIncomingCallDetailRouteEntry", () => $c37e69afa37e6186$export$39f40714591c98c0);

var $euxye = parcelRequire("euxye");



var $dUAVJ = parcelRequire("dUAVJ");

var $iP7KH = parcelRequire("iP7KH");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $2izvT = parcelRequire("2izvT");

var $8bf4L = parcelRequire("8bf4L");

var $6hCGb = parcelRequire("6hCGb");
const $c37e69afa37e6186$var$IncomingCallDetail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $6hCGb.LazyIncomingCallDetail),
        pageId: "async-jira-eoc-incoming-call-detail",
        shouldShowSpinner: false
    });
$c37e69afa37e6186$var$IncomingCallDetail.displayName = "IncomingCallDetail";
const $c37e69afa37e6186$export$39f40714591c98c0 = (0, $fdS54.createEntry)((0, $2izvT.globalIncomingCallDetailRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: $c37e69afa37e6186$var$IncomingCallDetail,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $iP7KH.detailResources)()
        ],
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6hCGb.LazyIncomingCall)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iP7KH", function(module, exports) {
$parcel$export(module.exports, "listResources", () => $7ede9cca075ef151$export$c83d9fd41123ab31);
$parcel$export(module.exports, "detailResources", () => $7ede9cca075ef151$export$63630293105c0f4e);

var $j1pgS = parcelRequire("j1pgS");

var $fMvCT = parcelRequire("fMvCT");
const $7ede9cca075ef151$export$c83d9fd41123ab31 = ()=>[
        (0, $fMvCT.listResource)
    ];
const $7ede9cca075ef151$export$63630293105c0f4e = ()=>[
        (0, $j1pgS.detailResource)
    ];

});
parcelRegister("j1pgS", function(module, exports) {
$parcel$export(module.exports, "detailResource", () => $e3e42799a6c1ef46$export$13d78d45f8054f1e);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $dDe7z = parcelRequire("dDe7z");
const $e3e42799a6c1ef46$export$13d78d45f8054f1e = (0, $7edbf.createResource)({
    type: 'getDetailResource',
    getKey: ()=>'getDetailResource',
    getData: async (routerContext)=>{
        const id = routerContext.match.params?.id;
        (0, $7Ljuo.assert)(!!id, new (0, $jpT5w.AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
        return (0, $dDe7z.getDetail)(id);
    },
    isBrowserOnly: true
});

});
parcelRegister("dDe7z", function(module, exports) {
$parcel$export(module.exports, "getDetail", () => $c7428d340660da73$export$d6c3faeb2ce9d297);

var $hG5S4 = parcelRequire("hG5S4");

var $h0JEJ = parcelRequire("h0JEJ");
const $c7428d340660da73$export$d6c3faeb2ce9d297 = (id)=>{
    const endpoint = `${(0, $h0JEJ.urls).incomingCall.detail.url(id)}`;
    return (0, $hG5S4.eocFetch)(endpoint);
};

});
parcelRegister("h0JEJ", function(module, exports) {
$parcel$export(module.exports, "urls", () => $354bb17aa30d5a46$export$bcae9ba627f604b6);
const $354bb17aa30d5a46$export$bcae9ba627f604b6 = Object.freeze({
    incomingCall: {
        url: ()=>`/v1/incoming-call`,
        detail: {
            url: (incomingCallId = ':incomingCallId')=>`${$354bb17aa30d5a46$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
        }
    }
});

});



parcelRegister("fMvCT", function(module, exports) {
$parcel$export(module.exports, "listResource", () => $ee0f49bcbaf684b1$export$5ee018e9baf9d633);

var $efCHx = parcelRequire("efCHx");

var $82DGz = parcelRequire("82DGz");
const $ee0f49bcbaf684b1$export$5ee018e9baf9d633 = (0, $efCHx.createPaginatedResource)({
    type: 'getListResource',
    getKey: ()=>'getListResource',
    getData: ()=>(0, $82DGz.getList),
    isBrowserOnly: true
});

});
parcelRegister("efCHx", function(module, exports) {
$parcel$export(module.exports, "createPaginatedResource", () => $721f46bbb4c51944$export$561b032e4d26d1e8);

var $7edbf = parcelRequire("7edbf");
const $721f46bbb4c51944$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
    return (0, $7edbf.createResource)({
        ...arg,
        getKey: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = query['page'] || '1';
            const key = `${getKey(routerContext, customContext)}#${page}`;
            return key;
        },
        getData: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = parseInt(query['page']) || 1;
            return getData(routerContext, customContext)({
                page: page
            });
        }
    });
};

});

parcelRegister("82DGz", function(module, exports) {
$parcel$export(module.exports, "getList", () => $db88c013da09485e$export$73fffd6dda5144e);
$parcel$export(module.exports, "addIncomingCall", () => $db88c013da09485e$export$cdae09ff00c893b2);

var $hG5S4 = parcelRequire("hG5S4");

var $h0JEJ = parcelRequire("h0JEJ");
const $db88c013da09485e$export$73fffd6dda5144e = ({ page: page })=>{
    const limit = 20;
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({
        offset: `${offset}`,
        limit: `${limit}`,
        sortBy: 'name',
        sort: 'asc'
    });
    const endpoint = `${(0, $h0JEJ.urls).incomingCall.url()}?${params.toString()}`;
    return (0, $hG5S4.eocFetch)(endpoint).then(({ data: data, count: count })=>{
        return {
            data: data,
            count: Math.ceil(count / limit)
        };
    });
};
const $db88c013da09485e$export$cdae09ff00c893b2 = (params)=>{
    return (0, $hG5S4.eocFetch)((0, $h0JEJ.urls).incomingCall.url(), {
        method: 'POST',
        body: params
    });
};

});



parcelRegister("2izvT", function(module, exports) {
$parcel$export(module.exports, "globalIncomingCallDetailRoute", () => $cf0e980223497991$export$10f19333da6ac52c);
const $cf0e980223497991$export$10f19333da6ac52c = {
    name: 'eoc-incoming-call-detail',
    path: '/jira/settings/products/ops/incoming-call/:id',
    exact: true
};

});

parcelRegister("6hCGb", function(module, exports) {
$parcel$export(module.exports, "LazyIncomingCall", () => $95050f68af3b50ef$export$d76e6607b7e88a7b);
$parcel$export(module.exports, "LazyIncomingCallDetail", () => $95050f68af3b50ef$export$1c56f2b1fdd5d724);

var $l8G1z = parcelRequire("l8G1z");

const $95050f68af3b50ef$export$d76e6607b7e88a7b = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("kaqvW")).then((module)=>module.IncomingCallPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

const $95050f68af3b50ef$export$1c56f2b1fdd5d724 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("kaqvW")).then((module)=>module.IncomingCallDetailPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

});
parcelRegister("kaqvW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4pkRR").then(()=>parcelRequire('kfLAy'));

});



parcelRegister("9WyQi", function(module, exports) {
$parcel$export(module.exports, "globalIncomingCallRouteEntry", () => $bebf4f8b0828e327$export$bf8ccc758901febd);

var $euxye = parcelRequire("euxye");



var $dUAVJ = parcelRequire("dUAVJ");

var $iP7KH = parcelRequire("iP7KH");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $gfyN3 = parcelRequire("gfyN3");

var $8bf4L = parcelRequire("8bf4L");

var $bkrFd = parcelRequire("bkrFd");

var $6hCGb = parcelRequire("6hCGb");
const $bebf4f8b0828e327$var$IncomingCall = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $6hCGb.LazyIncomingCall),
        pageId: "async-jira-eoc-incoming-call",
        shouldShowSpinner: false
    });
$bebf4f8b0828e327$var$IncomingCall.displayName = "IncomingCall";
const $bebf4f8b0828e327$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $bebf4f8b0828e327$export$bf8ccc758901febd = (0, $fdS54.createEntry)((0, $gfyN3.globalIncomingCallRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: $bebf4f8b0828e327$var$IncomingCall,
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $iP7KH.listResources)()
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$bebf4f8b0828e327$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6hCGb.LazyIncomingCall)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gfyN3", function(module, exports) {
$parcel$export(module.exports, "globalIncomingCallRoute", () => $39f85c3854fe18b7$export$8dd2e8adca05d8a3);
const $39f85c3854fe18b7$export$8dd2e8adca05d8a3 = {
    name: 'eoc-incoming-call',
    path: '/jira/settings/products/ops/incoming-call',
    exact: true
};

});


parcelRegister("2Wapk", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationCreateRouteEntry", () => $96b701e586137a60$export$62eef9a2917f041f);



var $dUAVJ = parcelRequire("dUAVJ");

var $jLaIf = parcelRequire("jLaIf");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $cqQNQ = parcelRequire("cqQNQ");

var $bkrFd = parcelRequire("bkrFd");

var $laTv7 = parcelRequire("laTv7");

var $bPbSe = parcelRequire("bPbSe");

var $lfcZt = parcelRequire("lfcZt");
const $96b701e586137a60$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $96b701e586137a60$export$62eef9a2917f041f = (0, $fdS54.createEntry)((0, $cqQNQ.globalIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        slot: (0, $bPbSe.IntegrationCreate),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $jLaIf.resources).configuredIntegrationsResource,
            (0, $jLaIf.resources).integrationListResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$96b701e586137a60$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jLaIf", function(module, exports) {
$parcel$export(module.exports, "resources", () => $ad3c553dd558084a$export$bc99aaabaf7b70a7);

var $7MSSX = parcelRequire("7MSSX");

var $1dlUX = parcelRequire("1dlUX");

var $3SxP9 = parcelRequire("3SxP9");
const $ad3c553dd558084a$export$bc99aaabaf7b70a7 = {
    configuredIntegrationsResource: $7MSSX.configuredIntegrationsResource,
    integrationListResource: $1dlUX.integrationListResource,
    userAccessRightsResource: $3SxP9.userAccessRightsResource
};

});
parcelRegister("7MSSX", function(module, exports) {
$parcel$export(module.exports, "configuredIntegrationsResource", () => $99dad56062db24e7$export$4136019b80be5917);

var $7edbf = parcelRequire("7edbf");

var $erj0F = parcelRequire("erj0F");

var $eRRVH = parcelRequire("eRRVH");

const $99dad56062db24e7$export$4136019b80be5917 = (0, $7edbf.createResource)({
    type: 'configuredIntegrationsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const group = query['group'];
        const keyword = query['keyword'];
        const status = query['status'];
        const page = query['page'] || '1';
        return (0, $erj0F.UrlHelper)((0, $d8cf0c2af539c94f$export$bc7daa294a7c75e4), {
            [(0, $d8cf0c2af539c94f$export$d26137cf824a9e53)]: page,
            [(0, $d8cf0c2af539c94f$export$299579ccbdd63cbc)]: keyword,
            [(0, $d8cf0c2af539c94f$export$d7415cfdee4bffc8)]: group,
            [(0, $d8cf0c2af539c94f$export$ce2c93e90dda8613)]: status,
            [(0, $d8cf0c2af539c94f$export$4e0ddb4dc97eb573)]: teamId
        });
    },
    getData: (routerContext)=>(0, $eRRVH.default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("erj0F", function(module, exports) {
$parcel$export(module.exports, "UrlHelper", () => $e6743d84b0ffa764$export$bacbc496e850c0a4);
const $e6743d84b0ffa764$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    // Using %2C in URLs causes bugs in AngularJS, so we need to replace it with comma
    const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("eRRVH", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5f45ef0f0aa88ac$export$2e2bcd8739ae039);

var $hG5S4 = parcelRequire("hG5S4");

var $erj0F = parcelRequire("erj0F");

const $f5f45ef0f0aa88ac$var$getIntegrations = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $f568c03cb28cd842$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        group: query.group,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $hG5S4.eocFetch)((0, $erj0F.UrlHelper)('/v3/integrations/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $f568c03cb28cd842$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $f568c03cb28cd842$export$31ecae7225aecec6)),
            itemCount: response.data.count,
            platformTeamId: response.data.platformTeamId
        }));
};
const $f5f45ef0f0aa88ac$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, $hG5S4.eocFetch)((0, $erj0F.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $f5f45ef0f0aa88ac$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, $hG5S4.eocFetch)((0, $erj0F.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
const $f5f45ef0f0aa88ac$var$_default_1 = {
    getIntegrations: $f5f45ef0f0aa88ac$var$getIntegrations,
    patchIntegration: $f5f45ef0f0aa88ac$var$patchIntegration,
    deleteIntegration: $f5f45ef0f0aa88ac$var$deleteIntegration
};
var $f5f45ef0f0aa88ac$export$2e2bcd8739ae039 = $f5f45ef0f0aa88ac$var$_default_1;

});
const $f568c03cb28cd842$export$31ecae7225aecec6 = 20;


const $d8cf0c2af539c94f$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $d8cf0c2af539c94f$export$d26137cf824a9e53 = 'page';
const $d8cf0c2af539c94f$export$299579ccbdd63cbc = 'keyword';
const $d8cf0c2af539c94f$export$d7415cfdee4bffc8 = 'group';
const $d8cf0c2af539c94f$export$ce2c93e90dda8613 = 'status';
const $d8cf0c2af539c94f$export$4e0ddb4dc97eb573 = 'teamId';


parcelRegister("1dlUX", function(module, exports) {
$parcel$export(module.exports, "integrationListResource", () => $0269a442db8d51e3$export$f60a40a11a6e0ee4);

var $7edbf = parcelRequire("7edbf");

var $iARbV = parcelRequire("iARbV");
const $0269a442db8d51e3$export$f60a40a11a6e0ee4 = (0, $7edbf.createResource)({
    type: 'integrationListResource',
    getKey: ({ query: query })=>{
        const group = query['group'];
        const keyword = query['keyword'];
        return `integrationListResource?group=${group}&keyword=${keyword}`;
    },
    getData: async (routerContext)=>await (0, $iARbV.default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("iARbV", function(module, exports) {
$parcel$export(module.exports, "default", () => $baa9e774daeb12e7$export$2e2bcd8739ae039);

var $hG5S4 = parcelRequire("hG5S4");

var $erj0F = parcelRequire("erj0F");
const $baa9e774daeb12e7$var$getIntegrationList = (query, teamId)=>{
    const { keyword: keyword, group: group } = query ?? {};
    return (0, $hG5S4.eocFetch)((0, $erj0F.UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
        keyword: keyword,
        group: group,
        teamId: teamId
    })).then((response)=>{
        const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
        return {
            labels: labels,
            availableGroups: availableGroups,
            allTypes: allTypes,
            platformTeamId: platformTeamId
        };
    });
};
const $baa9e774daeb12e7$var$getIntegrationTypes = (integrationType, teamId)=>(0, $hG5S4.eocFetch)((0, $erj0F.UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
        teamId: teamId
    })).then((response)=>response.data.map((integrationType)=>({
                ...integrationType,
                value: integrationType.type,
                label: integrationType.displayName
            })));
const $baa9e774daeb12e7$var$_default_1 = {
    getIntegrationList: $baa9e774daeb12e7$var$getIntegrationList,
    getIntegrationTypes: $baa9e774daeb12e7$var$getIntegrationTypes
};
var $baa9e774daeb12e7$export$2e2bcd8739ae039 = $baa9e774daeb12e7$var$_default_1;

});


parcelRegister("3SxP9", function(module, exports) {
$parcel$export(module.exports, "userAccessRightsResource", () => $210309cff6f1e21a$export$69ddc7cc64ae9a02);

var $7edbf = parcelRequire("7edbf");

var $6C6mc = parcelRequire("6C6mc");
const $210309cff6f1e21a$export$69ddc7cc64ae9a02 = (0, $7edbf.createResource)({
    type: 'userAccessRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params.teamId;
        return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
    },
    getData: (routerContext)=>(0, $6C6mc.getUserRights)(routerContext.match.params.teamId),
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("6C6mc", function(module, exports) {
$parcel$export(module.exports, "getUserRights", () => $88618a6c9dc398f6$export$84e2ed279bc4e64e);

var $hG5S4 = parcelRequire("hG5S4");

var $erj0F = parcelRequire("erj0F");
const $88618a6c9dc398f6$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $hG5S4.eocFetch)((0, $erj0F.UrlHelper)(`/v3/integrations/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data);
};

});



parcelRegister("cqQNQ", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationCreateRoute", () => $a8bddd9af56f7d95$export$bb272d36e3c3b7c1);
const $a8bddd9af56f7d95$export$bb272d36e3c3b7c1 = {
    name: 'eoc-integration-create',
    path: '/jira/settings/products/ops/integrations/create/:type',
    exact: true
};

});

parcelRegister("laTv7", function(module, exports) {
$parcel$export(module.exports, "IntegrationAutomation", () => $91a1526865c37737$export$434c3e2269913ac0);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $lfcZt = parcelRequire("lfcZt");
const $91a1526865c37737$export$434c3e2269913ac0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $lfcZt.LazyIntegrationAutomation),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
$91a1526865c37737$export$434c3e2269913ac0.displayName = "IntegrationAutomation";

});
parcelRegister("lfcZt", function(module, exports) {
$parcel$export(module.exports, "LazyIntegrationAutomation", () => $f67ead1765ed7674$export$68c40afda0287b61);
$parcel$export(module.exports, "LazyIntegrationDetail", () => $f67ead1765ed7674$export$fd7f60e3df94c902);
$parcel$export(module.exports, "LazyIntegrationCreate", () => $f67ead1765ed7674$export$aa9358ade7cb53ee);
$parcel$export(module.exports, "LazyIntegrationList", () => $f67ead1765ed7674$export$993132b847f26efa);
$parcel$export(module.exports, "LazyIntegrationLog", () => $f67ead1765ed7674$export$b02ef932401d95fc);

var $l8G1z = parcelRequire("l8G1z");

const $f67ead1765ed7674$export$68c40afda0287b61 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7eAEw")).then((module)=>module.IntegrationAutomation), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $f67ead1765ed7674$export$fd7f60e3df94c902 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7eAEw")).then((module)=>module.IntegrationDetail), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $f67ead1765ed7674$export$aa9358ade7cb53ee = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7eAEw")).then((module)=>module.IntegrationCreate), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $f67ead1765ed7674$export$993132b847f26efa = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7eAEw")).then((module)=>module.IntegrationList), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $f67ead1765ed7674$export$b02ef932401d95fc = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7eAEw")).then((module)=>module.IntegrationLog), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

});
parcelRegister("7eAEw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iqI8E")
]).then(()=>parcelRequire('gnIsr'));

});



parcelRegister("bPbSe", function(module, exports) {
$parcel$export(module.exports, "IntegrationCreate", () => $1eeaf123c5caed67$export$5cb14595364f02c);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $lfcZt = parcelRequire("lfcZt");
const $1eeaf123c5caed67$export$5cb14595364f02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $lfcZt.LazyIntegrationCreate),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
$1eeaf123c5caed67$export$5cb14595364f02c.displayName = "IntegrationCreate";

});


parcelRegister("b829t", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationDetailRouteEntry", () => $e32d62d17a08bbf6$export$b66abbccbf93e9ad);



var $dUAVJ = parcelRequire("dUAVJ");

var $jLaIf = parcelRequire("jLaIf");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $776Ek = parcelRequire("776Ek");

var $bkrFd = parcelRequire("bkrFd");

var $laTv7 = parcelRequire("laTv7");

var $4IADZ = parcelRequire("4IADZ");

var $lfcZt = parcelRequire("lfcZt");
const $e32d62d17a08bbf6$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $e32d62d17a08bbf6$export$b66abbccbf93e9ad = (0, $fdS54.createEntry)((0, $776Ek.globalIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        slot: (0, $4IADZ.IntegrationDetail),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $jLaIf.resources).configuredIntegrationsResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$e32d62d17a08bbf6$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("776Ek", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationDetailRoute", () => $4049140620ae7db1$export$f826f15073eda98);
const $4049140620ae7db1$export$f826f15073eda98 = {
    name: 'eoc-integration-detail',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId',
    exact: true
};

});

parcelRegister("4IADZ", function(module, exports) {
$parcel$export(module.exports, "IntegrationDetail", () => $cb4704d9d219d3fe$export$8bb99f196e0be5b6);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $lfcZt = parcelRequire("lfcZt");
const $cb4704d9d219d3fe$export$8bb99f196e0be5b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $lfcZt.LazyIntegrationDetail),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
$cb4704d9d219d3fe$export$8bb99f196e0be5b6.displayName = "IntegrationDetail";

});


parcelRegister("8FLFs", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationListRouteEntry", () => $4bbd8fecc8590fa8$export$790602da39f8af00);



var $dUAVJ = parcelRequire("dUAVJ");

var $jLaIf = parcelRequire("jLaIf");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $glMgv = parcelRequire("glMgv");

var $bkrFd = parcelRequire("bkrFd");

var $laTv7 = parcelRequire("laTv7");

var $hHvyy = parcelRequire("hHvyy");

var $lfcZt = parcelRequire("lfcZt");
const $4bbd8fecc8590fa8$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $4bbd8fecc8590fa8$export$790602da39f8af00 = (0, $fdS54.createEntry)((0, $glMgv.globalIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        slot: (0, $hHvyy.IntegrationList),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $jLaIf.resources).integrationListResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$4bbd8fecc8590fa8$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("glMgv", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationListRoute", () => $9867d22fee8b9b47$export$270e16f240db883b);
const $9867d22fee8b9b47$export$270e16f240db883b = {
    name: 'eoc-integration-list',
    path: '/jira/settings/products/ops/integrations/list',
    exact: true
};

});

parcelRegister("hHvyy", function(module, exports) {
$parcel$export(module.exports, "IntegrationList", () => $4ce27c8cd3922f8e$export$955768269b79c203);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $lfcZt = parcelRequire("lfcZt");
const $4ce27c8cd3922f8e$export$955768269b79c203 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $lfcZt.LazyIntegrationList),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
$4ce27c8cd3922f8e$export$955768269b79c203.displayName = "IntegrationList";

});


parcelRegister("6368z", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationLogRouteEntry", () => $7185506883610990$export$d30f51d0f351bd8a);



var $dUAVJ = parcelRequire("dUAVJ");

var $835qG = parcelRequire("835qG");

var $jLaIf = parcelRequire("jLaIf");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $3sCMV = parcelRequire("3sCMV");

var $bkrFd = parcelRequire("bkrFd");

var $laTv7 = parcelRequire("laTv7");

var $9PvxW = parcelRequire("9PvxW");

var $lfcZt = parcelRequire("lfcZt");
const $7185506883610990$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $7185506883610990$export$d30f51d0f351bd8a = (0, $fdS54.createEntry)((0, $3sCMV.globalIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        slot: (0, $9PvxW.IntegrationLog),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $835qG.resources)(),
            (0, $jLaIf.resources).configuredIntegrationsResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$7185506883610990$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3sCMV", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationLogRoute", () => $6eadfe93f827091c$export$71884dc820e415fc);
const $6eadfe93f827091c$export$71884dc820e415fc = {
    name: 'eoc-integration-log',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
    exact: true
};

});

parcelRegister("9PvxW", function(module, exports) {
$parcel$export(module.exports, "IntegrationLog", () => $fa18a964eef17f06$export$b545b4a4c4cee016);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $lfcZt = parcelRequire("lfcZt");
const $fa18a964eef17f06$export$b545b4a4c4cee016 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $lfcZt.LazyIntegrationLog),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
$fa18a964eef17f06$export$b545b4a4c4cee016.displayName = "IntegrationLog";

});


parcelRegister("dL4cN", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationsRouteEntry", () => $3c3d8421897db4df$export$6e5cd6656076550f);



var $dUAVJ = parcelRequire("dUAVJ");

var $jLaIf = parcelRequire("jLaIf");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $byJim = parcelRequire("byJim");

var $bkrFd = parcelRequire("bkrFd");

var $lfcZt = parcelRequire("lfcZt");

var $laTv7 = parcelRequire("laTv7");
const $3c3d8421897db4df$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $3c3d8421897db4df$export$6e5cd6656076550f = (0, $fdS54.createEntry)((0, $byJim.globalIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        slot: null,
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $jLaIf.resources).configuredIntegrationsResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$3c3d8421897db4df$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("byJim", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationsRoute", () => $518fe7eacbc68509$export$e196ff2390a1ec56);
const $518fe7eacbc68509$export$e196ff2390a1ec56 = {
    name: 'eoc-integrations',
    path: '/jira/settings/products/ops/integrations',
    exact: true
};

});


parcelRegister("WtQtU", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRouteEntry", () => $28bbc8adadf61a09$export$30f8c1a53605b10b);

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $i47Ja = parcelRequire("i47Ja");

var $kyA0J = parcelRequire("kyA0J");


var $4KNkL = parcelRequire("4KNkL");

var $7dMoN = parcelRequire("7dMoN");

var $31tCE = parcelRequire("31tCE");

var $5E19W = parcelRequire("5E19W");

var $2A6mK = parcelRequire("2A6mK");
const $28bbc8adadf61a09$export$30f8c1a53605b10b = (0, $fdS54.createEntry)((0, $i47Ja.globalIssueNavigatorBrowseIssueRedirectRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5E19W.default),
        skeleton: (0, $kyA0J.GlobalIssueNavigatorSkeleton),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2A6mK.LazyGlobalIssueNavigator)
        ],
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $4KNkL.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $7dMoN.getCommonGlobalResources)()
        ],
        layout: (0, $h2tgz.globalLayout),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("i47Ja", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", () => $d73e45e5a58ab226$export$34695dccebecc6bc);
const $d73e45e5a58ab226$export$34695dccebecc6bc = {
    name: 'global-issue-navigator-browse-issue-redirect',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});

parcelRegister("kyA0J", function(module, exports) {
$parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", () => $353cd48a20ea0a0b$export$51681996374b2585);
/* global-app.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $fSFF8 = parcelRequire("fSFF8");
const $353cd48a20ea0a0b$var$customCssStyles = null;
const $353cd48a20ea0a0b$export$51681996374b2585 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fSFF8))),
        className: (0, $4jQY2.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });
$353cd48a20ea0a0b$export$51681996374b2585.displayName = "GlobalIssueNavigatorSkeleton";

});
parcelRegister("fSFF8", function(module, exports) {
module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();

});


parcelRegister("4KNkL", function(module, exports) {
$parcel$export(module.exports, "getCommonGlobalNavigation", () => $676e28356e23065c$export$2f31f4f387017d83);

const $676e28356e23065c$export$2f31f4f387017d83 = ()=>({
        menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
    });

});

parcelRegister("7dMoN", function(module, exports) {
$parcel$export(module.exports, "getCommonGlobalResources", () => $ea8c45dc048998b1$export$343e92405307cf8d);

var $jFwZ0 = parcelRequire("jFwZ0");

var $8ycTI = parcelRequire("8ycTI");

var $L6Vhc = parcelRequire("L6Vhc");

var $dUAVJ = parcelRequire("dUAVJ");

var $9KYmb = parcelRequire("9KYmb");

var $fPXVF = parcelRequire("fPXVF");
const $ea8c45dc048998b1$export$343e92405307cf8d = ()=>[
        (0, $L6Vhc.issueNavigatorRelayResource),
        (0, $L6Vhc.issueNavigatorFilterRelayResource),
        (0, $L6Vhc.issueNavigatorHydrationRelayResource),
        ...(0, $dUAVJ.getNavigationResources)(),
        ...(0, $fPXVF.getIssueAppResources)(),
        (0, $jFwZ0.currentUserResource),
        ...(0, $9KYmb.getDraftReplyPillsResource)(),
        (0, $8ycTI.workspaceResource)
    ];

});
parcelRegister("L6Vhc", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorRelayResource", () => $8d6149d73c75d5b7$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $8d6149d73c75d5b7$export$44ca3a0b25f38d83);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResource", () => $8d6149d73c75d5b7$export$967ef0cfbd1cc946);
$parcel$export(module.exports, "issueNavigatorFilterRefinementRelayResource", () => $8d6149d73c75d5b7$export$b963a9a8713e35f3);
/* eslint-disable jira/import-whitelist */ 
var $n67Vb = parcelRequire("n67Vb");

var $aJDWs = parcelRequire("aJDWs");

var $2700E = parcelRequire("2700E");

var $9v1ZM = parcelRequire("9v1ZM");

var $aGuuA = parcelRequire("aGuuA");

var $2BI6B = parcelRequire("2BI6B");

var $bUbdD = parcelRequire("bUbdD");

var $5UWRF = parcelRequire("5UWRF");

var $fm1RV = parcelRequire("fm1RV");

var $ffz1y = parcelRequire("ffz1y");

var $355LU = parcelRequire("355LU");

var $2zU0a = parcelRequire("2zU0a");

var $aI7em = parcelRequire("aI7em");

var $5SJ3N = parcelRequire("5SJ3N");

var $htsFl = parcelRequire("htsFl");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

var $5JR60 = parcelRequire("5JR60");

var $j9gBV = parcelRequire("j9gBV");

var $2MVij = parcelRequire("2MVij");

var $hZR74 = parcelRequire("hZR74");

var $3fnQD = parcelRequire("3fnQD");

var $h8SYr = parcelRequire("h8SYr");
const $8d6149d73c75d5b7$var$getFilterResourceKey = (baseKey, { query: { filter: filter } })=>{
    const filterId = Boolean(filter) && (0, $9v1ZM.isFilterId)(filter) ? filter : null;
    return filterId ? `${baseKey}-${filterId}` : baseKey;
};
const $8d6149d73c75d5b7$var$loadIssueNavigatorRelayQuery = async (variables)=>{
    const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $3fnQD.default), variables, {
        fetchPolicy: 'network-only',
        networkCacheConfig: {
            metadata: {
                META_SLOW_ENDPOINT: true
            }
        }
    });
    if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
    return queryReference;
};
const $8d6149d73c75d5b7$export$b4096f516fb93159 = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${(0, $h8SYr.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: (0, $bUbdD.getIssueSearchResourceKey),
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        if ((0, $i860n.fg)('jira_nin_main_query_variables_builder') || (0, $i860n.fg)('jira_nin_force_client_only_main_query')) return $8d6149d73c75d5b7$var$loadIssueNavigatorRelayQuery((0, $aGuuA.buildMainIssueNavigatorQueryVariables)(routerContext, tenantContext));
        // Legacy main_IssueNavigatorQuery variables path. Delete this block when
        // `jira_nin_main_query_variables_builder` is cleaned up.
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter, groupBy: groupBy, hideDone: hideDone } = (0, $2BI6B.getParams)(routerContext);
        const issueSearchInput = (0, $2BI6B.getIssueSearchInput)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $fm1RV.getMaxIssuesPerPage)();
        const chromelessRoute = (0, $5UWRF.isChromelessRoute)(routerContext);
        let viewId;
        let shouldQueryConditionalFormatting = Boolean(projectKey);
        let isIFCEnabled = Boolean(projectKey);
        const filterId = Boolean(filter) && (0, $9v1ZM.isCustomFilter)(filter) ? filter : null;
        if (chromelessRoute) {
            // Disable conditional formatting for chromeless (i.e. embed) routes when saved views is disabled
            shouldQueryConditionalFormatting = (0, $i860n.fg)('saved_list_view_technical_changes');
            // Disable IFC for chromeless (i.e. embed) routes
            isIFCEnabled = false;
            // Explicitly load list view for chromeless (i.e. embed) routes
            viewId = filterId ? (0, $ffz1y.convertFilterIdToIssueNavigatorId)(filterId) : 'list_default';
        }
        let staticViewInput;
        if (projectKey === undefined || projectKey === null) staticViewInput = {
            isHierarchyEnabled: false,
            isGroupingEnabled: false,
            isHideDoneEnabled: false
        };
        else if (hideDone != null) staticViewInput = {
            isHideDoneEnabled: hideDone
        };
        const viewConfigInput = staticViewInput ? {
            staticViewInput: staticViewInput
        } : {
            viewInput: {
                namespace: (0, $fm1RV.ISSUE_SEARCH_NAMESPACE)
            }
        };
        let jiraViewQueryInput = null;
        if ((0, $i860n.fg)('saved_list_view_technical_changes')) {
            const itemIdSlug = routerContext.match.params.navigationItemId;
            const itemId = itemIdSlug ? `list/${itemIdSlug}` : 'list';
            if ((0, $aJDWs.isProjectsInJiraM2Enabled)()) {
                const subspaceId = routerContext.match.params.subspaceId;
                if (subspaceId) // Subcontainer (subspace) scoped view
                jiraViewQueryInput = {
                    subcontainerIdAndItemQuery: {
                        cloudId: tenantContext.cloudId,
                        itemId: itemId,
                        subcontainerId: subspaceId
                    }
                };
                else if (projectKey == null) jiraViewQueryInput = {
                    viewId: (0, $5JR60.createViewAri)({
                        activationId: tenantContext.activationId,
                        cloudId: tenantContext.cloudId
                    })
                };
                else jiraViewQueryInput = {
                    projectKeyAndItemQuery: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        itemId: itemId
                    }
                };
            } else jiraViewQueryInput = projectKey == null ? {
                viewId: (0, $5JR60.createViewAri)({
                    activationId: tenantContext.activationId,
                    cloudId: tenantContext.cloudId
                })
            } : {
                projectKeyAndItemQuery: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    itemId: itemId
                }
            };
        }
        let operationScope;
        if (isIFCEnabled && (0, $2700E.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) operationScope = (0, $355LU.getOperationScope)(projectKey);
        else if (projectKey) operationScope = (0, $fm1RV.NIN_PROJECT_OPERATION_SCOPE);
        else operationScope = (0, $fm1RV.NIN_GLOBAL_OPERATION_SCOPE);
        const scope = {
            operationScope: operationScope,
            projectKey: projectKey ?? null
        };
        const fieldSetsScope = {
            operationScope: operationScope,
            projectKey: projectKey ?? null
        };
        const dynamicSearchKey = (0, $bUbdD.getIssueSearchResourceKey)(routerContext);
        const legacyVariables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: issueSearchInput,
            namespace: (0, $fm1RV.ISSUE_SEARCH_NAMESPACE),
            fieldSetsInput: {
                viewInput: {
                    namespace: (0, $fm1RV.ISSUE_SEARCH_NAMESPACE),
                    filterId: filterId,
                    viewId: viewId
                }
            },
            after: null,
            options: {
                issueKey: issueKey
            },
            filterId: filterId,
            amountOfColumns: (0, $fm1RV.MAX_AMOUNT_OF_COLUMNS),
            shouldQueryHasChildren: projectKey !== null && projectKey !== undefined && !(0, $i860n.fg)('jsc_list_expand_all'),
            shouldQueryHasChildrenWithCount: projectKey !== null && projectKey !== undefined && (0, $i860n.fg)('jsc_list_expand_all'),
            scope: scope,
            viewConfigInput: viewConfigInput,
            staticViewInput: staticViewInput,
            jiraViewQueryInput: jiraViewQueryInput,
            settings: (0, $i860n.fg)('saved_list_view_technical_changes') ? {
                groupBy: groupBy,
                hideDone: hideDone,
                jql: 'jql' in issueSearchInput ? issueSearchInput.jql : undefined
            } : null,
            atlassianIntelligenceProductFeature: // oxlint-disable-next-line typescript/consistent-type-assertions
            (0, $fm1RV.NATURAL_LANGUAGE_TO_JQL),
            projectKey: projectKey ?? '',
            shouldQueryProject: Boolean(projectKey),
            shouldQueryConditionalFormatting: shouldQueryConditionalFormatting,
            shouldQueryConditionalFormattingFromSavedView: shouldQueryConditionalFormatting && (0, $i860n.fg)('saved_list_view_technical_changes'),
            shouldQuerySaveResetViewSettingsButton: !tenantContext.isAnonymous && (0, $2700E.expVal)('saved_list_view', 'isEnabled', false),
            groupBy: groupBy ?? null,
            shouldQueryRankField: Boolean(projectKey) && (0, $2700E.expVal)('pnin_jql_order_by_rank_enabled', 'isEnabled', false),
            fieldSetsScope: fieldSetsScope,
            viewId: viewId,
            dynamicSearchKey: /*
			This key is used to generate a unique identity for the issue connection record in the Relay store when running a
			new search. This is to prevent concurrency related bugs occurring when performing a refetch that returns a new
			connection of results. Ordinarily this would be handled automatically when relevant query variables change (as
			these are used to form the connection key), however we override the default connection filters which allows us
			to modify variables during pagination operations without producing a new connection key.
			 */ dynamicSearchKey
        };
        return $8d6149d73c75d5b7$var$loadIssueNavigatorRelayQuery(legacyVariables);
    },
    maxAge: 0
});
const $8d6149d73c75d5b7$export$44ca3a0b25f38d83 = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${(0, $h8SYr.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: (routerContext)=>(0, $i860n.fg)('nin_jql_in_route_query_whitelist') ? $8d6149d73c75d5b7$var$getFilterResourceKey('issue-navigator-filter-relay', routerContext) : (0, $bUbdD.getResourceKey)('issue-navigator-filter-relay', routerContext),
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $2BI6B.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $9v1ZM.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $2zU0a.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $hZR74.default), variables, options);
        if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $8d6149d73c75d5b7$export$967ef0cfbd1cc946 = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${(0, $h8SYr.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
    getKey: (routerContext)=>(0, $bUbdD.getResourceKey)('issue-navigator-hydration-relay', routerContext),
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $2BI6B.getParams)(routerContext);
        const isProjectNIN = Boolean(projectKey);
        if (isProjectNIN) return null;
        let itemId = null;
        if ((0, $i860n.fg)('saved_list_view_technical_changes')) {
            const itemIdSlug = routerContext.match.params.navigationItemId;
            itemId = itemIdSlug ? `list/${itemIdSlug}` : 'list';
        }
        const hydrateJqlInput = (0, $2BI6B.getHydrateJqlInput)({
            activationId: tenantContext.activationId,
            cloudId: tenantContext.cloudId,
            defaultJql: defaultJql,
            jqlParam: jqlParam,
            filter: filter,
            projectKey: projectKey,
            itemId: itemId
        });
        const variables = {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            viewContext: null,
            input: hydrateJqlInput,
            scope: !isProjectNIN && ((0, $i860n.fg)('projects_in_jira_ga_drop') || (0, $2700E.expVal)('anip-1095-goals-in-harmonised-filter', 'isEnabled', false)) ? {
                list: {
                    operationScope: (0, $fm1RV.NIN_GLOBAL_OPERATION_SCOPE)
                }
            } : null
        };
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $2MVij.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $8d6149d73c75d5b7$export$b963a9a8713e35f3 = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${(0, $h8SYr.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-refinement-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey } = (0, $2BI6B.getParams)(routerContext);
        const isProjectNIN = Boolean(projectKey);
        if (!isProjectNIN) return null;
        const variables = {
            cloudId: tenantContext.cloudId,
            isFilterRefinementEnabled: true,
            scope: {
                project: {
                    projectKey: projectKey
                }
            }
        };
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $j9gBV.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("9v1ZM", function(module, exports) {
$parcel$export(module.exports, "isCustomFilter", () => $d5aa8ec9a794c883$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $d5aa8ec9a794c883$export$23be85030bd58047);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $d5aa8ec9a794c883$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $d5aa8ec9a794c883$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $d5aa8ec9a794c883$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("aGuuA", function(module, exports) {
$parcel$export(module.exports, "buildMainIssueNavigatorQueryVariables", () => $1e6225a4fca21784$export$47cee21b42ff4513);

var $aJDWs = parcelRequire("aJDWs");

var $2700E = parcelRequire("2700E");

var $9v1ZM = parcelRequire("9v1ZM");

var $fm1RV = parcelRequire("fm1RV");

var $ffz1y = parcelRequire("ffz1y");

var $355LU = parcelRequire("355LU");

var $i860n = parcelRequire("i860n");

var $5JR60 = parcelRequire("5JR60");

var $2BI6B = parcelRequire("2BI6B");

var $bUbdD = parcelRequire("bUbdD");

var $5UWRF = parcelRequire("5UWRF");
const $1e6225a4fca21784$export$47cee21b42ff4513 = (routerContext, tenantContext)=>{
    const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter, groupBy: groupBy, hideDone: hideDone } = (0, $2BI6B.getParams)(routerContext);
    const issueSearchInput = (0, $2BI6B.getIssueSearchInput)(defaultJql, jqlParam, filter, projectKey);
    const maxIssuesPerPage = (0, $fm1RV.getMaxIssuesPerPage)();
    const chromelessRoute = (0, $5UWRF.isChromelessRoute)(routerContext);
    let viewId;
    let shouldQueryConditionalFormatting = Boolean(projectKey);
    let isIFCEnabled = Boolean(projectKey);
    const filterId = Boolean(filter) && (0, $9v1ZM.isCustomFilter)(filter) ? filter : null;
    if (chromelessRoute) {
        // Disable conditional formatting for chromeless (i.e. embed) routes when saved views is disabled
        shouldQueryConditionalFormatting = (0, $i860n.fg)('saved_list_view_technical_changes');
        // Disable IFC for chromeless (i.e. embed) routes
        isIFCEnabled = false;
        // Explicitly load list view for chromeless (i.e. embed) routes
        viewId = filterId ? (0, $ffz1y.convertFilterIdToIssueNavigatorId)(filterId) : 'list_default';
    }
    let staticViewInput;
    if (projectKey === undefined || projectKey === null) staticViewInput = {
        isHierarchyEnabled: false,
        isGroupingEnabled: false,
        isHideDoneEnabled: false
    };
    else if (hideDone != null) staticViewInput = {
        isHideDoneEnabled: hideDone
    };
    const viewConfigInput = staticViewInput ? {
        staticViewInput: staticViewInput
    } : {
        viewInput: {
            namespace: (0, $fm1RV.ISSUE_SEARCH_NAMESPACE)
        }
    };
    let jiraViewQueryInput = null;
    if ((0, $i860n.fg)('saved_list_view_technical_changes')) {
        const itemIdSlug = routerContext.match.params.navigationItemId;
        const itemId = itemIdSlug ? `list/${itemIdSlug}` : 'list';
        if ((0, $aJDWs.isProjectsInJiraM2Enabled)()) {
            const subspaceId = routerContext.match.params.subspaceId;
            if (subspaceId) // Subcontainer (subspace) scoped view
            jiraViewQueryInput = {
                subcontainerIdAndItemQuery: {
                    cloudId: tenantContext.cloudId,
                    itemId: itemId,
                    subcontainerId: subspaceId
                }
            };
            else if (projectKey == null) jiraViewQueryInput = {
                viewId: (0, $5JR60.createViewAri)({
                    activationId: tenantContext.activationId,
                    cloudId: tenantContext.cloudId
                })
            };
            else jiraViewQueryInput = {
                projectKeyAndItemQuery: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    itemId: itemId
                }
            };
        } else jiraViewQueryInput = projectKey == null ? {
            viewId: (0, $5JR60.createViewAri)({
                activationId: tenantContext.activationId,
                cloudId: tenantContext.cloudId
            })
        } : {
            projectKeyAndItemQuery: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey,
                itemId: itemId
            }
        };
    }
    let operationScope;
    if (isIFCEnabled && (0, $2700E.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) operationScope = (0, $355LU.getOperationScope)(projectKey);
    else if (projectKey) operationScope = (0, $fm1RV.NIN_PROJECT_OPERATION_SCOPE);
    else operationScope = (0, $fm1RV.NIN_GLOBAL_OPERATION_SCOPE);
    const scope = {
        operationScope: operationScope,
        projectKey: projectKey ?? null
    };
    const fieldSetsScope = {
        operationScope: operationScope,
        projectKey: projectKey ?? null
    };
    const dynamicSearchKey = (0, $bUbdD.getIssueSearchResourceKey)(routerContext);
    const variables = {
        cloudId: tenantContext.cloudId,
        first: issueKey == null ? maxIssuesPerPage : null,
        issueSearchInput: issueSearchInput,
        namespace: (0, $fm1RV.ISSUE_SEARCH_NAMESPACE),
        fieldSetsInput: {
            viewInput: {
                namespace: (0, $fm1RV.ISSUE_SEARCH_NAMESPACE),
                filterId: filterId,
                viewId: viewId
            }
        },
        after: null,
        options: {
            issueKey: issueKey
        },
        filterId: filterId,
        amountOfColumns: (0, $fm1RV.MAX_AMOUNT_OF_COLUMNS),
        shouldQueryHasChildren: projectKey !== null && projectKey !== undefined && !(0, $i860n.fg)('jsc_list_expand_all'),
        shouldQueryHasChildrenWithCount: projectKey !== null && projectKey !== undefined && (0, $i860n.fg)('jsc_list_expand_all'),
        scope: scope,
        viewConfigInput: viewConfigInput,
        staticViewInput: staticViewInput,
        jiraViewQueryInput: jiraViewQueryInput,
        settings: (0, $i860n.fg)('saved_list_view_technical_changes') ? {
            groupBy: groupBy,
            hideDone: hideDone,
            jql: 'jql' in issueSearchInput ? issueSearchInput.jql : undefined
        } : null,
        atlassianIntelligenceProductFeature: // oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $fm1RV.NATURAL_LANGUAGE_TO_JQL),
        projectKey: projectKey ?? '',
        shouldQueryProject: Boolean(projectKey),
        shouldQueryConditionalFormatting: shouldQueryConditionalFormatting,
        shouldQueryConditionalFormattingFromSavedView: shouldQueryConditionalFormatting && (0, $i860n.fg)('saved_list_view_technical_changes'),
        shouldQuerySaveResetViewSettingsButton: !tenantContext.isAnonymous && (0, $2700E.expVal)('saved_list_view', 'isEnabled', false),
        groupBy: groupBy ?? null,
        shouldQueryRankField: Boolean(projectKey) && (0, $2700E.expVal)('pnin_jql_order_by_rank_enabled', 'isEnabled', false),
        fieldSetsScope: fieldSetsScope,
        viewId: viewId,
        dynamicSearchKey: /*
		This key is used to generate a unique identity for the issue connection record in the Relay store when running a
		new search. This is to prevent concurrency related bugs occurring when performing a refetch that returns a new
		connection of results. Ordinarily this would be handled automatically when relevant query variables change (as
		these are used to form the connection key), however we override the default connection filters which allows us
		to modify variables during pagination operations without producing a new connection key.
		 */ dynamicSearchKey
    };
    return variables;
};

});
parcelRegister("fm1RV", function(module, exports) {
$parcel$export(module.exports, "sortDirections", () => $32b173e1419b0acb$export$73034536b9adc928);
$parcel$export(module.exports, "views", () => $32b173e1419b0acb$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $32b173e1419b0acb$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $32b173e1419b0acb$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $32b173e1419b0acb$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $32b173e1419b0acb$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $32b173e1419b0acb$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $32b173e1419b0acb$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $32b173e1419b0acb$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $32b173e1419b0acb$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $32b173e1419b0acb$export$52919046b94109dc);
$parcel$export(module.exports, "GROUPED_LIST_EXPERIENCE_ID", () => $32b173e1419b0acb$export$88890124f795113d);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $32b173e1419b0acb$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $32b173e1419b0acb$export$524ae4278a57eea2);
$parcel$export(module.exports, "LIST_VIEW_ID", () => $32b173e1419b0acb$export$af225181779390f4);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $32b173e1419b0acb$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $32b173e1419b0acb$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $32b173e1419b0acb$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $32b173e1419b0acb$export$55628b4c44d1522a);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $32b173e1419b0acb$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $32b173e1419b0acb$export$39ec48f092f3ea90);
$parcel$export(module.exports, "NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE", () => $32b173e1419b0acb$export$2c213b805a8379cf);
$parcel$export(module.exports, "NIN_GLOBAL_SHADOW_REQUEST_OPERATION_SCOPE", () => $32b173e1419b0acb$export$af868e072566ae2b);
$parcel$export(module.exports, "NIN_SIDEBAR_SCOPE", () => $32b173e1419b0acb$export$adc96a79a4445d56);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_SIDEBAR_ID", () => $32b173e1419b0acb$export$6c35abbca3056365);
$parcel$export(module.exports, "ALL_COLUMNS_ID", () => $32b173e1419b0acb$export$eb85a4c9b5d9ce7b);
$parcel$export(module.exports, "supportedOrderFields", () => $32b173e1419b0acb$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $32b173e1419b0acb$export$eaadab3243bf458);
$parcel$export(module.exports, "isJiraIssueSearchViewMetadata", () => $32b173e1419b0acb$export$f40fffea1f8469ac);
$parcel$export(module.exports, "isJiraSpreadsheetView", () => $32b173e1419b0acb$export$2627fa464eafde69);
/* eslint-disable jira/filename-case */ 
var $3U1bG = parcelRequire("3U1bG");
const $32b173e1419b0acb$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $32b173e1419b0acb$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $32b173e1419b0acb$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $32b173e1419b0acb$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $32b173e1419b0acb$export$393cb330f31d305c = $32b173e1419b0acb$export$2bd49f8f262d7cbb.created;
const $32b173e1419b0acb$export$8ea18fa9e35fdf25 = $32b173e1419b0acb$export$73034536b9adc928.DESC;
const $32b173e1419b0acb$export$500b5c379b5c7f2e = 'list_default';
const $32b173e1419b0acb$export$f88f58d1a4b2078b = 50;
const $32b173e1419b0acb$export$8c67ad1f64ab5a9c = ()=>$32b173e1419b0acb$export$f88f58d1a4b2078b;
const $32b173e1419b0acb$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $32b173e1419b0acb$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $32b173e1419b0acb$export$d57b6b390e78d90f = 'empanada';
const $32b173e1419b0acb$export$52919046b94109dc = 'showPinIssueList';
const $32b173e1419b0acb$export$88890124f795113d = 'groupedList';
const $32b173e1419b0acb$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $32b173e1419b0acb$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $32b173e1419b0acb$export$af225181779390f4 = 'list_default';
const $32b173e1419b0acb$export$608eeb3a32afef02 = (0, $3U1bG.MAX_COLUMNS);
const $32b173e1419b0acb$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $32b173e1419b0acb$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $32b173e1419b0acb$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $32b173e1419b0acb$export$fae6afe554014a45 = 'NIN_PROJECT';
const $32b173e1419b0acb$export$39ec48f092f3ea90 = 'NIN_GLOBAL';
const $32b173e1419b0acb$export$2c213b805a8379cf = 'NIN_PROJECT_SHADOW_REQUEST';
const $32b173e1419b0acb$export$af868e072566ae2b = 'NIN_GLOBAL_SHADOW_REQUEST';
const $32b173e1419b0acb$export$adc96a79a4445d56 = 'NIN_SIDEBAR';
const $32b173e1419b0acb$export$6c35abbca3056365 = 'IssueNavigator';
const $32b173e1419b0acb$export$eb85a4c9b5d9ce7b = 'all-columns';
const $32b173e1419b0acb$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $32b173e1419b0acb$export$eaadab3243bf458 = (alias)=>Object.keys($32b173e1419b0acb$export$3630aa1c4c69277f).find((key)=>$32b173e1419b0acb$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
const $32b173e1419b0acb$export$f40fffea1f8469ac = (data)=>[
        'JiraIssueSearchView',
        'JiraDetailedView',
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);
const $32b173e1419b0acb$export$2627fa464eafde69 = (data)=>[
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);

});

parcelRegister("ffz1y", function(module, exports) {
$parcel$export(module.exports, "createRememoizeSelector", () => $f21b08d18b4164ef$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $f21b08d18b4164ef$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $f21b08d18b4164ef$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $f21b08d18b4164ef$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $f21b08d18b4164ef$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $f21b08d18b4164ef$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $f21b08d18b4164ef$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $f21b08d18b4164ef$export$ec4f6e9ea23bb55d);
$parcel$export(module.exports, "exclusiveGroupResultsOrIssueResultsFragment", () => $f21b08d18b4164ef$export$1dde85fc919cd8db);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $a7e1f = parcelRequire("a7e1f");

var $fm1RV = parcelRequire("fm1RV");
const $f21b08d18b4164ef$export$982d75deeca693ef = (0, $a7e1f.createSelectorCreator)((0, $a7e1f.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $f21b08d18b4164ef$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $f21b08d18b4164ef$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $f21b08d18b4164ef$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($f21b08d18b4164ef$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $f21b08d18b4164ef$export$6256478a5735e738 = (state)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $f21b08d18b4164ef$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $fm1RV.views).detail : (0, $fm1RV.views).list;
const $f21b08d18b4164ef$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $fm1RV.views).detail ? 'detail' : 'list_default';
const $f21b08d18b4164ef$export$5786a571e562003d = (viewMode)=>viewMode === (0, $fm1RV.views).detail ? 'DETAIL' : 'LIST';
function $f21b08d18b4164ef$export$70573498ee17fe1d(value) {
    return value != null;
}
const $f21b08d18b4164ef$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($f21b08d18b4164ef$export$194f1a1e890054c9(viewId)) // oxlint-disable-next-line typescript/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $f21b08d18b4164ef$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $f21b08d18b4164ef$export$6ce707b3eccb341d = (view)=>view === (0, $fm1RV.views).detail ? 'detail' : 'list_default';
const $f21b08d18b4164ef$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $fm1RV.views).detail : (0, $fm1RV.views).list;
const $f21b08d18b4164ef$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};
function $f21b08d18b4164ef$export$1dde85fc919cd8db({ groupResults: groupResults, issueResults: issueResults }) {
    if (issueResults) return {
        groupResults: null,
        issueResults: issueResults
    };
    if (groupResults) return {
        groupResults: groupResults,
        issueResults: null
    };
    return null;
}

});

parcelRegister("355LU", function(module, exports) {
$parcel$export(module.exports, "getOperationScope", () => $56eaf0cfba9c9f94$export$93ef6e0525bce59d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7l6jM = parcelRequire("7l6jM");
const $56eaf0cfba9c9f94$export$93ef6e0525bce59d = (projectKey)=>{
    let operationScope;
    if (projectKey != null) operationScope = (0, $7l6jM.NIN_PROJECT_OPERATION_SCOPE);
    else operationScope = (0, $7l6jM.NIN_GLOBAL_OPERATION_SCOPE);
    return operationScope;
};

});

parcelRegister("5JR60", function(module, exports) {
$parcel$export(module.exports, "createViewAri", () => $758957f6332616e5$export$8e9e81ca81fb9409);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hOmct = parcelRequire("hOmct");

var $h3LJR = parcelRequire("h3LJR");

var $kt86l = parcelRequire("kt86l");

var $f2wVS = parcelRequire("f2wVS");
const $758957f6332616e5$var$useNavigationItemId = (0, $f2wVS.createRouterSelector)((state)=>state.match?.params?.navigationItemId);
const $758957f6332616e5$export$8e9e81ca81fb9409 = ({ activationId: activationId, cloudId: cloudId, layout: layout, projectId: projectId, viewItemId: viewItemId })=>{
    const layoutPart = layout ? `/layout/${layout}` : '';
    if (projectId) {
        const viewItemIdPart = viewItemId ? `/${viewItemId}` : '';
        return (0, $hOmct.JiraViewAri).create({
            activationId: activationId,
            scopeId: `${projectId}/list${viewItemIdPart}${layoutPart}`,
            scopeType: 'project',
            siteId: cloudId
        }).toString();
    }
    return (0, $hOmct.JiraViewAri).create({
        activationId: activationId,
        scopeId: `issue-navigator${layoutPart}`,
        scopeType: 'global',
        siteId: cloudId
    }).toString();
};
const $758957f6332616e5$export$b6b78fb187396ce9 = ({ layout: layout, projectId: projectId })=>{
    const activationId = (0, $h3LJR.useActivationId)();
    const cloudId = (0, $kt86l.useCloudId)();
    const viewItemId = $758957f6332616e5$var$useNavigationItemId();
    return $758957f6332616e5$export$8e9e81ca81fb9409({
        activationId: activationId,
        cloudId: cloudId,
        layout: layout,
        projectId: projectId,
        viewItemId: viewItemId
    });
};

});

parcelRegister("2BI6B", function(module, exports) {
$parcel$export(module.exports, "getDefaultJqlGin", () => $33d46f261fc0be7e$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $33d46f261fc0be7e$export$ec161d740909e39d);
$parcel$export(module.exports, "getIssueSearchInput", () => $33d46f261fc0be7e$export$7d76295e85a90b29);
$parcel$export(module.exports, "getHydrateJqlInput", () => $33d46f261fc0be7e$export$248650a7f669b084);

var $1zTEC = parcelRequire("1zTEC");

var $i860n = parcelRequire("i860n");

var $fm1RV = parcelRequire("fm1RV");

var $5JR60 = parcelRequire("5JR60");

var $9v1ZM = parcelRequire("9v1ZM");

var $c7zsx = parcelRequire("c7zsx");
const $33d46f261fc0be7e$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $fm1RV.defaultOrderFields).created} ${(0, $fm1RV.sortDirections).DESC}`;
const $33d46f261fc0be7e$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey } = params;
    const { filter: filter, jql: jql, selectedIssue: selectedIssue, groupBy: groupBy, hideDone: hideDone } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $c7zsx.getDefaultJql)(projectKey) : $33d46f261fc0be7e$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: selectedIssue,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql,
        groupBy: groupBy,
        hideDone: hideDone === 'true' || hideDone === 'false' ? hideDone === 'true' : undefined
    };
};
const $33d46f261fc0be7e$var$getJqlOrFilterIdOrNull = (jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $9v1ZM.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $c7zsx.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    return null;
};
const $33d46f261fc0be7e$export$7d76295e85a90b29 = (defaultJql, jqlParam, filter, projectKey)=>{
    // When in project scope fallback to searching by last used JQL, otherwise fallback to default JQL.
    const fallback = projectKey ? {
        searchWithLastUsedJql: true
    } : {
        jql: defaultJql
    };
    // Fallback if neither JQL or valid filter parameters have been provided.
    return $33d46f261fc0be7e$var$getJqlOrFilterIdOrNull(jqlParam, filter, projectKey) ?? fallback;
};
const $33d46f261fc0be7e$export$248650a7f669b084 = ({ activationId: activationId, cloudId: cloudId, defaultJql: defaultJql, jqlParam: jqlParam, filter: filter, projectKey: projectKey, itemId: itemId })=>{
    let fallback;
    if ((0, $i860n.fg)('saved_list_view_technical_changes')) fallback = projectKey ? {
        jiraViewQueryInput: {
            projectKeyAndItemQuery: {
                cloudId: cloudId,
                projectKey: projectKey,
                itemId: itemId ?? 'list'
            }
        }
    } : {
        jiraViewQueryInput: {
            viewId: (0, $5JR60.createViewAri)({
                activationId: activationId,
                cloudId: cloudId
            })
        }
    };
    else // When in project scope fallback to searching by last used JQL, otherwise fallback to default JQL.
    fallback = projectKey ? {
        lastUsedJqlForIssueNavigator: {
            list: {
                operationScope: (0, $fm1RV.NIN_PROJECT_OPERATION_SCOPE),
                projectKey: projectKey
            }
        }
    } : {
        jql: defaultJql
    };
    // Fallback if neither JQL or valid filter parameters have been provided.
    const result = $33d46f261fc0be7e$var$getJqlOrFilterIdOrNull(jqlParam, filter, projectKey) ?? fallback;
    // Hydration API expects filterId in ARI format
    if ('filterId' in result) return {
        filterId: (0, $1zTEC.JiraFilterAri).create({
            siteId: cloudId,
            filterId: result.filterId,
            activationId: activationId
        }).toString()
    };
    return result;
};

});
parcelRegister("c7zsx", function(module, exports) {
$parcel$export(module.exports, "mapFilterToJql", () => $3a42a1e74675b9fa$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $3a42a1e74675b9fa$export$346d50fe8350b1d0);

var $bS1iz = parcelRequire("bS1iz");
const $3a42a1e74675b9fa$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $3a42a1e74675b9fa$var$StatusCategoryValues = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};
const $3a42a1e74675b9fa$var$DEFAULT_SORT_DIRECTION = 'DESC';
const $3a42a1e74675b9fa$var$DEFAULT_ORDER_FIELD = 'created';
const $3a42a1e74675b9fa$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in $3a42a1e74675b9fa$export$92a576f896a9bf72;
const $3a42a1e74675b9fa$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$3a42a1e74675b9fa$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = $3a42a1e74675b9fa$var$DEFAULT_ORDER_FIELD;
    const direction = $3a42a1e74675b9fa$var$DEFAULT_SORT_DIRECTION;
    switch($3a42a1e74675b9fa$export$92a576f896a9bf72[filter]){
        case $3a42a1e74675b9fa$export$92a576f896a9bf72.myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${$3a42a1e74675b9fa$var$StatusCategoryValues.TO_DO}, ${$3a42a1e74675b9fa$var$StatusCategoryValues.IN_PROGRESS})`);
            break;
        case $3a42a1e74675b9fa$export$92a576f896a9bf72.reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case $3a42a1e74675b9fa$export$92a576f896a9bf72.allopenissues:
            clauses.push(`statusCategory IN (${$3a42a1e74675b9fa$var$StatusCategoryValues.TO_DO}, ${$3a42a1e74675b9fa$var$StatusCategoryValues.IN_PROGRESS})`);
            order = 'updated';
            break;
        case $3a42a1e74675b9fa$export$92a576f896a9bf72.doneissues:
            clauses.push(`statusCategory = ${$3a42a1e74675b9fa$var$StatusCategoryValues.DONE}`);
            break;
        case $3a42a1e74675b9fa$export$92a576f896a9bf72.recentlyviewed:
            order = 'lastviewed';
            break;
        case $3a42a1e74675b9fa$export$92a576f896a9bf72.resolvedrecently:
            clauses.push('resolved >= -1w');
            order = 'updated';
            break;
        case $3a42a1e74675b9fa$export$92a576f896a9bf72.updatedrecently:
            order = 'updated';
            break;
        case $3a42a1e74675b9fa$export$92a576f896a9bf72.allissues:
            order = 'created';
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $3a42a1e74675b9fa$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${$3a42a1e74675b9fa$var$DEFAULT_ORDER_FIELD} ${$3a42a1e74675b9fa$var$DEFAULT_SORT_DIRECTION}`;
const $3a42a1e74675b9fa$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $bS1iz.parse)(search),
        ...match && match.params
    });
const $3a42a1e74675b9fa$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});


parcelRegister("bUbdD", function(module, exports) {
$parcel$export(module.exports, "getResourceKey", () => $ed11b9ce7358c679$export$a3430967bdc03d38);
$parcel$export(module.exports, "getIssueSearchResourceKey", () => $ed11b9ce7358c679$export$7c952039f30eae47);

var $f9fMn = parcelRequire("f9fMn");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $9v1ZM = parcelRequire("9v1ZM");
const $ed11b9ce7358c679$export$a3430967bdc03d38 = (baseKey, { match: { params: { projectKey: projectKey } }, query: { filter: filter, jql: jql } })=>{
    if (projectKey) return `${baseKey}-${projectKey}`;
    const filterId = Boolean(filter) && (0, $9v1ZM.isFilterId)(filter) ? filter : null;
    if (filterId) return `${baseKey}-${filterId}`;
    const normalizedJql = (jql ?? '').trim();
    if (normalizedJql && (0, $i860n.fg)('nin_jql_in_route_query_whitelist')) return `${baseKey}-jql-${(0, $f9fMn.sha256)(normalizedJql)}`;
    return baseKey;
};
const $ed11b9ce7358c679$var$getProjectViewResourceKeySuffix = ({ match: { params: { navigationItemId: navigationItemId, projectKey: projectKey } } })=>{
    if (!projectKey || !navigationItemId || !(0, $2700E.expVal)('saved_list_view', 'isEnabled', false)) return '';
    return `-navigation-item-${navigationItemId}`;
};
const $ed11b9ce7358c679$export$7c952039f30eae47 = (routerContext)=>`${$ed11b9ce7358c679$export$a3430967bdc03d38('issue-navigator-relay', routerContext)}${$ed11b9ce7358c679$var$getProjectViewResourceKeySuffix(routerContext)}`;

});
parcelRegister("f9fMn", function(module, exports) {

var $gIMgJ = parcelRequire("gIMgJ");


/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2024
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $gIMgJ === 'object' && $gIMgJ.versions && $gIMgJ.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("5MpFc"));
        var Buffer = (parcelRequire("5MpFc")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >>> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >>> 28 & 0x0F] + HEX_CHARS[h4 >>> 24 & 0x0F] + HEX_CHARS[h4 >>> 20 & 0x0F] + HEX_CHARS[h4 >>> 16 & 0x0F] + HEX_CHARS[h4 >>> 12 & 0x0F] + HEX_CHARS[h4 >>> 8 & 0x0F] + HEX_CHARS[h4 >>> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >>> 28 & 0x0F] + HEX_CHARS[h5 >>> 24 & 0x0F] + HEX_CHARS[h5 >>> 20 & 0x0F] + HEX_CHARS[h5 >>> 16 & 0x0F] + HEX_CHARS[h5 >>> 12 & 0x0F] + HEX_CHARS[h5 >>> 8 & 0x0F] + HEX_CHARS[h5 >>> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >>> 28 & 0x0F] + HEX_CHARS[h6 >>> 24 & 0x0F] + HEX_CHARS[h6 >>> 20 & 0x0F] + HEX_CHARS[h6 >>> 16 & 0x0F] + HEX_CHARS[h6 >>> 12 & 0x0F] + HEX_CHARS[h6 >>> 8 & 0x0F] + HEX_CHARS[h6 >>> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >>> 28 & 0x0F] + HEX_CHARS[h7 >>> 24 & 0x0F] + HEX_CHARS[h7 >>> 20 & 0x0F] + HEX_CHARS[h7 >>> 16 & 0x0F] + HEX_CHARS[h7 >>> 12 & 0x0F] + HEX_CHARS[h7 >>> 8 & 0x0F] + HEX_CHARS[h7 >>> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >>> 24 & 0xFF,
            h0 >>> 16 & 0xFF,
            h0 >>> 8 & 0xFF,
            h0 & 0xFF,
            h1 >>> 24 & 0xFF,
            h1 >>> 16 & 0xFF,
            h1 >>> 8 & 0xFF,
            h1 & 0xFF,
            h2 >>> 24 & 0xFF,
            h2 >>> 16 & 0xFF,
            h2 >>> 8 & 0xFF,
            h2 & 0xFF,
            h3 >>> 24 & 0xFF,
            h3 >>> 16 & 0xFF,
            h3 >>> 8 & 0xFF,
            h3 & 0xFF,
            h4 >>> 24 & 0xFF,
            h4 >>> 16 & 0xFF,
            h4 >>> 8 & 0xFF,
            h4 & 0xFF,
            h5 >>> 24 & 0xFF,
            h5 >>> 16 & 0xFF,
            h5 >>> 8 & 0xFF,
            h5 & 0xFF,
            h6 >>> 24 & 0xFF,
            h6 >>> 16 & 0xFF,
            h6 >>> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >>> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >>> 12;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >>> 18;
                    bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});


parcelRegister("5UWRF", function(module, exports) {
$parcel$export(module.exports, "isChromelessRoute", () => $be5c1a9af02a18f3$export$cc6019019381b4fd);
const $be5c1a9af02a18f3$export$cc6019019381b4fd = ({ route: route })=>{
    return route.layout?.isChromeless ?? false;
};

});


parcelRegister("j9gBV", function(module, exports) {
$parcel$export(module.exports, "default", () => $b26ad40209a40526$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0fc7759b3d2fe84520f7411961647465>>
 * @relayHash 4b88ce8437584874bef00b5e698c7a10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3aae5f48673757995b85e4050688e46ad5baf435efbc45a826ea714a3ada1ec5
const $b26ad40209a40526$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilterRefinementEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scope"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isFilterRefinementEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "assignees",
                                            "value": 50
                                        },
                                        v1 /*: any*/ ,
                                        v2 /*: any*/ 
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "FilterRefinement_query"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isFilterRefinementEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v1 /*: any*/ 
                                    ],
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 50
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "jqlTerm",
                                                    "value": "assignee"
                                                },
                                                v2 /*: any*/ 
                                            ],
                                            "concreteType": "JiraJqlFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldValues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlFieldValueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "appType"
                                                                                        }
                                                                                    ],
                                                                                    "type": "AppUser"
                                                                                },
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlUserFieldValue"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3aae5f48673757995b85e4050688e46ad5baf435efbc45a826ea714a3ada1ec5",
            "metadata": {},
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b26ad40209a40526$var$node.hash = "8fb680426a5ff765df83b3dde9091a09";
var $b26ad40209a40526$export$2e2bcd8739ae039 = $b26ad40209a40526$var$node;

});

parcelRegister("hZR74", function(module, exports) {
$parcel$export(module.exports, "default", () => $226b88ecb591e5e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c37f28c52fea5a5af5618f49bb5fc19a>>
 * @relayHash bae5a36e1ad8b83cd7b85f774b03c878
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d071cfaaac2c3ac80547cc7ed974445b01cf770e4c793bfcb7c2f59f7d3bc89
const $226b88ecb591e5e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_IssueNavigatorIssueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2d071cfaaac2c3ac80547cc7ed974445b01cf770e4c793bfcb7c2f59f7d3bc89",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$226b88ecb591e5e5$var$node.hash = "808bfe366aaf83eaf764cfb82849b76d";
var $226b88ecb591e5e5$export$2e2bcd8739ae039 = $226b88ecb591e5e5$var$node;

});

parcelRegister("3fnQD", function(module, exports) {
$parcel$export(module.exports, "default", () => $429a6f2e51f1ed5d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<73f49c002cf930aa6dc8923ab4ee8f25>>
 * @relayHash cb2187d800d0df064aef2747c5005ce2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 612fd7f260d7c7a965d91f2aa9633d63478b89d92896e9cb8fd3379153d5a6f4

var $i69Qm = parcelRequire("i69Qm");

var $eP1tz = parcelRequire("eP1tz");

var $1D6fx = parcelRequire("1D6fx");

var $KUiqF = parcelRequire("KUiqF");

var $efrbL = parcelRequire("efrbL");

var $aczA0 = parcelRequire("aczA0");

var $7yObX = parcelRequire("7yObX");

var $7e655 = parcelRequire("7e655");

var $7zUJD = parcelRequire("7zUJD");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $gE0jx = parcelRequire("gE0jx");

var $4OQoB = parcelRequire("4OQoB");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $6qLgy = parcelRequire("6qLgy");

var $l4q64 = parcelRequire("l4q64");

var $1ZLvK = parcelRequire("1ZLvK");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $hXLS8 = parcelRequire("hXLS8");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $2XkhF = parcelRequire("2XkhF");

var $gQfDT = parcelRequire("gQfDT");

var $g3vGh = parcelRequire("g3vGh");

var $6VTOd = parcelRequire("6VTOd");

var $6BTmn = parcelRequire("6BTmn");

var $j4Aqb = parcelRequire("j4Aqb");

var $jhYmN = parcelRequire("jhYmN");

var $2Dmyc = parcelRequire("2Dmyc");

var $b3Nht = parcelRequire("b3Nht");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $2JQfe = parcelRequire("2JQfe");

var $5AEuh = parcelRequire("5AEuh");

var $cNoBc = parcelRequire("cNoBc");

var $3vGUX = parcelRequire("3vGUX");

var $aIZjN = parcelRequire("aIZjN");

var $1A1H9 = parcelRequire("1A1H9");

var $lIGkE = parcelRequire("lIGkE");
const $429a6f2e51f1ed5d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dynamicSearchKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraViewQueryInput"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryConditionalFormatting"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryConditionalFormattingFromSavedView"
    }, v23 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v24 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildrenWithCount"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryProject"
    }, v26 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryRankField"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQuerySaveResetViewSettingsButton"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v31 = {
        "kind": "Variable",
        "name": "isConditionalFormattingEnabled",
        "variableName": "shouldQueryConditionalFormatting"
    }, v32 = {
        "kind": "Variable",
        "name": "isSavedViewConditionalFormattingEnabled",
        "variableName": "shouldQueryConditionalFormattingFromSavedView"
    }, v33 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v34 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v35 = [
        v34 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v36 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v37 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v38 = {
        "kind": "Variable",
        "name": "jiraViewQueryInput",
        "variableName": "jiraViewQueryInput"
    }, v39 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v40 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v41 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v42 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v43 = {
        "kind": "ScalarField",
        "name": "message"
    }, v44 = [
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v41 /*: any*/ ,
                v42 /*: any*/ 
            ]
        },
        v43 /*: any*/ 
    ], v45 = {
        "kind": "ScalarField",
        "name": "id"
    }, v46 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v47 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v48 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v47 /*: any*/ 
    ], v49 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v50 = {
        "kind": "ScalarField",
        "name": "savedViewId"
    }, v51 = {
        "args": [
            v40 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "isViewConfigModified"
    }, v52 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v53 = [
        v52 /*: any*/ ,
        v37 /*: any*/ ,
        v40 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v54 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v55 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v57 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v58 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v59 = {
        "kind": "ClientExtension",
        "selections": [
            v58 /*: any*/ 
        ]
    }, v60 = {
        "kind": "Variable",
        "name": "saveJQLToUserHistory",
        "variableName": "saveJQLToUserHistory"
    }, v61 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v62 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v63 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v64 = {
        "kind": "ScalarField",
        "name": "type"
    }, v65 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v66 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v67 = {
        "kind": "ScalarField",
        "name": "aliases"
    }, v68 = {
        "kind": "ScalarField",
        "name": "value"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ ,
            {
                "alias": "singleValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            },
            v68 /*: any*/ 
        ],
        "type": "JiraFormattingSingleValueOperand"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ ,
            {
                "alias": "multipleValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            },
            {
                "kind": "ScalarField",
                "name": "values"
            }
        ],
        "type": "JiraFormattingMultipleValueOperand"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ ,
            {
                "alias": "noValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            }
        ],
        "type": "JiraFormattingNoValueOperand"
    }, v72 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v69 /*: any*/ ,
            v70 /*: any*/ ,
            v71 /*: any*/ 
        ]
    }, v73 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v74 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v75 = [
        {
            "concreteType": "JiraFormattingRuleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraFormattingRule",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v72 /*: any*/ ,
                        v73 /*: any*/ ,
                        {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                                v45 /*: any*/ ,
                                v74 /*: any*/ 
                            ]
                        },
                        v45 /*: any*/ 
                    ]
                }
            ]
        }
    ], v76 = [
        v74 /*: any*/ ,
        v45 /*: any*/ 
    ], v77 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "formattingColor",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v78 = {
        "kind": "ScalarField",
        "name": "name"
    }, v79 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v80 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v81 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v82 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v83 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v84 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v85 = [
        v79 /*: any*/ ,
        v80 /*: any*/ ,
        v81 /*: any*/ ,
        v82 /*: any*/ ,
        v37 /*: any*/ ,
        v83 /*: any*/ ,
        v84 /*: any*/ ,
        v60 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v86 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v87 = {
        "kind": "ScalarField",
        "name": "key"
    }, v88 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v89 = [
        v78 /*: any*/ ,
        v45 /*: any*/ 
    ], v90 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v91 = {
        "kind": "ScalarField",
        "name": "text"
    }, v92 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v93 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isUser"
    }, v94 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appType"
            }
        ],
        "type": "AppUser"
    }, v95 = [
        v93 /*: any*/ ,
        v94 /*: any*/ 
    ], v96 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v97 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v98 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v97 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            v98 /*: any*/ 
        ],
        "type": "JiraStatusCategoryField"
    }, v100 = {
        "concreteType": "JiraIssueEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            v86 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v41 /*: any*/ ,
                    v45 /*: any*/ ,
                    v87 /*: any*/ ,
                    v88 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": v89 /*: any*/ 
                                    },
                                    v45 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "args": v90 /*: any*/ ,
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v54 /*: any*/ ,
                                                            v41 /*: any*/ ,
                                                            v64 /*: any*/ ,
                                                            v45 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v91 /*: any*/ ,
                                                                    v78 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v78 /*: any*/ ,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v41 /*: any*/ ,
                                                                            v78 /*: any*/ ,
                                                                            v92 /*: any*/ ,
                                                                            v45 /*: any*/ ,
                                                                            {
                                                                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": v95 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v78 /*: any*/ ,
                                                                            v96 /*: any*/ ,
                                                                            v45 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            v99 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldSets(first:500)"
            },
            v41 /*: any*/ 
        ]
    }, v101 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v102 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v103 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v101 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v102 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v104 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            }
        ]
    }, v105 = [
        {
            "kind": "Literal",
            "name": "maxCursors",
            "value": 7
        }
    ], v106 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v107 = [
        v106 /*: any*/ 
    ], v108 = {
        "args": v105 /*: any*/ ,
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v107 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v107 /*: any*/ 
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v109 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v110 = [
        v43 /*: any*/ 
    ], v111 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v43 /*: any*/ ,
                    v61 /*: any*/ 
                ],
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": v110 /*: any*/ ,
                "type": "JiraServerError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v43 /*: any*/ ,
                    v42 /*: any*/ 
                ],
                "type": "JiraInvalidIssueSearchInputError"
            }
        ]
    }, v112 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v113 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v114 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v115 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v114 /*: any*/ ,
                    v45 /*: any*/ ,
                    v78 /*: any*/ ,
                    v96 /*: any*/ 
                ]
            },
            v45 /*: any*/ 
        ]
    }, v116 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraListRow"
    }, v117 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v98 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v118 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v117 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v119 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v120 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v121 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v122 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "resolutionPlanAssigneeProperty",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "jsm_resolution_plan_property"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "issuePropertyByKey",
                        "storageKey": "issuePropertyByKey(key:\"jsm_resolution_plan_property\")"
                    },
                    {
                        "concreteType": "JiraProjectField",
                        "kind": "LinkedField",
                        "name": "projectField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    v120 /*: any*/ ,
                                    v45 /*: any*/ 
                                ]
                            },
                            v45 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "delegator",
                        "plural": false,
                        "selections": [
                            v41 /*: any*/ ,
                            v78 /*: any*/ ,
                            v121 /*: any*/ ,
                            v92 /*: any*/ ,
                            v45 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v123 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v59 /*: any*/ 
                        ],
                        "type": "JiraListRow",
                        "abstractKey": "__isJiraListRow"
                    },
                    v122 /*: any*/ ,
                    v59 /*: any*/ 
                ],
                "type": "JiraIssue"
            }
        ]
    }, v124 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v122 /*: any*/ 
                ],
                "type": "JiraIssue"
            }
        ]
    }, v125 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isHighlightedIssueRow"
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    }, v126 = {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v113 /*: any*/ ,
            v115 /*: any*/ ,
            v116 /*: any*/ ,
            v118 /*: any*/ ,
            v119 /*: any*/ ,
            v123 /*: any*/ ,
            v59 /*: any*/ ,
            v124 /*: any*/ ,
            v125 /*: any*/ 
        ]
    }, v127 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraListRowEdge"
    }, v128 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraListRowFieldSetConnection"
    }, v129 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraListRowFieldSet"
    }, v130 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v131 = {
        "kind": "ClientExtension",
        "selections": [
            v130 /*: any*/ 
        ]
    }, v132 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v78 /*: any*/ ,
                                    v45 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v133 = [
        v68 /*: any*/ ,
        v45 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v134 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v133 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v133 /*: any*/ 
                    }
                ]
            },
            v131 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v135 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
                    }
                ],
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": v110 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v136 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v137 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v138 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v139 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "args": v136 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v137 /*: any*/ ,
                                    v138 /*: any*/ ,
                                    v45 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v131 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v140 = {
        "kind": "ScalarField",
        "name": "date"
    }, v141 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v142 = {
        "kind": "InlineFragment",
        "selections": [
            v140 /*: any*/ ,
            v78 /*: any*/ ,
            v141 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v143 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v144 = {
        "kind": "InlineFragment",
        "selections": [
            v143 /*: any*/ ,
            v78 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v145 = {
        "kind": "ScalarField",
        "name": "formattedText"
    }, v146 = {
        "kind": "ScalarField",
        "name": "number"
    }, v147 = [
        v78 /*: any*/ 
    ], v148 = {
        "concreteType": "JiraLabelEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraLabel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v147 /*: any*/ 
            }
        ]
    }, v149 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v150 = [
        v41 /*: any*/ ,
        v121 /*: any*/ ,
        v78 /*: any*/ ,
        v92 /*: any*/ ,
        v45 /*: any*/ 
    ], v151 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v143 /*: any*/ ,
                    v145 /*: any*/ 
                ],
                "type": "JiraForgeDatetimeField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v140 /*: any*/ ,
                    v145 /*: any*/ 
                ],
                "type": "JiraForgeDateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v146 /*: any*/ ,
                    v145 /*: any*/ 
                ],
                "type": "JiraForgeNumberField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v91 /*: any*/ ,
                    v145 /*: any*/ 
                ],
                "type": "JiraForgeStringField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v145 /*: any*/ ,
                    {
                        "args": v136 /*: any*/ ,
                        "concreteType": "JiraLabelConnection",
                        "kind": "LinkedField",
                        "name": "selectedLabelsConnection",
                        "plural": false,
                        "selections": [
                            v63 /*: any*/ ,
                            v148 /*: any*/ 
                        ],
                        "storageKey": "selectedLabelsConnection(first:1000)"
                    }
                ],
                "type": "JiraForgeStringsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v145 /*: any*/ ,
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "selectedGroup",
                        "plural": false,
                        "selections": v89 /*: any*/ 
                    }
                ],
                "type": "JiraForgeGroupField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v145 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v149 /*: any*/ ,
                                            v78 /*: any*/ ,
                                            v45 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraForgeGroupsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v145 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": v150 /*: any*/ 
                    }
                ],
                "type": "JiraForgeUserField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v145 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v150 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraForgeUsersField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v145 /*: any*/ 
                ],
                "type": "JiraForgeObjectField"
            }
        ]
    }, v152 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "start"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "end"
                    }
                ],
                "type": "JiraDateRangeField"
            }
        ]
    }, v153 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v154 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v155 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v78 /*: any*/ ,
                    v154 /*: any*/ ,
                    v98 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            },
            v59 /*: any*/ 
        ],
        "type": "JiraStatusField"
    }, v156 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategoryProgressConnection",
                "kind": "LinkedField",
                "name": "aggregatedStatusCategory",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraStatusCategoryProgressEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraStatusCategoryProgress",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v87 /*: any*/ ,
                                            v45 /*: any*/ 
                                        ]
                                    },
                                    v68 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAggregatedStatusField"
    }, v157 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v158 = [
        v78 /*: any*/ ,
        v157 /*: any*/ 
    ], v159 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v136 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v158 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v78 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v160 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v161 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v162 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v163 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v87 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v157 /*: any*/ ,
                            v45 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v160 /*: any*/ ,
                                    v78 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    v161 /*: any*/ ,
                                    v114 /*: any*/ 
                                ]
                            },
                            v45 /*: any*/ ,
                            v54 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v91 /*: any*/ ,
                            v45 /*: any*/ ,
                            v54 /*: any*/ 
                        ]
                    },
                    v45 /*: any*/ ,
                    v113 /*: any*/ ,
                    v162 /*: any*/ ,
                    {
                        "concreteType": "JiraStatusField",
                        "kind": "LinkedField",
                        "name": "statusField",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v54 /*: any*/ ,
                            v117 /*: any*/ 
                        ]
                    }
                ]
            },
            v78 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraParentIssueField"
    }, v164 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v165 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v78 /*: any*/ ,
                    v164 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            },
            v78 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v166 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v78 /*: any*/ ,
                    v87 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v167 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v89 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v168 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v169 = {
        "kind": "ScalarField",
        "name": "state"
    }, v170 = [
        v45 /*: any*/ ,
        v168 /*: any*/ ,
        v78 /*: any*/ ,
        v169 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v171 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v170 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v78 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v172 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v173 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v95 /*: any*/ 
    }, v174 = [
        {
            "concreteType": "JiraAdfToConvertedPlainText",
            "kind": "LinkedField",
            "name": "convertedPlainText",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "plainText"
                }
            ]
        }
    ], v175 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v174 /*: any*/ 
                    },
                    {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraADF",
                                "kind": "LinkedField",
                                "name": "adfValue",
                                "plural": false,
                                "selections": v174 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v176 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v78 /*: any*/ ,
                    v160 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v177 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementOrganizationConnection",
                "kind": "LinkedField",
                "name": "selectedOrganizationsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraServiceManagementOrganizationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraServiceManagementOrganization",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "organizationName"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraServiceManagementOrganizationField"
    }, v178 = {
        "kind": "Literal",
        "name": "first",
        "value": 50
    }, v179 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    v178 /*: any*/ 
                ],
                "concreteType": "JiraAgentSessionConnection",
                "kind": "LinkedField",
                "name": "agentSessions",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    {
                        "concreteType": "JiraAgentSessionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAgentSession",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v41 /*: any*/ ,
                                    v169 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "agent",
                                        "plural": false,
                                        "selections": [
                                            v41 /*: any*/ ,
                                            v78 /*: any*/ ,
                                            v93 /*: any*/ ,
                                            v92 /*: any*/ ,
                                            v94 /*: any*/ ,
                                            v45 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "agentSessions(first:50)"
            }
        ],
        "type": "JiraAgentSessionsField"
    }, v180 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v162 /*: any*/ ,
                                            v87 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v41 /*: any*/ ,
                                                                    v99 /*: any*/ ,
                                                                    v45 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            {
                                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    v88 /*: any*/ 
                                                ]
                                            },
                                            v45 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v45 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v181 = {
        "kind": "ScalarField",
        "name": "formatStyle"
    }, v182 = {
        "kind": "ScalarField",
        "name": "formatUnit"
    }, v183 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v146 /*: any*/ ,
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    v181 /*: any*/ ,
                    v182 /*: any*/ 
                ]
            },
            v78 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v184 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v63 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v185 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v131 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v186 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v187 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v68 /*: any*/ ,
                    v157 /*: any*/ ,
                    v45 /*: any*/ ,
                    v186 /*: any*/ 
                ]
            },
            v131 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v188 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v68 /*: any*/ ,
                                    v186 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v131 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v189 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v68 /*: any*/ 
        ]
    }, v190 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v189 /*: any*/ 
                        ]
                    }
                ]
            },
            v131 /*: any*/ 
        ],
        "type": "JiraCheckboxesField"
    }, v191 = {
        "concreteType": "JiraUserConnection",
        "kind": "LinkedField",
        "name": "selectedUsersConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v41 /*: any*/ ,
                            v121 /*: any*/ ,
                            v78 /*: any*/ ,
                            v92 /*: any*/ ,
                            v45 /*: any*/ ,
                            v172 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "email"
                                    }
                                ],
                                "type": "AtlassianAccountUser"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v192 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            v191 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v193 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v131 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v194 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTimeTrackingField",
                        "kind": "LinkedField",
                        "name": "timeTrackingField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "timeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingHoursPerDay"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingDaysPerWeek"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultFormat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultUnit"
                                    }
                                ]
                            },
                            v45 /*: any*/ ,
                            v54 /*: any*/ ,
                            v78 /*: any*/ ,
                            v64 /*: any*/ 
                        ]
                    },
                    v45 /*: any*/ 
                ]
            },
            v131 /*: any*/ 
        ],
        "type": "JiraOriginalTimeEstimateField"
    }, v195 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v196 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    v195 /*: any*/ ,
                    v45 /*: any*/ ,
                    v137 /*: any*/ 
                ]
            },
            v131 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v197 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v198 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "args": v136 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v78 /*: any*/ ,
                                    v137 /*: any*/ ,
                                    v138 /*: any*/ ,
                                    v197 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v131 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v199 = [
        v45 /*: any*/ 
    ], v200 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v199 /*: any*/ 
    }, v201 = {
        "kind": "ScalarField",
        "name": "status"
    }, v202 = [
        {
            "kind": "ScalarField",
            "name": "isPrivate"
        }
    ], v203 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            v200 /*: any*/ ,
            {
                "args": v136 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v87 /*: any*/ ,
                                    v78 /*: any*/ ,
                                    v201 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": v202 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v58 /*: any*/ ,
                    v130 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v204 = {
        "kind": "ScalarField",
        "name": "privateProject"
    }, v205 = {
        "kind": "ScalarField",
        "name": "hasPermission"
    }, v206 = {
        "kind": "ScalarField",
        "name": "isWorkspaceActive"
    }, v207 = {
        "kind": "ScalarField",
        "name": "iconName"
    }, v208 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v78 /*: any*/ ,
                    v200 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isLinkEditable"
                    },
                    {
                        "concreteType": "JiraTownsquareProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            {
                                "alias": "atlasProjectName",
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "alias": "atlasProjectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            v204 /*: any*/ ,
                            v205 /*: any*/ ,
                            v206 /*: any*/ ,
                            v207 /*: any*/ 
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isLinkInherited"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isParentLinked"
                            }
                        ]
                    },
                    v131 /*: any*/ 
                ],
                "type": "JiraTownsquareProjectField"
            }
        ]
    }, v209 = {
        "kind": "ScalarField",
        "name": "href"
    }, v210 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "args": v136 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v209 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    v41 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v209 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v63 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v131 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v211 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v78 /*: any*/ ,
                                    v149 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v131 /*: any*/ 
        ],
        "type": "JiraMultipleGroupPickerField"
    }, v212 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraFlag",
                "kind": "LinkedField",
                "name": "flag",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFlagged"
                    }
                ]
            }
        ],
        "type": "JiraFlagField"
    }, v213 = {
        "kind": "ScalarField",
        "name": "count"
    }, v214 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraWatch",
                "kind": "LinkedField",
                "name": "watch",
                "plural": false,
                "selections": [
                    v213 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isWatching"
                    }
                ]
            }
        ],
        "type": "JiraWatchesField"
    }, v215 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v78 /*: any*/ ,
                    v146 /*: any*/ ,
                    {
                        "concreteType": "JiraNumberFieldFormatConfig",
                        "kind": "LinkedField",
                        "name": "formatConfig",
                        "plural": false,
                        "selections": [
                            v181 /*: any*/ ,
                            v182 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "durationUnits"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraNumberFormulaField"
            }
        ]
    }, v216 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v78 /*: any*/ ,
                    v91 /*: any*/ 
                ],
                "type": "JiraTextFormulaField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v143 /*: any*/ ,
                    v78 /*: any*/ 
                ],
                "type": "JiraDateFormulaField"
            }
        ]
    }, v217 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v78 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isMulti"
                    },
                    v191 /*: any*/ ,
                    v131 /*: any*/ 
                ],
                "type": "JiraPeopleField"
            }
        ]
    }, v218 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v157 /*: any*/ 
                ],
                "type": "JiraColorField"
            }
        ]
    }, v219 = [
        v213 /*: any*/ 
    ], v220 = {
        "kind": "ScalarField",
        "name": "stateCount"
    }, v221 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueDevSummary",
                "kind": "LinkedField",
                "name": "devSummary",
                "plural": false,
                "selections": [
                    v41 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "branch",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueBranchDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": v219 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "commit",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueCommitDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": v219 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "pullrequest",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssuePullRequestDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                    v220 /*: any*/ ,
                                    v169 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "open"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "review",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueReviewDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                    v220 /*: any*/ ,
                                    v169 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "build",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueBuildDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                    v213 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "failedBuildCount"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "successfulBuildCount"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "unknownBuildCount"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "deploymentEnvironments",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": v219 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    v113 /*: any*/ ,
                    v87 /*: any*/ ,
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": v199 /*: any*/ 
                    },
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraDevSummaryField"
    }, v222 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "durationInSeconds"
            },
            v91 /*: any*/ 
        ],
        "type": "JiraDurationField"
    }, v223 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementFeedback",
                "kind": "LinkedField",
                "name": "feedback",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "rating"
                    }
                ]
            }
        ],
        "type": "JiraServiceManagementRequestFeedbackField"
    }, v224 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementSla",
                "kind": "LinkedField",
                "name": "sla",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraServiceManagementSlaError",
                        "kind": "LinkedField",
                        "name": "error",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "errorCode"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "goalId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "timeMetricId"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraServiceManagementSlaGoalView",
                        "kind": "LinkedField",
                        "name": "goalView",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "paused"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "active"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "closed"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "failed"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "emergencyLevel"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "remainingTime"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraServiceManagementSlaField"
    }, v225 = [
        v91 /*: any*/ 
    ], v226 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": v225 /*: any*/ ,
                        "type": "JiraRemoteSingleLineTextField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "avatarUrl"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "issueTypeName"
                            }
                        ],
                        "type": "JiraRemoteIssueTypeField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "priorityName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "priorityIconUrl"
                            }
                        ],
                        "type": "JiraRemotePriorityField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "userDisplayName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "avatarSmall"
                            }
                        ],
                        "type": "JiraRemoteSingleSelectUserPickerField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v154 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "statusName"
                            },
                            v97 /*: any*/ 
                        ],
                        "type": "JiraRemoteStatusField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v147 /*: any*/ ,
                        "type": "JiraRemoteGenericField"
                    }
                ],
                "type": "JiraRemoteIssueField",
                "abstractKey": "__isJiraRemoteIssueField"
            }
        ]
    }, v227 = {
        "kind": "InlineFragment",
        "selections": [
            v143 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v228 = {
        "kind": "InlineFragment",
        "selections": [
            v91 /*: any*/ ,
            v78 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v229 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v78 /*: any*/ ,
                    v97 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v230 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v96 /*: any*/ ,
                    v78 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v231 = {
        "kind": "InlineFragment",
        "selections": [
            v78 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v41 /*: any*/ ,
                    v78 /*: any*/ ,
                    v92 /*: any*/ ,
                    v172 /*: any*/ ,
                    v45 /*: any*/ ,
                    v121 /*: any*/ ,
                    v173 /*: any*/ ,
                    v94 /*: any*/ 
                ]
            },
            v141 /*: any*/ ,
            v131 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v232 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v78 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v132 /*: any*/ ,
                            v179 /*: any*/ ,
                            v134 /*: any*/ ,
                            v135 /*: any*/ ,
                            v139 /*: any*/ ,
                            v142 /*: any*/ ,
                            v227 /*: any*/ ,
                            v142 /*: any*/ ,
                            v151 /*: any*/ ,
                            v144 /*: any*/ ,
                            v216 /*: any*/ ,
                            v152 /*: any*/ ,
                            v153 /*: any*/ ,
                            v228 /*: any*/ ,
                            v229 /*: any*/ ,
                            v155 /*: any*/ ,
                            v156 /*: any*/ ,
                            v159 /*: any*/ ,
                            v230 /*: any*/ ,
                            v163 /*: any*/ ,
                            v165 /*: any*/ ,
                            v166 /*: any*/ ,
                            v167 /*: any*/ ,
                            v171 /*: any*/ ,
                            v231 /*: any*/ ,
                            v175 /*: any*/ ,
                            v176 /*: any*/ ,
                            v177 /*: any*/ ,
                            v180 /*: any*/ ,
                            v183 /*: any*/ ,
                            v184 /*: any*/ ,
                            v185 /*: any*/ ,
                            v187 /*: any*/ ,
                            v188 /*: any*/ ,
                            v190 /*: any*/ ,
                            v192 /*: any*/ ,
                            v193 /*: any*/ ,
                            v194 /*: any*/ ,
                            v196 /*: any*/ ,
                            v198 /*: any*/ ,
                            v203 /*: any*/ ,
                            v208 /*: any*/ ,
                            v210 /*: any*/ ,
                            v211 /*: any*/ ,
                            v212 /*: any*/ ,
                            v214 /*: any*/ ,
                            v215 /*: any*/ ,
                            v217 /*: any*/ ,
                            v218 /*: any*/ ,
                            v221 /*: any*/ ,
                            v222 /*: any*/ ,
                            v223 /*: any*/ ,
                            v224 /*: any*/ 
                        ],
                        "type": "JiraIssueField",
                        "abstractKey": "__isJiraIssueField"
                    }
                ]
            }
        ]
    }, v233 = [
        v140 /*: any*/ 
    ], v234 = [
        v146 /*: any*/ 
    ], v235 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v236 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v237 = [
        v197 /*: any*/ ,
        v45 /*: any*/ 
    ], v238 = [
        v41 /*: any*/ ,
        v45 /*: any*/ 
    ], v239 = {
        "args": v90 /*: any*/ ,
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v128 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v41 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v41 /*: any*/ ,
                            v64 /*: any*/ ,
                            v49 /*: any*/ ,
                            v129 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    v41 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v41 /*: any*/ ,
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v131 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            }
                                                        ],
                                                        "type": "JiraIssueField",
                                                        "abstractKey": "__isJiraIssueField"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v132 /*: any*/ ,
                                                                    v134 /*: any*/ ,
                                                                    v135 /*: any*/ ,
                                                                    v139 /*: any*/ ,
                                                                    v142 /*: any*/ ,
                                                                    v144 /*: any*/ ,
                                                                    v151 /*: any*/ ,
                                                                    v152 /*: any*/ ,
                                                                    v153 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraStatusCategory",
                                                                                "kind": "LinkedField",
                                                                                "name": "statusCategory",
                                                                                "plural": false,
                                                                                "selections": v147 /*: any*/ 
                                                                            }
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v155 /*: any*/ ,
                                                                    v156 /*: any*/ ,
                                                                    v159 /*: any*/ ,
                                                                    v163 /*: any*/ ,
                                                                    v165 /*: any*/ ,
                                                                    v166 /*: any*/ ,
                                                                    v167 /*: any*/ ,
                                                                    v171 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "user",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v172 /*: any*/ ,
                                                                                    v121 /*: any*/ ,
                                                                                    v173 /*: any*/ ,
                                                                                    v94 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v141 /*: any*/ ,
                                                                            v131 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                    },
                                                                    v175 /*: any*/ ,
                                                                    v176 /*: any*/ ,
                                                                    v177 /*: any*/ ,
                                                                    v179 /*: any*/ ,
                                                                    v180 /*: any*/ ,
                                                                    v183 /*: any*/ ,
                                                                    v184 /*: any*/ ,
                                                                    v185 /*: any*/ ,
                                                                    v187 /*: any*/ ,
                                                                    v188 /*: any*/ ,
                                                                    v190 /*: any*/ ,
                                                                    v192 /*: any*/ ,
                                                                    v193 /*: any*/ ,
                                                                    v194 /*: any*/ ,
                                                                    v196 /*: any*/ ,
                                                                    v198 /*: any*/ ,
                                                                    v203 /*: any*/ ,
                                                                    v208 /*: any*/ ,
                                                                    v210 /*: any*/ ,
                                                                    v211 /*: any*/ ,
                                                                    v212 /*: any*/ ,
                                                                    v214 /*: any*/ ,
                                                                    v215 /*: any*/ ,
                                                                    v216 /*: any*/ ,
                                                                    v217 /*: any*/ ,
                                                                    v218 /*: any*/ ,
                                                                    v221 /*: any*/ ,
                                                                    v222 /*: any*/ ,
                                                                    v223 /*: any*/ ,
                                                                    v224 /*: any*/ 
                                                                ],
                                                                "type": "JiraIssueField",
                                                                "abstractKey": "__isJiraIssueField"
                                                            }
                                                        ]
                                                    },
                                                    v226 /*: any*/ ,
                                                    v59 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v189 /*: any*/ ,
                                                                            v59 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "fieldOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    v186 /*: any*/ ,
                                                                    v45 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    }
                                                ]
                                            },
                                            v232 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isJiraListRowFieldConnection"
                                    }
                                ]
                            },
                            v59 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "shouldQueryConditionalFormatting",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v136 /*: any*/ ,
                                                                        "concreteType": "JiraComponentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedComponentsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponent",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "componentId"
                                                                                            },
                                                                                            v45 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v136 /*: any*/ ,
                                                                        "concreteType": "JiraLabelConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedLabelsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v148 /*: any*/ 
                                                                        ],
                                                                        "storageKey": "selectedLabelsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraLabelsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v121 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedUsersConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraUserEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v41 /*: any*/ ,
                                                                                            v121 /*: any*/ ,
                                                                                            v45 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v233 /*: any*/ ,
                                                                "type": "JiraDatePickerField"
                                                            },
                                                            v227 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v234 /*: any*/ ,
                                                                "type": "JiraNumberField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v235 /*: any*/ ,
                                                                            v45 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraPriorityField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v236 /*: any*/ ,
                                                                            v45 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraProjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedSprintsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprintEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraSprint",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v168 /*: any*/ ,
                                                                                            v45 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSprintField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "version",
                                                                        "plural": false,
                                                                        "selections": v237 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraSingleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v161 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v154 /*: any*/ ,
                                                                            v45 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraStatusField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v136 /*: any*/ ,
                                                                        "concreteType": "JiraVersionConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedVersionsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersionEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraVersion",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v237 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedVersionsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValue",
                                                                        "plural": false,
                                                                        "selections": v238 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSelectableValueEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v238 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v195 /*: any*/ ,
                                                                            v45 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraRadioSelectField"
                                                            },
                                                            {
                                                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v234 /*: any*/ ,
                                                                        "type": "JiraNumberFormulaField"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v225 /*: any*/ ,
                                                                        "type": "JiraTextFormulaField"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v233 /*: any*/ ,
                                                                        "type": "JiraDateFormulaField"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v240 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v241 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v242 = [
        v86 /*: any*/ ,
        v241 /*: any*/ 
    ], v243 = {
        "args": v105 /*: any*/ ,
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v86 /*: any*/ ,
                    v106 /*: any*/ ,
                    v241 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v242 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v242 /*: any*/ 
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v244 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v119 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v245 = {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueSearchWarning",
                "kind": "LinkedField",
                "name": "searchWarnings",
                "plural": true,
                "selections": v110 /*: any*/ 
            }
        ]
    }, v246 = [
        "scope"
    ], v247 = {
        "kind": "Variable",
        "name": "__dynamicKey",
        "variableName": "dynamicSearchKey"
    }, v248 = [
        {
            "kind": "ScalarField",
            "name": "defaultJql"
        }
    ], v249 = [
        v79 /*: any*/ ,
        v80 /*: any*/ ,
        v82 /*: any*/ ,
        v52 /*: any*/ ,
        v37 /*: any*/ ,
        v83 /*: any*/ ,
        v60 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v250 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v251 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v252 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v66 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v235 /*: any*/ ,
                            v78 /*: any*/ ,
                            v164 /*: any*/ 
                        ]
                    },
                    v65 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v41 /*: any*/ ,
                            v45 /*: any*/ ,
                            v121 /*: any*/ ,
                            v78 /*: any*/ ,
                            v92 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v95 /*: any*/ 
                            }
                        ]
                    },
                    v65 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v78 /*: any*/ ,
                            {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v97 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v65 /*: any*/ ,
                    v98 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": v234 /*: any*/ ,
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v186 /*: any*/ ,
                            v68 /*: any*/ ,
                            v157 /*: any*/ 
                        ]
                    },
                    v65 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v170 /*: any*/ 
                    },
                    v65 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": v158 /*: any*/ 
                    }
                ],
                "type": "JiraJqlLabelFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v149 /*: any*/ ,
                            v78 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlGroupFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v197 /*: any*/ ,
                            v78 /*: any*/ 
                        ]
                    },
                    v65 /*: any*/ 
                ],
                "type": "JiraJqlVersionFieldValue"
            },
            {
                "condition": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraTownsquareProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v87 /*: any*/ ,
                                    v78 /*: any*/ ,
                                    v204 /*: any*/ ,
                                    v205 /*: any*/ ,
                                    v207 /*: any*/ ,
                                    v206 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlTownsquareProjectFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v65 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "rangeStart"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rangeEnd"
                    }
                ],
                "type": "JiraJqlDateBucketFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v65 /*: any*/ ,
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v87 /*: any*/ ,
                            v78 /*: any*/ ,
                            v201 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            },
                            {
                                "condition": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v202 /*: any*/ 
                            }
                        ]
                    }
                ],
                "type": "JiraJqlGoalsFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraTownsquareProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v87 /*: any*/ ,
                            v204 /*: any*/ ,
                            v205 /*: any*/ ,
                            v78 /*: any*/ ,
                            v207 /*: any*/ ,
                            v169 /*: any*/ ,
                            v206 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "dueDate"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "owner",
                                        "plural": false,
                                        "selections": [
                                            v41 /*: any*/ ,
                                            v78 /*: any*/ ,
                                            v92 /*: any*/ ,
                                            v45 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraJqlTownsquareProjectFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueTypes",
                        "plural": true,
                        "selections": [
                            v78 /*: any*/ ,
                            v96 /*: any*/ ,
                            v45 /*: any*/ ,
                            v161 /*: any*/ ,
                            v114 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlIssueTypeFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v65 /*: any*/ ,
                    {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "resolution",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v78 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlResolutionFieldValue"
            }
        ]
    }, v253 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v254 = [
        v81 /*: any*/ ,
        v178 /*: any*/ ,
        v37 /*: any*/ ,
        v47 /*: any*/ ,
        v40 /*: any*/ ,
        v253 /*: any*/ 
    ], v255 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "filterByProjectKeys.0",
                    "variableName": "projectKey"
                }
            ],
            "kind": "ListValue",
            "name": "filterByProjectKeys"
        }
    ], v256 = [
        v33 /*: any*/ 
    ], v257 = {
        "condition": "shouldQueryHasChildren",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": v255 /*: any*/ ,
                "kind": "ScalarField",
                "name": "hasChildren"
            },
            {
                "alias": "canHaveChildIssuesWithOldCondition",
                "args": v256 /*: any*/ ,
                "kind": "ScalarField",
                "name": "canHaveChildIssues"
            }
        ]
    }, v258 = {
        "condition": "shouldQueryHasChildrenWithCount",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": v255 /*: any*/ ,
                "concreteType": "JiraIssueEdgeChildIssuesInfo",
                "kind": "LinkedField",
                "name": "childIssuesInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "childrenCount"
                    }
                ]
            },
            {
                "args": v256 /*: any*/ ,
                "kind": "ScalarField",
                "name": "canHaveChildIssues"
            }
        ]
    }, v259 = [
        v79 /*: any*/ ,
        v80 /*: any*/ ,
        v81 /*: any*/ ,
        v82 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v83 /*: any*/ ,
        v84 /*: any*/ ,
        v60 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v253 /*: any*/ 
    ], v260 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v34 /*: any*/ 
    ], v261 = [
        v34 /*: any*/ 
    ], v262 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "args": [
                        v31 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ ,
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys.0",
                                    "variableName": "projectKey"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildrenWithCount",
                            "variableName": "shouldQueryHasChildrenWithCount"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_IssueNavigatorIssueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "shouldQueryRankField",
                                    "variableName": "shouldQueryRankField"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_IssueNavigatorIssueNavigator_IssueNavigator_jira"
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v35 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ 
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "IssueNavigatorUIComponent_project_jiraProject"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "IssueSearch_issueNavigatorProject"
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v36 /*: any*/ ,
                                                            "kind": "FragmentSpread",
                                                            "name": "ConditionalFormattingInner"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ConditionalFormattingSidebarContainer_project"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v12 /*: any*/ ,
                v9 /*: any*/ ,
                v14 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v15 /*: any*/ ,
                v30 /*: any*/ ,
                v16 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v17 /*: any*/ ,
                v25 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v27 /*: any*/ ,
                v11 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v19 /*: any*/ ,
                v10 /*: any*/ ,
                v26 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v20 /*: any*/ ,
                v18 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsJSCExpandAllChangesEnabledRelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v34 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                v39 /*: any*/ ,
                                v40 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "viewConfigInput",
                                    "variableName": "staticViewInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "jiraIssueSearchView",
                            "plural": false,
                            "selections": [
                                v41 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraView"
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": v44 /*: any*/ 
                                },
                                v45 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v46 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v48 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v49 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isFrozen"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQuerySaveResetViewSettingsButton",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPublishViewConfig"
                                                },
                                                v50 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v53 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v55 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                v57 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v59 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v37 /*: any*/ ,
                                                        v60 /*: any*/ ,
                                                        v39 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraJqlValidationResult",
                                                    "kind": "LinkedField",
                                                    "name": "validateJql",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "extensions",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v41 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v42 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v50 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v53 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isGroupingEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canEnableGrouping"
                                                },
                                                v55 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                v56 /*: any*/ ,
                                                v62 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": [
                                                        v47 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v48 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v63 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v64 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v65 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        v54 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v59 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v51 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v53 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v57 /*: any*/ ,
                                                                v62 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                v55 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canEnableReranking"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": v36 /*: any*/ ,
                                                                    "concreteType": "JiraFormattingRuleConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "conditionalFormattingRules",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v75 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v59 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v50 /*: any*/ ,
                                                {
                                                    "args": v36 /*: any*/ ,
                                                    "concreteType": "JiraFormattingRuleConnection",
                                                    "kind": "LinkedField",
                                                    "name": "conditionalFormattingRules",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRuleEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "expression",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                v70 /*: any*/ ,
                                                                                v69 /*: any*/ ,
                                                                                v71 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v77 /*: any*/ ,
                                                                        v73 /*: any*/ 
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ]
                                                        },
                                                        v59 /*: any*/ 
                                                    ],
                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                },
                                                v59 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v46 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "filterId"
                                                        },
                                                        {
                                                            "args": v53 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v78 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "typeKey"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ],
                                            "type": "JiraView",
                                            "abstractKey": "__isJiraView"
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v85 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                v100 /*: any*/ ,
                                                v103 /*: any*/ ,
                                                v104 /*: any*/ ,
                                                v108 /*: any*/ ,
                                                v109 /*: any*/ ,
                                                v111 /*: any*/ ,
                                                v112 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v126 /*: any*/ ,
                                                                v127 /*: any*/ ,
                                                                v239 /*: any*/ ,
                                                                v59 /*: any*/ 
                                                            ]
                                                        },
                                                        v46 /*: any*/ ,
                                                        v240 /*: any*/ ,
                                                        v243 /*: any*/ ,
                                                        v59 /*: any*/ 
                                                    ],
                                                    "type": "JiraListRowConnection",
                                                    "abstractKey": "__isJiraListRowConnection"
                                                },
                                                v244 /*: any*/ ,
                                                v59 /*: any*/ ,
                                                v245 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v85 /*: any*/ ,
                                            "filters": v246 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues",
                                            "dynamicKey": v247 /*: any*/ 
                                        }
                                    ],
                                    "type": "JiraDetailedView"
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v248 /*: any*/ ,
                                            "type": "JiraDetailedView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v248 /*: any*/ ,
                                            "type": "JiraGroupedListView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v248 /*: any*/ ,
                                            "type": "JiraListView"
                                        }
                                    ]
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v249 /*: any*/ ,
                                            "concreteType": "JiraSpreadsheetGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "groups",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v86 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                v250 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v54 /*: any*/ ,
                                                                v251 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                v252 /*: any*/ 
                                                            ]
                                                        },
                                                        v41 /*: any*/ 
                                                    ]
                                                },
                                                v103 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "groupByField"
                                                },
                                                v46 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v44 /*: any*/ 
                                                },
                                                {
                                                    "condition": "isPaginating",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "firstGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "alias": "issuesWithIssueSearchInput",
                                                                    "args": v254 /*: any*/ ,
                                                                    "concreteType": "JiraIssueConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                v86 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v238 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "args": v90 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSets",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fields",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                v41 /*: any*/ ,
                                                                                                                                v64 /*: any*/ ,
                                                                                                                                v45 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "fieldSets(first:500)"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "PageInfo",
                                                                            "kind": "LinkedField",
                                                                            "name": "pageInfo",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v101 /*: any*/ ,
                                                                                v102 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v109 /*: any*/ ,
                                                                                v112 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v113 /*: any*/ ,
                                                                                                v87 /*: any*/ ,
                                                                                                v115 /*: any*/ ,
                                                                                                v116 /*: any*/ ,
                                                                                                v88 /*: any*/ ,
                                                                                                v118 /*: any*/ ,
                                                                                                v119 /*: any*/ ,
                                                                                                v123 /*: any*/ ,
                                                                                                v59 /*: any*/ ,
                                                                                                v124 /*: any*/ ,
                                                                                                v125 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v127 /*: any*/ ,
                                                                                        {
                                                                                            "args": v90 /*: any*/ ,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldSets",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v41 /*: any*/ ,
                                                                                                v128 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v41 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v41 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v49 /*: any*/ ,
                                                                                                                v129 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fields",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v41 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                v41 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v228 /*: any*/ ,
                                                                                                                                                v230 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueField",
                                                                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v132 /*: any*/ ,
                                                                                                                                                        v134 /*: any*/ ,
                                                                                                                                                        v135 /*: any*/ ,
                                                                                                                                                        v139 /*: any*/ ,
                                                                                                                                                        v142 /*: any*/ ,
                                                                                                                                                        v144 /*: any*/ ,
                                                                                                                                                        v151 /*: any*/ ,
                                                                                                                                                        v152 /*: any*/ ,
                                                                                                                                                        v153 /*: any*/ ,
                                                                                                                                                        v229 /*: any*/ ,
                                                                                                                                                        v155 /*: any*/ ,
                                                                                                                                                        v156 /*: any*/ ,
                                                                                                                                                        v159 /*: any*/ ,
                                                                                                                                                        v163 /*: any*/ ,
                                                                                                                                                        v165 /*: any*/ ,
                                                                                                                                                        v166 /*: any*/ ,
                                                                                                                                                        v167 /*: any*/ ,
                                                                                                                                                        v171 /*: any*/ ,
                                                                                                                                                        v231 /*: any*/ ,
                                                                                                                                                        v175 /*: any*/ ,
                                                                                                                                                        v176 /*: any*/ ,
                                                                                                                                                        v177 /*: any*/ ,
                                                                                                                                                        v179 /*: any*/ ,
                                                                                                                                                        v180 /*: any*/ ,
                                                                                                                                                        v183 /*: any*/ ,
                                                                                                                                                        v184 /*: any*/ ,
                                                                                                                                                        v185 /*: any*/ ,
                                                                                                                                                        v187 /*: any*/ ,
                                                                                                                                                        v188 /*: any*/ ,
                                                                                                                                                        v190 /*: any*/ ,
                                                                                                                                                        v192 /*: any*/ ,
                                                                                                                                                        v193 /*: any*/ ,
                                                                                                                                                        v194 /*: any*/ ,
                                                                                                                                                        v196 /*: any*/ ,
                                                                                                                                                        v198 /*: any*/ ,
                                                                                                                                                        v203 /*: any*/ ,
                                                                                                                                                        v208 /*: any*/ ,
                                                                                                                                                        v210 /*: any*/ ,
                                                                                                                                                        v211 /*: any*/ ,
                                                                                                                                                        v212 /*: any*/ ,
                                                                                                                                                        v214 /*: any*/ ,
                                                                                                                                                        v215 /*: any*/ ,
                                                                                                                                                        v216 /*: any*/ ,
                                                                                                                                                        v217 /*: any*/ ,
                                                                                                                                                        v218 /*: any*/ ,
                                                                                                                                                        v221 /*: any*/ ,
                                                                                                                                                        v222 /*: any*/ ,
                                                                                                                                                        v223 /*: any*/ ,
                                                                                                                                                        v224 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueField",
                                                                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v226 /*: any*/ ,
                                                                                                                                        v59 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v232 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldSets(first:500)"
                                                                                        },
                                                                                        v257 /*: any*/ ,
                                                                                        v258 /*: any*/ ,
                                                                                        v59 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v59 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraListRowConnection",
                                                                            "abstractKey": "__isJiraListRowConnection"
                                                                        },
                                                                        v59 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "alias": "issuesWithIssueSearchInput",
                                                                    "args": v254 /*: any*/ ,
                                                                    "filters": [
                                                                        "viewConfigInput",
                                                                        "fieldSetsInput",
                                                                        "scope",
                                                                        "settings",
                                                                        "issueSearchInput"
                                                                    ],
                                                                    "handle": "connection",
                                                                    "key": "firstGroupSection_nativeIssueTable__issuesWithIssueSearchInput",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "issues"
                                                                },
                                                                v46 /*: any*/ ,
                                                                v54 /*: any*/ ,
                                                                v251 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                v252 /*: any*/ ,
                                                                v250 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "firstGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": "issuesWithIssueSearchInput",
                                                                            "args": v254 /*: any*/ ,
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v113 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v59 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v249 /*: any*/ ,
                                            "filters": v246 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                                            "kind": "LinkedHandle",
                                            "name": "groups",
                                            "dynamicKey": v247 /*: any*/ 
                                        }
                                    ],
                                    "type": "JiraGroupedListView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v259 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                v100 /*: any*/ ,
                                                v103 /*: any*/ ,
                                                v104 /*: any*/ ,
                                                v108 /*: any*/ ,
                                                v109 /*: any*/ ,
                                                v111 /*: any*/ ,
                                                v112 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v126 /*: any*/ ,
                                                                v127 /*: any*/ ,
                                                                v239 /*: any*/ ,
                                                                v258 /*: any*/ ,
                                                                v257 /*: any*/ ,
                                                                v59 /*: any*/ 
                                                            ]
                                                        },
                                                        v46 /*: any*/ ,
                                                        v240 /*: any*/ ,
                                                        v243 /*: any*/ ,
                                                        v59 /*: any*/ 
                                                    ],
                                                    "type": "JiraListRowConnection",
                                                    "abstractKey": "__isJiraListRowConnection"
                                                },
                                                v244 /*: any*/ ,
                                                v59 /*: any*/ ,
                                                v245 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v259 /*: any*/ ,
                                            "filters": v246 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorJiraListViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues",
                                            "dynamicKey": v247 /*: any*/ 
                                        }
                                    ],
                                    "type": "JiraListView"
                                }
                            ]
                        },
                        {
                            "args": v260 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v261 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                v59 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                }
                            ]
                        },
                        {
                            "args": v260 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v41 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        },
                        {
                            "args": v261 /*: any*/ ,
                            "concreteType": "JiraJqlFieldWithAliases",
                            "kind": "LinkedField",
                            "name": "rankField",
                            "plural": false,
                            "selections": [
                                v54 /*: any*/ ,
                                v66 /*: any*/ ,
                                v67 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v35 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v87 /*: any*/ ,
                                        v236 /*: any*/ ,
                                        {
                                            "alias": "editIssues",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "EDIT_ISSUES"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": v262 /*: any*/ ,
                                            "storageKey": "action(type:\"EDIT_ISSUES\")"
                                        },
                                        {
                                            "alias": "createIssues",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "CREATE_ISSUES"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": v262 /*: any*/ ,
                                            "storageKey": "action(type:\"CREATE_ISSUES\")"
                                        },
                                        v120 /*: any*/ ,
                                        v45 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "allowLocalFields"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v36 /*: any*/ ,
                                                            "concreteType": "JiraFormattingRuleConnection",
                                                            "kind": "LinkedField",
                                                            "name": "conditionalFormattingRules",
                                                            "plural": false,
                                                            "selections": v75 /*: any*/ ,
                                                            "storageKey": "conditionalFormattingRules(first:20)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v36 /*: any*/ ,
                                                            "concreteType": "JiraFormattingRuleConnection",
                                                            "kind": "LinkedField",
                                                            "name": "conditionalFormattingRules",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRuleEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFormattingRule",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v45 /*: any*/ ,
                                                                                v77 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                v72 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v41 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "conditionalFormattingRules(first:20)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": v147 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "612fd7f260d7c7a965d91f2aa9633d63478b89d92896e9cb8fd3379153d5a6f4",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $g3vGh.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider": (0, $3vGUX.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider": (0, $gQfDT.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $2XkhF.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider": (0, $5AEuh.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider": (0, $j4Aqb.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled": (0, $6VTOd.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider": (0, $6qLgy.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": (0, $2Dmyc.default),
                "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider": (0, $eP1tz.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default),
                "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider": (0, $i69Qm.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider": (0, $4OQoB.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsJSCExpandAllChangesEnabledRelayprovider": (0, $aczA0.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": (0, $hXLS8.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": (0, $efrbL.default)
            }
        }
    };
}();
$429a6f2e51f1ed5d$var$node.hash = "e145ed16d65bc2f06f9bb966f9bcbb46";
(0, $lIGkE.PreloadableQueryRegistry).set($429a6f2e51f1ed5d$var$node.params.id, $429a6f2e51f1ed5d$var$node);
var $429a6f2e51f1ed5d$export$2e2bcd8739ae039 = $429a6f2e51f1ed5d$var$node;

});
parcelRegister("hXLS8", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e36844e052ba6c3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $6e36844e052ba6c3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jira_paid_list_nin_merge_onboarding_modal');
    }
};

});

parcelRegister("gQfDT", function(module, exports) {
$parcel$export(module.exports, "default", () => $139c07b304d264f1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
var $139c07b304d264f1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $2700E.expVal)('saved_list_view', 'isEnabled', false);
    }
};

});

parcelRegister("6VTOd", function(module, exports) {
$parcel$export(module.exports, "default", () => $61600063d96504e5$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $61600063d96504e5$var$isIssueSearchWarningsEnabled = {
    get () {
        return (0, $2700E.expVal)('jira_issue_search_warnings_banner_nin', 'isEnabled', false);
    }
};
var $61600063d96504e5$export$2e2bcd8739ae039 = $61600063d96504e5$var$isIssueSearchWarningsEnabled;

});

parcelRegister("j4Aqb", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b840a97b162b0c4$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $7b840a97b162b0c4$var$isNinIssuePreviewPanelChangeboardingEnabledRelayProvider = {
    get () {
        return (0, $i860n.fg)('nin_issue_preview_panel_changeboarding');
    }
};
var $7b840a97b162b0c4$export$2e2bcd8739ae039 = $7b840a97b162b0c4$var$isNinIssuePreviewPanelChangeboardingEnabledRelayProvider;

});

parcelRegister("2Dmyc", function(module, exports) {
$parcel$export(module.exports, "default", () => $279de380d097fe7d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $279de380d097fe7d$var$JiraAiAgentAvatarSingleUserPickerNINRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira_ai_agent_avatar_single_user_picker_nin');
    }
};
var $279de380d097fe7d$export$2e2bcd8739ae039 = $279de380d097fe7d$var$JiraAiAgentAvatarSingleUserPickerNINRelayProvider;

});

parcelRegister("5AEuh", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3cdc73f63593ee8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $e3cdc73f63593ee8$var$NINDecoupledJqlValidationFieldRelayProvider = {
    get () {
        return (0, $i860n.fg)('nin_decoupled_jql_validation_field');
    }
};
var $e3cdc73f63593ee8$export$2e2bcd8739ae039 = $e3cdc73f63593ee8$var$NINDecoupledJqlValidationFieldRelayProvider;

});

parcelRegister("3vGUX", function(module, exports) {
$parcel$export(module.exports, "default", () => $546176c6aa6267a7$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $546176c6aa6267a7$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('pnin_jql_order_by_rank_enabled_fg');
    }
};

});


parcelRegister("h8SYr", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $058a9c9edf11d92c$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $058a9c9edf11d92c$export$b99d8b4e19091835);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", () => $058a9c9edf11d92c$export$1b65799bbeba8a33);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY", () => $058a9c9edf11d92c$export$2609791ed67e6247);
/* eslint-disable jira/filename-case */ const $058a9c9edf11d92c$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $058a9c9edf11d92c$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $058a9c9edf11d92c$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
const $058a9c9edf11d92c$export$2609791ed67e6247 = 'ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY';
const $058a9c9edf11d92c$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $058a9c9edf11d92c$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});


parcelRegister("fPXVF", function(module, exports) {
$parcel$export(module.exports, "getIssueAppResources", () => $51036cc52c624557$export$c698d36360f30dcd);
/* eslint-disable import/order */ 
var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $ldGfw = parcelRequire("ldGfw");

var $fBZs7 = parcelRequire("fBZs7");

var $lTgGU = parcelRequire("lTgGU");
const $51036cc52c624557$export$c698d36360f30dcd = ()=>{
    const issueAppResources = [];
    if ((0, $2700E.expVal)('nin_glance_panel', 'isEnabled', false) || (0, $i860n.fg)('nin_issue_app_conditional_entrypoint')) {
        issueAppResources.push((0, $fBZs7.issueViewRelayResource));
        if (!(0, $i860n.fg)('remove-issueviewinteractivequery-m4')) issueAppResources.push((0, $lTgGU.issueGiraDataResource));
    }
    if ((0, $i860n.fg)('nin_glance_panel_technical_changes') || (0, $i860n.fg)('nin_common_issue_view_resources')) issueAppResources.push(...(0, $ldGfw.getIssueViewResources)());
    return issueAppResources;
};

});


parcelRegister("31tCE", function(module, exports) {
$parcel$export(module.exports, "getRouteReporting", () => $523f28422b57effb$export$1300cb25a03c28fe);
const $523f28422b57effb$export$1300cb25a03c28fe = ()=>({
        id: 'issue-navigator',
        packageName: 'issueNavigator',
        teamName: 'empanada'
    });

});

parcelRegister("5E19W", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b0a6603ebc17f70$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");

var $bc9Gj = parcelRequire("bc9Gj");
const $1b0a6603ebc17f70$var$GinBrowseIssuesRedirect = ()=>{
    const [{ match: match }] = (0, $bc9Gj.useRouter)();
    const issueKey = match.params.issueKey ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: `/issues/${issueKey}`
    });
};
$1b0a6603ebc17f70$var$GinBrowseIssuesRedirect.displayName = "GinBrowseIssuesRedirect";
var $1b0a6603ebc17f70$export$2e2bcd8739ae039 = $1b0a6603ebc17f70$var$GinBrowseIssuesRedirect;

});

parcelRegister("2A6mK", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorPageEntryPoint", () => $3b310416a28c5e3c$export$b1fc7a6fa07a8b5c);
$parcel$export(module.exports, "globalIssueNavigatorPageEntryPointWithoutPreviewPanel", () => $3b310416a28c5e3c$export$540a81ca2bf61ee2);
$parcel$export(module.exports, "issueNavigatorPageEntryPoint", () => $3b310416a28c5e3c$export$b75ca1c5551bc52f);
$parcel$export(module.exports, "issueNavigatorPageEntryPointWithoutPreviewPanel", () => $3b310416a28c5e3c$export$2de4dd98d0deb5b6);
$parcel$export(module.exports, "issueNavigatorPageEntryPointWithNested", () => $3b310416a28c5e3c$export$6f6d14ffd6415d3f);
$parcel$export(module.exports, "issueNavigatorPageEntryPointWithNestedWithoutPreviewPanel", () => $3b310416a28c5e3c$export$8d28ff4215ed9c04);
$parcel$export(module.exports, "GSNIssueNavigatorPageEntryPointWithNested", () => $3b310416a28c5e3c$export$f4d61362588b64c6);
$parcel$export(module.exports, "GSNIssueNavigatorPageEntryPointWithNestedWithoutPreviewPanel", () => $3b310416a28c5e3c$export$9c8b5e6fbae4657e);
$parcel$export(module.exports, "issueNavigatorWithoutHorizontalNavPageEntryPoint", () => $3b310416a28c5e3c$export$ebe022658b1c5d7a);
$parcel$export(module.exports, "issueNavigatorWithoutHorizontalNavPageEntryPointWithoutPreviewPanel", () => $3b310416a28c5e3c$export$558c40e7311b7dc4);
$parcel$export(module.exports, "issueNavigatorPinRedirectPageEntryPoint", () => $3b310416a28c5e3c$export$a90e8f2ed95763c3);
$parcel$export(module.exports, "issueNavigatorPinRedirectPageEntryPointWithoutPreviewPanel", () => $3b310416a28c5e3c$export$87628e55c86a09e1);
$parcel$export(module.exports, "issueNavigatorEmbedPageEntryPoint", () => $3b310416a28c5e3c$export$650aa18210eea5a8);
$parcel$export(module.exports, "LazyGlobalIssueNavigator", () => $3b310416a28c5e3c$export$8ff267588532c2ce);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $hZ8FS = parcelRequire("hZ8FS");

var $dhdPt = parcelRequire("dhdPt");

var $kmFG6 = parcelRequire("kmFG6");

var $l8G1z = parcelRequire("l8G1z");

var $3KSG6 = parcelRequire("3KSG6");

var $dTa0V = parcelRequire("dTa0V");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");

var $7dBr9 = parcelRequire("7dBr9");

var $c5j2J = parcelRequire("c5j2J");
const $3b310416a28c5e3c$export$b1fc7a6fa07a8b5c = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kmFG6.globalIssueNavigatorEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint),
    previewPanel: (0, $7dBr9.issuePreviewPanelEntryPoint)
});
const $3b310416a28c5e3c$export$540a81ca2bf61ee2 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kmFG6.globalIssueNavigatorEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $3b310416a28c5e3c$export$b75ca1c5551bc52f = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hZ8FS.issueNavigatorEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    previewPanel: (0, $7dBr9.issuePreviewPanelEntryPoint)
});
const $3b310416a28c5e3c$export$2de4dd98d0deb5b6 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hZ8FS.issueNavigatorEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $3b310416a28c5e3c$export$6f6d14ffd6415d3f = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hZ8FS.issueNavigatorEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    previewPanel: (0, $7dBr9.issuePreviewPanelEntryPoint)
});
const $3b310416a28c5e3c$export$8d28ff4215ed9c04 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hZ8FS.issueNavigatorEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $3b310416a28c5e3c$export$f4d61362588b64c6 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hZ8FS.issueNavigatorEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    previewPanel: (0, $7dBr9.issuePreviewPanelEntryPoint)
});
const $3b310416a28c5e3c$export$9c8b5e6fbae4657e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hZ8FS.issueNavigatorEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $3b310416a28c5e3c$export$ebe022658b1c5d7a = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hZ8FS.issueNavigatorEntrypoint),
    previewPanel: (0, $7dBr9.issuePreviewPanelEntryPoint)
});
const $3b310416a28c5e3c$export$558c40e7311b7dc4 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hZ8FS.issueNavigatorEntrypoint)
});
const $3b310416a28c5e3c$export$a90e8f2ed95763c3 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $c5j2J.issueNavigatorPinRedirectEntrypoint),
    previewPanel: (0, $7dBr9.issuePreviewPanelEntryPoint)
});
const $3b310416a28c5e3c$export$87628e55c86a09e1 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $c5j2J.issueNavigatorPinRedirectEntrypoint)
});
const $3b310416a28c5e3c$export$650aa18210eea5a8 = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $dhdPt.issueNavigatorEmbedEntrypoint)
});

const $3b310416a28c5e3c$export$8ff267588532c2ce = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("6v6QL")), {
    moduleId: "./src/packages/spa-apps/issue-navigator-global-issue-navigator/src/GlobalIssueNavigatorSPAMemo.tsx"
});

});
parcelRegister("hZ8FS", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorEntrypoint", () => $0f307a76e643833e$export$4ec136b0c737540b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $2QOmj = parcelRequire("2QOmj");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $kIYP9 = parcelRequire("kIYP9");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $cBqij = parcelRequire("cBqij");
const $0f307a76e643833e$var$PROJECT_ISSUE_NAVIGATOR_METRIC_INTERACTION_KEY = 'project-issue-navigator';
// Matches only plain objects: arrays, `null`, `Date`, `RegExp`, functions, and
// primitives are all excluded, so the `Record<string, unknown>` narrowing
// reflects the exact set of runtime values that reach the property access below.
const $0f307a76e643833e$var$isRecord = (value)=>Object.prototype.toString.call(value) === '[object Object]';
/**
 * Safely resolves the scroll element height calibration for a route from an
 * untrusted experiment value. Returns `undefined` (so the prop is omitted and
 * the Issue Table uses its built-in fallback) unless the value is a plain object
 * keyed by route name whose entry has finite numeric `scrollElementHeight` and
 * `viewportHeightOverhead`.
 */ const $0f307a76e643833e$var$getScrollElementHeightCalibration = (calibration, routeName)=>{
    if (!$0f307a76e643833e$var$isRecord(calibration)) return undefined;
    const entry = calibration[routeName];
    if (!$0f307a76e643833e$var$isRecord(entry)) return undefined;
    const { scrollElementHeight: scrollElementHeight, viewportHeightOverhead: viewportHeightOverhead } = entry;
    if (typeof scrollElementHeight !== 'number' || !Number.isFinite(scrollElementHeight) || typeof viewportHeightOverhead !== 'number' || !Number.isFinite(viewportHeightOverhead)) return undefined;
    return {
        scrollElementHeight: scrollElementHeight,
        viewportHeightOverhead: viewportHeightOverhead
    };
};

const $0f307a76e643833e$export$4ec136b0c737540b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hgCoY")), {
        moduleId: "d8e441ea",
        moduleName: "ProjectIssueNavigatorSPA",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.query?.selectedIssue;
        let preloadProps = {};
        // exclude nativeIssueTableEntryPoint and jqlBuilderWithAiEntryPoint from preloading on the issue route
        if (!issueKey || (0, $2700E.expVal)('nin_glance_panel', 'isEnabled', false)) preloadProps = {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $kIYP9.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...(0, $i860n.fg)('jql_builder_basic_ssr_stability_fixes') ? {
                    jqlBuilderWithAiEntryPoint: {
                        entryPoint: (0, $cBqij.jqlBuilderWithAiEntryPoint),
                        entryPointParams: entryPointParams
                    }
                } : {}
            }
        };
        else if (issueKey && /* eslint-disable jira/ff/no-work-item-modernization-exp-val -- Existing WIM rollout check; migrate to isWorkItemModernizationGatesEnabled. */ !((0, $2700E.expVal)('work_item_modernization', 'isEnabled', false) || (0, $i860n.fg)('enable_work_item_for_quadratic_release')) && /* eslint-enable jira/ff/no-work-item-modernization-exp-val */ (0, $i860n.fg)('nin_issue_app_conditional_entrypoint')) preloadProps = {
            entryPoints: {
                issueAppEntryPoint: {
                    entryPoint: (0, $2QOmj.issueAppEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
        // Per-route scroll element height calibration is delivered via the
        // `issue_table_virtualizer_dynamic_estimators` experiment's `calibration`
        // parameter, a `Record<routeName, ScrollElementHeightCalibration>`. The
        // experiment value is untrusted (it comes from remote config), so it is read
        // loosely and validated before use: the route's entry must be an object with
        // numeric `scrollElementHeight` and `viewportHeightOverhead`. When the route
        // has no valid entry the prop is omitted and the Issue Table falls back to its
        // built-in default.
        const scrollElementHeightCalibration = (0, $2700E.expVal)('issue_table_virtualizer_dynamic_estimators', 'isEnabled', false) ? $0f307a76e643833e$var$getScrollElementHeightCalibration((0, $2700E.expVal)('issue_table_virtualizer_dynamic_estimators', 'calibration', null), entryPointParams.context.route.name) : undefined;
        return {
            ...preloadProps,
            extraProps: {
                metricInteractionKey: $0f307a76e643833e$var$PROJECT_ISSUE_NAVIGATOR_METRIC_INTERACTION_KEY,
                ...scrollElementHeightCalibration ? {
                    scrollElementHeightCalibration: scrollElementHeightCalibration
                } : {}
            }
        };
    }
});

});
parcelRegister("2QOmj", function(module, exports) {
$parcel$export(module.exports, "issueAppEntryPoint", () => $23ef19ca9525b7fa$export$a10254225794f6e2);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $fiVog = parcelRequire("fiVog");

var $b3tU7 = parcelRequire("b3tU7");

var $i860n = parcelRequire("i860n");
const $23ef19ca9525b7fa$var$EMPTY_OBJECT = {};

const $23ef19ca9525b7fa$export$a10254225794f6e2 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("16SfS")), {
        moduleId: "9d86746c",
        moduleName: "IssueAppEntrypoint",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>(0, $i860n.fg)('nike-react-compiler-nin-transition-fixes') ? $23ef19ca9525b7fa$var$EMPTY_OBJECT : {}
});

});

parcelRegister("cBqij", function(module, exports) {
$parcel$export(module.exports, "jqlBuilderWithAiEntryPoint", () => $cb3eabede35caf7e$export$43f8e092231523ab);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $cb3eabede35caf7e$export$43f8e092231523ab = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("c2Ymq")), {
        moduleId: "8a7e19d5",
        moduleName: "JQLBuilderWithAIEntryPoint",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("c2Ymq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("11S5H")
]).then(()=>parcelRequire('gH7IY'));

});


parcelRegister("hgCoY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    $4cvLQ("lJdI1")
]).then(()=>parcelRequire('bVxG4'));

});


parcelRegister("dhdPt", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorEmbedEntrypoint", () => $52374539189b42f1$export$407d940f927eac56);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $kIYP9 = parcelRequire("kIYP9");

const $52374539189b42f1$export$407d940f927eac56 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("CMsDQ")), {
        moduleId: "697de78c",
        moduleName: "IssueNavigatorEmbedSPAMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $kIYP9.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("CMsDQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    $4cvLQ("99djY")
]).then(()=>parcelRequire('jPgPT'));

});


parcelRegister("kmFG6", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorEntryPoint", () => $43a27732d9198bf2$export$79ac0647e40ae809);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $2QOmj = parcelRequire("2QOmj");

var $kIYP9 = parcelRequire("kIYP9");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $cBqij = parcelRequire("cBqij");
// Matches only plain objects: arrays, `null`, `Date`, `RegExp`, functions, and
// primitives are all excluded, so the `Record<string, unknown>` narrowing
// reflects the exact set of runtime values that reach the property access below.
const $43a27732d9198bf2$var$isRecord = (value)=>Object.prototype.toString.call(value) === '[object Object]';
/**
 * Safely resolves the scroll element height calibration for a route from an
 * untrusted experiment value. Returns `undefined` (so the prop is omitted and
 * the Issue Table uses its built-in fallback) unless the value is a plain object
 * keyed by route name whose entry has finite numeric `scrollElementHeight` and
 * `viewportHeightOverhead`.
 */ const $43a27732d9198bf2$var$getScrollElementHeightCalibration = (calibration, routeName)=>{
    if (!$43a27732d9198bf2$var$isRecord(calibration)) return undefined;
    const entry = calibration[routeName];
    if (!$43a27732d9198bf2$var$isRecord(entry)) return undefined;
    const { scrollElementHeight: scrollElementHeight, viewportHeightOverhead: viewportHeightOverhead } = entry;
    if (typeof scrollElementHeight !== 'number' || !Number.isFinite(scrollElementHeight) || typeof viewportHeightOverhead !== 'number' || !Number.isFinite(viewportHeightOverhead)) return undefined;
    return {
        scrollElementHeight: scrollElementHeight,
        viewportHeightOverhead: viewportHeightOverhead
    };
};

const $43a27732d9198bf2$export$79ac0647e40ae809 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("6v6QL")), {
        moduleId: "60a80a32",
        moduleName: "GlobalIssueNavigatorSPAMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        let issueKey = entryPointParams?.context?.match?.params?.issueKey;
        // current prod bug workaround: issueKey is always undefined since issueKey is passed in as selectedIssue from query param
        if ((0, $i860n.fg)('nin_issue_app_conditional_entrypoint')) issueKey = entryPointParams?.context?.query?.selectedIssue;
        let preloadProps = {};
        // exclude nativeIssueTableEntryPoint and jqlBuilderWithAiEntryPoint from preloading on the issue route unless glance panel is enabled
        if (!issueKey || (0, $2700E.expVal)('nin_glance_panel', 'isEnabled', false)) preloadProps = {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $kIYP9.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...(0, $i860n.fg)('jql_builder_basic_ssr_stability_fixes') ? {
                    jqlBuilderWithAiEntryPoint: {
                        entryPoint: (0, $cBqij.jqlBuilderWithAiEntryPoint),
                        entryPointParams: entryPointParams
                    }
                } : {}
            }
        };
        else if (issueKey && /* eslint-disable jira/ff/no-work-item-modernization-exp-val -- Existing WIM rollout check; migrate to isWorkItemModernizationGatesEnabled. */ !((0, $2700E.expVal)('work_item_modernization', 'isEnabled', false) || (0, $i860n.fg)('enable_work_item_for_quadratic_release')) && /* eslint-enable jira/ff/no-work-item-modernization-exp-val */ (0, $i860n.fg)('nin_issue_app_conditional_entrypoint')) preloadProps = {
            entryPoints: {
                issueAppEntryPoint: {
                    entryPoint: (0, $2QOmj.issueAppEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
        // Per-route scroll element height calibration is delivered via the
        // `issue_table_virtualizer_dynamic_estimators` experiment's `calibration`
        // parameter, a `Record<routeName, ScrollElementHeightCalibration>`. The
        // experiment value is untrusted (it comes from remote config), so it is read
        // loosely and validated before use: the route's entry must be an object with
        // numeric `scrollElementHeight` and `viewportHeightOverhead`. When the route
        // has no valid entry the prop is omitted and the Issue Table falls back to its
        // built-in default.
        const scrollElementHeightCalibration = (0, $2700E.expVal)('issue_table_virtualizer_dynamic_estimators', 'isEnabled', false) ? $43a27732d9198bf2$var$getScrollElementHeightCalibration((0, $2700E.expVal)('issue_table_virtualizer_dynamic_estimators', 'calibration', null), entryPointParams.context.route.name) : undefined;
        return {
            ...preloadProps,
            ...scrollElementHeightCalibration ? {
                extraProps: {
                    scrollElementHeightCalibration: scrollElementHeightCalibration
                }
            } : {}
        };
    }
});

});
parcelRegister("6v6QL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    $4cvLQ("ae8Bl")
]).then(()=>parcelRequire('hC3bf'));

});


parcelRegister("7dBr9", function(module, exports) {
$parcel$export(module.exports, "issuePreviewPanelEntryPoint", () => $0f01db427148a6ed$export$eed8eaeb69adf40c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $2QOmj = parcelRequire("2QOmj");

var $fiVog = parcelRequire("fiVog");

var $b3tU7 = parcelRequire("b3tU7");

const $0f01db427148a6ed$export$eed8eaeb69adf40c = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("b3UKg")), {
        moduleId: "76f242b5",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                issueAppEntryPoint: {
                    entryPoint: (0, $2QOmj.issueAppEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("b3UKg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("kNfCv")
]).then(()=>parcelRequire('1oueY'));

});


parcelRegister("c5j2J", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorPinRedirectEntrypoint", () => $147905dbff818905$export$cc17cd3f65b3828f);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $147905dbff818905$export$cc17cd3f65b3828f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jz2ig")), {
        moduleId: "21dc3a59",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jz2ig", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ayKev").then(()=>parcelRequire('2bxJF'));

});




parcelRegister("98WKd", function(module, exports) {
$parcel$export(module.exports, "globalMailSettingsRouteEntry", () => $17c691e3edbdf494$export$5e1236665a530df4);



var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $4Oj6z = parcelRequire("4Oj6z");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $khy5y = parcelRequire("khy5y");

var $6zqoy = parcelRequire("6zqoy");

var $Ftdrj = parcelRequire("Ftdrj");
const $17c691e3edbdf494$export$5e1236665a530df4 = (0, $fdS54.createEntry)((0, $khy5y.globalMailSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.global-mail-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4Oj6z.default)(()=>true, (0, $Ftdrj.default), (0, $6zqoy.default)),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $Ftdrj.LazyGlobalMailSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("khy5y", function(module, exports) {
$parcel$export(module.exports, "globalMailSettingsRoute", () => $95f1f5f9626e71c9$export$e69b84daf70501b3);
const $95f1f5f9626e71c9$export$e69b84daf70501b3 = {
    name: 'global-mail-settings',
    path: '/secure/admin/global-mail-settings',
    exact: true
};

});

parcelRegister("6zqoy", function(module, exports) {
$parcel$export(module.exports, "default", () => $308ee37ee11cc3df$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $iKpxC = parcelRequire("iKpxC");
/** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
const $308ee37ee11cc3df$var$RedirectToLegacyRoutingWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iKpxC.default), null);
$308ee37ee11cc3df$var$RedirectToLegacyRoutingWrapper.displayName = "RedirectToLegacyRoutingWrapper";
var $308ee37ee11cc3df$export$2e2bcd8739ae039 = $308ee37ee11cc3df$var$RedirectToLegacyRoutingWrapper;

});
parcelRegister("iKpxC", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e98a2addb49a2c7$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $1uH7N = parcelRequire("1uH7N");

var $kTviw = parcelRequire("kTviw");

var $6PF9P = parcelRequire("6PF9P");

var $6CfY5 = parcelRequire("6CfY5");

var $5Ez9w = parcelRequire("5Ez9w");

var $6bEm8 = parcelRequire("6bEm8");

var $aJ81Y = parcelRequire("aJ81Y");

var $e2Tle = parcelRequire("e2Tle");

var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");

var $g2dvj = parcelRequire("g2dvj");
const $1e98a2addb49a2c7$var$THRESHOLD = 30000;
const $1e98a2addb49a2c7$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
class $1e98a2addb49a2c7$export$836fe1ef2cfde075 extends (0, $euxye.Component) {
    componentDidMount() {
        // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
        (0, $1uH7N.di)(sessionStorage, window);
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = (0, $i860n.fg)('jfp-vulcan-browser-storage-migration') ? Number((0, $4fPPi.AtlBrowserStorageSession).getItem(redirectPathname)) : Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) {
            if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) // @browser-storage setter
            (0, $4fPPi.AtlBrowserStorageSession).setStrictlyNecessaryItem(redirectPathname, Date.now().toString());
            else // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
            sessionStorage.setItem(redirectPathname, Date.now().toString());
        } else if (Date.now() - lastRedirectTime < $1e98a2addb49a2c7$var$THRESHOLD) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const scopeData = (0, $6PF9P.default)(window.location.href, (0, $6bEm8.default));
            const scope = $1e98a2addb49a2c7$var$getScopeType(scopeData);
            (0, $6CfY5.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $g2dvj.errorFlag)());
            if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) (0, $4fPPi.AtlBrowserStorageSession).removeItem(redirectPathname);
            else // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
            sessionStorage.removeItem(redirectPathname);
            return;
        } else if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) (0, $4fPPi.AtlBrowserStorageSession).removeItem(redirectPathname);
        else // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
        sessionStorage.removeItem(redirectPathname);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
$1e98a2addb49a2c7$export$836fe1ef2cfde075.displayName = "RedirectToLegacyRouting";
const $1e98a2addb49a2c7$var$defaultExport = (0, $e2Tle.withRouter)((0, $5Ez9w.default)((0, $kTviw.default)()($1e98a2addb49a2c7$export$836fe1ef2cfde075)));
var $1e98a2addb49a2c7$export$2e2bcd8739ae039 = $1e98a2addb49a2c7$var$defaultExport;

});
parcelRegister("6PF9P", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $33592acc8b32376a$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $33592acc8b32376a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $21iIq = parcelRequire("21iIq");

var $dBdbP = parcelRequire("dBdbP");

var $ks1PO = parcelRequire("ks1PO");

var $gQTgF = parcelRequire("gQTgF");

var $k62uT = parcelRequire("k62uT");
const $33592acc8b32376a$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $33592acc8b32376a$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $33592acc8b32376a$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $33592acc8b32376a$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $33592acc8b32376a$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $33592acc8b32376a$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $33592acc8b32376a$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $ks1PO.default).some((regex)=>regex.test(url)) || (0, $gQTgF.default).some((regex)=>regex.test(url));
const $33592acc8b32376a$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $33592acc8b32376a$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $33592acc8b32376a$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $k62uT.default).some((route)=>url.match(route)) || $33592acc8b32376a$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $33592acc8b32376a$var$getProjectPageType = (getMeta, url)=>{
    if ($33592acc8b32376a$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
const $33592acc8b32376a$var$getScopeData = (url, getMeta)=>{
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $33592acc8b32376a$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $33592acc8b32376a$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $33592acc8b32376a$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $33592acc8b32376a$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $33592acc8b32376a$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $dBdbP.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};
var $33592acc8b32376a$export$2e2bcd8739ae039 = $33592acc8b32376a$var$getScopeData;

});
parcelRegister("ks1PO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8210be613caf071d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $8210be613caf071d$var$connectRoutes = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];
var $8210be613caf071d$export$2e2bcd8739ae039 = $8210be613caf071d$var$connectRoutes;

});

parcelRegister("gQTgF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f3faacc494e2d3a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $9f3faacc494e2d3a$var$projectSettingsConnectRoutes = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];
var $9f3faacc494e2d3a$export$2e2bcd8739ae039 = $9f3faacc494e2d3a$var$projectSettingsConnectRoutes;

});

parcelRegister("k62uT", function(module, exports) {
$parcel$export(module.exports, "default", () => $d99f779240729cc8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $gQTgF = parcelRequire("gQTgF");
const $d99f779240729cc8$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
const $d99f779240729cc8$var$projectSettingsRoutes = [
    ...$d99f779240729cc8$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $gQTgF.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];
var $d99f779240729cc8$export$2e2bcd8739ae039 = $d99f779240729cc8$var$projectSettingsRoutes;

});


parcelRegister("5Ez9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bc509c365d32782$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $iQPOZ = parcelRequire("iQPOZ");
/**
 * The types for this aren't quite right - use with caution.
 * @deprecated Use `useFlagService` instead. HOCs are deprecated.
 */ const $7bc509c365d32782$var$withFlagService = (WrappedComponent)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $iQPOZ.flagService)
        });
var $7bc509c365d32782$export$2e2bcd8739ae039 = $7bc509c365d32782$var$withFlagService;

});

parcelRegister("g2dvj", function(module, exports) {
$parcel$export(module.exports, "errorFlag", () => $4e1463b59ddbd677$export$b9a7f1ebeaa76953);
/* eslint-disable jira/choreographer/message-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $7eNDO = parcelRequire("7eNDO");
const $4e1463b59ddbd677$var$title = (0, $7eNDO.defineMessage)({
    id: "redirect.legacy-routing.flags.error.title",
    defaultMessage: "We can't find the page you're looking for"
});
const $4e1463b59ddbd677$var$description = (0, $7eNDO.defineMessage)({
    id: "redirect.legacy-routing.flags.error.description",
    defaultMessage: "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
});
const $4e1463b59ddbd677$var$goHome = (0, $7eNDO.defineMessage)({
    id: "redirect.legacy-routing.flags.error.go-home",
    defaultMessage: "Go to the homepage"
});
const $4e1463b59ddbd677$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: $4e1463b59ddbd677$var$title,
        description: $4e1463b59ddbd677$var$description,
        messageId: 'common.redirect.legacy-routing.flags.flag.error.error-flag',
        messageType: 'transactional',
        actions: [
            {
                content: $4e1463b59ddbd677$var$goHome,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign('/')
            }
        ]
    });

});



parcelRegister("Ftdrj", function(module, exports) {
$parcel$export(module.exports, "LazyGlobalMailSettings", () => $c5715f247f2fe49d$export$a133d90b2004a90e);
$parcel$export(module.exports, "default", () => $c5715f247f2fe49d$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $c5715f247f2fe49d$export$a133d90b2004a90e = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("l3nWT"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-global-mail-settings/src/GlobalMailSettingsType.tsx"
});
const $c5715f247f2fe49d$var$AsyncGlobalMailSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c5715f247f2fe49d$export$a133d90b2004a90e,
        pageId: "global-mail-settings",
        shouldShowSpinner: false
    });
$c5715f247f2fe49d$var$AsyncGlobalMailSettings.displayName = "AsyncGlobalMailSettings";
var $c5715f247f2fe49d$export$2e2bcd8739ae039 = $c5715f247f2fe49d$var$AsyncGlobalMailSettings;

});
parcelRegister("l3nWT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("hIzvV")
]).then(()=>parcelRequire('eYyf2'));

});



parcelRegister("21UpQ", function(module, exports) {
$parcel$export(module.exports, "globalPoliciesRouteEntry", () => $54f3509c131146fd$export$2ee2f43d380cc210);



var $dUAVJ = parcelRequire("dUAVJ");

var $asdh0 = parcelRequire("asdh0");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $9w9tG = parcelRequire("9w9tG");

var $bkrFd = parcelRequire("bkrFd");

var $coId9 = parcelRequire("coId9");
const $54f3509c131146fd$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $54f3509c131146fd$export$2ee2f43d380cc210 = (0, $fdS54.createEntry)((0, $9w9tG.globalPoliciesRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $coId9.AlertPoliciesComponent),
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $asdh0.resources)()
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$54f3509c131146fd$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $coId9.LazyAlertPolicies)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9w9tG", function(module, exports) {
$parcel$export(module.exports, "globalPoliciesRoute", () => $102df35b540a4fb0$export$4eb24a8e860a3df7);
const $102df35b540a4fb0$export$4eb24a8e860a3df7 = {
    name: 'eoc-policies',
    path: '/jira/settings/products/ops/policies',
    exact: true
};

});


parcelRegister("6IPAd", function(module, exports) {
$parcel$export(module.exports, "globalSettingsContactAdministratorRouteEntry", () => $2172f674a93d7416$export$d213125be8246eea);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $fqBf8 = parcelRequire("fqBf8");

var $jjbZn = parcelRequire("jjbZn");
const $2172f674a93d7416$export$d213125be8246eea = (0, $fdS54.createEntry)((0, $fqBf8.globalSettingsContactAdministratorRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.contact-administrator',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jjbZn.default),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jjbZn.LazyContactAdministratorPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fqBf8", function(module, exports) {
$parcel$export(module.exports, "globalSettingsContactAdministratorRoute", () => $4fa5bdfd62d0df61$export$146910ddc36bf151);
const $4fa5bdfd62d0df61$export$146910ddc36bf151 = {
    name: 'global-settings-contact-administrator',
    path: '/jira/contact-administrator'
};

});

parcelRegister("jjbZn", function(module, exports) {
$parcel$export(module.exports, "LazyContactAdministratorPage", () => $5b5e1e279a545f16$export$bf75747a931b9a2b);
$parcel$export(module.exports, "default", () => $5b5e1e279a545f16$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $5b5e1e279a545f16$export$bf75747a931b9a2b = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("geNkQ"))), {
    moduleId: "./src/packages/admin-pages/contact-administrator/src/ContactAdministratorPage.tsx"
});
const $5b5e1e279a545f16$var$AsyncContactAdministratorPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5b5e1e279a545f16$export$bf75747a931b9a2b,
        pageId: "jira-admin-pages-contact-administrator",
        shouldShowSpinner: true
    });
$5b5e1e279a545f16$var$AsyncContactAdministratorPage.displayName = "AsyncContactAdministratorPage";
var $5b5e1e279a545f16$export$2e2bcd8739ae039 = $5b5e1e279a545f16$var$AsyncContactAdministratorPage;

});
parcelRegister("geNkQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("atkdw")
]).then(()=>parcelRequire('dQlgZ'));

});



parcelRegister("exdpX", function(module, exports) {
$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $a205940327e29fd0$export$d83c2e469d070766);



var $dz5H5 = parcelRequire("dz5H5");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $35eqr = parcelRequire("35eqr");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $vq7wN = parcelRequire("vq7wN");

var $l86TG = parcelRequire("l86TG");
const $a205940327e29fd0$export$d83c2e469d070766 = (0, $fdS54.createEntry)((0, $vq7wN.globalSettingsCustomFieldsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.custom-fields-directory',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l86TG.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $dz5H5.customFieldsDirectoryResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $l86TG.LazyCustomFieldsDirectoryAdmin)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dz5H5", function(module, exports) {
$parcel$export(module.exports, "customFieldsDirectoryResource", () => $a42e2a9637048c36$export$3d783f106e15b01a);

var $7edbf = parcelRequire("7edbf");
const $a42e2a9637048c36$var$RESOURCE_TYPE_CUSTOM_FIELDS_DIRECTORY = 'CUSTOM_FIELDS_DIRECTORY';

const $a42e2a9637048c36$export$3d783f106e15b01a = (0, $7edbf.createResource)({
    type: $a42e2a9637048c36$var$RESOURCE_TYPE_CUSTOM_FIELDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("jmqyL"))
});

});
parcelRegister("jmqyL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3e8RG").then(()=>parcelRequire('aMXha'));

});


parcelRegister("vq7wN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $a5f8991ebdc441d1$export$45e7d93edcc9507f);
const $a5f8991ebdc441d1$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields(!default)?.jspa'
};

});

parcelRegister("l86TG", function(module, exports) {
$parcel$export(module.exports, "LazyCustomFieldsDirectoryAdmin", () => $0309113d39ec9fb0$export$55a5c16f39a046af);
$parcel$export(module.exports, "default", () => $0309113d39ec9fb0$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0309113d39ec9fb0$export$55a5c16f39a046af = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("kMiCd"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-custom-fields-directory/src/CustomFieldsDirectoryAdminType.tsx"
});
const $0309113d39ec9fb0$var$AsyncCustomFieldsDirectoryAdmin = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0309113d39ec9fb0$export$55a5c16f39a046af,
        pageId: "admin-pages-custom-fields-directory",
        shouldShowSpinner: true
    });
$0309113d39ec9fb0$var$AsyncCustomFieldsDirectoryAdmin.displayName = "AsyncCustomFieldsDirectoryAdmin";
var $0309113d39ec9fb0$export$2e2bcd8739ae039 = $0309113d39ec9fb0$var$AsyncCustomFieldsDirectoryAdmin;

});
parcelRegister("kMiCd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("cv20a")
]).then(()=>parcelRequire('jFzRn'));

});



parcelRegister("arNsV", function(module, exports) {
$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRouteEntry", () => $52c6b89f16ed6cc9$export$25dca167915e813c);
/* eslint-disable import/order */ 


var $9sh1d = parcelRequire("9sh1d");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $iz9hV = parcelRequire("iz9hV");

var $38Jfh = parcelRequire("38Jfh");
const $52c6b89f16ed6cc9$export$25dca167915e813c = (0, $fdS54.createEntry)((0, $iz9hV.globalSettingsEditPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $38Jfh.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $9sh1d.editPermissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $38Jfh.LazyEditPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'EditPermissionScheme',
                packageName: 'jiraAdminPagesEditPermissionScheme',
                teamName: 'gordian'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9sh1d", function(module, exports) {
$parcel$export(module.exports, "editPermissionSchemePageResource", () => $b17714ae9ceabb5c$export$2b6bb2f543863b53);

var $5i2j1 = parcelRequire("5i2j1");

var $htsFl = parcelRequire("htsFl");

var $i860n = parcelRequire("i860n");
const $b17714ae9ceabb5c$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
const $b17714ae9ceabb5c$export$2b6bb2f543863b53 = (0, $htsFl.createRelayResource)({
    type: $b17714ae9ceabb5c$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $5i2j1.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                first: 50,
                isGrantsPerPermissionLimitEnabled: (0, $i860n.fg)('slt1_1018-use-limit-provider-for-grants-permission')
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("5i2j1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8da172c07aac2c79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13105775f3e6166d2d443b77213a5a4d>>
 * @relayHash 44a69ddf61ead718c338b99cb4f3276d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 599c8fd93a2821bd891bff99f25fa996abf9d2ab91bca688c7ead48015026c91
const $8da172c07aac2c79$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGrantsPerPermissionLimitEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v3 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v8 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "condition": "isGrantsPerPermissionLimitEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "grantsPerPermissionLimit"
            }
        ]
    }, v10 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "description"
    }, v15 = {
        "kind": "ScalarField",
        "name": "text"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = [
        v12 /*: any*/ ,
        v5 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = [
        v5 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditPermissionSchemesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isGrantsPerPermissionLimitEnabled",
                                                        "variableName": "isGrantsPerPermissionLimitEnabled"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "PermissionCategories"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "Header_PermissionsAdministrationPagesEditPermissionScheme"
                                            },
                                            {
                                                "concreteType": "JiraPermissionScheme",
                                                "kind": "LinkedField",
                                                "name": "scheme",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            },
                                            v8 /*: any*/ ,
                                            {
                                                "concreteType": "JiraPermissionSchemeGrantGroup",
                                                "kind": "LinkedField",
                                                "name": "grantGroups",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraPermissionGrantHolder",
                                                        "kind": "LinkedField",
                                                        "name": "grantHolders",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPermissionGrants",
                                                                "kind": "LinkedField",
                                                                "name": "grants",
                                                                "plural": true,
                                                                "selections": [
                                                                    v9 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v10 /*: any*/ ,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v11 /*: any*/ ,
                                                                "action": "LOG"
                                                            }
                                                        ]
                                                    },
                                                    "action": "LOG"
                                                }
                                            ]
                                        },
                                        "action": "LOG"
                                    }
                                ]
                            },
                            "action": "LOG"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditPermissionSchemesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "configuration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tag"
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionMessageExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "message",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionDocumentationExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "documentation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v12 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v6 /*: any*/ ,
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v17 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v18 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v18 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v17 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v16 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                v12 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "getProjectsByPermissionScheme",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "599c8fd93a2821bd891bff99f25fa996abf9d2ab91bca688c7ead48015026c91",
            "metadata": {},
            "name": "EditPermissionSchemesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8da172c07aac2c79$var$node.hash = "568855888dd6c86f418db5be5b14a538";
var $8da172c07aac2c79$export$2e2bcd8739ae039 = $8da172c07aac2c79$var$node;

});


parcelRegister("iz9hV", function(module, exports) {
$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRoute", () => $1fa06152b1b8e26e$export$d57f448badd0561f);
const $1fa06152b1b8e26e$export$d57f448badd0561f = {
    name: 'global-settings-issues-edit-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes/:schemeId'
};

});

parcelRegister("38Jfh", function(module, exports) {
$parcel$export(module.exports, "LazyEditPermissionSchemePage", () => $516ba02c87c3546c$export$4549705b02900c32);
$parcel$export(module.exports, "default", () => $516ba02c87c3546c$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $516ba02c87c3546c$export$4549705b02900c32 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)(// eslint-disable-next-line jira/import/file-extension-required
    (parcelRequire("cCbT4"))), {
    moduleId: "./src/packages/permissions-administration/pages-edit-permission-scheme/src/index.tsx"
});
const $516ba02c87c3546c$var$AsyncEditPermissionSchemePage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $516ba02c87c3546c$export$4549705b02900c32,
        pageId: "jira-edit-permission-scheme",
        shouldShowSpinner: true
    });
$516ba02c87c3546c$var$AsyncEditPermissionSchemePage.displayName = "AsyncEditPermissionSchemePage";
var $516ba02c87c3546c$export$2e2bcd8739ae039 = $516ba02c87c3546c$var$AsyncEditPermissionSchemePage;

});
parcelRegister("cCbT4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("eaP8t")
]).then(()=>parcelRequire('e1OWH'));

});



parcelRegister("3ENn5", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFieldSchemeSelfConversionRouteEntry", () => $b4d715ea724761d7$export$724fe5a7a28f61c9);

var $i860n = parcelRequire("i860n");

var $3oc03 = parcelRequire("3oc03");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $iSoIx = parcelRequire("iSoIx");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $1JBST = parcelRequire("1JBST");
const $b4d715ea724761d7$var$fieldSchemeSelfConversionPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $3oc03.fieldSchemeSelfConversionEntryPoint)
});
const $b4d715ea724761d7$export$724fe5a7a28f61c9 = (0, $fdS54.createEntry)((0, $1JBST.globalSettingsFieldSchemeSelfConversionRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        // No sidebar nav entry — this page is only accessible via a direct URL.
        navigation: {},
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        // Swap to not-found when the feature gate is off
        entryPoint: ()=>(0, $i860n.fg)('nfa-c2c-self-conversion-fe') ? $b4d715ea724761d7$var$fieldSchemeSelfConversionPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3oc03", function(module, exports) {
$parcel$export(module.exports, "fieldSchemeSelfConversionEntryPoint", () => $1f3e3e0e71a8b479$export$e94566bc24825301);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $1f3e3e0e71a8b479$export$e94566bc24825301 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bAPFs")), {
        moduleId: "bfcd5d8a",
        moduleName: "FieldSchemeSelfConversionManager",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bAPFs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2pHKu").then(()=>parcelRequire('j29hS'));

});


parcelRegister("1JBST", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFieldSchemeSelfConversionRoute", () => $221dffd26a1b524e$export$2ae9d2a3353ea5);
const $221dffd26a1b524e$export$2ae9d2a3353ea5 = {
    name: 'global-settings-issues-field-scheme-self-conversion',
    path: '/jira/settings/issues/field-configuration/enable-field-scheme',
    exact: true
};

});


parcelRegister("uQst0", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFormDataConnectionsRouteEntry", () => $c1afbbec16edf75b$export$d975ee3e4df0b4d2);



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $hiTDu = parcelRequire("hiTDu");

var $5zWAr = parcelRequire("5zWAr");
const $c1afbbec16edf75b$var$jiraAdminProformaDataConnectionsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5zWAr.default)
});
const $c1afbbec16edf75b$export$d975ee3e4df0b4d2 = (0, $fdS54.createEntry)((0, $hiTDu.globalSettingsFormDataConnectionsRoute), ()=>({
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        entryPoint () {
            return $c1afbbec16edf75b$var$jiraAdminProformaDataConnectionsPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hiTDu", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFormDataConnectionsRoute", () => $2361f9b5476dbecf$export$6633247975d81f28);
const $2361f9b5476dbecf$export$6633247975d81f28 = {
    name: 'global-settings-issues-form-data-connections',
    path: '/jira/settings/forms/data-connections'
};

});

parcelRegister("5zWAr", function(module, exports) {
$parcel$export(module.exports, "default", () => $34c9c9237475dc43$export$2e2bcd8739ae039);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $34c9c9237475dc43$var$JiraAdminProformaDataConnectionsEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("6eiv8")), {
        moduleId: "606040fa",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});
var $34c9c9237475dc43$export$2e2bcd8739ae039 = $34c9c9237475dc43$var$JiraAdminProformaDataConnectionsEntryPoint;

});
parcelRegister("6eiv8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lMCJT").then(()=>parcelRequire('gG5px'));

});



parcelRegister("hr37Z", function(module, exports) {
$parcel$export(module.exports, "globalSettingsGlobalPermissionsRouteEntry", () => $b39d155077b06fd2$export$34203273711b537f);
/* eslint-disable import/order */ 

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $iVR2c = parcelRequire("iVR2c");

var $dTa0V = parcelRequire("dTa0V");

var $f6Aof = parcelRequire("f6Aof");

var $i860n = parcelRequire("i860n");
const $b39d155077b06fd2$export$34203273711b537f = (0, $fdS54.createEntry)((0, $iVR2c.globalSettingsGlobalPermissionsRoute), ()=>({
        entryPoint () {
            return (0, $i860n.fg)('olympus-global-permissions-fe-modernisation') ? (0, $dTa0V.createPageEntryPoint)({
                main: (0, $f6Aof.globalPermissionsEntryPoint)
            }) : undefined;
        },
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iVR2c", function(module, exports) {
$parcel$export(module.exports, "globalSettingsGlobalPermissionsRoute", () => $760299600f160e83$export$236ce89eb737f752);
const $760299600f160e83$export$236ce89eb737f752 = {
    name: 'global-settings-global-permissions',
    path: '/secure/admin/global-permissions'
};

});

parcelRegister("f6Aof", function(module, exports) {
$parcel$export(module.exports, "globalPermissionsEntryPoint", () => $52d6346e8c74092a$export$78f97c5f11781a19);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $dlOmI = parcelRequire("dlOmI");

const $52d6346e8c74092a$export$78f97c5f11781a19 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("iNLKk")), {
        moduleId: "5c9bb197",
        moduleName: "GlobalPermissionsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>({
            queries: {
                globalPermissionsPageQuery: {
                    parameters: $dlOmI.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("dlOmI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a1e29f67c0adb11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8990da963e0a2274a4162022a89a56dd>>
 * @relayHash 8413120c5044e28e77415d3555a15759
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e4e25d9fc4d23494ef793218f910b44fe2c294adda73d3b1886bc6021f1a691
const $8a1e29f67c0adb11$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "RequiredField",
        "field": v2 /*: any*/ ,
        "action": "THROW"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isManagedByJira"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalPermissionsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "globalPermissionsAndGrants",
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "GrantPermissionModal"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraGlobalPermissionGrants",
                                                        "kind": "LinkedField",
                                                        "name": "globalPermissionGrants",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "RemovePermissionModal"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraGlobalPermission",
                                                                    "kind": "LinkedField",
                                                                    "name": "permission",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "THROW"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v5 /*: any*/ ,
                                                                            "action": "THROW"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "groups",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v6 /*: any*/ ,
                                                                            "action": "THROW"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW"
                                                }
                                            ],
                                            "type": "JiraGlobalPermissionGrantsList"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalPermissionsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "globalPermissionsAndGrants",
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9e4e25d9fc4d23494ef793218f910b44fe2c294adda73d3b1886bc6021f1a691",
            "metadata": {},
            "name": "GlobalPermissionsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8a1e29f67c0adb11$var$node.hash = "b086ae694030162f77bb1efd6fcab026";
var $8a1e29f67c0adb11$export$2e2bcd8739ae039 = $8a1e29f67c0adb11$var$node;

});

parcelRegister("iNLKk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k7He2").then(()=>parcelRequire('3W1J3'));

});



parcelRegister("hlKdK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemeRouteEntry", () => $7b99cfb3e859eaf4$export$7d7f30b10ed32027);

var $jP8lT = parcelRequire("jP8lT");



var $fdS54 = parcelRequire("fdS54");

var $56E4p = parcelRequire("56E4p");

var $ju22D = parcelRequire("ju22D");

var $i860n = parcelRequire("i860n");

var $dUAVJ = parcelRequire("dUAVJ");

var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $dTa0V = parcelRequire("dTa0V");
const $7b99cfb3e859eaf4$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $jP8lT.globalAdminFieldSchemeEntryPoint)
});
const $7b99cfb3e859eaf4$export$7d7f30b10ed32027 = (0, $fdS54.createEntry)((0, $56E4p.globalSettingsIssueFieldSchemeRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.field-scheme',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        canTransitionIn: ()=>!(0, $i860n.fg)('mc-nfa-soft-rollback'),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if ((0, $i860n.fg)('mc-nfa-soft-rollback')) return undefined;
            return $7b99cfb3e859eaf4$var$pageEntryPoint;
        },
        meta: {
            reporting: {
                packageName: 'jiraAdminPagesFieldScheme',
                id: 'globalSettingsIssueFieldScheme',
                teamName: 'Yamato'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jP8lT", function(module, exports) {
$parcel$export(module.exports, "globalAdminFieldSchemeEntryPoint", () => $b931abf07aad54ff$export$db849352675d81cc);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $a2IM3 = parcelRequire("a2IM3");

var $i860n = parcelRequire("i860n");

var $eyftZ = parcelRequire("eyftZ");

const $b931abf07aad54ff$export$db849352675d81cc = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8dKiC")), {
        moduleId: "d7333f59",
        moduleName: "FieldSchemeApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>({
            queries: {
                fieldSchemePageQuery: {
                    parameters: (0, $eyftZ.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        schemeId: match.params?.schemeId || '',
                        input: {
                            schemeId: match.params?.schemeId || ''
                        },
                        availableOnInput: {
                            schemeOrProject: {
                                schemeId: match.params?.schemeId || ''
                            }
                        },
                        descriptionsInput: {
                            schemeOrProject: {
                                schemeId: match.params?.schemeId || ''
                            }
                        },
                        requiredOnInput: {
                            schemeOrProject: {
                                schemeId: match.params?.schemeId || ''
                            }
                        },
                        fieldSchemeAri: match.params?.schemeId ? (0, $a2IM3.JiraFieldSchemeAri).create({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            fieldSchemeId: match.params.schemeId
                        }).toString() : '',
                        isPerSchemeFieldLimitEnabled: (0, $i860n.fg)('limits_enforcement_via_backend') || (0, $i860n.fg)('mc-nfa-enforce-project-field-limits')
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            },
            extraProps: {
                schemeId: match.params?.schemeId || ''
            }
        })
});

});
parcelRegister("a2IM3", function(module, exports) {
$parcel$export(module.exports, "JiraFieldSchemeAri", () => $74fcd281019492ef$export$5e44b06409c4e697);

var $hEZrN = parcelRequire("hEZrN");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/field-scheme/manifest.ts
var $74fcd281019492ef$var$jiraFieldSchemeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hEZrN.JiraFieldSchemeAriResourceOwner),
    resourceType: (0, $hEZrN.JiraFieldSchemeAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldSchemeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldSchemeId: /[0-9]+/
    }
};
// src/jira/field-scheme/index.ts
var $74fcd281019492ef$export$5e44b06409c4e697 = class _JiraFieldSchemeAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldSchemeId = opts.resourceIdSegmentValues.fieldSchemeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldSchemeId() {
        return this._fieldSchemeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74fcd281019492ef$var$jiraFieldSchemeAriStaticOpts.qualifier,
            platformQualifier: $74fcd281019492ef$var$jiraFieldSchemeAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74fcd281019492ef$var$jiraFieldSchemeAriStaticOpts.resourceOwner,
            resourceType: $74fcd281019492ef$var$jiraFieldSchemeAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldSchemeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldSchemeId: opts.fieldSchemeId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $74fcd281019492ef$var$jiraFieldSchemeAriStaticOpts);
        return new _JiraFieldSchemeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $74fcd281019492ef$var$jiraFieldSchemeAriStaticOpts);
        return new _JiraFieldSchemeAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldSchemeId: this.fieldSchemeId
        };
    }
};

});
parcelRegister("hEZrN", function(module, exports) {
$parcel$export(module.exports, "JiraFieldSchemeAriResourceOwner", () => $cdb5d641a28f1127$export$8f6ad5e411df9d8);
$parcel$export(module.exports, "JiraFieldSchemeAriResourceType", () => $cdb5d641a28f1127$export$6d39bf538961beb4);
// src/jira/field-scheme/types.ts
var $cdb5d641a28f1127$export$8f6ad5e411df9d8 = "jira", $cdb5d641a28f1127$export$6d39bf538961beb4 = "field-scheme";

});


parcelRegister("eyftZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $99d20862765a1889$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32559267f3e93dec4e22614087c3c064>>
 * @relayHash af0a655e3faf361a0bd752d984c38d42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60813beea58cb330d539e5ec8dacf95643df5e4008ab6e2ca093628ccd5cf9a0

var $lIGkE = parcelRequire("lIGkE");
const $99d20862765a1889$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "availableOnInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "descriptionsInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSchemeAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPerSchemeFieldLimitEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "requiredOnInput"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "args": v8 /*: any*/ ,
        "kind": "ScalarField",
        "name": "jira_isTenantConvertedToNfa"
    }, v10 = {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "fieldSchemeAri"
        }
    ], v12 = {
        "kind": "Variable",
        "name": "isPerSchemeFieldLimitEnabled",
        "variableName": "isPerSchemeFieldLimitEnabled"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "fieldsCount"
    }, v15 = {
        "kind": "ScalarField",
        "name": "projectsCount"
    }, v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v20 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = [
        v7 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 40
        },
        v10 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "id"
    }, v24 = {
        "kind": "ScalarField",
        "name": "description"
    }, v25 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v26 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v27 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "workTypes",
        "plural": true,
        "selections": [
            v23 /*: any*/ ,
            v25 /*: any*/ ,
            v13 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "isDefault"
    }, v29 = [
        {
            "concreteType": "JiraIssueTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v25 /*: any*/ ,
                        v13 /*: any*/ ,
                        v26 /*: any*/ ,
                        v23 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                v18 /*: any*/ 
            ]
        },
        v21 /*: any*/ 
    ], v30 = [
        "input"
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FieldSchemePageQuery",
            "selections": [
                v9 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "availableOnInput",
                            "variableName": "availableOnInput"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "descriptionsInput",
                            "variableName": "descriptionsInput"
                        },
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "requiredOnInput",
                            "variableName": "requiredOnInput"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "AssociatedFieldsTable_query"
                },
                {
                    "alias": "fieldSchemeNode",
                    "args": v11 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        v12 /*: any*/ 
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "PageHeaderGroup_scheme"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "AssociatedFieldsTable_scheme"
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "type": "JiraFieldScheme"
                        }
                    ]
                },
                {
                    "args": [
                        v7 /*: any*/ ,
                        v12 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PageHeaderGroup_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FieldSchemePageQuery",
            "selections": [
                v9 /*: any*/ ,
                {
                    "args": v16 /*: any*/ ,
                    "concreteType": "JiraFieldTypeGroupConnection",
                    "kind": "LinkedField",
                    "name": "jira_fieldTypeGroups",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraFieldTypeGroupEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraFieldTypeGroup",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        v21 /*: any*/ 
                    ]
                },
                {
                    "args": v16 /*: any*/ ,
                    "filters": [
                        "cloudId"
                    ],
                    "handle": "connection",
                    "key": "FilterSelectFieldTypeCategory_query_jira_fieldTypeGroups",
                    "kind": "LinkedHandle",
                    "name": "jira_fieldTypeGroups"
                },
                {
                    "args": v22 /*: any*/ ,
                    "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
                    "kind": "LinkedField",
                    "name": "jira_fieldSchemeAssociatedFields",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraFieldSchemeAssociatedField",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "concreteType": "JiraField",
                                            "kind": "LinkedField",
                                            "name": "field",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFieldLocked"
                                        },
                                        {
                                            "concreteType": "JiraIssueFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "input",
                                                            "variableName": "availableOnInput"
                                                        }
                                                    ],
                                                    "concreteType": "JiraFieldToWorkTypesAssociation",
                                                    "kind": "LinkedField",
                                                    "name": "workTypesAssociationV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "availableOnAllWorkTypes"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                },
                                                v23 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "input",
                                                            "variableName": "requiredOnInput"
                                                        }
                                                    ],
                                                    "concreteType": "JiraFieldWorkTypeRequiredCustomization",
                                                    "kind": "LinkedField",
                                                    "name": "requiredOnCustomizationsV2",
                                                    "plural": true,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isRequired"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldSchemeOperations",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSchemeOperations",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canRemove"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "input",
                                                            "variableName": "descriptionsInput"
                                                        }
                                                    ],
                                                    "concreteType": "JiraFieldWorkTypeDescriptionCustomization",
                                                    "kind": "LinkedField",
                                                    "name": "descriptionCustomisationsV2",
                                                    "plural": true,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "workTypes",
                                                            "plural": true,
                                                            "selections": [
                                                                v23 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isHighlighted"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v22 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
                    "kind": "LinkedHandle",
                    "name": "jira_fieldSchemeAssociatedFields"
                },
                {
                    "alias": "fieldSchemeNode",
                    "args": v11 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v23 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "schemeId"
                                },
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "associatedIssueTypes",
                                    "plural": false,
                                    "selections": v29 /*: any*/ 
                                },
                                {
                                    "filters": v30 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "FilterSelectWorkType_scheme_associatedIssueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "associatedIssueTypes"
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "requiredOnIssueTypes",
                                    "plural": false,
                                    "selections": v29 /*: any*/ 
                                },
                                {
                                    "filters": v30 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "FilterSelectRequiredOn_scheme_requiredOnIssueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "requiredOnIssueTypes"
                                },
                                v14 /*: any*/ 
                            ],
                            "type": "JiraFieldScheme"
                        }
                    ]
                },
                {
                    "condition": "isPerSchemeFieldLimitEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "jira_fieldsPerSchemeLimit"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "60813beea58cb330d539e5ec8dacf95643df5e4008ab6e2ca093628ccd5cf9a0",
            "metadata": {},
            "name": "FieldSchemePageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$99d20862765a1889$var$node.hash = "29e4f2ab73e1cffbee972dfc0d39e0ec";
(0, $lIGkE.PreloadableQueryRegistry).set($99d20862765a1889$var$node.params.id, $99d20862765a1889$var$node);
var $99d20862765a1889$export$2e2bcd8739ae039 = $99d20862765a1889$var$node;

});

parcelRegister("8dKiC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eEPTs").then(()=>parcelRequire('QnKqi'));

});


parcelRegister("56E4p", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemeRoute", () => $0639ae596b241a0e$export$4fa4d1ddd1b89f8e);
const $0639ae596b241a0e$export$4fa4d1ddd1b89f8e = {
    name: 'global-settings-issues-field-scheme',
    path: '/jira/settings/issues/field-schemes/:schemeId',
    exact: true
};

});


parcelRegister("4ctNm", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemesConfigRouteEntry", () => $e2deae7c85edd400$export$dc59f583c700b3f9);

var $euxye = parcelRequire("euxye");

var $9i86Q = parcelRequire("9i86Q");



var $fdS54 = parcelRequire("fdS54");

var $54nu5 = parcelRequire("54nu5");

var $ju22D = parcelRequire("ju22D");

var $i860n = parcelRequire("i860n");

var $dUAVJ = parcelRequire("dUAVJ");

var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $dTa0V = parcelRequire("dTa0V");

var $1c8RI = parcelRequire("1c8RI");
const $e2deae7c85edd400$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9i86Q.globalAdminFieldSchemesEntryPoint)
});
const $e2deae7c85edd400$export$dc59f583c700b3f9 = (0, $fdS54.createEntry)((0, $54nu5.globalSettingsIssueFieldSchemesConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.field-schemes',
        layout: (0, $ju22D.globalSettingsLayout),
        skeleton: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1c8RI.FieldSchemesSkeleton), null);
        },
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        canTransitionIn: ()=>!(0, $i860n.fg)('mc-nfa-soft-rollback'),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if ((0, $i860n.fg)('mc-nfa-soft-rollback')) return undefined;
            return $e2deae7c85edd400$var$pageEntryPoint;
        },
        meta: {
            reporting: {
                packageName: 'jiraAdminPagesFieldSchemes',
                id: 'globalSettingsIssueFieldSchemes',
                teamName: 'Yamato'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9i86Q", function(module, exports) {
$parcel$export(module.exports, "globalAdminFieldSchemesEntryPoint", () => $548d94ef0213d0f1$export$7f6007a9ef27a05a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $2V4CI = parcelRequire("2V4CI");

const $548d94ef0213d0f1$export$7f6007a9ef27a05a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8oaPw")), {
        moduleId: "b162d4e3",
        moduleName: "FieldSchemesApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                pageQueryRef: {
                    parameters: (0, $2V4CI.default),
                    variables: {
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("2V4CI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4783b5f17f0f37cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f04a358f4e799c527cc0884b915a339>>
 * @relayHash 1628f447ad22a385ddadbaf67dfb6033
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ecb5863776f69a8f023bf59108428baf9cabf79d7d7ba16a18d1e8a60c8774f0

var $lIGkE = parcelRequire("lIGkE");
const $4783b5f17f0f37cf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "args": [
            v1 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "jira_isTenantConvertedToNfa"
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 40
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FieldSchemesAppQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "FieldSchemesPage_query"
                },
                v2 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FieldSchemesAppQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraFieldSchemesConnection",
                    "kind": "LinkedField",
                    "name": "jira_fieldSchemes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraFieldSchemesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraFieldScheme",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "schemeId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldsCount"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDefault"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectsCount"
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isHighlighted"
                                                }
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "fieldSchemesTable_adminPagesFieldSchemes_jira_fieldSchemes",
                    "kind": "LinkedHandle",
                    "name": "jira_fieldSchemes"
                },
                v2 /*: any*/ 
            ]
        },
        "params": {
            "id": "ecb5863776f69a8f023bf59108428baf9cabf79d7d7ba16a18d1e8a60c8774f0",
            "metadata": {},
            "name": "FieldSchemesAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4783b5f17f0f37cf$var$node.hash = "90e96dad983eb98e1b94597e4205eafb";
(0, $lIGkE.PreloadableQueryRegistry).set($4783b5f17f0f37cf$var$node.params.id, $4783b5f17f0f37cf$var$node);
var $4783b5f17f0f37cf$export$2e2bcd8739ae039 = $4783b5f17f0f37cf$var$node;

});

parcelRegister("8oaPw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6Y4uz").then(()=>parcelRequire('j2UUI'));

});


parcelRegister("54nu5", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemesConfigRoute", () => $82c0c74a0e8985fc$export$9c41d0c6d3034d6a);
const $82c0c74a0e8985fc$export$9c41d0c6d3034d6a = {
    name: 'global-settings-issues-field-schemes',
    path: '/jira/settings/issues/field-schemes',
    exact: true
};

});

parcelRegister("1c8RI", function(module, exports) {
$parcel$export(module.exports, "FieldSchemesSkeleton", () => $c229c107f33c4dad$export$7e38a517468c73e2);
/* FieldSchemesSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $j16NQ = parcelRequire("j16NQ");
const $c229c107f33c4dad$export$7e38a517468c73e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j16NQ)))
    });
$c229c107f33c4dad$export$7e38a517468c73e2.displayName = "FieldSchemesSkeleton";

});
parcelRegister("j16NQ", function(module, exports) {
module.exports = new URL("field-schemes-app-skeleton.tpl.0f9ec3c8.svg", import.meta.url).toString();

});



parcelRegister("g8xCO", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRouteEntry", () => $dcd28e5785620e3e$export$d76b41f577aeeba5);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $4M1gu = parcelRequire("4M1gu");

var $35eqr = parcelRequire("35eqr");

var $g6pSm = parcelRequire("g6pSm");
const $dcd28e5785620e3e$export$d76b41f577aeeba5 = (0, $fdS54.createEntry)((0, $4M1gu.globalSettingsIssueFieldSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screen-schemes',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $g6pSm.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $g6pSm.LazyScreenSchemesPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4M1gu", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRoute", () => $701e84dd0494d98b$export$3c5a0cf6ecc1bdf1);
const $701e84dd0494d98b$export$3c5a0cf6ecc1bdf1 = {
    name: 'global-settings-issues-field-schemes-view',
    path: '/jira/settings/issues/screen-schemes'
};

});

parcelRegister("g6pSm", function(module, exports) {
$parcel$export(module.exports, "LazyScreenSchemesPage", () => $7bf59e2e481177f4$export$342ae41503f611f1);
$parcel$export(module.exports, "default", () => $7bf59e2e481177f4$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7bf59e2e481177f4$export$342ae41503f611f1 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("b3n57"))), {
    moduleId: "./src/packages/admin-pages/screen-schemes-page/src/ScreenSchemesPage.tsx"
});
const $7bf59e2e481177f4$var$AsyncScreenSchemesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7bf59e2e481177f4$export$342ae41503f611f1,
        pageId: "jira-admin-pages-screen-schemes-page",
        shouldShowSpinner: true
    });
$7bf59e2e481177f4$var$AsyncScreenSchemesPage.displayName = "AsyncScreenSchemesPage";
var $7bf59e2e481177f4$export$2e2bcd8739ae039 = $7bf59e2e481177f4$var$AsyncScreenSchemesPage;

});
parcelRegister("b3n57", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("32TeR").then(()=>parcelRequire('eju4R'));

});



parcelRegister("hAZdW", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldScreensRouteEntry", () => $b7b773b05ab38e26$export$ea08b1064c32ddb2);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $2pJmM = parcelRequire("2pJmM");

var $35eqr = parcelRequire("35eqr");

var $ceNEE = parcelRequire("ceNEE");
const $b7b773b05ab38e26$export$ea08b1064c32ddb2 = (0, $fdS54.createEntry)((0, $2pJmM.globalSettingsIssueFieldScreensRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screens',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ceNEE.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $ceNEE.LazyScreensPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2pJmM", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldScreensRoute", () => $9d0c913b6cf56950$export$197fd5d0ee709ca4);
const $9d0c913b6cf56950$export$197fd5d0ee709ca4 = {
    name: 'global-settings-issues-field-screens',
    path: '/jira/settings/issues/screens'
};

});

parcelRegister("ceNEE", function(module, exports) {
$parcel$export(module.exports, "LazyScreensPage", () => $7f6e8994dc571435$export$f4e6d546d7f2894c);
$parcel$export(module.exports, "default", () => $7f6e8994dc571435$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7f6e8994dc571435$export$f4e6d546d7f2894c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dXxrV"))), {
    moduleId: "./src/packages/admin-pages/screens-page/src/ScreensPage.tsx"
});
const $7f6e8994dc571435$var$AsyncScreensPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7f6e8994dc571435$export$f4e6d546d7f2894c,
        pageId: "jira-admin-pages-screens-page",
        shouldShowSpinner: true
    });
$7f6e8994dc571435$var$AsyncScreensPage.displayName = "AsyncScreensPage";
var $7f6e8994dc571435$export$2e2bcd8739ae039 = $7f6e8994dc571435$var$AsyncScreensPage;

});
parcelRegister("dXxrV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cw6oS").then(()=>parcelRequire('k9vWw'));

});



parcelRegister("fnBKt", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntry", () => $4879bb1d9a97d820$export$b0811d27c1832ea1);
/* eslint-disable import/order */ 
var $4yFMU = parcelRequire("4yFMU");



var $lFLfF = parcelRequire("lFLfF");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $1yFHL = parcelRequire("1yFHL");

var $35eqr = parcelRequire("35eqr");
const $4879bb1d9a97d820$var$globalSettingsIssueFieldsManagementEntryPointPage = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4yFMU.globalSettingsIssueFieldsManagementRouteEntryPoint)
});
const $4879bb1d9a97d820$export$b0811d27c1832ea1 = (0, $fdS54.createEntry)((0, $1yFHL.globalSettingsIssueFieldsManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.fields',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint () {
            return $4879bb1d9a97d820$var$globalSettingsIssueFieldsManagementEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4yFMU", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntryPoint", () => $38a40ddcd5b90648$export$b2a8ea978923a786);
/* eslint-disable eslint-comments/no-restricted-disable */ // entrypoint.tsx

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $6XdCR = parcelRequire("6XdCR");

var $2700E = parcelRequire("2700E");

var $j4DUH = parcelRequire("j4DUH");
// Backwards compatibility with old URL params
const $38a40ddcd5b90648$var$CustomFieldStatus = {
    TRASHED: 'trashed',
    ACTIVE: 'active'
};
// These params will sync state to the URL
const $38a40ddcd5b90648$var$URL_PARAMS = {
    SIDEBAR_ID: 'sidebarId',
    SIDEBAR_VIEW: 'sidebarView',
    FIELD_ID: 'fieldId',
    SEARCH_QUERY: 'searchQuery',
    FIELD_TYPE_GROUPS: 'fieldTypeGroups',
    FIELD_SCOPE: 'fieldScope',
    SORTING_COLUMN_ID: 'sortingColumnId',
    SORTING_DIRECTION: 'sortingDirection',
    // This is the intitialTab named like this to be backwards compatible with legacy experience
    customFieldStatus: 'customFieldStatus'
};

const $38a40ddcd5b90648$export$b2a8ea978923a786 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5AzJm")), {
        moduleId: "9c77ca70",
        moduleName: "GlobalSettingsAdminPagesFields",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, activationId: activationId, isAdmin: isAdmin }, context: { query: query } })=>{
        const sidebarId = query[$38a40ddcd5b90648$var$URL_PARAMS.SIDEBAR_ID]?.toUpperCase();
        const sidebarView = query[$38a40ddcd5b90648$var$URL_PARAMS.SIDEBAR_VIEW]?.toLowerCase();
        const fieldId = query[$38a40ddcd5b90648$var$URL_PARAMS.FIELD_ID];
        const initialTab = query[$38a40ddcd5b90648$var$URL_PARAMS.customFieldStatus]?.toLowerCase() === $38a40ddcd5b90648$var$CustomFieldStatus.TRASHED ? 'deleted' : 'active';
        const searchQuery = (()=>{
            const rawValue = query[$38a40ddcd5b90648$var$URL_PARAMS.SEARCH_QUERY];
            return rawValue ? decodeURIComponent(rawValue) : undefined;
        })();
        const fieldTypeGroups = (()=>{
            const rawValue = query[$38a40ddcd5b90648$var$URL_PARAMS.FIELD_TYPE_GROUPS];
            if (!rawValue) return undefined;
            const groups = decodeURIComponent(rawValue).split(',').filter(Boolean);
            return groups.length > 0 ? groups : undefined;
        })();
        const sortingColumnId = (()=>{
            const rawValue = query[$38a40ddcd5b90648$var$URL_PARAMS.SORTING_COLUMN_ID];
            return rawValue ? decodeURIComponent(rawValue) : undefined;
        })();
        const sortingDirection = query[$38a40ddcd5b90648$var$URL_PARAMS.SORTING_DIRECTION];
        const preloadFieldNodeId = fieldId ? (()=>{
            try {
                return (0, $6XdCR.JiraFieldConfigurationAri).create({
                    fieldConfigurationId: fieldId,
                    activationId: activationId,
                    siteId: cloudId
                }).toString();
            } catch (error) {
                return '';
            }
        })() : '';
        const fieldScope = 'ALL';
        /**
		 * We have to distinguish which tab the url params are for
		 */ const initialRawFilters = initialTab === 'deleted' ? {
            deletedSearchQuery: searchQuery ?? '',
            deletedFieldTypeGroups: fieldTypeGroups,
            deletedFieldScope: fieldScope,
            deletedSortingColumnId: sortingColumnId,
            deletedSortingDirection: sortingDirection
        } : {
            activeSearchQuery: searchQuery ?? '',
            activeFieldTypeGroups: fieldTypeGroups,
            activeFieldScope: fieldScope,
            activeSortingColumnId: sortingColumnId,
            activeSortingDirection: sortingDirection
        };
        return {
            queries: {
                globalFields: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $j4DUH.default,
                    variables: {
                        cloudId: cloudId,
                        isAdmin: isAdmin,
                        preloadFieldNodeId: preloadFieldNodeId,
                        shouldPreloadField: !!preloadFieldNodeId,
                        includeFieldId: (0, $i860n.fg)('centralized-fields-allow-editing-global-cf-options'),
                        includeInstalledByAppName: (0, $i860n.fg)('cfm_add_app_name'),
                        fieldScope: fieldScope,
                        activeSearchQuery: initialTab === 'active' ? searchQuery ?? '' : '',
                        deletedSearchQuery: initialTab === 'deleted' ? searchQuery ?? '' : '',
                        ...initialRawFilters,
                        includeFieldSchemeOperations: true,
                        // Never included for deleted fields
                        includeFieldSchemeOperationsForDeleted: false,
                        includeOptionsCount: (0, $i860n.fg)('slt1-987_add_options_count_fields_table'),
                        includeProjectInfo: (0, $2700E.expValEquals)('can_only_be_used_in_project_field', 'isEnabled', true, false),
                        filterKeys: [
                            'field.options.per.field.limit'
                        ]
                    }
                }
            },
            extraProps: {
                initialTab: initialTab,
                sidebarId: sidebarId,
                sidebarView: sidebarView,
                isAdmin: isAdmin,
                fieldNodeId: preloadFieldNodeId,
                searchQuery: searchQuery,
                fieldTypeGroups: fieldTypeGroups,
                sortingColumnId: sortingColumnId,
                sortingDirection: sortingDirection
            }
        };
    }
});

});
parcelRegister("6XdCR", function(module, exports) {
$parcel$export(module.exports, "JiraFieldConfigurationAri", () => $5102d291e0dea34c$export$a3e5f46252df758f);

var $2w6im = parcelRequire("2w6im");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/field-configuration/manifest.ts
var $5102d291e0dea34c$var$jiraFieldConfigurationAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $2w6im.JiraFieldConfigurationAriResourceOwner),
    resourceType: (0, $2w6im.JiraFieldConfigurationAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldConfigurationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldConfigurationId: /[a-zA-Z]+(_[0-9]+)?/
    }
};
// src/jira/field-configuration/index.ts
var $5102d291e0dea34c$export$a3e5f46252df758f = class _JiraFieldConfigurationAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldConfigurationId = opts.resourceIdSegmentValues.fieldConfigurationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldConfigurationId() {
        return this._fieldConfigurationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5102d291e0dea34c$var$jiraFieldConfigurationAriStaticOpts.qualifier,
            platformQualifier: $5102d291e0dea34c$var$jiraFieldConfigurationAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5102d291e0dea34c$var$jiraFieldConfigurationAriStaticOpts.resourceOwner,
            resourceType: $5102d291e0dea34c$var$jiraFieldConfigurationAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldConfigurationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldConfigurationId: opts.fieldConfigurationId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $5102d291e0dea34c$var$jiraFieldConfigurationAriStaticOpts);
        return new _JiraFieldConfigurationAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $5102d291e0dea34c$var$jiraFieldConfigurationAriStaticOpts);
        return new _JiraFieldConfigurationAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldConfigurationId: this.fieldConfigurationId
        };
    }
};

});
parcelRegister("2w6im", function(module, exports) {
$parcel$export(module.exports, "JiraFieldConfigurationAriResourceOwner", () => $1d5374060134cd61$export$b0ece3f43f00d97a);
$parcel$export(module.exports, "JiraFieldConfigurationAriResourceType", () => $1d5374060134cd61$export$f045a5ec770d79b7);
// src/jira/field-configuration/types.ts
var $1d5374060134cd61$export$b0ece3f43f00d97a = "jira", $1d5374060134cd61$export$f045a5ec770d79b7 = "field-configuration";

});


parcelRegister("j4DUH", function(module, exports) {
$parcel$export(module.exports, "default", () => $daa993d1d984e349$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5e7eca399a92e0577e7d8ae989fc85d0>>
 * @relayHash 25fb54fc01ed3f564d9bb04fc4b23719
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dbbd43911959590f7032906691201bd545bf770e83653a4c671b31c8916d0bab

var $k1uZ5 = parcelRequire("k1uZ5");
const $daa993d1d984e349$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "dbbd43911959590f7032906691201bd545bf770e83653a4c671b31c8916d0bab",
        "metadata": {},
        "name": "FieldsPageViewQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcShowTranslatedNameForCustomFieldRelayProvider": (0, $k1uZ5.default)
        }
    }
};
var $daa993d1d984e349$export$2e2bcd8739ae039 = $daa993d1d984e349$var$node;

});
parcelRegister("k1uZ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bdf9fa7559a2706$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $4bdf9fa7559a2706$var$ShowTranslatedNameForCustomFieldRelayProvider = {
    get () {
        return (0, $2700E.expVal)('show-translated-name-for-custom-field', 'isEnabled', false);
    }
};
var $4bdf9fa7559a2706$export$2e2bcd8739ae039 = $4bdf9fa7559a2706$var$ShowTranslatedNameForCustomFieldRelayProvider;

});


parcelRegister("5AzJm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("aAknj")
]).then(()=>parcelRequire('3B4Nq'));

});


parcelRegister("1yFHL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRoute", () => $7cfc129105a238be$export$6e571c84819449f5);
const $7cfc129105a238be$export$6e571c84819449f5 = {
    name: 'global-settings-issues-fields-management-view',
    path: '/jira/settings/issues/fields'
};

});


parcelRegister("hkkWR", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRouteEntry", () => $7b4abbb62d6be795$export$ce3302d254f9c0b4);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $9KM7q = parcelRequire("9KM7q");



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $9zhIW = parcelRequire("9zhIW");

var $dLVGe = parcelRequire("dLVGe");

var $2z1Od = parcelRequire("2z1Od");
const $7b4abbb62d6be795$export$ce3302d254f9c0b4 = (0, $fdS54.createEntry)((0, $9zhIW.globalSettingsIssueHierarchyRedirectRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
                to: "/jira/settings/issues/issue-hierarchy"
            }),
        isRedirect: true,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $9KM7q.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2z1Od.LazyIssueHierarchyDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9zhIW", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", () => $7bba0d61e52c83e4$export$6236a41e09bb858a);
const $7bba0d61e52c83e4$export$6236a41e09bb858a = {
    name: 'global-settings-issues-hierarchy-redirect',
    path: '/secure/PortfolioHierarchy.jspa'
};

});

parcelRegister("2z1Od", function(module, exports) {
$parcel$export(module.exports, "LazyIssueHierarchyDirectory", () => $a43a24c6f24024bf$export$1ff7255ab4f7a2dd);
$parcel$export(module.exports, "default", () => $a43a24c6f24024bf$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $a43a24c6f24024bf$export$1ff7255ab4f7a2dd = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7CuVj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-issue-types-issue-hierarchy-directory/src/IssueHierarchyDirectory.tsx"
});
const $a43a24c6f24024bf$var$AsyncIssueHierarchyDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $a43a24c6f24024bf$export$1ff7255ab4f7a2dd,
        pageId: "jira-admin-pages-issue-hierarchy-directory",
        shouldShowSpinner: true
    });
$a43a24c6f24024bf$var$AsyncIssueHierarchyDirectory.displayName = "AsyncIssueHierarchyDirectory";
var $a43a24c6f24024bf$export$2e2bcd8739ae039 = $a43a24c6f24024bf$var$AsyncIssueHierarchyDirectory;

});
parcelRegister("7CuVj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("5HXFC")
]).then(()=>parcelRequire('72Bfn'));

});



parcelRegister("6Je0z", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueHierarchyRouteEntry", () => $22975b9e62773a2f$export$119e5b48edcee4ff);
/* eslint-disable import/order */ 
var $9KM7q = parcelRequire("9KM7q");



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $lLJKt = parcelRequire("lLJKt");

var $35eqr = parcelRequire("35eqr");

var $2z1Od = parcelRequire("2z1Od");
const $22975b9e62773a2f$export$119e5b48edcee4ff = (0, $fdS54.createEntry)((0, $lLJKt.globalSettingsIssueHierarchyRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-hierarchy-config',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2z1Od.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $9KM7q.issueHierarchyPageResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2z1Od.LazyIssueHierarchyDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lLJKt", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", () => $47b84e78bf34fb08$export$2c220ed11ae62e14);
const $47b84e78bf34fb08$export$2c220ed11ae62e14 = {
    name: 'global-settings-issues-hierarchy-view',
    path: '/jira/settings/issues/issue-hierarchy'
};

});


parcelRegister("3nqiL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $0aef75d81ac8a962$export$5519b86c9ea602e1);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $gc1my = parcelRequire("gc1my");

var $iIyfF = parcelRequire("iIyfF");
const $0aef75d81ac8a962$export$5519b86c9ea602e1 = (0, $fdS54.createEntry)((0, $gc1my.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $iIyfF.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $iIyfF.LazyExplicitFieldsProjectListPromise)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gc1my", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $e4959b1d9e9a86be$export$4f2c2d125c2b811a);
const $e4959b1d9e9a86be$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("iIyfF", function(module, exports) {
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $56b6898274494e17$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $56b6898274494e17$export$e81c180c4f4833e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $l8G1z = parcelRequire("l8G1z");

var $8bf4L = parcelRequire("8bf4L");

const $56b6898274494e17$export$7b11685155ada84d = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("grAIU")), {
    moduleId: "./src/packages/spa-apps/error-pages-not-found/src/ErrorPagesNotFoundPage.tsx"
});
const $56b6898274494e17$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $56b6898274494e17$export$7b11685155ada84d,
        pageId: "errors-404",
        shouldShowSpinner: false
    });
$56b6898274494e17$export$e81c180c4f4833e.displayName = "LazyExplicitFieldsProjectListPage";

});


parcelRegister("ha5bJ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRouteEntry", () => $12b4231269716980$export$ecfeb067cb61f7f7);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $2oY6a = parcelRequire("2oY6a");

var $35eqr = parcelRequire("35eqr");

var $gf6Aq = parcelRequire("gf6Aq");
const $12b4231269716980$export$ecfeb067cb61f7f7 = (0, $fdS54.createEntry)((0, $2oY6a.globalSettingsIssuesNewIssueSearchRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.new-issue-search-transition',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gf6Aq.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gf6Aq.LazyNewIssueSearchTransition)
        ],
        canTransitionIn: ()=>true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2oY6a", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRoute", () => $1211bfed8fc88e7d$export$774dc60e785b8ae8);
const $1211bfed8fc88e7d$export$774dc60e785b8ae8 = {
    name: 'global-settings-issues-new-issue-search',
    path: '/jira/settings/issues/new-issue-search-transition'
};

});

parcelRegister("gf6Aq", function(module, exports) {
$parcel$export(module.exports, "LazyNewIssueSearchTransition", () => $9b89e0cd36b25659$export$aa5e318abd957ad);
$parcel$export(module.exports, "default", () => $9b89e0cd36b25659$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9b89e0cd36b25659$export$aa5e318abd957ad = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("76V0o"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-new-issue-search-settings/src/NewIssueSearchSettings.tsx"
});
const $9b89e0cd36b25659$var$AsyncNewIssueSearchTransition = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9b89e0cd36b25659$export$aa5e318abd957ad,
        pageId: "jira-admin-pages-new-issue-search-transition",
        shouldShowSpinner: true
    });
$9b89e0cd36b25659$var$AsyncNewIssueSearchTransition.displayName = "AsyncNewIssueSearchTransition";
var $9b89e0cd36b25659$export$2e2bcd8739ae039 = $9b89e0cd36b25659$var$AsyncNewIssueSearchTransition;

});
parcelRegister("76V0o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("R5ysY").then(()=>parcelRequire('7Ut1N'));

});



parcelRegister("jTZk2", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $f2d78cbb80e2cd31$export$63a56a096ab0d260);
/* eslint-disable import/order */ 
var $3MbDk = parcelRequire("3MbDk");



var $ju22D = parcelRequire("ju22D");

var $dTa0V = parcelRequire("dTa0V");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $i860n = parcelRequire("i860n");

var $5OydK = parcelRequire("5OydK");

var $35eqr = parcelRequire("35eqr");

var $acmx0 = parcelRequire("acmx0");
const $f2d78cbb80e2cd31$var$globalSettingsIssuesPrioritiesRouteEntryPointPage = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $3MbDk.globalAdminPrioritiesEntryPoint)
});
const $f2d78cbb80e2cd31$export$63a56a096ab0d260 = (0, $fdS54.createEntry)((0, $5OydK.globalSettingsIssuesPrioritiesRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $acmx0.default),
        layout: (0, $ju22D.globalSettingsLayout),
        entryPoint: ()=>(0, $i860n.fg)('eax-1638_priorities_page_route_to_use_entrypoint') ? $f2d78cbb80e2cd31$var$globalSettingsIssuesPrioritiesRouteEntryPointPage : undefined,
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $acmx0.LazyPrioritiesPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3MbDk", function(module, exports) {
$parcel$export(module.exports, "globalAdminPrioritiesEntryPoint", () => $d359078a3474bd7b$export$624512f50b5869eb);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $d359078a3474bd7b$export$624512f50b5869eb = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("lzl3X")), {
        moduleId: "c89d3809",
        moduleName: "PrioritiesPageWrapper",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lzl3X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("kF2fK")
]).then(()=>parcelRequire('cdSLM'));

});


parcelRegister("5OydK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $3522f57a0d15cfc3$export$518516cdf6b7cd83);
const $3522f57a0d15cfc3$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/jira/settings/issues/priorities'
};

});

parcelRegister("acmx0", function(module, exports) {
$parcel$export(module.exports, "LazyPrioritiesPage", () => $fc376d95fddba59a$export$2b5843205130631c);
$parcel$export(module.exports, "default", () => $fc376d95fddba59a$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $fc376d95fddba59a$export$2b5843205130631c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("lzl3X"))), {
    moduleId: "./src/packages/admin-pages/priorities/src/PrioritiesPageWrapper.tsx"
});
const $fc376d95fddba59a$var$PrioritiesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $fc376d95fddba59a$export$2b5843205130631c,
        pageId: "jira-admin-pages-priorities",
        shouldShowSpinner: true
    });
$fc376d95fddba59a$var$PrioritiesPage.displayName = "PrioritiesPage";
var $fc376d95fddba59a$export$2e2bcd8739ae039 = $fc376d95fddba59a$var$PrioritiesPage;

});


parcelRegister("nK9GP", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRouteEntry", () => $4ce938c8ef7999f6$export$a5ac2a64ed09e754);
/* eslint-disable import/order */ 
var $ikHsr = parcelRequire("ikHsr");



var $ju22D = parcelRequire("ju22D");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $3yTXB = parcelRequire("3yTXB");

var $35eqr = parcelRequire("35eqr");

var $i860n = parcelRequire("i860n");

var $1WUUJ = parcelRequire("1WUUJ");
const $4ce938c8ef7999f6$var$globalSettingsIssuesPrioritySchemesRouteEntryPointPage = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ikHsr.globalAdminPrioritySchemesEntryPoint)
});
const $4ce938c8ef7999f6$export$a5ac2a64ed09e754 = (0, $fdS54.createEntry)((0, $3yTXB.globalSettingsIssuesPrioritySchemesRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1WUUJ.default),
        layout: (0, $ju22D.globalSettingsLayout),
        entryPoint: ()=>(0, $i860n.fg)('eax-1638_priorities_page_route_to_use_entrypoint') ? $4ce938c8ef7999f6$var$globalSettingsIssuesPrioritySchemesRouteEntryPointPage : undefined,
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $1WUUJ.LazyPrioritySchemes)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ikHsr", function(module, exports) {
$parcel$export(module.exports, "globalAdminPrioritySchemesEntryPoint", () => $470c7ac13916aaa1$export$986b936d982e01e1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $470c7ac13916aaa1$export$986b936d982e01e1 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2oRyd")), {
        moduleId: "3dd03933",
        moduleName: "PrioritySchemesPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2oRyd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("krCPm").then(()=>parcelRequire('hsBpT'));

});


parcelRegister("3yTXB", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", () => $4c0e5023fb6a9ce1$export$185af30f53271c10);
const $4c0e5023fb6a9ce1$export$185af30f53271c10 = {
    name: 'global-settings-issues-priority-schemes',
    path: '/jira/settings/issues/priority-schemes'
};

});

parcelRegister("1WUUJ", function(module, exports) {
$parcel$export(module.exports, "LazyPrioritySchemes", () => $738b1f8ee6ca59b8$export$20bb8a3b40a3add4);
$parcel$export(module.exports, "default", () => $738b1f8ee6ca59b8$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $738b1f8ee6ca59b8$export$20bb8a3b40a3add4 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("2oRyd"))), {
    moduleId: "./src/packages/admin-pages/priority-schemes/src/PrioritySchemesPage.tsx"
});
const $738b1f8ee6ca59b8$var$AsyncPrioritySchemes = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $738b1f8ee6ca59b8$export$20bb8a3b40a3add4,
        pageId: "jira-admin-pages-priority-schemes",
        shouldShowSpinner: true
    });
$738b1f8ee6ca59b8$var$AsyncPrioritySchemes.displayName = "AsyncPrioritySchemes";
var $738b1f8ee6ca59b8$export$2e2bcd8739ae039 = $738b1f8ee6ca59b8$var$AsyncPrioritySchemes;

});


parcelRegister("3vNqj", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesRouteEntry", () => $d094a1507b4d222a$export$680243b058188dc0);
/* eslint-disable import/order */ 
var $hX1N8 = parcelRequire("hX1N8");



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $khOSI = parcelRequire("khOSI");

var $35eqr = parcelRequire("35eqr");

var $5EKa67 = parcelRequire("5EKa67");
const $d094a1507b4d222a$export$680243b058188dc0 = (0, $fdS54.createEntry)((0, $khOSI.globalSettingsIssueTypesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-types',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5EKa67.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $hX1N8.issueTypesResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5EKa67.LazyIssueTypesDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hX1N8", function(module, exports) {
$parcel$export(module.exports, "issueTypesResource", () => $5266c192c7a65cc8$export$614e9d897c1ef917);

var $bS1iz = parcelRequire("bS1iz");

var $7edbf = parcelRequire("7edbf");

var $eP9Iz = parcelRequire("eP9Iz");
const $5266c192c7a65cc8$export$614e9d897c1ef917 = (0, $7edbf.createResource)({
    type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
    getKey: ()=>'issue types',
    getData: async ({ query: query })=>(0, $eP9Iz.getIssueTypes)((0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(query))
});

});
parcelRegister("eP9Iz", function(module, exports) {
$parcel$export(module.exports, "getIssueTypes", () => $093a4a57cf24b14f$export$4cf4b24b88599615);

var $bS1iz = parcelRequire("bS1iz");

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");


var $iajVT = parcelRequire("iajVT");
const $093a4a57cf24b14f$export$4cf4b24b88599615 = async (qs)=>{
    const filter = (0, $iajVT.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify((0, $iajVT.toApiUrlTransformer)(filter));
    try {
        return await (0, $4fhEY.default)(`/rest/internal/3/issuetype/search?${query}`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $55a77183decfe26c$export$4adfbb237b083187),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $55a77183decfe26c$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';

parcelRegister("iajVT", function(module, exports) {
$parcel$export(module.exports, "toUrlTransformer", () => $7187ea3f6d884c1c$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $7187ea3f6d884c1c$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toSearchFilterQsTransformer", () => $7187ea3f6d884c1c$export$bcd1ab210547e2f5);
$parcel$export(module.exports, "toSortFieldFilterQsTransformer", () => $7187ea3f6d884c1c$export$c114848fa733e5c4);
$parcel$export(module.exports, "toSortDirectionFilterQsTransformer", () => $7187ea3f6d884c1c$export$c5d2609f8b4048d3);
$parcel$export(module.exports, "toApiUrlTransformer", () => $7187ea3f6d884c1c$export$fb15afa686993f11);

var $3sdCD = parcelRequire("3sdCD");

var $bS1iz = parcelRequire("bS1iz");

var $29Z3v = parcelRequire("29Z3v");

var $c6pdI = parcelRequire("c6pdI");

var $TquQ2 = parcelRequire("TquQ2");
const $7187ea3f6d884c1c$var$HIERARCHY_LEVEL = 'hierarchy-level';
const $7187ea3f6d884c1c$var$NAME = 'name';
const $7187ea3f6d884c1c$var$sortDirectionMap = {
    asc: 'ASC',
    desc: 'DESC'
};
const $7187ea3f6d884c1c$var$sortFieldMap = {
    [$7187ea3f6d884c1c$var$NAME.toLowerCase()]: $7187ea3f6d884c1c$var$NAME,
    [$7187ea3f6d884c1c$var$HIERARCHY_LEVEL.toLowerCase()]: $7187ea3f6d884c1c$var$HIERARCHY_LEVEL
};
const $7187ea3f6d884c1c$export$5b9f8ed2c34be88a = (filter)=>filter ? {
        page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
        sortDirection: (0, $c6pdI.fieldToParam)(filter.sortDirection),
        sortField: (0, $c6pdI.fieldToParam)(filter.sortField),
        searchFilter: (0, $c6pdI.trimSearchFilter)(filter.searchFilter)
    } : {};
const $7187ea3f6d884c1c$export$bec67ef860c0d0e1 = (params)=>({
        page: Math.floor(Number((0, $29Z3v.number).parse(params.page))) || undefined,
        searchFilter: (0, $c6pdI.trimSearchFilter)(params.searchFilter),
        sortDirection: (0, $c6pdI.fieldFromParam)($7187ea3f6d884c1c$var$sortDirectionMap, params.sortDirection),
        sortField: (0, $c6pdI.fieldFromParam)($7187ea3f6d884c1c$var$sortFieldMap, params.sortField)
    });
const $7187ea3f6d884c1c$export$bcd1ab210547e2f5 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(qs);
    return parsed.searchFilter ? parsed.searchFilter : '';
};
const $7187ea3f6d884c1c$export$c114848fa733e5c4 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(qs);
    return parsed.sortField && parsed.sortField === 'name' ? $7187ea3f6d884c1c$var$NAME : $7187ea3f6d884c1c$var$HIERARCHY_LEVEL;
};
const $7187ea3f6d884c1c$export$c5d2609f8b4048d3 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(qs);
    return parsed.sortDirection && parsed.sortDirection === 'asc' ? 'ASC' : 'DESC';
};
const $7187ea3f6d884c1c$var$apiSortByMap = {
    ASC: '',
    DESC: '-'
};
const $7187ea3f6d884c1c$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($3sdCD)))({}, filter, (0, $TquQ2.DEFAULT_FILTER));
    // this additional mapping here is needed because the BE issue type search API already supports sorting by hierarchy level using the "type" parameter. It was decided to add mapping on frontend. More details here https://atlassian.slack.com/archives/C02HN05MC8K/p1680683395059279
    const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
    return {
        maxResults: (0, $TquQ2.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.page - 1) * (0, $TquQ2.MAX_RESULTS),
        query: (0, $c6pdI.trimSearchFilter)(fullFilter.searchFilter),
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        orderBy: `${$7187ea3f6d884c1c$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
    };
};

});
parcelRegister("3sdCD", function(module, exports) {

var $citK5 = parcelRequire("citK5");

var $9Qwp7 = parcelRequire("9Qwp7");

var $4qbYM = parcelRequire("4qbYM");

var $hOatB = parcelRequire("hOatB");
/** Used for built-in method references. */ var $283e8db56bf456b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $283e8db56bf456b2$var$hasOwnProperty = $283e8db56bf456b2$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $283e8db56bf456b2$var$defaults = $citK5(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $4qbYM(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $hOatB(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $9Qwp7(value, $283e8db56bf456b2$var$objectProto[key]) && !$283e8db56bf456b2$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $283e8db56bf456b2$var$defaults;

});

parcelRegister("29Z3v", function(module, exports) {
$parcel$export(module.exports, "string", () => $fb69fee15c0561e1$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $fb69fee15c0561e1$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $fb69fee15c0561e1$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $fb69fee15c0561e1$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $fb69fee15c0561e1$export$98e628dec113755e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eSVkV = parcelRequire("eSVkV");
const $fb69fee15c0561e1$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($eSVkV))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($eSVkV)))
};
const $fb69fee15c0561e1$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $fb69fee15c0561e1$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $fb69fee15c0561e1$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $fb69fee15c0561e1$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("c6pdI", function(module, exports) {
$parcel$export(module.exports, "fieldToParam", () => $85fca56e930a084b$export$7341f299e7b93e87);
$parcel$export(module.exports, "fieldFromParam", () => $85fca56e930a084b$export$c876451e094c0060);
$parcel$export(module.exports, "trimSearchFilter", () => $85fca56e930a084b$export$ed1722f41c23aaaf);
const $85fca56e930a084b$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $85fca56e930a084b$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $85fca56e930a084b$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});

parcelRegister("TquQ2", function(module, exports) {
$parcel$export(module.exports, "MAX_RESULTS", () => $2bb1328c04bd4f27$export$f6b2881bc1090cea);
$parcel$export(module.exports, "DEFAULT_FILTER", () => $2bb1328c04bd4f27$export$6deee0e4f2fb784e);
const $2bb1328c04bd4f27$var$HIERARCHY_LEVEL = 'hierarchy-level';
const $2bb1328c04bd4f27$export$f6b2881bc1090cea = 15;
const $2bb1328c04bd4f27$export$6deee0e4f2fb784e = {
    page: 1,
    sortDirection: 'DESC',
    sortField: $2bb1328c04bd4f27$var$HIERARCHY_LEVEL
};

});




parcelRegister("khOSI", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesRoute", () => $5a530332aabdfa8a$export$7358263a3bbb38b1);
const $5a530332aabdfa8a$export$7358263a3bbb38b1 = {
    name: 'global-settings-issues-types-view',
    path: '/jira/settings/issues/issue-types'
};

});

parcelRegister("5EKa67", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypesDirectory", () => $4421c5345755a148$export$661e1bf38bb82270);
$parcel$export(module.exports, "default", () => $4421c5345755a148$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4421c5345755a148$export$661e1bf38bb82270 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("2a9bY"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-issue-types-issue-types-directory/src/IssueTypesDirectoryWithErrorBoundary.tsx"
});
const $4421c5345755a148$var$AsyncIssueTypesDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4421c5345755a148$export$661e1bf38bb82270,
        pageId: "jira-admin-pages-issue-types-directory",
        shouldShowSpinner: true
    });
$4421c5345755a148$var$AsyncIssueTypesDirectory.displayName = "AsyncIssueTypesDirectory";
var $4421c5345755a148$export$2e2bcd8739ae039 = $4421c5345755a148$var$AsyncIssueTypesDirectory;

});
parcelRegister("2a9bY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hjwRi").then(()=>parcelRequire('92LMQ'));

});



parcelRegister("5LoRz", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRouteEntry", () => $3f56330cf7b2c959$export$8f940be66a7e7324);
/* eslint-disable import/order */ 
var $3PaxI = parcelRequire("3PaxI");



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $98cu9 = parcelRequire("98cu9");

var $35eqr = parcelRequire("35eqr");

var $6CJL4 = parcelRequire("6CJL4");
const $3f56330cf7b2c959$export$8f940be66a7e7324 = (0, $fdS54.createEntry)((0, $98cu9.globalSettingsIssueTypesSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-issue-type-schemes',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6CJL4.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $3PaxI.default),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6CJL4.LazyIssueTypeSchemesDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3PaxI", function(module, exports) {
$parcel$export(module.exports, "default", () => $46bf3b3ed5916593$export$2e2bcd8739ae039);

var $bS1iz = parcelRequire("bS1iz");

var $7edbf = parcelRequire("7edbf");

var $kAud3 = parcelRequire("kAud3");
const $46bf3b3ed5916593$var$ISSUE_TYPE_SCHEME_TABLE_TYPE = 'ISSUE_TYPE_SCHEME_TABLE';
const $46bf3b3ed5916593$var$ISSUE_TYPE_SCHEME_TABLE_KEY = 'ISSUE_TYPE_SCHEME_TABLE_KEY';
const $46bf3b3ed5916593$var$issueTypeSchemeResource = (0, $7edbf.createResource)({
    type: $46bf3b3ed5916593$var$ISSUE_TYPE_SCHEME_TABLE_TYPE,
    getKey: ({ query: query })=>`${$46bf3b3ed5916593$var$ISSUE_TYPE_SCHEME_TABLE_KEY}-${(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $kAud3.getIssueTypeSchemes)((0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(query))
});
var $46bf3b3ed5916593$export$2e2bcd8739ae039 = $46bf3b3ed5916593$var$issueTypeSchemeResource;

});
parcelRegister("kAud3", function(module, exports) {
$parcel$export(module.exports, "getIssueTypeSchemes", () => $d4250c73fee01b4d$export$2844cac611eecaa7);

var $bS1iz = parcelRequire("bS1iz");

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $5Ky5U = parcelRequire("5Ky5U");
const $d4250c73fee01b4d$var$PACKAGE_NAME = 'jiraAdminPagesIssueTypeSchemesDirectory';
const $d4250c73fee01b4d$export$2844cac611eecaa7 = async (qs)=>{
    const filter = (0, $5Ky5U.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify((0, $5Ky5U.toApiUrlTransformer)(filter));
    try {
        return await (0, $h2wCv.performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: $d4250c73fee01b4d$var$PACKAGE_NAME,
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("5Ky5U", function(module, exports) {
$parcel$export(module.exports, "toUrlTransformer", () => $c4680e7623adf949$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $c4680e7623adf949$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $c4680e7623adf949$export$fb15afa686993f11);

var $3sdCD = parcelRequire("3sdCD");

var $29Z3v = parcelRequire("29Z3v");

var $aGJxI = parcelRequire("aGJxI");

var $gc4UG = parcelRequire("gc4UG");
const $c4680e7623adf949$var$MAX_RESULTS = 10;
const $c4680e7623adf949$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy
    };
};
const $c4680e7623adf949$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
    const parsedNumber = Number.isNaN((0, $29Z3v.number).parse(pageNumber)) ? (0, $aGJxI.defaultIssueTypeSchemesFilter).pageNumber : (0, $29Z3v.number).parse(pageNumber);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
    return {
        ...(0, $aGJxI.defaultIssueTypeSchemesFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy
    };
};
const $c4680e7623adf949$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($3sdCD)))({}, filter, (0, $aGJxI.defaultIssueTypeSchemesFilter));
    let requestParams = {
        maxResults: $c4680e7623adf949$var$MAX_RESULTS,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.pageNumber - 1) * $c4680e7623adf949$var$MAX_RESULTS,
        orderBy: fullFilter.orderBy,
        queryString: (0, $gc4UG.trimSearchFilter)(fullFilter.searchFilter)
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("aGJxI", function(module, exports) {
$parcel$export(module.exports, "ORDER", () => $0263659b9608a2d3$export$11e75bce9f7ea886);
$parcel$export(module.exports, "defaultIssueTypeSchemesFilter", () => $0263659b9608a2d3$export$625de46796f967ae);
$parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", () => $0263659b9608a2d3$export$81a0343467d0e9a9);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $0263659b9608a2d3$export$9ac56b2484c2d4e9);
// analytics constants
const $0263659b9608a2d3$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $0263659b9608a2d3$var$MAX_RESULTS = 10;
const $0263659b9608a2d3$export$625de46796f967ae = {
    pageNumber: 1,
    pageSize: $0263659b9608a2d3$var$MAX_RESULTS,
    expand: [
        'projects',
        'issueTypes'
    ],
    orderBy: 'name',
    sortDirection: 'DESC'
};
const $0263659b9608a2d3$export$81a0343467d0e9a9 = {
    startAt: 0,
    maxResults: 10,
    values: [],
    total: 0,
    isLast: true
};
const $0263659b9608a2d3$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});

});

parcelRegister("gc4UG", function(module, exports) {
$parcel$export(module.exports, "trimSearchFilter", () => $22cc65585063e2e8$export$ed1722f41c23aaaf);
const $22cc65585063e2e8$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});




parcelRegister("98cu9", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", () => $35d454ed9387ccda$export$2aba97aa663f43b3);
const $35d454ed9387ccda$export$2aba97aa663f43b3 = {
    name: 'global-settings-issues-types-schemes-manage',
    path: '/jira/settings/issues/issue-type-schemes'
};

});

parcelRegister("6CJL4", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeSchemesDirectory", () => $00b517c4d205642c$export$611728a54ba37830);
$parcel$export(module.exports, "default", () => $00b517c4d205642c$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $00b517c4d205642c$export$611728a54ba37830 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7w3Ie"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-issue-types-issue-type-schemes-directory/src/IssueTypeSchemesDirectory.tsx"
});
const $00b517c4d205642c$var$AsyncIssueTypeSchemesDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $00b517c4d205642c$export$611728a54ba37830,
        pageId: "jira-admin-pages-issue-type-schemes-directory",
        shouldShowSpinner: true
    });
$00b517c4d205642c$var$AsyncIssueTypeSchemesDirectory.displayName = "AsyncIssueTypeSchemesDirectory";
var $00b517c4d205642c$export$2e2bcd8739ae039 = $00b517c4d205642c$var$AsyncIssueTypeSchemesDirectory;

});
parcelRegister("7w3Ie", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cyxaU").then(()=>parcelRequire('g9gj6'));

});



parcelRegister("jYUJK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRouteEntry", () => $5d658cdd6a10dccf$export$e2c2c1569887e684);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $dgO5H = parcelRequire("dgO5H");

var $35eqr = parcelRequire("35eqr");

var $5B7iT = parcelRequire("5B7iT");
const $5d658cdd6a10dccf$export$e2c2c1569887e684 = (0, $fdS54.createEntry)((0, $dgO5H.globalSettingsIssueTypesScreenSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-type-screen-schemes',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5B7iT.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5B7iT.LazyIssueTypeScreenSchemesPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dgO5H", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRoute", () => $77c289b2208cb90e$export$df93a4addc359237);
const $77c289b2208cb90e$export$df93a4addc359237 = {
    name: 'global-settings-issues-types-screen-schemes-view',
    path: '/jira/settings/issues/issue-type-screen-schemes'
};

});

parcelRegister("5B7iT", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeScreenSchemesPage", () => $7eede612ca0d103d$export$350edfb57b335a57);
$parcel$export(module.exports, "default", () => $7eede612ca0d103d$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7eede612ca0d103d$export$350edfb57b335a57 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("eSlR6"))), {
    moduleId: "./src/packages/admin-pages/issue-type-screen-schemes-page/src/IssueTypeScreenSchemesPage.tsx"
});
const $7eede612ca0d103d$var$AsyncIssueTypeScreenSchemesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7eede612ca0d103d$export$350edfb57b335a57,
        pageId: "jira-admin-pages-issue-type-screen-schemes-page",
        shouldShowSpinner: true
    });
$7eede612ca0d103d$var$AsyncIssueTypeScreenSchemesPage.displayName = "AsyncIssueTypeScreenSchemesPage";
var $7eede612ca0d103d$export$2e2bcd8739ae039 = $7eede612ca0d103d$var$AsyncIssueTypeScreenSchemesPage;

});
parcelRegister("eSlR6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aJylX").then(()=>parcelRequire('9iP9o'));

});



parcelRegister("avx7c", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflow1RouteEntry", () => $e4219f8d1c542e80$export$55e4c1d21a9b75e6);
/* eslint-disable import/order */ 
var $ll8XL = parcelRequire("ll8XL");



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $caf8y = parcelRequire("caf8y");

var $35eqr = parcelRequire("35eqr");

var $iIEs1 = parcelRequire("iIEs1");
const $e4219f8d1c542e80$export$55e4c1d21a9b75e6 = (0, $fdS54.createEntry)((0, $caf8y.globalSettingsIssueWorkflow1Route), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-workflows',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $iIEs1.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $ll8XL.default),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $iIEs1.LazyListWorkflows)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ll8XL", function(module, exports) {
$parcel$export(module.exports, "default", () => $2171f4e412058028$export$2e2bcd8739ae039);

var $bS1iz = parcelRequire("bS1iz");

var $7edbf = parcelRequire("7edbf");

var $5lbg3 = parcelRequire("5lbg3");
const $2171f4e412058028$var$WORKFLOWS_TABLE_TYPE = 'WORKFLOWS_TABLE';
const $2171f4e412058028$var$WORKFLOWS_TABLE_KEY = 'WORKFLOWS_TABLE_KEY';
const $2171f4e412058028$var$workFlowsResource = (0, $7edbf.createResource)({
    type: $2171f4e412058028$var$WORKFLOWS_TABLE_TYPE,
    getKey: ({ query: query })=>`${$2171f4e412058028$var$WORKFLOWS_TABLE_KEY}-${(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $5lbg3.getListWorkFlows)((0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(query))
});
var $2171f4e412058028$export$2e2bcd8739ae039 = $2171f4e412058028$var$workFlowsResource;

});
parcelRegister("5lbg3", function(module, exports) {
$parcel$export(module.exports, "getListWorkFlows", () => $8d6280fdd67ea4d4$export$952f5d693c3c0d4e);

var $bS1iz = parcelRequire("bS1iz");

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $9KCor = parcelRequire("9KCor");

var $aQdsD = parcelRequire("aQdsD");
const $8d6280fdd67ea4d4$export$952f5d693c3c0d4e = async (qs)=>{
    const filter = (0, $aQdsD.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify((0, $aQdsD.toApiUrlTransformer)(filter));
    try {
        return await (0, $h2wCv.performGetRequest)(`/rest/api/3/workflow/search?${query}`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getWorkflowsSearchAPI',
                packageName: (0, $9KCor.PACKAGE_NAME),
                teamName: 'helix'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("9KCor", function(module, exports) {
$parcel$export(module.exports, "APP_NAME", () => $be119da09bc7a29e$export$5b6c28c7dca07ad7);
$parcel$export(module.exports, "TEAM_NAME", () => $be119da09bc7a29e$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SOURCE_NAME", () => $be119da09bc7a29e$export$a3821bc63538b210);
$parcel$export(module.exports, "WORKFLOW_NAME", () => $be119da09bc7a29e$export$a69699c3acbd94ca);
$parcel$export(module.exports, "PACKAGE_NAME", () => $be119da09bc7a29e$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "WORKFLOWS_ACTIONS", () => $be119da09bc7a29e$export$f3ab46ae5f3c01ad);
$parcel$export(module.exports, "WORKFLOWS_SCHEME", () => $be119da09bc7a29e$export$81c9aaf617cb2f01);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", () => $be119da09bc7a29e$export$615f1d8b29794ae);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", () => $be119da09bc7a29e$export$fccd4c1ce5f0896f);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $be119da09bc7a29e$export$5716e8bcb003888d);
$parcel$export(module.exports, "defaultListWorkFlowsFilter", () => $be119da09bc7a29e$export$dc5aae53031515c);
$parcel$export(module.exports, "ORDER", () => $be119da09bc7a29e$export$11e75bce9f7ea886);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $be119da09bc7a29e$export$9ac56b2484c2d4e9);
$parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", () => $be119da09bc7a29e$export$e6613a3c77896936);
$parcel$export(module.exports, "API_PREFIX", () => $be119da09bc7a29e$export$a3f6840410eb0571);
const $be119da09bc7a29e$export$5b6c28c7dca07ad7 = 'jira';
const $be119da09bc7a29e$export$d57b6b390e78d90f = 'helix';
const $be119da09bc7a29e$export$a3821bc63538b210 = 'listWorkflows';
const $be119da09bc7a29e$export$a69699c3acbd94ca = 'workflowName';
const $be119da09bc7a29e$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
const $be119da09bc7a29e$export$f3ab46ae5f3c01ad = 'workflowsActions';
const $be119da09bc7a29e$export$81c9aaf617cb2f01 = 'workflowScheme';
const $be119da09bc7a29e$export$615f1d8b29794ae = 'jira';
const $be119da09bc7a29e$export$fccd4c1ce5f0896f = 'Builds Workflow';
const $be119da09bc7a29e$export$5716e8bcb003888d = 10;
const $be119da09bc7a29e$export$dc5aae53031515c = {
    pageNumber: 1,
    pageSize: $be119da09bc7a29e$export$5716e8bcb003888d,
    expand: [
        'default',
        'hasDraftWorkflow',
        'schemes',
        'operations',
        'projects',
        'transitions.count',
        'transitions.limits.count',
        'statuses.count',
        'statuses.limits.count'
    ],
    orderBy: 'name',
    sortDirection: 'ASC',
    isActive: true
};
const $be119da09bc7a29e$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $be119da09bc7a29e$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});
const $be119da09bc7a29e$export$e6613a3c77896936 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'pageSize'
});
const $be119da09bc7a29e$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';

});

parcelRegister("aQdsD", function(module, exports) {
$parcel$export(module.exports, "toUrlTransformer", () => $ad722c4e1e68109a$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $ad722c4e1e68109a$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $ad722c4e1e68109a$export$fb15afa686993f11);

var $29Z3v = parcelRequire("29Z3v");

var $9KCor = parcelRequire("9KCor");

var $26sw5 = parcelRequire("26sw5");
const $ad722c4e1e68109a$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy,
        isActive: isActive,
        pageSize: pageSize
    };
};
const $ad722c4e1e68109a$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
    const parsedNumber = Number.isNaN((0, $29Z3v.number).parse(pageNumber)) ? (0, $9KCor.defaultListWorkFlowsFilter).pageNumber : (0, $29Z3v.number).parse(pageNumber);
    const parsedSize = Number.isNaN((0, $29Z3v.number).parse(pageSize)) ? (0, $9KCor.defaultListWorkFlowsFilter).pageSize : (0, $29Z3v.number).parse(pageSize);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
    const isActiveFinal = isActive != null ? isActive === 'true' : (0, $9KCor.defaultListWorkFlowsFilter).isActive;
    return {
        ...(0, $9KCor.defaultListWorkFlowsFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        pageSize: parsedSize != null ? Number(parsedSize) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy,
        isActive: isActiveFinal
    };
};
const $ad722c4e1e68109a$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = {
        ...(0, $9KCor.defaultListWorkFlowsFilter),
        ...filter
    };
    const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, $9KCor.DEFAULT_PAGE_SIZE) } = fullFilter;
    let requestParams = {
        maxResults: pageSize,
        startAt: (pageNumber - 1) * pageSize,
        orderBy: fullFilter.orderBy,
        queryString: (0, $26sw5.trimSearchFilter)(fullFilter.searchFilter),
        isActive: fullFilter.isActive
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("26sw5", function(module, exports) {
$parcel$export(module.exports, "trimSearchFilter", () => $a956bb331be761d6$export$ed1722f41c23aaaf);
const $a956bb331be761d6$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});




parcelRegister("caf8y", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflow1Route", () => $77c6e4c02fcbf603$export$f8f2a617a2f4d53);
const $77c6e4c02fcbf603$export$f8f2a617a2f4d53 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/jira/settings/issues/workflows'
};

});

parcelRegister("iIEs1", function(module, exports) {
$parcel$export(module.exports, "LazyListWorkflows", () => $c8aeb0a51731ab33$export$4c64b4f1ecf22fc8);
$parcel$export(module.exports, "default", () => $c8aeb0a51731ab33$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $c8aeb0a51731ab33$export$4c64b4f1ecf22fc8 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("edNfB"))), {
    moduleId: "./src/packages/admin-pages/list-workflows/src/ListWorkflows.tsx"
});
const $c8aeb0a51731ab33$var$AsyncListWorkflows = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c8aeb0a51731ab33$export$4c64b4f1ecf22fc8,
        pageId: "jira-admin-pages-list-workflows",
        shouldShowSpinner: true
    });
$c8aeb0a51731ab33$var$AsyncListWorkflows.displayName = "AsyncListWorkflows";
var $c8aeb0a51731ab33$export$2e2bcd8739ae039 = $c8aeb0a51731ab33$var$AsyncListWorkflows;

});
parcelRegister("edNfB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ge5aU").then(()=>parcelRequire('ikGV8'));

});



parcelRegister("38q9i", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRouteEntry", () => $5b8e2631e85bdb17$export$d2b3121978e344e);
/* eslint-disable import/order */ 
var $lmScC = parcelRequire("lmScC");

var $fp0BT = parcelRequire("fp0BT");

var $e2Z3B = parcelRequire("e2Z3B");

var $cH5Ll = parcelRequire("cH5Ll");

var $fyoT9 = parcelRequire("fyoT9");

var $dTa0V = parcelRequire("dTa0V");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $2PqkI = parcelRequire("2PqkI");

var $6DfNt = parcelRequire("6DfNt");

var $4B518 = parcelRequire("4B518");

var $6bGyp = parcelRequire("6bGyp");
const $5b8e2631e85bdb17$var$globalSettingsIssueWorkflowEditEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $lmScC.editWorkflowEntryPoint)
});
const $5b8e2631e85bdb17$var$getWorkflowBuilderProvisioningResources = ()=>[
        (0, $fyoT9.workflowBuilderProvisioningResource)
    ];
const $5b8e2631e85bdb17$export$d2b3121978e344e = (0, $fdS54.createEntry)((0, $2PqkI.globalSettingsIssueWorkflowEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.edit-workflow',
        entryPoint: ()=>$5b8e2631e85bdb17$var$globalSettingsIssueWorkflowEditEntryPoint,
        skeleton: (0, $6DfNt.default),
        // eslint-disable-next-line no-restricted-syntax
        component: undefined,
        layout: (0, $byMD7.chromelessLayout),
        navigation: undefined,
        resources: [
            (0, $e2Z3B.workflowCapabilitiesResource),
            (0, $cH5Ll.workflowDocumentResource),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $6bGyp.rovoEntitlementResource),
            (0, $fp0BT.workflowUserPreferencesResource),
            ...$5b8e2631e85bdb17$var$getWorkflowBuilderProvisioningResources()
        ],
        forPaint: undefined,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lmScC", function(module, exports) {
$parcel$export(module.exports, "editWorkflowEntryPoint", () => $26b34d24ea429fca$export$8173c14a99f6a4bb);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $26b34d24ea429fca$export$8173c14a99f6a4bb = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dGca7")), {
        moduleId: "9f739006",
        moduleName: "EditWorkflow",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dGca7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("60zSt")
]).then(()=>parcelRequire('iJC2V'));

});


parcelRegister("fp0BT", function(module, exports) {
$parcel$export(module.exports, "workflowUserPreferencesResource", () => $c3b9b28f210fce5e$export$dcc0e7a13dca73a4);
$parcel$export(module.exports, "useWorkflowUserPreference", () => $c3b9b28f210fce5e$export$63db1f00a6f1699b);
$parcel$export(module.exports, "useWorkflowUserPreferencesInitialiser", () => $c3b9b28f210fce5e$export$a568f6667d8c2696);
$parcel$export(module.exports, "useCollapseTransitionLabelsPreferenceFromResource", () => $c3b9b28f210fce5e$export$31ee5a83bc933bf);

var $euxye = parcelRequire("euxye");

var $7edbf = parcelRequire("7edbf");


var $g61Fi = parcelRequire("g61Fi");

var $gvFYu = parcelRequire("gvFYu");
const $c3b9b28f210fce5e$var$workflowUserPreferenceKeys = [
    (0, $fd6393214f9b270b$export$deefa5c1f10c69a0),
    (0, $fd6393214f9b270b$export$1e110a15789b066c),
    (0, $fd6393214f9b270b$export$a08cbe94405fa92),
    (0, $fd6393214f9b270b$export$2ed404c7f997572a),
    (0, $fd6393214f9b270b$export$5fd42b645db6c7db)
];
const $c3b9b28f210fce5e$export$dcc0e7a13dca73a4 = (0, $7edbf.createResource)({
    type: (0, $fd6393214f9b270b$export$952d335c91f3dcbc),
    getKey: ()=>(0, $fd6393214f9b270b$export$952d335c91f3dcbc),
    getData: ()=>(0, $g61Fi.getUserPreferences)([
            ...$c3b9b28f210fce5e$var$workflowUserPreferenceKeys
        ]),
    maxAge: 1000,
    isBrowserOnly: true
});
const $c3b9b28f210fce5e$export$63db1f00a6f1699b = (key, options)=>(0, $gvFYu.useUserPreference)($c3b9b28f210fce5e$export$dcc0e7a13dca73a4, key, options);
const $c3b9b28f210fce5e$export$a568f6667d8c2696 = ()=>(0, $gvFYu.useUserPreferencesInitialiser)($c3b9b28f210fce5e$export$dcc0e7a13dca73a4);
const $c3b9b28f210fce5e$export$31ee5a83bc933bf = ()=>{
    const { value: value, setValue: setValue } = $c3b9b28f210fce5e$export$63db1f00a6f1699b((0, $fd6393214f9b270b$export$2ed404c7f997572a));
    const areTransitionLabelsCollapsed = !value ? true : value === 'true';
    const setTransitionLabelsCollapsed = (0, $euxye.useCallback)((collapsed)=>{
        setValue(collapsed.toString());
    }, [
        setValue
    ]);
    return {
        value: areTransitionLabelsCollapsed,
        setValue: setTransitionLabelsCollapsed
    };
};

});
const $fd6393214f9b270b$export$952d335c91f3dcbc = 'ADMIN_WORKFLOW_USER_PREFERENCES';
const $fd6393214f9b270b$export$2ed404c7f997572a = 'jira.user.workflow.editor.collapsed.transitions';
const $fd6393214f9b270b$export$a08cbe94405fa92 = 'jira.user.workflow.editor.list-view';
const $fd6393214f9b270b$export$deefa5c1f10c69a0 = 'jira.user.workflow.editor.global.scope.enrolment';
const $fd6393214f9b270b$export$1e110a15789b066c = 'jira.user.workflow.editor.changeboarding-dismissed';
const $fd6393214f9b270b$export$5fd42b645db6c7db = 'jira.user.workflow.editor.new-editor-default-for-all-warning-seen';

parcelRegister("g61Fi", function(module, exports) {
$parcel$export(module.exports, "getUserPreferences", () => $8a9289d64afdc77c$export$ae3f5fa351e2f57a);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");
const $8a9289d64afdc77c$export$165e2fbe12123208 = (keys)=>`
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [${keys.map((key)=>`"${key}"`).join(', ')}])
}
`;
const $8a9289d64afdc77c$export$ae3f5fa351e2f57a = async (keys)=>{
    try {
        const apiResult = await (0, $h2wCv.performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $8a9289d64afdc77c$export$165e2fbe12123208(keys)
            })
        });
        return apiResult.data.myPreferences;
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error instanceof Error ? error : undefined,
            meta: {
                id: 'getUserPreferences',
                packageName: 'jiraAdminPagesWorkflowsUserPreferences',
                teamName: 'Helix'
            }
        });
        throw error;
    }
};

});

parcelRegister("gvFYu", function(module, exports) {
$parcel$export(module.exports, "useUserPreference", () => $5533b746b0bf1b2a$export$67772f4a901db59b);
$parcel$export(module.exports, "useUserPreferencesInitialiser", () => $5533b746b0bf1b2a$export$2b48814b5b24efde);

var $k6ufm = parcelRequire("k6ufm");

var $c9EX6 = parcelRequire("c9EX6");
const $5533b746b0bf1b2a$export$67772f4a901db59b = (resource, key, options)=>{
    const { data: data, update: update, error: error, loading: loading } = (0, $k6ufm.useResource)(resource);
    const value = data?.[key];
    const setValue = (newValue)=>{
        const formattedNewValue = options?.skipValueFormatting ? newValue : $5533b746b0bf1b2a$var$encodeValueObject(newValue);
        update((d)=>({
                ...d,
                [key]: formattedNewValue
            }));
        (0, $c9EX6.setUserPreference)(key, formattedNewValue);
    };
    try {
        const formattedValue = options?.skipValueFormatting ? value : $5533b746b0bf1b2a$var$decodeValueObject(value);
        return {
            value: formattedValue,
            setValue: setValue,
            error: error,
            loading: loading
        };
    } catch (formattingError) {
        return {
            value: undefined,
            setValue: setValue,
            error: formattingError instanceof Error ? formattingError : error,
            loading: loading
        };
    }
};
const $5533b746b0bf1b2a$export$2b48814b5b24efde = (resource)=>{
    const { refresh: refresh, loading: loading, error: error, data: data } = (0, $k6ufm.useResource)(resource);
    const initialise = ()=>{
        if (data === null && error === null && !loading) refresh();
    };
    return {
        initialise: initialise
    };
};
const $5533b746b0bf1b2a$var$decodeValueObject = (value)=>{
    if (!value) return value;
    return JSON.parse(value)?.value;
};
const $5533b746b0bf1b2a$var$encodeValueObject = (value)=>{
    return JSON.stringify({
        value: value
    });
};

});
parcelRegister("c9EX6", function(module, exports) {
$parcel$export(module.exports, "setUserPreference", () => $7e8fc1060842794f$export$b2da77ffcb5ccb19);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");
const $7e8fc1060842794f$export$615e3c066435ee7d = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $7e8fc1060842794f$export$b2da77ffcb5ccb19 = async (key, value)=>{
    try {
        const result = await (0, $h2wCv.performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $7e8fc1060842794f$export$615e3c066435ee7d,
                variables: {
                    input: {
                        key: key,
                        value: value
                    }
                }
            })
        });
        if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${key}`, {
            cause: result.errors?.[0]
        });
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error instanceof Error ? error : undefined,
            meta: {
                id: 'setUserPreference',
                packageName: 'jiraAdminPagesWorkflowsUserPreferences',
                teamName: 'Helix'
            }
        });
        throw error;
    }
};

});



parcelRegister("e2Z3B", function(module, exports) {
$parcel$export(module.exports, "workflowCapabilitiesResource", () => $cb4a10eedcd479fe$export$752f9619231646c7);
$parcel$export(module.exports, "useWorkflowCapabilities", () => $cb4a10eedcd479fe$export$861a32391dc35e21);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $5atFb = parcelRequire("5atFb");
const $cb4a10eedcd479fe$export$e683a752d2185432 = 'ADMIN_WORKFLOW_CAPABILITIES';
const $cb4a10eedcd479fe$export$752f9619231646c7 = (0, $7edbf.createResource)({
    type: $cb4a10eedcd479fe$export$e683a752d2185432,
    getKey: (matchedRoute)=>{
        const { workflowId: workflowId, projectKey: projectKey, issueTypeId: issueTypeId } = matchedRoute.match.params;
        if (workflowId) return `${$cb4a10eedcd479fe$export$e683a752d2185432}_${workflowId}`;
        return `${$cb4a10eedcd479fe$export$e683a752d2185432}_${projectKey}_${issueTypeId}`;
    },
    getData: async (routerContext, customContext)=>(0, $5atFb.fetchWorkflowCapabilities)(routerContext, customContext),
    maxAge: 0,
    isBrowserOnly: true
});
const $cb4a10eedcd479fe$export$861a32391dc35e21 = ()=>(0, $k6ufm.useResource)($cb4a10eedcd479fe$export$752f9619231646c7);

});
parcelRegister("5atFb", function(module, exports) {
$parcel$export(module.exports, "fetchWorkflowCapabilities", () => $daa3d14ae089438d$export$51e1638cbea98309);

var $4vwPT = parcelRequire("4vwPT");

var $bdEst = parcelRequire("bdEst");

var $6xuJS = parcelRequire("6xuJS");

var $khHvh = parcelRequire("khHvh");
const $daa3d14ae089438d$export$51e1638cbea98309 = async (routerContext, { tenantContext: tenantContext })=>{
    const { match: match } = routerContext;
    const { isAnonymous: isAnonymous, cloudId: cloudId } = tenantContext;
    if (isAnonymous) throw new Error("Workflows can't be edited in anonymous mode.");
    if (!match.params.workflowId && !match.params.projectKey && !match.params.issueTypeId) throw new Error('Workflow ID, project Key, or issue type ID is not defined.');
    try {
        // better way to monitor perf?
        (0, $6xuJS.setMark)((0, $khHvh.prefetchApiStartMark));
        let workflowCapabilities = null;
        if (match.params.workflowId) workflowCapabilities = await (0, $4vwPT.getWorkflowCapabilities)(cloudId, {
            workflowId: match.params.workflowId
        });
        else if (match.params.projectKey && match.params.issueTypeId) {
            const workflowIdentifier = {
                projectKey: match.params.projectKey,
                issueTypeId: match.params.issueTypeId
            };
            workflowCapabilities = await (0, $4vwPT.getWorkflowCapabilities)(cloudId, workflowIdentifier);
        }
        if (!workflowCapabilities) throw new Error('Workflow ID, project ID, or issue type ID is not defined.');
        (0, $6xuJS.setMark)((0, $khHvh.prefetchApiReadyMark));
        return workflowCapabilities;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $bdEst.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-capabilities.getData',
            message: 'An error was thrown while prefetching workflow capabilities data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("4vwPT", function(module, exports) {
$parcel$export(module.exports, "getWorkflowCapabilities", () => $0a1c15b1bd991361$export$334f82027882d665);

var $aVkFp = parcelRequire("aVkFp");

var $4fhEY = parcelRequire("4fhEY");

var $6CfY5 = parcelRequire("6CfY5");
const $0a1c15b1bd991361$var$getApiPrefix = ()=>'gateway/api/jira/project-configuration';
const $0a1c15b1bd991361$export$a5b7a8c3b1c6e775 = (cloudId, params)=>`/${$0a1c15b1bd991361$var$getApiPrefix()}/query/${cloudId}/workflow/capabilities?${(0, $aVkFp.stringify)(params)}`;
const $0a1c15b1bd991361$export$334f82027882d665 = (cloudId, options)=>(0, $4fhEY.default)($0a1c15b1bd991361$export$a5b7a8c3b1c6e775(cloudId, options), {
        method: 'GET'
    }).catch((e)=>{
        (0, $6CfY5.default).safeErrorWithoutCustomerData('getWorkflowAvailableCapabilities', e);
        throw e;
    });

});
parcelRegister("aVkFp", function(module, exports) {
$parcel$export(module.exports, "decode", () => $7f3f424a27a36562$export$2f872c0f2117be69, (v) => $7f3f424a27a36562$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $7f3f424a27a36562$export$98e6a39c04603d36, (v) => $7f3f424a27a36562$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $7f3f424a27a36562$export$c564cdbbe6da493, (v) => $7f3f424a27a36562$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $7f3f424a27a36562$export$fac44ee5b035f737, (v) => $7f3f424a27a36562$export$fac44ee5b035f737 = v);
var $7f3f424a27a36562$export$2f872c0f2117be69;
var $7f3f424a27a36562$export$98e6a39c04603d36;
var $7f3f424a27a36562$export$c564cdbbe6da493;
var $7f3f424a27a36562$export$fac44ee5b035f737;
'use strict';

$7f3f424a27a36562$export$2f872c0f2117be69 = $7f3f424a27a36562$export$98e6a39c04603d36 = (parcelRequire("2IFeo"));

$7f3f424a27a36562$export$c564cdbbe6da493 = $7f3f424a27a36562$export$fac44ee5b035f737 = (parcelRequire("6fiiO"));

});
parcelRegister("2IFeo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $1fafac7ec16ad14b$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$1fafac7ec16ad14b$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($1fafac7ec16ad14b$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $1fafac7ec16ad14b$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("6fiiO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $48c2574b0dcca79b$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $48c2574b0dcca79b$var$map($48c2574b0dcca79b$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($48c2574b0dcca79b$var$stringifyPrimitive(k)) + eq;
        if ($48c2574b0dcca79b$var$isArray(obj[k])) return $48c2574b0dcca79b$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($48c2574b0dcca79b$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($48c2574b0dcca79b$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($48c2574b0dcca79b$var$stringifyPrimitive(name)) + eq + encodeURIComponent($48c2574b0dcca79b$var$stringifyPrimitive(obj));
};
var $48c2574b0dcca79b$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $48c2574b0dcca79b$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $48c2574b0dcca79b$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});





parcelRegister("cH5Ll", function(module, exports) {
$parcel$export(module.exports, "workflowDocumentResource", () => $a384b4daef7745c3$export$b63b10ddc49fa54f);
$parcel$export(module.exports, "useWorkflowDocument", () => $a384b4daef7745c3$export$1ed79b881a7cb8b1);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $fwcGe = parcelRequire("fwcGe");
const $a384b4daef7745c3$export$e683a752d2185432 = 'ADMIN_WORKFLOW_DOCUMENT';
const $a384b4daef7745c3$export$b63b10ddc49fa54f = (0, $7edbf.createResource)({
    type: $a384b4daef7745c3$export$e683a752d2185432,
    getKey: (matchedRoute)=>{
        const { workflowId: workflowId, projectKey: projectKey, issueTypeId: issueTypeId } = matchedRoute.match.params;
        if (workflowId) return `${$a384b4daef7745c3$export$e683a752d2185432}_${workflowId}`;
        return `${$a384b4daef7745c3$export$e683a752d2185432}_${projectKey}_${issueTypeId}`;
    },
    getData: async (routerContext, customContext)=>(0, $fwcGe.fetchWorkflowDocument)(routerContext, customContext, false),
    maxAge: 0,
    isBrowserOnly: true
});
const $a384b4daef7745c3$export$1ed79b881a7cb8b1 = ()=>(0, $k6ufm.useResource)($a384b4daef7745c3$export$b63b10ddc49fa54f);

});
parcelRegister("fwcGe", function(module, exports) {
$parcel$export(module.exports, "fetchWorkflowDocument", () => $2ffd2ef095c8235e$export$f9f333ad2a8d394b);

var $gkOMk = parcelRequire("gkOMk");

var $bdEst = parcelRequire("bdEst");

var $6xuJS = parcelRequire("6xuJS");

var $khHvh = parcelRequire("khHvh");
const $2ffd2ef095c8235e$export$f9f333ad2a8d394b = async (routerContext, { tenantContext: tenantContext }, isProjectScoped)=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = tenantContext;
    const { match: match } = routerContext;
    if (isAnonymous) throw new Error("Workflows can't be edited in anonymous mode.");
    if (!match.params.workflowId && !match.params.projectKey && !match.params.issueTypeId) throw new Error('Workflow ID, project Key, or issue type ID is not defined.');
    try {
        (0, $6xuJS.setMark)((0, $khHvh.prefetchApiStartMark));
        let workflowDocument = null;
        if (match.params.workflowId) workflowDocument = await (0, $gkOMk.getWorkflow)(cloudId, {
            workflowId: match.params.workflowId
        }, {
            checkForDrafts: !isProjectScoped
        });
        else if (match.params.projectKey && match.params.issueTypeId) {
            const workflowIdentifier = {
                projectKeyAndIssueType: {
                    projectKey: match.params.projectKey,
                    issueTypeId: match.params.issueTypeId
                }
            };
            workflowDocument = await (0, $gkOMk.getWorkflow)(cloudId, workflowIdentifier, {
                checkForDrafts: !isProjectScoped
            });
        } else throw new Error('Project workflow context is not defined.');
        if (!workflowDocument) throw new Error('Workflow ID, project ID, or issue type ID is not defined.');
        (0, $6xuJS.setMark)((0, $khHvh.prefetchApiReadyMark));
        return workflowDocument;
    } catch (error) {
        throw (0, $bdEst.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-document.getData',
            message: 'An error was thrown while prefetching workflow document data',
            name: 'ResourceError'
        }, // oxlint-disable-next-line @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions
        error);
    }
};

});
parcelRegister("gkOMk", function(module, exports) {
$parcel$export(module.exports, "getWorkflow", () => $e13598c9ba023b81$export$f927248b35ee72a7);

var $WqSvO = parcelRequire("WqSvO");

var $h2wCv = parcelRequire("h2wCv");
const $e13598c9ba023b81$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';
const $e13598c9ba023b81$export$a5b7a8c3b1c6e775 = (cloudId)=>`/${$e13598c9ba023b81$export$c1b7f62a96ae605b()}/query/${cloudId}/3/workflow`;
const $e13598c9ba023b81$export$f927248b35ee72a7 = (cloudId, workflowIdentifier, config)=>{
    const url = $e13598c9ba023b81$export$a5b7a8c3b1c6e775(cloudId);
    const { workflowId: workflowId, workflowName: workflowName, projectAndIssueType: projectAndIssueType, projectKeyAndIssueType: projectKeyAndIssueType } = workflowIdentifier;
    const payload = {
        skipUsageLookup: false
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(workflowId)) payload.workflowIds = [
        workflowId
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(workflowName)) payload.workflowNames = [
        workflowName
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(projectAndIssueType)) payload.projectAndIssueTypes = [
        projectAndIssueType
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(projectKeyAndIssueType)) payload.projectKeyAndIssueTypes = [
        projectKeyAndIssueType
    ];
    if (config?.checkForDrafts) payload.checkForDrafts = true;
    if (config?.getDrafts) payload.getDrafts = true;
    return (0, $h2wCv.performPostRequest)(url, {
        body: JSON.stringify(payload)
    });
};

});



parcelRegister("fyoT9", function(module, exports) {
$parcel$export(module.exports, "workflowBuilderProvisioningResource", () => $b8ca3f373283433e$export$5dd78fb4d8e7d884);
$parcel$export(module.exports, "useWorkflowBuilderProvisioning", () => $b8ca3f373283433e$export$31f614b597ebcd64);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $hWvFC = parcelRequire("hWvFC");
const $b8ca3f373283433e$export$e683a752d2185432 = 'ADMIN_WORKFLOW_BUILDER_PROVISIONING';
const $b8ca3f373283433e$export$5dd78fb4d8e7d884 = (0, $7edbf.createResource)({
    type: $b8ca3f373283433e$export$e683a752d2185432,
    getKey: ()=>$b8ca3f373283433e$export$e683a752d2185432,
    getData: (0, $hWvFC.fetchWorkflowBuilderProvisioning),
    maxAge: 1000,
    isBrowserOnly: true
});
const $b8ca3f373283433e$export$31f614b597ebcd64 = ()=>(0, $k6ufm.useResource)($b8ca3f373283433e$export$5dd78fb4d8e7d884);

});
parcelRegister("hWvFC", function(module, exports) {
$parcel$export(module.exports, "fetchWorkflowBuilderProvisioning", () => $a56320cf2176d6ff$export$cd22f6e9979f476b);

var $7tjnB = parcelRequire("7tjnB");

var $bdEst = parcelRequire("bdEst");

var $6xuJS = parcelRequire("6xuJS");

var $khHvh = parcelRequire("khHvh");

var $h2wCv = parcelRequire("h2wCv");
const $a56320cf2176d6ff$export$97c8b1e63b442341 = (licenseStates)=>{
    const licenseStateKeys = [
        'core',
        'software',
        'serviceDesk',
        'customerService',
        'productDiscovery'
    ];
    const licenseKeyToXProduct = {
        core: 'jira-software',
        software: 'jira-software',
        serviceDesk: 'jsm',
        customerService: 'csm',
        productDiscovery: 'jpd'
    };
    if (!licenseStates) return 'jira';
    const activeKeys = licenseStateKeys.filter((key)=>licenseStates[key] === (0, $7tjnB.LICENSE_STATE_ACTIVE));
    if (activeKeys.length !== 1) return 'jira';
    return licenseKeyToXProduct[activeKeys[0]] ?? 'jira';
};
const $a56320cf2176d6ff$export$cd22f6e9979f476b = async ({ match: _match }, { tenantContext: tenantContext })=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId, licenseStates: licenseStates } = tenantContext;
    if (isAnonymous) {
        const message = "Workflows can't be edited in anonymous mode.";
        throw new Error(message);
    }
    try {
        (0, $6xuJS.setMark)((0, $khHvh.prefetchApiStartMark));
        await (0, $h2wCv.performPostRequest)('/gateway/api/assist/v1/agent/provisioning/ootb/jira_workflow_builder_agent', {
            headers: {
                'X-Product': $a56320cf2176d6ff$export$97c8b1e63b442341(licenseStates),
                'X-Experience-Id': 'ai-mate',
                'Atl-Cloudid': cloudId
            }
        });
        (0, $6xuJS.setMark)((0, $khHvh.prefetchApiReadyMark));
        // If the request is successful, we return true as this means that the workflow builder was already provisioned or has just succesfully been provisioned
        return true;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $bdEst.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-builder-provisioning.getData',
            message: 'An error was thrown while prefetching workflow builder provisioning',
            name: 'ResourceError'
        }, error);
    }
};

});


parcelRegister("2PqkI", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRoute", () => $46c06d37ac8ad8eb$export$9d533f08a4447cc);
const $46c06d37ac8ad8eb$export$9d533f08a4447cc = {
    name: 'global-settings-issues-workflow-edit',
    path: '/jira/settings/issues/workflows/:workflowId'
};

});


parcelRegister("hda6p", function(module, exports) {
$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRouteEntry", () => $edd598ee3b65ddfb$export$49998c6229ab8099);
/* eslint-disable import/order */ 

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $4B8YU = parcelRequire("4B8YU");

var $byxMi = parcelRequire("byxMi");
const $edd598ee3b65ddfb$export$49998c6229ab8099 = (0, $fdS54.createEntry)((0, $4B8YU.globalSettingsLegacyFieldLayoutRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $byxMi.LazyLegacyFieldLayoutPage),
        forPaint: [
            (0, $byxMi.LazyLegacyFieldLayoutPromise)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4B8YU", function(module, exports) {
$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRoute", () => $cf8c759cffa5d231$export$82fa992cdfa20fb5);
const $cf8c759cffa5d231$export$82fa992cdfa20fb5 = {
    name: 'global-settings-issues-legacy-field-layout',
    path: '/jira/settings/issues/field-configuration/:fieldLayoutId'
};

});

parcelRegister("byxMi", function(module, exports) {
$parcel$export(module.exports, "LazyLegacyFieldLayoutPromise", () => $bbd7f156afff91e8$export$8b5ab888f8df499);
$parcel$export(module.exports, "LazyLegacyFieldLayoutPage", () => $bbd7f156afff91e8$export$676ecf497a280cfa);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $bbd7f156afff91e8$export$8b5ab888f8df499 = (0, $l8G1z.lazyForPaint)(()=>{
    return (0, $jhKsF.markAsProductBundleReady)((parcelRequire("1Cccg")).then((bundle)=>bundle.LegacyFieldLayoutApp));
}, {
    moduleId: "./src/packages/admin-pages/legacy-field-layout-app/src/LegacyFieldLayoutApp.tsx"
});
const $bbd7f156afff91e8$export$676ecf497a280cfa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $bbd7f156afff91e8$export$8b5ab888f8df499,
        pageId: "jira-admin-pages-legacy-field-layout",
        shouldShowSpinner: true
    });
$bbd7f156afff91e8$export$676ecf497a280cfa.displayName = "LazyLegacyFieldLayoutPage";

});
parcelRegister("1Cccg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("dkiWl")
]).then(()=>parcelRequire('1P830'));

});



parcelRegister("2BCjc", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeCFOptionsRouteEntry", () => $f3c7d11be700af2c$export$6eca776a7fe1328c);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $jWxIY = parcelRequire("jWxIY");

var $35eqr = parcelRequire("35eqr");

var $38Xu6 = parcelRequire("38Xu6");
const $f3c7d11be700af2c$export$6eca776a7fe1328c = (0, $fdS54.createEntry)((0, $jWxIY.globalSettingsOptimizeCFOptionsRoute), ()=>({
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        entryPoint: ()=>{
            return 0, $38Xu6.optimizeCFOptionsPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("jWxIY", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeCFOptionsRoute", () => $797d96ecb308c8eb$export$ff76a7c55097b632);
const $797d96ecb308c8eb$export$ff76a7c55097b632 = {
    name: 'global-settings-optimize-cf-options-view',
    path: '/jira/settings/issues/custom-fields/:cfId/options/optimize'
};

});

parcelRegister("38Xu6", function(module, exports) {
$parcel$export(module.exports, "optimizeCFOptionsPageEntrypoint", () => $edde1be315a173cf$export$dd936d0d6f43477d);

var $dTa0V = parcelRequire("dTa0V");

var $7NTte = parcelRequire("7NTte");

const $edde1be315a173cf$export$dd936d0d6f43477d = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2zIbI")), {
            moduleId: "ac457746",
            moduleName: "OptimizeCFOptionsPage",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("2zIbI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("6PEez")
]).then(()=>parcelRequire('f32WH'));

});



parcelRegister("aFBIC", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRouteEntry", () => $afb6925c5b1fe09a$export$b98ced4649f55b1c);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $4AYHo = parcelRequire("4AYHo");

var $35eqr = parcelRequire("35eqr");

var $8d2G6 = parcelRequire("8d2G6");
const $afb6925c5b1fe09a$export$b98ced4649f55b1c = (0, $fdS54.createEntry)((0, $4AYHo.globalSettingsOptimizeFieldConfigurationSchemeRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8d2G6.OptimizeFieldConfigurationSchemePage),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8d2G6.LazyOptimizeFieldConfigurationSchemePagePage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4AYHo", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRoute", () => $0f8f772ddbda490d$export$3da73e59758744eb);
const $0f8f772ddbda490d$export$3da73e59758744eb = {
    name: 'global-settings-optimize-field-configuration-scheme-view',
    path: '/jira/settings/issues/field-configuration-schemes/:fieldConfigurationSchemeId/optimize'
};

});

parcelRegister("8d2G6", function(module, exports) {
$parcel$export(module.exports, "LazyOptimizeFieldConfigurationSchemePagePage", () => $f3c9c088be488a1f$export$bd8509501da10c3);
$parcel$export(module.exports, "OptimizeFieldConfigurationSchemePage", () => $f3c9c088be488a1f$export$7cd55863572c1f3a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f3c9c088be488a1f$export$bd8509501da10c3 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hkieN"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-field-configuration-scheme-page/src/OptimizeFieldConfigurationSchemePage.tsx"
});
const $f3c9c088be488a1f$export$7cd55863572c1f3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f3c9c088be488a1f$export$bd8509501da10c3,
        pageId: "jira-admin-pages-optimize-field-configuration-scheme-page",
        shouldShowSpinner: true
    });
$f3c9c088be488a1f$export$7cd55863572c1f3a.displayName = "OptimizeFieldConfigurationSchemePage";

});
parcelRegister("hkieN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("lUCWm")
]).then(()=>parcelRequire('e1VSS'));

});



parcelRegister("6Thsk", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeFieldSchemeRouteEntry", () => $a42d772c0d0c6d45$export$eb2f77aa9f487f34);
/* eslint-disable import/order */ 


var $87svi = parcelRequire("87svi");

var $4lWtN = parcelRequire("4lWtN");

var $i860n = parcelRequire("i860n");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $832CK = parcelRequire("832CK");

var $35eqr = parcelRequire("35eqr");

var $dTa0V = parcelRequire("dTa0V");
const $a42d772c0d0c6d45$var$optimizeFieldSchemePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $87svi.optimizeFieldSchemeEntryPoint)
});
const $a42d772c0d0c6d45$var$notFoundPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4lWtN.notFoundEntrypoint)
});
const $a42d772c0d0c6d45$export$eb2f77aa9f487f34 = (0, $fdS54.createEntry)((0, $832CK.globalSettingsOptimizeFieldSchemeRoute), ()=>({
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $i860n.fg)('slt1-1200-content-changes-for-nfa'),
        entryPoint: ()=>{
            if (!(0, $i860n.fg)('slt1-1200-content-changes-for-nfa')) return $a42d772c0d0c6d45$var$notFoundPageEntrypoint;
            return $a42d772c0d0c6d45$var$optimizeFieldSchemePageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("87svi", function(module, exports) {
$parcel$export(module.exports, "optimizeFieldSchemeEntryPoint", () => $b0e0ec9867ad6a86$export$9b42e3202b23d3ea);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $b0e0ec9867ad6a86$export$9b42e3202b23d3ea = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aHM5Q")), {
        moduleId: "8a51138f",
        moduleName: "OptimizeFieldSchemePage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aHM5Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("cHiJv")
]).then(()=>parcelRequire('9Ysx0'));

});


parcelRegister("832CK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeFieldSchemeRoute", () => $ef0278309129de3d$export$8f89e61643db7826);
const $ef0278309129de3d$export$8f89e61643db7826 = {
    name: 'global-settings-optimize-field-scheme-view',
    path: '/jira/settings/issues/field-schemes/:schemeId/optimize'
};

});


parcelRegister("f5nHW", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeIssueSecurityLevelSchemeRouteEntry", () => $f6e300b22292138d$export$83399e202ff70f4c);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $1c52d = parcelRequire("1c52d");

var $35eqr = parcelRequire("35eqr");

var $jVw5m = parcelRequire("jVw5m");
const $f6e300b22292138d$export$83399e202ff70f4c = (0, $fdS54.createEntry)((0, $1c52d.globalSettingsOptimizeIssueSecurityLevelSchemeRoute), ()=>({
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        entryPoint: ()=>{
            return 0, $jVw5m.optimizeIssueSecurityLevelSchemePageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("1c52d", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeIssueSecurityLevelSchemeRoute", () => $bf00ac648691003f$export$3d677b56830aff42);
const $bf00ac648691003f$export$3d677b56830aff42 = {
    name: 'global-settings-optimize-issue-security-level-scheme',
    path: '/jira/settings/system/performance/issue-security-level-scheme/:schemeId/optimize'
};

});

parcelRegister("jVw5m", function(module, exports) {
$parcel$export(module.exports, "optimizeIssueSecurityLevelSchemePageEntrypoint", () => $b008a1bbb3c65365$export$c1d30d13deea0087);

var $dTa0V = parcelRequire("dTa0V");

var $7NTte = parcelRequire("7NTte");

const $b008a1bbb3c65365$export$c1d30d13deea0087 = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("4Ro7d")), {
            moduleId: "e0a96539",
            moduleName: "OptimizeIssueSecurityLevelScheme",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("4Ro7d", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("K802S")
]).then(()=>parcelRequire('gAVBD'));

});



parcelRegister("6REob", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizePermissionSchemeRouteEntry", () => $79ca58944c35f82a$export$f4c6d87a8f333932);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $35eqr = parcelRequire("35eqr");

var $89mPH = parcelRequire("89mPH");

var $lgObU = parcelRequire("lgObU");
const $79ca58944c35f82a$export$f4c6d87a8f333932 = (0, $fdS54.createEntry)((0, $89mPH.globalSettingsOptimizePermissionSchemeRoute), ()=>({
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        entryPoint: ()=>{
            return 0, $lgObU.optimizePermissionSchemePageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("89mPH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizePermissionSchemeRoute", () => $cd805b683aa0c4da$export$ce9a425201b6f50);
const $cd805b683aa0c4da$export$ce9a425201b6f50 = {
    name: 'global-settings-optimize-permission-scheme',
    path: '/jira/settings/system/performance/permission-scheme/:permissionSchemeId/optimize'
};

});

parcelRegister("lgObU", function(module, exports) {
$parcel$export(module.exports, "optimizePermissionSchemePageEntrypoint", () => $139dc37d3f06a25e$export$bd953473a51d71ee);

var $dTa0V = parcelRequire("dTa0V");

var $7NTte = parcelRequire("7NTte");

const $139dc37d3f06a25e$export$bd953473a51d71ee = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("3BGG7")), {
            moduleId: "72296d55",
            moduleName: "OptimizePermissionScheme",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("3BGG7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("dpbXq")
]).then(()=>parcelRequire('11LaF'));

});



parcelRegister("30CEL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRouteEntry", () => $bbb50bcce8d95f44$export$bae97ca0b9dd2ea2);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $7zDz2 = parcelRequire("7zDz2");

var $35eqr = parcelRequire("35eqr");

var $cM1p9 = parcelRequire("cM1p9");
const $bbb50bcce8d95f44$export$bae97ca0b9dd2ea2 = (0, $fdS54.createEntry)((0, $7zDz2.globalSettingsOptimizeWorkTypeSchemeRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cM1p9.OptimizeWorkTypeSchemePage),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cM1p9.LazyOptimizeWorkTypeSchemePagePage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7zDz2", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRoute", () => $4b395ec7e8fe2383$export$c0e227e20c671f81);
const $4b395ec7e8fe2383$export$c0e227e20c671f81 = {
    name: 'global-settings-optimize-work-type-scheme-view',
    path: '/jira/settings/issues/issue-type-schemes/:workTypeSchemeId/optimize'
};

});

parcelRegister("cM1p9", function(module, exports) {
$parcel$export(module.exports, "LazyOptimizeWorkTypeSchemePagePage", () => $f1ada85004ef1b8b$export$267fd3967a05d273);
$parcel$export(module.exports, "OptimizeWorkTypeSchemePage", () => $f1ada85004ef1b8b$export$ba894e00aa169b3b);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f1ada85004ef1b8b$export$267fd3967a05d273 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("i9RYm"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-work-type-scheme-page/src/OptimizeWorkTypeSchemePage.tsx"
});
const $f1ada85004ef1b8b$export$ba894e00aa169b3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f1ada85004ef1b8b$export$267fd3967a05d273,
        pageId: "jira-admin-pages-optimize-work-type-scheme-page",
        shouldShowSpinner: true
    });
$f1ada85004ef1b8b$export$ba894e00aa169b3b.displayName = "OptimizeWorkTypeSchemePage";

});
parcelRegister("i9RYm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("kR2w6")
]).then(()=>parcelRequire('3NqCy'));

});



parcelRegister("1i3Ly", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldCleanupRouteEntry", () => $5d4fa4bbadb8849b$export$2861e75e48fa039f);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $6sTgN = parcelRequire("6sTgN");

var $knFKT = parcelRequire("knFKT");
const $5d4fa4bbadb8849b$export$2861e75e48fa039f = (0, $fdS54.createEntry)((0, $6sTgN.globalSettingsPerformanceCustomFieldCleanupRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $knFKT.customFieldCleanupMetricDetailEntryPoint;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6sTgN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldCleanupRoute", () => $465dba39812b8809$export$cb147997a6f0639a);
const $465dba39812b8809$export$cb147997a6f0639a = {
    name: 'global-settings-performance-custom-field-cleanup',
    path: '/jira/settings/system/performance/metrics/customfield/cleanup'
};

});

parcelRegister("knFKT", function(module, exports) {
$parcel$export(module.exports, "customFieldCleanupMetricDetailEntryPoint", () => $d7c49b15b743804c$export$47780c76bc3a7e1e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $dTa0V = parcelRequire("dTa0V");

var $7NTte = parcelRequire("7NTte");

const $d7c49b15b743804c$export$47780c76bc3a7e1e = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bwCYD")), {
            moduleId: "626d3bf9",
            moduleName: "CustomFieldCleanupDetail",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("bwCYD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1UUlo").then(()=>parcelRequire('cWPQF'));

});



parcelRegister("dCSf1", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldOptionProjectLimitRouteEntry", () => $da9ed23b041de311$export$e4bd055f8e981ef0);



var $im0Jw = parcelRequire("im0Jw");

var $4lWtN = parcelRequire("4lWtN");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $fD0IS = parcelRequire("fD0IS");

var $k0b67 = parcelRequire("k0b67");
const $da9ed23b041de311$var$notFoundPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4lWtN.notFoundEntrypoint)
});
const $da9ed23b041de311$var$getCustomFieldOptionProjectLimitResources = ()=>(0, $i860n.fg)('slt1-1341_site_optimizer_add_cfo_isl_metrics') ? [
        ...(0, $dUAVJ.getNavigationResources)(),
        (0, $45Itd.navigationSidebarGlobalResource),
        (0, $im0Jw.fieldOptionProjectsLimitsResource)
    ] : [
        ...(0, $dUAVJ.getNavigationResources)(),
        (0, $45Itd.navigationSidebarGlobalResource)
    ];
const $da9ed23b041de311$export$e4bd055f8e981ef0 = (0, $fdS54.createEntry)((0, $fD0IS.globalSettingsPerformanceCustomFieldOptionProjectLimitRoute), ()=>({
        group: 'global-settings',
        canTransitionIn: ()=>(0, $i860n.fg)('slt1-1341_site_optimizer_add_cfo_isl_metrics'),
        entryPoint () {
            if (!(0, $i860n.fg)('slt1-1341_site_optimizer_add_cfo_isl_metrics')) return $da9ed23b041de311$var$notFoundPageEntrypoint;
            return 0, $k0b67.customFieldOptionProjectLimitMetricDetailEntryPoint;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: $da9ed23b041de311$var$getCustomFieldOptionProjectLimitResources(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("im0Jw", function(module, exports) {
$parcel$export(module.exports, "fieldOptionProjectsLimitsResource", () => $b59c734a39faf693$export$3c6f2d5ebc9bc1a5);

var $7edbf = parcelRequire("7edbf");
const $b59c734a39faf693$var$RESOURCE_TYPE_FIELD_OPTION_PROJECTS_LIMITS = 'FIELD_OPTION_PROJECTS_LIMITS';

const $b59c734a39faf693$export$3c6f2d5ebc9bc1a5 = (0, $7edbf.createResource)({
    type: $b59c734a39faf693$var$RESOURCE_TYPE_FIELD_OPTION_PROJECTS_LIMITS,
    getKey: ()=>'fieldOptionProjectsLimits',
    getDataLoader: ()=>(parcelRequire("hXwnC"))
});

});
parcelRegister("hXwnC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2t6zK").then(()=>parcelRequire('6xyxF'));

});


parcelRegister("fD0IS", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldOptionProjectLimitRoute", () => $8519e98377e211f9$export$bab706e649224b92);
const $8519e98377e211f9$export$bab706e649224b92 = {
    name: 'global-settings-performance-custom-field-option-project-limit',
    path: '/jira/settings/system/performance/metrics/customfieldoption/projectlimit'
};

});

parcelRegister("k0b67", function(module, exports) {
$parcel$export(module.exports, "customFieldOptionProjectLimitMetricDetailEntryPoint", () => $40533f0c2d6a2de8$export$ac2c8b2f17a95fb3);

var $7NTte = parcelRequire("7NTte");

var $dTa0V = parcelRequire("dTa0V");

const $40533f0c2d6a2de8$export$ac2c8b2f17a95fb3 = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9UXOd")), {
            moduleId: "ceb8e0b6",
            moduleName: "CustomFieldOptionProjectLimitDetail",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("9UXOd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g1yq1").then(()=>parcelRequire('gDvR2'));

});



parcelRegister("6a25y", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldProjectLimitRouteEntry", () => $8b745e7784996f61$export$e86e8247db1f29bb);
/* eslint-disable import/order */ 


var $dCnrt = parcelRequire("dCnrt");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $9ESuL = parcelRequire("9ESuL");

var $QWUTP = parcelRequire("QWUTP");
const $8b745e7784996f61$export$e86e8247db1f29bb = (0, $fdS54.createEntry)((0, $9ESuL.globalSettingsPerformanceCustomFieldProjectLimitRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $QWUTP.customFieldProjectLimitMetricDetailEntryPoint;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $dCnrt.fieldsProjectsLimitsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dCnrt", function(module, exports) {
$parcel$export(module.exports, "fieldsProjectsLimitsResource", () => $a295f044be66e705$export$c3fe56fd6a83a952);

var $7edbf = parcelRequire("7edbf");
const $a295f044be66e705$var$RESOURCE_TYPE_FIELDS_PROJECTS_LIMITS = 'FIELDS_PROJECTS_LIMITS';

const $a295f044be66e705$export$c3fe56fd6a83a952 = (0, $7edbf.createResource)({
    type: $a295f044be66e705$var$RESOURCE_TYPE_FIELDS_PROJECTS_LIMITS,
    getKey: ()=>'fieldsProjectsLimits',
    getDataLoader: ()=>(parcelRequire("9eni8"))
});

});
parcelRegister("9eni8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8s37E").then(()=>parcelRequire('eRvr9'));

});


parcelRegister("9ESuL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldProjectLimitRoute", () => $8e2693ac43aa2379$export$9449246286770320);
const $8e2693ac43aa2379$export$9449246286770320 = {
    name: 'global-settings-performance-custom-field-project-limit',
    path: '/jira/settings/system/performance/metrics/customfield/projectlimit'
};

});

parcelRegister("QWUTP", function(module, exports) {
$parcel$export(module.exports, "customFieldProjectLimitMetricDetailEntryPoint", () => $6e96dee2cdd829fc$export$a2234cc105eb9aa9);
/* eslint-disable jira/naming/disallow-filenames */ 
var $dTa0V = parcelRequire("dTa0V");

var $7NTte = parcelRequire("7NTte");

const $6e96dee2cdd829fc$export$a2234cc105eb9aa9 = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("ivcBW")), {
            moduleId: "7c805c75",
            moduleName: "CustomFieldProjectLimitDetail",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("ivcBW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jqc6M").then(()=>parcelRequire('ioqUE'));

});



parcelRegister("H15ro", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRouteEntry", () => $d9ca666633431134$export$8cc68908e4ed5a16);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $4kEP7 = parcelRequire("4kEP7");

var $eppGR = parcelRequire("eppGR");
const $d9ca666633431134$export$8cc68908e4ed5a16 = (0, $fdS54.createEntry)((0, $4kEP7.globalSettingsPerformanceCustomFieldRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eppGR.CustomFieldMetricDetail),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eppGR.LazyCustomFieldDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4kEP7", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRoute", () => $2e1cf591ef29a659$export$198b0dea5bcb104d);
const $2e1cf591ef29a659$export$198b0dea5bcb104d = {
    name: 'global-settings-performance-custom-field',
    path: '/jira/settings/system/performance/metrics/customfield'
};

});

parcelRegister("eppGR", function(module, exports) {
$parcel$export(module.exports, "LazyCustomFieldDetail", () => $227826cb316609d4$export$d323aa888b5be0c2);
$parcel$export(module.exports, "CustomFieldMetricDetail", () => $227826cb316609d4$export$446bf9be075b3cb);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $227826cb316609d4$export$d323aa888b5be0c2 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("bjrpc"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-performance-metric-detail-custom-field/src/CustomFieldDetail.tsx"
});
const $227826cb316609d4$export$446bf9be075b3cb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $227826cb316609d4$export$d323aa888b5be0c2,
        pageId: "system-performance-metric-detail-custom-field",
        shouldShowSpinner: true
    });
$227826cb316609d4$export$446bf9be075b3cb.displayName = "CustomFieldMetricDetail";

});
parcelRegister("bjrpc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("zCAuy")
]).then(()=>parcelRequire('ayIsk'));

});



parcelRegister("eI7S7", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceDashboardRouteEntry", () => $04a644440fdc0506$export$6abc49117edae2db);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $4x1gs = parcelRequire("4x1gs");

var $cLypv = parcelRequire("cLypv");

var $buNKE = parcelRequire("buNKE");

var $4lWtN = parcelRequire("4lWtN");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");
const $04a644440fdc0506$var$notFoundPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4lWtN.notFoundEntrypoint)
});
const $04a644440fdc0506$export$6abc49117edae2db = (0, $fdS54.createEntry)((0, $4x1gs.globalSettingsPerformanceDashboardRoute), ()=>({
        group: 'global-settings',
        entryPoint: ()=>{
            if (!((0, $i860n.fg)('enable_jira_apm_m2') || (0, $i860n.fg)('enable_cfo_dashboard'))) return $04a644440fdc0506$var$notFoundPageEntrypoint;
            return 0, $buNKE.PerformanceMonitorDashboardEntryPoint;
        },
        layout: (0, $cLypv.performanceLayoutWithRightSidebar),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4x1gs", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceDashboardRoute", () => $e974204713ae0b6a$export$5cb922a7b379216b);
const $e974204713ae0b6a$export$5cb922a7b379216b = {
    name: 'global-settings-performance-dashboard',
    path: '/jira/settings/system/performance/dashboard'
};

});

parcelRegister("cLypv", function(module, exports) {
$parcel$export(module.exports, "performanceLayoutWithRightSidebar", () => $992889f1089e2065$export$4fe9f2ced0fb6c08);

var $IiTJi = parcelRequire("IiTJi");

var $QhQu4 = parcelRequire("QhQu4");

var $ju22D = parcelRequire("ju22D");
const $992889f1089e2065$export$4fe9f2ced0fb6c08 = (0, $QhQu4.composeLayouts)((0, $ju22D.globalSettingsLayout), {
    rightSidebars: [
        (0, $IiTJi.SafeRecommendationPanel)
    ]
});
var $992889f1089e2065$export$2e2bcd8739ae039 = $992889f1089e2065$export$4fe9f2ced0fb6c08;

});
parcelRegister("IiTJi", function(module, exports) {
$parcel$export(module.exports, "SafeRecommendationPanel", () => $f527b9c2efbc2a44$export$a5bbd58efa292e40);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $29eRG = parcelRequire("29eRG");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $4MYRQ = parcelRequire("4MYRQ");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2OD8L = parcelRequire("2OD8L");

var $fIFYd = parcelRequire("fIFYd");
const $f527b9c2efbc2a44$var$panelSplitter = (0, $7eNDO.defineMessage)({
    id: "admin-pages__performance.SafeRecommendationPanel.panel-splitter",
    defaultMessage: "Resize recommendation panel"
});
const $f527b9c2efbc2a44$var$closePanelLabel = (0, $7eNDO.defineMessage)({
    id: "admin-pages__performance.SafeRecommendationPanel.close-panel-label",
    defaultMessage: "Close panel"
});
/**
 * Inner component that contains all hooks.
 * This is only rendered on the client side.
 * NOTE: This component is rendered OUTSIDE the provider tree (in right sidebar layout).
 * It uses a bridge mechanism to access data from the provider in DashboardPage.
 */ const $f527b9c2efbc2a44$var$PanelInLayoutClient = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const rightSidebarCurrentState = (0, $29eRG.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId;
    // Force re-render when bridge data changes
    const [, forceUpdate] = (0, $euxye.useReducer)((x)=>x + 1, 0);
    // Access data via bridge (since this component is outside the provider tree)
    const bridge = (0, $fIFYd.getProviderBridge)();
    // Subscribe to bridge updates to trigger re-renders
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = (0, $fIFYd.subscribeToBridgeChanges)(()=>{
            forceUpdate();
        });
        return unsubscribe;
    }, []);
    // Get current values from bridge
    const selectedCardId = bridge.uiContext?.selectedCardId ?? null;
    const dataContextValue = bridge.dataContext;
    const uiContextValue = bridge.uiContext;
    // Only render when our panel ID matches the active right sidebar panel
    if (panelId !== (0, $fIFYd.RECOMMENDATION_PANEL_ID)) return null;
    // Don't render if no card is selected or no data available
    if (!selectedCardId || !dataContextValue || !uiContextValue) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fIFYd.RecommendationDataContext).Provider, {
        value: dataContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fIFYd.RecommendationUIContext).Provider, {
        value: uiContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4MYRQ.PanelSplitter), {
        label: formatMessage($f527b9c2efbc2a44$var$panelSplitter)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $f527b9c2efbc2a44$var$panelContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2OD8L.RecommendationPanel), {
        cardId: selectedCardId,
        closePanelLabel: formatMessage($f527b9c2efbc2a44$var$closePanelLabel)
    }))));
};
$f527b9c2efbc2a44$var$PanelInLayoutClient.displayName = "PanelInLayoutClient";
const $f527b9c2efbc2a44$export$a5bbd58efa292e40 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-recommendation-panel",
        packageName: "admin-pages-performance"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f527b9c2efbc2a44$var$PanelInLayoutClient, null));
$f527b9c2efbc2a44$export$a5bbd58efa292e40.displayName = "SafeRecommendationPanel";
const $f527b9c2efbc2a44$var$panelContentStyles = (0, $fbAgj.xcss)({
    padding: 'space.400'
});

});
parcelRegister("2OD8L", function(module, exports) {
$parcel$export(module.exports, "RecommendationPanel", () => $a02168d91f16ea48$export$a6dbe1033096e1fc);

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $6Elhl = parcelRequire("6Elhl");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $2iotI = parcelRequire("2iotI");

var $m9iwH = parcelRequire("m9iwH");

var $i68tN = parcelRequire("i68tN");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $e2Tle = parcelRequire("e2Tle");

var $hfA2Y = parcelRequire("hfA2Y");

var $fIFYd = parcelRequire("fIFYd");
const $a02168d91f16ea48$var$recommendationsHeading = (0, $7eNDO.defineMessage)({
    id: "admin-pages-performance.recommendation-panel.recommendations-heading",
    defaultMessage: "Recommendations"
});
// recommendation panel on-right
const $a02168d91f16ea48$var$RecommendationPanelComponent = ({ closePanelLabel: closePanelLabel, cardId: cardId })=>{
    const intl = (0, $1YIbA.default)();
    // Split context: access static data from data context (no re-renders on UI changes)
    const { groupToRecommendationsMap: groupToRecommendationsMap, recommendationsMap: recommendationsMap, recommendationGroupsArray: recommendationGroupsArray } = (0, $fIFYd.useRecommendationData)();
    // Split context: access dynamic UI actions from UI context
    const { closePanel: closePanel, clearSelections: clearSelections } = (0, $fIFYd.useRecommendationUI)();
    const handleClosePanel = ()=>{
        clearSelections();
        closePanel();
    };
    // Find the group data based on cardId
    const groupData = recommendationGroupsArray?.find((group)=>group.groupCategory === cardId);
    const title = groupData?.sidePanelTitle;
    const description = groupData?.sidePanelDescription;
    const performanceRecommendations = (0, $euxye.useMemo)(()=>{
        if (!groupToRecommendationsMap || !cardId) return [];
        const recommendations = [];
        groupToRecommendationsMap.get(cardId)?.forEach((recommendationCategory)=>{
            const recommendationMap = recommendationsMap?.get(recommendationCategory);
            if (!recommendationMap) return;
            recommendations.push({
                id: recommendationMap.recommendationCategory,
                title: recommendationMap.name,
                description: recommendationMap.description,
                buttonLabel: recommendationMap.actions[0].name,
                buttonLink: recommendationMap.actions[0].link,
                resources: recommendationMap.resources,
                cardType: recommendationMap.status
            });
        });
        return recommendations;
    }, [
        cardId,
        groupToRecommendationsMap,
        recommendationsMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $a02168d91f16ea48$var$panelContainerStyles
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $a02168d91f16ea48$var$sidePanelHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "large"
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $a02168d91f16ea48$var$descriptionStyles
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
        onClick: handleClosePanel,
        testId: "performance.close-panel-button",
        label: closePanelLabel || ''
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $a02168d91f16ea48$var$sidePanelContentStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        as: "h4",
        size: "small"
    }, intl.formatMessage($a02168d91f16ea48$var$recommendationsHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $a02168d91f16ea48$var$cardListContainerStyles,
        space: "space.200"
    }, performanceRecommendations.map((card)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hfA2Y.PerformanceRecommendationsCard), {
            key: card.id,
            ...card,
            link: card.buttonLink
        })))));
};
$a02168d91f16ea48$var$RecommendationPanelComponent.displayName = "RecommendationPanelComponent";
const $a02168d91f16ea48$var$panelContainerStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
});
const $a02168d91f16ea48$var$sidePanelHeaderStyles = (0, $fbAgj.xcss)({
    paddingBottom: 'space.300',
    flexShrink: 0
});
const $a02168d91f16ea48$var$sidePanelContentStyles = (0, $fbAgj.xcss)({
    flex: '1',
    overflow: 'auto'
});
const $a02168d91f16ea48$var$cardListContainerStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $a02168d91f16ea48$var$descriptionStyles = (0, $fbAgj.xcss)({
    paddingTop: 'space.300',
    color: 'color.text.subtle'
});
const $a02168d91f16ea48$export$a6dbe1033096e1fc = (0, $e2Tle.withRouter)($a02168d91f16ea48$var$RecommendationPanelComponent);

});
parcelRegister("hfA2Y", function(module, exports) {
$parcel$export(module.exports, "PerformanceRecommendationsCard", () => $b85942aa647e6cbc$export$87706c5999ca5bf);

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $7DcTT = parcelRequire("7DcTT");

var $jYEcG = parcelRequire("jYEcG");

var $fbAgj = parcelRequire("fbAgj");

var $8Sdzy = parcelRequire("8Sdzy");

var $ah9qo = parcelRequire("ah9qo");

var $gdvYt = parcelRequire("gdvYt");

var $6Z4Lw = parcelRequire("6Z4Lw");

var $aFpts = parcelRequire("aFpts");

var $ld25x = parcelRequire("ld25x");

var $a1Bqx = parcelRequire("a1Bqx");

var $4qNCE = parcelRequire("4qNCE");

var $2iotI = parcelRequire("2iotI");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $b85942aa647e6cbc$var$resourcesHeading = (0, $7eNDO.defineMessage)({
    id: "admin-pages-performance.performance-recommendations-card.resources-heading",
    defaultMessage: "Resources"
});
const $b85942aa647e6cbc$export$87706c5999ca5bf = (props)=>{
    const intl = (0, $1YIbA.default)();
    const { id: id, title: title, description: description, buttonLabel: buttonLabel, onButtonClick: onButtonClick, resources: resources, cardType: cardType = 'danger', isExpanded: controlledIsExpanded, onExpandChange: onExpandChange, link: link } = props;
    const [uncontrolledIsExpanded, setUncontrolledIsExpanded] = (0, $euxye.useState)(true);
    const isExpanded = controlledIsExpanded !== undefined ? controlledIsExpanded : uncontrolledIsExpanded;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handleExpandClick = (0, $euxye.useCallback)(()=>{
        const newExpandedState = !isExpanded;
        setUncontrolledIsExpanded(newExpandedState);
        onExpandChange?.(newExpandedState);
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'cfoRecommendationPanel',
            action: 'clicked'
        }), {
            groupCategory: id
        });
    }, [
        isExpanded,
        onExpandChange,
        createAnalyticsEvent,
        id
    ]);
    const handleButtonClick = (0, $euxye.useCallback)(()=>{
        onButtonClick?.();
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'cfoRecommendationResourceActionButton',
            action: 'clicked'
        }), {
            groupCategory: id
        });
    }, [
        onButtonClick,
        createAnalyticsEvent,
        id
    ]);
    const handleResourceClick = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'cfoRecommendationResourceLink',
            action: 'clicked'
        }), {
            groupCategory: id
        });
    }, [
        createAnalyticsEvent,
        id
    ]);
    const getIconForCardType = ()=>{
        switch(cardType){
            case 'WARNING':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gdvYt))), {
                    color: "var(--ds-icon-warning, #E06C00)",
                    label: ""
                });
            case 'INFO':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Z4Lw))), {
                    color: "var(--ds-icon-information, #357DE8)",
                    label: ""
                });
            case 'CRITICAL':
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    label: ""
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $b85942aa647e6cbc$var$cardContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.default), {
        onClick: handleExpandClick,
        xcss: $b85942aa647e6cbc$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $b85942aa647e6cbc$var$headerLeftStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $b85942aa647e6cbc$var$iconStyles
        ]
    }, getIconForCardType()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $b85942aa647e6cbc$var$headingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        as: "h4",
        size: "small"
    }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $b85942aa647e6cbc$var$chevronStyles
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFpts))), {
        label: "",
        size: "medium"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
        label: "",
        size: "medium"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $b85942aa647e6cbc$var$dividerStyles
    }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $b85942aa647e6cbc$var$bodyStyles,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        color: "color.text.subtle"
    }, description), buttonLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        appearance: "default",
        target: "_blank",
        href: link,
        onClick: handleButtonClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
            label: "",
            size: "small"
        })
    }, buttonLabel)), resources && resources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        as: "h5",
        xcss: $b85942aa647e6cbc$var$resourcesHeadingStyles
    }, intl.formatMessage($b85942aa647e6cbc$var$resourcesHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.050",
        xcss: $b85942aa647e6cbc$var$resourcesListStyles
    }, resources.map((resource, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7DcTT.default), {
            key: index,
            href: resource.link,
            target: "_blank",
            xcss: $b85942aa647e6cbc$var$resourceLinkStyles,
            onClick: handleResourceClick
        }, resource.name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
            label: "",
            size: "small"
        })))))));
};
$b85942aa647e6cbc$export$87706c5999ca5bf.displayName = "PerformanceRecommendationsCard";
// const warningStyles = xcss({
// 	backgroundColor: 'color.background.accent.orange.subtlest',
// });
// const dangerStyles = xcss({
// 	backgroundColor: 'color.background.accent.red.subtlest',
// });
const $b85942aa647e6cbc$var$cardContainerStyles = (0, $fbAgj.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)",
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    backgroundColor: 'color.background.neutral.subtle',
    overflow: 'hidden'
});
const $b85942aa647e6cbc$var$headerStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 'space.100',
    width: '100%',
    padding: 'space.200',
    borderTopLeftRadius: 'radius.large',
    borderTopRightRadius: 'radius.large',
    borderBottomRightRadius: '0',
    borderBottomLeftRadius: '0',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    background: "var(--ds-surface, #FFFFFF)",
    cursor: 'pointer',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle'
    }
});
const $b85942aa647e6cbc$var$headerLeftStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    flex: '1 1 auto',
    minWidth: '0',
    textAlign: 'left'
});
const $b85942aa647e6cbc$var$chevronStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
});
const $b85942aa647e6cbc$var$iconStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    width: '32px',
    height: '32px',
    minWidth: '32px',
    maxWidth: '32px',
    minHeight: '32px',
    maxHeight: '32px',
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'space.100',
    flexShrink: 0,
    borderRadius: "var(--ds-radius-tile, 25%)",
    background: "var(--ds-background-neutral, #0515240F)"
});
const $b85942aa647e6cbc$var$dividerStyles = (0, $fbAgj.xcss)({
    height: '1px',
    backgroundColor: 'color.background.neutral',
    width: '100%'
});
const $b85942aa647e6cbc$var$bodyStyles = (0, $fbAgj.xcss)({
    padding: 'space.200',
    textAlign: 'left'
});
const $b85942aa647e6cbc$var$resourcesHeadingStyles = (0, $fbAgj.xcss)({
    margin: '0'
});
const $b85942aa647e6cbc$var$resourcesListStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $b85942aa647e6cbc$var$resourceLinkStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    color: 'color.link',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $b85942aa647e6cbc$var$headingWrapperStyles = (0, $fbAgj.xcss)({
    flex: '1 1 auto',
    minWidth: '0',
    textAlign: 'left'
});

});
parcelRegister("7DcTT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c45470667263a4bb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $jiTLE = parcelRequire("jiTLE");

var $aZBDA = parcelRequire("aZBDA");

var $5atpW = parcelRequire("5atpW");

var $2oRWW = parcelRequire("2oRWW");

var $gUxVT = parcelRequire("gUxVT");

var $Cs8MU = parcelRequire("Cs8MU");

var $apUrw = parcelRequire("apUrw");

var $d7hXX = parcelRequire("d7hXX");

var $fbAgj = parcelRequire("fbAgj");
function $c45470667263a4bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $c45470667263a4bb$var$focusRingStyles = /*#__PURE__*/ (0, $hStPE.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $d7hXX.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $d7hXX.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $d7hXX.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $d7hXX.borderWidthMap)['border.width']} solid`
        }
    }
});
const $c45470667263a4bb$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $c45470667263a4bb$var$positionStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $c45470667263a4bb$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $c45470667263a4bb$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $c45470667263a4bb$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $c45470667263a4bb$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $2oRWW.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $gUxVT.useId)();
    const onClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $fbAgj.parseXcss)(xcss);
    const RouterLink = (0, $5atpW.default)();
    const isExternal = typeof href === 'string' && $c45470667263a4bb$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $c45470667263a4bb$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $jiTLE.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $hStPE.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $c45470667263a4bb$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $c45470667263a4bb$var$baseStyles,
            $c45470667263a4bb$var$positionStyles,
            $c45470667263a4bb$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $d7hXX.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $d7hXX.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $d7hXX.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $d7hXX.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $d7hXX.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $d7hXX.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $d7hXX.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $d7hXX.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $hStPE.jsx)((0, $apUrw.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $c45470667263a4bb$var$OPENS_NEW_WINDOW_LABEL}`));
};
$c45470667263a4bb$var$AnchorNoRef.displayName = "AnchorNoRef";
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $c45470667263a4bb$var$Anchor = /*#__PURE__*/ (0, $euxye.forwardRef)($c45470667263a4bb$var$AnchorNoRef);
var $c45470667263a4bb$export$2e2bcd8739ae039 = $c45470667263a4bb$var$Anchor;

});

parcelRegister("6Z4Lw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::987f1732135eba9300239393b5450485>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $515c22e1f88271d0$var$_react = $515c22e1f88271d0$var$_interopRequireDefault((parcelRequire("euxye")));

var $515c22e1f88271d0$var$_baseNew = $515c22e1f88271d0$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $515c22e1f88271d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $515c22e1f88271d0$var$LightbulbIcon = (props)=>/*#__PURE__*/ $515c22e1f88271d0$var$_react.default.createElement($515c22e1f88271d0$var$_baseNew.default, Object.assign({
        name: "LightbulbIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$515c22e1f88271d0$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $515c22e1f88271d0$var$_default = module.exports.default = $515c22e1f88271d0$var$LightbulbIcon;

});


parcelRegister("fIFYd", function(module, exports) {
$parcel$export(module.exports, "RecommendationDataContext", () => $a29dd95aafebb560$export$d0e49094432eba5c);
$parcel$export(module.exports, "RecommendationUIContext", () => $a29dd95aafebb560$export$1d079068b917dd03);
$parcel$export(module.exports, "RecommendationPanelProvider", () => $a29dd95aafebb560$export$7a4f235c564c4d74);
$parcel$export(module.exports, "RECOMMENDATION_PANEL_ID", () => $a29dd95aafebb560$export$99e1679d23263279);
$parcel$export(module.exports, "getProviderBridge", () => $a29dd95aafebb560$export$52fec34afc3885c8);
$parcel$export(module.exports, "subscribeToBridgeChanges", () => $a29dd95aafebb560$export$b803a45f76969b07);
$parcel$export(module.exports, "useRecommendationData", () => $a29dd95aafebb560$export$21463607abc70643);
$parcel$export(module.exports, "useRecommendationUI", () => $a29dd95aafebb560$export$5a7b5ecf0a7c5381);

var $3Z6hv = parcelRequire("3Z6hv");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $29eRG = parcelRequire("29eRG");
const $a29dd95aafebb560$export$d0e49094432eba5c = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $a29dd95aafebb560$export$1d079068b917dd03 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
// Default provider when experiment is off (no query available)
const $a29dd95aafebb560$var$DefaultRecommendationPanelProvider = ({ children: children })=>{
    const [isOpen] = (0, $euxye.useState)(false);
    const [selectedCardId] = (0, $euxye.useState)(null);
    // No-op callbacks when experiment is off
    const openPanel = (0, $euxye.useCallback)(()=>{
        // No-op: Panel functionality disabled when experiment is off
        return undefined;
    }, []);
    const closePanel = (0, $euxye.useCallback)(()=>{
        // No-op: Panel functionality disabled when experiment is off
        return undefined;
    }, []);
    const clearSelections = (0, $euxye.useCallback)(()=>{
        // No-op: Panel functionality disabled when experiment is off
        return undefined;
    }, []);
    const dataValue = (0, $euxye.useMemo)(()=>({
            recommendationsMap: null,
            recommendationGroupsArray: null,
            groupToRecommendationsMap: null,
            preloadedQueryRef: null
        }), []);
    const uiValue = (0, $euxye.useMemo)(()=>({
            isOpen: isOpen,
            selectedCardId: selectedCardId,
            openPanel: openPanel,
            closePanel: closePanel,
            clearSelections: clearSelections
        }), [
        isOpen,
        selectedCardId,
        openPanel,
        closePanel,
        clearSelections
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a29dd95aafebb560$export$d0e49094432eba5c.Provider, {
        value: dataValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a29dd95aafebb560$export$1d079068b917dd03.Provider, {
        value: uiValue
    }, children));
};
$a29dd95aafebb560$var$DefaultRecommendationPanelProvider.displayName = "DefaultRecommendationPanelProvider";
const $a29dd95aafebb560$export$7a4f235c564c4d74 = ({ children: children, preloadedQuery: preloadedQuery })=>{
    // If no query available, use default provider
    if (!preloadedQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a29dd95aafebb560$var$DefaultRecommendationPanelProvider, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a29dd95aafebb560$var$RecommendationPanelProviderWithQuery, {
        preloadedQuery: preloadedQuery
    }, children);
};
$a29dd95aafebb560$export$7a4f235c564c4d74.displayName = "RecommendationPanelProvider";
const $a29dd95aafebb560$export$99e1679d23263279 = 'performance-recommendations-panel';
const $a29dd95aafebb560$var$providerBridge = {
    uiContext: null,
    dataContext: null,
    listeners: new Set()
};
const $a29dd95aafebb560$export$52fec34afc3885c8 = ()=>$a29dd95aafebb560$var$providerBridge;
const $a29dd95aafebb560$export$b803a45f76969b07 = (listener)=>{
    $a29dd95aafebb560$var$providerBridge.listeners.add(listener);
    return ()=>{
        $a29dd95aafebb560$var$providerBridge.listeners.delete(listener);
    };
};
const $a29dd95aafebb560$var$notifyBridgeListeners = ()=>{
    $a29dd95aafebb560$var$providerBridge.listeners.forEach((listener)=>listener());
};
// Provider with actual query data
const $a29dd95aafebb560$var$RecommendationPanelProviderWithQuery = ({ children: children, preloadedQuery: preloadedQuery })=>{
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $29eRG.useRightSidebarController)();
    const rightSidebarState = (0, $29eRG.useActiveRightSidebarState)();
    // UI State
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const [selectedCardId, setSelectedCardId] = (0, $euxye.useState)(null);
    // Store refs for cross-boundary access
    const uiContextValueRef = (0, $euxye.useRef)(null);
    const dataContextValueRef = (0, $euxye.useRef)(null);
    // Load preloaded query
    const data = (0, $n67Vb.usePreloadedQuery)((0, $3Z6hv.default), preloadedQuery);
    // Process preloaded data synchronously - Relay handles errors via @required(action: THROW)
    // Using useMemo instead of useEffect ensures data is available on first render, preventing layout shift
    // This data is static and never changes, perfect for the data context
    const { recommendationsMap: recommendationsMap, recommendationGroupsArray: recommendationGroupsArray, groupToRecommendationsMap: groupToRecommendationsMap } = (0, $euxye.useMemo)(()=>{
        const jira = data.jira;
        // Map recommendations by category
        const recMap = new Map();
        for (const edge of jira.cfoRecommendations.edges)if (edge) {
            const node = edge.node;
            const actions = node.actions.filter(Boolean).map((action)=>({
                    name: action.name || '',
                    link: action.link || ''
                }));
            const resources = node.resources.filter(Boolean).map((resource)=>({
                    name: resource.name || '',
                    link: resource.link || ''
                }));
            recMap.set(node.recommendationCategory, {
                recommendationCategory: node.recommendationCategory,
                name: node.name,
                description: node.description,
                group: node.group,
                actions: actions,
                resources: resources,
                created: node.created,
                status: node.status
            });
        }
        // Map recommendation groups by category
        const groupMap = [];
        for (const edge of jira.cfoRecommendationGroups.edges)if (edge) {
            const node = edge.node;
            groupMap.push({
                name: node.name,
                description: node.description,
                groupCategory: node.groupCategory,
                sidePanelTitle: node.sidePanelTitle,
                sidePanelDescription: node.sidePanelDescription,
                status: node.status
            });
        }
        // Create map of group category to recommendation categories
        // Format: { "LIMITS_AND_CLEANUP": ["CFO_CUSTOM_FIELD", "CFO_BOARD_PERFORMANCE", ...], "USER_SETUP": [...] }
        const groupToRecsMap = new Map();
        for (const [category, recommendation] of recMap.entries()){
            const groupCategory = recommendation.group;
            if (!groupToRecsMap.has(groupCategory)) groupToRecsMap.set(groupCategory, []);
            const group = groupToRecsMap.get(groupCategory);
            if (group) group.push(category);
        }
        return {
            recommendationsMap: recMap,
            recommendationGroupsArray: groupMap,
            groupToRecommendationsMap: groupToRecsMap
        };
    }, [
        data
    ]);
    // Data context value - static, never changes
    const dataValue = (0, $euxye.useMemo)(()=>({
            recommendationsMap: recommendationsMap,
            recommendationGroupsArray: recommendationGroupsArray,
            groupToRecommendationsMap: groupToRecommendationsMap,
            preloadedQueryRef: preloadedQuery
        }), [
        recommendationsMap,
        recommendationGroupsArray,
        groupToRecommendationsMap,
        preloadedQuery
    ]);
    // UI Actions - only these cause re-renders
    const openPanel = (0, $euxye.useCallback)((cardId)=>{
        setSelectedCardId(cardId);
        setIsOpen(true);
        // Close any other panel that might be open before opening ours
        // This ensures a clean slate - when our panel closes, sidebar will be empty
        const currentPanelId = rightSidebarState?.panelId;
        if (currentPanelId && currentPanelId !== $a29dd95aafebb560$export$99e1679d23263279) closeRightSidebar(currentPanelId);
        // Open our panel (not using force since we explicitly closed others)
        // Parameters: (panelId, width, persistent?)
        openRightSidebar($a29dd95aafebb560$export$99e1679d23263279, 400, false);
    }, [
        openRightSidebar,
        closeRightSidebar,
        rightSidebarState
    ]);
    const closePanel = (0, $euxye.useCallback)(()=>{
        // Just close the sidebar - the useEffect listener will automatically clear state
        closeRightSidebar($a29dd95aafebb560$export$99e1679d23263279);
    }, [
        closeRightSidebar
    ]);
    const clearSelections = (0, $euxye.useCallback)(()=>{
        setSelectedCardId(null);
    }, []);
    // UI context value - only UI state, changes frequently
    const uiValue = (0, $euxye.useMemo)(()=>({
            isOpen: isOpen,
            selectedCardId: selectedCardId,
            openPanel: openPanel,
            closePanel: closePanel,
            clearSelections: clearSelections
        }), [
        isOpen,
        selectedCardId,
        openPanel,
        closePanel,
        clearSelections
    ]);
    // Listen for external panel closes (e.g., when Rovo opens and replaces our panel)
    // Clear selection when our panel is no longer active
    (0, $euxye.useEffect)(()=>{
        const currentPanelId = rightSidebarState?.panelId;
        // If we had a selection and now a different panel is active, clear our state
        if (selectedCardId && currentPanelId !== $a29dd95aafebb560$export$99e1679d23263279) {
            setIsOpen(false);
            setSelectedCardId(null);
        }
    }, [
        rightSidebarState?.panelId,
        selectedCardId
    ]);
    // Update bridge for cross-boundary access (SafeRecommendationPanel)
    (0, $euxye.useEffect)(()=>{
        uiContextValueRef.current = uiValue;
        $a29dd95aafebb560$var$providerBridge.uiContext = uiValue;
        $a29dd95aafebb560$var$notifyBridgeListeners();
    }, [
        uiValue
    ]);
    (0, $euxye.useEffect)(()=>{
        dataContextValueRef.current = dataValue;
        $a29dd95aafebb560$var$providerBridge.dataContext = dataValue;
        $a29dd95aafebb560$var$notifyBridgeListeners();
    }, [
        dataValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a29dd95aafebb560$export$d0e49094432eba5c.Provider, {
        value: dataValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a29dd95aafebb560$export$1d079068b917dd03.Provider, {
        value: uiValue
    }, children));
};
$a29dd95aafebb560$var$RecommendationPanelProviderWithQuery.displayName = "RecommendationPanelProviderWithQuery";
const $a29dd95aafebb560$export$21463607abc70643 = ()=>{
    const context = (0, $euxye.useContext)($a29dd95aafebb560$export$d0e49094432eba5c);
    if (!context) throw new Error('useRecommendationData must be used within RecommendationPanelProvider');
    return context;
};
const $a29dd95aafebb560$export$5a7b5ecf0a7c5381 = ()=>{
    const context = (0, $euxye.useContext)($a29dd95aafebb560$export$1d079068b917dd03);
    if (!context) throw new Error('useRecommendationUI must be used within RecommendationPanelProvider');
    return context;
};
const $a29dd95aafebb560$export$3dba1fa45fe9c5ef = ()=>{
    const dataContext = $a29dd95aafebb560$export$21463607abc70643();
    const uiContext = $a29dd95aafebb560$export$5a7b5ecf0a7c5381();
    return {
        ...dataContext,
        ...uiContext
    };
};
const $a29dd95aafebb560$export$f4a3a384e025b31d = $a29dd95aafebb560$export$1d079068b917dd03;

});
parcelRegister("3Z6hv", function(module, exports) {
$parcel$export(module.exports, "default", () => $083ee34de7abe29f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<944849d9b468cb7762f517b8e800e3ee>>
 * @relayHash 0a22f0f904233e12aeb8f1085117e284
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22ceaa941ce71fc7bc67f82e86c6d380cbbf7dfb46c821e1406d50d893d492a2
const $083ee34de7abe29f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "recommendationCategory"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "RequiredField",
        "field": v3 /*: any*/ ,
        "action": "THROW"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "RequiredField",
        "field": v5 /*: any*/ ,
        "action": "THROW"
    }, v7 = {
        "kind": "ScalarField",
        "name": "group"
    }, v8 = {
        "kind": "ScalarField",
        "name": "link"
    }, v9 = [
        v4 /*: any*/ ,
        {
            "kind": "RequiredField",
            "field": v8 /*: any*/ ,
            "action": "THROW"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "created"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "RequiredField",
        "field": v11 /*: any*/ ,
        "action": "THROW"
    }, v13 = {
        "kind": "ScalarField",
        "name": "groupCategory"
    }, v14 = {
        "kind": "ScalarField",
        "name": "sidePanelTitle"
    }, v15 = {
        "kind": "ScalarField",
        "name": "sidePanelDescription"
    }, v16 = [
        v3 /*: any*/ ,
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RecommendationPanelContextQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraCFORecommendationConnection",
                                    "kind": "LinkedField",
                                    "name": "cfoRecommendations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraCFORecommendationEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraCFORecommendation",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v2 /*: any*/ ,
                                                                    "action": "THROW"
                                                                },
                                                                v4 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7 /*: any*/ ,
                                                                    "action": "THROW"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraCFORecommendationLink",
                                                                        "kind": "LinkedField",
                                                                        "name": "actions",
                                                                        "plural": true,
                                                                        "selections": v9 /*: any*/ 
                                                                    },
                                                                    "action": "THROW"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraCFORecommendationLink",
                                                                        "kind": "LinkedField",
                                                                        "name": "resources",
                                                                        "plural": true,
                                                                        "selections": v9 /*: any*/ 
                                                                    },
                                                                    "action": "THROW"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v10 /*: any*/ ,
                                                                    "action": "THROW"
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW"
                                                    }
                                                ]
                                            },
                                            "action": "THROW"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraCFORecommendationGroupDetailConnection",
                                    "kind": "LinkedField",
                                    "name": "cfoRecommendationGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraCFORecommendationGroupDetailEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraCFORecommendationGroupDetail",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v13 /*: any*/ ,
                                                                    "action": "THROW"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v14 /*: any*/ ,
                                                                    "action": "THROW"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v15 /*: any*/ ,
                                                                    "action": "THROW"
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW"
                                                    }
                                                ]
                                            },
                                            "action": "THROW"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RecommendationPanelContextQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCFORecommendationConnection",
                            "kind": "LinkedField",
                            "name": "cfoRecommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCFORecommendationEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFORecommendation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraCFORecommendationLink",
                                                    "kind": "LinkedField",
                                                    "name": "actions",
                                                    "plural": true,
                                                    "selections": v16 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraCFORecommendationLink",
                                                    "kind": "LinkedField",
                                                    "name": "resources",
                                                    "plural": true,
                                                    "selections": v16 /*: any*/ 
                                                },
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCFORecommendationGroupDetailConnection",
                            "kind": "LinkedField",
                            "name": "cfoRecommendationGroups",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCFORecommendationGroupDetailEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFORecommendationGroupDetail",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "22ceaa941ce71fc7bc67f82e86c6d380cbbf7dfb46c821e1406d50d893d492a2",
            "metadata": {},
            "name": "RecommendationPanelContextQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$083ee34de7abe29f$var$node.hash = "4f911dcbaa55da2d7e52de6cccbd7ec6";
var $083ee34de7abe29f$export$2e2bcd8739ae039 = $083ee34de7abe29f$var$node;

});





parcelRegister("buNKE", function(module, exports) {
$parcel$export(module.exports, "PerformanceMonitorDashboardEntryPoint", () => $67242640d760c3d0$export$220d2ee62020fcad);
/* eslint-disable jira/naming/disallow-filenames */ 
var $kPkOR = parcelRequire("kPkOR");

var $17WN2 = parcelRequire("17WN2");

var $7KoJw = parcelRequire("7KoJw");

var $aX9ix = parcelRequire("aX9ix");

var $gxeuJ = parcelRequire("gxeuJ");

var $cuHRd = parcelRequire("cuHRd");

var $5dAAo = parcelRequire("5dAAo");

var $3Z6hv = parcelRequire("3Z6hv");

var $tCCNR = parcelRequire("tCCNR");

var $dTa0V = parcelRequire("dTa0V");

var $7NTte = parcelRequire("7NTte");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

const $67242640d760c3d0$export$220d2ee62020fcad = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("1RE2F")), {
            moduleId: "9167190b",
            moduleName: "DashboardWithErrorBoundary",
            priority: "interaction"
        }),
        getPreloadProps: ({ tenantContext: tenantContext, context: context })=>{
            const now = new Date();
            const endDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
            const startDate = new Date(endDate.getTime() - 604800000);
            // Read dimension from URL query parameter, default to 'network_downlink'
            const dimensionParam = context?.query?.dimension;
            const validDimensions = [
                'cpus',
                'network_downlink',
                'http_protocol',
                'os',
                'browser_name'
            ];
            const dimension = typeof dimensionParam === 'string' && validDimensions.includes(dimensionParam) ? dimensionParam : 'network_downlink';
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            const queries = {};
            if (!(0, $i860n.fg)('enable_jira_apm_m2') && !(0, $2700E.expVal)('enable_site_optimizer_tab_creation', 'value', false) && (0, $i860n.fg)('enable_cfo_dashboard')) queries.performanceLimitsAndCleanupQuery = {
                parameters: (0, $cuHRd.default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    schemaMigrationEnabled: (0, $i860n.fg)('site_optimiser_schema_migration'),
                    projectLevelReportingEnabled: (0, $i860n.fg)('slt1-682-fe-project-level-reporting-so'),
                    siteOptimizerAddCfoIslMetricsEnabled: (0, $i860n.fg)('slt1-1341_site_optimizer_add_cfo_isl_metrics')
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            };
            if ((0, $i860n.fg)('enable_cfo_dashboard')) {
                queries.boardPerformanceQuery = {
                    parameters: (0, $kPkOR.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        startDate: startDate,
                        endDate: endDate,
                        filters: [
                            {
                                boardFilter: {
                                    keyword: '',
                                    performanceStatus: [
                                        'SLOW',
                                        'MODERATE',
                                        'FAST'
                                    ],
                                    sortInput: [
                                        {
                                            key: 'perfStatus',
                                            order: 'DESC'
                                        },
                                        {
                                            key: 'views',
                                            order: 'DESC'
                                        }
                                    ]
                                }
                            }
                        ],
                        after: ''
                    },
                    fetchPolicy: 'store-or-network'
                };
                queries.performanceNetworkQuery = {
                    parameters: (0, $gxeuJ.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        startDate: startDate,
                        endDate: endDate,
                        granularity: 'DAY',
                        ...(0, $2700E.expValEquals)('enable_cfo_deep_linking_dimension', 'value', true, false) && {
                            dimension: dimension
                        }
                    },
                    fetchPolicy: 'store-or-network'
                };
                queries.performanceOverviewQuery = {
                    parameters: (0, $5dAAo.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        startDate: startDate,
                        endDate: endDate,
                        granularity: 'DAY'
                    },
                    fetchPolicy: 'store-or-network'
                };
                // Only load recommendationGroupsQuery if experiment is enabled
                if ((0, $2700E.expValEquals)('enable_cfo_recommendations_m1', 'value', true, false)) queries.recommendationGroupsQuery = {
                    parameters: (0, $3Z6hv.default),
                    variables: {
                        cloudId: tenantContext.cloudId
                    },
                    fetchPolicy: 'store-or-network'
                };
            }
            if ((0, $i860n.fg)('enable_jira_apm_m2')) {
                const loadTimesEnd = Date.now();
                const loadTimesStart = loadTimesEnd - 86400000;
                queries.loadTimesQuery = {
                    parameters: (0, $7KoJw.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        startDate: new Date(loadTimesStart).toISOString(),
                        endDate: new Date(loadTimesEnd).toISOString(),
                        granularity: 'HOUR',
                        sortInput: [
                            {
                                key: 'timestamp',
                                order: 'ASC'
                            }
                        ]
                    },
                    fetchPolicy: 'store-or-network'
                };
                // Board performance: daily-aligned 7-day range
                // End = yesterday 23:59:59 UTC (today midnight - 1s)
                // Start = today midnight - 7 days
                const boardPerfNow = new Date();
                const boardPerfTodayMidnight = new Date(Date.UTC(boardPerfNow.getUTCFullYear(), boardPerfNow.getUTCMonth(), boardPerfNow.getUTCDate()));
                const boardPerfEnd = new Date(boardPerfTodayMidnight.getTime() - 1000);
                const boardPerfStart = new Date(boardPerfTodayMidnight.getTime() - 604800000);
                // User setup: weekly-aligned 4-week range
                // End = previous Sunday 23:59:59 UTC (last Monday midnight - 1s)
                // Start = last Monday midnight - 28 days
                const userSetupDayOfWeek = boardPerfNow.getUTCDay();
                const userSetupDaysToLastMonday = userSetupDayOfWeek === 0 ? 6 : userSetupDayOfWeek - 1;
                const userSetupLastMonday = new Date(Date.UTC(boardPerfNow.getUTCFullYear(), boardPerfNow.getUTCMonth(), boardPerfNow.getUTCDate() - userSetupDaysToLastMonday));
                const userSetupEnd = new Date(userSetupLastMonday.getTime() - 1000);
                const userSetupStart = new Date(userSetupLastMonday.getTime() - 2419200000);
                queries.overviewTabQuery = {
                    parameters: (0, $aX9ix.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        startDate: new Date(loadTimesStart).toISOString(),
                        endDate: new Date(loadTimesEnd).toISOString(),
                        boardPerfStartDate: boardPerfStart.toISOString(),
                        boardPerfEndDate: boardPerfEnd.toISOString(),
                        userSetupStartDate: userSetupStart.toISOString(),
                        userSetupEndDate: userSetupEnd.toISOString()
                    },
                    fetchPolicy: 'store-or-network'
                };
                const cardsEnd = new Date();
                const cardsStart = new Date(cardsEnd.getTime() - 2419200000);
                queries.userSetupDimensionCardsQuery = {
                    parameters: (0, $tCCNR.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        startDate: cardsStart.toISOString(),
                        endDate: cardsEnd.toISOString()
                    },
                    fetchPolicy: 'store-or-network'
                };
                queries.boardPerformanceQueryV2 = {
                    parameters: (0, $17WN2.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        startDate: startDate,
                        endDate: endDate,
                        filters: [
                            {
                                boardFilter: {
                                    keyword: '',
                                    performanceStatus: [
                                        'SLOW',
                                        'MODERATE',
                                        'FAST'
                                    ]
                                }
                            }
                        ],
                        sortInput: [
                            {
                                key: 'perfStatus',
                                order: 'DESC'
                            },
                            {
                                key: 'views',
                                order: 'DESC'
                            }
                        ],
                        after: ''
                    },
                    fetchPolicy: 'store-or-network'
                };
            }
            return {
                queries: queries
            };
        }
    }
});

});
parcelRegister("kPkOR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6248112d4a6344ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<69ea8514cceb03cd7a14b3a1e75ad69c>>
 * @relayHash b3379c59530f1a530a0a4079f774e80d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc41ef8f0cfaddd3a97d66068e69b8dee15c77f71f773b37d120a0d2ad6cd1f9
const $6248112d4a6344ba$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v7 = {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
    }, v8 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v9 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v10 = {
        "kind": "Literal",
        "name": "dimensions",
        "value": [
            {
                "name": "jira_board_id"
            }
        ]
    }, v11 = {
        "type": "PERCENTILE",
        "value": 0.5
    }, v12 = {
        "type": "COUNT"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "Literal",
        "name": "first",
        "value": 25
    }, v15 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BoardPerformanceTabsQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BoardPerformanceTabSummary"
                },
                {
                    "args": [
                        v9 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BoardPerformanceTabTable"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BoardPerformanceTabsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "boardPerformanceSummary",
                            "args": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": v11 /*: any*/ ,
                                            "alias": "loadTime",
                                            "name": "ttvc90",
                                            "summarize": true
                                        },
                                        {
                                            "aggregation": v12 /*: any*/ ,
                                            "alias": "views",
                                            "name": "*",
                                            "summarize": true
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCFOBoardPerfStats",
                                                    "kind": "LinkedField",
                                                    "name": "boardPerfStats",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "slowBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moderateBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fastBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "slowBoardThreshold"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fastBoardThreshold"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCFOBoardPerformanceMetricSummary"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "after",
                                            "value": ""
                                        },
                                        v14 /*: any*/ 
                                    ],
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ 
                                    ],
                                    "storageKey": "data(after:\"\",first:25)"
                                }
                            ]
                        },
                        {
                            "alias": "boardPerformanceTableValues",
                            "args": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": v12 /*: any*/ ,
                                            "alias": "views",
                                            "name": "*"
                                        },
                                        {
                                            "aggregation": v11 /*: any*/ ,
                                            "alias": "loadTime",
                                            "name": "ttvc90"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "args": [
                                        v9 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ],
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFODataRowEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraCFOMetric",
                                                            "kind": "LinkedField",
                                                            "name": "metrics",
                                                            "plural": true,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardName"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "boardCreator",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "perfStatus"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "projectKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optimizationSuggestion"
                                                                }
                                                            ],
                                                            "type": "JiraCFOBoardPerformanceDataRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bc41ef8f0cfaddd3a97d66068e69b8dee15c77f71f773b37d120a0d2ad6cd1f9",
            "metadata": {},
            "name": "BoardPerformanceTabsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6248112d4a6344ba$var$node.hash = "306a79f31bf6a2bceda3f37cbfbdfbad";
var $6248112d4a6344ba$export$2e2bcd8739ae039 = $6248112d4a6344ba$var$node;

});

parcelRegister("17WN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9df5c79806a931$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f85c702e2ddc54383bcfa4ba4706b9c0>>
 * @relayHash 4b95665958870d4e08600508e3255f7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 685edb442232e0bac516826991501285e77f6e5637793ccc0f1c9256bf3efd06
const $ad9df5c79806a931$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v8 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v9 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v10 = {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
    }, v11 = {
        "kind": "Variable",
        "name": "sortInput",
        "variableName": "sortInput"
    }, v12 = {
        "kind": "Literal",
        "name": "dimensions",
        "value": [
            {
                "alias": "jira_board_id",
                "name": "custom:boardId"
            }
        ]
    }, v13 = {
        "kind": "Literal",
        "name": "isV2",
        "value": true
    }, v14 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            {
                "aggregation": {
                    "type": "SUM"
                },
                "alias": "views",
                "name": "count"
            },
            {
                "aggregation": {
                    "type": "PERCENTILE",
                    "value": 0.75
                },
                "alias": "loadTime",
                "name": "vc90"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "slowBoardThreshold"
    }, v17 = {
        "kind": "ScalarField",
        "name": "fastBoardThreshold"
    }, v18 = {
        "kind": "Literal",
        "name": "first",
        "value": 25
    }, v19 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "self"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BoardPerformanceTabV2Query",
            "selections": [
                {
                    "args": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BoardPerformanceTabSummaryV2"
                },
                {
                    "args": [
                        v9 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BoardPerformanceTabTableV2"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BoardPerformanceTabV2Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "boardPerformanceSummary",
                            "args": [
                                v6 /*: any*/ ,
                                v12 /*: any*/ ,
                                v7 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCFOBoardPerfStats",
                                                    "kind": "LinkedField",
                                                    "name": "boardPerfStats",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "slowBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moderateBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fastBoardsCount"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCFOBoardPerformanceMetricSummary"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "after",
                                            "value": ""
                                        },
                                        v18 /*: any*/ 
                                    ],
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ 
                                    ],
                                    "storageKey": "data(after:\"\",first:25)"
                                }
                            ]
                        },
                        {
                            "alias": "boardPerformanceTableValuesV2",
                            "args": [
                                v6 /*: any*/ ,
                                v12 /*: any*/ ,
                                v7 /*: any*/ ,
                                v10 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v11 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCFOBoardPerfStats",
                                                    "kind": "LinkedField",
                                                    "name": "boardPerfStats",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCFOBoardPerformanceMetricSummary"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v9 /*: any*/ ,
                                        v18 /*: any*/ 
                                    ],
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFODataRowEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraCFOMetric",
                                                            "kind": "LinkedField",
                                                            "name": "metrics",
                                                            "plural": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraBoardLocationModel",
                                                                    "kind": "LinkedField",
                                                                    "name": "boardLocation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "userLocationId"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "projectKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "perfStatus"
                                                                },
                                                                {
                                                                    "concreteType": "JiraBoardAdmins",
                                                                    "kind": "LinkedField",
                                                                    "name": "boardAdmins",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraBoardAdminUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "users",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "displayName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "active"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "accountId"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraBoardAdminAvatarUrls",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatarUrls",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "xsmall"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "small"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "medium"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "large"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraBoardAdminGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "groups",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraCFOBoardPerformanceDataRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "685edb442232e0bac516826991501285e77f6e5637793ccc0f1c9256bf3efd06",
            "metadata": {},
            "name": "BoardPerformanceTabV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ad9df5c79806a931$var$node.hash = "5fe8fba112b0ffefe41c1d7bb7e7ea4c";
var $ad9df5c79806a931$export$2e2bcd8739ae039 = $ad9df5c79806a931$var$node;

});

parcelRegister("7KoJw", function(module, exports) {
$parcel$export(module.exports, "default", () => $004074ca823b4ae2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<237cacb8b5b7f0346ee6ee58240a0af2>>
 * @relayHash 93e52fbeb9de0a05ec4982ac1e0aecac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d37d73adbd3a9cc6d79b10ac0a458fcaa19918b65f6029434a3375472417480
const $004074ca823b4ae2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v2 = {
        "defaultValue": "HOUR",
        "kind": "LocalArgument",
        "name": "granularity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v7 = {
        "kind": "Variable",
        "name": "granularity",
        "variableName": "granularity"
    }, v8 = {
        "kind": "Variable",
        "name": "sortInput",
        "variableName": "sortInput"
    }, v9 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v10 = {
        "kind": "Literal",
        "name": "dimensions",
        "value": [
            {
                "name": "apdexBucket"
            }
        ]
    }, v11 = {
        "kind": "Literal",
        "name": "filters",
        "value": [
            {
                "dimensionFilter": {
                    "name": "experienceKey",
                    "operator": "IN",
                    "values": [
                        "jira.fe.page-load.classic-board",
                        "jira.fe.page-load.next-gen-board",
                        "jira.fe.page-load.issue-view",
                        "jira.fe.page-load.issue-view-software",
                        "jira.fe.page-load.issue-view-serviceDesk",
                        "jira.fe.page-load.issue-view-core",
                        "jira.fe.page-load.issue-view-polaris",
                        "jira.fe.page-load.issue-view-platform",
                        "jira.fe.page-load.issue-view-embed",
                        "jira.fe.page-load.issue-view-addon",
                        "jira.fe.page-load.issue-view-unknown",
                        "jira.fe.page-load.issue-view-customer-service",
                        "jira.fe.custom.embedded-issue-view-load",
                        "jira.fe.page-load.classic-backlog",
                        "jira.fe.page-load.next-gen-backlog"
                    ]
                }
            }
        ]
    }, v12 = {
        "kind": "Literal",
        "name": "isV2",
        "value": true
    }, v13 = {
        "aggregation": {
            "type": "SUM"
        },
        "alias": "request_count",
        "name": "count"
    }, v14 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            v13 /*: any*/ 
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "timestamp"
    }, v17 = {
        "kind": "ScalarField",
        "name": "value"
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        v17 /*: any*/ 
    ], v19 = [
        v15 /*: any*/ ,
        {
            "concreteType": "JiraCFODataRowConnection",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "JiraCFODimension",
                                    "kind": "LinkedField",
                                    "name": "dimensions",
                                    "plural": true,
                                    "selections": v18 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraCFOMetric",
                                    "kind": "LinkedField",
                                    "name": "metrics",
                                    "plural": true,
                                    "selections": [
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v20 = {
        "kind": "Literal",
        "name": "filters",
        "value": [
            {
                "dimensionFilter": {
                    "name": "experienceKey",
                    "operator": "IN",
                    "values": [
                        "jira.fe.page-load.classic-board",
                        "jira.fe.page-load.next-gen-board"
                    ]
                }
            }
        ]
    }, v21 = {
        "kind": "Literal",
        "name": "filters",
        "value": [
            {
                "dimensionFilter": {
                    "name": "experienceKey",
                    "operator": "IN",
                    "values": [
                        "jira.fe.page-load.issue-view",
                        "jira.fe.page-load.issue-view-software",
                        "jira.fe.page-load.issue-view-serviceDesk",
                        "jira.fe.page-load.issue-view-core",
                        "jira.fe.page-load.issue-view-polaris",
                        "jira.fe.page-load.issue-view-platform",
                        "jira.fe.page-load.issue-view-embed",
                        "jira.fe.page-load.issue-view-addon",
                        "jira.fe.page-load.issue-view-unknown",
                        "jira.fe.page-load.issue-view-customer-service",
                        "jira.fe.custom.embedded-issue-view-load"
                    ]
                }
            }
        ]
    }, v22 = {
        "kind": "Literal",
        "name": "filters",
        "value": [
            {
                "dimensionFilter": {
                    "name": "experienceKey",
                    "operator": "IN",
                    "values": [
                        "jira.fe.page-load.classic-backlog",
                        "jira.fe.page-load.next-gen-backlog"
                    ]
                }
            }
        ]
    }, v23 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            {
                "aggregation": {
                    "type": "PERCENTILE",
                    "value": 0.5
                },
                "alias": "load_time_p50",
                "name": "vc90"
            },
            {
                "aggregation": {
                    "type": "PERCENTILE",
                    "value": 0.75
                },
                "alias": "load_time_p75",
                "name": "vc90"
            },
            v13 /*: any*/ 
        ]
    }, v24 = [
        v15 /*: any*/ ,
        {
            "concreteType": "JiraCFODataRowConnection",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "JiraCFOMetric",
                                    "kind": "LinkedField",
                                    "name": "metrics",
                                    "plural": true,
                                    "selections": v18 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "LoadTimesTabQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "LoadTimesTab"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "LoadTimesTabQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v5 /*: any*/ 
                            ],
                            "concreteType": "JiraCFOConfigsResult",
                            "kind": "LinkedField",
                            "name": "cfoConfigs",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCFOLoadTimeConfig",
                                    "kind": "LinkedField",
                                    "name": "loadTimeConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "lowerThreshold"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "higherThreshold"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "aggregated",
                            "args": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v11 /*: any*/ ,
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v19 /*: any*/ 
                        },
                        {
                            "alias": "boards",
                            "args": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v20 /*: any*/ ,
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v19 /*: any*/ 
                        },
                        {
                            "alias": "workItems",
                            "args": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v21 /*: any*/ ,
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v19 /*: any*/ 
                        },
                        {
                            "alias": "backlogs",
                            "args": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v22 /*: any*/ ,
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v19 /*: any*/ 
                        },
                        {
                            "alias": "aggregatedPercentile",
                            "args": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v11 /*: any*/ ,
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v23 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        },
                        {
                            "alias": "boardsPercentile",
                            "args": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v20 /*: any*/ ,
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v23 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        },
                        {
                            "alias": "workItemsPercentile",
                            "args": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v21 /*: any*/ ,
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v23 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        },
                        {
                            "alias": "backlogsPercentile",
                            "args": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v22 /*: any*/ ,
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v23 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5d37d73adbd3a9cc6d79b10ac0a458fcaa19918b65f6029434a3375472417480",
            "metadata": {},
            "name": "LoadTimesTabQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$004074ca823b4ae2$var$node.hash = "faf0e3b7e9ffdb2c5360c2bdfc76e4db";
var $004074ca823b4ae2$export$2e2bcd8739ae039 = $004074ca823b4ae2$var$node;

});

parcelRegister("aX9ix", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4462c616dba9af2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b8f90da531065286b0ac7b7abdbff850>>
 * @relayHash df4e6bf907f61a108db3338d5f684311
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81b5555319a4634a2993025edb386f42b5c688704d5c07e0b7c4aa3830bc87df
const $d4462c616dba9af2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardPerfEndDate"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardPerfStartDate"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userSetupEndDate"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userSetupStartDate"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = {
        "kind": "Literal",
        "name": "isV2",
        "value": true
    }, v9 = {
        "type": "SUM"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "aggregation": {
            "type": "PERCENTILE",
            "value": 0.75
        },
        "alias": "loadTime",
        "name": "vc90"
    }, v13 = [
        {
            "concreteType": "JiraCFOMetric",
            "kind": "LinkedField",
            "name": "metric",
            "plural": false,
            "selections": v11 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "OverviewTabQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "LoadTimesOverviewTile_query"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "BoardPerformanceOverviewTile_query"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "UserSetupOverviewTile_query"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "OverviewTabQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v7 /*: any*/ 
                            ],
                            "concreteType": "JiraCFOConfigsResult",
                            "kind": "LinkedField",
                            "name": "cfoConfigs",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCFOLoadTimeConfig",
                                    "kind": "LinkedField",
                                    "name": "loadTimeConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "lowerThreshold"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "higherThreshold"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "loadTimeSummary",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "alias": "apdex_bucket",
                                            "name": "metric:apdex_bucket"
                                        }
                                    ]
                                },
                                {
                                    "kind": "Variable",
                                    "name": "endDate",
                                    "variableName": "endDate"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "filters",
                                    "value": [
                                        {
                                            "dimensionFilter": {
                                                "name": "experience:key",
                                                "operator": "IN",
                                                "values": [
                                                    "jira.fe.page-load.issue-view",
                                                    "jira.fe.page-load.issue-view-software",
                                                    "jira.fe.page-load.issue-view-serviceDesk",
                                                    "jira.fe.page-load.issue-view-core",
                                                    "jira.fe.page-load.issue-view-polaris",
                                                    "jira.fe.page-load.issue-view-platform",
                                                    "jira.fe.page-load.issue-view-embed",
                                                    "jira.fe.page-load.issue-view-addon",
                                                    "jira.fe.page-load.issue-view-unknown",
                                                    "jira.fe.page-load.issue-view-customer-service",
                                                    "jira.fe.page-load.classic-board",
                                                    "jira.fe.page-load.classic-backlog",
                                                    "jira.fe.page-load.next-gen-board",
                                                    "jira.fe.page-load.next-gen-backlog",
                                                    "jira.fe.custom.embedded-issue-view-load"
                                                ]
                                            }
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": v9 /*: any*/ ,
                                            "name": "count"
                                        }
                                    ]
                                },
                                {
                                    "kind": "Variable",
                                    "name": "startDate",
                                    "variableName": "startDate"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCFOMetricBucketComparison",
                                                    "kind": "LinkedField",
                                                    "name": "bucketComparisons",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCFODimension",
                                                            "kind": "LinkedField",
                                                            "name": "dimension",
                                                            "plural": false,
                                                            "selections": v11 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraCFOMetric",
                                                            "kind": "LinkedField",
                                                            "name": "currentMetric",
                                                            "plural": false,
                                                            "selections": v11 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "changePercentage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCFOLoadTimeMetricSummary"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "boardPerformanceSummary",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "alias": "jira_board_id",
                                            "name": "custom:boardId"
                                        }
                                    ]
                                },
                                {
                                    "kind": "Variable",
                                    "name": "endDate",
                                    "variableName": "boardPerfEndDate"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": v9 /*: any*/ ,
                                            "alias": "views",
                                            "name": "count"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "Variable",
                                    "name": "startDate",
                                    "variableName": "boardPerfStartDate"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCFOBoardPerfStats",
                                                    "kind": "LinkedField",
                                                    "name": "boardPerfStats",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "slowBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moderateBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fastBoardsCount"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCFOBoardPerformanceMetricSummary"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "after",
                                            "value": ""
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 25
                                        }
                                    ],
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ],
                                    "storageKey": "data(after:\"\",first:25)"
                                }
                            ]
                        },
                        {
                            "alias": "userSetupSummary",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "alias": "networkDownlink",
                                            "name": "networkDownlink"
                                        },
                                        {
                                            "alias": "httpProtocol",
                                            "name": "httpProtocol"
                                        },
                                        {
                                            "alias": "cpus",
                                            "name": "telemetry:cpus"
                                        },
                                        {
                                            "alias": "osClassification",
                                            "name": "osClassification"
                                        }
                                    ]
                                },
                                {
                                    "kind": "Variable",
                                    "name": "endDate",
                                    "variableName": "userSetupEndDate"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "Variable",
                                    "name": "startDate",
                                    "variableName": "userSetupStartDate"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCFOUserSetupDimensionImpact",
                                                    "kind": "LinkedField",
                                                    "name": "dimensionImpacts",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dimensionName"
                                                        },
                                                        {
                                                            "concreteType": "JiraCFOCohortMetric",
                                                            "kind": "LinkedField",
                                                            "name": "fastestCohort",
                                                            "plural": false,
                                                            "selections": v13 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraCFOCohortMetric",
                                                            "kind": "LinkedField",
                                                            "name": "slowestCohort",
                                                            "plural": false,
                                                            "selections": v13 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraCFOCohortMetric",
                                                    "kind": "LinkedField",
                                                    "name": "overallFastest",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraCFOCohortMetric",
                                                    "kind": "LinkedField",
                                                    "name": "overallSlowest",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fastestSetupEventCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalEventCount"
                                                }
                                            ],
                                            "type": "JiraCFOUserSetupMetricSummary"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "81b5555319a4634a2993025edb386f42b5c688704d5c07e0b7c4aa3830bc87df",
            "metadata": {},
            "name": "OverviewTabQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d4462c616dba9af2$var$node.hash = "43bdf687e9be39a13d349164e03120f5";
var $d4462c616dba9af2$export$2e2bcd8739ae039 = $d4462c616dba9af2$var$node;

});

parcelRegister("gxeuJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $52c63ceed8a66d09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4970d18b5c86ca070279ec2f697bb3cf>>
 * @relayHash 1c57182c48cac0e1935dff63eed52f97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91ee270ba8a4a23aed34b9104b68a8d1847e24d7ecd5d2bb5ea88f0bed1ee6bf
const $52c63ceed8a66d09$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": "network_downlink",
        "kind": "LocalArgument",
        "name": "dimension"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v3 = {
        "defaultValue": "DAY",
        "kind": "LocalArgument",
        "name": "granularity"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v7 = {
        "kind": "Variable",
        "name": "granularity",
        "variableName": "granularity"
    }, v8 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v9 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            {
                "aggregation": {
                    "type": "COUNT_DISTINCT"
                },
                "name": "account_id"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "concreteType": "JiraCFODimension",
        "kind": "LinkedField",
        "name": "dimensions",
        "plural": true,
        "selections": v11 /*: any*/ 
    }, v13 = {
        "concreteType": "JiraCFOMetric",
        "kind": "LinkedField",
        "name": "metrics",
        "plural": true,
        "selections": v11 /*: any*/ 
    }, v14 = [
        v10 /*: any*/ ,
        {
            "concreteType": "JiraCFODataRowConnection",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "timestamp"
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PerformanceNetworkViewQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PerformanceNetworkUserCharts"
                },
                {
                    "args": [
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "dimension",
                            "variableName": "dimension"
                        },
                        v6 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PerformanceMonitoringHorizontalBarChart"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PerformanceNetworkViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "cores",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "cpus"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "speed",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "network_downlink"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "protocol",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "http_protocol"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "os",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "os"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "browsers",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "browser_name"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "ttvcAnalytics",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "items": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "name",
                                                    "variableName": "dimension"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "dimensions.0"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "dimensions"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": {
                                                "type": "PERCENTILE",
                                                "value": 0.5
                                            },
                                            "name": "ttvc90"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFODataRowEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "91ee270ba8a4a23aed34b9104b68a8d1847e24d7ecd5d2bb5ea88f0bed1ee6bf",
            "metadata": {},
            "name": "PerformanceNetworkViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$52c63ceed8a66d09$var$node.hash = "6203650689cd6f017f015501d7de4fcf";
var $52c63ceed8a66d09$export$2e2bcd8739ae039 = $52c63ceed8a66d09$var$node;

});

parcelRegister("cuHRd", function(module, exports) {
$parcel$export(module.exports, "default", () => $31f4473b968c5205$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2074b1295a5033783d5e9ee5c0082f8d>>
 * @relayHash 9f9cb1ab807b4251397ecd0c741c72a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc0b336f1bdcce98932017d4b5976c3beb6384ac96dfd649fce2812986df0448
const $31f4473b968c5205$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectLevelReportingEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemaMigrationEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteOptimizerAddCfoIslMetricsEnabled"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "projectLevelReportingEnabled",
            "variableName": "projectLevelReportingEnabled"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "currentValue"
    }, v8 = {
        "kind": "ScalarField",
        "name": "warningValue"
    }, v9 = {
        "kind": "ScalarField",
        "name": "thresholdValue"
    }, v10 = {
        "kind": "ScalarField",
        "name": "cleanupValue"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "projectsOverLimit"
    }, v13 = {
        "kind": "ScalarField",
        "name": "projectsReachingLimit"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = [
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v16 = {
        "kind": "InlineFragment",
        "selections": v15 /*: any*/ ,
        "type": "JiraWorkTypeUsageMetric"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": v15 /*: any*/ ,
        "type": "JiraCustomFieldUsageMetric"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PerformanceOverviewMainQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnection",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetrics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "OverviewPage"
                                                }
                                            ]
                                        },
                                        "action": "THROW"
                                    }
                                ]
                            },
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnectionV2",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetricsV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "OverviewPage843BadPattern"
                                                },
                                                {
                                                    "condition": "siteOptimizerAddCfoIslMetricsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "fragment": {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": "OverviewPageV2SchemaMigrationData"
                                                                    }
                                                                ],
                                                                "type": "JiraResourceUsageMetricConnectionV2"
                                                            },
                                                            "kind": "AliasedInlineFragmentSpread",
                                                            "name": "overviewPageV2SchemaMigrationData"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        "action": "THROW"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PerformanceOverviewMainQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnection",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "projectLevelReportingEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraResourceUsageMetric",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "projectLevelReportingEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraResourceUsageMetric",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetricsV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "projectLevelReportingEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "projectLevelReportingEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "siteOptimizerAddCfoIslMetricsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldsOverLimit"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldsReachingLimit"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFieldOptionUsageMetric"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v15 /*: any*/ ,
                                                            "type": "JiraIssueSecurityLevelUsageMetric"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bc0b336f1bdcce98932017d4b5976c3beb6384ac96dfd649fce2812986df0448",
            "metadata": {},
            "name": "PerformanceOverviewMainQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$31f4473b968c5205$var$node.hash = "5daa69147986dcb6c0bed5d352f2f492";
var $31f4473b968c5205$export$2e2bcd8739ae039 = $31f4473b968c5205$var$node;

});

parcelRegister("5dAAo", function(module, exports) {
$parcel$export(module.exports, "default", () => $92469770a15544cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7fffcd03605f06eaa5873ef7f1b6e834>>
 * @relayHash 4f476a3269c073f4aafe9312d2678410
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 582c84182b144e5c8671f00e32dff74f395b90bc152ef8e392d65273837f95cf

var $1micA = parcelRequire("1micA");

var $kMQg4 = parcelRequire("kMQg4");
const $92469770a15544cd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v2 = {
        "defaultValue": "DAY",
        "kind": "LocalArgument",
        "name": "granularity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v6 = {
        "kind": "Variable",
        "name": "granularity",
        "variableName": "granularity"
    }, v7 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v8 = [
        v4 /*: any*/ 
    ], v9 = {
        "kind": "Literal",
        "name": "dimensions",
        "value": []
    }, v10 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            {
                "aggregation": {
                    "type": "PERCENTILE",
                    "value": 0.75
                },
                "alias": "p75",
                "name": "ttvc90"
            },
            {
                "aggregation": {
                    "type": "PERCENTILE",
                    "value": 0.5
                },
                "alias": "p50",
                "name": "ttvc90",
                "summarize": true
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = [
        v11 /*: any*/ ,
        {
            "concreteType": "JiraCFODataRowConnection",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "timestamp"
                                },
                                {
                                    "concreteType": "JiraCFOMetric",
                                    "kind": "LinkedField",
                                    "name": "metrics",
                                    "plural": true,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "LinkedField",
            "name": "summary",
            "plural": false,
            "selections": [
                v11 /*: any*/ ,
                {
                    "concreteType": "JiraCFOMetricComparison",
                    "kind": "LinkedField",
                    "name": "periodComparison",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraCFOMetric",
                            "kind": "LinkedField",
                            "name": "currentPeriod",
                            "plural": false,
                            "selections": v12 /*: any*/ 
                        },
                        {
                            "kind": "ScalarField",
                            "name": "change"
                        }
                    ]
                }
            ]
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "projectsOverLimit"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PerformanceOverviewQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PerformanceOverviewCharts"
                },
                {
                    "args": v8 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "PerformanceOverviewRecommendations"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcenablecforecommendationsm1relayprovider"
                }
            ],
            "kind": "Operation",
            "name": "PerformanceOverviewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "allExperiences",
                            "args": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        },
                        {
                            "alias": "boards",
                            "args": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filters",
                                    "value": [
                                        {
                                            "dimensionFilter": {
                                                "name": "experience",
                                                "operator": "IN",
                                                "values": [
                                                    "Classic Board",
                                                    "Nextgen Board"
                                                ]
                                            }
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        },
                        {
                            "alias": "workItems",
                            "args": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "items": [
                                        {
                                            "fields": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "name",
                                                            "value": "experience"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "operator",
                                                            "value": "IN"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "values",
                                                            "variableName": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "dimensionFilter"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filters.0"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "filters"
                                },
                                v6 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        },
                        {
                            "alias": "backlogs",
                            "args": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filters",
                                    "value": [
                                        {
                                            "dimensionFilter": {
                                                "name": "experience",
                                                "operator": "IN",
                                                "values": [
                                                    "Classic Backlog",
                                                    "Nextgen Backlog"
                                                ]
                                            }
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcenablecforecommendationsm1relayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetricsV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "unusedCustomFieldsCount"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFieldUsageMetric"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraWorkTypeUsageMetric"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "582c84182b144e5c8671f00e32dff74f395b90bc152ef8e392d65273837f95cf",
            "metadata": {},
            "name": "PerformanceOverviewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider": (0, $kMQg4.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcenablecforecommendationsm1relayprovider": (0, $1micA.default)
            }
        }
    };
}();
$92469770a15544cd$var$node.hash = "881c8d46154125448c6f0461f1adf8cd";
var $92469770a15544cd$export$2e2bcd8739ae039 = $92469770a15544cd$var$node;

});
parcelRegister("1micA", function(module, exports) {
$parcel$export(module.exports, "default", () => $907e0aa87d017642$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
var $907e0aa87d017642$export$2e2bcd8739ae039 = {
    get () {
        return (0, $2700E.expVal)('enable_cfo_recommendations_m1', 'value', false);
    }
};

});

parcelRegister("kMQg4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3e5f14b17b851b9$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
var $f3e5f14b17b851b9$export$2e2bcd8739ae039 = {
    get () {
        // eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
        return (0, $2700E.expVal)('ttvc_dimensions_issue_view', 'value', [
            'Embedded Issue View',
            'Full Issue View'
        ]);
    }
};

});


parcelRegister("tCCNR", function(module, exports) {
$parcel$export(module.exports, "default", () => $622ed229a8e93f8f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ebdbeb12672b838c9860a754c98777c>>
 * @relayHash fce731839868cdd5f0fc2bc001011ec9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 597ed16ecd3baa9a953b3687c18a17edb827896dcfb8c0cd34c959ab6bf3b3cd
const $622ed229a8e93f8f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "name": "networkDownlink"
    }, v5 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v6 = {
        "kind": "Literal",
        "name": "isV2",
        "value": true
    }, v7 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            {
                "aggregation": {
                    "type": "SUM"
                },
                "alias": "request_count",
                "name": "count"
            },
            {
                "aggregation": {
                    "type": "PERCENTILE",
                    "value": 0.75
                },
                "alias": "load_time_p75",
                "name": "vc90"
            }
        ]
    }, v8 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v9 = [
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "dimensions",
            "value": [
                v4 /*: any*/ 
            ]
        },
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = [
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCFODimension",
                "kind": "LinkedField",
                "name": "dimensions",
                "plural": true,
                "selections": v11 /*: any*/ 
            },
            {
                "concreteType": "JiraCFOMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": v11 /*: any*/ 
            }
        ],
        "type": "JiraCFODefaultDataRow"
    }, v13 = [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCFODataRowEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v12 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW"
        }
    ], v14 = {
        "name": "cpus"
    }, v15 = [
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "dimensions",
            "value": [
                v14 /*: any*/ 
            ]
        },
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v16 = {
        "name": "httpProtocol"
    }, v17 = [
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "dimensions",
            "value": [
                v16 /*: any*/ 
            ]
        },
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v18 = {
        "name": "osClassification"
    }, v19 = [
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "dimensions",
            "value": [
                v18 /*: any*/ 
            ]
        },
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v20 = [
        v4 /*: any*/ ,
        v14 /*: any*/ ,
        v16 /*: any*/ ,
        v18 /*: any*/ 
    ], v21 = {
        "args": [
            v3 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "insightOn",
                "value": v20 /*: any*/ 
            },
            v8 /*: any*/ 
        ],
        "concreteType": "JiraCFOMetricInsightConnection",
        "kind": "LinkedField",
        "name": "cfoInsights",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraCFOMetricInsightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraCFOMetricInsight",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v10 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "concreteType": "JiraCFOMetricInsightMetaData",
                                "kind": "LinkedField",
                                "name": "metadata",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "loadTimeDiff"
                                    },
                                    {
                                        "concreteType": "JiraCFOInconclusiveData",
                                        "kind": "LinkedField",
                                        "name": "inconclusiveData",
                                        "plural": true,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "isInconclusive"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v22 = {
        "args": [
            v3 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "dimensions",
                "value": v20 /*: any*/ 
            }
        ],
        "concreteType": "JiraCFOConfigsResult",
        "kind": "LinkedField",
        "name": "cfoConfigs",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraCFOClientSetupConfig",
                "kind": "LinkedField",
                "name": "clientSetupConfig",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "concreteType": "JiraCFODistribution",
                        "kind": "LinkedField",
                        "name": "distribution",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "category"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "label"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = [
        v23 /*: any*/ ,
        {
            "concreteType": "JiraCFODataRowConnection",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v23 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserSetupDimensionCardsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "networkSpeed",
                                    "args": v9 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "cfoAnalytics",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "cpuCores",
                                    "args": v15 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "cfoAnalytics",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "networkProtocol",
                                    "args": v17 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "cfoAnalytics",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "operatingSystem",
                                    "args": v19 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "cfoAnalytics",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                "action": "THROW"
                            },
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserSetupDimensionCardsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "networkSpeed",
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        },
                        {
                            "alias": "cpuCores",
                            "args": v15 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        },
                        {
                            "alias": "networkProtocol",
                            "args": v17 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        },
                        {
                            "alias": "operatingSystem",
                            "args": v19 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v24 /*: any*/ 
                        },
                        v21 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "597ed16ecd3baa9a953b3687c18a17edb827896dcfb8c0cd34c959ab6bf3b3cd",
            "metadata": {},
            "name": "UserSetupDimensionCardsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$622ed229a8e93f8f$var$node.hash = "63f40d753f2307b07b86ce00ea827005";
var $622ed229a8e93f8f$export$2e2bcd8739ae039 = $622ed229a8e93f8f$var$node;

});

parcelRegister("1RE2F", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ecJWm").then(()=>parcelRequire('3z2eQ'));

});



parcelRegister("eQJy2", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRouteEntry", () => $4c526cacb62e905c$export$6f8a930d1f2f4103);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $gsywd = parcelRequire("gsywd");

var $2INlH = parcelRequire("2INlH");
const $4c526cacb62e905c$export$6f8a930d1f2f4103 = (0, $fdS54.createEntry)((0, $gsywd.globalSettingsPerformanceIssueArchivalRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2INlH.IssueMetricDetail),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2INlH.LazyIssueDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gsywd", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRoute", () => $41914895dc6c224e$export$a615b79ae9fb06e5);
const $41914895dc6c224e$export$a615b79ae9fb06e5 = {
    name: 'global-settings-performance-issue',
    path: '/jira/settings/system/performance/metrics/issue'
};

});

parcelRegister("2INlH", function(module, exports) {
$parcel$export(module.exports, "LazyIssueDetail", () => $f1382b8423125b9a$export$e44cbefb7c57e031);
$parcel$export(module.exports, "IssueMetricDetail", () => $f1382b8423125b9a$export$30b22d5292fcd86f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f1382b8423125b9a$export$e44cbefb7c57e031 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("70B9g"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-performance-metric-detail-issue/src/IssueDetail.tsx"
});
const $f1382b8423125b9a$export$30b22d5292fcd86f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f1382b8423125b9a$export$e44cbefb7c57e031,
        pageId: "system-performance-metric-detail-issue",
        shouldShowSpinner: true
    });
$f1382b8423125b9a$export$30b22d5292fcd86f.displayName = "IssueMetricDetail";

});
parcelRegister("70B9g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("8O79b")
]).then(()=>parcelRequire('f84Hj'));

});



parcelRegister("dVpN0", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceIssueSecurityLevelProjectLimitRouteEntry", () => $12fbd138e6491a99$export$cb732360d6e387a0);



var $9UpOy = parcelRequire("9UpOy");

var $4lWtN = parcelRequire("4lWtN");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $h5Piv = parcelRequire("h5Piv");

var $dyN31 = parcelRequire("dyN31");
const $12fbd138e6491a99$var$notFoundPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4lWtN.notFoundEntrypoint)
});
const $12fbd138e6491a99$var$getIssueSecurityLevelProjectLimitResources = ()=>(0, $i860n.fg)('slt1-1341_site_optimizer_add_cfo_isl_metrics') ? [
        ...(0, $dUAVJ.getNavigationResources)(),
        (0, $45Itd.navigationSidebarGlobalResource),
        (0, $9UpOy.issueSecurityLevelProjectsLimitsResource)
    ] : [
        ...(0, $dUAVJ.getNavigationResources)(),
        (0, $45Itd.navigationSidebarGlobalResource)
    ];
const $12fbd138e6491a99$export$cb732360d6e387a0 = (0, $fdS54.createEntry)((0, $h5Piv.globalSettingsPerformanceIssueSecurityLevelProjectLimitRoute), ()=>({
        group: 'global-settings',
        canTransitionIn: ()=>(0, $i860n.fg)('slt1-1341_site_optimizer_add_cfo_isl_metrics'),
        entryPoint () {
            if (!(0, $i860n.fg)('slt1-1341_site_optimizer_add_cfo_isl_metrics')) return $12fbd138e6491a99$var$notFoundPageEntrypoint;
            return 0, $dyN31.issueSecurityLevelProjectLimitMetricDetailEntryPoint;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: $12fbd138e6491a99$var$getIssueSecurityLevelProjectLimitResources(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9UpOy", function(module, exports) {
$parcel$export(module.exports, "issueSecurityLevelProjectsLimitsResource", () => $7ab2f5a53179d3ef$export$cab9d85864c578a2);

var $7edbf = parcelRequire("7edbf");
const $7ab2f5a53179d3ef$var$RESOURCE_TYPE_ISSUE_SECURITY_LEVEL_PROJECTS_LIMITS = 'ISSUE_SECURITY_LEVEL_PROJECTS_LIMITS';

const $7ab2f5a53179d3ef$export$cab9d85864c578a2 = (0, $7edbf.createResource)({
    type: $7ab2f5a53179d3ef$var$RESOURCE_TYPE_ISSUE_SECURITY_LEVEL_PROJECTS_LIMITS,
    getKey: ()=>'issueSecurityLevelProjectsLimits',
    getDataLoader: ()=>(parcelRequire("1giRa"))
});

});
parcelRegister("1giRa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5EVVn").then(()=>parcelRequire('020an'));

});


parcelRegister("h5Piv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceIssueSecurityLevelProjectLimitRoute", () => $af35466c615d201e$export$79838b27a3f624fd);
const $af35466c615d201e$export$79838b27a3f624fd = {
    name: 'global-settings-performance-issue-security-level-project-limit',
    path: '/jira/settings/system/performance/metrics/issuesecuritylevel/projectlimit'
};

});

parcelRegister("dyN31", function(module, exports) {
$parcel$export(module.exports, "issueSecurityLevelProjectLimitMetricDetailEntryPoint", () => $8832acd0e10146c7$export$8763896955bcbf76);

var $7NTte = parcelRequire("7NTte");

var $dTa0V = parcelRequire("dTa0V");

const $8832acd0e10146c7$export$8763896955bcbf76 = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("19Dwy")), {
            moduleId: "b83b7f05",
            moduleName: "IssueSecurityLevelProjectLimitDetail",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("19Dwy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("982ZO").then(()=>parcelRequire('eKmuR'));

});



parcelRegister("hZMof", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRouteEntry", () => $d2083c2121688365$export$4b547a5bd165bd83);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $gKz7M = parcelRequire("gKz7M");

var $bTVTb = parcelRequire("bTVTb");
const $d2083c2121688365$export$4b547a5bd165bd83 = (0, $fdS54.createEntry)((0, $gKz7M.globalSettingsPerformanceMetricDetailRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $bTVTb.RedirectToExactMetricRoutes),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gKz7M", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRoute", () => $1c10862ffc774f83$export$d4f7a24791f8b506);
const $1c10862ffc774f83$export$d4f7a24791f8b506 = {
    name: 'global-settings-performance-metric-detail',
    path: '/jira/settings/system/performance/metric/:metricKey'
};

});

parcelRegister("bTVTb", function(module, exports) {
$parcel$export(module.exports, "RedirectToExactMetricRoutes", () => $954693bffb6b4e4b$export$dda90f06f8afe9ec);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $aJ81Y = parcelRequire("aJ81Y");

var $dLVGe = parcelRequire("dLVGe");

var $bc9Gj = parcelRequire("bc9Gj");
const $954693bffb6b4e4b$export$dda90f06f8afe9ec = ()=>{
    const [{ match: match }] = (0, $bc9Gj.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        // If we have a metric key in the URL, we know the user has accessed the old route
        // and we should fire an operational analytics event.
        // Once the frequency of this event is 0, we can consider removing the redirect.
        if (match?.params?.metricKey) (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
            metricKey: match.params.metricKey
        });
    }, [
        match?.params?.metricKey,
        createAnalyticsEvent
    ]);
    if (match == null || match.params == null || match.params.metricKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/settings/system/performance/overview"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
    });
};
$954693bffb6b4e4b$export$dda90f06f8afe9ec.displayName = "RedirectToExactMetricRoutes";

});


parcelRegister("9Gg1F", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceOverviewRouteEntry", () => $30b3f76348b9fbdb$export$6f957aade53e2c17);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $hF7RV = parcelRequire("hF7RV");

var $gnP46 = parcelRequire("gnP46");

var $h4cz0 = parcelRequire("h4cz0");
const $30b3f76348b9fbdb$export$6f957aade53e2c17 = (0, $fdS54.createEntry)((0, $gnP46.globalSettingsPerformanceOverviewRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $h4cz0.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $hF7RV.metricsOverviewPageResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $h4cz0.LazyOverview)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hF7RV", function(module, exports) {
$parcel$export(module.exports, "metricsOverviewPageResource", () => $8248434021c5e8cc$export$ac0b4ef4ec4987ae);

var $cuHRd = parcelRequire("cuHRd");

var $i860n = parcelRequire("i860n");

var $htsFl = parcelRequire("htsFl");
const $8248434021c5e8cc$export$ac0b4ef4ec4987ae = (0, $htsFl.createRelayResource)({
    type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $cuHRd.default),
            variables: {
                cloudId: tenantContext.cloudId,
                schemaMigrationEnabled: (0, $i860n.fg)('site_optimiser_schema_migration'),
                projectLevelReportingEnabled: (0, $i860n.fg)('slt1-682-fe-project-level-reporting-so'),
                siteOptimizerAddCfoIslMetricsEnabled: (0, $i860n.fg)('slt1-1341_site_optimizer_add_cfo_isl_metrics')
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});

parcelRegister("gnP46", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceOverviewRoute", () => $fdca03a2bef8c8fc$export$677fc3a2086479d2);
const $fdca03a2bef8c8fc$export$677fc3a2086479d2 = {
    name: 'global-settings-performance-overview',
    path: '/jira/settings/system/performance/overview'
};

});

parcelRegister("h4cz0", function(module, exports) {
$parcel$export(module.exports, "LazyOverview", () => $57050e71b4e7b425$export$17b4d4eaede5f445);
$parcel$export(module.exports, "default", () => $57050e71b4e7b425$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $57050e71b4e7b425$export$17b4d4eaede5f445 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dElEh"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-performance-overview/src/OverviewWithErrorBoundary.tsx"
});
const $57050e71b4e7b425$var$AsyncOverview = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $57050e71b4e7b425$export$17b4d4eaede5f445,
        pageId: "system-performance-overview",
        shouldShowSpinner: true
    });
$57050e71b4e7b425$var$AsyncOverview.displayName = "AsyncOverview";
var $57050e71b4e7b425$export$2e2bcd8739ae039 = $57050e71b4e7b425$var$AsyncOverview;

});
parcelRegister("dElEh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("adMZQ").then(()=>parcelRequire('67FFR'));

});



parcelRegister("2yOeJ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRouteEntry", () => $2dab1b4874132a98$export$7048705fd224d040);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $8ABVA = parcelRequire("8ABVA");

var $7N7CB = parcelRequire("7N7CB");
const $2dab1b4874132a98$export$7048705fd224d040 = (0, $fdS54.createEntry)((0, $8ABVA.globalSettingsPerformanceProjectCleanupRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7N7CB.ProjectCleanupMetricDetail),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7N7CB.LazyProjectCleanupDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8ABVA", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRoute", () => $f4a9f57db81b0481$export$c0d3487a9dc79ff3);
const $f4a9f57db81b0481$export$c0d3487a9dc79ff3 = {
    name: 'global-settings-performance-project-cleanup',
    path: '/jira/settings/system/performance/metrics/projectCleanup'
};

});

parcelRegister("7N7CB", function(module, exports) {
$parcel$export(module.exports, "LazyProjectCleanupDetail", () => $9fb00d8ca2e4c7f2$export$a02cb3bfa11d0dc0);
$parcel$export(module.exports, "ProjectCleanupMetricDetail", () => $9fb00d8ca2e4c7f2$export$2adb5abd6651c182);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9fb00d8ca2e4c7f2$export$a02cb3bfa11d0dc0 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("5m2qI"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-performance-metric-detail-project-cleanup/src/ProjectCleanupDetail.tsx"
});
const $9fb00d8ca2e4c7f2$export$2adb5abd6651c182 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9fb00d8ca2e4c7f2$export$a02cb3bfa11d0dc0,
        pageId: "system-performance-metric-detail-project-cleanup",
        shouldShowSpinner: true
    });
$9fb00d8ca2e4c7f2$export$2adb5abd6651c182.displayName = "ProjectCleanupMetricDetail";

});
parcelRegister("5m2qI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("3liLI")
]).then(()=>parcelRequire('5TrDi'));

});



parcelRegister("6jRt0", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRouteEntry", () => $b48d0b8fb8c9a0c9$export$a37cab737d8b474a);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $cdBg6 = parcelRequire("cdBg6");

var $gL9pZ = parcelRequire("gL9pZ");
const $b48d0b8fb8c9a0c9$export$a37cab737d8b474a = (0, $fdS54.createEntry)((0, $cdBg6.globalSettingsPerformanceProjectRoleActorRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gL9pZ.ProjectRoleActorMetricDetail),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gL9pZ.LazyProjectRoleActorDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cdBg6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRoute", () => $ed892b2839f178a5$export$c81695f590e65a42);
const $ed892b2839f178a5$export$c81695f590e65a42 = {
    name: 'global-settings-performance-project-role-actor',
    path: '/jira/settings/system/performance/metrics/projectroleactor'
};

});

parcelRegister("gL9pZ", function(module, exports) {
$parcel$export(module.exports, "LazyProjectRoleActorDetail", () => $b6c383e4f6242f8c$export$41ecfa31d3d81e1c);
$parcel$export(module.exports, "ProjectRoleActorMetricDetail", () => $b6c383e4f6242f8c$export$3c58376b89706313);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $b6c383e4f6242f8c$export$41ecfa31d3d81e1c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("4O56R"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-performance-metric-detail-project-role-actor/src/ProjectRoleActorDetail.tsx"
});
const $b6c383e4f6242f8c$export$3c58376b89706313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $b6c383e4f6242f8c$export$41ecfa31d3d81e1c,
        pageId: "system-performance-metric-detail-project-role-actor",
        shouldShowSpinner: true
    });
$b6c383e4f6242f8c$export$3c58376b89706313.displayName = "ProjectRoleActorMetricDetail";

});
parcelRegister("4O56R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("8Y8hN")
]).then(()=>parcelRequire('fODeK'));

});



parcelRegister("ij9Oa", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceUserSetupInsightsRouteEntry", () => $b449e8b72697a493$export$596a95e56422526b);
/* eslint-disable import/order */ 


var $4lWtN = parcelRequire("4lWtN");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $3hyv6 = parcelRequire("3hyv6");

var $35eqr = parcelRequire("35eqr");

var $dTa0V = parcelRequire("dTa0V");

var $tcrSj = parcelRequire("tcrSj");
const $b449e8b72697a493$var$userSetupInsightsPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $tcrSj.userSetupInsightsEntryPoint)
});
const $b449e8b72697a493$var$notFoundPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4lWtN.notFoundEntrypoint)
});
const $b449e8b72697a493$export$596a95e56422526b = (0, $fdS54.createEntry)((0, $3hyv6.globalSettingsPerformanceUserSetupInsightsRoute), ()=>({
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        canTransitionIn: ()=>(0, $i860n.fg)('enable_jira_apm_m2'),
        entryPoint: ()=>{
            if (!(0, $i860n.fg)('enable_jira_apm_m2')) return $b449e8b72697a493$var$notFoundPageEntrypoint;
            return $b449e8b72697a493$var$userSetupInsightsPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("3hyv6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceUserSetupInsightsRoute", () => $1631ca00460324a4$export$71754a5dd3f9993f);
const $1631ca00460324a4$export$71754a5dd3f9993f = {
    name: 'global-settings-performance-user-setup-insights',
    path: '/jira/settings/system/performance/user-setup-insights/:dimension'
};

});

parcelRegister("tcrSj", function(module, exports) {
$parcel$export(module.exports, "userSetupInsightsEntryPoint", () => $2474f2de9593191f$export$ba62eb13d09f74ae);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $9XSbr = parcelRequire("9XSbr");

const $2474f2de9593191f$export$ba62eb13d09f74ae = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("h1mor")), {
        moduleId: "0b1e3449",
        moduleName: "UserSetupInsightsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: context })=>{
        const nowMs = Date.now();
        const performanceEnd = new Date(nowMs);
        const performanceStart = new Date(nowMs - 86400000);
        const dimensionName = context?.match?.params?.dimension ?? 'networkDownlink';
        const sortInput = [
            {
                key: 'timestamp',
                order: 'ASC'
            }
        ];
        return {
            queries: {
                performanceQuery: {
                    parameters: (0, $9XSbr.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        startDate: performanceStart.toISOString(),
                        endDate: performanceEnd.toISOString(),
                        granularity: 'HOUR',
                        dimensionInput: [
                            {
                                name: dimensionName
                            }
                        ],
                        regionDimensionInput: [
                            {
                                name: dimensionName
                            },
                            {
                                name: 'userCountry'
                            }
                        ],
                        configDimensionInput: [
                            {
                                name: dimensionName
                            }
                        ],
                        sortInput: sortInput
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("9XSbr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6af25b65d19b3bea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00909ee5a989ba001da481898bb32165>>
 * @relayHash f4f953e9b3e43aca0f1942ace4d4c3d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e4fb5a76528efa6596b16d5826ad1ed69896b72b44f6b7da2c1b94eab846734
const $6af25b65d19b3bea$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "configDimensionInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dimensionInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v4 = {
        "defaultValue": "HOUR",
        "kind": "LocalArgument",
        "name": "granularity"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "regionDimensionInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "kind": "Variable",
        "name": "dimensions",
        "variableName": "dimensionInput"
    }, v10 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v11 = {
        "kind": "Variable",
        "name": "granularity",
        "variableName": "granularity"
    }, v12 = {
        "kind": "Literal",
        "name": "isV2",
        "value": true
    }, v13 = {
        "aggregation": {
            "type": "SUM"
        },
        "alias": "request_count",
        "name": "count"
    }, v14 = {
        "kind": "Variable",
        "name": "sortInput",
        "variableName": "sortInput"
    }, v15 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "name"
    }, v18 = [
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v19 = {
        "concreteType": "JiraCFODimension",
        "kind": "LinkedField",
        "name": "dimensions",
        "plural": true,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "concreteType": "JiraCFOMetric",
        "kind": "LinkedField",
        "name": "metrics",
        "plural": true,
        "selections": v18 /*: any*/ 
    }, v21 = [
        v16 /*: any*/ ,
        {
            "concreteType": "JiraCFODataRowConnection",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "timestamp"
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ],
                                    "type": "JiraCFODefaultDataRow"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v22 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            v13 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserSetupInsightsPerformanceSectionQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "UserSetupInsightsPerformanceSection"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserSetupInsightsPerformanceSectionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "performanceData",
                            "args": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": {
                                                "type": "PERCENTILE",
                                                "value": 0.75
                                            },
                                            "alias": "load_time_p75",
                                            "name": "vc90"
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                v14 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v21 /*: any*/ 
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "dimensions",
                                    "variableName": "configDimensionInput"
                                }
                            ],
                            "concreteType": "JiraCFOConfigsResult",
                            "kind": "LinkedField",
                            "name": "cfoConfigs",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCFOClientSetupConfig",
                                    "kind": "LinkedField",
                                    "name": "clientSetupConfig",
                                    "plural": true,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        {
                                            "concreteType": "JiraCFODistribution",
                                            "kind": "LinkedField",
                                            "name": "distribution",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "insightOn",
                                    "variableName": "dimensionInput"
                                },
                                v15 /*: any*/ 
                            ],
                            "concreteType": "JiraCFOMetricInsightConnection",
                            "kind": "LinkedField",
                            "name": "cfoInsights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCFOMetricInsightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFOMetricInsight",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "concreteType": "JiraCFOMetricInsightMetaData",
                                                    "kind": "LinkedField",
                                                    "name": "metadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "loadTimeDiffFloat"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "userDistribution",
                            "args": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v22 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v21 /*: any*/ 
                        },
                        {
                            "alias": "regionBreakdown",
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "dimensions",
                                    "variableName": "regionDimensionInput"
                                },
                                v10 /*: any*/ ,
                                v12 /*: any*/ ,
                                v22 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFODataRowEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ],
                                                            "type": "JiraCFODefaultDataRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3e4fb5a76528efa6596b16d5826ad1ed69896b72b44f6b7da2c1b94eab846734",
            "metadata": {},
            "name": "UserSetupInsightsPerformanceSectionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6af25b65d19b3bea$var$node.hash = "0923f496823f598e757d88e048f1a4e9";
var $6af25b65d19b3bea$export$2e2bcd8739ae039 = $6af25b65d19b3bea$var$node;

});

parcelRegister("h1mor", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("29yy9").then(()=>parcelRequire('4Sbmx'));

});



parcelRegister("73GfK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeProjectLimitRouteEntry", () => $700fc14f8f03977c$export$965a17cb3e65a2e5);
/* eslint-disable import/order */ 


var $9u4A3 = parcelRequire("9u4A3");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $aonx8 = parcelRequire("aonx8");

var $dW5lx = parcelRequire("dW5lx");
const $700fc14f8f03977c$export$965a17cb3e65a2e5 = (0, $fdS54.createEntry)((0, $aonx8.globalSettingsPerformanceWorkTypeProjectLimitRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $dW5lx.workTypeProjectLimitMetricDetailEntryPoint;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $9u4A3.workTypeProjectsLimitsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9u4A3", function(module, exports) {
$parcel$export(module.exports, "workTypeProjectsLimitsResource", () => $8cab1c012f4b9cc9$export$2ec7f3178377ec2c);

var $7edbf = parcelRequire("7edbf");
const $8cab1c012f4b9cc9$var$RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS = 'WORK_TYPE_PROJECTS_LIMITS';

const $8cab1c012f4b9cc9$export$2ec7f3178377ec2c = (0, $7edbf.createResource)({
    type: $8cab1c012f4b9cc9$var$RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS,
    getKey: ()=>'workTypeProjectsLimits',
    getDataLoader: ()=>(parcelRequire("jVXyW"))
});

});
parcelRegister("jVXyW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("59qM4").then(()=>parcelRequire('iMOrA'));

});


parcelRegister("aonx8", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeProjectLimitRoute", () => $ae977cb742929eb5$export$1931d6cf70f5bde7);
const $ae977cb742929eb5$export$1931d6cf70f5bde7 = {
    name: 'global-settings-performance-work-type-project-limit',
    path: '/jira/settings/system/performance/metrics/worktype/projectlimit'
};

});

parcelRegister("dW5lx", function(module, exports) {
$parcel$export(module.exports, "workTypeProjectLimitMetricDetailEntryPoint", () => $d55f96df1a9722dd$export$f497120022a11a8d);
/* eslint-disable jira/naming/disallow-filenames */ 
var $dTa0V = parcelRequire("dTa0V");

var $7NTte = parcelRequire("7NTte");

const $d55f96df1a9722dd$export$f497120022a11a8d = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("91jh2")), {
            moduleId: "d5ecd226",
            moduleName: "WorkTypeProjectLimitDetail",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("91jh2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b9Bpa").then(()=>parcelRequire('g8UlL'));

});



parcelRegister("guOXW", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeRouteEntry", () => $0e7ef3890b77f886$export$92421240ff4c94e5);



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $kOxcD = parcelRequire("kOxcD");

var $dGGor = parcelRequire("dGGor");
const $0e7ef3890b77f886$export$92421240ff4c94e5 = (0, $fdS54.createEntry)((0, $kOxcD.globalSettingsPerformanceWorkTypeRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $dGGor.workTypeMetricDetailEntryPoint;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kOxcD", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeRoute", () => $b2e3754ba9a54363$export$6e2ae2fc0cb46e28);
const $b2e3754ba9a54363$export$6e2ae2fc0cb46e28 = {
    name: 'global-settings-performance-work-type',
    path: '/jira/settings/system/performance/metrics/worktype'
};

});

parcelRegister("dGGor", function(module, exports) {
$parcel$export(module.exports, "workTypeMetricDetailEntryPoint", () => $9ded70d9eb7c399e$export$a9f578d6187315f8);
/* eslint-disable jira/naming/disallow-filenames */ 
var $dTa0V = parcelRequire("dTa0V");

var $7NTte = parcelRequire("7NTte");

const $9ded70d9eb7c399e$export$a9f578d6187315f8 = (0, $dTa0V.createPageEntryPoint)({
    main: {
        root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("cdpSH")), {
            moduleId: "98d8e784",
            moduleName: "WorkTypeDetail",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    }
});

});
parcelRegister("cdpSH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("aW4ff")
]).then(()=>parcelRequire('5ysSw'));

});



parcelRegister("kLcj1", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPermissionSchemesRouteEntry", () => $8406ce2ec12fe5a8$export$85d07cd59d004b5b);
/* eslint-disable import/order */ 


var $8mNdl = parcelRequire("8mNdl");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $cJfdf = parcelRequire("cJfdf");

var $24nI2 = parcelRequire("24nI2");
const $8406ce2ec12fe5a8$export$85d07cd59d004b5b = (0, $fdS54.createEntry)((0, $cJfdf.globalSettingsPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $24nI2.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $8mNdl.permissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $24nI2.LazyPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'PermissionScheme',
                packageName: 'jiraAdminPagesPermissionScheme',
                teamName: 'gordian'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8mNdl", function(module, exports) {
$parcel$export(module.exports, "permissionSchemePageResource", () => $57155d6a53c42cd4$export$58d9013f694fc9d0);

var $i1EW1 = parcelRequire("i1EW1");

var $htsFl = parcelRequire("htsFl");
const $57155d6a53c42cd4$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
const $57155d6a53c42cd4$export$58d9013f694fc9d0 = (0, $htsFl.createRelayResource)({
    type: $57155d6a53c42cd4$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $i1EW1.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("i1EW1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f1b660f77fd6d66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<435d18d29ff056444f20c59282678540>>
 * @relayHash 0f778772b6735d8baf6fd48c7e856acd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0a205234a2ffbde72b592f84d60e3bc9a68db317c41418c0908f53a2072264d8
const $8f1b660f77fd6d66$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }
    ], v2 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v9 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PermissionSchemesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "Header_PermissionsAdministrationPagesPermissionScheme"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionsTable"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PermissionSchemesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0a205234a2ffbde72b592f84d60e3bc9a68db317c41418c0908f53a2072264d8",
            "metadata": {},
            "name": "PermissionSchemesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8f1b660f77fd6d66$var$node.hash = "265a7e7442af91ff522bac9b0772faa6";
var $8f1b660f77fd6d66$export$2e2bcd8739ae039 = $8f1b660f77fd6d66$var$node;

});


parcelRegister("cJfdf", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPermissionSchemesRoute", () => $e0972d4c619996e1$export$ceade8e040291782);
const $e0972d4c619996e1$export$ceade8e040291782 = {
    name: 'global-settings-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes-new/:schemeId'
};

});

parcelRegister("24nI2", function(module, exports) {
$parcel$export(module.exports, "LazyPermissionSchemePage", () => $00ea172cf1e70b8f$export$f7fcf8304eb17dda);
$parcel$export(module.exports, "default", () => $00ea172cf1e70b8f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $00ea172cf1e70b8f$export$f7fcf8304eb17dda = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)(// eslint-disable-next-line jira/import/file-extension-required
    (parcelRequire("c9lkY"))), {
    moduleId: "./src/packages/permissions-administration/pages-permission-scheme/src/index.tsx"
});
const $00ea172cf1e70b8f$var$AsyncPermissionSchemePage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $00ea172cf1e70b8f$export$f7fcf8304eb17dda,
        pageId: "jira-permission-scheme",
        shouldShowSpinner: true
    });
$00ea172cf1e70b8f$var$AsyncPermissionSchemePage.displayName = "AsyncPermissionSchemePage";
var $00ea172cf1e70b8f$export$2e2bcd8739ae039 = $00ea172cf1e70b8f$var$AsyncPermissionSchemePage;

});
parcelRegister("c9lkY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lPsoC").then(()=>parcelRequire('kQC3t'));

});



parcelRegister("cxIS4", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemBulkMailRouteEntry", () => $e0bb6cde4a5e95b4$export$f1e14d1857713e35);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $5ItoB = parcelRequire("5ItoB");

var $e7cCg = parcelRequire("e7cCg");
const $e0bb6cde4a5e95b4$export$f1e14d1857713e35 = (0, $fdS54.createEntry)((0, $5ItoB.globalSettingsSystemBulkMailRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $e7cCg.default),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $e7cCg.LazyBulkEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5ItoB", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemBulkMailRoute", () => $7f0fabcdede1d699$export$2b269dcf51f5a4d3);
const $7f0fabcdede1d699$export$2b269dcf51f5a4d3 = {
    name: 'global-settings-system-bulk-mail',
    path: '/jira/settings/system/send-email'
};

});

parcelRegister("e7cCg", function(module, exports) {
$parcel$export(module.exports, "LazyBulkEmail", () => $8a158431a7ee41db$export$416f8039fbf50bea);
$parcel$export(module.exports, "default", () => $8a158431a7ee41db$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $8a158431a7ee41db$export$416f8039fbf50bea = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7PR36"))), {
    moduleId: "./src/packages/admin-pages/bulk-email-page/src/BulkEmailPage.tsx"
});
const $8a158431a7ee41db$var$AsyncBulkEmail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $8a158431a7ee41db$export$416f8039fbf50bea,
        pageId: "jira-admin-pages-bulk-email",
        shouldShowSpinner: true
    });
$8a158431a7ee41db$var$AsyncBulkEmail.displayName = "AsyncBulkEmail";
var $8a158431a7ee41db$export$2e2bcd8739ae039 = $8a158431a7ee41db$var$AsyncBulkEmail;

});
parcelRegister("7PR36", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8O9Zo").then(()=>parcelRequire('aqewt'));

});



parcelRegister("iDLuu", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemLabsRouteEntry", () => $fba66db387e002e2$export$84e0948ea0786ec2);
/* eslint-disable import/order */ 
var $l6wtX = parcelRequire("l6wtX");



var $1X1jT = parcelRequire("1X1jT");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $9Q50z = parcelRequire("9Q50z");

var $dUAVJ = parcelRequire("dUAVJ");

var $35eqr = parcelRequire("35eqr");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");
const $fba66db387e002e2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l6wtX.adminPagesLabsEntryPoint)
});
const $fba66db387e002e2$export$84e0948ea0786ec2 = (0, $fdS54.createEntry)((0, $1X1jT.globalSettingsSystemLabsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.system.labs',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource),
            (0, $9Q50z.jiraSpaPageContainerResource)
        ],
        entryPoint: ()=>{
            if (!(0, $i860n.fg)('jira_labs_refresh_m1')) return undefined;
            return $fba66db387e002e2$var$pageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("l6wtX", function(module, exports) {
$parcel$export(module.exports, "adminPagesLabsEntryPoint", () => $ea29090368dacfe0$export$172292d7b0d99f5f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ea29090368dacfe0$export$172292d7b0d99f5f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("eUUKd")), {
        moduleId: "487bed86",
        moduleName: "AdminPagesLabsApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eUUKd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iw3n7").then(()=>parcelRequire('5GWMR'));

});


parcelRegister("1X1jT", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemLabsRoute", () => $7a91204f18912200$export$88a3d6b5c0c57cba);
const $7a91204f18912200$export$88a3d6b5c0c57cba = {
    name: 'global-settings-system-labs',
    path: '/jira/settings/system/labs'
};

});


parcelRegister("15dwL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRouteEntry", () => $9390c9ca991073ee$export$416d225883781012);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $hqNTg = parcelRequire("hqNTg");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $35eqr = parcelRequire("35eqr");

const $9390c9ca991073ee$var$LazyAnnouncementBanner = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("kAdjm"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-system-announcement-banner/src/AppType.tsx"
});
const $9390c9ca991073ee$var$AnnouncementBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9390c9ca991073ee$var$LazyAnnouncementBanner,
        pageId: "admin-pages-system-announcement-banner",
        shouldShowSpinner: true
    });
$9390c9ca991073ee$var$AnnouncementBanner.displayName = "AnnouncementBanner";
const $9390c9ca991073ee$export$416d225883781012 = (0, $fdS54.createEntry)((0, $hqNTg.globalSettingsSystemUiAnnouncementBannerRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.system.ui.announcement-banner',
        // eslint-disable-next-line no-restricted-syntax
        component: $9390c9ca991073ee$var$AnnouncementBanner,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $9390c9ca991073ee$var$LazyAnnouncementBanner
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hqNTg", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRoute", () => $e6f6a69a71111290$export$20631ff3b13dafc0);
const $e6f6a69a71111290$export$20631ff3b13dafc0 = {
    name: 'global-settings-system-ui-announcement-banner',
    path: '/jira/settings/system/ui/announcement-banner'
};

});

parcelRegister("kAdjm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bH0MI")
]).then(()=>parcelRequire('1FOpl'));

});


parcelRegister("gyHjd", function(module, exports) {
$parcel$export(module.exports, "governanceProjectsDirectoryRouteEntry", () => $de6092cecc4e80ad$export$b12025b2686aeec1);



var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $cM8rk = parcelRequire("cM8rk");

var $iSoIx = parcelRequire("iSoIx");

var $4ATkw = parcelRequire("4ATkw");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $2700E = parcelRequire("2700E");
const $de6092cecc4e80ad$var$governanceProjectsAdminPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4ATkw.governanceProjectsAdminEntryPoint)
});
const $de6092cecc4e80ad$export$b12025b2686aeec1 = (0, $fdS54.createEntry)((0, $cM8rk.governanceProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.governance-projects',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $3be6781b85030612$export$e3e768cbcc0eeacd),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>(0, $2700E.expValEquals)('frontier-guided-autonomy-eap', 'isEnabled', true, false) ? $de6092cecc4e80ad$var$governanceProjectsAdminPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cM8rk", function(module, exports) {
$parcel$export(module.exports, "governanceProjectsDirectoryRoute", () => $07b6e04a2f668e29$export$40a5ac40b70032f4);
const $07b6e04a2f668e29$export$40a5ac40b70032f4 = {
    name: 'governance-projects-directory',
    path: '/jira/settings/projects/policies',
    exact: true
};

});

parcelRegister("4ATkw", function(module, exports) {
$parcel$export(module.exports, "governanceProjectsAdminEntryPoint", () => $6062c3e74f7780d6$export$34ffa76dc099c707);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $9arpw = parcelRequire("9arpw");

const $6062c3e74f7780d6$export$34ffa76dc099c707 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("fMBH4")), {
        moduleId: "d6f82d59",
        moduleName: "GovernanceProjectsAdmin",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const { isAdmin: isAdmin } = tenantContext;
        if (!isAdmin) return {
            extraProps: {
                isAdmin: isAdmin
            }
        };
        return {
            queries: {
                governanceProjectsAdmin: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $9arpw.default,
                    variables: {
                        cloudId: tenantContext.cloudId
                    }
                }
            },
            extraProps: {
                isAdmin: isAdmin
            }
        };
    }
});

});
parcelRegister("9arpw", function(module, exports) {
$parcel$export(module.exports, "default", () => $39b72d9b5850b4a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b8de32020667a9369ef2052f78c0f78>>
 * @relayHash 0e9c5f11908fb91fb0b4839f2577a0cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID afcba70925a4b60fab1dae46c80cc8c25ca18444d3dbf5fe201e372282212c4e
const $39b72d9b5850b4a1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GovernanceProjectsAdminQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectPolicyConnection",
                            "kind": "LinkedField",
                            "name": "projectPolicies",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectPolicy",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "PolicyOption_policy"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GovernanceProjectsAdminQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectPolicyConnection",
                            "kind": "LinkedField",
                            "name": "projectPolicies",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectPolicy",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 20
                                                }
                                            ],
                                            "concreteType": "JiraProjectPolicyAssociationConnection",
                                            "kind": "LinkedField",
                                            "name": "associatedProjects",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectPolicyAssociation",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPolicyRuleViolationConnection",
                                                            "kind": "LinkedField",
                                                            "name": "ruleViolations",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "associatedProjects(first:20)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "afcba70925a4b60fab1dae46c80cc8c25ca18444d3dbf5fe201e372282212c4e",
            "metadata": {},
            "name": "GovernanceProjectsAdminQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$39b72d9b5850b4a1$var$node.hash = "9eeed55364bad282369db7852fe26e2d";
var $39b72d9b5850b4a1$export$2e2bcd8739ae039 = $39b72d9b5850b4a1$var$node;

});

parcelRegister("fMBH4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("grVhD").then(()=>parcelRequire('9yBZM'));

});



parcelRegister("g8j6S", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAgentStudioRouteEntry", () => $32e3b0607d6bdc15$export$5328c10e46075e4d);

var $2nex5 = parcelRequire("2nex5");


var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $74h93 = parcelRequire("74h93");

var $3HYSN = parcelRequire("3HYSN");

var $fdS54 = parcelRequire("fdS54");

var $dej4I = parcelRequire("dej4I");

var $gw49k = parcelRequire("gw49k");

var $9hSoa = parcelRequire("9hSoa");
const $32e3b0607d6bdc15$export$5328c10e46075e4d = (0, $fdS54.createEntry)((0, $dej4I.helpCenterSettingsAgentStudioRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio',
        // For either return undefined scenario, it will fallback to the component config below
        entryPoint () {
            return 0, $9hSoa.csmAgentOverviewPageEntryPoint;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9hSoa.AgentStudioOverviewPage),
        skeleton: (0, $gw49k.AgentOverviewPageSkeleton),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // TODO: AVP route resources here
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9hSoa.LazyAgentStudioOverviewPage)
        ],
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dej4I", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAgentStudioRoute", () => $49b848eb8b905eca$export$b8b0efb16984db50);
const $49b848eb8b905eca$export$b8b0efb16984db50 = {
    name: 'helpcenter-settings-agent-studio',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent',
    exact: true
};

});

parcelRegister("gw49k", function(module, exports) {
$parcel$export(module.exports, "AgentOverviewPageSkeleton", () => $a394d365326ac094$export$afcefc88e1a5cac8);
/* AgentOverviewPageSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $d5ps5 = parcelRequire("d5ps5");

var $eHvO2 = parcelRequire("eHvO2");
const $a394d365326ac094$var$customCssStyles = null;
const $a394d365326ac094$export$afcefc88e1a5cac8 = ()=>/*#__PURE__*/ $euxye.createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eHvO2))),
        className: (0, $4jQY2.default)([
            "_2zz11tcg _slt81tcg"
        ])
    });
$a394d365326ac094$export$afcefc88e1a5cac8.displayName = "AgentOverviewPageSkeleton";

});
parcelRegister("eHvO2", function(module, exports) {
module.exports = new URL("agent-overview-page-skeleton.tpl.5523a7de.svg", import.meta.url).toString();

});



parcelRegister("hJOuW", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAnalyticsRouteEntry", () => $b1d6e6131b8003c0$export$13d5cfdc3231d970);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $dUAVJ = parcelRequire("dUAVJ");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $8pOpf = parcelRequire("8pOpf");

var $iomKW = parcelRequire("iomKW");
const $b1d6e6131b8003c0$export$13d5cfdc3231d970 = (0, $fdS54.createEntry)((0, $8pOpf.helpCenterSettingsAnalyticsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.analytics',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return 0, $iomKW.helpCenterSettingsAnalyticsRoutePageEntryPoint;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // TODO: AVP route resources here
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8pOpf", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoute", () => $843da86dd4bc1bd6$export$1487d4661960397f);
const $843da86dd4bc1bd6$export$1487d4661960397f = {
    exact: true,
    name: 'customer-service-helpcenter-analytics',
    path: '/jira/helpcenter/analytics'
};

});

parcelRegister("iomKW", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoutePageEntryPoint", () => $26b963c98d5d4a67$export$cb0b3a882806ef6e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $8OKkG = parcelRequire("8OKkG");

var $dTa0V = parcelRequire("dTa0V");
const $26b963c98d5d4a67$export$cb0b3a882806ef6e = (0, $dTa0V.createPageEntryPoint)({
    main: $8OKkG.helpCenterSettingsAnalyticsAppEntryPoint
});

});
parcelRegister("8OKkG", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAnalyticsAppEntryPoint", () => $98e587f10ce2cb67$export$fa405dadb950b4a6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $98e587f10ce2cb67$export$fa405dadb950b4a6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2JPkX")), {
        moduleId: "17ec1c45",
        moduleName: "HelpCenterSettingAnalyticsApp",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("2JPkX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("94EOh")
]).then(()=>parcelRequire('iE3w4'));

});




parcelRegister("hxZix", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsArticlesRouteEntry", () => $ac63699b6da186f1$export$dcf98310ab461eb0);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $iNwfm = parcelRequire("iNwfm");

var $74h93 = parcelRequire("74h93");

var $culYu = parcelRequire("culYu");
const $ac63699b6da186f1$export$dcf98310ab461eb0 = (0, $fdS54.createEntry)((0, $iNwfm.helpCenterSettingsArticlesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>(0, $culYu.helpCenterSettingArticlesAppPageEntryPoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iNwfm", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsArticlesRoute", () => $6bc6311b8d8e0659$export$6445613754b0db30);
const $6bc6311b8d8e0659$export$6445613754b0db30 = {
    name: 'helpcenter-settings-articles',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles',
    exact: true
};

});


parcelRegister("bnYNC", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRouteEntry", () => $f5e86add1177aa49$export$d14f4c2b666bbb54);

var $2nex5 = parcelRequire("2nex5");


var $3XZ1h = parcelRequire("3XZ1h");

var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $5w1nb = parcelRequire("5w1nb");

var $74h93 = parcelRequire("74h93");

var $k81xb = parcelRequire("k81xb");
const $f5e86add1177aa49$export$d14f4c2b666bbb54 = (0, $fdS54.createEntry)((0, $5w1nb.helpCenterSettingsArticlesViewArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles-view-article',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>(0, $k81xb.helpCenterSettingViewArticleAppPageEntryPoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $3XZ1h.csmBaseUrlResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5w1nb", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRoute", () => $5986768f9095ed9e$export$c5c6fbcb1f26b87b);
const $5986768f9095ed9e$export$c5c6fbcb1f26b87b = {
    name: 'helpcenter-settings-articles-view-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId',
    exact: true
};

});

parcelRegister("k81xb", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingViewArticleAppPageEntryPoint", () => $b63b9d8f0df819b2$export$7f08ea9d5c2912ad);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hB8t0 = parcelRequire("hB8t0");

var $dTa0V = parcelRequire("dTa0V");
const $b63b9d8f0df819b2$export$7f08ea9d5c2912ad = (0, $dTa0V.createPageEntryPoint)({
    main: $hB8t0.HelpCenterSettingsArticlesViewArticleAppEntryPoint
});

});
parcelRegister("hB8t0", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsArticlesViewArticleAppEntryPoint", () => $1aa9b76fbad8db25$export$31df33b35c5b2ee);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $1aa9b76fbad8db25$export$31df33b35c5b2ee = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3lWL7")), {
        moduleId: "4c0d5928",
        moduleName: "HelpCenterSettingsArticlesViewArticleComponent",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("3lWL7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gIBDi")
]).then(()=>parcelRequire('g5p7m'));

});




parcelRegister("4CIaD", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsBrandingRouteEntry", () => $2a8038c74229e317$export$5ee7fbd23c469c7);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $3yEq8 = parcelRequire("3yEq8");

var $74h93 = parcelRequire("74h93");

var $aDN0P = parcelRequire("aDN0P");
const $2a8038c74229e317$export$5ee7fbd23c469c7 = (0, $fdS54.createEntry)((0, $3yEq8.helpCenterSettingsBrandingRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.branding',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            if ((0, $i860n.fg)('jcs-global-branding')) return 0, $aDN0P.helpCenterSettingBrandingAppPageEntryPoint;
            return undefined;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3yEq8", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsBrandingRoute", () => $203ce0bfc263f17d$export$f70734f5d2d3d52b);
const $203ce0bfc263f17d$export$f70734f5d2d3d52b = {
    exact: true,
    name: 'helpcenter-settings-branding',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/branding'
};

});


parcelRegister("5NZLw", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsChatConfigurationRouteEntry", () => $871953d21c7461ec$export$902932de18cd08);

var $2nex5 = parcelRequire("2nex5");


var $aSRe7 = parcelRequire("aSRe7");

var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $ahhZF = parcelRequire("ahhZF");

var $dTa0V = parcelRequire("dTa0V");
const $871953d21c7461ec$var$HelpCenterSettingsChatConfigurationEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: $aSRe7.HelpCenterSettingsChatConfiguration
});
const $871953d21c7461ec$export$902932de18cd08 = (0, $fdS54.createEntry)((0, $ahhZF.helpCenterSettingsChatConfigurationRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.chat-configuration',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget') ? $871953d21c7461ec$var$HelpCenterSettingsChatConfigurationEntryPoint : undefined;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@jira/router-routes__help-center-settings-entries/src/helpCenterSettingsChatConfigurationRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsChatConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ahhZF", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsChatConfigurationRoute", () => $a121aaf48e48fa6a$export$2d7f67c0619b3967);
const $a121aaf48e48fa6a$export$2d7f67c0619b3967 = {
    name: 'helpcenter-settings-chat-configuration',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/chat',
    exact: true
};

});


parcelRegister("aCb3M", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCreateArticleRouteEntry", () => $3ab6d44b18c86955$export$882f07b6a7d364c7);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $9luGV = parcelRequire("9luGV");

var $74h93 = parcelRequire("74h93");

var $e2JFE = parcelRequire("e2JFE");
const $3ab6d44b18c86955$export$882f07b6a7d364c7 = (0, $fdS54.createEntry)((0, $9luGV.helpCenterSettingsCreateArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.create-article',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>(0, $e2JFE.helpCenterSettingCreateArticleAppPageEntryPoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9luGV", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCreateArticleRoute", () => $68e55486b5e0c0cb$export$6f4350070b3391d2);
const $68e55486b5e0c0cb$export$6f4350070b3391d2 = {
    name: 'helpcenter-settings-create-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("e2JFE", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingCreateArticleAppPageEntryPoint", () => $c367e39303df39c7$export$2dedebb94d500afa);
/* eslint-disable jira/naming/disallow-filenames */ 
var $iRatk = parcelRequire("iRatk");

var $dTa0V = parcelRequire("dTa0V");
const $c367e39303df39c7$export$2dedebb94d500afa = (0, $dTa0V.createPageEntryPoint)({
    main: $iRatk.HelpCenterSettingsCreateArticleAppEntryPoint
});

});
parcelRegister("iRatk", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsCreateArticleAppEntryPoint", () => $612105f78d450c28$export$dd82613d258b9120);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $612105f78d450c28$export$dd82613d258b9120 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("ccSKv")), {
        moduleId: "8832e3b9",
        moduleName: "HelpCenterSettingsCreateArticleComponent",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("ccSKv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4ZgOR").then(()=>parcelRequire('3lUGO'));

});




parcelRegister("5FbjP", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRouteEntry", () => $ba43f7877bd4421a$export$5cfeb28cf3c43d24);

var $2nex5 = parcelRequire("2nex5");

var $hKTw5 = parcelRequire("hKTw5");


var $imXbM = parcelRequire("imXbM");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $knVsQ = parcelRequire("knVsQ");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $e7Hxd = parcelRequire("e7Hxd");
const $ba43f7877bd4421a$export$5cfeb28cf3c43d24 = (0, $fdS54.createEntry)((0, $knVsQ.helpCenterSettingsCustomerAccessRoute), ()=>({
        perfMetricKey: 'help-center-settings.customer-access',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $e7Hxd.HelpCenterSettingsCustomerAccess),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $e7Hxd.LazyHelpCenterSettingsCustomerAccess)
        ],
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $imXbM.jsmGlobalCustomerAccessSettingsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_customer_access_jsm_separation'), (0, $hKTw5.csmGlobalCustomerAccessSettingsResource)),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("knVsQ", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRoute", () => $1cedaf3343503903$export$5adf9b8f07e4dd7b);
const $1cedaf3343503903$export$5adf9b8f07e4dd7b = {
    name: 'helpcenter-settings-customer-access',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-access'
};

});


parcelRegister("d3C53", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRouteEntry", () => $8095779549aee61a$export$4e4f38417d267cf6);

var $c6zso = parcelRequire("c6zso");

var $2nex5 = parcelRequire("2nex5");


var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $7BwRn = parcelRequire("7BwRn");

var $74h93 = parcelRequire("74h93");

var $fU1OC = parcelRequire("fU1OC");
const $8095779549aee61a$export$4e4f38417d267cf6 = (0, $fdS54.createEntry)((0, $7BwRn.helpCenterSettingsCustomerNotificationsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.customer-notifications',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fU1OC.HelpCenterSettingsCustomerNotifications),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fU1OC.LazyHelpCenterSettingsCustomerNotifications)
        ],
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $c6zso.senderNameResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c6zso", function(module, exports) {
$parcel$export(module.exports, "senderNameResource", () => $0bc5cea88f4455aa$export$931003ada6f19fa5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fLTsc = parcelRequire("fLTsc");

var $7edbf = parcelRequire("7edbf");

const $0bc5cea88f4455aa$export$931003ada6f19fa5 = (0, $7edbf.createResource)({
    type: 'CSM_SENDER_NAME',
    getKey: (matchedRoute)=>`sender-name-${(0, $fLTsc.getProjectKeyOrId)(matchedRoute.match)}`,
    getDataLoader: ()=>(parcelRequire("8EAoL"))
});

});
parcelRegister("8EAoL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9BFcL").then(()=>parcelRequire('hIWtU'));

});


parcelRegister("7BwRn", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRoute", () => $11c720cd4ae4e115$export$88fcb9acf40a0827);
const $11c720cd4ae4e115$export$88fcb9acf40a0827 = {
    name: 'helpcenter-settings-customer-notifications',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-notifications'
};

});


parcelRegister("dEfbu", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsDetailsRouteEntry", () => $e8a0f91f2b3e4836$export$a9c03c3c37251dd3);

var $6rbdo = parcelRequire("6rbdo");

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $8b7jh = parcelRequire("8b7jh");

var $74h93 = parcelRequire("74h93");

var $QhQu4 = parcelRequire("QhQu4");
var $bKPo4 = parcelRequire("bKPo4");

var $gO1oK = parcelRequire("gO1oK");

var $i860n = parcelRequire("i860n");

var $bedjq = parcelRequire("bedjq");
const $e8a0f91f2b3e4836$export$a9c03c3c37251dd3 = (0, $fdS54.createEntry)((0, $8b7jh.helpCenterSettingsDetailsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.details',
        layout: (0, $bKPo4.layoutWithCondition)(()=>(0, $i860n.fg)('csm-support-widget-in-csm'), (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $gO1oK.csmWidgetLayout)), (0, $74h93.serviceProjectLayout)),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return 0, $bedjq.helpCenterSettingDetailsAppPageEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6rbdo.csmHubSetupResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8b7jh", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsDetailsRoute", () => $0e3d6232bc48ef20$export$f54c1546ddea019b);
const $0e3d6232bc48ef20$export$f54c1546ddea019b = {
    name: 'helpcenter-settings-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});


parcelRegister("7NyWg", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsEmailRouteEntry", () => $5cc2b2fa2edbf9d2$export$f95717dac47e4db3);

var $2nex5 = parcelRequire("2nex5");


var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $hU2Gp = parcelRequire("hU2Gp");

var $74h93 = parcelRequire("74h93");

var $dNBdS = parcelRequire("dNBdS");
const $5cc2b2fa2edbf9d2$export$f95717dac47e4db3 = (0, $fdS54.createEntry)((0, $hU2Gp.helpCenterSettingsEmailRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.email',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dNBdS.HelpCenterSettingsEmail),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dNBdS.LazyHelpCenterSettingsEmail)
        ],
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hU2Gp", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsEmailRoute", () => $d0e0d0ed79e8524f$export$4515288a48c62087);
const $d0e0d0ed79e8524f$export$4515288a48c62087 = {
    name: 'helpcenter-settings-email',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/email',
    exact: true
};

});

parcelRegister("dNBdS", function(module, exports) {
$parcel$export(module.exports, "LazyHelpCenterSettingsEmail", () => $de05b5d59ba36b9d$export$e090cd3a62343249);
$parcel$export(module.exports, "HelpCenterSettingsEmail", () => $de05b5d59ba36b9d$export$962f20e752738967);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $cZjb4 = parcelRequire("cZjb4");

const $de05b5d59ba36b9d$export$e090cd3a62343249 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("5abkt")), {
    moduleId: "./src/packages/spa-apps/help-center-settings-email/src/HelpCenterSettingsEmail.tsx"
});
const $de05b5d59ba36b9d$export$962f20e752738967 = ()=>{
    const [helpCenterId] = (0, $cZjb4.usePathParam)('helpCenterId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        // Emails does not handle projectKey changes so we're passing the helpCenterId as a key to force a re-render
        key: helpCenterId,
        Page: $de05b5d59ba36b9d$export$e090cd3a62343249,
        pageId: "help-center-settings-email",
        shouldShowSpinner: true
    });
};
$de05b5d59ba36b9d$export$962f20e752738967.displayName = "HelpCenterSettingsEmail";

});


parcelRegister("gYR3D", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsEmbeddedWidgetsRouteEntry", () => $a5876255f56a5dce$export$aedf84e113c01312);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $aAB9f = parcelRequire("aAB9f");

var $k76DA = parcelRequire("k76DA");
const $a5876255f56a5dce$export$aedf84e113c01312 = (0, $fdS54.createEntry)((0, $aAB9f.helpCenterSettingsEmbeddedWidgetsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.embedded-widgets',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>{
            return 0, $k76DA.HelpCenterSettingsEmbeddedWidgetsAppEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aAB9f", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsEmbeddedWidgetsRoute", () => $d807e28dda6e961c$export$73d2101a3c147453);
const $d807e28dda6e961c$export$73d2101a3c147453 = {
    name: 'helpcenter-settings-embedded-widgets',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/embed',
    exact: true
};

});


parcelRegister("8N41I", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsFormEditRouteEntry", () => $1505fd7c378c1bab$export$1750cfcab794a07d);

var $2nex5 = parcelRequire("2nex5");


var $au0Qi = parcelRequire("au0Qi");

var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");

var $lQctJ = parcelRequire("lQctJ");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $itJUX = parcelRequire("itJUX");

var $74h93 = parcelRequire("74h93");

var $1lXSA = parcelRequire("1lXSA");
const $1505fd7c378c1bab$export$1750cfcab794a07d = (0, $fdS54.createEntry)((0, $itJUX.helpCenterSettingsFormEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.form-edit',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>(0, $1lXSA.helpCenterSettingFormEditAppPageEntryPoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $au0Qi.formEditJirafieldsResource),
            (0, $2nex5.customerExperiencesNavigationResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_conditional_form_fields'), (0, $lQctJ.formEditProformaFormResource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("itJUX", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsFormEditRoute", () => $ad651d1deeb3e9f9$export$31bd3e10c42460dc);
const $ad651d1deeb3e9f9$export$31bd3e10c42460dc = {
    exact: true,
    name: 'helpcenter-settings-form-edit',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms/:formId'
};

});


parcelRegister("LrcKp", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsFormsRouteEntry", () => $2ccb7dd6f1650526$export$9a67aaae787c9f40);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $DAugd = parcelRequire("DAugd");

var $74h93 = parcelRequire("74h93");

var $feR6M = parcelRequire("feR6M");
const $2ccb7dd6f1650526$export$9a67aaae787c9f40 = (0, $fdS54.createEntry)((0, $DAugd.helpCenterSettingsFormsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.forms',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>(0, $feR6M.helpCenterSettingFormsAppPageEntryPoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("DAugd", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsFormsRoute", () => $d00f59b87d1dcc48$export$45b14c3ed47b2b3a);
const $d00f59b87d1dcc48$export$45b14c3ed47b2b3a = {
    exact: true,
    name: 'helpcenter-settings-forms',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms'
};

});


parcelRegister("l7tPZ", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsGetStartedRouteEntry", () => $21b12419d20390a0$export$d364ffaf1c958219);

var $2nex5 = parcelRequire("2nex5");


var $5q5DR = parcelRequire("5q5DR");

var $lFLfF = parcelRequire("lFLfF");

var $4B518 = parcelRequire("4B518");

var $lbxXL = parcelRequire("lbxXL");

var $gO1oK = parcelRequire("gO1oK");

var $8HUuJ = parcelRequire("8HUuJ");

var $fdS54 = parcelRequire("fdS54");

var $5lH21 = parcelRequire("5lH21");

var $74h93 = parcelRequire("74h93");

var $QhQu4 = parcelRequire("QhQu4");
var $bKPo4 = parcelRequire("bKPo4");

var $igvpg = parcelRequire("igvpg");

var $i860n = parcelRequire("i860n");

var $2KnY6 = parcelRequire("2KnY6");

var $4A6Co = parcelRequire("4A6Co");
const $21b12419d20390a0$export$d364ffaf1c958219 = (0, $fdS54.createEntry)((0, $5lH21.helpCenterSettingsGetStartedRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.get-started',
        layout: (0, $bKPo4.layoutWithCondition)(()=>(0, $i860n.fg)('csm-support-widget-in-csm'), (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $gO1oK.csmWidgetLayout)), (0, $74h93.serviceProjectLayout)),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return 0, $2KnY6.helpCenterSettingGetStartedAppPageEntryPoint;
        },
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $5q5DR.getStartedPropertyResource),
            (0, $2nex5.customerExperiencesNavigationResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_ai_onboarding_tasks'), (0, $4A6Co.csmHubSetupSupportWebsiteResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_ai_onboarding_tasks'), (0, $igvpg.serviceDeskIncomingEmailResource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5lH21", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsGetStartedRoute", () => $b5c2393c2c411fc6$export$43b09fc355246cda);
const $b5c2393c2c411fc6$export$43b09fc355246cda = {
    name: 'helpcenter-settings-get-started',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/get-started',
    exact: true
};

});


parcelRegister("3rrWW", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsMessagingAppsRouteEntry", () => $a179ff50def2b24d$export$23ffda31e1ef77f1);

var $2nex5 = parcelRequire("2nex5");


var $lbxXL = parcelRequire("lbxXL");

var $iyqMX = parcelRequire("iyqMX");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $8jjLC = parcelRequire("8jjLC");

var $iSoIx = parcelRequire("iSoIx");

var $9h5wj = parcelRequire("9h5wj");
const $a179ff50def2b24d$export$23ffda31e1ef77f1 = (0, $fdS54.createEntry)((0, $8jjLC.helpCenterSettingsMessagingAppsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.messaging-apps',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        entryPoint () {
            return (0, $i860n.fg)('csm-omni-whatsapp-support') ? (0, $9h5wj.HelpCenterSettingsMessagingAppsEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            (0, $iyqMX.serviceDeskContextResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8jjLC", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsMessagingAppsRoute", () => $a75cca13f631c993$export$386aadfa9c301c86);
const $a75cca13f631c993$export$386aadfa9c301c86 = {
    name: 'helpcenter-settings-messaging-apps',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/messaging-apps',
    exact: true
};

});


parcelRegister("j9fZa", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsNotFoundRouteEntry", () => $4ce42e12fbea3fd7$export$2dced3f6d0a4894);

var $4B518 = parcelRequire("4B518");

var $fdS54 = parcelRequire("fdS54");

var $Bjdpv = parcelRequire("Bjdpv");

var $dtShj = parcelRequire("dtShj");
const $4ce42e12fbea3fd7$export$2dced3f6d0a4894 = (0, $fdS54.createEntry)((0, $Bjdpv.helpCenterSettingsNotFoundRoute), ()=>({
        group: 'customer-service',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dtShj.NotFound),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("Bjdpv", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsNotFoundRoute", () => $ba966f515b3448b8$export$b6bc9dd96e9608e7);
const $ba966f515b3448b8$export$b6bc9dd96e9608e7 = {
    exact: false,
    name: 'customer-service-not-found',
    path: '/jira/helpcenter/:any'
};

});

parcelRegister("dtShj", function(module, exports) {
$parcel$export(module.exports, "NotFound", () => $0552d69779a7060c$export$271f9f08425019c7);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7Pwwk = parcelRequire("7Pwwk");

var $hFtK7 = parcelRequire("hFtK7");

var $f2wVS = parcelRequire("f2wVS");

var $i860n = parcelRequire("i860n");
const $0552d69779a7060c$var$useLocation = (0, $f2wVS.createRouterSelector)(({ location: location })=>location.pathname);
const $0552d69779a7060c$export$271f9f08425019c7 = ()=>{
    const pathname = $0552d69779a7060c$var$useLocation();
    (0, $euxye.useEffect)(()=>{
        !(0, $i860n.fg)('berry-63-sidebar-validation') && (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'serviceHubPageNotFound',
                packageName: 'jiraServicedeskCustomerServiceServiceHubs',
                teamName: 'boysenberry'
            },
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                pathname: pathname
            }
        });
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Pwwk.NotFoundErrorPageAsync), null);
};
$0552d69779a7060c$export$271f9f08425019c7.displayName = "NotFound";

});
parcelRegister("7Pwwk", function(module, exports) {
$parcel$export(module.exports, "NotFoundErrorPageAsync", () => $42d439df25a14c0d$export$8dd04806a5b061d8);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $42d439df25a14c0d$var$LazyNotFoundErrorPage = (0, $l8G1z.lazy)(()=>(parcelRequire("gOQPf")), {
    moduleId: "./src/packages/platform/not-found-error-page/src/NotFoundErrorPage.tsx"
});
const $42d439df25a14c0d$export$8dd04806a5b061d8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-not-found-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($42d439df25a14c0d$var$LazyNotFoundErrorPage, null));
$42d439df25a14c0d$export$8dd04806a5b061d8.displayName = "NotFoundErrorPageAsync";

});
parcelRegister("gOQPf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cdeQF").then(()=>parcelRequire('1Fj1V'));

});




parcelRegister("1Uc3N", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsPhoneConfigurationRouteEntry", () => $f1dab2bd30a92eb7$export$3fde67892e5614e2);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $iyqMX = parcelRequire("iyqMX");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $jkksl = parcelRequire("jkksl");

var $8IaSx = parcelRequire("8IaSx");
const $f1dab2bd30a92eb7$export$3fde67892e5614e2 = (0, $fdS54.createEntry)((0, $jkksl.helpCenterSettingsPhoneConfigurationRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.phone-configuration',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return 0, $8IaSx.HelpCenterSettingsPhoneConfigurationEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            (0, $iyqMX.serviceDeskContextResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jkksl", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsPhoneConfigurationRoute", () => $2ef22673b0f88dc8$export$b727f8e97d725873);
const $2ef22673b0f88dc8$export$b727f8e97d725873 = {
    name: 'helpcenter-settings-phone-configuration',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/phone',
    exact: true
};

});


parcelRegister("b3kdA", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsServiceHubsRouteEntry", () => $43a99072d644d0d2$export$4afd756ea4d2cf7e);

var $2nex5 = parcelRequire("2nex5");


var $3XZ1h = parcelRequire("3XZ1h");

var $lFLfF = parcelRequire("lFLfF");

var $dUAVJ = parcelRequire("dUAVJ");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $go6NL = parcelRequire("go6NL");

var $hMIvE = parcelRequire("hMIvE");
const $43a99072d644d0d2$export$4afd756ea4d2cf7e = (0, $fdS54.createEntry)((0, $go6NL.helpCenterSettingsServiceHubsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.service-hubs',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>(0, $hMIvE.helpCenterSettingsServiceHubsRoutePageEntryPoint),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $3XZ1h.csmBaseUrlResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("go6NL", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoute", () => $1731e9a849b26d7b$export$16970f28ba5bfb66);
const $1731e9a849b26d7b$export$16970f28ba5bfb66 = {
    exact: true,
    name: 'customer-service-helpcenter',
    path: '/jira/helpcenter'
};

});


parcelRegister("76As8", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteEditRouteEntry", () => $bfc158fb41d22a45$export$cde377f0172091f6);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $iyqMX = parcelRequire("iyqMX");

var $koA6h = parcelRequire("koA6h");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $ctEA1 = parcelRequire("ctEA1");

var $lU7cf = parcelRequire("lU7cf");

var $i860n = parcelRequire("i860n");

var $bXM2d = parcelRequire("bXM2d");
const $bfc158fb41d22a45$export$cde377f0172091f6 = (0, $fdS54.createEntry)((0, $ctEA1.helpCenterSettingsSupportWebsiteEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.edit',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            horizontal: (0, $i860n.fg)('csm_contact_us_rte') ? undefined : (0, $lU7cf.AsyncSupportWebsiteNav)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>{
            return 0, $bXM2d.SupportWebsiteEditEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            (0, $iyqMX.serviceDeskContextResource),
            (0, $koA6h.serviceDeskAnalyticsContextResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ctEA1", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteEditRoute", () => $8c0f4f71687d9193$export$e85d079407856ad);
const $8c0f4f71687d9193$export$e85d079407856ad = {
    name: 'helpcenter-settings-support-website-details-edit',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/edit/:pageId?',
    exact: true
};

});


parcelRegister("9F5gK", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRouteEntry", () => $8460f16359ca6886$export$eb728930eecb0b42);

var $4A6Co = parcelRequire("4A6Co");

var $2nex5 = parcelRequire("2nex5");


var $3XZ1h = parcelRequire("3XZ1h");

var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $iyqMX = parcelRequire("iyqMX");

var $koA6h = parcelRequire("koA6h");

var $i860n = parcelRequire("i860n");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $75ijj = parcelRequire("75ijj");

var $lU7cf = parcelRequire("lU7cf");

var $5XznV = parcelRequire("5XznV");
const $8460f16359ca6886$export$eb728930eecb0b42 = (0, $fdS54.createEntry)((0, $75ijj.helpCenterSettingsSupportWebsiteOverviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.overview',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            horizontal: (0, $i860n.fg)('csm_contact_us_rte') ? undefined : (0, $lU7cf.AsyncSupportWebsiteNav)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>(0, $i860n.fg)('csm_contact_us_rte') ? (0, $5XznV.HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation) : (0, $5XznV.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            (0, $iyqMX.serviceDeskContextResource),
            (0, $koA6h.serviceDeskAnalyticsContextResource),
            (0, $3XZ1h.csmBaseUrlResource),
            (0, $4A6Co.csmHubSetupSupportWebsiteResource),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("75ijj", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRoute", () => $f302fd493560db92$export$64e95782b19caeac);
const $f302fd493560db92$export$64e95782b19caeac = {
    name: 'helpcenter-settings-support-website-details-overview',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/overview',
    exact: true
};

});


parcelRegister("jSGFY", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRouteEntry", () => $ba6dd25297393943$export$5077ff1d96b93d83);

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $9w6Xd = parcelRequire("9w6Xd");

var $lU7cf = parcelRequire("lU7cf");

var $i860n = parcelRequire("i860n");

var $h4KqR = parcelRequire("h4KqR");
const $ba6dd25297393943$export$5077ff1d96b93d83 = (0, $fdS54.createEntry)((0, $9w6Xd.helpCenterSettingsSupportWebsitePagesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.pages',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            horizontal: (0, $i860n.fg)('csm_contact_us_rte') ? undefined : (0, $lU7cf.AsyncSupportWebsiteNav)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>(0, $i860n.fg)('csm_contact_us_rte') ? (0, $h4KqR.HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation) : (0, $h4KqR.HelpCenterSettingsSupportWebsitePagesAppEntryPoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9w6Xd", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRoute", () => $ff9af2a26686f432$export$a6eefe359f3d3ade);
const $ff9af2a26686f432$export$a6eefe359f3d3ade = {
    name: 'helpcenter-settings-support-website-details-pages',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/pages',
    exact: true
};

});


parcelRegister("3I3w7", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationCustomizeRouteEntry", () => $1e560c67a660bb8d$export$e2d2cfd4c910d192);

var $3GWKF = parcelRequire("3GWKF");

var $2nex5 = parcelRequire("2nex5");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $8sMpG = parcelRequire("8sMpG");

var $668Am = parcelRequire("668Am");
const $1e560c67a660bb8d$export$e2d2cfd4c910d192 = (0, $fdS54.createEntry)((0, $8sMpG.helpCenterSettingsWidgetConfigurationCustomizeRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.widget-configuration.customize',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            horizontal: (0, $3GWKF.AsyncWidgetConfigurationNav)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>{
            return 0, $668Am.HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8sMpG", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationCustomizeRoute", () => $6e4c43f2ef8f72a6$export$f737005f37c63b01);
const $6e4c43f2ef8f72a6$export$f737005f37c63b01 = {
    name: 'helpcenter-settings-widget-configuration-customize',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/embed/:widgetId/customize',
    exact: true
};

});


parcelRegister("kWaDE", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationInstallRouteEntry", () => $f5433b5f94fd2e94$export$59a8db5e8e5313cc);

var $3GWKF = parcelRequire("3GWKF");

var $2nex5 = parcelRequire("2nex5");

var $4cLgf = parcelRequire("4cLgf");


var $lFLfF = parcelRequire("lFLfF");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $fdS54 = parcelRequire("fdS54");

var $chGN1 = parcelRequire("chGN1");

var $2QlXq = parcelRequire("2QlXq");
const $f5433b5f94fd2e94$export$59a8db5e8e5313cc = (0, $fdS54.createEntry)((0, $chGN1.helpCenterSettingsWidgetConfigurationInstallRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.widget-configuration.install',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $9af5f31dbe9d4be3$export$b5ebf984c5a2d153),
            horizontal: (0, $3GWKF.AsyncWidgetConfigurationNav)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>{
            return 0, $2QlXq.HelpCenterSettingsWidgetConfigurationInstallEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $2nex5.customerExperiencesNavigationResource),
            (0, $4cLgf.widgetAnonymousAccessResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("chGN1", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationInstallRoute", () => $761af136343ac9ce$export$3f21158408d69752);
const $761af136343ac9ce$export$3f21158408d69752 = {
    name: 'helpcenter-settings-widget-configuration-install',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/embed/:widgetId/install',
    exact: true
};

});


parcelRegister("2YBdr", function(module, exports) {
$parcel$export(module.exports, "homeOnboardingRedirectRouteEntry", () => $4c1897c9c503b1eb$export$2740cfaa979353b9);
/* eslint-disable import/order */ 
var $2rEc3 = parcelRequire("2rEc3");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $ks9Dt = parcelRequire("ks9Dt");
const $4c1897c9c503b1eb$export$2740cfaa979353b9 = (0, $fdS54.createEntry)((0, $ks9Dt.homeOnboardingRedirectRoute), ()=>({
        group: 'home',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2rEc3.default),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2rEc3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a27746803e5c57f4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $aqPkH = parcelRequire("aqPkH");

var $55BnK = parcelRequire("55BnK");
/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */ const $a27746803e5c57f4$var$JiraHomeOnboardingRedirect = ()=>{
    const { replace: replace } = (0, $55BnK.useRouterActions)();
    replace('/jira/your-work');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireOperationalAnalytics), {
        eventName: "JiraHomeOnboardingRedirect loaded",
        componentName: "JiraHomeOnboardingRedirect",
        attributes: {
            isRedirectionEnabled: true
        }
    });
};
$a27746803e5c57f4$var$JiraHomeOnboardingRedirect.displayName = "JiraHomeOnboardingRedirect";
var $a27746803e5c57f4$export$2e2bcd8739ae039 = $a27746803e5c57f4$var$JiraHomeOnboardingRedirect;

});
parcelRegister("aqPkH", function(module, exports) {
$parcel$export(module.exports, "FireUiAnalytics", () => $0aaea35909df1115$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $0aaea35909df1115$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $0aaea35909df1115$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $0aaea35909df1115$export$2ccf161b817b43b);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kTviw = parcelRequire("kTviw");


var $aJ81Y = parcelRequire("aJ81Y");
// eslint-disable-next-line jira/react/no-class-components
class $0aaea35909df1115$var$FireComponent extends (0, $euxye.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $aJ81Y.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
$0aaea35909df1115$var$FireComponent.displayName = "FireComponent";
const $0aaea35909df1115$export$64eb47d7b94ba089 = (0, $kTviw.default)()($0aaea35909df1115$var$FireComponent);
const $0aaea35909df1115$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0aaea35909df1115$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $46f069e6c968f461$export$a1562d08625f5d7e)
    });
$0aaea35909df1115$export$5a67e7291fd4569e.displayName = "FireUiAnalytics";
const $0aaea35909df1115$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0aaea35909df1115$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $46f069e6c968f461$export$947dac6c72b26f81)
    });
$0aaea35909df1115$export$5f0d7aae8dfa8b86.displayName = "FireTrackAnalytics";
const $0aaea35909df1115$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0aaea35909df1115$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $46f069e6c968f461$export$12346a674644c156)
    });
$0aaea35909df1115$export$b71c3ada5d4ec5da.displayName = "FireOperationalAnalytics";
const $0aaea35909df1115$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0aaea35909df1115$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $46f069e6c968f461$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });
$0aaea35909df1115$export$2ccf161b817b43b.displayName = "FireScreenAnalytics";

});
/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';



parcelRegister("ks9Dt", function(module, exports) {
$parcel$export(module.exports, "homeOnboardingRedirectRoute", () => $6283d6e62f4b291b$export$2eaffde3ad991b33);
const $6283d6e62f4b291b$export$2eaffde3ad991b33 = {
    name: 'home-onboarding-redirect',
    path: '/jira/your-work-onboarding',
    exact: true
};

});


parcelRegister("lxwe8", function(module, exports) {
$parcel$export(module.exports, "homeRedirectRouteEntry", () => $751706c49a3be386$export$5379c026da4201e6);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $5sROQ = parcelRequire("5sROQ");

var $dKAgu = parcelRequire("dKAgu");
const $751706c49a3be386$export$5379c026da4201e6 = (0, $fdS54.createEntry)((0, $5sROQ.homeRedirectRoute), ()=>({
        group: 'home',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dKAgu.default),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5sROQ", function(module, exports) {
$parcel$export(module.exports, "homeRedirectRoute", () => $12535a11ac9c6a5c$export$f7a252c9d61f8f94);
const $12535a11ac9c6a5c$export$f7a252c9d61f8f94 = {
    name: 'home-redirect',
    path: '/jira',
    exact: true
};

});

parcelRegister("dKAgu", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ca5727e00880c96$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bEdHr = parcelRequire("bEdHr");
const $5ca5727e00880c96$var$JiraBaseRedirectWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEdHr.default), null);
$5ca5727e00880c96$var$JiraBaseRedirectWrapper.displayName = "JiraBaseRedirectWrapper";
var $5ca5727e00880c96$export$2e2bcd8739ae039 = $5ca5727e00880c96$var$JiraBaseRedirectWrapper;

});
parcelRegister("bEdHr", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf04e412b9e245da$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $1uH7N = parcelRequire("1uH7N");

var $6CfY5 = parcelRequire("6CfY5");

var $kmdD8 = parcelRequire("kmdD8");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");

const $bf04e412b9e245da$var$JiraBaseRedirectWrapper = ()=>{
    (0, $1uH7N.di)(window);
    const { data: data, loading: loading } = (0, $k6ufm.useResource)((0, $kmdD8.userHomepageResource));
    (0, $euxye.useEffect)(()=>{
        if (!loading && data == null) (0, $6CfY5.default).safeInfoWithoutCustomerData((0, $8058eb9be7966a39$export$25a759e49d5049db), 'userHomepage data is null');
    }, [
        loading,
        data
    ]);
    if (loading) return null;
    // redirect to monolith to handle "/jira" route if homepageData is null (should not happen)
    if (data == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira');
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: data.homepagePreference
    });
};
$bf04e412b9e245da$var$JiraBaseRedirectWrapper.displayName = "JiraBaseRedirectWrapper";
var $bf04e412b9e245da$export$2e2bcd8739ae039 = $bf04e412b9e245da$var$JiraBaseRedirectWrapper;

});
/* eslint-disable jira/filename-case */ const $8058eb9be7966a39$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';




parcelRegister("5tx3g", function(module, exports) {
$parcel$export(module.exports, "issueCreateEmbedRouteEntry", () => $99a2b5767f5f3c68$export$abd0bbe95839baf7);

var $euxye = parcelRequire("euxye");

var $7xLLk = parcelRequire("7xLLk");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $gz6M2 = parcelRequire("gz6M2");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");
const $99a2b5767f5f3c68$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    // this is used for handling all the button clicks inside the iframe to open the new link in a new tab
    // as this view is mainly used an embed view inside an iframe.
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $99a2b5767f5f3c68$var$LazyIssueCreateEmbed = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("bHxam")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
});
const $99a2b5767f5f3c68$var$IssueCreateEmbedLazy = ()=>{
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $99a2b5767f5f3c68$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $99a2b5767f5f3c68$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7xLLk.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $99a2b5767f5f3c68$var$LazyIssueCreateEmbed,
        pageId: "spa-apps/issue-create-embed",
        shouldShowSpinner: true
    }));
};
$99a2b5767f5f3c68$var$IssueCreateEmbedLazy.displayName = "IssueCreateEmbedLazy";
const $99a2b5767f5f3c68$export$abd0bbe95839baf7 = (0, $fdS54.createEntry)((0, $gz6M2.issueCreateEmbedRoute), ()=>({
        group: 'issue',
        // eslint-disable-next-line no-restricted-syntax
        component: $99a2b5767f5f3c68$var$IssueCreateEmbedLazy,
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        forPaint: [
            $99a2b5767f5f3c68$var$LazyIssueCreateEmbed
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gz6M2", function(module, exports) {
$parcel$export(module.exports, "issueCreateEmbedRoute", () => $70de284c9babb620$export$c155f4de16b62110);
const $70de284c9babb620$export$c155f4de16b62110 = {
    name: 'issue-create-embed',
    path: '/jira/issues/create/embed'
};

});

parcelRegister("bHxam", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("gCScl"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("io5cK")
]).then(()=>parcelRequire('aWa91'));

});


parcelRegister("bZnet", function(module, exports) {
$parcel$export(module.exports, "issueCreateRedirectRouteEntry", () => $85cb3eca93acd187$export$cf4449926ea0ec0e);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $cn1qc = parcelRequire("cn1qc");

var $idjz9 = parcelRequire("idjz9");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");
const $85cb3eca93acd187$var$RedirectComponent = ()=>{
    const $ = (0, $e7boj.c)(4);
    const { pathname: pathname, search: search } = (0, $cn1qc.useLocation)();
    let t0;
    if ($[0] !== pathname) {
        t0 = pathname.replace("/jira/", "/");
        $[0] = pathname;
        $[1] = t0;
    } else t0 = $[1];
    const redirectUrl = `${t0}${search}`;
    const t1 = `0;url=${redirectUrl}`;
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("meta", {
            "http-equiv": "Refresh",
            content: t1
        }));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
$85cb3eca93acd187$var$RedirectComponent.displayName = "RedirectComponent";
const $85cb3eca93acd187$export$cf4449926ea0ec0e = (0, $fdS54.createEntry)((0, $idjz9.issueCreateRedirectRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: $85cb3eca93acd187$var$RedirectComponent,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        isRedirect: true,
        canTransitionIn: ()=>false,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            redirects: [
                {
                    key: 'issue-create-redirect',
                    timeoutMs: 100,
                    handler: async ({ url: url })=>{
                        const newPath = url.pathname.replace('/jira/', '/');
                        return newPath + (url.search ?? '');
                    }
                }
            ]
        }
    }));

});
parcelRegister("cn1qc", function(module, exports) {
$parcel$export(module.exports, "useLocation", () => $c6d45eb89906a7fc$export$45d76561a5302f2b);

var $f2wVS = parcelRequire("f2wVS");
const $c6d45eb89906a7fc$export$45d76561a5302f2b = (0, $f2wVS.createRouterSelector)((state)=>state.location);

});

parcelRegister("idjz9", function(module, exports) {
$parcel$export(module.exports, "issueCreateRedirectRoute", () => $89843ecb70c7cd6e$export$b18e5d434b23067c);
const $89843ecb70c7cd6e$export$b18e5d434b23067c = {
    path: '/jira/secure/CreateIssue(.*)',
    name: 'legacy-create-redirect',
    exact: false
};

});


parcelRegister("9pVk4", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalIssueListEmbedRouteEntry", () => $711c5cf8563d8a46$export$fc410307cfbd6467);

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $byMD7 = parcelRequire("byMD7");


var $2osjz = parcelRequire("2osjz");

var $7M9v3 = parcelRequire("7M9v3");

var $iSoIx = parcelRequire("iSoIx");

var $7dMoN = parcelRequire("7dMoN");

var $31tCE = parcelRequire("31tCE");

var $2A6mK = parcelRequire("2A6mK");
const $711c5cf8563d8a46$export$fc410307cfbd6467 = (0, $fdS54.createEntry)((0, $7M9v3.issueNavigatorGlobalIssueListEmbedRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'jql'
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2osjz.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $7dMoN.getCommonGlobalResources)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        entryPoint: ()=>(0, $i860n.fg)('jira_global_issue_list_embed') ? (0, $2A6mK.issueNavigatorEmbedPageEntryPoint) : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2osjz", function(module, exports) {
$parcel$export(module.exports, "EmbedIssueNavigatorSkeleton", () => $d8d3d18aae5773e3$export$1b1eaa2e48fda507);
/* embed-app.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $ghoEt = parcelRequire("ghoEt");
const $d8d3d18aae5773e3$var$customCssStyles = null;
const $d8d3d18aae5773e3$export$1b1eaa2e48fda507 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ghoEt))),
        className: (0, $4jQY2.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });
$d8d3d18aae5773e3$export$1b1eaa2e48fda507.displayName = "EmbedIssueNavigatorSkeleton";

});
parcelRegister("ghoEt", function(module, exports) {
module.exports = new URL("embed-issue-navigator-skeleton.tpl.616c25ab.svg", import.meta.url).toString();

});


parcelRegister("7M9v3", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalIssueListEmbedRoute", () => $7ec7d0f2af120c39$export$f77d0e17a2bb34);
const $7ec7d0f2af120c39$export$f77d0e17a2bb34 = {
    name: 'global-issue-list-embed',
    path: '/jira/issues/embed',
    exact: true,
    query: [
        'jql?'
    ]
};

});


parcelRegister("etuKr", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalJiraRouteEntry", () => $7f34b5f75387ccef$export$8925c79a030fdfe8);

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $6c7K8 = parcelRequire("6c7K8");

var $kyA0J = parcelRequire("kyA0J");


var $i860n = parcelRequire("i860n");

var $4KNkL = parcelRequire("4KNkL");

var $7dMoN = parcelRequire("7dMoN");

var $31tCE = parcelRequire("31tCE");

var $2A6mK = parcelRequire("2A6mK");
const $7f34b5f75387ccef$export$8925c79a030fdfe8 = (0, $fdS54.createEntry)((0, $6c7K8.issueNavigatorGlobalJiraRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $kyA0J.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $4KNkL.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $7dMoN.getCommonGlobalResources)()
        ],
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>{
            return (0, $i860n.fg)('nin_glance_panel_technical_changes') ? (0, $2A6mK.globalIssueNavigatorPageEntryPoint) : (0, $2A6mK.globalIssueNavigatorPageEntryPointWithoutPreviewPanel);
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        excludeFromWrmDeferredLoading: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin')
    }));

});
parcelRegister("6c7K8", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalJiraRoute", () => $ea3fc2d555831655$export$286b1d26dcbbce9e);
const $ea3fc2d555831655$export$286b1d26dcbbce9e = {
    name: 'global-issue-navigator',
    path: '/jira/issues/:issueKey?',
    query: [
        'filter?'
    ]
};

});


parcelRegister("1A3Ru", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalRouteEntry", () => $f83623e6d0f10957$export$3e58fe44312b4093);

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $6b5LL = parcelRequire("6b5LL");

var $kyA0J = parcelRequire("kyA0J");


var $4KNkL = parcelRequire("4KNkL");

var $7dMoN = parcelRequire("7dMoN");

var $8tarW = parcelRequire("8tarW");

var $cBtxa = parcelRequire("cBtxa");

var $31tCE = parcelRequire("31tCE");

var $2A6mK = parcelRequire("2A6mK");
const $f83623e6d0f10957$export$3e58fe44312b4093 = (0, $fdS54.createEntry)((0, $6b5LL.issueNavigatorGlobalRoute), ()=>({
        group: 'issue-navigator',
        // Ignore `jql` in apdex match so JQL-only URL changes don't reset page-load timing.
        // Use `undefined` (not `[]`) on the FG-OFF path so the field stays absent — matches
        // pre-PR behavior exactly, in case any consumer distinguishes absent from empty.
        apdexIgnoreParams: (0, $i860n.fg)('nin_jql_route_should_reload_mitigation') ? [
            'jql'
        ] : undefined,
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $kyA0J.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $4KNkL.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $7dMoN.getCommonGlobalResources)()
        ],
        layout: (0, $h2tgz.globalLayout),
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0)),
            circuitBreakerConfig: (0, $8tarW.getSsrCircuitBreaker)()
        },
        entryPoint: ()=>(0, $i860n.fg)('nin_glance_panel_technical_changes') ? (0, $2A6mK.globalIssueNavigatorPageEntryPoint) : (0, $2A6mK.globalIssueNavigatorPageEntryPointWithoutPreviewPanel),
        supportsPreviewPanel: true,
        excludeFromWrmDeferredLoading: true,
        // EXPERIMENTAL__shouldReload override: stage-1 mitigation for the upcoming `'jql?'`
        // addition to this route's `query` whitelist (delivered in EM-12530 / PR B). Once the
        // whitelist change lands, `match.query` will include `jql`, which causes
        // `isSameRouteMatch` to return `false` on JQL-only URL changes.
        //
        // At time of writing there are exactly two router plugins in AFM:
        //   - resources-plugin
        //   - entry-points-plugin
        //
        // resources-plugin: defaultShouldReload = `pluginId === 'resources-plugin' || !sameRoute`
        //   The first operand short-circuits to true → defaultShouldReload is invariant to
        //   whitelist changes. Resources always say "reload"; downstream getKey() determines
        //   whether each resource actually refetches.
        //
        // entry-points-plugin: defaultShouldReload = `false || !sameRoute = !sameRoute`
        //   Fully sensitive to sameRoute. Without this override, JQL-only URL changes would
        //   trigger fresh loadEntryPoint() calls — wasted Relay queries + suspense flashes.
        //
        // We allow-list both plugins explicitly (rather than catching all) so any future
        // plugin additions get default behavior unless explicitly opted in.
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext, pluginId: pluginId, defaultShouldReload: defaultShouldReload })=>{
            if (!(0, $i860n.fg)('nin_jql_route_should_reload_mitigation')) return defaultShouldReload;
            if (pluginId === 'entry-points-plugin' || pluginId === 'resources-plugin') {
                // If we're using IssueAppWithConditionalEntrypoint, we need to make
                // sure the selected issue's data is fetched
                if (prevContext.query.selectedIssue !== context.query.selectedIssue && !(0, $2700E.expVal)('nin_glance_panel', 'isEnabled', false) && (0, $i860n.fg)('nin_issue_app_conditional_entrypoint')) return true;
                // Reload-significant params for this route: `filter` only. If a new param is added
                // to the route's query whitelist that should also trigger reloads (e.g. orderBy,
                // viewMode), add it to this comparison — otherwise it will be silently ignored.
                return prevContext.match.url !== context.match.url || prevContext.query.filter !== context.query.filter;
            }
            return defaultShouldReload;
        }
    }));

});
parcelRegister("6b5LL", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalRoute", () => $f5a1e007503d59d3$export$928d3577bbe9e124);
const $f5a1e007503d59d3$export$928d3577bbe9e124 = {
    name: 'global-issue-navigator',
    path: '/issues',
    // `jql?` distinguishes distinct-JQL NIN URLs for prefetch dedup (always-on; see EM-12530).
    query: [
        'filter?',
        'jql?'
    ]
};

});

parcelRegister("8tarW", function(module, exports) {
$parcel$export(module.exports, "getSsrCircuitBreaker", () => $9f4f590869cfd1d9$export$7f161bfcba3ff100);

var $k11SN = parcelRequire("k11SN");
function $9f4f590869cfd1d9$export$7f161bfcba3ff100() {
    return {
        isSetCookieEnabled: true,
        isMonitoringEnabled: true,
        isCircuitBreakerEnabled: !(0, $k11SN.default)('issue-navigator-cookie-cb'),
        cookieKey: 'nin',
        windowSize: 10,
        halfOpenForCount: 5,
        threshold: 0.7,
        keepOpenCount: 20
    };
}

});

parcelRegister("cBtxa", function(module, exports) {
$parcel$export(module.exports, "adjustSsrFetchTimeout", () => $2a6bdb00ddfd5eae$export$1b8ff90b3cebfe63);

var $6bEm8 = parcelRequire("6bEm8");
const $2a6bdb00ddfd5eae$var$STAGING_FETCH_TIMEOUT_BUFFER = 800;
function $2a6bdb00ddfd5eae$export$1b8ff90b3cebfe63(timeout) {
    if (!timeout) return undefined;
    if ((0, $6bEm8.default)('ajs-environment') === 'staging') return timeout + $2a6bdb00ddfd5eae$var$STAGING_FETCH_TIMEOUT_BUFFER;
    return timeout;
}

});


parcelRegister("4Jkh6", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessCustomEmbedRouteEntry", () => $c39cff6be1d44a52$export$ca299eb1d1e6d3a9);

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $g3rXW = parcelRequire("g3rXW");


var $2osjz = parcelRequire("2osjz");

var $byMD7 = parcelRequire("byMD7");

var $836A7 = parcelRequire("836A7");

var $31tCE = parcelRequire("31tCE");

var $2A6mK = parcelRequire("2A6mK");

var $g7Z5o = parcelRequire("g7Z5o");
const $c39cff6be1d44a52$export$ca299eb1d1e6d3a9 = (0, $fdS54.createEntry)((0, $g3rXW.issueNavigatorProjectBusinessCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2osjz.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $836A7.getCommonProjectResources)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>(0, $i860n.fg)('jira_list_nin_merge') ? undefined : (0, $2A6mK.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin')
    }));

});
parcelRegister("g3rXW", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessCustomEmbedRoute", () => $554f8238eb74388d$export$7c9a6e2f3d99aa24);
const $554f8238eb74388d$export$7c9a6e2f3d99aa24 = {
    name: 'issue-navigator-core-custom-embed',
    path: '/jira/core/projects/:projectKey/issues/:navigationItemId/embed'
};

});

parcelRegister("836A7", function(module, exports) {
$parcel$export(module.exports, "getCommonProjectResources", () => $4357c011af90b4f3$export$6236a7417086ea8d);
/* eslint-disable import/order */ 
var $jFwZ0 = parcelRequire("jFwZ0");

var $Jz4MJ = parcelRequire("Jz4MJ");

var $oXLtZ = parcelRequire("oXLtZ");

var $hFYSn = parcelRequire("hFYSn");

var $ljl4h = parcelRequire("ljl4h");

var $e2qxz = parcelRequire("e2qxz");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $L6Vhc = parcelRequire("L6Vhc");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $9KYmb = parcelRequire("9KYmb");

var $gZWlI = parcelRequire("gZWlI");

var $fPXVF = parcelRequire("fPXVF");
const $4357c011af90b4f3$export$6236a7417086ea8d = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        (0, $L6Vhc.issueNavigatorRelayResource),
        (0, $L6Vhc.issueNavigatorFilterRelayResource),
        (0, $L6Vhc.issueNavigatorHydrationRelayResource),
        (0, $L6Vhc.issueNavigatorFilterRefinementRelayResource),
        ...(0, $dUAVJ.getNavigationResources)({
            isUsingSidebarEntrypoint: isUsingSidebarEntrypoint
        }),
        ...(0, $fPXVF.getIssueAppResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $hWEkS.incidentExperimentTraitResource),
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        // eslint-disable-next-line camelcase
        (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $gZWlI.projectThemeResource),
        (0, $e2qxz.sidebarProjectIssuesResource),
        (0, $ljl4h.staticSidebarDefaultPINFiltersResource),
        (0, $jFwZ0.currentUserResource),
        ...(0, $Jz4MJ.getAIContextPanelResources)(),
        ...(0, $9KYmb.getDraftReplyPillsResource)()
    ];

});
parcelRegister("ljl4h", function(module, exports) {
$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $bf291bace0877a62$export$d3efe54a881807bf);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $cGbMH = parcelRequire("cGbMH");
const $bf291bace0877a62$export$d3efe54a881807bf = (0, $7edbf.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    // oxlint-disable-next-line no-explicit-any
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $cGbMH.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("cGbMH", function(module, exports) {
$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $7fba5ec1885a6369$export$268c1bcb44a0ddd3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $7fba5ec1885a6369$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $7fba5ec1885a6369$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $h2wCv.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $7fba5ec1885a6369$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});


parcelRegister("e2qxz", function(module, exports) {
$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $32dc3a55ea8d65a1$export$be31dd7adcfd2297);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $htsFl = parcelRequire("htsFl");

var $fttDy = parcelRequire("fttDy");

var $c4rhk = parcelRequire("c4rhk");
const $32dc3a55ea8d65a1$export$be31dd7adcfd2297 = (0, $c4rhk.withGiraAggAnonSsrFix)((0, $htsFl.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    // oxlint-disable-next-line no-explicit-any
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $fttDy.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("fttDy", function(module, exports) {
$parcel$export(module.exports, "default", () => $81e9f814ccc208f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8e84d94b6d73244a240a13707a8d897c>>
 * @relayHash 29ff181ab95db3cc7ca7b45d6f6a81b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 61e02e7cfd80e5aac6b124b5cfc50f504bb8ef7e3a90c6c9c3061346d2052d27
const $81e9f814ccc208f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarredFiltersContainerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    v1 /*: any*/ 
                                ],
                                "kind": "FragmentSpread",
                                "name": "StarredFiltersList"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarredFiltersContainerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "filterId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFavourite"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jql"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isEditable"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        }
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "61e02e7cfd80e5aac6b124b5cfc50f504bb8ef7e3a90c6c9c3061346d2052d27",
            "metadata": {},
            "name": "StarredFiltersContainerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$81e9f814ccc208f2$var$node.hash = "5638ded0435361762f065c662e4cb3fc";
var $81e9f814ccc208f2$export$2e2bcd8739ae039 = $81e9f814ccc208f2$var$node;

});



parcelRegister("g7Z5o", function(module, exports) {
$parcel$export(module.exports, "ListRedirect", () => $b6963d750dc76d60$export$c011d20faedb87c3);

var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");

var $f2wVS = parcelRequire("f2wVS");
const $b6963d750dc76d60$var$useMatchUrl = (0, $f2wVS.createRouterSelector)((state)=>state.match.url);
const $b6963d750dc76d60$export$c011d20faedb87c3 = ()=>{
    const matchUrl = $b6963d750dc76d60$var$useMatchUrl();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: matchUrl.replace('issues', 'list')
    });
};
$b6963d750dc76d60$export$c011d20faedb87c3.displayName = "ListRedirect";

});


parcelRegister("4Haw9", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRouteEntry", () => $2b451f08e5f1a7f0$export$2b29f9b6033583e1);

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $eQqb9 = parcelRequire("eQqb9");


var $2osjz = parcelRequire("2osjz");

var $byMD7 = parcelRequire("byMD7");

var $836A7 = parcelRequire("836A7");

var $31tCE = parcelRequire("31tCE");

var $2A6mK = parcelRequire("2A6mK");

var $g7Z5o = parcelRequire("g7Z5o");
const $2b451f08e5f1a7f0$export$2b29f9b6033583e1 = (0, $fdS54.createEntry)((0, $eQqb9.issueNavigatorProjectBusinessEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2osjz.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $836A7.getCommonProjectResources)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>(0, $i860n.fg)('jira_list_nin_merge') ? undefined : (0, $2A6mK.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin')
    }));

});
parcelRegister("eQqb9", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRoute", () => $bb1e4350129e301b$export$a59f4bdf8be89f93);
const $bb1e4350129e301b$export$a59f4bdf8be89f93 = {
    name: 'issue-navigator-core-embed',
    path: '/jira/core/projects/:projectKey/issues/embed'
};

});


parcelRegister("aXz6t", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessRouteEntry", () => $2fac3fc8eb58027c$export$ce258b07e4b7eb8c);


var $75Njg = parcelRequire("75Njg");

var $dvtoW = parcelRequire("dvtoW");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dyi4n = parcelRequire("dyi4n");

var $2EQPz = parcelRequire("2EQPz");


var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $836A7 = parcelRequire("836A7");

var $8tarW = parcelRequire("8tarW");

var $31tCE = parcelRequire("31tCE");

var $cBtxa = parcelRequire("cBtxa");

var $2A6mK = parcelRequire("2A6mK");

var $g7Z5o = parcelRequire("g7Z5o");
const $2fac3fc8eb58027c$export$ce258b07e4b7eb8c = (0, $fdS54.createEntry)((0, $dyi4n.issueNavigatorProjectBusinessRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $836A7.getCommonProjectResources)()
        ],
        layout: (0, $QhQu4.createLayout)((0, $dvtoW.genericProjectLayout)),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            circuitBreakerConfig: (0, $8tarW.getSsrCircuitBreaker)(),
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0))
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jira_list_nin_merge')) return undefined;
            return (0, $i860n.fg)('nin_glance_panel_technical_changes') ? (0, $2A6mK.issueNavigatorPageEntryPoint) : (0, $2A6mK.issueNavigatorPageEntryPointWithoutPreviewPanel);
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: (0, $2700E.expVal)('jira-list-full-theming-exp', 'isEnabled', false) ? 'full' : 'contoured',
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("dyi4n", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessRoute", () => $84e30967599828c7$export$3219766aa1a42d18);
const $84e30967599828c7$export$3219766aa1a42d18 = {
    name: 'issue-navigator-core',
    path: '/jira/core/projects/:projectKey/issues/:navigationItemId?'
};

});

parcelRegister("2EQPz", function(module, exports) {
$parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", () => $c174a07b9254a723$export$112138f5f732a994);
/* project-app.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $kFiO7 = parcelRequire("kFiO7");
const $c174a07b9254a723$var$customCssStyles = null;
const $c174a07b9254a723$export$112138f5f732a994 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kFiO7))),
        className: (0, $4jQY2.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });
$c174a07b9254a723$export$112138f5f732a994.displayName = "ProjectIssueNavigatorSkeleton";

});
parcelRegister("kFiO7", function(module, exports) {
module.exports = new URL("project-issue-navigator-nav4-skeleton.tpl.0c4c4250.svg", import.meta.url).toString();

});



parcelRegister("lkewN", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicCustomEmbedRouteEntry", () => $2f317eb793648d14$export$26b088a9b796b7a4);

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $3Yk16 = parcelRequire("3Yk16");

var $2osjz = parcelRequire("2osjz");

var $byMD7 = parcelRequire("byMD7");


var $836A7 = parcelRequire("836A7");

var $2A6mK = parcelRequire("2A6mK");

var $31tCE = parcelRequire("31tCE");

var $g7Z5o = parcelRequire("g7Z5o");
const $2f317eb793648d14$export$26b088a9b796b7a4 = (0, $fdS54.createEntry)((0, $3Yk16.issueNavigatorProjectClassicCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2osjz.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $836A7.getCommonProjectResources)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>(0, $i860n.fg)('jira_list_nin_merge') ? undefined : (0, $2A6mK.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3Yk16", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicCustomEmbedRoute", () => $09ccd8585f6e1bc4$export$67a527991a5dd89b);
const $09ccd8585f6e1bc4$export$67a527991a5dd89b = {
    name: 'issue-navigator-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/issues/:navigationItemId/embed'
};

});


parcelRegister("figDu", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRouteEntry", () => $9f1ff9112afd2a75$export$e77148aa19091842);

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $4F77J = parcelRequire("4F77J");

var $2osjz = parcelRequire("2osjz");

var $byMD7 = parcelRequire("byMD7");


var $836A7 = parcelRequire("836A7");

var $2A6mK = parcelRequire("2A6mK");

var $31tCE = parcelRequire("31tCE");

var $g7Z5o = parcelRequire("g7Z5o");
const $9f1ff9112afd2a75$export$e77148aa19091842 = (0, $fdS54.createEntry)((0, $4F77J.issueNavigatorProjectClassicEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2osjz.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $836A7.getCommonProjectResources)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>(0, $i860n.fg)('jira_list_nin_merge') ? undefined : (0, $2A6mK.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4F77J", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRoute", () => $5a0011f9f8f05eb8$export$1062bd8aa98d7bd1);
const $5a0011f9f8f05eb8$export$1062bd8aa98d7bd1 = {
    name: 'issue-navigator-classic-embed',
    path: '/jira/software/c/projects/:projectKey/issues/embed'
};

});


parcelRegister("iTCvp", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicRouteEntry", () => $ba55f5b2cf0fe5fa$export$88d5f4117ce3d0fb);



var $75Njg = parcelRequire("75Njg");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $dvtoW = parcelRequire("dvtoW");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lr5do = parcelRequire("lr5do");

var $2EQPz = parcelRequire("2EQPz");


var $836A7 = parcelRequire("836A7");

var $31tCE = parcelRequire("31tCE");

var $8tarW = parcelRequire("8tarW");

var $cBtxa = parcelRequire("cBtxa");

var $2A6mK = parcelRequire("2A6mK");

var $g7Z5o = parcelRequire("g7Z5o");
const $ba55f5b2cf0fe5fa$export$88d5f4117ce3d0fb = (0, $fdS54.createEntry)((0, $lr5do.issueNavigatorProjectClassicRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $836A7.getCommonProjectResources)({
                isUsingSidebarEntrypoint: true
            })
        ],
        layout: (0, $QhQu4.createLayout)((0, $dvtoW.genericProjectLayout)),
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0)),
            circuitBreakerConfig: (0, $8tarW.getSsrCircuitBreaker)()
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jira_list_nin_merge')) return undefined;
            const withPreviewPanel = (0, $i860n.fg)('navx-global-side-nav') ? (0, $2A6mK.GSNIssueNavigatorPageEntryPointWithNested) : (0, $2A6mK.issueNavigatorPageEntryPointWithNested);
            const withoutPreviewPanel = (0, $i860n.fg)('navx-global-side-nav') ? (0, $2A6mK.GSNIssueNavigatorPageEntryPointWithNestedWithoutPreviewPanel) : (0, $2A6mK.issueNavigatorPageEntryPointWithNestedWithoutPreviewPanel);
            return (0, $i860n.fg)('nin_glance_panel_technical_changes') ? withPreviewPanel : withoutPreviewPanel;
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: (0, $2700E.expVal)('jira-list-full-theming-exp', 'isEnabled', false) ? 'full' : 'contoured',
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("lr5do", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicRoute", () => $49834673b0eef35b$export$8e7b74b6169d59ca);
const $49834673b0eef35b$export$8e7b74b6169d59ca = {
    name: 'issue-navigator-classic',
    path: '/jira/software/c/projects/:projectKey/issues/:navigationItemId?'
};

});


parcelRegister("7npnA", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectListServicedeskRouteEntry", () => $e02147e89b6e2c9c$export$1e29ccb817b061b2);
/* eslint-disable import/order */ 

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $fdS54 = parcelRequire("fdS54");

var $cpnl1 = parcelRequire("cpnl1");

var $iHmVA = parcelRequire("iHmVA");

var $74h93 = parcelRequire("74h93");

var $2EQPz = parcelRequire("2EQPz");


var $862Zj = parcelRequire("862Zj");

var $9MeJD = parcelRequire("9MeJD");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");

var $836A7 = parcelRequire("836A7");

var $31tCE = parcelRequire("31tCE");

var $8tarW = parcelRequire("8tarW");

var $cBtxa = parcelRequire("cBtxa");

var $2A6mK = parcelRequire("2A6mK");
const $e02147e89b6e2c9c$export$1e29ccb817b061b2 = (0, $fdS54.createEntry)((0, $iHmVA.issueNavigatorProjectListServicedeskRoute), ()=>({
        ufoName: 'jsm-list-nin',
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $836A7.getCommonProjectResources)(),
            (0, $cpnl1.queuesNavigationItems),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            (0, $9MeJD.jsmProjectMenuContentSidebarResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_nin_prefetch_sidebar_resources'), (0, $862Zj.staticSidebarShortcutsResource)),
            ...(0, $lbxXL.getServiceDeskSharedNavigationSingleResources)().map((resource)=>(0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_nin_prefetch_sidebar_resources'), resource))
        ],
        layout: (0, $74h93.serviceProjectLayout),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            circuitBreakerConfig: (0, $8tarW.getSsrCircuitBreaker)(),
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0))
        },
        entryPoint: ()=>(0, $i860n.fg)('nin_glance_panel_technical_changes') ? (0, $2A6mK.issueNavigatorWithoutHorizontalNavPageEntryPoint) : (0, $2A6mK.issueNavigatorWithoutHorizontalNavPageEntryPointWithoutPreviewPanel),
        supportsPreviewPanel: true,
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        excludeFromWrmDeferredLoading: (0, $i860n.fg)('jira_list_nin_merge')
    }));

});
parcelRegister("iHmVA", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectListServicedeskRoute", () => $264d3930ca144015$export$ae79eb2d016347ad);
const $264d3930ca144015$export$ae79eb2d016347ad = {
    name: 'jsm-list-nin',
    path: '/jira/servicedesk/projects/:projectKey/list/:navigationItemId?'
};

});


parcelRegister("56dYq", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectServicedeskRouteEntry", () => $4957e16cc2087c7b$export$b779296ccb8ca1a8);
/* eslint-disable import/order */ 

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $cpnl1 = parcelRequire("cpnl1");

var $gHebK = parcelRequire("gHebK");

var $74h93 = parcelRequire("74h93");

var $2EQPz = parcelRequire("2EQPz");


var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $862Zj = parcelRequire("862Zj");

var $9MeJD = parcelRequire("9MeJD");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");

var $836A7 = parcelRequire("836A7");

var $31tCE = parcelRequire("31tCE");

var $8tarW = parcelRequire("8tarW");

var $cBtxa = parcelRequire("cBtxa");

var $2A6mK = parcelRequire("2A6mK");

var $g7Z5o = parcelRequire("g7Z5o");
const $4957e16cc2087c7b$export$b779296ccb8ca1a8 = (0, $fdS54.createEntry)((0, $gHebK.issueNavigatorProjectServicedeskRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $836A7.getCommonProjectResources)(),
            (0, $cpnl1.queuesNavigationItems),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            (0, $9MeJD.jsmProjectMenuContentSidebarResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_nin_prefetch_sidebar_resources'), (0, $862Zj.staticSidebarShortcutsResource)),
            ...(0, $lbxXL.getServiceDeskSharedNavigationSingleResources)().map((resource)=>(0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_nin_prefetch_sidebar_resources'), resource))
        ],
        layout: (0, $74h93.serviceProjectLayout),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            circuitBreakerConfig: (0, $8tarW.getSsrCircuitBreaker)(),
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0))
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jira_list_nin_merge')) return undefined;
            return (0, $i860n.fg)('nin_glance_panel_technical_changes') ? (0, $2A6mK.issueNavigatorWithoutHorizontalNavPageEntryPoint) : (0, $2A6mK.issueNavigatorWithoutHorizontalNavPageEntryPointWithoutPreviewPanel);
        },
        supportsPreviewPanel: true,
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("gHebK", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectServicedeskRoute", () => $236854f9d55a73cb$export$e3495d64f36ba27c);
const $236854f9d55a73cb$export$e3495d64f36ba27c = {
    name: 'servicedesk-issues',
    path: '/jira/servicedesk/projects/:projectKey/issues/:navigationItemId?'
};

});


parcelRegister("QGZql", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareCustomEmbedRouteEntry", () => $c5d3dc04727ca0f0$export$128e557bdc64663e);

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $9hq64 = parcelRequire("9hq64");

var $byMD7 = parcelRequire("byMD7");

var $2osjz = parcelRequire("2osjz");


var $i860n = parcelRequire("i860n");

var $836A7 = parcelRequire("836A7");

var $2A6mK = parcelRequire("2A6mK");

var $31tCE = parcelRequire("31tCE");

var $g7Z5o = parcelRequire("g7Z5o");
const $c5d3dc04727ca0f0$export$128e557bdc64663e = (0, $fdS54.createEntry)((0, $9hq64.issueNavigatorProjectSoftwareCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2osjz.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $836A7.getCommonProjectResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>(0, $i860n.fg)('jira_list_nin_merge') ? undefined : (0, $2A6mK.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin')
    }));

});
parcelRegister("9hq64", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareCustomEmbedRoute", () => $0e6f2e58a0402bfd$export$efddc86081bba5fc);
const $0e6f2e58a0402bfd$export$efddc86081bba5fc = {
    name: 'software-issue-navigator-custom-embed',
    path: '/jira/software/projects/:projectKey/issues/:navigationItemId/embed'
};

});


parcelRegister("bBBkV", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRouteEntry", () => $746d7b28e574fd69$export$e87ead168f851b66);

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $jrymI = parcelRequire("jrymI");

var $byMD7 = parcelRequire("byMD7");

var $2osjz = parcelRequire("2osjz");


var $i860n = parcelRequire("i860n");

var $836A7 = parcelRequire("836A7");

var $2A6mK = parcelRequire("2A6mK");

var $31tCE = parcelRequire("31tCE");

var $g7Z5o = parcelRequire("g7Z5o");
const $746d7b28e574fd69$export$e87ead168f851b66 = (0, $fdS54.createEntry)((0, $jrymI.issueNavigatorProjectSoftwareEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2osjz.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $836A7.getCommonProjectResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>(0, $i860n.fg)('jira_list_nin_merge') ? undefined : (0, $2A6mK.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin')
    }));

});
parcelRegister("jrymI", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRoute", () => $26ae204b8551b453$export$ab4385f7ae539901);
const $26ae204b8551b453$export$ab4385f7ae539901 = {
    name: 'software-issue-navigator-embed',
    path: '/jira/software/projects/:projectKey/issues/embed'
};

});


parcelRegister("hKZO1", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareRouteEntry", () => $66faf22d20abb395$export$2a50f64378877c9d);


var $75Njg = parcelRequire("75Njg");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $kPd8k = parcelRequire("kPd8k");

var $2EQPz = parcelRequire("2EQPz");

var $3eysO = parcelRequire("3eysO");


var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $836A7 = parcelRequire("836A7");

var $31tCE = parcelRequire("31tCE");

var $8tarW = parcelRequire("8tarW");

var $cBtxa = parcelRequire("cBtxa");

var $2A6mK = parcelRequire("2A6mK");

var $g7Z5o = parcelRequire("g7Z5o");
const $66faf22d20abb395$export$2a50f64378877c9d = (0, $fdS54.createEntry)((0, $kPd8k.issueNavigatorProjectSoftwareRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $836A7.getCommonProjectResources)()
        ],
        layout: (0, $QhQu4.createLayout)((0, $3eysO.softwareProjectLayoutNoOnboarding)),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            circuitBreakerConfig: (0, $8tarW.getSsrCircuitBreaker)(),
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0))
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $g7Z5o.ListRedirect) : undefined,
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jira_list_nin_merge')) return undefined;
            return (0, $i860n.fg)('nin_glance_panel_technical_changes') ? (0, $2A6mK.issueNavigatorPageEntryPoint) : (0, $2A6mK.issueNavigatorPageEntryPointWithoutPreviewPanel);
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: (0, $2700E.expVal)('jira-list-full-theming-exp', 'isEnabled', false) ? 'full' : 'contoured',
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("kPd8k", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareRoute", () => $908e4a61b61c80c0$export$b8bd410115307d80);
const $908e4a61b61c80c0$export$b8bd410115307d80 = {
    name: 'software-issue-navigator',
    path: '/jira/software/projects/:projectKey/issues/:navigationItemId?'
};

});


parcelRegister("6KpYG", function(module, exports) {
$parcel$export(module.exports, "itamAiInsightsPreviewRouteEntry", () => $14315004e43e4ad0$export$f7dd54ebd1bf2a17);

var $cayEn = parcelRequire("cayEn");

var $5tJXD = parcelRequire("5tJXD");

var $c4tGG = parcelRequire("c4tGG");

var $eEBcy = parcelRequire("eEBcy");

var $iSoIx = parcelRequire("iSoIx");

var $8HUuJ = parcelRequire("8HUuJ");

var $dZa0W = parcelRequire("dZa0W");

var $8ycTI = parcelRequire("8ycTI");

var $fdS54 = parcelRequire("fdS54");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");
const $14315004e43e4ad0$var$itamAiInsightsPreviewPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $5tJXD.itamAiInsightsPreviewEntryPoint)
});
const $14315004e43e4ad0$export$f7dd54ebd1bf2a17 = (0, $fdS54.createEntry)((0, $cayEn.itamAiInsightsPreviewRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $byMD7.chromelessLayout),
        entryPoint () {
            return (0, $i860n.fg)('itam_ftw') ? $14315004e43e4ad0$var$itamAiInsightsPreviewPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        },
        resources: [
            (0, $8ycTI.workspaceResource),
            (0, $c4tGG.verticalInstantiationResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('itam_ftw'), (0, $eEBcy.avsWorkspaceResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics'), (0, $dZa0W.itamDashboardsSemanticModelResource))
        ]
    }));

});
parcelRegister("cayEn", function(module, exports) {
$parcel$export(module.exports, "itamAiInsightsPreviewRoute", () => $cd7c942289913d4b$export$62f3254160b7ef1d);
const $cd7c942289913d4b$export$62f3254160b7ef1d = {
    name: 'itam-ai-insights-preview',
    path: '/jira/itam/:practice/ai-insights-preview/embed',
    exact: true
};

});

parcelRegister("5tJXD", function(module, exports) {
$parcel$export(module.exports, "itamAiInsightsPreviewEntryPoint", () => $1d6a8cd164de2ec8$export$f3084db55095f5a3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $1d6a8cd164de2ec8$export$f3084db55095f5a3 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6bCt4")), {
        moduleId: "90eae6ed",
        moduleName: "ItamAiInsightsPreviewPage",
        priority: "interaction"
    }),
    getPreloadProps: (_entryPointRouteParams)=>{
        return {
            entryPoints: {}
        };
    }
});

});
parcelRegister("6bCt4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7O9j5").then(()=>parcelRequire('cRiQX'));

});


parcelRegister("c4tGG", function(module, exports) {
$parcel$export(module.exports, "HAM_INSTANTIATION_COMPLETED_STATUS", () => $562fdef6618c3ced$export$c3b0aa674b346f4c);
$parcel$export(module.exports, "fetchVerticalInstantiations", () => $562fdef6618c3ced$export$11324546f7f4476d);
$parcel$export(module.exports, "verticalInstantiationResource", () => $562fdef6618c3ced$export$340a0421c9c15efa);
$parcel$export(module.exports, "useVerticalInstantiationResource", () => $562fdef6618c3ced$export$8876ab5e19c15fcd);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $562fdef6618c3ced$export$2d13ed8b9364bc2d = 'ITAM_VERTICAL_INSTANTIATION';
const $562fdef6618c3ced$export$c3b0aa674b346f4c = 'COMPLETED';
const $562fdef6618c3ced$var$verticalInstantiationQuery = `
	query verticalInstantiationResourceQuery($cloudId: ID!, $type: AssetsVerticalVerticalType!) {
		assetsVertical_verticalInstantiations(cloudId: $cloudId, first: 100, type: $type)
			@optIn(to: "AssetsVerticalVerticalInstantiations") {
			pageInfo {
				endCursor
			}
			edges {
				node {
					id
					type
					status
					categories(first: 100) {
						edges {
							node {
								id
								category
								status
							}
						}
					}
				}
			}
		}
	}
`;
const $562fdef6618c3ced$export$11324546f7f4476d = async (cloudId)=>{
    if (!cloudId) throw new Error('Unable to fetch vertical instantiations: missing cloudId');
    const requestBody = {
        query: $562fdef6618c3ced$var$verticalInstantiationQuery,
        variables: {
            cloudId: cloudId,
            type: 'HAM'
        }
    };
    const response = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
        body: JSON.stringify(requestBody),
        headers: {
            'content-type': 'application/json',
            'Atl-CloudId': cloudId
        }
    });
    return response.data?.assetsVertical_verticalInstantiations ?? null;
};
const $562fdef6618c3ced$export$340a0421c9c15efa = (0, $7edbf.createResource)({
    type: $562fdef6618c3ced$export$2d13ed8b9364bc2d,
    maxAge: Infinity,
    getKey: ()=>'state',
    getData: async (_routerContext, { tenantContext: tenantContext })=>{
        const cloudId = tenantContext?.cloudId;
        if (!cloudId) throw new Error('Unable to fetch vertical instantiations: missing tenantContext.cloudId');
        return $562fdef6618c3ced$export$11324546f7f4476d(cloudId);
    }
});
function $562fdef6618c3ced$export$8876ab5e19c15fcd() {
    return (0, $k6ufm.useResource)($562fdef6618c3ced$export$340a0421c9c15efa);
}

});

parcelRegister("eEBcy", function(module, exports) {
$parcel$export(module.exports, "avsWorkspaceResource", () => $217639826a48a016$export$b4b71a9ed06835ce);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $217639826a48a016$export$f87592d931bdc1e9 = 'assets-vertical';
const $217639826a48a016$export$e1fedb2fdd66867d = 'ITAM_AVS_WORKSPACE';
/**
 * Resolves the active activation (workspace) id for a given cloud id and the
 * Assets Vertical product slug.
 *
 * Mirrors the AVP pattern (`tenantContexts.activationIdByProduct`) so ITAM can
 * source the Assets Vertical workspace id rather than the legacy `jsm-cmdb`
 * CMDB workspace id.
 */ const $217639826a48a016$var$avsWorkspaceQuery = `
	query itamAvsWorkspaceResourceQuery($cloudId: ID!, $product: String!) {
		tenantContexts(cloudIds: [$cloudId]) {
			activationIdByProduct(product: $product) {
				active
			}
		}
	}
`;
const $217639826a48a016$export$13cbf6fe9a077c4b = async (cloudId)=>{
    if (!cloudId) throw new Error('Unable to fetch AVS workspace id: missing cloudId');
    const requestBody = {
        query: $217639826a48a016$var$avsWorkspaceQuery,
        variables: {
            cloudId: cloudId,
            product: $217639826a48a016$export$f87592d931bdc1e9
        }
    };
    const response = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
        body: JSON.stringify(requestBody),
        headers: {
            'content-type': 'application/json',
            'Atl-CloudId': cloudId
        }
    });
    return response.data?.tenantContexts?.[0]?.activationIdByProduct?.active ?? null;
};
const $217639826a48a016$export$b4b71a9ed06835ce = (0, $7edbf.createResource)({
    type: $217639826a48a016$export$e1fedb2fdd66867d,
    maxAge: Infinity,
    getKey: ()=>'state',
    getData: async (_routerContext, { tenantContext: tenantContext })=>{
        const cloudId = tenantContext?.cloudId;
        if (!cloudId) throw new Error('Unable to fetch AVS workspace id: missing tenantContext.cloudId');
        return $217639826a48a016$export$13cbf6fe9a077c4b(cloudId);
    }
});
function $217639826a48a016$export$d0ca088e94019ec1() {
    return (0, $k6ufm.useResource)($217639826a48a016$export$b4b71a9ed06835ce);
}

});

parcelRegister("dZa0W", function(module, exports) {
$parcel$export(module.exports, "itamDashboardsSemanticModelResource", () => $61f3b4549f99da2c$export$f48cace277d1817e);
$parcel$export(module.exports, "useItamDashboardsSemanticModel", () => $61f3b4549f99da2c$export$c7b9fa55a4f2b282);

var $k6ufm = parcelRequire("k6ufm");

var $2yODD = parcelRequire("2yODD");
const $61f3b4549f99da2c$export$f48cace277d1817e = (0, $2yODD.createSemanticModelResource)({
    hostingProduct: 'jsm-cmdb',
    location: 'itam',
    products: [
        'jsm-cmdb'
    ],
    subProducts: [
        'jsm'
    ],
    desiredOrder: [
        'jsm-cmdb',
        'jira',
        'goals',
        'devops',
        'xray'
    ]
});
const $61f3b4549f99da2c$export$c7b9fa55a4f2b282 = ()=>(0, $k6ufm.useResource)($61f3b4549f99da2c$export$f48cace277d1817e);

});


parcelRegister("dwoYZ", function(module, exports) {
$parcel$export(module.exports, "itamRouteEntry", () => $b52e128242cc19de$export$58b2216f0a0b541);

var $8lHBG = parcelRequire("8lHBG");

var $5wmtX = parcelRequire("5wmtX");

var $8rtFO = parcelRequire("8rtFO");

var $c4tGG = parcelRequire("c4tGG");

var $eEBcy = parcelRequire("eEBcy");

var $8HUuJ = parcelRequire("8HUuJ");

var $dZa0W = parcelRequire("dZa0W");


var $iSoIx = parcelRequire("iSoIx");

var $8ycTI = parcelRequire("8ycTI");

var $fdS54 = parcelRequire("fdS54");

var $h2tgz = parcelRequire("h2tgz");

var $7dMoN = parcelRequire("7dMoN");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");
const $b52e128242cc19de$var$itamAppPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5wmtX.itamEntryPoint)
});
const $b52e128242cc19de$export$58b2216f0a0b541 = (0, $fdS54.createEntry)((0, $8lHBG.itamRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $e8331ef75a276309$export$97144bc9cbbc1d5f)
        },
        resources: [
            ...(0, $7dMoN.getCommonGlobalResources)(),
            (0, $8ycTI.workspaceResource),
            (0, $c4tGG.verticalInstantiationResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('itam_ftw'), (0, $eEBcy.avsWorkspaceResource)),
            (0, $8rtFO.hamViewsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics'), (0, $dZa0W.itamDashboardsSemanticModelResource))
        ],
        entryPoint () {
            return (0, $i860n.fg)('itam_ftw') ? $b52e128242cc19de$var$itamAppPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8lHBG", function(module, exports) {
$parcel$export(module.exports, "itamRoute", () => $ac65f384987f9678$export$e2ac8467edb96a95);
const $ac65f384987f9678$export$e2ac8467edb96a95 = {
    name: 'itam',
    path: '/jira/itam/:practice',
    exact: true
};

});

parcelRegister("5wmtX", function(module, exports) {
$parcel$export(module.exports, "itamEntryPoint", () => $7663378d5c325713$export$17c57c041e4ba05e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $72OrN = parcelRequire("72OrN");

var $1lk5l = parcelRequire("1lk5l");

var $gn5aI = parcelRequire("gn5aI");

var $iDyWS = parcelRequire("iDyWS");

var $4yClM = parcelRequire("4yClM");

var $aj5dA = parcelRequire("aj5dA");

var $fiVog = parcelRequire("fiVog");

var $7NTte = parcelRequire("7NTte");

const $7663378d5c325713$export$17c57c041e4ba05e = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aDeiq")), {
        moduleId: "398255d9",
        moduleName: "ItamPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { query: query } })=>{
        const { tab: tab } = query;
        if (tab === 'hardware') return {
            entryPoints: {
                assetsEntryPoint: {
                    entryPoint: (0, $gn5aI.assetsEntryPoint)
                }
            }
        };
        if (tab === 'models') return {
            entryPoints: {
                assetModelsEntryPoint: {
                    entryPoint: (0, $iDyWS.assetModelsEntryPoint)
                }
            }
        };
        if (tab === 'stockrooms') return {
            entryPoints: {
                stockroomsEntryPoint: {
                    entryPoint: (0, $4yClM.stockroomsEntryPoint)
                }
            }
        };
        if (tab === 'work') return {
            entryPoints: {
                workEntryPoint: {
                    entryPoint: (0, $aj5dA.workItemsEntryPoint)
                }
            }
        };
        if (tab === 'dashboard') return {
            entryPoints: {
                dashboardPanelEntryPoint: {
                    entryPoint: (0, $72OrN.dashboardPanelEntryPoint)
                }
            }
        };
        // Overview tab (and default): preload overview entry point
        return {
            entryPoints: {
                overviewEntryPoint: {
                    entryPoint: (0, $1lk5l.overviewEntryPoint)
                }
            }
        };
    }
});

});
parcelRegister("72OrN", function(module, exports) {
$parcel$export(module.exports, "dashboardPanelEntryPoint", () => $48cf4adc891d4fb2$export$38f0e516dd4dfa17);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $fiVog = parcelRequire("fiVog");

var $7NTte = parcelRequire("7NTte");

const $48cf4adc891d4fb2$export$38f0e516dd4dfa17 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("27lqR")), {
        moduleId: "abf47052",
        moduleName: "DashboardPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("27lqR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9A5Lc").then(()=>parcelRequire('93G91'));

});


parcelRegister("1lk5l", function(module, exports) {
$parcel$export(module.exports, "overviewEntryPoint", () => $3bed60acb3b04977$export$ea1cd83f1c23c2f2);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $3bed60acb3b04977$export$ea1cd83f1c23c2f2 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("flOUT")), {
        moduleId: "f7bf41fb",
        moduleName: "OverviewEntryRoot",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("flOUT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("gCScl"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("6DC7P")
]).then(()=>parcelRequire('3AOxs'));

});


parcelRegister("gn5aI", function(module, exports) {
$parcel$export(module.exports, "assetsEntryPoint", () => $3fe99a2f2904b4a4$export$f37ce7f247707a64);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $3fe99a2f2904b4a4$export$f37ce7f247707a64 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6bccZ")), {
        moduleId: "28328b89",
        moduleName: "HamAssetsMain",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6bccZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("3Kkj5")
]).then(()=>parcelRequire('82LMD'));

});


parcelRegister("iDyWS", function(module, exports) {
$parcel$export(module.exports, "assetModelsEntryPoint", () => $d5411f6657b30035$export$5a56957cae517e68);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $d5411f6657b30035$export$5a56957cae517e68 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8fQKS")), {
        moduleId: "f9e75889",
        moduleName: "HamAssetModelsMain",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("8fQKS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("8asLj")
]).then(()=>parcelRequire('2OiRH'));

});


parcelRegister("4yClM", function(module, exports) {
$parcel$export(module.exports, "stockroomsEntryPoint", () => $edd80aca94b7d22d$export$eb2328f5dd07785c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $edd80aca94b7d22d$export$eb2328f5dd07785c = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6uohd")), {
        moduleId: "61304106",
        moduleName: "HamStockroomsMain",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("6uohd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("6h3Lx")
]).then(()=>parcelRequire('jlCeP'));

});


parcelRegister("aj5dA", function(module, exports) {
$parcel$export(module.exports, "workItemsEntryPoint", () => $9d8e7305c97926a8$export$a5f157d401b3935b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $9d8e7305c97926a8$export$a5f157d401b3935b = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("1nfTj")), {
        moduleId: "2946816e",
        moduleName: "HamWorkItems",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("1nfTj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h9qAn").then(()=>parcelRequire('jhvhr'));

});


parcelRegister("aDeiq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("7ZAxq")
]).then(()=>parcelRequire('2pG6X'));

});


parcelRegister("8rtFO", function(module, exports) {
$parcel$export(module.exports, "hamViewsResource", () => $7584355813ece031$export$9ab4e1efe39454c2);

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $7584355813ece031$var$WORKSPACE_LIST_URL = '/rest/servicedesk/cmdb/latest/workspace';
async function $7584355813ece031$var$fetchInsightWorkspaceId() {
    try {
        const response = await (0, $h2wCv.performGetRequest)($7584355813ece031$var$WORKSPACE_LIST_URL);
        const id = response.results?.[0]?.id;
        return id ?? null;
    } catch  {
        return null;
    }
}
const $7584355813ece031$export$7316b2be97733ca2 = 'ITAM_HAM_DASHBOARD_VIEWS';
const $7584355813ece031$export$9ab4e1efe39454c2 = (0, $7edbf.createResource)({
    type: $7584355813ece031$export$7316b2be97733ca2,
    getKey: ({ match: match })=>{
        const practice = match.params.practice ?? '';
        return `${$7584355813ece031$export$7316b2be97733ca2}_${practice}`;
    },
    getData: async (_routerContext, _customContext)=>{
        const workspaceId = await $7584355813ece031$var$fetchInsightWorkspaceId();
        if (workspaceId == null) throw new Error('Workspace ID not available');
        return (0, $h2wCv.performGetRequest)(`/gateway/api/jsm/reporting/assets/workspace/${workspaceId}/views`);
    },
    maxAge: 300000
});

});

const $e8331ef75a276309$export$97144bc9cbbc1d5f = 'ITAM';


parcelRegister("cbPm4", function(module, exports) {
$parcel$export(module.exports, "itamSettingsRouteEntry", () => $b506d5bed87adb7a$export$b8a9249a12523f92);

var $dAhPw = parcelRequire("dAhPw");

var $3F5k4 = parcelRequire("3F5k4");



var $iSoIx = parcelRequire("iSoIx");

var $c4tGG = parcelRequire("c4tGG");

var $eEBcy = parcelRequire("eEBcy");

var $8HUuJ = parcelRequire("8HUuJ");

var $8ycTI = parcelRequire("8ycTI");

var $fdS54 = parcelRequire("fdS54");

var $74h93 = parcelRequire("74h93");

var $dUAVJ = parcelRequire("dUAVJ");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");
const $b506d5bed87adb7a$var$itamSettingsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $3F5k4.itamSettingsEntryPoint)
});
const $b506d5bed87adb7a$export$b8a9249a12523f92 = (0, $fdS54.createEntry)((0, $dAhPw.itamSettingsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.rightSidebarsLayout),
        navigation: {
            menuId: (0, $e8331ef75a276309$export$97144bc9cbbc1d5f),
            sidebarId: (0, $326b5a4f81d4f584$export$b257d790d85197b2)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $8ycTI.workspaceResource),
            (0, $c4tGG.verticalInstantiationResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('itam_ftw'), (0, $eEBcy.avsWorkspaceResource))
        ],
        entryPoint () {
            return (0, $i860n.fg)('itam_ftw') ? $b506d5bed87adb7a$var$itamSettingsPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dAhPw", function(module, exports) {
$parcel$export(module.exports, "itamSettingsRoute", () => $68bf15447782ae4a$export$4a92b404754514d9);
const $68bf15447782ae4a$export$4a92b404754514d9 = {
    name: 'itam-settings',
    path: '/jira/itam/:practice/settings/:menu_item?',
    exact: true,
    query: [
        'role?'
    ]
};

});

parcelRegister("3F5k4", function(module, exports) {
$parcel$export(module.exports, "itamSettingsEntryPoint", () => $f710c8e228dcc0cb$export$bf3fa357356f0eb5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $ayEeO = parcelRequire("ayEeO");

var $j8ow7 = parcelRequire("j8ow7");

var $3Biaq = parcelRequire("3Biaq");

var $kprIH = parcelRequire("kprIH");

var $6BdjV = parcelRequire("6BdjV");

var $63Ve8 = parcelRequire("63Ve8");

var $i860n = parcelRequire("i860n");

var $fiVog = parcelRequire("fiVog");

var $7NTte = parcelRequire("7NTte");
/**
 * Practice -> menu item -> entry point mapping.
 * This map is the single source of truth within this file for route validation:
 * a practice is valid if it's a key here, and a menu item is valid if it's
 * a key under its practice.
 *
 * Canonical constant definitions live in
 * @jira/itam__settings/src/itamSettingsConstants.tsx.
 */ // oxlint-disable-next-line typescript/no-explicit-any
const $f710c8e228dcc0cb$var$getPracticeEntryPoints = ()=>({
        ham: {
            hardware: (0, $3Biaq.hardwareSettingsEntryPoint),
            ...(0, $i860n.fg)('enable_disable_hardware') ? {
                disable: (0, $j8ow7.disableHardwareEntryPoint)
            } : {},
            'request-types': (0, $kprIH.requestTypesEntryPoint),
            automations: (0, $ayEeO.automationSettingsEntryPoint),
            'roles-and-access': (0, $6BdjV.rolesAndAccessEntryPoint),
            'rovo-insights': (0, $63Ve8.rovoInsightsEntryPoint)
        }
    });

const $f710c8e228dcc0cb$export$bf3fa357356f0eb5 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("lqDWz")), {
        moduleId: "f8b59151",
        moduleName: "ItamSettingsPage",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>{
        const { context: { match: { params: routeParams } } } = params;
        const practice = routeParams?.practice;
        const menuItem = routeParams?.menu_item;
        // Resolve to valid practice, defaulting to 'ham'
        const practiceEntryPoints = $f710c8e228dcc0cb$var$getPracticeEntryPoints();
        const resolvedPractice = practice && practice in practiceEntryPoints ? practice : 'ham';
        const practiceMap = practiceEntryPoints[resolvedPractice];
        // Resolve to valid menu item, defaulting to first item for the practice
        const firstMenuItem = Object.keys(practiceMap)[0];
        const resolvedMenuItem = menuItem && menuItem in practiceMap ? menuItem : firstMenuItem;
        const entryPoint = practiceMap[resolvedMenuItem];
        const entryPointKey = 'settingsContent';
        const entryPointParams = entryPoint === (0, $3Biaq.hardwareSettingsEntryPoint) || entryPoint === (0, $6BdjV.rolesAndAccessEntryPoint) ? params : {};
        return {
            entryPoints: {
                [entryPointKey]: {
                    entryPoint: entryPoint,
                    entryPointParams: entryPointParams
                }
            },
            extraProps: {
                practice: resolvedPractice,
                menuItem: resolvedMenuItem,
                needsRedirect: practice !== resolvedPractice || menuItem !== resolvedMenuItem,
                validMenuItems: Object.keys(practiceMap),
                defaultMenuItem: firstMenuItem
            }
        };
    }
});

});
parcelRegister("ayEeO", function(module, exports) {
$parcel$export(module.exports, "automationSettingsEntryPoint", () => $a4f3df630c705720$export$5c8b85b2c0e0dff8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $a4f3df630c705720$export$5c8b85b2c0e0dff8 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("5mSFg")), {
        moduleId: "8886ccfb",
        moduleName: "AutomationSettings",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("5mSFg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lK5Nz").then(()=>parcelRequire('dWnvh'));

});


parcelRegister("j8ow7", function(module, exports) {
$parcel$export(module.exports, "disableHardwareEntryPoint", () => $9a8b30e2aebad722$export$7cc214985772544c);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $9a8b30e2aebad722$export$7cc214985772544c = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("i6ETh")), {
        moduleId: "01d071bb",
        moduleName: "DisableHardware",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("i6ETh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dV9Rt").then(()=>parcelRequire('jgc3R'));

});


parcelRegister("3Biaq", function(module, exports) {
$parcel$export(module.exports, "hardwareSettingsEntryPoint", () => $e52ad36098011344$export$ed94695f628a4291);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $11YiD = parcelRequire("11YiD");

var $ixbnL = parcelRequire("ixbnL");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");
const $e52ad36098011344$var$DEFAULT_TAB = 'deprecations';
const $e52ad36098011344$var$TAB_ENTRYPOINT_MAP = {
    hardware: {},
    deprecations: {
        deprecationsEntryPoint: {
            entryPoint: (0, $11YiD.deprecationsEntryPoint),
            entryPointParams: {}
        }
    },
    'stock-rules': {
        stockRulesEntryPoint: {
            entryPoint: (0, $ixbnL.stockRulesEntryPoint),
            entryPointParams: {}
        }
    }
};

const $e52ad36098011344$export$ed94695f628a4291 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("yBahb")), {
        moduleId: "d899bd19",
        moduleName: "HardwareSettings",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>{
        const tab = params?.context?.query?.tab ?? $e52ad36098011344$var$DEFAULT_TAB;
        const activeTab = tab in $e52ad36098011344$var$TAB_ENTRYPOINT_MAP ? tab : $e52ad36098011344$var$DEFAULT_TAB;
        return {
            entryPoints: $e52ad36098011344$var$TAB_ENTRYPOINT_MAP[activeTab]
        };
    }
});

});
parcelRegister("11YiD", function(module, exports) {
$parcel$export(module.exports, "deprecationsEntryPoint", () => $f7c96c2b46c4c699$export$bd53c3cc4d7be4a9);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $f7c96c2b46c4c699$export$bd53c3cc4d7be4a9 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("jygND")), {
        moduleId: "f629c88b",
        moduleName: "DeprecationsContent",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("jygND", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("vOfwJ").then(()=>parcelRequire('6hpXU'));

});


parcelRegister("ixbnL", function(module, exports) {
$parcel$export(module.exports, "stockRulesEntryPoint", () => $a0e17c659973c403$export$217ad49be1961af);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $a0e17c659973c403$export$217ad49be1961af = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("k2k1c")), {
        moduleId: "fc795069",
        moduleName: "StockRules",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("k2k1c", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("1ExZp")
]).then(()=>parcelRequire('inLFW'));

});


parcelRegister("yBahb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jfWgn").then(()=>parcelRequire('9cm4F'));

});


parcelRegister("kprIH", function(module, exports) {
$parcel$export(module.exports, "requestTypesEntryPoint", () => $4b43836cc60c2a01$export$15a53d7174acbe4c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $4b43836cc60c2a01$export$15a53d7174acbe4c = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("htwQx")), {
        moduleId: "a713ab87",
        moduleName: "RequestTypes",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("htwQx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7liE8").then(()=>parcelRequire('bihGW'));

});


parcelRegister("6BdjV", function(module, exports) {
$parcel$export(module.exports, "rolesAndAccessEntryPoint", () => $2480a41f7304c2da$export$f4738d78857ca3b1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $7POoT = parcelRequire("7POoT");
// Identity role ARIs are inlined here so the entry-point chunk does not pull in
// `RolesAndAccess.types.tsx`. Keep them in sync with `HAM_ROLE_IDS`.
const $2480a41f7304c2da$var$HAM_ROLE_ID_BY_TYPE = {
    HAM_ADMIN: 'ari:cloud:assets-vertical::role/ham/admin',
    HAM_USER: 'ari:cloud:assets-vertical::role/ham/user'
};
const $2480a41f7304c2da$var$ROLE_FILTER_QUERY_PARAM = 'role';
function $2480a41f7304c2da$var$parseRoleFilterQueryParamValue(value) {
    switch(value){
        case 'admin':
            return 'HAM_ADMIN';
        case 'user':
            return 'HAM_USER';
        default:
            return undefined;
    }
}
function $2480a41f7304c2da$var$getInitialRoleId(roleQueryParam) {
    const selectedRole = $2480a41f7304c2da$var$parseRoleFilterQueryParamValue(roleQueryParam) ?? 'HAM_ADMIN';
    return $2480a41f7304c2da$var$HAM_ROLE_ID_BY_TYPE[selectedRole];
}

const $2480a41f7304c2da$export$f4738d78857ca3b1 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("3TSJa")), {
        moduleId: "963098fb",
        moduleName: "RolesAndAccess",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                rolesAndAccessQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $7POoT.default,
                    variables: {
                        cloudId: cloudId,
                        verticalType: 'HAM',
                        roleIds: [
                            $2480a41f7304c2da$var$getInitialRoleId(context.query[$2480a41f7304c2da$var$ROLE_FILTER_QUERY_PARAM])
                        ]
                    }
                }
            },
            extraProps: {}
        })
});

});
parcelRegister("7POoT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a12772893bab3936$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2811fbaa5c0779cdea2d13b188a751e9>>
 * @relayHash d8ae146d401c8c2c5b74a1c1ee0482eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d973acede3abccab1537a56516ed3df2dda57816f50c4fe9675611026747d45f
const $a12772893bab3936$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "roleIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "verticalType"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "verticalType",
        "variableName": "verticalType"
    }, v7 = [
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v5 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "roleIds",
            "variableName": "roleIds"
        },
        v6 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RolesAndAccessQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "RolesAndAccess_rolesQuery"
                },
                {
                    "args": v8 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "RolesAndAccess_assignmentsQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RolesAndAccessQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "assetsVertical_verticalRoles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "AssetsVerticalRole",
                                    "kind": "LinkedField",
                                    "name": "roles",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "roleType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "roleId"
                                        },
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "AssetsVerticalRolesSuccess"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                },
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "AssetsVerticalRoleAssignmentConnection",
                    "kind": "LinkedField",
                    "name": "assetsVertical_verticalRoleAssignments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AssetsVerticalRoleAssignmentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AssetsVerticalRoleAssignment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "principal",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "email"
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "AssetsVerticalUserPrincipal"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "IdentityGroup",
                                                            "kind": "LinkedField",
                                                            "name": "group",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "AssetsVerticalGroupPrincipal"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "roleIds"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v8 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "verticalType",
                        "roleIds"
                    ],
                    "handle": "connection",
                    "key": "RolesAndAccess_assetsVertical_verticalRoleAssignments",
                    "kind": "LinkedHandle",
                    "name": "assetsVertical_verticalRoleAssignments"
                }
            ]
        },
        "params": {
            "id": "d973acede3abccab1537a56516ed3df2dda57816f50c4fe9675611026747d45f",
            "metadata": {},
            "name": "RolesAndAccessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a12772893bab3936$var$node.hash = "e87225f7532b51838667fadabee1ec4b";
var $a12772893bab3936$export$2e2bcd8739ae039 = $a12772893bab3936$var$node;

});

parcelRegister("3TSJa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2PMja").then(()=>parcelRequire('7oBXY'));

});


parcelRegister("63Ve8", function(module, exports) {
$parcel$export(module.exports, "rovoInsightsEntryPoint", () => $e1497c4e66ed145c$export$a4cdcbc63a9f4411);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $e1497c4e66ed145c$export$a4cdcbc63a9f4411 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("lJMeN")), {
        moduleId: "f2057d6b",
        moduleName: "RovoInsights",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("lJMeN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jtR2H").then(()=>parcelRequire('71zS2'));

});


parcelRegister("lqDWz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4YybW").then(()=>parcelRequire('45rgO'));

});


const $326b5a4f81d4f584$export$b257d790d85197b2 = 'ITAM_SETTINGS';


parcelRegister("6IdT3", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessAgentContextRouteEntry", () => $ed59e99e075ed48d$export$94b9c81cc3e1bf6e);


var $61eKY = parcelRequire("61eKY");

var $dizxY = parcelRequire("dizxY");

var $fdS54 = parcelRequire("fdS54");

var $4iKrU = parcelRequire("4iKrU");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $45gUU = parcelRequire("45gUU");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $jEYuY = parcelRequire("jEYuY");

var $75Njg = parcelRequire("75Njg");

var $dTa0V = parcelRequire("dTa0V");

var $2700E = parcelRequire("2700E");

var $iSoIx = parcelRequire("iSoIx");

var $3KSG6 = parcelRequire("3KSG6");
const $ed59e99e075ed48d$var$jiraBusinessAgentContextEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: $dizxY.AgentContextEntryPoint,
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $ed59e99e075ed48d$export$94b9c81cc3e1bf6e = (0, $fdS54.createEntry)((0, $45gUU.jiraBusinessAgentContextRoute), ()=>({
        group: 'classic-business',
        perfMetricKey: 'business.agent-context',
        layout: (0, $4iKrU.businessProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        entryPoint () {
            return (0, $2700E.expValEquals)('jira-agent-context-experiment', 'isEnabled', true, false) ? $ed59e99e075ed48d$var$jiraBusinessAgentContextEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $gZWlI.projectThemeResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        skeleton: (0, $61eKY.AgentContextLoadingSkeleton),
        ufoName: 'business-agent-context',
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        supportsProjectTheme: 'full'
    }));

});
parcelRegister("61eKY", function(module, exports) {
$parcel$export(module.exports, "AgentContextLoadingSkeleton", () => $bc9a71d71799ce9e$export$3d17ce8bf175b0d6);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $2XXtG = parcelRequire("2XXtG");

var $abhF2 = parcelRequire("abhF2");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $bc9a71d71799ce9e$var$styles = {
    container: "_vchhusvi _4t3i1osq _1tkeidpf _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1bsb1osq"
};
const $bc9a71d71799ce9e$var$loadingLabel = (0, $7eNDO.defineMessage)({
    id: "spa-apps-space-agent-context.loading-skeleton.label.non-final",
    defaultMessage: "Loading agent context"
});
const $bc9a71d71799ce9e$export$3d17ce8bf175b0d6 = ()=>{
    const $ = (0, $e7boj.c)(4);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($bc9a71d71799ce9e$var$loadingLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
            xcss: $bc9a71d71799ce9e$var$styles.container,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
            size: "large",
            label: t0
        }));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
$bc9a71d71799ce9e$export$3d17ce8bf175b0d6.displayName = "AgentContextLoadingSkeleton";

});

parcelRegister("dizxY", function(module, exports) {
$parcel$export(module.exports, "AgentContextEntryPoint", () => $c5731d1cf934f441$export$10a3ebd100e8fa8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $diDmE = parcelRequire("diDmE");

const $c5731d1cf934f441$export$10a3ebd100e8fa8 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("aq1JX")), {
        moduleId: "69fb7ecb",
        moduleName: "AgentContextApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey ?? '';
        return {
            queries: {
                agentContextQuery: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $diDmE.default,
                    variables: {
                        cloudId: cloudId,
                        input: {
                            projectByKey: {
                                cloudId: cloudId,
                                projectKey: projectKey
                            }
                        },
                        first: 50,
                        after: null,
                        filter: null,
                        isNewAgentContext: (0, $i860n.fg)('jira_agent_context_new_ui')
                    }
                }
            }
        };
    }
});

});
parcelRegister("diDmE", function(module, exports) {
$parcel$export(module.exports, "default", () => $974decd26467aea3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7c319f65829e0ddd5b1a8a0043d31f51>>
 * @relayHash 42fd7a181a3572c512e00d855d84ccd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 05257f00082c1505d2e9fd0b704170273715da91ce305df6773e3e2ff5cb28f6
const $974decd26467aea3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "05257f00082c1505d2e9fd0b704170273715da91ce305df6773e3e2ff5cb28f6",
        "metadata": {},
        "name": "AgentContextQuery",
        "operationKind": "query",
        "text": null
    }
};
var $974decd26467aea3$export$2e2bcd8739ae039 = $974decd26467aea3$var$node;

});

parcelRegister("aq1JX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("lzDzR")
]).then(()=>parcelRequire('clkMF'));

});


parcelRegister("45gUU", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessAgentContextRoute", () => $bf4c9ae873d18a7f$export$9f8496d64c35f61b);
const $bf4c9ae873d18a7f$export$9f8496d64c35f61b = {
    name: 'business-agent-context',
    exact: true,
    path: '/jira/core/projects/:projectKey/agent-context'
};

});


parcelRegister("3mG0v", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessAttachmentsRouteEntry", () => $5e5d5311089bdc7d$export$62c45d8ff658b6c2);

var $hi6Of = parcelRequire("hi6Of");


var $1L2Hl = parcelRequire("1L2Hl");

var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $h5Lf7 = parcelRequire("h5Lf7");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $5e5d5311089bdc7d$var$attachmentsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1L2Hl.attachmentsEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $5e5d5311089bdc7d$export$62c45d8ff658b6c2 = (0, $fdS54.createEntry)((0, $h5Lf7.jiraBusinessAttachmentsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.attachments-view',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        entryPoint: ()=>$5e5d5311089bdc7d$var$attachmentsPageEntryPoint,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1L2Hl", function(module, exports) {
$parcel$export(module.exports, "attachmentsEntryPoint", () => $6900202e854fa45a$export$d94bafd9d893ec98);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $1bvU3 = parcelRequire("1bvU3");

const $6900202e854fa45a$export$d94bafd9d893ec98 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("lFJzP")), {
        moduleId: "b6436d1c",
        moduleName: "JiraBusinessAttachmentsAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        // This entry point should only load in this route
        // once overview is supported by backend, we should have a different entry point for it
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                jwmAttachmentsQuery: {
                    parameters: $1bvU3.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        projectKeys: [
                            projectKey
                        ],
                        filters: {
                            fileName: '',
                            authorIds: [],
                            mimeTypes: [],
                            dateRange: {
                                before: undefined,
                                after: undefined
                            }
                        },
                        durationInSeconds: 900,
                        maxTokenLength: 65534,
                        attachmentCount: 100
                    },
                    options: {
                        // oxlint-disable-next-line typescript/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("1bvU3", function(module, exports) {
$parcel$export(module.exports, "default", () => $21563e8eb7168e76$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fe3b8fe5334ec13d7893a03f428a8d42>>
 * @relayHash a84fe10735a92a53e7c78b12a12494ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f3b57e29c1ce294be2ba0fadd405512bbc8cbe2c9fd26fea591a6b96106ec095

var $1F2RS = parcelRequire("1F2RS");
const $21563e8eb7168e76$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f3b57e29c1ce294be2ba0fadd405512bbc8cbe2c9fd26fea591a6b96106ec095",
        "metadata": {},
        "name": "JiraBusinessAttachmentsAppMemoQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": (0, $1F2RS.default)
        }
    }
};
var $21563e8eb7168e76$export$2e2bcd8739ae039 = $21563e8eb7168e76$var$node;

});

parcelRegister("lFJzP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("htxh0")
]).then(()=>parcelRequire('aupWU'));

});


parcelRegister("h5Lf7", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessAttachmentsRoute", () => $1aa49e231672e838$export$81237c0b791e592e);
const $1aa49e231672e838$export$81237c0b791e592e = {
    name: 'classic-business-attachments',
    path: '/jira/core/projects/:projectKey/attachments'
};

});


parcelRegister("2yyrl", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessAverageIssueAgeRouteEntry", () => $8d88a526d01965d7$export$629e778ce54886c);


var $9v3JR = parcelRequire("9v3JR");

var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $gGXLM = parcelRequire("gGXLM");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $8d88a526d01965d7$var$averageIssueAgePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9v3JR.averageIssueAgeReportEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $8d88a526d01965d7$export$629e778ce54886c = (0, $fdS54.createEntry)((0, $gGXLM.jiraBusinessAverageIssueAgeRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-average-issue-age',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>$8d88a526d01965d7$var$averageIssueAgePageEntrypoint,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gGXLM", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessAverageIssueAgeRoute", () => $ee9843389bf397fd$export$27bdccc594ef408a);
const $ee9843389bf397fd$export$27bdccc594ef408a = {
    name: 'classic-business-reports-average-issue-age',
    path: '/jira/core/projects/:projectKey/reports/average-age'
};

});


parcelRegister("5iCME", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRouteEntry", () => $5dc331a95fd6f530$export$4622ad4c7294f3a7);

var $e3uiC = parcelRequire("e3uiC");

var $byMD7 = parcelRequire("byMD7");

var $9EWfZ = parcelRequire("9EWfZ");


var $fdS54 = parcelRequire("fdS54");

var $gi9o8 = parcelRequire("gi9o8");

var $dTa0V = parcelRequire("dTa0V");

var $dH7X1 = parcelRequire("dH7X1");
const $5dc331a95fd6f530$var$boardEmbedPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $e3uiC.boardEntryPoint)
});
const $5dc331a95fd6f530$export$4622ad4c7294f3a7 = (0, $fdS54.createEntry)((0, $gi9o8.jiraBusinessBoardCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: (0, $dH7X1.jiraBusinessBoardResources)(),
        entryPoint: ()=>$5dc331a95fd6f530$var$boardEmbedPageEntryPoint,
        supportsProjectTheme: 'full',
        meta: {
            capability: (0, $0ce01f968965dadd$export$f154708d773ba5a0)
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e3uiC", function(module, exports) {
$parcel$export(module.exports, "boardEntryPoint", () => $fb03ac3bab777f87$export$937ca5a4cdc1a12e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $esYAS = parcelRequire("esYAS");
const $fb03ac3bab777f87$var$getViewQueryAndScope = (cloudId, projectKey, boardIdParam, itemId)=>{
    const encodedItemId = itemId ? `board/${itemId}` : 'board';
    if (boardIdParam != null) return {
        viewQueryInput: {
            boardIdAndItemQuery: {
                cloudId: cloudId,
                boardId: Number(boardIdParam),
                itemId: encodedItemId
            }
        },
        filterScope: {
            board: {
                boardId: Number(boardIdParam)
            }
        }
    };
    return {
        viewQueryInput: {
            projectKeyAndItemQuery: {
                cloudId: cloudId,
                projectKey: projectKey,
                itemId: encodedItemId
            }
        },
        filterScope: {
            project: {
                projectKey: projectKey
            }
        }
    };
};

const $fb03ac3bab777f87$export$937ca5a4cdc1a12e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5y05I")), {
        moduleId: "1efc4fed",
        moduleName: "JiraBoard",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKeyParam = context.match.params.projectKey;
        const boardIdParam = context.match.params.boardId;
        const itemId = context.match.params.itemId ?? '';
        const routeName = context.route.name;
        // Either projectKey or boardId must be present
        if (projectKeyParam == null && boardIdParam == null) throw new Error('Project key or board ID is required');
        const withProject = projectKeyParam != null;
        const projectKey = projectKeyParam ?? '';
        let filter;
        let groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        const currentLocation = typeof window !== 'undefined' ? window.location : null;
        if (currentLocation != null && (context == null || currentLocation.pathname === context?.match.url)) {
            const urlSearchParams = new URLSearchParams(currentLocation.search);
            filter = urlSearchParams.get('filter') ?? undefined;
            groupBy = urlSearchParams.get('groupBy') ?? undefined;
        } else if (context) {
            filter = context.query?.filter;
            groupBy = context.query?.groupBy;
        }
        const { viewQueryInput: viewQueryInput, filterScope: filterScope } = $fb03ac3bab777f87$var$getViewQueryAndScope(cloudId, projectKey, boardIdParam, itemId);
        return {
            queries: {
                boardQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $esYAS.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        withProject: withProject,
                        withFilterRefinement: routeName === 'classic-business-board' || routeName === 'classic-business-board-embed' || routeName === 'classic-business-board-custom-embed' ? (0, $i860n.fg)('board_harmonisation_m2_filter_refinement') : true,
                        viewQueryInput: viewQueryInput,
                        settings: {
                            filterJql: filter,
                            groupBy: groupBy,
                            swimlanesSupported: (0, $2700E.expValEquals)('board_harmonisation_m3_swimlanes', 'isEnabled', true, false)
                        },
                        filterScope: filterScope
                    }
                }
            }
        };
    }
});

});
parcelRegister("esYAS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d28459b7c322858d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8215703f1ab85811e4e5821603830932>>
 * @relayHash 224e8ab30460c1a736ebe973745d3db2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9684d768c156f42ad8980c04cd1fa8ab2813822ae9c4e8a79767a4f23f2b3dab

var $dVRwd = parcelRequire("dVRwd");

var $1wS4c = parcelRequire("1wS4c");

var $gMIJh = parcelRequire("gMIJh");

var $hR9LX = parcelRequire("hR9LX");

var $jAJnj = parcelRequire("jAJnj");

var $3DPDq = parcelRequire("3DPDq");

var $d3ok7 = parcelRequire("d3ok7");

var $3PDLp = parcelRequire("3PDLp");

var $486vS = parcelRequire("486vS");
const $d28459b7c322858d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9684d768c156f42ad8980c04cd1fa8ab2813822ae9c4e8a79767a4f23f2b3dab",
        "metadata": {},
        "name": "JiraBoard_JiraBoardQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraboard__relayproviderssrcJfindMatureExampleProjecttsx": (0, $d3ok7.default),
            "__relay_internal__pv__jiraboard__relayproviderssrcSwimlanesChangeboardingtsx": (0, $3PDLp.default),
            "__relay_internal__pv__jiraboard__relayproviderssrcTmpHarmonisationOnboardingtsx": (0, $486vS.default),
            "__relay_internal__pv__jiraboard__relayproviderssrcAutoManagedSprintsForHarmonisedBoardtsx": (0, $gMIJh.default),
            "__relay_internal__pv__jiraboard__relayproviderssrcBoardHarmonisationMilestone3tsx": (0, $hR9LX.default),
            "__relay_internal__pv__jiraboard__relayproviderssrcAssignAgentsInlineM2TechnicalRelayprovidertsx": (0, $dVRwd.default),
            "__relay_internal__pv__jiraboard__relayproviderssrcAssignMultiAgentsBoardM2DndRelayProvidertsx": (0, $1wS4c.default),
            "__relay_internal__pv__jiraboard__relayproviderssrcBoardJISDevSummaryFieldtsx": (0, $3DPDq.default),
            "__relay_internal__pv__jiraboard__relayproviderssrcBoardInlineAssignAgenttsx": (0, $jAJnj.default)
        }
    }
};
var $d28459b7c322858d$export$2e2bcd8739ae039 = $d28459b7c322858d$var$node;

});
parcelRegister("dVRwd", function(module, exports) {
$parcel$export(module.exports, "default", () => $200625badc2428e2$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $200625badc2428e2$var$AssignAgentsInlineM2TechnicalRelayprovider = {
    get () {
        return (0, $i860n.fg)('assign-agents-inline_m2_technical');
    }
};
var $200625badc2428e2$export$2e2bcd8739ae039 = $200625badc2428e2$var$AssignAgentsInlineM2TechnicalRelayprovider;

});

parcelRegister("1wS4c", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a17d4df79b8cedc$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $6a17d4df79b8cedc$var$AssignMultiAgentsBoardM2DndRelayProvider = {
    get () {
        return (0, $2700E.expVal)('assign-multi-agents-board-m2-dnd-technical-gate', 'isEnabled', false);
    }
};
var $6a17d4df79b8cedc$export$2e2bcd8739ae039 = $6a17d4df79b8cedc$var$AssignMultiAgentsBoardM2DndRelayProvider;

});

parcelRegister("gMIJh", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc41e4ee0b32ce0b$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $fc41e4ee0b32ce0b$var$AutoManagedSprintsForHarmonisedBoard = {
    get () {
        return (0, $i860n.fg)('auto-managed_sprints_for_tmp_harmonised_board');
    }
};
var $fc41e4ee0b32ce0b$export$2e2bcd8739ae039 = $fc41e4ee0b32ce0b$var$AutoManagedSprintsForHarmonisedBoard;

});

parcelRegister("hR9LX", function(module, exports) {
$parcel$export(module.exports, "default", () => $018ea5ec086f4c4e$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $018ea5ec086f4c4e$var$BoardHarmonisationMilestone3 = {
    get () {
        return (0, $2700E.expVal)('board_harmonisation_m3_swimlanes', 'isEnabled', false);
    }
};
var // eslint-disable-next-line import/no-default-export
$018ea5ec086f4c4e$export$2e2bcd8739ae039 = $018ea5ec086f4c4e$var$BoardHarmonisationMilestone3;

});

parcelRegister("jAJnj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0e7211ca63459c8$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $f0e7211ca63459c8$var$BoardInlineAssignAgent = {
    get () {
        return (0, $2700E.expVal)('inline_assign_agent_in_board', 'isEnabled', false);
    }
};
var $f0e7211ca63459c8$export$2e2bcd8739ae039 = $f0e7211ca63459c8$var$BoardInlineAssignAgent;

});

parcelRegister("3DPDq", function(module, exports) {
$parcel$export(module.exports, "default", () => $780dbc65152a913f$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $780dbc65152a913f$var$BoardJISDevSummaryField = {
    get () {
        return (0, $i860n.fg)('dis-14_use_jis_dev_summary');
    }
};
var // eslint-disable-next-line import/no-default-export
$780dbc65152a913f$export$2e2bcd8739ae039 = $780dbc65152a913f$var$BoardJISDevSummaryField;

});

parcelRegister("d3ok7", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd1a5537a8058ec2$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $fd1a5537a8058ec2$var$JfindMatureExampleProject = {
    get () {
        return (0, $i860n.fg)('jfind-gups-vc90-testing-gate');
    }
};
var // eslint-disable-next-line import/no-default-export
$fd1a5537a8058ec2$export$2e2bcd8739ae039 = $fd1a5537a8058ec2$var$JfindMatureExampleProject;

});

parcelRegister("3PDLp", function(module, exports) {
$parcel$export(module.exports, "default", () => $da11f64b432ac518$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");
const $da11f64b432ac518$var$SwimlanesChangeboarding = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $2700E.expVal)('board_harmonisation_m3_swimlanes', 'isEnabled', false) && (0, $i860n.fg)('board_harmonisation_m3_swimlanes_changeboarding'));
    }
};
var // eslint-disable-next-line import/no-default-export
$da11f64b432ac518$export$2e2bcd8739ae039 = $da11f64b432ac518$var$SwimlanesChangeboarding;

});

parcelRegister("486vS", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc7f974e7a273acf$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");
const $cc7f974e7a273acf$var$TmpHarmonisationOnboarding = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $2700E.expVal)('board_harmonisation_software_tmp', 'isEnabled', false) && (0, $i860n.fg)('software-tmp-board-changeboarding'));
    }
};
var $cc7f974e7a273acf$export$2e2bcd8739ae039 = $cc7f974e7a273acf$var$TmpHarmonisationOnboarding;

});


parcelRegister("5y05I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("52sLk")
]).then(()=>parcelRequire('eHrHT'));

});


parcelRegister("gi9o8", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRoute", () => $612af314c2159c35$export$7d977a74e9d9d32b);
const $612af314c2159c35$export$7d977a74e9d9d32b = {
    name: 'classic-business-board-custom-embed',
    path: '/jira/core/projects/:projectKey/board/:itemId/embed',
    exact: true
};

});

parcelRegister("dH7X1", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardResources", () => $38594e59028688af$export$d88dda595be0d0a1);
/* eslint-disable import/order */ // eslint-disable-next-line jira/import/no-restricted-import

var $9T5Cr = parcelRequire("9T5Cr");

var $dUAVJ = parcelRequire("dUAVJ");

var $gZWlI = parcelRequire("gZWlI");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");
const $38594e59028688af$export$d88dda595be0d0a1 = ()=>[
        ...(0, $dUAVJ.getNavigationResources)(),
        (0, $gZWlI.projectThemeResource),
        // delete when cleaning up board_harmonisation_m2_filter_refinement
        (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('board_harmonisation_m2_filter_refinement'), (0, $9T5Cr.fieldsResource))
    ];

});


parcelRegister("7gg2B", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardEmbedRouteEntry", () => $1545d1c8f238c566$export$7a97e5e258f37b2a);

var $e3uiC = parcelRequire("e3uiC");

var $byMD7 = parcelRequire("byMD7");

var $9EWfZ = parcelRequire("9EWfZ");


var $fdS54 = parcelRequire("fdS54");

var $6BuRB = parcelRequire("6BuRB");

var $dTa0V = parcelRequire("dTa0V");

var $dH7X1 = parcelRequire("dH7X1");
const $1545d1c8f238c566$var$boardEmbedPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $e3uiC.boardEntryPoint)
});
const $1545d1c8f238c566$export$7a97e5e258f37b2a = (0, $fdS54.createEntry)((0, $6BuRB.jiraBusinessBoardEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: (0, $dH7X1.jiraBusinessBoardResources)(),
        supportsProjectTheme: 'full',
        entryPoint: ()=>$1545d1c8f238c566$var$boardEmbedPageEntryPoint,
        meta: {
            capability: (0, $0ce01f968965dadd$export$f154708d773ba5a0)
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6BuRB", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardEmbedRoute", () => $ac001ebe3a6cb4e1$export$bd75a810572fe27d);
const $ac001ebe3a6cb4e1$export$bd75a810572fe27d = {
    name: 'classic-business-board-embed',
    path: '/jira/core/projects/:projectKey/board/embed',
    exact: true
};

});


parcelRegister("5w386", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardRouteEntry", () => $c53f03c70098ce79$export$c7fe0dd4417407a0);


var $e3uiC = parcelRequire("e3uiC");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");


var $fQvBx = parcelRequire("fQvBx");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $dH7X1 = parcelRequire("dH7X1");
const $c53f03c70098ce79$var$boardPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $e3uiC.boardEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $c53f03c70098ce79$export$c7fe0dd4417407a0 = (0, $fdS54.createEntry)((0, $fQvBx.jiraBusinessBoardRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: (0, $dH7X1.jiraBusinessBoardResources)(),
        entryPoint: ()=>$c53f03c70098ce79$var$boardPageEntryPoint,
        meta: {
            capability: (0, $0ce01f968965dadd$export$f154708d773ba5a0)
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        isHydrateRootEnabled: true,
        bifrost: {
            bifrostGroup: 'backlog-and-board'
        }
    }));

});
parcelRegister("fQvBx", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardRoute", () => $e795540b142223a0$export$14a5cbbd7e1e2dc2);
const $e795540b142223a0$export$14a5cbbd7e1e2dc2 = {
    name: 'classic-business-board',
    exact: true,
    path: '/jira/core/projects/:projectKey/board/:itemId?'
};

});


parcelRegister("1MRQH", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarCustomEmbedRouteEntry", () => $34952aeb2b3bdaaf$export$2971062de35b0b9e);
/* eslint-disable import/order */ 
var $bMfOT = parcelRequire("bMfOT");

var $byMD7 = parcelRequire("byMD7");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $frzmL = parcelRequire("frzmL");

var $dTa0V = parcelRequire("dTa0V");

var $4B518 = parcelRequire("4B518");
const $34952aeb2b3bdaaf$var$calendarEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $bMfOT.calendarEntryPoint)
});
const $34952aeb2b3bdaaf$export$2971062de35b0b9e = (0, $fdS54.createEntry)((0, $frzmL.jiraBusinessCalendarCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return $34952aeb2b3bdaaf$var$calendarEmbedPageEntrypoint;
        },
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bMfOT", function(module, exports) {
$parcel$export(module.exports, "calendarEntryPoint", () => $46b95ef7aa0ed32e$export$19cf4b398f638dc6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6ySM3 = parcelRequire("6ySM3");

var $cNSxS = parcelRequire("cNSxS");
const $46b95ef7aa0ed32e$var$SETTINGS_STORAGE_KEY = 'calendar:settings:business';
function $46b95ef7aa0ed32e$var$getViewSettings(key) {
    try {
        // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
const $46b95ef7aa0ed32e$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
function $46b95ef7aa0ed32e$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $46b95ef7aa0ed32e$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $46b95ef7aa0ed32e$var$createScope({ context: context }) {
    return {
        type: 'project',
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $46b95ef7aa0ed32e$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $46b95ef7aa0ed32e$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $46b95ef7aa0ed32e$var$toViewRange(mode) {
    switch(mode){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $46b95ef7aa0ed32e$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $46b95ef7aa0ed32e$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $46b95ef7aa0ed32e$var$toMidnightUTCString(selectedDate),
        mode: $46b95ef7aa0ed32e$var$toViewMode(viewRange),
        weekStart: $46b95ef7aa0ed32e$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
/** Extracted from business/shared/simpleSearch */ function $46b95ef7aa0ed32e$var$jqlSearchText(text) {
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const ISSUEKEY_REGEX = '([A-Z][A-Z0-9_]+-\\d+)';
    const issueKeyRegex = new RegExp(`^${ISSUEKEY_REGEX}$`);
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
}
function $46b95ef7aa0ed32e$var$buildIssuesSearchInput(filter = '', text = '', hideDoneItems) {
    const hideDoneItemsQuery = "StatusCategory != 'Complete'";
    const search = $46b95ef7aa0ed32e$var$jqlSearchText(text);
    return {
        additionalFilterQuery: $46b95ef7aa0ed32e$var$and([
            search,
            filter,
            ...hideDoneItems ? [
                hideDoneItemsQuery
            ] : []
        ])
    };
}
function $46b95ef7aa0ed32e$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $46b95ef7aa0ed32e$var$buildJiraCalendarInput({ cloudId: cloudId, projectKey: projectKey, itemId: itemId }) {
    return {
        viewInput: {
            projectKeyAndItemQuery: {
                cloudId: cloudId,
                projectKey: projectKey,
                itemId: itemId
            }
        }
    };
}
function $46b95ef7aa0ed32e$var$buildJiraCalendarViewSettings({ filterJql: filterJql }) {
    return {
        filterJql: filterJql
    };
}

const $46b95ef7aa0ed32e$export$19cf4b398f638dc6 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("haVOg")), {
        moduleId: "4fbdb348",
        moduleName: "JiraBusinessCalendarEntrypoint",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        const scope = $46b95ef7aa0ed32e$var$createScope(entryPointRouteParams);
        const { date: date, filter: filter, hideDone: hideDone, text: text, viewRange: viewRangeQueryParam } = context.query;
        const selectedDate = $46b95ef7aa0ed32e$var$toDate(date);
        const settings = $46b95ef7aa0ed32e$var$getViewSettings($46b95ef7aa0ed32e$var$SETTINGS_STORAGE_KEY);
        const viewRange = $46b95ef7aa0ed32e$var$toViewRange(viewRangeQueryParam ?? settings?.viewRange ?? 'month');
        const hideDoneItems = hideDone ? true : settings?.hideDoneItems ?? false;
        const weekStartsOn = settings?.weekStartsOn ?? 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const itemId = context.match.params.itemId ?? '';
        return {
            queries: {
                calendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $cNSxS.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $6ySM3.default),
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $46b95ef7aa0ed32e$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $46b95ef7aa0ed32e$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: $46b95ef7aa0ed32e$var$buildIssuesSearchInput(filter, text, hideDoneItems),
                        unscheduledIssuesSearchInput: $46b95ef7aa0ed32e$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: {
                            versionStatuses: [
                                'RELEASED',
                                'UNRELEASED'
                            ],
                            includeSharedReleases: true
                        },
                        sprintsSearchInput: null,
                        skipSprintSearch: true,
                        viewId: null,
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: true,
                        skipUserPreferences: false,
                        hasSavedViewCapability: (0, $2700E.expValEquals)('atlas-96240_saved_views_calendar', 'enabled', true, false),
                        ...(0, $i860n.fg)('calendar-filter-persistence') && {
                            jiraCalendarInput: $46b95ef7aa0ed32e$var$buildJiraCalendarInput({
                                cloudId: cloudId,
                                projectKey: projectKey,
                                itemId: itemId
                            }),
                            jiraCalendarViewSettings: $46b95ef7aa0ed32e$var$buildJiraCalendarViewSettings({
                                filterJql: filter
                            })
                        },
                        filterScope: (0, $2700E.expValEquals)('calendar-filter-refinement-sprt', 'isEnabled', true, false) ? {
                            project: {
                                projectKey: projectKey
                            }
                        } : null,
                        isCalendarFilterRefinementEnabled: (0, $2700E.expValEquals)('calendar-filter-refinement-sprt', 'isEnabled', true, false)
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                hasRecurrenceItemIndicator: true,
                filterScope: (0, $2700E.expValEquals)('calendar-filter-refinement-sprt', 'isEnabled', true, false) ? {
                    project: {
                        projectKey: projectKey
                    }
                } : null
            }
        };
    }
});

});
parcelRegister("cNSxS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c423dfb76991494$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfe1a063f9c3dee53e0ce29c41b55e19>>
 * @relayHash 4904f7cdc8e6a902778256166e661f7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03584fde98790a7e63f8ca85b13f2405c35faeb9ebc3dd7e7bd6286ce6193785
const $5c423dfb76991494$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "03584fde98790a7e63f8ca85b13f2405c35faeb9ebc3dd7e7bd6286ce6193785",
        "metadata": {},
        "name": "JiraBusinessCalendarEntrypointQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5c423dfb76991494$export$2e2bcd8739ae039 = $5c423dfb76991494$var$node;

});

parcelRegister("haVOg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("8Ax2t")
]).then(()=>parcelRequire('az1Bi'));

});


parcelRegister("frzmL", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarCustomEmbedRoute", () => $572f40ab968729c1$export$9cee00d5c4aee198);
const $572f40ab968729c1$export$9cee00d5c4aee198 = {
    name: 'classic-business-calendar-custom-embed',
    path: '/jira/core/projects/:projectKey/calendar/:itemId/embed',
    exact: true
};

});


parcelRegister("3HY5k", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarEmbedRouteEntry", () => $566a039a1ebd4d40$export$d75a7b48d8838f92);

var $bMfOT = parcelRequire("bMfOT");

var $hdZjx = parcelRequire("hdZjx");

var $byMD7 = parcelRequire("byMD7");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $dHelz = parcelRequire("dHelz");

var $dTa0V = parcelRequire("dTa0V");
const $566a039a1ebd4d40$var$calendarEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $bMfOT.calendarEntryPoint)
});
const $566a039a1ebd4d40$export$d75a7b48d8838f92 = (0, $fdS54.createEntry)((0, $dHelz.jiraBusinessCalendarEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return $566a039a1ebd4d40$var$calendarEmbedPageEntrypoint;
        },
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: (0, $hdZjx.getProjectViewResources)(),
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dHelz", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarEmbedRoute", () => $ab754768f290b325$export$71a801c267234959);
const $ab754768f290b325$export$71a801c267234959 = {
    name: 'classic-business-calendar-embed',
    path: '/jira/core/projects/:projectKey/calendar/embed',
    exact: true
};

});


parcelRegister("4HAfX", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarRouteEntry", () => $ed3087b219bae3df$export$b8f4785659c5349e);

var $hi6Of = parcelRequire("hi6Of");


var $bMfOT = parcelRequire("bMfOT");

var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $knmUP = parcelRequire("knmUP");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $ed3087b219bae3df$var$calendarPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bMfOT.calendarEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $ed3087b219bae3df$export$b8f4785659c5349e = (0, $fdS54.createEntry)((0, $knmUP.jiraBusinessCalendarRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-view',
        entryPoint () {
            return $ed3087b219bae3df$var$calendarPageEntrypoint;
        },
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("knmUP", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarRoute", () => $ee6b428cd017de98$export$3f1924073260dde6);
const $ee6b428cd017de98$export$3f1924073260dde6 = {
    name: 'classic-business-calendar',
    path: '/jira/core/projects/:projectKey/calendar/:itemId?',
    exact: true
};

});


parcelRegister("eUWpI", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCapacityPeopleEmbedRouteEntry", () => $5efa3c32558b1ed1$export$38e1bf82c112367c);
/* eslint-disable import/order */ 
var $aq8EV = parcelRequire("aq8EV");

var $hdZjx = parcelRequire("hdZjx");

var $byMD7 = parcelRequire("byMD7");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $2eRcm = parcelRequire("2eRcm");

var $dTa0V = parcelRequire("dTa0V");
const $5efa3c32558b1ed1$var$capacityPeopleEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $aq8EV.businessCapacityEntryPoint)
});
const $5efa3c32558b1ed1$export$38e1bf82c112367c = (0, $fdS54.createEntry)((0, $2eRcm.jiraBusinessCapacityPeopleEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-capacity-people-embed',
        entryPoint () {
            if (false) return undefined;
            return $5efa3c32558b1ed1$var$capacityPeopleEmbedPageEntrypoint;
        },
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            ...(0, $hdZjx.getProjectViewResources)()
        ],
        supportsProjectTheme: 'contoured',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aq8EV", function(module, exports) {
$parcel$export(module.exports, "businessCapacityEntryPoint", () => $8f056fbc6521db27$export$ea41e97541d78a1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $8f056fbc6521db27$export$ea41e97541d78a1 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gbHnu")), {
        moduleId: "fe80361e",
        moduleName: "BusinessCapacityEntryPoint",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { tenantContext: tenantContext } = entryPointRouteParams;
        return {
            queries: {},
            entryPoints: {},
            extraProps: {
                tenantContext: tenantContext
            }
        };
    }
});

});
parcelRegister("gbHnu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gA2dn").then(()=>parcelRequire('jFJZc'));

});


parcelRegister("2eRcm", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCapacityPeopleEmbedRoute", () => $fdd9b00477f7236b$export$e38421e2adacbf67);
const $fdd9b00477f7236b$export$e38421e2adacbf67 = {
    name: 'classic-business-capacity-people-embed',
    exact: true,
    path: '/jira/core/projects/:projectKey/capacity/people/embed'
};

});


parcelRegister("aze16", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCapacityRouteEntry", () => $695afffb3b381f9f$export$6d4677d6f87569b9);
/* eslint-disable import/order */ 
var $hi6Of = parcelRequire("hi6Of");

var $4D7as = parcelRequire("4D7as");


var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $4B518 = parcelRequire("4B518");

var $ZTCPL = parcelRequire("ZTCPL");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $695afffb3b381f9f$var$businessCapacityPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4D7as.businessCapacityParentEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $695afffb3b381f9f$export$6d4677d6f87569b9 = (0, $fdS54.createEntry)((0, $ZTCPL.jiraBusinessCapacityRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-capacity',
        layout: (0, $QhQu4.composeLayouts)((0, $4iKrU.businessProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $hdZjx.getProjectViewResources)()
        ],
        entryPoint: ()=>{
            if (false) return undefined;
            return $695afffb3b381f9f$var$businessCapacityPageEntrypoint;
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'contoured',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4D7as", function(module, exports) {
$parcel$export(module.exports, "businessCapacityParentEntryPoint", () => $dda706186871fa2d$export$87c61fbaf3f1fe41);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $c1kIz = parcelRequire("c1kIz");

var $aq8EV = parcelRequire("aq8EV");

var $l4Cam = parcelRequire("l4Cam");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");
const $dda706186871fa2d$var$ICP_MOST_RECENT_VIEW_COOKIE = 'icp_most_recent_view';
const $dda706186871fa2d$var$isCapacityView = (value)=>value === 'people' || value === 'work';
const $dda706186871fa2d$var$getCookieValue = (name)=>globalThis?.__GET_COOKIE__?.(name) ?? globalThis?.document?.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop();
const $dda706186871fa2d$var$getViewFromCookie = ()=>{
    const mostRecentView = $dda706186871fa2d$var$getCookieValue($dda706186871fa2d$var$ICP_MOST_RECENT_VIEW_COOKIE)?.toLowerCase();
    return mostRecentView === 'work' ? 'work' : 'people';
};

const $dda706186871fa2d$export$87c61fbaf3f1fe41 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("iVAtW")), {
        moduleId: "02779ff3",
        moduleName: "BusinessCapacityContainer",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointParams)=>{
        const viewParamRaw = entryPointParams.context.match.params.view;
        const viewParam = $dda706186871fa2d$var$isCapacityView(viewParamRaw) ? viewParamRaw : undefined;
        // Use URL param if set, otherwise fall back to cookie.
        const activeView = viewParam ?? $dda706186871fa2d$var$getViewFromCookie();
        return {
            extraProps: {
                activeView: activeView,
                viewParam: viewParam,
                tenantContext: entryPointParams.tenantContext
            },
            entryPoints: {
                headerControlPanel: {
                    entryPoint: (0, $c1kIz.businessCapacityHeaderControlPanelEntryPoint),
                    entryPointParams: entryPointParams
                },
                work: activeView === 'work' ? {
                    entryPoint: (0, $l4Cam.businessCapacityWorkEntryPoint),
                    entryPointParams: entryPointParams
                } : undefined,
                people: activeView === 'people' ? {
                    entryPoint: (0, $aq8EV.businessCapacityEntryPoint),
                    entryPointParams: entryPointParams
                } : undefined
            }
        };
    }
});

});
parcelRegister("c1kIz", function(module, exports) {
$parcel$export(module.exports, "businessCapacityHeaderControlPanelEntryPoint", () => $7479407a21b022b1$export$4f775c00a044c4a5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $7479407a21b022b1$export$4f775c00a044c4a5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("6CHcF")), {
        moduleId: "8a0e70eb",
        moduleName: "BusinessCapacityHeaderControlPanelEntryPoint",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({
            queries: {},
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("6CHcF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("14KoR").then(()=>parcelRequire('bof6P'));

});


parcelRegister("l4Cam", function(module, exports) {
$parcel$export(module.exports, "businessCapacityWorkEntryPoint", () => $404e2d00bcdeb614$export$fd274164ab8821c2);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $404e2d00bcdeb614$export$fd274164ab8821c2 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dUvb1")), {
        moduleId: "eeb57947",
        moduleName: "BusinessCapacityWorkEntryPoint",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { tenantContext: tenantContext } = entryPointRouteParams;
        return {
            queries: {},
            entryPoints: {},
            extraProps: {
                tenantContext: tenantContext
            }
        };
    }
});

});
parcelRegister("dUvb1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("chLxK").then(()=>parcelRequire('lgAlJ'));

});


parcelRegister("iVAtW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1O6Zm").then(()=>parcelRequire('fKDvI'));

});


parcelRegister("ZTCPL", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCapacityRoute", () => $c8400f93ecb02578$export$6efa34516d024fc3);
const $c8400f93ecb02578$export$6efa34516d024fc3 = {
    name: 'classic-business-capacity',
    exact: true,
    path: '/jira/core/projects/:projectKey/capacity/:view(people|work)?'
};

});


parcelRegister("c9rAZ", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCapacityWorkEmbedRouteEntry", () => $803755a9ad9ef037$export$3b392e00b1421f70);
/* eslint-disable import/order */ 
var $l4Cam = parcelRequire("l4Cam");

var $hdZjx = parcelRequire("hdZjx");

var $byMD7 = parcelRequire("byMD7");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $fg61H = parcelRequire("fg61H");

var $dTa0V = parcelRequire("dTa0V");
const $803755a9ad9ef037$var$capacityWorkEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $l4Cam.businessCapacityWorkEntryPoint)
});
const $803755a9ad9ef037$export$3b392e00b1421f70 = (0, $fdS54.createEntry)((0, $fg61H.jiraBusinessCapacityWorkEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-capacity-work-embed',
        entryPoint () {
            if (false) return undefined;
            return $803755a9ad9ef037$var$capacityWorkEmbedPageEntrypoint;
        },
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            ...(0, $hdZjx.getProjectViewResources)()
        ],
        supportsProjectTheme: 'contoured',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fg61H", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCapacityWorkEmbedRoute", () => $11fd84227955da7d$export$5040920ab285f737);
const $11fd84227955da7d$export$5040920ab285f737 = {
    name: 'classic-business-capacity-work-embed',
    exact: true,
    path: '/jira/core/projects/:projectKey/capacity/work/embed'
};

});


parcelRegister("kHwre", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCreatedVsResolvedRouteEntry", () => $09748efaa11d8f9f$export$b279da03936d90b6);


var $lFPF6 = parcelRequire("lFPF6");

var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $2XAkt = parcelRequire("2XAkt");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $09748efaa11d8f9f$var$createdVsResolvedPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $lFPF6.createdVsResolvedReportEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $09748efaa11d8f9f$export$b279da03936d90b6 = (0, $fdS54.createEntry)((0, $2XAkt.jiraBusinessCreatedVsResolvedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-created-vs-resolved',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>$09748efaa11d8f9f$var$createdVsResolvedPageEntrypoint,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2XAkt", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCreatedVsResolvedRoute", () => $a1724fd04595688e$export$1300cb070b9c1bc0);
const $a1724fd04595688e$export$1300cb070b9c1bc0 = {
    name: 'classic-business-reports-created-vs-resolved',
    path: '/jira/core/projects/:projectKey/reports/created-vs-resolved'
};

});


parcelRegister("ejKE2", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListCustomEmbedRouteEntry", () => $a52d03aec66fc520$export$e48bc622b980eb9a);

var $jBMak = parcelRequire("jBMak");

var $hdZjx = parcelRequire("hdZjx");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $edJFK = parcelRequire("edJFK");


var $31tCE = parcelRequire("31tCE");

var $2osjz = parcelRequire("2osjz");

var $2A6mK = parcelRequire("2A6mK");

var $836A7 = parcelRequire("836A7");
const $a52d03aec66fc520$var$listEmbedPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $jBMak.listEmbedEntryPoint)
});
const $a52d03aec66fc520$export$e48bc622b980eb9a = (0, $fdS54.createEntry)((0, $edJFK.jiraBusinessListCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'jwm-list-custom-nin-embed' : 'jwm.list-embed-view',
        meta: (0, $i860n.fg)('jira_list_nin_merge') ? {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        } : undefined,
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2osjz.EmbedIssueNavigatorSkeleton) : (0, $9EWfZ.ThemedLazySkeleton),
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jira_list_nin_merge')) return 0, $2A6mK.issueNavigatorEmbedPageEntryPoint;
            return $a52d03aec66fc520$var$listEmbedPageEntryPoint;
        },
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $836A7.getCommonProjectResources)() : (0, $hdZjx.getProjectViewResources)(),
        supportsProjectTheme: (0, $i860n.fg)('jira_list_nin_merge') ? undefined : 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jBMak", function(module, exports) {
$parcel$export(module.exports, "listEmbedEntryPoint", () => $b83985989496caa8$export$519bb55e1612f243);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6EpW0 = parcelRequire("6EpW0");

var $7wZ5H = parcelRequire("7wZ5H");
const $b83985989496caa8$var$FORMAT_RULES_FIRST = 20;

const $b83985989496caa8$export$519bb55e1612f243 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3Pz6a")), {
        moduleId: "c452bbf5",
        moduleName: "JiraBusinessListEmbedApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $7wZ5H.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $6EpW0.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $b83985989496caa8$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("6EpW0", function(module, exports) {
$parcel$export(module.exports, "default", () => $a47ec623e3478379$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eeb3f5f0c7e4c5f597cdccf0d16f309b>>
 * @relayHash 675361bd8a0cbf4e577c3d4a64e58d93
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09
const $a47ec623e3478379$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09",
        "metadata": {},
        "name": "FormatRulesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a47ec623e3478379$export$2e2bcd8739ae039 = $a47ec623e3478379$var$node;

});

parcelRegister("7wZ5H", function(module, exports) {
$parcel$export(module.exports, "default", () => $58a13f4a0d0a3f53$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14709da0eb3016ad6bd6108dd5e1a3f7>>
 * @relayHash 19c1ac51d55aceeac9b764c8dbf700c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c263536ede2352ca5302d36a6156cce8b87dc70dc5b82c03bad3714cd1e3d650
const $58a13f4a0d0a3f53$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c263536ede2352ca5302d36a6156cce8b87dc70dc5b82c03bad3714cd1e3d650",
        "metadata": {},
        "name": "JiraBusinessListEmbedAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $58a13f4a0d0a3f53$export$2e2bcd8739ae039 = $58a13f4a0d0a3f53$var$node;

});

parcelRegister("3Pz6a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("kY04q")
]).then(()=>parcelRequire('gm7CR'));

});


parcelRegister("edJFK", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListCustomEmbedRoute", () => $531758ec9f54e684$export$3bcc972f482cc0bd);
const $531758ec9f54e684$export$3bcc972f482cc0bd = {
    name: 'classic-business-list-custom-embed',
    path: '/jira/core/projects/:projectKey/list/:navigationItemId/embed',
    exact: true
};

});


parcelRegister("4JzGG", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListEmbedRouteEntry", () => $372eac7efea0a9a3$export$a6737d9a8c0f9d4f);

var $jBMak = parcelRequire("jBMak");

var $hdZjx = parcelRequire("hdZjx");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $55Cic = parcelRequire("55Cic");


var $31tCE = parcelRequire("31tCE");

var $2osjz = parcelRequire("2osjz");

var $2A6mK = parcelRequire("2A6mK");

var $836A7 = parcelRequire("836A7");
const $372eac7efea0a9a3$var$listEmbedPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $jBMak.listEmbedEntryPoint)
});
const $372eac7efea0a9a3$export$a6737d9a8c0f9d4f = (0, $fdS54.createEntry)((0, $55Cic.jiraBusinessListEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'jwm-list-nin-embed' : 'jwm.list-embed-view',
        meta: (0, $i860n.fg)('jira_list_nin_merge') ? {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        } : undefined,
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2osjz.EmbedIssueNavigatorSkeleton) : (0, $9EWfZ.ThemedLazySkeleton),
        entryPoint: ()=>{
            if ((0, $i860n.fg)('jira_list_nin_merge')) return 0, $2A6mK.issueNavigatorEmbedPageEntryPoint;
            return $372eac7efea0a9a3$var$listEmbedPageEntryPoint;
        },
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $836A7.getCommonProjectResources)() : (0, $hdZjx.getProjectViewResources)(),
        supportsProjectTheme: (0, $i860n.fg)('jira_list_nin_merge') ? undefined : 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("55Cic", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListEmbedRoute", () => $6030dac2edf13e53$export$40306068630dfc2);
const $6030dac2edf13e53$export$40306068630dfc2 = {
    name: 'classic-business-list-embed',
    path: '/jira/core/projects/:projectKey/list/embed',
    exact: true
};

});


parcelRegister("5j4hU", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListRouteEntry", () => $3d98ebfc4153ea64$export$9ef24aa950399eaf);

var $hi6Of = parcelRequire("hi6Of");


var $dqKS1 = parcelRequire("dqKS1");

var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $3KSG6 = parcelRequire("3KSG6");

var $4iKrU = parcelRequire("4iKrU");

var $dTa0V = parcelRequire("dTa0V");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $gRPUp = parcelRequire("gRPUp");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");


var $2EQPz = parcelRequire("2EQPz");

var $31tCE = parcelRequire("31tCE");

var $2A6mK = parcelRequire("2A6mK");

var $836A7 = parcelRequire("836A7");

var $8tarW = parcelRequire("8tarW");

var $cBtxa = parcelRequire("cBtxa");
const $3d98ebfc4153ea64$var$listPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $dqKS1.listEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $3d98ebfc4153ea64$export$9ef24aa950399eaf = (0, $fdS54.createEntry)((0, $gRPUp.jiraBusinessListRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'jwm-list-nin' : 'jwm.list-view',
        meta: (0, $i860n.fg)('jira_list_nin_merge') ? {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        } : undefined,
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2EQPz.ProjectIssueNavigatorSkeleton) : (0, $9EWfZ.ThemedLazySkeleton),
        entryPoint: ()=>(0, $i860n.fg)('jira_list_nin_merge') ? (0, $2A6mK.issueNavigatorPageEntryPoint) : $3d98ebfc4153ea64$var$listPageEntryPoint,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $836A7.getCommonProjectResources)() : (0, $hdZjx.getProjectViewResources)(),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            circuitBreakerConfig: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $8tarW.getSsrCircuitBreaker)() : undefined,
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0))
        },
        supportsPreviewPanel: true,
        // Pre-merge (jira_list_nin_merge off) the JWM list view is already fully themed, so keep
        // 'full' to avoid regressing those customers; post-merge, respect the theming experiment.
        supportsProjectTheme: !(0, $i860n.fg)('jira_list_nin_merge') || (0, $2700E.expVal)('jira-list-full-theming-exp', 'isEnabled', false) ? 'full' : 'contoured',
        isHydrateRootEnabled: (0, $i860n.fg)('jira_list_nin_merge'),
        excludeFromWrmDeferredLoading: (0, $i860n.fg)('jira_list_nin_merge')
    }));

});
parcelRegister("dqKS1", function(module, exports) {
$parcel$export(module.exports, "listEntryPoint", () => $62415a3e9da710a9$export$6be4f10150ff6073);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $6EpW0 = parcelRequire("6EpW0");

var $hMKST = parcelRequire("hMKST");
const $62415a3e9da710a9$var$FORMAT_RULES_FIRST = 20;

const $62415a3e9da710a9$export$6be4f10150ff6073 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6ldUa")), {
        moduleId: "cf2f5a2e",
        moduleName: "JiraBusinessListApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $hMKST.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $6EpW0.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $62415a3e9da710a9$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("hMKST", function(module, exports) {
$parcel$export(module.exports, "default", () => $604fbbb7bde4d72c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3cd3ca363b7ef4da69a18e1835fe7605>>
 * @relayHash 1e3a9c9e10fa41c68b2856a4ac4e2fa0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b957aa9d6b2dbcc23cdf3659001a4454a1e74a1e5f81b11d103631a7002abe0
const $604fbbb7bde4d72c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9b957aa9d6b2dbcc23cdf3659001a4454a1e74a1e5f81b11d103631a7002abe0",
        "metadata": {},
        "name": "JiraBusinessListAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $604fbbb7bde4d72c$export$2e2bcd8739ae039 = $604fbbb7bde4d72c$var$node;

});

parcelRegister("6ldUa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("6SGdn")
]).then(()=>parcelRequire('fUPst'));

});


parcelRegister("gRPUp", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListRoute", () => $84371406695f790c$export$ea171f7670960cff);
const $84371406695f790c$export$ea171f7670960cff = {
    name: 'classic-business-list',
    path: '/jira/core/projects/:projectKey/list/:navigationItemId?',
    exact: true
};

});


parcelRegister("VpjMH", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessProjectRedirectRouteEntry", () => $fb4873b3f931dae5$export$766e305da4c78de5);


var $hdZjx = parcelRequire("hdZjx");

var $3lEJh = parcelRequire("3lEJh");

var $jEYuY = parcelRequire("jEYuY");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $fdS54 = parcelRequire("fdS54");

var $6MRcq = parcelRequire("6MRcq");
const $fb4873b3f931dae5$export$766e305da4c78de5 = (0, $fdS54.createEntry)((0, $6MRcq.jiraBusinessProjectRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3lEJh.RedirectToLastVisitedProjectPage),
        layout: (0, $4iKrU.businessProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6MRcq", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $11b9ff6fed7ca2ec$export$73b60789ceb8e1eb);
const $11b9ff6fed7ca2ec$export$73b60789ceb8e1eb = {
    name: 'classic-business-redirect',
    path: '/jira/core/projects/:projectKey',
    exact: true
};

});


parcelRegister("i2Yzm", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessRecentlyCreatedRouteEntry", () => $27ba8205e4dd0f26$export$d23f89891b3f9c3e);


var $4eCEo = parcelRequire("4eCEo");

var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $iUQr8 = parcelRequire("iUQr8");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $27ba8205e4dd0f26$var$recentlyCreatedPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4eCEo.recentlyCreatedReportEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $27ba8205e4dd0f26$export$d23f89891b3f9c3e = (0, $fdS54.createEntry)((0, $iUQr8.jiraBusinessRecentlyCreatedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-recently-created-issues',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>$27ba8205e4dd0f26$var$recentlyCreatedPageEntrypoint,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iUQr8", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessRecentlyCreatedRoute", () => $51debc18f1b91c74$export$febe9a08fa79152c);
const $51debc18f1b91c74$export$febe9a08fa79152c = {
    name: 'classic-business-reports-recently-created',
    path: '/jira/core/projects/:projectKey/reports/recently-created'
};

});


parcelRegister("lpgz5", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessReportsOverviewRouteEntry", () => $10878daee427bda2$export$2cde310731fa9055);


var $5dHZ6 = parcelRequire("5dHZ6");

var $hdZjx = parcelRequire("hdZjx");

var $i860n = parcelRequire("i860n");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $eYWA9 = parcelRequire("eYWA9");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $10878daee427bda2$var$reportsOverviewPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5dHZ6.reportsOverviewPageEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $10878daee427bda2$export$2cde310731fa9055 = (0, $fdS54.createEntry)((0, $eYWA9.jiraBusinessReportsOverviewRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-overview',
        entryPoint () {
            return $10878daee427bda2$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        supportsProjectTheme: (0, $i860n.fg)('enable_avp_jira_summary_page') ? 'contoured' : 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5dHZ6", function(module, exports) {
$parcel$export(module.exports, "reportsOverviewPageEntryPoint", () => $c61094012ba202be$export$9dfa968d9e20b359);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $fDVI0 = parcelRequire("fDVI0");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $7PDQ2 = parcelRequire("7PDQ2");

const $c61094012ba202be$export$9dfa968d9e20b359 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("cSIwx")), {
        moduleId: "c98dfbb5",
        moduleName: "ReportsOverviewPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const boardId = context.match.params.boardId ? String(context.match.params.boardId) : null;
        const projectKey = context.match.params.projectKey ? String(context.match.params.projectKey) : null;
        const isBoardContext = !!boardId;
        const isProjectContext = !!projectKey;
        const cloudId = tenantContext.cloudId;
        const workspaceAri = (0, $i860n.fg)('avp_jira_space_dashboard_pass_workspace_ari') ? (0, $fDVI0.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: tenantContext.activationId
        }).toString() : undefined;
        return {
            queries: {
                reportsOverviewPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7PDQ2.default,
                    variables: {
                        boardId: isBoardContext ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '',
                        projectKey: !isBoardContext && isProjectContext ? projectKey : '',
                        cloudId: cloudId,
                        isBoardContext: isBoardContext,
                        isMigrateTMPReportsOverviewEnabled: (0, $i860n.fg)('uxissue_545_migrate_tmp_reports_overview_page'),
                        isSunsetHideEnabled: (0, $i860n.fg)('jira-cmp-report-sunset-hide'),
                        avpProjectKey: isProjectContext ? projectKey : '',
                        workspaceAri: workspaceAri
                    }
                }
            }
        };
    }
});

});
parcelRegister("7PDQ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e0a7d071c609cd9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d3479a1f0022651aa01c25656a9098a8>>
 * @relayHash 2ba830b428a4d9aeab607ff7cc4d0eb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce45398dd83e5e61497fa680ce09200d5e380a7e31060999df6e1ff54417fc1
const $8e0a7d071c609cd9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "avpProjectKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isBoardContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isMigrateTMPReportsOverviewEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSunsetHideEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "avpProjectKey"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectKey"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v13 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = {
        "kind": "ScalarField",
        "name": "failureCode"
    }, v16 = {
        "kind": "ScalarField",
        "name": "failureType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "hasAccess"
    }, v18 = {
        "kind": "ScalarField",
        "name": "hasManage"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hasWrite"
    }, v20 = {
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "concreteType": "AVPPermissionsPropertyEntry",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": [
            v20 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "values"
                            }
                        ],
                        "type": "AVPPermissionsPropertyValueList"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ],
                        "type": "AVPPermissionsPropertyValueString"
                    }
                ]
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "reason"
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "concreteType": "JiraReportCategoryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraReportCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraReportConnection",
                        "kind": "LinkedField",
                        "name": "reports",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraReportConnectionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraReport",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v21 /*: any*/ ,
                                            v24 /*: any*/ ,
                                            v20 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "imageUrl"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            },
                                            v14 /*: any*/ ,
                                            {
                                                "condition": "isMigrateTMPReportsOverviewEnabled",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isNotApplicableReason"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isNotApplicableDesc"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v14 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReportsOverviewPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ReportCategories"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SpaceDashboard_spaceDashboardQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "spaceDashboardAvpProject",
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v11 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jira_projectByIdOrKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v12 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    v13 /*: any*/ 
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReportsOverviewPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "spaceDashboardAvpProject",
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "fields": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "workspaceAri",
                                    "variableName": "workspaceAri"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "input"
                        }
                    ],
                    "concreteType": "AVPPermissionsGetCapabilitiesResponse",
                    "kind": "LinkedField",
                    "name": "avpPermissions_getCapabilities",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AVPPermissionsCapabilityResult",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "capabilityId"
                                },
                                {
                                    "concreteType": "AVPPermissionsHasCapabilityResponse",
                                    "kind": "LinkedField",
                                    "name": "result",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "concreteType": "AVPPermissionsProductCapabilityResult",
                                            "kind": "LinkedField",
                                            "name": "productResults",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "productId"
                                                },
                                                {
                                                    "concreteType": "AVPPermissionsProductCapabilityResponse",
                                                    "kind": "LinkedField",
                                                    "name": "result",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraReportCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "reportCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v25 /*: any*/ 
                                    ]
                                },
                                v14 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraReportCategoryConnection",
                                                    "kind": "LinkedField",
                                                    "name": "reportCategories",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7ce45398dd83e5e61497fa680ce09200d5e380a7e31060999df6e1ff54417fc1",
            "metadata": {},
            "name": "ReportsOverviewPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8e0a7d071c609cd9$var$node.hash = "f42068c8a966b532f112192add3a5acd";
var $8e0a7d071c609cd9$export$2e2bcd8739ae039 = $8e0a7d071c609cd9$var$node;

});

parcelRegister("cSIwx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ivyLi")
]).then(()=>parcelRequire('gwFYS'));

});


parcelRegister("eYWA9", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessReportsOverviewRoute", () => $a1bbc642485e2392$export$5881ca008f82b9d8);
const $a1bbc642485e2392$export$5881ca008f82b9d8 = {
    name: 'classic-business-reports-overview',
    path: '/jira/core/projects/:projectKey/reports',
    exact: true,
    query: [
        'dashboardId?'
    ]
};

});


parcelRegister("8OFru", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessSummaryEmbedRouteEntry", () => $fa8cf952a6cf037f$export$2c37f93832ff9919);
// eslint-disable-next-line jira/import/no-restricted-import

var $hdZjx = parcelRequire("hdZjx");

var $kpzER = parcelRequire("kpzER");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $9RcDE = parcelRequire("9RcDE");
const $fa8cf952a6cf037f$var$summaryEmbedBusimessPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $kpzER.summaryBusinessEmbedEntrypoint)
});
const $fa8cf952a6cf037f$export$2c37f93832ff9919 = (0, $fdS54.createEntry)((0, $9RcDE.jiraBusinessSummaryEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view-embed',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: [
            ...(0, $hdZjx.getProjectViewResources)()
        ],
        supportsProjectTheme: 'full',
        entryPoint: ()=>{
            return $fa8cf952a6cf037f$var$summaryEmbedBusimessPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kpzER", function(module, exports) {
$parcel$export(module.exports, "summaryBusinessEmbedEntrypoint", () => $51e4c05ec0635d3b$export$a027511631595373);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $3AYoO = parcelRequire("3AYoO");

const $51e4c05ec0635d3b$export$a027511631595373 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("4Bk0N")), {
        moduleId: "b8f88779",
        moduleName: "BusinessEmbedSummarySpaApps",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3AYoO.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("3AYoO", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c313d0a41979eab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d1c2ad413ce652c570464f5fe53e61f3>>
 * @relayHash f16b3e204ec39bfa9d43c285fb425425
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 803091d0ff0618d0995a2b6079d8b642bd8973b80d3025575e4adb7ac82984b2
const $9c313d0a41979eab$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "803091d0ff0618d0995a2b6079d8b642bd8973b80d3025575e4adb7ac82984b2",
        "metadata": {},
        "name": "BusinessEmbedSummarySpaAppsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9c313d0a41979eab$export$2e2bcd8739ae039 = $9c313d0a41979eab$var$node;

});

parcelRegister("4Bk0N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("alAYP")
]).then(()=>parcelRequire('8fH6W'));

});


parcelRegister("9RcDE", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessSummaryEmbedRoute", () => $b9fc958531e63033$export$d4aa7e677d381961);
const $b9fc958531e63033$export$d4aa7e677d381961 = {
    name: 'classic-business-summary-embed',
    path: '/jira/core/projects/:projectKey/summary/embed',
    exact: true
};

});


parcelRegister("kya75", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessSummaryRouteEntry", () => $aefbec67da542789$export$66365c0c5e8430d2);


var $hdZjx = parcelRequire("hdZjx");

var $fdgeq = parcelRequire("fdgeq");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $dTa0V = parcelRequire("dTa0V");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $lONPK = parcelRequire("lONPK");

var $3KSG6 = parcelRequire("3KSG6");
const $aefbec67da542789$var$summaryBusinessPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fdgeq.summaryBusinessEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $aefbec67da542789$export$66365c0c5e8430d2 = (0, $fdS54.createEntry)((0, $lONPK.jiraBusinessSummaryRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $hdZjx.getProjectViewResources)()
        ],
        entryPoint: ()=>{
            return $aefbec67da542789$var$summaryBusinessPageEntrypoint;
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fdgeq", function(module, exports) {
$parcel$export(module.exports, "summaryBusinessEntrypoint", () => $bdf78515fea3c17c$export$1655de4ea7d4bb73);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $ctl75 = parcelRequire("ctl75");

var $2700E = parcelRequire("2700E");

const $bdf78515fea3c17c$export$1655de4ea7d4bb73 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dX1Ho")), {
        moduleId: "7eb54397",
        moduleName: "BusinessSummarySpaApps",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ctl75.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        scope: {
                            project: {
                                projectKey: projectKey
                            }
                        },
                        isFilterRefinementEnabled: (0, $2700E.expValEquals)('jira_add_harmonisation_filter_to_summary_view', 'isEnabled', true, false)
                    }
                }
            }
        };
    }
});

});
parcelRegister("ctl75", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d1ec954a1371c77$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1179c587092b3c2282e6ab2a2fb3cd0e>>
 * @relayHash 90a80b4181f89b5f52bd889449d699b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 701fb74d1747c193510873223240f91465374fe4d7db89f32995a8b201acd557
const $8d1ec954a1371c77$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "701fb74d1747c193510873223240f91465374fe4d7db89f32995a8b201acd557",
        "metadata": {},
        "name": "BusinessSummarySpaAppsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8d1ec954a1371c77$export$2e2bcd8739ae039 = $8d1ec954a1371c77$var$node;

});

parcelRegister("dX1Ho", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("llA9e")
]).then(()=>parcelRequire('h2obR'));

});


parcelRegister("lONPK", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessSummaryRoute", () => $41f9ae90ad507e0e$export$ad0ce411d14c71d7);
const $41f9ae90ad507e0e$export$ad0ce411d14c71d7 = {
    name: 'classic-business-summary',
    path: '/jira/core/projects/:projectKey/summary',
    exact: true
};

});


parcelRegister("cpKx3", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineCustomEmbedRouteEntry", () => $b1e71f76eb26ce6f$export$7bf22b3ca2cb514d);

var $1phMj = parcelRequire("1phMj");

var $iI4lK = parcelRequire("iI4lK");

var $hdZjx = parcelRequire("hdZjx");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $52MLf = parcelRequire("52MLf");
const $b1e71f76eb26ce6f$var$timelineEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $iI4lK.timelineEntrypoint)
});
const $b1e71f76eb26ce6f$var$legacyTimelineEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $1phMj.timelineEmbedEntrypoint)
});
const $b1e71f76eb26ce6f$export$7bf22b3ca2cb514d = (0, $fdS54.createEntry)((0, $52MLf.jiraBusinessTimelineCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-embed-view',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: (0, $hdZjx.getProjectViewResources)(),
        supportsProjectTheme: 'full',
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jira_harmonised_business_timeline_embed') && (0, $i860n.fg)('jira_timeline_harmonisation_m1_targeting') ? $b1e71f76eb26ce6f$var$timelineEmbedPageEntrypoint : $b1e71f76eb26ce6f$var$legacyTimelineEmbedPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1phMj", function(module, exports) {
$parcel$export(module.exports, "timelineEmbedEntrypoint", () => $9277c56d32b0bd5c$export$12a9d017aa53985f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $9FTfi = parcelRequire("9FTfi");

const $9277c56d32b0bd5c$export$12a9d017aa53985f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7JtUa")), {
        moduleId: "bf4bbb8e",
        moduleName: "JiraBusinessTimelineEmbedAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $9FTfi.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("9FTfi", function(module, exports) {
$parcel$export(module.exports, "default", () => $682b5776ae60be1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4c12d1f4ef294ef8feb2411578ca031>>
 * @relayHash f837607613541f2d59174c00f8a94698
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f46006fe4d7f77f58b8b5ba08a0658fb8fc6edb90c0e7720add84d34b77f4b3
const $682b5776ae60be1b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f46006fe4d7f77f58b8b5ba08a0658fb8fc6edb90c0e7720add84d34b77f4b3",
        "metadata": {},
        "name": "JiraBusinessTimelineEmbedAppMemoQuery",
        "operationKind": "query",
        "text": null
    }
};
var $682b5776ae60be1b$export$2e2bcd8739ae039 = $682b5776ae60be1b$var$node;

});

parcelRegister("7JtUa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("eh0iS")
]).then(()=>parcelRequire('eBcaJ'));

});


parcelRegister("iI4lK", function(module, exports) {
$parcel$export(module.exports, "timelineEntrypoint", () => $5e9fb7850546c677$export$7586afa83216512a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i860n = parcelRequire("i860n");

var $iXN50 = parcelRequire("iXN50");

var $kIYP9 = parcelRequire("kIYP9");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $2700E = parcelRequire("2700E");

var $lh6D1 = parcelRequire("lh6D1");

var $71h0a = parcelRequire("71h0a");

var $g7hgf = parcelRequire("g7hgf");
const $5e9fb7850546c677$var$TOGGLEABLE_FIELD_SET_IDS = [
    'assignee',
    'status'
];
const $5e9fb7850546c677$var$WEEKS = 'WEEKS';
const $5e9fb7850546c677$var$MONTHS = 'MONTHS';
const $5e9fb7850546c677$var$QUARTERS = 'QUARTERS';
// Matches only plain objects: arrays, `null`, `Date`, `RegExp`, functions, and
// primitives are all excluded, so the `Record<string, unknown>` narrowing
// reflects the exact set of runtime values that reach the property access below.
const $5e9fb7850546c677$var$isRecord = (value)=>Object.prototype.toString.call(value) === '[object Object]';
/**
 * Safely resolves the scroll element height calibration for a route from an
 * untrusted experiment value. Returns `undefined` (so the prop is omitted and
 * the Issue Table uses its built-in fallback) unless the value is a plain object
 * keyed by route name whose entry has finite numeric `scrollElementHeight` and
 * `viewportHeightOverhead`.
 */ const $5e9fb7850546c677$var$getScrollElementHeightCalibration = (calibration, routeName)=>{
    if (!$5e9fb7850546c677$var$isRecord(calibration)) return undefined;
    const entry = calibration[routeName];
    if (!$5e9fb7850546c677$var$isRecord(entry)) return undefined;
    const { scrollElementHeight: scrollElementHeight, viewportHeightOverhead: viewportHeightOverhead } = entry;
    if (typeof scrollElementHeight !== 'number' || !Number.isFinite(scrollElementHeight) || typeof viewportHeightOverhead !== 'number' || !Number.isFinite(viewportHeightOverhead)) return undefined;
    return {
        scrollElementHeight: scrollElementHeight,
        viewportHeightOverhead: viewportHeightOverhead
    };
};
// Remove store after clean up fg timeline_harmonisation_m3_technical and jira_timeline_saved_view_biz
const $5e9fb7850546c677$var$store = typeof window !== 'undefined' ? (0, $iXN50.createLocalStorageProvider)('jwm-view-preferences') : undefined;
const $5e9fb7850546c677$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
const $5e9fb7850546c677$var$getProjectJql = (projectKey)=>projectKey.length > 0 ? `project = '${projectKey}'` : '';
const $5e9fb7850546c677$var$getSearchTextJql = (text)=>{
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const issueKeyRegex = new RegExp('^([A-Z][A-Z0-9_]+-\\d+)$');
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text) && (0, $2700E.expVal)('business-timeline-filter-refinement-sprt', 'isEnabled', false)) return `(textfields ~ "${search}" OR issuekey = "${search}")`;
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    if ((0, $2700E.expVal)('business-timeline-filter-refinement-sprt', 'isEnabled', false)) return `textfields ~ "${search}"`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $5e9fb7850546c677$var$buildJql = (queryFilter = '', queryJql = '', storageFilter = '', text = '', projectKey = '')=>{
    const filter = queryFilter || (queryJql !== '' && (0, $2700E.expVal)('business-timeline-filter-refinement-sprt', 'isEnabled', false) ? queryJql : '') || storageFilter;
    const search = $5e9fb7850546c677$var$getSearchTextJql(text);
    const project = $5e9fb7850546c677$var$getProjectJql(projectKey);
    return $5e9fb7850546c677$var$and([
        search,
        filter,
        project
    ]);
};
function $5e9fb7850546c677$var$isValidTimelineMode(value) {
    return value === $5e9fb7850546c677$var$WEEKS || value === $5e9fb7850546c677$var$MONTHS || value === $5e9fb7850546c677$var$QUARTERS;
}
// should be equivalent to the getToday function in jira/src/packages/software/roadmap-utils/src/utils/dates.tsx
const $5e9fb7850546c677$var$getToday = ()=>{
    const now = new Date();
    const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
    return date.valueOf();
};
const $5e9fb7850546c677$var$parseQueryParamValue = (str)=>{
    try {
        return str ? JSON.parse(str) : undefined;
    } catch  {
    // Do nothing - ignore invalid values
    }
};
const $5e9fb7850546c677$var$toStaticViewInput = (settings, aggregationConfig)=>{
    return {
        isGroupingEnabled: !!settings.groupBy,
        isHideDoneEnabled: settings.hideDone,
        isHierarchyEnabled: settings.hierarchyEnabled,
        ...aggregationConfig || {
            aggregationConfig: aggregationConfig
        }
    };
};
const $5e9fb7850546c677$var$getFilterPreference = (entityId, preferenceId = 'filter')=>{
    if ((0, $i860n.fg)('timeline_harmonisation_m3_technical') || (0, $2700E.expValEquals)('jira_timeline_saved_view_biz', 'isEnabled', true, false)) return '';
    if (entityId === undefined) return '';
    const key = `${entityId}_timeline_${preferenceId}`;
    return $5e9fb7850546c677$var$store?.get(key);
};
const $5e9fb7850546c677$var$getHideDonePreference = (entityId, preferenceId = 'hideDone')=>{
    if ((0, $i860n.fg)('timeline_harmonisation_m3_technical') || (0, $2700E.expValEquals)('jira_timeline_saved_view_biz', 'isEnabled', true, false)) return undefined;
    if (entityId === undefined) return undefined;
    const key = `${entityId}_timeline_${preferenceId}`;
    const value = $5e9fb7850546c677$var$store?.get(key);
    // We only save the value in local storage if it's true, so we can ignore
    // anything else
    return value === 'true' || undefined;
};
const $5e9fb7850546c677$var$getProjectId = (projectKey)=>{
    if ((0, $i860n.fg)('timeline_harmonisation_m3_technical') || (0, $2700E.expValEquals)('jira_timeline_saved_view_biz', 'isEnabled', true, false)) return '';
    const key = 'timeline_project-mapping-preference';
    const projectMapping = $5e9fb7850546c677$var$store?.get(key) ?? {};
    const projectId = projectMapping[projectKey];
    return projectId?.toString() ?? '';
};

const $5e9fb7850546c677$export$7586afa83216512a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3nzLH")), {
        moduleId: "1edfc3c1",
        moduleName: "JiraBusinessTimelineAppWithExperiment",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const { context: context, tenantContext: { cloudId: cloudId } } = entryPointParams;
        const namespace = 'TIMELINE';
        const projectKey = context.match.params.projectKey;
        const { filter: queryFilter, hideDone: hideDone, text: text, rangeMode: rangeMode, groupBy: queryGroupByParam, jql: queryJql } = context.query || {};
        // Only treat the URL value as a groupBy override when the experiment is on
        // and the value is a non-empty string. When absent, leave settings.groupBy
        // null so the BE can apply its persisted groupByField.
        const queryGroupBy = typeof queryGroupByParam === 'string' && queryGroupByParam !== '' && (0, $2700E.expValEquals)('jira_timeline_group_by', 'isEnabled', true, false) ? queryGroupByParam : null;
        const normalizedRangeMode = rangeMode?.toUpperCase();
        const validatedRangeMode = normalizedRangeMode && $5e9fb7850546c677$var$isValidTimelineMode(normalizedRangeMode) ? normalizedRangeMode : undefined;
        const viewId = context.match.params.viewId;
        const itemIdSuffix = viewId ? `/${viewId}` : '';
        const itemId = (0, $2700E.expValEquals)('jira_timeline_saved_view_biz', 'isEnabled', true, false) ? `timeline${itemIdSuffix}` : 'timeline';
        if (projectKey == null) throw new Error('Project key missing');
        const projectId = $5e9fb7850546c677$var$getProjectId(projectKey);
        const storageFilter = $5e9fb7850546c677$var$getFilterPreference(projectId);
        // The following is used to remount the timeline when the project key changes as to support the saved view feature.
        const projectKeyAndItemQuery = {
            cloudId: cloudId,
            projectKey: projectKey,
            itemId: itemId
        };
        const jiraViewQueryInput = {
            projectKeyAndItemQuery: projectKeyAndItemQuery
        };
        const remountKey = JSON.stringify(projectKeyAndItemQuery);
        const storageHideDone = $5e9fb7850546c677$var$getHideDonePreference(projectId);
        const prevFieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'timeline'
        ];
        // Explicity set the aggregation config to false when the timeline_harmonisation_m2 experiment is disabled.
        const aggregationConfig = !(0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
            aggregationConfig: {
                aggregationFields: [
                    {
                        fieldId: 'timeline',
                        isEnabled: false
                    },
                    {
                        fieldId: 'status',
                        isEnabled: false
                    }
                ]
            }
        } : undefined;
        const { fieldSetIds: fieldSetIds, fieldSetsInput: fieldSetsInput } = (0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
            fieldSetIds: undefined,
            fieldSetsInput: {
                viewInput: {
                    namespace: 'TIMELINE',
                    viewId: 'timeline_default'
                }
            }
        } : {
            fieldSetIds: prevFieldSetIds,
            fieldSetsInput: {
                fieldSetIds: prevFieldSetIds
            }
        };
        const scope = {
            operationScope: 'TIMELINE_PROJECT',
            projectKey: projectKey
        };
        // `viewScope` is the same value as `scope` above — it only exists so we can pass the
        // scope to the top-level jiraIssueSearchView behind jira_timeline_hierarchy_board_filter
        // without affecting the nested issues(scope), which must keep `scope` unconditionally.
        // On FG cleanup: delete `viewScope`, pass `scope` directly to jiraIssueSearchView.
        const viewScope = (0, $i860n.fg)('jira_timeline_hierarchy_board_filter') ? scope : undefined;
        // Combine with `scope` on `jira_timeline_group_by` FG cleanup
        // See https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/239157/diff#comment-2000357582
        const fieldSetsScope = (0, $2700E.expValEquals)('jira_timeline_group_by', 'isEnabled', true, false) ? {
            operationScope: 'TIMELINE_PROJECT',
            projectKey: projectKey
        } : undefined;
        const hasFilterOverrides = queryFilter !== undefined || text !== undefined || queryJql !== undefined && (0, $2700E.expVal)('business-timeline-filter-refinement-sprt', 'isEnabled', false);
        const hasJqlOverrides = queryFilter !== undefined || hideDone !== undefined || text !== undefined || validatedRangeMode !== undefined || queryJql !== undefined && (0, $2700E.expVal)('business-timeline-filter-refinement-sprt', 'isEnabled', false);
        const jql = $5e9fb7850546c677$var$buildJql(queryFilter, queryJql, storageFilter, text, projectKey);
        const settings = {
            ...queryGroupBy && (0, $i860n.fg)('jira_timeline_groupby_targeting') && {
                groupBy: queryGroupBy
            },
            // When the saved view or timeline M3 enabled, there’s no need to check hideDone from local storage.
            hideDone: (0, $2700E.expValEquals)('jira_timeline_saved_view_biz', 'isEnabled', true, false) || (0, $i860n.fg)('timeline_harmonisation_m3_technical') ? $5e9fb7850546c677$var$parseQueryParamValue(hideDone) : $5e9fb7850546c677$var$parseQueryParamValue(hideDone) ?? storageHideDone,
            hierarchyEnabled: true,
            jql: hasFilterOverrides ? jql : undefined
        };
        const timelineViewSettings = hasJqlOverrides ? {
            hideDone: $5e9fb7850546c677$var$parseQueryParamValue(hideDone),
            jql: jql,
            rangeMode: validatedRangeMode
        } : {};
        const timelineStaticViewInput = validatedRangeMode !== undefined ? {
            rangeMode: validatedRangeMode
        } : {};
        // JiraIssueSearchSettings will replace JiraIssueSearchStaticViewInput
        // as part of the saved views project, so we'll use it as the source of
        // truth
        const staticViewInput = (0, $2700E.expValEquals)('jira_timeline_group_by', 'isEnabled', true, false) ? // grouping/hide-done to the BE saved config and only keep hierarchy
        // enabled. When the URL explicitly overrides groupBy/hideDone, forward
        // those so the override is honoured. Only safe when group-by is enabled
        // on the client, otherwise the BE can return a JiraGroupedTimelineView
        // that the client can't render/validate (isTimelineGroupByEnabled is false).
        {
            isHierarchyEnabled: true,
            ...queryGroupBy ? {
                isGroupingEnabled: true
            } : {},
            ...hideDone ? {
                isHideDoneEnabled: !!$5e9fb7850546c677$var$parseQueryParamValue(hideDone)
            } : {}
        } : $5e9fb7850546c677$var$toStaticViewInput(settings, aggregationConfig);
        const filterRefinementScope = {
            project: {
                projectKey: projectKey
            }
        };
        // Per-route scroll element height calibration is delivered via the
        // `issue_table_virtualizer_dynamic_estimators` experiment's `calibration`
        // parameter, a `Record<routeName, ScrollElementHeightCalibration>`. The
        // experiment value is untrusted (it comes from remote config), so it is
        // validated before use; an absent or malformed entry yields `undefined` and
        // the calibration is omitted so the Issue Table falls back to its default.
        const scrollElementHeightCalibration = (0, $2700E.expVal)('issue_table_virtualizer_dynamic_estimators', 'isEnabled', false) ? $5e9fb7850546c677$var$getScrollElementHeightCalibration((0, $2700E.expVal)('issue_table_virtualizer_dynamic_estimators', 'calibration', null), context.route.name) : undefined;
        return {
            extraProps: {
                ...(0, $2700E.expValEquals)('jira_timeline_saved_view_biz', 'isEnabled', true, false) ? {
                    remountKey: remountKey
                } : {},
                today: $5e9fb7850546c677$var$getToday(),
                isTimelineSavedViewEnabled: (0, $2700E.expValEquals)('jira_timeline_saved_view_biz', 'isEnabled', true, false),
                isTimelineHarmonisationM2Enabled: (0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false),
                isBulkOperationsInTimelineEnabled: (0, $2700E.expValEquals)('bulk_operations_in_timeline', 'isEnabled', true, false),
                isTimelineGroupByEnabled: (0, $2700E.expValEquals)('jira_timeline_group_by', 'isEnabled', true, false),
                ...(0, $i860n.fg)('timeline-filter-refinement-technical-changes') ? {
                    filterRefinementScope: filterRefinementScope,
                    includeBoardFilters: false
                } : {},
                ...scrollElementHeightCalibration ? {
                    scrollElementHeightCalibration: scrollElementHeightCalibration
                } : {}
            },
            queries: {
                businessTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $g7hgf.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $lh6D1.default),
                    variables: {
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        fieldSetIds: fieldSetIds,
                        fieldSetsInput: fieldSetsInput,
                        filterId: null,
                        first: (0, $2700E.expValEquals)('load_less_rows_on_timeline_harmonisation', 'isEnabled', true, false) ? 30 : 50,
                        issueSearchInput: {
                            jql: jql
                        },
                        namespace: namespace,
                        projectKey: projectKey,
                        settings: settings,
                        /*
										This key is used to generate a unique identity for the issue connection record in the Relay
										store when running a new search. This is to prevent concurrency related bugs occurring when
										performing a refetch that returns a new connection of results. Ordinarily this would be
										handled automatically when relevant query variables change (as these are used to form the
										connection key), however we override the default connection filters which allows us to modify
										variables during pagination operations without producing a new connection key.
										 */ dynamicSearchKey: `business-timeline-${projectKey}${viewId ? `-${viewId}` : ''}`,
                        ...(0, $2700E.expValEquals)('jira_timeline_saved_view_biz', 'isEnabled', true, false) || (0, $i860n.fg)('timeline_harmonisation_m3_technical') ? {
                            timelineViewSettings: timelineViewSettings,
                            timelineStaticViewInput: timelineStaticViewInput
                        } : {},
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: !(0, $i860n.fg)('jsc_list_expand_all'),
                        shouldQueryHasChildrenWithCount: (0, $i860n.fg)('jsc_list_expand_all'),
                        shouldQueryHasParent: (0, $2700E.expValEquals)('business_timeline_hierarchy_flyout_sprt', 'isEnabled', true, false),
                        scope: scope,
                        viewScope: viewScope,
                        fieldSetsScope: fieldSetsScope,
                        staticViewInput: staticViewInput,
                        viewConfigInput: {
                            staticViewInput: staticViewInput
                        },
                        jiraViewQueryInput: jiraViewQueryInput,
                        // cleanup with jira_timeline_saved_view_technical fg: replace with jiraViewQueryInput.
                        jiraViewQueryInputForIssues: (0, $i860n.fg)('jira_timeline_saved_view_technical') ? jiraViewQueryInput : null,
                        viewId: 'timeline_default',
                        ...(0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
                            toggleableFieldSetIds: $5e9fb7850546c677$var$TOGGLEABLE_FIELD_SET_IDS,
                            isInlineEditingEnabled: true,
                            isTimelineHarmonisationM2Enabled: true
                        } : {
                            isTimelineHarmonisationM2Enabled: false,
                            isInlineEditingEnabled: false
                        },
                        isTimelineGroupByEnabled: (0, $2700E.expValEquals)('jira_timeline_group_by', 'isEnabled', true, false),
                        ...(0, $i860n.fg)('timeline_harmonisation_m3_technical') ? {
                            shouldQueryReleases: false,
                            shouldQueryBarColor: false,
                            shouldQuerySoftwareProjectSettings: false
                        } : {}
                    }
                },
                ...(0, $i860n.fg)('timeline-filter-refinement-technical-changes') ? {
                    filterRefinementQuery: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, $71h0a.default),
                        variables: {
                            cloudId: cloudId,
                            filterRefinementScope: filterRefinementScope,
                            boardId: '',
                            includeBoard: false
                        }
                    }
                } : {}
            },
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $kIYP9.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("g7hgf", function(module, exports) {
$parcel$export(module.exports, "default", () => $14063468cc8a0c40$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<920a59965964a2d7e587b1d7db6284c7>>
 * @relayHash e00b9ac070e3c587e6c54338b2927c57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c000f877912fd9c73d137c8b432d647b08693d0efb0cac14485988e83d18718
const $14063468cc8a0c40$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0c000f877912fd9c73d137c8b432d647b08693d0efb0cac14485988e83d18718",
        "metadata": {},
        "name": "JiraBusinessTimelineAppWithExperimentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $14063468cc8a0c40$export$2e2bcd8739ae039 = $14063468cc8a0c40$var$node;

});

parcelRegister("3nzLH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("7uVJ3")
]).then(()=>parcelRequire('lGSqg'));

});


parcelRegister("52MLf", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineCustomEmbedRoute", () => $2f29c5193f01bc14$export$ca33e2099975da73);
const $2f29c5193f01bc14$export$ca33e2099975da73 = {
    name: 'classic-business-timeline-custom-embed',
    path: '/jira/core/projects/:projectKey/timeline/:viewId/embed',
    exact: true
};

});


parcelRegister("bfuFe", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineEmbedRouteEntry", () => $c270a117e0c77031$export$ef65a62ced1a9df1);

var $1phMj = parcelRequire("1phMj");

var $iI4lK = parcelRequire("iI4lK");

var $hdZjx = parcelRequire("hdZjx");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $dACFL = parcelRequire("dACFL");
const $c270a117e0c77031$var$timelineEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $iI4lK.timelineEntrypoint)
});
const $c270a117e0c77031$var$legacyimelineEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $1phMj.timelineEmbedEntrypoint)
});
const $c270a117e0c77031$export$ef65a62ced1a9df1 = (0, $fdS54.createEntry)((0, $dACFL.jiraBusinessTimelineEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-embed-view',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        resources: (0, $hdZjx.getProjectViewResources)(),
        supportsProjectTheme: 'full',
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jira_harmonised_business_timeline_embed') && (0, $i860n.fg)('jira_timeline_harmonisation_m1_targeting') ? $c270a117e0c77031$var$timelineEmbedPageEntrypoint : $c270a117e0c77031$var$legacyimelineEmbedPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dACFL", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineEmbedRoute", () => $ed819a90eccce5bb$export$d85fbccfa0ba559a);
const $ed819a90eccce5bb$export$d85fbccfa0ba559a = {
    name: 'classic-business-timeline-embed',
    path: '/jira/core/projects/:projectKey/timeline/embed',
    exact: true
};

});


parcelRegister("8u2Ns", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineRouteEntry", () => $da1363e6dcec9b5f$export$5725375da49b5772);

var $euxye = parcelRequire("euxye");


var $8ohhq = parcelRequire("8ohhq");

var $iI4lK = parcelRequire("iI4lK");

var $hdZjx = parcelRequire("hdZjx");

var $75Njg = parcelRequire("75Njg");

var $4iKrU = parcelRequire("4iKrU");

var $dTa0V = parcelRequire("dTa0V");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $9EWfZ = parcelRequire("9EWfZ");

var $fdS54 = parcelRequire("fdS54");

var $ksyMR = parcelRequire("ksyMR");

var $3KSG6 = parcelRequire("3KSG6");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");
const $da1363e6dcec9b5f$var$timelinePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $iI4lK.timelineEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $da1363e6dcec9b5f$var$legacyTimelinePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8ohhq.timelineEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $da1363e6dcec9b5f$export$5725375da49b5772 = (0, $fdS54.createEntry)((0, $ksyMR.jiraBusinessTimelineRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-view',
        layout: (0, $4iKrU.businessProjectLayout),
        skeleton: (0, $i860n.fg)('timeline_skeleton_update') ? $da1363e6dcec9b5f$var$BusinessTimelineSkeleton : (0, $9EWfZ.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $hdZjx.getProjectViewResources)(),
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jira_timeline_harmonisation_m1_targeting') && (0, $2700E.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $da1363e6dcec9b5f$var$timelinePageEntrypoint : $da1363e6dcec9b5f$var$legacyTimelinePageEntrypoint,
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));
const $da1363e6dcec9b5f$var$BusinessTimelineSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $da1363e6dcec9b5f$var$timelineSkeletonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9EWfZ.ThemedLazySkeleton), null));
$da1363e6dcec9b5f$var$BusinessTimelineSkeleton.displayName = "BusinessTimelineSkeleton";
const $da1363e6dcec9b5f$var$timelineSkeletonContainerStyles = (0, $fbAgj.xcss)({
    height: '100%',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.large',
    overflow: 'hidden'
});

});
parcelRegister("8ohhq", function(module, exports) {
$parcel$export(module.exports, "timelineEntrypoint", () => $56e1c497c72415be$export$7586afa83216512a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6SqeW = parcelRequire("6SqeW");

const $56e1c497c72415be$export$7586afa83216512a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7yUhp")), {
        moduleId: "6703f122",
        moduleName: "JiraBusinessTimelineAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6SqeW.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6SqeW", function(module, exports) {
$parcel$export(module.exports, "default", () => $93972fb6f5d748af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e0dee6d5df4b9ca6f2e97644c9331a80>>
 * @relayHash dd0be80be508654ba05aad466cac5497
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13b92611b7053257ce303b6ad9e881a487263bd09a560a3f7dcba673ed920c4d
const $93972fb6f5d748af$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "13b92611b7053257ce303b6ad9e881a487263bd09a560a3f7dcba673ed920c4d",
        "metadata": {},
        "name": "JiraBusinessTimelineAppMemoQuery",
        "operationKind": "query",
        "text": null
    }
};
var $93972fb6f5d748af$export$2e2bcd8739ae039 = $93972fb6f5d748af$var$node;

});

parcelRegister("7yUhp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("kU3ny")
]).then(()=>parcelRequire('7L1tW'));

});


parcelRegister("ksyMR", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineRoute", () => $1942107cd8e6d9b5$export$4c71cfbf61bf0bf3);
const $1942107cd8e6d9b5$export$4c71cfbf61bf0bf3 = {
    name: 'classic-business-timeline',
    path: '/jira/core/projects/:projectKey/timeline/:viewId?',
    exact: true
};

});


parcelRegister("hSdYi", function(module, exports) {
$parcel$export(module.exports, "jiraHomeRouteEntry", () => $80df29770fd6f804$export$578dcb61ac3cb57a);

var $5iIzO = parcelRequire("5iIzO");


var $itEfp = parcelRequire("itEfp");

var $mNSKL = parcelRequire("mNSKL");


var $6RSCO = parcelRequire("6RSCO");

var $fRd8u = parcelRequire("fRd8u");

var $llbQS = parcelRequire("llbQS");

var $jy0b6 = parcelRequire("jy0b6");

var $jOrx3 = parcelRequire("jOrx3");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $7XVba = parcelRequire("7XVba");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $assfe = parcelRequire("assfe");

var $3T5IC = parcelRequire("3T5IC");

var $35eqr = parcelRequire("35eqr");

var $lu9Zb = parcelRequire("lu9Zb");

var $8HUuJ = parcelRequire("8HUuJ");

var $ikYWM = parcelRequire("ikYWM");

var $dTa0V = parcelRequire("dTa0V");

var $aWliK = parcelRequire("aWliK");
const $80df29770fd6f804$var$conditionalPostOfficeJiraYourWorkResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('post_office_ssr_jira_your_work_enabled'), (0, $35eqr.postOfficeJiraYourWorkResource));
const $80df29770fd6f804$var$conditionalPostOfficeJiraForYouCrossflowSolutionsResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jira-crossflow-solutions-for-you-killswitch'), (0, $lu9Zb.postOfficeJiraForYouCrossflowSolutionsResource));
const $80df29770fd6f804$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $3ec8eeeab0e63d24$export$25ee35b01de9d734].promise;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $jOrx3.checkShouldUseJSM)(data);
};
const $80df29770fd6f804$var$jiraHomeEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $mNSKL.jiraHomePageEntryPoint),
    redirect: (0, $5iIzO.onboardingRedirectEntryPoint)
});
const $80df29770fd6f804$export$578dcb61ac3cb57a = (0, $fdS54.createEntry)((0, $3T5IC.jiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        layout: (0, $7XVba.homepageLayout),
        skeleton: (0, $aWliK.componentWithCondition)(()=>(0, $2700E.expVal)('recommended_actions_on_for_you', 'isEnabled', false), (0, $fRd8u.ForYouSkeleton), (0, $ikYWM.YourWorkSkeleton)),
        entryPoint: ()=>$80df29770fd6f804$var$jiraHomeEntryPoint,
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $itEfp.jiraHomeResourceWithCache),
            $80df29770fd6f804$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $llbQS.widgetResources).map((resourceCreator)=>resourceCreator($80df29770fd6f804$var$checkConsolidationOnRouteDependency, [
                    (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
                ])),
            ...(0, $jy0b6.widgetResources).map((resourceCreator)=>resourceCreator($80df29770fd6f804$var$checkConsolidationOnRouteDependency, [
                    (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
                ])),
            // 10/12/2025: This REST resource is temporary and will be removed once we've added an equivalent GraphQL query
            // it will be used in UserSegmentationRedirect to determine if the user has completed the onboarding flow
            (0, $assfe.onboardingFlowCompletedResource),
            $80df29770fd6f804$var$conditionalPostOfficeJiraForYouCrossflowSolutionsResource
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-for-you')
    }));

});
parcelRegister("5iIzO", function(module, exports) {
$parcel$export(module.exports, "onboardingRedirectEntryPoint", () => $95c7c9822c7ea266$export$a82190724a4233be);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $95c7c9822c7ea266$export$a82190724a4233be = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2qGJm")), {
        moduleId: "3e4b1dd9",
        moduleName: "OnboardingRedirect",
        priority: "userVisible",
        /* eslint-disable-line jira/entry-fs/restrict-shell-only-to-navigation-apps */ includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2qGJm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("77l7w").then(()=>parcelRequire('8zzcT'));

});


parcelRegister("itEfp", function(module, exports) {
$parcel$export(module.exports, "jiraHomeResourceWithCache", () => $1d10d0e21f3e7628$export$1da15dc2d924240c);

var $8HUuJ = parcelRequire("8HUuJ");

var $7edbf = parcelRequire("7edbf");

var $2700E = parcelRequire("2700E");
const $1d10d0e21f3e7628$var$RESOURCE_TYPE_JIRA_HOME = 'JIRA_HOME';
const $1d10d0e21f3e7628$var$RESOURCE_TYPE_JIRA_HOME_PROJECT_REC_EXPERIMENT = 'JIRA_HOME_PROJECT_REC_EXPERIMENT';
const $1d10d0e21f3e7628$var$RESOURCE_TYPE_JIRA_HOME_ALL_FOR_YOU_EXPERIMENT = 'JIRA_HOME_ALL_FOR_YOU_EXPERIMENT';
const $1d10d0e21f3e7628$var$RESOURCE_TYPE_JIRA_HOME_ACTIONS_EXPERIMENT = 'JIRA_HOME_ACTIONS_EXPERIMENT';
const $1d10d0e21f3e7628$var$isRecommendedDataRequired = ()=>(0, $2700E.expVal)('recommended_projects_for_you_page', 'isEnabled', false) || (0, $2700E.expVal)('recommended_actions_on_for_you', 'isEnabled', false);




const $1d10d0e21f3e7628$export$1da15dc2d924240c = (0, $8HUuJ.resourceWithCondition)($1d10d0e21f3e7628$var$isRecommendedDataRequired, // recommended_projects_for_you_page or recommended_actions_on_for_you is ON
(0, $8HUuJ.resourceWithCondition)(()=>(0, $2700E.expVal)('recommended_actions_on_for_you', 'isEnabled', false), // Both recommended_projects_for_you_page + recommended_actions_on_for_you are ON
(0, $7edbf.createResource)({
    type: $1d10d0e21f3e7628$var$RESOURCE_TYPE_JIRA_HOME_ALL_FOR_YOU_EXPERIMENT,
    getKey: ()=>'jira-home-for-you-exp',
    getDataLoader: ()=>(parcelRequire("8Oj2L")),
    maxAge: Infinity
}), // Only recommended_projects_for_you_page or recommended_actions_on_for_you is ON
(0, $7edbf.createResource)({
    type: $1d10d0e21f3e7628$var$RESOURCE_TYPE_JIRA_HOME_PROJECT_REC_EXPERIMENT,
    getKey: ()=>'jira-home-2',
    getDataLoader: ()=>(parcelRequire("gf4PX")),
    maxAge: Infinity
})), // recommended_projects_for_you_page is OFF
(0, $8HUuJ.resourceWithCondition)(()=>(0, $2700E.expVal)('recommended_actions_on_for_you', 'isEnabled', false), // Only recommended_actions_on_for_you is ON
(0, $7edbf.createResource)({
    type: $1d10d0e21f3e7628$var$RESOURCE_TYPE_JIRA_HOME_ACTIONS_EXPERIMENT,
    getKey: ()=>'jira-home-actions-exp',
    getDataLoader: ()=>(parcelRequire("7JrWA")),
    maxAge: Infinity
}), // Both experiments are OFF - use old logic
(0, $7edbf.createResource)({
    type: $1d10d0e21f3e7628$var$RESOURCE_TYPE_JIRA_HOME,
    getKey: ()=>'jira-home',
    getDataLoader: ()=>(parcelRequire("6t6Vw")),
    maxAge: Infinity
})));

});
parcelRegister("8Oj2L", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5qtkl").then(()=>parcelRequire('8IEzy'));

});

parcelRegister("gf4PX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jzCDi").then(()=>parcelRequire('9ehF0'));

});

parcelRegister("7JrWA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dlrqZ").then(()=>parcelRequire('tpbpr'));

});

parcelRegister("6t6Vw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cVt7r").then(()=>parcelRequire('d4jy9'));

});


parcelRegister("mNSKL", function(module, exports) {
$parcel$export(module.exports, "jiraHomePageEntryPoint", () => $75ee75298436be54$export$40c7e702efed88fe);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $hEyVe = parcelRequire("hEyVe");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $e8LKF = parcelRequire("e8LKF");

const $75ee75298436be54$export$40c7e702efed88fe = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("h4mSC")), {
        moduleId: "f25d04f9",
        moduleName: "JiraHomePage",
        priority: "interaction"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { cloudId: cloudId } = entryPointRouteParams.tenantContext;
        const isRecommendedTabPreloadedEnabled = (0, $2700E.expValEquals)('recommended_actions_on_for_you', 'isEnabled', true, false) && (0, $2700E.expValEquals)('for_you_recommended_tab_preloaded_query', 'isEnabled', true, false);
        return {
            queries: {
                ...(0, $i860n.fg)('jfy-integrate-new-user-check') && {
                    homePageQuery: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: $e8LKF.default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            },
            entryPoints: {
                // When disabled, omit the key so static route generation does not iterate `undefined`.
                ...isRecommendedTabPreloadedEnabled && {
                    recommendedTab: {
                        entryPoint: (0, $hEyVe.recommendedTabEntryPoint),
                        entryPointParams: entryPointRouteParams
                    }
                }
            },
            extraProps: {}
        };
    }
});

});
parcelRegister("hEyVe", function(module, exports) {
$parcel$export(module.exports, "recommendedTabEntryPoint", () => $3b0c9c089935280e$export$9c4134683f550a0);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $1MUxX = parcelRequire("1MUxX");
// Inlined because entrypoint files restrict cross-package imports.
// NOTE: This logic must stay in sync with JfindForYouEmptyStateActions.get()
// in relay-providers/JfindForYouEmptyStateActions.tsx — keep both updated together.
const $3b0c9c089935280e$var$shouldIncludeGups = (accountId)=>Boolean(accountId) && (0, $i860n.fg)('jfind_onboarding_actions_targeting_request');
// Inlined because entrypoint files restrict cross-package imports
// Keep aligned with NEEDS_INPUT_STATES in @jira/platform__agents-session-state-filters/src/AgentsSessionState.tsx.
const $3b0c9c089935280e$var$getNeedsInputAqlQuery = (atlassianAccountId)=>`userAccountId = '${atlassianAccountId}' AND (state = 'UNKNOWN' OR state = 'INPUT_REQUIRED' OR state = 'AUTH_REQUIRED' OR state = 'REJECTED' OR state = 'FAILED' OR state = 'ARTEFACT_READY' OR state = 'ROVO_GENERATED_PLAN') AND deleted = 'false'`;
const $3b0c9c089935280e$var$getAgentSessionShardingContext = (cloudId, activationId)=>`ari:cloud:jira:${cloudId}:workspace/${activationId}`;

const $3b0c9c089935280e$export$9c4134683f550a0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6t22H")), {
        moduleId: "81dc50df",
        moduleName: "RecommendedTabEntryPointRoot",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, activationId: activationId } = tenantContext;
        const agentSessionVariables = atlassianAccountId != null && (0, $i860n.fg)('jira-fy-recommended-assign-agent') ? {
            aqlQuery: $3b0c9c089935280e$var$getNeedsInputAqlQuery(atlassianAccountId),
            shardingContext: $3b0c9c089935280e$var$getAgentSessionShardingContext(cloudId, activationId),
            first: 20
        } : {};
        return {
            queries: {
                recommendedTabQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1MUxX.default,
                    variables: {
                        cloudId: cloudId,
                        userId: atlassianAccountId ?? '',
                        includeGups: $3b0c9c089935280e$var$shouldIncludeGups(atlassianAccountId),
                        ...agentSessionVariables
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("1MUxX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fd4b72de349eab6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffdd44876a4ce88e9b82aac161024dc8>>
 * @relayHash 678630a9a928ebc4d8b67fb0dc0ae497
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eb60774f0578987201a47de3ab905c8154c05585856f74f3f9137126506fb9e5

var $eISMi = parcelRequire("eISMi");

var $d9BMh = parcelRequire("d9BMh");

var $dg15T = parcelRequire("dg15T");

var $1ZLvK = parcelRequire("1ZLvK");
const $9fd4b72de349eab6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "eb60774f0578987201a47de3ab905c8154c05585856f74f3f9137126506fb9e5",
        "metadata": {},
        "name": "RecommendedTabEntryPointRootQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyRecommendedAssignAgentRelayProvider": (0, $dg15T.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraForYouLandAllNewUsersRelayProvider": (0, $eISMi.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyInvokeAgentExperimentAnalyticsRelayProvider": (0, $d9BMh.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default)
        }
    }
};
var $9fd4b72de349eab6$export$2e2bcd8739ae039 = $9fd4b72de349eab6$var$node;

});
parcelRegister("eISMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ab89bfe5b5b873f$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $3ab89bfe5b5b873f$var$JiraForYouLandAllNewUsersRelayProvider = {
    get () {
        return (0, $2700E.expVal)('jira-for-you-land-all-new-users', 'isEnabled', false);
    }
};
var $3ab89bfe5b5b873f$export$2e2bcd8739ae039 = $3ab89bfe5b5b873f$var$JiraForYouLandAllNewUsersRelayProvider;

});

parcelRegister("d9BMh", function(module, exports) {
$parcel$export(module.exports, "default", () => $977457f90dcf55bc$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $977457f90dcf55bc$var$JiraFyInvokeAgentExperimentAnalyticsRelayProvider = {
    get () {
        return (0, $i860n.fg)('pack-2222-fyp-all-other-analytics');
    }
};
var $977457f90dcf55bc$export$2e2bcd8739ae039 = $977457f90dcf55bc$var$JiraFyInvokeAgentExperimentAnalyticsRelayProvider;

});

parcelRegister("dg15T", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8b25c3f3e1dd9ab$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $f8b25c3f3e1dd9ab$var$JiraFyRecommendedAssignAgentRelayProvider = {
    get () {
        return (0, $i860n.fg)('jira-fy-recommended-assign-agent');
    }
};
var $f8b25c3f3e1dd9ab$export$2e2bcd8739ae039 = $f8b25c3f3e1dd9ab$var$JiraFyRecommendedAssignAgentRelayProvider;

});


parcelRegister("6t22H", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("fliWi")
]).then(()=>parcelRequire('8YaGE'));

});


parcelRegister("e8LKF", function(module, exports) {
$parcel$export(module.exports, "default", () => $da9d9b1e851579f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2234b2dfce04408e87b4d0918f07dd5>>
 * @relayHash bf139aee88b1dec9dc815090d1967944
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6526ad2bb351934beef6d4df9ac8033ae4a5204261a17940fba9154fdb500107
const $da9d9b1e851579f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JiraHomePageQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "HomeTopSection_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JiraHomePageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "isUserActiveInAnySpace"
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 4
                                }
                            ],
                            "concreteType": "JiraSpaceSearchForYouConnection",
                            "kind": "LinkedField",
                            "name": "spaceSearchForYou",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpaceSearchForYouError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSpaceSearchForYouEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 7
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "recommend",
                                                            "value": true
                                                        }
                                                    ],
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        },
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:7,recommend:true)"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "recommendationType"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6526ad2bb351934beef6d4df9ac8033ae4a5204261a17940fba9154fdb500107",
            "metadata": {},
            "name": "JiraHomePageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$da9d9b1e851579f2$var$node.hash = "9b677acefbfb5e123352186fb122c885";
var $da9d9b1e851579f2$export$2e2bcd8739ae039 = $da9d9b1e851579f2$var$node;

});

parcelRegister("h4mSC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("9oDma")
]).then(()=>parcelRequire('1fNDN'));

});


parcelRegister("fRd8u", function(module, exports) {
$parcel$export(module.exports, "ForYouSkeleton", () => $8af8de073a6e2c47$export$f4a3777a40dfc0e1);
/* ForYouSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $e1nie = parcelRequire("e1nie");
const $8af8de073a6e2c47$var$containerStyles = {
    width: '100%',
    maxWidth: '1232px',
    marginInline: 'auto'
};
const $8af8de073a6e2c47$var$customCssStyles = null;
const $8af8de073a6e2c47$export$f4a3777a40dfc0e1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e1nie))),
        containerStyles: $8af8de073a6e2c47$var$containerStyles,
        className: (0, $4jQY2.default)([
            "_2zz1idpf"
        ])
    });
$8af8de073a6e2c47$export$f4a3777a40dfc0e1.displayName = "ForYouSkeleton";

});
parcelRegister("e1nie", function(module, exports) {
module.exports = new URL("for-you-skeleton.tpl.cba1dcf4.svg", import.meta.url).toString();

});


parcelRegister("llbQS", function(module, exports) {
$parcel$export(module.exports, "myTeamsResource", () => $8b0fb04c7ef9b552$export$602f373f7fdaccc1);
$parcel$export(module.exports, "statusResource", () => $8b0fb04c7ef9b552$export$8f57164cc67fb360);
$parcel$export(module.exports, "userTimelineResource", () => $8b0fb04c7ef9b552$export$35b906dc2329cdc6);
$parcel$export(module.exports, "schedulesResource", () => $8b0fb04c7ef9b552$export$f9574b51fbc36dc3);
$parcel$export(module.exports, "resources", () => $8b0fb04c7ef9b552$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "widgetResources", () => $8b0fb04c7ef9b552$export$bce3244764eac6e6);
$parcel$export(module.exports, "createMyTeamsResource", () => (parcelRequire("igOOU")).createMyTeamsResource);
$parcel$export(module.exports, "createStatusResource", () => (parcelRequire("owlsy")).createStatusResource);
$parcel$export(module.exports, "createUserTimelineResource", () => (parcelRequire("iR7lP")).createUserTimelineResource);
$parcel$export(module.exports, "createSchedulesResource", () => (parcelRequire("eBufL")).createSchedulesResource);
parcelRequire("lrLEP");
var $1OYWB = parcelRequire("1OYWB");

var $igOOU = parcelRequire("igOOU");

var $8yemE = parcelRequire("8yemE");

var $eBufL = parcelRequire("eBufL");

var $owlsy = parcelRequire("owlsy");

var $iR7lP = parcelRequire("iR7lP");
const $8b0fb04c7ef9b552$export$602f373f7fdaccc1 = (0, $igOOU.createMyTeamsResource)();
const $8b0fb04c7ef9b552$export$f363fac02afee7a4 = (0, $8yemE.createOpsTeamsResource)();
const $8b0fb04c7ef9b552$export$8f57164cc67fb360 = (0, $owlsy.createStatusResource)();
const $8b0fb04c7ef9b552$export$35b906dc2329cdc6 = (0, $iR7lP.createUserTimelineResource)();
const $8b0fb04c7ef9b552$export$f9574b51fbc36dc3 = (0, $eBufL.createSchedulesResource)();
const $8b0fb04c7ef9b552$export$bc99aaabaf7b70a7 = [
    (0, $1OYWB.eocUserResource),
    (0, $igOOU.createMyTeamsResource)(),
    (0, $owlsy.createStatusResource)(),
    (0, $8yemE.createOpsTeamsResource)()
];
const $8b0fb04c7ef9b552$export$bce3244764eac6e6 = [
    ()=>(0, $1OYWB.eocUserResource),
    (callback, depends)=>(0, $igOOU.createMyTeamsResource)(callback, depends),
    (callback, depends)=>(0, $owlsy.createStatusResource)(callback, depends),
    (callback, depends)=>(0, $iR7lP.createUserTimelineResource)(callback, depends),
    (callback, depends)=>(0, $eBufL.createSchedulesResource)(callback, depends)
];

});
parcelRegister("igOOU", function(module, exports) {
$parcel$export(module.exports, "createMyTeamsResource", () => $f8457f30c7b97a80$export$bf86fb90d0661bcb);

var $7edbf = parcelRequire("7edbf");

var $5ZjLL = parcelRequire("5ZjLL");
const $f8457f30c7b97a80$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'myTeamsResource',
        getKey: ()=>'myTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $5ZjLL.getMyTeamsEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("5ZjLL", function(module, exports) {
$parcel$export(module.exports, "getMyTeamsEndpoint", () => $bb4848a935301616$export$abe46da7d1f191a7);

var $hG5S4 = parcelRequire("hG5S4");
const $bb4848a935301616$export$abe46da7d1f191a7 = ()=>{
    return (0, $hG5S4.eocFetch)(`/v1/alerts/responders/suggested`);
};

});


parcelRegister("8yemE", function(module, exports) {
$parcel$export(module.exports, "createOpsTeamsResource", () => $f6fed815eefa1736$export$99505a9d792f516c);

var $7edbf = parcelRequire("7edbf");

var $jlIl9 = parcelRequire("jlIl9");
const $f6fed815eefa1736$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'opsTeamsResource',
        getKey: ()=>'opsTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $jlIl9.getOpsTeamsEndpoint)().then((response)=>{
                return response.values;
            });
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("jlIl9", function(module, exports) {
$parcel$export(module.exports, "getOpsTeamsEndpoint", () => $d21c33f1ebd05087$export$7498ba30158c16cd);

var $hG5S4 = parcelRequire("hG5S4");

var $bB4sX = parcelRequire("bB4sX");
const $d21c33f1ebd05087$export$7498ba30158c16cd = ()=>{
    return (0, $hG5S4.eocFetch)((0, $bB4sX.urls).teams.url());
};

});
parcelRegister("bB4sX", function(module, exports) {
$parcel$export(module.exports, "urls", () => $b48b6185b3570b93$export$bcae9ba627f604b6);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $b48b6185b3570b93$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $b48b6185b3570b93$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "WhoIsOnCallHandler", () => $b48b6185b3570b93$export$1e7191618d5d4548);
$parcel$export(module.exports, "WhoIsOnCallWidgetHandler", () => $b48b6185b3570b93$export$d05bbb1ada0e07c4);
const $b48b6185b3570b93$export$bcae9ba627f604b6 = Object.freeze({
    schedules: {
        url: ()=>`/v1/schedules`,
        user: {
            url: ()=>`${$b48b6185b3570b93$export$bcae9ba627f604b6.schedules.url()}/user`,
            timeline: {
                url: ()=>`${$b48b6185b3570b93$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                export: {
                    url: ()=>`${$b48b6185b3570b93$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                }
            },
            userId: {
                url: ({ userId: userId } = {
                    userId: ':userId'
                })=>`${$b48b6185b3570b93$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
            }
        },
        onCalls: {
            url: ()=>`${$b48b6185b3570b93$export$bcae9ba627f604b6.schedules.url()}/on-calls`
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`${$b48b6185b3570b93$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$b48b6185b3570b93$export$bcae9ba627f604b6.schedules.scheduleId.url({
                        scheduleId: scheduleId
                    })}/timeline`
            }
        }
    },
    wioc: {
        status: {
            url: ()=>`${$b48b6185b3570b93$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
        }
    },
    teams: {
        url: ()=>`/v1/teams`
    }
});
const $b48b6185b3570b93$export$a7c923252528b255 = {
    firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
};
const $b48b6185b3570b93$export$38c46ed7a5bc80a0 = {
    overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
};
class $b48b6185b3570b93$export$1e7191618d5d4548 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}
class $b48b6185b3570b93$export$d05bbb1ada0e07c4 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}

});



parcelRegister("eBufL", function(module, exports) {
$parcel$export(module.exports, "createSchedulesResource", () => $43011b6d21a9b82c$export$b5e65ca3f82b01c5);

var $7edbf = parcelRequire("7edbf");

var $5qUOL = parcelRequire("5qUOL");
const $43011b6d21a9b82c$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'schedulesResource',
        getKey: ()=>'schedulesResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $5qUOL.getSchedulesEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("5qUOL", function(module, exports) {
$parcel$export(module.exports, "getSchedulesEndpoint", () => $15f98c8303c5571d$export$e8e940098db1b988);

var $hG5S4 = parcelRequire("hG5S4");

var $bB4sX = parcelRequire("bB4sX");
const $15f98c8303c5571d$export$e8e940098db1b988 = ()=>{
    return (0, $hG5S4.eocFetch)(`${(0, $bB4sX.urls).schedules.onCalls.url()}`);
};

});


parcelRegister("owlsy", function(module, exports) {
$parcel$export(module.exports, "createStatusResource", () => $e76674c93d3ecf87$export$3d1c353e2693418c);

var $7edbf = parcelRequire("7edbf");

var $3k0zF = parcelRequire("3k0zF");

var $k9Bwl = parcelRequire("k9Bwl");
const $e76674c93d3ecf87$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'statusResource',
        getKey: ()=>'statusResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $3k0zF.getStatus)().then((0, $k9Bwl.transformStatusResponse));
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("3k0zF", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $19830fc984a26a6a$export$b70265791d2079d4);

var $hG5S4 = parcelRequire("hG5S4");

var $bB4sX = parcelRequire("bB4sX");
const $19830fc984a26a6a$export$b70265791d2079d4 = ()=>{
    return (0, $hG5S4.eocFetch)((0, $bB4sX.urls).wioc.status.url(), {
        method: 'GET'
    });
};

});

parcelRegister("k9Bwl", function(module, exports) {
$parcel$export(module.exports, "transformStatusResponse", () => $6d7d852a02d8cd6a$export$44a749c89534e42c);
const $6d7d852a02d8cd6a$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
    return {
        currentDate: currentTimeUtcMillis,
        currentShiftEnd: onCallUntilUtcMillis,
        currentShiftEndOffset: onCallUntilOffsetMillis,
        isOnCall: isCurrentOnCall,
        isParticipantOfAnyRotation: isParticipantOfAnyRotation,
        nextEndDate: nextOnCallEndUtcMillis,
        nextEndOffset: nextOnCallEndOffsetMillis,
        nextStartDate: nextOnCallStartUtcMillis,
        nextStartOffset: nextOnCallStartOffsetMillis
    };
};

});


parcelRegister("iR7lP", function(module, exports) {
$parcel$export(module.exports, "createUserTimelineResource", () => $ceab84abcafaa012$export$a479dcc35c33def1);

var $7edbf = parcelRequire("7edbf");
parcelRequire("lrLEP");
var $1OYWB = parcelRequire("1OYWB");

var $l80El = parcelRequire("l80El");
const $ceab84abcafaa012$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'userTimelineResource',
        getKey: ()=>'userTimelineResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await dependencies[(0, $1OYWB.eocUserResource).type]?.promise;
            // Since depends API types are not exported it's impossible to infer types,
            // thus we have to use casting
            const accountId = data?.accountId;
            const timezone = data?.timeZone;
            if (!accountId || !timezone) return null;
            return (0, $l80El.getWidgetTimeline)(accountId);
        },
        isBrowserOnly: true,
        depends: [
            ...depends ? depends : [],
            (0, $1OYWB.eocUserResource).type
        ]
    });

});
parcelRegister("l80El", function(module, exports) {
$parcel$export(module.exports, "getWidgetTimeline", () => $33212fa3f78044c3$export$bd80cae08a85b1f0);

var $K3BT5 = parcelRequire("K3BT5");

var $hG5S4 = parcelRequire("hG5S4");

var $bB4sX = parcelRequire("bB4sX");

var $rjls0 = parcelRequire("rjls0");
const $33212fa3f78044c3$export$bd80cae08a85b1f0 = (accountId)=>{
    const formattedCurrent = (0, $K3BT5.default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    const urlParams = new URLSearchParams({
        currentDate: formattedCurrent,
        accountId: accountId,
        mode: 'timeline',
        timelineType: '6'
    });
    return (0, $hG5S4.eocFetch)(`${(0, $bB4sX.urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
        method: 'GET'
    }).then((0, $rjls0.transformUserTimelineResponse));
};

});
parcelRegister("K3BT5", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a718e19076e21d$export$2e2bcd8739ae039);

var $3ZYbY = parcelRequire("3ZYbY");

var $40Sfw = parcelRequire("40Sfw");

var $5zWPH = parcelRequire("5zWPH");
function $08a718e19076e21d$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYbY)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $40Sfw.default)((0, $5zWPH.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("40Sfw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ec13e53438779ad$export$2e2bcd8739ae039);

var $6CZmd = parcelRequire("6CZmd");

var $6iM9O = parcelRequire("6iM9O");

var $bcN2z = parcelRequire("bcN2z");
var $2ec13e53438779ad$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $2ec13e53438779ad$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($2ec13e53438779ad$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $bcN2z.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $6iM9O.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CZmd)))(dirtyDate, formatStr, options);
}

});
parcelRegister("6iM9O", function(module, exports) {
$parcel$export(module.exports, "default", () => $4969c786b4ab9ade$export$2e2bcd8739ae039);

var $aZu1y = parcelRequire("aZu1y");

var $1kSLh = parcelRequire("1kSLh");
var $4969c786b4ab9ade$var$MILLISECONDS_IN_MINUTE = 60000;
var $4969c786b4ab9ade$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $4969c786b4ab9ade$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $4969c786b4ab9ade$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $4969c786b4ab9ade$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $4969c786b4ab9ade$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $4969c786b4ab9ade$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $4969c786b4ab9ade$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $4969c786b4ab9ade$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $4969c786b4ab9ade$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $4969c786b4ab9ade$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $4969c786b4ab9ade$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $4969c786b4ab9ade$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $aZu1y.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $aZu1y.default)('long', date, options);
        }
    }
};
function $4969c786b4ab9ade$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $1kSLh.default)(timeZone, originalDate, true) / $4969c786b4ab9ade$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $4969c786b4ab9ade$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $4969c786b4ab9ade$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $4969c786b4ab9ade$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $4969c786b4ab9ade$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $4969c786b4ab9ade$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $4969c786b4ab9ade$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $4969c786b4ab9ade$var$formatTimezone(offset, dirtyDelimeter);
}
function $4969c786b4ab9ade$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $4969c786b4ab9ade$var$addLeadingZeros(minutes, 2);
}
var $4969c786b4ab9ade$export$2e2bcd8739ae039 = $4969c786b4ab9ade$var$formatters;

});
parcelRegister("aZu1y", function(module, exports) {
$parcel$export(module.exports, "default", () => $8006e40d8697ad3f$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $8006e40d8697ad3f$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $8006e40d8697ad3f$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $8006e40d8697ad3f$var$partsTimeZone(dtf, date) : $8006e40d8697ad3f$var$hackyTimeZone(dtf, date);
}
function $8006e40d8697ad3f$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $8006e40d8697ad3f$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $8006e40d8697ad3f$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("1kSLh", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f922338f3b61796$export$2e2bcd8739ae039);

var $bOg30 = parcelRequire("bOg30");

var $c0gXI = parcelRequire("c0gXI");
var $0f922338f3b61796$var$MILLISECONDS_IN_HOUR = 3600000;
var $0f922338f3b61796$var$MILLISECONDS_IN_MINUTE = 60000;
var $0f922338f3b61796$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $0f922338f3b61796$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $0f922338f3b61796$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $0f922338f3b61796$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$0f922338f3b61796$var$validateTimezone(hours)) return NaN;
        return -(hours * $0f922338f3b61796$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $0f922338f3b61796$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$0f922338f3b61796$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $0f922338f3b61796$var$MILLISECONDS_IN_HOUR + minutes * $0f922338f3b61796$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($0f922338f3b61796$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $0f922338f3b61796$var$toUtcDate(date);
        var offset = $0f922338f3b61796$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $0f922338f3b61796$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $0f922338f3b61796$var$toUtcDate(date) {
    return (0, $c0gXI.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $0f922338f3b61796$var$calcOffset(date, timezoneString) {
    var tokens = (0, $bOg30.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $c0gXI.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $0f922338f3b61796$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $0f922338f3b61796$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $0f922338f3b61796$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $0f922338f3b61796$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $0f922338f3b61796$var$validIANATimezoneCache = {};
function $0f922338f3b61796$var$isValidTimezoneIANAString(timeZoneString) {
    if ($0f922338f3b61796$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $0f922338f3b61796$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("bOg30", function(module, exports) {
$parcel$export(module.exports, "default", () => $8990cfecda26f5bc$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $8990cfecda26f5bc$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $8990cfecda26f5bc$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $8990cfecda26f5bc$var$partsOffset(dtf, date) : $8990cfecda26f5bc$var$hackyOffset(dtf, date);
}
var $8990cfecda26f5bc$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $8990cfecda26f5bc$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $8990cfecda26f5bc$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $8990cfecda26f5bc$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $8990cfecda26f5bc$var$dtfCache = {};
function $8990cfecda26f5bc$var$getDateTimeFormat(timeZone) {
    if (!$8990cfecda26f5bc$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $8990cfecda26f5bc$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $8990cfecda26f5bc$var$dtfCache[timeZone];
}

});

parcelRegister("c0gXI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0241553b9f7fbed5$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $0241553b9f7fbed5$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("bcN2z", function(module, exports) {
$parcel$export(module.exports, "default", () => $8286db1b6ab15e60$export$2e2bcd8739ae039);

var $r1m99 = parcelRequire("r1m99");

var $fKom7 = parcelRequire("fKom7");

var $1kSLh = parcelRequire("1kSLh");

var $5QXKL = parcelRequire("5QXKL");
var $8286db1b6ab15e60$var$MILLISECONDS_IN_HOUR = 3600000;
var $8286db1b6ab15e60$var$MILLISECONDS_IN_MINUTE = 60000;
var $8286db1b6ab15e60$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $8286db1b6ab15e60$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $5QXKL.default)
};
function $8286db1b6ab15e60$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $8286db1b6ab15e60$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($r1m99)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $8286db1b6ab15e60$var$splitDateString(argument);
    var parseYearResult = $8286db1b6ab15e60$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $8286db1b6ab15e60$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $8286db1b6ab15e60$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $1kSLh.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($fKom7)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($fKom7)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $8286db1b6ab15e60$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $8286db1b6ab15e60$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $8286db1b6ab15e60$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $8286db1b6ab15e60$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $8286db1b6ab15e60$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $8286db1b6ab15e60$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $8286db1b6ab15e60$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $8286db1b6ab15e60$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $8286db1b6ab15e60$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $8286db1b6ab15e60$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $8286db1b6ab15e60$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$8286db1b6ab15e60$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $8286db1b6ab15e60$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$8286db1b6ab15e60$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $8286db1b6ab15e60$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$8286db1b6ab15e60$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $8286db1b6ab15e60$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$8286db1b6ab15e60$var$validateWeekDate(year, week)) return new Date(NaN);
        return $8286db1b6ab15e60$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $8286db1b6ab15e60$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$8286db1b6ab15e60$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $8286db1b6ab15e60$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $8286db1b6ab15e60$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $8286db1b6ab15e60$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$8286db1b6ab15e60$var$validateTime(hours)) return NaN;
        return hours % 24 * $8286db1b6ab15e60$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $8286db1b6ab15e60$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$8286db1b6ab15e60$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $8286db1b6ab15e60$var$MILLISECONDS_IN_HOUR + minutes * $8286db1b6ab15e60$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $8286db1b6ab15e60$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$8286db1b6ab15e60$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $8286db1b6ab15e60$var$MILLISECONDS_IN_HOUR + minutes * $8286db1b6ab15e60$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $8286db1b6ab15e60$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $8286db1b6ab15e60$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8286db1b6ab15e60$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $8286db1b6ab15e60$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $8286db1b6ab15e60$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $8286db1b6ab15e60$var$isLeapYearIndex(year);
        if (isLeapYear && date > $8286db1b6ab15e60$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $8286db1b6ab15e60$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $8286db1b6ab15e60$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $8286db1b6ab15e60$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $8286db1b6ab15e60$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $8286db1b6ab15e60$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("5QXKL", function(module, exports) {
$parcel$export(module.exports, "default", () => $443028d9b4b50e6f$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $443028d9b4b50e6f$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $443028d9b4b50e6f$export$2e2bcd8739ae039 = $443028d9b4b50e6f$var$tzPattern;

});



parcelRegister("5zWPH", function(module, exports) {
$parcel$export(module.exports, "default", () => $40fddb9d28906069$export$2e2bcd8739ae039);

var $1kSLh = parcelRequire("1kSLh");

var $bcN2z = parcelRequire("bcN2z");
function $40fddb9d28906069$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $bcN2z.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $1kSLh.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("rjls0", function(module, exports) {
$parcel$export(module.exports, "transformUserTimelineResponse", () => $728fa2c27bdf7fc0$export$78049913b79774a2);

var $l3hew = parcelRequire("l3hew");
const $728fa2c27bdf7fc0$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
    return {
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        nowEpoch: currentTime,
        startOffset: startOffsetMillis,
        endOffset: endOffsetMillis,
        nowOffset: utcTimeOffsetMillis,
        data: {
            ...data,
            periods: periods.map((0, $l3hew.fromMergedPeriodResponseToClusterPeriod))
        }
    };
};

});
parcelRegister("l3hew", function(module, exports) {
$parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", () => $a5e1800a7693feb0$export$9b0bac75f135bd57);
const $a5e1800a7693feb0$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
    const clusterPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingPeriods.map($a5e1800a7693feb0$var$fromOverlappingPeriodResponseToOverlappingPeriod)
    };
    return clusterPeriod;
};
const $a5e1800a7693feb0$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
    const overlappingPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingRotations,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime
    };
    return overlappingPeriod;
};

});





parcelRegister("jy0b6", function(module, exports) {
$parcel$export(module.exports, "openAlertsResource", () => $5388cb45521af57b$export$fb6d91a24bfaa074);
$parcel$export(module.exports, "ackedAlertsResource", () => $5388cb45521af57b$export$3917a9639b1be557);
$parcel$export(module.exports, "snoozedAlertsResource", () => $5388cb45521af57b$export$f62d237df457042d);
$parcel$export(module.exports, "widgetResources", () => $5388cb45521af57b$export$bce3244764eac6e6);

var $7edbf = parcelRequire("7edbf");

var $45JkB = parcelRequire("45JkB");

var $87F7N = parcelRequire("87F7N");
const $5388cb45521af57b$export$e5eb8aade1d4272a = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'openAlertsResource',
        getKey: ()=>'openAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $87F7N.fetchAlerts)({
                searchParams: {
                    query: (0, $45JkB.PredefinedQueries).MY_OPEN_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $5388cb45521af57b$export$66760ff81022525f = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'ackedAlertsResource',
        getKey: ()=>'ackedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $87F7N.fetchAlerts)({
                searchParams: {
                    query: (0, $45JkB.PredefinedQueries).MY_ACKED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $5388cb45521af57b$export$73c7fe1d8124595f = (checkConsolidationOnRouteDependency, depends)=>(0, $7edbf.createResource)({
        type: 'snoozedAlertsResource',
        getKey: ()=>'snoozedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $87F7N.fetchAlerts)({
                searchParams: {
                    query: (0, $45JkB.PredefinedQueries).MY_SNOOZED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $5388cb45521af57b$export$fb6d91a24bfaa074 = $5388cb45521af57b$export$e5eb8aade1d4272a();
const $5388cb45521af57b$export$3917a9639b1be557 = $5388cb45521af57b$export$66760ff81022525f();
const $5388cb45521af57b$export$f62d237df457042d = $5388cb45521af57b$export$73c7fe1d8124595f();
const $5388cb45521af57b$export$bce3244764eac6e6 = [
    (callback, depends)=>$5388cb45521af57b$export$e5eb8aade1d4272a(callback, depends),
    (callback, depends)=>$5388cb45521af57b$export$66760ff81022525f(callback, depends),
    (callback, depends)=>$5388cb45521af57b$export$73c7fe1d8124595f(callback, depends)
];

});
parcelRegister("45JkB", function(module, exports) {
$parcel$export(module.exports, "PredefinedQueries", () => $a1547938e5ee5cc4$export$ed6721f2880ce367);
$parcel$export(module.exports, "GLOBAL_ALERTS_ROUTE_NAME", () => $a1547938e5ee5cc4$export$ba93b3de87c980dc);
$parcel$export(module.exports, "GLOBAL_ALERT_DETAIL_ROUTE_NAME", () => $a1547938e5ee5cc4$export$1881423041ad1b5c);
const $a1547938e5ee5cc4$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $a1547938e5ee5cc4$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $a1547938e5ee5cc4$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$a1547938e5ee5cc4$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$a1547938e5ee5cc4$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$a1547938e5ee5cc4$var$ONLY_MY_SELECTOR_QUERY}`
};
const $a1547938e5ee5cc4$export$d4c72bab9d6cc13a = {};
const $a1547938e5ee5cc4$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $a1547938e5ee5cc4$export$ba93b3de87c980dc = 'eoc-global-alerts';
const $a1547938e5ee5cc4$export$1881423041ad1b5c = 'eoc-global-alert-detail';

});

parcelRegister("87F7N", function(module, exports) {
$parcel$export(module.exports, "fetchAlerts", () => $526e07c12d921792$export$f7b1e2075b3da718);

var $hG5S4 = parcelRequire("hG5S4");
const $526e07c12d921792$export$f7b1e2075b3da718 = async ({ searchParams: searchParams })=>{
    const params = new URLSearchParams(searchParams ?? {});
    return (0, $hG5S4.eocFetch)(`/v1/alerts/?${params.toString()}`);
};

});


parcelRegister("assfe", function(module, exports) {
$parcel$export(module.exports, "onboardingFlowCompletedResource", () => $b07ccccac780a0e5$export$a5933abdd506ddab);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $h2wCv = parcelRequire("h2wCv");
const $b07ccccac780a0e5$export$a5933abdd506ddab = (0, $7edbf.createResource)({
    type: 'ONBOARDING_FLOW_COMPLETED_RESOURCE',
    getKey: ()=>'onboarding_flow_completed',
    getData: async ()=>{
        try {
            const response = await (0, $h2wCv.performGetRequest)('/rest/onboarding/1.0/flow/completed');
            return {
                completed: response.completed
            };
        } catch (err) {
            const normalizedError = err instanceof Error ? err : new Error(JSON.stringify(err));
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'onboardingFlowCompleted.resourceError',
                    packageName: 'jiraRouterResourcesJswOnboarding',
                    teamName: 'jlove-makkuro'
                },
                attributes: {
                    action: 'fetchOnboardingFlowCompleted'
                },
                error: normalizedError
            });
            // Default to true if the request fails to avoid users completing onboarding multiple times
            return {
                completed: true
            };
        }
    },
    maxAge: 0
});
const $b07ccccac780a0e5$export$9d3559823a617fbc = ()=>(0, $k6ufm.useResource)($b07ccccac780a0e5$export$a5933abdd506ddab);

});

parcelRegister("lu9Zb", function(module, exports) {
$parcel$export(module.exports, "postOfficeJiraForYouCrossflowSolutionsResource", () => $99dfd706affecffa$export$c667051404d15964);
// eslint-disable-next-line jira/import-whitelist

var $cr9yX = parcelRequire("cr9yX");

var $7edbf = parcelRequire("7edbf");
const $99dfd706affecffa$export$c667051404d15964 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_FOR_YOU_CROSSFLOW_SOLUTIONS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-for-you-crossflow-solutions', tenantContext);
    },
    maxAge: Infinity
});

});

parcelRegister("ikYWM", function(module, exports) {
$parcel$export(module.exports, "YourWorkSkeleton", () => $b5746b468ca0dc50$export$62cf62fa23284b71);
$parcel$export(module.exports, "YourWorkItemListSkeleton", () => $b5746b468ca0dc50$export$31cebe1052db844);

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $3UNPo = parcelRequire("3UNPo");

var $fhigi = parcelRequire("fhigi");
const $b5746b468ca0dc50$export$62cf62fa23284b71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3UNPo)))
    });
$b5746b468ca0dc50$export$62cf62fa23284b71.displayName = "YourWorkSkeleton";
const $b5746b468ca0dc50$export$31cebe1052db844 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fhigi))),
        containerStyles: {
            maxHeight: '30em'
        }
    });
$b5746b468ca0dc50$export$31cebe1052db844.displayName = "YourWorkItemListSkeleton";

});
parcelRegister("3UNPo", function(module, exports) {
module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();

});

parcelRegister("fhigi", function(module, exports) {
module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();

});



parcelRegister("1srm4", function(module, exports) {
$parcel$export(module.exports, "jiraSearchRouteEntry", () => $9fbe5a95fd9813d0$export$76b74d5744e69817);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $cTMdB = parcelRequire("cTMdB");

var $8JWHB = parcelRequire("8JWHB");

var $gExHA = parcelRequire("gExHA");
const $9fbe5a95fd9813d0$export$76b74d5744e69817 = (0, $fdS54.createEntry)((0, $cTMdB.jiraSearchRoute), ()=>({
        group: 'redirects',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8JWHB.JiraSearchRedirect),
        isRedirect: true,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $gExHA.jiraSearchResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cTMdB", function(module, exports) {
$parcel$export(module.exports, "jiraSearchRoute", () => $faaaf3c8242787e5$export$a3a93dcf611b611a);
const $faaaf3c8242787e5$export$a3a93dcf611b611a = {
    name: 'jira-search',
    path: '/jira/search',
    exact: true
};

});

parcelRegister("8JWHB", function(module, exports) {
$parcel$export(module.exports, "JiraSearchRedirect", () => $cacda03c3f7b273d$export$ee180957879b33ac);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $jM84B = parcelRequire("jM84B");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");

var $aQcz3 = parcelRequire("aQcz3");

var $gExHA = parcelRequire("gExHA");
const $cacda03c3f7b273d$export$ee180957879b33ac = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)((0, $gExHA.jiraSearchResource));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jM84B.IssueViewSkeleton), null);
    if (error || !data?.url) // handle api error state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aQcz3.QuickSearchToGlobalIssueNavigatorRedirect), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: data.url,
        push: false
    });
};
$cacda03c3f7b273d$export$ee180957879b33ac.displayName = "JiraSearchRedirect";

});
parcelRegister("aQcz3", function(module, exports) {
$parcel$export(module.exports, "QuickSearchToGlobalIssueNavigatorRedirect", () => $080244183dd8a909$export$968c2900ae111000);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4Onaa = parcelRequire("4Onaa");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $gNbXR = parcelRequire("gNbXR");
var $2ffUK = parcelRequire("2ffUK");
const $080244183dd8a909$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $gNbXR.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, $aJ81Y.fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $inMxE.useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, $4Onaa.useCurrentRoute), useQueryParam: useQueryParam = (0, $2ffUK.useQueryParam) })=>{
    const route = useCurrentRoute();
    const [searchString] = useQueryParam('searchString');
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
    (0, $euxye.useEffect)(()=>{
        if (!route) return;
        const screenEvent = createAnalyticsEvent({
            screenName: 'quickSearchRedirect',
            attributes: {
                type: route.name
            }
        });
        fireScreenAnalytics(screenEvent);
    }, [
        createAnalyticsEvent,
        fireScreenAnalytics,
        route
    ]);
    const jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
    const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Redirect, {
        to: redirectUrl
    });
};
$080244183dd8a909$export$968c2900ae111000.displayName = "QuickSearchToGlobalIssueNavigatorRedirect";
const $080244183dd8a909$var$JiraGlobalIssueNavigatorRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($080244183dd8a909$export$968c2900ae111000, null);
$080244183dd8a909$var$JiraGlobalIssueNavigatorRedirect.displayName = "JiraGlobalIssueNavigatorRedirect";
var $080244183dd8a909$export$2e2bcd8739ae039 = $080244183dd8a909$var$JiraGlobalIssueNavigatorRedirect;

});

parcelRegister("gExHA", function(module, exports) {
$parcel$export(module.exports, "jiraSearchResource", () => $9bbb69102618c71f$export$d23832be0ebf8a93);
/* eslint-disable jira/naming/disallow-filenames */ 
var $bS1iz = parcelRequire("bS1iz");

var $i860n = parcelRequire("i860n");

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");
const $9bbb69102618c71f$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
const $9bbb69102618c71f$export$d23832be0ebf8a93 = (0, $7edbf.createResource)({
    type: $9bbb69102618c71f$export$486bd66a4d919be7,
    // Key per resolved query (the params getData fetches on). A constant key lets a
    // debounced prefetch for one query be reused by react-resource-router for a
    // different submit, landing the user on a stale search. Gated with that prefetch.
    getKey: ({ query: query })=>(0, $i860n.fg)('quick_find_typing_debounce_prefetch') ? `search-${(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
            ...query
        })}` : 'search',
    getData: ({ query: query }, { tenantContext: tenantContext })=>{
        const { atlassianAccountId: atlassianAccountId } = tenantContext;
        if (!atlassianAccountId || !query?.searchString) return null;
        // ideally to calculate NIN search relevance while transitioning from the dialog, we would want to pass in multiple query params.
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
            ...query
        });
        return (0, $4fhEY.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    },
    isBrowserOnly: true
});

});



parcelRegister("lUnDC", function(module, exports) {
$parcel$export(module.exports, "journeysListRouteEntry", () => $bdb16d2720fe24fe$export$d1d23e2ba1e2bc7a);


var $9jd1G = parcelRequire("9jd1G");

var $geK05 = parcelRequire("geK05");

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iSkKl = parcelRequire("iSkKl");

var $74h93 = parcelRequire("74h93");

var $2EQPz = parcelRequire("2EQPz");

var $6pofw = parcelRequire("6pofw");

var $i860n = parcelRequire("i860n");

var $4lWtN = parcelRequire("4lWtN");

var $dTa0V = parcelRequire("dTa0V");
const $bdb16d2720fe24fe$var$journeysListPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9jd1G.journeysListEntryPoint),
    horizontalNavigation: (0, $geK05.journeysHorizontalNavEntryPoint)
});
const $bdb16d2720fe24fe$var$notFoundPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4lWtN.notFoundEntrypoint)
});
const $bdb16d2720fe24fe$export$d1d23e2ba1e2bc7a = (0, $fdS54.createEntry)((0, $iSkKl.journeysListRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.journeys-list',
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>null,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm-active-journeys-table-m0') ? $bdb16d2720fe24fe$var$journeysListPageEntryPoint : $bdb16d2720fe24fe$var$notFoundPageEntryPoint,
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        meta: {
            reporting: {
                id: 'journeys-list',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).JOURNEYS),
                teamName: 'JSM Grape Soju'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9jd1G", function(module, exports) {
$parcel$export(module.exports, "journeysListEntryPoint", () => $02309a72549aca7a$export$d0f58ae631aec13a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $hiYJF = parcelRequire("hiYJF");
const $02309a72549aca7a$var$JOURNEYS_LIST_FIELD_SET_IDS = [
    'issuetype',
    'issuekey',
    'summary',
    'status',
    'assignee',
    'created',
    'duedate'
];

const $02309a72549aca7a$export$d0f58ae631aec13a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("k3ILh")), {
        moduleId: "979fe7c2",
        moduleName: "JourneysListPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                tableQueryRef: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $hiYJF.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        issueSearchInput: {
                            jql: `project = ${context.match.params.projectKey || ''} AND journeyParentOfTypeId IS NOT EMPTY ORDER BY created DESC`
                        },
                        first: 50,
                        fieldSetsInput: {
                            fieldSetIds: $02309a72549aca7a$var$JOURNEYS_LIST_FIELD_SET_IDS
                        },
                        fieldSetIds: $02309a72549aca7a$var$JOURNEYS_LIST_FIELD_SET_IDS
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("hiYJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $6733a6ea8760eb6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bcaed9db3fa456dd4b5619ecb70344e>>
 * @relayHash e64ccc8988c4ee011556aa52e41c214e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 873cbba14a1e58d2ee7b5b0e6aec255c752e2fa81d7ce96c4e2303fe818522b8

var $1D6fx = parcelRequire("1D6fx");

var $KUiqF = parcelRequire("KUiqF");

var $7yObX = parcelRequire("7yObX");

var $7e655 = parcelRequire("7e655");

var $7zUJD = parcelRequire("7zUJD");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $gE0jx = parcelRequire("gE0jx");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $l4q64 = parcelRequire("l4q64");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $6BTmn = parcelRequire("6BTmn");

var $jhYmN = parcelRequire("jhYmN");

var $b3Nht = parcelRequire("b3Nht");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $2JQfe = parcelRequire("2JQfe");

var $cNoBc = parcelRequire("cNoBc");

var $aIZjN = parcelRequire("aIZjN");

var $1A1H9 = parcelRequire("1A1H9");
const $6733a6ea8760eb6a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "873cbba14a1e58d2ee7b5b0e6aec255c752e2fa81d7ce96c4e2303fe818522b8",
        "metadata": {},
        "name": "JourneysListPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default)
        }
    }
};
var $6733a6ea8760eb6a$export$2e2bcd8739ae039 = $6733a6ea8760eb6a$var$node;

});

parcelRegister("k3ILh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("j2mqK")
]).then(()=>parcelRequire('4tjsH'));

});


parcelRegister("geK05", function(module, exports) {
$parcel$export(module.exports, "journeysHorizontalNavEntryPoint", () => $125ad2eb85bc668e$export$9b7323657c448aa2);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $125ad2eb85bc668e$export$9b7323657c448aa2 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("bnz2i")), {
        moduleId: "e70e7c1d",
        moduleName: "JourneysHorizontalNav",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({
            queries: {},
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("bnz2i", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("77VAs").then(()=>parcelRequire('5OMzg'));

});


parcelRegister("iSkKl", function(module, exports) {
$parcel$export(module.exports, "journeysListRoute", () => $321009a64b6d4484$export$ae27b4f77d51b155);
const $321009a64b6d4484$export$ae27b4f77d51b155 = {
    path: '/jira/servicedesk/projects/:projectKey/journeys',
    name: 'jsm-journeys-list',
    exact: true
};

});


parcelRegister("G2OkG", function(module, exports) {
$parcel$export(module.exports, "jsmBoardRouteEntry", () => $946591b75a53a6fb$export$44cb11fe4ca053f8);


var $2tUYk = parcelRequire("2tUYk");

var $6RSCO = parcelRequire("6RSCO");

var $5adCU = parcelRequire("5adCU");

var $4TFaG = parcelRequire("4TFaG");

var $hRSPo = parcelRequire("hRSPo");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");

var $fdS54 = parcelRequire("fdS54");

var $jEYuY = parcelRequire("jEYuY");

var $lQH62 = parcelRequire("lQH62");

var $74h93 = parcelRequire("74h93");

var $2bC10 = parcelRequire("2bC10");

var $cnPEq = parcelRequire("cnPEq");
const $946591b75a53a6fb$export$44cb11fe4ca053f8 = (0, $fdS54.createEntry)((0, $lQH62.jsmBoardRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cnPEq.ServicedeskBoard),
        layout: (0, $74h93.serviceProjectLayout),
        skeleton: (0, $2bC10.ClassicBoardSkeleton),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cnPEq.LazyServicedeskBoard),
            (0, $cnPEq.LazyBoardSettings)
        ],
        perfMetricKey: 'servicedesk-boards-load',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $2tUYk.AsyncViewsNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!false, (0, $2DCyG.uifBoardResource)),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2tUYk", function(module, exports) {
$parcel$export(module.exports, "AsyncViewsNav", () => $2d9b3e5aba4a440b$export$b43adc74b6a33bde);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $2d9b3e5aba4a440b$var$LazyViewsNav = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1r12t")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-views/src/ui/index.tsx"
});
const $2d9b3e5aba4a440b$export$b43adc74b6a33bde = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-jsm-views-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2d9b3e5aba4a440b$var$LazyViewsNav, null));
$2d9b3e5aba4a440b$export$b43adc74b6a33bde.displayName = "AsyncViewsNav";

});
parcelRegister("1r12t", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("S9Ov8").then(()=>parcelRequire('f7UHw'));

});


parcelRegister("lQH62", function(module, exports) {
$parcel$export(module.exports, "jsmBoardRoute", () => $d4411b84d9176106$export$a192088aab559fa1);
const $d4411b84d9176106$export$a192088aab559fa1 = {
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: 'servicedesk-boards',
    exact: true
};

});

parcelRegister("cnPEq", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskBoard", () => $be93868dd7446321$export$bb5ed4e7838cf30c);
$parcel$export(module.exports, "LazyBoardSettings", () => $be93868dd7446321$export$45bb2963a11a5163);
$parcel$export(module.exports, "ServicedeskBoard", () => $be93868dd7446321$export$f058c0d1561d67f3);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $be93868dd7446321$export$bb5ed4e7838cf30c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("gLOJk"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-board/src/ServicedeskBoard.tsx"
});

const $be93868dd7446321$export$45bb2963a11a5163 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("9nl3L")).then((module)=>module.ServicedeskBoardSettingsAppLayout)), {
    moduleId: "./src/packages/spa-apps/servicedesk-board-settings/src/ServicedeskBoardSettingsAppLayout.tsx"
});
const $be93868dd7446321$export$f058c0d1561d67f3 = (props)=>{
    const { route: route, query: query } = props;
    if (route.name !== 'servicedesk-boards') return null;
    return query.config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $be93868dd7446321$export$45bb2963a11a5163,
        pageId: "spa-apps/servicedesk/boards/board-settings",
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $be93868dd7446321$export$bb5ed4e7838cf30c,
        pageId: "spa-apps/servicedesk/boards/board",
        shouldShowSpinner: true
    });
};
$be93868dd7446321$export$f058c0d1561d67f3.displayName = "ServicedeskBoard";

});
parcelRegister("9nl3L", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("elMqu")
]).then(()=>parcelRequire('37qss'));

});



parcelRegister("5I7GX", function(module, exports) {
$parcel$export(module.exports, "jsmKbAiFirstCreateEmbedRouteEntry", () => $de09f2727dde84fc$export$5f2386d37fbbc60a);

var $aUzJT = parcelRequire("aUzJT");

var $cLdvY = parcelRequire("cLdvY");

var $fdS54 = parcelRequire("fdS54");

var $2jcLc = parcelRequire("2jcLc");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $iSoIx = parcelRequire("iSoIx");

var $i860n = parcelRequire("i860n");
const $de09f2727dde84fc$var$JsmKbAIFirstCreatePageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $aUzJT.jsmKbAiFirstCreateEntryPoint)
});
const $de09f2727dde84fc$export$5f2386d37fbbc60a = (0, $fdS54.createEntry)((0, $2jcLc.jsmKbAiFirstCreateEmbedRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jira-jsm-kb-ai-first-create.embed-view',
        layout: (0, $byMD7.chromelessLayout),
        entryPoint: ()=>{
            return (0, $i860n.fg)('jsm_kb_from_scratch') ? $de09f2727dde84fc$var$JsmKbAIFirstCreatePageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            (0, $cLdvY.aiEntitlementResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aUzJT", function(module, exports) {
$parcel$export(module.exports, "jsmKbAiFirstCreateEntryPoint", () => $3611f759b5c2149c$export$397467312f4c0990);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $3611f759b5c2149c$export$397467312f4c0990 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("jNv1L")), {
        moduleId: "7374d3bd",
        moduleName: "JsmKbAiFirstCreateComponent",
        priority: "interaction"
    }),
    getPreloadProps: (_entryPointRouteParams)=>{
        return {
            entryPoints: {}
        };
    }
});

});
parcelRegister("jNv1L", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ege2t").then(()=>parcelRequire('8z5yd'));

});


parcelRegister("2jcLc", function(module, exports) {
$parcel$export(module.exports, "jsmKbAiFirstCreateEmbedRoute", () => $ad52e48f458bd393$export$ac414dd18a2adf8a);
const $ad52e48f458bd393$export$ac414dd18a2adf8a = {
    name: 'jsm-kb-ai-first-create-embed',
    path: '/jira/servicedesk/create-kb/embed',
    exact: true
};

});


parcelRegister("3O97K", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemBrowseRouteEntry", () => $56017526835f73b0$export$587d391ee3bab1d8);

var $i860n = parcelRequire("i860n");


var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dYCGJ = parcelRequire("dYCGJ");

var $iSoIx = parcelRequire("iSoIx");

var $ldvQg = parcelRequire("ldvQg");
const $56017526835f73b0$var$jsmWorkItemBrowsePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ldvQg.jsmWorkItemServiceRequestEntryPoint)
});
const $56017526835f73b0$export$587d391ee3bab1d8 = (0, $fdS54.createEntry)((0, $dYCGJ.jsmWorkItemBrowseRoute), ()=>({
        group: 'servicedesk',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm_aniv_routing_phase_1') ? $56017526835f73b0$var$jsmWorkItemBrowsePageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dYCGJ", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemBrowseRoute", () => $f050adfbe3271280$export$69b20fc7958c382c);
const $f050adfbe3271280$export$69b20fc7958c382c = {
    name: 'jsm-work-item-browse',
    path: '/jira/servicedesk/browse/:issueKey(\\w+-\\d+)(.*)?',
    exact: true
};

});

parcelRegister("ldvQg", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemServiceRequestEntryPoint", () => $385fb879cfaf2515$export$f54b87ed4b49cef4);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7DhKj = parcelRequire("7DhKj");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $385fb879cfaf2515$export$f54b87ed4b49cef4 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("cQwvG")), {
        moduleId: "dbbb183d",
        moduleName: "JsmServiceRequest",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>({
            entryPoints: {
                jsmServices: {
                    entryPoint: (0, $7DhKj.jsmServicesEntryPoint),
                    entryPointParams: {
                        issueKey: params.context.match.params?.issueKey ?? '',
                        cloudId: params.tenantContext.cloudId,
                        tenantContext: params.tenantContext
                    }
                }
            }
        })
});

});
parcelRegister("7DhKj", function(module, exports) {
$parcel$export(module.exports, "jsmServicesEntryPoint", () => $c785f88ed4422839$export$219287c0c136cd28);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $ieliU = parcelRequire("ieliU");

var $i860n = parcelRequire("i860n");

var $6gqYx = parcelRequire("6gqYx");
const $c785f88ed4422839$var$DEFAULT_APPLICATION_KEY = 'JIRA_SERVICE_DESK';
const $c785f88ed4422839$var$getIssueViewAddAttachmentsFlag = (tenantContext)=>tenantContext?.appEditions?.software === 'FREE_EDITION' && tenantContext?.licenseStates?.software === 'ACTIVE';
// This function is a copy of getChildIssuesFieldIdsQueryVariables from '@jira/issue__main-issue-agg-query/src/getMainIssueViewAggQueryVariables.tsx'
const $c785f88ed4422839$var$getChildIssuesFieldIdsQueryVariables = ()=>{
    const childIssuesFieldIds = [
        'issuetype'
    ];
    if (!(0, $i860n.fg)('relay-migration-edit-worklog') && !(0, $i860n.fg)('jpx-93-unship-legacy-timetracking')) childIssuesFieldIds.push('timetracking');
    if (!(0, $i860n.fg)('jira-issue-view-child-issues-panel-realtime-update')) childIssuesFieldIds.push('status');
    return childIssuesFieldIds;
};
// This function is adapted from getIssueSearchForChildIssueQueryVariables from '@jira/issue__main-issue-agg-query/src/getMainIssueViewAggQueryVariables.tsx'
const $c785f88ed4422839$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        issueSearchInput: (0, $i860n.fg)('jira-issue-view-child-work-items-ssr-fg') ? {
            jql: issueKey ? `parent = ${issueKey}` : ''
        } : {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        childIssuesFieldIds: $c785f88ed4422839$var$getChildIssuesFieldIdsQueryVariables(),
        childIssuesAmountOfColumns: 500,
        childIssuesFirst: null,
        childWorkItemsSSRUIEnabled: Boolean((0, $i860n.fg)('jira-issue-view-child-work-items-ssr-fg')),
        shouldUseNewChildWorkItemsDatafetcher: true,
        isInitialLoadQuery: true
    });
const $c785f88ed4422839$var$RESOURCES_INTEGRATION = {
    ATTACHMENT: 'ATTACHMENT',
    LOOM: 'LOOM',
    CONFLUENCE: 'CONFLUENCE',
    WHITEBOARD: 'WHITEBOARD',
    GDRIVE: 'GDRIVE',
    WEBLINK: 'WEBLINK'
};
const $c785f88ed4422839$var$getDefaultAttachmentFilters = ()=>({
        defaultAttachmentFilters: [
            {
                integration: $c785f88ed4422839$var$RESOURCES_INTEGRATION.CONFLUENCE
            },
            {
                integration: $c785f88ed4422839$var$RESOURCES_INTEGRATION.WHITEBOARD
            },
            {
                integration: $c785f88ed4422839$var$RESOURCES_INTEGRATION.LOOM
            },
            {
                integration: $c785f88ed4422839$var$RESOURCES_INTEGRATION.ATTACHMENT,
                types: []
            },
            {
                integration: $c785f88ed4422839$var$RESOURCES_INTEGRATION.WEBLINK
            }
        ]
    });
const $c785f88ed4422839$var$getProjectKeyFromIssueKey = (issueKey)=>issueKey ? issueKey.split('-')[0] : '';

const $c785f88ed4422839$export$219287c0c136cd28 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("d5OBS")), {
        moduleId: "4bdececc",
        moduleName: "JsmServices",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ issueKey: issueKey, cloudId: cloudId, applicationKey: applicationKey = $c785f88ed4422839$var$DEFAULT_APPLICATION_KEY, tenantContext: tenantContext })=>{
        return {
            queries: {
                JsmServices_preloadedQuery: {
                    parameters: (0, $6gqYx.default),
                    variables: {
                        cloudId: cloudId ?? '',
                        issueKey: issueKey ?? '',
                        projectKey: $c785f88ed4422839$var$getProjectKeyFromIssueKey(issueKey),
                        siteAri: cloudId ? (0, $ieliU.JiraSiteAri).create({
                            siteId: cloudId
                        }).toString() : '',
                        forgeTypes: [],
                        applicationKey: applicationKey,
                        issueViewAddAttachmentFlag: !(0, $i860n.fg)('wi2_1p_attachments_resource') ? $c785f88ed4422839$var$getIssueViewAddAttachmentsFlag(tenantContext) : false,
                        ...$c785f88ed4422839$var$getIssueSearchForChildIssueQueryVariables(issueKey),
                        ...$c785f88ed4422839$var$getDefaultAttachmentFilters()
                    }
                }
            }
        };
    }
});

});
parcelRegister("6gqYx", function(module, exports) {
$parcel$export(module.exports, "default", () => $904e55c0e370b4fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<efb10e6cbbb3f3b26e6612b78f910e3e>>
 * @relayHash 26b041bb900106bc0f0a3d62f10854fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 991597e7885c790b9759426eba8b7506bbab8b0d3ba546b8febadc7742c7a3ee

var $frIhD = parcelRequire("frIhD");

var $25gUJ = parcelRequire("25gUJ");

var $1D6fx = parcelRequire("1D6fx");

var $8MXfm = parcelRequire("8MXfm");

var $KUiqF = parcelRequire("KUiqF");

var $efrbL = parcelRequire("efrbL");

var $hNa68 = parcelRequire("hNa68");

var $iZoUB = parcelRequire("iZoUB");

var $7yObX = parcelRequire("7yObX");

var $dZY9f = parcelRequire("dZY9f");

var $g1jeD = parcelRequire("g1jeD");

var $2OiA9 = parcelRequire("2OiA9");

var $djCI3 = parcelRequire("djCI3");

var $7e655 = parcelRequire("7e655");

var $7zUJD = parcelRequire("7zUJD");

var $gQsSz = parcelRequire("gQsSz");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $lFWP3 = parcelRequire("lFWP3");

var $1nq5z = parcelRequire("1nq5z");

var $gE0jx = parcelRequire("gE0jx");

var $gSEQT = parcelRequire("gSEQT");

var $JnBPc = parcelRequire("JnBPc");

var $2XfUx = parcelRequire("2XfUx");

var $2TCrO = parcelRequire("2TCrO");

var $vEj75 = parcelRequire("vEj75");

var $eJbZi = parcelRequire("eJbZi");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $1F2RS = parcelRequire("1F2RS");

var $l4q64 = parcelRequire("l4q64");

var $1ZLvK = parcelRequire("1ZLvK");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $2XkhF = parcelRequire("2XkhF");

var $6BTmn = parcelRequire("6BTmn");

var $02lp5 = parcelRequire("02lp5");

var $jhYmN = parcelRequire("jhYmN");

var $jXd0g = parcelRequire("jXd0g");

var $b3Nht = parcelRequire("b3Nht");

var $lcsWS = parcelRequire("lcsWS");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $gyjgw = parcelRequire("gyjgw");

var $5ZdKP = parcelRequire("5ZdKP");

var $bstvV = parcelRequire("bstvV");

var $fCPPo = parcelRequire("fCPPo");

var $7so7Y = parcelRequire("7so7Y");

var $8bioU = parcelRequire("8bioU");

var $fFz9x = parcelRequire("fFz9x");

var $kdPlB = parcelRequire("kdPlB");

var $1JsCG = parcelRequire("1JsCG");

var $2JQfe = parcelRequire("2JQfe");

var $cNoBc = parcelRequire("cNoBc");

var $aIZjN = parcelRequire("aIZjN");

var $gmyGN = parcelRequire("gmyGN");

var $98W07 = parcelRequire("98W07");

var $1A1H9 = parcelRequire("1A1H9");
const $904e55c0e370b4fe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "991597e7885c790b9759426eba8b7506bbab8b0d3ba546b8febadc7742c7a3ee",
        "metadata": {},
        "name": "JsmServices_dataQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmWfoAssigneeRecommendationOnQueuesRelayprovider": (0, $gQsSz.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUserPickerGuestLozengeRelayprovider": (0, $gSEQT.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $gmyGN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiv22472HasSummaryToMIAQFeatureGate": (0, $1JsCG.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiv22469DevSummaryToMIAQRelayProvider": (0, $kdPlB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsDFOCreateBranchTargetsEnabledRelayProvidertsx": (0, $hNa68.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraEnableClassificationControlEnforcementRelayprovider": (0, $8bioU.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraenableclassificationorgdefaultfgrelayprovider": (0, $gyjgw.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraAiDeeplinkInHeaderRelayProvider": (0, $fCPPo.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcrovoCatchUpLinkedItemsNudgeRelayProvider": (0, $98W07.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcactivityPanelModernisationRelayProvider": (0, $eJbZi.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraissueviewshowslacksyncinforelayprovider": (0, $bstvV.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraSmartRepliesV2RelayProvider": (0, $fFz9x.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarissueviewcommentsrelayprovider": (0, $jXd0g.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivSsrAttachmentsRelayProvidertsx": (0, $2TCrO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcDevSummaryPanelWivRelayProvider": (0, $25gUJ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $5ZdKP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraChildIssuesPaginationRelayProvider": (0, $7so7Y.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": (0, $efrbL.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $2XkhF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx": (0, $iZoUB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFixAiEnablementChecksInIssueViewRelayProvider": (0, $8MXfm.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisLinkedIssuesEditableSyncLoadedOnInitialLoad": (0, $02lp5.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx": (0, $lFWP3.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcContextSectionsReorderingExperimentRelayProvider": (0, $frIhD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAssignableAgentSessionExperienceRelayprovider": (0, $djCI3.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider": (0, $dZY9f.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiLocalAgentSessionsEnabledRelayProvider": (0, $2OiA9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgenticPlanningRelayProvider": (0, $g1jeD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivSsrForgeStoreHydration": (0, $vEj75.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": (0, $1F2RS.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWi2PerfSmartLinkstsx": (0, $JnBPc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivConfluenceApplinksHydration": (0, $2XfUx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatartmpboardrelayprovider": (0, $lcsWS.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveSearchurlFromCmdbFieldRelayProvider": (0, $1nq5z.default)
        }
    }
};
var $904e55c0e370b4fe$export$2e2bcd8739ae039 = $904e55c0e370b4fe$var$node;

});
parcelRegister("frIhD", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bb6df5658a7cb97$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
const $9bb6df5658a7cb97$var$ContextSectionsReorderingExperimentRelayProvider = {
    get () {
        return (0, $2700E.expVal)('context_sections_reordering', 'isEnabled', false);
    }
};
var $9bb6df5658a7cb97$export$2e2bcd8739ae039 = $9bb6df5658a7cb97$var$ContextSectionsReorderingExperimentRelayProvider;

});

parcelRegister("25gUJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2f854fcf8e50d4e$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $e2f854fcf8e50d4e$var$DevSummaryPanelWivRelayProvider = {
    get () {
        return (0, $i860n.fg)('gate-dev-summary-fragment-wiv');
    }
};
var $e2f854fcf8e50d4e$export$2e2bcd8739ae039 = $e2f854fcf8e50d4e$var$DevSummaryPanelWivRelayProvider;

});

parcelRegister("djCI3", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e41fb2ec6e5efc3$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $8e41fb2ec6e5efc3$var$JiraAssignableAgentSessionExperienceRelayprovider = {
    get () {
        return (0, $i860n.fg)('jira_assignable_agent_session_experience');
    }
};
var $8e41fb2ec6e5efc3$export$2e2bcd8739ae039 = $8e41fb2ec6e5efc3$var$JiraAssignableAgentSessionExperienceRelayprovider;

});

parcelRegister("1nq5z", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2423785b5cdc9bc$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $f2423785b5cdc9bc$var$RemoveSearchurlFromCmdbFieldRelayProvider = {
    get () {
        return (0, $i860n.fg)('flash-839-remove-searchurl-from-cmdb-field');
    }
};
var $f2423785b5cdc9bc$export$2e2bcd8739ae039 = $f2423785b5cdc9bc$var$RemoveSearchurlFromCmdbFieldRelayProvider;

});

parcelRegister("JnBPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3c2ad0910f03fb7$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $b3c2ad0910f03fb7$var$Wi2PerfSmartLinks = {
    get () {
        return (0, $i860n.fg)('wi2-perf-smart-links');
    }
};
var $b3c2ad0910f03fb7$export$2e2bcd8739ae039 = $b3c2ad0910f03fb7$var$Wi2PerfSmartLinks;

});

parcelRegister("2XfUx", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6fb8449fe32ff34$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $d6fb8449fe32ff34$var$WivConfluenceApplinksHydration = {
    get () {
        return (0, $i860n.fg)('jira_wiv_confluence_applinks_hydration');
    }
};
var $d6fb8449fe32ff34$export$2e2bcd8739ae039 = $d6fb8449fe32ff34$var$WivConfluenceApplinksHydration;

});

parcelRegister("2TCrO", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a26dc6e10271545$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $4a26dc6e10271545$var$WivSsrAttachmentsRelayProvider = {
    get () {
        return !(0, $i860n.fg)('wi2_1p_attachments_resource');
    }
};
var $4a26dc6e10271545$export$2e2bcd8739ae039 = $4a26dc6e10271545$var$WivSsrAttachmentsRelayProvider;

});

parcelRegister("vEj75", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e5ed43ca126c06$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $d7e5ed43ca126c06$var$WivSsrForgeStoreHydration = {
    get () {
        return (0, $i860n.fg)('wiv-ssr-forge-store-hydration');
    }
};
var $d7e5ed43ca126c06$export$2e2bcd8739ae039 = $d7e5ed43ca126c06$var$WivSsrForgeStoreHydration;

});

parcelRegister("02lp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f258471bff7efc2$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $9f258471bff7efc2$var$isLinkedIssuesEditableSyncLoadedOnInitialLoad = {
    get () {
        return (0, $i860n.fg)('jira_is_editable_sync_loaded_for_remote_links') && ((0, $i860n.fg)('jira_linked_issues_pagination') || (0, $i860n.fg)('use_node_id_for_row_key'));
    }
};
var $9f258471bff7efc2$export$2e2bcd8739ae039 = $9f258471bff7efc2$var$isLinkedIssuesEditableSyncLoadedOnInitialLoad;

});

parcelRegister("98W07", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a1ef26830d39b2f$export$2e2bcd8739ae039);

var $2700E = parcelRequire("2700E");
/**
 * Gates the `issueLinks { edges }` selection that the Work Item View (Relay-only)
 * path adds to `WorkItemHeaderActions_issue` so the "Catch up on linked items" Rovo nudge
 * can determine `hasLinkedIssues` without a Redux store.
 *
 * Mirrors the experiment used by `useCatchUpNudge` (`rovo_catch_up_linked_items_nudge`)
 * so non-eligible cohorts never request the extra field (zero network cost).
 *
 * IMPORTANT: this reads the experiment with NO exposure. Evaluating the provider only
 * means the query *could* fetch link data — the nudge may still never render (it also
 * needs hasLinkedIssues, MODAL view, Rovo entitlement, not-skipped, and seen/consent
 * checks). Firing exposure here would over-count and skew the experiment. Exposure is
 * fired by `useCatchUpNudge` at the point the nudge is actually shown.
 */ const $2a1ef26830d39b2f$var$rovoCatchUpLinkedItemsNudgeRelayProvider = {
    get () {
        const [config] = (0, $2700E.UNSAFE_noExposureExp)('rovo_catch_up_linked_items_nudge');
        return config.get('isEnabled', false);
    }
};
var $2a1ef26830d39b2f$export$2e2bcd8739ae039 = $2a1ef26830d39b2f$var$rovoCatchUpLinkedItemsNudgeRelayProvider;

});


parcelRegister("d5OBS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4TzYF")
]).then(()=>parcelRequire('dvUhQ'));

});


parcelRegister("cQwvG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ghQyX").then(()=>parcelRequire('1mrpv'));

});



parcelRegister("hjRvB", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemEmbedRouteEntry", () => $fa57e57c905aae8d$export$3f7458dfdc2c206f);

var $iSoIx = parcelRequire("iSoIx");

var $fdS54 = parcelRequire("fdS54");

var $byMD7 = parcelRequire("byMD7");

var $LjnsM = parcelRequire("LjnsM");

var $i860n = parcelRequire("i860n");

var $bYvXc = parcelRequire("bYvXc");
const $fa57e57c905aae8d$export$3f7458dfdc2c206f = (0, $fdS54.createEntry)((0, $LjnsM.jsmWorkItemEmbedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $byMD7.chromelessLayout),
        resources: [],
        entryPoint: ()=>(0, $i860n.fg)('jsm_aniv_routing_phase_1') ? (0, $bYvXc.jsmWorkItemPageEntrypoint) : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            redirects: [
                {
                    key: 'jsm-work-item-route-redirect',
                    timeoutMs: 10,
                    handler: async ({ match: match, url: url })=>{
                        const issueKey = match.params.issueKey;
                        // eslint-disable-next-line jira/ff/no-preconditioning
                        if (issueKey && !((0, $i860n.fg)('jsm_aniv_routing_phase_1') && (0, $i860n.fg)('jsm_aniv_route_redirection'))) return `/browse/${issueKey}/embed${url.search}`;
                    }
                }
            ]
        }
    }));

});
parcelRegister("LjnsM", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemEmbedRoute", () => $574ed753c7840c9b$export$40cfcc213981b742);
const $574ed753c7840c9b$export$40cfcc213981b742 = {
    name: 'jsm-work-item-embed',
    path: '/browse/jsm-work-item/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("bYvXc", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemPageEntrypoint", () => $0ea7eb2ab78180de$export$dc651c59946952de);

var $32Gtk = parcelRequire("32Gtk");

var $dTa0V = parcelRequire("dTa0V");
const $0ea7eb2ab78180de$export$dc651c59946952de = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $32Gtk.jsmWorkItemEntryPoint)
});

});
parcelRegister("32Gtk", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemEntryPoint", () => $a54cb0441481185a$export$7e42e26570702167);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $dprah = parcelRequire("dprah");

const $a54cb0441481185a$export$7e42e26570702167 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gXUnc")), {
        moduleId: "550b2670",
        moduleName: "JsmWorkItem",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const issueKey = context.match?.params?.issueKey || context.query?.selectedIssue || '';
        const cloudId = tenantContext.cloudId;
        return {
            queries: {
                issueDetailsQuery: {
                    parameters: $dprah.default,
                    variables: {
                        issueKey: issueKey || '',
                        cloudId: cloudId || ''
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            extraProps: {
                context: context
            }
        };
    }
});

});
parcelRegister("dprah", function(module, exports) {
$parcel$export(module.exports, "default", () => $bad0e257fb2bfa83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<55e6de1c7f73eb8d09fc6d63bbe1f4fc>>
 * @relayHash 00ec51509c7f9205b96335f3f528f44c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1a51b2d304474560c09e407081f51fc4b05663b28035ca2d9bbbfef11e39048e
const $bad0e257fb2bfa83$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1a51b2d304474560c09e407081f51fc4b05663b28035ca2d9bbbfef11e39048e",
        "metadata": {},
        "name": "JsmWorkItemIssueDetailsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $bad0e257fb2bfa83$export$2e2bcd8739ae039 = $bad0e257fb2bfa83$var$node;

});

parcelRegister("gXUnc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i6eXt").then(()=>parcelRequire('cYaZb'));

});




parcelRegister("6gY16", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemIncidentRouteEntry", () => $f12295f703fd59a8$export$a75c330b67eceebd);
/* eslint-disable import/order */ 
var $8CDeC = parcelRequire("8CDeC");

var $aznaH = parcelRequire("aznaH");


var $iSoIx = parcelRequire("iSoIx");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");
const $f12295f703fd59a8$var$jsmWorkItemIncidentPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $aznaH.jsmWorkItemIncidentEntryPoint)
});
const $f12295f703fd59a8$export$a75c330b67eceebd = (0, $fdS54.createEntry)((0, $8CDeC.jsmWorkItemIncidentRoute), ()=>({
        group: 'servicedesk',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm_aniv_routing_phase_1') ? $f12295f703fd59a8$var$jsmWorkItemIncidentPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8CDeC", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemIncidentRoute", () => $44b3c05fe3e7a769$export$b2389ba0305b4daa);
const $44b3c05fe3e7a769$export$b2389ba0305b4daa = {
    name: 'jsm-work-item-incident',
    path: '/jira/servicedesk/incidents/:issueKey',
    exact: true
};

});

parcelRegister("aznaH", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemIncidentEntryPoint", () => $cf80be5bf74f9b1a$export$74b46ee34a0c398f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $fijBL = parcelRequire("fijBL");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $cf80be5bf74f9b1a$export$74b46ee34a0c398f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dMfPG")), {
        moduleId: "cadb8308",
        moduleName: "JsmWorkItemIncident",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>({
            entryPoints: {
                incidentView: {
                    entryPoint: (0, $fijBL.jsmIncidentsEntryPoint),
                    entryPointParams: {
                        activeTabKey: params.context.query.tab
                    }
                }
            }
        })
});

});
parcelRegister("fijBL", function(module, exports) {
$parcel$export(module.exports, "jsmIncidentsEntryPoint", () => $8b9d27aac58a0702$export$b4ac6f37bb0c378e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NvCa = parcelRequire("7NvCa");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");
const $8b9d27aac58a0702$var$TAB_ENTRY_POINTS = {
    overview: (0, $7NvCa.overviewTabEntryPoint)
};

const $8b9d27aac58a0702$export$b4ac6f37bb0c378e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("eQR0D")), {
        moduleId: "8cb9fd0e",
        moduleName: "JsmIncidents",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ activeTabKey: activeTabKey })=>{
        const tabKey = $8b9d27aac58a0702$var$isValidTabKey(activeTabKey) ? activeTabKey : 'overview';
        const entryPoints = {
            overview: undefined
        };
        switch(tabKey){
            case 'overview':
                entryPoints.overview = {
                    entryPoint: $8b9d27aac58a0702$var$TAB_ENTRY_POINTS.overview,
                    entryPointParams: {}
                };
                break;
            default:
                {
                    const _exhaustiveCheck = tabKey;
                    throw new Error(`Invalid tab key: ${_exhaustiveCheck}`);
                }
        }
        return {
            entryPoints: entryPoints
        };
    }
});
const $8b9d27aac58a0702$var$isValidTabKey = (key)=>{
    return Object.keys($8b9d27aac58a0702$var$TAB_ENTRY_POINTS).includes(key);
};

});
parcelRegister("7NvCa", function(module, exports) {
$parcel$export(module.exports, "overviewTabEntryPoint", () => $8539cf4158196c94$export$aa4c32b21d9f9d56);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $8539cf4158196c94$export$aa4c32b21d9f9d56 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jC1qW")), {
        moduleId: "eed17c01",
        moduleName: "OverviewTab",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jC1qW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("c5EYQ")
]).then(()=>parcelRequire('9wOPk'));

});


parcelRegister("eQR0D", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fxa6j").then(()=>parcelRequire('hNdoh'));

});


parcelRegister("dMfPG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h9BKk").then(()=>parcelRequire('d3se2'));

});



parcelRegister("f5SC3", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemPreventionCenterRouteEntry", () => $50de3719d3785b36$export$846d83fde9ce106b);
/* eslint-disable import/order */ 
var $HIzeP = parcelRequire("HIzeP");

var $6UJwQ = parcelRequire("6UJwQ");


var $iSoIx = parcelRequire("iSoIx");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");
const $50de3719d3785b36$var$jsmWorkItemPreventionCenterPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6UJwQ.jsmWorkItemPreventionCenterEntryPoint)
});
const $50de3719d3785b36$export$846d83fde9ce106b = (0, $fdS54.createEntry)((0, $HIzeP.jsmWorkItemPreventionCenterRoute), ()=>({
        group: 'servicedesk',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('prevention_center_first_phase') ? $50de3719d3785b36$var$jsmWorkItemPreventionCenterPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("HIzeP", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemPreventionCenterRoute", () => $27b2df1970a93a56$export$ac50cb559365312c);
const $27b2df1970a93a56$export$ac50cb559365312c = {
    name: 'jsm-work-item-prevention-center',
    path: '/jira/servicedesk/projects/:projectKey/prevention-center/:issueKey',
    exact: true
};

});

parcelRegister("6UJwQ", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemPreventionCenterEntryPoint", () => $257d8dc04560d9a9$export$8ae54245610c6285);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $3Fci9 = parcelRequire("3Fci9");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $257d8dc04560d9a9$export$8ae54245610c6285 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("bqWn1")), {
        moduleId: "0880b5b4",
        moduleName: "JsmWorkItemPreventionCenter",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (params)=>({
            entryPoints: {
                preventionCenter: {
                    entryPoint: (0, $3Fci9.jsmPreventionCenterEntryPoint),
                    entryPointParams: {
                        activeTabKey: params.context.query?.tab,
                        issueKey: params.context.match.params?.issueKey ?? '',
                        cloudId: params.tenantContext.cloudId
                    }
                }
            }
        })
});

});
parcelRegister("3Fci9", function(module, exports) {
$parcel$export(module.exports, "jsmPreventionCenterEntryPoint", () => $5bb6cdd1600424fd$export$9ebeae7b07ecf4a1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $dIYp4 = parcelRequire("dIYp4");

var $jNvw1 = parcelRequire("jNvw1");

var $lQlzu = parcelRequire("lQlzu");
const $5bb6cdd1600424fd$var$TAB_ENTRY_POINTS = {
    overview: (0, $dIYp4.overviewTabEntryPoint),
    risks: (0, $jNvw1.risksTabEntryPoint),
    riskMitigation: (0, $lQlzu.riskMitigationTabEntryPoint)
};
const $5bb6cdd1600424fd$var$isValidTabKey = (key)=>{
    return key !== undefined && Object.keys($5bb6cdd1600424fd$var$TAB_ENTRY_POINTS).includes(key);
};

const $5bb6cdd1600424fd$export$9ebeae7b07ecf4a1 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8qDrG")), {
        moduleId: "ae42c2eb",
        moduleName: "JsmPreventionCenter",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ activeTabKey: activeTabKey, issueKey: issueKey, cloudId: cloudId } = {})=>{
        const tabKey = $5bb6cdd1600424fd$var$isValidTabKey(activeTabKey) ? activeTabKey : 'overview';
        let entryPoints;
        switch(tabKey){
            case 'overview':
                entryPoints = {
                    overview: {
                        entryPoint: (0, $dIYp4.overviewTabEntryPoint),
                        entryPointParams: {}
                    }
                };
                break;
            case 'risks':
                entryPoints = {
                    risks: {
                        entryPoint: (0, $jNvw1.risksTabEntryPoint),
                        entryPointParams: {
                            issueKey: issueKey,
                            cloudId: cloudId
                        }
                    }
                };
                break;
            case 'riskMitigation':
                entryPoints = {
                    riskMitigation: {
                        entryPoint: (0, $lQlzu.riskMitigationTabEntryPoint),
                        entryPointParams: {}
                    }
                };
                break;
            default:
                {
                    const _exhaustiveCheck = tabKey;
                    throw new Error(`Invalid tab key: ${_exhaustiveCheck}`);
                }
        }
        return {
            entryPoints: entryPoints
        };
    }
});

});
parcelRegister("dIYp4", function(module, exports) {
$parcel$export(module.exports, "overviewTabEntryPoint", () => $3f204ec27708c8ca$export$aa4c32b21d9f9d56);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $3f204ec27708c8ca$export$aa4c32b21d9f9d56 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1wZIY")), {
        moduleId: "8fce8399",
        moduleName: "OverviewTab",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1wZIY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("ay8Nt"),
    $4cvLQ("7MeaV")
]).then(()=>parcelRequire('1XJbG'));

});


parcelRegister("jNvw1", function(module, exports) {
$parcel$export(module.exports, "risksTabEntryPoint", () => $c6f7b3cfa19bb950$export$ac9338c19e568a31);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $E9uze = parcelRequire("E9uze");

const $c6f7b3cfa19bb950$export$ac9338c19e568a31 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("cQvvn")), {
        moduleId: "c00bc1fe",
        moduleName: "RisksTab",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ issueKey: issueKey = '', cloudId: cloudId = '' } = {})=>({
            queries: {
                issueQuery: {
                    parameters: (0, $E9uze.default),
                    variables: {
                        issueKey: issueKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("E9uze", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b1b3425c1585f11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<faa15a5ce4f8a1e457f9d78ab526888c>>
 * @relayHash 82736b6ac47b78477e2aaa327f346bda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bcb2e7997707bd4a85f3e6a076e96c5a6e2458649a0f7c89f5c62eb580a0ef40
const $8b1b3425c1585f11$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bcb2e7997707bd4a85f3e6a076e96c5a6e2458649a0f7c89f5c62eb580a0ef40",
        "metadata": {},
        "name": "RisksTabIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8b1b3425c1585f11$export$2e2bcd8739ae039 = $8b1b3425c1585f11$var$node;

});

parcelRegister("cQvvn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hVrUp")
]).then(()=>parcelRequire('cMhqy'));

});


parcelRegister("lQlzu", function(module, exports) {
$parcel$export(module.exports, "riskMitigationTabEntryPoint", () => $5201e9b5550162af$export$5f37473672178a96);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $5201e9b5550162af$export$5f37473672178a96 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gNSJP")), {
        moduleId: "da04fe01",
        moduleName: "RiskMitigationTab",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gNSJP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("ay8Nt"),
    $4cvLQ("hbH2g")
]).then(()=>parcelRequire('h93PO'));

});


parcelRegister("8qDrG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5FPMZ").then(()=>parcelRequire('gOfhp'));

});


parcelRegister("bqWn1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kV1mb").then(()=>parcelRequire('ekT6b'));

});



parcelRegister("80MOq", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemRouteEntry", () => $0c142a58ef2cc1de$export$44dcdbf711bfb1ef);
/* eslint-disable import/order */ 

var $iSoIx = parcelRequire("iSoIx");

var $2CnVB = parcelRequire("2CnVB");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $bYvXc = parcelRequire("bYvXc");
const $0c142a58ef2cc1de$export$44dcdbf711bfb1ef = (0, $fdS54.createEntry)((0, $2CnVB.jsmWorkItemRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm_aniv_routing_phase_1') ? (0, $bYvXc.jsmWorkItemPageEntrypoint) : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            redirects: [
                {
                    key: 'jsm-work-item-route-redirect',
                    timeoutMs: 10,
                    handler: async ({ match: match, url: url })=>{
                        const issueKey = match.params.issueKey;
                        // eslint-disable-next-line jira/ff/no-preconditioning
                        if (issueKey && !((0, $i860n.fg)('jsm_aniv_routing_phase_1') && (0, $i860n.fg)('jsm_aniv_route_redirection'))) return `/browse/${issueKey}${url.search}`;
                    }
                }
            ]
        }
    }));

});
parcelRegister("2CnVB", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemRoute", () => $cd5490018b8778cf$export$ca14212fb64b0157);
const $cd5490018b8778cf$export$ca14212fb64b0157 = {
    name: 'jsm-work-item',
    exact: true,
    path: '/browse/jsm-work-item/:issueKey'
};

});


parcelRegister("eWRDs", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemServiceRequestRouteEntry", () => $03d35f279bc29baa$export$953e0100da28876);
/* eslint-disable import/order */ 
var $hxakG = parcelRequire("hxakG");

var $ldvQg = parcelRequire("ldvQg");


var $iSoIx = parcelRequire("iSoIx");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");
const $03d35f279bc29baa$var$jsmWorkItemServiceRequestPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ldvQg.jsmWorkItemServiceRequestEntryPoint)
});
const $03d35f279bc29baa$export$953e0100da28876 = (0, $fdS54.createEntry)((0, $hxakG.jsmWorkItemServiceRequestRoute), ()=>({
        group: 'servicedesk',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm_aniv_routing_phase_1') ? $03d35f279bc29baa$var$jsmWorkItemServiceRequestPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hxakG", function(module, exports) {
$parcel$export(module.exports, "jsmWorkItemServiceRequestRoute", () => $cd5a71a3b636fc9b$export$714c3cba8bade150);
const $cd5a71a3b636fc9b$export$714c3cba8bade150 = {
    name: 'jsm-work-item-service-request',
    path: '/jira/servicedesk/service-requests/:issueKey',
    exact: true
};

});


parcelRegister("kBu1n", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubAllArticlesRouteEntry", () => $f13049e0fcfc6aa9$export$5b55251966102ec);

var $fLcUe = parcelRequire("fLcUe");

var $fNZVZ = parcelRequire("fNZVZ");


var $kBLrj = parcelRequire("kBLrj");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $e9MrQ = parcelRequire("e9MrQ");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $icM5g = parcelRequire("icM5g");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $4V0by = parcelRequire("4V0by");

var $c9EqH = parcelRequire("c9EqH");

var $5xIfK = parcelRequire("5xIfK");

var $aq2zI = parcelRequire("aq2zI");
const $f13049e0fcfc6aa9$export$5b55251966102ec = (0, $fdS54.createEntry)((0, $e9MrQ.knowledgeHubAllArticlesRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5xIfK.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $kBLrj.AsyncKbNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $c9EqH.projectIdResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $icM5g.kbTopicsResource)),
            (0, $fLcUe.servicedeskKnowledgeBaseServerLinkStatusResource),
            (0, $fNZVZ.servicedeskKnowledgeBaseLinkedSourcesResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $4V0by.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5xIfK.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fLcUe", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseServerLinkStatusResource", () => $c2b984d69bef9328$export$caf2ff51247eb919);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

const $c2b984d69bef9328$export$caf2ff51247eb919 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_SERVER_LINK_STATUS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("6ZGoM")),
    maxAge: 1800000
});

});
parcelRegister("6ZGoM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bsLHM").then(()=>parcelRequire('e0NXm'));

});


parcelRegister("fNZVZ", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseLinkedSourcesResource", () => $0914c858c4a448f4$export$19686a4cf468791b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

const $0914c858c4a448f4$export$19686a4cf468791b = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_LINKED_SOURCES',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("ajr9X")),
    maxAge: 1800000,
    isBrowserOnly: true
});

});
parcelRegister("ajr9X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1uwF2").then(()=>parcelRequire('1N5jY'));

});


parcelRegister("kBLrj", function(module, exports) {
$parcel$export(module.exports, "AsyncKbNav", () => $568093cd941390f1$export$223f755b7799fe02);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $cCE2Z = parcelRequire("cCE2Z");

var $l8G1z = parcelRequire("l8G1z");

var $i860n = parcelRequire("i860n");

const $568093cd941390f1$var$LazyKbNav = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1Q7yS")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-knowledge-base/src/ui/index.tsx"
});

const $568093cd941390f1$var$LazyKbNavWithUseResource = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1Q7yS")).then(({ KnowledgeBaseNavWithUseResource: KnowledgeBaseNavWithUseResource })=>KnowledgeBaseNavWithUseResource), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-knowledge-base/src/ui/index.tsx"
});
const $568093cd941390f1$export$223f755b7799fe02 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "horizontal-jsm-kb-nav",
        packageName: "jira-horizontal-nav-jsm-knowledge-base"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-jsm-kb-nav"
    }, (0, $i860n.fg)('jsm-kb-articles-functional') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($568093cd941390f1$var$LazyKbNavWithUseResource, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($568093cd941390f1$var$LazyKbNav, null)));
};
$568093cd941390f1$export$223f755b7799fe02.displayName = "AsyncKbNav";

});
parcelRegister("1Q7yS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("im10R").then(()=>parcelRequire('bqNiu'));

});


parcelRegister("e9MrQ", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubAllArticlesRoute", () => $d0e669d2c5d42478$export$20e57a83f181da7b);
const $d0e669d2c5d42478$export$20e57a83f181da7b = {
    name: 'knowledge-hub-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
};

});

parcelRegister("icM5g", function(module, exports) {
$parcel$export(module.exports, "kbTopicsResource", () => $f2ee6a997ae765b5$export$21fb94425a1f9352);

var $l8UJH = parcelRequire("l8UJH");

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

var $c9EqH = parcelRequire("c9EqH");
const $f2ee6a997ae765b5$var$isTopicSuggestionAllowed = (appEditions)=>{
    return appEditions.serviceDesk === 'PREMIUM_EDITION';
};
const $f2ee6a997ae765b5$export$21fb94425a1f9352 = (0, $7edbf.createResource)({
    type: 'KB_TOPIC',
    depends: [
        (0, $c9EqH.projectIdResource).type
    ],
    getKey: ({ match: match })=>{
        return match.params.projectKey ? `kb-topic-${match.params.projectKey}` : 'kb-topic';
    },
    getData: async (dataContext, { tenantContext: { activationId: activationId, appEditions: appEditions } })=>{
        const { match: { params: params } } = dataContext;
        if (!$f2ee6a997ae765b5$var$isTopicSuggestionAllowed(appEditions)) return {
            topicSuggestionAllowed: false
        };
        if ((0, $i860n.fg)('jsm-kb-articles-functional')) {
            // Use shared project ID resource - fetch project ID and AI enablement in parallel
            const [projectData, aiEnablementResponse] = await Promise.all([
                (0, $l8UJH.consumeDependency)(dataContext.dependencies, (0, $c9EqH.projectIdResource).type),
                (0, $4fhEY.default)('/rest/api/1/aiconfig/ai-enabled/jira-servicedesk', {
                    method: 'GET'
                })
            ]);
            if (!projectData?.id) return {
                topics: [],
                isFiltered: true,
                aiEnabled: false,
                topicSuggestionAllowed: true
            };
            // if ai enablement is enabled, fetch kb topics
            if (aiEnablementResponse.isEnabled) {
                const response = await (0, $4fhEY.default)(`/gateway/api/jsd-apollo-stargate/sharded/workspace/${activationId}/api/project/${projectData.id}/kb-topics`);
                return {
                    topics: response.topics,
                    aiEnabled: true,
                    topicSuggestionAllowed: true
                };
            }
            return {
                topics: [],
                aiEnabled: false,
                topicSuggestionAllowed: true
            };
        }
        // fetch project response and ai enablement response in parallel
        const [projectResponse, aiEnablementResponse] = await Promise.all([
            (0, $4fhEY.default)(`/rest/api/2/project/${params.projectKey}`),
            (0, $4fhEY.default)('/rest/api/1/aiconfig/ai-enabled/jira-servicedesk', {
                method: 'GET'
            })
        ]);
        // if ai enablement is enabled, fetch kb topics
        if (aiEnablementResponse.isEnabled) {
            const response = await (0, $4fhEY.default)(`/gateway/api/jsd-apollo-stargate/sharded/workspace/${activationId}/api/project/${projectResponse.id}/kb-topics`);
            return {
                topics: response.topics,
                aiEnabled: true,
                topicSuggestionAllowed: true
            };
        }
        return {
            topics: [],
            aiEnabled: false,
            topicSuggestionAllowed: true
        };
    },
    isBrowserOnly: true,
    maxAge: 1800000
});

});
parcelRegister("c9EqH", function(module, exports) {
$parcel$export(module.exports, "projectIdResource", () => $028d4e8a018400e2$export$8ab33580af181f4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $028d4e8a018400e2$export$8ab33580af181f4 = (0, $7edbf.createResource)({
    type: 'PROJECT_ID',
    getKey: (routerContext)=>{
        const projectKey = routerContext.match.params.projectKey;
        return `project-id-${projectKey}`;
    },
    getData: async (routerContext)=>{
        const projectKey = routerContext.match.params.projectKey;
        if (!projectKey) throw new Error('Project key is required');
        const project = await (0, $h2wCv.performGetRequest)(`/rest/api/2/project/${projectKey}`);
        return project;
    },
    maxAge: 3600000
});

});


parcelRegister("4V0by", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesKBTypeCheckerResource", () => $345c4714ef6026a7$export$151f5babb301c251);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames, jira/import-whitelist */ 
var $n67Vb = parcelRequire("n67Vb");

var $l8UJH = parcelRequire("l8UJH");

var $3lScx = parcelRequire("3lScx");

var $7edbf = parcelRequire("7edbf");

var $aI7em = parcelRequire("aI7em");

var $i860n = parcelRequire("i860n");

var $c9EqH = parcelRequire("c9EqH");
const $345c4714ef6026a7$export$151f5babb301c251 = (0, $7edbf.createResource)({
    type: 'KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES_KB_TYPE_CHECKER',
    depends: [
        (0, $c9EqH.projectIdResource).type
    ],
    getKey: (routerContext)=>{
        const projectKey = routerContext.match.params.projectKey;
        return `knowledge-hub-kb-type-checker-${projectKey}`;
    },
    getData: async (dataContext, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        const projectKey = dataContext.match.params.projectKey;
        // Use shared project ID resource
        const { dependencies: dependencies } = dataContext;
        const projectData = await (0, $l8UJH.consumeDependency)(dependencies, (0, $c9EqH.projectIdResource).type);
        if (!projectData?.id) throw new Error(`Failed to get project ID for project key: ${projectKey}`);
        // Construct container using projectId
        const container = `ari:cloud:jira:${cloudId}:project/${projectData.id}`;
        // Use loadQuery to create the preloaded query and return it
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $3lScx.default), {
            cloudId: cloudId,
            container: container,
            isAgentKbEnabled: (0, $i860n.fg)('enable_jsm_agent_kb')
        });
        return queryReference;
    },
    isBrowserOnly: true
});

});
parcelRegister("3lScx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c3999aa69198cdd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<641697ba13b9510a6a205573eb3d1da8>>
 * @relayHash 30f7986aba195278e1189f4b28aa525f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0537f6787d4dc30f8b976c06d412076756337d6f9f926f87fbb6ca7b2f561c72
const $9c3999aa69198cdd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "container"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAgentKbEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "container",
            "variableName": "container"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "sourceType"
    }, v5 = {
        "condition": "isAgentKbEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceVisibility"
            }
        ]
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "linkedSourceTypes"
            }
        ],
        "type": "KnowledgeBaseLinkedSourceTypes"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "KnowledgeHubBrowseAllArticlesContainerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "KnowledgeBaseQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeBase",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "KnowledgeBaseSourceEdge",
                                                "kind": "LinkedField",
                                                "name": "edge",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "KnowledgeBaseSource",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW"
                                                            },
                                                            v5 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW"
                                        }
                                    ],
                                    "type": "KnowledgeBaseSources"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "knowledgeBase_getLinkedSourceTypes",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "KnowledgeHubBrowseAllArticlesContainerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "KnowledgeBaseQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeBase",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeBaseSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeBaseSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "KnowledgeBaseSources"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "knowledgeBase_getLinkedSourceTypes",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "0537f6787d4dc30f8b976c06d412076756337d6f9f926f87fbb6ca7b2f561c72",
            "metadata": {},
            "name": "KnowledgeHubBrowseAllArticlesContainerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9c3999aa69198cdd$var$node.hash = "a60e8987c6cc4804ac469aeb71bd070b";
var $9c3999aa69198cdd$export$2e2bcd8739ae039 = $9c3999aa69198cdd$var$node;

});


parcelRegister("5xIfK", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllArticles", () => $7e7ca70865bec20a$export$c73ba7e80a805fb2);
$parcel$export(module.exports, "default", () => $7e7ca70865bec20a$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7e7ca70865bec20a$export$c73ba7e80a805fb2 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("gDeks"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-hub-browse-all-articles/src/index.tsx"
});
const $7e7ca70865bec20a$var$AsyncServicedeskKnowledgeHubBrowseAllArticles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7e7ca70865bec20a$export$c73ba7e80a805fb2,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
        shouldShowSpinner: true
    });
$7e7ca70865bec20a$var$AsyncServicedeskKnowledgeHubBrowseAllArticles.displayName = "AsyncServicedeskKnowledgeHubBrowseAllArticles";
var $7e7ca70865bec20a$export$2e2bcd8739ae039 = $7e7ca70865bec20a$var$AsyncServicedeskKnowledgeHubBrowseAllArticles;

});
parcelRegister("gDeks", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("9qDpr")
]).then(()=>parcelRequire('jEZWk'));

});


parcelRegister("aq2zI", function(module, exports) {
$parcel$export(module.exports, "getKnowledgeHubResources", () => $63046b5d285c7c53$export$5421e48e728c449f);

var $34Jgy = parcelRequire("34Jgy");

var $lbxXL = parcelRequire("lbxXL");
const $63046b5d285c7c53$export$5421e48e728c449f = ()=>[
        ...(0, $lbxXL.getServicedeskPageContextResources)(),
        (0, $34Jgy.kbConfluenceContextResource)
    ];

});


parcelRegister("7ch29", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRouteEntry", () => $a6ab0fe34951b497$export$513e093ef937dc06);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $em7Lq = parcelRequire("em7Lq");

var $74h93 = parcelRequire("74h93");

var $aq2zI = parcelRequire("aq2zI");

var $71Cd5 = parcelRequire("71Cd5");
const $a6ab0fe34951b497$export$513e093ef937dc06 = (0, $fdS54.createEntry)((0, $em7Lq.knowledgeHubArticleEmbedEditorRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $71Cd5.default),
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $71Cd5.LazyServiceDeskKnowledgeArticleEmbedEditor)
        ],
        perfMetricKey: 'service-management.knowledge.ep-editor',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("em7Lq", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", () => $031b4c0f66cc199e$export$bd512c426b095693);
const $031b4c0f66cc199e$export$bd512c426b095693 = {
    name: 'kb-article-embed-editor',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("71Cd5", function(module, exports) {
$parcel$export(module.exports, "LazyServiceDeskKnowledgeArticleEmbedEditor", () => $2f9a8b07bda2adf6$export$35c6d2a033ef4c42);
$parcel$export(module.exports, "default", () => $2f9a8b07bda2adf6$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $2f9a8b07bda2adf6$export$35c6d2a033ef4c42 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("1ZoGi"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-article-embed-editor/src/index.tsx"
});
const $2f9a8b07bda2adf6$var$AsyncServiceDeskKnowledgeArticleEmbedEditor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $2f9a8b07bda2adf6$export$35c6d2a033ef4c42,
        pageId: "knowledge-article-embed-editor",
        shouldShowSpinner: true
    });
$2f9a8b07bda2adf6$var$AsyncServiceDeskKnowledgeArticleEmbedEditor.displayName = "AsyncServiceDeskKnowledgeArticleEmbedEditor";
var $2f9a8b07bda2adf6$export$2e2bcd8739ae039 = $2f9a8b07bda2adf6$var$AsyncServiceDeskKnowledgeArticleEmbedEditor;

});
parcelRegister("1ZoGi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2hcOw").then(()=>parcelRequire('acpPv'));

});



parcelRegister("cSfj2", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubArticleInCategoryRouteEntry", () => $9f74c37e437b8dc7$export$a67199ebb12b0f7f);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $bHzYh = parcelRequire("bHzYh");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $aq2zI = parcelRequire("aq2zI");

var $h0iJY = parcelRequire("h0iJY");
const $9f74c37e437b8dc7$export$a67199ebb12b0f7f = (0, $fdS54.createEntry)((0, $bHzYh.knowledgeHubArticleInCategoryRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $h0iJY.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $h0iJY.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bHzYh", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", () => $4561431faedeed02$export$3afe8482ce820835);
const $4561431faedeed02$export$3afe8482ce820835 = {
    name: 'knowledge-hub-article-in-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
};

});

parcelRegister("h0iJY", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubViewArticle", () => $3752b2301b93a469$export$efd0ec49853aa81);
$parcel$export(module.exports, "default", () => $3752b2301b93a469$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $3752b2301b93a469$export$efd0ec49853aa81 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("5fa6U"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-hub-view-article/src/ServicedeskKnowledgeHubViewArticle.tsx"
});
const $3752b2301b93a469$var$AsyncServicedeskKnowledgeHubViewArticle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3752b2301b93a469$export$efd0ec49853aa81,
        pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
        shouldShowSpinner: true
    });
$3752b2301b93a469$var$AsyncServicedeskKnowledgeHubViewArticle.displayName = "AsyncServicedeskKnowledgeHubViewArticle";
var $3752b2301b93a469$export$2e2bcd8739ae039 = $3752b2301b93a469$var$AsyncServicedeskKnowledgeHubViewArticle;

});
parcelRegister("5fa6U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("lC5hd")
]).then(()=>parcelRequire('hdOyd'));

});



parcelRegister("bytv6", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRouteEntry", () => $12e553607821f7e1$export$de40c949b963d9e);

var $fLcUe = parcelRequire("fLcUe");

var $fNZVZ = parcelRequire("fNZVZ");


var $kBLrj = parcelRequire("kBLrj");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $1k9fK = parcelRequire("1k9fK");

var $8HUuJ = parcelRequire("8HUuJ");

var $h3dDK = parcelRequire("h3dDK");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $41FAq = parcelRequire("41FAq");

var $icM5g = parcelRequire("icM5g");

var $i860n = parcelRequire("i860n");

var $4V0by = parcelRequire("4V0by");

var $c9EqH = parcelRequire("c9EqH");

var $aq2zI = parcelRequire("aq2zI");

var $5xIfK = parcelRequire("5xIfK");
const $12e553607821f7e1$export$de40c949b963d9e = (0, $fdS54.createEntry)((0, $h3dDK.knowledgeHubBrowseAllArticlesRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5xIfK.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $kBLrj.AsyncKbNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('aem_rr_knowledge_hub') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent') : !(0, $l1vE2.isFedRamp)(), (0, $1k9fK.virtualAgentKnowledgebaseTouchpointResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $c9EqH.projectIdResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $icM5g.kbTopicsResource)),
            (0, $fLcUe.servicedeskKnowledgeBaseServerLinkStatusResource),
            (0, $fNZVZ.servicedeskKnowledgeBaseLinkedSourcesResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $4V0by.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5xIfK.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1k9fK", function(module, exports) {
$parcel$export(module.exports, "virtualAgentKnowledgebaseTouchpointResource", () => $c62c5b5a213baa39$export$1b798e6122168cca);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config

var $hvnt7 = parcelRequire("hvnt7");

var $i860n = parcelRequire("i860n");

var $htsFl = parcelRequire("htsFl");
const $c62c5b5a213baa39$export$1b798e6122168cca = (0, $htsFl.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $hvnt7.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $i860n.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("hvnt7", function(module, exports) {
$parcel$export(module.exports, "default", () => $993c23c4225bb815$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c48abcc6b496304054e100d2e441e9b>>
 * @relayHash cf384c20d02578de5057af63fc8ffcd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dec10e76f05bd66b0bce134e788f44487f264e251120bb3271f6f78d1bec90e
const $993c23c4225bb815$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7dec10e76f05bd66b0bce134e788f44487f264e251120bb3271f6f78d1bec90e",
        "metadata": {},
        "name": "VirtualServiceAgentCtaCardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $993c23c4225bb815$export$2e2bcd8739ae039 = $993c23c4225bb815$var$node;

});


parcelRegister("h3dDK", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", () => $f183a84928b80395$export$c8e99e3434791c0e);
const $f183a84928b80395$export$c8e99e3434791c0e = {
    name: 'knowledge-hub-browse-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
    exact: true
};

});


parcelRegister("ki0Kw", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRouteEntry", () => $1473ec27b3c9f780$export$dd6c99863524ee59);
/* eslint-disable import/order */ 

var $kBLrj = parcelRequire("kBLrj");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $aWyHv = parcelRequire("aWyHv");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $icM5g = parcelRequire("icM5g");

var $c9EqH = parcelRequire("c9EqH");

var $4V0by = parcelRequire("4V0by");

var $4yk4q = parcelRequire("4yk4q");

var $aq2zI = parcelRequire("aq2zI");
const $1473ec27b3c9f780$export$dd6c99863524ee59 = (0, $fdS54.createEntry)((0, $aWyHv.knowledgeHubBrowseAllCategoriesRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4yk4q.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $kBLrj.AsyncKbNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $c9EqH.projectIdResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $icM5g.kbTopicsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $4V0by.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4yk4q.LazyServicedeskKnowledgeHubBrowseAllCategories)
        ],
        perfMetricKey: 'service-management.kb-categories',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_BROWSE_CATEGORIES,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_BROWSE_CATEGORIES),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aWyHv", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", () => $484492f25b398b02$export$256f841794b3f077);
const $484492f25b398b02$export$256f841794b3f077 = {
    name: 'knowledge-hub-browse-all-categories',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
    exact: true
};

});

parcelRegister("4yk4q", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllCategories", () => $64feefa30797eda2$export$a488cba75f18ade8);
$parcel$export(module.exports, "default", () => $64feefa30797eda2$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $64feefa30797eda2$export$a488cba75f18ade8 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("aVHOM"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-hub-browse-all-categories/src/index.tsx"
});
const $64feefa30797eda2$var$AsyncServicedeskKnowledgeHubBrowseAllCategories = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $64feefa30797eda2$export$a488cba75f18ade8,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
        shouldShowSpinner: true
    });
$64feefa30797eda2$var$AsyncServicedeskKnowledgeHubBrowseAllCategories.displayName = "AsyncServicedeskKnowledgeHubBrowseAllCategories";
var $64feefa30797eda2$export$2e2bcd8739ae039 = $64feefa30797eda2$var$AsyncServicedeskKnowledgeHubBrowseAllCategories;

});
parcelRegister("aVHOM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("fNTAc")
]).then(()=>parcelRequire('faTDw'));

});



parcelRegister("4q4hj", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRouteEntry", () => $dfeb50e97a4418a8$export$abb9cdffbf5c943b);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7shRV = parcelRequire("7shRV");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $aq2zI = parcelRequire("aq2zI");

var $h0iJY = parcelRequire("h0iJY");
const $dfeb50e97a4418a8$export$abb9cdffbf5c943b = (0, $fdS54.createEntry)((0, $7shRV.knowledgeHubBrowseViewArticleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $h0iJY.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $h0iJY.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7shRV", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", () => $9431ddc6fa14e877$export$ef8a9ec2979d1b10);
const $9431ddc6fa14e877$export$ef8a9ec2979d1b10 = {
    name: 'knowledge-hub-browse-view-article',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
};

});


parcelRegister("adYD6", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubCategoryPageRouteEntry", () => $07016b8140234411$export$464b24032c2aeb02);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7dzjV = parcelRequire("7dzjV");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $aq2zI = parcelRequire("aq2zI");

var $arzgC = parcelRequire("arzgC");
const $07016b8140234411$export$464b24032c2aeb02 = (0, $fdS54.createEntry)((0, $7dzjV.knowledgeHubCategoryPageRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $arzgC.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $arzgC.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_CATEGORY,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7dzjV", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubCategoryPageRoute", () => $ca6ecf7e652c6048$export$79fb48a07e43639a);
const $ca6ecf7e652c6048$export$79fb48a07e43639a = {
    name: 'knowledge-hub-category-page',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
};

});

parcelRegister("arzgC", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubCategory", () => $4603d6416354ebfc$export$c01a896b8d33aa9c);
$parcel$export(module.exports, "default", () => $4603d6416354ebfc$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4603d6416354ebfc$export$c01a896b8d33aa9c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("aYwAS"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-hub-category/src/index.tsx"
});
const $4603d6416354ebfc$var$AsyncServicedeskKnowledgeHubCategory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4603d6416354ebfc$export$c01a896b8d33aa9c,
        pageId: "spa-apps/servicedesk/knowledge-hub/category",
        shouldShowSpinner: true
    });
$4603d6416354ebfc$var$AsyncServicedeskKnowledgeHubCategory.displayName = "AsyncServicedeskKnowledgeHubCategory";
var $4603d6416354ebfc$export$2e2bcd8739ae039 = $4603d6416354ebfc$var$AsyncServicedeskKnowledgeHubCategory;

});
parcelRegister("aYwAS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iigU8")
]).then(()=>parcelRequire('5oaxl'));

});



parcelRegister("F88dL", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubCategoryRouteEntry", () => $d8545d092dd6f6de$export$416d7b87b4f3205e);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7Q2gV = parcelRequire("7Q2gV");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $aq2zI = parcelRequire("aq2zI");

var $arzgC = parcelRequire("arzgC");
const $d8545d092dd6f6de$export$416d7b87b4f3205e = (0, $fdS54.createEntry)((0, $7Q2gV.knowledgeHubCategoryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.knowledge.category',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $arzgC.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $arzgC.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_CATEGORY,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7Q2gV", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubCategoryRoute", () => $cef2932830edbe96$export$69ed5b0214ea6ee5);
const $cef2932830edbe96$export$69ed5b0214ea6ee5 = {
    name: 'knowledge-hub-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
};

});


parcelRegister("4AhEY", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubDraftsRouteEntry", () => $a55d402e5e9a7a7e$export$4da743c0d13c2cfc);
/* eslint-disable import/order */ 

var $kBLrj = parcelRequire("kBLrj");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $51xgh = parcelRequire("51xgh");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $icM5g = parcelRequire("icM5g");

var $c9EqH = parcelRequire("c9EqH");

var $4V0by = parcelRequire("4V0by");

var $2sVOy = parcelRequire("2sVOy");

var $aq2zI = parcelRequire("aq2zI");
const $a55d402e5e9a7a7e$export$4da743c0d13c2cfc = (0, $fdS54.createEntry)((0, $51xgh.knowledgeHubDraftsRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2sVOy.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $kBLrj.AsyncKbNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $c9EqH.projectIdResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $icM5g.kbTopicsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $4V0by.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2sVOy.LazyServicedeskKnowledgeHubDrafts)
        ],
        perfMetricKey: 'service-management.kb-drafts',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_DRAFTS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_DRAFTS),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("51xgh", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubDraftsRoute", () => $ecf5a387528c8971$export$670f3b59aa55b7ae);
const $ecf5a387528c8971$export$670f3b59aa55b7ae = {
    name: 'knowledge-hub-drafts',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
    exact: true
};

});

parcelRegister("2sVOy", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubDrafts", () => $9ba78f232b81dfea$export$53decb9d1eb60aed);
$parcel$export(module.exports, "default", () => $9ba78f232b81dfea$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9ba78f232b81dfea$export$53decb9d1eb60aed = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("erkNd"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-hub-drafts/src/index.tsx"
});
const $9ba78f232b81dfea$var$AsyncServicedeskKnowledgeHubDrafts = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9ba78f232b81dfea$export$53decb9d1eb60aed,
        pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
        shouldShowSpinner: true
    });
$9ba78f232b81dfea$var$AsyncServicedeskKnowledgeHubDrafts.displayName = "AsyncServicedeskKnowledgeHubDrafts";
var $9ba78f232b81dfea$export$2e2bcd8739ae039 = $9ba78f232b81dfea$var$AsyncServicedeskKnowledgeHubDrafts;

});
parcelRegister("erkNd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("92dQF")
]).then(()=>parcelRequire('6f9Ci'));

});



parcelRegister("9VX8H", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubLandingRouteEntry", () => $1ac5efb28fc6a146$export$671687d85e096e5b);
/* eslint-disable import/order */ 

var $kBLrj = parcelRequire("kBLrj");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $8GCkj = parcelRequire("8GCkj");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $c9EqH = parcelRequire("c9EqH");

var $icM5g = parcelRequire("icM5g");

var $4V0by = parcelRequire("4V0by");

var $i860n = parcelRequire("i860n");

var $8HUuJ = parcelRequire("8HUuJ");

var $aq2zI = parcelRequire("aq2zI");

var $hvQ1V = parcelRequire("hvQ1V");
const $1ac5efb28fc6a146$export$671687d85e096e5b = (0, $fdS54.createEntry)((0, $8GCkj.knowledgeHubLandingRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hvQ1V.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $kBLrj.AsyncKbNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $c9EqH.projectIdResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $icM5g.kbTopicsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $4V0by.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hvQ1V.LazyServicedeskKnowledgeHubLanding)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_LANDING,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_LANDING),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8GCkj", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubLandingRoute", () => $984abd621c5b0928$export$239eaf6a202e0f54);
const $984abd621c5b0928$export$239eaf6a202e0f54 = {
    name: 'knowledge-hub-landing',
    path: '/jira/servicedesk/projects/:projectKey/knowledge',
    exact: true
};

});

parcelRegister("hvQ1V", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubLanding", () => $1fc56f32a8e5b530$export$f1266a588cfc310b);
$parcel$export(module.exports, "default", () => $1fc56f32a8e5b530$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1fc56f32a8e5b530$export$f1266a588cfc310b = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7kpbK")), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-hub-landing/src/index.tsx"
});
const $1fc56f32a8e5b530$var$AsyncServicedeskKnowledgeHubLanding = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1fc56f32a8e5b530$export$f1266a588cfc310b,
        pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
        shouldShowSpinner: true
    });
$1fc56f32a8e5b530$var$AsyncServicedeskKnowledgeHubLanding.displayName = "AsyncServicedeskKnowledgeHubLanding";
var $1fc56f32a8e5b530$export$2e2bcd8739ae039 = $1fc56f32a8e5b530$var$AsyncServicedeskKnowledgeHubLanding;

});
parcelRegister("7kpbK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("f2mty")
]).then(()=>parcelRequire('8dzyi'));

});



parcelRegister("gd2CR", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSearchRouteEntry", () => $e4f085c1f22a7f87$export$49337a3cc2431ae5);
/* eslint-disable import/order */ 

var $kBLrj = parcelRequire("kBLrj");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $K15i9 = parcelRequire("K15i9");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $c9EqH = parcelRequire("c9EqH");

var $icM5g = parcelRequire("icM5g");

var $4V0by = parcelRequire("4V0by");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $aq2zI = parcelRequire("aq2zI");

var $h0iJY = parcelRequire("h0iJY");
const $e4f085c1f22a7f87$export$49337a3cc2431ae5 = (0, $fdS54.createEntry)((0, $K15i9.knowledgeHubSearchRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $h0iJY.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $kBLrj.AsyncKbNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $c9EqH.projectIdResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $icM5g.kbTopicsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $4V0by.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $h0iJY.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("K15i9", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSearchRoute", () => $4022c2b729f08366$export$a47c36fb081b544d);
const $4022c2b729f08366$export$a47c36fb081b544d = {
    name: 'knowledge-hub-search',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
};

});


parcelRegister("gAPvJ", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSetupRouteEntry", () => $bb43ac76d5728eab$export$b220f8194ee7c231);


var $fNZVZ = parcelRequire("fNZVZ");

var $fLcUe = parcelRequire("fLcUe");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $5cBLE = parcelRequire("5cBLE");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $c9EqH = parcelRequire("c9EqH");

var $8HUuJ = parcelRequire("8HUuJ");

var $icM5g = parcelRequire("icM5g");

var $4V0by = parcelRequire("4V0by");

var $i860n = parcelRequire("i860n");

var $aq2zI = parcelRequire("aq2zI");

var $kXXIb = parcelRequire("kXXIb");

var $5DXGo = parcelRequire("5DXGo");
const $bb43ac76d5728eab$export$b220f8194ee7c231 = (0, $fdS54.createEntry)((0, $5cBLE.knowledgeHubSetupRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kXXIb.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $5DXGo.getKBExperimentResources)(),
            (0, $fLcUe.servicedeskKnowledgeBaseServerLinkStatusResource),
            (0, $fNZVZ.servicedeskKnowledgeBaseLinkedSourcesResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $c9EqH.projectIdResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $icM5g.kbTopicsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $4V0by.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $kXXIb.LazyServicedeskKnowledgeHubSetup)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_SETUP,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_SETUP),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5cBLE", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSetupRoute", () => $8eaf0fa71ad356b5$export$f20770545704547d);
const $8eaf0fa71ad356b5$export$f20770545704547d = {
    name: 'knowledge-hub-setup',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
};

});

parcelRegister("kXXIb", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSetup", () => $8fad19ee38c0587f$export$6c08040d2dc71e43);
$parcel$export(module.exports, "default", () => $8fad19ee38c0587f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $8fad19ee38c0587f$export$6c08040d2dc71e43 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("bWsFq")), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-hub-setup/src/index.tsx"
});
const $8fad19ee38c0587f$var$AsyncServicedeskKnowledgeHubSetup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $8fad19ee38c0587f$export$6c08040d2dc71e43,
        pageId: "spa-apps/servicedesk/knowledge-hub/setup",
        shouldShowSpinner: true
    });
$8fad19ee38c0587f$var$AsyncServicedeskKnowledgeHubSetup.displayName = "AsyncServicedeskKnowledgeHubSetup";
var $8fad19ee38c0587f$export$2e2bcd8739ae039 = $8fad19ee38c0587f$var$AsyncServicedeskKnowledgeHubSetup;

});
parcelRegister("bWsFq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("gCScl"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bnSKR")
]).then(()=>parcelRequire('9dMXQ'));

});


parcelRegister("5DXGo", function(module, exports) {
$parcel$export(module.exports, "getKBExperimentResources", () => $ff894bacc770c320$export$1f44ba1db527c265);

var $fRnuF = parcelRequire("fRnuF");

var $gVpLn = parcelRequire("gVpLn");

var $1e5QU = parcelRequire("1e5QU");

var $gCQVm = parcelRequire("gCQVm");

var $b6sxH = parcelRequire("b6sxH");
const $ff894bacc770c320$export$1f44ba1db527c265 = ()=>[
        (0, $fRnuF.servicedeskKnowledgeBaseAppLinksResource),
        (0, $gVpLn.servicedeskKnowledgeBaseKbTopicsResource),
        (0, $1e5QU.servicedeskKnowledgeBaseAiDraftGenerateResource),
        (0, $gCQVm.servicedeskKnowledgeBaseFetchProjectIssuesResource),
        (0, $b6sxH.servicedeskKnowledgeBaseThirdpartyConnectorsResource)
    ];

});
parcelRegister("fRnuF", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseAppLinksResource", () => $75c32184b91a8e74$export$44d5f7a53fb5c262);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

const $75c32184b91a8e74$export$44d5f7a53fb5c262 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_APP_LINKS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("5R9PF")),
    maxAge: Infinity
});

});
parcelRegister("5R9PF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2KRWv").then(()=>parcelRequire('jDAvW'));

});


parcelRegister("gVpLn", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseKbTopicsResource", () => $a8edebf621187628$export$f4625a4a319130bd);

var $7edbf = parcelRequire("7edbf");

const $a8edebf621187628$export$f4625a4a319130bd = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_KB_TOPICS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("3oyaE")),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("3oyaE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4I8zg").then(()=>parcelRequire('4nS8S'));

});


parcelRegister("1e5QU", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseAiDraftGenerateResource", () => $4dc077be4486d43d$export$1359a8300fe0f193);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

const $4dc077be4486d43d$export$1359a8300fe0f193 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_AI_DRAFT_GENERATE',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("d6spd")),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("d6spd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gGIpm").then(()=>parcelRequire('9Whaj'));

});


parcelRegister("gCQVm", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseFetchProjectIssuesResource", () => $47fc145a04fb5999$export$916781e82d6715a6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // project = "TO" AND created >= "-28d" ORDER BY created DESC

var $7edbf = parcelRequire("7edbf");

const $47fc145a04fb5999$export$916781e82d6715a6 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_FETCH_PROJECT_ISSUES',
    getKey: ({ match: match })=>match.query.projectKey || '',
    getDataLoader: ()=>(parcelRequire("1qaEl"))
});

});
parcelRegister("1qaEl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4GnHW").then(()=>parcelRequire('8OTXH'));

});


parcelRegister("b6sxH", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseThirdpartyConnectorsResource", () => $7006f2b38fb37aa7$export$98d85998fe3f25c6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

const $7006f2b38fb37aa7$export$98d85998fe3f25c6 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_THIRDPARTY_CONNECTORS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("67ATM")),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("67ATM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lUjTt").then(()=>parcelRequire('hQ2Gd'));

});




parcelRegister("dHOWY", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRouteEntry", () => $b9968eb01f736862$export$6a7974939bde7d37);
/* eslint-disable import/order */ 

var $kBLrj = parcelRequire("kBLrj");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $jCEjM = parcelRequire("jCEjM");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $icM5g = parcelRequire("icM5g");

var $c9EqH = parcelRequire("c9EqH");

var $4V0by = parcelRequire("4V0by");

var $bDHnB = parcelRequire("bDHnB");

var $aq2zI = parcelRequire("aq2zI");
const $b9968eb01f736862$export$6a7974939bde7d37 = (0, $fdS54.createEntry)((0, $jCEjM.knowledgeHubSuggestedArticlesRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('jsm-kb-articles-functional') ? (0, $bDHnB.ServiceDeskKnowledgeHubSuggestedArticlesWithResource) : (0, $bDHnB.ServiceDeskKnowledgeHubSuggestedArticles),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $kBLrj.AsyncKbNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $aq2zI.getKnowledgeHubResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $c9EqH.projectIdResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $icM5g.kbTopicsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm-kb-articles-functional'), (0, $4V0by.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bDHnB.LazyServicedeskKnowledgeHubSuggestedArticles)
        ],
        perfMetricKey: 'service-management.kb-suggested-articles',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).KB_SUGGESTED_ARTICLES,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).KB_SUGGESTED_ARTICLES),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jCEjM", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", () => $6e28cfd6f480fc06$export$54edf5cef1c6b21b);
const $6e28cfd6f480fc06$export$54edf5cef1c6b21b = {
    name: 'knowledge-hub-suggested-topics',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
    exact: true
};

});

parcelRegister("bDHnB", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSuggestedArticles", () => $c2d12a888d05cd30$export$aee7d96c2ee4c388);
$parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticles", () => $c2d12a888d05cd30$export$ee4623542ebd573e);
$parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticlesWithResource", () => $c2d12a888d05cd30$export$dce81affa4bfe4c6);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $2fAux = parcelRequire("2fAux");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $ccEzE = parcelRequire("ccEzE");

var $l8G1z = parcelRequire("l8G1z");

var $k6ufm = parcelRequire("k6ufm");

var $icM5g = parcelRequire("icM5g");

var $5z1Bn = parcelRequire("5z1Bn");

var $jxdWD = parcelRequire("jxdWD");

var $inMxE = parcelRequire("inMxE");

const $c2d12a888d05cd30$export$aee7d96c2ee4c388 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("a4d4w"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-hub-suggested-articles/src/index.tsx"
});
const $c2d12a888d05cd30$export$ee4623542ebd573e = ()=>{
    const { data: isAdminHubAIEnabled, loading: isAdminHubAIEnabledLoading, error: isAdminHubAIEnabledError, fetchAIEnablement: fetchAIEnablement } = (0, $2fAux.default)('jira-servicedesk');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $jxdWD.usePageContext)();
    const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
    const { projectId: projectId } = projectContext || {};
    const activationId = tenantContext?.activationId || '';
    const [{ error: topicsError, loading: isTopicsLoading }, { fetchSuggestedTopics: fetchSuggestedTopics }] = (0, $5z1Bn.useSuggestedTopics)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    const isTopicSuggestionAllowed = (0, $euxye.useCallback)(()=>{
        return appEditions.serviceDesk === 'PREMIUM_EDITION';
    }, [
        appEditions.serviceDesk
    ]);
    const showSuggestedTopics = isTopicSuggestionAllowed() && !isAdminHubAIEnabledLoading && !isAdminHubAIEnabledError && isAdminHubAIEnabled && !isTopicsLoading && !topicsError;
    (0, $euxye.useEffect)(()=>{
        projectId && isTopicSuggestionAllowed() && isAdminHubAIEnabled && fetchSuggestedTopics(projectId, createAnalyticsEvent({}), activationId);
    }, [
        activationId,
        createAnalyticsEvent,
        fetchSuggestedTopics,
        isTopicSuggestionAllowed,
        projectId,
        isAdminHubAIEnabled
    ]);
    (0, $euxye.useEffect)(()=>{
        isTopicSuggestionAllowed() && fetchAIEnablement();
    }, [
        fetchAIEnablement,
        isTopicSuggestionAllowed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, showSuggestedTopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c2d12a888d05cd30$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    }));
};
$c2d12a888d05cd30$export$ee4623542ebd573e.displayName = "ServiceDeskKnowledgeHubSuggestedArticles";
const $c2d12a888d05cd30$export$dce81affa4bfe4c6 = ()=>{
    const { data: isAdminHubAIEnabled, loading: isAdminHubAIEnabledLoading, error: isAdminHubAIEnabledError, fetchAIEnablement: fetchAIEnablement } = (0, $2fAux.default)('jira-servicedesk');
    const { data: topicsData, error: topicsError, loading: isTopicsLoading } = (0, $k6ufm.useResource)((0, $icM5g.kbTopicsResource));
    const showSuggestedTopics = topicsData?.topicSuggestionAllowed && !isAdminHubAIEnabledLoading && !isAdminHubAIEnabledError && isAdminHubAIEnabled && !isTopicsLoading && !topicsError;
    (0, $euxye.useEffect)(()=>{
        topicsData?.topicSuggestionAllowed && fetchAIEnablement();
    }, [
        fetchAIEnablement,
        topicsData?.topicSuggestionAllowed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, showSuggestedTopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c2d12a888d05cd30$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    }));
};
$c2d12a888d05cd30$export$dce81affa4bfe4c6.displayName = "ServiceDeskKnowledgeHubSuggestedArticlesWithResource";

});
parcelRegister("2fAux", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f4fb5d18aa02867$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $cLAxv = parcelRequire("cLAxv");
const $2f4fb5d18aa02867$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $euxye.useState)(null);
    const [loading, setLoading] = (0, $euxye.useState)(false);
    const [error, setError] = (0, $euxye.useState)(null);
    const fetchData = (0, $euxye.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $cLAxv.fetchAiEnablement)(jiraProduct, version);
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $hFtK7.fireErrorAnalytics)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $2f4fb5d18aa02867$export$2e2bcd8739ae039 = $2f4fb5d18aa02867$var$useIsAdminHubAIEnabled;

});
parcelRegister("cLAxv", function(module, exports) {
$parcel$export(module.exports, "fetchAiEnablement", () => $14bd812b856a6e01$export$ad4105850d0ce824);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");
const $14bd812b856a6e01$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $14bd812b856a6e01$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $14bd812b856a6e01$export$2171a423b572256a(jiraProduct, version);
    return (0, $4fhEY.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("ccEzE", function(module, exports) {
$parcel$export(module.exports, "useAppEditions", () => $03ee0c4316b674cd$export$92ed15881fc090d7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $03ee0c4316b674cd$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

parcelRegister("5z1Bn", function(module, exports) {
$parcel$export(module.exports, "KnowledgeHubSuggestedTopicsContainer", () => $39f66bd23bfd6e5a$export$545055c3c05f3a42);
$parcel$export(module.exports, "useSuggestedTopics", () => $39f66bd23bfd6e5a$export$2328a37d3e371b67);
$parcel$export(module.exports, "usePageNumber", () => $39f66bd23bfd6e5a$export$1571508029b597f4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $gfNUm = parcelRequire("gfNUm");

var $4HeYu = parcelRequire("4HeYu");
const $39f66bd23bfd6e5a$var$initialState = {
    topics: {
        data: [],
        loading: false,
        error: null
    },
    page: 1
};
const $39f66bd23bfd6e5a$export$6f57813fe9f31bf9 = (0, $5QDqc.createStore)({
    initialState: $39f66bd23bfd6e5a$var$initialState,
    actions: $gfNUm.actions,
    name: 'KnowledgeHubSuggestedTopicsStore'
});
const $39f66bd23bfd6e5a$export$545055c3c05f3a42 = (0, $dB6ay.createContainer)($39f66bd23bfd6e5a$export$6f57813fe9f31bf9, {
    displayName: 'KnowledgeHubSuggestedTopicsContainer'
});
const $39f66bd23bfd6e5a$export$2328a37d3e371b67 = (0, $3h1FP.createHook)($39f66bd23bfd6e5a$export$6f57813fe9f31bf9, {
    selector: (0, $4HeYu.getSuggestedTopics)
});
const $39f66bd23bfd6e5a$export$1571508029b597f4 = (0, $3h1FP.createHook)($39f66bd23bfd6e5a$export$6f57813fe9f31bf9, {
    selector: (0, $4HeYu.getPageNumber)
});

});
parcelRegister("gfNUm", function(module, exports) {
$parcel$export(module.exports, "actions", () => $ae2b18935b18fe8f$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3aDdJ = parcelRequire("3aDdJ");

var $hhTRp = parcelRequire("hhTRp");

var $284EZ = parcelRequire("284EZ");

var $aDN9t = parcelRequire("aDN9t");

var $1YvX9 = parcelRequire("1YvX9");
const $ae2b18935b18fe8f$export$e324594224ef24da = {
    fetchSuggestedTopics: $hhTRp.fetchSuggestedTopics,
    setPagination: $284EZ.setPagination,
    dismissTopic: $3aDdJ.dismissTopic,
    fetchAiDraftPreviewContent: $aDN9t.fetchAiDraftPreviewContent,
    triggerArticleGenerationForTopics: $1YvX9.triggerArticleGenerationForTopics
};

});
parcelRegister("3aDdJ", function(module, exports) {
$parcel$export(module.exports, "dismissTopic", () => $b1b9fbe3a006df61$export$8c9ab121673c8912);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $iQPOZ = parcelRequire("iQPOZ");

var $aJ81Y = parcelRequire("aJ81Y");

var $lcroN = parcelRequire("lcroN");

var $e7zqm = parcelRequire("e7zqm");

var $1SlyC = parcelRequire("1SlyC");


var $9f4QL = parcelRequire("9f4QL");

var $7eNDO = parcelRequire("7eNDO");
const $b1b9fbe3a006df61$var$dismissTopicSuccessTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-success-title",
    defaultMessage: "Removed the suggested topic"
});
const $b1b9fbe3a006df61$var$dismissTopicErrorTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-error-title",
    defaultMessage: "We couldn\u2019t remove the topic"
});
const $b1b9fbe3a006df61$var$dismissTopicErrorDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-error-description",
    defaultMessage: "Something went wrong. Try again or refresh the page"
});
const $b1b9fbe3a006df61$export$8c9ab121673c8912 = (topicId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, locale: locale, activationId: activationId } = props;
        const currentTopics = getState().topics.data;
        // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
        const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
        const formatMessage = (0, $lcroN.createFormatMessage)(locale);
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: true,
                    error: null
                }
            });
            projectId && await (0, $1SlyC.deleteTopic)(projectId, topicId, activationId);
            const updatedTopics = (0, $9f4QL.removeTopic)(currentTopics, topicId);
            const page = (0, $e7zqm.getPageOnDelete)(getState().page, updatedTopics.length, (0, $4635d31b849c7707$export$5631491ed07b4a08));
            setState({
                ...getState(),
                topics: {
                    data: updatedTopics,
                    loading: false,
                    error: null
                },
                page: page
            });
            showFlag({
                type: 'success',
                title: formatMessage($b1b9fbe3a006df61$var$dismissTopicSuccessTitle),
                isAutoDismiss: true,
                // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
                messageId: 'servicedesk-knowledge-performance.show-flag.success.dismiss-topic',
                messageType: 'transactional'
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'dismissTopic succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: false,
                    error: error
                }
            });
            showFlag({
                type: 'error',
                title: formatMessage($b1b9fbe3a006df61$var$dismissTopicErrorTitle),
                description: formatMessage($b1b9fbe3a006df61$var$dismissTopicErrorDescription),
                isAutoDismiss: true,
                // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
                messageId: 'servicedesk-knowledge-performance.show-flag.error.dismiss-topic',
                messageType: 'transactional'
            });
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'dismissTopic',
                    packageName: (0, $4635d31b849c7707$export$b8b9d90f9e5bd72b),
                    teamName: (0, $4635d31b849c7707$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("lcroN", function(module, exports) {
$parcel$export(module.exports, "createFormatMessage", () => $98cdd0ce72c6d11c$export$5eaf6c4755708cf2);
/// <reference types="node" />
// correctly type "require"

var $aUPBc = parcelRequire("aUPBc");

var $fKr2P = parcelRequire("fKr2P");

var $bzv7B = parcelRequire("bzv7B");

const $98cdd0ce72c6d11c$export$5eaf6c4755708cf2 = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((locale)=>{
    // TODO: providing locale to IntlProvider is nothing to do with translation. We can completely remove language, not providing any locale
    // TODO: React-intl just reads whatever given to messages object, regardless of locale. REMOVE THIS
    // IntlProvider cannot deal with locale w/ country code. Needs language-only.
    const language = (0, $fKr2P.default)(locale);
    // disable flow for unresolved externals module
    // disable eslint for both unresolved module
    // oxlint-disable-next-line typescript/no-require-imports, typescript/no-var-requires
    const messages = (parcelRequire("cK8QE"));
    const intl = (0, $bzv7B.getIntl)({
        locale: language,
        messages: messages
    });
    return intl.formatMessage;
});

});
parcelRegister("fKr2P", function(module, exports) {
$parcel$export(module.exports, "default", () => $90326461ce7b397a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // en_US => en
// DO NOT USE IT ANYMORE!!
// DO NOT USE IT ANYMORE!!
//
// After the feature flag(https://app.launchdarkly.com/jira/staging/features/use.bcp47.locale.format/targeting) is cleaned-up, this will be removed.
// The reason why it is deprecated is that we are providing locale to ReactIntlProvider as a locale prop after applying
// this function. This is wrong because we are passing only language part ignoring the region variance.
// The consequence is react-intl's format functions such as formatDate will format date into MM-DD-YYYY, instead of DD-MM-YYYY
// in case of en-gb. The similar things could happen in any other language variances.
// On 2. Feb. 2021, it is confirmed that this function is only used to provide locale for IntlProvider component
// Under the feature flag, it is replaced with getBCPLocale function that replaces _ to - to be BCP47 web standard locale format
//
// DO NOT USE IT ANYMORE!!
// DO NOT USE IT ANYMORE!!
const $90326461ce7b397a$var$getLanguageFromLocale = (locale)=>locale ? locale.substring(0, locale.indexOf('_')) : '';
var $90326461ce7b397a$export$2e2bcd8739ae039 = $90326461ce7b397a$var$getLanguageFromLocale;

});

parcelRegister("bzv7B", function(module, exports) {
$parcel$export(module.exports, "getIntl", () => $7412a1fb6769898f$export$51771ec7613ad564);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/react-intl

var $llgA6 = parcelRequire("llgA6");
var $dqCTG = parcelRequire("dqCTG");
const $7412a1fb6769898f$var$cache = (0, $dqCTG.createIntlCache)();
const $7412a1fb6769898f$export$51771ec7613ad564 = (config)=>(0, $llgA6.createIntl)(config, $7412a1fb6769898f$var$cache);

});

parcelRegister("cK8QE", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("e7zqm", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalyticsEvents", () => $e009589ec6e0ddc1$export$b84e314c48e09c44);
$parcel$export(module.exports, "getPageOnDelete", () => $e009589ec6e0ddc1$export$99689dbe56145ad5);
$parcel$export(module.exports, "fireCustomErrorAnalytics", () => $e009589ec6e0ddc1$export$3d13cbe76aeaf5e8);
$parcel$export(module.exports, "getViewArticleUrl", () => $e009589ec6e0ddc1$export$4b1de73aa951498c);
$parcel$export(module.exports, "getJcsViewArticleUrl", () => $e009589ec6e0ddc1$export$adfe9025f8369589);
$parcel$export(module.exports, "getAllDraftsUrl", () => $e009589ec6e0ddc1$export$939c0821a1193768);
$parcel$export(module.exports, "getAllArticlesUrl", () => $e009589ec6e0ddc1$export$240e98bbb8304c52);
$parcel$export(module.exports, "getAllJcsArticlesUrl", () => $e009589ec6e0ddc1$export$35dca3e17444a3e5);
$parcel$export(module.exports, "getFlag", () => $e009589ec6e0ddc1$export$a19b74191e00c5e);
$parcel$export(module.exports, "getCommonFlagData", () => $e009589ec6e0ddc1$export$f44d45dc3db56277);
$parcel$export(module.exports, "filterSupportedBillingPeriod", () => $e009589ec6e0ddc1$export$9f13ed259dc4b1bf);
$parcel$export(module.exports, "formatTrialEndDate", () => $e009589ec6e0ddc1$export$da56c66ce2766e02);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $75sVW = parcelRequire("75sVW");

var $aJ81Y = parcelRequire("aJ81Y");


var $fdN65 = parcelRequire("fdN65");

var $jozhZ = parcelRequire("jozhZ");
const $e009589ec6e0ddc1$var$TEAM_NAME = 'jsm-nebula';
const $e009589ec6e0ddc1$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $e009589ec6e0ddc1$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $e009589ec6e0ddc1$export$53ee51427129200c = (statusCode)=>$e009589ec6e0ddc1$export$1a5a4674dd906e7e(statusCode) || $e009589ec6e0ddc1$export$d31fd506ce75fa65(statusCode);
const $e009589ec6e0ddc1$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    if (error && typeof error.statusCode === 'number') {
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
        const { statusCode: statusCode } = error;
        const lowPriorityError = statusCode >= 400 && statusCode < 500;
        const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
        const transformedError = error instanceof (0, $75sVW.default) ? error : new (0, $75sVW.default)(statusCode);
        const errorObj = {
            error: transformedError,
            meta: {
                id: errorMetaId,
                packageName: packageName,
                teamName: $e009589ec6e0ddc1$var$TEAM_NAME
            },
            skipSentry: true,
            ...attributes && {
                attributes: attributes
            }
        };
        (0, $hFtK7.fireErrorAnalytics)(errorObj);
    } else (0, $hFtK7.fireErrorAnalytics)({
        // Note there should not be a case of circular object for error , if there is it will be handled by fireErrorAnalytics
        error: error instanceof Error ? error : new Error(JSON.stringify(error)),
        meta: {
            id: `${id}__JS_ERROR`,
            packageName: packageName,
            teamName: $e009589ec6e0ddc1$var$TEAM_NAME
        },
        ...attributes && {
            attributes: attributes
        }
    });
};
const $e009589ec6e0ddc1$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
    const lastPage = Math.ceil(updateDataSize / perPage);
    return currentPage > lastPage ? lastPage : currentPage;
};
const $e009589ec6e0ddc1$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
    if (error && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    typeof error.statusCode === 'number' && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    !$e009589ec6e0ddc1$export$53ee51427129200c(error.statusCode)) event && (0, $aJ81Y.fireOperationalAnalytics)(event, id);
    $e009589ec6e0ddc1$export$b84e314c48e09c44(error, id, packageName, attributes);
};
const $e009589ec6e0ddc1$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
const $e009589ec6e0ddc1$export$adfe9025f8369589 = (projectKey, contentId, spaceKey, helpCenterId)=>`/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles/${contentId}?spaceKey=${spaceKey}`;
const $e009589ec6e0ddc1$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
const $e009589ec6e0ddc1$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
const $e009589ec6e0ddc1$export$35dca3e17444a3e5 = (projectKey, helpCenterId)=>`/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles`;
const $e009589ec6e0ddc1$export$a19b74191e00c5e = (title, description, flagType)=>({
        title: title,
        description: description,
        id: (0, $fdN65.generateNanoId)(),
        flagType: flagType
    });
const $e009589ec6e0ddc1$export$a6125e21263de883 = (state)=>{
    const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
    const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
    const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
    const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
    const isArticleDeleted = Boolean(articleId && deleted);
    return {
        isDraftPublished: isDraftPublished,
        isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
        isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
        isArticleDeleted: isArticleDeleted
    };
};
const $e009589ec6e0ddc1$export$f44d45dc3db56277 = (state, messages)=>{
    let flag = {
        id: '',
        title: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        description: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        type: (0, $09e935d97045e22c$export$f215947b3d76a6b7)
    };
    const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
    // if confluence get content api fails
    if (showConfluenceCreatePageError) {
        flag = {
            id: 'draftErrorFlag',
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            title: messages.confluenceCreatePageFailureTitle,
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            description: messages.confluenceCreatePageFailureDescription,
            type: (0, $09e935d97045e22c$export$f215947b3d76a6b7)
        };
        return flag;
    }
    const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $e009589ec6e0ddc1$export$a6125e21263de883(state);
    // case when new article is published --> Article View
    if (isDraftPublished) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $09e935d97045e22c$export$516433e8a6db7503)
    };
    // case when draft is saved with unpublished changes --> Browse All Articles Page
    if (isDraftSavedWithUnpublishedChanges) flag = {
        id: 'draftSavedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'string | MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessSavedFlagDescription || '',
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $09e935d97045e22c$export$516433e8a6db7503)
    };
    // case when older article is saved with unpublished changes --> Article View
    if (isArticleSavedWithUnpublishedChanges) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleSuccessSavedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $09e935d97045e22c$export$516433e8a6db7503)
    };
    // case when article is deleted --> Browse All Articles Page
    if (isArticleDeleted) flag = {
        id: 'articleDeletedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleDeletedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleDeletedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $09e935d97045e22c$export$516433e8a6db7503)
    };
    return flag;
};
const $e009589ec6e0ddc1$export$9f13ed259dc4b1bf = (billingPeriod)=>{
    if (billingPeriod === (0, $jozhZ.MONTHLY_BILLED)) return 0, $jozhZ.MONTHLY_BILLED;
    if (billingPeriod === (0, $jozhZ.ANNUALLY_BILLED)) return 0, $jozhZ.ANNUALLY_BILLED;
    return 0, $jozhZ.INACTIVE;
};
const $e009589ec6e0ddc1$export$da56c66ce2766e02 = (trialEndDate)=>{
    if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
    return null;
};

});
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $09e935d97045e22c$export$516433e8a6db7503 = 'SUCCESS';
const $09e935d97045e22c$export$a0a5e05447abb018 = 'WARNING';
const $09e935d97045e22c$export$f215947b3d76a6b7 = 'ERROR';
const $09e935d97045e22c$export$21bdd502a5302e06 = 'INFO';

parcelRegister("fdN65", function(module, exports) {
$parcel$export(module.exports, "generateNanoId", () => $0df3b03723b072db$export$a4f5444a5996c185);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eVLyw = parcelRequire("eVLyw");
const $0df3b03723b072db$export$a4f5444a5996c185 = ()=>(0, $eVLyw.nanoid)(12);
const $0df3b03723b072db$export$e73c8bd0f20705a = ()=>(0, $eVLyw.nanoid)();

});
parcelRegister("eVLyw", function(module, exports) {
$parcel$export(module.exports, "nanoid", () => $adeb472cce71bd84$export$ac4959f4f1338dfc);
/* @ts-self-types="./index.d.ts" */ 
let $adeb472cce71bd84$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $adeb472cce71bd84$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log2(alphabet.length - 1)) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length >= size) return id;
            }
        }
    };
};
let $adeb472cce71bd84$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$adeb472cce71bd84$export$a5cee9e955a615e5(alphabet, size | 0, $adeb472cce71bd84$export$4385e60b38654f68);
let $adeb472cce71bd84$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
    while(size--)id += (0, $51131e1c59b8fb96$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};

});
const $51131e1c59b8fb96$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';



parcelRegister("jozhZ", function(module, exports) {
$parcel$export(module.exports, "NCS", () => $d2eb3db252d34107$export$d42203c46ecda0b5);
$parcel$export(module.exports, "PARENT_PRODUCT", () => $d2eb3db252d34107$export$f6fc4a5779d5dc2c);
$parcel$export(module.exports, "USER_ID_TYPE", () => $d2eb3db252d34107$export$a40257481ddef37e);
$parcel$export(module.exports, "TEAM_NAME", () => $d2eb3db252d34107$export$d57b6b390e78d90f);
$parcel$export(module.exports, "MONTHLY_BILLED", () => $d2eb3db252d34107$export$85314a8fbb8155e1);
$parcel$export(module.exports, "ANNUALLY_BILLED", () => $d2eb3db252d34107$export$d1eb58f682ad65ad);
$parcel$export(module.exports, "INACTIVE", () => $d2eb3db252d34107$export$1635bbf8efc1cbc4);
$parcel$export(module.exports, "CONFLUENCE", () => $d2eb3db252d34107$export$c811f21c9ad05dc2);
$parcel$export(module.exports, "NATIVE_CONFLUENCE", () => $d2eb3db252d34107$export$1b63ba606d8ecfaa);
$parcel$export(module.exports, "SERVER_CONFLUENCE", () => $d2eb3db252d34107$export$ce410195c34d61ac);
$parcel$export(module.exports, "CROSS_SITE_CONFLUENCE", () => $d2eb3db252d34107$export$2a7e16e321f5b7a0);
$parcel$export(module.exports, "SHAREPOINT", () => $d2eb3db252d34107$export$bc7192bfce222457);
$parcel$export(module.exports, "GOOGLE_DRIVE", () => $d2eb3db252d34107$export$a9b78a3a2613c33a);
$parcel$export(module.exports, "GOOGLE_DRIVE_CONNECTOR", () => $d2eb3db252d34107$export$ff6b6c90dea66f24);
$parcel$export(module.exports, "SHAREPOINT_CONNECTOR", () => $d2eb3db252d34107$export$58e1cd824c9d9f35);
$parcel$export(module.exports, "INTERNAL_VISIBILITY", () => $d2eb3db252d34107$export$5581bfec82a3629d);
$parcel$export(module.exports, "EXTERNAL_VISIBILITY", () => $d2eb3db252d34107$export$94a3b08b4e0442dd);
$parcel$export(module.exports, "GoogleDriveAri", () => $d2eb3db252d34107$export$1d6d386752f38c08);
$parcel$export(module.exports, "SharePointAri", () => $d2eb3db252d34107$export$45909285cd85fe3d);
/* eslint-disable jira/filename-case */ 
var $2zU0a = parcelRequire("2zU0a");
const $d2eb3db252d34107$export$d42203c46ecda0b5 = 'ncs';
const $d2eb3db252d34107$export$f6fc4a5779d5dc2c = 'JSM';
const $d2eb3db252d34107$export$a40257481ddef37e = 'atlassianAccount';
const $d2eb3db252d34107$export$d57b6b390e78d90f = 'jsm-nebula';
const $d2eb3db252d34107$export$85314a8fbb8155e1 = 'MONTHLY';
const $d2eb3db252d34107$export$d1eb58f682ad65ad = 'ANNUAL';
const $d2eb3db252d34107$export$1635bbf8efc1cbc4 = 'INACTIVE';
const $d2eb3db252d34107$export$c811f21c9ad05dc2 = 'CONFLUENCE';
const $d2eb3db252d34107$export$1b63ba606d8ecfaa = 'NATIVE_CONFLUENCE';
const $d2eb3db252d34107$export$ce410195c34d61ac = 'SERVER_CONFLUENCE';
const $d2eb3db252d34107$export$2a7e16e321f5b7a0 = 'CROSS_SITE_CONFLUENCE';
const $d2eb3db252d34107$export$bc7192bfce222457 = 'SHAREPOINT';
const $d2eb3db252d34107$export$a9b78a3a2613c33a = 'GOOGLE_DRIVE';
const $d2eb3db252d34107$export$ff6b6c90dea66f24 = 'google-drive-connector';
const $d2eb3db252d34107$export$58e1cd824c9d9f35 = 'sharepoint-connector';
const $d2eb3db252d34107$export$5581bfec82a3629d = 'INTERNAL';
const $d2eb3db252d34107$export$94a3b08b4e0442dd = 'EXTERNAL';
const $d2eb3db252d34107$export$1d6d386752f38c08 = (0, $2zU0a.createAri)({
    resourceOwner: 'platform',
    resourceType: 'integration',
    resourceId: 'google'
});
const $d2eb3db252d34107$export$45909285cd85fe3d = (0, $2zU0a.createAri)({
    resourceOwner: 'platform',
    resourceType: 'integration',
    resourceId: 'microsoft'
});

});


parcelRegister("1SlyC", function(module, exports) {
$parcel$export(module.exports, "deleteTopic", () => $641a0bb167a49a88$export$abca5685670e035c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $641a0bb167a49a88$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $641a0bb167a49a88$export$abca5685670e035c = (projectId, topicId, activationId)=>{
    return (0, $h2wCv.performDeleteRequest)(`${$641a0bb167a49a88$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}`);
};

});

/* eslint-disable jira/filename-case */ const $4635d31b849c7707$export$d57b6b390e78d90f = 'jsm-nebula';
const $4635d31b849c7707$export$5631491ed07b4a08 = 10;
const $4635d31b849c7707$export$b8b9d90f9e5bd72b = '@jira/servicedesk__knowledge-performance';

parcelRegister("9f4QL", function(module, exports) {
$parcel$export(module.exports, "removeTopic", () => $7a574d11c1234f6d$export$fcbc6597dc84c9da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $7a574d11c1234f6d$export$fcbc6597dc84c9da = (topics, topicId)=>topics.filter((topic)=>topic.topicId !== topicId);

});


parcelRegister("hhTRp", function(module, exports) {
$parcel$export(module.exports, "fetchSuggestedTopics", () => $5755bd5fb1aa716e$export$c5eac5039f8d8a0);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $aJ81Y = parcelRequire("aJ81Y");


var $kWGDT = parcelRequire("kWGDT");
const $5755bd5fb1aa716e$export$c5eac5039f8d8a0 = (projectId, analyticsEvent, activationId)=>async ({ getState: getState, setState: setState })=>{
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: true,
                    error: null
                }
            });
            const response = await (0, $kWGDT.fetchSuggestedTopics)(projectId, activationId);
            setState({
                ...getState(),
                topics: {
                    data: response.topics,
                    loading: false,
                    error: null
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'fetchTopics succeeded', {
                projectId: projectId,
                noOfTopics: response.topics.length,
                isFiltered: response.isFiltered
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'fetchTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $4635d31b849c7707$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                topics: {
                    data: [],
                    loading: false,
                    error: error
                }
            });
        }
    };

});
parcelRegister("kWGDT", function(module, exports) {
$parcel$export(module.exports, "fetchSuggestedTopics", () => $d441be08c7520461$export$c5eac5039f8d8a0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $d441be08c7520461$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $d441be08c7520461$var$getSuggestedTopicsUrl = (projectId, activationId)=>`${$d441be08c7520461$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics`;
const $d441be08c7520461$export$c5eac5039f8d8a0 = (projectId, activationId)=>{
    const url = $d441be08c7520461$var$getSuggestedTopicsUrl(projectId, activationId);
    return (0, $h2wCv.performGetRequest)(url);
};

});


parcelRegister("284EZ", function(module, exports) {
$parcel$export(module.exports, "setPagination", () => $1c5b09cf62585e7e$export$347aea62317e2398);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1c5b09cf62585e7e$export$347aea62317e2398 = (currentPage)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            page: currentPage
        });
    };

});

parcelRegister("aDN9t", function(module, exports) {
$parcel$export(module.exports, "fetchAiDraftPreviewContent", () => $bbe425b503f7f067$export$518af6df5154b1b1);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $aJ81Y = parcelRequire("aJ81Y");

var $jozhZ = parcelRequire("jozhZ");

var $iNleG = parcelRequire("iNleG");
const $bbe425b503f7f067$export$518af6df5154b1b1 = (topicId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId } = props;
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: null,
                                loading: true,
                                error: null
                            }
                        } : topic)
                }
            });
            const response = projectId && await (0, $iNleG.fetchAiDraftPreviewContent)(projectId, activationId, topicId) || null;
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: response && response?.content || null,
                                loading: false,
                                error: null
                            }
                        } : topic)
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiDraftPreviewContent succeeded', {
                projectId: projectId,
                topicId: topicId
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'fetchAiDraftPreviewContent',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $jozhZ.TEAM_NAME)
                },
                error: error
            });
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: null,
                                loading: false,
                                error: error
                            }
                        } : topic)
                }
            });
        }
    };

});
parcelRegister("iNleG", function(module, exports) {
$parcel$export(module.exports, "fetchAiDraftPreviewContent", () => $b1a6b69eb296305d$export$518af6df5154b1b1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $b1a6b69eb296305d$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $b1a6b69eb296305d$var$getAiDraftPreviewContentUrl = (projectId, activationId, topicId, contentFormat)=>`${$b1a6b69eb296305d$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}/draft-article?contentFormat=${contentFormat}`;
const $b1a6b69eb296305d$export$518af6df5154b1b1 = (projectId, activationId, topicId)=>{
    const contentFormat = 'text/adf';
    const url = $b1a6b69eb296305d$var$getAiDraftPreviewContentUrl(projectId, activationId, topicId, contentFormat);
    return (0, $h2wCv.performGetRequest)(url);
};

});


parcelRegister("1YvX9", function(module, exports) {
$parcel$export(module.exports, "triggerArticleGenerationForTopics", () => $0ea8b89e393e415e$export$7bd57fc6c7a6dd3d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $aJ81Y = parcelRequire("aJ81Y");


var $eVT0b = parcelRequire("eVT0b");
const $0ea8b89e393e415e$export$7bd57fc6c7a6dd3d = (projectId, analyticsEvent, activationId)=>async ()=>{
        try {
            await (0, $eVT0b.fetchArticleGenerationForTopics)(projectId, activationId);
            (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'triggerArticleGenerationForTopics succeeded', {
                projectId: projectId
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'triggerArticleGenerationForTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $4635d31b849c7707$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("eVT0b", function(module, exports) {
$parcel$export(module.exports, "fetchArticleGenerationForTopics", () => $02bf08849bc13b3e$export$5d2d7bed782963e7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $02bf08849bc13b3e$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $02bf08849bc13b3e$export$fd5c5783cdaa5a5f = (projectId, activationId)=>`${$02bf08849bc13b3e$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics/draft-article/generate`;
const $02bf08849bc13b3e$export$5d2d7bed782963e7 = (projectId, activationId)=>{
    const url = $02bf08849bc13b3e$export$fd5c5783cdaa5a5f(projectId, activationId);
    return (0, $h2wCv.performPostRequest)(url);
};

});



parcelRegister("4HeYu", function(module, exports) {
$parcel$export(module.exports, "getSuggestedTopics", () => $53f0616b9b805412$export$d95ddf26dc427cbd);
$parcel$export(module.exports, "getPageNumber", () => $53f0616b9b805412$export$c173ad1c1111eb41);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $53f0616b9b805412$export$d95ddf26dc427cbd = (state)=>state.topics;
const $53f0616b9b805412$export$c173ad1c1111eb41 = (state)=>state.page;

});


parcelRegister("jxdWD", function(module, exports) {
$parcel$export(module.exports, "usePageContext", () => $0b0f61fc09a8094b$export$9c25024bdfe755f7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $lgfXq = parcelRequire("lgfXq");

var $edf7u = parcelRequire("edf7u");

var $d7dm3 = parcelRequire("d7dm3");

var $eijVy = parcelRequire("eijVy");
const $0b0f61fc09a8094b$var$getProjectContextResource = ()=>(0, $edf7u.projectContextResourceWithCache);
const $0b0f61fc09a8094b$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $d7dm3.useResourceWithCustomRouterContext)($0b0f61fc09a8094b$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $lgfXq.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $euxye.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("lgfXq", function(module, exports) {
$parcel$export(module.exports, "useServiceDeskContext", () => $c8d09c973ce83418$export$712ead87353ac687);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $8xla3 = parcelRequire("8xla3");

var $d7dm3 = parcelRequire("d7dm3");

var $iyqMX = parcelRequire("iyqMX");
const $c8d09c973ce83418$var$getServiceDeskContextResource = ()=>(0, $iyqMX.serviceDeskContextResource);
const $c8d09c973ce83418$export$712ead87353ac687 = (projectKey, customContext, options)=>{
    const projectType = (0, $8xla3.useProjectType)(projectKey ?? '');
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $d7dm3.useResourceWithCustomRouterContext)($c8d09c973ce83418$var$getServiceDeskContextResource(), customContext, options);
    (0, $euxye.useEffect)(()=>{
        if (!false) // Only refresh cache if project type is SERVICE_DESK_PROJECT
        {
            if (projectType === (0, $f99M0.SERVICE_DESK_PROJECT)) refreshCache();
        }
    }, [
        projectKey,
        refreshCache,
        projectType
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("a4d4w", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("5Wn9O")
]).then(()=>parcelRequire('jjdHo'));

});



parcelRegister("hCocS", function(module, exports) {
$parcel$export(module.exports, "landingPageRouteEntry", () => $f773329ba5f1841a$export$8ccc5b384e778bac);



var $9zFCH = parcelRequire("9zFCH");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $7e9U7 = parcelRequire("7e9U7");

var $74h93 = parcelRequire("74h93");

var $8QQwn = parcelRequire("8QQwn");

var $dTa0V = parcelRequire("dTa0V");
const $f773329ba5f1841a$var$landingPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9zFCH.landingEntryPoint)
});
const $f773329ba5f1841a$export$8ccc5b384e778bac = (0, $fdS54.createEntry)((0, $7e9U7.landingPageRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            return $f773329ba5f1841a$var$landingPageEntryPoint;
        },
        skeleton: (0, $8QQwn.VirtualAgentLandingSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9zFCH", function(module, exports) {
$parcel$export(module.exports, "landingEntryPoint", () => $5f6f0f0963809dd2$export$ad927ca7512a3a01);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $8455Y = parcelRequire("8455Y");
const $5f6f0f0963809dd2$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $5f6f0f0963809dd2$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $5f6f0f0963809dd2$export$ad927ca7512a3a01 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("GMmct")), {
        moduleId: "0eda1aab",
        moduleName: "VirtualAgentLandingPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $8455Y.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $5f6f0f0963809dd2$var$formatFetchDate(new Date(Date.now() - $5f6f0f0963809dd2$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $5f6f0f0963809dd2$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("8455Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c1b022fb9cc73c1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<305c2a9011f70c47af7be8f6091dda9d>>
 * @relayHash 5fb4b45ffa26125ca2c7be227f6e7854
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00c79c593f16f476431b5e782fe02c21e9c2246675642bc8f0e0b4a3ce3c5458

var $k49ny = parcelRequire("k49ny");
const $2c1b022fb9cc73c1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00c79c593f16f476431b5e782fe02c21e9c2246675642bc8f0e0b4a3ce3c5458",
        "metadata": {},
        "name": "VirtualAgentLandingPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
        }
    }
};
var $2c1b022fb9cc73c1$export$2e2bcd8739ae039 = $2c1b022fb9cc73c1$var$node;

});

parcelRegister("GMmct", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jIl4Q").then(()=>parcelRequire('ipPLW'));

});


parcelRegister("8QQwn", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentLandingSkeleton", () => $d54fa6d77f052857$export$f4b71d7b732df8a7);
/* VirtualAgentLandingSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $gAyhK = parcelRequire("gAyhK");
const $d54fa6d77f052857$var$customStyles = null;
const $d54fa6d77f052857$export$f4b71d7b732df8a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gAyhK))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$d54fa6d77f052857$export$f4b71d7b732df8a7.displayName = "VirtualAgentLandingSkeleton";

});
parcelRegister("gAyhK", function(module, exports) {
module.exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();

});



parcelRegister("8HcaY", function(module, exports) {
$parcel$export(module.exports, "legacyPlanPageRedirectRouteEntry", () => $292308721513c4d1$export$e9cfdb950d40e917);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $hfdV4 = parcelRequire("hfdV4");

var $36TIq = parcelRequire("36TIq");

var $8tAZd = parcelRequire("8tAZd");
const $292308721513c4d1$export$e9cfdb950d40e917 = (0, $fdS54.createEntry)((0, $hfdV4.legacyPlanPageRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $36TIq.RedirectLegacyPlanPage),
        isRedirect: true,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6ZHVf.advancedRoadmapsScenarioIdResource)
        ],
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8tAZd.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $c269ad8423c234af$export$62f70d55c4a538b0 = 'PLANS';

parcelRegister("hfdV4", function(module, exports) {
$parcel$export(module.exports, "legacyPlanPageRedirectRoute", () => $68df341786a26007$export$1e324bd9675918a8);
const $68df341786a26007$export$1e324bd9675918a8 = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioPlanView.jspa'
};

});

parcelRegister("36TIq", function(module, exports) {
$parcel$export(module.exports, "RedirectLegacyPlanPage", () => $45989556063c7f0d$export$c3e4fda2290a52bf);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioIdLoadQuery", () => $45989556063c7f0d$export$e57364775e9e9634);

var $l2tNO = parcelRequire("l2tNO");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $8mhBo = parcelRequire("8mhBo");

var $6ZHVf = parcelRequire("6ZHVf");

var $6DfNt = parcelRequire("6DfNt");

var $dLVGe = parcelRequire("dLVGe");

var $k6ufm = parcelRequire("k6ufm");
var $bc9Gj = parcelRequire("bc9Gj");

var $eijVy = parcelRequire("eijVy");
const $45989556063c7f0d$var$PERSIST_SEARCH_PARAMS = [
    'search'
];
const $45989556063c7f0d$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
    const [{ query: query }] = (0, $bc9Gj.useRouter)();
    const { data: data, loading: loading } = (0, $k6ufm.useResource)((0, $6ZHVf.advancedRoadmapsScenarioIdResource));
    if (loading || data === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
        persistSearchParams: $45989556063c7f0d$var$PERSIST_SEARCH_PARAMS
    });
};
$45989556063c7f0d$var$RedirectLegacyPlanPageWithoutScenarioId.displayName = "RedirectLegacyPlanPageWithoutScenarioId";
const $45989556063c7f0d$export$c3e4fda2290a52bf = ()=>{
    const [{ query: query }] = (0, $bc9Gj.useRouter)();
    const { id: id, sid: sid } = query;
    if (Number.isNaN(Number.parseFloat(sid))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($45989556063c7f0d$var$RedirectLegacyPlanPageWithoutScenarioId, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: `/jira/plans/${id}/scenarios/${sid}`,
        persistSearchParams: $45989556063c7f0d$var$PERSIST_SEARCH_PARAMS
    });
};
$45989556063c7f0d$export$c3e4fda2290a52bf.displayName = "RedirectLegacyPlanPage";
const $45989556063c7f0d$export$b2194d886d9f3b64 = ({ queryRef: queryRef, planId: planId })=>{
    const gqlData = (0, $n67Vb.usePreloadedQuery)((0, $l2tNO.default), queryRef);
    const { data: data, loading: loading } = (0, $k6ufm.useResource)((0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource));
    const defaultTabUrl = gqlData?.jira?.planById?.defaultNavigationItem?.url;
    if (defaultTabUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: defaultTabUrl,
        persistSearchParams: $45989556063c7f0d$var$PERSIST_SEARCH_PARAMS
    });
    // Fallback if can not get defaultTabUrl
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DfNt.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8mhBo.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $45989556063c7f0d$var$PERSIST_SEARCH_PARAMS
    });
};
$45989556063c7f0d$export$b2194d886d9f3b64.displayName = "RedirectPlanPageWithoutScenarioIdPreloadQuery";
const $45989556063c7f0d$export$e57364775e9e9634 = ()=>{
    const [{ match: match }] = (0, $bc9Gj.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { cloudId: cloudId, activationId: activationId } = (0, $eijVy.useTenantContext)();
    const [queryRef, loadQuery, disposeQuery] = (0, $n67Vb.useQueryLoader)((0, $l2tNO.default));
    (0, $euxye.useEffect)(()=>{
        loadQuery({
            planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
        }, {
            fetchPolicy: 'store-or-network'
        });
        return disposeQuery;
    }, [
        loadQuery,
        disposeQuery,
        cloudId,
        activationId,
        planId
    ]);
    return queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($45989556063c7f0d$export$b2194d886d9f3b64, {
        queryRef: queryRef,
        planId: planId
    }) : null;
};
$45989556063c7f0d$export$e57364775e9e9634.displayName = "RedirectPlanPageWithoutScenarioIdLoadQuery";

});
parcelRegister("l2tNO", function(module, exports) {
$parcel$export(module.exports, "default", () => $378e9a16e146fead$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0981676389694ee441aeedbf62d18ac>>
 * @relayHash 06360d2bbaec11fabf37e9a939e4deb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 140235c4f5635e73615326edc00e7662870ea84fa76f18b7c55d808da8d4e566
const $378e9a16e146fead$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "planId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "planId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "JiraNavigationItem",
        "abstractKey": "__isJiraNavigationItem"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RedirectPlanPageWithoutScenarioIdPreloadQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "defaultNavigationItem",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RedirectPlanPageWithoutScenarioIdPreloadQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "140235c4f5635e73615326edc00e7662870ea84fa76f18b7c55d808da8d4e566",
            "metadata": {},
            "name": "RedirectPlanPageWithoutScenarioIdPreloadQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$378e9a16e146fead$var$node.hash = "83805307401c6ff4c137637ba3624e80";
var $378e9a16e146fead$export$2e2bcd8739ae039 = $378e9a16e146fead$var$node;

});

parcelRegister("8mhBo", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", () => $fa159b9243518817$export$42f84e610f279c31);

var $euxye = parcelRequire("euxye");

var $aj6PJ = parcelRequire("aj6PJ");


var $bbXqM = parcelRequire("bbXqM");

var $gr1cC = parcelRequire("gr1cC");

var $dPAlR = parcelRequire("dPAlR");

var $hZELj = parcelRequire("hZELj");
const $fa159b9243518817$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
    /**
	 * Clearing the early-preload promises here otherwise they get carried on to the following plan loads.
	 *
	 * The SPA app renders the ErrorScreen instead of the PlanApp when the validation fails,
	 * hence the early-preload promises did not get cleaned up.
	 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_BACKLOG_PROMISE__;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    switch(errorMessage){
        case 0, $1a18d835ca750f5c$export$aa64437890e7b596:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aj6PJ.RedirectToLoginPage), null);
        case 0, $1a18d835ca750f5c$export$3fe2400c9d24940d:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bbXqM.AsyncLicenseViolationErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $1a18d835ca750f5c$export$4589763db20bfd7f:
        case 0, $1a18d835ca750f5c$export$7e6358a0c21dff8c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dPAlR.AsyncNotFoundErrorPage), {
                entity: (0, $1a18d835ca750f5c$export$c303e491e026ebc6),
                isEmbedded: isEmbedded
            });
        case 0, $1a18d835ca750f5c$export$6519152a5f0e081:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dPAlR.AsyncNotFoundErrorPage), {
                entity: (0, $1a18d835ca750f5c$export$9b928fc5e710e864),
                isEmbedded: isEmbedded,
                planId: planId
            });
        case 0, $1a18d835ca750f5c$export$6128dc888243fa0a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gr1cC.AsyncNoPlanPermissionErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $1a18d835ca750f5c$export$1f988ace3cbe8975:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZELj.AsyncLazyGenericErrorPage), null);
        default:
            return null;
    }
};
$fa159b9243518817$export$42f84e610f279c31.displayName = "ErrorScreen";

});
/* eslint-disable jira/filename-case */ const $1a18d835ca750f5c$export$aa64437890e7b596 = 'permission-violation';
const $1a18d835ca750f5c$export$3fe2400c9d24940d = 'license-violation';
const $1a18d835ca750f5c$export$4589763db20bfd7f = 'plan-not-found';
const $1a18d835ca750f5c$export$6519152a5f0e081 = 'scenario-not-found';
const $1a18d835ca750f5c$export$7e6358a0c21dff8c = 'report-not-found';
const $1a18d835ca750f5c$export$6128dc888243fa0a = 'no-plan-permission';
const $1a18d835ca750f5c$export$1f988ace3cbe8975 = 'GENERIC';
const $1a18d835ca750f5c$export$c303e491e026ebc6 = 'PLAN';
const $1a18d835ca750f5c$export$9b928fc5e710e864 = 'SCENARIO';
const $1a18d835ca750f5c$export$b8b9d90f9e5bd72b = 'jiraSpaAppsAdvancedRoadmaps';
const $1a18d835ca750f5c$export$d57b6b390e78d90f = 'advanced-roadmaps';

parcelRegister("bbXqM", function(module, exports) {
$parcel$export(module.exports, "AsyncLicenseViolationErrorPage", () => $55156859c4812405$export$f5d9764f07badc4d);

var $euxye = parcelRequire("euxye");

var $6DfNt = parcelRequire("6DfNt");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $55156859c4812405$var$LazyLicenseViolationErrorPage = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("cIwj9")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-error-screens/src/LicenseViolation.tsx"
});
const $55156859c4812405$export$f5d9764f07badc4d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "arj-license-violation-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DfNt.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($55156859c4812405$var$LazyLicenseViolationErrorPage, props));
$55156859c4812405$export$f5d9764f07badc4d.displayName = "AsyncLicenseViolationErrorPage";

});
parcelRegister("cIwj9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("690Ix")
]).then(()=>parcelRequire('9Oejt'));

});


parcelRegister("gr1cC", function(module, exports) {
$parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", () => $b3b0a2738b5b469c$export$e595d2c5dfcb1d5a);

var $euxye = parcelRequire("euxye");

var $6DfNt = parcelRequire("6DfNt");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $b3b0a2738b5b469c$var$LazyNoPlanPermissionErrorPage = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7bkN1")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-error-screens/src/NoPlanPermissionErrorPage.tsx"
});
const $b3b0a2738b5b469c$export$e595d2c5dfcb1d5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "arj-no-plan-permission",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DfNt.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b3b0a2738b5b469c$var$LazyNoPlanPermissionErrorPage, props));
$b3b0a2738b5b469c$export$e595d2c5dfcb1d5a.displayName = "AsyncNoPlanPermissionErrorPage";

});
parcelRegister("7bkN1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("alhnz")
]).then(()=>parcelRequire('fmDS9'));

});


parcelRegister("dPAlR", function(module, exports) {
$parcel$export(module.exports, "AsyncNotFoundErrorPage", () => $e5976c4513413ca2$export$8f6c907860218fdc);

var $euxye = parcelRequire("euxye");

var $6DfNt = parcelRequire("6DfNt");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $e5976c4513413ca2$var$LazyNotFoundErrorPage = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7btA9")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-error-screens/src/NotFoundErrorPage.tsx"
});
const $e5976c4513413ca2$export$8f6c907860218fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "arj-not-found-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DfNt.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e5976c4513413ca2$var$LazyNotFoundErrorPage, props));
$e5976c4513413ca2$export$8f6c907860218fdc.displayName = "AsyncNotFoundErrorPage";

});
parcelRegister("7btA9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("3NkJl")
]).then(()=>parcelRequire('aYOdR'));

});


parcelRegister("hZELj", function(module, exports) {
$parcel$export(module.exports, "AsyncLazyGenericErrorPage", () => $499a42bbeb14a0ac$export$8e4963c137216f8f);

var $euxye = parcelRequire("euxye");

var $6DfNt = parcelRequire("6DfNt");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $499a42bbeb14a0ac$var$LazyGenericErrorPage = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("cdg0w")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-error-screens/src/GenericErrorPage.tsx"
});
const $499a42bbeb14a0ac$export$8e4963c137216f8f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-arj-generic-error-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DfNt.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($499a42bbeb14a0ac$var$LazyGenericErrorPage, null));
$499a42bbeb14a0ac$export$8e4963c137216f8f.displayName = "AsyncLazyGenericErrorPage";

});
parcelRegister("cdg0w", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fkJR0").then(()=>parcelRequire('jvzZh'));

});




parcelRegister("8tAZd", function(module, exports) {
$parcel$export(module.exports, "LazyPlanTimeline", () => $efdde1475d9d7a76$export$bf48e5f1529ddaeb);
$parcel$export(module.exports, "default", () => $efdde1475d9d7a76$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $efdde1475d9d7a76$export$bf48e5f1529ddaeb = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("5kKAK"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-timeline/src/ExportedComponent.tsx"
});
const $efdde1475d9d7a76$var$AsyncPlanTimeline = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $efdde1475d9d7a76$export$bf48e5f1529ddaeb,
        pageId: "plan-timeline",
        shouldShowSpinner: true
    });
$efdde1475d9d7a76$var$AsyncPlanTimeline.displayName = "AsyncPlanTimeline";
var $efdde1475d9d7a76$export$2e2bcd8739ae039 = $efdde1475d9d7a76$var$AsyncPlanTimeline;

});


parcelRegister("2vc0R", function(module, exports) {
$parcel$export(module.exports, "legacyPlanReportPageRedirectRouteEntry", () => $7ec1990d9c234d11$export$c2a4c5c6576a704c);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $4fis1 = parcelRequire("4fis1");

var $d94mb = parcelRequire("d94mb");

var $8tAZd = parcelRequire("8tAZd");
const $7ec1990d9c234d11$export$c2a4c5c6576a704c = (0, $fdS54.createEntry)((0, $4fis1.legacyPlanReportPageRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $d94mb.default),
        isRedirect: true,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8tAZd.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4fis1", function(module, exports) {
$parcel$export(module.exports, "legacyPlanReportPageRedirectRoute", () => $024f9cb4c628cb1e$export$7747547e845a016c);
const $024f9cb4c628cb1e$export$7747547e845a016c = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioReportView.jspa'
};

});

parcelRegister("d94mb", function(module, exports) {
$parcel$export(module.exports, "default", () => $1392191a8df371c2$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");

var $bc9Gj = parcelRequire("bc9Gj");
const $1392191a8df371c2$var$RedirectLegacyReportPage = ()=>{
    const [{ query: query }] = (0, $bc9Gj.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: `/jira/plans/reports/${query.r}`,
        persistSearchParams: false
    });
};
$1392191a8df371c2$var$RedirectLegacyReportPage.displayName = "RedirectLegacyReportPage";
var $1392191a8df371c2$export$2e2bcd8739ae039 = $1392191a8df371c2$var$RedirectLegacyReportPage;

});


parcelRegister("cIgeF", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $d2bd102ffa00ab14$export$836428e7b33b6c6c);



var $6RSCO = parcelRequire("6RSCO");

var $4B518 = parcelRequire("4B518");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $TMzHv = parcelRequire("TMzHv");

var $3eysO = parcelRequire("3eysO");

var $7ecC0 = parcelRequire("7ecC0");
const $d2bd102ffa00ab14$export$836428e7b33b6c6c = (0, $fdS54.createEntry)((0, $TMzHv.legacyProjectReleasesNoteConfigRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7ecC0.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("TMzHv", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $41d3c970ebc4ffa2$export$a9509017cabb1e30);
const $41d3c970ebc4ffa2$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});

parcelRegister("7ecC0", function(module, exports) {
$parcel$export(module.exports, "BoardSettingsRedirectToCSM", () => $500dbd6f6c6019a6$export$ccce5315da25c53e);
$parcel$export(module.exports, "RoadmapSettingsRedirectToTimelineSettings", () => $500dbd6f6c6019a6$export$eaa324972a212c18);
$parcel$export(module.exports, "SpaReleaseNoteRedirectToVersionDetails", () => $500dbd6f6c6019a6$export$52fa4fd8ca9baab5);
$parcel$export(module.exports, "LegacyFrontendReleaseNoteRedirect", () => $500dbd6f6c6019a6$export$dee47264404d89a0);
$parcel$export(module.exports, "getUFOName", () => $500dbd6f6c6019a6$export$759ec9adbd19c936);
$parcel$export(module.exports, "BoardCardSettingsRedirectToBoardView", () => $500dbd6f6c6019a6$export$3d7a9c7acd9acd10);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $fC5cV = parcelRequire("fC5cV");

var $gNbXR = parcelRequire("gNbXR");
const $500dbd6f6c6019a6$export$ccce5315da25c53e = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
        push: false
    });
$500dbd6f6c6019a6$export$ccce5315da25c53e.displayName = "BoardSettingsRedirectToCSM";
const $500dbd6f6c6019a6$export$eaa324972a212c18 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
        push: false
    });
$500dbd6f6c6019a6$export$eaa324972a212c18.displayName = "RoadmapSettingsRedirectToTimelineSettings";
const $500dbd6f6c6019a6$export$52fa4fd8ca9baab5 = ({ query: query })=>{
    const { version: versionId } = query;
    const { loading: loading, error: error, projectKey: projectKey } = (0, $fC5cV.useProjectKeyByProjectResource)();
    if (loading === false && error) return null;
    if (loading) return null;
    if (!versionId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: {
            pathname: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`,
            hash: '',
            search: ''
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: {
            pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
                isReleaseNoteModalOpen: true
            })
        }
    });
};
$500dbd6f6c6019a6$export$52fa4fd8ca9baab5.displayName = "SpaReleaseNoteRedirectToVersionDetails";
const $500dbd6f6c6019a6$export$dee47264404d89a0 = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: {
            pathname: '/secure/ReleaseNote.jspa',
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
                ...query,
                isRedirectedFromLegacy: true
            })
        }
    });
$500dbd6f6c6019a6$export$dee47264404d89a0.displayName = "LegacyFrontendReleaseNoteRedirect";
const $500dbd6f6c6019a6$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $500dbd6f6c6019a6$export$759ec9adbd19c936 = (name)=>$500dbd6f6c6019a6$var$ufoNamesMap[name] || name;
const $500dbd6f6c6019a6$export$3d7a9c7acd9acd10 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/boards/${String(match.params.boardId)}?openViewSettings=true`,
        push: false
    });
$500dbd6f6c6019a6$export$3d7a9c7acd9acd10.displayName = "BoardCardSettingsRedirectToBoardView";

});
parcelRegister("fC5cV", function(module, exports) {
$parcel$export(module.exports, "useProjectKeyByProjectResource", () => $25e578c68dbd1613$export$899fd1c46031ece8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $k6ufm = parcelRequire("k6ufm");

var $edf7u = parcelRequire("edf7u");
const $25e578c68dbd1613$export$899fd1c46031ece8 = (teamName)=>{
    const { data: data, error: resourceError, loading: loading } = (0, $k6ufm.useResource)((0, $edf7u.projectContextResource));
    if (resourceError && data == null) {
        const isErrorErrorType = resourceError instanceof Error;
        const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterResourcesProjectContext',
                teamName: teamName ?? 'magma'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            loading: false,
            error: error,
            projectKey: null
        };
    }
    if (loading) return {
        loading: true,
        error: null,
        projectKey: null
    };
    // This case never happens by type definition, which you can't even mock test data for this case due to type definition. But if you don't check this, TS is not happy
    if (data == null) return {
        loading: false,
        error: new Error('projectContextResource returned data=null when loading false'),
        projectKey: null
    };
    return {
        loading: false,
        projectKey: data.projectKey,
        error: null
    };
};

});



parcelRegister("5FEz6", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $c0cbcec399e9f1a4$export$781dd53d465d270d);



var $6RSCO = parcelRequire("6RSCO");

var $4B518 = parcelRequire("4B518");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $fHZcl = parcelRequire("fHZcl");

var $3eysO = parcelRequire("3eysO");

var $7ecC0 = parcelRequire("7ecC0");
const $c0cbcec399e9f1a4$export$781dd53d465d270d = (0, $fdS54.createEntry)((0, $fHZcl.legacyProjectReleasesNoteRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7ecC0.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fHZcl", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $a161aa1067be665e$export$6ef734887b6da0c8);
const $a161aa1067be665e$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/jira/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("7855X", function(module, exports) {
$parcel$export(module.exports, "legacyRapidBoardRouteEntry", () => $e1451a222811693e$export$4a5b9e48e40676ad);

var $51vnM = parcelRequire("51vnM");


var $5adCU = parcelRequire("5adCU");

var $jEYuY = parcelRequire("jEYuY");


var $3HYSN = parcelRequire("3HYSN");

var $dvtoW = parcelRequire("dvtoW");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $cee04 = parcelRequire("cee04");

var $eAaRp = parcelRequire("eAaRp");

var $2bC10 = parcelRequire("2bC10");

var $75Njg = parcelRequire("75Njg");

var $i860n = parcelRequire("i860n");
const $e1451a222811693e$export$4a5b9e48e40676ad = (0, $fdS54.createEntry)((0, $cee04.legacyRapidBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eAaRp.RapidBoardSpaPage),
        skeleton: (0, $2bC10.ClassicBoardSkeleton),
        wrmMode: (0, $i860n.fg)('jira-cmp-board-wrmmode-early') ? 'early' : undefined,
        layout: (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            ...(0, $dUAVJ.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eAaRp.LazyRapidBoard),
            (0, $eAaRp.LazyRapidBoardApps)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cee04", function(module, exports) {
$parcel$export(module.exports, "legacyRapidBoardRoute", () => $462c5fb7d863828e$export$2bc0c59cefa2bd5e);
const $462c5fb7d863828e$export$2bc0c59cefa2bd5e = {
    name: 'rapidboard-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ],
    __unsafeOrder: -1
};

});


parcelRegister("d9EEX", function(module, exports) {
$parcel$export(module.exports, "legacyRedirectRouteEntry", () => $bfdaaa2364ca5547$export$27f123cb9320355);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $iKpxC = parcelRequire("iKpxC");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $aMbgS = parcelRequire("aMbgS");

var $4B518 = parcelRequire("4B518");
// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const $bfdaaa2364ca5547$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iKpxC.default), null);
$bfdaaa2364ca5547$var$RedirectComponent.displayName = "RedirectComponent";
const $bfdaaa2364ca5547$export$27f123cb9320355 = (0, $fdS54.createEntry)((0, $aMbgS.legacyRedirectRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: $bfdaaa2364ca5547$var$RedirectComponent,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        isRedirect: true,
        canTransitionIn: ()=>false,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aMbgS", function(module, exports) {
$parcel$export(module.exports, "legacyRedirectRoute", () => $a36537ca17b17bf3$export$176ff76c3ba7c4ce);
const $a36537ca17b17bf3$export$176ff76c3ba7c4ce = {
    path: '',
    name: 'legacy-redirect',
    exact: false
};

});


parcelRegister("4TdbT", function(module, exports) {
$parcel$export(module.exports, "listRouteEntry", () => $94ee95b4927ce30e$export$4425668b2cd90292);

var $hi6Of = parcelRequire("hi6Of");


var $9RyT5 = parcelRequire("9RyT5");

var $3SuGJ = parcelRequire("3SuGJ");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $2EQPz = parcelRequire("2EQPz");

var $iMIPT = parcelRequire("iMIPT");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $cDLVA = parcelRequire("cDLVA");

var $lbxXL = parcelRequire("lbxXL");

var $edf7u = parcelRequire("edf7u");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");
const $94ee95b4927ce30e$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $3SuGJ.listEntryPoint),
    horizontalNavigation: (0, $9RyT5.horizontalNavViewEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $94ee95b4927ce30e$export$4425668b2cd90292 = (0, $fdS54.createEntry)((0, $iMIPT.listRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        entryPoint: ()=>{
            if (!(0, $i860n.fg)('jsm_list_view_milestone_1')) return undefined;
            return $94ee95b4927ce30e$var$entryPoint;
        },
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $cDLVA.getCalendarFilterFieldsResource)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!false && (0, $i860n.fg)('jsm_list_view_milestone_1'), (0, $2DCyG.uifBoardResource))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9RyT5", function(module, exports) {
$parcel$export(module.exports, "horizontalNavViewEntrypoint", () => $b631cfe07f2af909$export$47416ecfbb1a428a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $b631cfe07f2af909$export$47416ecfbb1a428a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1r12t")), {
        moduleId: "6efaff89",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});

parcelRegister("3SuGJ", function(module, exports) {
$parcel$export(module.exports, "listEntryPoint", () => $591bfc3d844e887b$export$6be4f10150ff6073);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $eaFGL = parcelRequire("eaFGL");

const $591bfc3d844e887b$export$6be4f10150ff6073 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("cP1s5")), {
        moduleId: "fed40e51",
        moduleName: "ServicedeskListList",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const boardId = match.params.boardId;
        const boardAri = `ari:cloud:jira-software:${cloudId}:board/${boardId}`;
        const projectKey = match.params.projectKey ?? '';
        const issueSearchInput = {
            customInput: {
                jiraSoftwareInput: {
                    jiraEntityId: boardAri,
                    additionalJql: ''
                }
            }
        };
        const fieldSetsInput = (0, $i860n.fg)('jsm_list_minor_bug_fixes_and_analytic_event') ? {
            viewInput: {
                namespace: 'JSM_ISSUE_NAVIGATOR',
                viewId: 'list_default',
                filterId: null
            }
        } : {
            viewInput: {
                namespace: 'JSM_ISSUE_NAVIGATOR',
                filterId: null
            }
        };
        const defaultProps = {
            first: 50,
            last: null,
            before: null,
            after: null,
            options: {
                issueKey: null
            },
            viewConfigInput: {
                staticViewInput: {
                    isHierarchyEnabled: false,
                    isGroupingEnabled: false,
                    isHideDoneEnabled: false
                }
            },
            filterId: null,
            namespace: 'JSM_ISSUE_NAVIGATOR',
            amountOfColumns: 500,
            groupBy: null,
            viewQueryInput: null,
            shouldQueryHasChildren: false,
            shouldQueryHasChildrenWithCount: false,
            fieldSetsInput: fieldSetsInput,
            scope: {
                operationScope: 'NIN_PROJECT',
                projectKey: projectKey
            },
            fieldSetsScope: {
                operationScope: 'NIN_PROJECT',
                projectKey: projectKey
            },
            boardId: boardAri,
            viewId: 'list_default'
        };
        return {
            queries: {
                jsmListDataQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $eaFGL.default,
                    variables: {
                        cloudId: cloudId,
                        issueSearchInput: issueSearchInput,
                        projectKey: projectKey,
                        ...defaultProps
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey,
                issueSearchInput: issueSearchInput,
                defaultProps: defaultProps
            }
        };
    }
});

});
parcelRegister("eaFGL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a514a98e7563323b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cfe882dfbbd2b5e03554e9547c743c27>>
 * @relayHash 34035ab003ecb7645e78cce82e1f89ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 754b356370d7abe7d0c2802feebd7bfc97f8edc95023f406dc3b0901b605455c

var $1D6fx = parcelRequire("1D6fx");

var $KUiqF = parcelRequire("KUiqF");

var $7yObX = parcelRequire("7yObX");

var $7e655 = parcelRequire("7e655");

var $7zUJD = parcelRequire("7zUJD");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $gE0jx = parcelRequire("gE0jx");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $l4q64 = parcelRequire("l4q64");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $6BTmn = parcelRequire("6BTmn");

var $jhYmN = parcelRequire("jhYmN");

var $b3Nht = parcelRequire("b3Nht");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $2JQfe = parcelRequire("2JQfe");

var $cNoBc = parcelRequire("cNoBc");

var $aIZjN = parcelRequire("aIZjN");

var $1A1H9 = parcelRequire("1A1H9");
const $a514a98e7563323b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "754b356370d7abe7d0c2802feebd7bfc97f8edc95023f406dc3b0901b605455c",
        "metadata": {},
        "name": "ServicedeskListListQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default)
        }
    }
};
var $a514a98e7563323b$export$2e2bcd8739ae039 = $a514a98e7563323b$var$node;

});

parcelRegister("cP1s5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("1PD49")
]).then(()=>parcelRequire('evskP'));

});


parcelRegister("iMIPT", function(module, exports) {
$parcel$export(module.exports, "listRoute", () => $653fcd660499d780$export$5cf62dc131f4fd3d);
const $653fcd660499d780$export$5cf62dc131f4fd3d = {
    name: 'servicedesk-list',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/list',
    exact: true
};

});


parcelRegister("dSDGg", function(module, exports) {
$parcel$export(module.exports, "loginEmbedRouteEntry", () => $84503dc870ff82ff$export$faa46f8c5e1f06d3);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $7CyMy = parcelRequire("7CyMy");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $4B518 = parcelRequire("4B518");

const $84503dc870ff82ff$var$LazyLoginEmbed = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("kUNZI")), {
    moduleId: "./src/packages/router-routes/login-embed-entries/src/login-embed-error-page/LoginEmbedErrorPage.tsx"
});
const $84503dc870ff82ff$var$LoginEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $84503dc870ff82ff$var$LazyLoginEmbed,
        pageId: "spa-apps/login-embed",
        shouldShowSpinner: true
    });
$84503dc870ff82ff$var$LoginEmbed.displayName = "LoginEmbed";
const $84503dc870ff82ff$export$faa46f8c5e1f06d3 = (0, $fdS54.createEntry)((0, $7CyMy.loginEmbedRoute), ()=>({
        group: 'errors',
        // eslint-disable-next-line no-restricted-syntax
        component: $84503dc870ff82ff$var$LoginEmbed,
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7CyMy", function(module, exports) {
$parcel$export(module.exports, "loginEmbedRoute", () => $beeddb51c3800124$export$9efae7a8e8e69866);
const $beeddb51c3800124$export$9efae7a8e8e69866 = {
    name: 'login-embed',
    path: '/jira-login/embed'
};

});

parcelRegister("kUNZI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8pLWK").then(()=>parcelRequire('l53SN'));

});


parcelRegister("eZca2", function(module, exports) {
$parcel$export(module.exports, "lookAndFeelRouteEntry", () => $4078cf5146b4c9c6$export$3f0d5be849b14758);

var $6FQD7 = parcelRequire("6FQD7");



var $k7TVL = parcelRequire("k7TVL");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $9Q50z = parcelRequire("9Q50z");

var $dUAVJ = parcelRequire("dUAVJ");

var $35eqr = parcelRequire("35eqr");

var $dTa0V = parcelRequire("dTa0V");
const $4078cf5146b4c9c6$var$lookAndFeelPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6FQD7.lookAndFeelEntryPoint)
});
const $4078cf5146b4c9c6$export$3f0d5be849b14758 = (0, $fdS54.createEntry)((0, $k7TVL.lookAndFeelRoute), ()=>({
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource),
            (0, $9Q50z.jiraSpaPageContainerResource)
        ],
        entryPoint: ()=>{
            return $4078cf5146b4c9c6$var$lookAndFeelPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6FQD7", function(module, exports) {
$parcel$export(module.exports, "lookAndFeelEntryPoint", () => $9d7d28e6668c7ad6$export$f859f97b1e8747cf);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $arQa1 = parcelRequire("arQa1");

const $9d7d28e6668c7ad6$export$f859f97b1e8747cf = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("cZJmJ")), {
        moduleId: "33662972",
        moduleName: "LookAndFeelPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            queries: {
                lookAndFeelQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $arQa1.default),
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("arQa1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e03678c31859fe14$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87c4af76f66aa7b3b440a563b00c2ef4>>
 * @relayHash 7a8283bfbb61d0d92635f5afae27a2f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b2c5d8a160bb67e0dc08c2d13b3a126ae17e7d8bc548d59da1d5e3f41d8643b

var $lIGkE = parcelRequire("lIGkE");
const $e03678c31859fe14$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        {
            "kind": "ScalarField",
            "name": "isCustom"
        },
        {
            "kind": "ScalarField",
            "name": "path"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LookAndFeelPageQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "LogoSection_query"
                },
                {
                    "args": v2 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "FaviconSection_query"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "TitleSection_jiraQuery"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "NavColorSection_jiraQuery"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "DateTimeSection_jiraQuery"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LookAndFeelPageQuery",
            "selections": [
                {
                    "alias": "LogoSectionLogo",
                    "args": v2 /*: any*/ ,
                    "concreteType": "JiraLookAndFeel",
                    "kind": "LinkedField",
                    "name": "jira_lookAndFeel",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraLogo",
                            "kind": "LinkedField",
                            "name": "logo",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "FaviconSectionProjectIconProperty",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.favicon.use.projecticon"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "TitleSectionProperty",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.lf.logo.show.application.title"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "NavColorSectionBackgroundColorProperty",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.lf.navigation.bgcolour"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "NavColorSectionHighlightColorProperty",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.lf.navigation.highlightcolour"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "DateTimeSectionTimeFormat",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.lf.date.time"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "DateTimeSectionDayFormat",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.lf.date.day"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "DateTimeSectionCompleteFormat",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.lf.date.complete"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "DateTimeSectionDateFormat",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.lf.date.dmy"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "DateTimeSectionUseIso8601",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "jira.date.time.picker.use.iso8061"
                                    ]
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        }
                    ]
                },
                {
                    "alias": "FaviconSectionFavicon",
                    "args": v2 /*: any*/ ,
                    "concreteType": "JiraLookAndFeel",
                    "kind": "LinkedField",
                    "name": "jira_lookAndFeel",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraFavicon",
                            "kind": "LinkedField",
                            "name": "favicon",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b2c5d8a160bb67e0dc08c2d13b3a126ae17e7d8bc548d59da1d5e3f41d8643b",
            "metadata": {},
            "name": "LookAndFeelPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e03678c31859fe14$var$node.hash = "d8417e64a6e2a995d4d390f3b7cc566e";
(0, $lIGkE.PreloadableQueryRegistry).set($e03678c31859fe14$var$node.params.id, $e03678c31859fe14$var$node);
var $e03678c31859fe14$export$2e2bcd8739ae039 = $e03678c31859fe14$var$node;

});

parcelRegister("cZJmJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("hBZ7Y")
]).then(()=>parcelRequire('foBb8'));

});


parcelRegister("k7TVL", function(module, exports) {
$parcel$export(module.exports, "lookAndFeelRoute", () => $c93f2408a2f68a02$export$3546b2cc5d24d26c);
const $c93f2408a2f68a02$export$3546b2cc5d24d26c = {
    name: 'look-and-feel',
    path: '/jira/settings/system/ui/look-and-feel'
};

});


parcelRegister("4yVjT", function(module, exports) {
$parcel$export(module.exports, "manageProjectsDirectoryRouteEntry", () => $ea572ab084aabb0c$export$d5b1a46987369ee4);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $5VpzU = parcelRequire("5VpzU");

var $85jAF = parcelRequire("85jAF");

var $8bf4L = parcelRequire("8bf4L");

var $jCwQG = parcelRequire("jCwQG");

var $72Jlz = parcelRequire("72Jlz");

var $1Mfsg = parcelRequire("1Mfsg");
const $ea572ab084aabb0c$var$LazyAdminProjectsDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72Jlz.LazyProjectsDirectory), {
        isAdminProjectDirectoryRoute: true
    });
$ea572ab084aabb0c$var$LazyAdminProjectsDirectory.displayName = "LazyAdminProjectsDirectory";
const $ea572ab084aabb0c$var$ProjectsDirectoryManageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ea572ab084aabb0c$var$LazyAdminProjectsDirectory,
        pageId: "projects-directory-manage-v3",
        shouldShowSpinner: false
    });
$ea572ab084aabb0c$var$ProjectsDirectoryManageComponent.displayName = "ProjectsDirectoryManageComponent";
const $ea572ab084aabb0c$export$d5b1a46987369ee4 = (0, $fdS54.createEntry)((0, $5VpzU.manageProjectsDirectoryRoute), ()=>({
        group: 'directories',
        // eslint-disable-next-line no-restricted-syntax
        component: $ea572ab084aabb0c$var$ProjectsDirectoryManageComponent,
        skeleton: (0, $85jAF.ProjectsDirectorySkeleton),
        navigation: {
            sidebarId: (0, $3be6781b85030612$export$e3e768cbcc0eeacd)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jCwQG.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $72Jlz.LazyProjectsDirectory)
        ],
        ufoName: 'projects-directory-v3-manage',
        entryPoint () {
            return 0, $1Mfsg.ProjectsDirectoryPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5VpzU", function(module, exports) {
$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $159619a46a612b46$export$281a4490a0f8fb4c);
const $159619a46a612b46$export$281a4490a0f8fb4c = {
    name: 'projects-directory-manage',
    path: '/jira/settings/projects/manage'
};

});

parcelRegister("jCwQG", function(module, exports) {
$parcel$export(module.exports, "adminProjectDirectoryResources", () => $45d6e5cd79b31519$export$1b29db6307155621);

var $45Itd = parcelRequire("45Itd");

var $lJNe8 = parcelRequire("lJNe8");
const $45d6e5cd79b31519$export$1b29db6307155621 = ()=>[
        (0, $45Itd.navigationSidebarGlobalResource),
        (0, $lJNe8.projectsDirectoryPageResource)
    ];

});
parcelRegister("lJNe8", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryPageResource", () => $27103b6d533a00f5$export$aabb201a7f7100c5);
/* eslint-disable jira/import-whitelist */ 
var $n67Vb = parcelRequire("n67Vb");

var $3ZvAG = parcelRequire("3ZvAG");

var $goyMU = parcelRequire("goyMU");

var $9SPo8 = parcelRequire("9SPo8");

var $aI7em = parcelRequire("aI7em");

var $5SJ3N = parcelRequire("5SJ3N");

var $htsFl = parcelRequire("htsFl");

var $7edbf = parcelRequire("7edbf");
const $27103b6d533a00f5$var$RESOURCE_TYPE_PROJECTS_DIRECTORY_RELAY = 'PROJECTS_DIRECTORY_RELAY';
const $27103b6d533a00f5$export$aabb201a7f7100c5 = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${$27103b6d533a00f5$var$RESOURCE_TYPE_PROJECTS_DIRECTORY_RELAY}`,
    getKey: ()=>'projects-directory-relay',
    // @ts-expect-error - might return null
    getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should temporally disable anonymous SSR until
        // the underlying auth issues have been fixed. Duplo team will push the real fix later.
        if (false && isAnonymous) return null;
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $9SPo8.default), {
            cloudId: tenantContext.cloudId,
            filter: (0, $goyMU.mapQueryToFilter)((0, $3ZvAG.filterInitialState), {
                cloudId: cloudId,
                query: (0, $goyMU.sanitizeLegacyQuery)(query),
                aliases: (0, $3ZvAG.filterAliasMap)
            }),
            first: query?.page ? (0, $3ZvAG.DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, $3ZvAG.DEFAULT_LIMIT),
            last: (0, $3ZvAG.DEFAULT_LIMIT),
            isAdminSettingsContext: route.name === 'projects-directory-manage',
            isAnonymous: isAnonymous
        }, {
            fetchPolicy: 'network-only'
        });
        if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});

});
parcelRegister("3ZvAG", function(module, exports) {
$parcel$export(module.exports, "TableColumns", () => $3914e096cba0e766$export$b0e68791ad9c52df);
$parcel$export(module.exports, "SortableColumns", () => $3914e096cba0e766$export$f9e740ef44a4c43a);
$parcel$export(module.exports, "FilterFields", () => $3914e096cba0e766$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "filterAliasMap", () => $3914e096cba0e766$export$5bc0ad9873e5cd89);
$parcel$export(module.exports, "filterInitialState", () => $3914e096cba0e766$export$fcb7b3e474e67781);
$parcel$export(module.exports, "DEFAULT_LIMIT", () => $3914e096cba0e766$export$ebc5ec3267fbcf57);
$parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", () => $3914e096cba0e766$export$7c1bd7128901e2c4);
$parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", () => $3914e096cba0e766$export$72fb94bf1b8ec849);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $5ZBQV = parcelRequire("5ZBQV");
const $3914e096cba0e766$export$b0e68791ad9c52df = {
    Favourites: 'favourite',
    Key: 'key',
    Name: 'name',
    Type: 'type',
    Lead: 'lead',
    Category: 'category',
    LastIssueUpdate: 'last_issue_updated_time',
    Url: 'url',
    Action: 'actions'
};
const $3914e096cba0e766$export$f9e740ef44a4c43a = [
    $3914e096cba0e766$export$b0e68791ad9c52df.Favourites,
    $3914e096cba0e766$export$b0e68791ad9c52df.Key,
    $3914e096cba0e766$export$b0e68791ad9c52df.Name,
    $3914e096cba0e766$export$b0e68791ad9c52df.Lead,
    $3914e096cba0e766$export$b0e68791ad9c52df.Category,
    $3914e096cba0e766$export$b0e68791ad9c52df.LastIssueUpdate
];
const $3914e096cba0e766$export$e38c2fbdcbc20613 = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectTypeLabel: 'ProjectTypeLabel',
    ProjectCategoryId: 'projectCategoryId',
    ProjectCategoryLabel: 'projectCategoryLabel',
    ...(0, $5ZBQV.DefaultFilterFields)
};
const $3914e096cba0e766$export$5bc0ad9873e5cd89 = {
    contains: $3914e096cba0e766$export$e38c2fbdcbc20613.Keyword,
    selectedProjectType: $3914e096cba0e766$export$e38c2fbdcbc20613.ProjectType,
    selectedCategory: $3914e096cba0e766$export$e38c2fbdcbc20613.ProjectCategoryId
};
const $3914e096cba0e766$export$fcb7b3e474e67781 = {
    [$3914e096cba0e766$export$e38c2fbdcbc20613.Keyword]: '',
    [$3914e096cba0e766$export$e38c2fbdcbc20613.ProjectType]: '',
    [$3914e096cba0e766$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$3914e096cba0e766$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$3914e096cba0e766$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$3914e096cba0e766$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
    [$3914e096cba0e766$export$e38c2fbdcbc20613.SortKey]: $3914e096cba0e766$export$b0e68791ad9c52df.Name,
    [$3914e096cba0e766$export$e38c2fbdcbc20613.Page]: '1'
};
const $3914e096cba0e766$export$ebc5ec3267fbcf57 = 25;
const $3914e096cba0e766$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
const $3914e096cba0e766$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';

});
parcelRegister("5ZBQV", function(module, exports) {
$parcel$export(module.exports, "DefaultFilterFields", () => $7cab6cf4025ba43c$export$7ecdd4b6ae40e139);
$parcel$export(module.exports, "createUseFilter", () => $7cab6cf4025ba43c$export$ef79d9c1dcb09f8f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bS1iz = parcelRequire("bS1iz");

var $hFtK7 = parcelRequire("hFtK7");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $7cab6cf4025ba43c$export$7ecdd4b6ae40e139 = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
const $7cab6cf4025ba43c$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
    const actions = {
        updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                const currentState = getState();
                const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                    [nameOrFilter]: value
                };
                const isFilterChanging = Object.keys(newFilter).some(// @ts-expect-error - Element implicitly has an 'any'
                (key)=>key !== $7cab6cf4025ba43c$export$7ecdd4b6ae40e139.Page && currentState[key] !== newFilter[key]);
                setState({
                    ...currentState,
                    ...isFilterChanging && {
                        [$7cab6cf4025ba43c$export$7ecdd4b6ae40e139.Page]: 1
                    },
                    ...newFilter
                });
                onUpdate(getState());
            },
        forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
    };
    const Store = (0, $5QDqc.createStore)({
        // oxlint-disable-next-line typescript/consistent-type-assertions
        initialState: {},
        actions: actions,
        name: storeName
    });
    const useFilter = (0, $3h1FP.createHook)(Store);
    const useScopedFilter = (0, $3h1FP.createHook)(Store, {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        selector: (state, name)=>state[name]
    });
    const FilterContainer = (0, $dB6ay.createContainer)(Store, {
        onInit: ()=>({ setState: setState }, { isAdminSettingsContext: isAdminSettingsContext })=>{
                try {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const routeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(window.location.search);
                    setState(getInitialState({
                        routeQuery: routeQuery,
                        isAdminSettingsContext: isAdminSettingsContext
                    }));
                } catch (error) {
                    (0, $hFtK7.fireErrorAnalytics)({
                        // oxlint-disable-next-line typescript/consistent-type-assertions
                        error: error,
                        meta: {
                            id: 'createUseFilter',
                            packageName: 'jiraDirectoryBaseV3',
                            teamName: 'jira-cosmos'
                        }
                    });
                }
            },
        // reset initial state on unmount
        onCleanup: ()=>({ setState: setState }, { isAdminSettingsContext: isAdminSettingsContext })=>setState(getInitialState({
                    routeQuery: {},
                    isAdminSettingsContext: isAdminSettingsContext
                }))
    });
    return {
        useFilter: useFilter,
        useScopedFilter: useScopedFilter,
        FilterContainer: FilterContainer
    };
};

});


parcelRegister("goyMU", function(module, exports) {
$parcel$export(module.exports, "sanitizeLegacyQuery", () => $afcf745a09e78a2f$export$b6d5141c3209bd35);
$parcel$export(module.exports, "mapQueryToFilter", () => $afcf745a09e78a2f$export$2274cd5f35844a96);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $f99M0 = parcelRequire("f99M0");

var $6fsuc = parcelRequire("6fsuc");

var $6OV7A = parcelRequire("6OV7A");

var $2pFGm = parcelRequire("2pFGm");

var $3ZvAG = parcelRequire("3ZvAG");
const $afcf745a09e78a2f$var$LEGACY_ALL_VALUE = 'all';
const $afcf745a09e78a2f$export$b6d5141c3209bd35 = (query)=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $afcf745a09e78a2f$var$LEGACY_ALL_VALUE ? (0, $3ZvAG.filterInitialState)[(0, $3ZvAG.FilterFields).ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $afcf745a09e78a2f$var$LEGACY_ALL_VALUE ? (0, $3ZvAG.filterInitialState)[(0, $3ZvAG.FilterFields).ProjectCategoryId] : query.selectedCategory
    });
const $afcf745a09e78a2f$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [(0, $3ZvAG.FilterFields).Keyword]: keyword, [(0, $3ZvAG.FilterFields).ProjectCategoryId]: projectCategoryId, [(0, $3ZvAG.FilterFields).ProjectType]: types, [(0, $3ZvAG.FilterFields).SortOrder]: sortOrder, [(0, $3ZvAG.FilterFields).SortKey]: sortKey } = aliases && query ? (0, $2pFGm.matchAliases)(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $6fsuc.AnyAri).check(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $6OV7A.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString();
    }
    if (sortKey || sortOrder) {
        const sortByValue = // oxlint-disable-next-line typescript/consistent-type-assertions
        sortKey && (0, $3ZvAG.SortableColumns).includes(sortKey) ? sortKey : (0, $3ZvAG.filterInitialState)[(0, $3ZvAG.FilterFields).SortKey];
        // oxlint-disable-next-line typescript/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : (0, $3ZvAG.filterInitialState)[(0, $3ZvAG.FilterFields).SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // oxlint-disable-next-line typescript/consistent-type-assertions
    variables.types = types.split(',') // oxlint-disable-next-line typescript/consistent-type-assertions
    .filter((type)=>(0, $f99M0.PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

});
parcelRegister("6OV7A", function(module, exports) {
$parcel$export(module.exports, "JiraProjectCategoryAri", () => $4f73b8b6044a7e94$export$da484aad24207e3d);

var $9C9EA = parcelRequire("9C9EA");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/project-category/manifest.ts
var $4f73b8b6044a7e94$var$jiraProjectCategoryAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9C9EA.JiraProjectCategoryAriResourceOwner),
    resourceType: (0, $9C9EA.JiraProjectCategoryAriResourceType),
    resourceIdSlug: "{projectCategoryId}",
    resourceIdSegmentFormats: {
        projectCategoryId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/project-category/index.ts
var $4f73b8b6044a7e94$export$da484aad24207e3d = class _JiraProjectCategoryAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectCategoryId = opts.resourceIdSegmentValues.projectCategoryId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectCategoryId() {
        return this._projectCategoryId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4f73b8b6044a7e94$var$jiraProjectCategoryAriStaticOpts.qualifier,
            platformQualifier: $4f73b8b6044a7e94$var$jiraProjectCategoryAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4f73b8b6044a7e94$var$jiraProjectCategoryAriStaticOpts.resourceOwner,
            resourceType: $4f73b8b6044a7e94$var$jiraProjectCategoryAriStaticOpts.resourceType,
            resourceId: `${opts.projectCategoryId}`,
            resourceIdSegmentValues: {
                projectCategoryId: opts.projectCategoryId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $4f73b8b6044a7e94$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $4f73b8b6044a7e94$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectCategoryId: this.projectCategoryId
        };
    }
};

});
parcelRegister("9C9EA", function(module, exports) {
$parcel$export(module.exports, "JiraProjectCategoryAriResourceOwner", () => $6fff26a785b05481$export$b4df372413a623f1);
$parcel$export(module.exports, "JiraProjectCategoryAriResourceType", () => $6fff26a785b05481$export$51b6f2a645c9e23a);
// src/jira/project-category/types.ts
var $6fff26a785b05481$export$b4df372413a623f1 = "jira", $6fff26a785b05481$export$51b6f2a645c9e23a = "project-category";

});


parcelRegister("2pFGm", function(module, exports) {
$parcel$export(module.exports, "matchAliases", () => $2c4e0aad00a3d3fa$export$55f686d7a3507dbe);
$parcel$export(module.exports, "serializeSelectOptions", () => $2c4e0aad00a3d3fa$export$74a705e0bee1565b);
$parcel$export(module.exports, "serializeSelectOptionsLabel", () => $2c4e0aad00a3d3fa$export$eed751fcc55ddadd);
$parcel$export(module.exports, "matchValueToSelectOptions", () => $2c4e0aad00a3d3fa$export$17e142fa55464467);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $l4Qlz = parcelRequire("l4Qlz");

var $cmscH = parcelRequire("cmscH");
const $2c4e0aad00a3d3fa$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $2c4e0aad00a3d3fa$export$40bf1812f0f07002 = (data, aliases)=>{
    const invertedAliases = (0, (/*@__PURE__*/$parcel$interopDefault($l4Qlz)))(aliases);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cmscH)))(data, (_, key)=>invertedAliases[key] || key);
};
const $2c4e0aad00a3d3fa$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
const $2c4e0aad00a3d3fa$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
const $2c4e0aad00a3d3fa$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];

});
parcelRegister("l4Qlz", function(module, exports) {

var $3dYYA = parcelRequire("3dYYA");

var $XYGf1 = parcelRequire("XYGf1");

var $eSVkV = parcelRequire("eSVkV");
/** Used for built-in method references. */ var $f58293b8ec29e506$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f58293b8ec29e506$var$nativeObjectToString = $f58293b8ec29e506$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $f58293b8ec29e506$var$invert = $XYGf1(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $f58293b8ec29e506$var$nativeObjectToString.call(value);
    result[value] = key;
}, $3dYYA($eSVkV));
module.exports = $f58293b8ec29e506$var$invert;

});
parcelRegister("XYGf1", function(module, exports) {

var $6Ogr8 = parcelRequire("6Ogr8");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $0b4494a60912b85f$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $6Ogr8(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $0b4494a60912b85f$var$createInverter;

});
parcelRegister("6Ogr8", function(module, exports) {

var $hmcvL = parcelRequire("hmcvL");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $4f54298e3aa7d67c$var$baseInverter(object, setter, iteratee, accumulator) {
    $hmcvL(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $4f54298e3aa7d67c$var$baseInverter;

});



parcelRegister("cmscH", function(module, exports) {

var $fOh92 = parcelRequire("fOh92");

var $hmcvL = parcelRequire("hmcvL");

var $9JUaE = parcelRequire("9JUaE");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $8ffd6ad298f8c2f6$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $9JUaE(iteratee, 3);
    $hmcvL(object, function(value, key, object) {
        $fOh92(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $8ffd6ad298f8c2f6$var$mapKeys;

});



parcelRegister("9SPo8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e82477fe7a76ee9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8830d8c0bed5a69377356c0a774119ed>>
 * @relayHash 6416f0e9ed30a12a61eecd6a4a661c18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa83058523b4afd93c8ed56f4d2de7d706da3719dd2e00f19f2f80256b7afc85

var $1ZLvK = parcelRequire("1ZLvK");

var $1ezSH = parcelRequire("1ezSH");

var $lIGkE = parcelRequire("lIGkE");
const $1e82477fe7a76ee9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeCsmLandingModal"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAdminSettingsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "isAnonymous",
            "variableName": "isAnonymous"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "alias": "canBrowseProjects",
        "args": [
            v8 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "BROWSE_PROJECTS"
            }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPermission"
            }
        ]
    }, v10 = [
        v8 /*: any*/ 
    ], v11 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v17 = [
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ProjectDirectoryLayoutQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "Header"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "RefinementBar"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ProjectsList130BadPattern"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "includeCsmLandingModal",
                            "variableName": "includeCsmLandingModal"
                        },
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ProjectDirectoryLayout"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "EmptyView"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "NoPermissionViews"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ProjectDirectoryLayoutQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v11 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v12 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appType"
                                                                        }
                                                                    ],
                                                                    "type": "AppUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v11 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        },
                        {
                            "alias": "canContactAdmin",
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": "jira.show.contact.administrators.form"
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        v9 /*: any*/ ,
                        {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectListRightPanelState"
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "sidebarExperimentTemplates",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "experimentKey",
                                            "value": "sidebarExperiment"
                                        }
                                    ],
                                    "concreteType": "JiraProjectListViewTemplateConnection",
                                    "kind": "LinkedField",
                                    "name": "projectListViewTemplates",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "includeCsmLandingModal",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "csmJiraProjects",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "types": [
                                                    "CUSTOMER_SERVICE"
                                                ]
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 0
                                        }
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraProjectTypeDetailsConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectTypeDetailsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectTypeDetails",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa83058523b4afd93c8ed56f4d2de7d706da3719dd2e00f19f2f80256b7afc85",
            "metadata": {},
            "name": "ProjectDirectoryLayoutQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $1ezSH.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default)
            }
        }
    };
}();
$1e82477fe7a76ee9$var$node.hash = "1c65a7871b4244d17b4d0d36831c2d34";
(0, $lIGkE.PreloadableQueryRegistry).set($1e82477fe7a76ee9$var$node.params.id, $1e82477fe7a76ee9$var$node);
var $1e82477fe7a76ee9$export$2e2bcd8739ae039 = $1e82477fe7a76ee9$var$node;

});



parcelRegister("72Jlz", function(module, exports) {
$parcel$export(module.exports, "LazyProjectsDirectory", () => $e60bf663ff8e8f05$export$f9ee24127b8e4a7f);

var $jhKsF = parcelRequire("jhKsF");

var $l8G1z = parcelRequire("l8G1z");

const $e60bf663ff8e8f05$export$f9ee24127b8e4a7f = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("vxRYS"))), {
    moduleId: "./src/packages/spa-apps/directories-projects-v3/src/ProjectDirectoryType.tsx"
});

});
parcelRegister("vxRYS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("kAXfD")
]).then(()=>parcelRequire('blq64'));

});


parcelRegister("1Mfsg", function(module, exports) {
$parcel$export(module.exports, "ProjectsDirectoryPageEntryPoint", () => $5b5f0e09f5b78cdc$export$f4985310f86f98fc);

var $5iIzO = parcelRequire("5iIzO");

var $9bPLT = parcelRequire("9bPLT");

var $dTa0V = parcelRequire("dTa0V");

var $feO6Q = parcelRequire("feO6Q");

var $2eTUm = parcelRequire("2eTUm");
const $5b5f0e09f5b78cdc$export$f4985310f86f98fc = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9bPLT.projectsDirectoryEntryPoint),
    rightSidebar: (0, $feO6Q.RecommendationsInProjectListEntryPoint),
    rightSidebarFallback: (0, $2eTUm.ProjectListSidebarSkeleton),
    redirect: (0, $5iIzO.onboardingRedirectEntryPoint)
});

});
parcelRegister("9bPLT", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryEntryPoint", () => $68e0aa9062c6fa8f$export$80225215a10b2688);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i860n = parcelRequire("i860n");

var $6fsuc = parcelRequire("6fsuc");

var $6OV7A = parcelRequire("6OV7A");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $PyUAC = parcelRequire("PyUAC");
const $68e0aa9062c6fa8f$var$DEFAULT_LIMIT = 25;
const $68e0aa9062c6fa8f$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
const $68e0aa9062c6fa8f$var$DefaultFilterFields = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $68e0aa9062c6fa8f$var$TableColumns = /*#__PURE__*/ function(TableColumns) {
    TableColumns["Favourites"] = "favourites";
    TableColumns["Key"] = "key";
    TableColumns["Name"] = "name";
    TableColumns["Type"] = "type";
    TableColumns["Lead"] = "lead";
    TableColumns["Category"] = "category";
    TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
    TableColumns["Url"] = "url";
    TableColumns["Action"] = "actions";
    return TableColumns;
}($68e0aa9062c6fa8f$var$TableColumns || {});
const $68e0aa9062c6fa8f$var$SortableColumns = [
    "key",
    "name",
    "lead",
    "category",
    "last_issue_updated_time"
];
const $68e0aa9062c6fa8f$var$FilterFields = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectCategoryId: 'projectCategoryId',
    ...$68e0aa9062c6fa8f$var$DefaultFilterFields
};
const $68e0aa9062c6fa8f$var$filterAliasMap = {
    contains: $68e0aa9062c6fa8f$var$FilterFields.Keyword,
    selectedProjectType: $68e0aa9062c6fa8f$var$FilterFields.ProjectType,
    selectedCategory: $68e0aa9062c6fa8f$var$FilterFields.ProjectCategoryId
};
const $68e0aa9062c6fa8f$var$filterInitialState = {
    [$68e0aa9062c6fa8f$var$FilterFields.Keyword]: '',
    [$68e0aa9062c6fa8f$var$FilterFields.ProjectType]: '',
    [$68e0aa9062c6fa8f$var$FilterFields.ProjectCategoryId]: '',
    [$68e0aa9062c6fa8f$var$FilterFields.SortOrder]: 'ASC',
    [$68e0aa9062c6fa8f$var$FilterFields.SortKey]: "name",
    [$68e0aa9062c6fa8f$var$FilterFields.Page]: '1'
};
const $68e0aa9062c6fa8f$var$LEGACY_ALL_VALUE = 'all';
const $68e0aa9062c6fa8f$var$sanitizeLegacyQuery = (query = {})=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $68e0aa9062c6fa8f$var$LEGACY_ALL_VALUE ? $68e0aa9062c6fa8f$var$filterInitialState[$68e0aa9062c6fa8f$var$FilterFields.ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $68e0aa9062c6fa8f$var$LEGACY_ALL_VALUE ? $68e0aa9062c6fa8f$var$filterInitialState[$68e0aa9062c6fa8f$var$FilterFields.ProjectCategoryId] : query.selectedCategory
    });
const $68e0aa9062c6fa8f$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $68e0aa9062c6fa8f$var$CORE_PROJECT = 'business';
const $68e0aa9062c6fa8f$var$SOFTWARE_PROJECT = 'software';
const $68e0aa9062c6fa8f$var$SERVICE_DESK_PROJECT = 'service_desk';
const $68e0aa9062c6fa8f$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
const $68e0aa9062c6fa8f$var$PROJECT_TYPES = [
    $68e0aa9062c6fa8f$var$CORE_PROJECT,
    $68e0aa9062c6fa8f$var$SOFTWARE_PROJECT,
    $68e0aa9062c6fa8f$var$SERVICE_DESK_PROJECT,
    $68e0aa9062c6fa8f$var$PRODUCT_DISCOVERY_PROJECT
];
const $68e0aa9062c6fa8f$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [$68e0aa9062c6fa8f$var$FilterFields.Keyword]: keyword, [$68e0aa9062c6fa8f$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$68e0aa9062c6fa8f$var$FilterFields.ProjectType]: types, [$68e0aa9062c6fa8f$var$FilterFields.SortOrder]: sortOrder, [$68e0aa9062c6fa8f$var$FilterFields.SortKey]: sortKey } = aliases && query ? $68e0aa9062c6fa8f$var$matchAliases(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $6fsuc.AnyAri).check(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $6OV7A.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString();
    }
    if (sortKey || sortOrder) {
        const sortByValue = // oxlint-disable-next-line typescript/consistent-type-assertions
        sortKey && $68e0aa9062c6fa8f$var$SortableColumns.includes(sortKey) ? sortKey : $68e0aa9062c6fa8f$var$filterInitialState[$68e0aa9062c6fa8f$var$FilterFields.SortKey];
        // oxlint-disable-next-line typescript/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : $68e0aa9062c6fa8f$var$filterInitialState[$68e0aa9062c6fa8f$var$FilterFields.SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // oxlint-disable-next-line typescript/consistent-type-assertions
    variables.types = types.split(',') // oxlint-disable-next-line typescript/consistent-type-assertions
    .filter((type)=>$68e0aa9062c6fa8f$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

const $68e0aa9062c6fa8f$export$80225215a10b2688 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("qbn6x")), {
        moduleId: "8b935c01",
        moduleName: "ProjectsV3",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const extraProps = {
            isAdminProjectDirectoryRoute: route.name === $68e0aa9062c6fa8f$var$PROJECTS_DIRECTORY_MANAGE
        };
        if (false && isAnonymous) return {
            extraProps: extraProps
        };
        return {
            queries: {
                projectsDirectoryPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $PyUAC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        filter: $68e0aa9062c6fa8f$var$mapQueryToFilter($68e0aa9062c6fa8f$var$filterInitialState, {
                            cloudId: cloudId,
                            query: $68e0aa9062c6fa8f$var$sanitizeLegacyQuery(query),
                            aliases: $68e0aa9062c6fa8f$var$filterAliasMap
                        }),
                        first: query?.page ? $68e0aa9062c6fa8f$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $68e0aa9062c6fa8f$var$DEFAULT_LIMIT,
                        last: $68e0aa9062c6fa8f$var$DEFAULT_LIMIT,
                        isAdminSettingsContext: route.name === $68e0aa9062c6fa8f$var$PROJECTS_DIRECTORY_MANAGE,
                        isAnonymous: isAnonymous,
                        includeCsmLandingModal: (0, $i860n.fg)('csm_landing_modal')
                    }
                }
            },
            extraProps: extraProps
        };
    }
});

});
parcelRegister("PyUAC", function(module, exports) {
$parcel$export(module.exports, "default", () => $89b990093783ae1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d3fbd7b4081eb2c8e1f779241b8ff6ee>>
 * @relayHash 6416f0e9ed30a12a61eecd6a4a661c18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa83058523b4afd93c8ed56f4d2de7d706da3719dd2e00f19f2f80256b7afc85

var $1ZLvK = parcelRequire("1ZLvK");

var $1ezSH = parcelRequire("1ezSH");
const $89b990093783ae1b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fa83058523b4afd93c8ed56f4d2de7d706da3719dd2e00f19f2f80256b7afc85",
        "metadata": {},
        "name": "ProjectDirectoryLayoutQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $1ezSH.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default)
        }
    }
};
var $89b990093783ae1b$export$2e2bcd8739ae039 = $89b990093783ae1b$var$node;

});

parcelRegister("qbn6x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("dq58Z")
]).then(()=>parcelRequire('5cYnx'));

});


parcelRegister("feO6Q", function(module, exports) {
$parcel$export(module.exports, "RecommendationsInProjectListEntryPoint", () => $c905cb0879233fa9$export$8baad7954c0e6b8c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $f5r3e = parcelRequire("f5r3e");

const $c905cb0879233fa9$export$8baad7954c0e6b8c = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2SKzn")), {
        moduleId: "77c78099",
        moduleName: "JiraProjectsTemplateListRightPanelContainer",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps,
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $f5r3e.default,
                    variables: {
                        cloudId: extraProps.tenantContext.cloudId,
                        isAnonymous: extraProps.tenantContext.isAnonymous,
                        isAllowingEndUsersToAccessCustomTemplates: (0, $i860n.fg)('allow_end_users_to_access_custom_templates')
                    }
                }
            }
        })
});

});
parcelRegister("f5r3e", function(module, exports) {
$parcel$export(module.exports, "default", () => $efac04b29f62a6e9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<393d0852ed03ab90736c5cd91c12ce93>>
 * @relayHash 7eae69585baaef03723add8e054843cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID acc3f7f2221983c9b372193365e61497048b1f0737ccef9007311d5f2b0e52a0
const $efac04b29f62a6e9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "acc3f7f2221983c9b372193365e61497048b1f0737ccef9007311d5f2b0e52a0",
        "metadata": {},
        "name": "JiraProjectsTemplateListRightPanelContainerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $efac04b29f62a6e9$export$2e2bcd8739ae039 = $efac04b29f62a6e9$var$node;

});

parcelRegister("2SKzn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h2Jrb").then(()=>parcelRequire('iNNCD'));

});


parcelRegister("2eTUm", function(module, exports) {
$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $9dd9572a71227fb0$export$808c25bcc6102427);
/* ProjectListSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $422EJ = parcelRequire("422EJ");
const $9dd9572a71227fb0$var$customCssStyles = null;
const $9dd9572a71227fb0$var$sidebarCssStyles = null;
const $9dd9572a71227fb0$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_4t3i1osq _1bsb1gwv _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _t6vde4h9 _1p3lnqa1 _5wra1l7x _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($422EJ))),
        className: (0, $4jQY2.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));
$9dd9572a71227fb0$export$808c25bcc6102427.displayName = "ProjectListSidebarSkeleton";

});
parcelRegister("422EJ", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});




parcelRegister("iw2x7", function(module, exports) {
$parcel$export(module.exports, "mergeTeamsRouteEntry", () => $be17e95c347da437$export$ca943a326e5fc7f);

var $74oEx = parcelRequire("74oEx");



var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $3hqQ7 = parcelRequire("3hqQ7");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $9YDxJ = parcelRequire("9YDxJ");

var $dTa0V = parcelRequire("dTa0V");
const $be17e95c347da437$var$mergeTeamsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9YDxJ.mergeTeamsEntryPoint)
});
const $be17e95c347da437$export$ca943a326e5fc7f = (0, $fdS54.createEntry)((0, $3hqQ7.mergeTeamsRoute), ()=>({
        group: 'eoc',
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$be17e95c347da437$var$mergeTeamsPageEntryPoint,
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
        },
        pageId: 'eoc-merge-teams',
        meta: {
            reporting: {
                id: 'eoc.merge-teams',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('eoc-merge-teams'),
                teamName: 'Alexstrasza'
            }
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3hqQ7", function(module, exports) {
$parcel$export(module.exports, "mergeTeamsRoute", () => $3f91ef4395b8757a$export$bce6d6357998d903);
const $3f91ef4395b8757a$export$bce6d6357998d903 = {
    name: 'eoc-merge-teams',
    path: '/jira/settings/products/ops/merge-teams',
    exact: true
};

});

parcelRegister("9YDxJ", function(module, exports) {
$parcel$export(module.exports, "mergeTeamsEntryPoint", () => $1f1f5e37dfee8a5e$export$4b7e3ec02acf92fe);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $1f1f5e37dfee8a5e$export$4b7e3ec02acf92fe = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2zzJs")), {
        moduleId: "974c5c0a",
        moduleName: "MergeTeams",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2zzJs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jDb4q").then(()=>parcelRequire('8ErOt'));

});



parcelRegister("hfHFu", function(module, exports) {
$parcel$export(module.exports, "newRovoSearchRouteEntry", () => $60c0f89d5c362910$export$33531d48a743e2a6);

var $euxye = parcelRequire("euxye");

var $dUAVJ = parcelRequire("dUAVJ");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $e5AKq = parcelRequire("e5AKq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $60c0f89d5c362910$var$LazyRovoSearchPage = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("8KyLz"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $60c0f89d5c362910$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $60c0f89d5c362910$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
$60c0f89d5c362910$var$RovoSearchPage.displayName = "RovoSearchPage";
const $60c0f89d5c362910$export$33531d48a743e2a6 = (0, $fdS54.createEntry)((0, $e5AKq.newRovoSearchRoute), ()=>({
        group: 'search',
        ufoName: 'search-page',
        // eslint-disable-next-line no-restricted-syntax
        component: $60c0f89d5c362910$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            $60c0f89d5c362910$var$LazyRovoSearchPage
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e5AKq", function(module, exports) {
$parcel$export(module.exports, "newRovoSearchRoute", () => $bdfa322498b405c9$export$595a3e6b7223948e);
const $bdfa322498b405c9$export$595a3e6b7223948e = {
    name: 'jira-rovo-search-new',
    path: '/jira/rovo-search',
    exact: true
};

});

parcelRegister("8KyLz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("5qC72"),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("lSv1z")
]).then(()=>parcelRequire('6NVBp'));

});


parcelRegister("eZYyu", function(module, exports) {
$parcel$export(module.exports, "notificationLogsRouteEntry", () => $568acb7dd5cdb24c$export$20ab3a955246df95);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $5W3Pg = parcelRequire("5W3Pg");

var $74h93 = parcelRequire("74h93");

var $gT2kp = parcelRequire("gT2kp");
const $568acb7dd5cdb24c$export$20ab3a955246df95 = (0, $fdS54.createEntry)((0, $5W3Pg.notificationLogsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gT2kp.NotificationLogs),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gT2kp.LazyNotificationLogs)
        ],
        perfMetricKey: 'jsm-notification-logs-component-load',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5W3Pg", function(module, exports) {
$parcel$export(module.exports, "notificationLogsRoute", () => $8f9e31d43923ecdb$export$c947c80f138bc137);
const $8f9e31d43923ecdb$export$c947c80f138bc137 = {
    name: 'notification-logs',
    path: '/jira/servicedesk/projects/:projectKey/notification-logs',
    exact: true
};

});

parcelRegister("gT2kp", function(module, exports) {
$parcel$export(module.exports, "LazyNotificationLogs", () => $13dc75d609655771$export$69cba5247233f8bc);
$parcel$export(module.exports, "NotificationLogs", () => $13dc75d609655771$export$1139895a5af7252e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $13dc75d609655771$export$69cba5247233f8bc = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hQQtG"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-notification-logs/src/ServicedeskNotificationLogs.tsx"
});
const $13dc75d609655771$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $13dc75d609655771$export$69cba5247233f8bc,
        pageId: "spa-apps/servicedesk/notification-logs",
        shouldShowSpinner: true
    });
$13dc75d609655771$export$1139895a5af7252e.displayName = "NotificationLogs";

});
parcelRegister("hQQtG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("etdQZ")
]).then(()=>parcelRequire('33fhx'));

});



parcelRegister("2VKyb", function(module, exports) {
$parcel$export(module.exports, "notificationsPersonalSettingsRouteEntry", () => $178961dcb218100c$export$640c1b3b96c9032e);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $hTpBY = parcelRequire("hTpBY");

var $6RSCO = parcelRequire("6RSCO");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $hFYSn = parcelRequire("hFYSn");

var $aNvSV = parcelRequire("aNvSV");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $3qYy0 = parcelRequire("3qYy0");

var $dLVGe = parcelRequire("dLVGe");

var $hxBvd = parcelRequire("hxBvd");
const $178961dcb218100c$var$personalSettingsNotificationsEntryPointPage = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hTpBY.personalSettingsNotificationsEntryPoint)
});
const $178961dcb218100c$export$640c1b3b96c9032e = (0, $fdS54.createEntry)((0, $3qYy0.notificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        skeleton: (0, $hxBvd.PersonalSettingsNotificationsAppSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
                to: (0, $aNvSV.getNotificationsPersonalSettingsPath)()
            }),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            sidebarId: (0, $f5c10d229cf55438$export$8f20a381b96458f0),
            menuId: (0, $a3b30e449fa4e063$export$75c8a2cf8cfeef9c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $hFYSn.getNavigationForgePersonalSettingsPageResources)()
        ],
        pageId: 'personal-settings-notifications',
        entryPoint () {
            return $178961dcb218100c$var$personalSettingsNotificationsEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hTpBY", function(module, exports) {
$parcel$export(module.exports, "personalSettingsNotificationsEntryPoint", () => $1456ddc21dd4969d$export$44d710abd316d1f1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $eN6C3 = parcelRequire("eN6C3");

const $1456ddc21dd4969d$export$44d710abd316d1f1 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1kKew")), {
        moduleId: "d138f114",
        moduleName: "PersonalSettingsNotificationsPageDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                pageAndProject: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $eN6C3.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                    }
                }
            },
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("eN6C3", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1e3a876541d32dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8877da0d5c56ce26532048cb838f9635>>
 * @relayHash 1bf61236a9b47b0d113e1152951b34c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e20f17c852acaea895ed6170ec6298dfc677d22fdbc6b17308d495536fed4e8

var $3PEoR = parcelRequire("3PEoR");

var $13wkZ = parcelRequire("13wkZ");
const $c1e3a876541d32dc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v8 = {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueAssigned",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueUpdated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentEdited",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueMoved",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "mentionsCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "worklogCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "miscellaneousIssueEventCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraenablenonadmininvitefromsharedialogfgrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraNotificationPreference",
                        "kind": "LinkedField",
                        "name": "spaceAccessRequestNotification",
                        "plural": false,
                        "selections": v7 /*: any*/ 
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "NotificationsPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ProjectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "GlobalNotificationConfigTableNew"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraNotificationOptions",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notificationPreferencesOptionsWrapper_PersonalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                    }
                                                ]
                                            },
                                            "action": "THROW"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraenablenonadmininvitefromsharedialogfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "NotificationsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "allJiraProjectsForModal",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "notificationConfigurationState": "DEFAULT",
                                        "sortBy": {
                                            "sortBy": "NAME"
                                        }
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1e20f17c852acaea895ed6170ec6298dfc677d22fdbc6b17308d495536fed4e8",
            "metadata": {},
            "name": "NotificationsPageQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraenablenonadmininvitefromsharedialogfgrelayprovider": (0, $13wkZ.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $3PEoR.default)
            }
        }
    };
}();
$c1e3a876541d32dc$var$node.hash = "cb87ee61d21ee84bd18461e4e639ea01";
var $c1e3a876541d32dc$export$2e2bcd8739ae039 = $c1e3a876541d32dc$var$node;

});
parcelRegister("3PEoR", function(module, exports) {
$parcel$export(module.exports, "default", () => $93f92cbf551ace31$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ var $93f92cbf551ace31$export$2e2bcd8739ae039 = {
    get () {
        return true;
    }
};

});

parcelRegister("13wkZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe02042b4227a4e4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $fe02042b4227a4e4$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jira_enable_non-admin_add_people_fg');
    }
};

});


parcelRegister("1kKew", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bS0vk").then(()=>parcelRequire('fJge6'));

});


parcelRegister("aNvSV", function(module, exports) {
$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $8c72b7f1296b7207$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $8c72b7f1296b7207$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $8c72b7f1296b7207$export$cff16c3a6aa7a3a9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $8c72b7f1296b7207$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $8c72b7f1296b7207$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $8c72b7f1296b7207$export$64a672523a583594);
$parcel$export(module.exports, "getAppsPersonalSettingsPath", () => $8c72b7f1296b7207$export$1a7321c4210a3049);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $8c72b7f1296b7207$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $8c72b7f1296b7207$export$a974f4af282a75ba = '/jira/settings/personal';
const $8c72b7f1296b7207$export$693b70d1bcef8627 = `${$8c72b7f1296b7207$export$a974f4af282a75ba}/general`;
const $8c72b7f1296b7207$export$21946ea4c58fd4c9 = `${$8c72b7f1296b7207$export$a974f4af282a75ba}/notifications`;
const $8c72b7f1296b7207$export$cff16c3a6aa7a3a9 = `${$8c72b7f1296b7207$export$a974f4af282a75ba}/digests`;
const $8c72b7f1296b7207$export$1fffbb6055aa320a = `${$8c72b7f1296b7207$export$a974f4af282a75ba}/apps`;
const $8c72b7f1296b7207$export$2321c59d517801c8 = `${$8c72b7f1296b7207$export$a974f4af282a75ba}/alert-notifications`;
function $8c72b7f1296b7207$export$db9e3ccc1e5e3317() {
    return $8c72b7f1296b7207$export$693b70d1bcef8627;
}
function $8c72b7f1296b7207$export$88a45ae8c4b1c664() {
    return $8c72b7f1296b7207$export$2321c59d517801c8;
}
function $8c72b7f1296b7207$export$64a672523a583594() {
    return $8c72b7f1296b7207$export$21946ea4c58fd4c9;
}
function $8c72b7f1296b7207$export$1a7321c4210a3049() {
    return $8c72b7f1296b7207$export$1fffbb6055aa320a;
}

});

parcelRegister("3qYy0", function(module, exports) {
$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $d6d0f3399286651d$export$55ab09b9d6beb8be);
const $d6d0f3399286651d$export$55ab09b9d6beb8be = {
    name: 'personal-settings-notifications',
    path: '/jira/settings/personal/notifications'
};

});

parcelRegister("hxBvd", function(module, exports) {
$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $db3701693e45d2ed$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $db3701693e45d2ed$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $db3701693e45d2ed$export$8cb773cb6fc17338);
/* PersonalSettingsNotificationsAppSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $d5ps5 = parcelRequire("d5ps5");

var $d3k11 = parcelRequire("d3k11");

var $lmJS3 = parcelRequire("lmJS3");

var $79pKC = parcelRequire("79pKC");

var $7Jxny = parcelRequire("7Jxny");
const $db3701693e45d2ed$var$maxWidthCssStyles = null;
const $db3701693e45d2ed$var$customCssStyles = null;
const $db3701693e45d2ed$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($79pKC))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f8stt"
        ])
    });
$db3701693e45d2ed$export$b542eb2d3193b983.displayName = "PersonalSettingsNotificationsAppSkeleton";
const $db3701693e45d2ed$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($db3701693e45d2ed$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d3k11))),
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    }));
$db3701693e45d2ed$export$d58f6bbbc1838cb2.displayName = "PersonalSettingsNotificationsGlobalTableSkeleton";
const $db3701693e45d2ed$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($db3701693e45d2ed$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lmJS3))),
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    }));
$db3701693e45d2ed$export$46fc11a564484c9c.displayName = "MimetypeSelectSkeleton";
const $db3701693e45d2ed$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($db3701693e45d2ed$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxny))),
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    }));
$db3701693e45d2ed$export$8cb773cb6fc17338.displayName = "ProjectNotificationAccordionSkeleton";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db3701693e45d2ed$var$SkeletonWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3k11", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("lmJS3", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("79pKC", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("7Jxny", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});



parcelRegister("1lT1j", function(module, exports) {
$parcel$export(module.exports, "oldJiraHomeRouteEntry", () => $96be559de786911d$export$a9f6f4dd735b1a50);
/* eslint-disable import/order */ 
var $aEhre = parcelRequire("aEhre");


var $itEfp = parcelRequire("itEfp");


var $6RSCO = parcelRequire("6RSCO");

var $llbQS = parcelRequire("llbQS");

var $jy0b6 = parcelRequire("jy0b6");

var $dTa0V = parcelRequire("dTa0V");

var $jOrx3 = parcelRequire("jOrx3");

var $i860n = parcelRequire("i860n");

var $7XVba = parcelRequire("7XVba");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $j10If = parcelRequire("j10If");

var $35eqr = parcelRequire("35eqr");

var $8HUuJ = parcelRequire("8HUuJ");

var $ikYWM = parcelRequire("ikYWM");
const $96be559de786911d$var$conditionalPostOfficeJiraYourWorkResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('post_office_ssr_jira_your_work_enabled'), (0, $35eqr.postOfficeJiraYourWorkResource));
const $96be559de786911d$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $3ec8eeeab0e63d24$export$25ee35b01de9d734].promise;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $jOrx3.checkShouldUseJSM)(data);
};
const $96be559de786911d$var$oldJiraHomeEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $aEhre.yourWorkRedirectPageEntryPoint)
});
const $96be559de786911d$export$a9f6f4dd735b1a50 = (0, $fdS54.createEntry)((0, $j10If.oldJiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        skeleton: (0, $ikYWM.YourWorkSkeleton),
        layout: (0, $7XVba.homepageLayout),
        entryPoint: ()=>$96be559de786911d$var$oldJiraHomeEntryPoint,
        navigation: {
            menuId: (0, $b7e3cc368b5225c1$export$5fd2fc81b4f591a3)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $itEfp.jiraHomeResourceWithCache),
            $96be559de786911d$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $llbQS.widgetResources).map((resourceCreator)=>resourceCreator($96be559de786911d$var$checkConsolidationOnRouteDependency, [
                    (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
                ])),
            ...(0, $jy0b6.widgetResources).map((resourceCreator)=>resourceCreator($96be559de786911d$var$checkConsolidationOnRouteDependency, [
                    (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
                ]))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aEhre", function(module, exports) {
$parcel$export(module.exports, "yourWorkRedirectPageEntryPoint", () => $108bcefc3f841589$export$405619c81f32edbc);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $108bcefc3f841589$export$405619c81f32edbc = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("58QA4")), {
        moduleId: "e7d8821c",
        moduleName: "YourWorkRedirectPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {},
            extraProps: {}
        })
});

});
parcelRegister("58QA4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("inQqu").then(()=>parcelRequire('5Zkp7'));

});


parcelRegister("j10If", function(module, exports) {
$parcel$export(module.exports, "oldJiraHomeRoute", () => $dabe59560e4d2e96$export$81e03d85d70e35e);
const $dabe59560e4d2e96$export$81e03d85d70e35e = {
    name: 'your-work',
    path: '/jira/your-work'
};

});


parcelRegister("eb3ne", function(module, exports) {
$parcel$export(module.exports, "opsgenieScheduleRedirectRouteEntry", () => $1abc2bc6eb568515$export$75f0bcae97d54ba0);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $6fhXO = parcelRequire("6fhXO");

var $2BK7F = parcelRequire("2BK7F");
const $1abc2bc6eb568515$export$75f0bcae97d54ba0 = (0, $fdS54.createEntry)((0, $6fhXO.opsgenieScheduleRedirectRoute), ()=>({
        group: 'components',
        // eslint-disable-next-line no-restricted-syntax
        component: !false ? (0, $2BK7F.OpsgenieScheduleRedirect) : (0, $2BK7F.default),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2BK7F.LazyOpsGenieSchedule)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6fhXO", function(module, exports) {
$parcel$export(module.exports, "opsgenieScheduleRedirectRoute", () => $47e4b0f8b5b72b63$export$5d29dbb36868dff4);
const $47e4b0f8b5b72b63$export$5d29dbb36868dff4 = {
    name: 'opsgenie-schedule-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
    ]
};

});

parcelRegister("2BK7F", function(module, exports) {
$parcel$export(module.exports, "LazyOpsGenieSchedule", () => $104467933bf8ba8c$export$3a9c3ff70731bdd6);
$parcel$export(module.exports, "OpsgenieScheduleRedirect", () => $104467933bf8ba8c$export$6ffd640c3062d976);
$parcel$export(module.exports, "default", () => $104467933bf8ba8c$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $9Ac9V = parcelRequire("9Ac9V");

const $104467933bf8ba8c$export$3a9c3ff70731bdd6 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("3E2g8"))), {
    moduleId: "./src/packages/spa-apps/project-opsgenie-schedule/src/OpsgenieScheduleApp.tsx"
});
const $104467933bf8ba8c$export$6ffd640c3062d976 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Ac9V.RedirectToProjectType), {
        page: "/on-call-schedule"
    });
$104467933bf8ba8c$export$6ffd640c3062d976.displayName = "OpsgenieScheduleRedirect";
const $104467933bf8ba8c$var$AsyncOpsGenieSchedule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $104467933bf8ba8c$export$3a9c3ff70731bdd6,
        pageId: "opsgenie-schedule",
        shouldShowSpinner: true
    });
$104467933bf8ba8c$var$AsyncOpsGenieSchedule.displayName = "AsyncOpsGenieSchedule";
var $104467933bf8ba8c$export$2e2bcd8739ae039 = $104467933bf8ba8c$var$AsyncOpsGenieSchedule;

});
parcelRegister("9Ac9V", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $dd3f5b9b02509703$export$8a3df560509448b8);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable import/order */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $edf7u = parcelRequire("edf7u");

var $eNr3t = parcelRequire("eNr3t");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");
var $bc9Gj = parcelRequire("bc9Gj");
const $dd3f5b9b02509703$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $gNbXR.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $aJ81Y.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $inMxE.useAnalyticsEvents), useResource: useResource = (0, $k6ufm.useResource), useRouter: useRouter = (0, $bc9Gj.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $eNr3t.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $edf7u.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $euxye.useRef)(createAnalyticsEvent({}));
    (0, $euxye.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $f99M0.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $f99M0.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $f99M0.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};
$dd3f5b9b02509703$export$8a3df560509448b8.displayName = "RedirectToProjectType";

});

parcelRegister("3E2g8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eWb8J").then(()=>parcelRequire('1or1j'));

});



parcelRegister("fflqE", function(module, exports) {
$parcel$export(module.exports, "opsgenieScheduleRouteEntry", () => $53255e7d42232a52$export$f128c1c4a1f0d631);

var $74oEx = parcelRequire("74oEx");


var $lFLfF = parcelRequire("lFLfF");

var $052eo = parcelRequire("052eo");

var $jEYuY = parcelRequire("jEYuY");

var $aWliK = parcelRequire("aWliK");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $bw2g0 = parcelRequire("bw2g0");

var $75Njg = parcelRequire("75Njg");

var $2BK7F = parcelRequire("2BK7F");
const $53255e7d42232a52$export$f128c1c4a1f0d631 = (0, $fdS54.createEntry)((0, $bw2g0.opsgenieScheduleRoute), ()=>({
        group: 'components',
        ufoName: 'project-opsgenie-schedule',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)((0, $052eo.isDevopsFeatureDisabledInFedRamp), (0, $lFLfF.default), (0, $2BK7F.default)),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2BK7F.LazyOpsGenieSchedule)
        ],
        meta: {
            reporting: {
                id: 'opsgenie-schedule',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('opsgenie-schedule'),
                teamName: 'fusion-solaris'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bw2g0", function(module, exports) {
$parcel$export(module.exports, "opsgenieScheduleRoute", () => $519073113b2d1eed$export$534a7ac096cb1da2);
const $519073113b2d1eed$export$534a7ac096cb1da2 = {
    name: 'opsgenie-schedule',
    path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
};

});


parcelRegister("gLnPj", function(module, exports) {
$parcel$export(module.exports, "opsNotificationsPersonalSettingsRouteEntry", () => $3594c94af6cd0138$export$407513e3bdb49efe);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $6RSCO = parcelRequire("6RSCO");

var $bnFXJ = parcelRequire("bnFXJ");

var $9BoWi = parcelRequire("9BoWi");

var $42KYp = parcelRequire("42KYp");parcelRequire("lrLEP");
var $1OYWB = parcelRequire("1OYWB");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $fRiFI = parcelRequire("fRiFI");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $7Fzs6 = parcelRequire("7Fzs6");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3594c94af6cd0138$var$LazyOpsNotificationsPersonalSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("ctmc4"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings-ops-notifications/src/ExportedDefault.tsx"
});
const $3594c94af6cd0138$var$OpsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3594c94af6cd0138$var$LazyOpsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
$3594c94af6cd0138$var$OpsNotificationsPersonalSettingsComponent.displayName = "OpsNotificationsPersonalSettingsComponent";
const $3594c94af6cd0138$export$407513e3bdb49efe = (0, $fdS54.createEntry)((0, $fRiFI.opsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: $3594c94af6cd0138$var$OpsNotificationsPersonalSettingsComponent,
        layout: (0, $7Fzs6.opsNotificationsLayout),
        navigation: {
            sidebarId: (0, $f5c10d229cf55438$export$8f20a381b96458f0),
            menuId: (0, $a3b30e449fa4e063$export$75c8a2cf8cfeef9c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $bnFXJ.createContactsResource)(),
            (0, $42KYp.createNotificationPreferencesResource)(),
            (0, $1OYWB.eocUserResource),
            (0, $9BoWi.createMuteResource)(),
            (0, $9BoWi.createQuietHoursResource)(),
            (0, $42KYp.createForwardingRulesResource)(),
            ...(0, $hFYSn.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $3594c94af6cd0138$var$LazyOpsNotificationsPersonalSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fRiFI", function(module, exports) {
$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $ed3d110bd1240a0b$export$68ebdd4eccb7b383);
const $ed3d110bd1240a0b$export$68ebdd4eccb7b383 = {
    name: 'personal-settings-ops-notifications',
    path: '/jira/settings/personal/alert-notifications'
};

});

parcelRegister("ctmc4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gZSkT")
]).then(()=>parcelRequire('iU1TQ'));

});


parcelRegister("3aM5P", function(module, exports) {
$parcel$export(module.exports, "pendingJourneysRouteEntry", () => $8bca8c05e689bc2f$export$2cc72512388790c);
/* eslint-disable import/order */ 

var $geK05 = parcelRequire("geK05");

var $9bMLW = parcelRequire("9bMLW");

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $i860n = parcelRequire("i860n");

var $lbxXL = parcelRequire("lbxXL");

var $9ZSnh = parcelRequire("9ZSnh");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $dTa0V = parcelRequire("dTa0V");
const $8bca8c05e689bc2f$var$pendingJourneysPageEntryPointWithNav = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9bMLW.pendingJourneysEntryPoint),
    horizontalNavigation: (0, $geK05.journeysHorizontalNavEntryPoint)
});
const $8bca8c05e689bc2f$var$pendingJourneysPageEntryPointWithoutNav = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9bMLW.pendingJourneysEntryPoint)
});
const $8bca8c05e689bc2f$export$2cc72512388790c = (0, $fdS54.createEntry)((0, $9ZSnh.pendingJourneysRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.journeys',
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>null,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm-active-journeys-table-m0') ? $8bca8c05e689bc2f$var$pendingJourneysPageEntryPointWithNav : $8bca8c05e689bc2f$var$pendingJourneysPageEntryPointWithoutNav,
        meta: {
            reporting: {
                id: 'journeys',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).JOURNEYS),
                teamName: 'JSM Grape Soju'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9bMLW", function(module, exports) {
$parcel$export(module.exports, "pendingJourneysEntryPoint", () => $dbf6f820c3ed996e$export$c6d063679b23201f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $7s0tt = parcelRequire("7s0tt");

const $dbf6f820c3ed996e$export$c6d063679b23201f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bXU8I")), {
        moduleId: "ffd341f1",
        moduleName: "PendingJourneysPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                pendingJourneysQuery: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7s0tt.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || null
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("7s0tt", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9aa0cb675b4e8fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<285a7d2547dc727f1b96a41b0ab3ca18>>
 * @relayHash 28febb2c31285c1e690c5c06c7b9b605
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b646221c7c35d7c849f518c9b5c45fba866e6a9d292b0226e3f7f776dc677fa2
const $b9aa0cb675b4e8fe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b646221c7c35d7c849f518c9b5c45fba866e6a9d292b0226e3f7f776dc677fa2",
        "metadata": {},
        "name": "PendingJourneysPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b9aa0cb675b4e8fe$export$2e2bcd8739ae039 = $b9aa0cb675b4e8fe$var$node;

});

parcelRegister("bXU8I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lkQOt").then(()=>parcelRequire('hmM86'));

});


parcelRegister("9ZSnh", function(module, exports) {
$parcel$export(module.exports, "pendingJourneysRoute", () => $fd0002d5d8985812$export$be68f6dfb4bd1094);
const $fd0002d5d8985812$export$be68f6dfb4bd1094 = {
    path: '/jira/servicedesk/projects/:projectKey/journeys/pending',
    name: 'journeys',
    exact: true
};

});


parcelRegister("j6et5", function(module, exports) {
$parcel$export(module.exports, "peopleProfilesRouteEntry", () => $43ce63e2fec6b34e$export$219b6cc00b2f91a0);
/* eslint-disable import/order */ 
var $hi6Of = parcelRequire("hi6Of");


var $4ZR6J = parcelRequire("4ZR6J");

var $6RSCO = parcelRequire("6RSCO");

var $2700E = parcelRequire("2700E");

var $h2tgz = parcelRequire("h2tgz");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $bKPo4 = parcelRequire("bKPo4");

var $dUAVJ = parcelRequire("dUAVJ");

var $cZGCd = parcelRequire("cZGCd");

var $74h93 = parcelRequire("74h93");
const $43ce63e2fec6b34e$var$peopleProfilesPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4ZR6J.peopleProfilesEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $43ce63e2fec6b34e$export$219b6cc00b2f91a0 = (0, $fdS54.createEntry)((0, $cZGCd.peopleProfilesRoute), ()=>({
        group: 'people-profiles',
        layout: (0, $bKPo4.layoutWithCondition)(()=>(0, $2700E.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, $74h93.rightSidebarsLayout), (0, $h2tgz.globalLayout)),
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        ufoName: 'people-profiles',
        entryPoint: ()=>$43ce63e2fec6b34e$var$peopleProfilesPageEntrypoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4ZR6J", function(module, exports) {
$parcel$export(module.exports, "peopleProfilesEntrypoint", () => $ec8470625833c6d4$export$26daeb77c71acf79);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ec8470625833c6d4$export$26daeb77c71acf79 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dyfIi")), {
        moduleId: "c63ab193",
        moduleName: "PeopleProfiles",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dyfIi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("5qC72"),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("66GtW")
]).then(()=>parcelRequire('bkoH9'));

});


parcelRegister("cZGCd", function(module, exports) {
$parcel$export(module.exports, "peopleProfilesRoute", () => $6a1f4028d6c48cba$export$1338132568be849);
const $6a1f4028d6c48cba$export$1338132568be849 = {
    name: 'people-index',
    path: '/jira/people/:subPath?'
};

});


parcelRegister("8d4Pa", function(module, exports) {
$parcel$export(module.exports, "performanceRouteEntry", () => $7c26fc5b7fdd8e31$export$3f75a1735cbe5a04);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 


var $7GHCf = parcelRequire("7GHCf");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $3geMU = parcelRequire("3geMU");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $1lV4Z = parcelRequire("1lV4Z");
const $7c26fc5b7fdd8e31$var$performancePageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7GHCf.performanceEntryPoint)
});
const $7c26fc5b7fdd8e31$export$3f75a1735cbe5a04 = (0, $fdS54.createEntry)((0, $3geMU.performanceRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_sd_virtual_agent') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-virtual-service-agent') : (0, $l1vE2.isFedRamp)()) return undefined;
            return $7c26fc5b7fdd8e31$var$performancePageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1lV4Z.FedRAMPFallbackRedirectToProjectSettings),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7GHCf", function(module, exports) {
$parcel$export(module.exports, "performanceEntryPoint", () => $c620ce9cd62e6958$export$52b48527e9315b46);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $8laMq = parcelRequire("8laMq");
const $c620ce9cd62e6958$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $c620ce9cd62e6958$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $c620ce9cd62e6958$export$52b48527e9315b46 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2CQOw")), {
        moduleId: "5bc71599",
        moduleName: "VirtualAgentPerformance",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $8laMq.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: $c620ce9cd62e6958$var$formatFetchDate(new Date(Date.now() - $c620ce9cd62e6958$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $c620ce9cd62e6958$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("8laMq", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c462356c01b5eb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cb111d2e17c75d3d42a6b1de487cb30f>>
 * @relayHash 8ef0897c82e537fb89fa244bfec22336
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 873b9b112623d6e204fe3457b5b98ead7990062eed771e3faea8aaf8e3890b77

var $k49ny = parcelRequire("k49ny");
const $8c462356c01b5eb0$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "873b9b112623d6e204fe3457b5b98ead7990062eed771e3faea8aaf8e3890b77",
        "metadata": {},
        "name": "VirtualAgentPerformanceQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
        }
    }
};
var $8c462356c01b5eb0$export$2e2bcd8739ae039 = $8c462356c01b5eb0$var$node;

});

parcelRegister("2CQOw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gCucJ").then(()=>parcelRequire('2vEsd'));

});


parcelRegister("3geMU", function(module, exports) {
$parcel$export(module.exports, "performanceRoute", () => $d10d19537cc9ab35$export$d867623f05adedb3);
const $d10d19537cc9ab35$export$d867623f05adedb3 = {
    name: 'project-settings-servicedesk-virtualagent-performance',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance'
};

});


parcelRegister("gW2I6", function(module, exports) {
$parcel$export(module.exports, "personalSettingsRouteEntry", () => $7b55b8ef1030328d$export$89646e32fa7698db);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");




var $6RSCO = parcelRequire("6RSCO");

var $bnFXJ = parcelRequire("bnFXJ");

var $9BoWi = parcelRequire("9BoWi");

var $42KYp = parcelRequire("42KYp");parcelRequire("lrLEP");
var $1OYWB = parcelRequire("1OYWB");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $hFYSn = parcelRequire("hFYSn");

var $aNvSV = parcelRequire("aNvSV");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dqnC6 = parcelRequire("dqnC6");

var $dLVGe = parcelRequire("dLVGe");

var $jhKsF = parcelRequire("jhKsF");

var $l8G1z = parcelRequire("l8G1z");

var $1rnr3 = parcelRequire("1rnr3");

var $kJe84 = parcelRequire("kJe84");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7b55b8ef1030328d$var$LazyLegacyPersonalSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("cmqlx"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/PersonalSettingsShell.tsx"
});
const $7b55b8ef1030328d$export$89646e32fa7698db = (0, $fdS54.createEntry)((0, $dqnC6.personalSettingsRoute), ()=>({
        group: 'personal-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
                to: (0, $aNvSV.GENERAL_PERSONAL_SETTINGS_PATH)
            }),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            sidebarId: (0, $f5c10d229cf55438$export$8f20a381b96458f0),
            menuId: (0, $a3b30e449fa4e063$export$75c8a2cf8cfeef9c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $bnFXJ.createContactsResource)((0, $1rnr3.checkConsolidationOnRouteDependency), [
                (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
            ]),
            (0, $42KYp.createNotificationPreferencesResource)((0, $1rnr3.checkConsolidationOnRouteDependency), [
                (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
            ]),
            (0, $1OYWB.eocUserResource),
            (0, $9BoWi.createMuteResource)((0, $1rnr3.checkConsolidationOnRouteDependency), [
                (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
            ]),
            (0, $9BoWi.createQuietHoursResource)((0, $1rnr3.checkConsolidationOnRouteDependency), [
                (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
            ]),
            (0, $42KYp.createForwardingRulesResource)((0, $1rnr3.checkConsolidationOnRouteDependency), [
                (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734)
            ]),
            ...(0, $hFYSn.getNavigationForgePersonalSettingsPageResources)(),
            ...(0, $kJe84.getLabsResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $7b55b8ef1030328d$var$LazyLegacyPersonalSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dqnC6", function(module, exports) {
$parcel$export(module.exports, "personalSettingsRoute", () => $01f8d4a536445e44$export$176d0935b95c75e8);
const $01f8d4a536445e44$export$176d0935b95c75e8 = {
    name: 'personal-settings',
    path: '/secure/ViewPersonalSettings.jspa'
};

});

parcelRegister("1rnr3", function(module, exports) {
$parcel$export(module.exports, "checkConsolidationOnRouteDependency", () => $ca00f7581fe2151b$export$ac86a769188afd33);


var $jOrx3 = parcelRequire("jOrx3");
const $ca00f7581fe2151b$export$ac86a769188afd33 = (dependencies)=>{
    const { data: data } = dependencies[0, $3ec8eeeab0e63d24$export$25ee35b01de9d734];
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $jOrx3.checkShouldUseJSM)(data);
};

});

parcelRegister("cmqlx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("5qC72"),
    $4cvLQ("1OPaV")
]).then(()=>parcelRequire('3nawz'));

});


parcelRegister("32FNJ", function(module, exports) {
$parcel$export(module.exports, "piCreateIssueEmbedRouteEntry", () => $a5fc2c80a2b316c0$export$7f9ffa2e2d102ba);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $7xLLk = parcelRequire("7xLLk");

var $fdS54 = parcelRequire("fdS54");

var $8bf4L = parcelRequire("8bf4L");

var $byMD7 = parcelRequire("byMD7");

var $4B518 = parcelRequire("4B518");

var $gWItI = parcelRequire("gWItI");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a5fc2c80a2b316c0$var$LazyPICreateIssueEmbed = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2BNeM")).then((module)=>module.CreateIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/create-issue/index.tsx"
});
const $a5fc2c80a2b316c0$var$PIIssueCreateEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7xLLk.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $a5fc2c80a2b316c0$var$LazyPICreateIssueEmbed,
        pageId: "spa-apps/pi-issue-create-embed",
        shouldShowSpinner: true
    }));
};
$a5fc2c80a2b316c0$var$PIIssueCreateEmbedLazy.displayName = "PIIssueCreateEmbedLazy";
const $a5fc2c80a2b316c0$export$7f9ffa2e2d102ba = (0, $fdS54.createEntry)((0, $gWItI.piCreateIssueEmbedRoute), ()=>({
        group: 'issue',
        // eslint-disable-next-line no-restricted-syntax
        component: $a5fc2c80a2b316c0$var$PIIssueCreateEmbedLazy,
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        forPaint: [
            $a5fc2c80a2b316c0$var$LazyPICreateIssueEmbed
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gWItI", function(module, exports) {
$parcel$export(module.exports, "piCreateIssueEmbedRoute", () => $0e7120b36d4c1d0a$export$e38c7e6f5c65691b);
const $0e7120b36d4c1d0a$export$e38c7e6f5c65691b = {
    name: 'pi-issue-create-embed',
    path: '/jira/issues/create/pi/embed'
};

});

parcelRegister("2BNeM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Ed93D").then(()=>parcelRequire('cJSeY'));

});


parcelRegister("68BYI", function(module, exports) {
$parcel$export(module.exports, "piEditIssueEmbedRouteEntry", () => $cd2ee9b584721088$export$54fd859765926fb);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $7xLLk = parcelRequire("7xLLk");

var $fdS54 = parcelRequire("fdS54");

var $62YQb = parcelRequire("62YQb");

var $8bf4L = parcelRequire("8bf4L");

var $byMD7 = parcelRequire("byMD7");

var $4B518 = parcelRequire("4B518");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cd2ee9b584721088$var$LazyPIEditIssueEmbed = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("f0EwM")).then((module)=>module.EditIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/edit-issue/index.tsx"
});
const $cd2ee9b584721088$var$PIIssueEditEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7xLLk.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $cd2ee9b584721088$var$LazyPIEditIssueEmbed,
        pageId: "spa-apps/pi-issue-edit-embed",
        shouldShowSpinner: true
    }));
};
$cd2ee9b584721088$var$PIIssueEditEmbedLazy.displayName = "PIIssueEditEmbedLazy";
const $cd2ee9b584721088$export$54fd859765926fb = (0, $fdS54.createEntry)((0, $62YQb.piEditIssueEmbedRoute), ()=>({
        group: 'issue',
        // eslint-disable-next-line no-restricted-syntax
        component: $cd2ee9b584721088$var$PIIssueEditEmbedLazy,
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        layout: (0, $byMD7.chromelessLayout),
        forPaint: [
            $cd2ee9b584721088$var$LazyPIEditIssueEmbed
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("62YQb", function(module, exports) {
$parcel$export(module.exports, "piEditIssueEmbedRoute", () => $a6dc6284e3f98256$export$963ebe9ee36e7e80);
const $a6dc6284e3f98256$export$963ebe9ee36e7e80 = {
    name: 'pi-issue-edit-embed',
    path: '/jira/issues/edit/pi/embed'
};

});

parcelRegister("f0EwM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kSyMJ").then(()=>parcelRequire('cp0gC'));

});


parcelRegister("1nenU", function(module, exports) {
$parcel$export(module.exports, "planExportPageRouteEntry", () => $840cb7f0c4696b0f$export$d751e3552b21c604);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $6ZHVf = parcelRequire("6ZHVf");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $9NQVp = parcelRequire("9NQVp");

var $8bf4L = parcelRequire("8bf4L");

var $8HI6e = parcelRequire("8HI6e");

var $8tAZd = parcelRequire("8tAZd");
/**
 * Export Page
 */ const $840cb7f0c4696b0f$var$ExportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8HI6e.LazyAdvancedRoadmapsPlanExport), null);
$840cb7f0c4696b0f$var$ExportPageComponent.displayName = "ExportPageComponent";
const $840cb7f0c4696b0f$var$ExportPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $840cb7f0c4696b0f$var$ExportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
$840cb7f0c4696b0f$var$ExportPage.displayName = "ExportPage";
const $840cb7f0c4696b0f$export$d751e3552b21c604 = (0, $fdS54.createEntry)((0, $9NQVp.planExportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario-export',
        // eslint-disable-next-line no-restricted-syntax
        component: $840cb7f0c4696b0f$var$ExportPage,
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $8tAZd.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9NQVp", function(module, exports) {
$parcel$export(module.exports, "planExportPageRoute", () => $7cfd16c374127a2d$export$2ca5fe6f9ab466c1);
const $7cfd16c374127a2d$export$2ca5fe6f9ab466c1 = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId/export'
};

});

parcelRegister("8HI6e", function(module, exports) {
$parcel$export(module.exports, "LazyAdvancedRoadmapsPlanExport", () => $1f2a0825dbdadf5f$export$890fb5003e472449);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1f2a0825dbdadf5f$export$890fb5003e472449 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("cIQxh"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan/src/AdvancedRoadmapsPlanType.tsx"
});
const $1f2a0825dbdadf5f$var$AsyncAdvancedRoadmapsPlanExport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1f2a0825dbdadf5f$export$890fb5003e472449,
        pageId: "advanced-roadmaps-plan",
        shouldShowSpinner: true
    });
$1f2a0825dbdadf5f$var$AsyncAdvancedRoadmapsPlanExport.displayName = "AsyncAdvancedRoadmapsPlanExport";
var $1f2a0825dbdadf5f$export$2e2bcd8739ae039 = $1f2a0825dbdadf5f$var$AsyncAdvancedRoadmapsPlanExport;

});
parcelRegister("cIQxh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("iCq3U")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gXIQP")
]).then(()=>parcelRequire('8SzlI'));

});



parcelRegister("i6yvS", function(module, exports) {
$parcel$export(module.exports, "planIncrementRouteEntry", () => $f2c774f237d00c06$export$a26fa5cabff8bc7c);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $bKDkW = parcelRequire("bKDkW");

var $2412k = parcelRequire("2412k");

var $50sfd = parcelRequire("50sfd");
const $f2c774f237d00c06$export$a26fa5cabff8bc7c = (0, $fdS54.createEntry)((0, $bKDkW.planIncrementRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $2412k.planIncrementPageEntryPoint),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $50sfd.PlanIncrement),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $50sfd.LazyPlanIncrement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gOM9u", function(module, exports) {
$parcel$export(module.exports, "planLayout", () => $4a03accb8bd47f22$export$94e1d79bf65579e2);
$parcel$export(module.exports, "planLayoutWithoutInvalidation", () => $4a03accb8bd47f22$export$d639cba605399474);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

const $4a03accb8bd47f22$export$b6292b5f7e5b5fad = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("cEXoG")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-jira-plan-layout/src/ui/resources-invalidate/index.tsx"
});

const $4a03accb8bd47f22$export$70238cd3868b67c9 = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("eTCyO")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-jira-plan-layout/src/ui/onboarding/index.tsx"
});
$4a03accb8bd47f22$export$70238cd3868b67c9.displayName = 'Onboarding';

const $4a03accb8bd47f22$export$f61c80ac3b95bc7d = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("fq7id")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-jira-plan-layout/src/ui/right-sidebars/index.tsx"
});
$4a03accb8bd47f22$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';
const $4a03accb8bd47f22$export$94e1d79bf65579e2 = (0, $QhQu4.createLayout)({
    rightSidebars: [
        $4a03accb8bd47f22$export$f61c80ac3b95bc7d
    ],
    globalComponents: [
        $4a03accb8bd47f22$export$b6292b5f7e5b5fad,
        $4a03accb8bd47f22$export$70238cd3868b67c9
    ]
});
const $4a03accb8bd47f22$export$d639cba605399474 = (0, $QhQu4.createLayout)({
    rightSidebars: [
        $4a03accb8bd47f22$export$f61c80ac3b95bc7d
    ],
    globalComponents: [
        $4a03accb8bd47f22$export$70238cd3868b67c9
    ]
});

});
parcelRegister("cEXoG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5vKJ5").then(()=>parcelRequire('eUtk9'));

});

parcelRegister("eTCyO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3pUVX").then(()=>parcelRequire('11LMC'));

});

parcelRegister("fq7id", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f9RpM").then(()=>parcelRequire('lJ2zn'));

});


parcelRegister("bKDkW", function(module, exports) {
$parcel$export(module.exports, "planIncrementRoute", () => $53833d8d1321108f$export$ef33a75556fde209);
const $53833d8d1321108f$export$ef33a75556fde209 = {
    name: 'software-plan-increment',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId',
    exact: true
};

});

parcelRegister("2412k", function(module, exports) {
$parcel$export(module.exports, "planIncrementPageEntryPoint", () => $081ae326c41925eb$export$a87dd3f7b0d2f7c2);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $flIfc = parcelRequire("flIfc");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");
const $081ae326c41925eb$export$a87dd3f7b0d2f7c2 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $flIfc.planIncrementEntryPoint),
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("g1xPc", function(module, exports) {
$parcel$export(module.exports, "plansHorizontalNavigationEntryPoint", () => $cfade6e71616a1f9$export$172a11f0d118de01);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $fiVog = parcelRequire("fiVog");

var $b3tU7 = parcelRequire("b3tU7");

var $i860n = parcelRequire("i860n");

var $3UToF = parcelRequire("3UToF");
const $cfade6e71616a1f9$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;
function $cfade6e71616a1f9$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $cfade6e71616a1f9$var$toPlanAri({ siteId: siteId, activationId: activationId, planId: planId }) {
    return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
}

const $cfade6e71616a1f9$export$172a11f0d118de01 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("g2DVp")), {
        moduleId: "800c9241",
        moduleName: "HorizontalNavPlans",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        // can't be true yet as plans use window.location.pathname at module level & create redux reducers at module level - both not import lifting friendly
        entryFsSsrLiftImportToModule: false
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId, isAnonymous: isAnonymous } })=>{
        const planId = match.params.planId;
        const scenarioId = match.params.scenarioId;
        if (!planId) throw new Error('Plan Id is missing');
        if (!scenarioId) throw new Error('Scenario Id is missing');
        if (isAnonymous && (0, $i860n.fg)('auth_check_in_horizontal_nav_plans_entrypoint')) // Anonymous users cannot access plans — skip the network request entirely.
        // loadEntryPoint treats a return value without a `queries` key as a no-op
        // and never calls loadQuery, preventing the 403 from the GQL gateway.
        return {};
        const planScenarioAri = $cfade6e71616a1f9$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: planId,
            scenarioId: scenarioId
        });
        const planAri = $cfade6e71616a1f9$var$toPlanAri({
            siteId: cloudId,
            activationId: activationId,
            planId: planId
        });
        return {
            queries: {
                horizontalNavPlansQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3UToF.default,
                    variables: {
                        first: $cfade6e71616a1f9$var$NAVIGATION_ITEMS_PAGE_SIZE,
                        cloudId: cloudId,
                        containerNavigationInput: {
                            scopeId: planScenarioAri
                        },
                        planId: planAri,
                        shouldFetchInvitePermission: (0, $i860n.fg)('plan_settings_sidebar_migrate_to_relay'),
                        scopeId: planScenarioAri
                    }
                }
            }
        };
    }
});

});
parcelRegister("3UToF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f65046b3b8caa347$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e1cc49284b754afb5911379f1b5d0d0>>
 * @relayHash d7ed975d357c90fe0b2b7af56d44be0b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f6849648240760c1a4e22938e1a11922b2177cf7f644bc6fe1c9cf6ef6e5aabd
const $f65046b3b8caa347$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f6849648240760c1a4e22938e1a11922b2177cf7f644bc6fe1c9cf6ef6e5aabd",
        "metadata": {},
        "name": "HorizontalNavPlansQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f65046b3b8caa347$export$2e2bcd8739ae039 = $f65046b3b8caa347$var$node;

});

parcelRegister("g2DVp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("kfAzg")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("5hDo9")
]).then(()=>parcelRequire('fnkZD'));

});



parcelRegister("50sfd", function(module, exports) {
$parcel$export(module.exports, "LazyPlanIncrement", () => $5e4b32ce88e5a2a4$export$e7b9f83d442bac51);
$parcel$export(module.exports, "PlanIncrement", () => $5e4b32ce88e5a2a4$export$5e1035d0876d64db);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $5e4b32ce88e5a2a4$export$e7b9f83d442bac51 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("b7lc0"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-increment/src/PlanIncrement.tsx"
});
const $5e4b32ce88e5a2a4$export$5e1035d0876d64db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5e4b32ce88e5a2a4$export$e7b9f83d442bac51,
        pageId: "plan-increment",
        shouldShowSpinner: true
    });
$5e4b32ce88e5a2a4$export$5e1035d0876d64db.displayName = "PlanIncrement";

});


parcelRegister("6EC2N", function(module, exports) {
$parcel$export(module.exports, "planIncrementsRouteEntry", () => $fbfdba3cb7643ff9$export$f7abc47036ff7dd9);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $dfKgS = parcelRequire("dfKgS");

var $efLpV = parcelRequire("efLpV");

var $VnSWg = parcelRequire("VnSWg");
const $fbfdba3cb7643ff9$export$f7abc47036ff7dd9 = (0, $fdS54.createEntry)((0, $dfKgS.planIncrementsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $VnSWg.planProgramPageEntryPoint),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $efLpV.PlanProgram),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            (0, $6ZHVf.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $efLpV.LazyPlanProgram)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dfKgS", function(module, exports) {
$parcel$export(module.exports, "planIncrementsRoute", () => $d88aab93694314fa$export$d0986e4bd9568b30);
const $d88aab93694314fa$export$d0986e4bd9568b30 = {
    name: 'software-plan-increments',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program',
    exact: true
};

});

parcelRegister("efLpV", function(module, exports) {
$parcel$export(module.exports, "LazyPlanProgram", () => $676767853ad468f1$export$9da4d4d5c4d7f749);
$parcel$export(module.exports, "PlanProgram", () => $676767853ad468f1$export$fb30c2b19a4f5d59);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $676767853ad468f1$export$9da4d4d5c4d7f749 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("2Ia6C"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-program/src/PlanProgram.tsx"
});
const $676767853ad468f1$export$fb30c2b19a4f5d59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $676767853ad468f1$export$9da4d4d5c4d7f749,
        pageId: "plan-program",
        shouldShowSpinner: true
    });
$676767853ad468f1$export$fb30c2b19a4f5d59.displayName = "PlanProgram";

});
parcelRegister("2Ia6C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("fgdDZ")),
    $4cvLQ("1qxAe")
]).then(()=>parcelRequire('14Ekw'));

});


parcelRegister("VnSWg", function(module, exports) {
$parcel$export(module.exports, "planProgramPageEntryPoint", () => $829c8bd75bfcee48$export$cb6ac90e8faddaeb);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $c4hHC = parcelRequire("c4hHC");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");
const $829c8bd75bfcee48$export$cb6ac90e8faddaeb = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $c4hHC.planProgramEntryPoint),
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("c4hHC", function(module, exports) {
$parcel$export(module.exports, "planProgramEntryPoint", () => $3e0da140d3c28dac$export$da91c765d9841bae);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $3e0da140d3c28dac$export$da91c765d9841bae = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("k7RY0")), {
        moduleId: "5a6ddb8d",
        moduleName: "AdvancedRoadmapsPlanProgramPlanProgram",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("k7RY0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("2KuxB")),
    $4cvLQ("ifmZc")
]).then(()=>parcelRequire('8KvBU'));

});




parcelRegister("8Iamy", function(module, exports) {
$parcel$export(module.exports, "planPageRouteEntry", () => $5abd677cfaaa5568$export$f85a75f1604118ff);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $KmeGf = parcelRequire("KmeGf");

var $QhQu4 = parcelRequire("QhQu4");

var $gOM9u = parcelRequire("gOM9u");

var $8tAZd = parcelRequire("8tAZd");

var $fKKOB = parcelRequire("fKKOB");
// This redirect is required to support legacy routes, it should never be deleted
const $5abd677cfaaa5568$var$planPageRedirect = (0, $fKKOB.withRedirection)((0, $8tAZd.default), {
    to: '/timeline',
    redirectCondition: ()=>true
});
const $5abd677cfaaa5568$export$f85a75f1604118ff = (0, $fdS54.createEntry)((0, $KmeGf.planPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario',
        // eslint-disable-next-line no-restricted-syntax
        component: $5abd677cfaaa5568$var$planPageRedirect,
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            (0, $6ZHVf.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8tAZd.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("KmeGf", function(module, exports) {
$parcel$export(module.exports, "planPageRoute", () => $80f05df8c3d1625f$export$26495e043d80cccc);
const $80f05df8c3d1625f$export$26495e043d80cccc = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId'
};

});

parcelRegister("fKKOB", function(module, exports) {
$parcel$export(module.exports, "withRedirection", () => $ba5674c17c3db6c5$export$2c9e4550ef8bdea9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");

var $bc9Gj = parcelRequire("bc9Gj");
function $ba5674c17c3db6c5$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const [{ match: match }] = (0, $bc9Gj.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}

});


parcelRegister("1ZZjB", function(module, exports) {
$parcel$export(module.exports, "planPageWithoutScenarioIdRouteEntry", () => $46181cb6f812562d$export$9cbef73b51558ef);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $drFL0 = parcelRequire("drFL0");

var $36TIq = parcelRequire("36TIq");

var $8tAZd = parcelRequire("8tAZd");
const $46181cb6f812562d$export$9cbef73b51558ef = (0, $fdS54.createEntry)((0, $drFL0.planPageWithoutScenarioIdRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-plan',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $36TIq.RedirectPlanPageWithoutScenarioIdLoadQuery),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8tAZd.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("drFL0", function(module, exports) {
$parcel$export(module.exports, "planPageWithoutScenarioIdRoute", () => $e72f2f9c03831995$export$610e14c9c89d0afb);
const $e72f2f9c03831995$export$610e14c9c89d0afb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId(\\d+)'
};

});


parcelRegister("bckOF", function(module, exports) {
$parcel$export(module.exports, "planReportPageRouteEntry", () => $d6ebb8301d044782$export$e71031acce6d7e47);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $3jPsH = parcelRequire("3jPsH");

var $lRMUR = parcelRequire("lRMUR");
const $d6ebb8301d044782$export$e71031acce6d7e47 = (0, $fdS54.createEntry)((0, $3jPsH.planReportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-report',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lRMUR.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanReportPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            (0, $6ZHVf.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lRMUR.LazyPlanReport)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3jPsH", function(module, exports) {
$parcel$export(module.exports, "planReportPageRoute", () => $44fb2a3f0582760f$export$7c8c0761b1ba57bb);
const $44fb2a3f0582760f$export$7c8c0761b1ba57bb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/reports/:reportId'
};

});

parcelRegister("lRMUR", function(module, exports) {
$parcel$export(module.exports, "LazyPlanReport", () => $1368e9997b7d9332$export$fe1fc08f511671db);
$parcel$export(module.exports, "default", () => $1368e9997b7d9332$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1368e9997b7d9332$export$fe1fc08f511671db = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("1N6v8"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-report/src/ExportedComponent.tsx"
});
const $1368e9997b7d9332$var$PlanReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1368e9997b7d9332$export$fe1fc08f511671db,
        pageId: "plan-report",
        shouldShowSpinner: true
    });
$1368e9997b7d9332$var$PlanReport.displayName = "PlanReport";
var $1368e9997b7d9332$export$2e2bcd8739ae039 = $1368e9997b7d9332$var$PlanReport;

});
parcelRegister("1N6v8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("CzI0h")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("kf76W")
]).then(()=>parcelRequire('4B2cC'));

});



parcelRegister("8JjPR", function(module, exports) {
$parcel$export(module.exports, "plansDirectoryRouteEntry", () => $3460b9d3eaebc675$export$4f9df77811fbdc1f);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $kYsVS = parcelRequire("kYsVS");

var $85jAF = parcelRequire("85jAF");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $3460b9d3eaebc675$var$LazyPlansDirectory = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("2EL75"))), {
    moduleId: "./src/packages/spa-apps/directories-plans/src/PlansDirectoryType.tsx"
});
const $3460b9d3eaebc675$var$PlansDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3460b9d3eaebc675$var$LazyPlansDirectory,
        pageId: "plans-directory",
        shouldShowSpinner: false
    });
$3460b9d3eaebc675$var$PlansDirectoryComponent.displayName = "PlansDirectoryComponent";
const $3460b9d3eaebc675$export$4f9df77811fbdc1f = (0, $fdS54.createEntry)((0, $kYsVS.plansDirectoryRoute), ()=>({
        group: 'directories',
        // eslint-disable-next-line no-restricted-syntax
        component: $3460b9d3eaebc675$var$PlansDirectoryComponent,
        skeleton: (0, $85jAF.PlansDirectorySkeleton),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $3460b9d3eaebc675$var$LazyPlansDirectory
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kYsVS", function(module, exports) {
$parcel$export(module.exports, "plansDirectoryRoute", () => $c9ef692ca2c5b7cd$export$143b4a1ef2ffc051);
const $c9ef692ca2c5b7cd$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("2EL75", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gs3U8")
]).then(()=>parcelRequire('6ncnC'));

});


parcelRegister("ccbVD", function(module, exports) {
$parcel$export(module.exports, "planSetupPageRouteEntry", () => $0c2862d23246cab6$export$2a24acea4e628148);
/* eslint-disable import/order */ 
var $6ZHVf = parcelRequire("6ZHVf");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $6UyUz = parcelRequire("6UyUz");

var $6qYW9 = parcelRequire("6qYW9");
const $0c2862d23246cab6$export$2a24acea4e628148 = (0, $fdS54.createEntry)((0, $6UyUz.planSetupPageRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6qYW9.default),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6qYW9.LazyAdvancedRoadmapsSetup)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6UyUz", function(module, exports) {
$parcel$export(module.exports, "planSetupPageRoute", () => $b35dc616179b8db5$export$4815756bb523904e);
const $b35dc616179b8db5$export$4815756bb523904e = {
    name: 'software-advanced-roadmaps-setup',
    path: '/jira/plans/:planId/setup'
};

});

parcelRegister("6qYW9", function(module, exports) {
$parcel$export(module.exports, "LazyAdvancedRoadmapsSetup", () => $51639953ed93af4f$export$46bb3a1779d7815b);
$parcel$export(module.exports, "default", () => $51639953ed93af4f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $51639953ed93af4f$export$46bb3a1779d7815b = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dMbTx"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-setup/src/AdvancedRoadmapsSetupType.tsx"
});
const $51639953ed93af4f$var$AsyncAdvancedRoadmapsSetup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $51639953ed93af4f$export$46bb3a1779d7815b,
        pageId: "advanced-roadmaps-setup",
        shouldShowSpinner: true
    });
$51639953ed93af4f$var$AsyncAdvancedRoadmapsSetup.displayName = "AsyncAdvancedRoadmapsSetup";
var $51639953ed93af4f$export$2e2bcd8739ae039 = $51639953ed93af4f$var$AsyncAdvancedRoadmapsSetup;

});
parcelRegister("dMbTx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kBRvd").then(()=>parcelRequire('1BI4x'));

});



parcelRegister("3i3Pz", function(module, exports) {
$parcel$export(module.exports, "planViewNotFoundRouteEntry", () => $240ab8652234cb41$export$19c7bb0eeda48c06);
/* eslint-disable import/order */ 

var $khW9g = parcelRequire("khW9g");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $7gOdu = parcelRequire("7gOdu");

var $QhQu4 = parcelRequire("QhQu4");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");
const $240ab8652234cb41$export$19c7bb0eeda48c06 = (0, $fdS54.createEntry)((0, $7gOdu.planViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        entryPoint: ()=>(0, $khW9g.planViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("khW9g", function(module, exports) {
$parcel$export(module.exports, "planViewNotFoundPageEntrypoint", () => $cbab2776ab7d6703$export$18e8a0d930f394a2);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");

var $gZ64X = parcelRequire("gZ64X");

const $cbab2776ab7d6703$var$main = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2ghKS")), {
        moduleId: "624be4f0",
        moduleName: "PlanViewNotFound",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        if (!planId) throw new Error('Plan Id is missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $gZ64X.default,
                    variables: {
                        planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
                    }
                }
            }
        };
    }
});
const $cbab2776ab7d6703$export$18e8a0d930f394a2 = (0, $dTa0V.createPageEntryPoint)({
    main: $cbab2776ab7d6703$var$main,
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("gZ64X", function(module, exports) {
$parcel$export(module.exports, "default", () => $050d939d27d815f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f97e78ab59091e8012bd8a05696ce789>>
 * @relayHash c51281360f2d7bd5387e9bb058f11f6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229
const $050d939d27d815f5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229",
        "metadata": {},
        "name": "PlanViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $050d939d27d815f5$export$2e2bcd8739ae039 = $050d939d27d815f5$var$node;

});

parcelRegister("2ghKS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5LC4H").then(()=>parcelRequire('i1fjY'));

});


parcelRegister("7gOdu", function(module, exports) {
$parcel$export(module.exports, "planViewNotFoundRoute", () => $4ad3fc3fcccb30f7$export$f2531e319f8b4274);
const $4ad3fc3fcccb30f7$export$f2531e319f8b4274 = {
    name: 'plan-view-not-found',
    path: '/jira/plans/:planId/scenarios/:scenarioId/not-found'
};

});


parcelRegister("cqwf2", function(module, exports) {
$parcel$export(module.exports, "polarisCollectionsRouteEntry", () => $55b0de21d4b0bf38$export$a034dc25c21d1029);

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $yFIkh = parcelRequire("yFIkh");

var $fbUns = parcelRequire("fbUns");
const $55b0de21d4b0bf38$export$a034dc25c21d1029 = (0, $fdS54.createEntry)((0, $yFIkh.polarisCollectionsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.collections',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fbUns.default),
        layout: (0, $h2tgz.globalLayout),
        canTransitionIn: ()=>{
            // default is no-refresh
            return true;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fbUns.LazyCollectionsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("yFIkh", function(module, exports) {
$parcel$export(module.exports, "polarisCollectionsRoute", () => $c198ed6df2179612$export$d415b74f78a5f159);
const $c198ed6df2179612$export$d415b74f78a5f159 = {
    name: 'polaris-collections',
    path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
    query: [
        'projects?',
        'owners?'
    ],
    exact: true
};

});

parcelRegister("fbUns", function(module, exports) {
$parcel$export(module.exports, "LazyCollectionsPage", () => $3d2d79f27f4c1b5a$export$f7960e7dbd7e5265);
$parcel$export(module.exports, "default", () => $3d2d79f27f4c1b5a$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dV3gw = parcelRequire("dV3gw");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $eijVy = parcelRequire("eijVy");

var $l8G1z = parcelRequire("l8G1z");

var $gNbXR = parcelRequire("gNbXR");

const $3d2d79f27f4c1b5a$export$f7960e7dbd7e5265 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("5xenJ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris-collections/src/index.tsx"
});
const $3d2d79f27f4c1b5a$var$useJpdLicensed = ()=>{
    const context = (0, $eijVy.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $3d2d79f27f4c1b5a$export$3bba33442c4150b1 = ()=>{
    const jpdLicensed = $3d2d79f27f4c1b5a$var$useJpdLicensed();
    const crossProjectViewsEnabled = (0, $dV3gw.useIsCrossProjectViewsEnabled)();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    if (!crossProjectViewsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/jira"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3d2d79f27f4c1b5a$export$f7960e7dbd7e5265,
        pageId: "async-polaris-collections",
        shouldShowSpinner: false
    });
};
$3d2d79f27f4c1b5a$export$3bba33442c4150b1.displayName = "RedirectingCollectionsPage";
var $3d2d79f27f4c1b5a$export$2e2bcd8739ae039 = $3d2d79f27f4c1b5a$export$3bba33442c4150b1;

});
parcelRegister("dV3gw", function(module, exports) {
$parcel$export(module.exports, "useIsPremiumEdition", () => $77e78bfe64e53724$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsStandardEdition", () => $77e78bfe64e53724$export$642bac71144485ad);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $77e78bfe64e53724$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $77e78bfe64e53724$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $77e78bfe64e53724$export$304793dd2c5f4db0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $ccEzE = parcelRequire("ccEzE");

var $fTdDx = parcelRequire("fTdDx");
const $77e78bfe64e53724$export$e03262ab59c85d02 = ()=>{
    return (0, $fTdDx.useIsEnterpriseEdition)();
};
const $77e78bfe64e53724$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jpdEdition = (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $d8LhJ.toEdition)((0, $d8LhJ.PREMIUM_EDITION));
};
const $77e78bfe64e53724$export$642bac71144485ad = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const jpdEdition = (0, $d8LhJ.getEdition)((0, $hJL79.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $d8LhJ.toEdition)((0, $d8LhJ.STANDARD_EDITION));
};
const $77e78bfe64e53724$export$a94405ffcb20c356 = ()=>{
    const isPremium = $77e78bfe64e53724$export$8aa8a7878fd61770();
    return isPremium;
};
const $77e78bfe64e53724$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $77e78bfe64e53724$export$8aa8a7878fd61770();
    return isPremium;
};
const $77e78bfe64e53724$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $77e78bfe64e53724$export$8aa8a7878fd61770();
    return isPremium;
};

});
parcelRegister("fTdDx", function(module, exports) {
$parcel$export(module.exports, "useLoadEditionMeta", () => $d03be57e209d1b54$export$8119112215805711);
$parcel$export(module.exports, "useIsEditionMetaLoading", () => $d03be57e209d1b54$export$cbbfe499fe6b5f2e);
$parcel$export(module.exports, "useIsEnterpriseEdition", () => $d03be57e209d1b54$export$e03262ab59c85d02);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $03ij3 = parcelRequire("03ij3");

var $1eJCD = parcelRequire("1eJCD");
const $d03be57e209d1b54$var$initialState = {
    editionMeta: (0, $03ij3.asyncValues).idle()
};
const $d03be57e209d1b54$var$actions = {
    loadEditionMeta: $1eJCD.loadEditionMeta
};
const $d03be57e209d1b54$export$fe446f49c1c8e2e = (0, $5QDqc.createStore)({
    initialState: $d03be57e209d1b54$var$initialState,
    actions: $d03be57e209d1b54$var$actions,
    name: 'PolarisEntitlementStore'
});
const $d03be57e209d1b54$var$useEntitlementStoreActions = (0, $3h1FP.createActionsHook)($d03be57e209d1b54$export$fe446f49c1c8e2e);
const $d03be57e209d1b54$export$8119112215805711 = ()=>{
    const storeActions = $d03be57e209d1b54$var$useEntitlementStoreActions();
    return storeActions.loadEditionMeta;
};
const $d03be57e209d1b54$export$cbbfe499fe6b5f2e = (0, $3h1FP.createStateHook)($d03be57e209d1b54$export$fe446f49c1c8e2e, {
    selector: (state)=>state.editionMeta.status === 'idle' || state.editionMeta.status === 'loading'
});
const $d03be57e209d1b54$export$e03262ab59c85d02 = (0, $3h1FP.createStateHook)($d03be57e209d1b54$export$fe446f49c1c8e2e, {
    selector: (state)=>state.editionMeta.status === 'loaded' && state.editionMeta.value === 'enterprise'
});

});
parcelRegister("03ij3", function(module, exports) {
$parcel$export(module.exports, "asyncValues", () => $f321ab8e66d37beb$export$fb83ab75bba707aa);
/* eslint-disable jira/filename-case */ const $f321ab8e66d37beb$var$asyncStatuses = {
    idle: 'idle',
    loading: 'loading',
    loaded: 'loaded',
    failed: 'failed'
};
const $f321ab8e66d37beb$export$fb83ab75bba707aa = {
    idle: ()=>({
            status: $f321ab8e66d37beb$var$asyncStatuses.idle
        }),
    loading: ()=>({
            status: $f321ab8e66d37beb$var$asyncStatuses.loading
        }),
    loaded: (value)=>({
            status: $f321ab8e66d37beb$var$asyncStatuses.loaded,
            value: value
        }),
    failed: (error)=>({
            status: $f321ab8e66d37beb$var$asyncStatuses.failed,
            error: error
        })
};

});

parcelRegister("1eJCD", function(module, exports) {
$parcel$export(module.exports, "loadEditionMeta", () => $4f9ec0a9feab3690$export$78c38838d239f422);

var $hFtK7 = parcelRequire("hFtK7");

var $ifsAO = parcelRequire("ifsAO");

var $i860n = parcelRequire("i860n");

var $fIaIz = parcelRequire("fIaIz");

var $03ij3 = parcelRequire("03ij3");
const $4f9ec0a9feab3690$export$78c38838d239f422 = ({ shouldLoad: shouldLoad, onLoadingFailed: onLoadingFailed })=>async ({ getState: getState, setState: setState })=>{
        if (!(0, $i860n.fg)('jpd_enterprise_edition_support')) return;
        if (!shouldLoad) {
            // We don't need to load the edition meta
            // but at the same time we want to set the state to loaded
            setState({
                editionMeta: (0, $03ij3.asyncValues).loaded(undefined)
            });
            return;
        }
        if (getState().editionMeta.status === 'loading' || getState().editionMeta.status === 'loaded') return;
        setState({
            editionMeta: (0, $03ij3.asyncValues).loading()
        });
        return (0, $fIaIz.getEditionMeta)().then((response)=>{
            setState({
                editionMeta: (0, $03ij3.asyncValues).loaded(response.edition)
            });
        }).catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('getEditionMeta failure', error));
            onLoadingFailed(error);
            setState({
                editionMeta: (0, $03ij3.asyncValues).failed(error)
            });
        });
    };

});
parcelRegister("ifsAO", function(module, exports) {
$parcel$export(module.exports, "createErrorAnalytics", () => $bbe086a2044d8577$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $bbe086a2044d8577$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $bbe086a2044d8577$export$4e01d30cacaf82b8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $26fxr = parcelRequire("26fxr");

var $ah9qo = parcelRequire("ah9qo");

var $2EFuW = parcelRequire("2EFuW");

var $d0F9p = parcelRequire("d0F9p");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $fV62N = parcelRequire("fV62N");

var $l9N6c = parcelRequire("l9N6c");

var $f6qTB = parcelRequire("f6qTB");
const $bbe086a2044d8577$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.error-title",
    defaultMessage: "Something went wrong."
});
const $bbe086a2044d8577$var$permissionErrorDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.permission-error-description",
    defaultMessage: "You may not have the permissions required to perform this operation."
});
const $bbe086a2044d8577$var$configErrorTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.config-error-title",
    defaultMessage: "We couldn't save that."
});
const $bbe086a2044d8577$var$configErrorDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.config-error-description",
    defaultMessage: "This usually happens because the configuration data on this field is too big. Contact support for more details"
});
const $bbe086a2044d8577$var$serverLoadFailedDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.server-load-failed-description",
    defaultMessage: "We had difficulties to fetch some data from the server. Please refresh the page."
});
const $bbe086a2044d8577$var$serverUpdateFailedDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.server-update-failed-description",
    defaultMessage: "We had some difficulties to save some data to the server. Please try again or refresh the page."
});
const $bbe086a2044d8577$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.error-description",
    defaultMessage: "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
});
const $bbe086a2044d8577$var$errorPossibleAccessLoss = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.error-possible-access-loss",
    defaultMessage: "You may have lost access to the project or site. Please refresh the page."
});
const $bbe086a2044d8577$var$cyclicFormulaFieldDescription = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.cyclic-formula-field-description",
    defaultMessage: "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
});
const $bbe086a2044d8577$var$entityLimitErrorTitle = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error-title",
    defaultMessage: "You\u2019ve hit a limit"
});
const $bbe086a2044d8577$var$errorPossibleAccessLossGalaxia = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.error-possible-access-loss-galaxia",
    defaultMessage: "You may have lost access to the space or site. Please refresh the page."
});
const $bbe086a2044d8577$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $bbe086a2044d8577$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $f6qTB.getMetadata)(errorObject));
};
const $bbe086a2044d8577$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((errorObject, callback)=>{
        $bbe086a2044d8577$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$serverLoadFailedDescription)
        });
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $bbe086a2044d8577$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((errorObject, callback)=>{
        $bbe086a2044d8577$var$handleCallback(errorObject, callback);
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $fV62N.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $fV62N.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage($bbe086a2044d8577$var$entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>// we are using feature gate here, because tag's text type is different then lozenge's children type. we need to convert chunks to string when feature gate is on.
                        (0, $i860n.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d0F9p.default), {
                            text: chunks.map(String).join(''),
                            color: "standard",
                            isRemovable: false,
                            hasMargin: false,
                            migration_fallback: "lozenge"
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $f6qTB.isPermissionError)(errorObject)) return error({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$permissionErrorDescription)
        });
        if ((0, $f6qTB.isConfigError)(errorObject)) return error({
            title: formatMessage($bbe086a2044d8577$var$configErrorTitle),
            description: formatMessage($bbe086a2044d8577$var$configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $bbe086a2044d8577$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((errorObject, callback)=>{
        $bbe086a2044d8577$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$errorDescription)
        });
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $bbe086a2044d8577$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((errorObject, callback)=>{
        $bbe086a2044d8577$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage((0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $bbe086a2044d8577$var$errorPossibleAccessLossGalaxia : $bbe086a2044d8577$var$errorPossibleAccessLoss)
        });
        // Skip Sentry for PolarisAccessLossError since it's an expected business scenario
        // (e.g. 403 when user loses access to a view).
        const skipSentry = errorObject instanceof (0, $l9N6c.PolarisAccessLossError);
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject, {
            skipSentry: skipSentry
        }));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $bbe086a2044d8577$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $bbe086a2044d8577$var$usePossibleAccessLossError();
    const generalActionFailedError = $bbe086a2044d8577$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $bbe086a2044d8577$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $bbe086a2044d8577$var$useGeneralDataLoadingFailedHandling();
    return (0, $euxye.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $bbe086a2044d8577$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { error: error } = (0, $26fxr.useNotifications)();
    return (0, $euxye.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage($bbe086a2044d8577$var$errorTitle),
            description: formatMessage($bbe086a2044d8577$var$cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $hFtK7.fireErrorAnalytics)($bbe086a2044d8577$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("26fxr", function(module, exports) {
$parcel$export(module.exports, "useNotifications", () => $6c1ecbef9fb0a71d$export$53d5ca6c3f53e109);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7TA2J = parcelRequire("7TA2J");

var $8Qvei = parcelRequire("8Qvei");

var $ah9qo = parcelRequire("ah9qo");

var $bzpbb = parcelRequire("bzpbb");
var $aR9wy = parcelRequire("aR9wy");
var $acwzf = parcelRequire("acwzf");
var $iQPOZ = parcelRequire("iQPOZ");
const $6c1ecbef9fb0a71d$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $7TA2J.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // oxlint-disable-next-line typescript/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $6c1ecbef9fb0a71d$var$customFlag = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customFlagCommon(notification, onDismiss, (0, $aR9wy.default));
const $6c1ecbef9fb0a71d$var$customAutoDismissFlag = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customFlagCommon(notification, onDismiss, (0, $bzpbb.default));
const $6c1ecbef9fb0a71d$var$success = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $6c1ecbef9fb0a71d$var$errorWithRefresh = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $6c1ecbef9fb0a71d$var$error = (notification, onDismiss)=>$6c1ecbef9fb0a71d$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $6c1ecbef9fb0a71d$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagsService)();
    return (0, $euxye.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($6c1ecbef9fb0a71d$var$customFlag(notification, dismissFlag));
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($6c1ecbef9fb0a71d$var$success(notification, dismissFlag));
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($6c1ecbef9fb0a71d$var$errorWithRefresh(notification, dismissFlag));
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($6c1ecbef9fb0a71d$var$error(notification, dismissFlag));
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $acwzf.toFlagId)((0, $7TA2J.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $acwzf.toFlagId)((0, $7TA2J.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // oxlint-disable-next-line typescript/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("bzpbb", function(module, exports) {
$parcel$export(module.exports, "default", () => $559b3c736f67ed77$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bafqJ = parcelRequire("bafqJ");

var $3mYdc = parcelRequire("3mYdc");
const $559b3c736f67ed77$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
$559b3c736f67ed77$var$AkAutoDismissFlag.displayName = "AkAutoDismissFlag";
var $559b3c736f67ed77$export$2e2bcd8739ae039 = $559b3c736f67ed77$var$AkAutoDismissFlag;

});

parcelRegister("aR9wy", function(module, exports) {
$parcel$export(module.exports, "default", () => $02a3de1e09014466$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bafqJ = parcelRequire("bafqJ");

var $3mYdc = parcelRequire("3mYdc");
const $02a3de1e09014466$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.CommonFlag), {
        flagType: "info",
        ...props
    }));
$02a3de1e09014466$var$AkFlag.displayName = "AkFlag";
var $02a3de1e09014466$export$2e2bcd8739ae039 = $02a3de1e09014466$var$AkFlag;

});


parcelRegister("fV62N", function(module, exports) {
$parcel$export(module.exports, "EntityLimitError", () => $37df1b32c58e21b8$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $37df1b32c58e21b8$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $37df1b32c58e21b8$export$cf58cbb2768ea4f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Tm5Y = parcelRequire("6Tm5Y");

var $65397 = parcelRequire("65397");

var $2KgJI = parcelRequire("2KgJI");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");

var $7TWAO = parcelRequire("7TWAO");
const $37df1b32c58e21b8$var$commentsPerViewMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
    defaultMessage: "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
});
const $37df1b32c58e21b8$var$fieldsPerViewMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
    defaultMessage: "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
});
const $37df1b32c58e21b8$var$fieldsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
});
const $37df1b32c58e21b8$var$insightsPerIdeaMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
    defaultMessage: "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
});
const $37df1b32c58e21b8$var$insightsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
});
const $37df1b32c58e21b8$var$labelsPerSnippetMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
    defaultMessage: "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
});
const $37df1b32c58e21b8$var$optionsPerFieldMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
    defaultMessage: "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
});
const $37df1b32c58e21b8$var$playContributionsPerPlayMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
    defaultMessage: "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
});
const $37df1b32c58e21b8$var$playContributionsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
});
const $37df1b32c58e21b8$var$playsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
});
const $37df1b32c58e21b8$var$snippetsPerInsightMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
    defaultMessage: "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
});
const $37df1b32c58e21b8$var$viewsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
});
const $37df1b32c58e21b8$var$viewsPerCollectionMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.views-per-collection",
    defaultMessage: "We couldn\u2019t create a new <item>view</item> because this <item>roadmap</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
});
const $37df1b32c58e21b8$var$viewsetsPerProjectMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
    defaultMessage: "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
});
const $37df1b32c58e21b8$var$viewsetsPerCollectionMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-collection",
    defaultMessage: "We couldn\u2019t create a new <item>section</item> because this <item>roadmap</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
});
const $37df1b32c58e21b8$var$viewsetsPerProjectGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project-galaxia",
    defaultMessage: "We couldn\u2019t create a new <item>section</item> because this <item>space</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
});
const $37df1b32c58e21b8$var$messages = {
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: $37df1b32c58e21b8$var$commentsPerViewMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: $37df1b32c58e21b8$var$fieldsPerViewMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: $37df1b32c58e21b8$var$fieldsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: $37df1b32c58e21b8$var$insightsPerIdeaMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: $37df1b32c58e21b8$var$insightsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: $37df1b32c58e21b8$var$labelsPerSnippetMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: $37df1b32c58e21b8$var$optionsPerFieldMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: $37df1b32c58e21b8$var$playContributionsPerPlayMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: $37df1b32c58e21b8$var$playContributionsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: $37df1b32c58e21b8$var$playsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: $37df1b32c58e21b8$var$snippetsPerInsightMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: $37df1b32c58e21b8$var$viewsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_COLLECTION]: $37df1b32c58e21b8$var$viewsPerCollectionMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: $37df1b32c58e21b8$var$viewsetsPerProjectMessage,
    [(0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_COLLECTION]: $37df1b32c58e21b8$var$viewsetsPerCollectionMessage,
    viewsetsPerProjectGalaxia: $37df1b32c58e21b8$var$viewsetsPerProjectGalaxiaMessage
};
class $37df1b32c58e21b8$export$c4e01b2c2ba95919 extends (0, $2KgJI.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
$37df1b32c58e21b8$export$c4e01b2c2ba95919.displayName = "EntityLimitError";
const $37df1b32c58e21b8$var$findEntityLimitError = (graphQLErrors)=>{
    const entityLimitError = graphQLErrors.filter((err)=>err.extensions?.limitType)[0];
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    if (!limitType) return null;
    const entityLimitErrorType = (0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $37df1b32c58e21b8$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $37df1b32c58e21b8$export$13f6f9a6b905ebbd = (error)=>{
    if (error instanceof $37df1b32c58e21b8$export$c4e01b2c2ba95919) return error;
    return error instanceof (0, $65397.RelayNetworkError) || error instanceof (0, $6Tm5Y.GraphQLResponseError) ? $37df1b32c58e21b8$var$findEntityLimitError(error.graphQLErrors) : null;
};
const $37df1b32c58e21b8$export$cf58cbb2768ea4f = (error)=>{
    if (error.type === (0, $7TWAO.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT && (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false)) return $37df1b32c58e21b8$var$messages[`${error.type}Galaxia`];
    return $37df1b32c58e21b8$var$messages[error.type] || null;
};

});
parcelRegister("6Tm5Y", function(module, exports) {
$parcel$export(module.exports, "GraphQLResponseError", () => $4fd845211c7cfcf5$export$e79568ed5ed78a3);
class $4fd845211c7cfcf5$export$e79568ed5ed78a3 extends Error {
    constructor(message, graphQLErrors){
        super(message);
        this.name = 'GraphQLResponseError';
        this.graphQLErrors = graphQLErrors;
    }
}
$4fd845211c7cfcf5$export$e79568ed5ed78a3.displayName = "GraphQLResponseError";

});

parcelRegister("65397", function(module, exports) {
$parcel$export(module.exports, "RelayNetworkError", () => $a65a76d15dc0438a$export$e13695f8013e7a53);
$parcel$export(module.exports, "createRelayNetworkError", () => $a65a76d15dc0438a$export$92f5ce6ff48e5a7b);
class $a65a76d15dc0438a$export$e13695f8013e7a53 extends Error {
    constructor(error){
        super(error.message), this.type = 'network', this.graphQLErrors = [];
        this.name = 'NetworkError';
        this.originalError = error;
        this.networkError = error;
        this.statusCode = 'statusCode' in error && typeof error.statusCode === 'number' ? error.statusCode : undefined;
    }
}
$a65a76d15dc0438a$export$e13695f8013e7a53.displayName = "RelayNetworkError";
const $a65a76d15dc0438a$export$92f5ce6ff48e5a7b = (error)=>new $a65a76d15dc0438a$export$e13695f8013e7a53(error);

});

parcelRegister("7TWAO", function(module, exports) {
$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $c20076fc63673537$export$a197d88688faa32c);
/* eslint-disable jira/filename-case */ const $c20076fc63673537$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWS_PER_COLLECTION: 'viewsPerCollection',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject',
    VIEWSETS_PER_COLLECTION: 'viewsetsPerCollection'
};

});


parcelRegister("l9N6c", function(module, exports) {
$parcel$export(module.exports, "PolarisAccessLossError", () => $0b62b55e266078bb$export$53d8cc65d6486762);

var $2KgJI = parcelRequire("2KgJI");
class $0b62b55e266078bb$export$53d8cc65d6486762 extends (0, $2KgJI.default) {
    constructor(...args){
        super(...args), this.name = 'PolarisAccessLossError';
    }
}
$0b62b55e266078bb$export$53d8cc65d6486762.displayName = "PolarisAccessLossError";

});

parcelRegister("f6qTB", function(module, exports) {
$parcel$export(module.exports, "isPermissionError", () => $65e957623186e840$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $65e957623186e840$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $65e957623186e840$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $65e957623186e840$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isBadRequestError", () => $65e957623186e840$export$cb878a62cae2cb6);
$parcel$export(module.exports, "isClientClosedError", () => $65e957623186e840$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $65e957623186e840$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConflictError", () => $65e957623186e840$export$b43c7b888ac6458);
$parcel$export(module.exports, "isConfigError", () => $65e957623186e840$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $65e957623186e840$export$8548546c0aa631e6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Tcej = parcelRequire("6Tcej");

var $jOlpf = parcelRequire("jOlpf");

var $gznU1 = parcelRequire("gznU1");
const $65e957623186e840$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($jOlpf)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($gznU1)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return(// that's probably obsolete
        // that's probably obsolete
        error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || safeMessage.includes('status code 403'));
    });
    return false;
};
const $65e957623186e840$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $65e957623186e840$export$a8908c3867f6f20b = (errorObject)=>{
    return $65e957623186e840$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $65e957623186e840$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$65e957623186e840$var$checkRateLimitErrorMatch(error)) || false;
};
const $65e957623186e840$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $65e957623186e840$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $65e957623186e840$export$cb878a62cae2cb6 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 400;
    return false;
};
const $65e957623186e840$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $65e957623186e840$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $65e957623186e840$export$b43c7b888ac6458 = (errorObject)=>errorObject.statusCode === 409;
const $65e957623186e840$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $65e957623186e840$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});
parcelRegister("gznU1", function(module, exports) {

var $crqhp = parcelRequire("crqhp");

var $9JUaE = parcelRequire("9JUaE");

var $4N94P = parcelRequire("4N94P");

var $jOlpf = parcelRequire("jOlpf");

var $4qbYM = parcelRequire("4qbYM");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $c10274c993e2d0d6$var$some(collection, predicate, guard) {
    var func = $jOlpf(collection) ? $crqhp : $4N94P;
    if (guard && $4qbYM(collection, predicate, guard)) predicate = undefined;
    return func(collection, $9JUaE(predicate, 3));
}
module.exports = $c10274c993e2d0d6$var$some;

});
parcelRegister("4N94P", function(module, exports) {

var $73ZOi = parcelRequire("73ZOi");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $37d2c77eb2ade812$var$baseSome(collection, predicate) {
    var result;
    $73ZOi(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $37d2c77eb2ade812$var$baseSome;

});




parcelRegister("fIaIz", function(module, exports) {
$parcel$export(module.exports, "getEditionMeta", () => $f8bc5c845c8e0234$export$14a724b9d67e77ce);

var $4fhEY = parcelRequire("4fhEY");
const $f8bc5c845c8e0234$export$14a724b9d67e77ce = ()=>(0, $4fhEY.default)('/rest/polaris/edition?operation=getEditionMeta');

});




parcelRegister("5xenJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("facKN")
]).then(()=>parcelRequire('6sbRN'));

});



parcelRegister("92Eq3", function(module, exports) {
$parcel$export(module.exports, "polarisIdeasRouteEntry", () => $3e637d7db6c1dcd2$export$26631f98f007b2d2);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $1MMnM = parcelRequire("1MMnM");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $fo04M = parcelRequire("fo04M");

var $kSYG3 = parcelRequire("kSYG3");
const $3e637d7db6c1dcd2$export$26631f98f007b2d2 = (0, $fdS54.createEntry)((0, $fo04M.polarisIdeasRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.project',
        layout: (0, $1MMnM.polarisProjectLayout),
        canTransitionIn: ()=>true,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint () {
            return 0, $kSYG3.ideasPageEntryPoint;
        },
        preloadOptions: {
            earlyChunks: [
                'jpd-ideas-early-entry'
            ]
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1MMnM", function(module, exports) {
$parcel$export(module.exports, "polarisProjectLayout", () => $c52746408f38b795$export$d5273c1a2e2fe212);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lVzKq = parcelRequire("lVzKq");

var $QhQu4 = parcelRequire("QhQu4");
const $c52746408f38b795$export$d5273c1a2e2fe212 = (0, $QhQu4.composeLayouts)((0, $lVzKq.projectLayout));

});

parcelRegister("fo04M", function(module, exports) {
$parcel$export(module.exports, "polarisIdeasRoute", () => $0f62cd7576cfb39b$export$54c333cd4ed2d70e);
const $0f62cd7576cfb39b$export$54c333cd4ed2d70e = {
    name: 'polaris-ideas',
    path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
    query: [
        'selectedIssue?',
        'issueViewLayout?',
        'jpdWrapped?'
    ],
    exact: true
};

});

parcelRegister("kSYG3", function(module, exports) {
$parcel$export(module.exports, "ideasPageEntryPoint", () => $cfe32460ed0f7a4f$export$aa9a00411f9c3e39);
/* eslint-disable jira/naming/disallow-filenames */ 
var $h3f0K = parcelRequire("h3f0K");

var $dTa0V = parcelRequire("dTa0V");
const $cfe32460ed0f7a4f$export$aa9a00411f9c3e39 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $h3f0K.ideasEntryPoint)
});

});
parcelRegister("h3f0K", function(module, exports) {
$parcel$export(module.exports, "ideasEntryPoint", () => $929d2c7e04fb6b20$export$ffc470fa0659ba16);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $929d2c7e04fb6b20$export$ffc470fa0659ba16 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("9clII")), {
        moduleId: "fda38dfd",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9clII", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("cGQke")
]).then(()=>parcelRequire('21TCZ'));

});




parcelRegister("3GJk3", function(module, exports) {
$parcel$export(module.exports, "polarisOnboardingRouteEntry", () => $7b362433289b0054$export$a297a71cb150e2af);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $aucfV = parcelRequire("aucfV");

var $eH76E = parcelRequire("eH76E");

var $8Rwih = parcelRequire("8Rwih");
const $7b362433289b0054$export$a297a71cb150e2af = (0, $fdS54.createEntry)((0, $eH76E.polarisOnboardingRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8Rwih.default),
        layout: (0, $h2tgz.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $aucfV.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8Rwih.LazyOnboardingPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aucfV", function(module, exports) {
$parcel$export(module.exports, "projectCreatePermissionsResource", () => $b9b8107b54e23198$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $b9b8107b54e23198$export$2bd0d3b374549a68);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $b9b8107b54e23198$var$RESOURCE_TYPE_PROJECT_PERMISSIONS = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

const $b9b8107b54e23198$export$f6c05eaea53ab4ae = (0, $7edbf.createResource)({
    type: $b9b8107b54e23198$var$RESOURCE_TYPE_PROJECT_PERMISSIONS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("8ISjJ")),
    maxAge: Infinity
});
const $b9b8107b54e23198$export$2bd0d3b374549a68 = ()=>(0, $k6ufm.useResource)($b9b8107b54e23198$export$f6c05eaea53ab4ae);

});
parcelRegister("8ISjJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("42K4W").then(()=>parcelRequire('c5jgh'));

});


parcelRegister("eH76E", function(module, exports) {
$parcel$export(module.exports, "polarisOnboardingRoute", () => $f1d4a372391312b7$export$6696e9deb45fe980);
const $f1d4a372391312b7$export$6696e9deb45fe980 = {
    name: 'polaris-onboarding',
    path: '/welcome/discovery',
    exact: true
};

});

parcelRegister("8Rwih", function(module, exports) {
$parcel$export(module.exports, "LazyOnboardingPage", () => $0bb30cf3d3454512$export$13889cc3ce0d5a93);
$parcel$export(module.exports, "default", () => $0bb30cf3d3454512$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0bb30cf3d3454512$export$13889cc3ce0d5a93 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("cMRn1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris-onboarding/src/index.tsx"
});
const $0bb30cf3d3454512$var$AsyncOnboardingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0bb30cf3d3454512$export$13889cc3ce0d5a93,
        pageId: "async-polaris-onboarding",
        shouldShowSpinner: false
    });
$0bb30cf3d3454512$var$AsyncOnboardingPage.displayName = "AsyncOnboardingPage";
var $0bb30cf3d3454512$export$2e2bcd8739ae039 = $0bb30cf3d3454512$var$AsyncOnboardingPage;

});
parcelRegister("cMRn1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("24wIZ")
]).then(()=>parcelRequire('bnyOU'));

});



parcelRegister("6k2Ti", function(module, exports) {
$parcel$export(module.exports, "polarisProjectSettingsPoliciesRouteEntry", () => $794ea788dfd7021b$export$6878a03c3c1a62b1);


var $k5Kh0 = parcelRequire("k5Kh0");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $i860n = parcelRequire("i860n");

var $1MMnM = parcelRequire("1MMnM");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $iSoIx = parcelRequire("iSoIx");

var $4GHfX = parcelRequire("4GHfX");

const $794ea788dfd7021b$var$projectSettingsSpacePoliciesPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $k5Kh0.projectSettingsSpacePoliciesEntryPoint)
});
const $794ea788dfd7021b$export$6878a03c3c1a62b1 = (0, $fdS54.createEntry)((0, $4GHfX.polarisProjectSettingsPoliciesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'project-settings.space-policies.jpd',
        layout: (0, $1MMnM.polarisProjectLayout),
        canTransitionIn: ()=>true,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('frontier-guided-autonomy-space-settings') ? $794ea788dfd7021b$var$projectSettingsSpacePoliciesPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("k5Kh0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSpacePoliciesEntryPoint", () => $753da567c2b7c94e$export$9dfdd6851a21d57a);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $hge9Q = parcelRequire("hge9Q");

const $753da567c2b7c94e$export$9dfdd6851a21d57a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("htuTP")), {
        moduleId: "6e199ed2",
        moduleName: "ProjectSettingsSpacePolicies",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = match.params.projectKey;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            extraProps: {
                projectKey: projectKey
            },
            queries: {
                projectSettingsSpacePoliciesQuery: {
                    parameters: (0, $hge9Q.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("hge9Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e0a3b2660e3e581$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac4aabcb2bde9eaf65d4e508aa433274>>
 * @relayHash e57a61bd41f5479e6556490d2ea7d14e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7b0e3122dec1298ceb76433ce5fbd3e4430a478ea7d4b6fb261c805d14a348a
const $0e0a3b2660e3e581$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectSettingsSpacePoliciesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectPolicyAssociationConnection",
                                    "kind": "LinkedField",
                                    "name": "policyAssociations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectPolicyAssociation",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPolicy",
                                                    "kind": "LinkedField",
                                                    "name": "policy",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "args": v2 /*: any*/ ,
                                                            "concreteType": "JiraProjectPolicyRuleConnection",
                                                            "kind": "LinkedField",
                                                            "name": "rules",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProjectPolicyRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraProjectPolicyRuleType",
                                                                            "kind": "LinkedField",
                                                                            "name": "ruleType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "rules(first:50)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "policyAssociations(first:50)"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectSettingsSpacePoliciesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectPolicyAssociationConnection",
                                    "kind": "LinkedField",
                                    "name": "policyAssociations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectPolicyAssociation",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPolicy",
                                                    "kind": "LinkedField",
                                                    "name": "policy",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "args": v2 /*: any*/ ,
                                                            "concreteType": "JiraProjectPolicyRuleConnection",
                                                            "kind": "LinkedField",
                                                            "name": "rules",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProjectPolicyRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraProjectPolicyRuleType",
                                                                            "kind": "LinkedField",
                                                                            "name": "ruleType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "rules(first:50)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "policyAssociations(first:50)"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c7b0e3122dec1298ceb76433ce5fbd3e4430a478ea7d4b6fb261c805d14a348a",
            "metadata": {},
            "name": "ProjectSettingsSpacePoliciesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0e0a3b2660e3e581$var$node.hash = "7d8a8a5051e63049bcbc199547b4a855";
var $0e0a3b2660e3e581$export$2e2bcd8739ae039 = $0e0a3b2660e3e581$var$node;

});

parcelRegister("htuTP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("54qcZ").then(()=>parcelRequire('lYuYY'));

});


parcelRegister("4GHfX", function(module, exports) {
$parcel$export(module.exports, "polarisProjectSettingsPoliciesRoute", () => $72c3e96b5eb0c931$export$c06265289e41d7e4);
const $72c3e96b5eb0c931$export$c06265289e41d7e4 = {
    name: 'polaris-project-settings-policies',
    path: '/jira/polaris/projects/:projectKey/ideas/settings/policies',
    exact: true
};

});


parcelRegister("7yRej", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsAccessRouteEntry", () => $17d477b2198c7a93$export$9c0f51630c25c3d);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $1qXwi = parcelRequire("1qXwi");

var $e8xfr = parcelRequire("e8xfr");
const $17d477b2198c7a93$export$9c0f51630c25c3d = (0, $fdS54.createEntry)((0, $1qXwi.polarisSettingsAccessRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $e8xfr.AccessSettingsPage),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $e8xfr.LazyAccessSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1qXwi", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsAccessRoute", () => $ab416376353cb40c$export$bfdcdf76e802d67d);
const $ab416376353cb40c$export$bfdcdf76e802d67d = {
    name: 'polaris-settings-access',
    path: '/jira/settings/products/jira-product-discovery/access',
    exact: true
};

});

parcelRegister("e8xfr", function(module, exports) {
$parcel$export(module.exports, "LazyAccessSettingsPage", () => $6c08313161b3668a$export$b66ea0dcd38af7f0);
$parcel$export(module.exports, "AccessSettingsPage", () => $6c08313161b3668a$export$d46497fe68b0853c);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6c08313161b3668a$export$b66ea0dcd38af7f0 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("15tHT"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris-settings-access/src/index.tsx"
});
const $6c08313161b3668a$export$d46497fe68b0853c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6c08313161b3668a$export$b66ea0dcd38af7f0,
        pageId: "async-polaris-settings-access",
        shouldShowSpinner: false
    });
$6c08313161b3668a$export$d46497fe68b0853c.displayName = "AccessSettingsPage";

});
parcelRegister("15tHT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a7lqb").then(()=>parcelRequire('7w2ne'));

});



parcelRegister("gDjnr", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsDatesRouteEntry", () => $3e06fcba6bff39fa$export$df39bbcec5c3d8fb);
/* eslint-disable import/order */ 


var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $jRczb = parcelRequire("jRczb");

var $7eeH1 = parcelRequire("7eeH1");
const $3e06fcba6bff39fa$export$df39bbcec5c3d8fb = (0, $fdS54.createEntry)((0, $jRczb.polarisSettingsDatesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $7eeH1.polarisProductDatesSettingsPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jRczb", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsDatesRoute", () => $8c62868dc8d516fa$export$41bd51b740ebfe25);
const $8c62868dc8d516fa$export$41bd51b740ebfe25 = {
    name: 'polaris-settings-dates',
    path: '/jira/settings/products/jira-product-discovery/dates',
    exact: true
};

});

parcelRegister("7eeH1", function(module, exports) {
$parcel$export(module.exports, "polarisProductDatesSettingsPageEntryPoint", () => $6f19a2a628eec90f$export$f7149e13a0f26e72);
/* eslint-disable jira/naming/disallow-filenames */ 
var $8VQ6g = parcelRequire("8VQ6g");

var $dTa0V = parcelRequire("dTa0V");
const $6f19a2a628eec90f$export$f7149e13a0f26e72 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8VQ6g.polarisProductDatesSettingsEntryPoint)
});

});
parcelRegister("8VQ6g", function(module, exports) {
$parcel$export(module.exports, "polarisProductDatesSettingsEntryPoint", () => $509ff7900237fc40$export$12b2ffa315a7a5d8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $509ff7900237fc40$export$12b2ffa315a7a5d8 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1fs6G")), {
        moduleId: "793f6696",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1fs6G", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lSsL9").then(()=>parcelRequire('Ms5zv'));

});




parcelRegister("giPrt", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRouteEntry", () => $7f733cfb25d389f0$export$986710683a071056);
/* eslint-disable import/order */ 


var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $kSC4j = parcelRequire("kSC4j");

var $9HZ8U = parcelRequire("9HZ8U");
const $7f733cfb25d389f0$export$986710683a071056 = (0, $fdS54.createEntry)((0, $kSC4j.polarisSettingsEarlyAccessFeaturesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $9HZ8U.polarisProductEAPSettingsPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kSC4j", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRoute", () => $d1822823c619fa4b$export$19bd38107b2ac64b);
const $d1822823c619fa4b$export$19bd38107b2ac64b = {
    name: 'polaris-settings-early-access-features',
    path: '/jira/settings/products/jira-product-discovery/early-access-features',
    exact: true
};

});

parcelRegister("9HZ8U", function(module, exports) {
$parcel$export(module.exports, "polarisProductEAPSettingsPageEntryPoint", () => $a5b9adf63d6b8bfa$export$1bd9d2b1f32dc9ee);
/* eslint-disable jira/naming/disallow-filenames */ 
var $2MQTE = parcelRequire("2MQTE");

var $dTa0V = parcelRequire("dTa0V");
const $a5b9adf63d6b8bfa$export$1bd9d2b1f32dc9ee = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2MQTE.polarisProductEAPSettingsEntryPoint)
});

});
parcelRegister("2MQTE", function(module, exports) {
$parcel$export(module.exports, "polarisProductEAPSettingsEntryPoint", () => $ae5723b4f8d75301$export$92df711874ab564a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ae5723b4f8d75301$export$92df711874ab564a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gjL34")), {
        moduleId: "ad50e63d",
        moduleName: "PolarisEarlyAccessFeaturesSettingsPageDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gjL34", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aRFdC").then(()=>parcelRequire('4R3pJ'));

});




parcelRegister("iEsMS", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsGlobalFieldsRouteEntry", () => $98a181ee4f8c6847$export$e29465c661741392);
/* eslint-disable import/order */ 


var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $55ckf = parcelRequire("55ckf");

var $5HqnN = parcelRequire("5HqnN");
const $98a181ee4f8c6847$export$e29465c661741392 = (0, $fdS54.createEntry)((0, $55ckf.polarisSettingsGlobalFieldsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $5HqnN.polarisProductGlobalFieldsSettingsPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("55ckf", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsGlobalFieldsRoute", () => $07758a8982204464$export$d1d77b6a84982ab8);
const $07758a8982204464$export$d1d77b6a84982ab8 = {
    name: 'polaris-settings-global-fields',
    path: '/jira/settings/products/jira-product-discovery/global-fields',
    exact: true
};

});

parcelRegister("5HqnN", function(module, exports) {
$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsPageEntryPoint", () => $3b43f5f59928c266$export$c682ebcd2290352f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $9FhGz = parcelRequire("9FhGz");

var $dTa0V = parcelRequire("dTa0V");
const $3b43f5f59928c266$export$c682ebcd2290352f = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9FhGz.polarisProductGlobalFieldsSettingsEntryPoint)
});

});
parcelRegister("9FhGz", function(module, exports) {
$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsEntryPoint", () => $953fa04035a1929a$export$f2f24531058bc251);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $953fa04035a1929a$export$f2f24531058bc251 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jXlBZ")), {
        moduleId: "e96594bb",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jXlBZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2b051").then(()=>parcelRequire('aAsKA'));

});




parcelRegister("lGgL6", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsGlobalViewsDetailsRouteEntry", () => $d6f4d502c13f2d8d$export$cc38d028b8a81d13);



var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $5ONgF = parcelRequire("5ONgF");

var $96ccJ = parcelRequire("96ccJ");
const $d6f4d502c13f2d8d$export$cc38d028b8a81d13 = (0, $fdS54.createEntry)((0, $5ONgF.polarisSettingsGlobalViewsDetailsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $96ccJ.polarisGlobalViewsSettingsDetailPageEntry;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5ONgF", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsGlobalViewsDetailsRoute", () => $c3d4f0f9c54e1e64$export$a851538eea1b38a7);
const $c3d4f0f9c54e1e64$export$a851538eea1b38a7 = {
    name: 'polaris-settings-global-views-details',
    path: '/jira/settings/products/jira-product-discovery/global-views/:viewId',
    exact: true
};

});

parcelRegister("96ccJ", function(module, exports) {
$parcel$export(module.exports, "polarisGlobalViewsSettingsDetailPageEntry", () => $60f1ac65238264dd$export$bcb9594e5cd4f71c);

var $fA0e1 = parcelRequire("fA0e1");

var $dTa0V = parcelRequire("dTa0V");
const $60f1ac65238264dd$export$bcb9594e5cd4f71c = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fA0e1.polarisProductGlobalViewsSettingsDetailsEntryPoint)
});

});
parcelRegister("fA0e1", function(module, exports) {
$parcel$export(module.exports, "polarisProductGlobalViewsSettingsDetailsEntryPoint", () => $2528ce73ddaf5289$export$e8ca9d0d947ba555);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $exNjJ = parcelRequire("exNjJ");

var $9v01h = parcelRequire("9v01h");

const $2528ce73ddaf5289$export$e8ca9d0d947ba555 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("5JbGC")), {
        moduleId: "d02333b7",
        moduleName: "PolarisGlobalViewsSettingsDetailsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const globalViewId = context.match.params.viewId;
        if (!globalViewId) // For TS safety. This won't really happen since the viewId is required in the route.
        throw new Error('Global view ID is required');
        return {
            queries: {
                globalViewsSettingsDetailsQuery: {
                    options: {
                        // let's restore store-or-network with https://pi-dev-sandbox.atlassian.net/browse/POL-21943
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9v01h.default,
                    variables: {
                        id: (0, $exNjJ.JiraProductDiscoveryGlobalViewAri).create({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            globalViewId: globalViewId
                        }).toString()
                    }
                }
            },
            extraProps: {
                globalViewId: globalViewId
            }
        };
    }
});

});
parcelRegister("exNjJ", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryGlobalViewAri", () => $a96a67246d3e5649$export$379cf2b59a640757);

var $jKzz8 = parcelRequire("jKzz8");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira-product-discovery/global-view/manifest.ts
var $a96a67246d3e5649$var$jiraProductDiscoveryGlobalViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jKzz8.JiraProductDiscoveryGlobalViewAriResourceOwner),
    resourceType: (0, $jKzz8.JiraProductDiscoveryGlobalViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{globalViewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        globalViewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira-product-discovery/global-view/index.ts
var $a96a67246d3e5649$export$379cf2b59a640757 = class _JiraProductDiscoveryGlobalViewAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._globalViewId = opts.resourceIdSegmentValues.globalViewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get globalViewId() {
        return this._globalViewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a96a67246d3e5649$var$jiraProductDiscoveryGlobalViewAriStaticOpts.qualifier,
            platformQualifier: $a96a67246d3e5649$var$jiraProductDiscoveryGlobalViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a96a67246d3e5649$var$jiraProductDiscoveryGlobalViewAriStaticOpts.resourceOwner,
            resourceType: $a96a67246d3e5649$var$jiraProductDiscoveryGlobalViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.globalViewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                globalViewId: opts.globalViewId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $a96a67246d3e5649$var$jiraProductDiscoveryGlobalViewAriStaticOpts);
        return new _JiraProductDiscoveryGlobalViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $a96a67246d3e5649$var$jiraProductDiscoveryGlobalViewAriStaticOpts);
        return new _JiraProductDiscoveryGlobalViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            globalViewId: this.globalViewId
        };
    }
};

});
parcelRegister("jKzz8", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryGlobalViewAriResourceOwner", () => $e60de6d1dca398f0$export$576447f33a3db158);
$parcel$export(module.exports, "JiraProductDiscoveryGlobalViewAriResourceType", () => $e60de6d1dca398f0$export$8e754361372a5363);
// src/jira-product-discovery/global-view/types.ts
var $e60de6d1dca398f0$export$576447f33a3db158 = "jira-product-discovery", $e60de6d1dca398f0$export$8e754361372a5363 = "global-view";

});


parcelRegister("9v01h", function(module, exports) {
$parcel$export(module.exports, "default", () => $af1953bcfd4d3724$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8c3782378308159f31890130bd3af5d2>>
 * @relayHash ca17349a7ce38fafb8a98b0fd48c67be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa4bd6a2014828f5726238076216c6f4ed8db3bfcef1e6679c11b63b0a5efe8b
const $af1953bcfd4d3724$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fa4bd6a2014828f5726238076216c6f4ed8db3bfcef1e6679c11b63b0a5efe8b",
        "metadata": {},
        "name": "PolarisGlobalViewsSettingsDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $af1953bcfd4d3724$export$2e2bcd8739ae039 = $af1953bcfd4d3724$var$node;

});

parcelRegister("5JbGC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("cHbgI")
]).then(()=>parcelRequire('vnpKZ'));

});




parcelRegister("iZwgi", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsGlobalViewsListRouteEntry", () => $92ca724536c8672a$export$72869d56e506c23b);



var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $3OOzB = parcelRequire("3OOzB");

var $bFRHc = parcelRequire("bFRHc");
const $92ca724536c8672a$export$72869d56e506c23b = (0, $fdS54.createEntry)((0, $3OOzB.polarisSettingsGlobalViewsListRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $bFRHc.polarisGlobalViewsSettingsListPageEntry;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3OOzB", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsGlobalViewsListRoute", () => $2c7b06701fd17a2c$export$59273cdbc5ed11bb);
const $2c7b06701fd17a2c$export$59273cdbc5ed11bb = {
    name: 'polaris-settings-global-views-list',
    path: '/jira/settings/products/jira-product-discovery/global-views',
    exact: true
};

});

parcelRegister("bFRHc", function(module, exports) {
$parcel$export(module.exports, "polarisGlobalViewsSettingsListPageEntry", () => $e8c325624f1f5e67$export$b88f02b1e18884f4);

var $bDvmL = parcelRequire("bDvmL");

var $dTa0V = parcelRequire("dTa0V");
const $e8c325624f1f5e67$export$b88f02b1e18884f4 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bDvmL.polarisProductGlobalViewsSettingsListEntryPoint)
});

});
parcelRegister("bDvmL", function(module, exports) {
$parcel$export(module.exports, "polarisProductGlobalViewsSettingsListEntryPoint", () => $29543deaab4b77cb$export$b42cf67afcdf7af7);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $1pZFh = parcelRequire("1pZFh");

const $29543deaab4b77cb$export$b42cf67afcdf7af7 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("gULJt")), {
        moduleId: "80903f54",
        moduleName: "PolarisGlobalViewsSettingsListPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                globalViewsSettingsListQuery: {
                    options: {
                        // let's restore store-or-network with https://pi-dev-sandbox.atlassian.net/browse/POL-21943
                        fetchPolicy: 'network-only'
                    },
                    parameters: $1pZFh.default,
                    variables: {
                        cloudId: cloudId,
                        filter: {
                            containsText: ''
                        },
                        first: 50
                    }
                }
            }
        };
    }
});

});
parcelRegister("1pZFh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4eef72f34866c24$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<430cb4872fb23c9eadc43b49abe73d39>>
 * @relayHash 4d2418e9c9df72fed61f2d01e4d5b883
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3497617b2a9ab95e9ff662ecba81473084cda948b9dd74c1b2388909ad50a389
const $d4eef72f34866c24$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "3497617b2a9ab95e9ff662ecba81473084cda948b9dd74c1b2388909ad50a389",
        "metadata": {},
        "name": "PolarisGlobalViewsSettingsListPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d4eef72f34866c24$export$2e2bcd8739ae039 = $d4eef72f34866c24$var$node;

});

parcelRegister("gULJt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1dkfe").then(()=>parcelRequire('8Fupf'));

});




parcelRegister("br5Fp", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsViewBlueprintsRouteEntry", () => $e67d94dee42502cb$export$3a434d3b47ab1779);
/* eslint-disable import/order */ 


var $lFLfF = parcelRequire("lFLfF");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $i860n = parcelRequire("i860n");

var $dUAVJ = parcelRequire("dUAVJ");

var $eA4X8 = parcelRequire("eA4X8");

var $900Xu = parcelRequire("900Xu");
const $e67d94dee42502cb$export$3a434d3b47ab1779 = (0, $fdS54.createEntry)((0, $eA4X8.polarisSettingsViewBlueprintsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return (0, $i860n.fg)('jpd-view-templates-sample-project') ? (0, $900Xu.polarisProductViewBlueprintsSettingsPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eA4X8", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsViewBlueprintsRoute", () => $d717d634a338e727$export$8a86f742c99c33c);
const $d717d634a338e727$export$8a86f742c99c33c = {
    name: 'polaris-settings-view-blueprints',
    path: '/jira/settings/products/jira-product-discovery/view-blueprints',
    exact: true
};

});

parcelRegister("900Xu", function(module, exports) {
$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsPageEntryPoint", () => $1700593f3768e8cc$export$b38d612b8eddc59a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $5qdI1 = parcelRequire("5qdI1");

var $dTa0V = parcelRequire("dTa0V");
const $1700593f3768e8cc$export$b38d612b8eddc59a = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5qdI1.polarisProductViewBlueprintsSettingsEntryPoint)
});

});
parcelRegister("5qdI1", function(module, exports) {
$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsEntryPoint", () => $1cf7500bc8bc88e3$export$39c56d81a6a3e673);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $1cf7500bc8bc88e3$export$39c56d81a6a3e673 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dPlEO")), {
        moduleId: "92d950f6",
        moduleName: "PolarisViewBlueprintsSettingsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dPlEO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8qgr7").then(()=>parcelRequire('8RcNL'));

});




parcelRegister("cgIlc", function(module, exports) {
$parcel$export(module.exports, "polarisShareViewRouteEntry", () => $d5495f6a92c8175d$export$7aa82918a4d72bd2);
/* eslint-disable import/order */ 
var $fdS54 = parcelRequire("fdS54");

var $1XlZL = parcelRequire("1XlZL");

var $byMD7 = parcelRequire("byMD7");

var $4B518 = parcelRequire("4B518");

var $4CHKu = parcelRequire("4CHKu");
const $d5495f6a92c8175d$export$7aa82918a4d72bd2 = (0, $fdS54.createEntry)((0, $1XlZL.polarisShareViewRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.shared-view',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        entryPoint () {
            return 0, $4CHKu.polarisShareViewEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            cspOverride: {
                frameAncestors: '*'
            }
        }
    }));

});
parcelRegister("1XlZL", function(module, exports) {
$parcel$export(module.exports, "polarisShareViewRoute", () => $e4534f0bdb8dac49$export$69dd9f884db2d333);
const $e4534f0bdb8dac49$export$69dd9f884db2d333 = {
    name: 'polaris-share-view',
    path: '/jira/discovery/share/:section/:resource',
    query: [
        'selectedIssue?',
        'issueViewLayout?'
    ],
    exact: true
};

});

parcelRegister("4CHKu", function(module, exports) {
$parcel$export(module.exports, "polarisShareViewEntryPoint", () => $0c00c9d237aabfb4$export$1e2d39a039f0ef47);
/* eslint-disable jira/naming/disallow-filenames */ 
var $estGE = parcelRequire("estGE");

var $dTa0V = parcelRequire("dTa0V");
const $0c00c9d237aabfb4$export$1e2d39a039f0ef47 = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $estGE.shareViewEntryPoint)
});

});
parcelRegister("estGE", function(module, exports) {
$parcel$export(module.exports, "shareViewEntryPoint", () => $81409cd2447bd05a$export$f2166c48f5b2f3ab);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $81409cd2447bd05a$export$f2166c48f5b2f3ab = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8LtG1")), {
        moduleId: "f57494ad",
        moduleName: "PolarisShareViewPage",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8LtG1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("b8pQw")
]).then(()=>parcelRequire('iiWHp'));

});




parcelRegister("fVlxG", function(module, exports) {
$parcel$export(module.exports, "polarisUnlicensedRouteEntry", () => $8761be05c4ca663f$export$f975154b9b0ce777);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $aucfV = parcelRequire("aucfV");

var $5pjhO = parcelRequire("5pjhO");

var $dGnhl = parcelRequire("dGnhl");
const $8761be05c4ca663f$export$f975154b9b0ce777 = (0, $fdS54.createEntry)((0, $5pjhO.polarisUnlicensedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dGnhl.default),
        layout: (0, $h2tgz.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $aucfV.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dGnhl.LazyUnlicensedPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5pjhO", function(module, exports) {
$parcel$export(module.exports, "polarisUnlicensedRoute", () => $69d90cab73937f89$export$32b1bc71501d2751);
const $69d90cab73937f89$export$32b1bc71501d2751 = {
    name: 'polaris-unlicensed',
    path: '/jira/polaris/unlicensed',
    exact: true
};

});

parcelRegister("dGnhl", function(module, exports) {
$parcel$export(module.exports, "LazyUnlicensedPage", () => $ac8fe9fcd3327652$export$394984ca86b38b8f);
$parcel$export(module.exports, "default", () => $ac8fe9fcd3327652$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $ac8fe9fcd3327652$export$394984ca86b38b8f = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("kVtFW"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris-unlicensed/src/index.tsx"
});
const $ac8fe9fcd3327652$var$AsyncUnlicensedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ac8fe9fcd3327652$export$394984ca86b38b8f,
        pageId: "async-polaris-unlicensed",
        shouldShowSpinner: false
    });
$ac8fe9fcd3327652$var$AsyncUnlicensedPage.displayName = "AsyncUnlicensedPage";
var $ac8fe9fcd3327652$export$2e2bcd8739ae039 = $ac8fe9fcd3327652$var$AsyncUnlicensedPage;

});
parcelRegister("kVtFW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gppOC").then(()=>parcelRequire('iFqKk'));

});



parcelRegister("2rAKo", function(module, exports) {
$parcel$export(module.exports, "productsCsmChatRouteEntry", () => $6a5b34a9dcd6aeb5$export$5adab32cb8dae3c5);



var $7HZbw = parcelRequire("7HZbw");

var $lFLfF = parcelRequire("lFLfF");

var $dUAVJ = parcelRequire("dUAVJ");

var $36G19 = parcelRequire("36G19");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");
const $6a5b34a9dcd6aeb5$var$productsCsmChatEntryPointPage = (0, $dTa0V.createPageEntryPoint)({
    main: $7HZbw.productsCsmChatEntryPoint
});
const $6a5b34a9dcd6aeb5$export$5adab32cb8dae3c5 = (0, $fdS54.createEntry)((0, $36G19.productsCsmChatRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget') ? $6a5b34a9dcd6aeb5$var$productsCsmChatEntryPointPage : undefined;
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7HZbw", function(module, exports) {
$parcel$export(module.exports, "productsCsmChatEntryPoint", () => $3a8eade2c010586a$export$e81ca0721e02cbca);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $knt7g = parcelRequire("knt7g");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $3a8eade2c010586a$export$e81ca0721e02cbca = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hu1NN")), {
        moduleId: "03cb9b5f",
        moduleName: "ProductsCsmChat",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            queries: {
                conversationLimitFormQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $knt7g.default),
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("knt7g", function(module, exports) {
$parcel$export(module.exports, "default", () => $de6ab87aaf62d68c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dddf1addea36b1672602313bed58c783>>
 * @relayHash 4bf1f3fd011d732dbac3100c522f86a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4edd2f6ad25c6b03880c3575cc47b1de438954bbea7c0d7bb89e09ee1f6ae59

var $lIGkE = parcelRequire("lIGkE");
const $de6ab87aaf62d68c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "globalCapacity"
            }
        ],
        "type": "CustomerServiceLiveChatSettings"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConversationLimitFormQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "kind": "LinkedField",
                        "name": "csm_liveChatSettings",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ThrowOnQueryError"
                                    }
                                ],
                                "type": "QueryError"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConversationLimitFormQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csm_liveChatSettings",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "identifier"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c4edd2f6ad25c6b03880c3575cc47b1de438954bbea7c0d7bb89e09ee1f6ae59",
            "metadata": {},
            "name": "ConversationLimitFormQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$de6ab87aaf62d68c$var$node.hash = "0e6719d042c8d9ad274d07d83f062078";
(0, $lIGkE.PreloadableQueryRegistry).set($de6ab87aaf62d68c$var$node.params.id, $de6ab87aaf62d68c$var$node);
var $de6ab87aaf62d68c$export$2e2bcd8739ae039 = $de6ab87aaf62d68c$var$node;

});

parcelRegister("hu1NN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jcHwY").then(()=>parcelRequire('iMYzc'));

});


parcelRegister("36G19", function(module, exports) {
$parcel$export(module.exports, "productsCsmChatRoute", () => $7a2269ad3a368f4e$export$d4cbca5e5fdb1cfb);
const $7a2269ad3a368f4e$export$d4cbca5e5fdb1cfb = {
    name: 'products-csm-chat',
    path: '/jira/settings/products/customerservice/chat',
    exact: true
};

});


parcelRegister("3HyYd", function(module, exports) {
$parcel$export(module.exports, "productsJcsCustomerAccessRouteEntry", () => $0e16c772a112f08d$export$487fd1bbb9f3684e);

var $hKTw5 = parcelRequire("hKTw5");



var $fqc13 = parcelRequire("fqc13");

var $3g2jM = parcelRequire("3g2jM");

var $imXbM = parcelRequire("imXbM");

var $lFLfF = parcelRequire("lFLfF");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $jaikS = parcelRequire("jaikS");

var $8HUuJ = parcelRequire("8HUuJ");
const $0e16c772a112f08d$var$productsJcsCustomerAccessEntryPointPage = (0, $dTa0V.createPageEntryPoint)({
    main: $fqc13.productsJcsCustomerAccessEntryPoint
});
const $0e16c772a112f08d$export$487fd1bbb9f3684e = (0, $fdS54.createEntry)((0, $jaikS.productsJcsCustomerAccessRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint: ()=>$0e16c772a112f08d$var$productsJcsCustomerAccessEntryPointPage,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('csm_customer_access_jsm_separation'), (0, $3g2jM.jsmGlobalCustomerAccessAffectedProjectsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_customer_access_jsm_separation'), (0, $3g2jM.csmFilteredAffectedProjectsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('csm_customer_access_jsm_separation'), (0, $imXbM.jsmGlobalCustomerAccessSettingsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_customer_access_jsm_separation'), (0, $hKTw5.csmGlobalCustomerAccessSettingsResource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fqc13", function(module, exports) {
$parcel$export(module.exports, "productsJcsCustomerAccessEntryPoint", () => $28bf85ac823d27d1$export$a10305920ea7bd7);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $28bf85ac823d27d1$export$a10305920ea7bd7 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("f1WdY")), {
        moduleId: "1fee40a2",
        moduleName: "ProductsJcsCustomerAccess",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f1WdY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("lwvyf")
]).then(()=>parcelRequire('ihbKq'));

});


parcelRegister("3g2jM", function(module, exports) {
$parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", () => $87feb67200ed2359$export$f27acbd4701f5dfe);
$parcel$export(module.exports, "jsmFilteredAffectedProjectsResource", () => $87feb67200ed2359$export$20489c7ded339ddc);
$parcel$export(module.exports, "csmFilteredAffectedProjectsResource", () => $87feb67200ed2359$export$18fea3d951aae33f);

var $7edbf = parcelRequire("7edbf");


var $ftCgw = parcelRequire("ftCgw");
const $87feb67200ed2359$var$ONE_DAY_IN_MILLIS = 86400000;

const $87feb67200ed2359$export$f27acbd4701f5dfe = (0, $7edbf.createResource)({
    type: (0, $13b64a53cbc9afb4$export$341f26dde034af5b),
    getKey: ()=>'affected-projects',
    getDataLoader: ()=>(parcelRequire("aHrkb")),
    maxAge: $87feb67200ed2359$var$ONE_DAY_IN_MILLIS
});
const $87feb67200ed2359$export$20489c7ded339ddc = (0, $7edbf.createResource)({
    type: 'JSM_FILTERED_AFFECTED_PROJECTS',
    getKey: ()=>'affected-projects-jsm',
    getData: (0, $ftCgw.default)('service_desk'),
    maxAge: $87feb67200ed2359$var$ONE_DAY_IN_MILLIS
});
const $87feb67200ed2359$export$18fea3d951aae33f = (0, $7edbf.createResource)({
    type: 'CSM_FILTERED_AFFECTED_PROJECTS',
    getKey: ()=>'affected-projects-csm',
    getData: (0, $ftCgw.default)('customer_service'),
    maxAge: $87feb67200ed2359$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("ftCgw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e45dd97896d7b252$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");
const $e45dd97896d7b252$var$getDataForProjectType = // oxlint-disable-next-line @typescript-eslint/no-explicit-any
(projectType)=>async ()=>{
        try {
            return await (0, $h2wCv.performGetRequest)(`/rest/servicedesk/admin/1/customer-access/settings/open-projects?projectType=${projectType}`);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            await (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'jsmGlobalCustomerAccessAffectedProjectsResource',
                    packageName: 'jiraRouterResourcesAdminPagesJsmCustomerAccess',
                    teamName: 'jsm-banana'
                }
            });
            throw error;
        }
    };
var $e45dd97896d7b252$export$2e2bcd8739ae039 = $e45dd97896d7b252$var$getDataForProjectType;

});

parcelRegister("aHrkb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hzrgh").then(()=>parcelRequire('exdUI'));

});


parcelRegister("jaikS", function(module, exports) {
$parcel$export(module.exports, "productsJcsCustomerAccessRoute", () => $f0735a22aca65dab$export$db5278559525ffee);
const $f0735a22aca65dab$export$db5278559525ffee = {
    name: 'products-jcs-customer-access',
    path: '/jira/settings/products/customerservice/customer-access',
    exact: true
};

});


parcelRegister("kaJTo", function(module, exports) {
$parcel$export(module.exports, "productsJcsStorageManagementRouteEntry", () => $b602ddd7500fe941$export$e0d4e0d952190e03);



var $i860n = parcelRequire("i860n");

var $ju22D = parcelRequire("ju22D");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $kpswX = parcelRequire("kpswX");

var $h7ltI = parcelRequire("h7ltI");

var $iSoIx = parcelRequire("iSoIx");

var $4PUGw = parcelRequire("4PUGw");
const $b602ddd7500fe941$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4PUGw.productsJcsStorageManagementEntryPoint)
});
const $b602ddd7500fe941$export$e0d4e0d952190e03 = (0, $fdS54.createEntry)((0, $h7ltI.productsJcsStorageManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jcs-configuration.storage-management',
        entryPoint () {
            return (0, $i860n.fg)('jsmgrowth-267_-_enforce_storage_limits') ? $b602ddd7500fe941$var$entryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $kpswX.productsJcsStorageManagementResource)
        ],
        meta: {
            reporting: {
                id: 'productsJcsStorageManagement',
                packageName: 'jiraRouterRoutesProductsJcsStorageManagementEntries',
                teamName: 'jlove-makkuro'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kpswX", function(module, exports) {
$parcel$export(module.exports, "productsJswStorageManagementResource", () => $42d314afee4ea7ac$export$2cd668845b3478bd);
$parcel$export(module.exports, "productsJsmStorageManagementResource", () => $42d314afee4ea7ac$export$72f2b75c6ead0b15);
$parcel$export(module.exports, "productsJcsStorageManagementResource", () => $42d314afee4ea7ac$export$e2fbfc6b77b9249b);

var $7edbf = parcelRequire("7edbf");
const $42d314afee4ea7ac$var$RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';
const $42d314afee4ea7ac$var$RESOURCE_TYPE_PRODUCT_JSM_STORAGE_MANAGEMENT = 'RESOURCE_TYPE_PRODUCT_JSM_STORAGE_MANAGEMENT';
const $42d314afee4ea7ac$var$RESOURCE_TYPE_PRODUCT_JCS_STORAGE_MANAGEMENT = 'RESOURCE_TYPE_PRODUCT_JCS_STORAGE_MANAGEMENT';

const $42d314afee4ea7ac$export$2cd668845b3478bd = (0, $7edbf.createResource)({
    type: $42d314afee4ea7ac$var$RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT,
    getKey: ()=>'state',
    getDataLoader: async ()=>{
        const mod = await (parcelRequire("dTWnS"));
        return {
            default: mod.getJswStorageData
        };
    }
});

const $42d314afee4ea7ac$export$72f2b75c6ead0b15 = (0, $7edbf.createResource)({
    type: $42d314afee4ea7ac$var$RESOURCE_TYPE_PRODUCT_JSM_STORAGE_MANAGEMENT,
    getKey: ()=>'state',
    getDataLoader: async ()=>{
        const mod = await (parcelRequire("dTWnS"));
        return {
            default: mod.getJsmStorageData
        };
    }
});

const $42d314afee4ea7ac$export$e2fbfc6b77b9249b = (0, $7edbf.createResource)({
    type: $42d314afee4ea7ac$var$RESOURCE_TYPE_PRODUCT_JCS_STORAGE_MANAGEMENT,
    getKey: ()=>'state',
    getDataLoader: async ()=>{
        const mod = await (parcelRequire("dTWnS"));
        return {
            default: mod.getJcsStorageData
        };
    }
});

});
parcelRegister("dTWnS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7BuU8").then(()=>parcelRequire('aTltS'));

});


parcelRegister("h7ltI", function(module, exports) {
$parcel$export(module.exports, "productsJcsStorageManagementRoute", () => $206c489f42059be4$export$3b30c7851a9fe3ad);
const $206c489f42059be4$export$3b30c7851a9fe3ad = {
    name: 'products-jcs-storage-management',
    path: '/jira/settings/products/customerservice/storage-management',
    exact: true
};

});

parcelRegister("4PUGw", function(module, exports) {
$parcel$export(module.exports, "productsJcsStorageManagementEntryPoint", () => $818d6b1635234e26$export$71890f1c112a9e87);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $818d6b1635234e26$export$71890f1c112a9e87 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("ec7Dv")), {
        moduleId: "6dbcb453",
        moduleName: "ProductsJcsStorageManagement",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {}
        })
});

});
parcelRegister("ec7Dv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("1aUn0")
]).then(()=>parcelRequire('4Smpj'));

});



parcelRegister("2uYIw", function(module, exports) {
$parcel$export(module.exports, "productsJsmAiGovernanceNativeAiCapabilitiesRouteEntry", () => $19e974195d377caf$export$3b0c7908fb0ec852);



var $i860n = parcelRequire("i860n");

var $ju22D = parcelRequire("ju22D");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $iSoIx = parcelRequire("iSoIx");

var $5hda2 = parcelRequire("5hda2");

var $jUvwn = parcelRequire("jUvwn");
const $19e974195d377caf$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $jUvwn.productJsmAiGovernanceEntryPoint)
});
const $19e974195d377caf$export$3b0c7908fb0ec852 = (0, $fdS54.createEntry)((0, $5hda2.productsJsmAiGovernanceNativeAiCapabilitiesRoute), ()=>({
        group: 'global-settings',
        entryPoint: ()=>(0, $i860n.fg)('enable-jsm-native-app-ai-capabilities') ? $19e974195d377caf$var$entryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: (0, $i860n.fg)('enable-jsm-native-app-ai-capabilities') ? [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ] : (0, $dUAVJ.getNavigationResources)(),
        ufoName: 'admin.jsm-ai-governance-native-ai-capabilities',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5hda2", function(module, exports) {
$parcel$export(module.exports, "productsJsmAiGovernanceNativeAiCapabilitiesRoute", () => $2ef987cc2df600f0$export$2fc717ca2085306c);
const $2ef987cc2df600f0$export$2fc717ca2085306c = {
    name: 'products-jsm-ai-governance-native-ai-capabilities',
    path: '/jira/settings/products/jira-service-management-ai-governance/native-ai-capabilities',
    exact: true
};

});

parcelRegister("jUvwn", function(module, exports) {
$parcel$export(module.exports, "productJsmAiGovernanceEntryPoint", () => $718e73970a839afd$export$78b396165480fb7f);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $718e73970a839afd$export$78b396165480fb7f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aSmjs")), {
        moduleId: "dce47b8c",
        moduleName: "ProductJsmAiGovernancePage",
        priority: "interaction"
    }),
    getPreloadProps: (_entryPointRouteParams)=>({
            queries: {}
        })
});

});
parcelRegister("aSmjs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("HZTCV").then(()=>parcelRequire('15oPF'));

});



parcelRegister("gPrfx", function(module, exports) {
$parcel$export(module.exports, "productsJsmAuthenticationSettingsRouteEntry", () => $294da31d214ffb18$export$de5cc5a334946074);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $9nci1 = parcelRequire("9nci1");

var $dUAVJ = parcelRequire("dUAVJ");

var $AwQIN = parcelRequire("AwQIN");

var $1RYu7 = parcelRequire("1RYu7");
const $294da31d214ffb18$export$de5cc5a334946074 = (0, $fdS54.createEntry)((0, $AwQIN.productsJsmAuthenticationSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-authentication-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1RYu7.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $9nci1.jsmCustomerAuthenticationSettingsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1RYu7.LazyAuthenticationSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9nci1", function(module, exports) {
$parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", () => $4f1c59b603163503$export$73134c05a3c27bd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $4f1c59b603163503$var$RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
const $4f1c59b603163503$var$ONE_DAY_IN_MILLIS = 86400000;

const $4f1c59b603163503$export$73134c05a3c27bd = (0, $7edbf.createResource)({
    type: $4f1c59b603163503$var$RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS,
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("gmuBP")),
    maxAge: $4f1c59b603163503$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("gmuBP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iywRW").then(()=>parcelRequire('3CBOx'));

});


parcelRegister("AwQIN", function(module, exports) {
$parcel$export(module.exports, "productsJsmAuthenticationSettingsRoute", () => $9197c3170fcdd26c$export$6395086ce7e72e37);
const $9197c3170fcdd26c$export$6395086ce7e72e37 = {
    name: 'products-jsm-authentication-settings',
    path: '/jira/settings/products/servicedesk/authentication',
    exact: true
};

});

parcelRegister("1RYu7", function(module, exports) {
$parcel$export(module.exports, "LazyAuthenticationSettings", () => $6301d2499c592b18$export$6cd59b0135f3fe86);
$parcel$export(module.exports, "default", () => $6301d2499c592b18$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6301d2499c592b18$export$6cd59b0135f3fe86 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("gK9mz"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-product-jsm-authentication-settings/src/AuthenticationSettingsType.tsx"
});
const $6301d2499c592b18$var$AsyncAuthenticationSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6301d2499c592b18$export$6cd59b0135f3fe86,
        pageId: "spa-apps/admin-pages/jsm-authentication-settings",
        shouldShowSpinner: false
    });
$6301d2499c592b18$var$AsyncAuthenticationSettings.displayName = "AsyncAuthenticationSettings";
var $6301d2499c592b18$export$2e2bcd8739ae039 = $6301d2499c592b18$var$AsyncAuthenticationSettings;

});
parcelRegister("gK9mz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("8zK8f")
]).then(()=>parcelRequire('gFX95'));

});



parcelRegister("fBDjl", function(module, exports) {
$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRouteEntry", () => $e4bd91dfbee5058c$export$8b55e723205ec5f3);
/* eslint-disable import/order */ 
var $41FAq = parcelRequire("41FAq");



var $lFLfF = parcelRequire("lFLfF");

var $jEYuY = parcelRequire("jEYuY");

var $aWliK = parcelRequire("aWliK");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $2vWHG = parcelRequire("2vWHG");

var $bkrFd = parcelRequire("bkrFd");

var $i860n = parcelRequire("i860n");

var $8idsF = parcelRequire("8idsF");
const $e4bd91dfbee5058c$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $e4bd91dfbee5058c$export$8b55e723205ec5f3 = (0, $fdS54.createEntry)((0, $2vWHG.productsJsmChatopsAndVideosToolsRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>!(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-chat-ops') && !(0, $i860n.fg)('fix_chatops_access_in_isolated_cloud'), (0, $lFLfF.default), (0, $8idsF.default)),
        layout: (0, $7Fzs6.opsSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$e4bd91dfbee5058c$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8idsF.LazyProductsJsmChatopsAndVideoTools)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2vWHG", function(module, exports) {
$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRoute", () => $70a58cd38be48d7e$export$7c663ddc097df1e8);
const $70a58cd38be48d7e$export$7c663ddc097df1e8 = {
    name: 'products-jsm-chatops-and-videos-tools',
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    exact: true
};

});

parcelRegister("8idsF", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmChatopsAndVideoTools", () => $4171570342752a88$export$1b7f55251df02fe9);
$parcel$export(module.exports, "default", () => $4171570342752a88$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4171570342752a88$export$1b7f55251df02fe9 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("5LST1"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-products-jsm-chatops-and-video-tools/src/ProductsJsmChatopsAndVideoToolsType.tsx"
});
const $4171570342752a88$var$AsyncProductsJsmChatopsAndVideoTools = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4171570342752a88$export$1b7f55251df02fe9,
        pageId: "products-jsm-chatops-and-video-tools",
        shouldShowSpinner: false
    });
$4171570342752a88$var$AsyncProductsJsmChatopsAndVideoTools.displayName = "AsyncProductsJsmChatopsAndVideoTools";
var $4171570342752a88$export$2e2bcd8739ae039 = $4171570342752a88$var$AsyncProductsJsmChatopsAndVideoTools;

});
parcelRegister("5LST1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("lhPGC")
]).then(()=>parcelRequire('k2scP'));

});



parcelRegister("3uXTj", function(module, exports) {
$parcel$export(module.exports, "productsJsmChatopsSlackAppSelectorRouteEntry", () => $04bbe24003206622$export$e4ab1a417da2fa0e);



var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $dTa0V = parcelRequire("dTa0V");

var $dUAVJ = parcelRequire("dUAVJ");

var $6mC0T = parcelRequire("6mC0T");

var $bkrFd = parcelRequire("bkrFd");

var $hefPt = parcelRequire("hefPt");
const $04bbe24003206622$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hefPt.productsJsmChatopsSlackAppSelectorEntryPoint)
});
const $04bbe24003206622$export$e4ab1a417da2fa0e = (0, $fdS54.createEntry)((0, $6mC0T.productsJsmChatopsSlackAppSelectorRoute), ()=>({
        group: 'global-settings',
        entryPoint: ()=>{
            if (!(0, $i860n.fg)('support_chatops_on_ic') || !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-chat-ops-ic-custom-apps')) return undefined;
            return $04bbe24003206622$var$entryPoint;
        },
        layout: (0, $7Fzs6.opsSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6mC0T", function(module, exports) {
$parcel$export(module.exports, "productsJsmChatopsSlackAppSelectorRoute", () => $21d1a5c613c7ef9d$export$ff57af1668a1331a);
const $21d1a5c613c7ef9d$export$ff57af1668a1331a = {
    name: 'products-jsm-chatops-slack-app-selector',
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools/select-custom-slack-app',
    exact: true
};

});

parcelRegister("hefPt", function(module, exports) {
$parcel$export(module.exports, "productsJsmChatopsSlackAppSelectorEntryPoint", () => $64be71149e974cf0$export$178f33347c3cd3c6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $64be71149e974cf0$export$178f33347c3cd3c6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("49K7j")), {
        moduleId: "d891e326",
        moduleName: "ProductsJsmChatopsSlackAppSelectorType",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {}
        })
});

});
parcelRegister("49K7j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("gSWeu")
]).then(()=>parcelRequire('eJCs7'));

});



parcelRegister("7iUmd", function(module, exports) {
$parcel$export(module.exports, "productsJsmComplianceRouteEntry", () => $1725351dfd48408b$export$9cc9423a3967333b);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $feaH3 = parcelRequire("feaH3");

var $dsq21 = parcelRequire("dsq21");
const $1725351dfd48408b$export$9cc9423a3967333b = (0, $fdS54.createEntry)((0, $feaH3.productsJsmComplianceRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dsq21.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dsq21.LazyProductsJsmCompliance)
        ],
        ufoName: 'admin.jsm-compliance',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("feaH3", function(module, exports) {
$parcel$export(module.exports, "productsJsmComplianceRoute", () => $a796ac133fb9831a$export$6196bf08f64419da);
const $a796ac133fb9831a$export$6196bf08f64419da = {
    name: 'products-jsm-compliance',
    path: '/jira/settings/products/jira-service-management-compliance',
    exact: true
};

});

parcelRegister("dsq21", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmCompliance", () => $990f8ae2e1848f9b$export$159d8c0e1862cd2b);
$parcel$export(module.exports, "default", () => $990f8ae2e1848f9b$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $990f8ae2e1848f9b$export$159d8c0e1862cd2b = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("iDco1"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-products-jsm-compliance/src/ProductsJsmComplianceType.tsx"
});
const $990f8ae2e1848f9b$var$AsyncProductsJsmCompliance = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $990f8ae2e1848f9b$export$159d8c0e1862cd2b,
        pageId: "products-jsm-compliance",
        shouldShowSpinner: false
    });
$990f8ae2e1848f9b$var$AsyncProductsJsmCompliance.displayName = "AsyncProductsJsmCompliance";
var $990f8ae2e1848f9b$export$2e2bcd8739ae039 = $990f8ae2e1848f9b$var$AsyncProductsJsmCompliance;

});
parcelRegister("iDco1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("PbHYD").then(()=>parcelRequire('1EnZk'));

});



parcelRegister("2OFgC", function(module, exports) {
$parcel$export(module.exports, "productsJsmConfigurationRouteEntry", () => $ef3eba0576b9b33a$export$461f2b06a7a914db);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $c1BUT = parcelRequire("c1BUT");

var $cZ5Wy = parcelRequire("cZ5Wy");
const $ef3eba0576b9b33a$export$461f2b06a7a914db = (0, $fdS54.createEntry)((0, $c1BUT.productsJsmConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-configuration',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cZ5Wy.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cZ5Wy.LazyProductsJsmConfiguration)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c1BUT", function(module, exports) {
$parcel$export(module.exports, "productsJsmConfigurationRoute", () => $3fa25b25b4517b0e$export$2ad48fbde4743a97);
const $3fa25b25b4517b0e$export$2ad48fbde4743a97 = {
    name: 'products-jsm-configuration',
    path: '/jira/settings/products/jira-service-management-configuration',
    exact: true
};

});

parcelRegister("cZ5Wy", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmConfiguration", () => $44cac602993adb84$export$aa3f3d5ca376f305);
$parcel$export(module.exports, "default", () => $44cac602993adb84$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $44cac602993adb84$export$aa3f3d5ca376f305 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("ln9xc"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-products-jsm-configuration/src/ProductsJsmConfigurationType.tsx"
});
const $44cac602993adb84$var$AsyncProductsJsmConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $44cac602993adb84$export$aa3f3d5ca376f305,
        pageId: "products-jsm-configuration",
        shouldShowSpinner: false
    });
$44cac602993adb84$var$AsyncProductsJsmConfiguration.displayName = "AsyncProductsJsmConfiguration";
var $44cac602993adb84$export$2e2bcd8739ae039 = $44cac602993adb84$var$AsyncProductsJsmConfiguration;

});
parcelRegister("ln9xc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gL99d").then(()=>parcelRequire('dvlMu'));

});



parcelRegister("2krk1", function(module, exports) {
$parcel$export(module.exports, "productsJsmCustomerAccessRouteEntry", () => $987301525ec17712$export$d014f5ba2dec6c16);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $3g2jM = parcelRequire("3g2jM");

var $imXbM = parcelRequire("imXbM");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $i860n = parcelRequire("i860n");

var $8HUuJ = parcelRequire("8HUuJ");

var $dUAVJ = parcelRequire("dUAVJ");

var $2oiEe = parcelRequire("2oiEe");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $987301525ec17712$var$LazyCustomerAccess = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("1d0hZ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-customer-access/src/CustomerAccessType.tsx"
});
const $987301525ec17712$var$ServiceDeskCustomerAccess = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $987301525ec17712$var$LazyCustomerAccess,
        pageId: "spa-apps/admin-pages/customer-access",
        shouldShowSpinner: false
    });
$987301525ec17712$var$ServiceDeskCustomerAccess.displayName = "ServiceDeskCustomerAccess";
const $987301525ec17712$export$d014f5ba2dec6c16 = (0, $fdS54.createEntry)((0, $2oiEe.productsJsmCustomerAccessRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-customer-access',
        // eslint-disable-next-line no-restricted-syntax
        component: $987301525ec17712$var$ServiceDeskCustomerAccess,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $imXbM.jsmGlobalCustomerAccessSettingsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('csm_customer_access_jsm_separation'), (0, $3g2jM.jsmGlobalCustomerAccessAffectedProjectsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('csm_customer_access_jsm_separation'), (0, $3g2jM.jsmFilteredAffectedProjectsResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $987301525ec17712$var$LazyCustomerAccess
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2oiEe", function(module, exports) {
$parcel$export(module.exports, "productsJsmCustomerAccessRoute", () => $75b315197bed132c$export$b97e3b6231be8149);
const $75b315197bed132c$export$b97e3b6231be8149 = {
    name: 'products-jsm-customer-access',
    path: '/jira/settings/products/servicedesk/customer-access',
    exact: true
};

});

parcelRegister("1d0hZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jzVTz")
]).then(()=>parcelRequire('5krlj'));

});


parcelRegister("dKGsB", function(module, exports) {
$parcel$export(module.exports, "productsJsmEmailRequestsRouteEntry", () => $b875bb1cdf6da715$export$3f8d7424a47f4dd);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $1E6WA = parcelRequire("1E6WA");

var $d4FPC = parcelRequire("d4FPC");
const $b875bb1cdf6da715$export$3f8d7424a47f4dd = (0, $fdS54.createEntry)((0, $1E6WA.productsJsmEmailRequestsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-email-requests',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $d4FPC.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $d4FPC.LazyProductsJsmEmailRequests)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1E6WA", function(module, exports) {
$parcel$export(module.exports, "productsJsmEmailRequestsRoute", () => $63d4dca6c3a0e04c$export$6288bb6ea42acf0c);
const $63d4dca6c3a0e04c$export$6288bb6ea42acf0c = {
    name: 'products-jsm-email-requests',
    path: '/jira/settings/products/jira-service-management-email-requests',
    exact: true
};

});

parcelRegister("d4FPC", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmEmailRequests", () => $13796491a3e33efa$export$4c9d90d0caf04d67);
$parcel$export(module.exports, "default", () => $13796491a3e33efa$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $13796491a3e33efa$export$4c9d90d0caf04d67 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("3hzbp"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-product-jsm-email-requests/src/ProductsJsmEmailRequestsType.tsx"
});
const $13796491a3e33efa$var$AsyncProductsJsmEmailRequests = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $13796491a3e33efa$export$4c9d90d0caf04d67,
        pageId: "products-jsm-email-requests",
        shouldShowSpinner: false
    });
$13796491a3e33efa$var$AsyncProductsJsmEmailRequests.displayName = "AsyncProductsJsmEmailRequests";
var $13796491a3e33efa$export$2e2bcd8739ae039 = $13796491a3e33efa$var$AsyncProductsJsmEmailRequests;

});
parcelRegister("3hzbp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("3ieXP")
]).then(()=>parcelRequire('dcAde'));

});



parcelRegister("eqqZn", function(module, exports) {
$parcel$export(module.exports, "productsJsmFeatureUsageRouteEntry", () => $4de0603d29ff14b4$export$80a3e4dda2dcd1a4);
/* eslint-disable import/order */ 


var $8ycTI = parcelRequire("8ycTI");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $i7LnL = parcelRequire("i7LnL");

var $eL7Bh = parcelRequire("eL7Bh");
const $4de0603d29ff14b4$export$80a3e4dda2dcd1a4 = (0, $fdS54.createEntry)((0, $i7LnL.productsJsmFeatureUsageRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eL7Bh.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $8ycTI.workspaceResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eL7Bh.LazyProductsJsmFeatureUsage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("i7LnL", function(module, exports) {
$parcel$export(module.exports, "productsJsmFeatureUsageRoute", () => $1cfe4422bb7c4211$export$f98dec539fffaa15);
const $1cfe4422bb7c4211$export$f98dec539fffaa15 = {
    name: 'products-jsm-feature-usage',
    path: '/jira/settings/products/servicedesk/feature-usage',
    exact: true
};

});

parcelRegister("eL7Bh", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmFeatureUsage", () => $c89d341033bb3bb6$export$5ad1c1e822bd5d34);
$parcel$export(module.exports, "default", () => $c89d341033bb3bb6$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $c89d341033bb3bb6$export$5ad1c1e822bd5d34 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("kSTdu"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-products-jsm-feature-usage/src/ProductsJsmFeatureUsageType.tsx"
});
const $c89d341033bb3bb6$var$AsyncProductsJsmFeatureUsage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c89d341033bb3bb6$export$5ad1c1e822bd5d34,
        pageId: "products-jsm-feature-usage",
        shouldShowSpinner: false
    });
$c89d341033bb3bb6$var$AsyncProductsJsmFeatureUsage.displayName = "AsyncProductsJsmFeatureUsage";
var $c89d341033bb3bb6$export$2e2bcd8739ae039 = $c89d341033bb3bb6$var$AsyncProductsJsmFeatureUsage;

});
parcelRegister("kSTdu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("i33w2")
]).then(()=>parcelRequire('avhEv'));

});



parcelRegister("a83iJ", function(module, exports) {
$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRouteEntry", () => $5bb13813eda1aaf2$export$289cc03f2eacd57a);
/* eslint-disable import/order */ 


var $5QT4k = parcelRequire("5QT4k");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $igTvJ = parcelRequire("igTvJ");

var $kcbTP = parcelRequire("kcbTP");
const $5bb13813eda1aaf2$export$289cc03f2eacd57a = (0, $fdS54.createEntry)((0, $igTvJ.productsJsmGlobalOpsReportsRedirectRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kcbTP.OpsReportsRedirect),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $5QT4k.resources)(),
            (0, $5QT4k.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $kcbTP.LazyGlobalOpsReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("igTvJ", function(module, exports) {
$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRoute", () => $834298ac8300ba92$export$c6d42e4b4a63248d);
const $834298ac8300ba92$export$c6d42e4b4a63248d = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports',
    exact: true
};

});

parcelRegister("kcbTP", function(module, exports) {
$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $5859199ede4afdde$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $5859199ede4afdde$export$66850ec5549adba6);
$parcel$export(module.exports, "OpsReportsRedirect", () => $5859199ede4afdde$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $5859199ede4afdde$export$648ddf2d1f8b1c3f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $5859199ede4afdde$export$2404f0e35deca592 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("leCfb")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $5859199ede4afdde$export$d33ea1a773b744e = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("leCfb")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $5859199ede4afdde$export$66850ec5549adba6 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("leCfb")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $5859199ede4afdde$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5859199ede4afdde$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
$5859199ede4afdde$export$22253dbadb46d0cf.displayName = "OpsReportsRedirect";
const $5859199ede4afdde$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5859199ede4afdde$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
$5859199ede4afdde$export$648ddf2d1f8b1c3f.displayName = "GlobalOpsReports";
const $5859199ede4afdde$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5859199ede4afdde$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
$5859199ede4afdde$export$87e6a54b4f5dc91e.displayName = "OpsReports";

});


parcelRegister("edvvt", function(module, exports) {
$parcel$export(module.exports, "productsJsmGlobalOpsReportsRouteEntry", () => $0926342b115a755e$export$6a7fc41fb2523290);
/* eslint-disable import/order */ 


var $5QT4k = parcelRequire("5QT4k");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dElRx = parcelRequire("dElRx");

var $kcbTP = parcelRequire("kcbTP");
const $0926342b115a755e$export$6a7fc41fb2523290 = (0, $fdS54.createEntry)((0, $dElRx.productsJsmGlobalOpsReportsRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kcbTP.GlobalOpsReports),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $5QT4k.resources)(),
            (0, $5QT4k.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $kcbTP.LazyOpsReportsRedirect)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dElRx", function(module, exports) {
$parcel$export(module.exports, "productsJsmGlobalOpsReportsRoute", () => $1ef505681270e4bf$export$d92d66762943b115);
const $1ef505681270e4bf$export$d92d66762943b115 = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("6RUKV", function(module, exports) {
$parcel$export(module.exports, "productsJsmIncidentManagementToolsRouteEntry", () => $3394498a30291ee1$export$773f8e3318be1dd5);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $8Nxgr = parcelRequire("8Nxgr");

var $bKmcT = parcelRequire("bKmcT");
const $3394498a30291ee1$export$773f8e3318be1dd5 = (0, $fdS54.createEntry)((0, $8Nxgr.productsJsmIncidentManagementToolsRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $bKmcT.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bKmcT.LazyProductsJsmIncidentManagementTools)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8Nxgr", function(module, exports) {
$parcel$export(module.exports, "productsJsmIncidentManagementToolsRoute", () => $a9b9afeddbb7de06$export$da6d538ddabade32);
const $a9b9afeddbb7de06$export$da6d538ddabade32 = {
    name: 'products-jsm-incident-management-tools',
    path: '/jira/settings/products/jira-service-management-incident-management-tools',
    exact: true
};

});

parcelRegister("bKmcT", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmIncidentManagementTools", () => $7fab7a255ce5d9ff$export$f541eb9b8f00bfaf);
$parcel$export(module.exports, "default", () => $7fab7a255ce5d9ff$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7fab7a255ce5d9ff$export$f541eb9b8f00bfaf = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("euOex"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-products-jsm-incident-management-tools/src/ProductsJsmIncidentManagementToolsType.tsx"
});
const $7fab7a255ce5d9ff$var$AsyncProductsJsmIncidentManagementTools = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7fab7a255ce5d9ff$export$f541eb9b8f00bfaf,
        pageId: "products-jsm-incident-management-tools",
        shouldShowSpinner: false
    });
$7fab7a255ce5d9ff$var$AsyncProductsJsmIncidentManagementTools.displayName = "AsyncProductsJsmIncidentManagementTools";
var $7fab7a255ce5d9ff$export$2e2bcd8739ae039 = $7fab7a255ce5d9ff$var$AsyncProductsJsmIncidentManagementTools;

});
parcelRegister("euOex", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("g1qqR")
]).then(()=>parcelRequire('5tWlQ'));

});



parcelRegister("99ERU", function(module, exports) {
$parcel$export(module.exports, "productsJsmKbPermissionsRouteEntry", () => $6fd0fb73a9301ba1$export$717e134eb971b450);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $4ltJX = parcelRequire("4ltJX");

var $9h8vY = parcelRequire("9h8vY");
const $6fd0fb73a9301ba1$export$717e134eb971b450 = (0, $fdS54.createEntry)((0, $4ltJX.productsJsmKbPermissionsRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9h8vY.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9h8vY.LazyProductsJsmKbPermissions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4ltJX", function(module, exports) {
$parcel$export(module.exports, "productsJsmKbPermissionsRoute", () => $10a58d34b92f1dcf$export$339486410c7a783f);
const $10a58d34b92f1dcf$export$339486410c7a783f = {
    name: 'products-jsm-kb-permissions',
    path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
    exact: true
};

});

parcelRegister("9h8vY", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmKbPermissions", () => $745a9bbac743642c$export$a3e7bdc5dbf2d47e);
$parcel$export(module.exports, "default", () => $745a9bbac743642c$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $745a9bbac743642c$export$a3e7bdc5dbf2d47e = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("eJYJ4"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-product-jsm-kb-permissions/src/ProductsJsmKbPermissionsType.tsx"
});
const $745a9bbac743642c$var$AsyncProductsJsmKbPermissions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $745a9bbac743642c$export$a3e7bdc5dbf2d47e,
        pageId: "products-jsm-kb-permissions",
        shouldShowSpinner: false
    });
$745a9bbac743642c$var$AsyncProductsJsmKbPermissions.displayName = "AsyncProductsJsmKbPermissions";
var $745a9bbac743642c$export$2e2bcd8739ae039 = $745a9bbac743642c$var$AsyncProductsJsmKbPermissions;

});
parcelRegister("eJYJ4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eFg2K").then(()=>parcelRequire('6vwrW'));

});



parcelRegister("mpFVB", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationsDetailsRouteEntry", () => $7c5cef2cff5d7d88$export$f7b6cda88404733e);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $jVrUf = parcelRequire("jVrUf");

var $Q5OI6 = parcelRequire("Q5OI6");

var $7DJe9 = parcelRequire("7DJe9");

var $l1BPi = parcelRequire("l1BPi");

var $dUAVJ = parcelRequire("dUAVJ");

var $fWY1J = parcelRequire("fWY1J");

var $7SFJb = parcelRequire("7SFJb");
const $7c5cef2cff5d7d88$export$f7b6cda88404733e = (0, $fdS54.createEntry)((0, $fWY1J.productsJsmOrganizationsDetailsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7SFJb.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $Q5OI6.productsJsmOrganizationDetailsResource),
            (0, $7DJe9.productsJsmOrganizationMembersResource),
            (0, $l1BPi.productsJsmOrganizationListResource),
            (0, $jVrUf.jsmEmailDomainsListResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7SFJb.LazyProductsJsmOrganizationDetails)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7DJe9", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationMembersResource", () => $fd137d8bd3f549a9$export$65c7941bd3e14d00);

var $7edbf = parcelRequire("7edbf");
const $fd137d8bd3f549a9$var$PRODUCT_JSM_ORGANIZATION_MEMBERS = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';
const $fd137d8bd3f549a9$var$TEN_SECONDS_IN_MILLIS = 10000;

const $fd137d8bd3f549a9$export$65c7941bd3e14d00 = (0, $7edbf.createResource)({
    type: $fd137d8bd3f549a9$var$PRODUCT_JSM_ORGANIZATION_MEMBERS,
    getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("3UEM3")),
    maxAge: $fd137d8bd3f549a9$var$TEN_SECONDS_IN_MILLIS
});

});
parcelRegister("3UEM3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4WQ14").then(()=>parcelRequire('d71pj'));

});


parcelRegister("l1BPi", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationListResource", () => $102ae5f1d21129e7$export$3e38a27ad406d7f7);

var $7edbf = parcelRequire("7edbf");
const $102ae5f1d21129e7$var$RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';
const $102ae5f1d21129e7$var$TEN_SECONDS_IN_MILLIS = 10000;

const $102ae5f1d21129e7$export$3e38a27ad406d7f7 = (0, $7edbf.createResource)({
    type: $102ae5f1d21129e7$var$RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST,
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("3Jmbd")),
    maxAge: $102ae5f1d21129e7$var$TEN_SECONDS_IN_MILLIS
});

});
parcelRegister("3Jmbd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iUu3Q").then(()=>parcelRequire('1dGao'));

});


parcelRegister("fWY1J", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationsDetailsRoute", () => $c00a6a4fc559a93c$export$bc61991d01535831);
const $c00a6a4fc559a93c$export$bc61991d01535831 = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations/:organizationId',
    exact: true
};

});

parcelRegister("7SFJb", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmOrganizationDetails", () => $6f5719e5958e16a8$export$ff149ceefa65ab70);
$parcel$export(module.exports, "default", () => $6f5719e5958e16a8$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6f5719e5958e16a8$export$ff149ceefa65ab70 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("RjfSD"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/OrganizationDetailsPage.tsx"
});
const $6f5719e5958e16a8$var$AsyncProductsJsmOrganizationDetails = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6f5719e5958e16a8$export$ff149ceefa65ab70,
        pageId: "products-jsm-organization-details",
        shouldShowSpinner: true
    });
$6f5719e5958e16a8$var$AsyncProductsJsmOrganizationDetails.displayName = "AsyncProductsJsmOrganizationDetails";
var $6f5719e5958e16a8$export$2e2bcd8739ae039 = $6f5719e5958e16a8$var$AsyncProductsJsmOrganizationDetails;

});
parcelRegister("RjfSD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("3DxXm")
]).then(()=>parcelRequire('l6VvQ'));

});



parcelRegister("aEn8k", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationsRouteEntry", () => $208c778dc5bfa599$export$34d843946d3894aa);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $l1BPi = parcelRequire("l1BPi");

var $dUAVJ = parcelRequire("dUAVJ");

var $kg3Op = parcelRequire("kg3Op");

var $9hsfp = parcelRequire("9hsfp");
const $208c778dc5bfa599$export$34d843946d3894aa = (0, $fdS54.createEntry)((0, $kg3Op.productsJsmOrganizationsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9hsfp.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $l1BPi.productsJsmOrganizationListResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9hsfp.LazyProductsJsmOrganizations)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kg3Op", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationsRoute", () => $062dc03e6e04be03$export$512fa30726e0049d);
const $062dc03e6e04be03$export$512fa30726e0049d = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations',
    exact: true
};

});

parcelRegister("9hsfp", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmOrganizations", () => $15e9bd2dc9aa1fae$export$410bec6e06fd4723);
$parcel$export(module.exports, "default", () => $15e9bd2dc9aa1fae$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $15e9bd2dc9aa1fae$export$410bec6e06fd4723 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("ib31I"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/OrganizationsListPage.tsx"
});
const $15e9bd2dc9aa1fae$var$AsyncProductsJsmOrganizations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $15e9bd2dc9aa1fae$export$410bec6e06fd4723,
        pageId: "products-jsm-organizations-list",
        shouldShowSpinner: true
    });
$15e9bd2dc9aa1fae$var$AsyncProductsJsmOrganizations.displayName = "AsyncProductsJsmOrganizations";
var $15e9bd2dc9aa1fae$export$2e2bcd8739ae039 = $15e9bd2dc9aa1fae$var$AsyncProductsJsmOrganizations;

});
parcelRegister("ib31I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("4YGWI")
]).then(()=>parcelRequire('jzRbV'));

});



parcelRegister("eZnvl", function(module, exports) {
$parcel$export(module.exports, "productsJsmStorageManagementRouteEntry", () => $4acf0ea22e2f1ec6$export$a784bf4ee82e7387);



var $i860n = parcelRequire("i860n");

var $ju22D = parcelRequire("ju22D");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $kpswX = parcelRequire("kpswX");

var $izq5Z = parcelRequire("izq5Z");

var $iSoIx = parcelRequire("iSoIx");

var $CNDp8 = parcelRequire("CNDp8");
const $4acf0ea22e2f1ec6$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $CNDp8.productsJsmStorageManagementEntryPoint)
});
const $4acf0ea22e2f1ec6$export$a784bf4ee82e7387 = (0, $fdS54.createEntry)((0, $izq5Z.productsJsmStorageManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-configuration.storage-management',
        entryPoint () {
            return (0, $i860n.fg)('jsmgrowth-267_-_enforce_storage_limits') ? $4acf0ea22e2f1ec6$var$entryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $kpswX.productsJsmStorageManagementResource)
        ],
        meta: {
            reporting: {
                id: 'productsJsmStorageManagement',
                packageName: 'jiraRouterRoutesProductsJsmStorageManagementEntries',
                teamName: 'jlove-makkuro'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("izq5Z", function(module, exports) {
$parcel$export(module.exports, "productsJsmStorageManagementRoute", () => $eed2ba74c7aec41e$export$9b34a58659910f74);
const $eed2ba74c7aec41e$export$9b34a58659910f74 = {
    name: 'products-jsm-storage-management',
    path: '/jira/settings/products/jira-service-management-storage-management',
    exact: true
};

});

parcelRegister("CNDp8", function(module, exports) {
$parcel$export(module.exports, "productsJsmStorageManagementEntryPoint", () => $30b9f4d8e32721a7$export$9eaae1a219b44e4a);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $30b9f4d8e32721a7$export$9eaae1a219b44e4a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("kSZ3v")), {
        moduleId: "0d2b7b6b",
        moduleName: "ProductsJsmStorageManagement",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {}
        })
});

});
parcelRegister("kSZ3v", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("fEcy3")
]).then(()=>parcelRequire('2pDCW'));

});



parcelRegister("5RdXl", function(module, exports) {
$parcel$export(module.exports, "productsJsmWorkforceSkillsRouteEntry", () => $fa4b07ac981e9be3$export$5b73bc31efd2df2);



var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $dUAVJ = parcelRequire("dUAVJ");

var $3Cm2S = parcelRequire("3Cm2S");

var $baMRn = parcelRequire("baMRn");

var $lFLfF = parcelRequire("lFLfF");
const $fa4b07ac981e9be3$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $fa4b07ac981e9be3$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $baMRn.productsJsmWorkforceSkillsEntryPoint)
});
const $fa4b07ac981e9be3$export$5b73bc31efd2df2 = (0, $fdS54.createEntry)((0, $3Cm2S.productsJsmWorkforceSkillsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-workforce-skills',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        entryPoint: ()=>{
            if (!$fa4b07ac981e9be3$var$isWorkforceAemEnabled() || !(0, $i860n.fg)('jsm_wfo_skills')) return undefined;
            return $fa4b07ac981e9be3$var$entryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3Cm2S", function(module, exports) {
$parcel$export(module.exports, "productsJsmWorkforceSkillsRoute", () => $17949443c873f344$export$974afa6842225097);
const $17949443c873f344$export$974afa6842225097 = {
    name: 'products-jsm-workforce-skills',
    path: '/jira/settings/products/jira-service-management-workforce-skills',
    exact: true
};

});

parcelRegister("baMRn", function(module, exports) {
$parcel$export(module.exports, "productsJsmWorkforceSkillsEntryPoint", () => $351fb16f52028080$export$e292b344d609364f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $NDnC8 = parcelRequire("NDnC8");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $kqQBI = parcelRequire("kqQBI");
// Matches the page size used inside `useSiteSkillsConnection` so the preloaded
// query and the in-page `loadMoreCategories` paginate by the same step.
const $351fb16f52028080$var$CATEGORIES_PAGE_SIZE = 10;
const $351fb16f52028080$var$SERVICE_DESK = 'jira-servicedesk';
const $351fb16f52028080$var$FREE_EDITION = 'FREE_EDITION';
const $351fb16f52028080$var$STANDARD_EDITION = 'STANDARD_EDITION';
const $351fb16f52028080$var$hasLicensedServiceDeskAboveStandard = ({ licensedProducts: licensedProducts, serviceDeskEdition: serviceDeskEdition })=>Boolean(licensedProducts?.[$351fb16f52028080$var$SERVICE_DESK]) && serviceDeskEdition !== undefined && serviceDeskEdition !== $351fb16f52028080$var$FREE_EDITION && serviceDeskEdition !== $351fb16f52028080$var$STANDARD_EDITION;

const $351fb16f52028080$export$e292b344d609364f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9TujA")), {
        moduleId: "a89247fb",
        moduleName: "ProductsJsmWorkforceSkillsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, licensedProducts: licensedProducts } })=>({
            queries: {
                siteWfoStatusQueryRef: {
                    parameters: (0, $kqQBI.default),
                    variables: {
                        cloudId: cloudId,
                        skipSiteWfoStatus: !(isAdmin && $351fb16f52028080$var$hasLicensedServiceDeskAboveStandard({
                            licensedProducts: licensedProducts,
                            serviceDeskEdition: appEditions?.serviceDesk
                        }) && (0, $i860n.fg)('jsm_wfo_skills'))
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                },
                siteSkillsQueryRef: {
                    parameters: $NDnC8.default,
                    variables: {
                        cloudId: cloudId,
                        first: $351fb16f52028080$var$CATEGORIES_PAGE_SIZE
                    }
                }
            },
            extraProps: {
                cloudId: cloudId
            }
        })
});

});
parcelRegister("NDnC8", function(module, exports) {
$parcel$export(module.exports, "default", () => $00ab63b754608e02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd857476131c0372823495eef22b20ab>>
 * @relayHash 0b3ab93ce67f2f873d66a3bad14734e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6296bdca1160c0740c8ce52e72bbcb463f6cef9a992e1bd6d0844ea2708c05ee
const $00ab63b754608e02$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAccountIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "agentAccountIds",
            "variableName": "agentAccountIds"
        },
        {
            "kind": "Variable",
            "name": "categoryIds",
            "variableName": "categoryIds"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSiteSkillsConnectionQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "useSiteSkillsConnection_categories"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSiteSkillsConnectionQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "AgentWorkspaceSkillCategoryConnection",
                    "kind": "LinkedField",
                    "name": "agentWorkspace_skillCategories",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentWorkspaceSkillCategoryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentWorkspaceSkillCategory",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "skillCount"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 20
                                                }
                                            ],
                                            "concreteType": "AgentWorkspaceSkillConnection",
                                            "kind": "LinkedField",
                                            "name": "skills",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AgentWorkspaceSkillEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AgentWorkspaceSkill",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                },
                                                                {
                                                                    "concreteType": "AgentWorkspaceSkillAgentAssignment",
                                                                    "kind": "LinkedField",
                                                                    "name": "assignedAgents",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AgentWorkspaceUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "agent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "accountId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "picture"
                                                                                        },
                                                                                        v7 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ],
                                            "storageKey": "skills(first:20)"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        v10 /*: any*/ 
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "filters": [
                        "query",
                        "categoryIds",
                        "agentAccountIds"
                    ],
                    "handle": "connection",
                    "key": "useSiteSkillsConnection__agentWorkspace_skillCategories",
                    "kind": "LinkedHandle",
                    "name": "agentWorkspace_skillCategories"
                }
            ]
        },
        "params": {
            "id": "6296bdca1160c0740c8ce52e72bbcb463f6cef9a992e1bd6d0844ea2708c05ee",
            "metadata": {},
            "name": "useSiteSkillsConnectionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$00ab63b754608e02$var$node.hash = "0d30518811c5dd0412c3e6dc27b7702e";
var $00ab63b754608e02$export$2e2bcd8739ae039 = $00ab63b754608e02$var$node;

});

parcelRegister("kqQBI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b34fcad5f7faa645$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6730fa61411a50b18c632b24436ca49>>
 * @relayHash f78ccda1f54d3fcb8894d76abca28091
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cf5c390ebb42a8df3f27c63920dca9fd3585cd581db98c7196847bbd81ea2782
const $b34fcad5f7faa645$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cf5c390ebb42a8df3f27c63920dca9fd3585cd581db98c7196847bbd81ea2782",
        "metadata": {},
        "name": "ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b34fcad5f7faa645$export$2e2bcd8739ae039 = $b34fcad5f7faa645$var$node;

});

parcelRegister("9TujA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lyCIh").then(()=>parcelRequire('g6Un0'));

});



parcelRegister("69S3K", function(module, exports) {
$parcel$export(module.exports, "productsJswConfigurationRouteEntry", () => $e8b4699eba08843a$export$2f65b1ec4ed05f91);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $kvsnJ = parcelRequire("kvsnJ");

var $8JfiH = parcelRequire("8JfiH");

var $gvq4D = parcelRequire("gvq4D");
const $e8b4699eba08843a$export$2f65b1ec4ed05f91 = (0, $fdS54.createEntry)((0, $8JfiH.productsJswConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gvq4D.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $kvsnJ.productsJswConfigurationResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gvq4D.LazyProductsJswConfiguration)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kvsnJ", function(module, exports) {
$parcel$export(module.exports, "productsJswConfigurationResource", () => $6fac9e87e729ca41$export$b6a5741c2b47fb17);

var $7edbf = parcelRequire("7edbf");
const $6fac9e87e729ca41$var$RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

const $6fac9e87e729ca41$export$b6a5741c2b47fb17 = (0, $7edbf.createResource)({
    type: $6fac9e87e729ca41$var$RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("6ThwR"))
});

});
parcelRegister("6ThwR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ceGlq").then(()=>parcelRequire('iuaEO'));

});


parcelRegister("8JfiH", function(module, exports) {
$parcel$export(module.exports, "productsJswConfigurationRoute", () => $c18544a5288c84e5$export$decdad53ba9b97af);
const $c18544a5288c84e5$export$decdad53ba9b97af = {
    name: 'products-jsw-configuration',
    path: '/jira/settings/products/jira-software-configuration',
    exact: true
};

});

parcelRegister("gvq4D", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJswConfiguration", () => $06913d4175602f89$export$f9a32397033f9ced);
$parcel$export(module.exports, "default", () => $06913d4175602f89$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $06913d4175602f89$export$f9a32397033f9ced = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("8zdub"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-products-jsw-configuration/src/ProductsJswConfigurationType.tsx"
});
const $06913d4175602f89$var$AsyncProductsJswConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $06913d4175602f89$export$f9a32397033f9ced,
        pageId: "products-jsw-configuration",
        shouldShowSpinner: false
    });
$06913d4175602f89$var$AsyncProductsJswConfiguration.displayName = "AsyncProductsJswConfiguration";
var $06913d4175602f89$export$2e2bcd8739ae039 = $06913d4175602f89$var$AsyncProductsJswConfiguration;

});
parcelRegister("8zdub", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dQRWx").then(()=>parcelRequire('aghaj'));

});



parcelRegister("65JjX", function(module, exports) {
$parcel$export(module.exports, "productsJswStorageManagementRouteEntry", () => $abb13ce36825c305$export$c62ca2d3fcc552a5);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $kpswX = parcelRequire("kpswX");

var $7n2MP = parcelRequire("7n2MP");

var $34aZN = parcelRequire("34aZN");
const $abb13ce36825c305$export$c62ca2d3fcc552a5 = (0, $fdS54.createEntry)((0, $7n2MP.productsJswStorageManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration.storage-management',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $34aZN.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            (0, $kpswX.productsJswStorageManagementResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $34aZN.LazyProductsJswStorageManagement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7n2MP", function(module, exports) {
$parcel$export(module.exports, "productsJswStorageManagementRoute", () => $90bfe4d14b97a5fb$export$18f0044f00cc3996);
const $90bfe4d14b97a5fb$export$18f0044f00cc3996 = {
    name: 'products-jsw-storage-management',
    path: '/jira/settings/products/jira-software-configuration/storage-management',
    exact: true
};

});

parcelRegister("34aZN", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJswStorageManagement", () => $979dc6cb702949c2$export$a4f5e12ce817cbb8);
$parcel$export(module.exports, "default", () => $979dc6cb702949c2$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $979dc6cb702949c2$export$a4f5e12ce817cbb8 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("1coCK"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-products-jsw-storage-management/src/ProductsJswStorageManagementType.tsx"
});
const $979dc6cb702949c2$var$AsyncProductsJswStorageManagement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $979dc6cb702949c2$export$a4f5e12ce817cbb8,
        pageId: "products-jsw-storage-management",
        shouldShowSpinner: true
    });
$979dc6cb702949c2$var$AsyncProductsJswStorageManagement.displayName = "AsyncProductsJswStorageManagement";
var $979dc6cb702949c2$export$2e2bcd8739ae039 = $979dc6cb702949c2$var$AsyncProductsJswStorageManagement;

});
parcelRegister("1coCK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("cFYbQ")
]).then(()=>parcelRequire('fXHaI'));

});



parcelRegister("b0YFc", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubCreateRouteEntry", () => $8352a862d2d40540$export$666a5dacd00ae9cf);
/* eslint-disable import/order */ 
var $5nIDw = parcelRequire("5nIDw");



var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $i860n = parcelRequire("i860n");

var $j13y3 = parcelRequire("j13y3");

var $dUAVJ = parcelRequire("dUAVJ");

var $3vrri = parcelRequire("3vrri");
const $8352a862d2d40540$var$productsOnboardingHubCreateWithDelegatedAdminEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5nIDw.onboardingHubWizardWithDelegatedAdminEntryPoint),
    leftSidebar: {
        sidebar: (0, $3vrri.nav4SidebarGlobalProductsSettingsEntryPoint)
    }
});
const $8352a862d2d40540$export$666a5dacd00ae9cf = (0, $fdS54.createEntry)((0, $j13y3.productsOnboardingHubCreateRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.products.onboarding-hub-create',
        meta: {
            reporting: {
                id: 'products-onboarding-hub-create',
                teamName: 'a4t-pandora',
                packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries'
            }
        },
        entryPoint () {
            if ((0, $i860n.fg)('jira-onboarding-hub-gate')) return $8352a862d2d40540$var$productsOnboardingHubCreateWithDelegatedAdminEntryPoint;
            return undefined;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5nIDw", function(module, exports) {
$parcel$export(module.exports, "onboardingHubWizardWithDelegatedAdminEntryPoint", () => $803dd5edca18d1fb$export$9c435eb0e972772a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $2bLNm = parcelRequire("2bLNm");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $803dd5edca18d1fb$export$9c435eb0e972772a = (0, $fiVog.createEntryPoint)({
    // Using `JSResourceForInteraction` to avoid SSR
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("cDYb1")), {
        moduleId: "28b09633",
        moduleName: "OnboardingHubWizardWithDelegatedAdminEntryPointRoot",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId, isAdmin: isAdmin, appEditions: appEditions } })=>({
            extraProps: {
                id: context.match.params?.id || ''
            },
            queries: {
                PermissionsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $2bLNm.default),
                    variables: {
                        cloudId: cloudId,
                        // We can skip the permission check when:
                        // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                        // 2. Upsell is enabled (because upsell is only available to admins)
                        skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION'
                    }
                }
            }
        })
});

});
parcelRegister("2bLNm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5776861667a2e2f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94faac199e5de7d068763564ee964082>>
 * @relayHash e80b0a4466bb973c579a3be7e724aa26
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10c26fee5a185705c6edc1cc504465a821bef8424513beeb6f40b39691874f32

var $lIGkE = parcelRequire("lIGkE");
const $5776861667a2e2f3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        }
    ], v1 = [
        {
            "condition": "skipDelegatedAdminCheck",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canManageCustomOnboarding",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "MANAGE_CUSTOM_ONBOARDING"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "hasGlobalPermission"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OnboardingWizardInnerPermissionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OnboardingWizardInnerPermissionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "10c26fee5a185705c6edc1cc504465a821bef8424513beeb6f40b39691874f32",
            "metadata": {},
            "name": "OnboardingWizardInnerPermissionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5776861667a2e2f3$var$node.hash = "4a25465480268eec81b6f5dc0fde9fca";
(0, $lIGkE.PreloadableQueryRegistry).set($5776861667a2e2f3$var$node.params.id, $5776861667a2e2f3$var$node);
var $5776861667a2e2f3$export$2e2bcd8739ae039 = $5776861667a2e2f3$var$node;

});

parcelRegister("cDYb1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("e7dYH")
]).then(()=>parcelRequire('65wr2'));

});


parcelRegister("j13y3", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubCreateRoute", () => $7468e0f0fceaf065$export$a27be1bacf345707);
const $7468e0f0fceaf065$export$a27be1bacf345707 = {
    name: 'products-onboarding-hub-create',
    path: '/jira/settings/products/onboarding/new'
};

});

parcelRegister("3vrri", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarGlobalProductsSettingsEntryPoint", () => $38b77cc26f756101$export$aa699a6476ee43d8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $cCjMO = parcelRequire("cCjMO");
const $38b77cc26f756101$var$SERVICE_DESK = 'jira-servicedesk';
const $38b77cc26f756101$var$FREE_EDITION = 'FREE_EDITION';
const $38b77cc26f756101$var$STANDARD_EDITION = 'STANDARD_EDITION';
const $38b77cc26f756101$var$hasLicensedServiceDeskAboveStandard = ({ licensedProducts: licensedProducts, serviceDeskEdition: serviceDeskEdition })=>Boolean(licensedProducts?.[$38b77cc26f756101$var$SERVICE_DESK]) && serviceDeskEdition !== undefined && serviceDeskEdition !== $38b77cc26f756101$var$FREE_EDITION && serviceDeskEdition !== $38b77cc26f756101$var$STANDARD_EDITION;

const $38b77cc26f756101$export$aa699a6476ee43d8 = (0, $fiVog.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("fOI4h")), {
        moduleId: "65cd45bb",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps ({ tenantContext: { cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, licensedProducts: licensedProducts } }) {
        return {
            queries: {
                nav4SidebarGlobalProductsSettings: {
                    parameters: (0, $cCjMO.default),
                    variables: {
                        cloudId: cloudId,
                        // We can skip the permission check when:
                        // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                        // 2. Upsell is enabled (because upsell is only available to admins), or
                        // 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone)
                        skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' || !(0, $i860n.fg)('jira-onboarding-hub-gate'),
                        skipSiteWfoStatus: !($38b77cc26f756101$var$hasLicensedServiceDeskAboveStandard({
                            licensedProducts: licensedProducts,
                            serviceDeskEdition: appEditions?.serviceDesk
                        }) && (0, $i860n.fg)('jsm_wfo_skills'))
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("fOI4h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("39FO2").then(()=>parcelRequire('c1XB1'));

});



parcelRegister("1JT7t", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubEditRouteEntry", () => $e899dc5afe88aaf4$export$a51e527aeaa5756f);
/* eslint-disable import/order */ 
var $5nIDw = parcelRequire("5nIDw");



var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $i860n = parcelRequire("i860n");

var $h1aCo = parcelRequire("h1aCo");

var $dUAVJ = parcelRequire("dUAVJ");

var $3vrri = parcelRequire("3vrri");
const $e899dc5afe88aaf4$var$productsOnboardingHubEditWithDelegatedAdminEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5nIDw.onboardingHubWizardWithDelegatedAdminEntryPoint),
    leftSidebar: {
        sidebar: (0, $3vrri.nav4SidebarGlobalProductsSettingsEntryPoint)
    }
});
const $e899dc5afe88aaf4$export$a51e527aeaa5756f = (0, $fdS54.createEntry)((0, $h1aCo.productsOnboardingHubEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.products.onboarding-hub-edit',
        meta: {
            reporting: {
                id: 'products-onboarding-hub-edit',
                teamName: 'a4t-pandora',
                packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries'
            }
        },
        entryPoint () {
            if ((0, $i860n.fg)('jira-onboarding-hub-gate')) return $e899dc5afe88aaf4$var$productsOnboardingHubEditWithDelegatedAdminEntryPoint;
            return undefined;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("h1aCo", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubEditRoute", () => $13c8e1fecf88aae6$export$28172feeb183ba94);
const $13c8e1fecf88aae6$export$28172feeb183ba94 = {
    name: 'products-onboarding-hub-edit',
    path: '/jira/settings/products/onboarding/:id/edit'
};

});


parcelRegister("53HKz", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubRouteEntry", () => $90361d54cab31a6d$export$114fd427e3931043);
/* eslint-disable import/order */ 
var $c4GjO = parcelRequire("c4GjO");



var $fdS54 = parcelRequire("fdS54");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $i860n = parcelRequire("i860n");

var $dGbEJ = parcelRequire("dGbEJ");

var $dUAVJ = parcelRequire("dUAVJ");

var $3vrri = parcelRequire("3vrri");
// When a user visits this page directly, the left sidebar comes from
// nav4SidebarGlobalProductsSettingsEntryPoint, but when they land on this page via
// the Global Settings Page Switcher, the left sidebar comes from the relay-resource-backed
// component: SidebarContentWithRelayResource.
// See @jira/navigation-apps__sidebar-nav4-sidebars-settings-global-products/src/ui/index.tsx.
const $90361d54cab31a6d$var$productsOnboardingHubWithDelegatedAdminEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $c4GjO.onboardingHubEntryPoint),
    leftSidebar: {
        sidebar: (0, $3vrri.nav4SidebarGlobalProductsSettingsEntryPoint)
    }
});
const $90361d54cab31a6d$export$114fd427e3931043 = (0, $fdS54.createEntry)((0, $dGbEJ.productsOnboardingHubRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.products.onboarding-hub',
        meta: {
            reporting: {
                id: 'products-onboarding-hub',
                teamName: 'a4t-pandora',
                packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries'
            }
        },
        entryPoint () {
            if ((0, $i860n.fg)('jira-onboarding-hub-gate')) return $90361d54cab31a6d$var$productsOnboardingHubWithDelegatedAdminEntryPoint;
            return undefined;
        },
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c4GjO", function(module, exports) {
$parcel$export(module.exports, "onboardingHubEntryPoint", () => $383b7a112da8db77$export$fbab93125af0feae);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $lYFOF = parcelRequire("lYFOF");

const $383b7a112da8db77$export$fbab93125af0feae = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("fffpY")), {
        moduleId: "7216e0de",
        moduleName: "OnboardingHubPageComponent",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const { appEditions: appEditions, cloudId: cloudId, isAdmin: isAdmin } = tenantContext;
        const queries = {
            onboardingHubQuery: {
                options: {
                    fetchPolicy: 'store-and-network'
                },
                parameters: (0, $lYFOF.default),
                variables: {
                    cloudId: cloudId,
                    upsellEnabled: appEditions?.software !== 'PREMIUM_EDITION',
                    hamsProductKey: 'jira-software.ondemand',
                    rollingIntervals: [
                        'DAYS_1',
                        'DAYS_7',
                        'DAYS_30',
                        'DAYS_90',
                        'DAYS_180'
                    ],
                    // We can skip the permission check when:
                    // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                    // 2. Upsell is enabled (because upsell is only available to admins)
                    skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION'
                }
            }
        };
        return {
            queries: queries
        };
    }
});

});
parcelRegister("lYFOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $01f8507458ac9a93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7c5a19af8484746d7732d62066c7927>>
 * @relayHash d583c17c36ed08c3eea4b56872e85490
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26531098faaed35f92396951d199e959fada1d0eefbc108e9919a5d3f8f25005

var $lIGkE = parcelRequire("lIGkE");
const $01f8507458ac9a93$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rollingIntervals"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipDelegatedAdminCheck"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "upsellEnabled"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "condition": "skipDelegatedAdminCheck",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "alias": "canManageCustomOnboarding",
                        "args": [
                            v5 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "MANAGE_CUSTOM_ONBOARDING"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "hasGlobalPermission"
                    }
                ]
            }
        ]
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "date"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "OnboardingHubPageComponentQuery",
            "selections": [
                {
                    "condition": "upsellEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "OnboardingListTable"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "InsightsPanel"
                        }
                    ]
                },
                {
                    "condition": "upsellEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CustomOnboardingUpsell"
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "OnboardingHubPageComponentQuery",
            "selections": [
                {
                    "condition": "upsellEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                v5 /*: any*/ 
                            ],
                            "concreteType": "JiraOnboardingConfigConnection",
                            "kind": "LinkedField",
                            "name": "jira_onboardingConfigs",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraOnboardingConfigEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOnboardingConfig",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "onboardingConfigAri"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "targetValues"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updatedAt"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDisabled"
                                                },
                                                {
                                                    "concreteType": "JiraOnboardingModal",
                                                    "kind": "LinkedField",
                                                    "name": "modals",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOnboardingStep",
                                                            "kind": "LinkedField",
                                                            "name": "steps",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOnboardingLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "text"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "tenantId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "GrowthUnifiedProfileSiteProfileResult",
                            "kind": "LinkedField",
                            "name": "growthUnifiedProfile_siteProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "rollingIntervals",
                                            "variableName": "rollingIntervals"
                                        }
                                    ],
                                    "concreteType": "GrowthUnifiedProfileSiteOnboardingInsightsResult",
                                    "kind": "LinkedField",
                                    "name": "onboardingHubInsightsOverAll",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalViews"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalEngagements"
                                        },
                                        {
                                            "concreteType": "GrowthUnifiedProfileEngagementsSeries",
                                            "kind": "LinkedField",
                                            "name": "engagementsSeries",
                                            "plural": true,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "rollingInterval"
                                        },
                                        {
                                            "concreteType": "GrowthUnifiedProfileViewSeries",
                                            "kind": "LinkedField",
                                            "name": "viewsSeries",
                                            "plural": true,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "completionRate"
                                        },
                                        {
                                            "concreteType": "GrowthUnifiedProfileCompletionSeries",
                                            "kind": "LinkedField",
                                            "name": "completionsSeries",
                                            "plural": true,
                                            "selections": v7 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "upsellEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "hamsProductKey",
                                            "variableName": "hamsProductKey"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "offeringName",
                                                                    "value": "Premium"
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "experienceUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isAvailableToUser"
                                                                }
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "id": "26531098faaed35f92396951d199e959fada1d0eefbc108e9919a5d3f8f25005",
            "metadata": {},
            "name": "OnboardingHubPageComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$01f8507458ac9a93$var$node.hash = "45bf7ee0f09ac7945bb3bc7bdb8c8315";
(0, $lIGkE.PreloadableQueryRegistry).set($01f8507458ac9a93$var$node.params.id, $01f8507458ac9a93$var$node);
var $01f8507458ac9a93$export$2e2bcd8739ae039 = $01f8507458ac9a93$var$node;

});

parcelRegister("fffpY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("eVOil")
]).then(()=>parcelRequire('btZtA'));

});


parcelRegister("dGbEJ", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubRoute", () => $fb3fa9bf90c005f2$export$6a9e8ece249577cc);
const $fb3fa9bf90c005f2$export$6a9e8ece249577cc = {
    name: 'products-onboarding-hub',
    path: '/jira/settings/products/onboarding'
};

});


parcelRegister("3R4tv", function(module, exports) {
$parcel$export(module.exports, "proformaExportRouteEntry", () => $82679e252551e2ce$export$27be010fc1b30f6c);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dXBv0 = parcelRequire("dXBv0");

var $6oEa4 = parcelRequire("6oEa4");
const $82679e252551e2ce$export$27be010fc1b30f6c = (0, $fdS54.createEntry)((0, $dXBv0.proformaExportRoute), ()=>({
        group: 'proforma',
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6oEa4.default),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6oEa4.LazyProformaExport)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dXBv0", function(module, exports) {
$parcel$export(module.exports, "proformaExportRoute", () => $a699a8f7b735308e$export$5130d152b1cda229);
const $a699a8f7b735308e$export$5130d152b1cda229 = {
    name: 'proforma-export',
    path: '/jira/forms/export',
    exact: true
};

});

parcelRegister("6oEa4", function(module, exports) {
$parcel$export(module.exports, "LazyProformaExport", () => $9c01414b825259ac$export$5e0d802a5d865352);
$parcel$export(module.exports, "default", () => $9c01414b825259ac$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9c01414b825259ac$export$5e0d802a5d865352 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("i6Xru")), {
    moduleId: "./src/packages/spa-apps/proforma-export/src/ProformaExport.tsx"
});
const $9c01414b825259ac$var$AsyncProformaExport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9c01414b825259ac$export$5e0d802a5d865352,
        pageId: "proforma-export",
        shouldShowSpinner: true
    });
$9c01414b825259ac$var$AsyncProformaExport.displayName = "AsyncProformaExport";
var $9c01414b825259ac$export$2e2bcd8739ae039 = $9c01414b825259ac$var$AsyncProformaExport;

});
parcelRegister("i6Xru", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hfXuW").then(()=>parcelRequire('h647P'));

});



parcelRegister("6zgxN", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsGeneralRouteEntry", () => $dc5fc3521b98fed4$export$90d7a2fe9ba3bc11);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $bh80l = parcelRequire("bh80l");

var $dK8bD = parcelRequire("dK8bD");
const $dc5fc3521b98fed4$export$90d7a2fe9ba3bc11 = (0, $fdS54.createEntry)((0, $bh80l.proformaIssueFormsGeneralRoute), ()=>({
        group: 'proforma',
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dK8bD.default),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dK8bD.LazyProformaIssueFormsGeneral)
        ],
        perfMetricKey: 'issue-forms-general',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bh80l", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsGeneralRoute", () => $acaabe69ccd3a9b1$export$5e0c19066a4c3806);
const $acaabe69ccd3a9b1$export$5e0c19066a4c3806 = {
    name: 'proforma-issue-forms-general',
    path: '/jira/forms/create',
    exact: true
};

});

parcelRegister("dK8bD", function(module, exports) {
$parcel$export(module.exports, "LazyProformaIssueFormsGeneral", () => $21d7c7e2527f075e$export$7c16b09eb95f1c5d);
$parcel$export(module.exports, "default", () => $21d7c7e2527f075e$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $21d7c7e2527f075e$export$7c16b09eb95f1c5d = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("dqqkg")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/ProformaIssueForms.tsx"
});
const $21d7c7e2527f075e$var$AsyncProformaIssueFormsGeneral = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $21d7c7e2527f075e$export$7c16b09eb95f1c5d,
        pageId: "proforma-issue-forms-general",
        shouldShowSpinner: true
    });
$21d7c7e2527f075e$var$AsyncProformaIssueFormsGeneral.displayName = "AsyncProformaIssueFormsGeneral";
var $21d7c7e2527f075e$export$2e2bcd8739ae039 = $21d7c7e2527f075e$var$AsyncProformaIssueFormsGeneral;

});
parcelRegister("dqqkg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("cfsci")
]).then(()=>parcelRequire('2HOiJ'));

});



parcelRegister("g5T7e", function(module, exports) {
$parcel$export(module.exports, "projectComponentsRedirectRouteEntry", () => $fc42ae4e63de20b8$export$b498607b4440c4ef);


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $iWjn3 = parcelRequire("iWjn3");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $gO3Ra = parcelRequire("gO3Ra");

var $avkF2 = parcelRequire("avkF2");
const $fc42ae4e63de20b8$export$b498607b4440c4ef = (0, $fdS54.createEntry)((0, $gO3Ra.projectComponentsRedirectRoute), ()=>({
        group: 'components',
        // eslint-disable-next-line no-restricted-syntax
        component: !false ? (0, $avkF2.ComponentsRedirect) : undefined,
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $iWjn3.projectsComponentsResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iWjn3", function(module, exports) {
$parcel$export(module.exports, "projectsComponentsResource", () => $7cbaedbdb907f6d9$export$557cc3eff8939b3);

var $7edbf = parcelRequire("7edbf");
const $7cbaedbdb907f6d9$var$MIN_MAX_AGE = 5000;
const $7cbaedbdb907f6d9$var$RESOURCE_TYPE_PROJECTS_COMPONENTS = 'PROJECTS_COMPONENTS';

const $7cbaedbdb907f6d9$export$557cc3eff8939b3 = (0, $7edbf.createResource)({
    type: $7cbaedbdb907f6d9$var$RESOURCE_TYPE_PROJECTS_COMPONENTS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("eoDkL")),
    maxAge: $7cbaedbdb907f6d9$var$MIN_MAX_AGE
});

});
parcelRegister("eoDkL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aEnAc").then(()=>parcelRequire('8iFUF'));

});


parcelRegister("gO3Ra", function(module, exports) {
$parcel$export(module.exports, "projectComponentsRedirectRoute", () => $daa87d112f4b44d2$export$d370abe25253fa1b);
const $daa87d112f4b44d2$export$d370abe25253fa1b = {
    name: 'project-components-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
    ]
};

});

parcelRegister("avkF2", function(module, exports) {
$parcel$export(module.exports, "ComponentsRedirect", () => $3eb1bca496e96b84$export$9cf9ae84482ff18e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $21iIq = parcelRequire("21iIq");

var $97Edu = parcelRequire("97Edu");
const $3eb1bca496e96b84$export$9cf9ae84482ff18e = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $21iIq.qs).stringify(rest, true);
        return `/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $97Edu.RedirectToProjectType), {
        page: page
    });
};
$3eb1bca496e96b84$export$9cf9ae84482ff18e.displayName = "ComponentsRedirect";

});
parcelRegister("97Edu", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $a3cc3fafa32067bc$export$8a3df560509448b8);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable import/order */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $edf7u = parcelRequire("edf7u");

var $eNr3t = parcelRequire("eNr3t");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");
var $bc9Gj = parcelRequire("bc9Gj");
const $a3cc3fafa32067bc$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $gNbXR.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $aJ81Y.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $inMxE.useAnalyticsEvents), useResource: useResource = (0, $k6ufm.useResource), useRouter: useRouter = (0, $bc9Gj.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $eNr3t.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $edf7u.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $euxye.useRef)(createAnalyticsEvent({}));
    (0, $euxye.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $f99M0.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $f99M0.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $f99M0.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};
$a3cc3fafa32067bc$export$8a3df560509448b8.displayName = "RedirectToProjectType";

});



parcelRegister("cbovl", function(module, exports) {
$parcel$export(module.exports, "projectComponentsRouteEntry", () => $498cd9c0299111ea$export$e60f53ff5ae626cd);



var $hdZjx = parcelRequire("hdZjx");

var $8rTlC = parcelRequire("8rTlC");

var $6RSCO = parcelRequire("6RSCO");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $iWjn3 = parcelRequire("iWjn3");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $8iQcO = parcelRequire("8iQcO");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $9dMXV = parcelRequire("9dMXV");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $i860n = parcelRequire("i860n");

var $eDEQ5 = parcelRequire("eDEQ5");
const $498cd9c0299111ea$var$projectComponentsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8rTlC.projectComponentsEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $498cd9c0299111ea$var$GSNProjectComponentsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8rTlC.projectComponentsEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $498cd9c0299111ea$export$e60f53ff5ae626cd = (0, $fdS54.createEntry)((0, $8iQcO.projectComponentsRoute), ()=>({
        group: 'components',
        ufoName: 'project-components-view',
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $iWjn3.projectsComponentsResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $9dMXV.projectGlobalComponentsResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? $498cd9c0299111ea$var$GSNProjectComponentsPageEntryPoint : $498cd9c0299111ea$var$projectComponentsPageEntryPoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8rTlC", function(module, exports) {
$parcel$export(module.exports, "projectComponentsEntrypoint", () => $ca34dda923453184$export$d90db228c6acd520);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ca34dda923453184$export$d90db228c6acd520 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jhpGq")), {
        moduleId: "4b4108ce",
        moduleName: "ExportedDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jhpGq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("iiLo6")
]).then(()=>parcelRequire('2TqRv'));

});


parcelRegister("8iQcO", function(module, exports) {
$parcel$export(module.exports, "projectComponentsRoute", () => $150817013cea9e91$export$f76189bea494b0b8);
const $150817013cea9e91$export$f76189bea494b0b8 = {
    name: 'project-components',
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
};

});


parcelRegister("a4ljM", function(module, exports) {
$parcel$export(module.exports, "projectDirectoryRedirectRouteEntry", () => $80e35d3f427f97d2$export$f1f04e35fd5f4283);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $jh3zV = parcelRequire("jh3zV");

var $dLVGe = parcelRequire("dLVGe");

var $h2tgz = parcelRequire("h2tgz");
const $80e35d3f427f97d2$var$ProjectsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/projects"
    });
$80e35d3f427f97d2$var$ProjectsDirectoryRedirect.displayName = "ProjectsDirectoryRedirect";
const $80e35d3f427f97d2$export$f1f04e35fd5f4283 = (0, $fdS54.createEntry)((0, $jh3zV.projectDirectoryRedirectRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: $80e35d3f427f97d2$var$ProjectsDirectoryRedirect,
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        isRedirect: true,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jh3zV", function(module, exports) {
$parcel$export(module.exports, "projectDirectoryRedirectRoute", () => $1721ca01413e9601$export$3913c8bee519225c);
const $1721ca01413e9601$export$3913c8bee519225c = {
    name: 'project-directory-redirect',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("k9FZd", function(module, exports) {
$parcel$export(module.exports, "projectIssueNavigatorRouteEntry", () => $f80af2ba623fc5fc$export$d6b778af15db7d3);


var $6RSCO = parcelRequire("6RSCO");

var $dvtoW = parcelRequire("dvtoW");


var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $fW0vK = parcelRequire("fW0vK");

var $2EQPz = parcelRequire("2EQPz");


var $i860n = parcelRequire("i860n");

var $836A7 = parcelRequire("836A7");

var $31tCE = parcelRequire("31tCE");

var $2A6mK = parcelRequire("2A6mK");
const $f80af2ba623fc5fc$export$d6b778af15db7d3 = (0, $fdS54.createEntry)((0, $fW0vK.projectIssueNavigatorRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        },
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $836A7.getCommonProjectResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        layout: (0, $QhQu4.createLayout)((0, $dvtoW.genericProjectLayout)),
        entryPoint: ()=>(0, $i860n.fg)('nin_glance_panel_technical_changes') ? (0, $2A6mK.issueNavigatorPinRedirectPageEntryPoint) : (0, $2A6mK.issueNavigatorPinRedirectPageEntryPointWithoutPreviewPanel),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin')
    }));

});
parcelRegister("fW0vK", function(module, exports) {
$parcel$export(module.exports, "projectIssueNavigatorRoute", () => $5b8ad1558d623e92$export$126b16ec65343bf);
const $5b8ad1558d623e92$export$126b16ec65343bf = {
    name: 'issue-navigator',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("6tnzy", function(module, exports) {
$parcel$export(module.exports, "projectNotFoundRouteEntry", () => $b32055500ffa6850$export$beae48175e3016b8);
/* eslint-disable import/order */ 
var $8e9Wj = parcelRequire("8e9Wj");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dpGjK = parcelRequire("dpGjK");
const $b32055500ffa6850$var$projectNotFoundPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8e9Wj.projectNotFoundEntryPoint)
});
const $b32055500ffa6850$export$beae48175e3016b8 = (0, $fdS54.createEntry)((0, $dpGjK.projectNotFoundRoute), ()=>({
        group: 'errors',
        entryPoint () {
            return $b32055500ffa6850$var$projectNotFoundPageEntryPoint;
        },
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        pageId: 'project-not-found-page-id',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8e9Wj", function(module, exports) {
$parcel$export(module.exports, "projectNotFoundEntryPoint", () => $d021ad721476f520$export$6ffa2f426ba3b25a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $d021ad721476f520$export$6ffa2f426ba3b25a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7v0sU")), {
        moduleId: "2aa2f4e8",
        moduleName: "ProjectNotFoundOrNoPermissionErrorPageWithAnalytics",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7v0sU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9jnB5").then(()=>parcelRequire('1kUrL'));

});


parcelRegister("dpGjK", function(module, exports) {
$parcel$export(module.exports, "projectNotFoundRoute", () => $07acc2588d128382$export$ad23ddca45852d02);
const $07acc2588d128382$export$ad23ddca45852d02 = {
    name: 'project-not-found',
    path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
    exact: true
};

});


parcelRegister("hVFyq", function(module, exports) {
$parcel$export(module.exports, "projectPagesLegacyRouteEntry", () => $ea7e134bfc3e773b$export$5788c5f8c4e440b1);


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jKOWk = parcelRequire("jKOWk");

var $2cU7d = parcelRequire("2cU7d");
const $ea7e134bfc3e773b$export$5788c5f8c4e440b1 = (0, $fdS54.createEntry)((0, $jKOWk.projectPagesLegacyRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: !false ? (0, $2cU7d.PagesRedirect) : (0, $2cU7d.default),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2cU7d.LazyProjectPages)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jKOWk", function(module, exports) {
$parcel$export(module.exports, "projectPagesLegacyRoute", () => $c955203edfba8f6e$export$a82cbb9b9c689c40);
const $c955203edfba8f6e$export$a82cbb9b9c689c40 = {
    name: 'project-pages-legacy',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
    ]
};

});

parcelRegister("2cU7d", function(module, exports) {
$parcel$export(module.exports, "LazyProjectPages", () => $f13c347f5e4d54e8$export$c2115a649411f570);
$parcel$export(module.exports, "PagesRedirect", () => $f13c347f5e4d54e8$export$7c3b1828ada63555);
$parcel$export(module.exports, "default", () => $f13c347f5e4d54e8$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $avy17 = parcelRequire("avy17");

const $f13c347f5e4d54e8$export$c2115a649411f570 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hf4T4"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project-pages/src/ProjectPages.tsx"
});
const $f13c347f5e4d54e8$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $avy17.RedirectToProjectType), {
        page: "/pages"
    });
$f13c347f5e4d54e8$export$7c3b1828ada63555.displayName = "PagesRedirect";
const $f13c347f5e4d54e8$var$AsyncProjectPages = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f13c347f5e4d54e8$export$c2115a649411f570,
        pageId: "project-pages",
        shouldShowSpinner: false
    });
$f13c347f5e4d54e8$var$AsyncProjectPages.displayName = "AsyncProjectPages";
var $f13c347f5e4d54e8$export$2e2bcd8739ae039 = $f13c347f5e4d54e8$var$AsyncProjectPages;

});
parcelRegister("avy17", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $80f549856d4a4bbe$export$8a3df560509448b8);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable import/order */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $edf7u = parcelRequire("edf7u");

var $eNr3t = parcelRequire("eNr3t");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");
var $bc9Gj = parcelRequire("bc9Gj");
const $80f549856d4a4bbe$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $gNbXR.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $aJ81Y.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $inMxE.useAnalyticsEvents), useResource: useResource = (0, $k6ufm.useResource), useRouter: useRouter = (0, $bc9Gj.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $eNr3t.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $edf7u.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $euxye.useRef)(createAnalyticsEvent({}));
    (0, $euxye.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $f99M0.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $f99M0.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $f99M0.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};
$80f549856d4a4bbe$export$8a3df560509448b8.displayName = "RedirectToProjectType";

});

parcelRegister("hf4T4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("1SALP")
]).then(()=>parcelRequire('5iuaY'));

});



parcelRegister("eoAAr", function(module, exports) {
$parcel$export(module.exports, "projectPagesRouteEntry", () => $4ef943c1c3863c70$export$babf32528ef518e9);


var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $052eo = parcelRequire("052eo");

var $jEYuY = parcelRequire("jEYuY");

var $aWliK = parcelRequire("aWliK");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $5Eie0 = parcelRequire("5Eie0");

var $gZWlI = parcelRequire("gZWlI");

var $2cU7d = parcelRequire("2cU7d");
const $4ef943c1c3863c70$export$babf32528ef518e9 = (0, $fdS54.createEntry)((0, $5Eie0.projectPagesRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $gZWlI.projectThemeResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)((0, $052eo.isDevopsFeatureDisabledInFedRamp), (0, $lFLfF.default), (0, $2cU7d.default)),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2cU7d.LazyProjectPages)
        ],
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5Eie0", function(module, exports) {
$parcel$export(module.exports, "projectPagesRoute", () => $638b8cac901f6226$export$54a218ca6d1c056a);
const $638b8cac901f6226$export$54a218ca6d1c056a = {
    name: 'project-pages',
    path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
};

});


parcelRegister("7ydol", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRouteEntry", () => $84adf00c0c8656fe$export$78ff5b5f42b9de4);


var $dUAVJ = parcelRequire("dUAVJ");

var $lJNe8 = parcelRequire("lJNe8");

var $jEYuY = parcelRequire("jEYuY");

var $7XVba = parcelRequire("7XVba");

var $fdS54 = parcelRequire("fdS54");

var $3F5Fd = parcelRequire("3F5Fd");

var $85jAF = parcelRequire("85jAF");

var $vXFSB = parcelRequire("vXFSB");

var $72Jlz = parcelRequire("72Jlz");
const $84adf00c0c8656fe$export$78ff5b5f42b9de4 = (0, $fdS54.createEntry)((0, $3F5Fd.projectsDirectoryLegacyPathRedirectRoute), ()=>({
        group: 'directories',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $vXFSB.ProjectsDirectoryRedirect),
        skeleton: (0, $85jAF.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $7XVba.homepageLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $lJNe8.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $72Jlz.LazyProjectsDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3F5Fd", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $6dcf2521769c52f2$export$c713f57300a82898);
const $6dcf2521769c52f2$export$c713f57300a82898 = {
    name: 'projects-directory-legacy-path-spa-redirect',
    path: '/secure/BrowseProjects.jspa'
};

});

parcelRegister("vXFSB", function(module, exports) {
$parcel$export(module.exports, "ProjectsDirectoryRedirect", () => $fed406ec7b34375f$export$b68dd6112a931c10);

var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");
const $fed406ec7b34375f$export$b68dd6112a931c10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/projects"
    });
$fed406ec7b34375f$export$b68dd6112a931c10.displayName = "ProjectsDirectoryRedirect";

});


parcelRegister("kgTjJ", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryManageRedirectRouteEntry", () => $83d1f0e2bb289e7e$export$c3c347e60b82f074);

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $7adso = parcelRequire("7adso");

var $85jAF = parcelRequire("85jAF");

var $kgaaS = parcelRequire("kgaaS");

var $jCwQG = parcelRequire("jCwQG");

var $72Jlz = parcelRequire("72Jlz");
const $83d1f0e2bb289e7e$export$c3c347e60b82f074 = (0, $fdS54.createEntry)((0, $7adso.projectsDirectoryManageRedirectRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kgaaS.ProjectsDirectoryManageRedirect),
        skeleton: (0, $85jAF.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {},
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jCwQG.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $72Jlz.LazyProjectsDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7adso", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $f91fbc535471050a$export$dbd3b6c012e8b6dc);
const $f91fbc535471050a$export$dbd3b6c012e8b6dc = {
    name: 'projects-directory-manage-redirect',
    path: '/secure/project/ViewProjects.jspa'
};

});

parcelRegister("kgaaS", function(module, exports) {
$parcel$export(module.exports, "ProjectsDirectoryManageRedirect", () => $077dc00d5cbd9031$export$74316a0a4963952b);

var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");
const $077dc00d5cbd9031$export$74316a0a4963952b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/settings/projects/manage"
    });
$077dc00d5cbd9031$export$74316a0a4963952b.displayName = "ProjectsDirectoryManageRedirect";

});


parcelRegister("9C3lY", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRouteEntry", () => $d0415ecc393486db$export$3f6ec3224d4c9da);

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $bfjsd = parcelRequire("bfjsd");

var $85jAF = parcelRequire("85jAF");

var $kgaaS = parcelRequire("kgaaS");

var $jCwQG = parcelRequire("jCwQG");

var $72Jlz = parcelRequire("72Jlz");
const $d0415ecc393486db$export$3f6ec3224d4c9da = (0, $fdS54.createEntry)((0, $bfjsd.projectsDirectoryManageRootRedirectRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kgaaS.ProjectsDirectoryManageRedirect),
        skeleton: (0, $85jAF.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {},
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jCwQG.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $72Jlz.LazyProjectsDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bfjsd", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $346400ff276c5572$export$4531e3b2e25fad23);
const $346400ff276c5572$export$4531e3b2e25fad23 = {
    name: 'projects-directory-manage-root-redirect',
    path: '/jira/settings/projects',
    exact: true
};

});


parcelRegister("9lQYl", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRedirectRouteEntry", () => $630a4684310070e9$export$8d9d65bb59f2354e);


var $dUAVJ = parcelRequire("dUAVJ");

var $lJNe8 = parcelRequire("lJNe8");

var $jEYuY = parcelRequire("jEYuY");

var $7XVba = parcelRequire("7XVba");

var $fdS54 = parcelRequire("fdS54");

var $3d31j = parcelRequire("3d31j");

var $85jAF = parcelRequire("85jAF");

var $vXFSB = parcelRequire("vXFSB");

var $72Jlz = parcelRequire("72Jlz");
const $630a4684310070e9$export$8d9d65bb59f2354e = (0, $fdS54.createEntry)((0, $3d31j.projectsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $vXFSB.ProjectsDirectoryRedirect),
        skeleton: (0, $85jAF.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $7XVba.homepageLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $lJNe8.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $72Jlz.LazyProjectsDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3d31j", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $ffb7ccdd52cad6fc$export$d44f1be3782f0fde);
const $ffb7ccdd52cad6fc$export$d44f1be3782f0fde = {
    name: 'projects-directory-redirect',
    path: '/projects',
    exact: true
};

});


parcelRegister("fKGT4", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRouteEntry", () => $0e6419f08153243a$export$79292a834772288c);


var $dUAVJ = parcelRequire("dUAVJ");

var $assfe = parcelRequire("assfe");

var $fdS54 = parcelRequire("fdS54");

var $2ONXd = parcelRequire("2ONXd");

var $85jAF = parcelRequire("85jAF");

var $1Mfsg = parcelRequire("1Mfsg");
const $0e6419f08153243a$export$79292a834772288c = (0, $fdS54.createEntry)((0, $2ONXd.projectsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint () {
            return 0, $1Mfsg.ProjectsDirectoryPageEntryPoint;
        },
        skeleton: (0, $85jAF.ProjectsDirectorySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $assfe.onboardingFlowCompletedResource)
        ],
        ufoName: 'projects-directory-v3',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2ONXd", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRoute", () => $39f601795d5967a5$export$74114064f06cd71b);
const $39f601795d5967a5$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true,
    query: [
        'csm_onboarding?'
    ]
};

});


parcelRegister("gWFAG", function(module, exports) {
$parcel$export(module.exports, "projectServiceDeskRouteEntry", () => $1d16d65e43221898$export$8810bfd4f6a0eb22);


var $3lEJh = parcelRequire("3lEJh");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $2JRrd = parcelRequire("2JRrd");

var $74h93 = parcelRequire("74h93");
const $1d16d65e43221898$export$8810bfd4f6a0eb22 = (0, $fdS54.createEntry)((0, $2JRrd.projectServiceDeskRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3lEJh.RedirectToLastVisitedProjectPage),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2JRrd", function(module, exports) {
$parcel$export(module.exports, "projectServiceDeskRoute", () => $63f9dcf60fc3b469$export$1cfc858068dd8718);
const $63f9dcf60fc3b469$export$1cfc858068dd8718 = {
    name: 'servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});


parcelRegister("edcP1", function(module, exports) {
$parcel$export(module.exports, "projectSettingsAutomationCRouteEntry", () => $0815a037ae5f1dc3$export$8a6c5a399335fa16);



var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $4styA = parcelRequire("4styA");

var $3eysO = parcelRequire("3eysO");

var $a3Ozg = parcelRequire("a3Ozg");
const $0815a037ae5f1dc3$export$8a6c5a399335fa16 = (0, $fdS54.createEntry)((0, $4styA.projectSettingsAutomationCRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings-automation-c',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $a3Ozg.default),
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $a3Ozg.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4styA", function(module, exports) {
$parcel$export(module.exports, "projectSettingsAutomationCRoute", () => $88d8d996c4c1039b$export$5337cc16f271a9cf);
const $88d8d996c4c1039b$export$5337cc16f271a9cf = {
    name: 'project-settings-automation',
    path: '/jira/software/c/projects/:projectKey/settings/automate'
};

});

parcelRegister("a3Ozg", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $97f3e2d2691403d6$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $97f3e2d2691403d6$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $97f3e2d2691403d6$export$dea5ad7e8eac12ae = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9DEIu")), {
    moduleId: "./src/packages/spa-apps/project-settings-jira-automation/src/ExportedDefault.tsx"
});
const $97f3e2d2691403d6$var$AsyncProjectSettingsJiraAutomation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $97f3e2d2691403d6$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });
$97f3e2d2691403d6$var$AsyncProjectSettingsJiraAutomation.displayName = "AsyncProjectSettingsJiraAutomation";
var $97f3e2d2691403d6$export$2e2bcd8739ae039 = $97f3e2d2691403d6$var$AsyncProjectSettingsJiraAutomation;

});
parcelRegister("9DEIu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3h60P").then(()=>parcelRequire('2gaMj'));

});



parcelRegister("e0XiB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsAutomationRouteEntry", () => $ce64a17f11491cef$export$a34f85c5b69f2c2f);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $h5Ssy = parcelRequire("h5Ssy");

var $3eysO = parcelRequire("3eysO");

var $a3Ozg = parcelRequire("a3Ozg");

var $gyAS0 = parcelRequire("gyAS0");
const $ce64a17f11491cef$export$a34f85c5b69f2c2f = (0, $fdS54.createEntry)((0, $h5Ssy.projectSettingsAutomationRoute), ()=>({
        group: 'project-settings-software',
        ufoName: `project-settings-automation-${0, $gyAS0.SOFTWARE_PRODUCT}`,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $a3Ozg.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $a3Ozg.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("h5Ssy", function(module, exports) {
$parcel$export(module.exports, "projectSettingsAutomationRoute", () => $9a14f98016efaa44$export$7809aa084868deea);
const $9a14f98016efaa44$export$7809aa084868deea = {
    name: 'project-settings-automation',
    path: '/jira/software/projects/:projectKey/settings/automate'
};

});


parcelRegister("7ZEak", function(module, exports) {
$parcel$export(module.exports, "projectSettingsComponentsRouteEntry", () => $98a5196b6cbe3a07$export$72497f4e39dd0df4);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $iWjn3 = parcelRequire("iWjn3");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $9dMXV = parcelRequire("9dMXV");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $cSIKa = parcelRequire("cSIKa");

var $7TxSI = parcelRequire("7TxSI");
const $98a5196b6cbe3a07$export$72497f4e39dd0df4 = (0, $fdS54.createEntry)((0, $cSIKa.projectSettingsComponentsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $iWjn3.projectsComponentsResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $9dMXV.projectGlobalComponentsResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7TxSI.default),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7TxSI.LazyProjectComponentsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cSIKa", function(module, exports) {
$parcel$export(module.exports, "projectSettingsComponentsRoute", () => $c8348057486597af$export$79cbce13eeecd53);
const $c8348057486597af$export$79cbce13eeecd53 = {
    name: 'project-settings-components',
    path: '/plugins/servlet/project-config/:projectKey/administer-components'
};

});

parcelRegister("7TxSI", function(module, exports) {
$parcel$export(module.exports, "LazyProjectComponentsSettings", () => $abb698a895b2d0b6$export$bb69d8c36391123);
$parcel$export(module.exports, "default", () => $abb698a895b2d0b6$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $21iIq = parcelRequire("21iIq");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $4Pf2u = parcelRequire("4Pf2u");

const $abb698a895b2d0b6$export$bb69d8c36391123 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("jhpGq"))), {
    moduleId: "./src/packages/spa-apps/project-components/src/ExportedDefault.tsx"
});
const $abb698a895b2d0b6$export$60cfbcd781a48d01 = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $21iIq.qs).stringify(rest, true);
        return `/settings/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4Pf2u.RedirectToProjectType), {
        page: page
    });
};
$abb698a895b2d0b6$export$60cfbcd781a48d01.displayName = "SettingsComponentsRedirect";
const $abb698a895b2d0b6$var$AsyncProjectComponentsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $abb698a895b2d0b6$export$bb69d8c36391123,
        pageId: "project-settings-components",
        shouldShowSpinner: true
    });
$abb698a895b2d0b6$var$AsyncProjectComponentsSettings.displayName = "AsyncProjectComponentsSettings";
var $abb698a895b2d0b6$export$2e2bcd8739ae039 = $abb698a895b2d0b6$var$AsyncProjectComponentsSettings;

});
parcelRegister("4Pf2u", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $bdff1887c4c644db$export$8a3df560509448b8);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable import/order */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $edf7u = parcelRequire("edf7u");

var $eNr3t = parcelRequire("eNr3t");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");
var $bc9Gj = parcelRequire("bc9Gj");
const $bdff1887c4c644db$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $gNbXR.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $aJ81Y.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $inMxE.useAnalyticsEvents), useResource: useResource = (0, $k6ufm.useResource), useRouter: useRouter = (0, $bc9Gj.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $eNr3t.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $edf7u.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $euxye.useRef)(createAnalyticsEvent({}));
    (0, $euxye.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $f99M0.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $f99M0.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $f99M0.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};
$bdff1887c4c644db$export$8a3df560509448b8.displayName = "RedirectToProjectType";

});



parcelRegister("j333x", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRouteEntry", () => $f8f3f0ade0dd7d6d$export$36e1851c22975fc0);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $1hzLA = parcelRequire("1hzLA");

var $gNbXR = parcelRequire("gNbXR");

var $6leOq = parcelRequire("6leOq");

var $7BLnC = parcelRequire("7BLnC");
const $f8f3f0ade0dd7d6d$export$36e1851c22975fc0 = (0, $fdS54.createEntry)((0, $1hzLA.projectSettingsCoreAccessRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
                to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                push: false
            }),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7BLnC.LazyPeopleSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1hzLA", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRoute", () => $1e8b24ba2cfa2122$export$59e3323ba0cc224a);
const $1e8b24ba2cfa2122$export$59e3323ba0cc224a = {
    name: 'project-settings-core-access-redirect',
    path: '/jira/core/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("7BLnC", function(module, exports) {
$parcel$export(module.exports, "LazyPeopleSettings", () => $cae35ad39bfda2e4$export$7eee4f97b7a1273);

var $jhKsF = parcelRequire("jhKsF");

var $l8G1z = parcelRequire("l8G1z");

const $cae35ad39bfda2e4$export$7eee4f97b7a1273 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7grbQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings-people/src/index.tsx"
});

});
parcelRegister("7grbQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4ABx9").then(()=>parcelRequire('keJqT'));

});



parcelRegister("3dAlK", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAccessRouteEntry", () => $c54053021ae5b9e9$export$8188648c76953df0);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $1GRSQ = parcelRequire("1GRSQ");

var $k2tg5 = parcelRequire("k2tg5");

var $8bf4L = parcelRequire("8bf4L");

var $6leOq = parcelRequire("6leOq");

var $7BLnC = parcelRequire("7BLnC");
const $c54053021ae5b9e9$var$Access = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: (0, $7BLnC.LazyPeopleSettings),
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
$c54053021ae5b9e9$var$Access.displayName = "Access";
const $c54053021ae5b9e9$export$8188648c76953df0 = (0, $fdS54.createEntry)((0, $1GRSQ.projectSettingsCoreAccessRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $c54053021ae5b9e9$var$Access,
        skeleton: (0, $k2tg5.ProjectSettingsAccessSkeleton),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7BLnC.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1GRSQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAccessRoute", () => $1f38446ff33de183$export$fe93051d5b7385a1);
const $1f38446ff33de183$export$fe93051d5b7385a1 = {
    name: 'project-settings-core-access',
    path: '/jira/core/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("2mJeL", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreApprovalsRouteEntry", () => $83205adc53c3bd45$export$728033a86ab68014);



var $l9IXC = parcelRequire("l9IXC");

var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $fU8CV = parcelRequire("fU8CV");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $heQaP = parcelRequire("heQaP");

var $6leOq = parcelRequire("6leOq");
const $83205adc53c3bd45$var$approvalsProjectSettingsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l9IXC.approvalsProjectSettingsEntryPoint)
});
const $83205adc53c3bd45$export$728033a86ab68014 = (0, $fdS54.createEntry)((0, $heQaP.projectSettingsCoreApprovalsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        entryPoint () {
            return $83205adc53c3bd45$var$approvalsProjectSettingsPageEntryPoint;
        },
        ufoName: 'project-settings-approvals-core',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("l9IXC", function(module, exports) {
$parcel$export(module.exports, "approvalsProjectSettingsEntryPoint", () => $ac3b2a9d4d5f1b14$export$1389a6ddf34f642e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $lpVEC = parcelRequire("lpVEC");

const $ac3b2a9d4d5f1b14$export$1389a6ddf34f642e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("l059U")), {
        moduleId: "cbe35575",
        moduleName: "JiraBusinessApprovalsProjectSettingsAppMemo",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsSettingsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $lpVEC.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("lpVEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cde262f1ddf4bbe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<766267f2a1c94103f5a30f040a6260f4>>
 * @relayHash 37ad7e4470edca57db1b559b865fb655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b17c4c0654abced26a7b9a4157ebf319e48dbab2f71da56fb795f76cca95b3e8
const $2cde262f1ddf4bbe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b17c4c0654abced26a7b9a4157ebf319e48dbab2f71da56fb795f76cca95b3e8",
        "metadata": {},
        "name": "JiraBusinessApprovalsProjectSettingsAppMemoQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2cde262f1ddf4bbe$export$2e2bcd8739ae039 = $2cde262f1ddf4bbe$var$node;

});

parcelRegister("l059U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("igT6v").then(()=>parcelRequire('hJzgw'));

});


parcelRegister("heQaP", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreApprovalsRoute", () => $56a960959a063d85$export$ba11c8f378a2c121);
const $56a960959a063d85$export$ba11c8f378a2c121 = {
    name: 'project-settings-core-approvals',
    path: '/jira/core/projects/:projectKey/settings/approvals',
    exact: true
};

});


parcelRegister("aczJL", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRouteEntry", () => $cbe914ae06215e8e$export$7870a0b1630a504e);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $cDpQ4 = parcelRequire("cDpQ4");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $cbe914ae06215e8e$var$LazyConnectAppControlsSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("i0lYp"))), {
    moduleId: "./src/packages/spa-apps/project-settings-connect-app-controls/src/ProjectSettingsConnectAppControls.tsx"
});
const $cbe914ae06215e8e$var$ConnectAppControlsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $cbe914ae06215e8e$var$LazyConnectAppControlsSettings,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
$cbe914ae06215e8e$var$ConnectAppControlsPage.displayName = "ConnectAppControlsPage";
const $cbe914ae06215e8e$export$7870a0b1630a504e = (0, $fdS54.createEntry)((0, $cDpQ4.projectSettingsCoreAppsFieldsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $cbe914ae06215e8e$var$ConnectAppControlsPage,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $cbe914ae06215e8e$var$LazyConnectAppControlsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cDpQ4", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRoute", () => $e82d9edd0664c17f$export$1c7e75ffaa491922);
const $e82d9edd0664c17f$export$1c7e75ffaa491922 = {
    name: 'project-settings-core-apps-fields',
    path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("i0lYp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("khkdM").then(()=>parcelRequire('8Po3n'));

});


parcelRegister("bY5oW", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAppsRouteEntry", () => $ba6107936e8decc7$export$c038a2892f34f1a9);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $71Jmz = parcelRequire("71Jmz");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $ba6107936e8decc7$var$LazyConnectAppsSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("aoRbT"))), {
    moduleId: "./src/packages/spa-apps/project-settings-connect-apps/src/ProjectSettingsApps.tsx"
});
const $ba6107936e8decc7$var$ConnectAppsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ba6107936e8decc7$var$LazyConnectAppsSettings,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
$ba6107936e8decc7$var$ConnectAppsPage.displayName = "ConnectAppsPage";
const $ba6107936e8decc7$export$c038a2892f34f1a9 = (0, $fdS54.createEntry)((0, $71Jmz.projectSettingsCoreAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $ba6107936e8decc7$var$ConnectAppsPage,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $ba6107936e8decc7$var$LazyConnectAppsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("71Jmz", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAppsRoute", () => $076bfa6e3ba3ce5a$export$c7ac65fb0bbe767f);
const $076bfa6e3ba3ce5a$export$c7ac65fb0bbe767f = {
    name: 'project-settings-core-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("aoRbT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5FiTB").then(()=>parcelRequire('6W7tW'));

});


parcelRegister("8FSAl", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAutomationRouteEntry", () => $2ac9f711afa93060$export$a244870e56f5c9a3);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $8Pj05 = parcelRequire("8Pj05");

var $6leOq = parcelRequire("6leOq");

var $7SYBp = parcelRequire("7SYBp");
const $2ac9f711afa93060$export$a244870e56f5c9a3 = (0, $fdS54.createEntry)((0, $8Pj05.projectSettingsCoreAutomationRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7SYBp.AutomationLazyPage),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7SYBp.LazyProjectSettingsJiraAutomation)
        ],
        ufoName: 'project-settings-automation-core',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8Pj05", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAutomationRoute", () => $eef48a674e97267b$export$65a4d727336c49f4);
const $eef48a674e97267b$export$65a4d727336c49f4 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automation'
};

});

parcelRegister("7SYBp", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $1ad2472bb775e6e7$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "AutomationLazyPage", () => $1ad2472bb775e6e7$export$88eebe21cecb82db);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1ad2472bb775e6e7$export$dea5ad7e8eac12ae = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9DEIu")), {
    moduleId: "./src/packages/spa-apps/project-settings-jira-automation/src/ExportedDefault.tsx"
});
const $1ad2472bb775e6e7$export$88eebe21cecb82db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1ad2472bb775e6e7$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });
$1ad2472bb775e6e7$export$88eebe21cecb82db.displayName = "AutomationLazyPage";

});


parcelRegister("c2gkm", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAutomationV2RouteEntry", () => $46d0e883937d8866$export$a2c8a6767edeeaed);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $9l9XN = parcelRequire("9l9XN");

var $6leOq = parcelRequire("6leOq");

var $7SYBp = parcelRequire("7SYBp");
const $46d0e883937d8866$export$a2c8a6767edeeaed = (0, $fdS54.createEntry)((0, $9l9XN.projectSettingsCoreAutomationV2Route), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7SYBp.AutomationLazyPage),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7SYBp.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9l9XN", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAutomationV2Route", () => $316179abac8bcd49$export$5437af2650f645e0);
const $316179abac8bcd49$export$5437af2650f645e0 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automate'
};

});


parcelRegister("72ryD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRouteEntry", () => $f957634fb7ba7ff9$export$cf5194c476e8bcdb);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $alhun = parcelRequire("alhun");

var $k2tg5 = parcelRequire("k2tg5");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $f957634fb7ba7ff9$var$LazyDataClassificationsSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("bWcHj"))), {
    moduleId: "./src/packages/spa-apps/project-settings-data-classifications/src/index.tsx"
});
const $f957634fb7ba7ff9$var$DataClassifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f957634fb7ba7ff9$var$LazyDataClassificationsSettings,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
$f957634fb7ba7ff9$var$DataClassifications.displayName = "DataClassifications";
const $f957634fb7ba7ff9$export$cf5194c476e8bcdb = (0, $fdS54.createEntry)((0, $alhun.projectSettingsCoreDataClassificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $f957634fb7ba7ff9$var$DataClassifications,
        skeleton: (0, $k2tg5.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("alhun", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRoute", () => $6874dd1a11e46991$export$7aae1006c82a79c0);
const $6874dd1a11e46991$export$7aae1006c82a79c0 = {
    name: 'project-settings-core-data-classifications',
    path: '/jira/core/projects/:projectKey/settings/data-classifications',
    exact: true
};

});


parcelRegister("2eHyY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRouteEntry", () => $3b2f2767e36ec5ea$export$df1c02c3f28b7a95);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $kbFfc = parcelRequire("kbFfc");

var $6leOq = parcelRequire("6leOq");

var $D36Qg = parcelRequire("D36Qg");
const $3b2f2767e36ec5ea$export$df1c02c3f28b7a95 = (0, $fdS54.createEntry)((0, $kbFfc.projectSettingsCoreDefaultRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $D36Qg.ProjectSettingsRedirect),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kbFfc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRoute", () => $9bd92e3074447e9c$export$322fe16ec991f12);
const $9bd92e3074447e9c$export$322fe16ec991f12 = {
    name: 'project-settings-core-redirect',
    path: '/jira/core/projects/:projectKey/settings'
};

});

parcelRegister("D36Qg", function(module, exports) {
$parcel$export(module.exports, "ProjectSettingsRedirect", () => $22f852e5ad689c37$export$72130cf40a3c3778);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8ANUF = parcelRequire("8ANUF");

var $gNbXR = parcelRequire("gNbXR");
const $22f852e5ad689c37$export$72130cf40a3c3778 = ({ match: match })=>{
    const { data: data, loading: loading } = (0, $8ANUF.useJiraWorkmanagementProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    // Wait for nav data to be available before deciding where to redirect on cold loads
    if (loading || !data) return null;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/core/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
    });
};
$22f852e5ad689c37$export$72130cf40a3c3778.displayName = "ProjectSettingsRedirect";

});


parcelRegister("5Fsvc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDetailsRouteEntry", () => $c69cb1e5621f90c7$export$438a330ccc1e7a91);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $98dWy = parcelRequire("98dWy");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $ehqpU = parcelRequire("ehqpU");

var $k2tg5 = parcelRequire("k2tg5");

var $dTa0V = parcelRequire("dTa0V");

var $6leOq = parcelRequire("6leOq");
const $c69cb1e5621f90c7$var$projectSettingsCoreDetailsPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $98dWy.projectDetailsPageEntrypoint)
});
const $c69cb1e5621f90c7$export$438a330ccc1e7a91 = (0, $fdS54.createEntry)((0, $ehqpU.projectSettingsCoreDetailsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        entryPoint: ()=>$c69cb1e5621f90c7$var$projectSettingsCoreDetailsPageEntrypoint,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        skeleton: (0, $k2tg5.ProjectSettingsDetailsSkeleton),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ehqpU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDetailsRoute", () => $193524610f2c6f85$export$14535b40530c8690);
const $193524610f2c6f85$export$14535b40530c8690 = {
    name: 'project-settings-core-details',
    path: '/jira/core/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("dF5Xf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreFieldsRouteEntry", () => $ca167842e580b11c$export$8d8dff75124dcebc);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $3Slbk = parcelRequire("3Slbk");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $ccEpm = parcelRequire("ccEpm");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $ca167842e580b11c$var$LazyFieldsSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("9hH3y"))), {
    moduleId: "./src/packages/spa-apps/project-settings-fields/src/ExportedDefault.tsx"
});
const $ca167842e580b11c$var$FieldsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ca167842e580b11c$var$LazyFieldsSettings,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
$ca167842e580b11c$var$FieldsPage.displayName = "FieldsPage";
const $ca167842e580b11c$export$8d8dff75124dcebc = (0, $fdS54.createEntry)((0, $ccEpm.projectSettingsCoreFieldsRoute), ()=>({
        group: 'project-settings-core',
        ufoName: 'project-settings.fields.jwm-tmp',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            (0, $3Slbk.fieldSettingsRelayResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $ca167842e580b11c$var$FieldsPage,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $ca167842e580b11c$var$LazyFieldsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3Slbk", function(module, exports) {
$parcel$export(module.exports, "fieldSettingsRelayResource", () => $fb0a6aaec00ea747$export$68b4e700e00bad7a);

var $fzcmC = parcelRequire("fzcmC");

var $i0CFV = parcelRequire("i0CFV");

var $htsFl = parcelRequire("htsFl");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");
const $fb0a6aaec00ea747$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
const $fb0a6aaec00ea747$export$68b4e700e00bad7a = (0, $htsFl.createRelayResource)({
    type: $fb0a6aaec00ea747$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        // Parse deep link parameters
        const fieldId = query.fieldId;
        const isValidSidebarId = [
            'EDIT'
        ].includes(query.sidebarId?.toUpperCase());
        const shouldPreloadField = Boolean(isValidSidebarId && !!fieldId);
        return {
            parameters: (0, $fzcmC.default),
            variables: {
                projectKey: projectKey ?? '',
                cloudId: tenantContext.cloudId ?? '',
                preloadedFieldId: fieldId ?? 'UNUSED_STRING',
                shouldPreloadField: shouldPreloadField ?? false,
                shouldEnforceLimits: (0, $i860n.fg)('enforce_limits_for_field_configuration_scheme_page') || (0, $i860n.fg)('limits_enforcement_via_backend'),
                shouldUseGuidedAutonomy: (0, $2700E.expVal)('frontier-guided-autonomy-eap', 'isEnabled', false)
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    }
});

});
parcelRegister("fzcmC", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b44201511248663$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7986424b7e85e3e4c837ecb1d1017dc4>>
 * @relayHash f3fe3f99f0358b6c9fc75a87e47efe41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc8000f877895f36b3ed559d71f3caea6440dc8d91730d818b11a15e7ef8c00

var $KUiqF = parcelRequire("KUiqF");

var $efrbL = parcelRequire("efrbL");

var $ayR1C = parcelRequire("ayR1C");

var $lIGkE = parcelRequire("lIGkE");
const $1b44201511248663$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "preloadedFieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldEnforceLimits"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldPreloadField"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldUseGuidedAutonomy"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "shouldEnforceLimits",
        "variableName": "shouldEnforceLimits"
    }, v8 = [
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "isExplicitFieldAssociationsEnabled"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "scope"
    }, v16 = {
        "kind": "ScalarField",
        "name": "typeName"
    }, v17 = {
        "kind": "ScalarField",
        "name": "description"
    }, v18 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hasMissingConfiguration"
    }, v20 = {
        "kind": "ScalarField",
        "name": "canRemove"
    }, v21 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v22 = {
        "kind": "ScalarField",
        "name": "canModifyOptions"
    }, v23 = {
        "concreteType": "JiraFieldOptionConnection",
        "kind": "LinkedField",
        "name": "fieldOptions",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraFieldOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraFieldOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "optionId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "parentOptionId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v12 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "kind": "LinkedField",
        "name": "fieldFormatConfig",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatDecimals"
                    },
                    {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "durationUnits"
                            }
                        ]
                    }
                ],
                "type": "JiraNumberFieldFormatConfig"
            }
        ]
    }, v26 = [
        {
            "concreteType": "JiraProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "allowLocalFields"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FieldsPageContentQuery",
            "selections": [
                {
                    "args": [
                        v6 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "shouldUseGuidedAutonomy",
                            "variableName": "shouldUseGuidedAutonomy"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "FieldsTable"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "FieldsPageHeader_limits"
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "args": [
                                        v7 /*: any*/ 
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "FieldsPageHeader"
                                },
                                {
                                    "condition": "shouldPreloadField",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "preloadedFieldId",
                                                    "variableName": "preloadedFieldId"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "DeepLinkSidebar"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider"
                }
            ],
            "kind": "Operation",
            "name": "FieldsPageContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v11 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "optionsPerFieldLimit"
                                },
                                {
                                    "concreteType": "JiraFieldTypeGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "projectFieldTypeGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldTypeGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldTypeGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedFieldsPerProjectLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedFieldsCount"
                                },
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectWithIssueTypeIds",
                                    "kind": "LinkedField",
                                    "name": "projectWithVisibleIssueTypeIds",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldAssociationWithIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldOperation",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOperation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canDelete"
                                                                        },
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                },
                                                                v23 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isFieldLocked"
                                                                },
                                                                v24 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "filters": [
                                                "input"
                                            ],
                                            "handle": "connection",
                                            "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "fieldAssociationWithIssueTypes"
                                        }
                                    ]
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "shouldUseGuidedAutonomy",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v26 /*: any*/ 
                                },
                                {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v26 /*: any*/ 
                                },
                                {
                                    "condition": "shouldEnforceLimits",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectWithIssueTypeIds",
                                            "kind": "LinkedField",
                                            "name": "projectWithVisibleIssueTypeIds",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "fieldAssociationWithIssueTypesCount",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 1
                                                        }
                                                    ],
                                                    "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldAssociationWithIssueTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "fieldAssociationWithIssueTypes(first:1)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "shouldPreloadField",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectWithIssueTypeIds",
                                            "kind": "LinkedField",
                                            "name": "projectWithVisibleIssueTypeIds",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "preloadedField",
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "fieldId",
                                                            "variableName": "preloadedFieldId"
                                                        }
                                                    ],
                                                    "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                    "kind": "LinkedField",
                                                    "name": "fieldAssociationWithIssueTypesByFieldId",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "field",
                                                            "plural": false,
                                                            "selections": [
                                                                v24 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        v23 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraFieldOperation",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOperation",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ]
                                                        },
                                                        v25 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldEnforceLimits",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filterKeys",
                                            "value": [
                                                "fields.per.project.limit"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraResourceUsageMetricLimitValue",
                                    "kind": "LinkedField",
                                    "name": "limitValues",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "limitValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "limitEnforced"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ccc8000f877895f36b3ed559d71f3caea6440dc8d91730d818b11a15e7ef8c00",
            "metadata": {},
            "name": "FieldsPageContentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": (0, $efrbL.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": (0, $ayR1C.default),
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default)
            }
        }
    };
}();
$1b44201511248663$var$node.hash = "598940e555852efd80a89e0376d0cd93";
(0, $lIGkE.PreloadableQueryRegistry).set($1b44201511248663$var$node.params.id, $1b44201511248663$var$node);
var $1b44201511248663$export$2e2bcd8739ae039 = $1b44201511248663$var$node;

});
parcelRegister("ayR1C", function(module, exports) {
$parcel$export(module.exports, "default", () => $74ce60906f6097de$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $2700E = parcelRequire("2700E");
var $74ce60906f6097de$export$2e2bcd8739ae039 = {
    get () {
        return (0, $2700E.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) && (0, $2700E.expVal)('thor_colourful_single_select_fields_experiment', 'isColorfulSingleSelectEnabled', false);
    }
};

});



parcelRegister("ccEpm", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreFieldsRoute", () => $f6b1d45a6c1def10$export$7c4ee74641923239);
const $f6b1d45a6c1def10$export$7c4ee74641923239 = {
    name: 'project-settings-core-fields',
    path: '/jira/core/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("9hH3y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gZmxv").then(()=>parcelRequire('7F3jc'));

});


parcelRegister("heQeQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreForgeAppsRouteEntry", () => $3db82cbb7612281e$export$1006fd9f5f02b1c2);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $aSBf5 = parcelRequire("aSBf5");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $3db82cbb7612281e$var$LazyForgeProjectSettingsPage = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7qZ2d")), {
    moduleId: "./src/packages/spa-apps/forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx"
});
const $3db82cbb7612281e$var$ForgeProjectSettingsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3db82cbb7612281e$var$LazyForgeProjectSettingsPage,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
$3db82cbb7612281e$var$ForgeProjectSettingsPage.displayName = "ForgeProjectSettingsPage";
const $3db82cbb7612281e$export$1006fd9f5f02b1c2 = (0, $fdS54.createEntry)((0, $aSBf5.projectSettingsCoreForgeAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $3db82cbb7612281e$var$ForgeProjectSettingsPage,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $3db82cbb7612281e$var$LazyForgeProjectSettingsPage
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aSBf5", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreForgeAppsRoute", () => $2d1ccd756d872f3c$export$b34160f55b6104e9);
const $2d1ccd756d872f3c$export$b34160f55b6104e9 = {
    name: 'project-settings-core-forge-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("7qZ2d", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("85RIs").then(()=>parcelRequire('bMu8a'));

});


parcelRegister("1tTym", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreIssueTypesRouteEntry", () => $c8f66493078a4a9e$export$95ecbacf0120fcfd);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $jb0co = parcelRequire("jb0co");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $c8f66493078a4a9e$var$LazyIssueTypeSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("foBE1"))), {
    moduleId: "./src/packages/spa-apps/project-settings-issue-type/src/IssueTypePage.tsx"
});
const $c8f66493078a4a9e$var$IssueTypePage = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c8f66493078a4a9e$var$LazyIssueTypeSettings,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
$c8f66493078a4a9e$var$IssueTypePage.displayName = "IssueTypePage";
const $c8f66493078a4a9e$export$95ecbacf0120fcfd = (0, $fdS54.createEntry)((0, $jb0co.projectSettingsCoreIssueTypesRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $c8f66493078a4a9e$var$IssueTypePage,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $c8f66493078a4a9e$var$LazyIssueTypeSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jb0co", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreIssueTypesRoute", () => $82cbe0ffa1d2d6d0$export$c3a32433c580b9ff);
const $82cbe0ffa1d2d6d0$export$c3a32433c580b9ff = {
    name: 'project-settings-core-issuetypes',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});


parcelRegister("eIaFf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRouteEntry", () => $1b814b4cc6ec4975$export$1dfd4811b9065dd6);

var $euxye = parcelRequire("euxye");

var $5qKUX = parcelRequire("5qKUX");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $fyoT9 = parcelRequire("fyoT9");

var $cH5Ll = parcelRequire("cH5Ll");

var $e2Z3B = parcelRequire("e2Z3B");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $4B518 = parcelRequire("4B518");

var $6bGyp = parcelRequire("6bGyp");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $byMD7 = parcelRequire("byMD7");

var $2700E = parcelRequire("2700E");

var $8hHpc = parcelRequire("8hHpc");

var $6leOq = parcelRequire("6leOq");

const $1b814b4cc6ec4975$var$LazyWorkflowNavigationSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("8xDGy"))), {
    moduleId: "./src/packages/spa-apps/project-settings-workflow-navigation/src/WorkflowNavigationPage.tsx"
});
const $1b814b4cc6ec4975$var$WorkflowNavigationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1b814b4cc6ec4975$var$LazyWorkflowNavigationSettings,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
$1b814b4cc6ec4975$var$WorkflowNavigationPage.displayName = "WorkflowNavigationPage";
const $1b814b4cc6ec4975$var$getWorkflowBuilderProvisioningResources = ()=>[
        (0, $fyoT9.workflowBuilderProvisioningResource)
    ];
const $1b814b4cc6ec4975$export$1dfd4811b9065dd6 = (0, $fdS54.createEntry)((0, $5qKUX.projectSettingsCoreIssueTypesWorkflowRoute), ()=>({
        group: 'project-settings-core',
        navigation: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? undefined : {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? (0, $byMD7.chromelessLayout) : (0, $fU8CV.coreProjectLayout),
        resources: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? [
            // Delete this resource after hix-7127_wfe_layout_to_chromeless_for_business experiment is over
            // AND usages of projectContextResource have been swapped with projectWorkflowContextResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8hHpc.projectWorkflowContextResource),
            (0, $e2Z3B.workflowCapabilitiesResource),
            (0, $cH5Ll.workflowDocumentResource),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $6bGyp.rovoEntitlementResource),
            ...$1b814b4cc6ec4975$var$getWorkflowBuilderProvisioningResources()
        ] : [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...$1b814b4cc6ec4975$var$getWorkflowBuilderProvisioningResources(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $1b814b4cc6ec4975$var$WorkflowNavigationPage,
        forPaint: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? [
            $1b814b4cc6ec4975$var$LazyWorkflowNavigationSettings
        ] : [
            (0, $jEYuY.LazyAtlassianNavigation),
            $1b814b4cc6ec4975$var$LazyWorkflowNavigationSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5qKUX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRoute", () => $c4d780cb7c86963f$export$9e79ee307216071b);
const $c4d780cb7c86963f$export$9e79ee307216071b = {
    name: 'project-settings-core-issuetypes-workflow',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("8hHpc", function(module, exports) {
$parcel$export(module.exports, "projectWorkflowContextResource", () => $5cc5cced17c0a861$export$622567128573c92f);
$parcel$export(module.exports, "useWorkflowProjectContext", () => $5cc5cced17c0a861$export$80419a93f26d85e1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


var $6Oj0M = parcelRequire("6Oj0M");
const $5cc5cced17c0a861$export$622567128573c92f = (0, $7edbf.createResource)({
    type: (0, $bc12d947cd9afed0$export$1be4077e1912f05d),
    getKey: (matchedRoute)=>(0, $i0CFV.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getData: $6Oj0M.default,
    maxAge: 0,
    isCritical: true,
    isBrowserOnly: true
});
const $5cc5cced17c0a861$export$80419a93f26d85e1 = ()=>(0, $k6ufm.useResource)($5cc5cced17c0a861$export$622567128573c92f);

});
/* eslint-disable jira/filename-case */ const $bc12d947cd9afed0$export$1be4077e1912f05d = 'PROJECT_WORKFLOW_CONTEXT';

parcelRegister("6Oj0M", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0ea7ea6b45bb20b$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable jira/import-whitelist */ // eslint-disable-next-line jira/import-whitelist

var $f99M0 = parcelRequire("f99M0");

var $i0CFV = parcelRequire("i0CFV");

var $siTdT = parcelRequire("siTdT");

var $75sVW = parcelRequire("75sVW");

var $h2wCv = parcelRequire("h2wCv");

const $d0ea7ea6b45bb20b$export$df64fe7442e4c87b = 512;
function $d0ea7ea6b45bb20b$var$extractAvatarIdFromIconUrl(iconUrl) {
    const regex = /\/avatar\/(\d+)/;
    const match = iconUrl.match(regex);
    if (match && match[1]) return parseInt(match[1], 10);
    return -1; // or handle the error as needed
}
const $d0ea7ea6b45bb20b$var$transformIssueTypes = (issueTypes)=>{
    if (!issueTypes || !issueTypes.edges) return [];
    return issueTypes.edges.map(({ node: node })=>({
            id: node.issueTypeId,
            name: node.name,
            iconUrl: node.avatar.large,
            avatarId: $d0ea7ea6b45bb20b$var$extractAvatarIdFromIconUrl(node.avatar.large),
            hierarchyLevel: node.hierarchy.level
        }));
};
const $d0ea7ea6b45bb20b$var$getProjectWorkflowContextData = async (projectIdOrKey, cloudId)=>{
    const fetchStartTime = performance.now();
    const { data: data, errors: errors } = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql?operation=JiraProjectWorkflowContext', {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'X-ExperimentalApi': 'JiraProject, projectStyle'
        },
        body: JSON.stringify({
            query: (0, $3a8a8563eee35fe7$export$2b91517d6d5b4365),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey
            }
        })
    });
    (0, $siTdT.addSpanToAll)('fetch', 'fetchProjectByKeyOrId', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    if (errors != null && errors.length > 0) {
        const statusCode = errors[0].extensions?.statusCode;
        throw new (0, $75sVW.default)(statusCode, `Fetch project context via AGG failed. Errors: ${errors.map((err)=>err.message).join(', ')}`);
    }
    const projectData = data?.jira_projectByIdOrKey;
    if (!projectData) throw new (0, $75sVW.default)($d0ea7ea6b45bb20b$export$df64fe7442e4c87b, 'Fetch project context via AGG succeeded but no data received');
    const { projectId: projectId, key: key, name: name, avatar: avatar, projectType: projectType, projectStyle: projectStyle, created: created } = projectData;
    return {
        key: key,
        name: name,
        id: projectId,
        avatarUrl: avatar?.medium ?? '',
        simplified: projectStyle === (0, $f99M0.TEAM_MANAGED_PROJECT),
        projectType: (0, $f99M0.convertToProjectType)(projectType),
        issueTypes: $d0ea7ea6b45bb20b$var$transformIssueTypes(projectData.issueTypes),
        created: created
    };
};
const $d0ea7ea6b45bb20b$var$getData = async (matchedRoute, { tenantContext: { cloudId: cloudId } })=>{
    const projectIdOrKey = (0, $i0CFV.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $d0ea7ea6b45bb20b$var$getProjectWorkflowContextData(projectIdOrKey, cloudId);
};
var $d0ea7ea6b45bb20b$export$2e2bcd8739ae039 = $d0ea7ea6b45bb20b$var$getData;

});
/* eslint-disable jira/filename-case */ const $3a8a8563eee35fe7$export$2b91517d6d5b4365 = `
query jiraWorkflowProject($cloudId: ID!, $projectIdOrKey: String!) {
  jira_projectByIdOrKey(cloudId: $cloudId, idOrKey: $projectIdOrKey) {
    id
    projectId
		projectType
    projectStyle
    key
    name
		created
    avatar {
      medium
    }
    issueTypes {
      edges {
        node {
          ... on JiraIssueType {
            issueTypeId
            name
            avatar {
              large
            }
            hierarchy {
              level
              name
            }
          }
        }
      }
    }
  }
}`;



parcelRegister("8xDGy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("a3Oba")
]).then(()=>parcelRequire('efs9S'));

});


parcelRegister("ilfAR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRouteEntry", () => $1c284fa600eff8e7$export$da36a1671d868927);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $9haqR = parcelRequire("9haqR");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $1c284fa600eff8e7$var$LazyProjectSettingsNotificationEmail = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("tWUUI"))), {
    moduleId: "./src/packages/spa-apps/project-settings-notification-email/src/ExportedDefault.tsx"
});
const $1c284fa600eff8e7$var$EmailNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1c284fa600eff8e7$var$LazyProjectSettingsNotificationEmail,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
$1c284fa600eff8e7$var$EmailNotifications.displayName = "EmailNotifications";
const $1c284fa600eff8e7$export$da36a1671d868927 = (0, $fdS54.createEntry)((0, $9haqR.projectSettingsCoreNotificationsEmailRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $1c284fa600eff8e7$var$EmailNotifications,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $1c284fa600eff8e7$var$LazyProjectSettingsNotificationEmail
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9haqR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRoute", () => $0ea1ffef0b09f644$export$b546589f1b048dc);
const $0ea1ffef0b09f644$export$b546589f1b048dc = {
    name: 'project-settings-core-notifications-notification-email',
    path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("tWUUI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("eZeMz")
]).then(()=>parcelRequire('6EfFY'));

});


parcelRegister("kbDih", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRouteEntry", () => $7662880b08804a09$export$e562140c482cb0c);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $1NFve = parcelRequire("1NFve");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $9KpPP = parcelRequire("9KpPP");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");
const $7662880b08804a09$var$emailNotificationsLogEntryPointPage = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1NFve.notificationsIssueLogsEntryPoint)
});

const $7662880b08804a09$var$LazyNotificationsIssueLogs = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("iXjRN"))), {
    moduleId: "./src/packages/spa-apps/project-settings-software-notifications-issue-logs/src/NotificationLogs.tsx"
});
const $7662880b08804a09$var$NotificationsIssueLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7662880b08804a09$var$LazyNotificationsIssueLogs,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });
$7662880b08804a09$var$NotificationsIssueLogs.displayName = "NotificationsIssueLogs";
const $7662880b08804a09$export$e562140c482cb0c = (0, $fdS54.createEntry)((0, $9KpPP.projectSettingsCoreNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $7662880b08804a09$var$NotificationsIssueLogs,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $7662880b08804a09$var$LazyNotificationsIssueLogs
        ],
        entryPoint () {
            return $7662880b08804a09$var$emailNotificationsLogEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9KpPP", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRoute", () => $95bd02d12313b388$export$56a8a0b88329b044);
const $95bd02d12313b388$export$56a8a0b88329b044 = {
    name: 'project-settings-core-notifications-issue-logs',
    path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("4w93k", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsRouteEntry", () => $d7c0af71515c5b15$export$ed481b03aa858542);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gyO3J = parcelRequire("gyO3J");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $d7c0af71515c5b15$var$LazyNotificationsSettings = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hfK3P"))), {
    moduleId: "./src/packages/spa-apps/project-settings-software-notifications/src/ProjectSettingsSoftwareNotifications.tsx"
});
const $d7c0af71515c5b15$var$Notifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $d7c0af71515c5b15$var$LazyNotificationsSettings,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
$d7c0af71515c5b15$var$Notifications.displayName = "Notifications";
const $d7c0af71515c5b15$export$ed481b03aa858542 = (0, $fdS54.createEntry)((0, $gyO3J.projectSettingsCoreNotificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $d7c0af71515c5b15$var$Notifications,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $d7c0af71515c5b15$var$LazyNotificationsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gyO3J", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsRoute", () => $b984c3ca79a035f5$export$a1ee80066685b98d);
const $b984c3ca79a035f5$export$a1ee80066685b98d = {
    name: 'project-settings-core-notifications',
    path: '/jira/core/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("hfK3P", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("57JkT")
]).then(()=>parcelRequire('2uWSf'));

});


parcelRegister("duDjv", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCorePoliciesRouteEntry", () => $a4b03a78959bd760$export$87f2a46491b4bcc1);



var $k5Kh0 = parcelRequire("k5Kh0");

var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $i860n = parcelRequire("i860n");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $iSoIx = parcelRequire("iSoIx");

var $2hF7Q = parcelRequire("2hF7Q");

var $6leOq = parcelRequire("6leOq");
const $a4b03a78959bd760$var$projectSettingsSpacePoliciesPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $k5Kh0.projectSettingsSpacePoliciesEntryPoint)
});
const $a4b03a78959bd760$export$87f2a46491b4bcc1 = (0, $fdS54.createEntry)((0, $2hF7Q.projectSettingsCorePoliciesRoute), ()=>({
        group: 'project-settings-core',
        ufoName: 'project-settings.space-policies.jwm-tmp',
        layout: (0, $fU8CV.coreProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        entryPoint: ()=>(0, $i860n.fg)('frontier-guided-autonomy-space-settings') ? $a4b03a78959bd760$var$projectSettingsSpacePoliciesPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint)
    }));

});
parcelRegister("2hF7Q", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCorePoliciesRoute", () => $8b1ab13a8caa2bf9$export$77b027416d7fed20);
const $8b1ab13a8caa2bf9$export$77b027416d7fed20 = {
    name: 'project-settings-core-policies',
    path: '/jira/core/projects/:projectKey/settings/policies',
    exact: true
};

});


parcelRegister("2rntA", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRouteEntry", () => $db3d8fd4dfea00cb$export$46d6b55ebf21ccc);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $dZyQq = parcelRequire("dZyQq");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $db3d8fd4dfea00cb$var$LazyProjectSettingsProformaJiraFormBuilder = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("lrE2c")), {
    moduleId: "./src/packages/spa-apps/project-settings-proforma-jira-form-builder/src/ProformaJiraFormBuilderPage.tsx"
});
const $db3d8fd4dfea00cb$var$ProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $db3d8fd4dfea00cb$var$LazyProjectSettingsProformaJiraFormBuilder,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
$db3d8fd4dfea00cb$var$ProformaJiraFormBuilder.displayName = "ProformaJiraFormBuilder";
const $db3d8fd4dfea00cb$export$46d6b55ebf21ccc = (0, $fdS54.createEntry)((0, $dZyQq.projectSettingsCoreProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $db3d8fd4dfea00cb$var$ProformaJiraFormBuilder,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $db3d8fd4dfea00cb$var$LazyProjectSettingsProformaJiraFormBuilder
        ],
        perfMetricKey: 'form-builder',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dZyQq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRoute", () => $9a078c1de4d5a514$export$4e7ce7e6ced0f291);
const $9a078c1de4d5a514$export$4e7ce7e6ced0f291 = {
    name: 'project-settings-core-proforma-jira-form-builder',
    path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("iLBBF", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRouteEntry", () => $ad1bdd7395729e2a$export$5e9e27f116094fdf);

var $euxye = parcelRequire("euxye");



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jEYuY = parcelRequire("jEYuY");

var $fU8CV = parcelRequire("fU8CV");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $9gXlr = parcelRequire("9gXlr");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $6leOq = parcelRequire("6leOq");

const $ad1bdd7395729e2a$var$LazyProjectSettingsProformaProjectForms = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("6nXBG")), {
    moduleId: "./src/packages/spa-apps/project-settings-proforma-project-forms/src/ProformaProjectFormsSettingsPage.tsx"
});
const $ad1bdd7395729e2a$var$ProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ad1bdd7395729e2a$var$LazyProjectSettingsProformaProjectForms,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
$ad1bdd7395729e2a$var$ProformaProjectForms.displayName = "ProformaProjectForms";
const $ad1bdd7395729e2a$export$5e9e27f116094fdf = (0, $fdS54.createEntry)((0, $9gXlr.projectSettingsCoreProformaProjectFormsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        layout: (0, $fU8CV.coreProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6leOq.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $ad1bdd7395729e2a$var$ProformaProjectForms,
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $ad1bdd7395729e2a$var$LazyProjectSettingsProformaProjectForms
        ],
        perfMetricKey: 'forms-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9gXlr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRoute", () => $0bc693b998f2f8b2$export$57fe8c5107a9c0de);
const $0bc693b998f2f8b2$export$57fe8c5107a9c0de = {
    name: 'project-settings-core-proforma-project-forms',
    path: '/jira/core/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("dLdOX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCustomerServiceCannedResponsesRouteEntry", () => $e47e939650195d31$export$532a49ee64fff9e3);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $9M7iQ = parcelRequire("9M7iQ");

var $74h93 = parcelRequire("74h93");

var $lbxXL = parcelRequire("lbxXL");

var $i860n = parcelRequire("i860n");

var $9oXPf = parcelRequire("9oXPf");
const $e47e939650195d31$export$532a49ee64fff9e3 = (0, $fdS54.createEntry)((0, $9M7iQ.projectSettingsCustomerServiceCannedResponsesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jcs-project-settings.canned-responses',
        entryPoint: ()=>{
            return (0, $i860n.fg)('csm_canned_responses_improvements') ? (0, $9oXPf.projectSettingsCannedResponsesPageEntrypoint) : undefined;
        },
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9M7iQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCustomerServiceCannedResponsesRoute", () => $65065da3b3a768a5$export$c7d3d068aa39e9dd);
const $65065da3b3a768a5$export$c7d3d068aa39e9dd = {
    name: 'project-settings-customer-service-canned-responses',
    path: '/jira/servicedesk/projects/:projectKey/settings/canned-responses',
    exact: true
};

});

parcelRegister("9oXPf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCannedResponsesPageEntrypoint", () => $ef1b5f5c7f720fbd$export$8228ebf241107b89);
/* eslint-disable jira/naming/disallow-filenames */ 
var $ePRL6 = parcelRequire("ePRL6");

var $dTa0V = parcelRequire("dTa0V");
const $ef1b5f5c7f720fbd$export$8228ebf241107b89 = (0, $dTa0V.createPageEntryPoint)({
    main: $ePRL6.projectSettingsCannedResponsesEntrypoint
});

});
parcelRegister("ePRL6", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCannedResponsesEntrypoint", () => $4ef748d517292bc5$export$94a21235b306d397);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $4ef748d517292bc5$export$94a21235b306d397 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("k0o6Z")), {
        moduleId: "f847fffc",
        moduleName: "ProjectSettingsCannedResponsesApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("k0o6Z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ezTHD").then(()=>parcelRequire('30fNe'));

});




parcelRegister("5Me2r", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCustomerServiceDetailsRouteEntry", () => $987a2bcdfe3c8955$export$4cb2ec37fcc65f28);




var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $iSoIx = parcelRequire("iSoIx");

var $lbxXL = parcelRequire("lbxXL");

var $evRXq = parcelRequire("evRXq");

var $98dWy = parcelRequire("98dWy");

var $74h93 = parcelRequire("74h93");

var $k2tg5 = parcelRequire("k2tg5");
const $987a2bcdfe3c8955$var$projectSettingsCustomerServiceDetailsPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $98dWy.projectDetailsPageEntrypoint)
});
const $987a2bcdfe3c8955$export$4cb2ec37fcc65f28 = (0, $fdS54.createEntry)((0, $evRXq.projectSettingsCustomerServiceDetailsRoute), ()=>({
        group: 'project-settings-servicedesk',
        skeleton: (0, $k2tg5.ProjectSettingsDetailsSkeleton),
        layout: (0, $74h93.serviceProjectLayout),
        entryPoint: ()=>(0, $i860n.fg)('csm_appification_standalone_navigation') ? $987a2bcdfe3c8955$var$projectSettingsCustomerServiceDetailsPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("evRXq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCustomerServiceDetailsRoute", () => $ecd7ce49be076b0d$export$e9f9c24ec359d1bb);
const $ecd7ce49be076b0d$export$e9f9c24ec359d1bb = {
    name: 'project-settings-customer-service-details',
    path: '/jira/customer-service-management/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("6Q9Qz", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRouteEntry", () => $92d28594c5edb689$export$e17f02db5d9c0485);


var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $lXRHx = parcelRequire("lXRHx");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $lEPfS = parcelRequire("lEPfS");

var $74h93 = parcelRequire("74h93");

var $eQgn6 = parcelRequire("eQgn6");
const $92d28594c5edb689$export$e17f02db5d9c0485 = (0, $fdS54.createEntry)((0, $lXRHx.projectSettingsCustomerServiceFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jcs-project-settings.features',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        entryPoint () {
            return 0, $eQgn6.projectSettingFeaturesAppPageEntryPoint;
        },
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $lEPfS.featuresResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jcs-project-settings.features',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lXRHx", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRoute", () => $93c88e8337ab0e1f$export$5498201d2eacd40d);
const $93c88e8337ab0e1f$export$5498201d2eacd40d = {
    name: 'project-settings-customer-service-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("eQgn6", function(module, exports) {
$parcel$export(module.exports, "projectSettingFeaturesAppPageEntryPoint", () => $c4a2e04cf699d160$export$f5b640657f5a50a3);
/* eslint-disable jira/naming/disallow-filenames */ 
var $3LZ5E = parcelRequire("3LZ5E");

var $dTa0V = parcelRequire("dTa0V");
const $c4a2e04cf699d160$export$f5b640657f5a50a3 = (0, $dTa0V.createPageEntryPoint)({
    main: $3LZ5E.projectSettingFeaturesAppEntryPoint
});

});
parcelRegister("3LZ5E", function(module, exports) {
$parcel$export(module.exports, "projectSettingFeaturesAppEntryPoint", () => $45fd5cd08d7a1286$export$83a2217e7eee641e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $45fd5cd08d7a1286$export$83a2217e7eee641e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("38dr1")), {
        moduleId: "e18dfd39",
        moduleName: "ProjectSettingsFeaturesApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("38dr1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ivYK3").then(()=>parcelRequire('9m7vf'));

});




parcelRegister("hYH27", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskEmployeeOnboardingConfigurationRouteEntry", () => $eaba66e3e596f26a$export$97a044627e76df46);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $28xuk = parcelRequire("28xuk");

var $7kqRo = parcelRequire("7kqRo");
const $eaba66e3e596f26a$export$97a044627e76df46 = (0, $fdS54.createEntry)((0, $28xuk.projectSettingServicedeskEmployeeOnboardingConfigurationRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-employee-onboarding-configuration',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7kqRo.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7kqRo.LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration)
        ],
        perfMetricKey: 'jsm-employee-onboarding-configuration',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("28xuk", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskEmployeeOnboardingConfigurationRoute", () => $79d4e3b6f24ed12c$export$ddfe3b955e47596d);
const $79d4e3b6f24ed12c$export$ddfe3b955e47596d = {
    name: 'project-settings-servicedesk-employee-onboarding-configuration',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent/employee-onboarding-configuration',
    exact: true
};

});

parcelRegister("7kqRo", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration", () => $6ac42251b6139853$export$196be5c385e15172);
$parcel$export(module.exports, "default", () => $6ac42251b6139853$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6ac42251b6139853$export$196be5c385e15172 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("OPO2M"))), {
    moduleId: "./src/packages/spa-apps/service-desk-employee-onboarding-configuration/src/EmployeeOnboardingConfigurationView.tsx"
});
const $6ac42251b6139853$var$ServicedeskEmployeeOnboardingConfigurationComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6ac42251b6139853$export$196be5c385e15172,
        pageId: "project-settings-employee-onboarding-configuration",
        shouldShowSpinner: true
    });
$6ac42251b6139853$var$ServicedeskEmployeeOnboardingConfigurationComponent.displayName = "ServicedeskEmployeeOnboardingConfigurationComponent";
var $6ac42251b6139853$export$2e2bcd8739ae039 = $6ac42251b6139853$var$ServicedeskEmployeeOnboardingConfigurationComponent;

});
parcelRegister("OPO2M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Mlll").then(()=>parcelRequire('94k23'));

});



parcelRegister("3i8l7", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskResolutionManagementRouteEntry", () => $d1d742a45cd15b24$export$2322934ee6757099);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");



var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ffvhw = parcelRequire("ffvhw");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $gNbXR = parcelRequire("gNbXR");

var $k48di = parcelRequire("k48di");
const $d1d742a45cd15b24$var$ResolutionManagementRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}/settings/rovo`
    });
$d1d742a45cd15b24$var$ResolutionManagementRedirect.displayName = "ResolutionManagementRedirect";
const $d1d742a45cd15b24$export$2322934ee6757099 = (0, $fdS54.createEntry)((0, $ffvhw.projectSettingServicedeskResolutionManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-rovo-service-agent-settings',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        // When enable-rovo-settings-revamp is ON, entryPoint returns undefined and the router falls back
        // to component, redirecting users to the revamped Rovo settings page (settings/rovo).
        // When OFF, entryPoint serves the resolution management page as normal.
        // eslint-disable-next-line no-restricted-syntax
        component: $d1d742a45cd15b24$var$ResolutionManagementRedirect,
        entryPoint: ()=>!(0, $i860n.fg)('enable-rovo-settings-revamp') ? (0, $k48di.servicedeskResolutionManagementPageEntrypoint) : undefined,
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        perfMetricKey: 'jsm-resolution-management-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("k48di", function(module, exports) {
$parcel$export(module.exports, "servicedeskResolutionManagementPageEntrypoint", () => $75dfdfb26ff6b023$export$5218e3134ab0407b);

var $brP4H = parcelRequire("brP4H");

var $dTa0V = parcelRequire("dTa0V");
const $75dfdfb26ff6b023$export$5218e3134ab0407b = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $brP4H.servicedeskResolutionManagementEntrypoint)
});

});
parcelRegister("brP4H", function(module, exports) {
$parcel$export(module.exports, "servicedeskResolutionManagementEntrypoint", () => $e044e3120e6e4fd6$export$9c7ed64bbb2b2def);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $e044e3120e6e4fd6$export$9c7ed64bbb2b2def = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("iIK8N")), {
        moduleId: "60cd459a",
        moduleName: "ResolutionManagementView",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iIK8N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9WhLM").then(()=>parcelRequire('eoVhn'));

});




parcelRegister("9OFk5", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskRovoServiceRouteEntry", () => $a27d3072c99eb62e$export$1bab4775f5d6935f);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $fdS54 = parcelRequire("fdS54");

var $1DnrG = parcelRequire("1DnrG");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $k48di = parcelRequire("k48di");
const $a27d3072c99eb62e$export$1bab4775f5d6935f = (0, $fdS54.createEntry)((0, $1DnrG.projectSettingServicedeskRovoServiceRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-rovo-service-settings',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint: ()=>(0, $i860n.fg)('enable-rovo-settings-revamp') ? (0, $k48di.servicedeskResolutionManagementPageEntrypoint) : (0, $iSoIx.notFoundPageEntrypoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        perfMetricKey: 'jsm-rovo-service-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("3BaOY", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskSelfServiceSetupRouteEntry", () => $9395ec84e6ef5b7e$export$38ac08fff80a25ae);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $49hTN = parcelRequire("49hTN");

var $74h93 = parcelRequire("74h93");

var $ldOqS = parcelRequire("ldOqS");
const $9395ec84e6ef5b7e$export$38ac08fff80a25ae = (0, $fdS54.createEntry)((0, $49hTN.projectSettingServicedeskSelfServiceSetupRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-self-service-setup-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ldOqS.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $ldOqS.LazyProjectSettingServicedeskSelfServiceSetup)
        ],
        perfMetricKey: 'jsm-self-service-setup-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ldOqS", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingServicedeskSelfServiceSetup", () => $3605f9624d606c62$export$8c3d5cfe6afc349d);
$parcel$export(module.exports, "default", () => $3605f9624d606c62$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $3605f9624d606c62$export$8c3d5cfe6afc349d = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("k9MjJ")).then((module)=>module.default)), {
    moduleId: "./src/packages/router-routes/project-settings-product-routes-service-desk-entries/src/ui/service-desk-self-service-setup/SelfServiceSetupView.tsx"
});
const $3605f9624d606c62$var$ServicedeskSelfServiceSetupComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3605f9624d606c62$export$8c3d5cfe6afc349d,
        pageId: "project-settings-self-service-setup",
        shouldShowSpinner: true
    });
$3605f9624d606c62$var$ServicedeskSelfServiceSetupComponent.displayName = "ServicedeskSelfServiceSetupComponent";
var $3605f9624d606c62$export$2e2bcd8739ae039 = $3605f9624d606c62$var$ServicedeskSelfServiceSetupComponent;

});
parcelRegister("k9MjJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cZy3Z").then(()=>parcelRequire('lAChW'));

});



parcelRegister("lFxv2", function(module, exports) {
$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRouteEntry", () => $d0848f17c66c43da$export$872a0285d27dfa47);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dIZUY = parcelRequire("dIZUY");

var $3eysO = parcelRequire("3eysO");

var $2IJWF = parcelRequire("2IJWF");

var $gyAS0 = parcelRequire("gyAS0");
const $d0848f17c66c43da$export$872a0285d27dfa47 = (0, $fdS54.createEntry)((0, $dIZUY.projectSettingsForgeAppsNextgenRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2IJWF.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)(),
            ...(0, $2IJWF.forgeProjectSettingsPageResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2IJWF.LazyForgeProjectSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dIZUY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRoute", () => $001ca88e216c729a$export$8559c4a0b692890e);
const $001ca88e216c729a$export$8559c4a0b692890e = {
    name: 'project-settings-software-apps-forge',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("2IJWF", function(module, exports) {
$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $0abe4ac4b2c589f1$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "forgeProjectSettingsPageResources", () => $0abe4ac4b2c589f1$export$33d85a1b2211b38);
$parcel$export(module.exports, "default", () => $0abe4ac4b2c589f1$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0abe4ac4b2c589f1$export$ef66d3f49a9953d8 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7qZ2d")), {
    moduleId: "./src/packages/spa-apps/forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx"
});
const $0abe4ac4b2c589f1$export$33d85a1b2211b38 = ()=>[
        (0, $edf7u.projectContextResourceWithCache),
        (0, $hFYSn.forgeProjectSettingsModuleResource)
    ];
const $0abe4ac4b2c589f1$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0abe4ac4b2c589f1$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
$0abe4ac4b2c589f1$export$b943f48844c671a5.displayName = "ForgeProjectSettingsPage";
var $0abe4ac4b2c589f1$export$2e2bcd8739ae039 = $0abe4ac4b2c589f1$export$b943f48844c671a5;

});


parcelRegister("inMYN", function(module, exports) {
$parcel$export(module.exports, "projectSettingsForgeAppsRouteEntry", () => $7a4c85ea4eabc694$export$54d0d8466c8b40dc);



var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $f2xGp = parcelRequire("f2xGp");

var $3eysO = parcelRequire("3eysO");

var $2IJWF = parcelRequire("2IJWF");
const $7a4c85ea4eabc694$export$54d0d8466c8b40dc = (0, $fdS54.createEntry)((0, $f2xGp.projectSettingsForgeAppsRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2IJWF.default),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $2IJWF.forgeProjectSettingsPageResources)()
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2IJWF.LazyForgeProjectSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("f2xGp", function(module, exports) {
$parcel$export(module.exports, "projectSettingsForgeAppsRoute", () => $c27ab3ff76db141c$export$f74a0b1be9d5b9f6);
const $c27ab3ff76db141c$export$f74a0b1be9d5b9f6 = {
    name: 'project-settings-software-forge-apps',
    path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});


parcelRegister("gylEl", function(module, exports) {
$parcel$export(module.exports, "projectSettingsOpsgenieRouteEntry", () => $38163bc860da5d45$export$4b4bfb4318f5a98e);



var $lFLfF = parcelRequire("lFLfF");

var $052eo = parcelRequire("052eo");

var $jEYuY = parcelRequire("jEYuY");

var $4Oj6z = parcelRequire("4Oj6z");

var $fdS54 = parcelRequire("fdS54");

var $33p1a = parcelRequire("33p1a");

var $3eysO = parcelRequire("3eysO");

var $5DGGA = parcelRequire("5DGGA");

var $gyAS0 = parcelRequire("gyAS0");
const $38163bc860da5d45$export$4b4bfb4318f5a98e = (0, $fdS54.createEntry)((0, $33p1a.projectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4Oj6z.default)((0, $052eo.isDevopsFeatureDisabledInFedRamp), (0, $lFLfF.default), (0, $5DGGA.default)),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5DGGA.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("33p1a", function(module, exports) {
$parcel$export(module.exports, "projectSettingsOpsgenieRoute", () => $61b5092b2079c846$export$c7039de5a4b78802);
const $61b5092b2079c846$export$c7039de5a4b78802 = {
    name: 'project-settings-software-link-opsgenie',
    path: '/jira/software/projects/:projectKey/settings/opsgenie',
    exact: true
};

});


parcelRegister("lSwir", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRouteEntry", () => $4771acfe10e20d91$export$7a0e75d9ac8038aa);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $gtGCF = parcelRequire("gtGCF");

var $74h93 = parcelRequire("74h93");

var $b5P3a = parcelRequire("b5P3a");

var $5fVMb = parcelRequire("5fVMb");
const $4771acfe10e20d91$export$7a0e75d9ac8038aa = (0, $fdS54.createEntry)((0, $gtGCF.projectSettingsServicedeskAccessRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $b5P3a.peopleAccessRedirect)(`/jira/${(0, $5fVMb.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $b5P3a.LazyPeopleSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gtGCF", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRoute", () => $d7af2900bad63ed2$export$115667ee60b1ec74);
const $d7af2900bad63ed2$export$115667ee60b1ec74 = {
    name: 'project-settings-servicedesk-access-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("b5P3a", function(module, exports) {
$parcel$export(module.exports, "LazyPeopleSettings", () => $0e02c8beb86ec364$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $0e02c8beb86ec364$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $0e02c8beb86ec364$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $gNbXR = parcelRequire("gNbXR");

const $0e02c8beb86ec364$export$7eee4f97b7a1273 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7grbQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings-people/src/index.tsx"
});
const $0e02c8beb86ec364$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
$0e02c8beb86ec364$var$PeopleAccessRedirectInner.displayName = "PeopleAccessRedirectInner";
const $0e02c8beb86ec364$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0e02c8beb86ec364$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
const $0e02c8beb86ec364$var$AsyncPeopleSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0e02c8beb86ec364$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
$0e02c8beb86ec364$var$AsyncPeopleSettings.displayName = "AsyncPeopleSettings";
var $0e02c8beb86ec364$export$2e2bcd8739ae039 = $0e02c8beb86ec364$var$AsyncPeopleSettings;

});

parcelRegister("5fVMb", function(module, exports) {
$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $639b48a5756ccefb$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $639b48a5756ccefb$export$c9b0516439c55d7a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");

var $8ANUF = parcelRequire("8ANUF");
const $639b48a5756ccefb$export$5575497f0592ee94 = 'servicedesk';
const $639b48a5756ccefb$export$c9b0516439c55d7a = (product)=>({ match: match })=>{
        const { data: data, loading: loading } = (0, $8ANUF.useJiraServiceManagementProjectNavigation)();
        // Wait for nav data to be available before deciding where to redirect on cold loads
        if (loading || !data) return null;
        if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: `/plugins/servlet/project-config/${String(match.params.projectKey)}/administer-versions`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
    };

});


parcelRegister("8H7Ue", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRouteEntry", () => $c4f87248529e4ae4$export$f7b56f6d0437146d);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $bpTrq = parcelRequire("bpTrq");

var $74h93 = parcelRequire("74h93");

var $k2tg5 = parcelRequire("k2tg5");

var $b5P3a = parcelRequire("b5P3a");
const $c4f87248529e4ae4$export$f7b56f6d0437146d = (0, $fdS54.createEntry)((0, $bpTrq.projectSettingsServicedeskAccessRoute), ()=>({
        group: 'project-settings-servicedesk',
        skeleton: (0, $k2tg5.ProjectSettingsAccessSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $b5P3a.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $b5P3a.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("cCKmJ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRouteEntry", () => $1ff2a0a9432bdcc4$export$12f064da36fbd279);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7jmvy = parcelRequire("7jmvy");

var $74h93 = parcelRequire("74h93");

var $huFCD = parcelRequire("huFCD");
const $1ff2a0a9432bdcc4$export$12f064da36fbd279 = (0, $fdS54.createEntry)((0, $7jmvy.projectSettingsServicedeskAppsFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $huFCD.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $huFCD.LazyConnectAppControlsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("huFCD", function(module, exports) {
$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $4dfcf83474a53b8a$export$246ec9cdadd2a163);
$parcel$export(module.exports, "default", () => $4dfcf83474a53b8a$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4dfcf83474a53b8a$export$246ec9cdadd2a163 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("i0lYp"))), {
    moduleId: "./src/packages/spa-apps/project-settings-connect-app-controls/src/ProjectSettingsConnectAppControls.tsx"
});
const $4dfcf83474a53b8a$var$AsyncConnectAppControlsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4dfcf83474a53b8a$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
$4dfcf83474a53b8a$var$AsyncConnectAppControlsSettings.displayName = "AsyncConnectAppControlsSettings";
var $4dfcf83474a53b8a$export$2e2bcd8739ae039 = $4dfcf83474a53b8a$var$AsyncConnectAppControlsSettings;

});


parcelRegister("lDzvD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsRouteEntry", () => $00835bdc97d9e8b8$export$d637c59982b0d896);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $3NVMC = parcelRequire("3NVMC");

var $74h93 = parcelRequire("74h93");

var $8UJpl = parcelRequire("8UJpl");
const $00835bdc97d9e8b8$export$d637c59982b0d896 = (0, $fdS54.createEntry)((0, $3NVMC.projectSettingsServicedeskAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8UJpl.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8UJpl.LazyConnectAppsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3NVMC", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsRoute", () => $d87f68a37f844e85$export$ccc91c475c403d1a);
const $d87f68a37f844e85$export$ccc91c475c403d1a = {
    name: 'project-settings-servicedesk-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("8UJpl", function(module, exports) {
$parcel$export(module.exports, "LazyConnectAppsSettings", () => $6caec46856f4227d$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $6caec46856f4227d$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6caec46856f4227d$export$3633e017e520a1c2 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("aoRbT"))), {
    moduleId: "./src/packages/spa-apps/project-settings-connect-apps/src/ProjectSettingsApps.tsx"
});
const $6caec46856f4227d$var$AsyncConnectAppsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6caec46856f4227d$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
$6caec46856f4227d$var$AsyncConnectAppsSettings.displayName = "AsyncConnectAppsSettings";
var $6caec46856f4227d$export$2e2bcd8739ae039 = $6caec46856f4227d$var$AsyncConnectAppsSettings;

});


parcelRegister("1VlQT", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRouteEntry", () => $23c68550ec5e8c83$export$1cfe280529d4ebf8);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $b0cAD = parcelRequire("b0cAD");

var $74h93 = parcelRequire("74h93");

var $l5mne = parcelRequire("l5mne");
const $23c68550ec5e8c83$export$1cfe280529d4ebf8 = (0, $fdS54.createEntry)((0, $b0cAD.projectSettingsServicedeskAutomationCopyRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.copy-rule',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l5mne.default),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $l5mne.LazyProjectSettingsServiceDeskAutomationCopyRule)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("b0cAD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRoute", () => $cce70078123da786$export$9aa8ef0c982cee2f);
const $cce70078123da786$export$9aa8ef0c982cee2f = {
    name: 'project-settings-servicedesk-automation-copy-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("l5mne", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCopyRule", () => $6e2dcef1b4e8cbf3$export$4a3b5f6370555dbc);
$parcel$export(module.exports, "default", () => $6e2dcef1b4e8cbf3$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6e2dcef1b4e8cbf3$export$4a3b5f6370555dbc = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("aEGc8")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-automation-copy-rule/src/index.tsx"
});
const $6e2dcef1b4e8cbf3$var$AsyncProjectSettingsServiceDeskAutomationCopyRule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6e2dcef1b4e8cbf3$export$4a3b5f6370555dbc,
        pageId: "project-settings-automation-copy-rule",
        shouldShowSpinner: true
    });
$6e2dcef1b4e8cbf3$var$AsyncProjectSettingsServiceDeskAutomationCopyRule.displayName = "AsyncProjectSettingsServiceDeskAutomationCopyRule";
var $6e2dcef1b4e8cbf3$export$2e2bcd8739ae039 = $6e2dcef1b4e8cbf3$var$AsyncProjectSettingsServiceDeskAutomationCopyRule;

});
parcelRegister("aEGc8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9oVm6").then(()=>parcelRequire('4pwDJ'));

});



parcelRegister("dglDe", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRouteEntry", () => $9e2b9d3f7469419c$export$f1e32463088d9246);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dO42h = parcelRequire("dO42h");

var $74h93 = parcelRequire("74h93");

var $5jDla = parcelRequire("5jDla");
const $9e2b9d3f7469419c$export$f1e32463088d9246 = (0, $fdS54.createEntry)((0, $dO42h.projectSettingsServicedeskAutomationCreateRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.create-rule',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5jDla.default),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5jDla.LazyProjectSettingsServiceDeskAutomationCreateRule)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dO42h", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRoute", () => $4302078a77bbafb7$export$6f20ce2991881c20);
const $4302078a77bbafb7$export$6f20ce2991881c20 = {
    name: 'project-settings-servicedesk-automation-create',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});

parcelRegister("5jDla", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCreateRule", () => $296b4ebd81497d7b$export$5b197b51eb5ad982);
$parcel$export(module.exports, "default", () => $296b4ebd81497d7b$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $296b4ebd81497d7b$export$5b197b51eb5ad982 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7jwlU")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-automation-create-rule/src/index.tsx"
});
const $296b4ebd81497d7b$var$AsyncProjectSettingsServiceDeskAutomationCreateRule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $296b4ebd81497d7b$export$5b197b51eb5ad982,
        pageId: "project-settings-automation-create-rule",
        shouldShowSpinner: true
    });
$296b4ebd81497d7b$var$AsyncProjectSettingsServiceDeskAutomationCreateRule.displayName = "AsyncProjectSettingsServiceDeskAutomationCreateRule";
var $296b4ebd81497d7b$export$2e2bcd8739ae039 = $296b4ebd81497d7b$var$AsyncProjectSettingsServiceDeskAutomationCreateRule;

});
parcelRegister("7jwlU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gnRHA").then(()=>parcelRequire('1CsFo'));

});



parcelRegister("dbmnC", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRouteEntry", () => $9c10baae2644d377$export$568d8653c06c756e);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $eo3Lg = parcelRequire("eo3Lg");

var $74h93 = parcelRequire("74h93");

var $kD2oL = parcelRequire("kD2oL");
const $9c10baae2644d377$export$568d8653c06c756e = (0, $fdS54.createEntry)((0, $eo3Lg.projectSettingsServicedeskAutomationEditRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.edit-rule',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kD2oL.default),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $kD2oL.LazyProjectSettingsServiceDeskAutomationEditRule)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eo3Lg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRoute", () => $1d520654ceebf6a1$export$9f1e5391e2d6f95);
const $1d520654ceebf6a1$export$9f1e5391e2d6f95 = {
    name: 'project-settings-servicedesk-automation-edit-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});

parcelRegister("kD2oL", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationEditRule", () => $37757bf0d8e62cc7$export$c1c9a68738a9ab36);
$parcel$export(module.exports, "default", () => $37757bf0d8e62cc7$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $37757bf0d8e62cc7$export$c1c9a68738a9ab36 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("281si")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-automation-edit-rule/src/index.tsx"
});
const $37757bf0d8e62cc7$var$AsyncProjectSettingsServiceDeskAutomationEditRule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $37757bf0d8e62cc7$export$c1c9a68738a9ab36,
        pageId: "project-settings-automation-edit-rule",
        shouldShowSpinner: true
    });
$37757bf0d8e62cc7$var$AsyncProjectSettingsServiceDeskAutomationEditRule.displayName = "AsyncProjectSettingsServiceDeskAutomationEditRule";
var $37757bf0d8e62cc7$export$2e2bcd8739ae039 = $37757bf0d8e62cc7$var$AsyncProjectSettingsServiceDeskAutomationEditRule;

});
parcelRegister("281si", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6jyio").then(()=>parcelRequire('5mOma'));

});



parcelRegister("7XljJ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationRouteEntry", () => $4fc7a36371c1a737$export$7a0b8ca27efc7201);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $g8IkD = parcelRequire("g8IkD");

var $74h93 = parcelRequire("74h93");

var $dSdPE = parcelRequire("dSdPE");

var $5fVMb = parcelRequire("5fVMb");
const $4fc7a36371c1a737$export$7a0b8ca27efc7201 = (0, $fdS54.createEntry)((0, $g8IkD.projectSettingsServicedeskAutomationRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: `project-settings-automation-${0, $5fVMb.SERVICE_DESK_PRODUCT}`,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dSdPE.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dSdPE.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dSdPE", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $7415400171d4ee71$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $7415400171d4ee71$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7415400171d4ee71$export$dea5ad7e8eac12ae = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9DEIu")), {
    moduleId: "./src/packages/spa-apps/project-settings-jira-automation/src/ExportedDefault.tsx"
});
const $7415400171d4ee71$var$AsyncProjectSettingsJiraAutomation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7415400171d4ee71$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });
$7415400171d4ee71$var$AsyncProjectSettingsJiraAutomation.displayName = "AsyncProjectSettingsJiraAutomation";
var $7415400171d4ee71$export$2e2bcd8739ae039 = $7415400171d4ee71$var$AsyncProjectSettingsJiraAutomation;

});


parcelRegister("3kVWl", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRouteEntry", () => $eb321c7364866ea9$export$4d6e0242b09fef3b);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $bdBcq = parcelRequire("bdBcq");

var $74h93 = parcelRequire("74h93");

var $jtLk0 = parcelRequire("jtLk0");
const $eb321c7364866ea9$export$4d6e0242b09fef3b = (0, $fdS54.createEntry)((0, $bdBcq.projectSettingsServicedeskAutomationSummaryRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.summary',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jtLk0.default),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jtLk0.LazyProjectSettingsServiceDeskAutomationSummary)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jtLk0", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationSummary", () => $1712826218751de9$export$2fc8c3fcbb365b89);
$parcel$export(module.exports, "default", () => $1712826218751de9$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1712826218751de9$export$2fc8c3fcbb365b89 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9eXPd")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-automation-summary/src/index.tsx"
});
const $1712826218751de9$var$AsyncProjectSettingsServiceDeskAutomationSummary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1712826218751de9$export$2fc8c3fcbb365b89,
        pageId: "project-settings-automation-summary",
        shouldShowSpinner: true
    });
$1712826218751de9$var$AsyncProjectSettingsServiceDeskAutomationSummary.displayName = "AsyncProjectSettingsServiceDeskAutomationSummary";
var $1712826218751de9$export$2e2bcd8739ae039 = $1712826218751de9$var$AsyncProjectSettingsServiceDeskAutomationSummary;

});
parcelRegister("9eXPd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jv8a5").then(()=>parcelRequire('WsFEB'));

});



parcelRegister("kvhzN", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRouteEntry", () => $0dd95d8684d465aa$export$ddc45b708634b66);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $bOAIG = parcelRequire("bOAIG");

var $74h93 = parcelRequire("74h93");

var $gGSgk = parcelRequire("gGSgk");
const $0dd95d8684d465aa$export$ddc45b708634b66 = (0, $fdS54.createEntry)((0, $bOAIG.projectSettingsServicedeskAutomationViewLogRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.log',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gGSgk.default),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gGSgk.LazyProjectSettingsServiceDeskAutomationViewLog)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bOAIG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRoute", () => $3b6c054e858b0970$export$ea3acd3ad4eb7d38);
const $3b6c054e858b0970$export$ea3acd3ad4eb7d38 = {
    name: 'project-settings-servicedesk-automation-view-log',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/log/:ruleId'
};

});

parcelRegister("gGSgk", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationViewLog", () => $c893ee04da7ab8df$export$db6c5cdbc65b2b4a);
$parcel$export(module.exports, "default", () => $c893ee04da7ab8df$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $c893ee04da7ab8df$export$db6c5cdbc65b2b4a = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("3N2BX")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-automation-view-log/src/index.tsx"
});
const $c893ee04da7ab8df$var$AsyncProjectSettingsServiceDeskAutomationViewLog = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c893ee04da7ab8df$export$db6c5cdbc65b2b4a,
        pageId: "project-settings-automation-view-log",
        shouldShowSpinner: true
    });
$c893ee04da7ab8df$var$AsyncProjectSettingsServiceDeskAutomationViewLog.displayName = "AsyncProjectSettingsServiceDeskAutomationViewLog";
var $c893ee04da7ab8df$export$2e2bcd8739ae039 = $c893ee04da7ab8df$var$AsyncProjectSettingsServiceDeskAutomationViewLog;

});
parcelRegister("3N2BX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fxJEh").then(()=>parcelRequire('7fZVL'));

});



parcelRegister("2z0UX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCaseNotesEditRouteEntry", () => $185f81edec0d4a3e$export$a601af1986b2a0b5);

var $i860n = parcelRequire("i860n");



var $jEYuY = parcelRequire("jEYuY");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $hDsXI = parcelRequire("hDsXI");

var $eZLmn = parcelRequire("eZLmn");
const $185f81edec0d4a3e$var$caseNoteEditPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $eZLmn.caseNoteEditEntryPoint)
});
const $185f81edec0d4a3e$export$a601af1986b2a0b5 = (0, $fdS54.createEntry)((0, $hDsXI.projectSettingsServicedeskCaseNotesEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        entryPoint: ()=>(0, $i860n.fg)('jsm-case-management-settings') ? $185f81edec0d4a3e$var$caseNoteEditPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eZLmn", function(module, exports) {
$parcel$export(module.exports, "caseNoteEditEntryPoint", () => $de9475ed20975f1a$export$a46fb9e283bd604a);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $bTMkS = parcelRequire("bTMkS");

const $de9475ed20975f1a$export$a46fb9e283bd604a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dUFWC")), {
        moduleId: "7e1e8a38",
        moduleName: "CaseNoteEditPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                caseNote: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $bTMkS.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("bTMkS", function(module, exports) {
$parcel$export(module.exports, "default", () => $03154aa83bf77944$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4d9a1d85d7c40f3ed361241803f5d13f>>
 * @relayHash ce0a1fcea73bbb6488d416c80ab59886
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 754d2cc38a760c8dc14a95e414fd026f8971c0689eecc44075d74dfb41db1a60
const $03154aa83bf77944$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "754d2cc38a760c8dc14a95e414fd026f8971c0689eecc44075d74dfb41db1a60",
        "metadata": {},
        "name": "CaseNoteEditPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $03154aa83bf77944$export$2e2bcd8739ae039 = $03154aa83bf77944$var$node;

});

parcelRegister("dUFWC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("45Utd")
]).then(()=>parcelRequire('38rqS'));

});



parcelRegister("8VSx6", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCaseNotesRouteEntry", () => $8dd5b2e12250a1da$export$7cb42373d79902c2);



var $jEYuY = parcelRequire("jEYuY");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $iyMkJ = parcelRequire("iyMkJ");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $6dumt = parcelRequire("6dumt");

var $74h93 = parcelRequire("74h93");

var $ctiMP = parcelRequire("ctiMP");

var $i860n = parcelRequire("i860n");
const $8dd5b2e12250a1da$var$caseNotesPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ctiMP.caseNotesEntryPoint)
});
const $8dd5b2e12250a1da$export$7cb42373d79902c2 = (0, $fdS54.createEntry)((0, $6dumt.projectSettingsServicedeskCaseNotesRoute), ()=>({
        group: 'project-settings-servicedesk',
        entryPoint: ()=>(0, $i860n.fg)('jsm-case-management-settings') ? $8dd5b2e12250a1da$var$caseNotesPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $iyMkJ.caseNoteFormsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iyMkJ", function(module, exports) {
$parcel$export(module.exports, "caseNoteFormsResource", () => $ec3bf91dee225e2b$export$bcad01501a94795);

var $7edbf = parcelRequire("7edbf");
const $ec3bf91dee225e2b$var$RESOURCE_TYPE_CASE_NOTE_FORMS = 'CASE_NOTE_FORMS';

const $ec3bf91dee225e2b$export$bcad01501a94795 = (0, $7edbf.createResource)({
    type: $ec3bf91dee225e2b$var$RESOURCE_TYPE_CASE_NOTE_FORMS,
    getKey: ({ match: match })=>match.params.projectKey ?? '',
    getDataLoader: ()=>(parcelRequire("aERfz")),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("aERfz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8GW8K").then(()=>parcelRequire('4tkE3'));

});


parcelRegister("ctiMP", function(module, exports) {
$parcel$export(module.exports, "caseNotesEntryPoint", () => $b040d40e2e94a89a$export$f5e24b9734128400);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $4qTAy = parcelRequire("4qTAy");

const $b040d40e2e94a89a$export$f5e24b9734128400 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8kaq8")), {
        moduleId: "59739b63",
        moduleName: "CaseNotesPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $4qTAy.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("4qTAy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3eb3daa53bf5a0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da1836ec75527553c6bb1ad442ca2d69>>
 * @relayHash a66b182c1e98d29a24ccc39146246ff5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad2942e63f580fdb10e21b5aa2bea007bbf7d1f0c03a65aad53b29d9310a0ffe
const $d3eb3daa53bf5a0a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ad2942e63f580fdb10e21b5aa2bea007bbf7d1f0c03a65aad53b29d9310a0ffe",
        "metadata": {},
        "name": "CaseNotesPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d3eb3daa53bf5a0a$export$2e2bcd8739ae039 = $d3eb3daa53bf5a0a$var$node;

});

parcelRegister("8kaq8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fVhW9").then(()=>parcelRequire('42v2A'));

});



parcelRegister("c8g3O", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRouteEntry", () => $abac256aee56050c$export$a8eaf3cca1d5d936);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $5LUw5 = parcelRequire("5LUw5");

var $lbxXL = parcelRequire("lbxXL");

var $iyqMX = parcelRequire("iyqMX");

var $lEPfS = parcelRequire("lEPfS");

var $6YA1Z = parcelRequire("6YA1Z");

var $74h93 = parcelRequire("74h93");

var $lBMEr = parcelRequire("lBMEr");

var $9sOH7 = parcelRequire("9sOH7");
const $abac256aee56050c$export$a8eaf3cca1d5d936 = (0, $fdS54.createEntry)((0, $6YA1Z.projectSettingsServicedeskChangeManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.change-management-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9sOH7.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $iyqMX.serviceDeskContextResource),
            (0, $lBMEr.changeManagementSettingsProjectConfigurationResource),
            (0, $5LUw5.jsmChangeManagementSettingsGitLabGatingResource),
            (0, $lEPfS.featuresResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9sOH7.LazyProjectSettingsServiceDeskChangeManagement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5LUw5", function(module, exports) {
$parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", () => $58ba86f6d77be08e$export$315b6278d34861b4);
$parcel$export(module.exports, "useGitLabGatingResource", () => $58ba86f6d77be08e$export$dd3715dce02ee460);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $58ba86f6d77be08e$export$315b6278d34861b4 = (0, $7edbf.createResource)({
    type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getDataLoader: ()=>(parcelRequire("cot1d")),
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $58ba86f6d77be08e$export$dd3715dce02ee460 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)($58ba86f6d77be08e$export$315b6278d34861b4);
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $euxye.useMemo)(()=>({
            data: data?.data,
            pending: loading,
            // oxlint-disable-next-line typescript/consistent-type-assertions
            error: data?.error || error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("cot1d", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3cQl2").then(()=>parcelRequire('iUVaX'));

});


parcelRegister("lBMEr", function(module, exports) {
$parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", () => $d7d9e7a8bde9a793$export$2413ba18ec38282d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $d7d9e7a8bde9a793$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';
const $d7d9e7a8bde9a793$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';

const $d7d9e7a8bde9a793$export$2413ba18ec38282d = (0, $7edbf.createResource)({
    type: $d7d9e7a8bde9a793$export$c0636b6062501e0b,
    getKey: $d7d9e7a8bde9a793$var$getKey,
    getDataLoader: ()=>(parcelRequire("jvs3K")),
    maxAge: Infinity
});

});
parcelRegister("jvs3K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Ziv2").then(()=>parcelRequire('aNwhV'));

});


parcelRegister("9sOH7", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChangeManagement", () => $fa96d9e24e85bd81$export$e674d93688e620b3);
$parcel$export(module.exports, "default", () => $fa96d9e24e85bd81$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $fa96d9e24e85bd81$export$e674d93688e620b3 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("79zEI"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-change-management-settings/src/ServiceDeskChangeManagementSettingsPage.tsx"
});
const $fa96d9e24e85bd81$var$AsyncProjectSettingsServiceDeskChangeManagement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $fa96d9e24e85bd81$export$e674d93688e620b3,
        pageId: "project-settings-change-management",
        shouldShowSpinner: true
    });
$fa96d9e24e85bd81$var$AsyncProjectSettingsServiceDeskChangeManagement.displayName = "AsyncProjectSettingsServiceDeskChangeManagement";
var $fa96d9e24e85bd81$export$2e2bcd8739ae039 = $fa96d9e24e85bd81$var$AsyncProjectSettingsServiceDeskChangeManagement;

});
parcelRegister("79zEI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("l0oYr")
]).then(()=>parcelRequire('6oeGY'));

});



parcelRegister("lcKg0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRouteEntry", () => $a6d4d9e781c4ed7c$export$aa27d235fc2eedf6);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $jPEBm = parcelRequire("jPEBm");

var $74h93 = parcelRequire("74h93");

var $fzRKT = parcelRequire("fzRKT");

var $cd7j2 = parcelRequire("cd7j2");
const $a6d4d9e781c4ed7c$export$aa27d235fc2eedf6 = (0, $fdS54.createEntry)((0, $jPEBm.projectSettingsServicedeskChannelsChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fzRKT.serviceDeskChatNextGenRedirect),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cd7j2.LazyProjectSettingsServiceDeskChatSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fzRKT", function(module, exports) {
$parcel$export(module.exports, "serviceDeskChatNextGenRedirect", () => $2bc18d3b30e38dcb$export$22c86ddb04b1359a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $2bc18d3b30e38dcb$export$22c86ddb04b1359a = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: url
    });
};

});

parcelRegister("cd7j2", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChatSettings", () => $7abf7bbeff76adc9$export$971347f9ac02f862);
$parcel$export(module.exports, "default", () => $7abf7bbeff76adc9$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7abf7bbeff76adc9$export$971347f9ac02f862 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("cRlH9")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-chat-settings/src/ServiceDeskChatSettingsPage.tsx"
});
const $7abf7bbeff76adc9$var$AsyncProjectSettingsServiceDeskChatSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7abf7bbeff76adc9$export$971347f9ac02f862,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });
$7abf7bbeff76adc9$var$AsyncProjectSettingsServiceDeskChatSettings.displayName = "AsyncProjectSettingsServiceDeskChatSettings";
var $7abf7bbeff76adc9$export$2e2bcd8739ae039 = $7abf7bbeff76adc9$var$AsyncProjectSettingsServiceDeskChatSettings;

});
parcelRegister("cRlH9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kO72Z").then(()=>parcelRequire('fXzYC'));

});



parcelRegister("dtdCX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRouteEntry", () => $13f2e927d53e6904$export$b4590bec09451e4c);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ebGgU = parcelRequire("ebGgU");

var $74h93 = parcelRequire("74h93");

var $idKo9 = parcelRequire("idKo9");

var $hg7nu = parcelRequire("hg7nu");
const $13f2e927d53e6904$export$b4590bec09451e4c = (0, $fdS54.createEntry)((0, $ebGgU.projectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $idKo9.serviceDeskEmailNextGenRedirect),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hg7nu.LazyProjectSettingsServiceDeskEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ebGgU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRoute", () => $f3c4c54d8318ea8d$export$89c7bf2bac1464c2);
const $f3c4c54d8318ea8d$export$89c7bf2bac1464c2 = {
    name: 'project-settings-servicedesk-channels-email-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/email',
    exact: true
};

});

parcelRegister("idKo9", function(module, exports) {
$parcel$export(module.exports, "serviceDeskEmailNextGenRedirect", () => $017aa13e60cc4001$export$86c8da903fb97c4f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $017aa13e60cc4001$export$86c8da903fb97c4f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: url
    });
};

});

parcelRegister("hg7nu", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskEmail", () => $44e7d54d5f824a38$export$66d0c668045080de);
$parcel$export(module.exports, "default", () => $44e7d54d5f824a38$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $2LCqr = parcelRequire("2LCqr");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $44e7d54d5f824a38$export$66d0c668045080de = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("kP3wH")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-email/src/ExportedDefault.tsx"
});
const $44e7d54d5f824a38$var$AsyncProjectSettingsServiceDeskEmail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2LCqr.HelpCenterSettingsRedirect), {
        page: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $44e7d54d5f824a38$export$66d0c668045080de,
        pageId: "project-settings-email",
        shouldShowSpinner: true
    }));
$44e7d54d5f824a38$var$AsyncProjectSettingsServiceDeskEmail.displayName = "AsyncProjectSettingsServiceDeskEmail";
var $44e7d54d5f824a38$export$2e2bcd8739ae039 = $44e7d54d5f824a38$var$AsyncProjectSettingsServiceDeskEmail;

});
parcelRegister("2LCqr", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsRedirect", () => $e8d57b1b2176eee7$export$a24ec33acfeae48d);

var $ao7dy = parcelRequire("ao7dy");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $f99M0 = parcelRequire("f99M0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $dLVGe = parcelRequire("dLVGe");

var $f2wVS = parcelRequire("f2wVS");

var $2b39L = parcelRequire("2b39L");

var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $h3LJR = parcelRequire("h3LJR");

var $kt86l = parcelRequire("kt86l");

var $ivTJy = parcelRequire("ivTJy");

var $gTHMM = parcelRequire("gTHMM");

var $2Ofrv = parcelRequire("2Ofrv");
const $e8d57b1b2176eee7$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-customer-service-common.help-center-settings-redirect.error-title",
    defaultMessage: "This page has been moved"
});
const $e8d57b1b2176eee7$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-customer-service-common.help-center-settings-redirect.error-description",
    defaultMessage: "You can find the page you\u2019re looking for in a service hub."
});
const $e8d57b1b2176eee7$export$c224e724e933fbea = (page, pathname)=>{
    if (page === 'customer-notifications') {
        const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
        if (customerNotificationsPage === '/template') return 'customer-notifications-template';
        if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
        if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
    }
    return page;
};
const $e8d57b1b2176eee7$export$2d1034e371a567c6 = (page, pathname, helpCenterId)=>{
    switch(page){
        case 'kb':
            return (0, $2Ofrv.getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true, helpCenterId);
        default:
            return (0, $2Ofrv.getSettingsPath)(pathname, true, helpCenterId);
    }
};
const $e8d57b1b2176eee7$var$useLocation = (0, $f2wVS.createRouterSelector)((state)=>state.location);
const $e8d57b1b2176eee7$export$a24ec33acfeae48d = ({ page: page, children: children })=>{
    const location = $e8d57b1b2176eee7$var$useLocation();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { data: projectContext } = (0, $2b39L.useProjectContext)();
    const isJCS = projectContext?.projectType === (0, $f99M0.CUSTOMER_SERVICE_PROJECT);
    (0, $euxye.useEffect)(()=>{
        if (isJCS && !(0, $gTHMM.isHelpCenterSettingsPath)()) (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
            page: $e8d57b1b2176eee7$export$c224e724e933fbea(page, location.pathname)
        });
    }, [
        createAnalyticsEvent,
        isJCS,
        location.pathname,
        page
    ]);
    if (isJCS && !(0, $gTHMM.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e8d57b1b2176eee7$export$b65700afa6ae3ae9, {
        page: page,
        pathname: location.pathname,
        projectId: projectContext.projectId
    });
    return children;
};
$e8d57b1b2176eee7$export$a24ec33acfeae48d.displayName = "HelpCenterSettingsRedirect";
const $e8d57b1b2176eee7$export$b65700afa6ae3ae9 = ({ page: page, pathname: pathname, projectId: projectId })=>{
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagService)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const activationId = (0, $h3LJR.useActivationId)();
    const cloudId = (0, $kt86l.useCloudId)();
    const jiraProjectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const jiraWorkspaceAri = `ari:cloud:jira:${cloudId}:workspace/${activationId}`;
    const { helpCenter: { helpCenterByHoistedProjectIdRouted: helpCenter } } = (0, $n67Vb.useLazyLoadQuery)((0, $ao7dy.default), {
        cloudId: cloudId,
        jiraProjectAri: jiraProjectAri,
        jiraWorkspaceAri: jiraWorkspaceAri
    });
    if (helpCenter.__typename !== 'HelpCenter') {
        showFlag({
            messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error.1',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage($e8d57b1b2176eee7$var$errorTitle),
            description: formatMessage($e8d57b1b2176eee7$var$errorDescription),
            isAutoDismiss: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
            to: "/jira/helpcenter"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: $e8d57b1b2176eee7$export$2d1034e371a567c6(page, pathname, (0, $ivTJy.HelpHelpCenterAri).parse(helpCenter.id).helpCenterId),
        persistSearchParams: true
    });
};
$e8d57b1b2176eee7$export$b65700afa6ae3ae9.displayName = "HelpCenterSettingsRedirectWithHelpCenterId";

});
parcelRegister("ao7dy", function(module, exports) {
$parcel$export(module.exports, "default", () => $333f733bbbe0105d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<643ae05f44654aa61f3f924745d6962f>>
 * @relayHash a0b6281ad8328e2adece33059d7b499e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 962b8856f333ff53b5c22613434dd482d1904e0e5e4341a8f7e1842d1be9743f
const $333f733bbbe0105d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraProjectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraWorkspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "jiraProjectAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "jiraWorkspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HelpCenterSettingsRedirectOldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "HelpCenterQueryApi",
                        "kind": "LinkedField",
                        "name": "helpCenter",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterByHoistedProjectIdRouted",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HelpCenterSettingsRedirectOldQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterByHoistedProjectIdRouted",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "962b8856f333ff53b5c22613434dd482d1904e0e5e4341a8f7e1842d1be9743f",
            "metadata": {},
            "name": "HelpCenterSettingsRedirectOldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$333f733bbbe0105d$var$node.hash = "b019fafdbfbfb9dc730e8f23eaf51dbd";
var $333f733bbbe0105d$export$2e2bcd8739ae039 = $333f733bbbe0105d$var$node;

});

parcelRegister("gTHMM", function(module, exports) {
$parcel$export(module.exports, "isHelpCenterSettingsPath", () => $228f8ba5814b6cb9$export$bf8b98b87d485657);
$parcel$export(module.exports, "getHelpCenterUUIDFromPath", () => $228f8ba5814b6cb9$export$73a9fbfd9155f593);

var $1uH7N = parcelRequire("1uH7N");
const $228f8ba5814b6cb9$export$bf8b98b87d485657 = ()=>{
    (0, $1uH7N.di)(window);
    if (!false) return window.location.pathname.includes('jira/helpcenter/');
    return false;
};
const $228f8ba5814b6cb9$export$73a9fbfd9155f593 = ()=>{
    (0, $1uH7N.di)(window);
    if (!$228f8ba5814b6cb9$export$bf8b98b87d485657()) return '';
    if (!false) return window.location.pathname.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/)?.[0];
    return '';
};

});

parcelRegister("2Ofrv", function(module, exports) {
$parcel$export(module.exports, "getSettingsPath", () => $0d781f15c8b6b7dd$export$67417cd3aaee582d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $0d781f15c8b6b7dd$export$67417cd3aaee582d = (path, isJCS, helpCenterId)=>{
    if (!helpCenterId) return isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
    return path.replace('/jira/servicedesk/', '/jira/helpcenter/').replace('/settings', `/settings/${helpCenterId}`);
};

});


parcelRegister("kP3wH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("clbEz")
]).then(()=>parcelRequire('lOhDu'));

});



parcelRegister("1tycn", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry", () => $e6155c5741565586$export$65a2b00cdeff4516);



var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $1ZSkY = parcelRequire("1ZSkY");

var $lNLqY = parcelRequire("lNLqY");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $dCZZS = parcelRequire("dCZZS");

var $aNhjU = parcelRequire("aNhjU");
const $e6155c5741565586$export$65a2b00cdeff4516 = (0, $fdS54.createEntry)((0, $lNLqY.projectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dCZZS.customerPermissionsRedirect),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $1ZSkY.customerPermissionsPageDataResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aNhjU.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1ZSkY", function(module, exports) {
$parcel$export(module.exports, "customerPermissionsPageDataResource", () => $733ca86a81a89b77$export$ae3446385906310c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $733ca86a81a89b77$var$RESOURCE_TYPE_CUSTOMER_PERMISSIONS = 'CUSTOMER_PERMISSIONS';

const $733ca86a81a89b77$export$ae3446385906310c = (0, $7edbf.createResource)({
    type: $733ca86a81a89b77$var$RESOURCE_TYPE_CUSTOMER_PERMISSIONS,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("kX0xM")),
    maxAge: Infinity
});

});
parcelRegister("kX0xM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eOt6K").then(()=>parcelRequire('9TCMW'));

});


parcelRegister("dCZZS", function(module, exports) {
$parcel$export(module.exports, "customerPermissionsRedirect", () => $da179d7ecb7c1cfa$export$59eedcca37dbbafd);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $da179d7ecb7c1cfa$export$59eedcca37dbbafd = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: url
    });
};

});

parcelRegister("aNhjU", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerPermissions", () => $2b68b284930b261e$export$5367e40a24f0bd54);
$parcel$export(module.exports, "default", () => $2b68b284930b261e$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $2b68b284930b261e$export$5367e40a24f0bd54 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7aNhx"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-customer-permissions/src/ServiceDeskCustomerPermissionsPage.tsx"
});
const $2b68b284930b261e$var$AsyncProjectSettingsServiceDeskCustomerPermissions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $2b68b284930b261e$export$5367e40a24f0bd54,
        pageId: "project-settings-customer-permissions",
        shouldShowSpinner: true
    });
$2b68b284930b261e$var$AsyncProjectSettingsServiceDeskCustomerPermissions.displayName = "AsyncProjectSettingsServiceDeskCustomerPermissions";
var $2b68b284930b261e$export$2e2bcd8739ae039 = $2b68b284930b261e$var$AsyncProjectSettingsServiceDeskCustomerPermissions;

});
parcelRegister("7aNhx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("eDYsB")
]).then(()=>parcelRequire('2Jx9M'));

});



parcelRegister("8zCHa", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRouteEntry", () => $805e077938fe8023$export$7b7294b50c70e50c);



var $9KaNE = parcelRequire("9KaNE");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $4DVg7 = parcelRequire("4DVg7");

var $78BYB = parcelRequire("78BYB");

var $74h93 = parcelRequire("74h93");

var $juqCr = parcelRequire("juqCr");
const $805e077938fe8023$export$7b7294b50c70e50c = (0, $fdS54.createEntry)((0, $78BYB.projectSettingsServicedeskChannelsPortalRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $juqCr.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $4DVg7.portalSettingsContextResource),
            (0, $9KaNE.serviceDeskPortalSettingsResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $juqCr.LazyProjectSettingsServiceDeskPortalSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9KaNE", function(module, exports) {
$parcel$export(module.exports, "serviceDeskPortalSettingsResource", () => $de5e59f3777cf83b$export$ed977e313d34da4b);
/* eslint-disable jira/filename-case */ 
var $htsFl = parcelRequire("htsFl");

var $iaLDD = parcelRequire("iaLDD");
const $de5e59f3777cf83b$export$ed977e313d34da4b = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_SERVICE_DESK_PORTAL_SETTINGS`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $iaLDD.default),
            variables: {
                cloudIdString: cloudId,
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("iaLDD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8570a07f978398d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50307b85d3ff5f9ee050b2035df873d2>>
 * @relayHash c324e30c6a8480f09db4e3a89d6f06a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28f8f3909c91ff287ac21cbf31f2dd93d56c24503dad52fbceb08473d09a40a4
const $8570a07f978398d1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdString"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudIdString"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyEditableAgents": true
            }
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ServiceDeskPortalSettingsQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "cloudIdString",
                            "variableName": "cloudIdString"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "CustomerPortalSettingsPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ServiceDeskPortalSettingsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalConfigReference"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "identityAccountId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "creatorType"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "RovoAgent_agentStudio_getAgents",
                    "kind": "LinkedHandle",
                    "name": "agentStudio_getAgents"
                },
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "AtlassianStudioUserProductPermissions",
                                    "kind": "LinkedField",
                                    "name": "userPermissions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAbleToCreateAgents"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianStudioUserSiteContextOutput"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "28f8f3909c91ff287ac21cbf31f2dd93d56c24503dad52fbceb08473d09a40a4",
            "metadata": {},
            "name": "ServiceDeskPortalSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8570a07f978398d1$var$node.hash = "eba27bb3ef600ddb29c1aba82b2a9c51";
var $8570a07f978398d1$export$2e2bcd8739ae039 = $8570a07f978398d1$var$node;

});


parcelRegister("4DVg7", function(module, exports) {
$parcel$export(module.exports, "portalSettingsContextResource", () => $5a98b4e342667e4b$export$4a3e29f235f3320c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $5a98b4e342667e4b$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';

const $5a98b4e342667e4b$export$4a3e29f235f3320c = (0, $7edbf.createResource)({
    type: $5a98b4e342667e4b$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("6nuoR"))
});

});
parcelRegister("6nuoR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5j3kU").then(()=>parcelRequire('aQ6Hf'));

});


parcelRegister("juqCr", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskPortalSettings", () => $0269ac5667397531$export$fdbd4b1e5ae0e422);
$parcel$export(module.exports, "default", () => $0269ac5667397531$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0269ac5667397531$export$fdbd4b1e5ae0e422 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("3fv6m")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-portal-settings/src/ExportedDefault.tsx"
});
const $0269ac5667397531$var$AsyncProjectSettingsServiceDeskPortalSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0269ac5667397531$export$fdbd4b1e5ae0e422,
        pageId: "project-settings-portal-settings",
        shouldShowSpinner: true
    });
$0269ac5667397531$var$AsyncProjectSettingsServiceDeskPortalSettings.displayName = "AsyncProjectSettingsServiceDeskPortalSettings";
var $0269ac5667397531$export$2e2bcd8739ae039 = $0269ac5667397531$var$AsyncProjectSettingsServiceDeskPortalSettings;

});
parcelRegister("3fv6m", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("dIeI9")
]).then(()=>parcelRequire('7l4OF'));

});



parcelRegister("dV8H2", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsRouteEntry", () => $384404d9383e2e94$export$2d20001d3350adbc);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ioJkG = parcelRequire("ioJkG");

var $74h93 = parcelRequire("74h93");

var $2l4Go = parcelRequire("2l4Go");
const $384404d9383e2e94$export$2d20001d3350adbc = (0, $fdS54.createEntry)((0, $ioJkG.projectSettingsServicedeskChannelsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2l4Go.channelsRedirect)('customer-permissions'),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ioJkG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsRoute", () => $dbbb66c1aa541aee$export$36e4210554830c2f);
const $dbbb66c1aa541aee$export$36e4210554830c2f = {
    name: 'project-settings-servicedesk-channels',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels',
    exact: true
};

});

parcelRegister("2l4Go", function(module, exports) {
$parcel$export(module.exports, "channelsRedirect", () => $004df4363e931d35$export$c7e6c0ac0abe2336);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3Sl5Y = parcelRequire("3Sl5Y");

var $f99M0 = parcelRequire("f99M0");

var $gNbXR = parcelRequire("gNbXR");
const $004df4363e931d35$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `${(0, $3Sl5Y.getNextgenSettingsUrl)((0, $f99M0.SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: url,
            push: false
        });
    };

});
parcelRegister("3Sl5Y", function(module, exports) {
$parcel$export(module.exports, "getNextgenSettingsUrl", () => $5a1736f2fd915006$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $5a1736f2fd915006$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $5a1736f2fd915006$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $5a1736f2fd915006$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $5a1736f2fd915006$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $5a1736f2fd915006$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $5a1736f2fd915006$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $5a1736f2fd915006$export$dad567762dae162e);

var $f99M0 = parcelRequire("f99M0");

var $bfa0b = parcelRequire("bfa0b");

var $ijgNF = parcelRequire("ijgNF");

var $i860n = parcelRequire("i860n");
const $5a1736f2fd915006$var$serializeBackLink = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $5a1736f2fd915006$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $f99M0.CORE_PROJECT)]: 'core',
        [(0, $f99M0.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $f99M0.CUSTOMER_SERVICE_PROJECT)]: (0, $i860n.fg)('csm_appification_standalone_navigation') ? 'customer-service-management' : 'servicedesk',
        [(0, $f99M0.SOFTWARE_PROJECT)]: 'software',
        [(0, $f99M0.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $ijgNF.logError)((0, $bfa0b.PACKAGE_NAME), 'urls', `Can't build default project settings url for project type: ${projectType}`, new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $5a1736f2fd915006$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT)) return `${$5a1736f2fd915006$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$5a1736f2fd915006$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$5a1736f2fd915006$var$serializeBackLink(backLink)}`;
};
const $5a1736f2fd915006$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT)) return `${$5a1736f2fd915006$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$5a1736f2fd915006$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $5a1736f2fd915006$export$b0d20d18e0230e83 = (projectKey)=>`${$5a1736f2fd915006$export$26432406821aa7bf((0, $f99M0.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $5a1736f2fd915006$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $5a1736f2fd915006$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $f99M0.SOFTWARE_PROJECT) && !isSimplified ? $5a1736f2fd915006$export$ff0a17aa36a000df(projectKey) : $5a1736f2fd915006$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $5a1736f2fd915006$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$5a1736f2fd915006$var$serializeBackLink(backLink)}`;
const $5a1736f2fd915006$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$5a1736f2fd915006$var$serializeBackLink(backLink)}`;

});
parcelRegister("bfa0b", function(module, exports) {
$parcel$export(module.exports, "TASK", () => $6d035fe2f93ba093$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $6d035fe2f93ba093$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $6d035fe2f93ba093$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $6d035fe2f93ba093$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $6d035fe2f93ba093$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $6d035fe2f93ba093$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $6d035fe2f93ba093$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $6d035fe2f93ba093$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $6d035fe2f93ba093$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $6d035fe2f93ba093$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $6d035fe2f93ba093$export$a11dccbf88784c62);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $6d035fe2f93ba093$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $6d035fe2f93ba093$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "PACKAGE_NAME", () => $6d035fe2f93ba093$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $6d035fe2f93ba093$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $6d035fe2f93ba093$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $6d035fe2f93ba093$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $6d035fe2f93ba093$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $6d035fe2f93ba093$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $6d035fe2f93ba093$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $6d035fe2f93ba093$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $6d035fe2f93ba093$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $6d035fe2f93ba093$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $6d035fe2f93ba093$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $6d035fe2f93ba093$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $6d035fe2f93ba093$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $6d035fe2f93ba093$export$d8b50f59220c7580);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $6d035fe2f93ba093$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $6d035fe2f93ba093$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $6d035fe2f93ba093$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $6d035fe2f93ba093$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $6d035fe2f93ba093$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $6d035fe2f93ba093$export$33dbe2a903610aa1);
/* eslint-disable jira/filename-case */ // Issue Type Templates

var $cDMQE = parcelRequire("cDMQE");
const $6d035fe2f93ba093$export$9355e489ad16f98e = 'task';
const $6d035fe2f93ba093$export$bcf558c186108044 = 'bug';
const $6d035fe2f93ba093$export$1ea39a3ae330045 = 'story';
const $6d035fe2f93ba093$export$3cb4a99a332e4186 = 'epic';
const $6d035fe2f93ba093$export$a06f889861f6537d = 'subtask';
const $6d035fe2f93ba093$export$952581bc40160893 = 'custom';
const $6d035fe2f93ba093$export$dff1da4a9bab6d3e = [
    $6d035fe2f93ba093$export$9355e489ad16f98e,
    $6d035fe2f93ba093$export$bcf558c186108044,
    $6d035fe2f93ba093$export$1ea39a3ae330045,
    $6d035fe2f93ba093$export$3cb4a99a332e4186
];
const $6d035fe2f93ba093$export$39cd48613b53ce2f = (0, $cDMQE.TEXT_AREA_CF_TYPE);
const $6d035fe2f93ba093$export$56eae1056efd4899 = (0, $cDMQE.DESCRIPTION_TYPE);
const $6d035fe2f93ba093$export$ca61f05d869b2ea3 = (0, $cDMQE.ENVIRONMENT_TYPE);
const $6d035fe2f93ba093$export$a11dccbf88784c62 = 'Jira Service Management';
const $6d035fe2f93ba093$export$2ec42920a0df6b9a = 'Story point estimate';
const $6d035fe2f93ba093$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $6d035fe2f93ba093$export$b8b9d90f9e5bd72b = 'jiraProjectSettingsAppsCommon';
const $6d035fe2f93ba093$export$a2231d79966e0ccc = 'NEW_';
const $6d035fe2f93ba093$export$28a4bdf7d9b6f9 = 'radio';
const $6d035fe2f93ba093$export$9d758b3e8c6e0ed1 = 'userpicker';
const $6d035fe2f93ba093$export$b0e37d421e006913 = 'multiuserpicker';
const $6d035fe2f93ba093$export$d77765147749db6b = 'select';
const $6d035fe2f93ba093$export$42ef68d6bd555a8d = 'cascadingselect';
const $6d035fe2f93ba093$export$4db6eb15b3c529cf = 'multiselect';
const $6d035fe2f93ba093$export$ee975373b7797e8a = 'checkbox';
const $6d035fe2f93ba093$export$aa99342cc6a8ced5 = 'text';
const $6d035fe2f93ba093$export$6f327bf99e20320 = 'number';
const $6d035fe2f93ba093$export$dc64bdfdf9660a05 = 'datetime';
const $6d035fe2f93ba093$export$e6d73ed745b9a04 = 'projectpicker';
const $6d035fe2f93ba093$export$d8b50f59220c7580 = 'date';
const $6d035fe2f93ba093$export$3a6f0a44478f1d2 = 'assetspicker';
const $6d035fe2f93ba093$export$68b76ef93df5a880 = 'labelpicker';
const $6d035fe2f93ba093$export$e7773fccbeec45e6 = 'grouppicker';
const $6d035fe2f93ba093$export$b45487b145c52a37 = 'multigrouppicker';
const $6d035fe2f93ba093$export$48548129a6d117f5 = 'version';
const $6d035fe2f93ba093$export$722c271a9e11cb94 = 'multiversion';
const $6d035fe2f93ba093$export$33dbe2a903610aa1 = 'textarea';

});
parcelRegister("cDMQE", function(module, exports) {
$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $98176e81b283ecb6$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $98176e81b283ecb6$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $98176e81b283ecb6$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $98176e81b283ecb6$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $98176e81b283ecb6$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $98176e81b283ecb6$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $98176e81b283ecb6$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $98176e81b283ecb6$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $98176e81b283ecb6$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $98176e81b283ecb6$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $98176e81b283ecb6$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $98176e81b283ecb6$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $98176e81b283ecb6$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $98176e81b283ecb6$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $98176e81b283ecb6$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $98176e81b283ecb6$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $98176e81b283ecb6$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $98176e81b283ecb6$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $98176e81b283ecb6$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $98176e81b283ecb6$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $98176e81b283ecb6$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $98176e81b283ecb6$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $98176e81b283ecb6$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $98176e81b283ecb6$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $98176e81b283ecb6$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $98176e81b283ecb6$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $98176e81b283ecb6$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $98176e81b283ecb6$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $98176e81b283ecb6$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $98176e81b283ecb6$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $98176e81b283ecb6$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $98176e81b283ecb6$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $98176e81b283ecb6$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $98176e81b283ecb6$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $98176e81b283ecb6$export$1f17904e959f2f0b);
$parcel$export(module.exports, "DATE_FORMULA_GQL_FIELD", () => $98176e81b283ecb6$export$237bf1e157794c5a);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $98176e81b283ecb6$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $98176e81b283ecb6$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_LINK_GQL_FIELD", () => $98176e81b283ecb6$export$ff2e58d499eebe1d);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $98176e81b283ecb6$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $98176e81b283ecb6$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $98176e81b283ecb6$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $98176e81b283ecb6$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $98176e81b283ecb6$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $98176e81b283ecb6$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $98176e81b283ecb6$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $98176e81b283ecb6$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "NUMBER_FORMULA_GQL_FIELD", () => $98176e81b283ecb6$export$4fb0b2a0fcb54e0);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $98176e81b283ecb6$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $98176e81b283ecb6$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $98176e81b283ecb6$export$31aea7548807c6b5);
$parcel$export(module.exports, "RESPONDERS_GQL_FIELD", () => $98176e81b283ecb6$export$379390890c7515ac);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $98176e81b283ecb6$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $98176e81b283ecb6$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $98176e81b283ecb6$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $98176e81b283ecb6$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $98176e81b283ecb6$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $98176e81b283ecb6$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $98176e81b283ecb6$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $98176e81b283ecb6$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $98176e81b283ecb6$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $98176e81b283ecb6$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $98176e81b283ecb6$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $98176e81b283ecb6$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $98176e81b283ecb6$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $98176e81b283ecb6$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_FORMULA_GQL_FIELD", () => $98176e81b283ecb6$export$1ce2ad10875c9e5d);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $98176e81b283ecb6$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $98176e81b283ecb6$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $98176e81b283ecb6$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $98176e81b283ecb6$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $98176e81b283ecb6$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $98176e81b283ecb6$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $98176e81b283ecb6$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $98176e81b283ecb6$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $98176e81b283ecb6$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $98176e81b283ecb6$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $98176e81b283ecb6$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $98176e81b283ecb6$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $98176e81b283ecb6$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $98176e81b283ecb6$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $98176e81b283ecb6$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $98176e81b283ecb6$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $98176e81b283ecb6$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $98176e81b283ecb6$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $98176e81b283ecb6$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $98176e81b283ecb6$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $98176e81b283ecb6$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $98176e81b283ecb6$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $98176e81b283ecb6$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $98176e81b283ecb6$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $98176e81b283ecb6$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $98176e81b283ecb6$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $98176e81b283ecb6$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $98176e81b283ecb6$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $98176e81b283ecb6$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $98176e81b283ecb6$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_CHANNEL_SOURCE_GQL_FIELD", () => $98176e81b283ecb6$export$f662f4e49ec67d9e);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $98176e81b283ecb6$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $98176e81b283ecb6$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $98176e81b283ecb6$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $98176e81b283ecb6$export$bfcb1a91094f113a);
$parcel$export(module.exports, "ATLAS_PROJECT_GQL_FIELD", () => $98176e81b283ecb6$export$29f2606483502142);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $98176e81b283ecb6$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $98176e81b283ecb6$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $98176e81b283ecb6$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $98176e81b283ecb6$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $98176e81b283ecb6$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $98176e81b283ecb6$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $98176e81b283ecb6$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $98176e81b283ecb6$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $98176e81b283ecb6$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $98176e81b283ecb6$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $98176e81b283ecb6$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $98176e81b283ecb6$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "FORGE_OBJECT_TYPE", () => $98176e81b283ecb6$export$8b34f7786d465001);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $98176e81b283ecb6$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $98176e81b283ecb6$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $98176e81b283ecb6$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $98176e81b283ecb6$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $98176e81b283ecb6$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $98176e81b283ecb6$export$492b0fa4fe201a22);
$parcel$export(module.exports, "FORMULA_NUMBER_CF_TYPE", () => $98176e81b283ecb6$export$45cfbf005b320b9c);
$parcel$export(module.exports, "FORMULA_DATE_CF_TYPE", () => $98176e81b283ecb6$export$983d1a3f0bd33fcf);
$parcel$export(module.exports, "FORMULA_TEXT_CF_TYPE", () => $98176e81b283ecb6$export$ccfd6611015b4827);
$parcel$export(module.exports, "URL_CF_TYPE", () => $98176e81b283ecb6$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $98176e81b283ecb6$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $98176e81b283ecb6$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $98176e81b283ecb6$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $98176e81b283ecb6$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $98176e81b283ecb6$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $98176e81b283ecb6$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $98176e81b283ecb6$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $98176e81b283ecb6$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $98176e81b283ecb6$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $98176e81b283ecb6$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $98176e81b283ecb6$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $98176e81b283ecb6$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $98176e81b283ecb6$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $98176e81b283ecb6$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $98176e81b283ecb6$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $98176e81b283ecb6$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $98176e81b283ecb6$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $98176e81b283ecb6$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $98176e81b283ecb6$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $98176e81b283ecb6$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $98176e81b283ecb6$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $98176e81b283ecb6$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $98176e81b283ecb6$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $98176e81b283ecb6$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $98176e81b283ecb6$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $98176e81b283ecb6$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $98176e81b283ecb6$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $98176e81b283ecb6$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $98176e81b283ecb6$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $98176e81b283ecb6$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $98176e81b283ecb6$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $98176e81b283ecb6$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $98176e81b283ecb6$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $98176e81b283ecb6$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $98176e81b283ecb6$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $98176e81b283ecb6$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $98176e81b283ecb6$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $98176e81b283ecb6$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $98176e81b283ecb6$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $98176e81b283ecb6$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $98176e81b283ecb6$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $98176e81b283ecb6$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "JIM_PLUGIN_IMPORT_ID_LINK_CF_TYPE", () => $98176e81b283ecb6$export$f94696506ee781f9);
$parcel$export(module.exports, "SYSTEM_IMPORT_ID_LINK_CF_TYPE", () => $98176e81b283ecb6$export$8ba6ed64df1ce64a);
$parcel$export(module.exports, "UUID_CF_TYPE", () => $98176e81b283ecb6$export$e90ce947f06b085d);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $98176e81b283ecb6$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $98176e81b283ecb6$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "SOURCE_CHANNEL_CF_TYPE", () => $98176e81b283ecb6$export$4cf67719dbe62fa);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $98176e81b283ecb6$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $98176e81b283ecb6$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $98176e81b283ecb6$export$2d75b47d12efc812);
$parcel$export(module.exports, "ATTACHMENTS_NUMBER_CF_TYPE", () => $98176e81b283ecb6$export$36500b2821f7114f);
$parcel$export(module.exports, "LAST_COMMENT_DATE_CF_TYPE", () => $98176e81b283ecb6$export$37dc91333ba7a96);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $98176e81b283ecb6$export$7b79405842547ccb);
$parcel$export(module.exports, "ASSIGNEE_DOMAIN_CF_TYPE", () => $98176e81b283ecb6$export$ac9f7d2dfc7c6826);
$parcel$export(module.exports, "REPORTER_DOMAIN_CF_TYPE", () => $98176e81b283ecb6$export$a3d9c149d737aa78);
$parcel$export(module.exports, "COMMENTS_NUMBER_CF_TYPE", () => $98176e81b283ecb6$export$4745e551386233a5);
$parcel$export(module.exports, "DAYS_LAST_COMMENTED_CF_TYPE", () => $98176e81b283ecb6$export$5ee213d6fd4c9b2b);
$parcel$export(module.exports, "LAST_USER_COMMENTED_CF_TYPE", () => $98176e81b283ecb6$export$fb0b6a2e098e1fe2);
$parcel$export(module.exports, "SLA_CF_TYPE", () => $98176e81b283ecb6$export$fe1291c40f590f35);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $98176e81b283ecb6$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $98176e81b283ecb6$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $98176e81b283ecb6$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $98176e81b283ecb6$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $98176e81b283ecb6$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ATLAS_PROJECT_CF_TYPE", () => $98176e81b283ecb6$export$bea7cbcd967ef962);
$parcel$export(module.exports, "ANY_CF_TYPE", () => $98176e81b283ecb6$export$8c0f7dd088e5671d);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $98176e81b283ecb6$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $98176e81b283ecb6$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $98176e81b283ecb6$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $98176e81b283ecb6$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $98176e81b283ecb6$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $98176e81b283ecb6$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $98176e81b283ecb6$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $98176e81b283ecb6$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $98176e81b283ecb6$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $98176e81b283ecb6$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $98176e81b283ecb6$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $98176e81b283ecb6$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $98176e81b283ecb6$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $98176e81b283ecb6$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $98176e81b283ecb6$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $98176e81b283ecb6$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $98176e81b283ecb6$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $98176e81b283ecb6$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $98176e81b283ecb6$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $98176e81b283ecb6$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $98176e81b283ecb6$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $98176e81b283ecb6$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $98176e81b283ecb6$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $98176e81b283ecb6$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $98176e81b283ecb6$export$d09aa6a4f3538063);
$parcel$export(module.exports, "WORK_ITEM_CREATED_PROFORMA_FORMS", () => $98176e81b283ecb6$export$ea10edc04f091c3f);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $98176e81b283ecb6$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $98176e81b283ecb6$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $98176e81b283ecb6$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $98176e81b283ecb6$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $98176e81b283ecb6$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $98176e81b283ecb6$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $98176e81b283ecb6$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $98176e81b283ecb6$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $98176e81b283ecb6$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $98176e81b283ecb6$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $98176e81b283ecb6$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $98176e81b283ecb6$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $98176e81b283ecb6$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $98176e81b283ecb6$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $98176e81b283ecb6$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $98176e81b283ecb6$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $98176e81b283ecb6$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $98176e81b283ecb6$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $98176e81b283ecb6$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $98176e81b283ecb6$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $98176e81b283ecb6$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $98176e81b283ecb6$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $98176e81b283ecb6$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $98176e81b283ecb6$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $98176e81b283ecb6$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $98176e81b283ecb6$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $98176e81b283ecb6$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $98176e81b283ecb6$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "WORKLOG", () => $98176e81b283ecb6$export$df36fc05622c402);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $98176e81b283ecb6$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $98176e81b283ecb6$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $98176e81b283ecb6$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $98176e81b283ecb6$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $98176e81b283ecb6$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $98176e81b283ecb6$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $98176e81b283ecb6$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $98176e81b283ecb6$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $98176e81b283ecb6$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $98176e81b283ecb6$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $98176e81b283ecb6$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $98176e81b283ecb6$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $98176e81b283ecb6$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $98176e81b283ecb6$export$48f82d653f85e459);
$parcel$export(module.exports, "TIME_SPENT_PORTFOLIO_TYPE", () => $98176e81b283ecb6$export$6737679b7674e795);
$parcel$export(module.exports, "TIME_ESTIMATE_PORTFOLIO_TYPE", () => $98176e81b283ecb6$export$fecd2d910d335851);
$parcel$export(module.exports, "START_DATE_TYPE", () => $98176e81b283ecb6$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $98176e81b283ecb6$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $98176e81b283ecb6$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $98176e81b283ecb6$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $98176e81b283ecb6$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $98176e81b283ecb6$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $98176e81b283ecb6$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $98176e81b283ecb6$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "AGGREGATE_TIME_ORIGINAL_ESTIMATE", () => $98176e81b283ecb6$export$871661506c0a91ea);
$parcel$export(module.exports, "AGGREGATE_TIME_ESTIMATE", () => $98176e81b283ecb6$export$4a7ecfe931ab6c07);
$parcel$export(module.exports, "PROGRESS", () => $98176e81b283ecb6$export$fbc5ebe2e580bf8b);
$parcel$export(module.exports, "AGGREGATE_PROGRESS", () => $98176e81b283ecb6$export$aa3b37e271efd578);
$parcel$export(module.exports, "WORKRATIO", () => $98176e81b283ecb6$export$444bffe6526fb5f2);
$parcel$export(module.exports, "FORMULA_FIELD_TYPES", () => $98176e81b283ecb6$export$433c2a3da5fb4d6c);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $98176e81b283ecb6$export$3c3e26aadbfa2c32);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $i860n = parcelRequire("i860n");
const $98176e81b283ecb6$export$b144116dae474c88 = 'issue-link-search';
const $98176e81b283ecb6$export$bc917bc699b25f75 = 'number';
const $98176e81b283ecb6$export$5f26ca419fdffbe7 = 'string';
const $98176e81b283ecb6$export$ce9bfd823c7e1a6d = 'datetime';
const $98176e81b283ecb6$export$346b72b1f7cd6d5a = 'date';
const $98176e81b283ecb6$export$b20fbcacd7942c2a = 'option2';
const $98176e81b283ecb6$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $98176e81b283ecb6$export$a2e8554bffc61ece = 'any';
const $98176e81b283ecb6$export$f25cd4907cbb25b9 = 'array';
const $98176e81b283ecb6$export$5600354b43577e17 = 'user';
const $98176e81b283ecb6$export$5dbc9917f72d0d2a = 'group';
const $98176e81b283ecb6$export$253649f07fb55948 = 'object';
const $98176e81b283ecb6$export$eb39592ba5247ee7 = 'group-list';
const $98176e81b283ecb6$export$f48a9be226105736 = 'array-string';
const $98176e81b283ecb6$export$42e2e93fc721df5d = 'version';
const $98176e81b283ecb6$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $98176e81b283ecb6$export$7773375e72c953ed = 'approval-panel';
const $98176e81b283ecb6$export$80ad0037098f3919 = 'project';
const $98176e81b283ecb6$export$82db8a26de491dd2 = 'array';
const $98176e81b283ecb6$export$c10d49310c28a01a = 'object';
const $98176e81b283ecb6$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $98176e81b283ecb6$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $98176e81b283ecb6$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $98176e81b283ecb6$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $98176e81b283ecb6$export$c979d9c548c05133 = 'JiraBooleanField';
const $98176e81b283ecb6$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $98176e81b283ecb6$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $98176e81b283ecb6$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $98176e81b283ecb6$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $98176e81b283ecb6$export$b0deb225eed90fbd = 'JiraCMDBField';
const $98176e81b283ecb6$export$add3775cfea8fde3 = 'JiraColorField';
const $98176e81b283ecb6$export$9631d4098abab3eb = 'JiraComponentsField';
const $98176e81b283ecb6$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $98176e81b283ecb6$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $98176e81b283ecb6$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $98176e81b283ecb6$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $98176e81b283ecb6$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $98176e81b283ecb6$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $98176e81b283ecb6$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $98176e81b283ecb6$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $98176e81b283ecb6$export$237bf1e157794c5a = 'JiraDateFormulaField';
const $98176e81b283ecb6$export$6d8da4497234455 = 'JiraEpicLinkField';
const $98176e81b283ecb6$export$9bcfac568e4fa59c = 'JiraFlagField';
const $98176e81b283ecb6$export$d2cadc5e6eb21e96 = 'JiraFormulaField';
const $98176e81b283ecb6$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $98176e81b283ecb6$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $98176e81b283ecb6$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $98176e81b283ecb6$export$810709f0c5c2e9db = 'JiraLabelsField';
const $98176e81b283ecb6$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $98176e81b283ecb6$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $98176e81b283ecb6$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $98176e81b283ecb6$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $98176e81b283ecb6$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $98176e81b283ecb6$export$4fb0b2a0fcb54e0 = 'JiraNumberFormulaField';
const $98176e81b283ecb6$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $98176e81b283ecb6$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $98176e81b283ecb6$export$31aea7548807c6b5 = 'JiraPeopleField';
const $98176e81b283ecb6$export$379390890c7515ac = 'JiraServiceManagementRespondersField';
const $98176e81b283ecb6$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $98176e81b283ecb6$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $98176e81b283ecb6$export$23f8dc81a6872ec4 = 'JiraIssueCreatedProformaFormsField';
const $98176e81b283ecb6$export$12f54499c6252188 = 'JiraProjectField';
const $98176e81b283ecb6$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $98176e81b283ecb6$export$c69486dd643dfb69 = 'JiraReporterField';
const $98176e81b283ecb6$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $98176e81b283ecb6$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $98176e81b283ecb6$export$37f4daaa7b409554 = 'JiraRichTextField';
const $98176e81b283ecb6$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $98176e81b283ecb6$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $98176e81b283ecb6$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $98176e81b283ecb6$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $98176e81b283ecb6$export$e40f819979b3881d = 'JiraStatusField';
const $98176e81b283ecb6$export$6c243704a22baffe = 'JiraTeamField';
const $98176e81b283ecb6$export$6c32429bac235203 = 'JiraTeamViewField';
const $98176e81b283ecb6$export$1ce2ad10875c9e5d = 'JiraTextFormulaField';
const $98176e81b283ecb6$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $98176e81b283ecb6$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $98176e81b283ecb6$export$37ccd11f08a93ccb = 'JiraUrlField';
const $98176e81b283ecb6$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $98176e81b283ecb6$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $98176e81b283ecb6$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $98176e81b283ecb6$export$aa815aaa741ae18 = 'JiraWatchesField';
const $98176e81b283ecb6$export$e805f89b15d2abf4 = 'JiraAssetField';
const $98176e81b283ecb6$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $98176e81b283ecb6$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $98176e81b283ecb6$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $98176e81b283ecb6$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $98176e81b283ecb6$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $98176e81b283ecb6$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $98176e81b283ecb6$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $98176e81b283ecb6$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $98176e81b283ecb6$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $98176e81b283ecb6$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $98176e81b283ecb6$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $98176e81b283ecb6$export$c48132adab502d6b = 'JiraForgeUsersField';
const $98176e81b283ecb6$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $98176e81b283ecb6$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $98176e81b283ecb6$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $98176e81b283ecb6$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $98176e81b283ecb6$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $98176e81b283ecb6$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $98176e81b283ecb6$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $98176e81b283ecb6$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $98176e81b283ecb6$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $98176e81b283ecb6$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $98176e81b283ecb6$export$f662f4e49ec67d9e = 'JiraServiceManagementChannelSourceField';
const $98176e81b283ecb6$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $98176e81b283ecb6$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $98176e81b283ecb6$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $98176e81b283ecb6$export$bfcb1a91094f113a = 'JiraGoalsField';
const $98176e81b283ecb6$export$29f2606483502142 = 'JiraTownsquareProjectField';
const $98176e81b283ecb6$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $98176e81b283ecb6$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $98176e81b283ecb6$export$798d2f5814884447 = 'forgeCustomField';
const $98176e81b283ecb6$export$1e188101081be3f8 = 'forge/string';
const $98176e81b283ecb6$export$caf3b3f20c0589b9 = 'forge/string-list';
const $98176e81b283ecb6$export$9bdf08a1276e866c = 'forge/number';
const $98176e81b283ecb6$export$996c3d3eb2880229 = 'forge/date';
const $98176e81b283ecb6$export$578c5856bf684e2a = 'forge/datetime';
const $98176e81b283ecb6$export$38791c0fdd0bcce = 'forge/user';
const $98176e81b283ecb6$export$5c209e1debd6c274 = 'forge/user-list';
const $98176e81b283ecb6$export$8646fecba9a8be61 = 'forge/group';
const $98176e81b283ecb6$export$68b91cd2f2e6b810 = 'forge/group-list';
const $98176e81b283ecb6$export$8b34f7786d465001 = 'forge/object';
const $98176e81b283ecb6$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $98176e81b283ecb6$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $98176e81b283ecb6$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $98176e81b283ecb6$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $98176e81b283ecb6$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $98176e81b283ecb6$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $98176e81b283ecb6$export$45cfbf005b320b9c = 'com.atlassian.jira.system.formula.fieldtypes:numberformula';
const $98176e81b283ecb6$export$983d1a3f0bd33fcf = 'com.atlassian.jira.system.formula.fieldtypes:dateformula';
const $98176e81b283ecb6$export$ccfd6611015b4827 = 'com.atlassian.jira.system.formula.fieldtypes:textformula';
const $98176e81b283ecb6$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $98176e81b283ecb6$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $98176e81b283ecb6$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $98176e81b283ecb6$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $98176e81b283ecb6$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $98176e81b283ecb6$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $98176e81b283ecb6$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $98176e81b283ecb6$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $98176e81b283ecb6$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $98176e81b283ecb6$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $98176e81b283ecb6$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $98176e81b283ecb6$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $98176e81b283ecb6$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $98176e81b283ecb6$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $98176e81b283ecb6$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $98176e81b283ecb6$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $98176e81b283ecb6$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $98176e81b283ecb6$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $98176e81b283ecb6$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $98176e81b283ecb6$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $98176e81b283ecb6$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $98176e81b283ecb6$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $98176e81b283ecb6$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $98176e81b283ecb6$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $98176e81b283ecb6$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $98176e81b283ecb6$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $98176e81b283ecb6$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $98176e81b283ecb6$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $98176e81b283ecb6$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $98176e81b283ecb6$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $98176e81b283ecb6$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $98176e81b283ecb6$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $98176e81b283ecb6$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $98176e81b283ecb6$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $98176e81b283ecb6$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $98176e81b283ecb6$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $98176e81b283ecb6$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $98176e81b283ecb6$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $98176e81b283ecb6$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $98176e81b283ecb6$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $98176e81b283ecb6$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $98176e81b283ecb6$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $98176e81b283ecb6$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $98176e81b283ecb6$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $98176e81b283ecb6$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $98176e81b283ecb6$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $98176e81b283ecb6$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $98176e81b283ecb6$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $98176e81b283ecb6$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $98176e81b283ecb6$export$4cf67719dbe62fa = 'com.atlassian.servicedesk.customer-context:sd-csm-source-channel';
const $98176e81b283ecb6$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $98176e81b283ecb6$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $98176e81b283ecb6$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $98176e81b283ecb6$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $98176e81b283ecb6$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $98176e81b283ecb6$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $98176e81b283ecb6$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $98176e81b283ecb6$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $98176e81b283ecb6$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $98176e81b283ecb6$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $98176e81b283ecb6$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $98176e81b283ecb6$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $98176e81b283ecb6$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $98176e81b283ecb6$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $98176e81b283ecb6$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $98176e81b283ecb6$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $98176e81b283ecb6$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $98176e81b283ecb6$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $98176e81b283ecb6$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $98176e81b283ecb6$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $98176e81b283ecb6$export$bea7cbcd967ef962 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlas-project';
const $98176e81b283ecb6$export$8c0f7dd088e5671d = 'any.custom.field.type';
const $98176e81b283ecb6$export$fba8634fd401ba8b = 'assignee';
const $98176e81b283ecb6$export$a91aea2438afcce8 = 'reporter';
const $98176e81b283ecb6$export$b159f8b8f27aae4c = 'duedate';
const $98176e81b283ecb6$export$34740f8d07d23ac0 = 'priority';
const $98176e81b283ecb6$export$43b6e33ec70f2272 = 'labels';
const $98176e81b283ecb6$export$ff39ebd4bb12b718 = 'created';
const $98176e81b283ecb6$export$cd8e68094cb5c3cb = 'updated';
const $98176e81b283ecb6$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $98176e81b283ecb6$export$37abf56f13f61ec5 = 'components';
const $98176e81b283ecb6$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $98176e81b283ecb6$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $98176e81b283ecb6$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $98176e81b283ecb6$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $98176e81b283ecb6$export$791007408faf42f4 = 'servicedesk-incident-management';
const $98176e81b283ecb6$export$827a1c600bac12a3 = 'devSummary';
const $98176e81b283ecb6$export$e9ba671d077969f8 = 'releases';
const $98176e81b283ecb6$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $98176e81b283ecb6$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $98176e81b283ecb6$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $98176e81b283ecb6$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $98176e81b283ecb6$export$a5c9f63aadcb220 = 'fixVersions';
const $98176e81b283ecb6$export$94009605902e4fe5 = 'versions';
const $98176e81b283ecb6$export$5e7324042f1d6b31 = 'description';
const $98176e81b283ecb6$export$113281d03e6830ef = 'environment';
const $98176e81b283ecb6$export$5ff798870a3dffbf = 'watches';
const $98176e81b283ecb6$export$907219511d14ba3d = 'summary';
const $98176e81b283ecb6$export$d09aa6a4f3538063 = 'proforma-forms';
const $98176e81b283ecb6$export$ea10edc04f091c3f = 'sfid:proforma:work-item-created-forms';
const $98176e81b283ecb6$export$b721454288a0403f = 'work-item-created-proforma-forms';
const $98176e81b283ecb6$export$3aca8c91b58a42e2 = 'resolution';
const $98176e81b283ecb6$export$ccb5ffefbf8b987c = 'timetracking';
const $98176e81b283ecb6$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $98176e81b283ecb6$export$358267065be1e = 'status';
const $98176e81b283ecb6$export$dcaa788c7ada56de = 'statusCategory';
const $98176e81b283ecb6$export$ebb48b08205007c5 = 'issuetype';
const $98176e81b283ecb6$export$5e91047fe9955d0e = 'issuekey';
const $98176e81b283ecb6$export$3b3d0889022c85b3 = 'children-issues';
const $98176e81b283ecb6$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $98176e81b283ecb6$export$8fe3d5be8cb17459 = 'epic-issues';
const $98176e81b283ecb6$export$335851d83a79891 = 'hierarchy-level-below';
const $98176e81b283ecb6$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $98176e81b283ecb6$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $98176e81b283ecb6$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $98176e81b283ecb6$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $98176e81b283ecb6$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $98176e81b283ecb6$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $98176e81b283ecb6$export$7b3d247435a784fa = 'SLA_PANEL';
const $98176e81b283ecb6$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $98176e81b283ecb6$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $98176e81b283ecb6$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $98176e81b283ecb6$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $98176e81b283ecb6$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $98176e81b283ecb6$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $98176e81b283ecb6$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $98176e81b283ecb6$export$22f61ccc2730431f = 'similar-issues';
const $98176e81b283ecb6$export$8bbb446f57294715 = 'subtasks';
const $98176e81b283ecb6$export$34fcd7cb291a1e4d = 'votes';
const $98176e81b283ecb6$export$5e93f2a57cc4ca3a = 'parent';
const $98176e81b283ecb6$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $98176e81b283ecb6$export$91a9dba2d38d9a6f = 'project';
const $98176e81b283ecb6$export$df36fc05622c402 = 'worklog';
const $98176e81b283ecb6$export$ede0a4c20124ec85 = 'timespent';
const $98176e81b283ecb6$export$3eeb79d48fb5f667 = 'dataclassification';
const $98176e81b283ecb6$export$45e72c9a63ab61ab = 'SENTIMENT';
const $98176e81b283ecb6$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $98176e81b283ecb6$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $98176e81b283ecb6$export$f34e595ab8b16b26 = 'com.atlassian.jira.plugin.system.customfieldtypes:agent-sessions';
const $98176e81b283ecb6$export$99ad62164189f781 = 'ecosystemGlance';
const $98176e81b283ecb6$export$7719ef6e9283671 = 'forgeGlance';
const $98176e81b283ecb6$export$bfebea5ce2e1887a = 'ecosystemContext';
const $98176e81b283ecb6$export$be8e68fb1aed253e = 'forgeContext';
const $98176e81b283ecb6$export$84e5674890d55030 = 'issuerestriction';
const $98176e81b283ecb6$export$326a5522a485e43d = 'security';
const $98176e81b283ecb6$export$c9f3f01e2c535302 = 'securitylevel';
const $98176e81b283ecb6$export$35e5652f764785bd = 'creator';
const $98176e81b283ecb6$export$66519f3bbff1796a = 'team';
const $98176e81b283ecb6$export$a4ee0bca77cc8463 = 'estimate';
const $98176e81b283ecb6$export$fed53408e89e0497 = 'dueDate';
const $98176e81b283ecb6$export$d53c26f9ce31f56b = 'targetStart';
const $98176e81b283ecb6$export$48f82d653f85e459 = 'targetEnd';
const $98176e81b283ecb6$export$6737679b7674e795 = 'timeSpent';
const $98176e81b283ecb6$export$fecd2d910d335851 = 'timeEstimate';
const $98176e81b283ecb6$export$ea5a888f39f722c7 = 'startDate';
const $98176e81b283ecb6$export$f245bbec12cc0e40 = 'color';
const $98176e81b283ecb6$export$aed630b4b7114a59 = 'attachment';
const $98176e81b283ecb6$export$b50c1a8fef07104 = 'issuelinks';
const $98176e81b283ecb6$export$ea3d72f4bb7738ba = 'timeestimate';
const $98176e81b283ecb6$export$a4cab0124760d860 = 'comment';
const $98176e81b283ecb6$export$734929aef118d7e2 = 'worklog';
const $98176e81b283ecb6$export$ffbacacb07c1d46d = 'parent';
const $98176e81b283ecb6$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $98176e81b283ecb6$export$278c072e2f9176ab = 'aggregatetimespent';
const $98176e81b283ecb6$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $98176e81b283ecb6$export$fbc5ebe2e580bf8b = 'progress';
const $98176e81b283ecb6$export$aa3b37e271efd578 = 'aggregateprogress';
const $98176e81b283ecb6$export$444bffe6526fb5f2 = 'workratio';
const $98176e81b283ecb6$export$433c2a3da5fb4d6c = [
    $98176e81b283ecb6$export$45cfbf005b320b9c,
    $98176e81b283ecb6$export$983d1a3f0bd33fcf,
    $98176e81b283ecb6$export$ccfd6611015b4827
];
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $98176e81b283ecb6$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $98176e81b283ecb6$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $98176e81b283ecb6$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $98176e81b283ecb6$export$34740f8d07d23ac0,
        REPORTER_TYPE: $98176e81b283ecb6$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $98176e81b283ecb6$export$5e7324042f1d6b31,
        LABELS_TYPE: $98176e81b283ecb6$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $98176e81b283ecb6$export$37abf56f13f61ec5,
        SPRINT_TYPE: $98176e81b283ecb6$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $98176e81b283ecb6$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $98176e81b283ecb6$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $98176e81b283ecb6$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $98176e81b283ecb6$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $98176e81b283ecb6$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $98176e81b283ecb6$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $98176e81b283ecb6$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $98176e81b283ecb6$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $98176e81b283ecb6$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $98176e81b283ecb6$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $98176e81b283ecb6$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $98176e81b283ecb6$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $98176e81b283ecb6$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $98176e81b283ecb6$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $98176e81b283ecb6$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $98176e81b283ecb6$export$c7ae0622b0bd5d56,
        RESPONDERS_CF_TYPE: $98176e81b283ecb6$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $98176e81b283ecb6$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $98176e81b283ecb6$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $98176e81b283ecb6$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $98176e81b283ecb6$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $98176e81b283ecb6$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $98176e81b283ecb6$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $98176e81b283ecb6$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $98176e81b283ecb6$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $98176e81b283ecb6$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $98176e81b283ecb6$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $98176e81b283ecb6$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $98176e81b283ecb6$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $98176e81b283ecb6$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $98176e81b283ecb6$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $98176e81b283ecb6$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $98176e81b283ecb6$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $98176e81b283ecb6$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $98176e81b283ecb6$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $98176e81b283ecb6$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $98176e81b283ecb6$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $98176e81b283ecb6$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $98176e81b283ecb6$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $98176e81b283ecb6$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $98176e81b283ecb6$export$39866626496bbfc8,
        VERSION_CF_TYPE: $98176e81b283ecb6$export$24382b4e8c58336b,
        DATE_CF_TYPE: $98176e81b283ecb6$export$ff745f432984005d,
        GROUP_CF_TYPE: $98176e81b283ecb6$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $98176e81b283ecb6$export$b600addfa3355c57,
        USER_CF_TYPE: $98176e81b283ecb6$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $98176e81b283ecb6$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $98176e81b283ecb6$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $98176e81b283ecb6$export$65524be5675e57e6,
        TEAM_CF_TYPE: $98176e81b283ecb6$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $98176e81b283ecb6$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $98176e81b283ecb6$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $98176e81b283ecb6$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $98176e81b283ecb6$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $98176e81b283ecb6$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $98176e81b283ecb6$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $98176e81b283ecb6$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $98176e81b283ecb6$export$1be1ecd4dfc06fab,
        ORGANIZATION_CF_TYPE: $98176e81b283ecb6$export$c1e26582406f77ec,
        ORGANIZATIONS_CF_TYPE: $98176e81b283ecb6$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $98176e81b283ecb6$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $98176e81b283ecb6$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $98176e81b283ecb6$export$555b4f35f98a3210,
        APPROVERS_LIST_CF_TYPE: $98176e81b283ecb6$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $98176e81b283ecb6$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $98176e81b283ecb6$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $98176e81b283ecb6$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $98176e81b283ecb6$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $98176e81b283ecb6$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $98176e81b283ecb6$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $98176e81b283ecb6$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $98176e81b283ecb6$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $98176e81b283ecb6$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $98176e81b283ecb6$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $98176e81b283ecb6$export$2bbb7f69c97ea279,
        ATLAS_PROJECT_CF_TYPE: $98176e81b283ecb6$export$bea7cbcd967ef962,
        PARENT_TYPE: $98176e81b283ecb6$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $98176e81b283ecb6$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $98176e81b283ecb6$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $98176e81b283ecb6$export$45e72c9a63ab61ab
    });
    if ((0, $i860n.fg)('csm_omni_source_channel_cf_fe')) Object.assign(types, {
        SOURCE_CHANNEL_CF_TYPE: $98176e81b283ecb6$export$4cf67719dbe62fa
    });
    if ((0, $i860n.fg)('frontier-formula-field-d2-d3')) Object.assign(types, {
        FORMULA_NUMBER_CF_TYPE: $98176e81b283ecb6$export$45cfbf005b320b9c,
        FORMULA_DATE_CF_TYPE: $98176e81b283ecb6$export$983d1a3f0bd33fcf,
        FORMULA_TEXT_CF_TYPE: $98176e81b283ecb6$export$ccfd6611015b4827
    });
    return types;
};
const $98176e81b283ecb6$export$3c3e26aadbfa2c32 = (0, $emCaV.default)($98176e81b283ecb6$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("ijgNF", function(module, exports) {
$parcel$export(module.exports, "logError", () => $2b8398af144ff2dc$export$58da9968c3170cb1);

var $hFtK7 = parcelRequire("hFtK7");

var $6CfY5 = parcelRequire("6CfY5");
const $2b8398af144ff2dc$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $6CfY5.default).unsafeErrorWithCustomerData(location, message, error);
};

});




parcelRegister("5GznM", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRouteEntry", () => $71bfadc075ad2b50$export$dcfc82c90a86b038);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $9pf2j = parcelRequire("9pf2j");

var $74h93 = parcelRequire("74h93");

var $b8tRK = parcelRequire("b8tRK");

var $k0XvP = parcelRequire("k0XvP");
const $71bfadc075ad2b50$export$dcfc82c90a86b038 = (0, $fdS54.createEntry)((0, $9pf2j.projectSettingsServicedeskChannelsWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $b8tRK.widgetsNextGenRedirect),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $k0XvP.LazyProjectSettingsServiceDeskWidgetSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("b8tRK", function(module, exports) {
$parcel$export(module.exports, "widgetsNextGenRedirect", () => $adbc5570600a4061$export$8ba256148f9b998f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $adbc5570600a4061$export$8ba256148f9b998f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: url
    });
};

});

parcelRegister("k0XvP", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskWidgetSettings", () => $1f2d4144f44022e5$export$216a049c4d917b0);
$parcel$export(module.exports, "default", () => $1f2d4144f44022e5$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1f2d4144f44022e5$export$216a049c4d917b0 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("biGvF")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-widget-settings/src/index.tsx"
});
const $1f2d4144f44022e5$var$AsyncProjectSettingsServiceDeskWidgetSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1f2d4144f44022e5$export$216a049c4d917b0,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });
$1f2d4144f44022e5$var$AsyncProjectSettingsServiceDeskWidgetSettings.displayName = "AsyncProjectSettingsServiceDeskWidgetSettings";
var $1f2d4144f44022e5$export$2e2bcd8739ae039 = $1f2d4144f44022e5$var$AsyncProjectSettingsServiceDeskWidgetSettings;

});
parcelRegister("biGvF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("kEMDZ")
]).then(()=>parcelRequire('iUvKs'));

});



parcelRegister("kyWXG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChatRouteEntry", () => $ebb068235d31b4c6$export$f030ac1baa84c682);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $90PZX = parcelRequire("90PZX");

var $74h93 = parcelRequire("74h93");

var $cd7j2 = parcelRequire("cd7j2");
const $ebb068235d31b4c6$export$f030ac1baa84c682 = (0, $fdS54.createEntry)((0, $90PZX.projectSettingsServicedeskChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cd7j2.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cd7j2.LazyProjectSettingsServiceDeskChatSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("b3uRO", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRouteEntry", () => $83fa2c04d8799c19$export$5a4abc64d2a82698);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $7sodi = parcelRequire("7sodi");

var $74h93 = parcelRequire("74h93");

var $4btZt = parcelRequire("4btZt");
const $83fa2c04d8799c19$export$5a4abc64d2a82698 = (0, $fdS54.createEntry)((0, $7sodi.projectSettingsServicedeskCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4btZt.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4btZt.LazyProjectSettingsServiceDeskCustomerNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4btZt", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerNotifications", () => $7eaefb511da83636$export$c763ea321ade5f68);
$parcel$export(module.exports, "default", () => $7eaefb511da83636$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $2LCqr = parcelRequire("2LCqr");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7eaefb511da83636$export$c763ea321ade5f68 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("fNgU6")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-customer-notifications/src/ExportedDefault.tsx"
});
const $7eaefb511da83636$var$AsyncProjectSettingsServiceDeskCustomerNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2LCqr.HelpCenterSettingsRedirect), {
        page: "customer-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7eaefb511da83636$export$c763ea321ade5f68,
        pageId: "project-settings-customer-notifications",
        shouldShowSpinner: true
    }));
$7eaefb511da83636$var$AsyncProjectSettingsServiceDeskCustomerNotifications.displayName = "AsyncProjectSettingsServiceDeskCustomerNotifications";
var $7eaefb511da83636$export$2e2bcd8739ae039 = $7eaefb511da83636$var$AsyncProjectSettingsServiceDeskCustomerNotifications;

});
parcelRegister("fNgU6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2sRl4").then(()=>parcelRequire('klq3u'));

});



parcelRegister("lEfPj", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRouteEntry", () => $ec1b0feab3473451$export$ed034e5245184767);



var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $1ZSkY = parcelRequire("1ZSkY");

var $828bw = parcelRequire("828bw");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $aNhjU = parcelRequire("aNhjU");
const $ec1b0feab3473451$export$ed034e5245184767 = (0, $fdS54.createEntry)((0, $828bw.projectSettingsServicedeskCustomerPermissionsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aNhjU.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $1ZSkY.customerPermissionsPageDataResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aNhjU.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("ivTip", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRouteEntry", () => $99e0dfd1259386cc$export$5cea2172fd288382);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $e0LsR = parcelRequire("e0LsR");

var $74h93 = parcelRequire("74h93");

var $k2tg5 = parcelRequire("k2tg5");

var $kzYRm = parcelRequire("kzYRm");
const $99e0dfd1259386cc$export$5cea2172fd288382 = (0, $fdS54.createEntry)((0, $e0LsR.projectSettingsServicedeskDataClassificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kzYRm.default),
        skeleton: (0, $k2tg5.ProjectSettingsDetailsSkeleton),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $kzYRm.LazyDataClassificationsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e0LsR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRoute", () => $b3acfd00f1158fe9$export$ec4d4f6583272cd);
const $b3acfd00f1158fe9$export$ec4d4f6583272cd = {
    name: 'project-settings-servicedesk-data-classifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("kzYRm", function(module, exports) {
$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $a1f1c62b77e6f227$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $a1f1c62b77e6f227$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $a1f1c62b77e6f227$export$b8abcf8aa8f4df56 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("bWcHj"))), {
    moduleId: "./src/packages/spa-apps/project-settings-data-classifications/src/index.tsx"
});
const $a1f1c62b77e6f227$var$AsyncDataClassificationsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $a1f1c62b77e6f227$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
$a1f1c62b77e6f227$var$AsyncDataClassificationsSettings.displayName = "AsyncDataClassificationsSettings";
var $a1f1c62b77e6f227$export$2e2bcd8739ae039 = $a1f1c62b77e6f227$var$AsyncDataClassificationsSettings;

});


parcelRegister("3asJu", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskDetailsRouteEntry", () => $2fbb9ef89df9bde4$export$6b37ff6fd616f383);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $Urcyr = parcelRequire("Urcyr");

var $74h93 = parcelRequire("74h93");

var $k2tg5 = parcelRequire("k2tg5");

var $hrJdV = parcelRequire("hrJdV");
const $2fbb9ef89df9bde4$export$6b37ff6fd616f383 = (0, $fdS54.createEntry)((0, $Urcyr.projectSettingsServicedeskDetailsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hrJdV.default),
        skeleton: (0, $k2tg5.ProjectSettingsDetailsSkeleton),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hrJdV.LazyDetailsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("Urcyr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskDetailsRoute", () => $2f4b34dacdc4949a$export$23583c23687c31c7);
const $2f4b34dacdc4949a$export$23583c23687c31c7 = {
    name: 'project-settings-servicedesk-details',
    // /settings/details
    path: '/jira/servicedesk/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("hrJdV", function(module, exports) {
$parcel$export(module.exports, "LazyDetailsSettings", () => $091c05202d8e304f$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $091c05202d8e304f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $091c05202d8e304f$export$6f16b5efddd5c646 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("al4uU"))), {
    moduleId: "./src/packages/spa-apps/project-settings-details/src/index.tsx"
});
const $091c05202d8e304f$var$AsyncDetailsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $091c05202d8e304f$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });
$091c05202d8e304f$var$AsyncDetailsSettings.displayName = "AsyncDetailsSettings";
var $091c05202d8e304f$export$2e2bcd8739ae039 = $091c05202d8e304f$var$AsyncDetailsSettings;

});
parcelRegister("al4uU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ldI7P")
]).then(()=>parcelRequire('2zO6z'));

});



parcelRegister("gvVUq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskEmailRouteEntry", () => $efabfc5c51d54d06$export$676e8af036d3e9c1);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $oAUzG = parcelRequire("oAUzG");

var $74h93 = parcelRequire("74h93");

var $hg7nu = parcelRequire("hg7nu");
const $efabfc5c51d54d06$export$676e8af036d3e9c1 = (0, $fdS54.createEntry)((0, $oAUzG.projectSettingsServicedeskEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.settings.email-channels',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hg7nu.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hg7nu.LazyProjectSettingsServiceDeskEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("dRyuZ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRouteEntry", () => $e006b779d2966d03$export$ca80e1d474f774d4);



var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $lEPfS = parcelRequire("lEPfS");

var $82QrG = parcelRequire("82QrG");

var $74h93 = parcelRequire("74h93");

var $7AE7r = parcelRequire("7AE7r");
const $e006b779d2966d03$export$ca80e1d474f774d4 = (0, $fdS54.createEntry)((0, $82QrG.projectSettingsServicedeskExternalLinksRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7AE7r.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $lEPfS.featuresResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7AE7r.LazyProjectSettingsServiceDeskExternalLinks)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        perfMetricKey: 'jsm-external-resources'
    }));

});
parcelRegister("7AE7r", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskExternalLinks", () => $f09e089399a8e72c$export$28482a53859ec466);
$parcel$export(module.exports, "default", () => $f09e089399a8e72c$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f09e089399a8e72c$export$28482a53859ec466 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("juvyX"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-external-links/src/ExportedDefault.tsx"
});
const $f09e089399a8e72c$var$AsyncProjectSettingsServiceDeskExternalLinks = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f09e089399a8e72c$export$28482a53859ec466,
        pageId: "project-settings-external-links",
        shouldShowSpinner: true
    });
$f09e089399a8e72c$var$AsyncProjectSettingsServiceDeskExternalLinks.displayName = "AsyncProjectSettingsServiceDeskExternalLinks";
var $f09e089399a8e72c$export$2e2bcd8739ae039 = $f09e089399a8e72c$var$AsyncProjectSettingsServiceDeskExternalLinks;

});
parcelRegister("juvyX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("62Hb2")
]).then(()=>parcelRequire('6SrwI'));

});



parcelRegister("l4LiH", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRouteEntry", () => $f470c5db9cb0686b$export$5c0731470c0dc065);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $2FyRg = parcelRequire("2FyRg");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $fM3pd = parcelRequire("fM3pd");

var $1hzuX = parcelRequire("1hzuX");
const $f470c5db9cb0686b$export$5c0731470c0dc065 = (0, $fdS54.createEntry)((0, $2FyRg.projectSettingsServicedeskFeedbackRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1hzuX.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $1hzuX.LazyProjectSettingsServiceDeskFeedbackSettings),
            (0, $fM3pd.LazyCsatSettingsPage)
        ],
        perfMetricKey: 'jsm-feedback-settings',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).CSAT_CONFIG,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CSAT_CONFIG),
                teamName: 'jsm-request-intake'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fM3pd", function(module, exports) {
$parcel$export(module.exports, "LoadingComponent", () => $03af326026f30615$export$7db30d367db7d20a);
$parcel$export(module.exports, "LazyCsatSettingsPage", () => $03af326026f30615$export$32eb62914bae0e84);
/* LazyCsatSettingsPage.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $abhF2 = parcelRequire("abhF2");

var $l8G1z = parcelRequire("l8G1z");
const $03af326026f30615$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($03af326026f30615$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: "large"
    }));
$03af326026f30615$export$7db30d367db7d20a.displayName = "LoadingComponent";

const $03af326026f30615$export$32eb62914bae0e84 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("ftf96")), {
    moduleId: "./src/packages/servicedesk/csat/src/CsatSettingApp.tsx"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $03af326026f30615$var$SpinnerContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ftf96", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lr73w").then(()=>parcelRequire('3UiNe'));

});


parcelRegister("1hzuX", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskFeedbackSettings", () => $3844c5d962fbdc08$export$ff54bec6c7cb7d47);
$parcel$export(module.exports, "default", () => $3844c5d962fbdc08$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");
const $3844c5d962fbdc08$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $3844c5d962fbdc08$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $3844c5d962fbdc08$export$ff54bec6c7cb7d47 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7ORBH")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-feedback-settings/src/ServiceDeskFeedbackSettingsPage.tsx"
});
const $3844c5d962fbdc08$var$AsyncProjectSettingsServiceDeskFeedbackSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3844c5d962fbdc08$export$ff54bec6c7cb7d47,
        pageId: "project-settings-feedback-settings",
        shouldShowSpinner: true
    });
$3844c5d962fbdc08$var$AsyncProjectSettingsServiceDeskFeedbackSettings.displayName = "AsyncProjectSettingsServiceDeskFeedbackSettings";
var $3844c5d962fbdc08$export$2e2bcd8739ae039 = $3844c5d962fbdc08$var$AsyncProjectSettingsServiceDeskFeedbackSettings;

});
parcelRegister("7ORBH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Zxmi").then(()=>parcelRequire('kBwTA'));

});



parcelRegister("48F6g", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFieldsRouteEntry", () => $23d536e4a89667bd$export$8a5eabbb292c5b39);
/* eslint-disable import/order */ 


var $3Slbk = parcelRequire("3Slbk");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $cjgSr = parcelRequire("cjgSr");

var $74h93 = parcelRequire("74h93");

var $5EQnf = parcelRequire("5EQnf");
const $23d536e4a89667bd$export$8a5eabbb292c5b39 = (0, $fdS54.createEntry)((0, $cjgSr.projectSettingsServicedeskFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings.fields.jsm-tmp',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5EQnf.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $3Slbk.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5EQnf.LazyFieldsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5EQnf", function(module, exports) {
$parcel$export(module.exports, "LazyFieldsSettings", () => $7f0e5bc9c871aca3$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $7f0e5bc9c871aca3$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7f0e5bc9c871aca3$export$e309780f520d125a = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("9hH3y"))), {
    moduleId: "./src/packages/spa-apps/project-settings-fields/src/ExportedDefault.tsx"
});
const $7f0e5bc9c871aca3$var$AsyncFieldsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7f0e5bc9c871aca3$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
$7f0e5bc9c871aca3$var$AsyncFieldsSettings.displayName = "AsyncFieldsSettings";
var $7f0e5bc9c871aca3$export$2e2bcd8739ae039 = $7f0e5bc9c871aca3$var$AsyncFieldsSettings;

});


parcelRegister("9dVUe", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRouteEntry", () => $2512d1ae87058ed8$export$58e3b68d22b7a42b);



var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $jOUdB = parcelRequire("jOUdB");

var $74h93 = parcelRequire("74h93");

var $hFYSn = parcelRequire("hFYSn");

var $edf7u = parcelRequire("edf7u");

var $dwII1 = parcelRequire("dwII1");
const $2512d1ae87058ed8$export$58e3b68d22b7a42b = (0, $fdS54.createEntry)((0, $jOUdB.projectSettingsServicedeskForgeAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dwII1.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResourceWithCache),
            (0, $hFYSn.forgeProjectSettingsModuleResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dwII1.LazyForgeProjectSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jOUdB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $db7be75e77ef0ac8$export$10bafd1256118bb8);
const $db7be75e77ef0ac8$export$10bafd1256118bb8 = {
    name: 'project-settings-servicedesk-forge-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("dwII1", function(module, exports) {
$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $4b4ff9391e744db8$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "default", () => $4b4ff9391e744db8$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4b4ff9391e744db8$export$ef66d3f49a9953d8 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7qZ2d")), {
    moduleId: "./src/packages/spa-apps/forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx"
});
const $4b4ff9391e744db8$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4b4ff9391e744db8$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
$4b4ff9391e744db8$export$b943f48844c671a5.displayName = "ForgeProjectSettingsPage";
var $4b4ff9391e744db8$export$2e2bcd8739ae039 = $4b4ff9391e744db8$export$b943f48844c671a5;

});


parcelRegister("50cDU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRouteEntry", () => $a29f41255309f2ae$export$95a73b5db67dd70a);



var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iyqMX = parcelRequire("iyqMX");

var $gl4Xc = parcelRequire("gl4Xc");

var $8zrjl = parcelRequire("8zrjl");

var $74h93 = parcelRequire("74h93");

var $29WYp = parcelRequire("29WYp");

var $i860n = parcelRequire("i860n");
const $a29f41255309f2ae$var$getIncidentCommandCenterFeatureResources = ()=>(0, $i860n.fg)('jsm_incident_command_center') ? [
        (0, $gl4Xc.incidentCommandCenterFeatureResource)
    ] : [];
const $a29f41255309f2ae$export$95a73b5db67dd70a = (0, $fdS54.createEntry)((0, $8zrjl.projectSettingsServicedeskIncidentManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $29WYp.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $iyqMX.serviceDeskContextResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...$a29f41255309f2ae$var$getIncidentCommandCenterFeatureResources()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $29WYp.LazyProjectSettingsServiceDeskIncidentManagement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gl4Xc", function(module, exports) {
$parcel$export(module.exports, "incidentCommandCenterFeatureResource", () => $6f3df63271143d19$export$323064595d11b8db);

var $7edbf = parcelRequire("7edbf");

var $cJP0L = parcelRequire("cJP0L");
const $6f3df63271143d19$var$RESOURCE_TYPE_SERVICEDESK_INCIDENT_COMMAND_CENTER_FEATURE = 'SERVICEDESK_INCIDENT_COMMAND_CENTER_FEATURE';
const $6f3df63271143d19$var$ONE_DAY_IN_MILLIS = 86400000;

const $6f3df63271143d19$export$323064595d11b8db = (0, $7edbf.createResource)({
    type: $6f3df63271143d19$var$RESOURCE_TYPE_SERVICEDESK_INCIDENT_COMMAND_CENTER_FEATURE,
    getKey: ({ match: match, query: query })=>(0, $cJP0L.getProjectKeyFromContext)(match, query),
    getDataLoader: ()=>(parcelRequire("9IO7h")),
    maxAge: $6f3df63271143d19$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("cJP0L", function(module, exports) {
$parcel$export(module.exports, "getProjectKeyFromContext", () => $2f66c008cb6f9c56$export$a2292aed3a28f853);

var $cY22M = parcelRequire("cY22M");

var $i0CFV = parcelRequire("i0CFV");
const $2f66c008cb6f9c56$export$a2292aed3a28f853 = (match, query)=>(0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0];

});

parcelRegister("9IO7h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2IdVH").then(()=>parcelRequire('886af'));

});


parcelRegister("29WYp", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskIncidentManagement", () => $39491d3e97a84538$export$7796b6d080b8c187);
$parcel$export(module.exports, "default", () => $39491d3e97a84538$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $39491d3e97a84538$export$7796b6d080b8c187 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("8BISU"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-incident-management-settings/src/ServiceDeskIncidentManagementSettingsPage.tsx"
});
const $39491d3e97a84538$var$AsyncProjectSettingsServiceDeskIncidentManagement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $39491d3e97a84538$export$7796b6d080b8c187,
        pageId: "project-settings-incident-management",
        shouldShowSpinner: true
    });
$39491d3e97a84538$var$AsyncProjectSettingsServiceDeskIncidentManagement.displayName = "AsyncProjectSettingsServiceDeskIncidentManagement";
var $39491d3e97a84538$export$2e2bcd8739ae039 = $39491d3e97a84538$var$AsyncProjectSettingsServiceDeskIncidentManagement;

});
parcelRegister("8BISU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("3RZkD")
]).then(()=>parcelRequire('cfitb'));

});



parcelRegister("lF5CE", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRouteEntry", () => $84b29d84be84004c$export$dfcd097af0ecd961);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $gALT7 = parcelRequire("gALT7");

var $74h93 = parcelRequire("74h93");

var $6Qfer = parcelRequire("6Qfer");

var $9UWcf = parcelRequire("9UWcf");
const $84b29d84be84004c$export$dfcd097af0ecd961 = (0, $fdS54.createEntry)((0, $gALT7.projectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9UWcf.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $9UWcf.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $6Qfer.LazyInternalNotificationSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6Qfer", function(module, exports) {
$parcel$export(module.exports, "LazyInternalNotificationSettingsPage", () => $3490d860e94e604d$export$501979bd6d492c43);
/* eslint-disable jira/filename-case */ 
var $l8G1z = parcelRequire("l8G1z");

const $3490d860e94e604d$export$501979bd6d492c43 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("jfNlc")), {
    moduleId: "./src/packages/servicedesk/notification-internal/src/ExportedComponent.tsx"
});

});
parcelRegister("jfNlc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jwlWb")
]).then(()=>parcelRequire('bCatb'));

});


parcelRegister("9UWcf", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskInternalNotifications", () => $37cb5d24081c7e78$export$9c9d293dc6de29d0);
$parcel$export(module.exports, "default", () => $37cb5d24081c7e78$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $37cb5d24081c7e78$export$9c9d293dc6de29d0 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("oabDq"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-internal-notifications/src/ExportedDefault.tsx"
});
const $37cb5d24081c7e78$var$AsyncProjectSettingsServiceDeskInternalNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $37cb5d24081c7e78$export$9c9d293dc6de29d0,
        pageId: "project-settings-internal-notifications",
        shouldShowSpinner: true
    });
$37cb5d24081c7e78$var$AsyncProjectSettingsServiceDeskInternalNotifications.displayName = "AsyncProjectSettingsServiceDeskInternalNotifications";
var $37cb5d24081c7e78$export$2e2bcd8739ae039 = $37cb5d24081c7e78$var$AsyncProjectSettingsServiceDeskInternalNotifications;

});
parcelRegister("oabDq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4Tcfi").then(()=>parcelRequire('eOX86'));

});



parcelRegister("eKtdo", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRouteEntry", () => $bfc3dc63a47dedc2$export$cf4a5eaa3cb7522f);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $gHXQv = parcelRequire("gHXQv");

var $74h93 = parcelRequire("74h93");

var $9cWZk = parcelRequire("9cWZk");

var $5GRa3 = parcelRequire("5GRa3");
const $bfc3dc63a47dedc2$export$cf4a5eaa3cb7522f = (0, $fdS54.createEntry)((0, $gHXQv.projectSettingsServicedeskIssuetypesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: (0, $5GRa3.getUFOName)('project-settings-servicedesk-issuetypes'),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $9cWZk.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9cWZk.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9cWZk", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeSettings", () => $b4fb715d21126c8a$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $b4fb715d21126c8a$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $b4fb715d21126c8a$export$36dcfb52d47cb93a = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("foBE1"))), {
    moduleId: "./src/packages/spa-apps/project-settings-issue-type/src/IssueTypePage.tsx"
});
const $b4fb715d21126c8a$var$AsyncIssueTypeSettings = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $b4fb715d21126c8a$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
$b4fb715d21126c8a$var$AsyncIssueTypeSettings.displayName = "AsyncIssueTypeSettings";
var $b4fb715d21126c8a$export$2e2bcd8739ae039 = $b4fb715d21126c8a$var$AsyncIssueTypeSettings;

});

parcelRegister("5GRa3", function(module, exports) {
$parcel$export(module.exports, "getUFOName", () => $dd06cd1577afed62$export$759ec9adbd19c936);
/* eslint-disable jira/naming/disallow-filenames */ const $dd06cd1577afed62$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $dd06cd1577afed62$export$759ec9adbd19c936 = (name)=>$dd06cd1577afed62$var$ufoNamesMap[name] || name;

});


parcelRegister("5RWf0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRouteEntry", () => $161ca0d1e08b02c9$export$a6c573e3904e9dbd);



var $fyoT9 = parcelRequire("fyoT9");

var $cH5Ll = parcelRequire("cH5Ll");

var $e2Z3B = parcelRequire("e2Z3B");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $4Ua9B = parcelRequire("4Ua9B");

var $edf7u = parcelRequire("edf7u");

var $4B518 = parcelRequire("4B518");

var $6bGyp = parcelRequire("6bGyp");

var $74h93 = parcelRequire("74h93");

var $byMD7 = parcelRequire("byMD7");

var $2700E = parcelRequire("2700E");

var $8hHpc = parcelRequire("8hHpc");

var $9cWZk = parcelRequire("9cWZk");

var $1bWF4 = parcelRequire("1bWF4");
const $161ca0d1e08b02c9$var$getWorkflowBuilderProvisioningResources = ()=>[
        (0, $fyoT9.workflowBuilderProvisioningResource)
    ];
const $161ca0d1e08b02c9$export$a6c573e3904e9dbd = (0, $fdS54.createEntry)((0, $4Ua9B.projectSettingsServicedeskIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1bWF4.default),
        layout: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? (0, $byMD7.chromelessLayout) : (0, $74h93.serviceProjectLayout),
        navigation: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? undefined : {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? [
            // Delete this resource after hix-7127_wfe_layout_to_chromeless_for_service experiment is over
            // AND usages of projectContextResource have been swapped with projectWorkflowContextResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8hHpc.projectWorkflowContextResource),
            (0, $e2Z3B.workflowCapabilitiesResource),
            (0, $cH5Ll.workflowDocumentResource),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $6bGyp.rovoEntitlementResource),
            ...$161ca0d1e08b02c9$var$getWorkflowBuilderProvisioningResources()
        ] : [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            ...$161ca0d1e08b02c9$var$getWorkflowBuilderProvisioningResources(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? [
            (0, $1bWF4.LazyWorkflowNavigationSettings)
        ] : [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9cWZk.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4Ua9B", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRoute", () => $e79bd0484e85140f$export$959cd36cc49d3b76);
const $e79bd0484e85140f$export$959cd36cc49d3b76 = {
    name: 'project-settings-servicedesk-issuetypes-workflow',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("1bWF4", function(module, exports) {
$parcel$export(module.exports, "LazyWorkflowNavigationSettings", () => $9574941441f16661$export$cb608e3696682e76);
$parcel$export(module.exports, "default", () => $9574941441f16661$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9574941441f16661$export$cb608e3696682e76 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("8xDGy"))), {
    moduleId: "./src/packages/spa-apps/project-settings-workflow-navigation/src/WorkflowNavigationPage.tsx"
});
const $9574941441f16661$var$AsyncWorkflowNavigationSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9574941441f16661$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
$9574941441f16661$var$AsyncWorkflowNavigationSettings.displayName = "AsyncWorkflowNavigationSettings";
var $9574941441f16661$export$2e2bcd8739ae039 = $9574941441f16661$var$AsyncWorkflowNavigationSettings;

});


parcelRegister("cqxXO", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRouteEntry", () => $aea44dcc0ec28f0e$export$40ca23d1e05da300);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $lEPfS = parcelRequire("lEPfS");

var $e8X5B = parcelRequire("e8X5B");

var $74h93 = parcelRequire("74h93");

var $de277 = parcelRequire("de277");
const $aea44dcc0ec28f0e$export$40ca23d1e05da300 = (0, $fdS54.createEntry)((0, $e8X5B.projectSettingsServicedeskItsmFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-features-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $de277.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $lEPfS.featuresResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $de277.LazyProjectSettingsServiceDeskItsmFeatures)
        ],
        perfMetricKey: 'jsm-features-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e8X5B", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRoute", () => $e05048a4c33ecb3d$export$e60ffa2990540464);
const $e05048a4c33ecb3d$export$e60ffa2990540464 = {
    name: 'project-settings-servicedesk-itsm-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/itsm-features',
    exact: true
};

});

parcelRegister("de277", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskItsmFeatures", () => $1417aa5645aa20ba$export$562be1021beb9882);
$parcel$export(module.exports, "default", () => $1417aa5645aa20ba$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1417aa5645aa20ba$export$562be1021beb9882 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dSXQO"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-itsm-features/src/ProjectSettingsServiceDeskItsmFeatures.tsx"
});
const $1417aa5645aa20ba$var$AsyncProjectSettingsServiceDeskItsmFeatures = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1417aa5645aa20ba$export$562be1021beb9882,
        pageId: "project-settings-itsm-features",
        shouldShowSpinner: true
    });
$1417aa5645aa20ba$var$AsyncProjectSettingsServiceDeskItsmFeatures.displayName = "AsyncProjectSettingsServiceDeskItsmFeatures";
var $1417aa5645aa20ba$export$2e2bcd8739ae039 = $1417aa5645aa20ba$var$AsyncProjectSettingsServiceDeskItsmFeatures;

});
parcelRegister("dSXQO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dmVnr").then(()=>parcelRequire('3Asn9'));

});



parcelRegister("kgEJd", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry", () => $7dbc55c8f516d622$export$49692fb0973d60ca);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $j0qHc = parcelRequire("j0qHc");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $7losm = parcelRequire("7losm");

var $74h93 = parcelRequire("74h93");

var $gGrwR = parcelRequire("gGrwR");
const $7dbc55c8f516d622$export$49692fb0973d60ca = (0, $fdS54.createEntry)((0, $7losm.projectSettingsServicedeskItsmTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gGrwR.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $j0qHc.servicedeskPracticesResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gGrwR.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7losm", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRoute", () => $2a4bf556e9f8be2b$export$1af0541fcb95547b);
const $2a4bf556e9f8be2b$export$1af0541fcb95547b = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?'
};

});

parcelRegister("gGrwR", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypeFields", () => $1b3fc54de3542687$export$471040ce01e559fc);
$parcel$export(module.exports, "default", () => $1b3fc54de3542687$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $2LCqr = parcelRequire("2LCqr");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1b3fc54de3542687$export$471040ce01e559fc = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9VdI2")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-ticket-type-fields/src/ProjectSettingsServiceDeskTicketTypeFields.tsx"
});
const $1b3fc54de3542687$var$AsyncProjectSettingsServiceDeskTicketTypeFields = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2LCqr.HelpCenterSettingsRedirect), {
        page: "ticket-type-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1b3fc54de3542687$export$471040ce01e559fc,
        pageId: "project-settings-ticket-type-fields",
        shouldShowSpinner: true
    }));
$1b3fc54de3542687$var$AsyncProjectSettingsServiceDeskTicketTypeFields.displayName = "AsyncProjectSettingsServiceDeskTicketTypeFields";
var $1b3fc54de3542687$export$2e2bcd8739ae039 = $1b3fc54de3542687$var$AsyncProjectSettingsServiceDeskTicketTypeFields;

});
parcelRegister("9VdI2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bGt3s")
]).then(()=>parcelRequire('5gAdB'));

});



parcelRegister("7e242", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRouteEntry", () => $61d581f415d386e4$export$9f40815b933b51ba);



var $02DIZ = parcelRequire("02DIZ");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $8gns3 = parcelRequire("8gns3");

var $lEPfS = parcelRequire("lEPfS");

var $j0qHc = parcelRequire("j0qHc");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $jEYuY = parcelRequire("jEYuY");

var $e4hT2 = parcelRequire("e4hT2");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $dQlMZ = parcelRequire("dQlMZ");
const $61d581f415d386e4$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $02DIZ.TicketTypesConfigEntrypoint)
});
const $61d581f415d386e4$export$9f40815b933b51ba = (0, $fdS54.createEntry)((0, $e4hT2.projectSettingsServicedeskItsmTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dQlMZ.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            return $61d581f415d386e4$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $j0qHc.servicedeskPracticesResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $8gns3.servicedeskPortalGroupsResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $lEPfS.featuresResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dQlMZ.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("02DIZ", function(module, exports) {
$parcel$export(module.exports, "TicketTypesConfigEntrypoint", () => $90b11c805a4d1c7c$export$85bc484c6bab022d);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $8BHn4 = parcelRequire("8BHn4");

const $90b11c805a4d1c7c$export$85bc484c6bab022d = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5IrzS")), {
        moduleId: "9ebe8a31",
        moduleName: "ServiceDeskRequestTypesConfigPageNew",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const cloudId = tenantContext.cloudId;
        const projectKey = context.match.params.projectKey;
        if (!projectKey) throw new Error('Project key is required');
        return {
            entryPoints: {
                requestTypeTableEntrypoint: {
                    entryPoint: (0, $8BHn4.requestTypeTableEntrypoint),
                    entryPointParams: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("8BHn4", function(module, exports) {
$parcel$export(module.exports, "requestTypeTableEntrypoint", () => $c1fdf5066b949150$export$ecbf0c880decd2ac);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $88cnk = parcelRequire("88cnk");

const $c1fdf5066b949150$export$ecbf0c880decd2ac = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2OMA3")), {
        moduleId: "6d4c2b52",
        moduleName: "RequestTypesTable",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>{
        return {
            queries: {
                tableSettings: {
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    },
                    parameters: $88cnk.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("88cnk", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff7cfe1b7dfab25c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7444bf78694ffa88e3b450b7571d85c>>
 * @relayHash 97c579efae3d53fdf04fb24bd9e41dec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a26df09afb87015beb814bd83b211612ea3e5234a6864a889c4060cda4a5e33c
const $ff7cfe1b7dfab25c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a26df09afb87015beb814bd83b211612ea3e5234a6864a889c4060cda4a5e33c",
        "metadata": {},
        "name": "RequestTypesTableQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ff7cfe1b7dfab25c$export$2e2bcd8739ae039 = $ff7cfe1b7dfab25c$var$node;

});

parcelRegister("2OMA3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Efn7").then(()=>parcelRequire('il3Sh'));

});


parcelRegister("5IrzS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("2bPjS")
]).then(()=>parcelRequire('8Vrhi'));

});


parcelRegister("8gns3", function(module, exports) {
$parcel$export(module.exports, "servicedeskPortalGroupsResource", () => $521b498849a9180f$export$c7fb28234b909b2f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

const $521b498849a9180f$var$ONE_DAY_IN_MILLIS = 86400000;

const $521b498849a9180f$export$c7fb28234b909b2f = (0, $7edbf.createResource)({
    type: (0, $a2945a644bc10e20$export$4160f2c498fcd32e),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("lpbfG")),
    maxAge: $521b498849a9180f$var$ONE_DAY_IN_MILLIS
});

});
/* eslint-disable jira/filename-case */ const $a2945a644bc10e20$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';

parcelRegister("lpbfG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dG7vL").then(()=>parcelRequire('kbIql'));

});


parcelRegister("dQlMZ", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypesConfig", () => $e05dbeb3ae323f06$export$c26e63f8b7d3b52c);
$parcel$export(module.exports, "default", () => $e05dbeb3ae323f06$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $2LCqr = parcelRequire("2LCqr");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $e05dbeb3ae323f06$export$c26e63f8b7d3b52c = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("l4b6W")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-ticket-types-config/src/ProjectSettingsServiceDeskTicketTypesConfig.tsx"
});
const $e05dbeb3ae323f06$var$AsyncProjectSettingsServiceDeskTicketTypesConfig = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2LCqr.HelpCenterSettingsRedirect), {
        page: "ticket-types-config"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e05dbeb3ae323f06$export$c26e63f8b7d3b52c,
        pageId: "project-settings-ticket-types-config",
        shouldShowSpinner: true
    }));
$e05dbeb3ae323f06$var$AsyncProjectSettingsServiceDeskTicketTypesConfig.displayName = "AsyncProjectSettingsServiceDeskTicketTypesConfig";
var $e05dbeb3ae323f06$export$2e2bcd8739ae039 = $e05dbeb3ae323f06$var$AsyncProjectSettingsServiceDeskTicketTypesConfig;

});
parcelRegister("l4b6W", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("94iUp")
]).then(()=>parcelRequire('lrhds'));

});



parcelRegister("cMh2i", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRouteEntry", () => $3f871919820f585e$export$5cbb0a0098e65c64);

var $74oEx = parcelRequire("74oEx");



var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $e8S9j = parcelRequire("e8S9j");

var $74h93 = parcelRequire("74h93");

var $9D9hZ = parcelRequire("9D9hZ");
const $3f871919820f585e$export$5cbb0a0098e65c64 = (0, $fdS54.createEntry)((0, $e8S9j.projectSettingsServicedeskJourneyConfigurationEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('journey-config'),
                teamName: 'JSM Grape Soju'
            }
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration-edit',
        entryPoint: ()=>(0, $9D9hZ.journeyConfigEditPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e8S9j", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRoute", () => $86d5b3419e175008$export$f80f582ef54900c6);
const $86d5b3419e175008$export$f80f582ef54900c6 = {
    name: 'project-settings-servicedesk-journey-configuration-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId/edit',
    exact: true
};

});

parcelRegister("9D9hZ", function(module, exports) {
$parcel$export(module.exports, "journeyConfigEditPageEntryPoint", () => $214411f260f14ea7$export$7388ef888b9170a7);
/* eslint-disable jira/naming/disallow-filenames */ 
var $fZrPU = parcelRequire("fZrPU");

var $dTa0V = parcelRequire("dTa0V");
const $214411f260f14ea7$export$7388ef888b9170a7 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fZrPU.journeyConfigEntryPoint)
});

});
parcelRegister("fZrPU", function(module, exports) {
$parcel$export(module.exports, "journeyConfigEntryPoint", () => $fae981b6d00cd579$export$26f82de7820f0c3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $i860n = parcelRequire("i860n");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $68tCR = parcelRequire("68tCR");

const $fae981b6d00cd579$export$26f82de7820f0c3 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9ua0e")), {
        moduleId: "c4735ccb",
        moduleName: "JourneyConfigurationPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        return {
            queries: {
                jiraJourneyConfiguration: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $68tCR.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        cloudIdAsString: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        journeyId: context.match.params.journeyId ?? '',
                        isEditing: context.match.path?.includes('journeys/:journeyId/edit'),
                        includeRovoServiceAgent: (0, $i860n.fg)('enable-jsm-rovo-service-hr-agent')
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("68tCR", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb772c15879fdf61$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09442617d3cc12f4ca68025475065038>>
 * @relayHash a28970faa54e03ecacdb9a53da1ca2bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4531640aea295b8d71f581d755b75ac7ba9d3a4ff72d3644ed4dfaab6cb58ffa

var $eMgaM = parcelRequire("eMgaM");
const $bb772c15879fdf61$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4531640aea295b8d71f581d755b75ac7ba9d3a4ff72d3644ed4dfaab6cb58ffa",
        "metadata": {},
        "name": "JourneyConfigurationPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmrovoservicehragentrelayprovider": (0, $eMgaM.default)
        }
    }
};
var $bb772c15879fdf61$export$2e2bcd8739ae039 = $bb772c15879fdf61$var$node;

});

parcelRegister("9ua0e", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("68WJx").then(()=>parcelRequire('49awD'));

});




parcelRegister("kEnic", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRouteEntry", () => $c0b52862fe1e63c7$export$7475316a4561dd76);

var $74oEx = parcelRequire("74oEx");



var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $TaNUe = parcelRequire("TaNUe");

var $74h93 = parcelRequire("74h93");

var $allda = parcelRequire("allda");
const $c0b52862fe1e63c7$export$7475316a4561dd76 = (0, $fdS54.createEntry)((0, $TaNUe.projectSettingsServicedeskJourneyConfigurationRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('journey-config'),
                teamName: 'JSM Grape Soju'
            }
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration',
        entryPoint: ()=>(0, $allda.journeyConfigPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("TaNUe", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRoute", () => $0f48ee78c8f71486$export$9013e78604bfadb0);
const $0f48ee78c8f71486$export$9013e78604bfadb0 = {
    name: 'project-settings-servicedesk-journey-configuration',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
    exact: true
};

});

parcelRegister("allda", function(module, exports) {
$parcel$export(module.exports, "journeyConfigPageEntryPoint", () => $c892462fe8970993$export$35537410b0bf07ea);
/* eslint-disable jira/naming/disallow-filenames */ 
var $fZrPU = parcelRequire("fZrPU");

var $dTa0V = parcelRequire("dTa0V");
const $c892462fe8970993$export$35537410b0bf07ea = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fZrPU.journeyConfigEntryPoint)
});

});


parcelRegister("lJx7q", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneysRouteEntry", () => $5b1fd5d93260fe2e$export$6c014a8c741bf222);

var $74oEx = parcelRequire("74oEx");



var $lbxXL = parcelRequire("lbxXL");

var $6bGyp = parcelRequire("6bGyp");

var $8HUuJ = parcelRequire("8HUuJ");

var $fdS54 = parcelRequire("fdS54");

var $5mWhG = parcelRequire("5mWhG");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $2OV4Q = parcelRequire("2OV4Q");
const $5b1fd5d93260fe2e$export$6c014a8c741bf222 = (0, $fdS54.createEntry)((0, $5mWhG.projectSettingsServicedeskJourneysRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journeys-list',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('journeys-list'),
                teamName: 'JSM Grape Soju'
            }
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('enable-jsm-rovo-service-hr-agent'), (0, $6bGyp.rovoEntitlementResource))
        ],
        perfMetricKey: 'jsm-journeys',
        entryPoint: ()=>(0, $2OV4Q.journeysPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5mWhG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneysRoute", () => $448509785d02e989$export$627d71a1dd7a9593);
const $448509785d02e989$export$627d71a1dd7a9593 = {
    name: 'project-settings-servicedesk-journeys',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
    exact: true
};

});

parcelRegister("2OV4Q", function(module, exports) {
$parcel$export(module.exports, "journeysPageEntryPoint", () => $5bbef15387bb89c2$export$3b90f0eb27bdd52f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $jxatm = parcelRequire("jxatm");

var $dTa0V = parcelRequire("dTa0V");
const $5bbef15387bb89c2$export$3b90f0eb27bdd52f = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $jxatm.journeysEntryPoint)
});

});
parcelRegister("jxatm", function(module, exports) {
$parcel$export(module.exports, "journeysEntryPoint", () => $6f0d14ef1db56578$export$4ded7f93dbe6eb63);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $hSjSu = parcelRequire("hSjSu");

const $6f0d14ef1db56578$export$4ded7f93dbe6eb63 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("fftG0")), {
        moduleId: "a86c2510",
        moduleName: "JourneysPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                journeysPageQueryRef: {
                    parameters: $hSjSu.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        cloudIdAsString: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("hSjSu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2b470eef901ef46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<71502aab73eaf8423970b4f4ee0f8576>>
 * @relayHash 79edc744ad42d3eeae80ddc01dacdfa0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bbfcc60618a31232af595ea3794d89c91b723ccd5a259deb04d4063ccb0b95eb

var $hcWVY = parcelRequire("hcWVY");
const $b2b470eef901ef46$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bbfcc60618a31232af595ea3794d89c91b723ccd5a259deb04d4063ccb0b95eb",
        "metadata": {},
        "name": "JourneysPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjourneybuilderthreetabsettingsrelayprovider": (0, $hcWVY.default)
        }
    }
};
var $b2b470eef901ef46$export$2e2bcd8739ae039 = $b2b470eef901ef46$var$node;

});
parcelRegister("hcWVY", function(module, exports) {
$parcel$export(module.exports, "default", () => $047a3b975f751961$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $047a3b975f751961$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('journey_builder_three_tab_settings');
    }
};

});


parcelRegister("fftG0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("10zCd").then(()=>parcelRequire('k8Fvc'));

});




parcelRegister("2d9Eg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskKbRouteEntry", () => $737da02cc409f3aa$export$d43e914d37d059b8);

var $fLcUe = parcelRequire("fLcUe");

var $fNZVZ = parcelRequire("fNZVZ");

var $b6sxH = parcelRequire("b6sxH");



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $c5IPX = parcelRequire("c5IPX");

var $74h93 = parcelRequire("74h93");

var $5DXGo = parcelRequire("5DXGo");

var $l5PlS = parcelRequire("l5PlS");
const $737da02cc409f3aa$export$d43e914d37d059b8 = (0, $fdS54.createEntry)((0, $c5IPX.projectSettingsServicedeskKbRoute), ()=>({
        group: 'project-settings-servicedesk',
        perfMetricKey: 'service-management.kb-settings',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l5PlS.ServiceDeskKnowledgeBaseV2),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $l5PlS.LazyProjectSettingsServiceDeskKnowledgeBaseV2)
        ],
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $5DXGo.getKBExperimentResources)(),
            (0, $b6sxH.servicedeskKnowledgeBaseThirdpartyConnectorsResource),
            (0, $fLcUe.servicedeskKnowledgeBaseServerLinkStatusResource),
            (0, $fNZVZ.servicedeskKnowledgeBaseLinkedSourcesResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("l5PlS", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskKnowledgeBaseV2", () => $21ac7981c4cbc3b4$export$7c7186fdd8c56428);
$parcel$export(module.exports, "ServiceDeskKnowledgeBaseV2", () => $21ac7981c4cbc3b4$export$6d92735e249274bb);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $2LCqr = parcelRequire("2LCqr");

var $kWzqm = parcelRequire("kWzqm");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");
const $21ac7981c4cbc3b4$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $21ac7981c4cbc3b4$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $21ac7981c4cbc3b4$export$583a442626bd3345 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("g5XnQ")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-knowledge-base/src/ExportedDefault.tsx"
});

const $21ac7981c4cbc3b4$export$7c7186fdd8c56428 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("3rNG8"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-knowledge-settings/src/ServicedeskKnowledgeSettings.tsx"
});
const $21ac7981c4cbc3b4$export$6d92735e249274bb = ()=>(0, $i860n.fg)('jsm_kb_agent_3p_connect_banner') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2LCqr.HelpCenterSettingsRedirect), {
        page: "kb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kWzqm.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $21ac7981c4cbc3b4$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2LCqr.HelpCenterSettingsRedirect), {
        page: "kb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $21ac7981c4cbc3b4$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    }));
$21ac7981c4cbc3b4$export$6d92735e249274bb.displayName = "ServiceDeskKnowledgeBaseV2";
const $21ac7981c4cbc3b4$var$AsyncProjectSettingsServiceDeskKnowledgeBaseV2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $21ac7981c4cbc3b4$export$583a442626bd3345,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });
$21ac7981c4cbc3b4$var$AsyncProjectSettingsServiceDeskKnowledgeBaseV2.displayName = "AsyncProjectSettingsServiceDeskKnowledgeBaseV2";
var $21ac7981c4cbc3b4$export$2e2bcd8739ae039 = $21ac7981c4cbc3b4$var$AsyncProjectSettingsServiceDeskKnowledgeBaseV2;

});
parcelRegister("kWzqm", function(module, exports) {
$parcel$export(module.exports, "PostOfficeProvider", () => $10a53f43e33d19d1$export$fb465b6e855c1e85);
$parcel$export(module.exports, "PostOfficeRouterListener", () => $10a53f43e33d19d1$export$9f8d3084fd3d5fc0);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6zTYs = parcelRequire("6zTYs");

var $cCE2Z = parcelRequire("cCE2Z");

var $i860n = parcelRequire("i860n");

var $k11SN = parcelRequire("k11SN");

var $XssJM = parcelRequire("XssJM");

var $6Kdw4 = parcelRequire("6Kdw4");

var $h3LJR = parcelRequire("h3LJR");

var $ccEzE = parcelRequire("ccEzE");

var $kt86l = parcelRequire("kt86l");

var $k5P9q = parcelRequire("k5P9q");

var $bs9jJ = parcelRequire("bs9jJ");

var $gQJGQ = parcelRequire("gQJGQ");

var $801ed = parcelRequire("801ed");

var $fz2Dv = parcelRequire("fz2Dv");

var $bc9Gj = parcelRequire("bc9Gj");

var $fNgVF = parcelRequire("fNgVF");

var $ln1b1 = parcelRequire("ln1b1");

var $ltdjJ = parcelRequire("ltdjJ");

var $aYGh8 = parcelRequire("aYGh8");

var $4iwgB = parcelRequire("4iwgB");

var $5OpEj = parcelRequire("5OpEj");
/**
 * Optional provider that wraps subscription providers only if feature gate is enabled.
 * Defined at module level to avoid "component during render" (subtree remount).
 */ const $10a53f43e33d19d1$var$OptionalPostOfficeSubscriptionsProvider = ({ children: children })=>{
    // https://switcheroo.atlassian.com/ui/gates/8299833f-7cf4-453b-bd5b-16f3bcf81ddb/key/post-office_graphql_subscriptions_enabled
    const subscriptionAdapter = (0, $euxye.useMemo)(()=>(0, $i860n.fg)('post-office_graphql_subscriptions_enabled') ? (0, $ltdjJ.createUseSubscribeAdapter)() : null, []);
    if (subscriptionAdapter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ln1b1.StableSubscriptionAdapterProvider), {
        subscriptionAdapter: subscriptionAdapter
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$10a53f43e33d19d1$var$OptionalPostOfficeSubscriptionsProvider.displayName = "OptionalPostOfficeSubscriptionsProvider";
const $10a53f43e33d19d1$var$JiraPostOfficeProvider = ({ children: children })=>{
    const { data: data } = (0, $XssJM.useProject)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const locale = (0, $gQJGQ.useLocale)();
    const environment = (0, $k5P9q.useEnvironment)();
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const editions = (0, $ccEzE.useAppEditions)();
    const subproduct = (0, $aYGh8.useSubproduct)(data?.type);
    const edition = (0, $aYGh8.subproductToEdition)(subproduct, editions);
    const additionalContext = (0, $euxye.useContext)((0, $4iwgB.CrossFlowPostOfficeContext));
    const context = (0, $euxye.useMemo)(()=>{
        return {
            current: {
                ...(0, $aYGh8.tenantToPostOfficeContext)({
                    activationId: activationId,
                    cloudId: cloudId,
                    isAdmin: isAdmin,
                    isSiteAdmin: isSiteAdmin,
                    locale: locale
                }),
                orgId: orgId,
                productEdition: edition || undefined,
                subproduct: subproduct,
                ...(0, $i860n.fg)('jira_xflow_quick_actions') ? additionalContext : {},
                ...(0, $i860n.fg)('jira-onboarding-hub-gate') ? (0, $5OpEj.getOnboardingParams)() : {}
            }
        };
    }, [
        cloudId,
        orgId,
        activationId,
        subproduct,
        isSiteAdmin,
        isAdmin,
        locale,
        edition,
        additionalContext
    ]);
    const env = (0, $euxye.useMemo)(()=>({
            env: (0, $aYGh8.transformJiraEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    const analyticsClient = (0, $euxye.useMemo)(()=>(0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance()), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $801ed.PostOfficeProvider), {
        context: context,
        environment: env,
        analyticsClientInstance: analyticsClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($10a53f43e33d19d1$var$OptionalPostOfficeSubscriptionsProvider, null, children));
};
$10a53f43e33d19d1$var$JiraPostOfficeProvider.displayName = "JiraPostOfficeProvider";
const $10a53f43e33d19d1$export$fb465b6e855c1e85 = ({ children: children })=>{
    // Using the Feature Gate used for the placement app-switcher-discovery-section because PostOfficeProvider is always needed when the app-switcher-discovery-section is enabled
    const isPostOfficeEnabled = !(0, $k11SN.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "postOfficeJiraProvider",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($10a53f43e33d19d1$var$JiraPostOfficeProvider, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$10a53f43e33d19d1$export$fb465b6e855c1e85.displayName = "PostOfficeProvider";
const $10a53f43e33d19d1$var$ReactResourceRouterListener = ({ children: children })=>{
    const [route] = (0, $bc9Gj.useRouter)();
    (0, $fz2Dv.usePostOfficeRouteUpdate)([
        route.basePath,
        route.location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$10a53f43e33d19d1$var$ReactResourceRouterListener.displayName = "ReactResourceRouterListener";
const $10a53f43e33d19d1$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    const isPostOfficeEnabled = !(0, $k11SN.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled && (0, $i860n.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($10a53f43e33d19d1$var$ReactResourceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$10a53f43e33d19d1$export$9f8d3084fd3d5fc0.displayName = "PostOfficeRouterListener";

});
parcelRegister("bs9jJ", function(module, exports) {
$parcel$export(module.exports, "useIsSiteAdmin", () => $6e0d269722a7ee5d$export$f9f8a5cdb0c565ef);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $6e0d269722a7ee5d$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("gQJGQ", function(module, exports) {
$parcel$export(module.exports, "useLocale", () => $011843fbbd811b4c$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $011843fbbd811b4c$export$31652d9c30d7d3f3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $978hs = parcelRequire("978hs");

var $eijVy = parcelRequire("eijVy");
const $011843fbbd811b4c$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $978hs.defaultLocale);
};
const $011843fbbd811b4c$export$31652d9c30d7d3f3 = ()=>{
    const locale = $011843fbbd811b4c$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $euxye.useMemo)(()=>(0, $978hs.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("801ed", function(module, exports) {
$parcel$export(module.exports, "PostOfficeProvider", () => $0c36a2fe4fc88393$export$fb465b6e855c1e85);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $f4ymX = parcelRequire("f4ymX");

var $f6SzU = parcelRequire("f6SzU");

var $egspI = parcelRequire("egspI");

var $j142y = parcelRequire("j142y");

var $fgdQf = parcelRequire("fgdQf");

var $gpTCJ = parcelRequire("gpTCJ");

var $fz2Dv = parcelRequire("fz2Dv");

var $bF40s = parcelRequire("bF40s");

var $2pabT = parcelRequire("2pabT");

var $khHng = parcelRequire("khHng");

var $clg9t = parcelRequire("clg9t");

var $lHZq9 = parcelRequire("lHZq9");

var $7unaJ = parcelRequire("7unaJ");

var $8d15r = parcelRequire("8d15r");
const $0c36a2fe4fc88393$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isFedRampCompliantUrlsEnabled = (0, $egspI.fg)('post-office-rml-fedramp-compliant-urls');
    const environmentValues = (0, $euxye.useMemo)(()=>(0, $fgdQf.buildDefaultEnvironmentValues)(isFedRampCompliantUrlsEnabled), [
        isFedRampCompliantUrlsEnabled
    ]);
    const stableEnvironment = (0, $khHng.useStableObject)((0, $7unaJ.generateEnvironmentConfigWithOverrides)(environmentValues, envWithOverrides));
    const stableContext = (0, $khHng.useStableObject)($0c36a2fe4fc88393$var$composeConfig((0, $j142y.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $euxye.useMemo)(()=>(0, $lHZq9.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($0c36a2fe4fc88393$var$MaybePostOfficeCacheProvider, {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fgdQf.PostOfficeEnvironmentProvider), {
            value: stableEnvironment,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j142y.InternalPostOfficeContextProvider), {
                value: stableContext,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bF40s.PostOfficeScreenContextProvider), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lHZq9.MessagePlacementProvider), {
                        value: memoizedMessagePlacementValues,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fz2Dv.RouteListenerProvider), {
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2pabT.TriggerContextProvider), {
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)($0c36a2fe4fc88393$var$MaybeAnalyticsListener, {
                                    analyticsClientInstance: analyticsClientInstance,
                                    children: children
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
$0c36a2fe4fc88393$export$fb465b6e855c1e85.displayName = "PostOfficeProvider";
const $0c36a2fe4fc88393$var$swrConfig = {
    provider: (0, $8d15r.localStorageCacheProvider),
    use: [
        (0, $8d15r.postOfficeCacheMiddleware)
    ]
};
const $0c36a2fe4fc88393$var$MaybePostOfficeCacheProvider = ({ children: children })=>{
    if ((0, $egspI.fg)('post-office-use-placement-with-client')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f4ymX.SWRConfig), {
        value: $0c36a2fe4fc88393$var$swrConfig,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$0c36a2fe4fc88393$var$MaybePostOfficeCacheProvider.displayName = "MaybePostOfficeCacheProvider";
const $0c36a2fe4fc88393$var$MaybeAnalyticsListener = ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isEPExposuresListenerEnabled = (0, $egspI.fg)('post-office_ep_exposures_enabled');
    const isAnalyticsListenerEnabled = (0, $egspI.fg)('post-office-analytics-listener-enabled');
    let content = children;
    if (isEPExposuresListenerEnabled) content = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $clg9t.EPExposuresListener), {
        analyticsClientInstance: analyticsClientInstance,
        children: content
    });
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $gpTCJ.postOfficeGasv3ListenerStore);
        content = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6SzU.default), {
            channel: "*",
            onEvent: handleEvent,
            children: content
        });
    }
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: content
    });
};
$0c36a2fe4fc88393$var$MaybeAnalyticsListener.displayName = "MaybeAnalyticsListener";
const $0c36a2fe4fc88393$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });

});
parcelRegister("f4ymX", function(module, exports) {
$parcel$export(module.exports, "SWRConfig", () => $af91e3bc57e84c7e$export$4c7bbecdacc3ca2c);
$parcel$export(module.exports, "default", () => $af91e3bc57e84c7e$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $4PfqE = parcelRequire("4PfqE");

var $fTV3G = parcelRequire("fTV3G");parcelRequire("7AeUu");
var $fTV3G = parcelRequire("fTV3G");
var $7AeUu = parcelRequire("7AeUu");
var $8Sa3N = parcelRequire("8Sa3N");
// Shared state between server components and client components
const $af91e3bc57e84c7e$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $af91e3bc57e84c7e$var$UNDEFINED = /*#__NOINLINE__*/ $af91e3bc57e84c7e$var$noop();
const $af91e3bc57e84c7e$var$OBJECT = Object;
const $af91e3bc57e84c7e$var$isUndefined = (v)=>v === $af91e3bc57e84c7e$var$UNDEFINED;
const $af91e3bc57e84c7e$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $af91e3bc57e84c7e$var$table = new WeakMap();
const $af91e3bc57e84c7e$var$getTypeName = (value)=>$af91e3bc57e84c7e$var$OBJECT.prototype.toString.call(value);
const $af91e3bc57e84c7e$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $af91e3bc57e84c7e$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $af91e3bc57e84c7e$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $af91e3bc57e84c7e$var$getTypeName(arg);
    const isDate = $af91e3bc57e84c7e$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $af91e3bc57e84c7e$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $af91e3bc57e84c7e$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($af91e3bc57e84c7e$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $af91e3bc57e84c7e$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$af91e3bc57e84c7e$var$counter + '~';
        $af91e3bc57e84c7e$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $af91e3bc57e84c7e$var$stableHash(arg[index]) + ',';
            $af91e3bc57e84c7e$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $af91e3bc57e84c7e$var$OBJECT.keys(arg).sort();
            while(!$af91e3bc57e84c7e$var$isUndefined(index = keys.pop()))if (!$af91e3bc57e84c7e$var$isUndefined(arg[index])) result += index + ':' + $af91e3bc57e84c7e$var$stableHash(arg[index]) + ',';
            $af91e3bc57e84c7e$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $af91e3bc57e84c7e$var$serialize = (key)=>{
    if ($af91e3bc57e84c7e$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $af91e3bc57e84c7e$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $af91e3bc57e84c7e$export$dbab534a48e651ef = (key)=>$af91e3bc57e84c7e$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $af91e3bc57e84c7e$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $af91e3bc57e84c7e$var$WITH_DEDUPE = {
    dedupe: true
};
const $af91e3bc57e84c7e$var$resolvedUndef = Promise.resolve((0, $fTV3G.U));
const $af91e3bc57e84c7e$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $fTV3G.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $fTV3G.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $euxye.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $euxye.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $euxye.useRef)(key);
    const fetcherRef = (0, $euxye.useRef)(fetcher);
    const configRef = (0, $euxye.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $fTV3G.z)(cache, key);
    const stateDependencies = (0, $euxye.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $fTV3G.e)(fallbackData) ? (0, $fTV3G.e)(config.fallback) ? (0, $fTV3G.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $fTV3G.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $euxye.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $fTV3G.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $fTV3G.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $4PfqE.useSyncExternalStore)((0, $euxye.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $fTV3G.e)(cachedData) ? fallback && (0, $fTV3G.B)(fallback) ? $af91e3bc57e84c7e$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $euxye.useRef)(data);
    const returnedData = keepPreviousData ? (0, $fTV3G.e)(cachedData) ? (0, $fTV3G.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $fTV3G.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $fTV3G.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $fTV3G.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $fTV3G.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $fTV3G.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $fTV3G.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $euxye.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $fTV3G.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $fTV3G.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $fTV3G.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $fTV3G.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $fTV3G.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $fTV3G.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $fTV3G.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $8Sa3N).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $euxye.useCallback)((...args)=>{
        return (0, $fTV3G.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $fTV3G.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $fTV3G.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $fTV3G.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $fTV3G.U), $af91e3bc57e84c7e$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $8Sa3N).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $8Sa3N).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $8Sa3N).MUTATE_EVENT) return revalidate();
            else if (type == (0, $8Sa3N).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $7AeUu.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $fTV3G.e)(data) || (0, $fTV3G.r)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $fTV3G.t)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $fTV3G.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $fTV3G.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($af91e3bc57e84c7e$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $euxye.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        const hasKeyButNoData = key && (0, $fTV3G.e)(data);
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $fTV3G.I) && (0, $fTV3G.r) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $fTV3G.e)(req) && hasKeyButNoData ? boundMutate(req) : $af91e3bc57e84c7e$var$resolvedUndef;
        $af91e3bc57e84c7e$var$use(mutateReq);
        if (!(0, $fTV3G.e)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($af91e3bc57e84c7e$var$WITH_DEDUPE) : $af91e3bc57e84c7e$var$resolvedUndef;
        if (!(0, $fTV3G.e)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $af91e3bc57e84c7e$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $af91e3bc57e84c7e$export$4c7bbecdacc3ca2c = (0, $fTV3G.O).defineProperty((0, $fTV3G.g), 'defaultValue', {
    value: (0, $fTV3G.d)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $af91e3bc57e84c7e$export$2e2bcd8739ae039 = (0, $7AeUu.withArgs)($af91e3bc57e84c7e$var$useSWRHandler);

});
parcelRegister("fTV3G", function(module, exports) {
$parcel$export(module.exports, "b", () => $b93840b199a5ed95$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "U", () => $b93840b199a5ed95$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "O", () => $b93840b199a5ed95$export$c4ce752e73470fba);
$parcel$export(module.exports, "e", () => $b93840b199a5ed95$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $b93840b199a5ed95$export$407448d2b89b1813);
$parcel$export(module.exports, "m", () => $b93840b199a5ed95$export$953cecd6e717a553);
$parcel$export(module.exports, "B", () => $b93840b199a5ed95$export$ef35774e6d314e91);
$parcel$export(module.exports, "i", () => $b93840b199a5ed95$export$23f2a1d2818174ef);
$parcel$export(module.exports, "z", () => $b93840b199a5ed95$export$df995fae86a55f06);
$parcel$export(module.exports, "I", () => $b93840b199a5ed95$export$9bb611d729802a56);
$parcel$export(module.exports, "r", () => $b93840b199a5ed95$export$43caf9889c228507);
$parcel$export(module.exports, "t", () => $b93840b199a5ed95$export$625550452a3fa3ec);
$parcel$export(module.exports, "u", () => $b93840b199a5ed95$export$3b14a55fb2447963);
$parcel$export(module.exports, "s", () => $b93840b199a5ed95$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "o", () => $b93840b199a5ed95$export$ae1af26003f05816);
$parcel$export(module.exports, "n", () => $b93840b199a5ed95$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "c", () => $b93840b199a5ed95$export$db3b6bfb95261072);
$parcel$export(module.exports, "d", () => $b93840b199a5ed95$export$4368d992c4eafac0);
$parcel$export(module.exports, "f", () => $b93840b199a5ed95$export$2d1720544b23b823);
$parcel$export(module.exports, "S", () => $b93840b199a5ed95$export$25ce5a424b770e84);
$parcel$export(module.exports, "g", () => $b93840b199a5ed95$export$39b482c5e57630a8);

var $euxye = parcelRequire("euxye");

var $8Sa3N = parcelRequire("8Sa3N");

var $grE7r = parcelRequire("grE7r");
'use client';
// Global state used to deduplicate requests and store listeners
const $b93840b199a5ed95$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $b93840b199a5ed95$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $b93840b199a5ed95$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $b93840b199a5ed95$export$ebd11618f299a286();
const $b93840b199a5ed95$export$c4ce752e73470fba = Object;
const $b93840b199a5ed95$export$f1e1789686576879 = (v)=>v === $b93840b199a5ed95$export$3a6d5c9ae78a2c08;
const $b93840b199a5ed95$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $b93840b199a5ed95$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $b93840b199a5ed95$export$ef35774e6d314e91 = (x)=>$b93840b199a5ed95$export$407448d2b89b1813(x.then);
const $b93840b199a5ed95$var$EMPTY_CACHE = {};
const $b93840b199a5ed95$var$INITIAL_CACHE = {};
const $b93840b199a5ed95$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $b93840b199a5ed95$export$23f2a1d2818174ef = typeof window != $b93840b199a5ed95$var$STR_UNDEFINED;
const $b93840b199a5ed95$export$efccba1c4a2ef57b = typeof document != $b93840b199a5ed95$var$STR_UNDEFINED;
const $b93840b199a5ed95$export$d141bba7fdc215a3 = $b93840b199a5ed95$export$23f2a1d2818174ef && 'Deno' in window;
const $b93840b199a5ed95$export$4a5767248b18ef41 = ()=>$b93840b199a5ed95$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $b93840b199a5ed95$var$STR_UNDEFINED;
const $b93840b199a5ed95$export$df995fae86a55f06 = (cache, key)=>{
    const state = $b93840b199a5ed95$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$b93840b199a5ed95$export$f1e1789686576879(key) && cache.get(key) || $b93840b199a5ed95$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$b93840b199a5ed95$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $b93840b199a5ed95$var$INITIAL_CACHE)) $b93840b199a5ed95$var$INITIAL_CACHE[key] = prev;
                state[5](key, $b93840b199a5ed95$export$953cecd6e717a553(prev, info), prev || $b93840b199a5ed95$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$b93840b199a5ed95$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $b93840b199a5ed95$var$INITIAL_CACHE) return $b93840b199a5ed95$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$b93840b199a5ed95$export$f1e1789686576879(key) && cache.get(key) || $b93840b199a5ed95$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $b93840b199a5ed95$var$online = true;
const $b93840b199a5ed95$var$isOnline = ()=>$b93840b199a5ed95$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$b93840b199a5ed95$var$onWindowEvent, $b93840b199a5ed95$var$offWindowEvent] = $b93840b199a5ed95$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $b93840b199a5ed95$export$ebd11618f299a286,
    $b93840b199a5ed95$export$ebd11618f299a286
];
const $b93840b199a5ed95$var$isVisible = ()=>{
    const visibilityState = $b93840b199a5ed95$export$efccba1c4a2ef57b && document.visibilityState;
    return $b93840b199a5ed95$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $b93840b199a5ed95$var$initFocus = (callback)=>{
    // focus revalidate
    if ($b93840b199a5ed95$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $b93840b199a5ed95$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($b93840b199a5ed95$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $b93840b199a5ed95$var$offWindowEvent('focus', callback);
    };
};
const $b93840b199a5ed95$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $b93840b199a5ed95$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $b93840b199a5ed95$var$online = false;
    };
    $b93840b199a5ed95$var$onWindowEvent('online', onOnline);
    $b93840b199a5ed95$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $b93840b199a5ed95$var$offWindowEvent('online', onOnline);
        $b93840b199a5ed95$var$offWindowEvent('offline', onOffline);
    };
};
const $b93840b199a5ed95$export$ffb5f4729a158638 = {
    isOnline: $b93840b199a5ed95$var$isOnline,
    isVisible: $b93840b199a5ed95$var$isVisible
};
const $b93840b199a5ed95$export$9e5f44173e64f162 = {
    initFocus: $b93840b199a5ed95$var$initFocus,
    initReconnect: $b93840b199a5ed95$var$initReconnect
};
const $b93840b199a5ed95$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useId;
const $b93840b199a5ed95$export$43caf9889c228507 = !$b93840b199a5ed95$export$23f2a1d2818174ef || $b93840b199a5ed95$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $b93840b199a5ed95$export$625550452a3fa3ec = (f)=>$b93840b199a5ed95$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $b93840b199a5ed95$export$3b14a55fb2447963 = $b93840b199a5ed95$export$43caf9889c228507 ? (0, $euxye.useEffect) : (0, $euxye.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $b93840b199a5ed95$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $b93840b199a5ed95$export$90a7f3efeed30595 = !$b93840b199a5ed95$export$43caf9889c228507 && $b93840b199a5ed95$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($b93840b199a5ed95$var$navigatorConnection.effectiveType) || $b93840b199a5ed95$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $b93840b199a5ed95$var$table = new WeakMap();
const $b93840b199a5ed95$var$getTypeName = (value)=>$b93840b199a5ed95$export$c4ce752e73470fba.prototype.toString.call(value);
const $b93840b199a5ed95$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $b93840b199a5ed95$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $b93840b199a5ed95$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $b93840b199a5ed95$var$getTypeName(arg);
    const isDate = $b93840b199a5ed95$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $b93840b199a5ed95$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $b93840b199a5ed95$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($b93840b199a5ed95$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $b93840b199a5ed95$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$b93840b199a5ed95$var$counter + '~';
        $b93840b199a5ed95$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $b93840b199a5ed95$export$882b5998b3b9117c(arg[index]) + ',';
            $b93840b199a5ed95$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $b93840b199a5ed95$export$c4ce752e73470fba.keys(arg).sort();
            while(!$b93840b199a5ed95$export$f1e1789686576879(index = keys.pop()))if (!$b93840b199a5ed95$export$f1e1789686576879(arg[index])) result += index + ':' + $b93840b199a5ed95$export$882b5998b3b9117c(arg[index]) + ',';
            $b93840b199a5ed95$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $b93840b199a5ed95$export$2408f22a0fab9ae5 = (key)=>{
    if ($b93840b199a5ed95$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $b93840b199a5ed95$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $b93840b199a5ed95$var$__timestamp = 0;
const $b93840b199a5ed95$export$ae1af26003f05816 = ()=>++$b93840b199a5ed95$var$__timestamp;
async function $b93840b199a5ed95$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $b93840b199a5ed95$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($b93840b199a5ed95$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $b93840b199a5ed95$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $b93840b199a5ed95$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $b93840b199a5ed95$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $b93840b199a5ed95$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($8Sa3N.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $b93840b199a5ed95$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$b93840b199a5ed95$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $b93840b199a5ed95$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $b93840b199a5ed95$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($b93840b199a5ed95$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $b93840b199a5ed95$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $b93840b199a5ed95$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($b93840b199a5ed95$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $b93840b199a5ed95$export$3a6d5c9ae78a2c08,
                        _c: $b93840b199a5ed95$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $b93840b199a5ed95$export$3a6d5c9ae78a2c08,
                    _c: $b93840b199a5ed95$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $b93840b199a5ed95$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $b93840b199a5ed95$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $b93840b199a5ed95$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $b93840b199a5ed95$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$b93840b199a5ed95$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $b93840b199a5ed95$export$953cecd6e717a553($b93840b199a5ed95$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $b93840b199a5ed95$export$7ccc53e8f1e7dfc5.bind($b93840b199a5ed95$export$3a6d5c9ae78a2c08, provider);
        let unmount = $b93840b199a5ed95$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$b93840b199a5ed95$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $b93840b199a5ed95$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$b93840b199a5ed95$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($b93840b199a5ed95$export$3a6d5c9ae78a2c08, $b93840b199a5ed95$var$revalidateAllKeys.bind($b93840b199a5ed95$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $8Sa3N.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($b93840b199a5ed95$export$3a6d5c9ae78a2c08, $b93840b199a5ed95$var$revalidateAllKeys.bind($b93840b199a5ed95$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $8Sa3N.RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $b93840b199a5ed95$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $b93840b199a5ed95$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $b93840b199a5ed95$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$b93840b199a5ed95$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $b93840b199a5ed95$export$342063e11d6c3cad = (0, $grE7r.dequal);
// Default cache provider
const [$b93840b199a5ed95$export$db3b6bfb95261072, $b93840b199a5ed95$export$35e795649ee09318] = $b93840b199a5ed95$export$dda1d9f60106f0e9(new Map());
// Default config
const $b93840b199a5ed95$export$4368d992c4eafac0 = $b93840b199a5ed95$export$953cecd6e717a553({
    // events
    onLoadingSlow: $b93840b199a5ed95$export$ebd11618f299a286,
    onSuccess: $b93840b199a5ed95$export$ebd11618f299a286,
    onError: $b93840b199a5ed95$export$ebd11618f299a286,
    onErrorRetry: $b93840b199a5ed95$var$onErrorRetry,
    onDiscarded: $b93840b199a5ed95$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $b93840b199a5ed95$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $b93840b199a5ed95$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $b93840b199a5ed95$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $b93840b199a5ed95$export$db3b6bfb95261072,
    mutate: $b93840b199a5ed95$export$35e795649ee09318,
    fallback: {}
}, $b93840b199a5ed95$export$ffb5f4729a158638);
const $b93840b199a5ed95$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $b93840b199a5ed95$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $b93840b199a5ed95$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $b93840b199a5ed95$export$25ce5a424b770e84 = (0, $euxye.createContext)({});
const $b93840b199a5ed95$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $euxye.useContext)($b93840b199a5ed95$export$25ce5a424b770e84);
    const isFunctionalConfig = $b93840b199a5ed95$export$407448d2b89b1813(value);
    const config = (0, $euxye.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $euxye.useMemo)(()=>isFunctionalConfig ? config : $b93840b199a5ed95$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $euxye.useRef)($b93840b199a5ed95$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $b93840b199a5ed95$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $b93840b199a5ed95$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $b93840b199a5ed95$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $euxye.createElement)($b93840b199a5ed95$export$25ce5a424b770e84.Provider, $b93840b199a5ed95$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};

});
parcelRegister("8Sa3N", function(module, exports) {
$parcel$export(module.exports, "FOCUS_EVENT", () => $01aac2c494e6e6b9$export$831c820ad60f9d12);
$parcel$export(module.exports, "RECONNECT_EVENT", () => $01aac2c494e6e6b9$export$24e9454cb99a11dc);
$parcel$export(module.exports, "MUTATE_EVENT", () => $01aac2c494e6e6b9$export$75ea288459391154);
$parcel$export(module.exports, "ERROR_REVALIDATE_EVENT", () => $01aac2c494e6e6b9$export$b019c3839228f243);
const $01aac2c494e6e6b9$export$831c820ad60f9d12 = 0;
const $01aac2c494e6e6b9$export$24e9454cb99a11dc = 1;
const $01aac2c494e6e6b9$export$75ea288459391154 = 2;
const $01aac2c494e6e6b9$export$b019c3839228f243 = 3;

});

parcelRegister("grE7r", function(module, exports) {
$parcel$export(module.exports, "dequal", () => $bf8e49c5e84e6ab3$export$de8294bb3be0322f);
var $bf8e49c5e84e6ab3$var$has = Object.prototype.hasOwnProperty;
function $bf8e49c5e84e6ab3$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $bf8e49c5e84e6ab3$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($bf8e49c5e84e6ab3$var$has.call(foo, ctor) && ++len && !$bf8e49c5e84e6ab3$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$bf8e49c5e84e6ab3$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});


parcelRegister("7AeUu", function(module, exports) {
$parcel$export(module.exports, "useSWRConfig", () => $5857760aa6857bb9$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "withArgs", () => $5857760aa6857bb9$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $5857760aa6857bb9$export$e005210ed621746);
$parcel$export(module.exports, "SWRGlobalState", () => (parcelRequire("fTV3G")).b);
$parcel$export(module.exports, "defaultConfig", () => (parcelRequire("fTV3G")).d);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("fTV3G")).a);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("fTV3G")).e);
$parcel$export(module.exports, "mergeObjects", () => (parcelRequire("fTV3G")).m);
$parcel$export(module.exports, "serialize", () => (parcelRequire("fTV3G")).s);

var $fTV3G = parcelRequire("fTV3G");

var $8Sa3N = parcelRequire("8Sa3N");

var $gZmcl = parcelRequire("gZmcl");

var $euxye = parcelRequire("euxye");

// @ts-expect-error
const $5857760aa6857bb9$var$enableDevtools = (0, $fTV3G.i) && window.__SWR_DEVTOOLS_USE__;
const $5857760aa6857bb9$var$use = $5857760aa6857bb9$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $5857760aa6857bb9$var$setupDevTools = ()=>{
    if ($5857760aa6857bb9$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($euxye)));
};
const $5857760aa6857bb9$export$a3295358bff77e = (args)=>{
    return (0, $fTV3G.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $5857760aa6857bb9$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $euxye.useContext)((0, $fTV3G.S));
    const mergedConfig = (0, $euxye.useMemo)(()=>(0, $fTV3G.m)((0, $fTV3G.d), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $5857760aa6857bb9$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $fTV3G.s)(key_);
    const [, , , PRELOAD] = (0, $fTV3G.b).get((0, $fTV3G.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $5857760aa6857bb9$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $fTV3G.s)(key_);
            const [, , , PRELOAD] = (0, $fTV3G.b).get((0, $fTV3G.c));
            if (key.startsWith((0, $gZmcl.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $fTV3G.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $5857760aa6857bb9$var$BUILT_IN_MIDDLEWARE = $5857760aa6857bb9$var$use.concat($5857760aa6857bb9$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $5857760aa6857bb9$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $5857760aa6857bb9$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $5857760aa6857bb9$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $fTV3G.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($5857760aa6857bb9$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $5857760aa6857bb9$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $5857760aa6857bb9$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $5857760aa6857bb9$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$5857760aa6857bb9$var$setupDevTools();

});
parcelRegister("gZmcl", function(module, exports) {
$parcel$export(module.exports, "INFINITE_PREFIX", () => $c5e38ff21accd821$export$8667f065faedc62c);
const $c5e38ff21accd821$export$8667f065faedc62c = '$inf$';

});



parcelRegister("j142y", function(module, exports) {
$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $b2697e17f6285a3d$export$da5dc9062cba6715);
$parcel$export(module.exports, "PostOfficeContext", () => $b2697e17f6285a3d$export$a228be81fcb77b42);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $b2697e17f6285a3d$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $b2697e17f6285a3d$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $b2697e17f6285a3d$export$5bd9099e0ae94a43);

var $euxye = parcelRequire("euxye");
const $b2697e17f6285a3d$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $b2697e17f6285a3d$export$a228be81fcb77b42 = (0, $euxye.createContext)($b2697e17f6285a3d$export$da5dc9062cba6715);
const $b2697e17f6285a3d$export$3a10495c2cd2db0c = $b2697e17f6285a3d$export$a228be81fcb77b42.Provider;
const $b2697e17f6285a3d$export$b77983be89bb0a4e = $b2697e17f6285a3d$export$3a10495c2cd2db0c;
const $b2697e17f6285a3d$export$5bd9099e0ae94a43 = ()=>(0, $euxye.useContext)($b2697e17f6285a3d$export$a228be81fcb77b42);

});

parcelRegister("gpTCJ", function(module, exports) {
$parcel$export(module.exports, "postOfficeGasv3ListenerStore", () => $9ba14ec4d62fb8f1$export$19b95495a42be187);

var $de6m4 = parcelRequire("de6m4");
function $9ba14ec4d62fb8f1$var$getSubscribers() {
    if (typeof window !== 'undefined' && window.postOffice?.gasv3Listener?.subscribers) return window.postOffice.gasv3Listener.subscribers;
    if (typeof window !== 'undefined') {
        window.postOffice = {
            ...window.postOffice,
            gasv3Listener: {
                ...window.postOffice?.gasv3Listener,
                subscribers: new Map()
            }
        };
        return window.postOffice.gasv3Listener.subscribers;
    }
    return new Map();
}
const $9ba14ec4d62fb8f1$var$createPostOfficeGasv3ListenerStore = ()=>{
    const subscribers = $9ba14ec4d62fb8f1$var$getSubscribers();
    const handleEvent = (event)=>{
        subscribers.forEach((callback, matcher)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($de6m4)))(event.payload, matcher)) callback();
        });
    };
    const subscribe = (matcher, callback)=>{
        subscribers.set(matcher, callback);
        return ()=>{
            subscribers.delete(matcher);
        };
    };
    return {
        subscribe: subscribe,
        handleEvent: handleEvent
    };
};
const $9ba14ec4d62fb8f1$export$19b95495a42be187 = $9ba14ec4d62fb8f1$var$createPostOfficeGasv3ListenerStore();

});

parcelRegister("fz2Dv", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeRouteUpdate", () => $01b438cc7c3e50f1$export$bb606326acdd1a64);
$parcel$export(module.exports, "RouteListenerProvider", () => $01b438cc7c3e50f1$export$31986273b686f5ea);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $950Y0 = parcelRequire("950Y0");

var $hCvtI = parcelRequire("hCvtI");
const $01b438cc7c3e50f1$var$noop = ()=>{};
const $01b438cc7c3e50f1$var$RouteListenerContext = /*#__PURE__*/ (0, $euxye.createContext)({
    update: $01b438cc7c3e50f1$var$noop
});
const $01b438cc7c3e50f1$export$7a2084f4baac29a7 = ()=>(0, $950Y0.createSimplePubSub)();
const $01b438cc7c3e50f1$export$72fd8977abf03d60 = ()=>(0, $euxye.useContext)($01b438cc7c3e50f1$var$RouteListenerContext);
const $01b438cc7c3e50f1$export$755edb1665399d41 = ()=>{
    const ref = (0, $euxye.useRef)();
    if (!ref.current) ref.current = $01b438cc7c3e50f1$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $euxye.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $euxye.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $01b438cc7c3e50f1$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $01b438cc7c3e50f1$export$72fd8977abf03d60();
    (0, $euxye.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $01b438cc7c3e50f1$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $01b438cc7c3e50f1$export$755edb1665399d41();
    return /*#__PURE__*/ (0, $e79Pd.jsx)($01b438cc7c3e50f1$var$RouteListenerContext.Provider, {
        value: routeUpdater,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hCvtI.PostOfficeRouteProvider), {
            ...route,
            children: children
        })
    });
};
$01b438cc7c3e50f1$export$31986273b686f5ea.displayName = "RouteListenerProvider";

});
parcelRegister("950Y0", function(module, exports) {
$parcel$export(module.exports, "createSimplePubSub", () => $c9a6a401550fb788$export$92469b55607f005b);
const $c9a6a401550fb788$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});

parcelRegister("hCvtI", function(module, exports) {
$parcel$export(module.exports, "PostOfficeRouteContext", () => $64d952398ea9bc99$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $64d952398ea9bc99$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $64d952398ea9bc99$export$79301b66f7808cd8);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4PfqE = parcelRequire("4PfqE");

var $khHng = parcelRequire("khHng");
const $64d952398ea9bc99$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $64d952398ea9bc99$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $64d952398ea9bc99$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $4PfqE.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $khHng.useStableObject)(route);
};
const $64d952398ea9bc99$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $64d952398ea9bc99$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$64d952398ea9bc99$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $64d952398ea9bc99$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $euxye.createContext)($64d952398ea9bc99$var$initialState);
const $64d952398ea9bc99$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $euxye.useRef)();
    if (!ref.current) ref.current = $64d952398ea9bc99$export$98c77e1bd702ed15(props);
    const route = $64d952398ea9bc99$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($64d952398ea9bc99$export$f7f47a74e8b47b1f.Provider, {
        value: route,
        children: children
    });
};
$64d952398ea9bc99$export$89eadc6b3e5f4e9e.displayName = "PostOfficeRouteProvider";
const $64d952398ea9bc99$export$79301b66f7808cd8 = ()=>(0, $euxye.useContext)($64d952398ea9bc99$export$f7f47a74e8b47b1f); //Route listener

});
parcelRegister("khHng", function(module, exports) {
$parcel$export(module.exports, "useStableObject", () => $08d11130695570c0$export$ed02d4adf2068b08);

var $euxye = parcelRequire("euxye");
function $08d11130695570c0$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $08d11130695570c0$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $euxye.useMemo)(()=>obj, $08d11130695570c0$export$cdf98ded28406f69(obj));
}

});



parcelRegister("bF40s", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeScreen", () => $31a36a868c2651bc$export$70e19226ddeaf957);
$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $31a36a868c2651bc$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $31a36a868c2651bc$export$f51d04a086368016);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $42bHP = parcelRequire("42bHP");
const $31a36a868c2651bc$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $31a36a868c2651bc$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $euxye.createContext)({
    placements: $31a36a868c2651bc$var$initialPlacementState
});
const $31a36a868c2651bc$export$70e19226ddeaf957 = ()=>(0, $euxye.useContext)($31a36a868c2651bc$var$PostOfficeScreenContext);
const $31a36a868c2651bc$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $euxye.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $31a36a868c2651bc$export$5d27c0ee02be2a23 = ()=>(0, $euxye.useContext)($31a36a868c2651bc$var$PostOfficeScreenUpdateContext);
const $31a36a868c2651bc$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $euxye.useState)($31a36a868c2651bc$var$initialPlacementState);
    const placementMount = (0, $euxye.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $42bHP.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $42bHP.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $euxye.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $euxye.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $euxye.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($31a36a868c2651bc$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($31a36a868c2651bc$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext,
            children: children
        })
    });
};
$31a36a868c2651bc$export$ca77a8cbe94108fe.displayName = "PostOfficeScreenContextProvider";
const $31a36a868c2651bc$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $31a36a868c2651bc$export$5d27c0ee02be2a23();
    (0, $euxye.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("42bHP", function(module, exports) {
$parcel$export(module.exports, "uniqueArray", () => $4a89b6dfd65ffe78$export$bbd17ecb0679edd7);
const $4a89b6dfd65ffe78$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});


parcelRegister("clg9t", function(module, exports) {
$parcel$export(module.exports, "EPExposuresListener", () => $ce3fa72e55dc044b$export$3476bc3bd0845b44);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hIipg = parcelRequire("hIipg");

var $f6SzU = parcelRequire("f6SzU");
const $ce3fa72e55dc044b$var$ENGAGEMENT_PLATFORM_CHANNEL = 'engagementPlatform';
const $ce3fa72e55dc044b$var$isPromise = (value)=>{
    return value && typeof value.then === 'function';
};
const $ce3fa72e55dc044b$export$3476bc3bd0845b44 = ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const handleEvent = (0, $euxye.useCallback)((event)=>{
        if (!analyticsClientInstance) return;
        const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
        const userId = restPayload?.userId || attributes?.userId;
        const tenantId = restPayload?.tenantId || attributes?.tenantId;
        if (eventType !== 'track' && eventType !== 'operational') return;
        if (!userId || !tenantId) return;
        // Handle Promise if analyticsClientInstance is a Promise
        const processEvent = (client)=>{
            // Update client with user and tenant info
            try {
                if (tenantId) client.setTenantInfo((0, $hIipg.tenantType).CLOUD_ID, tenantId);
                if (userId) client.setUserInfo((0, $hIipg.userType).ATLASSIAN_ACCOUNT, userId);
            } catch (error) {
                return;
            }
            // Build payload with tenantId at top level (userId is automatically included via setUserInfo)
            const gasPayload = {
                ...restPayload,
                tenantId: tenantId,
                ...attributes ? {
                    attributes: attributes
                } : {}
            };
            if (eventType === 'track') client.sendTrackEvent(gasPayload);
            else if (eventType === 'operational') client.sendOperationalEvent(gasPayload);
        };
        if ($ce3fa72e55dc044b$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
        else processEvent(analyticsClientInstance);
    }, [
        analyticsClientInstance
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6SzU.default), {
        channel: $ce3fa72e55dc044b$var$ENGAGEMENT_PLATFORM_CHANNEL,
        onEvent: handleEvent,
        children: children
    });
};
$ce3fa72e55dc044b$export$3476bc3bd0845b44.displayName = "EPExposuresListener";

});

parcelRegister("lHZq9", function(module, exports) {
$parcel$export(module.exports, "createMessagePlacementValues", () => $63288aa3c2bd587f$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $63288aa3c2bd587f$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $63288aa3c2bd587f$export$89f8e1f623d8f5ac);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $63288aa3c2bd587f$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $63288aa3c2bd587f$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $63288aa3c2bd587f$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $63288aa3c2bd587f$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $63288aa3c2bd587f$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $63288aa3c2bd587f$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $63288aa3c2bd587f$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $63288aa3c2bd587f$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $euxye.createContext)($63288aa3c2bd587f$export$a28a0c048b24fc5a());
const $63288aa3c2bd587f$export$c7535f8ebc5b75a9 = $63288aa3c2bd587f$export$ea58328f3ceee4d4.Provider;
const $63288aa3c2bd587f$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)($63288aa3c2bd587f$export$c7535f8ebc5b75a9, {
            value: $63288aa3c2bd587f$export$a28a0c048b24fc5a(),
            children: children
        });
const $63288aa3c2bd587f$export$89f8e1f623d8f5ac = ()=>(0, $euxye.useContext)($63288aa3c2bd587f$export$ea58328f3ceee4d4);

});

parcelRegister("7unaJ", function(module, exports) {
$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $6fdf8e5dc4890980$export$ae3dab16eb1fc2cc);
const $6fdf8e5dc4890980$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});

parcelRegister("8d15r", function(module, exports) {
$parcel$export(module.exports, "localStorageCacheProvider", () => $a2a8d15db4938c50$export$54eb3e634424b746);
$parcel$export(module.exports, "postOfficeCacheMiddleware", () => $a2a8d15db4938c50$export$711c5bb855c82238);

var $euxye = parcelRequire("euxye");

var $7AeUu = parcelRequire("7AeUu");

var $8faAl = parcelRequire("8faAl");
const $a2a8d15db4938c50$var$STORAGE_KEY = 'POST_OFFICE__CLIENT_CACHE';
const $a2a8d15db4938c50$var$CACHE_KEY = 'placement-api';
const $a2a8d15db4938c50$var$CACHE_EXPIRY = 120000; // 2 minutes
const $a2a8d15db4938c50$var$storageClient = new (0, $8faAl.default)($a2a8d15db4938c50$var$STORAGE_KEY);
const $a2a8d15db4938c50$export$3c979fbaa76beaf9 = (cache)=>{
    if (cache instanceof Map && cache.size > 0) {
        const existingCache = $a2a8d15db4938c50$export$54eb3e634424b746();
        const mergedCache = new Map([
            ...existingCache,
            ...cache
        ]);
        const appCache = Array.from(mergedCache.entries());
        // localStorage.getItem("POST_OFFICE__CLIENT_CACHE_placement-api")
        $a2a8d15db4938c50$var$storageClient.setItemWithExpiry($a2a8d15db4938c50$var$CACHE_KEY, appCache, $a2a8d15db4938c50$var$CACHE_EXPIRY);
    }
};
const $a2a8d15db4938c50$export$54eb3e634424b746 = ()=>{
    if (typeof window === 'undefined') // Return a dummy storage for server-side rendering
    return new Map();
    // When initializing, we restore the data from `localStorage` into a map.
    const cache = $a2a8d15db4938c50$var$storageClient.getItem($a2a8d15db4938c50$var$CACHE_KEY) || [];
    return new Map(cache);
};
const $a2a8d15db4938c50$export$711c5bb855c82238 = (useSWRNext)=>{
    return (key, fetcher, config)=>{
        const { cache: cache } = (0, $7AeUu.useSWRConfig)();
        const swr = useSWRNext(key, fetcher, config);
        /**
		 * This will execute even when data is pulled from the local storage cache.
		 * This means that the cache will be updated and the CACHE_EXPIRY reset to be a rolling window.
		 *
		 * We may want to change this behaviour in the future to only update the cache when the data is NOT pulled from the local storage cache.
		 */ (0, $euxye.useEffect)(()=>{
            if (swr.data !== undefined) $a2a8d15db4938c50$export$3c979fbaa76beaf9(cache);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            swr.data
        ]);
        return swr;
    };
};

});


parcelRegister("ln1b1", function(module, exports) {
$parcel$export(module.exports, "StableSubscriptionAdapterProvider", () => $98f59de9e2c164ca$export$a9c8cf9c01c68a0b);
$parcel$export(module.exports, "useSubscriptionAdapter", () => $98f59de9e2c164ca$export$b99cbdde6180775c);

var $euxye = parcelRequire("euxye");
const $98f59de9e2c164ca$var$SubscriptionAdapterContext = /*#__PURE__*/ (0, $euxye.createContext)({
    subscriptionAdapter: undefined
});
const $98f59de9e2c164ca$export$a9c8cf9c01c68a0b = ({ subscriptionAdapter: subscriptionAdapter, children: children })=>{
    const memoizedValue = (0, $euxye.useMemo)(()=>({
            subscriptionAdapter: subscriptionAdapter
        }), [
        subscriptionAdapter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($98f59de9e2c164ca$var$SubscriptionAdapterContext.Provider, {
        value: memoizedValue
    }, children);
};
$98f59de9e2c164ca$export$a9c8cf9c01c68a0b.displayName = "StableSubscriptionAdapterProvider";
const $98f59de9e2c164ca$export$b99cbdde6180775c = ()=>{
    return (0, $euxye.useContext)($98f59de9e2c164ca$var$SubscriptionAdapterContext);
};

});

parcelRegister("ltdjJ", function(module, exports) {
$parcel$export(module.exports, "createUseSubscribeAdapter", () => $8d807d56985258e3$export$7e4a10e4df39fa64);

var $euxye = parcelRequire("euxye");

var $ltalp = parcelRequire("ltalp");
const $8d807d56985258e3$var$NOOP_PAYLOAD = {
    query: 'subscription NoOp { __typename }',
    operationName: 'NoOp',
    variables: {}
};
function $8d807d56985258e3$var$useRelaySubscription(config) {
    const query = config.subscription !== undefined && typeof config.subscription === 'string' ? config.subscription : null;
    const [state, setState] = (0, $euxye.useState)({
        data: null,
        error: null,
        isLoading: true
    });
    const payload = (0, $euxye.useMemo)(()=>{
        if (query) {
            const operationName = query.match(/subscription\s+(\w+)/)?.[1] ?? '';
            return {
                query: query,
                operationName: operationName,
                variables: config.variables
            };
        }
        return {
            ...$8d807d56985258e3$var$NOOP_PAYLOAD,
            variables: config.variables
        };
    }, [
        query,
        config.variables
    ]);
    const sink = (0, $euxye.useMemo)(()=>({
            next: (value)=>{
                const data = value?.data;
                if (data != null) setState({
                    data: data,
                    error: null,
                    isLoading: false
                });
            },
            error: (err)=>{
                setState({
                    data: null,
                    error: err,
                    isLoading: false
                });
            }
        }), []);
    (0, $ltalp.useSubscribe)(payload, sink);
    if (!query) return {
        status: 'loading',
        data: null,
        error: null,
        isLoading: true
    };
    if (state.error) return {
        status: 'error',
        data: null,
        error: state.error,
        isLoading: false
    };
    if (state.data) return {
        status: 'success',
        data: state.data,
        error: null,
        isLoading: false
    };
    return {
        status: 'loading',
        data: null,
        error: null,
        isLoading: true
    };
}
const $8d807d56985258e3$export$7e4a10e4df39fa64 = ()=>({
        useSubscription: $8d807d56985258e3$var$useRelaySubscription
    });

});
parcelRegister("ltalp", function(module, exports) {
$parcel$export(module.exports, "useSubscribe", () => $af551d83e1e41517$export$d3d523392640272);

var $euxye = parcelRequire("euxye");


var $9U3Pa = parcelRequire("9U3Pa");

var $lOp85 = parcelRequire("lOp85");

var $7SqTw = parcelRequire("7SqTw");

var $dMvG2 = parcelRequire("dMvG2");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $af551d83e1e41517$var$noop = ()=>{};
const $af551d83e1e41517$var$subscribe = (payload, sink)=>{
    const client = (0, $lOp85.getClient)();
    if (!client) return;
    const { query: query, variables: variables, operationName: operationName, extensions: extensions } = payload;
    const { next: next, error: error, complete: complete = $af551d83e1e41517$var$noop } = sink;
    let requestId;
    return client.subscribe({
        query: query,
        variables: variables,
        operationName: operationName,
        extensions: {
            ...extensions ?? {}
        }
    }, {
        next: (value)=>{
            // @ts-expect-error agg prop is missing on generic "extensions" type
            const aggRequestId = value?.extensions?.agg?.request_id;
            if (aggRequestId) requestId = aggRequestId;
            // @ts-expect-error incompatible types between two libraries
            next(value);
        },
        complete: complete,
        error: (sinkError)=>{
            const errorInfo = (0, $7SqTw.getSinkError)(sinkError);
            const attributes = {
                operationName: operationName,
                requestId: requestId
            };
            error?.(errorInfo, attributes);
        }
    });
};
const $af551d83e1e41517$export$d3d523392640272 = (payload, sink)=>{
    (0, $euxye.useEffect)(()=>{
        let unsubscribe = $af551d83e1e41517$var$subscribe(payload, sink);
        let timeout;
        const onVisibilityChange = ()=>{
            if ((0, $dMvG2.isPageVisible)()) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = undefined;
                } else unsubscribe = $af551d83e1e41517$var$subscribe(payload, sink);
            } else if (!timeout) timeout = setTimeout(()=>{
                unsubscribe?.();
                unsubscribe = undefined;
                timeout = undefined;
            }, (0, $4987114a75f06bf7$export$1ad8434180c5936c));
        };
        if (!(0, $9U3Pa.isSSR)()) window.addEventListener((0, $dMvG2.supportedVisiblityEvent), onVisibilityChange);
        return ()=>{
            window.removeEventListener((0, $dMvG2.supportedVisiblityEvent), onVisibilityChange);
            unsubscribe?.();
        };
    }, [
        payload,
        sink
    ]);
};

});
const $4987114a75f06bf7$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $4987114a75f06bf7$export$bf6cd96e19b2987f = 100;
const $4987114a75f06bf7$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("dMvG2", function(module, exports) {
$parcel$export(module.exports, "supportedVisiblityEvent", () => $dd2fc0129022fdf3$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $dd2fc0129022fdf3$export$ae4f9b990bc70f70);
const $dd2fc0129022fdf3$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $dd2fc0129022fdf3$var$supportedHiddenKey = Object.keys($dd2fc0129022fdf3$var$visibilityMap).find((key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $dd2fc0129022fdf3$export$f7132cb36c80dad = $dd2fc0129022fdf3$var$visibilityMap[$dd2fc0129022fdf3$var$supportedHiddenKey];
const $dd2fc0129022fdf3$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$dd2fc0129022fdf3$var$supportedHiddenKey];

});



parcelRegister("4iwgB", function(module, exports) {
$parcel$export(module.exports, "CrossFlowPostOfficeContext", () => $f3f69b1508a0d657$export$2e4aec418d6136f);
$parcel$export(module.exports, "CrossFlowPostOfficeProvider", () => $f3f69b1508a0d657$export$de3f510d70d6c70c);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6VoYp = parcelRequire("6VoYp");

var $jGZAV = parcelRequire("jGZAV");

var $fNgVF = parcelRequire("fNgVF");

var $dSYlf = parcelRequire("dSYlf");

var $kd923 = parcelRequire("kd923");

var $33SjG = parcelRequire("33SjG");

var $5rZe5 = parcelRequire("5rZe5");

var $bs9jJ = parcelRequire("bs9jJ");

var $cp8vl = parcelRequire("cp8vl");
const $f3f69b1508a0d657$export$2e4aec418d6136f = /*#__PURE__*/ (0, $euxye.createContext)({
    loomTouchpointVariant: null,
    isAdmin: null,
    isOrgAdmin: null,
    hasActiveJpdLicense: null,
    tenantHasConfluence: null,
    canProvisionConfluenceEndUser: null,
    areProductSuggestionsEnabled: null,
    isAiEligibleAndTriggered: null
});
const $f3f69b1508a0d657$export$de3f510d70d6c70c = ({ children: children, loomTouchpointVariant: loomTouchpointVariant, isAiEligibleAndTriggered: isAiEligibleAndTriggered })=>{
    const licensedProducts = (0, $5rZe5.useLicensedProducts)();
    const tenantHasConfluence = licensedProducts?.confluence === true;
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const { canProvisionConfluenceEndUser: canProvisionConfluenceEndUser } = (0, $jGZAV.useUserHasAddProductPermissions)({
        skip: isSiteAdmin || tenantHasConfluence
    });
    const areProductSuggestionsEnabled = (0, $cp8vl.useAreProductSuggestionsEnabled)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const hasActiveJpdLicense = (0, $kd923.useSelector)((0, $6VoYp.tenantHasActiveProductDiscoveryLicenseSelector));
    // isOrgAdmin is fetched from an api call and the initial value of loading is false
    // so it changes from false to true and then back to false
    // we need to wait for the loading to be true and then false again before we can render the children
    // this is to avoid re render of post office placement
    // to achieve this, we use usePrevious hook to check the previous value of isOrgAdminLoading
    // and only render the children when the previous value is true and the current value is false
    const { isOrgAdmin: isOrgAdmin, loading: isOrgAdminLoading } = (0, $dSYlf.useIsOrgAdmin)();
    const previousIsOrgAdminLoading = (0, $33SjG.usePreviousPersistent)(isOrgAdminLoading);
    const context = (0, $euxye.useMemo)(()=>{
        return {
            loomTouchpointVariant: loomTouchpointVariant,
            isAdmin: isAdmin,
            isOrgAdmin: isOrgAdmin,
            hasActiveJpdLicense: hasActiveJpdLicense,
            tenantHasConfluence: tenantHasConfluence,
            canProvisionConfluenceEndUser: canProvisionConfluenceEndUser,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            isAiEligibleAndTriggered: !!isAiEligibleAndTriggered
        };
    }, [
        loomTouchpointVariant,
        isAdmin,
        isOrgAdmin,
        hasActiveJpdLicense,
        tenantHasConfluence,
        canProvisionConfluenceEndUser,
        areProductSuggestionsEnabled,
        isAiEligibleAndTriggered
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f3f69b1508a0d657$export$2e4aec418d6136f.Provider, {
        value: context
    }, previousIsOrgAdminLoading && !isOrgAdminLoading && children);
};
$f3f69b1508a0d657$export$de3f510d70d6c70c.displayName = "CrossFlowPostOfficeProvider";

});
parcelRegister("6VoYp", function(module, exports) {
$parcel$export(module.exports, "contextSelector", () => $ef16f6d31bf38b4c$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $ef16f6d31bf38b4c$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $ef16f6d31bf38b4c$export$24984a39db14d8);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $ef16f6d31bf38b4c$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $ef16f6d31bf38b4c$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $ef16f6d31bf38b4c$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $ef16f6d31bf38b4c$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $ef16f6d31bf38b4c$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $ef16f6d31bf38b4c$export$b5a643cfff945455);
$parcel$export(module.exports, "issueAriSelector", () => $ef16f6d31bf38b4c$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "commentAriSelector", () => $ef16f6d31bf38b4c$export$b600fd41c88f35c8);
$parcel$export(module.exports, "isAnonymousSelector", () => $ef16f6d31bf38b4c$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $ef16f6d31bf38b4c$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $ef16f6d31bf38b4c$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $ef16f6d31bf38b4c$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $ef16f6d31bf38b4c$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $ef16f6d31bf38b4c$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $ef16f6d31bf38b4c$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $ef16f6d31bf38b4c$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $ef16f6d31bf38b4c$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $ef16f6d31bf38b4c$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $ef16f6d31bf38b4c$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $ef16f6d31bf38b4c$export$93badd2a066af8bd);
$parcel$export(module.exports, "appPermissionsSelector", () => $ef16f6d31bf38b4c$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $ef16f6d31bf38b4c$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $ef16f6d31bf38b4c$export$631793d49dec78de);
$parcel$export(module.exports, "appEditionsSelector", () => $ef16f6d31bf38b4c$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $ef16f6d31bf38b4c$export$96c87532aec3474a);
$parcel$export(module.exports, "tenantHasActiveProductDiscoveryLicenseSelector", () => $ef16f6d31bf38b4c$export$f049ad7141428191);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $ef16f6d31bf38b4c$export$2b8e6729c89e24f5);

var $a7e1f = parcelRequire("a7e1f");

var $h2S4H = parcelRequire("h2S4H");
var $dtlih = parcelRequire("dtlih");
var $7cCLc = parcelRequire("7cCLc");
var $2Q8LI = parcelRequire("2Q8LI");
var $boO75 = parcelRequire("boO75");

var $7tjnB = parcelRequire("7tjnB");

var $40rxp = parcelRequire("40rxp");

var $bsHVd = parcelRequire("bsHVd");


var $2HuOR = parcelRequire("2HuOR");

var $2zU0a = parcelRequire("2zU0a");

var $i860n = parcelRequire("i860n");

var $3hAiL = parcelRequire("3hAiL");
const $ef16f6d31bf38b4c$export$c420c9f40402ab6d = (state)=>state.context;
const $ef16f6d31bf38b4c$export$cb29341089829e17 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $ef16f6d31bf38b4c$export$24984a39db14d8 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $ef16f6d31bf38b4c$export$767583fcce1653ec = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $ef16f6d31bf38b4c$export$d22bc6271070f453 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.issueKey);
const $ef16f6d31bf38b4c$export$31efbca30077ec1e = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.issueId);
const $ef16f6d31bf38b4c$export$404de5ac601b84bc = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$d22bc6271070f453, (issueKey)=>(0, $40rxp.extractProjectKey)(issueKey));
const $ef16f6d31bf38b4c$export$85a9d212d56669b4 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $ef16f6d31bf38b4c$export$b5a643cfff945455 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.cloudId || '');
const $ef16f6d31bf38b4c$export$a2cdbba2136e72d3 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$b5a643cfff945455, $ef16f6d31bf38b4c$export$31efbca30077ec1e, (cloudId, issueId)=>(0, $2zU0a.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    }));
const $ef16f6d31bf38b4c$export$b600fd41c88f35c8 = (commentId)=>(0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$b5a643cfff945455, $ef16f6d31bf38b4c$export$31efbca30077ec1e, (cloudId, issueId)=>`ari:cloud:jira:${cloudId}:issue-comment/${issueId ?? ''}/${commentId}`);
const $ef16f6d31bf38b4c$export$2335b963a9875096 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.activationId || '');
const $ef16f6d31bf38b4c$export$a165ec261432d0b8 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $ef16f6d31bf38b4c$var$localeSelectorWithLogging = (0, $3hAiL.createSelectorWithLogging)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.locale);
const $ef16f6d31bf38b4c$var$localeSelectorWithoutLogging = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.locale);
const $ef16f6d31bf38b4c$export$f7b7935883444b11 = (state)=>{
    // fg value not available at the module level :-https://hello.atlassian.net/wiki/spaces/JFP/blog/2025/06/02/4786217813/Write+your+frontend+for+SSR+Request-specific+code#Final-(bonus)-step---Lift-your-imports
    return (0, $i860n.fg)('jiv-21686-adding-logging-for-selectors-error') ? $ef16f6d31bf38b4c$var$localeSelectorWithLogging(state) : $ef16f6d31bf38b4c$var$localeSelectorWithoutLogging(state);
};
const $ef16f6d31bf38b4c$export$b62cb5286b153905 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $ef16f6d31bf38b4c$export$6c7d07328f197de7 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $ef16f6d31bf38b4c$export$4cbb8c74e98876a5 = (0, $a7e1f.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$ef16f6d31bf38b4c$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $1771eb0e641090af$export$ce88447986394f2d));
const $ef16f6d31bf38b4c$export$6fbe1dbaf5b67cc5 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $bsHVd.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $bsHVd.standardRoadmapConfiguration)().applicationKey);
const $ef16f6d31bf38b4c$export$7479ef2453efd3b4 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $bsHVd.softwareConfiguration)().applicationKey);
const $ef16f6d31bf38b4c$export$245e5ba54167b84a = (0, $a7e1f.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$ef16f6d31bf38b4c$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $1771eb0e641090af$export$7552fe2669628499));
const $ef16f6d31bf38b4c$export$43d733e4b7e8c7d0 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $bsHVd.serviceDeskConfiguration)().applicationKey);
const $ef16f6d31bf38b4c$export$9bffc1987c753bd9 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $ef16f6d31bf38b4c$export$718e830000b27a0e = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $ef16f6d31bf38b4c$export$8065de5fbcf23af5 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $ef16f6d31bf38b4c$export$5af08fd769c0f0 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.boardType);
const $ef16f6d31bf38b4c$export$955e7dbf76b61f80 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.boardId);
const $ef16f6d31bf38b4c$export$93badd2a066af8bd = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $ef16f6d31bf38b4c$export$b468116a08f9183e = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $ef16f6d31bf38b4c$export$f29192b357e6beca = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $ef16f6d31bf38b4c$export$5b71e1eb43056b6c = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $ef16f6d31bf38b4c$export$5fa593caa6a15917 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.isModal);
const $ef16f6d31bf38b4c$export$631793d49dec78de = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$5fa593caa6a15917, $ef16f6d31bf38b4c$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $ef16f6d31bf38b4c$export$1f11fe78e4f22d45 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $ef16f6d31bf38b4c$export$28ca74e18c8f4529 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $ef16f6d31bf38b4c$export$beea798086c18f0a = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $ef16f6d31bf38b4c$export$40487a15195e570e = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $7tjnB.LICENSE_STATE_ACTIVE));
const $ef16f6d31bf38b4c$export$96c87532aec3474a = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$f29192b357e6beca, $ef16f6d31bf38b4c$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $2HuOR.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $ef16f6d31bf38b4c$export$2fa17c0746682b0b = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.productDiscovery === (0, $7tjnB.LICENSE_STATE_ACTIVE));
const $ef16f6d31bf38b4c$export$f049ad7141428191 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$f29192b357e6beca, $ef16f6d31bf38b4c$export$2fa17c0746682b0b, (licensedProducts, isProductDiscoveryLicenseActive)=>Boolean(licensedProducts && licensedProducts[(0, $2HuOR.LICENSED_PRODUCTS).JIRA_PRODUCT_DISCOVERY] && isProductDiscoveryLicenseActive));
const $ef16f6d31bf38b4c$export$747a61878b414bda = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $ef16f6d31bf38b4c$export$2b8e6729c89e24f5 = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $h2S4H.default)(new Date());
        const fourteenDaysAgo = (0, $2Q8LI.default)((0, $boO75.default)(today, 14));
        const dateToCheck = (0, $7cCLc.default)(confluenceActivationDate);
        return (0, $dtlih.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});
const $ef16f6d31bf38b4c$export$2321d15582b8ce8a = (0, $a7e1f.createSelector)($ef16f6d31bf38b4c$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $h2S4H.default)(new Date());
        const thirtyDaysAgo = (0, $2Q8LI.default)((0, $boO75.default)(today, 31)); // 31 days to account for the 30 day trial
        const dateToCheck = (0, $7cCLc.default)(confluenceActivationDate);
        return (0, $dtlih.default)(dateToCheck, {
            start: thirtyDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});

});
parcelRegister("bsHVd", function(module, exports) {
$parcel$export(module.exports, "ISSUE_TYPE", () => $73833826f449bc44$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $73833826f449bc44$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $73833826f449bc44$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $73833826f449bc44$export$289917d9a7031e1d);
$parcel$export(module.exports, "SECURITY", () => $73833826f449bc44$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ASSIGNEE", () => $73833826f449bc44$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $73833826f449bc44$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $73833826f449bc44$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $73833826f449bc44$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $73833826f449bc44$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $73833826f449bc44$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $73833826f449bc44$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $73833826f449bc44$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $73833826f449bc44$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $73833826f449bc44$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $73833826f449bc44$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $73833826f449bc44$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $73833826f449bc44$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $73833826f449bc44$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $73833826f449bc44$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $73833826f449bc44$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $73833826f449bc44$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $73833826f449bc44$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $73833826f449bc44$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $73833826f449bc44$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $73833826f449bc44$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $73833826f449bc44$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $73833826f449bc44$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $73833826f449bc44$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $73833826f449bc44$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $73833826f449bc44$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $73833826f449bc44$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $73833826f449bc44$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $73833826f449bc44$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $73833826f449bc44$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $73833826f449bc44$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $73833826f449bc44$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $73833826f449bc44$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $73833826f449bc44$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $73833826f449bc44$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $73833826f449bc44$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $73833826f449bc44$export$902f6c5cc939598a);

var $f99M0 = parcelRequire("f99M0");

var $8tYi8 = parcelRequire("8tYi8");

var $i860n = parcelRequire("i860n");

var $cDMQE = parcelRequire("cDMQE");
const $73833826f449bc44$export$ebb48b08205007c5 = 'issuetype';
const $73833826f449bc44$export$a464614f8f5fe986 = 'summary';
const $73833826f449bc44$export$a311a3c9b207604e = 'parent';
const $73833826f449bc44$export$289917d9a7031e1d = 'watches';
const $73833826f449bc44$export$72a5630aa398d6b4 = 'security';
const $73833826f449bc44$export$caf1ff54fbdf44bf = 'issuerestriction';
const $73833826f449bc44$export$f8f7545d2bb78afb = 'assignee';
const $73833826f449bc44$export$6d7021166edc895c = 'reporter';
const $73833826f449bc44$export$cf7e173386d30cdd = 'duedate';
const $73833826f449bc44$export$bb34f3538ba26c7e = 'priority';
const $73833826f449bc44$export$79b91d4669dcadcb = 'labels';
const $73833826f449bc44$export$cbedbfe2cd0caec7 = 'components';
const $73833826f449bc44$export$a316570a0dbfd2b0 = 'sprint';
const $73833826f449bc44$export$405b6d72f2d243a9 = 'storyPointsField';
const $73833826f449bc44$export$3cb4a99a332e4186 = 'epic';
const $73833826f449bc44$export$d7e18f5730074533 = 'fixVersions';
const $73833826f449bc44$export$c435f0000304e508 = 'versions';
const $73833826f449bc44$export$ee99ef6ee562a446 = 'timetracking';
const $73833826f449bc44$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $73833826f449bc44$export$e50006273435e7d4 = 'status';
const $73833826f449bc44$export$ff39ebd4bb12b718 = 'created';
const $73833826f449bc44$export$cd8e68094cb5c3cb = 'updated';
const $73833826f449bc44$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $73833826f449bc44$export$913055729e1380b2 = 'summary';
const $73833826f449bc44$export$d44826c816b5619b = 'description';
const $73833826f449bc44$export$a29989082612d0d9 = 'comment';
const $73833826f449bc44$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $73833826f449bc44$export$3b3d0889022c85b3 = 'children-issues';
const $73833826f449bc44$export$be46596bc6608f3b = 'environment';
const $73833826f449bc44$export$f528fadbfdb3c25e = 'subtasks';
const $73833826f449bc44$export$f10e53e8928b61bd = 'dataclassification';
const $73833826f449bc44$export$e0dfb65d1047c53c = (0, $cDMQE.PARENT_CF_TYPE);
const $73833826f449bc44$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $73833826f449bc44$export$826d657005bbe54c = (0, $cDMQE.SELECT_CF_TYPE);
const $73833826f449bc44$export$cdbd1eb3b05729e0 = 'flagActions';
const $73833826f449bc44$export$c161a774ec2e7e56 = 'cardCoverActions';
const $73833826f449bc44$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$73833826f449bc44$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$73833826f449bc44$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$73833826f449bc44$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $cDMQE.TEAM_CF_TYPE)]: (0, $cDMQE.TEAM_CF_TYPE),
        [(0, $cDMQE.PARENT_CF_TYPE)]: (0, $cDMQE.PARENT_CF_TYPE),
        [(0, $cDMQE.BASELINE_START_CF_TYPE)]: (0, $cDMQE.BASELINE_START_CF_TYPE),
        [(0, $cDMQE.BASELINE_END_CF_TYPE)]: (0, $cDMQE.BASELINE_END_CF_TYPE),
        [(0, $cDMQE.COLOR_CF_TYPE)]: (0, $cDMQE.COLOR_CF_TYPE),
        [(0, $cDMQE.EPIC_COLOR_TYPE)]: (0, $cDMQE.EPIC_COLOR_TYPE),
        [(0, $cDMQE.EPIC_NAME_TYPE)]: (0, $cDMQE.EPIC_NAME_TYPE)
    };
    return fields;
};
const $73833826f449bc44$export$87934b3672715c91 = [
    (0, $cDMQE.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $cDMQE.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $cDMQE.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $cDMQE.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $cDMQE.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $73833826f449bc44$var$serviceDeskCustomFields = [
    (0, $cDMQE.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $cDMQE.ORGANIZATIONS_CF_TYPE),
    (0, $cDMQE.REQUEST_LANGUAGE_CF_TYPE),
    (0, $cDMQE.REQUEST_FEEDBACK_CF_TYPE),
    (0, $cDMQE.APPROVALS_CF_TYPE),
    (0, $cDMQE.APPROVERS_LIST_CF_TYPE),
    (0, $cDMQE.REQUEST_TYPE_CF_TYPE),
    (0, $cDMQE.CMDB_OBJECT_CF_TYPE),
    (0, $cDMQE.RESPONDERS_CF_TYPE),
    (0, $cDMQE.MAJOR_INCIDENT_CF_TYPE),
    (0, $cDMQE.ENTITLEMENT_CF_TYPE),
    (0, $cDMQE.SENTIMENT_CF_TYPE),
    (0, $cDMQE.ORGANIZATION_CF_TYPE)
];
const $73833826f449bc44$export$efd443bccc4c01ed = ()=>[
        (0, $cDMQE.LABELS_CF_TYPE),
        (0, $cDMQE.TEXT_CF_TYPE),
        (0, $cDMQE.MULTI_USER_CF_TYPE),
        (0, $cDMQE.PARTICIPANTS_CF_TYPE),
        (0, $cDMQE.URL_CF_TYPE),
        (0, $cDMQE.NUMBER_CF_TYPE),
        (0, $cDMQE.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $cDMQE.SELECT_CF_TYPE),
        (0, $cDMQE.MULTI_SELECT_CF_TYPE),
        (0, $cDMQE.VERSION_CF_TYPE),
        (0, $cDMQE.TEXT_AREA_CF_TYPE),
        (0, $cDMQE.MULTI_VERSION_CF_TYPE),
        (0, $cDMQE.DATE_CF_TYPE),
        (0, $cDMQE.GROUP_CF_TYPE),
        (0, $cDMQE.MULTI_GROUP_CF_TYPE),
        (0, $cDMQE.USER_CF_TYPE),
        (0, $cDMQE.MULTI_CHECKBOXES_CF_TYPE),
        (0, $cDMQE.RADIO_BUTTONS_CF_TYPE),
        (0, $cDMQE.DATETIME_CF_TYPE),
        (0, $cDMQE.SERVICE_ENTITY_CF_TYPE),
        (0, $cDMQE.PEOPLE_CF_TYPE),
        (0, $cDMQE.CASCADING_SELECT_CF_TYPE),
        (0, $cDMQE.PROJECT_PICKER_CF_TYPE),
        (0, $cDMQE.TEAMS_PLATFORM_CF_TYPE),
        (0, $cDMQE.READ_ONLY_CF_TYPE),
        (0, $cDMQE.EPIC_STATUS_TYPE),
        (0, $cDMQE.MESSAGE_VIEW_CF_TYPE),
        (0, $cDMQE.MESSAGE_EDIT_CF_TYPE),
        (0, $cDMQE.CATEGORY_TYPE),
        (0, $cDMQE.GOALS_CF_TYPE),
        (0, $cDMQE.ATLAS_PROJECT_CF_TYPE),
        ...$73833826f449bc44$export$87934b3672715c91,
        ...$73833826f449bc44$var$serviceDeskCustomFields,
        ...(0, $i860n.fg)('frontier-formula-field-d2-d3') ? [
            (0, $cDMQE.FORMULA_NUMBER_CF_TYPE),
            (0, $cDMQE.FORMULA_DATE_CF_TYPE),
            (0, $cDMQE.FORMULA_TEXT_CF_TYPE)
        ] : []
    ];
const $73833826f449bc44$export$a18b3a656ee9c709 = {
    [(0, $f99M0.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $f99M0.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $f99M0.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $73833826f449bc44$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $73833826f449bc44$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $8tYi8.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $73833826f449bc44$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $8tYi8.default).SOFTWARE_ISSUE,
        issueActions: [
            $73833826f449bc44$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $73833826f449bc44$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $8tYi8.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $73833826f449bc44$export$cdbd1eb3b05729e0,
            $73833826f449bc44$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $73833826f449bc44$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $8tYi8.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $73833826f449bc44$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $73833826f449bc44$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $8tYi8.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $73833826f449bc44$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $8tYi8.default).MOBILE_ISSUE,
        issueActions: []
    });
const $73833826f449bc44$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $8tYi8.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $73833826f449bc44$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $8tYi8.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $73833826f449bc44$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $f99M0.SOFTWARE_PROJECT:
            if (config.isSimplified) return $73833826f449bc44$export$aebf676dfa727a1c();
            return $73833826f449bc44$export$27e0678365e5dcff();
        case 0, $f99M0.CORE_PROJECT:
            return $73833826f449bc44$export$381ce08838c53afa();
        case 0, $f99M0.SERVICE_DESK_PROJECT:
            return $73833826f449bc44$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $73833826f449bc44$export$27e0678365e5dcff();
    }
    return $73833826f449bc44$export$27e0678365e5dcff();
};

});

/* eslint-disable jira/filename-case */ const $1771eb0e641090af$export$53d41ff2666118e1 = 'agility-backlog';
const $1771eb0e641090af$export$7552fe2669628499 = 'bitbucket-issue';
const $1771eb0e641090af$export$41a718da0a8636f4 = 'connect-issue';
const $1771eb0e641090af$export$cebf0bc8b2ccaf57 = 'core-issue';
const $1771eb0e641090af$export$f154708d773ba5a0 = 'jira-board';
const $1771eb0e641090af$export$5e91e17726e54450 = 'jiraCalendar';
const $1771eb0e641090af$export$2dac1950892123f5 = 'jiraTimeline';
const $1771eb0e641090af$export$82540942fb014b0a = 'business-calendar';
const $1771eb0e641090af$export$7ca28938a07e0c33 = 'business-list';
const $1771eb0e641090af$export$f6cf06aaaeb58a54 = 'business-timeline';
const $1771eb0e641090af$export$b2c0462ff17aa26e = 'business-board';
const $1771eb0e641090af$export$a607850ebccd28ac = 'business-approvals';
const $1771eb0e641090af$export$1da6cede3561048f = 'business-files';
const $1771eb0e641090af$export$b19f949fb9713614 = 'full-issue';
const $1771eb0e641090af$export$c3899e01aa51a88e = 'jsm-full-issue';
const $1771eb0e641090af$export$a5132300c5214280 = 'embed-issue';
const $1771eb0e641090af$export$36d32bfbadaf29fb = 'work-item-view';
const $1771eb0e641090af$export$710114090a811b37 = 'global-issue-navigator-issue';
const $1771eb0e641090af$export$ce88447986394f2d = 'mobile-issue';
const $1771eb0e641090af$export$6a90d9196d330040 = 'project-issue-navigator';
const $1771eb0e641090af$export$2247c9059c171db1 = 'roadmap-issue';
const $1771eb0e641090af$export$cd16d39c55c569d0 = 'simple-software-board';
const $1771eb0e641090af$export$f72626bf0d75dfad = 'software-backlog-issue';
const $1771eb0e641090af$export$778b4609e784cb27 = 'software-deployments-issue';
const $1771eb0e641090af$export$5b73d694a6048002 = 'version-detail-issue';
const $1771eb0e641090af$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $1771eb0e641090af$export$21b5b7189add7861 = 'software-incidents-issue';
const $1771eb0e641090af$export$9c5d81b901471b27 = 'software-issue';
const $1771eb0e641090af$export$1735f6ad917dc411 = 'change-calendar';
const $1771eb0e641090af$export$7063ee6d0035a982 = 'queues-issue-view';
const $1771eb0e641090af$export$e3ab9da1dcf8e2ba = 'live-chat-issue-view';
const $1771eb0e641090af$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $1771eb0e641090af$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $1771eb0e641090af$export$14a8072f422804fd = 'issue-navigator-next';
const $1771eb0e641090af$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $1771eb0e641090af$export$9dac02c804d7acd8 = 'classic-software-board';
const $1771eb0e641090af$export$d6a617b7cd271a10 = 'jira-home-recommended';
const $1771eb0e641090af$export$49d57bef9ac2550b = 'global-issue-create';
const $1771eb0e641090af$export$9aea6bdc77a1b448 = 'csm-live-conversation-issue-view';
const $1771eb0e641090af$export$887083471231a492 = 'ham-work-items';
const $1771eb0e641090af$export$74b1da58ccd0577f = 'agents-watchtower';

parcelRegister("3hAiL", function(module, exports) {
$parcel$export(module.exports, "pushToActionBuffer", () => $d85d7c01e83afb46$export$e925300cb151e2da);
$parcel$export(module.exports, "createSelectorWithLogging", () => $d85d7c01e83afb46$export$96ac73d7ff1ea279);

var $a7e1f = parcelRequire("a7e1f");

var $6CfY5 = parcelRequire("6CfY5");

var $gXtG2 = parcelRequire("gXtG2");
const $d85d7c01e83afb46$var$LOG_LOCATION = 'issue.selectors.createSelectorWithLogging';
// Action buffer for tracking recent actions to help debug selector errors
const $d85d7c01e83afb46$var$actionBuffer = [];
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $d85d7c01e83afb46$var$actionBuffer.length = 0;
});
const $d85d7c01e83afb46$var$MAX_ACTION_BUFFER_SIZE = 50;
const $d85d7c01e83afb46$export$e925300cb151e2da = (type)=>{
    if ($d85d7c01e83afb46$var$actionBuffer.length >= $d85d7c01e83afb46$var$MAX_ACTION_BUFFER_SIZE) $d85d7c01e83afb46$var$actionBuffer.shift();
    const timestamp = new Date().toISOString();
    $d85d7c01e83afb46$var$actionBuffer.push(`${timestamp} ${type}`);
};
const $d85d7c01e83afb46$export$3625310769768812 = ()=>$d85d7c01e83afb46$var$actionBuffer;
function $d85d7c01e83afb46$export$96ac73d7ff1ea279(// note:-createSelector has overloaded types, I am using the one we need for locale selector, We can change it if we need to use this wrapper universally.
inputSelector, resultFunc) {
    const selector = (0, $a7e1f.createSelector)(inputSelector, resultFunc);
    return (state)=>{
        try {
            return selector(state);
        } catch (error) {
            const recentActions = $d85d7c01e83afb46$export$3625310769768812();
            const errorMessage = error instanceof Error ? error.message : String(error);
            const actionBufferSummary = recentActions.length > 0 ? recentActions.join('; ') : '';
            (0, $6CfY5.default).safeErrorWithoutCustomerData($d85d7c01e83afb46$var$LOG_LOCATION, errorMessage, {
                errorMessage: errorMessage,
                actionBufferSummary: actionBufferSummary,
                selectorError: true
            });
            throw error;
        }
    };
}

});


parcelRegister("jGZAV", function(module, exports) {
$parcel$export(module.exports, "useUserHasAddProductPermissions", () => $d29fdae62b70d67a$export$d223ceb381c5cc91);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $d8LhJ = parcelRequire("d8LhJ");

var $kt86l = parcelRequire("kt86l");

var $iXN50 = parcelRequire("iXN50");

var $ccEzE = parcelRequire("ccEzE");
const $d29fdae62b70d67a$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY = 'confluence-add-product-permission';
const $d29fdae62b70d67a$export$8e35886de8a54f45 = ()=>{
    const localStorageProvider = (0, $iXN50.createLocalExpirableStorageProvider)('placeholderTemplateAddProductPermissionStorage');
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const getLocalStorage = ()=>localStorageProvider.get($d29fdae62b70d67a$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY);
    const LOCAL_STORAGE_EXPIRY_MS = 86400000; // one day
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const setLocalStorage = (value)=>// @browser-storage setter
        localStorageProvider.set($d29fdae62b70d67a$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY, value, Date.now() + LOCAL_STORAGE_EXPIRY_MS);
    return {
        getLocalStorage: getLocalStorage,
        setLocalStorage: setLocalStorage
    };
};
const $d29fdae62b70d67a$export$d223ceb381c5cc91 = (t0)=>{
    const $ = (0, $e7boj.c)(10);
    const { skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    const cloudId = (0, $kt86l.useCloudId)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = $d29fdae62b70d67a$export$8e35886de8a54f45();
        $[0] = t2;
    } else t2 = $[0];
    const { getLocalStorage: getLocalStorage, setLocalStorage: setLocalStorage } = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = getLocalStorage();
        $[1] = t3;
    } else t3 = $[1];
    const cachedStatus = t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = cachedStatus || {
            canProvisionConfluenceEndUser: false,
            fetchStatus: "pending"
        };
        $[2] = t4;
    } else t4 = $[2];
    const initialStatus = t4;
    const [status, setStatus] = (0, $euxye.useState)(initialStatus);
    let t5;
    if ($[3] !== appEditions.software) {
        t5 = async ()=>{
            try {
                const newStatus = {
                    canProvisionConfluenceEndUser: appEditions.software === (0, $d8LhJ.FREE_EDITION),
                    fetchStatus: "resolved"
                };
                setStatus(newStatus);
                setLocalStorage(newStatus);
            } catch (t6) {
                const error = t6;
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: $d29fdae62b70d67a$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY,
                        packageName: "jiraIssueViewBase",
                        teamName: "starburst"
                    },
                    error: new Error(`Failed to get ${$d29fdae62b70d67a$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY} status: ${error}`)
                });
                const errorStatus = {
                    canProvisionConfluenceEndUser: false,
                    fetchStatus: "failed"
                };
                setStatus(errorStatus);
                setLocalStorage(errorStatus);
            }
        };
        $[3] = appEditions.software;
        $[4] = t5;
    } else t5 = $[4];
    const handleFetchPermissions = t5;
    let t6;
    let t7;
    if ($[5] !== cloudId || $[6] !== handleFetchPermissions || $[7] !== skip) {
        t6 = ()=>{
            if (!skip && cloudId && !cachedStatus) handleFetchPermissions();
        };
        t7 = [
            cloudId,
            skip,
            cachedStatus,
            handleFetchPermissions
        ];
        $[5] = cloudId;
        $[6] = handleFetchPermissions;
        $[7] = skip;
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    (0, $euxye.useEffect)(t6, t7);
    return status;
};

});

parcelRegister("dSYlf", function(module, exports) {
$parcel$export(module.exports, "useIsOrgAdmin", () => $ea7731c1e0f6e15a$export$8ed42372757d8b2a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $5pyRb = parcelRequire("5pyRb");

var $6zTYs = parcelRequire("6zTYs");

var $h2wCv = parcelRequire("h2wCv");

var $3GN2r = parcelRequire("3GN2r");
const $ea7731c1e0f6e15a$var$getUserOrgPermissions = async ({ orgId: orgId, userId: userId })=>(0, $h2wCv.performPostRequest)('/gateway/api/permissions/permitted', {
        body: JSON.stringify({
            resourceId: `ari:cloud:platform::org/${orgId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage-users'
        })
    }).then((resp)=>!!resp?.permitted);
const $ea7731c1e0f6e15a$export$8ed42372757d8b2a = ()=>{
    const userId = (0, $3GN2r.useAccountId)();
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const checkUserIsOrgAdmin = (0, $euxye.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        return $ea7731c1e0f6e15a$var$getUserOrgPermissions({
            orgId: orgId,
            userId: userId
        });
    }, [
        orgId,
        userId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchIsOrgAdmin } = (0, $5pyRb.useService)(checkUserIsOrgAdmin, {
        data: false
    });
    (0, $euxye.useEffect)(()=>{
        fetchIsOrgAdmin();
    }, [
        fetchIsOrgAdmin
    ]);
    (0, $euxye.useEffect)(()=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'checkUserIsOrgAdmin',
                packageName: 'jiraBusinessGoalPicker',
                teamName: 'jira-cosmos'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: error
        });
    }, [
        error
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error,
        retry: fetchIsOrgAdmin
    };
};

});

parcelRegister("33SjG", function(module, exports) {
$parcel$export(module.exports, "usePrevious", () => $16dde21f554ca6e2$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $16dde21f554ca6e2$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $16dde21f554ca6e2$export$23fbbb2e62c4a911);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $16dde21f554ca6e2$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $euxye.useRef)();
    (0, $euxye.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $16dde21f554ca6e2$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $euxye.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $16dde21f554ca6e2$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $euxye.useRef)(value);
    (0, $euxye.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("5rZe5", function(module, exports) {
$parcel$export(module.exports, "useLicensedProducts", () => $c4f414ca3f71b058$export$54d534cc91e54850);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $c4f414ca3f71b058$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("cp8vl", function(module, exports) {
$parcel$export(module.exports, "useAreProductSuggestionsEnabled", () => $3b3719504a20f462$export$3fb3b8b7f13e1089);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $3b3719504a20f462$export$3fb3b8b7f13e1089 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.areProductSuggestionsEnabled || false;
};

});


parcelRegister("5OpEj", function(module, exports) {
$parcel$export(module.exports, "getOnboardingParams", () => $997b296e7b4ef6bc$export$e7ff252d67c56b90);
/* eslint-disable jira/filename-case */ 
var $gDpzL = parcelRequire("gDpzL");
const $997b296e7b4ef6bc$export$296e41ed2dc54bb0 = ()=>{
    const teamType = (0, $gDpzL.get)('teamType');
    if (!teamType || typeof teamType.value !== 'string') return null;
    return teamType.value;
};
const $997b296e7b4ef6bc$export$e7ff252d67c56b90 = ()=>({
        teamType: $997b296e7b4ef6bc$export$296e41ed2dc54bb0()
    });

});
parcelRegister("gDpzL", function(module, exports) {
$parcel$export(module.exports, "set", () => $6dd10651bf1bdcdd$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "get", () => $6dd10651bf1bdcdd$export$3988ae62b71be9a3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $iXN50 = parcelRequire("iXN50");
const $6dd10651bf1bdcdd$var$getStore = (0, $emCaV.default)(()=>(0, $iXN50.createLocalExpirableStorageProvider)('onboarding'));
const $6dd10651bf1bdcdd$var$ONE_WEEK_IN_MS = 604800000;
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $6dd10651bf1bdcdd$var$createStoredItem = (value, accessedAt)=>({
        value: value,
        accessedAt: accessedAt ?? null
    });
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $6dd10651bf1bdcdd$var$isItemValid = (item)=>typeof item === 'object' && !Array.isArray(item) && item !== null && 'value' in item && 'accessedAt' in item;
const $6dd10651bf1bdcdd$export$adaa4cf7ef1b65be = (key, value)=>{
    const store = $6dd10651bf1bdcdd$var$getStore();
    const serializedValue = JSON.stringify($6dd10651bf1bdcdd$var$createStoredItem(value));
    const expirationTime = Date.now() + $6dd10651bf1bdcdd$var$ONE_WEEK_IN_MS;
    // @browser-storage setter
    store.set(key, serializedValue, expirationTime);
};
const $6dd10651bf1bdcdd$export$3988ae62b71be9a3 = (key)=>{
    const store = $6dd10651bf1bdcdd$var$getStore();
    const item = store.get(key);
    try {
        const parsed = item && JSON.parse(item);
        if ($6dd10651bf1bdcdd$var$isItemValid(parsed)) {
            const serializedValue = JSON.stringify($6dd10651bf1bdcdd$var$createStoredItem(parsed.value, Date.now()));
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const currentExpiration = store?.getExpiration(key);
            if (currentExpiration) // @browser-storage setter
            store.set(key, serializedValue, currentExpiration);
            else {
                const expirationTime = Date.now() + $6dd10651bf1bdcdd$var$ONE_WEEK_IN_MS;
                // @browser-storage setter
                store.set(key, serializedValue, expirationTime);
            }
            return parsed;
        }
        return null;
    } catch  {
        return null;
    }
};

});



parcelRegister("g5XnQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iJru9").then(()=>parcelRequire('3UnWX'));

});

parcelRegister("3rNG8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("gCScl"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bQ6gw")
]).then(()=>parcelRequire('aJpc9'));

});



parcelRegister("ihd7R", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRouteEntry", () => $2c3d04a9f129e196$export$db3a99044f906462);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $8BwSt = parcelRequire("8BwSt");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $fOATF = parcelRequire("fOATF");

var $klz7A = parcelRequire("klz7A");
const $2c3d04a9f129e196$export$db3a99044f906462 = (0, $fdS54.createEntry)((0, $8BwSt.projectSettingsServicedeskLanguageKeyRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.translations',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $klz7A.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $fOATF.languageTranslationsResource),
            (0, $fOATF.outgoingEmailStateModelResource)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).LANGUAGE_SETTINGS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).LANGUAGE_SETTINGS),
                teamName: 'jsm-banana'
            }
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $klz7A.LazyProjectSettingsServiceDeskLanguageTranslations)
        ],
        perfMetricKey: 'jsm-language-translations',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8BwSt", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRoute", () => $0f27a3c8383059a8$export$194a3f27b07aafec);
const $0f27a3c8383059a8$export$194a3f27b07aafec = {
    name: 'project-settings-servicedesk-language-key',
    path: '/jira/servicedesk/projects/:projectKey/settings/language/:languageKey/:sidebarItemKey?'
};

});

parcelRegister("fOATF", function(module, exports) {
$parcel$export(module.exports, "languageTranslationsResource", () => $4c7a4d0ceba3fc61$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $4c7a4d0ceba3fc61$export$c460156a7e6b85b2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $4c7a4d0ceba3fc61$export$9f529be3aeae01ea = 'JSM Language Translations';
const $4c7a4d0ceba3fc61$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $4c7a4d0ceba3fc61$export$f51887e33895eab9 = (0, $7edbf.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$4c7a4d0ceba3fc61$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("ijg1y")),
    maxAge: Infinity
});

const $4c7a4d0ceba3fc61$export$c460156a7e6b85b2 = (0, $7edbf.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$4c7a4d0ceba3fc61$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("hdiAp")),
    maxAge: Infinity
});

});
parcelRegister("ijg1y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eJmkP").then(()=>parcelRequire('3XvlE'));

});

parcelRegister("hdiAp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3vwrZ").then(()=>parcelRequire('7JSIu'));

});


parcelRegister("klz7A", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskLanguageTranslations", () => $b267312bb9f62d87$export$c029d3f514c7b3e0);
$parcel$export(module.exports, "default", () => $b267312bb9f62d87$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $b267312bb9f62d87$export$c029d3f514c7b3e0 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("fpcsT")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-language-translations/src/WithRouterServiceDeskLanguageTranslationsPage.tsx"
});
const $b267312bb9f62d87$var$AsyncProjectSettingsServiceDeskLanguageTranslations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $b267312bb9f62d87$export$c029d3f514c7b3e0,
        pageId: "project-settings-language-translations",
        shouldShowSpinner: true
    });
$b267312bb9f62d87$var$AsyncProjectSettingsServiceDeskLanguageTranslations.displayName = "AsyncProjectSettingsServiceDeskLanguageTranslations";
var $b267312bb9f62d87$export$2e2bcd8739ae039 = $b267312bb9f62d87$var$AsyncProjectSettingsServiceDeskLanguageTranslations;

});
parcelRegister("fpcsT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("fhbWX")
]).then(()=>parcelRequire('bXNbD'));

});



parcelRegister("gFWMW", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLanguageRouteEntry", () => $91e71896538f33f4$export$576b048795cbefad);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $kdfJa = parcelRequire("kdfJa");

var $74h93 = parcelRequire("74h93");

var $4OlvQ = parcelRequire("4OlvQ");

var $klz7A = parcelRequire("klz7A");
const $91e71896538f33f4$export$576b048795cbefad = (0, $fdS54.createEntry)((0, $kdfJa.projectSettingsServicedeskLanguageRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.languages',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4OlvQ.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $klz7A.LazyProjectSettingsServiceDeskLanguageTranslations)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kdfJa", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLanguageRoute", () => $f19fcd347f12d686$export$99b0bbae92462ac2);
const $f19fcd347f12d686$export$99b0bbae92462ac2 = {
    name: 'project-settings-servicedesk-language',
    path: '/jira/servicedesk/projects/:projectKey/settings/language',
    exact: true
};

});

parcelRegister("4OlvQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4155d5c351ed5448$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4155d5c351ed5448$export$213b8279037c9d98 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("kuTy6"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-language-support/src/ExportedDefault.tsx"
});
const $4155d5c351ed5448$var$AsyncProjectSettingsServiceDeskLanguageSupport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4155d5c351ed5448$export$213b8279037c9d98,
        pageId: "project-settings-language-support",
        shouldShowSpinner: true
    });
$4155d5c351ed5448$var$AsyncProjectSettingsServiceDeskLanguageSupport.displayName = "AsyncProjectSettingsServiceDeskLanguageSupport";
var $4155d5c351ed5448$export$2e2bcd8739ae039 = $4155d5c351ed5448$var$AsyncProjectSettingsServiceDeskLanguageSupport;

});
parcelRegister("kuTy6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fakD").then(()=>parcelRequire('igWDm'));

});



parcelRegister("dPuQX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry", () => $c96aaf5d1dd5bb41$export$dd52be928c274980);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $bVSTJ = parcelRequire("bVSTJ");

var $74h93 = parcelRequire("74h93");

var $f49qa = parcelRequire("f49qa");
const $c96aaf5d1dd5bb41$export$dd52be928c274980 = (0, $fdS54.createEntry)((0, $bVSTJ.projectSettingsServicedeskLegacyAutomationRedirectCopyRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $f49qa.automationRedirect)('copy'),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bVSTJ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRoute", () => $f85ff3022f6b8ceb$export$869afe63d0e077be);
const $f85ff3022f6b8ceb$export$869afe63d0e077be = {
    name: 'project-settings-servicedesk-automation-redirect-copy',
    path: '/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("f49qa", function(module, exports) {
$parcel$export(module.exports, "automationRedirect", () => $0f968f1f3ff4c2c5$export$d6674bfa636b8090);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3Sl5Y = parcelRequire("3Sl5Y");

var $f99M0 = parcelRequire("f99M0");

var $gNbXR = parcelRequire("gNbXR");
// uses empty string instead of actual baseUrl as router redirect handles it internally
const $0f968f1f3ff4c2c5$var$newAutomationUrl = ({ match: match }, pageType)=>{
    const { projectKey: projectKey } = match.params;
    if (pageType === 'edit') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $3Sl5Y.getNextgenSettingsUrl)((0, $f99M0.SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
    }
    if (pageType === 'copy') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $3Sl5Y.getNextgenSettingsUrl)((0, $f99M0.SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
    }
    if (pageType === 'viewlog') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $3Sl5Y.getNextgenSettingsUrl)((0, $f99M0.SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
    }
    if (pageType === 'create') {
        const { blueprintKey: blueprintKey } = match.params;
        return `${(0, $3Sl5Y.getNextgenSettingsUrl)((0, $f99M0.SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
    }
    return `${(0, $3Sl5Y.getNextgenSettingsUrl)((0, $f99M0.SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
};
const $0f968f1f3ff4c2c5$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: $0f968f1f3ff4c2c5$var$newAutomationUrl(routeContext, pageType),
            push: false
        });
    };

});


parcelRegister("bRLRA", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry", () => $e5c1769b40bb5c3b$export$fc7d1f3302418153);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $58uil = parcelRequire("58uil");

var $74h93 = parcelRequire("74h93");

var $f49qa = parcelRequire("f49qa");
const $e5c1769b40bb5c3b$export$fc7d1f3302418153 = (0, $fdS54.createEntry)((0, $58uil.projectSettingsServicedeskLegacyAutomationRedirectCreateRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $f49qa.automationRedirect)('create'),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("58uil", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRoute", () => $bd8f6484ca4d1e2f$export$c2a59dbe6d23efd4);
const $bd8f6484ca4d1e2f$export$c2a59dbe6d23efd4 = {
    name: 'project-settings-servicedesk-automation-redirect-create',
    path: '/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});


parcelRegister("04hqt", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry", () => $0021ff5fa0ad11e9$export$cf95450a3eafe8ff);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $5pYFg = parcelRequire("5pYFg");

var $74h93 = parcelRequire("74h93");

var $f49qa = parcelRequire("f49qa");
const $0021ff5fa0ad11e9$export$cf95450a3eafe8ff = (0, $fdS54.createEntry)((0, $5pYFg.projectSettingsServicedeskLegacyAutomationRedirectEditRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $f49qa.automationRedirect)('edit'),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5pYFg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRoute", () => $bbb4dfeab65a9fd1$export$f61e79c14e9bc0a1);
const $bbb4dfeab65a9fd1$export$f61e79c14e9bc0a1 = {
    name: 'project-settings-servicedesk-automation-redirect-edit',
    path: '/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});


parcelRegister("loWOs", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry", () => $26e1cac876924257$export$d6873ef17e5a0ea5);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $iW9HF = parcelRequire("iW9HF");

var $74h93 = parcelRequire("74h93");

var $f49qa = parcelRequire("f49qa");
const $26e1cac876924257$export$d6873ef17e5a0ea5 = (0, $fdS54.createEntry)((0, $iW9HF.projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $f49qa.automationRedirect)('summary'),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iW9HF", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute", () => $adc6df29933f48ea$export$fdd432d4e600f9);
const $adc6df29933f48ea$export$fdd432d4e600f9 = {
    name: 'project-settings-servicedesk-automation-redirect-summary',
    path: '/projects/:projectKey/settings/automation/'
};

});


parcelRegister("i4KDV", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry", () => $f015ba56ee5899ba$export$f0eaafcdee9dfa31);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $fdS54 = parcelRequire("fdS54");

var $4VfZ3 = parcelRequire("4VfZ3");

var $74h93 = parcelRequire("74h93");

var $f49qa = parcelRequire("f49qa");
const $f015ba56ee5899ba$export$f0eaafcdee9dfa31 = (0, $fdS54.createEntry)((0, $4VfZ3.projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $f49qa.automationRedirect)('viewlog'),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4VfZ3", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute", () => $00b75af71939f507$export$e6e772830a33ba0b);
const $00b75af71939f507$export$e6e772830a33ba0b = {
    name: 'project-settings-servicedesk-automation-redirect-viewlog',
    path: '/projects/:projectKey/settings/automation/log/:ruleId'
};

});


parcelRegister("f8zsk", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLiveChatRouteEntry", () => $a9755e349ab61536$export$a1fd70ead2d0e01a);
/* eslint-disable import/order */ 
var $81yeh = parcelRequire("81yeh");

var $h0W3N = parcelRequire("h0W3N");



var $6RSCO = parcelRequire("6RSCO");

var $dTa0V = parcelRequire("dTa0V");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $jMjjm = parcelRequire("jMjjm");
const $a9755e349ab61536$var$projectSettingsServiceDeskLiveChatPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $81yeh.serviceDeskLiveChatEntryPoint)
});
const $a9755e349ab61536$export$a1fd70ead2d0e01a = (0, $fdS54.createEntry)((0, $h0W3N.projectSettingsServicedeskLiveChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jMjjm.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $t7VsO.servicedeskIssueTypesResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jMjjm.LazyProjectSettingsServiceDeskLiveChat)
        ],
        entryPoint () {
            return (0, $i860n.fg)('live-chat-admin-settings') ? $a9755e349ab61536$var$projectSettingsServiceDeskLiveChatPageEntryPoint : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("81yeh", function(module, exports) {
$parcel$export(module.exports, "serviceDeskLiveChatEntryPoint", () => $2cf584e34300db4d$export$e747716a4e56efb1);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $2cf584e34300db4d$export$e747716a4e56efb1 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("2YGsv")), {
        moduleId: "0e916f00",
        moduleName: "ServiceDeskLiveChatSpa",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2YGsv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fqhfy").then(()=>parcelRequire('g6IGj'));

});


parcelRegister("jMjjm", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskLiveChat", () => $9f750e59d4206491$export$be4e4d279f6c000);
$parcel$export(module.exports, "default", () => $9f750e59d4206491$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9f750e59d4206491$export$be4e4d279f6c000 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2YGsv")), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-live-chat/src/ServiceDeskLiveChatSpa.tsx"
});
const $9f750e59d4206491$var$AsyncProjectSettingsServiceDeskLiveChat = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9f750e59d4206491$export$be4e4d279f6c000,
        pageId: "project-settings-live-chat",
        shouldShowSpinner: true
    });
$9f750e59d4206491$var$AsyncProjectSettingsServiceDeskLiveChat.displayName = "AsyncProjectSettingsServiceDeskLiveChat";
var $9f750e59d4206491$export$2e2bcd8739ae039 = $9f750e59d4206491$var$AsyncProjectSettingsServiceDeskLiveChat;

});


parcelRegister("hZaNO", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry", () => $003b36b46e5d9adb$export$b4d122e49516c10d);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $iCRAQ = parcelRequire("iCRAQ");

var $74h93 = parcelRequire("74h93");

var $jc5Qe = parcelRequire("jc5Qe");

var $4btZt = parcelRequire("4btZt");
const $003b36b46e5d9adb$export$b4d122e49516c10d = (0, $fdS54.createEntry)((0, $iCRAQ.projectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jc5Qe.ServiceDeskCustomerNotificationsNextGenRedirect),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4btZt.LazyProjectSettingsServiceDeskCustomerNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jc5Qe", function(module, exports) {
$parcel$export(module.exports, "ServiceDeskCustomerNotificationsNextGenRedirect", () => $8031786ef9f1c5cd$export$8249a46a710af6da);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $8031786ef9f1c5cd$export$8249a46a710af6da = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: url
    });
};
$8031786ef9f1c5cd$export$8249a46a710af6da.displayName = "ServiceDeskCustomerNotificationsNextGenRedirect";

});


parcelRegister("4mwuU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRouteEntry", () => $fdd42a351cd8b148$export$ec0ead95e321b800);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $3KBxc = parcelRequire("3KBxc");

var $74h93 = parcelRequire("74h93");

var $46KyI = parcelRequire("46KyI");
const $fdd42a351cd8b148$export$ec0ead95e321b800 = (0, $fdS54.createEntry)((0, $3KBxc.projectSettingsServicedeskNotificationsEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $46KyI.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $46KyI.LazyProjectSettingsNotificationEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("46KyI", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $62de8af237fb17d7$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $62de8af237fb17d7$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $62de8af237fb17d7$export$ea7d73c94d9369f4 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("tWUUI"))), {
    moduleId: "./src/packages/spa-apps/project-settings-notification-email/src/ExportedDefault.tsx"
});
const $62de8af237fb17d7$var$AsyncProjectSettingsNotificationEmail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $62de8af237fb17d7$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
$62de8af237fb17d7$var$AsyncProjectSettingsNotificationEmail.displayName = "AsyncProjectSettingsNotificationEmail";
var $62de8af237fb17d7$export$2e2bcd8739ae039 = $62de8af237fb17d7$var$AsyncProjectSettingsNotificationEmail;

});


parcelRegister("7oxJi", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry", () => $e1b757e4e746fde4$export$4a15f2c244cd196c);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ljzmU = parcelRequire("ljzmU");

var $74h93 = parcelRequire("74h93");

var $6Qfer = parcelRequire("6Qfer");

var $e73tt = parcelRequire("e73tt");

var $9UWcf = parcelRequire("9UWcf");
const $e1b757e4e746fde4$export$4a15f2c244cd196c = (0, $fdS54.createEntry)((0, $ljzmU.projectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $e73tt.serviceDeskInternalNotificationsNextGenRedirect),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $9UWcf.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $6Qfer.LazyInternalNotificationSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e73tt", function(module, exports) {
$parcel$export(module.exports, "serviceDeskInternalNotificationsNextGenRedirect", () => $0cf2a9efe0bfc15b$export$49625f83fe7ecc69);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $0cf2a9efe0bfc15b$export$49625f83fe7ecc69 = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: url
    });
};

});


parcelRegister("5kwpg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRouteEntry", () => $31d8fc7fa7d03720$export$cc1164e0e5db595);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ftcBv = parcelRequire("ftcBv");

var $74h93 = parcelRequire("74h93");

var $46KyI = parcelRequire("46KyI");

var $4Ioyq = parcelRequire("4Ioyq");
const $31d8fc7fa7d03720$export$cc1164e0e5db595 = (0, $fdS54.createEntry)((0, $ftcBv.projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4Ioyq.ServiceDeskNotificationEmailNextGenRedirect),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $46KyI.LazyProjectSettingsNotificationEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4Ioyq", function(module, exports) {
$parcel$export(module.exports, "ServiceDeskNotificationEmailNextGenRedirect", () => $5f5d3c81ccac1970$export$735e58642f560ddc);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $5f5d3c81ccac1970$export$735e58642f560ddc = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: url
    });
};
$5f5d3c81ccac1970$export$735e58642f560ddc.displayName = "ServiceDeskNotificationEmailNextGenRedirect";

});


parcelRegister("evIjb", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRouteEntry", () => $3307510988512dcc$export$20923f853e06d781);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $duUlB = parcelRequire("duUlB");

var $74h93 = parcelRequire("74h93");

var $gUBrZ = parcelRequire("gUBrZ");
const $3307510988512dcc$export$20923f853e06d781 = (0, $fdS54.createEntry)((0, $duUlB.projectSettingsServicedeskNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gUBrZ.notificationsRedirect)('customer-notifications'),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("duUlB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRoute", () => $fb24ebd7f46e0562$export$dbc53740e1d7ff79);
const $fb24ebd7f46e0562$export$dbc53740e1d7ff79 = {
    name: 'project-settings-servicedesk-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("gUBrZ", function(module, exports) {
$parcel$export(module.exports, "notificationsRedirect", () => $b6646b5a9f4cb9d6$export$59144dd4441639fa);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3Sl5Y = parcelRequire("3Sl5Y");

var $f99M0 = parcelRequire("f99M0");

var $gNbXR = parcelRequire("gNbXR");
const $b6646b5a9f4cb9d6$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = projectKey !== null && projectKey !== undefined ? `${(0, $3Sl5Y.getNextgenSettingsUrl)((0, $f99M0.SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: url,
            push: false
        });
    };

});


parcelRegister("iX5mh", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskPoliciesRouteEntry", () => $ed6784c1d8ef1fbd$export$fc19c18c136dd15c);



var $k5Kh0 = parcelRequire("k5Kh0");

var $i860n = parcelRequire("i860n");


var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $74h93 = parcelRequire("74h93");

var $iSoIx = parcelRequire("iSoIx");

var $lbxXL = parcelRequire("lbxXL");

var $2FrmZ = parcelRequire("2FrmZ");
const $ed6784c1d8ef1fbd$var$projectSettingsSpacePoliciesPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $k5Kh0.projectSettingsSpacePoliciesEntryPoint)
});
const $ed6784c1d8ef1fbd$export$fc19c18c136dd15c = (0, $fdS54.createEntry)((0, $2FrmZ.projectSettingsServicedeskPoliciesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings.space-policies.jsm-tmp',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        entryPoint: ()=>(0, $i860n.fg)('frontier-guided-autonomy-space-settings') ? $ed6784c1d8ef1fbd$var$projectSettingsSpacePoliciesPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint)
    }));

});

parcelRegister("2gWR9", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRouteEntry", () => $079fa7589fab903f$export$2f07a0943f4553c4);
/* eslint-disable import/order */ 


var $kM0RM = parcelRequire("kM0RM");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $bDLxo = parcelRequire("bDLxo");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $U8Y6P = parcelRequire("U8Y6P");
const $079fa7589fab903f$export$2f07a0943f4553c4 = (0, $fdS54.createEntry)((0, $bDLxo.projectSettingsServicedeskPortalSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $U8Y6P.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $kM0RM.serviceDeskPortalClassicSettingsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $U8Y6P.LazyProjectSettingsServiceDeskClassicPortalSettings)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).PORTAL_SETTINGS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).PORTAL_SETTINGS),
                teamName: 'jsd-shield'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kM0RM", function(module, exports) {
$parcel$export(module.exports, "serviceDeskPortalClassicSettingsResource", () => $fedda0fde04bd1ca$export$2c58fa923657baed);
/* eslint-disable jira/filename-case */ 
var $htsFl = parcelRequire("htsFl");

var $ZbQ7Z = parcelRequire("ZbQ7Z");
const $fedda0fde04bd1ca$export$2c58fa923657baed = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_SERVICE_DESK_PORTAL_CLASSIC_SETTINGS`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $ZbQ7Z.default),
            variables: {
                cloudIdString: cloudId,
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("ZbQ7Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc35981efa2150fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53cace98e7e5b9682ff0361d13302e53>>
 * @relayHash dcdf9e543ea3ac6a59470fd83ad932bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f847bc24c208e18b7fc361ac99b7b0767ec39979f5bd9ee3446f306fddfee00
const $cc35981efa2150fa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdString"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudIdString"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyEditableAgents": true
            }
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ClassicPortalSettingsQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "cloudIdString",
                            "variableName": "cloudIdString"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PortalSettings"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ClassicPortalSettingsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalConfigReference"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "identityAccountId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "creatorType"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "RovoAgent_agentStudio_getAgents",
                    "kind": "LinkedHandle",
                    "name": "agentStudio_getAgents"
                },
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "AtlassianStudioUserProductPermissions",
                                    "kind": "LinkedField",
                                    "name": "userPermissions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAbleToCreateAgents"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianStudioUserSiteContextOutput"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7f847bc24c208e18b7fc361ac99b7b0767ec39979f5bd9ee3446f306fddfee00",
            "metadata": {},
            "name": "ClassicPortalSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cc35981efa2150fa$var$node.hash = "f6bb257b47e1fe1b359c1df932c2a29f";
var $cc35981efa2150fa$export$2e2bcd8739ae039 = $cc35981efa2150fa$var$node;

});


parcelRegister("U8Y6P", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskClassicPortalSettings", () => $16ec9e34fa388825$export$eb662b618d6247be);
$parcel$export(module.exports, "default", () => $16ec9e34fa388825$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $16ec9e34fa388825$export$eb662b618d6247be = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("iD89w"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-classic-portal-settings/src/ClassicPortalSettings.tsx"
});
const $16ec9e34fa388825$var$AsyncProjectSettingsServiceDeskClassicPortalSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $16ec9e34fa388825$export$eb662b618d6247be,
        pageId: "project-settings-classic-portal-settings",
        shouldShowSpinner: true
    });
$16ec9e34fa388825$var$AsyncProjectSettingsServiceDeskClassicPortalSettings.displayName = "AsyncProjectSettingsServiceDeskClassicPortalSettings";
var $16ec9e34fa388825$export$2e2bcd8739ae039 = $16ec9e34fa388825$var$AsyncProjectSettingsServiceDeskClassicPortalSettings;

});
parcelRegister("iD89w", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("2pJ6a")
]).then(()=>parcelRequire('anHJt'));

});



parcelRegister("9xJlI", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProactiveServiceManagementRouteEntry", () => $e4ec6b7fee7a1f16$export$331eea14e6c83a04);

var $97uvA = parcelRequire("97uvA");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $4XS9K = parcelRequire("4XS9K");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $iSoIx = parcelRequire("iSoIx");

var $8HUuJ = parcelRequire("8HUuJ");
const $e4ec6b7fee7a1f16$var$projectSettingsServicedeskProactiveServiceManagementPageEntry = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4XS9K.projectSettingsServicedeskProactiveServiceManagementAppEntryPoint)
});
const $e4ec6b7fee7a1f16$export$331eea14e6c83a04 = (0, $fdS54.createEntry)((0, $97uvA.projectSettingsServicedeskProactiveServiceManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings-servicedesk.proactive-service-management',
        perfMetricKey: 'project-settings-servicedesk.proactive-service-management',
        entryPoint: ()=>{
            return (0, $i860n.fg)('jsm_psm_visible') ? $e4ec6b7fee7a1f16$var$projectSettingsServicedeskProactiveServiceManagementPageEntry : (0, $iSoIx.notFoundPageEntrypoint);
        },
        navigation: {
            menuId: 'PROJECTS',
            sidebarId: 'PROJECT_SETTINGS'
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)().map((resource)=>(0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_psm_visible'), resource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4XS9K", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProactiveServiceManagementAppEntryPoint", () => $6d36bdbbde01ce91$export$3b3e057d7cf7ebc8);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $6d36bdbbde01ce91$export$3b3e057d7cf7ebc8 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9kONU")), {
        moduleId: "2a9b40b1",
        moduleName: "ProjectSettingsServicedeskProactiveServiceManagementApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match } })=>{
        return {
            extraProps: {
                projectKey: String(match.params.projectKey ?? '')
            }
        };
    }
});

});
parcelRegister("9kONU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gLgMC").then(()=>parcelRequire('hHr1g'));

});



parcelRegister("djfrw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRouteEntry", () => $3427dae8053bb44d$export$f7bbe7fb3eeb9258);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $hC68o = parcelRequire("hC68o");

var $74h93 = parcelRequire("74h93");

var $7RQJu = parcelRequire("7RQJu");
const $3427dae8053bb44d$export$f7bbe7fb3eeb9258 = (0, $fdS54.createEntry)((0, $hC68o.projectSettingsServicedeskProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7RQJu.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7RQJu.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hC68o", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRoute", () => $cb857fd56b297467$export$f2a7862c8cde472d);
const $cb857fd56b297467$export$f2a7862c8cde472d = {
    name: 'project-settings-servicedesk-proforma-jira-form-builder',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("7RQJu", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $b3315ccca7a0aa0b$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $b3315ccca7a0aa0b$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $b3315ccca7a0aa0b$export$a7d63246a10aedd = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("lrE2c")), {
    moduleId: "./src/packages/spa-apps/project-settings-proforma-jira-form-builder/src/ProformaJiraFormBuilderPage.tsx"
});
const $b3315ccca7a0aa0b$var$AsyncProjectSettingsProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $b3315ccca7a0aa0b$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
$b3315ccca7a0aa0b$var$AsyncProjectSettingsProformaJiraFormBuilder.displayName = "AsyncProjectSettingsProformaJiraFormBuilder";
var $b3315ccca7a0aa0b$export$2e2bcd8739ae039 = $b3315ccca7a0aa0b$var$AsyncProjectSettingsProformaJiraFormBuilder;

});


parcelRegister("34MGU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRouteEntry", () => $816a5638d8ecbed1$export$f0d9fbaec8a9f2a);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $anfeT = parcelRequire("anfeT");

var $74h93 = parcelRequire("74h93");

var $6ePXq = parcelRequire("6ePXq");
const $816a5638d8ecbed1$export$f0d9fbaec8a9f2a = (0, $fdS54.createEntry)((0, $anfeT.projectSettingsServicedeskProformaProjectFormsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6ePXq.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6ePXq.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6ePXq", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $5760a059edb72378$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $5760a059edb72378$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $5760a059edb72378$export$38414b624a749cec = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("6nXBG")), {
    moduleId: "./src/packages/spa-apps/project-settings-proforma-project-forms/src/ProformaProjectFormsSettingsPage.tsx"
});
const $5760a059edb72378$var$AsyncProjectSettingsProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5760a059edb72378$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
$5760a059edb72378$var$AsyncProjectSettingsProformaProjectForms.displayName = "AsyncProjectSettingsProformaProjectForms";
var $5760a059edb72378$export$2e2bcd8739ae039 = $5760a059edb72378$var$AsyncProjectSettingsProformaProjectForms;

});


parcelRegister("hdSuz", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRedirectRouteEntry", () => $549b7f19895a1a50$export$a0279fafdeb78607);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");


var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $bbbqF = parcelRequire("bbbqF");

var $74h93 = parcelRequire("74h93");

var $5fVMb = parcelRequire("5fVMb");
const $549b7f19895a1a50$export$a0279fafdeb78607 = (0, $fdS54.createEntry)((0, $bbbqF.projectSettingsServicedeskRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5fVMb.defaultRedirectForSettings)((0, $5fVMb.SERVICE_DESK_PRODUCT)),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bbbqF", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRedirectRoute", () => $81c9395952bf75e1$export$3fbe0a89e4d1e816);
const $81c9395952bf75e1$export$3fbe0a89e4d1e816 = {
    name: 'project-settings-servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings'
};

});


parcelRegister("9iB0A", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRovoOpsRouteEntry", () => $c64535c6f1279cb1$export$7c7fe081601d7813);
/* eslint-disable import/order */ 
var $9IEMe = parcelRequire("9IEMe");

var $5RjYW = parcelRequire("5RjYW");

var $6RSCO = parcelRequire("6RSCO");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");
const $c64535c6f1279cb1$var$rovoOpsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9IEMe.rovoOpsSettingsEntryPoint)
});
const $c64535c6f1279cb1$export$7c7fe081601d7813 = (0, $fdS54.createEntry)((0, $5RjYW.projectSettingsServicedeskRovoOpsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-rovo-ops-settings',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: 'PROJECTS',
            sidebarId: 'PROJECT_SETTINGS'
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        perfMetricKey: 'jsm-rovo-ops-settings',
        entryPoint: ()=>$c64535c6f1279cb1$var$rovoOpsPageEntryPoint,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9IEMe", function(module, exports) {
$parcel$export(module.exports, "rovoOpsSettingsEntryPoint", () => $cfd5220a138f6167$export$bf9e4a92a74019ca);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $c6HTc = parcelRequire("c6HTc");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $cfd5220a138f6167$export$bf9e4a92a74019ca = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dsr8y")), {
        moduleId: "e6b759b8",
        moduleName: "ProjectSettingsServiceDeskRovoOpsRovoOpsView",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                rovoOpsComponentQuery: {
                    parameters: $c6HTc.default,
                    variables: {
                        cloudIdString: tenantContext.cloudId,
                        cloudIdID: tenantContext.cloudId,
                        externalReference: 'ops_guide_agent',
                        newRelicDimensionIds: [
                            'ari:cloud:platform::product/newrelic/newrelic'
                        ],
                        dynatraceDimensionIds: [
                            'ari:cloud:platform::product/dynatrace/dynatrace'
                        ],
                        honeycombDimensionIds: [
                            'ari:cloud:platform::product/honeycomb/honeycomb'
                        ]
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("c6HTc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7f6cede4cb37cc5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d1b58898cb24ebb855fc957bbf66f88e>>
 * @relayHash 949330e07ba61fd88576d21e94f119fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b4252c1739ac4fa25f521892d38c5a1592bfc3cd2fa30951ae5a38076f7d4d00
const $b7f6cede4cb37cc5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdID"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdString"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dynatraceDimensionIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalReference"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "honeycombDimensionIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "newRelicDimensionIds"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudIdString"
    }, v7 = [
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "externalReference",
            "variableName": "externalReference"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": v9 /*: any*/ ,
        "type": "AgentStudioAssistant"
    }, v11 = [
        v6 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "scenarioVersion",
            "value": 2
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "definitionId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "tags"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudIdID"
    }, v15 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v16 = {
        "kind": "Literal",
        "name": "relevantFor",
        "value": "MCP_SERVER"
    }, v17 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "dimensionIds",
            "variableName": "newRelicDimensionIds"
        },
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "kind": "InlineFragment",
        "selections": v9 /*: any*/ ,
        "type": "GraphIntegrationMcpServer"
    }, v19 = [
        {
            "concreteType": "GraphIntegrationDirectoryItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ 
                    ]
                }
            ]
        }
    ], v20 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "dimensionIds",
            "variableName": "dynatraceDimensionIds"
        },
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v21 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "dimensionIds",
            "variableName": "honeycombDimensionIds"
        },
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = [
        {
            "concreteType": "GraphIntegrationDirectoryItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v22 /*: any*/ ,
                        v18 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v9 /*: any*/ ,
                            "type": "GraphIntegrationActionDirectoryItem"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v9 /*: any*/ ,
                            "type": "GraphIntegrationMcpTool"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v9 /*: any*/ ,
                            "type": "GraphIntegrationSkillDirectoryItem"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v9 /*: any*/ ,
                            "type": "GraphIntegrationSkillItem"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RovoOpsComponentQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_getByExternalReference",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ 
                    ]
                },
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "AgentStudioToolsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_tools",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioToolEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioTool",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "alias": "rovoOpsNewRelicIntegrationItems",
                    "args": v17 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": v19 /*: any*/ 
                },
                {
                    "alias": "rovoOpsDynatraceIntegrationItems",
                    "args": v20 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": v19 /*: any*/ 
                },
                {
                    "alias": "rovoOpsHoneycombIntegrationItems",
                    "args": v21 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": v19 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RovoOpsComponentQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_getByExternalReference",
                    "plural": false,
                    "selections": [
                        v22 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v9 /*: any*/ ,
                            "type": "Node",
                            "abstractKey": "__isNode"
                        }
                    ]
                },
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "AgentStudioToolsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_tools",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioToolEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioTool",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "alias": "rovoOpsNewRelicIntegrationItems",
                    "args": v17 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": v23 /*: any*/ 
                },
                {
                    "alias": "rovoOpsDynatraceIntegrationItems",
                    "args": v20 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": v23 /*: any*/ 
                },
                {
                    "alias": "rovoOpsHoneycombIntegrationItems",
                    "args": v21 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": v23 /*: any*/ 
                }
            ]
        },
        "params": {
            "id": "b4252c1739ac4fa25f521892d38c5a1592bfc3cd2fa30951ae5a38076f7d4d00",
            "metadata": {},
            "name": "RovoOpsComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b7f6cede4cb37cc5$var$node.hash = "7ac3beefee778215fdbbe8d20c559ffd";
var $b7f6cede4cb37cc5$export$2e2bcd8739ae039 = $b7f6cede4cb37cc5$var$node;

});

parcelRegister("dsr8y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("90nO5").then(()=>parcelRequire('aZ4qC'));

});


parcelRegister("5RjYW", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRovoOpsRoute", () => $9b017d73e68c2f43$export$480534494d967ed0);
const $9b017d73e68c2f43$export$480534494d967ed0 = {
    name: 'project-settings-servicedesk-rovo-ops',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo-ops',
    exact: true
};

});


parcelRegister("iQOGT", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRovoRouteEntry", () => $d1ed47f9bbf86bba$export$93cc09468b864d28);



var $58Owj = parcelRequire("58Owj");

var $iSoIx = parcelRequire("iSoIx");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $lEPfS = parcelRequire("lEPfS");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $870I8 = parcelRequire("870I8");

var $74h93 = parcelRequire("74h93");
const $d1ed47f9bbf86bba$var$servicedeskRovoPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $58Owj.servicedeskRovoEntrypoint)
});
const $d1ed47f9bbf86bba$var$getRovoFeatureResources = ()=>(0, $i860n.fg)('ai_summary_section') ? [
        (0, $lEPfS.featuresResource)
    ] : [];
const $d1ed47f9bbf86bba$export$93cc09468b864d28 = (0, $fdS54.createEntry)((0, $870I8.projectSettingsServicedeskRovoRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-rovo-settings',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint: ()=>((0, $i860n.fg)('enable-esa-jsm-ga') || (0, $i860n.fg)('rovo_agent_self_setup_admin_config_enabled')) && (0, $i860n.fg)('enable-rovo-settings-revamp') ? $d1ed47f9bbf86bba$var$servicedeskRovoPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            ...$d1ed47f9bbf86bba$var$getRovoFeatureResources(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        perfMetricKey: 'jsm-rovo-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("58Owj", function(module, exports) {
$parcel$export(module.exports, "servicedeskRovoEntrypoint", () => $5c1dd4f761cb629a$export$bd9581c642d14d7);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $5c1dd4f761cb629a$export$bd9581c642d14d7 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bkpXO")), {
        moduleId: "199684da",
        moduleName: "RovoView",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bkpXO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Hk2q").then(()=>parcelRequire('eJR1W'));

});


parcelRegister("870I8", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRovoRoute", () => $9408d9363c5e47ef$export$3e8d6037de73a9d);
const $9408d9363c5e47ef$export$3e8d6037de73a9d = {
    name: 'project-settings-servicedesk-rovo',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo',
    exact: true
};

});


parcelRegister("b7Kc2", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRovoServiceAgentRouteEntry", () => $68ce7a1dae0ccb1e$export$9603f70010abac7d);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $lS1Pt = parcelRequire("lS1Pt");

var $74h93 = parcelRequire("74h93");

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $gNbXR = parcelRequire("gNbXR");

var $jqvoi = parcelRequire("jqvoi");
const $68ce7a1dae0ccb1e$var$RovoServiceAgentRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}/settings/rovo`
    });
$68ce7a1dae0ccb1e$var$RovoServiceAgentRedirect.displayName = "RovoServiceAgentRedirect";
const $68ce7a1dae0ccb1e$export$9603f70010abac7d = (0, $fdS54.createEntry)((0, $lS1Pt.projectSettingsServicedeskRovoServiceAgentRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-rovo-service-agent-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: !(0, $i860n.fg)('enable-rovo-settings-revamp') ? (0, $jqvoi.default) : $68ce7a1dae0ccb1e$var$RovoServiceAgentRedirect,
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jqvoi.LazyProjectSettingsServiceDeskRovoServiceAgent)
        ],
        perfMetricKey: 'jsm-rovo-service-agent-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lS1Pt", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRovoServiceAgentRoute", () => $adcfb1c587c6854c$export$1a7cb35d9e086061);
const $adcfb1c587c6854c$export$1a7cb35d9e086061 = {
    name: 'project-settings-servicedesk-rovo-service-agent',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent',
    exact: true
};

});

parcelRegister("jqvoi", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskRovoServiceAgent", () => $7d721da494e48bca$export$aea40d500709e2b5);
$parcel$export(module.exports, "default", () => $7d721da494e48bca$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7d721da494e48bca$export$aea40d500709e2b5 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("iNlee"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-rovo-service-agent/src/RovoServiceAgentView.tsx"
});
const $7d721da494e48bca$var$ServicedeskRovoServiceAgentComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7d721da494e48bca$export$aea40d500709e2b5,
        pageId: "project-settings-rovo-service-agent",
        shouldShowSpinner: true
    });
$7d721da494e48bca$var$ServicedeskRovoServiceAgentComponent.displayName = "ServicedeskRovoServiceAgentComponent";
var $7d721da494e48bca$export$2e2bcd8739ae039 = $7d721da494e48bca$var$ServicedeskRovoServiceAgentComponent;

});
parcelRegister("iNlee", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2THWA").then(()=>parcelRequire('2PwL9'));

});



parcelRegister("e4QbX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRouteEntry", () => $833076b84cc112c8$export$30951c6038a30ec4);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $j0qHc = parcelRequire("j0qHc");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $69X0U = parcelRequire("69X0U");

var $74h93 = parcelRequire("74h93");

var $gGrwR = parcelRequire("gGrwR");
const $833076b84cc112c8$export$30951c6038a30ec4 = (0, $fdS54.createEntry)((0, $69X0U.projectSettingsServicedeskTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gGrwR.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $j0qHc.servicedeskPracticesResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gGrwR.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("69X0U", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRoute", () => $d45613884d3c36b6$export$6c99c477ef7583ba);
const $d45613884d3c36b6$export$6c99c477ef7583ba = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("jEYsQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRouteEntry", () => $f39280c3b869390b$export$bcc0bb7cf7f75a0f);



var $02DIZ = parcelRequire("02DIZ");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $8gns3 = parcelRequire("8gns3");

var $j0qHc = parcelRequire("j0qHc");

var $lEPfS = parcelRequire("lEPfS");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $jEYuY = parcelRequire("jEYuY");

var $5yfEX = parcelRequire("5yfEX");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $dQlMZ = parcelRequire("dQlMZ");
const $f39280c3b869390b$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $02DIZ.TicketTypesConfigEntrypoint)
});
const $f39280c3b869390b$export$bcc0bb7cf7f75a0f = (0, $fdS54.createEntry)((0, $5yfEX.projectSettingsServicedeskTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dQlMZ.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $j0qHc.servicedeskPracticesResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $8gns3.servicedeskPortalGroupsResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $lEPfS.featuresResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dQlMZ.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        entryPoint () {
            return $f39280c3b869390b$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint;
        },
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("5585C", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry", () => $56907a121c8ab3b2$export$515ee5ae44539ca4);



var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $j0qHc = parcelRequire("j0qHc");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $1NsSC = parcelRequire("1NsSC");

var $74h93 = parcelRequire("74h93");

var $gGrwR = parcelRequire("gGrwR");
const $56907a121c8ab3b2$export$515ee5ae44539ca4 = (0, $fdS54.createEntry)((0, $1NsSC.projectSettingsServicedeskUnassignedTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gGrwR.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $j0qHc.servicedeskPracticesResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gGrwR.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1NsSC", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRoute", () => $31fa6e9206b7d5bb$export$f7a986e844a111a6);
const $31fa6e9206b7d5bb$export$f7a986e844a111a6 = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("e2Vn0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry", () => $c109145c0e1785d6$export$6ba31a548ab77c4);



var $02DIZ = parcelRequire("02DIZ");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $8gns3 = parcelRequire("8gns3");

var $j0qHc = parcelRequire("j0qHc");

var $lEPfS = parcelRequire("lEPfS");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $jEYuY = parcelRequire("jEYuY");

var $aPX9C = parcelRequire("aPX9C");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $dQlMZ = parcelRequire("dQlMZ");
const $c109145c0e1785d6$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $02DIZ.TicketTypesConfigEntrypoint)
});
const $c109145c0e1785d6$export$6ba31a548ab77c4 = (0, $fdS54.createEntry)((0, $aPX9C.projectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dQlMZ.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $j0qHc.servicedeskPracticesResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $8gns3.servicedeskPortalGroupsResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $lEPfS.featuresResource)
        ],
        entryPoint () {
            return $c109145c0e1785d6$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint;
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dQlMZ.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("i3U1i", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskWidgetRouteEntry", () => $142cc35e1ab8cfdd$export$d86db47c21552ca);
/* eslint-disable import/order */ 


var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $rCDsK = parcelRequire("rCDsK");

var $74h93 = parcelRequire("74h93");

var $k0XvP = parcelRequire("k0XvP");
const $142cc35e1ab8cfdd$export$d86db47c21552ca = (0, $fdS54.createEntry)((0, $rCDsK.projectSettingsServicedeskWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $k0XvP.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $k0XvP.LazyProjectSettingsServiceDeskWidgetSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("26XVI", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskWorkforceOptimizationRouteEntry", () => $7d105c99be539c9b$export$5f0db0b7dc1fde);



var $co13a = parcelRequire("co13a");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $lkngp = parcelRequire("lkngp");

var $74h93 = parcelRequire("74h93");

var $fIlV7 = parcelRequire("fIlV7");

var $kocNw = parcelRequire("kocNw");
const $7d105c99be539c9b$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $7d105c99be539c9b$var$getConnectTeamsGlobalGroupsResources = ()=>(0, $2700E.expVal)('global_group_search_wfo', 'isEnabled', false) ? [
        (0, $co13a.connectTeamsGlobalGroupsResource)
    ] : [];
const $7d105c99be539c9b$export$5f0db0b7dc1fde = (0, $fdS54.createEntry)((0, $lkngp.projectSettingsServicedeskWorkforceOptimizationRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-workforce-optimization-settings',
        entryPoint: ()=>{
            if (!$7d105c99be539c9b$var$isWorkforceAemEnabled()) return undefined;
            return 0, $kocNw.workforceOptimizationSettingsPageEntryPoint;
        },
        layout: (0, $74h93.serviceProjectLayout),
        skeleton: (0, $i860n.fg)('jsm-routing-release-2') ? (0, $fIlV7.WorkforceOptimizationSettingsSkeleton) : undefined,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $co13a.routingOnboardingFinishedResource),
            ...$7d105c99be539c9b$var$getConnectTeamsGlobalGroupsResources()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jsm-workforce-optimization-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fIlV7", function(module, exports) {
$parcel$export(module.exports, "WorkforceOptimizationSettingsSkeleton", () => $6a8205de9c4183f6$export$617be49a8219ae7e);
/* WorkforceOptimizationSettingsSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");

var $i860n = parcelRequire("i860n");
// Mirror the page wrapper used when jsm-routing-release-2 is on.
// Keep layout values in sync with styles.pageWrapperNew in WorkforceOptimizationSettingsView.tsx.
const $6a8205de9c4183f6$var$styles = {
    scrollContainer: "_4t3i1osq _1tkeidpf _18m91wug _ln19p27b _1bsb1osq",
    appContainerInset: "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _ca0qze3t _u5f31ejb _n3tdze3t _19bv1ejb",
    container: "_195g1wug _1bsb1osq _p12fgysd _ca0qxy5q _u5f31epz",
    heading: "_2rko12b0 _bfhkizff _4t3i1f4h _1bsbuuw1",
    subtitle: "_2rko12b0 _bfhkizff _4t3i7vkz _1bsb1w2c",
    tab: "_2rko12b0 _bfhkizff _4t3izwfg _1bsb16xz",
    statusBanner: "_2rko1qi0 _bfhkizff _4t3i1ylp _1bsb1osq",
    sectionTitle: "_2rko12b0 _bfhkizff _4t3igktf _1bsb68cl",
    sectionDesc: "_2rko12b0 _bfhkizff _4t3i7vkz _1bsb1kdj",
    rowTitle: "_2rko12b0 _bfhkizff _4t3i7vkz _1bsbmgvx",
    rowSubtitle: "_2rko12b0 _bfhkizff _4t3idlk8 _1bsbnklw",
    rowAction: "_2rko12b0 _bfhkizff _4t3izwfg _1bsb68cl _1o9zidpf"
};
// A single card row: label+subtitle on the left, action pill on the right
const $6a8205de9c4183f6$var$SkeletonRow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        alignBlock: "center",
        grow: "fill",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.050",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.rowTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.rowSubtitle
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.rowAction
    }));
$6a8205de9c4183f6$var$SkeletonRow.displayName = "SkeletonRow";
// A labelled section card with a title, description, and rows
const $6a8205de9c4183f6$var$SkeletonSection = ({ rows: rows })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.sectionTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.sectionDesc
    })), Array.from({
        length: rows
    }).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6a8205de9c4183f6$var$SkeletonRow, {
            key: i
        })));
$6a8205de9c4183f6$var$SkeletonSection.displayName = "SkeletonSection";
const $6a8205de9c4183f6$export$617be49a8219ae7e = ()=>{
    const inner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.container,
        "aria-hidden": "true",
        testId: "project-settings-service-desk-workforce-optimization.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.heading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.subtitle
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.tab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.tab
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.statusBanner
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6a8205de9c4183f6$var$SkeletonSection, {
        rows: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6a8205de9c4183f6$var$SkeletonSection, {
        rows: 2
    })));
    return (0, $i860n.fg)('jsm-routing-fixes-for-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.scrollContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $6a8205de9c4183f6$var$styles.appContainerInset
    }, inner)) : inner;
};
$6a8205de9c4183f6$export$617be49a8219ae7e.displayName = "WorkforceOptimizationSettingsSkeleton";

});

parcelRegister("kocNw", function(module, exports) {
$parcel$export(module.exports, "workforceOptimizationSettingsPageEntryPoint", () => $57117caf7590bf9d$export$fd322ff5033bfa00);

var $86Ker = parcelRequire("86Ker");

var $dTa0V = parcelRequire("dTa0V");
const $57117caf7590bf9d$export$fd322ff5033bfa00 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $86Ker.workforceOptimizationSettingsEntryPoint)
});

});
parcelRegister("86Ker", function(module, exports) {
$parcel$export(module.exports, "workforceOptimizationSettingsEntryPoint", () => $6d0485d73db688de$export$3cce978b4b84ee26);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $dBMet = parcelRequire("dBMet");

var $jkM7C = parcelRequire("jkM7C");

var $ac9VS = parcelRequire("ac9VS");

var $7NTte = parcelRequire("7NTte");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $fiVog = parcelRequire("fiVog");

var $a4gGM = parcelRequire("a4gGM");

const $6d0485d73db688de$export$3cce978b4b84ee26 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("7fHtm")), {
        moduleId: "7fbe882b",
        moduleName: "WorkforceOptimizationSettingsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, orgId: orgId } })=>{
        const projectKey = match.params.projectKey ?? '';
        const organizationId = `ari:cloud:platform::org/${orgId}`;
        return {
            queries: {
                routingMethodSelectQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $dBMet.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                },
                teamCountsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $a4gGM.default),
                    variables: {
                        organizationId: organizationId,
                        siteId: cloudId,
                        filter: null,
                        sortBy: (0, $i860n.fg)('wfm_onboarding_ui_changes') ? [
                            {
                                field: 'DISPLAY_NAME',
                                order: 'ASC'
                            }
                        ] : null
                    }
                },
                ...(0, $i860n.fg)('jsm-routing-release-2') ? {
                    servicesAndSkillsQuery: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, $jkM7C.default),
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                } : {},
                ...(0, $2700E.expVal)('wfm_onboarding_experiment', 'isEnabled', false) ? {
                    servicesAndSkillsSetupActionQuery: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, $ac9VS.default),
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                } : {}
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
    }
});

});
parcelRegister("dBMet", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7ea2b212feef9c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb1cbe9ed8dc1e25b3e7de1cf5efdcd9>>
 * @relayHash 1ee15a3397489b60824c4c343fef76cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67754ccdf7dac8894e90328c3b77d6a6ff681f2021688087d5a1135d1c23475a
const $d7ea2b212feef9c6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "67754ccdf7dac8894e90328c3b77d6a6ff681f2021688087d5a1135d1c23475a",
        "metadata": {},
        "name": "RoutingMethodSelectQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d7ea2b212feef9c6$export$2e2bcd8739ae039 = $d7ea2b212feef9c6$var$node;

});

parcelRegister("jkM7C", function(module, exports) {
$parcel$export(module.exports, "default", () => $65f0e1f0ea50b6c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9a68fd09ad8c9dd0e5a0ad8b8c701750>>
 * @relayHash 3f092e22e11bcfe2dfda2d88d2170724
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dbf6dfd8f9d8b18c409442497a8cffe3158c9616c5c48de1ba0c626b858104bd
const $65f0e1f0ea50b6c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ServicesAndSkillsRow"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentWorkspaceSmartRoutingConfig",
                    "kind": "LinkedField",
                    "name": "agentWorkspace_routingConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "serviceFieldId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "serviceFieldName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "serviceFieldType"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentWorkspaceLiveRoutingTable",
                    "kind": "LinkedField",
                    "name": "agentWorkspace_liveRoutingTable",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentWorkspaceRoutingTableEntry",
                            "kind": "LinkedField",
                            "name": "entries",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "serviceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "serviceName"
                                },
                                {
                                    "concreteType": "TeamV2",
                                    "kind": "LinkedField",
                                    "name": "team",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "smallAvatarImageUrl"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "AgentWorkspaceSkill",
                                    "kind": "LinkedField",
                                    "name": "skills",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dbf6dfd8f9d8b18c409442497a8cffe3158c9616c5c48de1ba0c626b858104bd",
            "metadata": {},
            "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$65f0e1f0ea50b6c0$var$node.hash = "5fc2d85f557000c56c525177a8485258";
var $65f0e1f0ea50b6c0$export$2e2bcd8739ae039 = $65f0e1f0ea50b6c0$var$node;

});

parcelRegister("ac9VS", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfd0e8acb522155a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9aca81dda19b7baa686171f884d03e88>>
 * @relayHash c7f2a3c644e7ad31de1025becb232572
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f6cb9ed4f9983f50c5a2808ec95b8f49c6f9b38fec61405ad48cf2f2e5222598
const $bfd0e8acb522155a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                }
            ],
            "concreteType": "AgentWorkspaceSmartRoutingConfig",
            "kind": "LinkedField",
            "name": "agentWorkspace_routingConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "enabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ServicesAndSkillsSetupActionPreloadedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ServicesAndSkillsSetupActionPreloadedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "f6cb9ed4f9983f50c5a2808ec95b8f49c6f9b38fec61405ad48cf2f2e5222598",
            "metadata": {},
            "name": "ServicesAndSkillsSetupActionPreloadedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bfd0e8acb522155a$var$node.hash = "b8b23a7de27d6f4bd1d60bedd14eefaa";
var $bfd0e8acb522155a$export$2e2bcd8739ae039 = $bfd0e8acb522155a$var$node;

});

parcelRegister("a4gGM", function(module, exports) {
$parcel$export(module.exports, "default", () => $050ec4a51b3a4c85$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<82f246e8f5312caaef990e0dbb985577>>
 * @relayHash ca0e9a276ebb1bdbf77f24608fd2a11f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c89f39c033fb27269ee810086f850ec8e3612d01711b808620ba9a4c1a7fa4e1
const $050ec4a51b3a4c85$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c89f39c033fb27269ee810086f850ec8e3612d01711b808620ba9a4c1a7fa4e1",
        "metadata": {},
        "name": "WorkforceOptimizationSettingsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $050ec4a51b3a4c85$export$2e2bcd8739ae039 = $050ec4a51b3a4c85$var$node;

});

parcelRegister("7fHtm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4ITSj")
]).then(()=>parcelRequire('dSH3W'));

});




parcelRegister("3miVG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRouteEntry", () => $8b7b06af9e362feb$export$99415df4033272f);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $5ch9o = parcelRequire("5ch9o");

var $3eysO = parcelRequire("3eysO");

var $1J79Q = parcelRequire("1J79Q");

var $gyAS0 = parcelRequire("gyAS0");
const $8b7b06af9e362feb$export$99415df4033272f = (0, $fdS54.createEntry)((0, $5ch9o.projectSettingsSoftwareAccessRedirectRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1J79Q.peopleAccessRedirect)(`/jira/${(0, $gyAS0.SOFTWARE_PRODUCT)}`),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1J79Q.LazyPeopleSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5ch9o", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRoute", () => $957550ac4fb2eae3$export$55335c81a2be4654);
const $957550ac4fb2eae3$export$55335c81a2be4654 = {
    name: 'project-settings-software-access-redirect',
    path: '/jira/software/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("1J79Q", function(module, exports) {
$parcel$export(module.exports, "LazyPeopleSettings", () => $6c6cec743c620345$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $6c6cec743c620345$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $6c6cec743c620345$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $gNbXR = parcelRequire("gNbXR");

const $6c6cec743c620345$export$7eee4f97b7a1273 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7grbQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings-people/src/index.tsx"
});
const $6c6cec743c620345$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
$6c6cec743c620345$var$PeopleAccessRedirectInner.displayName = "PeopleAccessRedirectInner";
const $6c6cec743c620345$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6c6cec743c620345$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
const $6c6cec743c620345$var$AsyncPeopleSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6c6cec743c620345$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
$6c6cec743c620345$var$AsyncPeopleSettings.displayName = "AsyncPeopleSettings";
var $6c6cec743c620345$export$2e2bcd8739ae039 = $6c6cec743c620345$var$AsyncPeopleSettings;

});


parcelRegister("7s5cL", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAccessRouteEntry", () => $5125480db7a915e3$export$a5ead9d0de14b14b);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $4Hqbd = parcelRequire("4Hqbd");

var $k2tg5 = parcelRequire("k2tg5");

var $3eysO = parcelRequire("3eysO");

var $1J79Q = parcelRequire("1J79Q");

var $gyAS0 = parcelRequire("gyAS0");
const $5125480db7a915e3$export$a5ead9d0de14b14b = (0, $fdS54.createEntry)((0, $4Hqbd.projectSettingsSoftwareAccessRoute), ()=>({
        group: 'project-settings-software',
        skeleton: (0, $k2tg5.ProjectSettingsAccessSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1J79Q.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1J79Q.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4Hqbd", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAccessRoute", () => $20263877f3bc1673$export$db689602f90567d8);
const $20263877f3bc1673$export$db689602f90567d8 = {
    name: 'project-settings-software-access',
    path: '/jira/software/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("2bFMJ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRouteEntry", () => $400d228acea2aca9$export$78d9c4be1503dd23);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $ciKX3 = parcelRequire("ciKX3");

var $3eysO = parcelRequire("3eysO");

var $cKlkT = parcelRequire("cKlkT");

var $gyAS0 = parcelRequire("gyAS0");
const $400d228acea2aca9$export$78d9c4be1503dd23 = (0, $fdS54.createEntry)((0, $ciKX3.projectSettingsSoftwareAppsFieldsRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cKlkT.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cKlkT.LazyConnectAppControlsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ciKX3", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRoute", () => $870a96c379426662$export$333c94a9ec1a1535);
const $870a96c379426662$export$333c94a9ec1a1535 = {
    name: 'project-settings-software-apps-fields',
    path: '/jira/software/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("cKlkT", function(module, exports) {
$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $35b61f4e294dec51$export$246ec9cdadd2a163);
$parcel$export(module.exports, "default", () => $35b61f4e294dec51$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $35b61f4e294dec51$export$246ec9cdadd2a163 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("i0lYp"))), {
    moduleId: "./src/packages/spa-apps/project-settings-connect-app-controls/src/ProjectSettingsConnectAppControls.tsx"
});
const $35b61f4e294dec51$var$AsyncConnectAppControlsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $35b61f4e294dec51$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
$35b61f4e294dec51$var$AsyncConnectAppControlsSettings.displayName = "AsyncConnectAppControlsSettings";
var $35b61f4e294dec51$export$2e2bcd8739ae039 = $35b61f4e294dec51$var$AsyncConnectAppControlsSettings;

});


parcelRegister("cQYgq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAppsRouteEntry", () => $dfda6e7035805426$export$290fcdffa80c48ce);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $2eRLZ = parcelRequire("2eRLZ");

var $3eysO = parcelRequire("3eysO");

var $3nyRO = parcelRequire("3nyRO");

var $gyAS0 = parcelRequire("gyAS0");
const $dfda6e7035805426$export$290fcdffa80c48ce = (0, $fdS54.createEntry)((0, $2eRLZ.projectSettingsSoftwareAppsRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3nyRO.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $3nyRO.LazyConnectAppsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2eRLZ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAppsRoute", () => $cfc7d7d5c532923a$export$aece357f5f434121);
const $cfc7d7d5c532923a$export$aece357f5f434121 = {
    name: 'project-settings-software-apps',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("3nyRO", function(module, exports) {
$parcel$export(module.exports, "LazyConnectAppsSettings", () => $15858266cee2c670$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $15858266cee2c670$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $15858266cee2c670$export$3633e017e520a1c2 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("aoRbT"))), {
    moduleId: "./src/packages/spa-apps/project-settings-connect-apps/src/ProjectSettingsApps.tsx"
});
const $15858266cee2c670$var$AsyncConnectAppsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $15858266cee2c670$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
$15858266cee2c670$var$AsyncConnectAppsSettings.displayName = "AsyncConnectAppsSettings";
var $15858266cee2c670$export$2e2bcd8739ae039 = $15858266cee2c670$var$AsyncConnectAppsSettings;

});


parcelRegister("YxSwf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAutomationRouteEntry", () => $3f4f8fac4ee09c95$export$fb1f0477184046c5);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $2K9A5 = parcelRequire("2K9A5");

var $3eysO = parcelRequire("3eysO");

var $a3Ozg = parcelRequire("a3Ozg");

var $gyAS0 = parcelRequire("gyAS0");
const $3f4f8fac4ee09c95$export$fb1f0477184046c5 = (0, $fdS54.createEntry)((0, $2K9A5.projectSettingsSoftwareAutomationRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $a3Ozg.default),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $a3Ozg.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2K9A5", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAutomationRoute", () => $2ee0173124e3ed90$export$4d430aeb28b702f8);
const $2ee0173124e3ed90$export$4d430aeb28b702f8 = {
    name: 'project-settings-software-automation',
    path: '/jira/software/projects/:projectKey/settings/automation',
    exact: true
};

});


parcelRegister("9hYXu", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRouteEntry", () => $c2f1f7c7660f0723$export$ca616a5516b2e16d);

var $kwEWY = parcelRequire("kwEWY");



var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $hIWy4 = parcelRequire("hIWy4");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");

var $hMPfg = parcelRequire("hMPfg");

var $7ecC0 = parcelRequire("7ecC0");
const $c2f1f7c7660f0723$export$ca616a5516b2e16d = (0, $fdS54.createEntry)((0, $hIWy4.projectSettingsSoftwareBoardsCardRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('cover_image_issue_view_ga') ? (0, $7ecC0.BoardCardSettingsRedirectToBoardView) : (0, $hMPfg.default),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)(),
            (0, $kwEWY.cardCoverImageResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hMPfg.LazyCard)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kwEWY", function(module, exports) {
$parcel$export(module.exports, "cardCoverImageResource", () => $14e784a4b737518e$export$f37f52e28126ce75);

var $2zU0a = parcelRequire("2zU0a");

var $htsFl = parcelRequire("htsFl");

var $doB5G = parcelRequire("doB5G");
const $14e784a4b737518e$var$RESOURCE_TYPE_BOARD_CONTEXT_CARD_COVER_SETTINGS = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';
const $14e784a4b737518e$export$f37f52e28126ce75 = (0, $htsFl.createRelayResource)({
    type: $14e784a4b737518e$var$RESOURCE_TYPE_BOARD_CONTEXT_CARD_COVER_SETTINGS,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $doB5G.default),
            variables: {
                boardId: (0, $2zU0a.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("doB5G", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e29f3b03acf42a3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c394cc23e61e2106e8d0646dfd15635>>
 * @relayHash 139fae60f7b439ca7bbb2ae98032bdd1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e236e8096731e034049b4c120abe65ae117a620f5e0a8023028cb0064f1b65e
const $2e29f3b03acf42a3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CardCoverPageContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "CardCoverToggle"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "CardPreview"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CardCoverPageContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CardMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "cardMedia",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "3e236e8096731e034049b4c120abe65ae117a620f5e0a8023028cb0064f1b65e",
            "metadata": {},
            "name": "CardCoverPageContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2e29f3b03acf42a3$var$node.hash = "d86a54c6a42dc0ffbbcab92ac932cf91";
var $2e29f3b03acf42a3$export$2e2bcd8739ae039 = $2e29f3b03acf42a3$var$node;

});


parcelRegister("hIWy4", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRoute", () => $e18f4b203a68365e$export$d3f185a361401db7);
const $e18f4b203a68365e$export$d3f185a361401db7 = {
    name: 'project-settings-software-boards-card',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/card',
    exact: true
};

});

parcelRegister("hMPfg", function(module, exports) {
$parcel$export(module.exports, "LazyCard", () => $0201953ab560fc4e$export$40ff283c032abbc4);
$parcel$export(module.exports, "default", () => $0201953ab560fc4e$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0201953ab560fc4e$export$40ff283c032abbc4 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("iBOPA")), {
    moduleId: "./src/packages/project-settings/board-settings-card/src/CardCoverPage.tsx"
});
const $0201953ab560fc4e$var$AsyncCard = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0201953ab560fc4e$export$40ff283c032abbc4,
        pageId: "board-settings-card",
        shouldShowSpinner: false
    });
$0201953ab560fc4e$var$AsyncCard.displayName = "AsyncCard";
var $0201953ab560fc4e$export$2e2bcd8739ae039 = $0201953ab560fc4e$var$AsyncCard;

});
parcelRegister("iBOPA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("c3C83")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("8Gylw")
]).then(()=>parcelRequire('98lvS'));

});



parcelRegister("dBvp1", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRouteEntry", () => $55f6cca159f8443d$export$7a31e42733ba05a0);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $gTXms = parcelRequire("gTXms");

var $3eysO = parcelRequire("3eysO");

var $6AA7d = parcelRequire("6AA7d");

var $gyAS0 = parcelRequire("gyAS0");
const $55f6cca159f8443d$export$7a31e42733ba05a0 = (0, $fdS54.createEntry)((0, $gTXms.projectSettingsSoftwareBoardsCsmRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6AA7d.default),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6AA7d.LazyCsmSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gTXms", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRoute", () => $aef501ba6fa991c8$export$88e68eb447e3db49);
const $aef501ba6fa991c8$export$88e68eb447e3db49 = {
    name: 'project-settings-software-boards-csm',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/columns',
    exact: true
};

});

parcelRegister("6AA7d", function(module, exports) {
$parcel$export(module.exports, "LazyCsmSettings", () => $1edde1f1da002bb6$export$de293ea44d0410ca);
$parcel$export(module.exports, "default", () => $1edde1f1da002bb6$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1edde1f1da002bb6$export$de293ea44d0410ca = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("3kZ39"))), {
    moduleId: "./src/packages/spa-apps/project-settings-csm/src/index.tsx"
});
const $1edde1f1da002bb6$var$AsyncCsmSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1edde1f1da002bb6$export$de293ea44d0410ca,
        pageId: "project-settings-csm",
        shouldShowSpinner: false
    });
$1edde1f1da002bb6$var$AsyncCsmSettings.displayName = "AsyncCsmSettings";
var $1edde1f1da002bb6$export$2e2bcd8739ae039 = $1edde1f1da002bb6$var$AsyncCsmSettings;

});
parcelRegister("3kZ39", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("lOiZB")),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("2QPTS")
]).then(()=>parcelRequire('GDbdA'));

});



parcelRegister("3ryog", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRouteEntry", () => $22a54f37d769c10e$export$6332ad3e1d8d721);

var $bHJzX = parcelRequire("bHJzX");



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $4EcoE = parcelRequire("4EcoE");

var $3eysO = parcelRequire("3eysO");

var $6kUnF = parcelRequire("6kUnF");

var $gyAS0 = parcelRequire("gyAS0");
const $22a54f37d769c10e$export$6332ad3e1d8d721 = (0, $fdS54.createEntry)((0, $4EcoE.projectSettingsSoftwareBoardsCustomFiltersRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.custom-filters',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6kUnF.default),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)(),
            (0, $bHJzX.customFiltersResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $6kUnF.LazyCustomFiltersSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bHJzX", function(module, exports) {
$parcel$export(module.exports, "customFiltersResource", () => $f13297e1b0908613$export$3e390340716755de);

var $2zU0a = parcelRequire("2zU0a");

var $htsFl = parcelRequire("htsFl");

var $2VbYP = parcelRequire("2VbYP");
const $f13297e1b0908613$var$RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';
const $f13297e1b0908613$export$3e390340716755de = (0, $htsFl.createRelayResource)({
    type: $f13297e1b0908613$var$RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $2VbYP.default),
            variables: {
                boardId: (0, $2zU0a.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("2VbYP", function(module, exports) {
$parcel$export(module.exports, "default", () => $aeb16e1b2a1d101d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa95acb83ffd0e19d44fec092252da49>>
 * @relayHash 3e127a8a0f105d7dd3ffaf6658d29ff9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21aece67f1d4694a9ebcffa7e9910b5c638b92b86e44e42e66847c971c685c75
const $aeb16e1b2a1d101d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomFiltersLoaderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CustomFilter",
                                    "kind": "LinkedField",
                                    "name": "customFilters",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "CardCustomFiltersFragmentRef"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "CardCustomFilterBoardScopeFragmentRef"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ExpandedCardCustomFilterBoardScopeFragmentRef"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomFiltersLoaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "FilterQuery",
                                    "kind": "LinkedField",
                                    "name": "filterQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sanitisedJql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errors"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "21aece67f1d4694a9ebcffa7e9910b5c638b92b86e44e42e66847c971c685c75",
            "metadata": {},
            "name": "CustomFiltersLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aeb16e1b2a1d101d$var$node.hash = "9a24a10cb36d4bf37d5ade9f70e0437e";
var $aeb16e1b2a1d101d$export$2e2bcd8739ae039 = $aeb16e1b2a1d101d$var$node;

});


parcelRegister("4EcoE", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRoute", () => $24ce168b247cd7c0$export$9bc9b345958a301c);
const $24ce168b247cd7c0$export$9bc9b345958a301c = {
    name: 'project-settings-software-boards-custom-filters',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/custom-filters',
    exact: true
};

});

parcelRegister("6kUnF", function(module, exports) {
$parcel$export(module.exports, "LazyCustomFiltersSettings", () => $e2c205270db9a90f$export$7e21d36a9d4548e6);
$parcel$export(module.exports, "default", () => $e2c205270db9a90f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $e2c205270db9a90f$export$7e21d36a9d4548e6 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("lSifG")), {
    moduleId: "./src/packages/spa-apps/project-settings-custom-filters/src/index.tsx"
});
const $e2c205270db9a90f$var$AsyncCustomFiltersSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e2c205270db9a90f$export$7e21d36a9d4548e6,
        pageId: "project-settings-custom-filters",
        shouldShowSpinner: true
    });
$e2c205270db9a90f$var$AsyncCustomFiltersSettings.displayName = "AsyncCustomFiltersSettings";
var $e2c205270db9a90f$export$2e2bcd8739ae039 = $e2c205270db9a90f$var$AsyncCustomFiltersSettings;

});
parcelRegister("lSifG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("2pO6x")
]).then(()=>parcelRequire('kw0Cn'));

});



parcelRegister("dGozg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRouteEntry", () => $70e59dad2df22738$export$cb6169207ddfd1b2);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $2hIxt = parcelRequire("2hIxt");

var $3eysO = parcelRequire("3eysO");

var $7ecC0 = parcelRequire("7ecC0");

var $gyAS0 = parcelRequire("gyAS0");
const $70e59dad2df22738$export$cb6169207ddfd1b2 = (0, $fdS54.createEntry)((0, $2hIxt.projectSettingsSoftwareBoardsRedirectRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7ecC0.BoardSettingsRedirectToCSM),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        isRedirect: true,
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2hIxt", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRoute", () => $4f29ccd649dc9353$export$989ca67485551616);
const $4f29ccd649dc9353$export$989ca67485551616 = {
    name: 'project-settings-software-boards-redirect',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId',
    exact: true
};

});


parcelRegister("ciUor", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRouteEntry", () => $2b422c3a28f21110$export$6d5eadd440c430f5);



var $jUlyL = parcelRequire("jUlyL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $bCWRO = parcelRequire("bCWRO");

var $3eysO = parcelRequire("3eysO");

var $7ecC0 = parcelRequire("7ecC0");

var $gyAS0 = parcelRequire("gyAS0");

var $baR2Y = parcelRequire("baR2Y");
const $2b422c3a28f21110$export$6d5eadd440c430f5 = (0, $fdS54.createEntry)((0, $bCWRO.projectSettingsSoftwareBoardsRoadmapRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7ecC0.RoadmapSettingsRedirectToTimelineSettings),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)(),
            (0, $jUlyL.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $baR2Y.LazyRoadmap)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jUlyL", function(module, exports) {
$parcel$export(module.exports, "roadmapSettingsResource", () => $86eaede806c403d1$export$7901a008bd73bf46);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hXtMP = parcelRequire("hXtMP");

var $2zU0a = parcelRequire("2zU0a");

var $htsFl = parcelRequire("htsFl");

const $86eaede806c403d1$export$7901a008bd73bf46 = (0, $htsFl.createRelayResource)({
    type: (0, $758c696262b4288a$export$e905b9170ecbb599),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $hXtMP.default),
            variables: {
                sourceAri: (0, $2zU0a.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                locationAri: undefined
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("hXtMP", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d616b133619699c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1ba589d6a6e452814b11db6102ac8b75>>
 * @relayHash 843eef387f7f0cb53cf3fed2191cc36d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 769504860593365a143aeea3bd2de7134a061619ea7fbf34c3f188189dfb1e9f
const $8d616b133619699c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RoadmapPageLoaderQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ChildIssuesSchedulingToggle"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ChildIssuesSchedulingPreview"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW"
                                            }
                                        ]
                                    },
                                    "action": "THROW"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RoadmapPageLoaderQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapConfiguration",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapBoardConfiguration",
                                            "kind": "LinkedField",
                                            "name": "boardConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isChildIssuePlanningEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "childIssuePlanningMode"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "769504860593365a143aeea3bd2de7134a061619ea7fbf34c3f188189dfb1e9f",
            "metadata": {},
            "name": "RoadmapPageLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8d616b133619699c$var$node.hash = "315e874b325a4c87e0fd376eaa279ef0";
var $8d616b133619699c$export$2e2bcd8739ae039 = $8d616b133619699c$var$node;

});

/* eslint-disable jira/filename-case */ const $758c696262b4288a$export$75dfa03544a19422 = 'ROADMAP';
const $758c696262b4288a$export$e3b1cd17bd82de3d = 'CLASSIC_ROADMAP';
const $758c696262b4288a$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';


parcelRegister("bCWRO", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRoute", () => $86f26b9ac3b9c25f$export$17ccdaa366ec26b8);
const $86f26b9ac3b9c25f$export$17ccdaa366ec26b8 = {
    name: 'project-settings-software-boards-roadmap',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/roadmap',
    exact: true
};

});

parcelRegister("baR2Y", function(module, exports) {
$parcel$export(module.exports, "LazyRoadmap", () => $c2a56d61302e56bf$export$8eca5454e72ee961);
$parcel$export(module.exports, "default", () => $c2a56d61302e56bf$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $c2a56d61302e56bf$export$8eca5454e72ee961 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("bC3r0")), {
    moduleId: "./src/packages/project-settings/board-settings-roadmap-entry/src/RoadmapPageLoader.tsx"
});
const $c2a56d61302e56bf$var$AsyncProjectSettingsRoadmap = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "project-settings.roadmap",
        teamName: "chronos",
        attributes: {
            isSynthetic: (0, $i860n.fg)('is_synthetic_tenant') || (0, $6bEm8.default)('ajs-is-synthetic') === 'true'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c2a56d61302e56bf$export$8eca5454e72ee961,
        pageId: "board-settings-roadmap",
        shouldShowSpinner: false
    }));
$c2a56d61302e56bf$var$AsyncProjectSettingsRoadmap.displayName = "AsyncProjectSettingsRoadmap";
var $c2a56d61302e56bf$export$2e2bcd8739ae039 = $c2a56d61302e56bf$var$AsyncProjectSettingsRoadmap;

});
parcelRegister("bC3r0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8nBTf").then(()=>parcelRequire('1tYMu'));

});



parcelRegister("bItbu", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRouteEntry", () => $26849b41e8d3cdfc$export$cc224b8b7595975b);



var $jUlyL = parcelRequire("jUlyL");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dhM7q = parcelRequire("dhM7q");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");

var $baR2Y = parcelRequire("baR2Y");
const $26849b41e8d3cdfc$export$cc224b8b7595975b = (0, $fdS54.createEntry)((0, $dhM7q.projectSettingsSoftwareBoardsTimelineRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $baR2Y.default),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)(),
            (0, $jUlyL.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $baR2Y.LazyRoadmap)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dhM7q", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRoute", () => $ba8a30e528eb105a$export$e116d6b2a5f71426);
const $ba8a30e528eb105a$export$e116d6b2a5f71426 = {
    name: 'project-settings-software-boards-timeline',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/timeline',
    exact: true
};

});


parcelRegister("fGHom", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRouteEntry", () => $1062abd7e020b673$export$cc932462de184b27);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lN5qQ = parcelRequire("lN5qQ");

var $k2tg5 = parcelRequire("k2tg5");

var $3eysO = parcelRequire("3eysO");

var $iTFlf = parcelRequire("iTFlf");

var $gyAS0 = parcelRequire("gyAS0");
const $1062abd7e020b673$export$cc932462de184b27 = (0, $fdS54.createEntry)((0, $lN5qQ.projectSettingsSoftwareDataClassificationsRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $iTFlf.default),
        skeleton: (0, $k2tg5.ProjectSettingsDetailsSkeleton),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $iTFlf.LazyDataClassificationsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    })); /**
 * Contains all software settings routes using the new url format `jira/:product/projects/:projectKey/settings`.
 */ 

});
parcelRegister("lN5qQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRoute", () => $f93896c117c52f7d$export$af525a8f93b72cc7);
const $f93896c117c52f7d$export$af525a8f93b72cc7 = {
    name: 'project-settings-software-data-classifications',
    path: '/jira/software/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("iTFlf", function(module, exports) {
$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $1282779afaee883c$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $1282779afaee883c$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1282779afaee883c$export$b8abcf8aa8f4df56 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("bWcHj"))), {
    moduleId: "./src/packages/spa-apps/project-settings-data-classifications/src/index.tsx"
});
const $1282779afaee883c$var$AsyncDataClassificationsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1282779afaee883c$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
$1282779afaee883c$var$AsyncDataClassificationsSettings.displayName = "AsyncDataClassificationsSettings";
var $1282779afaee883c$export$2e2bcd8739ae039 = $1282779afaee883c$var$AsyncDataClassificationsSettings;

});


parcelRegister("kiC9A", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareDetailsRouteEntry", () => $3c932de3b369035e$export$8440d3384846d9b8);



var $98dWy = parcelRequire("98dWy");

var $fdS54 = parcelRequire("fdS54");

var $2VcYg = parcelRequire("2VcYg");

var $k2tg5 = parcelRequire("k2tg5");

var $3eysO = parcelRequire("3eysO");

var $dTa0V = parcelRequire("dTa0V");

var $gyAS0 = parcelRequire("gyAS0");
const $3c932de3b369035e$var$projectSettingsSoftwareDetailsPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $98dWy.projectDetailsPageEntrypoint)
});
const $3c932de3b369035e$export$8440d3384846d9b8 = (0, $fdS54.createEntry)((0, $2VcYg.projectSettingsSoftwareDetailsRoute), ()=>({
        group: 'project-settings-software',
        skeleton: (0, $k2tg5.ProjectSettingsDetailsSkeleton),
        layout: (0, $3eysO.softwareProjectLayout),
        entryPoint: ()=>$3c932de3b369035e$var$projectSettingsSoftwareDetailsPageEntrypoint,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2VcYg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareDetailsRoute", () => $96b1c072f149bc52$export$8760347e2b0955eb);
const $96b1c072f149bc52$export$8760347e2b0955eb = {
    name: 'project-settings-software-details',
    path: '/jira/software/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("kJYkR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareFieldsRouteEntry", () => $9ee3279d08306bfe$export$e6b200b5a1ce3063);



var $3Slbk = parcelRequire("3Slbk");

var $2wUEq = parcelRequire("2wUEq");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lQlWh = parcelRequire("lQlWh");

var $3eysO = parcelRequire("3eysO");

var $dTa0V = parcelRequire("dTa0V");

var $iKoJO = parcelRequire("iKoJO");

var $gyAS0 = parcelRequire("gyAS0");
const $9ee3279d08306bfe$var$projectSettingsSoftwareFieldsPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2wUEq.fieldSettingsPageEntrypoint)
});
const $9ee3279d08306bfe$export$e6b200b5a1ce3063 = (0, $fdS54.createEntry)((0, $lQlWh.projectSettingsSoftwareFieldsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.fields.jsw-tmp',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $iKoJO.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)(),
            (0, $3Slbk.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $iKoJO.LazyFieldsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        entryPoint () {
            return $9ee3279d08306bfe$var$projectSettingsSoftwareFieldsPageEntrypoint;
        }
    }));

});
parcelRegister("2wUEq", function(module, exports) {
$parcel$export(module.exports, "fieldSettingsPageEntrypoint", () => $6ae70ecd28bd796e$export$d5dcc8918d463e14);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $6ae70ecd28bd796e$export$d5dcc8918d463e14 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("2tW7Q")), {
        moduleId: "382f6322",
        moduleName: "FieldsPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context })=>({
            queries: {},
            extraProps: {
                context: context
            }
        })
});

});
parcelRegister("2tW7Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lKH57").then(()=>parcelRequire('5k9by'));

});


parcelRegister("lQlWh", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareFieldsRoute", () => $19a8fbb0a423c5af$export$1ab9d3299fbc789b);
const $19a8fbb0a423c5af$export$1ab9d3299fbc789b = {
    name: 'project-settings-software-fields',
    path: '/jira/software/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("iKoJO", function(module, exports) {
$parcel$export(module.exports, "LazyFieldsSettings", () => $778942e18d90eb35$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $778942e18d90eb35$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $778942e18d90eb35$export$e309780f520d125a = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("9hH3y"))), {
    moduleId: "./src/packages/spa-apps/project-settings-fields/src/ExportedDefault.tsx"
});
const $778942e18d90eb35$var$AsyncFieldsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $778942e18d90eb35$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
$778942e18d90eb35$var$AsyncFieldsSettings.displayName = "AsyncFieldsSettings";
var $778942e18d90eb35$export$2e2bcd8739ae039 = $778942e18d90eb35$var$AsyncFieldsSettings;

});


parcelRegister("gWiov", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRouteEntry", () => $79c58b597944a357$export$84a9a2dce32d93aa);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $hFDX3 = parcelRequire("hFDX3");

var $3eysO = parcelRequire("3eysO");

var $7ecC0 = parcelRequire("7ecC0");

var $isKTv = parcelRequire("isKTv");

var $gyAS0 = parcelRequire("gyAS0");
const $79c58b597944a357$export$84a9a2dce32d93aa = (0, $fdS54.createEntry)((0, $hFDX3.projectSettingsSoftwareIssuetypesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: (0, $7ecC0.getUFOName)('project-settings-software-issuetypes'),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $isKTv.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $isKTv.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hFDX3", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRoute", () => $37ef55c6ce651adb$export$7f26edefe51efc38);
const $37ef55c6ce651adb$export$7f26edefe51efc38 = {
    name: 'project-settings-software-issuetypes',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("isKTv", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeSettings", () => $69ed50e376274bc9$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $69ed50e376274bc9$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $69ed50e376274bc9$export$36dcfb52d47cb93a = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("foBE1"))), {
    moduleId: "./src/packages/spa-apps/project-settings-issue-type/src/IssueTypePage.tsx"
});
const $69ed50e376274bc9$var$AsyncIssueTypeSettings = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $69ed50e376274bc9$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
$69ed50e376274bc9$var$AsyncIssueTypeSettings.displayName = "AsyncIssueTypeSettings";
var $69ed50e376274bc9$export$2e2bcd8739ae039 = $69ed50e376274bc9$var$AsyncIssueTypeSettings;

});


parcelRegister("6LIr6", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRouteEntry", () => $44d51c264644d141$export$58ca33ed538911cb);

var $b6pOc = parcelRequire("b6pOc");



var $fyoT9 = parcelRequire("fyoT9");

var $e2Z3B = parcelRequire("e2Z3B");

var $cH5Ll = parcelRequire("cH5Ll");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $6bGyp = parcelRequire("6bGyp");

var $3eysO = parcelRequire("3eysO");

var $byMD7 = parcelRequire("byMD7");

var $2700E = parcelRequire("2700E");

var $8hHpc = parcelRequire("8hHpc");

var $edf7u = parcelRequire("edf7u");

var $isKTv = parcelRequire("isKTv");

var $gyAS0 = parcelRequire("gyAS0");

var $gwwzq = parcelRequire("gwwzq");
const $44d51c264644d141$var$getWorkflowBuilderProvisioningResources = ()=>[
        (0, $fyoT9.workflowBuilderProvisioningResource)
    ];
const $44d51c264644d141$export$58ca33ed538911cb = (0, $fdS54.createEntry)((0, $b6pOc.projectSettingsSoftwareIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gwwzq.default),
        layout: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? (0, $byMD7.chromelessLayout) : (0, $3eysO.softwareProjectLayout),
        navigation: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? undefined : {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? [
            ...(0, $4B518.jiraSpaResources)(),
            // Delete this resource after hix-7127_wfe_layout_to_chromeless_for_software experiment is over
            // AND usages of projectContextResource have been swapped with projectWorkflowContextResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8hHpc.projectWorkflowContextResource),
            (0, $e2Z3B.workflowCapabilitiesResource),
            (0, $cH5Ll.workflowDocumentResource),
            (0, $6bGyp.rovoEntitlementResource),
            ...$44d51c264644d141$var$getWorkflowBuilderProvisioningResources()
        ] : [
            ...(0, $4B518.jiraSpaResources)(),
            ...(0, $gyAS0.getSettingsNavigationResources)(),
            ...$44d51c264644d141$var$getWorkflowBuilderProvisioningResources(),
            (0, $fyoT9.workflowBuilderProvisioningResource)
        ],
        forPaint: (0, $2700E.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? [
            (0, $gwwzq.LazyWorkflowNavigationSettings)
        ] : [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $isKTv.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@jira/router-routes__project-settings-workflow-editor-software-entries/src/projectSettingsSoftwareIssuetypesWorkflowRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareIssuetypesWorkflowRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("b6pOc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRoute", () => $2c30570ab9166544$export$de010d824a551ec);
const $2c30570ab9166544$export$de010d824a551ec = {
    name: 'project-settings-software-issuetypes-workflow',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("gwwzq", function(module, exports) {
$parcel$export(module.exports, "LazyWorkflowNavigationSettings", () => $49af6f11a0e33dbd$export$cb608e3696682e76);
$parcel$export(module.exports, "default", () => $49af6f11a0e33dbd$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $49af6f11a0e33dbd$export$cb608e3696682e76 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("8xDGy"))), {
    moduleId: "./src/packages/spa-apps/project-settings-workflow-navigation/src/WorkflowNavigationPage.tsx"
});
const $49af6f11a0e33dbd$var$AsyncWorkflowNavigationSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $49af6f11a0e33dbd$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
$49af6f11a0e33dbd$var$AsyncWorkflowNavigationSettings.displayName = "AsyncWorkflowNavigationSettings";
var $49af6f11a0e33dbd$export$2e2bcd8739ae039 = $49af6f11a0e33dbd$var$AsyncWorkflowNavigationSettings;

});


parcelRegister("cDdFQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRouteEntry", () => $d408e7ce57f460e1$export$81067f5196099c81);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $3GCqg = parcelRequire("3GCqg");

var $k2tg5 = parcelRequire("k2tg5");

var $3eysO = parcelRequire("3eysO");

var $7RkQ4 = parcelRequire("7RkQ4");

var $gyAS0 = parcelRequire("gyAS0");
const $d408e7ce57f460e1$export$81067f5196099c81 = (0, $fdS54.createEntry)((0, $3GCqg.projectSettingsSoftwareNextGenFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.next-gen-features',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7RkQ4.default),
        skeleton: (0, $k2tg5.ProjectSettingsFeaturesSkeleton),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7RkQ4.LazyFeaturesSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3GCqg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRoute", () => $459a02cc6d78915c$export$12c7a1737b594a28);
const $459a02cc6d78915c$export$12c7a1737b594a28 = {
    name: 'project-settings-software-next-gen-features',
    path: '/jira/software/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("7RkQ4", function(module, exports) {
$parcel$export(module.exports, "LazyFeaturesSettings", () => $5e03d96a3ea4d6b6$export$da4d608b99858bfc);
$parcel$export(module.exports, "default", () => $5e03d96a3ea4d6b6$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $5e03d96a3ea4d6b6$export$da4d608b99858bfc = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hMNAs"))), {
    moduleId: "./src/packages/spa-apps/project-settings-next-gen-features/src/index.tsx"
});
const $5e03d96a3ea4d6b6$var$AsyncFeaturesSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5e03d96a3ea4d6b6$export$da4d608b99858bfc,
        pageId: "project-settings-next-gen-features",
        shouldShowSpinner: false
    });
$5e03d96a3ea4d6b6$var$AsyncFeaturesSettings.displayName = "AsyncFeaturesSettings";
var $5e03d96a3ea4d6b6$export$2e2bcd8739ae039 = $5e03d96a3ea4d6b6$var$AsyncFeaturesSettings;

});
parcelRegister("hMNAs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4gCJD").then(()=>parcelRequire('aFIdA'));

});



parcelRegister("fCMtp", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRouteEntry", () => $a6f0eff5a9a82da0$export$9bb08b8e1b39d15f);



var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $hajdP = parcelRequire("hajdP");

var $k2tg5 = parcelRequire("k2tg5");

var $3eysO = parcelRequire("3eysO");

var $i3MK1 = parcelRequire("i3MK1");

var $gEhlT = parcelRequire("gEhlT");
const $a6f0eff5a9a82da0$export$9bb08b8e1b39d15f = (0, $fdS54.createEntry)((0, $hajdP.projectSettingsSoftwareNotificationEmailCRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i3MK1.default),
        skeleton: (0, $k2tg5.ProjectSettingsFeaturesSkeleton),
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gEhlT.LazySoftwareClassicFeatures),
            (0, $i3MK1.LazyProjectSettingsNotificationEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hajdP", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRoute", () => $bfae952d6411b31a$export$dda91725b6c4a039);
const $bfae952d6411b31a$export$dda91725b6c4a039 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("i3MK1", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $965541d8eabcdacc$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $965541d8eabcdacc$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $965541d8eabcdacc$export$ea7d73c94d9369f4 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("tWUUI"))), {
    moduleId: "./src/packages/spa-apps/project-settings-notification-email/src/ExportedDefault.tsx"
});
const $965541d8eabcdacc$var$AsyncProjectSettingsNotificationEmail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $965541d8eabcdacc$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
$965541d8eabcdacc$var$AsyncProjectSettingsNotificationEmail.displayName = "AsyncProjectSettingsNotificationEmail";
var $965541d8eabcdacc$export$2e2bcd8739ae039 = $965541d8eabcdacc$var$AsyncProjectSettingsNotificationEmail;

});


parcelRegister("l1koB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRouteEntry", () => $7e523fbd991f3ea9$export$8a17783c300fca11);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $6WEc3 = parcelRequire("6WEc3");

var $k2tg5 = parcelRequire("k2tg5");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");
const $7e523fbd991f3ea9$export$8a17783c300fca11 = (0, $fdS54.createEntry)((0, $6WEc3.projectSettingsSoftwareNotificationEmailRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gyAS0.RedirectForSettings),
        skeleton: (0, $k2tg5.ProjectSettingsFeaturesSkeleton),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6WEc3", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRoute", () => $6cd141a28dcdc12d$export$d4ed083331cb6e00);
const $6cd141a28dcdc12d$export$d4ed083331cb6e00 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});


parcelRegister("hz1Ci", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $2a88072c1a34db73$export$9c37d834dfe46ebf);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $izShU = parcelRequire("izShU");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");

var $E0aBu = parcelRequire("E0aBu");
const $2a88072c1a34db73$export$9c37d834dfe46ebf = (0, $fdS54.createEntry)((0, $izShU.projectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications.issue-logs',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $E0aBu.SoftwareNotificationsIssueLogs),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $E0aBu.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $E0aBu.emailNotificationsLogEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("izShU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRoute", () => $f0b893139335309f$export$ff4977f79c273b29);
const $f0b893139335309f$export$ff4977f79c273b29 = {
    name: 'project-settings-software-notifications-issue-logs',
    path: '/jira/software/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("4Nxur", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRouteEntry", () => $0892b8b4cce2f440$export$1c340fa0c9022252);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $82ybW = parcelRequire("82ybW");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");

var $88Nz7 = parcelRequire("88Nz7");
const $0892b8b4cce2f440$export$1c340fa0c9022252 = (0, $fdS54.createEntry)((0, $82ybW.projectSettingsSoftwareNotificationsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $88Nz7.default),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $88Nz7.LazySoftwareNotificationsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("82ybW", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRoute", () => $8be676aa19a561ba$export$c1d1892d6c07135a);
const $8be676aa19a561ba$export$c1d1892d6c07135a = {
    name: 'project-settings-software-notifications',
    path: '/jira/software/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("88Nz7", function(module, exports) {
$parcel$export(module.exports, "LazySoftwareNotificationsSettings", () => $454e0fae6270a889$export$69a64a29d67ca160);
$parcel$export(module.exports, "default", () => $454e0fae6270a889$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $454e0fae6270a889$export$69a64a29d67ca160 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hfK3P"))), {
    moduleId: "./src/packages/spa-apps/project-settings-software-notifications/src/ProjectSettingsSoftwareNotifications.tsx"
});
const $454e0fae6270a889$var$AsyncSoftwareNotificationsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $454e0fae6270a889$export$69a64a29d67ca160,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
$454e0fae6270a889$var$AsyncSoftwareNotificationsSettings.displayName = "AsyncSoftwareNotificationsSettings";
var $454e0fae6270a889$export$2e2bcd8739ae039 = $454e0fae6270a889$var$AsyncSoftwareNotificationsSettings;

});


parcelRegister("k9sOB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwarePoliciesRouteEntry", () => $cacf9deda8dbff96$export$6cb6c9137bc4c416);



var $k5Kh0 = parcelRequire("k5Kh0");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");

var $iSoIx = parcelRequire("iSoIx");

var $ljYaN = parcelRequire("ljYaN");

var $gyAS0 = parcelRequire("gyAS0");
const $cacf9deda8dbff96$var$projectSettingsSpacePoliciesPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $k5Kh0.projectSettingsSpacePoliciesEntryPoint)
});
const $cacf9deda8dbff96$export$6cb6c9137bc4c416 = (0, $fdS54.createEntry)((0, $ljYaN.projectSettingsSoftwarePoliciesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.space-policies.jsw-tmp',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        entryPoint: ()=>(0, $i860n.fg)('frontier-guided-autonomy-space-settings') ? $cacf9deda8dbff96$var$projectSettingsSpacePoliciesPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint)
    }));

});
parcelRegister("ljYaN", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwarePoliciesRoute", () => $f47edcdbf994c2fc$export$4ca3814a664767c1);
const $f47edcdbf994c2fc$export$4ca3814a664767c1 = {
    name: 'project-settings-software-policies',
    path: '/jira/software/projects/:projectKey/settings/policies',
    exact: true
};

});


parcelRegister("bRlx8", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRouteEntry", () => $5f632fc5c57b9293$export$5606059eca31e30);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $i2gTU = parcelRequire("i2gTU");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");

var $hjNWi = parcelRequire("hjNWi");
const $5f632fc5c57b9293$export$5606059eca31e30 = (0, $fdS54.createEntry)((0, $i2gTU.projectSettingsSoftwareProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hjNWi.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hjNWi.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("i2gTU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRoute", () => $8d840cbfc09e9e3e$export$cf33294d9d90a855);
const $8d840cbfc09e9e3e$export$cf33294d9d90a855 = {
    name: 'project-settings-software-proforma-jira-form-builder',
    path: '/jira/software/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("krZyW", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRouteEntry", () => $c28c9f3da3d52bf8$export$ea77a3e974b26072);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $8bdhJ = parcelRequire("8bdhJ");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");

var $hcswn = parcelRequire("hcswn");
const $c28c9f3da3d52bf8$export$ea77a3e974b26072 = (0, $fdS54.createEntry)((0, $8bdhJ.projectSettingsSoftwareProformaProjectFormsRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hcswn.default),
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hcswn.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8bdhJ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRoute", () => $1e97998c296e2fb4$export$750dec948cc98062);
const $1e97998c296e2fb4$export$750dec948cc98062 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("g6qas", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareRedirectRouteEntry", () => $0c12ae85efd79a48$export$e5caf0892d6025c9);



var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $iZZBu = parcelRequire("iZZBu");

var $3eysO = parcelRequire("3eysO");

var $gyAS0 = parcelRequire("gyAS0");
const $0c12ae85efd79a48$export$e5caf0892d6025c9 = (0, $fdS54.createEntry)((0, $iZZBu.projectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gyAS0.RedirectForSettings),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iZZBu", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareRedirectRoute", () => $3652f7de62f4ff01$export$168cc8ed4398c230);
const $3652f7de62f4ff01$export$168cc8ed4398c230 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'project-settings-software-redirect',
    path: '/jira/software/projects/:projectKey/settings'
};

});


parcelRegister("69TKs", function(module, exports) {
$parcel$export(module.exports, "projectSettingsToolchainRouteEntry", () => $ca1bcd356ee4098f$export$dd97d29f96b25d09);



var $6I9K3 = parcelRequire("6I9K3");

var $lFLfF = parcelRequire("lFLfF");

var $052eo = parcelRequire("052eo");

var $jEYuY = parcelRequire("jEYuY");

var $4Oj6z = parcelRequire("4Oj6z");

var $fdS54 = parcelRequire("fdS54");

var $7gTfn = parcelRequire("7gTfn");

var $3eysO = parcelRequire("3eysO");

var $5VtgL = parcelRequire("5VtgL");

var $gyAS0 = parcelRequire("gyAS0");
const $ca1bcd356ee4098f$export$dd97d29f96b25d09 = (0, $fdS54.createEntry)((0, $7gTfn.projectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4Oj6z.default)((0, $052eo.isDevopsFeatureDisabledInFedRamp), (0, $lFLfF.default), (0, $5VtgL.default)),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)(),
            (0, $6I9K3.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5VtgL.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7gTfn", function(module, exports) {
$parcel$export(module.exports, "projectSettingsToolchainRoute", () => $a7b98ebcabc737f6$export$e3e3877ec9c5e840);
const $a7b98ebcabc737f6$export$e3e3877ec9c5e840 = {
    name: 'project-settings-software-toolchain-team-managed',
    path: '/jira/software/projects/:projectKey/settings/toolchain',
    exact: true
};

});


parcelRegister("5HpuX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsVersionsRouteEntry", () => $f9212b11b2f64a0b$export$4791201b4877aa5d);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $6nzBS = parcelRequire("6nzBS");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $6Doim = parcelRequire("6Doim");

var $ilise = parcelRequire("ilise");
const $f9212b11b2f64a0b$export$4791201b4877aa5d = (0, $fdS54.createEntry)((0, $6Doim.projectSettingsVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6nzBS.projectVersionsRelayResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ilise.RelayVersions),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $ilise.LazyRelayProjectVersions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6nzBS", function(module, exports) {
$parcel$export(module.exports, "projectVersionsRelayResource", () => $d76ebd1f0288960b$export$7e8aa1360f86345c);
/* eslint-disable jira/import-whitelist */ 
var $n67Vb = parcelRequire("n67Vb");


var $81EjT = parcelRequire("81EjT");

var $aI7em = parcelRequire("aI7em");

var $5SJ3N = parcelRequire("5SJ3N");

var $htsFl = parcelRequire("htsFl");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

var $e1LXy = parcelRequire("e1LXy");
const $d76ebd1f0288960b$var$RESOURCE_TYPE_PROJECT_VERSIONS = 'PROJECT_VERSIONS';
const $d76ebd1f0288960b$export$7e8aa1360f86345c = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${$d76ebd1f0288960b$var$RESOURCE_TYPE_PROJECT_VERSIONS}`,
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `project-version-query-relay-${projectKey}`;
    },
    // @ts-expect-error - might return null
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $e1LXy.default), {
            initialLoadCount: 20,
            cloudId: tenantContext.cloudId,
            projectKey: match.params.projectKey,
            filter: (0, $81EjT.transformStatusFromParam)(query[0, $4684d5b9e49d2e36$export$3e8168848b996f7]),
            searchString: query[0, $4684d5b9e49d2e36$export$a181206198b7f50c] || '',
            sortBy: {
                sortByField: (0, $81EjT.transformSortFieldFromParam)(query[0, $4684d5b9e49d2e36$export$a3482d3a8df0e725]),
                order: (0, $81EjT.transformSortOrderFromParam)(query[0, $4684d5b9e49d2e36$export$71089821f361e881])
            },
            isVersionPerProjectLimitEnabled: (0, $i860n.fg)('enable_versions_per_project_limit')
        }, {
            fetchPolicy: 'store-and-network'
        });
        if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
/* eslint-disable jira/filename-case */ const $4684d5b9e49d2e36$export$a181206198b7f50c = 'contains';
const $4684d5b9e49d2e36$export$3e8168848b996f7 = 'status';
const $4684d5b9e49d2e36$export$71089821f361e881 = 'orderDirection';
const $4684d5b9e49d2e36$export$a3482d3a8df0e725 = 'orderField';
const $4684d5b9e49d2e36$export$3c5e605ca7ade9f2 = 'NAME';
const $4684d5b9e49d2e36$export$50241fe906e4f94e = 'RELEASE_DATE';
const $4684d5b9e49d2e36$export$99a467bcc22b8df9 = 'START_DATE';
const $4684d5b9e49d2e36$export$d44826c816b5619b = 'DESCRIPTION';
const $4684d5b9e49d2e36$export$34694f8d8b23ee2a = 'SEQUENCE';
const $4684d5b9e49d2e36$export$cb638d1fae624fbf = 20;
const $4684d5b9e49d2e36$export$bbcbc202f2dfa28c = 3;
const $4684d5b9e49d2e36$export$b983f2cb1f658a55 = 'RELEASED';
const $4684d5b9e49d2e36$export$cb459d726a8530a5 = 'UNRELEASED';
const $4684d5b9e49d2e36$export$c936349447a77fe0 = 'ARCHIVED';
const $4684d5b9e49d2e36$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("81EjT", function(module, exports) {
$parcel$export(module.exports, "transformStatusFromParam", () => $62fab491e77450ba$export$5760f9690301cdb);
$parcel$export(module.exports, "transformStatusToParam", () => $62fab491e77450ba$export$46595832dd863016);
$parcel$export(module.exports, "transformSortOrderFromParam", () => $62fab491e77450ba$export$1945e6d2f31e09e6);
$parcel$export(module.exports, "transformSortFieldFromParam", () => $62fab491e77450ba$export$f842a0d1846d319d);
$parcel$export(module.exports, "transformStatusToDropdownSelection", () => $62fab491e77450ba$export$7dad705635760cfe);
$parcel$export(module.exports, "getUpdatedDisplayedStatuses", () => $62fab491e77450ba$export$ce4c948ba1d53df4);
$parcel$export(module.exports, "getFormattedVersionDate", () => $62fab491e77450ba$export$5a6eeb16be7dd21d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $fvBJV = parcelRequire("fvBJV");

var $3HovY = parcelRequire("3HovY");

const $62fab491e77450ba$export$5760f9690301cdb = (input)=>{
    switch(input){
        case 'no-filter':
            return [
                (0, $3HovY.RELEASED),
                (0, $3HovY.UNRELEASED),
                (0, $3HovY.ARCHIVED)
            ];
        case 'all':
            return [
                (0, $3HovY.RELEASED),
                (0, $3HovY.UNRELEASED),
                (0, $3HovY.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $3HovY.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $3HovY.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $3HovY.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $3HovY.UNRELEASED)
                ];
            }
    }
};
const $62fab491e77450ba$export$46595832dd863016 = (input)=>{
    if (input) {
        if (input.length === 0) return 'no-filter';
        if (input.length > 2) return 'all';
        return [
            input.includes((0, $3HovY.RELEASED)) && [
                'released'
            ],
            input.includes((0, $3HovY.UNRELEASED)) && [
                'unreleased'
            ],
            input.includes((0, $3HovY.ARCHIVED)) && [
                'archived'
            ]
        ].filter(Boolean).join('-');
    }
    return undefined;
};
const $62fab491e77450ba$export$1945e6d2f31e09e6 = (input)=>{
    switch(input){
        case 'ASC':
            return 0, $d350dce85a55cddf$export$1dee026a19752d6b;
        case 'DESC':
            return 0, $d350dce85a55cddf$export$b6abcf7fa1d94f65;
        default:
            return 0, $d350dce85a55cddf$export$b6abcf7fa1d94f65;
    }
};
const $62fab491e77450ba$export$f842a0d1846d319d = (input)=>{
    switch(input){
        case 'NAME':
            return 0, $4684d5b9e49d2e36$export$3c5e605ca7ade9f2;
        case 'RELEASEDATE':
            return 0, $4684d5b9e49d2e36$export$50241fe906e4f94e;
        case 'STARTDATE':
            return 0, $4684d5b9e49d2e36$export$99a467bcc22b8df9;
        case 'DESCRIPTION':
            return 0, $4684d5b9e49d2e36$export$d44826c816b5619b;
        case 'SEQUENCE':
            return 0, $4684d5b9e49d2e36$export$34694f8d8b23ee2a;
        default:
            return 0, $4684d5b9e49d2e36$export$34694f8d8b23ee2a;
    }
};
const $62fab491e77450ba$export$7dad705635760cfe = (input)=>{
    switch(input){
        case 'no-filter':
            return [];
        case 'all':
            return [
                (0, $3HovY.RELEASED),
                (0, $3HovY.UNRELEASED),
                (0, $3HovY.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $3HovY.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $3HovY.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $3HovY.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $3HovY.UNRELEASED)
                ];
            }
    }
};
const $62fab491e77450ba$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
    // Handle the case when a status is selected after deselection of all in dropdown where versions in all statuses are displayed despite empty selection & deselecting a status from a full selection.
    if (displayedStatuses.length === (0, $4684d5b9e49d2e36$export$bbcbc202f2dfa28c)) {
        if (!selectedStatuses.length) return [
            newStatus
        ];
        return displayedStatuses.filter((status)=>status !== newStatus);
    }
    return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
        ...displayedStatuses,
        newStatus
    ];
};
const $62fab491e77450ba$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
        timeZone: (0, $fvBJV.VERSION_DATE_FORMAT_OPTION).timeZone,
        dateStyle: 'long'
    }) : '';

});
/* eslint-disable jira/filename-case */ const $d350dce85a55cddf$export$1dee026a19752d6b = 'ASC';
const $d350dce85a55cddf$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("fvBJV", function(module, exports) {
$parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", () => $75cf4da9a1be7566$export$d54c0d576c2caef5);
/* eslint-disable jira/filename-case */ // Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
const $75cf4da9a1be7566$export$d54c0d576c2caef5 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};

});

parcelRegister("3HovY", function(module, exports) {
$parcel$export(module.exports, "RELEASED", () => $1e0dc0dbdd47d1ab$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $1e0dc0dbdd47d1ab$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $1e0dc0dbdd47d1ab$export$c936349447a77fe0);
/* eslint-disable jira/filename-case */ const $1e0dc0dbdd47d1ab$export$b983f2cb1f658a55 = 'RELEASED';
const $1e0dc0dbdd47d1ab$export$cb459d726a8530a5 = 'UNRELEASED';
const $1e0dc0dbdd47d1ab$export$c936349447a77fe0 = 'ARCHIVED';
const $1e0dc0dbdd47d1ab$var$statuses = [
    $1e0dc0dbdd47d1ab$export$b983f2cb1f658a55,
    $1e0dc0dbdd47d1ab$export$cb459d726a8530a5,
    $1e0dc0dbdd47d1ab$export$c936349447a77fe0
];
var $1e0dc0dbdd47d1ab$export$2e2bcd8739ae039 = $1e0dc0dbdd47d1ab$var$statuses;

});


parcelRegister("e1LXy", function(module, exports) {
$parcel$export(module.exports, "default", () => $e822c5de27de843c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<657fe69fbae1d931b271007cfa02f2d4>>
 * @relayHash 895535a62a5513fa91d9424b03f922de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0cd6689f58d70d089c5ce0d16c3651046806b0d99434650a0e51495ec7741474
const $e822c5de27de843c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialLoadCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isVersionPerProjectLimitEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "alias": "jiraProjectType",
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "MANAGE_VERSIONS"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "canPerform"
    }, v14 = {
        "condition": "isVersionPerProjectLimitEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraVersionsPerProjectLimit",
                "kind": "LinkedField",
                "name": "versionPerProjectLimit",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "limit"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "unreleasedVersionsCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "releasedVersionsCount"
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v16 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v17 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v22 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v23 = [
        v15 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "initialLoadCount"
        },
        v16 /*: any*/ ,
        v17 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "id"
    }, v25 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ProjectVersionsComponentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "alias": "canEditVersions",
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v13 /*: any*/ ,
                                                    "action": "THROW"
                                                }
                                            ],
                                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                        },
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    v15 /*: any*/ ,
                                                    v16 /*: any*/ ,
                                                    v17 /*: any*/ 
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v18 /*: any*/ ,
                                                            v19 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v18 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v20 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v21 /*: any*/ ,
                                                    v22 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "args": v23 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "Table_ReleasesProjectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ProjectVersionsComponentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "alias": "canEditVersions",
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ 
                                    ],
                                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                },
                                v14 /*: any*/ ,
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        v9 /*: any*/ ,
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0cd6689f58d70d089c5ce0d16c3651046806b0d99434650a0e51495ec7741474",
            "metadata": {
                "connection": [
                    {
                        "count": "initialLoadCount",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "versions"
                        ]
                    }
                ]
            },
            "name": "ProjectVersionsComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e822c5de27de843c$var$node.hash = "a16ca98ca354ef2d3f69eaf4750cb039";
var $e822c5de27de843c$export$2e2bcd8739ae039 = $e822c5de27de843c$var$node;

});


parcelRegister("6Doim", function(module, exports) {
$parcel$export(module.exports, "projectSettingsVersionsRoute", () => $bf6d92a221030f09$export$cc9450e5d7579b99);
const $bf6d92a221030f09$export$cc9450e5d7579b99 = {
    name: 'project-settings-versions',
    path: '/plugins/servlet/project-config/:projectKey/administer-versions'
};

});

parcelRegister("ilise", function(module, exports) {
$parcel$export(module.exports, "LazyRelayProjectVersions", () => $4ae3c8de2c6c84dc$export$9036da4fa9f7a66f);
$parcel$export(module.exports, "RelayVersions", () => $4ae3c8de2c6c84dc$export$9aff7dab80671d9);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4ae3c8de2c6c84dc$export$9036da4fa9f7a66f = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("eJH0W"))), {
    moduleId: "./src/packages/spa-apps/project-relay-versions/src/ExportedDefault.tsx"
});
const $4ae3c8de2c6c84dc$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4ae3c8de2c6c84dc$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
$4ae3c8de2c6c84dc$export$9aff7dab80671d9.displayName = "RelayVersions";

});
parcelRegister("eJH0W", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("8X2YY")
]).then(()=>parcelRequire('dL0WI'));

});



parcelRegister("8TKap", function(module, exports) {
$parcel$export(module.exports, "projectsNotFoundRouteEntry", () => $66b8ad72734d58a8$export$c142faf0f38f0f38);

var $iUBrg = parcelRequire("iUBrg");

var $8e9Wj = parcelRequire("8e9Wj");

var $dUAVJ = parcelRequire("dUAVJ");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");
const $66b8ad72734d58a8$var$projectsNotFoundPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8e9Wj.projectNotFoundEntryPoint)
});
const $66b8ad72734d58a8$export$c142faf0f38f0f38 = (0, $fdS54.createEntry)((0, $iUBrg.projectsNotFoundRoute), ()=>({
        group: 'errors',
        entryPoint: ()=>$66b8ad72734d58a8$var$projectsNotFoundPageEntryPoint,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        pageId: 'projects-not-found-page-id',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iUBrg", function(module, exports) {
$parcel$export(module.exports, "projectsNotFoundRoute", () => $88a85bbdb67f80b8$export$bd2cc4c0d8df1a6);
const $88a85bbdb67f80b8$export$bd2cc4c0d8df1a6 = {
    name: 'projects-not-found',
    path: '/jira/projects/not-found',
    exact: true
};

});


parcelRegister("fbMJX", function(module, exports) {
$parcel$export(module.exports, "projectsRedirectRouteEntry", () => $d455d0f7d9c26190$export$56f9921db324f30);


var $hdZjx = parcelRequire("hdZjx");

var $3lEJh = parcelRequire("3lEJh");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $fpfva = parcelRequire("fpfva");
const $d455d0f7d9c26190$export$56f9921db324f30 = (0, $fdS54.createEntry)((0, $fpfva.projectsRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3lEJh.RedirectToLastVisitedProjectPage),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fpfva", function(module, exports) {
$parcel$export(module.exports, "projectsRedirectRoute", () => $3ce1ce693dba0a57$export$e6bc3ea427ddafb8);
const $3ce1ce693dba0a57$export$e6bc3ea427ddafb8 = {
    name: 'projects-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});


parcelRegister("j1cF8", function(module, exports) {
$parcel$export(module.exports, "projectVersionsRouteEntry", () => $55b1c3a6f3c3255c$export$982bc443ef89cc3f);

var $euxye = parcelRequire("euxye");


var $hdZjx = parcelRequire("hdZjx");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $6nzBS = parcelRequire("6nzBS");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $b8phq = parcelRequire("b8phq");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $55b1c3a6f3c3255c$var$LazyRelayProjectVersions = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("eJH0W"))), {
    moduleId: "./src/packages/spa-apps/project-relay-versions/src/ExportedDefault.tsx"
});
const $55b1c3a6f3c3255c$var$RelayVersions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $55b1c3a6f3c3255c$var$LazyRelayProjectVersions,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
$55b1c3a6f3c3255c$var$RelayVersions.displayName = "RelayVersions";
const $55b1c3a6f3c3255c$export$982bc443ef89cc3f = (0, $fdS54.createEntry)((0, $b8phq.projectVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6nzBS.projectVersionsRelayResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $55b1c3a6f3c3255c$var$RelayVersions,
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $55b1c3a6f3c3255c$var$LazyRelayProjectVersions
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("b8phq", function(module, exports) {
$parcel$export(module.exports, "projectVersionsRoute", () => $f58780fd2878b209$export$fb5516756c3eba40);
const $f58780fd2878b209$export$fb5516756c3eba40 = {
    name: 'project-versions',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
    ]
};

});


parcelRegister("6f0V1", function(module, exports) {
$parcel$export(module.exports, "promotionsRouteEntry", () => $26c8ee2cf0d94b3b$export$875d88a44b1ff74c);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $4n4JC = parcelRequire("4n4JC");

var $khI8v = parcelRequire("khI8v");
const $26c8ee2cf0d94b3b$export$875d88a44b1ff74c = (0, $fdS54.createEntry)((0, $4n4JC.promotionsRoute), ()=>({
        group: 'marketplace',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $khI8v.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $khI8v.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4n4JC", function(module, exports) {
$parcel$export(module.exports, "promotionsRoute", () => $0010b55a80fc6b95$export$45df65bfacbf9a2a);
const $0010b55a80fc6b95$export$45df65bfacbf9a2a = {
    name: 'marketplace-promotions',
    path: '/jira/marketplace/manage/promotions'
};

});


parcelRegister("7oChK", function(module, exports) {
$parcel$export(module.exports, "rapidboardBacklog1RouteEntry", () => $62d829806dee9487$export$ee2385c1acba53f2);

var $51vnM = parcelRequire("51vnM");


var $5adCU = parcelRequire("5adCU");

var $fdS54 = parcelRequire("fdS54");

var $eAaRp = parcelRequire("eAaRp");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $3HYSN = parcelRequire("3HYSN");

var $8PWi1 = parcelRequire("8PWi1");

var $QhQu4 = parcelRequire("QhQu4");

var $dvtoW = parcelRequire("dvtoW");

var $75Njg = parcelRequire("75Njg");

var $dUAVJ = parcelRequire("dUAVJ");

var $7tgMD = parcelRequire("7tgMD");

var $jEYuY = parcelRequire("jEYuY");

var $6vLj0 = parcelRequire("6vLj0");

const $62d829806dee9487$export$ee2385c1acba53f2 = (0, $fdS54.createEntry)((0, $6vLj0.rapidboardBacklog1Route), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eAaRp.RapidBoardSpaPage),
        skeleton: (0, $8PWi1.NextGenBacklogSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            ...(0, $dUAVJ.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eAaRp.LazyRapidBoard),
            (0, $eAaRp.LazyRapidBoardApps)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6vLj0", function(module, exports) {
$parcel$export(module.exports, "rapidboardBacklog1Route", () => $4807c187e3b92f42$export$ff874528b0b33a61);
const $4807c187e3b92f42$export$ff874528b0b33a61 = {
    name: 'rapidboard-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(planning|planning.nodetail)'
    ]
};

});


parcelRegister("xpd8X", function(module, exports) {
$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRouteEntry", () => $8b7c7e676377e43b$export$420f86cfd239da4d);
/* eslint-disable import/order */ 

var $3lEJh = parcelRequire("3lEJh");

var $fdS54 = parcelRequire("fdS54");

var $dvtoW = parcelRequire("dvtoW");

var $75Njg = parcelRequire("75Njg");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $cxRas = parcelRequire("cxRas");
const $8b7c7e676377e43b$export$420f86cfd239da4d = (0, $fdS54.createEntry)((0, $cxRas.rapidboardLastVisitedProjectRedirectRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3lEJh.RedirectToLastVisitedProjectPage),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        isRedirect: true,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cxRas", function(module, exports) {
$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", () => $8aa9782b7d144983$export$991b1be164057e91);
const $8aa9782b7d144983$export$991b1be164057e91 = {
    name: 'rapidboard-last-visited-project-redirect',
    path: '/secure/RapidBoard.jspa',
    query: [
        'projectKey'
    ],
    __unsafeOrder: 1
};

});


parcelRegister("j42ZP", function(module, exports) {
$parcel$export(module.exports, "rapidboardReport1RouteEntry", () => $437ffc8bc7d775c7$export$7e8c0a9f6d68837);

var $51vnM = parcelRequire("51vnM");


var $5adCU = parcelRequire("5adCU");

var $fdS54 = parcelRequire("fdS54");

var $eAaRp = parcelRequire("eAaRp");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $3HYSN = parcelRequire("3HYSN");

var $dvtoW = parcelRequire("dvtoW");

var $dUAVJ = parcelRequire("dUAVJ");

var $7tgMD = parcelRequire("7tgMD");

var $jEYuY = parcelRequire("jEYuY");

var $4xlh4 = parcelRequire("4xlh4");

var $792kp = parcelRequire("792kp");

var $bXFey = parcelRequire("bXFey");
const $437ffc8bc7d775c7$export$7e8c0a9f6d68837 = (0, $fdS54.createEntry)((0, $4xlh4.rapidboardReport1Route), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eAaRp.RapidBoardSpaPage),
        skeleton: (0, $792kp.ClassicReportSkeleton),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            ...(0, $bXFey.getReportsCommonResource)(),
            ...(0, $dUAVJ.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eAaRp.LazyRapidBoard),
            (0, $eAaRp.LazyRapidBoardApps)
        ],
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4xlh4", function(module, exports) {
$parcel$export(module.exports, "rapidboardReport1Route", () => $eaf05017ca135e19$export$d27f9ad2fc277ff9);
const $eaf05017ca135e19$export$d27f9ad2fc277ff9 = {
    name: 'rapidboard-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});

parcelRegister("792kp", function(module, exports) {
$parcel$export(module.exports, "ClassicReportSkeleton", () => $d6d2c77f5d4caa10$export$d7667341f4db3b8d);

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $4ekkq = parcelRequire("4ekkq");
const $d6d2c77f5d4caa10$export$d7667341f4db3b8d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4ekkq)))
    });
$d6d2c77f5d4caa10$export$d7667341f4db3b8d.displayName = "ClassicReportSkeleton";

});
parcelRegister("4ekkq", function(module, exports) {
module.exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();

});



parcelRegister("5RPQd", function(module, exports) {
$parcel$export(module.exports, "rapidboardReportRouteEntry", () => $40b11b072fb85b42$export$745f1d5a2458a2d9);

var $51vnM = parcelRequire("51vnM");



var $5adCU = parcelRequire("5adCU");

var $fdS54 = parcelRequire("fdS54");

var $78wel = parcelRequire("78wel");

var $eAaRp = parcelRequire("eAaRp");

var $792kp = parcelRequire("792kp");

var $dvtoW = parcelRequire("dvtoW");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $jEYuY = parcelRequire("jEYuY");

var $3HYSN = parcelRequire("3HYSN");

var $i860n = parcelRequire("i860n");

var $bXFey = parcelRequire("bXFey");

var $65SUb = parcelRequire("65SUb");
const $40b11b072fb85b42$export$745f1d5a2458a2d9 = (0, $fdS54.createEntry)((0, $78wel.rapidboardReportRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eAaRp.RapidBoardSpaPage),
        skeleton: (0, $792kp.ClassicReportSkeleton),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            ...(0, $bXFey.getReportsCommonResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eAaRp.LazyRapidBoard),
            (0, $eAaRp.LazyRapidBoardApps)
        ],
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? (0, $65SUb.GSNReportPageProjectEntrypoint) : (0, $65SUb.reportPageProjectEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("78wel", function(module, exports) {
$parcel$export(module.exports, "rapidboardReportRoute", () => $55f278310ca502fa$export$d37f637b09fb9fda);
const $55f278310ca502fa$export$d37f637b09fb9fda = {
    name: 'rapidboard-report',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
};

});

parcelRegister("65SUb", function(module, exports) {
$parcel$export(module.exports, "reportPageEntrypoint", () => $abe0dadb27562fc8$export$73cecf7395943edd);
$parcel$export(module.exports, "reportPageProjectEntrypoint", () => $abe0dadb27562fc8$export$bf3e4f038f61a19c);
$parcel$export(module.exports, "GSNReportPageProjectEntrypoint", () => $abe0dadb27562fc8$export$68a20ab3b23784ff);

var $hi6Of = parcelRequire("hi6Of");

var $jXOli = parcelRequire("jXOli");

var $dTa0V = parcelRequire("dTa0V");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");
const $abe0dadb27562fc8$export$73cecf7395943edd = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $jXOli.rapidBoardEntryPoint)
});
const $abe0dadb27562fc8$export$bf3e4f038f61a19c = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $jXOli.rapidBoardEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $abe0dadb27562fc8$export$68a20ab3b23784ff = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $jXOli.rapidBoardEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("jXOli", function(module, exports) {
$parcel$export(module.exports, "rapidBoardEntryPoint", () => $62a2bd0ea8e3d7fa$export$15991360ec37fcaf);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $62a2bd0ea8e3d7fa$export$15991360ec37fcaf = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gvCKS")), {
        moduleId: "cb22816a",
        moduleName: "RapidBoardWrapper",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("gvCKS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fJJJ4").then(()=>parcelRequire('9oOxP'));

});




parcelRegister("eGqTw", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserBacklogRouteEntry", () => $99bb6553a02954bb$export$ccde3c1d7a857b27);

var $51vnM = parcelRequire("51vnM");

var $jFwZ0 = parcelRequire("jFwZ0");


var $5adCU = parcelRequire("5adCU");

var $hRSPo = parcelRequire("hRSPo");

var $4TFaG = parcelRequire("4TFaG");

var $5zPGY = parcelRequire("5zPGY");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $loJVV = parcelRequire("loJVV");

var $3bgcx = parcelRequire("3bgcx");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $3HYSN = parcelRequire("3HYSN");

var $1CX3l = parcelRequire("1CX3l");

var $8PWi1 = parcelRequire("8PWi1");

var $QhQu4 = parcelRequire("QhQu4");

var $dvtoW = parcelRequire("dvtoW");

var $75Njg = parcelRequire("75Njg");

var $8HUuJ = parcelRequire("8HUuJ");

var $dUAVJ = parcelRequire("dUAVJ");

var $gSeiR = parcelRequire("gSeiR");

var $fr3J5 = parcelRequire("fr3J5");
const $99bb6553a02954bb$export$ccde3c1d7a857b27 = (0, $fdS54.createEntry)((0, $1CX3l.rapidboardUserBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-user-backlog',
        skeleton: (0, $8PWi1.NextGenBacklogSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getUIFBacklogDataResource)(),
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            ...(0, $dUAVJ.getUserBoardNavigationResources)(),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!false || (0, $i860n.fg)('enable_ssr_for_cmp_backlog'), (0, $loJVV.epicsLiteResource)),
            (0, $5zPGY.backlogCMPViewSettingsResource),
            (0, $jFwZ0.currentUserResource),
            (0, $3bgcx.permissionsResource)
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $fr3J5.backlogPageEntrypoint),
        meta: {
            capability: (0, $gSeiR.classicBacklogCapability)
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1CX3l", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserBacklogRoute", () => $25c4983103cee6ad$export$79c2d9718e914f91);
const $25c4983103cee6ad$export$79c2d9718e914f91 = {
    name: 'rapidboard-user-backlog',
    path: '/jira/people/:accountId/boards/:boardId/backlog'
};

});

parcelRegister("gSeiR", function(module, exports) {
$parcel$export(module.exports, "classicBacklogCapability", () => $cad2dfbf136ee3a2$export$10a7bb102137d92b);

const $cad2dfbf136ee3a2$export$10a7bb102137d92b = !false ? (0, $0ce01f968965dadd$export$571692eec8a399e1) : (0, $0ce01f968965dadd$export$93104dc4eba58ba4);

});

parcelRegister("fr3J5", function(module, exports) {
$parcel$export(module.exports, "backlogPageEntrypoint", () => $3221dbc6829b8f97$export$1ccf08591607897d);

var $hi6Of = parcelRequire("hi6Of");

var $1JQn3 = parcelRequire("1JQn3");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $3221dbc6829b8f97$export$1ccf08591607897d = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1JQn3.nextGenBacklogEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("8fN46", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserReportRouteEntry", () => $c189941fc3705033$export$374d78dc1cde7b56);

var $51vnM = parcelRequire("51vnM");


var $5adCU = parcelRequire("5adCU");

var $fdS54 = parcelRequire("fdS54");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $3HYSN = parcelRequire("3HYSN");

var $dvtoW = parcelRequire("dvtoW");

var $dUAVJ = parcelRequire("dUAVJ");

var $JDYEQ = parcelRequire("JDYEQ");

var $792kp = parcelRequire("792kp");

var $bXFey = parcelRequire("bXFey");

var $65SUb = parcelRequire("65SUb");
const $c189941fc3705033$export$374d78dc1cde7b56 = (0, $fdS54.createEntry)((0, $JDYEQ.rapidboardUserReportRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $792kp.ClassicReportSkeleton),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            ...(0, $bXFey.getReportsCommonResource)(),
            ...(0, $dUAVJ.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $65SUb.reportPageEntrypoint),
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("JDYEQ", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserReportRoute", () => $a274af96effacf48$export$7b85bca17717def6);
const $a274af96effacf48$export$7b85bca17717def6 = {
    name: 'rapidboard-user-report',
    path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
};

});


parcelRegister("5rviH", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserReportsOverviewRouteEntry", () => $84a937451aac92d9$export$721c38d3152f9625);
/* eslint-disable import/order */ 

var $5dHZ6 = parcelRequire("5dHZ6");

var $5adCU = parcelRequire("5adCU");

var $fdS54 = parcelRequire("fdS54");

var $bK2fg = parcelRequire("bK2fg");

var $dvtoW = parcelRequire("dvtoW");

var $75Njg = parcelRequire("75Njg");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $hWEkS = parcelRequire("hWEkS");

var $dUAVJ = parcelRequire("dUAVJ");
const $84a937451aac92d9$var$reportsOverviewPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5dHZ6.reportsOverviewPageEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $84a937451aac92d9$export$721c38d3152f9625 = (0, $fdS54.createEntry)((0, $bK2fg.rapidboardUserReportsOverviewRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return $84a937451aac92d9$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            ...(0, $dUAVJ.getUserBoardNavigationResources)(),
            ...(0, $5adCU.getRapidboardResources)()
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bK2fg", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserReportsOverviewRoute", () => $d7916f50788ade4a$export$6101ec4dca41c740);
const $d7916f50788ade4a$export$6101ec4dca41c740 = {
    name: 'rapidboard-user-reports-overview',
    path: '/jira/people/:accountId/boards/:boardId/reports',
    query: [
        'dashboardId?'
    ]
};

});


parcelRegister("3cktz", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationDetailRouteEntry", () => $864a1db052434f41$export$565325825b04cec6);



var $6RSCO = parcelRequire("6RSCO");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $c88cw = parcelRequire("c88cw");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $eFpvL = parcelRequire("eFpvL");

var $bkrFd = parcelRequire("bkrFd");

var $lNEH0 = parcelRequire("lNEH0");

var $91fTI = parcelRequire("91fTI");
const $864a1db052434f41$export$565325825b04cec6 = (0, $fdS54.createEntry)((0, $eFpvL.roleBasedNotificationDetailRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lNEH0.RoleBasedNotificationsComponent),
        layout: (0, $ju22D.globalSettingsLayout),
        slot: (0, $91fTI.RoleBasedNotificationDetail),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $c88cw.resources)[0],
            (0, $c88cw.resources)[1],
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lNEH0.LazyRoleBasedNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c88cw", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationsResource", () => $1595eec7a8d4bc1e$export$9a716bf20d804ec3);
$parcel$export(module.exports, "notificationDetailResource", () => $1595eec7a8d4bc1e$export$8ad8a0a20fd0ed5a);
$parcel$export(module.exports, "resources", () => $1595eec7a8d4bc1e$export$bc99aaabaf7b70a7);

var $7edbf = parcelRequire("7edbf");

var $7Ljuo = parcelRequire("7Ljuo");
var $jpT5w = parcelRequire("jpT5w");

var $ioLpZ = parcelRequire("ioLpZ");
const $1595eec7a8d4bc1e$export$9a716bf20d804ec3 = (0, $7edbf.createResource)({
    type: 'roleBasedNotificationsResource',
    getKey: ()=>'roleBasedNotificationsResource',
    getData: (0, $ioLpZ.getRoleBasedNotificationsEndpoint),
    isBrowserOnly: true,
    maxAge: 300000
});
const $1595eec7a8d4bc1e$export$8ad8a0a20fd0ed5a = (0, $7edbf.createResource)({
    type: 'notificationDetailResource',
    getKey: ({ match: match })=>{
        const settingId = match.params['id'];
        return `notificationDetailResource-id=${settingId}`;
    },
    getData: ({ match: match })=>{
        const settingId = match.params['id'];
        (0, $7Ljuo.assert)(!!settingId, new (0, $jpT5w.AssertionError)('notificationDetailResource', 'settingId is required'));
        return (0, $ioLpZ.getRoleBasedNotificationDetailEndpoint)(settingId);
    },
    isBrowserOnly: true
});
const $1595eec7a8d4bc1e$export$bc99aaabaf7b70a7 = [
    $1595eec7a8d4bc1e$export$9a716bf20d804ec3,
    $1595eec7a8d4bc1e$export$8ad8a0a20fd0ed5a
];

});
parcelRegister("ioLpZ", function(module, exports) {
$parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", () => $1b40424f6f80a698$export$db67dfe9fe98cd49);
$parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", () => $1b40424f6f80a698$export$5522446e6d3ee73);

var $hG5S4 = parcelRequire("hG5S4");
const $1b40424f6f80a698$export$db67dfe9fe98cd49 = ()=>(0, $hG5S4.eocFetch)(`/v1/role-based-notifications`);
const $1b40424f6f80a698$export$5522446e6d3ee73 = (settingId)=>(0, $hG5S4.eocFetch)(`/v1/role-based-notifications/${settingId}`);

});


parcelRegister("eFpvL", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationDetailRoute", () => $05fbffe8879e559f$export$10ec812f053317c9);
const $05fbffe8879e559f$export$10ec812f053317c9 = {
    name: 'eoc-role-based-notifications-detail',
    path: '/jira/settings/products/ops/role-based-notifications/:id',
    exact: true
};

});

parcelRegister("lNEH0", function(module, exports) {
$parcel$export(module.exports, "LazyRoleBasedNotifications", () => $ec4b1582b65e565a$export$15a244aba8f3b406);
$parcel$export(module.exports, "RoleBasedNotificationsComponent", () => $ec4b1582b65e565a$export$8994be6f8ad6a04a);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $ec4b1582b65e565a$export$15a244aba8f3b406 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7vbka")).then((module)=>module.RoleBasedNotificationsPage), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $ec4b1582b65e565a$export$8994be6f8ad6a04a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ec4b1582b65e565a$export$15a244aba8f3b406,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });
$ec4b1582b65e565a$export$8994be6f8ad6a04a.displayName = "RoleBasedNotificationsComponent";

});
parcelRegister("7vbka", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hC1RD").then(()=>parcelRequire('6dqiw'));

});


parcelRegister("91fTI", function(module, exports) {
$parcel$export(module.exports, "RoleBasedNotificationDetail", () => $ab2829951a82fe17$export$445112c3a1089cc5);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $ab2829951a82fe17$export$5211e5a7ed694f98 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7vbka")).then((module)=>module.RoleBasedNotificationDetail), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $ab2829951a82fe17$export$445112c3a1089cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ab2829951a82fe17$export$5211e5a7ed694f98,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });
$ab2829951a82fe17$export$445112c3a1089cc5.displayName = "RoleBasedNotificationDetail";

});


parcelRegister("ara35", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationsRouteEntry", () => $17c2d28c5dc0a422$export$60de9875bb8ef1d6);



var $6RSCO = parcelRequire("6RSCO");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $c88cw = parcelRequire("c88cw");

var $jEYuY = parcelRequire("jEYuY");

var $7Fzs6 = parcelRequire("7Fzs6");

var $fdS54 = parcelRequire("fdS54");

var $ambug = parcelRequire("ambug");

var $bkrFd = parcelRequire("bkrFd");

var $lNEH0 = parcelRequire("lNEH0");
const $17c2d28c5dc0a422$var$getNavigationSpecifications = ()=>{
    return {
        sidebarId: (0, $69db4b0f28295983$export$e0323f266e5e0bb8)
    };
};
const $17c2d28c5dc0a422$export$60de9875bb8ef1d6 = (0, $fdS54.createEntry)((0, $ambug.roleBasedNotificationsRoute), ()=>({
        group: 'eoc',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lNEH0.RoleBasedNotificationsComponent),
        layout: (0, $7Fzs6.opsSettingsLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $c88cw.resources)[0],
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea),
            ...$17c2d28c5dc0a422$var$getNavigationSpecifications()
        },
        forPaint: [
            (0, $bkrFd.LazySidebarContent),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lNEH0.LazyRoleBasedNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ambug", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationsRoute", () => $804efe3298d5528b$export$5a10092825ee32e4);
const $804efe3298d5528b$export$5a10092825ee32e4 = {
    name: 'eoc-role-based-notifications',
    path: '/jira/settings/products/ops/role-based-notifications',
    exact: true
};

});


parcelRegister("g8c5T", function(module, exports) {
$parcel$export(module.exports, "rovoSearchRouteEntry", () => $576da89f1ff0c8fe$export$64c44018a429a3ed);

var $euxye = parcelRequire("euxye");

var $dUAVJ = parcelRequire("dUAVJ");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $5bg1i = parcelRequire("5bg1i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $576da89f1ff0c8fe$var$LazyRovoSearchPage = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("8KyLz"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $576da89f1ff0c8fe$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $576da89f1ff0c8fe$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
$576da89f1ff0c8fe$var$RovoSearchPage.displayName = "RovoSearchPage";
const $576da89f1ff0c8fe$export$64c44018a429a3ed = (0, $fdS54.createEntry)((0, $5bg1i.rovoSearchRoute), ()=>({
        group: 'search',
        // eslint-disable-next-line no-restricted-syntax
        component: $576da89f1ff0c8fe$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            $576da89f1ff0c8fe$var$LazyRovoSearchPage
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5bg1i", function(module, exports) {
$parcel$export(module.exports, "rovoSearchRoute", () => $ddda2ba6340241da$export$c45b7c601eb1ba93);
const $ddda2ba6340241da$export$c45b7c601eb1ba93 = {
    name: 'jira-rovo-search',
    path: '/jira/cross-product-search',
    exact: true
};

});


parcelRegister("fy0kN", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerRouteEntry", () => $174a094584628788$export$71497b88db8291d0);

var $euxye = parcelRequire("euxye");

var $lFLfF = parcelRequire("lFLfF");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $jepRN = parcelRequire("jepRN");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $aJInz = parcelRequire("aJInz");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $174a094584628788$var$LazySandboxBundlerPage = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("lPPfQ"))), {
    moduleId: "./src/packages/spa-apps/sandbox-bundler/src/index.tsx"
});
const $174a094584628788$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $174a094584628788$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler",
        shouldShowSpinner: true
    });
$174a094584628788$var$SandboxBundler.displayName = "SandboxBundler";
const $174a094584628788$export$71497b88db8291d0 = (0, $fdS54.createEntry)((0, $aJInz.sandboxBundlerRoute), ()=>({
        group: 'sandbox',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jepRN.componentWithFG)('conditional_import_sandbox', $174a094584628788$var$SandboxBundler, (0, $lFLfF.default)),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $174a094584628788$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler',
        bifrost: {
            bifrostGroup: 'not-deployed',
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("aJInz", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerRoute", () => $32700db587c30cc3$export$3891624aac454ec2);
const $32700db587c30cc3$export$3891624aac454ec2 = {
    name: 'sandbox-bundler',
    path: '/jira/software/sandbox/bundler',
    exact: true
};

});

parcelRegister("lPPfQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");



module.exports = Promise.all([
    (parcelRequire("gZgW8"))('test_conditional_imports', function() {
        return Promise.all([
            (parcelRequire("gZgW8"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $4cvLQ("6o4IV")
                ]);
            }, function() {
                return Promise.all([
                    $4cvLQ("iiqYN")
                ]);
            }),
            $4cvLQ("1PTuj")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("gZgW8"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $4cvLQ("6o4IV")
                ]);
            }, function() {
                return Promise.all([
                    $4cvLQ("iiqYN")
                ]);
            }),
            $4cvLQ("cSijE")
        ]);
    }),
    $4cvLQ("egT9R")
]).then(()=>parcelRequire('jfEyW'));

});


parcelRegister("aS8vp", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRouteEntry", () => $0297e5399a1e74a8$export$38fc3637f21e26b2);

var $8kxaA = parcelRequire("8kxaA");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $fUNU8 = parcelRequire("fUNU8");

var $dTa0V = parcelRequire("dTa0V");
const $0297e5399a1e74a8$var$sandboxRelayEchoPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8kxaA.sandboxEchoPageEntryPoint)
});
const $0297e5399a1e74a8$export$38fc3637f21e26b2 = (0, $fdS54.createEntry)((0, $fUNU8.sandboxRelayEchoPageUsingEntryPointRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>$0297e5399a1e74a8$var$sandboxRelayEchoPageEntryPoint,
        layout: (0, $h2tgz.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-echo',
        bifrost: {
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // manifestName: 'jira-spa-sandboxdemo.json',
            bifrostGroup: 'not-deployed'
        }
    }));

});
parcelRegister("8kxaA", function(module, exports) {
$parcel$export(module.exports, "sandboxEchoPageEntryPoint", () => $098a65f5a542234d$export$d3ff1e280a8985f3);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $hObIM = parcelRequire("hObIM");

const $098a65f5a542234d$export$d3ff1e280a8985f3 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("glY7U")), {
        moduleId: "856e4503",
        moduleName: "SandboxEchoPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: routerContext })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $hObIM.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
                        skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("hObIM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec22de015aa44d7e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4809c2b1ce33f2c5180608521bcd597c>>
 * @relayHash 34217eab0f370d5568f7c0ae333e556f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9
const $ec22de015aa44d7e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipLongQuery"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "alias": "criticalMessage",
        "args": v2 /*: any*/ ,
        "kind": "ScalarField",
        "name": "echo"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer1"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer2"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer3"
                                    }
                                ]
                            },
                            {
                                "condition": "skipLongQuery",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "Defer",
                                        "selections": [
                                            {
                                                "args": v2 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "SandboxEchoVeryLongQuery"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer1_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer1",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 500
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer2_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer2",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 700
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer3_1jcU60",
                            "selections": [
                                {
                                    "alias": "defer3",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 900
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                },
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoDefer3$defer$SandboxEchoNestedDefer_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "nestedImmediate",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer1",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer2",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "skipLongQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoPageQuery$defer$SandboxEchoVeryLongQuery_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "wasItWorthTheWait",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 5000
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9",
            "metadata": {},
            "name": "SandboxEchoPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ec22de015aa44d7e$var$node.hash = "2c6c898652168087f8a3a2478b34296f";
var $ec22de015aa44d7e$export$2e2bcd8739ae039 = $ec22de015aa44d7e$var$node;

});

parcelRegister("glY7U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Sa92").then(()=>parcelRequire('aNNYn'));

});


parcelRegister("fUNU8", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRoute", () => $972fef884ce68974$export$eaecd670f9df9fd6);
const $972fef884ce68974$export$eaecd670f9df9fd6 = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});


parcelRegister("1K6EX", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRouteEntry", () => $eec15be06d309659$export$3981404cc747e85);


var $hnYJO = parcelRequire("hnYJO");

var $4B518 = parcelRequire("4B518");

var $eQDIg = parcelRequire("eQDIg");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $1qodr = parcelRequire("1qodr");

var $75Njg = parcelRequire("75Njg");

var $gg59A = parcelRequire("gg59A");
const $eec15be06d309659$export$3981404cc747e85 = (0, $fdS54.createEntry)((0, $1qodr.sandboxRelayEchoPageUsingRLLRoute), ()=>({
        group: 'sandbox',
        layout: (0, $h2tgz.globalLayout),
        skeleton: (0, $gg59A.Skeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hnYJO.AsyncSandboxEchoPage),
        lazyForPaint: [
            (0, $hnYJO.AsyncSandboxEchoPage)
        ],
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $eQDIg.sandboxEchoPageRelayResource)
        ],
        ufoName: 'sandbox-relay-echo',
        bifrost: {
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // manifestName: 'jira-spa-sandboxdemo.json',
            bifrostGroup: 'not-deployed'
        }
    }));

});
parcelRegister("hnYJO", function(module, exports) {
$parcel$export(module.exports, "AsyncSandboxEchoPage", () => $42f14292ae74441e$export$3e76bcb04553d279);
/* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */ 
var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $eQDIg = parcelRequire("eQDIg");

var $l8G1z = parcelRequire("l8G1z");

var $htsFl = parcelRequire("htsFl");

var $jhKsF = parcelRequire("jhKsF");

var $a8EUd = parcelRequire("a8EUd");

var $hObIM = parcelRequire("hObIM");

const $42f14292ae74441e$export$cc4c54c1ebe3736c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("glY7U"))), {
    moduleId: "./src/packages/spa-apps/sandbox-relay/src/ui/SandboxEchoPage.tsx"
});
const $42f14292ae74441e$export$131119b9314343c7 = ()=>{
    const [queryReference, loadQuery] = (0, $n67Vb.useQueryLoader)((0, $hObIM.default));
    if (queryReference == null) {
        loadQuery({
            cloudId: '7088b486-bbf4-4e1f-9195-412bfac4be28',
            enableDefer: true,
            skipLongQuery: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("small", null, "Triggering query...");
    }
    const props = {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("small", null, "Self-starting sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "self-starting-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($42f14292ae74441e$export$cc4c54c1ebe3736c, props)));
};
$42f14292ae74441e$export$131119b9314343c7.displayName = "SelfStartingSandboxEchoPage";
const $42f14292ae74441e$export$3e76bcb04553d279 = ()=>{
    const { queryReference: queryReference } = (0, $htsFl.useRelayResource)((0, $eQDIg.sandboxEchoPageRelayResource));
    const props = queryReference ? {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    } : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("small", null, "Async sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, props && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($42f14292ae74441e$export$cc4c54c1ebe3736c, props)));
};
$42f14292ae74441e$export$3e76bcb04553d279.displayName = "AsyncSandboxEchoPage";

});
parcelRegister("eQDIg", function(module, exports) {
$parcel$export(module.exports, "sandboxEchoPageRelayResource", () => $1f43ae6f095290d2$export$1d94b7b81d2cfb0c);
/* eslint-disable jira/filename-case, jira/import-whitelist, jira/naming/disallow-filenames */ 
var $n67Vb = parcelRequire("n67Vb");

var $hObIM = parcelRequire("hObIM");

var $7edbf = parcelRequire("7edbf");

var $aI7em = parcelRequire("aI7em");

var $5SJ3N = parcelRequire("5SJ3N");

var $htsFl = parcelRequire("htsFl");
const $1f43ae6f095290d2$export$1d94b7b81d2cfb0c = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_SANDBOX_RELAY_DEFER_ECHO`,
    getKey: ()=>'sandbox-relay-defer-echo',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        // Bail if the request opted out of SSR rendering
        if (false && 'ssr' in routerContext.query && routerContext.query.ssr === 'false') return null;
        const variables = {
            cloudId: tenantContext.cloudId,
            enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
            skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
        };
        const options = {
            fetchPolicy: 'store-and-network'
        };
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $hObIM.default), variables, options);
        if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});


parcelRegister("1qodr", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRoute", () => $9d349cb8d7350029$export$382892be07e8f9fc);
const $9d349cb8d7350029$export$382892be07e8f9fc = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("gg59A", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $381dce2c88d1c8c5$export$8f31e4c4a37b8e9c);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");
const $381dce2c88d1c8c5$export$8f31e4c4a37b8e9c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), {
        id: "router-routes-sandbox-entries.loading-the-sandbox-page",
        defaultMessage: "Loading the sandbox page..."
    });
};
$381dce2c88d1c8c5$export$8f31e4c4a37b8e9c.displayName = "Skeleton";

});


parcelRegister("lYrMg", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayJiraPageRouteEntry", () => $c56bb49b8cf575ef$export$c19004b7e7b87ab0);

var $joQNM = parcelRequire("joQNM");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $7T4VG = parcelRequire("7T4VG");

var $dTa0V = parcelRequire("dTa0V");
const $c56bb49b8cf575ef$var$sandboxRelayJiraPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $joQNM.sandboxJiraPageEntryPoint)
});
const $c56bb49b8cf575ef$export$c19004b7e7b87ab0 = (0, $fdS54.createEntry)((0, $7T4VG.sandboxRelayJiraPageRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>$c56bb49b8cf575ef$var$sandboxRelayJiraPageEntryPoint,
        layout: (0, $h2tgz.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-jirasearch',
        bifrost: {
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // manifestName: 'jira-spa-sandboxdemo.json',
            bifrostGroup: 'not-deployed'
        }
    }));

});
parcelRegister("joQNM", function(module, exports) {
$parcel$export(module.exports, "sandboxJiraPageEntryPoint", () => $5a7e80faa23375ab$export$d56ccd62431eaba5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6jDnC = parcelRequire("6jDnC");

const $5a7e80faa23375ab$export$d56ccd62431eaba5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("iw2Gl")), {
        moduleId: "3350c9e4",
        moduleName: "SandboxJiraPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: context })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $6jDnC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in context.query ? context.query.defer === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("6jDnC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e07a87a1108ec61$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c5ddac0c3f16e46110084c79a89632d>>
 * @relayHash 3037c8cb08fdd5bd0f2bb8885e4a147b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4
const $4e07a87a1108ec61$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "SandboxJiraCriticalData"
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraUserPreferences"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraAiStuff"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraIssueSearch"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "childIssuesLimit"
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraUserPreferences_PVNZy",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isIssueViewCrossFlowBannerDismissed"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCustomNavBarThemeFlagDismissed"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraAiStuff_PVNZy",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "atlassianIntelligenceProductFeatureInput",
                                            "value": {
                                                "product": "JIRA_SOFTWARE"
                                            }
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "shouldShowAtlassianIntelligence"
                                },
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "isRovoEnabled"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraIssueSearch_1jcU60",
                            "selections": [
                                {
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "issueSearchInput",
                                            "value": {
                                                "jql": "ORDER BY created DESC"
                                            }
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "idsOrAliases",
                                                                    "value": [
                                                                        "assignee",
                                                                        "reporter",
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "fieldsByIdOrAlias",
                                                            "plural": true,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "if": "enableDefer",
                                                                    "kind": "Defer",
                                                                    "label": "SandboxJiraIssueWithDeferCard$defer$SandboxJiraIssueFieldEditability",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isEditableInIssueView"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusField"
                                                                }
                                                            ],
                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"assignee\",\"reporter\",\"status\"])"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4",
            "metadata": {},
            "name": "SandboxJiraPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4e07a87a1108ec61$var$node.hash = "1a8ba1e200e80a9f80ac57367382ae4b";
var $4e07a87a1108ec61$export$2e2bcd8739ae039 = $4e07a87a1108ec61$var$node;

});

parcelRegister("iw2Gl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j5YI1").then(()=>parcelRequire('4n6Ze'));

});


parcelRegister("7T4VG", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayJiraPageRoute", () => $2b02e0b5fa058018$export$71a894fccabfdcfa);
const $2b02e0b5fa058018$export$71a894fccabfdcfa = {
    name: 'sandbox-relay-defer-jira',
    path: '/jira/software/sandbox/relay/jirasearch',
    exact: true
};

});


parcelRegister("hi76j", function(module, exports) {
$parcel$export(module.exports, "schedulesRouteEntry", () => $62fd8429eaf56427$export$a4dfbf2ef256b88);

var $i0FZ2 = parcelRequire("i0FZ2");

var $bFQwU = parcelRequire("bFQwU");

var $bKvns = parcelRequire("bKvns");


var $jFwZ0 = parcelRequire("jFwZ0");

var $co13a = parcelRequire("co13a");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");
const $62fd8429eaf56427$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $62fd8429eaf56427$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $i0FZ2.schedulesEntryPoint)
});
const $62fd8429eaf56427$export$a4dfbf2ef256b88 = (0, $fdS54.createEntry)((0, $bFQwU.schedulesRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        skeleton: (0, $bKvns.PageSkeleton),
        ufoName: 'jsm-schedules',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        resources: [
            (0, $co13a.routingOnboardingFinishedResource),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $jFwZ0.currentUserResource)
        ],
        entryPoint: ()=>{
            if (!$62fd8429eaf56427$var$isWorkforceAemEnabled() || !(0, $i860n.fg)('jsm_workforce_optimization_main')) return undefined;
            return $62fd8429eaf56427$var$entryPoint;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("i0FZ2", function(module, exports) {
$parcel$export(module.exports, "schedulesEntryPoint", () => $c6e3daad93783d19$export$ac9a42077639a381);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $2iWg4 = parcelRequire("2iWg4");

const $c6e3daad93783d19$export$ac9a42077639a381 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aoYOL")), {
        moduleId: "49277a9a",
        moduleName: "SchedulesPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = match.params?.projectKey ?? '';
        // Both teamSchedules and shifts omit startTime/endTime on initial fetch.
        // The backend resolves the current week from the Jira user timezone
        // and returns it as resolvedDateRange in the response.
        return {
            queries: {
                teamSchedulesQuery: {
                    parameters: (0, $2iWg4.default),
                    variables: {
                        cloudId: cloudId,
                        input: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        },
                        shiftsInput: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        },
                        wfoSummaryInput: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        },
                        includeWfoForecastingBannerPreload: Boolean((0, $i860n.fg)('wfo_forecasting_dashboard_creation_preloaded_query')),
                        first: 10,
                        isInitialFetch: true
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("2iWg4", function(module, exports) {
$parcel$export(module.exports, "default", () => $754857c4e71b346d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<652ea7af242e03bfaf2732c7a499d0d6>>
 * @relayHash cfc990ad5a494b6624e86684c7b43e0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 656de23d90aa2410db1829f8216ec0ff174367722f5bec0cb54067cec7559a19
const $754857c4e71b346d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "656de23d90aa2410db1829f8216ec0ff174367722f5bec0cb54067cec7559a19",
        "metadata": {},
        "name": "SchedulesPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $754857c4e71b346d$export$2e2bcd8739ae039 = $754857c4e71b346d$var$node;

});

parcelRegister("aoYOL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bhZmW")
]).then(()=>parcelRequire('bDuLE'));

});


parcelRegister("bFQwU", function(module, exports) {
$parcel$export(module.exports, "schedulesRoute", () => $0c3d42740400fa2b$export$edd16a2109da3a1b);
const $0c3d42740400fa2b$export$edd16a2109da3a1b = {
    name: 'servicedesk-schedules',
    path: '/jira/servicedesk/projects/:projectKey/schedules',
    exact: true
};

});

parcelRegister("bKvns", function(module, exports) {
$parcel$export(module.exports, "PageSkeleton", () => $ba352aee8cea72d4$export$6d7d475dd49a348);

var $euxye = parcelRequire("euxye");

var $dBPzz = parcelRequire("dBPzz");
const $ba352aee8cea72d4$export$6d7d475dd49a348 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dBPzz.PageSkeleton), null);
$ba352aee8cea72d4$export$6d7d475dd49a348.displayName = "PageSkeleton";

});
parcelRegister("dBPzz", function(module, exports) {
$parcel$export(module.exports, "PageSkeleton", () => $254bb1c302e62e26$export$6d7d475dd49a348);
/* PageSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $2XXtG = parcelRequire("2XXtG");

var $ihEDU = parcelRequire("ihEDU");

var $1lxtp = parcelRequire("1lxtp");
const $254bb1c302e62e26$var$styles = {
    container: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    contentContainer: "_19pkoahv"
};
const $254bb1c302e62e26$export$6d7d475dd49a348 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $254bb1c302e62e26$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "29px",
        width: "123px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "29px",
        width: "123px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "29px",
        width: "123px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $254bb1c302e62e26$var$styles.contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lxtp.SchedulesPageSkeleton), null)));
$254bb1c302e62e26$export$6d7d475dd49a348.displayName = "PageSkeleton";

});
parcelRegister("1lxtp", function(module, exports) {
$parcel$export(module.exports, "SchedulesPageSkeleton", () => $19aea8a940d73425$export$754969bdca685d69);
/* SchedulesPageSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $gFnJK = parcelRequire("gFnJK");

var $3NRLa = parcelRequire("3NRLa");

var $2XXtG = parcelRequire("2XXtG");
const $19aea8a940d73425$var$styles = {
    filtersContainer: "_19pkoahv",
    calendarContainer: "_4t3i1kxc _19bvpxbi _19pkxy5q"
};
const $19aea8a940d73425$export$754969bdca685d69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "64px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "64px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "64px",
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        justifyContent: "end",
        xcss: $19aea8a940d73425$var$styles.filtersContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "35px",
        width: "300px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        direction: "row",
        justifyContent: "center",
        alignItems: "start",
        xcss: $19aea8a940d73425$var$styles.calendarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gFnJK.CalendarSkeleton), {
        rowCount: 6
    })));
$19aea8a940d73425$export$754969bdca685d69.displayName = "SchedulesPageSkeleton";

});
parcelRegister("gFnJK", function(module, exports) {
$parcel$export(module.exports, "CalendarSkeleton", () => $d55aab6f88a166cb$export$ebc7c47cc535837e);
/* CalendarSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $3NRLa = parcelRequire("3NRLa");

var $apUrw = parcelRequire("apUrw");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $d55aab6f88a166cb$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-resources-calendar.calendar-skeleton.loading",
    defaultMessage: "Loading"
});
const $d55aab6f88a166cb$var$ROWS = 7;
const $d55aab6f88a166cb$var$COLUMNS = 7;
const $d55aab6f88a166cb$var$AGENT_CELL_HEIGHT = '64px';
const $d55aab6f88a166cb$var$CALENDAR_CELL_HEIGHT = '37px';
const $d55aab6f88a166cb$var$styles = {
    container: "_zulpu2gc _1e0c1txw _2lx21bp4 _1bsb1osq",
    row: "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o",
    spacer: "_1bsbidpf _19bvu2gc"
};
const $d55aab6f88a166cb$var$CalendarSkeletonRow = ()=>/*#__PURE__*/ $euxye.createElement((0, $2XXtG.default), {
        xcss: $d55aab6f88a166cb$var$styles.row
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        height: $d55aab6f88a166cb$var$AGENT_CELL_HEIGHT,
        width: "100%"
    }), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $d55aab6f88a166cb$var$styles.spacer
    }), Array.from({
        length: $d55aab6f88a166cb$var$COLUMNS
    }).map((_, index)=>/*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
            key: index,
            height: $d55aab6f88a166cb$var$CALENDAR_CELL_HEIGHT,
            width: "100%"
        })));
$d55aab6f88a166cb$var$CalendarSkeletonRow.displayName = "CalendarSkeletonRow";
const $d55aab6f88a166cb$export$ebc7c47cc535837e = ({ rowCount: rowCount = $d55aab6f88a166cb$var$ROWS })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $d55aab6f88a166cb$var$styles.container,
        testId: "resources-calendar.skeleton"
    }, /*#__PURE__*/ $euxye.createElement((0, $apUrw.default), null, formatMessage($d55aab6f88a166cb$var$loadingMessage)), Array.from({
        length: rowCount
    }).map((_, index)=>/*#__PURE__*/ $euxye.createElement($d55aab6f88a166cb$var$CalendarSkeletonRow, {
            key: index
        })));
};
$d55aab6f88a166cb$export$ebc7c47cc535837e.displayName = "CalendarSkeleton";
var $d55aab6f88a166cb$export$2e2bcd8739ae039 = $d55aab6f88a166cb$export$ebc7c47cc535837e;

});





parcelRegister("6RvaF", function(module, exports) {
$parcel$export(module.exports, "secureFiltersDirectoryRedirectRouteEntry", () => $bc15623c6caf1b8c$export$c2ec350ee9e78717);


var $b59DA = parcelRequire("b59DA");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $7MIHJ = parcelRequire("7MIHJ");

var $85jAF = parcelRequire("85jAF");

var $lSyrn = parcelRequire("lSyrn");
const $bc15623c6caf1b8c$export$c2ec350ee9e78717 = (0, $fdS54.createEntry)((0, $7MIHJ.secureFiltersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $b59DA.filtersDirectoryResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: !false ? (0, $lSyrn.FiltersDirectoryRedirect) : (0, $lSyrn.FiltersDirectoryComponent),
        skeleton: (0, $85jAF.FiltersDirectorySkeleton),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lSyrn.LazyFiltersDirectory)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7MIHJ", function(module, exports) {
$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $23f68375f4d3363c$export$50796f2aecd63181);
const $23f68375f4d3363c$export$50796f2aecd63181 = {
    name: 'filters-directory-secure-redirect',
    path: '/secure/ManageFilters.jspa'
};

});


parcelRegister("fuD4B", function(module, exports) {
$parcel$export(module.exports, "selectedDashboardRouteEntry", () => $b132062df2d2a4c7$export$ac09a8d3ecbafc5);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");


var $3HYSN = parcelRequire("3HYSN");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $i0h25 = parcelRequire("i0h25");

var $lo4Xx = parcelRequire("lo4Xx");

var $cHkmB = parcelRequire("cHkmB");
const $b132062df2d2a4c7$export$ac09a8d3ecbafc5 = (0, $fdS54.createEntry)((0, $i0h25.selectedDashboardRoute), ()=>({
        group: 'dashboard',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lo4Xx.DashboardRedirect),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $cHkmB.dashboardResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cHkmB.LazyDashboardView)
        ],
        meta: {
            capability: (0, $0ce01f968965dadd$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("i0h25", function(module, exports) {
$parcel$export(module.exports, "selectedDashboardRoute", () => $b891ce8b8e4f9435$export$b32070ee9554c3fb);
const $b891ce8b8e4f9435$export$b32070ee9554c3fb = {
    name: 'dashboard-selected',
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};

});


parcelRegister("9tg6g", function(module, exports) {
$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRouteEntry", () => $043c8670676e88df$export$94d6674b63b9d647);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $gNXbQ = parcelRequire("gNXbQ");

var $lbxXL = parcelRequire("lbxXL");

var $hB9pe = parcelRequire("hB9pe");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $jR4fS = parcelRequire("jR4fS");
const $043c8670676e88df$export$94d6674b63b9d647 = (0, $fdS54.createEntry)((0, $hB9pe.servicedeskAtlassianAnalyticsRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jR4fS.AtlassianAnalytics),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $gNXbQ.servicedeskAtlassianAnalyticsResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jR4fS.LazyAtlassianAnalytics)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ATLASSIAN_ANALYTICS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ATLASSIAN_ANALYTICS),
                teamName: 'ITSM Saga'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gNXbQ", function(module, exports) {
$parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", () => $d9abdd2e0146a0f5$export$eb2deca89cf3fb61);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $d9abdd2e0146a0f5$var$RESOURCE_TYPE_SERVICEDESK_ATLASSIAN_ANALYTICS = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

const $d9abdd2e0146a0f5$export$eb2deca89cf3fb61 = (0, $7edbf.createResource)({
    type: $d9abdd2e0146a0f5$var$RESOURCE_TYPE_SERVICEDESK_ATLASSIAN_ANALYTICS,
    getKey: ()=>'atlassian analytics',
    getDataLoader: ()=>(parcelRequire("6whBH")),
    isBrowserOnly: true
});

});
parcelRegister("6whBH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fu9s").then(()=>parcelRequire('5ofD7'));

});


parcelRegister("hB9pe", function(module, exports) {
$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", () => $748c66d7c0ff2a46$export$399ef3a2d4288bba);
const $748c66d7c0ff2a46$export$399ef3a2d4288bba = {
    name: 'servicedesk-atlassian-analytics',
    path: '/jira/servicedesk/projects/:projectKey/reports/atlassian-analytics',
    exact: true
};

});

parcelRegister("jR4fS", function(module, exports) {
$parcel$export(module.exports, "LazyAtlassianAnalytics", () => $cd8c5c37b39d1197$export$78ffe2f6530d45d1);
$parcel$export(module.exports, "AtlassianAnalytics", () => $cd8c5c37b39d1197$export$6d23a188bb96b7ab);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $cd8c5c37b39d1197$export$78ffe2f6530d45d1 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("ejjmS"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-atlassian-analytics/src/ServicedeskAtlassianAnalytics.tsx"
});
const $cd8c5c37b39d1197$export$6d23a188bb96b7ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $cd8c5c37b39d1197$export$78ffe2f6530d45d1,
        pageId: "spa-apps/servicedesk/atlassian-analytics",
        shouldShowSpinner: true
    });
$cd8c5c37b39d1197$export$6d23a188bb96b7ab.displayName = "AtlassianAnalytics";

});
parcelRegister("ejjmS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b9MwM").then(()=>parcelRequire('3Hb5p'));

});



parcelRegister("dtmY2", function(module, exports) {
$parcel$export(module.exports, "servicedeskCalendarRouteEntry", () => $27701ebd94e17fd6$export$301bfcedbd0983b7);


var $2tUYk = parcelRequire("2tUYk");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $cDLVA = parcelRequire("cDLVA");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $J19mq = parcelRequire("J19mq");

var $74h93 = parcelRequire("74h93");

var $j69FH = parcelRequire("j69FH");

var $e6puP = parcelRequire("e6puP");
const $27701ebd94e17fd6$export$301bfcedbd0983b7 = (0, $fdS54.createEntry)((0, $J19mq.servicedeskCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm-calendar',
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>null,
        skeleton: (0, $j69FH.ClassicCalendarSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $2tUYk.AsyncViewsNav)
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $cDLVA.getCalendarFilterFieldsResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!false, (0, $2DCyG.uifBoardResource))
        ],
        entryPoint: ()=>(0, $e6puP.calendarPageEntryPoint),
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("J19mq", function(module, exports) {
$parcel$export(module.exports, "servicedeskCalendarRoute", () => $42b9004c258ec080$export$28a386a00670c893);
const $42b9004c258ec080$export$28a386a00670c893 = {
    name: 'servicedesk-calendar',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
    exact: true
};

});

parcelRegister("e6puP", function(module, exports) {
$parcel$export(module.exports, "calendarPageEntryPoint", () => $50622eed223ecd77$export$eda0c2fb67f7d7e7);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $ard19 = parcelRequire("ard19");

var $dTa0V = parcelRequire("dTa0V");
const $50622eed223ecd77$export$eda0c2fb67f7d7e7 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ard19.calendarEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("2hoxk", function(module, exports) {
$parcel$export(module.exports, "servicedeskChangeCalendarRouteEntry", () => $da3b2fd2c3cf9152$export$de5b915e23c7ce7d);


var $9QAbZ = parcelRequire("9QAbZ");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $aeOt9 = parcelRequire("aeOt9");

var $9OQq5 = parcelRequire("9OQq5");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $iyWML = parcelRequire("iyWML");

var $74h93 = parcelRequire("74h93");

var $kZUck = parcelRequire("kZUck");
const $da3b2fd2c3cf9152$export$de5b915e23c7ce7d = (0, $fdS54.createEntry)((0, $iyWML.servicedeskChangeCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.change-calendar',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kZUck.default),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $9QAbZ.AsyncJSMOperationsHorizontalNav)
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $aeOt9.changeCalendarViewSettingsResource),
            (0, $9OQq5.changeCalendarFilterSettingsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $kZUck.LazyChangeCalendar),
            (0, $9QAbZ.LazyJSMOperationsHorizontalNav)
        ],
        meta: {
            reporting: {
                id: 'changeCalendar',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CHANGE_CALENDAR),
                teamName: 'jenga'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9QAbZ", function(module, exports) {
$parcel$export(module.exports, "LazyJSMOperationsHorizontalNav", () => $cef9b1a632690097$export$d9802671a2b1aa20);
$parcel$export(module.exports, "AsyncJSMOperationsHorizontalNav", () => $cef9b1a632690097$export$d4493569f106c71);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $cef9b1a632690097$export$d9802671a2b1aa20 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("a4j5o")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-operations/src/ui/index.tsx"
});
const $cef9b1a632690097$export$d4493569f106c71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraHorizontalNavJsmOperations",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cef9b1a632690097$export$d9802671a2b1aa20, null)));
$cef9b1a632690097$export$d4493569f106c71.displayName = "AsyncJSMOperationsHorizontalNav";

});
parcelRegister("a4j5o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("koWjo").then(()=>parcelRequire('2Qo25'));

});


parcelRegister("aeOt9", function(module, exports) {
$parcel$export(module.exports, "changeCalendarViewSettingsResource", () => $6a767ab3ab8c4bd9$export$30950a4228efde07);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $6a767ab3ab8c4bd9$var$getData = async (routerContext, { tenantContext: tenantContext })=>{
    if (!routerContext.match.params.projectKey) return;
    const { cloudId: cloudId } = tenantContext;
    const { projectKey: projectKey } = routerContext.match.params;
    try {
        const response = await (0, $h2wCv.performGetRequest)(`/gateway/api/jsm/change-management/view/api/v1/cloudId/${cloudId}/settings/project/${projectKey}`);
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getChangeCalendarViewSettings',
                packageName: 'jiraRouterResourcesJsmChangeCalendar',
                teamName: 'jenga'
            },
            error: error
        });
        throw error;
    }
};
const $6a767ab3ab8c4bd9$export$30950a4228efde07 = (0, $7edbf.createResource)({
    getData: $6a767ab3ab8c4bd9$var$getData,
    isBrowserOnly: true,
    type: 'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE',
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    getKey: ({ match: match, query: query })=>{
        const issueKey = match && match.params && match.params.projectKey !== undefined && match.params.projectKey !== null ? match.params.projectKey : null;
        if (!issueKey) {
            if (query && query.selectedIssue) return query.selectedIssue || 'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE';
        }
        return issueKey || 'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE';
    }
});

});

parcelRegister("9OQq5", function(module, exports) {
$parcel$export(module.exports, "changeCalendarFilterSettingsResource", () => $41b1d86d66133a8c$export$2ec0cc3aa9fdf030);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $41b1d86d66133a8c$var$getData = async (routerContext, { tenantContext: tenantContext })=>{
    if (!routerContext.match.params.projectKey) return;
    const { cloudId: cloudId } = tenantContext;
    if (!routerContext.query.filterId) return;
    const { filterId: filterId } = routerContext.query;
    try {
        const response = await (0, $h2wCv.performGetRequest)(`/gateway/api/jsm/calendar/cloudid/${cloudId}/v1/change-calendar/filters/${filterId}`);
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getChangeCalendarFilterSettings',
                packageName: 'jiraRouterResourcesJsmChangeCalendar',
                teamName: 'jenga'
            },
            error: error
        });
        throw error;
    }
};
const $41b1d86d66133a8c$export$2ec0cc3aa9fdf030 = (0, $7edbf.createResource)({
    getData: $41b1d86d66133a8c$var$getData,
    isBrowserOnly: true,
    type: 'CHANGE_CALENDAR_FILTER_SETTINGS_RESOURCE',
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    getKey: ({ query: query })=>`CHANGE_CALENDAR_FILTER_SETTINGS_RESOURCE-${query.filterId}`
});

});

parcelRegister("iyWML", function(module, exports) {
$parcel$export(module.exports, "servicedeskChangeCalendarRoute", () => $ed05161693bc08f5$export$3dbc16ae422c469);
const $ed05161693bc08f5$export$3dbc16ae422c469 = {
    name: 'servicedesk-change-calendar',
    path: '/jira/servicedesk/projects/:projectKey/change-calendar',
    exact: true
};

});

parcelRegister("kZUck", function(module, exports) {
$parcel$export(module.exports, "LazyChangeCalendar", () => $3dcf74e85eab94fb$export$a6cec2d1c2e631eb);
$parcel$export(module.exports, "default", () => $3dcf74e85eab94fb$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $3dcf74e85eab94fb$export$a6cec2d1c2e631eb = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("6Ixhm"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-change-calendar/src/ServicedeskChangeCalendar.tsx"
});
const $3dcf74e85eab94fb$var$AsyncChangeCalendar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3dcf74e85eab94fb$export$a6cec2d1c2e631eb,
        pageId: "spa-apps/servicedesk/change-calendar",
        shouldShowSpinner: true
    });
$3dcf74e85eab94fb$var$AsyncChangeCalendar.displayName = "AsyncChangeCalendar";
var $3dcf74e85eab94fb$export$2e2bcd8739ae039 = $3dcf74e85eab94fb$var$AsyncChangeCalendar;

});
parcelRegister("6Ixhm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("kLP8P")
]).then(()=>parcelRequire('9Ggqx'));

});



parcelRegister("4582u", function(module, exports) {
$parcel$export(module.exports, "servicedeskChannelsRouteEntry", () => $3bd923df903e1c0c$export$578aad970210b66e);


var $hZdFk = parcelRequire("hZdFk");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $tS9MM = parcelRequire("tS9MM");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $2700E = parcelRequire("2700E");

var $74h93 = parcelRequire("74h93");

var $joXQi = parcelRequire("joXQi");

var $dTa0V = parcelRequire("dTa0V");
const $3bd923df903e1c0c$var$CHANNELS_APP_NAME = 'servicedesk.channels';
const $3bd923df903e1c0c$var$CHANNELS_PACKAGE_NAME = 'servicedeskChannels';
const $3bd923df903e1c0c$var$servicedeskChannelsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $tS9MM.servicedeskChannelsEntryPoint)
});
const $3bd923df903e1c0c$export$578aad970210b66e = (0, $fdS54.createEntry)((0, $hZdFk.servicedeskChannelsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        skeleton: (0, $2700E.expValEquals)('jsmgrowth_259_improve_discovery_of_channels', 'isEnabled', true, false) ? (0, $joXQi.ChannelsPageSkeleton) : undefined,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        entryPoint () {
            // Gate-off path serves a 404 — Channels bundle is NOT downloaded when gate is off
            return (0, $2700E.expValEquals)('jsmgrowth_259_improve_discovery_of_channels', 'isEnabled', true, false) ? $3bd923df903e1c0c$var$servicedeskChannelsPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        perfMetricKey: 'jsm-channels-page-load',
        meta: {
            reporting: {
                id: $3bd923df903e1c0c$var$CHANNELS_APP_NAME,
                packageName: $3bd923df903e1c0c$var$CHANNELS_PACKAGE_NAME,
                teamName: 'Sequoia'
            }
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hZdFk", function(module, exports) {
$parcel$export(module.exports, "servicedeskChannelsRoute", () => $19db3f6e76c535e0$export$4fdb147e1ce56c1);
const $19db3f6e76c535e0$export$4fdb147e1ce56c1 = {
    name: 'servicedesk-channels',
    path: '/jira/servicedesk/projects/:projectKey/channels',
    exact: true
};

});

parcelRegister("tS9MM", function(module, exports) {
$parcel$export(module.exports, "servicedeskChannelsEntryPoint", () => $673e1e6242f25e13$export$2ebd4adacfc6a650);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $673e1e6242f25e13$export$2ebd4adacfc6a650 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("kHF8a")), {
        moduleId: "f872532a",
        moduleName: "ChannelsAppLayout",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({
            queries: {},
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("kHF8a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5V17t").then(()=>parcelRequire('hKrMq'));

});


parcelRegister("joXQi", function(module, exports) {
$parcel$export(module.exports, "ChannelsPageSkeleton", () => $2cd6801636b74401$export$327b0a9c92c3f5cc);

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $rS2Qn = parcelRequire("rS2Qn");
// Calibrated against the real Channels page loading layout. The static SVG's final row ends at
// 72.5em (1160px at the app skeleton template's 16px baseline); the remaining space preserves the
// page's bottom padding/breathing room so replacing the route skeleton does not collapse the page.
const $2cd6801636b74401$var$containerStyles = {
    height: '1227px'
};
const $2cd6801636b74401$export$327b0a9c92c3f5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($rS2Qn))),
        hideBorder: true,
        containerStyles: $2cd6801636b74401$var$containerStyles
    });
$2cd6801636b74401$export$327b0a9c92c3f5cc.displayName = "ChannelsPageSkeleton";
var $2cd6801636b74401$export$2e2bcd8739ae039 = $2cd6801636b74401$export$327b0a9c92c3f5cc;

});
parcelRegister("rS2Qn", function(module, exports) {
module.exports = new URL("channels-page-skeleton.tpl.dbc62c54.svg", import.meta.url).toString();

});



parcelRegister("g6TjH", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewCreateRouteEntry", () => $4e31719710b3b6ed$export$b0a16a66af58eb25);


var $8ycTI = parcelRequire("8ycTI");

var $dUAVJ = parcelRequire("dUAVJ");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $9E67D = parcelRequire("9E67D");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $hFi6I = parcelRequire("hFi6I");

var $P2tcm = parcelRequire("P2tcm");
const $4e31719710b3b6ed$export$b0a16a66af58eb25 = (0, $fdS54.createEntry)((0, $9E67D.servicedeskCmdbAssetsAnalyticsDataViewCreateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $hFi6I.AssetsAnalyticsDataViewCreate),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hFi6I.LazyServicedeskCmdbAssetsAnalyticsDataViewCreate)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-create',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $40599577b3613cf9$export$6f4e17de67d45c3d = 'INSIGHT';

parcelRegister("9E67D", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewCreateRoute", () => $6c81571febe16239$export$ab4f147f1c700ecd);
const $6c81571febe16239$export$ab4f147f1c700ecd = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-create',
    path: '/jira/servicedesk/assets/analytics/data-view/create',
    exact: true
};

});

parcelRegister("hFi6I", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewList", () => $4980bee58040dc40$export$1a5a30b71ec01594);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewCreate", () => $4980bee58040dc40$export$dd5cf457fb6402f7);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewDetails", () => $4980bee58040dc40$export$df3c79bc4a19edf1);
$parcel$export(module.exports, "AssetsAnalyticsDataViewList", () => $4980bee58040dc40$export$a7db3f7bf80b4eb7);
$parcel$export(module.exports, "AssetsAnalyticsDataViewCreate", () => $4980bee58040dc40$export$fa1e0b9fb89de9d0);
$parcel$export(module.exports, "AssetsAnalyticsDataViewDetails", () => $4980bee58040dc40$export$3de2c3601c3c1cca);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $4980bee58040dc40$export$1a5a30b71ec01594 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("iZGwC")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewList), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-assets-custom-metrics/src/CmdbAssetsAnalyticsDataViewList.tsx"
});

const $4980bee58040dc40$export$dd5cf457fb6402f7 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("iZGwC")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewCreate), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-assets-custom-metrics/src/CmdbAssetsAnalyticsDataViewList.tsx"
});

const $4980bee58040dc40$export$df3c79bc4a19edf1 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("iZGwC")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewDetails), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-assets-custom-metrics/src/CmdbAssetsAnalyticsDataViewList.tsx"
});
const $4980bee58040dc40$export$a7db3f7bf80b4eb7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4980bee58040dc40$export$1a5a30b71ec01594,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list",
        shouldShowSpinner: true
    });
$4980bee58040dc40$export$a7db3f7bf80b4eb7.displayName = "AssetsAnalyticsDataViewList";
const $4980bee58040dc40$export$fa1e0b9fb89de9d0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4980bee58040dc40$export$dd5cf457fb6402f7,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-create",
        shouldShowSpinner: true
    });
};
$4980bee58040dc40$export$fa1e0b9fb89de9d0.displayName = "AssetsAnalyticsDataViewCreate";
const $4980bee58040dc40$export$3de2c3601c3c1cca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $4980bee58040dc40$export$df3c79bc4a19edf1,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details",
        shouldShowSpinner: true
    });
$4980bee58040dc40$export$3de2c3601c3c1cca.displayName = "AssetsAnalyticsDataViewDetails";

});
parcelRegister("iZGwC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ddvBw").then(()=>parcelRequire('kGuEg'));

});


parcelRegister("P2tcm", function(module, exports) {
$parcel$export(module.exports, "AssetsAppRedirect", () => $3af9aa475479f365$export$5d5d166a9477289f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $1DL4e = parcelRequire("1DL4e");

var $gNbXR = parcelRequire("gNbXR");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");
const $3af9aa475479f365$export$2197c8adbafa78d4 = (match, query)=>{
    const pattern = /\/jira\/servicedesk\/(assets|insight)/;
    // We are intentionally using a new regex for being extra safe and not to disturb original regex used for majority of the app routes
    const objectPathPattern = /\/jira\/servicedesk\/insight\/assets/;
    let redirectionUrl;
    if (match.url.match(objectPathPattern)) redirectionUrl = match.url.replace(objectPathPattern, (0, $1DL4e.ASSETS_APP_OBJECT_ROUTE_PREFIX));
    else redirectionUrl = match.url.replace(pattern, (0, $1DL4e.ASSETS_APP_ROUTE_PREFIX));
    if (Object.keys(query).length > 0) redirectionUrl += `?${(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(query)}`;
    return redirectionUrl;
};
const $3af9aa475479f365$export$5d5d166a9477289f = ({ match: match, query: query })=>{
    const redirectionUrl = $3af9aa475479f365$export$2197c8adbafa78d4(match, query);
    const analyticsAttributes = {
        matchedRoute: match.path
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceType: (0, $46f069e6c968f461$export$f636b5b56f1d624a),
        sourceName: "assetsAppRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: redirectionUrl,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), {
        attributes: analyticsAttributes
    }));
};
$3af9aa475479f365$export$5d5d166a9477289f.displayName = "AssetsAppRedirect";

});
parcelRegister("1DL4e", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $bb5bcae4198ae884$export$42e57fb76a904fc3);
$parcel$export(module.exports, "ASSETS_APP_OBJECT_ROUTE_PREFIX", () => $bb5bcae4198ae884$export$aede099f2ae23728);
$parcel$export(module.exports, "isInsightRoute", () => $bb5bcae4198ae884$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $bb5bcae4198ae884$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $bb5bcae4198ae884$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $bb5bcae4198ae884$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $bb5bcae4198ae884$export$20fd4a0aec335970);
$parcel$export(module.exports, "getAssetsSettingsUrl", () => $bb5bcae4198ae884$export$15f6d6ab94d89135);
$parcel$export(module.exports, "getDataManagerUrl", () => $bb5bcae4198ae884$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerGettingStartedUrl", () => $bb5bcae4198ae884$export$3d0380185f73b3d);
$parcel$export(module.exports, "getDataManagerObjectClassesUrl", () => $bb5bcae4198ae884$export$4c9768bc51c7a1a);
$parcel$export(module.exports, "getDataManagerVisualizationUrl", () => $bb5bcae4198ae884$export$6c3cb6f103b2324);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $bb5bcae4198ae884$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $bb5bcae4198ae884$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsDashboardsUrl", () => $bb5bcae4198ae884$export$da30a4c2eb7e2c58);
$parcel$export(module.exports, "getAssetsReportUrl", () => $bb5bcae4198ae884$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsForYouUrl", () => $bb5bcae4198ae884$export$ea8a41c5d5a50829);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $bb5bcae4198ae884$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $bb5bcae4198ae884$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $bb5bcae4198ae884$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $bb5bcae4198ae884$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $bb5bcae4198ae884$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $bb5bcae4198ae884$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $bb5bcae4198ae884$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $bb5bcae4198ae884$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $bb5bcae4198ae884$export$415502b49e27270d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bS1iz = parcelRequire("bS1iz");

var $i860n = parcelRequire("i860n");

var $6ibhc = parcelRequire("6ibhc");
const $bb5bcae4198ae884$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $bb5bcae4198ae884$export$42e57fb76a904fc3 = '/jira/assets';
const $bb5bcae4198ae884$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $bb5bcae4198ae884$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $bb5bcae4198ae884$export$aede099f2ae23728 = '/jira/assets/object';
const $bb5bcae4198ae884$export$296d80f3ce129968 = (pathname)=>pathname.includes($bb5bcae4198ae884$export$6d7574dbda22cf7);
const $bb5bcae4198ae884$export$1f9b8b558a361aaf = ()=>$bb5bcae4198ae884$export$ee637ecb2dfa4f6a;
const $bb5bcae4198ae884$export$5413f45d031c7806 = ()=>(0, $i860n.fg)('assets_as_an_app_v2') ? $bb5bcae4198ae884$export$42e57fb76a904fc3 : $bb5bcae4198ae884$export$80e512187a5e0d10;
const $bb5bcae4198ae884$export$9366da5a373815e5 = ()=>$bb5bcae4198ae884$export$5413f45d031c7806();
const $bb5bcae4198ae884$export$20fd4a0aec335970 = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/configure/global`;
const $bb5bcae4198ae884$export$15f6d6ab94d89135 = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/configure/global`;
const $bb5bcae4198ae884$export$c9b27b0d2e19d52f = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/data-manager/`;
const $bb5bcae4198ae884$export$3d0380185f73b3d = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/data-manager/getting-started`;
const $bb5bcae4198ae884$export$4c9768bc51c7a1a = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/data-manager/object-classes`;
const $bb5bcae4198ae884$export$6c3cb6f103b2324 = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/data-manager/#/dashboards`;
const $bb5bcae4198ae884$export$cd6b35373ba077a = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/data-manager/adapters/`;
const $bb5bcae4198ae884$export$c1909404b7ea317f = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/reports`;
const $bb5bcae4198ae884$export$da30a4c2eb7e2c58 = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/dashboards`;
const $bb5bcae4198ae884$export$2b59e824c7ce8a63 = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/discover/data-manager`;
const $bb5bcae4198ae884$export$b386a8fb9ae3586f = ()=>`${$bb5bcae4198ae884$export$42e57fb76a904fc3}/configure/global?menu=data-manager`;
const $bb5bcae4198ae884$export$771825afb10f956f = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/analytics/data-view/create`;
const $bb5bcae4198ae884$export$272d35cbff1c220e = (reportId)=>`${$bb5bcae4198ae884$export$c1909404b7ea317f()}/${reportId}`;
const $bb5bcae4198ae884$export$97bfda8f5f38a121 = (query)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $bb5bcae4198ae884$export$ea8a41c5d5a50829 = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/for-you`;
const $bb5bcae4198ae884$export$c48ea1282c74411e = ()=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/object-schemas`;
const $bb5bcae4198ae884$export$3a0332e980fe56cf = (objectSchemaId)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $bb5bcae4198ae884$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$bb5bcae4198ae884$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $6ibhc.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $bb5bcae4198ae884$export$f02479149ce3cac7 = (objectSchemaId)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $bb5bcae4198ae884$export$51e4229f2c7d3866 = (objectId)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/object/${objectId}`;
const $bb5bcae4198ae884$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$bb5bcae4198ae884$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $bb5bcae4198ae884$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$bb5bcae4198ae884$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $bb5bcae4198ae884$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$bb5bcae4198ae884$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $bb5bcae4198ae884$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal, hasAssetsEntitlement: hasAssetsEntitlement = false } = {})=>hasAssetsEntitlement && (0, $i860n.fg)('aurum-677-assets-usage-migration') ? '/jira/assets/configure/global?menu=app-usage' : `/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $bb5bcae4198ae884$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("6ibhc", function(module, exports) {
$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $0b85c6f547327d33$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $0b85c6f547327d33$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $0b85c6f547327d33$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $0b85c6f547327d33$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $0b85c6f547327d33$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_COMMON_DATA_MODEL", () => $0b85c6f547327d33$export$b5445f8b5c64a799);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $0b85c6f547327d33$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $0b85c6f547327d33$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $0b85c6f547327d33$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $0b85c6f547327d33$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $0b85c6f547327d33$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $0b85c6f547327d33$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $0b85c6f547327d33$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $0b85c6f547327d33$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $0b85c6f547327d33$export$1927b50f7d074492);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $hFcQt = parcelRequire("hFcQt");

var $2ffUK = parcelRequire("2ffUK");
var $bc9Gj = parcelRequire("bc9Gj");
var $55BnK = parcelRequire("55BnK");
const $0b85c6f547327d33$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $0b85c6f547327d33$export$f7855185bab37329 = 'reference-types';
const $0b85c6f547327d33$export$3739ebbc7c6e87e8 = 'statuses';
const $0b85c6f547327d33$export$2c22dc6c729ae0bd = 'icons';
const $0b85c6f547327d33$export$f37b3a97acf56eaf = 'data-manager';
const $0b85c6f547327d33$export$b5445f8b5c64a799 = 'common-data-model';
const $0b85c6f547327d33$export$12ebb1d5017e1d6d = 'general';
const $0b85c6f547327d33$export$a77734d9ea30fe44 = 'roles';
const $0b85c6f547327d33$export$be37b820df30c947 = 'import';
const $0b85c6f547327d33$export$670faa8ae93e0903 = 'inheritance';
const $0b85c6f547327d33$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $55BnK.useRouterActions)();
    const [{ location: location }] = (0, $bc9Gj.useRouter)();
    const updateQueryParams = (0, $euxye.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $euxye.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $0b85c6f547327d33$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $euxye.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $hFcQt.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $hFcQt.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $hFcQt.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $0b85c6f547327d33$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $hFcQt.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $0b85c6f547327d33$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $0b85c6f547327d33$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $2ffUK.useQueryParam)($0b85c6f547327d33$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});
parcelRegister("hFcQt", function(module, exports) {
$parcel$export(module.exports, "toSchemaId", () => $7a187f41b88f8e4f$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $7a187f41b88f8e4f$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $7a187f41b88f8e4f$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $7a187f41b88f8e4f$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $7a187f41b88f8e4f$export$cfd92c18cee8add7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $7a187f41b88f8e4f$export$d577b7f3b832f656 = (id)=>id;
const $7a187f41b88f8e4f$export$1ba342595bc7be13 = (id)=>id;
const $7a187f41b88f8e4f$export$b46e25afa2bab6a = (id)=>id;
const $7a187f41b88f8e4f$export$d002b8d7821b6b59 = (id)=>id;
const $7a187f41b88f8e4f$export$ece2917434bb0a8c = (id)=>id;
const $7a187f41b88f8e4f$export$cfd92c18cee8add7 = (id)=>id;

});





parcelRegister("b5ssb", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewDetailsRouteEntry", () => $07d0dcb656b7d78d$export$cb82af0ec920487e);


var $8ycTI = parcelRequire("8ycTI");

var $dUAVJ = parcelRequire("dUAVJ");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $9RAve = parcelRequire("9RAve");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $hFi6I = parcelRequire("hFi6I");

var $P2tcm = parcelRequire("P2tcm");
const $07d0dcb656b7d78d$export$cb82af0ec920487e = (0, $fdS54.createEntry)((0, $9RAve.servicedeskCmdbAssetsAnalyticsDataViewDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $hFi6I.AssetsAnalyticsDataViewDetails),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hFi6I.LazyServicedeskCmdbAssetsAnalyticsDataViewDetails)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-details',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9RAve", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewDetailsRoute", () => $c8fbf82ddf5f9401$export$b024a0a636d7f43e);
const $c8fbf82ddf5f9401$export$b024a0a636d7f43e = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-details',
    path: '/jira/servicedesk/assets/analytics/data-view/:dataViewId',
    exact: true
};

});


parcelRegister("b8gZR", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewListRouteEntry", () => $2cd67a95bd798b8d$export$79ee0c9fe260269a);


var $8ycTI = parcelRequire("8ycTI");

var $dUAVJ = parcelRequire("dUAVJ");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $yFLNC = parcelRequire("yFLNC");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $hFi6I = parcelRequire("hFi6I");

var $P2tcm = parcelRequire("P2tcm");
const $2cd67a95bd798b8d$export$79ee0c9fe260269a = (0, $fdS54.createEntry)((0, $yFLNC.servicedeskCmdbAssetsAnalyticsDataViewListRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $hFi6I.AssetsAnalyticsDataViewList),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hFi6I.LazyServicedeskCmdbAssetsAnalyticsDataViewList)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-list',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("yFLNC", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewListRoute", () => $80554dc14756981a$export$9134bfe87d382f51);
const $80554dc14756981a$export$9134bfe87d382f51 = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-list',
    path: '/jira/servicedesk/assets/analytics/data-view',
    exact: true
};

});


parcelRegister("fT2sm", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsDashboardsDetailRouteEntry", () => $026eb91f00351462$export$65208ca229cf3450);

var $euxye = parcelRequire("euxye");


var $eviQr = parcelRequire("eviQr");

var $8ycTI = parcelRequire("8ycTI");

var $dUAVJ = parcelRequire("dUAVJ");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");

var $8PHdJ = parcelRequire("8PHdJ");

var $oWdC4 = parcelRequire("oWdC4");

var $aZT7c = parcelRequire("aZT7c");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $cnRNa = parcelRequire("cnRNa");

var $h2tgz = parcelRequire("h2tgz");

var $gNbXR = parcelRequire("gNbXR");

var $i860n = parcelRequire("i860n");
const $026eb91f00351462$var$DashboardsDetailPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eviQr.AssetsAppBase), {
        appName: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS
    }, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZT7c.DashboardEditable), {
            workspaceId: workspaceId
        }));
$026eb91f00351462$var$DashboardsDetailPage.displayName = "DashboardsDetailPage";
const $026eb91f00351462$export$65208ca229cf3450 = (0, $fdS54.createEntry)((0, $cnRNa.servicedeskCmdbAssetsDashboardsDetailRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $oWdC4.isNewReportsNavExperienceEnabled)() ? $026eb91f00351462$var$DashboardsDetailPage : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
                to: "/jira/servicedesk/assets/reports"
            }),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics'), (0, $8PHdJ.assetsDashboardsSemanticModelResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eviQr", function(module, exports) {
$parcel$export(module.exports, "AssetsAppBase", () => $47a0549be7a4ecf5$export$603e3eacf9be07ce);
$parcel$export(module.exports, "InsightAppBaseV2", () => $47a0549be7a4ecf5$export$c9b1085d6a7138ac);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $sTvQ1 = parcelRequire("sTvQ1");

var $fIIXL = parcelRequire("fIIXL");

var $7Pwwk = parcelRequire("7Pwwk");

var $9XYjM = parcelRequire("9XYjM");

var $iV0vl = parcelRequire("iV0vl");

var $1ntzc = parcelRequire("1ntzc");

var $dE2ZP = parcelRequire("dE2ZP");

var $eBpdw = parcelRequire("eBpdw");

var $j65JU = parcelRequire("j65JU");

var $bOYO0 = parcelRequire("bOYO0");

var $7nWmb = parcelRequire("7nWmb");

var $6zTYs = parcelRequire("6zTYs");

var $kc1yl = parcelRequire("kc1yl");

var $aZMdt = parcelRequire("aZMdt");
var $inMxE = parcelRequire("inMxE");

var $bOtBg = parcelRequire("bOtBg");

var $6pofw = parcelRequire("6pofw");

var $zbgUa = parcelRequire("zbgUa");

var $gNbXR = parcelRequire("gNbXR");

var $3GN2r = parcelRequire("3GN2r");

var $4Ojfp = parcelRequire("4Ojfp");

var $i860n = parcelRequire("i860n");

var $5Swah = parcelRequire("5Swah");

var $cvJhE = parcelRequire("cvJhE");
/**
 * Page component will be deprecated very soon
 * Any new page should avoid using PageDI/PageWrapper wrapper if possible.
 */ const $47a0549be7a4ecf5$var$APP_NAMES_WITHOUT_WRAPPER = [
    (0, $6pofw.APP_NAMES).INSIGHT_LANDING_PAGE,
    (0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
    (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_SETTINGS_PAGE,
    (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE,
    (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_SETTINGS_PAGE,
    (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE,
    (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE,
    (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE,
    (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_DICTIONARY_GROUP_PAGE,
    (0, $6pofw.APP_NAMES).ASSETS_APP_DATA_MANAGER_ISSUES_PAGE
];
const $47a0549be7a4ecf5$var$shouldSkipWrapper = (appName)=>{
    if (!appName) return false;
    return $47a0549be7a4ecf5$var$APP_NAMES_WITHOUT_WRAPPER.includes(appName);
};
const $47a0549be7a4ecf5$export$603e3eacf9be07ce = ({ appName: appName, children: children, pageStyle: pageStyle = (0, $kc1yl.default), onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dE2ZP.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bOtBg.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: (0, $6pofw.toPackageName)(appName),
        sourceType: (0, $46f069e6c968f461$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($47a0549be7a4ecf5$export$9bb1b82b8c44ae62, {
        appName: appName,
        pageStyle: pageStyle,
        onExperienceFailure: onExperienceFailure,
        onExperienceAbort: onExperienceAbort
    }, children))));
$47a0549be7a4ecf5$export$603e3eacf9be07ce.displayName = "AssetsAppBase";
const $47a0549be7a4ecf5$export$9bb1b82b8c44ae62 = ({ appName: appName, children: children, pageStyle: PageWrapper, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>{
    const { workspaceId: workspaceId, error: error, loading: loading } = (0, $j65JU.useWorkspaceContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const tenantContext = (0, $zbgUa.useAssetsTenantContext)();
    const { isLicensedAssetsUser: isLicensedAssetsUser } = tenantContext;
    const licenceState = (0, $bOYO0.getUserJsmLicenceState)(tenantContext);
    const hasInsightPermission = (0, $j65JU.useInsightVisibility)();
    const userId = (0, $3GN2r.useAccountId)();
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const { isAssetsDataManagerUnauthorizedUser: isAssetsDataManagerUnauthorizedUser } = (0, $4Ojfp.useAssetsDataManagerUserAuth)();
    const shouldHideAssetsReports = (0, $cvJhE.useHideAssetsReportsInIsolatedCloud)();
    const isAssetsUserPermissionLoading = (0, $7nWmb.useAssetsUserPermissionLoading)();
    (0, $euxye.useEffect)(()=>{
        if (onExperienceFailure && onExperienceAbort) {
            if (workspaceId === null && !loading && !error) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onExperienceFailure('assets-app-base', (0, $sTvQ1.getErrorAttributes)(new Error('Workspace ID is not set')));
            else if (error && !(0, $sTvQ1.isClientNetworkError)(error)) {
                const trackerFunction = (0, $sTvQ1.isHttpClientErrorResponse)(error) ? onExperienceAbort : onExperienceFailure;
                trackerFunction?.('assets-app-base', (0, $sTvQ1.getErrorAttributes)(error));
            }
        }
    }, [
        onExperienceFailure,
        onExperienceAbort,
        workspaceId,
        loading,
        error
    ]);
    if (!(0, $eBpdw.isCMDBEnabledInEnvironment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Pwwk.NotFoundErrorPageAsync), null);
    if (!licenceState.siteHasJsmInstalled || !userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/"
    });
    if (!licenceState.siteIsPremium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9XYjM.AsyncCmdbUpsellPage), null);
    if (!hasInsightPermission && (isAssetsUserPermissionLoading || isLicensedAssetsUser)) return null;
    if (!licenceState.userLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Swah.NoAccessErrorPage), null);
    if (workspaceId == null) return !loading && !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Pwwk.NotFoundErrorPageAsync), null) : null;
    if (!hasInsightPermission || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fIIXL.GenericPermissionErrorPageAsync), null);
    if (isAssetsDataManagerUnauthorizedUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Swah.NoAccessErrorPage), null);
    if (shouldHideAssetsReports) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Pwwk.NotFoundErrorPageAsync), null);
    const shouldSkipPageWrapper = $47a0549be7a4ecf5$var$shouldSkipWrapper(appName) && (0, $i860n.fg)('assets_common_schema_listing');
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iV0vl.CmdbArchitectureContainer), {
        workspaceId: workspaceId
    }, children({
        workspaceId: workspaceId
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1ntzc.InsightGlobalConfigContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        userId: userId,
        orgId: orgId
    }, shouldSkipPageWrapper ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(PageWrapper, null, content));
};
$47a0549be7a4ecf5$export$9bb1b82b8c44ae62.displayName = "AssetsAppBaseInternal";
const $47a0549be7a4ecf5$export$c9b1085d6a7138ac = ({ children: children, appName: appName })=>{
    const { workspaceId: workspaceId, error: error, loading: loading } = (0, $j65JU.useWorkspaceContext)();
    const hasInsightPermission = (0, $j65JU.useInsightVisibility)();
    const tenantContext = (0, $zbgUa.useAssetsTenantContext)();
    if (!(0, $eBpdw.isCMDBEnabledInEnvironment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Pwwk.NotFoundErrorPageAsync), null);
    if (!(0, $bOYO0.isAssetsUser)(tenantContext)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9XYjM.AsyncCmdbUpsellPage), null);
    if (workspaceId == null) return !loading && !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Pwwk.NotFoundErrorPageAsync), null) : null;
    if (hasInsightPermission === false || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fIIXL.GenericPermissionErrorPageAsync), null);
    const shouldSkipPageWrapper = $47a0549be7a4ecf5$var$shouldSkipWrapper(appName) && (0, $i860n.fg)('assets_common_schema_listing');
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iV0vl.CmdbArchitectureContainer), {
        workspaceId: workspaceId
    }, children({
        workspaceId: workspaceId
    }));
    return shouldSkipPageWrapper ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kc1yl.default), null, content);
};
$47a0549be7a4ecf5$export$c9b1085d6a7138ac.displayName = "InsightAppBaseV2";

});
parcelRegister("sTvQ1", function(module, exports) {
$parcel$export(module.exports, "getErrorAttributes", () => $c94ec47770c4a3f4$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "isHttpClientErrorResponse", () => $c94ec47770c4a3f4$export$2b62e563f0fadcee);
$parcel$export(module.exports, "isClientNetworkError", () => $c94ec47770c4a3f4$export$dc0d2c5fff67f524);
$parcel$export(module.exports, "isSloFailure", () => $c94ec47770c4a3f4$export$2ab75c18c9535885);

var $cY22M = parcelRequire("cY22M");

var $1hZ79 = parcelRequire("1hZ79");

var $lCetP = parcelRequire("lCetP");

const $c94ec47770c4a3f4$var$extractGraphQLExtensionErrorName = (error)=>{
    const graphqlErrorExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'extensions'
    ], null);
    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(graphqlErrorExtensions, [
        'errorType'
    ]);
    if (errorType) return errorType;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(graphqlErrorExtensions, [
        'operationName'
    ]);
};
const $c94ec47770c4a3f4$var$extractErrorName = (error)=>{
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'networkError'
    ]);
    if (networkError) return (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(networkError, [
        'name'
    ], (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'name'
    ], (0, $0ecc75c642de7065$export$ba068cc3610b559d)));
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'graphQLErrors'
    ], []);
    if (graphQLErrors && graphQLErrors.length > 0) {
        const graphqlErrorExtensionsName = $c94ec47770c4a3f4$var$extractGraphQLExtensionErrorName((0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(graphQLErrors, [
            0
        ]));
        if (graphqlErrorExtensionsName) return graphqlErrorExtensionsName;
    }
    const graphqlErrorExtensionsName = $c94ec47770c4a3f4$var$extractGraphQLExtensionErrorName(error);
    if (graphqlErrorExtensionsName) return graphqlErrorExtensionsName;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'name'
    ], (0, $0ecc75c642de7065$export$ba068cc3610b559d));
};
const $c94ec47770c4a3f4$var$extractStatusCode = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'networkError',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'graphQLErrors',
        0,
        'extensions',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'extensions',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'extensions',
        'status'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'status'
    ]) || (0, $0ecc75c642de7065$export$ba068cc3610b559d);
const $c94ec47770c4a3f4$var$extractStatusCodeGroup = (error)=>{
    const statusCode = Number($c94ec47770c4a3f4$var$extractStatusCode(error));
    if (!statusCode) return 0, $0ecc75c642de7065$export$ba068cc3610b559d;
    if (statusCode >= 100 && statusCode < 200) return 0, $0ecc75c642de7065$export$d441f436c87942f5;
    if (statusCode >= 300 && statusCode < 400) return 0, $0ecc75c642de7065$export$b29a3bb66f63d888;
    if (statusCode >= 400 && statusCode < 500) return 0, $0ecc75c642de7065$export$16e7f409a0d3529f;
    if (statusCode >= 500 && statusCode < 600) return 0, $0ecc75c642de7065$export$549a32621a554e7c;
    return 0, $0ecc75c642de7065$export$78244dbb77cfa6b6;
};
const $c94ec47770c4a3f4$var$extractTraceId = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'traceId'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'extensions',
        'traceId'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'extensions',
        'request_id'
    ], (0, $0ecc75c642de7065$export$ba068cc3610b559d)) || (0, $0ecc75c642de7065$export$ba068cc3610b559d);
const $c94ec47770c4a3f4$var$extractErrorMessage = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'message'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'extensions',
        'message'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'extensions',
        'userMessage'
    ], (0, $0ecc75c642de7065$export$ba068cc3610b559d));
const $c94ec47770c4a3f4$var$extractErrorStack = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
        'stack'
    ], (0, $0ecc75c642de7065$export$ba068cc3610b559d));
const $c94ec47770c4a3f4$export$6ad9e7706a4ee0f8 = (error)=>({
        errorName: $c94ec47770c4a3f4$var$extractErrorName(error),
        errorMessage: $c94ec47770c4a3f4$var$extractErrorMessage(error),
        errorStack: $c94ec47770c4a3f4$var$extractErrorStack(error),
        statusCode: $c94ec47770c4a3f4$var$extractStatusCode(error),
        statusCodeGroup: $c94ec47770c4a3f4$var$extractStatusCodeGroup(error),
        traceId: $c94ec47770c4a3f4$var$extractTraceId(error)
    });
const $c94ec47770c4a3f4$export$2b62e563f0fadcee = (error)=>{
    const statusCode = Number($c94ec47770c4a3f4$var$extractStatusCode(error));
    return Number.isNaN(statusCode) ? false : statusCode >= 400 && statusCode < 500;
};
const $c94ec47770c4a3f4$export$dc0d2c5fff67f524 = (error)=>(0, $lCetP.isClientFetchError)(error);
const $c94ec47770c4a3f4$export$2ab75c18c9535885 = (error)=>!$c94ec47770c4a3f4$export$dc0d2c5fff67f524(error) && !$c94ec47770c4a3f4$export$2b62e563f0fadcee(error);
const $c94ec47770c4a3f4$export$9d73d6caff63cf52 = (error)=>{
    const statusCode = Number($c94ec47770c4a3f4$var$extractStatusCode(error));
    return Number.isNaN(statusCode) ? false : statusCode === 429;
};
const $c94ec47770c4a3f4$export$35ef4ce2961027c7 = (error)=>{
    const statusCode = Number($c94ec47770c4a3f4$var$extractStatusCode(error));
    return Number.isNaN(statusCode) ? false : statusCode === 409;
};
const $c94ec47770c4a3f4$export$7916ec13418094a3 = (attributes = {})=>({
        synthetic: (0, $1hZ79.isSynthetic)(),
        isUIF: true,
        isClassic: false,
        ...attributes
    });

});
parcelRegister("1hZ79", function(module, exports) {
$parcel$export(module.exports, "isSynthetic", () => $acb202e801ae7291$export$947749d756ccb0a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");
const $acb202e801ae7291$export$947749d756ccb0a = ()=>(0, $6bEm8.default)('ajs-is-synthetic') === 'true' || (0, $i860n.fg)('is_synthetic_tenant');

});

const $0ecc75c642de7065$export$ba068cc3610b559d = 'NOT_PRESENT';
const $0ecc75c642de7065$export$78244dbb77cfa6b6 = 'unknown';
const $0ecc75c642de7065$export$d441f436c87942f5 = '1xx';
const $0ecc75c642de7065$export$b29a3bb66f63d888 = '3xx';
const $0ecc75c642de7065$export$16e7f409a0d3529f = '4xx';
const $0ecc75c642de7065$export$549a32621a554e7c = '5xx';


parcelRegister("fIIXL", function(module, exports) {
$parcel$export(module.exports, "GenericPermissionErrorPageAsync", () => $7e58534c090b4a58$export$d9c0e71eccb9dcb3);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7e58534c090b4a58$var$LazyGenericPermissionErrorPage = (0, $l8G1z.lazy)(()=>(parcelRequire("fsaOd")).then((module)=>module.GenericPermissionErrorPage), {
    moduleId: "./src/packages/platform/generic-permission-error-page/src/GenericPermissionErrorPage.tsx"
});
const $7e58534c090b4a58$export$d9c0e71eccb9dcb3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-generic-permission-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7e58534c090b4a58$var$LazyGenericPermissionErrorPage, null));
$7e58534c090b4a58$export$d9c0e71eccb9dcb3.displayName = "GenericPermissionErrorPageAsync";

});
parcelRegister("fsaOd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("7E65X")
]).then(()=>parcelRequire('lsFuW'));

});


parcelRegister("9XYjM", function(module, exports) {
$parcel$export(module.exports, "AsyncCmdbUpsellPage", () => $9a841ce4b3dddaa3$export$659eb30d49d6ed87);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9a841ce4b3dddaa3$var$LazyCmdbUpsellPage = (0, $l8G1z.lazy)(()=>(parcelRequire("jX0al")).then((module)=>module.UpsellPage), {
    moduleId: "./src/packages/servicedesk/cmdb-upsell-page/src/UpsellPage.tsx"
});
const $9a841ce4b3dddaa3$export$659eb30d49d6ed87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "cmdb-upsell-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9a841ce4b3dddaa3$var$LazyCmdbUpsellPage, null));
$9a841ce4b3dddaa3$export$659eb30d49d6ed87.displayName = "AsyncCmdbUpsellPage";

});
parcelRegister("jX0al", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8stAx").then(()=>parcelRequire('akD60'));

});


parcelRegister("iV0vl", function(module, exports) {
$parcel$export(module.exports, "CmdbArchitectureContainer", () => $55f7b569e4106c1d$export$9f2b76d50d1e5752);

var $euxye = parcelRequire("euxye");

var $g7inT = parcelRequire("g7inT");

var $b4oPa = parcelRequire("b4oPa");

var $inMxE = parcelRequire("inMxE");

var $2D2gW = parcelRequire("2D2gW");

var $iyVjP = parcelRequire("iyVjP");
const $55f7b569e4106c1d$export$9f2b76d50d1e5752 = ({ workspaceId: workspaceId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iyVjP.CmdbArchitectureStoreContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($55f7b569e4106c1d$export$a94168bcf4c80e75, null, children));
};
$55f7b569e4106c1d$export$9f2b76d50d1e5752.displayName = "CmdbArchitectureContainer";
const $55f7b569e4106c1d$export$a94168bcf4c80e75 = ({ children: children })=>{
    const { loading: loading, error: error, migrationStatus: migrationStatus } = (0, $iyVjP.useCmdbArchitectureStore)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g7inT.JSErrorPageAsync), null);
    if (loading || !migrationStatus) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "migration-status"
    });
    if (migrationStatus.blockWriteTraffic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b4oPa.MaintenanceModePage), null);
    return children;
};
$55f7b569e4106c1d$export$a94168bcf4c80e75.displayName = "MigrationHandler";

});
parcelRegister("b4oPa", function(module, exports) {
$parcel$export(module.exports, "MaintenanceModePage", () => $57267795f7f587e5$export$407ffafe578d3c20);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $hzWaA = parcelRequire("hzWaA");

var $j26jU = parcelRequire("j26jU");

var $h4wf3 = parcelRequire("h4wf3");

var $l8Dej = parcelRequire("l8Dej");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $57267795f7f587e5$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.error-title",
    defaultMessage: "Be right back"
});
const $57267795f7f587e5$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.error-description",
    defaultMessage: "Assets is currently under maintenance and will return shortly. <break></break> Please try again later."
});
const $57267795f7f587e5$var$contactMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.contact-message",
    defaultMessage: "Contact support"
});
const $57267795f7f587e5$var$contactSupportLink = 'https://support.atlassian.com/contact/#/';
const $57267795f7f587e5$export$407ffafe578d3c20 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const renderImage = ()=>(0, $l8Dej.getAkEmptyStateRenderImageFn)((0, $h4wf3.default))({
            imageWidth: 275,
            maxImageWidth: 275,
            maxImageHeight: 275
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        width: "wide",
        renderImage: renderImage,
        header: formatMessage($57267795f7f587e5$var$errorTitle),
        description: formatMessage($57267795f7f587e5$var$errorDescription, {
            break: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("br", null)
        }),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
            href: $57267795f7f587e5$var$contactSupportLink,
            target: "_blank"
        }, formatMessage($57267795f7f587e5$var$contactMessage)),
        testId: "cmdb-maintenance-page.ui.cmdb-maintenance-page"
    });
};
$57267795f7f587e5$export$407ffafe578d3c20.displayName = "MaintenanceModePage";

});
parcelRegister("h4wf3", function(module, exports) {
$parcel$export(module.exports, "default", () => $98a235db3cf5c0aa$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $gboXr = parcelRequire("gboXr");

var $iAsQL = parcelRequire("iAsQL");
const $98a235db3cf5c0aa$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($iAsQL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($iAsQL))
});
var $98a235db3cf5c0aa$export$2e2bcd8739ae039 = $98a235db3cf5c0aa$var$Illustration;
const $98a235db3cf5c0aa$export$a179c88182cb9d56 = [
    0,
    0,
    276,
    276
];

});
parcelRegister("iAsQL", function(module, exports) {
module.exports = new URL("infrastructure-crane.3c8e069d.svg", import.meta.url).toString();

});



parcelRegister("iyVjP", function(module, exports) {
$parcel$export(module.exports, "CmdbArchitectureStoreContainer", () => $378ae81f22ec6564$export$3e99e0b586e9bd20);
$parcel$export(module.exports, "useCmdbArchitectureStore", () => $378ae81f22ec6564$export$cb0396e44d69a170);
$parcel$export(module.exports, "useIsNewCmdbArchitecture", () => $378ae81f22ec6564$export$cb6873bd1bfb6e11);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $l3MK1 = parcelRequire("l3MK1");
const $378ae81f22ec6564$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    migrationStatus: undefined
};
const $378ae81f22ec6564$var$store = (0, $5QDqc.createStore)({
    initialState: $378ae81f22ec6564$export$d4c72bab9d6cc13a,
    actions: {}
});
const $378ae81f22ec6564$export$3e99e0b586e9bd20 = (0, $dB6ay.createContainer)($378ae81f22ec6564$var$store, {
    onInit: (0, $l3MK1.fetchInitialStatus)
});
const $378ae81f22ec6564$export$cb0396e44d69a170 = (0, $3h1FP.createStateHook)($378ae81f22ec6564$var$store);
const $378ae81f22ec6564$export$cb6873bd1bfb6e11 = (0, $3h1FP.createStateHook)($378ae81f22ec6564$var$store, {
    selector: ({ migrationStatus: migrationStatus })=>migrationStatus?.routeToTempeh ?? false
});

});
parcelRegister("l3MK1", function(module, exports) {
$parcel$export(module.exports, "fetchInitialStatus", () => $f3f9607a9938995b$export$888156f6db906499);

var $dbvwv = parcelRequire("dbvwv");
const $f3f9607a9938995b$export$888156f6db906499 = ()=>({ getState: getState, dispatch: dispatch })=>{
        if (!getState().loading && !getState().migrationStatus) dispatch((0, $dbvwv.fetchMigrationStatus)());
    };

});
parcelRegister("dbvwv", function(module, exports) {
$parcel$export(module.exports, "fetchMigrationStatus", () => $bec770b4a9646e57$export$7edd275ea1b9d090);

var $hFtK7 = parcelRequire("hFtK7");

var $eh7eP = parcelRequire("eh7eP");

var $9FW2g = parcelRequire("9FW2g");

var $aJ81Y = parcelRequire("aJ81Y");
const $bec770b4a9646e57$export$f955a5fc47a6bbba = async (workspaceId)=>(0, $eh7eP.performCmdbGetRequest)((0, $9FW2g.getCmdbTempehMigrationUrl)(workspaceId));
const $bec770b4a9646e57$export$7edd275ea1b9d090 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading) return;
        setState({
            loading: true
        });
        try {
            const { blockWriteTraffic: blockWriteTraffic, routeToTempeh: routeToTempeh } = await $bec770b4a9646e57$export$f955a5fc47a6bbba(workspaceId);
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMigrationStatus succeeded');
            setState({
                loading: false,
                migrationStatus: {
                    blockWriteTraffic: blockWriteTraffic,
                    routeToTempeh: routeToTempeh
                }
            });
        } catch (error) {
            const typedError = error instanceof Error ? error : undefined;
            // We intentionally don't use fireCmdbErrorAnalytics because it's dependent on this store
            (0, $hFtK7.fireErrorAnalytics)({
                error: typedError,
                meta: {
                    id: 'fetchMigrationStatus',
                    packageName: 'jiraServicedeskCmdbArchitecture',
                    teamName: 'astral'
                }
            });
            setState({
                loading: false,
                error: typedError
            });
        }
    };

});
parcelRegister("9FW2g", function(module, exports) {
$parcel$export(module.exports, "getCmdbTempehMigrationUrl", () => $53ad9498c6c1627d$export$4699309ef0b4ff76);
/* eslint-disable jira/filename-case */ 
var $iGhBm = parcelRequire("iGhBm");
const $53ad9498c6c1627d$export$af33bbc68a181bd6 = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/tempeh`;
const $53ad9498c6c1627d$export$4699309ef0b4ff76 = (workspaceId)=>`${$53ad9498c6c1627d$export$af33bbc68a181bd6(workspaceId)}/migration`;

});





parcelRegister("1ntzc", function(module, exports) {
$parcel$export(module.exports, "useInsightGlobalConfig", () => $089c2d1268f4fcc3$export$ee996472bb397b41);
$parcel$export(module.exports, "useInsightReferenceTypes", () => $089c2d1268f4fcc3$export$efb93af726a65b26);
$parcel$export(module.exports, "useInsightStatusTypes", () => $089c2d1268f4fcc3$export$7eefa9cea32e596a);
$parcel$export(module.exports, "useInsightIcons", () => $089c2d1268f4fcc3$export$8336b36336c9f3c8);
$parcel$export(module.exports, "useDataManager", () => $089c2d1268f4fcc3$export$143bcc72da01e561);
$parcel$export(module.exports, "useCommonDataModel", () => $089c2d1268f4fcc3$export$a6f0c60c6d8cb283);
$parcel$export(module.exports, "useNamedInsightIcons", () => $089c2d1268f4fcc3$export$979b264266dab4ed);
$parcel$export(module.exports, "useIsRestrictedSchema", () => $089c2d1268f4fcc3$export$d07372ba961b2bc5);
$parcel$export(module.exports, "InsightGlobalConfigContainer", () => $089c2d1268f4fcc3$export$c4c69c73d422ea06);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $i860n = parcelRequire("i860n");

var $5gueZ = parcelRequire("5gueZ");

var $71cdE = parcelRequire("71cdE");
const $089c2d1268f4fcc3$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    config: undefined,
    referenceTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    statusTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    icons: {
        data: undefined,
        deleteLoading: false,
        deleteError: undefined,
        addLoading: false,
        addError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    dataManager: {
        rolesData: undefined,
        rolesError: undefined,
        rolesLoading: false,
        rolesUpdateLoading: false,
        rolesUpdateError: undefined,
        tokensLoading: false,
        tokensData: undefined,
        tokensError: undefined,
        tokenRevokeLoading: false,
        tokenRevokeError: undefined,
        isProvisioned: undefined,
        provisioningLoading: false,
        provisioningError: undefined,
        provisioningUpdateLoading: false,
        provisioningUpdateError: undefined,
        myRoles: undefined,
        myRolesError: undefined,
        myRolesLoading: false
    },
    cdm: {
        instantiations: undefined,
        tasks: []
    }
};
const $089c2d1268f4fcc3$var$Store = (0, $5QDqc.createStore)({
    initialState: $089c2d1268f4fcc3$export$d4c72bab9d6cc13a,
    actions: $5gueZ.actions
});
const $089c2d1268f4fcc3$export$ee996472bb397b41 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: (state)=>state
});
const $089c2d1268f4fcc3$export$efb93af726a65b26 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ referenceTypes: referenceTypes })=>({
            ...referenceTypes,
            data: referenceTypes.data ? (0, $71cdE.sortReferenceTypes)(referenceTypes.data) : undefined
        })
});
const $089c2d1268f4fcc3$export$7eefa9cea32e596a = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ statusTypes: statusTypes })=>({
            ...statusTypes,
            data: statusTypes.data ? (0, $71cdE.sortStatusTypes)(statusTypes.data) : undefined
        })
});
const $089c2d1268f4fcc3$export$8336b36336c9f3c8 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ icons: icons })=>icons
});
const $089c2d1268f4fcc3$export$143bcc72da01e561 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ dataManager: dataManager })=>dataManager
});
const $089c2d1268f4fcc3$export$a6f0c60c6d8cb283 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ cdm: cdm })=>cdm
});
const $089c2d1268f4fcc3$export$979b264266dab4ed = (0, $3h1FP.createStateHook)($089c2d1268f4fcc3$var$Store, {
    selector: ({ icons: icons })=>{
        const map = {};
        (icons.data ?? []).forEach((icon)=>{
            map[icon.name] = icon;
        });
        return map;
    }
});
const $089c2d1268f4fcc3$export$9c8eee3abcaa634e = (state, schemaId)=>{
    const restrictedObjectSchemaIds = state.config?.restrictedObjectSchemaIds ?? [];
    return restrictedObjectSchemaIds.includes(parseInt(schemaId, 10));
};
const $089c2d1268f4fcc3$export$d07372ba961b2bc5 = (0, $3h1FP.createHook)($089c2d1268f4fcc3$var$Store, {
    selector: $089c2d1268f4fcc3$export$9c8eee3abcaa634e
});
const $089c2d1268f4fcc3$var$autoFetchGlobalConfig = ()=>({ dispatch: dispatch, getState: getState }, { disableOnInit: disableOnInit })=>{
        const { loading: loading, error: error, config: config } = getState();
        if (!disableOnInit && !loading && !error && !config) {
            dispatch((0, $5gueZ.actions).fetchGlobalConfig());
            if ((0, $i860n.fg)('assets_cdm_ui_flow')) dispatch((0, $5gueZ.actions).fetchCdm());
            if ((0, $i860n.fg)('assets_as_an_app_v2')) {
                dispatch((0, $5gueZ.actions).fetchProvisioningStatus());
                dispatch((0, $5gueZ.actions).fetchMyDataManagerRoles());
            }
        }
    };
const $089c2d1268f4fcc3$export$c4c69c73d422ea06 = (0, $dB6ay.createContainer)($089c2d1268f4fcc3$var$Store, {
    onInit: $089c2d1268f4fcc3$var$autoFetchGlobalConfig
});

});
parcelRegister("5gueZ", function(module, exports) {
$parcel$export(module.exports, "actions", () => $d1f52fb1bae763b0$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eGz9b = parcelRequire("eGz9b");

var $8CIHz = parcelRequire("8CIHz");

var $5ZX4K = parcelRequire("5ZX4K");

var $9Uk9U = parcelRequire("9Uk9U");

var $8KJoS = parcelRequire("8KJoS");

var $7EbKM = parcelRequire("7EbKM");

var $hacul = parcelRequire("hacul");

var $4giZE = parcelRequire("4giZE");

var $aH3eH = parcelRequire("aH3eH");

var $jMWz2 = parcelRequire("jMWz2");

var $1oJL8 = parcelRequire("1oJL8");

var $iRdQ0 = parcelRequire("iRdQ0");

var $6rM2B = parcelRequire("6rM2B");

var $81SnW = parcelRequire("81SnW");

var $iRSmJ = parcelRequire("iRSmJ");

var $8AE9F = parcelRequire("8AE9F");

var $gykY5 = parcelRequire("gykY5");

var $ghOtU = parcelRequire("ghOtU");
const $d1f52fb1bae763b0$export$e324594224ef24da = {
    addIcon: $eGz9b.addIcon,
    createReferenceType: $8CIHz.createReferenceType,
    createStatusType: $5ZX4K.createStatusType,
    deleteIcon: $9Uk9U.deleteIcon,
    deleteReferenceType: $8KJoS.deleteReferenceType,
    deleteStatusType: $7EbKM.deleteStatusType,
    fetchCdm: $iRdQ0.fetchCdm,
    fetchDataManagerTokens: $1oJL8.fetchDataManagerTokens,
    fetchGlobalConfig: $hacul.fetchGlobalConfig,
    fetchMyDataManagerRoles: $4giZE.fetchMyDataManagerRoles,
    fetchPrincipalsForRoles: $aH3eH.fetchPrincipalsForRoles,
    fetchProvisioningStatus: $jMWz2.fetchProvisioningStatus,
    installCdm: $6rM2B.installCdm,
    setIcon: $iRSmJ.setIcon,
    setReferenceType: $gykY5.setReferenceType,
    setStatusType: $ghOtU.setStatusType,
    updateDataManagerRole: $81SnW.updateDataManagerRole,
    updateIcon: $iRSmJ.updateIcon,
    updateProvisioningStatus: $8AE9F.updateProvisioningStatus,
    updateReferenceType: $gykY5.updateReferenceType,
    updateStatusType: $ghOtU.updateStatusType
};

});
parcelRegister("eGz9b", function(module, exports) {
$parcel$export(module.exports, "addIcon", () => $3ece78116f2692ba$export$3488242433cbedb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $aJ81Y = parcelRequire("aJ81Y");

var $keqWM = parcelRequire("keqWM");

var $1F4TY = parcelRequire("1F4TY");
const $3ece78116f2692ba$export$3488242433cbedb = (newIcon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                addLoading: true
            }
        });
        try {
            const uploadCredentials = await (0, $1F4TY.mediaInfoForUpload)(workspaceId);
            const uploadMediaResult = await (0, $1F4TY.mediaUploadFile)({
                mediaBaseUrl: (0, $keqWM.toMediaBaseUrl)(uploadCredentials.mediaBaseUrl),
                collectionId: (0, $keqWM.toCollectionId)(uploadCredentials.collectionId),
                fileName: (0, $keqWM.toFileName)(newIcon.fileName),
                clientId: (0, $keqWM.toMediaClientId)(uploadCredentials.clientId),
                mediaJwtToken: (0, $keqWM.toMediaJwt)(uploadCredentials.mediaJwtToken),
                blob: newIcon.blob
            });
            const mediaInfoForPullingResult = await (0, $1F4TY.mediaInfoForPulling)(workspaceId, (0, $keqWM.toMediaFileUuid)(uploadMediaResult.data.id));
            const pollMediaFileReady = ()=>{
                const getMediaFileStatus = ()=>(0, $1F4TY.mediaGetFileInfo)({
                        mediaBaseUrl: (0, $keqWM.toMediaBaseUrl)(mediaInfoForPullingResult.mediaBaseUrl),
                        mediaFileUuid: (0, $keqWM.toMediaFileUuid)(uploadMediaResult.data.id),
                        clientId: (0, $keqWM.toMediaClientId)(uploadCredentials.clientId),
                        mediaJwtToken: (0, $keqWM.toMediaJwt)(mediaInfoForPullingResult.mediaJwtToken)
                    });
                return new Promise((resolve, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                reject)=>{
                    const poll = (attempt = 0)=>{
                        const statusPromise = getMediaFileStatus();
                        statusPromise.then((response)=>{
                            const status = response.data.processingStatus;
                            switch(status){
                                default:
                                case (0, $keqWM.MEDIA_PROCESS_STATUS).PENDING:
                                case (0, $keqWM.MEDIA_PROCESS_STATUS).RUNNING:
                                    return setTimeout(()=>{
                                        // 20 tries before throwing an error
                                        if (attempt > 20) return reject(new Error('Failed to add icon after 10 tries'));
                                        return poll(attempt + 1);
                                    }, 5000);
                                case (0, $keqWM.MEDIA_PROCESS_STATUS).SUCCEEDED:
                                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                                    return resolve();
                                case (0, $keqWM.MEDIA_PROCESS_STATUS).FAILED:
                                    return reject(new Error('Media services failed to process file!'));
                            }
                        }).catch((error)=>reject(new Error(error)));
                    };
                    poll();
                });
            };
            await pollMediaFileReady();
            const savedIconEntry = await (0, $1F4TY.publishNewIcon)(workspaceId, (0, $keqWM.toIconName)(newIcon.iconName), (0, $keqWM.toMediaFileUuid)(uploadMediaResult.data.id));
            // Make flow happy
            if (!Array.isArray(state.icons.data)) throw new Error('Invalid state! Icons data is not array!');
            const newIconsData = state.icons.data.slice(0);
            newIconsData.unshift(savedIconEntry);
            const newState = {
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    data: newIconsData
                }
            };
            setState(newState);
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'addIcon succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    addError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'addIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("keqWM", function(module, exports) {
$parcel$export(module.exports, "MEDIA_PROCESS_STATUS", () => $30f92c00723f594d$export$a760cae7c12e7f51);
$parcel$export(module.exports, "toMediaBaseUrl", () => $30f92c00723f594d$export$342e5c2fdd47297c);
$parcel$export(module.exports, "toCollectionId", () => $30f92c00723f594d$export$59b8a2c37e183bf5);
$parcel$export(module.exports, "toIconName", () => $30f92c00723f594d$export$41540e96af228b1a);
$parcel$export(module.exports, "toFileName", () => $30f92c00723f594d$export$249aa0c12095aafd);
$parcel$export(module.exports, "toMediaJwt", () => $30f92c00723f594d$export$dce78fe68aa68f20);
$parcel$export(module.exports, "toMediaFileUuid", () => $30f92c00723f594d$export$79083a8ab294d28e);
$parcel$export(module.exports, "toMediaClientId", () => $30f92c00723f594d$export$b105972f97cb69fa);
/* eslint-disable jira/filename-case */ const $30f92c00723f594d$export$a760cae7c12e7f51 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
    RUNNING: 'running'
};
const $30f92c00723f594d$export$342e5c2fdd47297c = (url)=>url;
const $30f92c00723f594d$export$59b8a2c37e183bf5 = (uuid)=>uuid;
const $30f92c00723f594d$export$41540e96af228b1a = (iconName)=>iconName;
const $30f92c00723f594d$export$249aa0c12095aafd = (fileName)=>fileName;
const $30f92c00723f594d$export$9dd52a3c923cba73 = (mediaIssuer)=>mediaIssuer;
const $30f92c00723f594d$export$dce78fe68aa68f20 = (mediaIssuer)=>mediaIssuer;
const $30f92c00723f594d$export$79083a8ab294d28e = (mediaFileUuid)=>mediaFileUuid;
const $30f92c00723f594d$export$b105972f97cb69fa = (mediaClientId)=>mediaClientId;

});

parcelRegister("1F4TY", function(module, exports) {
$parcel$export(module.exports, "mediaInfoForUpload", () => $4defb81869c18198$export$c7944179dc1cb15d);
$parcel$export(module.exports, "mediaUploadFile", () => $4defb81869c18198$export$6fba374ded90c76b);
$parcel$export(module.exports, "mediaInfoForPulling", () => $4defb81869c18198$export$4138ca7fa1c5dcbc);
$parcel$export(module.exports, "mediaGetFileInfo", () => $4defb81869c18198$export$c607c6f99a3a53ca);
$parcel$export(module.exports, "publishNewIcon", () => $4defb81869c18198$export$a7fc7d8db8ccf9da);
/* eslint-disable jira/filename-case */ 
var $eh7eP = parcelRequire("eh7eP");

var $dBNCB = parcelRequire("dBNCB");

var $h2wCv = parcelRequire("h2wCv");
const $4defb81869c18198$export$336c36f125eba39c = ({ clientId: clientId, mediaJwtToken: mediaJwtToken })=>{
    return {
        'X-Client-Id': clientId,
        Authorization: `Bearer ${mediaJwtToken}`
    };
};
const $4defb81869c18198$export$c7944179dc1cb15d = (workspaceId)=>(0, $eh7eP.performCmdbGetRequest)((0, $dBNCB.getCmdbIconTokenUploadingUrl)(workspaceId));
const $4defb81869c18198$export$6fba374ded90c76b = ({ mediaBaseUrl: mediaBaseUrl, collectionId: collectionId, fileName: fileName, mediaJwtToken: mediaJwtToken, blob: blob, clientId: clientId })=>(0, $h2wCv.performPostRequest)(`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(fileName)}&deletable=true`, {
        headers: {
            ...$4defb81869c18198$export$336c36f125eba39c({
                clientId: clientId,
                mediaJwtToken: mediaJwtToken
            }),
            'Content-Type': blob.type
        },
        body: blob
    });
const $4defb81869c18198$export$4138ca7fa1c5dcbc = (workspaceId, fileUuid)=>(0, $eh7eP.performCmdbGetRequest)((0, $dBNCB.getCmdbIconTokenFetchingUrl)(workspaceId, fileUuid));
const $4defb81869c18198$export$c607c6f99a3a53ca = ({ mediaBaseUrl: mediaBaseUrl, mediaFileUuid: mediaFileUuid, mediaJwtToken: mediaJwtToken, clientId: clientId })=>(0, $h2wCv.performGetRequest)(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
        headers: $4defb81869c18198$export$336c36f125eba39c({
            clientId: clientId,
            mediaJwtToken: mediaJwtToken
        })
    });
const $4defb81869c18198$export$a7fc7d8db8ccf9da = (workspaceId, iconName, mediaFileUuid)=>(0, $eh7eP.performCmdbPostRequest)((0, $dBNCB.getCmdbIconCreateUrl)(workspaceId), {
        body: JSON.stringify({
            name: iconName,
            mediaFileUuid: mediaFileUuid
        })
    });

});
parcelRegister("dBNCB", function(module, exports) {
$parcel$export(module.exports, "getCmdbIconCreateUrl", () => $2f0693206055e92f$export$4c6ff27b48881aba);
$parcel$export(module.exports, "getCmdbIconTokenFetchingUrl", () => $2f0693206055e92f$export$39e83f10cc93fe99);
$parcel$export(module.exports, "getCmdbIconTokenUploadingUrl", () => $2f0693206055e92f$export$7fdc9cd59a492763);
$parcel$export(module.exports, "getCmdbIconByIdUrl", () => $2f0693206055e92f$export$b881a625e1bc4876);
/* eslint-disable jira/filename-case */ 
var $iGhBm = parcelRequire("iGhBm");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon
 */ const $2f0693206055e92f$var$getCmdbIconUrl = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/icon`;
const $2f0693206055e92f$export$4c6ff27b48881aba = (workspaceId)=>`${$2f0693206055e92f$var$getCmdbIconUrl(workspaceId)}/create`;
const $2f0693206055e92f$export$39e83f10cc93fe99 = (workspaceId, fileUuid)=>`${$2f0693206055e92f$var$getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
const $2f0693206055e92f$export$7fdc9cd59a492763 = (workspaceId)=>`${$2f0693206055e92f$var$getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
const $2f0693206055e92f$export$b881a625e1bc4876 = (workspaceId, iconId)=>`${$2f0693206055e92f$var$getCmdbIconUrl(workspaceId)}/${iconId}`;

});



parcelRegister("8CIHz", function(module, exports) {
$parcel$export(module.exports, "createReferenceType", () => $dd4e7fd65fa07c62$export$ac28770630794807);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $dd4e7fd65fa07c62$export$ac28770630794807 = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPostRequest)((0, $el2ZZ.getCmdbConfigReferenceTypeUrl)(workspaceId), {
                body: JSON.stringify({
                    ...data,
                    color: data.color.replace('#', '')
                })
            });
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    data: [
                        ...state.referenceTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'createReferenceType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("el2ZZ", function(module, exports) {
$parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", () => $f1cc21ab7fa8ef1a$export$3269d36b59c9d27f);
$parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", () => $f1cc21ab7fa8ef1a$export$229964acb6a55e5);
$parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", () => $f1cc21ab7fa8ef1a$export$1991fb4d07b18469);
$parcel$export(module.exports, "getSitesPickerUrl", () => $f1cc21ab7fa8ef1a$export$15e2e023d82b7242);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", () => $f1cc21ab7fa8ef1a$export$ad07341c88d2bbab);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", () => $f1cc21ab7fa8ef1a$export$293e2bfa6752a2aa);
$parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", () => $f1cc21ab7fa8ef1a$export$225d5f547cc90d86);
$parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", () => $f1cc21ab7fa8ef1a$export$9c1d73050da32aae);
$parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", () => $f1cc21ab7fa8ef1a$export$6583ed007df50d2b);
$parcel$export(module.exports, "getCmdbPermsPrincipalUrl", () => $f1cc21ab7fa8ef1a$export$a635e2e9382b1621);
$parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", () => $f1cc21ab7fa8ef1a$export$b3cb4590859563b0);
$parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", () => $f1cc21ab7fa8ef1a$export$8ae00db5fd7218c5);
$parcel$export(module.exports, "getMyDataManagerRolesUrl", () => $f1cc21ab7fa8ef1a$export$794aa3ae46133f30);
/* eslint-disable jira/filename-case */ 
var $bS1iz = parcelRequire("bS1iz");

var $iGhBm = parcelRequire("iGhBm");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/config
 */ const $f1cc21ab7fa8ef1a$var$getCmdbConfigUrl = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/config`;
const $f1cc21ab7fa8ef1a$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $bS1iz.stringify)(queryParams)}` : ''}`;
const $f1cc21ab7fa8ef1a$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
const $f1cc21ab7fa8ef1a$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $bS1iz.stringify)(queryParams)}`;
const $f1cc21ab7fa8ef1a$export$15e2e023d82b7242 = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/picker/sites`;
const $f1cc21ab7fa8ef1a$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $bS1iz.stringify)(queryParams)}` : ''}`;
const $f1cc21ab7fa8ef1a$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
const $f1cc21ab7fa8ef1a$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
const $f1cc21ab7fa8ef1a$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
const $f1cc21ab7fa8ef1a$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
const $f1cc21ab7fa8ef1a$export$a635e2e9382b1621 = (workspaceId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
const $f1cc21ab7fa8ef1a$export$b3cb4590859563b0 = (workspaceId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
const $f1cc21ab7fa8ef1a$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
const $f1cc21ab7fa8ef1a$export$794aa3ae46133f30 = (workspaceId)=>`${$f1cc21ab7fa8ef1a$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;

});


parcelRegister("5ZX4K", function(module, exports) {
$parcel$export(module.exports, "createStatusType", () => $7da8ce52c326ce62$export$8c874b16a69a1b9d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $7da8ce52c326ce62$export$8c874b16a69a1b9d = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPostRequest)((0, $el2ZZ.getCmdbConfigStatusTypeUrl)(workspaceId), {
                body: JSON.stringify(data)
            });
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    data: [
                        ...state.statusTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({
                source: 'insightGlobalConfigStatuses',
                action: 'created',
                actionSubject: 'insightGlobalConfigStatuses'
            }), 'insightGlobalConfigStatuses created');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("9Uk9U", function(module, exports) {
$parcel$export(module.exports, "deleteIcon", () => $608629803746b3de$export$12d45ee5c2161b75);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $dBNCB = parcelRequire("dBNCB");

var $aJ81Y = parcelRequire("aJ81Y");
const $608629803746b3de$export$12d45ee5c2161b75 = (icon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                deleteLoading: true
            }
        });
        try {
            await (0, $eh7eP.performCmdbDeleteRequest)((0, $dBNCB.getCmdbIconByIdUrl)(workspaceId, icon.id));
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    data: state.icons.data ? state.icons.data.filter(({ id: id })=>id !== icon.id) : undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteIcon succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("8KJoS", function(module, exports) {
$parcel$export(module.exports, "deleteReferenceType", () => $7caa42a59cb3cde1$export$432ee1f3819316e5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $7caa42a59cb3cde1$export$432ee1f3819316e5 = (referenceType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $eh7eP.performCmdbDeleteRequest)((0, $el2ZZ.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceType.id));
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    data: state.referenceTypes.data ? state.referenceTypes.data.filter(({ id: id })=>id !== referenceType.id) : undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("7EbKM", function(module, exports) {
$parcel$export(module.exports, "deleteStatusType", () => $8b47e104d456bfa0$export$812423dc05f0fc3d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $8b47e104d456bfa0$export$812423dc05f0fc3d = (statusType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $eh7eP.performCmdbDeleteRequest)((0, $el2ZZ.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusType.id));
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    data: state.statusTypes.data ? state.statusTypes.data.filter(({ id: id })=>id !== statusType.id) : undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteStatusType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("hacul", function(module, exports) {
$parcel$export(module.exports, "fetchGlobalConfig", () => $3e66823e4dca5e48$export$14c75ba3f0e48e21);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $jlg5B = parcelRequire("jlg5B");

var $aJ81Y = parcelRequire("aJ81Y");
const $3e66823e4dca5e48$export$14c75ba3f0e48e21 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading || !shouldRefetch && getState().config) return;
        setState({
            loading: true,
            error: undefined
        });
        try {
            const response = await (0, $eh7eP.performCmdbGetRequest)((0, $jlg5B.getCmdbGlobalConfigUrl)(workspaceId));
            const iconListWithServiceOTEntriesRemoved = response ? response.icons.filter((item)=>item.name !== 'Applications' && item.name !== 'Business Services' && item.name !== 'Capabilities' && item.name !== 'Software Services') : undefined;
            setState({
                ...getState(),
                loading: false,
                config: {
                    ...response,
                    restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
                    icons: iconListWithServiceOTEntriesRemoved || []
                },
                referenceTypes: {
                    ...getState().referenceTypes,
                    data: response ? response.referenceTypes : undefined
                },
                statusTypes: {
                    ...getState().statusTypes,
                    data: response ? response.statusTypes : undefined
                },
                icons: {
                    ...getState().icons,
                    data: iconListWithServiceOTEntriesRemoved
                },
                dataManager: {
                    ...getState().dataManager
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchInsightGlobalConfig',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("jlg5B", function(module, exports) {
$parcel$export(module.exports, "getCmdbGlobalConfigUrl", () => $d1df4cccb5d78e67$export$50437136a9a5e2d3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", () => $d1df4cccb5d78e67$export$73e58b72a1074528);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", () => $d1df4cccb5d78e67$export$e2019224257efde3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", () => $d1df4cccb5d78e67$export$d1b25f8feb06db8a);
/* eslint-disable jira/filename-case */ 
var $bS1iz = parcelRequire("bS1iz");

var $iGhBm = parcelRequire("iGhBm");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */ const $d1df4cccb5d78e67$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/global`;
const $d1df4cccb5d78e67$export$50437136a9a5e2d3 = (workspaceId)=>`${$d1df4cccb5d78e67$var$getCmdbGlobalUrl(workspaceId)}/config`;
const $d1df4cccb5d78e67$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$d1df4cccb5d78e67$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $bS1iz.stringify)(queryParams)}`;
const $d1df4cccb5d78e67$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$d1df4cccb5d78e67$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
const $d1df4cccb5d78e67$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$d1df4cccb5d78e67$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;

});


parcelRegister("4giZE", function(module, exports) {
$parcel$export(module.exports, "fetchMyDataManagerRoles", () => $1751e6c0dd362ee1$export$2211f294ebd95b92);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $aJ81Y = parcelRequire("aJ81Y");
const $1751e6c0dd362ee1$export$2211f294ebd95b92 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.myRolesLoading || !shouldRefetch && getState().dataManager.myRoles) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                myRolesLoading: true,
                myRolesError: undefined
            }
        });
        try {
            const myRoles = await (0, $eh7eP.performCmdbGetRequest)((0, $el2ZZ.getMyDataManagerRolesUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRoles: myRoles.results,
                    myRolesLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRolesLoading: false,
                    myRolesError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchMyDataManagerRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("aH3eH", function(module, exports) {
$parcel$export(module.exports, "fetchPrincipalsForRoles", () => $b498242f6df33734$export$9c5110cfdcb72b5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $b498242f6df33734$export$9c5110cfdcb72b5 = (roleIds)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesLoading: true
            }
        });
        try {
            const requestBody = {
                roleIds: roleIds,
                resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`
            };
            const principalIdsForRoles = await (0, $eh7eP.performCmdbPostRequest)((0, $el2ZZ.getCmdbPermsPrincipalUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            setState((0, $i860n.fg)('aurum_dm_settings_stale_state_fix') ? {
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    rolesData: principalIdsForRoles.results,
                    rolesLoading: false
                }
            } : {
                dataManager: {
                    ...state.dataManager,
                    rolesData: principalIdsForRoles.results,
                    rolesLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $i860n.fg)('aurum_dm_settings_stale_state_fix') ? {
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    rolesLoading: false,
                    rolesError: error
                }
            } : {
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesLoading: false,
                    rolesError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchPrincipalsForRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("jMWz2", function(module, exports) {
$parcel$export(module.exports, "fetchProvisioningStatus", () => $4ab3d425a5f952fe$export$aa3ea988cce42be1);

var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $zijvz = parcelRequire("zijvz");

var $aJ81Y = parcelRequire("aJ81Y");
const $4ab3d425a5f952fe$export$aa3ea988cce42be1 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.provisioningLoading || !shouldRefetch && // isProvisioned is a boolean so needs to specifically check undefined
        getState().dataManager.isProvisioned !== undefined) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                provisioningLoading: true,
                provisioningError: undefined
            }
        });
        try {
            const result = await (0, $eh7eP.performCmdbGetRequest)((0, $zijvz.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: $4ab3d425a5f952fe$var$isProvisioned(result.enabled),
                    provisioningLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    provisioningLoading: false,
                    provisioningError: normalizedError
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: normalizedError
            });
            throw error;
        }
    };
const $4ab3d425a5f952fe$var$isProvisioned = (status)=>status === 'ON';

});
parcelRegister("zijvz", function(module, exports) {
$parcel$export(module.exports, "getDataManagerGenerateContainerTokenUrl", () => $ab714630f0b39e95$export$5f42b4e80a66d7c);
$parcel$export(module.exports, "delDataManagerContainerTokenUrl", () => $ab714630f0b39e95$export$ddc5a4cb751fae27);
$parcel$export(module.exports, "getDataManagerFetchContainerTokenUrl", () => $ab714630f0b39e95$export$591d877d695dbd95);
$parcel$export(module.exports, "getDataManagerProvisioningStatusUrl", () => $ab714630f0b39e95$export$1dd01c50c7948938);
/* eslint-disable jira/filename-case */ 
var $iGhBm = parcelRequire("iGhBm");
const $ab714630f0b39e95$export$5f42b4e80a66d7c = (workspaceId, label, type, duration)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;
const $ab714630f0b39e95$export$ddc5a4cb751fae27 = (workspaceId, tokenID)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${tokenID}`;
const $ab714630f0b39e95$export$591d877d695dbd95 = (workspaceId)=>`${(0, $iGhBm.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token`;
const $ab714630f0b39e95$export$1dd01c50c7948938 = (workspaceId)=>`${$ab714630f0b39e95$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;
const $ab714630f0b39e95$var$getAirtrackAppRestBaseUrl = (workspaceId)=>`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;

});


parcelRegister("1oJL8", function(module, exports) {
$parcel$export(module.exports, "fetchDataManagerTokens", () => $0d7ed8a71ea845aa$export$c6b3de84befa4259);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $zijvz = parcelRequire("zijvz");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $0d7ed8a71ea845aa$export$c6b3de84befa4259 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.tokensLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                tokensLoading: true
            }
        });
        try {
            const tokenDetails = await (0, $eh7eP.performCmdbGetRequest)((0, $zijvz.getDataManagerFetchContainerTokenUrl)(workspaceId));
            setState((0, $i860n.fg)('aurum_dm_settings_stale_state_fix') ? {
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    tokensData: tokenDetails.tokens,
                    tokensLoading: false
                }
            } : {
                dataManager: {
                    ...state.dataManager,
                    tokensData: tokenDetails.tokens,
                    tokensLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $i860n.fg)('aurum_dm_settings_stale_state_fix') ? {
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    tokensLoading: false,
                    tokensError: error
                }
            } : {
                ...state,
                dataManager: {
                    ...state.dataManager,
                    tokensLoading: false,
                    tokensError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchDataManagerTokens',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("iRdQ0", function(module, exports) {
$parcel$export(module.exports, "fetchCdm", () => $3a4b9bb1e559e1e7$export$dc14adeb4c2a88f9);

var $eh7eP = parcelRequire("eh7eP");

var $iGhBm = parcelRequire("iGhBm");

var $7cA7G = parcelRequire("7cA7G");

var $i860n = parcelRequire("i860n");
const $3a4b9bb1e559e1e7$var$getFetchCdmInstantiationsUrl = (workspaceId, type)=>{
    const base = (0, $iGhBm.getCmdbRestBaseUrl)(workspaceId);
    return `${base}/bundle/instantiated?type=${type}`;
};
const $3a4b9bb1e559e1e7$export$dc14adeb4c2a88f9 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId })=>{
        // First reset state to undefined to indicate loading
        const initialState = getState();
        setState({
            ...initialState,
            cdm: {
                ...initialState.cdm,
                instantiations: undefined
            }
        });
        let instantiationsResponse;
        try {
            const bundleType = (0, $i860n.fg)('assets_tempeh_update_cdm_to_foundations') ? 'foundations' : 'cdm';
            const apiResponse = await (0, $eh7eP.performCmdbGetRequest)($3a4b9bb1e559e1e7$var$getFetchCdmInstantiationsUrl(workspaceId, bundleType));
            instantiationsResponse = apiResponse?.instantiations || [];
        } catch (error) {
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : new Error('Unknown error'),
                meta: {
                    id: 'fetchInstantiations',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                }
            });
            // TODO(KKT-103) : handle error scenario by surfacing it to the user or retrying
            instantiationsResponse = [];
        }
        const state = getState();
        setState({
            ...state,
            cdm: {
                ...state.cdm,
                instantiations: instantiationsResponse
            }
        });
    };

});

parcelRegister("6rM2B", function(module, exports) {
$parcel$export(module.exports, "installCdm", () => $3b6ff4cb3c212dc8$export$2f65091e2af212f7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $3b6ff4cb3c212dc8$export$2f65091e2af212f7 = ()=>async ({ setState: setState, getState: getState })=>{
        // TODO: Implement the actual CDM instantiation logic here
        // submitAsyncCdmBundleInstantiationTask
        // useCmdbAsyncBundleInstantiation
        const state = getState();
        // Fake CDM instantiation task
        setState({
            ...state,
            cdm: {
                ...state.cdm,
                tasks: [
                    ...state.cdm.tasks,
                    'instantiateBundle'
                ]
            }
        });
        // Wait 2 seconds
        await new Promise((resolve)=>setTimeout(resolve, 2000));
        // Remove the task and add mock instantiation
        setState({
            ...getState(),
            cdm: {
                instantiations: [
                    {
                        instantiationId: 'test-instantiation-id',
                        bundleId: 'test-bundle-id',
                        schemas: []
                    }
                ],
                tasks: []
            }
        });
    };

});

parcelRegister("81SnW", function(module, exports) {
$parcel$export(module.exports, "updateDataManagerRole", () => $780e5841772ce038$export$314337b594e79a51);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $780e5841772ce038$export$93aad6482f82f57d = 5000;
const $780e5841772ce038$export$214f23982cabf5f8 = 1000;
const $780e5841772ce038$export$314337b594e79a51 = ({ principalIds: principalIds, roleId: roleId })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                principalIds: principalIds,
                roleId: roleId,
                resourceType: 'workspace'
            };
            const updateRolesResponse = await (0, $eh7eP.performCmdbPutRequest)((0, $el2ZZ.getCmdbPermsRoleAssignmentUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const pollTimeoutTime = new Date(Date.now() + $780e5841772ce038$export$93aad6482f82f57d).getTime();
            // poll the checking of the token status for 5 seconds as updating of
            // Identity role assignments have eventually consistency
            const tryPollTokenStatus = async (resolve, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            reject)=>{
                if (Date.now() > pollTimeoutTime) {
                    reject(new Error('Some role assignments have failed or is still in progress'));
                    return;
                }
                try {
                    const url = (0, $el2ZZ.getCmdbPermsTokenStatusUrl)(workspaceId, updateRolesResponse.tokens[updateRolesResponse.tokens.length - 1]);
                    const updateRoleAssignmentToken = await (0, $eh7eP.performCmdbGetRequest)(url);
                    if (updateRoleAssignmentToken.isSuccessful) {
                        resolve();
                        return;
                    }
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $780e5841772ce038$export$214f23982cabf5f8);
                // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // Ignore unexpected network/server error and quickly retry
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $780e5841772ce038$export$214f23982cabf5f8);
                }
            };
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            await new Promise((res, rej)=>tryPollTokenStatus(res, rej));
            setState((0, $i860n.fg)('aurum_dm_settings_stale_state_fix') ? {
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    rolesUpdateLoading: false
                }
            } : {
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateDataManagerRole succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $i860n.fg)('aurum_dm_settings_stale_state_fix') ? {
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    rolesUpdateLoading: false,
                    rolesUpdateError: error
                }
            } : {
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false,
                    rolesUpdateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateDataManagerRole',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'data-manager'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("iRSmJ", function(module, exports) {
$parcel$export(module.exports, "setIcon", () => $35c9a4a5999bdbf5$export$33914de34c28be6c);
$parcel$export(module.exports, "updateIcon", () => $35c9a4a5999bdbf5$export$89ea7ff652eb14dd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $dBNCB = parcelRequire("dBNCB");

var $aJ81Y = parcelRequire("aJ81Y");
const $35c9a4a5999bdbf5$export$33914de34c28be6c = (updatedIcon)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.icons.data?.map((icon)=>icon.id === updatedIcon.id ? updatedIcon : icon);
        setState({
            ...state,
            icons: {
                ...state.icons,
                data: updatedData
            }
        });
    };
const $35c9a4a5999bdbf5$export$89ea7ff652eb14dd = ({ iconId: iconId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPutRequest)((0, $dBNCB.getCmdbIconByIdUrl)(workspaceId, iconId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.icons.data?.map((icon)=>icon.id === response.id ? response : icon);
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    data: updatedData
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateIcon succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("8AE9F", function(module, exports) {
$parcel$export(module.exports, "updateProvisioningStatus", () => $4e2d9a78df80e130$export$ae3c5292a85a06f4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $zijvz = parcelRequire("zijvz");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $4e2d9a78df80e130$export$ae3c5292a85a06f4 = ({ isEnabled: isEnabled })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.provisioningUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                isProvisioned: isEnabled,
                provisioningUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                enabled: isEnabled
            };
            await (0, $eh7eP.performCmdbPutRequest)((0, $zijvz.getDataManagerProvisioningStatusUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const result = await (0, $eh7eP.performCmdbGetRequest)((0, $zijvz.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState((0, $i860n.fg)('aurum_dm_settings_stale_state_fix') ? {
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: result.enabled === 'ON',
                    provisioningUpdateLoading: false
                }
            } : {
                ...state,
                dataManager: {
                    ...state.dataManager,
                    isProvisioned: result.enabled === 'ON',
                    provisioningUpdateLoading: false
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState((0, $i860n.fg)('aurum_dm_settings_stale_state_fix') ? {
                ...getState(),
                dataManager: {
                    ...getState().dataManager,
                    provisioningUpdateLoading: false,
                    provisioningUpdateError: error
                }
            } : {
                ...state,
                dataManager: {
                    ...state.dataManager,
                    provisioningUpdateLoading: false,
                    provisioningUpdateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("gykY5", function(module, exports) {
$parcel$export(module.exports, "setReferenceType", () => $da190aeff67d4661$export$7c6efce0302318d);
$parcel$export(module.exports, "updateReferenceType", () => $da190aeff67d4661$export$f9e29a0f21a33136);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $da190aeff67d4661$export$7c6efce0302318d = (updatedReferenceType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.referenceTypes.data?.map((referenceType)=>referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType);
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                data: updatedData
            }
        });
    };
const $da190aeff67d4661$export$f9e29a0f21a33136 = ({ referenceTypeId: referenceTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPutRequest)((0, $el2ZZ.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceTypeId), {
                body: JSON.stringify({
                    ...updatedProperties,
                    color: updatedProperties.color !== undefined ? updatedProperties.color.replace('#', '') : undefined
                })
            });
            const updatedState = getState();
            let merged = response;
            if ((0, $i860n.fg)('cdm_display_name')) {
                const displayNameMerged = response.displayName !== undefined && response.displayName !== null ? response.displayName : updatedProperties.displayName;
                merged = {
                    ...response,
                    ...displayNameMerged !== undefined ? {
                        displayName: displayNameMerged
                    } : {}
                };
            }
            const updatedData = updatedState.referenceTypes.data?.map((referenceType)=>referenceType.id === response.id ? merged : referenceType);
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateReferenceType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("ghOtU", function(module, exports) {
$parcel$export(module.exports, "setStatusType", () => $d9f182d5741839d5$export$80a24939e43be67c);
$parcel$export(module.exports, "updateStatusType", () => $d9f182d5741839d5$export$2174575c3f57e8f8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7cA7G = parcelRequire("7cA7G");

var $eh7eP = parcelRequire("eh7eP");

var $el2ZZ = parcelRequire("el2ZZ");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
const $d9f182d5741839d5$export$80a24939e43be67c = (updatedStatusType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.statusTypes.data?.map((statusType)=>statusType.id === updatedStatusType.id ? updatedStatusType : statusType);
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                data: updatedData
            }
        });
    };
const $d9f182d5741839d5$export$2174575c3f57e8f8 = ({ statusTypeId: statusTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $eh7eP.performCmdbPutRequest)((0, $el2ZZ.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusTypeId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            let merged = response;
            if ((0, $i860n.fg)('cdm_display_name')) {
                const displayNameMerged = response.displayName !== undefined ? response.displayName : updatedProperties.displayName;
                merged = {
                    ...response,
                    ...displayNameMerged !== undefined ? {
                        displayName: displayNameMerged
                    } : {}
                };
            }
            const updatedData = updatedState.statusTypes.data?.map((statusType)=>statusType.id === response.id ? merged : statusType);
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateStatusType succeeded');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $7cA7G.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'astral'
                },
                error: error
            });
            throw error;
        }
    };

});


parcelRegister("71cdE", function(module, exports) {
$parcel$export(module.exports, "sortReferenceTypes", () => $8cf7bcb29c5a976b$export$7e55dd84e7cc0829);
$parcel$export(module.exports, "sortStatusTypes", () => $8cf7bcb29c5a976b$export$5f25bb3183b5823d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $8cf7bcb29c5a976b$export$7e55dd84e7cc0829 = (referenceTypes)=>referenceTypes.sort((a, b)=>a.name.localeCompare(b.name)).sort((a, b)=>{
        if (a.removable === b.removable) return 0;
        return a.removable ? 1 : -1;
    });
const $8cf7bcb29c5a976b$export$5f25bb3183b5823d = (statusTypes)=>statusTypes.sort((a, b)=>a.name.localeCompare(b.name));

});


parcelRegister("dE2ZP", function(module, exports) {
$parcel$export(module.exports, "SubProductUpdater", () => $5fd7c4d761fdc038$export$eb40d3df56aa5c53);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gp4ma = parcelRequire("gp4ma");

var $gtB5i = parcelRequire("gtB5i");

var $5Vn5h = parcelRequire("5Vn5h");

var $bTG3j = parcelRequire("bTG3j");
const $5fd7c4d761fdc038$var$isSubProductProps = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5fd7c4d761fdc038$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = $5fd7c4d761fdc038$var$isSubProductProps(props) ? props.subProduct : (0, $gtB5i.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gp4ma.default), {
        op: (0, $bTG3j.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Vn5h.default), {
        subProduct: subProduct
    }));
};
$5fd7c4d761fdc038$export$eb40d3df56aa5c53.displayName = "SubProductUpdater";

});
parcelRegister("gtB5i", function(module, exports) {
$parcel$export(module.exports, "subProductFromProjectType", () => $c6e300b7fb2f0263$export$246e1e2a5c86a633);
$parcel$export(module.exports, "useSubProduct", () => $c6e300b7fb2f0263$export$16aa2ad52cd8992a);
$parcel$export(module.exports, "subProductFromProjectTypeForAnalytics", () => $c6e300b7fb2f0263$export$9243583e56af95f6);
$parcel$export(module.exports, "useSubProductForAnalytics", () => $c6e300b7fb2f0263$export$cbfa57dd4a0c679e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2b39L = parcelRequire("2b39L");
const $c6e300b7fb2f0263$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        case 'customer_service':
            return 'customer-service';
        default:
    }
    return 'unknown';
};
const $c6e300b7fb2f0263$export$16aa2ad52cd8992a = ()=>{
    const { data: data } = (0, $2b39L.useProjectContext)();
    return data ? $c6e300b7fb2f0263$export$246e1e2a5c86a633(data.projectType) : null;
};
const $c6e300b7fb2f0263$export$9243583e56af95f6 = (projectType)=>{
    if (projectType === 'product_discovery') return 'polaris';
    return $c6e300b7fb2f0263$export$246e1e2a5c86a633(projectType);
};
const $c6e300b7fb2f0263$export$cbfa57dd4a0c679e = ()=>{
    const { data: data } = (0, $2b39L.useProjectContext)();
    return data ? $c6e300b7fb2f0263$export$9243583e56af95f6(data.projectType) : null;
};

});

parcelRegister("5Vn5h", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d00a1cd1708f652$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $buovh = parcelRequire("buovh");

var $5Nb9j = parcelRequire("5Nb9j");
const $1d00a1cd1708f652$var$TagMauEvent = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $buovh.default), {
        op: (0, $5Nb9j.default),
        args: [
            subProduct
        ]
    });
$1d00a1cd1708f652$var$TagMauEvent.displayName = "TagMauEvent";
var $1d00a1cd1708f652$export$2e2bcd8739ae039 = $1d00a1cd1708f652$var$TagMauEvent;

});
parcelRegister("buovh", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e746e233f88dd75$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
// eslint-disable-next-line jira/react/no-class-components
class $9e746e233f88dd75$var$OpTrigger extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
$9e746e233f88dd75$var$OpTrigger.displayName = "OpTrigger";
var $9e746e233f88dd75$export$2e2bcd8739ae039 = $9e746e233f88dd75$var$OpTrigger;

});

parcelRegister("5Nb9j", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea119c1abe55b1e1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");
const $ea119c1abe55b1e1$var$tagMauEvent = (subProduct)=>{
    (0, $h2wCv.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $6CfY5.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};
var $ea119c1abe55b1e1$export$2e2bcd8739ae039 = $ea119c1abe55b1e1$var$tagMauEvent;

});


parcelRegister("bTG3j", function(module, exports) {
$parcel$export(module.exports, "default", () => $268b53bbfdf0ce7e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/wrm/no-load-bridge

var $9dWMe = parcelRequire("9dWMe");
var $8IotF = parcelRequire("8IotF");
var $erQjo = parcelRequire("erQjo");


var $6CfY5 = parcelRequire("6CfY5");

var $6Kdw4 = parcelRequire("6Kdw4");
const $268b53bbfdf0ce7e$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
const $268b53bbfdf0ce7e$var$setCurrentSubProduct = async (subProduct, allowMonolithDeferral)=>{
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $382ab3343e49976c$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $268b53bbfdf0ce7e$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $erQjo.waitForHeritage)() : null, ()=>(0, $9dWMe.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ],
            // jira/analytics/sub-product-resolver is not using any heritage code
            isolatedFromHeritage: true
        }), ()=>(0, $8IotF.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $6CfY5.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };
var $268b53bbfdf0ce7e$export$2e2bcd8739ae039 = $268b53bbfdf0ce7e$var$setCurrentSubProduct;

});
parcelRegister("9dWMe", function(module, exports) {
$parcel$export(module.exports, "loadBridgeStrict", () => $e2d66ceeb4b43693$export$eba600d28decc4ac);
/* eslint-disable jira/filename-case */ 
var $fEmTm = parcelRequire("fEmTm");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $9MneQ = parcelRequire("9MneQ");

var $9wvOm = parcelRequire("9wvOm");

var $f39gG = parcelRequire("f39gG");

var $1fD9L = parcelRequire("1fD9L");

var $erQjo = parcelRequire("erQjo");
const $e2d66ceeb4b43693$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR), isolatedFromHeritage: isolatedFromHeritage = false })=>{
    (0, $9MneQ.saveStats)(name, wrmKeys);
    if (// FIXME: remove fg after initial rollout
    // eslint-disable-next-line jira/ff/no-preconditioning
    !isolatedFromHeritage && (0, $i860n.fg)('jfp_magma_jira-report-early-strict-bridge') && (0, $6bEm8.default)('ajs-environment') === 'staging') {
        if (!(0, $erQjo.isWRMHeritageLoaded)()) (0, $fEmTm.captureException)(`loadBridgeStrict:${name}`, new Error('Do not call loadBridgeStrict without waitForHeritage'));
    }
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $f39gG.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $9wvOm.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("9MneQ", function(module, exports) {
$parcel$export(module.exports, "saveStats", () => $154e3b1b7c5d8d00$export$9ea3ff7978093559);
/* eslint-disable jira/filename-case */ const $154e3b1b7c5d8d00$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $154e3b1b7c5d8d00$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $154e3b1b7c5d8d00$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $154e3b1b7c5d8d00$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $154e3b1b7c5d8d00$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $154e3b1b7c5d8d00$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $154e3b1b7c5d8d00$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $154e3b1b7c5d8d00$var$initStats();
        // stop accumulating stats at TTI mark
        if ($154e3b1b7c5d8d00$var$isPageInteractive()) return;
        stats.requests += 1;
        $154e3b1b7c5d8d00$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$154e3b1b7c5d8d00$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $154e3b1b7c5d8d00$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("9wvOm", function(module, exports) {
$parcel$export(module.exports, "loadBridgeRace", () => $a14da4be2750bb9b$export$20c32b4579d78b92);
/* eslint-disable jira/filename-case */ 
var $bAzzc = parcelRequire("bAzzc");

var $8IotF = parcelRequire("8IotF");

var $1fD9L = parcelRequire("1fD9L");
const $a14da4be2750bb9b$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $1fD9L.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $8IotF.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $bAzzc.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("bAzzc", function(module, exports) {
$parcel$export(module.exports, "loadBridgeBail", () => $da55d3b5c4f426b2$export$a036f92c2465504e);
/* eslint-disable jira/filename-case */ 
var $b3AOE = parcelRequire("b3AOE");

var $1fD9L = parcelRequire("1fD9L");
const $da55d3b5c4f426b2$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $1fD9L.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $b3AOE.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $b3AOE.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});


parcelRegister("erQjo", function(module, exports) {
$parcel$export(module.exports, "isWRMHeritageLoaded", () => $7a0b36f6a0f344fd$export$1a2b9c2d0a3d83ed);
$parcel$export(module.exports, "waitForHeritage", () => $7a0b36f6a0f344fd$export$c61060338d026f78);
/* eslint-disable jira/filename-case */ 
var $44A5J = parcelRequire("44A5J");

var $aA3A5 = parcelRequire("aA3A5");
let $7a0b36f6a0f344fd$var$heritageIsLoaded = false;
const $7a0b36f6a0f344fd$export$1a2b9c2d0a3d83ed = ()=>$7a0b36f6a0f344fd$var$heritageIsLoaded;
const $7a0b36f6a0f344fd$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        $7a0b36f6a0f344fd$var$heritageIsLoaded = false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aA3A5.default)();
        (0, $44A5J.bootstrapWrmClient)().then(()=>{
            $7a0b36f6a0f344fd$var$heritageIsLoaded = true;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("44A5J", function(module, exports) {
$parcel$export(module.exports, "bootstrapWrmClient", () => $dc731f2745b60094$export$d001f71dd306cb0c);
/* eslint-disable jira/filename-case */ 
var $b3AOE = parcelRequire("b3AOE");

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");
const $dc731f2745b60094$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $dc731f2745b60094$var$fetchSpaWrmContext = async ()=>{
    return (0, $4fhEY.default)($dc731f2745b60094$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $dc731f2745b60094$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $dc731f2745b60094$var$hasWrmInitialised;
const $dc731f2745b60094$var$runBootstrap = ()=>{
    const spaWrmContext = $dc731f2745b60094$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($dc731f2745b60094$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)({
                error: new Error((0, $b3AOE.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $dc731f2745b60094$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($dc731f2745b60094$var$hasWrmInitialised) return $dc731f2745b60094$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $dc731f2745b60094$var$hasWrmInitialised = Promise.resolve();
    else $dc731f2745b60094$var$hasWrmInitialised = $dc731f2745b60094$var$runBootstrap();
    return $dc731f2745b60094$var$hasWrmInitialised;
};

});



/* eslint-disable jira/filename-case */ const $382ab3343e49976c$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';



parcelRegister("j65JU", function(module, exports) {
$parcel$export(module.exports, "useWorkspaceContext", () => $6945d6c9597f67b3$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $6945d6c9597f67b3$export$74ebc9a49f60d38a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $eBpdw = parcelRequire("eBpdw");

var $zbgUa = parcelRequire("zbgUa");

var $k6ufm = parcelRequire("k6ufm");

var $i860n = parcelRequire("i860n");

var $bOYO0 = parcelRequire("bOYO0");

var $8ycTI = parcelRequire("8ycTI");
const $6945d6c9597f67b3$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $6945d6c9597f67b3$export$122fccf0bbbc9acc = 30000;
const $6945d6c9597f67b3$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $k6ufm.useResource)((0, $8ycTI.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $6945d6c9597f67b3$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $euxye.useRef)(callback);
    // Remember the latest callback.
    (0, $euxye.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $euxye.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $6945d6c9597f67b3$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $zbgUa.useAssetsTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $6945d6c9597f67b3$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $euxye.useState)((0, $eBpdw.isCMDBEnabledInEnvironment)() && (0, $bOYO0.isAssetsUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $euxye.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $euxye.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $euxye.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $euxye.useEffect)(()=>{
        if (!hasFetchedWorkspaceId && !workspaceId && (0, $bOYO0.isAssetsUser)(tenantContext) && (0, $eBpdw.isCMDBEnabledInEnvironment)()) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        hasFetchedWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $6945d6c9597f67b3$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $6945d6c9597f67b3$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $euxye.useEffect)(()=>{
        if ((hasFetchedWorkspaceId || workspaceId && (0, $i860n.fg)('assets-user-permission-timeout-fix')) && !loading) {
            if ((0, $bOYO0.isAssetsUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});

parcelRegister("kc1yl", function(module, exports) {
$parcel$export(module.exports, "default", () => $caccb2c7b8a8482f$export$2e2bcd8739ae039);

var $8nS0k = parcelRequire("8nS0k");

var $hmdu8 = parcelRequire("hmdu8");

var $f31kM = parcelRequire("f31kM");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$caccb2c7b8a8482f$export$2e2bcd8739ae039 = (0, $8nS0k.default);

});
parcelRegister("8nS0k", function(module, exports) {
$parcel$export(module.exports, "default", () => $f820fc7b499fdd20$export$2e2bcd8739ae039);
/* page.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $f8oF5 = parcelRequire("f8oF5");
const $f820fc7b499fdd20$var$styles = {
    banner: "_1bsb1osq _kqsw1n9t",
    bannerContainer: "_16jlkb7n _1o9zidpf _i0dl1wug _v564evma _1bsb1osq _kqswh2mm _1pby11wp",
    pageContent: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _kqswh2mm _1pbykb7n",
    wrapper: "_1e0c1txw _1bsb1osq _1tke1osq _2lx21bp4",
    mainContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw",
    navigation: "_kqswh2mm _1pbycs5v"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $f820fc7b499fdd20$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $f8oF5.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $f820fc7b499fdd20$var$styles.wrapper
        ]),
        children: [
            banner ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                style: {
                    height: isBannerOpen ? `${bannerHeight}px` : '0'
                },
                "aria-hidden": !isBannerOpen,
                "data-testid": testId ? `${testId}--banner-container` : undefined,
                className: (0, $4jQY2.default)([
                    $f820fc7b499fdd20$var$styles.bannerContainer
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $f820fc7b499fdd20$var$styles.banner
                    ]),
                    children: banner
                })
            }) : null,
            /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                className: (0, $4jQY2.default)([
                    $f820fc7b499fdd20$var$styles.mainContainer
                ]),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $f820fc7b499fdd20$var$styles.navigation
                        ]),
                        children: navigation
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $f820fc7b499fdd20$var$styles.pageContent
                        ]),
                        children: children
                    })
                ]
            })
        ]
    });
};
$f820fc7b499fdd20$var$Page.displayName = "Page";
var $f820fc7b499fdd20$export$2e2bcd8739ae039 = $f820fc7b499fdd20$var$Page;

});
parcelRegister("f8oF5", function(module, exports) {
$parcel$export(module.exports, "defaultGridColumns", () => $24d97456d940fdee$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultSpacing", () => $24d97456d940fdee$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $24d97456d940fdee$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $24d97456d940fdee$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $24d97456d940fdee$export$2303d2bd9eeff99a);
const $24d97456d940fdee$var$defaultGridSize = 8;
const $24d97456d940fdee$export$74797698e12f8baa = 12;
const $24d97456d940fdee$export$b8241a1616ab1b96 = $24d97456d940fdee$var$defaultGridSize * 10;
const $24d97456d940fdee$export$8ec7372efd74b753 = 'cosy';
const $24d97456d940fdee$export$d77f83c3d17a7b8a = 52;
const $24d97456d940fdee$export$f8725d21f81f3e01 = 0;
const $24d97456d940fdee$export$2303d2bd9eeff99a = 'fixed';
const $24d97456d940fdee$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $24d97456d940fdee$export$8b7e31f391e6e681 = '--ds-column-span';
const $24d97456d940fdee$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("hmdu8", function(module, exports) {
$parcel$export(module.exports, "default", () => $18c143c935f63105$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $f8oF5 = parcelRequire("f8oF5");

var $bw1gw = parcelRequire("bw1gw");

var $6B9oj = parcelRequire("6B9oj");

var $hkPfY = parcelRequire("hkPfY");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $18c143c935f63105$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $euxye.useContext)((0, $hkPfY.GridContext));
    const { medium: medium } = (0, $euxye.useContext)((0, $6B9oj.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f8oF5.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f8oF5.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $euxye.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hkPfY.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bw1gw.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
$18c143c935f63105$var$GridWrapper.displayName = "GridWrapper";
var $18c143c935f63105$export$2e2bcd8739ae039 = $18c143c935f63105$var$GridWrapper;

});
parcelRegister("bw1gw", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $7175ccf96e515575$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $f8oF5 = parcelRequire("f8oF5");

var $hkPfY = parcelRequire("hkPfY");

var $2M64p = parcelRequire("2M64p");
const $7175ccf96e515575$var$defaultGridColumnWidth = 80;
/**
 * The number of available columns in each row.
 */ const $7175ccf96e515575$var$varColumnsNum = '--ds-columns-num';
/**
 * The spacing (in `px`) between each column.
 */ const $7175ccf96e515575$var$varGridSpacing = '--ds-grid-spacing';
const $7175ccf96e515575$var$styles = {
    grid: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3wx3y _n3tdidpf _19bvwx3y _1e0c1txw _kqswh2mm _4cvr1y6m _1n261g80",
    nestedGrid: "_19pkidpf _2hwx1un2 _otyridpf _18u01un2"
};
const $7175ccf96e515575$var$gridLayoutMapStyles = {
    fixed: "_p12fgkkb",
    fluid: "_p12f1osq"
};
const $7175ccf96e515575$export$ef2184bd89960b14 = ({ layout: layout = (0, $f8oF5.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $euxye.useContext)((0, $hkPfY.GridContext));
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        style: {
            [$7175ccf96e515575$var$varColumnsNum]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$7175ccf96e515575$var$varGridSpacing]: `${(0, $2M64p.spacingMapping)[spacing]}px`
        },
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $7175ccf96e515575$var$styles.grid,
            $7175ccf96e515575$var$gridLayoutMapStyles[layout],
            isNested && $7175ccf96e515575$var$styles.nestedGrid
        ]),
        children: children
    });
};
$7175ccf96e515575$export$ef2184bd89960b14.displayName = "Grid";

});
parcelRegister("hkPfY", function(module, exports) {
$parcel$export(module.exports, "GridContext", () => $d7959daf2ebfbdc3$export$11cae3e04ab99fae);

var $euxye = parcelRequire("euxye");

var $f8oF5 = parcelRequire("f8oF5");
const $d7959daf2ebfbdc3$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $euxye.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f8oF5.defaultSpacing),
    columns: (0, $f8oF5.defaultGridColumns)
});

});

parcelRegister("2M64p", function(module, exports) {
$parcel$export(module.exports, "spacingMapping", () => $3b89376600068f7e$export$2a89a65a43bab52d);
const $3b89376600068f7e$var$defaultGridSize = 8;
const $3b89376600068f7e$export$2a89a65a43bab52d = {
    comfortable: $3b89376600068f7e$var$defaultGridSize * 5,
    cosy: $3b89376600068f7e$var$defaultGridSize * 2,
    compact: $3b89376600068f7e$var$defaultGridSize * 0.5
};

});


parcelRegister("6B9oj", function(module, exports) {
$parcel$export(module.exports, "GridColumnContext", () => $b5fe7ed1804a8ebc$export$1229ad7112b989f5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $f8oF5 = parcelRequire("f8oF5");
const $b5fe7ed1804a8ebc$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $euxye.createContext)({
    medium: (0, $f8oF5.defaultMedium)
});

});


parcelRegister("f31kM", function(module, exports) {
$parcel$export(module.exports, "default", () => $79227991f99a811f$export$2e2bcd8739ae039);
/* grid-column.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $f8oF5 = parcelRequire("f8oF5");

var $6B9oj = parcelRequire("6B9oj");

var $hkPfY = parcelRequire("hkPfY");
/**
 * Determines the method by which column width is calculated.
 */ var $79227991f99a811f$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($79227991f99a811f$var$ColumnVariant || {});
/**
 * The spacing (in `px`) between each column.
 */ const $79227991f99a811f$var$varGridSpacing = '--ds-grid-spacing';
/**
 * The number of columns that a `GridColumn` covers.
 */ const $79227991f99a811f$var$varColumnSpan = '--ds-column-span';
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $79227991f99a811f$var$singleColumnWidth = `(99.9999% / var(--ds-columns-num))`;
const $79227991f99a811f$var$styles = {
    gridColumn: "_19pkidpf _2hwxwx3y _otyridpf _18u0wx3y _1ul9hrtj _16jlkb7n _1o9zidpf _slp31hna"
};
const $79227991f99a811f$var$gridColumnWidthMapStyles = {
    auto: "_p12f1ho1 _i0dl1wug",
    bounded: "_p12fpg3g _i0dl1osq",
    fullWidth: "_p12f1ho1 _i0dl1osq"
};
const $79227991f99a811f$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f8oF5.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $79227991f99a811f$var$GridColumn = ({ medium: medium = (0, $f8oF5.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $euxye.useContext)((0, $hkPfY.GridContext));
    const contextValue = (0, $euxye.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $79227991f99a811f$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6B9oj.GridColumnContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            style: {
                /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ [$79227991f99a811f$var$varColumnSpan]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId,
            className: (0, $4jQY2.default)([
                $79227991f99a811f$var$styles.gridColumn,
                $79227991f99a811f$var$gridColumnWidthMapStyles[variant]
            ]),
            children: children
        })
    });
};
$79227991f99a811f$var$GridColumn.displayName = "GridColumn";
var $79227991f99a811f$export$2e2bcd8739ae039 = $79227991f99a811f$var$GridColumn;

});


parcelRegister("bOtBg", function(module, exports) {
$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $ad8c3d2138b2d254$export$ac31f8f3368d6881);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable import/order */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aZMdt = parcelRequire("aZMdt");

var $gapGE = parcelRequire("gapGE");

var $koA6h = parcelRequire("koA6h");
const $ad8c3d2138b2d254$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext = (0, $gapGE.useContainerContext), useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext = (0, $koA6h.useServiceDeskAnalyticsContext), children: children, forceRenderWhileLoading: forceRenderWhileLoading = false })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $euxye.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$ad8c3d2138b2d254$export$ac31f8f3368d6881.displayName = "ServiceDeskAnalyticsContext";

});

parcelRegister("4Ojfp", function(module, exports) {
$parcel$export(module.exports, "useAssetsDataManagerUserAuth", () => $ba355eed4384e6ee$export$7b8e9d8ead51323e);
$parcel$export(module.exports, "useAssetsDataManagerAccess", () => $ba355eed4384e6ee$export$c1d0380ec239cdde);

var $1ntzc = parcelRequire("1ntzc");

var $cIBCk = parcelRequire("cIBCk");

var $zbgUa = parcelRequire("zbgUa");

var $i860n = parcelRequire("i860n");

var $f2wVS = parcelRequire("f2wVS");
const $ba355eed4384e6ee$export$305222dff575c4e3 = (0, $f2wVS.createRouterSelector)(({ match: match })=>match.url);
const $ba355eed4384e6ee$var$isDataManagerAdmin = (roles)=>roles?.includes((0, $cIBCk.DATA_MANAGER_ADMIN)) || roles?.includes((0, $cIBCk.DATA_MANAGER_ADAPTERS_ADMIN));
const $ba355eed4384e6ee$export$30aadaab39fae199 = (0, $f2wVS.createRouterSelector)((state)=>state.route.name);
const $ba355eed4384e6ee$export$7b8e9d8ead51323e = ()=>{
    const url = $ba355eed4384e6ee$export$305222dff575c4e3();
    const isSiteAdmin = (0, $zbgUa.useAssetsIsSiteAdmin)();
    const [{ dataManager: dataManager, loading: isInsightGlobalConfigLoading }] = (0, $1ntzc.useInsightGlobalConfig)();
    const { isProvisioned: isDataManagerProvisioned, provisioningLoading: provisioningLoading, myRolesLoading: myRolesLoading } = dataManager ?? {};
    const isLoading = isInsightGlobalConfigLoading || myRolesLoading || provisioningLoading;
    const routeName = $ba355eed4384e6ee$export$30aadaab39fae199();
    const { isAdmin: isAdmin, isDashboardEditor: isDashboardEditor } = $ba355eed4384e6ee$export$c1d0380ec239cdde();
    if (!url.startsWith('/jira/assets/data-manager') || isLoading || !(0, $i860n.fg)('assets_data_manager_jira_spa')) return {
        isAssetsDataManagerUnauthorizedUser: false
    };
    if (!isDataManagerProvisioned) return {
        isAssetsDataManagerUnauthorizedUser: true
    };
    let isAuthorized = isSiteAdmin || isAdmin;
    if (isAuthorized) return {
        isAssetsDataManagerUnauthorizedUser: false
    };
    // For all open routes, display the page regardless of the role,
    // except for object class settings route because, certain nested routes in it have access for all roles.
    if ((0, $cIBCk.DATA_MANAGER_OPEN_ROUTE_ALL_ROLES).includes(routeName)) {
        const isObjectClassSettingsRouteWithAccessForAllRoles = routeName === 'assets-data-manager-object-class-settings' && !url.includes('mapping-matrix') && !url.includes('cleansing-statistics');
        isAuthorized = !isObjectClassSettingsRouteWithAccessForAllRoles;
    }
    // If the user is a dashboard editor and
    // the route is the data dictionaries route, allow access.
    if (isDashboardEditor && routeName === (0, $cIBCk.DATA_MANAGER_CLASS_SETTING_ROUTE_NAME) && url.includes('data-dictionaries')) isAuthorized = true;
    return {
        isAssetsDataManagerUnauthorizedUser: isAuthorized === false
    };
};
const $ba355eed4384e6ee$export$c1d0380ec239cdde = ()=>{
    const [{ dataManager: { myRoles: myRoles } }] = (0, $1ntzc.useInsightGlobalConfig)();
    let isAdmin = false;
    let isDashboardEditor = false;
    let isDashboardViewer = false;
    if ($ba355eed4384e6ee$var$isDataManagerAdmin(myRoles)) {
        isAdmin = true;
        isDashboardEditor = true;
        isDashboardViewer = true;
    } else if (myRoles?.includes((0, $cIBCk.DATA_MANAGER_REPORT_EDITOR))) {
        isDashboardEditor = true;
        isDashboardViewer = true;
    } else if (myRoles?.includes((0, $cIBCk.DATA_MANAGER_REPORT_VIEWER))) isDashboardViewer = true;
    return {
        isAdmin: isAdmin,
        isDashboardEditor: isDashboardEditor,
        isDashboardViewer: isDashboardViewer
    };
};

});
parcelRegister("cIBCk", function(module, exports) {
$parcel$export(module.exports, "DATA_MANAGER_ADMIN", () => $6b66977dd3675a51$export$48abe9ccfdd98170);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_VIEWER", () => $6b66977dd3675a51$export$8939b849d295aa4c);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_EDITOR", () => $6b66977dd3675a51$export$4ca2081d195ddbdb);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ADMIN", () => $6b66977dd3675a51$export$4c3d5fe6bdc107f1);
$parcel$export(module.exports, "DATA_MANAGER_ROLES", () => $6b66977dd3675a51$export$48703faa5030b273);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ROLES", () => $6b66977dd3675a51$export$8b2dfd13f5f35ee4);
$parcel$export(module.exports, "ORDERED_ASSETS_DATA_MANAGER_ROLES", () => $6b66977dd3675a51$export$1d276f65230af2e);
$parcel$export(module.exports, "DATA_MANAGER_CLASS_SETTING_ROUTE_NAME", () => $6b66977dd3675a51$export$59f9384eee594cb2);
$parcel$export(module.exports, "DATA_MANAGER_OPEN_ROUTE_ALL_ROLES", () => $6b66977dd3675a51$export$a71025248fd03044);
/* eslint-disable jira/filename-case */ const $6b66977dd3675a51$export$48abe9ccfdd98170 = 'ari:cloud:cmdb::role/airtrack/admin';
const $6b66977dd3675a51$export$8939b849d295aa4c = 'ari:cloud:cmdb::role/airtrack/report-viewer';
const $6b66977dd3675a51$export$4ca2081d195ddbdb = 'ari:cloud:cmdb::role/airtrack/report-editor';
const $6b66977dd3675a51$export$4c3d5fe6bdc107f1 = 'ari:cloud:cmdb::role/airtrack-buoy/admin';
const $6b66977dd3675a51$export$48703faa5030b273 = [
    $6b66977dd3675a51$export$48abe9ccfdd98170,
    $6b66977dd3675a51$export$8939b849d295aa4c,
    $6b66977dd3675a51$export$4ca2081d195ddbdb
];
const $6b66977dd3675a51$export$8b2dfd13f5f35ee4 = [
    $6b66977dd3675a51$export$4c3d5fe6bdc107f1
];
const $6b66977dd3675a51$export$1d276f65230af2e = [
    $6b66977dd3675a51$export$48abe9ccfdd98170,
    $6b66977dd3675a51$export$4c3d5fe6bdc107f1,
    $6b66977dd3675a51$export$4ca2081d195ddbdb,
    $6b66977dd3675a51$export$8939b849d295aa4c
];
const $6b66977dd3675a51$export$59f9384eee594cb2 = 'assets-data-manager-object-class-settings';
const $6b66977dd3675a51$export$a71025248fd03044 = [
    'assets-data-manager-getting-started',
    'assets-data-manager-object-classes',
    'assets-data-manager-object-class-view',
    'assets-data-manager-data-source',
    'assets-data-manager-object-detail-view',
    $6b66977dd3675a51$export$59f9384eee594cb2
];

});


parcelRegister("5Swah", function(module, exports) {
$parcel$export(module.exports, "NoAccessErrorPage", () => $442acedb6a23036f$export$8126b1d7463b1f82);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $j26jU = parcelRequire("j26jU");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $hzWaA = parcelRequire("hzWaA");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $8oyUS = parcelRequire("8oyUS");
const $442acedb6a23036f$var$errorTitle = (0, $7eNDO.defineMessage)({
    id: "spa-assets-app-base.no-access-error-page.error-title",
    defaultMessage: "You need permission to access this page"
});
const $442acedb6a23036f$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "spa-assets-app-base.no-access-error-page.error-description",
    defaultMessage: "If you think you should have access, contact your admin."
});
const $442acedb6a23036f$var$goToHomeLinkLabel = (0, $7eNDO.defineMessage)({
    id: "spa-assets-app-base.no-access-error-page.go-to-home-link-label",
    defaultMessage: "Go to Atlassian Home"
});
const $442acedb6a23036f$export$8126b1d7463b1f82 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $442acedb6a23036f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8oyUS))),
        header: formatMessage($442acedb6a23036f$var$errorTitle),
        description: formatMessage($442acedb6a23036f$var$errorDescription),
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
            href: "https://home.atlassian.com"
        }, formatMessage($442acedb6a23036f$var$goToHomeLinkLabel))
    }));
};
$442acedb6a23036f$export$8126b1d7463b1f82.displayName = "NoAccessErrorPage";
const $442acedb6a23036f$var$containerStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    height: '100%',
    placeItems: 'center'
});

});
parcelRegister("8oyUS", function(module, exports) {
module.exports = new URL("lock.bb0ac3af.svg", import.meta.url).toString();

});


parcelRegister("cvJhE", function(module, exports) {
$parcel$export(module.exports, "useHideAssetsReportsInIsolatedCloud", () => $71a998d37c8e4b2f$export$8156ab4e157cd35f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $41FAq = parcelRequire("41FAq");

var $f2wVS = parcelRequire("f2wVS");

var $lRYAe = parcelRequire("lRYAe");

var $i860n = parcelRequire("i860n");
const $71a998d37c8e4b2f$export$305222dff575c4e3 = (0, $f2wVS.createRouterSelector)(({ match: match })=>match.url);
const $71a998d37c8e4b2f$export$8156ab4e157cd35f = ()=>{
    const url = $71a998d37c8e4b2f$export$305222dff575c4e3();
    const isIsolatedCloudEnv = (0, $i860n.fg)('aem_migration_jira') ? !(0, $41FAq.isFeatureEnabled)('assets', 'assets-reports') : (0, $lRYAe.isIsolatedCloud)();
    const isReportsUrl = url.startsWith('/jira/assets/reports');
    if (isReportsUrl && isIsolatedCloudEnv) return true;
    return false;
};

});


parcelRegister("oWdC4", function(module, exports) {
$parcel$export(module.exports, "isNewReportsNavExperienceEnabled", () => $c91224bd9c65602d$export$47ecf2612742e601);
// eslint-disable-next-line jira/filename-case

var $i860n = parcelRequire("i860n");
const $c91224bd9c65602d$export$b8215a2c67e2e65d = {
    main: 'assets-reports-and-dashboard-navigation',
    eap: 'new_assets_reports_avp_experience'
};
const $c91224bd9c65602d$export$87e0f7dd6dec932f = (key)=>Boolean((0, $i860n.fg)(key));
const $c91224bd9c65602d$export$3ffa4c816d3c03c1 = ()=>$c91224bd9c65602d$export$87e0f7dd6dec932f($c91224bd9c65602d$export$b8215a2c67e2e65d.main);
const $c91224bd9c65602d$export$47ecf2612742e601 = ()=>$c91224bd9c65602d$export$87e0f7dd6dec932f($c91224bd9c65602d$export$b8215a2c67e2e65d.main) && $c91224bd9c65602d$export$87e0f7dd6dec932f($c91224bd9c65602d$export$b8215a2c67e2e65d.eap);
const $c91224bd9c65602d$export$9b7963d512920ccb = ()=>$c91224bd9c65602d$export$87e0f7dd6dec932f($c91224bd9c65602d$export$b8215a2c67e2e65d.eap);

});

parcelRegister("aZT7c", function(module, exports) {
$parcel$export(module.exports, "DashboardEditable", () => $2166bd797940eba0$export$33b9febc64bdf6bf);

var $euxye = parcelRequire("euxye");

var $2U5t1 = parcelRequire("2U5t1");

var $hCTLL = parcelRequire("hCTLL");

var $ctMIM = parcelRequire("ctMIM");

var $hUqPj = parcelRequire("hUqPj");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $l8G1z = parcelRequire("l8G1z");

var $i860n = parcelRequire("i860n");

var $15E7V = parcelRequire("15E7V");

var $1YIbA = parcelRequire("1YIbA");

var $gNbXR = parcelRequire("gNbXR");
var $cZjb4 = parcelRequire("cZjb4");
var $55BnK = parcelRequire("55BnK");

var $kt86l = parcelRequire("kt86l");

var $6bGyp = parcelRequire("6bGyp");

var $k5P9q = parcelRequire("k5P9q");

var $6RcRV = parcelRequire("6RcRV");

var $jZe0u = parcelRequire("jZe0u");

var $8PHdJ = parcelRequire("8PHdJ");
const $2166bd797940eba0$var$isUuid = (input)=>/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(input);

const $2166bd797940eba0$var$LazyITSMAnalyticsDashboard = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1CryE")).then(({ ITSMAnalyticsDashboard: ITSMAnalyticsDashboard })=>ITSMAnalyticsDashboard), {
    moduleId: "./node_modules/@atlassian/viz-platform-views-next/esm/index.js"
});
const $2166bd797940eba0$var$fallbackFormDimensions = {
    viewMode: {
        width: 592,
        maxHeight: 455,
        minHeight: 240
    },
    editMode: {
        width: 592,
        maxHeight: 622,
        minHeight: 407
    }
};
const $2166bd797940eba0$export$33b9febc64bdf6bf = ({ workspaceId: workspaceId })=>{
    const [templateId] = (0, $cZjb4.usePathParam)('templateId');
    const cloudId = (0, $kt86l.useCloudId)();
    const { locale: locale } = (0, $1YIbA.default)();
    const atlassianUser = (0, $2U5t1.useAvpAtlassianUser)();
    const workspace = (0, $hCTLL.useAvpWorkspace)(workspaceId);
    const environment = (0, $k5P9q.useEnvironment)();
    const { isOrgAdmin: isOrgAdmin } = (0, $ctMIM.useIsOrgAdmin)();
    const { data: rovoEntitlement } = (0, $6bGyp.useRovoEntitlementResource)();
    const { replace: replace } = (0, $55BnK.useRouterActions)();
    if (!templateId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/jira/servicedesk/assets/reports"
    });
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6RcRV.default), null), (0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jZe0u.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $2166bd797940eba0$var$dashboardEditableWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2166bd797940eba0$var$LazyITSMAnalyticsDashboard, {
        hostingProduct: "jsm-cmdb",
        // dashboardId is a uuid, slug is not
        slug: $2166bd797940eba0$var$isUuid(templateId) ? null : templateId,
        dashboardId: $2166bd797940eba0$var$isUuid(templateId) ? templateId : null,
        activationId: workspaceId,
        services: {
            useSemanticModel: (0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics') ? (0, $8PHdJ.useAssetsDashboardsSemanticModel) : undefined
        },
        allowGlobalFilters: true,
        cloudId: cloudId,
        locale: locale,
        atlassianUser: atlassianUser,
        ...(0, $i860n.fg)('enable_global_filter_config_ers_version') && {
            fallbackFormDimensions: $2166bd797940eba0$var$fallbackFormDimensions
        },
        workspace: workspace,
        isUserOrgAdmin: isOrgAdmin,
        environment: environment,
        perimeter: "commercial",
        location: "assets",
        aiConfig: {
            rovoEnabled: (0, $i860n.fg)('jsm_assets_dashboards_ai_insights') && Boolean(rovoEntitlement?.isRovoEnabled && rovoEntitlement?.isRovoLLMEnabled),
            feedbackEntrypointId: (0, $15E7V.ENTRY_POINT_ID_JSM_ASSETS_REPORTING)
        },
        ...(0, $i860n.fg)('jsm_reporting_graphql_fe_changes') && {
            redirectToDashboardId: (dashboardId)=>{
                replace(`/jira/assets/dashboards/${dashboardId}`);
            }
        },
        key: templateId
    })));
    if ((0, $i860n.fg)('jsm_assets_analytics_context_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hUqPj.default), {
        data: {
            source: 'assets-reporting'
        }
    }, content);
    return content;
};
$2166bd797940eba0$export$33b9febc64bdf6bf.displayName = "DashboardEditable";
const $2166bd797940eba0$var$dashboardEditableWrapper = (0, $fbAgj.xcss)({
    marginLeft: 'space.400',
    marginRight: 'space.400'
});

});
parcelRegister("2U5t1", function(module, exports) {
$parcel$export(module.exports, "useAvpAtlassianUser", () => $88cd79bfe1bcf85d$export$fb86573328c3d9d2);

var $e7boj = parcelRequire("e7boj");

var $3GN2r = parcelRequire("3GN2r");

var $gQJGQ = parcelRequire("gQJGQ");

var $8Cuad = parcelRequire("8Cuad");
function $88cd79bfe1bcf85d$export$fb86573328c3d9d2() {
    const $ = (0, $e7boj.c)(4);
    const accountId = (0, $3GN2r.useAccountId)();
    const userFullname = (0, $8Cuad.useUserFullname)();
    const locale = (0, $gQJGQ.useLocale)();
    let t0;
    if ($[0] !== accountId || $[1] !== locale || $[2] !== userFullname) {
        t0 = {
            account_id: accountId,
            name: userFullname,
            picture: undefined,
            principal_type: "user",
            locale: locale,
            email: undefined
        };
        $[0] = accountId;
        $[1] = locale;
        $[2] = userFullname;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
}

});
parcelRegister("8Cuad", function(module, exports) {
$parcel$export(module.exports, "useUserFullname", () => $1b98a0c6c3ff7086$export$d8370c6e50e762dd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $1b98a0c6c3ff7086$export$d8370c6e50e762dd = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.userFullname;
};

});


parcelRegister("hCTLL", function(module, exports) {
$parcel$export(module.exports, "useAvpWorkspace", () => $66898815647d13aa$export$5fa5486e47d5100b);

var $e7boj = parcelRequire("e7boj");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $6zTYs = parcelRequire("6zTYs");
function $66898815647d13aa$export$5fa5486e47d5100b(workspaceId) {
    const $ = (0, $e7boj.c)(4);
    const activationId = (0, $h3LJR.useActivationId)();
    const cloudId = (0, $kt86l.useCloudId)();
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const t0 = workspaceId ?? activationId;
    let t1;
    if ($[0] !== cloudId || $[1] !== orgId || $[2] !== t0) {
        t1 = {
            id: t0,
            cloud_id: cloudId,
            access: 2,
            atlassian_org_id: orgId,
            is_data_compliant: true
        };
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
}

});

parcelRegister("ctMIM", function(module, exports) {
$parcel$export(module.exports, "useIsOrgAdmin", () => $d92067e6617a676f$export$8ed42372757d8b2a);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $5pyRb = parcelRequire("5pyRb");

var $h2wCv = parcelRequire("h2wCv");

var $h1pEM = parcelRequire("h1pEM");

var $3GN2r = parcelRequire("3GN2r");
const $d92067e6617a676f$var$getUserOrgPermissions = async ({ orgId: orgId, userId: userId })=>(0, $h2wCv.performPostRequest)('/gateway/api/permissions/permitted', {
        body: JSON.stringify({
            resourceId: `ari:cloud:platform::org/${orgId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage/org'
        })
    }).then((resp)=>!!resp?.permitted);
const $d92067e6617a676f$export$8ed42372757d8b2a = ()=>{
    const userId = (0, $3GN2r.useAccountId)();
    const orgId = (0, $h1pEM.useOrgId)();
    const checkUserIsOrgAdmin = (0, $euxye.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        return $d92067e6617a676f$var$getUserOrgPermissions({
            orgId: orgId,
            userId: userId
        });
    }, [
        orgId,
        userId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchIsOrgAdmin } = (0, $5pyRb.useService)(checkUserIsOrgAdmin, {
        data: false
    });
    (0, $euxye.useEffect)(()=>{
        fetchIsOrgAdmin();
    }, [
        fetchIsOrgAdmin
    ]);
    (0, $euxye.useEffect)(()=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'checkUserIsOrgAdmin',
                packageName: 'jiraPlatformSrerviceIsOrgAdmin',
                teamName: 'duke-dlm'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: error
        });
    }, [
        error
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error,
        retry: fetchIsOrgAdmin
    };
};

});
parcelRegister("h1pEM", function(module, exports) {
$parcel$export(module.exports, "useOrgId", () => $8742d5a7d297fb28$export$52a03a3207af3687);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $8742d5a7d297fb28$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});


parcelRegister("15E7V", function(module, exports) {
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $5a20651f769fa2ff$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_GIC_AI_FIELD_SUGGESTIONS", () => $5a20651f769fa2ff$export$ef62c5d355c31b59);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $5a20651f769fa2ff$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $5a20651f769fa2ff$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $5a20651f769fa2ff$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $5a20651f769fa2ff$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $5a20651f769fa2ff$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $5a20651f769fa2ff$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $5a20651f769fa2ff$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_JIRA_SPACE_CREATE", () => $5a20651f769fa2ff$export$9bde170c20aeb12e);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $5a20651f769fa2ff$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $5a20651f769fa2ff$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $5a20651f769fa2ff$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $5a20651f769fa2ff$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $5a20651f769fa2ff$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRYPOINT_ID_PROJECT_BACKGROUNDS", () => $5a20651f769fa2ff$export$9a234699f0515bf);
$parcel$export(module.exports, "ENTRY_POINT_ID_JOURNEY_BUILDER", () => $5a20651f769fa2ff$export$f24169c529e6c9b5);
$parcel$export(module.exports, "ENTRY_POINT_ID_PLAYBOOKS", () => $5a20651f769fa2ff$export$68dc647ed5ef59d9);
$parcel$export(module.exports, "ENTRY_POINT_ID_BULK_OPERATIONS", () => $5a20651f769fa2ff$export$f849b75576b691b);
$parcel$export(module.exports, "ENTRY_POINT_ID_BULK_OPERATIONS_MERGE_PANEL", () => $5a20651f769fa2ff$export$3f171ed85802673d);
$parcel$export(module.exports, "ENTRY_POINT_ID_ADMIN_ONBOARDING_HUB", () => $5a20651f769fa2ff$export$c0e3a1d9aa18e8eb);
$parcel$export(module.exports, "ENTRY_POINT_ID_AI_CONTEXT_RESOLUTION_PLAN_PANEL", () => $5a20651f769fa2ff$export$7f190c8f7bc2242);
$parcel$export(module.exports, "ENTRY_POINT_ID_INDIVIDUAL_CAPACITY_PLANNING", () => $5a20651f769fa2ff$export$8df25926ec47a767);
$parcel$export(module.exports, "ENTRY_POINT_ID_HORIZONTAL_NAV", () => $5a20651f769fa2ff$export$88efeb072ad93ff7);
$parcel$export(module.exports, "EntryKeys", () => $5a20651f769fa2ff$export$12d01b6c311a909a);
/* eslint-disable jira/filename-case */ // Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $5a20651f769fa2ff$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $5a20651f769fa2ff$export$ef62c5d355c31b59 = '5d198c09-f525-4eb1-8e33-f277c4050a8e';
const $5a20651f769fa2ff$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $5a20651f769fa2ff$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $5a20651f769fa2ff$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $5a20651f769fa2ff$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $5a20651f769fa2ff$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $5a20651f769fa2ff$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $5a20651f769fa2ff$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $5a20651f769fa2ff$export$9bde170c20aeb12e = '4cd73d76-ada3-4ecc-8060-ba3113b3e96c';
const $5a20651f769fa2ff$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $5a20651f769fa2ff$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $5a20651f769fa2ff$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $5a20651f769fa2ff$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $5a20651f769fa2ff$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $5a20651f769fa2ff$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $5a20651f769fa2ff$export$9a234699f0515bf = 'd0f0863a-fe78-4d40-b4f0-451c268594cc';
const $5a20651f769fa2ff$export$f24169c529e6c9b5 = 'd5f62dde-d505-413b-a417-c2dd6979cac2';
const $5a20651f769fa2ff$export$68dc647ed5ef59d9 = 'e578a125-130e-4762-9556-2acb236a12cc';
const $5a20651f769fa2ff$export$f849b75576b691b = '106df6fd-feed-4aa7-bbf7-5ca2bec6266b';
const $5a20651f769fa2ff$export$3f171ed85802673d = 'c1880d75-c7ba-40e6-850f-1355c8ac2b22';
const $5a20651f769fa2ff$export$c0e3a1d9aa18e8eb = '7620f432-f831-4711-8e09-3aa379bf2d96';
const $5a20651f769fa2ff$export$7f190c8f7bc2242 = 'a8c2aa57-6975-4ed7-80c6-42f46f0bdf91';
const $5a20651f769fa2ff$export$8df25926ec47a767 = 'aab1458f-e9f0-49e0-b86e-b191e9186a4a';
const $5a20651f769fa2ff$export$88efeb072ad93ff7 = '9c1d7477-03c3-4266-8f32-44c536b4d4b4';
const $5a20651f769fa2ff$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_ANONYMOUS: 'is-anonymous',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap',
    STANDUPS: 'standups'
});

});

parcelRegister("6RcRV", function(module, exports) {
$parcel$export(module.exports, "default", () => $0661409448ec689f$export$2e2bcd8739ae039);
/* AssetsDeeplinkingModal.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $iOfms = parcelRequire("iOfms");

var $m9iwH = parcelRequire("m9iwH");

var $i68tN = parcelRequire("i68tN");

var $ihEDU = parcelRequire("ihEDU");

var $8Sdzy = parcelRequire("8Sdzy");

var $5xQxe = parcelRequire("5xQxe");

var $7eNDO = parcelRequire("7eNDO");
var $55qdj = parcelRequire("55qdj");

var $DIqjH = parcelRequire("DIqjH");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");
var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $8eE53 = parcelRequire("8eE53");

var $4hP6R = parcelRequire("4hP6R");
const $0661409448ec689f$var$MODAL_WIDTH = 968;
const $0661409448ec689f$var$MODAL_HEIGHT = 499;
const $0661409448ec689f$var$assetsDeeplinkingModalHeading = (0, $7eNDO.defineMessage)({
    id: "servicedesk-insight-reports-v2.assets-deeplinking-modal.heading",
    defaultMessage: "See the data behind your charts"
});
const $0661409448ec689f$var$assetsDeeplinkingModalDescription1 = (0, $7eNDO.defineMessage)({
    id: "servicedesk-insight-reports-v2.assets-deeplinking-modal.description1",
    defaultMessage: "You can now click directly on data points in your charts to drill in and see the underlying records. For example, if you select a bar in the \u201Cticket volume\u201D chart, we\u2019ll open a detailed view showing the actual tickets that make up that data point."
});
const $0661409448ec689f$var$assetsDeeplinkingModalDescription2 = (0, $7eNDO.defineMessage)({
    id: "servicedesk-insight-reports-v2.assets-deeplinking-modal.description2",
    defaultMessage: "This lets you move from high-level trends to the raw sources behind them in just one click."
});
const $0661409448ec689f$var$assetsDeeplinkingModalDoneButton = (0, $7eNDO.defineMessage)({
    id: "servicedesk-insight-reports-v2.assets-deeplinking-modal.doneButton",
    defaultMessage: "Done"
});
const $0661409448ec689f$var$assetsDeeplinkingModalCloseButton = (0, $7eNDO.defineMessage)({
    id: "servicedesk-insight-reports-v2.assets-deeplinking-modal.closeButton",
    defaultMessage: "Close"
});
const $0661409448ec689f$var$ModalActions = ({ onDoneClicked: onDoneClicked })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
        appearance: "primary",
        onClick: onDoneClicked,
        autoFocus: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $0661409448ec689f$var$assetsDeeplinkingModalDoneButton)));
$0661409448ec689f$var$ModalActions.displayName = "ModalActions";
const $0661409448ec689f$var$styles = {
    illustrationImage: "_1r04ze3t _1e0c1ule _4t3i1osq _c71l1osq _p12f1osq _5ral1dfr _rsufaqso _kqswstnw _1bsb1osq",
    imageWrapper: "_1reo15vq _18m915vq _4cvr1h6o _bfhk1773 _1e0c1txw _4t3i1osq _1bah1h6o _kqswh2mm _1bsb1osq",
    closeButtonWrapper: "_2rko12b0 _1h6d8yml _1dqonqa1 _189ee4h9 _bfhkysee _kqswstnw _1xi2pxbi _154ipxbi"
};
const $0661409448ec689f$var$CloseIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
        label: "Close",
        color: "var(--ds-icon, #292A2E)"
    });
$0661409448ec689f$var$CloseIcon.displayName = "CloseIcon";
const $0661409448ec689f$var$OnboardingImage = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $0661409448ec689f$var$styles.imageWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $0661409448ec689f$var$styles.illustrationImage,
        as: "img",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8eE53))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $0661409448ec689f$var$styles.closeButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        appearance: "subtle",
        icon: $0661409448ec689f$var$CloseIcon,
        onClick: onClose,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $0661409448ec689f$var$assetsDeeplinkingModalCloseButton)
    })));
$0661409448ec689f$var$OnboardingImage.displayName = "OnboardingImage";
const $0661409448ec689f$var$AssetsDeeplinkingModal = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $euxye.useState)(()=>(0, $4hP6R.readAssetsDeeplinkingModalShouldShow)());
    const persistModalClosed = (0, $euxye.useCallback)(()=>{
        (0, $4hP6R.persistAssetsDeeplinkingModalClosed)();
        setIsModalOpen(false);
    }, []);
    const handleDismiss = (0, $euxye.useCallback)(async ()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'assetsDashboardsDeepLinkingModal',
            attributes: {
                buttonId: 'cross'
            }
        });
        persistModalClosed();
    }, [
        createAnalyticsEvent,
        persistModalClosed
    ]);
    const onDoneClicked = (0, $euxye.useCallback)(async ()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'assetsDashboardsDeepLinkingModal',
            attributes: {
                buttonId: 'doneButton'
            }
        });
        persistModalClosed();
    }, [
        createAnalyticsEvent,
        persistModalClosed
    ]);
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "assetsDashboardsDeepLinkingOnboarding",
        sourceType: (0, $46f069e6c968f461$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal), {
        height: $0661409448ec689f$var$MODAL_HEIGHT,
        messageId: "insight-reports-v2.modal-dialog.jsm-insight-reports-v2.assets-deeplinking-modal.assets-deeplinking-modal",
        messageType: "transactional",
        onClose: handleDismiss,
        width: $0661409448ec689f$var$MODAL_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5xQxe.Modal), {
        renderedInsideEntrypoint: true,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $0661409448ec689f$var$assetsDeeplinkingModalHeading),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0661409448ec689f$var$ModalActions, {
            onDoneClicked: onDoneClicked
        }),
        sideContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0661409448ec689f$var$OnboardingImage, {
            onClose: handleDismiss
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        as: "p",
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $0661409448ec689f$var$assetsDeeplinkingModalDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        as: "p",
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55qdj.default), $0661409448ec689f$var$assetsDeeplinkingModalDescription2))))));
};
$0661409448ec689f$var$AssetsDeeplinkingModal.displayName = "AssetsDeeplinkingModal";
var $0661409448ec689f$export$2e2bcd8739ae039 = $0661409448ec689f$var$AssetsDeeplinkingModal;

});
parcelRegister("5xQxe", function(module, exports) {
$parcel$export(module.exports, "Modal", () => $5802df54c5a1439b$export$2b77a92f1a5ad772);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $keJFr = parcelRequire("keJFr");
var $7tY81 = parcelRequire("7tY81");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $93lG0 = parcelRequire("93lG0");

var $2r1x4 = parcelRequire("2r1x4");

var $l9ya1 = parcelRequire("l9ya1");
const $5802df54c5a1439b$var$styles = {
    hasSideContentContainer: "_2rkog72m _kqswh2mm _18m91wug _4t3i1osq _dm2511p5 _1rqtwxkt",
    baseContainer: "_kqswh2mm",
    stack: "_4t3i1osq _ca0qoahv _u5f3oahv _n3tdoahv _19bvoahv _18m91wug",
    sideContainer: "_1e0cglyw _4ap3ysee _dm251txw _glte1osq _1mbp1wug",
    leftSideContainer: "_st56g72m _ht3kg72m",
    rightSideContainer: "_o0bag72m _zsqyg72m",
    closeButton: "_kqswstnw _154ipxbi _1xi2pxbi _1pbykb7n"
};
const $5802df54c5a1439b$export$2b77a92f1a5ad772 = ({ renderedInsideEntrypoint: renderedInsideEntrypoint, backgroundColor: backgroundColor, ...modalProps })=>{
    const hasSideContent = !!modalProps.right || !!modalProps.sideContent;
    if (renderedInsideEntrypoint) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: (0, $1MNmN.cx)($5802df54c5a1439b$var$styles.baseContainer, hasSideContent && $5802df54c5a1439b$var$styles.hasSideContentContainer),
        backgroundColor: backgroundColor,
        style: {
            height: modalProps.height
        },
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($5802df54c5a1439b$var$ModalContent, {
            ...modalProps
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7tY81.default), {
        width: hasSideContent ? 'x-large' : undefined,
        ...modalProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
            xcss: (0, $1MNmN.cx)($5802df54c5a1439b$var$styles.baseContainer, hasSideContent && $5802df54c5a1439b$var$styles.hasSideContentContainer),
            backgroundColor: backgroundColor,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($5802df54c5a1439b$var$ModalContent, {
                ...modalProps
            })
        })
    });
};
$5802df54c5a1439b$export$2b77a92f1a5ad772.displayName = "Modal";
const $5802df54c5a1439b$var$ModalContent = ({ logo: logo, title: title, subtitle: subtitle, subtitleColor: subtitleColor = 'color.text.subtle', children: children, actions: actions, primaryAction: primaryAction, secondaryAction: secondaryAction, right: right, sideContent: sideContent, sideLocation: sideLocation = 'right', includeCloseButton: includeCloseButton = false, onClose: onClose })=>{
    const rightContent = right ?? (sideLocation === 'right' ? sideContent : undefined);
    const leftContent = !right && sideLocation === 'left' ? sideContent : undefined;
    const safeOnClose = typeof onClose === 'function' ? onClose : ()=>{};
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            includeCloseButton && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $5802df54c5a1439b$var$styles.closeButton,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $keJFr.CloseButton), {
                    testId: "modal-close-button",
                    onClick: safeOnClose
                })
            }),
            !!leftContent && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: (0, $1MNmN.cx)($5802df54c5a1439b$var$styles.sideContainer, $5802df54c5a1439b$var$styles.leftSideContainer),
                children: leftContent
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
                space: "space.400",
                xcss: $5802df54c5a1439b$var$styles.stack,
                children: [
                    logo,
                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l9ya1.ModalTitle), {
                                children: title
                            }),
                            subtitle ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                                color: subtitleColor,
                                size: "medium",
                                children: subtitle
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $93lG0.ModalBody), {
                        children: children
                    }),
                    actions ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2r1x4.ModalFooter), {
                        children: actions
                    }) : /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2r1x4.ModalFooter), {
                        children: [
                            secondaryAction,
                            primaryAction
                        ]
                    })
                ]
            }),
            !!rightContent && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: (0, $1MNmN.cx)($5802df54c5a1439b$var$styles.sideContainer, $5802df54c5a1439b$var$styles.rightSideContainer),
                children: rightContent
            })
        ]
    });
};
$5802df54c5a1439b$var$ModalContent.displayName = "ModalContent";

});
parcelRegister("93lG0", function(module, exports) {
$parcel$export(module.exports, "ModalBody", () => $fd722f785673d257$export$cb540d8b0ef7906c);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jr1Vl = parcelRequire("jr1Vl");

var $bN4k1 = parcelRequire("bN4k1");

var $3PC9r = parcelRequire("3PC9r");
const $fd722f785673d257$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dl1wug _18m91wug"
};
const $fd722f785673d257$export$cb540d8b0ef7906c = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $bN4k1.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jr1Vl.TouchScrollable), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($fd722f785673d257$var$ScrollableBody, {
            testId: testId,
            children: children
        })
    });
};
$fd722f785673d257$export$cb540d8b0ef7906c.displayName = "ModalBody";
const $fd722f785673d257$var$ScrollableBody = /*#__PURE__*/ (0, $euxye.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
        space: "space.300",
        xcss: $fd722f785673d257$var$styles.container,
        testId: testId,
        ref: ref,
        children: children
    });
});

});

parcelRegister("2r1x4", function(module, exports) {
$parcel$export(module.exports, "ModalFooter", () => $208165e0f62d04c8$export$519437715052e656);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $bN4k1 = parcelRequire("bN4k1");

var $defJG = parcelRequire("defJG");
const $208165e0f62d04c8$var$styles = {
    wrap: "_1n261tfl"
};
const $208165e0f62d04c8$export$519437715052e656 = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $bN4k1.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
        alignInline: "end",
        testId: testId,
        space: "space.150",
        xcss: $208165e0f62d04c8$var$styles.wrap,
        children: children
    });
};
$208165e0f62d04c8$export$519437715052e656.displayName = "ModalFooter";

});

parcelRegister("l9ya1", function(module, exports) {
$parcel$export(module.exports, "ModalTitle", () => $b95c582f9ba1da1b$export$b26fae16ba5468aa);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $bN4k1 = parcelRequire("bN4k1");
const $b95c582f9ba1da1b$export$b26fae16ba5468aa = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $bN4k1.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
        testId: testId,
        size: "large",
        id: titleId,
        children: children
    });
};
$b95c582f9ba1da1b$export$b26fae16ba5468aa.displayName = "ModalTitle";

});


parcelRegister("DIqjH", function(module, exports) {
$parcel$export(module.exports, "JiraModal", () => $ec9c8252741dc248$export$3782fcca1f68992e);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7tY81 = parcelRequire("7tY81");

var $gu6Rp = parcelRequire("gu6Rp");

var $7Odw0 = parcelRequire("7Odw0");

var $33qBb = parcelRequire("33qBb");
const $ec9c8252741dc248$export$3782fcca1f68992e = (props)=>{
    if ((0, $gu6Rp.shouldBeChoreographed)(props)) {
        if ((0, $7Odw0.isSupportedUserAgent)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $33qBb.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7tY81.default), rest);
};
$ec9c8252741dc248$export$3782fcca1f68992e.displayName = "JiraModal";
$ec9c8252741dc248$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("gu6Rp", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $af37ef6e011470be$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $af37ef6e011470be$export$e2cf19200849be9e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hIipg = parcelRequire("hIipg");

var $aAuB6 = parcelRequire("aAuB6");
function $af37ef6e011470be$export$a8ba9111c7eec9ac(props) {
    return (0, $aAuB6.shouldBeChoreographed)(props);
}
function $af37ef6e011470be$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $hIipg.envType).DEV;
        case 'staging':
            return (0, $hIipg.envType).STAGING;
        case 'prod':
            return (0, $hIipg.envType).PROD;
        default:
            return (0, $hIipg.envType).LOCAL;
    }
}

});
parcelRegister("aAuB6", function(module, exports) {
$parcel$export(module.exports, "getPendoPlugin", () => $d8d1a80215906590$export$3d3a86b2d636214b);
$parcel$export(module.exports, "useChoreographer", () => $d8d1a80215906590$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "shouldBeChoreographed", () => $d8d1a80215906590$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "withChoreographedToggle", () => $d8d1a80215906590$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $d8d1a80215906590$export$2cfd68294be82811);
$parcel$export(module.exports, "useDisableInAppMessagesForIframe", () => $d8d1a80215906590$export$a60a99a250d6a89c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $5EbfN = parcelRequire("5EbfN");

var $8ndFS = parcelRequire("8ndFS");

var $kNBjd = parcelRequire("kNBjd");

var $4KFYC = parcelRequire("4KFYC");

var $ilQ8n = parcelRequire("ilQ8n");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $1or3J = parcelRequire("1or3J");
// oxlint-disable-next-line typescript/consistent-type-assertions
const $d8d1a80215906590$var$environment = (0, $5EbfN.toEnvironment)((0, $6bEm8.default)('ajs-environment')) ?? 'prod';
const $d8d1a80215906590$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $kNBjd.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $kNBjd.MessageDeliveryStatus).STOPPED),
                // oxlint-disable-next-line typescript/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component,
        shouldBeChoreographed: (_props)=>false
    };
    return (0, $8ndFS.choreographerFactory)((0, $kNBjd.ProductIds).JIRA, $d8d1a80215906590$var$environment);
};
let $d8d1a80215906590$var$pendoPlugin;
function $d8d1a80215906590$export$3d3a86b2d636214b(env) {
    if (!$d8d1a80215906590$var$pendoPlugin) $d8d1a80215906590$var$pendoPlugin = new (0, $4KFYC.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $kNBjd.ProductIds).JIRA
    });
    return $d8d1a80215906590$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const $d8d1a80215906590$var$dest = $d8d1a80215906590$var$createChoreographerFactory();
const $d8d1a80215906590$export$9f0e2488ffd90f11 = $d8d1a80215906590$var$dest.useChoreographer;
const $d8d1a80215906590$var$withChoreographedToggleFromFactory = $d8d1a80215906590$var$dest.withChoreographedToggle;
const $d8d1a80215906590$export$a8ba9111c7eec9ac = $d8d1a80215906590$var$dest.shouldBeChoreographed;
const $d8d1a80215906590$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $1or3J.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $euxye.useMemo)(()=>$d8d1a80215906590$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $i860n.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1or3J.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // oxlint-disable-next-line typescript/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1or3J.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $d8d1a80215906590$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $1or3J.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $euxye.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $d8d1a80215906590$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $euxye.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};
const $d8d1a80215906590$export$a60a99a250d6a89c = ()=>{
    const cleanup = (0, $euxye.useRef)();
    const disabled = (0, $euxye.useRef)(false);
    if (!disabled.current) {
        cleanup.current = (0, $ilQ8n.Choreographer).getInstance().disableChoreographerForIframe();
        disabled.current = true;
    }
    (0, $euxye.useEffect)(()=>()=>cleanup.current?.(), []);
};

});
parcelRegister("1or3J", function(module, exports) {
$parcel$export(module.exports, "ChoreographerContextProvider", () => $5fa71657b34b0a57$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $5fa71657b34b0a57$export$2eb1efa814fe4a);

var $euxye = parcelRequire("euxye");
const $5fa71657b34b0a57$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $5fa71657b34b0a57$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $5fa71657b34b0a57$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5fa71657b34b0a57$export$3ff96dbefca6b00d.Provider, {
        value: $5fa71657b34b0a57$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$5fa71657b34b0a57$export$c3226151caaf2fbf.displayName = "ChoreographerContextProvider";
const $5fa71657b34b0a57$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $euxye.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $5fa71657b34b0a57$export$2eb1efa814fe4a = ()=>(0, $euxye.useContext)($5fa71657b34b0a57$export$3ff96dbefca6b00d);

});



parcelRegister("33qBb", function(module, exports) {
$parcel$export(module.exports, "ChoreographerModal", () => $08690ae685adb2be$export$3f5d627caa6fc630);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $7tY81 = parcelRequire("7tY81");

var $l6b8t = parcelRequire("l6b8t");
const $08690ae685adb2be$export$3f5d627caa6fc630 = (0, $l6b8t.withChoreographedRender)((0, $7tY81.default));

});
parcelRegister("l6b8t", function(module, exports) {
$parcel$export(module.exports, "withChoreographedRender", () => $ed662011ea2e0ae7$export$c1160fdac17030e);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1or3J = parcelRequire("1or3J");

var $aAuB6 = parcelRequire("aAuB6");
function $ed662011ea2e0ae7$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $aAuB6.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1or3J.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $1or3J.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});



parcelRegister("8eE53", function(module, exports) {
module.exports = new URL("assets-deeplinking-modal-illustration.f906f146.svg", import.meta.url).toString();

});

parcelRegister("4hP6R", function(module, exports) {
$parcel$export(module.exports, "readAssetsDeeplinkingModalShouldShow", () => $6ebf6db75858ff18$export$f970e19f61a1c485);
$parcel$export(module.exports, "persistAssetsDeeplinkingModalClosed", () => $6ebf6db75858ff18$export$ac021f1e5b8db5ff);

var $iXN50 = parcelRequire("iXN50");

var $i860n = parcelRequire("i860n");
const $6ebf6db75858ff18$var$storage = (0, $iXN50.createLocalStorageProvider)('jsm-insight-reports-assets-deeplinking-modal');
/** Persisted flag: `false` after the user dismisses the onboarding modal; absent means show once. */ const $6ebf6db75858ff18$var$MODAL_OPEN_STORAGE_KEY = 'modalOpen';
const $6ebf6db75858ff18$export$f970e19f61a1c485 = ()=>{
    const stored = $6ebf6db75858ff18$var$storage.get($6ebf6db75858ff18$var$MODAL_OPEN_STORAGE_KEY);
    return stored !== false;
};
const $6ebf6db75858ff18$export$ac021f1e5b8db5ff = ()=>{
    if ('setStrictlyNecessaryItem' in $6ebf6db75858ff18$var$storage && (0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
        // @browser-storage setter
        $6ebf6db75858ff18$var$storage.setStrictlyNecessaryItem($6ebf6db75858ff18$var$MODAL_OPEN_STORAGE_KEY, false);
        return;
    }
    // @browser-storage setter
    $6ebf6db75858ff18$var$storage.set($6ebf6db75858ff18$var$MODAL_OPEN_STORAGE_KEY, false);
};

});


parcelRegister("jZe0u", function(module, exports) {
$parcel$export(module.exports, "default", () => $68d644122141cf3c$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $l8G1z = parcelRequire("l8G1z");

var $8a4zh = parcelRequire("8a4zh");

// Lazy-loaded so the modal UI, its messages, the illustration PNGs, and all its Atlaskit
// imports are placed in a separate chunk that is only fetched for users who haven't
// dismissed the modal. Users who already dismissed it pay zero cost beyond the tiny
// localStorage check below.
const $68d644122141cf3c$var$LazyFiltersOnboardingModalContent = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2HEBz")).then((module)=>module.default), {
    moduleId: "./src/packages/servicedesk/insight-reports-v2/src/FiltersOnboardingModalContent.tsx"
});
const $68d644122141cf3c$var$FiltersOnboardingModal = ()=>{
    const [isModalOpen, setIsModalOpen] = (0, $euxye.useState)(()=>(0, $8a4zh.readFiltersOnboardingModalShouldShow)());
    const handleClose = (0, $euxye.useCallback)(()=>{
        (0, $8a4zh.persistFiltersOnboardingModalClosed)();
        setIsModalOpen(false);
    }, []);
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($68d644122141cf3c$var$LazyFiltersOnboardingModalContent, {
        onClose: handleClose
    });
};
$68d644122141cf3c$var$FiltersOnboardingModal.displayName = "FiltersOnboardingModal";
var $68d644122141cf3c$export$2e2bcd8739ae039 = $68d644122141cf3c$var$FiltersOnboardingModal;

});
parcelRegister("8a4zh", function(module, exports) {
$parcel$export(module.exports, "readFiltersOnboardingModalShouldShow", () => $d8377cd92d138f73$export$c6d60a36d37b4e85);
$parcel$export(module.exports, "persistFiltersOnboardingModalClosed", () => $d8377cd92d138f73$export$c52d52ed625fcdad);

var $iXN50 = parcelRequire("iXN50");

var $i860n = parcelRequire("i860n");
const $d8377cd92d138f73$var$storage = (0, $iXN50.createLocalStorageProvider)('jsm-insight-reports-filters-onboarding-modal');
/** Persisted flag: `false` after the user dismisses the onboarding modal; absent means show once. */ const $d8377cd92d138f73$var$MODAL_OPEN_STORAGE_KEY = 'modalOpen';
const $d8377cd92d138f73$export$c6d60a36d37b4e85 = ()=>{
    const stored = $d8377cd92d138f73$var$storage.get($d8377cd92d138f73$var$MODAL_OPEN_STORAGE_KEY);
    return stored !== false;
};
const $d8377cd92d138f73$export$c52d52ed625fcdad = ()=>{
    if ('setStrictlyNecessaryItem' in $d8377cd92d138f73$var$storage && (0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
        // @browser-storage setter
        $d8377cd92d138f73$var$storage.setStrictlyNecessaryItem($d8377cd92d138f73$var$MODAL_OPEN_STORAGE_KEY, false);
        return;
    }
    // @browser-storage setter
    $d8377cd92d138f73$var$storage.set($d8377cd92d138f73$var$MODAL_OPEN_STORAGE_KEY, false);
};

});

parcelRegister("2HEBz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ffep6").then(()=>parcelRequire('kjHmZ'));

});


parcelRegister("1CryE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("hsoZ3")
]).then(()=>parcelRequire('7WJ2P'));

});


parcelRegister("cnRNa", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsDashboardsDetailRoute", () => $5d64b7d6c57d1af3$export$d8486f1b228287be);
const $5d64b7d6c57d1af3$export$d8486f1b228287be = {
    name: 'servicedesk-cmdb-assets-dashboards-detail',
    path: '/jira/servicedesk/assets/dashboards/:templateId',
    exact: true
};

});


parcelRegister("40LXp", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsDashboardsRouteEntry", () => $768498ba9794999b$export$d897a26c40956416);

var $euxye = parcelRequire("euxye");


var $eviQr = parcelRequire("eviQr");

var $8ycTI = parcelRequire("8ycTI");

var $dUAVJ = parcelRequire("dUAVJ");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");

var $8PHdJ = parcelRequire("8PHdJ");

var $oWdC4 = parcelRequire("oWdC4");

var $jrbvW = parcelRequire("jrbvW");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $6wdNC = parcelRequire("6wdNC");

var $h2tgz = parcelRequire("h2tgz");

var $gNbXR = parcelRequire("gNbXR");

var $i860n = parcelRequire("i860n");
const $768498ba9794999b$var$DashboardsListPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eviQr.AssetsAppBase), {
        appName: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS
    }, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jrbvW.DashboardList), {
            workspaceId: workspaceId
        }));
$768498ba9794999b$var$DashboardsListPage.displayName = "DashboardsListPage";
const $768498ba9794999b$export$d897a26c40956416 = (0, $fdS54.createEntry)((0, $6wdNC.servicedeskCmdbAssetsDashboardsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $oWdC4.isNewReportsNavExperienceEnabled)() ? $768498ba9794999b$var$DashboardsListPage : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
                to: "/jira/servicedesk/assets/reports"
            }),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics'), (0, $8PHdJ.assetsDashboardsSemanticModelResource))
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jrbvW", function(module, exports) {
$parcel$export(module.exports, "DashboardList", () => $ee7c9e338d9f6e10$export$e8c763ce66dab6c9);

var $euxye = parcelRequire("euxye");

var $2U5t1 = parcelRequire("2U5t1");

var $hCTLL = parcelRequire("hCTLL");

var $ctMIM = parcelRequire("ctMIM");

var $hUqPj = parcelRequire("hUqPj");

var $l8G1z = parcelRequire("l8G1z");

var $i860n = parcelRequire("i860n");

var $8PHdJ = parcelRequire("8PHdJ");

var $1YIbA = parcelRequire("1YIbA");

var $k5P9q = parcelRequire("k5P9q");

var $kt86l = parcelRequire("kt86l");

var $oWdC4 = parcelRequire("oWdC4");

const $ee7c9e338d9f6e10$var$LazyITSMAnalyticsDashboardDirectory = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1CryE")).then(({ ITSMAnalyticsDashboardDirectory: ITSMAnalyticsDashboardDirectory })=>ITSMAnalyticsDashboardDirectory), {
    moduleId: "./node_modules/@atlassian/viz-platform-views-next/esm/index.js"
});
const $ee7c9e338d9f6e10$export$e8c763ce66dab6c9 = ({ workspaceId: workspaceId })=>{
    const { locale: locale } = (0, $1YIbA.default)();
    const cloudId = (0, $kt86l.useCloudId)();
    const atlassianUser = (0, $2U5t1.useAvpAtlassianUser)();
    const workspace = (0, $hCTLL.useAvpWorkspace)(workspaceId);
    const environment = (0, $k5P9q.useEnvironment)();
    const { isOrgAdmin: isOrgAdmin } = (0, $ctMIM.useIsOrgAdmin)();
    const dashboardEditableBaseUrl = (0, $oWdC4.isNewReportsNavExperienceEnabled)() ? '/jira/assets/dashboards' : '/jira/assets/reports';
    const templatePlaceholderReplacementsApiPath = `/gateway/api/jsm/reporting/assets/workspace/${workspaceId}/template-details`;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ee7c9e338d9f6e10$var$LazyITSMAnalyticsDashboardDirectory, {
        activationId: workspaceId,
        hostingProduct: "jsm-cmdb",
        cloudId: cloudId,
        location: "assets",
        dashboardEditableBaseUrl: dashboardEditableBaseUrl,
        services: {
            useSemanticModel: (0, $i860n.fg)('platform_avp_enable_jsm_assets_metrics') ? (0, $8PHdJ.useAssetsDashboardsSemanticModel) : undefined
        },
        templatePlaceholderReplacementsApiPath: templatePlaceholderReplacementsApiPath,
        locale: locale,
        atlassianUser: atlassianUser,
        workspace: workspace,
        isUserOrgAdmin: isOrgAdmin,
        environment: environment,
        perimeter: "commercial"
    });
    if ((0, $i860n.fg)('jsm_assets_analytics_context_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hUqPj.default), {
        data: {
            source: 'assets-reporting'
        }
    }, content);
    return content;
};
$ee7c9e338d9f6e10$export$e8c763ce66dab6c9.displayName = "DashboardList";

});

parcelRegister("6wdNC", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsDashboardsRoute", () => $40b64339ba01cb5b$export$95b52976fd861816);
const $40b64339ba01cb5b$export$95b52976fd861816 = {
    name: 'servicedesk-cmdb-assets-dashboards',
    path: '/jira/servicedesk/assets/dashboards',
    exact: true
};

});


parcelRegister("kPc3m", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRouteEntry", () => $a8a22c329513e581$export$6755c90e62150ca0);


var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lXESi = parcelRequire("lXESi");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $49tZR = parcelRequire("49tZR");

var $P2tcm = parcelRequire("P2tcm");
const $a8a22c329513e581$export$6755c90e62150ca0 = (0, $fdS54.createEntry)((0, $lXESi.servicedeskCmdbAssetsGlobalConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        ufoName: 'servicedesk-cmdb-assets-configure',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $49tZR.default),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $49tZR.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'astral'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lXESi", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRoute", () => $a160a8b88eeede6b$export$b28679181cd68abd);
const $a160a8b88eeede6b$export$b28679181cd68abd = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/assets/configure/global'
};

});

parcelRegister("49tZR", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbGlobalConfigure", () => $7db11bc91f9039f0$export$b80bd807bad3fd0a);
$parcel$export(module.exports, "default", () => $7db11bc91f9039f0$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7db11bc91f9039f0$export$b80bd807bad3fd0a = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("6Ew19")), {
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-configure-v2/src/index.tsx"
});
const $7db11bc91f9039f0$var$GlobalConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7db11bc91f9039f0$export$b80bd807bad3fd0a,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
$7db11bc91f9039f0$var$GlobalConfigure.displayName = "GlobalConfigure";
var $7db11bc91f9039f0$export$2e2bcd8739ae039 = $7db11bc91f9039f0$var$GlobalConfigure;

});


parcelRegister("gbXZ8", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRouteEntry", () => $5bbdb571fba6a562$export$ed571153b6c25586);


var $9Nwkz = parcelRequire("9Nwkz");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $6gUli = parcelRequire("6gUli");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $89qB4 = parcelRequire("89qB4");

var $P2tcm = parcelRequire("P2tcm");
const $5bbdb571fba6a562$export$ed571153b6c25586 = (0, $fdS54.createEntry)((0, $6gUli.servicedeskCmdbAssetsObjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $89qB4.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $1UBSs.getCmdbResources)(),
            (0, $9Nwkz.insightObjectResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $89qB4.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6gUli", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRoute", () => $b51fec6122a6a031$export$bf02944216c526ff);
const $b51fec6122a6a031$export$bf02944216c526ff = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/assets/object/:objectId'
};

});

parcelRegister("89qB4", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbObjectV2", () => $f623c8a975d2fa56$export$411c1981ced22249);
$parcel$export(module.exports, "InsightCmdbObjectViewV2", () => $f623c8a975d2fa56$export$3c208f927c6178ee);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f623c8a975d2fa56$export$411c1981ced22249 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9Zs43")), {
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-object-v2/src/ConditionalRedirectOrRouteView.tsx"
});
const $f623c8a975d2fa56$export$3c208f927c6178ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f623c8a975d2fa56$export$411c1981ced22249,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
        shouldShowSpinner: true
    });
$f623c8a975d2fa56$export$3c208f927c6178ee.displayName = "InsightCmdbObjectViewV2";
var $f623c8a975d2fa56$export$2e2bcd8739ae039 = $f623c8a975d2fa56$export$3c208f927c6178ee;

});


parcelRegister("5uZd0", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry", () => $7f8a913279edab86$export$ce7f2af5016c6aa9);


var $oaWSh = parcelRequire("oaWSh");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $2xxlZ = parcelRequire("2xxlZ");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $bdoJT = parcelRequire("bdoJT");

var $P2tcm = parcelRequire("P2tcm");
const $7f8a913279edab86$export$ce7f2af5016c6aa9 = (0, $fdS54.createEntry)((0, $2xxlZ.servicedeskCmdbAssetsObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $bdoJT.default),
        resources: [
            ...(0, $1UBSs.getCmdbResources)(),
            (0, $oaWSh.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bdoJT.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2xxlZ", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRoute", () => $eac952b542bce858$export$b4a150d67181752);
const $eac952b542bce858$export$b4a150d67181752 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("bdoJT", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaConfiguration", () => $52d19cc7e6a2f298$export$8305a1bc1c5bee45);
$parcel$export(module.exports, "default", () => $52d19cc7e6a2f298$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $52d19cc7e6a2f298$export$8305a1bc1c5bee45 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("8vihT")), {
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-object-schema-configuration/src/ConditionalRedirectOrRouteView.tsx"
});
const $52d19cc7e6a2f298$var$ObjectSchemaConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $52d19cc7e6a2f298$export$8305a1bc1c5bee45,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
        shouldShowSpinner: true
    });
$52d19cc7e6a2f298$var$ObjectSchemaConfiguration.displayName = "ObjectSchemaConfiguration";
var $52d19cc7e6a2f298$export$2e2bcd8739ae039 = $52d19cc7e6a2f298$var$ObjectSchemaConfiguration;

});


parcelRegister("f54pi", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRouteEntry", () => $b11638eab9315ae8$export$d9dc7083d0a34d11);


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $9o1cM = parcelRequire("9o1cM");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $cioaX = parcelRequire("cioaX");

var $P2tcm = parcelRequire("P2tcm");
const $b11638eab9315ae8$export$d9dc7083d0a34d11 = (0, $fdS54.createEntry)((0, $9o1cM.servicedeskCmdbAssetsObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $cioaX.ObjectSchemaV2),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cioaX.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9o1cM", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRoute", () => $8586e28e9741c995$export$6f86804eb594cd29);
const $8586e28e9741c995$export$6f86804eb594cd29 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
};

});


parcelRegister("33XKG", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry", () => $3dfad0ed203dddf9$export$d45b927987c92c0e);


var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $f3PLZ = parcelRequire("f3PLZ");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $85jGF = parcelRequire("85jGF");

var $P2tcm = parcelRequire("P2tcm");
const $3dfad0ed203dddf9$export$d45b927987c92c0e = (0, $fdS54.createEntry)((0, $f3PLZ.servicedeskCmdbAssetsObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $85jGF.default),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $85jGF.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'astral'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("f3PLZ", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRoute", () => $a0b82af635c9ff1b$export$73b901e16d5e5a02);
const $a0b82af635c9ff1b$export$73b901e16d5e5a02 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("85jGF", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbConfigureObjectType", () => $699102cf54fe4c00$export$926956539e1f72ba);
$parcel$export(module.exports, "default", () => $699102cf54fe4c00$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $699102cf54fe4c00$export$926956539e1f72ba = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("5kOmp")), {
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-configure-object-type/src/ConditionalRedirectOrRouteView.tsx"
});
const $699102cf54fe4c00$var$InsightConfigureObjectType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $699102cf54fe4c00$export$926956539e1f72ba,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
        shouldShowSpinner: true
    });
$699102cf54fe4c00$var$InsightConfigureObjectType.displayName = "InsightConfigureObjectType";
var $699102cf54fe4c00$export$2e2bcd8739ae039 = $699102cf54fe4c00$var$InsightConfigureObjectType;

});


parcelRegister("9hnc9", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRouteEntry", () => $b0c5d16ad6b997e3$export$2621677b40f03d6c);


var $8ycTI = parcelRequire("8ycTI");

var $dUAVJ = parcelRequire("dUAVJ");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $02YlE = parcelRequire("02YlE");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $33j7g = parcelRequire("33j7g");

var $P2tcm = parcelRequire("P2tcm");
const $b0c5d16ad6b997e3$export$2621677b40f03d6c = (0, $fdS54.createEntry)((0, $02YlE.servicedeskCmdbAssetsReportsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $33j7g.AssetsReportsNav4HomePage),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $33j7g.LazyServicedeskCmdbDefaultReportsRedirect),
            (0, $33j7g.LazyServicedeskCmdbAssetsReportsNav4HomePage)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("02YlE", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRoute", () => $665a18080731b315$export$a075d8b7c4c55c41);
const $665a18080731b315$export$a075d8b7c4c55c41 = {
    name: 'servicedesk-cmdb-assets-reports-default-redirect',
    path: '/jira/servicedesk/assets/reports',
    exact: true
};

});


parcelRegister("9fAvh", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRouteEntry", () => $b877578d838329e1$export$51d27be4bd1db6ce);


var $8ycTI = parcelRequire("8ycTI");

var $dUAVJ = parcelRequire("dUAVJ");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $4fFwE = parcelRequire("4fFwE");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $33j7g = parcelRequire("33j7g");

var $P2tcm = parcelRequire("P2tcm");
const $b877578d838329e1$export$51d27be4bd1db6ce = (0, $fdS54.createEntry)((0, $4fFwE.servicedeskCmdbAssetsReportsTemplateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $33j7g.AssetsReports),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $33j7g.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4fFwE", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRoute", () => $b9b28b894e8c57ca$export$9482cb7f11a7730);
const $b9b28b894e8c57ca$export$9482cb7f11a7730 = {
    name: 'servicedesk-cmdb-assets-reports',
    path: '/jira/servicedesk/assets/reports/:templateId',
    exact: true
};

});


parcelRegister("eGobt", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRouteEntry", () => $647281899b760a00$export$5842852f274cd739);


var $8ycTI = parcelRequire("8ycTI");

var $dUAVJ = parcelRequire("dUAVJ");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dkJQF = parcelRequire("dkJQF");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $33j7g = parcelRequire("33j7g");

var $P2tcm = parcelRequire("P2tcm");
const $647281899b760a00$export$5842852f274cd739 = (0, $fdS54.createEntry)((0, $dkJQF.servicedeskCmdbAssetsReportsUnsubscribeRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $33j7g.AssetsReportsUnsubscribe),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $33j7g.LazyServicedeskCmdbAssetsReportsUnsubscribe)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dkJQF", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRoute", () => $845ca67c913c91ab$export$66ab60d374e8e458);
const $845ca67c913c91ab$export$66ab60d374e8e458 = {
    name: 'servicedesk-cmdb-assets-reports-unsubscribe',
    path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("b5AFk", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRouteEntry", () => $7363838cc31ad924$export$70a75f8d403c935a);


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $50Rvm = parcelRequire("50Rvm");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $blZvh = parcelRequire("blZvh");

var $P2tcm = parcelRequire("P2tcm");
const $7363838cc31ad924$export$70a75f8d403c935a = (0, $fdS54.createEntry)((0, $50Rvm.servicedeskCmdbAssetsSchemasRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $blZvh.default),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $blZvh.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("50Rvm", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRoute", () => $4197b02bc36e19f7$export$118f7c2ddb756e80);
const $4197b02bc36e19f7$export$118f7c2ddb756e80 = {
    name: 'servicedesk-cmdb-assets',
    path: '/jira/servicedesk/assets',
    exact: true
};

});

parcelRegister("blZvh", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbLandingPage", () => $f08a3518d723353e$export$f6c79e6ff37913ee);
$parcel$export(module.exports, "default", () => $f08a3518d723353e$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f08a3518d723353e$export$f6c79e6ff37913ee = // oxlint-disable-next-line @typescript-eslint/no-explicit-any
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("jCEgN")), {
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-landing-page/src/index.tsx"
});
const $f08a3518d723353e$var$LandingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f08a3518d723353e$export$f6c79e6ff37913ee,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: true
    });
$f08a3518d723353e$var$LandingPage.displayName = "LandingPage";
var $f08a3518d723353e$export$2e2bcd8739ae039 = $f08a3518d723353e$var$LandingPage;

});


parcelRegister("kxhpa", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRouteEntry", () => $1eb12bffd6a6bc01$export$69b479583cd0d13f);


var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $Fy8Nz = parcelRequire("Fy8Nz");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $49tZR = parcelRequire("49tZR");

var $P2tcm = parcelRequire("P2tcm");
const $1eb12bffd6a6bc01$export$69b479583cd0d13f = (0, $fdS54.createEntry)((0, $Fy8Nz.servicedeskCmdbInsightConfigureGlobalRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        ufoName: 'servicedesk-cmdb-insight-configure-global',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $49tZR.default),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $49tZR.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'astral'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("Fy8Nz", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRoute", () => $425052fa1079dd5a$export$96e5da52356f214c);
const $425052fa1079dd5a$export$96e5da52356f214c = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure/global'
};

});


parcelRegister("dgOkS", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRouteEntry", () => $7abc3160020ac0e0$export$277a55a31c82cf0e);


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $ejdPu = parcelRequire("ejdPu");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $aebk5 = parcelRequire("aebk5");

var $P2tcm = parcelRequire("P2tcm");
const $7abc3160020ac0e0$export$277a55a31c82cf0e = (0, $fdS54.createEntry)((0, $ejdPu.servicedeskCmdbInsightConfigureRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        ufoName: 'servicedesk-cmdb-insight-configure',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $aebk5.default),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aebk5.LazyServicedeskCmdbConfigure)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ejdPu", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRoute", () => $b21597de42ef1b50$export$e960ab4fcd3e80b6);
const $b21597de42ef1b50$export$e960ab4fcd3e80b6 = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure'
};

});

parcelRegister("aebk5", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbConfigure", () => $56bd7e6079b0851c$export$8075d4042713bf6d);
$parcel$export(module.exports, "default", () => $56bd7e6079b0851c$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $56bd7e6079b0851c$export$8075d4042713bf6d = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("i2yER")), {
    moduleId: "./src/packages/spa-apps/servicedesk-cmdb-configure/src/ServicedeskCmdbConfigure.tsx"
});
const $56bd7e6079b0851c$var$InsightConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $56bd7e6079b0851c$export$8075d4042713bf6d,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
$56bd7e6079b0851c$var$InsightConfigure.displayName = "InsightConfigure";
var $56bd7e6079b0851c$export$2e2bcd8739ae039 = $56bd7e6079b0851c$var$InsightConfigure;

});
parcelRegister("i2yER", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("blnbO").then(()=>parcelRequire('au5oI'));

});



parcelRegister("bNEGg", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObject4RouteEntry", () => $ccf76f35063bf9da$export$95574c3333e559d3);


var $9Nwkz = parcelRequire("9Nwkz");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $ljfn7 = parcelRequire("ljfn7");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $89qB4 = parcelRequire("89qB4");

var $P2tcm = parcelRequire("P2tcm");
const $ccf76f35063bf9da$export$95574c3333e559d3 = (0, $fdS54.createEntry)((0, $ljfn7.servicedeskCmdbInsightObject4Route), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $89qB4.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $1UBSs.getCmdbResources)(),
            (0, $9Nwkz.insightObjectResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $89qB4.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ljfn7", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObject4Route", () => $0f63d838191e6891$export$223f5bacfd3d39fd);
const $0f63d838191e6891$export$223f5bacfd3d39fd = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/insight/assets/:objectId'
};

});


parcelRegister("fVNdp", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry", () => $5d418449252f664d$export$261e9b5115dfbb0a);


var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $1x8yE = parcelRequire("1x8yE");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $bdoJT = parcelRequire("bdoJT");

var $P2tcm = parcelRequire("P2tcm");
const $5d418449252f664d$export$261e9b5115dfbb0a = (0, $fdS54.createEntry)((0, $1x8yE.servicedeskCmdbInsightObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $bdoJT.default),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $bdoJT.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1x8yE", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRoute", () => $a7609814ad424ac8$export$f6b688a8729943b3);
const $a7609814ad424ac8$export$f6b688a8729943b3 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
};

});


parcelRegister("iCE0X", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRouteEntry", () => $48c52f4e661d4f17$export$192b200c13b0b76a);


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $11Dkg = parcelRequire("11Dkg");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $cioaX = parcelRequire("cioaX");

var $P2tcm = parcelRequire("P2tcm");
const $48c52f4e661d4f17$export$192b200c13b0b76a = (0, $fdS54.createEntry)((0, $11Dkg.servicedeskCmdbInsightObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $cioaX.ObjectSchemaV2),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cioaX.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("11Dkg", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRoute", () => $46a5da84b46a252a$export$fcde60ded71d4ae6);
const $46a5da84b46a252a$export$fcde60ded71d4ae6 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
};

});


parcelRegister("7DLur", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRouteEntry", () => $ce7bea2a5178e0c9$export$de4ab140a5dbd984);


var $6pofw = parcelRequire("6pofw");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $8UK6h = parcelRequire("8UK6h");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $85jGF = parcelRequire("85jGF");

var $P2tcm = parcelRequire("P2tcm");
const $ce7bea2a5178e0c9$export$de4ab140a5dbd984 = (0, $fdS54.createEntry)((0, $8UK6h.servicedeskCmdbInsightObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $85jGF.default),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $85jGF.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'astral'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8UK6h", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRoute", () => $d8bd349a64801d7f$export$12e89d5d79d59785);
const $d8bd349a64801d7f$export$12e89d5d79d59785 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
};

});


parcelRegister("fQEuo", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightRouteEntry", () => $5c06dd755223a14c$export$3befca4eb012b818);


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $3Choa = parcelRequire("3Choa");

var $i860n = parcelRequire("i860n");

var $h2tgz = parcelRequire("h2tgz");

var $1UBSs = parcelRequire("1UBSs");

var $blZvh = parcelRequire("blZvh");

var $P2tcm = parcelRequire("P2tcm");
const $5c06dd755223a14c$export$3befca4eb012b818 = (0, $fdS54.createEntry)((0, $3Choa.servicedeskCmdbInsightRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $40599577b3613cf9$export$6f4e17de67d45c3d)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('assets_as_an_app_v2') ? (0, $P2tcm.AssetsAppRedirect) : (0, $blZvh.default),
        resources: (0, $1UBSs.getCmdbResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $blZvh.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3Choa", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightRoute", () => $9f23aeb03f44b070$export$1efada07b7203f2d);
const $9f23aeb03f44b070$export$1efada07b7203f2d = {
    name: 'servicedesk-cmdb-insight',
    path: '/jira/servicedesk/insight',
    exact: true
};

});


parcelRegister("b19s3", function(module, exports) {
$parcel$export(module.exports, "servicedeskConnectProjectRouteEntry", () => $2bdbf6fe759939aa$export$72138a83eeba68eb);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $9qoKq = parcelRequire("9qoKq");

var $74h93 = parcelRequire("74h93");

var $b1D1c = parcelRequire("b1D1c");

var $iDs02 = parcelRequire("iDs02");
const $2bdbf6fe759939aa$export$72138a83eeba68eb = (0, $fdS54.createEntry)((0, $9qoKq.servicedeskConnectProjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $b1D1c.getProjectConnectRouteDefaultResources)(),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        ufoName: 'jira-connect',
        entryPoint: ()=>(0, $iDs02.connectProjectsWithoutHorizontalNavPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9qoKq", function(module, exports) {
$parcel$export(module.exports, "servicedeskConnectProjectRoute", () => $8ff5fb74ee06f4d1$export$148fcbe26061b2c9);
const $8ff5fb74ee06f4d1$export$148fcbe26061b2c9 = {
    name: 'servicedesk-connect-project',
    path: '/jira/servicedesk/projects/:projectKey',
    query: [
        'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
    ],
    exact: true
};

});


parcelRegister("9CrBu", function(module, exports) {
$parcel$export(module.exports, "servicedeskCreateProjectRouteEntry", () => $afb4df9ea0dfd58a$export$ac25abe07ac3f570);

var $euxye = parcelRequire("euxye");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $fFBeF = parcelRequire("fFBeF");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $afb4df9ea0dfd58a$var$LazyServiceDeskCreateProject = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("8LTpP")), {
    moduleId: "./src/packages/spa-apps/servicedesk-create-project/src/index.tsx"
});
const $afb4df9ea0dfd58a$var$ServiceDeskCreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $afb4df9ea0dfd58a$var$LazyServiceDeskCreateProject,
        pageId: "spa-apps/servicedesk/create-project",
        shouldShowSpinner: true
    });
$afb4df9ea0dfd58a$var$ServiceDeskCreateProject.displayName = "ServiceDeskCreateProject";
const $afb4df9ea0dfd58a$export$ac25abe07ac3f570 = (0, $fdS54.createEntry)((0, $fFBeF.servicedeskCreateProjectRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: $afb4df9ea0dfd58a$var$ServiceDeskCreateProject,
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $afb4df9ea0dfd58a$var$LazyServiceDeskCreateProject
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).CREATE_PROJECT,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CREATE_PROJECT),
                teamName: 'Sequoia'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fFBeF", function(module, exports) {
$parcel$export(module.exports, "servicedeskCreateProjectRoute", () => $bd84a9928270ec0b$export$1f409a894343952a);
const $bd84a9928270ec0b$export$1f409a894343952a = {
    name: 'servicedesk-create-project',
    path: '/jira/servicedesk/create-project',
    exact: true
};

});

parcelRegister("8LTpP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eM6v6").then(()=>parcelRequire('6RPsT'));

});


parcelRegister("3IwUO", function(module, exports) {
$parcel$export(module.exports, "servicedeskCustomerDetailsRouteEntry", () => $47d38c9ebcf9e683$export$97ee6e9bb7f7bd31);
/* eslint-disable import/order */ 

var $aqqTV = parcelRequire("aqqTV");

var $aMnvf = parcelRequire("aMnvf");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $kKfvg = parcelRequire("kKfvg");

var $6pofw = parcelRequire("6pofw");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $8MIL1 = parcelRequire("8MIL1");
const $47d38c9ebcf9e683$export$97ee6e9bb7f7bd31 = (0, $fdS54.createEntry)((0, $kKfvg.servicedeskCustomerDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8MIL1.ServicedeskCustomerDetails),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8MIL1.LazyServicedeskCustomerDetails)
        ],
        perfMetricKey: 'jsm-customer-details-component-load',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).CUSTOMER_DETAILS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CUSTOMER_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $aqqTV.EntitlementsQueryResource),
            (0, $aMnvf.CustomerDetailsPageQueryResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kKfvg", function(module, exports) {
$parcel$export(module.exports, "servicedeskCustomerDetailsRoute", () => $5717c9928ee50955$export$42c0f04d04ecd1f8);
const $5717c9928ee50955$export$42c0f04d04ecd1f8 = {
    name: 'servicedesk-customer-details',
    path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
    exact: true
};

});

parcelRegister("8MIL1", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCustomerDetails", () => $66be0c66937702e0$export$6c5749ec31de847d);
$parcel$export(module.exports, "ServicedeskCustomerDetails", () => $66be0c66937702e0$export$2412523c0e3657cc);
$parcel$export(module.exports, "ServiceDeskContacts", () => $66be0c66937702e0$export$db9de32a8b149a29);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $66be0c66937702e0$export$55118fe902ecc07a = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("fNgs7")), {
    moduleId: "./src/packages/spa-apps/servicedesk-contacts/src/ServicedeskContacts.tsx"
});

const $66be0c66937702e0$export$6c5749ec31de847d = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("26IPa"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-customer-details/src/ServicedeskCustomerDetails.tsx"
});
const $66be0c66937702e0$export$2412523c0e3657cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $66be0c66937702e0$export$6c5749ec31de847d,
        pageId: "spa-apps/servicedesk/customer-details",
        shouldShowSpinner: true
    });
$66be0c66937702e0$export$2412523c0e3657cc.displayName = "ServicedeskCustomerDetails";
const $66be0c66937702e0$export$db9de32a8b149a29 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $66be0c66937702e0$export$55118fe902ecc07a,
        pageId: "spa-apps/servicedesk/contacts",
        shouldShowSpinner: true
    });
$66be0c66937702e0$export$db9de32a8b149a29.displayName = "ServiceDeskContacts";

});
parcelRegister("fNgs7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("5ID2C")
]).then(()=>parcelRequire('42RSq'));

});

parcelRegister("26IPa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("dhajh")
]).then(()=>parcelRequire('2amsz'));

});



parcelRegister("5bNjI", function(module, exports) {
$parcel$export(module.exports, "servicedeskCustomersV2RouteEntry", () => $be1ec4ae5e510304$export$e1fa279356610d18);
/* eslint-disable import/order */ 
var $aS3GY = parcelRequire("aS3GY");


var $a6AZh = parcelRequire("a6AZh");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $fEpEj = parcelRequire("fEpEj");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $8MIL1 = parcelRequire("8MIL1");
const $be1ec4ae5e510304$export$e1fa279356610d18 = (0, $fdS54.createEntry)((0, $fEpEj.servicedeskCustomersV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8MIL1.ServiceDeskContacts),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jsm-customers-component-load',
        ufoName: 'jsm-customers-component-load',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $a6AZh.AsyncDirectoryNav)
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("a6AZh", function(module, exports) {
$parcel$export(module.exports, "AsyncDirectoryNav", () => $e0132bd3be6861c7$export$a237f415539577a5);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");


const $e0132bd3be6861c7$var$LazyDirectoryNav = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("95xK7")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-directory/src/ui/index.tsx"
});
const $e0132bd3be6861c7$export$a237f415539577a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-jsm-directory-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e0132bd3be6861c7$var$LazyDirectoryNav, null));
$e0132bd3be6861c7$export$a237f415539577a5.displayName = "AsyncDirectoryNav";

});
parcelRegister("95xK7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eCSoL").then(()=>parcelRequire('9pr7Q'));

});


parcelRegister("fEpEj", function(module, exports) {
$parcel$export(module.exports, "servicedeskCustomersV2Route", () => $7ff4edff91530048$export$89e9e350610ee31e);
const $7ff4edff91530048$export$89e9e350610ee31e = {
    name: 'servicedesk-customers-v2',
    path: '/jira/servicedesk/projects/:projectKey/customers',
    exact: true
};

});


parcelRegister("62WWj", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedHubsRouteEntry", () => $84229f8a287ec7f5$export$598aed449e90d3b3);
/* eslint-disable import/order */ 

var $7GC2J = parcelRequire("7GC2J");

var $lFLfF = parcelRequire("lFLfF");

var $dTa0V = parcelRequire("dTa0V");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $3C7Cb = parcelRequire("3C7Cb");

var $74h93 = parcelRequire("74h93");

var $jTpT3 = parcelRequire("jTpT3");

var $i860n = parcelRequire("i860n");
const $84229f8a287ec7f5$var$hubsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7GC2J.gettingStartedHubsEntryPoint)
});
const $84229f8a287ec7f5$export$598aed449e90d3b3 = (0, $fdS54.createEntry)((0, $3C7Cb.servicedeskGettingStartedHubsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-hubs-load',
        skeleton: (0, $jTpT3.HubsSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('solution_composer_master') ? $84229f8a287ec7f5$var$hubsPageEntryPoint : undefined,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("7GC2J", function(module, exports) {
$parcel$export(module.exports, "gettingStartedHubsEntryPoint", () => $edc6d28be0cdf55e$export$3da2e7e257e59a59);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $ivTJy = parcelRequire("ivTJy");

var $8F2Tx = parcelRequire("8F2Tx");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");
function $edc6d28be0cdf55e$var$getPortalPageAriId(portalId) {
    return `portal_page-${portalId}`;
}
/**
 * Extracts the helpCenterId string from a raw ARI or plain ID from the URL.
 * Returns an empty string if the ARI is malformed and no plain hubId is available.
 */ function $edc6d28be0cdf55e$var$extractHelpCenterIdFromAri(hubAri) {
    try {
        return (0, $ivTJy.HelpHelpCenterAri).parse(hubAri).helpCenterId;
    } catch  {
        return '';
    }
}
function $edc6d28be0cdf55e$var$hubHomeContentQueryAris(activationId, hubIdFromUrl, pageId, hubAriFromUrl) {
    const createPageAri = (resolvedActivationId, resolvedHubId)=>pageId ? `ari:cloud:help::page/${resolvedActivationId}/${$edc6d28be0cdf55e$var$getPortalPageAriId(pageId)}/${resolvedHubId}` : `ari:cloud:help::page/${resolvedActivationId}/${resolvedHubId}`;
    try {
        const hub = hubAriFromUrl ? (0, $ivTJy.HelpHelpCenterAri).parse(hubAriFromUrl) : (0, $ivTJy.HelpHelpCenterAri).parse(hubIdFromUrl);
        return {
            hubAri: hub.toString(),
            pageAri: createPageAri(hub.activationId, hub.helpCenterId)
        };
    } catch  {
        return {
            hubAri: hubAriFromUrl ?? `ari:cloud:help::help-center/${activationId}/${hubIdFromUrl}`,
            pageAri: createPageAri(activationId, hubIdFromUrl)
        };
    }
}

const $edc6d28be0cdf55e$var$hubsRoot = (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("927fr")), {
    moduleId: "9d3b6926",
    moduleName: "HubsDataPreloadProvider",
    priority: "userVisible",
    entryFsSsrLiftImportToModule: true
});
const $edc6d28be0cdf55e$export$3da2e7e257e59a59 = (0, $fiVog.createEntryPoint)({
    root: $edc6d28be0cdf55e$var$hubsRoot,
    getPreloadProps: (params)=>{
        const { context: { match: match, query: query }, tenantContext: { cloudId: cloudId, activationId: activationId } } = params;
        const projectKey = match?.params?.projectKey;
        if (!projectKey || !cloudId) return {
            extraProps: {
                cloudId: '',
                projectKey: ''
            }
        };
        const hubIdRaw = query?.hubId;
        const hubId = typeof hubIdRaw === 'string' ? hubIdRaw : null;
        const hubAriRaw = query?.hubAri;
        const hubAri = typeof hubAriRaw === 'string' ? hubAriRaw : undefined;
        const pageIdRaw = query?.pageId;
        const pageId = typeof pageIdRaw === 'string' ? pageIdRaw : undefined;
        if (!hubId && !hubAri) return {
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        const resolvedHelpCenterId = hubId ?? (hubAri ? $edc6d28be0cdf55e$var$extractHelpCenterIdFromAri(hubAri) : '');
        const { hubAri: resolvedHubAri, pageAri: pageAri } = $edc6d28be0cdf55e$var$hubHomeContentQueryAris(activationId, resolvedHelpCenterId, pageId, hubAri);
        return {
            queries: {
                hubHomeContentQuery: {
                    parameters: (0, $8F2Tx.default),
                    variables: {
                        cloudId: cloudId,
                        hubAri: resolvedHubAri,
                        hubEditMode: false,
                        operationType: 'READ',
                        pageAri: pageAri
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey,
                helpCenterId: resolvedHelpCenterId,
                hubAri: resolvedHubAri,
                pageId: pageId
            }
        };
    }
});

});
parcelRegister("8F2Tx", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff8150f7afea32dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9524e67479121c148f961069b31686ca>>
 * @relayHash e9e91bdc41c6aa27ad4d602068d16895
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e336d258a380543df462bd3a25cb41dfa6293e9221f871efa9346b76c8fabd9
const $ff8150f7afea32dd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0e336d258a380543df462bd3a25cb41dfa6293e9221f871efa9346b76c8fabd9",
        "metadata": {},
        "name": "hubHomeContentWrapperQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ff8150f7afea32dd$export$2e2bcd8739ae039 = $ff8150f7afea32dd$var$node;

});

parcelRegister("927fr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bwpVK")
]).then(()=>parcelRequire('jVkbL'));

});


parcelRegister("3C7Cb", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedHubsRoute", () => $b4a924ebfaa16ab1$export$4fc38272a85b6f31);
const $b4a924ebfaa16ab1$export$4fc38272a85b6f31 = {
    name: 'servicedesk-getting-started-hubs',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/helpcenter/hubs',
    exact: true
};

});

parcelRegister("jTpT3", function(module, exports) {
$parcel$export(module.exports, "HubsSkeleton", () => $9660d0353e9fd946$export$2184c1658e628b04);
/* HubsSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $3NRLa = parcelRequire("3NRLa");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $defJG = parcelRequire("defJG");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $8ityu = parcelRequire("8ityu");
const $9660d0353e9fd946$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.hubs-skeleton.loading",
    defaultMessage: "Loading hubs"
});
const $9660d0353e9fd946$var$styles = {
    container: "_1e0c1txw _2lx21bp4 _4t3i1osq _1bsb1osq _1ul91fdn _vchhusvi _bfhkvuon",
    content: "_16jlkb7n _1o9zkb7n _i0dl1wug _18zrxy5q _1tkeidpf",
    previewBanner: "_1rjcu2gc _18zrpxbi _bfhkysee",
    topicSection: "_1q51xy5q",
    cardGrid: "_zulppxbi _1e0c11p5 _yv0efsjm",
    card: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _bfhkhp5a _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb"
};
const $9660d0353e9fd946$var$ArticleCard = ({ titleWidth: titleWidth })=>/*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        xcss: $9660d0353e9fd946$var$styles.card,
        space: "space.150"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: titleWidth,
        height: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: "80%",
        height: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }));
$9660d0353e9fd946$var$ArticleCard.displayName = "ArticleCard";
const $9660d0353e9fd946$export$2184c1658e628b04 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $9660d0353e9fd946$var$styles.container,
        role: "status",
        "aria-busy": "true",
        "aria-label": formatMessage($9660d0353e9fd946$var$loadingMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $8ityu.EmbedHeaderSkeleton), null), /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $9660d0353e9fd946$var$styles.previewBanner,
        "aria-hidden": "true"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 240,
        height: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    })), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $9660d0353e9fd946$var$styles.content
    }, /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200",
        xcss: $9660d0353e9fd946$var$styles.topicSection,
        "aria-hidden": "true"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 160,
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $9660d0353e9fd946$var$styles.cardGrid
        ])
    }, /*#__PURE__*/ $euxye.createElement($9660d0353e9fd946$var$ArticleCard, {
        titleWidth: 180
    }), /*#__PURE__*/ $euxye.createElement($9660d0353e9fd946$var$ArticleCard, {
        titleWidth: 140
    }), /*#__PURE__*/ $euxye.createElement($9660d0353e9fd946$var$ArticleCard, {
        titleWidth: 200
    }), /*#__PURE__*/ $euxye.createElement($9660d0353e9fd946$var$ArticleCard, {
        titleWidth: 160
    }))), /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200",
        xcss: $9660d0353e9fd946$var$styles.topicSection,
        "aria-hidden": "true"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 120,
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $9660d0353e9fd946$var$styles.cardGrid
        ])
    }, /*#__PURE__*/ $euxye.createElement($9660d0353e9fd946$var$ArticleCard, {
        titleWidth: 200
    }), /*#__PURE__*/ $euxye.createElement($9660d0353e9fd946$var$ArticleCard, {
        titleWidth: 150
    })))));
};
$9660d0353e9fd946$export$2184c1658e628b04.displayName = "HubsSkeleton";

});
parcelRegister("8ityu", function(module, exports) {
$parcel$export(module.exports, "EmbedHeaderSkeleton", () => $edb9b017a15e04b7$export$b4bb4e328c7c47bb);
/* EmbedHeaderSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $3NRLa = parcelRequire("3NRLa");
/**
 * Skeleton that mirrors the EmbedHeader layout:
 * [back link skeleton] --- [title skeleton] --- [empty right]
 * with the same padding/border as the real EmbedHeader.
 *
 * This component does not set its own aria attributes — the parent
 * skeleton (RequestTypesSkeleton, HubsSkeleton, etc.) is responsible
 * for aria-busy / aria-label on the outer container.
 */ const $edb9b017a15e04b7$var$styles = {
    wrapper: "_18zrxy5q _1q51v47k _85i5pxbi _1r62e4h9 _12ornqa1 _1ezz1l7x",
    header: "_1e0c1txw _4cvr1h6o _1bah1yb4 _1o9zidpf",
    left: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1y6m _1ul9idpf",
    center: "_16jlidpf _1o9zidpf _i0dl1wug",
    right: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $edb9b017a15e04b7$export$b4bb4e328c7c47bb = ()=>{
    return /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $edb9b017a15e04b7$var$styles.wrapper
        ])
    }, /*#__PURE__*/ $euxye.createElement("header", {
        "aria-hidden": "true",
        className: (0, $4jQY2.default)([
            $edb9b017a15e04b7$var$styles.header
        ])
    }, /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $edb9b017a15e04b7$var$styles.left
        ])
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 160,
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    })), /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $edb9b017a15e04b7$var$styles.center
        ])
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 120,
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    })), /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $edb9b017a15e04b7$var$styles.right
        ])
    })));
};
$edb9b017a15e04b7$export$b4bb4e328c7c47bb.displayName = "EmbedHeaderSkeleton";

});



parcelRegister("hu05Z", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedQueueCreateRouteEntry", () => $26c2df1659441b3a$export$11c2ca39bb902af3);


var $hj9F6 = parcelRequire("hj9F6");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $cDLVA = parcelRequire("cDLVA");

var $t7VsO = parcelRequire("t7VsO");

var $dY6WN = parcelRequire("dY6WN");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $26apr = parcelRequire("26apr");

var $74h93 = parcelRequire("74h93");
const $26c2df1659441b3a$var$queueCreatePageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hj9F6.gettingStartedQueueCreateEntryPoint)
});
const $26c2df1659441b3a$export$11c2ca39bb902af3 = (0, $fdS54.createEntry)((0, $26apr.servicedeskGettingStartedQueueCreateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-queue-create-load',
        skeleton: (0, $dY6WN.QueueSettingsSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $cDLVA.getCalendarFilterFieldsResource)()
        ],
        entryPoint () {
            return (0, $i860n.fg)('solution_composer_master') ? $26c2df1659441b3a$var$queueCreatePageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hj9F6", function(module, exports) {
$parcel$export(module.exports, "gettingStartedQueueCreateEntryPoint", () => $ca64dc45a480e380$export$ff170a9ed15f6953);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ca64dc45a480e380$export$ff170a9ed15f6953 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("kboyd")), {
        moduleId: "1789c178",
        moduleName: "QueueCreateEmbeddedView",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: match } })=>{
        const projectKey = match.params.projectKey;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {},
            extraProps: {
                projectKey: projectKey
            }
        };
    }
});

});
parcelRegister("kboyd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f0AVh").then(()=>parcelRequire('dMbtH'));

});


parcelRegister("dY6WN", function(module, exports) {
$parcel$export(module.exports, "QueueSettingsContentSkeleton", () => $102c7204b6688a29$export$7f694f6b0610e06b);
$parcel$export(module.exports, "QueueSettingsSkeleton", () => $102c7204b6688a29$export$3c52b3f7e632ab04);
/* QueueSettingsSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $defJG = parcelRequire("defJG");

var $2XXtG = parcelRequire("2XXtG");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $8ityu = parcelRequire("8ityu");
const $102c7204b6688a29$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.queue-settings-skeleton.loading",
    defaultMessage: "Loading queue settings"
});
const $102c7204b6688a29$var$styles = {
    wrapper: "_1reo15vq _18m915vq _zulpv47k _4t3i1kxc _2lx21bp4",
    contentWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    container: "_18zrxy5q _1q511ejb",
    tableHeaderRow: "_1rjcu2gc _1r62e4h9 _12ornqa1 _1ezz1l7x _6rthu2gc",
    tableRow: "_1rjcutpp _1r62e4h9 _12ornqa1 _1ezz1l7x",
    actionBar: "_85i51ejb"
};
const $102c7204b6688a29$var$QueueRow = ({ nameWidth: nameWidth })=>/*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $102c7204b6688a29$var$styles.tableRow,
        "aria-hidden": "true"
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: nameWidth,
        height: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 72,
        height: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 28,
        height: 28,
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }))));
$102c7204b6688a29$var$QueueRow.displayName = "QueueRow";
const $102c7204b6688a29$export$7f694f6b0610e06b = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const queueNameWidths = [
        200,
        160,
        220,
        180,
        240
    ];
    return /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $102c7204b6688a29$var$styles.container,
        role: "status",
        "aria-busy": "true",
        "aria-label": formatMessage($102c7204b6688a29$var$loadingMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.0"
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $102c7204b6688a29$var$styles.actionBar
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 280,
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 120,
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    })), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $102c7204b6688a29$var$styles.tableHeaderRow
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 60,
        height: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.100"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 90,
        height: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    })))), queueNameWidths.map((w, i)=>/*#__PURE__*/ $euxye.createElement($102c7204b6688a29$var$QueueRow, {
            key: i,
            nameWidth: w
        }))));
};
$102c7204b6688a29$export$7f694f6b0610e06b.displayName = "QueueSettingsContentSkeleton";
const $102c7204b6688a29$export$3c52b3f7e632ab04 = ()=>/*#__PURE__*/ $euxye.createElement((0, $2XXtG.default), {
        xcss: $102c7204b6688a29$var$styles.wrapper
    }, /*#__PURE__*/ $euxye.createElement((0, $8ityu.EmbedHeaderSkeleton), null), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $102c7204b6688a29$var$styles.contentWrapper
    }, /*#__PURE__*/ $euxye.createElement($102c7204b6688a29$export$7f694f6b0610e06b, null)));
$102c7204b6688a29$export$3c52b3f7e632ab04.displayName = "QueueSettingsSkeleton";

});

parcelRegister("26apr", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedQueueCreateRoute", () => $4048db8d5590edd7$export$82f5fdb43014d911);
const $4048db8d5590edd7$export$82f5fdb43014d911 = {
    name: 'servicedesk-getting-started-queue-create',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});


parcelRegister("aXjIq", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedQueueEditRouteEntry", () => $4188ba2a5b9601c7$export$6148951d300de690);
/* eslint-disable import/order */ 

var $c1SKw = parcelRequire("c1SKw");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $dY6WN = parcelRequire("dY6WN");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $cDLVA = parcelRequire("cDLVA");

var $t7VsO = parcelRequire("t7VsO");

var $6l0SD = parcelRequire("6l0SD");

var $74h93 = parcelRequire("74h93");
const $4188ba2a5b9601c7$var$queueEditPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $c1SKw.gettingStartedQueueEditEntryPoint)
});
const $4188ba2a5b9601c7$export$6148951d300de690 = (0, $fdS54.createEntry)((0, $6l0SD.servicedeskGettingStartedQueueEditRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-queue-edit-load',
        skeleton: (0, $dY6WN.QueueSettingsSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $lbxXL.getQueueConfigResource)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $cDLVA.getCalendarFilterFieldsResource)()
        ],
        entryPoint () {
            return (0, $i860n.fg)('solution_composer_master') ? $4188ba2a5b9601c7$var$queueEditPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c1SKw", function(module, exports) {
$parcel$export(module.exports, "gettingStartedQueueEditEntryPoint", () => $1223ada0e812ffce$export$d2bb5e2f6092ed5f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $6n2pY = parcelRequire("6n2pY");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $lC5kV = parcelRequire("lC5kV");
const $1223ada0e812ffce$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;

const $1223ada0e812ffce$export$d2bb5e2f6092ed5f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("l1JOb")), {
        moduleId: "5ef02254",
        moduleName: "QueueEditEmbeddedView",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: match, query: query, route: route }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const projectKey = match.params.projectKey;
        const queueId = match.params.queueId ?? '';
        if (!projectKey) throw new Error('projectKey is required');
        const queueAri = queueId ? (0, $lC5kV.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId,
            activationId: activationId
        }).toString() : '';
        const input = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                SettingsContainerContentQuery: {
                    parameters: (0, $6n2pY.default),
                    variables: {
                        input: input,
                        first: $1223ada0e812ffce$var$NAVIGATION_ITEMS_PAGE_SIZE
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            extraProps: {
                projectKey: projectKey,
                query: query,
                match: match,
                route: route
            }
        };
    }
});

});
parcelRegister("l1JOb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eFgIX").then(()=>parcelRequire('jLKLx'));

});


parcelRegister("6l0SD", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedQueueEditRoute", () => $51e3be455ccc878b$export$53dd097f76d6a618);
const $51e3be455ccc878b$export$53dd097f76d6a618 = {
    name: 'servicedesk-getting-started-queue-edit',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/queues/custom/:queueId/edit/:boardId?',
    query: [
        'config?'
    ],
    exact: true
};

});


parcelRegister("vZN7a", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedQueuesRouteEntry", () => $e5fb4475b90abe31$export$934783fb378a9365);
/* eslint-disable import/order */ 

var $bfgvo = parcelRequire("bfgvo");

var $lFLfF = parcelRequire("lFLfF");

var $dY6WN = parcelRequire("dY6WN");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $azdAH = parcelRequire("azdAH");

var $74h93 = parcelRequire("74h93");
const $e5fb4475b90abe31$var$queueSettingsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bfgvo.gettingStartedQueueSettingsEntryPoint)
});
const $e5fb4475b90abe31$export$934783fb378a9365 = (0, $fdS54.createEntry)((0, $azdAH.servicedeskGettingStartedQueuesRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-queues-load',
        skeleton: (0, $dY6WN.QueueSettingsSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return (0, $i860n.fg)('solution_composer_master') ? $e5fb4475b90abe31$var$queueSettingsPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bfgvo", function(module, exports) {
$parcel$export(module.exports, "gettingStartedQueueSettingsEntryPoint", () => $04c32bd33534571a$export$294085e146ecfb0e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $esnYH = parcelRequire("esnYH");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $04c32bd33534571a$export$294085e146ecfb0e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("bVqwv")), {
        moduleId: "8778b844",
        moduleName: "QueueSettingsEmbeddedView",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = match.params.projectKey ?? '';
        return {
            queries: {
                queueSettingsQuery: {
                    parameters: $esnYH.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            extraProps: {
                projectKey: projectKey
            }
        };
    }
});

});
parcelRegister("esnYH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0697642255ea69df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04fda81fa14715d21f290814c9ed61d9>>
 * @relayHash eabecc9fa9096315fa62703f02e156f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 53d0a90a1be73201bf841505f2041a171880c7f58fea4507b79c103078db316c
const $0697642255ea69df$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "53d0a90a1be73201bf841505f2041a171880c7f58fea4507b79c103078db316c",
        "metadata": {},
        "name": "QueueSettingsEmbeddedViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0697642255ea69df$export$2e2bcd8739ae039 = $0697642255ea69df$var$node;

});

parcelRegister("bVqwv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hh3R1").then(()=>parcelRequire('c4Cgc'));

});


parcelRegister("azdAH", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedQueuesRoute", () => $ea822151e077bb63$export$f5d3307cf12b1c0c);
const $ea822151e077bb63$export$f5d3307cf12b1c0c = {
    name: 'servicedesk-getting-started-queues',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/queues/queue-settings',
    exact: true
};

});


parcelRegister("1e3lG", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRequestFormRouteEntry", () => $2ff65891aa2d3fa3$export$5529eb432cf264cc);
/* eslint-disable import/order */ 

var $kHkxC = parcelRequire("kHkxC");

var $lFLfF = parcelRequire("lFLfF");

var $3oMJS = parcelRequire("3oMJS");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $8gns3 = parcelRequire("8gns3");

var $lwd5d = parcelRequire("lwd5d");

var $74h93 = parcelRequire("74h93");
const $2ff65891aa2d3fa3$var$gettingStartedRequestFormPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kHkxC.gettingStartedRequestTypesEntryPoint)
});
const $2ff65891aa2d3fa3$export$5529eb432cf264cc = (0, $fdS54.createEntry)((0, $lwd5d.servicedeskGettingStartedRequestFormRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-request-form-load',
        skeleton: (0, $3oMJS.RequestTypesSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $8gns3.servicedeskPortalGroupsResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('solution_composer_master') ? $2ff65891aa2d3fa3$var$gettingStartedRequestFormPageEntryPoint : undefined,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("kHkxC", function(module, exports) {
$parcel$export(module.exports, "gettingStartedRequestTypesEntryPoint", () => $270656f034069220$export$d7e23fd84d62462a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $8BHn4 = parcelRequire("8BHn4");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $270656f034069220$export$d7e23fd84d62462a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dBtHC")), {
        moduleId: "8e213f36",
        moduleName: "RequestTypesPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const projectKey = context.match?.params?.projectKey;
        const cloudId = tenantContext?.cloudId ?? '';
        if (!projectKey || !cloudId) return {};
        return {
            entryPoints: {
                requestTypeTableEntrypoint: {
                    entryPoint: (0, $8BHn4.requestTypeTableEntrypoint),
                    entryPointParams: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("dBtHC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("boeok")
]).then(()=>parcelRequire('2XJ6V'));

});


parcelRegister("3oMJS", function(module, exports) {
$parcel$export(module.exports, "RequestTypesSkeleton", () => $aba3c7bb9747ea4d$export$576c97034c1057a);
/* RequestTypesSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $ihEDU = parcelRequire("ihEDU");

var $3PC9r = parcelRequire("3PC9r");

var $defJG = parcelRequire("defJG");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $8ityu = parcelRequire("8ityu");
const $aba3c7bb9747ea4d$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.request-types-skeleton.loading",
    defaultMessage: "Loading request types"
});
const $aba3c7bb9747ea4d$var$styles = {
    container: "_1e0c1txw _2lx21bp4 _4t3i1osq _1bsb1osq _1ul91fdn _vchhusvi _bfhkvuon",
    content: "_18zrxy5q _1q511ejb",
    sectionLabel: "_1q511ejb _85i5u2gc",
    row: "_1rjcutpp _1r62e4h9 _12ornqa1 _1ezz1l7x"
};
const $aba3c7bb9747ea4d$var$RequestTypeRow = ()=>/*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $aba3c7bb9747ea4d$var$styles.row,
        "aria-hidden": "true"
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.150",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.050"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 200,
        height: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 140,
        height: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }))), /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 60,
        height: 28,
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 28,
        height: 28,
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }))));
$aba3c7bb9747ea4d$var$RequestTypeRow.displayName = "RequestTypeRow";
const $aba3c7bb9747ea4d$export$576c97034c1057a = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $aba3c7bb9747ea4d$var$styles.container,
        role: "status",
        "aria-busy": "true",
        "aria-label": formatMessage($aba3c7bb9747ea4d$var$loadingMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $8ityu.EmbedHeaderSkeleton), null), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $aba3c7bb9747ea4d$var$styles.content
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        spread: "space-between",
        alignBlock: "center",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 260,
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.100"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 90,
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }), /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: 130,
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }))), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $aba3c7bb9747ea4d$var$styles.sectionLabel,
        "aria-hidden": "true"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: "var(--ds-space-1000, 80px)",
        height: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    })), [
        ...Array(3)
    ].map((_, i)=>/*#__PURE__*/ $euxye.createElement($aba3c7bb9747ea4d$var$RequestTypeRow, {
            key: i
        })), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $aba3c7bb9747ea4d$var$styles.sectionLabel,
        "aria-hidden": "true"
    }, /*#__PURE__*/ $euxye.createElement((0, $3NRLa.default), {
        width: "var(--ds-space-800, 64px)",
        height: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    })), [
        ...Array(4)
    ].map((_, i)=>/*#__PURE__*/ $euxye.createElement($aba3c7bb9747ea4d$var$RequestTypeRow, {
            key: i
        }))));
};
$aba3c7bb9747ea4d$export$576c97034c1057a.displayName = "RequestTypesSkeleton";

});

parcelRegister("lwd5d", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRequestFormRoute", () => $4674c0dbe2b49eb8$export$b82d79997cf8df9b);
const $4674c0dbe2b49eb8$export$b82d79997cf8df9b = {
    name: 'servicedesk-getting-started-request-form',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/request-types/request-type/:requestTypeId/:tabKey?',
    exact: true
};

});


parcelRegister("6zpko", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRequestTypesRouteEntry", () => $a7b65d06e8192b6d$export$7cb6d3b84546effe);
/* eslint-disable import/order */ 

var $kHkxC = parcelRequire("kHkxC");

var $lFLfF = parcelRequire("lFLfF");

var $3oMJS = parcelRequire("3oMJS");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $8gns3 = parcelRequire("8gns3");

var $73kzk = parcelRequire("73kzk");

var $74h93 = parcelRequire("74h93");
const $a7b65d06e8192b6d$var$gettingStartedRequestTypesPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kHkxC.gettingStartedRequestTypesEntryPoint)
});
const $a7b65d06e8192b6d$export$7cb6d3b84546effe = (0, $fdS54.createEntry)((0, $73kzk.servicedeskGettingStartedRequestTypesRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-request-types-load',
        skeleton: (0, $3oMJS.RequestTypesSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $8gns3.servicedeskPortalGroupsResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('solution_composer_master') ? $a7b65d06e8192b6d$var$gettingStartedRequestTypesPageEntryPoint : undefined,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});

parcelRegister("krUFs", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRouteEntry", () => $45ecb30259b4fb00$export$e4e0491275df7c2d);


var $jDJ4j = parcelRequire("jDJ4j");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $8gns3 = parcelRequire("8gns3");

var $XJeW7 = parcelRequire("XJeW7");

var $74h93 = parcelRequire("74h93");

var $xmwl9 = parcelRequire("xmwl9");
const $45ecb30259b4fb00$var$gettingStartedPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $jDJ4j.gettingStartedEntryPoint)
});
const $45ecb30259b4fb00$export$e4e0491275df7c2d = (0, $fdS54.createEntry)((0, $XJeW7.servicedeskGettingStartedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-page-load',
        skeleton: (0, $xmwl9.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $8gns3.servicedeskPortalGroupsResource)
        ],
        entryPoint () {
            return (0, $i860n.fg)('gsp_production_rollout') ? $45ecb30259b4fb00$var$gettingStartedPageEntryPoint : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jDJ4j", function(module, exports) {
$parcel$export(module.exports, "gettingStartedEntryPoint", () => $9300f808cf86bfb6$export$a91a58d8bb93ad8e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $4Jgyq = parcelRequire("4Jgyq");

var $i8BNs = parcelRequire("i8BNs");
var $fDVI0 = parcelRequire("fDVI0");

var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");
function $9300f808cf86bfb6$var$numericProjectIdForPreload(query) {
    const fromQuery = query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
    if (fromQuery != null && fromQuery !== '' && /^\d+$/.test(String(fromQuery))) return String(fromQuery);
    return null;
}

const $9300f808cf86bfb6$export$a91a58d8bb93ad8e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("4Zuhi")), {
        moduleId: "c3d5f960",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        if (!(0, $i860n.fg)('solution_composer_master')) return {};
        const { cloudId: cloudId, activationId: activationId } = entryPointParams.tenantContext;
        if (cloudId == null || activationId == null) return {};
        const { query: query, match: match } = entryPointParams.context;
        const projectId = $9300f808cf86bfb6$var$numericProjectIdForPreload(query);
        if (projectId == null) return {};
        const projectKey = match?.params?.projectKey;
        const projectAri = (0, $i8BNs.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString();
        const workspaceAri = (0, $fDVI0.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        if (!projectKey) return {};
        return {
            queries: {
                SolutionComposerDataProviderQuery: {
                    parameters: (0, $4Jgyq.default),
                    variables: {
                        cloudId: cloudId,
                        projectAri: projectAri,
                        projectId: projectId,
                        projectIdForHelpCenter: projectId,
                        workspaceAri: workspaceAri,
                        projectKey: projectKey
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("4Jgyq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a19a7b49927e8629$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65eadca36ed4c6e8ff5d8531f467f443>>
 * @relayHash ed2357135971fe9156669685e22ee2ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 647cc9989a1954034fe7d3f4e274b08ff2208b449dda2bcaaa87ba5aaf0295de
const $a19a7b49927e8629$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "647cc9989a1954034fe7d3f4e274b08ff2208b449dda2bcaaa87ba5aaf0295de",
        "metadata": {},
        "name": "SolutionComposerDataProviderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a19a7b49927e8629$export$2e2bcd8739ae039 = $a19a7b49927e8629$var$node;

});

parcelRegister("4Zuhi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("90Yo9")
]).then(()=>parcelRequire('fPPud'));

});


parcelRegister("XJeW7", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRoute", () => $4c49be393fce7d9a$export$165249c1c8f2e713);
const $4c49be393fce7d9a$export$165249c1c8f2e713 = {
    name: 'servicedesk-getting-started-page',
    path: '/jira/servicedesk/projects/:projectKey/getting-started',
    exact: true
};

});


parcelRegister("6Lrmn", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRouteEntry", () => $da9ae8653bdb4553$export$86e0c6fc38770afd);

var $liWGq = parcelRequire("liWGq");

var $dTa0V = parcelRequire("dTa0V");

var $idDnR = parcelRequire("idDnR");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $klrLd = parcelRequire("klrLd");

var $74h93 = parcelRequire("74h93");


var $lbxXL = parcelRequire("lbxXL");

var $lFLfF = parcelRequire("lFLfF");

var $6RXDY = parcelRequire("6RXDY");
const $da9ae8653bdb4553$var$rovoAgentSelfServiceSetupPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6RXDY.gettingStartedRovoServiceAgentSelfServiceSetupEntryPoint)
});
const $da9ae8653bdb4553$export$86e0c6fc38770afd = (0, $fdS54.createEntry)((0, $klrLd.servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-rovo-self-service-setup-load',
        skeleton: (0, $liWGq.RovoAgentSkeleton),
        entryPoint: ()=>(0, $i860n.fg)('solution_composer_master') ? $da9ae8653bdb4553$var$rovoAgentSelfServiceSetupPageEntryPoint : undefined,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("liWGq", function(module, exports) {
$parcel$export(module.exports, "RovoAgentSkeleton", () => $b55c42662c598c52$export$e717fc39b2422454);
/* RovoAgentSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $b55c42662c598c52$var$loadingMessage = (0, $7eNDO.defineMessage)({
    id: "servicedesk-solution-composer.rovo-agent-skeleton.loading",
    defaultMessage: "Loading Rovo agents"
});
const $b55c42662c598c52$var$styles = {
    container: "_1e0c1txw _2lx21bp4 _4t3i1osq _1bsb1osq _1ul91fdn _vchhusvi _bfhkvuon",
    content: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    leftColumn: "_16jlidpf _1o9zidpf _i0dlxilx",
    rightColumn: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    portalCard: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _bfhkhp5a"
};
const $b55c42662c598c52$export$e717fc39b2422454 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $b55c42662c598c52$var$styles.container,
        role: "status",
        "aria-busy": "true",
        "aria-label": formatMessage($b55c42662c598c52$var$loadingMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $b55c42662c598c52$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.500",
        alignBlock: "start",
        shouldWrap: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $b55c42662c598c52$var$styles.leftColumn,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "70%",
        height: "32px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "100%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "95%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "55%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "88%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "80%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "74%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "38%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $b55c42662c598c52$var$styles.portalCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "45%",
        height: "18px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "55%",
        height: "18px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: 140,
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: 160,
        height: "var(--ds-space-400, 32px)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        isShimmering: true
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $b55c42662c598c52$var$styles.rightColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        width: "100%",
        height: "420px",
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    })))));
};
$b55c42662c598c52$export$e717fc39b2422454.displayName = "RovoAgentSkeleton";

});

parcelRegister("klrLd", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRoute", () => $d971a7dcb68e51d5$export$94f3b7c4a9f7bcb5);
const $d971a7dcb68e51d5$export$94f3b7c4a9f7bcb5 = {
    name: 'servicedesk-getting-started-rovo-service-agent-self-service-setup',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/rovo-service-agent/self-service-setup',
    exact: true
};

});

parcelRegister("6RXDY", function(module, exports) {
$parcel$export(module.exports, "gettingStartedRovoServiceAgentSelfServiceSetupEntryPoint", () => $efabee311838ebb4$export$155cf48c4a622d5e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $efabee311838ebb4$export$155cf48c4a622d5e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("9CdEo")), {
        moduleId: "5c362e15",
        moduleName: "RovoAgentSelfServiceSetupEmbeddedView",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9CdEo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kgiBn").then(()=>parcelRequire('jRCHz'));

});



parcelRegister("2h2AR", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedSlaEditRouteEntry", () => $b02c2b316ba866e1$export$6d0a9ca303ef5ef6);


var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $140fA = parcelRequire("140fA");

var $lFLfF = parcelRequire("lFLfF");

var $87jIJ = parcelRequire("87jIJ");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $eFRqk = parcelRequire("eFRqk");

var $74h93 = parcelRequire("74h93");

var $xmwl9 = parcelRequire("xmwl9");
const $b02c2b316ba866e1$var$slaPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $87jIJ.gettingStartedSlaEntryPoint)
});
const $b02c2b316ba866e1$export$6d0a9ca303ef5ef6 = (0, $fdS54.createEntry)((0, $eFRqk.servicedeskGettingStartedSlaEditRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-sla-load',
        skeleton: (0, $xmwl9.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $140fA.slaMetricsDataResource)
        ],
        entryPoint () {
            return (0, $i860n.fg)('solution_composer_master') ? $b02c2b316ba866e1$var$slaPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("140fA", function(module, exports) {
$parcel$export(module.exports, "slaMetricsDataResource", () => $37fbbb9db6bbed78$export$6cdfca3e816e9661);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $37fbbb9db6bbed78$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';

const $37fbbb9db6bbed78$export$6cdfca3e816e9661 = (0, $7edbf.createResource)({
    type: $37fbbb9db6bbed78$export$c5fa03c9ad8df0e2,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("i4JQi")),
    maxAge: Infinity
});

});
parcelRegister("i4JQi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5UhV3").then(()=>parcelRequire('fSAeg'));

});


parcelRegister("87jIJ", function(module, exports) {
$parcel$export(module.exports, "gettingStartedSlaEntryPoint", () => $ea3584070e988c6e$export$e2954a6c1058775e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ea3584070e988c6e$export$e2954a6c1058775e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("bJUiA")), {
        moduleId: "6d6fc207",
        moduleName: "SlaPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bJUiA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("2EyR3")
]).then(()=>parcelRequire('44GEu'));

});


parcelRegister("eFRqk", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedSlaEditRoute", () => $956bed33bc797245$export$f35dbcf472fa8131);
const $956bed33bc797245$export$f35dbcf472fa8131 = {
    name: 'servicedesk-getting-started-sla-edit',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/sla/custom/:id/edit',
    exact: true
};

});


parcelRegister("cc4sb", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedSlaNewRouteEntry", () => $ca2c55df474c1730$export$76122cae3b8162e4);


var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $140fA = parcelRequire("140fA");

var $lFLfF = parcelRequire("lFLfF");

var $87jIJ = parcelRequire("87jIJ");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $d8oZB = parcelRequire("d8oZB");

var $74h93 = parcelRequire("74h93");

var $xmwl9 = parcelRequire("xmwl9");
const $ca2c55df474c1730$var$slaPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $87jIJ.gettingStartedSlaEntryPoint)
});
const $ca2c55df474c1730$export$76122cae3b8162e4 = (0, $fdS54.createEntry)((0, $d8oZB.servicedeskGettingStartedSlaNewRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-sla-load',
        skeleton: (0, $xmwl9.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $140fA.slaMetricsDataResource)
        ],
        entryPoint () {
            return (0, $i860n.fg)('solution_composer_master') ? $ca2c55df474c1730$var$slaPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("d8oZB", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedSlaNewRoute", () => $c9c1524fc8b4aab1$export$f3390aae1f9a3a83);
const $c9c1524fc8b4aab1$export$f3390aae1f9a3a83 = {
    name: 'servicedesk-getting-started-sla-new',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/sla/new',
    exact: true
};

});


parcelRegister("2EIyD", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedSlaRouteEntry", () => $f0e428c7734f30b1$export$ea954373847e24cf);


var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $140fA = parcelRequire("140fA");

var $lFLfF = parcelRequire("lFLfF");

var $87jIJ = parcelRequire("87jIJ");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $1GUwC = parcelRequire("1GUwC");

var $74h93 = parcelRequire("74h93");

var $xmwl9 = parcelRequire("xmwl9");
const $f0e428c7734f30b1$var$slaPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $87jIJ.gettingStartedSlaEntryPoint)
});
const $f0e428c7734f30b1$export$ea954373847e24cf = (0, $fdS54.createEntry)((0, $1GUwC.servicedeskGettingStartedSlaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-sla-load',
        skeleton: (0, $xmwl9.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $140fA.slaMetricsDataResource)
        ],
        entryPoint () {
            return (0, $i860n.fg)('solution_composer_master') ? $f0e428c7734f30b1$var$slaPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1GUwC", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedSlaRoute", () => $8a24d4705ff69365$export$4ae62e36cf5ac082);
const $8a24d4705ff69365$export$4ae62e36cf5ac082 = {
    name: 'servicedesk-getting-started-sla',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/sla',
    exact: true
};

});


parcelRegister("gUUEu", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedSlaViewRouteEntry", () => $fe43758489a33318$export$9aaca87d1fcbcc61);


var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $140fA = parcelRequire("140fA");

var $lFLfF = parcelRequire("lFLfF");

var $87jIJ = parcelRequire("87jIJ");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $k56Cj = parcelRequire("k56Cj");

var $74h93 = parcelRequire("74h93");

var $xmwl9 = parcelRequire("xmwl9");
const $fe43758489a33318$var$slaPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $87jIJ.gettingStartedSlaEntryPoint)
});
const $fe43758489a33318$export$9aaca87d1fcbcc61 = (0, $fdS54.createEntry)((0, $k56Cj.servicedeskGettingStartedSlaViewRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-sla-load',
        skeleton: (0, $xmwl9.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $t7VsO.servicedeskIssueTypesResource),
            (0, $140fA.slaMetricsDataResource)
        ],
        entryPoint () {
            return (0, $i860n.fg)('solution_composer_master') ? $fe43758489a33318$var$slaPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("k56Cj", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedSlaViewRoute", () => $197109d29fa72dfc$export$a5a5aef80ca29dac);
const $197109d29fa72dfc$export$a5a5aef80ca29dac = {
    name: 'servicedesk-getting-started-sla-view',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/sla/custom/:id',
    exact: true
};

});


parcelRegister("eb42n", function(module, exports) {
$parcel$export(module.exports, "servicedeskIssueRouteEntry", () => $0906e9dc65e084a6$export$a4bd7206a6659ad3);
/* eslint-disable import/order */ 

var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $d9D6I = parcelRequire("d9D6I");

var $74h93 = parcelRequire("74h93");

var $9KYmb = parcelRequire("9KYmb");

var $cvySC = parcelRequire("cvySC");
const $0906e9dc65e084a6$export$a4bd7206a6659ad3 = (0, $fdS54.createEntry)((0, $d9D6I.servicedeskIssueRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cvySC.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $lbxXL.getKnowledgeBaseResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            ...(0, $9KYmb.getDraftReplyPillsResource)(),
            ...(0, $lbxXL.getIssueViewResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cvySC.LazyServicedeskQueuesIssueViewRedirect)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("d9D6I", function(module, exports) {
$parcel$export(module.exports, "servicedeskIssueRoute", () => $91c31ee815e5152e$export$e146d4ae5415aa9);
const $91c31ee815e5152e$export$e146d4ae5415aa9 = {
    name: 'servicedesk-issue',
    path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
    exact: true
};

});

parcelRegister("cvySC", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesIssueViewRedirect", () => $b608c8357cc0ec90$export$52593b5917c5e179);
$parcel$export(module.exports, "default", () => $b608c8357cc0ec90$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $b608c8357cc0ec90$export$52593b5917c5e179 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("5B34M")), {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-issue-view-redirect/src/index.tsx"
});
const $b608c8357cc0ec90$var$AsyncServicedeskQueuesIssueViewRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $b608c8357cc0ec90$export$52593b5917c5e179,
        pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
        shouldShowSpinner: true
    });
$b608c8357cc0ec90$var$AsyncServicedeskQueuesIssueViewRedirect.displayName = "AsyncServicedeskQueuesIssueViewRedirect";
var $b608c8357cc0ec90$export$2e2bcd8739ae039 = $b608c8357cc0ec90$var$AsyncServicedeskQueuesIssueViewRedirect;

});
parcelRegister("5B34M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("rYeXC").then(()=>parcelRequire('4XXxh'));

});



parcelRegister("2GE6d", function(module, exports) {
$parcel$export(module.exports, "servicedeskItsmSampleSpaceRouteEntry", () => $12583e8280550810$export$61ad481262acd4e6);

var $euxye = parcelRequire("euxye");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $5aR4C = parcelRequire("5aR4C");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $12583e8280550810$var$LazyItsmSampleSpace = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("a7DCq")), {
    moduleId: "./src/packages/spa-apps/servicedesk-itsm-sample-space/src/index.tsx"
});
const $12583e8280550810$var$ItsmSampleSpace = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $12583e8280550810$var$LazyItsmSampleSpace,
        pageId: "spa-apps/servicedesk/itsm-sample-space",
        shouldShowSpinner: true
    });
$12583e8280550810$var$ItsmSampleSpace.displayName = "ItsmSampleSpace";
const $12583e8280550810$export$61ad481262acd4e6 = (0, $fdS54.createEntry)((0, $5aR4C.servicedeskItsmSampleSpaceRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: $12583e8280550810$var$ItsmSampleSpace,
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $12583e8280550810$var$LazyItsmSampleSpace
        ],
        perfMetricKey: 'jsm-sample-space-landing-page',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ITSM_SAMPLE_SPACE,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ITSM_SAMPLE_SPACE),
                teamName: 'Sequoia'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5aR4C", function(module, exports) {
$parcel$export(module.exports, "servicedeskItsmSampleSpaceRoute", () => $8a77dd31c341a03e$export$5bc288fedb880892);
const $8a77dd31c341a03e$export$5bc288fedb880892 = {
    name: 'servicedesk-itsm-sample-space',
    path: '/jira/servicedesk/itsm-sample-space',
    exact: true
};

});

parcelRegister("a7DCq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fKckx").then(()=>parcelRequire('lMwax'));

});


parcelRegister("1dNif", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReports2RouteEntry", () => $adcb5faa0437d494$export$c4c0806ea684088);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $hygnL = parcelRequire("hygnL");

var $74h93 = parcelRequire("74h93");

var $84jQ7 = parcelRequire("84jQ7");
const $adcb5faa0437d494$export$c4c0806ea684088 = (0, $fdS54.createEntry)((0, $hygnL.servicedeskKbRequestsReports2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $84jQ7.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $84jQ7.LazyServicedeskKbRequestsReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hygnL", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReports2Route", () => $53d8418784b1357a$export$276e2ed89304d21c);
const $53d8418784b1357a$export$276e2ed89304d21c = {
    name: 'servicedesk-kb-requests-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)'
};

});

parcelRegister("84jQ7", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKbRequestsReports", () => $f3cbb71b5b66189e$export$f86e12b111395ad);
$parcel$export(module.exports, "default", () => $f3cbb71b5b66189e$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f3cbb71b5b66189e$export$f86e12b111395ad = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("31agz"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-kb-requests-reports/src/KbRequestsReportsApp.tsx"
});
const $f3cbb71b5b66189e$var$AsyncServicedeskKbRequestsReports = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f3cbb71b5b66189e$export$f86e12b111395ad,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};
$f3cbb71b5b66189e$var$AsyncServicedeskKbRequestsReports.displayName = "AsyncServicedeskKbRequestsReports";
var $f3cbb71b5b66189e$export$2e2bcd8739ae039 = $f3cbb71b5b66189e$var$AsyncServicedeskKbRequestsReports;

});
parcelRegister("31agz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bfOyt")
]).then(()=>parcelRequire('jtd5o'));

});



parcelRegister("XHO18", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRouteEntry", () => $5140b44e61b3d1bc$export$280a79a8f002dd58);
/* eslint-disable import/order */ 
var $51vnM = parcelRequire("51vnM");


var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $f1QWg = parcelRequire("f1QWg");

var $74h93 = parcelRequire("74h93");

var $4acHw = parcelRequire("4acHw");
const $5140b44e61b3d1bc$export$280a79a8f002dd58 = (0, $fdS54.createEntry)((0, $f1QWg.servicedeskKbRequestsReportsIssueRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4acHw.default),
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4acHw.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("f1QWg", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", () => $ffc83c843ecd59fd$export$296aa46068d40f43);
const $ffc83c843ecd59fd$export$296aa46068d40f43 = {
    name: 'servicedesk-kb-requests-reports-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId/:issueKey',
    exact: true
};

});

parcelRegister("4acHw", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsIssueView", () => $614f429989f1c341$export$c2f0d3c59c9d3bf3);
$parcel$export(module.exports, "default", () => $614f429989f1c341$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $614f429989f1c341$export$c2f0d3c59c9d3bf3 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("ePpyi")), {
    moduleId: "./src/packages/spa-apps/servicedesk-reports-issue-view/src/ReportsIssueViewSpa.tsx"
});
/**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */ const $614f429989f1c341$var$AsyncServicedeskReportsIssueView = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $614f429989f1c341$export$c2f0d3c59c9d3bf3,
        pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}`,
        shouldShowSpinner: true
    });
};
$614f429989f1c341$var$AsyncServicedeskReportsIssueView.displayName = "AsyncServicedeskReportsIssueView";
var $614f429989f1c341$export$2e2bcd8739ae039 = $614f429989f1c341$var$AsyncServicedeskReportsIssueView;

});
parcelRegister("ePpyi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aROnT").then(()=>parcelRequire('2GHcZ'));

});



parcelRegister("hcYkM", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRouteEntry", () => $c419f6ffaf606fb8$export$1c6b1e308d58ca8b);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $4kQID = parcelRequire("4kQID");

var $74h93 = parcelRequire("74h93");

var $84jQ7 = parcelRequire("84jQ7");
const $c419f6ffaf606fb8$export$1c6b1e308d58ca8b = (0, $fdS54.createEntry)((0, $4kQID.servicedeskKbRequestsReportsTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $84jQ7.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $84jQ7.LazyServicedeskKbRequestsReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4kQID", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", () => $50c44de554d21487$export$1585b6f8f1838e19);
const $50c44de554d21487$export$1585b6f8f1838e19 = {
    name: 'servicedesk-kb-requests-reports-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId'
};

});


parcelRegister("cerux", function(module, exports) {
$parcel$export(module.exports, "servicedeskLiveChatMyChatsRouteEntry", () => $02e688544973bddd$export$8ba79fd5d9f5123c);
/* eslint-disable import/order */ 

var $37wYb = parcelRequire("37wYb");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $dTa0V = parcelRequire("dTa0V");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $t7VsO = parcelRequire("t7VsO");

var $3U4re = parcelRequire("3U4re");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");
const $02e688544973bddd$var$liveChatMyChatsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $37wYb.liveChatMyChatsEntryPoint)
});
const $02e688544973bddd$export$8ba79fd5d9f5123c = (0, $fdS54.createEntry)((0, $3U4re.servicedeskLiveChatMyChatsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        perfMetricKey: 'servicedesk-live-chat-my-chats-load',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $t7VsO.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return (0, $i860n.fg)('live-chat-rovo-for-service') ? $02e688544973bddd$var$liveChatMyChatsPageEntryPoint : undefined;
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("37wYb", function(module, exports) {
$parcel$export(module.exports, "liveChatMyChatsEntryPoint", () => $bdbb49938ea9f5a4$export$49294a5e86f1089f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $bdbb49938ea9f5a4$export$49294a5e86f1089f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("89qci")), {
        moduleId: "53c7e640",
        moduleName: "LiveChatMyChatsSpa",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("89qci", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("5t9h3")
]).then(()=>parcelRequire('2Zwnt'));

});


parcelRegister("3U4re", function(module, exports) {
$parcel$export(module.exports, "servicedeskLiveChatMyChatsRoute", () => $739c18e1302edd4e$export$91c031480ec465ee);
const $739c18e1302edd4e$export$91c031480ec465ee = {
    name: 'servicedesk-live-chat-my-chats',
    path: '/jira/servicedesk/projects/:projectKey/live-chat',
    exact: true
};

});


parcelRegister("d8Os7", function(module, exports) {
$parcel$export(module.exports, "servicedeskOncallScheduleRouteEntry", () => $384f23629cc8a3a9$export$36994f6fd22da90e);
/* eslint-disable import/order */ 

var $9QAbZ = parcelRequire("9QAbZ");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ZOrWp = parcelRequire("ZOrWp");

var $74h93 = parcelRequire("74h93");

var $dIUQY = parcelRequire("dIUQY");
const $384f23629cc8a3a9$export$36994f6fd22da90e = (0, $fdS54.createEntry)((0, $ZOrWp.servicedeskOncallScheduleRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.on-call-schedule',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dIUQY.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $9QAbZ.AsyncJSMOperationsHorizontalNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dIUQY.LazyServicedeskOpsgenieSchedule),
            (0, $9QAbZ.LazyJSMOperationsHorizontalNav)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ZOrWp", function(module, exports) {
$parcel$export(module.exports, "servicedeskOncallScheduleRoute", () => $b5f0d842d2c20c58$export$740e6e5e982b48a9);
const $b5f0d842d2c20c58$export$740e6e5e982b48a9 = {
    name: 'servicedesk-oncall-schedule',
    path: '/jira/servicedesk/projects/:projectKey/on-call-schedule',
    exact: true
};

});

parcelRegister("dIUQY", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskOpsgenieSchedule", () => $f2295874fb7b7d83$export$e8392650fdcd92d5);
$parcel$export(module.exports, "default", () => $f2295874fb7b7d83$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f2295874fb7b7d83$export$e8392650fdcd92d5 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("3RvZB")), {
    moduleId: "./src/packages/spa-apps/servicedesk-opsgenie-schedule/src/ServicedeskOpsgenieSchedule.tsx"
});
const $f2295874fb7b7d83$var$AsyncServicedeskOpsgenieSchedule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f2295874fb7b7d83$export$e8392650fdcd92d5,
        pageId: "spa-apps/servicedesk/opsgenie-schedule",
        shouldShowSpinner: true
    });
$f2295874fb7b7d83$var$AsyncServicedeskOpsgenieSchedule.displayName = "AsyncServicedeskOpsgenieSchedule";
var $f2295874fb7b7d83$export$2e2bcd8739ae039 = $f2295874fb7b7d83$var$AsyncServicedeskOpsgenieSchedule;

});
parcelRegister("3RvZB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2CUjG").then(()=>parcelRequire('ihSAz'));

});



parcelRegister("7O20s", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationDetailsRouteEntry", () => $a4678e657638ca64$export$a9452a74fdc4d74f);
/* eslint-disable import/order */ 

var $gAOlK = parcelRequire("gAOlK");

var $5hiaJ = parcelRequire("5hiaJ");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $jVrUf = parcelRequire("jVrUf");

var $Q5OI6 = parcelRequire("Q5OI6");

var $8IrlB = parcelRequire("8IrlB");

var $6pofw = parcelRequire("6pofw");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $lioZt = parcelRequire("lioZt");
const $a4678e657638ca64$export$a9452a74fdc4d74f = (0, $fdS54.createEntry)((0, $8IrlB.servicedeskOrganizationDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lioZt.ServicedeskOrganizationDetails),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lioZt.LazyServicedeskOrganizationDetails)
        ],
        perfMetricKey: 'jsm-organization-details-component-load',
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ORGANIZATION_DETAILS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ORGANIZATION_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $gAOlK.EntitlementsEntitlementsQueryResource),
            (0, $5hiaJ.OrganizationDetailsPageQueryResource),
            (0, $Q5OI6.productsJsmOrganizationDetailsResource),
            (0, $jVrUf.jsmEmailDomainsListResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8IrlB", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", () => $126dc657990c19fd$export$eacc4723293cbc36);
const $126dc657990c19fd$export$eacc4723293cbc36 = {
    name: 'servicedesk-organization-details',
    path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
    exact: true
};

});

parcelRegister("lioZt", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskOrganizations", () => $f4d9e261987d069d$export$b40b4bfa472057b9);
$parcel$export(module.exports, "ServiceDeskOrganizations", () => $f4d9e261987d069d$export$4abec67d7b34dda2);
$parcel$export(module.exports, "LazyServicedeskOrganizationDetails", () => $f4d9e261987d069d$export$4a01866152e4a375);
$parcel$export(module.exports, "ServicedeskOrganizationDetails", () => $f4d9e261987d069d$export$709be875ca0a7ead);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f4d9e261987d069d$export$b40b4bfa472057b9 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("PIWcm"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-organizations/src/ServicedeskOrganizations.tsx"
});
const $f4d9e261987d069d$export$4abec67d7b34dda2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f4d9e261987d069d$export$b40b4bfa472057b9,
        pageId: "spa-apps/servicedesk/organizations",
        shouldShowSpinner: true
    });
$f4d9e261987d069d$export$4abec67d7b34dda2.displayName = "ServiceDeskOrganizations";

const $f4d9e261987d069d$export$4a01866152e4a375 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("id0sE"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-organization-details/src/ServicedeskOrganizationDetails.tsx"
});
const $f4d9e261987d069d$export$709be875ca0a7ead = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f4d9e261987d069d$export$4a01866152e4a375,
        pageId: "spa-apps/servicedesk/organization-details",
        shouldShowSpinner: true
    });
$f4d9e261987d069d$export$709be875ca0a7ead.displayName = "ServicedeskOrganizationDetails";

});
parcelRegister("PIWcm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("iwvKC")
]).then(()=>parcelRequire('66Wrc'));

});

parcelRegister("id0sE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gir7a")
]).then(()=>parcelRequire('707HO'));

});



parcelRegister("ajJlg", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationsRouteEntry", () => $7afc22a2160bb20c$export$cf20fe731144ca3b);
/* eslint-disable import/order */ 
var $aS3GY = parcelRequire("aS3GY");


var $a6AZh = parcelRequire("a6AZh");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $hDsxm = parcelRequire("hDsxm");

var $6pofw = parcelRequire("6pofw");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $lioZt = parcelRequire("lioZt");
const $7afc22a2160bb20c$export$cf20fe731144ca3b = (0, $fdS54.createEntry)((0, $hDsxm.servicedeskOrganizationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lioZt.ServiceDeskOrganizations),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lioZt.LazyServicedeskOrganizations)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $a6AZh.AsyncDirectoryNav)
        },
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).ORGANIZATIONS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).ORGANIZATIONS),
                teamName: 'boysenberry'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hDsxm", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationsRoute", () => $6ed6ca7a750ab732$export$d4a712c5bc3c3434);
const $6ed6ca7a750ab732$export$d4a712c5bc3c3434 = {
    name: 'servicedesk-organizations',
    path: '/jira/servicedesk/projects/:projectKey/organizations',
    exact: true
};

});


parcelRegister("c6fhT", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationV2RouteEntry", () => $a4306a9b7b6b3e8a$export$1b6ea96c35c2472c);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $jVrUf = parcelRequire("jVrUf");

var $Q5OI6 = parcelRequire("Q5OI6");

var $lbxXL = parcelRequire("lbxXL");

var $3Gnra = parcelRequire("3Gnra");

var $6WS3U = parcelRequire("6WS3U");

var $74h93 = parcelRequire("74h93");

var $7l5xU = parcelRequire("7l5xU");
const $a4306a9b7b6b3e8a$export$1b6ea96c35c2472c = (0, $fdS54.createEntry)((0, $6WS3U.servicedeskOrganizationV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $3Gnra.serviceDeskOrganizationPanelForgeDataResource),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $Q5OI6.productsJsmOrganizationDetailsResource),
            (0, $jVrUf.jsmEmailDomainsListResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7l5xU.ServiceDeskOrganizationV2),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $7l5xU.LazyServicedeskOrganizationV2)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3Gnra", function(module, exports) {
$parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", () => $c081f23c3d6b3876$export$f3c46a19f3594363);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");


const $c081f23c3d6b3876$export$f3c46a19f3594363 = (0, $7edbf.createResource)({
    type: (0, $4f1f31fc3f280fc7$export$66d6e1e05866ee2f),
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `extension-${projectKey}`;
    },
    getDataLoader: ()=>(parcelRequire("7M8iV")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
/* eslint-disable jira/filename-case */ const $4f1f31fc3f280fc7$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';

parcelRegister("7M8iV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("27tKG").then(()=>parcelRequire('cNBqh'));

});


parcelRegister("6WS3U", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationV2Route", () => $de2a16a6a2fd5aff$export$7f878f9aeac61f1e);
const $de2a16a6a2fd5aff$export$7f878f9aeac61f1e = {
    name: 'servicedesk-organization_v2',
    path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
    exact: true
};

});

parcelRegister("7l5xU", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskOrganizationV2", () => $000c83bb1009aef1$export$1c7fcdb58f42db03);
$parcel$export(module.exports, "ServiceDeskOrganizationV2", () => $000c83bb1009aef1$export$5f69663d85db303d);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $000c83bb1009aef1$export$1c7fcdb58f42db03 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("gIk1s"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-organization-v2/src/ServicedeskOrganizationV2.tsx"
});
const $000c83bb1009aef1$export$5f69663d85db303d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $000c83bb1009aef1$export$1c7fcdb58f42db03,
        pageId: "spa-apps/servicedesk/organization-v2",
        shouldShowSpinner: true
    });
$000c83bb1009aef1$export$5f69663d85db303d.displayName = "ServiceDeskOrganizationV2";

});
parcelRegister("gIk1s", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("vORya")
]).then(()=>parcelRequire('h43Pd'));

});



parcelRegister("1Y7s6", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksEditDedicatedRouteEntry", () => $208c5b366ba46701$export$ab609e9d29d0f7a2);

var $74oEx = parcelRequire("74oEx");



var $aVaWm = parcelRequire("aVaWm");

var $iSoIx = parcelRequire("iSoIx");

var $6RSCO = parcelRequire("6RSCO");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $TrHni = parcelRequire("TrHni");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $itHlY = parcelRequire("itHlY");
const $208c5b366ba46701$var$editEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $aVaWm.default)
});
const $208c5b366ba46701$export$ab609e9d29d0f7a2 = (0, $fdS54.createEntry)((0, $TrHni.servicedeskPlaybooksEditDedicatedRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            // AEM's isFeatureEnabled is the source of truth for Playbooks availability (it already
            // encodes the FedRamp / isolated-cloud restrictions), replacing the deprecated isFedRamp.
            if (!(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-automation-playbook')) return 0, $iSoIx.notFoundPageEntrypoint;
            // This dedicated `/edit/:playbookId` route only serves the edit screen behind the
            // migration gate; with the gate off the legacy `/:playbookId` route serves it instead.
            if (!(0, $i860n.fg)('playbooks_edit_route_migration')) return 0, $iSoIx.notFoundPageEntrypoint;
            return $208c5b366ba46701$var$editEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // Mirrors the legacy edit route's reporting id and ufoName so edit metrics stay continuous
        // across the migration.
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-edit-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('project-settings-playbooks-edit'),
                teamName: 'ITOps Phantom'
            }
        },
        ufoName: 'playbook-edit',
        skeleton: (0, $itHlY.PlaybookEditSkeleton),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aVaWm", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5f087088818d076$export$2e2bcd8739ae039);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $2Zgo3 = parcelRequire("2Zgo3");

/**
 * NOTE - Please update src/packages/playbooks/edit-screen/src/entrypoint.tsx
 * as that is used in integration test and ideally both should be same except queries
 */ const $d5f087088818d076$var$playbookEditViewEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("grNrg")), {
        moduleId: "e2493165",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey, playbookId: playbookId = '' } = context.match.params;
        const { fromPlaybookId: fromPlaybookId = '' } = context.query;
        const aiResultId = (0, $i860n.fg)('phantom-4816-ai-playbook-creation-fe') ? context.query.aiResultId : undefined;
        if (!projectKey) throw new Error('projectKey is required');
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const isNewPlaybook = !!playbookId?.includes($d5f087088818d076$var$NEW_PLAYBOOK_IDENTIFIER);
        const callablePlaybookId = $d5f087088818d076$var$getPlaybookId(playbookId, fromPlaybookId);
        const playbookAri = $d5f087088818d076$var$toPlaybookAri({
            siteId: cloudId,
            activationId: activationId,
            playbookId: callablePlaybookId
        });
        const isNewPlaybookCheck = isNewPlaybook && !fromPlaybookId;
        if (isNewPlaybookCheck) // This is complete new playbook creation
        return {
            extraProps: {
                playbookAri: playbookAri,
                isNew: true,
                variant: 'new',
                aiResultId: aiResultId
            }
        };
        return {
            queries: {
                PlaybookDetailQuery: {
                    parameters: (0, $2Zgo3.default),
                    variables: {
                        playbookAri: playbookAri,
                        cloudId: cloudId,
                        isMediaSupportEnabled: (0, $i860n.fg)('playbooks_step_image_file_support')
                    }
                }
            },
            extraProps: {
                playbookAri: playbookAri,
                isNew: false,
                variant: isNewPlaybook && !!fromPlaybookId ? 'copy' : 'edit'
            }
        };
    }
});
var $d5f087088818d076$export$2e2bcd8739ae039 = $d5f087088818d076$var$playbookEditViewEntryPoint;
function $d5f087088818d076$var$toPlaybookAri({ siteId: siteId, activationId: activationId, playbookId: playbookId }) {
    return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}
const $d5f087088818d076$var$getPlaybookId = (playbookId, fromPlaybookId)=>{
    if (fromPlaybookId) return fromPlaybookId;
    return playbookId || '';
};
const $d5f087088818d076$var$NEW_PLAYBOOK_IDENTIFIER = '_new_';

});
parcelRegister("2Zgo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $54f2c414abbd43f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20744149a6abca00bfe3fbe4782f8e76>>
 * @relayHash 61e4dfda9f4ee5eafd7aa36bd3e9ee64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ce5423efd579a4621c0f1f58dcc6187e13f9e96f2c1dcfc5c718c7c8d7c1e802

var $3l1eI = parcelRequire("3l1eI");
const $54f2c414abbd43f7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ce5423efd579a4621c0f1f58dcc6187e13f9e96f2c1dcfc5c718c7c8d7c1e802",
        "metadata": {},
        "name": "PlaybookDetailQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraPlaybookChecklistStepRelayProvider": (0, $3l1eI.default)
        }
    }
};
var $54f2c414abbd43f7$export$2e2bcd8739ae039 = $54f2c414abbd43f7$var$node;

});
parcelRegister("3l1eI", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f8740808612304d$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $3f8740808612304d$var$JiraPlaybookChecklistStepRelayProvider = {
    get () {
        return (0, $i860n.fg)('phantom-5483-checklist-step');
    }
};
var $3f8740808612304d$export$2e2bcd8739ae039 = $3f8740808612304d$var$JiraPlaybookChecklistStepRelayProvider;

});


parcelRegister("grNrg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("kitkz")
]).then(()=>parcelRequire('iuEea'));

});


parcelRegister("TrHni", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksEditDedicatedRoute", () => $1af3d30637fe9696$export$e0937618464af50f);
const $1af3d30637fe9696$export$e0937618464af50f = {
    name: 'project-settings-playbooks-edit-dedicated',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/edit/:playbookId',
    exact: true
};

});

parcelRegister("itHlY", function(module, exports) {
$parcel$export(module.exports, "PlaybookEditSkeleton", () => $5c2ca3e0b26c1dbe$export$8e181e27312cd7a4);
/* eslint-disable jira/i18n/no-export-define-message */ 
var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $6Elhl = parcelRequire("6Elhl");

var $5BP41 = parcelRequire("5BP41");

var $2BUXh = parcelRequire("2BUXh");

var $9ufM9 = parcelRequire("9ufM9");

var $3NRLa = parcelRequire("3NRLa");

var $2iotI = parcelRequire("2iotI");

var $apUrw = parcelRequire("apUrw");

var $bwVQC = parcelRequire("bwVQC");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $6Moae = parcelRequire("6Moae");
const $5c2ca3e0b26c1dbe$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    returnToList: {
        id: "playbooks-edit-screen.playbook-item.skeleton.return-to-list",
        defaultMessage: "Return to list"
    }
});
const $5c2ca3e0b26c1dbe$export$8e181e27312cd7a4 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [playbookListLink] = (0, $6Moae.useReturnToListUrl)();
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.100",
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
        appearance: "subtle",
        href: playbookListLink
    }, formatMessage($5c2ca3e0b26c1dbe$export$defe85febe8b728c.returnToList)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $5c2ca3e0b26c1dbe$var$containerStyle,
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bwVQC.default), {
        actions: actions,
        disableTitleStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $apUrw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        as: "h1",
        size: "small"
    }, formatMessage($5c2ca3e0b26c1dbe$var$loadingTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        gap: "space.300",
        direction: "row",
        justifyContent: "space-between",
        xcss: $5c2ca3e0b26c1dbe$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        xcss: $5c2ca3e0b26c1dbe$var$stepCards,
        alignBlock: "start",
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-large, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-large, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        xcss: $5c2ca3e0b26c1dbe$var$addButton,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "40px",
        width: "40px",
        isShimmering: true,
        borderRadius: "var(--ds-radius-full, 9999px)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $5c2ca3e0b26c1dbe$var$detailStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: "520px",
        width: "100%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-large, 8px)"
    }))));
};
$5c2ca3e0b26c1dbe$export$8e181e27312cd7a4.displayName = "PlaybookEditSkeleton";
const $5c2ca3e0b26c1dbe$var$containerStyle = (0, $fbAgj.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    paddingLeft: 'space.300',
    paddingRight: 'space.500',
    height: '100vh'
});
const $5c2ca3e0b26c1dbe$var$detailStyle = (0, $fbAgj.xcss)({
    maxWidth: '800px',
    minWidth: '440px',
    width: '45%'
});
const $5c2ca3e0b26c1dbe$var$contentStyles = (0, $fbAgj.xcss)({
    width: '100%',
    paddingTop: 'space.400'
});
const $5c2ca3e0b26c1dbe$var$stepCards = (0, $fbAgj.xcss)({
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: '30%',
    maxWidth: '600px'
});
const $5c2ca3e0b26c1dbe$var$addButton = (0, $fbAgj.xcss)({
    height: '52px'
});
const $5c2ca3e0b26c1dbe$var$loadingTitle = (0, $7eNDO.defineMessage)({
    id: "playbooks-edit-screen.playbook-item.skeleton.loading-title",
    defaultMessage: "Opening playbook ..."
});

});
parcelRegister("6Moae", function(module, exports) {
$parcel$export(module.exports, "getStepData", () => $9253c62955141de4$export$f1427121561aecf8);
$parcel$export(module.exports, "isStep", () => $9253c62955141de4$export$21684750287da054);
$parcel$export(module.exports, "getJiraPlaybookIdFromARI", () => $9253c62955141de4$export$191a8b6475837449);
$parcel$export(module.exports, "useReturnToListUrl", () => $9253c62955141de4$export$565f39f00aacdb73);
$parcel$export(module.exports, "usePlaybooksTabUrl", () => $9253c62955141de4$export$e6f6d3a4d9a9ba5c);
$parcel$export(module.exports, "getIsDescriptionEmpty", () => $9253c62955141de4$export$f11d072d2cef989a);
$parcel$export(module.exports, "getStepsOrder", () => $9253c62955141de4$export$812421dcb7983dd1);
$parcel$export(module.exports, "getStepsDetail", () => $9253c62955141de4$export$aa46de8dc426f402);
$parcel$export(module.exports, "isPlaybooksTab", () => $9253c62955141de4$export$8f5946cd7bd6acfd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ixTPY = parcelRequire("ixTPY");

var $jFp2x = parcelRequire("jFp2x");

var $cZjb4 = parcelRequire("cZjb4");

var $kAzZd = parcelRequire("kAzZd");
const $9253c62955141de4$export$f1427121561aecf8 = (id, name, type, index)=>{
    return {
        stepId: id,
        name: name,
        index: index,
        type: type
    };
};
const $9253c62955141de4$export$21684750287da054 = (data)=>{
    if (data) {
        const { type: type } = data;
        return type === 'INSTRUCTIONAL_RULE' || type === 'AUTOMATION_RULE' || type === 'CHECKLIST';
    }
    return false;
};
const $9253c62955141de4$export$cf6e5a5e05d437ad = (cloudId, activationId, playbookId)=>{
    return (0, $jFp2x.JiraPlaybookAri).create({
        siteId: cloudId,
        activationId: activationId,
        playbookId: playbookId
    }).toString();
};
const $9253c62955141de4$export$191a8b6475837449 = (playbookAri)=>{
    return (0, $jFp2x.JiraPlaybookAri).parse(playbookAri).playbookId;
};
const $9253c62955141de4$export$565f39f00aacdb73 = ()=>{
    const [projectKey = ''] = (0, $cZjb4.usePathParam)('projectKey');
    const playbookListLink = (0, $kAzZd.getProjectSettingsPageUrl)(projectKey, 'playbooks/list');
    return [
        playbookListLink
    ];
};
const $9253c62955141de4$export$e6f6d3a4d9a9ba5c = (tab)=>{
    const [projectKey = ''] = (0, $cZjb4.usePathParam)('projectKey');
    return (0, $kAzZd.getProjectSettingsPageUrl)(projectKey, `playbooks/${tab}`);
};
const $9253c62955141de4$export$f11d072d2cef989a = (description)=>{
    if (description && Object.keys(description).length > 0) return JSON.stringify(description) === JSON.stringify((0, $ixTPY.getEmptyADF)());
    return true;
};
const $9253c62955141de4$export$812421dcb7983dd1 = (data)=>{
    return data.map((step)=>step.stepId);
};
const $9253c62955141de4$export$aa46de8dc426f402 = (data)=>{
    const acc = {};
    data.forEach((step)=>{
        acc[step.stepId] = step;
    });
    return acc;
};
const $9253c62955141de4$var$PLAYBOOKS_TABS = new Set([
    'list',
    'logs',
    'templates'
]);
const $9253c62955141de4$export$8f5946cd7bd6acfd = (value)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return value !== undefined && $9253c62955141de4$var$PLAYBOOKS_TABS.has(value);
};

});
parcelRegister("ixTPY", function(module, exports) {
$parcel$export(module.exports, "getEmptyADF", () => $e4011dfb210e6095$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fppHP = parcelRequire("fppHP");
const $e4011dfb210e6095$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("fppHP", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $668447f454f74885$export$dd1bc94b04021eeb);
const $668447f454f74885$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("jFp2x", function(module, exports) {
$parcel$export(module.exports, "JiraPlaybookAri", () => $e51545112190e1a0$export$2b27259a6ef92c74);

var $0ywuy = parcelRequire("0ywuy");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/playbook/manifest.ts
var $e51545112190e1a0$var$jiraPlaybookAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $0ywuy.JiraPlaybookAriResourceOwner),
    resourceType: (0, $0ywuy.JiraPlaybookAriResourceType),
    resourceIdSlug: "activation/{activationId}/{playbookId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        playbookId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/playbook/index.ts
var $e51545112190e1a0$export$2b27259a6ef92c74 = class _JiraPlaybookAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._playbookId = opts.resourceIdSegmentValues.playbookId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get playbookId() {
        return this._playbookId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e51545112190e1a0$var$jiraPlaybookAriStaticOpts.qualifier,
            platformQualifier: $e51545112190e1a0$var$jiraPlaybookAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e51545112190e1a0$var$jiraPlaybookAriStaticOpts.resourceOwner,
            resourceType: $e51545112190e1a0$var$jiraPlaybookAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.playbookId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                playbookId: opts.playbookId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $e51545112190e1a0$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $e51545112190e1a0$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            playbookId: this.playbookId
        };
    }
};

});
parcelRegister("0ywuy", function(module, exports) {
$parcel$export(module.exports, "JiraPlaybookAriResourceOwner", () => $001ac7c34756e6d4$export$91235105b4a9ebd9);
$parcel$export(module.exports, "JiraPlaybookAriResourceType", () => $001ac7c34756e6d4$export$5af5bf4e6f11326f);
// src/jira/playbook/types.ts
var $001ac7c34756e6d4$export$91235105b4a9ebd9 = "jira", $001ac7c34756e6d4$export$5af5bf4e6f11326f = "playbook";

});


parcelRegister("kAzZd", function(module, exports) {
$parcel$export(module.exports, "getProjectUrl", () => $80c705f426083fd9$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $80c705f426083fd9$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $80c705f426083fd9$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsPageUrl", () => $80c705f426083fd9$export$75ee62cffcd82d96);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $80c705f426083fd9$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $80c705f426083fd9$export$c2a8139910ee6c);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $80c705f426083fd9$export$b87292f363462760);
$parcel$export(module.exports, "getUserManagementUrl", () => $80c705f426083fd9$export$13f39b40814e5f3e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3Sl5Y = parcelRequire("3Sl5Y");

var $f99M0 = parcelRequire("f99M0");

var $4P0Fw = parcelRequire("4P0Fw");

var $5yfEX = parcelRequire("5yfEX");

var $fpfva = parcelRequire("fpfva");

var $881dx = parcelRequire("881dx");
const $80c705f426083fd9$export$951b86b8e730b952 = (projectKey)=>(0, $881dx.generatePath)((0, $fpfva.projectsRedirectRoute).path, {
        projectKey: projectKey
    });
const $80c705f426083fd9$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $3Sl5Y.getNextgenSettingsIssueTypesUrl)((0, $f99M0.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $80c705f426083fd9$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $80c705f426083fd9$var$getNextgenIssueTypesUrl(projectKey) : (0, $881dx.generatePath)((0, $5yfEX.projectSettingsServicedeskTicketTypesConfigRoute).path, {
        projectKey: projectKey
    });
const $80c705f426083fd9$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $80c705f426083fd9$var$getNextgenIssueTypesUrl(projectKey) : `${$80c705f426083fd9$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
const $80c705f426083fd9$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $80c705f426083fd9$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $80c705f426083fd9$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $80c705f426083fd9$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
    if (isSimplified) return $80c705f426083fd9$var$getNextgenIssueTypesUrl(projectKey, issueTypeId || undefined);
    // For non-simplified, the URL does not depend on issueTypeId
    return (0, $881dx.generatePath)((0, $4P0Fw.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
};
const $80c705f426083fd9$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
const $80c705f426083fd9$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("4P0Fw", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $643899e8d9124880$export$b03606cedffdadf6);
const $643899e8d9124880$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});





parcelRegister("6UzoR", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksEditRouteEntry", () => $baf4959699ace500$export$abfa8cd64fabd80e);

var $74oEx = parcelRequire("74oEx");



var $aVaWm = parcelRequire("aVaWm");

var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $6RSCO = parcelRequire("6RSCO");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7CJBq = parcelRequire("7CJBq");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $itHlY = parcelRequire("itHlY");

var $lEGhN = parcelRequire("lEGhN");
const $baf4959699ace500$var$editEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $aVaWm.default)
});
const $baf4959699ace500$export$abfa8cd64fabd80e = (0, $fdS54.createEntry)((0, $7CJBq.servicedeskPlaybooksEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_playbooks') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-automation-playbook') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            if ((0, $i860n.fg)('playbooks_edit_route_migration')) return undefined;
            return $baf4959699ace500$var$editEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-edit-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('project-settings-playbooks-edit'),
                teamName: 'ITOps Phantom'
            }
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i860n.fg)('playbooks_edit_route_migration') ? (0, $lEGhN.RedirectToPlaybookEditPage) : (0, $lFLfF.default),
        isRedirect: (0, $i860n.fg)('playbooks_edit_route_migration'),
        ufoName: 'playbook-edit',
        skeleton: (0, $itHlY.PlaybookEditSkeleton),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7CJBq", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksEditRoute", () => $d2b83543a4faa0d5$export$5920ce3a2ccf6e2b);
const $d2b83543a4faa0d5$export$5920ce3a2ccf6e2b = {
    name: 'project-settings-playbooks-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/:playbookId',
    exact: true
};

});

parcelRegister("lEGhN", function(module, exports) {
$parcel$export(module.exports, "RedirectToPlaybookEditPage", () => $f009e702af8b6eb6$export$267c682c7b913411);

var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");

var $f2wVS = parcelRequire("f2wVS");
const $f009e702af8b6eb6$var$useMatchUrl = (0, $f2wVS.createRouterSelector)((state)=>state.match.url);
const $f009e702af8b6eb6$export$267c682c7b913411 = ()=>{
    const matchUrl = $f009e702af8b6eb6$var$useMatchUrl();
    const editUrl = matchUrl.replace('/settings/playbooks/', '/settings/playbooks/edit/');
    // persistSearchParams forwards the current query string (step, fromPlaybookId, aiResultId, fromTab).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: editUrl,
        persistSearchParams: true
    });
};
$f009e702af8b6eb6$export$267c682c7b913411.displayName = "RedirectToPlaybookEditPage";

});


parcelRegister("hq3sr", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksListOnlyRouteEntry", () => $97ec797dcb66620e$export$f9e5d9d800421777);

var $74oEx = parcelRequire("74oEx");



var $hnt9O = parcelRequire("hnt9O");

var $cEPzq = parcelRequire("cEPzq");

var $8HUuJ = parcelRequire("8HUuJ");

var $6hEyz = parcelRequire("6hEyz");

var $6YJvG = parcelRequire("6YJvG");

var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7lOm6 = parcelRequire("7lOm6");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $as18y = parcelRequire("as18y");
const $97ec797dcb66620e$var$listOnlyEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6hEyz.default),
    horizontalNavigation: (0, $6YJvG.default)
});
const $97ec797dcb66620e$export$f9e5d9d800421777 = (0, $fdS54.createEntry)((0, $7lOm6.servicedeskPlaybooksListOnlyRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_playbooks') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-automation-playbook') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            return $97ec797dcb66620e$var$listOnlyEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $hnt9O.playbooksListRequestTypesResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('phantom-5397_playbook_work_type_column'), (0, $cEPzq.playbooksListWorkTypesResource))
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.list-only-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('project-settings-playbooks-list-only'),
                teamName: 'ITOps Phantom'
            }
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        ufoName: 'playbook-list-only',
        skeleton: (0, $as18y.PlaybookListLoadingView),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hnt9O", function(module, exports) {
$parcel$export(module.exports, "playbooksListRequestTypesResource", () => $01685fbdcab2d346$export$43f774aa05fabd18);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $l8UJH = parcelRequire("l8UJH");

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $01685fbdcab2d346$export$43f774aa05fabd18 = (0, $7edbf.createResource)({
    type: 'PLAYBOOKS-LIST-REQUEST-TYPES-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const projectKey = match.params.projectKey;
        return `playbooksListRequestTypesResource-${projectKey}`;
    },
    getData: async ({ dependencies: dependencies })=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const { projectId: projectId } = await (0, $l8UJH.consumeDependency)(dependencies, (0, $feef523243843e2f$export$80a60a092d9ab81));
        return (0, $h2wCv.performGetRequest)($01685fbdcab2d346$var$getRequestTypesUrl(projectId)).then((response)=>response.ticketTypes);
    },
    maxAge: 300000,
    depends: [
        (0, $feef523243843e2f$export$80a60a092d9ab81)
    ]
});
const $01685fbdcab2d346$var$getRequestTypesUrl = (projectId)=>`/rest/servicedesk/1/servicedesk/${projectId}/request-types`;

});

parcelRegister("cEPzq", function(module, exports) {
$parcel$export(module.exports, "playbooksListWorkTypesResource", () => $5cb922fa1caa9ebc$export$e66b0ae70b45ad2a);

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $5cb922fa1caa9ebc$export$e66b0ae70b45ad2a = (0, $7edbf.createResource)({
    type: 'PLAYBOOKS-LIST-WORK-TYPES-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const projectKey = match.params.projectKey;
        return `playbooksListWorkTypesResource-${projectKey}`;
    },
    getData: async ({ match: match })=>{
        const projectKey = match.params.projectKey ?? '';
        const response = await (0, $h2wCv.performGetRequest)($5cb922fa1caa9ebc$var$getProjectUrl(projectKey));
        return response.issueTypes ?? [];
    },
    maxAge: 300000
});
const $5cb922fa1caa9ebc$var$getProjectUrl = (projectKey)=>`/rest/api/2/project/${projectKey}`;

});

parcelRegister("6hEyz", function(module, exports) {
$parcel$export(module.exports, "default", () => $56230190b6aa7520$export$2e2bcd8739ae039);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $3mXM9 = parcelRequire("3mXM9");

const $56230190b6aa7520$var$playbookListOnlyViewEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("gjmad")), {
        moduleId: "ed884b8f",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { name: name = '', status: status } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                PlaybookListQuery: {
                    parameters: (0, $3mXM9.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        first: $56230190b6aa7520$var$PLAYBOOK_LIST_FIRST_COUNT,
                        filter: $56230190b6aa7520$var$getFilters(name, status),
                        isFetchingLabels: (0, $i860n.fg)('phantom-3292-playbook-labels'),
                        isFetchingWorkType: (0, $i860n.fg)('phantom-5397_playbook_work_type_column')
                    }
                }
            },
            extraProps: {
                projectKey: context.match.params.projectKey
            }
        };
    }
});
var $56230190b6aa7520$export$2e2bcd8739ae039 = $56230190b6aa7520$var$playbookListOnlyViewEntryPoint;
const $56230190b6aa7520$var$getFilters = (name, status)=>{
    if ((0, $i860n.fg)('phantom-playbook-save-as-draft')) {
        const filter = {};
        const state = $56230190b6aa7520$var$getStateFromStatus(status);
        if (name) filter.name = name;
        if (state) filter.state = state;
        return Object.values(filter).some(Boolean) ? filter : null;
    }
    return name ? {
        name: name
    } : null;
};
const $56230190b6aa7520$var$PLAYBOOK_LIST_FIRST_COUNT = 20;
const $56230190b6aa7520$var$getStateFromStatus = (status)=>{
    switch(status){
        case 'on':
            return 'ENABLED';
        case 'off':
            return 'DISABLED';
        case 'draft':
            return 'DRAFT';
        default:
            return undefined;
    }
};

});
parcelRegister("3mXM9", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd3aedd06aef8bc8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49f06d405fb7678fba181372914d80e7>>
 * @relayHash ea3e49347413e8bf30ce93d8f158104f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 459030a25b00b200f0758055644870f9f250c56ce6625e65bf7655d4feb38501
const $bd3aedd06aef8bc8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "459030a25b00b200f0758055644870f9f250c56ce6625e65bf7655d4feb38501",
        "metadata": {},
        "name": "PlaybookListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $bd3aedd06aef8bc8$export$2e2bcd8739ae039 = $bd3aedd06aef8bc8$var$node;

});

parcelRegister("gjmad", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("6IvMK")
]).then(()=>parcelRequire('bybwJ'));

});


parcelRegister("6YJvG", function(module, exports) {
$parcel$export(module.exports, "default", () => $98041d10574a98d2$export$2e2bcd8739ae039);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $98041d10574a98d2$var$playbooksHorizontalNavEntrypoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("fblMM")), {
        moduleId: "82ef2ade",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match } })=>{
        // Extract projectKey from route parameters
        const projectKey = match.params.projectKey;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            extraProps: {
                projectKey: projectKey
            }
        };
    }
});
var $98041d10574a98d2$export$2e2bcd8739ae039 = $98041d10574a98d2$var$playbooksHorizontalNavEntrypoint;

});
parcelRegister("fblMM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("jtuzh")
]).then(()=>parcelRequire('3leH0'));

});


parcelRegister("7lOm6", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksListOnlyRoute", () => $3c5a957e4519fe1c$export$22e68595bc191dc2);
const $3c5a957e4519fe1c$export$22e68595bc191dc2 = {
    name: 'project-settings-playbooks-list-only',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/list',
    exact: true
};

});

parcelRegister("as18y", function(module, exports) {
$parcel$export(module.exports, "PlaybookListLoadingView", () => $fd7f473bdcd577a7$export$987a3a981b9fa390);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $2BUXh = parcelRequire("2BUXh");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $3NRLa = parcelRequire("3NRLa");

var $2fcKf = parcelRequire("2fcKf");
const $fd7f473bdcd577a7$export$987a3a981b9fa390 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2fcKf.TabContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.250",
        grow: "fill",
        xcss: $fd7f473bdcd577a7$var$wrapperStyles,
        testId: "playbooks-list-screen.ui.playbook-list.edge-cases.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: 240,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: 120,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fd7f473bdcd577a7$var$LoadingRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fd7f473bdcd577a7$var$LoadingRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fd7f473bdcd577a7$var$LoadingRow, null))));
$fd7f473bdcd577a7$export$987a3a981b9fa390.displayName = "PlaybookListLoadingView";
const $fd7f473bdcd577a7$var$LoadingRow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "30%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "18%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "18%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "18%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "6%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "10%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }));
$fd7f473bdcd577a7$var$LoadingRow.displayName = "LoadingRow";
const $fd7f473bdcd577a7$var$wrapperStyles = (0, $fbAgj.xcss)({
    paddingTop: 'space.300'
});

});
parcelRegister("2fcKf", function(module, exports) {
$parcel$export(module.exports, "TabContainer", () => $e82a69669ad87304$export$eed545bf41e40386);
/* TabContainer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $hmdu8 = parcelRequire("hmdu8");

var $f31kM = parcelRequire("f31kM");
const $e82a69669ad87304$export$eed545bf41e40386 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $e82a69669ad87304$var$styles.tabContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hmdu8.default), {
        layout: "fluid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f31kM.default), null, children)));
};
$e82a69669ad87304$export$eed545bf41e40386.displayName = "TabContainer";
const $e82a69669ad87304$var$styles = {
    tabContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _ca0qze3t _u5f31ejb _n3tdze3t _19bv1ejb _4t3i1osq"
};

});



parcelRegister("gJH3P", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksLogsRouteEntry", () => $a17f622e1725582e$export$556757ffa43b9345);

var $74oEx = parcelRequire("74oEx");



var $hnt9O = parcelRequire("hnt9O");

var $3wmeF = parcelRequire("3wmeF");

var $6YJvG = parcelRequire("6YJvG");

var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $akwAG = parcelRequire("akwAG");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $n49bX = parcelRequire("n49bX");
const $a17f622e1725582e$var$logsEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $3wmeF.default),
    horizontalNavigation: (0, $6YJvG.default)
});
const $a17f622e1725582e$export$556757ffa43b9345 = (0, $fdS54.createEntry)((0, $akwAG.servicedeskPlaybooksLogsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_playbooks') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-automation-playbook') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            return $a17f622e1725582e$var$logsEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $hnt9O.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.logs-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('project-settings-playbooks-logs'),
                teamName: 'ITOps Phantom'
            }
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        ufoName: 'playbook-logs',
        skeleton: (0, $n49bX.PlaybookLogsLoadingView),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3wmeF", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf7b9dfbaa4f2f8e$export$2e2bcd8739ae039);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $igcQo = parcelRequire("igcQo");

const $bf7b9dfbaa4f2f8e$var$playbookLogsViewEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9vilM")), {
        moduleId: "98f4fab2",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { name: name = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                PlaybookLogsQuery: {
                    parameters: (0, $igcQo.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        first: $bf7b9dfbaa4f2f8e$var$PLAYBOOK_LOGS_FIRST_COUNT,
                        filter: name ? {
                            name: name
                        } : null
                    }
                }
            },
            extraProps: {
                projectKey: context.match.params.projectKey
            }
        };
    }
});
const $bf7b9dfbaa4f2f8e$var$PLAYBOOK_LOGS_FIRST_COUNT = 20;
var $bf7b9dfbaa4f2f8e$export$2e2bcd8739ae039 = $bf7b9dfbaa4f2f8e$var$playbookLogsViewEntryPoint;

});
parcelRegister("igcQo", function(module, exports) {
$parcel$export(module.exports, "default", () => $1edb4177f2325547$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<15280667f706316750b55d64796fb790>>
 * @relayHash c197bbece789e4cb329e128453687570
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 565606802eb0a72ceab02256a296b8539bab587a529cc4b38118031f77bf14d2
const $1edb4177f2325547$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "565606802eb0a72ceab02256a296b8539bab587a529cc4b38118031f77bf14d2",
        "metadata": {},
        "name": "PlaybookLogsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1edb4177f2325547$export$2e2bcd8739ae039 = $1edb4177f2325547$var$node;

});

parcelRegister("9vilM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bmuuD").then(()=>parcelRequire('g56VV'));

});


parcelRegister("akwAG", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksLogsRoute", () => $03d83fa536dda1f9$export$7fdae29617c2cd73);
const $03d83fa536dda1f9$export$7fdae29617c2cd73 = {
    name: 'project-settings-playbooks-logs',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/logs',
    exact: true
};

});

parcelRegister("n49bX", function(module, exports) {
$parcel$export(module.exports, "PlaybookLogsLoadingView", () => $c9d5861e7e390a1f$export$42f7712c79c4d758);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $2BUXh = parcelRequire("2BUXh");

var $5BP41 = parcelRequire("5BP41");

var $fbAgj = parcelRequire("fbAgj");

var $3NRLa = parcelRequire("3NRLa");

var $2fcKf = parcelRequire("2fcKf");
const $c9d5861e7e390a1f$export$42f7712c79c4d758 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2fcKf.TabContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        testId: "playbooks-list-screen.ui.playbook-logs.edge-cases.loading",
        space: "space.250",
        grow: "fill",
        xcss: $c9d5861e7e390a1f$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: 240,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: 40,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c9d5861e7e390a1f$var$LoadingRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c9d5861e7e390a1f$var$LoadingRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c9d5861e7e390a1f$var$LoadingRow, null))));
$c9d5861e7e390a1f$export$42f7712c79c4d758.displayName = "PlaybookLogsLoadingView";
const $c9d5861e7e390a1f$var$LoadingRow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "22%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "16%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "16%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "16%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "10%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "10%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: "10%",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }));
$c9d5861e7e390a1f$var$LoadingRow.displayName = "LoadingRow";
const $c9d5861e7e390a1f$var$wrapperStyles = (0, $fbAgj.xcss)({
    paddingTop: 'space.300'
});

});


parcelRegister("kp1Tx", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksTemplateCreateRouteEntry", () => $0568dcc760ddc17b$export$e693d2e428384d7);
/* eslint-disable import/order */ 
var $74oEx = parcelRequire("74oEx");



var $kHPNF = parcelRequire("kHPNF");

var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $6RSCO = parcelRequire("6RSCO");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iZ2As = parcelRequire("iZ2As");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $itHlY = parcelRequire("itHlY");
const $0568dcc760ddc17b$var$playbookTemplateCreateEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kHPNF.default)
});
const $0568dcc760ddc17b$export$e693d2e428384d7 = (0, $fdS54.createEntry)((0, $iZ2As.servicedeskPlaybooksTemplateCreateRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_playbooks') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-automation-playbook') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            return $0568dcc760ddc17b$var$playbookTemplateCreateEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-template-create-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('project-settings-playbooks-template-create'),
                teamName: 'ITOps Phantom'
            }
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        ufoName: 'playbook-template-create',
        skeleton: (0, $itHlY.PlaybookEditSkeleton),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kHPNF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f4e7637af003a56$export$2e2bcd8739ae039);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $62e0H = parcelRequire("62e0H");

const $2f4e7637af003a56$var$playbookTemplateCreateViewEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("ej9C0")), {
        moduleId: "046c06dd",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey, templateId: templateId = '' } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const playbookAri = $2f4e7637af003a56$var$toPlaybookAri({
            siteId: cloudId,
            activationId: activationId,
            playbookId: ''
        });
        return {
            queries: {
                PlaybookTemplateCreateQuery: {
                    parameters: (0, $62e0H.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        templateId: templateId ?? ''
                    }
                }
            },
            extraProps: {
                playbookAri: playbookAri,
                isNew: true,
                variant: 'new',
                templateId: templateId ?? ''
            }
        };
    }
});
var $2f4e7637af003a56$export$2e2bcd8739ae039 = $2f4e7637af003a56$var$playbookTemplateCreateViewEntryPoint;
function $2f4e7637af003a56$var$toPlaybookAri({ siteId: siteId, activationId: activationId, playbookId: playbookId }) {
    return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}

});
parcelRegister("62e0H", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b3f5ac9117e65a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b530973bff90fff079483bdd8a37e142>>
 * @relayHash 84c2c1e346b9a26f93ec271062299f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 990ee6cb15a97d6610be8c786bb0db24d16f77a6df01554ca9f374ec6a6a765b
const $4b3f5ac9117e65a9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "990ee6cb15a97d6610be8c786bb0db24d16f77a6df01554ca9f374ec6a6a765b",
        "metadata": {},
        "name": "PlaybookTemplateCreateQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4b3f5ac9117e65a9$export$2e2bcd8739ae039 = $4b3f5ac9117e65a9$var$node;

});

parcelRegister("ej9C0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gqQam")
]).then(()=>parcelRequire('cSF2b'));

});


parcelRegister("iZ2As", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksTemplateCreateRoute", () => $ef419c3365a259e9$export$b8c33038909d50ad);
const $ef419c3365a259e9$export$b8c33038909d50ad = {
    name: 'project-settings-playbooks-template-create',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/template/:templateId',
    exact: true
};

});


parcelRegister("yRwJU", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksTemplatesRouteEntry", () => $85e043719355691f$export$68af602a86f0318a);

var $74oEx = parcelRequire("74oEx");



var $hnt9O = parcelRequire("hnt9O");

var $fgUt3 = parcelRequire("fgUt3");

var $6YJvG = parcelRequire("6YJvG");

var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $kLv8U = parcelRequire("kLv8U");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $ggIna = parcelRequire("ggIna");
const $85e043719355691f$var$templatesEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $fgUt3.default),
    horizontalNavigation: (0, $6YJvG.default)
});
const $85e043719355691f$export$68af602a86f0318a = (0, $fdS54.createEntry)((0, $kLv8U.servicedeskPlaybooksTemplatesRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_playbooks') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-automation-playbook') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            return $85e043719355691f$var$templatesEntryPoint;
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $hnt9O.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.templates-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('project-settings-playbooks-templates'),
                teamName: 'ITOps Phantom'
            }
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        ufoName: 'playbook-templates',
        skeleton: (0, $ggIna.PlaybookTemplatesLoadingView),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fgUt3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a41cf1c646a829de$export$2e2bcd8739ae039);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $93PG1 = parcelRequire("93PG1");

const $a41cf1c646a829de$var$playbookTemplatesEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("ju5dD")), {
        moduleId: "c9dbd826",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { name: name = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                PlaybookTemplatesQuery: {
                    parameters: (0, $93PG1.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        filters: name ? {
                            name: name
                        } : null
                    }
                }
            },
            extraProps: {
                projectKey: context.match.params.projectKey
            }
        };
    }
});
var $a41cf1c646a829de$export$2e2bcd8739ae039 = $a41cf1c646a829de$var$playbookTemplatesEntryPoint;

});
parcelRegister("93PG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd702567a10fd672$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<05e5abe17cc8dee398e422c62a7ab150>>
 * @relayHash ffc4aede5d787c1ab10609dac8e5c5fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf0e43c38d7bd278ae03ad0f7dab63e31964f7d06ea8058a3c4cada548ccec66
const $fd702567a10fd672$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bf0e43c38d7bd278ae03ad0f7dab63e31964f7d06ea8058a3c4cada548ccec66",
        "metadata": {},
        "name": "PlaybookTemplatesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $fd702567a10fd672$export$2e2bcd8739ae039 = $fd702567a10fd672$var$node;

});

parcelRegister("ju5dD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("botBN").then(()=>parcelRequire('1nnjs'));

});


parcelRegister("kLv8U", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksTemplatesRoute", () => $d97d797d19287181$export$db0eaacc419e5ad7);
const $d97d797d19287181$export$db0eaacc419e5ad7 = {
    name: 'project-settings-playbooks-templates',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/templates',
    exact: true
};

});

parcelRegister("ggIna", function(module, exports) {
$parcel$export(module.exports, "PlaybookTemplatesLoadingView", () => $58af95f2aa360f38$export$cc6c6f45cef7ebe);
/* PlaybookTemplatesLoadingView.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $3NRLa = parcelRequire("3NRLa");

var $2fcKf = parcelRequire("2fcKf");

var $3AKQe = parcelRequire("3AKQe");
const $58af95f2aa360f38$var$styles = {
    wrapper: "_ca0q1ejb"
};
const $58af95f2aa360f38$export$cc6c6f45cef7ebe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2fcKf.TabContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        testId: "playbooks-list-screen.ui.playbook-templates.edge-cases.loading",
        space: "space.250",
        grow: "fill",
        xcss: $58af95f2aa360f38$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 32,
        width: 240,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3AKQe.TemplatesListLoadingView), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3AKQe.TemplatesListLoadingView), null))));
$58af95f2aa360f38$export$cc6c6f45cef7ebe.displayName = "PlaybookTemplatesLoadingView";

});
parcelRegister("3AKQe", function(module, exports) {
$parcel$export(module.exports, "TemplatesListLoadingView", () => $554647147eb96421$export$24c3e442327746dc);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $3PC9r = parcelRequire("3PC9r");

var $defJG = parcelRequire("defJG");

var $3NRLa = parcelRequire("3NRLa");
const $554647147eb96421$export$24c3e442327746dc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        space: "space.200",
        testId: "playbooks-list-screen.ui.playbook-templates.edge-cases.templates-list-loading-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 20,
        width: 220,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 282,
        width: 272,
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
        height: 282,
        width: 272,
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    })));
$554647147eb96421$export$24c3e442327746dc.displayName = "TemplatesListLoadingView";

});



parcelRegister("l7fta", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeEditRouteEntry", () => $3e110f635eb947e1$export$5d9efd0f838d30a1);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $cpnl1 = parcelRequire("cpnl1");

var $7o6Gp = parcelRequire("7o6Gp");

var $74h93 = parcelRequire("74h93");

var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");

var $c87b6 = parcelRequire("c87b6");

var $5Er72 = parcelRequire("5Er72");

var $9QD8J = parcelRequire("9QD8J");
const $3e110f635eb947e1$export$5d9efd0f838d30a1 = (0, $fdS54.createEntry)((0, $7o6Gp.servicedeskPracticeEditRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $5Er72.ServicedeskQueuesConfig), (0, $c87b6.default)),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            (0, $cpnl1.issueListSsrResource),
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $lbxXL.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $5Er72.LazyServicedeskQueuesConfig) : (0, $c87b6.LazyServicedeskQueuesEditView)
        ],
        pageId: ({ query: query, match: match })=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9QD8J.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7o6Gp", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeEditRoute", () => $cf942ea0b21c51c3$export$dfaa99f66db1aa2);
const $cf942ea0b21c51c3$export$dfaa99f66db1aa2 = {
    name: 'servicedesk-practice-edit',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});

parcelRegister("c87b6", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesEditView", () => $05fd426a65c97b39$export$5bb02347e0261e6a);
$parcel$export(module.exports, "default", () => $05fd426a65c97b39$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $05fd426a65c97b39$export$5bb02347e0261e6a = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("8I7mC"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-edit-view/src/index.tsx"
});
/**
 * @deprecated Remove this when fsm_views_inside_queues_-_main_flag is cleaned up
 */ const $05fd426a65c97b39$var$AsyncServicedeskQueuesEditView = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $05fd426a65c97b39$export$5bb02347e0261e6a,
        pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
        shouldShowSpinner: true
    });
};
$05fd426a65c97b39$var$AsyncServicedeskQueuesEditView.displayName = "AsyncServicedeskQueuesEditView";
var $05fd426a65c97b39$export$2e2bcd8739ae039 = $05fd426a65c97b39$var$AsyncServicedeskQueuesEditView;

});
parcelRegister("8I7mC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("i0C2B")
]).then(()=>parcelRequire('gqEjD'));

});


parcelRegister("5Er72", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesConfig", () => $86cff4df6ba504f2$export$8bc01f18d5db1178);
$parcel$export(module.exports, "ServicedeskQueuesConfig", () => $86cff4df6ba504f2$export$ac10b7696844d33);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $gNbXR = parcelRequire("gNbXR");

const $86cff4df6ba504f2$export$8bc01f18d5db1178 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("hteMO")), {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-config/src/index.tsx"
});
const $86cff4df6ba504f2$export$ac10b7696844d33 = (props)=>{
    const { query: query } = props;
    // If URL is from edit queue, then redirect to the new URL with config query param
    if (!query.config) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
            to: {
                pathname: `${props.location.pathname}`,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
                    ...restQuery,
                    config: 'queueConfig'
                })
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $86cff4df6ba504f2$export$8bc01f18d5db1178,
        pageId: `spa-apps/servicedesk/queues/config/${query.config}`,
        shouldShowSpinner: true
    });
};
$86cff4df6ba504f2$export$ac10b7696844d33.displayName = "ServicedeskQueuesConfig";

});


parcelRegister("h002s", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeIssueRouteEntry", () => $442fc603b62b5562$export$ff51f5ad948cb987);
/* eslint-disable import/order */ 
var $51vnM = parcelRequire("51vnM");


var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $2YYDo = parcelRequire("2YYDo");

var $74h93 = parcelRequire("74h93");

var $9KYmb = parcelRequire("9KYmb");

var $730Ep = parcelRequire("730Ep");
const $442fc603b62b5562$export$ff51f5ad948cb987 = (0, $fdS54.createEntry)((0, $2YYDo.servicedeskPracticeIssueRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $730Ep.default),
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getKnowledgeBaseResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            ...(0, $9KYmb.getDraftReplyPillsResource)(),
            ...(0, $lbxXL.getIssueViewResources)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $730Ep.LazyServicedeskQueuesIssueView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2YYDo", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeIssueRoute", () => $530ff4535d5c86e7$export$38a6ee0f22e74bf3);
const $530ff4535d5c86e7$export$38a6ee0f22e74bf3 = {
    name: 'servicedesk-practice-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
    exact: true
};

});

parcelRegister("730Ep", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesIssueView", () => $5efd667876315022$export$164f2dfdd8dc056b);
$parcel$export(module.exports, "default", () => $5efd667876315022$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $5efd667876315022$export$164f2dfdd8dc056b = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("AwWMI")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk-queues-issue-view/src/index.tsx"
});
/**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */ const $5efd667876315022$var$AsyncServicedeskQueuesIssueView = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const queueId = `/${match.params && match.params.queueId || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5efd667876315022$export$164f2dfdd8dc056b,
        pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}`,
        shouldShowSpinner: true
    });
};
$5efd667876315022$var$AsyncServicedeskQueuesIssueView.displayName = "AsyncServicedeskQueuesIssueView";
var $5efd667876315022$export$2e2bcd8739ae039 = $5efd667876315022$var$AsyncServicedeskQueuesIssueView;

});
parcelRegister("AwWMI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8vCSf").then(()=>parcelRequire('gBGOo'));

});



parcelRegister("aIBbH", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeLandingRouteEntry", () => $4abdecbba266a2aa$export$881d545af6c177f1);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $3hBN4 = parcelRequire("3hBN4");

var $74h93 = parcelRequire("74h93");

var $269nT = parcelRequire("269nT");
const $4abdecbba266a2aa$export$881d545af6c177f1 = (0, $fdS54.createEntry)((0, $3hBN4.servicedeskPracticeLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $269nT.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $269nT.LazyServicedeskQueuesLanding)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3hBN4", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeLandingRoute", () => $955df4989ec6cc45$export$3c859c71be33b36c);
const $955df4989ec6cc45$export$3c859c71be33b36c = {
    name: 'servicedesk-practice-landing',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
    exact: true
};

});

parcelRegister("269nT", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesLanding", () => $70446a52960f4c23$export$bdf522692228bb6f);
$parcel$export(module.exports, "default", () => $70446a52960f4c23$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $70446a52960f4c23$export$bdf522692228bb6f = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("dgX58")), {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-landing/src/ExportedDefault.tsx"
});
const $70446a52960f4c23$var$AsyncServicedeskQueuesLanding = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $70446a52960f4c23$export$bdf522692228bb6f,
        pageId: "spa-apps/servicedesk/queues/landing",
        shouldShowSpinner: true
    });
$70446a52960f4c23$var$AsyncServicedeskQueuesLanding.displayName = "AsyncServicedeskQueuesLanding";
var $70446a52960f4c23$export$2e2bcd8739ae039 = $70446a52960f4c23$var$AsyncServicedeskQueuesLanding;

});


parcelRegister("38IAb", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeManageViewRouteEntry", () => $63882d3f41d48d28$export$4e1b0df2a8fcae78);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $bMs72 = parcelRequire("bMs72");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $dPHxc = parcelRequire("dPHxc");
const $63882d3f41d48d28$var$getNavigationSpecifications = ()=>{
    return (0, $i860n.fg)('jsm_manage_queues_in_space_settings') && {
        sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
    };
};
const $63882d3f41d48d28$export$4e1b0df2a8fcae78 = (0, $fdS54.createEntry)((0, $bMs72.servicedeskPracticeManageViewRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dPHxc.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            ...$63882d3f41d48d28$var$getNavigationSpecifications()
        },
        resources: (0, $i860n.fg)('jsm_manage_queues_in_space_settings') ? [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            ...(0, $lbxXL.getQueuesResources)()
        ] : (0, $lbxXL.getQueuesResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dPHxc.LazyServicedeskQueuesManageView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dPHxc", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesManageView", () => $89b33eaa5643fd29$export$9f1e189198f08c4a);
$parcel$export(module.exports, "default", () => $89b33eaa5643fd29$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $89b33eaa5643fd29$export$9f1e189198f08c4a = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("46A43"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-manage-view/src/index.tsx"
});
const $89b33eaa5643fd29$var$AsyncServicedeskQueuesManageView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $89b33eaa5643fd29$export$9f1e189198f08c4a,
        pageId: "spa-apps/servicedesk/queues/manage",
        shouldShowSpinner: true
    });
$89b33eaa5643fd29$var$AsyncServicedeskQueuesManageView.displayName = "AsyncServicedeskQueuesManageView";
var $89b33eaa5643fd29$export$2e2bcd8739ae039 = $89b33eaa5643fd29$var$AsyncServicedeskQueuesManageView;

});
parcelRegister("46A43", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("e5QLe")
]).then(()=>parcelRequire('1Lnm4'));

});



parcelRegister("fop9Z", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeNewRouteEntry", () => $b6ff98c84ba56e17$export$50a04ec00cb8039);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $F5atL = parcelRequire("F5atL");

var $74h93 = parcelRequire("74h93");

var $2qLmV = parcelRequire("2qLmV");
const $b6ff98c84ba56e17$export$50a04ec00cb8039 = (0, $fdS54.createEntry)((0, $F5atL.servicedeskPracticeNewRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2qLmV.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2qLmV.LazyServicedeskQueuesCreateView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("F5atL", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeNewRoute", () => $abf3a4fdc7b8e0f3$export$8595a5452f93a1fd);
const $abf3a4fdc7b8e0f3$export$8595a5452f93a1fd = {
    name: 'servicedesk-practice-new',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});

parcelRegister("2qLmV", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesCreateView", () => $f9a6a9143542a27a$export$c050b699bf9e3e40);
$parcel$export(module.exports, "default", () => $f9a6a9143542a27a$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f9a6a9143542a27a$export$c050b699bf9e3e40 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("4J0bR"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-create-view/src/index.tsx"
});
const $f9a6a9143542a27a$var$AsyncServicedeskQueuesCreateView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f9a6a9143542a27a$export$c050b699bf9e3e40,
        pageId: "spa-apps/servicedesk/queues/create",
        shouldShowSpinner: true
    });
$f9a6a9143542a27a$var$AsyncServicedeskQueuesCreateView.displayName = "AsyncServicedeskQueuesCreateView";
var $f9a6a9143542a27a$export$2e2bcd8739ae039 = $f9a6a9143542a27a$var$AsyncServicedeskQueuesCreateView;

});
parcelRegister("4J0bR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bCZSN")
]).then(()=>parcelRequire('9nTwI'));

});



parcelRegister("16IWv", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeViewsConfigRouteEntry", () => $964a02cf1151b1ac$export$101c882abd4d051);


var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7vkjP = parcelRequire("7vkjP");

var $74h93 = parcelRequire("74h93");

var $edf7u = parcelRequire("edf7u");

var $i860n = parcelRequire("i860n");

var $aWliK = parcelRequire("aWliK");

var $9QD8J = parcelRequire("9QD8J");

var $jt2fv = parcelRequire("jt2fv");
const $964a02cf1151b1ac$export$101c882abd4d051 = (0, $fdS54.createEntry)((0, $7vkjP.servicedeskPracticeViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            ...(0, $lbxXL.getQueueViewConfigResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jt2fv.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $jt2fv.ServicedeskQueuesViewsConfig), (0, $lFLfF.default)),
        pageId: ({ query: query, match: match })=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9QD8J.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7vkjP", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeViewsConfigRoute", () => $b653a36c8fb08b5d$export$e8e807e90d20fe7b);
const $b653a36c8fb08b5d$export$e8e807e90d20fe7b = {
    name: 'servicedesk-practice-views-config',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit/:boardId',
    query: [
        'config'
    ],
    exact: true
};

});

parcelRegister("jt2fv", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesViewsConfig", () => $d6a205899d82344b$export$12b9e920fc614605);
$parcel$export(module.exports, "ServicedeskQueuesViewsConfig", () => $d6a205899d82344b$export$666845896df029ad);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $d6a205899d82344b$export$12b9e920fc614605 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("hteMO")), {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-config/src/index.tsx"
});
const $d6a205899d82344b$export$666845896df029ad = (props)=>{
    const { query: query } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $d6a205899d82344b$export$12b9e920fc614605,
        pageId: `spa-apps/servicedesk/queues/views-config/${query.config}`,
        shouldShowSpinner: true
    });
};
$d6a205899d82344b$export$666845896df029ad.displayName = "ServicedeskQueuesViewsConfig";

});


parcelRegister("7rcYw", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportAuditLogRouteEntry", () => $41d013a4082c6173$export$49cbb8d9329f583e);

var $i860n = parcelRequire("i860n");


var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $iueht = parcelRequire("iueht");

var $d2zgP = parcelRequire("d2zgP");
const $41d013a4082c6173$var$proactiveSupportPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $d2zgP.servicedeskProactiveSupportEntryPoint)
});
const $41d013a4082c6173$export$49cbb8d9329f583e = (0, $fdS54.createEntry)((0, $iueht.servicedeskProactiveSupportAuditLogRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.proactive-support.audit-log',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm_psm_visible') ? $41d013a4082c6173$var$proactiveSupportPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iueht", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportAuditLogRoute", () => $c0d1f498e9124e05$export$9c4721c1f2406216);
const $c0d1f498e9124e05$export$9c4721c1f2406216 = {
    name: 'servicedesk-proactive-support-audit-log',
    path: '/jira/servicedesk/projects/:projectKey/proactive-support/audit-log',
    exact: true
};

});

parcelRegister("d2zgP", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportEntryPoint", () => $256949706afa85a6$export$dfdaa07ab74cac6d);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $3Lgjc = parcelRequire("3Lgjc");

var $jJhWz = parcelRequire("jJhWz");

var $3yU7a = parcelRequire("3yU7a");

var $WHtlS = parcelRequire("WHtlS");

const $256949706afa85a6$export$dfdaa07ab74cac6d = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gPfjB")), {
        moduleId: "6438f37c",
        moduleName: "ServicedeskProactiveSupportApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    // Route names mirror the definitions in `@jira/router-routes__servicedesk-proactive-support-routes`.
    // Only the active route's panel is preloaded so the other panel chunks stay lazy.
    getPreloadProps: ({ context: { match: match, route: route } })=>{
        const isOpenIssues = route.name === 'servicedesk-proactive-support-open-issues';
        const isDevices = route.name === 'servicedesk-proactive-support-devices';
        const isAuditLog = route.name === 'servicedesk-proactive-support-audit-log';
        return {
            extraProps: {
                projectKey: String(match.params.projectKey ?? '')
            },
            entryPoints: {
                dashboard: !isOpenIssues && !isDevices && !isAuditLog ? {
                    entryPoint: (0, $3Lgjc.dashboardPanelEntryPoint),
                    entryPointParams: {}
                } : undefined,
                'open-issues': isOpenIssues ? {
                    entryPoint: (0, $jJhWz.openIssuesPanelEntryPoint),
                    entryPointParams: {}
                } : undefined,
                devices: isDevices ? {
                    entryPoint: (0, $3yU7a.devicesPanelEntryPoint),
                    entryPointParams: {}
                } : undefined,
                'audit-log': isAuditLog ? {
                    entryPoint: (0, $WHtlS.auditLogPanelEntryPoint),
                    entryPointParams: {}
                } : undefined
            }
        };
    }
});

});
parcelRegister("3Lgjc", function(module, exports) {
$parcel$export(module.exports, "dashboardPanelEntryPoint", () => $b156e1ae6f8f9fe9$export$38f0e516dd4dfa17);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $b156e1ae6f8f9fe9$export$38f0e516dd4dfa17 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("kpnz8")), {
        moduleId: "95564492",
        moduleName: "DashboardPanel",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kpnz8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4mQLi").then(()=>parcelRequire('4cySu'));

});


parcelRegister("jJhWz", function(module, exports) {
$parcel$export(module.exports, "openIssuesPanelEntryPoint", () => $bcfb6760a22a2c43$export$a276261fccf8dbb4);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $bcfb6760a22a2c43$export$a276261fccf8dbb4 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3KpH0")), {
        moduleId: "aa04a564",
        moduleName: "OpenIssuesPanel",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3KpH0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("95jIG").then(()=>parcelRequire('aH7Fl'));

});


parcelRegister("3yU7a", function(module, exports) {
$parcel$export(module.exports, "devicesPanelEntryPoint", () => $5a2f4076793cd315$export$3055dd6ec23aad2c);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $5a2f4076793cd315$export$3055dd6ec23aad2c = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7UuoZ")), {
        moduleId: "600b5044",
        moduleName: "DevicesPanel",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7UuoZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("286oO").then(()=>parcelRequire('8OrfS'));

});


parcelRegister("WHtlS", function(module, exports) {
$parcel$export(module.exports, "auditLogPanelEntryPoint", () => $bca08f7074d71e49$export$845f10bce93af267);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $bca08f7074d71e49$export$845f10bce93af267 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("89yD1")), {
        moduleId: "5c73d44c",
        moduleName: "AuditLogPanel",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("89yD1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("foyPA").then(()=>parcelRequire('caP4E'));

});


parcelRegister("gPfjB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jaIe3").then(()=>parcelRequire('b8vOZ'));

});



parcelRegister("70Vv8", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportDashboardRouteEntry", () => $2c470cbea2478ec0$export$ed083e3b0d900944);

var $i860n = parcelRequire("i860n");


var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $88Fyc = parcelRequire("88Fyc");

var $d2zgP = parcelRequire("d2zgP");
const $2c470cbea2478ec0$var$proactiveSupportPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $d2zgP.servicedeskProactiveSupportEntryPoint)
});
const $2c470cbea2478ec0$export$ed083e3b0d900944 = (0, $fdS54.createEntry)((0, $88Fyc.servicedeskProactiveSupportDashboardRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.proactive-support.dashboard',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm_psm_visible') ? $2c470cbea2478ec0$var$proactiveSupportPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("88Fyc", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportDashboardRoute", () => $480f676a1d16af10$export$595768f03093bcdb);
const $480f676a1d16af10$export$595768f03093bcdb = {
    name: 'servicedesk-proactive-support-dashboard',
    path: '/jira/servicedesk/projects/:projectKey/proactive-support/dashboard',
    exact: true
};

});


parcelRegister("1F2VA", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportDevicesRouteEntry", () => $660399733f814748$export$d35915d3f023e0f);

var $i860n = parcelRequire("i860n");


var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $1jXjl = parcelRequire("1jXjl");

var $d2zgP = parcelRequire("d2zgP");
const $660399733f814748$var$proactiveSupportPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $d2zgP.servicedeskProactiveSupportEntryPoint)
});
const $660399733f814748$export$d35915d3f023e0f = (0, $fdS54.createEntry)((0, $1jXjl.servicedeskProactiveSupportDevicesRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.proactive-support.devices',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm_psm_visible') ? $660399733f814748$var$proactiveSupportPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1jXjl", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportDevicesRoute", () => $cd4c71fbfa74afd0$export$8e4582b0322b0793);
const $cd4c71fbfa74afd0$export$8e4582b0322b0793 = {
    name: 'servicedesk-proactive-support-devices',
    path: '/jira/servicedesk/projects/:projectKey/proactive-support/devices',
    exact: true
};

});


parcelRegister("gUpP3", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportOpenIssuesRouteEntry", () => $1b66c47ae0f89871$export$81c71006f96d6069);

var $i860n = parcelRequire("i860n");


var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $cnPAv = parcelRequire("cnPAv");

var $d2zgP = parcelRequire("d2zgP");
const $1b66c47ae0f89871$var$proactiveSupportPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $d2zgP.servicedeskProactiveSupportEntryPoint)
});
const $1b66c47ae0f89871$export$81c71006f96d6069 = (0, $fdS54.createEntry)((0, $cnPAv.servicedeskProactiveSupportOpenIssuesRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.proactive-support.open-issues',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        entryPoint: ()=>(0, $i860n.fg)('jsm_psm_visible') ? $1b66c47ae0f89871$var$proactiveSupportPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cnPAv", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportOpenIssuesRoute", () => $78392b429956f51a$export$29791e9fb2e12a45);
const $78392b429956f51a$export$29791e9fb2e12a45 = {
    name: 'servicedesk-proactive-support-open-issues',
    path: '/jira/servicedesk/projects/:projectKey/proactive-support/open-issues',
    exact: true
};

});


parcelRegister("gOMGi", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportRouteEntry", () => $23e24071e44e8c7c$export$90825278240a986e);

var $i860n = parcelRequire("i860n");


var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $iSoIx = parcelRequire("iSoIx");

var $dNMOj = parcelRequire("dNMOj");

var $c1gpg = parcelRequire("c1gpg");
const $23e24071e44e8c7c$var$proactiveSupportRedirectPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $c1gpg.proactiveSupportDashboardRedirectEntryPoint)
});
const $23e24071e44e8c7c$export$90825278240a986e = (0, $fdS54.createEntry)((0, $dNMOj.servicedeskProactiveSupportRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.proactive-support',
        layout: (0, $74h93.serviceProjectLayout),
        isRedirect: true,
        entryPoint: ()=>(0, $i860n.fg)('jsm_psm_visible') ? $23e24071e44e8c7c$var$proactiveSupportRedirectPageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dNMOj", function(module, exports) {
$parcel$export(module.exports, "servicedeskProactiveSupportRoute", () => $f9c1ff4c0adbcb17$export$8f60809ddca5a7ee);
const $f9c1ff4c0adbcb17$export$8f60809ddca5a7ee = {
    name: 'servicedesk-proactive-support',
    path: '/jira/servicedesk/projects/:projectKey/proactive-support',
    exact: true
};

});

parcelRegister("c1gpg", function(module, exports) {
$parcel$export(module.exports, "proactiveSupportDashboardRedirectEntryPoint", () => $9ab9bfdc5a01dece$export$636010e550853d19);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $9ab9bfdc5a01dece$export$636010e550853d19 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("7V6DM")), {
        moduleId: "a08c5e1d",
        moduleName: "ProactiveSupportDashboardRedirect",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {},
            extraProps: {}
        })
});

});
parcelRegister("7V6DM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e6lzd").then(()=>parcelRequire('21Qbt'));

});



parcelRegister("d5nAU", function(module, exports) {
$parcel$export(module.exports, "serviceDeskProductsRouteEntry", () => $0baf5ea733ac6eec$export$a422b7dc1738c58f);

var $euxye = parcelRequire("euxye");

var $aS3GY = parcelRequire("aS3GY");


var $a6AZh = parcelRequire("a6AZh");

var $5aglK = parcelRequire("5aglK");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7M6um = parcelRequire("7M6um");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0baf5ea733ac6eec$var$LazyServicedeskCustomerServiceProducts = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("4gepk"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-customer-service-products/src/ServicedeskCustomerServiceProducts.tsx"
});
const $0baf5ea733ac6eec$var$ServicedeskCustomerServiceProducts = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0baf5ea733ac6eec$var$LazyServicedeskCustomerServiceProducts,
        pageId: "spa-apps/servicedesk/customer-service-products",
        shouldShowSpinner: true
    });
$0baf5ea733ac6eec$var$ServicedeskCustomerServiceProducts.displayName = "ServicedeskCustomerServiceProducts";
const $0baf5ea733ac6eec$export$a422b7dc1738c58f = (0, $fdS54.createEntry)((0, $7M6um.serviceDeskProductsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $a6AZh.AsyncDirectoryNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $5aglK.customerServiceProductsQueryResource),
            (0, $aS3GY.csmCustomerContextTenantMigratedStatusResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: $0baf5ea733ac6eec$var$ServicedeskCustomerServiceProducts,
        perfMetricKey: 'jsm-customer-service-products-component-load',
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $0baf5ea733ac6eec$var$LazyServicedeskCustomerServiceProducts
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                teamName: 'boysenberry'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5aglK", function(module, exports) {
$parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", () => $49cd4106d5d781b8$export$9e59a0b3e9d74a99);
$parcel$export(module.exports, "customerServiceProductsQueryResource", () => $49cd4106d5d781b8$export$f9257217f5333b1a);

var $dtOpE = parcelRequire("dtOpE");

var $htsFl = parcelRequire("htsFl");
const $49cd4106d5d781b8$export$9e59a0b3e9d74a99 = 50;
const $49cd4106d5d781b8$export$f9257217f5333b1a = (0, $htsFl.createRelayResource)({
    type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $dtOpE.default),
            variables: {
                cloudId: tenantContext.cloudId,
                first: $49cd4106d5d781b8$export$9e59a0b3e9d74a99
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("dtOpE", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0e8073987a8cd3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c99679a59a97b69d16256343614b5c47>>
 * @relayHash 2f2525f72b335b5d911e7fb1e6f7b2df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6

var $lIGkE = parcelRequire("lIGkE");
const $f0e8073987a8cd3f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProductsAppQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ProductsPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProductsAppQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "entitlementsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "customerServiceProducts_productConnections",
                            "kind": "LinkedHandle",
                            "name": "productConnections"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6",
            "metadata": {},
            "name": "ProductsAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f0e8073987a8cd3f$var$node.hash = "49ec283be936d856f639396ab852c52d";
(0, $lIGkE.PreloadableQueryRegistry).set($f0e8073987a8cd3f$var$node.params.id, $f0e8073987a8cd3f$var$node);
var $f0e8073987a8cd3f$export$2e2bcd8739ae039 = $f0e8073987a8cd3f$var$node;

});


parcelRegister("7M6um", function(module, exports) {
$parcel$export(module.exports, "serviceDeskProductsRoute", () => $22ffc5a60aa76ec1$export$bd8225ca9fa6533b);
const $22ffc5a60aa76ec1$export$bd8225ca9fa6533b = {
    name: 'servicedesk-customer-service-products',
    path: '/jira/servicedesk/projects/:projectKey/products',
    exact: true
};

});

parcelRegister("4gepk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("l14Gt")
]).then(()=>parcelRequire('2gFsS'));

});


parcelRegister("aXFPR", function(module, exports) {
$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRouteEntry", () => $2ad020657f114f05$export$2792607788ca81db);

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $edf7u = parcelRequire("edf7u");

var $kSpPQ = parcelRequire("kSpPQ");

var $ixLW7 = parcelRequire("ixLW7");
const $2ad020657f114f05$export$2792607788ca81db = (0, $fdS54.createEntry)((0, $kSpPQ.servicedeskProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $edf7u.projectContextResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ixLW7.default),
        forPaint: [
            (0, $ixLW7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kSpPQ", function(module, exports) {
$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRoute", () => $41780491d7928fce$export$bf24763c9fc04bde);
const $41780491d7928fce$export$bf24763c9fc04bde = {
    name: 'servicedesk-proforma-issue-forms-direct-embed',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("ichNm", function(module, exports) {
$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRouteEntry", () => $aee0adf3a2ac56cf$export$f249c6e19ad4181e);


var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $edf7u = parcelRequire("edf7u");

var $hmUHW = parcelRequire("hmUHW");

var $74h93 = parcelRequire("74h93");

var $gXJFZ = parcelRequire("gXJFZ");
const $aee0adf3a2ac56cf$export$f249c6e19ad4181e = (0, $fdS54.createEntry)((0, $hmUHW.servicedeskProformaIssueFormsDirectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $edf7u.projectContextResource)
        ],
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        entryPoint: ()=>(0, $gXJFZ.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hmUHW", function(module, exports) {
$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRoute", () => $c59950e5c26ca90d$export$9b51b0994bb4b8f0);
const $c59950e5c26ca90d$export$9b51b0994bb4b8f0 = {
    name: 'servicedesk-proforma-issue-forms-direct',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("2ZddW", function(module, exports) {
$parcel$export(module.exports, "servicedeskProjectSummaryRouteEntry", () => $5ecbf19b3327b856$export$a24d68fcf82b16bb);


var $8I3dm = parcelRequire("8I3dm");

var $6RSCO = parcelRequire("6RSCO");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $5AkNL = parcelRequire("5AkNL");

var $74h93 = parcelRequire("74h93");

var $8HUuJ = parcelRequire("8HUuJ");

var $6pofw = parcelRequire("6pofw");

var $lyJy6 = parcelRequire("lyJy6");

var $bzsNe = parcelRequire("bzsNe");

var $ilvEm = parcelRequire("ilvEm");

var $6eGtV = parcelRequire("6eGtV");

var $5JmxC = parcelRequire("5JmxC");

var $f8ObX = parcelRequire("f8ObX");

var $kFJGp = parcelRequire("kFJGp");

var $hud1Q = parcelRequire("hud1Q");
const $5ecbf19b3327b856$export$a24d68fcf82b16bb = (0, $fdS54.createEntry)((0, $5AkNL.servicedeskProjectSummaryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.project-summary',
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>null,
        skeleton: (0, $6eGtV.ProjectSummarySkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jsm_project_summary_avp') && (0, $i860n.fg)('jsm_project_summary_avp_m1') ? (0, $8I3dm.AsyncJSMProjectSummaryHorizontalNav) : undefined
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jsm_project_summary_avp'), (0, $5JmxC.getProjectSummaryFilterFieldsResource)()),
            (0, $8HUuJ.resourceWithCondition)(()=>!false && (0, $i860n.fg)('jsm_project_summary_avp'), (0, $f8ObX.summaryPageViewsResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_summary_page_is_reporting_enabled'), (0, $kFJGp.summaryPageConfigResource)),
            // TODO: AVP route resources here
            (0, $lyJy6.capabilitiesConfigResource),
            (0, $ilvEm.jsmSummarySemanticModelResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('platform_avp_dashboard-resource_jsm-proj-sum'), (0, $8HUuJ.safeCloneResource)((0, $bzsNe.dashboardConfigResource), {
                depends: [
                    (0, $f8ObX.SUMMARY_PAGE_VIEWS_RESOURCE_KEY)
                ]
            }))
        ],
        entryPoint: ()=>(0, $hud1Q.projectSummaryPageEntryPoint),
        meta: {
            reporting: {
                id: 'project-summary',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).PROJECT_SUMMARY),
                teamName: 'jsd-shield'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8I3dm", function(module, exports) {
$parcel$export(module.exports, "AsyncJSMProjectSummaryHorizontalNav", () => $5597fa2534305d63$export$8430ca2fced69261);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $kFJGp = parcelRequire("kFJGp");

var $2D2gW = parcelRequire("2D2gW");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $edCuj = parcelRequire("edCuj");

var $4dJtO = parcelRequire("4dJtO");

var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");


const $5597fa2534305d63$var$LazyJSMProjectSummaryHorizontalNav = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("kwptS")).then(({ JSMProjectSummaryHorizontalNav: JSMProjectSummaryHorizontalNav })=>JSMProjectSummaryHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jsm-project-summary/src/ui/index.tsx"
});
const $5597fa2534305d63$var$AsyncJSMProjectSummaryHorizontalNavContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "project-summary-horizontal-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "asyncHorizontalProjectSummaryNav",
        packageName: (0, $604134e936b25094$export$b8b9d90f9e5bd72b),
        fallback: "flag",
        teamName: (0, $604134e936b25094$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5597fa2534305d63$var$LazyJSMProjectSummaryHorizontalNav, null)));
$5597fa2534305d63$var$AsyncJSMProjectSummaryHorizontalNavContent.displayName = "AsyncJSMProjectSummaryHorizontalNavContent";
const $5597fa2534305d63$var$JSMProjectSummaryHorizontalNavWithConfig = ()=>{
    const { loading: loading, isReportingEnabled: isReportingEnabled, isByokCustomer: isByokCustomer } = (0, $4dJtO.useSummaryPageConfigAndByokData)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "byok-or-reporting-config-loading-horizontal-nav",
        hold: loading
    });
    if (isByokCustomer || !isReportingEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5597fa2534305d63$var$AsyncJSMProjectSummaryHorizontalNavContent, null);
};
$5597fa2534305d63$var$JSMProjectSummaryHorizontalNavWithConfig.displayName = "JSMProjectSummaryHorizontalNavWithConfig";
const $5597fa2534305d63$var$ProjectSummaryHorizontalNav = ()=>{
    const { data: config, loading: loading } = (0, $kFJGp.useSummaryPageConfig)();
    const isNewExperienceFeatureEnabled = (0, $edCuj.useNewExperienceFeatureEnabled)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "reporting-config-loading-horizontal-nav",
        hold: loading
    });
    const showHorizontalNav = (0, $i860n.fg)('jsm_project_summary_toggle_experience') ? config?.isReportingEnabled && isNewExperienceFeatureEnabled : config?.isReportingEnabled;
    return showHorizontalNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5597fa2534305d63$var$AsyncJSMProjectSummaryHorizontalNavContent, null) : null;
};
$5597fa2534305d63$var$ProjectSummaryHorizontalNav.displayName = "ProjectSummaryHorizontalNav";
const $5597fa2534305d63$var$ProjectSummaryHorizontalNavWithByok = ()=>{
    if ((0, $i860n.fg)('jsm_project_summary_fe_ga_issues_fixes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5597fa2534305d63$var$JSMProjectSummaryHorizontalNavWithConfig, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5597fa2534305d63$var$AsyncJSMProjectSummaryHorizontalNavContent, null);
};
$5597fa2534305d63$var$ProjectSummaryHorizontalNavWithByok.displayName = "ProjectSummaryHorizontalNavWithByok";
const $5597fa2534305d63$export$8430ca2fced69261 = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('jsm_reporting_enable_byok_checks_summary_page'), $5597fa2534305d63$var$ProjectSummaryHorizontalNav, $5597fa2534305d63$var$ProjectSummaryHorizontalNavWithByok);

});
parcelRegister("kFJGp", function(module, exports) {
$parcel$export(module.exports, "summaryPageConfigResource", () => $4cbde9e8aaca6e91$export$cd6a12f4412cdbf2);
$parcel$export(module.exports, "useSummaryPageConfig", () => $4cbde9e8aaca6e91$export$f723736820cd1955);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $h2wCv = parcelRequire("h2wCv");
const $4cbde9e8aaca6e91$export$92d070a855155313 = 'SERVICE_DESK_PROJECT_SUMMARY_CONFIG';
const $4cbde9e8aaca6e91$export$cd6a12f4412cdbf2 = (0, $7edbf.createResource)({
    type: $4cbde9e8aaca6e91$export$92d070a855155313,
    getKey: ()=>$4cbde9e8aaca6e91$export$92d070a855155313,
    getData: async (_, { tenantContext: { activationId: workspaceId } })=>{
        if (!(0, $i860n.fg)('jsm_summary_page_is_reporting_enabled')) return {
            isReportingEnabled: true
        };
        const csrConfigApiTarget = (0, $i860n.fg)('jsm_project_summary_avp_m0_reporting_dev_endpoint') ? 'reporting-dev' : 'reporting';
        const csrConfigApiEndpoint = `/gateway/api/jsm/${csrConfigApiTarget}/jira/workspace/${workspaceId}/v1/config`;
        const url = false ? '/api/v1/config' : csrConfigApiEndpoint;
        return (0, $h2wCv.performGetRequest)(url, {
            headers: {
                'x-ssr-service-name': 'jsm-reporting',
                'atl-workspaceid': workspaceId,
                'atl-workspacetype': 'jira'
            }
        });
    },
    maxAge: 86400000
});
const $4cbde9e8aaca6e91$export$f723736820cd1955 = ()=>{
    return (0, $k6ufm.useResource)($4cbde9e8aaca6e91$export$cd6a12f4412cdbf2);
};

});

parcelRegister("edCuj", function(module, exports) {
$parcel$export(module.exports, "useNewExperienceFeatureEnabled", () => $f940224e0bfb1d4e$export$ed4f9697b0250bc4);

var $kYRzy = parcelRequire("kYRzy");

const $f940224e0bfb1d4e$export$ed4f9697b0250bc4 = ()=>{
    const features = (0, $kYRzy.default)();
    return features.data?.[0, $6a18985c64d19567$export$d797e2b2eea7f98c]?.status === (0, $6a18985c64d19567$export$e927a5d1b72f0b68);
};

});
parcelRegister("kYRzy", function(module, exports) {
$parcel$export(module.exports, "default", () => $230f49105318ac17$export$2e2bcd8739ae039);

var $lEPfS = parcelRequire("lEPfS");

var $k6ufm = parcelRequire("k6ufm");
const $230f49105318ac17$var$useServiceProjectFeatures = ()=>(0, $k6ufm.useResource)((0, $lEPfS.featuresResource));
var $230f49105318ac17$export$2e2bcd8739ae039 = $230f49105318ac17$var$useServiceProjectFeatures;

});


parcelRegister("4dJtO", function(module, exports) {
$parcel$export(module.exports, "useSummaryPageConfigAndByokData", () => $352b46281247ab6c$export$86be54c861ff95c9);
/* eslint-disable import/order */ 
var $eiIY9 = parcelRequire("eiIY9");

var $i860n = parcelRequire("i860n");

var $kFJGp = parcelRequire("kFJGp");
const $352b46281247ab6c$export$86be54c861ff95c9 = ()=>{
    const { data: config, loading: configLoading } = (0, $kFJGp.useSummaryPageConfig)();
    const { isByokCustomer: isByokCustomer, loading: byokLoading, error: byokError, data: byokData } = (0, $eiIY9.useByokComplianceSettingWithInitialisation)();
    const isByokFetchNotStarted = !byokLoading && !byokData && !byokError && (0, $i860n.fg)('audit-logs-byok-encrypted-data');
    const loading = configLoading || byokLoading || isByokFetchNotStarted;
    return {
        loading: loading,
        isByokCustomer: isByokCustomer,
        isReportingEnabled: config?.isReportingEnabled
    };
};

});
parcelRegister("eiIY9", function(module, exports) {
$parcel$export(module.exports, "useByokComplianceSettingData", () => $a67f73c5539423fe$export$1972fcad574711bc);
$parcel$export(module.exports, "useByokComplianceSettingWithInitialisation", () => $a67f73c5539423fe$export$fb68f4844474e7cb);

var $euxye = parcelRequire("euxye");

var $h2wCv = parcelRequire("h2wCv");

var $acwzf = parcelRequire("acwzf");
var $iQPOZ = parcelRequire("iQPOZ");

var $eijVy = parcelRequire("eijVy");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
const $a67f73c5539423fe$var$byokComplianceSettingEnabledSuccessTitle = (0, $7eNDO.defineMessage)({
    id: "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-title",
    defaultMessage: "HIPAA-compliant alert notifications turned on"
});
const $a67f73c5539423fe$var$byokComplianceSettingEnabledSuccessDescription = (0, $7eNDO.defineMessage)({
    id: "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-description",
    defaultMessage: "Let your team admins know about the recommended actions they can take."
});
const $a67f73c5539423fe$var$flagOk = (0, $7eNDO.defineMessage)({
    id: "products-jsm-compliance-main.services.byok-compliance-setting.flag-ok",
    defaultMessage: "Ok"
});
const $a67f73c5539423fe$var$flagLearnMore = (0, $7eNDO.defineMessage)({
    id: "products-jsm-compliance-main.services.byok-compliance-setting.flag-learn-more",
    defaultMessage: "Learn more"
});
const $a67f73c5539423fe$export$f907f15fb3e7d5a9 = (0, $acwzf.toFlagId)('byok-settings-enabled-success-flag-key');
const $a67f73c5539423fe$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/data-managed-with-byok-encryption/24h';
const $a67f73c5539423fe$var$actions = {
    fetchByokComplianceSetting: (cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            setState({
                ...state,
                loading: true
            });
            try {
                const { data: data } = await (0, $h2wCv.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`);
                setState({
                    ...state,
                    data: data,
                    loading: false,
                    error: undefined
                });
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        },
    updateByokComplianceSetting: (option, cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
            const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagsService)();
            setState({
                ...state,
                loading: true
            });
            try {
                await (0, $h2wCv.performPatchRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`, {
                    body: JSON.stringify({
                        ugcPrimaryLogEnabledForByok: option
                    })
                });
                if (option) showFlag({
                    id: $a67f73c5539423fe$export$f907f15fb3e7d5a9,
                    title: $a67f73c5539423fe$var$byokComplianceSettingEnabledSuccessTitle,
                    type: 'success',
                    description: $a67f73c5539423fe$var$byokComplianceSettingEnabledSuccessDescription,
                    messageId: 'products-jsm-compliance.show-flag.success.byok-compliance-setting',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: $a67f73c5539423fe$var$flagOk,
                            onClick: ()=>{
                                dismissFlag($a67f73c5539423fe$export$f907f15fb3e7d5a9);
                            }
                        },
                        {
                            content: $a67f73c5539423fe$var$flagLearnMore,
                            href: $a67f73c5539423fe$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK,
                            target: '_blank'
                        }
                    ]
                });
                setState({
                    ...state,
                    data: {
                        byokCustomer: state.data?.byokCustomer ?? false,
                        ugcPrimaryLogEnabledForByok: option
                    },
                    loading: false,
                    error: undefined
                });
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        }
};
const $a67f73c5539423fe$var$Store = (0, $5QDqc.createStore)({
    initialState: {
        data: null,
        loading: false,
        error: undefined
    },
    actions: $a67f73c5539423fe$var$actions,
    name: 'BYOKComplianceSetting'
});
const $a67f73c5539423fe$export$1972fcad574711bc = (0, $3h1FP.createHook)($a67f73c5539423fe$var$Store);
const $a67f73c5539423fe$export$fb68f4844474e7cb = ()=>{
    const [ByokComplianceSettingState, { fetchByokComplianceSetting: fetchByokComplianceSetting, updateByokComplianceSetting: updateByokComplianceSetting }] = $a67f73c5539423fe$export$1972fcad574711bc();
    const { cloudId: cloudId } = (0, $eijVy.useTenantContext)();
    (0, $euxye.useEffect)(()=>{
        if (!ByokComplianceSettingState.data && (0, $i860n.fg)('audit-logs-byok-encrypted-data')) fetchByokComplianceSetting(cloudId);
    }, [
        ByokComplianceSettingState.data,
        cloudId,
        fetchByokComplianceSetting
    ]);
    return {
        loading: ByokComplianceSettingState.loading,
        error: ByokComplianceSettingState.error,
        data: ByokComplianceSettingState.data,
        isByokComplianceSettingEnabled: ByokComplianceSettingState.data?.ugcPrimaryLogEnabledForByok ?? false,
        isByokCustomer: ByokComplianceSettingState.data?.byokCustomer ?? false,
        enableSetting: ()=>updateByokComplianceSetting(true, cloudId),
        disableSetting: ()=>updateByokComplianceSetting(false, cloudId)
    };
};

});


/* eslint-disable jira/filename-case */ const $604134e936b25094$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsHorizontalNavJsmProjectSummary';
const $604134e936b25094$export$d57b6b390e78d90f = 'jsd-shield';

parcelRegister("kwptS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("U9tRU")
]).then(()=>parcelRequire('8FnGY'));

});


parcelRegister("5AkNL", function(module, exports) {
$parcel$export(module.exports, "servicedeskProjectSummaryRoute", () => $fa5dc56b56b35295$export$a23b752ff24027ae);
const $fa5dc56b56b35295$export$a23b752ff24027ae = {
    path: '/jira/servicedesk/projects/:projectKey/summary/:dashboardId?',
    name: 'servicedesk-project-summary'
};

});

parcelRegister("lyJy6", function(module, exports) {
$parcel$export(module.exports, "capabilitiesConfigResource", () => $9899996e44a1ccaf$export$11d144320844b89f);
$parcel$export(module.exports, "useCapabilitiesConfig", () => $9899996e44a1ccaf$export$d8a72c257bf0289e);

var $i860n = parcelRequire("i860n");

var $bdEst = parcelRequire("bdEst");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $l9uGd = parcelRequire("l9uGd");
const $9899996e44a1ccaf$var$RESOURCE_TYPE_AVP_CAPABILITY_CONFIG = 'AVP_CAPABILITY_CONFIG';
const $9899996e44a1ccaf$export$11d144320844b89f = (0, $7edbf.createResource)({
    type: $9899996e44a1ccaf$var$RESOURCE_TYPE_AVP_CAPABILITY_CONFIG,
    getKey: (_, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        return activationId && cloudId ? JSON.stringify({
            activationId: activationId,
            cloudId: cloudId
        }) : '-none-';
    },
    isBrowserOnly: true,
    getData: async (_, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const __startTime = (0, $i860n.fg)('platform_avp_custom-fetch-spans_dashboard') ? performance.now() : null;
        try {
            if (!activationId) throw new Error('Route config is missing activation ID');
            if (!cloudId) throw new Error('Route config is missing cloud ID');
            const data = await (0, $l9uGd.fetchAvpPermissionsGetCapabilities)(activationId, cloudId);
            return __startTime ? {
                ...data,
                __metadata: {
                    startTime: __startTime,
                    endTime: performance.now()
                }
            } : data;
        } catch (error) {
            throw (0, $bdEst.createResourceError)({
                component: 'spa.view.routes.viz-platform.getData',
                message: 'Error fetching capabilities',
                name: 'ResourceError'
            }, error);
        }
    },
    maxAge: 60000
});
const $9899996e44a1ccaf$export$d8a72c257bf0289e = ()=>(0, $k6ufm.useResource)($9899996e44a1ccaf$export$11d144320844b89f);

});
parcelRegister("l9uGd", function(module, exports) {
$parcel$export(module.exports, "fetchAvpPermissionsGetCapabilities", () => $65135056e9793df3$export$e1afa49181c8c67e);

var $fDVI0 = parcelRequire("fDVI0");

var $i860n = parcelRequire("i860n");

var $2zU0a = parcelRequire("2zU0a");
const $65135056e9793df3$var$CAPABILITIES_QUERY_OLD = `
	query avpPermissions_getCapabilities($cloudId: ID!) {
		avpPermissions_getCapabilities(
			input: {
				cloudId: $cloudId
				capabilityRequests: [
					{ capabilityId: "JsmMetrics" }
					{ capabilityId: "JiraMetrics" }
					{ capabilityId: "JiraMetricsAdvanced" }
					{ capabilityId: "JiraMetricsAdvanced2" }
					{ capabilityId: "MercuryMetrics" }
					{ capabilityId: "ChartUpdatedAtHistoryLength" }
				]
			}
		) @optIn(to: "AVPPermissions") {
			capabilities {
				capabilityId
				result {
					failureCode
					failureType
					hasAccess
					hasManage
					hasWrite
					productResults {
						productId
						result {
							failureCode
							failureType
							hasAccess
							hasManage
							hasWrite
							properties {
								key
								value {
									... on AVPPermissionsPropertyValueList {
										__typename
										values
									}
									... on AVPPermissionsPropertyValueString {
										value
									}
								}
							}
							reason
						}
					}
					properties {
						key
						value {
							... on AVPPermissionsPropertyValueList {
								__typename
								values
							}
							... on AVPPermissionsPropertyValueString {
								value
							}
						}
					}
					reason
				}
			}
		}
	}
`;
const $65135056e9793df3$var$CAPABILITIES_QUERY = `
	query avpPermissions_getCapabilities($cloudId: ID!, $workspaceAri: ID) {
		avpPermissions_getCapabilities(
			input: {
				cloudId: $cloudId
				workspaceAri: $workspaceAri
				capabilityRequests: [
					{ capabilityId: "JsmMetrics" }
					{ capabilityId: "JiraMetrics" }
					{ capabilityId: "JiraMetricsAdvanced" }
					{ capabilityId: "JiraMetricsAdvanced2" }
					{ capabilityId: "MercuryMetrics" }
					{ capabilityId: "ChartUpdatedAtHistoryLength" }
				]
			}
		) @optIn(to: "AVPPermissions") {
			capabilities {
				capabilityId
				result {
					failureCode
					failureType
					hasAccess
					hasManage
					hasWrite
					productResults {
						productId
						result {
							failureCode
							failureType
							hasAccess
							hasManage
							hasWrite
							properties {
								key
								value {
									... on AVPPermissionsPropertyValueList {
										__typename
										values
									}
									... on AVPPermissionsPropertyValueString {
										value
									}
								}
							}
							reason
						}
					}
					properties {
						key
						value {
							... on AVPPermissionsPropertyValueList {
								__typename
								values
							}
							... on AVPPermissionsPropertyValueString {
								value
							}
						}
					}
					reason
				}
			}
		}
	}
`;
async function $65135056e9793df3$export$e1afa49181c8c67e(activationId, cloudId) {
    const response = await fetch('/gateway/api/graphql', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'atl-attribution': JSON.stringify({
                atlWorkspaceId: activationId,
                tenantId: cloudId,
                businessUnit: 'Engineering-AVP',
                service: 'avp-chartio-castle',
                costCenter: '3408'
            }),
            'X-Query-Context': (0, $2zU0a.createAri)({
                resourceOwner: 'platform',
                resourceType: 'site',
                resourceId: cloudId
            })
        },
        credentials: 'include',
        body: (0, $i860n.fg)('platform_avp_capabilities_workspaceari') ? JSON.stringify({
            operationName: 'avpPermissions_getCapabilities',
            query: $65135056e9793df3$var$CAPABILITIES_QUERY,
            variables: {
                cloudId: cloudId,
                workspaceAri: (0, $fDVI0.JiraWorkspaceAri).create({
                    siteId: cloudId,
                    activationId: activationId
                }).toString()
            }
        }) : JSON.stringify({
            operationName: 'avpPermissions_getCapabilities',
            query: $65135056e9793df3$var$CAPABILITIES_QUERY_OLD,
            variables: {
                cloudId: cloudId
            }
        })
    });
    const json = await response.json();
    return json?.data?.avpPermissions_getCapabilities ?? {
        capabilities: []
    };
}

});


parcelRegister("bzsNe", function(module, exports) {
$parcel$export(module.exports, "dashboardConfigResource", () => $1bd0f064b87030fd$export$3095a8cfd2017615);
$parcel$export(module.exports, "useDashboardConfig", () => $1bd0f064b87030fd$export$f69a0df1904034e);

var $i860n = parcelRequire("i860n");

var $l8UJH = parcelRequire("l8UJH");

var $bdEst = parcelRequire("bdEst");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $1NQw8 = parcelRequire("1NQw8");
const $1bd0f064b87030fd$var$RESOURCE_TYPE_AVP_DASHBOARD_CONFIG = 'AVP_DASHBOARD_CONFIG';
const $1bd0f064b87030fd$var$getDashboardId = async ({ match: match, dependencies: dependencies })=>{
    const [dependencyKey] = Object.keys(dependencies);
    const paramId = match.params.dashboardId;
    if (paramId) return paramId;
    if (!dependencyKey) return null;
    const dependency = await (0, $l8UJH.consumeDependency)(dependencies, dependencyKey);
    return dependency?.dashboardId ?? null;
};
const $1bd0f064b87030fd$export$3095a8cfd2017615 = (0, $7edbf.createResource)({
    type: $1bd0f064b87030fd$var$RESOURCE_TYPE_AVP_DASHBOARD_CONFIG,
    getKey: ({ match: { params: params } }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>// dashboardId is a dependent resource and we don't want to have to know its key
        // so unfortunately we need to just take all the params and dilute the resource cache
        JSON.stringify({
            ...params,
            activationId: activationId,
            cloudId: cloudId
        }),
    isBrowserOnly: true,
    getData: async (routerContext, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const __startTime = (0, $i860n.fg)('platform_avp_custom-fetch-spans_dashboard') ? performance.now() : null;
        try {
            if (!activationId) throw new Error('Route config is missing activation ID');
            if (!cloudId) throw new Error('Route config is missing cloud ID');
            const dashboardId = await $1bd0f064b87030fd$var$getDashboardId(routerContext);
            if (!dashboardId) // legal edge case given the dashboard is not created until first visit
            return null;
            const data = await (0, $1NQw8.fetchAvpDashboard)(activationId, cloudId, dashboardId);
            return __startTime && data ? {
                ...data,
                __metadata: {
                    startTime: __startTime,
                    endTime: performance.now()
                }
            } : data;
        } catch (error) {
            throw (0, $bdEst.createResourceError)({
                component: 'spa.view.routes.viz-platform.getData',
                message: 'Error fetching dashboard',
                name: 'ResourceError'
            }, error);
        }
    },
    maxAge: 60000
});
const $1bd0f064b87030fd$export$f69a0df1904034e = ()=>(0, $k6ufm.useResource)($1bd0f064b87030fd$export$3095a8cfd2017615);

});
parcelRegister("1NQw8", function(module, exports) {
$parcel$export(module.exports, "fetchAvpDashboard", () => $51b18660bc525d46$export$273f7ada777ea5a7);
// eslint-disable-next-line jira/import-whitelist

var $2zU0a = parcelRequire("2zU0a");

var $cSm0W = parcelRequire("cSm0W");

var $i860n = parcelRequire("i860n");
/**
 * ⚠️⚠️⚠️ DUPLICATED FROM AVP ⚠️⚠️⚠️
 * Mirrored from: `avp/packages/common/api/src/graphql/queries/{dashboard,fragments}.ts`
 * (`getDashboardQueryWithPipeline` + the chart/canvas-layout/env-var fragments it
 * depends on, using the rendering pipeline variant).
 *
 * ⚠️ Any change here MUST also land in the AVP copy to avoid divergence. ⚠️
 *
 * Reason for duplication:
 *   AVP query/fragment helpers cannot be imported safely into the Jira SPA. The
 *   only public entrypoint (`@atlassian/viz-platform-views`) is a single barrel
 *   `index.ts`; importing even one helper would add several MB to the Jira SPA
 *   bundle. This mirrors the existing approach in `fetchAvpSemanticModel.tsx` and
 *   `fetchAvpPermissionsGetCapabilities.tsx`.
 *
 * Queries are composed (via plain template interpolation, mirroring the AVP
 * source) from shared fragment constants and selected by the same AVP runtime
 * gates: filters-v2 for JSM summary (`platform_avp_enable_filters_v2_jsm_summary`)
 * and the filter visibility field (`platform_avp_filter_visibility_fe`). This keeps
 * the prefetched query shape identical to what `DashboardEditable` requests on
 * normal load — otherwise the prefetched payload omits filters and the rendered
 * dashboard diverges.
 */ // Fragments shared by every dashboard query variant.
const $51b18660bc525d46$var$COMMON_FRAGMENTS = `
	fragment envVarFields on AVPEnvVar {
		id
		name
		chartId
		chartType
		dataType
		defaultValues
		hotTierFilterConfig {
			datasourceLocator {
				dstype
				workspaceId
			}
			product
			semanticModel
			dimension
		}
		operator
		metadata
	}

	fragment pipelineFields on AVPChartPipeline {
		id
		queries {
			id
			datasourceLocator {
				dstype
				workspaceId
			}
			metricsConfiguration {
				metrics
				dimensions {
					type
					name
				}
				filters {
					product
					dimension
					comparison
					operands
					withNullValue
				}
				jqlSource {
					type
					filterId
				}
			}
		}
	}

	fragment chartFields on AVPChart {
		id
		chartType
		chartLayout {
			x
			y
			z
			blocksWide
			blocksHigh
		}
		envVar {
			...envVarFields
		}
		templateChartId
		chartConfig {
			clientSettings {
				type
				options {
					name
					jsonValue
				}
			}
			settings {
				name
				jsonValue
			}
		}
	}

	fragment chartFieldsWithPipeline on AVPChart {
		...chartFields
		pipeline {
			...pipelineFields
		}
	}

	fragment canvasLayoutFields on AVPDashboardCanvasLayout {
		version
		rows {
			id
			height
			columns: elements {
				id
				span
				item {
					id
					template_chart_id: templateChartId
				}
			}
		}
		controlIds
	}
`;
// The `filterExpression` selection added to the dashboard body when filters-v2 is on.
const $51b18660bc525d46$var$FILTER_EXPRESSION_FIELD = `
			filterExpression @optIn(to: ["AVPFilterExpression"]) {
				...avpFilterGroupFields
			}`;
// Mirror of AVP `AVP_FILTER_GROUP_WITH_VISIBILITY_FRAGMENT` (filter fields use `visibility`).
// Inlined to avoid fragment cycles (gateway rejects recursive fragments); supports 3 nesting levels.
const $51b18660bc525d46$var$FILTER_FRAGMENTS_VISIBILITY = `
	fragment avpFilterGroupFields on AVPFilterGroup {
		id
		operator
		metadata
		groups {
			... on AVPFilterGroup {
				id
				operator
				metadata
				groups {
					... on AVPFilterGroup {
						id
						operator
						metadata
						groups {
							__typename
							... on AVPPlatformFilter {
								...avpPlatformFilterFields
							}
						}
					}
					... on AVPPlatformFilter {
						...avpPlatformFilterFields
					}
				}
			}
			... on AVPPlatformFilter {
				...avpPlatformFilterFields
			}
		}
	}

	fragment avpPlatformFilterFields on AVPPlatformFilter {
		id
		label
		comparison
		defaultValues
		visibility
		metadata
		dimensions {
			name
			product
			subProduct
			dynamicDimensionKey
			datasourceLocator {
				datasourceId
				dstype
				workspaceId
			}
		}
	}
`;
// Mirror of AVP `AVP_FILTER_GROUP_FRAGMENT` (filter fields use `isHidden`).
// Inlined to avoid fragment cycles (gateway rejects recursive fragments); supports 3 nesting levels.
const $51b18660bc525d46$var$FILTER_FRAGMENTS_HIDDEN = `
	fragment avpFilterGroupFields on AVPFilterGroup {
		id
		operator
		metadata
		groups {
			... on AVPFilterGroup {
				id
				operator
				metadata
				groups {
					... on AVPFilterGroup {
						id
						operator
						metadata
						groups {
							__typename
							... on AVPPlatformFilter {
								...avpPlatformFilterFields
							}
						}
					}
					... on AVPPlatformFilter {
						...avpPlatformFilterFields
					}
				}
			}
			... on AVPPlatformFilter {
				...avpPlatformFilterFields
			}
		}
	}

	fragment avpPlatformFilterFields on AVPPlatformFilter {
		id
		label
		comparison
		defaultValues
		isHidden
		metadata
		dimensions {
			name
			product
			subProduct
			dynamicDimensionKey
			datasourceLocator {
				datasourceId
				dstype
				workspaceId
			}
		}
	}
`;
// Composes a full dashboard query from the optional filter field + filter fragments.
const $51b18660bc525d46$var$dashboardQuery = (filterExpressionField, filterFragments)=>`
	query avp_getDashboard($dashboardAri: ID!) {
		avp_getDashboard(dashboardAri: $dashboardAri) {
			id
			title
			description
			category
			status
			access
			envVars {
				...envVarFields
			}${filterExpressionField}
			charts {
				...chartFieldsWithPipeline
			}
			settings {
				allowViewerRefresh
				allowTzOverride
				time_zone: timezone
				autoRefreshInterval
				refreshMethod
				cacheDuration
				autoApplyVars
				canvasLayout {
					...canvasLayoutFields
				}
			}
			is_readonly: isReadOnly
			fromTemplate
			templateVersion
		}
	}
${$51b18660bc525d46$var$COMMON_FRAGMENTS}${filterFragments}
`;
// Filters-v2 disabled: dashboard without the `filterExpression` field/fragments.
const $51b18660bc525d46$var$QUERY_WITHOUT_FILTERS = $51b18660bc525d46$var$dashboardQuery('', '');
// Filters-v2 enabled, `platform_avp_filter_visibility_fe` ON: filter fields use `visibility`.
const $51b18660bc525d46$var$QUERY_WITH_FILTERS_VISIBILITY = $51b18660bc525d46$var$dashboardQuery($51b18660bc525d46$var$FILTER_EXPRESSION_FIELD, $51b18660bc525d46$var$FILTER_FRAGMENTS_VISIBILITY);
// Filters-v2 enabled, `platform_avp_filter_visibility_fe` OFF: filter fields use `isHidden`.
const $51b18660bc525d46$var$QUERY_WITH_FILTERS_HIDDEN = $51b18660bc525d46$var$dashboardQuery($51b18660bc525d46$var$FILTER_EXPRESSION_FIELD, $51b18660bc525d46$var$FILTER_FRAGMENTS_HIDDEN);
// Selects the query matching the runtime gate state so the prefetched query shape
// matches what `DashboardEditable` requests on normal load.
const $51b18660bc525d46$var$getDashboardQuery = ()=>{
    if (!(0, $i860n.fg)('platform_avp_enable_filters_v2_jsm_summary')) return $51b18660bc525d46$var$QUERY_WITHOUT_FILTERS;
    if ((0, $i860n.fg)('platform_avp_filter_visibility_fe')) return $51b18660bc525d46$var$QUERY_WITH_FILTERS_VISIBILITY;
    return $51b18660bc525d46$var$QUERY_WITH_FILTERS_HIDDEN;
};
async function $51b18660bc525d46$export$273f7ada777ea5a7(activationId, cloudId, dashboardId) {
    const dashboardAri = (0, $cSm0W.AvpDashboardAri).create({
        siteId: cloudId,
        activationId: activationId,
        dashboardId: dashboardId
    }).toString();
    const response = await fetch('/gateway/api/graphql', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'atl-attribution': JSON.stringify({
                atlWorkspaceId: activationId,
                tenantId: cloudId,
                businessUnit: 'Engineering-AVP',
                service: 'avp-chartio-castle',
                costCenter: '3408'
            }),
            'X-Query-Context': (0, $2zU0a.createAri)({
                resourceOwner: 'platform',
                resourceType: 'site',
                resourceId: cloudId
            })
        },
        credentials: 'include',
        body: JSON.stringify({
            operationName: 'avp_getDashboard',
            query: $51b18660bc525d46$var$getDashboardQuery(),
            variables: {
                dashboardAri: dashboardAri
            }
        })
    });
    if (!response.ok) throw new Error(`fetchAvpDashboard failed: ${response.status}`);
    const json = await response.json();
    return json?.data?.avp_getDashboard ?? null;
}

});
parcelRegister("cSm0W", function(module, exports) {
$parcel$export(module.exports, "AvpDashboardAri", () => $95fb9aba408653be$export$4f332b50c12537eb);

var $dFeW3 = parcelRequire("dFeW3");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/avp/dashboard/manifest.ts
var $95fb9aba408653be$var$avpDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: "avp",
    resourceType: (0, $dFeW3.AvpDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/avp/dashboard/index.ts
var $95fb9aba408653be$export$4f332b50c12537eb = class _AvpDashboardAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $95fb9aba408653be$var$avpDashboardAriStaticOpts.qualifier,
            platformQualifier: $95fb9aba408653be$var$avpDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $95fb9aba408653be$var$avpDashboardAriStaticOpts.resourceOwner,
            resourceType: $95fb9aba408653be$var$avpDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $95fb9aba408653be$var$avpDashboardAriStaticOpts);
        return new _AvpDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $95fb9aba408653be$var$avpDashboardAriStaticOpts);
        return new _AvpDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("dFeW3", function(module, exports) {
$parcel$export(module.exports, "AvpDashboardAriResourceType", () => $029134656a20e5fd$export$fb6b42ce2aa2b8c9);
// src/avp/dashboard/types.ts
var $029134656a20e5fd$export$cab1e40024c8ea24 = "avp", $029134656a20e5fd$export$fb6b42ce2aa2b8c9 = "dashboard";

});




parcelRegister("ilvEm", function(module, exports) {
$parcel$export(module.exports, "jsmSummarySemanticModelResource", () => $a6ab2713793de1cb$export$49c1b9dd5c59d402);
$parcel$export(module.exports, "useJsmSummarySemanticModel", () => $a6ab2713793de1cb$export$b2f53e41108fad6e);

var $k6ufm = parcelRequire("k6ufm");

var $2yODD = parcelRequire("2yODD");
const $a6ab2713793de1cb$export$49c1b9dd5c59d402 = (0, $2yODD.createSemanticModelResource)({
    hostingProduct: 'jira',
    location: 'jsm-summary',
    products: [
        'jira'
    ],
    subProducts: [
        'jsm'
    ]
});
const $a6ab2713793de1cb$export$b2f53e41108fad6e = ()=>(0, $k6ufm.useResource)($a6ab2713793de1cb$export$49c1b9dd5c59d402);

});

parcelRegister("6eGtV", function(module, exports) {
$parcel$export(module.exports, "ProjectSummarySkeleton", () => $c01b6aacac324ae2$export$93a223cf4712c63d);

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $2D2gW = parcelRequire("2D2gW");

var $i860n = parcelRequire("i860n");

var $kq58F = parcelRequire("kq58F");
const $c01b6aacac324ae2$export$93a223cf4712c63d = ()=>{
    if ((0, $i860n.fg)('jsm_reporting_enable_byok_checks_summary_page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "summary-page-skeleton",
        hold: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kq58F)))
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kq58F)))
    });
};
$c01b6aacac324ae2$export$93a223cf4712c63d.displayName = "ProjectSummarySkeleton";

});
parcelRegister("kq58F", function(module, exports) {
module.exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();

});


parcelRegister("5JmxC", function(module, exports) {
$parcel$export(module.exports, "getProjectSummaryFilterFieldsResource", () => $99b76c72c57becb3$export$efafab65f8d3c3b6);
$parcel$export(module.exports, "useGetProjectSummaryFilterFields", () => $99b76c72c57becb3$export$e6baafb2e3d74187);
$parcel$export(module.exports, "useRequestTypeJqlTerm", () => $99b76c72c57becb3$export$1bb1552d41afd41f);

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $i0CFV = parcelRequire("i0CFV");

var $lCetP = parcelRequire("lCetP");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $99b76c72c57becb3$var$PACKAGE_NAME = 'jiraRouterResourcesServicedeskProjectSummary';
const $99b76c72c57becb3$var$TEAM_NAME = 'jsd-shield';
const $99b76c72c57becb3$var$RESOURCE_NAME = 'projectSummaryFilterFieldResource';
const $99b76c72c57becb3$export$6f0555de4f60e84e = 'RESOURCE_TYPE_JSM_PROJECT_SUMMARY_FILTERS';
// oxlint-disable-next-line typescript/consistent-type-assertions
const $99b76c72c57becb3$var$createdField = {
    displayName: 'Created',
    fieldType: 'created',
    jqlTerm: 'created',
    operators: [
        'LESS_THAN_OR_EQUAL',
        'GREATER_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'LESS_THAN',
        'GREATER_THAN',
        'EQUALS',
        'IS',
        'IN',
        'NOT_EQUALS'
    ],
    searchTemplate: 'created',
    type: 'created'
};
// oxlint-disable-next-line typescript/consistent-type-assertions
const $99b76c72c57becb3$var$priorityField = {
    displayName: 'Priority',
    fieldType: 'priority',
    jqlTerm: 'priority',
    operators: [
        'GREATER_THAN_OR_EQUAL',
        'LESS_THAN',
        'GREATER_THAN',
        'WAS_NOT',
        'IS',
        'IN',
        'CHANGED',
        'LESS_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'WAS_NOT_IN',
        'EQUALS',
        'WAS_IN',
        'WAS',
        'NOT_EQUALS'
    ],
    searchTemplate: 'priority',
    type: 'priority'
};
const $99b76c72c57becb3$var$reportError = ({ error: error, id: id })=>(0, $hFtK7.fireErrorAnalytics)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: id ? `${$99b76c72c57becb3$var$RESOURCE_NAME}.${id}` : $99b76c72c57becb3$var$RESOURCE_NAME,
            packageName: $99b76c72c57becb3$var$PACKAGE_NAME,
            teamName: $99b76c72c57becb3$var$TEAM_NAME
        }
    });
const $99b76c72c57becb3$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $8d6deda7fc9e58aa$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return {
            requestTypeField: undefined
        };
        return {
            requestTypeField: {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate?.key,
                fieldType: requestTypeField.type,
                displayName: requestTypeField.displayName
            }
        };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $lCetP.isHttpClientErrorResponse)(error)) $99b76c72c57becb3$var$reportError({
            error: error,
            id: 'fetchFields'
        });
        return {
            requestTypeField: undefined
        };
    }
};
const $99b76c72c57becb3$var$getProjectKeyOrId = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $99b76c72c57becb3$var$filterFieldsResource = (0, $7edbf.createResource)({
    type: $99b76c72c57becb3$export$6f0555de4f60e84e,
    getKey: ({ match: match, query: query })=>(0, $i860n.fg)('jsm_project_summary_filter_resource_cloud_scoped_cache_key') ? $99b76c72c57becb3$export$6f0555de4f60e84e : $99b76c72c57becb3$export$6f0555de4f60e84e + $99b76c72c57becb3$var$getProjectKeyOrId(match, query),
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$99b76c72c57becb3$var$fetchFilterFields(cloudId),
    maxAge: Infinity
});
const $99b76c72c57becb3$export$efafab65f8d3c3b6 = ()=>$99b76c72c57becb3$var$filterFieldsResource;
const $99b76c72c57becb3$export$e6baafb2e3d74187 = ()=>{
    const { data: filterResource } = (0, $k6ufm.useResource)($99b76c72c57becb3$var$filterFieldsResource);
    const useFilterFields = (0, $euxye.useMemo)(()=>({ requestTypeField: requestTypeField = filterResource?.requestTypeField, requestTypeDisplayName: requestTypeDisplayName, priorityDisplayName: priorityDisplayName, createdDisplayName: createdDisplayName })=>{
            return [
                ...requestTypeField ? [
                    {
                        ...requestTypeField,
                        ...requestTypeDisplayName && {
                            displayName: requestTypeDisplayName
                        }
                    }
                ] : [],
                'status',
                'assignee',
                {
                    ...$99b76c72c57becb3$var$priorityField,
                    ...priorityDisplayName && {
                        displayName: priorityDisplayName
                    }
                },
                {
                    ...$99b76c72c57becb3$var$createdField,
                    ...createdDisplayName && {
                        displayName: createdDisplayName
                    }
                }
            ];
        }, [
        filterResource
    ]);
    return useFilterFields;
};
const $99b76c72c57becb3$export$1bb1552d41afd41f = ({ jqlTerm: jqlTerm })=>{
    const { data: filterResource, loading: loading } = (0, $k6ufm.useResource)($99b76c72c57becb3$var$filterFieldsResource);
    const term = jqlTerm ?? filterResource?.requestTypeField?.jqlTerm;
    const hasError = !loading && !term;
    (0, $euxye.useEffect)(()=>{
        if (hasError) $99b76c72c57becb3$var$reportError({
            error: new Error('Error while getting request type jql term.'),
            id: 'rtJqlTerm'
        });
    }, [
        hasError
    ]);
    return term;
};

});
/* eslint-disable jira/filename-case */ const $8d6deda7fc9e58aa$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;


parcelRegister("f8ObX", function(module, exports) {
$parcel$export(module.exports, "SUMMARY_PAGE_VIEWS_RESOURCE_KEY", () => $5212649c24229147$export$42b614996cb2ce11);
$parcel$export(module.exports, "summaryPageViewsResource", () => $5212649c24229147$export$ff1d54b75c7d6959);

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");

var $i860n = parcelRequire("i860n");
const $5212649c24229147$export$42b614996cb2ce11 = 'SERVICE_DESK_PROJECT_SUMMARY_VIEWS';
const $5212649c24229147$export$ff1d54b75c7d6959 = (0, $7edbf.createResource)({
    type: $5212649c24229147$export$42b614996cb2ce11,
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        return `${$5212649c24229147$export$42b614996cb2ce11}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { activationId: workspaceId } })=>{
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        const response = await ((0, $i860n.fg)('jsm_project_summary_avp_m0_reporting_dev_endpoint') ? (0, $h2wCv.performGetRequest)(`/gateway/api/jsm/reporting-dev/jira/workspace/${workspaceId}/project/${projectKey}/v1/views`) : (0, $h2wCv.performGetRequest)(`/gateway/api/jsm/reporting/jira/workspace/${workspaceId}/project/${projectKey}/v1/views`));
        const dashboardId = (0, $i860n.fg)('platform_avp_dashboard-resource_jsm-proj-sum') ? response.views.find(({ type: type })=>type === 'DEFAULT')?.dashboardId ?? null : null;
        return response ? {
            ...response,
            dashboardId: dashboardId
        } : response;
    },
    maxAge: 300000
});

});

parcelRegister("hud1Q", function(module, exports) {
$parcel$export(module.exports, "projectSummaryPageEntryPoint", () => $b22ae6fa0dd012df$export$ae7c241893e7dab9);
/* eslint-disable jira/naming/disallow-filenames */ 
var $6nhO1 = parcelRequire("6nhO1");

var $dTa0V = parcelRequire("dTa0V");
const $b22ae6fa0dd012df$export$ae7c241893e7dab9 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6nhO1.projectSummaryEntryPoint)
});

});
parcelRegister("6nhO1", function(module, exports) {
$parcel$export(module.exports, "projectSummaryEntryPoint", () => $580cb931dbe430b6$export$95a2fe4e495efca5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $580cb931dbe430b6$export$95a2fe4e495efca5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("eSXAu")), {
        moduleId: "6bde31f7",
        moduleName: "ProjectSummaryLayout",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eSXAu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bEu3U")
]).then(()=>parcelRequire('2yMjQ'));

});




parcelRegister("g3Nmy", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesAddonRouteEntry", () => $a59f570541deff72$export$23a16f20b48235b3);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $3WElZ = parcelRequire("3WElZ");

var $74h93 = parcelRequire("74h93");

var $aHrDx = parcelRequire("aHrDx");
const $a59f570541deff72$export$23a16f20b48235b3 = (0, $fdS54.createEntry)((0, $3WElZ.servicedeskQueuesAddonRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aHrDx.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aHrDx.LazyServicedeskQueuesAddonView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3WElZ", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesAddonRoute", () => $728e38edc5a63cff$export$1465f05b88a63f13);
const $728e38edc5a63cff$export$1465f05b88a63f13 = {
    name: 'servicedesk-queues-addon',
    path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
    exact: true
};

});

parcelRegister("aHrDx", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesAddonView", () => $d26b515e4bf1d7c0$export$451a7cce84b6b1e6);
$parcel$export(module.exports, "default", () => $d26b515e4bf1d7c0$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $d26b515e4bf1d7c0$export$451a7cce84b6b1e6 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2fpBb")), {
    moduleId: "./src/packages/spa-apps/servicedesk-queues-addon-view/src/index.tsx"
});
const $d26b515e4bf1d7c0$var$AsyncServicedeskQueuesAddonView = ({ match: match })=>{
    const addonKey = match.params && match.params.addonKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $d26b515e4bf1d7c0$export$451a7cce84b6b1e6,
        pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
        shouldShowSpinner: true
    });
};
$d26b515e4bf1d7c0$var$AsyncServicedeskQueuesAddonView.displayName = "AsyncServicedeskQueuesAddonView";
var $d26b515e4bf1d7c0$export$2e2bcd8739ae039 = $d26b515e4bf1d7c0$var$AsyncServicedeskQueuesAddonView;

});
parcelRegister("2fpBb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4sfbv").then(()=>parcelRequire('6qCP2'));

});



parcelRegister("jLs9s", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesEditRouteEntry", () => $ddc28377c56247ae$export$ae7b71ac953d95bf);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $cpnl1 = parcelRequire("cpnl1");

var $c717Z = parcelRequire("c717Z");

var $74h93 = parcelRequire("74h93");

var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");

var $c87b6 = parcelRequire("c87b6");

var $5Er72 = parcelRequire("5Er72");

var $9QD8J = parcelRequire("9QD8J");
const $ddc28377c56247ae$export$ae7b71ac953d95bf = (0, $fdS54.createEntry)((0, $c717Z.servicedeskQueuesEditRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $5Er72.ServicedeskQueuesConfig), (0, $c87b6.default)),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            (0, $cpnl1.issueListSsrResource),
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $lbxXL.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $5Er72.LazyServicedeskQueuesConfig) : (0, $c87b6.LazyServicedeskQueuesEditView)
        ],
        ufoName: 'service-management.queues.edit',
        pageId: ({ query: query, match: match })=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9QD8J.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("c717Z", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesEditRoute", () => $4d6c4c218ab82fd0$export$f8fd3a1f8c33aff8);
const $4d6c4c218ab82fd0$export$f8fd3a1f8c33aff8 = {
    name: 'servicedesk-queues-edit',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});


parcelRegister("9neNF", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesIssueRouteEntry", () => $ca41d992f75e7e42$export$2e4931acac9270fc);
/* eslint-disable import/order */ 
var $51vnM = parcelRequire("51vnM");


var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $jfrQu = parcelRequire("jfrQu");

var $74h93 = parcelRequire("74h93");

var $9KYmb = parcelRequire("9KYmb");

var $730Ep = parcelRequire("730Ep");
const $ca41d992f75e7e42$export$2e4931acac9270fc = (0, $fdS54.createEntry)((0, $jfrQu.servicedeskQueuesIssueRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $730Ep.default),
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getKnowledgeBaseResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            ...(0, $9KYmb.getDraftReplyPillsResource)(),
            ...(0, $lbxXL.getIssueViewResources)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $730Ep.LazyServicedeskQueuesIssueView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jfrQu", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesIssueRoute", () => $1f38605deda21563$export$52a24b9cf42d208b);
const $1f38605deda21563$export$52a24b9cf42d208b = {
    name: 'servicedesk-queues-issue',
    path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
    exact: true
};

});


parcelRegister("7mDLx", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesLandingRouteEntry", () => $80b39812c1744dc2$export$4242a81237c45c7d);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $f9B4x = parcelRequire("f9B4x");

var $74h93 = parcelRequire("74h93");

var $269nT = parcelRequire("269nT");
const $80b39812c1744dc2$export$4242a81237c45c7d = (0, $fdS54.createEntry)((0, $f9B4x.servicedeskQueuesLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $269nT.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $269nT.LazyServicedeskQueuesLanding)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("f9B4x", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesLandingRoute", () => $059ca8b1eea05941$export$52b4c044e4929ebc);
const $059ca8b1eea05941$export$52b4c044e4929ebc = {
    name: 'servicedesk-queues-landing',
    // Supporting optional /default for legacy backwards compatability
    path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
    exact: true
};

});


parcelRegister("oULj4", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesManageViewRouteEntry", () => $bc6e61dd2e4cdae0$export$7e9e2984a94a07b0);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7Xo5b = parcelRequire("7Xo5b");

var $74h93 = parcelRequire("74h93");

var $i860n = parcelRequire("i860n");

var $dPHxc = parcelRequire("dPHxc");
const $bc6e61dd2e4cdae0$var$getNavigationSpecifications = ()=>{
    return (0, $i860n.fg)('jsm_manage_queues_in_space_settings') && {
        sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
    };
};
const $bc6e61dd2e4cdae0$export$7e9e2984a94a07b0 = (0, $fdS54.createEntry)((0, $7Xo5b.servicedeskQueuesManageViewRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dPHxc.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            ...$bc6e61dd2e4cdae0$var$getNavigationSpecifications()
        },
        resources: (0, $i860n.fg)('jsm_manage_queues_in_space_settings') ? [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            ...(0, $lbxXL.getQueuesResources)()
        ] : (0, $lbxXL.getQueuesResources)(),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dPHxc.LazyServicedeskQueuesManageView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});

parcelRegister("52pe0", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesNewRouteEntry", () => $6cd8dbb14d654308$export$9f7cc3294b3141b1);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $cQiu6 = parcelRequire("cQiu6");

var $74h93 = parcelRequire("74h93");

var $2qLmV = parcelRequire("2qLmV");
const $6cd8dbb14d654308$export$9f7cc3294b3141b1 = (0, $fdS54.createEntry)((0, $cQiu6.servicedeskQueuesNewRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $2qLmV.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $2qLmV.LazyServicedeskQueuesCreateView)
        ],
        ufoName: 'service-management.queues.new',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cQiu6", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesNewRoute", () => $0df196ae63263b4b$export$c1908994722d1e73);
const $0df196ae63263b4b$export$c1908994722d1e73 = {
    name: 'servicedesk-queues-new',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});


parcelRegister("hsPLz", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesViewsConfigRouteEntry", () => $4eb7dd2aa5865226$export$a5000d326f347afb);


var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $hRSPo = parcelRequire("hRSPo");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $bzmjU = parcelRequire("bzmjU");

var $74h93 = parcelRequire("74h93");

var $edf7u = parcelRequire("edf7u");

var $i860n = parcelRequire("i860n");

var $jEYuY = parcelRequire("jEYuY");

var $aWliK = parcelRequire("aWliK");

var $9QD8J = parcelRequire("9QD8J");

var $jt2fv = parcelRequire("jt2fv");
const $4eb7dd2aa5865226$export$a5000d326f347afb = (0, $fdS54.createEntry)((0, $bzmjU.servicedeskQueuesViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getQueuesResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            ...(0, $lbxXL.getQueueViewConfigResource)(),
            (0, $hRSPo.getEditModelResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jt2fv.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $jt2fv.ServicedeskQueuesViewsConfig), (0, $lFLfF.default)),
        pageId: ({ query: query, match: match })=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9QD8J.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bzmjU", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesViewsConfigRoute", () => $29cce2358947330b$export$eea17b09d67a7980);
const $29cce2358947330b$export$eea17b09d67a7980 = {
    name: 'servicedesk-queues-views-config',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit/:boardId',
    query: [
        'config?'
    ],
    exact: true
};

});


parcelRegister("kega6", function(module, exports) {
$parcel$export(module.exports, "servicedeskRcaInvestigationRouteEntry", () => $d07d8a64e12d9b4a$export$e698401f2ffa00ff);
/* eslint-disable import/order */ 
var $goerq = parcelRequire("goerq");

var $3cN6Q = parcelRequire("3cN6Q");

var $kDKbu = parcelRequire("kDKbu");

var $hp0XY = parcelRequire("hp0XY");

var $5klKQ = parcelRequire("5klKQ");


var $iSoIx = parcelRequire("iSoIx");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");
const $d07d8a64e12d9b4a$var$rcaInvestigationRoutePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $goerq.rcaInvestigationPageEntryPoint)
});
const $d07d8a64e12d9b4a$export$e698401f2ffa00ff = (0, $fdS54.createEntry)((0, $5klKQ.servicedeskRcaInvestigationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        ufoName: (0, $3cN6Q.investigationPageLoadUfo).experienceName,
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        skeleton: (0, $kDKbu.RcaInvestigationPageSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            ...(0, $lbxXL.getInsightResources)(),
            (0, $hp0XY.rcaInvestigationResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('aiops_rca_v2_ui') ? $d07d8a64e12d9b4a$var$rcaInvestigationRoutePageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("goerq", function(module, exports) {
$parcel$export(module.exports, "rcaInvestigationPageEntryPoint", () => $b21062aacc49d353$export$86dbc277833a8b0);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $b21062aacc49d353$export$86dbc277833a8b0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("1ufVg")), {
        moduleId: "5a73e7b1",
        moduleName: "RcaInvestigationPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1ufVg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("iKk9l")
]).then(()=>parcelRequire('4hgND'));

});


parcelRegister("3cN6Q", function(module, exports) {
$parcel$export(module.exports, "investigationPageLoadUfo", () => $cdd0ec130634413b$export$f2e7dfdce7bcd03b);
const $cdd0ec130634413b$export$f2e7dfdce7bcd03b = {
    experienceName: 'jsm.rca-investigation',
    customDataPhases: {
        inProgress: {
            rcaInvestigationPhase: 'IN_PROGRESS'
        },
        completed: {
            rcaInvestigationPhase: 'COMPLETED'
        },
        noRootCauseFound: {
            rcaInvestigationPhase: 'NO_ROOT_CAUSE_FOUND'
        },
        terminated: {
            rcaInvestigationPhase: 'TERMINATED'
        }
    }
};

});

parcelRegister("kDKbu", function(module, exports) {
$parcel$export(module.exports, "RcaInvestigationPageSkeleton", () => $887e63d7098a4fdc$export$94aaefe8c923e69a);
$parcel$export(module.exports, "PageFallback", () => $887e63d7098a4fdc$export$f2459ef7d14935ba);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $ihEDU = parcelRequire("ihEDU");

var $defJG = parcelRequire("defJG");

var $3PC9r = parcelRequire("3PC9r");

var $2D2gW = parcelRequire("2D2gW");

var $d7U1K = parcelRequire("d7U1K");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $iK8G7 = parcelRequire("iK8G7");

var $75sVW = parcelRequire("75sVW");

var $651gg = parcelRequire("651gg");

var $3cN6Q = parcelRequire("3cN6Q");

var $PdWnG = parcelRequire("PdWnG");
const $887e63d7098a4fdc$var$errorHeader = (0, $7eNDO.defineMessage)({
    id: "servicedesk.rca-investigation.error-header.no-translate",
    defaultMessage: "We couldn't load the investigation"
});
const $887e63d7098a4fdc$var$errorDescription = (0, $7eNDO.defineMessage)({
    id: "servicedesk.rca-investigation.error-description.no-translate",
    defaultMessage: "Something went wrong. Give it a few seconds, then try again."
});
const $887e63d7098a4fdc$var$DEFAULT_AI_ERROR_MESSAGE = 'Investigation could not be loaded';
const $887e63d7098a4fdc$var$ErrorPage = (t0)=>{
    const $ = (0, $e7boj.c)(15);
    const { onRefresh: onRefresh, error: error } = t0;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { trackAIResultError: trackAIResultError } = (0, $iK8G7.useAIEventsInstrumentation)();
    let t1;
    let t2;
    if ($[0] !== error || $[1] !== trackAIResultError) {
        t1 = ()=>{
            const aiErrorMessage = error instanceof Error ? error.message : $887e63d7098a4fdc$var$DEFAULT_AI_ERROR_MESSAGE;
            const aiErrorCode = error instanceof (0, $75sVW.default) ? error.statusCode : undefined;
            trackAIResultError({
                aiErrorCode: aiErrorCode,
                aiErrorMessage: aiErrorMessage
            });
        };
        t2 = [
            error,
            trackAIResultError
        ];
        $[0] = error;
        $[1] = trackAIResultError;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $euxye.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[4] !== error) {
        t3 = ()=>{
            if (error && error instanceof Error) (0, $d7U1K.setInteractionError)((0, $3cN6Q.investigationPageLoadUfo).experienceName, {
                name: error.name,
                errorMessage: error.message
            });
        };
        t4 = [
            error
        ];
        $[4] = error;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $euxye.useEffect)(t3, t4);
    let t5;
    if ($[7] !== formatMessage) {
        t5 = formatMessage($887e63d7098a4fdc$var$errorHeader);
        $[7] = formatMessage;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== formatMessage) {
        t6 = formatMessage($887e63d7098a4fdc$var$errorDescription);
        $[9] = formatMessage;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== onRefresh || $[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $651gg.default), {
            onRetry: onRefresh,
            header: t5,
            description: t6
        });
        $[11] = onRefresh;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
};
$887e63d7098a4fdc$var$ErrorPage.displayName = "ErrorPage";
const $887e63d7098a4fdc$var$loadingStyles = {
    root: "_18zr1ejb _1rjcpxbi",
    graphSkeleton: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _4t3i1yw0"
};
const $887e63d7098a4fdc$var$BasePageSkeleton = ()=>{
    const $ = (0, $e7boj.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "140px",
            height: "16px",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "280px",
            height: "28px",
            isShimmering: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "200px",
            height: "80px",
            borderRadius: "var(--ds-radius-large, 8px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "200px",
            height: "80px",
            borderRadius: "var(--ds-radius-large, 8px)",
            isShimmering: true
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "120px",
            height: "16px",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "100%",
            height: "48px",
            borderRadius: "var(--ds-radius-large, 8px)",
            isShimmering: true
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "160px",
            height: "16px",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "100%",
            height: "120px",
            borderRadius: "var(--ds-radius-large, 8px)",
            isShimmering: true
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
            name: "jsm.rca-investigation.page-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.300"
        }, t0, t1, t2, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "140px",
            height: "16px",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
            xcss: $887e63d7098a4fdc$var$loadingStyles.graphSkeleton
        }))));
        $[4] = t4;
    } else t4 = $[4];
    return t4;
};
$887e63d7098a4fdc$var$BasePageSkeleton.displayName = "BasePageSkeleton";
const $887e63d7098a4fdc$var$LoadingPage = ()=>{
    const $ = (0, $e7boj.c)(1);
    (0, $PdWnG.useTrackAIInteractionDismissOnTabClose)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($887e63d7098a4fdc$var$BasePageSkeleton, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$887e63d7098a4fdc$var$LoadingPage.displayName = "LoadingPage";
const $887e63d7098a4fdc$export$94aaefe8c923e69a = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
            xcss: $887e63d7098a4fdc$var$loadingStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($887e63d7098a4fdc$var$BasePageSkeleton, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$887e63d7098a4fdc$export$94aaefe8c923e69a.displayName = "RcaInvestigationPageSkeleton";
const $887e63d7098a4fdc$export$f2459ef7d14935ba = {
    Loading: $887e63d7098a4fdc$var$LoadingPage,
    Error: $887e63d7098a4fdc$var$ErrorPage
};

});
parcelRegister("651gg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ea92f32b13abae4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4qNCE = parcelRequire("4qNCE");

var $j26jU = parcelRequire("j26jU");

var $jepRN = parcelRequire("jepRN");

var $jG1Iz = parcelRequire("jG1Iz");

var $7eNDO = parcelRequire("7eNDO");

var $9wGXN = parcelRequire("9wGXN");

var $cZHUQ = parcelRequire("cZHUQ");
const $9ea92f32b13abae4$var$retry = (0, $7eNDO.defineMessage)({
    id: "common.components.error-state.retry-action",
    defaultMessage: "Try again"
});
function $9ea92f32b13abae4$var$ErrorNew({ header: header = '', description: description, size: size = 'wide', onRetry: onRetry, isLoading: isLoading = false, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle = false, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage = $9ea92f32b13abae4$var$retry, renderErrorImage: renderErrorImage, headingLevel: headingLevel }) {
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($9wGXN))) : (0, (/*@__PURE__*/$parcel$interopDefault($cZHUQ)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$9ea92f32b13abae4$var$ErrorNew.displayName = "ErrorNew";
function $9ea92f32b13abae4$var$ErrorOld({ header: header = '', description: description, size: size = 'wide', onRetry: onRetry, isLoading: isLoading = false, intl: intl, errorImage: errorImage, isSubtle: isSubtle = false, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage = $9ea92f32b13abae4$var$retry, renderErrorImage: renderErrorImage, headingLevel: headingLevel }) {
    const { formatMessage: formatMessage } = intl;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($9wGXN))) : (0, (/*@__PURE__*/$parcel$interopDefault($cZHUQ)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$9ea92f32b13abae4$var$ErrorOld.displayName = "ErrorOld";
const $9ea92f32b13abae4$export$edf27be85e5f6da0 = (0, $jepRN.componentWithFG)('jiv-migrate-default-props-error-state', $9ea92f32b13abae4$var$ErrorNew, $9ea92f32b13abae4$var$ErrorOld);
const $9ea92f32b13abae4$var$ExportedComponent = (0, $jG1Iz.injectIntlV2)($9ea92f32b13abae4$export$edf27be85e5f6da0);
var $9ea92f32b13abae4$export$2e2bcd8739ae039 = $9ea92f32b13abae4$var$ExportedComponent;

});
parcelRegister("jG1Iz", function(module, exports) {
$parcel$export(module.exports, "injectIntlV2", () => $075e908aba9db369$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $8hZ0d = parcelRequire("8hZ0d");
const $075e908aba9db369$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
function $075e908aba9db369$var$getDisplayName(Component) {
    if ($075e908aba9db369$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($075e908aba9db369$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $075e908aba9db369$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const WithIntl = (props)=>{
        const intl = (0, $1YIbA.default)();
        const intlRef = (0, $euxye.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$075e908aba9db369$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($8hZ0d)))(/*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8hZ0d)))(WithIntl, WrappedComponent); // oxlint-disable-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
};

});

parcelRegister("9wGXN", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("cZHUQ", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});


parcelRegister("PdWnG", function(module, exports) {
$parcel$export(module.exports, "useTrackAIInteractionDismissOnTabClose", () => $c6ac3d931729a954$export$be12758175837018);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $u9iDa = parcelRequire("u9iDa");

var $iK8G7 = parcelRequire("iK8G7");
const $c6ac3d931729a954$export$be12758175837018 = ()=>{
    const $ = (0, $e7boj.c)(3);
    const { trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $iK8G7.useAIEventsInstrumentation)();
    let t0;
    let t1;
    if ($[0] !== trackAIInteractionDismiss) {
        t0 = ()=>{
            const win = (0, $u9iDa.getDocument)()?.defaultView;
            if (win == null) return;
            const onPageHide = function onPageHide() {
                trackAIInteractionDismiss();
            };
            win.addEventListener("pagehide", onPageHide);
            return ()=>{
                win.removeEventListener("pagehide", onPageHide);
            };
        };
        t1 = [
            trackAIInteractionDismiss
        ];
        $[0] = trackAIInteractionDismiss;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $euxye.useEffect)(t0, t1);
};

});


parcelRegister("hp0XY", function(module, exports) {
$parcel$export(module.exports, "rcaInvestigationResource", () => $6f5f1734327c5c8b$export$4de2fe6bbcefc34);

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

var $99bcZ = parcelRequire("99bcZ");
// Sentinel value the incident page appends to investigationUrl when it opens
// the analysis page in a known-completed state. Allows the resource to skip
// thinking_steps in the initial fetch for faster initial paint.
const $6f5f1734327c5c8b$var$INCIDENT_COMPLETED_SOURCE = 'incident-completed';
const $6f5f1734327c5c8b$export$4de2fe6bbcefc34 = (0, $7edbf.createResource)({
    type: 'RCA_INVESTIGATION_RESOURCE',
    // Direct navigation keeps the original `investigation-<id>` shape so
    // pre-existing cached entries survive this change. Only when source
    // is present do we append it, which prevents the from-incident fetch
    // (with thinking_steps potentially skipped) from colliding with a
    // direct-visit fetch.
    getKey: ({ match: match, query: query })=>query.source ? `investigation-${match.params.id}-${query.source}` : `investigation-${match.params.id}`,
    getData: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const investigationId = match.params.id;
        if (!investigationId) throw new Error('Investigation ID is required to fetch RCA investigation ');
        return (0, $99bcZ.getRcaInvestigationData)(tenantContext.cloudId, investigationId, undefined, // Only skip thinking_steps when the incident page hinted at a
        // completed-state navigation AND the optimization gate is on.
        // fg() is kept inline (no const alias) to satisfy
        // jira/ff/inline-usage.
        query.source !== $6f5f1734327c5c8b$var$INCIDENT_COMPLETED_SOURCE || !(0, $i860n.fg)('rca_skip_thinking_steps_from_incident_panel'));
    },
    isBrowserOnly: true
});

});
parcelRegister("99bcZ", function(module, exports) {
$parcel$export(module.exports, "getRcaInvestigationData", () => $d5b8c08f250145b7$export$9bf90bcd0f6c6a55);

var $75sVW = parcelRequire("75sVW");

var $h2wCv = parcelRequire("h2wCv");

var $i860n = parcelRequire("i860n");
const $d5b8c08f250145b7$export$9bf90bcd0f6c6a55 = (cloudId, investigationId, signal, includeThinkingSteps = true)=>(0, $h2wCv.performGetRequest)(`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/investigation?investigation_id=${investigationId}${(0, $i860n.fg)('rca_investigation_exclude_extra_fields') ? `&include_audit_logs=false${includeThinkingSteps ? '' : '&include_thinking_steps=false'}` : ''}`, {
        signal: signal
    }).then((response)=>{
        if (response.error) throw new (0, $75sVW.default)(response.error.code, response.error.message);
        if (!response.data) throw new Error(`getRcaInvestigationData: investigation response missing data for investigation ID: ${investigationId}`);
        return response.data;
    });

});


parcelRegister("5klKQ", function(module, exports) {
$parcel$export(module.exports, "servicedeskRcaInvestigationRoute", () => $cedbe2af4b101e46$export$8853f92336839774);
const $cedbe2af4b101e46$export$8853f92336839774 = {
    name: 'servicedesk-rca-investigation',
    path: '/jira/servicedesk/projects/:projectKey/investigation/:id',
    exact: true
};

});


parcelRegister("iuKWj", function(module, exports) {
$parcel$export(module.exports, "servicedeskReports1RouteEntry", () => $96bbd3afc82c6130$export$8055c8b2162cf5bd);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $2wv74 = parcelRequire("2wv74");

var $74h93 = parcelRequire("74h93");

var $1AcoV = parcelRequire("1AcoV");

var $aKJ6x = parcelRequire("aKJ6x");
const $96bbd3afc82c6130$export$8055c8b2162cf5bd = (0, $fdS54.createEntry)((0, $2wv74.servicedeskReports1Route), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aKJ6x.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $1AcoV.getReportsWithKbResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aKJ6x.LazyServicedeskReportsHomePage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2wv74", function(module, exports) {
$parcel$export(module.exports, "servicedeskReports1Route", () => $a3b4ed7564ee9c9f$export$f5adfd681a4e85ad);
const $a3b4ed7564ee9c9f$export$f5adfd681a4e85ad = {
    name: 'servicedesk-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("1AcoV", function(module, exports) {
$parcel$export(module.exports, "getReportsWithKbResources", () => $13b40ee67334f5ce$export$1a63e9cdf8268e40);

var $34Jgy = parcelRequire("34Jgy");

var $lbxXL = parcelRequire("lbxXL");
const $13b40ee67334f5ce$export$1a63e9cdf8268e40 = ()=>[
        ...(0, $lbxXL.getServicedeskPageContextResources)(),
        (0, $34Jgy.kbConfluenceContextResource)
    ];

});

parcelRegister("aKJ6x", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsHomePage", () => $7850f66a00b0e851$export$121b9cfb2b001a53);
$parcel$export(module.exports, "default", () => $7850f66a00b0e851$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");


const $7850f66a00b0e851$export$121b9cfb2b001a53 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hyfuh"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-reports-home-page/src/ReportsHomePage.tsx"
});
const $7850f66a00b0e851$var$AsyncServicedeskReportsHomePage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7850f66a00b0e851$export$121b9cfb2b001a53,
        pageId: `spa-apps/servicedesk${(0, $7f3ca926ac2b64e7$export$13bdc187fca9c33e)}}`,
        shouldShowSpinner: true
    });
$7850f66a00b0e851$var$AsyncServicedeskReportsHomePage.displayName = "AsyncServicedeskReportsHomePage";
var $7850f66a00b0e851$export$2e2bcd8739ae039 = $7850f66a00b0e851$var$AsyncServicedeskReportsHomePage;

});
const $7f3ca926ac2b64e7$export$e4c007d05145b8c2 = '/reports/all-rating';
const $7f3ca926ac2b64e7$export$ddc580d759168f88 = '/reports/workload';
const $7f3ca926ac2b64e7$export$13bdc187fca9c33e = '/reports';

parcelRegister("hyfuh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j9Ndj").then(()=>parcelRequire('2rqJ8'));

});



parcelRegister("e0xiU", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustom4RouteEntry", () => $b4f9f24302c36da6$export$5ef62fad7280cd08);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74VrW = parcelRequire("74VrW");

var $74h93 = parcelRequire("74h93");

var $cwJKs = parcelRequire("cwJKs");
const $b4f9f24302c36da6$export$5ef62fad7280cd08 = (0, $fdS54.createEntry)((0, $74VrW.servicedeskReportsCustom4Route), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cwJKs.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cwJKs.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("74VrW", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustom4Route", () => $72e4284889e9b8ef$export$39325072940fb58c);
const $72e4284889e9b8ef$export$39325072940fb58c = {
    name: 'servicedesk-reports-custom',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId'
};

});

parcelRegister("cwJKs", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsCustom", () => $a39ea4b4595ad972$export$3ec5c3d7729889b9);
$parcel$export(module.exports, "default", () => $a39ea4b4595ad972$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $a39ea4b4595ad972$export$3ec5c3d7729889b9 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("3zGnm"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-reports-custom/src/KbRequestsReportsApp.tsx"
});
const $a39ea4b4595ad972$var$AsyncServicedeskReportsCustom = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $a39ea4b4595ad972$export$3ec5c3d7729889b9,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};
$a39ea4b4595ad972$var$AsyncServicedeskReportsCustom.displayName = "AsyncServicedeskReportsCustom";
var $a39ea4b4595ad972$export$2e2bcd8739ae039 = $a39ea4b4595ad972$var$AsyncServicedeskReportsCustom;

});
parcelRegister("3zGnm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("3EIxn")
]).then(()=>parcelRequire('23Ke2'));

});



parcelRegister("hZVFb", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomCreateRouteEntry", () => $1cfc8e674071ba7f$export$b806d1abc9172b6d);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $51orw = parcelRequire("51orw");

var $74h93 = parcelRequire("74h93");

var $fEGe0 = parcelRequire("fEGe0");
const $1cfc8e674071ba7f$export$b806d1abc9172b6d = (0, $fdS54.createEntry)((0, $51orw.servicedeskReportsCustomCreateRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-create',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fEGe0.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fEGe0.LazyServicedeskReportsCustomCreate)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("51orw", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", () => $77fb33847515077d$export$333e623d5eb41af0);
const $77fb33847515077d$export$333e623d5eb41af0 = {
    name: 'servicedesk-reports-custom-create',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/new'
};

});

parcelRegister("fEGe0", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsCustomCreate", () => $353f0cd4ea76fc09$export$821b8201b24f8b7d);
$parcel$export(module.exports, "default", () => $353f0cd4ea76fc09$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $353f0cd4ea76fc09$export$821b8201b24f8b7d = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("bOw1H"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-reports-custom-create/src/ServicedeskReportsCustomCreateType.tsx"
});
const $353f0cd4ea76fc09$var$AsyncServicedeskReportsCustomCreate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $353f0cd4ea76fc09$export$821b8201b24f8b7d,
        pageId: "spa-apps/servicedesk/reports/custom/create",
        shouldShowSpinner: true
    });
$353f0cd4ea76fc09$var$AsyncServicedeskReportsCustomCreate.displayName = "AsyncServicedeskReportsCustomCreate";
var $353f0cd4ea76fc09$export$2e2bcd8739ae039 = $353f0cd4ea76fc09$var$AsyncServicedeskReportsCustomCreate;

});
parcelRegister("bOw1H", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("1vNUm")
]).then(()=>parcelRequire('gPdcr'));

});



parcelRegister("jhbBi", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomEditRouteEntry", () => $f934c0c4d4d9970b$export$c4c3dcf824e7036e);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $cMiDq = parcelRequire("cMiDq");

var $74h93 = parcelRequire("74h93");

var $53D8Q = parcelRequire("53D8Q");
const $f934c0c4d4d9970b$export$c4c3dcf824e7036e = (0, $fdS54.createEntry)((0, $cMiDq.servicedeskReportsCustomEditRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-edit-view',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $53D8Q.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $53D8Q.LazyServicedeskReportsCustomEdit)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cMiDq", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomEditRoute", () => $226e697d2c5bfeab$export$3b6b3105a9ef9b83);
const $226e697d2c5bfeab$export$3b6b3105a9ef9b83 = {
    name: 'servicedesk-reports-custom-edit',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/edit'
};

});

parcelRegister("53D8Q", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsCustomEdit", () => $27d22676b1cc3d67$export$53def03ace9a6c5b);
$parcel$export(module.exports, "default", () => $27d22676b1cc3d67$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $27d22676b1cc3d67$export$53def03ace9a6c5b = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("jn4GU"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-reports-custom-edit/src/ServicedeskReportsCustomEditType.tsx"
});
const $27d22676b1cc3d67$var$AsyncServicedeskReportsCustomEdit = ({ match: match })=>{
    const { reportId: reportId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $27d22676b1cc3d67$export$53def03ace9a6c5b,
        pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
        shouldShowSpinner: true
    });
};
$27d22676b1cc3d67$var$AsyncServicedeskReportsCustomEdit.displayName = "AsyncServicedeskReportsCustomEdit";
var $27d22676b1cc3d67$export$2e2bcd8739ae039 = $27d22676b1cc3d67$var$AsyncServicedeskReportsCustomEdit;

});
parcelRegister("jn4GU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("evTNW")
]).then(()=>parcelRequire('5yPKo'));

});



parcelRegister("co4G4", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomIssueRouteEntry", () => $27f4e7364be6c339$export$222c6398b69dbc6d);
/* eslint-disable import/order */ 
var $51vnM = parcelRequire("51vnM");


var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $bQ8vl = parcelRequire("bQ8vl");

var $74h93 = parcelRequire("74h93");

var $4acHw = parcelRequire("4acHw");
const $27f4e7364be6c339$export$222c6398b69dbc6d = (0, $fdS54.createEntry)((0, $bQ8vl.servicedeskReportsCustomIssueRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4acHw.default),
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4acHw.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bQ8vl", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", () => $ab6ba6f97987137c$export$1cfe539c854438e8);
const $ab6ba6f97987137c$export$1cfe539c854438e8 = {
    name: 'servicedesk-reports-custom-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId/:issueKey',
    exact: true
};

});


parcelRegister("kR1nP", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRouteEntry", () => $3ab14b419a29760f$export$508d5e1a59322a54);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $a80FS = parcelRequire("a80FS");

var $74h93 = parcelRequire("74h93");

var $cwJKs = parcelRequire("cwJKs");
const $3ab14b419a29760f$export$508d5e1a59322a54 = (0, $fdS54.createEntry)((0, $a80FS.servicedeskReportsCustomTimeScaleRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cwJKs.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cwJKs.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("a80FS", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", () => $122608f3d1eeadac$export$eae9a65fe3f035ef);
const $122608f3d1eeadac$export$eae9a65fe3f035ef = {
    name: 'servicedesk-reports-custom-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId'
};

});


parcelRegister("lRd9M", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfaction2RouteEntry", () => $10e5f5bc2bf69417$export$d6fb66bfd4a40ef);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $hjxPU = parcelRequire("hjxPU");

var $74h93 = parcelRequire("74h93");

var $kjYEY = parcelRequire("kjYEY");
const $10e5f5bc2bf69417$export$d6fb66bfd4a40ef = (0, $fdS54.createEntry)((0, $hjxPU.servicedeskReportsSatisfaction2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kjYEY.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $kjYEY.LazyServicedeskReportsSatisfaction)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hjxPU", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", () => $63615ae0183873e4$export$22fd25b495033fdf);
const $63615ae0183873e4$export$22fd25b495033fdf = {
    name: 'servicedesk-reports-satisfaction',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating'
};

});

parcelRegister("kjYEY", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsSatisfaction", () => $5eb48e6a8e049460$export$8edc7b9d922cd22f);
$parcel$export(module.exports, "default", () => $5eb48e6a8e049460$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");


const $5eb48e6a8e049460$export$8edc7b9d922cd22f = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("h71Sb"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-reports-satisfaction/src/SatisfactionViewSpa.tsx"
});
const $5eb48e6a8e049460$var$AsyncServicedeskReportsSatisfaction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $5eb48e6a8e049460$export$8edc7b9d922cd22f,
        pageId: `spa-apps/servicedesk${(0, $7f3ca926ac2b64e7$export$e4c007d05145b8c2)}}`,
        shouldShowSpinner: true
    });
$5eb48e6a8e049460$var$AsyncServicedeskReportsSatisfaction.displayName = "AsyncServicedeskReportsSatisfaction";
var $5eb48e6a8e049460$export$2e2bcd8739ae039 = $5eb48e6a8e049460$var$AsyncServicedeskReportsSatisfaction;

});
parcelRegister("h71Sb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("3K8k4")
]).then(()=>parcelRequire('8jDmu'));

});



parcelRegister("5hPVZ", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRouteEntry", () => $a161d740402a8dc1$export$6b98300c0f2ab048);
/* eslint-disable import/order */ 
var $51vnM = parcelRequire("51vnM");


var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $aM4Nb = parcelRequire("aM4Nb");

var $74h93 = parcelRequire("74h93");

var $4acHw = parcelRequire("4acHw");
const $a161d740402a8dc1$export$6b98300c0f2ab048 = (0, $fdS54.createEntry)((0, $aM4Nb.servicedeskReportsSatisfactionIssueRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $4acHw.default),
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4acHw.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aM4Nb", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", () => $af840eb76790fc29$export$da606765550c7e7);
const $af840eb76790fc29$export$da606765550c7e7 = {
    name: 'servicedesk-reports-satisfaction-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
    exact: true
};

});


parcelRegister("hzYpr", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRouteEntry", () => $5ae41b7ef8ba18aa$export$8d7026b8c74a8be8);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $6JJ6c = parcelRequire("6JJ6c");

var $74h93 = parcelRequire("74h93");

var $kjYEY = parcelRequire("kjYEY");
const $5ae41b7ef8ba18aa$export$8d7026b8c74a8be8 = (0, $fdS54.createEntry)((0, $6JJ6c.servicedeskReportsSatisfactionTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $kjYEY.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $kjYEY.LazyServicedeskReportsSatisfaction)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6JJ6c", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", () => $a6fa09133eebf845$export$64ae70b2d6b34c4e);
const $a6fa09133eebf845$export$64ae70b2d6b34c4e = {
    name: 'servicedesk-reports-satisfaction-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId'
};

});


parcelRegister("jwXSg", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsTypeRouteEntry", () => $7c3500e5feb1378c$export$bc47b2df6d39fd3f);
/* eslint-disable import/order */ 

var $Jz4MJ = parcelRequire("Jz4MJ");

var $ghc7e = parcelRequire("ghc7e");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $lbxXL = parcelRequire("lbxXL");

var $8PtcY = parcelRequire("8PtcY");

var $74h93 = parcelRequire("74h93");

var $9KYmb = parcelRequire("9KYmb");

var $1AcoV = parcelRequire("1AcoV");

var $ic6VN = parcelRequire("ic6VN");
const $7c3500e5feb1378c$export$bc47b2df6d39fd3f = (0, $fdS54.createEntry)((0, $8PtcY.servicedeskReportsTypeRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ic6VN.default),
        layout: (0, $QhQu4.composeLayouts)((0, $74h93.serviceProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $1AcoV.getReportsWithKbResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...(0, $Jz4MJ.getAIContextPanelResources)(),
            ...(0, $ghc7e.getResolutionPlanSSRResource)(),
            ...(0, $9KYmb.getDraftReplyPillsResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $ic6VN.LazyServicedeskReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8PtcY", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsTypeRoute", () => $216d856d171d4c0b$export$b955ac7f09c5dbb);
const $216d856d171d4c0b$export$b955ac7f09c5dbb = {
    name: 'servicedesk-reports-type',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?'
};

});

parcelRegister("ic6VN", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReports", () => $f0753b9ec5a6e23e$export$75e043cf7a4e3661);
$parcel$export(module.exports, "default", () => $f0753b9ec5a6e23e$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f0753b9ec5a6e23e$export$75e043cf7a4e3661 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("dZmlL")), {
    moduleId: "./src/packages/spa-apps/servicedesk-reports/src/index.tsx"
});
/**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */ const $f0753b9ec5a6e23e$var$AsyncServicedeskReports = ({ match: match })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f0753b9ec5a6e23e$export$75e043cf7a4e3661,
        pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}`,
        shouldShowSpinner: true
    });
};
$f0753b9ec5a6e23e$var$AsyncServicedeskReports.displayName = "AsyncServicedeskReports";
var $f0753b9ec5a6e23e$export$2e2bcd8739ae039 = $f0753b9ec5a6e23e$var$AsyncServicedeskReports;

});
parcelRegister("dZmlL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5JRc6").then(()=>parcelRequire('hY9bz'));

});



parcelRegister("3cRQJ", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsWorkloadRouteEntry", () => $b40330fd035b498a$export$793ba749f18b4dd4);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $ecT8l = parcelRequire("ecT8l");

var $74h93 = parcelRequire("74h93");

var $3s3mv = parcelRequire("3s3mv");
const $b40330fd035b498a$export$793ba749f18b4dd4 = (0, $fdS54.createEntry)((0, $ecT8l.servicedeskReportsWorkloadRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3s3mv.default),
        perfMetricKey: 'service-management.reports.workload',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $3s3mv.LazyServicedeskReportsWorkload)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ecT8l", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsWorkloadRoute", () => $43817ea57584dc62$export$ce9b409ccf53e93c);
const $43817ea57584dc62$export$ce9b409ccf53e93c = {
    name: 'servicedesk-reports-workload',
    path: '/jira/servicedesk/projects/:projectKey/reports/workload',
    exact: true
};

});

parcelRegister("3s3mv", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsWorkload", () => $0086f21971f5d37f$export$e805fb47fdcd991);
$parcel$export(module.exports, "default", () => $0086f21971f5d37f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");


const $0086f21971f5d37f$export$e805fb47fdcd991 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("kKhHu"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-reports-workload/src/ReportsIssueViewSpa.tsx"
});
const $0086f21971f5d37f$var$AsyncServicedeskReportsWorkload = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0086f21971f5d37f$export$e805fb47fdcd991,
        pageId: `spa-apps/servicedesk${(0, $7f3ca926ac2b64e7$export$ddc580d759168f88)}}`,
        shouldShowSpinner: true
    });
$0086f21971f5d37f$var$AsyncServicedeskReportsWorkload.displayName = "AsyncServicedeskReportsWorkload";
var $0086f21971f5d37f$export$2e2bcd8739ae039 = $0086f21971f5d37f$var$AsyncServicedeskReportsWorkload;

});
parcelRegister("kKhHu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("CEpZc")
]).then(()=>parcelRequire('54Vii'));

});



parcelRegister("ejsPt", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceDetailsRouteEntry", () => $8ba16c9400dcd36f$export$48af7c0b8f21929b);
/* eslint-disable import/order */ 

var $6RSCO = parcelRequire("6RSCO");

var $8ycTI = parcelRequire("8ycTI");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $7v2YW = parcelRequire("7v2YW");

var $74h93 = parcelRequire("74h93");

var $8LVww = parcelRequire("8LVww");
const $8ba16c9400dcd36f$export$48af7c0b8f21929b = (0, $fdS54.createEntry)((0, $7v2YW.servicedeskServiceDetailsRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8LVww.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8LVww.LazyServicedeskServiceDetailsWithProjectContext)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7v2YW", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceDetailsRoute", () => $981fc473ba1f0e34$export$fe5fe00b6d5eab87);
const $981fc473ba1f0e34$export$fe5fe00b6d5eab87 = {
    name: 'servicedesk-service-details',
    path: '/jira/servicedesk/projects/:projectKey/services/:serviceAri'
};

});

parcelRegister("8LVww", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithProjectContext", () => $563050bae818c744$export$b154597f29589502);
$parcel$export(module.exports, "default", () => $563050bae818c744$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $563050bae818c744$export$b154597f29589502 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hAwdO"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-service-details-with-project-context/src/ServicedeskServiceDetailsWithProjectContext.tsx"
});
const $563050bae818c744$var$AsyncServicedeskServiceDetailsWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $563050bae818c744$export$b154597f29589502,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });
$563050bae818c744$var$AsyncServicedeskServiceDetailsWithProjectContext.displayName = "AsyncServicedeskServiceDetailsWithProjectContext";
var $563050bae818c744$export$2e2bcd8739ae039 = $563050bae818c744$var$AsyncServicedeskServiceDetailsWithProjectContext;

});
parcelRegister("hAwdO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ccYJn")
]).then(()=>parcelRequire('4V4zq'));

});



parcelRegister("koZPz", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRouteEntry", () => $bb37cc87c8d5e901$export$de2e645f69483ce);
/* eslint-disable import/order */ 
var $6RSCO = parcelRequire("6RSCO");

var $8ycTI = parcelRequire("8ycTI");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $5iQc3 = parcelRequire("5iQc3");

var $cVpLc = parcelRequire("cVpLc");
const $bb37cc87c8d5e901$export$de2e645f69483ce = (0, $fdS54.createEntry)((0, $5iQc3.serviceDeskServiceDetailsWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details-without-project',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cVpLc.default),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $8ycTI.workspaceResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cVpLc.LazyServicedeskServiceDetailsWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-service-details-without-project',
                packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                teamName: 'Astral'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5iQc3", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", () => $3f9946e2402ee54e$export$25e1d58db18a7c8b);
const $3f9946e2402ee54e$export$25e1d58db18a7c8b = {
    name: 'servicedesk-service-details-without-project',
    path: '/jira/servicedesk/services/:serviceAri'
};

});

parcelRegister("cVpLc", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithoutProjectContext", () => $951f0e756efea54e$export$ba1931edde0ce20c);
$parcel$export(module.exports, "default", () => $951f0e756efea54e$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $951f0e756efea54e$export$ba1931edde0ce20c = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("UQb2F"))), {
    moduleId: "./src/packages/spa-apps/servicedesk-service-details-without-project-context/src/ServicedeskServiceDetailsWithoutProjectContext.tsx"
});
const $951f0e756efea54e$var$AsyncServicedeskServiceDetailsWithoutProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $951f0e756efea54e$export$ba1931edde0ce20c,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });
$951f0e756efea54e$var$AsyncServicedeskServiceDetailsWithoutProjectContext.displayName = "AsyncServicedeskServiceDetailsWithoutProjectContext";
var $951f0e756efea54e$export$2e2bcd8739ae039 = $951f0e756efea54e$var$AsyncServicedeskServiceDetailsWithoutProjectContext;

});
parcelRegister("UQb2F", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4duM3")
]).then(()=>parcelRequire('bAira'));

});



parcelRegister("52tSp", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServiceListRouteEntry", () => $80a0ab3697bad5a9$export$e0714a8d0f48e9d7);

var $hboQV = parcelRequire("hboQV");

var $kORMo = parcelRequire("kORMo");


var $fdS54 = parcelRequire("fdS54");

var $h2tgz = parcelRequire("h2tgz");

var $dUAVJ = parcelRequire("dUAVJ");

var $8ycTI = parcelRequire("8ycTI");

var $iBJFD = parcelRequire("iBJFD");

var $i860n = parcelRequire("i860n");

var $dTa0V = parcelRequire("dTa0V");

var $lbxXL = parcelRequire("lbxXL");

var $8HUuJ = parcelRequire("8HUuJ");
const $80a0ab3697bad5a9$var$serviceDeskServiceListAppPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $hboQV.serviceListEntrypoint)
});
// TODO: Remove this resources when backend responses are ready.
const $80a0ab3697bad5a9$var$getConditionalInsightResources = ()=>(0, $lbxXL.getInsightResources)().map((resource)=>(0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('service-list-sidebar-item'), resource));
// Resolves the primary Assets site cloud id + workspace id (via the units /
// collaboration-context-aware resolver) before the page renders, so the Assets
// GraphQL request targets the primary site on its first fetch. Gated so that
// when the gate is OFF the resource is a no-op and behaviour is unchanged.
const $80a0ab3697bad5a9$var$getAssetsPrimaryWorkspaceResource = ()=>(0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_service_list_units_primary_site'), (0, $iBJFD.assetsPrimaryWorkspaceResource));
const $80a0ab3697bad5a9$export$e0714a8d0f48e9d7 = (0, $fdS54.createEntry)((0, $kORMo.serviceDeskServiceListRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $8ycTI.workspaceResource),
            $80a0ab3697bad5a9$var$getAssetsPrimaryWorkspaceResource(),
            ...$80a0ab3697bad5a9$var$getConditionalInsightResources()
        ],
        entryPoint () {
            return (0, $i860n.fg)('service-list-sidebar-item') ? $80a0ab3697bad5a9$var$serviceDeskServiceListAppPageEntryPoint : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hboQV", function(module, exports) {
$parcel$export(module.exports, "serviceListEntrypoint", () => $28ecc229785f7bbc$export$e51597f24a61c6c7);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $28ecc229785f7bbc$export$e51597f24a61c6c7 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("ichbG")), {
        moduleId: "d82ab717",
        moduleName: "ServiceListPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ichbG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("jUwSM")
]).then(()=>parcelRequire('8Or4h'));

});


parcelRegister("kORMo", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServiceListRoute", () => $f7c0c2bc06636f4f$export$c5c345ae806dd826);
const $f7c0c2bc06636f4f$export$c5c345ae806dd826 = {
    name: 'servicedesk-service-list',
    path: '/jira/ops/services',
    exact: true
};

});

parcelRegister("iBJFD", function(module, exports) {
$parcel$export(module.exports, "assetsPrimaryWorkspaceResource", () => $4b61e0573acc335c$export$dd305d470b0f649f);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $4b61e0573acc335c$export$a91de72aff71ef43 = 'JSM_ASSETS_PRIMARY_WORKSPACE';
const $4b61e0573acc335c$var$ASSETS_INTERNAL_WORKSPACE_RESOLVER_URL = '/assets/internal/workspace?productContext=jsm';
const $4b61e0573acc335c$var$EMPTY_RESULT = Object.freeze({
    cmdbSiteCloudId: null,
    workspaceId: null
});
const $4b61e0573acc335c$var$ERROR_META = {
    id: 'assetsPrimaryWorkspaceResource',
    packageName: 'jiraRouterResourcesAssetsPrimaryWorkspace',
    teamName: 'rohirrim'
};
const $4b61e0573acc335c$export$28733f6fa6396c15 = async (cloudId)=>{
    if (cloudId == null || cloudId === '') return $4b61e0573acc335c$var$EMPTY_RESULT;
    try {
        const response = await (0, $h2wCv.performGetRequest)($4b61e0573acc335c$var$ASSETS_INTERNAL_WORKSPACE_RESOLVER_URL, {
            headers: {
                accept: 'application/json',
                'x-atlassian-cloud-id': cloudId
            }
        });
        if (!response?.cmdbSiteCloudId) return $4b61e0573acc335c$var$EMPTY_RESULT;
        return Object.freeze({
            cmdbSiteCloudId: response.cmdbSiteCloudId,
            workspaceId: response.workspaceId ?? null
        });
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: $4b61e0573acc335c$var$ERROR_META,
            error: error instanceof Error ? error : new Error(String(error)),
            attributes: {
                reason: 'resolverUnavailableOrError'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return $4b61e0573acc335c$var$EMPTY_RESULT;
    }
};
const $4b61e0573acc335c$export$dd305d470b0f649f = (0, $7edbf.createResource)({
    type: $4b61e0573acc335c$export$a91de72aff71ef43,
    getKey: (_, { tenantContext: tenantContext })=>tenantContext?.cloudId ?? 'no-cloud-id',
    getData: async (_, { tenantContext: tenantContext })=>$4b61e0573acc335c$export$28733f6fa6396c15(tenantContext?.cloudId),
    maxAge: Infinity
});

});


parcelRegister("2lNQx", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceModalEditRouteEntry", () => $9d1d4fc4ec9c5159$export$5698449b623d4af);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $5pjTp = parcelRequire("5pjTp");

var $74h93 = parcelRequire("74h93");

var $k6CJP = parcelRequire("k6CJP");
const $9d1d4fc4ec9c5159$export$5698449b623d4af = (0, $fdS54.createEntry)((0, $5pjTp.servicedeskServiceModalEditRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $k6CJP.default),
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $k6CJP.LazyServiceUpdateModalWithProjectContext)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5pjTp", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceModalEditRoute", () => $8800baa412dc79a1$export$319fbbab5eb49cbf);
const $8800baa412dc79a1$export$319fbbab5eb49cbf = {
    name: 'servicedesk-service-modal-edit',
    path: '/jira/servicedesk/service-modal/:serviceAri'
};

});

parcelRegister("k6CJP", function(module, exports) {
$parcel$export(module.exports, "LazyServiceUpdateModalWithProjectContext", () => $cbbe98d9d503c781$export$8984aadca7e15d1);
$parcel$export(module.exports, "default", () => $cbbe98d9d503c781$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $cbbe98d9d503c781$export$8984aadca7e15d1 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("64yeb")), {
    moduleId: "./src/packages/spa-apps/servicedesk-service-update-modal-without-project-context/src/ServicedeskServiceUpdateModalWithoutProjectContext.tsx"
});
const $cbbe98d9d503c781$var$AsyncServiceUpdateModalWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $cbbe98d9d503c781$export$8984aadca7e15d1,
        pageId: "spa-apps/servicedesk/service-update-modal",
        shouldShowSpinner: true
    });
$cbbe98d9d503c781$var$AsyncServiceUpdateModalWithProjectContext.displayName = "AsyncServiceUpdateModalWithProjectContext";
var $cbbe98d9d503c781$export$2e2bcd8739ae039 = $cbbe98d9d503c781$var$AsyncServiceUpdateModalWithProjectContext;

});
parcelRegister("64yeb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jMzjI")
]).then(()=>parcelRequire('aA2PH'));

});



parcelRegister("8tNhS", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceModalNewRouteEntry", () => $f4df820bb9ea90c5$export$75c24699abe8e616);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $eghLH = parcelRequire("eghLH");

var $74h93 = parcelRequire("74h93");

var $i4jO8 = parcelRequire("i4jO8");
const $f4df820bb9ea90c5$export$75c24699abe8e616 = (0, $fdS54.createEntry)((0, $eghLH.servicedeskServiceModalNewRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $i4jO8.default),
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $i4jO8.LazyServiceCreateModalWithProjectContext)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eghLH", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceModalNewRoute", () => $5ffe27c60b8f2e85$export$5b5ea97286af2784);
const $5ffe27c60b8f2e85$export$5b5ea97286af2784 = {
    name: 'servicedesk-service-modal-new',
    path: '/jira/servicedesk/service-modal',
    exact: true
};

});

parcelRegister("i4jO8", function(module, exports) {
$parcel$export(module.exports, "LazyServiceCreateModalWithProjectContext", () => $e8997da43476fcf2$export$7f4092c8e7b7d3ec);
$parcel$export(module.exports, "default", () => $e8997da43476fcf2$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $e8997da43476fcf2$export$7f4092c8e7b7d3ec = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("j6Ktg")), {
    moduleId: "./src/packages/spa-apps/servicedesk-service-create-modal-without-project-context/src/ServicedeskServiceCreateModalWithoutProjectContext.tsx"
});
const $e8997da43476fcf2$var$AsyncServiceCreateModalWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e8997da43476fcf2$export$7f4092c8e7b7d3ec,
        pageId: "spa-apps/servicedesk/service-create-modal",
        shouldShowSpinner: true
    });
$e8997da43476fcf2$var$AsyncServiceCreateModalWithProjectContext.displayName = "AsyncServiceCreateModalWithProjectContext";
var $e8997da43476fcf2$export$2e2bcd8739ae039 = $e8997da43476fcf2$var$AsyncServiceCreateModalWithProjectContext;

});
parcelRegister("j6Ktg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("hVzih")
]).then(()=>parcelRequire('82SHH'));

});



parcelRegister("1pbab", function(module, exports) {
$parcel$export(module.exports, "servicedeskServicesRouteEntry", () => $8c30b24540b60a45$export$5df203501090bc7f);
/* eslint-disable import/order */ 

var $9QAbZ = parcelRequire("9QAbZ");

var $8ycTI = parcelRequire("8ycTI");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $6dQS7 = parcelRequire("6dQS7");

var $74h93 = parcelRequire("74h93");

var $iLCvR = parcelRequire("iLCvR");
const $8c30b24540b60a45$export$5df203501090bc7f = (0, $fdS54.createEntry)((0, $6dQS7.servicedeskServicesRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $iLCvR.default),
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $9QAbZ.AsyncJSMOperationsHorizontalNav)
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $8ycTI.workspaceResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $9QAbZ.LazyJSMOperationsHorizontalNav),
            (0, $iLCvR.LazyServicedeskServicesWithProjectContext)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6dQS7", function(module, exports) {
$parcel$export(module.exports, "servicedeskServicesRoute", () => $6b98d7289f592c4f$export$4a800381bda6d53c);
const $6b98d7289f592c4f$export$4a800381bda6d53c = {
    name: 'servicedesk-services',
    path: '/jira/servicedesk/projects/:projectKey/services',
    exact: true
};

});

parcelRegister("iLCvR", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskServicesWithProjectContext", () => $6cf12134fd379389$export$4aa60213b3477cf6);
$parcel$export(module.exports, "default", () => $6cf12134fd379389$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6cf12134fd379389$export$4aa60213b3477cf6 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("1yAwE")), {
    moduleId: "./src/packages/spa-apps/servicedesk-services-with-project-context/src/ServicedeskServicesWithProjectContext.tsx"
});
const $6cf12134fd379389$var$AsyncServicedeskServicesWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6cf12134fd379389$export$4aa60213b3477cf6,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });
$6cf12134fd379389$var$AsyncServicedeskServicesWithProjectContext.displayName = "AsyncServicedeskServicesWithProjectContext";
var $6cf12134fd379389$export$2e2bcd8739ae039 = $6cf12134fd379389$var$AsyncServicedeskServicesWithProjectContext;

});
parcelRegister("1yAwE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("2ISAq")
]).then(()=>parcelRequire('ifyIK'));

});



parcelRegister("3PfFy", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRouteEntry", () => $2980d3239c96f303$export$7031f96c25be5e14);
/* eslint-disable import/order */ 
var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $lrmKl = parcelRequire("lrmKl");

var $8ycTI = parcelRequire("8ycTI");

var $l6qot = parcelRequire("l6qot");
const $2980d3239c96f303$export$7031f96c25be5e14 = (0, $fdS54.createEntry)((0, $lrmKl.serviceDeskServicesWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services-without-project',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $l6qot.default),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $8ycTI.workspaceResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $l6qot.LazyServicedeskServicesWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-services-without-project',
                packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                teamName: 'Astral'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lrmKl", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", () => $3d791768d40223e8$export$3210e7c54c21be97);
const $3d791768d40223e8$export$3210e7c54c21be97 = {
    name: 'servicedesk-services-without-project',
    path: '/jira/servicedesk/services',
    exact: true
};

});

parcelRegister("l6qot", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskServicesWithoutProjectContext", () => $462f4e2412b772a7$export$fc385e1392a8e28);
$parcel$export(module.exports, "default", () => $462f4e2412b772a7$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $462f4e2412b772a7$export$fc385e1392a8e28 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("53JFW")), {
    moduleId: "./src/packages/spa-apps/servicedesk-services-without-project-context/src/ServicedeskServicesWithoutProjectContext.tsx"
});
const $462f4e2412b772a7$var$AsyncServicedeskServicesWithoutProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $462f4e2412b772a7$export$fc385e1392a8e28,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });
$462f4e2412b772a7$var$AsyncServicedeskServicesWithoutProjectContext.displayName = "AsyncServicedeskServicesWithoutProjectContext";
var $462f4e2412b772a7$export$2e2bcd8739ae039 = $462f4e2412b772a7$var$AsyncServicedeskServicesWithoutProjectContext;

});
parcelRegister("53JFW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("52Oqs")
]).then(()=>parcelRequire('33C4m'));

});



parcelRegister("dv5SV", function(module, exports) {
$parcel$export(module.exports, "servicedeskSlaSettingsRouteEntry", () => $88c1061ec4acdf9a$export$472949ed4e9ddfb0);



var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $140fA = parcelRequire("140fA");

var $6pofw = parcelRequire("6pofw");

var $fdS54 = parcelRequire("fdS54");

var $jEYuY = parcelRequire("jEYuY");

var $az1fH = parcelRequire("az1fH");

var $74h93 = parcelRequire("74h93");

var $hae5X = parcelRequire("hae5X");
const $88c1061ec4acdf9a$export$472949ed4e9ddfb0 = (0, $fdS54.createEntry)((0, $az1fH.servicedeskSlaSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).SLA_SETTINGS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).SLA_SETTINGS),
                teamName: 'bumblebee'
            }
        },
        perfMetricKey: 'jsm-sla-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hae5X.ServiceDeskSlaSettings),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $140fA.slaMetricsDataResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hae5X.LazyProjectSettingsServiceDeskSlaSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hae5X", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskSlaSettings", () => $37d2435069aa3000$export$a6694c07cb5be8c1);
$parcel$export(module.exports, "ServiceDeskSlaSettings", () => $37d2435069aa3000$export$c56fde3803c5a1a3);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $gDdYI = parcelRequire("gDdYI");

var $l8G1z = parcelRequire("l8G1z");

const $37d2435069aa3000$export$a6694c07cb5be8c1 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dKFn0"))), {
    moduleId: "./src/packages/spa-apps/project-settings-service-desk-sla-settings/src/ServiceDeskSlaSettingsPage.tsx"
});
const $37d2435069aa3000$export$c56fde3803c5a1a3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "project-settings-service-desk-sla-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $37d2435069aa3000$export$a6694c07cb5be8c1,
        pageId: "project-settings-service-desk-sla-settings",
        shouldShowSpinner: true
    }));
$37d2435069aa3000$export$c56fde3803c5a1a3.displayName = "ServiceDeskSlaSettings";

});
parcelRegister("dKFn0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("fwt7V")
]).then(()=>parcelRequire('9T7ZH'));

});



parcelRegister("koL9q", function(module, exports) {
$parcel$export(module.exports, "servicedeskSurveysRouteEntry", () => $6b9c9b8bfb0cac46$export$e76b07d7344f6d26);


var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $8IO8Y = parcelRequire("8IO8Y");

var $74h93 = parcelRequire("74h93");

var $6pofw = parcelRequire("6pofw");

var $jQZue = parcelRequire("jQZue");
const $6b9c9b8bfb0cac46$export$e76b07d7344f6d26 = (0, $fdS54.createEntry)((0, $8IO8Y.servicedeskSurveysRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.surveys',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        layout: (0, $74h93.serviceProjectLayout),
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $jQZue.surveysPageEntryPoint),
        meta: {
            reporting: {
                id: 'surveys',
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).SURVEYS),
                teamName: 'jsm-phoenix'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8IO8Y", function(module, exports) {
$parcel$export(module.exports, "servicedeskSurveysRoute", () => $6d2b34ac75e0aea6$export$1cc09e33ef01ef07);
const $6d2b34ac75e0aea6$export$1cc09e33ef01ef07 = {
    path: '/jira/servicedesk/projects/:projectKey/surveys/:surveyId?/(edit|settings)?',
    name: 'servicedesk-surveys'
};

});

parcelRegister("jQZue", function(module, exports) {
$parcel$export(module.exports, "surveysPageEntryPoint", () => $7a175350633a9e7b$export$89090149a538f2bd);
/* eslint-disable jira/naming/disallow-filenames */ 
var $57pUO = parcelRequire("57pUO");

var $dTa0V = parcelRequire("dTa0V");
const $7a175350633a9e7b$export$89090149a538f2bd = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $57pUO.surveysEntryPoint)
});

});
parcelRegister("57pUO", function(module, exports) {
$parcel$export(module.exports, "surveysEntryPoint", () => $045af38e79fd6717$export$afe6a4612d77e23e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $045af38e79fd6717$export$afe6a4612d77e23e = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6DVIq")), {
        moduleId: "7ecdb087",
        moduleName: "SurveysPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                context: context
            }
        })
});

});
parcelRegister("6DVIq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("gCScl"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("41LI2")
]).then(()=>parcelRequire('6p3L1'));

});




parcelRegister("k3KhI", function(module, exports) {
$parcel$export(module.exports, "servicedeskWorkflowConfigRouteEntry", () => $d5689828bc0d08c8$export$212f7f79630d5adc);



var $kSs3D = parcelRequire("kSs3D");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $7GKTa = parcelRequire("7GKTa");

var $74h93 = parcelRequire("74h93");
const $d5689828bc0d08c8$var$workflowSchemeConfigPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kSs3D.workflowSchemeConfigEntrypoint)
});
const $d5689828bc0d08c8$export$212f7f79630d5adc = (0, $fdS54.createEntry)((0, $7GKTa.servicedeskWorkflowConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        entryPoint () {
            return $d5689828bc0d08c8$var$workflowSchemeConfigPageEntrypoint;
        },
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $edf7u.projectContextResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.workflow-scheme-config',
                packageName: 'projectSettingsWorkflowSchemeConfig',
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-workflow-scheme-config',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kSs3D", function(module, exports) {
$parcel$export(module.exports, "workflowSchemeConfigEntrypoint", () => $27e6cf848ba2374a$export$12ccdf1d30de8ac);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $27e6cf848ba2374a$export$12ccdf1d30de8ac = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("5Yovt")), {
        moduleId: "b867b899",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5Yovt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ckzgk").then(()=>parcelRequire('71ilt'));

});



parcelRegister("4kOsL", function(module, exports) {
$parcel$export(module.exports, "settingsAutomationRouteEntry", () => $062d51ef26be8761$export$4df9f9dcaf8565c9);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $cHJl1 = parcelRequire("cHJl1");

var $35eqr = parcelRequire("35eqr");

var $3a7nR = parcelRequire("3a7nR");
const $062d51ef26be8761$export$4df9f9dcaf8565c9 = (0, $fdS54.createEntry)((0, $cHJl1.settingsAutomationRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3a7nR.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $3a7nR.LazyGlobalAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cHJl1", function(module, exports) {
$parcel$export(module.exports, "settingsAutomationRoute", () => $dd43c6e269cd862f$export$b314ab31b2da625b);
const $dd43c6e269cd862f$export$b314ab31b2da625b = {
    name: 'global-automation',
    path: '/jira/settings/automation',
    exact: true
};

});

parcelRegister("3a7nR", function(module, exports) {
$parcel$export(module.exports, "LazyGlobalAutomation", () => $9ed15554836a9ee4$export$4189991a2992b828);
$parcel$export(module.exports, "default", () => $9ed15554836a9ee4$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $21iIq = parcelRequire("21iIq");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $aq2CA = parcelRequire("aq2CA");

const $9ed15554836a9ee4$export$4189991a2992b828 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("dJEvN"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-automation/src/GlobalAutomationApp.tsx"
});
const $9ed15554836a9ee4$export$7c85ddcd4f0a813f = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $21iIq.qs).stringify(rest, true);
        return `/automation${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aq2CA.RedirectToProjectType), {
        page: page
    });
};
$9ed15554836a9ee4$export$7c85ddcd4f0a813f.displayName = "AutomationRedirect";
const $9ed15554836a9ee4$var$AsyncGlobalAutomation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9ed15554836a9ee4$export$4189991a2992b828,
        pageId: "global-automation",
        shouldShowSpinner: false
    });
$9ed15554836a9ee4$var$AsyncGlobalAutomation.displayName = "AsyncGlobalAutomation";
var $9ed15554836a9ee4$export$2e2bcd8739ae039 = $9ed15554836a9ee4$var$AsyncGlobalAutomation;

});
parcelRegister("aq2CA", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $1e2af6e6be467707$export$8a3df560509448b8);
/* eslint-disable jira/naming/disallow-filenames */ /* eslint-disable import/order */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $edf7u = parcelRequire("edf7u");

var $eNr3t = parcelRequire("eNr3t");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");
var $bc9Gj = parcelRequire("bc9Gj");
const $1e2af6e6be467707$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $gNbXR.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $aJ81Y.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $inMxE.useAnalyticsEvents), useResource: useResource = (0, $k6ufm.useResource), useRouter: useRouter = (0, $bc9Gj.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $eNr3t.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $edf7u.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $euxye.useRef)(createAnalyticsEvent({}));
    (0, $euxye.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $f99M0.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $f99M0.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $f99M0.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};
$1e2af6e6be467707$export$8a3df560509448b8.displayName = "RedirectToProjectType";

});

parcelRegister("dJEvN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1SoYa").then(()=>parcelRequire('5WWt7'));

});



parcelRegister("8jTrX", function(module, exports) {
$parcel$export(module.exports, "settingsCmdbFieldConfigRouteEntry", () => $da3ddc2e2d931791$export$c68a412f25295511);
/* eslint-disable import/order */ 


var $8ycTI = parcelRequire("8ycTI");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $jjFFr = parcelRequire("jjFFr");

var $gPxnu = parcelRequire("gPxnu");
const $da3ddc2e2d931791$export$c68a412f25295511 = (0, $fdS54.createEntry)((0, $jjFFr.settingsCmdbFieldConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.cmdb-field-config',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gPxnu.AsyncCmdbFieldConfigPage),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $8ycTI.workspaceResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gPxnu.LazyCMDBFieldConfigAdmin)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jjFFr", function(module, exports) {
$parcel$export(module.exports, "settingsCmdbFieldConfigRoute", () => $10503cf30a13bc07$export$5097bfaa68f86ca6);
const $10503cf30a13bc07$export$5097bfaa68f86ca6 = {
    name: 'global-settings-issues-cmdb-field-config',
    path: '/secure/admin/CmdbObjectFieldConfiguration'
};

});

parcelRegister("gPxnu", function(module, exports) {
$parcel$export(module.exports, "LazyCMDBFieldConfigAdmin", () => $7e7a7b4804cafaca$export$ccc6da5137e23637);
$parcel$export(module.exports, "AsyncCmdbFieldConfigPage", () => $7e7a7b4804cafaca$export$8dfbe255f554ebab);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7e7a7b4804cafaca$export$ccc6da5137e23637 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7kbp1"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-cmdb-field-config/src/CmdbFieldConfigPage.tsx"
});
const $7e7a7b4804cafaca$export$8dfbe255f554ebab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7e7a7b4804cafaca$export$ccc6da5137e23637,
        pageId: "admin-pages-cmdb-field-config",
        shouldShowSpinner: true
    });
$7e7a7b4804cafaca$export$8dfbe255f554ebab.displayName = "AsyncCmdbFieldConfigPage";

});
parcelRegister("7kbp1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("jZZDs")
]).then(()=>parcelRequire('5zESs'));

});



parcelRegister("lB4o7", function(module, exports) {
$parcel$export(module.exports, "settingsOauthCredentialsRouteEntry", () => $4766922a5918893a$export$d1c67ceb7c5e2d6a);
/* eslint-disable import/order */ 


var $clVqx = parcelRequire("clVqx");

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $iepnP = parcelRequire("iepnP");

var $grSI0 = parcelRequire("grSI0");
const $4766922a5918893a$export$d1c67ceb7c5e2d6a = (0, $fdS54.createEntry)((0, $iepnP.settingsOauthCredentialsRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $grSI0.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $clVqx.adminOauthCredentialsResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $grSI0.LazyOAuthCredentialsAdmin)
        ],
        ufoName: 'admin.oauth-credentials',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("clVqx", function(module, exports) {
$parcel$export(module.exports, "adminOauthCredentialsResource", () => $b5fc461fea780ed1$export$870d7919c1ca4482);

var $7edbf = parcelRequire("7edbf");
const $b5fc461fea780ed1$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

const $b5fc461fea780ed1$export$870d7919c1ca4482 = (0, $7edbf.createResource)({
    type: $b5fc461fea780ed1$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("5OPnK"))
});

});
parcelRegister("5OPnK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6TklR").then(()=>parcelRequire('jAxPt'));

});


parcelRegister("iepnP", function(module, exports) {
$parcel$export(module.exports, "settingsOauthCredentialsRoute", () => $fb934de6a584dcb2$export$c0ee28def7ef8783);
const $fb934de6a584dcb2$export$c0ee28def7ef8783 = {
    name: 'admin-oauth-credentials',
    path: '/secure/admin/oauth-credentials'
};

});

parcelRegister("grSI0", function(module, exports) {
$parcel$export(module.exports, "LazyOAuthCredentialsAdmin", () => $f98047efb6c23be4$export$101baa25055633e8);
$parcel$export(module.exports, "default", () => $f98047efb6c23be4$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f98047efb6c23be4$export$101baa25055633e8 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("epPz8"))), {
    moduleId: "./src/packages/spa-apps/admin-oauth-credentials-consumer/src/AdminOauthCredentialsConsumerAdminOAuthCredentialsShell.tsx"
});
const $f98047efb6c23be4$var$AsyncOAuthCredentialsAdmin = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f98047efb6c23be4$export$101baa25055633e8,
        pageId: "admin-oauth-credentials",
        shouldShowSpinner: true
    });
$f98047efb6c23be4$var$AsyncOAuthCredentialsAdmin.displayName = "AsyncOAuthCredentialsAdmin";
var $f98047efb6c23be4$export$2e2bcd8739ae039 = $f98047efb6c23be4$var$AsyncOAuthCredentialsAdmin;

});
parcelRegister("epPz8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("esDoq")
]).then(()=>parcelRequire('1zcIm'));

});



parcelRegister("fanIl", function(module, exports) {
$parcel$export(module.exports, "settingsRouteEntry", () => $5b3e3c69588418a7$export$1d28e19560927106);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 
var $hi6Of = parcelRequire("hi6Of");



var $7hGNU = parcelRequire("7hGNU");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $6yZOL = parcelRequire("6yZOL");

var $74h93 = parcelRequire("74h93");

var $ho8mN = parcelRequire("ho8mN");

var $dTa0V = parcelRequire("dTa0V");

var $1lV4Z = parcelRequire("1lV4Z");
const $5b3e3c69588418a7$var$settingsPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7hGNU.settingsEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $5b3e3c69588418a7$export$1d28e19560927106 = (0, $fdS54.createEntry)((0, $6yZOL.settingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_sd_virtual_agent') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-virtual-service-agent') : (0, $l1vE2.isFedRamp)()) return undefined;
            return $5b3e3c69588418a7$var$settingsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1lV4Z.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $ho8mN.VirtualAgentSettingsSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7hGNU", function(module, exports) {
$parcel$export(module.exports, "settingsEntryPoint", () => $d9cc7b540197b355$export$d34e7816b7ac181a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $bI0si = parcelRequire("bI0si");

const $d9cc7b540197b355$export$d34e7816b7ac181a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("kvsyQ")), {
        moduleId: "9f9906e8",
        moduleName: "VirtualAgentSettingsPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $bI0si.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("bI0si", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea51b3bda783a3a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47149fbd12abe37edb2f3eb42b3e7a94>>
 * @relayHash 318c00e7b3cff7e313d49c436f280f1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID db6faa5d2931aa45a065261fcff44ac46b1114b0bcfb97fe2b4f0d8e70532609

var $ktbTt = parcelRequire("ktbTt");

var $k49ny = parcelRequire("k49ny");
const $ea51b3bda783a3a5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "db6faa5d2931aa45a065261fcff44ac46b1114b0bcfb97fe2b4f0d8e70532609",
        "metadata": {},
        "name": "VirtualAgentSettingsPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaenableaianswerspagerelayprovider": (0, $ktbTt.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
        }
    }
};
var $ea51b3bda783a3a5$export$2e2bcd8739ae039 = $ea51b3bda783a3a5$var$node;

});
parcelRegister("ktbTt", function(module, exports) {
$parcel$export(module.exports, "default", () => $09123c029fe70142$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $09123c029fe70142$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jsm_va_enable_ai_answers_page');
    }
};

});


parcelRegister("kvsyQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bB3CX").then(()=>parcelRequire('2hvhF'));

});


parcelRegister("6yZOL", function(module, exports) {
$parcel$export(module.exports, "settingsRoute", () => $cf39fcb04236fa99$export$847a7c378c11c645);
const $cf39fcb04236fa99$export$847a7c378c11c645 = {
    name: 'project-settings-servicedesk-virtualagent-settings',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?'
};

});

parcelRegister("ho8mN", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentSettingsSkeleton", () => $a8cab533f650b1a1$export$429c43ddcb09c14c);
/* VirtualAgentSettingsSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $f4JDg = parcelRequire("f4JDg");
const $a8cab533f650b1a1$var$customCssStyles = null;
const $a8cab533f650b1a1$export$429c43ddcb09c14c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f4JDg))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$a8cab533f650b1a1$export$429c43ddcb09c14c.displayName = "VirtualAgentSettingsSkeleton";

});
parcelRegister("f4JDg", function(module, exports) {
module.exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();

});



parcelRegister("joaaH", function(module, exports) {
$parcel$export(module.exports, "skillsRouteEntry", () => $8e49d86891545b1b$export$4062020e59ff0b94);
/* eslint-disable import/order */ 
var $eMxBl = parcelRequire("eMxBl");

var $7SKFq = parcelRequire("7SKFq");


var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $2EQPz = parcelRequire("2EQPz");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");
const $8e49d86891545b1b$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $eMxBl.skillsEntryPoint)
});
const $8e49d86891545b1b$export$4062020e59ff0b94 = (0, $fdS54.createEntry)((0, $7SKFq.skillsRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        skeleton: (0, $2EQPz.ProjectIssueNavigatorSkeleton),
        ufoName: 'jsm-skills',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>{
            if (!(0, $i860n.fg)('jsm_wfo_skills')) return undefined;
            return $8e49d86891545b1b$var$entryPoint;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eMxBl", function(module, exports) {
$parcel$export(module.exports, "skillsEntryPoint", () => $e5e4592e0b34ed43$export$cfe10f3170c207ae);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $eORIz = parcelRequire("eORIz");
// The entrypoint preloads the first page of categories; follow-up category pages
// are loaded via usePaginationFragment on agentWorkspace_skillCategoriesInProject
// inside useSpaceSkillsConnection. Keep this small so the initial payload is fast
// and the rest stream in via outer infinite scroll (CORCAP-6705).
const $e5e4592e0b34ed43$var$SPACE_SKILLS_CATEGORIES_FIRST = 20;
// Prefetch the first page of skills inline with the initial query so the
// (pre-expanded) first category renders its skills with no extra client
// round-trip. `limitSkillsToFirstCategories: 1` scopes the inline `projectSkills`
// to just the first category to keep the initial payload small; other categories
// load their skills lazily on first expand via useSpaceSkillsConnection.
const $e5e4592e0b34ed43$var$SPACE_SKILLS_PER_CATEGORY_FIRST = 20;
const $e5e4592e0b34ed43$var$SPACE_SKILLS_LIMIT_TO_FIRST_CATEGORIES = 1;
const $e5e4592e0b34ed43$var$SPACE_SKILLS_AGENT_INITIAL_FETCHING = true;

const $e5e4592e0b34ed43$export$cfe10f3170c207ae = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bUfHE")), {
        moduleId: "e1fb8185",
        moduleName: "SkillsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = match.params.projectKey ?? '';
        return {
            queries: {
                skillsPageQuery: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $eORIz.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        categoriesFirst: $e5e4592e0b34ed43$var$SPACE_SKILLS_CATEGORIES_FIRST,
                        skillsLimit: $e5e4592e0b34ed43$var$SPACE_SKILLS_PER_CATEGORY_FIRST,
                        limitSkillsToFirstCategories: $e5e4592e0b34ed43$var$SPACE_SKILLS_LIMIT_TO_FIRST_CATEGORIES,
                        agentInitialFetching: $e5e4592e0b34ed43$var$SPACE_SKILLS_AGENT_INITIAL_FETCHING
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
    }
});

});
parcelRegister("eORIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eb47bb20618b8bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ca9fc7fc7c90a27ace395d846e0f8ae>>
 * @relayHash 4e3906105f44b4ee5789a45fdd3066ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 41a623a81f707cf267afd8d2b7763a90c12f714aef52d56ce5d41a8ba61f97c5
const $2eb47bb20618b8bf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "41a623a81f707cf267afd8d2b7763a90c12f714aef52d56ce5d41a8ba61f97c5",
        "metadata": {},
        "name": "SkillsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2eb47bb20618b8bf$export$2e2bcd8739ae039 = $2eb47bb20618b8bf$var$node;

});

parcelRegister("bUfHE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3eOnh").then(()=>parcelRequire('afaXM'));

});


parcelRegister("7SKFq", function(module, exports) {
$parcel$export(module.exports, "skillsRoute", () => $660abbdbcc5db8ab$export$43fec6b3d2240a2d);
const $660abbdbcc5db8ab$export$43fec6b3d2240a2d = {
    name: 'servicedesk-skills',
    path: '/jira/servicedesk/projects/:projectKey/skills',
    exact: true
};

});


parcelRegister("i4GHr", function(module, exports) {
$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry", () => $1b5672544c221f8d$export$4652a26319dca4d0);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dt6kD = parcelRequire("dt6kD");

var $dLVGe = parcelRequire("dLVGe");

var $8tAZd = parcelRequire("8tAZd");
const $1b5672544c221f8d$export$4652a26319dca4d0 = (0, $fdS54.createEntry)((0, $dt6kD.softwareAdvancedRoadmapsGettingStartedRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
                to: "/jira/plans?create-sample-plan=true"
            }),
        isRedirect: true,
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8tAZd.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dt6kD", function(module, exports) {
$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", () => $ced4a8045a0876ae$export$38c76ea9ddc85b3);
const $ced4a8045a0876ae$export$38c76ea9ddc85b3 = {
    name: 'software-advanced-roadmaps-getting-started-redirect',
    path: '/secure/PortfolioGettingStarted.jspa'
};

});


parcelRegister("j3bhm", function(module, exports) {
$parcel$export(module.exports, "softwareAgentContextClassicRouteEntry", () => $992365ec6435f130$export$13d870717e60abbf);


var $dizxY = parcelRequire("dizxY");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $dJ7R3 = parcelRequire("dJ7R3");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $jEYuY = parcelRequire("jEYuY");

var $75Njg = parcelRequire("75Njg");

var $dTa0V = parcelRequire("dTa0V");

var $2700E = parcelRequire("2700E");

var $iSoIx = parcelRequire("iSoIx");

var $3KSG6 = parcelRequire("3KSG6");
const $992365ec6435f130$var$softwareAgentContextClassicEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: $dizxY.AgentContextEntryPoint,
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $992365ec6435f130$export$13d870717e60abbf = (0, $fdS54.createEntry)((0, $dJ7R3.softwareAgentContextClassicRoute), ()=>({
        group: 'classic-software',
        perfMetricKey: 'software.agent-context-classic',
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        entryPoint () {
            return (0, $2700E.expValEquals)('jira-agent-context-experiment', 'isEnabled', true, false) ? $992365ec6435f130$var$softwareAgentContextClassicEntryPoint : (0, $iSoIx.notFoundPageEntrypoint);
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $gZWlI.projectThemeResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        ufoName: 'software-agent-context-classic',
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        supportsProjectTheme: 'full'
    }));

});
parcelRegister("dJ7R3", function(module, exports) {
$parcel$export(module.exports, "softwareAgentContextClassicRoute", () => $35cbf43401718f4f$export$40af51cf104ca4f0);
const $35cbf43401718f4f$export$40af51cf104ca4f0 = {
    name: 'software-agent-context-classic',
    path: '/jira/software/c/projects/:projectKey/agent-context',
    exact: true
};

});


parcelRegister("dtL5L", function(module, exports) {
$parcel$export(module.exports, "softwareAgentContextRouteEntry", () => $03dcaafcfb29f800$export$f5943fb6a77305ca);


var $61eKY = parcelRequire("61eKY");

var $dizxY = parcelRequire("dizxY");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $ldmDZ = parcelRequire("ldmDZ");

var $75Njg = parcelRequire("75Njg");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $2700E = parcelRequire("2700E");

var $iSoIx = parcelRequire("iSoIx");

var $jEYuY = parcelRequire("jEYuY");
const $03dcaafcfb29f800$var$softwareAgentContextEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: $dizxY.AgentContextEntryPoint,
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $03dcaafcfb29f800$export$f5943fb6a77305ca = (0, $fdS54.createEntry)((0, $ldmDZ.softwareAgentContextRoute), ()=>({
        group: 'software',
        perfMetricKey: 'software.agent-context',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $gZWlI.projectThemeResource)
        ],
        entryPoint: ()=>(0, $2700E.expValEquals)('jira-agent-context-experiment', 'isEnabled', true, false) ? $03dcaafcfb29f800$var$softwareAgentContextEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        skeleton: (0, $61eKY.AgentContextLoadingSkeleton),
        ufoName: 'software-agent-context',
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        supportsProjectTheme: 'full'
    }));

});
parcelRegister("ldmDZ", function(module, exports) {
$parcel$export(module.exports, "softwareAgentContextRoute", () => $927012821a552cbc$export$1af5cb4cae6a48eb);
const $927012821a552cbc$export$1af5cb4cae6a48eb = {
    name: 'software-agent-context',
    exact: true,
    path: '/jira/software/projects/:projectKey/agent-context'
};

});


parcelRegister("jC0nD", function(module, exports) {
$parcel$export(module.exports, "softwareAiPlanningClassicPlanRouteEntry", () => $f71010f09fbfa5d6$export$30fdbf4ebc24143e);

var $dIUBq = parcelRequire("dIUBq");

var $iSoIx = parcelRequire("iSoIx");

var $zsZxC = parcelRequire("zsZxC");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");
const $f71010f09fbfa5d6$var$aiPlanningClassicSoftwarePlanPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $dIUBq.aiPlanningPlanEntrypoint)
});
const $f71010f09fbfa5d6$export$30fdbf4ebc24143e = (0, $fdS54.createEntry)((0, $zsZxC.softwareAiPlanningClassicPlanRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-ai-planning-classic-plan',
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [],
        meta: {
            reporting: {
                id: 'software-ai-planning-classic-plan',
                packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
                teamName: 'Reverie'
            }
        },
        entryPoint: ()=>(0, $i860n.fg)('jira_ai_planner_tab') ? $f71010f09fbfa5d6$var$aiPlanningClassicSoftwarePlanPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dIUBq", function(module, exports) {
$parcel$export(module.exports, "aiPlanningPlanEntrypoint", () => $2ee882d24b8c896e$export$bba6e951dc109ba5);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");
const $2ee882d24b8c896e$var$createJiraSearch = (query)=>{
    const searchParams = new URLSearchParams(query);
    const search = searchParams.toString();
    return search.length > 0 ? `?${search}` : '';
};

const $2ee882d24b8c896e$export$bba6e951dc109ba5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jZakW")), {
        moduleId: "faf68887",
        moduleName: "AiPlanningPlanApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: { params: params }, query: query }, tenantContext: { atlassianAccountId: atlassianAccountId, cloudId: cloudId } })=>{
        const { planId: planId } = params;
        if (planId == null || planId === '') throw new Error('Plan id missing');
        return {
            extraProps: {
                cloudId: cloudId,
                accountId: atlassianAccountId,
                planId: planId,
                jiraSearch: $2ee882d24b8c896e$var$createJiraSearch(query)
            }
        };
    }
});

});
parcelRegister("jZakW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fFjiP").then(()=>parcelRequire('8MKZS'));

});


parcelRegister("zsZxC", function(module, exports) {
$parcel$export(module.exports, "softwareAiPlanningClassicPlanRoute", () => $3e2b886c45091feb$export$2e2dfea84c52786e);
const $3e2b886c45091feb$export$2e2dfea84c52786e = {
    name: 'software-ai-planning-classic-plan',
    path: '/jira/software/c/projects/:projectKey/ai-planning/:planId',
    exact: true
};

});


parcelRegister("izbEh", function(module, exports) {
$parcel$export(module.exports, "softwareAiPlanningClassicRouteEntry", () => $73bcee939adf8395$export$f05256592a2dae0d);


var $9LROf = parcelRequire("9LROf");

var $bXSxE = parcelRequire("bXSxE");

var $iSoIx = parcelRequire("iSoIx");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $68W59 = parcelRequire("68W59");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $75Njg = parcelRequire("75Njg");

var $3KSG6 = parcelRequire("3KSG6");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");
const $73bcee939adf8395$var$aiPlanningClassicSoftwarePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9LROf.aiPlanningEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $73bcee939adf8395$var$aiPlanningPlannerRedirectPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bXSxE.aiPlanningPlannerRedirectEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $73bcee939adf8395$export$f05256592a2dae0d = (0, $fdS54.createEntry)((0, $68W59.softwareAiPlanningClassicRoute), ()=>({
        group: 'classic-software',
        /* eslint-disable jira/ff/no-preconditioning -- temporary route handoff keeps the old route alive until the rename gate is fully launched. */ isRedirect: (0, $i860n.fg)('jira_ai_planner_tab') && (0, $i860n.fg)('ai-planner-jira-monolith-route-rename'),
        ufoName: 'software-ai-planning-classic',
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $gZWlI.projectThemeResource)
        ],
        meta: {
            reporting: {
                id: 'software-ai-planning-classic',
                packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
                teamName: 'Dev AI - Planner'
            }
        },
        entryPoint: ()=>{
            if (!(0, $i860n.fg)('jira_ai_planner_tab')) return 0, $iSoIx.notFoundPageEntrypoint;
            if ((0, $i860n.fg)('ai-planner-jira-monolith-route-rename')) return $73bcee939adf8395$var$aiPlanningPlannerRedirectPageEntrypoint;
            return $73bcee939adf8395$var$aiPlanningClassicSoftwarePageEntrypoint;
        },
        /* eslint-enable jira/ff/no-preconditioning */ supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9LROf", function(module, exports) {
$parcel$export(module.exports, "aiPlanningEntrypoint", () => $a0899658157be4e4$export$e13a330d38b7cd7c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $a0899658157be4e4$export$e13a330d38b7cd7c = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1keSO")), {
        moduleId: "d9cec75c",
        moduleName: "AiPlanningApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (_entryPointRouteParams)=>({})
});

});
parcelRegister("1keSO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("78Crv").then(()=>parcelRequire('1c0h1'));

});


parcelRegister("bXSxE", function(module, exports) {
$parcel$export(module.exports, "aiPlanningPlannerRedirectEntrypoint", () => $6ce85b019317779d$export$1f89893742f3acce);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $6ce85b019317779d$export$1f89893742f3acce = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5TVNc")), {
        moduleId: "a66ea7c3",
        moduleName: "AiPlanningPlannerRedirect",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (_entryPointRouteParams)=>({})
});

});
parcelRegister("5TVNc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jrXe2").then(()=>parcelRequire('lSihg'));

});


parcelRegister("68W59", function(module, exports) {
$parcel$export(module.exports, "softwareAiPlanningClassicRoute", () => $035ae72f6cf2cee2$export$3b967a01f486d4c8);
const $035ae72f6cf2cee2$export$3b967a01f486d4c8 = {
    name: 'software-ai-planning-classic',
    path: '/jira/software/c/projects/:projectKey/ai-planning',
    exact: true
};

});


parcelRegister("2mw5U", function(module, exports) {
$parcel$export(module.exports, "softwareAiPlanningPlanRouteEntry", () => $04cfe478c68f041c$export$617a4fd881be9488);

var $dIUBq = parcelRequire("dIUBq");

var $iSoIx = parcelRequire("iSoIx");

var $a3RE4 = parcelRequire("a3RE4");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");
const $04cfe478c68f041c$var$aiPlanningSoftwarePlanPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $dIUBq.aiPlanningPlanEntrypoint)
});
const $04cfe478c68f041c$export$617a4fd881be9488 = (0, $fdS54.createEntry)((0, $a3RE4.softwareAiPlanningPlanRoute), ()=>({
        group: 'software',
        ufoName: 'software-ai-planning-plan',
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [],
        meta: {
            reporting: {
                id: 'software-ai-planning-plan',
                packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
                teamName: 'Reverie'
            }
        },
        entryPoint: ()=>(0, $i860n.fg)('jira_ai_planner_tab') ? $04cfe478c68f041c$var$aiPlanningSoftwarePlanPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("a3RE4", function(module, exports) {
$parcel$export(module.exports, "softwareAiPlanningPlanRoute", () => $3a99fc2fd0954371$export$8a610ca5b550a233);
const $3a99fc2fd0954371$export$8a610ca5b550a233 = {
    name: 'software-ai-planning-plan',
    path: '/jira/software/projects/:projectKey/ai-planning/:planId',
    exact: true
};

});


parcelRegister("GfsW7", function(module, exports) {
$parcel$export(module.exports, "softwareAiPlanningRouteEntry", () => $ecff5f33ad2e0a32$export$e2eb0c570da560c7);


var $9LROf = parcelRequire("9LROf");

var $bXSxE = parcelRequire("bXSxE");

var $iSoIx = parcelRequire("iSoIx");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $4dSjE = parcelRequire("4dSjE");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $75Njg = parcelRequire("75Njg");

var $3KSG6 = parcelRequire("3KSG6");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");
const $ecff5f33ad2e0a32$var$aiPlanningSoftwarePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9LROf.aiPlanningEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $ecff5f33ad2e0a32$var$aiPlanningPlannerRedirectPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $bXSxE.aiPlanningPlannerRedirectEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $ecff5f33ad2e0a32$export$e2eb0c570da560c7 = (0, $fdS54.createEntry)((0, $4dSjE.softwareAiPlanningRoute), ()=>({
        group: 'software',
        /* eslint-disable jira/ff/no-preconditioning -- temporary route handoff keeps the old route alive until the rename gate is fully launched. */ isRedirect: (0, $i860n.fg)('jira_ai_planner_tab') && (0, $i860n.fg)('ai-planner-jira-monolith-route-rename'),
        ufoName: 'software-ai-planning',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $gZWlI.projectThemeResource)
        ],
        meta: {
            reporting: {
                id: 'software-ai-planning',
                packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
                teamName: 'Dev AI - Planner'
            }
        },
        entryPoint: ()=>{
            if (!(0, $i860n.fg)('jira_ai_planner_tab')) return 0, $iSoIx.notFoundPageEntrypoint;
            if ((0, $i860n.fg)('ai-planner-jira-monolith-route-rename')) return $ecff5f33ad2e0a32$var$aiPlanningPlannerRedirectPageEntrypoint;
            return $ecff5f33ad2e0a32$var$aiPlanningSoftwarePageEntrypoint;
        },
        /* eslint-enable jira/ff/no-preconditioning */ supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4dSjE", function(module, exports) {
$parcel$export(module.exports, "softwareAiPlanningRoute", () => $6e173676f36e20d0$export$200bda5cc6e2d758);
const $6e173676f36e20d0$export$200bda5cc6e2d758 = {
    name: 'software-ai-planning',
    path: '/jira/software/projects/:projectKey/ai-planning',
    exact: true
};

});


parcelRegister("OYqNs", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogEmbedRouteEntry", () => $b04abf06d96c93ec$export$7cd14dee22609378);

var $51vnM = parcelRequire("51vnM");

var $jFwZ0 = parcelRequire("jFwZ0");

var $cLdvY = parcelRequire("cLdvY");


var $i860n = parcelRequire("i860n");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $cBYKZ = parcelRequire("cBYKZ");

var $CXNgX = parcelRequire("CXNgX");

var $loJVV = parcelRequire("loJVV");

var $3bgcx = parcelRequire("3bgcx");

var $cEVzH = parcelRequire("cEVzH");

var $edf7u = parcelRequire("edf7u");

var $4B518 = parcelRequire("4B518");

var $ldGfw = parcelRequire("ldGfw");

var $90O4c = parcelRequire("90O4c");

var $8HUuJ = parcelRequire("8HUuJ");

var $22bZB = parcelRequire("22bZB");
const $b04abf06d96c93ec$export$7cd14dee22609378 = (0, $fdS54.createEntry)((0, $90O4c.softwareBacklogEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $cBYKZ.backlogResource),
            (0, $CXNgX.backlogFilterRefinementResource),
            (0, $hFYSn.forgeBacklogModuleResource),
            (0, $hFYSn.forgeSprintModuleResource),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $cLdvY.aiEntitlementResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!false || (0, $i860n.fg)('enable_ssr_for_cmp_backlog'), (0, $loJVV.epicsLiteResource)),
            (0, $jFwZ0.currentUserResource),
            (0, $3bgcx.permissionsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('twcg-992-loom-meeting-notes-sprint-planning-gate'), (0, $cEVzH.confluenceUserPermissionsResource))
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? (0, $22bZB.GSNBacklogPageEntrypoint) : (0, $22bZB.backlogPageEntrypoint),
        ufoName: 'next-gen-backlog-embed',
        meta: {
            capability: (0, $0ce01f968965dadd$export$c17f34c425972af1)
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-backlog')
    }));

});
parcelRegister("cBYKZ", function(module, exports) {
$parcel$export(module.exports, "backlogResource", () => $9e45aa6f443fd902$export$31d171ba71468137);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");


const $9e45aa6f443fd902$export$31d171ba71468137 = (0, $7edbf.createResource)({
    type: (0, $7ce0d31518ce4ed2$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("9WdHP")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
/* eslint-disable jira/filename-case */ const $7ce0d31518ce4ed2$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $7ce0d31518ce4ed2$export$214238a9ff4636a = 'NEXTGEN_BACKLOG_FILTER_REFINEMENT';
const $7ce0d31518ce4ed2$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';

parcelRegister("9WdHP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5zPG8").then(()=>parcelRequire('ebE6M'));

});


parcelRegister("CXNgX", function(module, exports) {
$parcel$export(module.exports, "backlogFilterRefinementResource", () => $962b3dc7675ab73b$export$f9d71cb27b4dd1d8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $n67Vb = parcelRequire("n67Vb");

var $dwFIm = parcelRequire("dwFIm");

var $2zU0a = parcelRequire("2zU0a");

var $7edbf = parcelRequire("7edbf");

var $aI7em = parcelRequire("aI7em");

const $962b3dc7675ab73b$export$f9d71cb27b4dd1d8 = (0, $7edbf.createResource)({
    type: (0, $7ce0d31518ce4ed2$export$214238a9ff4636a),
    getKey: ()=>'backlog-filter-refinement-relay',
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const variables = {
            cloudId: tenantContext.cloudId,
            jql: query.jql ?? '',
            boardId: (0, $2zU0a.createAri)({
                resourceOwner: 'jira-software',
                cloudId: tenantContext.cloudId,
                resourceType: 'board',
                resourceId: String(match.params.boardId)
            }),
            filterRefinementScope: {
                backlog: {
                    boardId: Number(match.params.boardId)
                }
            }
        };
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $dwFIm.default), variables, {
            fetchPolicy: 'store-and-network'
        });
        return queryReference;
    },
    isBrowserOnly: true,
    maxAge: 0
});

});
parcelRegister("dwFIm", function(module, exports) {
$parcel$export(module.exports, "default", () => $58276505395ccdd4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<52e64610191d172700fe8ecfce1093bf>>
 * @relayHash 53666bf1c9b6e755c7bb77693279ee3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29570588328f466bf21bce3b0889d8d158a1b0cb5f44cbd62b8ef8385cb1d6e7

var $lAsqD = parcelRequire("lAsqD");
const $58276505395ccdd4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "29570588328f466bf21bce3b0889d8d158a1b0cb5f44cbd62b8ef8385cb1d6e7",
        "metadata": {},
        "name": "BacklogFilterRefinementQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__filterrefinementsrcuirelayprovidersprojectsinjiraeapdrop1relayprovider": (0, $lAsqD.default)
        }
    }
};
var $58276505395ccdd4$export$2e2bcd8739ae039 = $58276505395ccdd4$var$node;

});
parcelRegister("lAsqD", function(module, exports) {
$parcel$export(module.exports, "default", () => $47cfc876ba5a3bb8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $aJDWs = parcelRequire("aJDWs");
const $47cfc876ba5a3bb8$var$isProjectsInJiraEapDrop1Enabled = {
    get () {
        return (0, $aJDWs.isProjectsInJiraM1Enabled)();
    }
};
var $47cfc876ba5a3bb8$export$2e2bcd8739ae039 = $47cfc876ba5a3bb8$var$isProjectsInJiraEapDrop1Enabled;

});



parcelRegister("90O4c", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogEmbedRoute", () => $5d35b95d77b6b415$export$bc022a39c42aba2f);
const $5d35b95d77b6b415$export$bc022a39c42aba2f = {
    name: 'software-backlog-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
    exact: true
};

});

parcelRegister("22bZB", function(module, exports) {
$parcel$export(module.exports, "backlogPageEntrypoint", () => $76c163bd0820e58c$export$1ccf08591607897d);
$parcel$export(module.exports, "GSNBacklogPageEntrypoint", () => $76c163bd0820e58c$export$1b58bc4ceb84d5ee);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $1JQn3 = parcelRequire("1JQn3");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $eDEQ5 = parcelRequire("eDEQ5");
const $76c163bd0820e58c$export$1ccf08591607897d = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1JQn3.nextGenBacklogEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $76c163bd0820e58c$export$1b58bc4ceb84d5ee = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1JQn3.nextGenBacklogEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("iQ9bp", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogRouteEntry", () => $42ffe7108e4822dd$export$a5f8ba02d2755510);

var $51vnM = parcelRequire("51vnM");

var $jFwZ0 = parcelRequire("jFwZ0");



var $cLdvY = parcelRequire("cLdvY");


var $i860n = parcelRequire("i860n");

var $75Njg = parcelRequire("75Njg");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $cBYKZ = parcelRequire("cBYKZ");

var $loJVV = parcelRequire("loJVV");

var $3bgcx = parcelRequire("3bgcx");

var $CXNgX = parcelRequire("CXNgX");

var $cEVzH = parcelRequire("cEVzH");

var $edf7u = parcelRequire("edf7u");

var $4gG2N = parcelRequire("4gG2N");

var $8PWi1 = parcelRequire("8PWi1");

var $3eysO = parcelRequire("3eysO");

var $8HUuJ = parcelRequire("8HUuJ");

var $gZWlI = parcelRequire("gZWlI");

var $22bZB = parcelRequire("22bZB");
const $42ffe7108e4822dd$export$a5f8ba02d2755510 = (0, $fdS54.createEntry)((0, $4gG2N.softwareBacklogRoute), ()=>({
        group: 'software',
        skeleton: (0, $8PWi1.NextGenBacklogSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            ...(0, $ldGfw.getIssueViewResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $cBYKZ.backlogResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!false || (0, $i860n.fg)('enable_ssr_for_cmp_backlog'), (0, $loJVV.epicsLiteResource)),
            (0, $CXNgX.backlogFilterRefinementResource),
            (0, $hFYSn.forgeBacklogModuleResource),
            (0, $hFYSn.forgeSprintModuleResource),
            (0, $gZWlI.projectThemeResource),
            (0, $cLdvY.aiEntitlementResource),
            (0, $jFwZ0.currentUserResource),
            (0, $3bgcx.permissionsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('twcg-992-loom-meeting-notes-sprint-planning-gate'), (0, $cEVzH.confluenceUserPermissionsResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-backlog-early-entry'
            ]
        },
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        ufoName: 'next-gen-backlog',
        meta: {
            capability: (0, $0ce01f968965dadd$export$c17f34c425972af1)
        },
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? (0, $22bZB.GSNBacklogPageEntrypoint) : (0, $22bZB.backlogPageEntrypoint),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-backlog'),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4gG2N", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogRoute", () => $aa01088fbc8a0939$export$fb454ec14936c0ab);
const $aa01088fbc8a0939$export$fb454ec14936c0ab = {
    name: 'software-backlog',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
};

});


parcelRegister("5skqi", function(module, exports) {
$parcel$export(module.exports, "softwareBoardEmbedRouteEntry", () => $eb200fb107a9c7c5$export$ff8632c8a0f5d984);

var $51vnM = parcelRequire("51vnM");

var $e3uiC = parcelRequire("e3uiC");

var $6PFJr = parcelRequire("6PFJr");


var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $i860n = parcelRequire("i860n");

var $QhQu4 = parcelRequire("QhQu4");

var $gZWlI = parcelRequire("gZWlI");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $4B518 = parcelRequire("4B518");

var $ldGfw = parcelRequire("ldGfw");

var $3mcIs = parcelRequire("3mcIs");

var $2700E = parcelRequire("2700E");

var $dTa0V = parcelRequire("dTa0V");

var $lPcZi = parcelRequire("lPcZi");

var $4fdV2 = parcelRequire("4fdV2");

var $iV8mc = parcelRequire("iV8mc");

var $evFor = parcelRequire("evFor");
const $eb200fb107a9c7c5$var$boardEmbedPageEntryPoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $e3uiC.boardEntryPoint)
});
const $eb200fb107a9c7c5$var$getLegacyResources = ()=>{
    if ((0, $2700E.expValEquals)('board_harmonisation_software_tmp', 'isEnabled', true, false)) return [
        (0, $gZWlI.projectThemeResource)
    ];
    return [
        (0, $edf7u.projectContextResource),
        (0, $lPcZi.conditionalBoardNBTOptInResource),
        (0, $iV8mc.conditionalBoardResource),
        (0, $4fdV2.conditionalBoardRelayResource),
        (0, $6PFJr.boardFilterRefinementResource),
        (0, $6PFJr.conditionalBoardTmpMatureExampleGupsResource),
        ...(0, $4B518.jiraSpaResources)(),
        (0, $hFYSn.forgeBoardModuleResource)
    ];
};
const $eb200fb107a9c7c5$export$ff8632c8a0f5d984 = (0, $fdS54.createEntry)((0, $3mcIs.softwareBoardEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...$eb200fb107a9c7c5$var$getLegacyResources()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $2700E.expValEquals)('board_harmonisation_software_tmp', 'isEnabled', true, false) ? $eb200fb107a9c7c5$var$boardEmbedPageEntryPoint : (0, $evFor.softwareBoardPageEntrypoint),
        supportsProjectTheme: (0, $2700E.expValEquals)('board_harmonisation_software_tmp', 'isEnabled', true, false) ? 'full' : undefined,
        ufoName: 'next-gen-board-embed',
        meta: {
            capability: (0, $0ce01f968965dadd$export$f364828958cffad0)
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-boards')
    }));

});
parcelRegister("6PFJr", function(module, exports) {
$parcel$export(module.exports, "boardResource", () => $79b4bc2bee3e24cb$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $79b4bc2bee3e24cb$export$3e390340716755de);
$parcel$export(module.exports, "boardFilterRefinementResource", () => $79b4bc2bee3e24cb$export$283d16e3e02421f0);
$parcel$export(module.exports, "conditionalBoardTmpMatureExampleGupsResource", () => $79b4bc2bee3e24cb$export$ebd240adcb3158c3);
$parcel$export(module.exports, "boardRelayResource", () => $79b4bc2bee3e24cb$export$81ac23db76b1f935);
/* eslint-disable jira/import-whitelist */ 
var $4RQ4u = parcelRequire("4RQ4u");

var $giKAl = parcelRequire("giKAl");

var $iMnY3 = parcelRequire("iMnY3");

var $gAHjf = parcelRequire("gAHjf");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $2zU0a = parcelRequire("2zU0a");

var $htsFl = parcelRequire("htsFl");

var $7edbf = parcelRequire("7edbf");


const $79b4bc2bee3e24cb$export$286b76e0f2661cfb = (0, $7edbf.createResource)({
    type: (0, $9224c0d03791d4cf$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("jcHrm")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});
const $79b4bc2bee3e24cb$export$3e390340716755de = (0, $htsFl.createRelayResource)({
    type: (0, $9224c0d03791d4cf$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $iMnY3.default),
            variables: {
                boardId: (0, $2zU0a.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});
const $79b4bc2bee3e24cb$export$283d16e3e02421f0 = (0, $htsFl.createRelayResource)({
    type: (0, $9224c0d03791d4cf$export$339da8fd7fc0a8e9),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $gAHjf.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $2zU0a.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});
const $79b4bc2bee3e24cb$export$8169c15bc19a128a = (0, $htsFl.createRelayResource)({
    type: (0, $9224c0d03791d4cf$export$96e39f6779e0c52a),
    getQuery: (_ctx, { tenantContext: tenantContext })=>({
            parameters: (0, $giKAl.default),
            variables: {
                cloudId: tenantContext.cloudId,
                includeGups: true
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});
const $79b4bc2bee3e24cb$export$ebd240adcb3158c3 = (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('critical_board_query_with_relay') && (0, $i860n.fg)('spice-gups-tmp-board-gate'), $79b4bc2bee3e24cb$export$8169c15bc19a128a);
const $79b4bc2bee3e24cb$export$81ac23db76b1f935 = (0, $htsFl.createRelayResource)({
    type: (0, $9224c0d03791d4cf$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $4RQ4u.default),
            variables: {
                boardId: (0, $2zU0a.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});

});
parcelRegister("4RQ4u", function(module, exports) {
$parcel$export(module.exports, "default", () => $7296950eb24df340$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e5605c892abb7aa66b2c2fcbdf11c5c>>
 * @relayHash 9f8e28d0f8d18bbce68dbc943123a0ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08efba67f706c4b8c3e987443bffc477163e8297cc227d6b595636f7a410cd63
const $7296950eb24df340$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "08efba67f706c4b8c3e987443bffc477163e8297cc227d6b595636f7a410cd63",
        "metadata": {},
        "name": "BoardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7296950eb24df340$export$2e2bcd8739ae039 = $7296950eb24df340$var$node;

});

parcelRegister("giKAl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d411f78ffa95fa60$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51ee56fdcd4c1dd3f2fde1e621f5d25c>>
 * @relayHash 49e56d172287bb583e6143235343cde8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d750cd41b6bb77afc03be232afda9cb69b1eb32a92b3781ed76c1e028da91166

var $lIGkE = parcelRequire("lIGkE");
const $d411f78ffa95fa60$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeGups"
        }
    ], v1 = [
        {
            "condition": "includeGups",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "tenantId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "GrowthUnifiedProfileResult",
                    "kind": "LinkedField",
                    "name": "growthUnifiedProfile_getUnifiedProfile",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GrowthUnifiedProfileOnboardingContext",
                            "kind": "LinkedField",
                            "name": "onboardingContext",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GrowthUnifiedProfileJiraOnboardingContext",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "matureExampleProjectIds"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BoardTmpMatureExampleGupsAnalyticsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BoardTmpMatureExampleGupsAnalyticsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "d750cd41b6bb77afc03be232afda9cb69b1eb32a92b3781ed76c1e028da91166",
            "metadata": {},
            "name": "BoardTmpMatureExampleGupsAnalyticsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d411f78ffa95fa60$var$node.hash = "4899112bd23551c908c9d2c360feb0f2";
(0, $lIGkE.PreloadableQueryRegistry).set($d411f78ffa95fa60$var$node.params.id, $d411f78ffa95fa60$var$node);
var $d411f78ffa95fa60$export$2e2bcd8739ae039 = $d411f78ffa95fa60$var$node;

});

parcelRegister("iMnY3", function(module, exports) {
$parcel$export(module.exports, "default", () => $592faa4392611407$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9bf3b467c4339db9009f9752c8557cd2>>
 * @relayHash 113b66fe53b02698654a159f858772ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 808561747853f51bf295dd617fbcb21649d2e0bc4eb7f67fe6baba0b910e3ff9
const $592faa4392611407$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "808561747853f51bf295dd617fbcb21649d2e0bc4eb7f67fe6baba0b910e3ff9",
        "metadata": {},
        "name": "BoardCustomFilterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $592faa4392611407$export$2e2bcd8739ae039 = $592faa4392611407$var$node;

});

parcelRegister("gAHjf", function(module, exports) {
$parcel$export(module.exports, "default", () => $30a1cb476bb53aee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4905d9622522781995df1cf64c179ff2>>
 * @relayHash bc100fc4a7f97e7be7598a807cfcb2cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 38fb6023b8b77153e4d99c2e1236769d9fa74fc68da4133c7d44a8c0fb2121ac
const $30a1cb476bb53aee$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "38fb6023b8b77153e4d99c2e1236769d9fa74fc68da4133c7d44a8c0fb2121ac",
        "metadata": {},
        "name": "BoardFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $30a1cb476bb53aee$export$2e2bcd8739ae039 = $30a1cb476bb53aee$var$node;

});

/* eslint-disable jira/filename-case */ const $9224c0d03791d4cf$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $9224c0d03791d4cf$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $9224c0d03791d4cf$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
const $9224c0d03791d4cf$export$339da8fd7fc0a8e9 = 'NEXTGEN_BOARD_FILTER_REFINEMENT';
const $9224c0d03791d4cf$export$96e39f6779e0c52a = 'NEXTGEN_BOARD_TMP_MATURE_EXAMPLE_GUPS';

parcelRegister("jcHrm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("35qqj").then(()=>parcelRequire('jIseg'));

});


parcelRegister("3mcIs", function(module, exports) {
$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $d2c2ff167c8c606d$export$f55626b64e3fcb4f);
const $d2c2ff167c8c606d$export$f55626b64e3fcb4f = {
    name: 'software-boards-embed',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("lPcZi", function(module, exports) {
$parcel$export(module.exports, "conditionalBoardNBTOptInResource", () => $5091d829dac362f4$export$3cdaa13b878c3c59);
/* eslint-disable import/order */ // eslint-disable-next-line jira/restricted/fedramp-isolated-cloud

var $l1vE2 = parcelRequire("l1vE2");

var $41FAq = parcelRequire("41FAq");

var $i860n = parcelRequire("i860n");

var $iEE0R = parcelRequire("iEE0R");

var $8HUuJ = parcelRequire("8HUuJ");
const $5091d829dac362f4$export$3cdaa13b878c3c59 = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('aem_rr_sw_board') ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-next-best-task') : !(0, $l1vE2.isFedRamp)(), (0, $iEE0R.nextBestTaskFeatureResource));

});

parcelRegister("4fdV2", function(module, exports) {
$parcel$export(module.exports, "conditionalBoardRelayResource", () => $7aca8c15c93ce286$export$ce009bf1a33fb264);
/* eslint-disable import/order */ 
var $6PFJr = parcelRequire("6PFJr");

var $i860n = parcelRequire("i860n");

var $8HUuJ = parcelRequire("8HUuJ");
const $7aca8c15c93ce286$export$ce009bf1a33fb264 = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('critical_board_query_with_relay'), (0, $6PFJr.boardRelayResource));

});

parcelRegister("iV8mc", function(module, exports) {
$parcel$export(module.exports, "conditionalBoardResource", () => $b749da3a11faf5d6$export$2ba7dfd4089a1a57);
/* eslint-disable import/order */ 
var $6PFJr = parcelRequire("6PFJr");

var $i860n = parcelRequire("i860n");

var $8HUuJ = parcelRequire("8HUuJ");
const $b749da3a11faf5d6$export$2ba7dfd4089a1a57 = (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('critical_board_query_with_relay'), (0, $6PFJr.boardResource));

});

parcelRegister("evFor", function(module, exports) {
$parcel$export(module.exports, "softwareBoardPageEntrypoint", () => $8c2667115e30fe84$export$89009c28cae628ae);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $aEPLp = parcelRequire("aEPLp");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $8c2667115e30fe84$export$89009c28cae628ae = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $aEPLp.nextGenBoardEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("dXpAT", function(module, exports) {
$parcel$export(module.exports, "softwareBoardRouteEntry", () => $a7d8f8f7d1835cad$export$2964ea1cdd5afa39);
/* eslint-disable import/order */ 
var $51vnM = parcelRequire("51vnM");


var $e3uiC = parcelRequire("e3uiC");

var $6PFJr = parcelRequire("6PFJr");

var $cLdvY = parcelRequire("cLdvY");

var $2sB0d = parcelRequire("2sB0d");


var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $a8oxM = parcelRequire("a8oxM");

var $32LKB = parcelRequire("32LKB");

var $9EWfZ = parcelRequire("9EWfZ");

var $8HUuJ = parcelRequire("8HUuJ");

var $3eysO = parcelRequire("3eysO");

var $gZWlI = parcelRequire("gZWlI");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $lPcZi = parcelRequire("lPcZi");

var $4fdV2 = parcelRequire("4fdV2");

var $iV8mc = parcelRequire("iV8mc");

var $evFor = parcelRequire("evFor");
const $a7d8f8f7d1835cad$var$boardPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $e3uiC.boardEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $a7d8f8f7d1835cad$var$getColoredLabelsResource = ()=>{
    return (0, $2700E.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? [
        (0, $2sB0d.coloredLabelsResource)
    ] : [];
};
const $a7d8f8f7d1835cad$var$getLegacyResources = ()=>{
    if ((0, $2700E.expValEquals)('board_harmonisation_software_tmp', 'isEnabled', true, false)) return [
        (0, $gZWlI.projectThemeResource)
    ];
    return [
        (0, $edf7u.projectContextResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $iV8mc.conditionalBoardResource),
        (0, $6PFJr.boardFilterRefinementResource),
        (0, $6PFJr.conditionalBoardTmpMatureExampleGupsResource),
        (0, $4fdV2.conditionalBoardRelayResource),
        (0, $lPcZi.conditionalBoardNBTOptInResource),
        (0, $hFYSn.forgeBoardModuleResource),
        (0, $gZWlI.projectThemeResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource)),
        ...$a7d8f8f7d1835cad$var$getColoredLabelsResource()
    ];
};
const $a7d8f8f7d1835cad$export$2964ea1cdd5afa39 = (0, $fdS54.createEntry)((0, $a8oxM.softwareBoardRoute), ()=>({
        group: 'software',
        skeleton: (0, $2700E.expValEquals)('board_harmonisation_software_tmp', 'isEnabled', true, false) ? (0, $9EWfZ.ThemedLazySkeleton) : (0, $32LKB.NextGenBoardSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            ...$a7d8f8f7d1835cad$var$getLegacyResources()
        ],
        preloadOptions: {
            earlyChunks: (0, $2700E.expValEquals)('board_harmonisation_software_tmp', 'isEnabled', true, false) ? [] : [
                'software-board-early-entry'
            ]
        },
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $2700E.expValEquals)('board_harmonisation_software_tmp', 'isEnabled', true, false) ? $a7d8f8f7d1835cad$var$boardPageEntryPoint : (0, $evFor.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board',
        meta: {
            capability: (0, $0ce01f968965dadd$export$f364828958cffad0)
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-boards'),
        bifrost: {
            bifrostGroup: 'backlog-and-board'
        }
    }));

});
parcelRegister("a8oxM", function(module, exports) {
$parcel$export(module.exports, "softwareBoardRoute", () => $9b707021b4786ba9$export$9ae2c0a566d4e0f6);
const $9b707021b4786ba9$export$9ae2c0a566d4e0f6 = {
    name: 'software-boards',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("32LKB", function(module, exports) {
$parcel$export(module.exports, "NextGenBoardSkeleton", () => $6a3a19ab96f60450$export$25a9d0fbcb127c90);
/* NextGenBoardSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $dAYdE = parcelRequire("dAYdE");
const $6a3a19ab96f60450$var$customCssStyles = null;
const $6a3a19ab96f60450$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dAYdE))),
        className: (0, $4jQY2.default)([
            "_2zz1idpf"
        ])
    });
$6a3a19ab96f60450$export$25a9d0fbcb127c90.displayName = "NextGenBoardSkeleton";

});
parcelRegister("dAYdE", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});



parcelRegister("aLAep", function(module, exports) {
$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRouteEntry", () => $dd39fdd8ed998e90$export$bdd0e204be6866cd);


var $fLLrQ = parcelRequire("fLLrQ");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $iwFYt = parcelRequire("iwFYt");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");
const $dd39fdd8ed998e90$export$bdd0e204be6866cd = (0, $fdS54.createEntry)((0, $iwFYt.softwareBoardViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $fLLrQ.boardViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fLLrQ", function(module, exports) {
$parcel$export(module.exports, "boardViewNotFoundPageEntrypoint", () => $2a33aab8a5e5d21a$export$7f51979492148d53);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $bHHLh = parcelRequire("bHHLh");

const $2a33aab8a5e5d21a$var$main = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5Sx4A")), {
        moduleId: "30d86a05",
        moduleName: "BoardViewNotFound",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const boardId = context.match.params.boardId;
        if (boardId == null) throw new Error('Board id missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $bHHLh.default,
                    variables: {
                        boardId: `ari:cloud:jira-software:${cloudId}:board/${boardId}`
                    }
                }
            }
        };
    }
});
const $2a33aab8a5e5d21a$export$7f51979492148d53 = (0, $dTa0V.createPageEntryPoint)({
    main: $2a33aab8a5e5d21a$var$main,
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("bHHLh", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fd659208781bef5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b4c2382e9edb79ca18ee82cc3dcb5e>>
 * @relayHash c015acb85644d3bee5c8b2cb145b1d66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51
const $4fd659208781bef5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51",
        "metadata": {},
        "name": "BoardViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4fd659208781bef5$export$2e2bcd8739ae039 = $4fd659208781bef5$var$node;

});

parcelRegister("5Sx4A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iDEBx").then(()=>parcelRequire('7YfTQ'));

});


parcelRegister("iwFYt", function(module, exports) {
$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRoute", () => $c6ae2470aa3cecd7$export$b31cf885abe93fbf);
const $c6ae2470aa3cecd7$export$b31cf885abe93fbf = {
    name: 'software-board-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("gSkfR", function(module, exports) {
$parcel$export(module.exports, "softwareBoardViewNotFoundRouteEntry", () => $9768a57f13cc7ad8$export$70fda0ba037c81ca);


var $fLLrQ = parcelRequire("fLLrQ");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $lcK3u = parcelRequire("lcK3u");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");
const $9768a57f13cc7ad8$export$70fda0ba037c81ca = (0, $fdS54.createEntry)((0, $lcK3u.softwareBoardViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $fLLrQ.boardViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lcK3u", function(module, exports) {
$parcel$export(module.exports, "softwareBoardViewNotFoundRoute", () => $94a5a43a9929850b$export$4c5eaffb9e70d071);
const $94a5a43a9929850b$export$4c5eaffb9e70d071 = {
    name: 'software-board-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("2qIgp", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicCustomEmbedRouteEntry", () => $0e3fd77c68027554$export$406edd4ac84413cc);
/* eslint-disable import/order */ 
var $cLdvY = parcelRequire("cLdvY");

var $fdS54 = parcelRequire("fdS54");

var $dD3QA = parcelRequire("dD3QA");

var $jmSzK = parcelRequire("jmSzK");

var $byMD7 = parcelRequire("byMD7");

var $4B518 = parcelRequire("4B518");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $ldGfw = parcelRequire("ldGfw");

var $dJzWg = parcelRequire("dJzWg");
const $0e3fd77c68027554$export$406edd4ac84413cc = (0, $fdS54.createEntry)((0, $dD3QA.softwareCalendarClassicCustomEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $jmSzK.CalendarEmbedSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jmSzK.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $dJzWg.softwareCalendarRouteEntry;
        },
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource))
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
            if ((0, $i860n.fg)('dfo_connectedtoissueaggquery')) {
                if (pluginId === 'resources-plugin') return context.match.url !== prevContext.match.url || context.query.selectedIssue !== undefined && context.query.selectedIssue !== prevContext.query.selectedIssue;
                return context.match.url !== prevContext.match.url;
            }
            return context.match.url !== prevContext.match.url;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dD3QA", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicCustomEmbedRoute", () => $f984a0f3d9ec64a6$export$15e88f3b033926ec);
const $f984a0f3d9ec64a6$export$15e88f3b033926ec = {
    name: 'software-calendar-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("dJzWg", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $b8c17fbf2e97d8f8$export$83b1b9036cc7961a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $2vbj7 = parcelRequire("2vbj7");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $b8c17fbf2e97d8f8$export$83b1b9036cc7961a = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2vbj7.calendarEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("2vbj7", function(module, exports) {
$parcel$export(module.exports, "calendarEntryPoint", () => $d5ffc561735b16a0$export$19cf4b398f638dc6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $iXN50 = parcelRequire("iXN50");

var $2700E = parcelRequire("2700E");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6ySM3 = parcelRequire("6ySM3");
const $d5ffc561735b16a0$var$storageProvider = typeof window !== 'undefined' ? (0, $iXN50.createLocalStorageProvider)() : undefined;
const $d5ffc561735b16a0$var$DEFAULT_CALENDAR_BOARD_SETTINGS = {
    additionalFilterQuery: ''
};
const $d5ffc561735b16a0$var$SETTINGS_STORAGE_KEY = 'calendar:settings:software';
/**
 * Must append boardId to the storage key to avoid conflicts with other boards.
 *
 * @example
 * const boardSpecificKey = `${CALENDAR_BOARD_SETTINGS_STORAGE_KEY}:${boardId}`;
 */ const $d5ffc561735b16a0$var$CALENDAR_BOARD_SETTINGS_STORAGE_KEY = 'calendar:settings:software:board';
function $d5ffc561735b16a0$var$getViewSettings(key) {
    try {
        // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
const $d5ffc561735b16a0$var$getCalendarBoardSettingsFromLocalStorage = (boardId)=>{
    const boardSpecificKey = `${$d5ffc561735b16a0$var$CALENDAR_BOARD_SETTINGS_STORAGE_KEY}:${boardId}`;
    const settings = $d5ffc561735b16a0$var$storageProvider?.get(boardSpecificKey);
    return {
        additionalFilterQuery: settings?.additionalFilterQuery ?? $d5ffc561735b16a0$var$DEFAULT_CALENDAR_BOARD_SETTINGS.additionalFilterQuery
    };
};
function $d5ffc561735b16a0$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $d5ffc561735b16a0$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $d5ffc561735b16a0$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
/* Given the current constraints that prevent importing route name constants into the entrypoint,
we are re-defining these constants here in order to perform a route name check.
Consider breaking this entrypoint per route to avoid these types of checks and dependencies. */ const $d5ffc561735b16a0$var$SOFTWARE_CALENDAR = 'software-calendar';
const $d5ffc561735b16a0$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
const $d5ffc561735b16a0$var$SOFTWARE_CALENDAR_CUSTOM_EMBED = 'software-calendar-custom-embed';
const $d5ffc561735b16a0$var$TEAM_MANAGED_CALENDAR_ROUTES = [
    $d5ffc561735b16a0$var$SOFTWARE_CALENDAR,
    $d5ffc561735b16a0$var$SOFTWARE_CALENDAR_EMBED,
    $d5ffc561735b16a0$var$SOFTWARE_CALENDAR_CUSTOM_EMBED
];
function $d5ffc561735b16a0$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    const isTMP = $d5ffc561735b16a0$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
    return {
        type: 'board',
        boardId: $d5ffc561735b16a0$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: isTMP ? [
            String(context.match.params.projectKey)
        ] : []
    };
}
function $d5ffc561735b16a0$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    const scopeInput = {
        ids: [
            scope.boardId
        ]
    };
    return {
        ...scopeInput,
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $d5ffc561735b16a0$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $d5ffc561735b16a0$var$toViewRange(mode) {
    switch(mode){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $d5ffc561735b16a0$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $d5ffc561735b16a0$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $d5ffc561735b16a0$var$toMidnightUTCString(selectedDate),
        mode: $d5ffc561735b16a0$var$toViewMode(viewRange),
        weekStart: $d5ffc561735b16a0$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
function $d5ffc561735b16a0$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d5ffc561735b16a0$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $d5ffc561735b16a0$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $d5ffc561735b16a0$export$19cf4b398f638dc6 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("i57Nk")), {
        moduleId: "51a0e9a7",
        moduleName: "CalendarEntryPoint",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $d5ffc561735b16a0$var$createScope(entryPointRouteParams);
        const { date: date, viewRange: viewRangeQueryParam, filter: filterQueryParam } = context.query;
        const selectedDate = $d5ffc561735b16a0$var$toDate(date);
        const boardId = String(context.match.params.boardId);
        const projectKey = String(context.match.params.projectKey);
        const settings = $d5ffc561735b16a0$var$getViewSettings($d5ffc561735b16a0$var$SETTINGS_STORAGE_KEY);
        const calendarBoardSettings = $d5ffc561735b16a0$var$getCalendarBoardSettingsFromLocalStorage(boardId);
        const issuesSearchInput = {
            additionalFilterQuery: filterQueryParam ?? calendarBoardSettings.additionalFilterQuery
        };
        const viewRange = $d5ffc561735b16a0$var$toViewRange(viewRangeQueryParam ?? 'month');
        const weekStartsOn = settings?.weekStartsOn ?? 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6ySM3.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $d5ffc561735b16a0$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $d5ffc561735b16a0$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $d5ffc561735b16a0$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $d5ffc561735b16a0$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $d5ffc561735b16a0$var$buildSprintsSearchInput(),
                        includeRecurrenceIndicator: true,
                        skipSprintSearch: false,
                        viewId: null,
                        skipVersionsV2Search: false,
                        skipUserPreferences: false,
                        hasSavedFilterCapability: (0, $2700E.expValEquals)('atlas-96240_saved_views_calendar', 'enabled', true, false),
                        filterScope: (0, $2700E.expValEquals)('calendar-filter-refinement-sprt', 'isEnabled', true, false) ? {
                            project: {
                                projectKey: projectKey
                            }
                        } : null,
                        isCalendarFilterRefinementEnabled: (0, $2700E.expValEquals)('calendar-filter-refinement-sprt', 'isEnabled', true, false)
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                boardId: boardId,
                hasRecurrenceItemIndicator: true,
                filterScope: (0, $2700E.expValEquals)('calendar-filter-refinement-sprt', 'isEnabled', true, false) ? {
                    project: {
                        projectKey: projectKey
                    }
                } : null
            }
        };
    }
});

});
parcelRegister("i57Nk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("1OIUD")
]).then(()=>parcelRequire('cUR8Y'));

});




parcelRegister("dGEFm", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicEmbedRouteEntry", () => $bfd029e340a90eb5$export$6a544072729c1964);

var $cLdvY = parcelRequire("cLdvY");

var $fdS54 = parcelRequire("fdS54");

var $fOXhY = parcelRequire("fOXhY");

var $jmSzK = parcelRequire("jmSzK");

var $byMD7 = parcelRequire("byMD7");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $4B518 = parcelRequire("4B518");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $ldGfw = parcelRequire("ldGfw");

var $dJzWg = parcelRequire("dJzWg");
const $bfd029e340a90eb5$export$6a544072729c1964 = (0, $fdS54.createEntry)((0, $fOXhY.softwareCalendarClassicEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $jmSzK.CalendarEmbedSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jmSzK.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $dJzWg.softwareCalendarRouteEntry;
        },
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4B518.jiraSpaResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource))
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
            if ((0, $i860n.fg)('dfo_connectedtoissueaggquery')) {
                if (pluginId === 'resources-plugin') return context.match.url !== prevContext.match.url || context.query.selectedIssue !== undefined && context.query.selectedIssue !== prevContext.query.selectedIssue;
                return context.match.url !== prevContext.match.url;
            }
            return context.match.url !== prevContext.match.url;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fOXhY", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", () => $1510608aaa1078ce$export$ced2612fe5124ff8);
const $1510608aaa1078ce$export$ced2612fe5124ff8 = {
    name: 'software-calendar-classic-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});


parcelRegister("lLfhz", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicRouteEntry", () => $693da5c4a98008c3$export$17ea82bdc641d5ce);

var $51vnM = parcelRequire("51vnM");


var $cLdvY = parcelRequire("cLdvY");

var $fdS54 = parcelRequire("fdS54");

var $i860n = parcelRequire("i860n");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $g3Is6 = parcelRequire("g3Is6");

var $jmSzK = parcelRequire("jmSzK");

var $QhQu4 = parcelRequire("QhQu4");

var $3eysO = parcelRequire("3eysO");

var $75Njg = parcelRequire("75Njg");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $8HUuJ = parcelRequire("8HUuJ");

var $gZWlI = parcelRequire("gZWlI");

var $dJzWg = parcelRequire("dJzWg");
const $693da5c4a98008c3$export$17ea82bdc641d5ce = (0, $fdS54.createEntry)((0, $g3Is6.softwareCalendarClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $jmSzK.CalendarSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jmSzK.CalendarSkeleton),
        entryPoint () {
            // TODO: Adopt sidebar entrypoints when calender route enables SSR
            return 0, $dJzWg.softwareCalendarRouteEntry;
        },
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.classicSoftwareProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gZWlI.projectThemeResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        ufoName: 'classic-calendar',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
            if ((0, $i860n.fg)('dfo_connectedtoissueaggquery')) {
                if (pluginId === 'resources-plugin') return context.match.url !== prevContext.match.url || context.query.selectedIssue !== undefined && context.query.selectedIssue !== prevContext.query.selectedIssue;
                return context.match.url !== prevContext.match.url;
            }
            return context.match.url !== prevContext.match.url;
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("g3Is6", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicRoute", () => $adb29afefe735c6a$export$f2c3b99639d54eb8);
const $adb29afefe735c6a$export$f2c3b99639d54eb8 = {
    name: 'software-calendar-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId?',
    query: [
        'date?'
    ]
};

});


parcelRegister("9e6Vx", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarCustomEmbedRouteEntry", () => $e8693930863023d1$export$bfbf26d8d634e108);
/* eslint-disable import/order */ 
var $cLdvY = parcelRequire("cLdvY");

var $byMD7 = parcelRequire("byMD7");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $4Wapk = parcelRequire("4Wapk");

var $jmSzK = parcelRequire("jmSzK");

var $4B518 = parcelRequire("4B518");

var $8HUuJ = parcelRequire("8HUuJ");

var $ldGfw = parcelRequire("ldGfw");

var $gi7C7 = parcelRequire("gi7C7");
const $e8693930863023d1$export$bfbf26d8d634e108 = (0, $fdS54.createEntry)((0, $4Wapk.softwareCalendarCustomEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $jmSzK.CalendarEmbedSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jmSzK.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $gi7C7.calendarRouteEntry;
        },
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource))
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
            if ((0, $i860n.fg)('dfo_connectedtoissueaggquery')) {
                if (pluginId === 'resources-plugin') return context.match.url !== prevContext.match.url || context.query.selectedIssue !== undefined && context.query.selectedIssue !== prevContext.query.selectedIssue;
                return context.match.url !== prevContext.match.url;
            }
            return context.match.url !== prevContext.match.url;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4Wapk", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarCustomEmbedRoute", () => $8873c18186924148$export$c933cc18934d5dbd);
const $8873c18186924148$export$c933cc18934d5dbd = {
    name: 'software-calendar-custom-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/:itemId/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("gi7C7", function(module, exports) {
$parcel$export(module.exports, "calendarRouteEntry", () => $6f081a4f319abbc4$export$d154630e8966be91);

var $hi6Of = parcelRequire("hi6Of");

var $2vbj7 = parcelRequire("2vbj7");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $6f081a4f319abbc4$export$d154630e8966be91 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2vbj7.calendarEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("iXxvM", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarEmbedRouteEntry", () => $5a89ca2444141991$export$24fc07c22f0d06);

var $cLdvY = parcelRequire("cLdvY");

var $byMD7 = parcelRequire("byMD7");

var $i860n = parcelRequire("i860n");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $4B518 = parcelRequire("4B518");

var $8HUuJ = parcelRequire("8HUuJ");

var $jePDa = parcelRequire("jePDa");

var $jmSzK = parcelRequire("jmSzK");

var $ldGfw = parcelRequire("ldGfw");

var $gi7C7 = parcelRequire("gi7C7");
const $5a89ca2444141991$export$24fc07c22f0d06 = (0, $fdS54.createEntry)((0, $jePDa.softwareCalendarEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $jmSzK.CalendarEmbedSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jmSzK.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $gi7C7.calendarRouteEntry;
        },
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            // Delete when cleaning up jira-nav4-yurree-resources-cleanup
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), (0, $hWEkS.incidentExperimentTraitResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), (0, $hFYSn.forgeProjectModuleResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), (0, $idDnR.staticProjectSidebarNavigationResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource))
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
            if ((0, $i860n.fg)('dfo_connectedtoissueaggquery')) {
                if (pluginId === 'resources-plugin') return context.match.url !== prevContext.match.url || context.query.selectedIssue !== undefined && context.query.selectedIssue !== prevContext.query.selectedIssue;
                return context.match.url !== prevContext.match.url;
            }
            return context.match.url !== prevContext.match.url;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("jePDa", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarEmbedRoute", () => $495772f3159584b0$export$b55c4d4efb097c1c);
const $495772f3159584b0$export$b55c4d4efb097c1c = {
    name: 'software-calendar-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});


parcelRegister("7vjYA", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $fd5bc6f8d5b23bd7$export$83b1b9036cc7961a);

var $51vnM = parcelRequire("51vnM");


var $cLdvY = parcelRequire("cLdvY");

var $jEYuY = parcelRequire("jEYuY");

var $i860n = parcelRequire("i860n");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $isrho = parcelRequire("isrho");

var $jmSzK = parcelRequire("jmSzK");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $8HUuJ = parcelRequire("8HUuJ");

var $gZWlI = parcelRequire("gZWlI");

var $gi7C7 = parcelRequire("gi7C7");
const $fd5bc6f8d5b23bd7$export$83b1b9036cc7961a = (0, $fdS54.createEntry)((0, $isrho.softwareCalendarRoute), ()=>({
        group: 'software',
        skeleton: (0, $jmSzK.CalendarSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jmSzK.CalendarSkeleton),
        entryPoint () {
            // TODO: Adopt sidebar entrypoints when calender route enables SSR
            return 0, $gi7C7.calendarRouteEntry;
        },
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $gZWlI.projectThemeResource),
            // Delete when cleaning up jira-nav4-yurree-resources-cleanup
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), (0, $hWEkS.incidentExperimentTraitResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), (0, $hFYSn.forgeProjectModuleResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), (0, $idDnR.staticProjectSidebarNavigationResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-nav4-yurree-resources-cleanup'), (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-calendar',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
            if ((0, $i860n.fg)('dfo_connectedtoissueaggquery')) {
                if (pluginId === 'resources-plugin') return context.match.url !== prevContext.match.url || context.query.selectedIssue !== undefined && context.query.selectedIssue !== prevContext.query.selectedIssue;
                return context.match.url !== prevContext.match.url;
            }
            return context.match.url !== prevContext.match.url;
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("isrho", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarRoute", () => $799f8e9f6ece7f36$export$d6730f103a4ad844);
const $799f8e9f6ece7f36$export$d6730f103a4ad844 = {
    name: 'software-calendar',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/:itemId?',
    query: [
        'date?'
    ]
};

});


parcelRegister("huTOz", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicPeopleEmbedRouteEntry", () => $729d40f487125826$export$60401437aa9aa595);

var $9CfRP = parcelRequire("9CfRP");

var $fdS54 = parcelRequire("fdS54");

var $cKOvO = parcelRequire("cKOvO");

var $byMD7 = parcelRequire("byMD7");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $862Zj = parcelRequire("862Zj");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $4B518 = parcelRequire("4B518");

var $3wvYd = parcelRequire("3wvYd");

var $dTa0V = parcelRequire("dTa0V");
const $729d40f487125826$var$softwareCapacityPeopleEmbedRouteEntry = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9CfRP.capacityEntryPoint)
});
const $729d40f487125826$export$60401437aa9aa595 = (0, $fdS54.createEntry)((0, $cKOvO.softwareCapacityClassicPeopleEmbedRoute), ()=>({
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3wvYd.CapacityEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return $729d40f487125826$var$softwareCapacityPeopleEmbedRouteEntry;
        },
        group: 'classic-software',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $862Zj.staticSidebarShortcutsResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4B518.jiraSpaResources)()
        ],
        skeleton: (0, $3wvYd.CapacityEmbedSkeleton),
        ufoName: 'classic-capacity-people-embed'
    }));

});
parcelRegister("9CfRP", function(module, exports) {
$parcel$export(module.exports, "capacityEntryPoint", () => $1ad8a25195a9faac$export$2ea9514c195131bd);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $bHdZo = parcelRequire("bHdZo");

const $1ad8a25195a9faac$export$2ea9514c195131bd = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("fuUll")), {
        moduleId: "ed4453dc",
        moduleName: "CapacityEntryPoint",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: { match: match }, tenantContext: tenantContext } = entryPointRouteParams;
        const boardId = match.params.boardId ?? '';
        const sourceAri = `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`;
        return {
            queries: {
                capacityData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bHdZo.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        id: sourceAri
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                tenantContext: tenantContext,
                sourceAri: sourceAri
            }
        };
    }
});

});
parcelRegister("bHdZo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ae17e8f0f0b70fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08060add23e9855b0af1bdd57c08d4b1>>
 * @relayHash 7653330fe77d5a9f4d6a8d3529559b3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 65ccbf7e5f79b9f99519b702745550e8e5f7d55589f62713d36e304750f2cdce

var $23227 = parcelRequire("23227");

var $6if4V = parcelRequire("6if4V");

var $6Xh0g = parcelRequire("6Xh0g");
const $7ae17e8f0f0b70fd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "65ccbf7e5f79b9f99519b702745550e8e5f7d55589f62713d36e304750f2cdce",
        "metadata": {},
        "name": "CapacityPeopleViewContentQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__isaiimportenabledrelayprovidertsx": (0, $23227.default),
            "__relay_internal__pv__isreorderingenabledrelayprovidertsx": (0, $6Xh0g.default),
            "__relay_internal__pv__isbulkeditenabledrelayprovidertsx": (0, $6if4V.default)
        }
    }
};
var $7ae17e8f0f0b70fd$export$2e2bcd8739ae039 = $7ae17e8f0f0b70fd$var$node;

});
parcelRegister("23227", function(module, exports) {
$parcel$export(module.exports, "default", () => $95dbc338e18a8e92$export$2e2bcd8739ae039);

var $egspI = parcelRequire("egspI");
var $95dbc338e18a8e92$export$2e2bcd8739ae039 = {
    get () {
        return (0, $egspI.fg)('icp_ai_import');
    }
};

});

parcelRegister("6if4V", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b2e01cddbbb7ba5$export$2e2bcd8739ae039);

var $egspI = parcelRequire("egspI");
var $4b2e01cddbbb7ba5$export$2e2bcd8739ae039 = {
    get () {
        return (0, $egspI.fg)('icp_bulk_edit') === true;
    }
};

});

parcelRegister("6Xh0g", function(module, exports) {
$parcel$export(module.exports, "default", () => $2be7482ecfa45d35$export$2e2bcd8739ae039);

var $egspI = parcelRequire("egspI");
var $2be7482ecfa45d35$export$2e2bcd8739ae039 = {
    get () {
        return (0, $egspI.fg)('icp_work_people_reordering');
    }
};

});


parcelRegister("fuUll", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8QERS").then(()=>parcelRequire('6OUCE'));

});


parcelRegister("cKOvO", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicPeopleEmbedRoute", () => $0b1747fc3e78fd39$export$ebdc0afccfad30ab);
const $0b1747fc3e78fd39$export$ebdc0afccfad30ab = {
    name: 'software-capacity-classic-people-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/people/embed',
    query: []
};

});

parcelRegister("3wvYd", function(module, exports) {
$parcel$export(module.exports, "CapacitySkeleton", () => $3d54e87263b9cd56$export$79fcfa58dbcaf030);
$parcel$export(module.exports, "CapacityEmbedSkeleton", () => $3d54e87263b9cd56$export$27d33e13f167f420);
$parcel$export(module.exports, "CapacityNoHeaderSkeleton", () => $3d54e87263b9cd56$export$a0dc4c0a6f5a9296);
$parcel$export(module.exports, "CapacityHeaderOnlySkeleton", () => $3d54e87263b9cd56$export$25e0d844d64bc11e);
$parcel$export(module.exports, "CapacityHeaderOnlySkeletonOld", () => $3d54e87263b9cd56$export$81a95f3ae7d83b12);
$parcel$export(module.exports, "EntryPointCapacityWithHeaderSkeleton", () => $3d54e87263b9cd56$export$8f45dadf0afadafd);
/* CapacitySkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $i860n = parcelRequire("i860n");

var $9TmFr = parcelRequire("9TmFr");

var $834Fe = parcelRequire("834Fe");

var $fT5gI = parcelRequire("fT5gI");

var $brbz6 = parcelRequire("brbz6");

var $liVxP = parcelRequire("liVxP");

var $cIZgD = parcelRequire("cIZgD");

var $1vJw1 = parcelRequire("1vJw1");
const $3d54e87263b9cd56$export$79fcfa58dbcaf030 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9TmFr))),
        className: (0, $4jQY2.default)([
            $3d54e87263b9cd56$var$styles.compensateTemplateBorder
        ])
    });
$3d54e87263b9cd56$export$79fcfa58dbcaf030.displayName = "CapacitySkeleton";
const $3d54e87263b9cd56$export$27d33e13f167f420 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($834Fe))),
        className: (0, $4jQY2.default)([
            $3d54e87263b9cd56$var$styles.compensateTemplateBorder
        ])
    });
$3d54e87263b9cd56$export$27d33e13f167f420.displayName = "CapacityEmbedSkeleton";
const $3d54e87263b9cd56$export$a0dc4c0a6f5a9296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fT5gI))),
        className: (0, $4jQY2.default)([
            $3d54e87263b9cd56$var$styles.noBorder,
            $3d54e87263b9cd56$var$styles.compensateTemplateBorder
        ])
    });
$3d54e87263b9cd56$export$a0dc4c0a6f5a9296.displayName = "CapacityNoHeaderSkeleton";
const $3d54e87263b9cd56$export$25e0d844d64bc11e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($brbz6))),
        containerStyles: {
            height: '44px',
            flexShrink: 0
        },
        className: (0, $4jQY2.default)([
            $3d54e87263b9cd56$var$styles.noBorder,
            $3d54e87263b9cd56$var$styles.compensateTemplateBorder
        ])
    });
$3d54e87263b9cd56$export$25e0d844d64bc11e.displayName = "CapacityHeaderOnlySkeleton";
const $3d54e87263b9cd56$export$81a95f3ae7d83b12 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($liVxP))),
        containerStyles: {
            height: '44px',
            flexShrink: 0
        },
        className: (0, $4jQY2.default)([
            $3d54e87263b9cd56$var$styles.noBorder,
            $3d54e87263b9cd56$var$styles.compensateTemplateBorder
        ])
    });
$3d54e87263b9cd56$export$81a95f3ae7d83b12.displayName = "CapacityHeaderOnlySkeletonOld";
const $3d54e87263b9cd56$export$e3ed7fd4e4f69e94 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cIZgD))),
        className: (0, $4jQY2.default)([
            $3d54e87263b9cd56$var$styles.noBorder,
            $3d54e87263b9cd56$var$styles.compensateTemplateBorder
        ])
    });
$3d54e87263b9cd56$export$e3ed7fd4e4f69e94.displayName = "CapacityWithHeaderSkeleton";
const $3d54e87263b9cd56$export$259c35fa3a3f9454 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1vJw1))),
        className: (0, $4jQY2.default)([
            $3d54e87263b9cd56$var$styles.noBorder,
            $3d54e87263b9cd56$var$styles.compensateTemplateBorder
        ])
    });
$3d54e87263b9cd56$export$259c35fa3a3f9454.displayName = "CapacityWithHeaderSkeletonOld";
const $3d54e87263b9cd56$export$8f45dadf0afadafd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            $3d54e87263b9cd56$var$styles.entryPointStyles
        ])
    }, (0, $i860n.fg)('icp_ai_import') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3d54e87263b9cd56$export$e3ed7fd4e4f69e94, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3d54e87263b9cd56$export$259c35fa3a3f9454, null));
$3d54e87263b9cd56$export$8f45dadf0afadafd.displayName = "EntryPointCapacityWithHeaderSkeleton";
const $3d54e87263b9cd56$var$styles = {
    compensateTemplateBorder: "_t6vdidpf _hr4jidpf _l82tidpf _j7o0idpf",
    entryPointStyles: "_1reo15vq _18m915vq _1rjc1ejb _bozg1ejb _16jlkb7n _4t3i1osq",
    noBorder: "_1wgmglyw"
};

});
parcelRegister("9TmFr", function(module, exports) {
module.exports = new URL("capacity-app-skeleton.tpl.61191f22.svg", import.meta.url).toString();

});

parcelRegister("834Fe", function(module, exports) {
module.exports = new URL("capacity-embed-app-skeleton.tpl.61191f22.svg", import.meta.url).toString();

});

parcelRegister("fT5gI", function(module, exports) {
module.exports = new URL("capacity-no-header-skeleton.tpl.61191f22.svg", import.meta.url).toString();

});

parcelRegister("brbz6", function(module, exports) {
module.exports = new URL("capacity-header-only-skeleton.tpl.554374e5.svg", import.meta.url).toString();

});

parcelRegister("liVxP", function(module, exports) {
module.exports = new URL("capacity-header-only-skeleton-old.tpl.31c4baa7.svg", import.meta.url).toString();

});

parcelRegister("cIZgD", function(module, exports) {
module.exports = new URL("capacity-with-header-skeleton.tpl.dbbfef90.svg", import.meta.url).toString();

});

parcelRegister("1vJw1", function(module, exports) {
module.exports = new URL("capacity-with-header-skeleton-old.tpl.af1f2ed8.svg", import.meta.url).toString();

});



parcelRegister("1vzE5", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicRouteEntry", () => $d9874b5a31eff82a$export$d503898bb2c92461);

var $51vnM = parcelRequire("51vnM");



var $fdS54 = parcelRequire("fdS54");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $amFJz = parcelRequire("amFJz");

var $3eysO = parcelRequire("3eysO");

var $75Njg = parcelRequire("75Njg");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $gZWlI = parcelRequire("gZWlI");

var $3wvYd = parcelRequire("3wvYd");

var $kNCMG = parcelRequire("kNCMG");
const $d9874b5a31eff82a$export$d503898bb2c92461 = (0, $fdS54.createEntry)((0, $amFJz.softwareCapacityClassicRoute), ()=>({
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3wvYd.CapacitySkeleton),
        entryPoint: ()=>{
            if (false) return undefined;
            return 0, $kNCMG.softwareCapacityRouteEntry;
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        group: 'classic-software',
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $ldGfw.getIssueViewResources)(),
            ...(0, $dUAVJ.getNavigationResources)(),
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gZWlI.projectThemeResource)
        ],
        skeleton: (0, $3wvYd.CapacitySkeleton),
        supportsPreviewPanel: true,
        supportsProjectTheme: 'contoured',
        ufoName: 'classic-capacity'
    }));

});
parcelRegister("amFJz", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicRoute", () => $c3e0a6c77effaf02$export$df4c9b5e5502344a);
const $c3e0a6c77effaf02$export$df4c9b5e5502344a = {
    name: 'software-capacity-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/:view(people|work)?',
    query: []
};

});

parcelRegister("kNCMG", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityRouteEntry", () => $07342bb68b8f37bf$export$7c0a73481693ad26);
/* eslint-disable jira/naming/disallow-filenames */ 
var $5YIbU = parcelRequire("5YIbU");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $07342bb68b8f37bf$export$7c0a73481693ad26 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5YIbU.softwareCapacityParentEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("5YIbU", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityParentEntryPoint", () => $6794e8d297fb1511$export$10a266abd7a26b4b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7VZmM = parcelRequire("7VZmM");

var $9CfRP = parcelRequire("9CfRP");

var $axdUI = parcelRequire("axdUI");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $dAcqC = parcelRequire("dAcqC");
const $6794e8d297fb1511$var$ICP_MOST_RECENT_VIEW_COOKIE = 'icp_most_recent_view';
const $6794e8d297fb1511$var$isCapacityView = (value)=>value === 'people' || value === 'work';
const $6794e8d297fb1511$var$getCookieValue = (name)=>globalThis?.__GET_COOKIE__?.(name) ?? globalThis?.document?.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop();
const $6794e8d297fb1511$var$getViewFromCookie = ()=>{
    const mostRecentView = $6794e8d297fb1511$var$getCookieValue($6794e8d297fb1511$var$ICP_MOST_RECENT_VIEW_COOKIE)?.toLowerCase();
    return mostRecentView === 'work' ? 'work' : 'people';
};

const $6794e8d297fb1511$export$10a266abd7a26b4b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1JGk7")), {
        moduleId: "332d8a4c",
        moduleName: "SoftwareCapacityContainer",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointParams)=>{
        const { context: { match: match, route: route }, tenantContext: tenantContext } = entryPointParams;
        const viewParamRaw = match.params.view;
        const viewParam = $6794e8d297fb1511$var$isCapacityView(viewParamRaw) ? viewParamRaw : undefined;
        const boardId = match.params.boardId;
        if (!boardId) throw new Error('boardId is required for software capacity');
        const boardAri = `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`;
        const isCMP = route.name.startsWith('software-capacity-classic');
        // Use URL param if set, otherwise fall back to cookie.
        const activeView = viewParam ?? $6794e8d297fb1511$var$getViewFromCookie();
        return {
            queries: {
                boardFilterData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $dAcqC.default,
                    variables: {
                        boardId: boardAri,
                        isCMP: isCMP,
                        includeBoardJql: (0, $i860n.fg)('icp_people_work_recommendation')
                    }
                }
            },
            extraProps: {
                activeView: activeView,
                viewParam: viewParam,
                tenantContext: tenantContext
            },
            entryPoints: {
                headerControlPanel: {
                    entryPoint: (0, $7VZmM.capacityHeaderControlPanelEntryPoint),
                    entryPointParams: entryPointParams
                },
                work: activeView === 'work' ? {
                    entryPoint: (0, $axdUI.capacityWorkEntryPoint),
                    entryPointParams: entryPointParams
                } : undefined,
                people: activeView === 'people' ? {
                    entryPoint: (0, $9CfRP.capacityEntryPoint),
                    entryPointParams: entryPointParams
                } : undefined
            }
        };
    }
});

});
parcelRegister("7VZmM", function(module, exports) {
$parcel$export(module.exports, "capacityHeaderControlPanelEntryPoint", () => $cb8f82b82ce25ede$export$574fc0521bd75adb);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $a5stn = parcelRequire("a5stn");

const $cb8f82b82ce25ede$export$574fc0521bd75adb = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1qM9j")), {
        moduleId: "bed4ad24",
        moduleName: "SoftwareCapacityHeaderControlPanelEntryPoint",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: { match: match }, tenantContext: tenantContext } = entryPointRouteParams;
        const boardId = match.params.boardId;
        if (!boardId) throw new Error('boardId is required for capacity header control panel');
        const sourceAri = `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`;
        return {
            queries: {
                headerControlPanelData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $a5stn.default,
                    variables: {
                        id: sourceAri
                    }
                }
            }
        };
    }
});

});
parcelRegister("a5stn", function(module, exports) {
$parcel$export(module.exports, "default", () => $26b393c3ee3f2b55$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8096b147ed24f7f04c7692eb1a042852>>
 * @relayHash 9f5daf267ba841ca3405893d93917ec1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d08279cf4aa6afaf958ccfad90eb70e8d991ce775fa4f30b704b598c14cdca2c
const $26b393c3ee3f2b55$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d08279cf4aa6afaf958ccfad90eb70e8d991ce775fa4f30b704b598c14cdca2c",
        "metadata": {},
        "name": "HeaderControlPanelContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $26b393c3ee3f2b55$export$2e2bcd8739ae039 = $26b393c3ee3f2b55$var$node;

});

parcelRegister("1qM9j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("06lCg").then(()=>parcelRequire('edvjw'));

});


parcelRegister("axdUI", function(module, exports) {
$parcel$export(module.exports, "capacityWorkEntryPoint", () => $e7b24d417aa3f202$export$a4da442de848981b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $kWo2n = parcelRequire("kWo2n");

const $e7b24d417aa3f202$export$a4da442de848981b = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8URFd")), {
        moduleId: "634e72e6",
        moduleName: "SoftwareCapacityWorkEntryPoint",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: { match: match }, tenantContext: tenantContext } = entryPointRouteParams;
        const boardId = match.params.boardId;
        if (!boardId) throw new Error('boardId is required for capacity work view');
        const sourceAri = `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`;
        return {
            queries: {
                capacityData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kWo2n.default,
                    variables: {
                        id: sourceAri
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                tenantContext: tenantContext,
                sourceAri: sourceAri
            }
        };
    }
});

});
parcelRegister("kWo2n", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8d7629563e7681d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebae0f03969db112bb088f69ffe78085>>
 * @relayHash a20c097e1a7def5c9d2bbc9ae1d9251b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID af14fdd6541cfb1fc8fd4e7d5760a04e71787cfa33fe36e65842c29811d876c2

var $23227 = parcelRequire("23227");

var $6Xh0g = parcelRequire("6Xh0g");
const $c8d7629563e7681d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "af14fdd6541cfb1fc8fd4e7d5760a04e71787cfa33fe36e65842c29811d876c2",
        "metadata": {},
        "name": "CapacityWorkViewContentQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__isreorderingenabledrelayprovidertsx": (0, $6Xh0g.default),
            "__relay_internal__pv__isaiimportenabledrelayprovidertsx": (0, $23227.default)
        }
    }
};
var $c8d7629563e7681d$export$2e2bcd8739ae039 = $c8d7629563e7681d$var$node;

});

parcelRegister("8URFd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ch0Y8").then(()=>parcelRequire('4WP7r'));

});


parcelRegister("dAcqC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c49e32fe4d27eeb4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2d3ea9ef31abd71f6c2436fc8fb5dfb>>
 * @relayHash 80fdeb47579d1a9684bee7502dcfaf87
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e417de34ba10a08295f1761f71b6cc1bd7cb2cebb45ca848a312e3e2d5c42de8
const $c49e32fe4d27eeb4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e417de34ba10a08295f1761f71b6cc1bd7cb2cebb45ca848a312e3e2d5c42de8",
        "metadata": {},
        "name": "SoftwareCapacityContainerBoardFilterQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c49e32fe4d27eeb4$export$2e2bcd8739ae039 = $c49e32fe4d27eeb4$var$node;

});

parcelRegister("1JGk7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4qDaH").then(()=>parcelRequire('dk4YI'));

});




parcelRegister("de0Ix", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicWorkEmbedRouteEntry", () => $81ab51c077f92195$export$9f0fe842131c936a);

var $axdUI = parcelRequire("axdUI");

var $fdS54 = parcelRequire("fdS54");

var $hr3nv = parcelRequire("hr3nv");

var $byMD7 = parcelRequire("byMD7");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $862Zj = parcelRequire("862Zj");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $4B518 = parcelRequire("4B518");

var $3wvYd = parcelRequire("3wvYd");

var $dTa0V = parcelRequire("dTa0V");
const $81ab51c077f92195$var$softwareCapacityWorkEmbedRouteEntry = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $axdUI.capacityWorkEntryPoint)
});
const $81ab51c077f92195$export$9f0fe842131c936a = (0, $fdS54.createEntry)((0, $hr3nv.softwareCapacityClassicWorkEmbedRoute), ()=>({
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3wvYd.CapacityEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return $81ab51c077f92195$var$softwareCapacityWorkEmbedRouteEntry;
        },
        group: 'classic-software',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $862Zj.staticSidebarShortcutsResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4B518.jiraSpaResources)()
        ],
        skeleton: (0, $3wvYd.CapacityEmbedSkeleton),
        ufoName: 'classic-capacity-work-embed'
    }));

});
parcelRegister("hr3nv", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicWorkEmbedRoute", () => $5124ae5a84218641$export$1cb27c6afb3814aa);
const $5124ae5a84218641$export$1cb27c6afb3814aa = {
    name: 'software-capacity-classic-work-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/work/embed',
    query: []
};

});


parcelRegister("7bi6n", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityPeopleEmbedRouteEntry", () => $9a9765ba1631dd28$export$7e2cb0f23926bdba);

var $byMD7 = parcelRequire("byMD7");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $862Zj = parcelRequire("862Zj");

var $fdS54 = parcelRequire("fdS54");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $4B518 = parcelRequire("4B518");

var $ebGU7 = parcelRequire("ebGU7");

var $3wvYd = parcelRequire("3wvYd");

var $6fPSZ = parcelRequire("6fPSZ");
const $9a9765ba1631dd28$export$7e2cb0f23926bdba = (0, $fdS54.createEntry)((0, $ebGU7.softwareCapacityPeopleEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $3wvYd.CapacityEmbedSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3wvYd.CapacityEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $6fPSZ.capacityPeopleRouteEntry;
        },
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $862Zj.staticSidebarShortcutsResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4B518.jiraSpaResources)()
        ],
        ufoName: 'next-gen-capacity-people-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ebGU7", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityPeopleEmbedRoute", () => $2911321c27455a7d$export$41cd1cfbd6002314);
const $2911321c27455a7d$export$41cd1cfbd6002314 = {
    name: 'software-capacity-people-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/people/embed',
    query: []
};

});

parcelRegister("6fPSZ", function(module, exports) {
$parcel$export(module.exports, "capacityPeopleRouteEntry", () => $e7c88a1b4cd964fb$export$723ef332ad91604e);

var $hi6Of = parcelRequire("hi6Of");

var $9CfRP = parcelRequire("9CfRP");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $e7c88a1b4cd964fb$export$723ef332ad91604e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9CfRP.capacityEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("9B0aY", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityRouteEntry", () => $e8efd8b682351448$export$7c0a73481693ad26);

var $euxye = parcelRequire("euxye");

var $51vnM = parcelRequire("51vnM");


var $jEYuY = parcelRequire("jEYuY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $bhPZc = parcelRequire("bhPZc");

var $3wvYd = parcelRequire("3wvYd");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $gZWlI = parcelRequire("gZWlI");

var $kGIlx = parcelRequire("kGIlx");
const $e8efd8b682351448$export$7c0a73481693ad26 = (0, $fdS54.createEntry)((0, $bhPZc.softwareCapacityRoute), ()=>({
        group: 'software',
        skeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3wvYd.EntryPointCapacityWithHeaderSkeleton), null),
        // eslint-disable-next-line no-restricted-syntax
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3wvYd.EntryPointCapacityWithHeaderSkeleton), null),
        entryPoint () {
            if (false) return undefined;
            return 0, $kGIlx.capacityRouteEntry;
        },
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gZWlI.projectThemeResource)
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-capacity',
        supportsPreviewPanel: true,
        supportsProjectTheme: 'contoured',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bhPZc", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityRoute", () => $0d36d5c1382aa946$export$57ddb8414c776aa1);
const $0d36d5c1382aa946$export$57ddb8414c776aa1 = {
    name: 'software-capacity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/:view(people|work)?',
    query: []
};

});

parcelRegister("kGIlx", function(module, exports) {
$parcel$export(module.exports, "capacityRouteEntry", () => $7b7813f42e5bb1b4$export$721be00e430c45e);

var $hi6Of = parcelRequire("hi6Of");

var $5YIbU = parcelRequire("5YIbU");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $7b7813f42e5bb1b4$export$721be00e430c45e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5YIbU.softwareCapacityParentEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("gJDfg", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityWorkEmbedRouteEntry", () => $e4563a0cd680314f$export$bd99dba585d7b878);

var $byMD7 = parcelRequire("byMD7");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $862Zj = parcelRequire("862Zj");

var $fdS54 = parcelRequire("fdS54");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $4B518 = parcelRequire("4B518");

var $frMYq = parcelRequire("frMYq");

var $3wvYd = parcelRequire("3wvYd");

var $97gNQ = parcelRequire("97gNQ");
const $e4563a0cd680314f$export$bd99dba585d7b878 = (0, $fdS54.createEntry)((0, $frMYq.softwareCapacityWorkEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $3wvYd.CapacityEmbedSkeleton),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3wvYd.CapacityEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $97gNQ.capacityWorkRouteEntry;
        },
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $862Zj.staticSidebarShortcutsResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4B518.jiraSpaResources)()
        ],
        ufoName: 'next-gen-capacity-work-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("frMYq", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityWorkEmbedRoute", () => $d4800b67485ca86c$export$526adf51ffebd886);
const $d4800b67485ca86c$export$526adf51ffebd886 = {
    name: 'software-capacity-work-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/work/embed',
    query: []
};

});

parcelRegister("97gNQ", function(module, exports) {
$parcel$export(module.exports, "capacityWorkRouteEntry", () => $6571924c18674d19$export$8f544867c662f74a);

var $hi6Of = parcelRequire("hi6Of");

var $axdUI = parcelRequire("axdUI");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $6571924c18674d19$export$8f544867c662f74a = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $axdUI.capacityWorkEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("ioh4Q", function(module, exports) {
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRouteEntry", () => $7b5e03d9573aae25$export$fdc2679a6c96e9fa);

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $edf7u = parcelRequire("edf7u");

var $4IIPJ = parcelRequire("4IIPJ");

var $byMD7 = parcelRequire("byMD7");

var $e265i = parcelRequire("e265i");
const $7b5e03d9573aae25$export$fdc2679a6c96e9fa = (0, $fdS54.createEntry)((0, $4IIPJ.softwareClassicProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $e265i.default),
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $edf7u.projectContextResource)
        ],
        forPaint: [
            (0, $e265i.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4IIPJ", function(module, exports) {
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", () => $1f3f5bade15b73e7$export$16987cdd084cceba);
const $1f3f5bade15b73e7$export$16987cdd084cceba = {
    name: 'classic-software-proforma-issue-forms-direct-embed',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("e265i", function(module, exports) {
$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $a1e941dcc332fd05$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $a1e941dcc332fd05$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $a1e941dcc332fd05$export$22681210aaeb910f = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("bTGU2")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/ProformaJiraIssueFormsDirectEmbedWrapper.tsx"
});
const $a1e941dcc332fd05$var$AsyncProformaIssueFormsDirectEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $a1e941dcc332fd05$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });
$a1e941dcc332fd05$var$AsyncProformaIssueFormsDirectEmbed.displayName = "AsyncProformaIssueFormsDirectEmbed";
var $a1e941dcc332fd05$export$2e2bcd8739ae039 = $a1e941dcc332fd05$var$AsyncProformaIssueFormsDirectEmbed;

});


parcelRegister("jFJKp", function(module, exports) {
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRouteEntry", () => $382a345b633c9c73$export$8fd8b0cbd2b8730d);


var $fdS54 = parcelRequire("fdS54");

var $9TaTx = parcelRequire("9TaTx");

var $3eysO = parcelRequire("3eysO");

var $edf7u = parcelRequire("edf7u");

var $9w3P1 = parcelRequire("9w3P1");
const $382a345b633c9c73$export$8fd8b0cbd2b8730d = (0, $fdS54.createEntry)((0, $9TaTx.softwareClassicProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-software',
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            (0, $edf7u.projectContextResource)
        ],
        entryPoint: ()=>(0, $9w3P1.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9TaTx", function(module, exports) {
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", () => $272288b0a6420fec$export$92f34907c6bf7007);
const $272288b0a6420fec$export$92f34907c6bf7007 = {
    name: 'classic-software-proforma-issue-forms-direct',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("9w3P1", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $3117a2cdc5ea42dd$export$dc0bb5719ae7aab4);
/* eslint-disable jira/naming/disallow-filenames */ 
var $gb6l3 = parcelRequire("gb6l3");

var $dTa0V = parcelRequire("dTa0V");
const $3117a2cdc5ea42dd$export$dc0bb5719ae7aab4 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $gb6l3.proformaIssueFormsDirectEntryPoint)
});

});


parcelRegister("fUfB9", function(module, exports) {
$parcel$export(module.exports, "softwareCodeClassicRouteEntry", () => $1ba2cd9deaa646b9$export$6acfada96c85cfaa);



var $iSoIx = parcelRequire("iSoIx");

var $052eo = parcelRequire("052eo");

var $fdS54 = parcelRequire("fdS54");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $i860n = parcelRequire("i860n");

var $75Njg = parcelRequire("75Njg");

var $dUAVJ = parcelRequire("dUAVJ");

var $I9cL6 = parcelRequire("I9cL6");

var $3eysO = parcelRequire("3eysO");

var $jDjCj = parcelRequire("jDjCj");
const $1ba2cd9deaa646b9$export$6acfada96c85cfaa = (0, $fdS54.createEntry)((0, $I9cL6.softwareCodeClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        entryPoint: ()=>{
            if ((0, $052eo.isDevopsFeatureDisabledInFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            return (0, $i860n.fg)('navx-global-side-nav') ? (0, $jDjCj.GSNSoftwareCodeClassicPageEntrypoint) : (0, $jDjCj.softwareCodeClassicPageEntrypoint);
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("I9cL6", function(module, exports) {
$parcel$export(module.exports, "softwareCodeClassicRoute", () => $292cbc398cc8e9ff$export$d92cd77785d00ff);
const $292cbc398cc8e9ff$export$d92cd77785d00ff = {
    name: 'software-code-classic',
    path: '/jira/software/c/projects/:projectKey/code'
};

});

parcelRegister("jDjCj", function(module, exports) {
$parcel$export(module.exports, "softwareCodeClassicPageEntrypoint", () => $f520a5923ed7d21f$export$10463031c8017b);
$parcel$export(module.exports, "GSNSoftwareCodeClassicPageEntrypoint", () => $f520a5923ed7d21f$export$fe7fe6fa8acb2aee);
/* eslint-disable jira/naming/disallow-filenames */ 
var $cuCO3 = parcelRequire("cuCO3");

var $3KSG6 = parcelRequire("3KSG6");

var $dTa0V = parcelRequire("dTa0V");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");
const $f520a5923ed7d21f$export$10463031c8017b = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $cuCO3.softwareCodeEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $f520a5923ed7d21f$export$fe7fe6fa8acb2aee = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $cuCO3.softwareCodeEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("cuCO3", function(module, exports) {
$parcel$export(module.exports, "softwareCodeEntrypoint", () => $4c3521e14623daef$export$7dbaba2b508f1f10);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $4c3521e14623daef$export$7dbaba2b508f1f10 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("fAKPw")), {
        moduleId: "7390c6ca",
        moduleName: "CodeSpaV2",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fAKPw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("8ixg2")
]).then(()=>parcelRequire('i21X3'));

});




parcelRegister("54Pxb", function(module, exports) {
$parcel$export(module.exports, "softwareCodeRouteEntry", () => $323b4746a45b6641$export$eac18b7aea4cb524);


var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $052eo = parcelRequire("052eo");

var $jEYuY = parcelRequire("jEYuY");

var $aWliK = parcelRequire("aWliK");

var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $luewH = parcelRequire("luewH");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $i860n = parcelRequire("i860n");

var $4Mlim = parcelRequire("4Mlim");
const $323b4746a45b6641$var$getHorizontalNavResource = ()=>(0, $i860n.fg)('entrypoint_migration_for_software_code') ? [] : [
        (0, $7tgMD.horizontalNavJiraResource)
    ];
const $323b4746a45b6641$export$eac18b7aea4cb524 = (0, $fdS54.createEntry)((0, $luewH.softwareCodeRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)((0, $052eo.isDevopsFeatureDisabledInFedRamp), (0, $lFLfF.default), (0, $4Mlim.CodePageNextGen)),
        layout: (0, $3eysO.softwareProjectLayoutCode),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            ...$323b4746a45b6641$var$getHorizontalNavResource()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4Mlim.LazyCode)
        ],
        entryPoint: ()=>{
            if ((0, $i860n.fg)('entrypoint_migration_for_software_code')) return (0, $052eo.isDevopsFeatureDisabledInFedRamp)() ? (0, $iSoIx.notFoundPageEntrypoint) : (0, $4Mlim.softwareCodeNextGenPageEntrypoint);
            return undefined;
        },
        ufoName: 'next-gen-code',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("luewH", function(module, exports) {
$parcel$export(module.exports, "softwareCodeRoute", () => $f8952672427e3a30$export$9d24fc75b0f1d9a0);
const $f8952672427e3a30$export$9d24fc75b0f1d9a0 = {
    name: 'software-code',
    path: '/jira/software/projects/:projectKey/code'
};

});

parcelRegister("4Mlim", function(module, exports) {
$parcel$export(module.exports, "LazyCode", () => $0f2509fdffd5f823$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageNextGen", () => $0f2509fdffd5f823$export$d9e8184332f86b53);
$parcel$export(module.exports, "softwareCodeNextGenPageEntrypoint", () => $0f2509fdffd5f823$export$bba7318d4079a95);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hi6Of = parcelRequire("hi6Of");

var $cuCO3 = parcelRequire("cuCO3");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $3KSG6 = parcelRequire("3KSG6");

var $dTa0V = parcelRequire("dTa0V");

var $lenAs = parcelRequire("lenAs");

const $0f2509fdffd5f823$export$4beafd9dbad29bff = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("fAKPw"))), {
    moduleId: "./src/packages/spa-apps/code/src/CodeSpaV2.tsx"
});
const $0f2509fdffd5f823$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0f2509fdffd5f823$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $lenAs.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
$0f2509fdffd5f823$export$d9e8184332f86b53.displayName = "CodePageNextGen";
const $0f2509fdffd5f823$export$bba7318d4079a95 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $cuCO3.softwareCodeEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("lenAs", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $bb89e621693cb848$export$557c2f222778cea6);
/* eslint-disable jira/naming/disallow-filenames */ 
var $bS1iz = parcelRequire("bS1iz");
const $bb89e621693cb848$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(location.search);
    return rapidView;
};

});



parcelRegister("fJNsm", function(module, exports) {
$parcel$export(module.exports, "softwareCompanyManagedAgentsRouteEntry", () => $f117ab7c2af4f220$export$b41936f87ef78328);

var $870NF = parcelRequire("870NF");

var $1h3Ak = parcelRequire("1h3Ak");



var $gyAS0 = parcelRequire("gyAS0");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");

var $2700E = parcelRequire("2700E");

var $dTa0V = parcelRequire("dTa0V");

var $iSoIx = parcelRequire("iSoIx");
const $f117ab7c2af4f220$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $870NF.agentsHomeEntryPoint)
});
const $f117ab7c2af4f220$export$b41936f87ef78328 = (0, $fdS54.createEntry)((0, $1h3Ak.softwareCompanyManagedAgentsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.agents.jsw-cmp',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $d579872b9d7d689d$export$983f2e89073dd86)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        entryPoint: ()=>(0, $2700E.expVal)('yamato-agents-home-space-settings-beta', 'isEnabled', false) ? $f117ab7c2af4f220$var$pageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        meta: {
            reporting: {
                packageName: 'jiraProjectSettingsAgentsHome',
                id: 'project-settings.agents.jsw-cmp',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("870NF", function(module, exports) {
$parcel$export(module.exports, "agentsHomeEntryPoint", () => $1405df07ac4fb637$export$c5b25c6dc778e823);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $1405df07ac4fb637$export$c5b25c6dc778e823 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("4GNKn")), {
        moduleId: "d425435e",
        moduleName: "AgentsHomeApp",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4GNKn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1yse4").then(()=>parcelRequire('lXUfb'));

});


parcelRegister("1h3Ak", function(module, exports) {
$parcel$export(module.exports, "softwareCompanyManagedAgentsRoute", () => $b323ed466547667d$export$1febbf8a67f169f);
const $b323ed466547667d$export$1febbf8a67f169f = {
    name: 'software-company-managed-agents',
    path: '/jira/software/c/projects/:projectKey/settings/agents',
    exact: true
};

});

const $d579872b9d7d689d$export$983f2e89073dd86 = 'SPACE_AGENTS';


parcelRegister("d4Kv4", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsClassicRouteEntry", () => $c80d8b6e902b7894$export$dcf1f9ba660dedf6);

var $74oEx = parcelRequire("74oEx");


var $iSoIx = parcelRequire("iSoIx");

var $052eo = parcelRequire("052eo");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $3CqgD = parcelRequire("3CqgD");

var $hWEkS = parcelRequire("hWEkS");

var $ailKG = parcelRequire("ailKG");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $ip2qt = parcelRequire("ip2qt");
const $c80d8b6e902b7894$export$dcf1f9ba660dedf6 = (0, $fdS54.createEntry)((0, $ailKG.softwareDeploymentsClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $3CqgD.deploymentPreconditionRelayResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        entryPoint: ()=>(0, $052eo.isDevopsFeatureDisabledInFedRamp)() ? (0, $iSoIx.notFoundPageEntrypoint) : (0, $ip2qt.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-deployments-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3CqgD", function(module, exports) {
$parcel$export(module.exports, "deploymentPreconditionRelayResource", () => $80f6ed6e38662460$export$50e4eedb9e6127c8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gdk0z = parcelRequire("gdk0z");

var $htsFl = parcelRequire("htsFl");

var $7edbf = parcelRequire("7edbf");
const $80f6ed6e38662460$var$RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $80f6ed6e38662460$var$RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION_RELAY = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

const $80f6ed6e38662460$export$a1c09d7f7318f85c = (0, $7edbf.createResource)({
    type: $80f6ed6e38662460$var$RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION,
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("kxPbI")),
    maxAge: 60000
});
const $80f6ed6e38662460$export$50e4eedb9e6127c8 = (0, $htsFl.createRelayResource)({
    type: $80f6ed6e38662460$var$RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION_RELAY,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $gdk0z.default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: String(match.params.projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("gdk0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $efacfa6ef9e54fcc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef059a3bf7025544a090270585313b63>>
 * @relayHash 30b3b4c98728e6d8df90bcd7260947b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0da0df7a2cc14efe99be26c64e2273a2f486581c7042e7c7c380792413310fa
const $efacfa6ef9e54fcc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "deploymentsFeaturePreconditionByProjectKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PreconditionCheckQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v1 /*: any*/ ,
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PreconditionCheckQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "c0da0df7a2cc14efe99be26c64e2273a2f486581c7042e7c7c380792413310fa",
            "metadata": {},
            "name": "PreconditionCheckQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$efacfa6ef9e54fcc$var$node.hash = "03cf79a1a58a23b75e425cb6cdf7a7e6";
var $efacfa6ef9e54fcc$export$2e2bcd8739ae039 = $efacfa6ef9e54fcc$var$node;

});

parcelRegister("kxPbI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cORIl").then(()=>parcelRequire('1fy4Z'));

});


parcelRegister("ailKG", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsClassicRoute", () => $73972f926c113783$export$485e4a7b82f29d70);
const $73972f926c113783$export$485e4a7b82f29d70 = {
    name: 'software-deployments-classic',
    path: '/jira/software/c/projects/:projectKey/deployments'
};

});

parcelRegister("ip2qt", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsPageEntrypoint", () => $a13935ebc2bae6b1$export$44d7744645dea53c);

var $4Srij = parcelRequire("4Srij");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $a13935ebc2bae6b1$export$44d7744645dea53c = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4Srij.softwareDeploymentsEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("4Srij", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsEntrypoint", () => $c7c6c64f2cc50656$export$c51c7780e55a0186);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $c7c6c64f2cc50656$export$c51c7780e55a0186 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("a4Gxq")), {
        moduleId: "15aebcbc",
        moduleName: "DeploymentsPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("a4Gxq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("irGC5").then(()=>parcelRequire('9B1V3'));

});




parcelRegister("h9tcg", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsNextGenRouteEntry", () => $28751e6f56721822$export$7e5ccb20ad8e1612);

var $74oEx = parcelRequire("74oEx");


var $iSoIx = parcelRequire("iSoIx");

var $052eo = parcelRequire("052eo");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $3CqgD = parcelRequire("3CqgD");

var $hWEkS = parcelRequire("hWEkS");

var $4wf6U = parcelRequire("4wf6U");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $ip2qt = parcelRequire("ip2qt");
const $28751e6f56721822$export$7e5ccb20ad8e1612 = (0, $fdS54.createEntry)((0, $4wf6U.softwareDeploymentsNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $3CqgD.deploymentPreconditionRelayResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        entryPoint: ()=>(0, $052eo.isDevopsFeatureDisabledInFedRamp)() ? (0, $iSoIx.notFoundPageEntrypoint) : (0, $ip2qt.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-deployments'),
                teamName: 'fusion-solaris'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4wf6U", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsNextGenRoute", () => $22b1f0626e656dca$export$4b0939825a323ea5);
const $22b1f0626e656dca$export$4b0939825a323ea5 = {
    name: 'software-deployments',
    path: '/jira/software/projects/:projectKey/deployments'
};

});


parcelRegister("6IQcp", function(module, exports) {
$parcel$export(module.exports, "softwareFormBuilderClassicRouteEntry", () => $b758eba9ec5b8182$export$96aa488380334044);



var $oXLtZ = parcelRequire("oXLtZ");

var $6lhMD = parcelRequire("6lhMD");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $3FSzw = parcelRequire("3FSzw");

var $3KSG6 = parcelRequire("3KSG6");

var $3eysO = parcelRequire("3eysO");

var $dTa0V = parcelRequire("dTa0V");

var $75Njg = parcelRequire("75Njg");

var $gZWlI = parcelRequire("gZWlI");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");

var $i860n = parcelRequire("i860n");
const $b758eba9ec5b8182$var$formBuilderPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6lhMD.formBuilderEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $b758eba9ec5b8182$var$GSNFormBuilderPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6lhMD.formBuilderEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $b758eba9ec5b8182$export$96aa488380334044 = (0, $fdS54.createEntry)((0, $3FSzw.softwareFormBuilderClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-builder',
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gZWlI.projectThemeResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? $b758eba9ec5b8182$var$GSNFormBuilderPageEntrypoint : $b758eba9ec5b8182$var$formBuilderPageEntrypoint,
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6lhMD", function(module, exports) {
$parcel$export(module.exports, "formBuilderEntrypoint", () => $9c260a9960ed9a53$export$6d3c9fa7232f412c);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $bhpl8 = parcelRequire("bhpl8");

const $9c260a9960ed9a53$export$6d3c9fa7232f412c = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("9OFsr")), {
        moduleId: "64fef73e",
        moduleName: "JiraSoftwareFormBuilderApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bhpl8.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("bhpl8", function(module, exports) {
$parcel$export(module.exports, "default", () => $703a09e5724975cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5152123c5deccf99b1d648d9eba4f49d>>
 * @relayHash 494d8258faf52b56ead95e20e76dd5f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 61c7c3c454dc6822fea33b1b6d5c9002b0be0f4002aa1362d23caf71e7dba486
const $703a09e5724975cd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "61c7c3c454dc6822fea33b1b6d5c9002b0be0f4002aa1362d23caf71e7dba486",
        "metadata": {},
        "name": "JiraSoftwareFormBuilderAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $703a09e5724975cd$export$2e2bcd8739ae039 = $703a09e5724975cd$var$node;

});

parcelRegister("9OFsr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("aULk9")
]).then(()=>parcelRequire('4qIKU'));

});


parcelRegister("3FSzw", function(module, exports) {
$parcel$export(module.exports, "softwareFormBuilderClassicRoute", () => $c24800c317c48b6b$export$f6cfee0232aa1e);
const $c24800c317c48b6b$export$f6cfee0232aa1e = {
    name: 'software-form-builder-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
    exact: true
};

});


parcelRegister("ctRYW", function(module, exports) {
$parcel$export(module.exports, "softwareFormBuilderRouteEntry", () => $3e7e361b916274ed$export$e8dede7671fad23d);

var $hi6Of = parcelRequire("hi6Of");


var $oXLtZ = parcelRequire("oXLtZ");

var $6lhMD = parcelRequire("6lhMD");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $8R9LY = parcelRequire("8R9LY");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $3KSG6 = parcelRequire("3KSG6");

var $dTa0V = parcelRequire("dTa0V");

var $gZWlI = parcelRequire("gZWlI");
const $3e7e361b916274ed$var$formBuilderPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6lhMD.formBuilderEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $3e7e361b916274ed$export$e8dede7671fad23d = (0, $fdS54.createEntry)((0, $8R9LY.softwareFormBuilderRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-builder',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gZWlI.projectThemeResource)
        ],
        entryPoint: ()=>$3e7e361b916274ed$var$formBuilderPageEntrypoint,
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8R9LY", function(module, exports) {
$parcel$export(module.exports, "softwareFormBuilderRoute", () => $a8d9185967dea853$export$c5589046ee2a390d);
const $a8d9185967dea853$export$c5589046ee2a390d = {
    name: 'software-form-builder',
    path: '/jira/software/projects/:projectKey/form/:formId/builder',
    exact: true
};

});


parcelRegister("hlYPF", function(module, exports) {
$parcel$export(module.exports, "softwareFormClassicRouteEntry", () => $b20f7bfa0fe8b96c$export$4bb0f20ad6471148);



var $oXLtZ = parcelRequire("oXLtZ");

var $2eb1s = parcelRequire("2eb1s");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $3KSG6 = parcelRequire("3KSG6");

var $hmEKQ = parcelRequire("hmEKQ");

var $dTa0V = parcelRequire("dTa0V");

var $3eysO = parcelRequire("3eysO");

var $75Njg = parcelRequire("75Njg");

var $gZWlI = parcelRequire("gZWlI");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");

var $i860n = parcelRequire("i860n");
const $b20f7bfa0fe8b96c$var$formPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2eb1s.formEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $b20f7bfa0fe8b96c$var$GSNFormPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2eb1s.formEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $b20f7bfa0fe8b96c$export$4bb0f20ad6471148 = (0, $fdS54.createEntry)((0, $hmEKQ.softwareFormClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form',
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gZWlI.projectThemeResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? $b20f7bfa0fe8b96c$var$GSNFormPageEntrypoint : $b20f7bfa0fe8b96c$var$formPageEntrypoint,
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2eb1s", function(module, exports) {
$parcel$export(module.exports, "formEntrypoint", () => $71e6295902ed4cd3$export$b931eb60522f687a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $7tpgs = parcelRequire("7tpgs");

const $71e6295902ed4cd3$export$b931eb60522f687a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("evbdN")), {
        moduleId: "2596bbc8",
        moduleName: "JiraSoftwareFormApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $7tpgs.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("7tpgs", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5bf7ad75dda0de0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cb6ec97b5d80f17cf95a2ad98f1f0a7>>
 * @relayHash 3e504c2a5cd0303a43a0d4f9f1731b08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c7d3d77866ff1cede55d066114d2d3a2ca66881db35990578af056b96d50101
const $e5bf7ad75dda0de0$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0c7d3d77866ff1cede55d066114d2d3a2ca66881db35990578af056b96d50101",
        "metadata": {},
        "name": "JiraSoftwareFormAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e5bf7ad75dda0de0$export$2e2bcd8739ae039 = $e5bf7ad75dda0de0$var$node;

});

parcelRegister("evbdN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ewKRg").then(()=>parcelRequire('jM1LM'));

});


parcelRegister("hmEKQ", function(module, exports) {
$parcel$export(module.exports, "softwareFormClassicRoute", () => $fe4f7e7370cb4874$export$ae560ee5b676193d);
const $fe4f7e7370cb4874$export$ae560ee5b676193d = {
    name: 'software-form-classic',
    path: '/jira/software/c/projects/:projectKey/form',
    exact: true
};

});


parcelRegister("4PE7M", function(module, exports) {
$parcel$export(module.exports, "softwareFormRouteEntry", () => $2ba5c47f08c74df1$export$563e3b39911993a0);

var $hi6Of = parcelRequire("hi6Of");


var $oXLtZ = parcelRequire("oXLtZ");

var $2eb1s = parcelRequire("2eb1s");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $eIbZ2 = parcelRequire("eIbZ2");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $3KSG6 = parcelRequire("3KSG6");

var $dTa0V = parcelRequire("dTa0V");

var $gZWlI = parcelRequire("gZWlI");
const $2ba5c47f08c74df1$var$formPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2eb1s.formEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $2ba5c47f08c74df1$export$563e3b39911993a0 = (0, $fdS54.createEntry)((0, $eIbZ2.softwareFormRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gZWlI.projectThemeResource)
        ],
        entryPoint: ()=>$2ba5c47f08c74df1$var$formPageEntrypoint,
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eIbZ2", function(module, exports) {
$parcel$export(module.exports, "softwareFormRoute", () => $c0d17f3a1f847606$export$a46217d369231a5);
const $c0d17f3a1f847606$export$a46217d369231a5 = {
    name: 'software-form',
    path: '/jira/software/projects/:projectKey/form',
    exact: true
};

});


parcelRegister("1nIbC", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitClassicPublicRouteEntry", () => $48e91ac1fb94d251$export$df7e146d38db5cc0);
/* eslint-disable import/order */ 
var $bUOmx = parcelRequire("bUOmx");

var $fdS54 = parcelRequire("fdS54");

var $iQlNF = parcelRequire("iQlNF");

var $4B518 = parcelRequire("4B518");

var $byMD7 = parcelRequire("byMD7");
const $48e91ac1fb94d251$export$df7e146d38db5cc0 = (0, $fdS54.createEntry)((0, $iQlNF.softwareFormSubmitClassicPublicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-public',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        // This public route should not include
        // DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
        // remove all usages of projectKey.
        entryPoint: ()=>(0, $bUOmx.formSubmitPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("iQlNF", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitClassicPublicRoute", () => $1bbb614faa7ea162$export$c66ba06e288dec3f);
const $1bbb614faa7ea162$export$c66ba06e288dec3f = {
    name: 'software-form-submit-classic-public',
    path: '/jira/software/c/form/:formUuid',
    exact: true
};

});


parcelRegister("dQ7Zd", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitClassicRouteEntry", () => $d34d435234054f4e$export$a7c8812838762453);


var $oXLtZ = parcelRequire("oXLtZ");

var $1VTY3 = parcelRequire("1VTY3");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $dTa0V = parcelRequire("dTa0V");

var $4F5fZ = parcelRequire("4F5fZ");

var $byMD7 = parcelRequire("byMD7");
const $d34d435234054f4e$var$formSubmitPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1VTY3.formSubmitEntrypoint)
});
const $d34d435234054f4e$export$a7c8812838762453 = (0, $fdS54.createEntry)((0, $4F5fZ.softwareFormSubmitClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit',
        layout: (0, $byMD7.chromelessLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>$d34d435234054f4e$var$formSubmitPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1VTY3", function(module, exports) {
$parcel$export(module.exports, "formSubmitEntrypoint", () => $6b5a9e04d73f0723$export$d33b8db02e0a0cb5);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $6b5a9e04d73f0723$export$d33b8db02e0a0cb5 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("iX4cw")), {
        moduleId: "c733be65",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iX4cw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("67PNb")
]).then(()=>parcelRequire('hvlPc'));

});


parcelRegister("4F5fZ", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitClassicRoute", () => $568d7ce2e6cca143$export$91d6851bf27349);
const $568d7ce2e6cca143$export$91d6851bf27349 = {
    name: 'software-form-submit-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("9qcOI", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRouteEntry", () => $e407ba8abe14073a$export$ffc85d68201bbe35);


var $7lPQ5 = parcelRequire("7lPQ5");

var $oXLtZ = parcelRequire("oXLtZ");

var $fdS54 = parcelRequire("fdS54");

var $byMD7 = parcelRequire("byMD7");

var $3NuNT = parcelRequire("3NuNT");

var $dTa0V = parcelRequire("dTa0V");
const $e407ba8abe14073a$var$formSubmitEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $7lPQ5.formSubmitEmbedEntrypoint)
});
const $e407ba8abe14073a$export$ffc85d68201bbe35 = (0, $fdS54.createEntry)((0, $3NuNT.softwareFormSubmitEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-embed',
        layout: (0, $byMD7.chromelessLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        // eslint-disable-next-line camelcase
        resources: [
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return $e407ba8abe14073a$var$formSubmitEmbedPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7lPQ5", function(module, exports) {
$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $ef5dbba026f97cfe$export$4c748d8ca82fc24);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ef5dbba026f97cfe$export$4c748d8ca82fc24 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dxd1w")), {
        moduleId: "73648999",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dxd1w", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("ajf2I")
]).then(()=>parcelRequire('caGNx'));

});


parcelRegister("3NuNT", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRoute", () => $875940f740f91e6b$export$812703a022333f7c);
const $875940f740f91e6b$export$812703a022333f7c = {
    name: 'software-form-submit-classic-embed',
    path: '/jira/software/c/projects/:projectKey/form/:formId/embed',
    exact: true
};

});


parcelRegister("2LaFd", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitEmbedRouteEntry", () => $8e8e694e11f89a50$export$ac2e374edf86801f);
// eslint-disable-next-line jira/import/no-restricted-import, camelcase

var $oXLtZ = parcelRequire("oXLtZ");

var $7lPQ5 = parcelRequire("7lPQ5");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $1JJtn = parcelRequire("1JJtn");

var $dTa0V = parcelRequire("dTa0V");
const $8e8e694e11f89a50$var$formSubmitEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $7lPQ5.formSubmitEmbedEntrypoint)
});
const $8e8e694e11f89a50$export$ac2e374edf86801f = (0, $fdS54.createEntry)((0, $1JJtn.softwareFormSubmitEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-embed',
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line camelcase
        resources: [
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return $8e8e694e11f89a50$var$formSubmitEmbedPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1JJtn", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitEmbedRoute", () => $ac1565bc87269916$export$2bee26f083dc2946);
const $ac1565bc87269916$export$2bee26f083dc2946 = {
    name: 'software-form-submit-embed',
    path: '/jira/software/projects/:projectKey/form/:formId/embed',
    exact: true
};

});


parcelRegister("l2mgI", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitPublicRouteEntry", () => $f29eb6cdd114a230$export$70893a47a5c041fd);
/* eslint-disable import/order */ 
var $bUOmx = parcelRequire("bUOmx");

var $fdS54 = parcelRequire("fdS54");

var $lbHXW = parcelRequire("lbHXW");

var $byMD7 = parcelRequire("byMD7");

var $4B518 = parcelRequire("4B518");
const $f29eb6cdd114a230$export$70893a47a5c041fd = (0, $fdS54.createEntry)((0, $lbHXW.softwareFormSubmitPublicRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-public',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        // This public route should not include
        // DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
        // remove all usages of projectKey.
        entryPoint: ()=>(0, $bUOmx.formSubmitPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lbHXW", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitPublicRoute", () => $0b3f8bbfae0e46e6$export$d238522bd96fb720);
const $0b3f8bbfae0e46e6$export$d238522bd96fb720 = {
    name: 'software-form-submit-public',
    path: '/jira/software/form/:formUuid',
    exact: true
};

});


parcelRegister("lGA0k", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitRouteEntry", () => $3332138bac1629e6$export$752724866670c36);


var $oXLtZ = parcelRequire("oXLtZ");

var $1VTY3 = parcelRequire("1VTY3");

var $byMD7 = parcelRequire("byMD7");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $8y2MI = parcelRequire("8y2MI");

var $dTa0V = parcelRequire("dTa0V");
const $3332138bac1629e6$var$formSubmitPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $1VTY3.formSubmitEntrypoint)
});
const $3332138bac1629e6$export$752724866670c36 = (0, $fdS54.createEntry)((0, $8y2MI.softwareFormSubmitRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit',
        layout: (0, $byMD7.chromelessLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>$3332138bac1629e6$var$formSubmitPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8y2MI", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitRoute", () => $16917f8e0da62cf0$export$75b28ee1c7f02f00);
const $16917f8e0da62cf0$export$75b28ee1c7f02f00 = {
    name: 'software-form-submit',
    path: '/jira/software/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("uFd6W", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsClassicRouteEntry", () => $cfc7ce01ab857a57$export$58d10390fc181fcf);



var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $75Njg = parcelRequire("75Njg");

var $fHJGw = parcelRequire("fHJGw");

var $i860n = parcelRequire("i860n");

var $jRa1D = parcelRequire("jRa1D");
const $cfc7ce01ab857a57$export$58d10390fc181fcf = (0, $fdS54.createEntry)((0, $fHJGw.softwareGoalsClassicRoute), ()=>({
        group: 'classic-software',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? (0, $jRa1D.GSNSoftwareGoalsClassicPageEntrypoint) : (0, $jRa1D.softwareGoalsClassicPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fHJGw", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsClassicRoute", () => $28fb4050a3fa7de7$export$d12f3924cf53b545);
const $28fb4050a3fa7de7$export$d12f3924cf53b545 = {
    name: 'software-goals-classic',
    path: '/jira/software/c/projects/:projectKey/goals'
};

});

parcelRegister("jRa1D", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsClassicPageEntrypoint", () => $65d96a0ce87d0247$export$6c6f7e606a16292);
$parcel$export(module.exports, "GSNSoftwareGoalsClassicPageEntrypoint", () => $65d96a0ce87d0247$export$5b2461ebcbb8a66);
/* eslint-disable jira/naming/disallow-filenames */ 
var $7ZQ4A = parcelRequire("7ZQ4A");

var $dTa0V = parcelRequire("dTa0V");

var $eDEQ5 = parcelRequire("eDEQ5");

var $3KSG6 = parcelRequire("3KSG6");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");
const $65d96a0ce87d0247$export$6c6f7e606a16292 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7ZQ4A.softwareGoalsEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $65d96a0ce87d0247$export$5b2461ebcbb8a66 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7ZQ4A.softwareGoalsEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7ZQ4A", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsEntrypoint", () => $ca56804147325c04$export$a75f86449cc34a72);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $95Suf = parcelRequire("95Suf");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $ca56804147325c04$export$a75f86449cc34a72 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("5S4DJ")), {
        moduleId: "6dae33e7",
        moduleName: "SoftwareGoalsComponent",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: { match: match } })=>{
        const { projectKey: projectKey } = match.params;
        return {
            queries: {
                linkedGoalsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $95Suf.default),
                    variables: {
                        projectKey: projectKey ?? '',
                        cloudId: cloudId,
                        cloudIdAsId: cloudId,
                        first: 15,
                        after: null
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey ?? undefined
            }
        };
    }
});

});
parcelRegister("95Suf", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbf83eb00cf5ec92$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7896ef110f9246521e45f0321a498597>>
 * @relayHash 18ddcc3405d47b3e8a49048770d8854b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf1bddd448997e0a4b36eb021a1605c73d29a7406cb035f377b1ba1c4bd57e0e
const $dbf83eb00cf5ec92$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bf1bddd448997e0a4b36eb021a1605c73d29a7406cb035f377b1ba1c4bd57e0e",
        "metadata": {},
        "name": "LinkedGoalsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $dbf83eb00cf5ec92$export$2e2bcd8739ae039 = $dbf83eb00cf5ec92$var$node;

});

parcelRegister("5S4DJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("eVMEV")
]).then(()=>parcelRequire('hyXeT'));

});




parcelRegister("cs4H2", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsRouteEntry", () => $37189ee23b30846c$export$d3fcc412edfa2068);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $8Jg0U = parcelRequire("8Jg0U");

var $75Njg = parcelRequire("75Njg");

var $3atxP = parcelRequire("3atxP");
const $37189ee23b30846c$export$d3fcc412edfa2068 = (0, $fdS54.createEntry)((0, $8Jg0U.softwareGoalsRoute), ()=>({
        group: 'software',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $3atxP.softwareGoalsPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8Jg0U", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsRoute", () => $319ede05b2db8f70$export$2328fed7ebee3cce);
const $319ede05b2db8f70$export$2328fed7ebee3cce = {
    name: 'software-goals',
    exact: true,
    path: '/jira/software/projects/:projectKey/goals'
};

});

parcelRegister("3atxP", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsPageEntrypoint", () => $df571816528fd4f3$export$6c63903b420029c0);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $7ZQ4A = parcelRequire("7ZQ4A");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $df571816528fd4f3$export$6c63903b420029c0 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7ZQ4A.softwareGoalsEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("lJ0vE", function(module, exports) {
$parcel$export(module.exports, "softwareInboxClassicRouteEntry", () => $d5792b11c3607c45$export$ca6aeb36a7b6211d);

var $74oEx = parcelRequire("74oEx");


var $brrcZ = parcelRequire("brrcZ");

var $dvtoW = parcelRequire("dvtoW");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $75Njg = parcelRequire("75Njg");

var $fT9zl = parcelRequire("fT9zl");

var $836A7 = parcelRequire("836A7");

var $1x9PT = parcelRequire("1x9PT");
const $d5792b11c3607c45$export$ca6aeb36a7b6211d = (0, $fdS54.createEntry)((0, $brrcZ.softwareInboxClassicRoute), ()=>({
        group: 'classic-software',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $fT9zl.InboxTableSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $836A7.getCommonProjectResources)()
        ],
        layout: (0, $QhQu4.createLayout)((0, $dvtoW.genericProjectLayout)),
        entryPoint: ()=>(0, $1x9PT.inboxPageEntryPoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("brrcZ", function(module, exports) {
$parcel$export(module.exports, "softwareInboxClassicRoute", () => $ca6b439638413cab$export$a3612f128eff4e3c);
const $ca6b439638413cab$export$a3612f128eff4e3c = {
    name: 'inbox-classic',
    path: '/jira/software/c/projects/:projectKey/inbox/:issueKey?'
};

});

parcelRegister("fT9zl", function(module, exports) {
$parcel$export(module.exports, "InboxTableSkeleton", () => $13aa862795924fd7$export$568bd3d46cd43a09);
/* InboxTableSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $SrKfn = parcelRequire("SrKfn");
const $13aa862795924fd7$var$customCssStyles = null;
const $13aa862795924fd7$var$containerStyles = {
    height: '504px'
};
const $13aa862795924fd7$export$568bd3d46cd43a09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($SrKfn))),
        containerStyles: $13aa862795924fd7$var$containerStyles,
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    });
$13aa862795924fd7$export$568bd3d46cd43a09.displayName = "InboxTableSkeleton";

});
parcelRegister("SrKfn", function(module, exports) {
module.exports = new URL("inbox-table-skeleton.tpl.a385d40e.svg", import.meta.url).toString();

});


parcelRegister("1x9PT", function(module, exports) {
$parcel$export(module.exports, "inboxPageEntryPoint", () => $55b42c7f813c62a0$export$6da9e4ae87b73009);
/* eslint-disable jira/naming/disallow-filenames */ 
var $2IoDb = parcelRequire("2IoDb");

var $3KSG6 = parcelRequire("3KSG6");

var $dTa0V = parcelRequire("dTa0V");
const $55b42c7f813c62a0$export$6da9e4ae87b73009 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2IoDb.customerServiceInboxPageEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("2IoDb", function(module, exports) {
$parcel$export(module.exports, "customerServiceInboxPageEntrypoint", () => $1c3cb189e0936ee2$export$bf72eb0f567836ce);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $1c3cb189e0936ee2$export$bf72eb0f567836ce = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jfcGC")), {
        moduleId: "cf509bf0",
        moduleName: "CustomerServiceInboxApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("jfcGC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("cTXLr")
]).then(()=>parcelRequire('9L0Fa'));

});




parcelRegister("6cVAZ", function(module, exports) {
$parcel$export(module.exports, "softwareInboxNextGenRouteEntry", () => $35fc008c1abb99d4$export$22d61f7936797fc0);

var $74oEx = parcelRequire("74oEx");


var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $ki60Z = parcelRequire("ki60Z");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $fT9zl = parcelRequire("fT9zl");

var $836A7 = parcelRequire("836A7");

var $1x9PT = parcelRequire("1x9PT");
const $35fc008c1abb99d4$export$22d61f7936797fc0 = (0, $fdS54.createEntry)((0, $ki60Z.softwareInboxNextGenRoute), ()=>({
        group: 'software',
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $fT9zl.InboxTableSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $836A7.getCommonProjectResources)()
        ],
        layout: (0, $QhQu4.createLayout)((0, $3eysO.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $1x9PT.inboxPageEntryPoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ki60Z", function(module, exports) {
$parcel$export(module.exports, "softwareInboxNextGenRoute", () => $524dd443439fabd5$export$e44454ed868d0941);
const $524dd443439fabd5$export$e44454ed868d0941 = {
    name: 'inbox',
    path: '/jira/software/projects/:projectKey/inbox/:issueKey?'
};

});


parcelRegister("ka3fH", function(module, exports) {
$parcel$export(module.exports, "softwareIncidentsClassicRouteEntry", () => $49cbc7ca6955772f$export$c7d98bfe75274932);

var $74oEx = parcelRequire("74oEx");


var $i860n = parcelRequire("i860n");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $afKD6 = parcelRequire("afKD6");

var $gPlGE = parcelRequire("gPlGE");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $bsD8p = parcelRequire("bsD8p");

var $fidt3 = parcelRequire("fidt3");
const $49cbc7ca6955772f$export$c7d98bfe75274932 = (0, $fdS54.createEntry)((0, $afKD6.softwareIncidentsClassicRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $i860n.fg)('corex_operandi_incidents_page_in_jira') ? (0, $bsD8p.entryPoint) : (0, $fidt3.entryPointDeprecated);
        },
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        skeleton: (0, $gPlGE.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hWEkS.incidentsInitialPageChecksResource),
            (0, $hWEkS.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-incidents-classic'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("afKD6", function(module, exports) {
$parcel$export(module.exports, "softwareIncidentsClassicRoute", () => $ec6e31bed867f811$export$3356a7870a2717f4);
const $ec6e31bed867f811$export$3356a7870a2717f4 = {
    name: 'software-incidents-classic',
    path: '/jira/software/c/projects/:projectKey/incidents'
};

});

parcelRegister("gPlGE", function(module, exports) {
$parcel$export(module.exports, "IncidentsPageSkeleton", () => $47236bbcd2128053$export$3105d59d9ca899bd);
$parcel$export(module.exports, "IncidentsTableSkeleton", () => $47236bbcd2128053$export$7092b8ea63ebf9be);
/* IncidentsPageSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $f1gTe = parcelRequire("f1gTe");

var $hGke5 = parcelRequire("hGke5");
const $47236bbcd2128053$var$incidentsPageSkeletonStyles = null;
const $47236bbcd2128053$var$incidentsTableSkeletonStyles = null;
const $47236bbcd2128053$export$3105d59d9ca899bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
        className: (0, $4jQY2.default)([
            "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f1gTe)))
    }));
$47236bbcd2128053$export$3105d59d9ca899bd.displayName = "IncidentsPageSkeleton";
const $47236bbcd2128053$export$7092b8ea63ebf9be = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hGke5)))
    }));
$47236bbcd2128053$export$7092b8ea63ebf9be.displayName = "IncidentsTableSkeleton";

});
parcelRegister("f1gTe", function(module, exports) {
module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();

});

parcelRegister("hGke5", function(module, exports) {
module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();

});


parcelRegister("bsD8p", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $5864a62774a541db$export$6333901e831d7af0);

var $hi6Of = parcelRequire("hi6Of");

var $ROhEG = parcelRequire("ROhEG");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $5864a62774a541db$export$6333901e831d7af0 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ROhEG.incidentsPageEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("ROhEG", function(module, exports) {
$parcel$export(module.exports, "incidentsPageEntryPoint", () => $60ca5805e8d4f3e0$export$a59477eea6e8cd7f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $wDeUq = parcelRequire("wDeUq");
const $60ca5805e8d4f3e0$var$AriGraphSortOrderInput = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $60ca5805e8d4f3e0$var$QUERY_PARAM_SEARCH = 'search';
const $60ca5805e8d4f3e0$var$QUERY_PARAM_PRIORITY = 'priority';
const $60ca5805e8d4f3e0$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
const $60ca5805e8d4f3e0$var$QUERY_PARAM_STATUS = 'status';
const $60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_BY = 'sortBy';
const $60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
const $60ca5805e8d4f3e0$var$STATUS_SORT_KEY = 'status';
const $60ca5805e8d4f3e0$var$CREATED_SORT_KEY = 'created';
const $60ca5805e8d4f3e0$var$PRIORITY_SORT_KEY = 'priority';
const $60ca5805e8d4f3e0$var$SUMMARY_SORT_KEY = 'key';
const $60ca5805e8d4f3e0$var$ASC_SORT_KEY = 'ASC';
const $60ca5805e8d4f3e0$var$DESC_SORT_KEY = 'DESC';
function $60ca5805e8d4f3e0$var$notEmpty(value) {
    return Boolean(value);
}
const $60ca5805e8d4f3e0$var$isPriority = $60ca5805e8d4f3e0$var$notEmpty;
const $60ca5805e8d4f3e0$var$isStatus = (val)=>val === 'resolved' || val === 'open';
const $60ca5805e8d4f3e0$var$isSortBy = (val)=>val === $60ca5805e8d4f3e0$var$STATUS_SORT_KEY || val === $60ca5805e8d4f3e0$var$CREATED_SORT_KEY || val === $60ca5805e8d4f3e0$var$PRIORITY_SORT_KEY || val === $60ca5805e8d4f3e0$var$SUMMARY_SORT_KEY;
const $60ca5805e8d4f3e0$var$isSortOrder = (val)=>val === $60ca5805e8d4f3e0$var$ASC_SORT_KEY || val === $60ca5805e8d4f3e0$var$DESC_SORT_KEY;
const $60ca5805e8d4f3e0$var$isAffectedService = $60ca5805e8d4f3e0$var$notEmpty;
function $60ca5805e8d4f3e0$var$parseParameter(parameter, parameterValidationFn) {
    return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
}
const $60ca5805e8d4f3e0$var$parseQueryParams = (paramsRaw)=>{
    const result = {
        [$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_BY]: paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_BY] && $60ca5805e8d4f3e0$var$isSortBy(paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_BY] : $60ca5805e8d4f3e0$var$CREATED_SORT_KEY,
        [$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_ORDER] && $60ca5805e8d4f3e0$var$isSortOrder(paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_ORDER] : $60ca5805e8d4f3e0$var$DESC_SORT_KEY
    };
    result[$60ca5805e8d4f3e0$var$QUERY_PARAM_AFFECTED_SERVICE] = $60ca5805e8d4f3e0$var$parseParameter(paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_AFFECTED_SERVICE], $60ca5805e8d4f3e0$var$isAffectedService);
    result[$60ca5805e8d4f3e0$var$QUERY_PARAM_STATUS] = $60ca5805e8d4f3e0$var$parseParameter(paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_STATUS], $60ca5805e8d4f3e0$var$isStatus);
    result[$60ca5805e8d4f3e0$var$QUERY_PARAM_SEARCH] = paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_SEARCH] ?? undefined;
    result[$60ca5805e8d4f3e0$var$QUERY_PARAM_PRIORITY] = $60ca5805e8d4f3e0$var$parseParameter(paramsRaw[$60ca5805e8d4f3e0$var$QUERY_PARAM_PRIORITY], $60ca5805e8d4f3e0$var$isPriority);
    return result;
};
const $60ca5805e8d4f3e0$var$getFilterValue = (// oxlint-disable-next-line @typescript-eslint/no-explicit-any
values)=>({
        ...values.length > 0 ? {
            is: values
        } : {}
    });
const $60ca5805e8d4f3e0$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
        switch(stat){
            case 'open':
                return [
                    'NEW',
                    'INDETERMINATE'
                ];
            case 'resolved':
                return [
                    'DONE'
                ];
            default:
                return [
                    'UNDEFINED'
                ];
        }
    });
const $60ca5805e8d4f3e0$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
        and: [
            {
                to_status: $60ca5805e8d4f3e0$var$getFilterValue($60ca5805e8d4f3e0$var$parseStatusToFilterValues(parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_STATUS] ?? [])),
                to_priority: $60ca5805e8d4f3e0$var$getFilterValue(parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_PRIORITY] ?? []),
                to_affectedServiceAris: $60ca5805e8d4f3e0$var$getFilterValue(parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
            }
        ]
    });
const $60ca5805e8d4f3e0$var$parseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.ASC;
        case $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.DESC;
        default:
            return defaultValue;
    }
};
const $60ca5805e8d4f3e0$var$getSortValue = (sortOrder)=>({
        priority: 2,
        direction: $60ca5805e8d4f3e0$var$parseSortDirection(sortOrder, $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.DESC)
    });
// Added Inverse sort fn as data in AGS is indexed in reverse order for priority
const $60ca5805e8d4f3e0$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.DESC;
        case $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.ASC;
        default:
            return defaultValue;
    }
};
const $60ca5805e8d4f3e0$var$getInverseSortValue = (sortOrder)=>({
        priority: 2,
        direction: $60ca5805e8d4f3e0$var$parseInverseSortDirection(sortOrder, $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.ASC)
    });
const $60ca5805e8d4f3e0$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
        lastModified: {
            priority: 1,
            direction: $60ca5805e8d4f3e0$var$AriGraphSortOrderInput.DESC
        },
        ...$60ca5805e8d4f3e0$var$STATUS_SORT_KEY === parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_BY] ? {
            to_status: $60ca5805e8d4f3e0$var$getSortValue(parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$60ca5805e8d4f3e0$var$PRIORITY_SORT_KEY === parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_BY] ? {
            to_priority: $60ca5805e8d4f3e0$var$getInverseSortValue(parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$60ca5805e8d4f3e0$var$CREATED_SORT_KEY === parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_BY] ? {
            createdAt: $60ca5805e8d4f3e0$var$getSortValue(parsedQueryParams[$60ca5805e8d4f3e0$var$QUERY_PARAM_SORT_ORDER])
        } : {}
    });

const $60ca5805e8d4f3e0$export$a59477eea6e8cd7f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8wnKX")), {
        moduleId: "600f9393",
        moduleName: "IncidentsPageWrapper",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $wDeUq.default,
                    variables: {
                        incidentPageSize: 30,
                        servicePageSize: 30,
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        filter: $60ca5805e8d4f3e0$var$getGqlFiltersFromQueryParams($60ca5805e8d4f3e0$var$parseQueryParams(context.query)),
                        sort: $60ca5805e8d4f3e0$var$getGraphStoreSortFromQueryParams($60ca5805e8d4f3e0$var$parseQueryParams(context.query)),
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            }
        })
});

});
parcelRegister("wDeUq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c32611a4452890a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c90ee0b975e43b949a1672600a5245cc>>
 * @relayHash 838f6c4fb52c2aef06e7177fbaac9aa1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58bd8572e1346ce73b12b8a3d3da2d4bfa71ad3331d216c6673184377ed3f881
const $c32611a4452890a2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "58bd8572e1346ce73b12b8a3d3da2d4bfa71ad3331d216c6673184377ed3f881",
        "metadata": {
            "connection": [
                {
                    "count": "servicePageSize",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "linkedOperationsComponentsByProject"
                    ]
                }
            ]
        },
        "name": "IncidentsPageWrapperQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c32611a4452890a2$export$2e2bcd8739ae039 = $c32611a4452890a2$var$node;

});

parcelRegister("8wnKX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("cXZjl")
]).then(()=>parcelRequire('6Heuw'));

});



parcelRegister("fidt3", function(module, exports) {
$parcel$export(module.exports, "entryPointDeprecated", () => $517674b4e919df83$export$821fec5ea5acc81d);

var $hi6Of = parcelRequire("hi6Of");

var $u61Jv = parcelRequire("u61Jv");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $517674b4e919df83$export$821fec5ea5acc81d = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $u61Jv.incidentsPageEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("u61Jv", function(module, exports) {
$parcel$export(module.exports, "incidentsPageEntryPoint", () => $0ea64097a4ee6754$export$a59477eea6e8cd7f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $hMRTX = parcelRequire("hMRTX");

const $0ea64097a4ee6754$export$a59477eea6e8cd7f = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("jKwRq")), {
        moduleId: "1c1bc8f4",
        moduleName: "IncidentsPageLinkedServicesWrapper",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $hMRTX.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("hMRTX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7090d9ce3b87ff75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<192696eb41bc42a27061d590d41c945c>>
 * @relayHash 31cc56de62b91ad81dab7c63784ec1d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 529e4a86708354a1f72fd05479e3a731aae4550fcda440d26f53c159807689f0
const $7090d9ce3b87ff75$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "529e4a86708354a1f72fd05479e3a731aae4550fcda440d26f53c159807689f0",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "associatedComponents"
                    ]
                }
            ]
        },
        "name": "IncidentsPageLinkedServicesWrapperSrcQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7090d9ce3b87ff75$export$2e2bcd8739ae039 = $7090d9ce3b87ff75$var$node;

});

parcelRegister("jKwRq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i1DQg").then(()=>parcelRequire('aaHxa'));

});




parcelRegister("7Vt7A", function(module, exports) {
$parcel$export(module.exports, "softwareIncidentsNextGenRouteEntry", () => $1ec79627961c56ae$export$fd29243dbe4103);

var $74oEx = parcelRequire("74oEx");


var $i860n = parcelRequire("i860n");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $2unO0 = parcelRequire("2unO0");

var $gPlGE = parcelRequire("gPlGE");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $bsD8p = parcelRequire("bsD8p");

var $fidt3 = parcelRequire("fidt3");
const $1ec79627961c56ae$export$fd29243dbe4103 = (0, $fdS54.createEntry)((0, $2unO0.softwareIncidentsNextGenRoute), ()=>({
        group: 'software',
        entryPoint () {
            return (0, $i860n.fg)('corex_operandi_incidents_page_in_jira') ? (0, $bsD8p.entryPoint) : (0, $fidt3.entryPointDeprecated);
        },
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        skeleton: (0, $gPlGE.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hWEkS.incidentsInitialPageChecksResource),
            (0, $hWEkS.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-incidents'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2unO0", function(module, exports) {
$parcel$export(module.exports, "softwareIncidentsNextGenRoute", () => $3d80ccb1e4657130$export$12e1ca6c7cfdfd49);
const $3d80ccb1e4657130$export$12e1ca6c7cfdfd49 = {
    name: 'software-incidents',
    path: '/jira/software/projects/:projectKey/incidents'
};

});


parcelRegister("j16Nz", function(module, exports) {
$parcel$export(module.exports, "softwareListClassicRouteEntry", () => $fcdcfb60a565d4b3$export$4e2a0a97feb715a5);

var $51vnM = parcelRequire("51vnM");



var $oXLtZ = parcelRequire("oXLtZ");

var $9T5Cr = parcelRequire("9T5Cr");

var $fdS54 = parcelRequire("fdS54");

var $ldtoF = parcelRequire("ldtoF");

var $QhQu4 = parcelRequire("QhQu4");

var $3eysO = parcelRequire("3eysO");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hm066 = parcelRequire("hm066");

var $75Njg = parcelRequire("75Njg");

var $aucfV = parcelRequire("aucfV");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $gZWlI = parcelRequire("gZWlI");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");


var $31tCE = parcelRequire("31tCE");

var $2EQPz = parcelRequire("2EQPz");

var $2A6mK = parcelRequire("2A6mK");

var $dvtoW = parcelRequire("dvtoW");

var $836A7 = parcelRequire("836A7");

var $8tarW = parcelRequire("8tarW");

var $cBtxa = parcelRequire("cBtxa");

var $1l1eo = parcelRequire("1l1eo");
const $fcdcfb60a565d4b3$export$4e2a0a97feb715a5 = (0, $fdS54.createEntry)((0, $hm066.softwareListClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $i860n.fg)('jira_list_nin_merge') ? {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        } : undefined,
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2EQPz.ProjectIssueNavigatorSkeleton) : (0, $ldtoF.ListSkeleton),
        entryPoint () {
            if ((0, $i860n.fg)('jira_list_nin_merge')) return (0, $i860n.fg)('navx-global-side-nav') ? (0, $2A6mK.GSNIssueNavigatorPageEntryPointWithNested) : (0, $2A6mK.issueNavigatorPageEntryPointWithNested);
            if ((0, $i860n.fg)('navx-global-side-nav')) return 0, $1l1eo.GSNSoftwareListRouteEntry;
            return 0, $1l1eo.softwareListRouteEntry;
        },
        layout: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $QhQu4.createLayout)((0, $dvtoW.genericProjectLayout)) : (0, $QhQu4.composeLayouts)((0, $3eysO.classicSoftwareProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0)),
            circuitBreakerConfig: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $8tarW.getSsrCircuitBreaker)() : undefined
        },
        navigation: (0, $i860n.fg)('jira_list_nin_merge') ? {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        } : {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to replace
        //  with .
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? [
            ...(0, $836A7.getCommonProjectResources)({
                isUsingSidebarEntrypoint: true
            }),
            ...(0, $ldGfw.getIssueViewResources)()
        ] : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aucfV.projectCreatePermissionsResource),
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $9T5Cr.fieldsResource),
            (0, $gZWlI.projectThemeResource)
        ],
        afterPaint: (0, $i860n.fg)('jira_list_nin_merge') ? undefined : [
            (0, $51vnM.LazyIssueApp)
        ],
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'classic-list-nin' : 'classic-list',
        supportsPreviewPanel: true,
        supportsProjectTheme: (0, $2700E.expVal)('jira-list-full-theming-exp', 'isEnabled', false) ? 'full' : 'contoured',
        isHydrateRootEnabled: (0, $i860n.fg)('jira_list_nin_merge'),
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        excludeFromWrmDeferredLoading: (0, $i860n.fg)('jira_list_nin_merge')
    }));

});
parcelRegister("ldtoF", function(module, exports) {
$parcel$export(module.exports, "ListSkeleton", () => $4aa979ed3e35f88c$export$cbc3335f7a517046);
$parcel$export(module.exports, "ListEmbedSkeleton", () => $4aa979ed3e35f88c$export$2638f1c98fe91c13);

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $duzW0 = parcelRequire("duzW0");

var $awY1F = parcelRequire("awY1F");
const $4aa979ed3e35f88c$export$cbc3335f7a517046 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($duzW0)))
    });
$4aa979ed3e35f88c$export$cbc3335f7a517046.displayName = "ListSkeleton";
const $4aa979ed3e35f88c$export$2638f1c98fe91c13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($awY1F)))
    });
$4aa979ed3e35f88c$export$2638f1c98fe91c13.displayName = "ListEmbedSkeleton";

});
parcelRegister("duzW0", function(module, exports) {
module.exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();

});

parcelRegister("awY1F", function(module, exports) {
module.exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();

});


parcelRegister("hm066", function(module, exports) {
$parcel$export(module.exports, "softwareListClassicRoute", () => $448d2d3d2e503461$export$1bf758507ca6b2);
const $448d2d3d2e503461$export$1bf758507ca6b2 = {
    name: 'software-list-classic',
    path: '/jira/software/c/projects/:projectKey/list/:navigationItemId?'
};

});

parcelRegister("1l1eo", function(module, exports) {
$parcel$export(module.exports, "softwareListRouteEntry", () => $1a11b04bf8e22468$export$f30a66efa682bf2d);
$parcel$export(module.exports, "GSNSoftwareListRouteEntry", () => $1a11b04bf8e22468$export$1ae28c052b05a648);
$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $1a11b04bf8e22468$export$1099e0e49394fa9a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $j05on = parcelRequire("j05on");

var $9X1f9 = parcelRequire("9X1f9");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");
const $1a11b04bf8e22468$export$e844b8d1d10f4a38 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9X1f9.listEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $1a11b04bf8e22468$export$f30a66efa682bf2d = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9X1f9.listEntryPoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $1a11b04bf8e22468$export$1ae28c052b05a648 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9X1f9.listEntryPoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $1a11b04bf8e22468$export$1099e0e49394fa9a = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $j05on.listEmbedEntryPoint)
});

});
parcelRegister("j05on", function(module, exports) {
$parcel$export(module.exports, "listEmbedEntryPoint", () => $68f0ac426a903388$export$519bb55e1612f243);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6EpW0 = parcelRequire("6EpW0");

var $e45Tj = parcelRequire("e45Tj");
const $68f0ac426a903388$var$FORMAT_RULES_FIRST = 20;

const $68f0ac426a903388$export$519bb55e1612f243 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("9cO3g")), {
        moduleId: "be51c460",
        moduleName: "JiraSoftwareListEmbedApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $e45Tj.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $6EpW0.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $68f0ac426a903388$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("e45Tj", function(module, exports) {
$parcel$export(module.exports, "default", () => $655948eeae994064$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b419fa4736f3c95044c3f7a70e6a3ea0>>
 * @relayHash 1305915d09089e21e4c8930da18db3e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0f565f55b9a0ebf771c0b300219e898f33e4a93a98567019cab857187320741
const $655948eeae994064$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c0f565f55b9a0ebf771c0b300219e898f33e4a93a98567019cab857187320741",
        "metadata": {},
        "name": "JiraSoftwareListEmbedAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $655948eeae994064$export$2e2bcd8739ae039 = $655948eeae994064$var$node;

});

parcelRegister("9cO3g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("9ukn4")
]).then(()=>parcelRequire('2r6Ov'));

});


parcelRegister("9X1f9", function(module, exports) {
$parcel$export(module.exports, "listEntryPoint", () => $f9cad88c8caedd18$export$6be4f10150ff6073);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6EpW0 = parcelRequire("6EpW0");

var $87Cum = parcelRequire("87Cum");
const $f9cad88c8caedd18$var$FORMAT_RULES_FIRST = 20;

const $f9cad88c8caedd18$export$6be4f10150ff6073 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("erTg9")), {
        moduleId: "de9bd58a",
        moduleName: "JiraSoftwareListApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $87Cum.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $6EpW0.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $f9cad88c8caedd18$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("87Cum", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e3b190098ae9219$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b6c17a2a35903912b25e380f58630851>>
 * @relayHash 36f07a23042e3d8b2713f56ed7f44023
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06a7ef491f56ed3890b2d1e700a2513a829a8028798213c4053e72e8fb5d0c21
const $1e3b190098ae9219$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "06a7ef491f56ed3890b2d1e700a2513a829a8028798213c4053e72e8fb5d0c21",
        "metadata": {},
        "name": "JiraSoftwareListAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1e3b190098ae9219$export$2e2bcd8739ae039 = $1e3b190098ae9219$var$node;

});

parcelRegister("erTg9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("lfFZG")
]).then(()=>parcelRequire('2InON'));

});




parcelRegister("1iV3F", function(module, exports) {
$parcel$export(module.exports, "softwareListCustomEmbedClassicRouteEntry", () => $aee23f9887b4e792$export$1bf6c018ccb88bd6);

var $51vnM = parcelRequire("51vnM");

var $9T5Cr = parcelRequire("9T5Cr");

var $oXLtZ = parcelRequire("oXLtZ");

var $fdS54 = parcelRequire("fdS54");

var $2fm6Q = parcelRequire("2fm6Q");

var $ldtoF = parcelRequire("ldtoF");

var $byMD7 = parcelRequire("byMD7");

var $aucfV = parcelRequire("aucfV");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");


var $31tCE = parcelRequire("31tCE");

var $836A7 = parcelRequire("836A7");

var $2osjz = parcelRequire("2osjz");

var $2A6mK = parcelRequire("2A6mK");

var $i860n = parcelRequire("i860n");

var $1l1eo = parcelRequire("1l1eo");
const $aee23f9887b4e792$export$1bf6c018ccb88bd6 = (0, $fdS54.createEntry)((0, $2fm6Q.softwareListCustomEmbedClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $i860n.fg)('jira_list_nin_merge') ? {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        } : undefined,
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2osjz.EmbedIssueNavigatorSkeleton) : (0, $ldtoF.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $i860n.fg)('jira_list_nin_merge')) return 0, $2A6mK.issueNavigatorEmbedPageEntryPoint;
            return 0, $1l1eo.softwareListEmbedRouteEntry;
        },
        layout: (0, $byMD7.chromelessLayout),
        isHydrateRootEnabled: (0, $i860n.fg)('jira_list_nin_merge'),
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? [
            ...(0, $836A7.getCommonProjectResources)(),
            ...(0, $ldGfw.getIssueViewResources)()
        ] : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aucfV.projectCreatePermissionsResource),
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $9T5Cr.fieldsResource)
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'classic-list-custom-nin-embed' : 'classic-list-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2fm6Q", function(module, exports) {
$parcel$export(module.exports, "softwareListCustomEmbedClassicRoute", () => $2203baa86844c46d$export$1273c580eb34bde5);
const $2203baa86844c46d$export$1273c580eb34bde5 = {
    name: 'software-list-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/list/:navigationItemId/embed'
};

});


parcelRegister("78blt", function(module, exports) {
$parcel$export(module.exports, "softwareListCustomEmbedRouteEntry", () => $0dbe1936cabd17df$export$4387d360bb5b569b);
/* eslint-disable import/order */ 
var $j05on = parcelRequire("j05on");

var $6RSCO = parcelRequire("6RSCO");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $fClSj = parcelRequire("fClSj");

var $ldtoF = parcelRequire("ldtoF");

var $2osjz = parcelRequire("2osjz");

var $836A7 = parcelRequire("836A7");

var $2A6mK = parcelRequire("2A6mK");

var $i860n = parcelRequire("i860n");

var $jueD3 = parcelRequire("jueD3");
const $0dbe1936cabd17df$var$listEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $j05on.listEmbedEntryPoint)
});
const $0dbe1936cabd17df$export$4387d360bb5b569b = (0, $fdS54.createEntry)((0, $fClSj.softwareListCustomEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2osjz.EmbedIssueNavigatorSkeleton) : (0, $ldtoF.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $i860n.fg)('jira_list_nin_merge')) return 0, $2A6mK.issueNavigatorEmbedPageEntryPoint;
            return $0dbe1936cabd17df$var$listEmbedPageEntrypoint;
        },
        layout: (0, $byMD7.chromelessLayout),
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? [
            ...(0, $836A7.getCommonProjectResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ] : [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jueD3.getListProjectResources)()
        ],
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'software-list-custom-nin-embed' : 'next-gen-list-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin')
    }));

});
parcelRegister("fClSj", function(module, exports) {
$parcel$export(module.exports, "softwareListCustomEmbedRoute", () => $2419cc41ad122e0e$export$2565ab956bab3afb);
const $2419cc41ad122e0e$export$2565ab956bab3afb = {
    name: 'software-list-custom-embed',
    path: '/jira/software/projects/:projectKey/list/:navigationItemId/embed'
};

});

parcelRegister("jueD3", function(module, exports) {
$parcel$export(module.exports, "getListProjectResources", () => $57284239ffeeb116$export$7bd00eef349a268a);
// eslint-disable-next-line jira/import/no-restricted-import

var $9T5Cr = parcelRequire("9T5Cr");

var $oXLtZ = parcelRequire("oXLtZ");

var $aucfV = parcelRequire("aucfV");
const $57284239ffeeb116$export$7bd00eef349a268a = ()=>[
        (0, $aucfV.projectCreatePermissionsResource),
        // eslint-disable-next-line camelcase
        (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $9T5Cr.fieldsResource)
    ];

});


parcelRegister("inZ6Z", function(module, exports) {
$parcel$export(module.exports, "softwareListEmbedClassicRouteEntry", () => $696f8441131e94d5$export$bdb096e193b6e97b);

var $51vnM = parcelRequire("51vnM");

var $9T5Cr = parcelRequire("9T5Cr");

var $oXLtZ = parcelRequire("oXLtZ");

var $fdS54 = parcelRequire("fdS54");

var $3wIdh = parcelRequire("3wIdh");

var $ldtoF = parcelRequire("ldtoF");

var $byMD7 = parcelRequire("byMD7");

var $aucfV = parcelRequire("aucfV");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $i860n = parcelRequire("i860n");


var $31tCE = parcelRequire("31tCE");

var $836A7 = parcelRequire("836A7");

var $2A6mK = parcelRequire("2A6mK");

var $2osjz = parcelRequire("2osjz");

var $1l1eo = parcelRequire("1l1eo");
const $696f8441131e94d5$export$bdb096e193b6e97b = (0, $fdS54.createEntry)((0, $3wIdh.softwareListEmbedClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $i860n.fg)('jira_list_nin_merge') ? {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        } : undefined,
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2osjz.EmbedIssueNavigatorSkeleton) : (0, $ldtoF.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $i860n.fg)('jira_list_nin_merge')) return 0, $2A6mK.issueNavigatorEmbedPageEntryPoint;
            return 0, $1l1eo.softwareListEmbedRouteEntry;
        },
        layout: (0, $byMD7.chromelessLayout),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? [
            ...(0, $836A7.getCommonProjectResources)(),
            ...(0, $ldGfw.getIssueViewResources)()
        ] : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aucfV.projectCreatePermissionsResource),
            // eslint-disable-next-line camelcase
            (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $9T5Cr.fieldsResource)
        ],
        isHydrateRootEnabled: (0, $i860n.fg)('jira_list_nin_merge'),
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        afterPaint: (0, $i860n.fg)('jira_list_nin_merge') ? undefined : [
            (0, $51vnM.LazyIssueApp)
        ],
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'classic-list-nin-embed' : 'classic-list-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3wIdh", function(module, exports) {
$parcel$export(module.exports, "softwareListEmbedClassicRoute", () => $46e8bce60074be83$export$de5fcecec40b3c98);
const $46e8bce60074be83$export$de5fcecec40b3c98 = {
    name: 'software-list-classic-embed',
    path: '/jira/software/c/projects/:projectKey/list/embed'
};

});


parcelRegister("jXBS2", function(module, exports) {
$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $883ce94bb944f4c5$export$1099e0e49394fa9a);
/* eslint-disable import/order */ 
var $j05on = parcelRequire("j05on");

var $6RSCO = parcelRequire("6RSCO");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $hAEtR = parcelRequire("hAEtR");

var $ldtoF = parcelRequire("ldtoF");

var $2osjz = parcelRequire("2osjz");

var $836A7 = parcelRequire("836A7");

var $2A6mK = parcelRequire("2A6mK");

var $i860n = parcelRequire("i860n");

var $jueD3 = parcelRequire("jueD3");
const $883ce94bb944f4c5$var$listEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $j05on.listEmbedEntryPoint)
});
const $883ce94bb944f4c5$export$1099e0e49394fa9a = (0, $fdS54.createEntry)((0, $hAEtR.softwareListEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2osjz.EmbedIssueNavigatorSkeleton) : (0, $ldtoF.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $i860n.fg)('jira_list_nin_merge')) return 0, $2A6mK.issueNavigatorEmbedPageEntryPoint;
            return $883ce94bb944f4c5$var$listEmbedPageEntrypoint;
        },
        layout: (0, $byMD7.chromelessLayout),
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? [
            ...(0, $836A7.getCommonProjectResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ] : [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $jueD3.getListProjectResources)()
        ],
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'software-list-nin-embed' : 'next-gen-list-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin')
    }));

});
parcelRegister("hAEtR", function(module, exports) {
$parcel$export(module.exports, "softwareListEmbedRoute", () => $398eaf8596f57da1$export$70dd8df584442004);
const $398eaf8596f57da1$export$70dd8df584442004 = {
    name: 'software-list-embed',
    path: '/jira/software/projects/:projectKey/list/embed'
};

});


parcelRegister("lW5D3", function(module, exports) {
$parcel$export(module.exports, "softwareListRouteEntry", () => $8707749481dde6fa$export$f30a66efa682bf2d);

var $hi6Of = parcelRequire("hi6Of");

var $51vnM = parcelRequire("51vnM");


var $9X1f9 = parcelRequire("9X1f9");

var $dTa0V = parcelRequire("dTa0V");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $ieM4e = parcelRequire("ieM4e");

var $ldtoF = parcelRequire("ldtoF");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $3KSG6 = parcelRequire("3KSG6");

var $gZWlI = parcelRequire("gZWlI");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $2EQPz = parcelRequire("2EQPz");


var $31tCE = parcelRequire("31tCE");

var $836A7 = parcelRequire("836A7");

var $8tarW = parcelRequire("8tarW");

var $cBtxa = parcelRequire("cBtxa");

var $2A6mK = parcelRequire("2A6mK");

var $jueD3 = parcelRequire("jueD3");
const $8707749481dde6fa$var$listPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9X1f9.listEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $8707749481dde6fa$export$f30a66efa682bf2d = (0, $fdS54.createEntry)((0, $ieM4e.softwareListRoute), ()=>({
        group: 'software',
        skeleton: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $2EQPz.ProjectIssueNavigatorSkeleton) : (0, $ldtoF.ListSkeleton),
        entryPoint () {
            if ((0, $i860n.fg)('jira_list_nin_merge')) return (0, $i860n.fg)('nin_glance_panel_technical_changes') ? (0, $2A6mK.issueNavigatorPageEntryPoint) : (0, $2A6mK.issueNavigatorPageEntryPointWithoutPreviewPanel);
            return $8707749481dde6fa$var$listPageEntrypoint;
        },
        meta: (0, $i860n.fg)('jira_list_nin_merge') ? {
            capability: (0, $0ce01f968965dadd$export$d0ad1160bb95ce50),
            reporting: (0, $31tCE.getRouteReporting)()
        } : undefined,
        bifrost: {
            bifrostGroup: 'issue-navigator',
            manifestName: 'jira-spa-issue-navigator.json',
            circuitBreakerConfig: (0, $i860n.fg)('jira_list_nin_merge') ? (0, $8tarW.getSsrCircuitBreaker)() : undefined,
            // Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
            fetchTimeout: (0, $cBtxa.adjustSsrFetchTimeout)((0, $2700E.expVal)('nin_ssr_resource_timeout', 'timeout', 0))
        },
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: (0, $i860n.fg)('jira_list_nin_merge') ? [
            ...(0, $836A7.getCommonProjectResources)(),
            ...(0, $ldGfw.getIssueViewResources)()
        ] : [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $jueD3.getListProjectResources)(),
            (0, $gZWlI.projectThemeResource)
        ],
        afterPaint: (0, $i860n.fg)('jira_list_nin_merge') ? undefined : [
            (0, $51vnM.LazyIssueApp)
        ],
        ufoName: (0, $i860n.fg)('jira_list_nin_merge') ? 'software-list-nin' : 'next-gen-list',
        supportsPreviewPanel: true,
        supportsProjectTheme: (0, $2700E.expVal)('jira-list-full-theming-exp', 'isEnabled', false) ? 'full' : 'contoured',
        isHydrateRootEnabled: (0, $i860n.fg)('jira_list_nin_merge'),
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-nin'),
        excludeFromWrmDeferredLoading: (0, $i860n.fg)('jira_list_nin_merge')
    }));

});
parcelRegister("ieM4e", function(module, exports) {
$parcel$export(module.exports, "softwareListRoute", () => $4cbf7c3f93d3cd1a$export$f3a5b1b732315e13);
const $4cbf7c3f93d3cd1a$export$f3a5b1b732315e13 = {
    name: 'software-list',
    path: '/jira/software/projects/:projectKey/list/:navigationItemId?'
};

});


parcelRegister("arMEr", function(module, exports) {
$parcel$export(module.exports, "softwareNextgenRedirectRouteEntry", () => $81e2408edc5f40c9$export$e328d22412aeb5cf);

var $euxye = parcelRequire("euxye");

var $51vnM = parcelRequire("51vnM");


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $ldGfw = parcelRequire("ldGfw");

var $7B9zm = parcelRequire("7B9zm");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $gNbXR = parcelRequire("gNbXR");

var $l8G1z = parcelRequire("l8G1z");

var $jhKsF = parcelRequire("jhKsF");

var $lFlYs = parcelRequire("lFlYs");
const $81e2408edc5f40c9$var$SoftwareNextgenRedirectComponent = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: (0, $lFlYs.pickNextGenView)(location)
    });
$81e2408edc5f40c9$var$SoftwareNextgenRedirectComponent.displayName = "SoftwareNextgenRedirectComponent";

const $81e2408edc5f40c9$var$LazyBoardPage = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("20xiv"))), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/BoardSPAApp.tsx"
});
const $81e2408edc5f40c9$export$e328d22412aeb5cf = (0, $fdS54.createEntry)((0, $7B9zm.softwareNextgenRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: $81e2408edc5f40c9$var$SoftwareNextgenRedirectComponent,
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            $81e2408edc5f40c9$var$LazyBoardPage
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7B9zm", function(module, exports) {
$parcel$export(module.exports, "softwareNextgenRedirectRoute", () => $0845023d23ab111b$export$6072946fe7f2d45a);
const $0845023d23ab111b$export$6072946fe7f2d45a = {
    name: 'software-nextgen-redirect',
    path: '/secure/NextGen.jspa'
};

});

parcelRegister("lFlYs", function(module, exports) {
$parcel$export(module.exports, "pickNextGenView", () => $665c9da150f0418f$export$8c47088cd9b527ba);
/* eslint-disable jira/naming/disallow-filenames */ 
var $bS1iz = parcelRequire("bS1iz");
const $665c9da150f0418f$var$PLAN = 'planning';
const $665c9da150f0418f$var$REPORTING = 'reporting';
const $665c9da150f0418f$var$REPORTS = 'reports';
const $665c9da150f0418f$var$constructUrlForView = (url, view, searchResult)=>{
    if (view.startsWith($665c9da150f0418f$var$PLAN)) return `${url}/backlog`;
    if (view.startsWith($665c9da150f0418f$var$REPORTING) || view.startsWith($665c9da150f0418f$var$REPORTS)) {
        if (searchResult.report) return `${url}/reports/${searchResult.report}`;
        return `${url}/reports`;
    }
    return url;
};
const $665c9da150f0418f$var$KNOWN_KEYS = [
    'rapidView',
    'projectKey',
    'view',
    'report'
];
const $665c9da150f0418f$var$forwardUnknownQueryParams = (url, queryParams)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(Object.entries(queryParams).filter(([k])=>!$665c9da150f0418f$var$KNOWN_KEYS.includes(k)) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, [k, v])=>({
            [k]: v,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result
        }), {}));
    if (query) return `${url}?${query}`;
    return url;
};
const $665c9da150f0418f$export$8c47088cd9b527ba = (location)=>{
    const searchResult = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(location.search);
    const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
    if (searchResult.view) return $665c9da150f0418f$var$forwardUnknownQueryParams($665c9da150f0418f$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
    return $665c9da150f0418f$var$forwardUnknownQueryParams(url, searchResult);
};

});


parcelRegister("9dduz", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingRouteEntry", () => $874266dcc6681672$export$bb72a943d2340466);

var $chpvF = parcelRequire("chpvF");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");

var $gZRQz = parcelRequire("gZRQz");

var $4B518 = parcelRequire("4B518");

var $8AAgR = parcelRequire("8AAgR");

var $aucfV = parcelRequire("aucfV");

var $6bGyp = parcelRequire("6bGyp");

var $8HUuJ = parcelRequire("8HUuJ");

var $74gjm = parcelRequire("74gjm");
const $874266dcc6681672$var$softwareOnboardingEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $chpvF.softwareOnboardingPageEntryPoint)
});
const $874266dcc6681672$export$bb72a943d2340466 = (0, $fdS54.createEntry)((0, $8AAgR.softwareOnboardingRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $74gjm.SoftwareOnboardingPage),
        layout: (0, $byMD7.chromelessLayout),
        entryPoint: ()=>(0, $i860n.fg)('jfind-gups-onboarding-gate') ? $874266dcc6681672$var$softwareOnboardingEntryPoint : undefined,
        resources: [
            (0, $gZRQz.jswOnboardingResource),
            ...(0, $4B518.jiraSpaResources)(),
            (0, $aucfV.projectCreatePermissionsResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('add_rovo_check_resource_to_onboarding'), (0, $6bGyp.rovoEntitlementResource))
        ],
        forPaint: [
            (0, $74gjm.LazySoftwareOnboardingPage)
        ],
        canTransitionIn: ()=>false,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("chpvF", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingPageEntryPoint", () => $c3bb5626752968d2$export$92b449e7742bf241);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $gaHAW = parcelRequire("gaHAW");

const $c3bb5626752968d2$export$92b449e7742bf241 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8RTFN")), {
        moduleId: "d5770183",
        moduleName: "SoftwareOnboardingPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>({
            queries: {
                gupsQuery: {
                    parameters: (0, $gaHAW.default),
                    variables: {
                        tenantId: cloudId
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            extraProps: {}
        })
});

});
parcelRegister("gaHAW", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cc48e78d28693cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c783d1ae424fe9e58f9788adfc6fce5a>>
 * @relayHash 409380a00146ae3b415da19a5d574e54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 425ad325217bbd6c5c11424db1069eb65abcb4ffe5316659f0b3a3081c180ccb
const $9cc48e78d28693cd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "425ad325217bbd6c5c11424db1069eb65abcb4ffe5316659f0b3a3081c180ccb",
        "metadata": {},
        "name": "SoftwareOnboardingPageGupsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9cc48e78d28693cd$export$2e2bcd8739ae039 = $9cc48e78d28693cd$var$node;

});

parcelRegister("8RTFN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("hNcFi")
]).then(()=>parcelRequire('lHI4Z'));

});


parcelRegister("gZRQz", function(module, exports) {
$parcel$export(module.exports, "jswOnboardingResource", () => $fc84a5ba4e212a02$export$be21a2d8a350a80);
$parcel$export(module.exports, "useJswOnboardingResource", () => $fc84a5ba4e212a02$export$83f546a45ad58d0a);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $fc84a5ba4e212a02$var$RESOURCE_TYPE_SOFTWARE_ONBOARDING = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

const $fc84a5ba4e212a02$export$be21a2d8a350a80 = (0, $7edbf.createResource)({
    type: $fc84a5ba4e212a02$var$RESOURCE_TYPE_SOFTWARE_ONBOARDING,
    getKey: ()=>'jsw_onboarding',
    getDataLoader: ()=>(parcelRequire("kqn8f"))
});
const $fc84a5ba4e212a02$export$83f546a45ad58d0a = ()=>(0, $k6ufm.useResource)($fc84a5ba4e212a02$export$be21a2d8a350a80);

});
parcelRegister("kqn8f", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hAcFw").then(()=>parcelRequire('7CHa2'));

});


parcelRegister("8AAgR", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingRoute", () => $8261a163b6ae30c1$export$5e6c92d2f34c1e48);
const $8261a163b6ae30c1$export$5e6c92d2f34c1e48 = {
    name: 'software-onboarding',
    path: '/welcome/software',
    exact: true
};

});

parcelRegister("74gjm", function(module, exports) {
$parcel$export(module.exports, "LazySoftwareOnboardingPage", () => $ca616c86f79f56dd$export$31e9f06d3389e445);
$parcel$export(module.exports, "SoftwareOnboardingPage", () => $ca616c86f79f56dd$export$ee768d69c6e3a8bd);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $ca616c86f79f56dd$export$31e9f06d3389e445 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hSjjG"))), {
    moduleId: "./src/packages/spa-apps/software-onboarding/src/index.tsx"
});
const $ca616c86f79f56dd$export$ee768d69c6e3a8bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $ca616c86f79f56dd$export$31e9f06d3389e445,
        pageId: "software-onboarding",
        shouldShowSpinner: false
    });
$ca616c86f79f56dd$export$ee768d69c6e3a8bd.displayName = "SoftwareOnboardingPage";

});
parcelRegister("hSjjG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("aGfY8")
]).then(()=>parcelRequire('iCIRc'));

});



parcelRegister("6OpnH", function(module, exports) {
$parcel$export(module.exports, "softwarePeriscopeClassicRouteEntry", () => $eed07be4699275f4$export$d7d49c1a51b3c0a9);

var $74oEx = parcelRequire("74oEx");



var $iSoIx = parcelRequire("iSoIx");

var $l1vE2 = parcelRequire("l1vE2");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $ayS3g = parcelRequire("ayS3g");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $ldxei = parcelRequire("ldxei");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $6bGyp = parcelRequire("6bGyp");

var $41FAq = parcelRequire("41FAq");

var $i860n = parcelRequire("i860n");

var $jk8fq = parcelRequire("jk8fq");
const $eed07be4699275f4$export$d7d49c1a51b3c0a9 = (0, $fdS54.createEntry)((0, $ldxei.softwarePeriscopeClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $ayS3g.Skeleton),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6bGyp.rovoEntitlementResource)
        ],
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        entryPoint: ()=>{
            if ((0, $l1vE2.isFedRamp)()) {
                // JOLT-2765: FedRAMP tenants are blocked from Periscope by default.
                // The kill-switch gate enables an AEM allowlist check that lets
                // individual FedRAMP tenants opt in.
                if (!(0, $i860n.fg)('jira_development_enable_aem_fedramp_check')) return 0, $iSoIx.notFoundPageEntrypoint;
                if (!(0, $41FAq.isFeatureEnabled)('jira', 'jira-development-tab')) return 0, $iSoIx.notFoundPageEntrypoint;
            }
            if ((0, $i860n.fg)('navx-global-side-nav')) return 0, $jk8fq.GSNPeriscopeEntryPoint;
            return 0, $jk8fq.periscopeEntryPoint;
        },
        meta: {
            reporting: {
                id: 'software-periscope-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-periscope-classic'),
                teamName: 'jolt'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ayS3g", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $4dd1dbaae8b67fb6$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InsightsSkeleton", () => $4dd1dbaae8b67fb6$export$dd0b74c715df3275);
$parcel$export(module.exports, "RelatedWorkSkeleton", () => $4dd1dbaae8b67fb6$export$f1d22a895b1f6d5);
$parcel$export(module.exports, "WorkItemsVulnTabSkeleton", () => $4dd1dbaae8b67fb6$export$5aea7d4ed03d6ea6);
$parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", () => $4dd1dbaae8b67fb6$export$ff38ee81427877e9);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $2XXtG = parcelRequire("2XXtG");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");

var $1lXvx = parcelRequire("1lXvx");
const $4dd1dbaae8b67fb6$var$label = (0, $7eNDO.defineMessage)({
    id: "periscope.skeleton.label",
    defaultMessage: "Loading"
});
const $4dd1dbaae8b67fb6$var$insightsLabel = (0, $7eNDO.defineMessage)({
    id: "periscope.insights-skeleton.label",
    defaultMessage: "Developer insights loading"
});
const $4dd1dbaae8b67fb6$var$workItemsLabel = (0, $7eNDO.defineMessage)({
    id: "periscope.work-items-skeleton.work-items-label",
    defaultMessage: "Work items loading"
});
const $4dd1dbaae8b67fb6$var$workItemsVulnTabLabel = (0, $7eNDO.defineMessage)({
    id: "periscope.work-items-skeleton.work-items-vuln-tab-label",
    defaultMessage: "Work items vulnerability tab loading"
});
const $4dd1dbaae8b67fb6$var$workItemsDeploymentTabLabel = (0, $7eNDO.defineMessage)({
    id: "periscope.work-items-skeleton.work-items-deployment-tab-label",
    defaultMessage: "Work items deployment tab loading"
});
const $4dd1dbaae8b67fb6$var$styles = {
    mainContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _1e0c1txw _vchhusvi",
    leftColumn: "_16jlcs5v _1o9zkb7n _i0dlf1ug",
    rightColumn: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    suggestionsContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3istmo _vchhusvi",
    insightsContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1iym _vchhusvi",
    relatedWorkContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1ogm _vchhusvi",
    workItemsVulnTabContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1pna _vchhusvi"
}; // Extend this for loading screen
const $4dd1dbaae8b67fb6$export$8f31e4c4a37b8e9c = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if ((0, $2700E.expVal)('jira_dev_periscope_whole_page_loading_state', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.mainContainer,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage($4dd1dbaae8b67fb6$var$label),
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4dd1dbaae8b67fb6$export$dd0b74c715df3275, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4dd1dbaae8b67fb6$export$f1d22a895b1f6d5, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.mainContainer,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage($4dd1dbaae8b67fb6$var$label),
        gap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.leftColumn,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.insightsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lXvx.PeriscopeInsightsSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.relatedWorkContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lXvx.PeriscopeRelatedWorkSkeleton), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.rightColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.suggestionsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lXvx.PeriscopeSuggestionsSkeleton), null))));
};
$4dd1dbaae8b67fb6$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
const $4dd1dbaae8b67fb6$export$dd0b74c715df3275 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.insightsContainer,
        "data-testId": "software-periscope-periscope-page.insights-ui.loading",
        "aria-label": formatMessage($4dd1dbaae8b67fb6$var$insightsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lXvx.PeriscopeInsightsSkeleton), null));
}; // Extend this for loading screen
$4dd1dbaae8b67fb6$export$dd0b74c715df3275.displayName = "InsightsSkeleton";
const $4dd1dbaae8b67fb6$export$f1d22a895b1f6d5 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.relatedWorkContainer,
        "aria-label": formatMessage($4dd1dbaae8b67fb6$var$workItemsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lXvx.PeriscopeRelatedWorkSkeleton), null));
};
$4dd1dbaae8b67fb6$export$f1d22a895b1f6d5.displayName = "RelatedWorkSkeleton";
const $4dd1dbaae8b67fb6$export$5aea7d4ed03d6ea6 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.workItemsVulnTabContainer,
        "aria-label": formatMessage($4dd1dbaae8b67fb6$var$workItemsVulnTabLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lXvx.DevelopmentPageWorkItemsVulnTabSkeleton), null));
};
$4dd1dbaae8b67fb6$export$5aea7d4ed03d6ea6.displayName = "WorkItemsVulnTabSkeleton";
const $4dd1dbaae8b67fb6$export$ff38ee81427877e9 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $4dd1dbaae8b67fb6$var$styles.relatedWorkContainer,
        "aria-label": formatMessage($4dd1dbaae8b67fb6$var$workItemsDeploymentTabLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lXvx.DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
};
$4dd1dbaae8b67fb6$export$ff38ee81427877e9.displayName = "WorkItemsDeploymentTabSkeleton";

});
parcelRegister("1lXvx", function(module, exports) {
$parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", () => $818acdf95b67de2e$export$176dfe4c14771136);
$parcel$export(module.exports, "PeriscopeInsightsSkeleton", () => $818acdf95b67de2e$export$afb44f298901be44);
$parcel$export(module.exports, "PeriscopeRelatedWorkSkeleton", () => $818acdf95b67de2e$export$200193a9f68098e3);
$parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", () => $818acdf95b67de2e$export$8940e0b80e4066d6);
$parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", () => $818acdf95b67de2e$export$2f5ed71a7df2d4e6);
/* PeriscopeSuggestionsSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $j1rHt = parcelRequire("j1rHt");

var $7tcr8 = parcelRequire("7tcr8");

var $jCwzl = parcelRequire("jCwzl");

var $69tUg = parcelRequire("69tUg");

var $7I2gp = parcelRequire("7I2gp");

var $988jd = parcelRequire("988jd");

var $bcmRT = parcelRequire("bcmRT");

var $itG3s = parcelRequire("itG3s");
const $818acdf95b67de2e$var$PeriscopePageSkeletonStyles = null;
const $818acdf95b67de2e$export$4aecc030c4d69f74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($69tUg)))
    }));
$818acdf95b67de2e$export$4aecc030c4d69f74.displayName = "PeriscopePageSkeleton";
const $818acdf95b67de2e$export$176dfe4c14771136 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7I2gp)))
    }));
$818acdf95b67de2e$export$176dfe4c14771136.displayName = "PeriscopeSuggestionsSkeleton";
const $818acdf95b67de2e$export$afb44f298901be44 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7tcr8)))
    }));
$818acdf95b67de2e$export$afb44f298901be44.displayName = "PeriscopeInsightsSkeleton";
const $818acdf95b67de2e$export$200193a9f68098e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-related-work-skeleton",
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bcmRT)))
    }));
$818acdf95b67de2e$export$200193a9f68098e3.displayName = "PeriscopeRelatedWorkSkeleton";
const $818acdf95b67de2e$export$8940e0b80e4066d6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($988jd)))
    }));
$818acdf95b67de2e$export$8940e0b80e4066d6.displayName = "DevelopmentPageWorkItemsVulnTabSkeleton";
const $818acdf95b67de2e$export$2f5ed71a7df2d4e6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j1rHt)))
    }));
$818acdf95b67de2e$export$2f5ed71a7df2d4e6.displayName = "DevelopmentPageWorkItemsDeploymentTabSkeleton";
const $818acdf95b67de2e$export$e70f5fa3451855e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-on-call-panel-skeleton",
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jCwzl)))
    }));
$818acdf95b67de2e$export$e70f5fa3451855e2.displayName = "DevelopmentPageOnCallPanelSkeleton";
const $818acdf95b67de2e$export$e3f7fac0f7e53296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.code-agents-tab-skeleton",
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($itG3s)))
    }));
$818acdf95b67de2e$export$e3f7fac0f7e53296.displayName = "DevelopmentPageCodeAgentsTabSkeleton";

});
parcelRegister("j1rHt", function(module, exports) {
module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();

});

parcelRegister("7tcr8", function(module, exports) {
module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();

});

parcelRegister("jCwzl", function(module, exports) {
module.exports = new URL("on-call-panel-skeleton.tpl.d7139b03.svg", import.meta.url).toString();

});

parcelRegister("69tUg", function(module, exports) {
module.exports = new URL("periscope-page-full-layout.tpl.e2fc2cdf.svg", import.meta.url).toString();

});

parcelRegister("7I2gp", function(module, exports) {
module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();

});

parcelRegister("988jd", function(module, exports) {
module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();

});

parcelRegister("bcmRT", function(module, exports) {
module.exports = new URL("work-items.tpl.d620c6cd.svg", import.meta.url).toString();

});

parcelRegister("itG3s", function(module, exports) {
module.exports = new URL("code-agents-tab-skeleton.tpl.874ad579.svg", import.meta.url).toString();

});



parcelRegister("ldxei", function(module, exports) {
$parcel$export(module.exports, "softwarePeriscopeClassicRoute", () => $45364ae1d9624780$export$cb5cec74f302b3c6);
const $45364ae1d9624780$export$cb5cec74f302b3c6 = {
    name: 'software-periscope-classic',
    path: '/jira/software/c/projects/:projectKey/development'
};

});

parcelRegister("jk8fq", function(module, exports) {
$parcel$export(module.exports, "periscopeEntryPoint", () => $5f3bf43516b9e4cc$export$5a8cf468a1d46d4);
$parcel$export(module.exports, "GSNPeriscopeEntryPoint", () => $5f3bf43516b9e4cc$export$e9bda320f77097c2);

var $lKaEk = parcelRequire("lKaEk");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");
const $5f3bf43516b9e4cc$export$5a8cf468a1d46d4 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $lKaEk.periscopeEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $5f3bf43516b9e4cc$export$e9bda320f77097c2 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $lKaEk.periscopeEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("lKaEk", function(module, exports) {
$parcel$export(module.exports, "periscopeEntrypoint", () => $bab180b3cb5c548f$export$89ba9048c6fd23c6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $bab180b3cb5c548f$export$89ba9048c6fd23c6 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3xUAI")), {
        moduleId: "54c2239d",
        moduleName: "PeriscopePage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3xUAI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4TeAM")
]).then(()=>parcelRequire('9AZvJ'));

});




parcelRegister("hJy28", function(module, exports) {
$parcel$export(module.exports, "softwarePeriscopeNextGenRouteEntry", () => $ec3c1af8b8c51e18$export$7db4d910357a4d89);

var $74oEx = parcelRequire("74oEx");


var $iSoIx = parcelRequire("iSoIx");

var $l1vE2 = parcelRequire("l1vE2");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $ayS3g = parcelRequire("ayS3g");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $aOrm7 = parcelRequire("aOrm7");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $6bGyp = parcelRequire("6bGyp");

var $41FAq = parcelRequire("41FAq");

var $i860n = parcelRequire("i860n");

var $jk8fq = parcelRequire("jk8fq");
const $ec3c1af8b8c51e18$export$7db4d910357a4d89 = (0, $fdS54.createEntry)((0, $aOrm7.softwarePeriscopeNextGenRoute), ()=>({
        group: 'software',
        skeleton: (0, $ayS3g.Skeleton),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)((0, $i860n.fg)('navx-global-side-nav') ? {
                isUsingSidebarEntrypoint: true
            } : undefined),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6bGyp.rovoEntitlementResource)
        ],
        entryPoint: ()=>{
            if ((0, $l1vE2.isFedRamp)()) {
                // JOLT-2765: FedRAMP tenants are blocked from Periscope by default.
                // The kill-switch gate enables an AEM allowlist check that lets
                // individual FedRAMP tenants opt in.
                if (!(0, $i860n.fg)('jira_development_enable_aem_fedramp_check')) return 0, $iSoIx.notFoundPageEntrypoint;
                if (!(0, $41FAq.isFeatureEnabled)('jira', 'jira-development-tab')) return 0, $iSoIx.notFoundPageEntrypoint;
            }
            if ((0, $i860n.fg)('navx-global-side-nav')) return 0, $jk8fq.GSNPeriscopeEntryPoint;
            return 0, $jk8fq.periscopeEntryPoint;
        },
        meta: {
            reporting: {
                id: 'software-periscope',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-periscope'),
                teamName: 'jolt'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aOrm7", function(module, exports) {
$parcel$export(module.exports, "softwarePeriscopeNextGenRoute", () => $da135b3395ed8b23$export$9d0f329211395c25);
const $da135b3395ed8b23$export$9d0f329211395c25 = {
    name: 'software-periscope',
    path: '/jira/software/projects/:projectKey/development'
};

});


parcelRegister("fPKcH", function(module, exports) {
$parcel$export(module.exports, "softwarePlanCalendarRouteEntry", () => $8649313135f55323$export$67c64fea9be584ed);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");


var $lB7xL = parcelRequire("lB7xL");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $kyBX6 = parcelRequire("kyBX6");

var $jmSzK = parcelRequire("jmSzK");

var $91AnQ = parcelRequire("91AnQ");
const $8649313135f55323$export$67c64fea9be584ed = (0, $fdS54.createEntry)((0, $kyBX6.softwarePlanCalendarRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar',
        skeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jmSzK.CalendarSkeleton), null),
        entryPoint () {
            (0, $lB7xL.setCapability)((0, $0ce01f968965dadd$export$f999749ac7a2cd1));
            return 0, $91AnQ.planCalendarPageEntryPoint;
        },
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            (0, $6ZHVf.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        meta: {
            capability: (0, $0ce01f968965dadd$export$f999749ac7a2cd1)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kyBX6", function(module, exports) {
$parcel$export(module.exports, "softwarePlanCalendarRoute", () => $810c184293f71b99$export$ca4c39d60ec156a2);
const $810c184293f71b99$export$ca4c39d60ec156a2 = {
    name: 'software-plan-calendar',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
};

});

parcelRegister("91AnQ", function(module, exports) {
$parcel$export(module.exports, "planCalendarPageEntryPoint", () => $c6866a5d80c82d26$export$6e8a1c5de1f63c61);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $f9udY = parcelRequire("f9udY");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");
const $c6866a5d80c82d26$export$6e8a1c5de1f63c61 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $f9udY.calendarEntryPoint),
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("cgZW8", function(module, exports) {
$parcel$export(module.exports, "softwarePlanDependenciesRouteEntry", () => $dd898e1fd715b2e9$export$103062f08086fba0);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $3uDe5 = parcelRequire("3uDe5");

var $aXCpS = parcelRequire("aXCpS");

var $1eLV9 = parcelRequire("1eLV9");
const $dd898e1fd715b2e9$export$103062f08086fba0 = (0, $fdS54.createEntry)((0, $3uDe5.softwarePlanDependenciesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $1eLV9.planDependenciesReportPageEntryPoint),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aXCpS.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            (0, $6ZHVf.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aXCpS.LazyPlanDependenciesReport)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3uDe5", function(module, exports) {
$parcel$export(module.exports, "softwarePlanDependenciesRoute", () => $e37da490ed784783$export$ad8296aa5394f696);
const $e37da490ed784783$export$ad8296aa5394f696 = {
    name: 'software-plan-dependencies',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
};

});

parcelRegister("aXCpS", function(module, exports) {
$parcel$export(module.exports, "LazyPlanDependenciesReport", () => $2019561bf85f9d93$export$d4669c7a2f17c261);
$parcel$export(module.exports, "default", () => $2019561bf85f9d93$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $2019561bf85f9d93$export$d4669c7a2f17c261 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("lt7TE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-dependencies-report/src/PlanDependenciesReport.tsx"
});
const $2019561bf85f9d93$var$AsyncPlanDependenciesReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $2019561bf85f9d93$export$d4669c7a2f17c261,
        pageId: "plan-dependencies-report",
        shouldShowSpinner: true
    });
$2019561bf85f9d93$var$AsyncPlanDependenciesReport.displayName = "AsyncPlanDependenciesReport";
var $2019561bf85f9d93$export$2e2bcd8739ae039 = $2019561bf85f9d93$var$AsyncPlanDependenciesReport;

});

parcelRegister("1eLV9", function(module, exports) {
$parcel$export(module.exports, "planDependenciesReportPageEntryPoint", () => $03613c799c866e44$export$1d873335adb647af);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $8tfk1 = parcelRequire("8tfk1");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");
const $03613c799c866e44$export$1d873335adb647af = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8tfk1.planDependenciesReportEntryPoint),
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("7BVmS", function(module, exports) {
$parcel$export(module.exports, "softwarePlannerClassicPlanRouteEntry", () => $8321f687eb3be4a3$export$c9d668f408f2866f);

var $dIUBq = parcelRequire("dIUBq");

var $iSoIx = parcelRequire("iSoIx");

var $hvoiq = parcelRequire("hvoiq");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");
const $8321f687eb3be4a3$var$aiPlanningClassicSoftwarePlanPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $dIUBq.aiPlanningPlanEntrypoint)
});
const $8321f687eb3be4a3$export$c9d668f408f2866f = (0, $fdS54.createEntry)((0, $hvoiq.softwarePlannerClassicPlanRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-planner-classic-plan',
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [],
        meta: {
            reporting: {
                id: 'software-planner-classic-plan',
                packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
                teamName: 'Dev AI - Planner'
            }
        },
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning -- temporary route handoff requires both the Planner tab gate and route-rename gate.
            (0, $i860n.fg)('jira_ai_planner_tab') && (0, $i860n.fg)('ai-planner-jira-monolith-route-rename') ? $8321f687eb3be4a3$var$aiPlanningClassicSoftwarePlanPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hvoiq", function(module, exports) {
$parcel$export(module.exports, "softwarePlannerClassicPlanRoute", () => $837eec49e58ac30b$export$bc0e6a484f7ad21a);
const $837eec49e58ac30b$export$bc0e6a484f7ad21a = {
    name: 'software-planner-classic-plan',
    path: '/jira/software/c/projects/:projectKey/planner/:planId',
    exact: true
};

});


parcelRegister("fX7zq", function(module, exports) {
$parcel$export(module.exports, "softwarePlannerClassicRouteEntry", () => $1ce09685ef5b55b0$export$febebb32256e2707);


var $9LROf = parcelRequire("9LROf");

var $iSoIx = parcelRequire("iSoIx");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $3O0ZG = parcelRequire("3O0ZG");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $75Njg = parcelRequire("75Njg");

var $3KSG6 = parcelRequire("3KSG6");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");
const $1ce09685ef5b55b0$var$aiPlanningClassicSoftwarePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9LROf.aiPlanningEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $1ce09685ef5b55b0$export$febebb32256e2707 = (0, $fdS54.createEntry)((0, $3O0ZG.softwarePlannerClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-planner-classic',
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $gZWlI.projectThemeResource)
        ],
        meta: {
            reporting: {
                id: 'software-planner-classic',
                packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
                teamName: 'Dev AI - Planner'
            }
        },
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning -- temporary route handoff requires both the Planner tab gate and route-rename gate.
            (0, $i860n.fg)('jira_ai_planner_tab') && (0, $i860n.fg)('ai-planner-jira-monolith-route-rename') ? $1ce09685ef5b55b0$var$aiPlanningClassicSoftwarePageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3O0ZG", function(module, exports) {
$parcel$export(module.exports, "softwarePlannerClassicRoute", () => $9375d0bf0061429a$export$f050e8b70fd70fa7);
const $9375d0bf0061429a$export$f050e8b70fd70fa7 = {
    name: 'software-planner-classic',
    path: '/jira/software/c/projects/:projectKey/planner',
    exact: true
};

});


parcelRegister("bZjzP", function(module, exports) {
$parcel$export(module.exports, "softwarePlannerPlanRouteEntry", () => $ae16cd7fbbfde25f$export$a38741cf93d55eb1);

var $dIUBq = parcelRequire("dIUBq");

var $iSoIx = parcelRequire("iSoIx");

var $6pSPT = parcelRequire("6pSPT");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $fdS54 = parcelRequire("fdS54");
const $ae16cd7fbbfde25f$var$aiPlanningSoftwarePlanPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $dIUBq.aiPlanningPlanEntrypoint)
});
const $ae16cd7fbbfde25f$export$a38741cf93d55eb1 = (0, $fdS54.createEntry)((0, $6pSPT.softwarePlannerPlanRoute), ()=>({
        group: 'software',
        ufoName: 'software-planner-plan',
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [],
        meta: {
            reporting: {
                id: 'software-planner-plan',
                packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
                teamName: 'Dev AI - Planner'
            }
        },
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning -- temporary route handoff requires both the Planner tab gate and route-rename gate.
            (0, $i860n.fg)('jira_ai_planner_tab') && (0, $i860n.fg)('ai-planner-jira-monolith-route-rename') ? $ae16cd7fbbfde25f$var$aiPlanningSoftwarePlanPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6pSPT", function(module, exports) {
$parcel$export(module.exports, "softwarePlannerPlanRoute", () => $fb8c7f7ce625c012$export$c46b69477f48c69d);
const $fb8c7f7ce625c012$export$c46b69477f48c69d = {
    name: 'software-planner-plan',
    path: '/jira/software/projects/:projectKey/planner/:planId',
    exact: true
};

});


parcelRegister("3Op65", function(module, exports) {
$parcel$export(module.exports, "softwarePlannerRouteEntry", () => $08fcd6468829db5a$export$e59517dbfb31f9af);


var $9LROf = parcelRequire("9LROf");

var $iSoIx = parcelRequire("iSoIx");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $ekjCi = parcelRequire("ekjCi");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $75Njg = parcelRequire("75Njg");

var $3KSG6 = parcelRequire("3KSG6");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");
const $08fcd6468829db5a$var$aiPlanningSoftwarePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $9LROf.aiPlanningEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $08fcd6468829db5a$export$e59517dbfb31f9af = (0, $fdS54.createEntry)((0, $ekjCi.softwarePlannerRoute), ()=>({
        group: 'software',
        ufoName: 'software-planner',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $gZWlI.projectThemeResource)
        ],
        meta: {
            reporting: {
                id: 'software-planner',
                packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
                teamName: 'Dev AI - Planner'
            }
        },
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning -- temporary route handoff requires both the Planner tab gate and route-rename gate.
            (0, $i860n.fg)('jira_ai_planner_tab') && (0, $i860n.fg)('ai-planner-jira-monolith-route-rename') ? $08fcd6468829db5a$var$aiPlanningSoftwarePageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ekjCi", function(module, exports) {
$parcel$export(module.exports, "softwarePlannerRoute", () => $84c377d495df68de$export$dec399d4cf16cde0);
const $84c377d495df68de$export$dec399d4cf16cde0 = {
    name: 'software-planner',
    path: '/jira/software/projects/:projectKey/planner',
    exact: true
};

});


parcelRegister("cw7Gw", function(module, exports) {
$parcel$export(module.exports, "softwarePlanReleasesRouteEntry", () => $dc5002072523dd69$export$b874fabd66f10ff4);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $fcvoC = parcelRequire("fcvoC");

var $3mpL9 = parcelRequire("3mpL9");

var $5NNRV = parcelRequire("5NNRV");
const $dc5002072523dd69$export$b874fabd66f10ff4 = (0, $fdS54.createEntry)((0, $fcvoC.softwarePlanReleasesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $5NNRV.planReleasesPageEntryPoint),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3mpL9.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            (0, $6ZHVf.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $3mpL9.LazyPlanReleases)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fcvoC", function(module, exports) {
$parcel$export(module.exports, "softwarePlanReleasesRoute", () => $fc0f6022871e8314$export$850236b64b0aa28b);
const $fc0f6022871e8314$export$850236b64b0aa28b = {
    name: 'software-plan-releases',
    path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
};

});

parcelRegister("3mpL9", function(module, exports) {
$parcel$export(module.exports, "LazyPlanReleases", () => $6d7e8ac09b10e92e$export$749f5d2513e04ec0);
$parcel$export(module.exports, "default", () => $6d7e8ac09b10e92e$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6d7e8ac09b10e92e$export$749f5d2513e04ec0 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("2OZyE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-releases/src/PlanReleases.tsx"
});
const $6d7e8ac09b10e92e$var$AsyncPlanReleases = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6d7e8ac09b10e92e$export$749f5d2513e04ec0,
        pageId: "plan-releases",
        shouldShowSpinner: true
    });
$6d7e8ac09b10e92e$var$AsyncPlanReleases.displayName = "AsyncPlanReleases";
var $6d7e8ac09b10e92e$export$2e2bcd8739ae039 = $6d7e8ac09b10e92e$var$AsyncPlanReleases;

});
parcelRegister("2OZyE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("jrTIv")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ezDCH")
]).then(()=>parcelRequire('lzfrg'));

});


parcelRegister("5NNRV", function(module, exports) {
$parcel$export(module.exports, "planReleasesPageEntryPoint", () => $1550d4d73285d619$export$accb0033190d648e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $2Xp6m = parcelRequire("2Xp6m");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");
const $1550d4d73285d619$export$accb0033190d648e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2Xp6m.planReleasesEntryPoint),
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("2Xp6m", function(module, exports) {
$parcel$export(module.exports, "planReleasesEntryPoint", () => $1a6d0bb1d386f3f2$export$4e18896acd7f3236);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $1a6d0bb1d386f3f2$export$4e18896acd7f3236 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("66W8K")), {
        moduleId: "62e46b0b",
        moduleName: "PlanReleasesPlanReleases",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("66W8K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("8eIyt")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("eyQ9q")
]).then(()=>parcelRequire('exbiI'));

});




parcelRegister("hO2gx", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRouteEntry", () => $b9d32d114e26bbf8$export$fc7007717398c727);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $i27eQ = parcelRequire("i27eQ");

var $i860n = parcelRequire("i860n");

var $lV81A = parcelRequire("lV81A");
const $b9d32d114e26bbf8$var$getConditionalSidebarResources = ()=>{
    return (0, $i860n.fg)('plan_settings_sidebar_migrate_to_relay') ? [] : (0, $dUAVJ.getNavigationSidebarPlanResources)();
};
const $b9d32d114e26bbf8$export$fc7007717398c727 = (0, $fdS54.createEntry)((0, $i27eQ.softwarePlanSettingsAutoSchedulerRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lV81A.default),
        layout: (0, $i860n.fg)('plan_settings_sidebar_migrate_to_relay') ? (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayoutWithoutInvalidation)) : (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...$b9d32d114e26bbf8$var$getConditionalSidebarResources(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lV81A.LazyPlanSettingsAutoScheduler)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $0dab87234c301ee0$export$e52a1c4dceb4b708 = 'PLAN_SETTINGS';

parcelRegister("i27eQ", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", () => $157e6b0b15586b73$export$e44088b2cc0206cf);
const $157e6b0b15586b73$export$e44088b2cc0206cf = {
    name: 'plan-settings-auto-scheduler',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
};

});

parcelRegister("lV81A", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsAutoScheduler", () => $79ea7906f1396e92$export$8bcf7155849993f5);
$parcel$export(module.exports, "default", () => $79ea7906f1396e92$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $79ea7906f1396e92$export$8bcf7155849993f5 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("h5m45"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/PlanSettingsAutoScheduler.tsx"
});
const $79ea7906f1396e92$var$AsyncPlanSettingsAutoScheduler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $79ea7906f1396e92$export$8bcf7155849993f5,
        pageId: "plan-settings-auto-scheduler",
        shouldShowSpinner: true
    });
$79ea7906f1396e92$var$AsyncPlanSettingsAutoScheduler.displayName = "AsyncPlanSettingsAutoScheduler";
var $79ea7906f1396e92$export$2e2bcd8739ae039 = $79ea7906f1396e92$var$AsyncPlanSettingsAutoScheduler;

});
parcelRegister("h5m45", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("4YgfX")),
    $4cvLQ("f3QHe")
]).then(()=>parcelRequire('89HQV'));

});



parcelRegister("7iRmA", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRouteEntry", () => $b369191fd968413f$export$89472d9db6946668);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $hQ3r4 = parcelRequire("hQ3r4");

var $atVT4 = parcelRequire("atVT4");
const $b369191fd968413f$export$89472d9db6946668 = (0, $fdS54.createEntry)((0, $hQ3r4.softwarePlanSettingsCustomFieldsRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $atVT4.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $atVT4.LazyPlanSettingsCustomFields)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hQ3r4", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", () => $13f33ed11188d446$export$2634cd63c73f7a35);
const $13f33ed11188d446$export$2634cd63c73f7a35 = {
    name: 'plan-settings-custom-fields',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
};

});

parcelRegister("atVT4", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsCustomFields", () => $93eb7fdda6e0e9a4$export$72bf44dbae2383e5);
$parcel$export(module.exports, "default", () => $93eb7fdda6e0e9a4$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $93eb7fdda6e0e9a4$export$72bf44dbae2383e5 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("12ANL"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/CustomFieldsPage.tsx"
});
const $93eb7fdda6e0e9a4$var$AsyncPlanSettingsCustomFields = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $93eb7fdda6e0e9a4$export$72bf44dbae2383e5,
        pageId: "plan-settings-custom-fields",
        shouldShowSpinner: true
    });
$93eb7fdda6e0e9a4$var$AsyncPlanSettingsCustomFields.displayName = "AsyncPlanSettingsCustomFields";
var $93eb7fdda6e0e9a4$export$2e2bcd8739ae039 = $93eb7fdda6e0e9a4$var$AsyncPlanSettingsCustomFields;

});
parcelRegister("12ANL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e5H1t").then(()=>parcelRequire('5wOXe'));

});



parcelRegister("clUFS", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRouteEntry", () => $3be41e41fda12a40$export$cd1b612d0c014154);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $3Euv1 = parcelRequire("3Euv1");

var $lHkAv = parcelRequire("lHkAv");
const $3be41e41fda12a40$export$cd1b612d0c014154 = (0, $fdS54.createEntry)((0, $3Euv1.softwarePlanSettingsExclusionRulesRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lHkAv.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lHkAv.LazyPlanSettingsExclusionRules)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3Euv1", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", () => $501d1526f2615d93$export$358b0ca69a4bd731);
const $501d1526f2615d93$export$358b0ca69a4bd731 = {
    name: 'plan-settings-exclusion-rules',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
};

});

parcelRegister("lHkAv", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsExclusionRules", () => $b53073f33373cb9a$export$78f61b03c267e6d9);
$parcel$export(module.exports, "default", () => $b53073f33373cb9a$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $b53073f33373cb9a$export$78f61b03c267e6d9 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("d3kP1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/ExclusionRulesPage.tsx"
});
const $b53073f33373cb9a$var$AsyncPlanSettingsExclusionRules = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $b53073f33373cb9a$export$78f61b03c267e6d9,
        pageId: "plan-settings-exclusion-rules",
        shouldShowSpinner: true
    });
$b53073f33373cb9a$var$AsyncPlanSettingsExclusionRules.displayName = "AsyncPlanSettingsExclusionRules";
var $b53073f33373cb9a$export$2e2bcd8739ae039 = $b53073f33373cb9a$var$AsyncPlanSettingsExclusionRules;

});
parcelRegister("d3kP1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4fpwF").then(()=>parcelRequire('iiiVd'));

});



parcelRegister("6E9wb", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsFeaturesRouteEntry", () => $5722720242f05d31$export$591e778de9bccacd);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $i860n = parcelRequire("i860n");

var $1wmYK = parcelRequire("1wmYK");

var $5AxQt = parcelRequire("5AxQt");
const $5722720242f05d31$var$getConditionalSidebarResources = ()=>{
    return (0, $i860n.fg)('plan_settings_sidebar_migrate_to_relay') ? [] : (0, $dUAVJ.getNavigationSidebarPlanResources)();
};
const $5722720242f05d31$export$591e778de9bccacd = (0, $fdS54.createEntry)((0, $1wmYK.softwarePlanSettingsFeaturesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $5AxQt.planSettingsFeaturesRouteEntry),
        layout: (0, $i860n.fg)('plan_settings_sidebar_migrate_to_relay') ? (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayoutWithoutInvalidation)) : (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...$5722720242f05d31$var$getConditionalSidebarResources(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1wmYK", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsFeaturesRoute", () => $e387a8cba0b52967$export$2e79af7413eb4921);
const $e387a8cba0b52967$export$2e79af7413eb4921 = {
    name: 'plan-settings-features',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/features'
};

});

parcelRegister("5AxQt", function(module, exports) {
$parcel$export(module.exports, "planSettingsFeaturesRouteEntry", () => $71a3b9a32f5ea53f$export$2cf26c8369ef29cd);
/* eslint-disable jira/naming/disallow-filenames */ 
var $geEOM = parcelRequire("geEOM");

var $dTa0V = parcelRequire("dTa0V");
const $71a3b9a32f5ea53f$export$2cf26c8369ef29cd = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $geEOM.planSettingsFeaturesEntryPoint)
});

});
parcelRegister("geEOM", function(module, exports) {
$parcel$export(module.exports, "planSettingsFeaturesEntryPoint", () => $6cdc427e6021533e$export$ae1839f07bffa153);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $lbpmy = parcelRequire("lbpmy");

const $6cdc427e6021533e$export$ae1839f07bffa153 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dZ6jM")), {
        moduleId: "d628d6d9",
        moduleName: "PlanSettingsFeatures",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                preLoadFeaturesEntryPoint: {
                    entryPoint: (0, $lbpmy.featuresEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("lbpmy", function(module, exports) {
$parcel$export(module.exports, "featuresEntryPoint", () => $19a91d078d11b4ce$export$e283e7092d12783d);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $8NHOp = parcelRequire("8NHOp");
const $19a91d078d11b4ce$var$toPlanAri = ({ siteId: siteId, activationId: activationId, planId: planId })=>{
    return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
};

const $19a91d078d11b4ce$export$e283e7092d12783d = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("7rCZ8")), {
        moduleId: "d3f15a98",
        moduleName: "DefaultFeaturesSettingsPageView",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>{
        return {
            queries: {
                plan: {
                    variables: {
                        planId: $19a91d078d11b4ce$var$toPlanAri({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            planId: String(match.params.planId)
                        })
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $8NHOp.default
                }
            }
        };
    }
});

});
parcelRegister("8NHOp", function(module, exports) {
$parcel$export(module.exports, "default", () => $63e571638c5eee17$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02c873fd829b83773f6e4cd716be2802>>
 * @relayHash e279a48377b7737b706dfa93c69e92c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cf392471e62cd1be0448a4a8325e310d19205fe38dd9ba1ecbd80f211e41a0b
const $63e571638c5eee17$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6cf392471e62cd1be0448a4a8325e310d19205fe38dd9ba1ecbd80f211e41a0b",
        "metadata": {},
        "name": "DefaultFeaturesSettingsPageViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $63e571638c5eee17$export$2e2bcd8739ae039 = $63e571638c5eee17$var$node;

});

parcelRegister("7rCZ8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8ky7L").then(()=>parcelRequire('kwjRP'));

});


parcelRegister("dZ6jM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("aWev6")),
    $4cvLQ("jN3g0")
]).then(()=>parcelRequire('kEjFf'));

});




parcelRegister("kHXh3", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRouteEntry", () => $90f07ae566886cde$export$2f975c505121e139);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $9LQyJ = parcelRequire("9LQyJ");

var $85Vra = parcelRequire("85Vra");
const $90f07ae566886cde$export$2f975c505121e139 = (0, $fdS54.createEntry)((0, $9LQyJ.softwarePlanSettingsFindYourIssueRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $85Vra.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $85Vra.LazyPlanSettingsFindYourIssue)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9LQyJ", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", () => $eab737e0876c6447$export$ab61883f74eb27c2);
const $eab737e0876c6447$export$ab61883f74eb27c2 = {
    name: 'plan-settings-find-your-issue',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
};

});

parcelRegister("85Vra", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsFindYourIssue", () => $d4760533a9197f85$export$731998664b7d5e72);
$parcel$export(module.exports, "default", () => $d4760533a9197f85$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $d4760533a9197f85$export$731998664b7d5e72 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("3cy9x"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/FindYourIssuePage.tsx"
});
const $d4760533a9197f85$var$AsyncPlanSettingsFindYourIssue = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $d4760533a9197f85$export$731998664b7d5e72,
        pageId: "plan-settings-find-your-issue",
        shouldShowSpinner: true
    });
$d4760533a9197f85$var$AsyncPlanSettingsFindYourIssue.displayName = "AsyncPlanSettingsFindYourIssue";
var $d4760533a9197f85$export$2e2bcd8739ae039 = $d4760533a9197f85$var$AsyncPlanSettingsFindYourIssue;

});
parcelRegister("3cy9x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("feGsU").then(()=>parcelRequire('65zo2'));

});



parcelRegister("7zkj7", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRouteEntry", () => $dc0160d4ba388f93$export$f0b7e9788ab79be0);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $faPMd = parcelRequire("faPMd");

var $96ulN = parcelRequire("96ulN");
const $dc0160d4ba388f93$export$f0b7e9788ab79be0 = (0, $fdS54.createEntry)((0, $faPMd.softwarePlanSettingsIssueSourcesRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $96ulN.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $96ulN.LazyPlanSettingsIssueSources)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("faPMd", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", () => $33d63e5b4a2180e3$export$fa18324265e4400c);
const $33d63e5b4a2180e3$export$fa18324265e4400c = {
    name: 'plan-settings-issue-sources',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
};

});

parcelRegister("96ulN", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsIssueSources", () => $157fb8b748716e09$export$7ba4b487efcedeb3);
$parcel$export(module.exports, "default", () => $157fb8b748716e09$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $157fb8b748716e09$export$7ba4b487efcedeb3 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("ahzju"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/PlanSettingsIssueSources.tsx"
});
const $157fb8b748716e09$var$AsyncPlanSettingsIssueSources = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $157fb8b748716e09$export$7ba4b487efcedeb3,
        pageId: "plan-settings-issue-sources",
        shouldShowSpinner: false
    });
$157fb8b748716e09$var$AsyncPlanSettingsIssueSources.displayName = "AsyncPlanSettingsIssueSources";
var $157fb8b748716e09$export$2e2bcd8739ae039 = $157fb8b748716e09$var$AsyncPlanSettingsIssueSources;

});
parcelRegister("ahzju", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("eo4iO")),
    $4cvLQ("7XEPQ")
]).then(()=>parcelRequire('idGlW'));

});



parcelRegister("7feYc", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsPermissionsRouteEntry", () => $d163ff16dc876167$export$1afc7a9efa99340);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $1jT2L = parcelRequire("1jT2L");

var $3ts06 = parcelRequire("3ts06");
const $d163ff16dc876167$export$1afc7a9efa99340 = (0, $fdS54.createEntry)((0, $1jT2L.softwarePlanSettingsPermissionsRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3ts06.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $3ts06.LazyPlanSettingsPermissions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1jT2L", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", () => $2a1039554d66779f$export$6734c29372722a5e);
const $2a1039554d66779f$export$6734c29372722a5e = {
    name: 'plan-settings-permissions',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
};

});

parcelRegister("3ts06", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsPermissions", () => $8b64b4f77ceb7834$export$49f5b76ad5c06a42);
$parcel$export(module.exports, "default", () => $8b64b4f77ceb7834$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $8b64b4f77ceb7834$export$49f5b76ad5c06a42 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("bldyx"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/PermissionsPage.tsx"
});
const $8b64b4f77ceb7834$var$AsyncPlanSettingsPermissions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $8b64b4f77ceb7834$export$49f5b76ad5c06a42,
        pageId: "plan-settings-permissions",
        shouldShowSpinner: true
    });
$8b64b4f77ceb7834$var$AsyncPlanSettingsPermissions.displayName = "AsyncPlanSettingsPermissions";
var $8b64b4f77ceb7834$export$2e2bcd8739ae039 = $8b64b4f77ceb7834$var$AsyncPlanSettingsPermissions;

});
parcelRegister("bldyx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l6Qpd").then(()=>parcelRequire('jUPZv'));

});



parcelRegister("3prgj", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRouteEntry", () => $985b68b0184da03d$export$1d6300da0c837e02);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $4lZZk = parcelRequire("4lZZk");

var $3OdBw = parcelRequire("3OdBw");
const $985b68b0184da03d$export$1d6300da0c837e02 = (0, $fdS54.createEntry)((0, $4lZZk.softwarePlanSettingsPlanInfoRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $3OdBw.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $3OdBw.LazyPlanSettingsPlanInfo)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4lZZk", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", () => $a3d112130c90877d$export$76e6bdc959f6fa97);
const $a3d112130c90877d$export$76e6bdc959f6fa97 = {
    name: 'plan-settings-plan-info',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
};

});

parcelRegister("3OdBw", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsPlanInfo", () => $67fb40e614c551a8$export$c1344fd7d24991b3);
$parcel$export(module.exports, "default", () => $67fb40e614c551a8$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $67fb40e614c551a8$export$c1344fd7d24991b3 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("9BYJQ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/PlanSettingsPlanInfo.tsx"
});
const $67fb40e614c551a8$var$AsyncPlanSettingsPlanInfo = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $67fb40e614c551a8$export$c1344fd7d24991b3,
        pageId: "plan-settings-plan-info",
        shouldShowSpinner: false
    });
$67fb40e614c551a8$var$AsyncPlanSettingsPlanInfo.displayName = "AsyncPlanSettingsPlanInfo";
var $67fb40e614c551a8$export$2e2bcd8739ae039 = $67fb40e614c551a8$var$AsyncPlanSettingsPlanInfo;

});
parcelRegister("9BYJQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("dCnND")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("6EZMZ")
]).then(()=>parcelRequire('jCB2X'));

});



parcelRegister("5Bwf9", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRouteEntry", () => $d7e0944722929170$export$be96222796ad98f0);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $e5dRS = parcelRequire("e5dRS");

var $gBee4 = parcelRequire("gBee4");
const $d7e0944722929170$export$be96222796ad98f0 = (0, $fdS54.createEntry)((0, $e5dRS.softwarePlanSettingsProgramBoardsRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gBee4.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $gBee4.LazyPlanSettingsProgramBoards)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("e5dRS", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", () => $3f4305f73d84dcec$export$3d54c48a91a178c0);
const $3f4305f73d84dcec$export$3d54c48a91a178c0 = {
    name: 'plan-settings-program-boards',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
};

});

parcelRegister("gBee4", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsProgramBoards", () => $af888686b77ca14b$export$ffdec728a47c437c);
$parcel$export(module.exports, "default", () => $af888686b77ca14b$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $af888686b77ca14b$export$ffdec728a47c437c = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("lb3tt"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/ProgramBoards.tsx"
});
const $af888686b77ca14b$var$AsyncPlanSettingsProgramBoards = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $af888686b77ca14b$export$ffdec728a47c437c,
        pageId: "plan-settings-program-boards",
        shouldShowSpinner: true
    });
$af888686b77ca14b$var$AsyncPlanSettingsProgramBoards.displayName = "AsyncPlanSettingsProgramBoards";
var $af888686b77ca14b$export$2e2bcd8739ae039 = $af888686b77ca14b$var$AsyncPlanSettingsProgramBoards;

});
parcelRegister("lb3tt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("kboeo")),
    $4cvLQ("iWfMV")
]).then(()=>parcelRequire('gpATI'));

});



parcelRegister("hC17e", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRouteEntry", () => $45bd2d1223f92b90$export$53a9ea0e0b05ceb5);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $7eerC = parcelRequire("7eerC");

var $aGwcJ = parcelRequire("aGwcJ");
const $45bd2d1223f92b90$export$53a9ea0e0b05ceb5 = (0, $fdS54.createEntry)((0, $7eerC.softwarePlanSettingsRemovedIssuesRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aGwcJ.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aGwcJ.LazyPlanSettingsRemovedIssues)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("7eerC", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", () => $a1fee2af85647565$export$8b77532ba9798e64);
const $a1fee2af85647565$export$8b77532ba9798e64 = {
    name: 'plan-settings-removed-issues',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
};

});

parcelRegister("aGwcJ", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsRemovedIssues", () => $c6a4c8b71d0c8c74$export$759df6301ec72119);
$parcel$export(module.exports, "default", () => $c6a4c8b71d0c8c74$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $c6a4c8b71d0c8c74$export$759df6301ec72119 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("k80Ck"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/RemovedIssuesPage.tsx"
});
const $c6a4c8b71d0c8c74$var$AsyncPlanSettingsRemovedIssues = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c6a4c8b71d0c8c74$export$759df6301ec72119,
        pageId: "plan-settings-removed-issues",
        shouldShowSpinner: true
    });
$c6a4c8b71d0c8c74$var$AsyncPlanSettingsRemovedIssues.displayName = "AsyncPlanSettingsRemovedIssues";
var $c6a4c8b71d0c8c74$export$2e2bcd8739ae039 = $c6a4c8b71d0c8c74$var$AsyncPlanSettingsRemovedIssues;

});
parcelRegister("k80Ck", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8lMAI").then(()=>parcelRequire('3NZAj'));

});



parcelRegister("8VnOK", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRouteEntry", () => $521c990296940547$export$64d5b46da2e58194);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $hr3rc = parcelRequire("hr3rc");

var $krNy0 = parcelRequire("krNy0");
const $521c990296940547$export$64d5b46da2e58194 = (0, $fdS54.createEntry)((0, $hr3rc.softwarePlanSettingsSavedViewsRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $krNy0.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $krNy0.LazyPlanSettingsSavedViews)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("hr3rc", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", () => $2bac3bd49c18141e$export$a0fec30f475e8756);
const $2bac3bd49c18141e$export$a0fec30f475e8756 = {
    name: 'plan-settings-saved-views',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
};

});

parcelRegister("krNy0", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsSavedViews", () => $be339dee7810c44f$export$a5398542699d356a);
$parcel$export(module.exports, "default", () => $be339dee7810c44f$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $be339dee7810c44f$export$a5398542699d356a = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("9r7uA"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/PlanSettingsSavedViews.tsx"
});
const $be339dee7810c44f$var$AsyncPlanSettingsSavedViews = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $be339dee7810c44f$export$a5398542699d356a,
        pageId: "plan-settings-saved-views",
        shouldShowSpinner: false
    });
$be339dee7810c44f$var$AsyncPlanSettingsSavedViews.displayName = "AsyncPlanSettingsSavedViews";
var $be339dee7810c44f$export$2e2bcd8739ae039 = $be339dee7810c44f$var$AsyncPlanSettingsSavedViews;

});
parcelRegister("9r7uA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("fvCsn")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iUT1v")
]).then(()=>parcelRequire('3aW0a'));

});



parcelRegister("dTKEk", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsScenariosRouteEntry", () => $97698281ab93f445$export$9b6e6b5d471b90f);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $beTZE = parcelRequire("beTZE");

var $i860n = parcelRequire("i860n");

var $aq4Do = parcelRequire("aq4Do");
const $97698281ab93f445$var$getConditionalSidebarResources = ()=>{
    return (0, $i860n.fg)('plan_settings_sidebar_migrate_to_relay') ? [] : (0, $dUAVJ.getNavigationSidebarPlanResources)();
};
const $97698281ab93f445$export$9b6e6b5d471b90f = (0, $fdS54.createEntry)((0, $beTZE.softwarePlanSettingsScenariosRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aq4Do.default),
        layout: (0, $i860n.fg)('plan_settings_sidebar_migrate_to_relay') ? (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayoutWithoutInvalidation)) : (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...$97698281ab93f445$var$getConditionalSidebarResources(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aq4Do.LazyPlanSettingsScenarios)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("beTZE", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", () => $12c325acfacf3ec2$export$d32efeefb944c6b7);
const $12c325acfacf3ec2$export$d32efeefb944c6b7 = {
    name: 'plan-settings-scenarios',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
};

});

parcelRegister("aq4Do", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsScenarios", () => $1b4fdc7b0a4f8147$export$94104fcc1a6f460f);
$parcel$export(module.exports, "default", () => $1b4fdc7b0a4f8147$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $1b4fdc7b0a4f8147$export$94104fcc1a6f460f = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("kdOqk"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/PlanSettingsScenarios.tsx"
});
const $1b4fdc7b0a4f8147$var$AsyncPlanSettingsScenarios = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $1b4fdc7b0a4f8147$export$94104fcc1a6f460f,
        pageId: "plan-settings-scenarios",
        shouldShowSpinner: true
    });
$1b4fdc7b0a4f8147$var$AsyncPlanSettingsScenarios.displayName = "AsyncPlanSettingsScenarios";
var $1b4fdc7b0a4f8147$export$2e2bcd8739ae039 = $1b4fdc7b0a4f8147$var$AsyncPlanSettingsScenarios;

});
parcelRegister("kdOqk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("2D3n2")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("i9nRW")
]).then(()=>parcelRequire('bCSNI'));

});



parcelRegister("9m1kX", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsSchedulingRouteEntry", () => $e6f960a808f7f70d$export$c1319dec79812860);
/* eslint-disable import/order */ 


var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $l9nPP = parcelRequire("l9nPP");

var $dFMN1 = parcelRequire("dFMN1");
const $e6f960a808f7f70d$export$c1319dec79812860 = (0, $fdS54.createEntry)((0, $l9nPP.softwarePlanSettingsSchedulingRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dFMN1.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $0dab87234c301ee0$export$e52a1c4dceb4b708),
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $dFMN1.LazyPlanSettingsScheduling)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("l9nPP", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", () => $a9a4b6adbbaf27be$export$a215ef374dd2a8a9);
const $a9a4b6adbbaf27be$export$a215ef374dd2a8a9 = {
    name: 'plan-settings-scheduling',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
};

});

parcelRegister("dFMN1", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsScheduling", () => $7818175cf3635e7b$export$3bf11db1bbeae73e);
$parcel$export(module.exports, "default", () => $7818175cf3635e7b$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $7818175cf3635e7b$export$3bf11db1bbeae73e = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("jNxng"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-settings/src/PlanSettingsScheduling.tsx"
});
const $7818175cf3635e7b$var$AsyncPlanSettingsScheduling = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $7818175cf3635e7b$export$3bf11db1bbeae73e,
        pageId: "plan-settings-scheduling",
        shouldShowSpinner: false
    });
$7818175cf3635e7b$var$AsyncPlanSettingsScheduling.displayName = "AsyncPlanSettingsScheduling";
var $7818175cf3635e7b$export$2e2bcd8739ae039 = $7818175cf3635e7b$var$AsyncPlanSettingsScheduling;

});
parcelRegister("jNxng", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("f7L5S")),
    $4cvLQ("frXW4")
]).then(()=>parcelRequire('aLK5U'));

});



parcelRegister("eMB1E", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSummaryRouteEntry", () => $b0178e92e7827c5d$export$4bc10767887a84cc);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $eHM2A = parcelRequire("eHM2A");

var $hSbtM = parcelRequire("hSbtM");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $inv50 = parcelRequire("inv50");

var $fq61u = parcelRequire("fq61u");

var $7jq9C = parcelRequire("7jq9C");
const $b0178e92e7827c5d$export$4bc10767887a84cc = (0, $fdS54.createEntry)((0, $inv50.softwarePlanSummaryRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $7jq9C.planSummaryPageEntryPoint),
        ufoName: 'software-advanced-roadmaps-summary',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $fq61u.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $eHM2A.advancedRoadmapsSummaryDataResource),
            (0, $hSbtM.summaryPagePreferencesResource),
            (0, $6ZHVf.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $fq61u.LazyPlanSummary)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("inv50", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSummaryRoute", () => $bfb7e74470db1d92$export$25a8cf27557a612d);
const $bfb7e74470db1d92$export$25a8cf27557a612d = {
    name: 'software-plan-summary',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
};

});

parcelRegister("fq61u", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSummary", () => $9d065863ec9dacab$export$c717f0d9d7f11b49);
$parcel$export(module.exports, "default", () => $9d065863ec9dacab$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $9d065863ec9dacab$export$c717f0d9d7f11b49 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("jox58"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-summary/src/PlanSummaryWithErrorBoundary.tsx"
});
const $9d065863ec9dacab$var$AsyncPlanSummary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $9d065863ec9dacab$export$c717f0d9d7f11b49,
        pageId: "plan-summary",
        shouldShowSpinner: true
    });
$9d065863ec9dacab$var$AsyncPlanSummary.displayName = "AsyncPlanSummary";
var $9d065863ec9dacab$export$2e2bcd8739ae039 = $9d065863ec9dacab$var$AsyncPlanSummary;

});

parcelRegister("7jq9C", function(module, exports) {
$parcel$export(module.exports, "planSummaryPageEntryPoint", () => $5774a0d9a9e561e7$export$a3858cce1e973f19);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $4sqdF = parcelRequire("4sqdF");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");
const $5774a0d9a9e561e7$export$a3858cce1e973f19 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4sqdF.planSummaryEntryPoint),
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("crkYO", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTeamsRouteEntry", () => $c18acf7935a23f48$export$cc5b7d3f8546a313);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $gT701 = parcelRequire("gT701");

var $jsiAt = parcelRequire("jsiAt");

var $hDBwy = parcelRequire("hDBwy");
const $c18acf7935a23f48$export$cc5b7d3f8546a313 = (0, $fdS54.createEntry)((0, $gT701.softwarePlanTeamsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $hDBwy.planTeamsPageEntryPoint),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jsiAt.default),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $jsiAt.LazyPlanTeams)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gT701", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTeamsRoute", () => $55be4d2457d983c2$export$fc66f5c0de18ddc7);
const $55be4d2457d983c2$export$fc66f5c0de18ddc7 = {
    name: 'software-plan-teams',
    path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
};

});

parcelRegister("jsiAt", function(module, exports) {
$parcel$export(module.exports, "LazyPlanTeams", () => $f2b244b48021f24c$export$f85952f98f28fed0);
$parcel$export(module.exports, "default", () => $f2b244b48021f24c$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $f2b244b48021f24c$export$f85952f98f28fed0 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("7OrH8"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps-plan-teams/src/ExportedComponent.tsx"
});
const $f2b244b48021f24c$var$AsyncPlanTeams = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $f2b244b48021f24c$export$f85952f98f28fed0,
        pageId: "plan-teams",
        shouldShowSpinner: true
    });
$f2b244b48021f24c$var$AsyncPlanTeams.displayName = "AsyncPlanTeams";
var $f2b244b48021f24c$export$2e2bcd8739ae039 = $f2b244b48021f24c$var$AsyncPlanTeams;

});
parcelRegister("7OrH8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("59Su4")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("cDG9h")
]).then(()=>parcelRequire('1OleG'));

});


parcelRegister("hDBwy", function(module, exports) {
$parcel$export(module.exports, "planTeamsPageEntryPoint", () => $25d8c7eeb6a26e94$export$e75b3c6626974862);
/* eslint-disable jira/naming/disallow-filenames */ 
var $cbhB0 = parcelRequire("cbhB0");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");
const $25d8c7eeb6a26e94$export$e75b3c6626974862 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $cbhB0.planTeamsEntryPoint),
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("cbhB0", function(module, exports) {
$parcel$export(module.exports, "planTeamsEntryPoint", () => $d060557bb8d07080$export$afd1c95955e9abac);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $d060557bb8d07080$export$afd1c95955e9abac = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("3vq3y")), {
        moduleId: "a55ebb73",
        moduleName: "PlanTeamsEntryPointRoot",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3vq3y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("6IImj"))((parcelRequire("96thM")).resolve("9C1EH")),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ewjjN")
]).then(()=>parcelRequire('9X48N'));

});




parcelRegister("jCOMd", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTimelineRouteEntry", () => $8f969fb250089e20$export$c5b46ecd4d9a8abd);
/* eslint-disable import/order */ 

var $6ZHVf = parcelRequire("6ZHVf");

var $9G2Ea = parcelRequire("9G2Ea");

var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $gOM9u = parcelRequire("gOM9u");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $gND04 = parcelRequire("gND04");

var $mwGtD = parcelRequire("mwGtD");

var $8tAZd = parcelRequire("8tAZd");

var $3zppm = parcelRequire("3zppm");
const $8f969fb250089e20$export$c5b46ecd4d9a8abd = (0, $fdS54.createEntry)((0, $gND04.softwarePlanTimelineRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $3zppm.planTimelinePageEntryPoint),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8tAZd.default),
        skeleton: (0, $mwGtD.PlanTimelineSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), (0, $gOM9u.planLayout)),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarPlanResources)(),
            (0, $6ZHVf.advancedRoadmapsPlanPageInitialChecksResource),
            ...(0, $9G2Ea.getPlansBacklogResource)(),
            (0, $6ZHVf.advancedRoadmapsReduxStoreStateResource),
            (0, $6ZHVf.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $8tAZd.LazyPlanTimeline)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gND04", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTimelineRoute", () => $4f44a3bf572fb82f$export$61abeb6a03d23dd3);
const $4f44a3bf572fb82f$export$61abeb6a03d23dd3 = {
    name: 'software-plan-timeline',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
};

});

parcelRegister("mwGtD", function(module, exports) {
$parcel$export(module.exports, "PlanTimelineSkeleton", () => $7730c7418ec3d909$export$66cb34f8935c5b02);
$parcel$export(module.exports, "PlanTimelineSkeletonWithoutPadding", () => $7730c7418ec3d909$export$f811d7dfe6fc560);
/* PlanTimelineSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $hfCcB = parcelRequire("hfCcB");

var $j4icM = parcelRequire("j4icM");
const $7730c7418ec3d909$var$customCssStyles = null;
const $7730c7418ec3d909$var$customCssStylesWithPadding = null;
const $7730c7418ec3d909$export$66cb34f8935c5b02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hfCcB))),
        className: (0, $4jQY2.default)([
            "_slt81tcg _2zz1idpf"
        ])
    });
$7730c7418ec3d909$export$66cb34f8935c5b02.displayName = "PlanTimelineSkeleton";
const $7730c7418ec3d909$export$f811d7dfe6fc560 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hfCcB))),
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    });
$7730c7418ec3d909$export$f811d7dfe6fc560.displayName = "PlanTimelineSkeletonWithoutPadding";
const $7730c7418ec3d909$export$5310e44384026686 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j4icM))),
        className: (0, $4jQY2.default)([
            "_1wgmglyw"
        ])
    });
$7730c7418ec3d909$export$5310e44384026686.displayName = "PlanTimelineSkeletonWithoutFilters";

});
parcelRegister("hfCcB", function(module, exports) {
module.exports = new URL("plan-timeline-skeleton.tpl.184c1195.svg", import.meta.url).toString();

});

parcelRegister("j4icM", function(module, exports) {
module.exports = new URL("plan-timeline-without-filters-skeleton.tpl.745bd011.svg", import.meta.url).toString();

});


parcelRegister("3zppm", function(module, exports) {
$parcel$export(module.exports, "planTimelinePageEntryPoint", () => $a5affa6f8dc7cf7e$export$7ee5b399f9530a72);
/* eslint-disable jira/naming/disallow-filenames */ 
var $l35MP = parcelRequire("l35MP");

var $dTa0V = parcelRequire("dTa0V");

var $g1xPc = parcelRequire("g1xPc");
const $a5affa6f8dc7cf7e$export$7ee5b399f9530a72 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l35MP.planTimelineEntryPoint),
    horizontalNavigation: (0, $g1xPc.plansHorizontalNavigationEntryPoint)
});

});


parcelRegister("kZ0yx", function(module, exports) {
$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRouteEntry", () => $161aaaf7359f0b45$export$6df3cef5dab31b3b);

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $edf7u = parcelRequire("edf7u");

var $8CTEG = parcelRequire("8CTEG");

var $ixLW7 = parcelRequire("ixLW7");
const $161aaaf7359f0b45$export$6df3cef5dab31b3b = (0, $fdS54.createEntry)((0, $8CTEG.softwareProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $byMD7.chromelessLayout),
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $edf7u.projectContextResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $ixLW7.default),
        forPaint: [
            (0, $ixLW7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8CTEG", function(module, exports) {
$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRoute", () => $ff23842570edce20$export$6d1b944aeb758fdb);
const $ff23842570edce20$export$6d1b944aeb758fdb = {
    name: 'software-proforma-issue-forms-direct-embed',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("8rJFK", function(module, exports) {
$parcel$export(module.exports, "softwareProformaIssueFormsDirectRouteEntry", () => $7b9db077c3e73c84$export$552db754a91368f3);


var $fdS54 = parcelRequire("fdS54");

var $4B518 = parcelRequire("4B518");

var $edf7u = parcelRequire("edf7u");

var $2PXFe = parcelRequire("2PXFe");

var $3eysO = parcelRequire("3eysO");

var $gXJFZ = parcelRequire("gXJFZ");
const $7b9db077c3e73c84$export$552db754a91368f3 = (0, $fdS54.createEntry)((0, $2PXFe.softwareProformaIssueFormsDirectRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayout),
        // eslint-disable-next-line jira/router/no-project-context-resource
        resources: [
            ...(0, $4B518.jiraSpaResources)(),
            (0, $edf7u.projectContextResource)
        ],
        entryPoint: ()=>(0, $gXJFZ.proformaIssueFormsDirectPageEntryPoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        perfMetricKey: 'issue-forms-direct',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2PXFe", function(module, exports) {
$parcel$export(module.exports, "softwareProformaIssueFormsDirectRoute", () => $4c2cd82f7b357db0$export$69db7046ead228b9);
const $4c2cd82f7b357db0$export$69db7046ead228b9 = {
    name: 'software-proforma-issue-forms-direct',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("iycSK", function(module, exports) {
$parcel$export(module.exports, "softwareReleaseNotesRouteEntry", () => $fce66725b64d47dd$export$543aad2020051ecb);



var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $eobPE = parcelRequire("eobPE");

var $3eysO = parcelRequire("3eysO");

var $7ecC0 = parcelRequire("7ecC0");
const $fce66725b64d47dd$export$543aad2020051ecb = (0, $fdS54.createEntry)((0, $eobPE.softwareReleaseNotesRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $7ecC0.SpaReleaseNoteRedirectToVersionDetails),
        layout: (0, $3eysO.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("eobPE", function(module, exports) {
$parcel$export(module.exports, "softwareReleaseNotesRoute", () => $7c44e3dabe980a38$export$a0223091962262d4);
const $7c44e3dabe980a38$export$a0223091962262d4 = {
    name: 'software-release-notes',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId'
    ]
};

});


parcelRegister("716o6", function(module, exports) {
$parcel$export(module.exports, "softwareReportsBurndownRouteEntry", () => $ae965a83d0bdeeba$export$c54d6c6781ad5beb);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $dqqbQ = parcelRequire("dqqbQ");

var $3eysO = parcelRequire("3eysO");

var $1xSQN = parcelRequire("1xSQN");

var $eK14D = parcelRequire("eK14D");
const $ae965a83d0bdeeba$export$c54d6c6781ad5beb = (0, $fdS54.createEntry)((0, $dqqbQ.softwareReportsBurndownRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burndown-chart',
        entryPoint: ()=>(0, $eK14D.BurnDownReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1xSQN.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dqqbQ", function(module, exports) {
$parcel$export(module.exports, "softwareReportsBurndownRoute", () => $bc8ab22180d4085f$export$e0d8c26cb1430ae4);
const $bc8ab22180d4085f$export$e0d8c26cb1430ae4 = {
    name: 'software-reports-burndown',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
};

});

parcelRegister("1xSQN", function(module, exports) {
$parcel$export(module.exports, "getTMPReportsCommonResource", () => $3673baf7c3384224$export$f234446c23dc22a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $3673baf7c3384224$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $3673baf7c3384224$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});

parcelRegister("eK14D", function(module, exports) {
$parcel$export(module.exports, "BurnDownReportPageEntrypoint", () => $0da0e0c9e7df3825$export$4cba13cb70183e0e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $2FLso = parcelRequire("2FLso");

var $dTa0V = parcelRequire("dTa0V");
const $0da0e0c9e7df3825$export$4cba13cb70183e0e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $2FLso.burnDownReportEntrypoint)
});

});
parcelRegister("2FLso", function(module, exports) {
$parcel$export(module.exports, "burnDownReportEntrypoint", () => $288df7c21f43a625$export$ca10f29d444e87e0);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $288df7c21f43a625$export$ca10f29d444e87e0 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hQCPP")), {
        moduleId: "3e084b51",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hQCPP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fIHi").then(()=>parcelRequire('jL3b1'));

});




parcelRegister("7yKoP", function(module, exports) {
$parcel$export(module.exports, "softwareReportsBurnupRouteEntry", () => $18cfcecbf29789c3$export$e53193d8a7e7d068);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $awJLw = parcelRequire("awJLw");

var $3eysO = parcelRequire("3eysO");

var $1xSQN = parcelRequire("1xSQN");

var $hLeyn = parcelRequire("hLeyn");
const $18cfcecbf29789c3$export$e53193d8a7e7d068 = (0, $fdS54.createEntry)((0, $awJLw.softwareReportsBurnupRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burnup-chart',
        entryPoint: ()=>(0, $hLeyn.BurnUpReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1xSQN.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("awJLw", function(module, exports) {
$parcel$export(module.exports, "softwareReportsBurnupRoute", () => $96971af3fffb3aaa$export$5b818a6914ca8376);
const $96971af3fffb3aaa$export$5b818a6914ca8376 = {
    name: 'software-reports-burnup',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
};

});

parcelRegister("hLeyn", function(module, exports) {
$parcel$export(module.exports, "BurnUpReportPageEntrypoint", () => $4001f3f26590f465$export$5901b46abc65034e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $eQnwN = parcelRequire("eQnwN");

var $dTa0V = parcelRequire("dTa0V");
const $4001f3f26590f465$export$5901b46abc65034e = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $eQnwN.burnUpReportEntrypoint)
});

});
parcelRegister("eQnwN", function(module, exports) {
$parcel$export(module.exports, "burnUpReportEntrypoint", () => $a5fe52dda445190e$export$dfec2f14e71954f6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $a5fe52dda445190e$export$dfec2f14e71954f6 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("cWhd7")), {
        moduleId: "7e22ac6c",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cWhd7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jIrz4").then(()=>parcelRequire('krE6A'));

});




parcelRegister("l0NQn", function(module, exports) {
$parcel$export(module.exports, "softwareReportsControlRouteEntry", () => $04f7a351b2152cb6$export$3cb9570ca242f2a2);

var $74oEx = parcelRequire("74oEx");


var $iSoIx = parcelRequire("iSoIx");

var $052eo = parcelRequire("052eo");

var $i860n = parcelRequire("i860n");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $XjZbb = parcelRequire("XjZbb");

var $3eysO = parcelRequire("3eysO");

var $1xSQN = parcelRequire("1xSQN");

var $aDJbx = parcelRequire("aDJbx");
const $04f7a351b2152cb6$export$3cb9570ca242f2a2 = (0, $fdS54.createEntry)((0, $XjZbb.softwareReportsControlRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.control-chart',
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1xSQN.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>!(0, $i860n.fg)('jsw_enable_avp_control_chart') || (0, $052eo.isDevopsFeatureDisabledInFedRamp)() ? (0, $iSoIx.notFoundPageEntrypoint) : (0, $aDJbx.softwareReportsControlPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-reports-control',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-reports-control'),
                teamName: 'jira-werewolves'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("XjZbb", function(module, exports) {
$parcel$export(module.exports, "softwareReportsControlRoute", () => $fccc3c0b34e2d0f1$export$8c91815cd4b1c078);
const $fccc3c0b34e2d0f1$export$8c91815cd4b1c078 = {
    name: 'software-reports-control',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
};

});

parcelRegister("aDJbx", function(module, exports) {
$parcel$export(module.exports, "softwareReportsControlPageEntrypoint", () => $b45bfd7512bc7183$export$a35d50a33df2f6d5);
/* eslint-disable jira/naming/disallow-filenames */ 
var $lHGWm = parcelRequire("lHGWm");

var $dTa0V = parcelRequire("dTa0V");
const $b45bfd7512bc7183$export$a35d50a33df2f6d5 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $lHGWm.softwareReportsControlEntrypoint)
});

});
parcelRegister("lHGWm", function(module, exports) {
$parcel$export(module.exports, "softwareReportsControlEntrypoint", () => $689aba576398e7ee$export$240870c8f3915828);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $689aba576398e7ee$export$240870c8f3915828 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gxUTQ")), {
        moduleId: "5fd9542d",
        moduleName: "ExportedComponent",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gxUTQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("f1SEn")
]).then(()=>parcelRequire('dkHts'));

});




parcelRegister("2Q23O", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCumulativeRouteEntry", () => $26b86655c0fb0edc$export$7ace4d0363d78b41);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $cfk4E = parcelRequire("cfk4E");

var $3eysO = parcelRequire("3eysO");

var $1xSQN = parcelRequire("1xSQN");

var $13vcb = parcelRequire("13vcb");
const $26b86655c0fb0edc$export$7ace4d0363d78b41 = (0, $fdS54.createEntry)((0, $cfk4E.softwareReportsCumulativeRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.cumulative-flow-diagram',
        entryPoint: ()=>(0, $13vcb.CumulativeReportPageEntrypoint),
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1xSQN.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("cfk4E", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCumulativeRoute", () => $2abd6ccfc37473fa$export$3c48ddd40d00b0d2);
const $2abd6ccfc37473fa$export$3c48ddd40d00b0d2 = {
    name: 'software-reports-cumulative',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
};

});

parcelRegister("13vcb", function(module, exports) {
$parcel$export(module.exports, "CumulativeReportPageEntrypoint", () => $e5db3d53d0cb14f9$export$2f3ad380ae691fb5);
/* eslint-disable jira/naming/disallow-filenames */ 
var $8dj6O = parcelRequire("8dj6O");

var $dTa0V = parcelRequire("dTa0V");
const $e5db3d53d0cb14f9$export$2f3ad380ae691fb5 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $8dj6O.cumulativeReportEntrypoint)
});

});
parcelRegister("8dj6O", function(module, exports) {
$parcel$export(module.exports, "cumulativeReportEntrypoint", () => $28c953c1d1318815$export$f01a8d84f5a47478);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $28c953c1d1318815$export$f01a8d84f5a47478 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("bKSa0")), {
        moduleId: "be71bed4",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bKSa0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fdqtU").then(()=>parcelRequire('9Wbpw'));

});




parcelRegister("cjH5d", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRouteEntry", () => $22660f3d4fe8ac3d$export$9c40eb459ce6a0bc);

var $74oEx = parcelRequire("74oEx");



var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $dB43u = parcelRequire("dB43u");

var $052eo = parcelRequire("052eo");

var $fdS54 = parcelRequire("fdS54");

var $19ZQC = parcelRequire("19ZQC");

var $aWliK = parcelRequire("aWliK");

var $dvtoW = parcelRequire("dvtoW");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $jEYuY = parcelRequire("jEYuY");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $919ww = parcelRequire("919ww");

var $bXFey = parcelRequire("bXFey");

var $8YZ7E = parcelRequire("8YZ7E");
const $22660f3d4fe8ac3d$export$9c40eb459ce6a0bc = (0, $fdS54.createEntry)((0, $19ZQC.softwareReportsCycleTimeClassicBoardRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('aem_rr_classic_projects') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-cycle-time') : (0, $052eo.isDevopsFeatureDisabledInFedRamp)(), (0, $lFLfF.default), (0, $919ww.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $i860n.fg)('aem_rr_classic_projects') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-cycle-time') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            if ((0, $i860n.fg)('navx-global-side-nav')) return 0, $8YZ7E.GSNCycleTimeReportClassicPageEntrypoint;
            return 0, $8YZ7E.cycleTimeReportClassicPageEntrypoint;
        },
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $bXFey.getReportsCommonResource)(),
            (0, $dB43u.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $919ww.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $919ww.LazyCycleTimeReport)
        ],
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-reports-cycle-time-classic'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("dB43u", function(module, exports) {
$parcel$export(module.exports, "devOpsProviderResource", () => $c5c33c42e0caf279$export$19e58e21b24ae0d8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


const $c5c33c42e0caf279$export$19e58e21b24ae0d8 = (0, $7edbf.createResource)({
    type: (0, $0154af5f890a6ea1$export$5f92e516f4b78544),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("bqhPd")),
    maxAge: 60000
});
const $c5c33c42e0caf279$export$b80f5852c41a5ca8 = ()=>(0, $k6ufm.useResource)($c5c33c42e0caf279$export$19e58e21b24ae0d8);

});
/* eslint-disable jira/filename-case */ const $0154af5f890a6ea1$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $0154af5f890a6ea1$export$d7f081d6dd0e72fc = 'bitbucket';
const $0154af5f890a6ea1$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $0154af5f890a6ea1$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';

parcelRegister("bqhPd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bP6a2").then(()=>parcelRequire('5DBum'));

});


parcelRegister("19ZQC", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRoute", () => $291befd0094183e7$export$12423e360eb5fa9d);
const $291befd0094183e7$export$12423e360eb5fa9d = {
    name: 'software-reports-cycle-time-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/cycle-time',
    exact: true
};

});

parcelRegister("919ww", function(module, exports) {
$parcel$export(module.exports, "LazyCycleTimeReport", () => $42238895c0725489$export$956f830ed027f1fb);
$parcel$export(module.exports, "CycleTimeReportClassic", () => $42238895c0725489$export$237924ba64065cc3);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $42238895c0725489$export$956f830ed027f1fb = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("MadKW")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/CycleTimeReportSpa.tsx"
});
const $42238895c0725489$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $42238895c0725489$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
$42238895c0725489$export$e16ce0656a74a015.displayName = "CycleTimeReportNextGen";
const $42238895c0725489$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $42238895c0725489$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });
$42238895c0725489$export$237924ba64065cc3.displayName = "CycleTimeReportClassic";

});
parcelRegister("MadKW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("7O4yW")
]).then(()=>parcelRequire('gJ2WP'));

});


parcelRegister("8YZ7E", function(module, exports) {
$parcel$export(module.exports, "cycleTimeReportClassicPageEntrypoint", () => $78f5d49d59e1c5ac$export$2dba7a1bad1f01b2);
$parcel$export(module.exports, "GSNCycleTimeReportClassicPageEntrypoint", () => $78f5d49d59e1c5ac$export$b29c22c8adb45e31);
/* eslint-disable jira/naming/disallow-filenames */ 
var $7fLqU = parcelRequire("7fLqU");

var $dTa0V = parcelRequire("dTa0V");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");
const $78f5d49d59e1c5ac$export$2dba7a1bad1f01b2 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7fLqU.cycleTimeReportEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});
const $78f5d49d59e1c5ac$export$b29c22c8adb45e31 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7fLqU.cycleTimeReportEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});

});
parcelRegister("7fLqU", function(module, exports) {
$parcel$export(module.exports, "cycleTimeReportEntrypoint", () => $c9532f02eb51bd79$export$a4c2e42865ef5d9d);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $c9532f02eb51bd79$export$a4c2e42865ef5d9d = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("kG8xc")), {
        moduleId: "d7f072ae",
        moduleName: "CycleTimeReportCycleTimeReportSpa",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kG8xc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("aneIi")
]).then(()=>parcelRequire('cdmiF'));

});




parcelRegister("3UOiI", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeClassicRouteEntry", () => $9e3d531f7e7aa034$export$1bbbe71c256ed1d0);

var $74oEx = parcelRequire("74oEx");



var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $dB43u = parcelRequire("dB43u");

var $052eo = parcelRequire("052eo");

var $fdS54 = parcelRequire("fdS54");

var $fB3FR = parcelRequire("fB3FR");

var $aWliK = parcelRequire("aWliK");

var $dvtoW = parcelRequire("dvtoW");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $jEYuY = parcelRequire("jEYuY");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $919ww = parcelRequire("919ww");

var $bXFey = parcelRequire("bXFey");

var $8YZ7E = parcelRequire("8YZ7E");
const $9e3d531f7e7aa034$export$1bbbe71c256ed1d0 = (0, $fdS54.createEntry)((0, $fB3FR.softwareReportsCycleTimeClassicRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('aem_rr_classic_projects') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-cycle-time') : (0, $052eo.isDevopsFeatureDisabledInFedRamp)(), (0, $lFLfF.default), (0, $919ww.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $i860n.fg)('aem_rr_classic_projects') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-cycle-time') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            if ((0, $i860n.fg)('navx-global-side-nav')) return 0, $8YZ7E.GSNCycleTimeReportClassicPageEntrypoint;
            return 0, $8YZ7E.cycleTimeReportClassicPageEntrypoint;
        },
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $bXFey.getReportsCommonResource)(),
            (0, $dB43u.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $919ww.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $919ww.LazyCycleTimeReport)
        ],
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-reports-cycle-time-classic'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("fB3FR", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", () => $c9525898d4e73850$export$1e5e610e11119ea7);
const $c9525898d4e73850$export$1e5e610e11119ea7 = {
    name: 'software-reports-cycle-time-classic',
    path: '/jira/software/c/projects/:projectKey/reports/cycle-time',
    exact: true
};

});


parcelRegister("7vLTx", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeRouteEntry", () => $acc7deef064e1233$export$8aee4b14556485d5);

var $74oEx = parcelRequire("74oEx");


var $iSoIx = parcelRequire("iSoIx");

var $dB43u = parcelRequire("dB43u");

var $052eo = parcelRequire("052eo");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $azEBC = parcelRequire("azEBC");

var $3eysO = parcelRequire("3eysO");

var $1xSQN = parcelRequire("1xSQN");

var $aBy70 = parcelRequire("aBy70");
const $acc7deef064e1233$export$8aee4b14556485d5 = (0, $fdS54.createEntry)((0, $azEBC.softwareReportsCycleTimeRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1xSQN.getTMPReportsCommonResource)(),
            (0, $dB43u.devOpsProviderResource)
        ],
        entryPoint: ()=>{
            if ((0, $052eo.isDevopsFeatureDisabledInFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            return 0, $aBy70.cycleTimeReportPageEntrypoint;
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-reports-cycle-time'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("azEBC", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeRoute", () => $523e9f22fd607e72$export$c777bb8f2591081);
const $523e9f22fd607e72$export$c777bb8f2591081 = {
    name: 'software-reports-cycle-time',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
};

});

parcelRegister("aBy70", function(module, exports) {
$parcel$export(module.exports, "cycleTimeReportPageEntrypoint", () => $8d23a12511db6991$export$465717d84afb3d8f);
/* eslint-disable jira/naming/disallow-filenames */ 
var $7fLqU = parcelRequire("7fLqU");

var $dTa0V = parcelRequire("dTa0V");
const $8d23a12511db6991$export$465717d84afb3d8f = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7fLqU.cycleTimeReportEntrypoint)
});

});


parcelRegister("gIZVO", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRouteEntry", () => $454487a711e083f9$export$e0c7b9ad9dd8b956);

var $74oEx = parcelRequire("74oEx");



var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $dB43u = parcelRequire("dB43u");

var $052eo = parcelRequire("052eo");

var $fdS54 = parcelRequire("fdS54");

var $aWliK = parcelRequire("aWliK");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $jEYuY = parcelRequire("jEYuY");

var $gb4d0 = parcelRequire("gb4d0");

var $dvtoW = parcelRequire("dvtoW");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $4aEzF = parcelRequire("4aEzF");

var $bXFey = parcelRequire("bXFey");

var $bcBql = parcelRequire("bcBql");
const $454487a711e083f9$export$e0c7b9ad9dd8b956 = (0, $fdS54.createEntry)((0, $gb4d0.softwareReportsDeploymentFrequencyClassicBoardRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('aem_rr_classic_projects') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-deployment-frequency') : (0, $052eo.isDevopsFeatureDisabledInFedRamp)(), (0, $lFLfF.default), (0, $4aEzF.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $i860n.fg)('aem_rr_classic_projects') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-deployment-frequency') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            if ((0, $i860n.fg)('navx-global-side-nav')) return 0, $bcBql.GSNDeploymentFrequencyReportPageEntrypoint;
            return 0, $bcBql.deploymentFrequencyReportPageEntrypoint;
        },
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $bXFey.getReportsCommonResource)(),
            (0, $dB43u.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $4aEzF.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4aEzF.LazyDeploymentFrequencyReport)
        ],
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gb4d0", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRoute", () => $a2c4b74e51967563$export$56d4754499615215);
const $a2c4b74e51967563$export$56d4754499615215 = {
    name: 'software-reports-deployment-frequency-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/deployment-frequency',
    exact: true
};

});

parcelRegister("4aEzF", function(module, exports) {
$parcel$export(module.exports, "LazyDeploymentFrequencyReport", () => $3cd605bbb7ca1d1c$export$5113b2b19ec1fb53);
$parcel$export(module.exports, "DeploymentFrequencyReportClassic", () => $3cd605bbb7ca1d1c$export$655707e8ae1053d3);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $3cd605bbb7ca1d1c$export$5113b2b19ec1fb53 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2147M")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/DeploymentFrequencyReport.tsx"
});
const $3cd605bbb7ca1d1c$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3cd605bbb7ca1d1c$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
$3cd605bbb7ca1d1c$export$e2db9c7426cdb53.displayName = "DeploymentFrequencyReportNextGen";
const $3cd605bbb7ca1d1c$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3cd605bbb7ca1d1c$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });
$3cd605bbb7ca1d1c$export$655707e8ae1053d3.displayName = "DeploymentFrequencyReportClassic";

});
parcelRegister("2147M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1VGA2").then(()=>parcelRequire('5DuZj'));

});


parcelRegister("bcBql", function(module, exports) {
$parcel$export(module.exports, "deploymentFrequencyReportPageEntrypoint", () => $07455b23fbfa9f1c$export$2a837f21eaa534d9);
$parcel$export(module.exports, "GSNDeploymentFrequencyReportPageEntrypoint", () => $07455b23fbfa9f1c$export$b303e9a29bfe9467);
/* eslint-disable jira/naming/disallow-filenames */ 
var $6LVWe = parcelRequire("6LVWe");

var $dTa0V = parcelRequire("dTa0V");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");
const $07455b23fbfa9f1c$export$2a837f21eaa534d9 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6LVWe.deploymentFrequencyReportEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});
const $07455b23fbfa9f1c$export$b303e9a29bfe9467 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6LVWe.deploymentFrequencyReportEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});

});
parcelRegister("6LVWe", function(module, exports) {
$parcel$export(module.exports, "deploymentFrequencyReportEntrypoint", () => $7fda6d5fa6f9bc0a$export$7377438ce2792970);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $7fda6d5fa6f9bc0a$export$7377438ce2792970 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("iosie")), {
        moduleId: "2d008143",
        moduleName: "DeploymentFrequencyReportSpa",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iosie", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("69g5u").then(()=>parcelRequire('frrTX'));

});




parcelRegister("3z5oR", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRouteEntry", () => $ce7ec51328749a07$export$e5eaafb1fb588922);

var $74oEx = parcelRequire("74oEx");



var $lFLfF = parcelRequire("lFLfF");

var $iSoIx = parcelRequire("iSoIx");

var $dB43u = parcelRequire("dB43u");

var $052eo = parcelRequire("052eo");

var $fdS54 = parcelRequire("fdS54");

var $aWliK = parcelRequire("aWliK");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $jEYuY = parcelRequire("jEYuY");

var $6dKhT = parcelRequire("6dKhT");

var $dvtoW = parcelRequire("dvtoW");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $4aEzF = parcelRequire("4aEzF");

var $bXFey = parcelRequire("bXFey");

var $bcBql = parcelRequire("bcBql");
const $ce7ec51328749a07$export$e5eaafb1fb588922 = (0, $fdS54.createEntry)((0, $6dKhT.softwareReportsDeploymentFrequencyClassicRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('aem_rr_classic_projects') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-deployment-frequency') : (0, $052eo.isDevopsFeatureDisabledInFedRamp)(), (0, $lFLfF.default), (0, $4aEzF.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $i860n.fg)('aem_rr_classic_projects') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-deployment-frequency') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            if ((0, $i860n.fg)('navx-global-side-nav')) return 0, $bcBql.GSNDeploymentFrequencyReportPageEntrypoint;
            return 0, $bcBql.deploymentFrequencyReportPageEntrypoint;
        },
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $bXFey.getReportsCommonResource)(),
            (0, $dB43u.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $4aEzF.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $4aEzF.LazyDeploymentFrequencyReport)
        ],
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-reports-deployment-frequency-classic'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6dKhT", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", () => $5b46b9caea989188$export$312c410cb3b49afe);
const $5b46b9caea989188$export$312c410cb3b49afe = {
    name: 'software-reports-deployment-frequency-classic',
    path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency',
    exact: true
};

});


parcelRegister("4tHqE", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRouteEntry", () => $dd7c70a72dcd207b$export$c87b25c0997e584d);

var $74oEx = parcelRequire("74oEx");


var $iSoIx = parcelRequire("iSoIx");

var $dB43u = parcelRequire("dB43u");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $j4UPn = parcelRequire("j4UPn");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $3eysO = parcelRequire("3eysO");

var $1xSQN = parcelRequire("1xSQN");

var $5keYg = parcelRequire("5keYg");
const $dd7c70a72dcd207b$export$c87b25c0997e584d = (0, $fdS54.createEntry)((0, $j4UPn.softwareReportsDeploymentFrequencyRoute), ()=>({
        group: 'software',
        entryPoint: ()=>{
            if ((0, $i860n.fg)('aem_rr_next_gen') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-software-reports-deployment-frequency') : (0, $l1vE2.isFedRamp)()) return 0, $iSoIx.notFoundPageEntrypoint;
            return 0, $5keYg.DeploymentFrequencyPageEntrypoint;
        },
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1xSQN.getTMPReportsCommonResource)(),
            (0, $dB43u.devOpsProviderResource)
        ],
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-reports-deployment-frequency'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("j4UPn", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRoute", () => $899ba2325d2bcb02$export$bbf45ab0423b990);
const $899ba2325d2bcb02$export$bbf45ab0423b990 = {
    name: 'software-reports-deployment-frequency',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
};

});

parcelRegister("5keYg", function(module, exports) {
$parcel$export(module.exports, "DeploymentFrequencyPageEntrypoint", () => $471fd8f84c965d1f$export$76cc51683254a696);
/* eslint-disable jira/naming/disallow-filenames */ 
var $6LVWe = parcelRequire("6LVWe");

var $dTa0V = parcelRequire("dTa0V");
const $471fd8f84c965d1f$export$76cc51683254a696 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6LVWe.deploymentFrequencyReportEntrypoint)
});

});


parcelRegister("6rfJS", function(module, exports) {
$parcel$export(module.exports, "softwareReportsOverviewBoardlessRouteEntry", () => $266560f46cb85c12$export$1341f3a3578e9e4);


var $5dHZ6 = parcelRequire("5dHZ6");

var $fdS54 = parcelRequire("fdS54");

var $bQD4m = parcelRequire("bQD4m");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $75Njg = parcelRequire("75Njg");

var $dTa0V = parcelRequire("dTa0V");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $5ivqw = parcelRequire("5ivqw");

var $3eysO = parcelRequire("3eysO");

var $edf7u = parcelRequire("edf7u");

var $3KSG6 = parcelRequire("3KSG6");

var $5y845 = parcelRequire("5y845");
const $266560f46cb85c12$var$reportsOverviewPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5dHZ6.reportsOverviewPageEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $266560f46cb85c12$export$1341f3a3578e9e4 = (0, $fdS54.createEntry)((0, $bQD4m.softwareReportsOverviewBoardlessRoute), ()=>({
        group: 'software-reports-boardless',
        skeleton: (0, $5y845.ReportsOverviewSkeleton),
        entryPoint () {
            return $266560f46cb85c12$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $5ivqw.staticSidebarJSWReportsResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bQD4m", function(module, exports) {
$parcel$export(module.exports, "softwareReportsOverviewBoardlessRoute", () => $9f74ef90a1d9e1bc$export$e2f371bced79a0e4);
const $9f74ef90a1d9e1bc$export$e2f371bced79a0e4 = {
    name: 'software-reports-boardless',
    path: '/jira/software/c/projects/:projectKey/reports',
    exact: true,
    query: [
        'dashboardId?'
    ]
};

});

parcelRegister("5y845", function(module, exports) {
$parcel$export(module.exports, "ReportsOverviewSkeleton", () => $997e2cd4dcd567b8$export$c70e702bcad58c36);
/* ReportsOverviewSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $knZgh = parcelRequire("knZgh");
const $997e2cd4dcd567b8$var$containerStyles = {
    maxWidth: '100%'
};
const $997e2cd4dcd567b8$var$customCssStyles = null;
const $997e2cd4dcd567b8$export$c70e702bcad58c36 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($knZgh))),
        containerStyles: $997e2cd4dcd567b8$var$containerStyles,
        className: (0, $4jQY2.default)([
            "_2zz1idpf"
        ])
    });
$997e2cd4dcd567b8$export$c70e702bcad58c36.displayName = "ReportsOverviewSkeleton";

});
parcelRegister("knZgh", function(module, exports) {
module.exports = new URL("report-categories-skeleton.tpl.5b53a8d3.svg", import.meta.url).toString();

});



parcelRegister("buBeq", function(module, exports) {
$parcel$export(module.exports, "softwareReportsOverviewRouteEntry", () => $d262714ebb3df582$export$705071d2eca06bf9);


var $5dHZ6 = parcelRequire("5dHZ6");

var $fdS54 = parcelRequire("fdS54");

var $8KSKQ = parcelRequire("8KSKQ");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $75Njg = parcelRequire("75Njg");

var $dTa0V = parcelRequire("dTa0V");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $3eysO = parcelRequire("3eysO");

var $edf7u = parcelRequire("edf7u");

var $3KSG6 = parcelRequire("3KSG6");

var $5y845 = parcelRequire("5y845");
const $d262714ebb3df582$var$reportsOverviewPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5dHZ6.reportsOverviewPageEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $d262714ebb3df582$export$705071d2eca06bf9 = (0, $fdS54.createEntry)((0, $8KSKQ.softwareReportsOverviewRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $5y845.ReportsOverviewSkeleton),
        entryPoint () {
            return $d262714ebb3df582$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("8KSKQ", function(module, exports) {
$parcel$export(module.exports, "softwareReportsOverviewRoute", () => $ddcd5e27882fce8e$export$f38928477442c9cf);
const $ddcd5e27882fce8e$export$f38928477442c9cf = {
    name: 'software-reports',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports',
    query: [
        'dashboardId?'
    ]
};

});


parcelRegister("7LBLF", function(module, exports) {
$parcel$export(module.exports, "softwareReportsRouteEntry", () => $e9c2d36cdc0e1886$export$2eee2f4f773d5b1f);

var $hi6Of = parcelRequire("hi6Of");


var $5dHZ6 = parcelRequire("5dHZ6");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $3N4C5 = parcelRequire("3N4C5");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $3KSG6 = parcelRequire("3KSG6");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $1xSQN = parcelRequire("1xSQN");

var $8DyWE = parcelRequire("8DyWE");
const $e9c2d36cdc0e1886$var$tmpReportsOverviewPageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5dHZ6.reportsOverviewPageEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $e9c2d36cdc0e1886$export$2eee2f4f773d5b1f = (0, $fdS54.createEntry)((0, $3N4C5.softwareReportsRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1xSQN.getTMPReportsCommonResource)()
        ],
        entryPoint () {
            if ((0, $i860n.fg)('uxissue_545_migrate_tmp_reports_overview_page')) return $e9c2d36cdc0e1886$var$tmpReportsOverviewPageEntrypoint;
            return 0, $8DyWE.reportsOverviewPageEntrypoint;
        },
        ufoName: 'software-reports.overview',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3N4C5", function(module, exports) {
$parcel$export(module.exports, "softwareReportsRoute", () => $759e8d5961af5255$export$5bf75a5d8c554930);
const $759e8d5961af5255$export$5bf75a5d8c554930 = {
    name: 'software-reports',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports',
    query: [
        'dashboardId?'
    ]
};

});

parcelRegister("8DyWE", function(module, exports) {
$parcel$export(module.exports, "reportsOverviewPageEntrypoint", () => $0f9560764c75c454$export$d9a1db2306b376e2);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $kP1wu = parcelRequire("kP1wu");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $0f9560764c75c454$export$d9a1db2306b376e2 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kP1wu.reportsOverviewEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("kP1wu", function(module, exports) {
$parcel$export(module.exports, "reportsOverviewEntrypoint", () => $6dc4784d14921466$export$bb9acba529741f89);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $6dc4784d14921466$export$bb9acba529741f89 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("fD3GX")), {
        moduleId: "89579ec8",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fD3GX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aTwE4").then(()=>parcelRequire('fX4d3'));

});




parcelRegister("gpSI4", function(module, exports) {
$parcel$export(module.exports, "softwareReportsVelocityRouteEntry", () => $fa5e5cf709009840$export$7d814f4300d0e318);


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $6KOHl = parcelRequire("6KOHl");

var $3eysO = parcelRequire("3eysO");

var $1xSQN = parcelRequire("1xSQN");

var $elKNf = parcelRequire("elKNf");
const $fa5e5cf709009840$export$7d814f4300d0e318 = (0, $fdS54.createEntry)((0, $6KOHl.softwareReportsVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report',
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1xSQN.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $elKNf.velocityReportPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6KOHl", function(module, exports) {
$parcel$export(module.exports, "softwareReportsVelocityRoute", () => $b9180275d7f229d0$export$cde83a6497756848);
const $b9180275d7f229d0$export$cde83a6497756848 = {
    name: 'software-reports-velocity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
};

});


parcelRegister("7NX0d", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapClassicRouteEntry", () => $5f925de533f035ba$export$17cff822dd3757db);

var $51vnM = parcelRequire("51vnM");


var $fdS54 = parcelRequire("fdS54");

var $ansaj = parcelRequire("ansaj");

var $7xkRt = parcelRequire("7xkRt");

var $QhQu4 = parcelRequire("QhQu4");

var $3eysO = parcelRequire("3eysO");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $75Njg = parcelRequire("75Njg");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $idDnR = parcelRequire("idDnR");

var $7tgMD = parcelRequire("7tgMD");

var $8lFL8 = parcelRequire("8lFL8");

var $jEYuY = parcelRequire("jEYuY");

var $llsMT = parcelRequire("llsMT");

var $5I8Gg = parcelRequire("5I8Gg");
const $5f925de533f035ba$export$17cff822dd3757db = (0, $fdS54.createEntry)((0, $ansaj.softwareRoadmapClassicRoute), ()=>({
        group: 'classic-software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $llsMT.TimelineRedirect),
        skeleton: (0, $7xkRt.RoadmapSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayoutCode), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $8lFL8.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5I8Gg.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ansaj", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapClassicRoute", () => $975d9a1c5cea3ef0$export$79089e2853f04197);
const $975d9a1c5cea3ef0$export$79089e2853f04197 = {
    name: 'software-roadmap-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("7xkRt", function(module, exports) {
$parcel$export(module.exports, "RoadmapSkeleton", () => $2aad2d5c0976308e$export$66a1e8bb48359566);
$parcel$export(module.exports, "RoadmapSkeletonNoHeader", () => $2aad2d5c0976308e$export$efa601f4a1a0309d);
/* RoadmapSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $d5ps5 = parcelRequire("d5ps5");

var $eGQML = parcelRequire("eGQML");

var $ljZJW = parcelRequire("ljZJW");
const $2aad2d5c0976308e$var$customCssStyles = null;
const $2aad2d5c0976308e$export$66a1e8bb48359566 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2aad2d5c0976308e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eGQML))),
        className: (0, $4jQY2.default)([
            "_2zz1idpf"
        ])
    }));
$2aad2d5c0976308e$export$66a1e8bb48359566.displayName = "RoadmapSkeleton";
const $2aad2d5c0976308e$export$efa601f4a1a0309d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_1e0c1ule _1bsb1osq _4t3i1osq _bhl91osq _k8em1osq _fdvu1ule _1do91ule _zdnt1osq _1lv31osq _1ht21osq _t8yl1osq _1swz1osq _k3b51osq _nrie1f51 _1h041f51 _c1vk5d63 _1bbd5d63"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ljZJW))),
        hideBorder: true,
        containerStyles: $2aad2d5c0976308e$var$fullBleedContainerStyles,
        className: (0, $4jQY2.default)([
            "_1e0c1ule _1bsb1osq _4t3i1osq _5ral1f51 _rsuf5d63"
        ])
    }));
$2aad2d5c0976308e$export$efa601f4a1a0309d.displayName = "RoadmapSkeletonNoHeader";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $2aad2d5c0976308e$var$Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});
const $2aad2d5c0976308e$var$fullBleedWrapperStyles = null;
const $2aad2d5c0976308e$var$fullBleedContainerStyles = {
    width: '100%',
    height: '100%'
};
const $2aad2d5c0976308e$var$fullBleedMediaStyles = null;

});
parcelRegister("eGQML", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();

});

parcelRegister("ljZJW", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh-no-header.ec54a9d5.svg", import.meta.url).toString();

});


parcelRegister("8lFL8", function(module, exports) {
$parcel$export(module.exports, "classicRoadmapResource", () => $6cc4492d8937a458$export$e755913caca1ab8e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");


const $6cc4492d8937a458$export$e755913caca1ab8e = (0, $7edbf.createResource)({
    type: (0, $758c696262b4288a$export$e3b1cd17bd82de3d),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("jvBKA")),
    isBrowserOnly: true
});

});
parcelRegister("jvBKA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bpkJJ").then(()=>parcelRequire('bTq7t'));

});


parcelRegister("llsMT", function(module, exports) {
$parcel$export(module.exports, "TimelineRedirect", () => $603718d961e1a8e8$export$c70b8d9ef0c891b2);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
var $bc9Gj = parcelRequire("bc9Gj");
const $603718d961e1a8e8$export$c70b8d9ef0c891b2 = ()=>{
    const [{ query: query, match: match }] = (0, $bc9Gj.useRouter)();
    const queryParams = new URLSearchParams(query).toString();
    const { projectKey: projectKey, boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: {
            pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
$603718d961e1a8e8$export$c70b8d9ef0c891b2.displayName = "TimelineRedirect";

});

parcelRegister("5I8Gg", function(module, exports) {
$parcel$export(module.exports, "LazyRoadmapViewClassic", () => $bee5fc211caf9795$export$84165bb08bf42eef);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $bee5fc211caf9795$export$84165bb08bf42eef = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("58TBQ"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/RoadmapViewClassicType.tsx"
});
/** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */ const $bee5fc211caf9795$var$AsyncRoadmapViewClassic = ({ match: match })=>{
    const { boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $bee5fc211caf9795$export$84165bb08bf42eef,
        pageId: `classic-roadmap-${boardId || ''}`,
        shouldShowSpinner: false
    });
};
$bee5fc211caf9795$var$AsyncRoadmapViewClassic.displayName = "AsyncRoadmapViewClassic";
var $bee5fc211caf9795$export$2e2bcd8739ae039 = $bee5fc211caf9795$var$AsyncRoadmapViewClassic;

});
parcelRegister("58TBQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("13VI2")
]).then(()=>parcelRequire('lwdIp'));

});



parcelRegister("4C3e4", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapRedirectRouteEntry", () => $b16c561e45c9b471$export$4180bde2c4464aed);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $51vnM = parcelRequire("51vnM");


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $ldGfw = parcelRequire("ldGfw");

var $gWChd = parcelRequire("gWChd");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $gNbXR = parcelRequire("gNbXR");

var $aw0WI = parcelRequire("aw0WI");
const $b16c561e45c9b471$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
    const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: {
            pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(restQuery)
        }
    });
};
$b16c561e45c9b471$var$SoftwareTimelineLegacyRedirect.displayName = "SoftwareTimelineLegacyRedirect";
const $b16c561e45c9b471$export$4180bde2c4464aed = (0, $fdS54.createEntry)((0, $gWChd.softwareRoadmapRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: $b16c561e45c9b471$var$SoftwareTimelineLegacyRedirect,
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $aw0WI.LazyNextGenRoadmap)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gWChd", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapRedirectRoute", () => $9cd078fbce191d8f$export$866215abd09c0f4d);
const $9cd078fbce191d8f$export$866215abd09c0f4d = {
    name: 'software-roadmap-redirect',
    path: '/secure/Roadmap.jspa'
};

});

parcelRegister("aw0WI", function(module, exports) {
$parcel$export(module.exports, "LazyNextGenRoadmap", () => $e6b384f02a802b1b$export$1339c847cf4ab57);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $e6b384f02a802b1b$export$1339c847cf4ab57 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("1f4vm"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/NextGenExportedDefault.tsx"
});
const $e6b384f02a802b1b$var$AsyncNextGenRoadmap = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $e6b384f02a802b1b$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });
$e6b384f02a802b1b$var$AsyncNextGenRoadmap.displayName = "AsyncNextGenRoadmap";
var $e6b384f02a802b1b$export$2e2bcd8739ae039 = $e6b384f02a802b1b$var$AsyncNextGenRoadmap;

});
parcelRegister("1f4vm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("eT6J6")
]).then(()=>parcelRequire('lV9hu'));

});



parcelRegister("jhLPO", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapRouteEntry", () => $49eefc618d4bf71b$export$c1d875e34d537389);

var $euxye = parcelRequire("euxye");

var $51vnM = parcelRequire("51vnM");


var $jEYuY = parcelRequire("jEYuY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $7tgMD = parcelRequire("7tgMD");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $bMMFU = parcelRequire("bMMFU");

var $c8XTh = parcelRequire("c8XTh");

var $7xkRt = parcelRequire("7xkRt");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $gNbXR = parcelRequire("gNbXR");

var $f7s9X = parcelRequire("f7s9X");
const $49eefc618d4bf71b$var$SoftwareTimelineRedirect = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: {
            pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
$49eefc618d4bf71b$var$SoftwareTimelineRedirect.displayName = "SoftwareTimelineRedirect";
const $49eefc618d4bf71b$export$c1d875e34d537389 = (0, $fdS54.createEntry)((0, $c8XTh.softwareRoadmapRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: $49eefc618d4bf71b$var$SoftwareTimelineRedirect,
        skeleton: (0, $7xkRt.RoadmapSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayoutCode), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bMMFU.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $f7s9X.LazyNextGenRoadmap)
        ],
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bMMFU", function(module, exports) {
$parcel$export(module.exports, "nextGenRoadmapResource", () => $ce4ff04e896fb037$export$2750f87d68dfb02a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");


const $ce4ff04e896fb037$export$2750f87d68dfb02a = (0, $7edbf.createResource)({
    type: (0, $758c696262b4288a$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("2omTO")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("2omTO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kS2EB").then(()=>parcelRequire('gbm8Q'));

});


parcelRegister("c8XTh", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapRoute", () => $96af4ded2fef059b$export$a4a573c36fc75b30);
const $96af4ded2fef059b$export$a4a573c36fc75b30 = {
    name: 'software-roadmap',
    path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("f7s9X", function(module, exports) {
$parcel$export(module.exports, "LazyNextGenRoadmap", () => $0ec965825099f3d0$export$1339c847cf4ab57);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $0ec965825099f3d0$export$1339c847cf4ab57 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("1f4vm"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/NextGenExportedDefault.tsx"
});
const $0ec965825099f3d0$var$AsyncNextGenRoadmap = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $0ec965825099f3d0$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });
$0ec965825099f3d0$var$AsyncNextGenRoadmap.displayName = "AsyncNextGenRoadmap";
var $0ec965825099f3d0$export$2e2bcd8739ae039 = $0ec965825099f3d0$var$AsyncNextGenRoadmap;

});


parcelRegister("1tbMh", function(module, exports) {
$parcel$export(module.exports, "softwareSecurityClassicRouteEntry", () => $6871de35edca8474$export$8acfebad16c9d6f2);

var $74oEx = parcelRequire("74oEx");


var $iSoIx = parcelRequire("iSoIx");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $6aSVi = parcelRequire("6aSVi");

var $efWgR = parcelRequire("efWgR");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $i860n = parcelRequire("i860n");

var $8HUuJ = parcelRequire("8HUuJ");

var $cTgIW = parcelRequire("cTgIW");

var $3xGhS = parcelRequire("3xGhS");
const $6871de35edca8474$export$8acfebad16c9d6f2 = (0, $fdS54.createEntry)((0, $efWgR.softwareSecurityClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-security-page-to-ugs-v2') && !(0, $i860n.fg)('jolt-security-page-deprecated'), (0, $6aSVi.securityPageResource))
        ],
        ufoName: 'software-security-combined',
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        meta: {
            reporting: {
                id: 'software-security-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-security-classic'),
                teamName: 'jolt'
            }
        },
        entryPoint: ()=>{
            // When the Security tab is deprecated, serve the "moved to Development" page regardless of
            // `isSecurityPageEnabled()` so users who navigate to the old URL still see the deprecation
            // page rather than a not-found page.
            if ((0, $i860n.fg)('jolt-security-page-deprecated')) return 0, $3xGhS.securityDeprecatedPageEntrypoint;
            return (0, $cTgIW.isSecurityPageEnabled)() ? (0, $3xGhS.securityPageEntrypoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6aSVi", function(module, exports) {
$parcel$export(module.exports, "securityPageResource", () => $ae033f987e6d4000$export$2c5e3c161b8fe98);

var $d85XH = parcelRequire("d85XH");

var $6PVWV = parcelRequire("6PVWV");

var $2zU0a = parcelRequire("2zU0a");

var $htsFl = parcelRequire("htsFl");

var $i860n = parcelRequire("i860n");
const $ae033f987e6d4000$var$RESOURCE_TYPE_SECURITY = 'SOFTWARE_SECURITY';
const $ae033f987e6d4000$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
const $ae033f987e6d4000$var$getNumberOfSecurityContainersToFetch = ()=>(0, $i860n.fg)('jira-development-increase-security-container-limit') ? 1000 : 100;
let $ae033f987e6d4000$var$filters;
const $ae033f987e6d4000$export$2c5e3c161b8fe98 = (0, $htsFl.createRelayResource)({
    type: $ae033f987e6d4000$var$RESOURCE_TYPE_SECURITY,
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        const isSecRoute = name === 'software-security' || name === 'software-security-classic';
        // Set filters on initial call only and not on every query param change
        if (!$ae033f987e6d4000$var$filters && isSecRoute) {
            const connectionAri = (0, $2zU0a.createAri)({
                resourceOwner: 'jira',
                resourceType: 'security-container',
                cloudId: cloudId,
                activationId: activationId,
                resourceId: ''
            });
            // oxlint-disable-next-line typescript/consistent-type-assertions
            $ae033f987e6d4000$var$filters = (0, $d85XH.getGqlFiltersFromQueryParams)(query, connectionAri);
        }
        // Reset filters when navigating away from the security page
        if (!isSecRoute) $ae033f987e6d4000$var$filters = undefined;
        return {
            parameters: (0, $6PVWV.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudAri: (0, $2zU0a.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                }),
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                numberOfVulnsToFetch: $ae033f987e6d4000$var$getNumberOfVulnerabilitiesToFetch(),
                getContainers: false,
                numberOfContainersToFetch: $ae033f987e6d4000$var$getNumberOfSecurityContainersToFetch(),
                filter: $ae033f987e6d4000$var$filters
            }
        };
    }
});

});
parcelRegister("d85XH", function(module, exports) {
$parcel$export(module.exports, "getGqlFiltersFromQueryParams", () => $d2db147f07ffeb65$export$2af359d48d48e5f1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8sphF = parcelRequire("8sphF");

var $6RFcK = parcelRequire("6RFcK");

var $4fKrp = parcelRequire("4fKrp");
const $d2db147f07ffeb65$var$getFilterValue = (// oxlint-disable-next-line @typescript-eslint/no-explicit-any
values, fieldStortKey, sortKey = (0, $6RFcK.initialVulnerabilityTableOptions).sortKey, sortOrder = (0, $6RFcK.initialVulnerabilityTableOptions).sortOrder)=>({
        ...values.length > 0 ? {
            values: values
        } : {},
        ...sortKey === fieldStortKey && {
            sort: {
                priority: 2,
                order: (0, $4fKrp.parseSortDirection)(sortOrder, (0, $8sphF.AriGraphSortOrderInput).DESC)
            }
        }
    });
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $d2db147f07ffeb65$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
const $d2db147f07ffeb65$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
    const containerValues = $d2db147f07ffeb65$var$getOrDefault((0, $4fKrp.connectionQueryParamToFilter)(queryParams[0, $6RFcK.QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, $6RFcK.initialVulnerabilityTableOptions).connectionFilter);
    const statusQueryParams = (0, $4fKrp.arrayQueryParamToFilter)(queryParams[0, $6RFcK.QUERY_PARAM_VULN_STATUS]);
    return {
        and: [
            {
                lastUpdated: {
                    sort: {
                        priority: 1,
                        order: (0, $8sphF.AriGraphSortOrderInput).DESC
                    }
                },
                to_severity: $d2db147f07ffeb65$var$getFilterValue($d2db147f07ffeb65$var$getOrDefault((0, $4fKrp.arrayQueryParamToFilter)(queryParams[0, $6RFcK.QUERY_PARAM_SEVERITY]).map((0, $4fKrp.parseSeverity)).filter(Boolean), (0, $6RFcK.initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, $6RFcK.QUERY_PARAM_SORT_KEY], queryParams[0, $6RFcK.QUERY_PARAM_SORT_ORDER]),
                to_status: $d2db147f07ffeb65$var$getFilterValue(statusQueryParams.includes((0, $6RFcK.NO_FILTER_VULN_STATUS)) ? [] : $d2db147f07ffeb65$var$getOrDefault(statusQueryParams.map((0, $4fKrp.parseStatus)).filter(Boolean), (0, $6RFcK.initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, $6RFcK.QUERY_PARAM_SORT_KEY], queryParams[0, $6RFcK.QUERY_PARAM_SORT_ORDER]),
                createdAt: {
                    ...queryParams[0, $6RFcK.QUERY_PARAM_SORT_KEY] === 'introduced' && {
                        sort: {
                            priority: 2,
                            order: (0, $4fKrp.parseSortDirection)(queryParams[0, $6RFcK.QUERY_PARAM_SORT_ORDER], (0, $8sphF.AriGraphSortOrderInput).DESC)
                        }
                    }
                },
                to_container: {
                    containerAri: {
                        value: {
                            ...containerValues.length > 0 ? {
                                values: containerValues
                            } : {}
                        }
                    }
                }
            }
        ]
    };
};

});
parcelRegister("8sphF", function(module, exports) {
$parcel$export(module.exports, "AriGraphSortOrderInput", () => $dd0edd64bfb2d6b7$export$3b69903df4cd6048);
/* eslint-disable jira/filename-case */ const $dd0edd64bfb2d6b7$export$3b69903df4cd6048 = {
    ASC: 'ASC',
    DESC: 'DESC'
};

});

parcelRegister("6RFcK", function(module, exports) {
$parcel$export(module.exports, "QUERY_PARAM_SEARCH", () => $6f46140b7a2a37ed$export$a181206198b7f50c);
$parcel$export(module.exports, "QUERY_PARAM_CONTAINER", () => $6f46140b7a2a37ed$export$3873b20ffa21b004);
$parcel$export(module.exports, "QUERY_PARAM_SEVERITY", () => $6f46140b7a2a37ed$export$af01a3d59250f3d3);
$parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", () => $6f46140b7a2a37ed$export$c315695f017955dc);
$parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", () => $6f46140b7a2a37ed$export$2e69a24fe65d4109);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $6f46140b7a2a37ed$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $6f46140b7a2a37ed$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "NO_FILTER_VULN_STATUS", () => $6f46140b7a2a37ed$export$d8115099d465de4c);
$parcel$export(module.exports, "initialVulnerabilityTableOptions", () => $6f46140b7a2a37ed$export$e9b4ea84d666c490);
/* eslint-disable jira/filename-case */ const $6f46140b7a2a37ed$export$a181206198b7f50c = 'search';
const $6f46140b7a2a37ed$export$3873b20ffa21b004 = 'container';
const $6f46140b7a2a37ed$export$af01a3d59250f3d3 = 'severity';
const $6f46140b7a2a37ed$export$c315695f017955dc = 'vulnerabilityStatus';
const $6f46140b7a2a37ed$export$2e69a24fe65d4109 = 'issueStatus';
const $6f46140b7a2a37ed$export$6da773286c35ef41 = 'sortKey';
const $6f46140b7a2a37ed$export$810a1f7ed2facfcb = 'sortOrder';
const $6f46140b7a2a37ed$export$d8115099d465de4c = 'NO-FILTERS';
const $6f46140b7a2a37ed$var$initialVulnerabilityTableFilters = {
    searchFilter: '',
    connectionFilter: [],
    severityFilter: [],
    statusFilter: [
        'OPEN'
    ],
    jiraIssueStatusFilter: []
};
const $6f46140b7a2a37ed$export$e9b4ea84d666c490 = {
    sortKey: 'severity',
    sortOrder: 'DESC',
    ...$6f46140b7a2a37ed$var$initialVulnerabilityTableFilters
};

});

parcelRegister("4fKrp", function(module, exports) {
$parcel$export(module.exports, "arrayQueryParamToFilter", () => $4013551ee3707a18$export$7500862c6689a767);
$parcel$export(module.exports, "arrayFilterToQueryParam", () => $4013551ee3707a18$export$b0dee3c5bfc7249e);
$parcel$export(module.exports, "connectionFilterToQueryParam", () => $4013551ee3707a18$export$a6950ca4fdc8498f);
$parcel$export(module.exports, "connectionQueryParamToFilter", () => $4013551ee3707a18$export$1040034504af5b41);
$parcel$export(module.exports, "parseSeverity", () => $4013551ee3707a18$export$3551b8a2cbdb5162);
$parcel$export(module.exports, "parseStatus", () => $4013551ee3707a18$export$2188844eb84f7f06);
$parcel$export(module.exports, "parseSortDirection", () => $4013551ee3707a18$export$85cf5c73b48a482e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $l123t = parcelRequire("l123t");

var $kE4qX = parcelRequire("kE4qX");

var $8sphF = parcelRequire("8sphF");

var $92ItQ = parcelRequire("92ItQ");
const $4013551ee3707a18$var$DELIMITER = ',';
const $4013551ee3707a18$var$ENCODED_DELIMITER = encodeURIComponent($4013551ee3707a18$var$DELIMITER);
// We encode the delimiter to protect the values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $4013551ee3707a18$var$encodeDelimiter = (input)=>{
    const regex = new RegExp($4013551ee3707a18$var$DELIMITER, 'g');
    return input.replace(regex, $4013551ee3707a18$var$ENCODED_DELIMITER);
};
const $4013551ee3707a18$var$decodeDelimiter = (input)=>{
    const regex = new RegExp($4013551ee3707a18$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $4013551ee3707a18$var$DELIMITER);
};
const $4013551ee3707a18$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($4013551ee3707a18$var$DELIMITER)?.map($4013551ee3707a18$var$decodeDelimiter) ?? [];
const $4013551ee3707a18$export$b0dee3c5bfc7249e = (filterArray)=>{
    if (filterArray.length === 0) return undefined;
    return filterArray.map((entity)=>$4013551ee3707a18$var$encodeDelimiter(entity)).join($4013551ee3707a18$var$DELIMITER);
};
const $4013551ee3707a18$export$a6950ca4fdc8498f = (connectionArray)=>{
    if (connectionArray.length === 0) return undefined;
    const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
        const [, , , , securityParts] = connection.split(':');
        const [, , , appKey, ...containerId] = securityParts.split('/');
        if (!acc[appKey]) acc[appKey] = [];
        acc[appKey].push(containerId.join('/'));
        return acc;
    }, {});
    return JSON.stringify(groupedConnectionsByAppKey);
};
const $4013551ee3707a18$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
    if (!queryParamString) return [];
    const groupedConnectionsByAppKey = JSON.parse(queryParamString);
    return (0, (/*@__PURE__*/$parcel$interopDefault($l123t)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($kE4qX)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
};
const $4013551ee3707a18$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
    switch(maybeSeverity?.toUpperCase()){
        case (0, $92ItQ.VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
            return (0, $92ItQ.VulnerabilitySeverityEnums).CRITICAL;
        case (0, $92ItQ.VulnerabilitySeverityEnums).HIGH.toUpperCase():
            return (0, $92ItQ.VulnerabilitySeverityEnums).HIGH;
        case (0, $92ItQ.VulnerabilitySeverityEnums).LOW.toUpperCase():
            return (0, $92ItQ.VulnerabilitySeverityEnums).LOW;
        case (0, $92ItQ.VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
            return (0, $92ItQ.VulnerabilitySeverityEnums).MEDIUM;
        case (0, $92ItQ.VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
            return (0, $92ItQ.VulnerabilitySeverityEnums).UNKNOWN;
        default:
            return undefined;
    }
};
const $4013551ee3707a18$export$2188844eb84f7f06 = (maybeStatus)=>{
    switch(maybeStatus?.toUpperCase()){
        case (0, $92ItQ.VulnerabilityStatusEnums).OPEN.toUpperCase():
            return (0, $92ItQ.VulnerabilityStatusEnums).OPEN;
        case (0, $92ItQ.VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
            return (0, $92ItQ.VulnerabilityStatusEnums).UNKNOWN;
        case (0, $92ItQ.VulnerabilityStatusEnums).CLOSED.toUpperCase():
            return (0, $92ItQ.VulnerabilityStatusEnums).CLOSED;
        case (0, $92ItQ.VulnerabilityStatusEnums).IGNORED.toUpperCase():
            return (0, $92ItQ.VulnerabilityStatusEnums).IGNORED;
        default:
            return undefined;
    }
};
const $4013551ee3707a18$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case (0, $8sphF.AriGraphSortOrderInput).ASC.toUpperCase():
            return (0, $8sphF.AriGraphSortOrderInput).ASC;
        case (0, $8sphF.AriGraphSortOrderInput).DESC.toUpperCase():
            return (0, $8sphF.AriGraphSortOrderInput).DESC;
        default:
            return defaultValue;
    }
};

});
parcelRegister("l123t", function(module, exports) {

var $bCc8n = parcelRequire("bCc8n");

var $kE4qX = parcelRequire("kE4qX");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $f4cb490ff11f89f3$var$flatMap(collection, iteratee) {
    return $bCc8n($kE4qX(collection, iteratee), 1);
}
module.exports = $f4cb490ff11f89f3$var$flatMap;

});
parcelRegister("kE4qX", function(module, exports) {

var $bTATB = parcelRequire("bTATB");

var $9JUaE = parcelRequire("9JUaE");

var $fQg47 = parcelRequire("fQg47");

var $jOlpf = parcelRequire("jOlpf");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $f07afb87d3c27a4d$var$map(collection, iteratee) {
    var func = $jOlpf(collection) ? $bTATB : $fQg47;
    return func(collection, $9JUaE(iteratee, 3));
}
module.exports = $f07afb87d3c27a4d$var$map;

});
parcelRegister("fQg47", function(module, exports) {

var $73ZOi = parcelRequire("73ZOi");

var $dWb9x = parcelRequire("dWb9x");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b8882c9c1eef481f$var$baseMap(collection, iteratee) {
    var index = -1, result = $dWb9x(collection) ? Array(collection.length) : [];
    $73ZOi(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b8882c9c1eef481f$var$baseMap;

});



parcelRegister("92ItQ", function(module, exports) {
$parcel$export(module.exports, "VulnerabilitySeverityEnums", () => $bbaf26b684519407$export$c1a102938d8dc10);
$parcel$export(module.exports, "VulnerabilityStatusEnums", () => $bbaf26b684519407$export$2d6749bded378262);
/* eslint-disable jira/filename-case */ const $bbaf26b684519407$export$c1a102938d8dc10 = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    UNKNOWN: 'UNKNOWN'
};
const $bbaf26b684519407$export$2d6749bded378262 = {
    CLOSED: 'CLOSED',
    IGNORED: 'IGNORED',
    OPEN: 'OPEN',
    UNKNOWN: 'UNKNOWN'
};
const $bbaf26b684519407$var$VulnerabilityTypeEnums = {
    DAST: 'DAST',
    SAST: 'SAST',
    SCA: 'SCA',
    UNKNOWN: 'UNKNOWN'
};

});



parcelRegister("6PVWV", function(module, exports) {
$parcel$export(module.exports, "default", () => $79802c7c65a4a05b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d66339b8e5815835c94600b317e89593>>
 * @relayHash 8d72bfa055c6fdfde707669ce5104bc0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0376bc7752cbb270206d5bcd51b533ec3fa2f679207bdd786d4dab220eace86f
const $79802c7c65a4a05b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "getContainers"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfContainersToFetch"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfVulnsToFetch"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "totalLinkedSecurityContainerCount"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfContainersToFetch"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": v12 /*: any*/ ,
        "type": "ThirdPartySecurityContainer"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "numberOfVulnsToFetch"
    }, v16 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "and": {
                    "lastUpdated": {
                        "sort": {
                            "order": "ASC",
                            "priority": 1
                        }
                    }
                }
            }
        },
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "cloudAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                            "SECURITY"
                        ]
                    }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSecurityProvider",
                        "kind": "LinkedField",
                        "name": "securityProviders",
                        "plural": true,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "appInstallationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            v18 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    }
                                ],
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedWorkspaces",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AriGraphRelationship",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v19 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "linkedWorkspaces(first:100)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraAutodevJob"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    }, v35 = [
        v8 /*: any*/ ,
        v15 /*: any*/ 
    ], v36 = {
        "kind": "ScalarField",
        "name": "url"
    }, v37 = {
        "kind": "ScalarField",
        "name": "key"
    }, v38 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v39 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SecurityPageRootQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v8 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "getContainers",
                                                "variableName": "getContainers"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "numberOfContainersToFetch",
                                                "variableName": "numberOfContainersToFetch"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "MainPage"
                                    },
                                    v9 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "getContainers",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "data",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16 /*: any*/ ,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": v12 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                v20 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SecurityPageRootQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v17 /*: any*/ ,
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityContainers",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v8 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "totalLinkedSecurityVulnerabilityCount"
                                },
                                {
                                    "args": v35 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                    "kind": "LinkedField",
                                                                    "name": "identifiers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "additionalInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "content"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "concreteType": "AriGraphRelationshipConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "linkedJiraIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "data",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "assignee",
                                                                                                                        "status",
                                                                                                                        "issuetype"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "status",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "picture"
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "small"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueId"
                                                                                                        },
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                v17 /*: any*/ ,
                                                                v36 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "introducedDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerVulnerabilityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "securityContainerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "severity"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        },
                                        v39 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v35 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "security__linkedSecurityVulnerabilitiesByProject",
                                    "kind": "LinkedHandle",
                                    "name": "linkedSecurityVulnerabilitiesByProject"
                                },
                                {
                                    "alias": "projectHaveVulnerabilityCheck",
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "linkedVulnsForAnalytics",
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "getContainers",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "vulnerability",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "icon"
                                                                                        },
                                                                                        v36 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "providerName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastUpdated"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v17 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ThirdPartySecurityContainer"
                                                                                },
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v38 /*: any*/ 
                                                    ]
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "security__linkedSecurityContainers",
                                            "kind": "LinkedHandle",
                                            "name": "linkedSecurityContainers"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v20 /*: any*/ 
            ]
        },
        "params": {
            "id": "0376bc7752cbb270206d5bcd51b533ec3fa2f679207bdd786d4dab220eace86f",
            "metadata": {},
            "name": "SecurityPageRootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$79802c7c65a4a05b$var$node.hash = "e4de580b4abe10bed553ada356d774cf";
var $79802c7c65a4a05b$export$2e2bcd8739ae039 = $79802c7c65a4a05b$var$node;

});


parcelRegister("efWgR", function(module, exports) {
$parcel$export(module.exports, "softwareSecurityClassicRoute", () => $3c9fb6e6fb25c7ed$export$b7285748f1151353);
const $3c9fb6e6fb25c7ed$export$b7285748f1151353 = {
    name: 'software-security-classic',
    path: '/jira/software/c/projects/:projectKey/security'
};

});

parcelRegister("cTgIW", function(module, exports) {
$parcel$export(module.exports, "isSecurityPageEnabled", () => $1ef9faa5246b2481$export$f99b2868577ed515);

var $052eo = parcelRequire("052eo");

var $i860n = parcelRequire("i860n");
const $1ef9faa5246b2481$export$f99b2868577ed515 = ()=>!(0, $052eo.isDevopsFeatureDisabledInFedRamp)() && (0, $i860n.fg)('isotopes-security-page-in-jira-enabled-v2');

});

parcelRegister("3xGhS", function(module, exports) {
$parcel$export(module.exports, "securityPageEntrypoint", () => $00ac0f81400a3183$export$5f2f9dbf41e3e769);
$parcel$export(module.exports, "securityDeprecatedPageEntrypoint", () => $00ac0f81400a3183$export$6b4cc82931a48e15);

var $4qsjf = parcelRequire("4qsjf");

var $ahWYy = parcelRequire("ahWYy");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $00ac0f81400a3183$export$5f2f9dbf41e3e769 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4qsjf.securityEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $00ac0f81400a3183$export$6b4cc82931a48e15 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $ahWYy.securityDeprecatedPageEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("4qsjf", function(module, exports) {
$parcel$export(module.exports, "securityEntrypoint", () => $320bbdb23d030ca9$export$63f7fc80f88b035a);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $320bbdb23d030ca9$export$63f7fc80f88b035a = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("3Af1y")), {
        moduleId: "3a237305",
        moduleName: "ExportedDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3Af1y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("4GIdw")
]).then(()=>parcelRequire('jRzUp'));

});


parcelRegister("ahWYy", function(module, exports) {
$parcel$export(module.exports, "securityDeprecatedPageEntryPoint", () => $e8845ea31fae153f$export$769f49e036e6c074);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $e8845ea31fae153f$export$769f49e036e6c074 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8qPbs")), {
        moduleId: "acd5c132",
        moduleName: "SecurityDeprecatedPage",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8qPbs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fwtD8").then(()=>parcelRequire('elSSa'));

});




parcelRegister("hwzvQ", function(module, exports) {
$parcel$export(module.exports, "softwareSecurityNextGenRouteEntry", () => $cc241f8cdd6a5188$export$a8dcfae475505e7a);

var $74oEx = parcelRequire("74oEx");


var $iSoIx = parcelRequire("iSoIx");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $6aSVi = parcelRequire("6aSVi");

var $bg776 = parcelRequire("bg776");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $i860n = parcelRequire("i860n");

var $8HUuJ = parcelRequire("8HUuJ");

var $cTgIW = parcelRequire("cTgIW");

var $3xGhS = parcelRequire("3xGhS");
const $cc241f8cdd6a5188$export$a8dcfae475505e7a = (0, $fdS54.createEntry)((0, $bg776.softwareSecurityNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        ufoName: 'software-security-combined',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira-security-page-to-ugs-v2') && !(0, $i860n.fg)('jolt-security-page-deprecated'), (0, $6aSVi.securityPageResource))
        ],
        meta: {
            reporting: {
                id: 'software-security',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-security'),
                teamName: 'jolt'
            }
        },
        entryPoint: ()=>{
            // When the Security tab is deprecated, serve the "moved to Development" page regardless of
            // `isSecurityPageEnabled()` so users who navigate to the old URL still see the deprecation
            // page rather than a not-found page.
            if ((0, $i860n.fg)('jolt-security-page-deprecated')) return 0, $3xGhS.securityDeprecatedPageEntrypoint;
            return (0, $cTgIW.isSecurityPageEnabled)() ? (0, $3xGhS.securityPageEntrypoint) : (0, $iSoIx.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bg776", function(module, exports) {
$parcel$export(module.exports, "softwareSecurityNextGenRoute", () => $83bdddbffc86754c$export$a2aed78ebacc3233);
const $83bdddbffc86754c$export$a2aed78ebacc3233 = {
    name: 'software-security',
    path: '/jira/software/projects/:projectKey/security'
};

});


parcelRegister("hCiGE", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryClassicRouteEntry", () => $89c0107c4837dda2$export$f81c7c178a9483e8);



var $kazMY = parcelRequire("kazMY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $idDnR = parcelRequire("idDnR");

var $4Rvd7 = parcelRequire("4Rvd7");

var $75Njg = parcelRequire("75Njg");

var $72iop = parcelRequire("72iop");

var $3eysO = parcelRequire("3eysO");

var $3KSG6 = parcelRequire("3KSG6");

var $dTa0V = parcelRequire("dTa0V");

var $gZWlI = parcelRequire("gZWlI");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");

var $i860n = parcelRequire("i860n");
const $89c0107c4837dda2$var$summarySoftwarePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kazMY.summarySoftwareEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $89c0107c4837dda2$var$GSNSummarySoftwarePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kazMY.summarySoftwareEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $89c0107c4837dda2$export$f81c7c178a9483e8 = (0, $fdS54.createEntry)((0, $72iop.softwareSummaryClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        layout: (0, $3eysO.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $gZWlI.projectThemeResource)
        ],
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? $89c0107c4837dda2$var$GSNSummarySoftwarePageEntrypoint : $89c0107c4837dda2$var$summarySoftwarePageEntrypoint,
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("kazMY", function(module, exports) {
$parcel$export(module.exports, "summarySoftwareEntrypoint", () => $035a88fade6220b4$export$6c7cf31fcbd213b8);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $jqRza = parcelRequire("jqRza");

var $jCgTZ = parcelRequire("jCgTZ");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

const $035a88fade6220b4$export$6c7cf31fcbd213b8 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("dlJbb")), {
        moduleId: "0259365f",
        moduleName: "JiraSoftwareSummaryApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jqRza.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        scope: {
                            project: {
                                projectKey: projectKey
                            }
                        },
                        isFilterRefinementEnabled: (0, $2700E.expValEquals)('jira_add_harmonisation_filter_to_summary_view', 'isEnabled', true, false)
                    }
                },
                ...(0, $i860n.fg)('jira_agentic_automations_kill_switch') ? {
                    studioWorkspaceIdQuery: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, $jCgTZ.default),
                        variables: {
                            jiraSiteAri: `ari:cloud:jira::site/${cloudId}`
                        }
                    }
                } : {}
            }
        };
    }
});

});
parcelRegister("jqRza", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4c70efe4ee7254b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<534b657f78d9393f00c774afa442764f>>
 * @relayHash af0616eab8ea5c25f4abe13d1878b7d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e2e9ab820e90d629f5c0c049ddfd8e5ab8c6ce47d02d875103e759cd8ff2c92
const $e4c70efe4ee7254b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "3e2e9ab820e90d629f5c0c049ddfd8e5ab8c6ce47d02d875103e759cd8ff2c92",
        "metadata": {},
        "name": "JiraSoftwareSummaryAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e4c70efe4ee7254b$export$2e2bcd8739ae039 = $e4c70efe4ee7254b$var$node;

});

parcelRegister("jCgTZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $67e788781f935432$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0beb8024834e0692cdf09c58f57dabc>>
 * @relayHash 71a6bdc9b776667078a30235316760ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e76823faddb437fa410f0ee4f0071f1f1833d46e55f21413adf9b54810754c90
const $67e788781f935432$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraSiteAri"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "jiraSiteAri"
                }
            ],
            "concreteType": "AdminUnitLinkedResource",
            "kind": "LinkedField",
            "name": "admin_unitLinkedResource",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 10
                        }
                    ],
                    "concreteType": "AdminUnitLinkedConnection",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AdminUnitLinkedEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AdminUnitLinkedTo",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "links(first:10)"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StudioWorkspaceIdLoaderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StudioWorkspaceIdLoaderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "e76823faddb437fa410f0ee4f0071f1f1833d46e55f21413adf9b54810754c90",
            "metadata": {},
            "name": "StudioWorkspaceIdLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$67e788781f935432$var$node.hash = "fbc2fa57e550872aa23f04f1e66a4104";
var $67e788781f935432$export$2e2bcd8739ae039 = $67e788781f935432$var$node;

});

parcelRegister("dlJbb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("5BBun")
]).then(()=>parcelRequire('in9KN'));

});


parcelRegister("72iop", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryClassicRoute", () => $0381dc9902053c1b$export$b5046fccf399983f);
const $0381dc9902053c1b$export$b5046fccf399983f = {
    name: 'software-summary-classic',
    path: '/jira/software/c/projects/:projectKey/summary'
};

});


parcelRegister("crO1B", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryEmbedClassicRouteEntry", () => $765c32b980368ac0$export$1dc5e581d8ca39ac);

var $28o2t = parcelRequire("28o2t");

var $fdS54 = parcelRequire("fdS54");

var $hWEkS = parcelRequire("hWEkS");

var $edf7u = parcelRequire("edf7u");

var $hFYSn = parcelRequire("hFYSn");

var $2jRrn = parcelRequire("2jRrn");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");
const $765c32b980368ac0$var$summarySoftwareEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $28o2t.summarySoftwareEmbedEntrypoint)
});
const $765c32b980368ac0$export$1dc5e581d8ca39ac = (0, $fdS54.createEntry)((0, $2jRrn.softwareSummaryEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource)
        ],
        entryPoint: ()=>{
            return $765c32b980368ac0$var$summarySoftwareEmbedPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("28o2t", function(module, exports) {
$parcel$export(module.exports, "summarySoftwareEmbedEntrypoint", () => $7bc42e53f00432c7$export$4eeb5d2e0e9b94b6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $aTPm4 = parcelRequire("aTPm4");

const $7bc42e53f00432c7$export$4eeb5d2e0e9b94b6 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("c47Me")), {
        moduleId: "d41b1f3b",
        moduleName: "JiraSoftwareSummaryEmbedApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $aTPm4.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("aTPm4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3c91f733f5bfed3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdf401725a79bf7d20d26bebeeaedf77>>
 * @relayHash eba1c502749083d7858f23a8a4380f36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3b9d98ccf886b12917104f999ff14f90165d6108a2547ca1fbf4ca98d929e1e
const $b3c91f733f5bfed3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b3b9d98ccf886b12917104f999ff14f90165d6108a2547ca1fbf4ca98d929e1e",
        "metadata": {},
        "name": "JiraSoftwareSummaryEmbedAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b3c91f733f5bfed3$export$2e2bcd8739ae039 = $b3c91f733f5bfed3$var$node;

});

parcelRegister("c47Me", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("anDu8")
]).then(()=>parcelRequire('2p0Xh'));

});


parcelRegister("2jRrn", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryEmbedClassicRoute", () => $8dc764bef91a6f77$export$7fa3d3891ccec782);
const $8dc764bef91a6f77$export$7fa3d3891ccec782 = {
    name: 'software-summary-classic-embed',
    path: '/jira/software/c/projects/:projectKey/summary/embed'
};

});


parcelRegister("5EYUQ", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryEmbedRouteEntry", () => $20b230fc774eb071$export$d0dcb1130082d8e);

var $74oEx = parcelRequire("74oEx");

var $28o2t = parcelRequire("28o2t");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $3qNZY = parcelRequire("3qNZY");

var $hFYSn = parcelRequire("hFYSn");

var $edf7u = parcelRequire("edf7u");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $dTa0V = parcelRequire("dTa0V");
const $20b230fc774eb071$var$summarySoftwareEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $28o2t.summarySoftwareEmbedEntrypoint)
});
const $20b230fc774eb071$export$d0dcb1130082d8e = (0, $fdS54.createEntry)((0, $3qNZY.softwareSummaryEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary-embed',
        layout: (0, $byMD7.chromelessLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource)
        ],
        meta: {
            reporting: {
                id: 'software-summary-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-summary-embed'),
                teamName: 'jira-werewolves'
            }
        },
        entryPoint: ()=>$20b230fc774eb071$var$summarySoftwareEmbedPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3qNZY", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryEmbedRoute", () => $1722b6f6514601fd$export$11863f01f5694529);
const $1722b6f6514601fd$export$11863f01f5694529 = {
    name: 'software-summary-embed',
    path: '/jira/software/projects/:projectKey/summary/embed'
};

});


parcelRegister("9l8dE", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryRouteEntry", () => $6b8ff0ad5e0f3b11$export$a2560b0baf928c49);

var $74oEx = parcelRequire("74oEx");

var $hi6Of = parcelRequire("hi6Of");


var $kazMY = parcelRequire("kazMY");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $lEqMZ = parcelRequire("lEqMZ");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $3KSG6 = parcelRequire("3KSG6");

var $gZWlI = parcelRequire("gZWlI");
const $6b8ff0ad5e0f3b11$var$summarySoftwarePageEntrypoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $kazMY.summarySoftwareEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});
const $6b8ff0ad5e0f3b11$export$a2560b0baf928c49 = (0, $fdS54.createEntry)((0, $lEqMZ.softwareSummaryRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gZWlI.projectThemeResource)
        ],
        meta: {
            reporting: {
                id: 'software-summary',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-summary'),
                teamName: 'jira-werewolves'
            }
        },
        entryPoint: ()=>$6b8ff0ad5e0f3b11$var$summarySoftwarePageEntrypoint,
        supportsPreviewPanel: true,
        supportsProjectTheme: 'full',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lEqMZ", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryRoute", () => $4d206b1b9d1954ea$export$c6629202e90df62a);
const $4d206b1b9d1954ea$export$c6629202e90df62a = {
    name: 'software-summary',
    path: '/jira/software/projects/:projectKey/summary'
};

});


parcelRegister("38HPm", function(module, exports) {
$parcel$export(module.exports, "softwareTeamManagedAgentsRouteEntry", () => $a32fb7b6a8acee2d$export$881fb64d35fcdff);

var $870NF = parcelRequire("870NF");

var $iCJcU = parcelRequire("iCJcU");



var $gyAS0 = parcelRequire("gyAS0");

var $fdS54 = parcelRequire("fdS54");

var $3eysO = parcelRequire("3eysO");

var $2700E = parcelRequire("2700E");

var $dTa0V = parcelRequire("dTa0V");

var $iSoIx = parcelRequire("iSoIx");
const $a32fb7b6a8acee2d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $870NF.agentsHomeEntryPoint)
});
const $a32fb7b6a8acee2d$export$881fb64d35fcdff = (0, $fdS54.createEntry)((0, $iCJcU.softwareTeamManagedAgentsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.agents.jsw-tmp',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $d579872b9d7d689d$export$983f2e89073dd86)
        },
        resources: [
            ...(0, $gyAS0.getSettingsNavigationResources)()
        ],
        entryPoint: ()=>(0, $2700E.expVal)('yamato-agents-home-space-settings-beta', 'isEnabled', false) ? $a32fb7b6a8acee2d$var$pageEntryPoint : (0, $iSoIx.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        meta: {
            reporting: {
                packageName: 'jiraProjectSettingsAgentsHome',
                id: 'project-settings.agents.jsw-tmp',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("iCJcU", function(module, exports) {
$parcel$export(module.exports, "softwareTeamManagedAgentsRoute", () => $f6cb2fc0c083c921$export$fad0384c381ad032);
const $f6cb2fc0c083c921$export$fad0384c381ad032 = {
    name: 'software-team-managed-agents',
    path: '/jira/software/projects/:projectKey/settings/agents',
    exact: true
};

});


parcelRegister("9qWPj", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineClassicRouteEntry", () => $62a0dd46e19907f2$export$a822ee67d4c66296);

var $euxye = parcelRequire("euxye");

var $51vnM = parcelRequire("51vnM");



var $9T5Cr = parcelRequire("9T5Cr");

var $cLdvY = parcelRequire("cLdvY");

var $fdS54 = parcelRequire("fdS54");

var $g4vag = parcelRequire("g4vag");

var $7xkRt = parcelRequire("7xkRt");

var $QhQu4 = parcelRequire("QhQu4");

var $3eysO = parcelRequire("3eysO");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $75Njg = parcelRequire("75Njg");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $idDnR = parcelRequire("idDnR");

var $8lFL8 = parcelRequire("8lFL8");

var $8HUuJ = parcelRequire("8HUuJ");

var $gZWlI = parcelRequire("gZWlI");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $8phT9 = parcelRequire("8phT9");
const $62a0dd46e19907f2$export$a822ee67d4c66296 = (0, $fdS54.createEntry)((0, $g4vag.softwareTimelineClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $i860n.fg)('timeline_skeleton_update') ? $62a0dd46e19907f2$var$ClassicSoftwareTimelineSkeleton : (0, $7xkRt.RoadmapSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayoutCode), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira),
            sidebarId: (0, $6cc4c278d90305fc$export$373854fe102ad77c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false), (0, $8lFL8.classicRoadmapResource)),
            (0, $gZWlI.projectThemeResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira_software_timeline_perf_improvements') && (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false), (0, $9T5Cr.fieldsResource))
        ],
        preloadOptions: {
            earlyChunks: !(0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? [
                'software-roadmap-early-entry'
            ] : []
        },
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        ufoName: (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? 'software.timeline-view' : 'classic-roadmap',
        entryPoint: ()=>{
            const [roadmapEP, softwareEP] = (0, $i860n.fg)('navx-global-side-nav') ? [
                (0, $8phT9.GSNRoadmapViewClassicPageEntrypoint),
                (0, $8phT9.GSNSoftwareHarmonisedTimelineClassicPageEntrypoint)
            ] : [
                (0, $8phT9.roadmapViewClassicPageEntrypoint),
                (0, $8phT9.softwareHarmonisedTimelineClassicPageEntrypoint)
            ];
            return (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? softwareEP : roadmapEP;
        },
        supportsPreviewPanel: true,
        supportsProjectTheme: (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? 'full' : 'contoured',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));
const $62a0dd46e19907f2$var$ClassicSoftwareTimelineSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $62a0dd46e19907f2$var$timelineSkeletonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7xkRt.RoadmapSkeleton), null));
$62a0dd46e19907f2$var$ClassicSoftwareTimelineSkeleton.displayName = "ClassicSoftwareTimelineSkeleton";
const $62a0dd46e19907f2$var$timelineSkeletonContainerStyles = (0, $fbAgj.xcss)({
    height: '100%',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.large',
    overflow: 'hidden'
});

});
parcelRegister("g4vag", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineClassicRoute", () => $e708c6907da7d3e9$export$ce5173f7e8fa932b);
const $e708c6907da7d3e9$export$ce5173f7e8fa932b = {
    name: 'software-timeline-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline/:viewId?'
};

});

parcelRegister("8phT9", function(module, exports) {
$parcel$export(module.exports, "roadmapViewClassicPageEntrypoint", () => $3917c576fc7a2816$export$af2674d32463682f);
$parcel$export(module.exports, "GSNRoadmapViewClassicPageEntrypoint", () => $3917c576fc7a2816$export$7fecfa4f3ebdc9d);
$parcel$export(module.exports, "softwareHarmonisedTimelineClassicPageEntrypoint", () => $3917c576fc7a2816$export$8e39ce9fdb72723);
$parcel$export(module.exports, "GSNSoftwareHarmonisedTimelineClassicPageEntrypoint", () => $3917c576fc7a2816$export$36a2f98a50a70010);
/* eslint-disable jira/naming/disallow-filenames */ 
var $77OhI = parcelRequire("77OhI");

var $9OXP2 = parcelRequire("9OXP2");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $9BxTS = parcelRequire("9BxTS");

var $eDEQ5 = parcelRequire("eDEQ5");
const $3917c576fc7a2816$var$pageEntrypointConfig = {
    main: (0, $9OXP2.roadmapViewClassicEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
};
const $3917c576fc7a2816$var$GSNPageEntrypointConfig = {
    main: (0, $9OXP2.roadmapViewClassicEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $9BxTS.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
};
const $3917c576fc7a2816$export$af2674d32463682f = (0, $dTa0V.createPageEntryPoint)($3917c576fc7a2816$var$pageEntrypointConfig);
const $3917c576fc7a2816$export$7fecfa4f3ebdc9d = (0, $dTa0V.createPageEntryPoint)($3917c576fc7a2816$var$GSNPageEntrypointConfig);
const $3917c576fc7a2816$export$8e39ce9fdb72723 = (0, $dTa0V.createPageEntryPoint)({
    ...$3917c576fc7a2816$var$pageEntrypointConfig,
    main: (0, $77OhI.softwareTimelineEntrypoint)
});
const $3917c576fc7a2816$export$36a2f98a50a70010 = (0, $dTa0V.createPageEntryPoint)({
    ...$3917c576fc7a2816$var$GSNPageEntrypointConfig,
    main: (0, $77OhI.softwareTimelineEntrypoint)
});

});
parcelRegister("77OhI", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineEntrypoint", () => $c359a8e1d75a2367$export$85a905c235ac34bb);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $71h0a = parcelRequire("71h0a");

var $i860n = parcelRequire("i860n");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $2700E = parcelRequire("2700E");

var $lh6D1 = parcelRequire("lh6D1");

var $6nh3o = parcelRequire("6nh3o");

var $eKFQE = parcelRequire("eKFQE");

var $kIYP9 = parcelRequire("kIYP9");
const $c359a8e1d75a2367$var$NAMESPACE = 'TIMELINE';
const $c359a8e1d75a2367$var$TOGGLEABLE_FIELD_SET_IDS = [
    'assignee',
    'status'
];
/**
 * The window used to filter sprints shown on the timeline: from one year before
 * the current date to two years after it. Bounds are ISO date-time strings
 * matching the `JiraDateTimeWindow` input.
 */ const $c359a8e1d75a2367$var$getSprintsActiveWithin = ()=>{
    const now = new Date();
    const start = new Date(now);
    start.setFullYear(start.getFullYear() - 1);
    const end = new Date(now);
    end.setFullYear(end.getFullYear() + 2);
    return {
        start: start.toISOString(),
        end: end.toISOString()
    };
};
const $c359a8e1d75a2367$var$WEEKS = 'WEEKS';
const $c359a8e1d75a2367$var$MONTHS = 'MONTHS';
const $c359a8e1d75a2367$var$QUARTERS = 'QUARTERS';
// Matches only plain objects: arrays, `null`, `Date`, `RegExp`, functions, and
// primitives are all excluded, so the `Record<string, unknown>` narrowing
// reflects the exact set of runtime values that reach the property access below.
const $c359a8e1d75a2367$var$isRecord = (value)=>Object.prototype.toString.call(value) === '[object Object]';
/**
 * Safely resolves the scroll element height calibration for a route from an
 * untrusted experiment value. Returns `undefined` (so the prop is omitted and
 * the Issue Table uses its built-in fallback) unless the value is a plain object
 * keyed by route name whose entry has finite numeric `scrollElementHeight` and
 * `viewportHeightOverhead`.
 */ const $c359a8e1d75a2367$var$getScrollElementHeightCalibration = (calibration, routeName)=>{
    if (!$c359a8e1d75a2367$var$isRecord(calibration)) return undefined;
    const entry = calibration[routeName];
    if (!$c359a8e1d75a2367$var$isRecord(entry)) return undefined;
    const { scrollElementHeight: scrollElementHeight, viewportHeightOverhead: viewportHeightOverhead } = entry;
    if (typeof scrollElementHeight !== 'number' || !Number.isFinite(scrollElementHeight) || typeof viewportHeightOverhead !== 'number' || !Number.isFinite(viewportHeightOverhead)) return undefined;
    return {
        scrollElementHeight: scrollElementHeight,
        viewportHeightOverhead: viewportHeightOverhead
    };
};
const $c359a8e1d75a2367$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
const $c359a8e1d75a2367$var$getProjectJql = (projectKey)=>projectKey.length > 0 ? `project = '${projectKey}'` : '';
const $c359a8e1d75a2367$var$withSpecialValues = (value = '')=>{
    if (value.indexOf('unassigned') > -1) return 'empty';
    return value;
};
const $c359a8e1d75a2367$var$queryParamToJqlClause = ({ key: key, queryParam: queryParam })=>{
    const values = queryParam.split(',');
    return values.length > 1 ? `${key} in (${values.map($c359a8e1d75a2367$var$withSpecialValues).join(', ')})` : `${key} = ${$c359a8e1d75a2367$var$withSpecialValues(values[0])}`;
};
const $c359a8e1d75a2367$var$getTextSearchJql = (text)=>{
    if (!text || text.trim() === '') return '';
    const sanitize = (value)=>value.trim().replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `textfields ~ "${search}"`;
};
function $c359a8e1d75a2367$var$isValidTimelineMode(value) {
    return value === $c359a8e1d75a2367$var$WEEKS || value === $c359a8e1d75a2367$var$MONTHS || value === $c359a8e1d75a2367$var$QUARTERS;
}
const $c359a8e1d75a2367$var$buildJql = ({ jqlParam: jqlParam = '', text: text, projectKey: projectKey, filterQueryParams: filterQueryParams })=>{
    const filterJqlClauses = Object.keys(filterQueryParams).map((key)=>$c359a8e1d75a2367$var$queryParamToJqlClause({
            key: key,
            queryParam: filterQueryParams[key]
        }));
    const project = $c359a8e1d75a2367$var$getProjectJql(projectKey);
    const textSearch = $c359a8e1d75a2367$var$getTextSearchJql(text);
    return {
        jql: `${$c359a8e1d75a2367$var$and([
            jqlParam,
            textSearch,
            ...filterJqlClauses,
            project
        ])} ORDER BY rank ASC`,
        jqlParam: $c359a8e1d75a2367$var$and([
            jqlParam,
            textSearch,
            ...filterJqlClauses
        ])
    };
};
// should be equivalent to the getToday function in jira/src/packages/software/roadmap-utils/src/utils/dates.tsx
const $c359a8e1d75a2367$var$getToday = ()=>{
    const now = new Date();
    const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
    return date.valueOf();
};
const $c359a8e1d75a2367$var$parseQueryParamValue = (str)=>{
    try {
        return str ? JSON.parse(str) : undefined;
    } catch  {
    // Do nothing - ignore invalid values
    }
};
const $c359a8e1d75a2367$var$parseHierarchyLevelParamValue = (str)=>{
    if (!str) return undefined;
    const parsed = Number(str);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
};
const $c359a8e1d75a2367$var$toStaticViewInput = (settings, aggregationConfig)=>{
    return {
        isGroupingEnabled: !!settings.groupBy,
        isHideDoneEnabled: settings.hideDone,
        isHierarchyEnabled: settings.hierarchyEnabled,
        ...aggregationConfig || {
            aggregationConfig: aggregationConfig
        }
    };
};

const $c359a8e1d75a2367$export$85a905c235ac34bb = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("gE5hY")), {
        moduleId: "67754d3a",
        moduleName: "JiraSoftwareTimelineApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const { context: context, tenantContext: { cloudId: cloudId } } = entryPointParams;
        const projectKey = context.match.params.projectKey;
        const boardId = context.match.params.boardId;
        const viewId = context.match.params.viewId;
        const isCMP = context.route.name === 'software-timeline-classic';
        const { hideDone: hideDone, jql: jqlQueryParam, assignee: assignee, label: label, statuses: statuses, issueParent: issueParent, version: version, text: text, goal: goal, rangeMode: rangeMode, hideWarnings: hideWarnings, hideDependencies: hideDependencies, hideVersionHeader: hideVersionHeader, hideUnParentedItems: hideUnParentedItems, maxHierarchyLevel: maxHierarchyLevel, customFilter: customFilter, quickFilter: quickFilter } = context.query;
        if (projectKey == null) throw new Error('Project key missing');
        const prevFieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'timeline'
        ];
        const { fieldSetIds: fieldSetIds, fieldSetsInput: fieldSetsInput } = (0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
            fieldSetIds: undefined,
            fieldSetsInput: {
                viewInput: {
                    namespace: 'TIMELINE',
                    viewId: 'timeline_default'
                }
            }
        } : {
            fieldSetIds: prevFieldSetIds,
            fieldSetsInput: {
                fieldSetIds: prevFieldSetIds
            }
        };
        // Explicity set the aggregation config to false when the timeline_harmonisation_m2 experiment is disabled.
        const aggregationConfig = !(0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
            aggregationConfig: {
                aggregationFields: [
                    {
                        fieldId: 'timeline',
                        isEnabled: false
                    },
                    {
                        fieldId: 'status',
                        isEnabled: false
                    }
                ]
            }
        } : undefined;
        const scope = {
            operationScope: 'TIMELINE_BOARD',
            projectKey: projectKey
        };
        // `viewScope` is the same value as `scope` above — it only exists so we can pass the
        // scope to the top-level jiraIssueSearchView behind jira_timeline_hierarchy_board_filter
        // without affecting the nested issues(scope), which must keep `scope` unconditionally.
        // On FG cleanup: delete `viewScope`, pass `scope` directly to jiraIssueSearchView.
        const viewScope = (0, $i860n.fg)('jira_timeline_hierarchy_board_filter') ? scope : undefined;
        const { jql: jql, jqlParam: jqlParam } = $c359a8e1d75a2367$var$buildJql({
            jqlParam: jqlQueryParam,
            text: text,
            projectKey: projectKey,
            filterQueryParams: {
                ...assignee ? {
                    assignee: assignee
                } : {},
                ...label ? {
                    labels: label
                } : {},
                ...statuses ? {
                    statusCategory: statuses
                } : {},
                ...issueParent ? {
                    parent: issueParent
                } : {},
                ...version ? {
                    fixVersion: version
                } : {},
                ...goal ? {
                    '"Goals[Goals]"': goal
                } : {}
            }
        });
        const settings = {
            groupBy: null,
            hideDone: $c359a8e1d75a2367$var$parseQueryParamValue(hideDone),
            hierarchyEnabled: true,
            jql: null
        };
        // JiraIssueSearchSettings will replace JiraIssueSearchStaticViewInput
        // as part of the saved views project, so we'll use it as the source of
        // truth
        const staticViewInput = $c359a8e1d75a2367$var$toStaticViewInput(settings, aggregationConfig);
        const sourceARI = (0, $6nh3o.JiraSoftwareBoardAri).create({
            siteId: cloudId,
            boardId: String(boardId)
        }).toString();
        const filterRefinementScope = {
            backlog: {
                boardId: Number(boardId)
            }
        };
        const normalizedRangeMode = rangeMode?.toUpperCase();
        const validatedRangeMode = normalizedRangeMode && $c359a8e1d75a2367$var$isValidTimelineMode(normalizedRangeMode) ? normalizedRangeMode : undefined;
        const parsedHideDone = $c359a8e1d75a2367$var$parseQueryParamValue(hideDone);
        const parsedHideWarnings = $c359a8e1d75a2367$var$parseQueryParamValue(hideWarnings);
        const parsedHideDependencies = $c359a8e1d75a2367$var$parseQueryParamValue(hideDependencies);
        const parsedHideReleases = $c359a8e1d75a2367$var$parseQueryParamValue(hideVersionHeader);
        const parsedHideUnParentedItems = $c359a8e1d75a2367$var$parseQueryParamValue(hideUnParentedItems);
        const parsedMaxHierarchyLevel = $c359a8e1d75a2367$var$parseHierarchyLevelParamValue(maxHierarchyLevel);
        const timelineToggleOverrides = (0, $i860n.fg)('jira_sw_timeline_saved_view_technical') ? {
            ...parsedHideWarnings !== undefined ? {
                hideWarnings: parsedHideWarnings
            } : {},
            ...parsedHideDependencies !== undefined ? {
                hideDependencies: parsedHideDependencies
            } : {},
            ...parsedHideReleases !== undefined ? {
                hideReleases: parsedHideReleases
            } : {},
            ...parsedHideUnParentedItems !== undefined ? {
                hideUnParentedItems: parsedHideUnParentedItems
            } : {},
            ...parsedMaxHierarchyLevel !== undefined ? {
                maxHierarchyLevel: parsedMaxHierarchyLevel
            } : {}
        } : {};
        const customFilterIds = customFilter ? customFilter.split(',').filter(Boolean) : undefined;
        const quickFilterIds = quickFilter ? quickFilter.split(',').filter(Boolean) : undefined;
        // appliedFilters lives on JiraTimelineViewSettings only (not JiraTimelineStaticViewInput);
        // it's needed so isTimelineViewConfigModified detects a filter override from the URL. The
        // actual issue filtering is applied via issueSearchInput below.
        const appliedFiltersOverride = (customFilterIds || quickFilterIds || jqlParam) && (0, $i860n.fg)('jira_sw_timeline_saved_view_technical') ? {
            appliedFilters: {
                // Use the same `jql` sent to issueSearchInput.customInput.additionalJql below,
                // so the persisted appliedFilters.additionalJql matches the applied search.
                ...jqlParam ? {
                    additionalJql: jqlParam
                } : {},
                ...customFilterIds ? {
                    customFilterIds: customFilterIds
                } : {},
                ...quickFilterIds ? {
                    quickFilterIds: quickFilterIds
                } : {}
            }
        } : {};
        const timelineViewSettings = {
            ...validatedRangeMode !== undefined ? {
                rangeMode: validatedRangeMode
            } : {},
            // hideDone exists on JiraTimelineViewSettings (not JiraTimelineStaticViewInput); it's
            // needed so isTimelineViewConfigModified detects a hideDone override from the URL.
            ...parsedHideDone !== undefined && (0, $i860n.fg)('jira_sw_timeline_saved_view_technical') ? {
                hideDone: parsedHideDone
            } : {},
            ...timelineToggleOverrides,
            ...appliedFiltersOverride
        };
        const timelineStaticViewInput = {
            ...validatedRangeMode !== undefined ? {
                rangeMode: validatedRangeMode
            } : {},
            ...timelineToggleOverrides
        };
        const useSavedFilters = !(customFilter || quickFilter || jqlParam);
        const issueSearchInput = {
            customInput: {
                jiraTimelineInput: {
                    boardId: String(boardId),
                    ...useSavedFilters === false ? {
                        ...jql && !(0, $i860n.fg)('jira_sw_timeline_saved_view_technical') ? {
                            additionalJql: jql
                        } : {},
                        ...jqlParam && (0, $i860n.fg)('jira_sw_timeline_saved_view_technical') ? {
                            additionalJql: jqlParam
                        } : {},
                        ...customFilterIds ? {
                            customFilterIds: customFilterIds
                        } : {},
                        ...quickFilterIds ? {
                            quickFilterIds: quickFilterIds
                        } : {}
                    } : {},
                    useSavedFilters: useSavedFilters
                }
            }
        };
        const itemIdSuffix = viewId ? `/${viewId}` : '';
        const itemId = (0, $2700E.expValEquals)('jira_sw_timeline_saved_views', 'isEnabled', true, false) ? `timeline${itemIdSuffix}` : 'timeline';
        const boardIdAndItemQuery = {
            cloudId: cloudId,
            itemId: itemId,
            boardId: Number(boardId)
        };
        const jiraViewQueryInput = {
            boardIdAndItemQuery: boardIdAndItemQuery
        };
        const dynamicSearchKey = `software-timeline-${projectKey}-${boardId}${viewId && (0, $2700E.expValEquals)('jira_sw_timeline_saved_views', 'isEnabled', true, false) ? `-${viewId}` : ''}`;
        // Per-route scroll element height calibration is delivered via the
        // `issue_table_virtualizer_dynamic_estimators` experiment's `calibration`
        // parameter, a `Record<routeName, ScrollElementHeightCalibration>`. The
        // experiment value is untrusted (it comes from remote config), so it is
        // validated before use; an absent or malformed entry yields `undefined` and
        // the calibration is omitted so the Issue Table falls back to its default.
        const scrollElementHeightCalibration = (0, $2700E.expVal)('issue_table_virtualizer_dynamic_estimators', 'isEnabled', false) ? $c359a8e1d75a2367$var$getScrollElementHeightCalibration((0, $2700E.expVal)('issue_table_virtualizer_dynamic_estimators', 'calibration', null), context.route.name) : undefined;
        return {
            extraProps: {
                ...(0, $2700E.expValEquals)('jira_sw_timeline_saved_views', 'isEnabled', true, false) ? {
                    remountKey: JSON.stringify(boardIdAndItemQuery)
                } : {},
                today: $c359a8e1d75a2367$var$getToday(),
                isTimelineHarmonisationM2Enabled: (0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false),
                isTimelineSavedViewEnabled: (0, $2700E.expValEquals)('jira_sw_timeline_saved_views', 'isEnabled', true, false),
                isTimelineGroupByEnabled: false,
                jqlParam: jqlParam,
                isBulkOperationsInTimelineEnabled: (0, $2700E.expValEquals)('bulk_operations_in_timeline', 'isEnabled', true, false),
                ...(0, $i860n.fg)('timeline-filter-refinement-technical-changes') ? {
                    filterRefinementScope: filterRefinementScope,
                    includeBoardFilters: true
                } : {},
                ...scrollElementHeightCalibration ? {
                    scrollElementHeightCalibration: scrollElementHeightCalibration
                } : {}
            },
            queries: {
                softwareTimelineQuery: {
                    options: {
                        fetchPolicy: (0, $i860n.fg)('jira_software_timeline_perf_improvements') ? 'store-or-network' : 'store-and-network'
                    },
                    parameters: (0, $eKFQE.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        boardId: sourceARI,
                        isCMP: isCMP
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $lh6D1.default),
                    variables: {
                        boardIds: [
                            sourceARI
                        ],
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        fieldSetIds: fieldSetIds,
                        fieldSetsInput: fieldSetsInput,
                        filterId: null,
                        first: (0, $i860n.fg)('jira_software_timeline_perf_improvements') ? 30 : 50,
                        issueSearchInput: issueSearchInput,
                        namespace: $c359a8e1d75a2367$var$NAMESPACE,
                        projectKey: projectKey,
                        settings: settings,
                        dynamicSearchKey: /*
									This key is used to generate a unique identity for the issue connection record in the Relay
									store when running a new search. This is to prevent concurrency related bugs occurring when
									performing a refetch that returns a new connection of results. Ordinarily this would be
									handled automatically when relevant query variables change (as these are used to form the
									connection key), however we override the default connection filters which allows us to modify
									variables during pagination operations without producing a new connection key.
									 */ dynamicSearchKey,
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: !(0, $i860n.fg)('jsc_list_expand_all'),
                        shouldQueryHasChildrenWithCount: (0, $i860n.fg)('jsc_list_expand_all'),
                        shouldQueryHasParent: (0, $i860n.fg)('jira_harmonised_timeline_hierarchy_flyout'),
                        scope: scope,
                        viewScope: viewScope,
                        staticViewInput: staticViewInput,
                        viewConfigInput: {
                            staticViewInput: staticViewInput
                        },
                        jiraViewQueryInput: jiraViewQueryInput,
                        // jiraViewQueryInputForIssues is temporary and is used to replace jiraViewQueryInput.
                        // It will be removed when jira_timeline_saved_view_technical is cleaned up.
                        // When cleaning up jira_timeline_saved_view_technical, replace this with jiraViewQueryInput.
                        // Keep this consistent with the business project.
                        jiraViewQueryInputForIssues: (0, $2700E.expValEquals)('jira_sw_timeline_saved_views', 'isEnabled', true, false) ? jiraViewQueryInput : null,
                        timelineViewSettings: timelineViewSettings,
                        timelineStaticViewInput: timelineStaticViewInput,
                        viewId: 'timeline_default',
                        ...(0, $2700E.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false) ? {
                            toggleableFieldSetIds: $c359a8e1d75a2367$var$TOGGLEABLE_FIELD_SET_IDS,
                            isInlineEditingEnabled: true,
                            isTimelineHarmonisationM2Enabled: true
                        } : {
                            isTimelineHarmonisationM2Enabled: false,
                            isInlineEditingEnabled: false
                        },
                        shouldQuerySprints: true,
                        sprintsActiveWithin: $c359a8e1d75a2367$var$getSprintsActiveWithin(),
                        shouldQuerySoftwareProjectSettings: true,
                        shouldQueryLastAppliedFilters: true,
                        shouldQueryReleases: true,
                        shouldQueryBarColor: true,
                        isTimelineGroupByEnabled: false,
                        projectOrBoardInput: {
                            boardId: Number(boardId)
                        }
                    }
                },
                filterRefinementQuery: {
                    options: {
                        fetchPolicy: (0, $i860n.fg)('jira_software_timeline_perf_improvements') ? 'store-or-network' : 'store-and-network'
                    },
                    parameters: (0, $71h0a.default),
                    variables: {
                        cloudId: cloudId,
                        filterRefinementScope: filterRefinementScope,
                        boardId: sourceARI,
                        includeBoard: true
                    }
                }
            },
            ...(0, $i860n.fg)('jira_software_timeline_perf_improvements') ? {
                entryPoints: {
                    nativeIssueTableEntryPoint: {
                        entryPoint: (0, $kIYP9.nativeIssueTableEntryPoint),
                        entryPointParams: entryPointParams
                    }
                }
            } : {}
        };
    }
});

});
parcelRegister("eKFQE", function(module, exports) {
$parcel$export(module.exports, "default", () => $97f540dd053639df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1b4c206501db2ca5a68f4a6129d1a729>>
 * @relayHash d6d2c3d7f03461063a5fa739fc90f661
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36d7971b58c17507520135674b8261ab5cbe636d62b35c3d988449c193468c4c
const $97f540dd053639df$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "36d7971b58c17507520135674b8261ab5cbe636d62b35c3d988449c193468c4c",
        "metadata": {},
        "name": "JiraSoftwareTimelineAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $97f540dd053639df$export$2e2bcd8739ae039 = $97f540dd053639df$var$node;

});

parcelRegister("gE5hY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("cY0bj")
]).then(()=>parcelRequire('1kugi'));

});


parcelRegister("9OXP2", function(module, exports) {
$parcel$export(module.exports, "roadmapViewClassicEntrypoint", () => $82ab6c16b7ec2380$export$583357f75b3be3a7);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $82ab6c16b7ec2380$export$583357f75b3be3a7 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("irgZN")), {
        moduleId: "1dd921a3",
        moduleName: "ExportedDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("irgZN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("loAtq")
]).then(()=>parcelRequire('4np9E'));

});




parcelRegister("hMYmt", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineCustomEmbedRouteEntry", () => $2e2d79f99756c9dd$export$6ead139b9199cf98);

var $iFBvi = parcelRequire("iFBvi");

var $iSoIx = parcelRequire("iSoIx");

var $edf7u = parcelRequire("edf7u");

var $9T5Cr = parcelRequire("9T5Cr");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $1FxnF = parcelRequire("1FxnF");

var $9EWfZ = parcelRequire("9EWfZ");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $8HUuJ = parcelRequire("8HUuJ");
const $2e2d79f99756c9dd$var$softwareTimelineEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $iFBvi.softwareTimelineEmbedEntrypoint)
});
const $2e2d79f99756c9dd$export$6ead139b9199cf98 = (0, $fdS54.createEntry)((0, $1FxnF.softwareTimelineCustomEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software-timeline-embed-view',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jira_harmonised_software_timeline_embed') && (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? $2e2d79f99756c9dd$var$softwareTimelineEmbedPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        resources: [
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira_software_timeline_perf_improvements'), (0, $9T5Cr.fieldsResource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        supportsProjectTheme: 'full'
    }));

});
parcelRegister("1FxnF", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineCustomEmbedRoute", () => $e0aa6d1806e06af5$export$1347983a721dfa9e);
const $e0aa6d1806e06af5$export$1347983a721dfa9e = {
    name: 'software-timeline-custom-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline/:viewId/embed',
    exact: true
};

});


parcelRegister("7muqP", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineEmbedRouteEntry", () => $f75fe05ae432e6a6$export$19a806a982b5810c);

var $iFBvi = parcelRequire("iFBvi");

var $iSoIx = parcelRequire("iSoIx");

var $edf7u = parcelRequire("edf7u");

var $9T5Cr = parcelRequire("9T5Cr");

var $byMD7 = parcelRequire("byMD7");

var $dTa0V = parcelRequire("dTa0V");

var $fdS54 = parcelRequire("fdS54");

var $1VM7e = parcelRequire("1VM7e");

var $9EWfZ = parcelRequire("9EWfZ");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $8HUuJ = parcelRequire("8HUuJ");
const $f75fe05ae432e6a6$var$softwareTimelineEmbedPageEntrypoint = (0, $dTa0V.createChromelessEntryPoint)({
    main: (0, $iFBvi.softwareTimelineEmbedEntrypoint)
});
const $f75fe05ae432e6a6$export$19a806a982b5810c = (0, $fdS54.createEntry)((0, $1VM7e.softwareTimelineEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software-timeline-embed-view',
        layout: (0, $byMD7.chromelessLayout),
        skeleton: (0, $9EWfZ.ThemedLazySkeleton),
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jira_harmonised_software_timeline_embed') && (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? $f75fe05ae432e6a6$var$softwareTimelineEmbedPageEntrypoint : (0, $iSoIx.notFoundPageEntrypoint),
        resources: [
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira_software_timeline_perf_improvements'), (0, $9T5Cr.fieldsResource))
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        },
        supportsProjectTheme: 'full'
    }));

});
parcelRegister("1VM7e", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineEmbedRoute", () => $9270b22b503b541e$export$a657fb0465de0b9e);
const $9270b22b503b541e$export$a657fb0465de0b9e = {
    name: 'software-timeline-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline/embed'
};

});


parcelRegister("9a57v", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineRouteEntry", () => $798468981662af3c$export$ace6a996c7e99f3);

var $euxye = parcelRequire("euxye");

var $51vnM = parcelRequire("51vnM");


var $9T5Cr = parcelRequire("9T5Cr");

var $cLdvY = parcelRequire("cLdvY");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $bMMFU = parcelRequire("bMMFU");

var $hbcoO = parcelRequire("hbcoO");

var $7xkRt = parcelRequire("7xkRt");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $8HUuJ = parcelRequire("8HUuJ");

var $gZWlI = parcelRequire("gZWlI");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $eQdmW = parcelRequire("eQdmW");
const $798468981662af3c$export$ace6a996c7e99f3 = (0, $fdS54.createEntry)((0, $hbcoO.softwareTimelineRoute), ()=>({
        group: 'software',
        skeleton: (0, $i860n.fg)('timeline_skeleton_update') ? $798468981662af3c$var$SoftwareTimelineSkeleton : (0, $7xkRt.RoadmapSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $3eysO.softwareProjectLayoutCode), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)((0, $i860n.fg)('navx-global-side-nav') ? {
                isUsingSidebarEntrypoint: true
            } : undefined),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false), (0, $bMMFU.nextGenRoadmapResource)),
            (0, $gZWlI.projectThemeResource),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('ai_sprint_goal_gate'), (0, $cLdvY.aiEntitlementResource)),
            (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira_software_timeline_perf_improvements') && (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false), (0, $9T5Cr.fieldsResource))
        ],
        preloadOptions: {
            earlyChunks: !(0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? [
                'software-roadmap-early-entry'
            ] : []
        },
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        entryPoint: ()=>{
            const [harmonisedEP, softwareEP] = (0, $i860n.fg)('navx-global-side-nav') ? [
                (0, $eQdmW.GSNSoftwareHarmonisedTimelinePageEntrypoint),
                (0, $eQdmW.GSNSoftwareTimelinePageEntrypoint)
            ] : [
                (0, $eQdmW.softwareHarmonisedTimelinePageEntrypoint),
                (0, $eQdmW.softwareTimelinePageEntrypoint)
            ];
            return (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? harmonisedEP : softwareEP;
        },
        ufoName: (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? 'software.timeline-view' : 'next-gen-roadmap',
        supportsPreviewPanel: true,
        supportsProjectTheme: (0, $2700E.expVal)('jira_timeline_harmonisation_m3', 'isEnabled', false) ? 'full' : 'contoured',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));
const $798468981662af3c$var$SoftwareTimelineSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $798468981662af3c$var$timelineSkeletonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7xkRt.RoadmapSkeleton), null));
$798468981662af3c$var$SoftwareTimelineSkeleton.displayName = "SoftwareTimelineSkeleton";
const $798468981662af3c$var$timelineSkeletonContainerStyles = (0, $fbAgj.xcss)({
    height: '100%',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.large',
    overflow: 'hidden'
});

});
parcelRegister("hbcoO", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineRoute", () => $6ee6951d435c7aea$export$d25dafcda96d5af9);
const $6ee6951d435c7aea$export$d25dafcda96d5af9 = {
    name: 'software-timeline',
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline/:viewId?'
};

});

parcelRegister("eQdmW", function(module, exports) {
$parcel$export(module.exports, "softwareTimelinePageEntrypoint", () => $2a6d67b8254cd452$export$3315ee4fac32ee8);
$parcel$export(module.exports, "GSNSoftwareTimelinePageEntrypoint", () => $2a6d67b8254cd452$export$482f2a3e0e07765b);
$parcel$export(module.exports, "softwareHarmonisedTimelinePageEntrypoint", () => $2a6d67b8254cd452$export$f20e0eee7b207ac6);
$parcel$export(module.exports, "GSNSoftwareHarmonisedTimelinePageEntrypoint", () => $2a6d67b8254cd452$export$2946887f7c24ea8d);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $77OhI = parcelRequire("77OhI");

var $9Gk3S = parcelRequire("9Gk3S");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $iHNG5 = parcelRequire("iHNG5");

var $dBNbj = parcelRequire("dBNbj");

var $eDEQ5 = parcelRequire("eDEQ5");
const $2a6d67b8254cd452$var$pageEntryPointConfig = {
    main: (0, $9Gk3S.softwareTimelineEntrypoint),
    leftSidebar: {
        sidebar: (0, $iHNG5.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
};
const $2a6d67b8254cd452$var$GSNPageEntryPointConfig = {
    main: (0, $9Gk3S.softwareTimelineEntrypoint),
    leftSidebar: {
        sidebar: (0, $eDEQ5.gsnSidebarContentEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $dBNbj.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
};
const $2a6d67b8254cd452$export$3315ee4fac32ee8 = (0, $dTa0V.createPageEntryPoint)($2a6d67b8254cd452$var$pageEntryPointConfig);
const $2a6d67b8254cd452$export$482f2a3e0e07765b = (0, $dTa0V.createPageEntryPoint)($2a6d67b8254cd452$var$GSNPageEntryPointConfig);
const $2a6d67b8254cd452$export$f20e0eee7b207ac6 = (0, $dTa0V.createPageEntryPoint)({
    ...$2a6d67b8254cd452$var$pageEntryPointConfig,
    main: (0, $77OhI.softwareTimelineEntrypoint)
});
const $2a6d67b8254cd452$export$2946887f7c24ea8d = (0, $dTa0V.createPageEntryPoint)({
    ...$2a6d67b8254cd452$var$GSNPageEntryPointConfig,
    main: (0, $77OhI.softwareTimelineEntrypoint)
});

});
parcelRegister("9Gk3S", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineEntrypoint", () => $0197679970b701c0$export$85a905c235ac34bb);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $0197679970b701c0$export$85a905c235ac34bb = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("1f4vm")), {
        moduleId: "05c5207a",
        moduleName: "NextGenExportedDefault",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("g4jM1", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailEmbedRouteEntry", () => $068ae8da19eded3b$export$83102a6097008c79);

var $74oEx = parcelRequire("74oEx");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $qcmrK = parcelRequire("qcmrK");

var $f5UUA = parcelRequire("f5UUA");

var $cQZw0 = parcelRequire("cQZw0");

var $01ESl = parcelRequire("01ESl");
const $068ae8da19eded3b$export$83102a6097008c79 = (0, $fdS54.createEntry)((0, $f5UUA.softwareVersionDetailEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page-embed',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $01ESl.VersionDetailPage),
        skeleton: (0, $cQZw0.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $QhQu4.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $qcmrK.versionDetailsRelayResourceCustom),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        forPaint: [
            (0, $01ESl.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-version-detail-embed'),
                teamName: 'a4t-pandora'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("qcmrK", function(module, exports) {
$parcel$export(module.exports, "versionDetailsRelayResourceCustom", () => $b936172605dd2ce4$export$c56c5b19da4d0fd1);
/* eslint-disable jira/import-whitelist */ 
var $n67Vb = parcelRequire("n67Vb");

var $fOKvg = parcelRequire("fOKvg");

var $052eo = parcelRequire("052eo");

var $2zU0a = parcelRequire("2zU0a");

var $2700E = parcelRequire("2700E");

var $aI7em = parcelRequire("aI7em");

var $5SJ3N = parcelRequire("5SJ3N");

var $htsFl = parcelRequire("htsFl");

var $bkoMj = parcelRequire("bkoMj");

var $7edbf = parcelRequire("7edbf");

var $bN2qP = parcelRequire("bN2qP");
const $b936172605dd2ce4$var$RESOURCE_TYPE_PROJECTS_VERSION_DETAILS = 'PROJECTS_VERSION_DETAILS';
const $b936172605dd2ce4$export$c56c5b19da4d0fd1 = (0, $7edbf.createResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${$b936172605dd2ce4$var$RESOURCE_TYPE_PROJECTS_VERSION_DETAILS}`,
    // Deliberately returning the static key, not to rerun query by resource, as different key returns null queryReference shortly while the query is running, when filter query parameter is changed,
    // which is believed to be a bug in react-resource-router part, but we don't know the reason yet.
    // Context: https://atlassian.slack.com/archives/CFLN3FEF8/p1680495188086669
    // Due to the same bug, issue navigator team is doing the similar technique: src/packages/platform/routes/src/ui/spa/issue-navigator/resources/index.tsx
    getKey: ({ match: match })=>{
        const { versionId: versionId } = match.params;
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { versionId: versionId, projectKey: projectKey } = match.params;
        const { filters: filters, sortBy: sortBy } = (0, $bkoMj.toVersionIssuesGraphQLVariables)(query);
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        const queryReference = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $bN2qP.default), {
            cloudAri: (0, $2zU0a.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: tenantContext.cloudId
            }),
            versionAri: (0, $2zU0a.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'version/activation',
                resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
            }),
            sortBy: sortBy,
            filters: filters,
            skip: !(0, $fOKvg.checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
            isDevopsFeatureDisabledInFedRamp: (0, $052eo.isDevopsFeatureDisabledInFedRamp)(),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $052eo.isDevopsFeatureDisabledInFedRamp)(),
            cloudId: tenantContext.cloudId,
            projectKey: projectKey || '',
            includeChangeHistory: (0, $2700E.expValEquals)('release_change_history_enabled', 'isEnabled', true)
        }, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("bkoMj", function(module, exports) {
$parcel$export(module.exports, "toVersionIssuesGraphQLVariables", () => $55b8e7053bc70dd1$export$72df1c7780b3e8e2);
$parcel$export(module.exports, "useVersionIssuesGraphQLVariables", () => $55b8e7053bc70dd1$export$3d12d3ffbce57135);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iCfie = parcelRequire("iCfie");


var $jLJIt = parcelRequire("jLJIt");

var $1fgjf = parcelRequire("1fgjf");
const $55b8e7053bc70dd1$var$accountIdToAriStr = (accountIds)=>{
    if (accountIds == null) return null;
    return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
};
const $55b8e7053bc70dd1$export$72df1c7780b3e8e2 = (queryParams)=>{
    const parsedQueryParams = (0, $1fgjf.parseQueryParams)(queryParams);
    return {
        filters: {
            searchStr: parsedQueryParams[0, $2691ec913484acf5$export$e39925d10cebc0b] ?? null,
            epicIds: parsedQueryParams[0, $2691ec913484acf5$export$b98a7875ddbefaac] ?? null,
            statusCategories: parsedQueryParams[0, $2691ec913484acf5$export$c307007520232013] != null ? parsedQueryParams[0, $2691ec913484acf5$export$c307007520232013].filter((0, $jLJIt.isVersionStatusCategory)) : null,
            warningCategories: parsedQueryParams[0, $2691ec913484acf5$export$2552faed9df6a2cd] ?? null,
            assigneeAccountIds: $55b8e7053bc70dd1$var$accountIdToAriStr(parsedQueryParams[0, $2691ec913484acf5$export$f78d8c81fcad32a2])
        },
        sortBy: {
            sortByField: parsedQueryParams[0, $2691ec913484acf5$export$13d5b2891ca65cd6] ?? 'CREATED',
            order: parsedQueryParams[0, $2691ec913484acf5$export$810a1f7ed2facfcb] ?? 'ASC'
        }
    };
};
const $55b8e7053bc70dd1$export$3d12d3ffbce57135 = ()=>{
    const [queryParams] = (0, $iCfie.useQueryParams)((0, $2691ec913484acf5$export$e39925d10cebc0b), (0, $2691ec913484acf5$export$b98a7875ddbefaac), (0, $2691ec913484acf5$export$c307007520232013), (0, $2691ec913484acf5$export$2552faed9df6a2cd), (0, $2691ec913484acf5$export$f78d8c81fcad32a2), (0, $2691ec913484acf5$export$13d5b2891ca65cd6), (0, $2691ec913484acf5$export$810a1f7ed2facfcb));
    return $55b8e7053bc70dd1$export$72df1c7780b3e8e2(queryParams);
};

});
parcelRegister("iCfie", function(module, exports) {
$parcel$export(module.exports, "useQueryParams", () => $d1c6a6591598859b$export$b37ee0d76c6d2fbc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $WqSvO = parcelRequire("WqSvO");

var $3irVK = parcelRequire("3irVK");

var $bS1iz = parcelRequire("bS1iz");

var $7Cd1x = parcelRequire("7Cd1x");

var $bc9Gj = parcelRequire("bc9Gj");
const $d1c6a6591598859b$export$b37ee0d76c6d2fbc = (...unstableQueryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $bc9Gj.useRouter)();
    const queryParamsRef = (0, $euxye.useRef)({});
    // ensure queryParamsToWatch is not a new array on every invocation
    const queryParamsToWatch = (0, $7Cd1x.useShallowStableReference)(unstableQueryParamsToWatch);
    const parsedQueryParams = (0, $euxye.useMemo)(()=>{
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $euxye.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

/* eslint-disable jira/filename-case */ const $2691ec913484acf5$export$e39925d10cebc0b = 'text';
const $2691ec913484acf5$export$b98a7875ddbefaac = 'epics';
const $2691ec913484acf5$export$c307007520232013 = 'statusCategory';
const $2691ec913484acf5$export$2552faed9df6a2cd = 'warnings';
const $2691ec913484acf5$export$f78d8c81fcad32a2 = 'assignee';
const $2691ec913484acf5$export$13d5b2891ca65cd6 = 'sortBy';
const $2691ec913484acf5$export$810a1f7ed2facfcb = 'sortOrder';

parcelRegister("jLJIt", function(module, exports) {
$parcel$export(module.exports, "isWarningsFilterValue", () => $52d1ad9263de9fe1$export$5c25bcf27380084);
$parcel$export(module.exports, "toWarningsFilterValue", () => $52d1ad9263de9fe1$export$ac3017cd78edb8a1);
$parcel$export(module.exports, "isVersionStatusCategory", () => $52d1ad9263de9fe1$export$3af93bbba0d4241a);
$parcel$export(module.exports, "isSortBy", () => $52d1ad9263de9fe1$export$472650e4cbd40b70);
$parcel$export(module.exports, "isSortOrder", () => $52d1ad9263de9fe1$export$dfece8cb679d32a3);
/* eslint-disable jira/filename-case */ 
var $10Vo7 = parcelRequire("10Vo7");
const $52d1ad9263de9fe1$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
const $52d1ad9263de9fe1$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($52d1ad9263de9fe1$export$5c25bcf27380084);
const $52d1ad9263de9fe1$export$3af93bbba0d4241a = (val)=>val === (0, $10Vo7.TODO) || val === (0, $10Vo7.IN_PROGRESS) || val === (0, $10Vo7.DONE);
const $52d1ad9263de9fe1$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
const $52d1ad9263de9fe1$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';

});
parcelRegister("10Vo7", function(module, exports) {
$parcel$export(module.exports, "UNDEFINED", () => $e950bdb0fb2f6aca$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e950bdb0fb2f6aca$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e950bdb0fb2f6aca$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e950bdb0fb2f6aca$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e950bdb0fb2f6aca$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e950bdb0fb2f6aca$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e950bdb0fb2f6aca$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e950bdb0fb2f6aca$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e950bdb0fb2f6aca$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e950bdb0fb2f6aca$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e950bdb0fb2f6aca$export$d928f247c903643a);
/* eslint-disable jira/filename-case */ const $e950bdb0fb2f6aca$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e950bdb0fb2f6aca$export$aa456a5030160740 = 'TODO';
const $e950bdb0fb2f6aca$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e950bdb0fb2f6aca$export$71efb3495f6084f2 = 'DONE';
const $e950bdb0fb2f6aca$export$d9119300f9d9a815 = [
    $e950bdb0fb2f6aca$export$6db089fe7b26f5b6,
    $e950bdb0fb2f6aca$export$aa456a5030160740,
    $e950bdb0fb2f6aca$export$5a9ac66c2785cc13,
    $e950bdb0fb2f6aca$export$71efb3495f6084f2
];
const $e950bdb0fb2f6aca$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e950bdb0fb2f6aca$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e950bdb0fb2f6aca$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e950bdb0fb2f6aca$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e950bdb0fb2f6aca$export$71efb3495f6084f2
    }
];
const $e950bdb0fb2f6aca$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e950bdb0fb2f6aca$export$3f42f49c284d5b58 = Object.freeze({
    [$e950bdb0fb2f6aca$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e950bdb0fb2f6aca$export$5d42a08d46cffe7.NEW]: 2,
    [$e950bdb0fb2f6aca$export$5d42a08d46cffe7.DONE]: 3,
    [$e950bdb0fb2f6aca$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e950bdb0fb2f6aca$export$f3f919dc0f56d9eb = Object.values($e950bdb0fb2f6aca$export$5d42a08d46cffe7);
const $e950bdb0fb2f6aca$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e950bdb0fb2f6aca$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e950bdb0fb2f6aca$export$6db089fe7b26f5b6;
};
const $e950bdb0fb2f6aca$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e950bdb0fb2f6aca$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e950bdb0fb2f6aca$export$d928f247c903643a = (key)=>$e950bdb0fb2f6aca$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("1fgjf", function(module, exports) {
$parcel$export(module.exports, "isAnyFilterApplied", () => $329e5de9fe5bb7fc$export$e6b3ec1d09429da8);
$parcel$export(module.exports, "parseQueryParams", () => $329e5de9fe5bb7fc$export$67c4cee80a3410cd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $jLJIt = parcelRequire("jLJIt");
const $329e5de9fe5bb7fc$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $2691ec913484acf5$export$e39925d10cebc0b] != null && parsedQueryParams[0, $2691ec913484acf5$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $2691ec913484acf5$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $2691ec913484acf5$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $2691ec913484acf5$export$c307007520232013] != null && parsedQueryParams[0, $2691ec913484acf5$export$c307007520232013].length > 0 || parsedQueryParams[0, $2691ec913484acf5$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $2691ec913484acf5$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $2691ec913484acf5$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $2691ec913484acf5$export$f78d8c81fcad32a2].length > 0;
const $329e5de9fe5bb7fc$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim());
const $329e5de9fe5bb7fc$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, $jLJIt.isVersionStatusCategory));
const $329e5de9fe5bb7fc$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, $jLJIt.toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
const $329e5de9fe5bb7fc$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim());
const $329e5de9fe5bb7fc$export$67c4cee80a3410cd = (paramsRaw)=>{
    const result = {};
    result[0, $2691ec913484acf5$export$e39925d10cebc0b] = paramsRaw[0, $2691ec913484acf5$export$e39925d10cebc0b];
    result[0, $2691ec913484acf5$export$b98a7875ddbefaac] = $329e5de9fe5bb7fc$export$2a2e94972ab280d4(paramsRaw[0, $2691ec913484acf5$export$b98a7875ddbefaac]);
    result[0, $2691ec913484acf5$export$c307007520232013] = $329e5de9fe5bb7fc$export$fb136b568c6d78b5(paramsRaw[0, $2691ec913484acf5$export$c307007520232013]);
    result[0, $2691ec913484acf5$export$2552faed9df6a2cd] = $329e5de9fe5bb7fc$export$5cb324c621ca24e8(paramsRaw[0, $2691ec913484acf5$export$2552faed9df6a2cd]);
    result[0, $2691ec913484acf5$export$f78d8c81fcad32a2] = $329e5de9fe5bb7fc$export$6c8eda0352c7cf5(paramsRaw[0, $2691ec913484acf5$export$f78d8c81fcad32a2]);
    result[0, $2691ec913484acf5$export$13d5b2891ca65cd6] = paramsRaw[0, $2691ec913484acf5$export$13d5b2891ca65cd6] && (0, $jLJIt.isSortBy)(paramsRaw[0, $2691ec913484acf5$export$13d5b2891ca65cd6]) ? paramsRaw[0, $2691ec913484acf5$export$13d5b2891ca65cd6] : 'CREATED';
    result[0, $2691ec913484acf5$export$810a1f7ed2facfcb] = paramsRaw[0, $2691ec913484acf5$export$810a1f7ed2facfcb] && (0, $jLJIt.isSortOrder)(paramsRaw[0, $2691ec913484acf5$export$810a1f7ed2facfcb]) ? paramsRaw[0, $2691ec913484acf5$export$810a1f7ed2facfcb] : 'ASC';
    return result;
};

});


parcelRegister("bN2qP", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e79a7f6aed0e6f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a91eb5f9fe7e2f70a323ab058e5e38a>>
 * @relayHash 15033d29c4c86816bc2bcac278579aac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bbab77ab04d83bfb1940fc983291b5736e4ecc1bd597b092cec2793c384f8d25
const $5e79a7f6aed0e6f4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bbab77ab04d83bfb1940fc983291b5736e4ecc1bd597b092cec2793c384f8d25",
        "metadata": {},
        "name": "uiVersionDetailsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5e79a7f6aed0e6f4$export$2e2bcd8739ae039 = $5e79a7f6aed0e6f4$var$node;

});


parcelRegister("f5UUA", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailEmbedRoute", () => $6362518f11027a72$export$78d11017d9c9ed74);
const $6362518f11027a72$export$78d11017d9c9ed74 = {
    name: 'software-version-detail-embed',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
    exact: true
};

});

parcelRegister("cQZw0", function(module, exports) {
$parcel$export(module.exports, "VersionDetailSkeleton", () => $96e02cf34c9db7a7$export$b3661a594ba34350);

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $2r82u = parcelRequire("2r82u");
const $96e02cf34c9db7a7$export$b3661a594ba34350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2r82u)))
    });
$96e02cf34c9db7a7$export$b3661a594ba34350.displayName = "VersionDetailSkeleton";

});
parcelRegister("2r82u", function(module, exports) {
module.exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();

});


parcelRegister("01ESl", function(module, exports) {
$parcel$export(module.exports, "LazyVersionDetail", () => $82c88bbc332b04ca$export$2d31f5f47e6584e0);
$parcel$export(module.exports, "VersionDetailPage", () => $82c88bbc332b04ca$export$231cc5186b991031);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $82c88bbc332b04ca$export$2d31f5f47e6584e0 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("5eu3T"))), {
    moduleId: "./src/packages/spa-apps/version-detail/src/VersionDetail.tsx"
});
const $82c88bbc332b04ca$export$231cc5186b991031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $82c88bbc332b04ca$export$2d31f5f47e6584e0,
        pageId: "version-detail",
        shouldShowSpinner: false
    });
$82c88bbc332b04ca$export$231cc5186b991031.displayName = "VersionDetailPage";

});
parcelRegister("5eu3T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("i813I")
]).then(()=>parcelRequire('jXiuX'));

});



parcelRegister("gh7H7", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRouteEntry", () => $96a98e64a684de04$export$f29aafdff734071c);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $lfJqc = parcelRequire("lfJqc");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");

var $01ESl = parcelRequire("01ESl");

var $6afjy = parcelRequire("6afjy");
const $96a98e64a684de04$export$f29aafdff734071c = (0, $fdS54.createEntry)((0, $lfJqc.softwareVersionDetailLegacyRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6afjy.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $01ESl.LazyVersionDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lfJqc", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRoute", () => $ba8a1c34fcc96691$export$3fc8dbcec208bca0);
const $ba8a1c34fcc96691$export$3fc8dbcec208bca0 = {
    name: 'software-version-detail-legacy-redirect',
    path: '/browse/:projectKey/fixforversion/:versionId'
};

});

parcelRegister("6afjy", function(module, exports) {
$parcel$export(module.exports, "VersionDetailPageLegacyRedirect", () => $12a0e2cef0e6f71c$export$8524eef1a0d9339);

var $euxye = parcelRequire("euxye");

var $gNbXR = parcelRequire("gNbXR");
const $12a0e2cef0e6f71c$export$8524eef1a0d9339 = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
    // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
    });
};
$12a0e2cef0e6f71c$export$8524eef1a0d9339.displayName = "VersionDetailPageLegacyRedirect";

});


parcelRegister("7J2Tk", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRouteEntry", () => $0a465864735672a9$export$28d16aae32969765);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $75Njg = parcelRequire("75Njg");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $9v9sQ = parcelRequire("9v9sQ");

var $3eysO = parcelRequire("3eysO");

var $01ESl = parcelRequire("01ESl");

var $6afjy = parcelRequire("6afjy");
const $0a465864735672a9$export$28d16aae32969765 = (0, $fdS54.createEntry)((0, $9v9sQ.softwareVersionDetailNoTabPathRedirectRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $6afjy.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $01ESl.LazyVersionDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("9v9sQ", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRoute", () => $a75ba77879ba4730$export$f22288f2d2f1b9ea);
const $a75ba77879ba4730$export$f22288f2d2f1b9ea = {
    name: 'software-version-detail-no-tab-path',
    path: '/projects/:projectKey/versions/:versionId'
};

});


parcelRegister("4KxZu", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailRouteEntry", () => $8f4844c879b23fca$export$c97dabcfe9d495fa);

var $74oEx = parcelRequire("74oEx");


var $jEYuY = parcelRequire("jEYuY");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $qcmrK = parcelRequire("qcmrK");

var $gvHmz = parcelRequire("gvHmz");

var $cQZw0 = parcelRequire("cQZw0");

var $3eysO = parcelRequire("3eysO");

var $01ESl = parcelRequire("01ESl");
const $8f4844c879b23fca$export$c97dabcfe9d495fa = (0, $fdS54.createEntry)((0, $gvHmz.softwareVersionDetailRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $01ESl.VersionDetailPage),
        skeleton: (0, $cQZw0.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $3eysO.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $qcmrK.versionDetailsRelayResourceCustom),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $01ESl.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))('software-version-detail'),
                teamName: 'a4t-pandora'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gvHmz", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailRoute", () => $625aa3d4dd0e389a$export$eb3633614d0521b0);
const $625aa3d4dd0e389a$export$eb3633614d0521b0 = {
    name: 'software-version-detail',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab'
};

});


parcelRegister("9sZlR", function(module, exports) {
$parcel$export(module.exports, "softwareViewNotFoundClassicRouteEntry", () => $4116e8fb04181e1b$export$191700cbad42b1f0);


var $6tkVZ = parcelRequire("6tkVZ");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $aLcTp = parcelRequire("aLcTp");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");
const $4116e8fb04181e1b$export$191700cbad42b1f0 = (0, $fdS54.createEntry)((0, $aLcTp.softwareViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $6tkVZ.projectViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aLcTp", function(module, exports) {
$parcel$export(module.exports, "softwareViewNotFoundClassicRoute", () => $c64f3ac9a174d66d$export$7d9d54603ab2405d);
const $c64f3ac9a174d66d$export$7d9d54603ab2405d = {
    name: 'software-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/not-found'
};

});


parcelRegister("c1OMN", function(module, exports) {
$parcel$export(module.exports, "softwareViewNotFoundRouteEntry", () => $d5ed33e4a21a3e03$export$7dab5fe9ccb76142);


var $6tkVZ = parcelRequire("6tkVZ");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $1VBUD = parcelRequire("1VBUD");

var $75Njg = parcelRequire("75Njg");

var $3eysO = parcelRequire("3eysO");
const $d5ed33e4a21a3e03$export$7dab5fe9ccb76142 = (0, $fdS54.createEntry)((0, $1VBUD.softwareViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $3eysO.softwareProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $6tkVZ.projectViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1VBUD", function(module, exports) {
$parcel$export(module.exports, "softwareViewNotFoundRoute", () => $eae185446e0a490d$export$d72ea457f192511a);
const $eae185446e0a490d$export$d72ea457f192511a = {
    name: 'software-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/not-found'
};

});


parcelRegister("kmqxP", function(module, exports) {
$parcel$export(module.exports, "syncWaitRouteEntry", () => $ed0af0acaf885d97$export$b9a35c0dabc34735);

var $l3sSQ = parcelRequire("l3sSQ");

var $dTa0V = parcelRequire("dTa0V");

var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $7Y8ox = parcelRequire("7Y8ox");
const $ed0af0acaf885d97$var$syncWaitEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $7Y8ox.syncWaitPageEntryPoint)
});
const $ed0af0acaf885d97$export$b9a35c0dabc34735 = (0, $fdS54.createEntry)((0, $l3sSQ.syncWaitRoute), ()=>({
        layout: (0, $byMD7.chromelessLayout),
        entryPoint: ()=>$ed0af0acaf885d97$var$syncWaitEntryPoint,
        bifrost: {
            bifrostGroup: 'shell-only',
            enabled: true
        }
    }));

});
parcelRegister("l3sSQ", function(module, exports) {
$parcel$export(module.exports, "syncWaitRoute", () => $cdb149c457a8e9f2$export$707a22f9ec0ddf1d);
const $cdb149c457a8e9f2$export$707a22f9ec0ddf1d = {
    name: 'sync-wait',
    path: '/jira/sync-wait',
    exact: true
};

});

parcelRegister("7Y8ox", function(module, exports) {
$parcel$export(module.exports, "syncWaitPageEntryPoint", () => $831924438b297e9b$export$803b0e6c8aa8e101);

var $7NTte = parcelRequire("7NTte");

const $831924438b297e9b$export$803b0e6c8aa8e101 = {
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("1j5gw")), {
        moduleId: "844dd7b6",
        moduleName: "SyncWaitPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {},
            extraProps: {}
        })
};

});
parcelRegister("1j5gw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a9J82").then(()=>parcelRequire('7siq5'));

});



parcelRegister("cDP2z", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationRedirectRouteEntry", () => $b7700a4164694a61$export$7c2e1ea4fc4a192f);
/* eslint-disable import/order */ 


var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $cmvhE = parcelRequire("cmvhE");

var $2imWk = parcelRequire("2imWk");

var $1N8uK = parcelRequire("1N8uK");
const $b7700a4164694a61$export$7c2e1ea4fc4a192f = (0, $fdS54.createEntry)((0, $2imWk.systemConfigurationRedirectRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1N8uK.default),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $cmvhE.systemConfigurationGeneralResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("2imWk", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationRedirectRoute", () => $c7792a7ae1f0a5d1$export$fe4807c49c838619);
const $c7792a7ae1f0a5d1$export$fe4807c49c838619 = {
    name: 'system-configuration-general-redirect',
    path: '/secure/admin/ViewApplicationProperties.jspa',
    exact: true
};

});

parcelRegister("1N8uK", function(module, exports) {
$parcel$export(module.exports, "default", () => $a241bb2c231af1fb$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dLVGe = parcelRequire("dLVGe");
const $a241bb2c231af1fb$var$SystemConfigurationGeneralRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dLVGe.ScreenRedirect), {
        to: "/jira/settings/system/general-configuration"
    });
$a241bb2c231af1fb$var$SystemConfigurationGeneralRedirect.displayName = "SystemConfigurationGeneralRedirect";
var $a241bb2c231af1fb$export$2e2bcd8739ae039 = $a241bb2c231af1fb$var$SystemConfigurationGeneralRedirect;

});


parcelRegister("gSK8t", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationRouteEntry", () => $50ba4adfe653efeb$export$360a82088f35f2f);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $cmvhE = parcelRequire("cmvhE");

var $gpXME = parcelRequire("gpXME");

var $35eqr = parcelRequire("35eqr");

var $1hTw9 = parcelRequire("1hTw9");
const $50ba4adfe653efeb$export$360a82088f35f2f = (0, $fdS54.createEntry)((0, $gpXME.systemConfigurationRoute), ()=>({
        group: 'global-settings',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1hTw9.default),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $cmvhE.systemConfigurationGeneralResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $1hTw9.LazySystemConfigurationGeneral)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gpXME", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationRoute", () => $c4c3949a6fac3cd4$export$6823cb5626e61bc7);
const $c4c3949a6fac3cd4$export$6823cb5626e61bc7 = {
    name: 'system-configuration-general',
    path: '/jira/settings/system/general-configuration',
    exact: true
};

});

parcelRegister("1hTw9", function(module, exports) {
$parcel$export(module.exports, "LazySystemConfigurationGeneral", () => $3f9a053bfbbd0467$export$c452a8c622781ccd);
$parcel$export(module.exports, "default", () => $3f9a053bfbbd0467$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $3f9a053bfbbd0467$export$c452a8c622781ccd = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("bjlCW"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-system-configuration-general/src/SystemConfigurationGeneralSwitcher.tsx"
});
const $3f9a053bfbbd0467$var$AsyncSystemConfigurationGeneral = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $3f9a053bfbbd0467$export$c452a8c622781ccd,
        pageId: "system-configuration-general",
        shouldShowSpinner: false
    });
$3f9a053bfbbd0467$var$AsyncSystemConfigurationGeneral.displayName = "AsyncSystemConfigurationGeneral";
var $3f9a053bfbbd0467$export$2e2bcd8739ae039 = $3f9a053bfbbd0467$var$AsyncSystemConfigurationGeneral;

});
parcelRegister("bjlCW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7tYJg").then(()=>parcelRequire('ksKep'));

});



parcelRegister("31KZb", function(module, exports) {
$parcel$export(module.exports, "systemDashboardEditRouteEntry", () => $9164d2c3c3e7f6e4$export$15f76f1b0d2d671);
/* eslint-disable import/order */ 


var $dv1xk = parcelRequire("dv1xk");

var $jEYuY = parcelRequire("jEYuY");

var $3TTqW = parcelRequire("3TTqW");

var $3HYSN = parcelRequire("3HYSN");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $h70qU = parcelRequire("h70qU");

var $cHkmB = parcelRequire("cHkmB");
const $9164d2c3c3e7f6e4$export$15f76f1b0d2d671 = (0, $fdS54.createEntry)((0, $h70qU.systemDashboardEditRoute), ()=>({
        group: 'dashboard',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $cHkmB.SystemDashboardEditPage),
        layout: (0, $QhQu4.composeLayouts)((0, $ju22D.globalSettingsLayout), (0, $3TTqW.dashboardBackgroundScriptsLayout)),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            // IMPORTANT - SSR requires wrm resource must come first
            ...(0, $cHkmB.dashboardResources)(),
            (0, $dv1xk.gadgetDirectoryResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $cHkmB.LazySystemDashboardEdit),
            (0, $cHkmB.LazyForPaintBackgroundScripts),
            (0, $cHkmB.LazyForPaintConnectJsApi)
        ],
        earlyAssets: (0, $3HYSN.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("h70qU", function(module, exports) {
$parcel$export(module.exports, "systemDashboardEditRoute", () => $1d8c024aaf0f84f6$export$7367fb465296c7dd);
const $1d8c024aaf0f84f6$export$7367fb465296c7dd = {
    name: 'system-dashboard-edit',
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});


parcelRegister("4nWrk", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationCreateRouteEntry", () => $bbc0dd15d074b089$export$83aea99d18750f08);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jLaIf = parcelRequire("jLaIf");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $gv0py = parcelRequire("gv0py");

var $laTv7 = parcelRequire("laTv7");

var $bPbSe = parcelRequire("bPbSe");

var $lfcZt = parcelRequire("lfcZt");
const $bbc0dd15d074b089$export$83aea99d18750f08 = (0, $fdS54.createEntry)((0, $gv0py.teamIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        layout: (0, $iQGmB.opsTeamLayout),
        slot: (0, $bPbSe.IntegrationCreate),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $jLaIf.resources).configuredIntegrationsResource,
            (0, $jLaIf.resources).integrationListResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("gv0py", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationCreateRoute", () => $033ec8aee10dcd3f$export$a2ec7da6c43acbbf);
const $033ec8aee10dcd3f$export$a2ec7da6c43acbbf = {
    name: 'eoc-team-integration-create',
    path: '/jira/ops/teams/:teamId/integrations/create/:type',
    exact: true
};

});


parcelRegister("9OXJj", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationDetailRouteEntry", () => $59df261d7e812f14$export$7e0b6b79953422c1);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jLaIf = parcelRequire("jLaIf");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $3gzsA = parcelRequire("3gzsA");

var $laTv7 = parcelRequire("laTv7");

var $4IADZ = parcelRequire("4IADZ");

var $lfcZt = parcelRequire("lfcZt");
const $59df261d7e812f14$export$7e0b6b79953422c1 = (0, $fdS54.createEntry)((0, $3gzsA.teamIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        layout: (0, $iQGmB.opsTeamLayout),
        slot: (0, $4IADZ.IntegrationDetail),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $jLaIf.resources).configuredIntegrationsResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("3gzsA", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationDetailRoute", () => $71bd86d9cc29b45a$export$72169399df792b7c);
const $71bd86d9cc29b45a$export$72169399df792b7c = {
    name: 'eoc-team-integration-detail',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
    exact: true
};

});


parcelRegister("g0u6h", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationListRouteEntry", () => $e26473997a1461a1$export$52ee366e7b51f38d);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jLaIf = parcelRequire("jLaIf");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $f7RYh = parcelRequire("f7RYh");

var $laTv7 = parcelRequire("laTv7");

var $hHvyy = parcelRequire("hHvyy");

var $lfcZt = parcelRequire("lfcZt");
const $e26473997a1461a1$export$52ee366e7b51f38d = (0, $fdS54.createEntry)((0, $f7RYh.teamIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        layout: (0, $iQGmB.opsTeamLayout),
        slot: (0, $hHvyy.IntegrationList),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $jLaIf.resources).integrationListResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("f7RYh", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationListRoute", () => $fe86632f1857e62f$export$b8218f375778e6d7);
const $fe86632f1857e62f$export$b8218f375778e6d7 = {
    name: 'eoc-team-integration-list',
    path: '/jira/ops/teams/:teamId/integrations/list',
    exact: true
};

});


parcelRegister("6dCix", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationLogRouteEntry", () => $ea759755b4006be9$export$d5e169223d2a5d1d);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $835qG = parcelRequire("835qG");

var $jLaIf = parcelRequire("jLaIf");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $lzXq6 = parcelRequire("lzXq6");

var $laTv7 = parcelRequire("laTv7");

var $9PvxW = parcelRequire("9PvxW");

var $lfcZt = parcelRequire("lfcZt");
const $ea759755b4006be9$export$d5e169223d2a5d1d = (0, $fdS54.createEntry)((0, $lzXq6.teamIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        slot: (0, $9PvxW.IntegrationLog),
        layout: (0, $iQGmB.opsTeamLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            ...(0, $835qG.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $jLaIf.resources).configuredIntegrationsResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("lzXq6", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationLogRoute", () => $51962f345b29d466$export$ca02d7b2c7df3d60);
const $51962f345b29d466$export$ca02d7b2c7df3d60 = {
    name: 'eoc-team-integration-log',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
    exact: true
};

});


parcelRegister("eJhl7", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationsRouteEntry", () => $39136ab2fe07766d$export$ded9494f81dd2a4d);


var $2PaMI = parcelRequire("2PaMI");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $jLaIf = parcelRequire("jLaIf");

var $7EF5l = parcelRequire("7EF5l");

var $jEYuY = parcelRequire("jEYuY");

var $jyp1t = parcelRequire("jyp1t");

var $iQGmB = parcelRequire("iQGmB");

var $fdS54 = parcelRequire("fdS54");

var $akOnU = parcelRequire("akOnU");

var $laTv7 = parcelRequire("laTv7");

var $lfcZt = parcelRequire("lfcZt");
const $39136ab2fe07766d$export$ded9494f81dd2a4d = (0, $fdS54.createEntry)((0, $akOnU.teamIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $laTv7.IntegrationAutomation),
        layout: (0, $iQGmB.opsTeamLayout),
        slot: null,
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $7EF5l.resources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $jLaIf.resources).configuredIntegrationsResource,
            (0, $jLaIf.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $c2089d0a2d032c78$export$18c48dc6584a0abb),
            horizontal: (0, $2PaMI.AsyncHorizontalOperationsNav)
        },
        forPaint: [
            (0, $2PaMI.LazyHorizontalOperationsNav),
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $lfcZt.LazyIntegrationAutomation),
            (0, $jyp1t.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("akOnU", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationsRoute", () => $7ef7dbfdf1131cf2$export$400ead354c81dee3);
const $7ef7dbfdf1131cf2$export$400ead354c81dee3 = {
    name: 'eoc-team-integrations',
    path: '/jira/ops/teams/:teamId/integrations',
    exact: true
};

});


parcelRegister("hPa8K", function(module, exports) {
$parcel$export(module.exports, "trashedPlanDirectLinkRouteEntry", () => $30b31115331c5e30$export$dbcd0bd16f12397d);
/* eslint-disable import/order */ 
var $jEYuY = parcelRequire("jEYuY");

var $h2tgz = parcelRequire("h2tgz");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $5mCrV = parcelRequire("5mCrV");

var $62yrf = parcelRequire("62yrf");
const $30b31115331c5e30$export$dbcd0bd16f12397d = (0, $fdS54.createEntry)((0, $5mCrV.trashedPlanDirectLinkRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $62yrf.TrashedPlanDirectLink),
        layout: (0, $h2tgz.globalLayout),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $62yrf.LazyTrashedPlanDirectLink)
        ],
        ufoName: 'plan-trashed',
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5mCrV", function(module, exports) {
$parcel$export(module.exports, "trashedPlanDirectLinkRoute", () => $dd56d97d1ce0b188$export$1a9edb72cd49ca79);
const $dd56d97d1ce0b188$export$1a9edb72cd49ca79 = {
    name: 'trashed-plan-direct-link',
    path: '/jira/plans/plan-trashed',
    exact: true
};

});

parcelRegister("62yrf", function(module, exports) {
$parcel$export(module.exports, "LazyTrashedPlanDirectLink", () => $d973cd1dd242960f$export$20a71ac28e6a3c8f);
$parcel$export(module.exports, "TrashedPlanDirectLink", () => $d973cd1dd242960f$export$38f3a061bb1fceee);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $d973cd1dd242960f$export$20a71ac28e6a3c8f = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("5ghYE"))), {
    moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
});
const $d973cd1dd242960f$export$38f3a061bb1fceee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $d973cd1dd242960f$export$20a71ac28e6a3c8f,
        pageId: "trashed-plan-direct-link",
        shouldShowSpinner: false
    });
$d973cd1dd242960f$export$38f3a061bb1fceee.displayName = "TrashedPlanDirectLink";

});
parcelRegister("5ghYE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6rCPS").then(()=>parcelRequire('kYqKY'));

});



parcelRegister("j0nUp", function(module, exports) {
$parcel$export(module.exports, "trashPlansRouteEntry", () => $08e388a94b8ffce8$export$eabcbe4dd6fc9f1f);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $4NdxQ = parcelRequire("4NdxQ");

var $5dVoV = parcelRequire("5dVoV");
const $08e388a94b8ffce8$export$eabcbe4dd6fc9f1f = (0, $fdS54.createEntry)((0, $4NdxQ.trashPlansRoute), ()=>({
        group: 'software',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $5dVoV.TrashedPlansDirectory),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $5dVoV.LazyTrashedPlans)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4NdxQ", function(module, exports) {
$parcel$export(module.exports, "trashPlansRoute", () => $6bc62d2f16fc8ce9$export$6f5b50c5dc090fd1);
const $6bc62d2f16fc8ce9$export$6f5b50c5dc090fd1 = {
    name: 'trash-plans-directory',
    path: '/jira/plans/settings/trash',
    exact: true
};

});

parcelRegister("5dVoV", function(module, exports) {
$parcel$export(module.exports, "LazyTrashedPlans", () => $6b08be6cbdf350cb$export$6ac18b311b7e51a1);
$parcel$export(module.exports, "TrashedPlansDirectory", () => $6b08be6cbdf350cb$export$b145fa65818ff157);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $6b08be6cbdf350cb$export$6ac18b311b7e51a1 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("adh39")).then((module)=>module.TrashedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages-trashed-plans/src/TrashedPlans.tsx"
});
const $6b08be6cbdf350cb$export$b145fa65818ff157 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $6b08be6cbdf350cb$export$6ac18b311b7e51a1,
        pageId: "trashed-plans",
        shouldShowSpinner: true
    });
$6b08be6cbdf350cb$export$b145fa65818ff157.displayName = "TrashedPlansDirectory";

});
parcelRegister("adh39", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4O1g3")
]).then(()=>parcelRequire('gpjh8'));

});



parcelRegister("dKwf4", function(module, exports) {
$parcel$export(module.exports, "trashProjectsDirectoryRedirectRouteEntry", () => $f7ede5efbf9e885f$export$8ea64bac0a832a5c);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $01xgR = parcelRequire("01xgR");

var $1D1Wc = parcelRequire("1D1Wc");

var $eImnW = parcelRequire("eImnW");
const $f7ede5efbf9e885f$export$8ea64bac0a832a5c = (0, $fdS54.createEntry)((0, $01xgR.trashProjectsDirectoryRedirectRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1D1Wc.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $3be6781b85030612$export$e3e768cbcc0eeacd),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eImnW.LazyTrashedProjectsAdmin)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("01xgR", function(module, exports) {
$parcel$export(module.exports, "trashProjectsDirectoryRedirectRoute", () => $c57e3b0a79ddffab$export$6eafffd4489b3d4);
const $c57e3b0a79ddffab$export$6eafffd4489b3d4 = {
    name: 'trash-projects-directory',
    path: '/secure/projects/trash',
    exact: true
};

});

parcelRegister("1D1Wc", function(module, exports) {
$parcel$export(module.exports, "default", () => $67cd756d20e4e561$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");

var $gNbXR = parcelRequire("gNbXR");
const $67cd756d20e4e561$var$RedirectToPrettyUrlTrashDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceType: (0, $46f069e6c968f461$export$f636b5b56f1d624a),
        sourceName: "projectsTrashRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNbXR.Redirect), {
        to: "/jira/settings/projects/trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null));
$67cd756d20e4e561$var$RedirectToPrettyUrlTrashDirectory.displayName = "RedirectToPrettyUrlTrashDirectory";
var $67cd756d20e4e561$export$2e2bcd8739ae039 = $67cd756d20e4e561$var$RedirectToPrettyUrlTrashDirectory;

});

parcelRegister("eImnW", function(module, exports) {
$parcel$export(module.exports, "LazyTrashedProjectsAdmin", () => $23b5bdcd0837bdcd$export$dd65a8ee0a9ac24f);
$parcel$export(module.exports, "default", () => $23b5bdcd0837bdcd$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $23b5bdcd0837bdcd$export$dd65a8ee0a9ac24f = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("htSF8"))), {
    moduleId: "./src/packages/spa-apps/admin-pages-trashed-projects/src/TrashedProjectsAdminType.tsx"
});
const $23b5bdcd0837bdcd$var$AsyncTrashedProjectsAdmin = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $23b5bdcd0837bdcd$export$dd65a8ee0a9ac24f,
        pageId: "trashed-projects",
        shouldShowSpinner: true
    });
$23b5bdcd0837bdcd$var$AsyncTrashedProjectsAdmin.displayName = "AsyncTrashedProjectsAdmin";
var $23b5bdcd0837bdcd$export$2e2bcd8739ae039 = $23b5bdcd0837bdcd$var$AsyncTrashedProjectsAdmin;

});
parcelRegister("htSF8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("5QPQ4")
]).then(()=>parcelRequire('aEcD8'));

});



parcelRegister("kR7ka", function(module, exports) {
$parcel$export(module.exports, "trashProjectsDirectoryRouteEntry", () => $82b2adcfc0724b88$export$27d1f352c2f7acae);
/* eslint-disable import/order */ 


var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $5DBJe = parcelRequire("5DBJe");

var $eImnW = parcelRequire("eImnW");
const $82b2adcfc0724b88$export$27d1f352c2f7acae = (0, $fdS54.createEntry)((0, $5DBJe.trashProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $eImnW.default),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $3be6781b85030612$export$e3e768cbcc0eeacd),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $eImnW.LazyTrashedProjectsAdmin)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5DBJe", function(module, exports) {
$parcel$export(module.exports, "trashProjectsDirectoryRoute", () => $3894948050f7695f$export$74ec9fecd42fa96e);
const $3894948050f7695f$export$74ec9fecd42fa96e = {
    name: 'trash-projects-directory',
    path: '/jira/settings/projects/trash',
    exact: true
};

});


parcelRegister("dMhXs", function(module, exports) {
$parcel$export(module.exports, "unlockOperationsRouteEntry", () => $08731950efc10ffd$export$c058f4d1c0667ce1);



var $1BOBA = parcelRequire("1BOBA");

var $dUAVJ = parcelRequire("dUAVJ");

var $jEYuY = parcelRequire("jEYuY");

var $bqxMM = parcelRequire("bqxMM");

var $fdS54 = parcelRequire("fdS54");

var $dqVRd = parcelRequire("dqVRd");

var $92a07 = parcelRequire("92a07");
const $08731950efc10ffd$export$c058f4d1c0667ce1 = (0, $fdS54.createEntry)((0, $dqVRd.unlockOperationsRoute), ()=>({
        group: 'eoc',
        layout: (0, $bqxMM.eocChangeboardingLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $92a07.default),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1BOBA.resources)()
        ],
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727),
            menuId: (0, $57a8d3ee2467d6bc$export$1b6b909295618bea)
        },
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $92a07.LazyUnlockOperations)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("1BOBA", function(module, exports) {
$parcel$export(module.exports, "resources", () => $ba47251997d5d890$export$bc99aaabaf7b70a7);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gIb7y = parcelRequire("gIb7y");
const $ba47251997d5d890$export$bc99aaabaf7b70a7 = ()=>[
        (0, $gIb7y.transitioningDetailsResource)
    ];

});
parcelRegister("gIb7y", function(module, exports) {
$parcel$export(module.exports, "transitioningDetailsResource", () => $7d3108bbd8db5518$export$850d76e0c9ffbdeb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $7d3108bbd8db5518$export$7985153d37586c9a = (cloudId)=>(0, $h2wCv.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getTransitioningDetails',
                packageName: 'jiraRouterResourcesEocUnlockOperations',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $7d3108bbd8db5518$export$850d76e0c9ffbdeb = (0, $7edbf.createResource)({
    type: 'EOC_UNLOCK_OPERATIONS',
    getKey: ()=>'eoc-unlock-operations',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>$7d3108bbd8db5518$export$7985153d37586c9a(cloudId),
    maxAge: 0,
    isBrowserOnly: true
});

});


parcelRegister("dqVRd", function(module, exports) {
$parcel$export(module.exports, "unlockOperationsRoute", () => $f0a4ef587f2c0205$export$30306de7e00bc5a2);
const $f0a4ef587f2c0205$export$30306de7e00bc5a2 = {
    name: 'eoc-unlock-operations',
    path: '/jira/settings/products/ops/unlock',
    exact: true
};

});

parcelRegister("92a07", function(module, exports) {
$parcel$export(module.exports, "LazyUnlockOperations", () => $c85de3a9a1850cb3$export$55e4754d556d072);
$parcel$export(module.exports, "default", () => $c85de3a9a1850cb3$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $c85de3a9a1850cb3$export$55e4754d556d072 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("7NUrh")), {
    moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
});
const $c85de3a9a1850cb3$var$AsyncUnlockOperations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $c85de3a9a1850cb3$export$55e4754d556d072,
        pageId: "eoc-products-unlock-operations",
        shouldShowSpinner: false
    });
$c85de3a9a1850cb3$var$AsyncUnlockOperations.displayName = "AsyncUnlockOperations";
var $c85de3a9a1850cb3$export$2e2bcd8739ae039 = $c85de3a9a1850cb3$var$AsyncUnlockOperations;

});
parcelRegister("7NUrh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("1sdcM")
]).then(()=>parcelRequire('6aEb6'));

});



parcelRegister("d7hDG", function(module, exports) {
$parcel$export(module.exports, "userBoardRouteEntry", () => $fb437818564c2292$export$cde4dacc737dc0f1);

var $51vnM = parcelRequire("51vnM");


var $4TFaG = parcelRequire("4TFaG");

var $hRSPo = parcelRequire("hRSPo");

var $5adCU = parcelRequire("5adCU");

var $3HYSN = parcelRequire("3HYSN");

var $dvtoW = parcelRequire("dvtoW");

var $iYidr = parcelRequire("iYidr");

var $ldGfw = parcelRequire("ldGfw");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $QhQu4 = parcelRequire("QhQu4");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");

var $4vnZU = parcelRequire("4vnZU");

var $2bC10 = parcelRequire("2bC10");

var $75Njg = parcelRequire("75Njg");

var $aNuRI = parcelRequire("aNuRI");
const $fb437818564c2292$export$cde4dacc737dc0f1 = (0, $fdS54.createEntry)((0, $4vnZU.userBoardRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $2bC10.ClassicBoardSkeleton),
        layout: (0, $QhQu4.composeLayouts)((0, $dvtoW.genericProjectLayout), (0, $iYidr.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $ldGfw.getIssueViewResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            ...(0, $dUAVJ.getUserBoardNavigationResources)(),
            (0, $8HUuJ.resourceWithCondition)((0, $5adCU.shouldLoadUIFBoardResources), (0, $2DCyG.uifBoardResource)),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $51vnM.LazyIssueApp)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        earlyAssets: (0, $3HYSN.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        entryPoint: ()=>(0, $aNuRI.userBoardPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4vnZU", function(module, exports) {
$parcel$export(module.exports, "userBoardRoute", () => $23ee1f7686338bdf$export$57a2a0fe739f16);
const $23ee1f7686338bdf$export$57a2a0fe739f16 = {
    name: 'rapidboard-user-board',
    path: '/jira/people/:accountId/boards/:boardId'
};

});

parcelRegister("aNuRI", function(module, exports) {
$parcel$export(module.exports, "userBoardPageEntrypoint", () => $2bcf2bbee47d5e97$export$606f36f7912a11ef);

var $hi6Of = parcelRequire("hi6Of");

var $aEPLp = parcelRequire("aEPLp");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");
const $2bcf2bbee47d5e97$export$606f36f7912a11ef = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $aEPLp.nextGenBoardEntryPoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});


parcelRegister("kIN2F", function(module, exports) {
$parcel$export(module.exports, "userBoardSettingsRouteEntry", () => $8ac539be972030e5$export$f8e56ba3f544195d);



var $4TFaG = parcelRequire("4TFaG");

var $hRSPo = parcelRequire("hRSPo");

var $5adCU = parcelRequire("5adCU");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $2DCyG = parcelRequire("2DCyG");

var $8HUuJ = parcelRequire("8HUuJ");

var $bRNr9 = parcelRequire("bRNr9");

var $2bC10 = parcelRequire("2bC10");

var $hO1Vg = parcelRequire("hO1Vg");

var $i860n = parcelRequire("i860n");
const $8ac539be972030e5$export$f8e56ba3f544195d = (0, $fdS54.createEntry)((0, $bRNr9.userBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $2bC10.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $i860n.fg)('navx-global-side-nav') ? (0, $hO1Vg.GSNBoardSettingsPageEntryPoint) : (0, $hO1Vg.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $98344e6aff454659$export$c97893643d53b8ab)
        },
        layout: (0, $dvtoW.genericProjectLayout),
        // This list is based on the resources needed by ./userBoardRouteEntry.tsx
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5adCU.getRapidboardResources)(),
            (0, $5adCU.getRapidBoardDataResource)(),
            ...(0, $dUAVJ.getUserBoardNavigationResources)(),
            (0, $8HUuJ.resourceWithCondition)((0, $5adCU.shouldLoadUIFBoardResources), (0, $2DCyG.uifBoardResource)),
            (0, $hRSPo.getEditModelResource)(),
            (0, $4TFaG.getBoardDetailsResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("bRNr9", function(module, exports) {
$parcel$export(module.exports, "userBoardSettingsRoute", () => $958b716260fef5ce$export$a6e04dfbb956c677);
const $958b716260fef5ce$export$a6e04dfbb956c677 = {
    name: 'rapidboard-user-board-settings',
    path: '/jira/people/:accountId/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});


parcelRegister("fMtz0", function(module, exports) {
$parcel$export(module.exports, "userBoardVelocityRouteEntry", () => $4a67a34bd125fdcd$export$ba0f726701b9e407);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $fdS54 = parcelRequire("fdS54");

var $dUAVJ = parcelRequire("dUAVJ");

var $dvtoW = parcelRequire("dvtoW");

var $5rWtl = parcelRequire("5rWtl");

var $hECVV = parcelRequire("hECVV");
const $4a67a34bd125fdcd$export$ba0f726701b9e407 = (0, $fdS54.createEntry)((0, $5rWtl.userBoardVelocityRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-reports.velocity-report-cmp',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $hECVV.default),
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            ...(0, $dUAVJ.getUserBoardNavigationResources)()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $hECVV.LazyNextGenVelocityReport)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5rWtl", function(module, exports) {
$parcel$export(module.exports, "userBoardVelocityRoute", () => $41cd2b2f28fb625d$export$57431a0e4f3a32e8);
const $41cd2b2f28fb625d$export$57431a0e4f3a32e8 = {
    name: 'software-reports-velocity-user-board',
    path: '/jira/people/:accountId/boards/:boardId/reports/velocity'
};

});

parcelRegister("hECVV", function(module, exports) {
$parcel$export(module.exports, "LazyNextGenVelocityReport", () => $58acaf84fc4479d0$export$a2ca519c668b2f72);
$parcel$export(module.exports, "default", () => $58acaf84fc4479d0$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

var $lenAs = parcelRequire("lenAs");

const $58acaf84fc4479d0$export$a2ca519c668b2f72 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)((parcelRequire("hwfjJ"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports-velocity/src/index-old.tsx"
});
/** @deprecated delete file after all usages have been migrated to use entry points */ const $58acaf84fc4479d0$var$AsyncNextGenVelocityReport = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $58acaf84fc4479d0$export$a2ca519c668b2f72,
        pageId: `next-gen-reports-velocity-${(0, $lenAs.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
$58acaf84fc4479d0$var$AsyncNextGenVelocityReport.displayName = "AsyncNextGenVelocityReport";
var $58acaf84fc4479d0$export$2e2bcd8739ae039 = $58acaf84fc4479d0$var$AsyncNextGenVelocityReport;

});
parcelRegister("hwfjJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d6rXF").then(()=>parcelRequire('5FIlI'));

});



parcelRegister("eBxih", function(module, exports) {
$parcel$export(module.exports, "userBoardViewNotFoundRouteEntry", () => $114e2da90577321f$export$a2bfa34d08651f6d);


var $fLLrQ = parcelRequire("fLLrQ");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $fdS54 = parcelRequire("fdS54");

var $edf7u = parcelRequire("edf7u");

var $dUAVJ = parcelRequire("dUAVJ");

var $hWEkS = parcelRequire("hWEkS");

var $aM7Yq = parcelRequire("aM7Yq");

var $75Njg = parcelRequire("75Njg");
const $114e2da90577321f$export$a2bfa34d08651f6d = (0, $fdS54.createEntry)((0, $aM7Yq.userBoardViewNotFoundRoute), ()=>({
        group: 'classic-software',
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $fLLrQ.boardViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("aM7Yq", function(module, exports) {
$parcel$export(module.exports, "userBoardViewNotFoundRoute", () => $c2b1417a61b30782$export$ad6b96e14e735ed7);
const $c2b1417a61b30782$export$ad6b96e14e735ed7 = {
    name: 'rapidboard-user-board-view-not-found',
    path: '/jira/people/:accountId/boards/:boardId/not-found'
};

});


parcelRegister("b3UlM", function(module, exports) {
$parcel$export(module.exports, "userSegmentationRouteEntry", () => $e977327a9e8bd6b9$export$2af76482b576a135);
/* eslint-disable import/order */ 
var $byMD7 = parcelRequire("byMD7");

var $fdS54 = parcelRequire("fdS54");

var $4yukp = parcelRequire("4yukp");

var $4B518 = parcelRequire("4B518");

var $bSCwb = parcelRequire("bSCwb");
const $e977327a9e8bd6b9$export$2af76482b576a135 = (0, $fdS54.createEntry)((0, $4yukp.userSegmentationRoute), ()=>({
        ufoName: 'user-segmentation',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $bSCwb.UserSegmentation),
        layout: (0, $byMD7.chromelessLayout),
        forPaint: [
            (0, $bSCwb.LazyUserSegmentation)
        ],
        resources: [
            ...(0, $4B518.jiraSpaResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("4yukp", function(module, exports) {
$parcel$export(module.exports, "userSegmentationRoute", () => $53cc953c699b0ca3$export$b0b13170cadf6395);
const $53cc953c699b0ca3$export$b0b13170cadf6395 = {
    name: 'user-segmentation',
    path: '/jira/get-started',
    exact: true
};

});

parcelRegister("bSCwb", function(module, exports) {
$parcel$export(module.exports, "LazyUserSegmentation", () => $d079a25a482e83e9$export$bf9c9e0729c919f5);
$parcel$export(module.exports, "UserSegmentation", () => $d079a25a482e83e9$export$15f8c5ccbb9c7ec3);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jhKsF = parcelRequire("jhKsF");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $d079a25a482e83e9$export$bf9c9e0729c919f5 = (0, $l8G1z.lazyForPaint)(()=>(0, $jhKsF.markAsProductBundleReady)(// eslint-disable-next-line jira/import/file-extension-required
    (parcelRequire("iywXO"))), {
    moduleId: "./src/packages/platform/user-segmentation/src/index.tsx"
});
const $d079a25a482e83e9$export$15f8c5ccbb9c7ec3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $d079a25a482e83e9$export$bf9c9e0729c919f5,
        pageId: "user-segmentation",
        shouldShowSpinner: true
    });
$d079a25a482e83e9$export$15f8c5ccbb9c7ec3.displayName = "UserSegmentation";

});
parcelRegister("iywXO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jubUK").then(()=>parcelRequire('3S9eP'));

});



parcelRegister("1yXFq", function(module, exports) {
$parcel$export(module.exports, "viewIntentRouteEntry", () => $7f61ea7306e7d6f5$export$e693459ab8454027);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 


var $5SA0S = parcelRequire("5SA0S");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $1Os5h = parcelRequire("1Os5h");

var $74h93 = parcelRequire("74h93");

var $eFLx2 = parcelRequire("eFLx2");

var $dTa0V = parcelRequire("dTa0V");

var $1lV4Z = parcelRequire("1lV4Z");
const $7f61ea7306e7d6f5$var$viewIntentPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5SA0S.viewIntentEntryPoint)
});
const $7f61ea7306e7d6f5$export$e693459ab8454027 = (0, $fdS54.createEntry)((0, $1Os5h.viewIntentRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_sd_virtual_agent') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-virtual-service-agent') : (0, $l1vE2.isFedRamp)()) return undefined;
            return $7f61ea7306e7d6f5$var$viewIntentPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1lV4Z.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $eFLx2.VirtualAgentViewIntentSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5SA0S", function(module, exports) {
$parcel$export(module.exports, "viewIntentEntryPoint", () => $8854d7d5edd50907$export$f51df662bd71ce39);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $j2ucF = parcelRequire("j2ucF");

const $8854d7d5edd50907$export$f51df662bd71ce39 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8m11y")), {
        moduleId: "2510e364",
        moduleName: "VirtualAgentViewIntent",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $j2ucF.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        intentId: context.match.params.intentId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("j2ucF", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7603157a72af9ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44e6f8da43c4b543c22e753de5aa8dab>>
 * @relayHash a5ee24692eecbb295447dbf1a5faa141
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed2e77e1b08e7e09103a24100711b8373e8faf27265dcd616a6acf7f9949ce36

var $k49ny = parcelRequire("k49ny");
const $c7603157a72af9ae$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ed2e77e1b08e7e09103a24100711b8373e8faf27265dcd616a6acf7f9949ce36",
        "metadata": {},
        "name": "VirtualAgentViewIntentQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
        }
    }
};
var $c7603157a72af9ae$export$2e2bcd8739ae039 = $c7603157a72af9ae$var$node;

});

parcelRegister("8m11y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("d6m4S")
]).then(()=>parcelRequire('abVIU'));

});


parcelRegister("1Os5h", function(module, exports) {
$parcel$export(module.exports, "viewIntentRoute", () => $aa34dd17f31559dd$export$bf8131fb060d0e73);
const $aa34dd17f31559dd$export$bf8131fb060d0e73 = {
    name: 'project-settings-servicedesk-virtualagent-view-intent',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?'
};

});

parcelRegister("eFLx2", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentViewIntentSkeleton", () => $69d5379b2366c2c9$export$72b20c10a0f18a2f);
/* VirtualAgentViewIntentSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $gfQaN = parcelRequire("gfQaN");
const $69d5379b2366c2c9$var$customCssStyles = null;
const $69d5379b2366c2c9$export$72b20c10a0f18a2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gfQaN))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$69d5379b2366c2c9$export$72b20c10a0f18a2f.displayName = "VirtualAgentViewIntentSkeleton";

});
parcelRegister("gfQaN", function(module, exports) {
module.exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();

});



parcelRegister("jsoqu", function(module, exports) {
$parcel$export(module.exports, "viewStandardFlowRouteEntry", () => $b7fbf56d0e8eabb2$export$84dc2dfc944b0434);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 


var $5x4Jq = parcelRequire("5x4Jq");

var $6RSCO = parcelRequire("6RSCO");

var $lbxXL = parcelRequire("lbxXL");

var $6pofw = parcelRequire("6pofw");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $fdS54 = parcelRequire("fdS54");

var $kJALu = parcelRequire("kJALu");

var $74h93 = parcelRequire("74h93");

var $15Vft = parcelRequire("15Vft");

var $dTa0V = parcelRequire("dTa0V");

var $1lV4Z = parcelRequire("1lV4Z");
const $b7fbf56d0e8eabb2$var$viewStandardFlowPageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $5x4Jq.viewStandardFlowEntryPoint)
});
const $b7fbf56d0e8eabb2$export$84dc2dfc944b0434 = (0, $fdS54.createEntry)((0, $kJALu.viewStandardFlowRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        entryPoint () {
            if ((0, $i860n.fg)('aem_rr_sd_virtual_agent') ? !(0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-virtual-service-agent') : (0, $l1vE2.isFedRamp)()) return undefined;
            return $b7fbf56d0e8eabb2$var$viewStandardFlowPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $1lV4Z.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $15Vft.VirtualAgentViewStandardFlowSkeleton),
        resources: [
            ...(0, $lbxXL.getServiceDeskSettingsResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $6pofw.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                packageName: (0, $6pofw.toPackageName)((0, $6pofw.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("5x4Jq", function(module, exports) {
$parcel$export(module.exports, "viewStandardFlowEntryPoint", () => $f1f0e0f19894d944$export$4fd7bf09308d4abd);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $oELTG = parcelRequire("oELTG");

const $f1f0e0f19894d944$export$4fd7bf09308d4abd = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bF7iO")), {
        moduleId: "23925d2b",
        moduleName: "VirtualAgentViewStandardFlow",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $oELTG.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        flowId: context.match.params.flowId ?? '',
                        offerEscalationEnabled: (0, $i860n.fg)('toggle_offer_escalation_standard_flow_feature') ?? false
                    }
                }
            }
        })
});

});
parcelRegister("oELTG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d57e2e4f610af77d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<86a7ef9967a835af5f26f5a050a9d58b>>
 * @relayHash 4e2dbb7ac42e698d4b8d14f8de008aa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b06dfc4daaafb36a569456905e0b413b020394c237510308dfc32078fbf0646

var $k49ny = parcelRequire("k49ny");
const $d57e2e4f610af77d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2b06dfc4daaafb36a569456905e0b413b020394c237510308dfc32078fbf0646",
        "metadata": {},
        "name": "VirtualAgentViewStandardFlowQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k49ny.default)
        }
    }
};
var $d57e2e4f610af77d$export$2e2bcd8739ae039 = $d57e2e4f610af77d$var$node;

});

parcelRegister("bF7iO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("21IOo")
]).then(()=>parcelRequire('ihDTg'));

});


parcelRegister("kJALu", function(module, exports) {
$parcel$export(module.exports, "viewStandardFlowRoute", () => $0ec4e6c6d19bc95d$export$c74dca8be49046ea);
const $0ec4e6c6d19bc95d$export$c74dca8be49046ea = {
    name: 'project-settings-servicedesk-virtualagent-view-standard-flow',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?'
};

});

parcelRegister("15Vft", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentViewStandardFlowSkeleton", () => $d13e67937dd298f5$export$c6d3f04e6931e3f6);
/* VirtualAgentViewStandardFlowSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $d5ps5 = parcelRequire("d5ps5");

var $9VtTk = parcelRequire("9VtTk");
const $d13e67937dd298f5$var$customCssStyles = null;
const $d13e67937dd298f5$export$c6d3f04e6931e3f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d5ps5.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9VtTk))),
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
$d13e67937dd298f5$export$c6d3f04e6931e3f6.displayName = "VirtualAgentViewStandardFlowSkeleton";

});
parcelRegister("9VtTk", function(module, exports) {
module.exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();

});



parcelRegister("gAkge", function(module, exports) {
$parcel$export(module.exports, "whoIsOnCallRouteEntry", () => $927df813fa5a96f9$export$fee33ca9661e49dd);

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $llbQS = parcelRequire("llbQS");

var $jEYuY = parcelRequire("jEYuY");

var $bqxMM = parcelRequire("bqxMM");

var $fdS54 = parcelRequire("fdS54");

var $47JTY = parcelRequire("47JTY");

var $esUWa = parcelRequire("esUWa");
const $927df813fa5a96f9$var$getWhoIsOnCallResources = ()=>(0, $llbQS.resources);
const $927df813fa5a96f9$export$fee33ca9661e49dd = (0, $fdS54.createEntry)((0, $47JTY.whoIsOnCallRoute), ()=>({
        group: 'eoc',
        layout: (0, $bqxMM.eocChangeboardingLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $esUWa.WhoIsOnCallComponent),
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            ...$927df813fa5a96f9$var$getWhoIsOnCallResources()
        ],
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $esUWa.LazyWhoIsOnCall)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("47JTY", function(module, exports) {
$parcel$export(module.exports, "whoIsOnCallRoute", () => $a7ca7d842492989d$export$26b06efd7311586b);
const $a7ca7d842492989d$export$26b06efd7311586b = {
    name: 'eoc-who-is-on-call',
    path: '/jira/ops/who-is-on-call',
    exact: true
};

});

parcelRegister("esUWa", function(module, exports) {
$parcel$export(module.exports, "LazyWhoIsOnCall", () => $85e1df2d04062186$export$7b03e7437c5d4f77);
$parcel$export(module.exports, "WhoIsOnCallComponent", () => $85e1df2d04062186$export$51430a0cf6ef3c09);

var $euxye = parcelRequire("euxye");

var $8bf4L = parcelRequire("8bf4L");

var $l8G1z = parcelRequire("l8G1z");

const $85e1df2d04062186$export$7b03e7437c5d4f77 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("esTF8")), {
    moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
});
const $85e1df2d04062186$export$51430a0cf6ef3c09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $85e1df2d04062186$export$7b03e7437c5d4f77,
        pageId: "async-jira-eoc-who-is-on-call",
        shouldShowSpinner: false
    });
$85e1df2d04062186$export$51430a0cf6ef3c09.displayName = "WhoIsOnCallComponent";

});
parcelRegister("esTF8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("biuRj").then(()=>parcelRequire('gXFSr'));

});



parcelRegister("b91Hq", function(module, exports) {
$parcel$export(module.exports, "workforceOptimizationRouteEntry", () => $c09bf34efa5d1f7a$export$e60dac35cd42e367);

var $6pCQT = parcelRequire("6pCQT");

var $bVNpi = parcelRequire("bVNpi");

var $co13a = parcelRequire("co13a");

var $lFLfF = parcelRequire("lFLfF");

var $6RSCO = parcelRequire("6RSCO");

var $fdS54 = parcelRequire("fdS54");

var $lbxXL = parcelRequire("lbxXL");

var $74h93 = parcelRequire("74h93");

var $dTa0V = parcelRequire("dTa0V");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");
const $c09bf34efa5d1f7a$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $c09bf34efa5d1f7a$var$entryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6pCQT.workforceOptimizationEntryPoint)
});
const $c09bf34efa5d1f7a$export$e60dac35cd42e367 = (0, $fdS54.createEntry)((0, $bVNpi.workforceOptimizationRoute), ()=>({
        group: 'servicedesk',
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $lFLfF.default),
        layout: (0, $74h93.serviceProjectLayout),
        ufoName: 'jsm-workforce-optimization',
        navigation: {
            menuId: 'PROJECTS'
        },
        resources: [
            ...(0, $lbxXL.getServiceDeskNavigationResources)(),
            ...(0, $lbxXL.getServicedeskPageContextResources)(),
            (0, $6RSCO.getConsolidationStateResource)(),
            (0, $co13a.routingSetupStatusResource),
            (0, $co13a.routingOnboardingFinishedResource)
        ],
        entryPoint: ()=>{
            if (!$c09bf34efa5d1f7a$var$isWorkforceAemEnabled() || !(0, $i860n.fg)('jsm_workforce_optimization_main')) return undefined;
            return $c09bf34efa5d1f7a$var$entryPoint;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("6pCQT", function(module, exports) {
$parcel$export(module.exports, "workforceOptimizationEntryPoint", () => $0e6ac3bca19d7745$export$5e6babe6c550e5be);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $ac9VS = parcelRequire("ac9VS");

var $7S30O = parcelRequire("7S30O");

const $0e6ac3bca19d7745$export$5e6babe6c550e5be = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("adxie")), {
        moduleId: "2373c894",
        moduleName: "WorkforceOptimizationPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, orgId: orgId } })=>{
        const projectKey = match.params.projectKey ?? '';
        const hasOrgId = orgId != null && orgId !== '';
        return {
            queries: {
                ...hasOrgId && (0, $i860n.fg)('wfm-onboarding-updates') ? {
                    teamCountsQuery: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, $7S30O.default),
                        variables: {
                            organizationId: `ari:cloud:platform::org/${orgId}`,
                            siteId: cloudId,
                            filter: null
                        }
                    },
                    servicesAndSkillsSetupActionQuery: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, $ac9VS.default),
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                } : {}
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey,
                orgId: orgId
            }
        };
    }
});

});
parcelRegister("7S30O", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e69564766169cf9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8af192af5a60a74bc9b5a5a00b908b12>>
 * @relayHash d0c92b0a02babeaefbf81c25e350b9a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7fcba28610d4d0a69b897174ef84bbb22c00450f09f807a16e5ffb16dccf0bf3
const $2e69564766169cf9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7fcba28610d4d0a69b897174ef84bbb22c00450f09f807a16e5ffb16dccf0bf3",
        "metadata": {},
        "name": "WorkforceOptimizationExperimentPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2e69564766169cf9$export$2e2bcd8739ae039 = $2e69564766169cf9$var$node;

});

parcelRegister("adxie", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Fact").then(()=>parcelRequire('iPszQ'));

});


parcelRegister("bVNpi", function(module, exports) {
$parcel$export(module.exports, "workforceOptimizationRoute", () => $9b9dc9d28fc6a975$export$412a7990d1140939);
const $9b9dc9d28fc6a975$export$412a7990d1140939 = {
    name: 'servicedesk-workforce-optimization',
    path: '/jira/servicedesk/projects/:projectKey/workforce-optimization',
    exact: true
};

});


parcelRegister("4bMc3", function(module, exports) {
$parcel$export(module.exports, "workItemEmbedRouteEntry", () => $4aac8566681d1c1a$export$bf0f31c23b37b1f5);

var $9CPfL = parcelRequire("9CPfL");

var $40YhB = parcelRequire("40YhB");

var $fdS54 = parcelRequire("fdS54");

var $byMD7 = parcelRequire("byMD7");

var $edf7u = parcelRequire("edf7u");

var $6UbAk = parcelRequire("6UbAk");

var $22cTn = parcelRequire("22cTn");

var $ldGfw = parcelRequire("ldGfw");

var $4IEwP = parcelRequire("4IEwP");

var $io0d5 = parcelRequire("io0d5");

var $8HUuJ = parcelRequire("8HUuJ");

var $dUAVJ = parcelRequire("dUAVJ");

var $i860n = parcelRequire("i860n");

var $6jRoa = parcelRequire("6jRoa");

var $habYS = parcelRequire("habYS");

var $4nf6e = parcelRequire("4nf6e");

var $4B518 = parcelRequire("4B518");
const $4aac8566681d1c1a$export$bf0f31c23b37b1f5 = (0, $fdS54.createEntry)((0, $4IEwP.workItemEmbedRoute), ()=>({
        group: 'work-item',
        // bifrost property is set up, which is required for Bifrost SSR onboarding
        bifrost: {
            bifrostGroup: 'issue-view',
            manifestName: 'jira-spa-issue-view.json',
            redirects: [
                {
                    key: 'work-item-project-context-redirect',
                    timeoutMs: 1000,
                    handler: ({ match: match, url: url, tenantContext: tenantContext })=>(0, $4nf6e.workItemRedirectionHandler)({
                            match: match,
                            url: url,
                            tenantContext: tenantContext,
                            isEmbed: true
                        })
                }
            ]
        },
        meta: {
            capability: 'WORK_ITEM_VIEW'
        },
        resources: [
            ...(0, $ldGfw.getIssueViewResources)({
                disableShadowQuery: true
            }),
            ...(0, $dUAVJ.getModernIssueTransitionResources)(),
            (0, $6UbAk.gicOptInStatusResources),
            ...(0, $4B518.jiraSpaResources)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            // List view resources (loaded when ?hasList=true)
            (0, $22cTn.workItemConditionalListResources).conditionalIssueNavigatorResource,
            (0, $22cTn.workItemConditionalListResources).conditionalFieldsResource,
            (0, $22cTn.workItemConditionalListResources).conditionalProjectContextResource,
            ...(0, $9CPfL.getWorkItemResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('wi2-perf-smart-links'), (0, $io0d5.issueDescriptionSmartlinkDataResource)),
            (0, $6jRoa.loomPermissionResource)
        ],
        skeleton: (0, $40YhB.WorkItemViewSkeleton),
        entryPoint: ()=>(0, $habYS.workItemPageEntrypoint),
        ufoName: 'work-item',
        fallbackExperience: 'work-item-view',
        supportsPreviewPanel: true,
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-work-item'),
        layout: (0, $byMD7.chromelessLayout),
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("9CPfL", function(module, exports) {
$parcel$export(module.exports, "workItemResourcesRouteResource", () => $81d1fded29f82f1d$export$d1b4a11963fbb000);
$parcel$export(module.exports, "getWorkItemResources", () => $81d1fded29f82f1d$export$7beb55794ad9686);

var $kfVxU = parcelRequire("kfVxU");

var $8HUuJ = parcelRequire("8HUuJ");

var $jFwZ0 = parcelRequire("jFwZ0");

var $htsFl = parcelRequire("htsFl");

var $i860n = parcelRequire("i860n");

var $cEoYb = parcelRequire("cEoYb");

var $ewo8v = parcelRequire("ewo8v");
const $81d1fded29f82f1d$export$d1b4a11963fbb000 = (0, $htsFl.createRelayResource)({
    type: 'WORK_ITEM_RESOURCES_ROUTE_RESOURCE',
    getQuery: ({ match: match }, storeContext)=>{
        const variables = (0, $ewo8v.getNonNullWorkItemResourcesQueryVariablesForIssueKey)((0, $kfVxU.getIssueKey)(match), storeContext?.tenantContext?.cloudId);
        return {
            parameters: (0, $cEoYb.default),
            variables: variables,
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isBrowserOnly: false
});
function $81d1fded29f82f1d$export$7beb55794ad9686() {
    return [
        // currentUserResource remains tied to the SSR attachments experience, but
        // attachments data itself is supplied either by the old browser-only
        // resource or by the new Relay route resource. Keeping those paths mutually
        // exclusive prevents route preload + client fallback from double fetching.
        (0, $jFwZ0.currentUserResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('wi2_1p_attachments_resource'), $81d1fded29f82f1d$export$d1b4a11963fbb000)
    ];
}

});
parcelRegister("cEoYb", function(module, exports) {
$parcel$export(module.exports, "default", () => $de728946405db457$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9a8adbf6bd76e46c0fb7fff6743688d8>>
 * @relayHash 2b5b5d56d6efce945ddf6cc5cf71884f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 368bcf2c8749f072074e216bb1eb8ff7bebb864c547c89562432f08682c3914d

var $8MXfm = parcelRequire("8MXfm");
const $de728946405db457$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrate"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTwcCoUseRovoCheckEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTwcEntitlementCheckEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueViewAddAttachmentFlag"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderDirection"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderField"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v13 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v14 = {
        "kind": "Variable",
        "name": "applicationKey",
        "variableName": "applicationKey"
    }, v15 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v16 = {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
    }, v17 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v18 = {
        "kind": "Variable",
        "name": "hydrate",
        "variableName": "hydrate"
    }, v19 = {
        "kind": "Variable",
        "name": "orderDirection",
        "variableName": "orderDirection"
    }, v20 = {
        "kind": "Variable",
        "name": "orderField",
        "variableName": "orderField"
    }, v21 = [
        v15 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "productKey",
            "variableName": "productKey"
        }
    ], v22 = [
        v14 /*: any*/ ,
        v15 /*: any*/ 
    ], v23 = [
        v13 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "fields": [
                v16 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "kind": "ScalarField",
        "name": "id"
    }, v26 = {
        "kind": "ScalarField",
        "name": "integration"
    }, v27 = {
        "kind": "ScalarField",
        "name": "name"
    }, v28 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "accountId"
            },
            v27 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v25 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "href"
    }, v30 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "hamsProductKey",
                        "variableName": "productKey"
                    }
                ],
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "collectionEntitlement",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "where",
                                        "value": {
                                            "hasRelationshipFromWithType": "COLLECTION"
                                        }
                                    }
                                ],
                                "concreteType": "CcpEntitlement",
                                "kind": "LinkedField",
                                "name": "entitlement",
                                "plural": false,
                                "selections": [
                                    v24 /*: any*/ ,
                                    v25 /*: any*/ 
                                ],
                                "storageKey": "entitlement(where:{\"hasRelationshipFromWithType\":\"COLLECTION\"})"
                            }
                        ],
                        "type": "CommerceEntitlementInfoCcp"
                    }
                ]
            }
        ]
    }, v31 = [
        v15 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "workItemViewResourcesQuery",
            "selections": [
                {
                    "args": [
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "issueKey",
                            "variableName": "issueKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueViewAddAttachmentFlag",
                            "variableName": "issueViewAddAttachmentFlag"
                        },
                        v19 /*: any*/ ,
                        v20 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "WorkItemAttachments_paginationQuery"
                },
                {
                    "condition": "isTwcEntitlementCheckEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v21 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "useTwcEligibility_twcEntitlement"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "twcEligibilityTwcEntitlement"
                        }
                    ]
                },
                {
                    "condition": "isTwcCoUseRovoCheckEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v21 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "WorkItemAttachmentsView_twcCoUseEntitlement"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "workItemAttachmentsViewTwcCoUseEntitlement"
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v21 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "ResourcesEmptyState_twcCoUseEntitlement"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "resourcesEmptyStateTwcCoUseEntitlement"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v8 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v11 /*: any*/ ,
                v10 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFixAiEnablementChecksInIssueViewRelayProvider"
                }
            ],
            "kind": "Operation",
            "name": "workItemViewResourcesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "issueViewAddAttachmentFlag",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v22 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageAllowed"
                                },
                                {
                                    "args": v22 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageUsed"
                                },
                                {
                                    "args": v22 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageIsUnlimited"
                                }
                            ]
                        },
                        {
                            "args": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "key",
                                    "variableName": "issueKey"
                                }
                            ],
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraConsolidatedResourceConnection",
                                    "kind": "LinkedField",
                                    "name": "consolidatedResources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraConsolidatedResourcesEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v24 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "createdDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "contentType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileName"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaApiFileId"
                                                                },
                                                                v26 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "parent"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "parentId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasRestrictedParent"
                                                                },
                                                                v28 /*: any*/ 
                                                            ],
                                                            "type": "JiraAttachmentResource"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isExternallyLinked"
                                                                },
                                                                v28 /*: any*/ 
                                                            ],
                                                            "type": "JiraConfluenceLinkResource"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v28 /*: any*/ 
                                                            ],
                                                            "type": "JiraRemoteLinkResource"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ],
                                                            "type": "JiraWhiteboardResource"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileSize"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                }
                                            ]
                                        },
                                        v24 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "filters": [
                                        "input"
                                    ],
                                    "handle": "connection",
                                    "key": "WorkItemAttachments_consolidatedResources",
                                    "kind": "LinkedHandle",
                                    "name": "consolidatedResources"
                                },
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "input",
                                            "value": {
                                                "integration": [
                                                    "ATTACHMENT",
                                                    "CONFLUENCE",
                                                    "LOOM",
                                                    "WHITEBOARD",
                                                    "WEBLINK"
                                                ]
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "getConsolidatedResourcesTotalCount",
                                    "storageKey": "getConsolidatedResourcesTotalCount(input:{\"integration\":[\"ATTACHMENT\",\"CONFLUENCE\",\"LOOM\",\"WHITEBOARD\",\"WEBLINK\"]})"
                                },
                                {
                                    "alias": "allLinksTotalCount",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "input",
                                            "value": {
                                                "integration": [
                                                    "CONFLUENCE",
                                                    "LOOM",
                                                    "WHITEBOARD",
                                                    "WEBLINK"
                                                ]
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "getConsolidatedResourcesTotalCount",
                                    "storageKey": "getConsolidatedResourcesTotalCount(input:{\"integration\":[\"CONFLUENCE\",\"LOOM\",\"WHITEBOARD\",\"WEBLINK\"]})"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "deletableAttachmentsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalAttachmentsCount"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTwcEntitlementCheckEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v30 /*: any*/ 
                    ]
                },
                {
                    "condition": "isTwcCoUseRovoCheckEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v31 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "isRovoLLMEnabled"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFixAiEnablementChecksInIssueViewRelayProvider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v31 /*: any*/ ,
                                    "concreteType": "JiraRovoEnablementStatus",
                                    "kind": "LinkedField",
                                    "name": "jira_rovoEnablementStatus",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "rovoAiFeaturesEnabledJiraProducts"
                                        }
                                    ]
                                }
                            ]
                        },
                        v30 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "368bcf2c8749f072074e216bb1eb8ff7bebb864c547c89562432f08682c3914d",
            "metadata": {},
            "name": "workItemViewResourcesQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFixAiEnablementChecksInIssueViewRelayProvider": (0, $8MXfm.default)
            }
        }
    };
}();
$de728946405db457$var$node.hash = "80364bdd44433260adf772f41bb39741";
var $de728946405db457$export$2e2bcd8739ae039 = $de728946405db457$var$node;

});

parcelRegister("ewo8v", function(module, exports) {
$parcel$export(module.exports, "getNonNullWorkItemResourcesQueryVariablesForIssueKey", () => $dd7dd21c09d46a8f$export$1bcf28650d9beaa9);

var $n67Vb = parcelRequire("n67Vb");

var $7tjnB = parcelRequire("7tjnB");

var $kfVxU = parcelRequire("kfVxU");

var $bS6BF = parcelRequire("bS6BF");

var $87ZgK = parcelRequire("87ZgK");

var $2HuOR = parcelRequire("2HuOR");

var $6bEm8 = parcelRequire("6bEm8");

var $aI7em = parcelRequire("aI7em");

var $i860n = parcelRequire("i860n");

var $cEoYb = parcelRequire("cEoYb");
const $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION = {
    ATTACHMENT: 'ATTACHMENT',
    LOOM: 'LOOM',
    CONFLUENCE: 'CONFLUENCE',
    WHITEBOARD: 'WHITEBOARD',
    GDRIVE: 'GDRIVE',
    WEBLINK: 'WEBLINK'
};
const $dd7dd21c09d46a8f$var$hasActiveJiraSoftwareLicense = ()=>(0, $2HuOR.getLicensedProducts)((0, $6bEm8.default))[(0, $2HuOR.LICENSED_PRODUCTS).JIRA_SOFTWARE] === true && (0, $87ZgK.default)((0, $6bEm8.default)).software === (0, $7tjnB.LICENSE_STATE_ACTIVE);
const $dd7dd21c09d46a8f$export$3734e68ca9a88866 = (issueKey, storeContext)=>{
    if (!issueKey) return null;
    const { tenantContext: { cloudId: cloudId } } = storeContext;
    return {
        issueKey: issueKey,
        cloudId: cloudId,
        first: 10,
        // DEFAULT_GRID_COLUMNS(5) * GRID_INITIAL_ROWS(2)
        hydrate: true,
        orderField: 'CREATED',
        orderDirection: 'DESC',
        applicationKey: 'JIRA_SOFTWARE',
        issueViewAddAttachmentFlag: (0, $bS6BF.default)((0, $6bEm8.default)).software === 'FREE_EDITION' && (0, $87ZgK.default)((0, $6bEm8.default)).software === 'ACTIVE',
        productKey: 'jira-software',
        // Gates a backend-sensitive TWC entitlement lookup that requires an active Jira Software license.
        isTwcEntitlementCheckEnabled: $dd7dd21c09d46a8f$var$hasActiveJiraSoftwareLicense() && (0, $i860n.fg)('twcg-1399_twc_project_kickoff_workflow_killswitch'),
        // Gates a backend-sensitive TWC co-use entitlement lookup that requires an active Jira Software
        // license, so the fetch does not fire on non-JSW issue views.
        isTwcCoUseRovoCheckEnabled: $dd7dd21c09d46a8f$var$hasActiveJiraSoftwareLicense() && (0, $i860n.fg)('twcg_1846_twc_couse_jira_pt_rovo_create_killswitch'),
        filters: [
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.CONFLUENCE
            },
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.WHITEBOARD
            },
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.LOOM
            },
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.ATTACHMENT,
                types: []
            },
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.WEBLINK
            }
        ]
    };
};
const $dd7dd21c09d46a8f$export$1bcf28650d9beaa9 = (issueKey, cloudId)=>{
    return {
        issueKey: issueKey || '',
        cloudId: cloudId || '',
        first: 10,
        // DEFAULT_GRID_COLUMNS(5) * GRID_INITIAL_ROWS(2)
        hydrate: true,
        orderField: 'CREATED',
        orderDirection: 'DESC',
        applicationKey: 'JIRA_SOFTWARE',
        issueViewAddAttachmentFlag: (0, $bS6BF.default)((0, $6bEm8.default)).software === 'FREE_EDITION' && (0, $87ZgK.default)((0, $6bEm8.default)).software === 'ACTIVE',
        productKey: 'jira-software',
        // Gates a backend-sensitive TWC entitlement lookup that requires an active Jira Software license.
        isTwcEntitlementCheckEnabled: $dd7dd21c09d46a8f$var$hasActiveJiraSoftwareLicense() && (0, $i860n.fg)('twcg-1399_twc_project_kickoff_workflow_killswitch'),
        // Gates a backend-sensitive TWC co-use entitlement lookup that requires an active Jira Software
        // license, so the fetch does not fire on non-JSW issue views.
        isTwcCoUseRovoCheckEnabled: $dd7dd21c09d46a8f$var$hasActiveJiraSoftwareLicense() && (0, $i860n.fg)('twcg_1846_twc_couse_jira_pt_rovo_create_killswitch'),
        filters: [
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.CONFLUENCE
            },
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.WHITEBOARD
            },
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.LOOM
            },
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.ATTACHMENT,
                types: []
            },
            {
                integration: $dd7dd21c09d46a8f$var$RESOURCES_INTEGRATION.WEBLINK
            }
        ]
    };
};
const $dd7dd21c09d46a8f$export$5b71113fd1d0f537 = async (routerContext, storeContext)=>{
    const variables = $dd7dd21c09d46a8f$export$3734e68ca9a88866((0, $kfVxU.getIssueKey)(routerContext.match), storeContext);
    if (!variables) return null;
    const workItemViewResourcesData = (0, $n67Vb.loadQuery)((0, $aI7em.default)(), (0, $cEoYb.default), variables);
    return workItemViewResourcesData;
};

});


parcelRegister("40YhB", function(module, exports) {
$parcel$export(module.exports, "WorkItemViewSkeleton", () => $0e3ef278d177d43d$export$59cdbfb0a6b9df16);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $d5ps5 = parcelRequire("d5ps5");

var $3sEBa = parcelRequire("3sEBa");

var $6wSeJ = parcelRequire("6wSeJ");
const $0e3ef278d177d43d$var$fullPageStyles = null;
const $0e3ef278d177d43d$var$customSpacingStyles = null;
const $0e3ef278d177d43d$export$59cdbfb0a6b9df16 = (t0)=>{
    const $ = (0, $e7boj.c)(7);
    const { isEmbedView: isEmbedView, isModalView: isModalView } = t0;
    const t1 = isEmbedView !== true && isModalView !== true && "_uwhk1ejb";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $4jQY2.default)([
            "_p12f107j _19pkze3t _otyrze3t _t6vdxy5q _hr4jxy5q _1bsb1osq _18u01wug _2hwx1wug _11y7uu9g _l82tpxbi _j7o0pxbi",
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = isModalView === true ? (0, (/*@__PURE__*/$parcel$interopDefault($6wSeJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($3sEBa)));
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ $euxye.createElement((0, $d5ps5.AppSkeletonImage), {
            src: t3
        });
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t2 || $[5] !== t4) {
        t5 = /*#__PURE__*/ $euxye.createElement("div", {
            className: t2
        }, t4);
        $[4] = t2;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
};
$0e3ef278d177d43d$export$59cdbfb0a6b9df16.displayName = "WorkItemViewSkeleton";

});
parcelRegister("3sEBa", function(module, exports) {
module.exports = new URL("work-item-app-skeleton.tpl.85998b2d.svg", import.meta.url).toString();

});

parcelRegister("6wSeJ", function(module, exports) {
module.exports = new URL("work-item-modal-app-skeleton.tpl.5fd7724b.svg", import.meta.url).toString();

});


parcelRegister("22cTn", function(module, exports) {
$parcel$export(module.exports, "workItemConditionalListResources", () => $57f378002f06ead7$export$b1102804bd8952da);

var $9T5Cr = parcelRequire("9T5Cr");

var $L6Vhc = parcelRequire("L6Vhc");

var $edf7u = parcelRequire("edf7u");

var $7edbf = parcelRequire("7edbf");
/**
 * Extract project key from issue key (e.g., "ABC-123" → "ABC")
 */ const $57f378002f06ead7$var$extractProjectKeyFromIssueKey = (issueKey)=>{
    if (!issueKey) return null;
    const parts = issueKey.split('-');
    return parts.length >= 2 ? parts[0] : null;
};
/**
 * Creates a conditional resource wrapper that only loads when hasList query param is true.
 * This allows SSR to conditionally load list view resources without impacting default work item performance.
 *
 * For work-item routes, this also extracts projectKey from the issueKey param to ensure proper JQL scoping.
 */ function $57f378002f06ead7$var$createConditionalListResource(baseResource, resourceName) {
    return (0, $7edbf.createResource)({
        type: `work-item-list-${resourceName}`,
        getKey: ()=>`work-item-list-${resourceName}`,
        getData: async (routerContext, resourceContext)=>{
            // Only load if hasList query param is explicitly set to 'true'
            if (routerContext.query?.hasList === 'true') {
                // Extract projectKey from issueKey for work-item routes
                const issueKey = routerContext.match.params.issueKey;
                const projectKey = issueKey ? $57f378002f06ead7$var$extractProjectKeyFromIssueKey(issueKey) : null;
                // Create a modified context with projectKey for resources that need it
                const modifiedContext = {
                    ...routerContext,
                    match: {
                        ...routerContext.match,
                        params: {
                            ...routerContext.match.params,
                            ...projectKey && {
                                projectKey: projectKey
                            }
                        }
                    }
                };
                return baseResource.getData(modifiedContext, resourceContext);
            }
            // Return null to skip loading when not needed
            return null;
        },
        maxAge: baseResource.maxAge || 0
    });
}
/**
 * issue navigator relay resource.
 */ const $57f378002f06ead7$var$conditionalIssueNavigatorResource = $57f378002f06ead7$var$createConditionalListResource((0, $L6Vhc.issueNavigatorRelayResource), 'issue-navigator');
/**
 * fields resource.
 */ const $57f378002f06ead7$var$conditionalFieldsResource = $57f378002f06ead7$var$createConditionalListResource((0, $9T5Cr.fieldsResource), 'fields');
/**
 * project context resource.
 */ const $57f378002f06ead7$var$conditionalProjectContextResource = $57f378002f06ead7$var$createConditionalListResource((0, $edf7u.projectContextResource), 'project-context');
const $57f378002f06ead7$export$b1102804bd8952da = {
    conditionalProjectContextResource: $57f378002f06ead7$var$conditionalProjectContextResource,
    conditionalFieldsResource: $57f378002f06ead7$var$conditionalFieldsResource,
    conditionalIssueNavigatorResource: $57f378002f06ead7$var$conditionalIssueNavigatorResource
};

});

parcelRegister("4IEwP", function(module, exports) {
$parcel$export(module.exports, "workItemEmbedRoute", () => $ce662a84e61b7da2$export$14d29efa785f7364);
const $ce662a84e61b7da2$export$14d29efa785f7364 = {
    name: 'work-item-embed',
    path: '/jira/browse/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("habYS", function(module, exports) {
$parcel$export(module.exports, "workItemPageEntrypoint", () => $ae15c4a5c9a413ce$export$16cd62cd4baaf460);
/* eslint-disable jira/naming/disallow-filenames */ 
var $hi6Of = parcelRequire("hi6Of");

var $6Jmu2 = parcelRequire("6Jmu2");

var $dTa0V = parcelRequire("dTa0V");
const $ae15c4a5c9a413ce$export$16cd62cd4baaf460 = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $6Jmu2.workItemEntrypoint),
    redirect: (0, $hi6Of.userSegRedirectEntrypoint)
});

});
parcelRegister("6Jmu2", function(module, exports) {
$parcel$export(module.exports, "workItemEntrypoint", () => $75f9828f8b629dc6$export$7776ba0e0fd82365);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $ieliU = parcelRequire("ieliU");

var $i860n = parcelRequire("i860n");

var $hTMx5 = parcelRequire("hTMx5");
const $75f9828f8b629dc6$var$CHILD_ISSUES_INITIAL_DISPLAY_COUNT = 5;
/** Forge module types for work item query. Keep in sync with workItemForgeTypes in @jira/work-item. */ const $75f9828f8b629dc6$var$WORK_ITEM_FORGE_TYPES = [
    'jira:issueAction',
    'jira:issueGlance',
    'jira:issueContext',
    'jira:issuePanel',
    'jira:issueActivity',
    'jira:customField',
    'jira:customFieldType',
    'jira:issueViewBackgroundScript',
    'jira:uiModifications'
];
const $75f9828f8b629dc6$var$getIssueKey = (match)=>{
    return match?.params?.issueKey?.length ? match.params.issueKey : null;
};
const $75f9828f8b629dc6$var$extractProjectKey = (issueKey)=>issueKey.split('-')[0];
const $75f9828f8b629dc6$var$RESOURCES_INTEGRATION = {
    ATTACHMENT: 'ATTACHMENT',
    LOOM: 'LOOM',
    CONFLUENCE: 'CONFLUENCE',
    WHITEBOARD: 'WHITEBOARD',
    GDRIVE: 'GDRIVE',
    WEBLINK: 'WEBLINK'
};
const $75f9828f8b629dc6$var$getIssueViewAddAttachmentsFlag = (tenantContext)=>tenantContext?.appEditions?.software === 'FREE_EDITION' && tenantContext?.licenseStates?.software === 'ACTIVE';
const $75f9828f8b629dc6$var$getDefaultAttachmentFilters = ()=>({
        defaultAttachmentFilters: [
            {
                integration: $75f9828f8b629dc6$var$RESOURCES_INTEGRATION.CONFLUENCE
            },
            {
                integration: $75f9828f8b629dc6$var$RESOURCES_INTEGRATION.WHITEBOARD
            },
            {
                integration: $75f9828f8b629dc6$var$RESOURCES_INTEGRATION.LOOM
            },
            {
                integration: $75f9828f8b629dc6$var$RESOURCES_INTEGRATION.ATTACHMENT,
                types: []
            },
            {
                integration: $75f9828f8b629dc6$var$RESOURCES_INTEGRATION.WEBLINK
            }
        ]
    });

const $75f9828f8b629dc6$export$7776ba0e0fd82365 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("g1oct")), {
        moduleId: "75b343be",
        moduleName: "WorkItemSanitisedEntrypoint",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext, tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        const { match: match } = context;
        const issueKey = $75f9828f8b629dc6$var$getIssueKey(match);
        const projectKey = issueKey ? $75f9828f8b629dc6$var$extractProjectKey(issueKey) : '';
        const jql = projectKey ? `project = "${projectKey}"` : '';
        const focusedCommentId = context.query?.focusedCommentId ? String(context.query.focusedCommentId) : null;
        // Logic from getChildIssuesFieldIdsQueryVariables (main-issue-agg-query). fg() only in `if`
        // conditions — not inside `const queryVariables = { fg() }` (jira/ff/inline-usage).
        const childIssuesFieldIds = [
            'issuetype'
        ];
        if (!(0, $i860n.fg)('relay-migration-edit-worklog') && !(0, $i860n.fg)('jpx-93-unship-legacy-timetracking')) childIssuesFieldIds.push('timetracking');
        if (!(0, $i860n.fg)('jira-issue-view-child-issues-panel-realtime-update')) childIssuesFieldIds.push('status');
        // Design panel + child-issue vars + master preload fields (issueTypeId / favourite fields).
        return {
            queries: {
                workItemQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId || '',
                        issueKey: issueKey || '',
                        projectKey: projectKey,
                        jql: jql,
                        siteAri: cloudId ? (0, $ieliU.JiraSiteAri).create({
                            siteId: cloudId
                        }).toString() : '',
                        // wi2-design-panel-data: design panel data is now fetched via
                        // connectedToIssueAggDataResource (ConnectedToIssueAggQuery) and passed
                        // into WorkItemLayout as connectedAggData. When this gate is on, we set
                        // these to false/false to remove the fields from the main blocking query.
                        consistentRead: (0, $i860n.fg)('wi2-design-panel-data') ? false : (0, $i860n.fg)('design-panel-ags-consistent-read'),
                        includeDesignPanelData: (0, $i860n.fg)('wi2-design-panel-data') ? false : Boolean(!isAnonymous),
                        includeFigmaConfigData: (0, $i860n.fg)('remove_ctiaq_config_state') ? Boolean(!isAnonymous) : false,
                        commentTargetId: focusedCommentId,
                        hasCommentTargetId: !!focusedCommentId,
                        applicationKey: 'JIRA_SOFTWARE',
                        issueViewAddAttachmentFlag: !(0, $i860n.fg)('wi2_1p_attachments_resource') ? $75f9828f8b629dc6$var$getIssueViewAddAttachmentsFlag(tenantContext) : false,
                        forgeTypes: [
                            ...$75f9828f8b629dc6$var$WORK_ITEM_FORGE_TYPES
                        ],
                        issueSearchInput: (0, $i860n.fg)('jira-issue-view-child-work-items-ssr-fg') ? {
                            jql: issueKey ? `parent = ${issueKey}` : ''
                        } : {
                            childIssuesInput: {
                                parentIssueKey: issueKey || ''
                            }
                        },
                        fieldSetsInput: {
                            viewInput: {
                                namespace: 'CHILD_ISSUE_PANEL',
                                context: {
                                    issueContext: {
                                        issueKey: issueKey
                                    }
                                }
                            }
                        },
                        childIssuesFieldIds: childIssuesFieldIds,
                        childIssuesAmountOfColumns: 500,
                        childIssuesFirst: (0, $i860n.fg)('jira_child_work_items_pagination') ? $75f9828f8b629dc6$var$CHILD_ISSUES_INITIAL_DISPLAY_COUNT : undefined,
                        childWorkItemsSSRUIEnabled: Boolean((0, $i860n.fg)('jira-issue-view-child-work-items-ssr-fg')),
                        shouldUseNewChildWorkItemsDatafetcher: true,
                        isInitialLoadQuery: true,
                        shouldCaptureEntrypointQuery5xx: Boolean((0, $i860n.fg)('wi2-work-item-entrypoint-query-5xx-capture')),
                        includeAgenticWorkItemData: Boolean((0, $i860n.fg)('enable_work_item_for_quadratic_release')),
                        includeCommandPaletteIssueType: Boolean((0, $i860n.fg)('mwiv-868-work-type-icon-command-palette')),
                        sideBarLayoutDecompositionEnabled: Boolean((0, $i860n.fg)('side-layout-work-item-integration')),
                        ...$75f9828f8b629dc6$var$getDefaultAttachmentFilters()
                    },
                    parameters: $hTMx5.default
                }
            }
        };
    }
});

});
parcelRegister("hTMx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c71a0499546a27e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ef804d0349a5778c9e4e9c20642d140>>
 * @relayHash 00b499b3e59f0e2e5007ce14a3f01d48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fbac20d69a8847ae3d430b8dc1cd44a505c4e84e6548b9373dcaf123a94ee8f5

var $frIhD = parcelRequire("frIhD");

var $25gUJ = parcelRequire("25gUJ");

var $1D6fx = parcelRequire("1D6fx");

var $8MXfm = parcelRequire("8MXfm");

var $KUiqF = parcelRequire("KUiqF");

var $efrbL = parcelRequire("efrbL");

var $hNa68 = parcelRequire("hNa68");

var $iZoUB = parcelRequire("iZoUB");

var $7yObX = parcelRequire("7yObX");

var $dZY9f = parcelRequire("dZY9f");

var $g1jeD = parcelRequire("g1jeD");

var $2OiA9 = parcelRequire("2OiA9");

var $djCI3 = parcelRequire("djCI3");

var $7e655 = parcelRequire("7e655");

var $7zUJD = parcelRequire("7zUJD");

var $gQsSz = parcelRequire("gQsSz");

var $aIPay = parcelRequire("aIPay");

var $2JgIP = parcelRequire("2JgIP");

var $qRbQN = parcelRequire("qRbQN");

var $lFWP3 = parcelRequire("lFWP3");

var $1nq5z = parcelRequire("1nq5z");

var $gE0jx = parcelRequire("gE0jx");

var $gSEQT = parcelRequire("gSEQT");

var $JnBPc = parcelRequire("JnBPc");

var $2xYMo = parcelRequire("2xYMo");

var $2XfUx = parcelRequire("2XfUx");

var $2TCrO = parcelRequire("2TCrO");

var $vEj75 = parcelRequire("vEj75");

var $eJbZi = parcelRequire("eJbZi");

var $aSs0z = parcelRequire("aSs0z");

var $1HnQt = parcelRequire("1HnQt");

var $1F2RS = parcelRequire("1F2RS");

var $jRbnD = parcelRequire("jRbnD");

var $l4q64 = parcelRequire("l4q64");

var $1ZLvK = parcelRequire("1ZLvK");

var $6fQZA = parcelRequire("6fQZA");

var $i8kHQ = parcelRequire("i8kHQ");

var $1ZafW = parcelRequire("1ZafW");

var $llli9 = parcelRequire("llli9");

var $R0lic = parcelRequire("R0lic");

var $2XkhF = parcelRequire("2XkhF");

var $6BTmn = parcelRequire("6BTmn");

var $02lp5 = parcelRequire("02lp5");

var $gbGxw = parcelRequire("gbGxw");

var $jhYmN = parcelRequire("jhYmN");

var $jXd0g = parcelRequire("jXd0g");

var $b3Nht = parcelRequire("b3Nht");

var $lcsWS = parcelRequire("lcsWS");

var $ch1QC = parcelRequire("ch1QC");

var $7OGJO = parcelRequire("7OGJO");

var $gyjgw = parcelRequire("gyjgw");

var $5ZdKP = parcelRequire("5ZdKP");

var $bstvV = parcelRequire("bstvV");

var $fCPPo = parcelRequire("fCPPo");

var $7so7Y = parcelRequire("7so7Y");

var $8bioU = parcelRequire("8bioU");

var $fFz9x = parcelRequire("fFz9x");

var $kdPlB = parcelRequire("kdPlB");

var $1JsCG = parcelRequire("1JsCG");

var $coyfZ = parcelRequire("coyfZ");

var $2JQfe = parcelRequire("2JQfe");

var $cNoBc = parcelRequire("cNoBc");

var $aIZjN = parcelRequire("aIZjN");

var $gmyGN = parcelRequire("gmyGN");

var $98W07 = parcelRequire("98W07");

var $1A1H9 = parcelRequire("1A1H9");
const $c71a0499546a27e2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fbac20d69a8847ae3d430b8dc1cd44a505c4e84e6548b9373dcaf123a94ee8f5",
        "metadata": {},
        "name": "WorkItemEntrypointUiQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrclinkedIssuesInitialLoadRowsCount": (0, $coyfZ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisLinkedIssuesPaginationEnabled": (0, $gbGxw.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivAgentsRhsTabRelayProvidertsx": (0, $2xYMo.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisLinkedIssuesEditableSyncLoadedOnInitialLoad": (0, $02lp5.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFixAiEnablementChecksInIssueViewRelayProvider": (0, $8MXfm.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx": (0, $iZoUB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx": (0, $lFWP3.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmWfoAssigneeRecommendationOnQueuesRelayprovider": (0, $gQsSz.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $ch1QC.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": (0, $7zUJD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": (0, $b3Nht.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUserPickerGuestLozengeRelayprovider": (0, $gSEQT.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $gmyGN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $R0lic.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": (0, $aIZjN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": (0, $qRbQN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccoverimageissueviewgarelayprovider": (0, $jRbnD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAssignableAgentSessionExperienceRelayprovider": (0, $djCI3.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider": (0, $dZY9f.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiLocalAgentSessionsEnabledRelayProvider": (0, $2OiA9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgenticPlanningRelayProvider": (0, $g1jeD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraEnableClassificationControlEnforcementRelayprovider": (0, $8bioU.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraenableclassificationorgdefaultfgrelayprovider": (0, $gyjgw.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraAiDeeplinkInHeaderRelayProvider": (0, $fCPPo.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcrovoCatchUpLinkedItemsNudgeRelayProvider": (0, $98W07.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcactivityPanelModernisationRelayProvider": (0, $eJbZi.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraissueviewshowslacksyncinforelayprovider": (0, $bstvV.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraSmartRepliesV2RelayProvider": (0, $fFz9x.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarissueviewcommentsrelayprovider": (0, $jXd0g.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": (0, $1ZLvK.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivSsrAttachmentsRelayProvidertsx": (0, $2TCrO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcContextSectionsReorderingExperimentRelayProvider": (0, $frIhD.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiv22472HasSummaryToMIAQFeatureGate": (0, $1JsCG.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiv22469DevSummaryToMIAQRelayProvider": (0, $kdPlB.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsDFOCreateBranchTargetsEnabledRelayProvidertsx": (0, $hNa68.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcDevSummaryPanelWivRelayProvider": (0, $25gUJ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $5ZdKP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraChildIssuesPaginationRelayProvider": (0, $7so7Y.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": (0, $efrbL.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $2XkhF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $6fQZA.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": (0, $2JQfe.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $1ZafW.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": (0, $2JgIP.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": (0, $gE0jx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $i8kHQ.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": (0, $7e655.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": (0, $1D6fx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $1HnQt.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": (0, $6BTmn.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": (0, $l4q64.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": (0, $KUiqF.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": (0, $jhYmN.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": (0, $7yObX.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": (0, $1A1H9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": (0, $aSs0z.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": (0, $aIPay.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $cNoBc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $7OGJO.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": (0, $llli9.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivSsrForgeStoreHydration": (0, $vEj75.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": (0, $1F2RS.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWi2PerfSmartLinkstsx": (0, $JnBPc.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcWivConfluenceApplinksHydration": (0, $2XfUx.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatartmpboardrelayprovider": (0, $lcsWS.default),
            "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveSearchurlFromCmdbFieldRelayProvider": (0, $1nq5z.default)
        }
    }
};
var $c71a0499546a27e2$export$2e2bcd8739ae039 = $c71a0499546a27e2$var$node;

});
parcelRegister("2xYMo", function(module, exports) {
$parcel$export(module.exports, "default", () => $809d86154f33d3ec$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $809d86154f33d3ec$var$WivAgentsRhsTabRelayProvider = {
    get () {
        return (0, $i860n.fg)('wiv_agents_rhs_tab');
    }
};
var $809d86154f33d3ec$export$2e2bcd8739ae039 = $809d86154f33d3ec$var$WivAgentsRhsTabRelayProvider;

});

parcelRegister("gbGxw", function(module, exports) {
$parcel$export(module.exports, "default", () => $4464a992f1be75b3$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");
const $4464a992f1be75b3$var$isLinkedIssuesPaginationEnabled = {
    get () {
        return (0, $i860n.fg)('jira_linked_issues_pagination');
    }
};
var $4464a992f1be75b3$export$2e2bcd8739ae039 = $4464a992f1be75b3$var$isLinkedIssuesPaginationEnabled;

});

parcelRegister("coyfZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb680310069eae07$export$2e2bcd8739ae039);


var $i860n = parcelRequire("i860n");
const $fb680310069eae07$var$linkedIssuesInitialLoadRowsCount = {
    get () {
        return (0, $i860n.fg)('jira_linked_issues_pagination') ? (0, $e835cb7d71743748$export$40002f9448ab2965) : null;
    }
};
var $fb680310069eae07$export$2e2bcd8739ae039 = $fb680310069eae07$var$linkedIssuesInitialLoadRowsCount;

});
const $e835cb7d71743748$export$40002f9448ab2965 = 5;



parcelRegister("g1oct", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr_wiv', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("hhvQ3")
]).then(()=>parcelRequire('2jrmY'));

});



parcelRegister("4nf6e", function(module, exports) {
$parcel$export(module.exports, "workItemRedirectionHandler", () => $35191c9d0bc5806b$export$5363564bf6fb356e);

var $75YsU = parcelRequire("75YsU");

var $adMfn = parcelRequire("adMfn");

var $ao3nB = parcelRequire("ao3nB");

var $i860n = parcelRequire("i860n");

var $6CfY5 = parcelRequire("6CfY5");
const $35191c9d0bc5806b$export$5363564bf6fb356e = async ({ match: match, url: url, tenantContext: tenantContext, isEmbed: isEmbed })=>{
    try {
        const issueKey = match.params.issueKey || undefined;
        if (!issueKey) return undefined;
        const embedPath = isEmbed ? '/embed' : '';
        if (!(0, $75YsU.isWorkItemModernizationGatesEnabled)()) return `/browse/${issueKey}${embedPath}${url.search}`;
        const projectKey = issueKey.split('-')[0];
        // MWIV-814: prefer the canonical issue key from Jira to handle project key moves/renames.
        const { projectType: projectType, userPreference: userPreference, issueKey: canonicalIssueKey, isCreatedFromAgenticTemplate: isCreatedFromAgenticTemplate, isAgenticWorkItemViewEnabled: isAgenticWorkItemViewEnabled } = (0, $i860n.fg)('wiv-fix-redirection-issue-key') ? await (0, $ao3nB.issueViewSwitchDataFetcher)(projectKey, tenantContext.cloudId, issueKey) : await (0, $ao3nB.issueViewSwitchDataFetcher)(projectKey, tenantContext.cloudId);
        const fromIssueKey = (0, $i860n.fg)('wiv-fix-redirection-issue-key') ? canonicalIssueKey ?? issueKey : issueKey;
        const shouldShowWiv = (0, $adMfn.shouldShowWorkItemView)({
            cloudId: tenantContext.cloudId,
            issueKey: issueKey,
            isIssueViewWivEnabled: userPreference,
            projectType: projectType,
            isCreatedFromAgenticTemplate: isCreatedFromAgenticTemplate,
            isAgenticWorkItemViewEnabled: isAgenticWorkItemViewEnabled
        });
        if (!shouldShowWiv) return `/browse/${fromIssueKey}${embedPath}${url.search}`;
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('work-item.router-routes.work-item.route.entry', error instanceof Error ? error.message : 'Unable to redirect to issue view');
    }
};

});


parcelRegister("2aySF", function(module, exports) {
$parcel$export(module.exports, "workItemRouteEntry", () => $a20c5d33081d7745$export$2fea809b4007e17d);

var $9CPfL = parcelRequire("9CPfL");


var $40YhB = parcelRequire("40YhB");

var $edf7u = parcelRequire("edf7u");

var $dUAVJ = parcelRequire("dUAVJ");

var $22cTn = parcelRequire("22cTn");

var $ldGfw = parcelRequire("ldGfw");

var $io0d5 = parcelRequire("io0d5");

var $8HUuJ = parcelRequire("8HUuJ");

var $gZWlI = parcelRequire("gZWlI");

var $dvtoW = parcelRequire("dvtoW");

var $fdS54 = parcelRequire("fdS54");

var $bN8Sj = parcelRequire("bN8Sj");

var $i860n = parcelRequire("i860n");

var $6jRoa = parcelRequire("6jRoa");

var $idDnR = parcelRequire("idDnR");

var $habYS = parcelRequire("habYS");

var $4nf6e = parcelRequire("4nf6e");
const $a20c5d33081d7745$export$2fea809b4007e17d = (0, $fdS54.createEntry)((0, $bN8Sj.workItemRoute), ()=>({
        group: 'work-item',
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        // bifrost property is set up, which is required for Bifrost SSR onboarding
        bifrost: {
            bifrostGroup: 'issue-view',
            manifestName: 'jira-spa-issue-view.json',
            redirects: [
                {
                    key: 'work-item-project-context-redirect',
                    timeoutMs: 1000,
                    handler: (0, $4nf6e.workItemRedirectionHandler)
                }
            ]
        },
        meta: {
            capability: 'WORK_ITEM_VIEW',
            reporting: {
                id: 'routeApp.issue',
                packageName: 'jiraSpa',
                teamName: 'bento'
            }
        },
        resources: [
            ...(0, $ldGfw.getIssueViewResources)({
                disableShadowQuery: true
            }),
            ...(0, $dUAVJ.getNavigationResourcesForWorkItem)(),
            // eslint-disable-next-line jira/router/no-project-context-resource
            (0, $edf7u.projectContextResource),
            (0, $gZWlI.projectThemeResource),
            // Required for useFaviconService to resolve the project avatar and display it as the
            // browser tab favicon — matching the behaviour of the old issue view (JIV).
            (0, $idDnR.staticProjectSidebarNavigationResource),
            // List view resources (loaded when ?hasList=true)
            (0, $22cTn.workItemConditionalListResources).conditionalIssueNavigatorResource,
            (0, $22cTn.workItemConditionalListResources).conditionalFieldsResource,
            (0, $22cTn.workItemConditionalListResources).conditionalProjectContextResource,
            ...(0, $9CPfL.getWorkItemResources)(),
            (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('wi2-perf-smart-links'), (0, $io0d5.issueDescriptionSmartlinkDataResource)),
            (0, $6jRoa.loomPermissionResource)
        ],
        // Compose the project layout so the Quickstart onboarding panel (injected via the layout's
        // rightSidebars/globalComponents slots) renders in the Work Item View, matching the classic
        // issue route (browseIssueRouteEntry).
        layout: (0, $dvtoW.genericProjectLayout),
        skeleton: (0, $40YhB.WorkItemViewSkeleton),
        entryPoint: ()=>(0, $habYS.workItemPageEntrypoint),
        ufoName: 'work-item',
        fallbackExperience: 'work-item-view',
        supportsPreviewPanel: true,
        supportsProjectTheme: 'contoured',
        isHydrateRootEnabled: true,
        isStreamingEnabled: (0, $i860n.fg)('jfp-magma-ssr-streaming-enable-work-item'),
        excludeFromWrmDeferredLoading: true
    }));

});
parcelRegister("bN8Sj", function(module, exports) {
$parcel$export(module.exports, "workItemRoute", () => $e2ce84f250bcff83$export$cdf7747c91065c7f);
const $e2ce84f250bcff83$export$cdf7747c91065c7f = {
    name: 'work-item',
    exact: true,
    path: '/jira/browse/:issueKey(\\w+-\\d+)(.*)?'
};

});



parcelRegister("77BpO", function(module, exports) {
$parcel$export(module.exports, "startJiraSpa", () => $9dfa48b395ba7aa0$export$f71867a5b2484020);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $l28YB = parcelRequire("l28YB");

var $gVFE3 = parcelRequire("gVFE3");

var $9r1Sc = parcelRequire("9r1Sc");

var $h8QGu = parcelRequire("h8QGu");

var $8iLt0 = parcelRequire("8iLt0");

var $hbvZL = parcelRequire("hbvZL");

var $gi67c = parcelRequire("gi67c");

var $7MCPh = parcelRequire("7MCPh");

var $hwbnZ = parcelRequire("hwbnZ");

var $1pIYN = parcelRequire("1pIYN");

var $eSjtg = parcelRequire("eSjtg");

var $egspI = parcelRequire("egspI");

var $9yf7o = parcelRequire("9yf7o");

var $ba8z9 = parcelRequire("ba8z9");

var $7bitu = parcelRequire("7bitu");


var $lB7xL = parcelRequire("lB7xL");
parcelRequire("1ADnd");

var $6xuJS = parcelRequire("6xuJS");

var $1j6ST = parcelRequire("1j6ST");

var $2HuOR = parcelRequire("2HuOR");

var $dsVXF = parcelRequire("dsVXF");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $cAfRH = parcelRequire("cAfRH");

var $fAYMv = parcelRequire("fAYMv");

var $41zzZ = parcelRequire("41zzZ");

var $4Onaa = parcelRequire("4Onaa");

var $b3oW6 = parcelRequire("b3oW6");

var $lFOLo = parcelRequire("lFOLo");

var $3Z2Qh = parcelRequire("3Z2Qh");

var $iLktG = parcelRequire("iLktG");

var $fGV3I = parcelRequire("fGV3I");

var $9RXSf = parcelRequire("9RXSf");

var $5kLXK = parcelRequire("5kLXK");

var $6FMwd = parcelRequire("6FMwd");

var $cPAVv = parcelRequire("cPAVv");

var $gDdYI = parcelRequire("gDdYI");

var $h8wQT = parcelRequire("h8wQT");

var $gxyIZ = parcelRequire("gxyIZ");

var $isKx1 = parcelRequire("isKx1");

var $fJ5g0 = parcelRequire("fJ5g0");
var $55BnK = parcelRequire("55BnK");

var $7jsro = parcelRequire("7jsro");

var $f2wVS = parcelRequire("f2wVS");

var $ehOO1 = parcelRequire("ehOO1");

var $76Y3S = parcelRequire("76Y3S");

var $QhQu4 = parcelRequire("QhQu4");

var $57TEW = parcelRequire("57TEW");

var $6CfY5 = parcelRequire("6CfY5");

var $6bEm8 = parcelRequire("6bEm8");

var $hOqkw = parcelRequire("hOqkw");

var $diXNS = parcelRequire("diXNS");

var $37BCc = parcelRequire("37BCc");

var $k1Xkv = parcelRequire("k1Xkv");
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;
(0, $gxyIZ.LooselyLazy).init({
    mode: (0, $37BCc.getIsSsrHydrationEnabled)() ? (0, $isKx1.MODE).HYDRATE : (0, $isKx1.MODE).RENDER,
    crossOrigin: 'anonymous',
    // hide fg access from eslint, we can do it on "pure client
    react18: true
});

const $9dfa48b395ba7aa0$var$getMessages = ()=>{
    (0, $6xuJS.setMark)('jira-spa/language-pack.start');
    const messages = (parcelRequire("cK8QE"));
    (0, $6xuJS.setMark)('jira-spa/language-pack.end');
    return messages;
};
const $9dfa48b395ba7aa0$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body?.classList.contains('deferred')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body?.classList.remove('deferred');
};
const $9dfa48b395ba7aa0$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $9dfa48b395ba7aa0$var$InstallGlobalComponentsOnce = ()=>{
    (0, $euxye.useEffect)(()=>{
        (0, $hOqkw.default).installLowPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))($9dfa48b395ba7aa0$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $6xuJS.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
$9dfa48b395ba7aa0$var$InstallGlobalComponentsOnce.displayName = "InstallGlobalComponentsOnce";
// this will move low priority apps to after TTAI (currently just the async-profilecard (legacy profilecard, only used on legacy experiences like GIN and legacy GIC))
const $9dfa48b395ba7aa0$var$LoadPhaseSwitcher = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cAfRH.NonCritical), {
        id: "spa-main.client-router.non-critical",
        teamName: "delorean-spa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9dfa48b395ba7aa0$var$InstallGlobalComponentsOnce, null));
};
$9dfa48b395ba7aa0$var$LoadPhaseSwitcher.displayName = "LoadPhaseSwitcher";
const $9dfa48b395ba7aa0$var$updateCapability = (capability)=>{
    (0, $lB7xL.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $0ce01f968965dadd$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $0ce01f968965dadd$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $0ce01f968965dadd$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $9dfa48b395ba7aa0$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $55BnK.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $fJ5g0.default)(routes, nextLocation.pathname, nextLocation.search, '');
        $9dfa48b395ba7aa0$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $4Onaa.useCurrentRoute)();
    $9dfa48b395ba7aa0$var$updateCapability(route.meta?.capability || null);
    return null;
};
$9dfa48b395ba7aa0$var$CapabilityTrackerConnector.displayName = "CapabilityTrackerConnector";
// This verification is called after render to ensure that nothing is overriding the resolved value
const $9dfa48b395ba7aa0$var$verifyAlwaysOffFeatureGates = ()=>{
    // eslint-disable-next-line jira/ff/inline-usage
    const fgResult = (0, $i860n.fg)('jfp-magma-always-off-fg-test');
    const platformFgResult = (0, $egspI.fg)('jfp-magma-always-off-fg-test');
    if (fgResult !== false || platformFgResult !== false) return [
        {
            expected: false,
            fgResult: fgResult,
            platformFgResult: platformFgResult
        }
    ];
    return [];
};
const $9dfa48b395ba7aa0$var$reportFeatureGateMismatches = ()=>{
    // This one is populated on SSR so we can check if Statsig is working correctly
    const ssrMismatches = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE?.featureGateMismatch?.mismatches ?? [];
    const postRenderMismatches = $9dfa48b395ba7aa0$var$verifyAlwaysOffFeatureGates();
    const allMismatches = [
        ...ssrMismatches,
        ...postRenderMismatches
    ];
    if (allMismatches.length) (0, $6CfY5.default).safeErrorWithoutCustomerData('feature-gate-verification', 'Statsig feature gate mismatch detected', {
        mismatches: JSON.stringify(allMismatches)
    });
};
const $9dfa48b395ba7aa0$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
    if (!(0, $i860n.fg)('jfp-magma-data-ssr-placeholder-retain')) (0, $7MCPh.collectSSRPlaceholderDimensions)(document, window, true);
    (0, $cPAVv.default)();
    (0, $7bitu.initBrowserMetrics3)();
    (0, $k1Xkv.initPlatformFeatureFlagsWithMetrics)();
    (0, $k1Xkv.verifyPlatformFeatureFlags)();
    (0, $76Y3S.initEntryPointConfig)();
    (0, $h8wQT.getClientReceiver)();
    (0, $fGV3I.addInitialPageLoadTimings)();
    (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $6xuJS.setMark)('jira-spa/setup.start');
    const routes = (0, $iLktG.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
    const history = (0, $iLktG.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $5kLXK.default)(routes));
    const initRoute = (0, $iLktG.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $fJ5g0.default)(routes, window.location.pathname, window.location.search);
        (0, $41zzZ.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if ((0, $i860n.fg)('nin_ssr_resource_timeout_info')) (0, $1j6ST.setSsrResourceTimeout)(initRoute?.route?.bifrost?.fetchTimeout);
    if (initRoute != null) {
        const ufoName = (0, $gi67c.default)(initRoute.route);
        (0, $hwbnZ.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $4Onaa.useCurrentRoute)();
        (0, $9yf7o.browserMetrics).setRoute(route.name);
        (0, $1pIYN.useUFOTransitionCompleter)();
        (0, $ehOO1.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    (0, $ehOO1.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    const messages = $9dfa48b395ba7aa0$var$getMessages();
    const tenantContext = (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { locale: locale } = tenantContext;
    const routerProps = {
        history: history,
        routes: routes,
        basePath: '',
        initialRoute: initRoute?.route,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resourceData: window.SPA_STATE,
        resourceContext: (0, $6FMwd.getSpaRouterContext)({
            tenantContext: tenantContext
        }),
        onPrefetch: ({ route: route, match: match })=>{
            (0, $9RXSf.setPrefetchStartMark)(match);
            if (!route.forPaint) return;
            route.forPaint.map((component)=>component.preload && component.preload());
        },
        isLazyRoutes: typeof loadLazyRoutes === 'function'
    };
    const SpaClientRouterTemplate = ({ children: children, trackedRoutes: trackedRoutes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3Z2Qh.SpaRouter), {
            routerProps: routerProps,
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7jsro.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9dfa48b395ba7aa0$var$CapabilityTrackerConnector, {
                routes: trackedRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8iLt0.default), null)),
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9dfa48b395ba7aa0$var$LoadPhaseSwitcher, null)
        }, children);
    let SpaClientRouter;
    if (typeof loadLazyRoutes === 'function') {
        const useRouterRoutes = (0, $f2wVS.createRouterSelector)((state)=>state.routes);
        SpaClientRouter = ({ children: children })=>{
            const actions = (0, $f2wVS.useRouterStoreActions)();
            const currentRoutes = useRouterRoutes();
            (0, $euxye.useEffect)(()=>{
                let isCancelled = false;
                const loadRoutes = async ()=>{
                    if (!isCancelled) {
                        const getLazyRoutes = await loadLazyRoutes();
                        await actions.setRoutes(getLazyRoutes());
                    }
                };
                loadRoutes();
                return ()=>{
                    isCancelled = true;
                };
            }, [
                actions
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(SpaClientRouterTemplate, {
                trackedRoutes: currentRoutes
            }, children);
        };
    } else SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(SpaClientRouterTemplate, {
            trackedRoutes: routes
        }, children);
    const AppWithoutPlaceholders = ({ entryPointPlaceholders: entryPointPlaceholders })=>{
        const spaContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fAYMv.Spa), {
            locale: locale,
            messages: messages,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $lFOLo.JiraRouterLinkConfiguration)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b3oW6.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
            name: "jira-spa"
        }, entryPointPlaceholders ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointPlaceholderContext).Provider, {
            value: entryPointPlaceholders
        }, spaContent) : spaContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null));
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $6xuJS.setMark)('_jira-spa/spa-shell.start');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('jira-frontend');
    if (container) {
        (0, $eSjtg.getVCObserver)().setSSRElement(container);
        (0, $eSjtg.getVCObserver)().setReactRootRenderStart();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                (0, $eSjtg.getVCObserver)().setReactRootRenderStop();
            });
        });
        const isSsrHydrationEnabled = (0, $37BCc.getIsSsrHydrationEnabled)();
        const isServerStreamingEnabled = (0, $37BCc.getIsServerStreamingEnabled)();
        const entryPointPlaceholders = isSsrHydrationEnabled ? undefined : (0, $dsVXF.getPlaceholdersFromHTML)();
        (0, $37BCc.renderReactApp)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AppWithoutPlaceholders, {
            entryPointPlaceholders: entryPointPlaceholders
        }), {
            isSsrHydrationEnabled: isSsrHydrationEnabled,
            isServerStreamingEnabled: isServerStreamingEnabled,
            container: container
        });
        // Replay SSR-evaluated feature gates into UFO so SSR-evaluated gates show up on UFO
        // interactions on the client. The global is set during SSR in jira/src/packages/ssr/frontend-server/src/render.tsx
        const ssrFeatureFlagsAccessed = // @ts-expect-error - __SSR_FEATURE_FLAGS_ACCESSED__ is not declared on Window (globals.d.ts is ratcheted)
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__SSR_FEATURE_FLAGS_ACCESSED__;
        if (ssrFeatureFlagsAccessed && typeof ssrFeatureFlagsAccessed === 'object') Object.keys(ssrFeatureFlagsAccessed).forEach((key)=>{
            (0, $hbvZL.addFeatureFlagAccessed)(key, // oxlint-disable-next-line typescript/consistent-type-assertions
            ssrFeatureFlagsAccessed[key]);
        });
    }
    (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
    (0, $6xuJS.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
    setTimeout(()=>{
        (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
    });
    if ((0, $2700E.expVal)('uip_preprod_slow', 'value', 0) > 0) {
        (0, $6xuJS.setMark)('slow-start');
        const end = performance.now() + (0, $2700E.expVal)('uip_preprod_slow', 'value', 0);
        while(performance.now() < end);
        (0, $6xuJS.setMark)('slow-stop');
    }
    (0, $hOqkw.default).installHighPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
    (0, (/*@__PURE__*/$parcel$interopDefault($gVFE3)))($9dfa48b395ba7aa0$var$globalSettingsArgs, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
    if (initRoute?.route?.bifrost?.circuitBreakerConfig) {
        const userId = (0, $6bEm8.default)('ajs-atlassian-account-id') ?? undefined;
        const cloudId = (0, $6bEm8.default)('ajs-cloud-id') ?? undefined;
        (0, $9r1Sc.setCircuitBreakerOnIdle)({
            ...initRoute.route.bifrost.circuitBreakerConfig,
            userId: userId,
            cloudId: cloudId
        });
    }
    $9dfa48b395ba7aa0$var$superbatchInit();
    if (!false) {
        if ((0, $i860n.fg)('jpx-870-stable-ui-for-criterion')) (0, $QhQu4.preloadComponents)((0, $57TEW.getSharedLayout)());
        else (0, $QhQu4.preloadComponents)((0, $57TEW.sharedLayout));
    }
    return null;
};
const $9dfa48b395ba7aa0$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
    // In React 18: 500ms is the default value internally in react-dom
    // In React 19: 300ms is the default value
    // In React 19.2: This value becomes dynamic https://react.dev/blog/2025/10/01/react-19-2
    //
    // Based of our experiment (`jfp-magma-initial-react-fallback-throttle-ms`), 100ms appears to be the optimal value for Jira *at this point in time*
    // It can and should be removed or tweaked when we upgrade React
    globalThis.REACT_FALLBACK_THROTTLE_MS = 100;
    return $9dfa48b395ba7aa0$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>(0, $ba8z9.reportBootstrapError)(reason)).finally(()=>{
        (0, $diXNS.reportUnreportedStatsigInitialisationError)();
        $9dfa48b395ba7aa0$var$reportFeatureGateMismatches();
    });
};

});
parcelRegister("gVFE3", function(module, exports) {

var $bbfDv = parcelRequire("bbfDv");

var $5skZT = parcelRequire("5skZT");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $c532460ce91509de$var$pick = $5skZT(function(object, paths) {
    return object == null ? {} : $bbfDv(object, paths);
});
module.exports = $c532460ce91509de$var$pick;

});
parcelRegister("bbfDv", function(module, exports) {

var $gAOXx = parcelRequire("gAOXx");

var $27fbA = parcelRequire("27fbA");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $823cd9cb930fa0f5$var$basePick(object, paths) {
    return $gAOXx(object, paths, function(value, path) {
        return $27fbA(object, path);
    });
}
module.exports = $823cd9cb930fa0f5$var$basePick;

});


parcelRegister("9r1Sc", function(module, exports) {
$parcel$export(module.exports, "setCircuitBreakerOnIdle", () => $17c6416e3e3840c8$export$811391ccc8baa1bb);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import/file-extension-required

var $fngNu = parcelRequire("fngNu");

var $6J5OQ = parcelRequire("6J5OQ");

var $3Nfah = parcelRequire("3Nfah");

var $iayqi = parcelRequire("iayqi");

var $iC4BV = parcelRequire("iC4BV");
function $17c6416e3e3840c8$export$811391ccc8baa1bb({ isSetCookieEnabled: isSetCookieEnabled, cookieKey: cookieKey, windowSize: windowSize, threshold: threshold, keepOpenCount: keepOpenCount, halfOpenForCount: halfOpenForCount, userId: userId, cloudId: cloudId }) {
    if (isSetCookieEnabled) (0, $fngNu.callWhenIdle)(async ()=>{
        await (0, $6J5OQ.initControlsOnce)({
            userId: userId,
            cloudId: cloudId
        });
        const circuitBreaker = new (0, $3Nfah.CookieCircuitBreaker)({
            cookieKey: cookieKey,
            windowSize: windowSize,
            threshold: threshold,
            keepOpenCount: keepOpenCount,
            halfOpenForCount: halfOpenForCount,
            version: (0, $iC4BV.getCookieCircuitBreakerKillswitch)() ?? 0
        });
        const didVersionMismatch = circuitBreaker.resetCookieIfVersionMismatch();
        // Do not record a pass/fail if we just reset the cookie incase it failed due
        // to the circuit breaker being OPEN
        if (!didVersionMismatch) {
            if ((0, $iayqi.didSSRSucceed)()) circuitBreaker.recordPass();
            else circuitBreaker.recordFailure();
        }
    }, 1000);
}

});
parcelRegister("6J5OQ", function(module, exports) {
$parcel$export(module.exports, "initControlsOnce", () => $5eec88c480201bd1$export$1120113854b04415);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fYUfv = parcelRequire("fYUfv");

var $4yn95 = parcelRequire("4yn95");

var $i860n = parcelRequire("i860n");

var $l1vE2 = parcelRequire("l1vE2");

var $gXtG2 = parcelRequire("gXtG2");

var $jBDHl = parcelRequire("jBDHl");
function $5eec88c480201bd1$var$isWebStorageEnforcedGateEnabled(isSpa) {
    return globalThis?.__SPA__ || isSpa ? (0, $i860n.fg)('jfp-vulcan-browser-storage-enabled') : (0, $i860n.fg)('jfp-vulcan-browser-storage-enabled-legacy');
}
function $5eec88c480201bd1$var$isIndexedDbEnforcedGateEnabled(isSpa) {
    return globalThis?.__SPA__ || isSpa ? (0, $i860n.fg)('jfp-vulcan-indexeddb-enabled') : (0, $i860n.fg)('jfp-vulcan-indexeddb-enabled-legacy');
}
let $5eec88c480201bd1$var$initializeControlsPromise = null;
function $5eec88c480201bd1$export$1120113854b04415({ userId: userId, cloudId: cloudId, isSpa: isSpa }) {
    if (!$5eec88c480201bd1$var$initializeControlsPromise) {
        if ((0, $i860n.fg)('jfp-vulcan-browser-storage-disable-auto-cleanup')) (0, $4yn95.removeLegacyTimestampNamespaceKeys)();
        $5eec88c480201bd1$var$initializeControlsPromise = (0, $fYUfv.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $i860n.fg)('jfp-vulcan-browser-storage-analytics-enabled') || $5eec88c480201bd1$var$isWebStorageEnforcedGateEnabled(isSpa),
            disableWebStorageConsentChecks: (0, $i860n.fg)('jfp-vulcan-browser-storage-analytics-enabled') && !$5eec88c480201bd1$var$isWebStorageEnforcedGateEnabled(isSpa),
            indexedDbEnabled: (0, $i860n.fg)('jfp-vulcan-indexeddb-analytics-enabled') || $5eec88c480201bd1$var$isIndexedDbEnforcedGateEnabled(isSpa),
            disableIndexedDbConsentChecks: (0, $i860n.fg)('jfp-vulcan-indexeddb-analytics-enabled') && !$5eec88c480201bd1$var$isIndexedDbEnforcedGateEnabled(isSpa),
            perimeter: (0, $l1vE2.isFedRamp)() ? 'fedramp-moderate' : 'commercial',
            userId: userId,
            cloudId: cloudId,
            allowUncategorizedItemsInWebStorageOverrides: $5eec88c480201bd1$var$isWebStorageEnforcedGateEnabled(isSpa),
            __UNSAFE_shouldEnforceKeyForRollout: (0, $jBDHl.shouldEnforceKeyForRollout)
        });
    }
    return $5eec88c480201bd1$var$initializeControlsPromise;
}
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $5eec88c480201bd1$var$initializeControlsPromise = null;
});

});
parcelRegister("fYUfv", function(module, exports) {
$parcel$export(module.exports, "initializeControls", () => $a5dc05ca8c50fcab$export$919040c32a62c7db);

var $egspI = parcelRequire("egspI");

var $2rFtA = parcelRequire("2rFtA");
var $hRda6 = parcelRequire("hRda6");
var $j1sAG = parcelRequire("j1sAG");

var $c1I7W = parcelRequire("c1I7W");
var $aXcc9 = parcelRequire("aXcc9");

var $4fPPi = parcelRequire("4fPPi");

var $4CHTG = parcelRequire("4CHTG");

var $l4jKk = parcelRequire("l4jKk");

var $e5dm8 = parcelRequire("e5dm8");

var $9uE6b = parcelRequire("9uE6b");
const $a5dc05ca8c50fcab$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $egspI.fg)('platform_moonjelly_bsc_master_killswitch')) return undefined;
    let initResult;
    try {
        (0, $j1sAG.Logger).debug('initializeControls invoked');
        if ((0, $egspI.fg)('fedramp-consent-banner-perimeter-prop')) (0, $aXcc9.initializeGlobalState)({
            ...args,
            overrideOnceParams: true
        });
        else (0, $aXcc9.initializeGlobalState)(args);
        if ((0, $hRda6.isSSR)()) return undefined;
        if ((0, $egspI.fg)('platform_bsc_initialize_controls_analytics')) (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'bscInitControlsParameters',
            attributes: {
                product: args.product,
                analyticsEnabled: args.analyticsEnabled,
                flagEnabled: args.flagEnabled,
                webStorageEnabled: args.webStorageEnabled,
                indexedDbEnabled: args.indexedDbEnabled,
                disableWebStorageConsentChecks: args.disableWebStorageConsentChecks,
                disableIndexedDbConsentChecks: args.disableIndexedDbConsentChecks,
                allowUncategorizedCookiesInOverrides: args.allowUncategorizedCookiesInOverrides,
                allowUncategorizedItemsInWebStorageOverrides: args.allowUncategorizedItemsInWebStorageOverrides,
                allowUncategorizedItemsInIndexedDBOverrides: args.allowUncategorizedItemsInIndexedDBOverrides,
                perimeter: args.perimeter,
                hasShouldEnforceKeyCallback: !!args.__UNSAFE_shouldEnforceKeyForRollout
            }
        });
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $2rFtA.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $l4jKk.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $c1I7W.getBscGlobalState)().webStorageEnabled;
        if (isWebStorageControlsEnabled) {
            await (0, $9uE6b.createWebStoragePassthrough)((0, $4fPPi.WebStorageType).LocalStorage);
            await (0, $9uE6b.createWebStoragePassthrough)((0, $4fPPi.WebStorageType).SessionStorage);
        }
        const isIndexedDbEnabled = (0, $c1I7W.getBscGlobalState)().indexedDbEnabled;
        if (isIndexedDbEnabled) {
            const disableIndexedDbConsentChecks = (0, $c1I7W.getBscGlobalState)().disableIndexedDbConsentChecks ?? false;
            if ((0, $egspI.fg)('jfp-magma-selective-storage-enforcement')) {
                const __UNSAFE_shouldEnforceKeyForRollout = (0, $c1I7W.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
                // `__UNSAFE_shouldEnforceKeyForRollout` needs the consent-checking override installed to do
                // per-key re-enforcement at call time.
                await (0, $e5dm8.createIndexedDBPassthrough)({
                    performConsentChecks: !disableIndexedDbConsentChecks || __UNSAFE_shouldEnforceKeyForRollout !== undefined
                });
            } else await (0, $e5dm8.createIndexedDBPassthrough)({
                performConsentChecks: !disableIndexedDbConsentChecks
            });
        }
        (0, $j1sAG.Logger).debug('initializeControls finished');
        if ((0, $egspI.fg)('platform_bsc_cleanup_revoked_storage')) {
            const storageCleanupPromise = (0, $4CHTG.cleanupStorage)();
            initResult = Object.assign(initResult ?? {}, {
                storageCleanupPromise: storageCleanupPromise
            });
        }
    } catch (e) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
    return initResult;
};

});
parcelRegister("aXcc9", function(module, exports) {
$parcel$export(module.exports, "initializeGlobalState", () => $cb1094217bb859fd$export$882c4530c58781d8);

var $41FAq = parcelRequire("41FAq");

var $egspI = parcelRequire("egspI");

var $5MrbU = parcelRequire("5MrbU");

var $j58CX = parcelRequire("j58CX");

var $j1sAG = parcelRequire("j1sAG");

var $ixvQs = parcelRequire("ixvQs");

var $c1I7W = parcelRequire("c1I7W");
const $cb1094217bb859fd$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, disableWebStorageConsentChecks: disableWebStorageConsentChecks, packageLogLevel: packageLogLevel, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides, allowUncategorizedItemsInIndexedDBOverrides: allowUncategorizedItemsInIndexedDBOverrides, disableIndexedDbConsentChecks: disableIndexedDbConsentChecks, __UNSAFE_shouldEnforceKeyForRollout: __UNSAFE_shouldEnforceKeyForRollout, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true, userId: userId, cloudId: cloudId, overrideOnceParams: overrideOnceParams = false } = {})=>{
    (0, $j1sAG.Logger).debug('Initialize global state invoked');
    const productGlobalState = (0, $c1I7W.__internalGetProductGlobalState)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, $c1I7W.__internalApplyInitialState)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, $c1I7W.__internalGetWebStorageControlsEnabledGlobalState)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, $c1I7W.__internalApplyInitialState)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, $egspI.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $egspI.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, $c1I7W.__internalGetIndexedDbControlsEnabledGlobalState)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, $c1I7W.__internalApplyInitialState)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, $egspI.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $egspI.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    // `disableWebStorageConsentChecks` is sticky like the other controls flags above and
    // mirrors the behaviour of `disableIndexedDbConsentChecks`. When the caller does not
    // explicitly pass a value, the global state is left undefined and the public getter
    // (`getBscGlobalState`) reports `false` by default. It only takes effect when the
    // matching `webStorageEnabled` is `true` — see the consumer in `initializeControls`.
    const disableWebStorageConsentChecksGlobalState = (0, $c1I7W.__internalGetDisableWebStorageConsentChecksGlobalState)();
    if (disableWebStorageConsentChecks !== undefined && disableWebStorageConsentChecksGlobalState === undefined) (0, $c1I7W.__internalApplyInitialState)({
        disableWebStorageConsentChecksGlobalState: disableWebStorageConsentChecks
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, $c1I7W.__internalGetAllowUncategorizedCookiesInOverridesGlobalState)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, $c1I7W.__internalApplyInitialState)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    // `allowUncategorizedItemsInWebStorageOverrides` is the web-storage-only counterpart to
    // `allowUncategorizedCookiesInOverrides`. It is sticky in the same way, and only takes
    // effect when web-storage controls are enabled. It does not affect cookies.
    const allowUncategorizedItemsInWebStorageOverridesGlobalState = (0, $c1I7W.__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState)();
    if (allowUncategorizedItemsInWebStorageOverrides !== undefined && allowUncategorizedItemsInWebStorageOverridesGlobalState === undefined) (0, $c1I7W.__internalApplyInitialState)({
        allowUncategorizedItemsInWebStorageOverridesGlobalState: allowUncategorizedItemsInWebStorageOverrides
    });
    // `allowUncategorizedItemsInIndexedDBOverrides` is the IDB-only counterpart to
    // `allowUncategorizedItemsInWebStorageOverrides`. It is sticky in the same way, and only
    // takes effect when IndexedDB controls are enabled. It does not affect cookies or web storage.
    const allowUncategorizedItemsInIndexedDBOverridesGlobalState = (0, $c1I7W.__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState)();
    if (allowUncategorizedItemsInIndexedDBOverrides !== undefined && allowUncategorizedItemsInIndexedDBOverridesGlobalState === undefined) (0, $c1I7W.__internalApplyInitialState)({
        allowUncategorizedItemsInIndexedDBOverridesGlobalState: allowUncategorizedItemsInIndexedDBOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, $c1I7W.__internalGetDisableIndexedDbConsentChecksGlobalState)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, $c1I7W.__internalApplyInitialState)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // Sticky on first set, mirroring the consent-check flags above.
    const __UNSAFE_shouldEnforceKeyForRolloutGlobalState = (0, $c1I7W.__internalGetShouldEnforceKeyGlobalState)();
    if (__UNSAFE_shouldEnforceKeyForRollout !== undefined && __UNSAFE_shouldEnforceKeyForRolloutGlobalState === undefined) (0, $c1I7W.__internalApplyInitialState)({
        __UNSAFE_shouldEnforceKeyForRolloutGlobalState: __UNSAFE_shouldEnforceKeyForRollout
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    // This behaviour is gated behind the fedramp-consent-banner-perimeter-prop feature flag.
    if ((0, $c1I7W.__internalGetHasInitialized)() && !(overrideOnceParams && (0, $egspI.fg)('fedramp-consent-banner-perimeter-prop'))) return;
    // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    const localConsentModeGlobalState = localConsentMode || !(0, $41FAq.isFeatureEnabled)('consent-platform', 'consenthub');
    const cookiesCacheLoader = new (0, $j58CX.CacheLoader)((0, $5MrbU.CategoryStorageType).Cookies, perimeter);
    const localStorageCacheLoader = new (0, $j58CX.CacheLoader)((0, $5MrbU.CategoryStorageType).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, $j58CX.CacheLoader)((0, $5MrbU.CategoryStorageType).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, $j58CX.CacheLoader)((0, $5MrbU.CategoryStorageType).IndexedDB, perimeter);
    const updates = {
        localConsentModeGlobalState: localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader: cookiesCacheLoader,
        localStorageCacheLoader: localStorageCacheLoader,
        sessionStorageCacheLoader: sessionStorageCacheLoader,
        indexedDBCacheLoader: indexedDBCacheLoader,
        packageLogLevelGlobalState: packageLogLevel,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, $c1I7W.__internalApplyInitialState)(updates);
    // Invalidate the resolved Logger level so any callers that triggered an
    // early `Logger.*` call before init pick up the new `packageLogLevel`.
    (0, $ixvQs.resetLogLevelCache)();
};

});
parcelRegister("j58CX", function(module, exports) {
$parcel$export(module.exports, "CacheLoader", () => $1fe200406cede2b4$export$e479342c697b82a9);

var $egspI = parcelRequire("egspI");

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $c1I7W = parcelRequire("c1I7W");

var $j1sAG = parcelRequire("j1sAG");

var $lYfNK = parcelRequire("lYfNK");
class $1fe200406cede2b4$export$e479342c697b82a9 {
    constructor(storageType, perimeter = 'commercial'){
        const useFlatFormat = (0, $egspI.fg)('platform_bsc_flat_pattern_file_structure');
        const cacheUrlLookup = (0, $lYfNK.getCategoryCacheUrlPerimeterLookup)(useFlatFormat)[perimeter] || (0, $lYfNK.getCommercialCategoryCacheUrlLookup)(useFlatFormat);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
	 * Unpacks the response promise from the categories CDN
	 *
	 * errors if that request was unsuccessful, returns the categories data otherwise
	 *
	 */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    getStorageControlsDataFromCache() {
        return this.localResponseCache;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, $jkqqC.UFOExperience)('browser-storage-controls-fetch-time', {
                type: (0, $ipvkO.ExperienceTypes).Load,
                performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $j1sAG.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            if ((0, $egspI.fg)('platform_bsc_cache_load_date')) (0, $c1I7W.__internalSetCacheLoadedDate)(new Date().toISOString().slice(0, 10));
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("lYfNK", function(module, exports) {
$parcel$export(module.exports, "getCommercialCategoryCacheUrlLookup", () => $a7a2952a55bc1a52$export$5989415260e0cf82);
$parcel$export(module.exports, "getCategoryCacheUrlPerimeterLookup", () => $a7a2952a55bc1a52$export$9797a362f9385b1a);

var $egspI = parcelRequire("egspI");

var $5MrbU = parcelRequire("5MrbU");
var $a7a2952a55bc1a52$export$40467b362aa82ae = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var $a7a2952a55bc1a52$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const $a7a2952a55bc1a52$var$generateResourcePath = (perimeter, storageType, useFlatFormat = false)=>{
    const baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
    const baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
    const fileName = useFlatFormat ? `categories_v2_${storageType}.json` : `categories_${storageType}.json`;
    switch(perimeter){
        case 'fedramp-moderate':
            return `${baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${baseBifrostCommercialPath}${fileName}`;
        default:
            return `${baseBifrostCommercialPath}${fileName}`;
    }
};
const $a7a2952a55bc1a52$export$5989415260e0cf82 = (useFlatFormat = false)=>{
    return {
        [(0, $5MrbU.CategoryStorageType).Cookies]: $a7a2952a55bc1a52$var$generateResourcePath('commercial', "COOKIE", useFlatFormat),
        [(0, $5MrbU.CategoryStorageType).LocalStorage]: $a7a2952a55bc1a52$var$generateResourcePath('commercial', "LOCAL_STORAGE", useFlatFormat),
        [(0, $5MrbU.CategoryStorageType).SessionStorage]: $a7a2952a55bc1a52$var$generateResourcePath('commercial', "SESSION_STORAGE", useFlatFormat),
        [(0, $5MrbU.CategoryStorageType).IndexedDB]: $a7a2952a55bc1a52$var$generateResourcePath('commercial', "INDEXED_DB", useFlatFormat)
    };
};
const $a7a2952a55bc1a52$export$9797a362f9385b1a = (useFlatFormat = false)=>{
    return {
        commercial: $a7a2952a55bc1a52$export$5989415260e0cf82(useFlatFormat),
        'fedramp-moderate': {
            [(0, $5MrbU.CategoryStorageType).Cookies]: $a7a2952a55bc1a52$var$generateResourcePath('fedramp-moderate', "COOKIE", useFlatFormat),
            [(0, $5MrbU.CategoryStorageType).LocalStorage]: $a7a2952a55bc1a52$var$generateResourcePath('fedramp-moderate', "LOCAL_STORAGE", useFlatFormat),
            [(0, $5MrbU.CategoryStorageType).SessionStorage]: $a7a2952a55bc1a52$var$generateResourcePath('fedramp-moderate', "SESSION_STORAGE", useFlatFormat),
            [(0, $5MrbU.CategoryStorageType).IndexedDB]: $a7a2952a55bc1a52$var$generateResourcePath('fedramp-moderate', "INDEXED_DB", useFlatFormat)
        }
    };
};
const $a7a2952a55bc1a52$export$1f60178895e28eb8 = (source, perimeter, storageType)=>{
    const useFlatFormat = (0, $egspI.fg)('platform_bsc_flat_pattern_file_structure');
    return $a7a2952a55bc1a52$var$generateResourcePath(perimeter, storageType, useFlatFormat);
};

});



parcelRegister("4CHTG", function(module, exports) {
$parcel$export(module.exports, "cleanupStorage", () => $a9cea9b783a7b514$export$e6332b39565fb2b3);

var $lO5Ez = parcelRequire("lO5Ez");

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");
var $j1sAG = parcelRequire("j1sAG");
var $2rFtA = parcelRequire("2rFtA");

var $bDj2g = parcelRequire("bDj2g");

var $4fPPi = parcelRequire("4fPPi");

var $5MrbU = parcelRequire("5MrbU");

var $eTDvj = parcelRequire("eTDvj");

var $fg6Qq = parcelRequire("fg6Qq");
function $a9cea9b783a7b514$var$isCategoryRevoked({ category: category, preferences: preferences }) {
    if (category === (0, $5MrbU.PreferenceCategory).StrictlyNecessary) return false;
    if (!preferences) return false;
    return !preferences[category];
}
function $a9cea9b783a7b514$var$yieldToMain() {
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const $a9cea9b783a7b514$var$ITEMS_PER_YIELD = 50;
const $a9cea9b783a7b514$var$ITEM_CAP = 500;
async function $a9cea9b783a7b514$export$e6332b39565fb2b3() {
    try {
        const cleanupStartTime = performance.now();
        const globalState = (0, $c1I7W.getBscGlobalState)();
        const preferences = await (0, $eTDvj.getPreferences)();
        const localStorage = (0, $4fPPi.findStorageTarget)((0, $4fPPi.WebStorageType).LocalStorage);
        const sessionStorage = (0, $4fPPi.findStorageTarget)((0, $4fPPi.WebStorageType).SessionStorage);
        const idb = window.indexedDB;
        const productName = globalState.product;
        const [localStorageCache, sessionStorageCache, cookieCache, indexedDBCache] = await Promise.all([
            globalState.loadCache((0, $5MrbU.CategoryStorageType).LocalStorage),
            globalState.loadCache((0, $5MrbU.CategoryStorageType).SessionStorage),
            globalState.loadCache((0, $5MrbU.CategoryStorageType).Cookies),
            globalState.loadCache((0, $5MrbU.CategoryStorageType).IndexedDB)
        ]);
        const revokedItems = [];
        const uncategorizedItems = [];
        let hitEnumerationLimit = false;
        let itemsProcessed = 0;
        let deletionCount = 0;
        // localStorage
        const shouldDeleteWebStorage = !globalState.disableWebStorageConsentChecks && globalState.webStorageEnabled;
        if (localStorageCache) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        for(let i = 0; i < localStorage.length(); i++){
            if (itemsProcessed >= $a9cea9b783a7b514$var$ITEM_CAP) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $a9cea9b783a7b514$var$ITEMS_PER_YIELD === 0) await $a9cea9b783a7b514$var$yieldToMain();
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const key = localStorage.key(i);
            if (key === null) continue;
            const category = (0, $bDj2g.getItemCategoryFromPassedCache)(key, localStorageCache, productName);
            if (category === null || category === (0, $5MrbU.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'localStorage'
            });
            else if ($a9cea9b783a7b514$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                revokedItems.push({
                    key: key,
                    storageType: 'localStorage',
                    category: category
                });
                if (shouldDeleteWebStorage && (0, $egspI.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.removeItem(key);
                    i--; // removing an item shifts later ones; use same index for the next iteration
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // sessionStorage
        if (!hitEnumerationLimit && sessionStorageCache) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        for(let i = 0; i < sessionStorage.length(); i++){
            if (itemsProcessed >= $a9cea9b783a7b514$var$ITEM_CAP) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $a9cea9b783a7b514$var$ITEMS_PER_YIELD === 0) await $a9cea9b783a7b514$var$yieldToMain();
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const key = sessionStorage.key(i);
            if (key === null) continue;
            const category = (0, $bDj2g.getItemCategoryFromPassedCache)(key, sessionStorageCache, productName);
            if (category === null || category === (0, $5MrbU.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'sessionStorage'
            });
            else if ($a9cea9b783a7b514$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                revokedItems.push({
                    key: key,
                    storageType: 'sessionStorage',
                    category: category
                });
                if (shouldDeleteWebStorage && (0, $egspI.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    sessionStorage.removeItem(key);
                    i--; // removing an item shifts later ones; use same index for the next iteration
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // cookies
        if (!hitEnumerationLimit && cookieCache) for (const key of Object.keys((0, $lO5Ez.default).get())){
            if (itemsProcessed >= $a9cea9b783a7b514$var$ITEM_CAP) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $a9cea9b783a7b514$var$ITEMS_PER_YIELD === 0) await $a9cea9b783a7b514$var$yieldToMain();
            const category = (0, $bDj2g.getItemCategoryFromPassedCache)(key, cookieCache, productName);
            if (category === null || category === (0, $5MrbU.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'cookie'
            });
            else if ($a9cea9b783a7b514$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                revokedItems.push({
                    key: key,
                    storageType: 'cookie',
                    category: category
                });
                // There's no corresponding `shouldDeleteWebStorage` for cookies as they have no reporting-only mode.
                if ((0, $egspI.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    (0, $fg6Qq.deleteCookie)(key);
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // IndexedDB
        const shouldDeleteIdb = !globalState.disableIndexedDbConsentChecks && globalState.indexedDbEnabled;
        if (!hitEnumerationLimit && indexedDBCache && typeof idb?.databases === 'function') try {
            const dbs = await idb.databases();
            for (const db of dbs){
                if (itemsProcessed >= $a9cea9b783a7b514$var$ITEM_CAP) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $a9cea9b783a7b514$var$ITEMS_PER_YIELD === 0) await $a9cea9b783a7b514$var$yieldToMain();
                const name = db.name;
                if (name === undefined) continue;
                const category = (0, $bDj2g.getItemCategoryFromPassedCache)(name, indexedDBCache, productName);
                if (category === null || category === (0, $5MrbU.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: name,
                    storageType: 'indexedDB'
                });
                else if ($a9cea9b783a7b514$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    revokedItems.push({
                        key: name,
                        storageType: 'indexedDB',
                        category: category
                    });
                    if (shouldDeleteIdb && (0, $egspI.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                        const request = idb.deleteDatabase(name);
                        request.onerror = ()=>{
                            (0, $j1sAG.Logger).warn(`cleanupStorage: failed to delete IndexedDB "${name}": ${request.error?.message ?? ''}`);
                        };
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        } catch  {
        // idb.databases() unavailable or threw — skip IDB entirely
        }
        if (deletionCount > 0) (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'storageCleanupDeleted',
            attributes: {
                deletedCount: deletionCount
            }
        });
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'storageCleanupCategorized',
            attributes: {
                durationMs: Math.round(performance.now() - cleanupStartTime),
                deletionMode: (0, $egspI.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
                revokedCount: revokedItems.length,
                revokedItems: revokedItems.map(({ storageType: storageType, key: key, category: category })=>`${storageType} ${key} ${category}`),
                uncategorizedCount: uncategorizedItems.length,
                uncategorizedItems: uncategorizedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`),
                hitEnumerationLimit: hitEnumerationLimit
            }
        });
        return {
            deletionMode: (0, $egspI.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
            revokedItems: revokedItems,
            uncategorizedItems: uncategorizedItems,
            hitEnumerationLimit: hitEnumerationLimit
        };
    } catch (error) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'storageCleanupError',
            message: `cleanupStorage failed: ${error?.message ?? 'no message'}`
        });
        return {
            deletionMode: (0, $egspI.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
            revokedItems: [],
            uncategorizedItems: [],
            hitEnumerationLimit: false
        };
    }
}

});

parcelRegister("l4jKk", function(module, exports) {
$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $845abe65dcf51050$export$45a5573b04db016c);

var $j1sAG = parcelRequire("j1sAG");

var $h6Hyz = parcelRequire("h6Hyz");
const $845abe65dcf51050$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $j1sAG.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $h6Hyz.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

});
parcelRegister("h6Hyz", function(module, exports) {
$parcel$export(module.exports, "getSetCookieOverride", () => $dbd9b5a7b8c5db50$export$b7364c41ddbfdb0a);

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");
var $2rFtA = parcelRequire("2rFtA");

var $2rFtA = parcelRequire("2rFtA");

var $bDj2g = parcelRequire("bDj2g");

var $j1sAG = parcelRequire("j1sAG");

var $5MrbU = parcelRequire("5MrbU");
const $dbd9b5a7b8c5db50$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $2rFtA.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $c1I7W.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, $bDj2g.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory })=>{
                        if (!itemHasCategory) (0, $2rFtA.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: (0, $5MrbU.CategoryStorageType).Cookies,
                                productName: productName,
                                originalItemKey: sanitizedCookieKey,
                                itemCategory: itemCategory ?? null,
                                ...(0, $egspI.fg)('platform_bsc_cache_load_date') && {
                                    cacheLoadedDate: (0, $c1I7W.getBscGlobalState)().cacheLoadedDate ?? null
                                }
                            }
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $c1I7W.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $j1sAG.Logger).warn(`document.cookie setter for '${sanitizedCookieKey}' was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${sanitizedCookieKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: (0, $5MrbU.CategoryStorageType).Cookies,
                    productName: productName
                });
            } catch (e) {
                (0, $j1sAG.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

});


parcelRegister("e5dm8", function(module, exports) {
$parcel$export(module.exports, "createIndexedDBPassthrough", () => $e5152eeb61f91213$export$a03098708eb0de1);

var $j1sAG = parcelRequire("j1sAG");

var $6vxM5 = parcelRequire("6vxM5");
const $e5152eeb61f91213$export$a03098708eb0de1 = async (config)=>{
    const indexedDB = window.indexedDB;
    if (!indexedDB) {
        (0, $j1sAG.Logger).warn('No IndexedDB capabilities found');
        return;
    }
    if (typeof indexedDB.open !== 'function') {
        (0, $j1sAG.Logger).warn('IndexedDB.open is not a function');
        return;
    }
    try {
        const originalOpen = indexedDB.open.bind(indexedDB);
        (0, $j1sAG.Logger).debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);
        // Use Object.defineProperty for better browser compatibility and consistency
        // with other passthrough implementations (document.cookie, localStorage/sessionStorage)
        Object.defineProperty(indexedDB, 'open', {
            value: config.performConsentChecks ? (0, $6vxM5.getIndexedDBOpenOverride)(originalOpen) : (0, $6vxM5.getIndexedDBOpenOverrideEventOnly)(originalOpen),
            writable: true,
            configurable: true
        });
        (0, $j1sAG.Logger).debug('IndexedDB open override installed');
    } catch (e) {
        (0, $j1sAG.Logger).error(`Failed to install IndexedDB open override. ${e.message || ''}`);
    }
};

});
parcelRegister("6vxM5", function(module, exports) {
$parcel$export(module.exports, "getIndexedDBOpenOverrideEventOnly", () => $aeae0cf7e9d8ec49$export$5a412306febb78c);
$parcel$export(module.exports, "getIndexedDBOpenOverride", () => $aeae0cf7e9d8ec49$export$5721aa15a04b1881);

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");
var $2rFtA = parcelRequire("2rFtA");

var $bDj2g = parcelRequire("bDj2g");

var $j1sAG = parcelRequire("j1sAG");

var $fXApL = parcelRequire("fXApL");

var $vHD2x = parcelRequire("vHD2x");

var $lbJxq = parcelRequire("lbJxq");

var $5MrbU = parcelRequire("5MrbU");
// DatabaseBlockedError extends DOMException in browser environments, but DOMException is not
// available in SSR/Node.js, which causes import errors. We conditionally extend DOMException
// only when it is available, falling back to a plain Error in SSR — the same pattern used
// for IDBOpenDBRequestWrapper.
let $aeae0cf7e9d8ec49$var$DatabaseBlockedError;
if (typeof DOMException !== 'undefined') $aeae0cf7e9d8ec49$var$DatabaseBlockedError = class DatabaseBlockedError extends DOMException {
};
else $aeae0cf7e9d8ec49$var$DatabaseBlockedError = class DatabaseBlockedError extends Error {
    constructor(message, name = 'DatabaseBlockedError'){
        super(message), this.name = name;
    }
};
const $aeae0cf7e9d8ec49$var$checkAndSendAnalyticsEvent = async (eventDetails)=>{
    const wasSetByPackage = (0, $lbJxq.ItemKeyCache).wasSetByPackage((0, $5MrbU.CategoryStorageType).IndexedDB, eventDetails.databaseName);
    const productName = (0, $c1I7W.getBscGlobalState)().product;
    const itemCategory = await (0, $bDj2g.getItemCategory)(eventDetails.databaseName, (0, $5MrbU.CategoryStorageType).IndexedDB, productName);
    const isStrictlyNecessary = itemCategory === (0, $5MrbU.PreferenceCategory).StrictlyNecessary;
    if (!isStrictlyNecessary && !wasSetByPackage) {
        const categoryAttribute = (0, $egspI.fg)('platform_bsc_add_category_to_idb_open_events') ? {
            itemCategory: itemCategory ?? (0, $5MrbU.PreferenceCategory).Unknown
        } : {};
        const attributes = {
            ...eventDetails,
            productName: productName,
            outsidePackage: true,
            ...categoryAttribute
        };
        // Send analytics event for uncategorized IndexedDB usage
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedAtlIndexedDBOpen',
            attributes: attributes
        });
    }
};
const $aeae0cf7e9d8ec49$var$checkIfAllowed = async (dbName)=>{
    if (!(0, $vHD2x.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $c1I7W.getBscGlobalState)().product;
    return (0, $bDj2g.isProcessingAllowedByPreferences)({
        itemKey: dbName,
        storageType: (0, $5MrbU.CategoryStorageType).IndexedDB,
        productName: productName
    });
};
const $aeae0cf7e9d8ec49$var$checkIfAllowedWithCategory = async (dbName)=>{
    if (!(0, $vHD2x.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $c1I7W.getBscGlobalState)().product;
    const { isAllowed: isAllowed, itemCategory: itemCategory } = await (0, $bDj2g.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, $5MrbU.CategoryStorageType).IndexedDB,
        productName: productName
    });
    return {
        isAllowed: isAllowed,
        itemCategory: itemCategory
    };
};
const $aeae0cf7e9d8ec49$export$5a412306febb78c = (originalOpen)=>(databaseName, version)=>{
        $aeae0cf7e9d8ec49$var$checkAndSendAnalyticsEvent({
            databaseName: databaseName
        }).catch((e)=>{
            (0, $j1sAG.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
        });
        // Always allow the operation to proceed (we're only tracking usage)
        return originalOpen(databaseName, version);
    };
const $aeae0cf7e9d8ec49$export$5721aa15a04b1881 = (originalOpen)=>(databaseName, version)=>{
        const wasSetByPackage = (0, $lbJxq.ItemKeyCache).wasSetByPackage((0, $5MrbU.CategoryStorageType).IndexedDB, databaseName);
        if (wasSetByPackage) return originalOpen(databaseName, version);
        if ((0, $egspI.fg)('jfp-magma-selective-storage-enforcement')) {
            // Per-key opt-out: when `disableIndexedDbConsentChecks` is on, `__UNSAFE_shouldEnforceKeyForRollout`
            // can re-enable enforcement for this database name; otherwise fall back to
            // analytics-only behaviour.
            const globalState = (0, $c1I7W.getBscGlobalState)();
            const enforceThisKey = globalState.__UNSAFE_shouldEnforceKeyForRollout?.(databaseName, (0, $5MrbU.CategoryStorageType).IndexedDB) === true;
            const disableIndexedDbConsentChecks = (globalState.disableIndexedDbConsentChecks ?? false) && !enforceThisKey;
            if (disableIndexedDbConsentChecks) {
                $aeae0cf7e9d8ec49$var$checkAndSendAnalyticsEvent({
                    databaseName: databaseName
                }).catch((e)=>{
                    (0, $j1sAG.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
                });
                return originalOpen(databaseName, version);
            }
        }
        (0, $j1sAG.Logger).debug(`IndexedDB operation: overridden open on database \"${databaseName}\"`, {
            version: String(version ?? 'unspecified')
        });
        const requestWrapper = (0, $fXApL.createIDBOpenDBRequestWrapper)();
        // We need category information when either the category analytics gate or the uncategorized
        // passthrough gate is on so that we can distinguish "uncategorized" from "user-denied".
        // `fg(...)` is evaluated inline (not stored in a variable) so gate cleanup stays a simple
        // grep-and-delete. The uncategorized-override config is read once here into a local.
        const allowUncategorizedOverride = (0, $egspI.fg)('platform_bsc_allow_uncategorized_idb_overrides') && !!(0, $c1I7W.getBscGlobalState)().allowUncategorizedItemsInIndexedDBOverrides;
        const needsCategoryInfo = (0, $egspI.fg)('platform_bsc_add_category_to_idb_open_events') || allowUncategorizedOverride;
        const allowedPromise = needsCategoryInfo ? $aeae0cf7e9d8ec49$var$checkIfAllowedWithCategory(databaseName).then(({ isAllowed: isAllowed, itemCategory: itemCategory })=>({
                isAllowed: isAllowed,
                itemCategory: itemCategory ?? (0, $5MrbU.PreferenceCategory).Unknown,
                categoryAttribute: (0, $egspI.fg)('platform_bsc_add_category_to_idb_open_events') ? {
                    itemCategory: itemCategory ?? (0, $5MrbU.PreferenceCategory).Unknown
                } : {}
            })) : $aeae0cf7e9d8ec49$var$checkIfAllowed(databaseName).then((isAllowed)=>({
                isAllowed: isAllowed,
                itemCategory: null,
                categoryAttribute: {}
            }));
        allowedPromise.then(({ isAllowed: isAllowed, itemCategory: itemCategory, categoryAttribute: categoryAttribute })=>{
            // When `allowUncategorizedItemsInIndexedDBOverrides` is enabled, databases that have
            // no known category (null/Unknown) are allowed through instead of being blocked. This
            // is a rollout-safety valve — only uncategorized DBs are affected; DBs that are
            // categorized but user-denied are still blocked regardless of this flag.
            const isUncategorized = itemCategory == null || itemCategory === (0, $5MrbU.PreferenceCategory).Unknown;
            const resolvedIsAllowed = isAllowed || allowUncategorizedOverride && isUncategorized;
            (0, $2rFtA.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpen',
                attributes: {
                    databaseName: databaseName,
                    wasRejected: !resolvedIsAllowed,
                    outsidePackage: true,
                    ...categoryAttribute
                }
            });
            if (resolvedIsAllowed) {
                (0, $j1sAG.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was ALLOWED`, {
                    version: String(version ?? 'unspecified')
                });
                const actualRequest = originalOpen(databaseName, version);
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $j1sAG.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was REJECTED`, {
                    version: String(version ?? 'unspecified')
                });
                const error = new $aeae0cf7e9d8ec49$var$DatabaseBlockedError('The database was blocked by consent preferences', 'storageItemBlocked');
                const errorEvent = new ErrorEvent('error', {
                    message: error.message,
                    error: error
                });
                requestWrapper.setError(error);
                requestWrapper.dispatchEvent(errorEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $j1sAG.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" ERROR: ${errorMessage}`, {
                version: String(version ?? 'unspecified')
            });
            (0, $j1sAG.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: databaseName,
                    outsidePackage: true
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage,
                error: e
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    };

});
parcelRegister("fXApL", function(module, exports) {
$parcel$export(module.exports, "createIDBOpenDBRequestWrapper", () => $39725925175b253b$export$4037ef1f5b40c4b6);

var $glbdM = parcelRequire("glbdM");

var $hRda6 = parcelRequire("hRda6");

var $c4w52 = parcelRequire("c4w52");
// Store the browser implementation class here - defined conditionally below
let $39725925175b253b$var$BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
$39725925175b253b$var$BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    // Implementing IDBRequest readonly properties with getters
    get error() {
        return this._wrappedRequest?.error ?? this._error;
    }
    get result() {
        return this._wrappedRequest?.result ?? this._result;
    }
    get readyState() {
        return this._wrappedRequest?.readyState ?? this._readyState;
    }
    get source() {
        return this._wrappedRequest?.source ?? this._source;
    }
    get transaction() {
        return this._wrappedRequest?.transaction ?? this._transaction;
    }
    /**
		 * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
		 * Once wrapped, all property getters will delegate to the wrapped request,
		 * and all events from the wrapped request will be re-dispatched on this wrapper.
		 *
		 * @param request - The real IDBOpenDBRequest to wrap
		 */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, $glbdM.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
		 * Check if this mock is wrapping a real request
		 */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
		 * Get the wrapped request (if any)
		 */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
		 * Unbind all event listeners attached to the wrapped request.
		 * Should be called when the wrapper is no longer needed.
		 */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
		 * Set the error property (normally readonly)
		 * Only works when not wrapping another request
		 */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
		 * Set the result property (normally readonly)
		 * Only works when not wrapping another request
		 */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
		 * Set the readyState property (normally readonly)
		 * Only works when not wrapping another request
		 */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
		 * Set the source property (normally readonly)
		 * Only works when not wrapping another request
		 */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
		 * Set the transaction property (normally readonly)
		 * Only works when not wrapping another request
		 */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
		 * Override dispatchEvent to also call the corresponding event handler if set
		 */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
    constructor(...args){
        super(...args), this._error = null, this._result = null, this._readyState = 'pending', this._source = null, this._transaction = null, this._wrappedRequest = null, this._unbindEventListeners = null, // Event handler properties (can be set directly by consumers)
        this.onerror = null, this.onsuccess = null, this.onblocked = null, this.onupgradeneeded = null;
    }
};
function $39725925175b253b$export$4037ef1f5b40c4b6() {
    if ((0, $hRda6.isSSR)() || typeof EventTarget === 'undefined' || !$39725925175b253b$var$BrowserImpl) return new (0, $c4w52.IDBOpenDBRequestNoOp)();
    return new $39725925175b253b$var$BrowserImpl();
}
const $39725925175b253b$export$c69b1cb39abae960 = $39725925175b253b$var$BrowserImpl;

});
parcelRegister("c4w52", function(module, exports) {
$parcel$export(module.exports, "IDBOpenDBRequestNoOp", () => $5a6f42954c62a3f7$export$55ffeaf417e03b66);
/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ class $5a6f42954c62a3f7$export$55ffeaf417e03b66 {
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
    constructor(){
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
}

});


parcelRegister("vHD2x", function(module, exports) {
$parcel$export(module.exports, "checkDBAvailability", () => $977685054a18df44$export$ae0d255aec75942);
$parcel$export(module.exports, "isValidDBName", () => $977685054a18df44$export$a5be9a74f3347ccf);
$parcel$export(module.exports, "isValidVersion", () => $977685054a18df44$export$396291456af4fc3);

var $c1I7W = parcelRequire("c1I7W");
var $hRda6 = parcelRequire("hRda6");
function $977685054a18df44$export$ae0d255aec75942(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, $hRda6.isSSR)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, $c1I7W.getBscGlobalState)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function $977685054a18df44$export$a5be9a74f3347ccf(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function $977685054a18df44$export$396291456af4fc3(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}

});



parcelRegister("9uE6b", function(module, exports) {
$parcel$export(module.exports, "createWebStoragePassthrough", () => $ef9492db35d1b4cf$export$619fe705922e5d61);

var $egspI = parcelRequire("egspI");

var $j1sAG = parcelRequire("j1sAG");

var $32VVg = parcelRequire("32VVg");

var $4fPPi = parcelRequire("4fPPi");

var $4jkBf = parcelRequire("4jkBf");
const $ef9492db35d1b4cf$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $4fPPi.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $j1sAG.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $32VVg.BSCIndexedDB).isAvailable) {
        (0, $j1sAG.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $32VVg.BSCIndexedDB).isBooted) {
        if ((0, $egspI.fg)('cookies-bsc-timeout-for-indexeddb')) try {
            await (0, $32VVg.BSCIndexedDB).boot();
        } catch  {
            (0, $j1sAG.Logger).warn('IndexedDB boot failed, proceeding without IDB tracking');
        }
        else await (0, $32VVg.BSCIndexedDB).boot();
    }
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $4jkBf.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, $4fPPi.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

});
parcelRegister("4jkBf", function(module, exports) {
$parcel$export(module.exports, "setItemOverride", () => $d7e6ed6d3fd7f079$export$b4469df6294ea6aa);

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");
var $2rFtA = parcelRequire("2rFtA");

var $2rFtA = parcelRequire("2rFtA");

var $bDj2g = parcelRequire("bDj2g");

var $j1sAG = parcelRequire("j1sAG");

var $lbJxq = parcelRequire("lbJxq");

var $4fPPi = parcelRequire("4fPPi");

var $jTLe5 = parcelRequire("jTLe5");

var $5MrbU = parcelRequire("5MrbU");
const $d7e6ed6d3fd7f079$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const categoryStorageType = storageType === (0, $4fPPi.WebStorageType).LocalStorage ? (0, $5MrbU.CategoryStorageType).LocalStorage : (0, $5MrbU.CategoryStorageType).SessionStorage;
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        itemSetByPackage = (0, $lbJxq.ItemKeyCache).wasSetByPackage(categoryStorageType, originalItemKey);
        // `disableWebStorageConsentChecks` is read from the package global state so the
        // behaviour stays consistent with other consent-check flags (rather than being
        // threaded through props/options on every call site). When set, the override
        // always passes through to the underlying storage and only emits analytics
        // events — `AtlBrowserStorage` behaviour is preserved.
        let disableWebStorageConsentChecks = (0, $c1I7W.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
        if ((0, $egspI.fg)('jfp-magma-selective-storage-enforcement')) {
            // `disableWebStorageConsentChecks` skips the consent pipeline (analytics-only),
            // but `__UNSAFE_shouldEnforceKeyForRollout(key, type) === true` re-enables enforcement for this key.
            const categoryStorageType = storageType === (0, $4fPPi.WebStorageType).LocalStorage ? (0, $5MrbU.CategoryStorageType).LocalStorage : (0, $5MrbU.CategoryStorageType).SessionStorage;
            const __UNSAFE_shouldEnforceKeyForRollout = (0, $c1I7W.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
            const enforceThisKey = __UNSAFE_shouldEnforceKeyForRollout?.(originalItemKey, categoryStorageType) === true;
            disableWebStorageConsentChecks = ((0, $c1I7W.getBscGlobalState)().disableWebStorageConsentChecks ?? false) && !enforceThisKey;
        }
        if (disableWebStorageConsentChecks) {
            try {
                (0, $lbJxq.ItemKeyCache).markSetByPackage(categoryStorageType, originalItemKey);
                originalSetItem.apply(storageContext, [
                    originalItemKey,
                    originalItemValue
                ]);
            } catch (e) {
                (0, $jTLe5.reportSetItemError)({
                    message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: !itemSetByPackage,
                        storageType: storageType,
                        consentChecksDisabled: true
                    },
                    error: e
                });
            }
            let wasCheckAsync = true;
            try {
                const productName = (0, $c1I7W.getBscGlobalState)().product;
                const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $c1I7W.getBscGlobalState)();
                // trigger the callbacks to emit analytics events but do nothing with the result.
                (0, $bDj2g.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $2rFtA.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $2rFtA.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                        if (!itemHasCategory) (0, $2rFtA.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides,
                                allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides,
                                consentChecksDisabled: true,
                                wasAsync: wasAsync,
                                ...(0, $egspI.fg)('platform_bsc_cache_load_date') && {
                                    cacheLoadedDate: (0, $c1I7W.getBscGlobalState)().cacheLoadedDate ?? null
                                }
                            }
                        });
                    },
                    storageType: categoryStorageType,
                    productName: productName
                });
            } catch (e) {
                (0, $jTLe5.reportSetItemError)({
                    message: `Failed to emit analytics with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        consentChecksDisabled: true,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
            }
            return;
        }
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $jTLe5.reportSetItemError)({
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                },
                error: e
            });
        }
        try {
            let wasCheckAsync = true;
            try {
                const productName = (0, $c1I7W.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, $bDj2g.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $2rFtA.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $2rFtA.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        if (!itemHasCategory) (0, $2rFtA.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                wasAsync: wasAsync,
                                ...(0, $egspI.fg)('platform_bsc_cache_load_date') && {
                                    cacheLoadedDate: (0, $c1I7W.getBscGlobalState)().cacheLoadedDate ?? null
                                }
                            }
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $c1I7W.getBscGlobalState)();
                        // allowUncategorizedCookiesInOverrides impacts both web storage and cookies due to historical reasons
                        const allowUncategorized = allowUncategorizedCookiesInOverrides || allowUncategorizedItemsInWebStorageOverrides;
                        if (allowUncategorized && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $j1sAG.Logger).warn(`${storageType}.setItem('${originalItemKey}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${originalItemKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: categoryStorageType,
                    productName: productName
                });
            } catch (e) {
                (0, $jTLe5.reportSetItemError)({
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
            }
        } catch (e) {
            (0, $jTLe5.reportSetItemError)({
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`,
                error: e
            });
        }
    };

});



parcelRegister("4yn95", function(module, exports) {
$parcel$export(module.exports, "removeLegacyTimestampNamespaceKeys", () => $f564be6e75fcfc71$export$91fe675779d6b157);
/**
 * Removes all localStorage and sessionStorage keys that were written with the legacy
 * "timestamps" namespace format (storejs plugin: __storejs_<appPrefix>_timestamps_<key>).
 * Call this on app init to reclaim space and avoid duplicate timestamp entries when
 * migrating to a single metadata key approach.
 */ const $f564be6e75fcfc71$var$STOREJS_PREFIX = '__storejs_';
const $f564be6e75fcfc71$var$TIMESTAMPS_NAMESPACE_MARKER = '_timestamps';
function $f564be6e75fcfc71$var$removeLegacyKeysFromStorage(storage) {
    for(let i = storage.length - 1; i >= 0; i--){
        const key = storage.key(i);
        if (key && key.startsWith($f564be6e75fcfc71$var$STOREJS_PREFIX) && key.includes($f564be6e75fcfc71$var$TIMESTAMPS_NAMESPACE_MARKER)) storage.removeItem(key);
    }
}
function $f564be6e75fcfc71$export$91fe675779d6b157() {
    const win = globalThis.window;
    if (typeof win === 'undefined') return;
    if (typeof win.localStorage !== 'undefined') $f564be6e75fcfc71$var$removeLegacyKeysFromStorage(win.localStorage);
    if (typeof win.sessionStorage !== 'undefined') $f564be6e75fcfc71$var$removeLegacyKeysFromStorage(win.sessionStorage);
}

});

parcelRegister("jBDHl", function(module, exports) {
$parcel$export(module.exports, "shouldEnforceKeyForRollout", () => $e73f123fcd7f353c$export$5dd396b9dc16319d);
/**
 * Browser Storage Controls — batched enforcement rollout (Jira-owned web-storage keys).
 *
 * Selectively re-enables consent enforcement for individual local-/session-storage
 * keys while the product is otherwise in analytics-only mode
 * (`disableWebStorageConsentChecks`). Each batch is gated by its own feature gate so
 * enforcement can be ramped a few keys at a time and rolled back per batch.
 *
 * The platform package consults this callback ONLY when:
 *   - `disableWebStorageConsentChecks` is true (analytics-only mode), AND
 *   - `fg('jfp-magma-selective-storage-enforcement')` is on.
 * Returning `true` re-enables the consent pipeline for that single key.
 *
 * Matching mirrors the platform categorizer precedence so the gate consulted always
 * matches the entry that decides the key's category:
 *   exact key  >  longest startsWith  >  longest endsWith  >  regexp.
 *
 * The batch definitions live in the generated `./rolloutBatches.constants.tsx` module. Once
 * `jfp-vulcan-browser-storage-enabled(-legacy)` is fully on, this callback is a no-op
 * and both modules + their gates can be deleted.
 */ 
var $5MrbU = parcelRequire("5MrbU");

var $i860n = parcelRequire("i860n");

var $51pUV = parcelRequire("51pUV");
const $e73f123fcd7f353c$var$LOCAL = (0, $5MrbU.CategoryStorageType).LocalStorage;
const $e73f123fcd7f353c$var$SESSION = (0, $5MrbU.CategoryStorageType).SessionStorage;
const $e73f123fcd7f353c$var$IDB = (0, $5MrbU.CategoryStorageType).IndexedDB;
const $e73f123fcd7f353c$var$createLookup = ()=>({
        exact: new Map(),
        startsWith: [],
        endsWith: [],
        regexp: []
    });
// Combined ramp. Drop `...SN_ROLLOUT_BATCHES` here to remove the strictly-necessary
// canary once the non-SN batches are fully rolled out. `CROSS_PRODUCT_ROLLOUT_BATCHES` covers
// `product = all` keys (their own 30-capped gates) and `MONOLITH_ROLLOUT_BATCHES` covers Jira
// monolith-owned keys; both ramp independently of the AFM team batches.
const $e73f123fcd7f353c$var$ALL_ROLLOUT_BATCHES = [
    ...(0, $51pUV.SN_ROLLOUT_BATCHES),
    ...(0, $51pUV.ROLLOUT_BATCHES),
    ...(0, $51pUV.CROSS_PRODUCT_ROLLOUT_BATCHES),
    ...(0, $51pUV.MONOLITH_ROLLOUT_BATCHES)
];
// Spreads one storage's column (exact/startsWith/endsWith/regexp string arrays) into the
// lookup. Extracted out of `buildLookups` so the per-kind loops aren't nested under the
// batch loop (keeps the work flat and visibly linear in the number of keys).
const $e73f123fcd7f353c$var$indexMatchers = (lookup, matchers, gate)=>{
    for (const value of matchers.exact ?? [])lookup.exact.set(value, gate);
    for (const value of matchers.startsWith ?? [])lookup.startsWith.push({
        token: value,
        gate: gate
    });
    for (const value of matchers.endsWith ?? [])lookup.endsWith.push({
        token: value,
        gate: gate
    });
    for (const value of matchers.regexp ?? [])lookup.regexp.push({
        re: new RegExp(value),
        gate: gate
    });
};
const $e73f123fcd7f353c$var$buildLookups = ()=>{
    const lookups = {
        [$e73f123fcd7f353c$var$LOCAL]: $e73f123fcd7f353c$var$createLookup(),
        [$e73f123fcd7f353c$var$SESSION]: $e73f123fcd7f353c$var$createLookup(),
        [$e73f123fcd7f353c$var$IDB]: $e73f123fcd7f353c$var$createLookup()
    };
    // Runs once at module load over a fixed, bounded list of batches.
    for (const batch of $e73f123fcd7f353c$var$ALL_ROLLOUT_BATCHES){
        if (batch.entries.local) $e73f123fcd7f353c$var$indexMatchers(lookups[$e73f123fcd7f353c$var$LOCAL], batch.entries.local, batch.isEnabled);
        if (batch.entries.session) $e73f123fcd7f353c$var$indexMatchers(lookups[$e73f123fcd7f353c$var$SESSION], batch.entries.session, batch.isEnabled);
        if (batch.entries.indexeddb) $e73f123fcd7f353c$var$indexMatchers(lookups[$e73f123fcd7f353c$var$IDB], batch.entries.indexeddb, batch.isEnabled);
    }
    // Sort token candidates by length descending so the longest-match lookup can return
    // on the first matching token instead of scanning the whole array on every call.
    for (const lookup of [
        lookups[$e73f123fcd7f353c$var$LOCAL],
        lookups[$e73f123fcd7f353c$var$SESSION],
        lookups[$e73f123fcd7f353c$var$IDB]
    ]){
        lookup.startsWith.sort((a, b)=>b.token.length - a.token.length);
        lookup.endsWith.sort((a, b)=>b.token.length - a.token.length);
    }
    return lookups;
};
const $e73f123fcd7f353c$var$LOOKUPS = $e73f123fcd7f353c$var$buildLookups();
// `candidates` is pre-sorted by token length descending in `buildLookups`, so the first
// match is the longest match.
const $e73f123fcd7f353c$var$findLongestTokenGate = (candidates, predicate)=>candidates.find(({ token: token })=>predicate(token))?.gate;
const $e73f123fcd7f353c$export$5dd396b9dc16319d = (key, keyType)=>{
    const lookup = $e73f123fcd7f353c$var$LOOKUPS[keyType];
    const gate = lookup.exact.get(key) ?? $e73f123fcd7f353c$var$findLongestTokenGate(lookup.startsWith, (token)=>key.startsWith(token)) ?? $e73f123fcd7f353c$var$findLongestTokenGate(lookup.endsWith, (token)=>key.endsWith(token)) ?? lookup.regexp.find(({ re: re })=>re.test(key))?.gate;
    if (gate) return gate();
    // Unbatched keys fall through to a per-storage-type catch-all so they can be ramped
    // (and rolled back) independently of the per-batch gates.
    if (keyType === $e73f123fcd7f353c$var$IDB) {
        if (!(0, $i860n.fg)('jfp-magma-indexeddb-rollout-default')) return false;
        // Keys owned by known browser extensions are excluded from the catch-all gate so that
        // third-party extension storage is never inadvertently blocked by Jira's enforcement
        // ramp. Only evaluated when the catch-all gate is on.
        return !(0, $51pUV.KNOWN_BROWSER_EXTENSION_KEYS).indexeddb.includes(key);
    }
    if (!(0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-default')) return false;
    // Keys owned by known browser extensions are excluded from the catch-all gate so that
    // third-party extension storage is never inadvertently blocked by Jira's enforcement
    // ramp. Only evaluated when the catch-all gate is on.
    return !(0, $51pUV.KNOWN_BROWSER_EXTENSION_KEYS).localOrSession.some((re)=>re.test(key));
};

});
parcelRegister("51pUV", function(module, exports) {
$parcel$export(module.exports, "SN_ROLLOUT_BATCHES", () => $393775676d134593$export$b5c422c1a6a90c28);
$parcel$export(module.exports, "ROLLOUT_BATCHES", () => $393775676d134593$export$8220faa88feef05a);
$parcel$export(module.exports, "CROSS_PRODUCT_ROLLOUT_BATCHES", () => $393775676d134593$export$7e571b50be0a6a2d);
$parcel$export(module.exports, "KNOWN_BROWSER_EXTENSION_KEYS", () => $393775676d134593$export$eeaf6f44e750887c);
$parcel$export(module.exports, "MONOLITH_ROLLOUT_BATCHES", () => $393775676d134593$export$eea5bcbba31420e9);
/**
 * Browser Storage Controls — batched enforcement rollout DATA (Jira + cross-product web-storage keys).
 *
 * GENERATED from the atlassian-cookies `storage-items` list (product = jira or all; other
 * products' keys are left to the catch-all gate) by the `browser-storage-rollout-batches`
 * dev command. Jira strictly-necessary keys share one SN batch; the rest of the Jira keys
 * are grouped by team into a hard cap of 11 batches (the count never grows — incremental
 * runs grow existing batches). Cross-product (`product = all`) keys live in their own
 * CROSS_PRODUCT_ROLLOUT_BATCHES, a hard cap of 2 batches (the count never grows). Do not
 * hand-edit SN_ROLLOUT_BATCHES / ROLLOUT_BATCHES / CROSS_PRODUCT_ROLLOUT_BATCHES — run
 * `yarn dev browser-storage-rollout-batches` to regenerate. MONOLITH_ROLLOUT_BATCHES below
 * is hand-authored (monolith keys, not in the cookies list) and is preserved verbatim across
 * regenerations.
 *
 * Keys are stored columnar (per storage, per match kind) to keep the bundle small. Gate
 * names are string literals (Jira requires literal fg() arguments). Matching and
 * consumption of these batches lives in ./shouldEnforceKeyForRollout.tsx.
 */ 
var $i860n = parcelRequire("i860n");
const $393775676d134593$export$b5c422c1a6a90c28 = [
    // Strictly-necessary keys (all, 58)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-sn'),
        entries: {
            local: {
                exact: [
                    '__storejs_agent-picker_coding-agents-discovery-dismissed',
                    '__storejs_jira-board-stand-up-panel_timer-muted',
                    '__storejs_jira-board-stand-up-panel_timer-value',
                    '__storejs_jira-nav4-benefits-modal_jiraNav4BenefitsModal',
                    '__storejs_jira-redaction-flag_lastViewedTimestamp',
                    '__storejs_jira_plans_calendar-view_plans_calendar_view_settings',
                    '__storejs_jsm-insight-reports-assets-deeplinking-modal_modalOpen',
                    '__storejs_jsm-insight-reports-filters-onboarding-modal_modalOpen',
                    '__storejs_servicedesk-live-chat-common_declined-chats',
                    '__storejs_servicedesk-schedules_wfo-forecasting-banner-dismissal',
                    '__storejs_usage-limits-by-product_usageLimitsByProductCache',
                    'atlassian-analytics.jira',
                    'atlassian-analytics.jira.lock',
                    'gh.nonWorkingDaysShown.version',
                    'lastReloadTimestamp',
                    'liveChatIssueView:sidebar:width',
                    'navigation_next_ui_state',
                    'persist:@portfolio/common/sections2',
                    'plansDependenciesReportZoomOnScroll',
                    'polaris-pendo-strictly-necessary',
                    'reloadAttempts',
                    'this_site_organization_id',
                    'atlassian-analytics.unknown.lock',
                    'gh.presentation.mode',
                    'gh.welcomeMode'
                ],
                startsWith: [
                    '@atlassiansox/flight-deck-frontend-client_app-switcher-fe_prod_commercial',
                    '__storejs___storejs_',
                    '__storejs_issue-drafts_',
                    '__storejs_polaris_description.draft.',
                    'aiMateChatLoadPreference',
                    'description.draft',
                    'jsm.cs.customers-list.import.media.id_',
                    'jsm.cs.organizations-list.import.media.id_',
                    'ld:',
                    'nav-platform-sidebar-state',
                    'polaris.description.draft.',
                    'rovo-navigation-filters-',
                    'rovo-reintroduction-modal.dismissed',
                    'showBlockedAppsBanner-',
                    'statsig.session_id.',
                    'timelineToken_'
                ],
                endsWith: [
                    '568765c2-daf3-47fb-7b95-fe1569e5a0d9',
                    'rovo.fomo.nudge.dismissed',
                    'search-combined-config'
                ],
                regexp: [
                    '^__storejs_jwm-view-preferences_[^_]+_[^_]+_filter$',
                    '^__storejs_jwm-view-preferences_[^_]+_[^_]+_hideDone$',
                    '^__storejs_jwm-view-preferences_[^_]+_[^_]+_sorting$',
                    '^__storejs_jwm-view-preferences_[^_]+_list_fieldsDetail$',
                    '^__storejs_jwm-view-preferences_[^_]+_list_groupBy$',
                    '^persist:calendar\\/plan\\/[^/]+\\/scenario\\/[^/]+$'
                ]
            },
            session: {
                exact: [
                    '__storejs_onboarding-core_projectCreateJwmOnboarding',
                    '__storejs_servicedesk-live-chat-common_notification-permission-banner-dismissed',
                    '__storejs_sidebar-navigation_back-button-url',
                    'awc.taskSessionsInit',
                    'classicBatchUrl'
                ],
                startsWith: [
                    '__storejs___storejs_',
                    '__storejs_have-i-seen-it-',
                    'addProject:Sel'
                ]
            }
        }
    }
];
const $393775676d134593$export$8220faa88feef05a = [
    // Teams: Astral, Cross flow (Growth), Gordian (30 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-1'),
        entries: {
            local: {
                exact: [
                    '__storejs_assets-schema-tree-sidebar_sidebar-width',
                    '__storejs_jira-assets-sidebar_sideBarWidth',
                    '__storejs_jira-servicedesk-insight-object-details_currentObjectId',
                    '__storejs_jira-servicedesk-insight-object-details_currentTab',
                    '__storejs_jsm-assets-object-usage-info_dismissed',
                    '__storejs_jsm-cbp-common-info_cbp-change-notifications-banner-dismissed',
                    '__storejs_jsm-cbp-common-info_cbp-change-notifications-flag-dismissed',
                    '__storejs_jsm-cbp-pre-release_dismissed',
                    '__storejs_jsm-cmdb-linked-issues-panel_hideResolvedIssues',
                    '__storejs_jsm-cmdb-linked-issues-panel_selectedFilter',
                    '__storejs_jsm-cmdb-linked-issues-panel_selectedFilterCloudId',
                    '__storejs_jsm-cmdb-linked-issues-panel_selectedFilterName',
                    '__storejs_jsm-cmdb-linked-issues-panel_textFieldValue',
                    '__storejs_jsm-cmdb-object-graph_objectGraphConfiguration',
                    '__storejs_jsm-cmdb-schema_viewMode',
                    '__storejs_schema-graph-config_toShowLinksToParentObjects',
                    '__storejs_schema-graph-config_toShowObjectCount',
                    'edit-issue-layout-permission-discovery-message',
                    'edit-workflow-permission-discovery-message',
                    'issuelayout-landing-edit-issue-layout-permission-discovery-message',
                    'manage-versions-permission-discovery-message'
                ],
                startsWith: [
                    '__storejs_cmdb-object-hide-empty-attributes_hideEmptyAttributes_',
                    '__storejs_jira_loom_ad_controls_',
                    '__storejs_jsm-cmdb-insight-object-search_localLastSearchQuery-',
                    '__storejs_jsm-cmdb-insight-object-search_object-type:',
                    '__storejs_jsm-cmdb-insight-object-search_searchMode-',
                    '__storejs_jsm-cmdb-object-graph_objectType',
                    '__storejs_jsm-cmdb-object-timeline_insight_drafts.object_comment.',
                    '__storejs_jsm-cmdb-quick-search_quickSearchSelectedAttrs_schema',
                    '__storejs_uniapa_has-spotlight-been-shown_'
                ]
            }
        }
    },
    // Teams: A4T-Tanuki, Automation Platform / Automation, JFP Magma (27 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-2'),
        entries: {
            local: {
                exact: [
                    '__storejs_backlog_gh.detailViewWidth',
                    '__storejs_backlog_gh.workloadModal.subtasks',
                    '__storejs_backlog_panel-state',
                    '__storejs_backlog_selectedIssueType',
                    '__storejs_number_currency_formatting_changeboarding_flag_local_storage_should_show_number_currency_formatting_changeboarding',
                    '__storejs_software_board-detail-view-mode',
                    '__storejs_software_collapsed-swimlanes',
                    '__storejs_software_gh.detailViewWidth',
                    '__storejs_whiteboardsTouchpoint_whiteboardsExperimentHasClickedOnPulse',
                    '__storejs_whiteboardsTouchpoint_whiteboards_backlog_jira_confluence_data'
                ],
                startsWith: [
                    '__storejs_backlog_gh.backlogCardGroupSettings.',
                    '__storejs_backlog_gh.backlogSettings.',
                    '__storejs_backlog_panel-state-',
                    '__storejs_jira-software-view-settings_view-settings-',
                    '__storejs_software_backlog-filters.',
                    '__storejs_software_board-filters.',
                    '__storejs_software_gh.groupBySelection.',
                    'automation-frontend-ff-overrides-',
                    'automation-rule-id-',
                    'gh.epicShownOnRapidBoard.',
                    'gh.statusShownOnRapidBoard.',
                    'gh.versionShownOnRapidBoard.'
                ]
            },
            session: {
                exact: [
                    '__storejs_navigation_returnToProjectUrl',
                    '__storejs_whiteboards-entrypoint_whiteboard_backlog_jira_ui_button_clicked_confirmbutton_xflow',
                    '__storejs_whiteboards-entrypoint_whiteboard_backlog_jira_ui_user_properties'
                ],
                startsWith: [
                    '__storejs_quickfilters_',
                    'jira.messages'
                ]
            }
        }
    },
    // Teams: Issue View - Pulsar, Issue View - Tenet, Olympus (27 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-3'),
        entries: {
            local: {
                exact: [
                    '__storejs_atl-issue-view-comment_unread-comment-lozenge-viewed',
                    '__storejs_cache_prefix___scope_key__',
                    '__storejs_cache_prefix_board-etag',
                    '__storejs_cache_prefix_components',
                    '__storejs_cache_prefix_epics',
                    '__storejs_cache_prefix_labels',
                    '__storejs_cache_prefix_roadmap-sprint-details-cache',
                    '__storejs_cache_prefix_roadmap-version-details-cache',
                    '__storejs_cache_prefix_sprints',
                    '__storejs_cache_prefix_versions',
                    '__storejs_jira-issue-view-comment-placeholder_hideAddCommentPlaceholder',
                    '__storejs_placeholderTemplateAddProductPermissionStorage_confluence-add-product-permission',
                    'edit_sprint_cache_value'
                ],
                startsWith: [
                    '__storejs_cache_prefix_',
                    '__storejs_confluenceContentPlaceholderTemplate_hasActivatedConfluenceWithinDays_',
                    '__storejs_issue-mobile-section-message_',
                    '__storejs_placeholderTemplateStorage_hasDismissedConfluenceDummyLinkCoUse_',
                    '__storejs_placeholderTemplateStorage_hasDismissedConfluenceDummyLink_',
                    '__storejs_placeholderTemplateStorage_hasDismissedlistViewEntrypoint_',
                    '__storejs_placeholderTemplateStorage_hasDismissedwhiteboardsEntrypoint_'
                ],
                endsWith: [
                    '.issue-panel-pin-to-project.clicked',
                    '_CHILD_WORK_ITEM_TABLE_COLUMN_SORT_CONFIG'
                ]
            },
            session: {
                exact: [
                    '__storejs_cache_prefix_roadmap-sprint-details-cache',
                    '__storejs_cache_prefix_roadmap-version-details-cache',
                    '__storejs_confluence-permitted-session-storage_user-confluence-permitted'
                ],
                startsWith: [
                    '__storejs_cache_prefix_',
                    'applink'
                ]
            }
        }
    },
    // Teams: Growth: Puma, CC Flywheel Activation, JSD SHIELD (26 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-4'),
        entries: {
            local: {
                exact: [
                    '__storejs_cache_prefix_cjn-eligibility-cache',
                    '__storejs_cross-join-nudge-conf-capabilities-api-cache_cross.join.confluence-capabilities.cache.key',
                    '__storejs_cross-join-nudge-conf-perms-api-cache_cross.join.confluence.cache.key',
                    '__storejs_cross-join-nudge-visited_cross.join.nudges.confluence.visited',
                    '__storejs_cross-join-nudge-visited_cross.join.nudges.jpd.visited',
                    '__storejs_cross-join-nudge-visited_cross.join.nudges.loom.visited',
                    '__storejs_cross-join-nudge-visited_cross.join.nudges.msr',
                    '__storejs_cross-join-nudge-visited_cross.join.nudges.your.work',
                    '__storejs_grw-1287-pcjn_access-request-capabilities',
                    '__storejs_grw-1287-pcjn_confluence-collaborators-userid',
                    '__storejs_grw-1287-pcjn_has-dismissed-feature',
                    '__storejs_nudge-bundle-users_flag-dismissed',
                    '__storejs_nudge-inactive-confluence-user-access-api-cache_nudge-inactive-confluence-user.confluence-access.cache.key',
                    '__storejs_nudge-inactive-confluence-user-capabilities-api-cache_nudge-inactive-confluence-user.confluence-capabilities.cache.key',
                    '__storejs_nudge-inactive-confluence-user_initial-dismissed-date',
                    '__storejs_servicedesk_queues_queue-groups-nav-state',
                    '__storejs_servicedesk_queues_queues-category-state',
                    'invitedAppShortcuts.eligibilityChecked',
                    'invitedAppShortcuts.featureExposed',
                    'queueIssueView:sidebar:width'
                ],
                startsWith: [
                    '__storejs_jsm-all-queues-state_is-open-',
                    '__storejs_jsm-queue-groups-state_selected-group-id-',
                    '__storejs_servicedesk_queues_issues_',
                    '__storejs_servicedesk_queues_last_visited_category_',
                    '__storejs_servicedesk_queues_last_visited_queue_',
                    'persist:calendar/view/ari:cloud:jira:'
                ]
            }
        }
    },
    // Teams: Confluence Integrations, Product Integrations, Endeavour, jira-werewolves (26 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-5'),
        entries: {
            local: {
                exact: [
                    '__storejs_create-retro-checkbox_isChecked',
                    '__storejs_create-retro-type-selector_selectedRetroType',
                    '__storejs_cross-join-third-party-nudges-v2-visited_cross.join.third.party.nudges.v2.jira.visited',
                    '__storejs_dashboard_AG.congolmerate.cookie',
                    '__storejs_dashboard_dashboard-data',
                    '__storejs_form-templates_formTemplateSelectionToggleKey',
                    '__storejs_jira-insights-should-use-jql_shouldUseJQLQuery',
                    '__storejs_jira-software-code-tab_clickedGoToDevelopment',
                    '__storejs_jira-software-security-tab_clickedGoToDevelopment',
                    '__storejs_jira-summary-reports-banner_reports-customization-dismissed',
                    '__storejs_jira_integration_spotlight_throttle_jira_3p_within_1p_spotlight_last_shown_timestamp',
                    '__storejs_jira_integration_spotlight_throttle_jira_integration_spotlight_last_shown_timestamp',
                    '__storejs_team-field-onboarding_TEAM_FIELD_ONBOARDING_BANNER_DISMISSED',
                    '__storejs_team-field-onboarding_clicked',
                    '__storejs_third-party-nudge_has-seen-nudge',
                    '__storejs_use-is-space-auto-created_twcg-390-space-auto-created'
                ],
                startsWith: [
                    '__storejs_auto-expand-halfway-alert-',
                    '__storejs_jira-list-view-statistics-',
                    '__storejs_jira_integration_spotlight_trait_',
                    'rovo-ghost-icons-'
                ]
            },
            session: {
                exact: [
                    '__storejs_confluence-integration-controls-session-storage_confluence-integration-controls',
                    '__storejs_confluence-permissions-session-storage_user-confluence-access',
                    '__storejs_create-confluence-content_userConfluenceAccessStatus',
                    '__storejs_third-party-nudge_issues-view-nudge-date',
                    '__storejs_third-party-nudge_issues-watch-nudge-state',
                    '__storejs_third-party-nudge_notification-section-nudge-state'
                ]
            }
        }
    },
    // Teams: Alexstrasza, A4T-Pandora, MorphineCake, Galileo (Growth), Keystone (26 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-6'),
        entries: {
            local: {
                exact: [
                    '__storejs_alert_filters_popout_jira-ops-alert-filters-last-visited-search',
                    '__storejs_github-for-jira-arc_github-for-jira.configuration.message.closed',
                    '__storejs_issue-layout-editor_project-settings-product-features-jsw-cmp.sidebar.get-permissions-info-panel-dismiss-button',
                    '__storejs_jira-jpd-roadmaps-upsell_jpd-roadmaps-upsell.dismissed',
                    '__storejs_jira-onboarding-hub-cta-panel_dismissed',
                    '__storejs_jsm-change-calendar_assigneeFilterItems',
                    '__storejs_jsm-change-calendar_filterStatus',
                    '__storejs_jsm-change-calendar_moreFilterItems',
                    '__storejs_jsm-change-calendar_project',
                    '__storejs_nfa-onboarding_cachedFieldConfigSchemes__v1',
                    '__storejs_nfa-onboarding_cachedFields__v2',
                    '__storejs_nfa-onboarding_cachedProjects__v1',
                    '__storejs_nfa-onboarding_rejectedFieldIds',
                    '__storejs_onboarding_teamType',
                    '__storejs_sprint-summary-checkbox_isChecked',
                    '__storejs_work-suggestions-github-onboarding-finished_finished',
                    'calendar:settings:business',
                    'calendar:settings:software',
                    'calendar:sidebar:width',
                    'jsm-ops-xflow-onboarding',
                    'selectedConfigTab'
                ],
                startsWith: [
                    '__storejs_jira-project-create_project-create.show-auto-provisioned-onboarding.',
                    'calendar:settings:software:board:'
                ],
                regexp: [
                    '^__storejs_jira_business_.+-view_.+_hierarchy_levels$'
                ]
            },
            session: {
                exact: [
                    '__storejs_templates-sidebar-focus_trigger-element-test-id'
                ],
                startsWith: [
                    '__storejs_avatar-modal_AVATARS_ISSUE_TYPE_'
                ]
            }
        }
    },
    // Team: Jlove-Makkuro (28 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-7'),
        entries: {
            local: {
                exact: [
                    '__storejs_jira-onboarding-personalisation_response',
                    '__storejs_jiraSoftwareOnboardingV2_onboarding-selected-project-template-key',
                    '__storejs_jsw-onboarding-premium-reverse-trial_premiumTrialOnSignup',
                    '__storejs_jsw-onboarding-premium-reverse-trial_reverseTrialCohort',
                    '__storejs_onboarding-core_onboarding_started_timestamp',
                    '__storejs_onboarding-core_team-type',
                    '__storejs_onboarding-core_team-type-shorthand',
                    'quickstart.jsm-business-checklist.visibility',
                    'quickstart.jsw-onboarding-checklist.visibility'
                ],
                startsWith: [
                    '__storejs_jira-initial-project-template-name_',
                    '__storejs_jira_business_list-view_',
                    '__storejs_list-view-simplification_ENABLED_FEATURES_',
                    '__storejs_quickstart_'
                ],
                regexp: [
                    '^__storejs_jwm-view-preferences_(?![^_]+_list_groupBy$)(?![^_]+_list_fieldsDetail$)(?![^_]+_[^_]+_filter$)(?![^_]+_[^_]+_hideDone$)(?![^_]+_[^_]+_sorting$).+$'
                ]
            },
            session: {
                exact: [
                    '__storejs_jira-user-cross-project-board-trait_jira-user-cross-project-board-trait',
                    '__storejs_jsw-onboarding-checklist_accountId.jsw-onboarding-checklist.has.navigated.from.link',
                    '__storejs_onboarding-core_can-enroll-in-config-wizard-view',
                    '__storejs_onboarding-core_project_updated_in_welcome_modal',
                    '__storejs_onboarding-core_should-hide-quickstart-for-personalized-sample-data',
                    '__storejs_onboarding-core_should-show-list-view-fields-dropdown-spotlight',
                    '__storejs_onboarding-core_should-show-list-view-type-cell-spotlight',
                    '__storejs_onboarding-core_should-show-personlized-sample-data-for-kanban',
                    '__storejs_onboarding-core_should-show-welcome-modal',
                    '__storejs_onboarding-core_showed-welcome-modal-during-signup',
                    '__storejs_sampleProjectSessionStoreKey_sampleProjectListExpandProperty',
                    '__storejs_sampleProjectSessionStoreKey_sampleProjectNavNudgeProperty',
                    '__storejs_sampleProjectSessionStoreKey_sampleProjectNudgesProperty'
                ]
            }
        }
    },
    // Teams: jdm-streamlining-tools, Self-Help Experiences, Jolt, Reverie, Issue View - Thor, JPD - Juno, Issue View - Kenji, Polaris, Work Item View - Vanguard, Navigation, Lodestone, Luna (Growth), JSM Sherpas (26 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-8'),
        entries: {
            local: {
                exact: [
                    '__storejs_admin-pages-performance_cfo_experience_preference',
                    '__storejs_admin-pages-performance_cfo_new_exp_banner_dismissed',
                    '__storejs_assets-app-for-you-page_showEssentialResources',
                    '__storejs_code_in_jira-code-page_dismissedEmptyRepoCards',
                    '__storejs_development-summary-open-in-ide_last-open-target',
                    '__storejs_development-summary-open-in-ide_recent-cli-paths',
                    '__storejs_hasPinFieldInfoBannerShown_hasPinFieldInfoBannerShown',
                    '__storejs_incidents_show_more_discovery_shouldShowDiscovery',
                    '__storejs_issue-ecosystem_collapsed-panels',
                    '__storejs_jira-roadmap-on-timeline_jpd-roadmap-on-timeline.button-dismissed',
                    '__storejs_jira-roadmap-on-timeline_jpd-roadmap-on-timeline.spotlight-shown',
                    '__storejs_jira_issue_view_view-mode',
                    '__storejs_polaris_last-used-date-field-scale',
                    '__storejs_polaris_sidebar-width',
                    '__storejs_project-scoped-labels_restrict_labels_to_projects_checkbox_value',
                    '__storejs_projects-menu-jpd-recommendation_app-recommendation-state'
                ],
                startsWith: [
                    '__storejs_compass-components_spotlight-viewed-',
                    '__storejs_compass-components_table-crossflow-dismissed-',
                    '__storejs_jira-auto-upgrade-not-a-trial_'
                ],
                endsWith: [
                    'upsell_jira_global_automations_limit_banner_upsell_jira_global_automations_limit_banner'
                ]
            },
            session: {
                exact: [
                    '__storejs_atl-issue-view_first-viewed-issue',
                    '__storejs_hr-space_dualSpaceEligibilityStates',
                    '__storejs_hr-space_labelBlankSpaceEligibilityStates',
                    '__storejs_iph_history',
                    '__storejs_page-container_navigation-journey'
                ],
                startsWith: [
                    '__storejs_jira-platform-persistent-cache_user-property-'
                ]
            }
        }
    },
    // Teams: X2C Wolverine, Jira - Yurree, ITSM Agni, JSM Phoenix, Empanada, Jira - Warepil, Helix, Jira Chronos (26 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-9'),
        entries: {
            local: {
                exact: [
                    'X2C-Migration-Id-Store',
                    '__storejs_jira-board-issue-create-provider_board__preferred__issue__type__id',
                    '__storejs_jira-board-stand-up-panel_skipped-users',
                    '__storejs_jira-harmonized-timeline_timeline:sidebar:width',
                    '__storejs_jira_business_common_jwm.sidebar',
                    '__storejs_jsm-linked-alerts_saved-search-id',
                    '__storejs_jsm-linked-alerts_text-search',
                    '__storejs_jsm-surveys-dashboard_dashboardViewMode',
                    '__storejs_jwm-view-preferences_timeline_project-mapping-preference',
                    '__storejs_nin-changeboarding_jira.nin.global.scope.enrolment',
                    '__storejs_nin-changeboarding_jira.user.nin.global.scope.enrolment.flag.disabled',
                    '__storejs_servicedesk-linked-object-incidents-store_cross-tab-cache',
                    'advanced-roadmaps-request-premium-trial'
                ],
                startsWith: [
                    '__storejs_dead-end-access-request_',
                    '__storejs_jira-native-issue-table-inline-issue-create_',
                    '__storejs_jira-standups_participants-board-',
                    '__storejs_jira-standups_settings-board-',
                    'workflow-an-message-dismissed#'
                ],
                endsWith: [
                    'advanced-roadmaps-request-premium-trial',
                    'last-used-date-field-scale'
                ]
            },
            session: {
                exact: [
                    'SHOW_NEW_EDITOR_SUCCESS_FLAG',
                    'SHOW_OLD_EDITOR_SUCCESS_FLAG',
                    '__storejs_sla-breach-configuration-banner-session_sla-banner-navigating-from-reports',
                    '__storejs_sla-breach-configuration-banner_sla-configuration-banner-dismissed',
                    'showGinOptOutFlag'
                ],
                startsWith: [
                    '__storejs_plan-invite-permissions_'
                ]
            }
        }
    },
    // Teams: Dropbears, __uncategorized__ (26 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-10'),
        entries: {
            local: {
                exact: [
                    'aiMateSmartLinkProviders',
                    'cjn-eligibility-cache',
                    'cjn-event-eligibility-cache',
                    'cross.join.nudges.msr',
                    'cross.join.nudges.msr.count',
                    'jira.create-with-rovo-modal-close-feedback-flag.last-shown',
                    'jsm-cmdb-schema.viewMode',
                    'polaris-last-used-date-field-scale',
                    'polaris-pendo-functional',
                    'polaris-route-slug',
                    'polaris-sidebar-width',
                    'polaris_sidebar_width'
                ],
                startsWith: [
                    'cmdb-object-hide-empty-attributes',
                    'jsm-change-calendar',
                    'jsm-cmdb-insight-object-search',
                    'jsm-cmdb-linked-issues-panel',
                    'jsm-cmdb-object-graph',
                    'jsm-cmdb-object-timeline.insight_drafts.object_comment',
                    'jsm-cmdb-quick-search',
                    'jsm-linked-alerts',
                    'polaris-description-draft-',
                    'schema-graph-config',
                    'servicedesk-linked-object-incidents-store'
                ],
                endsWith: [
                    '-ends-with-test',
                    '__csm-requests-list__layout'
                ]
            },
            session: {
                startsWith: [
                    '@atlassian/switcher-team-25-experiment-cohort'
                ]
            }
        }
    },
    // Teams: JSM Request Intake, Deliveroo, Boysenberry, Wanjel, Yamato, Groot, Crocs, Smite, JPD - Pulsar, Gravity-AI, Studio Expansion, Jira Cosmos, JSM nebula, Advanced Roadmaps, Linking Platform, Navigation Experiences - Linking Platform, JSM ASAP AI, Eng - Ecosystem - Enterprise, Starburst, Aurum, Gryffindor, Jira Notifications Platform, Jlove-Makkuro, Atlassian Analytics Pipeline, JFP - Nike, Studio Expansion - Growth (26 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-batch-11'),
        entries: {
            local: {
                exact: [
                    'LastSelectedFormDetails',
                    '__storejs_bulk_operations_sidebar_ratio_sidebar_ratio',
                    '__storejs_issue-layout-editor_project-settings-product-features-jcs.sidebar.get-permissions-info-panel-dismiss-button',
                    '__storejs_jira-forge-compal_forge-compal-modules-cache',
                    '__storejs_jiraAdminPagesFields_initialState',
                    '__storejs_jira_3p_within_1p_spotlight_last_shown_timestamp',
                    '__storejs_jira_ai_agent_orchestration_analytics_jira_ai_agent_orchestration_analytics',
                    '__storejs_jsm-va-limit-info_dismissed',
                    '__storejs_polaris_routeslug',
                    '__storejs_related-resources-site-switcher_related-resources-site-switcher',
                    'studio-entry-point-banner-dismissed'
                ],
                startsWith: [
                    '__storejs_navigation-apps-sidebar-nav4-project-settings_',
                    '__storejs_suggested-topic-feedback_',
                    'persist:jpo-app-simple-plans-',
                    'smart-card-social-proof_pct-map:v1:',
                    'smart-card-social-proof_site-cloud-id:v1:',
                    '__storejs_ai-summary-section_lastActivityTime:'
                ],
                endsWith: [
                    'connect-eos-banner_dismissed'
                ]
            },
            session: {
                exact: [
                    'JIRA_LINKED_CONFLUENCE_DOC_ROVO_NUDGE_DISMISSED',
                    '__storejs_atlassian-jira-dm-notifications_exportedObjectsListFileStatus',
                    '__storejs_jira-issue-create-restore-_issue-restore-meta',
                    '__storejs_personal-settings_show-success-flag',
                    '__storejs_sampleProjectSessionStoreKey_sampleProjectTimelineExpandProperty',
                    'awc.taskSessions',
                    'clicks-before-tti'
                ],
                startsWith: [
                    'automation.rovo-suggestion-banner.'
                ]
            }
        }
    }
];
const $393775676d134593$export$7e571b50be0a6a2d = [
    // Teams: Knowledge Discovery, __uncategorized__, Search Platform: Search Experience, Enterprise Readiness: Consent Pals (59 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-all-1'),
        entries: {
            local: {
                exact: [
                    '@atlassian.search-ai.add-new-pin-card-dismissed',
                    '@atlassian.search-ai.jira-issue-url',
                    'AS_ORG_SELECTOR_WIDTH',
                    'CHART_EDITOR.SELECTED_DATASOURCE_BY_ORG',
                    '__storejs_platform_educational_discount_dismissed',
                    'accounts-by-aaid-cache',
                    'assets-workspace-id',
                    'atlassian.search-page.visited',
                    'atlassian.unified-search.github-tip-dismiss',
                    'atlassian.unified-search.oauth-banner-snooze',
                    'atlassian.unified-search.quick-find-rovo-tip',
                    'atlassian.unified-search.recent-searches',
                    'automation.execution.limit',
                    'avp.activity_stream_banner_feedback.dismissed',
                    'avp.dashboard_dogfooding.dismissed',
                    'avp.preferred_view',
                    'avp.test_full',
                    'cachedImageErrorDark',
                    'cachedImageErrorLight',
                    'chartio.collapsed_dashboard_nav',
                    'csrfToken',
                    'heartbeat-last-session-expiry',
                    'jiraNav4BenefitsModal_dismissed',
                    'lastActivePageId',
                    'loom-user-auth',
                    'mediaViewer.hasLocalStorage',
                    'outbound-auth-cache',
                    'quick-find-ghost-text',
                    'quick-find-recent-activities',
                    'quick-find-recommended-documents',
                    'quick-find-user-documents',
                    'resultTableHeightPercent',
                    'search-ai.sain.store_message',
                    'search-page-hidden-filters-v2',
                    'search-page-rovo-browser-extension-banner-state',
                    'search-page.auto-open-chat-dismiss-count',
                    'search-page.sain-on-demand-banner-dismiss',
                    'search-personalization-site-user',
                    'search-personalization-smartlink-site',
                    'search-personalization-smartlink-usage-and-top-apps-site',
                    'session-banner-dismissed',
                    'shania-20',
                    'shania-test-storage-item',
                    'storageTest'
                ]
            },
            session: {
                exact: [
                    '@atlassian/switcher-overflow-experiment-cohort',
                    '@atlassiansox/flight-deck-frontend-client_app-switcher-fe_prod_commercial',
                    'AUTOMATION_TEST_STACK_ID',
                    'STATSIG_OVERRIDES',
                    '__storage_test__',
                    'atlassian.search-ai.ai-definition-toggle',
                    'atlassian.search-dialog-filters',
                    'atlassian.search-dialog-query',
                    'atlassian.search-dialog-sticky',
                    'atlassian.search-dialog.ai-answer-component',
                    'atlassian.search-dialog.ai-dialog',
                    'atlassian.search-dialog.ai-dialog.referrer',
                    'atlassian.search-dialog.ai-topics-component',
                    'convo_ai_sain_prompt_override_hello',
                    'shania-test-storage-item'
                ]
            }
        }
    },
    // Teams: Editor, Dropbears, Local Devloop, Identity - Zero, JFP Magma, Automation Platform / Automation, Atlassian Analytics, ASIMO, Atlassian Analytics Pipeline, Editor Ease of Use, Editor: Collaboration, Post Office, Rovo, TRex, Automation, TRex - Rovo Button, Editor: Lego, CSMAI, Editor FE Platform, Studio Expansion - Growth (59 keys)
    {
        isEnabled: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-targeting') && (0, $i860n.fg)('jfp-vulcan-browser-storage-rollout-all-2'),
        entries: {
            local: {
                exact: [
                    '@atlaskit/editor-plugin-card_smart-link-upgrade-pulse',
                    '@atlassian/conversation-assistant-widget-installer__discovery',
                    'STATSIG_OVERRIDES',
                    '__TWILIO_CLIENT_TOKEN__',
                    '__cuid',
                    '__storejs__',
                    'ai-rule-generation-has-been-generated-ever',
                    'ajs_anonymous_id',
                    'atlassian.unified-search.oauth-banner-dismiss-counts',
                    'atlassian.unified-search.third-party-query-suggestions-dismissed',
                    'automation-frontend-ff-favourites',
                    'automation.onboarding.override',
                    'awc.storage.support',
                    'editor.tinyMCE.just.published',
                    'fabric.emoji.lastUsed',
                    'feedback-survey-email',
                    'insert-wiki-markup-dialog.parser',
                    'ncs-session-step-metrics-storage_ncsActiveSessions',
                    'ncs-session-step-metrics-storage_ncsSessionStepMetrics',
                    'notification-list.readStateFilter',
                    'notifyWatchers',
                    'quick_find_connect_apps_cooldown',
                    'rovo-onboarding-checklist-item-states',
                    'rovo.catch-up-linked-items.nudge.dismissed',
                    'rovoChatCsatEligibility',
                    'rovoOnboardingHoldout',
                    'track-element-analytics.element-insertion-stats'
                ],
                startsWith: [
                    'ai-quick-prompt-standdown-',
                    'loglevel:'
                ],
                endsWith: [
                    'copied',
                    'editor-controls.initial-preferences',
                    'editor.survey.last.submitted',
                    'editor:offline:last-background-cleanup-attempt',
                    'markdown.view.mode',
                    'onboarding.state.editor.custom.groups',
                    'onboarding.state.editor.pinned.groups',
                    'opiedCols',
                    'persisted.editor-controls.onboarding-banner-new-pinning.dismissed',
                    'persisted.editor-controls.onboarding-banner-updated.dismissed',
                    'persisted.editor-controls.onboarding-banner.classic-page.dismissed',
                    'persisted.editor-controls.onboarding-banner.dismissed',
                    'persisted.editor-controls.onboarding-banner.live-page.dismissed',
                    'state.editor.custom.groups.toggle'
                ]
            },
            session: {
                exact: [
                    'AP-RULE-BUILDER-FEEDBACK-SEEN',
                    'awc.interactionSession.bridge',
                    'awc.interactionSession.expiry',
                    'awc.interactionSession.id',
                    'awc.interactionSession.id.prev',
                    'awc.storage.support',
                    'rovo-button-nudges-ots',
                    'rovo-button-nudges-suppression',
                    'smart-card-url-data_response-cache'
                ],
                startsWith: [
                    'csm:consent-form:accepted:',
                    'editor-persit-scroll-position',
                    'automation.changeboarding.modal'
                ],
                endsWith: [
                    'smart-card-url-data'
                ],
                regexp: [
                    '^.+::document::.+$',
                    '^.+::list::.+$',
                    '^.+::map::.+$'
                ]
            }
        }
    }
];
const $393775676d134593$export$eeaf6f44e750887c = {
    // IndexedDB database names created by browser extensions
    indexeddb: [
        'CannedResponses',
        'indexedDbCheck',
        'ticket_db',
        'WFX_EventsDB',
        'DeepUiStorage'
    ],
    // localStorage / sessionStorage key patterns from browser extensions.
    // `wm-*` covers any key starting with "wm-".
    localOrSession: [
        /^wm-.*/,
        /^jiraBarData\..*/,
        /^rx\..*/,
        /^shortstack\..*/,
        /^_?wfx\..*/,
        /^hopscotch\..*/
    ]
};
const $393775676d134593$export$eea5bcbba31420e9 = [
    // store.Atlassian.PAS.Announcements.<DYNAMIC> — public announcement module (ACTIVE)
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-pas-announcements'),
        entries: {
            local: {
                startsWith: [
                    'store.Atlassian.PAS.Announcements.'
                ]
            }
        }
    },
    // gh.* — greenhopper/agile monolith keys (gh.epicShownOnRapidBoard. is already governed
    // by an AFM team batch and is intentionally not duplicated here)
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-gh'),
        entries: {
            local: {
                exact: [
                    'gh.charts.intro',
                    'gh.detailViewWork',
                    'gh.latestRapidViewId',
                    'gh.mode',
                    'gh.nonWorkingDaysShown.burndown'
                ],
                startsWith: [
                    'gh.boardSettings.'
                ]
            },
            session: {
                exact: [
                    'gh.pageloadmessages'
                ]
            }
        }
    },
    // media-picker.herment.storage (OBSELETE)
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-media-picker'),
        entries: {
            local: {
                exact: [
                    'media-picker.herment.storage'
                ]
            },
            session: {
                exact: [
                    'media-picker.herment.storage'
                ]
            }
        }
    },
    // twixi (READ ONLY)
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-twixi'),
        entries: {
            local: {
                exact: [
                    'twixi'
                ]
            }
        }
    },
    // dismissedFlags (ACTIVE)
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-dismissed-flags'),
        entries: {
            session: {
                exact: [
                    'dismissedFlags'
                ]
            }
        }
    },
    // AJS.thisPage (OBSELETE)
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-ajs-this-page'),
        entries: {
            session: {
                exact: [
                    'AJS.thisPage'
                ]
            }
        }
    },
    // selectedScreenTab (ACTIVE)
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-selected-screen-tab'),
        entries: {
            session: {
                exact: [
                    'selectedScreenTab'
                ]
            }
        }
    },
    // issues-calendar-month (ACTIVE)
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-issues-calendar-month'),
        entries: {
            session: {
                exact: [
                    'issues-calendar-month'
                ]
            }
        }
    },
    // Catch-all for every remaining monolith key without a dedicated gate — READ ONLY,
    // ACTIVE, OBSELETE and untagged keys all ramp together under this single gate.
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-vulcan-bsc-monolith-rest'),
        entries: {
            local: {
                exact: [
                    '__storejs_navigation-session-provider_navigationSessionId',
                    'block-states',
                    'jira.wikieditor.last.color',
                    'kanplan.acknowledge.display',
                    'lhc-state',
                    'navSimpleSearch',
                    'parentpicker.showdone',
                    'ui.sidebar.layoutview-draggable',
                    'workflow-landing-edit-workflow-permission-discovery-message'
                ],
                startsWith: [
                    'AJS.Shortener#',
                    'jira.projecttemplates.',
                    'jira.wikieditor.visibility'
                ]
            },
            session: {
                exact: [
                    'jira.messages.fadeInBackground.color',
                    'jira.messages.fadeInBackground.target',
                    'selectedIssueId'
                ]
            }
        }
    },
    // IndexedDB — issue-create restore stores (jira-bsp__*). Grouped so the issue-create
    // IndexedDB usage ramps (and rolls back) together on its own gate.
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-magma-bsc-idb-issue-create'),
        entries: {
            indexeddb: {
                exact: [
                    'jira-bsp__jira-issue-create-restore-in-progress-issue',
                    'jira-bsp__jira-issue-create-restore-browser-storage-cleanup'
                ]
            }
        }
    },
    // IndexedDB — Jira Product Discovery (JPD) stores. Grouped so JPD IndexedDB usage
    // ramps independently of the issue-create batch.
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-magma-bsc-idb-jpd'),
        entries: {
            indexeddb: {
                exact: [
                    'jpd-store',
                    'jira-bsp__jpd-view-visits'
                ]
            }
        }
    },
    // IndexedDB — remaining monolith IndexedDB keys (CMP board, analytics web client, and
    // the pendo-* family) that don't belong to a dedicated feature batch.
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-magma-bsc-idb-misc'),
        entries: {
            indexeddb: {
                exact: [
                    'jira-bsp__cmp-board',
                    'analytics-web-client'
                ],
                startsWith: [
                    'pendo-'
                ]
            }
        }
    },
    // IndexedDB — Growth recommendations expiry store. Grouped so Growth IndexedDB usage
    // ramps independently of the other IndexedDB batches.
    {
        isEnabled: ()=>(0, $i860n.fg)('jfp-magma-bsc-idb-growth'),
        entries: {
            indexeddb: {
                exact: [
                    'atlassian-growth-recos-expiry'
                ]
            }
        }
    }
];

});



parcelRegister("iayqi", function(module, exports) {
$parcel$export(module.exports, "didSSRSucceed", () => $8ba3b83c8ed4f7ef$export$581f5d7058f82eac);
/* eslint-disable jira/filename-case */ function $8ba3b83c8ed4f7ef$export$581f5d7058f82eac() {
    const traceData = globalThis.window?.SPA_STATE?.['ssr/detail_request_trace']?.data;
    if (!traceData) return false;
    const prefetchTimedOut = Object.values(// oxlint-disable-next-line typescript/consistent-type-assertions
    traceData).some((x)=>x.failureReason === 'timeout');
    return !prefetchTimedOut && // Static fallback is returned when there is the 2.7s timeout of SSR
    !globalThis.window.__SSR_FALLBACK__;
}

});

parcelRegister("iC4BV", function(module, exports) {
$parcel$export(module.exports, "getCookieCircuitBreakerKillswitch", () => $1bf9bab9a73edf4e$export$10bf444f24046dfd);
/* eslint-disable jira/filename-case */ 
var $4LDqh = parcelRequire("4LDqh");

var $hjhet = parcelRequire("hjhet");
function $1bf9bab9a73edf4e$export$10bf444f24046dfd() {
    // This function is not called on SSR.
    if (false) return null;
    (0, $hjhet.UNSAFE_initIfNeeded)();
    /*
	 * not using the util because:
	 * - this is a dynamic config
	 * - only evaluated once per full page load, so cache is not needed
	 * - never evaluated on SSR, so no need for deferring __SSR_SYNC_READ_EXP_VAL__
	 *   instead of initing flags
	 */ // eslint-disable-next-line jira/ff/use-recommended-utils
    const value = (0, $4LDqh.default).getExperimentValue('cookie-cb-reset', 'value', 0, {
        fireExperimentExposure: false
    });
    if (value && Number.isFinite(value)) return value;
    return null;
}

});


parcelRegister("8iLt0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d9a7c7242d37a6b$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $5BjZr = parcelRequire("5BjZr");

var $6jLTU = parcelRequire("6jLTU");

var $glqvt = parcelRequire("glqvt");

var $6bEm8 = parcelRequire("6bEm8");

var $e2Tle = parcelRequire("e2Tle");

var $9ObL1 = parcelRequire("9ObL1");

var $aNuBm = parcelRequire("aNuBm");

var $guQfx = parcelRequire("guQfx");
const $6d9a7c7242d37a6b$var$sessionQueryParams = [
    'searchSessionId',
    'searchObjectId',
    'searchContainerId',
    'searchContentType'
];
const $6d9a7c7242d37a6b$var$sessionMeta = [
    'ajs-search-session-id',
    'ajs-search-object-id',
    'ajs-search-container-id',
    'ajs-search-content-type'
];
const $6d9a7c7242d37a6b$var$removeDwellComponent = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const element = document.getElementById(placeholderId);
    if (placeholderId && element) (0, $85XPu.unmountComponentAtNode)(element);
};
const $6d9a7c7242d37a6b$var$removeSessionMeta = ()=>$6d9a7c7242d37a6b$var$sessionMeta.forEach((0, $aNuBm.removeMetaTag));
// @ts-expect-error - TS7031 - Binding element 'sessionId' implicitly has an 'any' type. | TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'containerId' implicitly has an 'any' type. | TS7031 - Binding element 'objectType' implicitly has an 'any' type.
const $6d9a7c7242d37a6b$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
    const newMeta = {
        'ajs-search-session-id': sessionId,
        'ajs-search-object-id': objectId,
        'ajs-search-container-id': containerId,
        'ajs-search-content-type': objectType
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(newMeta).forEach(([name, content])=>(0, $aNuBm.addMetaTag)(name, content));
};
const $6d9a7c7242d37a6b$var$getPreviousSessionId = ()=>(0, $6bEm8.default)('ajs-search-session-id');
class $6d9a7c7242d37a6b$export$f1e582dddb502dd6 extends (0, $euxye.Component) {
    constructor(props){
        super(props), this.onClearSessionEvent = ()=>{
            if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                shouldRemoveSessionBeIgnored: false
            });
        }, this.onHistoryChange = (location)=>{
            $6d9a7c7242d37a6b$var$removeDwellComponent('search-dwell-time');
            const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($5BjZr))).parse(location.pathname + location.search, true);
            const queryString = parsedUrl.query || {};
            const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
            const { path: path } = parsedUrl;
            const previousSessionId = $6d9a7c7242d37a6b$var$getPreviousSessionId();
            const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $6d9a7c7242d37a6b$var$removeSessionMeta();
            if (searchSessionId) {
                (0, $glqvt.default)($6d9a7c7242d37a6b$var$sessionQueryParams);
                const newState = {
                    sessionId: searchSessionId,
                    objectId: searchObjectId,
                    objectType: searchContentType,
                    containerId: searchContainerId,
                    previousSessionId: $6d9a7c7242d37a6b$var$getPreviousSessionId()
                };
                $6d9a7c7242d37a6b$var$addSessionMeta(newState);
                const shouldRemoveSession = !!(0, $guQfx.skipClearSessionURLs).find((skipUrlRegex)=>!(0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(path) ? skipUrlRegex.test(path) : false);
                // @ts-expect-error - TS2345 - Argument of type '{ shouldRemoveSessionBeIgnored: boolean; sessionId: string | string[]; objectId: string | string[] | undefined; objectType: string | string[] | undefined; containerId: string | string[] | undefined; previousSessionId: string | null; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "containerId" | "objectType" | "objectId" | "sessionId" | "previousSessionId" | "shouldRemoveSessionBeIgnored"> | null) | Pick<...> | null'.
                this.setState({
                    ...newState,
                    shouldRemoveSessionBeIgnored: shouldRemoveSession
                });
            }
        };
        this.props.history.listen(this.onHistoryChange);
        this.state = {
            shouldRemoveSessionBeIgnored: false,
            sessionId: ''
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $guQfx.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $guQfx.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    render() {
        if (this.state && this.state.sessionId) {
            const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
            const data = {
                objectId: objectId,
                containerId: containerId,
                objectType: objectType,
                source: objectType,
                actionSubject: objectType,
                attributes: {
                    previousSessionId: previousSessionId
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ObL1.default), {
                sessionId: sessionId,
                data: data
            });
        }
        return null;
    }
}
$6d9a7c7242d37a6b$export$f1e582dddb502dd6.displayName = "SessionTracker";
const $6d9a7c7242d37a6b$var$ExportedComponent = (0, $e2Tle.withRouter)($6d9a7c7242d37a6b$export$f1e582dddb502dd6);
var $6d9a7c7242d37a6b$export$2e2bcd8739ae039 = $6d9a7c7242d37a6b$var$ExportedComponent;

});
parcelRegister("glqvt", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ed1cd4fdaf1a867$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5BjZr = parcelRequire("5BjZr");

var $l28YB = parcelRequire("l28YB");
/**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ const $7ed1cd4fdaf1a867$var$stripQueryParams = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($5BjZr))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($5BjZr))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};
var $7ed1cd4fdaf1a867$export$2e2bcd8739ae039 = $7ed1cd4fdaf1a867$var$stripQueryParams;

});

parcelRegister("9ObL1", function(module, exports) {
$parcel$export(module.exports, "default", () => $332991cc62459752$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4B1S7 = parcelRequire("4B1S7");

var $bx8kK = parcelRequire("bx8kK");

var $4aWLY = parcelRequire("4aWLY");


var $5ZjZ2 = parcelRequire("5ZjZ2");
const $332991cc62459752$var$defaultSource = 'dwellComponent';
const $332991cc62459752$var$defaultActionSubject = 'dwellComponent';
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $332991cc62459752$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($4B1S7)))((0, $bx8kK.AnalyticsSubject)(actionSubject || $332991cc62459752$var$defaultActionSubject), (0, $bx8kK.AnalyticsSource)(source || $332991cc62459752$var$defaultSource, (0, $46f069e6c968f461$export$f636b5b56f1d624a)))((0, $5ZjZ2.default));
class $332991cc62459752$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $332991cc62459752$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $332991cc62459752$var$defaultSource,
            actionSubject: data && data.actionSubject || $332991cc62459752$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4aWLY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}
$332991cc62459752$export$2e2bcd8739ae039.displayName = "DwellWrapper";

});
parcelRegister("4B1S7", function(module, exports) {

var $hH4fr = parcelRequire("hH4fr");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $358c11d1f0aa447e$var$flow = $hH4fr();
module.exports = $358c11d1f0aa447e$var$flow;

});
parcelRegister("hH4fr", function(module, exports) {

var $gg5in = parcelRequire("gg5in");

var $5skZT = parcelRequire("5skZT");

var $cMGSd = parcelRequire("cMGSd");

var $kAHSq = parcelRequire("kAHSq");

var $jOlpf = parcelRequire("jOlpf");

var $lvBLI = parcelRequire("lvBLI");
/** Error message constants. */ var $ce19bf6af86e6704$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $ce19bf6af86e6704$var$WRAP_CURRY_FLAG = 8, $ce19bf6af86e6704$var$WRAP_PARTIAL_FLAG = 32, $ce19bf6af86e6704$var$WRAP_ARY_FLAG = 128, $ce19bf6af86e6704$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $ce19bf6af86e6704$var$createFlow(fromRight) {
    return $5skZT(function(funcs) {
        var length = funcs.length, index = length, prereq = $gg5in.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($ce19bf6af86e6704$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $kAHSq(func) == 'wrapper') var wrapper = new $gg5in([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $kAHSq(func), data = funcName == 'wrapper' ? $cMGSd(func) : undefined;
            if (data && $lvBLI(data[0]) && data[1] == ($ce19bf6af86e6704$var$WRAP_ARY_FLAG | $ce19bf6af86e6704$var$WRAP_CURRY_FLAG | $ce19bf6af86e6704$var$WRAP_PARTIAL_FLAG | $ce19bf6af86e6704$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$kAHSq(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $lvBLI(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $jOlpf(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $ce19bf6af86e6704$var$createFlow;

});
parcelRegister("gg5in", function(module, exports) {

var $1R5h4 = parcelRequire("1R5h4");

var $jSocY = parcelRequire("jSocY");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $bd623f8a4c43550d$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$bd623f8a4c43550d$var$LodashWrapper.prototype = $1R5h4($jSocY.prototype);
$bd623f8a4c43550d$var$LodashWrapper.prototype.constructor = $bd623f8a4c43550d$var$LodashWrapper;
module.exports = $bd623f8a4c43550d$var$LodashWrapper;

});
parcelRegister("jSocY", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $e785d6bca43b2222$var$baseLodash() {
// No operation performed.
}
module.exports = $e785d6bca43b2222$var$baseLodash;

});


parcelRegister("cMGSd", function(module, exports) {

var $emNji = parcelRequire("emNji");

var $fcq2N = parcelRequire("fcq2N");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $94eb3985a0e670cb$var$getData = !$emNji ? $fcq2N : function(func) {
    return $emNji.get(func);
};
module.exports = $94eb3985a0e670cb$var$getData;

});
parcelRegister("emNji", function(module, exports) {

var $j0H8z = parcelRequire("j0H8z");
/** Used to store function metadata. */ var $a7595eb8f9ce4fa2$var$metaMap = $j0H8z && new $j0H8z;
module.exports = $a7595eb8f9ce4fa2$var$metaMap;

});


parcelRegister("kAHSq", function(module, exports) {

var $pl2zd = parcelRequire("pl2zd");
/** Used for built-in method references. */ var $efd9347aa48ca91c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $efd9347aa48ca91c$var$hasOwnProperty = $efd9347aa48ca91c$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $efd9347aa48ca91c$var$getFuncName(func) {
    var result = func.name + '', array = $pl2zd[result], length = $efd9347aa48ca91c$var$hasOwnProperty.call($pl2zd, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $efd9347aa48ca91c$var$getFuncName;

});
parcelRegister("pl2zd", function(module, exports) {
/** Used to lookup unminified function names. */ var $04c2a81983f98d0c$var$realNames = {};
module.exports = $04c2a81983f98d0c$var$realNames;

});


parcelRegister("lvBLI", function(module, exports) {

var $ataFk = parcelRequire("ataFk");

var $cMGSd = parcelRequire("cMGSd");

var $kAHSq = parcelRequire("kAHSq");

var $jcJQ5 = parcelRequire("jcJQ5");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $fa89ca427c9f68d4$var$isLaziable(func) {
    var funcName = $kAHSq(func), other = $jcJQ5[funcName];
    if (typeof other != 'function' || !(funcName in $ataFk.prototype)) return false;
    if (func === other) return true;
    var data = $cMGSd(other);
    return !!data && func === data[0];
}
module.exports = $fa89ca427c9f68d4$var$isLaziable;

});
parcelRegister("ataFk", function(module, exports) {

var $1R5h4 = parcelRequire("1R5h4");

var $jSocY = parcelRequire("jSocY");
/** Used as references for the maximum length and index of an array. */ var $79f4e2c2d1aadef1$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $79f4e2c2d1aadef1$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $79f4e2c2d1aadef1$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$79f4e2c2d1aadef1$var$LazyWrapper.prototype = $1R5h4($jSocY.prototype);
$79f4e2c2d1aadef1$var$LazyWrapper.prototype.constructor = $79f4e2c2d1aadef1$var$LazyWrapper;
module.exports = $79f4e2c2d1aadef1$var$LazyWrapper;

});

parcelRegister("jcJQ5", function(module, exports) {

var $ataFk = parcelRequire("ataFk");

var $gg5in = parcelRequire("gg5in");

var $jSocY = parcelRequire("jSocY");

var $jOlpf = parcelRequire("jOlpf");

var $czB45 = parcelRequire("czB45");

var $p0kcc = parcelRequire("p0kcc");
/** Used for built-in method references. */ var $dfb2b2023e398cfa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dfb2b2023e398cfa$var$hasOwnProperty = $dfb2b2023e398cfa$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $dfb2b2023e398cfa$var$lodash(value) {
    if ($czB45(value) && !$jOlpf(value) && !(value instanceof $ataFk)) {
        if (value instanceof $gg5in) return value;
        if ($dfb2b2023e398cfa$var$hasOwnProperty.call(value, '__wrapped__')) return $p0kcc(value);
    }
    return new $gg5in(value);
}
// Ensure wrappers are instances of `baseLodash`.
$dfb2b2023e398cfa$var$lodash.prototype = $jSocY.prototype;
$dfb2b2023e398cfa$var$lodash.prototype.constructor = $dfb2b2023e398cfa$var$lodash;
module.exports = $dfb2b2023e398cfa$var$lodash;

});
parcelRegister("p0kcc", function(module, exports) {

var $ataFk = parcelRequire("ataFk");

var $gg5in = parcelRequire("gg5in");

var $iM6Ha = parcelRequire("iM6Ha");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $04b296667d7ea8bc$var$wrapperClone(wrapper) {
    if (wrapper instanceof $ataFk) return wrapper.clone();
    var result = new $gg5in(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $iM6Ha(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $04b296667d7ea8bc$var$wrapperClone;

});





parcelRegister("bx8kK", function(module, exports) {
$parcel$export(module.exports, "AnalyticsSource", () => $a1dff6dfccfc5381$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $a1dff6dfccfc5381$export$ec9f54bd4341ceb);
/* eslint-disable jira/filename-case */ 
var $kY2zM = parcelRequire("kY2zM");
const $a1dff6dfccfc5381$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $kY2zM.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $a1dff6dfccfc5381$export$ec9f54bd4341ceb = (name, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
attributes)=>(WrappedComponent)=>(0, $kY2zM.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

parcelRegister("5ZjZ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fd962bee3079abf$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bnIXS = parcelRequire("bnIXS");

var $lpTWz = parcelRequire("lpTWz");

var $foz8X = parcelRequire("foz8X");
class $1fd962bee3079abf$export$1c7ccff61c195c75 extends (0, $euxye.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $bnIXS.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args), this.sendDwellEvent = (payload)=>(0, $foz8X.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
$1fd962bee3079abf$export$1c7ccff61c195c75.displayName = "DwellTime";
const $1fd962bee3079abf$var$ExportedComponent = (0, $lpTWz.default)('dwellTime', {
    onDwell: 'dwelled'
})($1fd962bee3079abf$export$1c7ccff61c195c75);
var $1fd962bee3079abf$export$2e2bcd8739ae039 = $1fd962bee3079abf$var$ExportedComponent;

});
parcelRegister("lpTWz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8322f485796824b9$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/js/no-reduce-accumulator-spread */ 
var $kTviw = parcelRequire("kTviw");

var $kY2zM = parcelRequire("kY2zM");
const $8322f485796824b9$export$871de8747c9eaa88 = (props)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
function $8322f485796824b9$var$componentWithAnalytics(componentName, eventActions) {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return (0, $kY2zM.default)({
            componentName: componentName
        })((0, $kTviw.default)($8322f485796824b9$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $8322f485796824b9$export$2e2bcd8739ae039 = $8322f485796824b9$var$componentWithAnalytics;

});

parcelRegister("foz8X", function(module, exports) {
$parcel$export(module.exports, "fireTrackAnalytics", () => $76becd6a06e03f70$export$13990ad4625571ed);
/* eslint-disable jira/filename-case */ 
var $dAmGh = parcelRequire("dAmGh");

var $7iRBQ = parcelRequire("7iRBQ");

var $g6Mb9 = parcelRequire("g6Mb9");
const $76becd6a06e03f70$var$isNotUndefined = (a)=>a !== undefined;
const $76becd6a06e03f70$var$mapPayload = (payload)=>{
    const context = (0, $g6Mb9.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $76becd6a06e03f70$var$isNotUndefined);
};
const $76becd6a06e03f70$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$76becd6a06e03f70$var$mapPayload(payload),
        analyticsType: (0, $7iRBQ.TRACK_EVENT_TYPE)
    }).fire();
};

});
parcelRegister("g6Mb9", function(module, exports) {
$parcel$export(module.exports, "default", () => $4389a520086d49d1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $808aL = parcelRequire("808aL");

var $3irVK = parcelRequire("3irVK");
// AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
const $4389a520086d49d1$var$mapPayload = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))));
};
var $4389a520086d49d1$export$2e2bcd8739ae039 = $4389a520086d49d1$var$mapPayload;

});




parcelRegister("aNuBm", function(module, exports) {
$parcel$export(module.exports, "addMetaTag", () => $16eac2c27a04c97d$export$c79fd820617d7f);
$parcel$export(module.exports, "removeMetaTag", () => $16eac2c27a04c97d$export$4267657a25105d9d);
/* eslint-disable jira/filename-case */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $16eac2c27a04c97d$export$c9d44c736471c518 = (name)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $16eac2c27a04c97d$var$getHead = ()=>document.head || document.querySelector('head');
const $16eac2c27a04c97d$export$c79fd820617d7f = (name, content)=>{
    if (!name || !content) return;
    const existingMeta = $16eac2c27a04c97d$export$c9d44c736471c518(name);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    if (existingMeta) existingMeta.parentNode?.replaceChild(meta, existingMeta);
    else {
        const head = $16eac2c27a04c97d$var$getHead();
        if (head) head.appendChild(meta);
    }
};
const $16eac2c27a04c97d$export$4267657a25105d9d = (name)=>{
    const meta = $16eac2c27a04c97d$export$c9d44c736471c518(name);
    if (meta) meta.parentNode?.removeChild(meta);
};

});

parcelRegister("guQfx", function(module, exports) {
$parcel$export(module.exports, "CLEAR_SEARCH_SESSION", () => $3314857c565d0ced$export$b669eaa3e4786d5c);
$parcel$export(module.exports, "skipClearSessionURLs", () => $3314857c565d0ced$export$c092460ed33e0e35);
/* eslint-disable jira/filename-case */ const $3314857c565d0ced$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
const $3314857c565d0ced$export$c092460ed33e0e35 = [
    /.*RapidBoard.jspa.*/,
    /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
    /\/jira\/people\/.*\/boards\/.*/
];

});


parcelRegister("gi67c", function(module, exports) {
$parcel$export(module.exports, "default", () => $8361f4313c009656$export$2e2bcd8739ae039);
function $8361f4313c009656$var$getUFORouteName(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}
var $8361f4313c009656$export$2e2bcd8739ae039 = $8361f4313c009656$var$getUFORouteName;

});

parcelRegister("7MCPh", function(module, exports) {
$parcel$export(module.exports, "collectSSRPlaceholderDimensions", () => $7f30114bf6fe577d$export$aee7516e57289027);
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $7f30114bf6fe577d$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = $7f30114bf6fe577d$var$getEffectiveBoundingRect(elem, window);
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = $7f30114bf6fe577d$var$getEffectiveBoundingRect(pageLayoutRoot, window);
        }
    }
}
/**
 * Gets the effective bounding rectangle for an element, handling display: contents elements
 * by collecting dimensions from their children instead
 */ function $7f30114bf6fe577d$var$getEffectiveBoundingRect(elem, window) {
    const computedStyle = window.getComputedStyle(elem);
    // If element has display: contents, collect bounding rect from children
    if (computedStyle.display === 'contents') {
        const children = Array.from(elem.children);
        if (children.length === 0) // No children, return zero rect
        return new DOMRect(0, 0, 0, 0);
        // Calculate union of all children's bounding rects
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        children.forEach((child)=>{
            const childRect = child.getBoundingClientRect();
            // Skip children with zero dimensions (likely also display: contents)
            if (childRect.width > 0 || childRect.height > 0) {
                minX = Math.min(minX, childRect.left);
                minY = Math.min(minY, childRect.top);
                maxX = Math.max(maxX, childRect.right);
                maxY = Math.max(maxY, childRect.bottom);
            }
        });
        // If no children with dimensions found, return zero rect
        if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
        return new DOMRect(minX, minY, maxX - minX, maxY - minY);
    }
    // Normal element, return its bounding rect
    return elem.getBoundingClientRect();
}

});

parcelRegister("hwbnZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd178b89de0a6928$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updatePageloadName", () => $dd178b89de0a6928$export$d0f99433cd4f4028);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7TA2J = parcelRequire("7TA2J");

var $erszr = parcelRequire("erszr");

var $gmMRH = parcelRequire("gmMRH");

var $anDmR = parcelRequire("anDmR");

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");

var $7VWGN = parcelRequire("7VWGN");
const $dd178b89de0a6928$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $dd178b89de0a6928$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $gmMRH.isUFOEnabled)()) return;
    const activeInteraction = (0, $siTdT.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $7VWGN.default).current = routeName || null;
    const rate = ufoName ? (0, $gmMRH.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $erszr.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $7TA2J.v4)();
        (0, $qqoKJ.DefaultInteractionID).current = newId;
        (0, $siTdT.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $anDmR.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $siTdT.addHoldByID)(newId, [], $dd178b89de0a6928$var$AWAITING_PAGELOAD_NAME, $dd178b89de0a6928$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $siTdT.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $siTdT.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $siTdT.removeHoldByID)(activeInteraction.id, $dd178b89de0a6928$var$AWAITING_PAGELOAD_NAME);
    }
}
var $dd178b89de0a6928$export$2e2bcd8739ae039 = $dd178b89de0a6928$var$traceUFOPageLoad;
function $dd178b89de0a6928$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    if (!(0, $gmMRH.isUFOEnabled)()) return;
    const interaction = (0, $siTdT.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $gmMRH.getInteractionRate)(ufoName, 'page_load');
        (0, $siTdT.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $erszr.default)(rate)) (0, $7VWGN.default).current = ufoName;
        else (0, $siTdT.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $siTdT.removeHoldByID)(interaction.id, $dd178b89de0a6928$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("ba8z9", function(module, exports) {
$parcel$export(module.exports, "reportBootstrapError", () => $ceff780717b5447e$export$a5c16644a2d3c205);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $ffNik = parcelRequire("ffNik");

var $iYYeq = parcelRequire("iYYeq");

var $66ukR = parcelRequire("66ukR");

var $2HuOR = parcelRequire("2HuOR");


var $h3795 = parcelRequire("h3795");
const $ceff780717b5447e$export$649804097de83b3b = [
    // https://jplat.jira.atlassian.cloud/browse/MAGMA-2440
    {
        browser: 'Chrome',
        browserVersion: '116.0.0',
        errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
    }
];
const $ceff780717b5447e$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $66ukR.getBrowser)().name === filterCriteria.browser : true;
const $ceff780717b5447e$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $66ukR.getBrowser)().version === filterCriteria.browserVersion : true;
const $ceff780717b5447e$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
const $ceff780717b5447e$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
    try {
        // condition checkers must return true if they don't apply, so an empty filterCriteria will match (and block) ALL errors
        const conditionCheckers = [
            $ceff780717b5447e$var$checkBrowserCondition,
            $ceff780717b5447e$var$checkBrowserVersionCondition,
            $ceff780717b5447e$var$checkErrorMessageCondition
        ];
        // Should send analytics if no filtering conditions are met
        return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
    } catch (e) {
        // If any error occurs during filtering, experience analytics should still be sent
        return true;
    }
};
const $ceff780717b5447e$export$a5c16644a2d3c205 = async (error)=>{
    const tenantContextData = (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // We probably already have analytics initialised but we could have failed earlier than it
    (0, $ffNik.initAnalytics)(tenantContextData);
    // Experience analytics should only be sent if it is not filtered
    if ($ceff780717b5447e$export$a66ce4bea8340820(error, $ceff780717b5447e$export$649804097de83b3b)) (0, $iYYeq.default)({
        analyticsSource: (0, $e6ec049ffa8f915a$export$c9e16a15d65437),
        experience: (0, $e6ec049ffa8f915a$export$b1534bc11f201efd),
        wasExperienceSuccesful: false,
        location: (0, $e6ec049ffa8f915a$export$7dfef0177e883b05),
        application: (0, $e6ec049ffa8f915a$export$aa6008fe0169b864),
        edition: (0, $e6ec049ffa8f915a$export$39418a21fbb51487),
        additionalAttributes: (0, $h3795.routeAnalyticsAttributes)
    });
    (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            packageName: 'jiraBootstrapSlaReporter',
            id: 'bootstrap-failure',
            teamName: 'nike'
        },
        error: error,
        attributes: (0, $h3795.routeAnalyticsAttributes)
    });
    throw error;
};

});
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $e6ec049ffa8f915a$export$c9e16a15d65437 = 'navigationNext';
const $e6ec049ffa8f915a$export$b1534bc11f201efd = 'jiraPageContainer';
const $e6ec049ffa8f915a$export$fa4bbc89fd1f1a7 = null;
const $e6ec049ffa8f915a$export$aa6008fe0169b864 = null;
const $e6ec049ffa8f915a$export$39418a21fbb51487 = null;
const $e6ec049ffa8f915a$export$7dfef0177e883b05 = 'entry.jira-spa';
const $e6ec049ffa8f915a$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $e6ec049ffa8f915a$export$7114284ca03133ee = `_${$e6ec049ffa8f915a$var$PAGE_CONTAINER_MARK}.end`;
const $e6ec049ffa8f915a$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $e6ec049ffa8f915a$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $e6ec049ffa8f915a$export$e2bc63118050de32 = `_${$e6ec049ffa8f915a$export$898b6208220685b0}.start`;
const $e6ec049ffa8f915a$export$59f83d43fe209319 = `_${$e6ec049ffa8f915a$export$898b6208220685b0}.end`;
const $e6ec049ffa8f915a$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $e6ec049ffa8f915a$export$c20831be6f780cb5 = `_${$e6ec049ffa8f915a$export$fb9876ab4228d985}.start`;
const $e6ec049ffa8f915a$export$398df1bca49f9884 = `_${$e6ec049ffa8f915a$export$fb9876ab4228d985}.end`;
const $e6ec049ffa8f915a$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $e6ec049ffa8f915a$export$3c2d8af5c7577fe7 = `_${$e6ec049ffa8f915a$export$7048c99f32c60b34}.start`;
const $e6ec049ffa8f915a$export$aac77afee74c49d0 = `_${$e6ec049ffa8f915a$export$7048c99f32c60b34}.end`;
const $e6ec049ffa8f915a$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $e6ec049ffa8f915a$export$16e7ead3a8b5c366 = `_${$e6ec049ffa8f915a$export$4f341d86a3c214}.start`;
const $e6ec049ffa8f915a$export$c389f0b50840d5ca = `_${$e6ec049ffa8f915a$export$4f341d86a3c214}.end`;

parcelRegister("h3795", function(module, exports) {
$parcel$export(module.exports, "routeAnalyticsAttributes", () => $43b26033de7d45c9$export$c71778b3a4356b04);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $41zzZ = parcelRequire("41zzZ");

var $lpBPi = parcelRequire("lpBPi");

var $kGsgY = parcelRequire("kGsgY");
const $43b26033de7d45c9$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $41zzZ.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $41zzZ.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $41zzZ.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $lpBPi.getIsProjectAdmin)
    },
    bifrostGroup: {
        enumerable: true,
        get: (0, $41zzZ.getBifrostGroup)
    },
    ufoName: {
        enumerable: true,
        get: (0, $41zzZ.getUfoName)
    },
    isIframe: {
        enumerable: true,
        get: (0, $kGsgY.getIsIframe)
    }
});

});
parcelRegister("kGsgY", function(module, exports) {
$parcel$export(module.exports, "getIsIframe", () => $8400342778f55869$export$fc717e37ed2e7b6e);
const $8400342778f55869$export$fc717e37ed2e7b6e = ()=>{
    try {
        return typeof window !== 'undefined' && window.self !== window.top;
    } catch (e) {
        // Accessing window.top can throw a SecurityError in cross‑origin cases
        return true; // If we can't access top, we *are* in an iframe
    }
};

});



parcelRegister("1ADnd", function(module, exports) {
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6s4F0 = parcelRequire("6s4F0");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // oxlint-disable-next-line typescript/no-require-imports
    (parcelRequire("7wBWJ"));
    const isDevMode = false;
    (0, $6s4F0.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $6s4F0.default).batchUpdates = !false;
    Object.freeze((0, $6s4F0.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("7wBWJ", function(module, exports) {
const $57a8f4eb12418915$var$style = document.createElement('style');
$57a8f4eb12418915$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body,[data-subtree-theme]{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif)}body{-ms-overflow-style:-ms-autohiding-scrollbar;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-focused,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-focused,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ul style:first-child~*+ul,ol ul:not(:first-child),ol style:first-child~*+ul,ul ol:not(:first-child),ul style:first-child~*+ol,ol ol:not(:first-child),ol style:first-child~*+ol{margin-top:var(--ds-space-050,4px)}p:first-child,style:first-child+p,ul:first-child,style:first-child+ul,ol:first-child,style:first-child+ol,dl:first-child,style:first-child+dl,h1:first-child,style:first-child+h1,h2:first-child,style:first-child+h2,h3:first-child,style:first-child+h3,h4:first-child,style:first-child+h4,h5:first-child,style:first-child+h5,h6:first-child,style:first-child+h6,blockquote:first-child,style:first-child+blockquote,pre:first-child,style:first-child+pre,form:first-child,style:first-child+form,table:first-child,style:first-child+table{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,ui-monospace,Menlo,"Segoe UI Mono","Ubuntu Mono",monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:var(--ds-border-width,1px)var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{color-scheme:light}[data-color-mode=dark]{color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:var(--ds-border-width-selected,2px)solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,style:first-child+td,th:first-child,style:first-child+th{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($57a8f4eb12418915$var$style);

});


parcelRegister("1j6ST", function(module, exports) {
$parcel$export(module.exports, "setSsrResourceTimeout", () => $8b31ef07bf6fe793$export$1d92ea83fb46d1f8);
$parcel$export(module.exports, "getSsrResourceTimeout", () => $8b31ef07bf6fe793$export$c9dfca603a555282);
const $8b31ef07bf6fe793$export$21e1ed4fcd4dd269 = 1200;
let $8b31ef07bf6fe793$var$currentSsrResourceTimeout = $8b31ef07bf6fe793$export$21e1ed4fcd4dd269;
const $8b31ef07bf6fe793$export$1d92ea83fb46d1f8 = (timeout)=>{
    $8b31ef07bf6fe793$var$currentSsrResourceTimeout = timeout || $8b31ef07bf6fe793$export$21e1ed4fcd4dd269;
};
const $8b31ef07bf6fe793$export$c9dfca603a555282 = ()=>$8b31ef07bf6fe793$var$currentSsrResourceTimeout;
const $8b31ef07bf6fe793$export$e638a45d8c691a4b = {
    get: $8b31ef07bf6fe793$export$c9dfca603a555282,
    set: $8b31ef07bf6fe793$export$1d92ea83fb46d1f8
};

});

parcelRegister("dsVXF", function(module, exports) {
$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $dcfa27f3f38bf37a$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $dcfa27f3f38bf37a$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointReferencePlaceholder", () => $dcfa27f3f38bf37a$export$35247b69e0cfe74);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $TTcqD = parcelRequire("TTcqD");

var $a8EUd = parcelRequire("a8EUd");

var $aWliK = parcelRequire("aWliK");
const $dcfa27f3f38bf37a$var$styles = {
    root: "_1e0c1bgi"
};
function $dcfa27f3f38bf37a$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // oxlint-disable-next-line typescript/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $dcfa27f3f38bf37a$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $euxye.createContext)(new Map());
/**
 * Entry point placeholder component without content preservation.
 * Uses the fallback from props directly without attempting to preserve SSR content.
 */ function $dcfa27f3f38bf37a$var$NoContentPreservationEntryPointReferencePlaceholder({ children: children, entryPointReference: entryPointReference, fallback: fallback, name: name, isPlaceholderForPageLayoutComponent: _isPlaceholderForPageLayoutComponent, isSSRPlaceholderEnabled: _isSSRPlaceholderEnabled, ...placeholderProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, children);
}
$dcfa27f3f38bf37a$var$NoContentPreservationEntryPointReferencePlaceholder.displayName = "NoContentPreservationEntryPointReferencePlaceholder";
/**
 * Entry point placeholder component with content preservation.
 * Preserves SSR-rendered content from the context until the component is ready.
 */ function $dcfa27f3f38bf37a$var$EntryPointReferencePlaceholderWithContentPreservation({ children: children, entryPointReference: entryPointReference, fallback: originalFallback, name: name, isPlaceholderForPageLayoutComponent: isPlaceholderForPageLayoutComponent = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled, ...placeholderProps }) {
    const hasMounted = (0, $euxye.useRef)(false);
    const displaySsrPlaceholderAttrs = (0, $TTcqD.useSsrPlaceholders)();
    // using useState to ensure the entryPointReference is loaded synchronously
    // for the initial render (enabling SSR)
    const [component] = (0, $euxye.useState)(()=>{
        if (entryPointReference) try {
            return entryPointReference.getComponent();
        } catch (thrown) {
            return undefined;
        }
    });
    const placeholders = (0, $euxye.useContext)($dcfa27f3f38bf37a$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $euxye.useState)(!ssrFallback || component ? originalFallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name,
        ...isPlaceholderForPageLayoutComponent && {
            'data-layout-slot': 'true'
        },
        ...isSSRPlaceholderEnabled && {
            'data-vc': name
        },
        ...isSSRPlaceholderEnabled && displaySsrPlaceholderAttrs && false && {
            'data-ssr-placeholder': name
        },
        ...isSSRPlaceholderEnabled && displaySsrPlaceholderAttrs && !false && {
            'data-ssr-placeholder-replace': name
        },
        className: (0, $4jQY2.default)([
            $dcfa27f3f38bf37a$var$styles.root
        ])
    }));
    const lastOriginalFallback = (0, $euxye.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    const resetFallback = (0, $euxye.useCallback)(()=>{
        if (placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        name,
        placeholders,
        setFallback
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        // reset the fallback when the entrypoint reference changes
        if (hasMounted.current) resetFallback();
    }, [
        entryPointReference,
        resetFallback
    ]);
    (0, $euxye.useEffect)(()=>{
        hasMounted.current = true;
        // reset fallback on unmount
        return resetFallback;
    }, [
        resetFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
        "data-ep-placeholder-id": name,
        ...isPlaceholderForPageLayoutComponent && {
            'data-layout-slot': 'true'
        },
        ...isSSRPlaceholderEnabled && {
            'data-vc': name
        },
        ...isSSRPlaceholderEnabled && false && {
            'data-ssr-placeholder': name
        },
        ...isSSRPlaceholderEnabled && !false && {
            'data-ssr-placeholder-replace': name
        },
        className: (0, $4jQY2.default)([
            $dcfa27f3f38bf37a$var$styles.root
        ])
    }, children));
}
$dcfa27f3f38bf37a$var$EntryPointReferencePlaceholderWithContentPreservation.displayName = "EntryPointReferencePlaceholderWithContentPreservation";
const $dcfa27f3f38bf37a$export$35247b69e0cfe74 = (0, $aWliK.componentWithCondition)(// useIsHydrateRenderMode isn't actually a hook and componentWithCondition is evaluated at render time :)
()=>(0, $TTcqD.useIsHydrateRenderMode)() || !false && !globalThis.__SPA__, $dcfa27f3f38bf37a$var$NoContentPreservationEntryPointReferencePlaceholder, $dcfa27f3f38bf37a$var$EntryPointReferencePlaceholderWithContentPreservation);

});

parcelRegister("cAfRH", function(module, exports) {
$parcel$export(module.exports, "NonCritical", () => $dd9ab9266fa0dc36$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $dd9ab9266fa0dc36$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $62Xqf = parcelRequire("62Xqf");
const $dd9ab9266fa0dc36$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const isReady = (0, $62Xqf.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $euxye.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    }
    return null;
};
$dd9ab9266fa0dc36$export$83d969795398ec56.displayName = "NonCriticalComponentWithTimerFallback";
const $dd9ab9266fa0dc36$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($dd9ab9266fa0dc36$export$83d969795398ec56, props));
$dd9ab9266fa0dc36$export$5b2f4b62d18632.displayName = "NonCriticalWithTimerFallback";
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $dd9ab9266fa0dc36$var$NonCriticalComponent = (props)=>{
    const isReady = (0, $62Xqf.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $euxye.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, props.children);
    }
    return null;
};
$dd9ab9266fa0dc36$var$NonCriticalComponent.displayName = "NonCriticalComponent";
const $dd9ab9266fa0dc36$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($dd9ab9266fa0dc36$var$NonCriticalComponent, props));
$dd9ab9266fa0dc36$export$20fd89b1bf707b1a.displayName = "NonCritical";
var $dd9ab9266fa0dc36$export$2e2bcd8739ae039 = $dd9ab9266fa0dc36$var$NonCriticalComponent;

});

parcelRegister("fAYMv", function(module, exports) {
$parcel$export(module.exports, "Spa", () => $8a9200c2d7d817b9$export$6d4069f4b64f7492);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $979J2 = parcelRequire("979J2");

var $a8EUd = parcelRequire("a8EUd");

var $dQkkK = parcelRequire("dQkkK");


var $iLktG = parcelRequire("iLktG");

var $i860n = parcelRequire("i860n");

var $bnTQg = parcelRequire("bnTQg");

var $3wQ2J = parcelRequire("3wQ2J");

var $6CchP = parcelRequire("6CchP");

var $8SFjS = parcelRequire("8SFjS");

var $1jGfn = parcelRequire("1jGfn");

var $78Q6r = parcelRequire("78Q6r");

var $92ZVP = parcelRequire("92ZVP");

var $fJ0xd = parcelRequire("fJ0xd");
const $8a9200c2d7d817b9$var$FaviconService = /*#__PURE__*/ (0, $euxye.memo)(()=>{
    (0, $bnTQg.useFaviconService)();
    return null;
});
const $8a9200c2d7d817b9$export$6d4069f4b64f7492 = ({ locale: locale, messages: messages, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
    const isStreamingEnabled = (0, $979J2.useIsStreamingEnabled)();
    const isStreamingAdvisoryEnabled = (0, $979J2.useIsStreamingAdvisoryEnabled)();
    const pageContainerPerformanceTiming = (0, $euxye.useCallback)(()=>{
        (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)((0, $e6ec049ffa8f915a$export$21473105c510aacc), (0, $e6ec049ffa8f915a$export$59f83d43fe209319), (0, $e6ec049ffa8f915a$export$7114284ca03133ee), true, true);
    }, []);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6CchP.PageContainer), {
        id: false ? 'jira.entry.ssr' : 'spa',
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1jGfn.ReadinessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8a9200c2d7d817b9$var$FaviconService, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$7114284ca03133ee),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SFjS.Content), {
        initRoute: initRoute,
        routes: routes
    }), (0, $i860n.fg)('magma-hotfix-testing') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $78Q6r.HotfixTesting), null), (0, $i860n.fg)('ditto_fcf_jira_globalbackgroundscript') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3wQ2J.ForgeUiGlobalExtensionsAsync), null));
    // During M1 of streaming, the client does not need to know that we're streaming, as we're practically returning the same output as with M1 streaming disabled.
    // Because of this only isStreamingAdvisoryEnabled is set to true on the client, but we still need to render the same tree as on SSR.
    // Because of this we check both isStreamingEnabled and isStreamingAdvisoryEnabled to ensure we render the same tree on both.
    if (isStreamingEnabled || isStreamingAdvisoryEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "root"
    }, content), isStreamingAdvisoryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fJ0xd.StreamingAdvisory), null));
    if ((0, $i860n.fg)('jfp-magma-hydration-advisory')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $92ZVP.HydrationAdvisory), null));
    return content;
};
$8a9200c2d7d817b9$export$6d4069f4b64f7492.displayName = "Spa";

});
parcelRegister("979J2", function(module, exports) {
$parcel$export(module.exports, "useIsStreamingEnabled", () => $fdb46af67757da10$export$623a0bcaea828a1a);
$parcel$export(module.exports, "useIsStreamingAdvisoryEnabled", () => $fdb46af67757da10$export$7e2cdec4fb4547f5);

var $ldgHZ = parcelRequire("ldgHZ");
const $fdb46af67757da10$export$623a0bcaea828a1a = ()=>{
    return (0, $ldgHZ.isStreamingEnabled)();
};
const $fdb46af67757da10$export$7e2cdec4fb4547f5 = ()=>{
    return (0, $ldgHZ.isStreamingAdvisoryEnabled)();
};

});

parcelRegister("dQkkK", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a4bd3fbd7a8174$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $6xuJS = parcelRequire("6xuJS");
const $33a4bd3fbd7a8174$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $euxye.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $6xuJS.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
$33a4bd3fbd7a8174$var$PerformanceMark.displayName = "PerformanceMark";
var $33a4bd3fbd7a8174$export$2e2bcd8739ae039 = $33a4bd3fbd7a8174$var$PerformanceMark;

});

parcelRegister("bnTQg", function(module, exports) {
$parcel$export(module.exports, "useFaviconService", () => $3052e32ced04bfe7$export$c5544731c404c896);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8RAJy = parcelRequire("8RAJy");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $gWmMH = parcelRequire("gWmMH");

var $XssJM = parcelRequire("XssJM");

var $f2wVS = parcelRequire("f2wVS");

var $eWrdd = parcelRequire("eWrdd");

var $kQzXa = parcelRequire("kQzXa");

var $7o9Ps = parcelRequire("7o9Ps");

var $9TtJ9 = parcelRequire("9TtJ9");

var $iXSkG = parcelRequire("iXSkG");

var $8gTrz = parcelRequire("8gTrz");
const $3052e32ced04bfe7$export$f948ae143e35cfaf = 'ajs-fspage-favicon-prefixed';
const $3052e32ced04bfe7$export$c9e8acb6bea47122 = 'ajs-fspage-favicon';
const $3052e32ced04bfe7$export$7ef9895286e10387 = 'ajs-favicon-use-projecticon';
const $3052e32ced04bfe7$var$useRouteGroup = (0, $f2wVS.createRouterSelector)((state)=>state.route.group);
const $3052e32ced04bfe7$var$getCustomFavicon = ()=>{
    // Some instances might not have the prefixed metadata key, so we fallback to the original key
    const faviconPath = (0, $6bEm8.default)($3052e32ced04bfe7$export$f948ae143e35cfaf) || (0, $6bEm8.default)($3052e32ced04bfe7$export$c9e8acb6bea47122);
    // Check if favicon is default or custom by matching the image path with pattern "favicon.*.ico"
    if (faviconPath) {
        const imagePath = faviconPath.split('/').at(-1);
        const defaultFaviconPattern = /^favicon.*\.ico$/;
        if (imagePath && !defaultFaviconPattern.test(imagePath)) return faviconPath;
    }
    return null;
};
const $3052e32ced04bfe7$export$c5544731c404c896 = false ? ()=>undefined : ()=>{
    const routeGroup = $3052e32ced04bfe7$var$useRouteGroup();
    const { data: project } = (0, $XssJM.useProject)();
    const isProjectFaviconEnabled = (0, $6bEm8.default)($3052e32ced04bfe7$export$7ef9895286e10387) === 'true';
    const productName = (0, $gWmMH.useProductName)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $euxye.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const customFavicon = $3052e32ced04bfe7$var$getCustomFavicon();
    const { faviconState: assetsFaviconState, hasAssetsEntitlementEnabled: hasAssetsEntitlementEnabled } = (0, $8RAJy.useFaviconService)();
    const assetsCustomFaviconUrl = assetsFaviconState.data?.url64;
    const isAssetsDefaultFavicon = Boolean(assetsFaviconState.data?.isDefaultFavicon);
    const showAssetsCustomFavicon = !isAssetsDefaultFavicon && assetsCustomFaviconUrl;
    (0, $euxye.useEffect)(()=>{
        let faviconPath = defaultFavicon;
        if (routeGroup === 'assets' && (0, $i860n.fg)('assets_as_an_app_v2')) {
            // Assets is currently a specific set of routes, and doesn't exist as a separate "product" as per `productName`.
            // Assets is moving towards being a platform outside of Jira (rendering its own Bifrost app etc), so it doesn't
            // make sense to register it as a Jira sub-product.
            if (showAssetsCustomFavicon) faviconPath = assetsCustomFaviconUrl;
            else if (customFavicon && !hasAssetsEntitlementEnabled) faviconPath = customFavicon;
            else if ((0, $i860n.fg)('assets-platform-branding') || (0, $i860n.fg)('assets-platform-branding-with-confluence')) faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($kQzXa)));
            else faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($eWrdd)));
        } else if (isProjectFaviconEnabled && project) faviconPath = project.avatarUrl;
        else if (customFavicon) faviconPath = customFavicon;
        else if (productName === 'serviceDesk') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($iXSkG)));
        else if (productName === 'product-discovery') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($9TtJ9)));
        else if (productName === 'customer-service') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($8gTrz)));
        else if (productName === 'jira' || productName === 'core' || productName === 'software') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($7o9Ps)));
        if (iconEle instanceof HTMLLinkElement) iconEle.href = faviconPath;
        // Cleanup: Restore default favicon when component unmounts
        return ()=>{
            if (iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
        };
    }, [
        routeGroup,
        productName,
        defaultFavicon,
        iconEle,
        customFavicon,
        isProjectFaviconEnabled,
        project,
        assetsCustomFaviconUrl,
        showAssetsCustomFavicon,
        hasAssetsEntitlementEnabled
    ]);
};

});
parcelRegister("8RAJy", function(module, exports) {
$parcel$export(module.exports, "useFaviconService", () => $652c905369a47bbf$export$c5544731c404c896);

var $euxye = parcelRequire("euxye");

var $bOYO0 = parcelRequire("bOYO0");

var $1kh2I = parcelRequire("1kh2I");

var $iuGVF = parcelRequire("iuGVF");

var $57UQ8 = parcelRequire("57UQ8");

var $zbgUa = parcelRequire("zbgUa");
const $652c905369a47bbf$export$c5544731c404c896 = ()=>{
    const { data: resourceData, loading: loading, error: error, update: update } = (0, $1kh2I.useAssetsLogoAndFaviconResource)();
    const assetsTenantContext = (0, $zbgUa.useAssetsTenantContext)();
    const hasAssetsEntitlementEnabled = (0, $bOYO0.hasAssetsEntitlement)(assetsTenantContext);
    const [faviconState, setFaviconState] = (0, $euxye.useState)({
        loading: loading,
        error: error instanceof Error ? error : null,
        data: resourceData?.favicon ?? null
    });
    (0, $euxye.useEffect)(()=>{
        if (!loading && resourceData) setFaviconState((prev)=>({
                ...prev,
                data: resourceData.favicon
            }));
    }, [
        loading,
        resourceData
    ]);
    const uploadFavicon = async (workspaceId, payload)=>{
        setFaviconState((prev)=>({
                ...prev,
                loading: true,
                error: null
            }));
        try {
            const uploadedFavicon = await (0, $iuGVF.uploadFavicon)(workspaceId, payload);
            update((currentData)=>{
                return currentData ? {
                    ...currentData,
                    favicon: uploadedFavicon
                } : {
                    logo: (0, $57UQ8.emptyLogoResponse),
                    favicon: uploadedFavicon
                };
            });
            setFaviconState({
                loading: false,
                error: null,
                data: uploadedFavicon
            });
        } catch (uploadError) {
            setFaviconState({
                loading: false,
                error: uploadError instanceof Error ? uploadError : null,
                data: null
            });
            throw uploadError;
        }
    };
    const resetFaviconToDefault = async (workspaceId)=>{
        setFaviconState((prev)=>({
                ...prev,
                loading: true,
                error: null
            }));
        try {
            const defaultFavicon = await (0, $iuGVF.resetFaviconToDefault)(workspaceId);
            update((currentData)=>{
                return currentData ? {
                    ...currentData,
                    favicon: defaultFavicon
                } : {
                    logo: (0, $57UQ8.emptyLogoResponse),
                    favicon: defaultFavicon
                };
            });
            setFaviconState({
                loading: false,
                error: null,
                data: defaultFavicon
            });
        } catch (resetError) {
            setFaviconState({
                loading: false,
                error: resetError instanceof Error ? resetError : null,
                data: null
            });
            throw resetError;
        }
    };
    return {
        faviconState: faviconState,
        uploadFavicon: uploadFavicon,
        resetFaviconToDefault: resetFaviconToDefault,
        isDefaultFavicon: Boolean(resourceData?.favicon?.isDefaultFavicon),
        hasAssetsEntitlementEnabled: hasAssetsEntitlementEnabled
    };
};

});

parcelRegister("gWmMH", function(module, exports) {
$parcel$export(module.exports, "useProductName", () => $3ef65d5ae0317ccd$export$dde400a84de238be);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $1KydW = parcelRequire("1KydW");

var $h8lYu = parcelRequire("h8lYu");
const $3ef65d5ae0317ccd$export$dde400a84de238be = ()=>{
    const appPermissions = (0, $1KydW.useApplicationPermissions)();
    return (0, $h8lYu.getProductName)(appPermissions);
};

});
parcelRegister("h8lYu", function(module, exports) {
$parcel$export(module.exports, "getProductName", () => $506417f12ea4fdb2$export$aa3f36fe5dd1f237);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $506417f12ea4fdb2$export$aa3f36fe5dd1f237 = (permissions)=>{
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
    return ([
        {
            condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
            value: 'software'
        },
        {
            condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
            value: 'serviceDesk'
        },
        {
            condition: hasServiceDeskAccess && hasCustomerServiceAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess,
            value: 'serviceDesk'
        },
        {
            condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
            value: 'core'
        },
        {
            condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasCustomerServiceAccess,
            value: 'product-discovery'
        },
        {
            condition: hasCustomerServiceAccess && !hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
            value: 'customer-service'
        }
    ].find((item)=>item.condition) || {
        value: 'jira'
    }).value;
};

});


parcelRegister("eWrdd", function(module, exports) {
module.exports = new URL("favicon-temp-assets.32f0aa73.png", import.meta.url).toString();

});

parcelRegister("kQzXa", function(module, exports) {
module.exports = new URL("favicon-temp-assets-platform.b96df0c9.png", import.meta.url).toString();

});

parcelRegister("7o9Ps", function(module, exports) {
module.exports = new URL("favicon-temp-family.9e1adb01.png", import.meta.url).toString();

});

parcelRegister("9TtJ9", function(module, exports) {
module.exports = new URL("favicon-temp-jpd.d360a2a3.png", import.meta.url).toString();

});

parcelRegister("iXSkG", function(module, exports) {
module.exports = new URL("favicon-temp-jsm.a82c490c.png", import.meta.url).toString();

});

parcelRegister("8gTrz", function(module, exports) {
module.exports = new URL("favicon-temp-csm.7aac7873.png", import.meta.url).toString();

});


parcelRegister("3wQ2J", function(module, exports) {
$parcel$export(module.exports, "ForgeUiGlobalExtensionsAsync", () => $e2f7050c74042686$export$49ab642f30b953dd);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kCfV9 = parcelRequire("kCfV9");

const $e2f7050c74042686$var$forgeUiGlobalResource = (0, $kCfV9.JSResourceForBackground)(()=>(parcelRequire("e1vnB")).then((m)=>m.default), {
    moduleId: "2e38c0c3",
    priority: "background"
});
const $e2f7050c74042686$export$49ab642f30b953dd = ()=>{
    const [LoadedComponent, setLoadedComponent] = (0, $euxye.useState)(null);
    const mounted = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        mounted.current = true;
        if (!LoadedComponent) $e2f7050c74042686$var$forgeUiGlobalResource.load().then((resource)=>{
            if (!mounted.current) return;
            const Comp = resource;
            if (Comp) setLoadedComponent(()=>Comp);
        });
        return ()=>{
            mounted.current = false;
        };
    }, [
        LoadedComponent
    ]);
    return LoadedComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(LoadedComponent, null);
};
$e2f7050c74042686$export$49ab642f30b953dd.displayName = "ForgeUiGlobalExtensionsAsync";

});
parcelRegister("kCfV9", function(module, exports) {
$parcel$export(module.exports, "JSResourceForBackground", () => $72c35c3dc3193d41$export$1f734e6fd513727a);

var $jW8UK = parcelRequire("jW8UK");

var $hkiLZ = parcelRequire("hkiLZ");

var $bCiN9 = parcelRequire("bCiN9");
const $72c35c3dc3193d41$var$cache = (0, $jW8UK.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $72c35c3dc3193d41$var$RUNTIME_STRING_ERROR = "JSResourceForBackground was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $72c35c3dc3193d41$export$1f734e6fd513727a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$72c35c3dc3193d41$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $72c35c3dc3193d41$var$cache.get(opts.moduleId, ()=>(0, $hkiLZ.PreloadableJSResource)(()=>(0, $bCiN9.postTask)(loaderOrPath, {
                priority: 'background'
            }), opts));
}

});

parcelRegister("e1vnB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("lgRoL")
]).then(()=>parcelRequire('5f2Mf'));

});


parcelRegister("6CchP", function(module, exports) {
$parcel$export(module.exports, "PageContainer", () => $9a0b21ab4e5cdd89$export$5f86df0ee0a255b5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");

var $bmNys = parcelRequire("bmNys");

var $3cRSz = parcelRequire("3cRSz");
const $9a0b21ab4e5cdd89$export$5f86df0ee0a255b5 = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpx-463-spa-relay-query'), (0, $bmNys.JiraSpaPageContainerBootstrapper), (0, $3cRSz.JiraSpaPageContainerOld));

});
parcelRegister("bmNys", function(module, exports) {
$parcel$export(module.exports, "JiraSpaPageContainerBootstrapper", () => $c39f141b38df8add$export$3e543cc7b96c89a2);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $kt86l = parcelRequire("kt86l");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");


var $btoiF = parcelRequire("btoiF");

var $htsFl = parcelRequire("htsFl");

var $9Q50z = parcelRequire("9Q50z");

var $bIzi7 = parcelRequire("bIzi7");

var $1bhIG = parcelRequire("1bhIG");

var $6IHMU = parcelRequire("6IHMU");
/**
 * Glues whatever the SSR service did with this route's configuration in to the CSR render process.
 *
 * @note
 * The page layout has its own data query, which is preloaded during SSR.
 * This component attempts to load the query via entrypoint definition first.
 * If that does not exist, it falls back to a route-resource method.
 * If that does not work, it falls back to loading the query lazily.
 */ const $c39f141b38df8add$var$LoadViaSideEffect = (props)=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // Check both of our mechanisms for initiating queries ahead of time
    const spaPageEntryPointReference = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$22ce74854c620e75));
    const { queryReference: queryReferenceViaRouteResource } = (0, $htsFl.useRelayResource)((0, $9Q50z.jiraSpaPageContainerResource));
    // Condense the two mechanisms in to a single preloaded query reference (or null)
    const initialQueryReference = spaPageEntryPointReference?.queries?.queryReference || queryReferenceViaRouteResource || null;
    // Invoke query loader, which will either use the (now-found) preloaded query, or a null query reference
    const [queryReference, loadQuery] = (0, $n67Vb.useQueryLoader)((0, $6IHMU.default), initialQueryReference);
    // We lean on this query having been kicked off via a route resource or a nested page entrypoint.
    // If we're in the client and it hasn't been started, we need to force the query to load lazily.
    // This would typically happen on a static fallback page or a misconfigured route.
    // This effect wouldn't ever run during SSR, so don't worry about that.
    (0, $euxye.useEffect)(()=>{
        if (!queryReference) {
            const event = createAnalyticsEvent({});
            (0, $aJ81Y.fireOperationalAnalytics)(event, 'jiraSpaPageContainerBootstrapper fallback', {
                isSpa: !!globalThis.__SPA__,
                // @ts-expect-error it exists most of the time
                hasSpaState: !!globalThis.SPA_STATE,
                // @ts-expect-error it exists some of the time
                isSsrFallback: !!globalThis.__SSR_FALLBACK__,
                ssrDetails: globalThis.SSR_DETAILS
            });
            (0, $euxye.startTransition)(()=>loadQuery({
                    cloudId: cloudId
                }));
        }
    }, [
        queryReference,
        loadQuery,
        cloudId,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1bhIG.JiraSpaPageContainer), {
        queryReference: queryReference
    }, props.children);
};
$c39f141b38df8add$var$LoadViaSideEffect.displayName = "LoadViaSideEffect";
const $c39f141b38df8add$export$3e543cc7b96c89a2 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bIzi7.GlobalContextProvider), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c39f141b38df8add$var$LoadViaSideEffect, null, children));
};
$c39f141b38df8add$export$3e543cc7b96c89a2.displayName = "JiraSpaPageContainerBootstrapper";

});
parcelRegister("btoiF", function(module, exports) {
$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $0d107f7c073839dc$export$fe1c839e8baf4110);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3BHey = parcelRequire("3BHey");

var $4Onaa = parcelRequire("4Onaa");
const $0d107f7c073839dc$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const entryPointReference = (0, $3BHey.useRouteEntryPoint)({
        route: route
    });
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("3BHey", function(module, exports) {
$parcel$export(module.exports, "useRouteEntryPoint", () => $fdccfcf2cac6c9dd$export$c96377f800cdddb4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $69eDJ = parcelRequire("69eDJ");
const $fdccfcf2cac6c9dd$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $69eDJ.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});
parcelRegister("69eDJ", function(module, exports) {
$parcel$export(module.exports, "useLastLoadedRoute", () => $a2327206acecff45$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $a2327206acecff45$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $a2327206acecff45$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $a2327206acecff45$export$7e18f3e3cbd04326);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $ciIbx = parcelRequire("ciIbx");
const $a2327206acecff45$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $a2327206acecff45$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $a2327206acecff45$var$actions = {
    setLastLoadedRoute: $a2327206acecff45$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $a2327206acecff45$export$bb3dc9c55f78173e
};
const $a2327206acecff45$var$EntryPointsStore = (0, $5QDqc.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $a2327206acecff45$var$actions,
    name: 'react-resource-router/entry-points'
});
const $a2327206acecff45$export$895238443fc3eae4 = (0, $3h1FP.createHook)($a2327206acecff45$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $a2327206acecff45$export$fe654a734624d17f = ()=>(0, $ciIbx.defaultRegistry).getStore($a2327206acecff45$var$EntryPointsStore);
const $a2327206acecff45$export$b28ecd0e4705f6b7 = ()=>$a2327206acecff45$export$fe654a734624d17f().storeState.getState();
const $a2327206acecff45$export$5763b2305b3056df = ()=>$a2327206acecff45$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $a2327206acecff45$export$7e18f3e3cbd04326 = ()=>$a2327206acecff45$export$b28ecd0e4705f6b7().prefetchingRoute;

});



parcelRegister("bIzi7", function(module, exports) {
$parcel$export(module.exports, "GlobalContextProvider", () => $4b8dd4ad8861a669$export$e514c39bb46f1923);

var $euxye = parcelRequire("euxye");


var $dQkkK = parcelRequire("dQkkK");

var $iLktG = parcelRequire("iLktG");

var $1JfCO = parcelRequire("1JfCO");
const $4b8dd4ad8861a669$export$e514c39bb46f1923 = (props)=>{
    const { id: id, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent, children: children } = props;
    const pageContainerPerformanceTiming = (0, $euxye.useCallback)(()=>{
        (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)((0, $e6ec049ffa8f915a$export$898b6208220685b0), (0, $e6ec049ffa8f915a$export$e2bc63118050de32), (0, $e6ec049ffa8f915a$export$59f83d43fe209319), true, false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1JfCO.GlobalContainers), {
        id: id,
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), children));
};
$4b8dd4ad8861a669$export$e514c39bb46f1923.displayName = "GlobalContextProvider";

});
parcelRegister("1JfCO", function(module, exports) {
$parcel$export(module.exports, "GlobalContainers", () => $9d00cd2b53e58b8b$export$3b677a7048d7ae0);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f2wVS = parcelRequire("f2wVS");

var $5rm2I = parcelRequire("5rm2I");

var $5hgiN = parcelRequire("5hgiN");

var $hTmoz = parcelRequire("hTmoz");

var $8w5ez = parcelRequire("8w5ez");

var $kLjnO = parcelRequire("kLjnO");

var $a8EUd = parcelRequire("a8EUd");

var $dQkkK = parcelRequire("dQkkK");

var $lPmfV = parcelRequire("lPmfV");

var $6bEm8 = parcelRequire("6bEm8");

var $1lRyZ = parcelRequire("1lRyZ");


var $h3795 = parcelRequire("h3795");

var $kWzqm = parcelRequire("kWzqm");

var $jG3eR = parcelRequire("jG3eR");

var $55cpN = parcelRequire("55cpN");

var $6zTYs = parcelRequire("6zTYs");

var $iLktG = parcelRequire("iLktG");

var $eijVy = parcelRequire("eijVy");

var $7jSss = parcelRequire("7jSss");

var $AmkAi = parcelRequire("AmkAi");

var $jepRN = parcelRequire("jepRN");

var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");

var $75YsU = parcelRequire("75YsU");

var $fnihK = parcelRequire("fnihK");

var $lRV6k = parcelRequire("lRV6k");

var $i1x6r = parcelRequire("i1x6r");

var $l7ocq = parcelRequire("l7ocq");

var $9CVb0 = parcelRequire("9CVb0");

var $h8EvR = parcelRequire("h8EvR");

var $ilauN = parcelRequire("ilauN");

var $jz0sK = parcelRequire("jz0sK");

var $oeNBe = parcelRequire("oeNBe");

var $flKp5 = parcelRequire("flKp5");

var $6ZLJT = parcelRequire("6ZLJT");
const $9d00cd2b53e58b8b$var$MaybePreviewPanelsProvider = (0, $jepRN.componentWithFG)('jira-glance-panel', (0, $7jSss.PreviewPanelsProvider), (0, $euxye.Fragment));
const $9d00cd2b53e58b8b$var$EventHorizon = /*#__PURE__*/ (0, $euxye.memo)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children));
const $9d00cd2b53e58b8b$var$Passthrough = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
$9d00cd2b53e58b8b$var$Passthrough.displayName = "Passthrough";
const $9d00cd2b53e58b8b$var$MaybeIssuePreviewViewModeProvider = (0, $aWliK.componentWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $i860n.fg)('jira_wiv_modal_view_consistency') && (0, $75YsU.isWorkItemModernizationGatesEnabled)(), (0, $AmkAi.default), $9d00cd2b53e58b8b$var$Passthrough);
// Deprioritises rendering child components when React progressive hydration is running.
const $9d00cd2b53e58b8b$var$ScreenSpaceFlagsPlaceholder = (0, $jepRN.componentWithFG)('jpx-463-spa-deprioritise-postoffice-screen-flags', (0, $a8EUd.default), $9d00cd2b53e58b8b$var$Passthrough);
const $9d00cd2b53e58b8b$var$MaybeRovoNudgePlacement = (0, $jepRN.componentWithFG)('post-office_enable-rovo-nudge-placement_gate', (0, $5rm2I.Placement), (0, $euxye.Fragment));
const $9d00cd2b53e58b8b$var$MaybeJsmLiveChatPlacement = (0, $jepRN.componentWithFG)('jsm_live_chat_browser_notifications', (0, $5hgiN.Placement), (0, $euxye.Fragment));
const $9d00cd2b53e58b8b$export$33711a1ebb85e1e4 = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jira_screen_space_flag_route_change'), ()=>$9d00cd2b53e58b8b$var$useRouterLocationPathname(), ()=>'');
const $9d00cd2b53e58b8b$var$useRouterLocationPathname = (0, $f2wVS.createRouterSelector)((state)=>state.location.pathname);
const $9d00cd2b53e58b8b$export$8318d01ce600c21b = ()=>{
    const pathname = $9d00cd2b53e58b8b$export$33711a1ebb85e1e4();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9d00cd2b53e58b8b$var$ScreenSpaceFlagsPlaceholder, {
        name: "screen-flags-placement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jG3eR.ScreenSpaceFlagsPlacement), (0, $i860n.fg)('jira_screen_space_flag_route_change') ? {
        key: pathname
    } : null));
};
$9d00cd2b53e58b8b$export$8318d01ce600c21b.displayName = "ScreenSpaceFlagsPlacementWithRouteKey";
const $9d00cd2b53e58b8b$export$3b677a7048d7ae0 = /*#__PURE__*/ (0, $euxye.memo)(({ id: id, children: children, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const globalContainersPerformanceTiming = (0, $euxye.useCallback)(()=>{
        (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)((0, $e6ec049ffa8f915a$export$4f341d86a3c214), (0, $e6ec049ffa8f915a$export$16e7ead3a8b5c366), (0, $e6ec049ffa8f915a$export$c389f0b50840d5ca), true, true);
        (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)((0, $e6ec049ffa8f915a$export$7048c99f32c60b34), (0, $e6ec049ffa8f915a$export$3c2d8af5c7577fe7), (0, $e6ec049ffa8f915a$export$aac77afee74c49d0), true, true);
    }, []);
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("style", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, #FFFFFF)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9CVb0.IntlProviders), {
        messages: messages,
        locale: locale
    }, __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(MonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eijVy.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $6bEm8.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8w5ez.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lPmfV.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kLjnO.ViewExperienceTrackingProvider), {
        analyticsSource: (0, $e6ec049ffa8f915a$export$c9e16a15d65437),
        experience: (0, $e6ec049ffa8f915a$export$b1534bc11f201efd),
        experienceId: (0, $e6ec049ffa8f915a$export$fa4bbc89fd1f1a7),
        application: (0, $e6ec049ffa8f915a$export$aa6008fe0169b864),
        edition: (0, $e6ec049ffa8f915a$export$39418a21fbb51487),
        additionalAttributes: (0, $h3795.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l7ocq.ErrorBoundary), {
        id: id,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$16e7ead3a8b5c366)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Router, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hTmoz.default), {
        UNSAFE_isThemingDisabled: true,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$c389f0b50840d5ca)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jz0sK.PageConfigContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8EvR.MetricsContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55cpN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ilauN.NavigationContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i1x6r.UserPreferencesContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $oeNBe.UiManagers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$3c2d8af5c7577fe7)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kWzqm.PostOfficeRouterListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9d00cd2b53e58b8b$var$MaybePreviewPanelsProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9d00cd2b53e58b8b$var$MaybeIssuePreviewViewModeProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lRV6k.PanelProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $flKp5.LinkingProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fnihK.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$aac77afee74c49d0),
        onSet: globalContainersPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1lRyZ.SidebarNav4ControllerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9d00cd2b53e58b8b$var$EventHorizon, null, children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9d00cd2b53e58b8b$export$8318d01ce600c21b, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9d00cd2b53e58b8b$var$MaybeRovoNudgePlacement, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9d00cd2b53e58b8b$var$MaybeJsmLiveChatPlacement, null)))))))))))))));
});

});
parcelRegister("5rm2I", function(module, exports) {
$parcel$export(module.exports, "Placement", () => $aa69555f92d74612$export$af2bcbdc04a2d456);
// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

var $hAo2S = parcelRequire("hAo2S");

var $hmyVG = parcelRequire("hmyVG");

var $jlzDs = parcelRequire("jlzDs");

var $g51X5 = parcelRequire("g51X5");

var $5OhlA = parcelRequire("5OhlA");

var $HjNqP = parcelRequire("HjNqP");
const $aa69555f92d74612$var$messageFrontends = [
    (0, $hmyVG.MessageFrontend)({
        messageTemplateId: 'live-nudge-demo-message'
    }),
    (0, $jlzDs.MessageFrontend)({
        messageTemplateId: 'live-and-persisted-test-message'
    }),
    (0, $g51X5.MessageFrontend)({
        messageTemplateId: 'jira-board-catch-up-rovo-nudge'
    }),
    (0, $5OhlA.MessageFrontend)({
        messageTemplateId: 'jira-board-backlog-update-work-suggestions'
    })
];
const $aa69555f92d74612$export$7b621692a0aa2333 = (0, $hAo2S.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: $aa69555f92d74612$var$messageFrontends
});
const $aa69555f92d74612$export$af2bcbdc04a2d456 = (0, $HjNqP.withI18n)($aa69555f92d74612$export$7b621692a0aa2333);
const $aa69555f92d74612$export$7d3d92a960f07a28 = $aa69555f92d74612$export$7b621692a0aa2333;

});
parcelRegister("hAo2S", function(module, exports) {
$parcel$export(module.exports, "PlacementFrontend", () => $6e8f64e36648f43b$export$55486c2b6964dcf2);
$parcel$export(module.exports, "PlacementBackend", () => $6e8f64e36648f43b$export$d90b37843c84d1c3);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iISCq = parcelRequire("iISCq");
var $j142y = parcelRequire("j142y");

var $fGrpH = parcelRequire("fGrpH");

var $2vhMr = parcelRequire("2vhMr");

var $a5l9n = parcelRequire("a5l9n");

var $gOhos = parcelRequire("gOhos");

var $1mpEL = parcelRequire("1mpEL");

var $dSKwo = parcelRequire("dSKwo");

var $kHtv0 = parcelRequire("kHtv0");

var $kT2HN = parcelRequire("kT2HN");

var $1wUjh = parcelRequire("1wUjh");
const $6e8f64e36648f43b$var$ROVO_NUDGE_PLACEMENT_ID = 'rovo-nudge';
const $6e8f64e36648f43b$var$LIVE_NUDGE_DEMO_MESSAGE_DATA_FRAGMENT = `... on PostOfficeMessageRovoNudgeLiveNudgeDemoMessageData {
	__typename
	title
	description
}`;
const $6e8f64e36648f43b$var$LIVE_AND_PERSISTED_TEST_MESSAGE_DATA_FRAGMENT = `... on PostOfficeMessageRovoNudgeLiveAndPersistedTestMessageData {
	__typename
	title
	description
}`;
const $6e8f64e36648f43b$var$JIRA_BOARD_CATCH_UP_ROVO_NUDGE_DATA_FRAGMENT = `... on PostOfficeMessageRovoNudgeJiraBoardCatchUpRovoNudgeData {
	__typename
	title
	description
}`;
const $6e8f64e36648f43b$var$JIRA_BOARD_BACKLOG_UPDATE_WORK_SUGGESTIONS_DATA_FRAGMENT = `... on PostOfficeMessageRovoNudgeJiraBoardBacklogUpdateWorkSuggestionsData {
	__typename
	conversationChannelId
	numberOfSuggestions
}`;
const $6e8f64e36648f43b$var$doesScopeMatchPathname = (scopeName, pathname)=>{
    if (!pathname) return false;
    const scope = (0, $dSKwo.scopes).find((scopeConfig)=>scopeConfig.name === scopeName);
    const pathnameMatcher = scope?.when?.route?.pathname;
    if (!pathnameMatcher) return true;
    if (typeof pathnameMatcher === 'string') return pathname === pathnameMatcher;
    if (typeof pathnameMatcher.equals === 'string') return pathname === pathnameMatcher.equals;
    if (typeof pathnameMatcher.matches === 'string') try {
        return new RegExp(pathnameMatcher.matches).test(pathname);
    } catch  {
        return false;
    }
    return true;
};
const $6e8f64e36648f43b$var$placement = (0, $2vhMr.createPlacement)({
    placementId: $6e8f64e36648f43b$var$ROVO_NUDGE_PLACEMENT_ID,
    options: {
        choreographer: {
            isDefaultEnabled: true
        },
        hideInIsolatedCloud: false,
        subscription: {
            enabled: true
        }
    }
});
const $6e8f64e36648f43b$export$81df3aa6753d44e2 = $6e8f64e36648f43b$var$placement.createFrontend;
const $6e8f64e36648f43b$export$da912f58cb37a643 = $6e8f64e36648f43b$var$placement.createBackend;
/**
 * preInit stage that applies the active scopes check filter.
 *
 * rovo-nudge is an in-app-v2 placement. The in-app-v2 runtime does not expose
 * a direct `pre-filters` injection pathway (unlike in-app / screen-space-flags which
 * passes `pre-filters` through `getEligibleMessages` additionalParameters.stages).
 *
 * Using `preInit` is the recommended approach for in-app-v2 placements:
 * - It executes before `init` (transformMetadata) and `postInit` (hydrate),
 *   so filtered messages are never unnecessarily hydrated.
 * - `activeScopes` is forwarded by the placement router into
 *   `request.additionalContext.activeScopes`, making it available here.
 * - The scope-check logic is identical to what screen-space-flags uses via pre-filters;
 *   the `createActiveScopesCheckFilter` export from `@post-office/placement-filters`
 *   is the shared, extracted version of that filter.
 */ const $6e8f64e36648f43b$var$activeScopesPreInitStage = async (input)=>{
    const { request: request, data: data } = input;
    const activeScopes = request.additionalContext?.activeScopes;
    return {
        messages: (0, $gOhos.filterEligibleMessagesByActiveScopes)(data.messages, {
            activeScopes: activeScopes,
            requestContext: request
        })
    };
};
const $6e8f64e36648f43b$var$RovoNudgeSubscriptionContent = ({ Messages: Messages, variables: variables })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    // Register this effect before the subscription hook so the placement traffic event is
    // scheduled as close as possible to subscription setup. The event is intended to track
    // every aligned rovo-nudge subscription attempt; placing it after the subscription hook
    // can undercount when subscription setup effects run before this analytics effect.
    (0, $euxye.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'rovoNudgePlacement',
            attributes: {
                placementId: $6e8f64e36648f43b$var$ROVO_NUDGE_PLACEMENT_ID,
                activeScope: variables.activeScopes,
                ...variables.context?.locale ? {
                    locale: variables.context.locale
                } : {},
                ...variables.context?.subproduct ? {
                    subproduct: variables.context.subproduct
                } : {},
                ...variables.context?.product ? {
                    product: variables.context.product
                } : {}
            }
        });
    }, [
        fireAnalyticsEvent,
        variables
    ]);
    const { data: subscriptionData } = (0, $a5l9n.usePlacementGraphQLSubscriptionApi)({
        dataFragments: [
            $6e8f64e36648f43b$var$LIVE_NUDGE_DEMO_MESSAGE_DATA_FRAGMENT,
            $6e8f64e36648f43b$var$LIVE_AND_PERSISTED_TEST_MESSAGE_DATA_FRAGMENT,
            $6e8f64e36648f43b$var$JIRA_BOARD_CATCH_UP_ROVO_NUDGE_DATA_FRAGMENT,
            $6e8f64e36648f43b$var$JIRA_BOARD_BACKLOG_UPDATE_WORK_SUGGESTIONS_DATA_FRAGMENT
        ],
        variables: variables
    });
    const messages = (0, $euxye.useMemo)(()=>(0, $a5l9n.getSubscriptionMessages)(subscriptionData), [
        subscriptionData
    ]);
    // The backend is responsible for ranking/sorting rovo-nudge messages.
    // The placement intentionally renders only the highest-priority message,
    // and the rendered message template owns the full nudge lifecycle via NudgeDefinition.
    // Experimental messages are filtered out if the user is not in the experiment cohort.
    const topMessage = (0, $kHtv0.filterExperimentalMessages)(messages)[0];
    if (!topMessage?.data) return null;
    const { data: data, ...message } = topMessage;
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Messages.render, {
        ...message,
        ...data
    }, message.messageInstanceId);
};
$6e8f64e36648f43b$var$RovoNudgeSubscriptionContent.displayName = "RovoNudgeSubscriptionContent";
const $6e8f64e36648f43b$export$55486c2b6964dcf2 = $6e8f64e36648f43b$export$81df3aa6753d44e2((Messages)=>()=>{
        const activeScopes = (0, $iISCq.usePostOfficeContextScope)({
            scopes: $dSKwo.scopes,
            treatIntersectionAsSame: true
        });
        const activeScopeName = activeScopes.current[0]?.name;
        const { pathname: pathname } = (0, $1mpEL.usePostOfficeSearchParams)();
        const { tenantId: tenantId, orgId: orgId, locale: locale, subproduct: subproduct, isSiteAdmin: isSiteAdmin, productEdition: productEdition, product: product } = (0, $j142y.usePostOfficeContext)();
        const isScopePathnameAligned = (0, $euxye.useMemo)(()=>activeScopeName ? $6e8f64e36648f43b$var$doesScopeMatchPathname(activeScopeName, pathname) : false, [
            activeScopeName,
            pathname
        ]);
        const variables = (0, $euxye.useMemo)(()=>activeScopeName && isScopePathnameAligned ? {
                activeScopes: activeScopeName,
                pathname: pathname,
                context: {
                    tenantId: tenantId,
                    orgId: orgId,
                    locale: locale,
                    subproduct: subproduct,
                    isSiteAdmin: isSiteAdmin,
                    productEdition: productEdition,
                    product: product
                }
            } : null, [
            activeScopeName,
            isScopePathnameAligned,
            pathname,
            tenantId,
            orgId,
            locale,
            subproduct,
            isSiteAdmin,
            productEdition,
            product
        ]);
        if (!variables) return null;
        return /*#__PURE__*/ (0, $e79Pd.jsx)($6e8f64e36648f43b$var$RovoNudgeSubscriptionContent, {
            Messages: Messages,
            variables: variables
        });
    });
const $6e8f64e36648f43b$export$d90b37843c84d1c3 = $6e8f64e36648f43b$export$da912f58cb37a643({
    /**
	 * Override the default placement stages to add a postInit stage that selects
	 * the highest-priority messages for rovo-nudge:
	 * - Max 1 live subscription message (latest by eventTime; subscriptionConfig.deliveryMechanism is live-only or live-and-persisted)
	 * - Max 1 other message (latest by eventTime)
	 * - Live subscription message is prioritized first
	 *
	 * `subscriptionConfig` is copied by stripUnserializablePayload from messageConfig.subscriptionConfig.
	 */ stages: (placementMessageStages)=>{
        const { init: init, postInit: postInit } = (0, $1wUjh.defaultBackendPlacementStages)(placementMessageStages);
        return {
            preInit: $6e8f64e36648f43b$var$activeScopesPreInitStage,
            init: init,
            postInit: async (input)=>{
                const hydratedData = postInit ? await postInit(input) : input.data;
                return {
                    ...hydratedData,
                    messages: (0, $kT2HN.selectRovoNudgeMessages)(hydratedData.messages)
                };
            }
        };
    }
});

});
parcelRegister("iISCq", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeContextScope", () => $a0c7b7fa2a123cd1$export$daf66a67c26dc848);
$parcel$export(module.exports, "createMatchScopes", () => $a0c7b7fa2a123cd1$export$ec890b48cae4cc1c);

var $euxye = parcelRequire("euxye");

var $hRhsb = parcelRequire("hRhsb");

var $l7P7L = parcelRequire("l7P7L");

var $j142y = parcelRequire("j142y");

var $hCvtI = parcelRequire("hCvtI");

var $950Y0 = parcelRequire("950Y0");
const $a0c7b7fa2a123cd1$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $a0c7b7fa2a123cd1$export$daf66a67c26dc848 = (config)=>{
    const currentScopeNames = $a0c7b7fa2a123cd1$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $euxye.useCallback)((input)=>$a0c7b7fa2a123cd1$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentScopeNames
    ]);
    const [state, setState] = (0, $euxye.useState)($a0c7b7fa2a123cd1$var$initialState);
    const route = (0, $hCvtI.usePostOfficeRoute)();
    const context = (0, $j142y.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    const nextScopeNames = $a0c7b7fa2a123cd1$var$scopesNamesAsString(next);
    const updateKey = `${currentScopeNames}-${nextScopeNames}`;
    $a0c7b7fa2a123cd1$var$usePostOfficeScopeSpy(state, config);
    (0, $euxye.useEffect)(()=>{
        if ($a0c7b7fa2a123cd1$export$fcc046cb16c47539({
            next: next,
            state: state,
            treatIntersectionAsSame: config.treatIntersectionAsSame
        })) setState(({ current: current })=>({
                updateKey: (0, $l7P7L.simpleHash)(updateKey),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updateKey
    ]);
    return state;
};
const $a0c7b7fa2a123cd1$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $a0c7b7fa2a123cd1$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $a0c7b7fa2a123cd1$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $a0c7b7fa2a123cd1$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $a0c7b7fa2a123cd1$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname, search: search } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname,
        search: search
    };
};
const $a0c7b7fa2a123cd1$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($hRhsb)))(contextMatch, inputMatch, (contextValue, inputValue)=>$a0c7b7fa2a123cd1$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $a0c7b7fa2a123cd1$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $a0c7b7fa2a123cd1$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $a0c7b7fa2a123cd1$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $a0c7b7fa2a123cd1$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $a0c7b7fa2a123cd1$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($a0c7b7fa2a123cd1$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $a0c7b7fa2a123cd1$export$fcc046cb16c47539 = ({ next: next, state: state, treatIntersectionAsSame: treatIntersectionAsSame })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (treatIntersectionAsSame) {
        if (currentSet.length !== 0 && nextSet.length === 0) return true;
    } else {
        if (currentSet.length !== nextSet.length) return true;
    }
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $a0c7b7fa2a123cd1$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $950Y0.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $euxye.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $a0c7b7fa2a123cd1$var$scopesNamesAsString(state.current)
    ]);
};

});
parcelRegister("hRhsb", function(module, exports) {

var $fwIi1 = parcelRequire("fwIi1");

var $3nCDh = parcelRequire("3nCDh");
/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $d004ecd4990852e7$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $fwIi1(object, source, $3nCDh(source), customizer);
}
module.exports = $d004ecd4990852e7$var$isMatchWith;

});

parcelRegister("l7P7L", function(module, exports) {
$parcel$export(module.exports, "simpleHash", () => $ed388fa2841c8c3b$export$b211ce59c0ea1cfb);
const $ed388fa2841c8c3b$export$b211ce59c0ea1cfb = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("fGrpH", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $e8f1fbe114179a20$export$85183a312807388d);
$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $e8f1fbe114179a20$export$57d19d18d6e255a5);
$parcel$export(module.exports, "useFireEngagementPlatformAnalyticsEvents", () => $e8f1fbe114179a20$export$f14470c9a12428fc);

var $inMxE = parcelRequire("inMxE");

var $euxye = parcelRequire("euxye");
const $e8f1fbe114179a20$export$85183a312807388d = 'postOffice';
const $e8f1fbe114179a20$export$33911828b25deac7 = 'engagementPlatform';
const $e8f1fbe114179a20$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $euxye.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($e8f1fbe114179a20$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $e8f1fbe114179a20$export$f7fadc54a04f9307 = {
    eventType: 'track',
    action: 'exposed',
    actionSubject: 'feature',
    source: 'engagement-platform',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ]
};
const $e8f1fbe114179a20$export$e0b2a6bfc6c6f992 = {
    eventType: 'operational',
    action: 'stopped',
    actionSubject: 'message',
    source: 'epTargeting',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ],
    product: 'engagementPlatform'
};
const $e8f1fbe114179a20$export$f14470c9a12428fc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $euxye.useCallback)((eventPayload, attributes)=>{
        if (eventPayload.messageType === 'inapp') {
            const epMessageId = `engagement.inproduct.${eventPayload.messageId}`;
            createAnalyticsEvent({
                ...$e8f1fbe114179a20$export$f7fadc54a04f9307,
                ...eventPayload,
                actionSubjectId: epMessageId,
                attributes: {
                    ...$e8f1fbe114179a20$export$f7fadc54a04f9307.attributes,
                    ...eventPayload.locale && {
                        locale: eventPayload.locale
                    },
                    ...attributes,
                    flagKey: epMessageId
                }
            }).fire($e8f1fbe114179a20$export$33911828b25deac7);
        } else createAnalyticsEvent({
            ...$e8f1fbe114179a20$export$e0b2a6bfc6c6f992,
            ...eventPayload,
            actionSubjectId: eventPayload.messageId,
            attributes: {
                ...$e8f1fbe114179a20$export$e0b2a6bfc6c6f992.attributes,
                ...eventPayload.locale && {
                    locale: eventPayload.locale
                },
                ...attributes
            }
        }).fire($e8f1fbe114179a20$export$33911828b25deac7);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});

parcelRegister("2vhMr", function(module, exports) {
$parcel$export(module.exports, "createPlacement", () => $1c8a34a53979fff4$export$a2cfeb566a0f6574);
$parcel$export(module.exports, "createPlacementMessageBackend", () => $1c8a34a53979fff4$export$be911676c0a45778);

var $e79Pd = parcelRequire("e79Pd");

var $khHng = parcelRequire("khHng");

var $67djf = parcelRequire("67djf");

var $1DC8Q = parcelRequire("1DC8Q");

var $6JBQt = parcelRequire("6JBQt");

var $2bKWE = parcelRequire("2bKWE");

var $koLgf = parcelRequire("koLgf");

var $GUJN3 = parcelRequire("GUJN3");

var $fvahW = parcelRequire("fvahW");

var $8hQRz = parcelRequire("8hQRz");

var $hSnUm = parcelRequire("hSnUm");

var $1wUjh = parcelRequire("1wUjh");

var $gH56o = parcelRequire("gH56o");

var $4LDqh = parcelRequire("4LDqh");

var $3qNLG = parcelRequire("3qNLG");

var $euxye = parcelRequire("euxye");
const $1c8a34a53979fff4$export$a2cfeb566a0f6574 = (placementConfig)=>{
    return {
        createFrontend: $1c8a34a53979fff4$var$createFrontend(placementConfig),
        createBackend: $1c8a34a53979fff4$var$createBackend(placementConfig)
    };
};
/*-- Frontend --*/ const $1c8a34a53979fff4$var$createFrontend = (placementConfig)=>(placementRenderer)=>({
            createFrontendStage: (stage)=>stage,
            createMessageFrontend: (stage)=>(config)=>[
                        config.messageTemplateId,
                        stage
                    ],
            createPlacementFrontendComponent: (config)=>{
                const messageTemplateRouter = $1c8a34a53979fff4$var$createFrontendPlacementMessageTemplateRouter({
                    ...placementConfig,
                    ...config
                });
                return (0, $koLgf.createPlacementComponentV2)(placementConfig.placementId, placementRenderer(messageTemplateRouter), placementConfig.options);
            }
        });
const $1c8a34a53979fff4$var$createFrontendPlacementMessageRunner = ({ messageTemplates: messageTemplates, isMaybeI18nProviderEnabledCallback: isMaybeI18nProviderEnabledCallback, ...config })=>({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCategory: messageCategory, children: children, ...props })=>{
        const renderableStage = messageTemplates?.[messageTemplateId];
        // Headless messages are handled in-product by the consuming team (e.g. via usePlacementData).
        // They are registered in the backend but have no PlacementFrontend renderer — return null
        // silently without logging a warning.
        const isHeadless = config.headlessMessageTemplateIds?.includes(messageTemplateId);
        // This should never happen — a message cannot be both headless and have a renderer.
        // If it does, log an error but render anyway to avoid silently swallowing the message.
        (0, $euxye.useEffect)(()=>{
            if (isHeadless && renderableStage) // eslint-disable-next-line no-console
            console.error(new (0, $fvahW.PlacementMessageError)({
                ...placementLocation,
                ...config
            }), 'Misconfiguration: message is registered as both headless and has a MessageFrontend renderer. Remove it from headlessMessageTemplateIds or remove the MessageFrontend export.');
            if (!isHeadless && !renderableStage) // eslint-disable-next-line no-console
            console.error(new (0, $fvahW.PlacementMessageError)({
                ...placementLocation,
                ...config
            }), 'Misconfiguration: message is not registered as headless but has no MessageFrontend renderer. Register it as a headless message by reinstalling or add a MessageFrontend export.');
        }, [
            isHeadless,
            renderableStage
        ]);
        const componentPropsStable = (0, $khHng.useStableObject)(props);
        // Client-triggered messages: triggerType is preserved in context by backend hydration
        const triggerType = props?.context?.triggerType;
        const hasTrigger = (0, $2bKWE.isClientTriggeredMessage)(triggerType);
        // Create waitForTrigger hook for triggered messages
        // Note: messageSuccessComponent is undefined here since isUFOEnabled={false}
        const { waitForTrigger: waitForTrigger } = (0, $3qNLG.useWaitForTrigger)({
            hasTrigger: hasTrigger,
            messageSuccessComponent: undefined,
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
        const placementLocation = {
            messageTemplateId: messageTemplateId,
            messageInstanceId: messageInstanceId,
            placementLevel: 'Message',
            stageName: config?.stageName,
            placementId: config.placementId
        };
        if (!renderableStage) return null;
        try {
            renderableStage.validate({
                messageTemplateId: messageTemplateId,
                children: children,
                ...props
            }); // Will throw error if type validation fails
            const { Component: Component } = renderableStage;
            return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $1DC8Q.MessageRendererProvider), {
                ...componentPropsStable,
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCategory: messageCategory,
                isUFOEnabled: false,
                componentProps: componentPropsStable,
                waitForTrigger: waitForTrigger,
                isMaybeI18nProviderEnabledCallback: isMaybeI18nProviderEnabledCallback,
                placementId: config.placementId,
                children: [
                    !waitForTrigger && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6JBQt.MessageViewed), {}),
                    /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                        ...props,
                        waitForTrigger: waitForTrigger,
                        children: children
                    })
                ]
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error((0, $fvahW.createPlacementMessageError)(error));
            return null;
        }
    };
const $1c8a34a53979fff4$var$createFrontendPlacementMessageTemplateRouter = (config)=>{
    const messageTemplateLookup = $1c8a34a53979fff4$export$9681465a68237b0(config);
    return Object.entries(messageTemplateLookup).reduce((base, [stageName, messageTemplates])=>({
            ...base,
            [stageName]: $1c8a34a53979fff4$var$createFrontendPlacementMessageRunner({
                messageTemplates: messageTemplates,
                stageName: stageName,
                placementId: config.placementId,
                isMaybeI18nProviderEnabledCallback: config.isMaybeI18nProviderEnabledCallback,
                headlessMessageTemplateIds: config.headlessMessageTemplateIds
            })
        }), {});
};
const $1c8a34a53979fff4$export$be911676c0a45778 = (stages)=>(messageBackendConfig)=>{
        const stagesWithDefaults = $1c8a34a53979fff4$var$applyDefaultMessageBackendStages(stages);
        return [
            messageBackendConfig.messageTemplateId,
            stagesWithDefaults
        ];
    };
const $1c8a34a53979fff4$var$createBackend = (placementConfig)=>(placementBackendParams)=>({
            createBackendStage: (stage)=>stage,
            createMessageBackend: (stages)=>$1c8a34a53979fff4$export$be911676c0a45778(stages),
            createPlacementBackend: (placementBackendConfig)=>(runtime)=>{
                    const placementId = placementConfig.placementId;
                    if (!placementId) throw new (0, $fvahW.MissingPlacementIdError)();
                    const placementBackendStages = placementBackendParams?.stages ?? (0, $1wUjh.defaultBackendPlacementStages);
                    const placementStages = $1c8a34a53979fff4$export$ad7e52259531e489(placementBackendStages);
                    const messagesStages = $1c8a34a53979fff4$export$45fdb660a0e079d7({
                        ...placementConfig,
                        ...placementBackendConfig
                    });
                    const middleware = placementBackendParams?.customMiddleware ?? (0, $GUJN3.defaultPlacementMiddleware);
                    const statelessMiddleware = middleware({
                        ...placementConfig,
                        ...placementBackendParams?.params
                    });
                    const statelessMessagesRuntime = runtime({
                        messagesStages: messagesStages,
                        placementStages: placementStages,
                        placementId: placementId
                    });
                    const withRequestMetadata = (ctx)=>{
                        const includePlacementMetadata = ctx.header?.['x-include-request-metadata'] === 'true';
                        if (includePlacementMetadata) {
                            // Cast is safe: addRequestContext and addLocation middleware run before this code.
                            const state = ctx.state;
                            ctx.body.requestMetadata = {
                                ...describe(),
                                graph: (0, $4LDqh.default).checkGate('post_office_enable-visualization') ? state.requestContext.location.getGraph() : undefined
                            };
                        }
                    };
                    const buildPlacementContext = (ctx, next)=>{
                        const koa = {
                            ctx: ctx,
                            next: next
                        };
                        // Cast is safe: addRequestContext and addLocation middleware run before this code.
                        const state = ctx.state;
                        const request = state.requestContext.location.tag({
                            placementId: placementConfig.placementId
                        });
                        const messagesRuntime = async (config)=>{
                            // config?.request is already typed with location; request is from buildPlacementContext which has it.
                            const configuredRequest = (config?.request ?? request).location.tag({
                                placementLevel: 'Runtime'
                            });
                            if (!configuredRequest) throw new (0, $fvahW.PlacementSystemError)({
                                message: 'request context not available at runtime call'
                            });
                            const contexts = {
                                koa: koa,
                                request: configuredRequest
                            };
                            const combinedParams = {
                                ...placementBackendParams?.params,
                                ...config?.params
                            };
                            try {
                                const runtimeStartTime = performance.now();
                                const result = await (0, $hSnUm.placementRuntimeTimedStage)(statelessMessagesRuntime)(contexts)(combinedParams);
                                // Note: runtimeLatencyInMs includes placementRuntimeTimedStage's own finally-block
                                // overhead (histogram stop, gate check, "Finished stage" log), so it will be
                                // marginally higher than the latencyInMs emitted inside that stage for the same request.
                                const runtimeLatencyInMs = performance.now() - runtimeStartTime;
                                (0, $hSnUm.logRuntimeResult)(contexts)({
                                    result: result,
                                    latencyInMs: runtimeLatencyInMs
                                });
                                return result;
                            } catch (error) {
                                // contexts.request is guaranteed to have location from buildPlacementContext.
                                throw (0, $fvahW.handlePlacementRuntimeError)(contexts.request)(error);
                            }
                        };
                        const postOffice = {
                            messagesRuntime: messagesRuntime
                        };
                        return {
                            koa: koa,
                            request: request,
                            postOffice: postOffice,
                            messagesRuntime: messagesRuntime
                        };
                    };
                    const koaMiddleware = async (ctx, next)=>{
                        const { koa: koa, request: request, postOffice: postOffice } = buildPlacementContext(ctx, next);
                        // Hoist middlewareRequest before try so it is accessible in finally.
                        const middlewareRequest = request.location.tag({
                            placementLevel: 'Middleware'
                        });
                        try {
                            await statelessMiddleware({
                                koa: koa,
                                postOffice: postOffice,
                                request: middlewareRequest,
                                placement: placementConfig
                            });
                        } catch (error) {
                            // request is guaranteed to have location from buildPlacementContext.
                            throw (0, $fvahW.handlePlacementMiddlewareError)(request)(error);
                        } finally{
                            // Stop the timer in finally so durationMs is recorded whether the
                            // middleware succeeded or threw — making failed stages distinguishable
                            // from untimed stages in the execution graph.
                            if ((0, $4LDqh.default).checkGate('post_office_enable-visualization')) middlewareRequest.location.stopTimer();
                            withRequestMetadata(ctx);
                        }
                    };
                    const dataMiddleware = async (ctx, next)=>{
                        const { request: request, messagesRuntime: messagesRuntime } = buildPlacementContext(ctx, next);
                        // Hoist middlewareRequest before try so it is accessible in finally.
                        const middlewareRequest = request.location.tag({
                            placementLevel: 'Middleware'
                        });
                        try {
                            const result = await messagesRuntime({
                                request: middlewareRequest
                            });
                            ctx.body = result;
                            ctx.status = 200;
                        } catch (error) {
                            throw (0, $fvahW.handlePlacementMiddlewareError)(request)(error);
                        } finally{
                            // Stop the timer in finally so durationMs is recorded whether the
                            // middleware succeeded or threw — making failed stages distinguishable
                            // from untimed stages in the execution graph.
                            if ((0, $4LDqh.default).checkGate('post_office_enable-visualization')) middlewareRequest.location.stopTimer();
                            withRequestMetadata(ctx);
                        }
                    };
                    const describe = ()=>{
                        const messageTemplates = placementBackendConfig.messageTemplates.map(([id, stages])=>{
                            return {
                                id: id,
                                stages: Object.keys(stages)
                            };
                        });
                        const placementId = placementConfig.placementId;
                        return {
                            placementId: placementId,
                            messageTemplates: messageTemplates
                        };
                    };
                    const standaloneRuntime = async (config)=>{
                        if (!config?.request) throw new (0, $fvahW.PlacementSystemError)({
                            message: 'request is required when calling runtime directly'
                        });
                        const request = config.request.location.tag({
                            placementId: placementConfig.placementId,
                            placementLevel: 'Runtime'
                        });
                        const combinedParams = {
                            ...placementBackendParams?.params,
                            ...config?.params
                        };
                        try {
                            const runtimeStartTime = performance.now();
                            const result = await (0, $hSnUm.placementRuntimeTimedStage)(statelessMessagesRuntime)({
                                request: request
                            })(combinedParams);
                            const runtimeLatencyInMs = performance.now() - runtimeStartTime;
                            (0, $hSnUm.logRuntimeResult)({
                                request: request
                            })({
                                result: result,
                                latencyInMs: runtimeLatencyInMs
                            });
                            return result;
                        } catch (error) {
                            throw (0, $fvahW.handlePlacementRuntimeError)(request)(error);
                        }
                    };
                    return {
                        middleware: koaMiddleware,
                        endpoints: {
                            renderer: koaMiddleware,
                            data: dataMiddleware
                        },
                        config: {
                            ...placementBackendConfig,
                            ...placementBackendParams,
                            ...placementConfig
                        },
                        describe: describe,
                        runtime: standaloneRuntime
                    };
                }
        });
const $1c8a34a53979fff4$var$applyDefaultMessageBackendStages = (stages)=>{
    const validatedDefaultStages = {};
    Object.entries((0, $gH56o.defaultBackendPlacementMessageStages)).forEach(([stageName, stage])=>{
        validatedDefaultStages[stageName] = {
            validate: (0, $8hQRz.noValidation)(),
            stage: stage
        };
    });
    return {
        ...validatedDefaultStages,
        ...stages()
    };
};
const $1c8a34a53979fff4$export$ad7e52259531e489 = (config)=>{
    return (placementMessageStages)=>{
        const placementStages = config(placementMessageStages);
        const wrappedPlacementStages = {};
        Object.entries(placementStages).forEach(([stageName, stage])=>{
            if (!stage) wrappedPlacementStages[stageName] = undefined;
            wrappedPlacementStages[stageName] = $1c8a34a53979fff4$var$createBackendPlacementRunner({
                stageName: stageName,
                stage: stage
            });
        });
        return wrappedPlacementStages;
    };
};
const $1c8a34a53979fff4$var$createBackendPlacementRunner = ({ stageName: stageName, stage: stage })=>async (params)=>{
        const request = params.request.location.tag({
            placementLevel: 'Placement',
            stageName: stageName
        });
        if (!stage) return params.data;
        try {
            const result = await (0, $hSnUm.placementTimedStage)(stage)({
                request: request,
                data: params.data
            });
            return result;
        } catch (error) {
            throw (0, $fvahW.handlePlacementError)(request)(error);
        }
    };
const $1c8a34a53979fff4$export$45fdb660a0e079d7 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stages])=>Object.entries(stages).forEach(([stageName, stage])=>{
            if (!result[messageTemplateId]) result[messageTemplateId] = {};
            // We can safely use a non-null assertion here as we validate the existance of
            // result[messageTemplateId] above
            result[messageTemplateId][stageName] = $1c8a34a53979fff4$var$createBackendPlacementMessageRunner({
                stage: stage,
                stageName: stageName,
                placementId: config.placementId
            });
        }));
    return result;
};
const $1c8a34a53979fff4$var$createBackendPlacementMessageRunner = (config)=>{
    return async (input)=>{
        const { message: message } = input;
        const request = input.request.location.tag({
            placementLevel: 'Message',
            messageTemplateId: message?.messageTemplateId,
            messageInstanceId: message?.messageInstanceId,
            triggerId: message?.triggerId,
            stageName: config?.stageName
        });
        try {
            const { validate: validate, stage: stage } = config.stage;
            validate(input.message.context); // Throws if fails validation
            const messagePerformance = request.messagePerformance ?? new (0, $67djf.MessagePerformance)(request, {
                trackEndToEnd: false,
                metricNameSegments: {
                    flow: 'pull',
                    placementId: config.placementId
                }
            });
            const hydratedContext = await messagePerformance.measureOperation(async ()=>await (0, $hSnUm.messageTimedStage)(stage)({
                    request: request,
                    message: message
                }), {
                messageTemplateId: message.messageTemplateId,
                operation: config.stageName,
                stage: 'hydration'
            }, {
                // This stage executes message-template hydration code owned by message makers.
                layer: 'message'
            });
            // V2 render functions receive a context prop
            return {
                ...message,
                context: {
                    ...hydratedContext,
                    ...message.context.triggerType !== undefined ? {
                        triggerType: message.context.triggerType
                    } : {}
                }
            };
        } catch (error) {
            throw (0, $fvahW.handlePlacementMessageError)(request)(error);
        }
    };
};
const $1c8a34a53979fff4$export$9681465a68237b0 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stage])=>{
        Object.entries(stage).forEach(([stageName, stageExecutable])=>{
            if (!result[stageName]) result[stageName] = {};
            // We can safely use a non-null assertion here as we validate the existance of
            // result[stageName] above
            result[stageName][messageTemplateId] = stageExecutable;
        });
    });
    return result;
};

});
parcelRegister("67djf", function(module, exports) {
$parcel$export(module.exports, "MessagePerformance", () => $d6fc7962ecb14840$export$f5bd5a7a850da66e);

var $ifYoj = parcelRequire("ifYoj");
const $d6fc7962ecb14840$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT = 'message-performance.pull.per-placement';
const $d6fc7962ecb14840$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE = 'message-performance.push.per-recipient-type';
const $d6fc7962ecb14840$var$HISTOGRAM_BUCKETS = {
    pull: {
        perStage: [
            10,
            25,
            50,
            100,
            150,
            200,
            250,
            300,
            400,
            500
        ],
        endToEnd: [
            25,
            100,
            200,
            300,
            400,
            500
        ]
    },
    push: {
        perStage: [
            100,
            500,
            1000
        ],
        endToEnd: [
            100,
            500,
            1000,
            5000
        ]
    }
};
const $d6fc7962ecb14840$var$defaultOptions = {
    logThreshold: 500,
    trackEndToEnd: false
};
class $d6fc7962ecb14840$export$f5bd5a7a850da66e {
    constructor(observability, options){
        this.observability = observability;
        this.options = options;
        this.startTime = performance.now();
        // Keeps only the longest duration per stage+template combination for threshold logs.
        this.slowestOperationPerStagePerMessage = new Map();
        // Tracks operation intervals per execution layer and message template id.
        this.operationIntervalsPerLayerPerMessage = new Map();
    }
    /**
	 * Wraps one async operation with timing instrumentation.
	 *
	 * Flow:
	 * 1) Start stage metrics (timer + histogram).
	 * 2) Execute callback.
	 * 3) Record layer + longest-stage bookkeeping.
	 * 4) Stop stage metrics with success/failure status.
	 */ async measureOperation(callback, tags, context) {
        const operationStart = performance.now();
        const stageMetricName = this.getMetricName(tags.stage);
        const histogramBuckets = $d6fc7962ecb14840$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].perStage;
        const histogram = this.observability.metrics.histogram(stageMetricName, histogramBuckets).measure();
        const timer = this.observability.metrics.timing(stageMetricName).measure();
        let status = 'success';
        try {
            return await callback();
        } catch (error) {
            status = 'failure';
            throw error;
        } finally{
            const operationEndTime = performance.now();
            const operationLatency = operationEndTime - operationStart;
            this.recordOperationIntervalPerLayerPerMessage(tags.messageTemplateId, context.layer, operationStart, operationEndTime);
            this.updateSlowestOperationPerStagePerMessage(tags, context.layer, operationLatency);
            const operationMetricTags = this.applyTagOverrides({
                ...tags,
                status: status
            });
            histogram.stop(operationMetricTags);
            timer.stop(operationMetricTags);
        }
    }
    /**
	 * Finalizes recording for this instance.
	 *
	 * Always publishes per-layer cumulative timings.
	 * If end-to-end is enabled, also stops e2e metrics and logs slow executions.
	 */ stop() {
        this.publishTotalLayerLatencyPerMessage();
        if (!this.options.trackEndToEnd) return;
        const totalTime = performance.now() - this.startTime;
        this.publishEndToEndFlowLatency(totalTime);
        this.logThresholdExceeded(totalTime);
    }
    logThresholdExceeded(totalTime) {
        const logThreshold = this.options.logThreshold ?? $d6fc7962ecb14840$var$defaultOptions.logThreshold;
        const shouldLogThresholdExceeded = totalTime > logThreshold && this.slowestOperationPerStagePerMessage.size > 0;
        if (shouldLogThresholdExceeded) {
            const operationSequence = Array.from(this.slowestOperationPerStagePerMessage.values());
            this.observability.logger.info({
                totalTime: totalTime,
                logThreshold: logThreshold,
                operationSequence: operationSequence
            }, 'Message performance threshold exceeded');
        }
    }
    getMetricName(suffix) {
        return this.options.metricNameSegments.flow === 'pull' ? `${$d6fc7962ecb14840$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT}.${this.options.metricNameSegments.placementId}.${suffix}` : `${$d6fc7962ecb14840$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE}.${this.options.metricNameSegments.recipientType}.${suffix}`;
    }
    applyTagOverrides(tags) {
        return {
            ...tags,
            ...(0, $ifYoj.HIGH_CARDINALITY_METRIC_TAG_OVERRIDES)
        };
    }
    recordOperationIntervalPerLayerPerMessage(messageTemplateId, layer, operationStartTimeMs, operationEndTimeMs) {
        const key = `${layer}:${messageTemplateId}`;
        const existingIntervals = this.operationIntervalsPerLayerPerMessage.get(key) ?? [];
        existingIntervals.push({
            startTimeMs: operationStartTimeMs,
            endTimeMs: operationEndTimeMs
        });
        this.operationIntervalsPerLayerPerMessage.set(key, existingIntervals);
    }
    calculateTotalDurationForLayers(intervals) {
        if (intervals.length === 0) return 0;
        const sortedIntervals = intervals.toSorted((firstInterval, secondInterval)=>{
            return firstInterval.startTimeMs - secondInterval.startTimeMs;
        });
        const mergedIntervals = [];
        for (const currentInterval of sortedIntervals){
            const lastMergedInterval = mergedIntervals[mergedIntervals.length - 1];
            // Start a new merged interval when there is no previous interval,
            // or when the current interval starts after the previous one ends.
            if (!lastMergedInterval || currentInterval.startTimeMs > lastMergedInterval.endTimeMs) {
                mergedIntervals.push({
                    ...currentInterval
                });
                continue;
            }
            lastMergedInterval.endTimeMs = Math.max(lastMergedInterval.endTimeMs, currentInterval.endTimeMs);
        }
        return mergedIntervals.reduce((totalDuration, interval)=>totalDuration + (interval.endTimeMs - interval.startTimeMs), 0);
    }
    updateSlowestOperationPerStagePerMessage(tags, layer, durationMs) {
        const key = `${tags.stage}:${tags.messageTemplateId}`;
        const existing = this.slowestOperationPerStagePerMessage.get(key);
        if (!existing || durationMs > existing.timeMs) this.slowestOperationPerStagePerMessage.set(key, {
            messageTemplateId: tags.messageTemplateId,
            stage: tags.stage,
            timeMs: durationMs,
            layer: layer
        });
    }
    publishTotalLayerLatencyPerMessage() {
        for (const [layer, operationIntervals] of this.operationIntervalsPerLayerPerMessage){
            const [layerName, messageTemplateId] = layer.split(':');
            const metricName = this.getMetricName(layerName);
            const totalLayerDuration = this.calculateTotalDurationForLayers(operationIntervals);
            const buckets = $d6fc7962ecb14840$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].endToEnd;
            const tags = this.applyTagOverrides({
                messageTemplateId: messageTemplateId
            });
            this.observability.metrics.timing(metricName, tags).set(totalLayerDuration);
            this.observability.metrics.histogram(metricName, buckets, tags).set(totalLayerDuration);
        }
    }
    publishEndToEndFlowLatency(totalTime) {
        const metricName = this.getMetricName('e2e');
        const buckets = $d6fc7962ecb14840$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].endToEnd;
        const tags = this.applyTagOverrides({});
        this.observability.metrics.timing(metricName, tags).set(totalTime);
        this.observability.metrics.histogram(metricName, buckets, tags).set(totalTime);
    }
}

});
parcelRegister("ifYoj", function(module, exports) {
$parcel$export(module.exports, "HIGH_CARDINALITY_METRIC_TAG_OVERRIDES", () => $ddb712cb65ba665a$export$e924d1234600a844);
/* eslint-disable camelcase -- Metric tag names are external SignalFx dimensions. */ const $ddb712cb65ba665a$var$DISABLED_METRIC_TAG_VALUE = 'disabled';
// Only include tags that collapse cleanly after Micros/SFX enrichment.
const $ddb712cb65ba665a$var$HIGH_CARDINALITY_METRIC_TAG_OVERRIDE_NAME_LIST = [
    // Use `environment` for rollout scope; deployment IDs churn on every deploy.
    'deployment_id',
    // Use commit/deployment tracker data when version-level diagnosis is needed.
    'micros_service_version',
    // Use `environment`, which already carries the regional production/staging split.
    'region',
    // Use `environment` for regional placement instead of zone-level fan-out.
    'micros_zone',
    // Use telemetry configuration outside the metric series.
    'obs_sfx_enable',
    // Use `micros_group` when container-level grouping is needed.
    'container_name'
];
const $ddb712cb65ba665a$export$e924d1234600a844 = Object.freeze(Object.fromEntries($ddb712cb65ba665a$var$HIGH_CARDINALITY_METRIC_TAG_OVERRIDE_NAME_LIST.map((tagName)=>[
        tagName,
        $ddb712cb65ba665a$var$DISABLED_METRIC_TAG_VALUE
    ])));

});


parcelRegister("1DC8Q", function(module, exports) {
$parcel$export(module.exports, "MessageRendererProvider", () => $95701fffd28227d0$export$5fe06fe68913d493);

var $e79Pd = parcelRequire("e79Pd");

var $bDiVY = parcelRequire("bDiVY");

var $lK7pY = parcelRequire("lK7pY");

var $8KzDp = parcelRequire("8KzDp");

var $euxye = parcelRequire("euxye");

var $1wNxv = parcelRequire("1wNxv");

var $cxMk3 = parcelRequire("cxMk3");

var $140JV = parcelRequire("140JV");

var $8opyJ = parcelRequire("8opyJ");

var $4uj2Z = parcelRequire("4uj2Z");

var $b18n5 = parcelRequire("b18n5");

var $gwHtt = parcelRequire("gwHtt");

var $7BZpb = parcelRequire("7BZpb");
const $95701fffd28227d0$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $95701fffd28227d0$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $euxye.Suspense), waitForTrigger: waitForTrigger, configSetId: configSetId, journeyId: journeyId, journeyTriggerId: journeyTriggerId, placementId: placementId, isMaybeI18nProviderEnabledCallback: isMaybeI18nProviderEnabledCallback })=>{
    const subscriptionConfig = (0, $7BZpb.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    /**
	 * Type guard: messageContextMemo must match MessageContextData exactly.
	 * If a field is missing or wrong type, the type annotation will catch it.
	 */ const loadingComponent = (0, $euxye.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bDiVY.UFOv2).UFOLoadHold, {
            name: (0, $bDiVY.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $euxye.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            transactionAccountId: componentProps.transactionAccountId,
            analyticsDetails: {
                ...postOffice?.analyticsDetails,
                subscriptionEnabled: subscriptionEnabled
            },
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps.transactionAccountId,
        postOffice?.analyticsDetails,
        subscriptionEnabled,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const isMaybeI18nEnabled = isMaybeI18nProviderEnabledCallback?.() ?? false;
    // MaybeChoreographerWrapper sits at the top so it can claim its slot while the
    // lazy template is loading; it no-ops for client-triggered messages, which handle
    // their own choreography via MaybeTriggeredMessageValidator below.
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $140JV.MaybeChoreographerWrapper), {
        ChoreographerWrapper: (0, $cxMk3.ChoreographerWrapper),
        enabled: !waitForTrigger,
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8opyJ.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lK7pY.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8KzDp.RecommendationProvider), {
                    value: recommendationSession ?? $95701fffd28227d0$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4uj2Z.MaybeTriggeredMessageValidator), {
                            waitForTrigger: waitForTrigger,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $b18n5.MessageAnalyticsContextProvider), {
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gwHtt.MaybeManualMessageViewedEvent), {
                                    isManual: !!waitForTrigger,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $1wNxv.MaybeI18nProvider), {
                                        messageTemplateId: messageTemplateId,
                                        placementId: placementId,
                                        isI18nMigrationInAppEnabled: isMaybeI18nEnabled,
                                        children: [
                                            !waitForTrigger && messageSuccessComponent,
                                            children
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
$95701fffd28227d0$export$5fe06fe68913d493.displayName = "MessageRendererProvider";

});
parcelRegister("bDiVY", function(module, exports) {
$parcel$export(module.exports, "UFOv2", () => $f56791b52ca6e675$export$c91b09caa8ecbab1);

var $2D2gW = parcelRequire("2D2gW");

var $3BBB7 = parcelRequire("3BBB7");
const $f56791b52ca6e675$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: (0, $2D2gW.default),
    UFOSegment: (0, $3BBB7.default)
};

});

parcelRegister("lK7pY", function(module, exports) {
$parcel$export(module.exports, "MessageContextProvider", () => $7a1a7e55772ddb0e$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $7a1a7e55772ddb0e$export$a5b6d14a2e25725a);
/**
 * Canonical message context implementation.
 *
 * This is the source of truth. `@post-office/message-context` re-exports from here.
 * Consumers should import via:
 *   import { useMessageContext, MessageContextProvider } from '@atlassian/post-office-context/message-context';
 */ 
var $euxye = parcelRequire("euxye");
const $7a1a7e55772ddb0e$var$initialValue = {};
const $7a1a7e55772ddb0e$export$b060d577040138d8 = (0, $euxye.createContext)($7a1a7e55772ddb0e$var$initialValue);
const $7a1a7e55772ddb0e$export$42de33f7652dc3de = $7a1a7e55772ddb0e$export$b060d577040138d8.Provider;
const $7a1a7e55772ddb0e$export$a5b6d14a2e25725a = ()=>(0, $euxye.useContext)($7a1a7e55772ddb0e$export$b060d577040138d8);

});

parcelRegister("8KzDp", function(module, exports) {
$parcel$export(module.exports, "RecommendationProvider", () => $78d4274eb6e62af1$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $78d4274eb6e62af1$export$3321c0b02f750bcc);
/**
 * Canonical recommendation context implementation.
 *
 * This is the source of truth. `@post-office/recommendation-context` re-exports from here.
 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");
const $78d4274eb6e62af1$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $euxye.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $78d4274eb6e62af1$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($78d4274eb6e62af1$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
            data: value,
            children: children
        })
    });
};
$78d4274eb6e62af1$export$f60e87d7b5f59562.displayName = "RecommendationProvider";
const $78d4274eb6e62af1$export$3321c0b02f750bcc = ()=>(0, $euxye.useContext)($78d4274eb6e62af1$export$ba2f44035effd9c1);

});

parcelRegister("1wNxv", function(module, exports) {
$parcel$export(module.exports, "MaybeI18nProvider", () => $5b845fd55cca8681$export$d55fcc9e7bd9ff3e);

var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $fGrpH = parcelRequire("fGrpH");

var $euxye = parcelRequire("euxye");

var $5KKyn = parcelRequire("5KKyn");
var $1YIbA = parcelRequire("1YIbA");

var $VtsYQ = parcelRequire("VtsYQ");
const $5b845fd55cca8681$export$d5a462ce7bd04520 = async (messageTemplateId, placementId, _locale)=>{
    const candidate = `@post-office/i18n-translation/${messageTemplateId}-in-app/${placementId}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return await import(/* webpackIgnore: true */ candidate);
};
function $5b845fd55cca8681$export$c003690f5ce066ed(messageTemplateId, placementId, messageLoader = $5b845fd55cca8681$export$d5a462ce7bd04520) {
    const [messages, setMessages] = (0, $euxye.useState)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    let locale = 'en';
    try {
        locale = (0, $1YIbA.default)().locale;
    } catch  {
    // fallback to en
    }
    (0, $euxye.useEffect)(()=>{
        messageLoader(messageTemplateId, placementId, locale).then((loadedMessages)=>{
            setMessages(loadedMessages.default);
        }).catch(()=>{
            setMessages({});
            fireAnalyticsEvent({
                action: 'error',
                actionSubject: 'i18nMessageLoader',
                eventType: 'operational'
            });
        });
    }, [
        fireAnalyticsEvent,
        locale,
        messageLoader,
        messageTemplateId,
        placementId
    ]);
    return {
        locale: locale,
        messages: messages
    };
}
const $5b845fd55cca8681$var$I18nProvider = ({ children: children, messageTemplateId: messageTemplateId, placementId: placementId, messageLoader: messageLoader })=>{
    const { locale: locale, messages: messages } = $5b845fd55cca8681$export$c003690f5ce066ed(messageTemplateId, placementId, messageLoader);
    if (!messages || Object.keys(messages).length === 0) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    const shouldSuppressMissingTranslationErrors = (0, $4LDqh.default).checkGate((0, $VtsYQ.SUPPRESS_MISSING_TRANSLATION_ERRORS_GATE));
    const suppressMissingTranslationErrorsProps = shouldSuppressMissingTranslationErrors ? {
        onError: (0, $VtsYQ.handleError)
    } : {};
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        locale: locale,
        messages: messages,
        ...suppressMissingTranslationErrorsProps,
        children: children
    });
};
$5b845fd55cca8681$var$I18nProvider.displayName = "I18nProvider";
const $5b845fd55cca8681$export$d55fcc9e7bd9ff3e = ({ isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled, messageTemplateId: messageTemplateId, placementId: placementId, children: children, messageLoader: messageLoader = $5b845fd55cca8681$export$d5a462ce7bd04520 })=>{
    if (!isI18nMigrationInAppEnabled || !placementId) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($5b845fd55cca8681$var$I18nProvider, {
        messageTemplateId: messageTemplateId,
        placementId: placementId,
        messageLoader: messageLoader,
        children: children
    });
};
$5b845fd55cca8681$export$d55fcc9e7bd9ff3e.displayName = "MaybeI18nProvider";

});
parcelRegister("VtsYQ", function(module, exports) {
$parcel$export(module.exports, "SUPPRESS_MISSING_TRANSLATION_ERRORS_GATE", () => $a78275dc9216cea8$export$96a2a9656bab1d3d);
$parcel$export(module.exports, "handleError", () => $a78275dc9216cea8$export$d3da1ecaf1206c58);

var $hDX1b = parcelRequire("hDX1b");
var $ceutJ = parcelRequire("ceutJ");
const $a78275dc9216cea8$export$96a2a9656bab1d3d = 'post_office_suppress_missing_translation_errors';
const $a78275dc9216cea8$export$d3da1ecaf1206c58 = (err)=>{
    if (err?.code === (0, $ceutJ.IntlErrorCode).MISSING_TRANSLATION) return;
    return (0, $hDX1b.DEFAULT_INTL_CONFIG).onError(err);
};

});
parcelRegister("hDX1b", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $cd83dbf826e8e863$export$b52f8d6fc0d47415);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("jGeM1");
var $cM6Na = parcelRequire("cM6Na");

var $jr7MJ = parcelRequire("jr7MJ");

var $ceutJ = parcelRequire("ceutJ");
function $cd83dbf826e8e863$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $cd83dbf826e8e863$var$defaultErrorHandler = function(error) {};
var $cd83dbf826e8e863$var$defaultWarnHandler = function(warning) {};
var $cd83dbf826e8e863$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $cd83dbf826e8e863$var$defaultErrorHandler,
    onWarn: $cd83dbf826e8e863$var$defaultWarnHandler
};
function $cd83dbf826e8e863$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $cd83dbf826e8e863$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $cd83dbf826e8e863$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $cd83dbf826e8e863$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $jr7MJ.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $j9yrT.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $cd83dbf826e8e863$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $jr7MJ.strategies).variadic
    });
    var getNumberFormat = (0, $jr7MJ.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $j9yrT.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $cd83dbf826e8e863$var$createFastMemoizeCache(cache.number),
        strategy: (0, $jr7MJ.strategies).variadic
    });
    var getPluralRules = (0, $jr7MJ.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $j9yrT.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $cd83dbf826e8e863$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $jr7MJ.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $jr7MJ.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $cM6Na.IntlMessageFormat)(message, locales, overrideFormats, (0, $j9yrT.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $cd83dbf826e8e863$var$createFastMemoizeCache(cache.message),
            strategy: (0, $jr7MJ.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $jr7MJ.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $cd83dbf826e8e863$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $jr7MJ.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $jr7MJ.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $cd83dbf826e8e863$var$createFastMemoizeCache(cache.list),
            strategy: (0, $jr7MJ.strategies).variadic
        }),
        getDisplayNames: (0, $jr7MJ.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $cd83dbf826e8e863$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $jr7MJ.strategies).variadic
        })
    };
}
function $cd83dbf826e8e863$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $ceutJ.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("jGeM1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("cM6Na")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $cM6Na = parcelRequire("cM6Na");


var $e53d6648760d3d69$export$2e2bcd8739ae039 = (0, $cM6Na.IntlMessageFormat);

});
parcelRegister("cM6Na", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $94cf3c8289ae55e9$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $j9yrT = parcelRequire("j9yrT");

var $jr7MJ = parcelRequire("jr7MJ");

var $ixPDv = parcelRequire("ixPDv");

var $d1eO2 = parcelRequire("d1eO2");
// -- MessageFormat --------------------------------------------------------
function $94cf3c8289ae55e9$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $94cf3c8289ae55e9$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $94cf3c8289ae55e9$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $j9yrT.__assign)({}, defaultConfig));
}
function $94cf3c8289ae55e9$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $94cf3c8289ae55e9$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $jr7MJ.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $94cf3c8289ae55e9$var$createFastMemoizeCache(cache.number),
            strategy: (0, $jr7MJ.strategies).variadic
        }),
        getDateTimeFormat: (0, $jr7MJ.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $94cf3c8289ae55e9$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $jr7MJ.strategies).variadic
        }),
        getPluralRules: (0, $jr7MJ.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $94cf3c8289ae55e9$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $jr7MJ.strategies).variadic
        })
    };
}
var $94cf3c8289ae55e9$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $d1eO2.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $d1eO2.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $j9yrT.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $94cf3c8289ae55e9$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $94cf3c8289ae55e9$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $ixPDv.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("jr7MJ", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $e26693e3445f17ea$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $e26693e3445f17ea$export$c5491a8691a23b9e);
//
// Main
//
function $e26693e3445f17ea$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $e26693e3445f17ea$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $e26693e3445f17ea$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $e26693e3445f17ea$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $e26693e3445f17ea$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $e26693e3445f17ea$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $e26693e3445f17ea$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $e26693e3445f17ea$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $e26693e3445f17ea$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $e26693e3445f17ea$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $e26693e3445f17ea$var$monadic : $e26693e3445f17ea$var$variadic;
    return $e26693e3445f17ea$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $e26693e3445f17ea$var$strategyVariadic(fn, options) {
    return $e26693e3445f17ea$var$assemble(fn, this, $e26693e3445f17ea$var$variadic, options.cache.create(), options.serializer);
}
function $e26693e3445f17ea$var$strategyMonadic(fn, options) {
    return $e26693e3445f17ea$var$assemble(fn, this, $e26693e3445f17ea$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $e26693e3445f17ea$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $e26693e3445f17ea$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$e26693e3445f17ea$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$e26693e3445f17ea$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $e26693e3445f17ea$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $e26693e3445f17ea$var$ObjectWithoutPrototypeCache();
    }
};
var $e26693e3445f17ea$export$c5491a8691a23b9e = {
    variadic: $e26693e3445f17ea$var$strategyVariadic,
    monadic: $e26693e3445f17ea$var$strategyMonadic
};

});

parcelRegister("ixPDv", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("dEY0Q")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("dEY0Q")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("dEY0Q")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("dEY0Q")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("dEY0Q")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("dEY0Q")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("dEY0Q")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("dEY0Q")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("dEY0Q")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("dEY0Q")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("dEY0Q")).isTimeElement);
$parcel$export(module.exports, "parse", () => $d8035ce9140f9b66$export$98e6a39c04603d36);

var $j9yrT = parcelRequire("j9yrT");

var $eBFRL = parcelRequire("eBFRL");

var $19Gjn = parcelRequire("19Gjn");

var $dEY0Q = parcelRequire("dEY0Q");
function $d8035ce9140f9b66$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $dEY0Q.isSelectElement)(el) || (0, $dEY0Q.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $d8035ce9140f9b66$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $dEY0Q.isNumberElement)(el) && (0, $dEY0Q.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $dEY0Q.isDateElement)(el) || (0, $dEY0Q.isTimeElement)(el)) && (0, $dEY0Q.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $dEY0Q.isTagElement)(el)) $d8035ce9140f9b66$var$pruneLocation(el.children);
    });
}
function $d8035ce9140f9b66$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $j9yrT.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $19Gjn.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $eBFRL.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $d8035ce9140f9b66$var$pruneLocation(result.val);
    return result.val;
}
var $d8035ce9140f9b66$export$d3c1bfa0f7d806e9 = (0, $19Gjn.Parser);

});
parcelRegister("eBFRL", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $aa24ff24b735badd$export$896afd8541959ee5);
var $aa24ff24b735badd$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($aa24ff24b735badd$export$896afd8541959ee5 || ($aa24ff24b735badd$export$896afd8541959ee5 = {}));

});

parcelRegister("19Gjn", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $0d7773e642cd15c0$export$7acfa6ed01010e37);

var $j9yrT = parcelRequire("j9yrT");

var $eBFRL = parcelRequire("eBFRL");

var $dEY0Q = parcelRequire("dEY0Q");

var $jICNJ = parcelRequire("jICNJ");
parcelRequire("f92ek");
var $8dHOx = parcelRequire("8dHOx");
var $kmZBG = parcelRequire("kmZBG");

var $9WRjG = parcelRequire("9WRjG");
var $0d7773e642cd15c0$var$_a;
var $0d7773e642cd15c0$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $jICNJ.SPACE_SEPARATOR_REGEX).source, "*"));
var $0d7773e642cd15c0$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $jICNJ.SPACE_SEPARATOR_REGEX).source, "*$"));
function $0d7773e642cd15c0$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $0d7773e642cd15c0$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $0d7773e642cd15c0$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $0d7773e642cd15c0$var$hasNativeFromEntries = !!Object.fromEntries;
var $0d7773e642cd15c0$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $0d7773e642cd15c0$var$hasTrimStart = !!String.prototype.trimStart;
var $0d7773e642cd15c0$var$hasTrimEnd = !!String.prototype.trimEnd;
var $0d7773e642cd15c0$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $0d7773e642cd15c0$var$isSafeInteger = $0d7773e642cd15c0$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $0d7773e642cd15c0$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $0d7773e642cd15c0$var$re = $0d7773e642cd15c0$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $0d7773e642cd15c0$var$REGEX_SUPPORTS_U_AND_Y = (($0d7773e642cd15c0$var$_a = $0d7773e642cd15c0$var$re.exec('a')) === null || $0d7773e642cd15c0$var$_a === void 0 ? void 0 : $0d7773e642cd15c0$var$_a[0]) === 'a';
} catch (_) {
    $0d7773e642cd15c0$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $0d7773e642cd15c0$var$startsWith = $0d7773e642cd15c0$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $0d7773e642cd15c0$var$fromCodePoint = $0d7773e642cd15c0$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $0d7773e642cd15c0$var$fromEntries = // native
$0d7773e642cd15c0$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $0d7773e642cd15c0$var$codePointAt = $0d7773e642cd15c0$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $0d7773e642cd15c0$var$trimStart = $0d7773e642cd15c0$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($0d7773e642cd15c0$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $0d7773e642cd15c0$var$trimEnd = $0d7773e642cd15c0$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($0d7773e642cd15c0$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $0d7773e642cd15c0$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $0d7773e642cd15c0$var$matchIdentifierAtIndex;
if ($0d7773e642cd15c0$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $0d7773e642cd15c0$var$IDENTIFIER_PREFIX_RE_1 = $0d7773e642cd15c0$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $0d7773e642cd15c0$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $0d7773e642cd15c0$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $0d7773e642cd15c0$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$0d7773e642cd15c0$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $0d7773e642cd15c0$var$codePointAt(s, index);
        if (c === undefined || $0d7773e642cd15c0$var$_isWhiteSpace(c) || $0d7773e642cd15c0$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $0d7773e642cd15c0$var$fromCodePoint.apply(void 0, match);
};
var $0d7773e642cd15c0$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $dEY0Q.TYPE).pound,
                    location: $0d7773e642cd15c0$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $eBFRL.ErrorKind).UNMATCHED_CLOSING_TAG, $0d7773e642cd15c0$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $0d7773e642cd15c0$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $dEY0Q.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $0d7773e642cd15c0$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$0d7773e642cd15c0$var$_isAlpha(this.char())) return this.error((0, $eBFRL.ErrorKind).INVALID_TAG, $0d7773e642cd15c0$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $eBFRL.ErrorKind).UNMATCHED_CLOSING_TAG, $0d7773e642cd15c0$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $eBFRL.ErrorKind).INVALID_TAG, $0d7773e642cd15c0$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $dEY0Q.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $0d7773e642cd15c0$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $eBFRL.ErrorKind).UNCLOSED_TAG, $0d7773e642cd15c0$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $eBFRL.ErrorKind).INVALID_TAG, $0d7773e642cd15c0$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $0d7773e642cd15c0$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $0d7773e642cd15c0$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $dEY0Q.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$0d7773e642cd15c0$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $0d7773e642cd15c0$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $0d7773e642cd15c0$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $eBFRL.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $eBFRL.ErrorKind).EMPTY_ARGUMENT, $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $eBFRL.ErrorKind).MALFORMED_ARGUMENT, $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $eBFRL.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $dEY0Q.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $eBFRL.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $eBFRL.ErrorKind).MALFORMED_ARGUMENT, $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $0d7773e642cd15c0$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $0d7773e642cd15c0$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $eBFRL.ErrorKind).EXPECT_ARGUMENT_TYPE, $0d7773e642cd15c0$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $0d7773e642cd15c0$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $eBFRL.ErrorKind).EXPECT_ARGUMENT_STYLE, $0d7773e642cd15c0$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $0d7773e642cd15c0$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $0d7773e642cd15c0$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $0d7773e642cd15c0$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $dEY0Q.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $eBFRL.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $9WRjG.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $dEY0Q.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $8dHOx.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $dEY0Q.TYPE).date : (0, $dEY0Q.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $dEY0Q.TYPE).number : argType === 'date' ? (0, $dEY0Q.TYPE).date : (0, $dEY0Q.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $eBFRL.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $0d7773e642cd15c0$var$createLocation(typeEndPosition_1, (0, $j9yrT.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $eBFRL.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $0d7773e642cd15c0$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $eBFRL.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $eBFRL.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $dEY0Q.TYPE).select,
                        value: value,
                        options: $0d7773e642cd15c0$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $dEY0Q.TYPE).plural,
                        value: value,
                        options: $0d7773e642cd15c0$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $eBFRL.ErrorKind).INVALID_ARGUMENT_TYPE, $0d7773e642cd15c0$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $eBFRL.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $eBFRL.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $0d7773e642cd15c0$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $kmZBG.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $eBFRL.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $dEY0Q.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $kmZBG.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $eBFRL.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $eBFRL.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $0d7773e642cd15c0$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $eBFRL.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $eBFRL.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $eBFRL.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $eBFRL.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $0d7773e642cd15c0$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $0d7773e642cd15c0$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $eBFRL.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $eBFRL.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $0d7773e642cd15c0$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $eBFRL.ErrorKind).MISSING_OTHER_CLAUSE, $0d7773e642cd15c0$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $0d7773e642cd15c0$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$0d7773e642cd15c0$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $0d7773e642cd15c0$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($0d7773e642cd15c0$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $0d7773e642cd15c0$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $0d7773e642cd15c0$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $0d7773e642cd15c0$var$_isAlphaOrSlash(codepoint) {
    return $0d7773e642cd15c0$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $0d7773e642cd15c0$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $0d7773e642cd15c0$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $0d7773e642cd15c0$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("dEY0Q", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $9f1d900dc3de138c$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $9f1d900dc3de138c$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $9f1d900dc3de138c$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $9f1d900dc3de138c$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $9f1d900dc3de138c$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $9f1d900dc3de138c$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $9f1d900dc3de138c$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $9f1d900dc3de138c$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $9f1d900dc3de138c$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $9f1d900dc3de138c$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $9f1d900dc3de138c$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $9f1d900dc3de138c$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $9f1d900dc3de138c$export$7680c41f1a55f4cf);
var $9f1d900dc3de138c$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($9f1d900dc3de138c$export$b87f371cbc396fcf || ($9f1d900dc3de138c$export$b87f371cbc396fcf = {}));
var $9f1d900dc3de138c$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($9f1d900dc3de138c$export$906452485466fa53 || ($9f1d900dc3de138c$export$906452485466fa53 = {}));
function $9f1d900dc3de138c$export$cfa10c5697238752(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.literal;
}
function $9f1d900dc3de138c$export$4f55724281bdfaf9(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.argument;
}
function $9f1d900dc3de138c$export$e11187b219e191e1(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.number;
}
function $9f1d900dc3de138c$export$32d811605da75f40(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.date;
}
function $9f1d900dc3de138c$export$34ec46f596b1702f(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.time;
}
function $9f1d900dc3de138c$export$dcfe1c11d168b5a1(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.select;
}
function $9f1d900dc3de138c$export$6c796d116f0a4fbc(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.plural;
}
function $9f1d900dc3de138c$export$c0ece297bdd0c082(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.pound;
}
function $9f1d900dc3de138c$export$5c83de34745812b(el) {
    return el.type === $9f1d900dc3de138c$export$b87f371cbc396fcf.tag;
}
function $9f1d900dc3de138c$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $9f1d900dc3de138c$export$906452485466fa53.number);
}
function $9f1d900dc3de138c$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $9f1d900dc3de138c$export$906452485466fa53.dateTime);
}
function $9f1d900dc3de138c$export$f0ac572c1121c662(value) {
    return {
        type: $9f1d900dc3de138c$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $9f1d900dc3de138c$export$425e864b0ba114f1(value, style) {
    return {
        type: $9f1d900dc3de138c$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("jICNJ", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $e5b03977e12bc75b$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $e5b03977e12bc75b$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $e5b03977e12bc75b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("f92ek", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("8dHOx")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("kmZBG")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("kmZBG")).parseNumberSkeletonFromString);
parcelRequire("8dHOx");
parcelRequire("kmZBG");

});
parcelRegister("8dHOx", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $5fc1862d89c734e7$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $5fc1862d89c734e7$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $5fc1862d89c734e7$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($5fc1862d89c734e7$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("kmZBG", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $ed45a68e8ef9f70c$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $ed45a68e8ef9f70c$export$47c6f8480bda3e11);

var $j9yrT = parcelRequire("j9yrT");

var $kkHwO = parcelRequire("kkHwO");
function $ed45a68e8ef9f70c$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $kkHwO.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $ed45a68e8ef9f70c$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $ed45a68e8ef9f70c$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $ed45a68e8ef9f70c$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $ed45a68e8ef9f70c$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $ed45a68e8ef9f70c$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $ed45a68e8ef9f70c$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($ed45a68e8ef9f70c$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $ed45a68e8ef9f70c$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $ed45a68e8ef9f70c$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$ed45a68e8ef9f70c$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $ed45a68e8ef9f70c$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $ed45a68e8ef9f70c$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $ed45a68e8ef9f70c$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $ed45a68e8ef9f70c$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, all), $ed45a68e8ef9f70c$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, all), $ed45a68e8ef9f70c$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($ed45a68e8ef9f70c$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($ed45a68e8ef9f70c$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($ed45a68e8ef9f70c$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($ed45a68e8ef9f70c$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), $ed45a68e8ef9f70c$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($ed45a68e8ef9f70c$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), $ed45a68e8ef9f70c$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $ed45a68e8ef9f70c$var$parseSign(token.stem);
        if (signOpts) result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $ed45a68e8ef9f70c$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("kkHwO", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $ecd770b97cbd054b$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $ecd770b97cbd054b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("9WRjG", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $73e2e35ed1792bb6$export$29c5368be8904d27);

var $68ykW = parcelRequire("68ykW");
function $73e2e35ed1792bb6$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $73e2e35ed1792bb6$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $73e2e35ed1792bb6$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $68ykW.timeData)[regionTag || ''] || (0, $68ykW.timeData)[languageTag || ''] || (0, $68ykW.timeData)["".concat(languageTag, "-001")] || (0, $68ykW.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("68ykW", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $477e20046626786c$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $477e20046626786c$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("d1eO2", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $97a6da8d4d56469d$export$49694c2877b44c57);
$parcel$export(module.exports, "formatToParts", () => $97a6da8d4d56469d$export$275d4a3bb5f66fda);
parcelRequire("ixPDv");
var $dEY0Q = parcelRequire("dEY0Q");

var $1ezAN = parcelRequire("1ezAN");
var $97a6da8d4d56469d$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($97a6da8d4d56469d$export$49694c2877b44c57 || ($97a6da8d4d56469d$export$49694c2877b44c57 = {}));
function $97a6da8d4d56469d$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $97a6da8d4d56469d$export$49694c2877b44c57.literal || part.type !== $97a6da8d4d56469d$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $97a6da8d4d56469d$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $97a6da8d4d56469d$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $dEY0Q.isLiteralElement)(els[0])) return [
        {
            type: $97a6da8d4d56469d$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $dEY0Q.isLiteralElement)(el)) {
            result.push({
                type: $97a6da8d4d56469d$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $dEY0Q.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $97a6da8d4d56469d$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $1ezAN.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $dEY0Q.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $97a6da8d4d56469d$export$49694c2877b44c57.literal : $97a6da8d4d56469d$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $dEY0Q.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $dEY0Q.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $97a6da8d4d56469d$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $dEY0Q.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $dEY0Q.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $97a6da8d4d56469d$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $dEY0Q.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $dEY0Q.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $97a6da8d4d56469d$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $dEY0Q.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$97a6da8d4d56469d$export$df0c12a2d414a163(formatFn)) throw new (0, $1ezAN.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $97a6da8d4d56469d$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $97a6da8d4d56469d$export$49694c2877b44c57.literal : $97a6da8d4d56469d$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $dEY0Q.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $1ezAN.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $97a6da8d4d56469d$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $dEY0Q.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $1ezAN.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $1ezAN.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $1ezAN.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $97a6da8d4d56469d$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $97a6da8d4d56469d$var$mergeLiteral(result);
}

});
parcelRegister("1ezAN", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $0e62b52b856edfc2$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $0e62b52b856edfc2$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $0e62b52b856edfc2$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $0e62b52b856edfc2$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $0e62b52b856edfc2$export$8bfc137e4d23fdf0);

var $j9yrT = parcelRequire("j9yrT");
var $0e62b52b856edfc2$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($0e62b52b856edfc2$export$d4e71bc0b80dc0fb || ($0e62b52b856edfc2$export$d4e71bc0b80dc0fb = {}));
var $0e62b52b856edfc2$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $0e62b52b856edfc2$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $0e62b52b856edfc2$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($0e62b52b856edfc2$export$7369836851cc1329);
var $0e62b52b856edfc2$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $0e62b52b856edfc2$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($0e62b52b856edfc2$export$7369836851cc1329);
var $0e62b52b856edfc2$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $0e62b52b856edfc2$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($0e62b52b856edfc2$export$7369836851cc1329);

});




parcelRegister("ceutJ", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $8e7e6f38ee8f98e4$export$557d6acb76e8a244);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $8e7e6f38ee8f98e4$export$549f97e137a05c90);

var $j9yrT = parcelRequire("j9yrT");
var $8e7e6f38ee8f98e4$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($8e7e6f38ee8f98e4$export$557d6acb76e8a244 || ($8e7e6f38ee8f98e4$export$557d6acb76e8a244 = {}));
var $8e7e6f38ee8f98e4$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $8e7e6f38ee8f98e4$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $8e7e6f38ee8f98e4$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($8e7e6f38ee8f98e4$export$c016d36112f6ddf8);
var $8e7e6f38ee8f98e4$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $8e7e6f38ee8f98e4$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($8e7e6f38ee8f98e4$export$c016d36112f6ddf8);
var $8e7e6f38ee8f98e4$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $8e7e6f38ee8f98e4$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($8e7e6f38ee8f98e4$export$c016d36112f6ddf8);
var $8e7e6f38ee8f98e4$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $8e7e6f38ee8f98e4$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($8e7e6f38ee8f98e4$export$c016d36112f6ddf8);
var $8e7e6f38ee8f98e4$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($8e7e6f38ee8f98e4$export$e3b7eee1dbc44895);
var $8e7e6f38ee8f98e4$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $8e7e6f38ee8f98e4$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($8e7e6f38ee8f98e4$export$c016d36112f6ddf8);

});




parcelRegister("cxMk3", function(module, exports) {
$parcel$export(module.exports, "ChoreographerWrapper", () => $fd20582e848c1ad4$export$8db7ba034addcd65);

var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $fGrpH = parcelRequire("fGrpH");

var $euxye = parcelRequire("euxye");

var $iMsV9 = parcelRequire("iMsV9");
const $fd20582e848c1ad4$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    return null;
};
$fd20582e848c1ad4$var$ChoreographedComponent.displayName = "ChoreographedComponent";
const $fd20582e848c1ad4$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $iMsV9.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $4LDqh.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $4LDqh.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $4LDqh.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $e79Pd.jsx)($fd20582e848c1ad4$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$fd20582e848c1ad4$export$8db7ba034addcd65.displayName = "ChoreographerWrapper";

});
parcelRegister("iMsV9", function(module, exports) {
$parcel$export(module.exports, "StableChoreographerProvider", () => $708a720ca3c586bc$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $708a720ca3c586bc$export$cab5a8adbabcee23);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $j142y = parcelRequire("j142y");
var $fgdQf = parcelRequire("fgdQf");

var $i1uKb = parcelRequire("i1uKb");

var $lSxTw = parcelRequire("lSxTw");
// @twood: NEVER CHANGE THIS DEFAULT VALUE
const $708a720ca3c586bc$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $708a720ca3c586bc$var$choreographerLogger = (0, $i1uKb.createInBrowserDebugLogger)('Choreographer');
const $708a720ca3c586bc$var$defaultContext = {
    choreographerEnabled: $708a720ca3c586bc$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $708a720ca3c586bc$var$ChoreographerContext = /*#__PURE__*/ (0, $euxye.createContext)($708a720ca3c586bc$var$defaultContext);
// Helper to automatically handle ESM and non-ESM imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $708a720ca3c586bc$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        $708a720ca3c586bc$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        $708a720ca3c586bc$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof mod?.default === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        $708a720ca3c586bc$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $708a720ca3c586bc$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};

const $708a720ca3c586bc$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $euxye.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $euxye.useState)(choreographer?.isDefaultEnabled ?? $708a720ca3c586bc$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $fgdQf.usePostOfficeEnvironment)();
    const context = (0, $j142y.usePostOfficeContext)();
    (0, $euxye.useEffect)(()=>{
        if ((0, $lSxTw.shouldBypassChoreographerFromDevtools)()) setChoreographerEnabled(false);
    }, [
        setChoreographerEnabled
    ]);
    (0, $euxye.useEffect)(()=>{
        if (choreographerEnabled) // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("SntTi")).then((m)=>{
            const ChoreographerRegistryClass = $708a720ca3c586bc$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $708a720ca3c586bc$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $708a720ca3c586bc$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $708a720ca3c586bc$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $708a720ca3c586bc$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $euxye.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    (0, $euxye.useEffect)(()=>{
        $708a720ca3c586bc$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    (0, $euxye.useEffect)(()=>{
        return (0, $lSxTw.installChoreographerDevtoolsBridge)({
            setChoreographerEnabled: setChoreographerEnabled
        });
    }, [
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($708a720ca3c586bc$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
$708a720ca3c586bc$export$e68b2c75bfb5682a.displayName = "StableChoreographerProvider";
const $708a720ca3c586bc$export$cab5a8adbabcee23 = ()=>(0, $euxye.useContext)($708a720ca3c586bc$var$ChoreographerContext);

});
parcelRegister("i1uKb", function(module, exports) {
$parcel$export(module.exports, "createInBrowserDebugLogger", () => $86725688157fa072$export$806eda59584e395d);
/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components.
 *
 * NOTE: This is a copy of
 * `post-office/packages/util/shared-contracts/src/util/in-browser-debug-logger.ts`
 * to avoid a cross-workspace import. You may want to keep them in sync.
 *
 * Usage:
 * - Enable:  window.postOffice{Component}Debug = true
 * - Disable: window.postOffice{Component}Debug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $86725688157fa072$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};

});

parcelRegister("lSxTw", function(module, exports) {
$parcel$export(module.exports, "shouldBypassChoreographerFromDevtools", () => $989077b6a473c0f5$export$8e299e8aab3a0cc6);
$parcel$export(module.exports, "installChoreographerDevtoolsBridge", () => $989077b6a473c0f5$export$606f928dbd560712);

var $8faAl = parcelRequire("8faAl");

var $egspI = parcelRequire("egspI");
const $989077b6a473c0f5$var$DEBUG_BYPASS_SESSION_STORAGE_KEY = 'postOffice.choreographer.debug';
const $989077b6a473c0f5$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY = 'bypassEnabled';
const $989077b6a473c0f5$var$getStorageClient = ()=>new (0, $8faAl.default)($989077b6a473c0f5$var$DEBUG_BYPASS_SESSION_STORAGE_KEY, {
        storageEngine: 'sessionStorage'
    });
const $989077b6a473c0f5$var$getWindow = ()=>typeof window === 'undefined' ? undefined : window;
const $989077b6a473c0f5$var$getPersistedBypassEnabled = ()=>{
    return $989077b6a473c0f5$var$getStorageClient().getItem($989077b6a473c0f5$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY) === true;
};
const $989077b6a473c0f5$export$8e299e8aab3a0cc6 = ()=>{
    return (0, $egspI.fg)('post-office_choreographer_devtools_bridge') && $989077b6a473c0f5$var$getPersistedBypassEnabled();
};
const $989077b6a473c0f5$var$setPersistedBypassEnabled = (isEnabled)=>{
    // The devtools bridge should never break message rendering when browser storage is blocked.
    // StorageClient handles exceptions internally.
    $989077b6a473c0f5$var$getStorageClient().setItemWithExpiry($989077b6a473c0f5$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY, isEnabled);
};
const $989077b6a473c0f5$var$getChoreographerSingleton = ()=>$989077b6a473c0f5$var$getWindow()?.postOffice?.choreographer?.singleton;
const $989077b6a473c0f5$var$getRegisteredPluginIds = ()=>{
    return [
        ...$989077b6a473c0f5$var$getWindow()?.choreographerRegistry?.keys() ?? []
    ];
};
const $989077b6a473c0f5$var$getSnapshot = ()=>{
    const singleton = $989077b6a473c0f5$var$getChoreographerSingleton();
    const registeredPlugins = $989077b6a473c0f5$var$getRegisteredPluginIds();
    return {
        activeMessage: singleton?.getCurrentMessage() ?? null,
        bypassEnabled: $989077b6a473c0f5$export$8e299e8aab3a0cc6(),
        pendingMessage: singleton?.getCurrentPendingMessage() ?? null,
        queuedMessages: singleton?.getQueuedMessages() ?? [],
        recentEvents: [],
        registeredMessages: registeredPlugins.map((productId)=>({
                productId: productId,
                messageIds: [
                    ...singleton?.getMessages(productId).keys() ?? []
                ]
            })),
        registeredPlugins: registeredPlugins,
        updatedAt: Date.now()
    };
};
const $989077b6a473c0f5$export$606f928dbd560712 = ({ setChoreographerEnabled: setChoreographerEnabled })=>{
    const currentWindow = $989077b6a473c0f5$var$getWindow();
    if (!currentWindow) return ()=>{};
    if (!(0, $egspI.fg)('post-office_choreographer_devtools_bridge')) {
        delete currentWindow.postOffice?.choreographer?.debug;
        return ()=>{};
    }
    const bridge = {
        getSnapshot: $989077b6a473c0f5$var$getSnapshot,
        isBypassEnabled: $989077b6a473c0f5$export$8e299e8aab3a0cc6,
        setBypassEnabled: (isEnabled)=>{
            $989077b6a473c0f5$var$setPersistedBypassEnabled(isEnabled);
            setChoreographerEnabled(!isEnabled);
        }
    };
    currentWindow.postOffice = {
        ...currentWindow.postOffice,
        choreographer: {
            ...currentWindow.postOffice?.choreographer,
            debug: bridge
        }
    };
    return ()=>{
        if (currentWindow.postOffice?.choreographer?.debug === bridge) delete currentWindow.postOffice.choreographer.debug;
    };
};

});

parcelRegister("SntTi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gztnI").then(()=>parcelRequire('lNG13'));

});



parcelRegister("140JV", function(module, exports) {
$parcel$export(module.exports, "MaybeChoreographerWrapper", () => $ee6f55c54192cdc3$export$738797901aa9197a);

var $e79Pd = parcelRequire("e79Pd");
const $ee6f55c54192cdc3$export$738797901aa9197a = ({ ChoreographerWrapper: ChoreographerWrapper, enabled: enabled, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, children: children })=>{
    if (!enabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)(ChoreographerWrapper, {
        messageId: messageId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: children
    });
};
$ee6f55c54192cdc3$export$738797901aa9197a.displayName = "MaybeChoreographerWrapper";

});

parcelRegister("8opyJ", function(module, exports) {
$parcel$export(module.exports, "FeatureFlaggedUfoWrapper", () => $7e7fcc669bd1d00b$export$8e6fb7035018b3e4);

var $e79Pd = parcelRequire("e79Pd");

var $bDiVY = parcelRequire("bDiVY");
const $7e7fcc669bd1d00b$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bDiVY.UFOv2).UFOSegment, {
        name: (0, $bDiVY.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bDiVY.UFOv2).UFOSegment, {
            name: `${(0, $bDiVY.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$7e7fcc669bd1d00b$export$8e6fb7035018b3e4.displayName = "FeatureFlaggedUfoWrapper";

});

parcelRegister("4uj2Z", function(module, exports) {
$parcel$export(module.exports, "MaybeTriggeredMessageValidator", () => $8347e8b1f5429687$export$dac988aa97dc7b79);

var $e79Pd = parcelRequire("e79Pd");

var $92dA1 = parcelRequire("92dA1");
const $8347e8b1f5429687$export$dac988aa97dc7b79 = ({ children: children, waitForTrigger: waitForTrigger })=>{
    if (!waitForTrigger) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $92dA1.TriggeredMessageValidator), {
        waitForTrigger: waitForTrigger,
        children: children
    });
};
$8347e8b1f5429687$export$dac988aa97dc7b79.displayName = "MaybeTriggeredMessageValidator";

});
parcelRegister("92dA1", function(module, exports) {
$parcel$export(module.exports, "TriggeredMessageValidator", () => $05b8f15cf864a274$export$c8b5f992b8a1b38b);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1Heu1 = parcelRequire("1Heu1");
/** Hide content until validated; avoids flash without off-screen positioning or scrollbar issues. */ const $05b8f15cf864a274$var$HIDDEN_CONTAINER_STYLE = {
    display: 'none'
};
const $05b8f15cf864a274$export$c8b5f992b8a1b38b = ({ children: children, waitForTrigger: waitForTrigger })=>{
    const [validated, setValidated] = (0, $euxye.useState)('pending');
    (0, $1Heu1.useLayoutEffect)(()=>{
        const calledRef = waitForTrigger?.__calledRef;
        if (calledRef?.current) {
            setValidated('allowed');
            return;
        }
        // Ref not set after template had a chance to run.
        if (calledRef) setValidated('blocked');
    }, [
        waitForTrigger,
        children
    ]);
    if (validated === 'blocked') return null;
    const isHidden = validated === 'pending';
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        style: isHidden ? $05b8f15cf864a274$var$HIDDEN_CONTAINER_STYLE : undefined,
        "aria-hidden": isHidden,
        "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
        children: children
    });
};
$05b8f15cf864a274$export$c8b5f992b8a1b38b.displayName = "TriggeredMessageValidator";

});
parcelRegister("1Heu1", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $18e0a21f3282ed7a$export$e5c5a5f917a5871c);

var $euxye = parcelRequire("euxye");
/**
 * `useLayoutEffect` warns during SSR ("Warning: useLayoutEffect does nothing on the server").
 * Fall back to `useEffect` on the server so utilities in this package are safe to render in SSR
 * contexts. In the browser the synchronous commit-time semantics of `useLayoutEffect` are preserved.
 *
 * Consumers import this as `useLayoutEffect` so the call site reads identically to React's hook.
 *
 * See: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */ const $18e0a21f3282ed7a$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? (0, $euxye.useLayoutEffect) : (0, $euxye.useEffect);

});



parcelRegister("b18n5", function(module, exports) {
$parcel$export(module.exports, "MessageAnalyticsContextProvider", () => $f577bfc4db50cbf0$export$1737ab199e83455e);
$parcel$export(module.exports, "useMessageAnalyticsContext", () => $f577bfc4db50cbf0$export$bb426ba114b64992);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $f577bfc4db50cbf0$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $f577bfc4db50cbf0$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $euxye.createContext)($f577bfc4db50cbf0$var$defaultMessageAnalyticsContextValue);
const $f577bfc4db50cbf0$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $euxye.useRef)(false);
    const contextValue = (0, $euxye.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($f577bfc4db50cbf0$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
$f577bfc4db50cbf0$export$1737ab199e83455e.displayName = "MessageAnalyticsContextProvider";
const $f577bfc4db50cbf0$export$bb426ba114b64992 = ()=>(0, $euxye.useContext)($f577bfc4db50cbf0$export$c81717973c6c4a90);

});

parcelRegister("gwHtt", function(module, exports) {
$parcel$export(module.exports, "MaybeManualMessageViewedEvent", () => $2fb1327e21a870a4$export$9915b88f81e90e6e);

var $e79Pd = parcelRequire("e79Pd");

var $6JBQt = parcelRequire("6JBQt");
const $2fb1327e21a870a4$export$9915b88f81e90e6e = ({ isManual: isManual, children: children })=>{
    return isManual ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6JBQt.ManualMessageViewedEvent), {
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$2fb1327e21a870a4$export$9915b88f81e90e6e.displayName = "MaybeManualMessageViewedEvent";

});
parcelRegister("6JBQt", function(module, exports) {
$parcel$export(module.exports, "ManualMessageViewedEvent", () => $46d53e08c9bb97e4$export$de534803cb07dfcc);
$parcel$export(module.exports, "MessageViewed", () => $46d53e08c9bb97e4$export$14fe1fc3395b6e3f);

var $e79Pd = parcelRequire("e79Pd");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $euxye = parcelRequire("euxye");

var $jDl4h = parcelRequire("jDl4h");

var $b18n5 = parcelRequire("b18n5");

var $5R7RH = parcelRequire("5R7RH");
const $46d53e08c9bb97e4$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $b18n5.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$46d53e08c9bb97e4$export$de534803cb07dfcc.displayName = "ManualMessageViewedEvent";
const $46d53e08c9bb97e4$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $b18n5.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $iKPvC.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $euxye.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $euxye.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $euxye.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5R7RH.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
$46d53e08c9bb97e4$export$14fe1fc3395b6e3f.displayName = "MessageViewed";
const $46d53e08c9bb97e4$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $euxye.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $iKPvC.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $jDl4h.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $euxye.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $euxye.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $e79Pd.jsx)($46d53e08c9bb97e4$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};
$46d53e08c9bb97e4$export$4c73c6f545b966b7.displayName = "MessageViewedTrackerWithViewportTracking";

});
parcelRegister("iKPvC", function(module, exports) {
$parcel$export(module.exports, "useMessageInstanceEvent", () => $2b36103a28c11e08$export$39b0f5626e96f41e);

var $f5EyW = parcelRequire("f5EyW");
const $2b36103a28c11e08$export$39b0f5626e96f41e = (0, $f5EyW.useMessageInstanceEvent);

});
parcelRegister("f5EyW", function(module, exports) {
$parcel$export(module.exports, "useMessageInstanceEvent", () => $486880309969f420$export$39b0f5626e96f41e);

var $1Ocjm = parcelRequire("1Ocjm");
const $486880309969f420$export$39b0f5626e96f41e = (0, $1Ocjm.useMessageInstanceEvent);

});
parcelRegister("1Ocjm", function(module, exports) {
$parcel$export(module.exports, "useMessageInstanceEvent", () => $e3b367cb1c3190fb$export$39b0f5626e96f41e);
$parcel$export(module.exports, "useMessageViewed", () => $e3b367cb1c3190fb$export$f847ba3acec566f4);
$parcel$export(module.exports, "MessageInstanceEventClient", () => (parcelRequire("4x0T0")).MessageInstanceEventClient);
$parcel$export(module.exports, "useRecommendationContext", () => (parcelRequire("8KzDp")).useRecommendationContext);
$parcel$export(module.exports, "useMessageContext", () => (parcelRequire("lK7pY")).useMessageContext);
$parcel$export(module.exports, "usePlacementContext", () => (parcelRequire("fslfv")).usePlacementContext);
/**
 * Message lifecycle hooks for Post Office headless consumers.
 *
 * Provides `useMessageViewed` — a single hook that fires viewed and delivery
 * analytics events on mount:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed() (message-instance-event endpoint)
 *   - messageInstanceDeliveredSuccessfully() (message-instance-event endpoint)
 *
 * This module is hoisted into @atlassian/post-office-context so that platform
 * packages can consume it without cross-workspace @post-office/* imports.
 *
 * Canonical sources this was inlined from:
 *   post-office/packages/clients/message-lifecycle
 *   post-office/packages/clients/message-instance-event-frontend-client
 *   post-office/packages/clients/recommendation-context
 */ 
var $euxye = parcelRequire("euxye");

var $lHZq9 = parcelRequire("lHZq9");
var $j142y = parcelRequire("j142y");

var $lK7pY = parcelRequire("lK7pY");

var $9rDQt = parcelRequire("9rDQt");

var $4x0T0 = parcelRequire("4x0T0");

var $fslfv = parcelRequire("fslfv");

var $8KzDp = parcelRequire("8KzDp");
class $e3b367cb1c3190fb$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $e3b367cb1c3190fb$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}
const $e3b367cb1c3190fb$export$39b0f5626e96f41e = ()=>{
    // globalThis resolves to window in the browser, this will therefore attach at window.window, but we should not change until we are sure what is relying on this path.
    if (typeof window !== 'undefined' && !globalThis?.window?.postOfficeMessageInstanceEventClient) {
        // If we are in the browser but there is no window.window
        if (typeof globalThis.window === 'undefined') globalThis.window = {};
        globalThis.window.postOfficeMessageInstanceEventClient = new (0, $4x0T0.MessageInstanceEventClient)();
    }
    const messageInstanceEventClientRef = (0, $euxye.useRef)(globalThis?.window?.postOfficeMessageInstanceEventClient ?? new (0, $4x0T0.MessageInstanceEventClient)());
    // This falls back to creation per call in the case window is not defined. It is not the best behaviour as this could cause too many object to be created but is
    // better than an uncontrolled error in SSR. This function needs to be made SSR safe in a safter manner.
    const client = messageInstanceEventClientRef.current;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId = null, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, analyticsDetails: analyticsDetails = null, configSetId: configSetId } = (0, $lK7pY.useMessageContext)();
    const { placementId: placementId } = (0, $fslfv.usePlacementContext)();
    const browserContext = (0, $j142y.usePostOfficeContext)();
    const recommendationContext = (0, $8KzDp.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $euxye.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $e3b367cb1c3190fb$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceViewed = (0, $euxye.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $e3b367cb1c3190fb$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceClicked = (0, $euxye.useCallback)(async (params)=>{
        if (!messageInstanceId && !params.messageInstanceId || !messageTemplateId && !params.messageTemplateId || !placementId || !messageCreationType && !params.messageCreationType || !messageTriggerId && !params.messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $e3b367cb1c3190fb$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: params.messageTriggerId ?? messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            ...params,
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...params.additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};
const $e3b367cb1c3190fb$export$f847ba3acec566f4 = ()=>{
    // -- message-lifecycle (legacy) client --
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $9rDQt.MessageEventClient)();
    const legacyClient = globalThis.window.postOfficeMessageEventClient;
    // -- message-instance-event client --
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $4x0T0.MessageInstanceEventClient)();
    const instanceClient = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId } = (0, $lK7pY.useMessageContext)();
    const { placementId: placementId } = (0, $fslfv.usePlacementContext)();
    const browserContext = (0, $j142y.usePostOfficeContext)();
    const recommendationContext = (0, $8KzDp.useRecommendationContext)();
    const { markViewedFromPlacement: markViewedFromPlacement } = (0, $lHZq9.useMessagePlacementHooks)();
    return async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) {
            // eslint-disable-next-line no-console
            console.error('[post-office] useMessageViewed: missing required context fields');
            return;
        }
        const sharedContext = {
            ...browserContext,
            source: placementId,
            recommendation: {
                recommendationSessionId: recommendationContext.sessionId ?? '',
                recommendationEntityId: recommendationContext.entityId ?? ''
            }
        };
        // 1. Legacy lifecycle event (messageViewed)
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        legacyClient.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $9rDQt.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: {
                browser: browserContext,
                recommendation: recommendationContext
            }
        });
        // 2. messageInstanceViewed
        await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType ?? 'implicit',
            messageTriggerId: messageTriggerId ?? '',
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails ?? {}
            },
            timestamp: Date.now()
        });
        // 3. messageInstanceDeliveredSuccessfully
        if (messageCreationType && messageTriggerId) await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails ?? {}
            },
            timestamp: Date.now()
        });
    };
};

});
parcelRegister("9rDQt", function(module, exports) {
$parcel$export(module.exports, "InAppMessageEventType", () => $f0177f03459d4931$export$b31ffc6f7c85f1b);
$parcel$export(module.exports, "MessageEventClient", () => $f0177f03459d4931$export$ae86a6dabe385178);
/**
 * Canonical MessageEventClient implementation.
 *
 * This is the source of truth. `@post-office/message-lifecycle` uses this via
 * `@atlassian/post-office-context/message-lifecycle`.
 */ // ---------------------------------------------------------------------------
// Types (inlined from @post-office/message-lifecycle/src/types.ts)
// ---------------------------------------------------------------------------
var $f0177f03459d4931$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
// ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $f0177f03459d4931$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $f0177f03459d4931$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $f0177f03459d4931$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("5NsYN"));
class $f0177f03459d4931$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $f0177f03459d4931$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $f0177f03459d4931$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $f0177f03459d4931$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($f0177f03459d4931$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $f0177f03459d4931$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $f0177f03459d4931$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("5NsYN", function(module, exports) {
$parcel$export(module.exports, "Headers", () => $43880215f73f14c5$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $43880215f73f14c5$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $43880215f73f14c5$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $43880215f73f14c5$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $43880215f73f14c5$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $43880215f73f14c5$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $43880215f73f14c5$var$support = {
    searchParams: 'URLSearchParams' in $43880215f73f14c5$var$g,
    iterable: 'Symbol' in $43880215f73f14c5$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $43880215f73f14c5$var$g && 'Blob' in $43880215f73f14c5$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $43880215f73f14c5$var$g,
    arrayBuffer: 'ArrayBuffer' in $43880215f73f14c5$var$g
};
function $43880215f73f14c5$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($43880215f73f14c5$var$support.arrayBuffer) {
    var $43880215f73f14c5$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $43880215f73f14c5$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $43880215f73f14c5$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $43880215f73f14c5$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $43880215f73f14c5$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $43880215f73f14c5$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($43880215f73f14c5$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $43880215f73f14c5$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $43880215f73f14c5$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$43880215f73f14c5$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $43880215f73f14c5$var$normalizeName(name);
    value = $43880215f73f14c5$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$43880215f73f14c5$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$43880215f73f14c5$var$normalizeName(name)];
};
$43880215f73f14c5$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $43880215f73f14c5$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$43880215f73f14c5$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($43880215f73f14c5$var$normalizeName(name));
};
$43880215f73f14c5$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$43880215f73f14c5$var$normalizeName(name)] = $43880215f73f14c5$var$normalizeValue(value);
};
$43880215f73f14c5$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$43880215f73f14c5$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $43880215f73f14c5$var$iteratorFor(items);
};
$43880215f73f14c5$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $43880215f73f14c5$var$iteratorFor(items);
};
$43880215f73f14c5$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $43880215f73f14c5$var$iteratorFor(items);
};
if ($43880215f73f14c5$var$support.iterable) $43880215f73f14c5$export$79b704688b15c0f4.prototype[Symbol.iterator] = $43880215f73f14c5$export$79b704688b15c0f4.prototype.entries;
function $43880215f73f14c5$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $43880215f73f14c5$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $43880215f73f14c5$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $43880215f73f14c5$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $43880215f73f14c5$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $43880215f73f14c5$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $43880215f73f14c5$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $43880215f73f14c5$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $43880215f73f14c5$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($43880215f73f14c5$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($43880215f73f14c5$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($43880215f73f14c5$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($43880215f73f14c5$var$support.arrayBuffer && $43880215f73f14c5$var$support.blob && $43880215f73f14c5$var$isDataView(body)) {
            this._bodyArrayBuffer = $43880215f73f14c5$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($43880215f73f14c5$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $43880215f73f14c5$var$isArrayBufferView(body))) this._bodyArrayBuffer = $43880215f73f14c5$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($43880215f73f14c5$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($43880215f73f14c5$var$support.blob) this.blob = function() {
        var rejected = $43880215f73f14c5$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $43880215f73f14c5$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($43880215f73f14c5$var$support.blob) return this.blob().then($43880215f73f14c5$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $43880215f73f14c5$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $43880215f73f14c5$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($43880215f73f14c5$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($43880215f73f14c5$var$support.formData) this.formData = function() {
        return this.text().then($43880215f73f14c5$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $43880215f73f14c5$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $43880215f73f14c5$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $43880215f73f14c5$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $43880215f73f14c5$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $43880215f73f14c5$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $43880215f73f14c5$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $43880215f73f14c5$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $43880215f73f14c5$export$79b704688b15c0f4(options.headers);
    this.method = $43880215f73f14c5$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $43880215f73f14c5$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$43880215f73f14c5$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $43880215f73f14c5$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $43880215f73f14c5$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $43880215f73f14c5$var$parseHeaders(rawHeaders) {
    var headers = new $43880215f73f14c5$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$43880215f73f14c5$var$Body.call($43880215f73f14c5$export$7fa6c5b6f8193917.prototype);
function $43880215f73f14c5$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $43880215f73f14c5$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $43880215f73f14c5$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$43880215f73f14c5$var$Body.call($43880215f73f14c5$export$9f633d56d7ec90d3.prototype);
$43880215f73f14c5$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $43880215f73f14c5$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $43880215f73f14c5$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$43880215f73f14c5$export$9f633d56d7ec90d3.error = function() {
    var response = new $43880215f73f14c5$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $43880215f73f14c5$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$43880215f73f14c5$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($43880215f73f14c5$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $43880215f73f14c5$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $43880215f73f14c5$export$fe58bcf938607f6a = $43880215f73f14c5$var$g.DOMException;
try {
    new $43880215f73f14c5$export$fe58bcf938607f6a();
} catch (err) {
    $43880215f73f14c5$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $43880215f73f14c5$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $43880215f73f14c5$export$fe58bcf938607f6a.prototype.constructor = $43880215f73f14c5$export$fe58bcf938607f6a;
}
function $43880215f73f14c5$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $43880215f73f14c5$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $43880215f73f14c5$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $43880215f73f14c5$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $43880215f73f14c5$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $43880215f73f14c5$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $43880215f73f14c5$var$g.location.href ? $43880215f73f14c5$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($43880215f73f14c5$var$support.blob) xhr.responseType = 'blob';
            else if ($43880215f73f14c5$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $43880215f73f14c5$export$79b704688b15c0f4 || $43880215f73f14c5$var$g.Headers && init.headers instanceof $43880215f73f14c5$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($43880215f73f14c5$var$normalizeName(name));
                xhr.setRequestHeader(name, $43880215f73f14c5$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$43880215f73f14c5$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$43880215f73f14c5$var$g.fetch) {
    $43880215f73f14c5$var$g.fetch = $43880215f73f14c5$export$e7aa7bc5c1b3cfb3;
    $43880215f73f14c5$var$g.Headers = $43880215f73f14c5$export$79b704688b15c0f4;
    $43880215f73f14c5$var$g.Request = $43880215f73f14c5$export$7fa6c5b6f8193917;
    $43880215f73f14c5$var$g.Response = $43880215f73f14c5$export$9f633d56d7ec90d3;
}

});


parcelRegister("4x0T0", function(module, exports) {
$parcel$export(module.exports, "MessageInstanceEventClient", () => $f3e703382db72d04$export$4564cfc2de39be55);
/**
 * Canonical MessageInstanceEventClient implementation.
 *
 * This is the source of truth for frontend in-app message instance events.
 * `@atlassian/message-instance-event-frontend-client/message-instance-event-client` and the legacy
 * `@post-office/message-instance-event-frontend-client` package both export this implementation.
 */ // ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $f3e703382db72d04$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $f3e703382db72d04$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $f3e703382db72d04$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("5NsYN"));
class $f3e703382db72d04$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $f3e703382db72d04$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $f3e703382db72d04$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $f3e703382db72d04$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($f3e703382db72d04$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $f3e703382db72d04$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $f3e703382db72d04$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});

parcelRegister("fslfv", function(module, exports) {
$parcel$export(module.exports, "PlacementProvider", () => $b8f026fa9a2789c0$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $b8f026fa9a2789c0$export$4fc0446ee742ad80);
/**
 * Canonical placement context implementation.
 *
 * This is the source of truth. `@post-office/placement-context` re-exports from here.
 * Consumers should import via:
 *   import { PlacementProvider, usePlacementContext } from '@atlassian/post-office-context/placement-context';
 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5ySJg = parcelRequire("5ySJg");

var $bF40s = parcelRequire("bF40s");
const $b8f026fa9a2789c0$export$6394bf86db095a8 = /*#__PURE__*/ (0, $euxye.createContext)({
    placementId: undefined
});
const $b8f026fa9a2789c0$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $euxye.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $bF40s.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($b8f026fa9a2789c0$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5ySJg.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
$b8f026fa9a2789c0$export$6272e220478c7f1d.displayName = "PlacementProvider";
const $b8f026fa9a2789c0$export$4fc0446ee742ad80 = ()=>(0, $euxye.useContext)($b8f026fa9a2789c0$export$6394bf86db095a8);

});




parcelRegister("kdOoc", function(module, exports) {
$parcel$export(module.exports, "useMessageEvent", () => $66c376bf1930389a$export$3cbbf1e81e2ecb39);

var $lHZq9 = parcelRequire("lHZq9");
var $j142y = parcelRequire("j142y");

var $lK7pY = parcelRequire("lK7pY");

var $fslfv = parcelRequire("fslfv");
parcelRequire("1Ocjm");
var $8KzDp = parcelRequire("8KzDp");

var $euxye = parcelRequire("euxye");

var $jReQC = parcelRequire("jReQC");
parcelRequire("2wTCt");
var $9rDQt = parcelRequire("9rDQt");

var $fOY0m = parcelRequire("fOY0m");
const $66c376bf1930389a$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $9rDQt.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $lHZq9.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $lK7pY.useMessageContext)();
    const { placementId: placementId } = (0, $fslfv.usePlacementContext)();
    const browserContext = (0, $j142y.usePostOfficeContext)();
    const recommendationContext = (0, $8KzDp.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $euxye.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $fOY0m.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $jReQC.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $euxye.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $fOY0m.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $jReQC.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $euxye.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $fOY0m.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $jReQC.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $euxye.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $fOY0m.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageClicked = (0, $euxye.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $fOY0m.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $euxye.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $fOY0m.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $euxye.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $fOY0m.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageDismissed = (0, $euxye.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $fOY0m.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $euxye.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jReQC.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $fOY0m.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};

});
parcelRegister("jReQC", function(module, exports) {
$parcel$export(module.exports, "MessageLifecycleContextError", () => $8bdfbfdebc237cf5$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $8bdfbfdebc237cf5$export$44f397e2afeb89e0);
class $8bdfbfdebc237cf5$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $8bdfbfdebc237cf5$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("2wTCt", function(module, exports) {
$parcel$export(module.exports, "MessageEventClient", () => (parcelRequire("9rDQt")).MessageEventClient);
/**
 * Re-exports from the canonical implementation in `@atlassian/post-office-context`.
 *
 * The source of truth is:
 *   platform/packages/post-office/post-office-context/src/message-lifecycle/message-event-client.ts
 *
 * This re-export ensures that `@post-office/message-lifecycle` and
 * `@atlassian/post-office-context` share the same `MessageEventClient` class
 * identity, avoiding TypeScript structural mismatch errors caused by private fields.
 */ 
var $9rDQt = parcelRequire("9rDQt");

});

parcelRegister("fOY0m", function(module, exports) {
$parcel$export(module.exports, "InAppMessageEventType", () => $779d068411a24e6f$export$b31ffc6f7c85f1b);
var $779d068411a24e6f$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});

});


parcelRegister("jDl4h", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $e4b20088c87a3223$export$6215040b989f9b0f, (v) => $e4b20088c87a3223$export$6215040b989f9b0f = v);
var $e4b20088c87a3223$export$1e511d4a378977f5;
var $e4b20088c87a3223$export$6215040b989f9b0f;
var $e4b20088c87a3223$export$436b63fa4855237f;
var $e4b20088c87a3223$export$2e2bcd8739ae039;
var $e4b20088c87a3223$export$95cef81be5ddcfd4;
"use strict";
$e4b20088c87a3223$export$1e511d4a378977f5 = true;
$e4b20088c87a3223$export$6215040b989f9b0f = $e4b20088c87a3223$export$436b63fa4855237f = $e4b20088c87a3223$export$2e2bcd8739ae039 = $e4b20088c87a3223$export$95cef81be5ddcfd4 = void 0;

var $e4b20088c87a3223$var$_handleViewport = $e4b20088c87a3223$var$_interopRequireDefault((parcelRequire("eZ13N")));
$e4b20088c87a3223$export$436b63fa4855237f = $e4b20088c87a3223$var$_handleViewport.default;

var $e4b20088c87a3223$var$_useInViewport = $e4b20088c87a3223$var$_interopRequireDefault((parcelRequire("7BRQu")));
$e4b20088c87a3223$export$6215040b989f9b0f = $e4b20088c87a3223$var$_useInViewport.default;
function $e4b20088c87a3223$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $e4b20088c87a3223$var$customProps = $e4b20088c87a3223$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $e4b20088c87a3223$var$_default = $e4b20088c87a3223$export$2e2bcd8739ae039 = $e4b20088c87a3223$var$_handleViewport.default;

});
parcelRegister("eZ13N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $ae8795b544a1e337$export$1e511d4a378977f5, (v) => $ae8795b544a1e337$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ae8795b544a1e337$export$2e2bcd8739ae039, (v) => $ae8795b544a1e337$export$2e2bcd8739ae039 = v);
var $ae8795b544a1e337$export$1e511d4a378977f5;
var $ae8795b544a1e337$export$2e2bcd8739ae039;
"use strict";
$ae8795b544a1e337$export$1e511d4a378977f5 = true;
$ae8795b544a1e337$export$2e2bcd8739ae039 = void 0;

var $euxye = parcelRequire("euxye");

var $ae8795b544a1e337$var$_hoistNonReactStatics = $ae8795b544a1e337$var$_interopRequireDefault((parcelRequire("8hZ0d")));

var $ae8795b544a1e337$var$_useInViewport = $ae8795b544a1e337$var$_interopRequireDefault((parcelRequire("7BRQu")));

var $2tvVX = parcelRequire("2tvVX");

var $e79Pd = parcelRequire("e79Pd");
var $ae8795b544a1e337$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $ae8795b544a1e337$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $ae8795b544a1e337$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $ae8795b544a1e337$var$_extends() {
    return $ae8795b544a1e337$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ae8795b544a1e337$var$_extends.apply(null, arguments);
}
function $ae8795b544a1e337$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $2tvVX.defaultOptions;
    if (config === void 0) config = $2tvVX.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)(TargetComponent, $ae8795b544a1e337$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $2tvVX.noop, onLeaveViewport: onLeaveViewport = $2tvVX.noop } = _ref, restProps = $ae8795b544a1e337$var$_objectWithoutPropertiesLoose(_ref, $ae8795b544a1e337$var$_excluded);
        var node = (0, $euxye.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $ae8795b544a1e337$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $ae8795b544a1e337$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ForwardedRefComponent, $ae8795b544a1e337$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $ae8795b544a1e337$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $ae8795b544a1e337$var$_default = $ae8795b544a1e337$export$2e2bcd8739ae039 = $ae8795b544a1e337$var$handleViewport;

});
parcelRegister("7BRQu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $58a5c1bcb38585ff$export$1e511d4a378977f5, (v) => $58a5c1bcb38585ff$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $58a5c1bcb38585ff$export$2e2bcd8739ae039, (v) => $58a5c1bcb38585ff$export$2e2bcd8739ae039 = v);
var $58a5c1bcb38585ff$export$1e511d4a378977f5;
var $58a5c1bcb38585ff$export$2e2bcd8739ae039;
"use strict";
$58a5c1bcb38585ff$export$1e511d4a378977f5 = true;
$58a5c1bcb38585ff$export$2e2bcd8739ae039 = void 0;

var $euxye = parcelRequire("euxye");

var $2tvVX = parcelRequire("2tvVX");
var $58a5c1bcb38585ff$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $58a5c1bcb38585ff$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $2tvVX.defaultOptions;
    if (config === void 0) config = $2tvVX.defaultConfig;
    if (props === void 0) props = $2tvVX.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $euxye.useState)();
    var observer = (0, $euxye.useRef)();
    var inViewportRef = (0, $euxye.useRef)(false);
    var intersected = (0, $euxye.useRef)(false);
    var enterCountRef = (0, $euxye.useRef)(0);
    var leaveCountRef = (0, $euxye.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $euxye.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $euxye.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $euxye.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $58a5c1bcb38585ff$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $58a5c1bcb38585ff$var$_default = $58a5c1bcb38585ff$export$2e2bcd8739ae039 = $58a5c1bcb38585ff$var$useInViewport;

});
parcelRegister("2tvVX", function(module, exports) {
$parcel$export(module.exports, "noop", () => $1cd70f9219935fec$export$8793edee2d425525, (v) => $1cd70f9219935fec$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $1cd70f9219935fec$export$9c21a3269931e1e6, (v) => $1cd70f9219935fec$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $1cd70f9219935fec$export$ba43bf67f3d48107, (v) => $1cd70f9219935fec$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $1cd70f9219935fec$export$f84bd70098573c5c, (v) => $1cd70f9219935fec$export$f84bd70098573c5c = v);
var $1cd70f9219935fec$export$1e511d4a378977f5;
var $1cd70f9219935fec$export$8793edee2d425525;
var $1cd70f9219935fec$export$9c21a3269931e1e6;
var $1cd70f9219935fec$export$ba43bf67f3d48107;
var $1cd70f9219935fec$export$f84bd70098573c5c;
"use strict";
$1cd70f9219935fec$export$1e511d4a378977f5 = true;
$1cd70f9219935fec$export$8793edee2d425525 = $1cd70f9219935fec$export$9c21a3269931e1e6 = $1cd70f9219935fec$export$ba43bf67f3d48107 = $1cd70f9219935fec$export$f84bd70098573c5c = void 0;
var $1cd70f9219935fec$var$defaultOptions = $1cd70f9219935fec$export$ba43bf67f3d48107 = {};
var $1cd70f9219935fec$var$defaultConfig = $1cd70f9219935fec$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $1cd70f9219935fec$var$noop = ()=>{};
$1cd70f9219935fec$export$8793edee2d425525 = $1cd70f9219935fec$var$noop;
var $1cd70f9219935fec$var$defaultProps = $1cd70f9219935fec$export$9c21a3269931e1e6 = {
    onEnterViewport: $1cd70f9219935fec$var$noop,
    onLeaveViewport: $1cd70f9219935fec$var$noop
};

});




parcelRegister("5R7RH", function(module, exports) {
$parcel$export(module.exports, "TrackMount", () => $b70ac4e3a2477305$export$21b400a8c8ebc91a);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $b70ac4e3a2477305$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $euxye.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$b70ac4e3a2477305$export$21b400a8c8ebc91a.displayName = "TrackMount";

});



parcelRegister("7BZpb", function(module, exports) {
$parcel$export(module.exports, "StableSubscriptionConfigProvider", () => $32ed823579e96215$export$d870bd1cf2974c88);
$parcel$export(module.exports, "useSubscriptionConfig", () => $32ed823579e96215$export$1129f1fe63b2d7ab);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $32ed823579e96215$var$SubscriptionConfigContext = /*#__PURE__*/ (0, $euxye.createContext)({
    subscription: undefined
});
const $32ed823579e96215$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $euxye.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($32ed823579e96215$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
$32ed823579e96215$export$d870bd1cf2974c88.displayName = "StableSubscriptionConfigProvider";
const $32ed823579e96215$export$1129f1fe63b2d7ab = ()=>{
    return (0, $euxye.useContext)($32ed823579e96215$var$SubscriptionConfigContext);
};

});


parcelRegister("2bKWE", function(module, exports) {
$parcel$export(module.exports, "isClientTriggeredMessage", () => $e6369489fc5fb75c$export$21c420c0c257c346);
const $e6369489fc5fb75c$export$21c420c0c257c346 = (triggerType)=>{
    if (!triggerType) return false;
    return triggerType === 'gasV3' || triggerType === 'poTrigger';
};

});

parcelRegister("koLgf", function(module, exports) {
$parcel$export(module.exports, "createPlacementComponentV2", () => $8e03ce941fd27f6b$export$baf3e7aff0bbcf43);

var $e79Pd = parcelRequire("e79Pd");

var $lRYAe = parcelRequire("lRYAe");

var $3YKjt = parcelRequire("3YKjt");
var $j142y = parcelRequire("j142y");
var $hCvtI = parcelRequire("hCvtI");
var $khHng = parcelRequire("khHng");

var $62BGq = parcelRequire("62BGq");
var $3HcP9 = parcelRequire("3HcP9");

var $3oVpu = parcelRequire("3oVpu");

var $euxye = parcelRequire("euxye");
const $8e03ce941fd27f6b$export$71ff7382870ef1b0 = 'create-placement-component';
const $8e03ce941fd27f6b$export$66305c2a07eec241 = (placementId, Component, options)=>(0, $3oVpu.withErrorBoundary)(/*#__PURE__*/ (0, $euxye.memo)((props)=>{
        const providedContext = (0, $j142y.usePostOfficeContext)();
        const route = (0, $hCvtI.usePostOfficeRoute)();
        const stableContext = (0, $khHng.useStableObject)(props?.context ?? providedContext);
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (options?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $lRYAe.isIsolatedCloud)()) return null;
        const { onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const context = props?.context ?? providedContext;
        if ((0, $3YKjt.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $62BGq.PerformanceTrackingSegment), {
            placementId: placementId,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $62BGq.PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3HcP9.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: options?.choreographer,
                    subscription: options?.subscription,
                    subscriptionAdapter: options?.subscriptionAdapter,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    }));
const $8e03ce941fd27f6b$export$baf3e7aff0bbcf43 = (placementId, Component, options)=>{
    const placement = $8e03ce941fd27f6b$export$66305c2a07eec241(placementId, Component, options);
    return /*#__PURE__*/ (0, $euxye.memo)((props)=>{
        return placement({
            ...props,
            errorBoundaryLocation: $8e03ce941fd27f6b$export$71ff7382870ef1b0,
            placementId: placementId,
            fallbackRender: ()=>null
        });
    });
};

});
parcelRegister("3YKjt", function(module, exports) {
$parcel$export(module.exports, "isPostOfficePlacementsGloballyDisabled", () => $37daec28ad60d0b9$export$be54ac815726b4bd);

var $egspI = parcelRequire("egspI");
const $37daec28ad60d0b9$export$be54ac815726b4bd = (context)=>{
    const isGlobalDisablePlacementCheckEnabled = (0, $egspI.fg)('post-office-enable-disable-placement-check');
    if (isGlobalDisablePlacementCheckEnabled) return context.disableAllPlacements === true;
    return false;
};

});

parcelRegister("62BGq", function(module, exports) {
$parcel$export(module.exports, "PerformanceTracking", () => $3975e25d81b3614b$export$9a335a42ce02bdb8);
$parcel$export(module.exports, "PerformanceTrackingSegment", () => $3975e25d81b3614b$export$b35129264a401b3c);

var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $bDiVY = parcelRequire("bDiVY");

var $euxye = parcelRequire("euxye");

var $5R7RH = parcelRequire("5R7RH");

var $dgciF = parcelRequire("dgciF");
const $3975e25d81b3614b$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $euxye.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $4LDqh.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $dgciF.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bDiVY.UFOv2).UFOLoadHold, {
                name: (0, $bDiVY.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5R7RH.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $3975e25d81b3614b$export$b35129264a401b3c = /*#__PURE__*/ (0, $euxye.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $4LDqh.default).checkGate('post_office_update_ufov2_placements');
    /**
		 * If feature gate is not enabled, then we just return the children without the
		 * UFO segments attached.
		 */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bDiVY.UFOv2).UFOSegment, {
        name: (0, $bDiVY.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bDiVY.UFOv2).UFOSegment, {
            name: `${(0, $bDiVY.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});

});
parcelRegister("dgciF", function(module, exports) {
$parcel$export(module.exports, "usePerformanceTracking", () => $cad3a2ddfc87f4dd$export$317d52099614f316);

var $euxye = parcelRequire("euxye");
const $cad3a2ddfc87f4dd$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    // Initialise to true only if there's a Promise to await, avoiding an unnecessary UFO hold on mount.
    const [isLoading, setIsLoading] = (0, $euxye.useState)(initialData !== undefined);
    const onMount = (0, $euxye.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $euxye.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $euxye.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("3HcP9", function(module, exports) {
$parcel$export(module.exports, "StableProviders", () => $87e2bc054a640c7d$export$2b6596bcb1383a71);

var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $e3p4m = parcelRequire("e3p4m");

var $31Wbs = parcelRequire("31Wbs");

var $iMsV9 = parcelRequire("iMsV9");

var $2FxKA = parcelRequire("2FxKA");

var $QCDui = parcelRequire("QCDui");

var $7BZpb = parcelRequire("7BZpb");

var $gIJQ2 = parcelRequire("gIJQ2");

var $62BGq = parcelRequire("62BGq");
/**
 * Feature gate name for GraphQL subscriptions in Post Office placements.
 * When disabled, subscriptions will not be enabled even if configured.
 */ // https://switcheroo.atlassian.com/ui/gates/8299833f-7cf4-453b-bd5b-16f3bcf81ddb/key/post-office_graphql_subscriptions_enabled
const $87e2bc054a640c7d$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE = 'post-office_graphql_subscriptions_enabled';
/**
 * Optional provider that wraps subscription providers only if feature gate is enabled.
 */ const $87e2bc054a640c7d$var$OptionalPostOfficeSubscriptionsProvider = ({ children: children, subscription: subscription })=>{
    const isPostOfficeSubscriptionsFeatureGateEnabled = (0, $4LDqh.default).checkGate($87e2bc054a640c7d$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE);
    if (isPostOfficeSubscriptionsFeatureGateEnabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7BZpb.StableSubscriptionConfigProvider), {
        subscription: subscription,
        children: children
    });
    return children;
};
$87e2bc054a640c7d$var$OptionalPostOfficeSubscriptionsProvider.displayName = "OptionalPostOfficeSubscriptionsProvider";
const $87e2bc054a640c7d$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2FxKA.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $QCDui.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gIJQ2.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $31Wbs.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)($87e2bc054a640c7d$var$OptionalPostOfficeSubscriptionsProvider, {
                        subscription: subscription,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iMsV9.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e3p4m.RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
$87e2bc054a640c7d$export$2b6596bcb1383a71.displayName = "StableProviders";

});
parcelRegister("e3p4m", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerProvider", () => $bcbf5239ea8cb5df$export$2d84fd9af6c9e378);

var $e79Pd = parcelRequire("e79Pd");

var $fGrpH = parcelRequire("fGrpH");

var $euxye = parcelRequire("euxye");

var $7BZpb = parcelRequire("7BZpb");
/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $bcbf5239ea8cb5df$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $bcbf5239ea8cb5df$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const subscriptionConfig = (0, $7BZpb.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    (0, $euxye.useEffect)(()=>{
        if ($bcbf5239ea8cb5df$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement',
            attributes: {
                subscriptionEnabled: subscriptionEnabled
            }
        });
    }, [
        fireAnalyticsEvent,
        placementId,
        subscriptionEnabled
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$bcbf5239ea8cb5df$export$2d84fd9af6c9e378.displayName = "RenderTrackerProvider";

});

parcelRegister("31Wbs", function(module, exports) {
$parcel$export(module.exports, "StableAnaltyicsProvider", () => $2726edd3d199d17d$export$5a66cdc9893b43e);

var $e79Pd = parcelRequire("e79Pd");

var $5ySJg = parcelRequire("5ySJg");
const $2726edd3d199d17d$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "2c64b2371c21ed81d0b2ca392c0baa1556488d6a",
            b: "17763378",
            t: undefined
        }
    }
};
const $2726edd3d199d17d$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5ySJg.PostOfficeAnalyticsContext), {
        data: $2726edd3d199d17d$var$postOfficeAnalyticsContextData,
        children: children
    });
};
$2726edd3d199d17d$export$5a66cdc9893b43e.displayName = "StableAnaltyicsProvider";

});

parcelRegister("2FxKA", function(module, exports) {
$parcel$export(module.exports, "StableContextProvider", () => $26e01174895b52b5$export$d4982c0a28b18f63);

var $e79Pd = parcelRequire("e79Pd");

var $j142y = parcelRequire("j142y");
var $khHng = parcelRequire("khHng");

var $1o7Ue = parcelRequire("1o7Ue");
const $26e01174895b52b5$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $khHng.useStableObject)({
        ...(0, $1o7Ue.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j142y.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};
$26e01174895b52b5$export$d4982c0a28b18f63.displayName = "StableContextProvider";

});
parcelRegister("1o7Ue", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $e360ef725b2baa24$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $e360ef725b2baa24$export$71ff7382870ef1b0);
const $e360ef725b2baa24$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $e360ef725b2baa24$export$71ff7382870ef1b0 = 'create-placement-component';

});


parcelRegister("QCDui", function(module, exports) {
$parcel$export(module.exports, "StablePlacementProvider", () => $6618ac2263289317$export$e9fd288527498af6);

var $e79Pd = parcelRequire("e79Pd");

var $khHng = parcelRequire("khHng");

var $fslfv = parcelRequire("fslfv");
const $6618ac2263289317$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $khHng.useStableObject)(placement);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fslfv.PlacementProvider), {
        value: stableValue,
        children: children
    });
};
$6618ac2263289317$export$e9fd288527498af6.displayName = "StablePlacementProvider";

});

parcelRegister("gIJQ2", function(module, exports) {
$parcel$export(module.exports, "StableRouteProvider", () => $913b0b650945251c$export$ce13d00e696dfc96);

var $e79Pd = parcelRequire("e79Pd");

var $hCvtI = parcelRequire("hCvtI");
var $khHng = parcelRequire("khHng");

var $dO7bh = parcelRequire("dO7bh");
const $913b0b650945251c$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $dO7bh.useLocationHref)();
    const stableRoute = (0, $khHng.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hCvtI.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};
$913b0b650945251c$export$ce13d00e696dfc96.displayName = "StableRouteProvider";

});
parcelRegister("dO7bh", function(module, exports) {
$parcel$export(module.exports, "useLocationHref", () => $3c62dd3ef98c2c2d$export$49fc3f3d8c7f99);
const $3c62dd3ef98c2c2d$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $3c62dd3ef98c2c2d$export$49fc3f3d8c7f99 = ()=>{
    return $3c62dd3ef98c2c2d$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("3oVpu", function(module, exports) {
$parcel$export(module.exports, "withErrorBoundary", () => $ad752026357dfe83$export$f0c7a449e0cfaec7);

var $e79Pd = parcelRequire("e79Pd");


var $fGrpH = parcelRequire("fGrpH");

var $jB0d6 = parcelRequire("jB0d6");
const $ad752026357dfe83$export$f0c7a449e0cfaec7 = (Component)=>(props)=>{
        const { errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, messageTemplateId: messageTemplateId, fallbackRender: fallbackRender, onError: onError } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId,
                    messageTemplateId: additionalAnalytics.messageTemplateId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $e79Pd.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jB0d6.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId,
                messageTemplateId: messageTemplateId
            }, onError),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                ...props
            })
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

parcelRegister("jB0d6", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $e441a2cff34079ac$export$e926676385687eaf);

var $euxye = parcelRequire("euxye");
'use client';
const $e441a2cff34079ac$export$b16d9fb1a22de840 = (0, $euxye.createContext)(null);
const $e441a2cff34079ac$var$initialState = {
    didCatch: false,
    error: null
};
class $e441a2cff34079ac$export$e926676385687eaf extends (0, $euxye.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $e441a2cff34079ac$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($e441a2cff34079ac$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $e441a2cff34079ac$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($e441a2cff34079ac$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $euxye.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $euxye.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $euxye.createElement)($e441a2cff34079ac$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $e441a2cff34079ac$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $e441a2cff34079ac$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $e441a2cff34079ac$export$c052f6604b7d51fe() {
    const context = (0, $euxye.useContext)($e441a2cff34079ac$export$b16d9fb1a22de840);
    $e441a2cff34079ac$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $euxye.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $euxye.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $e441a2cff34079ac$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $euxye.forwardRef)((props, ref)=>(0, $euxye.createElement)($e441a2cff34079ac$export$e926676385687eaf, errorBoundaryProps, (0, $euxye.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});



parcelRegister("GUJN3", function(module, exports) {
$parcel$export(module.exports, "createDefaultPlacementMiddleware", () => $1fe3ee97ef602ce1$export$a815601a0de834af);
$parcel$export(module.exports, "defaultPlacementMiddleware", () => $1fe3ee97ef602ce1$export$c4652643d257c65);
$parcel$export(module.exports, "flattenMessagesForFrontend", () => (parcelRequire("kiRQw")).flattenMessagesForFrontend);

var $kiRQw = parcelRequire("kiRQw");
const $1fe3ee97ef602ce1$export$a815601a0de834af = (execute)=>(params)=>async ({ request: request, koa: koa, postOffice: postOffice, placement: placement })=>{
            try {
                const result = await execute({
                    request: request,
                    koa: koa,
                    postOffice: postOffice,
                    placement: placement,
                    params: params
                });
                koa.ctx.body = result;
                koa.ctx.status = 200;
            } catch (error) {
                request.logger.error({
                    error: error
                }, 'placement middleware error');
                koa.ctx.status = 500;
                koa.ctx.body = {
                    message: 'An error occurred'
                };
            }
        };
const $1fe3ee97ef602ce1$export$c4652643d257c65 = $1fe3ee97ef602ce1$export$a815601a0de834af(async ({ postOffice: postOffice })=>{
    const result = await postOffice.messagesRuntime();
    $1fe3ee97ef602ce1$export$af2103662bc91e89(result);
    return {
        ...result.data,
        messages: (0, $kiRQw.flattenMessagesForFrontend)(result.data.messages)
    };
});
const $1fe3ee97ef602ce1$export$af2103662bc91e89 = ({ errors: errors, data: data })=>{
    const { messages: messages } = data;
    if (!(messages.length > 1)) return;
    const uniqueErrorIds = new Set(errors.map((e)=>e?.messageTemplateId ?? 'unknown'));
    const uniqueMessageIds = new Set(messages.map((e)=>e.messageTemplateId));
    if (uniqueErrorIds.size > 1 && uniqueMessageIds.size / uniqueMessageIds.size > 0.1) // Better error required
    throw new Error('too many message template errors');
};

});
parcelRegister("kiRQw", function(module, exports) {
$parcel$export(module.exports, "flattenMessagesForFrontend", () => $63294ba82238bb32$export$e578dffc38a1382b);
const $63294ba82238bb32$export$45bce7b2197b989e = ({ context: context, ...message })=>({
        ...message,
        ...context
    });
const $63294ba82238bb32$export$e578dffc38a1382b = (messages)=>messages.map($63294ba82238bb32$export$45bce7b2197b989e);

});


parcelRegister("fvahW", function(module, exports) {
$parcel$export(module.exports, "MissingPlacementIdError", () => $0fcd25691812708e$export$7680abc1ce949430);
$parcel$export(module.exports, "PlacementSystemError", () => $0fcd25691812708e$export$3d5f437b74b20d52);
$parcel$export(module.exports, "PlacementMessageError", () => $0fcd25691812708e$export$8a38dc1cb159944a);
$parcel$export(module.exports, "createPlacementMessageError", () => $0fcd25691812708e$export$ee31fecb3809975f);
$parcel$export(module.exports, "handlePlacementMessageError", () => $0fcd25691812708e$export$6536fa2f9f327746);
$parcel$export(module.exports, "handlePlacementError", () => $0fcd25691812708e$export$fac04fc2e7d95393);
$parcel$export(module.exports, "handlePlacementRuntimeError", () => $0fcd25691812708e$export$146aabc04248e280);
$parcel$export(module.exports, "handlePlacementMiddlewareError", () => $0fcd25691812708e$export$e644214358a6da92);

var $jnJcP = parcelRequire("jnJcP");
class $0fcd25691812708e$export$7680abc1ce949430 extends Error {
    static{
        this.message = "createPlacementBackend requires a non-empty placementId. DefaultHeadlessPlacementBackend only provides createMessageBackend and useDefaultMessageBackend. The production placement (with the correct placementId) is created at install time by the CLI.";
    }
    constructor(){
        super($0fcd25691812708e$export$7680abc1ce949430.message);
        this.name = 'MissingPlacementIdError';
    }
}
class $0fcd25691812708e$export$3d5f437b74b20d52 extends (0, $jnJcP.PostOfficeError) {
    constructor(params){
        const message = params.message ?? params.error?.message ?? 'unknown placement system error';
        const code = params.code ?? (0, $jnJcP.PostOfficeErrorCodes).PlacementSystemError;
        super(message, code);
        this.name = params.error?.name ?? this.constructor.name;
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
}
class $0fcd25691812708e$export$8a38dc1cb159944a extends $0fcd25691812708e$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement message error',
            code: (0, $jnJcP.PostOfficeErrorCodes).PlacementMessageError
        });
    }
}
class $0fcd25691812708e$export$321382f6614c450c extends $0fcd25691812708e$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement error',
            code: (0, $jnJcP.PostOfficeErrorCodes).PlacementError
        });
    }
}
class $0fcd25691812708e$export$c8e5ef21fa31d723 extends $0fcd25691812708e$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement runtime error',
            code: (0, $jnJcP.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
}
class $0fcd25691812708e$export$20e3e1204742e375 extends $0fcd25691812708e$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement middleware error',
            code: (0, $jnJcP.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
}
const $0fcd25691812708e$export$33fc68e75ae0d686 = (errorType)=>(error)=>{
        if (error instanceof errorType) return new errorType({
            ...error,
            error: error
        });
        if (error instanceof Error) return new errorType({
            error: error
        });
        return new errorType({});
    };
const $0fcd25691812708e$export$ee31fecb3809975f = $0fcd25691812708e$export$33fc68e75ae0d686($0fcd25691812708e$export$3d5f437b74b20d52);
const $0fcd25691812708e$export$6536fa2f9f327746 = (request)=>(error)=>$0fcd25691812708e$export$795c072ee2f403d0(request)($0fcd25691812708e$export$ee31fecb3809975f(error));
const $0fcd25691812708e$export$72b956efef19a76d = $0fcd25691812708e$export$33fc68e75ae0d686($0fcd25691812708e$export$3d5f437b74b20d52);
const $0fcd25691812708e$export$fac04fc2e7d95393 = (request)=>(error)=>$0fcd25691812708e$export$795c072ee2f403d0(request)($0fcd25691812708e$export$72b956efef19a76d(error));
const $0fcd25691812708e$export$8fe51a926669e297 = $0fcd25691812708e$export$33fc68e75ae0d686($0fcd25691812708e$export$3d5f437b74b20d52);
const $0fcd25691812708e$export$76f72ccfbe960ca1 = (request)=>(error)=>$0fcd25691812708e$export$795c072ee2f403d0(request)($0fcd25691812708e$export$8fe51a926669e297(error));
const $0fcd25691812708e$export$149a31b9f5a4a9c2 = $0fcd25691812708e$export$33fc68e75ae0d686($0fcd25691812708e$export$c8e5ef21fa31d723);
const $0fcd25691812708e$export$146aabc04248e280 = (request)=>(error)=>$0fcd25691812708e$export$795c072ee2f403d0(request)($0fcd25691812708e$export$149a31b9f5a4a9c2(error));
const $0fcd25691812708e$export$572d500120860974 = $0fcd25691812708e$export$33fc68e75ae0d686($0fcd25691812708e$export$20e3e1204742e375);
const $0fcd25691812708e$export$e644214358a6da92 = (request)=>(error)=>$0fcd25691812708e$export$795c072ee2f403d0(request)($0fcd25691812708e$export$572d500120860974(error));
const $0fcd25691812708e$export$795c072ee2f403d0 = (request)=>(error)=>{
        request.logger.error({
            message: error.message,
            cause: error.cause,
            name: error.name,
            stack: error.stack,
            placementLevel: error.placementLevel
        });
        return error;
    };

});
parcelRegister("jnJcP", function(module, exports) {
$parcel$export(module.exports, "PostOfficeErrorCodes", () => $618406d2f255865c$export$b9722560029694e7);
$parcel$export(module.exports, "PostOfficeError", () => $618406d2f255865c$export$d145ea5319863172);
$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $618406d2f255865c$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $618406d2f255865c$export$3dfc27a8d3942f4d);
var $618406d2f255865c$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["RetryableAtlassianMailError"] = "RetryableAtlassianMailError";
    PostOfficeErrorCodes["RetryableMobileNotificationsError"] = "RetryableMobileNotificationsError";
    PostOfficeErrorCodes["RecipientExpanderError"] = "RecipientExpanderError";
    PostOfficeErrorCodes["RetryableTCSError"] = "RetryableTCSError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    PostOfficeErrorCodes["PostOfficeGraphQLError"] = "PostOfficeGraphQLError";
    PostOfficeErrorCodes["NotificationRollupConflictError"] = "NotificationRollupConflictError";
    return PostOfficeErrorCodes;
}({});
class $618406d2f255865c$export$46f86d28cd0a5d38 extends Error {
}
class $618406d2f255865c$export$627bc00a5ef5f6ae extends Error {
}
class $618406d2f255865c$export$66e065cfeb491a4d extends $618406d2f255865c$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
    static is(value) {
        return value instanceof $618406d2f255865c$export$66e065cfeb491a4d;
    }
}
class $618406d2f255865c$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
class $618406d2f255865c$export$69be53c018c89481 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, details){
        super(message, "PostOfficeGraphQLError");
        this.name = this.constructor.name;
        this.clientName = details.clientName;
        this.operationName = details.operationName;
        this.status = details.status;
        this.graphQLErrorMessage = details.graphQLErrorMessage;
        this.errors = details.errors;
        this.sanitisedRequestHeaders = details.sanitisedRequestHeaders;
        this.sanitisedResponseHeaders = details.sanitisedResponseHeaders;
        this.responseBody = details.responseBody;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$6452976adc01572 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(cause, code){
        super($618406d2f255865c$var$getErrorMessage(cause), code, cause);
        this.name = this.constructor.name;
    }
}
const $618406d2f255865c$var$getErrorMessage = (cause)=>{
    if (cause instanceof Error) return cause.message;
    if (typeof cause === 'string') return cause;
    return 'Unknown error';
};
function $618406d2f255865c$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $618406d2f255865c$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $618406d2f255865c$export$ed601cd0dc1a1be7 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(args){
        /**
		 * It is expected that this error message can be not deterministic.
		 * This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		 * Showing the error cause helps them understand what was the problem with their payload.
		 *
		 * On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		 * to distinguish between message makers code errors and platform errors,
		 * but we don't rely on the error message itself.
		 */ const errMessage = args.cause instanceof Error ? args.cause.message : 'Error in message template code';
        super(errMessage, "MessageTemplateError", args.cause);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$2833d4759f81601b extends $618406d2f255865c$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = 'Invalid CSS property could not be processed by Juice';
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$8d39b103586e9fd4 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$f649da38897d27f7 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$c2852c1c4d9aba3e extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$4b7b4e09547e4bb3 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$360a094a97597d87 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$4d068b43eb55165b extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$ac007ee150add337 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$19cb89dd679394cb extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$78651662ad470cc5 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$8a5041670cdd8db2 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(journeyId){
        super('Journey not found', "JourneyNotFoundError"), this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$1240ddc25cf964e6 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$3c4884b7ae7fe517 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$913b8e68dc7ae8fe extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$3dfc27a8d3942f4d extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$e5ccdf8bbfead7a2 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$823733742d803ae6 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$1caa32527f23acd2 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$a6f2aad8fa094b39 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$2296e5dc6a1bf3d2 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Gateway timeout occurred', "GatewayTimeoutError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$2f1e27130c2bf271 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$d0dc094613469f2b extends $618406d2f255865c$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$5603eab37ce562f5 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$e0e9aa0e9c6b37ff extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$3ad818f64601e141 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$25470bb6cba4fba0 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$ce14d445679448b6 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $618406d2f255865c$export$c9a26a17db1045c8 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$8ab4fb362168b928 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$2afd69f57fe5285f extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$7635d2b1a281d626 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$9e1c6d00e675bc86 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$6d1a4929f6ff1a32 extends $618406d2f255865c$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $618406d2f255865c$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.message = message, this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $618406d2f255865c$export$c504492f06c975b5 extends $618406d2f255865c$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$1c932b9d1680ee0b extends $618406d2f255865c$export$d145ea5319863172 {
    constructor(message, code, cause){
        super(message, code, cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$5d5d1885c87ef4bc extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $618406d2f255865c$export$85497ede72633b85 extends $618406d2f255865c$export$1c932b9d1680ee0b {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Recipient Expander Error: ${message}`, "RecipientExpanderError", error);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
}
class $618406d2f255865c$export$359a331da49d1ec8 extends $618406d2f255865c$export$5d5d1885c87ef4bc {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Unretryable Recipient Expander Error: ${message}`, {
            cause: error
        });
        this.name = this.constructor.name;
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
}
class $618406d2f255865c$export$c2cfe2317dcfcabb extends Error {
    constructor(deliveryChannel){
        super('Duplicate message detected'), this.deliveryChannel = deliveryChannel;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
    get nonSensitiveFields() {
        return {
            deliveryChannel: this.deliveryChannel
        };
    }
}
const $618406d2f255865c$export$fec3468114498229 = (value)=>typeof value === 'object' && value !== null && // Enforce the primitive-only shape at runtime: a nested object could smuggle in PII/UGC that the
    // serializer would then merge verbatim into the logs. Fields that fail this are dropped, not logged.
    Object.values(value).every((field)=>field === undefined || field === null || typeof field === 'string' || typeof field === 'number' || typeof field === 'boolean');

});


parcelRegister("8hQRz", function(module, exports) {
$parcel$export(module.exports, "defaultMessageBackend", () => $b99b12404a01e551$export$ed649b7c8ee8dc84);
$parcel$export(module.exports, "noValidation", () => $b99b12404a01e551$export$3f7a3f360cb80be4);

var $iGhXx = parcelRequire("iGhXx");
const $b99b12404a01e551$export$ed649b7c8ee8dc84 = ()=>({
        transformMetadata: {
            validate: $b99b12404a01e551$export$3f7a3f360cb80be4(),
            stage: (0, $iGhXx.defaultTransformMetadata)
        }
    });
const $b99b12404a01e551$export$3f7a3f360cb80be4 = (_valueWithType)=>(input)=>input;

});
parcelRegister("iGhXx", function(module, exports) {
$parcel$export(module.exports, "defaultTransformMetadata", () => $94fb754f3bc47f3a$export$d56f9d28855034df);
const $94fb754f3bc47f3a$export$d56f9d28855034df = ()=>({
        goalMetadata: {
            primaryGoal: {
                goalId: 'clickthrough'
            }
        }
    });

});


parcelRegister("hSnUm", function(module, exports) {
$parcel$export(module.exports, "messageTimedStage", () => $c0f6ea5a1e34d88e$export$ef814b969fe01b12);
$parcel$export(module.exports, "placementTimedStage", () => $c0f6ea5a1e34d88e$export$d1ae1adf079f8144);
$parcel$export(module.exports, "placementRuntimeTimedStage", () => $c0f6ea5a1e34d88e$export$1119d982b61d8814);
$parcel$export(module.exports, "logRuntimeResult", () => $c0f6ea5a1e34d88e$export$79586cc267015801);

var $ifYoj = parcelRequire("ifYoj");
const $c0f6ea5a1e34d88e$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS = [
    25,
    50,
    100,
    150,
    200,
    250,
    500,
    1000
];
const $c0f6ea5a1e34d88e$var$timerName = 'post-office.placement-v2.stage.execute';
const $c0f6ea5a1e34d88e$var$counterName = 'post-office.placement-v2.stage.result';
const $c0f6ea5a1e34d88e$export$ceff3228f3d06831 = 'post-office_enable-unified-finish-logs';
const $c0f6ea5a1e34d88e$var$hasDelta = (tags)=>{
    if (!tags || typeof tags.delta !== 'object' || tags.delta === null) return false;
    const delta = tags.delta;
    // A delta exists when the message count has changed (messages were filtered or added)
    return typeof delta.number === 'number' && delta.number !== 0;
};
const $c0f6ea5a1e34d88e$var$createTimedStage = ({ tag: tag } = {})=>(stage)=>async (params)=>{
            const startTime = performance.now();
            const { stop: stop } = params.request.metrics.histogram($c0f6ea5a1e34d88e$var$timerName, $c0f6ea5a1e34d88e$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS, (0, $ifYoj.HIGH_CARDINALITY_METRIC_TAG_OVERRIDES)).measure();
            const result = stage(params);
            let tags;
            try {
                const unwrappedResult = result instanceof Promise ? await result : result;
                try {
                    tags = tag?.({
                        input: params,
                        output: unwrappedResult
                    });
                } catch  {
                    params.request.logger.warn('Unable to apply tags to stage logs');
                }
                params.request.metrics.counter($c0f6ea5a1e34d88e$var$counterName, {
                    status: 'success'
                }).incr();
                return unwrappedResult;
            } catch (error) {
                params.request.metrics.counter($c0f6ea5a1e34d88e$var$counterName, {
                    status: 'error'
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                const isGateEnabled = params.request.statsig.checkGate({
                    identifiers: {
                        tenantId: params.request.orchestrationContext.tenantId ?? ''
                    }
                }, $c0f6ea5a1e34d88e$export$ceff3228f3d06831);
                // When gate is ON: suppress message-level stages (high-volume, low-value) and only emit
                // placement-level stages when messages were filtered (delta != 0). Metrics are always
                // recorded regardless. When gate is OFF: always emit (old behavior).
                const defaultShouldLog = tag !== undefined ? $c0f6ea5a1e34d88e$var$hasDelta : ()=>false;
                const shouldEmit = isGateEnabled ? defaultShouldLog(tags) : true;
                if (shouldEmit) // eslint-disable-next-line @atlassian/incredible/safe-logging-practices
                params.request.logger.info({
                    latencyInMs: latencyInMs,
                    ...tags
                }, 'Finished stage');
            }
        };
const $c0f6ea5a1e34d88e$var$createTimedSystemStage = (fn)=>(contexts)=>{
        return async (params)=>{
            const startTime = performance.now();
            const { stop: stop } = contexts.request.metrics.histogram($c0f6ea5a1e34d88e$var$timerName, $c0f6ea5a1e34d88e$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS, (0, $ifYoj.HIGH_CARDINALITY_METRIC_TAG_OVERRIDES)).measure();
            const result = fn(contexts)(params);
            try {
                const unwrappedResult = await result;
                contexts.request.metrics.counter($c0f6ea5a1e34d88e$var$counterName, {
                    status: 'success'
                }).incr();
                return unwrappedResult;
            } catch (error) {
                contexts.request.metrics.counter($c0f6ea5a1e34d88e$var$counterName, {
                    status: 'error'
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                contexts.request.logger.info({
                    latencyInMs: latencyInMs
                }, 'Finished stage');
            }
        };
    };
const $c0f6ea5a1e34d88e$export$ef814b969fe01b12 = $c0f6ea5a1e34d88e$var$createTimedStage({});
const $c0f6ea5a1e34d88e$export$d1ae1adf079f8144 = $c0f6ea5a1e34d88e$var$createTimedStage({
    tag: ({ input: input, output: output })=>{
        if (!output) return {};
        const inputMessageTemplateIdsSet = new Set(input.data.messages.map((message)=>message.messageTemplateId));
        const inputMessageTemplateIds = Array.from(inputMessageTemplateIdsSet.values());
        const outputMessageTemplateIdsSet = new Set(output.messages.map((message)=>message.messageTemplateId));
        const outputMessageTemplateIds = Array.from(outputMessageTemplateIdsSet.values());
        const deltaMessageTemplateIds = inputMessageTemplateIds.filter((id)=>!outputMessageTemplateIdsSet.has(id));
        const inputMessageInstanceIds = input.data.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId);
        const outputMessageInstanceIdsSet = new Set(output.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId));
        const outputMessageInstanceIds = Array.from(outputMessageInstanceIdsSet.values());
        const deltaMessageInstanceIds = inputMessageInstanceIds.filter((id)=>!outputMessageInstanceIdsSet.has(id));
        return {
            input: {
                number: input.data.messages.length,
                messageTemplateIds: inputMessageTemplateIds,
                messageInstanceIds: inputMessageInstanceIds
            },
            output: {
                number: output.messages.length,
                messageTemplateIds: outputMessageTemplateIds,
                messageInstanceIds: outputMessageInstanceIds
            },
            delta: {
                number: output.messages.length - input.data.messages.length,
                messageTemplateIds: deltaMessageTemplateIds,
                messageInstanceIds: deltaMessageInstanceIds
            }
        };
    }
});
const $c0f6ea5a1e34d88e$export$1119d982b61d8814 = $c0f6ea5a1e34d88e$var$createTimedSystemStage;
const $c0f6ea5a1e34d88e$export$79586cc267015801 = ({ request: request })=>({ result: result, latencyInMs: latencyInMs })=>{
        const errorMessageTemplateIds = Array.from(new Set(result.errors.map((e)=>e.messageTemplateId)).values());
        const messageTemplateIds = Array.from(new Set(result.data.messages.map((e)=>e.messageTemplateId)).values());
        const formattedMessages = result.data.messages.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCreationType: messageCreationType, messageCategory: messageCategory, triggerId: triggerId })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCreationType: messageCreationType,
                messageCategory: messageCategory,
                triggerId: triggerId
            }));
        const formattedErrorDetails = result.errors.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, reason: reason })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                reason: reason
            }));
        request.logger.info({
            latencyInMs: latencyInMs,
            errors: {
                number: result.errors.length,
                messageTemplateIds: errorMessageTemplateIds,
                messageDetails: formattedErrorDetails
            },
            messages: {
                number: result.data.messages.length,
                messageTemplateIds: messageTemplateIds,
                messageDetails: formattedMessages
            }
        }, 'Runtime result');
    };

});

parcelRegister("1wUjh", function(module, exports) {
$parcel$export(module.exports, "defaultBackendPlacementStages", () => $496f56cea11708a1$export$fc43c4563ceea5ce);

var $lXkfy = parcelRequire("lXkfy");

var $YBBxt = parcelRequire("YBBxt");
const $496f56cea11708a1$export$fc43c4563ceea5ce = ({ transformMetadata: transformMetadata, hydrate: hydrate })=>({
        init: (0, $YBBxt.applyTransformMetadata)(transformMetadata),
        postInit: (0, $lXkfy.applyHydrate)(hydrate)
    });

});
parcelRegister("lXkfy", function(module, exports) {
$parcel$export(module.exports, "applyHydrate", () => $a43e45808301ab5e$export$a505170ba4b7665a);

var $ho54X = parcelRequire("ho54X");
const $a43e45808301ab5e$export$a505170ba4b7665a = (hydrate)=>(0, $ho54X.Stages).maybe(hydrate);

});
parcelRegister("ho54X", function(module, exports) {
$parcel$export(module.exports, "Stages", () => $e4d40e2d36e0cbd7$export$908c35f258f55229);
const $e4d40e2d36e0cbd7$var$maybe = (stage)=>async (params)=>{
        return stage?.(params) ?? params.data;
    };
const $e4d40e2d36e0cbd7$var$mergeMetadata = (fn)=>{
    const applyMerge = (target, source)=>{
        {
            const sourceMap = Object.fromEntries(source.messages.map((message)=>[
                    message.messageInstanceId,
                    message
                ]));
            const messages = target.data.messages.map((message)=>fn(message, sourceMap?.[message.messageInstanceId]?.context));
            return {
                messages: messages
            };
        }
    };
    return applyMerge;
};
const $e4d40e2d36e0cbd7$export$908c35f258f55229 = {
    maybe: /**
	 * The `maybe` function creates a passthrough stage,
	 * which applies no changes, for cases where a stage might be undefined.
	 */ $e4d40e2d36e0cbd7$var$maybe,
    mergeMetadata: /**
	 * the `mergeMetadata` function is used when the result of a stage is
	 * used to modify the message payload outside the message context
	 */ $e4d40e2d36e0cbd7$var$mergeMetadata
};

});


parcelRegister("YBBxt", function(module, exports) {
$parcel$export(module.exports, "applyTransformMetadata", () => $35200fa7e690f6ad$export$e43f344828ec0e3);

var $ho54X = parcelRequire("ho54X");
const $35200fa7e690f6ad$export$e43f344828ec0e3 = (transformMetadata)=>async (params)=>{
        const transformedMetadata = await (0, $ho54X.Stages).maybe(transformMetadata)(params);
        const placementId = params?.request?.orchestrationContext?.placementId ?? 'no-placement-found';
        return (0, $ho54X.Stages).mergeMetadata((original, metadata)=>({
                ...original,
                enrichedAttributes: {
                    'in-app': {
                        [placementId]: metadata
                    }
                }
            }))(params, transformedMetadata);
    };

});


parcelRegister("gH56o", function(module, exports) {
$parcel$export(module.exports, "defaultBackendPlacementMessageStages", () => $afa8747dced15dfd$export$1c5532bd04c77e4b);
const $afa8747dced15dfd$export$1c5532bd04c77e4b = {
};

});

parcelRegister("3qNLG", function(module, exports) {
$parcel$export(module.exports, "useWaitForTrigger", () => $5cf4947eb18f0f57$export$b5884e72fa051e28);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $cxMk3 = parcelRequire("cxMk3");

var $eRwFj = parcelRequire("eRwFj");

var $iKPvC = parcelRequire("iKPvC");
/**
 * Component that calls messageInstanceViewed, renders messageSuccessComponent, and calls onShow callback once when mounted
 */ const $5cf4947eb18f0f57$var$OnChoreographerApproved = ({ children: children, onShow: onShow, messageSuccessComponent: messageSuccessComponent, additionalMetadataFromFrontend: additionalMetadataFromFrontend = {} })=>{
    const hasShownRef = (0, $euxye.useRef)(false);
    const { messageInstanceViewed: messageInstanceViewed } = (0, $iKPvC.useMessageInstanceEvent)();
    (0, $euxye.useEffect)(()=>{
        if (hasShownRef.current) return;
        hasShownRef.current = true;
        messageInstanceViewed(additionalMetadataFromFrontend);
        onShow?.();
    // Intentional empty deps: this effect must fire exactly once after the first commit.
    // The values captured here are the ones the caller passed at mount, which is the desired
    // "as of when the message was shown" semantic — if a caller subsequently passes a new
    // onShow or metadata, we should NOT fire again. Using non-empty deps would also cause
    // this effect to re-register on every render whenever a caller passes an unmemoized
    // `additionalMetadataFromFrontend={{ ... }}` literal, even though the body is a no-op
    // after first run. Strict-Mode double-invocation is still handled by hasShownRef.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            messageSuccessComponent,
            children
        ]
    });
};
$5cf4947eb18f0f57$var$OnChoreographerApproved.displayName = "OnChoreographerApproved";
const $5cf4947eb18f0f57$export$b5884e72fa051e28 = ({ hasTrigger: hasTrigger, messageSuccessComponent: messageSuccessComponent, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const waitForTriggerCalledRef = (0, $euxye.useRef)(false);
    // Create waitForTrigger function that wraps content with choreography
    const waitForTriggerCallback = (0, $euxye.useCallback)(({ isTriggerActive: isTriggerActive, messageContent: messageContent, onMessageShown: onMessageShown, additionalMetadataFromFrontend: additionalMetadataFromFrontend, onTeardown: onTeardown })=>{
        // Mark that this function was called
        waitForTriggerCalledRef.current = true;
        // If isTriggerActive is false, don't claim choreographer slot yet
        if (!isTriggerActive) return null;
        const messageContentWithOptionalTeardown = onTeardown !== undefined ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eRwFj.UnmountCleanup), {
            onCleanup: onTeardown,
            children: messageContent
        }) : messageContent;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxMk3.ChoreographerWrapper), {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($5cf4947eb18f0f57$var$OnChoreographerApproved, {
                onShow: onMessageShown,
                additionalMetadataFromFrontend: additionalMetadataFromFrontend,
                messageSuccessComponent: messageSuccessComponent,
                children: messageContentWithOptionalTeardown
            })
        });
    }, [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        messageSuccessComponent
    ]);
    const waitForTrigger = hasTrigger ? waitForTriggerCallback : undefined; // Non-triggered messages don't get this prop
    // Attach the ref to the function as a property
    if (waitForTrigger) waitForTrigger.__calledRef = waitForTriggerCalledRef;
    return {
        waitForTrigger: waitForTrigger
    };
};

});
parcelRegister("eRwFj", function(module, exports) {
$parcel$export(module.exports, "UnmountCleanup", () => $a43f1e309ec28cdb$export$ea970fe2c565070a);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1Heu1 = parcelRequire("1Heu1");
const $a43f1e309ec28cdb$export$ea970fe2c565070a = ({ onCleanup: onCleanup, children: children })=>{
    const onCleanupRef = (0, $euxye.useRef)(onCleanup);
    (0, $1Heu1.useLayoutEffect)(()=>{
        onCleanupRef.current = onCleanup;
    });
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            onCleanupRef.current?.();
        };
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$a43f1e309ec28cdb$export$ea970fe2c565070a.displayName = "UnmountCleanup";

});



parcelRegister("a5l9n", function(module, exports) {
$parcel$export(module.exports, "getSubscriptionMessages", () => $32f737c62d03b950$export$85c5c4dfb3b616b);
$parcel$export(module.exports, "usePlacementGraphQLSubscriptionApi", () => $32f737c62d03b950$export$e9b51d3d4f35f690);

var $euxye = parcelRequire("euxye");

var $fslfv = parcelRequire("fslfv");

var $7BZpb = parcelRequire("7BZpb");

var $hosII = parcelRequire("hosII");

var $4LDqh = parcelRequire("4LDqh");
const $32f737c62d03b950$export$45fcaadf17d42ce9 = 'post-office_enable_subscription-enrichment';
const $32f737c62d03b950$export$ac437297516aae60 = (dataFragments, options)=>{
    const subscriptionName = (0, $4LDqh.default).checkGate($32f737c62d03b950$export$45fcaadf17d42ce9) ? 'postOffice_onMessageReceivedEnriched' : 'postOffice_onMessageReceived';
    const variableDeclarations = [
        '$placementId: String!',
        '$product: String',
        '$workspaceAri: String',
        ...options?.includeActiveScopes ? [
            '$activeScopes: String'
        ] : [],
        ...options?.includePathname ? [
            '$pathname: String'
        ] : [],
        ...options?.includeContext ? [
            '$context: PostOfficeContextInput'
        ] : []
    ];
    const variableDeclarationsBlock = variableDeclarations.map((line)=>`\t${line}`).join('\n');
    const subscriptionArgs = [
        'placementId: $placementId',
        'product: $product',
        'workspaceAri: $workspaceAri',
        ...options?.includeActiveScopes ? [
            'activeScopes: $activeScopes'
        ] : [],
        ...options?.includePathname ? [
            'pathname: $pathname'
        ] : [],
        ...options?.includeContext ? [
            'context: $context'
        ] : []
    ];
    const subscriptionArgsBlock = subscriptionArgs.map((line)=>`\t\t${line}`).join('\n');
    const fragmentsBlock = dataFragments.map((fragment)=>`\t\t\t\t${fragment}`).join('\n');
    return `subscription PostOfficeOnMessageReceived(
${variableDeclarationsBlock}) {
	${subscriptionName}(
${subscriptionArgsBlock}) {
		messages {
			messageInstanceId
			messageTemplateId
			messageCategory
			createdAt
			eventTime
			triggerId
			messageCreationType
			recommendationSession {
				sessionId
				entityId
			}
			data {
${fragmentsBlock}
			}
		}
	}
}`;
};
const $32f737c62d03b950$export$85c5c4dfb3b616b = (data)=>{
    if (!data) return [];
    const payload = (0, $4LDqh.default).checkGate($32f737c62d03b950$export$45fcaadf17d42ce9) ? data['postOffice_onMessageReceivedEnriched'] : data['postOffice_onMessageReceived'];
    return payload?.messages ?? [];
};
/**
 * Type parameter TData lets the placement specify which PostOfficeMessageData variant it subscribes to.
 * This narrows `msg.data` in the returned messages, so you get proper typing without manual casting.
 *
 * @example
 * ```tsx
 * usePlacementGraphQLSubscriptionApi<PostOfficeMessageLiveNudgeDemoMessageData>({
 *   dataFragments: [LIVE_NUDGE_FRAGMENT],
 * });
 * // msg.data is now PostOfficeMessageLiveNudgeDemoMessageData | null
 * ```
 */ const $32f737c62d03b950$var$EMPTY_VARIABLES = {};
const $32f737c62d03b950$export$e9b51d3d4f35f690 = (options)=>{
    const { placementId: placementId } = (0, $fslfv.usePlacementContext)();
    const subscriptionConfig = (0, $7BZpb.useSubscriptionConfig)();
    const variables = options.variables ?? $32f737c62d03b950$var$EMPTY_VARIABLES;
    const includeActiveScopes = 'activeScopes' in variables;
    const includePathname = 'pathname' in variables;
    const includeContext = 'context' in variables;
    const subscription = (0, $euxye.useMemo)(()=>$32f737c62d03b950$export$ac437297516aae60(options.dataFragments, {
            includeActiveScopes: includeActiveScopes,
            includePathname: includePathname,
            includeContext: includeContext
        }), // eslint-disable-next-line react-hooks/exhaustive-deps -- subscription only changes when dataFragments content or optional variable flags change
    [
        options.dataFragments.join(),
        includeActiveScopes,
        includePathname,
        includeContext
    ]);
    return (0, $hosII.usePlacementSubscription)({
        subscription: subscription,
        placementId: placementId ?? undefined,
        subscriptionSettings: subscriptionConfig,
        variables: options.variables
    });
};

});
parcelRegister("hosII", function(module, exports) {
$parcel$export(module.exports, "usePlacementSubscription", () => $c98d3ec69783d22c$export$56d93bf73d94f4b2);

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $j142y = parcelRequire("j142y");

var $ln1b1 = parcelRequire("ln1b1");
const $c98d3ec69783d22c$export$827b8f70ff3c10d4 = 'post-office_nullified_subscription_variable_gate';
/**
 * Stable no-op adapter that returns an error state.
 * Used to satisfy Rules of Hooks when the real adapter is not available.
 * Uses `never` type since it never successfully returns data.
 */ const $c98d3ec69783d22c$var$noOpAdapter = {
    useSubscription: (_config)=>({
            status: 'error',
            data: null,
            error: new Error('No subscription adapter provided. Products must provide a subscription adapter via StableSubscriptionAdapterProvider.'),
            isLoading: false
        })
};
function $c98d3ec69783d22c$var$adapterResultToPlacementResult(adapterResult, isEnabledForLiveMessages) {
    return {
        data: adapterResult.data === null || adapterResult.data === undefined ? null : adapterResult.data,
        error: adapterResult.error,
        isLoading: adapterResult.isLoading,
        isEnabledForLiveMessages: isEnabledForLiveMessages
    };
}
const $c98d3ec69783d22c$export$56d93bf73d94f4b2 = (config)=>{
    const postOfficeContext = (0, $j142y.usePostOfficeContext)();
    const { subscriptionAdapter: subscriptionAdapter } = (0, $ln1b1.useSubscriptionAdapter)();
    const placementId = config.placementId;
    const subscriptionConfig = config.subscriptionSettings;
    const isEnabledForLiveMessages = subscriptionConfig?.subscription?.enabled ?? false;
    const isNullifiedSubscriptionVariableGateEnabled = (0, $egspI.fg)('post-office_nullified_subscription_variable_gate');
    const subscriptionVariables = (0, $euxye.useMemo)(()=>({
            placementId: placementId,
            cloudId: postOfficeContext?.tenantId,
            workspaceAri: isNullifiedSubscriptionVariableGateEnabled ? postOfficeContext?.workspaceAri ?? null : postOfficeContext?.workspaceAri,
            product: isNullifiedSubscriptionVariableGateEnabled ? postOfficeContext?.product ?? null : postOfficeContext?.product,
            activeScopes: isNullifiedSubscriptionVariableGateEnabled ? config.variables?.activeScopes ?? null : config.variables?.activeScopes,
            ...config.variables
        }), [
        placementId,
        postOfficeContext?.tenantId,
        postOfficeContext?.product,
        postOfficeContext?.workspaceAri,
        isNullifiedSubscriptionVariableGateEnabled,
        config.variables
    ]);
    const adapterConfig = (0, $euxye.useMemo)(()=>({
            subscription: config.subscription,
            variables: subscriptionVariables
        }), [
        config.subscription,
        subscriptionVariables
    ]);
    const effectiveAdapter = (0, $euxye.useMemo)(()=>subscriptionAdapter ?? $c98d3ec69783d22c$var$noOpAdapter, [
        subscriptionAdapter
    ]);
    const adapterResult = effectiveAdapter.useSubscription(adapterConfig);
    return (0, $euxye.useMemo)(()=>{
        if (!placementId) return {
            data: null,
            error: new Error('usePlacementSubscription must be used within a PlacementProvider with a valid placementId'),
            isLoading: false,
            isEnabledForLiveMessages: false
        };
        if (!isEnabledForLiveMessages) return {
            data: null,
            error: null,
            isLoading: false,
            isEnabledForLiveMessages: false
        };
        return $c98d3ec69783d22c$var$adapterResultToPlacementResult(adapterResult, true);
    }, [
        placementId,
        isEnabledForLiveMessages,
        adapterResult
    ]);
};

});


parcelRegister("gOhos", function(module, exports) {
$parcel$export(module.exports, "filterEligibleMessagesByActiveScopes", () => $c391a6664769ceba$export$947efa1b49bb2f1b);

var $a63ly = parcelRequire("a63ly");

var $8Lf1t = parcelRequire("8Lf1t");
async function $c391a6664769ceba$export$21f950bbeed19814(createFilterParams, sharedFilterParams) {
    const { activeScopes: activeScopes } = createFilterParams;
    return function executeFilter(message) {
        // @ts-expect-error - TODO: Update post-office/services/post-office/src/orchestration/service/implicit-message-processor.ts
        return $c391a6664769ceba$var$activeScopeCheckFilter(activeScopes, message, sharedFilterParams);
    };
}
const $c391a6664769ceba$export$4f9a24202c553a37 = (requestContext, { activeScopes: activeScopes })=>({
        execute: async (message, options)=>{
            return $c391a6664769ceba$var$activeScopeCheckFilter(activeScopes, message, {
                requestContext: requestContext,
                ...options.deps
            });
        }
    });
const $c391a6664769ceba$var$activeScopeCheckFilter = (activeScopes, message, sharedFilterParams)=>{
    const { logger: logger } = sharedFilterParams;
    // Skip filter for non-implicit messages — not part of the core scope check.
    if (message.messageCreationType !== 'implicit') return {
        result: (0, $a63ly.FilterResult).Skip,
        filterName: 'activeScopesCheckFilter'
    };
    // Message-specific guard: the message must declare its required scopes.
    if (!Array.isArray(message.context.scopes) || message.context.scopes.length === 0) return {
        result: (0, $a63ly.FilterResult).Deny,
        failureReason: `No scopes found for the message with messageInstanceId: ${message.messageInstanceId} and templateId: ${message.messageTemplateId}`,
        filterName: 'activeScopesCheckFilter'
    };
    const messageScopes = message.context.scopes;
    const result = (0, $8Lf1t.coreActiveScopesCheck)({
        activeScopes: activeScopes,
        requiredScopes: messageScopes,
        request: {
            logger: logger
        }
    });
    switch(result.outcome){
        case 'active':
            return {
                result: (0, $a63ly.FilterResult).Allow,
                filterName: 'activeScopesCheckFilter'
            };
        case 'no-active-scopes':
            return {
                result: (0, $a63ly.FilterResult).Deny,
                failureReason: 'Active scopes was not found in additional filter context. Make sure the placement is providing the activeScopes',
                filterName: 'activeScopesCheckFilter'
            };
        case 'excluded-scope':
            return {
                result: (0, $a63ly.FilterResult).Deny,
                failureReason: `Active scope matches excluded route: ${result.excludedScopes.join(', ')}`,
                filterName: 'activeScopesCheckFilter'
            };
        case 'no-required-scopes':
            return {
                result: (0, $a63ly.FilterResult).Deny,
                failureReason: `No scopes found for the message with messageInstanceId: ${message.messageInstanceId} and templateId: ${message.messageTemplateId}`,
                filterName: 'activeScopesCheckFilter'
            };
        case 'no-match':
            return {
                result: (0, $a63ly.FilterResult).Deny,
                failureReason: `The following scopes are not active: ${result.nonIntersectedScopes.join(', ')}`,
                filterName: 'activeScopesCheckFilter'
            };
        default:
            {
                // Exhaustiveness guard — if CoreActiveScopesCheckResult gains a new member,
                // the explicit return type above will surface a compile error here.
                const _exhaustive = result;
                _exhaustive;
                return {
                    result: (0, $a63ly.FilterResult).Deny,
                    failureReason: 'Unhandled scope check outcome',
                    filterName: 'activeScopesCheckFilter'
                };
            }
    }
};
const $c391a6664769ceba$export$947efa1b49bb2f1b = (messages, { activeScopes: activeScopes, requestContext: requestContext })=>{
    const { logger: logger } = requestContext;
    return messages.filter((message)=>{
        // Message-specific guard: the message must declare its required scopes.
        if (!Array.isArray(message.context.scopes) || message.context.scopes.length === 0) {
            logger.warn({
                messageInstanceId: message.messageInstanceId,
                messageTemplateId: message.messageTemplateId
            }, "activeScopesCheckFilter: denying message \u2014 no scopes defined on message");
            return false;
        }
        const messageScopes = message.context.scopes;
        const result = (0, $8Lf1t.coreActiveScopesCheck)({
            activeScopes: activeScopes,
            requiredScopes: messageScopes,
            request: {
                logger: logger
            }
        });
        return result.outcome === 'active';
    });
};

});
parcelRegister("a63ly", function(module, exports) {
$parcel$export(module.exports, "FilterResult", () => $ae7e893918a4384b$export$62c1563e8fa78f30);

var $2NSbF = parcelRequire("2NSbF");
const $ae7e893918a4384b$export$799f2caf9f0a48f9 = [
    5,
    10,
    25,
    50,
    100,
    150,
    200,
    250,
    500,
    1000
];
// https://switcheroo.atlassian.com/ui/gates/5ff82fe4-0e85-4521-8282-65d373d9607f/key/post-office_enable-new-filter-error
const $ae7e893918a4384b$var$ENABLE_NEW_FILTER_ERROR_FEATURE_GATE = 'post-office_enable-new-filter-error';
const $ae7e893918a4384b$var$RESOLVE_FILTER_NAME_FROM_FILTER_FEATURE_GATE = 'post-office_enable-resolve-filter-name-from-filter';
// https://switcheroo.atlassian.com/ui/gates/31b52f70-f1b6-4f61-a220-b2fb3b14f9b5/key/post-office_ignore-message-template-filter-errors
const $ae7e893918a4384b$var$IGNORE_MESSAGE_TEMPLATE_FILTER_ERRORS_FEATURE_GATE = 'post-office_ignore-message-template-filter-errors';
var $ae7e893918a4384b$export$62c1563e8fa78f30 = /*#__PURE__*/ function(FilterResult) {
    FilterResult["Allow"] = "allow";
    FilterResult["Deny"] = "deny";
    FilterResult["Skip"] = "skip";
    FilterResult["Fail"] = "fail";
    FilterResult["Defer"] = "defer";
    return FilterResult;
}({});
const $ae7e893918a4384b$export$cfa826fb2a249e25 = (response)=>{
    return {
        ...response,
        shouldSkip: (context)=>{
            const criteria = response.criteria;
            if (!criteria) return false;
            if (criteria.type === 'deliveryChannel') return context.deliveryChannel !== undefined && criteria.deliveryChannel !== context.deliveryChannel;
            if (criteria.type === 'placementId') return context.placementId !== undefined && criteria.placementId !== context.placementId;
            if (criteria.type === 'deliveryMethod') // if we ARE NOT currently evaluating a message that will be rolled up into a digest
            // ignore a digest enrolled preference response that relates to digests
            return context.deliveryMethod === undefined || criteria.deliveryMethod !== context.deliveryMethod;
            return false;
        },
        shouldBreakIfDeny: ()=>{
            return response.result === "deny";
        },
        shouldBreakIfFail: ()=>{
            return response.result === "fail";
        },
        hasRedactionLevel: ()=>{
            return response.redactionLevel !== undefined;
        }
    };
};
const $ae7e893918a4384b$var$REJECTED_FILTER_RESPONSE = {
    result: "fail",
    filterName: 'unknown',
    failureReason: 'Unknown error'
};
class $ae7e893918a4384b$export$d8ea20af4c01b9d9 extends Error {
    constructor(error, additionalInfo){
        super(error.message, {
            cause: error
        }), this.additionalInfo = additionalInfo;
        this.name = this.constructor.name;
    }
}
const $ae7e893918a4384b$var$shouldOverrideReturnedFilterName = (statsig, filter)=>{
    const filterName = $ae7e893918a4384b$export$e76cb762f8c4c3ef(filter);
    return statsig.checkGate({
        identifiers: {
            miscellaneousId: filterName
        }
    }, $ae7e893918a4384b$var$RESOLVE_FILTER_NAME_FROM_FILTER_FEATURE_GATE);
};
const $ae7e893918a4384b$var$resolveFilterNameForResponse = (response, filterName, shouldOverrideReturnedFilterNameForResponse)=>{
    const resolvedFilterName = shouldOverrideReturnedFilterNameForResponse ? filterName : response.filterName ?? filterName;
    return {
        ...response,
        filterName: resolvedFilterName
    };
};
const $ae7e893918a4384b$var$withResolvedFilterName = (filterResponses, filter, shouldOverrideReturnedFilterName = false)=>{
    const filterName = $ae7e893918a4384b$export$e76cb762f8c4c3ef(filter);
    if (Array.isArray(filterResponses)) return filterResponses.map((response)=>$ae7e893918a4384b$var$resolveFilterNameForResponse(response, filterName, shouldOverrideReturnedFilterName));
    return $ae7e893918a4384b$var$resolveFilterNameForResponse(filterResponses, filterName, shouldOverrideReturnedFilterName);
};
const $ae7e893918a4384b$export$e64ef7d458976170 = async (message, metrics, logger, statsig, additionalFilterContext, restApiClients, graphqlClients, tapProvider, executionRuntime)=>{
    const filters = message.messageTemplate.messageFilters;
    if (!Array.isArray(filters) || filters.length === 0) return [];
    const filterPromises = [];
    for (const filter of filters)// TODO: Look at improving this type validation and in filters-processor.ts
    if (typeof filter.execute === 'function') {
        const startTime = new Date().getTime();
        const promise = filter.execute(message, logger, {
            restApiClients: restApiClients,
            statsig: statsig,
            graphqlClients: graphqlClients,
            tapProvider: tapProvider,
            executionRuntime: executionRuntime
        }, additionalFilterContext, metrics).then((res)=>{
            return $ae7e893918a4384b$export$e315e6b8dddf819b($ae7e893918a4384b$var$withResolvedFilterName(res, filter, $ae7e893918a4384b$var$shouldOverrideReturnedFilterName(statsig, filter)), startTime, metrics);
        }).catch((err)=>{
            const useNewFilterErrorHandler = statsig.checkGate({
                identifiers: {
                    atlassianAccountId: message.recipient.type === 'AccountId' ? (0, $2NSbF.IdentityUserAri).parse(message.recipient.userAri).userId : 'unknown'
                }
            }, $ae7e893918a4384b$var$ENABLE_NEW_FILTER_ERROR_FEATURE_GATE);
            const ignoreMessageTemplateFilterFailures = statsig.checkGate({
                identifiers: {
                    atlassianAccountId: message.recipient.type === 'AccountId' ? (0, $2NSbF.IdentityUserAri).parse(message.recipient.userAri).userId : 'unknown'
                }
            }, $ae7e893918a4384b$var$IGNORE_MESSAGE_TEMPLATE_FILTER_ERRORS_FEATURE_GATE);
            let result;
            if (useNewFilterErrorHandler) result = $ae7e893918a4384b$export$eec952dbd9161493({
                logger: logger,
                metrics: metrics,
                error: err,
                message: message,
                startTime: startTime,
                filter: filter,
                isMessageTemplateFilter: ignoreMessageTemplateFilterFailures
            });
            else result = $ae7e893918a4384b$var$handleFilterError(logger, metrics, err, message, startTime);
            return Promise.reject(result);
        });
        filterPromises.push(promise);
    }
    const filterResponses = await Promise.allSettled(filterPromises);
    return $ae7e893918a4384b$export$25a39c76f5fb6428(filterResponses);
};
const $ae7e893918a4384b$var$recordFilterMetrics = ({ filterResponses: filterResponses, startTime: startTime, metrics: metrics, isMessageTemplateFilter: isMessageTemplateFilter })=>{
    if (!isMessageTemplateFilter) $ae7e893918a4384b$export$51debb9a715474b0(filterResponses, metrics);
    $ae7e893918a4384b$export$e315e6b8dddf819b(filterResponses, startTime, metrics);
};
const $ae7e893918a4384b$export$e315e6b8dddf819b = (filterResponse, start, metrics)=>{
    const latency = new Date().getTime() - start;
    if (Array.isArray(filterResponse)) filterResponse.map((res)=>{
        res.latencyInMillis = latency;
        const metricName = `post-office.orchestration.filter-check.${res.filterName}`;
        metrics.histogram(metricName, $ae7e893918a4384b$export$799f2caf9f0a48f9, {
            filter: res.filterName
        }).set(latency);
    });
    else {
        filterResponse.latencyInMillis = latency;
        const metricName = `post-office.orchestration.filter-check.${filterResponse.filterName}`;
        metrics.histogram(metricName, $ae7e893918a4384b$export$799f2caf9f0a48f9, {
            filter: filterResponse.filterName
        }).set(latency);
    }
    return filterResponse;
};
const $ae7e893918a4384b$var$FILTERING_RELIABILITY_METRIC_NAME = 'post-office.orchestration.filter-operation';
const $ae7e893918a4384b$var$FILTERING_RELIABILITY_FAILURE_DETAILED_METRIC_NAME = 'post-office.orchestration.filter-operation-failures';
const $ae7e893918a4384b$export$51debb9a715474b0 = (filterResponses, metrics)=>{
    const filterArray = Array.isArray(filterResponses) ? filterResponses : [
        filterResponses
    ];
    const filterFailures = filterArray.filter((response)=>response.result === "fail");
    const wasFilterFailure = filterFailures.length > 0;
    metrics.counter($ae7e893918a4384b$var$FILTERING_RELIABILITY_METRIC_NAME, {
        result: wasFilterFailure ? 'error' : 'success'
    }).incr();
    for (const filterFailure of filterFailures)metrics.counter($ae7e893918a4384b$var$FILTERING_RELIABILITY_FAILURE_DETAILED_METRIC_NAME, {
        filterName: filterFailure.filterName
    }).incr();
};
const $ae7e893918a4384b$export$25a39c76f5fb6428 = (results)=>{
    const filterResponses = results.flatMap((promiseResult)=>{
        if (promiseResult.status === 'fulfilled') return promiseResult.value;
        else return $ae7e893918a4384b$var$REJECTED_FILTER_RESPONSE;
    });
    return filterResponses;
};
const $ae7e893918a4384b$var$handleFilterError = (logger, metrics, error, message, startTime)=>{
    logger.error({
        messageInstanceId: message.messageInstanceId,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error: error
    }, 'Error resolving filter');
    $ae7e893918a4384b$var$recordFilterMetrics({
        filterResponses: $ae7e893918a4384b$var$REJECTED_FILTER_RESPONSE,
        startTime: startTime,
        metrics: metrics,
        isMessageTemplateFilter: false
    });
    return $ae7e893918a4384b$var$REJECTED_FILTER_RESPONSE;
};
const $ae7e893918a4384b$export$eec952dbd9161493 = ({ logger: logger, metrics: metrics, error: error, message: message, startTime: startTime, filter: filter, isMessageTemplateFilter: isMessageTemplateFilter })=>{
    const filterName = $ae7e893918a4384b$export$e76cb762f8c4c3ef(filter);
    const filterError = new $ae7e893918a4384b$export$d8ea20af4c01b9d9(error, {
        filterName: filterName
    });
    logger.error({
        messageInstanceId: message.messageInstanceId,
        error: filterError,
        filterName: filterName
    }, 'Error resolving filter');
    const rejectedFilterResponse = {
        result: "fail",
        filterName: filterName,
        failureReason: error.message
    };
    $ae7e893918a4384b$var$recordFilterMetrics({
        filterResponses: rejectedFilterResponse,
        startTime: startTime,
        metrics: metrics,
        isMessageTemplateFilter: isMessageTemplateFilter
    });
    return rejectedFilterResponse;
};
const $ae7e893918a4384b$export$e76cb762f8c4c3ef = (filter)=>{
    if ($ae7e893918a4384b$var$isPreDefinedMessageFilterMetadata(filter)) return filter.execute.name;
    return filter.filterName;
};
const $ae7e893918a4384b$var$isPreDefinedMessageFilterMetadata = (filter)=>{
    return 'execute' in filter && typeof filter.execute !== 'function' && 'name' in filter.execute;
};
const $ae7e893918a4384b$export$3ff0a6b2d89617f6 = async (filter, message, logger, metrics, statsig)=>{
    const startTime = new Date().getTime();
    try {
        const res = $ae7e893918a4384b$var$withResolvedFilterName(await filter.execute(message), filter, $ae7e893918a4384b$var$shouldOverrideReturnedFilterName(statsig, filter));
        $ae7e893918a4384b$var$recordFilterMetrics({
            filterResponses: res,
            startTime: startTime,
            metrics: metrics,
            isMessageTemplateFilter: false
        });
        return res;
    } catch (err) {
        const useNewFilterErrorHandler = statsig.checkGate({
            identifiers: {
                atlassianAccountId: message.recipient.type === 'AccountId' ? (0, $2NSbF.IdentityUserAri).parse(message.recipient.userAri).userId : 'unknown'
            }
        }, $ae7e893918a4384b$var$ENABLE_NEW_FILTER_ERROR_FEATURE_GATE);
        let result;
        if (useNewFilterErrorHandler) result = $ae7e893918a4384b$export$eec952dbd9161493({
            logger: logger,
            metrics: metrics,
            error: err,
            message: message,
            startTime: startTime,
            filter: filter,
            isMessageTemplateFilter: false
        });
        else result = $ae7e893918a4384b$var$handleFilterError(logger, metrics, err, message, startTime);
        throw result;
    }
};

});

parcelRegister("8Lf1t", function(module, exports) {
$parcel$export(module.exports, "coreActiveScopesCheck", () => $d5f8ad2f848426fe$export$ef740c23665fcf34);
const $d5f8ad2f848426fe$export$8df9619554dc21cd = [
    'welcome/software',
    'jira/get-started'
];
const $d5f8ad2f848426fe$export$ef740c23665fcf34 = ({ activeScopes: activeScopes, requiredScopes: requiredScopes, request: request })=>{
    const log = (message, context)=>request.logger.info({
            message: message,
            ...context
        }, 'coreActiveScopesCheck');
    const requiredScopeNames = requiredScopes.map((s)=>typeof s === 'string' ? s : s.name);
    if (!activeScopes) {
        log('Active scopes not found in context', {
            requiredScopes: requiredScopeNames
        });
        return {
            outcome: 'no-active-scopes',
            activeScopes: undefined,
            intersectedScopes: [],
            nonIntersectedScopes: requiredScopeNames
        };
    }
    const activeScopeNames = activeScopes.current.map((s)=>s.name);
    const excludedScopes = activeScopeNames.filter((name)=>$d5f8ad2f848426fe$export$8df9619554dc21cd.includes(name));
    if (excludedScopes.length > 0) {
        log("Active scope matches excluded route \u2014 denying", {
            excludedScopes: excludedScopes
        });
        return {
            outcome: 'excluded-scope',
            activeScopes: activeScopes,
            excludedScopes: excludedScopes,
            intersectedScopes: [],
            nonIntersectedScopes: requiredScopeNames
        };
    }
    if (requiredScopeNames.length === 0) {
        log('No required scopes provided');
        return {
            outcome: 'no-required-scopes',
            activeScopes: activeScopes,
            intersectedScopes: [],
            nonIntersectedScopes: []
        };
    }
    const intersectedScopes = requiredScopeNames.filter((name)=>activeScopeNames.includes(name));
    const nonIntersectedScopes = requiredScopeNames.filter((name)=>!activeScopeNames.includes(name));
    if (intersectedScopes.length > 0) return {
        outcome: 'active',
        activeScopes: activeScopes,
        intersectedScopes: intersectedScopes,
        nonIntersectedScopes: nonIntersectedScopes
    };
    log('None of the required scopes are active', {
        requiredScopes: requiredScopeNames,
        activeScopeNames: activeScopeNames
    });
    return {
        outcome: 'no-match',
        activeScopes: activeScopes,
        intersectedScopes: [],
        nonIntersectedScopes: requiredScopeNames
    };
};

});


parcelRegister("1mpEL", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeSearchParams", () => $f7034f640c830f05$export$e343914da553b968);

var $hCvtI = parcelRequire("hCvtI");
const $f7034f640c830f05$export$e343914da553b968 = ()=>{
    const route = (0, $hCvtI.usePostOfficeRoute)();
    let result = {};
    if (route?.searchParams) result = Object.fromEntries(route.searchParams);
    if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') result = {
        ...result,
        pathname: window.location.pathname
    };
    return result;
};

});

parcelRegister("dSKwo", function(module, exports) {
$parcel$export(module.exports, "scopes", () => $ee3f735b621d8089$export$54a06e3f4a159ad8);
const $ee3f735b621d8089$export$54a06e3f4a159ad8 = [
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    // Jira uses both `/jira/software/c/projects/...` (classic) and
                    // `/jira/software/projects/...` (no `c`) — same as screen-space-flags.
                    matches: '/jira/software(?:/c)?/projects/.*/boards/.*/backlog'
                }
            }
        }
    },
    {
        name: 'jira/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '/jira/software(?:/c)?/projects/.*/boards/[^/]+$'
                }
            }
        }
    }
];

});

parcelRegister("kHtv0", function(module, exports) {
$parcel$export(module.exports, "filterExperimentalMessages", () => $3a4882ccf620a359$export$d8dd292ae505204c);

var $4LDqh = parcelRequire("4LDqh");
const $3a4882ccf620a359$export$963cdca6c7580c53 = [];
const $3a4882ccf620a359$export$d8dd292ae505204c = (messages)=>{
    return messages.filter((message)=>{
        const experimentalMessages = $3a4882ccf620a359$export$963cdca6c7580c53.filter((exp)=>exp.messageTemplateId === message.messageTemplateId);
        // Non-experimental messages pass through
        if (experimentalMessages.length === 0) return true;
        // Message passes if any matching experiment says the user is in cohort
        return experimentalMessages.some((experimentalMessage)=>{
            const experimentValue = (0, $4LDqh.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, false);
            return experimentalMessage.statsigTestCohortPredicate(experimentValue);
        });
    });
};

});

parcelRegister("kT2HN", function(module, exports) {
$parcel$export(module.exports, "selectRovoNudgeMessages", () => $7c321f8049c23751$export$756b24563195bae3);
/** Messages with subscriptionConfig enabling live-only or live-and-persisted delivery get the first slot when present. */ const $7c321f8049c23751$var$isLiveSubscriptionDelivery = (m)=>{
    const { subscriptionConfig: subscriptionConfig } = m;
    if (!subscriptionConfig) return false;
    const { deliveryMechanism: deliveryMechanism } = subscriptionConfig;
    return deliveryMechanism === 'live-only' || deliveryMechanism === 'live-and-persisted';
};
/**
 * Selects up to 2 messages for the rovo-nudge placement:
 * - Max 1 prioritized message (latest by eventTime, subscriptionConfig.deliveryMechanism is `live-only` or `live-and-persisted`)
 * - Max 1 other message (latest by eventTime)
 * - Prioritized subscription message is first in the result array
 *
 * Edge cases:
 * - If only live subscription messages exist: returns 1 such message
 * - If only non-live messages exist: returns 1 message
 * - If no messages at all: returns []
 */ const $7c321f8049c23751$var$getLatestByEventTime = (messages)=>{
    let best;
    for (const current of messages)if (!best || new Date(current.eventTime) > new Date(best.eventTime)) best = current;
    return best;
};
const $7c321f8049c23751$export$756b24563195bae3 = (messages)=>{
    const subscriptionMessages = messages.filter($7c321f8049c23751$var$isLiveSubscriptionDelivery);
    const normalMessages = messages.filter((m)=>!$7c321f8049c23751$var$isLiveSubscriptionDelivery(m));
    const topSubscription = $7c321f8049c23751$var$getLatestByEventTime(subscriptionMessages);
    const topNormal = $7c321f8049c23751$var$getLatestByEventTime(normalMessages);
    // Priority: subscription first, then normal — filter out undefined entries
    const result = [
        topSubscription,
        topNormal
    ].filter((m)=>m !== undefined);
    // Edge case: no messages matched either bucket (e.g. empty input)
    return result;
};

});


parcelRegister("hmyVG", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $2fdf8badfc9e8a7e$export$fa9bb46961aca2cc);

var $e79Pd = parcelRequire("e79Pd");

var $eI9IH = parcelRequire("eI9IH");

var $50DkA = parcelRequire("50DkA");

var $euxye = parcelRequire("euxye");

var $hAo2S = parcelRequire("hAo2S");

var $6R5gq = parcelRequire("6R5gq");

var $1ulsE = parcelRequire("1ulsE");
const $2fdf8badfc9e8a7e$export$e7843a8f64a8d87c = (0, $hAo2S.PlacementBackend).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $1ulsE.assertMessageTemplateContext),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $1ulsE.assertMessageTemplateContext),
            stage: async ({ message: message })=>{
                return message.context;
            }
        }
    }));
const $2fdf8badfc9e8a7e$export$fa9bb46961aca2cc = (0, $hAo2S.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $1ulsE.assertMessageTemplateContext),
        Component: ({ title: title, description: description })=>{
            const icon = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eI9IH))), {
                    size: "medium",
                    label: title
                }), [
                title
            ]);
            const nudgeContext = (0, $euxye.useMemo)(()=>({
                    id: 'live-nudge-demo-message'
                }), []);
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6R5gq.NudgeDefinition), {
                title: title,
                description: description,
                icon: icon,
                handleType: (0, $50DkA.HandleActionType).Chat,
                staticPrompt: `Tell me more about: ${title}`,
                starterType: "static",
                nudgeContext: nudgeContext
            });
        }
    }
});

});
parcelRegister("eI9IH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d41a49be2d57b5fca92e1196d1fac8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab5cb6f4285cbffa$var$_react = $ab5cb6f4285cbffa$var$_interopRequireDefault((parcelRequire("euxye")));

var $ab5cb6f4285cbffa$var$_baseNew = $ab5cb6f4285cbffa$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $ab5cb6f4285cbffa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBarLine".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: Bar charts with trend lines
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab5cb6f4285cbffa$var$ChartBarLineIcon = (props)=>/*#__PURE__*/ $ab5cb6f4285cbffa$var$_react.default.createElement($ab5cb6f4285cbffa$var$_baseNew.default, Object.assign({
        name: "ChartBarLineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M14 2v1.5h-2.97L7.24 6.81a.75.75 0 0 1-.49.19H3.5V5.5h2.97l3.79-3.31.11-.08a.75.75 0 0 1 .38-.11zm-8.75 8h.08a.75.75 0 0 1 .67.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75zm4-2h.08a.75.75 0 0 1 .67.75v3a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-3A.75.75 0 0 1 8.25 8zm4-2a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$ab5cb6f4285cbffa$var$ChartBarLineIcon.displayName = 'ChartBarLineIcon';
var $ab5cb6f4285cbffa$var$_default = module.exports.default = $ab5cb6f4285cbffa$var$ChartBarLineIcon;

});

parcelRegister("50DkA", function(module, exports) {
$parcel$export(module.exports, "HandleActionType", () => $a51e1c5b02153e6d$export$87497e63e164f4b3);
$parcel$export(module.exports, "LEGACY_DYNAMIC_SKILL_IDS", () => $a51e1c5b02153e6d$export$c91e07269f22915a);
$parcel$export(module.exports, "PageContextType", () => $a51e1c5b02153e6d$export$7f7a6f1c2ab5127);
$parcel$export(module.exports, "PROMPT_OF_DAY_ACTION_ID", () => $a51e1c5b02153e6d$export$4f757e7d9540e8f9);
var $a51e1c5b02153e6d$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $a51e1c5b02153e6d$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $a51e1c5b02153e6d$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_BOARD"] = "jira-board";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["FOCUS_FOCUS_AREA_FUNDS_VIEW"] = "focus-focus-area-funds-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $a51e1c5b02153e6d$export$4f757e7d9540e8f9 = 'prompt-of-day';

});

parcelRegister("6R5gq", function(module, exports) {
$parcel$export(module.exports, "NudgeDefinition", () => $c1758b928c08f640$export$3c0e67261e79451d);

var $khHng = parcelRequire("khHng");

var $jvHCQ = parcelRequire("jvHCQ");

var $euxye = parcelRequire("euxye");
function $c1758b928c08f640$export$3c0e67261e79451d(actionProps) {
    const { setNudges: setNudges } = (0, $jvHCQ.useAISmartButtonActions)();
    const stableActionProps = (0, $khHng.useStableObject)(actionProps);
    (0, $euxye.useEffect)(()=>{
        // `RovoNudgeAction` is a superset of `ConversationAction` with additional nudge-specific
        // fields (for example `staticPrompt`, `starterType`, and `nudgeContext`) that are passed
        // through to the Smart Button API at runtime.
        setNudges([
            {
                id: 'post-office-rovo-nudge',
                ...stableActionProps
            }
        ]);
        // This simplified flow assumes only one rovo nudge is rendered at a time.
        // Clearing on unmount allows the next backend-ranked message to take over.
        return ()=>setNudges([]);
    }, [
        setNudges,
        stableActionProps
    ]);
    return null;
}
$c1758b928c08f640$export$3c0e67261e79451d.displayName = "NudgeDefinition";

});
parcelRegister("jvHCQ", function(module, exports) {
$parcel$export(module.exports, "AISmartButtonStore", () => $c8eb6e69ef578ce0$export$72552b26ebb37b2);
$parcel$export(module.exports, "useAISmartButtonActions", () => $c8eb6e69ef578ce0$export$af36d029992e7a8c);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $c8eb6e69ef578ce0$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null,
    isNudgeVisible: false
};
const $c8eb6e69ef578ce0$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        },
    setIsNudgeVisible: (isNudgeVisible)=>({ setState: setState })=>{
            setState({
                isNudgeVisible: isNudgeVisible
            });
        }
};
const $c8eb6e69ef578ce0$export$72552b26ebb37b2 = (0, $5QDqc.createStore)({
    initialState: $c8eb6e69ef578ce0$export$d4c72bab9d6cc13a,
    actions: $c8eb6e69ef578ce0$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $c8eb6e69ef578ce0$export$af36d029992e7a8c = (0, $3h1FP.createActionsHook)($c8eb6e69ef578ce0$export$72552b26ebb37b2);

});


parcelRegister("1ulsE", function(module, exports) {
$parcel$export(module.exports, "assertMessageTemplateContext", () => $28160ef6534bbc71$export$a7a9523472993e97);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $bCHUl = parcelRequire("bCHUl");
function $28160ef6534bbc71$export$a7a9523472993e97(value) {
    const result = $28160ef6534bbc71$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $bCHUl.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $28160ef6534bbc71$export$226b3eccf92c9ed9(value) {
    const result = $28160ef6534bbc71$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $28160ef6534bbc71$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('title' in value)) errors.push({
            path: 'value["title"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["title"] !== 'string') errors.push({
            path: 'value["title"]',
            expected: 'string',
            value: value["title"]
        });
        if (!('description' in value)) errors.push({
            path: 'value["description"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["description"] !== 'string') errors.push({
            path: 'value["description"]',
            expected: 'string',
            value: value["description"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}

});
parcelRegister("bCHUl", function(module, exports) {
"use strict";
var $87654d808c45d5d6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $87654d808c45d5d6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $87654d808c45d5d6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$87654d808c45d5d6$var$__exportStar((parcelRequire("eL97Z")), module.exports);

$87654d808c45d5d6$var$__exportStar((parcelRequire("iHv9E")), module.exports);

});
parcelRegister("eL97Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AssertError = void 0;
class $abec8918df83f248$var$AssertError extends Error {
    constructor(method, path, expected, value){
        const message = path ? `Error on ${method}(): invalid type on ${path}, expect to be ${expected}` : `Error on ${method}(): invalid type, expect to be ${expected}`;
        super(message);
        this.method = method;
        this.path = path;
        this.expected = expected;
        this.value = value;
    }
}
module.exports.AssertError = $abec8918df83f248$var$AssertError;

});

parcelRegister("iHv9E", function(module, exports) {
"use strict";
var $d9d468c9c687855e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d9d468c9c687855e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d9d468c9c687855e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d9d468c9c687855e$var$__exportStar((parcelRequire("3D8fX")), module.exports);

});
parcelRegister("3D8fX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});





parcelRegister("jlzDs", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $439eb17df1d67a76$export$fa9bb46961aca2cc);

var $e79Pd = parcelRequire("e79Pd");

var $eI9IH = parcelRequire("eI9IH");

var $50DkA = parcelRequire("50DkA");

var $euxye = parcelRequire("euxye");

var $8hQRz = parcelRequire("8hQRz");

var $hAo2S = parcelRequire("hAo2S");

var $6R5gq = parcelRequire("6R5gq");

var $fRiz1 = parcelRequire("fRiz1");
const $439eb17df1d67a76$export$e7843a8f64a8d87c = (0, $hAo2S.PlacementBackend).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $fRiz1.assertMessageTemplateContext),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            // Subscription / GraphQL payloads may include extra or mistyped fields (e.g. scopes).
            // Validate only after narrowing to the shape render uses.
            validate: (0, $8hQRz.noValidation)(),
            stage: async ({ message: message })=>({
                    title: message.context.title,
                    description: message.context.description
                })
        }
    }));
const $439eb17df1d67a76$export$fa9bb46961aca2cc = (0, $hAo2S.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $8hQRz.noValidation)(),
        Component: ({ title: title, description: description })=>{
            const icon = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eI9IH))), {
                    size: "medium",
                    label: title
                }), [
                title
            ]);
            const nudgeContext = (0, $euxye.useMemo)(()=>({
                    id: 'live-and-persisted-test-message'
                }), []);
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6R5gq.NudgeDefinition), {
                title: title,
                description: description,
                icon: icon,
                handleType: (0, $50DkA.HandleActionType).Chat,
                staticPrompt: `Tell me more about: ${title}`,
                starterType: "static",
                nudgeContext: nudgeContext
            });
        }
    }
});

});
parcelRegister("fRiz1", function(module, exports) {
$parcel$export(module.exports, "assertMessageTemplateContext", () => $e564e3f5360f279f$export$a7a9523472993e97);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $bCHUl = parcelRequire("bCHUl");
function $e564e3f5360f279f$export$a7a9523472993e97(value) {
    const result = $e564e3f5360f279f$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $bCHUl.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $e564e3f5360f279f$export$226b3eccf92c9ed9(value) {
    const result = $e564e3f5360f279f$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $e564e3f5360f279f$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('title' in value)) errors.push({
            path: 'value["title"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["title"] !== 'string') errors.push({
            path: 'value["title"]',
            expected: 'string',
            value: value["title"]
        });
        if (!('description' in value)) errors.push({
            path: 'value["description"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["description"] !== 'string') errors.push({
            path: 'value["description"]',
            expected: 'string',
            value: value["description"]
        });
        if (!('scopes' in value)) errors.push({
            path: 'value["scopes"]',
            expected: '(object | object)[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["scopes"])) errors.push({
                path: 'value["scopes"]',
                expected: 'array',
                value: value["scopes"]
            });
            if (Array.isArray(value["scopes"])) value["scopes"].forEach((element, index)=>{
                {
                    let element_valid = false;
                    if (!element_valid) {
                        const element_errors_0 = [];
                        if (typeof element !== 'object' || element === null || Array.isArray(element)) element_errors_0.push({
                            path: 'element',
                            expected: 'object',
                            value: element
                        });
                        else {
                            if (!('name' in element)) element_errors_0.push({
                                path: 'element["name"]',
                                expected: '"jira/backlog"',
                                value: undefined
                            });
                            else if (element["name"] !== "jira/backlog") element_errors_0.push({
                                path: 'element["name"]',
                                expected: "jira/backlog",
                                value: element["name"]
                            });
                        }
                        if (element_errors_0.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_1 = [];
                        if (typeof element !== 'object' || element === null || Array.isArray(element)) element_errors_1.push({
                            path: 'element',
                            expected: 'object',
                            value: element
                        });
                        else {
                            if (!('name' in element)) element_errors_1.push({
                                path: 'element["name"]',
                                expected: '"jira/board"',
                                value: undefined
                            });
                            else if (element["name"] !== "jira/board") element_errors_1.push({
                                path: 'element["name"]',
                                expected: "jira/board",
                                value: element["name"]
                            });
                        }
                        if (element_errors_1.length === 0) element_valid = true;
                    }
                    if (!element_valid) errors.push({
                        path: 'element',
                        expected: 'object | object',
                        value: element
                    });
                }
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}

});


parcelRegister("g51X5", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $e40ffe9c10c074ff$export$fa9bb46961aca2cc);

var $e79Pd = parcelRequire("e79Pd");

var $8hQRz = parcelRequire("8hQRz");

var $hAo2S = parcelRequire("hAo2S");

var $6R5gq = parcelRequire("6R5gq");

var $7ocXt = parcelRequire("7ocXt");

var $euxye = parcelRequire("euxye");

var $50DkA = parcelRequire("50DkA");

var $iA6Wy = parcelRequire("iA6Wy");

var $biXRw = parcelRequire("biXRw");
var $18msh = parcelRequire("18msh");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $e40ffe9c10c074ff$export$e7843a8f64a8d87c = (0, $hAo2S.PlacementBackend).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $8hQRz.noValidation)(),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'mau',
                            targetProduct: [
                                (0, $iA6Wy.RovoCcpId)
                            ],
                            edition: [
                                (0, $iA6Wy.AnyEdition)
                            ]
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $8hQRz.noValidation)(),
            stage: async ({ message: message })=>message.context
        }
    }));
const $e40ffe9c10c074ff$var$messages = (0, $7eNDO.defineMessages)({
    title: {
        id: 'post-office.growth.jira-board-catch-up-rovo-nudge.title',
        defaultMessage: 'Catch up on recent changes',
        description: 'Title of the Rovo nudge for Jira board catch-up'
    },
    secondaryTitle: {
        id: 'post-office.growth.jira-board-catch-up-rovo-nudge.secondary-title',
        defaultMessage: 'Get a quick summary of new issues and important activity.',
        description: 'Secondary title of the Rovo nudge for Jira board catch-up'
    },
    staticPrompt: {
        id: 'post-office.growth.jira-board-catch-up-rovo-nudge.static-prompt',
        defaultMessage: `Summarize the most recent activity on this Jira board. Create an executive-ready update (max ~8 bullets total) using this structure:

1. Sprint / timeline context
- Current sprint or time window, dates, and high-level status (e.g. "on track / at risk / off track").

2. Key progress / wins (2-4 bullets)
- Focus on issues that moved into In Progress, In Review / Pending Review, or Done in the selected period.
- For each, include: issue key, short description (3-7 words), and current status only (no technical deep dive).

3. Blockers / risks (1-3 bullets)
- Call out any flagged issues, long-running items stuck in In Progress or In Review, or dependencies that could impact delivery for this sprint / period.

4. Scope & pipeline (1-3 bullets)
- Highlight important newly created or To Do issues that are not yet started but are significant for upcoming milestones.
- Note if work is skewed toward setup/foundations vs user-visible outcomes.

5. Next-focus recommendation (1-2 bullets)
- Recommend the 1-2 highest-leverage next actions to keep the team's objectives on track, referencing specific issue keys.

Output the answer as concise markdown bullets, optimized for an executive audience (outcomes, risks, and next moves over implementation details).`,
        description: 'Static prompt sent to Rovo for Jira board catch-up summary'
    }
});
const $e40ffe9c10c074ff$var$nudgeContext = {
    id: 'jira-board-catch-up-rovo-nudge'
};
const $e40ffe9c10c074ff$export$fa9bb46961aca2cc = (0, $hAo2S.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $8hQRz.noValidation)(),
        Component: ({ description: description })=>{
            const intl = (0, $1YIbA.default)();
            (0, $biXRw.useClickedRovoNudgeCta)({
                nudgeId: $e40ffe9c10c074ff$var$nudgeContext.id
            });
            (0, $18msh.useClickedRovoNudgeDismiss)({
                nudgeId: $e40ffe9c10c074ff$var$nudgeContext.id
            });
            const icon = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ocXt))), {
                    size: "medium",
                    label: "Jira board summary"
                }), []);
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6R5gq.NudgeDefinition), {
                title: intl.formatMessage($e40ffe9c10c074ff$var$messages.title),
                secondaryTitle: intl.formatMessage($e40ffe9c10c074ff$var$messages.secondaryTitle),
                description: description,
                icon: icon,
                handleType: (0, $50DkA.HandleActionType).Chat,
                staticPrompt: intl.formatMessage($e40ffe9c10c074ff$var$messages.staticPrompt),
                starterType: "static",
                nudgeContext: $e40ffe9c10c074ff$var$nudgeContext
            });
        }
    }
});

});
parcelRegister("7ocXt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b15d3fb67cad438983aaed8a0b0acfc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5614d38357d0544f$var$_react = $5614d38357d0544f$var$_interopRequireDefault((parcelRequire("euxye")));

var $5614d38357d0544f$var$_baseNew = $5614d38357d0544f$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $5614d38357d0544f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemoveSilence".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for silence removal functionality in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5614d38357d0544f$var$AiGenerativeRemoveSilenceIcon = (props)=>/*#__PURE__*/ $5614d38357d0544f$var$_react.default.createElement($5614d38357d0544f$var$_baseNew.default, Object.assign({
        name: "AiGenerativeRemoveSilenceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.115 1.664A7.98 7.98 0 0 1 8 0v1.5a6.48 6.48 0 0 0-3.968 1.35zM1.5 8c0 1.664.635 3.326 1.904 4.595A6.48 6.48 0 0 0 8 14.5V16a7.98 7.98 0 0 1-5.657-2.343A7.97 7.97 0 0 1 0 8m11.795 1.494a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.686-.615a.75.75 0 0 1 0-1.41l1.686-.615z" clip-rule="evenodd"/><path fill="currentcolor" d="m2.92 3.95-1.17-.94A7.98 7.98 0 0 0 0 8a7.97 7.97 0 0 0 2.34 5.66A7.98 7.98 0 0 0 8 16v-1.5a6.48 6.48 0 0 1-4.6-1.9A6.48 6.48 0 0 1 1.5 8c0-1.44.47-2.87 1.42-4.05m10.45-1.8a.75.75 0 0 1-1 1.11l-.02-.01a.75.75 0 1 1 1-1.12zM10.69.55a.75.75 0 1 1-.5 1.41l-.02-.01a.75.75 0 1 1 .5-1.41zm4.59 4.27a.75.75 0 0 0-1.41.5l.01.02a.75.75 0 1 0 1.41-.5zM16 8.06a.75.75 0 0 0-1.5-.08V8a.75.75 0 0 0 1.5.08v-.01z"/>`
    }, props));
$5614d38357d0544f$var$AiGenerativeRemoveSilenceIcon.displayName = 'AiGenerativeRemoveSilenceIcon';
var $5614d38357d0544f$var$_default = module.exports.default = $5614d38357d0544f$var$AiGenerativeRemoveSilenceIcon;

});

parcelRegister("iA6Wy", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementCcpId", () => $50266e5f5c3d1fee$export$749a64c68d670e1c);
$parcel$export(module.exports, "JiraProductDiscoveryCcpId", () => $50266e5f5c3d1fee$export$d3304f5525ccba77);
$parcel$export(module.exports, "ConfluenceCloudCcpId", () => $50266e5f5c3d1fee$export$c44082beda68c821);
$parcel$export(module.exports, "OpsgenieCcpId", () => $50266e5f5c3d1fee$export$174b0d3ebcf732d2);
$parcel$export(module.exports, "RovoCcpId", () => $50266e5f5c3d1fee$export$fe6a238b700ff48b);
$parcel$export(module.exports, "LoomCcpId", () => $50266e5f5c3d1fee$export$a9a5d8e6a4b07b3);
$parcel$export(module.exports, "AnyEdition", () => $50266e5f5c3d1fee$export$de3613be25133e67);
$parcel$export(module.exports, "ValidEdition", () => $50266e5f5c3d1fee$export$3089d1941106d80a);
$parcel$export(module.exports, "D1to6aiGoal", () => $50266e5f5c3d1fee$export$af08535a504b4ba1);
$parcel$export(module.exports, "ClickthroughGoal", () => $50266e5f5c3d1fee$export$c1b571ea4fc68de);
// See the current list of valid CCP product IDS here:
// This is a constant used to standardized the value of the "any" field in the message metadata
const $50266e5f5c3d1fee$var$AnyValue = 'any';
const $50266e5f5c3d1fee$export$d7170743086edf62 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $50266e5f5c3d1fee$export$749a64c68d670e1c = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $50266e5f5c3d1fee$export$7452609cc2879709 = '46ccaa9e-cdb0-4995-8886-5827a5ff162b';
const $50266e5f5c3d1fee$export$d3304f5525ccba77 = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $50266e5f5c3d1fee$export$c44082beda68c821 = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $50266e5f5c3d1fee$export$3ffd6e56cffd07e5 = '0b8ea1e2-52df-11ea-8d77-2e728ce88125';
const $50266e5f5c3d1fee$export$e91f394c1f32343a = '7c917705-866d-4b6b-b266-0fc7633e8342';
const $50266e5f5c3d1fee$export$9135e98f8bbab458 = '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2';
const $50266e5f5c3d1fee$export$a5e8ad58f7670c77 = 'f44da23e-5907-4d81-8a78-33bedee10969';
const $50266e5f5c3d1fee$export$8ce8b463868cb16e = 'b6c5632b-6018-4656-b2ac-3e32e7cef0d3';
const $50266e5f5c3d1fee$export$174b0d3ebcf732d2 = 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551';
const $50266e5f5c3d1fee$export$fe6a238b700ff48b = '91ae3e3f-138e-43be-98cc-48df03d13c32';
const $50266e5f5c3d1fee$export$23a18b32c52da583 = '56cce7cb-8c54-4103-8736-e64d1ab00128';
const $50266e5f5c3d1fee$export$a9a5d8e6a4b07b3 = '7683a73e-423d-41a1-b43f-d497656f8b5d';
const $50266e5f5c3d1fee$export$b729c699fa9f25a6 = 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905';
const $50266e5f5c3d1fee$export$64ae0929ad3ee453 = 'dbe4d391-d570-4313-ab0f-3a02dbab4720';
const $50266e5f5c3d1fee$export$2ee82f14fe1b2d80 = $50266e5f5c3d1fee$var$AnyValue;
const $50266e5f5c3d1fee$export$a0b0b6a3fe1e8702 = 'fake-id';
const $50266e5f5c3d1fee$export$ba7683be5feaa33e = {
    JiraSoftwareCcpId: $50266e5f5c3d1fee$export$d7170743086edf62,
    JiraServiceManagementCcpId: $50266e5f5c3d1fee$export$749a64c68d670e1c,
    JiraWorkManagementCloudCcpId: $50266e5f5c3d1fee$export$7452609cc2879709,
    JiraProductDiscoveryCcpId: $50266e5f5c3d1fee$export$d3304f5525ccba77,
    ConfluenceCloudCcpId: $50266e5f5c3d1fee$export$c44082beda68c821,
    StatuspageCcpId: $50266e5f5c3d1fee$export$3ffd6e56cffd07e5,
    AtlasCcpId: $50266e5f5c3d1fee$export$e91f394c1f32343a,
    CompassCcpId: $50266e5f5c3d1fee$export$9135e98f8bbab458,
    AtlassianAnalyticsCcpId: $50266e5f5c3d1fee$export$a5e8ad58f7670c77,
    AtlassianWhiteboardCcpId: $50266e5f5c3d1fee$export$8ce8b463868cb16e,
    OpsgenieCcpId: $50266e5f5c3d1fee$export$174b0d3ebcf732d2,
    RovoCcpId: $50266e5f5c3d1fee$export$fe6a238b700ff48b,
    RovoDevCcpId: $50266e5f5c3d1fee$export$23a18b32c52da583,
    LoomCcpId: $50266e5f5c3d1fee$export$a9a5d8e6a4b07b3,
    FocusCcpId: $50266e5f5c3d1fee$export$b729c699fa9f25a6,
    StudioCcpId: $50266e5f5c3d1fee$export$64ae0929ad3ee453,
    AnyProductCcpId: $50266e5f5c3d1fee$export$2ee82f14fe1b2d80,
    TestProductCcpId: $50266e5f5c3d1fee$export$a0b0b6a3fe1e8702
};
const $50266e5f5c3d1fee$export$ed719b477b100ccf = 'free';
const $50266e5f5c3d1fee$export$9c0d875ac3fc7486 = 'standard';
const $50266e5f5c3d1fee$export$ef90b2d2063bbde5 = 'premium';
const $50266e5f5c3d1fee$export$de3613be25133e67 = $50266e5f5c3d1fee$var$AnyValue;
const $50266e5f5c3d1fee$export$3089d1941106d80a = {
    FreeEdition: $50266e5f5c3d1fee$export$ed719b477b100ccf,
    StandardEdition: $50266e5f5c3d1fee$export$9c0d875ac3fc7486,
    PremiumEdiiton: $50266e5f5c3d1fee$export$ef90b2d2063bbde5,
    AnyEdition: $50266e5f5c3d1fee$export$de3613be25133e67
};
const $50266e5f5c3d1fee$export$935920ee20f5fbfd = 'signup';
const $50266e5f5c3d1fee$export$af08535a504b4ba1 = 'd1to6ai';
const $50266e5f5c3d1fee$export$2e8b1b8d42494923 = 'ffp';
const $50266e5f5c3d1fee$export$2887820b2787a3b = 'fo';
const $50266e5f5c3d1fee$export$17c81379c0af852c = 'mcu';
const $50266e5f5c3d1fee$export$7af8db49468f6ca0 = 'mau';
const $50266e5f5c3d1fee$export$4a4a9bf2ef44c9d3 = 'macm'; // Month Active Community Member
const $50266e5f5c3d1fee$export$1d22059176a01613 = 'purchase';
const $50266e5f5c3d1fee$export$62e129faf973b35b = 'm2_ati';
const $50266e5f5c3d1fee$export$b2e16dc790f0af57 = 'peu';
const $50266e5f5c3d1fee$export$b02d9c969aca0c41 = 'event_registration';
const $50266e5f5c3d1fee$export$6086e660e37fefd1 = 'tech_alert';
const $50266e5f5c3d1fee$export$74d3ca88165fd9c7 = 'commerce_notification';
const $50266e5f5c3d1fee$export$95514713d19a18ca = 'webinar_invites';
const $50266e5f5c3d1fee$export$91eb8e25419b040e = 'demo';
const $50266e5f5c3d1fee$export$2d677556a829b674 = 'survey_research';
const $50266e5f5c3d1fee$export$c1b571ea4fc68de = 'clickthrough';
const $50266e5f5c3d1fee$export$abb11c2932ba2d5f = {
    SignupGoal: $50266e5f5c3d1fee$export$935920ee20f5fbfd,
    D1to6aiGoal: $50266e5f5c3d1fee$export$af08535a504b4ba1,
    FfpGoal: $50266e5f5c3d1fee$export$2e8b1b8d42494923,
    FoGoal: $50266e5f5c3d1fee$export$2887820b2787a3b,
    McuGoal: $50266e5f5c3d1fee$export$17c81379c0af852c,
    MauGoal: $50266e5f5c3d1fee$export$7af8db49468f6ca0,
    MacmGoal: $50266e5f5c3d1fee$export$4a4a9bf2ef44c9d3,
    PurchaseGoal: $50266e5f5c3d1fee$export$1d22059176a01613,
    M2AtiGoal: $50266e5f5c3d1fee$export$62e129faf973b35b,
    PeuGoal: $50266e5f5c3d1fee$export$b2e16dc790f0af57,
    EventRegistrationGoal: $50266e5f5c3d1fee$export$b02d9c969aca0c41,
    TechAlertGoal: $50266e5f5c3d1fee$export$6086e660e37fefd1,
    CommerceNotificationGoal: $50266e5f5c3d1fee$export$74d3ca88165fd9c7,
    WebinarInvitesGoal: $50266e5f5c3d1fee$export$95514713d19a18ca,
    DemoGoal: $50266e5f5c3d1fee$export$91eb8e25419b040e,
    SurveryResearchGoal: $50266e5f5c3d1fee$export$2d677556a829b674,
    ClickthroughGoal: $50266e5f5c3d1fee$export$c1b571ea4fc68de
};
const $50266e5f5c3d1fee$export$428528e1e61b68ff = 'ui';
const $50266e5f5c3d1fee$export$d4c7c79f2dff5f1f = 'track';
const $50266e5f5c3d1fee$export$287340d0a2f482b0 = 'screen';
const $50266e5f5c3d1fee$var$ValidGASv3EventTypes = {
    UIEventTypeGASv3: $50266e5f5c3d1fee$export$428528e1e61b68ff,
    TrackEventTypeGASv3: $50266e5f5c3d1fee$export$d4c7c79f2dff5f1f,
    ScreenEventTypeGASv3: $50266e5f5c3d1fee$export$287340d0a2f482b0
};
const $50266e5f5c3d1fee$export$42867c57e2cf7ae6 = {
    SignupGoal: $50266e5f5c3d1fee$export$935920ee20f5fbfd,
    D1to6aiGoal: $50266e5f5c3d1fee$export$af08535a504b4ba1,
    FfpGoal: $50266e5f5c3d1fee$export$2e8b1b8d42494923,
    FoGoal: $50266e5f5c3d1fee$export$2887820b2787a3b,
    McuGoal: $50266e5f5c3d1fee$export$17c81379c0af852c,
    MauGoal: $50266e5f5c3d1fee$export$7af8db49468f6ca0,
    PurchaseGoal: $50266e5f5c3d1fee$export$1d22059176a01613,
    M2AtiGoal: $50266e5f5c3d1fee$export$62e129faf973b35b,
    PeuGoal: $50266e5f5c3d1fee$export$b2e16dc790f0af57
};

});

parcelRegister("biXRw", function(module, exports) {
$parcel$export(module.exports, "useClickedRovoNudgeCta", () => $6604a329ee722b80$export$b2565cb05a810419);

var $7C6RU = parcelRequire("7C6RU");

var $iKPvC = parcelRequire("iKPvC");

var $euxye = parcelRequire("euxye");
const $6604a329ee722b80$export$b2565cb05a810419 = ({ nudgeId: nudgeId })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const clicked = (0, $7C6RU.useGasv3Listener)({
        action: 'clicked',
        actionSubject: 'rovoButton',
        actionSubjectId: 'aiRovoProactiveNudge',
        attributes: {
            recommendationFeatureId: nudgeId
        }
    });
    (0, $euxye.useEffect)(()=>{
        if (clicked) messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'cta',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
    }, [
        clicked,
        messageInstanceClicked
    ]);
};

});
parcelRegister("7C6RU", function(module, exports) {
$parcel$export(module.exports, "useGasv3Listener", () => $363e2b5e377b3cf8$export$ac5133e8f763edca);

var $euxye = parcelRequire("euxye");

var $gpTCJ = parcelRequire("gpTCJ");
const $363e2b5e377b3cf8$export$ac5133e8f763edca = (eventToMatch)=>{
    const { subscribe: subscribe } = (0, $gpTCJ.postOfficeGasv3ListenerStore);
    const [showMessage, setShowMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState(false);
    (0, $euxye.useEffect)(()=>{
        if (!eventToMatch || Object.keys(eventToMatch).length === 0) return ()=>{};
        return subscribe(eventToMatch, ()=>setShowMessage(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        eventToMatch
    ]);
    return showMessage;
};

});


parcelRegister("18msh", function(module, exports) {
$parcel$export(module.exports, "useClickedRovoNudgeDismiss", () => $9aec511c6c31f2bb$export$b2280e03bd734b9c);

var $7C6RU = parcelRequire("7C6RU");

var $iKPvC = parcelRequire("iKPvC");

var $euxye = parcelRequire("euxye");
const $9aec511c6c31f2bb$export$b2280e03bd734b9c = ({ nudgeId: nudgeId })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const dismissed = (0, $7C6RU.useGasv3Listener)({
        action: 'dismissed',
        actionSubject: 'rovoButton',
        actionSubjectId: 'aiRovoProactiveNudge',
        attributes: {
            recommendationFeatureId: nudgeId,
            dismissedMethod: 'manual'
        }
    });
    (0, $euxye.useEffect)(()=>{
        if (dismissed) messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
    }, [
        dismissed,
        messageInstanceClicked
    ]);
};

});


parcelRegister("5OhlA", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $1cc6c53f8dbf58f9$export$fa9bb46961aca2cc);

var $e79Pd = parcelRequire("e79Pd");

var $8hQRz = parcelRequire("8hQRz");

var $hAo2S = parcelRequire("hAo2S");

var $6R5gq = parcelRequire("6R5gq");

var $eYjNM = parcelRequire("eYjNM");

var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9ll9z = parcelRequire("9ll9z");

var $50DkA = parcelRequire("50DkA");

var $18msh = parcelRequire("18msh");
const $1cc6c53f8dbf58f9$var$nudgeTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: 'You have {numberOfSuggestions} work item {numberOfSuggestions, plural, one {update} other {updates}}',
    description: 'The title of the nudge shown to users when there are work item updates available.',
    id: 'ai-rovo.actions-software-backlog.nudge-title.nonfinal'
});
const $1cc6c53f8dbf58f9$var$nudgeDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: 'We have identified {numberOfSuggestions} work item {numberOfSuggestions, plural, one {update} other {updates}}',
    description: 'The description of the nudge shown to users when there are work item updates available.',
    id: 'ai-rovo.actions-software-backlog.nudge-description.nonfinal'
});
const $1cc6c53f8dbf58f9$var$nudgeIconLabelMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: 'Work items icon',
    description: 'Label for the work items icon used in the nudge.',
    id: 'ai-rovo.actions-software-backlog.nudge-icon-label.nonfinal'
});
const $1cc6c53f8dbf58f9$export$e7843a8f64a8d87c = (0, $hAo2S.PlacementBackend).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $8hQRz.noValidation)(),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $8hQRz.noValidation)(),
            stage: async ({ message: message })=>message.context
        }
    }));
const $1cc6c53f8dbf58f9$var$nudgeContext = {
    id: 'jira-board-backlog-update-work-suggestions'
};
const $1cc6c53f8dbf58f9$export$fa9bb46961aca2cc = (0, $hAo2S.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $8hQRz.noValidation)(),
        Component: ({ conversationChannelId: conversationChannelId, numberOfSuggestions: numberOfSuggestions })=>{
            (0, $18msh.useClickedRovoNudgeDismiss)({
                nudgeId: $1cc6c53f8dbf58f9$var$nudgeContext.id
            });
            const publish = (0, $9ll9z.usePublish)('ai-mate');
            const { formatMessage: formatMessage } = (0, $1YIbA.default)();
            const icon = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eYjNM))), {
                    size: "medium",
                    label: formatMessage($1cc6c53f8dbf58f9$var$nudgeIconLabelMessage)
                }), []);
            const nudgeData = {
                id: `jira-board-backlog-update-work-suggestions-rovo-nudge-${conversationChannelId}`,
                onClick: ()=>{
                    publish({
                        type: 'chat-open',
                        product: 'jira',
                        data: {
                            channelId: conversationChannelId
                        },
                        openChatMode: 'mini-modal',
                        source: 'project-board-backlog'
                    });
                }
            };
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6R5gq.NudgeDefinition), {
                title: formatMessage($1cc6c53f8dbf58f9$var$nudgeTitleMessage, {
                    numberOfSuggestions: numberOfSuggestions
                }),
                description: formatMessage($1cc6c53f8dbf58f9$var$nudgeDescriptionMessage, {
                    numberOfSuggestions: numberOfSuggestions
                }),
                icon: icon,
                handleType: (0, $50DkA.HandleActionType).Base,
                nudgeContext: $1cc6c53f8dbf58f9$var$nudgeContext,
                ...nudgeData
            });
        }
    }
});

});
parcelRegister("eYjNM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eef8c7bda009f013e8cf54eb12259e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae66078be14541b7$var$_react = $ae66078be14541b7$var$_interopRequireDefault((parcelRequire("euxye")));

var $ae66078be14541b7$var$_baseNew = $ae66078be14541b7$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $ae66078be14541b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae66078be14541b7$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $ae66078be14541b7$var$_react.default.createElement($ae66078be14541b7$var$_baseNew.default, Object.assign({
        name: "WorkItemsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$ae66078be14541b7$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $ae66078be14541b7$var$_default = module.exports.default = $ae66078be14541b7$var$WorkItemsIcon;

});


parcelRegister("HjNqP", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $6c179ea30ea3ccdc$export$bfba3ccd9d9038f9);

var $2I9KJ = parcelRequire("2I9KJ");

var $9wQWt = parcelRequire("9wQWt");
const $6c179ea30ea3ccdc$export$bfba3ccd9d9038f9 = (0, $2I9KJ.createWithI18n)((0, $9wQWt.messagesLoader));

});
parcelRegister("2I9KJ", function(module, exports) {
$parcel$export(module.exports, "createWithI18n", () => $7675ac6b4202a249$export$d71c6502467fe725);

var $e79Pd = parcelRequire("e79Pd");

var $dZXqr = parcelRequire("dZXqr");
var $icNTy = parcelRequire("icNTy");
const $7675ac6b4202a249$export$920091e3d72d80ee = (loaders)=>{
    const messagesLoader = $7675ac6b4202a249$export$99ce90405b04bcbd(loaders);
    const I18n = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $dZXqr.IntlProvider), {
            messagesLoader: messagesLoader,
            children: children
        });
    return ({ children: children })=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)(I18n, {
            children: children
        });
    };
};
const $7675ac6b4202a249$export$d71c6502467fe725 = (...loaders)=>{
    const messagesLoader = $7675ac6b4202a249$export$99ce90405b04bcbd(...loaders);
    return (component)=>{
        return (0, $icNTy.withIntlProvider)({
            messagesLoader: messagesLoader
        }, component);
    };
};
const $7675ac6b4202a249$export$99ce90405b04bcbd = (...loaders)=>async (locale)=>{
        const messagePromises = loaders.filter((e)=>!!e).map((loader)=>loader(locale));
        const loadedMessages = await Promise.allSettled(messagePromises);
        const translatedMessages = {
            messages: {},
            errors: []
        };
        loadedMessages.forEach((result)=>{
            if (result.status === 'rejected') {
                translatedMessages.errors.push(`Failed to load translations with ${result.reason}`);
                return;
            }
            translatedMessages.messages = {
                ...translatedMessages.messages,
                ...result.value
            };
        });
        return translatedMessages;
    };

});
parcelRegister("dZXqr", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $8d8acc0d4dcd0ace$export$480518999dfc4151);

var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $fGrpH = parcelRequire("fGrpH");

var $5KKyn = parcelRequire("5KKyn");

var $5KKyn = parcelRequire("5KKyn");
var $1YIbA = parcelRequire("1YIbA");

var $VtsYQ = parcelRequire("VtsYQ");

var $lPxaO = parcelRequire("lPxaO");
const $8d8acc0d4dcd0ace$var$DOUBLE_WRAP_INTL_PROVIDER_GATE = 'post-office_enable_double-wrap-intl-provider';
function $8d8acc0d4dcd0ace$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $1YIbA.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $8d8acc0d4dcd0ace$export$480518999dfc4151(props) {
    const { locale: locale } = $8d8acc0d4dcd0ace$var$useFetchLocale();
    const messages = (0, $lPxaO.useIntlMessages)(locale, props.messagesLoader, props.messages);
    const shouldDoubleWrapIntlProvider = (0, $4LDqh.default).checkGate($8d8acc0d4dcd0ace$var$DOUBLE_WRAP_INTL_PROVIDER_GATE);
    const shouldSuppressMissingTranslationErrors = (0, $4LDqh.default).checkGate((0, $VtsYQ.SUPPRESS_MISSING_TRANSLATION_ERRORS_GATE));
    const suppressMissingTranslationErrorsProps = shouldSuppressMissingTranslationErrors ? {
        onError: (0, $VtsYQ.handleError)
    } : {};
    if (!shouldDoubleWrapIntlProvider) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        locale: locale,
        messages: messages,
        ...suppressMissingTranslationErrorsProps,
        children: props.children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        locale: locale,
        messages: messages,
        ...suppressMissingTranslationErrorsProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
            locale: locale,
            messages: messages,
            ...suppressMissingTranslationErrorsProps,
            children: props.children
        })
    });
}
$8d8acc0d4dcd0ace$export$480518999dfc4151.displayName = "IntlProvider";

});
parcelRegister("lPxaO", function(module, exports) {
$parcel$export(module.exports, "useIntlMessages", () => $36f489bb61ce43ed$export$2641ec9a2025a81f);

var $fGrpH = parcelRequire("fGrpH");

var $euxye = parcelRequire("euxye");
const $36f489bb61ce43ed$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $euxye.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};

});


parcelRegister("icNTy", function(module, exports) {
$parcel$export(module.exports, "withIntlProvider", () => $2a8cd2360eabf6dc$export$a5d940130f33be3f);

var $e79Pd = parcelRequire("e79Pd");

var $dZXqr = parcelRequire("dZXqr");
const $2a8cd2360eabf6dc$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dZXqr.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                ...props
            })
        });
    };

});


parcelRegister("9wQWt", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $beacae31c9f88943$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bTOqz = parcelRequire("bTOqz");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $beacae31c9f88943$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $beacae31c9f88943$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("bLqMH")));
        case 'da':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("aXw7H")));
        case 'de':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("hkbXd")));
        case 'en-GB':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("4S8G0")));
        case 'en-US':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("pYmeK")));
        case 'en-XA':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("jVj8j")));
        case 'en-XB':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("7tX0Y")));
        case 'en-ZZ':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("jD4Mj")));
        case 'en':
            return $beacae31c9f88943$var$importHelper(await Promise.resolve((parcelRequire("bTOqz"))));
        case 'es':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("fvZaN")));
        case 'et':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("4WfE5")));
        case 'fi':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("7jjE7")));
        case 'fr':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("fE05E")));
        case 'hr':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("1sYYG")));
        case 'hu':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("fKJC0")));
        case 'it':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("96yj8")));
        case 'ja':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("bEDjr")));
        case 'ko':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("6t08c")));
        case 'nb':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("i5aRr")));
        case 'nl':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("9yXdf")));
        case 'pl':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("6cVuF")));
        case 'pt-BR':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("6eruu")));
        case 'ro':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("7cKZV")));
        case 'ru':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("fI6Et")));
        case 'sl':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("b9Niz")));
        case 'sr-RS':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("aprcR")));
        case 'sr-YR':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("7icWW")));
        case 'sr':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("fqzNB")));
        case 'sv':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("2nLVV")));
        case 'th':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("gr0PC")));
        case 'tr':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("01wPY")));
        case 'uk':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("lYElB")));
        case 'vi':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("3kMIh")));
        case 'zh-CN':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("elIZY")));
        case 'zh-TW':
            return $beacae31c9f88943$var$importHelper(await (parcelRequire("fD3Ah")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bTOqz));
    }
};

});
parcelRegister("bTOqz", function(module, exports) {
module.exports = JSON.parse('{"Check out the support documentation for more details.":[{"type":0,"value":"Check out the support documentation for more details."}],"Dismiss":[{"type":0,"value":"Dismiss"}],"Looking to enhance the agent experience?":[{"type":0,"value":"Looking to enhance the agent experience?"}],"Not now":[{"type":0,"value":"Not now"}],"Show me":[{"type":0,"value":"Show me"}],"Show me the apps":[{"type":0,"value":"Show me the apps"}],"Upgrade options":[{"type":0,"value":"Upgrade options"}],"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!":[{"type":0,"value":"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!"}],"We\'ve made some changes to imports":[{"type":0,"value":"We\'ve made some changes to imports"}],"We\u2019re having trouble with your plan":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"We\u2019ve kept you on the Standard plan of Confluence for now.":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users.":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"confluence-3p-connector-nudge.action.connect":[{"type":0,"value":"Connect now"}],"confluence-3p-connector-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"confluence-3p-connector-nudge.description":[{"type":0,"value":"You\'ve been using "},{"type":1,"value":"providerName"},{"type":0,"value":". Connect it to get richer previews and better search."}],"confluence-3p-connector-nudge.error.generic.action.tryAgain":[{"type":0,"value":"Try again"}],"confluence-3p-connector-nudge.error.generic.description":[{"type":0,"value":"Try again or ask your admin for help."}],"confluence-3p-connector-nudge.error.generic.title":[{"type":0,"value":"We\'re having trouble connecting "},{"type":1,"value":"providerName"}],"confluence-3p-connector-nudge.error.unavailable.description":[{"type":0,"value":"Try using the "},{"type":1,"value":"providerName"},{"type":0,"value":" Smart Link to connect your account, or ask your admin for help."}],"confluence-3p-connector-nudge.error.unavailable.title":[{"type":0,"value":"We couldn\'t connect your app"}],"confluence-3p-connector-nudge.title":[{"type":0,"value":"Connect "},{"type":1,"value":"providerName"}],"feedback-collector.can-be-enrolled-label.text":[{"type":0,"value":"Atlassian can contact me about this feedback. See our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"feedback-collector.enroll-in-research-label.text":[{"type":0,"value":"I\'d like to help improve Atlassian products by joining the"},{"type":1,"value":"nbsp"},{"type":1,"value":"n"},{"type":1,"value":"t"},{"type":1,"value":"t"},{"children":[{"type":0,"value":"Atlassian Research Group"}],"type":8,"value":"enrollLink"}],"feedback-collector.feedback-title-details.component":[{"type":0,"value":"For help with billing or other issues, visit our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"documentation"}],"type":8,"value":"documentationLink"},{"type":1,"value":"nbsp"},{"type":0,"value":"or contact"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"support"}],"type":8,"value":"supportLink"}],"no-notifications-fallback.learn-more-link.text":[{"type":0,"value":"Learn more about this feature"}],"no-notifications-fallback.no-notifications.text":[{"type":0,"value":"Check back soon. No notifications yet."}],"notifications.error-fallback-error-reason.text":[{"type":0,"value":"We\'re unable to load notifications"}],"notifications.error-fallback-proposed-solution.text":[{"type":0,"value":"Refresh the page or try again later"}],"post-office-team.commerce-approvals-received-author-notification-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.commerce-approvals-received-author-notification-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.confluence-recommended-following-feed.add-comment-button":[{"type":0,"value":"Comment"}],"post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text":[{"type":0,"value":"Add Emoji"}],"post-office-team.confluence-recommended-following-feed.ai-generated-content-icon-alt-text":[{"type":0,"value":"AI Generated Content"}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer":[{"type":0,"value":"Uses AI. Verify results."}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer-alt-text":[{"type":0,"value":"Information icon"}],"post-office-team.confluence-recommended-following-feed.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office-team.confluence-recommended-following-feed.blog-icon":[{"type":0,"value":"Blog icon"}],"post-office-team.confluence-recommended-following-feed.clap-button-alt-text":[{"type":0,"value":"Clap"}],"post-office-team.confluence-recommended-following-feed.database-icon":[{"type":0,"value":"Database icon"}],"post-office-team.confluence-recommended-following-feed.email-unsubscribe-text":[{"children":[{"type":0,"value":"Update your email settings"}],"type":8,"value":"trackedLink"},{"type":0,"value":" to customize or stop receiving this email."}],"post-office-team.confluence-recommended-following-feed.email.body.hello":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.confluence-recommended-following-feed.email.body.summary":[{"type":0,"value":"Here are pages your team is reading, don\'t miss out on the conversation."}],"post-office-team.confluence-recommended-following-feed.email.ios-android-text":[{"type":0,"value":"Download the Confluence mobile app on "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"iosLink"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"androidLink"},{"type":0,"value":" to read notifications and comment on the go."}],"post-office-team.confluence-recommended-following-feed.email.privacy-policy-text":[{"type":0,"value":"This email was sent by Atlassian Confluence  \u2022  "},{"children":[{"type":0,"value":"Privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"post-office-team.confluence-recommended-following-feed.email.subject":[{"type":1,"value":"name"},{"type":0,"value":", your team is working on these pages -- join the conversation"}],"post-office-team.confluence-recommended-following-feed.email.subject.variant-a":[{"type":1,"value":"name"},{"type":0,"value":", "},{"type":1,"value":"pageTitle"},{"type":0,"value":" plus more pages your team is working on"}],"post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text":[{"type":0,"value":"Confluence Icon"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted":[{"children":[{"type":1,"value":"firstUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"secondUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.no-comments":[{"type":0,"value":"Be the first to comment"}],"post-office-team.confluence-recommended-following-feed.no-reactions-text":[{"type":0,"value":"Be the first to react"}],"post-office-team.confluence-recommended-following-feed.number-of-comments":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comment"}]},"other":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comments"}]}},"pluralType":"cardinal","type":6,"value":"commentCount"}],"post-office-team.confluence-recommended-following-feed.number-of-users-reacted":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"reactionCount"}],"post-office-team.confluence-recommended-following-feed.owned-by":[{"type":0,"value":"Owned by "},{"type":1,"value":"ownerName"}],"post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text":[{"type":0,"value":"Party Popper"}],"post-office-team.confluence-recommended-following-feed.read-more-link":[{"type":0,"value":"Read more"}],"post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text":[{"type":0,"value":"Thumbs up"}],"post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text":[{"type":1,"value":"name"},{"type":0,"value":"\'s profile picture"}],"post-office-team.confluence-recommended-following-feed.whiteboard-icon":[{"type":0,"value":"Whiteboard icon"}],"post-office-team.email-with-tracking-links.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.email-with-tracking-links.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.email-with-tracking-links.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.email-with-tracking-links.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.email-with-tracking-links.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.email-with-tracking-links.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.email-with-tracking-links.test-message.email.confluence-link.text.no-translate":[{"type":0,"value":"Go to Confluence link"}],"post-office-team.email-with-tracking-links.test-message.email.jira-link.text.no-translate":[{"type":0,"value":"Go to Jira link"}],"post-office-team.email-with-tracking-links.test-message.email.trello-link.text.no-translate":[{"type":0,"value":"Go to Trello board"}],"post-office-team.push-msg-object-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.push-msg-object-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.push-msg-object-tracking.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office-team.push-msg-object-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.push-msg-object-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.push-msg-object-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.push-msg-object-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.push-msg-object-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.test-audience-message-template.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.test-audience-message-template.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.test-audience-message-template.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.test-audience-message-template.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.test-audience-message-template.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.test-audience-message-template.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.test-audience-message-template.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.test-message-groot.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.test-message-groot.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.test-message-groot.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.test-message-groot.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.test-message-groot.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.test-message-groot.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.test-message-groot.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.admin-hub.end-of-notifications.description":[{"type":0,"value":"That\'s all your notifications from the last 90 days"}],"post-office.live-nudge-demo.connecting.no-translate":[{"type":0,"value":"Connecting..."}],"post-office.live-nudge-demo.live-count.no-translate":[{"type":1,"value":"count"},{"type":0,"value":" live"}],"post-office.live-nudge-demo.main-heading.no-translate":[{"type":0,"value":"Live Nudge Demo Placement"}],"post-office.live-nudge-demo.subscription-error.no-translate":[{"type":0,"value":"Subscription Error!"}],"post-office.post-office-team-components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.post-office-team-components.email.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email":[{"type":0,"value":"You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link":[{"type":0,"value":"Get started"}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Help us improve messaging for Atlassian Admins! Answer a few short questions, and our\\n\\t\\t\\t\\t\\tResearch team will contact you for a 60-minute Zoom session if you qualify."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Share your experience for $120 USD"}],"post-office.post-office-team.push-msg-object-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.post-office-team.push-msg-object-tracking.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.post-office-team.test-message-dynamic-config-sets.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"test-messages.test-message-dynamic-config-sets.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-dynamic-config-sets.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"},{"type":0,"value":" for Dynamic Config Sets"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"Click here to visit Atlassian"}],"test-messages.test-message-dynamic-config-sets.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("bLqMH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3FAIP").then(()=>parcelRequire('7XXwC'));

});

parcelRegister("aXw7H", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("BMHdT").then(()=>parcelRequire('7opNP'));

});

parcelRegister("hkbXd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hGLfV").then(()=>parcelRequire('luXud'));

});

parcelRegister("4S8G0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ctJiT").then(()=>parcelRequire('gv9C7'));

});

parcelRegister("pYmeK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fgz4l").then(()=>parcelRequire('dOP1S'));

});

parcelRegister("jVj8j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3tAoN").then(()=>parcelRequire('3rWQQ'));

});

parcelRegister("7tX0Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dWeng").then(()=>parcelRequire('ksZAY'));

});

parcelRegister("jD4Mj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aaSQG").then(()=>parcelRequire('8UOCa'));

});

parcelRegister("fvZaN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iG7BU").then(()=>parcelRequire('aFmDt'));

});

parcelRegister("4WfE5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1cmrO").then(()=>parcelRequire('T7eKV'));

});

parcelRegister("7jjE7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4oiGq").then(()=>parcelRequire('juVIn'));

});

parcelRegister("fE05E", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("drzD6").then(()=>parcelRequire('baIgG'));

});

parcelRegister("1sYYG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("75h5Q").then(()=>parcelRequire('i6HOV'));

});

parcelRegister("fKJC0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("03l3e").then(()=>parcelRequire('iCgMW'));

});

parcelRegister("96yj8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fvC2s").then(()=>parcelRequire('2KqiM'));

});

parcelRegister("bEDjr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4WC2s").then(()=>parcelRequire('8D1A9'));

});

parcelRegister("6t08c", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2bpux").then(()=>parcelRequire('9UAdM'));

});

parcelRegister("i5aRr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1UN4Y").then(()=>parcelRequire('6rz3S'));

});

parcelRegister("9yXdf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9NccO").then(()=>parcelRequire('7QBri'));

});

parcelRegister("6cVuF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lOf0V").then(()=>parcelRequire('7kzAQ'));

});

parcelRegister("6eruu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8250a").then(()=>parcelRequire('2fKy1'));

});

parcelRegister("7cKZV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("besMe").then(()=>parcelRequire('3RQJy'));

});

parcelRegister("fI6Et", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("13KQZ").then(()=>parcelRequire('9tir5'));

});

parcelRegister("b9Niz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cRsie").then(()=>parcelRequire('9ASX2'));

});

parcelRegister("aprcR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h4Cwt").then(()=>parcelRequire('9RE03'));

});

parcelRegister("7icWW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4optG").then(()=>parcelRequire('gt91h'));

});

parcelRegister("fqzNB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7tNYy").then(()=>parcelRequire('aCW4d'));

});

parcelRegister("2nLVV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gNheo").then(()=>parcelRequire('mCCYB'));

});

parcelRegister("gr0PC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6lybw").then(()=>parcelRequire('3dXXR'));

});

parcelRegister("01wPY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8owYa").then(()=>parcelRequire('g6ZoT'));

});

parcelRegister("lYElB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e9JrB").then(()=>parcelRequire('8gww3'));

});

parcelRegister("3kMIh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Vatl").then(()=>parcelRequire('lRT1T'));

});

parcelRegister("elIZY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("65pIC").then(()=>parcelRequire('9bfKG'));

});

parcelRegister("fD3Ah", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f3JrA").then(()=>parcelRequire('1h0VP'));

});




parcelRegister("5hgiN", function(module, exports) {
$parcel$export(module.exports, "Placement", () => $f8f287b993486f35$export$af2bcbdc04a2d456);
// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

var $kHZ1U = parcelRequire("kHZ1U");

var $cS9Td = parcelRequire("cS9Td");

var $f483l = parcelRequire("f483l");
const $f8f287b993486f35$var$messageFrontends = [
    (0, $cS9Td.MessageFrontend)({
        messageTemplateId: 'jsm-live-chat'
    })
];
const $f8f287b993486f35$export$7b621692a0aa2333 = (0, $kHZ1U.PlacementFrontend).createPlacementFrontendComponent({
    messageTemplates: $f8f287b993486f35$var$messageFrontends
});
const $f8f287b993486f35$export$af2bcbdc04a2d456 = (0, $f483l.withI18n)($f8f287b993486f35$export$7b621692a0aa2333);
const $f8f287b993486f35$export$7d3d92a960f07a28 = $f8f287b993486f35$export$7b621692a0aa2333;

});
parcelRegister("kHZ1U", function(module, exports) {
$parcel$export(module.exports, "PlacementFrontend", () => $f147c9c5e3cb6323$export$55486c2b6964dcf2);
$parcel$export(module.exports, "PlacementBackend", () => $f147c9c5e3cb6323$export$d90b37843c84d1c3);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iISCq = parcelRequire("iISCq");
var $j142y = parcelRequire("j142y");

var $2vhMr = parcelRequire("2vhMr");

var $gOhos = parcelRequire("gOhos");

var $1wUjh = parcelRequire("1wUjh");

var $a5l9n = parcelRequire("a5l9n");

var $1mpEL = parcelRequire("1mpEL");

var $kvx4a = parcelRequire("kvx4a");
/**
 * GraphQL data fragment requested for the `jsm-live-chat` message template
 * delivered via this placement. The naming convention is
 * `PostOfficeMessage<PlacementId><MessageTemplateId>Data` (PascalCase) and is
 * generated server-side once the message template is registered.
 *
 * Add additional fragments here as new message templates are added that should
 * be delivered through this placement.
 */ const $f147c9c5e3cb6323$var$JSM_LIVE_CHAT_DATA_FRAGMENT = `... on PostOfficeMessageJsmLiveChatNotificationsJsmLiveChatData {
	__typename
	title
	description
	projectKey
	tenantUrl
	conversationId
}`;
const $f147c9c5e3cb6323$var$doesScopeMatchPathname = (scopeName, pathname)=>{
    if (!pathname) return false;
    const scope = (0, $kvx4a.scopes).find((scopeConfig)=>scopeConfig.name === scopeName);
    const pathnameMatcher = scope?.when?.route?.pathname;
    if (!pathnameMatcher) return true;
    if (typeof pathnameMatcher === 'string') return pathname === pathnameMatcher;
    if (typeof pathnameMatcher.equals === 'string') return pathname === pathnameMatcher.equals;
    if (typeof pathnameMatcher.matches === 'string') try {
        return new RegExp(pathnameMatcher.matches).test(pathname);
    } catch  {
        return false;
    }
    return true;
};
const $f147c9c5e3cb6323$var$placement = (0, $2vhMr.createPlacement)({
    placementId: 'jsm-live-chat-notifications',
    options: {
        choreographer: {
            isDefaultEnabled: false
        },
        hideInIsolatedCloud: false,
        subscription: {
            enabled: true
        }
    }
});
const $f147c9c5e3cb6323$var$activeScopesPreInitStage = async (input)=>{
    const { request: request, data: data } = input;
    const activeScopes = request.additionalContext?.activeScopes;
    return {
        messages: (0, $gOhos.filterEligibleMessagesByActiveScopes)(data.messages, {
            activeScopes: activeScopes,
            requestContext: request
        })
    };
};
const $f147c9c5e3cb6323$export$81df3aa6753d44e2 = $f147c9c5e3cb6323$var$placement.createFrontend;
const $f147c9c5e3cb6323$export$da912f58cb37a643 = $f147c9c5e3cb6323$var$placement.createBackend;
const $f147c9c5e3cb6323$var$JsmLiveChatSubscriptionContent = ({ Messages: Messages, variables: variables })=>{
    const { data: subscriptionData, error: subscriptionError } = (0, $a5l9n.usePlacementGraphQLSubscriptionApi)({
        dataFragments: [
            $f147c9c5e3cb6323$var$JSM_LIVE_CHAT_DATA_FRAGMENT
        ],
        variables: variables
    });
    const messages = (0, $euxye.useMemo)(()=>(0, $a5l9n.getSubscriptionMessages)(subscriptionData), [
        subscriptionData
    ]);
    if (subscriptionError) return null;
    if (messages.length === 0) return null;
    // Render all live messages — each rendered template instance owns its own
    // browser-notification side effect (dispatched once on mount). React keys
    // off `messageInstanceId` ensure a fresh component (and therefore a fresh
    // notification) per incoming event.
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: messages.map(({ data: data, ...message })=>{
            if (!data) return null;
            return /*#__PURE__*/ (0, $e79Pd.jsx)(Messages.render, {
                ...message,
                ...data
            }, message.messageInstanceId);
        })
    });
};
$f147c9c5e3cb6323$var$JsmLiveChatSubscriptionContent.displayName = "JsmLiveChatSubscriptionContent";
const $f147c9c5e3cb6323$export$55486c2b6964dcf2 = $f147c9c5e3cb6323$export$81df3aa6753d44e2((Messages)=>()=>{
        const activeScopes = (0, $iISCq.usePostOfficeContextScope)({
            scopes: $kvx4a.scopes,
            treatIntersectionAsSame: true
        });
        const activeScopeName = activeScopes.current[0]?.name;
        const { pathname: pathname } = (0, $1mpEL.usePostOfficeSearchParams)();
        const { productEdition: productEdition, subproduct: subproduct } = (0, $j142y.usePostOfficeContext)();
        const PREMIUM_EDITION = 'PREMIUM_EDITION';
        const isScopePathnameAligned = (0, $euxye.useMemo)(()=>activeScopeName ? $f147c9c5e3cb6323$var$doesScopeMatchPathname(activeScopeName, pathname) : false, [
            activeScopeName,
            pathname
        ]);
        const variables = (0, $euxye.useMemo)(()=>activeScopeName && isScopePathnameAligned ? {
                activeScopes: activeScopeName,
                context: {
                    subproduct: subproduct
                }
            } : null, [
            activeScopeName,
            isScopePathnameAligned,
            subproduct
        ]);
        if (!variables || productEdition !== PREMIUM_EDITION) return null;
        return /*#__PURE__*/ (0, $e79Pd.jsx)($f147c9c5e3cb6323$var$JsmLiveChatSubscriptionContent, {
            Messages: Messages,
            variables: variables
        });
    });
const $f147c9c5e3cb6323$export$d90b37843c84d1c3 = $f147c9c5e3cb6323$export$da912f58cb37a643({
    stages: (placementMessageStages)=>{
        const { init: init, postInit: postInit } = (0, $1wUjh.defaultBackendPlacementStages)(placementMessageStages);
        return {
            preInit: $f147c9c5e3cb6323$var$activeScopesPreInitStage,
            init: init,
            postInit: postInit
        };
    }
});

});
parcelRegister("kvx4a", function(module, exports) {
$parcel$export(module.exports, "scopes", () => $ec30e77e041d8839$export$54a06e3f4a159ad8);
const $ec30e77e041d8839$export$54a06e3f4a159ad8 = [
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    }
];

});


parcelRegister("cS9Td", function(module, exports) {
$parcel$export(module.exports, "MessageFrontend", () => $1575a975cab6831b$export$fa9bb46961aca2cc);

var $euxye = parcelRequire("euxye");

var $8hQRz = parcelRequire("8hQRz");

var $kHZ1U = parcelRequire("kHZ1U");

var $9KuNm = parcelRequire("9KuNm");

var $fGrpH = parcelRequire("fGrpH");
/**
 * JSM icon used as the OS-level notification thumbnail.
 *
 * Sourced from the Jira `live-chat-common` ProjectSubscription hook (see
 * `jira/src/packages/servicedesk/live-chat-common/src/hooks/ProjectSubscription.tsx`).
 *
 * Encoded as a URL-encoded SVG data URL rather than base64 because Safari
 * does not render base64 SVGs in the Web Notifications API. Keep this in sync
 * with the Jira-side copy if the icon ever changes.
 */ const $1575a975cab6831b$var$JSM_ICON_DATA_URL = 'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23ffc716%22%20d%3D%22M0%206a6%206%200%200%201%206-6h12a6%206%200%200%201%206%206v12a6%206%200%200%201-6%206H6a6%206%200%200%201-6-6z%22%2F%3E%3Cpath%20fill%3D%22%23101214%22%20d%3D%22M13.744%2010.156h4.578c.688%200%20.922.654.503%201.174l-7.16%208.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538%203.521H5.63c-.688%200-.923-.654-.504-1.173l7.16-8.837c2.315%201.844%202.063%204.728.386%206.875z%22%2F%3E%3C%2Fsvg%3E';
/**
 * Build the deep-link URL used when the user clicks the browser notification.
 *
 * Example: `https://abinashnayakjsm.jira-dev.com/jira/servicedesk/projects/JHC/live-chat`
 */ const $1575a975cab6831b$var$buildLiveChatUrl = (tenantUrl, projectKey, conversationId)=>{
    if (!tenantUrl || !projectKey) return undefined;
    const trimmed = tenantUrl.replace(/\/$/, '');
    const base = `${trimmed}/jira/servicedesk/projects/${projectKey}/live-chat`;
    return conversationId ? `${base}?conversationId=${encodeURIComponent(conversationId)}` : base;
};
/**
 * Build a stable, cross-tab deduplication key for a notification.
 *
 * Uses the null byte (\x00) as a field separator to prevent key collisions
 * from titles/descriptions that naturally contain hyphens or other delimiters.
 */ const $1575a975cab6831b$var$buildNotificationLockKey = (title, description, conversationId)=>{
    const identity = [
        title,
        description,
        conversationId ?? ''
    ].join('\x00');
    return `jsm-live-chat-notification:${identity}`;
};
/**
 * How long (ms) the winning tab holds the deduplication lock after dispatching.
 *
 * All other tabs race to acquire the same lock within this window. Because the
 * subscription event reaches all tabs nearly simultaneously (~0–50 ms apart),
 * 3 000 ms is a safe margin: long enough to cover any realistic tab jitter,
 * short enough that a genuinely new message with the same text fired seconds
 * later is not accidentally suppressed.
 */ const $1575a975cab6831b$var$NOTIFICATION_LOCK_HOLD_MS = 3000;
/**
 * Create and configure a Notification object with its onclick handler.
 */ const $1575a975cab6831b$var$dispatchNotification = ({ title: title, description: description, projectKey: projectKey, tenantUrl: tenantUrl, conversationId: conversationId }, fireAnalyticsEvent)=>{
    try {
        const notification = new Notification(title, {
            body: description,
            icon: $1575a975cab6831b$var$JSM_ICON_DATA_URL
        });
        notification.onclick = (event)=>{
            // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-all-member-expressions
            event.preventDefault();
            const target = $1575a975cab6831b$var$buildLiveChatUrl(tenantUrl, projectKey, conversationId);
            if (!target) {
                notification.close();
                return;
            }
            fireAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'notification',
                actionSubjectId: 'jsmLiveChatNotifications',
                eventType: 'ui',
                attributes: {
                    targetUrl: target,
                    tenantUrl: tenantUrl,
                    projectKey: projectKey,
                    conversationId: conversationId,
                    title: title
                }
            });
            const opened = globalThis?.window?.open(target, '_blank', 'noopener,noreferrer');
            if (opened) opened.focus();
            notification.close();
        };
    } catch  {
    // Some browsers throw on certain notification options. Swallow — the
    // notification is best-effort and must never break the placement.
    }
};
/**
 * Dispatch a browser notification using the Web Notifications API.
 * Cross-tab deduplication via Web Locks API is used when available.
 * Fallback: if the Web Locks API is unavailable (non-secure context, very old
 * browsers, or SSR) we dispatch without deduplication — same as before.
 *
 * On click, focus the existing tab / open a new tab pointing at the live chat
 * page for the given project + (optional) conversation.
 */ const $1575a975cab6831b$var$triggerBrowserNotification = ({ title: title, description: description, projectKey: projectKey, tenantUrl: tenantUrl, conversationId: conversationId }, fireAnalyticsEvent)=>{
    if (typeof globalThis.window === 'undefined' || typeof globalThis.window?.Notification === 'undefined') {
        fireAnalyticsEvent({
            action: 'failed',
            actionSubject: 'notification',
            actionSubjectId: 'jsmLiveChatNotifications',
            eventType: 'track',
            attributes: {
                reason: 'window or notification not available',
                tenantUrl: tenantUrl,
                projectKey: projectKey,
                conversationId: conversationId,
                title: title
            }
        });
        return;
    }
    if (globalThis.window?.Notification?.permission !== 'granted') {
        fireAnalyticsEvent({
            action: 'failed',
            actionSubject: 'notification',
            actionSubjectId: 'jsmLiveChatNotifications',
            eventType: 'track',
            attributes: {
                reason: 'notification permission not granted',
                tenantUrl: tenantUrl,
                projectKey: projectKey,
                conversationId: conversationId,
                title: title
            }
        });
        return;
    }
    const notificationParams = {
        title: title,
        description: description,
        projectKey: projectKey,
        tenantUrl: tenantUrl,
        conversationId: conversationId
    };
    // Use the Web Locks API for cross-tab deduplication when available.
    if (typeof globalThis.navigator?.locks?.request === 'function') {
        const lockKey = $1575a975cab6831b$var$buildNotificationLockKey(title, description, conversationId);
        // `ifAvailable: true` makes the request non-blocking: the callback
        // receives the lock immediately if it is free, or `null` if another tab
        // already holds it for this exact notification identity.
        //
        // IMPORTANT: the callback must return a Promise that stays pending for
        // NOTIFICATION_LOCK_HOLD_MS. If we return synchronously (or resolve
        // immediately), the lock is released before other tabs have had a chance
        // to attempt acquisition — every tab would then win its own lock and fire
        // its own notification, defeating the deduplication entirely.
        globalThis.navigator.locks.request(lockKey, {
            ifAvailable: true
        }, (lock)=>{
            if (lock === null) // Another tab already holds the lock for this notification — skip.
            return;
            fireAnalyticsEvent({
                action: 'success',
                actionSubject: 'notification',
                actionSubjectId: 'jsmLiveChatNotifications',
                eventType: 'track',
                attributes: {
                    reason: 'lock acquired',
                    tenantUrl: tenantUrl,
                    projectKey: projectKey,
                    conversationId: conversationId,
                    title: title
                }
            });
            $1575a975cab6831b$var$dispatchNotification(notificationParams, fireAnalyticsEvent);
            // Hold the lock for NOTIFICATION_LOCK_HOLD_MS so that other tabs
            // that arrive within that window see the lock as taken and bail out.
            return new Promise((resolve)=>{
                setTimeout(resolve, $1575a975cab6831b$var$NOTIFICATION_LOCK_HOLD_MS);
            });
        });
        return;
    }
    // Fallback: Web Locks API is unavailable — dispatch without deduplication.
    $1575a975cab6831b$var$dispatchNotification(notificationParams, fireAnalyticsEvent);
};
const $1575a975cab6831b$export$e7843a8f64a8d87c = (0, $kHZ1U.PlacementBackend).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $9KuNm.assertMessageTemplateContext),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            // Subscription / GraphQL payloads may include extra fields injected by
            // the producer. Keep validation permissive here and rely on the
            // generated assert in `transformMetadata` for the inbound shape.
            validate: (0, $8hQRz.noValidation)(),
            stage: async ({ message: message })=>({
                    title: message.context.title,
                    description: message.context.description,
                    projectKey: message.context.projectKey,
                    tenantUrl: message.context.tenantUrl,
                    conversationId: message.context.conversationId,
                    scopes: message.context.scopes
                })
        }
    }));
const $1575a975cab6831b$export$fa9bb46961aca2cc = (0, $kHZ1U.PlacementFrontend).createMessageFrontend({
    render: {
        validate: (0, $8hQRz.noValidation)(),
        Component: ({ title: title, description: description, projectKey: projectKey, tenantUrl: tenantUrl, conversationId: conversationId })=>{
            // Each message instance is mounted with a unique React key
            // (`messageInstanceId`) so this effect runs exactly once per incoming
            // GraphQL subscription event. `firedRef` is a defensive guard against
            // React 18 strict-mode double-invocation in development.
            const firedRef = (0, $euxye.useRef)(false);
            const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
            (0, $euxye.useEffect)(()=>{
                if (firedRef.current) return;
                firedRef.current = true;
                $1575a975cab6831b$var$triggerBrowserNotification({
                    title: title,
                    description: description,
                    projectKey: projectKey,
                    tenantUrl: tenantUrl,
                    conversationId: conversationId
                }, fireAnalyticsEvent);
            }, [
                title,
                description,
                projectKey,
                tenantUrl,
                conversationId,
                fireAnalyticsEvent
            ]);
            // This message template is intentionally headless — the visible
            // surface is the OS-level browser notification.
            return null;
        }
    }
});

});
parcelRegister("9KuNm", function(module, exports) {
$parcel$export(module.exports, "assertMessageTemplateContext", () => $c0962c0dcd42b552$export$a7a9523472993e97);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $bCHUl = parcelRequire("bCHUl");
function $c0962c0dcd42b552$export$a7a9523472993e97(value) {
    const result = $c0962c0dcd42b552$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $bCHUl.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $c0962c0dcd42b552$export$226b3eccf92c9ed9(value) {
    const result = $c0962c0dcd42b552$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $c0962c0dcd42b552$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('title' in value)) errors.push({
            path: 'value["title"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["title"] !== 'string') errors.push({
            path: 'value["title"]',
            expected: 'string',
            value: value["title"]
        });
        if (!('description' in value)) errors.push({
            path: 'value["description"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["description"] !== 'string') errors.push({
            path: 'value["description"]',
            expected: 'string',
            value: value["description"]
        });
        if ('projectKey' in value && value['projectKey'] !== undefined) {
            if (typeof value["projectKey"] !== 'string') errors.push({
                path: 'value["projectKey"]',
                expected: 'string',
                value: value["projectKey"]
            });
        }
        if ('tenantUrl' in value && value['tenantUrl'] !== undefined) {
            if (typeof value["tenantUrl"] !== 'string') errors.push({
                path: 'value["tenantUrl"]',
                expected: 'string',
                value: value["tenantUrl"]
            });
        }
        if ('conversationId' in value && value['conversationId'] !== undefined) {
            if (typeof value["conversationId"] !== 'string') errors.push({
                path: 'value["conversationId"]',
                expected: 'string',
                value: value["conversationId"]
            });
        }
        if (!('scopes' in value)) errors.push({
            path: 'value["scopes"]',
            expected: 'object[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["scopes"])) errors.push({
                path: 'value["scopes"]',
                expected: 'array',
                value: value["scopes"]
            });
            if (Array.isArray(value["scopes"])) value["scopes"].forEach((element, index)=>{
                if (typeof element !== 'object' || element === null || Array.isArray(element)) errors.push({
                    path: 'element',
                    expected: 'object',
                    value: element
                });
                else {
                    if (!('name' in element)) errors.push({
                        path: 'element["name"]',
                        expected: '"jira/servicedesk"',
                        value: undefined
                    });
                    else if (element["name"] !== "jira/servicedesk") errors.push({
                        path: 'element["name"]',
                        expected: "jira/servicedesk",
                        value: element["name"]
                    });
                }
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}

});


parcelRegister("f483l", function(module, exports) {
$parcel$export(module.exports, "withI18n", () => $9ed7cd06a7097f64$export$bfba3ccd9d9038f9);

var $2I9KJ = parcelRequire("2I9KJ");

var $4FSVX = parcelRequire("4FSVX");
const $9ed7cd06a7097f64$export$bfba3ccd9d9038f9 = (0, $2I9KJ.createWithI18n)((0, $4FSVX.messagesLoader));

});
parcelRegister("4FSVX", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $612c16ab74fb9062$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $brfN8 = parcelRequire("brfN8");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $612c16ab74fb9062$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $612c16ab74fb9062$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("ed3cF")));
        case 'da':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("93jgY")));
        case 'de':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("4A8o5")));
        case 'en-GB':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("6i6zn")));
        case 'en-US':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("9yik7")));
        case 'en-XA':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("7hK7p")));
        case 'en-XB':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("1SebY")));
        case 'en-ZZ':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("1i8kb8")));
        case 'en':
            return $612c16ab74fb9062$var$importHelper(await Promise.resolve((parcelRequire("brfN8"))));
        case 'es':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("dnDWK")));
        case 'et':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("kJlXh")));
        case 'fi':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("d07PI")));
        case 'fr':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("fb6MG")));
        case 'hr':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("lAHps")));
        case 'hu':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("2iTgm")));
        case 'it':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("fYCHA")));
        case 'ja':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("dFxQa")));
        case 'ko':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("7CENQ")));
        case 'nb':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("2cEIC")));
        case 'nl':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("cRdVj")));
        case 'pl':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("3tyYT")));
        case 'pt-BR':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("5282j")));
        case 'ro':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("bEPeY")));
        case 'ru':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("37N73")));
        case 'sl':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("bYmQS")));
        case 'sr-RS':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("j6Q3i")));
        case 'sr-YR':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("cHfH5")));
        case 'sr':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("i3173")));
        case 'sv':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("23Qx1")));
        case 'th':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("eJkoB")));
        case 'tr':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("hgMWQ")));
        case 'uk':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("lRZMB")));
        case 'vi':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("gJqsv")));
        case 'zh-CN':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("e0r2q")));
        case 'zh-TW':
            return $612c16ab74fb9062$var$importHelper(await (parcelRequire("031Fp")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($brfN8));
    }
};

});
parcelRegister("brfN8", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("ed3cF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hVdJb").then(()=>parcelRequire('ljZHI'));

});

parcelRegister("93jgY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Hg1w").then(()=>parcelRequire('7s8iJ'));

});

parcelRegister("4A8o5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k6ge3").then(()=>parcelRequire('lOJA0'));

});

parcelRegister("6i6zn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("23fyn").then(()=>parcelRequire('8J9LP'));

});

parcelRegister("9yik7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9VyT1").then(()=>parcelRequire('fM4R5'));

});

parcelRegister("7hK7p", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fV0R7").then(()=>parcelRequire('6Bq25'));

});

parcelRegister("1SebY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ikir0").then(()=>parcelRequire('fVsms'));

});

parcelRegister("1i8kb8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ezHWQ").then(()=>parcelRequire('fqBhv'));

});

parcelRegister("dnDWK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5I4Sq").then(()=>parcelRequire('3EWYP'));

});

parcelRegister("kJlXh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("42os8").then(()=>parcelRequire('8Ei1D'));

});

parcelRegister("d07PI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2qr42").then(()=>parcelRequire('iLZRy'));

});

parcelRegister("fb6MG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bnbeB").then(()=>parcelRequire('5stgm'));

});

parcelRegister("lAHps", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jFQ2T").then(()=>parcelRequire('frXb2'));

});

parcelRegister("2iTgm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iTFhQ").then(()=>parcelRequire('dWnGR'));

});

parcelRegister("fYCHA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e34bV").then(()=>parcelRequire('2KNfN'));

});

parcelRegister("dFxQa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8f80h").then(()=>parcelRequire('4OxPY'));

});

parcelRegister("7CENQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jCTxU").then(()=>parcelRequire('isEEk'));

});

parcelRegister("2cEIC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kTlFr").then(()=>parcelRequire('22Z6j'));

});

parcelRegister("cRdVj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gw0oI").then(()=>parcelRequire('eYVuN'));

});

parcelRegister("3tyYT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eS2Pl").then(()=>parcelRequire('iTUtU'));

});

parcelRegister("5282j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dE75Z").then(()=>parcelRequire('8Ia0Q'));

});

parcelRegister("bEPeY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aeR5i").then(()=>parcelRequire('5hLAa'));

});

parcelRegister("37N73", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gVYjm").then(()=>parcelRequire('l0uaM'));

});

parcelRegister("bYmQS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("baOHp").then(()=>parcelRequire('faYqQ'));

});

parcelRegister("j6Q3i", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4ABfx").then(()=>parcelRequire('12msn'));

});

parcelRegister("cHfH5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5xxk6").then(()=>parcelRequire('9ZoTj'));

});

parcelRegister("i3173", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iQm1t").then(()=>parcelRequire('9CmA0'));

});

parcelRegister("23Qx1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dSGU8").then(()=>parcelRequire('lEe5a'));

});

parcelRegister("eJkoB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6oMYy").then(()=>parcelRequire('4QBjT'));

});

parcelRegister("hgMWQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("daEFn").then(()=>parcelRequire('RkTqx'));

});

parcelRegister("lRZMB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dP0Da").then(()=>parcelRequire('bEDzt'));

});

parcelRegister("gJqsv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8YSRf").then(()=>parcelRequire('6b9w4'));

});

parcelRegister("e0r2q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ba5Hn").then(()=>parcelRequire('cUc5P'));

});

parcelRegister("031Fp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8anFM").then(()=>parcelRequire('zJA1r'));

});




parcelRegister("hTmoz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f0b64f1091b7598$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $kfYCc = parcelRequire("kfYCc");

var $6m9Nx = parcelRequire("6m9Nx");

var $jlh1Q = parcelRequire("jlh1Q");

var $9fViR = parcelRequire("9fViR");

var $8DDUN = parcelRequire("8DDUN");
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $2f0b64f1091b7598$var$AppProvider({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $8DDUN.useIsInsideAppProvider)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jlh1Q.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6m9Nx.InsideAppProviderContext).Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kfYCc.AppProviderThemingEnabledContext).Provider, {
            value: true,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9fViR.default), {
                defaultColorMode: defaultColorMode,
                defaultTheme: defaultTheme,
                children: routerLinkProvider
            })
        })
    });
}
$2f0b64f1091b7598$var$AppProvider.displayName = "AppProvider";
var $2f0b64f1091b7598$export$2e2bcd8739ae039 = $2f0b64f1091b7598$var$AppProvider;

});

parcelRegister("kLjnO", function(module, exports) {
$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $313d08a25078c89c$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $313d08a25078c89c$export$e0241c84ce5db240);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6CfY5 = parcelRequire("6CfY5");

var $6DzQn = parcelRequire("6DzQn");

var $l7vxt = parcelRequire("l7vxt");

var $iHdCg = parcelRequire("iHdCg");
const $313d08a25078c89c$var$additionalAttributesDefaultValue = {};
const $313d08a25078c89c$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady = true, experience: experience, experienceId: experienceId = null, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes = $313d08a25078c89c$var$additionalAttributesDefaultValue, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iHdCg.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$313d08a25078c89c$export$a5efa46877be148f.displayName = "ViewExperienceTrackingProvider";
var $313d08a25078c89c$export$2e2bcd8739ae039 = $313d08a25078c89c$export$a5efa46877be148f;
const $313d08a25078c89c$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders = null })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DzQn.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l7vxt.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iHdCg.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$313d08a25078c89c$export$e0241c84ce5db240.displayName = "SubExperienceTrackingProvider";

});
parcelRegister("iHdCg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ddb145ffb11cb1f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $iYYeq = parcelRequire("iYYeq");


var $6DzQn = parcelRequire("6DzQn");
class $0ddb145ffb11cb1f$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props), this.onPending = (experienceTrackerId)=>{
            this.shouldTrackExperience = true;
            if ((0, $i860n.fg)('jfp-magma-fix-experience-tracker-concurrency')) this.pendingExperienceTrackerIds.add(experienceTrackerId);
            else this.pendingCount += 1;
            this.checkAndStartTimer();
        }, this.onClearPending = (experienceTrackerId)=>{
            if ((0, $i860n.fg)('jfp-magma-fix-experience-tracker-concurrency')) this.pendingExperienceTrackerIds.delete(experienceTrackerId);
        }, // TODO: Make this required on cleanup of: jfp-magma-fix-experience-tracker-concurrency
        this.onSuccess = (experienceTrackerId)=>{
            if (experienceTrackerId && (0, $i860n.fg)('jfp-magma-fix-experience-tracker-concurrency')) this.pendingExperienceTrackerIds.delete(experienceTrackerId);
            else this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        }, this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $a196702bd494009a$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        }, this.pendingExperienceTrackerIds = new Set();
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name,
                ...this.props?.additionalAttributes
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            if ((0, $i860n.fg)('jfp-magma-fix-experience-tracker-concurrency')) {
                if (this.pendingExperienceTrackerIds.size === 0) this.trackExperience({
                    wasExperienceSuccesful: true
                });
            } else if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        if ((0, $i860n.fg)('jfp-magma-fix-experience-tracker-concurrency')) this.pendingExperienceTrackerIds.clear();
        else this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onClearPending: this.onClearPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $iYYeq.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DzQn.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}
$0ddb145ffb11cb1f$export$2e2bcd8739ae039.displayName = "ExperienceTrackingProvider";

});


parcelRegister("1lRyZ", function(module, exports) {
$parcel$export(module.exports, "SidebarNav4ControllerProvider", () => $4eea5f6e62ca859f$export$ec25d268893d889d);
$parcel$export(module.exports, "useSidebarNav4Controller", () => $4eea5f6e62ca859f$export$641950c86d73374);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aK5Al = parcelRequire("aK5Al");
const $4eea5f6e62ca859f$var$SidebarNav4ControllerContext = /*#__PURE__*/ (0, $euxye.createContext)(null);
function $4eea5f6e62ca859f$export$ec25d268893d889d(props) {
    const { children: children, controlledPath: initialControlledPath = null } = props;
    const [controlledPath, setControlledPath] = (0, $euxye.useState)(initialControlledPath); // null means "not being controlled"
    const sidebarNav4Controller = (0, $euxye.useMemo)(()=>({
            // is any path in Navigation a controlled one
            isControlledNav: controlledPath !== null,
            isControlledPath: (0, $aK5Al.isSelectedPath)(controlledPath ?? []),
            setControlledPath: setControlledPath
        }), [
        controlledPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4eea5f6e62ca859f$var$SidebarNav4ControllerContext.Provider, {
        value: sidebarNav4Controller
    }, children);
}
$4eea5f6e62ca859f$export$ec25d268893d889d.displayName = "SidebarNav4ControllerProvider";
function $4eea5f6e62ca859f$export$641950c86d73374() {
    const context = (0, $euxye.useContext)($4eea5f6e62ca859f$var$SidebarNav4ControllerContext);
    if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
    return context;
}

});

parcelRegister("jG3eR", function(module, exports) {
$parcel$export(module.exports, "ScreenSpaceFlagsPlacement", () => $90fe528e37df9998$export$f6564e60882bdf90);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5fkf9 = parcelRequire("5fkf9");

var $i860n = parcelRequire("i860n");

var $iQPOZ = parcelRequire("iQPOZ");

var $k11SN = parcelRequire("k11SN");

var $czLPq = parcelRequire("czLPq");

var $lDSFV = parcelRequire("lDSFV");


var $jfW0Y = parcelRequire("jfW0Y");
const $90fe528e37df9998$var$PLACEMENT_ID = 'screen-space-flags';
const $90fe528e37df9998$export$f6564e60882bdf90 = ()=>{
    const isRestrictedSynthetic = (0, $jfW0Y.isRestrictedFromPostOfficeSynthetic)();
    const flagsService = (0, $iQPOZ.useFlagsService)();
    const stablePlacementProps = (0, $euxye.useMemo)(()=>({
            jiraFlagsService: {
                dismissFlag: flagsService.dismissFlag,
                hasFlag: flagsService.hasFlag,
                showFlag: flagsService.showFlag
            }
        }), [
        flagsService?.dismissFlag,
        flagsService?.hasFlag,
        flagsService?.showFlag
    ]);
    if (false || (0, $k11SN.default)((0, $4a7259f4b0dbf3a6$export$37d4bb5bc0e315db)) || isRestrictedSynthetic) return null;
    return (0, $i860n.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lDSFV.ScreenSpaceFlagPlacementPreviewSwitcher), {
        // https://switcheroo.atlassian.com/ui/gates/8fe500fb-6c32-48c7-be3f-caf511e97a8e/key/post-office_enable_screen-space-preview_jfe
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $czLPq.default), {
        placementId: $90fe528e37df9998$var$PLACEMENT_ID,
        PlacementComponent: (0, $5fkf9.default),
        disableInitialData: true,
        placementProps: stablePlacementProps
    })) : null;
};
$90fe528e37df9998$export$f6564e60882bdf90.displayName = "ScreenSpaceFlagsPlacement";

});
parcelRegister("5fkf9", function(module, exports) {
$parcel$export(module.exports, "ScreenSpaceFlagsPlacementComponent", () => $bca97c0af8f30af9$export$c60b43809441c5b0);
$parcel$export(module.exports, "default", () => $bca97c0af8f30af9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $iISCq = parcelRequire("iISCq");

var $7Cbbq = parcelRequire("7Cbbq");

var $euxye = parcelRequire("euxye");

var $2amfq = parcelRequire("2amfq");


var $ek6Zj = parcelRequire("ek6Zj");

var $7k8gw = parcelRequire("7k8gw");
const $bca97c0af8f30af9$export$c32237a999261c49 = (input)=>(0, $iISCq.createMatchScopes)({
        scopes: $2amfq.scopes
    })(input);
const $bca97c0af8f30af9$export$c60b43809441c5b0 = (0, $ek6Zj.withScreenSpaceFlagsIntlProvider)((0, $7Cbbq.createPlacementComponent)((0, $2a944e02f94c71f9$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7k8gw.ScreenSpaceFlagsPlacement), {
        ...props
    });
}), {
    choreographer: {
        isDefaultEnabled: true
    }
}));
var $bca97c0af8f30af9$export$2e2bcd8739ae039 = $bca97c0af8f30af9$export$c60b43809441c5b0;

});
parcelRegister("7Cbbq", function(module, exports) {
$parcel$export(module.exports, "createPlacementComponent", () => $50bf1e2224532fe4$export$8a57effc6307f916);

var $3KJc4 = parcelRequire("3KJc4");
const $50bf1e2224532fe4$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $3KJc4.createPlacementComponent)(placementId, Component, placementConfigurationOptions);

});
parcelRegister("3KJc4", function(module, exports) {
$parcel$export(module.exports, "createPlacementComponent", () => $4d6e2d3300c320f0$export$8a57effc6307f916);

var $e79Pd = parcelRequire("e79Pd");

var $lRYAe = parcelRequire("lRYAe");

var $3YKjt = parcelRequire("3YKjt");
var $khHng = parcelRequire("khHng");

var $hDw0T = parcelRequire("hDw0T");

var $1o7Ue = parcelRequire("1o7Ue");

var $e1mDe = parcelRequire("e1mDe");

var $62BGq = parcelRequire("62BGq");
var $3HcP9 = parcelRequire("3HcP9");

var $3oVpu = parcelRequire("3oVpu");
const $4d6e2d3300c320f0$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $3oVpu.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $lRYAe.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $3YKjt.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $khHng.useStableObject)(context);
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $62BGq.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hDw0T.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3HcP9.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $4d6e2d3300c320f0$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $4d6e2d3300c320f0$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $e1mDe.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $1o7Ue.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("hDw0T", function(module, exports) {
$parcel$export(module.exports, "usePlacementFetchingContext", () => $c7424352a57a8fa1$export$e1e2cdb0425a9fa8);
$parcel$export(module.exports, "useOptionalPlacementFetchingContext", () => $c7424352a57a8fa1$export$e6d4e8801dff09b9);
$parcel$export(module.exports, "PlacementFetchingProvider", () => $c7424352a57a8fa1$export$5f25a6ddf0324fa8);
$parcel$export(module.exports, "MaybePlacementFetchingProvider", () => $c7424352a57a8fa1$export$a088c81282679a25);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $c7424352a57a8fa1$export$afec669dc416ee7e = /*#__PURE__*/ (0, $euxye.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $c7424352a57a8fa1$export$e1e2cdb0425a9fa8 = ()=>(0, $euxye.useContext)($c7424352a57a8fa1$export$afec669dc416ee7e);
const $c7424352a57a8fa1$export$e6d4e8801dff09b9 = ()=>{
    try {
        return (0, $euxye.useContext)($c7424352a57a8fa1$export$afec669dc416ee7e);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error) {
        return undefined;
    }
};
const $c7424352a57a8fa1$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $euxye.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($c7424352a57a8fa1$export$afec669dc416ee7e.Provider, {
        value: value,
        children: children
    });
};
$c7424352a57a8fa1$export$5f25a6ddf0324fa8.displayName = "PlacementFetchingProvider";
const $c7424352a57a8fa1$export$a088c81282679a25 = ({ fetch: fetch, children: children })=>{
    if (!fetch) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($c7424352a57a8fa1$export$5f25a6ddf0324fa8, {
        fetch: fetch,
        children: children
    });
};
$c7424352a57a8fa1$export$a088c81282679a25.displayName = "MaybePlacementFetchingProvider";

});

parcelRegister("e1mDe", function(module, exports) {
$parcel$export(module.exports, "useComponentErrorHandling", () => $17bdac7eb918cbfd$export$3d127465d22fe4e5);

var $euxye = parcelRequire("euxye");
const $17bdac7eb918cbfd$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $euxye.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});



parcelRegister("2amfq", function(module, exports) {
$parcel$export(module.exports, "scopes", () => $df6d885d9d240683$export$54a06e3f4a159ad8);
const $df6d885d9d240683$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/overview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'overview'
                }
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'atlassian-apps'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'shadow-it-apps'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-requests',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-requests'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'app-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/data-residency',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-residency'
                }
            }
        }
    },
    {
        name: 'admin/encryption',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'encryption'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'admin/backups',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'backups'
                }
            }
        }
    },
    {
        name: 'admin/rovo',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'rovo'
                }
            }
        }
    },
    {
        name: 'admin/units',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/user-connected-apps',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-connected-apps'
                }
            }
        }
    },
    {
        name: 'admin/changelog',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'changelog'
                }
            }
        }
    },
    {
        name: 'admin/product-insights',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'product-insights'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-welcome',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/welcome'
                }
            }
        }
    },
    {
        name: 'confluence/space-overview',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/[^/]+/overview.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^(?!.*edit).*wiki/spaces/.*/pages.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages-with-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*/pages/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^(?!.*edit).*wiki/spaces/.*/blog.*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-with-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*/blog/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-content',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/*/.*'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-space-settings',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.+?/settings(/.*)?$'
                }
            }
        }
    },
    {
        name: 'confluence/blogs',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/(?!.*/edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/whiteboard',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/.*whiteboard.*'
                }
            }
        }
    },
    {
        name: 'confluence/slides',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/slide/.*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/software',
        when: {
            context: {
                product: 'jira',
                subproduct: 'software'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/issue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse/.*?'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'list'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list/detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/risk-insights',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/settings/change-management?tab=risk-insights'
                }
            }
        }
    },
    {
        name: 'jira/itsm/incidents-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/incidents/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/get-started',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/get-started'
                }
            }
        }
    },
    {
        name: 'jira/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'projects/selectedissue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'projects'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/global-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '/issues'
                },
                search: {
                    matches: '.*filter.*'
                }
            }
        }
    },
    {
        name: 'jira/issues-full-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        name: 'jira/helpcenter',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/helpcenter'
                }
            }
        }
    },
    {
        name: 'jira/ops',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops'
                }
            }
        }
    },
    {
        // Jira Plans timeline/list view
        name: 'jira/plan/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/timeline'
                }
            }
        }
    },
    {
        // Jira Plans calendar view
        name: 'jira/plan/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/calendar'
                }
            }
        }
    },
    {
        // Jira Plans program board
        name: 'jira/plan/program',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/program'
                }
            }
        }
    },
    {
        // Any pages within Jira Plan
        name: 'jira/plan',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/issues/?$'
                }
            }
        }
    },
    {
        name: 'jira/ops/alerts',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-details',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/integration',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/integrations/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team-policies',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/policies'
                }
            }
        }
    },
    {
        name: 'jira/ops/group-detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/group-detail'
                }
            }
        }
    },
    {
        name: 'jira/ops/heartbeats',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/heartbeats'
                }
            }
        }
    },
    {
        name: 'jira/ops/who-is-on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/who-is-on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-notifications',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/personal/alert-notifications'
                }
            }
        }
    },
    {
        name: 'jira/settings/products/ops/incoming-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/products/ops/incoming-call(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/settings/automation',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'settings/automation'
                }
            }
        }
    },
    {
        name: 'jira/for-you',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/for-you'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types/cases',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types/category/cases'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/projects/incidents',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/section/incidents/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/business/board/not/embedded',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*/boards/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*/boards/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*/boards/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*/boards/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/board/not/embedded',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/boards/(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/boards/.*?/backlog(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/list-detail-view',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*list.*'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/software/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        // Any project route in JSW
        name: 'jira/software/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JSW
        name: 'jira/software/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Any project route in JWM
        name: 'jira/business/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JWM
        name: 'jira/business/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Project directory
        name: 'jira/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/projects'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/.+?/list'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/project-summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        name: 'jira/software/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/[^/]+)?/projects/[^/]+/boards'
                }
            }
        }
    },
    {
        name: 'loom/all',
        when: {
            context: {
                product: 'loom'
            }
        }
    },
    {
        name: 'loom/home',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'home'
                }
            }
        }
    },
    {
        name: 'loom/looms/videos',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'looms/videos'
                }
            }
        }
    },
    {
        name: 'loom/meetings',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'meetings'
                }
            }
        }
    },
    {
        name: 'loom/notifications/all',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'notifications/all'
                }
            }
        }
    },
    {
        name: 'loom/watch-later',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'watch-later'
                }
            }
        }
    },
    {
        name: 'loom/history',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'history'
                }
            }
        }
    },
    {
        name: 'loom/settings/account',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/account'
                }
            }
        }
    },
    {
        name: 'loom/settings/workspace',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/workspace'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/cmp/project-settings/project-config/issuelayout',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/issuelayout'
                }
            }
        }
    },
    {
        name: 'studio/rovo-agents',
        when: {
            context: {
                product: 'atlassianStudio',
                subproduct: 'rovo-agents'
            }
        }
    },
    {
        name: 'studio/all',
        when: {
            context: {
                product: 'atlassianStudio'
            }
        }
    },
    {
        name: 'cpq',
        when: {
            context: {
                product: 'cpq'
            }
        }
    },
    {
        name: 'welcome/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'welcome/software'
                }
            }
        }
    },
    {
        name: 'bitbucket/all',
        when: {
            context: {
                product: 'bitbucket'
            }
        }
    },
    {
        name: 'bitbucket/home',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'workspace/overview'
                }
            }
        }
    },
    {
        name: 'bitbucket/admin',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'admin'
                }
            }
        }
    },
    {
        name: 'bitbucket/settings',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'workspace/settings'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-requests/new',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/new'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-requests/list',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/?$'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-request/view',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/\\d+'
                }
            }
        }
    },
    {
        name: 'jira/rovo-search',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/rovo-search'
                }
            }
        }
    },
    {
        name: 'confluence/rovo-search',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/search'
                }
            }
        }
    },
    {
        name: 'jira/assets/dashboards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    // Dashboard id in product is a UUID (path segment after …/dashboards/)
                    matches: 'jira/assets/dashboards/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
                }
            }
        }
    },
    {
        name: 'jira/assets/schemas',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/assets/schemas$'
                }
            }
        }
    },
    {
        // JSM project directory (e.g. .../jira/servicedesk/projects/ACM/summary)
        name: 'jira/servicedesk/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects'
                }
            }
        }
    },
    {
        // Any JSW project route (TMP or CMP)
        name: 'jira/software/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects'
                }
            }
        }
    },
    {
        // JSM project dashboards (e.g. .../jira/servicedesk/projects/ACM/dashboards)
        name: 'jira/servicedesk/dashboards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/dashboards'
                }
            }
        }
    },
    {
        // JSM virtual agent settings (e.g. .../jira/servicedesk/projects/ACM/settings/virtual-agent)
        name: 'jira/servicedesk/virtual-agent',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/settings/virtual-agent'
                }
            }
        }
    },
    {
        // JSW project settings (e.g. .../jira/software/projects/TT/settings/details)
        name: 'jira/software/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/[^/]+/settings'
                }
            }
        }
    },
    {
        // JSM queue board (e.g. .../jira/servicedesk/projects/ACM/queues/custom/11627/board/19488)
        name: 'jira/servicedesk/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/queues/[^/]+/[^/]+/board'
                }
            }
        }
    },
    {
        // JSW project summary (e.g. .../jira/software/projects/MT/summary)
        name: 'jira/software/summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        // Jira Plans timeline (e.g. .../jira/plans/123/scenarios/456/timeline)
        name: 'jira/plans',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/[^/]+/[^/]+/[^/]+/timeline'
                }
            }
        }
    }
];

});

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $2a944e02f94c71f9$export$a5cfae247d8360ef = 'screen-space-flags';

parcelRegister("ek6Zj", function(module, exports) {
$parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", () => $86887691b4957af4$export$b0eee5de066b2bf5);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $icNTy = parcelRequire("icNTy");

var $iPnfD = parcelRequire("iPnfD");

var $F11b3 = parcelRequire("F11b3");

var $jOra1 = parcelRequire("jOra1");

var $gdt5n = parcelRequire("gdt5n");

var $keSNb = parcelRequire("keSNb");

var $1OuMs = parcelRequire("1OuMs");

var $eaK8v = parcelRequire("eaK8v");

var $dTlqp = parcelRequire("dTlqp");

var $4sz4f = parcelRequire("4sz4f");

var $9wQWt = parcelRequire("9wQWt");

var $1jVWp = parcelRequire("1jVWp");

var $cZYU6 = parcelRequire("cZYU6");

var $iL0ky = parcelRequire("iL0ky");

var $agO15 = parcelRequire("agO15");

var $24ssA = parcelRequire("24ssA");

var $hx0aP = parcelRequire("hx0aP");

var $5AwYx = parcelRequire("5AwYx");

var $jMOP8 = parcelRequire("jMOP8");

var $bOBrx = parcelRequire("bOBrx");

var $dFD5Z = parcelRequire("dFD5Z");

var $jvZSQ = parcelRequire("jvZSQ");

var $lWlZ1 = parcelRequire("lWlZ1");

var $3GKMZ = parcelRequire("3GKMZ");

var $7IH13 = parcelRequire("7IH13");

var $eEttz = parcelRequire("eEttz");

var $eqG4l = parcelRequire("eqG4l");

var $fOfuV = parcelRequire("fOfuV");

var $bWhYF = parcelRequire("bWhYF");

var $1Crx4 = parcelRequire("1Crx4");

var $gJpEn = parcelRequire("gJpEn");

var $ailzg = parcelRequire("ailzg");

var $6LR7s = parcelRequire("6LR7s");

var $2LjiL = parcelRequire("2LjiL");

var $33RDh = parcelRequire("33RDh");

var $42Dsa = parcelRequire("42Dsa");

var $10ncK = parcelRequire("10ncK");

var $8cuyX = parcelRequire("8cuyX");

var $dR9dm = parcelRequire("dR9dm");

var $yk4js = parcelRequire("yk4js");

var $fjm92 = parcelRequire("fjm92");

var $3Tbrz = parcelRequire("3Tbrz");

var $fVSH4 = parcelRequire("fVSH4");

var $3J6RP = parcelRequire("3J6RP");

var $28RSh = parcelRequire("28RSh");

var $gqumX = parcelRequire("gqumX");

var $2AnZW = parcelRequire("2AnZW");

var $lBMYS = parcelRequire("lBMYS");

var $9ZkjY = parcelRequire("9ZkjY");

var $lyTFG = parcelRequire("lyTFG");

var $1WFMp = parcelRequire("1WFMp");

var $8zbRV = parcelRequire("8zbRV");

var $iWdVz = parcelRequire("iWdVz");

var $3ozRQ = parcelRequire("3ozRQ");

var $a7zI3 = parcelRequire("a7zI3");
const $86887691b4957af4$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $iPnfD.messagesLoader)(locale),
        (0, $F11b3.messagesLoader)(locale),
        (0, $jOra1.messagesLoader)(locale),
        (0, $gdt5n.messagesLoader)(locale),
        (0, $keSNb.messagesLoader)(locale),
        (0, $1OuMs.messagesLoader)(locale),
        (0, $eaK8v.messagesLoader)(locale),
        (0, $dTlqp.messagesLoader)(locale),
        (0, $4sz4f.messagesLoader)(locale),
        (0, $9wQWt.messagesLoader)(locale),
        (0, $1jVWp.messagesLoader)(locale),
        (0, $cZYU6.messagesLoader)(locale),
        (0, $iL0ky.messagesLoader)(locale),
        (0, $agO15.messagesLoader)(locale),
        (0, $24ssA.messagesLoader)(locale),
        (0, $hx0aP.messagesLoader)(locale),
        (0, $5AwYx.messagesLoader)(locale),
        (0, $jMOP8.messagesLoader)(locale),
        (0, $bOBrx.messagesLoader)(locale),
        (0, $dFD5Z.messagesLoader)(locale),
        (0, $jvZSQ.messagesLoader)(locale),
        (0, $lWlZ1.messagesLoader)(locale),
        (0, $3GKMZ.messagesLoader)(locale),
        (0, $7IH13.messagesLoader)(locale),
        (0, $eEttz.messagesLoader)(locale),
        (0, $eqG4l.messagesLoader)(locale),
        (0, $fOfuV.messagesLoader)(locale),
        (0, $bWhYF.messagesLoader)(locale),
        (0, $1Crx4.messagesLoader)(locale),
        (0, $gJpEn.messagesLoader)(locale),
        (0, $ailzg.messagesLoader)(locale),
        (0, $6LR7s.messagesLoader)(locale),
        (0, $2LjiL.messagesLoader)(locale),
        (0, $33RDh.messagesLoader)(locale),
        (0, $42Dsa.messagesLoader)(locale),
        (0, $10ncK.messagesLoader)(locale),
        (0, $8cuyX.messagesLoader)(locale),
        (0, $dR9dm.messagesLoader)(locale),
        (0, $yk4js.messagesLoader)(locale),
        (0, $fjm92.messagesLoader)(locale),
        (0, $3Tbrz.messagesLoader)(locale),
        (0, $fVSH4.messagesLoader)(locale),
        (0, $3J6RP.messagesLoader)(locale),
        (0, $28RSh.messagesLoader)(locale),
        (0, $gqumX.messagesLoader)(locale),
        (0, $2AnZW.messagesLoader)(locale),
        (0, $lBMYS.messagesLoader)(locale),
        (0, $9ZkjY.messagesLoader)(locale),
        (0, $lyTFG.messagesLoader)(locale),
        (0, $1WFMp.messagesLoader)(locale),
        (0, $8zbRV.messagesLoader)(locale),
        (0, $iWdVz.messagesLoader)(locale),
        (0, $3ozRQ.messagesLoader)(locale),
        (0, $a7zI3.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $86887691b4957af4$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $icNTy.withIntlProvider)({
        messagesLoader: $86887691b4957af4$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("iPnfD", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $ad050db5c58d0183$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jHA86 = parcelRequire("jHA86");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ad050db5c58d0183$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ad050db5c58d0183$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("drwJM")));
        case 'da':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("d0F7w")));
        case 'de':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("jf4XG")));
        case 'en-GB':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("30sRs")));
        case 'en-US':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("kHdQf")));
        case 'en-XA':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("amhjc")));
        case 'en-XB':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("h6hp5")));
        case 'en-ZZ':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("ggPQh")));
        case 'en':
            return $ad050db5c58d0183$var$importHelper(await Promise.resolve((parcelRequire("jHA86"))));
        case 'es':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("5fFtI")));
        case 'et':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("1FHM7")));
        case 'fi':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("8Zq5T")));
        case 'fr':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("1ik63")));
        case 'hr':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("6JhYg")));
        case 'hu':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("bJnv7")));
        case 'it':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("evl5R")));
        case 'ja':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("c7Vkh")));
        case 'ko':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("2ZC71")));
        case 'nb':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("fozmS")));
        case 'nl':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("2gc4C")));
        case 'pl':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("aA6Xu")));
        case 'pt-BR':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("f9MAu")));
        case 'ro':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("fKoev")));
        case 'ru':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("ZTpQv")));
        case 'sl':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("8z6Ut")));
        case 'sr-RS':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("k2tnG")));
        case 'sr-YR':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("s2EXC")));
        case 'sr':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("fMG5W")));
        case 'sv':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("3fkmO")));
        case 'th':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("252du")));
        case 'tr':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("6v9cW")));
        case 'uk':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("bYmUG")));
        case 'vi':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("aY41r")));
        case 'zh-CN':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("iD0iT")));
        case 'zh-TW':
            return $ad050db5c58d0183$var$importHelper(await (parcelRequire("9OLqD")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jHA86));
    }
};

});
parcelRegister("jHA86", function(module, exports) {
module.exports = JSON.parse("{\"adminhub.user.requests.count.message.spotlight.content.body\":[{\"type\":0,\"value\":\"See how many times a user has tried to access their requested app\"}],\"adminhub.user.requests.count.message.spotlight.content.done\":[{\"type\":0,\"value\":\"Done\"}],\"adminhub.user.requests.count.message.spotlight.content.headline\":[{\"type\":0,\"value\":\"View access attempts\"}],\"growth-groot.pending-request-access-summary.message-template.in-app-notification.body\":[{\"type\":0,\"value\":\"Approve or deny your users' requests for app access.\"}],\"growth-groot.pending-request-access-summary.message-template.in-app-notification.heading\":[{\"type\":1,\"value\":\"totalRequests\"},{\"type\":0,\"value\":\" access requests are waiting for review\"}],\"user.access.settings.access.message.spotlight.content.body\":[{\"type\":0,\"value\":\"Create a message that users in your organization will see when they want to request access to an app.\"}],\"user.access.settings.access.message.spotlight.content.got.it\":[{\"type\":0,\"value\":\"Got it\"}],\"user.access.settings.access.message.spotlight.content.headline\":[{\"type\":0,\"value\":\"Create an access message\"}]}");

});

parcelRegister("drwJM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ccTPm").then(()=>parcelRequire('dHwhA'));

});

parcelRegister("d0F7w", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3bDRn").then(()=>parcelRequire('j6uIy'));

});

parcelRegister("jf4XG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eKiYY").then(()=>parcelRequire('5xINs'));

});

parcelRegister("30sRs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bRPag").then(()=>parcelRequire('fOyfo'));

});

parcelRegister("kHdQf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2FZL3").then(()=>parcelRequire('4iyti'));

});

parcelRegister("amhjc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7uGFD").then(()=>parcelRequire('gaCp1'));

});

parcelRegister("h6hp5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Sx9f").then(()=>parcelRequire('fPCsf'));

});

parcelRegister("ggPQh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9dgPh").then(()=>parcelRequire('g3Dud'));

});

parcelRegister("5fFtI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bQQiV").then(()=>parcelRequire('jBPj6'));

});

parcelRegister("1FHM7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("elZBY").then(()=>parcelRequire('bjiLa'));

});

parcelRegister("8Zq5T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lngDU").then(()=>parcelRequire('9zHZi'));

});

parcelRegister("1ik63", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aPXMV").then(()=>parcelRequire('cNqim'));

});

parcelRegister("6JhYg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ds2uZ").then(()=>parcelRequire('aZ2CB'));

});

parcelRegister("bJnv7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3Bf1y").then(()=>parcelRequire('S9JrW'));

});

parcelRegister("evl5R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7CpBF").then(()=>parcelRequire('2qlsz'));

});

parcelRegister("c7Vkh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2b09A").then(()=>parcelRequire('bhdj4'));

});

parcelRegister("2ZC71", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gcoYN").then(()=>parcelRequire('4XD7S'));

});

parcelRegister("fozmS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8gcOi").then(()=>parcelRequire('lr2Kw'));

});

parcelRegister("2gc4C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kZMZY").then(()=>parcelRequire('cURQv'));

});

parcelRegister("aA6Xu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fubo").then(()=>parcelRequire('qPcWx'));

});

parcelRegister("f9MAu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kpY8L").then(()=>parcelRequire('b7P1k'));

});

parcelRegister("fKoev", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iHyfa").then(()=>parcelRequire('afX6m'));

});

parcelRegister("ZTpQv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("blEqi").then(()=>parcelRequire('9idX9'));

});

parcelRegister("8z6Ut", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1vTcK").then(()=>parcelRequire('6Pq3u'));

});

parcelRegister("k2tnG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("istTV").then(()=>parcelRequire('hIjL5'));

});

parcelRegister("s2EXC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cQVeU").then(()=>parcelRequire('kiLVa'));

});

parcelRegister("fMG5W", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a4YeC").then(()=>parcelRequire('4migw'));

});

parcelRegister("3fkmO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8P6xt").then(()=>parcelRequire('ecuZI'));

});

parcelRegister("252du", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("avTJ5").then(()=>parcelRequire('auOdR'));

});

parcelRegister("6v9cW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9xZj4").then(()=>parcelRequire('3wavx'));

});

parcelRegister("bYmUG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ir5Xj").then(()=>parcelRequire('idvvB'));

});

parcelRegister("aY41r", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6bzeJ").then(()=>parcelRequire('1J6xS'));

});

parcelRegister("iD0iT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k8cNy").then(()=>parcelRequire('i8vgr'));

});

parcelRegister("9OLqD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8aBqJ").then(()=>parcelRequire('i7liC'));

});


parcelRegister("F11b3", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $89904c31614cddb5$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cgSbf = parcelRequire("cgSbf");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89904c31614cddb5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $89904c31614cddb5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("cI0dL")));
        case 'da':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("3f5VQ")));
        case 'de':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("8olDo")));
        case 'en-GB':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("6oGfL")));
        case 'en-US':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("6W254")));
        case 'en-XA':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("csswk")));
        case 'en-XB':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("iyHUg")));
        case 'en-ZZ':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("lAwQN")));
        case 'en':
            return $89904c31614cddb5$var$importHelper(await Promise.resolve((parcelRequire("cgSbf"))));
        case 'es':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("9gAhe")));
        case 'et':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("4coy5")));
        case 'fi':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("cr1iI")));
        case 'fr':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("fadFK")));
        case 'hr':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("dcDvC")));
        case 'hu':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("kWnov")));
        case 'it':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("4CSyR")));
        case 'ja':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("i7Dpu")));
        case 'ko':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("28REk")));
        case 'nb':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("1HLye")));
        case 'nl':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("42onA")));
        case 'pl':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("365gk")));
        case 'pt-BR':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("lmTOu")));
        case 'ro':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("b8NVq")));
        case 'ru':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("8i3I7")));
        case 'sl':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("egCsm")));
        case 'sr-RS':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("hjvIT")));
        case 'sr-YR':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("9JfPT")));
        case 'sr':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("e2sDG")));
        case 'sv':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("4SkBS")));
        case 'th':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("9WZ07")));
        case 'tr':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("gf1Xk")));
        case 'uk':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("5JsGZ")));
        case 'vi':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("7GUJJ")));
        case 'zh-CN':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("hmqjs")));
        case 'zh-TW':
            return $89904c31614cddb5$var$importHelper(await (parcelRequire("cfM2m")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cgSbf));
    }
};

});
parcelRegister("cgSbf", function(module, exports) {
module.exports = JSON.parse('{"admin-hub-notifications.dropdown-menu-button.aria-label":[{"type":0,"value":"More actions"}],"admin-hub-notifications.unread-notifications.aria-label":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" unread notification"}]},"other":{"value":[{"type":7},{"type":0,"value":" unread notifications"}]}},"pluralType":"cardinal","type":6,"value":"displayedCount"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-0":[{"type":0,"value":"Gain insight into your current period, past usage, and 30, 60, 90-day history."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-1":[{"type":0,"value":"Explore usage broken down by apps, features, and individual users."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-2":[{"type":0,"value":"Download usage data for in-depth analysis, custom reports, and easy sharing."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-0":[{"type":0,"value":"Track "},{"type":1,"value":"meterName"},{"type":0,"value":" credits across time"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-1":[{"type":0,"value":"Granular "},{"type":1,"value":"meterName"},{"type":0,"value":" insights"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-2":[{"type":0,"value":"Download usage reports"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-1":[{"type":0,"value":"Different reports now live in dedicated spaces so you can quickly find what you need."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-2":[{"type":0,"value":"Assess your Data Center instances and get them ready for cloud migration."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-3":[{"type":0,"value":"Monitor and improve the health and performance of your Data Center instances."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-4":[{"type":0,"value":"Discover Data Center instances you own based on existing connections."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-1":[{"type":0,"value":"What\'s new in Portfolio insights"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-2":[{"type":0,"value":"Cloud readiness"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-3":[{"type":0,"value":"Instance health"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-4":[{"type":0,"value":"Detected instances"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-rovo-chat-button-spotlight.body":[{"type":0,"value":"Troubleshoot common tasks with Rovo admin skills. Go to "},{"type":1,"value":"rovoSettings"},{"type":0,"value":" to turn on "},{"type":1,"value":"rovoChatInAdministration"},{"type":0,"value":"."}],"admin-hub.adminhub-rovo-chat-button-spotlight.button-open-rovo-chat":[{"type":0,"value":"Open Rovo Chat"}],"admin-hub.adminhub-rovo-chat-button-spotlight.heading":[{"type":0,"value":"Meet your new admin assistant"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-chat-in-administration":[{"type":0,"value":"Rovo Chat in Administration"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link":[{"type":0,"value":"Rovo settings"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link-text":[{"type":0,"value":"Rovo settings"}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.body":[{"type":0,"value":"Turn on Rovo Chat to enable it in Atlassian Administration."}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.button-try-it":[{"type":0,"value":"Turn on"}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.heading":[{"type":0,"value":"Turn on Rovo Chat"}],"admin-hub.adminhub-theme-darkmode.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-theme-darkmode.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-theme-darkmode.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-theme-darkmode.spotlight-body-1":[{"type":0,"value":"Reduce glare and boost focus with our sleek new dark theme."}],"admin-hub.adminhub-theme-darkmode.spotlight-body-2":[{"type":0,"value":"Go dark, stay light, or match your browser settings. Give it a try."}],"admin-hub.adminhub-theme-darkmode.spotlight-heading-1":[{"type":0,"value":"Experience dark mode"}],"admin-hub.adminhub-theme-darkmode.spotlight-heading-2":[{"type":0,"value":"Switch themes"}],"admin-hub.adminhub-theme-darkmode.step-count-1":[{"type":0,"value":"1 of 2"}],"admin-hub.adminhub-theme-darkmode.step-count-2":[{"type":0,"value":"2 of 2"}],"adminhub.inbox.recommendations.placement.header":[{"type":0,"value":"Recommendations"}],"ai-3p-connector-action-required.admin-hub-notifications.actionLink":[{"type":0,"value":"Go to connector settings"}],"ai-3p-connector-action-required.admin-hub-notifications.body":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector is still syncing, but a configuration issue needs your review. Some content may not be included as intended until it\'s resolved. Go to the connector setting and select the "},{"children":[{"type":0,"value":"Action required"}],"type":8,"value":"b"},{"type":0,"value":" status on your connector to see what needs attention and how to fix it."}],"ai-3p-connector-action-required.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector needs attention"}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.actionLink":[{"type":0,"value":"Go to connector settings"}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.body":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"},{"options":{"other":{"value":[]},"true":{"value":[{"type":0,"value":" on "},{"type":1,"value":"cloudUrl"}]}},"type":5,"value":"hasCloudUrl"},{"type":0,"value":" is currently experiencing issues and cannot sync data from "},{"type":1,"value":"connectorType"},{"type":0,"value":"."}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.heading":[{"type":0,"value":"Action required: Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" Teamwork Graph connector needs attention"}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors"}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.body":[{"type":0,"value":"Good news! Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"},{"options":{"other":{"value":[]},"true":{"value":[{"type":0,"value":" on "},{"type":1,"value":"cloudUrl"}]}},"type":5,"value":"hasCloudUrl"},{"type":0,"value":" has recovered and is now syncing data normally. No further action is required."}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" Teamwork Graph connector is back online"}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors"}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.body":[{"type":0,"value":"We\'ve finished the initial sync of your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector and ingested everything your connector configuration allows. Your data is now searchable in Rovo - try asking a question or running a search to see it in action."}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector\'s initial sync is complete"}],"brie-automated-restore-failed.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the automated restore test for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" run on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This may affect your ability to recover data if needed. Review restore test view more details."}],"brie-automated-restore-failed.admin-hub-notifications.heading":[{"type":0,"value":"Automated restore test did not complete"}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.action":[{"type":0,"value":"Check Backup"}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.body":[{"type":0,"value":"You can view details in the attached report or download the report for "},{"type":1,"value":"product"},{"type":0,"value":"."}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" backup "},{"type":1,"value":"status"},{"type":0,"value":" for "},{"type":1,"value":"cloudUrl"}],"brie-backup-failed.admin-hub-notifications.body":[{"type":0,"value":"The backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" failed on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This means your latest data may not be protected. Review backup job to view more details."}],"brie-backup-failed.admin-hub-notifications.heading":[{"type":0,"value":"Backup failed"}],"brie-backup-incomplete.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This means your latest data may not be protected. Review backup job to view more details."}],"brie-backup-incomplete.admin-hub-notifications.heading":[{"type":0,"value":"Backup did not complete"}],"brie-restore-completed-successfully.admin-hub-notifications.body":[{"type":0,"value":"The restore job for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" finished successfully. Review restore job to view more details."}],"brie-restore-completed-successfully.admin-hub-notifications.heading":[{"type":0,"value":"Restore complete"}],"brie-restore-failed.admin-hub-notifications.body":[{"type":0,"value":"The restore for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" that started at "},{"type":1,"value":"startTime"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":" has failed. Review restore job to view more details."}],"brie-restore-failed.admin-hub-notifications.heading":[{"type":0,"value":"Restore failed"}],"brie-restore-incomplete.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the restore for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" started at "},{"type":1,"value":"startTime"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". Review restore job to view more details."}],"brie-restore-incomplete.admin-hub-notifications.heading":[{"type":0,"value":"Restore did not complete"}],"brie-scheduler-halted-access-issue.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t run the scheduled backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":" due to a user access issue. This means your latest data may not be protected."}],"brie-scheduler-halted-access-issue.admin-hub-notifications.heading":[{"type":0,"value":"Scheduled backup could not run"}],"commerce.commerce-soft-limit-breach-ccp.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" is over the user limit"}],"commerce.commerce-soft-limit-breach-ccp.body-default.no-translate":[{"type":0,"value":"We recommend removing users as soon as possible if you don\'t want to automatically upgrade user tiers"}],"encryption.policy-page.spotlight.apps":[{"type":0,"value":"Your CMK encrypted apps will appear here."}],"encryption.policy-page.spotlight.back":[{"type":0,"value":"Back"}],"encryption.policy-page.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"encryption.policy-page.spotlight.done":[{"type":0,"value":"Done"}],"encryption.policy-page.spotlight.next":[{"type":0,"value":"Next"}],"encryption.policy-page.spotlight.tenantIdVpce":[{"type":0,"value":"Update your AWS KMS key policy with Encryption Tenant Identifier-tag pair and VPC endpoint(s) to enhance security."}],"growth-groot.pending-request-access-summary.admin-hub-notification.body":[{"type":0,"value":"Approve or deny your users\' requests for app access."}],"growth-groot.pending-request-access-summary.admin-hub-notification.heading":[{"type":1,"value":"totalRequests"},{"type":0,"value":" access requests are waiting for review"}],"placement.admin-hub-notifications.button.markAsRead":[{"type":0,"value":"Mark all as read"}],"placement.admin-hub-notifications.give-feedback":[{"type":0,"value":"Give feedback"}],"placement.admin-hub-notifications.learn-more.beta":[{"type":0,"value":"About this feature"}],"placement.admin-hub-notifications.main-heading":[{"type":0,"value":"Notifications"}],"placement.admin-hub-notifications.mark-as-read-tooltip":[{"type":0,"value":"Mark as read"}],"placement.admin-hub-notifications.mark-as-unread-tooltip":[{"type":0,"value":"Mark as unread"}],"post-office.access-invalid-payment.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.access-invalid-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.access-missing-payment.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.access-missing-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.actionLink":[{"type":0,"value":"Regenerate key"}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.body":[{"type":0,"value":"Regenerate key for "},{"type":1,"value":"directoryName"},{"type":0,"value":" to continue customer provisioning."}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.header":[{"type":0,"value":"Your SCIM API key will expire on "},{"type":1,"value":"expirationDate"},{"type":0,"value":"."}],"post-office.admin-hub-expiring-scim-tokens.notification.actionLink":[{"type":0,"value":"Regenerate key"}],"post-office.admin-hub-expiring-scim-tokens.notification.body":[{"type":0,"value":"Regenerate key for "},{"type":1,"value":"directoryName"},{"type":0,"value":" to continue user provisioning."}],"post-office.admin-hub-expiring-scim-tokens.notification.header":[{"type":0,"value":"Your SCIM API key will expire on "},{"type":1,"value":"expirationDate"},{"type":0,"value":"."}],"post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.body.non-final":[{"type":1,"value":"requesterName"},{"type":0,"value":" requested org admin permissions for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.heading.non-final":[{"type":0,"value":"Org Admin Request"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.body":[{"type":0,"value":"We\'ve found "},{"children":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" Atlassian app"}]},"other":{"value":[{"type":7},{"type":0,"value":" Atlassian apps"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"type":8,"value":"strong"},{"type":0,"value":" that might belong to your portfolio. Review and connect them to get more insights. "}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.heading":[{"type":0,"value":"Detected "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" Atlassian app"}]},"other":{"value":[{"type":7},{"type":0,"value":" Atlassian apps"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.notification.buttonText":[{"type":0,"value":"Review detected apps"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.body":[{"type":0,"value":"We\'ve found "},{"children":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" product"}]},"other":{"value":[{"type":7},{"type":0,"value":" products"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"type":8,"value":"strong"},{"type":0,"value":" that might belong to your portfolio. Review and connect them to get more insights. "}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.heading":[{"type":0,"value":"Detected "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" product"}]},"other":{"value":[{"type":7},{"type":0,"value":" products"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.notification.buttonText":[{"type":0,"value":"Review detected products"}],"post-office.adminhub-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.body":[{"type":0,"value":"We\'re consolidating groups and teams visibility to support future improvements and features. Assign teams to a site to avoid losing team data."}],"post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.heading":[{"type":0,"value":"Teams must be assigned to sites"}],"post-office.adminhub-scope-alignment-reminder.notification.buttonText":[{"type":0,"value":"Assign teams"}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.body":[{"type":0,"value":"As a result, some features will be restricted or unavailable until your allowance resets."}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.heading":[{"type":1,"value":"chargeElement"},{"type":0,"value":" limit reached"}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit has been used"}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.action":[{"type":0,"value":"Review new bill"}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.body":[{"type":0,"value":"You can now be billed for this app based on the number of Jira Service Management agents, instead of Jira users. If you don\'t switch to the new way of billing, we\'ll transition you automatically soon."}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Move to a new way of billing for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management"}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.action":[{"type":0,"value":"View subscription"}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.body":[{"type":0,"value":"The way you\'re billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management has been updated, which means you\'re now billed based on the number of JSM agents who have access to the app. Organization admins can view and manage user access in Atlassian Administration."}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Enjoy more control over billing for "},{"type":1,"value":"productName"},{"type":0,"value":" for JSM"}],"post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.body":[{"type":0,"value":"You can start your download by clicking here"}],"post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.heading":[{"type":0,"value":"JSON file for invoice ["},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"] is ready"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.body":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlement"},{"type":0,"value":" purchase."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.header":[{"type":0,"value":"Try "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" free"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.body":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlement"},{"type":0,"value":" purchase."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.header":[{"type":0,"value":"Try "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.body":[{"type":0,"value":"Tired of hunting for the right doc? Build a single source of truth for your team\u2019s info with Confluence "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.header":[{"type":0,"value":"Try Confluence"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.body":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. Try the "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" plan free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.header":[{"type":0,"value":"Try Jira"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.body":[{"type":0,"value":"Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.header":[{"type":0,"value":"Try Jira Product Discovery"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.body":[{"type":0,"value":"Bring developers, IT, and ops on the same tool and make work visible across teams with the "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" plan. Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.header":[{"type":0,"value":"Try Jira Service Management"}],"post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.body":[{"type":0,"value":"We\u2019ll need a payment method before "},{"type":1,"value":"lastDate"},{"type":0,"value":" to start the migration, otherwise migration will be cancelled automatically"}],"post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.header.heading":[{"type":0,"value":"Migrating Opsgenie to "},{"type":1,"value":"targetProductName"},{"type":0,"value":", bill approval pending"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\'re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.header.heading":[{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount applied on your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.body":[{"type":0,"value":"We\'re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.header.heading":[{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount applied on your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.secondary-action":[{"type":0,"value":"Download Report"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\u2019re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of the discounted Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.body":[{"type":0,"value":"We\u2019re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of the discounted Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Review the subscription plan."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"A new Atlassian Guard subscription has been activated"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who\u2019ll use Atlassian Guard."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Configure your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of your newly activated Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of your newly activated Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who\u2019ll use Atlassian Guard."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Configure your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.body":[{"type":1,"value":"bodyContent"}],"post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.header.heading":[{"type":1,"value":"titleContent"}],"post-office.commerce-payment-failure-hams-atlassian-access-paid.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details."}],"post-office.commerce-payment-failure-hams-atlassian-access-paid.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-multi-product-paid.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions for this site ("},{"type":1,"value":"siteUrl"},{"type":0,"value":") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-hams-multi-product-paid.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-hams-multi-product-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for subscriptions for this site ("},{"type":1,"value":"siteUrl"},{"type":0,"value":"). To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-multi-product-trial.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-trials-multi-product-invalid-payment.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions on your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-trials-multi-product-invalid-payment.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-trials-multi-product-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscriptions on your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"). To avoid your subscriptions being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-trials-multi-product-missing-payment.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-trials-single-product-invalid-payment.body":[{"type":0,"value":"We couldn\u2019t process payment for subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-trials-single-product-invalid-payment.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-trials-single-product-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details."}],"post-office.commerce-payment-failure-trials-single-product-missing-payment.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.body.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Request to add payment from "},{"type":1,"value":"name"}],"post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.body.no-translate":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Payment details added by billing admin"}],"post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.body.no-translate":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"children":[{"type":1,"value":"email"}],"type":8,"value":"b"},{"type":0,"value":") requested billing admin permission."}],"post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Billing admin access requested"}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.body":[{"type":0,"value":"Your billing admin request was approved."}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.heading":[{"type":0,"value":"You\'re now a billing admin"}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.body":[{"type":0,"value":"Your billing admin request was declined. If needed, you can submit another request."}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.heading":[{"type":0,"value":"Your request to be a billing admin was declined"}],"post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for some of your subscriptions. To avoid your subscriptions being deactivated, add payment details as soon as possible."}],"post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.heading":[{"type":0,"value":"Your trial expired for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.heading":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" trial expired"}],"post-office.commerce-quote-json-download-ppc.admin-hub-notifications.body":[{"type":0,"value":"You can start your download by clicking here"}],"post-office.commerce-quote-json-download-ppc.admin-hub-notifications.heading":[{"type":0,"value":"JSON file for quote ["},{"type":1,"value":"quoteNumber"},{"type":0,"value":"] is ready"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.heading":[{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance reached"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance used"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-view-usage.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.action":[{"type":0,"value":"Request upgrade"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.body":[{"type":0,"value":"Rovo Dev will be disabled for users who reach their limit. Allow more credits by requesting an upgrade to Rovo Dev Standard."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.heading":[{"type":0,"value":"Upgrade Rovo Dev users to avoid interruption"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.body":[{"type":0,"value":"At least one user has reached "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of their Rovo Dev credit limit. If extra usage is enabled, extra charges will apply to use over the limit. Otherwise, Rovo Dev will be disabled for those users."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of Rovo Dev credits used"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.body":[{"type":0,"value":"If an extra usage limit has been set, Rovo Dev usage will be disabled for those users. Otherwise, charges will apply for extra usage."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.heading":[{"type":0,"value":"Users have reached their Rovo Dev credit limit"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.common.email.body.sent-by-atlassian-cloud.footer.org-id":[{"type":0,"value":" (ID: "},{"type":1,"value":"orgId"},{"type":0,"value":")"}],"post-office.common.email.body.sent-by-atlassian-cloud.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Administration. You are receiving this email because you are an admin for "},{"type":1,"value":"orgName"}],"post-office.et-domain-verification-missing-token.admin-hub.notification.body":[{"type":0,"value":"We\'re unable to verify that you own "},{"children":[{"type":1,"value":"domain"}],"type":8,"value":"strong"},{"type":0,"value":" due to missing tokens. Verify this domain to keep your managed accounts."}],"post-office.et-domain-verification-missing-token.admin-hub.notification.header":[{"type":0,"value":"Domain will be unverified in "},{"type":1,"value":"remainingDays"},{"type":0,"value":" days"}],"post-office.et-domain-verification-token-revoked.admin-hub.notification.body":[{"children":[{"type":1,"value":"domain"}],"type":8,"value":"strong"},{"type":0,"value":" is no longer verified. Accounts with this domain are now unmanaged. Verify the domain again to claim these accounts."}],"post-office.et-domain-verification-token-revoked.admin-hub.notification.header":[{"type":0,"value":"Domain has been unverified"}],"post-office.generic-invalid-payment.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription because of an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.generic-invalid-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.generic-missing-payment.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have payment details for your subscription. To avoid your subscription being deactivated, add payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.generic-missing-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.multi-generic-invalid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions on this site "},{"type":1,"value":"siteUrl"},{"type":0,"value":" due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.multi-generic-invalid.admin-hub-notifications.heading":[{"type":0,"value":"Payment failed"}],"post-office.multi-generic-missing.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for subscriptions on this site "},{"type":1,"value":"siteUrl"},{"type":0,"value":". To avoid your subscription being deactivated, add payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.multi-generic-missing.admin-hub-notifications.heading":[{"type":0,"value":"Payment failed"}],"post-office.one-admin-left-notification.admin-hub.notification.body":[{"type":0,"value":"You\'re the only organization admin for this organization. Add another admin to avoid being locked out if you lose access."}],"post-office.one-admin-left-notification.admin-hub.notification.header":[{"type":0,"value":"Only one organization admin"}],"post-office.one-admin-left-notification.admin-hub.notification.how-to-add-admin-link":[{"type":0,"value":"How to add an admin"}],"post-office.one-admin-left-notification.notification.add-another-admin-link":[{"type":0,"value":"Add another organization admin"}],"post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.body":[{"type":0,"value":"You can view the PVR registration by clicking here"}],"post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.heading":[{"type":0,"value":"PVR registration "},{"type":1,"value":"pvrNumber"},{"type":0,"value":" submitted by "},{"type":1,"value":"submittedBy"}],"post-office.pure-dynamic-template.admin-hub.notification.body.no-translate":[{"type":1,"value":"bodyText"}],"post-office.pure-dynamic-template.admin-hub.notification.header.heading.no-translate":[{"type":1,"value":"headingText"}],"post-office.single-generic-invalid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to a problem with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.single-generic-invalid.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.single-generic-missing.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add a payment method by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.single-generic-missing.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.three-ds-payment-failure.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process your payment since we need your help to complete 3-D Secure (3DS) authentication."}],"post-office.three-ds-payment-failure.admin-hub-notifications.heading":[{"type":0,"value":"3DS payment failure"}],"post-office.townsquare-goals-request-trial.admin-hub-notifications.body":[{"type":0,"value":"Hi, I\u2019d like to try goals in the early access program. I think it can help the team save time and work better together. It\u2019s free to try if we\u2019re eligible."}],"post-office.townsquare-goals-request-trial.admin-hub-notifications.heading":[{"type":1,"value":"requesterName"},{"type":0,"value":" sent an approval request."}],"toggleLabel":[{"type":0,"value":"Only show unread"}]}');

});

parcelRegister("cI0dL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fhMfi").then(()=>parcelRequire('fuZo4'));

});

parcelRegister("3f5VQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8RpjA").then(()=>parcelRequire('josxJ'));

});

parcelRegister("8olDo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gR8Rs").then(()=>parcelRequire('iLl7h'));

});

parcelRegister("6oGfL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4sXzl").then(()=>parcelRequire('7si3r'));

});

parcelRegister("6W254", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("daSOj").then(()=>parcelRequire('lxVLW'));

});

parcelRegister("csswk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lNGZO").then(()=>parcelRequire('912ik'));

});

parcelRegister("iyHUg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iQIXn").then(()=>parcelRequire('bmo8v'));

});

parcelRegister("lAwQN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gwo3q").then(()=>parcelRequire('eLips'));

});

parcelRegister("9gAhe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9A7lU").then(()=>parcelRequire('9vxli'));

});

parcelRegister("4coy5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gEDII").then(()=>parcelRequire('hOSZu'));

});

parcelRegister("cr1iI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9MI9r").then(()=>parcelRequire('9Xcb8'));

});

parcelRegister("fadFK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7Z8Oi").then(()=>parcelRequire('9IWiV'));

});

parcelRegister("dcDvC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6iSzj").then(()=>parcelRequire('cZuks'));

});

parcelRegister("kWnov", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aNxHq").then(()=>parcelRequire('45I1J'));

});

parcelRegister("4CSyR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fu5a").then(()=>parcelRequire('cTPKN'));

});

parcelRegister("i7Dpu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jv39q").then(()=>parcelRequire('a5pbj'));

});

parcelRegister("28REk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eZIDW").then(()=>parcelRequire('3VZHI'));

});

parcelRegister("1HLye", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("anlH0").then(()=>parcelRequire('417jP'));

});

parcelRegister("42onA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2G6Ki").then(()=>parcelRequire('3mChe'));

});

parcelRegister("365gk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fhs7z").then(()=>parcelRequire('bekuR'));

});

parcelRegister("lmTOu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7dHdD").then(()=>parcelRequire('bIAsM'));

});

parcelRegister("b8NVq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("22XxQ").then(()=>parcelRequire('kipvX'));

});

parcelRegister("8i3I7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ebePU").then(()=>parcelRequire('bNbya'));

});

parcelRegister("egCsm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bovLh").then(()=>parcelRequire('7ojMF'));

});

parcelRegister("hjvIT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b662W").then(()=>parcelRequire('cur6w'));

});

parcelRegister("9JfPT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4akVV").then(()=>parcelRequire('bWSAQ'));

});

parcelRegister("e2sDG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aHGOm").then(()=>parcelRequire('i3Az4'));

});

parcelRegister("4SkBS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iUyrs").then(()=>parcelRequire('3jn29'));

});

parcelRegister("9WZ07", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bhUQy").then(()=>parcelRequire('9pwg9'));

});

parcelRegister("gf1Xk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gXLkj").then(()=>parcelRequire('eQrRj'));

});

parcelRegister("5JsGZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3m8ws").then(()=>parcelRequire('8BZpb'));

});

parcelRegister("7GUJJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dzY5W").then(()=>parcelRequire('4qGYY'));

});

parcelRegister("hmqjs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9g0Id").then(()=>parcelRequire('5cw4r'));

});

parcelRegister("cfM2m", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lfyDb").then(()=>parcelRequire('70xuQ'));

});


parcelRegister("jOra1", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $289dcdaa1583581d$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4yrD0 = parcelRequire("4yrD0");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $289dcdaa1583581d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $289dcdaa1583581d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("dGuvG")));
        case 'da':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("2boGC")));
        case 'de':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("c51hN")));
        case 'en-GB':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("kGzMw")));
        case 'en-US':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("9fe32")));
        case 'en-XA':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("3GK30")));
        case 'en-XB':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("pcRkc")));
        case 'en-ZZ':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("5e1xW")));
        case 'en':
            return $289dcdaa1583581d$var$importHelper(await Promise.resolve((parcelRequire("4yrD0"))));
        case 'es':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("i0pxe")));
        case 'et':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("2CH9P")));
        case 'fi':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("5Pvsy")));
        case 'fr':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("et2AV")));
        case 'hr':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("5xMo6")));
        case 'hu':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("fqdnI")));
        case 'it':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("9cbg4")));
        case 'ja':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("7ecww")));
        case 'ko':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("5Dr6A")));
        case 'nb':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("esAL2")));
        case 'nl':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("8pbPf")));
        case 'pl':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("dHf6J")));
        case 'pt-BR':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("hICdK")));
        case 'ro':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("jy8nz")));
        case 'ru':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("hJHky")));
        case 'sl':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("hgtzj")));
        case 'sr-RS':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("w9wTd")));
        case 'sr-YR':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("fEeQ1")));
        case 'sr':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("d9hNl")));
        case 'sv':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("eKh8C")));
        case 'th':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("9jL1X")));
        case 'tr':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("7WH2j")));
        case 'uk':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("9mpAF")));
        case 'vi':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("jScwG")));
        case 'zh-CN':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("g98OZ")));
        case 'zh-TW':
            return $289dcdaa1583581d$var$importHelper(await (parcelRequire("9hKps")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4yrD0));
    }
};

});
parcelRegister("4yrD0", function(module, exports) {
module.exports = JSON.parse('{"belugas.ax-admin-export-rovo-usage.message-template-template.email.header.logo.alt":[{"type":0,"value":"Atlassian"}],"belugas.ax-admin-export-rovo-usage.message-template.email.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Administration."}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.contact-support.button":[{"type":0,"value":"Contact support"}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.button":[{"type":0,"value":"Download CSV file"}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro":[{"type":0,"value":"A CSV of your organization\u2019s Rovo usage is ready to download."}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro.access":[{"type":0,"value":"Only organization admins can access this link and it expires in 24 hours."}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro.contact":[{"type":0,"value":"If you need access to more data, contact support to request a larger export."}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.title":[{"type":0,"value":"Download usage data export"}],"belugas.ax-admin-export-rovo-usage.message-template.email.office-icon.alt":[{"type":0,"value":"Organization"}],"belugas.ax-admin-export-rovo-usage.message-template.email.subject":[{"type":0,"value":"Your user export is ready"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.cta-button":[{"type":0,"value":"Unlock all of Rovo\'s potential"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.heading":[{"type":0,"value":"You\'re almost there!"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.hero-image.description":[{"type":0,"value":"People collaborating with Rovo, showing various app integrations including Google Drive, Gmail, GitHub, Slack, and others"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.supporting-text":[{"type":0,"value":"Rovo is nearly ready. Connect your apps to enable all the features for your organization."}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.subject":[{"type":0,"value":"Reminder: Finish setting up Rovo by connecting your apps"}],"belugas.rovo-bookmarks-spotlight.action.back":[{"type":0,"value":"Back"}],"belugas.rovo-bookmarks-spotlight.action.done":[{"type":0,"value":"Done"}],"belugas.rovo-bookmarks-spotlight.action.learn-more":[{"type":0,"value":"Learn more"}],"belugas.rovo-bookmarks-spotlight.action.next":[{"type":0,"value":"Next"}],"belugas.rovo-bookmarks-spotlight.action.next-2":[{"type":0,"value":"Next"}],"belugas.rovo-bookmarks-spotlight.step-1.content":[{"type":0,"value":"Bookmarks allow you to make sure your teammates get the right result every time they search."}],"belugas.rovo-bookmarks-spotlight.step-1.heading":[{"type":0,"value":"Add bookmarks"}],"belugas.rovo-bookmarks-spotlight.step-1.page-count":[{"type":0,"value":"1 of 3"}],"belugas.rovo-bookmarks-spotlight.step-2.content":[{"type":0,"value":"Pick the terms and the result you want people to see the next time they use Rovo search."}],"belugas.rovo-bookmarks-spotlight.step-2.heading":[{"type":0,"value":"Add your first bookmark"}],"belugas.rovo-bookmarks-spotlight.step-2.page-count":[{"type":0,"value":"2 of 3"}],"belugas.rovo-bookmarks-spotlight.step-3.content":[{"type":0,"value":"Pick the terms and the result you want people to see the next time they use Rovo search."}],"belugas.rovo-bookmarks-spotlight.step-3.heading":[{"type":0,"value":"Bulk import"}],"belugas.rovo-bookmarks-spotlight.step-3.page-count":[{"type":0,"value":"3 of 3"}],"belugas.rovo-enablement-notification.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"belugas.rovo-enablement-notification.message-template.email.body.cta-button":[{"type":0,"value":"Connect my apps"}],"belugas.rovo-enablement-notification.message-template.email.body.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"belugas.rovo-enablement-notification.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"belugas.rovo-enablement-notification.message-template.email.body.heading":[{"type":0,"value":"Rovo is ready. Connect your apps today."}],"belugas.rovo-enablement-notification.message-template.email.body.hero-image.description":[{"type":0,"value":"People collaborating with Rovo, showing various app integrations including Google Drive, Gmail, GitHub, Slack, and others"}],"belugas.rovo-enablement-notification.message-template.email.body.supporting-text":[{"type":0,"value":"Power up your workspace. Set up and configure connectors to unlock all Rovo\'s potential."}],"belugas.rovo-enablement-notification.message-template.email.subject":[{"type":0,"value":"Rovo is ready for you to set up"}],"post-office.confluence-rovo-onboarding-banner.body":[{"type":0,"value":"Power up your workspace. Set up and configure connectors to unlock all Rovo\'s potential."}],"post-office.confluence-rovo-onboarding-banner.call.to.action":[{"type":0,"value":"Get started"}],"post-office.confluence-rovo-onboarding-banner.heading":[{"type":0,"value":"Rovo is ready for you"}],"post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.message":[{"type":0,"value":"We think setting up Rovo and connecting apps will improve your team\'s productivity. You\'re seeing this because Rovo is available to your team, and as an organizational admin you can extend Rovo\'s features by configuring connectors."}],"post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.reason":[{"type":0,"value":"Rovo is available to your team and you are an organizational admin"}]}');

});

parcelRegister("dGuvG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1nmTV").then(()=>parcelRequire('8ZbQn'));

});

parcelRegister("2boGC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3fMKu").then(()=>parcelRequire('7t5h2'));

});

parcelRegister("c51hN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lnDOS").then(()=>parcelRequire('ly2Dl'));

});

parcelRegister("kGzMw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("abvlK").then(()=>parcelRequire('fTgtW'));

});

parcelRegister("9fe32", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7uO01").then(()=>parcelRequire('7qbQo'));

});

parcelRegister("3GK30", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kZBdi").then(()=>parcelRequire('gb2C8'));

});

parcelRegister("pcRkc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aiejD").then(()=>parcelRequire('i9F3R'));

});

parcelRegister("5e1xW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kcBgD").then(()=>parcelRequire('fOksH'));

});

parcelRegister("i0pxe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("krQdm").then(()=>parcelRequire('3dkET'));

});

parcelRegister("2CH9P", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4TOhc").then(()=>parcelRequire('5gBMM'));

});

parcelRegister("5Pvsy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("91Hlq").then(()=>parcelRequire('8EP6c'));

});

parcelRegister("et2AV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8gnGZ").then(()=>parcelRequire('ieqHe'));

});

parcelRegister("5xMo6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3rMsP").then(()=>parcelRequire('cuMhi'));

});

parcelRegister("fqdnI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("78VmZ").then(()=>parcelRequire('cWANc'));

});

parcelRegister("9cbg4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j8jtH").then(()=>parcelRequire('3T7XP'));

});

parcelRegister("7ecww", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aVhmF").then(()=>parcelRequire('70qVw'));

});

parcelRegister("5Dr6A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ght9l").then(()=>parcelRequire('7wSt9'));

});

parcelRegister("esAL2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ch0YC").then(()=>parcelRequire('bqqxj'));

});

parcelRegister("8pbPf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gHUnn").then(()=>parcelRequire('66oF9'));

});

parcelRegister("dHf6J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lbdGA").then(()=>parcelRequire('jaML7'));

});

parcelRegister("hICdK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3HGlZ").then(()=>parcelRequire('d40II'));

});

parcelRegister("jy8nz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1sd8h").then(()=>parcelRequire('bWSt7'));

});

parcelRegister("hJHky", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("V15t7").then(()=>parcelRequire('kgmeR'));

});

parcelRegister("hgtzj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("heQWm").then(()=>parcelRequire('4pXx9'));

});

parcelRegister("w9wTd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1eYx0").then(()=>parcelRequire('3Ib0C'));

});

parcelRegister("fEeQ1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lbNKE").then(()=>parcelRequire('hjBXG'));

});

parcelRegister("d9hNl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dfpWX").then(()=>parcelRequire('2s24H'));

});

parcelRegister("eKh8C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("40ip8").then(()=>parcelRequire('kdg4y'));

});

parcelRegister("9jL1X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("clcuM").then(()=>parcelRequire('5d5Aw'));

});

parcelRegister("7WH2j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("68p7l").then(()=>parcelRequire('dftTR'));

});

parcelRegister("9mpAF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dlalW").then(()=>parcelRequire('fGyde'));

});

parcelRegister("jScwG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lGTDn").then(()=>parcelRequire('30koK'));

});

parcelRegister("g98OZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bK4ty").then(()=>parcelRequire('cBFff'));

});

parcelRegister("9hKps", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iNMCv").then(()=>parcelRequire('1mpaV'));

});


parcelRegister("gdt5n", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $29b3043e6eced9d6$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fHQYi = parcelRequire("fHQYi");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $29b3043e6eced9d6$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $29b3043e6eced9d6$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("i7snK")));
        case 'da':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("gwfu8")));
        case 'de':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("3U1sQ")));
        case 'en-GB':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("luZBv")));
        case 'en-US':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("fhfvT")));
        case 'en-XA':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("yHNnc")));
        case 'en-XB':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("4QGBR")));
        case 'en-ZZ':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("3u4kp")));
        case 'en':
            return $29b3043e6eced9d6$var$importHelper(await Promise.resolve((parcelRequire("fHQYi"))));
        case 'es':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("jAZaQ")));
        case 'et':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("6KudV")));
        case 'fi':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("gM9vU")));
        case 'fr':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("7oSg3")));
        case 'hr':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("cDIAW")));
        case 'hu':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("jbFcJ")));
        case 'it':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("duv61")));
        case 'ja':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("6ctCz")));
        case 'ko':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("lRqXW")));
        case 'nb':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("h9V0K")));
        case 'nl':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("3Vq04")));
        case 'pl':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("2lKBJ")));
        case 'pt-BR':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("5ac9b")));
        case 'ro':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("krHzY")));
        case 'ru':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("hH5s4")));
        case 'sl':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("eQ3OZ")));
        case 'sr-RS':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("hOJTp")));
        case 'sr-YR':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("1LbdL")));
        case 'sr':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("hkkx7")));
        case 'sv':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("8H8KI")));
        case 'th':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("13SSc")));
        case 'tr':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("cWdBb")));
        case 'uk':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("cj8Qh")));
        case 'vi':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("4iZq6")));
        case 'zh-CN':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("2fBEQ")));
        case 'zh-TW':
            return $29b3043e6eced9d6$var$importHelper(await (parcelRequire("4rzJq")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fHQYi));
    }
};

});
parcelRegister("fHQYi", function(module, exports) {
module.exports = JSON.parse("{\"aviator.service-health-dashboard.app-status-spotlight.action.back\":[{\"type\":0,\"value\":\"Back\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.done\":[{\"type\":0,\"value\":\"Done\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.next\":[{\"type\":0,\"value\":\"Next\"}],\"aviator.service-health-dashboard.app-status-spotlight.step-counter\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"aviator.service-health-dashboard.app-status-spotlight.step1.body\":[{\"type\":0,\"value\":\"View active incidents, maintenance events and their details.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step1.heading\":[{\"type\":0,\"value\":\"Track current events\"}],\"aviator.service-health-dashboard.app-status-spotlight.step2.body\":[{\"type\":0,\"value\":\"Search and filter past incidents and maintenance events.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step2.heading\":[{\"type\":0,\"value\":\"Browse event history\"}],\"aviator.service-health-dashboard.app-status-spotlight.step3.body\":[{\"type\":0,\"value\":\"View which app experiences across app instances are currently impacted.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step3.heading\":[{\"type\":0,\"value\":\"Check experience status\"}],\"aviator.service-health-dashboard.app-status-spotlight.step4.body\":[{\"type\":0,\"value\":\"Get an overview of how events affect your apps and their experiences.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step4.heading\":[{\"type\":0,\"value\":\"Review impact on apps\"}],\"aviator.service-health-dashboard.spotlight.action.back\":[{\"type\":0,\"value\":\"Back\"}],\"aviator.service-health-dashboard.spotlight.action.done\":[{\"type\":0,\"value\":\"Done\"}],\"aviator.service-health-dashboard.spotlight.action.next\":[{\"type\":0,\"value\":\"Next\"}],\"aviator.service-health-dashboard.spotlight.step-counter\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"aviator.service-health-dashboard.spotlight.step1.body\":[{\"type\":0,\"value\":\"View the current status and recent events for each app in your organization.\"}],\"aviator.service-health-dashboard.spotlight.step1.heading\":[{\"type\":0,\"value\":\"Dive into app status\"}],\"aviator.service-health-dashboard.spotlight.step2.body\":[{\"type\":0,\"value\":\"Stay informed about incidents and maintenance events in your organization\"}],\"aviator.service-health-dashboard.spotlight.step2.heading\":[{\"type\":0,\"value\":\"Subscribe to updates\"}]}");

});

parcelRegister("i7snK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Apfm").then(()=>parcelRequire('1tiMr'));

});

parcelRegister("gwfu8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8zQry").then(()=>parcelRequire('3dhqh'));

});

parcelRegister("3U1sQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8AsWj").then(()=>parcelRequire('gyQLy'));

});

parcelRegister("luZBv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a6qVV").then(()=>parcelRequire('8o7H2'));

});

parcelRegister("fhfvT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3Ngyj").then(()=>parcelRequire('2FkEU'));

});

parcelRegister("yHNnc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2g5oL").then(()=>parcelRequire('5jYFW'));

});

parcelRegister("4QGBR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3O5dR").then(()=>parcelRequire('14aqy'));

});

parcelRegister("3u4kp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1p1K2").then(()=>parcelRequire('jklI8'));

});

parcelRegister("jAZaQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("13BMP").then(()=>parcelRequire('6yiLy'));

});

parcelRegister("6KudV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iar9t").then(()=>parcelRequire('jb5g6'));

});

parcelRegister("gM9vU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i6T8k").then(()=>parcelRequire('kcI3l'));

});

parcelRegister("7oSg3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iDyHH").then(()=>parcelRequire('knyb6'));

});

parcelRegister("cDIAW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j6V7Y").then(()=>parcelRequire('bTCpb'));

});

parcelRegister("jbFcJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fqTcf").then(()=>parcelRequire('7MEle'));

});

parcelRegister("duv61", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4kxy1").then(()=>parcelRequire('15XtM'));

});

parcelRegister("6ctCz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lPZt8").then(()=>parcelRequire('jJ4Bu'));

});

parcelRegister("lRqXW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cMsjA").then(()=>parcelRequire('aXFEb'));

});

parcelRegister("h9V0K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3Y1dm").then(()=>parcelRequire('dXr0j'));

});

parcelRegister("3Vq04", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cSiGe").then(()=>parcelRequire('lS2Sp'));

});

parcelRegister("2lKBJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hGMH6").then(()=>parcelRequire('eego3'));

});

parcelRegister("5ac9b", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("31UfX").then(()=>parcelRequire('9sz0s'));

});

parcelRegister("krHzY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7DUfk").then(()=>parcelRequire('jbKhA'));

});

parcelRegister("hH5s4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l2NJL").then(()=>parcelRequire('8y6oZ'));

});

parcelRegister("eQ3OZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1wv1k").then(()=>parcelRequire('j6EPC'));

});

parcelRegister("hOJTp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Zlw7").then(()=>parcelRequire('5bS9A'));

});

parcelRegister("1LbdL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("foRAn").then(()=>parcelRequire('cv9n9'));

});

parcelRegister("hkkx7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("68Il5").then(()=>parcelRequire('7zr5C'));

});

parcelRegister("8H8KI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7koS6").then(()=>parcelRequire('lw41v'));

});

parcelRegister("13SSc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8j5mn").then(()=>parcelRequire('7p8sO'));

});

parcelRegister("cWdBb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("egV6q").then(()=>parcelRequire('5JIyi'));

});

parcelRegister("cj8Qh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("04Cuq").then(()=>parcelRequire('e0AXY'));

});

parcelRegister("4iZq6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b75p7").then(()=>parcelRequire('19fnR'));

});

parcelRegister("2fBEQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5hm5h").then(()=>parcelRequire('6yy7S'));

});

parcelRegister("4rzJq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c9gLJ").then(()=>parcelRequire('28NZb'));

});


parcelRegister("keSNb", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $82ab69db6b95bbfa$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cehe4 = parcelRequire("cehe4");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $82ab69db6b95bbfa$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $82ab69db6b95bbfa$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("ddF8a")));
        case 'da':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("lptRb")));
        case 'de':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("8CMb6")));
        case 'en-GB':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("etzGA")));
        case 'en-US':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("4yOcS")));
        case 'en-XA':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("gRCSR")));
        case 'en-XB':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("k2FKi")));
        case 'en-ZZ':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("9eh12")));
        case 'en':
            return $82ab69db6b95bbfa$var$importHelper(await Promise.resolve((parcelRequire("cehe4"))));
        case 'es':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("9A5yj")));
        case 'et':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("bV9sh")));
        case 'fi':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("976hX")));
        case 'fr':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("am9W0")));
        case 'hr':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("gWPFs")));
        case 'hu':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("gSuMX")));
        case 'it':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("5qz38")));
        case 'ja':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("etBW1")));
        case 'ko':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("3EgjJ")));
        case 'nb':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("fI5IH")));
        case 'nl':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("kGRH4")));
        case 'pl':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("iJBgV")));
        case 'pt-BR':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("k8iy3")));
        case 'ro':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("6Bjlm")));
        case 'ru':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("fMHPJ")));
        case 'sl':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("hBApT")));
        case 'sr-RS':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("04fOz")));
        case 'sr-YR':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("7S29R")));
        case 'sr':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("dWVJ0")));
        case 'sv':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("cKJ2I")));
        case 'th':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("iUJgR")));
        case 'tr':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("afwlA")));
        case 'uk':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("qC26u")));
        case 'vi':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("arrRX")));
        case 'zh-CN':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("6yYrE")));
        case 'zh-TW':
            return $82ab69db6b95bbfa$var$importHelper(await (parcelRequire("g9ZxU")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cehe4));
    }
};

});
parcelRegister("cehe4", function(module, exports) {
module.exports = JSON.parse('{"assets-deeplinking-modal.closeButton":[{"type":0,"value":"Close"}],"assets-deeplinking-modal.description1":[{"type":0,"value":"You can now click directly on data points in your charts to drill in and see the underlying records. For example, if you select a bar in the \u201CTicket volume\u201D chart, we\u2019ll open a detailed view showing the actual tickets that make up that data point."}],"assets-deeplinking-modal.description2":[{"type":0,"value":"This lets you move from high-level trends to the raw sources behind them in just one click."}],"assets-deeplinking-modal.doneButton":[{"type":0,"value":"Done"}],"assets-deeplinking-modal.heading":[{"type":0,"value":"See the data behind your charts"}]}');

});

parcelRegister("ddF8a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g9Hmj").then(()=>parcelRequire('czDkn'));

});

parcelRegister("lptRb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dMRiM").then(()=>parcelRequire('iXZkQ'));

});

parcelRegister("8CMb6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cpVlW").then(()=>parcelRequire('jr008'));

});

parcelRegister("etzGA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7NOwv").then(()=>parcelRequire('kcr3M'));

});

parcelRegister("4yOcS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jSzca").then(()=>parcelRequire('4gkPA'));

});

parcelRegister("gRCSR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9baPl").then(()=>parcelRequire('bUEpr'));

});

parcelRegister("k2FKi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bvIZN").then(()=>parcelRequire('iOgUG'));

});

parcelRegister("9eh12", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("igFFg").then(()=>parcelRequire('ilhrQ'));

});

parcelRegister("9A5yj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7Bna9").then(()=>parcelRequire('8WieE'));

});

parcelRegister("bV9sh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k0SK3").then(()=>parcelRequire('1TAsP'));

});

parcelRegister("976hX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cC1KH").then(()=>parcelRequire('17cjH'));

});

parcelRegister("am9W0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("giNTm").then(()=>parcelRequire('3wwni'));

});

parcelRegister("gWPFs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i2QKC").then(()=>parcelRequire('ke86s'));

});

parcelRegister("gSuMX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ghbey").then(()=>parcelRequire('kYiNk'));

});

parcelRegister("5qz38", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("joZsG").then(()=>parcelRequire('hr2j4'));

});

parcelRegister("etBW1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d6NSd").then(()=>parcelRequire('j5dxL'));

});

parcelRegister("3EgjJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6LbX4").then(()=>parcelRequire('9JXQ9'));

});

parcelRegister("fI5IH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hvJpu").then(()=>parcelRequire('k6Ti2'));

});

parcelRegister("kGRH4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1X4z0").then(()=>parcelRequire('bwERZ'));

});

parcelRegister("iJBgV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3odzT").then(()=>parcelRequire('cdKPK'));

});

parcelRegister("k8iy3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ht7zb").then(()=>parcelRequire('h86XU'));

});

parcelRegister("6Bjlm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3JroQ").then(()=>parcelRequire('8XJkA'));

});

parcelRegister("fMHPJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b88cV").then(()=>parcelRequire('8hkHe'));

});

parcelRegister("hBApT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6N7M9").then(()=>parcelRequire('6kzBb'));

});

parcelRegister("04fOz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("53YVa").then(()=>parcelRequire('jNCPw'));

});

parcelRegister("7S29R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5nTQ9").then(()=>parcelRequire('l8Ozs'));

});

parcelRegister("dWVJ0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fPccI").then(()=>parcelRequire('8PZIu'));

});

parcelRegister("cKJ2I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5FHDZ").then(()=>parcelRequire('3fcCk'));

});

parcelRegister("iUJgR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4tL8R").then(()=>parcelRequire('lfX4S'));

});

parcelRegister("afwlA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kuwac").then(()=>parcelRequire('UyXYz'));

});

parcelRegister("qC26u", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9O2YA").then(()=>parcelRequire('8POZn'));

});

parcelRegister("arrRX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("64jhg").then(()=>parcelRequire('ftewe'));

});

parcelRegister("6yYrE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eUoQq").then(()=>parcelRequire('cBQZJ'));

});

parcelRegister("g9ZxU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jfFoN").then(()=>parcelRequire('kIcV1'));

});


parcelRegister("1OuMs", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $e57903acac388125$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $7zSVx = parcelRequire("7zSVx");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e57903acac388125$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e57903acac388125$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e57903acac388125$var$importHelper(await (parcelRequire("3XMu1")));
        case 'da':
            return $e57903acac388125$var$importHelper(await (parcelRequire("04ocK")));
        case 'de':
            return $e57903acac388125$var$importHelper(await (parcelRequire("fMsOq")));
        case 'en-GB':
            return $e57903acac388125$var$importHelper(await (parcelRequire("5ej3F")));
        case 'en-US':
            return $e57903acac388125$var$importHelper(await (parcelRequire("1eOHJ")));
        case 'en-XA':
            return $e57903acac388125$var$importHelper(await (parcelRequire("hZTsg")));
        case 'en-XB':
            return $e57903acac388125$var$importHelper(await (parcelRequire("a2On4")));
        case 'en-ZZ':
            return $e57903acac388125$var$importHelper(await (parcelRequire("5WIKY")));
        case 'en':
            return $e57903acac388125$var$importHelper(await Promise.resolve((parcelRequire("7zSVx"))));
        case 'es':
            return $e57903acac388125$var$importHelper(await (parcelRequire("hMjFX")));
        case 'et':
            return $e57903acac388125$var$importHelper(await (parcelRequire("lyktT")));
        case 'fi':
            return $e57903acac388125$var$importHelper(await (parcelRequire("bnHNN")));
        case 'fr':
            return $e57903acac388125$var$importHelper(await (parcelRequire("92lAs")));
        case 'hr':
            return $e57903acac388125$var$importHelper(await (parcelRequire("hcZsK")));
        case 'hu':
            return $e57903acac388125$var$importHelper(await (parcelRequire("fXfh0")));
        case 'it':
            return $e57903acac388125$var$importHelper(await (parcelRequire("kmLB3")));
        case 'ja':
            return $e57903acac388125$var$importHelper(await (parcelRequire("ctvlc")));
        case 'ko':
            return $e57903acac388125$var$importHelper(await (parcelRequire("iQgZ0")));
        case 'nb':
            return $e57903acac388125$var$importHelper(await (parcelRequire("2jtCX")));
        case 'nl':
            return $e57903acac388125$var$importHelper(await (parcelRequire("j7BYd")));
        case 'pl':
            return $e57903acac388125$var$importHelper(await (parcelRequire("ebnH0")));
        case 'pt-BR':
            return $e57903acac388125$var$importHelper(await (parcelRequire("38lVs")));
        case 'ro':
            return $e57903acac388125$var$importHelper(await (parcelRequire("iBhip")));
        case 'ru':
            return $e57903acac388125$var$importHelper(await (parcelRequire("iAKr1")));
        case 'sl':
            return $e57903acac388125$var$importHelper(await (parcelRequire("7gUaY")));
        case 'sr-RS':
            return $e57903acac388125$var$importHelper(await (parcelRequire("5QueO")));
        case 'sr-YR':
            return $e57903acac388125$var$importHelper(await (parcelRequire("iy9Jg")));
        case 'sr':
            return $e57903acac388125$var$importHelper(await (parcelRequire("5AUMq")));
        case 'sv':
            return $e57903acac388125$var$importHelper(await (parcelRequire("ctIab")));
        case 'th':
            return $e57903acac388125$var$importHelper(await (parcelRequire("kUinz")));
        case 'tr':
            return $e57903acac388125$var$importHelper(await (parcelRequire("8Rs8S")));
        case 'uk':
            return $e57903acac388125$var$importHelper(await (parcelRequire("gLKCY")));
        case 'vi':
            return $e57903acac388125$var$importHelper(await (parcelRequire("3BNoh")));
        case 'zh-CN':
            return $e57903acac388125$var$importHelper(await (parcelRequire("beD66")));
        case 'zh-TW':
            return $e57903acac388125$var$importHelper(await (parcelRequire("6jLlk")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7zSVx));
    }
};

});
parcelRegister("7zSVx", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("3XMu1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("irnHV").then(()=>parcelRequire('2ELn7'));

});

parcelRegister("04ocK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4AG7L").then(()=>parcelRequire('9P3WZ'));

});

parcelRegister("fMsOq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bFB3Y").then(()=>parcelRequire('6IMTW'));

});

parcelRegister("5ej3F", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bu1ee").then(()=>parcelRequire('evVMF'));

});

parcelRegister("1eOHJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("LSKwl").then(()=>parcelRequire('6LdrZ'));

});

parcelRegister("hZTsg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1rT15").then(()=>parcelRequire('jaUfY'));

});

parcelRegister("a2On4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kFRnI").then(()=>parcelRequire('4OoHr'));

});

parcelRegister("5WIKY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eYOCB").then(()=>parcelRequire('a1GtU'));

});

parcelRegister("hMjFX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jDaBR").then(()=>parcelRequire('7xjdp'));

});

parcelRegister("lyktT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k4rqD").then(()=>parcelRequire('9o78Z'));

});

parcelRegister("bnHNN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jDG9f").then(()=>parcelRequire('3ehLB'));

});

parcelRegister("92lAs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1ISUS").then(()=>parcelRequire('41Ea9'));

});

parcelRegister("hcZsK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aRF4h").then(()=>parcelRequire('agx6c'));

});

parcelRegister("fXfh0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ipijF").then(()=>parcelRequire('hMVM4'));

});

parcelRegister("kmLB3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9S2zF").then(()=>parcelRequire('ghbfK'));

});

parcelRegister("ctvlc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d19Nx").then(()=>parcelRequire('bsDNV'));

});

parcelRegister("iQgZ0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bzdRB").then(()=>parcelRequire('glCvd'));

});

parcelRegister("2jtCX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1UCah").then(()=>parcelRequire('h2zUu'));

});

parcelRegister("j7BYd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dELid").then(()=>parcelRequire('5PoFv'));

});

parcelRegister("ebnH0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kBJgu").then(()=>parcelRequire('lNLvv'));

});

parcelRegister("38lVs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3pK8t").then(()=>parcelRequire('5Jv4s'));

});

parcelRegister("iBhip", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5VY5P").then(()=>parcelRequire('9vDxA'));

});

parcelRegister("iAKr1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6AaPU").then(()=>parcelRequire('6l7Fs'));

});

parcelRegister("7gUaY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jdfux").then(()=>parcelRequire('5T4OC'));

});

parcelRegister("5QueO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("46PBG").then(()=>parcelRequire('hx9ed'));

});

parcelRegister("iy9Jg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("adivl").then(()=>parcelRequire('89fx5'));

});

parcelRegister("5AUMq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("edIoZ").then(()=>parcelRequire('lFnz4'));

});

parcelRegister("ctIab", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c58Tz").then(()=>parcelRequire('2Plkn'));

});

parcelRegister("kUinz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ku8Q5").then(()=>parcelRequire('8xCqW'));

});

parcelRegister("8Rs8S", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fKJUr").then(()=>parcelRequire('gl3QW'));

});

parcelRegister("gLKCY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7wVGP").then(()=>parcelRequire('uFWMN'));

});

parcelRegister("3BNoh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6SSki").then(()=>parcelRequire('cff0v'));

});

parcelRegister("beD66", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bfBE6").then(()=>parcelRequire('akwjJ'));

});

parcelRegister("6jLlk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9MAno").then(()=>parcelRequire('aiN30'));

});


parcelRegister("eaK8v", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $6b479f5970ec94d3$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4b7nJ = parcelRequire("4b7nJ");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b479f5970ec94d3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $6b479f5970ec94d3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("e47pc")));
        case 'da':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("12WpE")));
        case 'de':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("2ALNi")));
        case 'en-GB':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("2JVME")));
        case 'en-US':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("2XPz4")));
        case 'en-XA':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("2BOk7")));
        case 'en-XB':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("cSoPw")));
        case 'en-ZZ':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("dJiZm")));
        case 'en':
            return $6b479f5970ec94d3$var$importHelper(await Promise.resolve((parcelRequire("4b7nJ"))));
        case 'es':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("1KkOb")));
        case 'et':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("afuIV")));
        case 'fi':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("9WZc1")));
        case 'fr':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("bvtai")));
        case 'hr':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("8Cpsp")));
        case 'hu':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("dulOx")));
        case 'it':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("geKgu")));
        case 'ja':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("hLLuD")));
        case 'ko':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("g99Sd")));
        case 'nb':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("3GOSY")));
        case 'nl':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("DcNAB")));
        case 'pl':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("h5FO3")));
        case 'pt-BR':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("XbTJI")));
        case 'ro':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("j50EO")));
        case 'ru':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("iPgei")));
        case 'sl':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("j06X1")));
        case 'sr-RS':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("b71a9")));
        case 'sr-YR':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("eSb31")));
        case 'sr':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("xa5Bt")));
        case 'sv':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("7M4oT")));
        case 'th':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("aypsK")));
        case 'tr':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("f4S2g")));
        case 'uk':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("5U7fk")));
        case 'vi':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("f0V50")));
        case 'zh-CN':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("742nf")));
        case 'zh-TW':
            return $6b479f5970ec94d3$var$importHelper(await (parcelRequire("7vXUF")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4b7nJ));
    }
};

});
parcelRegister("4b7nJ", function(module, exports) {
module.exports = JSON.parse("{\"jsm-gs.cases.spotlight.step1.body.non-final\":[{\"type\":0,\"value\":\"Streamline how your team documents findings and outcomes with a dedicated \"},{\"children\":[{\"type\":0,\"value\":\"Case notes\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" section within work items.\"}],\"jsm-gs.cases.spotlight.step1.next.non-final\":[{\"type\":0,\"value\":\"Next\"}],\"jsm-gs.cases.spotlight.step1.step-count.non-final\":[{\"type\":0,\"value\":\"1 of 3\"}],\"jsm-gs.cases.spotlight.step1.title.non-final\":[{\"type\":0,\"value\":\"Better manage your case load\"}],\"jsm-gs.cases.spotlight.step2.back.non-final\":[{\"type\":0,\"value\":\"Back\"}],\"jsm-gs.cases.spotlight.step2.body.non-final\":[{\"type\":0,\"value\":\"To enable \"},{\"children\":[{\"type\":0,\"value\":\"Case notes\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" on work items, simply create or assign existing request types to this work category.\"}],\"jsm-gs.cases.spotlight.step2.next.non-final\":[{\"type\":0,\"value\":\"Next\"}],\"jsm-gs.cases.spotlight.step2.step-count.non-final\":[{\"type\":0,\"value\":\"2 of 3\"}],\"jsm-gs.cases.spotlight.step2.title.non-final\":[{\"type\":0,\"value\":\"Create or assign existing types\"}],\"jsm-gs.cases.spotlight.step3.back.non-final\":[{\"type\":0,\"value\":\"Back\"}],\"jsm-gs.cases.spotlight.step3.body.non-final\":[{\"type\":0,\"value\":\"Lock down sensitive \"},{\"children\":[{\"type\":0,\"value\":\"Cases\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" with work item security so only those with access can view case information.\"}],\"jsm-gs.cases.spotlight.step3.done.non-final\":[{\"type\":0,\"value\":\"Done\"}],\"jsm-gs.cases.spotlight.step3.step-count.non-final\":[{\"type\":0,\"value\":\"3 of 3\"}],\"jsm-gs.cases.spotlight.step3.title.non-final\":[{\"type\":0,\"value\":\"Restrict access to specific people\"}]}");

});

parcelRegister("e47pc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9nzDB").then(()=>parcelRequire('1gLea'));

});

parcelRegister("12WpE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4XrGc").then(()=>parcelRequire('gnsYp'));

});

parcelRegister("2ALNi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iHKK9").then(()=>parcelRequire('eSiRF'));

});

parcelRegister("2JVME", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ejono").then(()=>parcelRequire('eAgGF'));

});

parcelRegister("2XPz4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gyd9m").then(()=>parcelRequire('jeCmo'));

});

parcelRegister("2BOk7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ivwVH").then(()=>parcelRequire('1MOn4'));

});

parcelRegister("cSoPw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9WTwh").then(()=>parcelRequire('33MAY'));

});

parcelRegister("dJiZm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c78Qi").then(()=>parcelRequire('dC3zk'));

});

parcelRegister("1KkOb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("huF8F").then(()=>parcelRequire('gqm4S'));

});

parcelRegister("afuIV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hUusR").then(()=>parcelRequire('efw8z'));

});

parcelRegister("9WZc1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5LOeM").then(()=>parcelRequire('9cfNg'));

});

parcelRegister("bvtai", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lFXqf").then(()=>parcelRequire('foSnp'));

});

parcelRegister("8Cpsp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("zKg6v").then(()=>parcelRequire('4oAAe'));

});

parcelRegister("dulOx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Cynm").then(()=>parcelRequire('9UlSo'));

});

parcelRegister("geKgu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("O0cBe").then(()=>parcelRequire('hbRUt'));

});

parcelRegister("hLLuD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lbROC").then(()=>parcelRequire('duQD5'));

});

parcelRegister("g99Sd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1bTDw").then(()=>parcelRequire('3qGwb'));

});

parcelRegister("3GOSY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("evreL").then(()=>parcelRequire('5PkGM'));

});

parcelRegister("DcNAB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("60R8A").then(()=>parcelRequire('72K1v'));

});

parcelRegister("h5FO3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fEF6c").then(()=>parcelRequire('2ymQK'));

});

parcelRegister("XbTJI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b07rC").then(()=>parcelRequire('7AfGR'));

});

parcelRegister("j50EO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lo9Q2").then(()=>parcelRequire('foi0n'));

});

parcelRegister("iPgei", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hUi2d").then(()=>parcelRequire('gLQqp'));

});

parcelRegister("j06X1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("0wRpu").then(()=>parcelRequire('iA3CY'));

});

parcelRegister("b71a9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1b8E7").then(()=>parcelRequire('4Ewk6'));

});

parcelRegister("eSb31", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("85kuA").then(()=>parcelRequire('d4L9S'));

});

parcelRegister("xa5Bt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4tQ5x").then(()=>parcelRequire('kgbxK'));

});

parcelRegister("7M4oT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iEHLx").then(()=>parcelRequire('bazkb'));

});

parcelRegister("aypsK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gI7gs").then(()=>parcelRequire('eb5Ts'));

});

parcelRegister("f4S2g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a6EFV").then(()=>parcelRequire('8L2ci'));

});

parcelRegister("5U7fk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jIy06").then(()=>parcelRequire('hIWvv'));

});

parcelRegister("f0V50", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Wpku").then(()=>parcelRequire('l2JWF'));

});

parcelRegister("742nf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a8s8o").then(()=>parcelRequire('gSPsP'));

});

parcelRegister("7vXUF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4AQgu").then(()=>parcelRequire('iqGDS'));

});


parcelRegister("dTlqp", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $b801a5599686307a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9sWxG = parcelRequire("9sWxG");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b801a5599686307a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b801a5599686307a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("Yj7A2")));
        case 'da':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("7ZVS7")));
        case 'de':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("6R1xH")));
        case 'en-GB':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("8EGaP")));
        case 'en-US':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("1w7R9")));
        case 'en-XA':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("b8Dku")));
        case 'en-XB':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("6pz5o")));
        case 'en-ZZ':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("bFrqa")));
        case 'en':
            return $b801a5599686307a$var$importHelper(await Promise.resolve((parcelRequire("9sWxG"))));
        case 'es':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("9F3Y5")));
        case 'et':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("4Sm53")));
        case 'fi':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("jGfD4")));
        case 'fr':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("1Uxmx")));
        case 'hr':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("2uUW4")));
        case 'hu':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("7YK5T")));
        case 'it':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("8V4EP")));
        case 'ja':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("2WLEg")));
        case 'ko':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("aqIYk")));
        case 'nb':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("8UtA6")));
        case 'nl':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("2rB06")));
        case 'pl':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("keE64")));
        case 'pt-BR':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("2PBxr")));
        case 'ro':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("4pB75")));
        case 'ru':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("bkJUj")));
        case 'sl':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("bOPR6")));
        case 'sr-RS':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("jd7hi")));
        case 'sr-YR':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("eZdvU")));
        case 'sr':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("gFKKQ")));
        case 'sv':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("gbMEX")));
        case 'th':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("5pnrG")));
        case 'tr':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("8UYS2")));
        case 'uk':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("ajaAR")));
        case 'vi':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("19irc")));
        case 'zh-CN':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("ci6kE")));
        case 'zh-TW':
            return $b801a5599686307a$var$importHelper(await (parcelRequire("hza9z")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9sWxG));
    }
};

});
parcelRegister("9sWxG", function(module, exports) {
module.exports = JSON.parse("{\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-description\":[{\"type\":0,\"value\":\"Blocks of content can now be easily transformed, kept in sync, and saved as a template!\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-header\":[{\"type\":0,\"value\":\"Transform, sync & save blocks\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-image-alt\":[{\"type\":0,\"value\":\"Blocks feature illustration\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-description\":[{\"type\":0,\"value\":\"Blocks of content can now be easily transformed, kept in sync, and saved as a template!\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-header\":[{\"type\":0,\"value\":\"Transform, sync & save blocks\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-image-alt\":[{\"type\":0,\"value\":\"Blocks feature illustration\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-description\":[{\"type\":0,\"value\":\"Save any content as a block template for easy reuse across Confluence and Jira!\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-header\":[{\"type\":0,\"value\":\"Save content with block templates\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-image-alt\":[{\"type\":0,\"value\":\"Block templates feature illustration\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-description\":[{\"type\":0,\"value\":\"Easily change content blocks from one format to another!\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-header-new\":[{\"type\":0,\"value\":\"Quickly change format\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-image-alt-new\":[{\"type\":0,\"value\":\"Format feature illustration\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-description\":[{\"type\":0,\"value\":\"Synced blocks maintain source of truth across Confluence & Jira. Insert, copy, and paste!\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-header\":[{\"type\":0,\"value\":\"Keep content in sync\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-image-alt\":[{\"type\":0,\"value\":\"Synced blocks feature illustration\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-button\":[{\"type\":0,\"value\":\"Got it\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-description\":[{\"type\":0,\"value\":\"Controls to add or delete rows and columns have moved to their own menus. You can also align content vertically from the cell menu.\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-header\":[{\"type\":0,\"value\":\"Simple table controls\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-image-alt\":[{\"type\":0,\"value\":\"Table cell menu illustration\"}]}");

});

parcelRegister("Yj7A2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9FlTp").then(()=>parcelRequire('gIlJq'));

});

parcelRegister("7ZVS7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6H9I5").then(()=>parcelRequire('gZ2qA'));

});

parcelRegister("6R1xH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gbZmk").then(()=>parcelRequire('jZkXM'));

});

parcelRegister("8EGaP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3rJrJ").then(()=>parcelRequire('hCaur'));

});

parcelRegister("1w7R9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Qo9J").then(()=>parcelRequire('aClg7'));

});

parcelRegister("b8Dku", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8vuoe").then(()=>parcelRequire('8btZD'));

});

parcelRegister("6pz5o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("anYou").then(()=>parcelRequire('fnDPo'));

});

parcelRegister("bFrqa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("af3NY").then(()=>parcelRequire('4B3iI'));

});

parcelRegister("9F3Y5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c80D9").then(()=>parcelRequire('dfbua'));

});

parcelRegister("4Sm53", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1vtPU").then(()=>parcelRequire('XkqdM'));

});

parcelRegister("jGfD4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9uBeS").then(()=>parcelRequire('69Yrd'));

});

parcelRegister("1Uxmx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kABOD").then(()=>parcelRequire('b6Gox'));

});

parcelRegister("2uUW4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jfo6f").then(()=>parcelRequire('4O1BU'));

});

parcelRegister("7YK5T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("drBb8").then(()=>parcelRequire('gywVo'));

});

parcelRegister("8V4EP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8rjOe").then(()=>parcelRequire('4bwPa'));

});

parcelRegister("2WLEg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aADa2").then(()=>parcelRequire('4yjMZ'));

});

parcelRegister("aqIYk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("df4fq").then(()=>parcelRequire('81mnr'));

});

parcelRegister("8UtA6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jj7oy").then(()=>parcelRequire('9Nlbj'));

});

parcelRegister("2rB06", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cVA69").then(()=>parcelRequire('f5JKr'));

});

parcelRegister("keE64", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9kNtL").then(()=>parcelRequire('dXQ7u'));

});

parcelRegister("2PBxr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jVW5i").then(()=>parcelRequire('drjzV'));

});

parcelRegister("4pB75", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dLFYn").then(()=>parcelRequire('cY3KO'));

});

parcelRegister("bkJUj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("df7Vn").then(()=>parcelRequire('dhokl'));

});

parcelRegister("bOPR6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5gbsf").then(()=>parcelRequire('l0BTr'));

});

parcelRegister("jd7hi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8UNgU").then(()=>parcelRequire('58vsW'));

});

parcelRegister("eZdvU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5NYFR").then(()=>parcelRequire('i4owW'));

});

parcelRegister("gFKKQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ieIUn").then(()=>parcelRequire('d36Ar'));

});

parcelRegister("gbMEX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bYCzX").then(()=>parcelRequire('24bhM'));

});

parcelRegister("5pnrG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1RF7g").then(()=>parcelRequire('9Cp1i'));

});

parcelRegister("8UYS2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cQpaz").then(()=>parcelRequire('2UCWC'));

});

parcelRegister("ajaAR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("01E2T").then(()=>parcelRequire('9iOhD'));

});

parcelRegister("19irc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gXPiU").then(()=>parcelRequire('aAQ9x'));

});

parcelRegister("ci6kE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jbHVQ").then(()=>parcelRequire('iBsyB'));

});

parcelRegister("hza9z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ljQ8r").then(()=>parcelRequire('gdKpt'));

});


parcelRegister("4sz4f", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $ea210f0b6b3dc6a3$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cvGMJ = parcelRequire("cvGMJ");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea210f0b6b3dc6a3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $ea210f0b6b3dc6a3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("9E6iG")));
        case 'da':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("5Y48P")));
        case 'de':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("1b1fj")));
        case 'en-GB':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("fCdG4")));
        case 'en-US':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("fsaWg")));
        case 'en-XA':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("lLSyB")));
        case 'en-XB':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("fr5iR")));
        case 'en-ZZ':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("3OTLp")));
        case 'en':
            return $ea210f0b6b3dc6a3$var$importHelper(await Promise.resolve((parcelRequire("cvGMJ"))));
        case 'es':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("fGYVE")));
        case 'et':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("iLvQh")));
        case 'fi':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("gbRBe")));
        case 'fr':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("exLlE")));
        case 'hr':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("dl5zl")));
        case 'hu':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("8A7J9")));
        case 'it':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("4j0Qx")));
        case 'ja-JP':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("7QpeD")));
        case 'ja':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("hvNhw")));
        case 'ko':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("fLNG0")));
        case 'nb':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("hQEa3")));
        case 'nl':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("eruaT")));
        case 'pl':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("4ytd6")));
        case 'pt-BR':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("4HZqL")));
        case 'ro':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("4FcIr")));
        case 'ru':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("8beGL")));
        case 'sl':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("eoEjg")));
        case 'sr-RS':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("lXaSn")));
        case 'sr-YR':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("cLSkf")));
        case 'sr':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("kB6Wi")));
        case 'sv':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("2VjHF")));
        case 'th':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("jJgzW")));
        case 'tr':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("ic1qD")));
        case 'uk':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("ke4eK")));
        case 'vi':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("jxd20")));
        case 'zh-CN':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("l8mQT")));
        case 'zh-TW':
            return $ea210f0b6b3dc6a3$var$importHelper(await (parcelRequire("fgvws")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cvGMJ));
    }
};

});
parcelRegister("cvGMJ", function(module, exports) {
module.exports = JSON.parse('{"ccommerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-dispute":[{"type":0,"value":"Action required: ACH Direct debit payment failed"}],"commerce-access-invalid-payment-ccp.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-access-invalid-payment-hams.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch":[{"type":0,"value":"To understand more on why we couldn\'t generate your invoice, please "},{"type":1,"value":"getInTouchLink"},{"type":0,"value":" with us."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch-link":[{"type":0,"value":"get in touch"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.no-invoice-generation":[{"type":0,"value":"We couldn\'t generate an invoice for your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") as we don\'t have\\n\\t\\t\\t\\tyour complete billing information. As a result, your subscription has been canceled."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-1":[{"type":0,"value":"Once you\u2019ve updated the billing details, reactivate your subscription by going to "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-5":[{"type":0,"value":". If you reactivate your subscription within 60 days of cancellation, your data and preferences will remain the same."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-partner-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.wrong-details":[{"type":0,"value":"It could be because you\u2019ve entered the wrong details, or that the information you\u2019ve provided us is\\n\\t\\t\\t\\tincomplete. Don\'t worry, you can reactivate your subscription after updating your billing information."}],"commerce-credit-account-deactivation-ccp.clear-unpaid-invoices":[{"type":0,"value":"Clear any unpaid invoices associated with your account."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.help-message":[{"type":0,"value":"We understand that managing payments can sometimes be challenging, and we\'re here to help."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.learn-reasons":[{"type":0,"value":"Learn about possible reasons"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.message":[{"type":0,"value":"You can no longer use Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms to place your orders as your billing account\u2019s eligibility has been suspended. "},{"type":1,"value":"learnReason"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.title":[{"type":0,"value":"You\u2019re no longer eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" terms"}],"commerce-credit-account-deactivation-ccp.reach-out":[{"type":0,"value":"Reach out to us so we can review your eligibility."}],"commerce-credit-account-deactivation-ccp.reconsider-eligibility":[{"type":0,"value":"If you\u2019d like us to reconsider your eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms, we suggest you to:"}],"commerce-credit-account-deactivation-ccp.view-unpaid-invoices-link":[{"type":0,"value":"View unpaid invoices"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.couldn\'t-approve-request":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your request because you\u2019ve reached the maximum credit limit that we can offer at this time. You can check back in a few months to see if your eligibility has changed."}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Unable to offer a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.rejected.title":[{"type":0,"value":"We\u2019re unable to offer you a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.thank-you.submitting":[{"type":0,"value":"Thank you for submitting your application for increasing your Atlassian Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit."}],"commerce-credit-account-limit-increase-request-rejection-ccp.move-forward":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce-credit-account-reactivation-ccp.message-template.good-news.restored.billing.account":[{"type":0,"value":"Good news! We\u2019ve restored your billing account\u2019s eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details:"}],"commerce-credit-account-reactivation-ccp.message-template.restored.title":[{"type":0,"value":"Your eligibility has been restored"}],"commerce-invoice-generated-ccp-g.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp-g.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-generated-ccp.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-terms-payment-pending-ccp.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-updated-ccp-g.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp-g.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-invoice-updated-ccp.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.message.entity.link.label":[{"type":0,"value":"Atlassian Administration"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.body.multiple":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlementProductName"},{"type":0,"value":" purchase."}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.different.trial.lengths.multiple":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" free"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.multiple":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"}],"commerce-marketing-multiple-product-upgrade-ccp-single.message.entity.link.label":[{"type":0,"value":"Atlassian Administration"}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.message.title.single":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.confluence.message.body.single":[{"type":0,"value":"Tired of hunting for the right doc? Build a single source of truth for your team\'s info with Confluence "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jira.message.body.single":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. Try the "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" plan free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jpd.message.body.single":[{"type":0,"value":"Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jsm.message.body.single":[{"type":0,"value":"Bring developers, IT, and ops on the same tool and make work visible across teams with the "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" plan. Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp.subtext":[{"type":0,"value":"Atlassian Administration"}],"commerce-on-account-approval-partner.email.attached-instructions":[{"type":0,"value":"We\'ve attached instructions outlining how to read your statement."}],"commerce-on-account-approval-partner.email.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Pay on account with terms of Net-\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from statement date."}],"commerce-on-account-approval-partner.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-approval-partner.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-approval-partner.email.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce-on-account-approval-partner.email.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the statement date"}],"commerce-on-account-approval-partner.email.statement-info":[{"type":0,"value":"As Pay on account Partner, you will now receive a statement twice a month (on the 1st and 16th) covering\\n\\t\\t\\t\\tinvoices for the periods 16th to last day and 1st to 15th respectively."}],"commerce-on-account-approval-partner.email.subject":[{"type":0,"value":"Your Pay on account request is approved"}],"commerce-on-account-approval-partner.email.title":[{"type":0,"value":"Your Pay on account request has been approved"}],"commerce-on-account-deactivation-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-deactivation-partner-ccp.email.apply-again":[{"type":0,"value":"You may apply again for Pay on account option after 6 months. Don\u2019t worry, you can still place new orders using a credit card. "}],"commerce-on-account-deactivation-partner-ccp.email.contact-us":[{"type":0,"value":"Should you have questions or wish to discuss ways to reactivate your pay on account option, please contact us at "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-deactivation-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-deactivation-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-deactivation-partner-ccp.email.on-account-being-deactivated":[{"type":0,"value":"Your Pay on account option with Atlassian is being deactivated effective immediately, due to overdue balances and failure to meet the agreed payment terms. "}],"commerce-on-account-deactivation-partner-ccp.email.reach-us":[{"type":0,"value":"You can reach out to us if you need further help in placing your order."}],"commerce-on-account-deactivation-partner-ccp.email.subject":[{"type":0,"value":"Pay on account deactivation notice"}],"commerce-on-account-deactivation-partner-ccp.email.title":[{"type":0,"value":"Pay on account is deactivated"}],"commerce-on-account-rejection-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.apply-again":[{"type":0,"value":"You can resubmit your application after 6 months to be considered again.  "}],"commerce-on-account-rejection-partner-ccp.email.contact-us":[{"type":0,"value":"You can still go ahead with your purchase. We suggest using a credit card to pay for your order. If you still need help placing an order contact us at  "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-rejection-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-rejection-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-rejection-partner-ccp.email.on-account-application-rejected":[{"type":0,"value":"Thank you for submitting your application for Pay on account. Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements. "}],"commerce-on-account-rejection-partner-ccp.email.sales-op-support.no-translate":[{"type":0,"value":"sales-ops-support@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.subject":[{"type":0,"value":"Pay on account application rejection notice"}],"commerce-on-account-rejection-partner-ccp.email.title":[{"type":0,"value":"We\u2019re unable to approve your Pay on account request"}],"commerce-payment-failure-ccp.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"FAQ"}],"commerce-payment-failure-hams.email.not-trial.without-cc.add-payment-details":[{"type":0,"value":"We noticed you haven\'t added payment details for "},{"type":1,"value":"allProductListString"},{"type":0,"value":". Add payment details today so your team can keep working without interruption."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.subject":[{"type":1,"value":"subject"}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or alternatively contact your bank.Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for Atlassian Cloud "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-1":[{"type":0,"value":"We\'re unable to process your payment for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":":"}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-2":[{"type":0,"value":"This is due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.not-processed":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"allProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.additional-actions":[{"type":0,"value":"If you\u2019re unable to make payments or you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details.submit":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request":[{"type":0,"value":"For more information about what happens when you\u2019re unsubscribed from Atlassian Access, "},{"type":1,"value":"submitRequestLink"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"see our FAQ"}],"commerce-payment-failure-hams.email.trial.without-cc.2-4.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-1":[{"type":0,"value":"It\u2019s okay, we all get busy! Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but you can still add your payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-1":[{"type":0,"value":"Your Standard plan trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-2":[{"type":0,"value":"But it\u2019s not too late! You can still add payment details and keep the work you\u2019ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested.cancel-subscription":[{"type":0,"value":"cancel your subscription"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-1":[{"type":0,"value":"Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but this could just be the beginning! Add payment details to keep working\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\twith your dream team."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more.support":[{"type":0,"value":"support.atlassian.com"}],"commerce-payment-failure-hams.email.trial.without-cc.org.2-4.expiration":[{"type":0,"value":"It\'s okay, we all get busy! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.org.4more.expiration.expiration":[{"type":0,"value":"It\'s not too late! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tdetails and keep the work you\'ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.org.less2.expiration":[{"type":0,"value":"Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but this could just be the beginning. Add payment details to keep working with your dream team"}],"commerce-payment-failure-hams.email.trial.without-cc.without-cc.org.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can unsubscribe at any time within the Manage Subscriptions area\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tof your organization administration."}],"commerce-payment-failure-hams.email.update-payment-details":[{"type":0,"value":"Update Payment Detail"}],"commerce-payment-failure-trials.add-payment":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.add-payment-without-access":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.billing-cycle-label.no-translate":[{"type":0,"value":" | "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.billing-cycle-text-label.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.card-details":[{"type":0,"value":"Card: "},{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"lastFourDigits"}],"commerce-payment-failure-trials.contact-your-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue.\\n                        Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.contact_us":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation. We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access.contact_us_link":[{"type":0,"value":"Contact us"}],"commerce-payment-failure-trials.contact_us_access.data_storage_link":[{"type":0,"value":"Data Storage FAQs"}],"commerce-payment-failure-trials.contact_us_access.downgrade_link":[{"type":0,"value":"downgrade to a free plan"}],"commerce-payment-failure-trials.couldnt-charge-card":[{"type":0,"value":"We\'re reaching out as we couldn\'t charge your card for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.couldnt-charge-paypal":[{"type":0,"value":"We couldn\'t charge your PayPal account for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" because there was a problem with your account settings or the payment method selected from your PayPal wallet."}],"commerce-payment-failure-trials.ent-org-name-with-space-label.no-translate":[{"type":1,"value":"separator"},{"type":0,"value":" "},{"type":1,"value":"entOrgName"},{"type":0,"value":" "}],"commerce-payment-failure-trials.entitlement-number-label.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.entitlement-number-text.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.has_payment_method.add-payment-caption":[{"type":0,"value":"Add payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.caption":[{"type":0,"value":"Action required: Your payment was declined"}],"commerce-payment-failure-trials.has_payment_method.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment, based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.has_company_name.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"companyName"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.no_retries.partners.caption":[{"type":0,"value":"Action required: Update payment details by "},{"type":1,"value":"dueDate"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.payment-declined-title":[{"type":0,"value":"Action required: Payment declined for #"},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access":[{"type":0,"value":"Update your credit card details, or add a different credit card. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual":[{"type":0,"value":"Update your payment details or add a different payment method to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-monthly-subscriptions":[{"type":0,"value":"For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-payment-caption":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.update-paypal":[{"type":0,"value":"Log in to your PayPal account and go to your automatic payment settings. Select a different payment method for your Atlassian payment. You should also check that your account isn\'t restricted and allows international payments."}],"commerce-payment-failure-trials.has_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.invoice-number":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.invoice-number-label":[{"type":0,"value":"Invoice Number:"}],"commerce-payment-failure-trials.invoice_pdf_attachment":[{"type":0,"value":"For your records, the invoice with payment due is attached as a PDF."}],"commerce-payment-failure-trials.item-description-label.no-translate":[{"type":1,"value":"description"}],"commerce-payment-failure-trials.item-description.no-translate":[{"type":0,"value":" "},{"type":1,"value":"description"}],"commerce-payment-failure-trials.log-in-paypal":[{"type":0,"value":"Log in to PayPal"}],"commerce-payment-failure-trials.no_payment_method.partners.add_your_payment_details":[{"type":0,"value":"Add payment details today to avoid interruptions."}],"commerce-payment-failure-trials.no_payment_method.partners.caption":[{"type":0,"value":"Add payment details to avoid interruptions"}],"commerce-payment-failure-trials.no_payment_method.partners.title.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.partners.title.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.title":[{"type":0,"value":"Action required: Add your payment details"}],"commerce-payment-failure-trials.no_payment_method.unable_to_process_your_payment":[{"type":0,"value":"We were unable to process your payment since we haven\'t received your payment details for your subscription."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process your payment for Atlassian products as you haven\'t provided us with payment details yet."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process-access":[{"type":0,"value":"We\'re reaching out as we couldn\'t process your recent payment for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" due to an issue with your account\'s payment details."}],"commerce-payment-failure-trials.payment":[{"type":0,"value":"This payment was for:"}],"commerce-payment-failure-trials.paypal-details":[{"type":0,"value":"PayPal account: "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.sold-to-details.address":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"address"}],"commerce-payment-failure-trials.sold-to-details.address-message":[{"type":0,"value":"Address:"}],"commerce-payment-failure-trials.sold-to-details.company":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"companyName"}],"commerce-payment-failure-trials.sold-to-details.company-label":[{"type":0,"value":"Company:"}],"commerce-payment-failure-trials.sold-to-details.customer-contact":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"customerContact"}],"commerce-payment-failure-trials.sold-to-details.customer-contact-label":[{"type":0,"value":"Customer contact:"}],"commerce-payment-failure-trials.total-bill":[{"type":0,"value":"Your total bill is "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce-payment-failure-trials.update-credit-card":[{"type":0,"value":"Update your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-without-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.we_will_try_to_process_again":[{"type":0,"value":"We\u2019ll try to process your payment again on "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-payment-failure-trials.what-to-do":[{"type":0,"value":"What you need to do:"}],"commerce-payment-failure-trials.without-payment-faq-product-access-lost":[{"type":0,"value":"Without this payment, product access will be lost, and product data will be permanently deleted soon after. See our "},{"type":1,"value":"element"}],"commerce-permission-request-add-payment-ccp.email.add-payment-request-text":[{"type":0,"value":"There is an add payment request from "},{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") for the subscription: "}],"commerce-permission-request-add-payment-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce-permission-request-add-payment-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce-permission-request-add-payment-ccp.email.personal-note.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"commerce-permission-request-add-payment-ccp.email.subtext-for-personal-note":[{"type":0,"value":"To help you with more details, here\u2019s a note from the requester: "}],"commerce-permission-request-add-payment-ccp.email.title":[{"type":0,"value":"Request from "},{"type":1,"value":"name"},{"type":0,"value":" to add payment details"}],"commerce-permission-request-add-payment-ccp.email.whats-next-subtext":[{"type":0,"value":"If you approve the request, continue with adding payment details for the subscription and we\u2019ll notify the requester. Ignore this email to deny. "}],"commerce-permission-request-add-payment-response-ccp.email.add-payment-request-text":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"commerce-permission-request-add-payment-response-ccp.email.benefits-text":[{"type":0,"value":"You can now enjoy the benefits of:"}],"commerce-permission-request-add-payment-response-ccp.email.go-to-site":[{"type":0,"value":"Go to site"}],"commerce-permission-request-add-payment-response-ccp.email.title":[{"type":0,"value":"Your request is complete"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-count":[{"type":0,"value":"Units: "},{"type":1,"value":"count"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-entitlement-number":[{"type":1,"value":"entitlementNumber"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.free-entitlement.no-action":[{"type":0,"value":"You don\u2019t need to do anything, and your monthly Statuspage payments will remain the same."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.merged-addon":[{"type":0,"value":"Over the next few days, we\u2019ll simplify things for you by merging these "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on subscriptions into one:"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.multiple-addons":[{"type":0,"value":"We noticed your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" for "},{"type":1,"value":"site"},{"type":0,"value":" has more than one "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on: "}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.merged-add-on":[{"type":0,"value":"You\u2019ll only see one Subscribers add-on listed on your next invoice."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-change":[{"type":0,"value":"There\u2019s no change to what you\u2019ll pay each month."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-setup":[{"type":0,"value":"You won\u2019t need to set up or configure anything."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.title":[{"type":0,"value":"We\u2019re merging your "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-ons for Statuspage"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.what-this-means":[{"type":0,"value":"What this means for you"}],"commerce-reactivation-order-to-paid-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-auto-servco-upgrade-notification.message.link.view.apps":[{"type":0,"value":"View apps"}],"commerce-subscription-auto-servco-upgrade-notification.message.link.what.is.service.collection":[{"type":0,"value":"What\'s Service Collection?"}],"commerce-subscription-auto-servco-upgrade-notification.message.text":[{"type":0,"value":"Jira Service Management has moved to Service Collection on your site. You can now use the new Customer Service Management app while your existing setup stays the same."}],"commerce-subscription-auto-servco-upgrade-notification.message.title":[{"type":0,"value":"Jira Service Management update"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.agent":[{"type":0,"value":"We upgraded you to a no-cost 14 day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard, because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":"-"},{"type":1,"value":"userType"},{"type":0,"value":" for the Free plan. Add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to avoid deactivation. Cancel anytime.\\nYou can switch back to a Free plan anytime by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count."}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.user":[{"type":0,"value":"We upgraded you to a no-cost 14 day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard, because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":"-"},{"type":1,"value":"userType"},{"type":0,"value":" for the Free plan. Add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to avoid deactivation. Cancel anytime.\\nYou can switch back to a Free plan anytime by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count."}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.path.manage.billing":[{"type":0,"value":"Manage billing"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.primary.action":[{"type":0,"value":"Add payment"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.secondary.action":[{"type":0,"value":"Manage subscriptions"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.agent":[{"type":0,"value":"Subscription upgraded: Add payment or remove "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" before your trial ends"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.user":[{"type":0,"value":"Subscription upgraded: Add payment or remove "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" before your trial ends"}],"commerce-subscription-cancellation-ecc.email.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" canceled"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-reactivation-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-reactivation-trial-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce-subscription-skip-trial-ccp.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.estimated-bill":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excluding tax)"},{"type":1,"value":"content"}],"commerce-subscription-skip-trial-ccp.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" subscription "}],"commerce-subscription-systematic-downgrade-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" subscription "}],"commerce.bill-estimate-common.key":[{"type":0,"value":"Estimated bill:"}],"commerce.bill-estimate-common.value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excludes tax)"}],"commerce.billing-cycle-common.key":[{"type":0,"value":"Billing cycle:"}],"commerce.billing-cycle-common.value":[{"type":1,"value":"billingCycle"}],"commerce.commerce-approvals-received-author-notification.email.body":[{"type":0,"value":"Your initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") has been approved and is now ready for release."}],"commerce.commerce-approvals-received-author-notification.email.cta.link":[{"type":0,"value":"Click on the button below to release the initiative in Workbench."}],"commerce.commerce-approvals-received-author-notification.email.initiative.link":[{"type":0,"value":"Go to initiative"}],"commerce.commerce-approvals-received-author-notification.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-approvals-received-author-notification.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-approvals-received-author-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-approvals-received-author-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Your initiative is ready for release"}],"commerce.commerce-approvals-received-author-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.cancellation-reason":[{"type":0,"value":"It could be because the information provided to us is incorrect or incomplete. Don\'t worry,\\n                            the subscription can be reactivated after you update your billing information."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.reactive-within":[{"type":1,"value":"content"},{"type":0,"value":" If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.subscription-cancellation-message":[{"type":0,"value":"We couldn\'t generate an invoice for the following subscription as we don\'t have your complete billing information.\\n                            As a result, the subscription has been canceled."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription canceled - update billing details"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.subject":[{"type":1,"value":"title"},{"type":0,"value":" canceled"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-adjust-limit":[{"type":0,"value":"Organization admins can adjust this limit anytime. For the amount of usage above the allowance, at the end of the current cycle, you\'ll receive a bill for extra usage incurred this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-body":[{"type":0,"value":"Your organization has reached the monthly "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit set by your admin. As a result, some features will be restricted or unavailable until your usage reset date. "},{"type":1,"value":"learnMoreLink"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-caption":[{"type":0,"value":"Your organization has hit its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-body":[{"type":0,"value":"Your organization has used 80% of its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit. This is a limit that was set by your admin, and is different to the allowance included with your subscriptions."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"80% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit has been used"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next":[{"type":0,"value":"Once your organization reaches the limit, some features will be restricted or unavailable until your usage resets. Organization admins can adjust this limit anytime. For the amount of usage above the allowance, at the end of the current cycle, you\'ll receive a bill for extra usage incurred this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.breach":[{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"Your organization has used 80% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.more-about-usage-charges-and-billing":[{"type":0,"value":"More about usage charges and billing"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.whats-next":[{"type":0,"value":"What\'s next?"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-adjust-limit":[{"type":0,"value":"You can adjust this limit anytime. For the amount of usage above the allowance, at the end of the current cycle, the bill will include extra charges incurred for any extra usage this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-body":[{"type":0,"value":"Your customer has reached the monthly "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit you set. As a result, some features will be restricted or unavailable for your customer until their usage reset date. "},{"type":1,"value":"learnMoreLink"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-caption":[{"type":0,"value":"Your customer has hit their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-body":[{"type":0,"value":"Your customer has used 80% of their organization\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit. This is a limit that was set by your customer\'s admin, and is different to the allowance included with your customer\'s subscriptions."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"80% of your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit has been used"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-whats-next":[{"type":0,"value":"Once your customer reaches the limit, some features will be restricted or unavailable until their usage resets. You can adjust this limit anytime. For the amount of usage above the allowance, at the end of the current cycle, the bill will include extra charges incurred for any extra usage this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach.without-company-name":[{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": 80% of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone.without-company-name":[{"type":0,"value":"80% of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-credit-account-approval-ccp.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-approval-ccp.message-template.approved.title":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application has been approved"}],"commerce.commerce-credit-account-approval-ccp.message-template.email.subject":[{"type":0,"value":"Approved for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-approval-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details: "}],"commerce.commerce-credit-account-deactivation-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your account is now ineligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-limit-update-ccp.email.list.new-credit-limit":[{"type":0,"value":"New Credit limit: "},{"type":1,"value":"newCreditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-limit-update-ccp.email.possible-reasons":[{"type":0,"value":"Learn about possible reasons."}],"commerce.commerce-credit-account-limit-update-ccp.email.statement-info":[{"type":0,"value":"We\u2019ve decreased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". "},{"type":1,"value":"possibleReasons"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.decrease.title":[{"type":0,"value":"We\u2019ve decreased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.decrease.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been decreased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.increase.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been increased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve increased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". Here are the details: "}],"commerce.commerce-credit-account-limit-update-ccp.message-template.increase.title":[{"type":0,"value":"We\u2019ve increased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-reactivation-ccp.message-template.email.subject":[{"type":0,"value":"Your account is now re-eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.bad-news":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements."}],"commerce.commerce-credit-account-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Couldn\u2019t approve your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application"}],"commerce.commerce-credit-account-rejection-ccp.message-template.other-option":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce.commerce-credit-account-rejection-ccp.message-template.rejection.title":[{"type":0,"value":"We\u2019re unable to approve you for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.thanks":[{"type":0,"value":"Thank you for submitting your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Credit Application Result: Reject"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.how-to-move-forward":[{"type":0,"value":"Here\'s how to move forward:"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.all-fields":[{"children":[{"type":0,"value":"Double-check"}],"type":8,"value":"strong"},{"type":0,"value":" that every field is filled in \u2014 this helps us complete our review faster."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.return-form":[{"children":[{"type":0,"value":"Send them the form"}],"type":8,"value":"strong"},{"type":0,"value":" and ask them to return it directly to us."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.sign":[{"children":[{"type":0,"value":"Sign"}],"type":8,"value":"strong"},{"type":0,"value":" the top of the form."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.vendors":[{"children":[{"type":0,"value":"Choose two vendors"}],"type":8,"value":"strong"},{"type":0,"value":" you\'ve traded with for at least 12 months, whose trade volume with you exceeds the credit limit you\'re requesting. Please note: they can\'t be related entities."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.financial-statements":[{"children":[{"type":0,"value":"Latest audited financial statements"}],"type":8,"value":"strong"},{"type":0,"value":" (if you haven\'t already shared these), or"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.trade-references":[{"children":[{"type":0,"value":"A completed trade references form"}],"type":8,"value":"strong"},{"type":0,"value":" (attached)"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment":[{"type":0,"value":"The good news? This isn\'t final \u2014 we\'d be happy to reassess your account once we have a bit more information."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment-underway":[{"type":0,"value":"Once we receive everything, we\'ll get your reassessment underway."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.rejection":[{"type":0,"value":"Thank you for applying for payment terms with us. After carefully reviewing your application, we\'re unable to approve Net-30 terms at this time."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.resubmit-instructions":[{"type":0,"value":"Once you have the additional information ready, you can resubmit a new Net-30 application directly from your account (the application link is available there). Just include "},{"children":[{"type":0,"value":"one"}],"type":8,"value":"strong"},{"type":0,"value":" of the following with your resubmission:"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.trade-reference-intro":[{"type":0,"value":"Using the trade references form? Just follow these 4 steps:"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.card-expiry-warning-message":[{"type":0,"value":"Heads up \u2014 your credit card expires in "},{"type":1,"value":"expiryMonthAndYear"},{"type":0,"value":". To make sure your next payment is made on time so you can continue using your subscriptions without interruption, you\u2019ll need to update your payment details before "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action":[{"type":0,"value":"What happens if I don\u2019t update my details?"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action-warning":[{"type":0,"value":"Your next payment attempt will fail \u2013 this means your subscription could be deactivated and you could lose product access and data."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.select":[{"type":0,"value":"Select "}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your credit card expires soon"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.time-to-update-credit-card-details":[{"type":0,"value":"Time to update your credit card details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details":[{"type":0,"value":"Update payment details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details-note":[{"type":0,"value":" below to edit your saved card."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.email.subject":[{"type":0,"value":"Additional information needed for your Net-30 application"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.balance-sheet":[{"type":0,"value":"Balance Sheet"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.cash-flow":[{"type":0,"value":"Cash Flow Statement"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.income-statement":[{"type":0,"value":"Income Statement"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.all-fields":[{"type":0,"value":"Ensure all fields are completed so we can finalize the review without delays."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.return-form":[{"type":0,"value":"Send them the form and ask them to return it directly to us."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.sign":[{"type":0,"value":"Sign the top of the form."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.vendors":[{"type":0,"value":"Select two vendors you\'ve traded with for at least 12 months, whose trade volume with you exceeds the credit limit you\'re requesting. Please note that they can\'t be related entities."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.intro":[{"type":0,"value":"Thank you for your interest in setting up Net-30 payment terms with us. After reviewing your D&B credit profile, we\'re unable to approve the request at this time."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-accounting-team":[{"type":0,"value":"Your accounting team should be able to provide these. They\'ll give us a clearer view of your account and support our reassessment."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-heading":[{"type":0,"value":"Option 1: Provide your audited financial statements"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-intro":[{"type":0,"value":"If you haven\'t already shared these, please send your most recent:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-heading":[{"type":0,"value":"Option 2: Provide trade references"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-intro":[{"type":0,"value":"If you\'d prefer this option, please complete the attached trade reference form. Here\'s what we\'ll need:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.reconsider":[{"type":0,"value":"If you\'d like us to reconsider, we\'d be glad to take another look with some additional information from your end."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.thank-you":[{"type":0,"value":"Thank you again for being an Atlassian customer. We appreciate your business and look forward to hearing from you soon."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.two-options":[{"type":0,"value":"You have two options:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-body":[{"type":0,"value":"Please let us know which option you\'d like to pursue, or feel free to reach out with any questions. We\'re here to support you and want to make this process as straightforward as possible."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-heading":[{"type":0,"value":"What happens next?"}],"commerce.commerce-customer-contact-remove-digest.email.body.removed-contact":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":")"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.caption":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.contact-removed":[{"type":0,"value":"Contact removed: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.impacted-subscriptions":[{"type":0,"value":"Impacted subscriptions:"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.intro":[{"type":0,"value":"We\'ve removed a key customer contact from a billing profile."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.questions":[{"type":0,"value":"If you have any questions, please reach out to your Atlassian billing partner."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.removed-by":[{"type":0,"value":"Removed by: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes":[{"type":0,"value":"You can view the changes at "},{"type":1,"value":"url"},{"type":0,"value":" page."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes-link":[{"type":0,"value":"partner managed subscriptions"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" subscriptions."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.subject":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customers-deactivation-eve.email.body-p1":[{"type":0,"value":"U.S. law prohibits Atlassian, an Australian corporation with offices in the United States, from providing you with access to our products and services. After analyzing the applicable lists of restricted parties maintained by the U.S. Government, we were unable to confirm that your name was not affiliated with a restricted party."}],"commerce.commerce-customers-deactivation-eve.email.body-p2":[{"type":0,"value":"If this is a case of misidentification, please reply with two different copies of official documentation to verify your identity."}],"commerce.commerce-customers-deactivation-eve.email.body-p3":[{"type":0,"value":"Official documentation includes, but is not limited to, a government-issued driver\'s license or identification card, passport, utility bill, mortgage or bank statement, etc. Please make sure your full name and address are clearly visible."}],"commerce.commerce-customers-deactivation-eve.email.body-p4":[{"type":0,"value":"You may check out these resources for more information: U.S. export controls ("},{"type":1,"value":"exportControl"},{"type":0,"value":") | Consolidated Screening List ("},{"type":1,"value":"csl"},{"type":0,"value":")"}],"commerce.commerce-customers-deactivation-eve.email.body-p5":[{"type":0,"value":"Please reply directly via email with any further questions and the identification requested."}],"commerce.commerce-customers-deactivation-eve.email.body-p6":[{"type":0,"value":"We look forward to your reply."}],"commerce.commerce-customers-deactivation-eve.email.body.csl":[{"type":0,"value":"https://www.trade.gov/consolidated-screening-list"}],"commerce.commerce-customers-deactivation-eve.email.body.exportControl":[{"type":0,"value":"https://www.trade.gov/us-export-controls"}],"commerce.commerce-customers-deactivation-eve.email.caption":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-customers-deactivation-eve.email.salutation":[{"type":0,"value":"Dear Atlassian user,"}],"commerce.commerce-customers-deactivation-eve.email.subject":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.billed-based-on-the-users":[{"type":0,"value":"Until now, billing for this app has been linked to your total user count for Jira. The change will mean that you\'ll be billed based on the number of agents who use the Jira Service Management subscription instead."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.billing-flexibility-info-message":[{"type":0,"value":"Billing flexibility is now available for your "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management app."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.body.this-change-will-introduce-pricing-updates":[{"type":0,"value":"The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn\'t updated."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.body.we-will-make-the-change":[{"type":0,"value":"We\'ll automatically make the change on "},{"type":1,"value":"nextBillingDate"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.caption":[{"type":0,"value":"Have more billing flexibility and only pay for what you need"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.if-you-dont-do-anything":[{"type":0,"value":"If you don\'t do anything"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.maximize-your-billing-efficiency":[{"type":0,"value":"Maximize your billing efficiency"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.need-more-info":[{"type":0,"value":"Need more info? See our guide on "},{"type":1,"value":"howMarketplaceAreBilled"},{"type":0,"value":"."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billed-based-on-the-users":[{"type":0,"value":"Until now, billing for this app has been linked to your customer\'s total user count for Jira. The change will mean that your customer will be billed based on the number of agents who use the Jira Service Management subscription instead."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billing-flexibility-info-message":[{"type":0,"value":"Billing flexibility is now available for your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management app."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.this-change-will-introduce-pricing-updates":[{"type":0,"value":"The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn\'t updated."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.we-will-make-the-change":[{"type":0,"value":"We\'ll automatically make the change on "},{"type":1,"value":"nextBillingDate"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.caption":[{"type":0,"value":"Give your customer more billing flexibility"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.customer-label":[{"type":0,"value":"Customer: "},{"type":1,"value":"customerName"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-for-what-you-need":[{"type":0,"value":"To only pay for what you need, your customer can update the number of JSM agents by heading to Atlassian Administration."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-only-for-users-who-need-access":[{"type":0,"value":"This means they have the option to only pay for the users that really need access."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.review-your-bill":[{"type":0,"value":"Make the switch now so your customer can start making the most of billing flexibility for this app. Keep in mind that the bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We\'d recommend reviewing the bill as you make the change."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.pay-for-what-you-need":[{"type":0,"value":"To only pay for what you need, your organization admin can update the number of JSM agents by heading to Atlassian Administration."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.pay-only-for-users-who-need-access":[{"type":0,"value":"This means you have the option to only pay for the users that really need access."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.review-your-bill":[{"type":0,"value":"Make the switch now to start making the most of billing flexibility for this app. Keep in mind that your bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We\'d recommend reviewing your bill as you make the change."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Update billing for your Marketplace app"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.what-does-this-mean":[{"type":0,"value":"What does this mean?"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p1":[{"type":0,"value":"As requested, we\'ve updated the way you\'re billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management. You can now enjoy more control over who has access to and is charged for the app, and your bill will be based on the number of Jira Service Management agents, instead of the user count for Jira."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p2":[{"type":0,"value":"It\'s a good idea to review who you\'d like to have access to the app. Keep in mind that your bill may be impacted, and organization admins can change it by managing who has access to the app as needed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p1":[{"type":0,"value":"As requested, we\'ve updated the way your customer is billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management. They can now enjoy more control over who has access to and is charged for the app, and the bill will be linked to the number of JSM agents instead of the user count for Jira."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p2":[{"type":0,"value":"It\'s a good idea to remind your customer to review who they\'d like to have access to the app, and their bill may be impacted. Organization admins can adjust the bill by managing who has access to the app as needed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.button.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.help":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouch"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.get-in-touch":[{"type":0,"value":"Get in touch"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.how-billed":[{"type":0,"value":"Find out more about how Marketplace apps are billed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.signoff":[{"type":0,"value":"Thanks,"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" for JSM billing has been updated"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.partner":[{"type":0,"value":"Update billing for your customer\'s Marketplace app"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.team":[{"type":0,"value":"The Atlassian team"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.direct":[{"type":0,"value":"Enjoy more control over your Marketplace app billing"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.partner":[{"type":0,"value":"Enjoy more control over your customer\'s app billing"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.custom":[{"type":1,"value":"greetingText"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.default":[{"type":0,"value":"Dear "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-dynamic-content-test-cns.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"message"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-generated-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"businessKey"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-generated-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-resend-email-ccp.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-invoice-resend-email-ccp.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-invoice-resend-email-ccp.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.commerce-invoice-resend-email-ccp.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"commerce.commerce-invoice-resend-email-ccp.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"commerce.commerce-invoice-resend-email-ccp.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.offer-message":[{"type":0,"value":"When you use the two together, you can centralize your docs, connect work across teams and more. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-congratulations-message":[{"type":0,"value":"Did you know that "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Confluence?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-product-caption":[{"type":0,"value":"Build a single source of truth for all your team\u2019s important info"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.cta.try-now":[{"type":0,"value":"Try now"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.offer-message":[{"type":0,"value":"Together, the products help you capture ideas and prioritize work, so you\u2019re always organized. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-congratulations-message":[{"type":0,"value":"Did you know "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Jira Product Discovery?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-product-caption":[{"type":0,"value":"Say goodbye to messy backlogs"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.offer-message":[{"type":0,"value":"With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-congratulations-message":[{"type":0,"value":"People who use Jira Service Management say that work is more visible for all teams involved, from request to resolution."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-product-caption":[{"type":0,"value":"Bring developers, IT, and operations onto the same platform"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.offer-message":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-congratulations-message":[{"type":0,"value":"Jira and "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" can help you visualize and deliver work, fast."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-product-caption":[{"type":0,"value":"Break down silos and connect the dots between teams"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-congratulations-message":[{"type":0,"value":"Congrats on purchasing "},{"type":1,"value":"purchasedProductTitle"},{"type":0,"value":"! Get free trials of these products and unlock these advanced features:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-product-caption":[{"type":0,"value":"Get free trials of "},{"type":1,"value":"productName1"},{"type":0,"value":" & "},{"type":1,"value":"productName2"},{"type":0,"value":" Standard with your "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" purchase"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.trial-length-message":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement-with-trial-length.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.single-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-space-permissions":[{"type":0,"value":"Advanced user & space permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.higher-automation-limit":[{"type":0,"value":"Higher automation limit"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.insights-into-page-views":[{"type":0,"value":"Get insights into page views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.on-call-management":[{"type":0,"value":"On-call management"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.published-views":[{"type":0,"value":"Published views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.trial-length":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents":[{"type":0,"value":"Unlimited agents"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents-storage":[{"type":0,"value":"Unlocked agent & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creator-storage":[{"type":0,"value":"Unlocked creator & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-user-storage":[{"type":0,"value":"Unlocked user & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-users":[{"type":0,"value":"Unlimited users"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-archive.alt-text":[{"type":0,"value":"Icon - Archive"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-graph.alt-text":[{"type":0,"value":"Icon - Graph"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-lightning.alt-text":[{"type":0,"value":"Icon - Lightning"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-link.alt-text":[{"type":0,"value":"Icon - Link"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-people.alt-text":[{"type":0,"value":"Icon - People"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-phone.alt-text":[{"type":0,"value":"Icon - Phone"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-unlock.alt-text":[{"type":0,"value":"Icon - Unlock"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.billing":[{"type":1,"value":"billingUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.faq":[{"type":0,"value":"FAQs"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.migrate":[{"type":0,"value":"You have been successfully migrated from Jira Work Management to Jira, within "},{"type":1,"value":"site"},{"type":0,"value":"."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.options":[{"type":0,"value":"To view pricing, auto-renewal, and cancellation options, go to "},{"type":1,"value":"billing"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.site":[{"type":1,"value":"siteUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.subsciption":[{"type":0,"value":"The current price of your subscription has not changed. However, pricing may vary if changes are made to your user tier, plan, and/or licensing. See "},{"type":1,"value":"faq"},{"type":0,"value":" for more details."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.caption":[{"type":0,"value":"You\u2019ve been successfully migrated to Jira"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.subject":[{"type":0,"value":"Your migration was successful"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.encryption-policy-info":[{"type":0,"value":"CMK policy enrollment is required for activation. "},{"type":1,"value":"supportInfo"},{"type":0,"value":" to self-enroll before provisioning Atlassian app instances. For step-by-step instructions, refer to the support "},{"type":1,"value":"CMKSupportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.manage-subscription":[{"type":0,"value":"Please click \u2018Manage Subscription\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.partner-managed-subscription":[{"type":0,"value":"Please visit your partner-managed subscriptions page"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.view-subscription":[{"type":0,"value":"Please click \u2018View all Subscriptions\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration. You can view a detailed breakdown of your team\u2019s usage in your billing account."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above your allowance may incur extra usage charges, which will be added to your bill each month. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.cbp-details":[{"type":0,"value":"Your plan includes:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"You can visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":" to learn more about how billing works."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"We\u2019ll send the final invoice within 24 hours, which will include all the details and payment options for your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" details from your "},{"type":1,"value":"hostingDetails"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.non-cloud.billing-info":[{"type":0,"value":"Go to your billing account to set up your new subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated-with-date.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription from its start date"}]},"other":{"value":[{"type":0,"value":"subscriptions from their start dates"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-reseller":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.give-admin-permission":[{"type":0,"value":"Setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian billing partner. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian reseller. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-reseller":[{"type":0,"value":"You can view or cancel your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time by going to "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" and following the steps."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"the subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.setup-your-site":[{"type":0,"value":"Get started straight away by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":":"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-url":[{"children":[{"type":1,"value":"siteURL"}],"type":8,"value":"a"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.ecc-reseller-managed-subscription.url":[{"type":0,"value":"your Subscription overview"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body-ecc.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.subject":[{"type":1,"value":"billToPartyName"},{"type":0,"value":": Atlassian product order confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\u2019s bill each month. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.auto_prov_notification":[{"type":0,"value":"The products will be added to your customer\u2019s account shortly."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.cbp-details":[{"type":0,"value":"The plan also includes the following:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.customer_contact_info":[{"type":0,"value":"Your customer contact can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.get-started":[{"type":0,"value":"You can get started straight away by setting up the subscriptions. We\u2019ve also sent a notification to your customer with a setup link to get started. "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from our "},{"type":1,"value":"ppcHomePage"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_invoice_info":[{"type":0,"value":"We\u2019ll email the invoice with all the details within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_notification":[{"type":0,"value":"We\u2019ll also send a notification to your customer with a link to set up their new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and get started."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-details":[{"type":0,"value":"We\u2019ll send you an invoice with all the details within 24 hours. We\u2019ll also send an email to your customer with a link to set up and get started with their new subscription. You can get started straight away by setting up the subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order, and the products will be ready to use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\'ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscriptions from their start dates. We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.with.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscription/s on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"For more information on how to manage your subscriptions and billing, visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"Expect the final invoice within 24 hours, which will include all the necessary details and payment options for your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your cloud site for your new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your Atlassian order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-date.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-manage-subscriptions":[{"type":0,"value":"You can view the subscription from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.next_steps":[{"type":0,"value":"Get started by setting up your customer\u2019s cloud site for the new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.ppc_homepage":[{"type":0,"value":" You can also view and manage the subscription details from our Partner Purchasing Center. "},{"type":1,"value":"viewQuoteUrl"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.processing":[{"type":0,"value":"We\u2019re processing the payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-date.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.subject":[{"type":0,"value":"We\u2019ve received your order for "},{"type":1,"value":"customerCompanyName"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message-template.email.subject":[{"type":0,"value":"This template has been deprecated"}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message.email.body.no-translate":[{"type":0,"value":"This template has been deprecated as it has been merged along with \'commerce-quote-order-fulfilled-ccp\' template with dynamic content added to differentiate between pull/push payment method."}],"commerce.commerce-partner-cancellation-personal-data-deletion-link":[{"type":0,"value":"personal data deletion request form"}],"commerce.commerce-partner-personal-data-deletion":[{"type":0,"value":"If your customer would like to place a request for immediate deletion of personal data after cancellation, they can submit a "},{"type":1,"value":"formLink"},{"type":0,"value":". Otherwise, the data will be deleted in accordance with Atlassian\u2019s standard "},{"type":1,"value":"policyLink"},{"type":0,"value":"."}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\'ve received your payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The invoice is attached as a PDF for your records."}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.confirm":[{"type":0,"value":"This email is to confirm we have received payment for the following invoice:"}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your payment has been processed for the invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Payment processed"}],"commerce.commerce-payment-method-manage-ccp.account-ending-key":[{"type":0,"value":"Account ending: "}],"commerce.commerce-payment-method-manage-ccp.account-ending-value":[{"type":1,"value":"last4"}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-key":[{"type":0,"value":"Account holder name: "}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-value":[{"type":1,"value":"accountHolder"}],"commerce.commerce-payment-method-manage-ccp.authorization-date-key":[{"type":0,"value":"Authorization date: "}],"commerce.commerce-payment-method-manage-ccp.authorization-date-value":[{"type":1,"value":"authorizationDate"}],"commerce.commerce-payment-method-manage-ccp.authorization-details":[{"type":0,"value":"Authorization details"}],"commerce.commerce-payment-method-manage-ccp.bank-name-key":[{"type":0,"value":"Bank name: "}],"commerce.commerce-payment-method-manage-ccp.bank-name-value":[{"type":1,"value":"bankName"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-authorization":[{"type":0,"value":"Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-dispute":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce.commerce-payment-method-manage-ccp.could-not-process-payment":[{"type":0,"value":"We couldn\'t process your recent payment due to a dispute raised with your bank."}],"commerce.commerce-payment-method-manage-ccp.direct-debit-legal-terms":[{"type":0,"value":"You have authorized Atlassian to debit the bank account specified above for any amount owed for charges arising from your use of Atlassian\u2019 services and/or purchase of products from Atlassian, pursuant to Atlassian\u2019 website and terms, until this authorization is revoked. You have authorized Atlassian to debit your bank account periodically if and when you use Atlassian\u2019 services or purchase more than one of Atlassian\u2019 products periodically pursuant to Atlassian terms. Payments that fall outside the regular debits authorized above will only be debited after your authorization is obtained."}],"commerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-mandate":[{"type":0,"value":"Confirmation: Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.how-to-cancel-direct-debit":[{"type":0,"value":"You can cancel this direct debit at any time by deleting the linked bank account from your "},{"type":1,"value":"paymentMethods"},{"type":0,"value":" page"}],"commerce.commerce-payment-method-manage-ccp.payment-methods":[{"type":0,"value":"Payment methods"}],"commerce.commerce-payment-method-manage-ccp.received-authorization":[{"type":0,"value":"We\u2019ve received your authorization for direct debit."}],"commerce.commerce-payment-method-manage-ccp.routing-number-key":[{"type":0,"value":"Routing number: "}],"commerce.commerce-payment-method-manage-ccp.routing-number-value":[{"type":1,"value":"routingNumber"}],"commerce.commerce-payment-method-manage-ccp.update-bank-details":[{"type":0,"value":"Update your bank account details, or link a different bank account. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce.commerce-permission-request-add-payment-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: You have an add payment request"}],"commerce.commerce-permission-request-add-payment-response-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Request complete: Payment details added by billing admin "}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.cta.accept-billing-admin-request":[{"type":0,"value":"Review billing admin request"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.ba-request-text":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") is requesting billing admin permission for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.personal-note.no-translate":[{"type":1,"value":"customMessage"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.subtext-for-personal-note":[{"type":0,"value":"The request was sent with the following note: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.title":[{"type":1,"value":"name"},{"type":0,"value":" is requesting billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.what-they-can-do":[{"type":0,"value":"If you approve, they\'ll be able to:"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.whats-next-subtext":[{"type":0,"value":"If you accept the request, we\'ll notify the requester. If you don\'t want to grant billing admin access, you can decline the request."}],"commerce.commerce-permission-request-grant-ba-role-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: "},{"type":1,"value":"requesterName"},{"type":0,"value":" is requesting Billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.cta.manageSubscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails-for-changes":[{"type":0,"value":"Receive emails about any changes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.request-billing-admin":[{"type":0,"value":"Request billing admins to make changes to subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-site":[{"type":0,"value":"View, upgrade, downgrade and cancel subscriptions in your site"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-approved-text":[{"type":0,"value":"Great news - your billing admin request has been approved for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-declined-text":[{"type":0,"value":"Your request to become a billing admin on the following account has been declined."}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-approved":[{"type":0,"value":"You\'re now a billing admin"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get":[{"type":0,"value":"You\'ll now be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get-without-access":[{"type":0,"value":"You\'ll still be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.approved":[{"type":0,"value":"Your billing admin request has been approved"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-pre-comms-sp-add-on-merge-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Important information about your Statuspage add-ons"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.body-text":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" Standard "},{"children":[{"type":0,"value":"trial has ended."}],"type":8,"value":"strong"},{"type":0,"value":" You\'re currently over the 10-user limit for our Free plan. Add payment details now to keep your team active - otherwise, your team will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.heading":[{"type":0,"value":"Last chance to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" site and data"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.not-ready-heading":[{"type":0,"value":"Not ready to upgrade?"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.subject":[{"type":0,"value":"Last chance to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-admin":[{"type":0,"value":"You can switch back to a Free plan by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"link"},{"type":0,"value":" to 10 or fewer."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan by reducing your user count to 10 or fewer."}],"commerce.commerce-pre-dunning-ccp.v2.email.contact-us":[{"type":0,"value":"Please "},{"type":1,"value":"contactUs"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"commerce.commerce-pre-dunning-ccp.v2.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-pre-dunning-ccp.v2.email.total-bill":[{"type":0,"value":"Your total estimated bill is "},{"type":1,"value":"amount"},{"type":0,"value":" (excludes tax)"}],"commerce.commerce-quote-expired-ccp.email.caption":[{"type":0,"value":"Your quote has expired"}],"commerce.commerce-quote-expired-ccp.email.contact-us":[{"type":0,"value":"Contact us"}],"commerce.commerce-quote-expired-ccp.email.ready-to-order":[{"type":0,"value":"If you\u2019d like to try Atlassian products, opt for a free trial."}],"commerce.commerce-quote-expired-ccp.email.reminder-before-expiry":[{"type":0,"value":"Your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired. You\u2019ll no longer be able to pay for it."}],"commerce.commerce-quote-expired-ccp.email.view-quote":[{"type":0,"value":"You can always create a new quote by reaching out to us."}],"commerce.commerce-quote-expired-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"It\u2019s time to renew your subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.request-quote-to-avoid-losing-access":[{"type":0,"value":"To avoid losing access to your products, request a quote that is valid until the end of your billing cycle. When you are ready to pay, simply review the quote and place your order. "}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.list-subscriptions":[{"type":0,"value":"Subscriptions list:"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.caption":[{"type":0,"value":"It\u2019s time to renew"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.reach-out-to-create-quote":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.request-quote-to-avoid-customer-losing-access":[{"type":0,"value":"To avoid losing access to the products, request a quote valid until the end of your billing cycle. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring":[{"type":0,"value":"Just a heads up that you have subscriptions that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring-for-customer-company":[{"type":0,"value":"Just a heads up that you have subscriptions for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote billing period"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote billing period change"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.updated-quote-body":[{"type":0,"value":"We\'ve updated the quote billing period for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.estimates-changed":[{"type":0,"value":"Changing the billing period has changed how we calculate the quote total, which means that the quote total has now been updated."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote billing period and total change"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.updated-quote-body":[{"type":0,"value":"We\'ve updated the quote billing period and quote total for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote total"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote total change"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.updated-quote":[{"type":0,"value":"We\'ve updated the quote total for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because the billing address or sold-to address or subscription\'s user count linked to the quote was updated since the quote was created, which changes how we estimate the quote total."}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.caption":[{"type":0,"value":"It\u2019s time to renew "}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.get-in-touch":[{"type":0,"value":"Get in touch with your Atlassian Billing Partner to get started on your renewal. They\u2019ll be able to help you with your quote and any next steps."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.let-you-know":[{"type":0,"value":"We hope you\u2019ve been enjoying your Atlassian products. We wanted to let you know that your subscription/s expire soon, so it\u2019s time to renew."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-quote-open-auto-renewal-ccp.message-template.email.ecc.subject":[{"type":0,"value":"Contact your Atlassian Billing Partner to renew "}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.caption":[{"type":0,"value":"Renew your subscription"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.caption":[{"type":0,"value":"It\'s time to renew your subscription"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order":[{"type":0,"value":"When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. You can also head to our Partner Purchasing Center to create an order. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"learnMoreLink"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order-title":[{"type":0,"value":"To create an order"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.intro":[{"type":0,"value":"Hi, "},{"children":[],"type":8,"value":"br"},{"type":0,"value":"Just a heads up that the subscription for "},{"type":1,"value":"companyName"},{"type":0,"value":" expires soon and is ready to be renewed. To review the subscription details and the cost, we\'ve created a quote that\'s valid until the end of your customer\'s billing cycle."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.quote-created":[{"type":0,"value":"This is a friendly reminder that you have subscriptions up for renewal on "},{"children":[{"type":1,"value":"renewalDate"}],"type":8,"value":"b"},{"type":0,"value":". To review your subscription details and assess the cost, we\'ve created a quote("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") that\'s valid until the end of your current billing cycle. To view the details, download the attached quote PDF."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.ready-to-pay":[{"children":[{"type":0,"value":"Ready to pay?"}],"type":8,"value":"b"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.reseller.create-order":[{"type":0,"value":"When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"learnMoreLink"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-details":[{"type":0,"value":"When you\'re ready to renew your subscription, access the quote from the "},{"children":[{"type":0,"value":"Quotes"}],"type":8,"value":"b"},{"type":0,"value":" page of your "},{"children":[{"type":0,"value":"billing account"}],"type":8,"value":"billingLink"},{"type":0,"value":" and place an order."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-answer":[{"type":0,"value":"Your subscription will be canceled, unless you renew for the next billing cycle."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-question":[{"children":[{"type":0,"value":"What happens after my current billing cycle ends?"}],"type":8,"value":"b"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.direct":[{"type":0,"value":"Renew now: your subscription expires soon"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.partner":[{"type":0,"value":"Quote created for "},{"type":1,"value":"companyName"},{"type":0,"value":" ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":")"}],"commerce.commerce-quote-open-auto-trial-ccp.email.caption":[{"type":0,"value":"Your quote is ready"}],"commerce.commerce-quote-open-auto-trial-ccp.email.place-order":[{"type":0,"value":"Ready to start your paid subscription? Simply review the quote and place your order."}],"commerce.commerce-quote-open-auto-trial-ccp.email.quote-created":[{"type":0,"value":"We\'ve created a quote for your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" trial ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"), to help you assess if it\'s the right plan for you. The quote is valid until your trial ends on "},{"children":[{"type":1,"value":"trialExpiry"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-quote-open-auto-trial-ccp.email.reminder":[{"type":0,"value":"Just a reminder \u2013 be sure to order before your trial ends to avoid losing access to your product."}],"commerce.commerce-quote-open-auto-trial-ccp.email.view-details":[{"type":0,"value":"To view the details, download the attached quote PDF or go to the "},{"children":[{"type":0,"value":"Quotes"}],"type":8,"value":"b"},{"type":0,"value":" page of your "},{"children":[{"type":0,"value":"billing account"}],"type":8,"value":"billingLink"},{"type":0,"value":"."}],"commerce.commerce-quote-open-auto-trial-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-trial-ccp.message-template.email.subject":[{"type":0,"value":"Quote created: "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" trial ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":")"}],"commerce.commerce-quote-open-ccp.email.contract-type-non-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, contact your customer advocate."}],"commerce.commerce-quote-open-ccp.email.contract-type-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, go to the quote in your billing account and proceed to create an order."}],"commerce.commerce-quote-open-ccp.email.direct-customer":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":0,"value":"admin.atlassian.com/billing"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":1,"value":"billingUrlText"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open-reminder":[{"type":0,"value":"Keep in mind, if you have product trials in the quote, we recommend placing your order before the trial ends. If you need more time, "},{"children":[{"type":0,"value":"reach out to us"}],"type":8,"value":"RawLink"},{"type":0,"value":" to extend your quote validity."}],"commerce.commerce-quote-open-ccp.email.manage-subscription":[{"type":0,"value":"You can view subscription and billing details on your "},{"children":[{"type":0,"value":"Manage Subscriptions"}],"type":8,"value":"RawLink"},{"type":0,"value":" page."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open":[{"type":0,"value":"Good news \u2013 the quote you requested is now ready:"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open-details":[{"type":0,"value":"The quote will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details, select \u2018View quote\u2019 and download the PDF."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.email.partner-ppc-homepage":[{"type":0,"value":"You can also view quotes and manage these subscriptions from our Partner Purchasing Center. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is here!"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.partner-or-reseller":[{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is ready"}],"commerce.commerce-quote-reminder-expiry-ccp.email.administration":[{"type":0,"value":"Administration"}],"commerce.commerce-quote-reminder-expiry-ccp.email.caption":[{"type":0,"value":"Your quote will expire soon"}],"commerce.commerce-quote-reminder-expiry-ccp.email.order-in-bac":[{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":" and create an order."}],"commerce.commerce-quote-reminder-expiry-ccp.email.ready-to-order":[{"type":0,"value":"When you\u2019re ready to convert your quote to an order, go to your site\'s "}],"commerce.commerce-quote-reminder-expiry-ccp.email.reminder-before-expiry":[{"type":0,"value":"This is a friendly reminder that your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire on "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". Once expired, the quote will be canceled and you have to create a new one."}],"commerce.commerce-quote-reminder-expiry-ccp.email.view-quote":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-reminder-expiry-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire soon"}],"commerce.commerce-quote-stale-ccp.email.body":[{"type":0,"value":"Just a heads up that your quote for "},{"type":1,"value":"companyName"},{"type":0,"value":" needs to be updated before it can be moved back to OPEN."}],"commerce.commerce-quote-stale-ccp.email.caption":[{"type":0,"value":"Your quote needs to be reviewed"}],"commerce.commerce-quote-stale-ccp.email.update-line-item":[{"type":0,"value":"Head to the effected line item/s on the quote and follow the prompts from the error to update it. If that doesn\'t work, you\'ll need to raise a GSAC ticket so that an Atlassian Customer Advocate can look into it."}],"commerce.commerce-quote-stale-ccp.message-template.email.subject":[{"type":0,"value":"Action required: "},{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" needs review"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.caption":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been successfully reactivated"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.we-will-charge":[{"type":0,"value":"We\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entNumber"},{"type":0,"value":")"}],"commerce.commerce-reactivation-order-to-paid-ccp.personal-information":[{"type":0,"value":"Since you reactivated your subscription within 60 days of cancellation, your data and preferences\\n                    are as you left them. You can jump right in and get started!"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.cannot-be-refunded":[{"type":0,"value":"Please note that this balance can\'t be refunded or exchanged for cash."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.caption":[{"type":0,"value":"Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.completed":[{"type":0,"value":"We have successfully processed your request for SLA Compensation. You are entitled to receive Service Credits, as per our service level commitment. These credits will be added to your account balance and will be used in future invoices."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.terms":[{"type":0,"value":"Service Credits are applied to your account governed by the terms in "},{"type":1,"value":"slaLink"},{"type":0,"value":". To read more about Service Credits, click "},{"type":1,"value":"hereLink"},{"type":0,"value":"."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.here-link-text":[{"type":0,"value":"here"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.completed":[{"type":0,"value":"We\'ve successfully processed a request for SLA Compensation. You\'re entitled to receive Service Credits, as per our service level commitment. These credits will be added to your account balance and used in future invoices."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":": Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.terms":[{"type":0,"value":"Service Credits are applied to your account governed by the terms in "},{"type":1,"value":"slaLink"},{"type":0,"value":". Read more about "},{"type":1,"value":"serviceCreditsLink"},{"type":0,"value":"."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.service-credits-link-text":[{"type":0,"value":"Service Credits"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.sla-link-text":[{"type":0,"value":"Atlassian Service Level Agreement"}],"commerce.commerce-refund-generic-email-ccp.email.direct.caption":[{"type":0,"value":"Your refund has been processed"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.caption":[{"type":0,"value":"Your refund has been processed"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.completed":[{"type":0,"value":"We have completed the refund related to the following invoice:"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.refund-amount":[{"type":0,"value":"The refund has been credited to the payment method used in the original purchase. Please allow 2-3 business days for the refunded amount to appear on your bank statement. Please note that any subscription changes based on your refund request will reflect on your account shortly."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.cash-refund":[{"type":0,"value":"If you would like to receive a cash refund instead, please reach out to "},{"children":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"type":8,"value":"a"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.completed":[{"type":0,"value":"We have completed the refund related to the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.credit-issued":[{"type":0,"value":"The credits issued on this credit note will be applied to any outstanding unpaid invoices you may have."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Refund processed for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-refund-generic-email-ccp.message-template.email.more-info":[{"type":0,"value":"For more information about invoices and subscriptions, go to your sites "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Refund processed"}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-amount":[{"type":0,"value":"The refunded amount should appear on your bank statement in 2-3 business days. Any subscription changes based on your refund request will reflect on your account soon."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-cc":[{"type":0,"value":"A refund from the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been credited to your card "},{"children":[{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"maskedNumber"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-paypal":[{"type":0,"value":"A refund from the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been credited to your "},{"children":[{"type":0,"value":"PayPal account, "},{"type":1,"value":"paypalEmail"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.terms-completed":[{"type":0,"value":"We have completed the refund related to the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" and generated a credit note "},{"type":1,"value":"creditNoteNumber"},{"type":0,"value":" against it."}],"commerce.commerce-refund-internal-ccp.message-template.email.adc-refund.body":[{"type":0,"value":"Advocate Central REFUND LINK - "},{"type":1,"value":"advocateCentralUrl"},{"type":0,"value":"/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-bank-transfer.subject":[{"type":0,"value":"Bank Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-onAccount.subject":[{"type":0,"value":"Expert Account Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund.body":[{"type":0,"value":"CASSI REFUND LINK - "},{"type":1,"value":"cassiUrl"},{"type":0,"value":"/ui/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-rde-caption":[{"type":0,"value":"Upgrade to Rovo Dev Standard to get more Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"Rovo Dev credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached.pooled-meter":[{"type":1,"value":"productName"},{"type":0,"value":" allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone.pooled-meter":[{"type":1,"value":"productName"},{"type":0,"value":" allowance is running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-monitor":[{"type":0,"value":"You can monitor usage in your billing account to see which users have used their allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-ugrade-to-standard":[{"type":0,"value":"To increase Rovo Dev credits and allow extra usage, organization admins can upgrade to Rovo Dev Standard."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-user-cannot-use-extra":[{"type":0,"value":"Users who are at their credit limit won\'t be able to use any Rovo Dev features until the next billing cycle."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done anytime in Atlassian Administration to keep costs predictable. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-extra-usage-charges":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trialsneed-to-know-list-function-disabled":[{"type":0,"value":"Rovo Dev functionality is disabled for users who reach their allowance, and usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done at any time in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-will-be-disabled":[{"type":0,"value":"Once users use up their Rovo Dev credits, Rovo Dev functionality will be disabled until usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-details.ubp5":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message-announcement.ubp5":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-rde-info-message":[{"type":0,"value":"At least one of your users has used up their free Rovo Dev credit allowance in Jira."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-update-limits.ubp5":[{"type":0,"value":"Your org admin can update your usage limits anytime."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-what-next.ubp5":[{"type":0,"value":"If your org admin has enabled extra usage, you\u2019ll incur extra usage charges up to your extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until your usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.rovo-no-interruption":[{"type":0,"value":"Your org can still use "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" without interruption. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement.ubp5":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-org-details.ubp5":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-what-next.ubp5":[{"type":0,"value":"If your org reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until your usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone.rovo-no-interruption":[{"type":0,"value":"If the allowance limit is reached, your org can still use "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" without interruption. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-details.ubp5":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message-pooled-meter.ubp5":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-update-limits.ubp5":[{"type":0,"value":"You can update your customer\u2019s usage limits anytime."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-what-next.ubp5":[{"type":0,"value":"If you\'ve enabled extra usage for your customer, they\u2019ll incur extra usage charges up to the extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until their usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached.rovo-no-interruption":[{"type":0,"value":"Your customer can still use "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" without interruption. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-details.ubp5":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter.ubp5":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-vist-ppc-pooled-meter":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-what-next.ubp5":[{"type":0,"value":"If your customer reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until their usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone.rovo-no-interruption":[{"type":0,"value":"If the allowance limit is reached, your customer can still use "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" without interruption. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.rc-io-usage-notice":[{"type":0,"value":"Extra usage is currently non-billable. "},{"type":1,"value":"moreAboutUsageUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.rc-io-usage-url":[{"type":0,"value":"More about usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.whats-next.ubp5":[{"type":0,"value":"What\u2019s next?"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption-pooled-meter.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.pooled-meter":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.pooled-meter":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" allowance is running low "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-ship-to-party-archival-ccp.body.initimation":[{"type":0,"value":"Please note that this sold-to address is no longer available for billing."}],"commerce.commerce-ship-to-party-archival-ccp.body.partner.p3":[{"type":0,"value":"To view the changes, head to "},{"type":1,"value":"ppcHomePageLink"},{"type":0,"value":"."}],"commerce.commerce-ship-to-party-archival-ccp.email.body.disclaimer":[{"type":0,"value":"We\'ve deactivated the below sold-to address:"}],"commerce.commerce-ship-to-party-archival-ccp.message-template.email.subject":[{"type":1,"value":"name"},{"type":0,"value":" Sold to address deactivated"}],"commerce.commerce-soft-limit-breach-ccp.email.automatic-upgrade":[{"type":0,"value":"Automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.email.manage-users":[{"type":0,"value":"Manage "},{"type":1,"value":"product"}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade":[{"type":0,"value":"Don\'t want to upgrade? "}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade-text":[{"type":0,"value":"We recommend removing "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users before your upgrade date. You can do this by selecting Manage users in your "},{"type":1,"value":"product"},{"type":0,"value":" subscription"}],"commerce.commerce-soft-limit-breach-ccp.email.note1":[{"type":0,"value":"If no changes are made, you\'ll be upgraded and we\'ll send you an invoice of prorated costs for the remainder of your billing period."}],"commerce.commerce-soft-limit-breach-ccp.email.note2":[{"type":0,"value":"You don\'t need to take any action. We\'ll automatically upgrade your account and the new charges will be applied."}],"commerce.commerce-soft-limit-breach-ccp.email.product-limit-exceeded":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" user limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" has exceeded by "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder":[{"type":0,"value":"In a few days you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder-caption":[{"type":0,"value":"You\u2019re about to be upgraded"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder":[{"type":0,"value":"Soon you\'ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder-caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder":[{"type":0,"value":"In the next week, you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count. "}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder-caption":[{"type":0,"value":"You\u2019ll be upgraded soon"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.final-reminder":[{"type":0,"value":"Last chance: manage users before automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.reminder":[{"type":0,"value":"Action required before automatic upgrade"}],"commerce.commerce-subscription-activation-ccp.message-template.ecc.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.setup-site":[{"type":0,"value":"Setting up the site means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.with-site":[{"type":0,"value":"Your products are ready for use "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.without-site":[{"type":0,"value":"Set up your subscription and get started"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian partner had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.site-info":[{"type":0,"value":"They\'ll be added to your site shortly."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian reseller had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage these subscriptions from our "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.subscriptions-active":[{"type":0,"value":"Great news \u2014 the subscriptions that you ordered for your customer on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are now active and ready to use. We\u2019ve also informed your customer that they can get started."}],"commerce.commerce-subscription-activation-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to your "},{"type":1,"value":"managedSubscriptionUrl"},{"type":0,"value":" page and following the steps."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.partner-managed-subscription.url":[{"type":0,"value":"Subscription overview"}],"commerce.commerce-subscription-activation-ccp.message-template.email.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.ecc":[{"type":0,"value":"It\u2019s time to set up your subscription"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.partner":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": it\u2019s time to set up subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.singular":[{"type":0,"value":"It\'s time to set up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subscriptions-active":[{"type":0,"value":"Great news \u2014 the "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" is"}]},"other":{"value":[{"type":0,"value":"subscriptions that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active."}],"commerce.commerce-subscription-activation-ccp.message-template.email.time-to-get-set-up":[{"type":0,"value":"It\'s time to get set up"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.add-on.cta":[{"type":0,"value":"Increase usage limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.add-on.cta":[{"type":0,"value":"Get quote for higher limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-auto-downgrade-ccp.email.partner.subject.with.company.name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.limted.features.info":[{"type":0,"value":"This way, your customer can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uncollectible":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uninvoiceable":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we don\u2019t have your customer\u2019s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.explore-plans":[{"type":0,"value":"Explore plans"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.how-to-get-back-to-original-plan":[{"type":0,"value":"If you\'d like to get back to your original plan, go to "},{"children":[{"type":0,"value":"Subscriptions"}],"type":8,"value":"b"},{"type":0,"value":" and select "},{"children":[{"type":0,"value":"Manage"}],"type":8,"value":"b"},{"type":0,"value":" for your product. In "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":", select "},{"children":[{"type":0,"value":"Change plan"}],"type":8,"value":"b"},{"type":0,"value":" to upgrade."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.request-deletion-of-personal-data-link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"). As a result, we\'ve moved your subscription to the Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"You may also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"You are now on the Free plan of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption-v2":[{"type":1,"value":"firstName"},{"type":0,"value":", you\u2019re now on the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" subscription downgraded to a Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.subject-v2":[{"type":0,"value":"We\u2019ve switched you to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.summary-v2":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":", as of today, you\'ve been switched to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.upgrade-your-subscription":[{"type":0,"value":"You can also choose to upgrade to go back to your original plan."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.go-back-original-plan":[{"type":0,"value":"Want to go back on the original plan?"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.review-and-manage-subscription":[{"type":0,"value":"Review the customer\u2019s billing details from our Partner Purchasing Center and change the subscription."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for this subscription. As a result, we\'ve moved the subscription to the Free plan. This way, "},{"type":1,"value":"productName"},{"type":0,"value":" can still be used, but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"Your customer can also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" moved to Free plan due to payment issue"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.partner.email.body.personal-data-retention-summary.link":[{"type":0,"value":"request for deletion of their personal data."}],"commerce.commerce-subscription-auto-upgrade-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.downgrade":[{"type":0,"value":"downgrade"}],"commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.reduce-your-user-count":[{"type":0,"value":"reduce your user count"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Your customer can now enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, with instructions."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.body.switch-to-back-free-plan":[{"type":0,"value":"To stay on the Standard plan, you don\'t need to do anything. We\'ll charge your saved payment method when your trial ends. To return to the Free plan, first "},{"type":1,"value":"reduceYourUserCount"},{"type":0,"value":" to meet the plan limit, then "},{"type":1,"value":"downgrade"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-date-label":[{"type":0,"value":"Next bill date"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-label":[{"type":0,"value":"Next bill estimate"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-value":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"type":1,"value":"billingCycle"},{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-label":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.explore-standard-cta":[{"type":0,"value":"Explore Standard"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial":[{"type":0,"value":"You\'ve reached the user limit for your Free plan, so "},{"children":[{"type":0,"value":"we\'ve upgraded you"}],"type":8,"value":"bold"},{"type":0,"value":" to our Standard plan. It\'s free for 14 days."},{"type":1,"value":"br"},{"type":0,"value":"You can now add unlimited users to your projects and help your team ship faster."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial-with-end-date":[{"type":0,"value":"You\'ve reached the user limit for your Free plan, so "},{"children":[{"type":0,"value":"we\'ve upgraded you"}],"type":8,"value":"bold"},{"type":0,"value":" to our Standard plan. It\'s free for 14 days."},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"You can now add unlimited users to your projects and help your team ship faster. Your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"bold"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.caption":[{"type":0,"value":"Your Standard trial has started"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subscription-details-heading":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.what-happens-next-heading":[{"type":0,"value":"What happens next?"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.confluence-logo-alt":[{"type":0,"value":"Confluence"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jira-logo-alt":[{"type":0,"value":"Jira"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jpd-logo-alt":[{"type":0,"value":"Jira Product Discovery"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.email.icon-warning.alt-text":[{"type":0,"value":"Icon - Warning"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Important things to know about "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you\u2019ll just need to make sure your Atlassian billing partner has the correct billing details. We\u2019ve also sent them an email with instructions."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been upgraded to the "},{"type":1,"value":"planName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.add-payment-details":[{"type":0,"value":"Add payment details before the trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", otherwise the subscription will be deactivated."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access":[{"type":0,"value":"You\u2019ll lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" if you don\u2019t take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-billing-admin":[{"type":0,"value":"You can switch back to a Free plan at any time by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"Link"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-mpucup-user":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan at any time by reducing your user count."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.body-intro":[{"type":0,"value":"Your team now has a "},{"children":[{"type":0,"value":"free 14-day trial"}],"type":8,"value":"b"},{"type":0,"value":" of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard because you reached the 10-user limit on the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.invite-team":[{"children":[{"type":0,"value":"Invite your team."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need to your spaces."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.page-insights":[{"children":[{"type":0,"value":"Measure impact."}],"type":8,"value":"b"},{"type":0,"value":" Track views and engagement with page insights."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.rovo-ai":[{"children":[{"type":0,"value":"Draft faster."}],"type":8,"value":"b"},{"type":0,"value":" Generate ideas and first drafts with Rovo AI."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.automation":[{"children":[{"type":0,"value":"Automate tedious tasks."}],"type":8,"value":"b"},{"type":0,"value":" Set rules for repetitive updates."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.invite-team":[{"children":[{"type":0,"value":"Invite your team."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need to your spaces."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.rovo-agents":[{"children":[{"type":0,"value":"Put agents to work."}],"type":8,"value":"b"},{"type":0,"value":" Call on Rovo agents for specialized tasks."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.heading":[{"type":0,"value":"We\'ve upgraded you to "},{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.payment-deadline":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\'t add payment details or reduce your user count to 10 or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019ve already added your payment details, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject3":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has changed to Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-admin-partner.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or have your customer\u2019s admin remove users so you can switch back to Free in the "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.add-payment-or-remove-users":[{"type":0,"value":"To keep unlimited and users stay on Standard, ensure your Atlassian billing partner updates your billing details. We\u2019ve also sent them instructions. To switch back to Free, "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.take-action":[{"type":0,"value":"Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation. For help, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.direct-customer.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":" to switch back to the Free plan. Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.over-free-limit-moved-to-standard":[{"type":0,"value":"You\'re over the Free user limit, so we moved you to Standard, which includes unlimited users."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.partner-purchasing-center":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.remove-users":[{"type":0,"value":"remove users"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.caption":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.closing-line":[{"type":0,"value":"Your new bill date will be in effect from the next billing cycle. To transition you to the new\\n\\t\\t\\t\\t\\t  bill date, pro-rated adjustments will be applied to your next invoice."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.first-line":[{"type":0,"value":"We\'ve processed your request to change the bill date for your "},{"type":1,"value":"productName"},{"type":0,"value":"\\n\\t\\t\\t\\t\\t\\t("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription to "},{"type":1,"value":"requestedNextBillingDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.second-line":[{"type":0,"value":"If you have any other product and subscriptions on the same site that belong to the same product family,\\n            they need to be billed together. That means we\u2019ve changed the bill date for those subscriptions too."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template.email.subject":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-cancellation-ecc.email.body.billing-partner":[{"type":0,"value":"Atlassian billing partner"}],"commerce.commerce-subscription-cancellation-ecc.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" subscription is canceled"}],"commerce.commerce-subscription-cancellation-ecc.email.body.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-ecc.email.body.data-will-be-deleted":[{"type":0,"value":"Data will be deleted within 60 days from the date of cancellation. If you\u2019d like to request deletion of the data earlier, "}],"commerce.commerce-subscription-cancellation-ecc.email.body.reactivate":[{"type":0,"value":"Your Atlassian billing partner can ask us to reactivate the subscription if needed. If you weren\u2019t expecting this email, you can contact us."}],"commerce.commerce-subscription-cancellation-ecc.email.body.this-is-to-let-you-know":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your app\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.cta.reactivate-button":[{"type":0,"value":"Reactivate "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days":[{"type":0,"value":"You can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-direct-customer-non-cloud":[{"type":0,"value":"If you want to keep your subscription, "},{"type":1,"value":"reachOutLinkForNonCloud"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.jsm-requirement":[{"type":0,"value":"This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption.twc":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.body.sub-cancel-note.twc":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.received-request":[{"type":0,"value":"We\'ve received your request to cancel your subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.sub-cancel-note":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.billing-partner-details.twc":[{"type":0,"value":"Your billing partner details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.data-deletion-note":[{"type":0,"value":"Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you\u2019d like to request deletion of personal data, "},{"type":1,"value":"contactSupport"},{"type":0,"value":". Learn about "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.contact-us":[{"type":0,"value":"contact us"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.data-deletion-note":[{"type":0,"value":"Product data will be deleted 60 days from cancellation. For trials, we retain data for 15 days. If you\'d like to request deletion of personal data, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.intro":[{"type":0,"value":"Your app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to contact your Atlassian billing partner to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request":[{"type":0,"value":"We\'ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request.twc":[{"type":0,"value":"We\'ve received your request to cancel your subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject.twc":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-user.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.customer-details.twc":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy":[{"type":0,"value":"Atlassian\u2019s Privacy Policy"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-billing-partner":[{"type":0,"value":"You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.intro":[{"type":0,"value":"Your customer\'s app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since your customer doesn\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription":[{"type":0,"value":"Keeping the subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription.twc":[{"type":0,"value":"Your customer contact can undo the cancellation at any time from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner-managed-subscriptions-link":[{"type":1,"value":"partnerManagedSubscriptionsLink"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link":[{"type":0,"value":"Learn how to undo a cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request":[{"type":0,"value":"We\u2019ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request.twc":[{"type":0,"value":"We\u2019ve received your customer\u2019s request to cancel their subscription."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note.twc":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". Until then, the subscription can still be used. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.subscription-details.twc":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name.twc":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name.twc":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.body.could-not-process-payment":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription since we were unable to process your payment. "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.cta.reactivate-button":[{"type":0,"value":"Reactivate "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days":[{"type":0,"value":"You can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for the following subscription.As a result, the subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject.no-customer-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.cta-direct-customer.reactivate-subscription":[{"type":0,"value":"Don\u2019t worry, all\u2019s not lost! You can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days, we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription-button":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.product-list-item":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"},{"type":0,"value":")"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.update-payment-details":[{"type":0,"value":"We recommend updating your payment details to ensure this doesn\'t happen again."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.payment-details-up-to-date":[{"type":0,"value":"To avoid this in the future, ensure your payment details are up to date."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes canceled"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-view-cancel-subscription":[{"type":0,"value":"You can view or cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.managed-subscriptions-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-manage-subscription":[{"type":0,"value":"You can manage the subscription from the "},{"type":1,"value":"partnerPurchaseCentralUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, your customer\u2019s subscriptions are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-view-cancel-subscription":[{"type":0,"value":"Your customer contact can view and cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"Based on a quote that you\u2019ve already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-view-cancel-subscription":[{"type":0,"value":"You can view and manage your subscription from your billing account. "}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":" We\u2019ll charge your chosen payment details annually, and your subscription will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":"We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.auto-renewal":[{"type":0,"value":"As requested, your subscription has now been moved to the annual (auto-renewal) plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.termed":[{"type":0,"value":"As requested, your subscription has now been moved to the annual plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.caption":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":"We\u2019ll charge your chosen payment details annually for this subscription, and it will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":" We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.auto-renewal":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n\\t\\t\\t\\tAs requested, your subscription has been moved to an annual (auto-renewal) plan, which will start after\\n\\t\\t\\t\\tyour trial period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.termed":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n                As requested, your subscription has been moved to an annual plan, which will start after your trial\\n                period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.subject":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.charge-quantities-added-message":[{"type":0,"value":"You added new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to your subscription. Based on these changes, we\u2019ve adjusted your billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and prorated the cost for new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for the remaining time in your billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.estimated-bill":[{"type":0,"value":"Your estimated bill for the next billing cycle is "},{"children":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"type":8,"value":"b"},{"type":0,"value":" (excluding tax)."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.final-invoice-details":[{"type":0,"value":"Your final invoice will reflect all "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of your current billing period and the subsequent prorated charges."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.to-view-bill":[{"type":0,"value":"To view your bill breakdown and usage details, visit your "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":" page."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.charge-quantities-added-message":[{"type":0,"value":"More "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been added to the following subscription:"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.final-invoice-details":[{"type":0,"value":"The final invoice will reflect the total number of "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of the current billing cycle."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.p2-billing-adjusted":[{"type":0,"value":"The billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been adjusted to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and the cost for the new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" has been prorated for the remaining time in the billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.ppc":[{"type":0,"value":"You can view the usage details from our "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your customer\u2019s team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.app-retiring":[{"type":0,"value":"We wanted to let you know that we\u2019re no longer offering "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". "}],"commerce.commerce-subscription-offering-cancellation-ccp.email.atlassian-suite":[{"type":0,"value":"Atlassian suite"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-at-end-of-billing-cycle":[{"type":0,"value":"This means your subscription will be canceled at the end of your last billing cycle."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-immediately":[{"type":0,"value":"This means your subscription will be canceled 30 days from the date of this email."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-on-offering-expiry-date":[{"type":0,"value":"This means your subscription will be canceled on "},{"type":1,"value":"expiryDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.caption":[{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is being retired"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.marketplace-apps":[{"type":0,"value":"Marketplace apps"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.other-plans-available":[{"type":0,"value":"There may still be other "},{"type":1,"value":"appName"},{"type":0,"value":" plans available \u2014 you can check out our "},{"type":1,"value":"atlassianSuite"},{"type":0,"value":" of products or "},{"type":1,"value":"marketplaceApps"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription will be canceled"}],"commerce.commerce-subscription-offering-movement-ccp.email.app-getting-replaced":[{"type":0,"value":" The developers of "},{"type":1,"value":"appName"},{"type":0,"value":" are retiring this app and replacing it with a free version. Your paid\\n                subscription will transition to "},{"type":1,"value":"freeAppName"},{"type":0,"value":". From the end of your last billing cycle, you\u2019ll no \\n\\t\\t\\t\\tlonger be charged for this app."}],"commerce.commerce-subscription-offering-movement-ccp.email.caption":[{"type":0,"value":"Your paid subscription for this app will convert to a free subscription"}],"commerce.commerce-subscription-offering-movement-ccp.message-template.email.subject":[{"type":1,"value":"appName"},{"type":0,"value":" is being retired."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp-g.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-opt-out-ccp-grouped.email.direct.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember \u2014 if your organization admin has enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. Organization admins can adjust usage limits anytime. "}],"commerce.commerce-subscription-opt-out-ccp-grouped.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember \u2014 if you\u2019ve enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. You can adjust usage limits anytime."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.email.direct.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\'s bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and billing details on your "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.manage-url":[{"type":0,"value":"Manage Subscriptions"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.ba-when-the-trial-ends":[{"type":0,"value":"Your subscription will be canceled, unless you place an order for the paid plan before the trial end date. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.bu-when-the-trial-ends":[{"type":0,"value":"When you\'re ready to start paid subscription, your billing admin will need to use the quote we send them to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-partner-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p2.partner":[{"type":0,"value":"When trial ends, the subscription will be deactivated. To extend the trial "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3":[{"type":0,"value":"We\'ve sent a quote to your billing admin. When you\'re ready to start your paid subscription, your billing admin will need to use the quote to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3-admin":[{"type":0,"value":"During your trial, we\'ll send you a quote. When you\'re ready to start your paid subscription, you can use the quote to place the order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.reach-out-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.ba.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to the included amount for each quota. If they want extra usage straight away you can contact us. Otherwise, they\u2019ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-details":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-cbp-details":[{"type":0,"value":"Your new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.twc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.twc.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.upgraded-cbp-details":[{"type":0,"value":"The new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-cc.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allowance for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.caption-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.cbps-description":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":". You won\'t be charged if you switch before the trial ends."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.rovo-dev-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-on":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.twc-as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends"},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.twc-good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-description":[{"type":0,"value":", and you\u2019ll continue to be charged for your existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.twc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.cta.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.docs":[{"children":[{"type":0,"value":"Create docs instantly."}],"type":8,"value":"b"},{"type":0,"value":" Generate plans, roadmaps, and more with AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.find":[{"children":[{"type":0,"value":"Find what you need."}],"type":8,"value":"b"},{"type":0,"value":" Search across all your connected apps in one place."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.automate":[{"children":[{"type":0,"value":"Automate tedious tasks."}],"type":8,"value":"b"},{"type":0,"value":" Set rules for repetitive updates."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.plans":[{"children":[{"type":0,"value":"Turn plans into work."}],"type":8,"value":"b"},{"type":0,"value":" Create work items from docs using AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.align":[{"children":[{"type":0,"value":"Align your team."}],"type":8,"value":"b"},{"type":0,"value":" Share plans with co-workers, no sign up required."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.prioritize":[{"children":[{"type":0,"value":"Prioritize ideas."}],"type":8,"value":"b"},{"type":0,"value":" Define and refine your opportunities in one place."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.edit":[{"children":[{"type":0,"value":"Edit your videos."}],"type":8,"value":"b"},{"type":0,"value":" Cut \u201Cums\u201D and more with trim and stitch tools."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.engagement":[{"children":[{"type":0,"value":"Understand engagement."}],"type":8,"value":"b"},{"type":0,"value":" See who watched and for how long."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.record":[{"children":[{"type":0,"value":"Record without limits."}],"type":8,"value":"b"},{"type":0,"value":" Create and share unlimited videos."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.confluence":[{"children":[{"type":0,"value":"Create docs instantly."}],"type":8,"value":"b"},{"type":0,"value":" Generate plans, roadmaps, and more with AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.jira":[{"children":[{"type":0,"value":"Turn plans into work."}],"type":8,"value":"b"},{"type":0,"value":" Create work items from docs using AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.loom":[{"children":[{"type":0,"value":"Align without meetings."}],"type":8,"value":"b"},{"type":0,"value":" Explain work or decisions with async video."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.rovo":[{"children":[{"type":0,"value":"Put agents to work."}],"type":8,"value":"b"},{"type":0,"value":" Create AI agents to handle specific tasks."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-full-access":[{"type":0,"value":"You get full access to all "},{"children":[{"type":1,"value":"planName"},{"type":0,"value":" features"}],"type":8,"value":"link"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-refund":[{"type":0,"value":"You can request a refund within 30 days if you forget to cancel."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-reminder":[{"type":0,"value":"We\'ll remind you 3 days before your trial ends. Cancel anytime."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.title":[{"type":0,"value":"How your trial works"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-date.label":[{"type":0,"value":"Next bill date"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.label":[{"type":0,"value":"Next bill estimate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.value":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"type":1,"value":"billingCycle"},{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.plan.label":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.label":[{"type":0,"value":"Rovo credits"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.value":[{"type":1,"value":"quantity"},{"type":0,"value":" per user / month"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.title":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subtitle":[{"type":0,"value":"Your free "},{"children":[{"type":1,"value":"trialLength"},{"type":0,"value":" trial"}],"type":8,"value":"b"},{"type":0,"value":" has started. "},{"type":1,"value":"offeringName"},{"type":0,"value":" gives you unlimited users and advanced features that help you:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.confluence":[{"type":0,"value":"Create and collaborate in one place"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jira":[{"type":0,"value":"Start building better workflows"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jpd":[{"type":0,"value":"Discover your next great product idea"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.loom":[{"type":0,"value":"Align your team without extra meetings"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.twc":[{"type":0,"value":"Sync work across teams, all in one place"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.twc.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new.partners":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin-button":[{"type":0,"value":"Add payment details"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-user":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.downgrade-to-free":[{"type":0,"value":"Add your payment details by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to continue using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" without any disruption. If you\u2019re under the user limit and don\u2019t add payment, you\u2019ll automatically switch to the Free plan at the end of your trial."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.twc.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption.grouped":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans.grouped":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences.grouped":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject.grouped":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details.grouped":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption.grouped":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans.grouped":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details.grouped":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-ccp-g.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you left them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.email.body.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you\\n\\t\\t\\t\\t\\t\\t\\t\\tleft them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information-next":[{"type":0,"value":"If you\u2019ve already settled the outstanding amount, you\u2019re all set. If not, settling it immediately will ensure uninterrupted service and prevent any future deactivations."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information.partner":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your customer\u2019s data and preferences will be as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.what\'s-next":[{"type":0,"value":"What\u2019s next"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription trial successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription trial."}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.subject.customerCompanyName":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.trial.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information":[{"type":0,"value":"When your trial ends, we\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information.partner":[{"type":0,"value":"When the trial ends, we\u2019ll charge the chosen payment method and send an invoice within 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.caption":[{"type":0,"value":"We\'ve reactivated your subscriptions"}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.details":[{"type":0,"value":"Your data and preferences are just as you left them, so your team can jump back in straight away."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.intro":[{"type":0,"value":"As requested, we\'ve reactivated "},{"type":1,"value":"numOfReactivatedSubscriptions"},{"type":0,"value":" subscriptions in the last 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.subject":[{"type":0,"value":"Your daily reactivations"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure your service continues smoothly, we\'ve moved you back on your previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription-change-plan":[{"type":0,"value":"Go to Manage subscription, then Change plan. "}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.payment-details-up-to-date":[{"type":0,"value":"Make sure your payment details are up to date."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users you have exceeds the user limit allowed on your updated plan. You can do this by heading to your Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure service continues smoothly, we\'ve changed the subscription back to its previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users exceeds the user limit allowed on the updated plan. You can do this from the Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.manage-subscription":[{"type":0,"value":"Ensure the payment details are up to date then manage the subscription in Partner Purchasing Center."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription changed"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-key":[{"type":0,"value":"Users:"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-value":[{"type":1,"value":"users"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.direct-customer-whats-next":[{"type":0,"value":"You can use your current plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.nonpause-billing-accepted-request":[{"type":0,"value":"We\'ve accepted your request to move your subscription from monthly to annual (auto-renewal) plan, which will start at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.nonpause-billing-caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-accepted-request":[{"type":0,"value":"You can use the current plan, but your partner would need to contact us for any modifications. "}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details":[{"children":[{"type":0,"value":"Subscription:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details-billing-partner":[{"children":[{"type":0,"value":"Atlassian billing partner:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"billingPartner"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.nonpause-billing-current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-accepted-request":[{"type":0,"value":"The customer can continue with the existing plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"The billing cycle for one of your customer\u2019s subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ve also informed your customer about the change."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-wont-billed":[{"type":0,"value":"Your customer won\'t be billed between the end of the current monthly billing cycle and the start of the annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.wont-billed.direct-customer-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.caption":[{"type":0,"value":"Your billing frequency will soon be changed"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.contact-us":[{"type":0,"value":"If you have any questions concerning this change, please contact us."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.request-to-change-bill-freq":[{"type":0,"value":"We received a request to change the billing frequency for your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.when-will-cycle-change":[{"type":0,"value":"We\u2019ll change your "},{"type":1,"value":"oldBillingCycleName"},{"type":0,"value":" subscription to "},{"type":1,"value":"newBillingCycleName"},{"type":0,"value":" subscription at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.message-template.email.subject":[{"type":0,"value":"Your request to change your billing frequency"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.email.dc.ubp-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.email.partner.ubp-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.caption":[{"type":0,"value":"Welcome to the "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.charge-chosen-payment-method":[{"type":0,"value":"We\'ll charge your chosen payment method within 24 hours and send you a payment confirmation along with your invoice"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.caption":[{"type":0,"value":"Welcome to your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision":[{"type":0,"value":"If you decide that this isn\u2019t for you, "},{"type":1,"value":"content"},{"type":0,"value":" "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-multiple-offering":[{"type":0,"value":"you can change your plan from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-single-offering":[{"type":0,"value":"you can cancel anytime from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.great-news":[{"type":0,"value":"Great news \u2014 your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.how-addon-billed":[{"type":0,"value":"Find out more about "},{"type":1,"value":"manageAddonLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.manage-addon-link":[{"type":0,"value":"how add-ons are billed"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.on-pricing-plan":[{"type":0,"value":" on "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com/billing/partner-managed-subscriptions"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.caption":[{"type":0,"value":"Welcome to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision":[{"type":0,"value":"If your customer decides this isn\u2019t for them, they can "},{"type":1,"value":"content"},{"type":0,"value":" at any time from "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-multiple-offering":[{"type":0,"value":"change their plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-single-offering":[{"type":0,"value":"cancel the subscription"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.great-news":[{"type":0,"value":"Great news \u2014 "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription"},{"type":1,"value":"companyName"},{"type":0,"value":" is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.personal-information":[{"type":0,"value":"Remember - your invoice contains personal information such as your address and other billing admin details, so you should only share it with trusted sources."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan":[{"type":0,"value":"Change plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan-and-upgrade":[{"type":0,"value":" and upgrade your subscription. Don\u2019t forget to add your payment details so you can use "},{"type":1,"value":"productName"},{"type":0,"value":" without any interruptions."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.manage-subscription-button":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.no-payment-info":[{"type":0,"value":"Since we dont have your complete billing information, we moved you to the Free plan. You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" but with limited features."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.product-info":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is now on the Free plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.to-get-back-go-to":[{"type":0,"value":"Want to go back on the "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" plan? Select "}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.trial-has-ended":[{"type":0,"value":"Your "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" has ended. We hope you enjoyed it!"}],"commerce.commerce-subscription-transferred-ccp-g.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.can-now-manage":[{"type":0,"value":"You can now manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.uninterrupted-service":[{"type":0,"value":"To ensure uninterrupted access to your subscriptions, add your payment details before your bill end date."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can view and cancel the subscription by going to "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-from-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-to-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-from-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-to-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.can-not-manage":[{"type":0,"value":"You can no longer manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":". However, all the invoices up to the date of transfer are still available."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.caption":[{"type":0,"value":"Subscription removed from billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.product-transferred-info":[{"type":0,"value":"If you had any other product and subscriptions on the same site that belonged to the same product family,\\n\\t\\t\\tthey need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription from your Billing Account, "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.caption":[{"type":0,"value":"Subscription added to your billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.product-transferred-info":[{"type":0,"value":"If the billing account "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":" had any other product and subscriptions on the same site that belonged to the same product family, they need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\u2019ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-customer-billing-account.caption":[{"type":0,"value":"Subscription transferred to your billing account"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.trial-ended-message":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". Your paid plan has now started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.trial-ended-message":[{"type":0,"value":"The free "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended, and the paid period has started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge the chosen payment method and send you an invoice soon, along with the payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject.without-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.moved-back-old-plan":[{"type":0,"value":"The subscription will be moved back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan. You don\'t have to pay any additional charges for the trial period used as we continued your billing per your "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan while on trial. If you were initially on the Free plan, you won\'t be charged anything. "}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.subscription-opted-out-from-to":[{"type":0,"value":"As requested, we\'ve ended the no-cost "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial of the following product:"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"If needed, you can always restart the trial from our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial ended on request"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.trial-ended-message":[{"type":0,"value":"The no-cost "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.upgrade-offering-message":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" paid plan:"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"To view the subscription, visit our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.we-will-charge-message":[{"type":0,"value":"We\u2019ll charge you for a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with the payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan has started"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": No cost "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" trial period has ended"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.ba-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.bu-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.cancel":[{"type":0,"value":"If you decide this isn\u2019t for you, you can cancel your subscription before your trial ends by logging in to your account."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.on-trial":[{"type":0,"value":"Good news \u2014 you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.trial-auto-convert":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.lets-make-it-official":[{"type":0,"value":"Let\u2019s make it official"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-flies":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is coming to an end"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.add-payment":[{"type":0,"value":"If you want to continue with the paid plan, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion":[{"type":0,"value":"If you want to continue, you don\u2019t need to do anything. When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off":[{"type":0,"value":"Your subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"You\u2019ll be moved back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan":[{"type":0,"value":"You can change or cancel your subscription before your trial ends by going to "},{"type":1,"value":"changePlanLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, we\u2019ll move you to the Free plan \u2014 as long as you meet the user limit requirements. If not, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.extend-trial":[{"type":0,"value":"If you\u2019d like to extend your trial, you\u2019ll need to contact us at "},{"type":1,"value":"salesOpsSupportEmail"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.scheduled-for-cancellation":[{"type":0,"value":"You can undo the cancellation by "},{"type":1,"value":"contactingUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end-twc":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial and your team\'s making the most of the increased collaboration."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.features.your-features-include":[{"children":[{"type":0,"value":"Your features include:"}],"type":8,"value":"b"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.end-of-trial-with-pde":[{"type":0,"value":"Your subscription begins on "},{"type":1,"value":"subscriptionStartDate"},{"type":0,"value":". Learn about your plan\u2019s features and see what they can do for you."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.end-of-trial-with-pde":[{"type":0,"value":"Ready for your next chapter?"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off":[{"type":0,"value":"When the trial ends, the subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-upgrade-trial":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, the subscription will be moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and charged on the next bill date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.deactivate-if-payment-not-added":[{"type":0,"value":"To continue, add payment details (if you haven\u2019t already) before your trial ends to avoid deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"To continue with the paid plan, add payment details (if you haven\u2019t already) before your trial ends to avoid downgrading to the Free plan or deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.extend-trial":[{"type":0,"value":"To extend the trial, "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your customer\'s "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.scheduled-for-cancellation":[{"type":0,"value":"The trial is scheduled for cancellation. If your customer wants to undo the cancellation, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.intro":[{"type":0,"value":"Your trial will end in 3 days. Add your payment details now so you don\u2019t lose your features."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.refund-policy":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" Refund within 30 days of initial purchase if you change your mind."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.title":[{"type":0,"value":"Keep what\u2019s working for you"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.permissions":[{"type":0,"value":"You\u2019ll no longer be able to choose who can view, edit, or comment on pages."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.whiteboards":[{"type":0,"value":"Whiteboards are great for planning and brainstorming, but Free only allows 3 per person."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.permissions":[{"type":0,"value":"You\u2019ll no longer be able to choose who can view, edit, or comment on pages."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 10 people."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 10 people. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.permissions":[{"type":0,"value":"You won\u2019t be able to set rules on who can create, view, or comment on work items."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.plans":[{"type":0,"value":"Without cross-project plans, you won\u2019t be able to see status or problems across teams."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat or agents."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.permissions":[{"type":0,"value":"You won\u2019t be able to set rules on who can create, view, or comment on work items."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat or agents."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 10 people."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 10 people. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.roadmaps":[{"type":0,"value":"Cross-project roadmaps won\u2019t be available, so you can\u2019t see all ideas in one view."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.view-restrictions":[{"type":0,"value":"You won\u2019t be able to control who can see, edit, or create views."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.published-view":[{"type":0,"value":"You won\u2019t be able to publish and share your plans with people unless they\u2019re signed in."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.storage":[{"type":0,"value":"Storage will drop from 250 GB to 2 GB, which will limit your ability to upload files."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 3."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 3 creators. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.add-payment":[{"type":0,"value":"Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.end-of-trial-with-pde":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup":[{"type":0,"value":"Payment required to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup.no-product-name":[{"type":0,"value":"Payment required to keep your subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.add-payment":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.trial-ends-soon":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.personalised-no-pde":[{"type":0,"value":"Don\u2019t lose your features - add payment details today"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.trial-ends-soon":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.add-payment-details-before-trial-ends":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\'t add payment details or reduce your user count to 10 or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.caption":[{"type":0,"value":"Add payment details to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.your-trial-ends-in-days":[{"type":0,"value":"Your free "},{"type":1,"value":"productName"},{"type":0,"value":" Standard trial ends in "},{"children":[{"type":0,"value":"3 days"}],"type":8,"value":"b"},{"type":0,"value":". Add payment details now to ensure your team has uninterrupted access."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.add-payment-details":[{"type":0,"value":"We noticed that we don\'t have your payment details on file. Add payment details before the renewal date to avoid any disruptions to your subscription."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.caption":[{"type":0,"value":"Your upcoming renewal"}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.payment-method-charged":[{"type":0,"value":"We\u2019ll charge your chosen payment method at this time. If you want to use a different payment method, update your details before the renewal date."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.renewal-reminder":[{"type":0,"value":"This is a friendly reminder that your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will renew on "},{"type":1,"value":"renewalDate"},{"type":0,"value":". Here are the details:"}],"commerce.commerce-subscription-upcoming-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription renews soon"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp.email.dc.ubp-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-ccp.email.partner.ubp-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if you go over the included quantity or allowance for any of the usage types on your subscription, extra usage charges will be added to your next invoice. Organization admins can set and adjust usage limits anytime."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your customer goes over the included quantity or allowance for any of the usage types on the subscription, extra usage charges will be added to their next invoice. You can set and adjust usage limits anytime."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-trial-extension-ad.created-date-bold.key":[{"type":0,"value":"Created date: "}],"commerce.commerce-trial-extension-ad.created-date-value":[{"type":1,"value":"createdDate"}],"commerce.commerce-trial-extension-ad.created-date.key":[{"type":1,"value":"createdDateKey"}],"commerce.commerce-trial-extension-ad.email.approved":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has approved the request."}],"commerce.commerce-trial-extension-ad.email.caption":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.email.declined":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has declined the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.default":[{"type":0,"value":"Your request for a trial extension has been received and is being processed."}],"commerce.commerce-trial-extension-ad.email.in-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" is the assignee of the approval request."}],"commerce.commerce-trial-extension-ad.email.reasons-provided":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has provided supporting reasons."}],"commerce.commerce-trial-extension-ad.email.reasons-requested":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has requested supporting reasons."}],"commerce.commerce-trial-extension-ad.email.request-cancelled":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has cancelled the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.waiting-for-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has submitted a new Trial Extension request."}],"commerce.commerce-trial-extension-ad.initiator-id-bold.key":[{"type":0,"value":"Initiator: "}],"commerce.commerce-trial-extension-ad.initiator-id-value":[{"type":1,"value":"initiator"}],"commerce.commerce-trial-extension-ad.initiator-id.key":[{"type":1,"value":"initiatorKey"}],"commerce.commerce-trial-extension-ad.message-template.email.subject":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id-bold.key":[{"type":0,"value":"Request ID: "}],"commerce.commerce-trial-extension-ad.request-id-value":[{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id.key":[{"type":1,"value":"requestIdKey"}],"commerce.commerce-trial-extension-ad.status-bold.key":[{"type":0,"value":"Status: "}],"commerce.commerce-trial-extension-ad.status-value":[{"type":1,"value":"status"}],"commerce.commerce-trial-extension-ad.status.key":[{"type":1,"value":"statusKey"}],"commerce.commerce-trial-extension-ad.subscription-bold.key":[{"type":0,"value":"Subscription: "}],"commerce.commerce-trial-extension-ad.subscription-value":[{"type":1,"value":"entitlementNumber"}],"commerce.commerce-trial-extension-ad.subscription.key":[{"type":1,"value":"subscriptionKey"}],"commerce.commerce-trial-extension-ad.support-ticket-id-bold.key":[{"type":0,"value":"Support Ticket: "}],"commerce.commerce-trial-extension-ad.support-ticket-id-value":[{"type":1,"value":"supportTicket"}],"commerce.commerce-trial-extension-ad.support-ticket-id.key":[{"type":1,"value":"supportTicketKey"}],"commerce.commerce-trial-extension-ad.total-trial-length-bold.key":[{"type":0,"value":"Total days on trial so far: "}],"commerce.commerce-trial-extension-ad.total-trial-length-value":[{"type":1,"value":"currentTotalTrialLength"}],"commerce.commerce-trial-extension-ad.total-trial-length.key":[{"type":1,"value":"totalTrialLengthKey"}],"commerce.commerce-trial-extension-ad.trial-length-bold.key":[{"type":0,"value":"Request: "}],"commerce.commerce-trial-extension-ad.trial-length-value":[{"type":0,"value":"Extend trial for "},{"type":1,"value":"netTrialDays"},{"type":0,"value":" days"}],"commerce.commerce-trial-extension-ad.trial-length.key":[{"type":1,"value":"requestKey"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.disabled":[{"type":0,"value":"An admin has disabled extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.enabled":[{"type":0,"value":"An admin has enabled extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on your organization. If your organization goes over the extra usage limit, you\'ll receive a bill for extra usage incurred at the end of your bill cycle."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-policy":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime. If your organization goes over the extra usage limit, you\'ll receive a bill for extra usage incurred at the end of your bill cycle."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your organization now allows monthly usage up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.disabled":[{"type":0,"value":"Extra "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage has been disabled"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.enabled":[{"type":0,"value":"Extra "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage has been enabled"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.policy":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime. If your organization allows extra usage above the allowance, at the end of the cycle, you\'ll receive a bill for extra usage incurred."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your organization now allows monthly usage up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organisation. Your extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated.unlimited":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organisation. Your extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now unlimited."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.set":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.updated":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.set":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.updated":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.policy":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime. If your customer\'s usage exceeds their allowance, at the end of the cycle, the bill will include extra charges incurred for any extra usage this cycle."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organization. They can now use up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organisation. Your customer\'s extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated.unlimited":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organisation. Your customer\'s extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now unlimited."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.set":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit has been set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.updated":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit has been updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set.without-company-name":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated.without-company-name":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-write-off-email-ccp.message-template.email.caption":[{"type":0,"value":"Your invoice has been written off"}],"commerce.commerce-write-off-email-ccp.message-template.email.no-refund":[{"type":0,"value":"Please note that this credit note will not result in any refund since it is generated against an unpaid invoice."}],"commerce.commerce-write-off-email-ccp.message-template.email.processed-write-off":[{"type":0,"value":"We\'ve processed a write-off for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". If the invoice used any account balance, this has been returned to your account."}],"commerce.commerce-write-off-email-ccp.message-template.email.subject":[{"type":0,"value":"Write-off processed for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce.commerce-ship-to-party-archival-ccp.email.body.caption":[{"type":1,"value":"name"},{"type":0,"value":": Sold to address deactivated"}],"commerce.common-ui.manage-subscription-from-ppc-homepage":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":"."}],"commerce.common-ui.ppc":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.common.atlassian-privacy-policy":[{"type":0,"value":"Atlassian Privacy Policy"}],"commerce.common.contact-us-to-talk-or-downgrade-to-free":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce.common.contact-your-bank-for-more-info":[{"type":0,"value":"Contact your bank if you need more information about the issue."}],"commerce.common.contacting-us":[{"type":0,"value":"contacting us"}],"commerce.common.data-retention-and-backup-policy":[{"type":0,"value":"data retention and backup policies"}],"commerce.common.data-storage-faqs":[{"type":0,"value":"Data Storage FAQs"}],"commerce.common.downgrade-to-a-free-plan":[{"type":0,"value":"downgrade to a free plan"}],"commerce.common.email.atl-logo.alt-text":[{"type":0,"value":"Atlassian logo"}],"commerce.common.email.billing-url":[{"type":1,"value":"url"}],"commerce.common.email.bitbucket-logo.alt-text":[{"type":0,"value":"Bitbucket logo"}],"commerce.common.email.compass-logo.alt-text":[{"type":0,"value":"Compass logo"}],"commerce.common.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.common.email.csm-logo.alt-text":[{"type":0,"value":"Customer Service Management logo"}],"commerce.common.email.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"commerce.common.email.guard-logo.alt-text":[{"type":0,"value":"Guard logo"}],"commerce.common.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.common.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.common.email.loom-logo.alt-text":[{"type":0,"value":"Loom logo"}],"commerce.common.email.rovo-dev-logo.alt-text":[{"type":0,"value":"Rovo Dev logo"}],"commerce.common.email.rovo-logo.alt-text":[{"type":0,"value":"Rovo logo"}],"commerce.common.email.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.common.email.talent-logo.alt-text":[{"type":0,"value":"Talent logo"}],"commerce.common.if-you-are-unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce.common.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.common.manage-subscription-document-link":[{"type":0,"value":"Manage your subscription for Standard and Premium plans"}],"commerce.common.subscriptiom-reactivation-link":[{"type":0,"value":"reactivate your subscription"}],"commerce.common.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.email.body.what-happens-if-your-customer-uses-extra":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.email.changed-your-mind":[{"type":0,"value":"Changed your mind?"}],"commerce.email.cms.learn-more":[{"type":0,"value":"Pay later by invoice."}],"commerce.email.dont-want-continue":[{"type":0,"value":"Don\'t want to continue with the subscription?"}],"commerce.email.dont-want-to-cancel":[{"type":0,"value":"Don\'t want to cancel?"}],"commerce.email.extra-usage-charge-for-metered-billing":[{"type":0,"value":"Remember, if the included quantity or allowance for any of the usage types on the subscription are exceeded each billing cycle, extra usage charges will be added to the next invoice. "},{"type":1,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.email.how-to":[{"type":0,"value":"How to pay your invoices"}],"commerce.email.included-products":[{"type":0,"value":"Included products:"}],"commerce.email.last-page":[{"type":0,"value":"The last page of your invoice includes Atlassian\u2019s account details and instructions on how to pay."}],"commerce.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"}],"commerce.email.list.payment-method":[{"type":0,"value":"Payment method: Pay later by invoice"}],"commerce.email.list.payment-terms":[{"type":0,"value":"Payment terms: "},{"type":1,"value":"netTermsDuration"}],"commerce.email.list.taxId":[{"type":1,"value":"identifierName"},{"type":0,"value":": "},{"type":1,"value":"id"}],"commerce.email.new-plan-includes":[{"type":0,"value":"Your new plan includes:"}],"commerce.email.payment-days":[{"type":0,"value":"You\u2019ll have "},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the order invoice date to send your payment to Atlassian. You can pay using bank transfer or ACH/check (U.S. banks). "}],"commerce.email.subscription-and-billing-support-url":[{"type":0,"value":"More about how billing works."}],"commerce.email.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.email.subscription-includes":[{"type":0,"value":"Your subscription includes:"}],"commerce.email.subscription-includes-quotes":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.email.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.email.teamwork-collection":[{"type":0,"value":"Teamwork Collection can make it easy for your whole organization to work more effectively together - "},{"type":1,"value":"findOut"},{"type":0,"value":"."}],"commerce.email.teamwork-collection.find-out":[{"type":0,"value":"find out more about Atlassian collections"}],"commerce.email.the.new-plan-includes":[{"type":0,"value":"The new plan includes:"}],"commerce.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.email.view-usage":[{"type":0,"value":"View usage"}],"commerce.email.want-to-keep your subscription":[{"type":0,"value":"Want to keep your subscription?"}],"commerce.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.email.what-do-you-need-to-do":[{"type":0,"value":"What you need to do:"}],"commerce.email.what-happens-when-trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.whats-next":[{"type":0,"value":"What\u2019s next?"}],"commerce.learn-more":[{"type":0,"value":"To learn more, see "},{"type":1,"value":"learnMore"}],"commerce.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce.message-template.email.explore-all-features-button.explore-all-features":[{"type":0,"value":"Explore all features"}],"commerce.message-template.email.features-list.confluence.premium.analytics":[{"children":[{"type":0,"value":"Analytics:"}],"type":8,"value":"b"},{"type":0,"value":" See who has viewed a page and when"}],"commerce.message-template.email.features-list.confluence.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.confluence.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.confluence.standard.page-insights":[{"children":[{"type":0,"value":"Page insights:"}],"type":8,"value":"b"},{"type":0,"value":" See engagement data, like page views"}],"commerce.message-template.email.features-list.confluence.standard.page-permissions":[{"children":[{"type":0,"value":"Page permissions:"}],"type":8,"value":"b"},{"type":0,"value":" Choose who can view, edit, and comment"}],"commerce.message-template.email.features-list.confluence.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jira.premium.cross-team-planning":[{"children":[{"type":0,"value":"Cross-team planning:"}],"type":8,"value":"b"},{"type":0,"value":" See all projects and timelines in one place"}],"commerce.message-template.email.features-list.jira.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your work and remove human error"}],"commerce.message-template.email.features-list.jira.standard.data-residency":[{"children":[{"type":0,"value":"Data residency:"}],"type":8,"value":"b"},{"type":0,"value":" Choose where your data is stored"}],"commerce.message-template.email.features-list.jira.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jpd.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jpd.premium.roadmaps":[{"children":[{"type":0,"value":"Roadmaps:"}],"type":8,"value":"b"},{"type":0,"value":" See multiple roadmaps in a single view"}],"commerce.message-template.email.features-list.jpd.premium.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jpd.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up work and reduce human error"}],"commerce.message-template.email.features-list.jpd.standard.published-views":[{"children":[{"type":0,"value":"Published views:"}],"type":8,"value":"b"},{"type":0,"value":" Share read-only views with anyone"}],"commerce.message-template.email.features-list.jpd.standard.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jsm.premium.ai-features":[{"children":[{"type":0,"value":"AI features:"}],"type":8,"value":"b"},{"type":0,"value":" AI-powered agents, search, and chat"}],"commerce.message-template.email.features-list.jsm.premium.change-automation":[{"children":[{"type":0,"value":"Change automation:"}],"type":8,"value":"b"},{"type":0,"value":" Gate deploys and automate record creation"}],"commerce.message-template.email.features-list.jsm.premium.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.jsm.standard.branded-help-center":[{"children":[{"type":0,"value":"Branded help center:"}],"type":8,"value":"b"},{"type":0,"value":" Use your company\'s branding and URLs"}],"commerce.message-template.email.features-list.jsm.standard.enhanced-support":[{"children":[{"type":0,"value":"Enhanced support:"}],"type":8,"value":"b"},{"type":0,"value":" Get business hour support from our experts"}],"commerce.message-template.email.features-list.jsm.standard.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.loom.business-ai.advanced-editing":[{"children":[{"type":0,"value":"Advanced editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim, stitch, remove silence and filler words"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.loom.business.editing":[{"children":[{"type":0,"value":"Editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim out mistakes or stitch multiple videos together"}],"commerce.message-template.email.features-list.loom.business.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.service-collection.premium.advanced-aiops":[{"children":[{"type":0,"value":"Advanced AIOps:"}],"type":8,"value":"b"},{"type":0,"value":" Fast alert grouping, incident creation, and more"}],"commerce.message-template.email.features-list.service-collection.premium.ai-agents":[{"children":[{"type":0,"value":"AI agents:"}],"type":8,"value":"b"},{"type":0,"value":" Save time and use AI for basic conversational support"}],"commerce.message-template.email.features-list.service-collection.premium.asset-management":[{"children":[{"type":0,"value":"Asset management:"}],"type":8,"value":"b"},{"type":0,"value":" Manage the lifecycle of assets and services"}],"commerce.message-template.email.features-list.service-collection.standard.ai-powered-agents":[{"children":[{"type":0,"value":"AI-powered agents:"}],"type":8,"value":"b"},{"type":0,"value":" Automate support, resolve requests faster"}],"commerce.message-template.email.features-list.service-collection.standard.custom-help-center":[{"children":[{"type":0,"value":"Custom help center:"}],"type":8,"value":"b"},{"type":0,"value":" Deliver a seamless support experience"}],"commerce.message-template.email.features-list.service-collection.standard.unlimited-emails":[{"children":[{"type":0,"value":"Unlimited emails:"}],"type":8,"value":"b"},{"type":0,"value":" Talk to customers as much as you need"}],"commerce.message-template.email.upgrade-benefits.compass.body.customizations":[{"type":0,"value":"More customizations"}],"commerce.message-template.email.upgrade-benefits.compass.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benefits.compass.body.reusable-templates":[{"type":0,"value":"20 reusable templates"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.agents-and-customers":[{"type":0,"value":"Up to 20,000 agents and unlimited customers"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.ai-powered-support":[{"type":0,"value":"AI-powered employee support, operations, and customer service"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.audit-logs-data-residency":[{"type":0,"value":"Audit logs and multi-region data residency"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.custom-help-center":[{"type":0,"value":"Custom-branded help center"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\'s team of experts"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.unlimited-email-notifications":[{"type":0,"value":"Unlimited email notifications"}],"commerce.message-template.email.upgrade-benifits.compass.body.storage":[{"type":0,"value":"One year of data retention"}],"commerce.message-template.email.upgrade-benifits.compass.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.confluence.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.confluence.body.page-analytics":[{"type":0,"value":"Page analytics"}],"commerce.message-template.email.upgrade-benifits.confluence.body.space-and-page-permissions":[{"type":0,"value":"Space and page permissions"}],"commerce.message-template.email.upgrade-benifits.confluence.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.confluence.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jira.body.create-issues":[{"type":0,"value":"Anonymous access to let external users view and create issues"}],"commerce.message-template.email.upgrade-benifits.jira.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jira.body.issue-permissions":[{"type":0,"value":"Advanced project and issue permissions"}],"commerce.message-template.email.upgrade-benifits.jira.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jira.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.message-template.email.upgrade-benifits.jpd.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jpd.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.message-template.email.upgrade-benifits.jsm.body.automation-rules-per-month":[{"type":0,"value":"500 project automation rules per month"}],"commerce.message-template.email.upgrade-benifits.jsm.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jsm.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jsm.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jsm.body.track-changes":[{"type":0,"value":"Audit logs to troubleshoot and track changes"}],"commerce.message-template.next-steps":[{"type":0,"value":"Next steps:"}],"commerce.message-template.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.next-bill-estimate-common.key":[{"type":0,"value":"Next estimated bill (prorated):"}],"commerce.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.partner-name.key":[{"type":0,"value":"Atlassian billing partner:"}],"commerce.partner-name.value":[{"type":1,"value":"partnerName"}],"commerce.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n    \\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days."}],"commerce.requested-by-common.key":[{"type":0,"value":"Requested by:"}],"commerce.requested-by-common.value":[{"type":1,"value":"orderPlacedBy"}],"commerce.requested-by-common.value-with-email":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"emailLink"},{"type":0,"value":")"}],"commerce.requested-by-common.value-without-email":[{"type":1,"value":"name"}],"commerce.reseller-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from the "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":" page."}],"commerce.reseller-manage-subscriptions-subscription-overview":[{"type":0,"value":"Subscription overview"}],"commerce.servco-post-auto-uplift-email-notification.email.banner-alt":[{"type":0,"value":"Service Collection"}],"commerce.servco-post-auto-uplift-email-notification.email.button-v2":[{"type":0,"value":"See details"}],"commerce.servco-post-auto-uplift-email-notification.email.csm-label":[{"type":0,"value":"Customer Service Management"}],"commerce.servco-post-auto-uplift-email-notification.email.heading":[{"type":0,"value":"Jira Service Management is now part of Service Collection"}],"commerce.servco-post-auto-uplift-email-notification.email.help-message":[{"type":0,"value":"If you have any questions or need assistance exploring the new features, please don\'t hesitate to reach out."}],"commerce.servco-post-auto-uplift-email-notification.email.intro":[{"type":0,"value":"We\'re excited to announce that as of "},{"type":1,"value":"month"},{"type":0,"value":" "},{"type":1,"value":"day"},{"type":0,"value":", "},{"type":1,"value":"year"},{"type":0,"value":", your Jira Service Management has become part of Service Collection. Try the new Customer Service Management app and enjoy extra features, with no changes to your Jira Service Management."}],"commerce.servco-post-auto-uplift-email-notification.email.jsm-label":[{"type":0,"value":"JSM"}],"commerce.servco-post-auto-uplift-email-notification.email.jsm-label.v2":[{"type":0,"value":"Jira Service Management"}],"commerce.servco-post-auto-uplift-email-notification.email.new-app-label":[{"type":0,"value":"New app"}],"commerce.servco-post-auto-uplift-email-notification.email.on-your-entitlement":[{"type":0,"value":"On your entitlement:"}],"commerce.servco-post-auto-uplift-email-notification.email.received-because":[{"type":0,"value":"You received this email because you\'re an admin for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"commerce.servco-post-auto-uplift-email-notification.email.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Administration."}],"commerce.servco-post-auto-uplift-email-notification.message-template.email.subject":[{"type":0,"value":"Jira Service Management has moved to Service Collection"}],"commerce.ship-to-information.address-key":[{"type":0,"value":"Address:"}],"commerce.ship-to-information.address-value":[{"type":1,"value":"soldToAddress"}],"commerce.ship-to-information.company-name-key":[{"type":0,"value":"Company:"}],"commerce.ship-to-information.company-name-key-alt-customer":[{"type":0,"value":"Customer:"}],"commerce.ship-to-information.company-name-value":[{"type":1,"value":"soldToCompanyName"}],"commerce.ship-to-information.end-customer-contact-key":[{"type":0,"value":"Customer contact:"}],"commerce.ship-to-information.end-customer-contact-value":[{"type":1,"value":"endCustomerContacts"}],"commerce.ship-to-information.invoice-number-key":[{"type":0,"value":"Invoice number:"}],"commerce.ship-to-information.invoice-number-value":[{"type":1,"value":"invoiceNumber"}],"commerce.subscription-common.entitlement-details":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-with-org-name":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") | "},{"type":1,"value":"orgName"}],"commerce.subscription-common.entitlement-details-with-site-url":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteURL"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-without-orgName":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.key":[{"type":0,"value":"Subscription:"}],"commerce.subscription-common.new-quote-total-key":[{"type":0,"value":"New quote total:"}],"commerce.subscription-common.old-quote-total-key":[{"type":0,"value":"Old quote total:"}],"commerce.subscription-common.quote-number-key":[{"type":0,"value":"Quote:"}],"commerce.subscription-common.quote-number-value":[{"type":1,"value":"quoteNumber"}],"commerce.subscription-common.quote-total-key":[{"type":0,"value":"Quote total:"}],"commerce.subscription-common.quote-total-value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amount"}],"commerce.subscription-common.value-with-offering":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-offering-without-entitlement":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"commerce.subscription-common.value-with-pricing-plan":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"pricingPlanName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-product":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"commerce.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"common.cloud-payment-retry-actions.admin-hub-url":[{"type":0,"value":"admin.atlassian.com"}],"common.cloud-payment-retry-actions.atlassian-administration":[{"type":0,"value":"Atlassian administration"}],"common.cloud-payment-retry-actions.billing-console-url":[{"type":0,"value":"admin.atlassian.com/billing"}],"common.cloud-payment-retry-actions.billing-overview":[{"type":0,"value":"Billing overview"}],"common.cloud-payment-retry-actions.change-plan":[{"type":0,"value":"Change plan"}],"common.cloud-payment-retry-actions.contact-supportt":[{"type":0,"value":"If you need to speak to our team, you may "},{"type":1,"value":"element"},{"type":0,"value":" to the Atlassian Support Team."}],"common.cloud-payment-retry-actions.contact-us-heading":[{"type":0,"value":"Contact us:"}],"common.cloud-payment-retry-actions.data-storage-faq":[{"type":0,"value":"Data Storage FAQs"}],"common.cloud-payment-retry-actions.downgrade-heading":[{"type":0,"value":"Downgrade to a Free plan:"}],"common.cloud-payment-retry-actions.export-data":[{"type":0,"value":"We advise you to export your business data from your Atlassian instance. For more information, see our "},{"type":1,"value":"element"}],"common.cloud-payment-retry-actions.export-data-heading":[{"type":0,"value":"Export your data:"}],"common.cloud-payment-retry-actions.free":[{"type":0,"value":"Free"}],"common.cloud-payment-retry-actions.free-plan-change":[{"type":0,"value":"Change to the Free plan at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"billingOverview"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" in the "},{"type":1,"value":"subscriptions"},{"type":0,"value":" section. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" for your product. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"planChange"},{"type":0,"value":". Select the "},{"type":1,"value":"free"},{"type":0,"value":" plan and confirm"}],"common.cloud-payment-retry-actions.here-are-actions":[{"type":0,"value":"Here are some actions we suggest you take:"}],"common.cloud-payment-retry-actions.manage":[{"type":0,"value":"Manage"}],"common.cloud-payment-retry-actions.manage-users":[{"type":0,"value":"Manage users"}],"common.cloud-payment-retry-actions.reduce-users":[{"type":0,"value":"If applicable, you\'ll first need to reduce users to 10 or fewer (three agents or fewer for Jira Service Management). Go to your site\'s admin at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"admin"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":". Find users you want to remove, and select "},{"type":1,"value":"showDetails"},{"type":0,"value":"."}],"common.cloud-payment-retry-actions.show-details":[{"type":0,"value":"Show details &gt; Actions &gt; Remove user"}],"common.cloud-payment-retry-actions.submit-ticket":[{"type":0,"value":"Submit a ticket"}],"common.cloud-payment-retry-actions.subscription-details":[{"type":0,"value":"Subscription details"}],"common.cloud-payment-retry-actions.subscriptions":[{"type":0,"value":"Subscriptions"}],"common.cloud-payment-retry-actions.what-if-unable":[{"type":0,"value":"What if I\'m unable to make payments?"}],"common.invoice.manage-subscriptions.partner-info":[{"type":0,"value":"To manage subscriptions, visit our Partner Purchasing Center (PPC)."}],"common.invoice.manage-subscriptions.subscription-info":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"post-office.commerce-access-invalid-payment-hams.caption":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"post-office.commerce-access-invalid-payment-hams.error-message.access":[{"type":0,"value":"We couldn\u2019t process your payment for Atlassian Access since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.bitbucket":[{"type":0,"value":"We couldn\u2019t process your payment for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.cloud":[{"type":0,"value":"We couldn\'t process your payment for Atlassian Cloud since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.server":[{"type":0,"value":"We couldn\u2019t process your payment for "},{"type":1,"value":"productInfoString"},{"type":0,"value":" since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.retry-button":[{"type":0,"value":"Retry Payment"}],"post-office.commerce-access-invalid-payment-hams.retry-message":[{"type":0,"value":"Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or asked to authenticate in a different way."}],"post-office.commerce-common.Contact-us":[{"type":0,"value":"Contact us"}],"post-office.commerce-common.atlassian-support-team":[{"type":0,"value":"Atlassian Support Team"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.label":[{"type":0,"value":"Plan"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.value":[{"type":1,"value":"productName"},{"type":0,"value":" Standard ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" user"}]},"other":{"value":[{"type":7},{"type":0,"value":" users"}]}},"pluralType":"cardinal","type":6,"value":"userCount"},{"type":0,"value":")"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.value.no-user-count":[{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.heading":[{"type":0,"value":"Not ready to upgrade?"}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-admin":[{"type":0,"value":"You can switch back to a Free plan by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"link"},{"type":0,"value":" to 10 or fewer."}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan by reducing your user count to 10 or fewer."}],"post-office.commerce-common.blocks.regards":[{"type":0,"value":"Regards,"}],"post-office.commerce-common.blocks.thanks":[{"type":0,"value":"Thanks,"}],"post-office.commerce-common.cheers":[{"type":0,"value":"Cheers,"}],"post-office.commerce-common.cheers.from-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.cheers.from-atlassians":[{"type":0,"value":"The Atlassians"}],"post-office.commerce-common.choose-plan-link":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.choose-plan.billing-console":[{"type":0,"value":"Keep Premium plan"}],"post-office.commerce-common.choose-plan.choose-plan.billing-console":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.consumption.included-quantity-details":[{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"includedQuantityUnit"}],"post-office.commerce-common.consumption.summary-included-quantity":[{"type":0,"value":"Included quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity":[{"type":0,"value":"Consumed quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity-details":[{"type":1,"value":"consumedQuantity"},{"type":0,"value":" "},{"type":1,"value":"consumedQuantityUnit"}],"post-office.commerce-common.consumptionl.summary.consumption-percentage":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% consumed"}],"post-office.commerce-common.contact-support-button.partner":[{"type":0,"value":"Contact Support"}],"post-office.commerce-common.contact-us":[{"type":0,"value":"contact us"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-service-management":[{"type":0,"value":"Atlassian Jira Service Management"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-service-collection":[{"type":0,"value":"Atlassian Service Collection"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-teamwork-collection":[{"type":0,"value":"Atlassian Teamwork Collection"}],"post-office.commerce-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.email.plan-section.description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" 30-day money back guarantee if you forget to cancel."}],"post-office.commerce-common.email.plan-section.explore-plan.link-description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Explore all plans \u2192"}],"type":8,"value":"b"}],"post-office.commerce-common.email.subscription-details-section.billing-cycle-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Billing cycle"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-subtitle.end-of-trial-with-pde":[{"type":0,"value":"First bill estimate"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-suffix.end-of-trial-with-pde":[{"type":0,"value":" (Excludes taxes)"}],"post-office.commerce-common.email.subscription-details-section.plan-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Plan"}],"post-office.commerce-common.email.subscription-details-section.title.end-of-trial-with-pde":[{"type":0,"value":"Subscription details"}],"post-office.commerce-common.email.subscription-details-section.trial-ends-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Trial ends"}],"post-office.commerce-common.email.subscription.deactivate-consequence-section.deactivate-info":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\u2019t add payment details or reduce your user count to "},{"type":1,"value":"ceiling"},{"type":0,"value":" or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"post-office.commerce-common.email.subscription.deactivate-consequence-section.what-to-do-question":[{"type":0,"value":"What do I need to do?"}],"post-office.commerce-common.email.subscription.description.end-of-trial-with-pde":[{"type":0,"value":"When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"post-office.commerce-common.email.subscription.downgrade-consequence-section.downgrade-info":[{"type":0,"value":"If you don\u2019t add payment details you\u2019ll downgrade to the Free plan and lose access to your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan features."}],"post-office.commerce-common.email.subscription.downgrade-consequence-section.features-question":[{"type":0,"value":"Which other features will I lose access to?"}],"post-office.commerce-common.email.subscription.headline.end-of-trial-with-pde":[{"type":0,"value":"You don\'t need to do anything"}],"post-office.commerce-common.email.subscription.other-features-you-lose.confluence-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are unlimited whiteboards, page insights, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.confluence-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users, page insights, and access to Rovo on Standard."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jira-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are plans for multiple projects, ability to assign roles, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jira-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users, ability to assign roles, and access to Rovo on Standard."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jpd-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are roadmaps for multiple spaces, ability to assign roles, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jpd-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users and ability to assign roles on Standard."}],"post-office.commerce-common.email.subscription.payment-details.keep-your-plan":[{"type":0,"value":"Keep "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"post-office.commerce-common.email.subscription.tick-circle-green-icon.end-of-trial-with-pde":[{"type":0,"value":"Green tick circle icon for the billing section"}],"post-office.commerce-common.features-image.confluence-premium":[{"type":0,"value":"Confluence Premium Features"}],"post-office.commerce-common.features-image.confluence-standard":[{"type":0,"value":"Confluence Standard Features"}],"post-office.commerce-common.features-image.jira-premium":[{"type":0,"value":"Jira Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-premium":[{"type":0,"value":"Jira Product Discovery Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-standard":[{"type":0,"value":"Jira Product Discovery Standard Features"}],"post-office.commerce-common.features-image.jira-service-management-premium":[{"type":0,"value":"Jira Service Management Premium Features"}],"post-office.commerce-common.features-image.jira-service-management-standard":[{"type":0,"value":"Jira Service Management Standard Features"}],"post-office.commerce-common.features-image.jira-standard":[{"type":0,"value":"Jira Standard Features"}],"post-office.commerce-common.features-image.loom-business":[{"type":0,"value":"Loom Business Features"}],"post-office.commerce-common.features-image.loom-business-ai":[{"type":0,"value":"Loom Business + AI Features"}],"post-office.commerce-common.features-image.service-collection-premium":[{"type":0,"value":"Service Collection Premium Features"}],"post-office.commerce-common.features-image.service-collection-standard":[{"type":0,"value":"Service Collection Standard Features"}],"post-office.commerce-common.footer-v2.ai-disclaimer":[{"type":0,"value":"Some content in this email has been generated by AI."}],"post-office.commerce-common.footer-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer-v2.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer-v2.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.commerce-common.footer-v2.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer-v2.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer-v2.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer-v2.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer-v2.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer-v2.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.commerce-common.footer-v2.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer-v2.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.commerce-common.footer-v2.x-alt-text":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.x-title":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer-v2.youtube-title":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.commerce-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer.office-address.we-are-located-at":[{"type":0,"value":"We are located at "}],"post-office.commerce-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.commerce-common.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.formal-goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"post-office.commerce-common.formal-goodbye.contact-representative":[{"type":0,"value":"Contact your Atlassian representative if you have any questions."}],"post-office.commerce-common.formal-thank-you":[{"type":0,"value":"Thank you for taking action at your earliest convenience."}],"post-office.commerce-common.get-in-touch":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouchLink"}],"post-office.commerce-common.need-help-with-contact-us":[{"type":0,"value":"Need help with plans and billing? "},{"type":1,"value":"contactUs"}],"post-office.commerce-common.not-personal-greetings":[{"type":0,"value":"Hi,"}],"post-office.commerce-common.payment-details.add":[{"type":0,"value":"Add payment details"}],"post-office.commerce-common.payment-details.add.v2":[{"type":0,"value":"explore your plan options"}],"post-office.commerce-common.payment-details.update":[{"type":0,"value":"Update payment details"}],"post-office.commerce-common.personal-greetings":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"post-office.commerce-common.product.entitlement-number.billing-cycle":[{"type":0,"value":"Billing cycle: "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.product.entitlement-number.requested-by-email-id":[{"type":0,"value":"Requested by: "},{"type":1,"value":"requestedByEmailId"}],"post-office.commerce-common.product.entitlement-number.site-url.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"}]},"true":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"}]}},"type":5,"value":"hasSiteUrl"}],"post-office.commerce-common.product.entitlement-number.users-count":[{"type":1,"value":"chargeElement"},{"type":0,"value":"s: "},{"type":1,"value":"usersCount"}],"post-office.commerce-common.product.product-title.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"productName"}]},"true":{"value":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"offeringName"},{"type":0,"value":")"}]}},"type":5,"value":"hasOfferingName"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits":[{"children":[{"type":0,"value":"Assets objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits-with-unit":[{"children":[{"type":0,"value":"Assets objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits":[{"children":[{"type":0,"value":"Automation steps:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits-with-unit":[{"children":[{"type":0,"value":"Automation steps:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time-with-unit":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network-with-unit":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution":[{"children":[{"type":0,"value":"Customer Service Management AI agent resolutions:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution-with-unit":[{"children":[{"type":0,"value":"Customer Service Management AI agent resolutions:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects":[{"children":[{"type":0,"value":"Indexed objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects-with-unit":[{"children":[{"type":0,"value":"Indexed objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits-with-unit":[{"children":[{"type":0,"value":"Rovo credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-product-details.bill-estimate-and-currency":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"post-office.commerce-common.subscription-product-details.bill-estimate-title":[{"type":0,"value":"Total bill estimate"}],"post-office.commerce-common.subscription-product-details.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription-product-details.exclude-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscription-product-details.offering-name.user-size.billing-cycle.no-translate":[{"type":1,"value":"siteDetails"}],"post-office.commerce-common.subscription-product-details.product-name.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription-product-details.site-url.no-translate":[{"type":1,"value":"siteURL"}],"post-office.commerce-common.subscription.atlassian-guard-standard":[{"type":0,"value":"Atlassian Guard Standard"}],"post-office.commerce-common.subscription.atlassian-rovo":[{"type":0,"value":"Atlassian Rovo"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits":[{"type":0,"value":"Assets objects: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits-with-unit":[{"type":0,"value":"Assets objects: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits":[{"type":0,"value":"Automation steps: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits-with-unit":[{"type":0,"value":"Automation steps: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time-with-unit":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage-with-unit":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network-with-unit":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage-with-unit":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution":[{"type":0,"value":"Customer Service Management AI agent resolutions: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution-with-unit":[{"type":0,"value":"Customer Service Management AI agent resolutions: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects":[{"type":0,"value":"Indexed objects: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects-with-unit":[{"type":0,"value":"Indexed objects: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits":[{"type":0,"value":"Rovo credits: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits-with-unit":[{"type":0,"value":"Rovo credits: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-charge-element-package-network":[{"children":[{"type":0,"value":"Network traffic:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-package-storage":[{"children":[{"type":0,"value":"Package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo Dev credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" credits per user"}],"post-office.commerce-common.subscription.cbp-charge-element-runners":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage":[{"children":[{"type":0,"value":"Storage (Git LFS):"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage-minutes":[{"children":[{"type":0,"value":"Build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.free-access":[{"type":0,"value":"Free access to:"}],"post-office.commerce-common.subscription.included-apps":[{"type":0,"value":"Included apps:"}],"post-office.commerce-common.subscription.pooled-allocation.per-user-month":[{"type":1,"value":"credits"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" per user/month"}],"post-office.commerce-common.subscription.product-title.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.address.no-translate":[{"type":0,"value":"Address: "},{"type":1,"value":"address"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.company.no-translate":[{"type":0,"value":"Company: "},{"type":1,"value":"companyName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.customer-contact.no-translate":[{"type":0,"value":"Customer contact: "},{"type":1,"value":"customerContact"}],"post-office.commerce-common.subscription.product.billing-cycle.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.subscription.product.billing-user-partner-contextual-info.partner-name.no-translate":[{"type":0,"value":"Atlassian billing partner: "},{"type":1,"value":"billingPartner"}],"post-office.commerce-common.subscription.product.charge quantities.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"usageQuantity"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":"s "}],"post-office.commerce-common.subscription.product.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription.product.offering-name.no-translate":[{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"post-office.commerce-common.subscription.product.site-url.no-translate":[{"type":1,"value":"siteUrl"}],"post-office.commerce-common.subscription.rovo-dev-credit-allocation.per-user":[{"type":1,"value":"credits"},{"type":0,"value":" Rovo Dev credits per user"}],"post-office.commerce-common.subscriptions-change-plan":[{"type":0,"value":"Subscriptions"}],"post-office.commerce-common.subscriptions.excludes-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscriptions.this-payment-is-for":[{"type":0,"value":"This payment is for:"}],"post-office.commerce-common.subscriptions.total-bill-estimate":[{"type":0,"value":"Total bill estimate:"}],"post-office.commerce-common.subscriptions.total-bill-estimate-after-trial":[{"type":0,"value":"Total bill estimate after trial ends:"}],"post-office.commerce-common.subscriptions.your-estimated-bill-is":[{"type":0,"value":"Your estimated bill is:"}],"post-office.commerce-common.the-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.view-subscription.billing-console":[{"type":0,"value":"View subscription"}],"post-office.commerce-decoupled-offering-ccp.button.review-bill":[{"type":0,"value":"Review your new bill"}],"post-office.commerce-decoupled-offering-ccp.marketplace-details-guide":[{"type":0,"value":"how Marketplace apps are billed"}],"post-office.commerce-order-fulfilled-ccp.email.billing-account.other-host-type":[{"type":0,"value":"billing account"}],"post-office.commerce-order-fulfilled-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-ccp.email.cmk.support-url":[{"type":0,"value":"page"}],"post-office.commerce-order-fulfilled-ccp.email.direct-customer.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-ccp.email.siteAdmin.cloud":[{"type":0,"value":"site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"}],"post-office.commerce-order-fulfilled-ccp.email.support-url":[{"type":0,"value":"billing support"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.siteAdmin":[{"type":0,"value":"Administration"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.support-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.view-quote-url":[{"type":0,"value":"Learn more"}],"post-office.commerce-payment-failure-hams.email.support.additional_actions":[{"type":0,"value":"additional actions"}],"post-office.commerce-payment-failure-hams.email.title.check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.expiration":[{"type":0,"value":"This doesn\'t have to be a goodbye"}],"post-office.commerce-payment-failure-hams.email.title.expired":[{"type":0,"value":"Your Atlassian subscription has expired"}],"post-office.commerce-payment-failure-hams.email.title.make-it-official":[{"type":0,"value":"Let\'s make it official!"}],"post-office.commerce-payment-failure-hams.email.title.trial-check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.trial-end":[{"type":0,"value":"Your trial has ended. What\'s next?"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.email.partner.set-up":[{"type":0,"value":"set up the collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.direct-customer.set-up":[{"type":0,"value":"set up your collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.partner.set-up":[{"type":0,"value":"sets up the collection"}],"post-office.commerce.star-email-template.body.agent-limit":[{"type":0,"value":"Get "},{"children":[{"type":0,"value":"unlimited agents"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"250 GB file storage"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.ai-triage":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"AI"}],"type":8,"value":"b"},{"type":0,"value":" to triage requests from portal, email, and chat"}],"post-office.commerce.star-email-template.body.ai-written-support":[{"type":0,"value":"Power your Rovo agent with "},{"children":[{"type":0,"value":"AI written support articles"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.assets":[{"type":0,"value":"Track business "},{"children":[{"type":0,"value":"assets"}],"type":8,"value":"b"},{"type":0,"value":" and link them to work items"}],"post-office.commerce.star-email-template.body.auto":[{"type":0,"value":"You\'ve reached the agent limit for your Free plan, so we\'ve upgraded you to our "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of the "},{"children":[{"type":0,"value":"Standard"}],"type":8,"value":"b"},{"type":0,"value":" plan."}],"post-office.commerce.star-email-template.body.auto.change-your-mind":[{"type":0,"value":"If you change your mind, get refunded in the first 30 days of your purchase. You can also "},{"children":[{"type":0,"value":"cancel or switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime by reducing your agent count."}],"post-office.commerce.star-email-template.body.auto.storage":[{"type":0,"value":"You\'ve reached the 2 GB storage limit for your Free plan, so we\'ve upgraded you to our "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of the "},{"children":[{"type":0,"value":"Standard"}],"type":8,"value":"b"},{"type":0,"value":" plan."}],"post-office.commerce.star-email-template.body.billing-date-with-pde":[{"type":0,"value":"You won\'t be charged until your next billing date on "},{"children":[{"type":1,"value":"nextBillTimestamp"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"post-office.commerce.star-email-template.body.billing-date-without-pde":[{"type":0,"value":"To continue with Standard, add payment details by "},{"children":[{"type":1,"value":"nextBillTimestamp"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"post-office.commerce.star-email-template.body.direct":[{"type":0,"value":"You\'re currently on a "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":". Dive in to manage requests, incidents, changes and assets. All in one place, with the power of AI."}],"post-office.commerce.star-email-template.body.manual":[{"type":0,"value":"Enjoy your "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":" with brand new benefits like AI, Assets, higher automation limits and unlimited agents."}],"post-office.commerce.star-email-template.body.manual-direct.change-your-mind":[{"type":0,"value":"If you change your mind, get refunded in the first 30 days of your purchase. You can also "},{"children":[{"type":0,"value":"cancel or switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime."}],"post-office.commerce.star-email-template.body.rovo-ai-agents":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"Rovo AI agents"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.rovo-ai-agents-direct":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"AI agents"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.button.explore-standard-direct":[{"type":0,"value":"Explore your new service space"}],"post-office.commerce.star-email-template.button.explore-standard-manual-auto":[{"type":0,"value":"Explore Standard"}],"post-office.commerce.star-email-template.caption.add-payment-details-button":[{"type":0,"value":"Add Payment Details"}],"post-office.commerce.star-email-template.caption.billing":[{"type":0,"value":"What happens to your billing?"}],"post-office.commerce.star-email-template.caption.heading.auto":[{"type":0,"value":"\uD83D\uDC4B Say hello to unlimited agents"}],"post-office.commerce.star-email-template.caption.heading.auto.storage":[{"type":0,"value":"\uD83D\uDC4B Say hello to more storage"}],"post-office.commerce.star-email-template.caption.heading.welcome.manual-direct":[{"type":0,"value":"\uD83C\uDF89 Welcome to Service Collection Standard"}],"post-office.commerce.star-email-template.link.explore-plans":[{"type":0,"value":"Explore all plans"}],"post-office.commerce.star-email-template.subject.auto-upgrade":[{"type":0,"value":"You\'ve been upgraded to our Standard plan - free for 14 days"}],"post-office.commerce.star-email-template.subject.direct-trial":[{"type":0,"value":"Welcome to your Service Collection "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan!"}],"post-office.commerce.star-email-template.subject.manual-trial":[{"type":0,"value":"Your "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialDaysLeft"},{"type":0,"value":" free trial of our "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has started"}],"post-office.commerce.star-email-template.subscription.excludes-taxes":[{"type":0,"value":"(Excludes Taxes)"}],"post-office.commerce.star-email-template.subscription.header":[{"type":0,"value":"Subscription Details"}],"post-office.commerce.star-email-template.subscription.header-no-payment":[{"type":0,"value":"Trial details"}],"post-office.commerce.star-email-template.subscription.included-apps":[{"type":0,"value":"Included apps:"}],"post-office.commerce.star-email-template.subscription.next-bill-date":[{"type":0,"value":"Next bill date"}],"post-office.commerce.star-email-template.subscription.next-bill-estimate":[{"type":0,"value":"Next bill estimate"}],"post-office.commerce.star-email-template.subscription.next-bill-estimate-no-payment":[{"type":0,"value":"Estimated first bill"}],"post-office.commerce.star-email-template.subscription.trial-end-date":[{"type":0,"value":"Trial ends"}],"post-office.commerce.star-email-template.subscription.users":[{"type":1,"value":"count"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"user"}]},"other":{"value":[{"type":0,"value":"users"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"post-office.star-email-template.email-header-alt":[{"type":0,"value":"Service Collection"}],"post-office.star-email-template.email-header-subtitle":[{"type":0,"value":"Includes:"}],"post-office.star-email-template.footer.ai-disclaimer":[{"type":0,"value":"Some content in this email has been generated by AI."}],"post-office.star-email-template.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.star-email-template.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.star-email-template.footer.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.star-email-template.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.star-email-template.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.star-email-template.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.star-email-template.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.star-email-template.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.star-email-template.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.star-email-template.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.star-email-template.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.star-email-template.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.star-email-template.footer.x-alt-text":[{"type":0,"value":"X"}],"post-office.star-email-template.footer.x-title":[{"type":0,"value":"X"}],"post-office.star-email-template.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.star-email-template.footer.youtube-title":[{"type":0,"value":"Youtube"}]}');

});

parcelRegister("9E6iG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lxlFz").then(()=>parcelRequire('9Mg6w'));

});

parcelRegister("5Y48P", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dIaKZ").then(()=>parcelRequire('gaqt8'));

});

parcelRegister("1b1fj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h4BRC").then(()=>parcelRequire('iVBXs'));

});

parcelRegister("fCdG4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("88zLT").then(()=>parcelRequire('esMh8'));

});

parcelRegister("fsaWg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2xzqj").then(()=>parcelRequire('lisWZ'));

});

parcelRegister("lLSyB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6C504").then(()=>parcelRequire('at40s'));

});

parcelRegister("fr5iR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lANRy").then(()=>parcelRequire('fKF96'));

});

parcelRegister("3OTLp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hiFvc").then(()=>parcelRequire('jziKC'));

});

parcelRegister("fGYVE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aTXbb").then(()=>parcelRequire('eZXoP'));

});

parcelRegister("iLvQh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("49AQy").then(()=>parcelRequire('8jZGG'));

});

parcelRegister("gbRBe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cRpMx").then(()=>parcelRequire('2Kj4P'));

});

parcelRegister("exLlE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6ds4u").then(()=>parcelRequire('22U0B'));

});

parcelRegister("dl5zl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cSTDM").then(()=>parcelRequire('6XutQ'));

});

parcelRegister("8A7J9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("85gz5").then(()=>parcelRequire('giRQv'));

});

parcelRegister("4j0Qx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2213e").then(()=>parcelRequire('gw7Nu'));

});

parcelRegister("7QpeD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g4ESO").then(()=>parcelRequire('aP1GJ'));

});

parcelRegister("hvNhw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("26m8J").then(()=>parcelRequire('dBFJ0'));

});

parcelRegister("fLNG0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cxGmk").then(()=>parcelRequire('erFoF'));

});

parcelRegister("hQEa3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cDcpD").then(()=>parcelRequire('i1aFT'));

});

parcelRegister("eruaT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("73lSg").then(()=>parcelRequire('1Qi08'));

});

parcelRegister("4ytd6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8vJ4D").then(()=>parcelRequire('lFqgk'));

});

parcelRegister("4HZqL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gMOfq").then(()=>parcelRequire('iPLAl'));

});

parcelRegister("4FcIr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("DLp7F").then(()=>parcelRequire('5NDDQ'));

});

parcelRegister("8beGL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3yA7C").then(()=>parcelRequire('aVCQr'));

});

parcelRegister("eoEjg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eJg9o").then(()=>parcelRequire('8GqPz'));

});

parcelRegister("lXaSn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gXlRg").then(()=>parcelRequire('3qYmG'));

});

parcelRegister("cLSkf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jXkRI").then(()=>parcelRequire('hQnaL'));

});

parcelRegister("kB6Wi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dcaL5").then(()=>parcelRequire('lGOzx'));

});

parcelRegister("2VjHF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dT9dk").then(()=>parcelRequire('eLV0y'));

});

parcelRegister("jJgzW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1EDEQ").then(()=>parcelRequire('e3vHm'));

});

parcelRegister("ic1qD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kRglL").then(()=>parcelRequire('bpKht'));

});

parcelRegister("ke4eK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("klT5B").then(()=>parcelRequire('kQJNK'));

});

parcelRegister("jxd20", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5EY9D").then(()=>parcelRequire('ftCQE'));

});

parcelRegister("l8mQT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kXfU1").then(()=>parcelRequire('5CBCT'));

});

parcelRegister("fgvws", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ug15").then(()=>parcelRequire('hlCgA'));

});


parcelRegister("1jVWp", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $98889dc3ea50c81f$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $iXjeu = parcelRequire("iXjeu");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $98889dc3ea50c81f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $98889dc3ea50c81f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("1Dlk9")));
        case 'da':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("6fMEp")));
        case 'de':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("4pzDc")));
        case 'en-GB':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("1Ckig")));
        case 'en-US':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("bngo8")));
        case 'en-XA':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("fExJr")));
        case 'en-XB':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("8UoIg")));
        case 'en-ZZ':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("dFhOr")));
        case 'en':
            return $98889dc3ea50c81f$var$importHelper(await Promise.resolve((parcelRequire("iXjeu"))));
        case 'es':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("2HDb9")));
        case 'et':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("dqGZr")));
        case 'fi':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("lDBpS")));
        case 'fr':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("bKuta")));
        case 'hr':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("VWznH")));
        case 'hu':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("y3aMX")));
        case 'it':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("ivA3J")));
        case 'ja':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("li3l6")));
        case 'ko':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("fxv4z")));
        case 'nb':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("5NAOY")));
        case 'nl':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("a3sU9")));
        case 'pl':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("cpNTj")));
        case 'pt-BR':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("aR3M5")));
        case 'ro':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("lxFmh")));
        case 'ru':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("eqBWw")));
        case 'sl':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("22pZY")));
        case 'sr-RS':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("iZ4Vn")));
        case 'sr-YR':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("1KYJK")));
        case 'sr':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("ibPpT")));
        case 'sv':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("8veAq")));
        case 'th':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("10Sjz")));
        case 'tr':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("c4vsl")));
        case 'uk':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("jgukk")));
        case 'vi':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("kpmCm")));
        case 'zh-CN':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("gOD5W")));
        case 'zh-TW':
            return $98889dc3ea50c81f$var$importHelper(await (parcelRequire("hp3b7")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($iXjeu));
    }
};

});
parcelRegister("iXjeu", function(module, exports) {
module.exports = JSON.parse('{"confluence-ai-audio.scenario-changeboarding.backButton":[{"type":0,"value":"Back"}],"confluence-ai-audio.scenario-changeboarding.doneButton":[{"type":0,"value":"Done"}],"confluence-ai-audio.scenario-changeboarding.nextButton":[{"type":0,"value":"Next"}],"confluence-ai-audio.scenario-changeboarding.step1Body":[{"type":0,"value":"Not ready to listen? Add it to your playlist for later or play it on the app."}],"confluence-ai-audio.scenario-changeboarding.step1Headline":[{"type":0,"value":"Save it"}],"confluence-ai-audio.scenario-changeboarding.step2Body":[{"type":0,"value":"See what\u2019s next, change the order, or start playing."}],"confluence-ai-audio.scenario-changeboarding.step2Headline":[{"type":0,"value":"Open playlist"}],"confluence-ai-audio.scenario-changeboarding.step3Body":[{"type":0,"value":"Copy and share a link so anyone with access can listen."}],"confluence-ai-audio.scenario-changeboarding.step3Headline":[{"type":0,"value":"Share it"}],"confluence-ai-audio.scenario-changeboarding.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"post-office.audio-button-spotlight.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2 hello there"}],"post-office.audio-player-spotlight-tour.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}]}');

});

parcelRegister("1Dlk9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jngRw").then(()=>parcelRequire('7NmP7'));

});

parcelRegister("6fMEp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dvjzL").then(()=>parcelRequire('bsQwH'));

});

parcelRegister("4pzDc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("koxT3").then(()=>parcelRequire('eFwdt'));

});

parcelRegister("1Ckig", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9qtDd").then(()=>parcelRequire('alVfw'));

});

parcelRegister("bngo8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ednhz").then(()=>parcelRequire('a86qx'));

});

parcelRegister("fExJr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8G5Fz").then(()=>parcelRequire('iVqlx'));

});

parcelRegister("8UoIg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lSXgR").then(()=>parcelRequire('d5Q8K'));

});

parcelRegister("dFhOr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kfn7s").then(()=>parcelRequire('frieJ'));

});

parcelRegister("2HDb9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bYF0Y").then(()=>parcelRequire('9d2qw'));

});

parcelRegister("dqGZr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2jDvz").then(()=>parcelRequire('4nkit'));

});

parcelRegister("lDBpS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i8u8l").then(()=>parcelRequire('gaKz2'));

});

parcelRegister("bKuta", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dlKBG").then(()=>parcelRequire('hzlj8'));

});

parcelRegister("VWznH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7kvUh").then(()=>parcelRequire('63zeQ'));

});

parcelRegister("y3aMX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l0qB3").then(()=>parcelRequire('12Cp7'));

});

parcelRegister("ivA3J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("esAaB").then(()=>parcelRequire('2YgwZ'));

});

parcelRegister("li3l6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lHqHI").then(()=>parcelRequire('906ZH'));

});

parcelRegister("fxv4z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6Ud5f").then(()=>parcelRequire('1biVa'));

});

parcelRegister("5NAOY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("caW6a").then(()=>parcelRequire('6Oacn'));

});

parcelRegister("a3sU9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("31YbQ").then(()=>parcelRequire('kKaSP'));

});

parcelRegister("cpNTj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7OWI6").then(()=>parcelRequire('4O7aA'));

});

parcelRegister("aR3M5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("70ynF").then(()=>parcelRequire('9VEm9'));

});

parcelRegister("lxFmh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4KVwF").then(()=>parcelRequire('ajsFH'));

});

parcelRegister("eqBWw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dH6Tl").then(()=>parcelRequire('6D3uK'));

});

parcelRegister("22pZY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6VFyY").then(()=>parcelRequire('aP7WW'));

});

parcelRegister("iZ4Vn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gCOfw").then(()=>parcelRequire('dadrg'));

});

parcelRegister("1KYJK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("85huw").then(()=>parcelRequire('7S9JJ'));

});

parcelRegister("ibPpT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4mLB1").then(()=>parcelRequire('haRhG'));

});

parcelRegister("8veAq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kb06n").then(()=>parcelRequire('h76Ft'));

});

parcelRegister("10Sjz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fwhDU").then(()=>parcelRequire('4Lziq'));

});

parcelRegister("c4vsl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kwirs").then(()=>parcelRequire('klc5H'));

});

parcelRegister("jgukk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bKJiT").then(()=>parcelRequire('7O9wv'));

});

parcelRegister("kpmCm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cFvRT").then(()=>parcelRequire('igBgB'));

});

parcelRegister("gOD5W", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g2Rnc").then(()=>parcelRequire('clcDE'));

});

parcelRegister("hp3b7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gMjhD").then(()=>parcelRequire('giBM1'));

});


parcelRegister("cZYU6", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $cb28b75026f38be0$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5j37n = parcelRequire("5j37n");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cb28b75026f38be0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $cb28b75026f38be0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("d9M5k")));
        case 'da':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("hvNcm")));
        case 'de':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("jsycV")));
        case 'en-GB':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("hxDoF")));
        case 'en-US':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("6QWJA")));
        case 'en-XA':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("bjiEU")));
        case 'en-XB':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("ew3gy")));
        case 'en-ZZ':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("5uesi")));
        case 'en':
            return $cb28b75026f38be0$var$importHelper(await Promise.resolve((parcelRequire("5j37n"))));
        case 'es':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("jOWET")));
        case 'et':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("gp6p6")));
        case 'fi':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("55U7U")));
        case 'fr':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("dn0hO")));
        case 'hr':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("efeY8")));
        case 'hu':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("h6rtt")));
        case 'it':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("UDtmu")));
        case 'ja':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("7HEuS")));
        case 'ko':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("ltb8C")));
        case 'nb':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("bRvE4")));
        case 'nl':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("4nMdy")));
        case 'pl':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("53IpP")));
        case 'pt-BR':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("gCFTN")));
        case 'ro':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("3Ua0P")));
        case 'ru':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("cHgLs")));
        case 'sl':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("b2bws")));
        case 'sr-RS':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("dD431")));
        case 'sr-YR':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("9lvXY")));
        case 'sr':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("6Gboh")));
        case 'sv':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("kphXb")));
        case 'th':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("eqKDV")));
        case 'tr':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("9gUF6")));
        case 'uk':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("iXGt2")));
        case 'vi':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("dvypc")));
        case 'zh-CN':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("82fho")));
        case 'zh-TW':
            return $cb28b75026f38be0$var$importHelper(await (parcelRequire("kGqco")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5j37n));
    }
};

});
parcelRegister("5j37n", function(module, exports) {
module.exports = JSON.parse('{"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.primary.no-pde":[{"type":0,"value":"Try it free"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.primary.pde":[{"type":0,"value":"Try now"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.secondary":[{"type":0,"value":"No thanks"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.body.has-payment":[{"type":0,"value":"Billing starts after "},{"type":1,"value":"trialEndDate"},{"type":0,"value":". We\u2019ll remind you before your trial ends. Downgrade to Free or "},{"children":[{"type":0,"value":"switch plans"}],"type":8,"value":"Link"},{"type":0,"value":" anytime."}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.body.no-payment":[{"type":0,"value":"After your trial you can stay on your plan or downgrade to a free plan. "},{"children":[{"type":0,"value":"Explore plans"}],"type":8,"value":"Link"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.header":[{"type":0,"value":"Welcome to your "},{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":"-day"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":" free trial "},{"options":{"other":{"value":[]},"premium":{"value":[{"type":0,"value":"of Premium"}]},"standard":{"value":[{"type":0,"value":"of Standard"}]}},"type":5,"value":"edition"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature1":[{"type":0,"value":"See user data and insights in one place"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature2":[{"type":0,"value":"Control who can view, edit, and comment"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature3":[{"type":0,"value":"Create unlimited whiteboards"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature1":[{"type":0,"value":"Share read-only pages with external stakeholders"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature2":[{"type":0,"value":"Automate repetitive tasks"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature3":[{"type":0,"value":"Control who can edit and comment"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.admin-key":[{"children":[{"type":0,"value":"Admin key"}],"type":8,"value":"b"},{"type":0,"value":": Access restricted content so you can fix bugs, fast"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.automation":[{"children":[{"type":0,"value":"Automation"}],"type":8,"value":"b"},{"type":0,"value":": 10x more rule runs per month"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.page-insights":[{"children":[{"type":0,"value":"Page insights"}],"type":8,"value":"b"},{"type":0,"value":": See who viewed your page and when"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.page-permissions":[{"children":[{"type":0,"value":"Page permissions"}],"type":8,"value":"b"},{"type":0,"value":": Choose who can view, edit, and comment"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.rovo":[{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"},{"type":0,"value":": AI-powered search, chat, and agents"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.space-permissions":[{"children":[{"type":0,"value":"Space permissions"}],"type":8,"value":"b"},{"type":0,"value":": Choose who can access entire folders"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.admin-features-title":[{"type":0,"value":"You also get more admin features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Archive\' feature on the Confluence Standard plan. This will make it easy to archive outdated content and keep things tidy."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Archive\' feature on the Confluence Standard plan. This will make it easy to archive outdated content and keep things tidy."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Archive\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.title":[{"type":0,"value":"Help your team keep Confluence work tidy and up-to-date"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Archive\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" keep Confluence work tidy and up-to-date"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Calendars\' feature on the Confluence Premium plan. This will make it easy to plan deadlines and time off across teams."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Calendars\' feature on the Confluence Premium plan. This will make it easy to plan deadlines and time off across teams."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Calendars\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.title":[{"type":0,"value":"Help your team balance downtime with deadlines"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Calendars\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" balance downtime with deadlines"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try features on the Confluence Standard plan."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.description":[{"type":0,"value":"Someone on your team has requested to try features on the Confluence Standard plan."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try new features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try new features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.explore-all-features":[{"type":0,"value":"Explore all features \u2192"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.get-started-button":[{"type":0,"value":"Get Started"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Confluence logo"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Pages insights and analytics\' feature on the Confluence Standard plan. This will make it easy to see user engagement and make more informed decisions"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Pages insights and analytics\' feature on the Confluence Standard plan. This will make it easy to see user engagement and make more informed decisions"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Page insights\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.title":[{"type":0,"value":"Unlock data and insights for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Page insights\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.title":[{"type":0,"value":"Unlock data and insights for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Page permissions\' feature on the Confluence Standard plan. This will makes it easy to decide who can edit, view, and comment on pages."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Page permissions\' feature on the Confluence Standard plan. This will makes it easy to decide who can edit, view, and comment on pages."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Page permissions\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.title":[{"type":0,"value":"Help your team share more and worry less"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Page permissions\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" share more and worry less"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try Rovo (AI) on the Confluence Standard plan. This will make it easy to summarize pages, get writing help, and generate ideas, fast."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.description":[{"type":0,"value":"Someone on your team has requested to try Rovo (AI) on the Confluence Standard plan. This will make it easy to summarize pages, get writing help, and generate ideas, fast."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try Rovo (AI)"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.title":[{"type":0,"value":"Unlock improved writing and more creativity for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try Rovo (AI)"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.title":[{"type":0,"value":"Unlock improved writing and more creativity for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.upgrade-trial-edition-info":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested access to more whiteboards on the Confluence Premium plan. This will unlock unlimited whiteboards."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.description":[{"type":0,"value":"Someone on your team has requested access to more whiteboards on the Confluence Premium plan. This will unlock unlimited whiteboards."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team needs more Confluence whiteboards"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.title":[{"type":0,"value":"Help your team turn ideas into action"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" needs more Confluence whiteboards"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" turn ideas into action"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.xflow-access-request-slack-notification.app-description.confluence":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Confluence, a collaboration app that lets your team create, share, and organize work in pages and spaces."}],"post-office.xflow-access-request-slack-notification.app-description.jira-product-discovery":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Jira Product Discovery, a roadmap and prioritization app that links to your Jira projects."}],"post-office.xflow-access-request-slack-notification.app-description.jira-service-management":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Jira Service Management, an app that helps your team unify and resolve requests faster."}],"post-office.xflow-access-request-slack-notification.app-description.loom":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Loom, an app that lets your team record and embed videos to Jira work items."}],"post-office.xflow-access-request-slack-notification.app-description.service-collection":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Service Collection, a suite of apps designed to help your team unify and resolve requests faster."}],"post-office.xflow-access-request-slack-notification.more-actions-placeholder":[{"type":0,"value":"More actions..."}],"post-office.xflow-access-request-slack-notification.mute-for-1-day":[{"type":0,"value":"Snooze for 1 day"}],"post-office.xflow-access-request-slack-notification.requestor-mention-fallback":[{"type":0,"value":"Someone"}],"post-office.xflow-access-request-slack-notification.review-request-button":[{"type":0,"value":"Review request"}],"post-office.xflow-access-request-slack-notification.turn-off-notifications":[{"type":0,"value":"Turn off these notifications"}]}');

});

parcelRegister("d9M5k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2kbFS").then(()=>parcelRequire('eE4fo'));

});

parcelRegister("hvNcm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("YWEmR").then(()=>parcelRequire('7H3u3'));

});

parcelRegister("jsycV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kjmtf").then(()=>parcelRequire('3uo1g'));

});

parcelRegister("hxDoF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kFQM2").then(()=>parcelRequire('dHeL3'));

});

parcelRegister("6QWJA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("185jF").then(()=>parcelRequire('BgHJx'));

});

parcelRegister("bjiEU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eHuHN").then(()=>parcelRequire('ecOiI'));

});

parcelRegister("ew3gy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ht6x4").then(()=>parcelRequire('jYnNW'));

});

parcelRegister("5uesi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9RnOC").then(()=>parcelRequire('i0XYD'));

});

parcelRegister("jOWET", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1BfgS").then(()=>parcelRequire('041hl'));

});

parcelRegister("gp6p6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3K4Oa").then(()=>parcelRequire('aruDI'));

});

parcelRegister("55U7U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hAcvd").then(()=>parcelRequire('iYDe0'));

});

parcelRegister("dn0hO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("84RC0").then(()=>parcelRequire('cKpRD'));

});

parcelRegister("efeY8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kWSCI").then(()=>parcelRequire('jfQ3w'));

});

parcelRegister("h6rtt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1B73V").then(()=>parcelRequire('6cSb2'));

});

parcelRegister("UDtmu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h394r").then(()=>parcelRequire('h1wOb'));

});

parcelRegister("7HEuS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lDy6K").then(()=>parcelRequire('lTdy0'));

});

parcelRegister("ltb8C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jJgLC").then(()=>parcelRequire('25iHf'));

});

parcelRegister("bRvE4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("18vhb").then(()=>parcelRequire('T74FO'));

});

parcelRegister("4nMdy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gjj4E").then(()=>parcelRequire('hV3Ke'));

});

parcelRegister("53IpP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4eIEh").then(()=>parcelRequire('8JOgC'));

});

parcelRegister("gCFTN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hkjgk").then(()=>parcelRequire('9fXEK'));

});

parcelRegister("3Ua0P", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c1uo0").then(()=>parcelRequire('FZsqY'));

});

parcelRegister("cHgLs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("liznk").then(()=>parcelRequire('5kexn'));

});

parcelRegister("b2bws", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8d7l4").then(()=>parcelRequire('aojH3'));

});

parcelRegister("dD431", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6pE9S").then(()=>parcelRequire('9bPkO'));

});

parcelRegister("9lvXY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8zawL").then(()=>parcelRequire('eUNea'));

});

parcelRegister("6Gboh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("YQ2OQ").then(()=>parcelRequire('aLnO7'));

});

parcelRegister("kphXb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ilFHp").then(()=>parcelRequire('kVlnb'));

});

parcelRegister("eqKDV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cf3JC").then(()=>parcelRequire('6Lv82'));

});

parcelRegister("9gUF6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3oTi4").then(()=>parcelRequire('bc2KD'));

});

parcelRegister("iXGt2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iGnJD").then(()=>parcelRequire('iicuR'));

});

parcelRegister("dvypc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8kcCw").then(()=>parcelRequire('lu4Tl'));

});

parcelRegister("82fho", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jFLVE").then(()=>parcelRequire('5cISQ'));

});

parcelRegister("kGqco", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eMtaS").then(()=>parcelRequire('eWCfk'));

});


parcelRegister("iL0ky", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $f87975946259d20a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $dbXL4 = parcelRequire("dbXL4");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f87975946259d20a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $f87975946259d20a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("ha1hf")));
        case 'da':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("2Zy29")));
        case 'de':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("jBEqI")));
        case 'en-GB':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("4tydK")));
        case 'en-US':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("1yXH8")));
        case 'en-XA':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("E8jBG")));
        case 'en-XB':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("3Oq30")));
        case 'en-ZZ':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("2XsaH")));
        case 'en':
            return $f87975946259d20a$var$importHelper(await Promise.resolve((parcelRequire("dbXL4"))));
        case 'es':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("hyCWK")));
        case 'et':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("b4a5N")));
        case 'fi':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("fJtT6")));
        case 'fr':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("25wxC")));
        case 'hr':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("6W4Qz")));
        case 'hu':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("9VdkY")));
        case 'it':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("8ITPD")));
        case 'ja':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("dyftG")));
        case 'ko':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("gv6DW")));
        case 'nb':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("iy94T")));
        case 'nl':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("23tUw")));
        case 'pl':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("iT4na")));
        case 'pt-BR':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("9PvaK")));
        case 'ro':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("hNOOQ")));
        case 'ru':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("foXmI")));
        case 'sl':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("k9vZN")));
        case 'sr-RS':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("23djb")));
        case 'sr-YR':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("5KCOT")));
        case 'sr':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("digez")));
        case 'sv':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("36VTI")));
        case 'th':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("idjZZ")));
        case 'tr':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("jDxYU")));
        case 'uk':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("5tHqj")));
        case 'vi':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("dYAMN")));
        case 'zh-CN':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("eOBfN")));
        case 'zh-TW':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("aGwkh")));
        case 'zh':
            return $f87975946259d20a$var$importHelper(await (parcelRequire("eOBfN")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($dbXL4));
    }
};

});
parcelRegister("dbXL4", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.atlassian-store":[{"type":0,"value":"Marketplace apps"}],"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-itsm-template.jsm.title":[{"type":0,"value":"Collect IT requests"}],"cross-flow-product-prioritization-template.jpd.title":[{"type":0,"value":"Prioritize ideas"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"cross-flow-product-roadmap-template.jpd.title":[{"type":0,"value":"Create a roadmap"}],"cross-flow-work-requests-template.jsm.title":[{"type":0,"value":"Collect requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluence-nudge-for-jira.action":[{"type":0,"value":"Accept invitation"}],"growth.confluence-nudge-for-jira.description":[{"type":0,"value":"Accept your invitation to make sure you\'re not missing any project updates."}],"growth.confluence-nudge-for-jira.title":[{"type":0,"value":"Your team invited you to Jira"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product":[{"type":0,"value":"TRY"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-twc.twc-apps-lozenge":[{"type":0,"value":"New"}],"growth.recommendation-twc.twc-apps-product-benefits-description":[{"type":0,"value":"Run your whole project seamlessly"}],"growth.recommendation-twc.twc-apps-product-benefits-title":[{"type":0,"value":"1 collection, 4 tools"}],"growth.recommendation-twc.twc-image-alt-text":[{"type":0,"value":"Teamwork Collection"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.example-placement-quick-start.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.growth.jira-activation-project-recommendation.check-jira":[{"type":0,"value":"Check Jira"}],"post-office.growth.jira-activation-project-recommendation.hello-message":[{"type":0,"value":":wave: Hey "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"post-office.growth.jira-activation-project-recommendation.message-text":[{"type":0,"value":"Have you checked Jira lately? You may be missing out on important updates. Take a quick look to see if your team is using it to track any of your projects."}],"post-office.growth.jira-activation-project-recommendation.messages-exist":[{"type":0,"value":"Don\u2019t forget to get caught up on your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"project"}]},"other":{"value":[{"type":0,"value":"projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":" in Jira! Take a quick look to get up-to-date on your teammates\u2019 progress."}],"post-office.growth.jira-activation-project-recommendation.see-projects":[{"type":0,"value":"See all projects"}],"post-office.growth.jira-activation-project-recommendation.you-have-messages":[{"offset":0,"options":{"=0":{"value":[]},"=1":{"value":[]},"=2":{"value":[{"type":0,"value":"You have *two projects*:"}]},"=3":{"value":[{"type":0,"value":"You have *three projects*:"}]},"other":{"value":[{"type":0,"value":"You have *"},{"options":{"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects*. Here are three to get you started:"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects":[{"type":0,"value":":wave: Just a heads up \u2014 you have *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one project"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":"* assigned to you with new work items you haven\'t checked out yet."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items":[{"type":0,"value":":wave: Just a heads up \u2014 you were assigned "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"a work item in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]},"other":{"value":[{"type":0,"value":"some work items in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":" over three days ago."}],"post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message":[{"type":0,"value":"You\'ve got *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one item"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfWorkItems"}]}},"type":5,"value":"numberOfWorkItems"},{"type":0,"value":" items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":"* to check on \u2014 here are three:"}],"post-office.growth.jira-assigned-nudge-digest.plural-cta-message":[{"type":0,"value":"See inactive "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"item"}]},"other":{"value":[{"type":0,"value":"items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"}],"post-office.growth.jira-assigned-nudge-digest.top-projects-message":[{"type":0,"value":"Here are three to get you started:"}],"post-office.growth.jira-board-catch-up-rovo-nudge.secondary-title":[{"type":0,"value":"Get a quick summary of new issues and important activity."}],"post-office.growth.jira-board-catch-up-rovo-nudge.static-prompt":[{"type":0,"value":"Summarize the most recent activity on this Jira board. Create an executive-ready update (max ~8 bullets total) using this structure:\\n\\n1. Sprint / timeline context\\n- Current sprint or time window, dates, and high-level status (e.g. \\"on track / at risk / off track\\").\\n\\n2. Key progress / wins (2-4 bullets)\\n- Focus on issues that moved into In Progress, In Review / Pending Review, or Done in the selected period.\\n- For each, include: issue key, short description (3-7 words), and current status only (no technical deep dive).\\n\\n3. Blockers / risks (1-3 bullets)\\n- Call out any flagged issues, long-running items stuck in In Progress or In Review, or dependencies that could impact delivery for this sprint / period.\\n\\n4. Scope & pipeline (1-3 bullets)\\n- Highlight important newly created or To Do issues that are not yet started but are significant for upcoming milestones.\\n- Note if work is skewed toward setup/foundations vs user-visible outcomes.\\n\\n5. Next-focus recommendation (1-2 bullets)\\n- Recommend the 1-2 highest-leverage next actions to keep the team\'s objectives on track, referencing specific issue keys.\\n\\nOutput the answer as concise markdown bullets, optimized for an executive audience (outcomes, risks, and next moves over implementation details)."}],"post-office.growth.jira-board-catch-up-rovo-nudge.title":[{"type":0,"value":"Catch up on recent changes"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-projects-recommendations.cta-button-lozenge-try":[{"type":0,"value":"Try"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-one-spork":[{"type":0,"value":"the tools you use (Jira)"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-two-appify":[{"type":0,"value":"the way you use your existing tools and apps"}],"post-office.nav-4-projects-recommendations.reasons-modal-explanation":[{"type":0,"value":"We think "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"post-office.nav-4-projects-recommendations.section-heading":[{"type":0,"value":"Recommended"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"rovo-3p-party-integration-admin-nudge.action.connect":[{"type":0,"value":"Connect now"}],"rovo-3p-party-integration-admin-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-two-apps":[{"type":0,"value":"Over 90% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.low-percentage":[{"type":0,"value":"Most of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.one-app":[{"type":1,"value":"percUsersConnected"},{"type":0,"value":"% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.more-apps-label":[{"type":0,"value":"More apps"}],"rovo-3p-party-integration-admin-nudge.title.one-app":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("ha1hf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jTU9w").then(()=>parcelRequire('dJMld'));

});

parcelRegister("2Zy29", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7XBhD").then(()=>parcelRequire('hevo5'));

});

parcelRegister("jBEqI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ajtLI").then(()=>parcelRequire('5qCuH'));

});

parcelRegister("4tydK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hhrTB").then(()=>parcelRequire('eGTwQ'));

});

parcelRegister("1yXH8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hkXCf").then(()=>parcelRequire('KCxTF'));

});

parcelRegister("E8jBG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1OYbV").then(()=>parcelRequire('iKoOs'));

});

parcelRegister("3Oq30", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5fVoN").then(()=>parcelRequire('a3P3E'));

});

parcelRegister("2XsaH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9oEGp").then(()=>parcelRequire('7iWIj'));

});

parcelRegister("hyCWK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3fAn7").then(()=>parcelRequire('keAZg'));

});

parcelRegister("b4a5N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8j3p3").then(()=>parcelRequire('2UQ3r'));

});

parcelRegister("fJtT6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cvy8P").then(()=>parcelRequire('kNoio'));

});

parcelRegister("25wxC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jhPD8").then(()=>parcelRequire('8BgpR'));

});

parcelRegister("6W4Qz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7s9UK").then(()=>parcelRequire('kgJLZ'));

});

parcelRegister("9VdkY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fYDq9").then(()=>parcelRequire('4ZVLU'));

});

parcelRegister("8ITPD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jJtAo").then(()=>parcelRequire('9WBWw'));

});

parcelRegister("dyftG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1nKMr").then(()=>parcelRequire('9Z72H'));

});

parcelRegister("gv6DW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("NuFDB").then(()=>parcelRequire('bT7iz'));

});

parcelRegister("iy94T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8SQ2E").then(()=>parcelRequire('js4f8'));

});

parcelRegister("23tUw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6H3Lm").then(()=>parcelRequire('1rXtf'));

});

parcelRegister("iT4na", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2z5uX").then(()=>parcelRequire('6tf9e'));

});

parcelRegister("9PvaK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7rflT").then(()=>parcelRequire('1dyoH'));

});

parcelRegister("hNOOQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gfVJt").then(()=>parcelRequire('laYXx'));

});

parcelRegister("foXmI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7hZag").then(()=>parcelRequire('hVffl'));

});

parcelRegister("k9vZN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a64SF").then(()=>parcelRequire('e2EdX'));

});

parcelRegister("23djb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g6hrK").then(()=>parcelRequire('1fjiS'));

});

parcelRegister("5KCOT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5WE06").then(()=>parcelRequire('9Q3Az'));

});

parcelRegister("digez", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5x8kH").then(()=>parcelRequire('7MPfs'));

});

parcelRegister("36VTI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("folPo").then(()=>parcelRequire('fRI9Q'));

});

parcelRegister("idjZZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8nZmo").then(()=>parcelRequire('7WKp9'));

});

parcelRegister("jDxYU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("79gvb").then(()=>parcelRequire('TVufT'));

});

parcelRegister("5tHqj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aIfRe").then(()=>parcelRequire('2wNHc'));

});

parcelRegister("dYAMN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h0yJW").then(()=>parcelRequire('5wNc6'));

});

parcelRegister("eOBfN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7IgNJ").then(()=>parcelRequire('4eqCy'));

});

parcelRegister("aGwkh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l34wg").then(()=>parcelRequire('xo7el'));

});


parcelRegister("agO15", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $dd23e464f1ee3e63$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $gtcyy = parcelRequire("gtcyy");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dd23e464f1ee3e63$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $dd23e464f1ee3e63$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("1q70d")));
        case 'da':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("aaR1P")));
        case 'de':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("15D7k")));
        case 'en-GB':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("5lwA8")));
        case 'en-US':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("j5dBT")));
        case 'en-XA':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("ffHwO")));
        case 'en-XB':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("jTWPV")));
        case 'en-ZZ':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("ahKD8")));
        case 'en':
            return $dd23e464f1ee3e63$var$importHelper(await Promise.resolve((parcelRequire("gtcyy"))));
        case 'es':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("3h3jd")));
        case 'et':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("feDjo")));
        case 'fi':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("g3687")));
        case 'fr':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("lu0pY")));
        case 'hr':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("3enE6")));
        case 'hu':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("1DWlv")));
        case 'it':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("eusyZ")));
        case 'ja':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("g6BTV")));
        case 'ko':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("7R44c")));
        case 'nb':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("h65A4")));
        case 'nl':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("5M3AF")));
        case 'pl':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("g1Zf7")));
        case 'pt-BR':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("9xWWO")));
        case 'ro':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("bk6En")));
        case 'ru':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("4w7QW")));
        case 'sl':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("76egp")));
        case 'sr-RS':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("k65RV")));
        case 'sr-YR':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("2B2fQ")));
        case 'sr':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("lWeJB")));
        case 'sv':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("4p9nF")));
        case 'th':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("7kSj3")));
        case 'tr':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("8xIpA")));
        case 'uk':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("6L10N")));
        case 'vi':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("ejOF3")));
        case 'zh-CN':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("lDJMm")));
        case 'zh-TW':
            return $dd23e464f1ee3e63$var$importHelper(await (parcelRequire("1j2WJ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($gtcyy));
    }
};

});
parcelRegister("gtcyy", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.context":[{"type":0,"value":"Context"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.meeting":[{"type":0,"value":"Meeting"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.pre-read":[{"type":0,"value":"Pre-read"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.time":[{"type":0,"value":"Time"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.cta.go-to-confluence":[{"type":0,"value":"Go to Confluence"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.feedback.body":[{"type":0,"value":"What\'s working, what\'s not, what do you wish it did?"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.feedback.cta":[{"type":0,"value":"Share your thoughts in "},{"children":[{"type":0,"value":"#cc-atlaspulse-feedback"}],"type":8,"value":"link"},{"type":0,"value":". We\'d love to hear from you!"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.feedback.heading":[{"type":0,"value":"Feedback: How can we improve your daily brief?"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.ai-disclaimer":[{"type":0,"value":"This briefing was generated by Rovo based on your recent work activity."}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.ai-disclaimer-note":[{"children":[{"type":0,"value":"Uses AI. Verify results."}],"type":8,"value":"link"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.manage-notifications":[{"type":0,"value":"Manage notification preferences"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.privacy-policy":[{"type":0,"value":"Privacy policy"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.sent-by":[{"type":0,"value":"This email was sent by Atlassian"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.header.date":[{"type":0,"value":"Your briefing for "},{"type":1,"value":"briefingDate"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.header.greeting":[{"type":0,"value":"Good morning, "},{"type":1,"value":"userName"},{"type":0,"value":" \uD83D\uDC4B"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.subject":[{"type":0,"value":"Atlas Pulse: Your daily briefing for "},{"type":1,"value":"briefingDate"}],"confluence-editor-smart-links-draggable-changeboard.description":[{"type":0,"value":"Organize your smart links and keep them in one place for quick access. Simply drag any smart link into your sidebar."}],"confluence-editor-smart-links-draggable-changeboard.dismissButton":[{"type":0,"value":"Got it"}],"confluence-editor-smart-links-draggable-changeboard.gifAlt":[{"type":0,"value":"Animation showing how to drag a smart link into the sidebar"}],"confluence-editor-smart-links-draggable-changeboard.headline":[{"type":0,"value":"Drag smart links to your sidebar"}],"confluence-inline-reactions-mcu-nudge.description.many-reactions":[{"type":1,"value":"user1"},{"type":0,"value":", "},{"type":1,"value":"user2"},{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" other"},{"offset":0,"options":{"one":{"value":[]},"other":{"value":[{"type":0,"value":"s"}]}},"pluralType":"cardinal","type":6,"value":"count"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-mcu-nudge.description.no-reactions":[{"type":0,"value":"Be the first one to react"}],"confluence-inline-reactions-mcu-nudge.description.one-reaction":[{"type":1,"value":"user"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-mcu-nudge.description.two-reactions":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-mcu-nudge.title":[{"type":0,"value":"Love this page? Let "},{"type":1,"value":"authorName"},{"type":0,"value":" know"}],"post-office.confluence-resurrected-user-welcome-back.body":[{"type":0,"value":"Catch up on the top discussions and highlights from your team."}],"post-office.confluence-resurrected-user-welcome-back.close":[{"type":0,"value":"Close"}],"post-office.confluence-resurrected-user-welcome-back.cta":[{"type":0,"value":"See what\'s popular"}],"post-office.confluence-resurrected-user-welcome-back.image-alt":[{"type":0,"value":"Two hearts overlapped with each other"}],"post-office.confluence-resurrected-user-welcome-back.next-best-action.header":[{"type":0,"value":"Welcome back"}]}');

});

parcelRegister("1q70d", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9sD7s").then(()=>parcelRequire('hms18'));

});

parcelRegister("aaR1P", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("72xAc").then(()=>parcelRequire('7lSij'));

});

parcelRegister("15D7k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3CrA8").then(()=>parcelRequire('bxPKl'));

});

parcelRegister("5lwA8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1QTaD").then(()=>parcelRequire('cMY7G'));

});

parcelRegister("j5dBT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5NjeC").then(()=>parcelRequire('h7lnJ'));

});

parcelRegister("ffHwO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1OLc9").then(()=>parcelRequire('44hj2'));

});

parcelRegister("jTWPV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d0tCP").then(()=>parcelRequire('f1qBh'));

});

parcelRegister("ahKD8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("26naE").then(()=>parcelRequire('2p8Qf'));

});

parcelRegister("3h3jd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eQXe6").then(()=>parcelRequire('hq6wr'));

});

parcelRegister("feDjo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hD0RL").then(()=>parcelRequire('6ufBv'));

});

parcelRegister("g3687", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9qhz4").then(()=>parcelRequire('49NUA'));

});

parcelRegister("lu0pY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k20u5").then(()=>parcelRequire('02xvf'));

});

parcelRegister("3enE6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gWx5q").then(()=>parcelRequire('56crf'));

});

parcelRegister("1DWlv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2BcAK").then(()=>parcelRequire('8CF76'));

});

parcelRegister("eusyZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j3FRD").then(()=>parcelRequire('4cUHc'));

});

parcelRegister("g6BTV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("141X1").then(()=>parcelRequire('9XOP3'));

});

parcelRegister("7R44c", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ed8VD").then(()=>parcelRequire('6X74f'));

});

parcelRegister("h65A4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gGcf5").then(()=>parcelRequire('afzaI'));

});

parcelRegister("5M3AF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bLioB").then(()=>parcelRequire('g3iSv'));

});

parcelRegister("g1Zf7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6h3hG").then(()=>parcelRequire('jUmfm'));

});

parcelRegister("9xWWO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dXu7Y").then(()=>parcelRequire('kW784'));

});

parcelRegister("bk6En", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9BF3t").then(()=>parcelRequire('cvhdP'));

});

parcelRegister("4w7QW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dMNpS").then(()=>parcelRequire('b30FQ'));

});

parcelRegister("76egp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6J0Wu").then(()=>parcelRequire('lTcS5'));

});

parcelRegister("k65RV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("faq5v").then(()=>parcelRequire('io1EY'));

});

parcelRegister("2B2fQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ew8y6").then(()=>parcelRequire('jxNyv'));

});

parcelRegister("lWeJB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gugkU").then(()=>parcelRequire('7BnOA'));

});

parcelRegister("4p9nF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i8BcI").then(()=>parcelRequire('gLioz'));

});

parcelRegister("7kSj3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("crKeu").then(()=>parcelRequire('7nTPp'));

});

parcelRegister("8xIpA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iiQ2l").then(()=>parcelRequire('gyXjA'));

});

parcelRegister("6L10N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7OZTY").then(()=>parcelRequire('2JHyR'));

});

parcelRegister("ejOF3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2vdax").then(()=>parcelRequire('k9uss'));

});

parcelRegister("lDJMm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8BglM").then(()=>parcelRequire('9UEYO'));

});

parcelRegister("1j2WJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hJ7ze").then(()=>parcelRequire('7vLNc'));

});


parcelRegister("24ssA", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $99a8438158dd1e7a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $afJ93 = parcelRequire("afJ93");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $99a8438158dd1e7a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $99a8438158dd1e7a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("2v1Kp")));
        case 'da':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("bg3Fa")));
        case 'de':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("3IAw9")));
        case 'en-GB':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("bZUfx")));
        case 'en-US':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("hr2Mk")));
        case 'en-XA':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("5KC1x")));
        case 'en-XB':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("h2wUP")));
        case 'en-ZZ':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("85utK")));
        case 'en':
            return $99a8438158dd1e7a$var$importHelper(await Promise.resolve((parcelRequire("afJ93"))));
        case 'es':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("aMFkq")));
        case 'et':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("8WVSb")));
        case 'fi':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("1kywi")));
        case 'fr':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("4ZpYd")));
        case 'hr':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("hAUUU")));
        case 'hu':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("kPABm")));
        case 'it':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("kfkjn")));
        case 'ja':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("kVdln")));
        case 'ko':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("43LVC")));
        case 'nb':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("eKti2")));
        case 'nl':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("iKgNA")));
        case 'pl':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("807o6")));
        case 'pt-BR':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("383ko")));
        case 'ro':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("5zY5r")));
        case 'ru':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("aAQ09")));
        case 'sl':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("h1UDg")));
        case 'sr-RS':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("cX5H8")));
        case 'sr-YR':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("9pcYj")));
        case 'sr':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("8lhat")));
        case 'sv':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("loGL2")));
        case 'th':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("aXy42")));
        case 'tr':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("bBcOs")));
        case 'uk':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("5NFhV")));
        case 'vi':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("21y2k")));
        case 'zh-CN':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("e0uBY")));
        case 'zh-TW':
            return $99a8438158dd1e7a$var$importHelper(await (parcelRequire("ehXRD")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($afJ93));
    }
};

});
parcelRegister("afJ93", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.long-read":[{"type":0,"value":"You\u2019ve been diving deep into Confluence pages lately to stay ahead of the game. To help you keep up without the information overload, "},{"children":[{"type":0,"value":"meet Rovo"}],"type":8,"value":"b"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.page-created":[{"type":0,"value":"Now that you created a page, "},{"children":[{"type":0,"value":"take it further with Rovo"}],"type":8,"value":"b"},{"type":0,"value":" \u2014 you\u2019ll get instant feedback on clarity, structure, and completeness."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.page-watched":[{"type":0,"value":"Watching pages is a great way to stay in the loop. But instead of sifting through every notification, let Rovo give you a quick AI-powered catch-up on what changed."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.long-read":[{"type":0,"value":"Summarize a page with Rovo"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.page-created":[{"type":0,"value":"Review my page with Rovo"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.page-watched":[{"type":0,"value":"Try AI catch-up"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.footer.unsubscribe":[{"type":1,"value":"link"},{"type":0,"value":" to opt out of future emails like this."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.footer.unsubscribe.cta":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.long-read":[{"type":0,"value":"You\u2019re crushing your reading list \uD83D\uDCDA"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.page-created":[{"type":0,"value":"Nice work on your new page! \uD83C\uDF89"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.page-watched":[{"type":0,"value":"You\'re watching a page \u2014 nice!"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.long-read":[{"type":0,"value":"Review key points in seconds with AI summary"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.page-created":[{"type":0,"value":"Get instant feedback on clarity and structure from Rovo"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.page-watched":[{"type":0,"value":"Get AI-powered summaries instead of notification noise"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.long-read":[{"type":0,"value":"Summarize the key points of this page, \\""},{"type":1,"value":"pageTitle"},{"type":0,"value":"\\""}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.page-created":[{"type":0,"value":"Review this page, \\""},{"type":1,"value":"pageTitle"},{"type":0,"value":"\\", for clarity, tone, and structure"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.page-watched":[{"type":0,"value":"Notify me when this page, \\""},{"type":1,"value":"pageTitle"},{"type":0,"value":"\\", is updated"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.long-read":[{"type":0,"value":"That was a long read \u2014 here\'s a shortcut for next time"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.page-created":[{"type":0,"value":"You just published a page - want a second opinion?"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.page-watched":[{"type":0,"value":"A smarter way to stay updated on pages you watch"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.long-read":[{"type":0,"value":"Next time, let Rovo scan the page\u2014you\'ll get a bulleted breakdown of "},{"children":[{"type":0,"value":"action items and insights"}],"type":8,"value":"b"},{"type":0,"value":" without the grind."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.page-created":[{"children":[{"type":0,"value":"Ask Rovo"}],"type":8,"value":"b"},{"type":0,"value":" to review your page for clarity, tone, and structure. It\'s like having an editor on standby."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.page-watched":[{"type":0,"value":"Rovo summarizes all recent changes across the pages you watch, so you can stay informed without the notification noise."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.long-read":[{"type":0,"value":"Summarize long pages in seconds"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.page-created":[{"type":0,"value":"Get instant feedback from Rovo"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.page-watched":[{"type":0,"value":"Get an AI catch-up"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta1.button.go-to-content-type.link-name":[{"type":0,"value":"Go to "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta1.button.view-more-insights.link-name":[{"type":0,"value":"View more insights"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta2-template-link-name":[{"type":0,"value":"Try template"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta2-template-name":[{"type":0,"value":"Meeting Notes"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.first-line-with-content-type":[{"type":0,"value":"Your "},{"type":1,"value":"contentType"},{"type":0,"value":" just got its first view"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.second-line.line1":[{"type":0,"value":"Your work is already helping your team stay on the same page."}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.second-line.line2":[{"type":0,"value":"To keep the collaboration momentum going, many teams use Confluence for meeting agendas and notes to make shared decisions easy to reference."}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-1.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. 341 George Street, Sydney, NSW, 2000, Australia"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-2.unsubscribe.cta":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-2.with-unsubscribe-cta":[{"type":1,"value":"link"},{"type":0,"value":" to opt out of future emails like this."}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Image depicting a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.header.img.alt":[{"type":0,"value":"Confluence logo"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.meeting-notes-template.img.alt":[{"type":0,"value":"Meeting notes template preview"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.page-icon.img.alt":[{"type":0,"value":"Page icon"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.blog-post":[{"type":0,"value":"blog post"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.live-page":[{"type":0,"value":"live page"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.page":[{"type":0,"value":"page"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.subject":[{"type":0,"value":"You just got your first view ever!"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.blogpost":[{"type":0,"value":"blog post"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.database":[{"type":0,"value":"database"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.anonymous":[{"type":0,"value":"There\'s a new reaction to your "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.first-reaction":[{"type":1,"value":"reactor"},{"type":0,"value":" reacted to your "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.second-reaction":[{"type":1,"value":"reactor"},{"type":0,"value":" and "},{"type":1,"value":"secondReactor"},{"type":0,"value":" reacted to your "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.third-reaction-or-more":[{"type":1,"value":"reactor"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"numberOfOtherReactors"},{"type":0,"value":" reacted to your "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.live-doc":[{"type":0,"value":"live doc"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.page":[{"type":0,"value":"page"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.anonymous":[{"type":0,"value":"There\'s a new reaction to a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.first-reaction":[{"type":1,"value":"reactor"},{"type":0,"value":" reacted to a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.second-reaction":[{"type":1,"value":"reactor"},{"type":0,"value":" and "},{"type":1,"value":"secondReactor"},{"type":0,"value":" reacted to a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.third-reaction-or-more":[{"type":1,"value":"reactor"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"numberOfOtherReactors"},{"type":0,"value":" reacted to a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.whiteboard":[{"type":0,"value":"whiteboard"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.button-text":[{"type":0,"value":"Create meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.description":[{"type":0,"value":"Share goals, set context, and save time with a meeting notes template."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header":[{"type":0,"value":"Keep meetings aligned and actionable"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header-image.alt-text":[{"type":0,"value":"Atlassian Confluence logo"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.main-image.alt-text":[{"type":0,"value":"Meeting notes illustration showing document with highlighted content"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-image.alt-text":[{"type":0,"value":"Meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-text":[{"type":0,"value":"Meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.unsubscribe-link-text":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or unsubscribe "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"a"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.message-template.email.subject":[{"type":0,"value":"Save time with a Confluence meeting notes template"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part1":[{"type":0,"value":"Your teammates are using Confluence to share project context, capture decisions, and more in "},{"type":1,"value":"projectName"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part2":[{"type":0,"value":"Here\'s what they\'ve recently linked to your Jira project:"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.email.subject":[{"type":0,"value":"Your team in "},{"type":1,"value":"projectName"},{"type":0,"value":" is using Confluence for project docs--see what they\u2019ve added"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.button-cta":[{"type":0,"value":"Open Confluence"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.signoff":[{"type":0,"value":"See what else is happening across your company:"}],"confluence-personalized-use-case-expansion.first.body":[{"type":0,"value":"Create your first page"}],"confluence-personalized-use-case-expansion.first.cta":[{"type":0,"value":"Create a page"}],"confluence-personalized-use-case-expansion.first.title":[{"type":0,"value":"Get started with Confluence"}],"confluence-reactivate-inactive-link-paste-in-jira-notif.action.text":[{"type":0,"value":"View in Confluence"}],"confluence-reactivate-inactive-link-paste-in-jira-notif.message.body":[{"type":0,"value":"A Confluence page was shared with you in Jira"}],"confluence-reminder.cta.button":[{"type":0,"value":"Accept invite"}],"confluence-reminder.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"confluence-reminder.email.subject":[{"type":0,"value":"Reminder: "},{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to collaborate in Confluence"}],"confluence-reminder.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"confluence-reminder.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"confluence-reminder.inviter.avatar.alt":[{"type":0,"value":"Profile photo of "},{"type":1,"value":"inviterName"}],"confluence-reminder.main.heading":[{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to join Confluence"}],"confluence-reminder.product.description":[{"type":0,"value":"Plan projects, run meetings, and brainstorm ideas with your team\u2014all in one place."}],"confluence-reminder.redacted.heading":[{"type":0,"value":"Reminder: Join your team in Confluence"}],"confluence-reminder.redacted.subject":[{"type":0,"value":"Reminder: Join your team in Confluence"}],"confluence-reminder.social-proof.text":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":" customers use "},{"type":1,"value":"productName"},{"type":0,"value":" to move work forward"}],"confluence.fastAndSnappy.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.fastAndSnappy.survey.score-subtext.neutral":[{"type":0,"value":"Neutral"}],"confluence.fastAndSnappy.survey.score-subtext.strongly-agree":[{"type":0,"value":"Strongly agree"}],"confluence.fastAndSnappy.survey.score-subtext.strongly-disagree":[{"type":0,"value":"Strongly disagree"}],"confluence.fastAndSnappy.survey.statement":[{"type":0,"value":"Confluence feels fast and snappy."}],"confluence.lovability.survey.new-question":[{"type":0,"value":"How much do you love using Confluence?"}],"confluence.lovability.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.lovability.survey.score-subtext.neutral":[{"type":0,"value":"Neutral"}],"confluence.lovability.survey.score-subtext.not-at-all":[{"type":0,"value":"Not at all"}],"confluence.lovability.survey.score-subtext.very-much":[{"type":0,"value":"Very much"}],"confluence.lovability.survey.statement":[{"type":0,"value":"Confluence is a product I love using."}],"post-office-team.confluence-reactivate-inactive-link-paste-in-jira-email.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.body":[{"type":0,"value":"We\'ve prioritized your agenda today so you don\'t have to."}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.cta":[{"type":0,"value":"Review brief"}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.headline":[{"type":0,"value":"Your Daily Brief - "},{"type":1,"value":"briefDate"}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.spotlight.prompt":[{"type":0,"value":"Give me my daily brief"}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.spotlight.title":[{"type":0,"value":"Daily brief for "},{"type":1,"value":"briefDate"}],"post-office.confluence-connect-3p-tools-nudge.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-connect-3p-tools-nudge.heading":[{"type":0,"value":"See more at a glance"}],"post-office.confluence-connect-3p-tools-nudge.modal.close":[{"type":0,"value":"Close"}],"post-office.confluence-connect-3p-tools-nudge.modal.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-connect-3p-tools-nudge.modal.subtitle":[{"children":[{"type":0,"value":"Bring your team\u2019s work"}],"type":8,"value":"strong"},{"type":0,"value":" into Confluence pages with rich, interactive previews \u2013 no tab-switching needed."}],"post-office.confluence-connect-3p-tools-nudge.modal.teammates.empty":[{"type":0,"value":"Teams stay in sync by seeing live updates directly in Confluence."}],"post-office.confluence-connect-3p-tools-nudge.modal.teammates.few":[{"type":0,"value":"Your team is already using "},{"type":1,"value":"appName"},{"type":0,"value":" to work smarter."}],"post-office.confluence-connect-3p-tools-nudge.modal.teammates.lots":[{"type":0,"value":"\uD83D\uDE4C "},{"children":[{"type":0,"value":"50+ teammates"}],"type":8,"value":"strong"},{"type":0,"value":" already connected "},{"type":1,"value":"appName"},{"type":0,"value":" to Confluence."}],"post-office.confluence-connect-3p-tools-nudge.modal.teammates.many":[{"type":0,"value":"\uD83D\uDE4C "},{"children":[{"type":1,"value":"numTeammates"},{"type":0,"value":" teammates"}],"type":8,"value":"strong"},{"type":0,"value":" already connected "},{"type":1,"value":"appName"},{"type":0,"value":" to Confluence."}],"post-office.confluence-connect-3p-tools-nudge.modal.title":[{"type":0,"value":"Connect your most-used apps"}],"post-office.confluence-connect-3p-tools-nudge.multi-app-body":[{"type":0,"value":"Connect your apps to embed rich links in this space."}],"post-office.confluence-connect-3p-tools-nudge.multi-app.call.to.action":[{"type":0,"value":"Connect apps"}],"post-office.confluence-connect-3p-tools-nudge.single-app-body":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" to embed rich links in this space."}],"post-office.confluence-connect-3p-tools-nudge.single-app.call.to.action":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}]}');

});

parcelRegister("2v1Kp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fTlnP").then(()=>parcelRequire('3Yhb9'));

});

parcelRegister("bg3Fa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9kUYc").then(()=>parcelRequire('eFU4t'));

});

parcelRegister("3IAw9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fsXPb").then(()=>parcelRequire('5XOqe'));

});

parcelRegister("bZUfx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fKWic").then(()=>parcelRequire('iI0M3'));

});

parcelRegister("hr2Mk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8cjHN").then(()=>parcelRequire('iAX1N'));

});

parcelRegister("5KC1x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5z0xW").then(()=>parcelRequire('cYLhx'));

});

parcelRegister("h2wUP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1DL5t").then(()=>parcelRequire('7WZql'));

});

parcelRegister("85utK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cAzXW").then(()=>parcelRequire('9LbI8'));

});

parcelRegister("aMFkq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("VETie").then(()=>parcelRequire('fjd1x'));

});

parcelRegister("8WVSb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aj0WB").then(()=>parcelRequire('befWt'));

});

parcelRegister("1kywi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7SrFb").then(()=>parcelRequire('kphLc'));

});

parcelRegister("4ZpYd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3LEcm").then(()=>parcelRequire('3s0RN'));

});

parcelRegister("hAUUU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aFyMo").then(()=>parcelRequire('2teBx'));

});

parcelRegister("kPABm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kEeEN").then(()=>parcelRequire('giqmu'));

});

parcelRegister("kfkjn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kicR9").then(()=>parcelRequire('acf7A'));

});

parcelRegister("kVdln", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1shpC").then(()=>parcelRequire('dYZnR'));

});

parcelRegister("43LVC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3gXnQ").then(()=>parcelRequire('iEGIy'));

});

parcelRegister("eKti2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bftYz").then(()=>parcelRequire('cm6XY'));

});

parcelRegister("iKgNA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1h8I0").then(()=>parcelRequire('7giMu'));

});

parcelRegister("807o6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lRgc9").then(()=>parcelRequire('ltT8t'));

});

parcelRegister("383ko", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jjoRw").then(()=>parcelRequire('2VaKb'));

});

parcelRegister("5zY5r", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hv6aC").then(()=>parcelRequire('fQugi'));

});

parcelRegister("aAQ09", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lcgKU").then(()=>parcelRequire('9QK77'));

});

parcelRegister("h1UDg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("guYJf").then(()=>parcelRequire('fg0jc'));

});

parcelRegister("cX5H8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3jRT1").then(()=>parcelRequire('5nwa8'));

});

parcelRegister("9pcYj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iJf43").then(()=>parcelRequire('gPn61'));

});

parcelRegister("8lhat", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3Xqx8").then(()=>parcelRequire('7h6Yf'));

});

parcelRegister("loGL2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hdDvj").then(()=>parcelRequire('iqE5c'));

});

parcelRegister("aXy42", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3xZxt").then(()=>parcelRequire('bo7qU'));

});

parcelRegister("bBcOs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fdh1L").then(()=>parcelRequire('hKTCC'));

});

parcelRegister("5NFhV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3nAXg").then(()=>parcelRequire('f0Od8'));

});

parcelRegister("21y2k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3fSXU").then(()=>parcelRequire('i8cbC'));

});

parcelRegister("e0uBY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ZACU").then(()=>parcelRequire('3PqYh'));

});

parcelRegister("ehXRD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9aHMp").then(()=>parcelRequire('4ijxi'));

});


parcelRegister("hx0aP", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $2d739d2ccfac85d9$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $gCp12 = parcelRequire("gCp12");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d739d2ccfac85d9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2d739d2ccfac85d9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("gxNwe")));
        case 'da':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("2TmMI")));
        case 'de':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("1kFgP")));
        case 'en-GB':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("6y0dA")));
        case 'en-US':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("2L308")));
        case 'en-XA':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("hISVV")));
        case 'en-XB':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("1PTuR")));
        case 'en-ZZ':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("14Mhk")));
        case 'en':
            return $2d739d2ccfac85d9$var$importHelper(await Promise.resolve((parcelRequire("gCp12"))));
        case 'es':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("llyWx")));
        case 'et':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("gxjBA")));
        case 'fi':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("j8PcL")));
        case 'fr':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("hAWtZ")));
        case 'hr':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("hyQfh")));
        case 'hu':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("kqTgE")));
        case 'it':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("8MFsx")));
        case 'ja':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("jK2SX")));
        case 'ko':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("9ifG4")));
        case 'nb':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("ivIEY")));
        case 'nl':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("bUOgm")));
        case 'pl':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("65YKe")));
        case 'pt-BR':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("dTtPB")));
        case 'ro':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("ikSDX")));
        case 'ru':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("7qWLU")));
        case 'sl':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("kcUjX")));
        case 'sr-RS':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("3VfJ2")));
        case 'sr-YR':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("2kFQo")));
        case 'sr':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("ckb4Q")));
        case 'sv':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("8GbaV")));
        case 'th':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("2wZVt")));
        case 'tr':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("9U2SB")));
        case 'uk':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("gmS1k")));
        case 'vi':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("9AewK")));
        case 'zh-CN':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("hHKhY")));
        case 'zh-TW':
            return $2d739d2ccfac85d9$var$importHelper(await (parcelRequire("8CFmP")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($gCp12));
    }
};

});
parcelRegister("gCp12", function(module, exports) {
module.exports = JSON.parse('{"growth-confluence-find.confluence-d1d6-back-to-product-email.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.header":[{"type":0,"value":"Confluence is better "},{"type":1,"value":"lineBreak"},{"type":0,"value":" when the team\u2019s all in"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Your team\u2019s waiting for your great ideas!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Jump back into Confluence and start collaborating today"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Click "},{"children":[{"type":0,"value":"Share"}],"type":8,"value":"b"},{"type":0,"value":" in Confluence to copy a link you can send in email, Slack or MS Teams"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Link content to teammates"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Give feedback on docs in progress, and @mention teammates to keep everyone in the loop"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Comment in pages"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Align on the best path forward by voting on ideas as a team in whiteboards"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Vote in whiteboards"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-header":[{"type":0,"value":"How to use Confluence "},{"type":1,"value":"lineBreak"},{"type":0,"value":" with your team:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.subtext":[{"type":0,"value":"You\u2019re creating awesome ideas in Confluence, "},{"type":1,"value":"firstName"},{"type":0,"value":". It\u2019s "},{"type":1,"value":"lineBreak"},{"type":0,"value":" time to share them with your team!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83D\uDC4F Your ideas deserve an audience, "},{"type":1,"value":"firstName"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.header":[{"type":0,"value":"Get your ideas"},{"type":1,"value":"lineBreak"},{"type":0,"value":"on \u201Cpaper\u201D, "},{"type":1,"value":"firstName"},{"type":0,"value":"!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Ready to jump back in?"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Go back to Confluence today to start doing your team\u2019s best work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Jot down & organize your ideas with sleek editor tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Start with a page"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"@mention someone to show them what you\u2019re working on"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Brainstorm with teammates"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Connect Slack, Microsoft, or Google to keep the whole team in sync"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Connect your tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Easy ways to get setup:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.subtext":[{"type":0,"value":"It only takes a minute to wrap up your Confluence setup. Jump back in now to start unleashing your team\u2019s knowledge."}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83D\uDC4B Almost there\u2014need help setting up Confluence?"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.header":[{"type":0,"value":"It\u2019s time to make your space, more spacious"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Create a space everyone will rave about!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Create, organize & share to get the team\u2019s ideas all out there"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Simply drag items around in the left-hand sidebar & click + to create something new to your space"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Drag, drop & create in context"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Add folders to create directories where everything\u2019s stored. You can even convert pages to folders in the ... menu."}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Pop it into a folder"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Create "},{"children":[{"type":0,"value":"smart links"}],"type":8,"value":"b"},{"type":0,"value":" to auto-pull content into Confluence from other tools your team already uses, like Google Docs or MS Excel"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Link from your favorite tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Tips for building out your team\u2019s space:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.subtext":[{"type":0,"value":"Your "},{"children":[{"type":0,"value":"space"}],"type":8,"value":"b"},{"type":0,"value":" is like a hub for your team\u2019s docs & resources. "},{"type":1,"value":"lineBreak"},{"type":0,"value":"Create more and organize it all in your space today!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83E\uDD29 Impressive work you\u2019ve got there, "},{"type":1,"value":"firstName"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.header":[{"type":0,"value":"Take your team\u2019s knowledge"},{"type":1,"value":"lineBreak"},{"type":0,"value":" to the next level"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Go ahead - unleash your team\u2019s knowledge!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Speed up teamwork by building out your knowledge hub today"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Organize work for specific teams, projects and workstreams in separate spaces to create specialized knowledge repos"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"More spaces = more knowledge sources"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Rovo Search helps any team instantly find the info they need in Confluence, Slack, MS Office, and more!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Search across spaces & tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Need to make a page or presentation with info from multiple sources? Ask Rovo Chat to pull in knowledge from anywhere and auto-create it for you in a snap!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Just ask Rovo"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Try out the knowledge hub basics:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.subtext":[{"type":0,"value":"Creating new spaces with even more Confluence content helps "},{"type":1,"value":"lineBreak"},{"type":0,"value":"unlock knowledge across every team!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83E\uDDD9 Did you know? A knowledge hub makes work easier"}],"growth-confluence-find.message-templates.confluence-notification-drawer-getting-started-nth-user.welcome-to-confluence":[{"type":0,"value":"Welcome to Confluence, "},{"type":1,"value":"name"},{"type":0,"value":"! Learn how to create your first doc."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.atlassian-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-ideas":[{"type":0,"value":"Capture your ideas as a team in pages, whiteboards, and more today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-thoughts":[{"type":0,"value":"Capture your thoughts and ideas on docs and whiteboards."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.collaborate-with-your-new-teammate":[{"type":0,"value":"Collaborate with your new teammate on your next big idea today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.confluence-is":[{"children":[{"type":0,"value":"Confluence is a collaborative workspace"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers create and organize knowledge with their team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.copy-shareable-link":[{"type":1,"value":"copyIcon"},{"type":0,"value":" Copy shareable link"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.create-with-a-template":[{"type":0,"value":"Create with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-started-at-lightning-speed":[{"type":0,"value":"\u26A1 Get started at lightning speed with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-your-ideas-on-paper":[{"type":0,"value":"Get your ideas on \\"paper\\" with pages, whiteboards, and more in Confluence today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-job-adding":[{"type":0,"value":"Great job adding your work to your Confluence space!"},{"children":[],"type":8,"value":"br"},{"type":0,"value":"Invite a teammate to get feedback on it today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-momentum":[{"type":0,"value":"Great momentum, "},{"type":1,"value":"name"},{"type":0,"value":"! Keep it going with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-work":[{"type":0,"value":"\uD83E\uDD29 Great work\u2014Your space deserves an audience"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-teammates":[{"type":0,"value":"Invite teammates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-your-teammates":[{"type":0,"value":"Invite your teammates to collaborate and align on ideas quickly."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.jump-back-in":[{"type":0,"value":"Jump back in"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.kick-off-collaboration":[{"type":0,"value":"Kick off collaboration with your new teammate, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited":[{"type":0,"value":"Last edited "},{"type":1,"value":"relativeTime"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortJustNow":[{"type":0,"value":"just now"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXDaysAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"d ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXHoursAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"h ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXMinutesAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"m ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.lets-create-your-next":[{"type":0,"value":"Let\'s create your next big idea, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.nows-the-time":[{"type":0,"value":"\u23F0 Now\'s the time to create something great as a team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.one-new-teammate":[{"type":0,"value":"1 new teammate joined your Confluence space. Capture your next big idea with them in pages, whiteboards, and more today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.save-time-with":[{"type":0,"value":"Save time with these templates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.share-your-work":[{"type":0,"value":"Share your work with the team, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.space":[{"type":1,"value":"spaceName"},{"type":0,"value":" space"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.start-creating-fast":[{"type":0,"value":"Start creating fast with templates recommended for your team."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.team":[{"type":0,"value":"Team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.90-day-plan":[{"type":0,"value":"90-day plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.all-hands-meeting":[{"type":0,"value":"All hands meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.annual-plan-one-pager":[{"type":0,"value":"Annual plan one-pager"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.aws-architecture-diagram":[{"type":0,"value":"AWS architecture diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-plan-one-pager":[{"type":0,"value":"Business plan one-pager"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-status-update":[{"type":0,"value":"Business status update"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.career-development-plan":[{"type":0,"value":"Career development plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.competitive-analysis":[{"type":0,"value":"Competitive analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-design-glossary":[{"type":0,"value":"Content design glossary"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-strategy":[{"type":0,"value":"Content strategy"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-impact-assessment":[{"type":0,"value":"Customer impact assessment"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-interview-report":[{"type":0,"value":"Customer interview report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.daci-decision-documentation":[{"type":0,"value":"DACI: decision documentation"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-decision":[{"type":0,"value":"Design decision"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-review":[{"type":0,"value":"Design review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-sprint":[{"type":0,"value":"Design sprint"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-systems":[{"type":0,"value":"Design systems"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.devops-runbook":[{"type":0,"value":"DevOps runbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.disruptive-brainstorming":[{"type":0,"value":"Disruptive brainstorming"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.employee-handbook":[{"type":0,"value":"Employee handbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.end-of-week-status-report":[{"type":0,"value":"End of week status report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.executive-business-review":[{"type":0,"value":"Executive business review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hiring-process":[{"type":0,"value":"Hiring process"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.how-to-article":[{"type":0,"value":"How-to article"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hr-knowledge-base-management":[{"type":0,"value":"HR knowledge base management"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-communication":[{"type":0,"value":"Incident communication"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-postmortem":[{"type":0,"value":"Incident postmortem"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-change-management":[{"type":0,"value":"ITSM change management"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-known-errors":[{"type":0,"value":"ITSM known errors"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-post-incident-reviews":[{"type":0,"value":"ITSM post incident reviews"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-runbook":[{"type":0,"value":"ITSM runbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-weekly-major-incident-report":[{"type":0,"value":"ITSM weekly major incident report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.job-description":[{"type":0,"value":"Job description"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-performance-review":[{"type":0,"value":"Lenny\'s performance review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-product-requirements":[{"type":0,"value":"Lenny\'s product requirements"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-blog-post":[{"type":0,"value":"Marketing blog post"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-campaign":[{"type":0,"value":"Marketing campaign"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-plan":[{"type":0,"value":"Marketing plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.meeting-notes":[{"type":0,"value":"Meeting notes"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.message-house":[{"type":0,"value":"Message house"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.mutual-action-plan":[{"type":0,"value":"Mutual action plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.okrs":[{"type":0,"value":"OKRs"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.persona":[{"type":0,"value":"Persona"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.presenter-mode":[{"type":0,"value":"Presenter mode"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-requirements":[{"type":0,"value":"Product requirements"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-roadmap":[{"type":0,"value":"Product roadmap"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-kickoff":[{"type":0,"value":"Project kickoff"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-plan":[{"type":0,"value":"Project plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-status":[{"type":0,"value":"Project status"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-timeline-template":[{"type":0,"value":"Project timeline"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.qtc-acquisition":[{"type":0,"value":"QTC acquisition"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.quarterly-check-in":[{"type":0,"value":"Quarterly check in"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.remote-team-meeting":[{"type":0,"value":"Remote team meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.risk-assessment-matrix":[{"type":0,"value":"Risk assessment matrix"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.roles-and-responsibilities-play":[{"type":0,"value":"Roles and responsibilities play"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-account-planning":[{"type":0,"value":"Sales account planning"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-portal":[{"type":0,"value":"Sales portal"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.service-team-health-monitor":[{"type":0,"value":"Service team health monitor"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.smart-goals":[{"type":0,"value":"SMART goals"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.software-architecture-review":[{"type":0,"value":"Software architecture review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sprint-planning-meeting":[{"type":0,"value":"Sprint planning meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.stakeholder-communications":[{"type":0,"value":"Stakeholder communications"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.standard-operating-procedure":[{"type":0,"value":"Standard operating procedure (SOP)"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.strategic-plan":[{"type":0,"value":"Strategic plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.swot-analysis":[{"type":0,"value":"SWOT analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-homepage":[{"type":0,"value":"Team homepage"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-poster":[{"type":0,"value":"Team poster"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.to-do-list":[{"type":0,"value":"To-do list"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.troubleshooting-article":[{"type":0,"value":"Troubleshooting article"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vendor-agreement":[{"type":0,"value":"Vendor agreement"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.virtual-event":[{"type":0,"value":"Virtual event"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vision-to-values":[{"type":0,"value":"Vision to values"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.weekly-meeting-notes":[{"type":0,"value":"Weekly meeting notes"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.work-trip-planner":[{"type":0,"value":"Work trip planner"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.workshop-planner":[{"type":0,"value":"Workshop planner"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.writing-guidelines":[{"type":0,"value":"Writing guidelines"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.use-template":[{"type":0,"value":"Use template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-starting":[{"type":0,"value":"We recommend starting with these templates for your team:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-these-templates":[{"type":0,"value":"We recommend these templates for your team:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.4ls-retro":[{"type":0,"value":"4 Ls Retro"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.action-plan":[{"type":0,"value":"Action plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.annual-calendar-2025-2026":[{"type":0,"value":"Annual Calendar"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.brainwriting":[{"type":0,"value":"Brainwriting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.concept-map":[{"type":0,"value":"Concept map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.crazy-8s":[{"type":0,"value":"Crazy 8s brainstorming"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.disruptive-brainstorm":[{"type":0,"value":"Disruptive brainstorm"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.elevator-pitch":[{"type":0,"value":"Elevator pitch"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.executive-summary":[{"type":0,"value":"Executive summary"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.fishbone-diagram":[{"type":0,"value":"Fishbone diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.flow-chart":[{"type":0,"value":"Flowchart"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.focus-area-diagram":[{"type":0,"value":"Focus area diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.gap-analysis":[{"type":0,"value":"Gap analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.health-monitor":[{"type":0,"value":"Team health monitor"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.ice-breakers":[{"type":0,"value":"Icebreakers"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.incident-postmortem":[{"type":0,"value":"Incident postmortem"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.network-of-teams":[{"type":0,"value":"Network of teams"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.org-chart":[{"type":0,"value":"Org chart"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.prioritization":[{"type":0,"value":"Prioritization matrix"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-roadmap":[{"type":0,"value":"Product roadmap"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-vision-board":[{"type":0,"value":"Product vision board"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.root-cause-analysis":[{"type":0,"value":"Root cause analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.service-blueprint":[{"type":0,"value":"Service blueprint"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.simple-retrospective":[{"type":0,"value":"Simple retrospective"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.stakeholder-mapping":[{"type":0,"value":"Stakeholder mapping"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swimlanes":[{"type":0,"value":"Swimlanes process map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swot-analysis":[{"type":0,"value":"SWOT Analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.team-formation-guide":[{"type":0,"value":"Team charter template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.timeline-workflow":[{"type":0,"value":"Timeline workflow"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.user-story-map":[{"type":0,"value":"User story map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.workflow":[{"type":0,"value":"Workflow"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.youre-off-to-a-great-start":[{"type":0,"value":"\uD83D\uDE80 You\'re off to a great start\u2014Let\'s start creating"}],"post-office.growth-confluence-find.connect-tools-spotlight.body":[{"type":0,"value":"Connect your team\'s most used apps to get better answers and more results across Search and Chat."}],"post-office.growth-confluence-find.connect-tools-spotlight.headline":[{"type":0,"value":"Search across tools"}],"post-office.growth-confluence-find.connect-tools-spotlight.primary-action":[{"type":0,"value":"Setup"}]}');

});

parcelRegister("gxNwe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3tnS7").then(()=>parcelRequire('fKORS'));

});

parcelRegister("2TmMI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k4YMp").then(()=>parcelRequire('gLZgl'));

});

parcelRegister("1kFgP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lc0PU").then(()=>parcelRequire('jDqFX'));

});

parcelRegister("6y0dA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9dK1T").then(()=>parcelRequire('jRSR4'));

});

parcelRegister("2L308", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9IRXu").then(()=>parcelRequire('g8YCm'));

});

parcelRegister("hISVV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ctN4A").then(()=>parcelRequire('2USDk'));

});

parcelRegister("1PTuR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8pn9P").then(()=>parcelRequire('13eh5'));

});

parcelRegister("14Mhk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Abmp").then(()=>parcelRequire('d4Dkj'));

});

parcelRegister("llyWx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eU8us").then(()=>parcelRequire('lX3SI'));

});

parcelRegister("gxjBA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("BjU8T").then(()=>parcelRequire('bPcBF'));

});

parcelRegister("j8PcL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ghj0p").then(()=>parcelRequire('E9ibd'));

});

parcelRegister("hAWtZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1MSJz").then(()=>parcelRequire('5HNNH'));

});

parcelRegister("hyQfh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gAVaY").then(()=>parcelRequire('bFhVF'));

});

parcelRegister("kqTgE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kdaNK").then(()=>parcelRequire('5VXGu'));

});

parcelRegister("8MFsx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fPvfI").then(()=>parcelRequire('giLbj'));

});

parcelRegister("jK2SX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2iIEW").then(()=>parcelRequire('cPKye'));

});

parcelRegister("9ifG4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ecyKQ").then(()=>parcelRequire('l7Rtj'));

});

parcelRegister("ivIEY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4pn1R").then(()=>parcelRequire('h36zg'));

});

parcelRegister("bUOgm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c7aAM").then(()=>parcelRequire('1G3e8'));

});

parcelRegister("65YKe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lkNil").then(()=>parcelRequire('fk017'));

});

parcelRegister("dTtPB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9MhWX").then(()=>parcelRequire('6qrk0'));

});

parcelRegister("ikSDX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dQV28").then(()=>parcelRequire('lirdm'));

});

parcelRegister("7qWLU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kQ3m8").then(()=>parcelRequire('6nmK1'));

});

parcelRegister("kcUjX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jH4Lv").then(()=>parcelRequire('ck9Sy'));

});

parcelRegister("3VfJ2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aaKEh").then(()=>parcelRequire('3anuM'));

});

parcelRegister("2kFQo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4770Y").then(()=>parcelRequire('gZYSZ'));

});

parcelRegister("ckb4Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hGnds").then(()=>parcelRequire('gFu1j'));

});

parcelRegister("8GbaV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9wgtI").then(()=>parcelRequire('aWq29'));

});

parcelRegister("2wZVt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Sec5").then(()=>parcelRequire('9UIl1'));

});

parcelRegister("9U2SB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3azvE").then(()=>parcelRequire('eRJBE'));

});

parcelRegister("gmS1k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bgOwW").then(()=>parcelRequire('hs9M5'));

});

parcelRegister("9AewK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4I73l").then(()=>parcelRequire('fFpKA'));

});

parcelRegister("hHKhY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9zm3s").then(()=>parcelRequire('hQOZX'));

});

parcelRegister("8CFmP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("71ckS").then(()=>parcelRequire('9iC87'));

});


parcelRegister("5AwYx", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $07d8c20a24b082d5$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $CA8xK = parcelRequire("CA8xK");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $07d8c20a24b082d5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $07d8c20a24b082d5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("8sTC4")));
        case 'da':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("2kKYi")));
        case 'de':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("jHvsm")));
        case 'en-GB':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("h5Se2")));
        case 'en-US':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("8jptM")));
        case 'en-XA':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("6atvp")));
        case 'en-XB':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("aHpRn")));
        case 'en-ZZ':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("4QSOS")));
        case 'en':
            return $07d8c20a24b082d5$var$importHelper(await Promise.resolve((parcelRequire("CA8xK"))));
        case 'es':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("9OEaO")));
        case 'et':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("d7pDH")));
        case 'fi':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("eOTDM")));
        case 'fr':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("40Pbt")));
        case 'hr':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("4Zgoj")));
        case 'hu':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("2mW0x")));
        case 'it':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("KXAIC")));
        case 'ja':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("85iju")));
        case 'ko':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("8nGwL")));
        case 'nb':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("U9N7K")));
        case 'nl':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("gXOg1")));
        case 'pl':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("jFvSS")));
        case 'pt-BR':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("bqQsN")));
        case 'ro':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("aS2Q1")));
        case 'ru':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("e7rI5")));
        case 'sl':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("iCSEo")));
        case 'sr-RS':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("eUzO1")));
        case 'sr-YR':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("7bF3N")));
        case 'sr':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("6mCgu")));
        case 'sv':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("kK4Kx")));
        case 'th':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("lC3YU")));
        case 'tr':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("D9rJf")));
        case 'uk':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("1hT6L")));
        case 'vi':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("5JtMp")));
        case 'zh-CN':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("hvmIK")));
        case 'zh-TW':
            return $07d8c20a24b082d5$var$importHelper(await (parcelRequire("5CCNv")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($CA8xK));
    }
};

});
parcelRegister("CA8xK", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-feature-discovery.rovo-awareness-survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"cc-flywheel-feature-discovery.rovo-awareness-survey.statement":[{"type":0,"value":"I\'m aware of Atlassian Rovo and its functionalities."}],"confluence-home-rovo-awareness.banner.ask-anything-cta":[{"type":0,"value":"Ask Rovo"}],"confluence-home-rovo-awareness.banner.description":[{"type":0,"value":"Let your AI teammate do the heavy lifting so you can focus on what matters. Just ask."}],"confluence-home-rovo-awareness.banner.dismiss-banner-cta":[{"type":0,"value":"Close banner"}],"confluence-home-rovo-awareness.banner.header":[{"type":0,"value":"Ask Rovo to get you up to speed, create automations, brainstorm ideas, and more."}],"confluence-home-rovo-awareness.banner.more-ideas-cta":[{"type":0,"value":"More ideas"}],"confluence-home-rovo-awareness.banner.search-bar-image-text":[{"type":0,"value":"If you Rovo, you know..."}],"confluence-home-rovo-awareness.carousel-modal.audio-description":[{"type":0,"value":"Rovo\u2032s audio briefings can fill you in on key information from your team.Just hit play and go for a walk."}],"confluence-home-rovo-awareness.carousel-modal.audio-title":[{"type":0,"value":"Get briefed on the go"}],"confluence-home-rovo-awareness.carousel-modal.carousel-image-alt":[{"type":0,"value":"New Feature"}],"confluence-home-rovo-awareness.carousel-modal.create-description":[{"type":0,"value":"You describe, Rovo creates. Pages, live docs, whiteboards, databases \u2014 Rovo does it all."}],"confluence-home-rovo-awareness.carousel-modal.create-title":[{"type":0,"value":"Bye-bye blank page"}],"confluence-home-rovo-awareness.carousel-modal.description":[{"type":0,"value":"Discover how you can use Rovo to make your life easier."}],"confluence-home-rovo-awareness.carousel-modal.diagram-description":[{"type":0,"value":"Rovo can draw the diagrams for you that clearly communicate your ideas."}],"confluence-home-rovo-awareness.carousel-modal.diagram-title":[{"type":0,"value":"Let flow charts flow"}],"confluence-home-rovo-awareness.carousel-modal.lozenge-coming-soon":[{"type":0,"value":"Coming soon"}],"confluence-home-rovo-awareness.carousel-modal.lozenge-new":[{"type":0,"value":"New"}],"confluence-home-rovo-awareness.carousel-modal.next-label":[{"type":0,"value":"Next"}],"confluence-home-rovo-awareness.carousel-modal.previous-label":[{"type":0,"value":"Previous"}],"confluence-home-rovo-awareness.carousel-modal.title":[{"type":0,"value":"More ways to Rovo"}],"post-office.confluence-create-with-rovo-side-nav-nudge.body":[{"type":0,"value":"With a simple prompt, Rovo can draft a page or whiteboard."}],"post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action":[{"type":0,"value":"Show me how"}],"post-office.confluence-create-with-rovo-side-nav-nudge.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-create-with-rovo-side-nav-nudge.heading":[{"type":0,"value":"You describe, Rovo creates"}],"post-office.confluence-maui-changeboarding.remix.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-changeboarding.remix.spotlight-header":[{"type":0,"value":"Transform your content"}],"post-office.confluence-maui-changeboarding.remix.spotlight-image-alt":[{"type":0,"value":"Remix content illustration"}],"post-office.confluence-maui-changeboarding.remix.spotlight-new-description":[{"type":0,"value":"Create charts, diagrams, and other content inspired by existing work."}],"post-office.confluence-maui-changeboarding.remix.spotlight-new-header":[{"type":0,"value":"Create custom visuals"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-done-button":[{"type":0,"value":"Done"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-next-button":[{"type":0,"value":"Next"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-1-description":[{"type":0,"value":"Ask Rovo to make adjustments to your remix."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-1-header":[{"type":0,"value":"Refine with Rovo"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-copy-description":[{"type":0,"value":"Then paste it somewhere else in Confluence to view it later."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-copy-header":[{"type":0,"value":"Copy this remix"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-insert-description":[{"type":0,"value":"Add your remix directly to this content, or copy and paste it somewhere else."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-insert-header":[{"type":0,"value":"Insert this remix"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-description":[{"type":0,"value":"Turn rough ideas and existing content into polished slides in seconds."}],"post-office.confluence-maui-slides-create-spotlight.spotlight-header":[{"type":0,"value":"Create stunning presentations"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-image-alt":[{"type":0,"value":"Create slides illustration"}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-description":[{"type":0,"value":"Use Rovo to add or remove slides, edit sections, change the tone, and more."}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-header":[{"type":0,"value":"Refine slides with Rovo"}],"post-office.confluence-maui-slides-modal.description":[{"type":0,"value":"Create polished presentations with Rovo."}],"post-office.confluence-maui-slides-modal.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-maui-slides-modal.feature-add-sources":[{"type":0,"value":"Add sources or links for context"}],"post-office.confluence-maui-slides-modal.feature-describe-presentation":[{"type":0,"value":"Start by describing your ideal presentation"}],"post-office.confluence-maui-slides-modal.feature-refine-slides":[{"type":0,"value":"Refine your slides with Rovo"}],"post-office.confluence-maui-slides-modal.got-it":[{"type":0,"value":"Got it"}],"post-office.confluence-maui-slides-modal.media-alt":[{"type":0,"value":"Slides feature illustration"}],"post-office.confluence-maui-slides-modal.title":[{"type":0,"value":"Welcome to Slides"}],"post-office.confluence-maui-slides-modal.try-it-out":[{"type":0,"value":"Create my own"}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-description":[{"type":0,"value":"Ask Rovo to rewrite, adjust tone, shorten or lengthen text, or apply other changes."}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-header":[{"type":0,"value":"Make edits with Rovo"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-description":[{"type":0,"value":"Transform content into slides, infographics, whiteboards, and more."}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-header":[{"type":0,"value":"Remix this content"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-image-alt":[{"type":0,"value":"Remix content illustration"}]}');

});

parcelRegister("8sTC4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eWutQ").then(()=>parcelRequire('3ghQm'));

});

parcelRegister("2kKYi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2ENmM").then(()=>parcelRequire('7xFCs'));

});

parcelRegister("jHvsm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5inwV").then(()=>parcelRequire('crqxQ'));

});

parcelRegister("h5Se2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bIXz1").then(()=>parcelRequire('lrijZ'));

});

parcelRegister("8jptM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cbDMz").then(()=>parcelRequire('f6ATu'));

});

parcelRegister("6atvp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cufDK").then(()=>parcelRequire('8Cp3T'));

});

parcelRegister("aHpRn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fgTvS").then(()=>parcelRequire('juJ8a'));

});

parcelRegister("4QSOS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8zWAV").then(()=>parcelRequire('cas3O'));

});

parcelRegister("9OEaO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("46D4E").then(()=>parcelRequire('6XrAb'));

});

parcelRegister("d7pDH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kLxeP").then(()=>parcelRequire('6hYTO'));

});

parcelRegister("eOTDM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ka1HO").then(()=>parcelRequire('8TCOV'));

});

parcelRegister("40Pbt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3I1XU").then(()=>parcelRequire('cIX0o'));

});

parcelRegister("4Zgoj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7pgUW").then(()=>parcelRequire('3fihO'));

});

parcelRegister("2mW0x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8kkYN").then(()=>parcelRequire('dD1aC'));

});

parcelRegister("KXAIC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j0Ye9").then(()=>parcelRequire('dFqmu'));

});

parcelRegister("85iju", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9TMjG").then(()=>parcelRequire('ls09c'));

});

parcelRegister("8nGwL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fb4d4").then(()=>parcelRequire('jl5b2'));

});

parcelRegister("U9N7K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f7tK3").then(()=>parcelRequire('97WuI'));

});

parcelRegister("gXOg1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Wlwi").then(()=>parcelRequire('czrIW'));

});

parcelRegister("jFvSS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("66SWQ").then(()=>parcelRequire('am8fp'));

});

parcelRegister("bqQsN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("adgd7").then(()=>parcelRequire('7S3KC'));

});

parcelRegister("aS2Q1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5dNPe").then(()=>parcelRequire('jo3qn'));

});

parcelRegister("e7rI5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l1cmA").then(()=>parcelRequire('3jjo0'));

});

parcelRegister("iCSEo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aXTj5").then(()=>parcelRequire('ihhzL'));

});

parcelRegister("eUzO1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("28Zxx").then(()=>parcelRequire('2f0dv'));

});

parcelRegister("7bF3N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9OZpi").then(()=>parcelRequire('QzDaj'));

});

parcelRegister("6mCgu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h9cpI").then(()=>parcelRequire('jk4qN'));

});

parcelRegister("kK4Kx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("02871").then(()=>parcelRequire('4VHNV'));

});

parcelRegister("lC3YU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5O04i").then(()=>parcelRequire('7KDTO'));

});

parcelRegister("D9rJf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cuCJZ").then(()=>parcelRequire('7b1pf'));

});

parcelRegister("1hT6L", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Rj7r").then(()=>parcelRequire('16kql'));

});

parcelRegister("5JtMp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9VRtX").then(()=>parcelRequire('havsq'));

});

parcelRegister("hvmIK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5sK8t").then(()=>parcelRequire('8XMIr'));

});

parcelRegister("5CCNv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8c6xY").then(()=>parcelRequire('85BD4'));

});


parcelRegister("jMOP8", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $3282bf050a202ffc$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2SEwN = parcelRequire("2SEwN");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3282bf050a202ffc$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3282bf050a202ffc$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("buY0T")));
        case 'da':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("fQZby")));
        case 'de':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("1BTrU")));
        case 'en-GB':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("bBlJj")));
        case 'en-US':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("cP31k")));
        case 'en-XA':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("bWQyG")));
        case 'en-XB':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("gvGt8")));
        case 'en-ZZ':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("cgcSY")));
        case 'en':
            return $3282bf050a202ffc$var$importHelper(await Promise.resolve((parcelRequire("2SEwN"))));
        case 'es':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("6j43V")));
        case 'et':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("g11Vz")));
        case 'fi':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("5iJ9l")));
        case 'fr':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("2Xk6T")));
        case 'hr':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("5oZBo")));
        case 'hu':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("gbBsj")));
        case 'it':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("6yHNK")));
        case 'ja':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("19u43")));
        case 'ko':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("js0d6")));
        case 'nb':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("6duYn")));
        case 'nl':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("ds55W")));
        case 'pl':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("j8aAE")));
        case 'pt-BR':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("cNxJf")));
        case 'ro':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("3o3HM")));
        case 'ru':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("fSD27")));
        case 'sl':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("j8hoO")));
        case 'sr-RS':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("9nr61")));
        case 'sr-YR':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("dCc2e")));
        case 'sr':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("g4isG")));
        case 'sv':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("ilQli")));
        case 'th':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("4ait8")));
        case 'tr':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("hNdre")));
        case 'uk':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("hehSR")));
        case 'vi':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("e0NoA")));
        case 'zh-CN':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("ccfy8")));
        case 'zh-TW':
            return $3282bf050a202ffc$var$importHelper(await (parcelRequire("dI3Gl")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2SEwN));
    }
};

});
parcelRegister("2SEwN", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("buY0T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("45nNj").then(()=>parcelRequire('1RGdB'));

});

parcelRegister("fQZby", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lWyOA").then(()=>parcelRequire('2TOmy'));

});

parcelRegister("1BTrU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lg7KX").then(()=>parcelRequire('1lxIa'));

});

parcelRegister("bBlJj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hxID1").then(()=>parcelRequire('enKOk'));

});

parcelRegister("cP31k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9mMsa").then(()=>parcelRequire('bx3ZF'));

});

parcelRegister("bWQyG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4COdO").then(()=>parcelRequire('hzy2s'));

});

parcelRegister("gvGt8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dNjDI").then(()=>parcelRequire('fHFbL'));

});

parcelRegister("cgcSY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jt2Ha").then(()=>parcelRequire('dDBEM'));

});

parcelRegister("6j43V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7E5QA").then(()=>parcelRequire('7QI0L'));

});

parcelRegister("g11Vz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("KE2fh").then(()=>parcelRequire('72Llf'));

});

parcelRegister("5iJ9l", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3StX8").then(()=>parcelRequire('bnWjm'));

});

parcelRegister("2Xk6T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7g3bg").then(()=>parcelRequire('caOzr'));

});

parcelRegister("5oZBo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("faIL5").then(()=>parcelRequire('ibFaL'));

});

parcelRegister("gbBsj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gtIDd").then(()=>parcelRequire('wJAMf'));

});

parcelRegister("6yHNK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8OdgQ").then(()=>parcelRequire('1TKSq'));

});

parcelRegister("19u43", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hJ1Df").then(()=>parcelRequire('6sfN4'));

});

parcelRegister("js0d6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5unZX").then(()=>parcelRequire('dOtWd'));

});

parcelRegister("6duYn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gqoeA").then(()=>parcelRequire('dGzAu'));

});

parcelRegister("ds55W", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5hkE6").then(()=>parcelRequire('5GwRP'));

});

parcelRegister("j8aAE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9q3kP").then(()=>parcelRequire('9NoO8'));

});

parcelRegister("cNxJf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fygbn").then(()=>parcelRequire('549wO'));

});

parcelRegister("3o3HM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gj3Jw").then(()=>parcelRequire('39qs0'));

});

parcelRegister("fSD27", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("67u99").then(()=>parcelRequire('iTNCE'));

});

parcelRegister("j8hoO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7ULhj").then(()=>parcelRequire('jz4DK'));

});

parcelRegister("9nr61", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4q0Ua").then(()=>parcelRequire('jsGfy'));

});

parcelRegister("dCc2e", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eueEX").then(()=>parcelRequire('iTdFq'));

});

parcelRegister("g4isG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dU2L9").then(()=>parcelRequire('cCFVC'));

});

parcelRegister("ilQli", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7gbuC").then(()=>parcelRequire('c0yQi'));

});

parcelRegister("4ait8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3vnTj").then(()=>parcelRequire('28Azn'));

});

parcelRegister("hNdre", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9XBaA").then(()=>parcelRequire('6WgMi'));

});

parcelRegister("hehSR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1ZgP8").then(()=>parcelRequire('htAHt'));

});

parcelRegister("e0NoA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kJo5L").then(()=>parcelRequire('1lA8i'));

});

parcelRegister("ccfy8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lOvjs").then(()=>parcelRequire('17Ys0'));

});

parcelRegister("dI3Gl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Hxk3").then(()=>parcelRequire('7MCbA'));

});


parcelRegister("bOBrx", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $85a9653c01c88b9c$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jjhBA = parcelRequire("jjhBA");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $85a9653c01c88b9c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $85a9653c01c88b9c$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("dtPJk")));
        case 'da':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("4kyze")));
        case 'de':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("lhVCX")));
        case 'en-GB':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("2jfuw")));
        case 'en-US':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("7RxGb")));
        case 'en-XA':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("02fhl")));
        case 'en-XB':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("4hKS3")));
        case 'en-ZZ':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("zi3Oy")));
        case 'en':
            return $85a9653c01c88b9c$var$importHelper(await Promise.resolve((parcelRequire("jjhBA"))));
        case 'es':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("gxrae")));
        case 'et':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("V9440")));
        case 'fi':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("dVf4g")));
        case 'fr':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("cnmSa")));
        case 'hr':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("pRQUd")));
        case 'hu':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("lgpZi")));
        case 'it':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("3DsaH")));
        case 'ja':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("7zE9i")));
        case 'ko':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("8l0GV")));
        case 'nb':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("clpjv")));
        case 'nl':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("1kzZp")));
        case 'pl':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("d8a4I")));
        case 'pt-BR':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("ayKtw")));
        case 'ro':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("52Z9d")));
        case 'ru':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("jQ2Mg")));
        case 'sl':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("gmHM4")));
        case 'sr-RS':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("lyjB0")));
        case 'sr-YR':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("d0f6J")));
        case 'sr':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("4QJEv")));
        case 'sv':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("c4TX1")));
        case 'th':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("8qP4x")));
        case 'tr':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("9Mc9V")));
        case 'uk':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("hMbug")));
        case 'vi':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("dtUkR")));
        case 'zh-CN':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("aMCoQ")));
        case 'zh-TW':
            return $85a9653c01c88b9c$var$importHelper(await (parcelRequire("cL0tm")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jjhBA));
    }
};

});
parcelRegister("jjhBA", function(module, exports) {
module.exports = JSON.parse('{"jsm-cbp-grace-period-notification.message.link.extra.objects":[{"type":0,"value":"Get extra objects"}],"jsm-cbp-grace-period-notification.message.link.learn.more":[{"type":0,"value":"Learn more"}],"jsm-cbp-grace-period-notification.message.link.manage.usage":[{"type":0,"value":"Manage usage"}],"jsm-cbp-grace-period-notification.message.text.ninety.days":[{"type":0,"value":"Consumption-based pricing will come into effect after "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"jsm-cbp-grace-period-notification.message.text.thirty.days":[{"type":0,"value":"Extra usage of Assets and the virtual service agent in Jira Service Management will be billed."}],"jsm-cbp-grace-period-notification.message.title.ninety.days":[{"type":0,"value":"You are nearing the end of your Grace period"}],"jsm-cbp-grace-period-notification.message.title.thirty.days":[{"type":0,"value":"Consumption-based pricing starts in "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading":[{"type":0,"value":"Consumption-based pricing starts with your next renewal"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro":[{"type":0,"value":"We\u2019re letting you know that Assets and Virtual service agent will move to consumption-based pricing at your next renewal on "},{"type":1,"value":"cbpEffectiveDate"},{"type":0,"value":". Additional charges will only apply if your usage exceeds the included limit. Check your current usage and learn more below."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know":[{"type":0,"value":"Helpful things to know:"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text":[{"type":0,"value":"comment"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text":[{"type":0,"value":"lightbulb"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema":[{"children":[{"type":0,"value":"Contact support"}],"type":8,"value":"a"},{"type":0,"value":" if you have any questions"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit":[{"type":0,"value":"Consider "},{"children":[{"type":0,"value":"optimizing the structure of your schemas"}],"type":8,"value":"a"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button":[{"type":0,"value":"More details"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject":[{"type":0,"value":"[Reminder] Upcoming pricing changes to Assets and Virtual Service Agent"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide":[{"type":0,"value":"For more information, read more about "},{"children":[{"type":0,"value":"how feature usage limits work"}],"type":8,"value":"a"},{"type":0,"value":"."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button":[{"type":0,"value":"View and manage usage"}],"jsm-sequoia.nearing-storage-limit.body.agent-limit":[{"type":0,"value":"Get "},{"children":[{"type":0,"value":"unlimited agents"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"250 GB file storage"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.body.ai-written-support":[{"type":0,"value":"Power your Rovo agent with "},{"children":[{"type":0,"value":"AI written support articles"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.body.assets":[{"type":0,"value":"Track business "},{"children":[{"type":0,"value":"assets"}],"type":8,"value":"b"},{"type":0,"value":" and link them to work items"}],"jsm-sequoia.nearing-storage-limit.body.disclaimer":[{"type":0,"value":"We will automatically upgrade you to a "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":". You can "},{"children":[{"type":0,"value":"switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime by reducing your limits."}],"jsm-sequoia.nearing-storage-limit.body.rovo-ai-agents":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"Rovo AI agents"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.button.try-standard":[{"type":0,"value":"Try Standard for free"}],"jsm-sequoia.nearing-storage-limit.caption.body":[{"type":0,"value":"You\'ve used at least 1.8 GB of the 2 GB storage available on the Free plan. Once you reach 2 GB, you\'ll be upgraded to the 14-day free trial of our Standard plan."}],"jsm-sequoia.nearing-storage-limit.caption.disclaimer":[{"type":0,"value":"What happens once storage is full?"}],"jsm-sequoia.nearing-storage-limit.caption.heading":[{"type":0,"value":"You\'re almost out of storage"}],"jsm-sequoia.nearing-storage-limit.email-header-alt":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.nearing-storage-limit.email-header-customer-service-management":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.nearing-storage-limit.email-header-jira-service-management":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.nearing-storage-limit.email-header-rovo":[{"type":0,"value":"Rovo"}],"jsm-sequoia.nearing-storage-limit.email-header-subtitle":[{"type":0,"value":"Includes:"}],"jsm-sequoia.nearing-storage-limit.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.nearing-storage-limit.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.nearing-storage-limit.footer.dot-separator":[{"type":0,"value":"\u2022"}],"jsm-sequoia.nearing-storage-limit.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"jsm-sequoia.nearing-storage-limit.footer.facebook-title":[{"type":0,"value":"Facebook"}],"jsm-sequoia.nearing-storage-limit.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"jsm-sequoia.nearing-storage-limit.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"jsm-sequoia.nearing-storage-limit.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"jsm-sequoia.nearing-storage-limit.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"jsm-sequoia.nearing-storage-limit.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.nearing-storage-limit.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"jsm-sequoia.nearing-storage-limit.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"jsm-sequoia.nearing-storage-limit.footer.x-alt-text":[{"type":0,"value":"X"}],"jsm-sequoia.nearing-storage-limit.footer.x-title":[{"type":0,"value":"X"}],"jsm-sequoia.nearing-storage-limit.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"jsm-sequoia.nearing-storage-limit.footer.youtube-title":[{"type":0,"value":"Youtube"}],"jsm-sequoia.nearing-storage-limit.link.explore-plans":[{"type":0,"value":"Explore all plans"}],"jsm-sequoia.service-collection-nearing-storage-limit-awareness.email.subject":[{"type":0,"value":"You are about to reach your limit"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.avatar.alt_text.user_avatar":[{"type":0,"value":"User Avatar"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.connection":[{"type":0,"value":"Connection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.csm":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.id-badge":[{"type":0,"value":"ID Badge"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.jsm":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.service-collection":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.description":[{"type":0,"value":"Deliver better customer support and quickly turn feedback into product improvements."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.title":[{"type":0,"value":"Delight external customers with purpose-built features"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.description":[{"type":0,"value":"Make internal support easier by enabling HR, IT, and other teams to resolve employee requests quickly."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.title":[{"type":0,"value":"Unite teams to deliver exceptional service experiences"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.alt_text.atlassian":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.contact_us":[{"type":0,"value":"Contact us"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.privacy_policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.read_our_blog":[{"type":0,"value":"Blog"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.twitter.no-translate":[{"type":0,"value":"Twitter"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.greeting":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":","}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.message":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" has requested a trial of Service Collection."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" requested your organization try Service Collection, Atlassian\u2019s solution for AI service management at high velocity."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.cta":[{"type":0,"value":"Try Service Collection for free"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.review-request-cta":[{"type":0,"value":"Review request"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":", "},{"type":1,"value":"requestingUserName"},{"type":0,"value":" wants you to start a Service Collection trial"}],"jsm-servco-uplift-notification.message.button.servco.uplift":[{"type":0,"value":"Try it now"}],"jsm-servco-uplift-notification.message.link.learn.more.servco.uplift":[{"type":0,"value":"What\'s Service Collection"}],"jsm-servco-uplift-notification.message.text.servco.uplift":[{"type":0,"value":"Deliver great service experiences fast with a template designed to help your external customers."}],"jsm-servco-uplift-notification.message.title.servco.uplift":[{"type":0,"value":"Try Customer Service Management today with Service Collection"}],"post-office.ad-controls-sequoia.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls-sequoia.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls-sequoia.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls-sequoia.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls-sequoia.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls-sequoia.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls-sequoia.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls-sequoia.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls-sequoia.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls-sequoia.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls-sequoia.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls-sequoia.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls-sequoia.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls-sequoia.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls-sequoia.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls-sequoia.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls-sequoia.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-dashboard-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-dashboard-item.menu-item-label":[{"type":0,"value":"Dashboards"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-data-manager-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-data-manager-item.menu-item-label":[{"type":0,"value":"Data Manager"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-item.menu-item-label":[{"type":0,"value":"Assets"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-issue-view-details-section.description":[{"type":0,"value":"Update incidents from within Slack and summarize key events with AI."}],"post-office.jsm-issue-view-details-section.dismiss-button-one":[{"type":0,"value":"I don\'t use Slack"}],"post-office.jsm-issue-view-details-section.reasons-modal-bullet-one":[{"type":0,"value":"your usage of Jira Service Management\'s Alerts and Incidents features"}],"post-office.jsm-issue-view-details-section.reasons-modal-explanation":[{"type":0,"value":"We think Service Collection Premium will improve your team\'s workflow. The recommendation is based on:"}],"post-office.jsm-issue-view-details-section.title":[{"type":0,"value":"Resolve incidents on Slack with AI"}]}');

});

parcelRegister("dtPJk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hHigu").then(()=>parcelRequire('6B4Pp'));

});

parcelRegister("4kyze", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("38TSU").then(()=>parcelRequire('dUffB'));

});

parcelRegister("lhVCX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8U5MX").then(()=>parcelRequire('fzmSr'));

});

parcelRegister("2jfuw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5gpde").then(()=>parcelRequire('3OTK5'));

});

parcelRegister("7RxGb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Rmgn").then(()=>parcelRequire('awwoP'));

});

parcelRegister("02fhl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8kWPW").then(()=>parcelRequire('cLbvo'));

});

parcelRegister("4hKS3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("23lnm").then(()=>parcelRequire('5LtH7'));

});

parcelRegister("zi3Oy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iwbPU").then(()=>parcelRequire('2zgNS'));

});

parcelRegister("gxrae", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("agiMX").then(()=>parcelRequire('kd6eO'));

});

parcelRegister("V9440", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l8Ax5").then(()=>parcelRequire('8nEAa'));

});

parcelRegister("dVf4g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gt95R").then(()=>parcelRequire('ktrFJ'));

});

parcelRegister("cnmSa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kqmf0").then(()=>parcelRequire('g6Bgq'));

});

parcelRegister("pRQUd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jgrsW").then(()=>parcelRequire('ayGND'));

});

parcelRegister("lgpZi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cxjG3").then(()=>parcelRequire('kvUD0'));

});

parcelRegister("3DsaH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1dZE7").then(()=>parcelRequire('6ptA5'));

});

parcelRegister("7zE9i", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("doDgb").then(()=>parcelRequire('8Xxbr'));

});

parcelRegister("8l0GV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lwGjd").then(()=>parcelRequire('9C8NS'));

});

parcelRegister("clpjv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iHW6e").then(()=>parcelRequire('7e7U4'));

});

parcelRegister("1kzZp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("95S6F").then(()=>parcelRequire('4Vnzr'));

});

parcelRegister("d8a4I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("elJsR").then(()=>parcelRequire('fPZTG'));

});

parcelRegister("ayKtw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5BJJ2").then(()=>parcelRequire('cyddB'));

});

parcelRegister("52Z9d", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bQWQ9").then(()=>parcelRequire('9lZ8D'));

});

parcelRegister("jQ2Mg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fSYva").then(()=>parcelRequire('jlA0I'));

});

parcelRegister("gmHM4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k0ar0").then(()=>parcelRequire('4ciNd'));

});

parcelRegister("lyjB0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3T7ow").then(()=>parcelRequire('jMwNu'));

});

parcelRegister("d0f6J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8TuAW").then(()=>parcelRequire('9WQZe'));

});

parcelRegister("4QJEv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7PBvZ").then(()=>parcelRequire('hwEMr'));

});

parcelRegister("c4TX1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1ptZ8").then(()=>parcelRequire('4N8Ih'));

});

parcelRegister("8qP4x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aoEKP").then(()=>parcelRequire('7VdZJ'));

});

parcelRegister("9Mc9V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fXrK").then(()=>parcelRequire('ld333'));

});

parcelRegister("hMbug", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gDozw").then(()=>parcelRequire('aCJts'));

});

parcelRegister("dtUkR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4TSPL").then(()=>parcelRequire('8rIhe'));

});

parcelRegister("aMCoQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7L55S").then(()=>parcelRequire('kElcx'));

});

parcelRegister("cL0tm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("25JPb").then(()=>parcelRequire('b2mNy'));

});


parcelRegister("dFD5Z", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $f5de20936b2e761d$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bkZ7z = parcelRequire("bkZ7z");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f5de20936b2e761d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $f5de20936b2e761d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("9rrbN")));
        case 'da':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("9p7ze")));
        case 'de':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("e6vV0")));
        case 'en-GB':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("1yVUF")));
        case 'en-US':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("4rYDs")));
        case 'en-XA':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("5lHCs")));
        case 'en-XB':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("887kI")));
        case 'en-ZZ':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("hGTgp")));
        case 'en':
            return $f5de20936b2e761d$var$importHelper(await Promise.resolve((parcelRequire("bkZ7z"))));
        case 'es':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("5nhNC")));
        case 'et':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("3kRi3")));
        case 'fi':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("liUEL")));
        case 'fr':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("g3C0T")));
        case 'hr':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("hgPrW")));
        case 'hu':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("6XPXv")));
        case 'it':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("jfmv3")));
        case 'ja':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("lVAvb")));
        case 'ko':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("cgBx1")));
        case 'nb':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("f8F9q")));
        case 'nl':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("au6x3")));
        case 'pl':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("RAmRC")));
        case 'pt-BR':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("k5mu2")));
        case 'ro':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("9BOG6")));
        case 'ru':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("kMzV0")));
        case 'sl':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("kbeXz")));
        case 'sr-RS':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("dmxQY")));
        case 'sr-YR':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("dCqkR")));
        case 'sr':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("4meTr")));
        case 'sv':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("d1G3s")));
        case 'th':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("795dW")));
        case 'tr':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("5n7Bi")));
        case 'uk':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("03grE")));
        case 'vi':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("6sWeM")));
        case 'zh-CN':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("aftkN")));
        case 'zh-TW':
            return $f5de20936b2e761d$var$importHelper(await (parcelRequire("dLo5j")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bkZ7z));
    }
};

});
parcelRegister("bkZ7z", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"playground.post-office-auto-merge-config.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.post-office-auto-merge-config.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.post-office-auto-merge-config.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.post-office-auto-merge-config.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"playground.post-office-auto-merge-config.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"playground.post-office-auto-merge-config.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.post-office-auto-merge-config.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("9rrbN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kfWfD").then(()=>parcelRequire('j1kJy'));

});

parcelRegister("9p7ze", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ZQ6Y").then(()=>parcelRequire('5ouVj'));

});

parcelRegister("e6vV0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eXK0F").then(()=>parcelRequire('jbAsz'));

});

parcelRegister("1yVUF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6CSJA").then(()=>parcelRequire('7Vj4v'));

});

parcelRegister("4rYDs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3uLeV").then(()=>parcelRequire('8K0gt'));

});

parcelRegister("5lHCs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iwyk2").then(()=>parcelRequire('1FPwL'));

});

parcelRegister("887kI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3eicG").then(()=>parcelRequire('hFs5W'));

});

parcelRegister("hGTgp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("92d0R").then(()=>parcelRequire('hsZAZ'));

});

parcelRegister("5nhNC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("47C1m").then(()=>parcelRequire('aWzgt'));

});

parcelRegister("3kRi3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l1PvT").then(()=>parcelRequire('e3Zd1'));

});

parcelRegister("liUEL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8vtHA").then(()=>parcelRequire('5aAuL'));

});

parcelRegister("g3C0T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("046lp").then(()=>parcelRequire('c6zki'));

});

parcelRegister("hgPrW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ls9x4").then(()=>parcelRequire('jN1k4'));

});

parcelRegister("6XPXv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8QwpM").then(()=>parcelRequire('cUmfC'));

});

parcelRegister("jfmv3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Xued").then(()=>parcelRequire('fcqlC'));

});

parcelRegister("lVAvb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bpmm8").then(()=>parcelRequire('jpPQh'));

});

parcelRegister("cgBx1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3piHy").then(()=>parcelRequire('giWhb'));

});

parcelRegister("f8F9q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fBab").then(()=>parcelRequire('giFjn'));

});

parcelRegister("au6x3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fGw7R").then(()=>parcelRequire('37AE4'));

});

parcelRegister("RAmRC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9dzfh").then(()=>parcelRequire('aTWgn'));

});

parcelRegister("k5mu2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2LYr8").then(()=>parcelRequire('35foD'));

});

parcelRegister("9BOG6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gqb9f").then(()=>parcelRequire('cja4r'));

});

parcelRegister("kMzV0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("13Baa").then(()=>parcelRequire('4i5JT'));

});

parcelRegister("kbeXz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lBgWY").then(()=>parcelRequire('1RJ3T'));

});

parcelRegister("dmxQY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bSAvv").then(()=>parcelRequire('gT98W'));

});

parcelRegister("dCqkR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lV2Br").then(()=>parcelRequire('bqaeq'));

});

parcelRegister("4meTr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4W6OP").then(()=>parcelRequire('is17B'));

});

parcelRegister("d1G3s", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("CTcat").then(()=>parcelRequire('656TX'));

});

parcelRegister("795dW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3noKQ").then(()=>parcelRequire('ksKFy'));

});

parcelRegister("5n7Bi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8nYY2").then(()=>parcelRequire('b1F5d'));

});

parcelRegister("03grE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gyL1Z").then(()=>parcelRequire('9jkkb'));

});

parcelRegister("6sWeM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7saWB").then(()=>parcelRequire('iPU8u'));

});

parcelRegister("aftkN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3rbVy").then(()=>parcelRequire('32x0P'));

});

parcelRegister("dLo5j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5aYgT").then(()=>parcelRequire('br9dE'));

});


parcelRegister("jvZSQ", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $7aa2d5fa9d061164$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2fwBX = parcelRequire("2fwBX");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7aa2d5fa9d061164$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7aa2d5fa9d061164$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("4NLdw")));
        case 'da':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("33Z8u")));
        case 'de':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("bsHdU")));
        case 'en-GB':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("6MNzj")));
        case 'en-US':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("GK13c")));
        case 'en-XA':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("kQhsw")));
        case 'en-XB':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("dotnr")));
        case 'en-ZZ':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("SNdIu")));
        case 'en':
            return $7aa2d5fa9d061164$var$importHelper(await Promise.resolve((parcelRequire("2fwBX"))));
        case 'es':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("k5dKJ")));
        case 'et':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("61iSW")));
        case 'fi':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("6KXye")));
        case 'fr':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("hSrZW")));
        case 'hr':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("1SnJl")));
        case 'hu':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("7Gudg")));
        case 'it':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("5bUu1")));
        case 'ja':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("dkip9")));
        case 'ko':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("hyeWu")));
        case 'nb':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("kZFYi")));
        case 'nl':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("bN8sX")));
        case 'pl':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("gnD7Q")));
        case 'pt-BR':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("8aMjo")));
        case 'ro':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("jLMJv")));
        case 'ru':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("igbHV")));
        case 'sl':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("lpF96")));
        case 'sr-RS':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("lnggu")));
        case 'sr-YR':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("ggPzq")));
        case 'sr':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("3WsRu")));
        case 'sv':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("daB49")));
        case 'th':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("4CLQZ")));
        case 'tr':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("1gk0R")));
        case 'uk':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("8NgJ8")));
        case 'vi':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("avQpA")));
        case 'zh-CN':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("28HmY")));
        case 'zh-TW':
            return $7aa2d5fa9d061164$var$importHelper(await (parcelRequire("4HaCJ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2fwBX));
    }
};

});
parcelRegister("2fwBX", function(module, exports) {
module.exports = JSON.parse('{"INAPP-1736.spotlight.body":[{"type":0,"value":"We\'ve got the basic settings for your integration covered. Customize them to make sure you get the most out of the integration."}],"INAPP-1736.spotlight.primary":[{"type":0,"value":"OK"}],"INAPP-1736.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-1736.spotlight.title":[{"type":0,"value":"Set up your integration"}],"INAPP-1737.spotlight.body":[{"type":0,"value":"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"}],"INAPP-1737.spotlight.primary":[{"type":0,"value":"Learn more"}],"INAPP-1737.spotlight.secondary":[{"type":0,"value":"OK"}],"INAPP-1737.spotlight.title":[{"type":0,"value":"Create rich and informative alerts"}],"alert.status.acked":[{"type":0,"value":"Acknowledged"}],"alert.status.closed":[{"type":0,"value":"Closed"}],"alert.status.open":[{"type":0,"value":"Open"}],"alert.status.snoozed":[{"type":0,"value":"Snoozed"}],"alexstrasza.assess-risk-button-spotlight.description":[{"type":0,"value":"Evaluate the potential impact of this change before approving or scheduling."}],"alexstrasza.assess-risk-button-spotlight.heading":[{"type":0,"value":"Assess risk with Rovo Ops"}],"alexstrasza.assess-risk-button-spotlight.try-it-now":[{"type":0,"value":"Try it now"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Note added"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View alert in OpsGenie"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Note added to alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert acknowledged: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert assigned: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert closed: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-export.message-template.email.subject.no-translate":[{"type":0,"value":"Export Alert Result"}],"alexstrasza.jsm-operations-alert-export.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"alexstrasza.jsm-operations-alert-export.test-message.email.body.no-translate":[{"type":0,"value":"We\u2019ve exported your alerts and now you can download the zip file here:"}],"alexstrasza.jsm-operations-alert-export.test-message.email.continue-export-label.no-translate":[{"type":0,"value":"The results contain the latest 10k alerts. To continue exporting, you can click the link below:"}],"alexstrasza.jsm-operations-alert-export.test-message.email.expiry.no-translate":[{"type":0,"value":"Please note that the export link will expire in 14 days."}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-new.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" New alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-button.no-translate":[{"type":0,"value":"Download "},{"type":1,"value":"exportType"},{"type":0,"value":" log"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-icon.alt.no-translate":[{"type":0,"value":"Download icon"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-category.no-translate":[{"type":0,"value":"Category: "},{"type":1,"value":"filterCategories"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-label.no-translate":[{"type":0,"value":"Export Criteria:"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-log-level.no-translate":[{"type":0,"value":"Log level: "},{"type":1,"value":"filterLogLevels"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-search.no-translate":[{"type":0,"value":"Search: "},{"type":1,"value":"searchKeywords"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-time.no-translate":[{"type":0,"value":"Time: "},{"type":1,"value":"from"},{"type":0,"value":" to "},{"type":1,"value":"to"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"userFullName"},{"type":0,"value":","}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.heading.no-translate":[{"type":0,"value":"Download your "},{"type":1,"value":"exportType"},{"type":0,"value":" log"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.intro-message.no-translate":[{"type":0,"value":"The CSV file for "},{"type":1,"value":"siteName"},{"type":0,"value":"\'s "},{"type":1,"value":"exportType"},{"type":0,"value":" log is ready to download. The download link will expire in 24 hours."}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.limit-note.no-translate":[{"type":0,"value":"Up to 100,000 activities can be exported at once, activities over the limit would be skipped in the CSV file."}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.subject.no-translate":[{"type":0,"value":"Your "},{"type":1,"value":"exportType"},{"type":0,"value":" log is ready to download"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.affected-role-label.no-translate":[{"type":0,"value":"Affected member role"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.button-text.no-translate":[{"type":0,"value":"View your alert notifications"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.contact-methods.no-translate":[{"type":0,"value":"contact methods"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-text.no-translate":[{"type":0,"value":"The role-based notification "},{"type":1,"value":"roleBasedNotificationSettingName"},{"type":0,"value":" will trigger alert notifications based on the conditions set by the admin."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-label.no-translate":[{"type":0,"value":"Note"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-text.no-translate":[{"type":0,"value":"Review your "},{"type":1,"value":"contactMethods"},{"type":0,"value":" to confirm that this role-based notification works as expected."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.override-message.no-translate":[{"type":0,"value":"Role-based notifications override your personal notifications."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.title.no-translate":[{"type":0,"value":"Role-based notification turned on"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.subject.no-translate":[{"type":0,"value":"Role-based notification turned on"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" ends"}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending, at "},{"type":1,"value":"endTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending now."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.app-store-logo.alt.no-translate":[{"type":0,"value":"Download on the App Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.link-text.no-translate":[{"type":0,"value":"update your notification settings"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.no-translate":[{"type":0,"value":"To customize the email or unsubscribe, "},{"type":1,"value":"link"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.mobile-app.no-translate":[{"type":0,"value":"Stay notified and comment on the go with Jira Service Management Mobile App"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.play-store-logo.alt.no-translate":[{"type":0,"value":"Download on the Play Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer-logo.alt.no-translate":[{"type":0,"value":"Atlassian"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.privacy-policy.no-translate":[{"type":0,"value":"Privacy Policy"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.text.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" starts"}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting, at "},{"type":1,"value":"startTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting now."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.alert-feature-image.alt.no-translate":[{"type":0,"value":"Alert management illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.chat-feature-image.alt.no-translate":[{"type":0,"value":"Chat integration illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.explore-subheading.no-translate":[{"type":0,"value":"Explore how operations can elevate your team\'s response"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-description.no-translate":[{"type":0,"value":"Improve response efficiency and reduce the alert fatigue."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-title.no-translate":[{"type":0,"value":"Manage all alerts in one place"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-description.no-translate":[{"type":0,"value":"Handle alerts and on-call using your chat tools."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-title.no-translate":[{"type":0,"value":"Respond to alerts via chat"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-description.no-translate":[{"type":0,"value":"Connect your IT tools and apps to centralize alerts in one place."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-title.no-translate":[{"type":0,"value":"Integrate with your apps"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-description.no-translate":[{"type":0,"value":"Set on-call schedules easily and never miss a critical alert."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-title.no-translate":[{"type":0,"value":"Become an on-call team"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.heading.no-translate":[{"children":[{"type":1,"value":"teamName"}],"type":8,"value":"strong"},{"type":0,"value":" has launched its operations and is ready to respond"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.integration-feature-image.alt.no-translate":[{"type":0,"value":"Integration illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.launch-message.no-translate":[{"children":[{"type":1,"value":"actorUserName"}],"type":8,"value":"strong"},{"type":0,"value":" has launched "},{"children":[{"type":1,"value":"teamName"},{"type":0,"value":"\'s"}],"type":8,"value":"strong"},{"type":0,"value":" operations and added you as a member to collaborate."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.learn-more-link.no-translate":[{"type":0,"value":"Learn more"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.oncall-feature-image.alt.no-translate":[{"type":0,"value":"On-call scheduling illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.start-collaborating-button.no-translate":[{"type":0,"value":"Start collaborating"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.team-image.alt.no-translate":[{"type":0,"value":"Team profile picture"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.what-are-operations.no-translate":[{"type":0,"value":"What are operations?"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.subject.no-translate":[{"type":0,"value":"You\'re invited to collaborate on your team\'s operations"}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-allowlist.no-translate":[{"type":0,"value":"Your email server might be rejecting emails from Jira Service Management. Request your email administrator to allowlist jsm-notifications.atlassian.net."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-deactivated.no-translate":[{"type":0,"value":"The email address "},{"type":1,"value":"displayName"},{"type":0,"value":" you had added for alert notifications is deactivated."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-reactivate.no-translate":[{"type":0,"value":"If the email address is correct, go to the Alert notifications page in your personal settings and reactivate it."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"fullName"},{"type":0,"value":","}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.mobile-deactivated.no-translate":[{"type":0,"value":"The mobile device "},{"type":1,"value":"displayName"},{"type":0,"value":" added to your contact methods for mobile push notifications is currently deactivated because it\'s invalid or your app instance was unregistered. To continue receiving push notifications, re-install the application and verify the status from the Alert notifications page in your Jira personal settings."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.phone-deactivated.no-translate":[{"type":0,"value":"The phone number "},{"type":1,"value":"displayName"},{"type":0,"value":" added to your contact methods for voice/SMS is currently deactivated because it\'s invalid or it\'s blocklisted by your service provider. If the phone number is correct, go to the Alert notifications page in your Jira personal settings and reactivate it."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"product"},{"type":0,"value":"] Contact method for notifications deactivated"}],"alexstrasza.jsm-ops-enablement-notification-drawer.message-template.notification-drawer.message":[{"type":1,"value":"actorName"},{"type":0,"value":" launched "},{"type":1,"value":"teamName"},{"type":0,"value":"\'s operations"}],"alexstrasza.operations-overview-discoverability-spotlights.high-bug.description":[{"type":0,"value":"Your team\'s been logging a lot of bugs. Set up operations to get ahead of the next one \u2014 with on-call, alerting, and incident response built right in."}],"alexstrasza.operations-overview-discoverability-spotlights.high-bug.tour.step1-description":[{"type":0,"value":"Your team\'s been logging a lot of bugs. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and get ahead of the next one \u2014 with on-call, alerting, and incident response built right in."}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.description":[{"type":0,"value":"It\'s been a while since you started setting up operations. Turn on alerts and on-call schedules to unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.heading":[{"type":0,"value":"You\'re almost there"}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.primary-action":[{"type":0,"value":"Go to Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.tour.step1-description":[{"type":0,"value":"It\'s been a while since you started setting up operations. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.description":[{"type":0,"value":"You\'re getting notified through third-party integrations today. Instead, set up operations to receive real-time alerts and stay on top of issues as soon as they happen."}],"alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.tour.step1-description":[{"type":0,"value":"You\'re getting notified through third-party integrations today. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.heading":[{"type":0,"value":"Explore Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.primary-action":[{"type":0,"value":"Explore"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.next-button":[{"type":0,"value":"Next"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.primary-action":[{"type":0,"value":"Go to Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step-count":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step1-heading":[{"type":0,"value":"Complete your Operations setup"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step2-description":[{"type":0,"value":"Click on "},{"children":[{"type":0,"value":"Operations"}],"type":8,"value":"b"},{"type":0,"value":" to set up alerts and on-call schedules to make sure your team stay on top of issues as soon as they happen."}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step2-heading":[{"type":0,"value":"You\'re almost there"}],"alexstrasza.risk-assessment-spotlight.explore-categories.description":[{"type":0,"value":"Rovo Ops breaks down risk into categories. Select any category to see risk details, contributing factors, and why it was flagged."}],"alexstrasza.risk-assessment-spotlight.explore-categories.heading":[{"type":0,"value":"Explore risk by category"}],"alexstrasza.risk-assessment-spotlight.mitigate-risk.description":[{"type":0,"value":"Get actionable mitigation steps tailored to each risk category, so you can address issues before the change goes live."}],"alexstrasza.risk-assessment-spotlight.mitigate-risk.heading":[{"type":0,"value":"Mitigate risk"}],"alexstrasza.risk-assessment-spotlight.navigation.done":[{"type":0,"value":"Done"}],"alexstrasza.risk-assessment-spotlight.navigation.next":[{"type":0,"value":"Next"}],"alexstrasza.risk-assessment-spotlight.navigation.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"eoc-heartbeats.message-id.spotlight.body":[{"type":0,"value":"Copy heartbeat\u2019s name, edit, duplicate, and manage more heartbeat actions."}],"eoc-heartbeats.message-id.spotlight.dismiss":[{"type":0,"value":"OK"}],"eoc-heartbeats.message-id.spotlight.title":[{"type":0,"value":"Easy access to heartbeat actions"}],"eoc-heartbeats.tour.learn-more.no-translate":[{"type":0,"value":"Learn More"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-body.no-translate":[{"type":1,"value":"description"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-subtitle.no-translate":[{"type":0,"value":"Status: "},{"type":1,"value":"status"},{"type":0,"value":" | Source: "},{"type":1,"value":"source"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-title.no-translate":[{"type":0,"value":"["},{"type":1,"value":"priority"},{"type":0,"value":"] "},{"type":1,"value":"message"}]}');

});

parcelRegister("4NLdw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j2Kye").then(()=>parcelRequire('hzvhH'));

});

parcelRegister("33Z8u", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7SWZZ").then(()=>parcelRequire('6tbgY'));

});

parcelRegister("bsHdU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5jeII").then(()=>parcelRequire('7OaN4'));

});

parcelRegister("6MNzj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g8be8").then(()=>parcelRequire('2XKk8'));

});

parcelRegister("GK13c", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("amGSJ").then(()=>parcelRequire('4YmyL'));

});

parcelRegister("kQhsw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3QJI8").then(()=>parcelRequire('j8t0a'));

});

parcelRegister("dotnr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("apaXi").then(()=>parcelRequire('gOYoF'));

});

parcelRegister("SNdIu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dcOsk").then(()=>parcelRequire('fGlah'));

});

parcelRegister("k5dKJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fMt3q").then(()=>parcelRequire('kS0Mc'));

});

parcelRegister("61iSW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4LYRV").then(()=>parcelRequire('bLXKD'));

});

parcelRegister("6KXye", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eR2Sz").then(()=>parcelRequire('gCujL'));

});

parcelRegister("hSrZW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aWicM").then(()=>parcelRequire('gdwnK'));

});

parcelRegister("1SnJl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9O2Va").then(()=>parcelRequire('eiNs3'));

});

parcelRegister("7Gudg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dqQOq").then(()=>parcelRequire('cs9ZJ'));

});

parcelRegister("5bUu1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jAS11").then(()=>parcelRequire('f5Pxr'));

});

parcelRegister("dkip9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1KwJV").then(()=>parcelRequire('dHLAp'));

});

parcelRegister("hyeWu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1wYBD").then(()=>parcelRequire('4AgMm'));

});

parcelRegister("kZFYi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ebQPi").then(()=>parcelRequire('dcIAP'));

});

parcelRegister("bN8sX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lDbGx").then(()=>parcelRequire('bz4X6'));

});

parcelRegister("gnD7Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1GRQX").then(()=>parcelRequire('2ohS0'));

});

parcelRegister("8aMjo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5QNpE").then(()=>parcelRequire('9LV3R'));

});

parcelRegister("jLMJv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9leIW").then(()=>parcelRequire('jLDeE'));

});

parcelRegister("igbHV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kz71w").then(()=>parcelRequire('lOdDv'));

});

parcelRegister("lpF96", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Z1KG").then(()=>parcelRequire('2OUid'));

});

parcelRegister("lnggu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eBric").then(()=>parcelRequire('fa7QN'));

});

parcelRegister("ggPzq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3PN7B").then(()=>parcelRequire('bJFgY'));

});

parcelRegister("3WsRu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lxF6C").then(()=>parcelRequire('hO8pw'));

});

parcelRegister("daB49", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("idIUO").then(()=>parcelRequire('71IiT'));

});

parcelRegister("4CLQZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dmLvD").then(()=>parcelRequire('lLjkB'));

});

parcelRegister("1gk0R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bPTMa").then(()=>parcelRequire('7E2Vd'));

});

parcelRegister("8NgJ8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("M6E1y").then(()=>parcelRequire('1Qave'));

});

parcelRegister("avQpA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6rhDf").then(()=>parcelRequire('aLuyx'));

});

parcelRegister("28HmY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9m84W").then(()=>parcelRequire('2aBS5'));

});

parcelRegister("4HaCJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3Ph45").then(()=>parcelRequire('jciDR'));

});


parcelRegister("lWlZ1", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $2999108c999175e6$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $eEtj9 = parcelRequire("eEtj9");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2999108c999175e6$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2999108c999175e6$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("2qxZc")));
        case 'da':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("9TldV")));
        case 'de':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("dH4MZ")));
        case 'en-GB':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("gxMIr")));
        case 'en-US':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("lQDVh")));
        case 'en-XA':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("bzakx")));
        case 'en-XB':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("ef1yu")));
        case 'en-ZZ':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("8fnaf")));
        case 'en':
            return $2999108c999175e6$var$importHelper(await Promise.resolve((parcelRequire("eEtj9"))));
        case 'es':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("gGmKG")));
        case 'et':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("dy2Tr")));
        case 'fi':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("1FyxN")));
        case 'fr':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("4fPvG")));
        case 'hr':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("199QH")));
        case 'hu':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("2Iqtn")));
        case 'it':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("19RLE")));
        case 'ja':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("kGvFN")));
        case 'ko':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("kttZf")));
        case 'nb':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("2KkJs")));
        case 'nl':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("kSNWu")));
        case 'pl':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("9i0w3")));
        case 'pt-BR':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("3Itgg")));
        case 'ro':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("b9oj1")));
        case 'ru':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("kjXLE")));
        case 'sl':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("aIiq3")));
        case 'sr-RS':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("9sVGV")));
        case 'sr-YR':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("k0yHg")));
        case 'sr':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("idRBr")));
        case 'sv':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("8IKe5")));
        case 'th':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("lTbwQ")));
        case 'tr':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("ehKMn")));
        case 'uk':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("7xYMr")));
        case 'vi':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("3sxrB")));
        case 'zh-CN':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("g7nws")));
        case 'zh-TW':
            return $2999108c999175e6$var$importHelper(await (parcelRequire("kS2Nb")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eEtj9));
    }
};

});
parcelRegister("eEtj9", function(module, exports) {
module.exports = JSON.parse("{\"INAPP-2055.spotlight.body\":[{\"type\":0,\"value\":\"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed\"}],\"INAPP-2055.spotlight.primary\":[{\"type\":0,\"value\":\"Learn more\"}],\"INAPP-2055.spotlight.secondary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-2055.spotlight.title\":[{\"type\":0,\"value\":\"Create rich and informative alerts\"}],\"INAPP-3273.spotlight.body\":[{\"type\":0,\"value\":\"Triage and resolve alerts faster by using Atlassian Intelligence to access similar alerts.\"}],\"INAPP-3273.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-3273.spotlight.title\":[{\"type\":0,\"value\":\"Drive faster alert resolution with Atlassian Intelligence\"}],\"aiops-grogu.rovo-ops-cta-spotlight.body\":[{\"type\":0,\"value\":\"Investigate and compare alerts, and find related resources to resolve faster.\"}],\"aiops-grogu.rovo-ops-cta-spotlight.done\":[{\"type\":0,\"value\":\"Ok\"}],\"aiops-grogu.rovo-ops-cta-spotlight.heading\":[{\"type\":0,\"value\":\"Triage alerts with Rovo Ops\"}],\"jira-ops-group-customisation.spotlight.body\":[{\"type\":0,\"value\":\"Your team's alerts are grouped based on the similarity of alert titles, descriptions, tags and so on within a specific time window. If you want more control, you can fine-tune how alerts are grouped. Only team admins, Ops admins, or Jira admins can change these settings.\"}],\"jira-ops-group-customisation.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"jira-ops-group-customisation.spotlight.title\":[{\"type\":0,\"value\":\"Configure alert groups\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.body\":[{\"type\":0,\"value\":\"Expand to quickly view all alerts in the group.\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.title\":[{\"type\":0,\"value\":\"View grouped alerts\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.body\":[{\"type\":0,\"value\":\"Rovo helps you classify your alerts as signal or noise so you can focus on what matters most.\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.title\":[{\"type\":0,\"value\":\"Triage alerts faster\"}],\"jira-ops-unified-view-revamp.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-ops-unified-view-revamp.spotlight.go-back\":[{\"type\":0,\"value\":\"Go back\"}],\"jira-ops-unified-view-revamp.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-ops-unified-view-revamp.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}]}");

});

parcelRegister("2qxZc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4cTLl").then(()=>parcelRequire('kiA3N'));

});

parcelRegister("9TldV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aMWZO").then(()=>parcelRequire('943Kb'));

});

parcelRegister("dH4MZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("785iL").then(()=>parcelRequire('9WRWd'));

});

parcelRegister("gxMIr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d71tm").then(()=>parcelRequire('4yLQ6'));

});

parcelRegister("lQDVh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7rdpR").then(()=>parcelRequire('cDTsI'));

});

parcelRegister("bzakx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jLPJa").then(()=>parcelRequire('8bzLB'));

});

parcelRegister("ef1yu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aiP4A").then(()=>parcelRequire('6VJSO'));

});

parcelRegister("8fnaf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("72Fqb").then(()=>parcelRequire('6FJxK'));

});

parcelRegister("gGmKG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ff6vb").then(()=>parcelRequire('1dQJ2'));

});

parcelRegister("dy2Tr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1xxLb").then(()=>parcelRequire('eFYBX'));

});

parcelRegister("1FyxN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dAMS3").then(()=>parcelRequire('i0Odx'));

});

parcelRegister("4fPvG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dc8YG").then(()=>parcelRequire('lvK9b'));

});

parcelRegister("199QH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hBjCY").then(()=>parcelRequire('4VNAX'));

});

parcelRegister("2Iqtn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4Re6v").then(()=>parcelRequire('14H9f'));

});

parcelRegister("19RLE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cvjWa").then(()=>parcelRequire('1Butu'));

});

parcelRegister("kGvFN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lmAR1").then(()=>parcelRequire('kJf3S'));

});

parcelRegister("kttZf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f8Xgo").then(()=>parcelRequire('dxnP2'));

});

parcelRegister("2KkJs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iDRYL").then(()=>parcelRequire('MwLeX'));

});

parcelRegister("kSNWu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lp4n8").then(()=>parcelRequire('6IELs'));

});

parcelRegister("9i0w3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Ap3B").then(()=>parcelRequire('dAZrc'));

});

parcelRegister("3Itgg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("grqFN").then(()=>parcelRequire('dTnnR'));

});

parcelRegister("b9oj1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dFr2p").then(()=>parcelRequire('btAOU'));

});

parcelRegister("kjXLE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5mlaJ").then(()=>parcelRequire('kGgLy'));

});

parcelRegister("aIiq3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dwOLb").then(()=>parcelRequire('5G0wW'));

});

parcelRegister("9sVGV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fjjpO").then(()=>parcelRequire('f3gfs'));

});

parcelRegister("k0yHg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cvzSx").then(()=>parcelRequire('81zsd'));

});

parcelRegister("idRBr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cifeo").then(()=>parcelRequire('k8mZq'));

});

parcelRegister("8IKe5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e8Gqd").then(()=>parcelRequire('kz9Qm'));

});

parcelRegister("lTbwQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bJS0k").then(()=>parcelRequire('eJqRn'));

});

parcelRegister("ehKMn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6HxP5").then(()=>parcelRequire('9RYMm'));

});

parcelRegister("7xYMr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5YvFW").then(()=>parcelRequire('bMP1Z'));

});

parcelRegister("3sxrB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kbqzE").then(()=>parcelRequire('9e4to'));

});

parcelRegister("g7nws", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a9By0").then(()=>parcelRequire('fdEfE'));

});

parcelRegister("kS2Nb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cM6AR").then(()=>parcelRequire('jactF'));

});


parcelRegister("3GKMZ", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $6e47a73868fda524$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $01LJD = parcelRequire("01LJD");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6e47a73868fda524$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $6e47a73868fda524$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("6LbMu")));
        case 'da':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("eVkgB")));
        case 'de':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("6ZLzr")));
        case 'en-GB':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("5EE4K")));
        case 'en-US':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("fDBkx")));
        case 'en-XA':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("ioRKf")));
        case 'en-XB':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("b9sN7")));
        case 'en-ZZ':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("l6EUT")));
        case 'en':
            return $6e47a73868fda524$var$importHelper(await Promise.resolve((parcelRequire("01LJD"))));
        case 'es':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("k6uw8")));
        case 'et':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("3O9m6")));
        case 'fi':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("kRDFs")));
        case 'fr':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("kbxxG")));
        case 'hr':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("750ZX")));
        case 'hu':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("jUxwl")));
        case 'it':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("7S2dm")));
        case 'ja':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("df6KN")));
        case 'ko':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("5sZd2")));
        case 'nb':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("fuWtJ")));
        case 'nl':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("aP48v")));
        case 'pl':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("9zaRn")));
        case 'pt-BR':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("9GQxx")));
        case 'ro':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("46JA9")));
        case 'ru':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("4WUkn")));
        case 'sl':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("1BbM7")));
        case 'sr-RS':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("8A06n")));
        case 'sr-YR':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("aiNlN")));
        case 'sr':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("lGrmZ")));
        case 'sv':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("dU2EI")));
        case 'th':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("4hRWZ")));
        case 'tr':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("eLr07")));
        case 'uk':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("13Eco")));
        case 'vi':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("9NlO7")));
        case 'zh-CN':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("aRVMO")));
        case 'zh-TW':
            return $6e47a73868fda524$var$importHelper(await (parcelRequire("1Cksm")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($01LJD));
    }
};

});
parcelRegister("01LJD", function(module, exports) {
module.exports = JSON.parse('{"INAPP-2270.spotlight.body":[{"type":0,"value":"Collaborate on requirements, meetings notes, retros, and more."}],"INAPP-2270.spotlight.primary":[{"type":0,"value":"Ok"}],"INAPP-2270.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-2270.spotlight.title":[{"type":0,"value":"Create docs without leaving Jira"}],"INAPP-2271.spotlight.body":[{"type":0,"value":"Create a single source of truth for your project docs. It\'s free to try."}],"INAPP-2271.spotlight.bodyV2":[{"type":0,"value":"Use it to create a single source of truth for all of your project docs."}],"INAPP-2271.spotlight.primary":[{"type":0,"value":"Ok"}],"INAPP-2271.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-2271.spotlight.title":[{"type":0,"value":"You have Confluence!"}],"growth-starburst.chloe-test-po-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"growth-starburst.chloe-test-po-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"growth-starburst.chloe-test-po-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"growth-starburst.chloe-test-po-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"growth-starburst.chloe-test-po-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"growth-starburst.chloe-test-po-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"growth-starburst.chloe-test-po-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"growth-starburst.common.arrow-right.alt-text":[{"type":0,"value":"Arrow right"}],"growth-starburst.common.bundled-existing-apps.header":[{"type":0,"value":"Bundled with your existing apps"}],"growth-starburst.common.icon-check-circle-blue.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-starburst.common.icon-confluence.alt-text":[{"type":0,"value":"Icon - Confluence"}],"growth-starburst.common.icon-jira.alt-text":[{"type":0,"value":"Icon - Jira"}],"growth-starburst.common.icon-loom.alt-text":[{"type":0,"value":"Icon - Loom"}],"growth-starburst.common.icon-rovo.alt-text":[{"type":0,"value":"Icon - Rovo"}],"growth-starburst.common.percentage.alt-text":[{"type":0,"value":"Percentage "},{"type":1,"value":"percentage"}],"growth-starburst.common.pro-tip.alt-text":[{"type":0,"value":"Pro tip"}],"growth-starburst.common.twc-email-summary.confluence":[{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"b"},{"type":0,"value":" - Idea & knowledge sharing"}],"growth-starburst.common.twc-email-summary.header":[{"type":0,"value":"Your Teamwork Collection gives you access to:"}],"growth-starburst.common.twc-email-summary.jira":[{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"b"},{"type":0,"value":" - Work planning & tracking"}],"growth-starburst.common.twc-email-summary.loom":[{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" - Async video communication"}],"growth-starburst.common.twc-email-summary.rovo":[{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"},{"type":0,"value":" - AI Chat, Search & a team of specialized Agents"}],"growth-starburst.ep-migration-inapp-3280.description":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"growth-starburst.ep-migration-inapp-3280.primary-button":[{"type":0,"value":"Upgrade options"}],"growth-starburst.ep-migration-inapp-3280.secondary-button":[{"type":0,"value":"Dismiss"}],"growth-starburst.ep-migration-inapp-3280.title":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"growth-starburst.ep-migration-inapp-3282.description":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"growth-starburst.ep-migration-inapp-3282.primary-button":[{"type":0,"value":"Upgrade options"}],"growth-starburst.ep-migration-inapp-3282.secondary-button":[{"type":0,"value":"Dismiss"}],"growth-starburst.ep-migration-inapp-3282.title":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.description":[{"type":0,"value":"Try summarizing or generating more content with AI. You can always come back to this panel."}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.title":[{"type":0,"value":"Now it\'s your turn!"}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content.description":[{"type":0,"value":"Try Keep adding content to your page. You can type /ai to prompt AI."}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content.title":[{"type":0,"value":"Now it\'s your turn!"}],"growth-starburst.jira-issue-view-twc-spotlight-card.documentation.description":[{"type":0,"value":"Create docs directly in Jira to capture work, strategy, and more \u2014 with AI doing the heavy lifting."}],"growth-starburst.jira-issue-view-twc-spotlight-card.documentation.title":[{"type":0,"value":"Turn ideas into docs instantly with AI"}],"growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.description":[{"type":0,"value":"Create video messages using Loom to talk through updates, feedback, or upcoming work."}],"growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.title":[{"type":0,"value":"Record & share videos"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.explore":[{"type":0,"value":"Explore"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.next":[{"type":0,"value":"Next"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.skip":[{"type":0,"value":"Dismiss"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-enabled":[{"type":0,"value":"enabled"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-label":[{"type":0,"value":"Auto advance:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.dismiss-button":[{"type":0,"value":"Dismiss Tour"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.start-from-step-label":[{"type":0,"value":"Start from step:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.steps-label":[{"type":0,"value":"Steps:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.title":[{"type":0,"value":"TWC Spotlight Tour Test"}],"growth-starburst.twc-conf-sample-page-tour.back":[{"type":0,"value":"Back"}],"growth-starburst.twc-conf-sample-page-tour.dismiss":[{"type":0,"value":"Dismiss"}],"growth-starburst.twc-conf-sample-page-tour.done":[{"type":0,"value":"Done"}],"growth-starburst.twc-conf-sample-page-tour.next":[{"type":0,"value":"Next"}],"growth-starburst.twc-conf-sample-page-tour.step1.description":[{"type":0,"value":"Create, update and manage Jira work directly in Confluence docs."}],"growth-starburst.twc-conf-sample-page-tour.step1.header":[{"type":0,"value":"Create and update tasks in Jira"}],"growth-starburst.twc-conf-sample-page-tour.step1.progressIndicator":[{"type":0,"value":"1 of 3"}],"growth-starburst.twc-conf-sample-page-tour.step2.description":[{"type":0,"value":"Generate content easily and quickly with our AI-powered writing assistant. Type /rovo to try it now."}],"growth-starburst.twc-conf-sample-page-tour.step2.header":[{"type":0,"value":"Let AI do the writing for you"}],"growth-starburst.twc-conf-sample-page-tour.step2.progressIndicator":[{"type":0,"value":"2 of 3"}],"growth-starburst.twc-conf-sample-page-tour.step3.description":[{"type":0,"value":"Loom can create a script from your page content. Record a quick video and add it to your doc to explain updates."}],"growth-starburst.twc-conf-sample-page-tour.step3.header":[{"type":0,"value":"Share updates with video"}],"growth-starburst.twc-conf-sample-page-tour.step3.progressIndicator":[{"type":0,"value":"3 of 3"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-confluence":[{"type":0,"value":"Create documents in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"b"},{"type":0,"value":" to share knowledge"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-jira":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"b"},{"type":0,"value":" to organize and plan projects"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-loom.premium":[{"type":0,"value":"Save time with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" and get AI-generated meeting recaps"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-loom.standard":[{"type":0,"value":"Save time with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" and record async video updates"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-rovo":[{"type":0,"value":"Get AI-powered help and keep work moving with "},{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.description":[{"type":0,"value":"Teamwork Collection brings together Jira, Confluence, Loom, and Rovo so you can plan, document, and collaborate across teams\u2014all in one place."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.explore-features-link":[{"type":0,"value":"Explore all features \u2192"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.features-title":[{"type":0,"value":"Finish work 3x faster with Teamwork Collection"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.get-started-button":[{"type":0,"value":"Get started"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.heading":[{"type":1,"value":"requesterName"},{"type":0,"value":" requested to try Teamwork Collection"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.logo.alt":[{"type":0,"value":"Teamwork Collection Atlassian"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.trial-info.premium":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", 30-day trial of Premium."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":", we\'ll remind you 3 days before your trial ends."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.trial-info.standard":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", 14-day trial of Standard."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":", we\'ll remind you 3 days before your trial ends."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.visual.alt":[{"type":0,"value":"Teamwork Collection visual showing Jira, Confluence, Loom, and Rovo"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterName"},{"type":0,"value":" wants to try Teamwork Collection"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraConf":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Save time with AI-generated meeting notes and async video"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraConf":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step2Title.jiraConf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email-v2.article1Copy1.confluenceArticle":[{"type":0,"value":"Start with a simple prompt like \\"plan a Q3 launch\\" and let Rovo draft a structured project plan."}],"growth-starburst.twc-marketing-email-v2.article1Copy1.jiraArticle":[{"type":0,"value":"Start with a simple prompt like \\"plan a Q3 launch\\" and let Rovo draft a structured project plan."}],"growth-starburst.twc-marketing-email-v2.article1Copy1.jiraConfArticle":[{"type":0,"value":"Start with a simple prompt like \\"plan a Q3 launch\\" and let Rovo draft a structured project plan. Turn key milestones into Jira work items, with fields, assignees, and due dates pre\u2011filled and linked back to a plan in Confluence."}],"growth-starburst.twc-marketing-email-v2.article1Copy2.confluenceArticle":[{"type":0,"value":"Turn key milestones into Jira issues, with fields, assignees, and due dates pre\u2011filled and linked back to your plan in Confluence."}],"growth-starburst.twc-marketing-email-v2.article1Copy2.jiraArticle":[{"type":0,"value":"Turn key milestones into Jira work items, with fields, assignees, and due dates pre\u2011filled and linked back to a plan in Confluence."}],"growth-starburst.twc-marketing-email-v2.article1Copy2.jiraConfArticle":[{"type":0,"value":"Add a Loom recording to your pages & tickets to keep your teams up to date!"}],"growth-starburst.twc-marketing-email-v2.article1Subhead.confluenceArticle":[{"type":0,"value":"From project idea \u2192 structured plan"}],"growth-starburst.twc-marketing-email-v2.article1Subhead.jiraArticle":[{"type":0,"value":"From project idea \u2192 structured plan"}],"growth-starburst.twc-marketing-email-v2.article1Subhead.jiraConfArticle":[{"type":0,"value":"From project idea \u2192 structured plan"}],"growth-starburst.twc-marketing-email-v2.article2Copy1.confluenceArticle":[{"type":0,"value":"Write specs in Confluence, create linked Jira work items with tasks, owners, and due dates."}],"growth-starburst.twc-marketing-email-v2.article2Copy1.jiraArticle":[{"type":0,"value":"Confluence captures your project plans, notes, and decision logs as organized knowledge that stays connected to your Jira work."}],"growth-starburst.twc-marketing-email-v2.article2Copy1.jiraConfArticle":[{"type":0,"value":"Confluence captures your project plans, notes, and decision logs as organized knowledge that stays connected to your Jira work."}],"growth-starburst.twc-marketing-email-v2.article2Copy2.confluenceArticle":[{"type":0,"value":"No more \\"Who picked this?\\" or \\"Who\'s on point?\\" weeks later."}],"growth-starburst.twc-marketing-email-v2.article2Copy2.jiraArticle":[{"type":0,"value":"See the \\"why\\" and \\"how\\" behind any work item \u2013 no digging required."}],"growth-starburst.twc-marketing-email-v2.article2Copy2.jiraConfArticle":[{"type":0,"value":"See the \\"why\\" and \\"how\\" behind any work item \u2013 no digging required."}],"growth-starburst.twc-marketing-email-v2.article2Subhead.confluenceArticle":[{"type":0,"value":"Product requirements \u2192 Development tickets"}],"growth-starburst.twc-marketing-email-v2.article2Subhead.jiraArticle":[{"type":0,"value":"Docs and decisions that stay in sync with issues"}],"growth-starburst.twc-marketing-email-v2.article2Subhead.jiraConfArticle":[{"type":0,"value":"Docs and decisions that stay in sync with issues"}],"growth-starburst.twc-marketing-email-v2.article3Copy1.confluenceArticle":[{"type":0,"value":"Drop Loom videos straight into Confluence pages and Jira work items to add instant visual context and reduce confusion."}],"growth-starburst.twc-marketing-email-v2.article3Copy1.jiraArticle":[{"type":0,"value":"Drop Loom videos straight into Jira work items and Confluence pages to add instant visual context and reduce confusion."}],"growth-starburst.twc-marketing-email-v2.article3Copy1.jiraConfArticle":[{"type":0,"value":"Add Instant Visual Context: Embed Loom videos directly into your Jira issues and Confluence pages to clearly explain complex ideas and reduce confusion. Automate Next Steps: Let AI automatically summarize your recordings, extract key feedback, and link action items directly to your work."}],"growth-starburst.twc-marketing-email-v2.article3Copy2.confluenceArticle":[{"type":0,"value":"Then let Loom AI auto\u2011capture feedback, summarize meetings, and turn recordings into action items so work keeps moving forward without more meetings."}],"growth-starburst.twc-marketing-email-v2.article3Copy2.jiraArticle":[{"type":0,"value":"Then let Loom AI auto\u2011capture feedback, summarize meetings, and turn recordings into action items so work keeps moving forward without more meetings."}],"growth-starburst.twc-marketing-email-v2.article3Copy2.jiraConfArticle":[{"type":0,"value":"Eliminate Additional Meetings: Keep your team perfectly aligned and work moving forward asynchronously"}],"growth-starburst.twc-marketing-email-v2.article3Subhead.confluenceArticle":[{"type":0,"value":"Async updates without more meetings"}],"growth-starburst.twc-marketing-email-v2.article3Subhead.jiraArticle":[{"type":0,"value":"Async updates without more meetings"}],"growth-starburst.twc-marketing-email-v2.article3Subhead.jiraConfArticle":[{"type":0,"value":"Async updates without more meetings"}],"growth-starburst.twc-marketing-email-v2.articleHeader.confluenceArticle":[{"type":0,"value":"Here\'s how teams use Teamwork Collection:"}],"growth-starburst.twc-marketing-email-v2.articleHeader.jiraArticle":[{"type":0,"value":"Here\'s how teams use Teamwork Collection:"}],"growth-starburst.twc-marketing-email-v2.articleHeader.jiraConfArticle":[{"type":0,"value":"Here\'s how teams use Teamwork Collection:"}],"growth-starburst.twc-marketing-email-v2.bodyCopy.confluenceArticle":[{"type":0,"value":"Your best work already starts in Confluence. "},{"children":[{"type":0,"value":"Teamwork Collection"}],"type":8,"value":"link"},{"type":0,"value":" helps you get to results faster."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.confluenceData":[{"type":0,"value":"Teams that use Teamwork Collection see one consistent pattern: less chaos and faster progress on the work."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.confluencePlatform":[{"type":0,"value":"Confluence is where your team thinks: project plans, decision logs, documentation, meeting notes, etc.\\n\\nBut after you agree on what to do, work frequently scatters into different tools and channels. Tasks get lost, updates go stale, and stakeholders aren\'t sure where to look for the latest.\\n\\n"},{"children":[{"type":0,"value":"Teamwork Collection"}],"type":8,"value":"link"},{"type":0,"value":" closes that gap. \\n\\nTeamwork Collection combines "},{"children":[{"type":0,"value":"Jira + Confluence + Loom + Rovo AI"}],"type":8,"value":"bold"},{"type":0,"value":" into one connected workspace."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraArticle":[{"type":0,"value":"With Teamwork Collection, Jira remains the structured backbone of your work, but your teams also get shared context, knowledge, and AI to help them go further, faster."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfArticle":[{"type":0,"value":"With Teamwork Collection, Jira & Confluence remain the structured backbones of your work, but your teams also get shared context, knowledge, and AI to help them go further, faster."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfData":[{"type":0,"value":"You already have a head start with Jira and Confluence. Upgrading to Teamwork Collection adds Loom and Rovo AI, bringing one consistent pattern to your workflows: less chaos and faster progress on the work."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfDataHasRovo":[{"type":0,"value":"You already have a head start with Jira and Confluence. Upgrading to Teamwork Collection adds Loom, bringing one consistent pattern to your workflows: less chaos and faster progress on the work."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfPlatform":[{"type":0,"value":"Confluence and Jira already help you plan and track your work. Adding Loom and Rovo to your tools brings greater clarity, faster progress, and improved teamwork."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfPlatformHasRovo":[{"type":0,"value":"Confluence and Jira already help you plan and track your work. Adding Loom to your tools brings greater clarity, faster progress, and improved teamwork."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraData":[{"type":0,"value":"Teams that use Teamwork Collection see one consistent pattern: less chaos and faster progress on the work."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraPlatform":[{"type":0,"value":"Teamwork Collection brings Jira, Confluence, Loom, and Rovo AI together, augmenting your work already in Jira with clearer plans, shared context, and fewer status meetings."}],"growth-starburst.twc-marketing-email-v2.bullet1.confluenceData":[{"children":[{"type":0,"value":"3x faster delivery"}],"type":8,"value":"bold"},{"type":0,"value":": Less app switching and manual copy\u2011pasting across tools"}],"growth-starburst.twc-marketing-email-v2.bullet1.confluencePlatform":[{"type":0,"value":"Plan and document in Confluence"}],"growth-starburst.twc-marketing-email-v2.bullet1.jiraConfData":[{"children":[{"type":0,"value":"3x faster delivery"}],"type":8,"value":"bold"},{"type":0,"value":": Less app switching and manual copy-pasting across tools"}],"growth-starburst.twc-marketing-email-v2.bullet1.jiraConfPlatform":[{"type":0,"value":"Plan and track work in Jira, with Rovo AI agents as teammates"}],"growth-starburst.twc-marketing-email-v2.bullet1.jiraData":[{"children":[{"type":0,"value":"3x faster delivery"}],"type":8,"value":"bold"},{"type":0,"value":": Less app switching and manual copy-pasting across tools"}],"growth-starburst.twc-marketing-email-v2.bullet1.jiraPlatform":[{"type":0,"value":"Plan and track work in Jira, with Rovo AI agents as teammates"}],"growth-starburst.twc-marketing-email-v2.bullet2.confluenceData":[{"children":[{"type":0,"value":"50% less time searching for info"}],"type":8,"value":"bold"},{"type":0,"value":": Teams align faster with everyone seeing the same source of truth"}],"growth-starburst.twc-marketing-email-v2.bullet2.confluencePlatform":[{"type":0,"value":"Track and execute in Jira"}],"growth-starburst.twc-marketing-email-v2.bullet2.jiraConfData":[{"children":[{"type":0,"value":"50% less time searching for info"}],"type":8,"value":"bold"},{"type":0,"value":": Teams align faster with everyone seeing the same source of truth"}],"growth-starburst.twc-marketing-email-v2.bullet2.jiraConfPlatform":[{"type":0,"value":"Capture project plans, notes, and decision logs in Confluence and keep them tied to the right work items"}],"growth-starburst.twc-marketing-email-v2.bullet2.jiraData":[{"children":[{"type":0,"value":"50% less time searching for info"}],"type":8,"value":"bold"},{"type":0,"value":": Teams align faster with everyone seeing the same source of truth"}],"growth-starburst.twc-marketing-email-v2.bullet2.jiraPlatform":[{"type":0,"value":"Capture project plans, notes, and decision logs in Confluence and keep them tied to the right work items"}],"growth-starburst.twc-marketing-email-v2.bullet3.confluenceData":[{"children":[{"type":0,"value":"31% increase in project success"}],"type":8,"value":"bold"},{"type":0,"value":": Rovo AI helps teams unlock the knowledge buried in projects"}],"growth-starburst.twc-marketing-email-v2.bullet3.confluencePlatform":[{"type":0,"value":"Share updates asynchronously with Loom"}],"growth-starburst.twc-marketing-email-v2.bullet3.jiraConfData":[{"children":[{"type":0,"value":"31% increase in project success"}],"type":8,"value":"bold"},{"type":0,"value":": Rovo AI helps teams unlock the knowledge buried in projects"}],"growth-starburst.twc-marketing-email-v2.bullet3.jiraConfPlatform":[{"type":0,"value":"Share quick Loom updates instead of scheduling another live meeting"}],"growth-starburst.twc-marketing-email-v2.bullet3.jiraData":[{"children":[{"type":0,"value":"31% increase in project success"}],"type":8,"value":"bold"},{"type":0,"value":": Rovo AI helps teams unlock the knowledge buried in projects"}],"growth-starburst.twc-marketing-email-v2.bullet3.jiraPlatform":[{"type":0,"value":"Share quick Loom updates instead of scheduling another live meeting"}],"growth-starburst.twc-marketing-email-v2.bullet4.confluencePlatform":[{"type":0,"value":"Use Rovo AI to augment your work"}],"growth-starburst.twc-marketing-email-v2.bullet4.jiraConfPlatform":[{"type":0,"value":"Use Rovo to help draft plans, summarize changes, and surface what matters from across your tools"}],"growth-starburst.twc-marketing-email-v2.bullet4.jiraPlatform":[{"type":0,"value":"Use Rovo to help draft plans, summarize changes, and surface what matters from across your tools"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.confluenceData":[{"type":0,"value":"With Teamwork Collection, teams report:"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.confluencePlatform":[{"type":0,"value":"With Teamwork Collection, your team can:"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.jiraConfData":[{"type":0,"value":"With Teamwork Collection, teams report:"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.jiraConfPlatform":[{"type":0,"value":"Teamwork Collection upgrades your workspace by adding Loom for quick, asynchronous video updates and Rovo to connect the dots. Now, your team can see the plan, track the status, and watch the context\u2014all in one place."}],"growth-starburst.twc-marketing-email-v2.bulletHeader.jiraData":[{"type":0,"value":"With Teamwork Collection, teams report:"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.jiraPlatform":[{"type":0,"value":"With Teamwork Collection, your team can:"}],"growth-starburst.twc-marketing-email-v2.closingLine.confluenceData":[{"type":0,"value":"Teamwork Collection brings the power of connected Atlassian tools to your Confluence docs."}],"growth-starburst.twc-marketing-email-v2.closingLine.confluencePlatform":[{"type":0,"value":"The result: one platform to run the whole project."}],"growth-starburst.twc-marketing-email-v2.closingLine.jiraConfData":[{"type":0,"value":"Teamwork Collection brings the power of connected Atlassian tools to your Jira and Confluence workspace."}],"growth-starburst.twc-marketing-email-v2.closingLine.jiraConfPlatform":[{"type":0,"value":"The result: one intelligent platform to run the whole project."}],"growth-starburst.twc-marketing-email-v2.closingLine.jiraData":[{"type":0,"value":"Teamwork Collection brings the power of connected Atlassian tools to your Jira projects."}],"growth-starburst.twc-marketing-email-v2.closingLine.jiraPlatform":[{"type":0,"value":"The result: one intelligent platform to run the whole project."}],"growth-starburst.twc-marketing-email-v2.ctaText.confluenceArticle":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.confluenceData":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.confluencePlatform":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraArticle":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraConfArticle":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraConfData":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraConfPlatform":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraData":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraPlatform":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.emailSubject.confluenceArticle":[{"type":0,"value":"Extend Confluence with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.confluenceData":[{"type":0,"value":"Get 3x faster delivery with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.confluencePlatform":[{"type":0,"value":"Your plans live in Confluence. Where is the work?"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraArticle":[{"type":0,"value":"Elevate Jira with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfArticle":[{"type":0,"value":"Elevate Jira and Confluence workflows with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfData":[{"type":0,"value":"3 ways to speed up your Jira & Confluence workflows"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfPlatform":[{"type":0,"value":"Add context to your workflows with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraData":[{"type":0,"value":"Elevate Jira with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraPlatform":[{"type":0,"value":"Elevate Jira with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.headline.confluenceArticle":[{"type":0,"value":"Take Confluence further with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.headline.confluenceData":[{"type":0,"value":"Get the most out of Confluence with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.headline.confluencePlatform":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraArticle":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraConfArticle":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraConfData":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraConfPlatform":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraData":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraPlatform":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.heroAlt.confluenceArticle":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.confluenceData":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.confluencePlatform":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraArticle":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfArticle":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfData":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfPlatform":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraData":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraPlatform":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.outroText.confluenceArticle":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.confluenceData":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.confluencePlatform":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraArticle":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraConfArticle":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraConfData":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraConfPlatform":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraData":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraPlatform":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroTitle.confluenceArticle":[{"type":0,"value":"Ready to try Teamwork Collection for free?"}],"growth-starburst.twc-marketing-email-v2.outroTitle.jiraArticle":[{"type":0,"value":"Ready to try Teamwork Collection for free?"}],"growth-starburst.twc-marketing-email-v2.outroTitle.jiraConfArticle":[{"type":0,"value":"Ready to try Teamwork Collection for free?"}],"growth-starburst.twc-marketing-email-v2.preheader.confluenceArticle":[{"type":0,"value":"Pages -> projects, decisions -> action, updates -> insight"}],"growth-starburst.twc-marketing-email-v2.preheader.confluenceData":[{"type":0,"value":"Add plans, context, video, and AI to your work"}],"growth-starburst.twc-marketing-email-v2.preheader.confluencePlatform":[{"type":0,"value":"Connect planning, documentation, and delivery"}],"growth-starburst.twc-marketing-email-v2.preheader.jiraArticle":[{"type":0,"value":"Connect work, knowledge, and updates in one place"}],"growth-starburst.twc-marketing-email-v2.preheader.jiraConfArticle":[{"type":0,"value":"Add video, summaries and data-driven context to your updates in one place"}],"growth-starburst.twc-marketing-email-v2.preheader.jiraConfData":[{"type":0,"value":"Connect work, knowledge, and updates in one place with Video and AI context."}],"growth-starburst.twc-marketing-email-v2.preheader.jiraConfPlatform":[{"type":0,"value":"Bridge the gap between planning and execution with clarity."}],"growth-starburst.twc-marketing-email-v2.preheader.jiraData":[{"type":0,"value":"Connect work, knowledge, and updates in one place"}],"growth-starburst.twc-marketing-email-v2.preheader.jiraPlatform":[{"type":0,"value":"Connect work, knowledge, and updates in one place"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.conf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.confAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jira":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.conf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.confAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jira":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.confAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.conf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.confAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jira":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.header.conf":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.confAndLoom":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jira":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork "},{"children":[{"type":0,"value":"3x faster"}],"type":8,"value":"blue"},{"type":0,"value":" with video and AI"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraAndLoom":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraConf":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.conf":[{"type":0,"value":"The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.confAndLoom":[{"type":0,"value":"The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jira":[{"type":0,"value":"Create strategy docs, flowcharts, project plans, and more \u2014 without leaving Jira."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Reduce repetitive syncs and follow-ups \u2014 Loom videos and automated recaps keep everyone aligned."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndLoom":[{"type":0,"value":"Create strategy docs, flowcharts, project plans, and more \u2014 without leaving Jira."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.conf":[{"type":0,"value":"increase speed in decision making"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.confAndLoom":[{"type":0,"value":"increase speed in decision making"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jira":[{"type":0,"value":"boost in project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndLoom":[{"type":0,"value":"boost in project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraConf":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.conf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.confAndLoom":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jira":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraAndLoom":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.conf":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.confAndLoom":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jira":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraAndLoom":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraConf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step3Description.conf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step3Description.jira":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step3Title.conf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step3Title.jira":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.conf":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jira":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.land":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.conf":[{"type":0,"value":"Try Jira today to make getting work done a snap!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jira":[{"type":0,"value":"Try Confluence today to start connecting org-wide knowledge to your work."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.land":[{"type":0,"value":"Try out Confluence today to add context to your work in Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.land":[{"type":0,"value":"Bring your next big idea to life"}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.conf":[{"type":0,"value":"Use Jira to visualize your tasks and workflows. Plus, use AI-powered automations to get the whole team get moving fast."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.jira":[{"type":0,"value":"Use Confluence to capture notes, draft plans, share project insights. Plus, keep it all organized alongside Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.jiraConf":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.land":[{"type":0,"value":"Hit \u201CCreate\u201D in Confluence to jot down notes, draft plans, or share learnings. Pick a ready-made template to start fast."}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83C\uDFCE\uFE0F Kickstart collaboration with Jira & Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83C\uDFCE\uFE0F Kickstart collaboration with Confluence & Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83D\uDDBC\uFE0F See the full picture for your projects"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.conf":[{"type":0,"value":"Plan it, track it, get it done"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.jira":[{"type":0,"value":"Go from cluttered docs to organized knowledge"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.jiraConf":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.land":[{"type":0,"value":"Say \u201Cgoodbye\u201D to boring project docs"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.conf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jira":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jiraConf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.conf":[{"type":0,"value":"Add Jira views as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Confluence to help keep everyone in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jira":[{"type":0,"value":"Add Confluence docs as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira to help keep everyone in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jiraConf":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.conf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jira":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jiraConf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.conf":[{"type":0,"value":"Use a "},{"children":[{"type":0,"value":"board"}],"type":8,"value":"b"},{"type":0,"value":" to arrange issues in columns, or plot work out on a "},{"children":[{"type":0,"value":"timeline"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"calendar"}],"type":8,"value":"b"},{"type":0,"value":" over months or quarters."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jira":[{"type":0,"value":"Add Jira boards, Google forms, Figma designs, Excel spreadsheets & more\u2014right into Confluence. It\'s your team\'s new single source of truth!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.land":[{"type":0,"value":"Embed Jira views, reports, and forms directly into Confluence pages with Smart Links."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.conf":[{"type":0,"value":"View it your way"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jira":[{"type":0,"value":"Connect your work from anywhere"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.land":[{"type":0,"value":"Keep it all in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.conf":[{"type":0,"value":"Let AI automatically transform Confluence notes into trackable work in Jira\u2014no copy-pasting or re-typing needed."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jira":[{"type":0,"value":"Let AI automatically transform Confluence notes into trackable work in Jira\u2014no copy-pasting or re-typing needed."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.land":[{"type":0,"value":"Let AI automatically turn Confluence pages and whiteboards into trackable work in Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.conf":[{"type":0,"value":"Auto-capture action items"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jira":[{"type":0,"value":"Auto-capture action items"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.land":[{"type":0,"value":"Transform ideas into action"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.conf":[{"type":0,"value":"Create and edit Confluence docs and whiteboards right inside Jira to help your team stay connected all in one tool."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jira":[{"type":0,"value":"Create and edit docs, whiteboards (anything, really!) right inside Confluence to help your team stay connected all in one tool."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jiraConf":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.land":[{"type":0,"value":"View, edit, and create Confluence pages and whiteboards right from Jira, without losing context."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.conf":[{"type":0,"value":"Never switch context again!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jira":[{"type":0,"value":"Never switch context again!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jiraConf":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.land":[{"type":0,"value":"View work across teams"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.conf":[{"type":0,"value":"Our top tips for planning and tracking work:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jira":[{"type":0,"value":"Our top tips for connecting team knowledge:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jiraConf":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.land":[{"type":0,"value":"How to plan, track, and doc with Confluence and Jira:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.conf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jira":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.land":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.conf":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jira":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Chat with Rovo AI today to get on the fast-track to productivity."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.land":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to try out Rovo AI?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.land":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.conf":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.jira":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.jiraConf":[{"type":0,"value":"Summarize, search, and streamline any task. No context-switching, no searching\u2014just better results."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.land":[{"type":0,"value":"Record a Loom video to add visual context to project updates, presentations, and training materials in Jira and Confluence."}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83E\uDD2B Your secret to better, faster teamwork"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.conf":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.jira":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.jiraConf":[{"type":0,"value":"Get to \u201Cdone\u201D faster with Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.land":[{"type":0,"value":"Bring work to life with video"}],"growth-starburst.twc-onboarding-email-2.message-template.email.item1.jiraConf":[{"children":[{"type":0,"value":"Take action in a flash"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Chat with Rovo AI to summarize updates, create tasks, and draft content in seconds."}],"growth-starburst.twc-onboarding-email-2.message-template.email.item2.jiraConf":[{"children":[{"type":0,"value":"Find, don\'t search"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Rovo AI Search provides rich, contextual answers grounded in your org\'s knowledge, history, and context."}],"growth-starburst.twc-onboarding-email-2.message-template.email.item3.jiraConf":[{"children":[{"type":0,"value":"Say \u201Chey\u201D to your AI teammate"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Call on Rovo to tackle any task and act on insights across all your apps and integrations."}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.conf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.jira":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.land":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.conf":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.jira":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.land":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.conf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.jira":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.land":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.conf":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.jira":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.land":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.conf":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.jira":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.land":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.conf":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.jira":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.land":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.conf":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.jira":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.land":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.conf":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.jira":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.land":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.conf":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.jira":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.land":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.conf":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jira":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jiraConf":[{"type":0,"value":"Top tips for working smarter & speedier with Rovo AI:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.land":[{"type":0,"value":"How to work with AI-powered videos in Loom:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.conf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jira":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.land":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.conf":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jira":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.land":[{"type":0,"value":"Use Rovo AI to turn deliver big ideas faster and collaborate as a human-AI team. Try out Rovo AI with your collection of apps today."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.conf":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jira":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.land":[{"type":0,"value":"Discover a whole new way to teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.conf":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.jira":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.jiraConf":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.land":[{"type":0,"value":"Supercharge how you work with AI-powered Search, Chat, and Agents\u2014all integrated directly into Jira, Confluence, and Loom."}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83E\uDD29 Here\'s everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.conf":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.jira":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.jiraConf":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.land":[{"type":0,"value":"Get to \u201Cdone\u201D faster with your apps + Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.land":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipButtonText.land":[{"type":0,"value":"Read more"}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipContent.land":[{"type":0,"value":"The Rovo guide introduces the basics of working with AI Search, Chat and agents."}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipHeader.land":[{"type":0,"value":"Pro tip:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.conf":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jira":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.land":[{"type":0,"value":"Need help dreaming up your next big idea? Brainstorm project docs and tasks with Rovo Chat to create everything you need in the blink of an eye."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.conf":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jira":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.land":[{"type":0,"value":"Create anything in seconds!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.conf":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jira":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.land":[{"type":0,"value":"Use Rovo AI to automatically scan Confluence pages for action items and turn them into Jira tasks with just a few clicks."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.conf":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jira":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.land":[{"type":0,"value":"Transform pages into action"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.conf":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jira":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jiraConf":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.land":[{"type":0,"value":"Use Rovo AI to break your Jira work items into easily-achievable sub-tasks. Automatically surface related Confluence pages, and use them to create descriptions."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.conf":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jira":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jiraConf":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.land":[{"type":0,"value":"Instantly enhance your work"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step4Description.land":[{"type":0,"value":"Create and embed a Loom right from your Confluence page (along with AI-generated notes or action items!) and keep everyone in-the-know."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step4Title.land":[{"type":0,"value":"Auto-summarize with video"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.conf":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jira":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jiraConf":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.land":[{"type":0,"value":"Try this workflow for using Jira, Confluence, Loom, and Rovo together:"}],"growth-starburst.twc-onboarding-widget.onboarding-card.dismiss-tooltip":[{"type":0,"value":"Dismiss"}],"growth-starburst.twc-onboarding-widget.onboarding-card.status":[{"type":0,"value":"Completed"}],"growth-starburst.twc-project-pages-confluence-tour.back":[{"type":0,"value":"Back"}],"growth-starburst.twc-project-pages-confluence-tour.dismiss":[{"type":0,"value":"Dismiss"}],"growth-starburst.twc-project-pages-confluence-tour.done":[{"type":0,"value":"Done"}],"growth-starburst.twc-project-pages-confluence-tour.next":[{"type":0,"value":"Next"}],"growth-starburst.twc-project-pages-confluence-tour.step1.description":[{"type":0,"value":"Create, update and manage Jira work directly in Pages."}],"growth-starburst.twc-project-pages-confluence-tour.step1.header":[{"type":0,"value":"Create Jira tasks directly in Pages"}],"growth-starburst.twc-project-pages-confluence-tour.step1.progressIndicator":[{"type":0,"value":"1 of 3"}],"growth-starburst.twc-project-pages-confluence-tour.step2.description":[{"type":0,"value":"Generate content easily and quickly with our AI-powered writing assistant. Type /rovo to try it now."}],"growth-starburst.twc-project-pages-confluence-tour.step2.header":[{"type":0,"value":"Let AI do the writing for you"}],"growth-starburst.twc-project-pages-confluence-tour.step2.progressIndicator":[{"type":0,"value":"2 of 3"}],"growth-starburst.twc-project-pages-confluence-tour.step3.description":[{"type":0,"value":"Loom can create a script from your page content. Record a quick video and add it to your doc to explain updates."}],"growth-starburst.twc-project-pages-confluence-tour.step3.header":[{"type":0,"value":"Share updates with video"}],"growth-starburst.twc-project-pages-confluence-tour.step3.progressIndicator":[{"type":0,"value":"3 of 3"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.conf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.jira":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.land":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.conf":[{"type":0,"value":"See how Jira, Loom, and Rovo plug into your Confluence workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.jira":[{"type":0,"value":"See how Confluence, Loom, and Rovo plug into your Jira workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"See how Loom and Rovo plug into your Jira and Confluence workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.land":[{"type":0,"value":"Jump into Jira to create your first task"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.land":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.content.conf":[{"type":0,"value":"Your new collection of apps supercharges productivity with work tracking across teams, async video, and AI-powered insights\u2014all alongside Confluence."}],"growth-starburst.twc-welcome-email.message-template.email.content.jira":[{"type":0,"value":"Your new collection of apps supercharges productivity with org-wide knowledge sharing, async video, and AI-powered insights\u2014all alongside Jira."}],"growth-starburst.twc-welcome-email.message-template.email.content.jiraConf":[{"type":0,"value":"Your new collection of apps supercharges productivity with async video and AI-powered insights\u2014all alongside Jira & Confluence."}],"growth-starburst.twc-welcome-email.message-template.email.content.land":[{"type":0,"value":"Collaborate and achieve more\u2014right from day one. We\'ll guide you step-by-step over the next few days."}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.header.conf":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.jira":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.jiraConf":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.land":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.conf":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.jira":[{"type":0,"value":"Create and share information effortlessly\u2014plan better, stay aligned, and keep everything you need right at your fingertips."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Send quick video messages that add context, save time, reduce meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.land":[{"type":0,"value":"Create "},{"children":[{"type":0,"value":"work items"}],"type":8,"value":"b"},{"type":0,"value":", which are chunks of work (just like to-dos) that you can break down into smaller, more achievable tasks."}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.conf":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.jira":[{"type":0,"value":"Organize knowledge with Confluence"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.land":[{"type":0,"value":"Break down your work"}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.conf":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.jira":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.land":[{"type":0,"value":"Add "},{"children":[{"type":0,"value":"fields"}],"type":8,"value":"b"},{"type":0,"value":" to include all the important details to your work items, like due dates, assignees, priority, and more."}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.conf":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.jira":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.land":[{"type":0,"value":"Add important details"}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.conf":[{"type":0,"value":"Plan and manage anything\u2014from big projects to daily tasks\u2014with seamless workflows, real-time tracking, and clear alignment to goals."}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.jira":[{"type":0,"value":"Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.land":[{"type":0,"value":"Use a "},{"children":[{"type":0,"value":"board"}],"type":8,"value":"b"},{"type":0,"value":" to arrange work items in columns and by status, or plot work out on a "},{"children":[{"type":0,"value":"timeline"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"calendar"}],"type":8,"value":"b"},{"type":0,"value":" view over months or quarters."}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.conf":[{"type":0,"value":"Get it done with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.jira":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.land":[{"type":0,"value":"View it your way"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.conf":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.jira":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.jiraConf":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.land":[{"type":0,"value":"We recommend starting with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.subheaderDescription.land":[{"type":0,"value":"Managing your projects starts with Jira. Start by setting things up to manage your work more efficiently:"}],"growth-starburst.wac-product-activation-checklist.add-comment.cta":[{"type":0,"value":"Add comment"}],"growth-starburst.wac-product-activation-checklist.add-comment.description":[{"type":0,"value":"Jump back into a recent work item and leave a comment for your team."}],"growth-starburst.wac-product-activation-checklist.add-comment.title":[{"type":0,"value":"Add a comment to a work item"}],"growth-starburst.wac-product-activation-checklist.create-work-item.cta":[{"type":0,"value":"Create work item"}],"growth-starburst.wac-product-activation-checklist.create-work-item.description":[{"type":0,"value":"Use AI to draft a work item in your most recent Jira Software project."}],"growth-starburst.wac-product-activation-checklist.create-work-item.title":[{"type":0,"value":"Create your first Jira work item"}],"growth-starburst.wac-product-activation-checklist.dismiss-checklist":[{"type":0,"value":"Dismiss checklist"}],"growth-starburst.wac-product-activation-checklist.invite-team.cta":[{"type":0,"value":"Invite team"}],"growth-starburst.wac-product-activation-checklist.invite-team.description":[{"type":0,"value":"Bring teammates into Jira so everyone can collaborate in one place."}],"growth-starburst.wac-product-activation-checklist.invite-team.title":[{"type":0,"value":"Invite your team"}],"growth-starburst.wac-product-activation-checklist.item-completed":[{"type":0,"value":"Completed"}],"growth-starburst.wac-product-activation-checklist.update-work-item.cta":[{"type":0,"value":"Update work item"}],"growth-starburst.wac-product-activation-checklist.update-work-item.description":[{"type":0,"value":"Open a recent work item and update one of its fields."}],"growth-starburst.wac-product-activation-checklist.update-work-item.title":[{"type":0,"value":"Update a work item"}],"jira-project-space-connected.message-templates.spotlight-description-couse":[{"type":0,"value":"Create pages for your project without leaving Jira."}],"jira-project-space-connected.message-templates.spotlight-description-xflow":[{"type":0,"value":"Create Confluence pages within Jira. Free for 10 users."}],"jira-project-space-connected.message-templates.spotlight-header-couse":[{"type":0,"value":"Your project has Confluence pages"}],"jira-project-space-connected.message-templates.spotlight-header-xflow":[{"type":0,"value":"Add pages to your project"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body":[{"type":0,"value":"Instead of manually typing meeting notes, why not try Loom to record meetings?"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close":[{"type":0,"value":"Close"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta":[{"type":0,"value":"Try now"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header":[{"type":0,"value":"Automate meeting notes"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt":[{"type":0,"value":"Notepad with sparkling background"}],"post-office.project-assets-ai-suggestions.empty-state":[{"type":0,"value":"No suggestions available right now."}],"post-office.project-assets-ai-suggestions.header.loaded":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" suggested action"}]},"other":{"value":[{"type":7},{"type":0,"value":" suggested actions"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"post-office.project-assets-ai-suggestions.header.loading":[{"type":0,"value":"Rovo is analyzing\u2026"}],"post-office.project-assets-ai-suggestions.loom-meeting-notes.cta":[{"type":0,"value":"Set up Loom"}],"post-office.project-assets-ai-suggestions.loom-meeting-notes.description":[{"type":0,"value":"Use Loom to record meetings and auto-create notes, so you never forget next steps."}],"post-office.project-assets-ai-suggestions.loom-meeting-notes.title":[{"type":0,"value":"Set up meeting notes"}],"post-office.project-assets-ai-suggestions.project-plan.cta":[{"type":0,"value":"Create summary"}],"post-office.project-assets-ai-suggestions.project-plan.description":[{"type":0,"value":"Create a project plan for your newly added epic "},{"type":1,"value":"epicKey"},{"type":0,"value":" to share with your team."}],"post-office.project-assets-ai-suggestions.project-plan.title":[{"type":0,"value":"Create a project plan"}],"post-office.project-assets-ai-suggestions.toggle.hide":[{"type":0,"value":"Hide"}],"post-office.project-assets-ai-suggestions.toggle.show":[{"type":0,"value":"Show"}],"post-office.project-assets-ai-suggestions.weekly-summary.additional-count":[{"type":0,"value":" +"},{"type":1,"value":"count"}],"post-office.project-assets-ai-suggestions.weekly-summary.cta":[{"type":0,"value":"Create summary"}],"post-office.project-assets-ai-suggestions.weekly-summary.description":[{"type":0,"value":"Create a summary for completed tasks "},{"type":1,"value":"issueKey"},{"type":1,"value":"additionalCount"},{"type":0,"value":" to share with leadership."}],"post-office.project-assets-ai-suggestions.weekly-summary.title":[{"type":0,"value":"Create a weekly summary"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.for-you-spotlight-text":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.rovo-chat-spotlight-text":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.switcher-spotlight-text":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-modal.progress":[{"type":1,"value":"currentSpotlightNumber"},{"type":0,"value":"/"},{"type":1,"value":"numTotalSpotlights"}],"townsquare.townsquare-twc-modal.twc-modal-story.for-you-spotlight-text.no-translate":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-twc-modal.twc-modal-story.rovo-chat-spotlight-text.no-translate":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-twc-modal.twc-modal-story.switcher-spotlight-text.no-translate":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.for-you-spotlight-text.no-translate":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.rovo-chat-spotlight-text.no-translate":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.switcher-spotlight-text.no-translate":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-spotlight.progress":[{"type":1,"value":"currentSpotlightNumber"},{"type":0,"value":"/"},{"type":1,"value":"numTotalSpotlights"}],"townsquare.twc-onboarding-modal.app-switcher.body":[{"type":0,"value":"Use this menu to easily switch between other Atlassian apps."}],"townsquare.twc-onboarding-modal.app-switcher.heading":[{"type":0,"value":"Find all your apps here"}],"townsquare.twc-onboarding-modal.apps-icon-label":[{"type":0,"value":"Apps"}],"townsquare.twc-onboarding-modal.atlassian-home":[{"type":0,"value":"Access all your "},{"children":[{"type":0,"value":"work"}],"type":8,"value":"bold"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"spaces"}],"type":8,"value":"bold"},{"type":0,"value":" in Atlassian Home"}],"townsquare.twc-onboarding-modal.atlassian-logo-label":[{"type":0,"value":"Atlassian"}],"townsquare.twc-onboarding-modal.back-button":[{"type":0,"value":"Back"}],"townsquare.twc-onboarding-modal.close-button-label":[{"type":0,"value":"Close onboarding modal"}],"townsquare.twc-onboarding-modal.confluence-feature":[{"type":0,"value":"Document notes and knowledge in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.confluence-icon-label":[{"type":0,"value":"Confluence"}],"townsquare.twc-onboarding-modal.connect-integrations":[{"type":0,"value":"Connect work with "},{"children":[{"type":0,"value":"teams, AI,"}],"type":8,"value":"bold"},{"type":0,"value":" and more"}],"townsquare.twc-onboarding-modal.connect-work-title":[{"type":0,"value":"Connect work across Atlassian"}],"townsquare.twc-onboarding-modal.description":[{"type":0,"value":"Collaborating is easier than ever with new apps and features, including AI-powered Search and Chat."}],"townsquare.twc-onboarding-modal.explore-atlassian-home":[{"type":0,"value":"Explore Atlassian Home"}],"townsquare.twc-onboarding-modal.explore-loom":[{"type":0,"value":"Explore Loom"}],"townsquare.twc-onboarding-modal.for-you.body":[{"type":0,"value":"Home connects work from across Atlassian, giving you an overview of what\'s happening across teams, goals, and projects."}],"townsquare.twc-onboarding-modal.for-you.generic-heading":[{"type":0,"value":"Welcome Home!"}],"townsquare.twc-onboarding-modal.for-you.heading":[{"type":0,"value":"Welcome Home, "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"townsquare.twc-onboarding-modal.got-it-button":[{"type":0,"value":"Got it"}],"townsquare.twc-onboarding-modal.home-icon-label":[{"type":0,"value":"Home"}],"townsquare.twc-onboarding-modal.illustration-alt":[{"type":0,"value":"Illustration showing collaborative teamwork with connected apps and AI-powered features"}],"townsquare.twc-onboarding-modal.integration-feature":[{"type":0,"value":"Bring it all together with "},{"children":[{"type":0,"value":"teams, AI,"}],"type":8,"value":"bold"},{"type":0,"value":" and more"}],"townsquare.twc-onboarding-modal.integration-icon-label":[{"type":0,"value":"Integration"}],"townsquare.twc-onboarding-modal.jira-confluence-features":[{"type":0,"value":"Add context in "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"bold"},{"type":0,"value":" with detailed docs in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.jira-feature":[{"type":0,"value":"Map out your team\'s work and tasks in "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.jira-icon-label":[{"type":0,"value":"Jira"}],"townsquare.twc-onboarding-modal.left-align-icon-label":[{"type":0,"value":"Align Text Left"}],"townsquare.twc-onboarding-modal.loom-add-demos":[{"type":0,"value":"Add "},{"children":[{"type":0,"value":"demos"}],"type":8,"value":"bold"},{"type":0,"value":" and walkthroughs of your work in Jira"}],"townsquare.twc-onboarding-modal.loom-bring-together":[{"type":0,"value":"Bring it all together with "},{"children":[{"type":0,"value":"teams, goals, AI"}],"type":8,"value":"bold"},{"type":0,"value":", and more"}],"townsquare.twc-onboarding-modal.loom-description":[{"type":0,"value":"Loom makes it easy to record videos and streamline communication in the apps you already use:"}],"townsquare.twc-onboarding-modal.loom-feature":[{"type":0,"value":"Share and embed async video updates with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.loom-icon-label":[{"type":0,"value":"Loom"}],"townsquare.twc-onboarding-modal.loom-share-updates":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"bold"},{"type":0,"value":" to easily share updates and knowledge"}],"townsquare.twc-onboarding-modal.loom-title":[{"type":0,"value":"Create better shareouts with Loom"}],"townsquare.twc-onboarding-modal.loom-use-videos":[{"type":0,"value":"Use videos to give "},{"children":[{"type":0,"value":"context"}],"type":8,"value":"bold"},{"type":0,"value":" to Confluence pages"}],"townsquare.twc-onboarding-modal.new-apps-one":[{"type":0,"value":"Streamline work with "},{"children":[{"type":1,"value":"appOneName"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.new-apps-title":[{"type":0,"value":"New apps and features are here"}],"townsquare.twc-onboarding-modal.new-apps-two":[{"type":0,"value":"Streamline work with "},{"children":[{"type":1,"value":"appOneName"}],"type":8,"value":"bold"},{"type":0,"value":" and "},{"children":[{"type":1,"value":"appTwoName"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.next-button":[{"type":0,"value":"Next"}],"townsquare.twc-onboarding-modal.ok-button":[{"type":0,"value":"Ok"}],"townsquare.twc-onboarding-modal.rovo-chat.body":[{"type":0,"value":"You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."}],"townsquare.twc-onboarding-modal.rovo-chat.heading":[{"type":0,"value":"Chat with AI"}],"townsquare.twc-onboarding-modal.spotlight.close-button-label":[{"type":0,"value":"Close onboarding spotlight tour"}],"townsquare.twc-onboarding-modal.take-a-tour-button":[{"type":0,"value":"Take a tour"}],"townsquare.twc-onboarding-modal.teams-icon-label":[{"type":0,"value":"Integration"}],"townsquare.twc-onboarding-modal.title":[{"type":0,"value":"Transform teamwork, together"}],"townsquare.twc-onboarding-modal.try-now-button":[{"type":0,"value":"Try now"}],"townsquare.twc-onboarding-spotlight.app-switcher.body":[{"type":0,"value":"Use this menu to easily switch between other Atlassian apps."}],"townsquare.twc-onboarding-spotlight.app-switcher.heading":[{"type":0,"value":"Find all your apps here"}],"townsquare.twc-onboarding-spotlight.back-button":[{"type":0,"value":"Back"}],"townsquare.twc-onboarding-spotlight.close-button-label":[{"type":0,"value":"Close"}],"townsquare.twc-onboarding-spotlight.for-you.body":[{"type":0,"value":"Home connects work from across Atlassian, giving you an overview of what\'s happening across teams, goals, and projects."}],"townsquare.twc-onboarding-spotlight.for-you.generic-heading":[{"type":0,"value":"Welcome Home!"}],"townsquare.twc-onboarding-spotlight.for-you.heading":[{"type":0,"value":"Welcome Home, "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"townsquare.twc-onboarding-spotlight.next-button":[{"type":0,"value":"Next"}],"townsquare.twc-onboarding-spotlight.ok-button":[{"type":0,"value":"Ok"}],"townsquare.twc-onboarding-spotlight.rovo-chat.body":[{"type":0,"value":"You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."}],"townsquare.twc-onboarding-spotlight.rovo-chat.heading":[{"type":0,"value":"Chat with AI"}],"townsquare.twc-onboarding-spotlight.try-now-button":[{"type":0,"value":"Try now"}],"townsquare.twc-onboarding-widget.chat-card.cta":[{"type":0,"value":"Try Chat"}],"townsquare.twc-onboarding-widget.chat-card.description":[{"type":0,"value":"Get helpful answers to your questions and collaborate with AI on your work."}],"townsquare.twc-onboarding-widget.chat-card.heading":[{"type":0,"value":"Chat with Rovo"}],"townsquare.twc-onboarding-widget.confluence-card.cta":[{"type":0,"value":"Try Confluence"}],"townsquare.twc-onboarding-widget.confluence-card.description":[{"type":0,"value":"Create a knowledge bank available to everyone in your team."}],"townsquare.twc-onboarding-widget.confluence-card.heading":[{"type":0,"value":"Write docs with Confluence"}],"townsquare.twc-onboarding-widget.goals-card.cta":[{"type":0,"value":"Try Goals"}],"townsquare.twc-onboarding-widget.goals-card.description":[{"type":0,"value":"Align your work with goals to make sure you are on track."}],"townsquare.twc-onboarding-widget.goals-card.heading":[{"type":0,"value":"Track progress with goals"}],"townsquare.twc-onboarding-widget.jira-card.cta":[{"type":0,"value":"Try Jira"}],"townsquare.twc-onboarding-widget.jira-card.description":[{"type":0,"value":"Create project tasks to begin managing your project."}],"townsquare.twc-onboarding-widget.jira-card.heading":[{"type":0,"value":"Plan out tasks with Jira"}],"townsquare.twc-onboarding-widget.loom-card.cta":[{"type":0,"value":"Try Loom"}],"townsquare.twc-onboarding-widget.loom-card.description":[{"type":0,"value":"Share async video updates and reduce meetings for all."}],"townsquare.twc-onboarding-widget.loom-card.heading":[{"type":0,"value":"Share updates with Loom"}],"townsquare.twc-onboarding-widget.search-card.cta":[{"type":0,"value":"Try Search"}],"townsquare.twc-onboarding-widget.search-card.description":[{"type":0,"value":"Power up your searches with AI and find what you\'re looking for faster."}],"townsquare.twc-onboarding-widget.search-card.heading":[{"type":0,"value":"Find more with Search"}],"townsquare.twc-onboarding-widget.studio-card.cta":[{"type":0,"value":"Try Studio"}],"townsquare.twc-onboarding-widget.studio-card.description":[{"type":0,"value":"Build custom AI agents, automations, and more without needing to code."}],"townsquare.twc-onboarding-widget.studio-card.heading":[{"type":0,"value":"Automate work with Studio"}],"townsquare.twc-onboarding-widget.teams-card.cta":[{"type":0,"value":"Try Teams"}],"townsquare.twc-onboarding-widget.teams-card.description":[{"type":0,"value":"Collaborate more with teams and unlock the power of your teammates."}],"townsquare.twc-onboarding-widget.teams-card.heading":[{"type":0,"value":"Collaborate with teams"}],"townsquare.twc-onboarding-widget.twc-card.cta":[{"type":0,"value":"Watch video"}],"townsquare.twc-onboarding-widget.twc-card.description":[{"type":0,"value":"Not sure where to start? Find out how your apps can streamline your work."}],"townsquare.twc-onboarding-widget.twc-card.heading":[{"type":0,"value":"See how it all works together"}],"townsquare.twc-onboarding-widget.twc-card.modal-close":[{"type":0,"value":"Close"}],"townsquare.twc-onboarding-widget.twc-card.modal-external-link":[{"type":0,"value":"Open link"}],"townsquare.twc-onboarding-widget.twc-card.modal-title":[{"type":0,"value":"Welcome to Atlassian"}],"twc-jira.email.header.alt":[{"type":0,"value":"Jira"}],"twc.email.header.alt":[{"type":0,"value":"Teamwork Collection Atlassian"}],"twc.sidenav.banner.generic.app.tiles.alt":[{"type":0,"value":"App tiles illustration"}],"twc.sidenav.banner.generic.close":[{"type":0,"value":"Close"}],"twc.sidenav.banner.generic.cta":[{"type":0,"value":"Try now"}],"twc.sidenav.banner.generic.heading":[{"type":0,"value":"Explore Teamwork Collection"}],"twc.sidenav.banner.generic.subheading.confluence":[{"type":0,"value":"Discover how the other apps can accelerate your workflows in Confluence."}],"twc.sidenav.banner.generic.subheading.jira":[{"type":0,"value":"Discover how the other apps can accelerate your workflows in Jira."}],"twc.sidenav.banner.personalized.app.tiles.alt":[{"type":0,"value":"App tiles illustration"}],"twc.sidenav.banner.personalized.close":[{"type":0,"value":"Close"}],"twc.sidenav.banner.personalized.cta":[{"type":0,"value":"Get started"}],"twc.sidenav.banner.personalized.heading":[{"type":0,"value":"Explore Teamwork Collection"}],"twc.sidenav.banner.personalized.subheading.confluence":[{"type":0,"value":"Create with Rovo in Confluence"}],"twc.sidenav.banner.personalized.subheading.jira":[{"type":0,"value":"Plan your next team project in Jira"}],"twc.sidenav.banner.personalized.subheading.loom":[{"type":0,"value":"Setup video meetings with Loom AI"}],"twc.solo.admin.invite.body.comment_created_v2":[{"type":0,"value":"Invite your team so they can see your comments, reply, and stay in the loop!"}],"twc.solo.admin.invite.body.issue_completed_v2":[{"type":0,"value":"Invite your team so they can review your completed Jira ticket, leave comments, and create a new one!"}],"twc.solo.admin.invite.body.issue_created_only_v2":[{"type":0,"value":"Invite your team so they can review your new Jira ticket, leave comments, and help you finish it!"}],"twc.solo.admin.invite.body.loom_active_v2":[{"type":0,"value":"Invite your team so they can watch your Loom, leave comments, and record their own videos!"}],"twc.solo.admin.invite.body.no_actions":[{"type":0,"value":"Teamwork Collection is better together. Invite your team and try creating a page together, assigning a task, or recording a quick Loom!"}],"twc.solo.admin.invite.body.page_edited_v2":[{"type":0,"value":"Invite your team so they can review your edited doc, leave comments, and add their own ideas!"}],"twc.solo.admin.invite.body.template_used_v2":[{"type":0,"value":"Invite your team so they can use your template, leave comments, and add their own ideas!"}],"twc.solo.admin.invite.cta":[{"type":0,"value":"Invite teammates"}],"twc.solo.admin.invite.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"twc.solo.admin.invite.headline.no_actions":[{"type":0,"value":"Now that you have Teamwork Collection, bring in your team!"}],"twc.solo.admin.invite.headline.shared_v2":[{"type":0,"value":"Teams that share are "},{"children":[{"type":0,"value":"4x"}],"type":8,"value":"em"},{"type":0,"value":" more likely to stay on track"}],"twc.solo.admin.invite.hero.alt.comment_created":[{"type":0,"value":"Illustration of a comment being shared with teammates"}],"twc.solo.admin.invite.hero.alt.issue_completed":[{"type":0,"value":"Illustration of a completed Jira issue being shared with teammates"}],"twc.solo.admin.invite.hero.alt.issue_created_only":[{"type":0,"value":"Illustration of a new Jira issue being shared with teammates"}],"twc.solo.admin.invite.hero.alt.loom_active":[{"type":0,"value":"Illustration of a Loom recording being shared with teammates"}],"twc.solo.admin.invite.hero.alt.no_actions":[{"type":0,"value":"Illustration of Jira, Confluence, Loom and Rovo working together"}],"twc.solo.admin.invite.hero.alt.page_edited":[{"type":0,"value":"Illustration of an edited document being shared with teammates"}],"twc.solo.admin.invite.hero.alt.template_used":[{"type":0,"value":"Illustration of a template being shared with teammates"}],"twc.solo.admin.invite.preheader.comment_created":[{"type":0,"value":"You\'ve started a conversation\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.issue_completed":[{"type":0,"value":"You\'ve completed a Jira ticket\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.issue_created_only":[{"type":0,"value":"You\'ve created a Jira ticket\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.loom_active":[{"type":0,"value":"You\'ve recorded a Loom\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.no_actions":[{"type":0,"value":"Bring in your team to collaborate across your apps"}],"twc.solo.admin.invite.preheader.page_edited":[{"type":0,"value":"You\'ve edited a doc\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.template_used":[{"type":0,"value":"You\'ve set up a template\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.secondary.body":[{"type":0,"value":"Invite your teammates to open up the conversation."}],"twc.solo.admin.invite.secondary.heading":[{"type":0,"value":"Teamwork Collection\u2019s better together"}],"twc.solo.admin.invite.signoff":[{"type":0,"value":"The Atlassian Team"}],"twc.solo.admin.invite.subject.comment_created":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.issue_completed":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.issue_created_only":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.loom_active":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.no_actions":[{"type":0,"value":"\uD83D\uDC65 Teamwork Collection is better together"}],"twc.solo.admin.invite.subject.page_edited":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.template_used":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}]}');

});

parcelRegister("6LbMu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ivDFK").then(()=>parcelRequire('gjXkn'));

});

parcelRegister("eVkgB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dBxXx").then(()=>parcelRequire('f49gl'));

});

parcelRegister("6ZLzr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k7Gla").then(()=>parcelRequire('68vrT'));

});

parcelRegister("5EE4K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9ClYb").then(()=>parcelRequire('2LVTo'));

});

parcelRegister("fDBkx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("54aLX").then(()=>parcelRequire('jIvPr'));

});

parcelRegister("ioRKf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("36Edt").then(()=>parcelRequire('7yn2G'));

});

parcelRegister("b9sN7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9iziV").then(()=>parcelRequire('j3zQQ'));

});

parcelRegister("l6EUT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cA1Fh").then(()=>parcelRequire('gS6RJ'));

});

parcelRegister("k6uw8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eOoTt").then(()=>parcelRequire('3zqgj'));

});

parcelRegister("3O9m6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("96VBe").then(()=>parcelRequire('89ulL'));

});

parcelRegister("kRDFs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3sCSX").then(()=>parcelRequire('34D20'));

});

parcelRegister("kbxxG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fXrKh").then(()=>parcelRequire('7tZ1k'));

});

parcelRegister("750ZX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iscEi").then(()=>parcelRequire('aLmFr'));

});

parcelRegister("jUxwl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("80Lnc").then(()=>parcelRequire('9DbDv'));

});

parcelRegister("7S2dm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8qVoS").then(()=>parcelRequire('hJlWu'));

});

parcelRegister("df6KN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7AMO4").then(()=>parcelRequire('ImGT2'));

});

parcelRegister("5sZd2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bnpvZ").then(()=>parcelRequire('18Zp9'));

});

parcelRegister("fuWtJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8udxR").then(()=>parcelRequire('hik28'));

});

parcelRegister("aP48v", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iC1sH").then(()=>parcelRequire('6eMOl'));

});

parcelRegister("9zaRn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7k6Dg").then(()=>parcelRequire('cR73s'));

});

parcelRegister("9GQxx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("giSpt").then(()=>parcelRequire('cwald'));

});

parcelRegister("46JA9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5UTQt").then(()=>parcelRequire('bAVjS'));

});

parcelRegister("4WUkn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8j6ZQ").then(()=>parcelRequire('5PY0r'));

});

parcelRegister("1BbM7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l8uj3").then(()=>parcelRequire('dgxW7'));

});

parcelRegister("8A06n", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("97Wld").then(()=>parcelRequire('3a3WQ'));

});

parcelRegister("aiNlN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ad7nk").then(()=>parcelRequire('flGIN'));

});

parcelRegister("lGrmZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h5bjO").then(()=>parcelRequire('3Vfss'));

});

parcelRegister("dU2EI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5z6V9").then(()=>parcelRequire('f67OX'));

});

parcelRegister("4hRWZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hTms5").then(()=>parcelRequire('3pNzP'));

});

parcelRegister("eLr07", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gCTY9").then(()=>parcelRequire('3Bx7O'));

});

parcelRegister("13Eco", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lcSR9").then(()=>parcelRequire('dOsMU'));

});

parcelRegister("9NlO7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hqy8N").then(()=>parcelRequire('d3yaB'));

});

parcelRegister("aRVMO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Yc2H").then(()=>parcelRequire('4Hikh'));

});

parcelRegister("1Cksm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8WT4s").then(()=>parcelRequire('7vkZl'));

});


parcelRegister("7IH13", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $78e1f7e665e23189$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $mQRei = parcelRequire("mQRei");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $78e1f7e665e23189$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $78e1f7e665e23189$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("7BxUV")));
        case 'da':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("5qWxs")));
        case 'de':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("81uaY")));
        case 'en-GB':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("2tPwl")));
        case 'en-US':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("bUcjD")));
        case 'en-XA':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("1SnHm")));
        case 'en-XB':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("lfmrS")));
        case 'en-ZZ':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("eE1j8")));
        case 'en':
            return $78e1f7e665e23189$var$importHelper(await Promise.resolve((parcelRequire("mQRei"))));
        case 'es':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("dDn3W")));
        case 'et':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("iAD78")));
        case 'fi':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("7LfmV")));
        case 'fr':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("45ZNZ")));
        case 'hr':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("dOek7")));
        case 'hu':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("iqfhS")));
        case 'it':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("j8g0m")));
        case 'ja':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("7xcip")));
        case 'ko':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("gzqAe")));
        case 'nb':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("h4cvR")));
        case 'nl':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("RCe3b")));
        case 'pl':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("fugiN")));
        case 'pt-BR':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("5K4qX")));
        case 'ro':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("05hAH")));
        case 'ru':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("1bbkB")));
        case 'sl':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("awqlY")));
        case 'sr-RS':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("4Sb6K")));
        case 'sr-YR':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("dJbdN")));
        case 'sr':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("eDT8n")));
        case 'sv':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("judG9")));
        case 'th':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("gdVDP")));
        case 'tr':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("dtTxI")));
        case 'uk':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("kHRqi")));
        case 'vi':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("E8fu8")));
        case 'zh-CN':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("bbqO0")));
        case 'zh-TW':
            return $78e1f7e665e23189$var$importHelper(await (parcelRequire("fw5kn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($mQRei));
    }
};

});
parcelRegister("mQRei", function(module, exports) {
module.exports = JSON.parse('{"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.admin-key":[{"children":[{"type":0,"value":"Admin key"}],"type":8,"value":"b"},{"type":0,"value":": Access restricted content so you can fix issues"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.advanced-insights":[{"children":[{"type":0,"value":"Advanced insights"}],"type":8,"value":"b"},{"type":0,"value":": Audit and track all admin activity"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.support":[{"children":[{"type":0,"value":"24/7 support"}],"type":8,"value":"b"},{"type":0,"value":": Dedicated support team for critical issues"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Mission Control\' feature on the Premium plan. This will give them a dashboard to easily see activity across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Mission Control\' feature on the Confluence Premium plan. This will give them a dashboard to easily see activity across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Mission Control\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.title":[{"type":0,"value":"Help your team do more and worry less"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Mission Control\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" stay across team activity"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-features-title":[{"type":0,"value":"You also get more admin features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.description":[{"type":0,"value":"Someone on your team wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced page elements"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.title":[{"type":0,"value":"Help your team create engaging content"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced page elements"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" create engaging content"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.description":[{"type":0,"value":"Someone on your team wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced permissions features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.title":[{"type":0,"value":"Help your team manage access better"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced permissions features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" manage access better"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Company Hub\' feature on the Premium plan. This will let them create a central place for updates and key resources."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.description":[{"type":0,"value":"Someone on your team wants to try the \u2018Company Hub\u2019 feature on the Premium plan. This will let them create a central place for updates and key resources."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Company Hub\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.title":[{"type":0,"value":"Give your team one place to share updates"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Company Hub\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.title":[{"type":0,"value":"Give "},{"type":1,"value":"firstName"},{"type":0,"value":" one place to share updates"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Content manager\' feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.description":[{"type":0,"value":"Someone on your team wants to try the \u2018Content Manager\u2019 feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Content manager\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.title":[{"type":0,"value":"Help your team keep spaces organised"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Content manager\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" keep spaces organised"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.body-description":[{"children":[{"type":0,"value":"Let "},{"type":1,"value":"firstName"},{"type":0,"value":" try on a free, "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Cancel anytime. We\'ll remind you "},{"type":1,"value":"reminderDays"},{"type":0,"value":" days before your trial ends."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.description":[{"type":1,"value":"firstName"},{"type":0,"value":" has requested to try features on the Confluence Premium plan."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.body-description":[{"children":[{"type":0,"value":"Let your team member try on a free, "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Cancel anytime. We\'ll remind you "},{"type":1,"value":"reminderDays"},{"type":0,"value":" days before your trial ends."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.description":[{"type":0,"value":"Someone on your team has requested to try features on the Confluence Premium plan."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try new features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for your team"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try new features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for "},{"type":1,"value":"firstName"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.explore-all-features":[{"type":0,"value":"Explore all features \u2192"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.get-started-button":[{"type":0,"value":"Get Started"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.img.alt":[{"type":0,"value":"Confluence logo"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.learn-more":[{"type":0,"value":"Learn more"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.description":[{"type":0,"value":"Someone on your team wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced whiteboard features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.title":[{"type":0,"value":"Boost your team\'s collaboration"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced whiteboard features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.title":[{"type":0,"value":"Boost "},{"type":1,"value":"firstName"},{"type":0,"value":"\'s team collaboration"}],"growth-luna.jira-automation-limit-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"growth-luna.jira-automation-limit-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"growth-luna.jira-automation-limit-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"growth-luna.jira-automation-limit-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"growth-luna.jira-automation-limit-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"growth-luna.jira-automation-limit-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"growth-luna.jira-automation-limit-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"growth-luna.jira-recommend-retrial.banner.cta.permissions":[{"type":0,"value":"Set up permissions"}],"growth-luna.jira-recommend-retrial.banner.cta.plans":[{"type":0,"value":"Create a plan"}],"growth-luna.jira-recommend-retrial.banner.title.permissions":[{"type":0,"value":"Keep work secure"}],"growth-luna.jira-recommend-retrial.banner.title.plans":[{"type":0,"value":"See all your timelines in one plan"}],"growth-luna.jira-recommend-retrial.permissions.allow-customer-submissions":[{"type":0,"value":"Allow customers to submit bugs and requests"}],"growth-luna.jira-recommend-retrial.permissions.assign-roles":[{"type":0,"value":"Assign roles for groups, teams, or individuals"}],"growth-luna.jira-recommend-retrial.permissions.set-custom-permissions":[{"type":0,"value":"Set custom permissions for each role"}],"growth-luna.jira-recommend-retrial.placement.cancel-anytime":[{"type":0,"value":"Cancel anytime"}],"growth-luna.jira-recommend-retrial.placement.customer-agreement":[{"type":0,"value":"Atlassian Customer Agreement"}],"growth-luna.jira-recommend-retrial.placement.dismiss":[{"type":0,"value":"Dismiss"}],"growth-luna.jira-recommend-retrial.placement.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"growth-luna.jira-recommend-retrial.placement.progress-bar-label":[{"type":0,"value":"Upgrading your workspace, less than a minute remaining..."}],"growth-luna.jira-recommend-retrial.placement.suggested-feature.permissions":[{"type":0,"value":"Keep work secure and organized"}],"growth-luna.jira-recommend-retrial.placement.suggested-feature.plans":[{"type":0,"value":"See all your timelines in one plan"}],"growth-luna.jira-recommend-retrial.placement.terms":[{"type":0,"value":"By continuing, you agree to the "},{"type":1,"value":"customerAgreement"},{"type":0,"value":" and acknowledge the "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":". "},{"type":1,"value":"cancelAnytime"},{"type":0,"value":"."}],"growth-luna.jira-recommend-retrial.placement.try-it-free":[{"type":0,"value":"Try it free"}],"growth-luna.jira-recommend-retrial.placement.upgrading-message":[{"type":0,"value":"Upgrading in a new tab, come back here when you\'re done..."}],"growth-luna.jira-recommend-retrial.plans.break-into-steps":[{"type":0,"value":"Break plans into achievable steps with AI"}],"growth-luna.jira-recommend-retrial.plans.customize-view":[{"type":0,"value":"Customize your view to suit you"}],"growth-luna.jira-recommend-retrial.plans.team-progress":[{"type":0,"value":"See every team\'s progress in one place"}],"growth-luna.jira-twcg-810-upgrade-free.action.primary.pde":[{"type":0,"value":"Try it free"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.body":[{"type":0,"value":"Your team has already used half your free automation runs. Try a higher limit free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.limit":[{"type":0,"value":"Increase your limit to 1,700 monthly runs"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.rovo":[{"type":0,"value":"Create new automations fast with Rovo AI"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.workflows":[{"type":0,"value":"Keep workflows moving and avoid interruptions"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.heading":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" rules running"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.body":[{"type":0,"value":"See progress across your team\'s work in one view. Try Plans free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.blockers":[{"type":0,"value":"Spot blockers early and keep things moving"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.goals":[{"type":0,"value":"Help your team hit goals together"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.timelines":[{"type":0,"value":"Create one view of all your team\'s timelines"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.heading":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" projects on track"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.body":[{"type":0,"value":"Help your team move work in progress faster. Try Rovo AI free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.connect":[{"type":0,"value":"Connect related and duplicate tasks automatically"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.next-steps":[{"type":0,"value":"Turn big work into clearer next steps"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.summaries":[{"type":0,"value":"Get instant summaries of what\'s happening"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.heading":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"Stay across your team\'s tasks"}]},"one":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" task"}]},"other":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" tasks"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.cta":[{"type":0,"value":"Get more runs"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.title":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" rules running"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.cta":[{"type":0,"value":"Try Plans"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.title":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" projects on track"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.cta":[{"type":0,"value":"Try Rovo"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.title":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"Stay across your team\'s tasks"}]},"one":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" task"}]},"other":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" tasks"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira-recommend-retrial.placement.body.has-payment":[{"type":0,"value":"Enjoy "},{"type":1,"value":"trialLength"},{"type":0,"value":" days to try "},{"type":1,"value":"suggestedFeature"},{"type":0,"value":" with another free trial of "},{"options":{"other":{"value":[{"type":0,"value":"Premium"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"post-office.ep-migration-inapp-715.body":[{"type":0,"value":"Get Confluence Premium to ship projects faster with advanced admin controls and analytics."}],"post-office.ep-migration-inapp-715.change-plans-button":[{"type":0,"value":"Change plans"}],"post-office.ep-migration-inapp-715.image-alt":[{"type":0,"value":"Confluence Premium illustration"}],"post-office.ep-migration-inapp-715.not-now-button":[{"type":0,"value":"Not now"}],"post-office.ep-migration-inapp-715.title":[{"type":0,"value":"Grow more agile"}],"post-office.jira-exp-banner.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.jira-standard-automation-limit-awareness-banner.close":[{"type":0,"value":"Close"}],"post-office.jira-standard-automation-limit-awareness-banner.message":[{"type":0,"value":"You\'re nearing or at your monthly automation run limit. Automations will fail to run this month if you hit the limit."}]}');

});

parcelRegister("7BxUV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hHRa7").then(()=>parcelRequire('hQw5E'));

});

parcelRegister("5qWxs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9AR7k").then(()=>parcelRequire('4hQJP'));

});

parcelRegister("81uaY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("flIOh").then(()=>parcelRequire('kU06Y'));

});

parcelRegister("2tPwl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9T0sN").then(()=>parcelRequire('2qBkR'));

});

parcelRegister("bUcjD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4vvtR").then(()=>parcelRequire('hlsce'));

});

parcelRegister("1SnHm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l6dPQ").then(()=>parcelRequire('brXOA'));

});

parcelRegister("lfmrS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6uW7K").then(()=>parcelRequire('88rAV'));

});

parcelRegister("eE1j8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6KxOw").then(()=>parcelRequire('jWwaZ'));

});

parcelRegister("dDn3W", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l1FXG").then(()=>parcelRequire('97oGZ'));

});

parcelRegister("iAD78", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3qcgn").then(()=>parcelRequire('6abff'));

});

parcelRegister("7LfmV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Khxy").then(()=>parcelRequire('iCRU6'));

});

parcelRegister("45ZNZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ljqbx").then(()=>parcelRequire('7Mx82'));

});

parcelRegister("dOek7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gF8dv").then(()=>parcelRequire('4gJFM'));

});

parcelRegister("iqfhS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d98TY").then(()=>parcelRequire('cl5Fx'));

});

parcelRegister("j8g0m", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1wITW").then(()=>parcelRequire('45bIl'));

});

parcelRegister("7xcip", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("16YKi").then(()=>parcelRequire('lgwEV'));

});

parcelRegister("gzqAe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g5xpr").then(()=>parcelRequire('1HPhI'));

});

parcelRegister("h4cvR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7Aj8Z").then(()=>parcelRequire('ahdjH'));

});

parcelRegister("RCe3b", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iMANm").then(()=>parcelRequire('dNO1c'));

});

parcelRegister("fugiN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iv2VY").then(()=>parcelRequire('bX2t5'));

});

parcelRegister("5K4qX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("FuQx2").then(()=>parcelRequire('kMNFH'));

});

parcelRegister("05hAH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("80FbN").then(()=>parcelRequire('lKLyJ'));

});

parcelRegister("1bbkB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3SvY1").then(()=>parcelRequire('c7Wpd'));

});

parcelRegister("awqlY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fdtoI").then(()=>parcelRequire('cREbr'));

});

parcelRegister("4Sb6K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4UWsm").then(()=>parcelRequire('ijn7j'));

});

parcelRegister("dJbdN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7E5KD").then(()=>parcelRequire('diRki'));

});

parcelRegister("eDT8n", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("23rHP").then(()=>parcelRequire('8nxG4'));

});

parcelRegister("judG9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("S9aK2").then(()=>parcelRequire('3m0Yj'));

});

parcelRegister("gdVDP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4wsrA").then(()=>parcelRequire('4D4P3'));

});

parcelRegister("dtTxI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("90aYe").then(()=>parcelRequire('27fAC'));

});

parcelRegister("kHRqi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f7Nmc").then(()=>parcelRequire('ipXUy'));

});

parcelRegister("E8fu8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("554pf").then(()=>parcelRequire('91C43'));

});

parcelRegister("bbqO0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("32HiD").then(()=>parcelRequire('85CKM'));

});

parcelRegister("fw5kn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lGhhh").then(()=>parcelRequire('fK0jf'));

});


parcelRegister("eEttz", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $5ac1f2b5ebde5d2b$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bzXCd = parcelRequire("bzXCd");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5ac1f2b5ebde5d2b$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $5ac1f2b5ebde5d2b$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("asS0M")));
        case 'da':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("22pPg")));
        case 'de':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("8TtEK")));
        case 'en-GB':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("a4Myr")));
        case 'en-US':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("bNB7V")));
        case 'en-XA':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("gMV1o")));
        case 'en-XB':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("dwigq")));
        case 'en-ZZ':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("9Avkn")));
        case 'en':
            return $5ac1f2b5ebde5d2b$var$importHelper(await Promise.resolve((parcelRequire("bzXCd"))));
        case 'es':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("7zPgR")));
        case 'et':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("gRdse")));
        case 'fi':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("50nlK")));
        case 'fr':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("60cZX")));
        case 'hr':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("d61eY")));
        case 'hu':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("j7uwA")));
        case 'it':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("jxVhp")));
        case 'ja':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("eXISc")));
        case 'ko':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("eFcgO")));
        case 'nb':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("eBHC4")));
        case 'nl':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("8IQc9")));
        case 'pl':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("6284J")));
        case 'pt-BR':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("liN8D")));
        case 'ro':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("g7CcJ")));
        case 'ru':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("kqc5q")));
        case 'sl':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("7N33I")));
        case 'sr-RS':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("l9thK")));
        case 'sr-YR':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("cUv2e")));
        case 'sr':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("6DmL7")));
        case 'sv':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("lLgdg")));
        case 'th':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("6UDMq")));
        case 'tr':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("hpsMq")));
        case 'uk':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("YGZqX")));
        case 'vi':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("44adN")));
        case 'zh-CN':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("2WpDi")));
        case 'zh-TW':
            return $5ac1f2b5ebde5d2b$var$importHelper(await (parcelRequire("hhySd")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bzXCd));
    }
};

});
parcelRegister("bzXCd", function(module, exports) {
module.exports = JSON.parse("{\"post-office.aurum.jira-assets-schemas-display-name.body\":[{\"type\":0,\"value\":\"Clarify and localise entities without breaking AQL or integrations.\"}],\"post-office.aurum.jira-assets-schemas-display-name.headline\":[{\"type\":0,\"value\":\"Display names are here\"}],\"post-office.aurum.jira-assets-schemas-display-name.primary-action\":[{\"type\":0,\"value\":\"Learn more\"}]}");

});

parcelRegister("asS0M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d4p3C").then(()=>parcelRequire('3AG8g'));

});

parcelRegister("22pPg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("BwNX4").then(()=>parcelRequire('93m2g'));

});

parcelRegister("8TtEK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4tUNL").then(()=>parcelRequire('9I25P'));

});

parcelRegister("a4Myr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("irEJ0").then(()=>parcelRequire('e0ZlS'));

});

parcelRegister("bNB7V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("38VXi").then(()=>parcelRequire('dNiHv'));

});

parcelRegister("gMV1o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4L0ls").then(()=>parcelRequire('jLdnm'));

});

parcelRegister("dwigq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bMgTB").then(()=>parcelRequire('6zXEu'));

});

parcelRegister("9Avkn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("79kys").then(()=>parcelRequire('dKDgg'));

});

parcelRegister("7zPgR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("23TkE").then(()=>parcelRequire('3GREa'));

});

parcelRegister("gRdse", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ij2JK").then(()=>parcelRequire('iekeS'));

});

parcelRegister("50nlK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bZ7Qs").then(()=>parcelRequire('dShor'));

});

parcelRegister("60cZX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5qMfb").then(()=>parcelRequire('iXUhp'));

});

parcelRegister("d61eY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hcBLa").then(()=>parcelRequire('23p4k'));

});

parcelRegister("j7uwA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gwTtR").then(()=>parcelRequire('h9uc1'));

});

parcelRegister("jxVhp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2ORiM").then(()=>parcelRequire('1QbOK'));

});

parcelRegister("eXISc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4mzrX").then(()=>parcelRequire('hY4uJ'));

});

parcelRegister("eFcgO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hyHx0").then(()=>parcelRequire('hvr2W'));

});

parcelRegister("eBHC4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("arXyj").then(()=>parcelRequire('b1Kl9'));

});

parcelRegister("8IQc9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("77gBr").then(()=>parcelRequire('84gmk'));

});

parcelRegister("6284J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bUFXF").then(()=>parcelRequire('7OOSr'));

});

parcelRegister("liN8D", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9rVtR").then(()=>parcelRequire('hYHiO'));

});

parcelRegister("g7CcJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dobDT").then(()=>parcelRequire('kcrMp'));

});

parcelRegister("kqc5q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("28ETs").then(()=>parcelRequire('8rBxq'));

});

parcelRegister("7N33I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b5B3N").then(()=>parcelRequire('gJz8L'));

});

parcelRegister("l9thK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Gh3p").then(()=>parcelRequire('bx6iL'));

});

parcelRegister("cUv2e", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gMcIs").then(()=>parcelRequire('6wWfV'));

});

parcelRegister("6DmL7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("11LXq").then(()=>parcelRequire('fi3Tx'));

});

parcelRegister("lLgdg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6C7s9").then(()=>parcelRequire('ewisy'));

});

parcelRegister("6UDMq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9LN7e").then(()=>parcelRequire('eXgiU'));

});

parcelRegister("hpsMq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3IDtQ").then(()=>parcelRequire('2O5cK'));

});

parcelRegister("YGZqX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hRcrv").then(()=>parcelRequire('6Dycq'));

});

parcelRegister("44adN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fZxwu").then(()=>parcelRequire('3nH6s'));

});

parcelRegister("2WpDi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6HWRd").then(()=>parcelRequire('hX4no'));

});

parcelRegister("hhySd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d3ARv").then(()=>parcelRequire('8SLWU'));

});


parcelRegister("eqG4l", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $4fe213c07e359e43$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $a77Rf = parcelRequire("a77Rf");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4fe213c07e359e43$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4fe213c07e359e43$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("dyjhE")));
        case 'da':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("ktC5a")));
        case 'de':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("ds6eV")));
        case 'en-GB':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("jUtx3")));
        case 'en-US':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("5uYzP")));
        case 'en-XA':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("1XCw6")));
        case 'en-XB':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("lLnpq")));
        case 'en-ZZ':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("hnqLI")));
        case 'en':
            return $4fe213c07e359e43$var$importHelper(await Promise.resolve((parcelRequire("a77Rf"))));
        case 'es':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("5PGDK")));
        case 'et':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("9o4Ew")));
        case 'fi':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("dCAc4")));
        case 'fr':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("jE05i")));
        case 'hr':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("4oGjd")));
        case 'hu':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("nQRTZ")));
        case 'it':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("7dIiK")));
        case 'ja':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("aI2xt")));
        case 'ko':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("3h46A")));
        case 'nb':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("5rbO6")));
        case 'nl':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("9tNgG")));
        case 'pl':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("7Ey8z")));
        case 'pt-BR':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("eJBJI")));
        case 'ro':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("eiJZF")));
        case 'ru':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("15ILl")));
        case 'sl':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("3sDJU")));
        case 'sr-RS':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("hnJG2")));
        case 'sr-YR':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("iLdM4")));
        case 'sr':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("iIINy")));
        case 'sv':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("hyueh")));
        case 'th':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("hxRRY")));
        case 'tr':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("9pm9M")));
        case 'uk':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("6pivr")));
        case 'vi':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("cYFcf")));
        case 'zh-CN':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("aKXOD")));
        case 'zh-TW':
            return $4fe213c07e359e43$var$importHelper(await (parcelRequire("eYd8i")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($a77Rf));
    }
};

});
parcelRegister("a77Rf", function(module, exports) {
module.exports = JSON.parse("{\"jira-board-inline-editing-onboarding.message-templates.ok-button\":[{\"type\":0,\"value\":\"OK\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-body\":[{\"type\":0,\"value\":\"You can now edit fields like the summary, assignee, parent and estimate. Select the fields to edit them.\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-header\":[{\"type\":0,\"value\":\"Edit details of the work item directly in the board\"}]}");

});

parcelRegister("dyjhE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lXFdi").then(()=>parcelRequire('i2DvS'));

});

parcelRegister("ktC5a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("38kWp").then(()=>parcelRequire('i7jYa'));

});

parcelRegister("ds6eV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jrcMa").then(()=>parcelRequire('l1dAs'));

});

parcelRegister("jUtx3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iqp9a").then(()=>parcelRequire('2sCTD'));

});

parcelRegister("5uYzP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b4OZc").then(()=>parcelRequire('1mVzm'));

});

parcelRegister("1XCw6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iPVTf").then(()=>parcelRequire('gNS0T'));

});

parcelRegister("lLnpq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("66XQP").then(()=>parcelRequire('d7otG'));

});

parcelRegister("hnqLI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kmhzt").then(()=>parcelRequire('iUD0X'));

});

parcelRegister("5PGDK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fMRn").then(()=>parcelRequire('42d0E'));

});

parcelRegister("9o4Ew", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1viC2").then(()=>parcelRequire('esrfd'));

});

parcelRegister("dCAc4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4qQpr").then(()=>parcelRequire('2SUK2'));

});

parcelRegister("jE05i", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1rroS").then(()=>parcelRequire('lf7Wh'));

});

parcelRegister("4oGjd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("64yVk").then(()=>parcelRequire('6I9G1'));

});

parcelRegister("nQRTZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e6w9w").then(()=>parcelRequire('4KnAj'));

});

parcelRegister("7dIiK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6OVBP").then(()=>parcelRequire('eFG6Y'));

});

parcelRegister("aI2xt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aahyy").then(()=>parcelRequire('hRQAh'));

});

parcelRegister("3h46A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gBC4r").then(()=>parcelRequire('1O5Hs'));

});

parcelRegister("5rbO6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eqSul").then(()=>parcelRequire('ghYKU'));

});

parcelRegister("9tNgG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5FZ7H").then(()=>parcelRequire('jRiW0'));

});

parcelRegister("7Ey8z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dpf0h").then(()=>parcelRequire('2ZE7g'));

});

parcelRegister("eJBJI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fYPWR").then(()=>parcelRequire('lkIXl'));

});

parcelRegister("eiJZF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k9apa").then(()=>parcelRequire('aSdou'));

});

parcelRegister("15ILl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gNrjJ").then(()=>parcelRequire('izZYV'));

});

parcelRegister("3sDJU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8uPJR").then(()=>parcelRequire('jh4le'));

});

parcelRegister("hnJG2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hOdTP").then(()=>parcelRequire('g52MT'));

});

parcelRegister("iLdM4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("67KAv").then(()=>parcelRequire('3Us8h'));

});

parcelRegister("iIINy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kij9D").then(()=>parcelRequire('9G01w'));

});

parcelRegister("hyueh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("apusq").then(()=>parcelRequire('e5ANT'));

});

parcelRegister("hxRRY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4CLS0").then(()=>parcelRequire('87mvw'));

});

parcelRegister("9pm9M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("apdHO").then(()=>parcelRequire('45bRh'));

});

parcelRegister("6pivr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("biEQW").then(()=>parcelRequire('lqlQ9'));

});

parcelRegister("cYFcf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dIrnq").then(()=>parcelRequire('3MdI5'));

});

parcelRegister("aKXOD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9HFC5").then(()=>parcelRequire('jwzVW'));

});

parcelRegister("eYd8i", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gcO76").then(()=>parcelRequire('c3YCh'));

});


parcelRegister("fOfuV", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $687040f1527b5d28$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fhn4y = parcelRequire("fhn4y");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $687040f1527b5d28$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $687040f1527b5d28$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("048ji")));
        case 'da':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("h22nf")));
        case 'de':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("heVlo")));
        case 'en-GB':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("lMojQ")));
        case 'en-US':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("6AKT2")));
        case 'en-XA':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("9Ufwk")));
        case 'en-XB':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("4tsun")));
        case 'en-ZZ':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("3UGmV")));
        case 'en':
            return $687040f1527b5d28$var$importHelper(await Promise.resolve((parcelRequire("fhn4y"))));
        case 'es':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("bic8R")));
        case 'et':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("6ODvb")));
        case 'fi':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("i1OJj")));
        case 'fr':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("1pv2k")));
        case 'hr':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("2rlw3")));
        case 'hu':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("cdciu")));
        case 'it':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("ea0jE")));
        case 'ja':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("dyNjI")));
        case 'ko':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("dNJq9")));
        case 'nb':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("jaSuw")));
        case 'nl':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("7mb35")));
        case 'pl':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("7YVw2")));
        case 'pt-BR':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("J4oX7")));
        case 'ro':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("bHVw3")));
        case 'ru':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("24bwp")));
        case 'sl':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("4fRKp")));
        case 'sr-RS':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("9vEOs")));
        case 'sr-YR':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("WWC8s")));
        case 'sr':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("1rVEx")));
        case 'sv':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("2ZzIB")));
        case 'th':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("dNKTo")));
        case 'tr':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("k74vJ")));
        case 'uk':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("47gbx")));
        case 'vi':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("l4LpZ")));
        case 'zh-CN':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("cbiCs")));
        case 'zh-TW':
            return $687040f1527b5d28$var$importHelper(await (parcelRequire("3wGvW")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fhn4y));
    }
};

});
parcelRegister("fhn4y", function(module, exports) {
module.exports = JSON.parse('{"jira-business-saved-views.admin.changeboarding.spotlight.body":[{"type":0,"value":"Saved views are now in timeline view.\\n\\nSave your view for everyone in the project or reset it back to your previous saved view."}],"jira-business-saved-views.admin.changeboarding.spotlight.headline":[{"type":0,"value":"Save and reset your timeline view"}],"jira-business-saved-views.admin.changeboarding.spotlight.primary-action":[{"type":0,"value":"OK"}],"jira-business-saved-views.admin.changeboarding.spotlight.secondary-action":[{"type":0,"value":"More about saved views"}],"jira-business-saved-views.changeboarding.spotlight.body":[{"type":0,"value":"Saved views are now in timeline view. Your admin set up a view to help make collaboration easier.\\n\\nYou can make changes to your view or reset to the admin\'s view anytime."}],"jira-business-saved-views.changeboarding.spotlight.headline":[{"type":0,"value":"Reset your view"}],"jira-business-saved-views.changeboarding.spotlight.primary-action":[{"type":0,"value":"OK"}],"jira-business-saved-views.changeboarding.spotlight.secondary-action":[{"type":0,"value":"More about saved views"}],"jira-filter-refinement-standalone-release-changeboarding.tour.addFieldsBody":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement-standalone-release-changeboarding.tour.addFieldsHeadline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement-standalone-release-changeboarding.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement-standalone-release-changeboarding.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement-standalone-release-changeboarding.tour.filterHomeBody":[{"type":0,"value":"More fields and more ways to surface the information that is important to you."}],"jira-filter-refinement-standalone-release-changeboarding.tour.filterHomeHeadline":[{"type":0,"value":"A new home for filters"}],"jira-filter-refinement-standalone-release-changeboarding.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement-standalone-release-changeboarding.tour.reorderPinFieldsBody":[{"type":0,"value":"Reorder and pin fields to prioritize what matters most to you."}],"jira-filter-refinement-standalone-release-changeboarding.tour.reorderPinFieldsHeadline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement-standalone-release-changeboarding.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-software-timeline-hierarchy-changeboarding-flag.back":[{"type":0,"value":"Back"}],"jira-software-timeline-hierarchy-changeboarding-flag.done":[{"type":0,"value":"Done"}],"jira-software-timeline-hierarchy-changeboarding-flag.next":[{"type":0,"value":"Next"}],"jira-software-timeline-hierarchy-changeboarding-flag.step1.description":[{"type":0,"value":"Pick the top level of work shown on the timeline. Zoom out to see the big picture, or drill down into the details. The lowest level stays fixed"}],"jira-software-timeline-hierarchy-changeboarding-flag.step1.title":[{"type":0,"value":"Focus your hierarchy"}],"jira-software-timeline-hierarchy-changeboarding-flag.step2.description":[{"type":0,"value":"Hide items that aren\'t linked to a higher level parent to keep your timeline clean and focused on your primary goals"}],"jira-software-timeline-hierarchy-changeboarding-flag.step2.title":[{"type":0,"value":"Focus on what matters"}],"jira-software-timeline-hierarchy-changeboarding-flag.stepCount":[{"type":1,"value":"current"},{"type":0,"value":" of "},{"type":1,"value":"total"}],"jira-software-timeline-m3.descriptionContentBulkOperations":[{"type":0,"value":"Edit, move, transition, watch or delete multiple work items simultaneously."}],"jira-software-timeline-m3.descriptionContentCustomizeBar":[{"type":0,"value":"Make specific work items easier to scan or highlight as a priority."}],"jira-software-timeline-m3.descriptionContentFindWork":[{"type":0,"value":"Search, filter and group work items."}],"jira-software-timeline-m3.descriptionContentSeeSubtasks":[{"type":0,"value":"They now appear under epics."}],"jira-software-timeline-m3.headingContentBulkOperations":[{"type":0,"value":"Reduce repetitive work"}],"jira-software-timeline-m3.headingContentCustomizeBar":[{"type":0,"value":"Customize bars using colors"}],"jira-software-timeline-m3.headingContentFindWork":[{"type":0,"value":"Quickly find work items"}],"jira-software-timeline-m3.headingContentSeeSubtasks":[{"type":0,"value":"See subtasks at a glance"}],"jira-software-timeline-m3.modal.closeButton":[{"type":0,"value":"Close"}],"jira-software-timeline-m3.modal.doneButton":[{"type":0,"value":"Done"}],"jira-software-timeline-m3.modal.nextButton":[{"type":0,"value":"Next"}],"jira-software-timeline-m3.timelineImprovmentsLink":[{"type":0,"value":"Read about Timeline improvements."}],"post-office.software-timeline-example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.software-timeline-testing.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.software-timeline-testing.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.software-timeline-testing.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"timeline-10k-issues-flag.actions":[{"type":0,"value":"Learn more about the 10k limit"}],"timeline-10k-issues-flag.description":[{"type":0,"value":"Parent rollup bars in timeline have been disabled to give you a smoother performance and experience."}],"timeline-10k-issues-flag.title":[{"type":0,"value":"This space has more than 10k work items."}],"timeline-feedback-collector.spotlight.body":[{"type":0,"value":"In doing this we are keen to hear feedback from users about the timeline, what else you may want, and importantly, what you don\u2019t want."}],"timeline-feedback-collector.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"timeline-feedback-collector.spotlight.give-feedback":[{"type":0,"value":"Give feedback"}],"timeline-feedback-collector.spotlight.heading":[{"type":0,"value":"We\u2019re updating Jira timelines"}]}');

});

parcelRegister("048ji", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7UW3n").then(()=>parcelRequire('cKnv4'));

});

parcelRegister("h22nf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dDHN7").then(()=>parcelRequire('iAuvd'));

});

parcelRegister("heVlo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6mKRh").then(()=>parcelRequire('eIijy'));

});

parcelRegister("lMojQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("axV3G").then(()=>parcelRequire('g0Ncu'));

});

parcelRegister("6AKT2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c0sgE").then(()=>parcelRequire('h7f5r'));

});

parcelRegister("9Ufwk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3qnrY").then(()=>parcelRequire('bTmYH'));

});

parcelRegister("4tsun", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bjIdR").then(()=>parcelRequire('7aQv4'));

});

parcelRegister("3UGmV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d0EpE").then(()=>parcelRequire('1RKRP'));

});

parcelRegister("bic8R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aDl5E").then(()=>parcelRequire('g7UWI'));

});

parcelRegister("6ODvb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3RsKY").then(()=>parcelRequire('f3VCB'));

});

parcelRegister("i1OJj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2L5oY").then(()=>parcelRequire('ceY8d'));

});

parcelRegister("1pv2k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kVPLc").then(()=>parcelRequire('7VJtf'));

});

parcelRegister("2rlw3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fmIkE").then(()=>parcelRequire('lAJbK'));

});

parcelRegister("cdciu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ehYKQ").then(()=>parcelRequire('i94CK'));

});

parcelRegister("ea0jE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9MSKM").then(()=>parcelRequire('a5qOF'));

});

parcelRegister("dyNjI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5GmmA").then(()=>parcelRequire('dttow'));

});

parcelRegister("dNJq9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i4iAy").then(()=>parcelRequire('hEazZ'));

});

parcelRegister("jaSuw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3kg2o").then(()=>parcelRequire('kwVn5'));

});

parcelRegister("7mb35", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h0tG2").then(()=>parcelRequire('6YLmx'));

});

parcelRegister("7YVw2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8zRf6").then(()=>parcelRequire('by4Dh'));

});

parcelRegister("J4oX7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("70bgU").then(()=>parcelRequire('45Ui4'));

});

parcelRegister("bHVw3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iTErc").then(()=>parcelRequire('6qP87'));

});

parcelRegister("24bwp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jzXN6").then(()=>parcelRequire('l9DHP'));

});

parcelRegister("4fRKp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f1hX0").then(()=>parcelRequire('6S1XC'));

});

parcelRegister("9vEOs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7Ru9M").then(()=>parcelRequire('aWmbP'));

});

parcelRegister("WWC8s", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jcKho").then(()=>parcelRequire('jeiP3'));

});

parcelRegister("1rVEx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ln95J").then(()=>parcelRequire('8Qtmi'));

});

parcelRegister("2ZzIB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iXS0i").then(()=>parcelRequire('llZUY'));

});

parcelRegister("dNKTo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hPZOR").then(()=>parcelRequire('ezclC'));

});

parcelRegister("k74vJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jtQdw").then(()=>parcelRequire('7xm6w'));

});

parcelRegister("47gbx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fWOgx").then(()=>parcelRequire('eMyrr'));

});

parcelRegister("l4LpZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jcLvZ").then(()=>parcelRequire('aFCzs'));

});

parcelRegister("cbiCs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kuQW5").then(()=>parcelRequire('dhOGo'));

});

parcelRegister("3wGvW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bl0nO").then(()=>parcelRequire('eAyI4'));

});


parcelRegister("bWhYF", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $5e626dc8fec02b6f$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $730Sh = parcelRequire("730Sh");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5e626dc8fec02b6f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $5e626dc8fec02b6f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("8ljxk")));
        case 'da':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("5aN8j")));
        case 'de':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("krCts")));
        case 'en-GB':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("fn90z")));
        case 'en-US':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("70gDJ")));
        case 'en-XA':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("8XLrD")));
        case 'en-XB':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("4hTuC")));
        case 'en-ZZ':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("tvYLQ")));
        case 'en':
            return $5e626dc8fec02b6f$var$importHelper(await Promise.resolve((parcelRequire("730Sh"))));
        case 'es':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("lSPBe")));
        case 'et':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("gKPjQ")));
        case 'fi':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("4eCRb")));
        case 'fr':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("hzr2w")));
        case 'hr':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("iP0fx")));
        case 'hu':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("gj8QS")));
        case 'it':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("cZV0G")));
        case 'ja':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("eEakD")));
        case 'ko':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("cW9SI")));
        case 'nb':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("g6NQq")));
        case 'nl':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("7B4pi")));
        case 'pl':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("dh2VI")));
        case 'pt-BR':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("jTqtR")));
        case 'ro':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("ir4zt")));
        case 'ru':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("30jph")));
        case 'sl':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("iokwn")));
        case 'sr-RS':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("jmZ7k")));
        case 'sr-YR':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("64mQN")));
        case 'sr':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("eFj49")));
        case 'sv':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("8Cvq3")));
        case 'th':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("5DnoD")));
        case 'tr':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("85Vfy")));
        case 'uk':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("eIci9")));
        case 'vi':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("4sbdr")));
        case 'zh-CN':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("eo9bK")));
        case 'zh-TW':
            return $5e626dc8fec02b6f$var$importHelper(await (parcelRequire("iujPg")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($730Sh));
    }
};

});
parcelRegister("730Sh", function(module, exports) {
module.exports = JSON.parse('{"export-issues-flyout-spotlight-tour.spotlight.body":[{"type":0,"value":"Export your work items in the format you need, right from the more actions menu."}],"export-issues-flyout-spotlight-tour.spotlight.heading":[{"type":0,"value":"Export options have moved"}],"export-issues-flyout-spotlight-tour.spotlight.okButton":[{"type":0,"value":"OK"}],"jira-filter-refinement-board-and-backlog.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement-board-and-backlog.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement-board-and-backlog.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement-board-and-backlog.tour.step1Body":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement-board-and-backlog.tour.step1Headline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement-board-and-backlog.tour.step2Body":[{"type":0,"value":"Reorder and pin fields to\xa0prioritize\xa0what matters\xa0most to you."}],"jira-filter-refinement-board-and-backlog.tour.step2Headline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement-board-and-backlog.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-filter-refinement.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement.tour.step1Body":[{"type":0,"value":"Save any filter combination to reuse later."}],"jira-filter-refinement.tour.step1Headline":[{"type":0,"value":"Save your filter"}],"jira-filter-refinement.tour.step2Body":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement.tour.step2Headline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement.tour.step3Body":[{"type":0,"value":"Reorder and pin fields to\xa0prioritize\xa0what matters\xa0most to you."}],"jira-filter-refinement.tour.step3Headline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-nin-issue-preview-panel.body":[{"type":0,"value":"View and edit work items in the new preview panel, while staying on the List."}],"jira-nin-issue-preview-panel.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-issue-preview-panel.heading":[{"type":0,"value":"Access work items instantly"}],"jira-nin-issue-preview-panel.more":[{"type":0,"value":"More about preview panels"}],"jira-nin-issue-preview-panel.new-window":[{"type":0,"value":"(opens in a new window)"}],"jira-nin-list-merge-modal-onboarding-v2.closeButton":[{"type":0,"value":"Close"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription":[{"type":0,"value":"Want us to apply your current filter and group settings to this new List view?"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo":[{"type":0,"value":"No"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes":[{"type":0,"value":"Yes"}],"jira-nin-list-merge-modal-onboarding-v2.description":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience. A new List view."}],"jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription":[{"type":0,"value":"Any existing filters and groups will be applied."}],"jira-nin-list-merge-modal-onboarding-v2.heading":[{"type":0,"value":"We\'ve merged List and All Work"}],"jira-nin-list-merge-modal-onboarding-v2.learnMoreLink":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.body":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience. A new List view."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label":[{"type":0,"value":"Explore List view"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.filter":[{"type":0,"value":"One place to search work and filter results to find what you need."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.heading":[{"type":0,"value":"We\'ve merged List and All Work views"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions":[{"type":0,"value":"Dive deeper - view work items as a chart, use format rules to highlight key work, and more."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.next":[{"type":0,"value":"Next"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.ok":[{"type":0,"value":"OK"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.body":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience."}],"jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.heading":[{"type":0,"value":"We\'ve merged List and All Work views"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more":[{"type":0,"value":"Tell me more"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira.filter.refinement.filter-popup.changeboarding.description.filter":[{"type":0,"value":"You can now filter work items by status and priority, making it easier to find work."}],"jira.filter.refinement.filter-popup.changeboarding.description.improvements":[{"type":0,"value":"More improvements to come."}],"jira.filter.refinement.filter-popup.changeboarding.description.parent":[{"type":0,"value":"Use the parent filter to search for epics, as well as any other work items with child work items."}],"jira.filter.refinement.filter-popup.changeboarding.dismiss":[{"type":0,"value":"Dismiss"}],"jira.filter.refinement.filter-popup.changeboarding.next":[{"type":0,"value":"Next"}],"jira.filter.refinement.filter-popup.changeboarding.ok":[{"type":0,"value":"OK"}],"jira.filter.refinement.filter-popup.changeboarding.page2.title":[{"type":0,"value":"We\'ve updated epic to parent"}],"jira.filter.refinement.filter-popup.changeboarding.title":[{"type":0,"value":"Introducing a new home for filters"}]}');

});

parcelRegister("8ljxk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gZLK3").then(()=>parcelRequire('5VHtg'));

});

parcelRegister("5aN8j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ejj3e").then(()=>parcelRequire('llo1r'));

});

parcelRegister("krCts", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("26QZ8").then(()=>parcelRequire('1RI5C'));

});

parcelRegister("fn90z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Jgsmk").then(()=>parcelRequire('fhHSp'));

});

parcelRegister("70gDJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5BDbj").then(()=>parcelRequire('fcZxs'));

});

parcelRegister("8XLrD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hggqh").then(()=>parcelRequire('1IvdS'));

});

parcelRegister("4hTuC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9tmxM").then(()=>parcelRequire('jENq8'));

});

parcelRegister("tvYLQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("42PFQ").then(()=>parcelRequire('fvMfl'));

});

parcelRegister("lSPBe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lvg4b").then(()=>parcelRequire('4Rx1V'));

});

parcelRegister("gKPjQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7q79t").then(()=>parcelRequire('4zk1J'));

});

parcelRegister("4eCRb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kkivs").then(()=>parcelRequire('lj8db'));

});

parcelRegister("hzr2w", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6zVKu").then(()=>parcelRequire('eVuZP'));

});

parcelRegister("iP0fx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hzR6T").then(()=>parcelRequire('ah5tP'));

});

parcelRegister("gj8QS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("46hgt").then(()=>parcelRequire('9B93q'));

});

parcelRegister("cZV0G", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("94VSE").then(()=>parcelRequire('l5Qmf'));

});

parcelRegister("eEakD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3whH4").then(()=>parcelRequire('4rVm6'));

});

parcelRegister("cW9SI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7RhAQ").then(()=>parcelRequire('iXa3L'));

});

parcelRegister("g6NQq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("etMwg").then(()=>parcelRequire('991x4'));

});

parcelRegister("7B4pi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3VXby").then(()=>parcelRequire('ds9tb'));

});

parcelRegister("dh2VI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3BOdx").then(()=>parcelRequire('4c57B'));

});

parcelRegister("jTqtR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j5tzo").then(()=>parcelRequire('7wbIY'));

});

parcelRegister("ir4zt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kvZSB").then(()=>parcelRequire('23EAg'));

});

parcelRegister("30jph", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cGL8f").then(()=>parcelRequire('71wAm'));

});

parcelRegister("iokwn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8r5I2").then(()=>parcelRequire('c5ITk'));

});

parcelRegister("jmZ7k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fRLk0").then(()=>parcelRequire('h318O'));

});

parcelRegister("64mQN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3q1Ml").then(()=>parcelRequire('i8cOM'));

});

parcelRegister("eFj49", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hjLOa").then(()=>parcelRequire('fTpSH'));

});

parcelRegister("8Cvq3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("BbR4q").then(()=>parcelRequire('jn3Y9'));

});

parcelRegister("5DnoD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("heP6X").then(()=>parcelRequire('aJjhp'));

});

parcelRegister("85Vfy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fNYRR").then(()=>parcelRequire('9mq2V'));

});

parcelRegister("eIci9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dbUIy").then(()=>parcelRequire('5n9OH'));

});

parcelRegister("4sbdr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4sgru").then(()=>parcelRequire('beljy'));

});

parcelRegister("eo9bK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1TChU").then(()=>parcelRequire('gRgkp'));

});

parcelRegister("iujPg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6ZnDM").then(()=>parcelRequire('f7j1D'));

});


parcelRegister("1Crx4", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $5be7bca348c11279$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9tAvY = parcelRequire("9tAvY");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5be7bca348c11279$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $5be7bca348c11279$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("gCUOs")));
        case 'da':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("15yeq")));
        case 'de':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("44Aa9")));
        case 'en-GB':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("lNiB8")));
        case 'en-US':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("koMF4")));
        case 'en-XA':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("kO5Nf")));
        case 'en-XB':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("2ZTVB")));
        case 'en-ZZ':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("bolKL")));
        case 'en':
            return $5be7bca348c11279$var$importHelper(await Promise.resolve((parcelRequire("9tAvY"))));
        case 'es':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("hWTrM")));
        case 'et':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("eTGWP")));
        case 'fi':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("aLWTP")));
        case 'fr':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("4THWB")));
        case 'hr':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("03lQE")));
        case 'hu':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("02a66")));
        case 'it':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("5JxSm")));
        case 'ja':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("dsOr4")));
        case 'ko':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("53k9A")));
        case 'nb':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("eeQ0v")));
        case 'nl':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("gFhxO")));
        case 'pl':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("3K3mZ")));
        case 'pt-BR':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("WxPLQ")));
        case 'ro':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("8xC4l")));
        case 'ru':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("hWWty")));
        case 'sl':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("aL7Dm")));
        case 'sr-RS':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("2CWxW")));
        case 'sr-YR':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("hztgM")));
        case 'sr':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("9i45h")));
        case 'sv':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("5PuZy")));
        case 'th':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("dNWBJ")));
        case 'tr':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("lLi3g")));
        case 'uk':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("7ogit")));
        case 'vi':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("3Fu9m")));
        case 'zh-CN':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("2JG33")));
        case 'zh-TW':
            return $5be7bca348c11279$var$importHelper(await (parcelRequire("hjFj1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9tAvY));
    }
};

});
parcelRegister("9tAvY", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("gCUOs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jThr0").then(()=>parcelRequire('gXquJ'));

});

parcelRegister("15yeq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dWFn6").then(()=>parcelRequire('fyL75'));

});

parcelRegister("44Aa9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6il6r").then(()=>parcelRequire('gilxo'));

});

parcelRegister("lNiB8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6IBsr").then(()=>parcelRequire('dOa1Z'));

});

parcelRegister("koMF4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9A6hf").then(()=>parcelRequire('bvfFs'));

});

parcelRegister("kO5Nf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jOMWX").then(()=>parcelRequire('JPaDy'));

});

parcelRegister("2ZTVB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ebLuR").then(()=>parcelRequire('cOS7u'));

});

parcelRegister("bolKL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gjxPy").then(()=>parcelRequire('d43XC'));

});

parcelRegister("hWTrM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eUBSC").then(()=>parcelRequire('l1Olb'));

});

parcelRegister("eTGWP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bRI2G").then(()=>parcelRequire('1NwGc'));

});

parcelRegister("aLWTP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kKman").then(()=>parcelRequire('dzkvF'));

});

parcelRegister("4THWB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kiIFE").then(()=>parcelRequire('9HqXU'));

});

parcelRegister("03lQE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7AxWj").then(()=>parcelRequire('dIKJk'));

});

parcelRegister("02a66", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2tT7G").then(()=>parcelRequire('f8WZN'));

});

parcelRegister("5JxSm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hkP6P").then(()=>parcelRequire('46Ban'));

});

parcelRegister("dsOr4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ioiCP").then(()=>parcelRequire('aRuEh'));

});

parcelRegister("53k9A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7PQHl").then(()=>parcelRequire('bt4CL'));

});

parcelRegister("eeQ0v", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("boxE2").then(()=>parcelRequire('9j64m'));

});

parcelRegister("gFhxO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1RzwN").then(()=>parcelRequire('cURus'));

});

parcelRegister("3K3mZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6lI01").then(()=>parcelRequire('74pbN'));

});

parcelRegister("WxPLQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jM57R").then(()=>parcelRequire('6SA1L'));

});

parcelRegister("8xC4l", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("17UyM").then(()=>parcelRequire('gaqbn'));

});

parcelRegister("hWWty", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2ImBA").then(()=>parcelRequire('Ao6Rj'));

});

parcelRegister("aL7Dm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9ktO1").then(()=>parcelRequire('9egEI'));

});

parcelRegister("2CWxW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Nrxaw").then(()=>parcelRequire('fqeV0'));

});

parcelRegister("hztgM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9aFxc").then(()=>parcelRequire('fWjN0'));

});

parcelRegister("9i45h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dCo4d").then(()=>parcelRequire('aEccY'));

});

parcelRegister("5PuZy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("WHxaz").then(()=>parcelRequire('2TFc3'));

});

parcelRegister("dNWBJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lgDXS").then(()=>parcelRequire('d5o1L'));

});

parcelRegister("lLi3g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4NA0c").then(()=>parcelRequire('6UMJy'));

});

parcelRegister("7ogit", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3N9Xp").then(()=>parcelRequire('9gI69'));

});

parcelRegister("3Fu9m", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5tkkP").then(()=>parcelRequire('9GcFx'));

});

parcelRegister("2JG33", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fmXmy").then(()=>parcelRequire('cEeil'));

});

parcelRegister("hjFj1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iv68o").then(()=>parcelRequire('3x29R'));

});


parcelRegister("gJpEn", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $8da7bdcee53e6241$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $htpgm = parcelRequire("htpgm");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8da7bdcee53e6241$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8da7bdcee53e6241$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("9CC5R")));
        case 'da':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("gyktI")));
        case 'de':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("aumJK")));
        case 'en-GB':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("jJ3z9")));
        case 'en-US':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("g2PpO")));
        case 'en-XA':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("euti0")));
        case 'en-XB':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("dSWDm")));
        case 'en-ZZ':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("3GZOB")));
        case 'en':
            return $8da7bdcee53e6241$var$importHelper(await Promise.resolve((parcelRequire("htpgm"))));
        case 'es':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("ikdPU")));
        case 'et':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("3XuGa")));
        case 'fi':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("fo2Se")));
        case 'fr':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("5jg4w")));
        case 'hr':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("gHQ5V")));
        case 'hu':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("cXcbF")));
        case 'it':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("2pCdt")));
        case 'ja':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("5pTCI")));
        case 'ko':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("boQGl")));
        case 'nb':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("2wyc3")));
        case 'nl':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("6wC2g")));
        case 'pl':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("67Lu6")));
        case 'pt-BR':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("kt4vw")));
        case 'ro':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("eAocJ")));
        case 'ru':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("36QPv")));
        case 'sl':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("3aFf2")));
        case 'sr-RS':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("ikt7J")));
        case 'sr-YR':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("2A2CW")));
        case 'sr':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("fDl6K")));
        case 'sv':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("17z8U")));
        case 'th':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("8YMn5")));
        case 'tr':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("kVGgo")));
        case 'uk':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("8jgrX")));
        case 'vi':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("cNELQ")));
        case 'zh-CN':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("9vJs5")));
        case 'zh-TW':
            return $8da7bdcee53e6241$var$importHelper(await (parcelRequire("1g6oG")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($htpgm));
    }
};

});
parcelRegister("htpgm", function(module, exports) {
module.exports = JSON.parse("{\"gnin.fps-redirect.changeboarding.description\":[{\"type\":0,\"value\":\"Looking for more? Switch to find results and answers from all your Atlassian and connected apps.\"}],\"gnin.fps-redirect.changeboarding.primary-button\":[{\"type\":0,\"value\":\"Got it\"}],\"gnin.fps-redirect.changeboarding.title\":[{\"type\":0,\"value\":\"Switch to search beyond Jira\"}],\"post-office.quick-find-spotlight.spotlight-body-1\":[{\"type\":0,\"value\":\"Apply a mix of filters to narrow down results.\"}],\"post-office.quick-find-spotlight.spotlight-body-2\":[{\"type\":0,\"value\":\"Search only Jira, or expand across all your Atlassian and connected apps.\"}],\"post-office.quick-find-spotlight.spotlight-button-done\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.quick-find-spotlight.spotlight-button-next\":[{\"type\":0,\"value\":\"Next\"}],\"post-office.quick-find-spotlight.spotlight-heading-1\":[{\"type\":0,\"value\":\"Filter for what you need\"}],\"post-office.quick-find-spotlight.spotlight-heading-2\":[{\"type\":0,\"value\":\"Choose where to search\"}],\"search-page.gnin-redirect.changeboarding.back-button\":[{\"type\":0,\"value\":\"Back\"}],\"search-page.gnin-redirect.changeboarding.next-button\":[{\"type\":0,\"value\":\"Next\"}],\"search-page.gnin-redirect.changeboarding.primary-button\":[{\"type\":0,\"value\":\"Got it\"}],\"search-page.gnin-redirect.changeboarding.step-label\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"search-page.gnin-redirect.changeboarding.step1.description\":[{\"type\":0,\"value\":\"Your results may come from all your apps or just Jira, depending on your search terms.\"}],\"search-page.gnin-redirect.changeboarding.step1.image-alt\":[{\"type\":0,\"value\":\"Rovo full page search smart AI answer illustration\"}],\"search-page.gnin-redirect.changeboarding.step1.title\":[{\"type\":0,\"value\":\"Search that adapts to you\"}],\"search-page.gnin-redirect.changeboarding.step2.description\":[{\"type\":0,\"value\":\"You can switch anytime to search Jira work items (including JQL).\"}],\"search-page.gnin-redirect.changeboarding.step2.image-alt\":[{\"type\":0,\"value\":\"Rovo full page search illustration\"}],\"search-page.gnin-redirect.changeboarding.step2.title\":[{\"type\":0,\"value\":\"Switch your view anytime\"}]}");

});

parcelRegister("9CC5R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5d0yZ").then(()=>parcelRequire('tGgS4'));

});

parcelRegister("gyktI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jiofP").then(()=>parcelRequire('dc8cB'));

});

parcelRegister("aumJK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jKfkm").then(()=>parcelRequire('25RkI'));

});

parcelRegister("jJ3z9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lKLQP").then(()=>parcelRequire('7w6R6'));

});

parcelRegister("g2PpO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6f115").then(()=>parcelRequire('4y56A'));

});

parcelRegister("euti0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l4V7B").then(()=>parcelRequire('6bicR'));

});

parcelRegister("dSWDm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7Q3pR").then(()=>parcelRequire('laS75'));

});

parcelRegister("3GZOB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lYzcy").then(()=>parcelRequire('5TciF'));

});

parcelRegister("ikdPU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kwUth").then(()=>parcelRequire('1N23y'));

});

parcelRegister("3XuGa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hDwJj").then(()=>parcelRequire('lj1zp'));

});

parcelRegister("fo2Se", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eDYMG").then(()=>parcelRequire('fOD1V'));

});

parcelRegister("5jg4w", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dMFUK").then(()=>parcelRequire('d1Ekb'));

});

parcelRegister("gHQ5V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("50pGs").then(()=>parcelRequire('i15vK'));

});

parcelRegister("cXcbF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d72Lr").then(()=>parcelRequire('bzhIc'));

});

parcelRegister("2pCdt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("S7xMz").then(()=>parcelRequire('eBjYj'));

});

parcelRegister("5pTCI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jViQc").then(()=>parcelRequire('gnSL8'));

});

parcelRegister("boQGl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ivxBE").then(()=>parcelRequire('liHuX'));

});

parcelRegister("2wyc3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iVBv0").then(()=>parcelRequire('6ecx8'));

});

parcelRegister("6wC2g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4Zpry").then(()=>parcelRequire('4Fznl'));

});

parcelRegister("67Lu6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hqN7V").then(()=>parcelRequire('hyBeG'));

});

parcelRegister("kt4vw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("77x0F").then(()=>parcelRequire('eannM'));

});

parcelRegister("eAocJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9IAUR").then(()=>parcelRequire('e2OyR'));

});

parcelRegister("36QPv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bkXn4").then(()=>parcelRequire('e28Ns'));

});

parcelRegister("3aFf2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fKn5T").then(()=>parcelRequire('aPY0S'));

});

parcelRegister("ikt7J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("khSXJ").then(()=>parcelRequire('f3fdJ'));

});

parcelRegister("2A2CW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d51Nq").then(()=>parcelRequire('ihswF'));

});

parcelRegister("fDl6K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("knmRo").then(()=>parcelRequire('5RBDy'));

});

parcelRegister("17z8U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4i3Dl").then(()=>parcelRequire('l25zR'));

});

parcelRegister("8YMn5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2KxRK").then(()=>parcelRequire('d0zO4'));

});

parcelRegister("kVGgo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("akyMH").then(()=>parcelRequire('dUhQt'));

});

parcelRegister("8jgrX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jZfia").then(()=>parcelRequire('3nspa'));

});

parcelRegister("cNELQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cMTBo").then(()=>parcelRequire('2JNYJ'));

});

parcelRegister("9vJs5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lN8kg").then(()=>parcelRequire('eOZkR'));

});

parcelRegister("1g6oG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("o0wMX").then(()=>parcelRequire('dnbNn'));

});


parcelRegister("ailzg", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $24fd9249bc1961fa$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $lK74E = parcelRequire("lK74E");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24fd9249bc1961fa$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $24fd9249bc1961fa$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("eF0QD")));
        case 'da':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("fm4Dz")));
        case 'de':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("7TYfb")));
        case 'en-GB':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("9TMDp")));
        case 'en-US':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("l4eMM")));
        case 'en-XA':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("cnZjL")));
        case 'en-XB':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("fLpaF")));
        case 'en-ZZ':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("1SEc4")));
        case 'en':
            return $24fd9249bc1961fa$var$importHelper(await Promise.resolve((parcelRequire("lK74E"))));
        case 'es':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("loxZA")));
        case 'et':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("f5Kub")));
        case 'fi':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("f7hvj")));
        case 'fr':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("aWc3X")));
        case 'hr':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("72a40")));
        case 'hu':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("hoeCp")));
        case 'it':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("4tzqZ")));
        case 'ja':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("5O0jY")));
        case 'ko':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("1NVjo")));
        case 'nb':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("18T4K")));
        case 'nl':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("a4niI")));
        case 'pl':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("1Kd2Y")));
        case 'pt-BR':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("f2Y1k")));
        case 'ro':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("kjHWG")));
        case 'ru':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("aUT2E")));
        case 'sl':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("6KVmn")));
        case 'sr-RS':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("d65l9")));
        case 'sr-YR':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("kk1jy")));
        case 'sr':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("4wncc")));
        case 'sv':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("bC6od")));
        case 'th':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("1TRvp")));
        case 'tr':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("cWb7Y")));
        case 'uk':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("6sZs9")));
        case 'vi':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("2iToW")));
        case 'zh-CN':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("15eOg")));
        case 'zh-TW':
            return $24fd9249bc1961fa$var$importHelper(await (parcelRequire("2HSGj")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lK74E));
    }
};

});
parcelRegister("lK74E", function(module, exports) {
module.exports = JSON.parse("{\"jira-glance-panel-navigation-arrows.spotlight.body\":[{\"type\":0,\"value\":\"View your work in a side panel or modal, and navigate both contextually.\"}],\"jira-glance-panel-navigation-arrows.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-glance-panel-navigation-arrows.spotlight.headline\":[{\"type\":0,\"value\":\"Control how you view work\"}],\"jira-glance-panel-navigation-arrows.spotlight.image-alt\":[{\"type\":0,\"value\":\"Navigation arrows on the glance panel\"}],\"jira-glance-panel-navigation-arrows.spotlight.primary-action\":[{\"type\":0,\"value\":\"OK\"}],\"jira-work-item-view-native-projects-field.body\":[{\"type\":0,\"value\":\"Your existing project connections have moved to the new field. Nothing to set up.\"}],\"jira-work-item-view-native-projects-field.button.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-work-item-view-native-projects-field.button.done\":[{\"type\":0,\"value\":\"Got it\"}],\"jira-work-item-view-native-projects-field.headline\":[{\"type\":0,\"value\":\"Projects are now part of Jira\"}],\"jira-work-item-view-native-projects-field.image-alt\":[{\"type\":0,\"value\":\"Illustration showing a native Atlas project smart card pointing to the project interface\"}],\"jira-work-item-view-native-projects-field.tp.body\":[{\"type\":0,\"value\":\"Connect your work to a project, track progress, and easily share updates.\"}],\"jira-work-item-view-native-projects-field.tp.button.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-work-item-view-native-projects-field.tp.button.done\":[{\"type\":0,\"value\":\"Try Projects\"}],\"jira-work-item-view-native-projects-field.tp.headline\":[{\"type\":0,\"value\":\"Share updates with Projects\"}],\"jira-work-item-view-native-projects-field.tp.image-alt\":[{\"type\":0,\"value\":\"Illustration showing the new Projects field in the Jira work item view, ready to connect work to a project\"}]}");

});

parcelRegister("eF0QD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3qrQs").then(()=>parcelRequire('cDjGi'));

});

parcelRegister("fm4Dz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8aYUD").then(()=>parcelRequire('6pO0X'));

});

parcelRegister("7TYfb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iuILs").then(()=>parcelRequire('1w5sT'));

});

parcelRegister("9TMDp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6rbfJ").then(()=>parcelRequire('hnzsH'));

});

parcelRegister("l4eMM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cizl3").then(()=>parcelRequire('enild'));

});

parcelRegister("cnZjL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gJeYm").then(()=>parcelRequire('7dfn3'));

});

parcelRegister("fLpaF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("39QqN").then(()=>parcelRequire('3xUWH'));

});

parcelRegister("1SEc4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fX2Rs").then(()=>parcelRequire('FGvbn'));

});

parcelRegister("loxZA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("29ZKx").then(()=>parcelRequire('jpfjf'));

});

parcelRegister("f5Kub", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lPd2O").then(()=>parcelRequire('bek0Q'));

});

parcelRegister("f7hvj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1EavD").then(()=>parcelRequire('4ng4J'));

});

parcelRegister("aWc3X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ixJkT").then(()=>parcelRequire('8XD0o'));

});

parcelRegister("72a40", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1dadE").then(()=>parcelRequire('ceZMl'));

});

parcelRegister("hoeCp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("57Z9V").then(()=>parcelRequire('4SGqw'));

});

parcelRegister("4tzqZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kmNev").then(()=>parcelRequire('j2JXG'));

});

parcelRegister("5O0jY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("44qan").then(()=>parcelRequire('4fYr6'));

});

parcelRegister("1NVjo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b0UVG").then(()=>parcelRequire('43OrF'));

});

parcelRegister("18T4K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Ga0O").then(()=>parcelRequire('2zGlR'));

});

parcelRegister("a4niI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7kT6f").then(()=>parcelRequire('9Y7f9'));

});

parcelRegister("1Kd2Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cDLIU").then(()=>parcelRequire('7hgya'));

});

parcelRegister("f2Y1k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3zUvK").then(()=>parcelRequire('3sPWn'));

});

parcelRegister("kjHWG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8zgEw").then(()=>parcelRequire('asG5P'));

});

parcelRegister("aUT2E", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lLVbS").then(()=>parcelRequire('fsXms'));

});

parcelRegister("6KVmn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6G4P9").then(()=>parcelRequire('Q53u7'));

});

parcelRegister("d65l9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j4k8v").then(()=>parcelRequire('isijX'));

});

parcelRegister("kk1jy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7mLD6").then(()=>parcelRequire('lh6Z2'));

});

parcelRegister("4wncc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6nBTw").then(()=>parcelRequire('drPuL'));

});

parcelRegister("bC6od", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1qmRF").then(()=>parcelRequire('acaTl'));

});

parcelRegister("1TRvp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aGywi").then(()=>parcelRequire('aU5oJ'));

});

parcelRegister("cWb7Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g3bqR").then(()=>parcelRequire('kGfVH'));

});

parcelRegister("6sZs9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l9BL2").then(()=>parcelRequire('khLTT'));

});

parcelRegister("2iToW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("TIU8N").then(()=>parcelRequire('lKEd7'));

});

parcelRegister("15eOg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gJMY0").then(()=>parcelRequire('tndhp'));

});

parcelRegister("2HSGj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8yYSD").then(()=>parcelRequire('haqxB'));

});


parcelRegister("6LR7s", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $8146ea26e702649a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3wa3F = parcelRequire("3wa3F");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8146ea26e702649a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8146ea26e702649a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("2B4Ug")));
        case 'da':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("hxljK")));
        case 'de':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("5SikO")));
        case 'en-GB':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("aCosb")));
        case 'en-US':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("kC40R")));
        case 'en-XA':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("kE33p")));
        case 'en-XB':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("aa48A")));
        case 'en-ZZ':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("jPuEL")));
        case 'en':
            return $8146ea26e702649a$var$importHelper(await Promise.resolve((parcelRequire("3wa3F"))));
        case 'es':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("9BODd")));
        case 'et':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("4Vv7l")));
        case 'fi':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("4PQOk")));
        case 'fr':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("fX8xj")));
        case 'hr':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("b03CJ")));
        case 'hu':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("4ziGW")));
        case 'it':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("7ZPAn")));
        case 'ja':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("gkHoQ")));
        case 'ko':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("cy4Fs")));
        case 'nb':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("5t9ak")));
        case 'nl':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("cGbdG")));
        case 'pl':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("9acBK")));
        case 'pt-BR':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("5XTIF")));
        case 'ro':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("j71WC")));
        case 'ru':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("2a7N5")));
        case 'sl':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("acHkf")));
        case 'sr-RS':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("foB5Z")));
        case 'sr-YR':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("42qZG")));
        case 'sr':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("lRzNF")));
        case 'sv':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("jnoXN")));
        case 'th':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("1GuWw")));
        case 'tr':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("k5wya")));
        case 'uk':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("3Zwkh")));
        case 'vi':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("mh7qy")));
        case 'zh-CN':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("4pZEE")));
        case 'zh-TW':
            return $8146ea26e702649a$var$importHelper(await (parcelRequire("aJa74")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3wa3F));
    }
};

});
parcelRegister("3wa3F", function(module, exports) {
module.exports = JSON.parse('{"growth-jira-onboarding.Contact-us":[{"type":0,"value":"Contact us"}],"growth-jira-onboarding.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"growth-jira-onboarding.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"growth-jira-onboarding.footer.dot-separator":[{"type":0,"value":"\u2022"}],"growth-jira-onboarding.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"growth-jira-onboarding.footer.facebook-title":[{"type":0,"value":"Facebook"}],"growth-jira-onboarding.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"growth-jira-onboarding.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"growth-jira-onboarding.footer.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"growth-jira-onboarding.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"growth-jira-onboarding.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"growth-jira-onboarding.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-jira-onboarding.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"growth-jira-onboarding.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"growth-jira-onboarding.footer.x-alt-text":[{"type":0,"value":"X"}],"growth-jira-onboarding.footer.x-title":[{"type":0,"value":"X"}],"growth-jira-onboarding.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"growth-jira-onboarding.footer.youtube-title":[{"type":0,"value":"Youtube"}],"growth-jira-onboarding.invite-reminder-with-board-activity.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading":[{"type":0,"value":"Join in on your team\u2019s recent work"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading-text":[{"type":0,"value":"Here\u2019s what everyone\u2019s been up to in Jira:"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text":[{"type":0,"value":"Start collaborating"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text.join-now":[{"type":0,"value":"Join now"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-view-all":[{"type":0,"value":"View all work"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.assignee":[{"type":0,"value":"Assignee"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.due-date":[{"type":0,"value":"Due date"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.status":[{"type":0,"value":"Status"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.summary":[{"type":0,"value":"Summary"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.created-by":[{"type":0,"value":"Created by "},{"type":1,"value":"projectAdmin"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-admin-only":[{"type":1,"value":"projectAdmin"},{"type":0,"value":" is waiting for you to join \'"},{"type":1,"value":"projectName"},{"type":0,"value":"\'"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-many-user":[{"type":1,"value":"projectAdmin"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"otherUsers"},{"type":0,"value":" are waiting for you to join \'"},{"type":1,"value":"projectName"},{"type":0,"value":"\'"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.in-body-header":[{"type":0,"value":"Your team is waiting for you to join them in Jira"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.subject.no-translate":[{"type":0,"value":"Reminder: You\u2019ve been invited to plan and track work in Jira"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.done":[{"type":0,"value":"Done"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.inProgress":[{"type":0,"value":"In Progress"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.todo":[{"type":0,"value":"To Do"}],"growth-jira-onboarding.invite-reminder-with-board-activity.social-proof.text":[{"children":[{"type":0,"value":"Jira is the #1 project management tool"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers plan and track work across every team."}],"growth-jira-onboarding.invite-reminder-with-board-activitye.message-template.email.project-launch":[{"type":1,"value":"projectName"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.body-text":[{"children":[{"type":0,"value":"Jira is the #1 project management tool"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers plan and track work across every team."}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.button-text":[{"type":0,"value":"Join now"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.created-by":[{"type":0,"value":"Created by "},{"type":1,"value":"projectAdmin"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.header":[{"type":0,"value":"Start collaborating with your team in Jira"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.invite-nudge.banner":[{"type":0,"value":"\uD83D\uDC4B "},{"children":[{"type":0,"value":"Forward this email"}],"type":8,"value":"b"},{"type":0,"value":" to easily invite more teammates"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.project-launch":[{"type":1,"value":"filteredProjectName"},{"type":0,"value":" Launch"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.subject.start-collaborating":[{"type":0,"value":"Start collaborating with your team on "},{"type":1,"value":"filteredProjectName"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.unsubscribe-link-text":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"jira-sidebar-nav-day-x-notification.body-text":[{"type":0,"value":"We\u2019ve added features to boost your productivity. "},{"children":[{"type":0,"value":"Customize your sidebar"}],"type":8,"value":"strong"},{"type":0,"value":" to change what shows up."}],"jira-sidebar-nav-day-x-notification.button-text":[{"type":0,"value":"Got it"}],"post-office.components.email.default-project-name":[{"type":0,"value":"Big Campaign"}],"post-office.components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.components.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.growth-jira-onboarding-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.growth-jira-onboarding-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.growth-jira-onboarding-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.growth-jira-onboarding-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.growth-jira-onboarding-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.growth-jira-onboarding-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.growth-jira-onboarding-common.footer.footer-links.join-atlassian-community":[{"type":1,"value":"joinAtlassianCommunity"}],"post-office.growth-jira-onboarding-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.growth-jira-onboarding-common.footer.footer-links.read-in-browser":[{"type":1,"value":"readInBrowser"}],"post-office.growth-jira-onboarding-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.growth-jira-onboarding-common.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"post-office.growth-jira-onboarding-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.growth-jira-onboarding-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.growth-jira-onboarding-common.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.growth-jira-onboarding-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.growth-jira-onboarding-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.growth-jira-onboarding-common.footer.read-in-browser":[{"type":0,"value":"Read in browser \u2022 "}],"post-office.growth-jira-onboarding-common.footer.read-our-blog":[{"type":0,"value":"Read our blog \u2022 "}],"post-office.growth-jira-onboarding-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.growth-jira-onboarding-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.growth-jira-onboarding-common.footer.unsubscribe":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or "},{"type":1,"value":"unsubscribe"},{"type":0,"value":" here."}],"post-office.growth-jira-onboarding-common.footer.unsubscribeText":[{"type":0,"value":"unsubscribe"}],"post-office.growth-jira-onboarding-common.jira-email-header.atlassian-text":[{"type":0,"value":"Atlassian"}],"post-office.growth-jira-onboarding-common.jira-email-header.jira-logo-alt-text":[{"type":0,"value":"Jira"}],"post-office.growth-jira-onboarding-common.jira-email-header.jira-text":[{"type":0,"value":"Jira"}],"post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Tell us about your setup experience and we\u2019ll send you a $100 gift card as a thank you."}],"post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Join our paid research study \uD83D\uDCB8"}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.body":[{"type":0,"value":"Use Rovo to create structured tasks, connect agents, and organize work."}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.cta":[{"type":0,"value":"Try now"}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.headline":[{"type":0,"value":"Try a suggested action"}],"post-office.growth-jira-onboarding.jira-setup-user-interviews-signup.screen-space-flags.cta-link":[{"type":0,"value":"Join now"}],"post-office.test-placement.jonboarding-jira-side-nav-projects.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}]}');

});

parcelRegister("2B4Ug", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hVwan").then(()=>parcelRequire('35zxg'));

});

parcelRegister("hxljK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("apD53").then(()=>parcelRequire('8LOK1'));

});

parcelRegister("5SikO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h5Wpl").then(()=>parcelRequire('gb8Fd'));

});

parcelRegister("aCosb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hPr2X").then(()=>parcelRequire('1HAR9'));

});

parcelRegister("kC40R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jLaYd").then(()=>parcelRequire('avYBx'));

});

parcelRegister("kE33p", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j3cLC").then(()=>parcelRequire('7EiEH'));

});

parcelRegister("aa48A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("31c2F").then(()=>parcelRequire('kEGXp'));

});

parcelRegister("jPuEL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bYU6B").then(()=>parcelRequire('1BXCT'));

});

parcelRegister("9BODd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8aNu5").then(()=>parcelRequire('1Xatv'));

});

parcelRegister("4Vv7l", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eUkqk").then(()=>parcelRequire('5T7j0'));

});

parcelRegister("4PQOk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iUPGS").then(()=>parcelRequire('7juKT'));

});

parcelRegister("fX8xj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a5Mxp").then(()=>parcelRequire('j9igY'));

});

parcelRegister("b03CJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("QJddz").then(()=>parcelRequire('jcXdf'));

});

parcelRegister("4ziGW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lAUae").then(()=>parcelRequire('8NrY1'));

});

parcelRegister("7ZPAn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("koz38").then(()=>parcelRequire('1M8m2'));

});

parcelRegister("gkHoQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5GO4r").then(()=>parcelRequire('lsShW'));

});

parcelRegister("cy4Fs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l1TYO").then(()=>parcelRequire('kigaQ'));

});

parcelRegister("5t9ak", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eacie").then(()=>parcelRequire('3ltP1'));

});

parcelRegister("cGbdG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dsrKl").then(()=>parcelRequire('5Tnnk'));

});

parcelRegister("9acBK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aS0Rl").then(()=>parcelRequire('2021q'));

});

parcelRegister("5XTIF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d19md").then(()=>parcelRequire('c6mPA'));

});

parcelRegister("j71WC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dVpdZ").then(()=>parcelRequire('3vvZz'));

});

parcelRegister("2a7N5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aI2nV").then(()=>parcelRequire('kWLyU'));

});

parcelRegister("acHkf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ulOv").then(()=>parcelRequire('7kqMG'));

});

parcelRegister("foB5Z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5XnKH").then(()=>parcelRequire('H0qh6'));

});

parcelRegister("42qZG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5aiCH").then(()=>parcelRequire('5vOSw'));

});

parcelRegister("lRzNF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eZIgX").then(()=>parcelRequire('eYToF'));

});

parcelRegister("jnoXN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1QupD").then(()=>parcelRequire('eOFQf'));

});

parcelRegister("1GuWw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bVyB8").then(()=>parcelRequire('guhIa'));

});

parcelRegister("k5wya", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iEe0O").then(()=>parcelRequire('E2Zi5'));

});

parcelRegister("3Zwkh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2zc7c").then(()=>parcelRequire('k3srv'));

});

parcelRegister("mh7qy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lpm6n").then(()=>parcelRequire('i4qfn'));

});

parcelRegister("4pZEE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8LODi").then(()=>parcelRequire('9iKA5'));

});

parcelRegister("aJa74", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cpxQy").then(()=>parcelRequire('hDQQ6'));

});


parcelRegister("2LjiL", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $a19e2c8342fb5c7d$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $7uNIk = parcelRequire("7uNIk");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a19e2c8342fb5c7d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a19e2c8342fb5c7d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("bGW9v")));
        case 'da':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("6YflN")));
        case 'de':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("79mZi")));
        case 'en-GB':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("9abmS")));
        case 'en-US':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("6Lf28")));
        case 'en-XA':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("a7WQb")));
        case 'en-XB':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("1Vjvk")));
        case 'en-ZZ':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("gEiS7")));
        case 'en':
            return $a19e2c8342fb5c7d$var$importHelper(await Promise.resolve((parcelRequire("7uNIk"))));
        case 'es':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("7uhC6")));
        case 'et':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("1Zxip")));
        case 'fi':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("i1Hgb")));
        case 'fr':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("1qJ2w")));
        case 'hr':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("QZLXT")));
        case 'hu':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("hVoe7")));
        case 'it':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("fpGxn")));
        case 'ja':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("kX7Vc")));
        case 'ko':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("jsb5e")));
        case 'nb':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("gMfM1")));
        case 'nl':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("2qPAb")));
        case 'pl':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("kETEV")));
        case 'pt-BR':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("7uTq4")));
        case 'ro':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("iIUVB")));
        case 'ru':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("cJbYk")));
        case 'sl':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("c0qwO")));
        case 'sr-RS':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("dnZ9g")));
        case 'sr-YR':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("8UAtj")));
        case 'sr':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("9vhWC")));
        case 'sv':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("k9gx6")));
        case 'th':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("cEbGd")));
        case 'tr':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("9Ys5g")));
        case 'uk':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("jtkjH")));
        case 'vi':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("1jvAs")));
        case 'zh-CN':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("3zgyn")));
        case 'zh-TW':
            return $a19e2c8342fb5c7d$var$importHelper(await (parcelRequire("5Lykz")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7uNIk));
    }
};

});
parcelRegister("7uNIk", function(module, exports) {
module.exports = JSON.parse("{\"dismissButton\":[{\"type\":0,\"value\":\"OK\"}],\"jira-issueview-status.issue-view-resolution-changeboarding-body\":[{\"type\":0,\"value\":\"To keep key information in one spot, we've moved the status and resolution field to the left\"}],\"jira-issueview-status.issue-view-resolution-changeboarding-heading\":[{\"type\":0,\"value\":\"Status is now on the left\"}],\"jira-issueview-status.issue-view-status-changeboarding-body\":[{\"type\":0,\"value\":\"To keep key information in one spot, we've moved status to the left\"}],\"jira-issueview-status.issue-view-status-changeboarding-heading\":[{\"type\":0,\"value\":\"Status is now on the left\"}],\"post-office.jira-issueview-status.main-heading.no-translate\":[{\"type\":0,\"value\":\"Welcome to Jira Issue View Status\"}]}");

});

parcelRegister("bGW9v", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8UOZC").then(()=>parcelRequire('5I6lK'));

});

parcelRegister("6YflN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6A0kU").then(()=>parcelRequire('87CMD'));

});

parcelRegister("79mZi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Y6Is").then(()=>parcelRequire('bLhCW'));

});

parcelRegister("9abmS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kDMIT").then(()=>parcelRequire('lUFSx'));

});

parcelRegister("6Lf28", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8uytE").then(()=>parcelRequire('9C2Tb'));

});

parcelRegister("a7WQb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cUTzi").then(()=>parcelRequire('gMVtC'));

});

parcelRegister("1Vjvk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3xRUP").then(()=>parcelRequire('3UTEy'));

});

parcelRegister("gEiS7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lomaG").then(()=>parcelRequire('eiLXN'));

});

parcelRegister("7uhC6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hL6DE").then(()=>parcelRequire('3Y2sk'));

});

parcelRegister("1Zxip", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3TVRJ").then(()=>parcelRequire('fYXBB'));

});

parcelRegister("i1Hgb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bAtFm").then(()=>parcelRequire('uZtLw'));

});

parcelRegister("1qJ2w", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7FZbO").then(()=>parcelRequire('jGnam'));

});

parcelRegister("QZLXT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l4FJ9").then(()=>parcelRequire('dnfv7'));

});

parcelRegister("hVoe7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cjF4m").then(()=>parcelRequire('QGMSd'));

});

parcelRegister("fpGxn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fAeN1").then(()=>parcelRequire('fnVqn'));

});

parcelRegister("kX7Vc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dWuqK").then(()=>parcelRequire('3AEdo'));

});

parcelRegister("jsb5e", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("culiR").then(()=>parcelRequire('80cyp'));

});

parcelRegister("gMfM1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Pdxj").then(()=>parcelRequire('5pjGU'));

});

parcelRegister("2qPAb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bF9Tv").then(()=>parcelRequire('SrCct'));

});

parcelRegister("kETEV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("759ND").then(()=>parcelRequire('ersl7'));

});

parcelRegister("7uTq4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1bqKH").then(()=>parcelRequire('b4lpC'));

});

parcelRegister("iIUVB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8eb78").then(()=>parcelRequire('1XBEZ'));

});

parcelRegister("cJbYk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bTQW5").then(()=>parcelRequire('dH9zb'));

});

parcelRegister("c0qwO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3jIig").then(()=>parcelRequire('iuGTm'));

});

parcelRegister("dnZ9g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5fsoL").then(()=>parcelRequire('3ip5K'));

});

parcelRegister("8UAtj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dKqQN").then(()=>parcelRequire('3fXAa'));

});

parcelRegister("9vhWC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7PMtG").then(()=>parcelRequire('38iFr'));

});

parcelRegister("k9gx6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ciBPV").then(()=>parcelRequire('iBqPo'));

});

parcelRegister("cEbGd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gWb8M").then(()=>parcelRequire('gRrGs'));

});

parcelRegister("9Ys5g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2wHBy").then(()=>parcelRequire('28BF4'));

});

parcelRegister("jtkjH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4q0gJ").then(()=>parcelRequire('3E3Bo'));

});

parcelRegister("1jvAs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ixVjg").then(()=>parcelRequire('OscPX'));

});

parcelRegister("3zgyn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2OI1w").then(()=>parcelRequire('2g86A'));

});

parcelRegister("5Lykz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lSqEf").then(()=>parcelRequire('3A4DE'));

});


parcelRegister("33RDh", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $42cedf1982978498$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9U5pS = parcelRequire("9U5pS");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42cedf1982978498$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $42cedf1982978498$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("jcfjA")));
        case 'da':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("7KSkb")));
        case 'de':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("kt3Xp")));
        case 'en-GB':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("a0H4M")));
        case 'en-US':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("llSQC")));
        case 'en-XA':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("77iwd")));
        case 'en-XB':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("jlMbb")));
        case 'en-ZZ':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("2rr6J")));
        case 'en':
            return $42cedf1982978498$var$importHelper(await Promise.resolve((parcelRequire("9U5pS"))));
        case 'es':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("739rv")));
        case 'et':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("53lFP")));
        case 'fi':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("TFMXs")));
        case 'fr':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("lhyNZ")));
        case 'hr':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("9ASo7")));
        case 'hu':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("hHDsQ")));
        case 'it':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("dFdcE")));
        case 'ja':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("fww2P")));
        case 'ko':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("jvLkG")));
        case 'nb':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("llyAu")));
        case 'nl':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("g9tot")));
        case 'pl':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("cro9Y")));
        case 'pt-BR':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("8VEYw")));
        case 'ro':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("ieIck")));
        case 'ru':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("aPIKg")));
        case 'sl':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("gTGrs")));
        case 'sr-RS':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("kFKr9")));
        case 'sr-YR':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("7yTdM")));
        case 'sr':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("5zn2p")));
        case 'sv':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("3CwF1")));
        case 'th':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("8OYoB")));
        case 'tr':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("4nywb")));
        case 'uk':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("yuiCZ")));
        case 'vi':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("e1t6X")));
        case 'zh-CN':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("cWndg")));
        case 'zh-TW':
            return $42cedf1982978498$var$importHelper(await (parcelRequire("4OyTm")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9U5pS));
    }
};

});
parcelRegister("9U5pS", function(module, exports) {
module.exports = JSON.parse("{\"jira-nin-grouping-with-hierarchy-spotlight.spotlightDismissButton\":[{\"type\":0,\"value\":\"Done\"}],\"jira-nin-grouping-with-hierarchy-spotlight.spotlightHeading\":[{\"type\":0,\"value\":\"Show hierarchy when grouping\"}],\"jira-nin-grouping-with-hierarchy-spotlight.spotlightImageAltText\":[{\"type\":0,\"value\":\"Illustration of the hierarchy toggle enabled when grouping is applied in the List View.\"}],\"jira-nin-grouping-with-hierarchy-spotlight.spotlightManageHierarchyDescription\":[{\"type\":0,\"value\":\"To manage hierarchy, select \"},{\"children\":[{\"type\":0,\"value\":\"More actions (...)\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" at the top-right of your list.\"}],\"jira-nin-grouping-with-hierarchy-spotlight.spotlightSeeRelationshipsDescription\":[{\"type\":0,\"value\":\"See relationships between work items when you group the list view.\"}],\"jira-nin-paid-list-merge-modal-onboarding.closeButton\":[{\"type\":0,\"value\":\"Close\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescriptionContentRefresh\":[{\"type\":0,\"value\":\"Want to use the same settings that you're currently using in List? This includes filters, groups and columns you've set.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltText\":[{\"type\":0,\"value\":\"Illustration of multiple spaces stacked to show everything will migrate together.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextCurrentSpace\":[{\"type\":0,\"value\":\"Illustration of a single space showing the list settings will migrate to the new view.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextNo\":[{\"type\":0,\"value\":\"Illustration of a cursor selecting the More actions menu to choose migrate later.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoContentRefresh\":[{\"type\":0,\"value\":\"Don't apply current settings\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescriptionContentRefresh\":[{\"type\":0,\"value\":\"Update settings later in More actions (...)\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpacesContentRefresh\":[{\"type\":0,\"value\":\"Apply current settings for all spaces I use\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpaceContentRefresh\":[{\"type\":0,\"value\":\"Apply current settings for \"},{\"type\":1,\"value\":\"spaceName\"},{\"type\":0,\"value\":\" space only\"}],\"jira-nin-paid-list-merge-modal-onboarding.descriptionContentRefresh\":[{\"type\":0,\"value\":\"We've combined the best of List and All work into \"},{\"children\":[{\"type\":0,\"value\":\"one powerful, unified view for managing work items.\"}],\"type\":8,\"value\":\"link\"}],\"jira-nin-paid-list-merge-modal-onboarding.headingContentRefresh\":[{\"type\":0,\"value\":\"A single, more powerful List view\"}],\"jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback\":[{\"type\":0,\"value\":\"current\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label\":[{\"type\":0,\"value\":\"Apply settings\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label\":[{\"type\":0,\"value\":\"Explore List view\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.filter\":[{\"type\":0,\"value\":\"Search, filter, and group work items to quickly find what you need.\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions\":[{\"type\":0,\"value\":\"Adjust how you visualise the work with charts and format rules. You can also apply your old list settings.\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.text\":[{\"type\":0,\"value\":\"Find work faster using filters.\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.text.advanced.jql\":[{\"type\":0,\"value\":\"Select advanced or JQL mode to filter by more fields.\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.title\":[{\"type\":0,\"value\":\"A new home for filters\"}]}");

});

parcelRegister("jcfjA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1iBXy").then(()=>parcelRequire('6nEG2'));

});

parcelRegister("7KSkb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dVWKi").then(()=>parcelRequire('5NJm8'));

});

parcelRegister("kt3Xp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4hrLq").then(()=>parcelRequire('c7cXy'));

});

parcelRegister("a0H4M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gN3Km").then(()=>parcelRequire('gBgPf'));

});

parcelRegister("llSQC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d9ts4").then(()=>parcelRequire('lCOXP'));

});

parcelRegister("77iwd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("71c3W").then(()=>parcelRequire('gcXjG'));

});

parcelRegister("jlMbb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1F443").then(()=>parcelRequire('ht4Bw'));

});

parcelRegister("2rr6J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3rW1z").then(()=>parcelRequire('5BFho'));

});

parcelRegister("739rv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jlp5d").then(()=>parcelRequire('6CrNx'));

});

parcelRegister("53lFP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kflD5").then(()=>parcelRequire('5Jb4x'));

});

parcelRegister("TFMXs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("flhyt").then(()=>parcelRequire('7yxVC'));

});

parcelRegister("lhyNZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2daNM").then(()=>parcelRequire('kJhl5'));

});

parcelRegister("9ASo7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1rMVg").then(()=>parcelRequire('brzJG'));

});

parcelRegister("hHDsQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3aeVM").then(()=>parcelRequire('72ntm'));

});

parcelRegister("dFdcE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kAJo7").then(()=>parcelRequire('br6cZ'));

});

parcelRegister("fww2P", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4WKXF").then(()=>parcelRequire('8sk1G'));

});

parcelRegister("jvLkG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5TzYe").then(()=>parcelRequire('hgLTA'));

});

parcelRegister("llyAu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7WvlH").then(()=>parcelRequire('gKsHA'));

});

parcelRegister("g9tot", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9KY3V").then(()=>parcelRequire('cJIJb'));

});

parcelRegister("cro9Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("klEBs").then(()=>parcelRequire('327qN'));

});

parcelRegister("8VEYw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fnh1J").then(()=>parcelRequire('gSHMw'));

});

parcelRegister("ieIck", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fDsAO").then(()=>parcelRequire('32MsL'));

});

parcelRegister("aPIKg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2NRSs").then(()=>parcelRequire('imQSo'));

});

parcelRegister("gTGrs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kLc4P").then(()=>parcelRequire('7z0wx'));

});

parcelRegister("kFKr9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kb0Ie").then(()=>parcelRequire('75pvj'));

});

parcelRegister("7yTdM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jvbCm").then(()=>parcelRequire('dy5EH'));

});

parcelRegister("5zn2p", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l0UhE").then(()=>parcelRequire('3vt1l'));

});

parcelRegister("3CwF1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dQuEF").then(()=>parcelRequire('1Bjhg'));

});

parcelRegister("8OYoB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hexYi").then(()=>parcelRequire('jWbwT'));

});

parcelRegister("4nywb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aZdzN").then(()=>parcelRequire('6y3K7'));

});

parcelRegister("yuiCZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cBnd5").then(()=>parcelRequire('54M2V'));

});

parcelRegister("e1t6X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hdHD4").then(()=>parcelRequire('7BoJv'));

});

parcelRegister("cWndg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cwXye").then(()=>parcelRequire('iGxbP'));

});

parcelRegister("4OyTm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iB5ZB").then(()=>parcelRequire('fN5m0'));

});


parcelRegister("42Dsa", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $9f14a503b5f1e3c7$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6w5af = parcelRequire("6w5af");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f14a503b5f1e3c7$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9f14a503b5f1e3c7$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("idpgw")));
        case 'da':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("ls2Tq")));
        case 'de':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("62Dtz")));
        case 'en-GB':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("gU2gN")));
        case 'en-US':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("5t8zR")));
        case 'en-XA':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("qP0om")));
        case 'en-XB':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("dzheI")));
        case 'en-ZZ':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("f3rCP")));
        case 'en':
            return $9f14a503b5f1e3c7$var$importHelper(await Promise.resolve((parcelRequire("6w5af"))));
        case 'es':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("atWKT")));
        case 'et':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("28WXC")));
        case 'fi':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("93XO7")));
        case 'fr':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("4AcDv")));
        case 'hr':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("1reuS")));
        case 'hu':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("5x4mR")));
        case 'it':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("kqIjI")));
        case 'ja':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("7AWtH")));
        case 'ko':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("hmC7v")));
        case 'nb':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("d8fws")));
        case 'nl':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("4QzUy")));
        case 'pl':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("9RNJ0")));
        case 'pt-BR':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("hYtv8")));
        case 'ro':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("hpRR7")));
        case 'ru':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("lRI6P")));
        case 'sl':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("6nSGV")));
        case 'sr-RS':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("3fAcs")));
        case 'sr-YR':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("4nTad")));
        case 'sr':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("lE7n7")));
        case 'sv':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("j8DXB")));
        case 'th':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("koVA7")));
        case 'tr':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("jq7NZ")));
        case 'uk':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("2qNs3")));
        case 'vi':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("5HhCr")));
        case 'zh-CN':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("dMLVP")));
        case 'zh-TW':
            return $9f14a503b5f1e3c7$var$importHelper(await (parcelRequire("92AxF")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6w5af));
    }
};

});
parcelRegister("6w5af", function(module, exports) {
module.exports = JSON.parse("{\"jira-pandora.common.footer.address.no-translate\":[{\"type\":0,\"value\":\"341 George Street, Sydney, NSW, 2000, Australia\"}],\"jira-pandora.common.footer.copyright.no-translate\":[{\"type\":0,\"value\":\"Copyright 2025 Atlassian Pty Ltd. All rights reserved.\"}],\"jira-pandora.common.project-access-email.banner.alt\":[{\"type\":0,\"value\":\"Jira banner image\"}],\"jira-pandora.jira-project-access-granted.email.body.content\":[{\"type\":0,\"value\":\"You can now access \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"You can now access your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.button.redacted.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.email.button.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"You've been granted access to your project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.subject\":[{\"type\":0,\"value\":\"You've been granted access to \"},{\"type\":1,\"value\":\"projectName\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.content\":[{\"type\":0,\"value\":\"Users have requested to join \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" project\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"Users have requested to join your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.redacted.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"Access request for your project\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.subject\":[{\"type\":0,\"value\":\"Access request for \"},{\"type\":1,\"value\":\"projectName\"}],\"jira-sprints-auto-managed-feature-discovery.spotlight-content\":[{\"type\":0,\"value\":\"Sprints can now start and complete automatically based on their scheduled dates.\"}],\"jira-sprints-auto-managed-feature-discovery.spotlight-cta-button-label\":[{\"type\":0,\"value\":\"See how\"}],\"jira-sprints-auto-managed-feature-discovery.spotlight-headline\":[{\"type\":0,\"value\":\"Automate your sprint transitions\"}]}");

});

parcelRegister("idpgw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5sYkh").then(()=>parcelRequire('73UcX'));

});

parcelRegister("ls2Tq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dBH9G").then(()=>parcelRequire('b3RH1'));

});

parcelRegister("62Dtz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5KlrU").then(()=>parcelRequire('hMrGq'));

});

parcelRegister("gU2gN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hwG8u").then(()=>parcelRequire('b4bNK'));

});

parcelRegister("5t8zR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bE2N9").then(()=>parcelRequire('4jmXl'));

});

parcelRegister("qP0om", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kezna").then(()=>parcelRequire('jzMgV'));

});

parcelRegister("dzheI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kD4a8").then(()=>parcelRequire('dgRQO'));

});

parcelRegister("f3rCP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hyptw").then(()=>parcelRequire('hX9gz'));

});

parcelRegister("atWKT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ewrEb").then(()=>parcelRequire('c4Xa6'));

});

parcelRegister("28WXC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8ebf4").then(()=>parcelRequire('gou7z'));

});

parcelRegister("93XO7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7yuYp").then(()=>parcelRequire('kIYs4'));

});

parcelRegister("4AcDv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jfjYL").then(()=>parcelRequire('ekTa6'));

});

parcelRegister("1reuS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2wAIB").then(()=>parcelRequire('ece5b'));

});

parcelRegister("5x4mR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gXBBV").then(()=>parcelRequire('cuEgc'));

});

parcelRegister("kqIjI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9hL2F").then(()=>parcelRequire('kmVaN'));

});

parcelRegister("7AWtH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eQwBk").then(()=>parcelRequire('5whCr'));

});

parcelRegister("hmC7v", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ip29u").then(()=>parcelRequire('ZTUmL'));

});

parcelRegister("d8fws", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e95U3").then(()=>parcelRequire('j6oAV'));

});

parcelRegister("4QzUy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aCSr3").then(()=>parcelRequire('aqqHI'));

});

parcelRegister("9RNJ0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gx6dD").then(()=>parcelRequire('hZ53J'));

});

parcelRegister("hYtv8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7ckke").then(()=>parcelRequire('bJQfy'));

});

parcelRegister("hpRR7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bDhHc").then(()=>parcelRequire('a0gZm'));

});

parcelRegister("lRI6P", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8tmbr").then(()=>parcelRequire('lkr0v'));

});

parcelRegister("6nSGV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eMavg").then(()=>parcelRequire('7JGwq'));

});

parcelRegister("3fAcs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("chze4").then(()=>parcelRequire('lMoUK'));

});

parcelRegister("4nTad", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kEMBi").then(()=>parcelRequire('by598'));

});

parcelRegister("lE7n7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eSbUm").then(()=>parcelRequire('h80o8'));

});

parcelRegister("j8DXB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9dcKi").then(()=>parcelRequire('ewTpk'));

});

parcelRegister("koVA7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b6Dqs").then(()=>parcelRequire('7KCi5'));

});

parcelRegister("jq7NZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6QIcp").then(()=>parcelRequire('c9mZd'));

});

parcelRegister("2qNs3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4S62Y").then(()=>parcelRequire('40WJH'));

});

parcelRegister("5HhCr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("71DnZ").then(()=>parcelRequire('gqzts'));

});

parcelRegister("dMLVP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kj1kk").then(()=>parcelRequire('lEslx'));

});

parcelRegister("92AxF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("75MFN").then(()=>parcelRequire('iNS3Z'));

});


parcelRegister("10ncK", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $79bd2a01d7ddfb5a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jQRqD = parcelRequire("jQRqD");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $79bd2a01d7ddfb5a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $79bd2a01d7ddfb5a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("e6Pcm")));
        case 'da':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("fOYNo")));
        case 'de':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("gEzfU")));
        case 'en-GB':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("8Fn6Q")));
        case 'en-US':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("ke2l8")));
        case 'en-XA':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("5ffJx")));
        case 'en-XB':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("l8LYu")));
        case 'en-ZZ':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("7wuZX")));
        case 'en':
            return $79bd2a01d7ddfb5a$var$importHelper(await Promise.resolve((parcelRequire("jQRqD"))));
        case 'es':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("29wxe")));
        case 'et':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("lI9Fs")));
        case 'fi':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("3EG5x")));
        case 'fr':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("ccs79")));
        case 'hr':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("kN8tF")));
        case 'hu':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("aKsD8")));
        case 'it':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("dkccd")));
        case 'ja':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("2xlq7")));
        case 'ko':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("fuMw5")));
        case 'nb':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("dEqAd")));
        case 'nl':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("dFPzj")));
        case 'pl':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("5IxHI")));
        case 'pt-BR':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("aDuSM")));
        case 'ro':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("e9TVz")));
        case 'ru':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("8qv2B")));
        case 'sl':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("3yu2c")));
        case 'sr-RS':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("6vnmH")));
        case 'sr-YR':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("bmK9h")));
        case 'sr':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("hl6zj")));
        case 'sv':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("dDYK6")));
        case 'th':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("81yy2")));
        case 'tr':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("c0nzH")));
        case 'uk':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("hEwec")));
        case 'vi':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("lS29B")));
        case 'zh-CN':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("XV1e7")));
        case 'zh-TW':
            return $79bd2a01d7ddfb5a$var$importHelper(await (parcelRequire("bpYj9")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jQRqD));
    }
};

});
parcelRegister("jQRqD", function(module, exports) {
module.exports = JSON.parse('{"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.cta-button":[{"type":0,"value":"View your plan"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.header-title":[{"type":0,"value":"Your plan is waiting for you!"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.intro-paragraph-1":[{"type":0,"value":"Getting started is the hardest step, and you\'ve already done that! Your plan "},{"type":1,"value":"planTitle"},{"type":0,"value":" is waiting for you to unlock its full potential!"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.intro-paragraph-2":[{"type":0,"value":"Whether you\'re managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-description":[{"type":0,"value":"View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view. "}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-link":[{"type":0,"value":"Open the Timeline view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-title":[{"type":0,"value":"See the big picture"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-description":[{"type":0,"value":"Share important dates from your plan with stakeholders using the Calendar view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-link":[{"type":0,"value":"Open the Calendar view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-title":[{"type":0,"value":"Take it day-by-day"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-description":[{"type":0,"value":"Track work that\'s blocked by other work using the Dependencies view, and resolve conflicts before they become problems."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-link":[{"type":0,"value":"Open the Dependencies view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-title":[{"type":0,"value":"Transparency for all"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-description":[{"type":0,"value":"Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-link":[{"type":0,"value":"Open your Summary view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-title":[{"type":0,"value":"Visualize your progress"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.blog":[{"type":0,"value":"Read our blog"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.contact-us":[{"type":0,"value":"Contact Us"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"currentYear"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.message-template.email.subject":[{"type":0,"value":"Plan and track complex work confidently in "},{"type":1,"value":"planTitle"},{"type":0,"value":" in a few easy steps"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.cta-button":[{"type":0,"value":"View your plan"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.header-title":[{"type":0,"value":"Your plan is waiting for you!"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.intro-paragraph-1":[{"type":0,"value":"Getting started is the hardest step, and you\'ve already done that! Your plan "},{"type":1,"value":"planTitle"},{"type":0,"value":" is waiting for you to unlock its full potential!"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.intro-paragraph-2":[{"type":0,"value":"Whether you\'re managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-description":[{"type":0,"value":"View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view. "}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-read-more":[{"type":0,"value":"Read more."}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-title":[{"type":0,"value":"See the big picture"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-description":[{"type":0,"value":"Balance the workload among your teams to create an achievable yet realistic delivery plan. "}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-read-more":[{"type":0,"value":"Read more."}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-title":[{"type":0,"value":"Spread the load"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-description":[{"type":0,"value":"Track work that\'s blocked by other work using the Dependencies view, and resolve conflicts before they become problems. "}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-read-more":[{"type":0,"value":"Read more."}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-title":[{"type":0,"value":"Transparency for all"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-description":[{"type":0,"value":"Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track. "}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-read-more":[{"type":0,"value":"Read more."}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-title":[{"type":0,"value":"Visualize your progress"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.blog":[{"type":0,"value":"Read our blog"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.contact-us":[{"type":0,"value":"Contact Us"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"currentYear"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.message-template.email.subject":[{"type":0,"value":"Plan and track complex work confidently in "},{"type":1,"value":"planTitle"},{"type":0,"value":" in a few easy steps"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.cta-button":[{"type":0,"value":"View your plan"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.header-title":[{"type":0,"value":"Your plan is waiting for you!"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.intro-paragraph-1":[{"type":0,"value":"Getting started is the hardest step, and you\'ve already done that! Your plan "},{"type":1,"value":"planTitle"},{"type":0,"value":" is waiting for you to unlock its full potential!"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.intro-paragraph-2":[{"type":0,"value":"Whether you\'re managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.see-big-picture-description":[{"type":0,"value":"View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.see-big-picture-title":[{"type":0,"value":"See the big picture"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.stay-realistic-description":[{"type":0,"value":"Balance the workload among your teams to create an achievable yet realistic delivery plan."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.stay-realistic-title":[{"type":0,"value":"Spread the load"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.take-it-day-by-day-description":[{"type":0,"value":"Share important dates from your plan with stakeholders using the Calendar view."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.take-it-day-by-day-title":[{"type":0,"value":"Take it day-by-day"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.transparency-for-all-description":[{"type":0,"value":"Track work that\'s blocked by other work using the Dependencies view, and resolve conflicts before they become problems."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.transparency-for-all-title":[{"type":0,"value":"Transparency for all"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.visualize-your-progress-description":[{"type":0,"value":"Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.visualize-your-progress-title":[{"type":0,"value":"Visualize your progress"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.blog":[{"type":0,"value":"Read our blog"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.contact-us":[{"type":0,"value":"Contact Us"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"currentYear"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.message-template.email.subject":[{"type":0,"value":"Plan and track complex work confidently in "},{"type":1,"value":"planTitle"},{"type":0,"value":" in a few easy steps"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.avatar.no-translate":[{"type":0,"value":"avatar"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.globe.no-translate":[{"type":0,"value":"globeLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"planTitle"},{"type":0,"value":" "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.join.link":[{"type":0,"value":"Join the Plan"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.learn.more.message":[{"type":0,"value":"Learn more about Jira"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.logo.no-translate":[{"type":0,"value":"logo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template.dot":[{"type":0,"value":"."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.write.no-translate":[{"type":0,"value":"writeLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"planTitle"},{"type":0,"value":")"}],"jira-chronos.plan-calendar-create-item-spotlight.body":[{"type":0,"value":"Use + to create a work item without leaving the Calendar."}],"jira-chronos.plan-calendar-create-item-spotlight.done":[{"type":0,"value":"Done"}],"jira-chronos.plan-calendar-create-item-spotlight.header":[{"type":0,"value":"Add here, view here"}],"jira-plan-created-reminder-experiment.action":[{"type":0,"value":"View plan"}],"jira-plan-created-reminder-experiment.body":[{"type":0,"value":"View your plan from end-to-end and get insights to help you move forward. Your plan can do it all!"}],"jira-plan-created-reminder-experiment.title":[{"type":1,"value":"planTitle"},{"type":0,"value":" is waiting for you in Jira"}],"jira-plans-efa-change-boarding.message-templates.flag.description":[{"type":0,"value":"Fields that aren\u2019t part of a space\u2019s configuration can no longer be used in your plan. Add those fields to your space to use them again."}],"jira-plans-efa-change-boarding.message-templates.flag.goToSettings":[{"type":0,"value":"Go to settings"}],"jira-plans-efa-change-boarding.message-templates.flag.read-more":[{"type":0,"value":"Read more"}],"jira-plans-efa-change-boarding.message-templates.flag.title":[{"type":0,"value":"Some fields in your plan may be deactivated."}]}');

});

parcelRegister("e6Pcm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bQTyw").then(()=>parcelRequire('2oVi7'));

});

parcelRegister("fOYNo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8VJpd").then(()=>parcelRequire('aAftE'));

});

parcelRegister("gEzfU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("OF5Y9").then(()=>parcelRequire('52dmj'));

});

parcelRegister("8Fn6Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bPfU9").then(()=>parcelRequire('2xmxm'));

});

parcelRegister("ke2l8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("11KcU").then(()=>parcelRequire('fV2tR'));

});

parcelRegister("5ffJx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ix5AG").then(()=>parcelRequire('4SBLT'));

});

parcelRegister("l8LYu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jLwMn").then(()=>parcelRequire('96qn8'));

});

parcelRegister("7wuZX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("m6PcQ").then(()=>parcelRequire('dLaBw'));

});

parcelRegister("29wxe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iaZLB").then(()=>parcelRequire('hH3JT'));

});

parcelRegister("lI9Fs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ib3zj").then(()=>parcelRequire('aWhpv'));

});

parcelRegister("3EG5x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("80uQj").then(()=>parcelRequire('3UTMj'));

});

parcelRegister("ccs79", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kWMwF").then(()=>parcelRequire('1fPpp'));

});

parcelRegister("kN8tF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9TUBq").then(()=>parcelRequire('c7CRe'));

});

parcelRegister("aKsD8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fMZ7a").then(()=>parcelRequire('jX5jU'));

});

parcelRegister("dkccd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5A2gV").then(()=>parcelRequire('g1EIr'));

});

parcelRegister("2xlq7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kXgzA").then(()=>parcelRequire('bCNcC'));

});

parcelRegister("fuMw5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ioJTV").then(()=>parcelRequire('gzBQ3'));

});

parcelRegister("dEqAd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hlHra").then(()=>parcelRequire('l6Nhv'));

});

parcelRegister("dFPzj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3VpDi").then(()=>parcelRequire('btJK2'));

});

parcelRegister("5IxHI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bl4wI").then(()=>parcelRequire('5P9sD'));

});

parcelRegister("aDuSM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9NgKK").then(()=>parcelRequire('3cHS7'));

});

parcelRegister("e9TVz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cqXvk").then(()=>parcelRequire('du1a1'));

});

parcelRegister("8qv2B", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6L8WG").then(()=>parcelRequire('5ntM8'));

});

parcelRegister("3yu2c", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fF89w").then(()=>parcelRequire('4x3eN'));

});

parcelRegister("6vnmH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jvqLr").then(()=>parcelRequire('805CU'));

});

parcelRegister("bmK9h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2WAI6").then(()=>parcelRequire('9FYJ6'));

});

parcelRegister("hl6zj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("93qrj").then(()=>parcelRequire('hfE8e'));

});

parcelRegister("dDYK6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hJCq8").then(()=>parcelRequire('7pEOK'));

});

parcelRegister("81yy2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fYYJr").then(()=>parcelRequire('kGbV0'));

});

parcelRegister("c0nzH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iaPWB").then(()=>parcelRequire('fwsxQ'));

});

parcelRegister("hEwec", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ffHCR").then(()=>parcelRequire('40H3W'));

});

parcelRegister("lS29B", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kDb3O").then(()=>parcelRequire('44IWY'));

});

parcelRegister("XV1e7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kOfux").then(()=>parcelRequire('gs8EY'));

});

parcelRegister("bpYj9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kcTI5").then(()=>parcelRequire('3V83L'));

});


parcelRegister("8cuyX", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $d826580a412f71cd$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8soKu = parcelRequire("8soKu");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d826580a412f71cd$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $d826580a412f71cd$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("kJSL2")));
        case 'da':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("7kPy0")));
        case 'de':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("7RRZy")));
        case 'en-GB':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("51NoZ")));
        case 'en-US':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("bYRjt")));
        case 'en-XA':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("dpqxt")));
        case 'en-XB':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("N63Bs")));
        case 'en-ZZ':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("5fIxD")));
        case 'en':
            return $d826580a412f71cd$var$importHelper(await Promise.resolve((parcelRequire("8soKu"))));
        case 'es':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("gbHoL")));
        case 'et':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("7X1ii")));
        case 'fi':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("7nyun")));
        case 'fr':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("4yL7Q")));
        case 'hr':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("bdaiZ")));
        case 'hu':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("eM6nk")));
        case 'it':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("7YchU")));
        case 'ja':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("8JNEu")));
        case 'ko':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("5h6BA")));
        case 'nb':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("bIYtw")));
        case 'nl':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("YgyGF")));
        case 'pl':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("3T5gN")));
        case 'pt-BR':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("diRNc")));
        case 'ro':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("6u0pl")));
        case 'ru':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("dyiem")));
        case 'sl':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("3vdDc")));
        case 'sr-RS':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("9Xha4")));
        case 'sr-YR':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("evWZ4")));
        case 'sr':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("7yX5f")));
        case 'sv':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("hAHke")));
        case 'th':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("2XiSl")));
        case 'tr':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("h2nQQ")));
        case 'uk':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("7OHI6")));
        case 'vi':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("5w7S3")));
        case 'zh-CN':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("lUmLU")));
        case 'zh-TW':
            return $d826580a412f71cd$var$importHelper(await (parcelRequire("1GX0I")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8soKu));
    }
};

});
parcelRegister("8soKu", function(module, exports) {
module.exports = JSON.parse('{"ai-rovo.actions-software-backlog.nudge-description.nonfinal":[{"type":0,"value":"We have identified "},{"type":1,"value":"numberOfSuggestions"},{"type":0,"value":" work item "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"update"}]},"other":{"value":[{"type":0,"value":"updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfSuggestions"}],"ai-rovo.actions-software-backlog.nudge-icon-label.nonfinal":[{"type":0,"value":"Work items icon"}],"ai-rovo.actions-software-backlog.nudge-title.nonfinal":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfSuggestions"},{"type":0,"value":" work item "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"update"}]},"other":{"value":[{"type":0,"value":"updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfSuggestions"}],"jira-issueview-quickactions.src.ui.index.recommended-for-you":[{"type":0,"value":"Recommended for you"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.now":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.soon":[{"type":0,"value":"Jira \'projects\' will soon be renamed \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.learn-more":[{"type":0,"value":"Read more about this change"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.now":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.soon":[{"type":0,"value":"Coming soon"}],"jira-pulsar.common.components.cross-flow.add":[{"type":0,"value":"Add"}],"jira-pulsar.common.components.cross-flow.dismiss":[{"type":0,"value":"Dismiss"}],"jira-pulsar.common.components.issue-view-description-ad.close":[{"type":0,"value":"Close"}],"jira-pulsar.jira-comment-mention.message-template.notification-drawer.message":[{"type":1,"value":"user1"},{"type":0,"value":" mentioned you in a comment"}],"jira-pulsar.jira-comment-mention.message-template.notification-drawer.message.anonymous":[{"type":0,"value":"You\'ve been mentioned in a comment"}],"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.jira-logo.alt_text":[{"type":0,"value":"Jira logo"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.redesign.footer.atlassian-logo.no-translate":[{"type":0,"value":"Atlassian logo"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.html.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been assigned to "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been unassigned from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous":[{"type":0,"value":"There\'s a new assignee on an issue"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new assignee on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" to "},{"type":1,"value":"newAssignee"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assignee.change.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" to "},{"type":1,"value":"newAssignee"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"The "},{"options":{"Bug":{"value":[{"type":0,"value":"bug\'s"}]},"Epic":{"value":[{"type":0,"value":"epic\'s"}]},"Generalrequest":{"value":[{"type":0,"value":"request\'s"}]},"Idea":{"value":[{"type":0,"value":"idea\'s"}]},"Story":{"value":[{"type":0,"value":"story\'s"}]},"Subtask":{"value":[{"type":0,"value":"subtask\'s"}]},"Task":{"value":[{"type":0,"value":"task\'s"}]},"other":{"value":[{"type":0,"value":"work item\'s"}]}},"type":5,"value":"issueType"},{"type":0,"value":" assignee has been removed"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new update in a comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" updated the comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.add-comment":[{"type":0,"value":"Add comment"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-create.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" created "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-delete.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been mentioned on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user1"},{"type":0,"value":" mentioned you on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"options":{"Bug":{"value":[{"type":0,"value":"A bug"}]},"Epic":{"value":[{"type":0,"value":"An epic"}]},"Generalrequest":{"value":[{"type":0,"value":"A request"}]},"Idea":{"value":[{"type":0,"value":"An idea"}]},"Story":{"value":[{"type":0,"value":"A story"}]},"Subtask":{"value":[{"type":0,"value":"A subtask"}]},"Task":{"value":[{"type":0,"value":"A task"}]},"other":{"value":[{"type":0,"value":"A work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" has been transitioned from "},{"type":1,"value":"fromStatus"},{"type":0,"value":" to "},{"type":1,"value":"toStatus"}],"jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" changed "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"fromStatus"},{"type":0,"value":" to "},{"type":1,"value":"toStatus"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page":[{"type":0,"value":"Page"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Record a comment"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription":[{"type":0,"value":"Use video to explain the work"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription":[{"type":0,"value":"Record your screen"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video":[{"type":0,"value":"Video"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.addon-banner.gmail":[{"type":0,"value":"Gmail"}],"jira.jira-common.email.addon-banner.install-text":[{"type":0,"value":"Install the Atlassian email extension for "},{"type":1,"value":"gmailLink"},{"type":0,"value":" or "},{"type":1,"value":"outlookLink"},{"type":0,"value":"."}],"jira.jira-common.email.addon-banner.main-text":[{"type":0,"value":"Update work items without leaving your inbox."}],"jira.jira-common.email.addon-banner.opt-out":[{"type":0,"value":"Don\'t show again"}],"jira.jira-common.email.addon-banner.outlook":[{"type":0,"value":"Outlook"}],"jira.jira-common.email.addon-banner.tip":[{"type":0,"value":"Tip:"}],"jira.jira-common.email.dot-separator.no-translate":[{"type":0,"value":" \u2022 "}],"jira.jira-common.email.footer.custom.message":[{"type":1,"value":"footerText"}],"jira.jira-common.email.footer.download.app-store.no-translate":[{"type":0,"value":"Download on the App Store"}],"jira.jira-common.email.footer.get-on.google-play.no-translate":[{"type":0,"value":"Get it on Google Play"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.get.apps.new":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"a1"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"a2"},{"type":0,"value":"."}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent-by-atlassian-jira":[{"type":0,"value":"This email was sent by Atlassian Jira"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.footer.unsubscribe-message":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or unsubscribe "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"link"},{"type":0,"value":"."}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"/"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other person"}]},"other":{"value":[{"type":7},{"type":0,"value":" other people"}]}},"pluralType":"cardinal","type":6,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"an update"}]},"other":{"value":[{"type":1,"value":"count"},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"an update"}]},"other":{"value":[{"type":1,"value":"count"},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.email.body.closed":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.email.body.closed.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.original.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueKey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"mentioned you"}],"type":8,"value":"strong"},{"type":0,"value":" on a work item"}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.body.heading.redesigned":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.email.body.reopened":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"reopened a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.shared-with":[{"type":0,"value":" Also shared with "}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.created.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.email.body.created.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.body.title.redesigned":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.body.title.redesigned":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-deletion-reminder.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"},{"type":0,"value":" "}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Space archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited-new-user.message-template.email.subject":[{"type":0,"value":"Action requested: "},{"type":1,"value":"userName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"projectName"},{"type":0,"value":", Jira"}],"jira.jira-project-event-user-invited-new-user.message-template.email.subject.redacted":[{"type":0,"value":"Action requested: You\'ve been invited to join your team in Jira"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.common.reply-button":[{"type":0,"value":"Reply"}],"postoffice.jira.issue.common.visibility-level":[{"type":0,"value":"Restricted to "},{"children":[{"type":1,"value":"name"}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"type"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.share-search.shared-with.no-translate":[{"type":0,"value":"sharedWithUser"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.body":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.learn-more":[{"type":0,"value":"Learn more"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.title":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template..project-deletion-reminder.restore-link.multiple-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.restore-link.single-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.trash-link.multiple-project":[{"type":0,"value":" Trash"}],"template.project-deletion-reminder.generic-message.mutiple-projects":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" project"}]},"other":{"value":[{"type":7},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"projectCount"},{"type":0,"value":" will be permanently deleted in 7 days "}],"template.project-deletion-reminder.generic-message.single-project":[{"type":0,"value":"The project will be permanently deleted in 7 days "}],"template.project-deletion-reminder.view-more-projects-message":[{"type":0,"value":"+ "},{"type":1,"value":"remainingProjectCount"},{"type":0,"value":" other projects currently in "}],"template.project-event-user-invited-new.custom-message-heading":[{"type":0,"value":"A note from "},{"type":1,"value":"inviterName"}],"template.project-event-user-invited-new.custom-message-heading-no-inviter":[{"type":0,"value":"A note from the admin"}],"template.project-event-user-invited-new.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"template.project-event-user-invited-new.join-space":[{"type":0,"value":"Join the space"}],"template.project-event-user-invited-new.logo-alt-text":[{"type":0,"value":"Jira logo"}],"template.project-event-user-invited-new.product-description":[{"children":[{"type":0,"value":"What is Jira?"}],"type":8,"value":"strong"},{"type":0,"value":" A software tool for project and work item tracking with your team"}],"template.project-event-user-invited-new.social-proof-text":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":"+ customers use Jira to move work forward"}],"template.project-event-user-invited-new.title-generic":[{"type":0,"value":"You\'ve been invited to join your team in Jira"}],"template.project-event-user-invited-new.title-inviter":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in Jira"}],"template.project-event-user-invited-new.welcome-message":[{"type":1,"value":"waveEmoji"},{"type":0,"value":" G\'day, "},{"type":1,"value":"recipientFirstName"}],"template.project-event-user-invited.invited-custom-message":[{"type":1,"value":"customMessage"}],"template.project-event-user-invited.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"projectName"},{"type":0,"value":" "}],"type":8,"value":"b"}],"template.project.archived.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the space."}],"template.project.deleted.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this space on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This space and its work items, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" archive "}],"type":8,"value":"a"},{"type":0,"value":" forever"}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"The project, including all its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" trash "}],"type":8,"value":"a"},{"type":0,"value":" for 60 days after which it will be permanently deleted."}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "},{"children":[{"type":0,"value":" Go to trash "}],"type":8,"value":"a"},{"type":0,"value":" and try again. If it persists, please contact support."}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" matched work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" matched work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":". "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "},{"children":[{"type":0,"value":" here "}],"type":8,"value":"a"},{"type":0,"value":" "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data. "},{"children":[{"type":0,"value":" View the filter "}],"type":8,"value":"a"},{"type":0,"value":" in Jira"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("kJSL2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2w6LJ").then(()=>parcelRequire('4Zsuy'));

});

parcelRegister("7kPy0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6RmrJ").then(()=>parcelRequire('lVrZS'));

});

parcelRegister("7RRZy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("itxWv").then(()=>parcelRequire('3wYAI'));

});

parcelRegister("51NoZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("27keg").then(()=>parcelRequire('rwnHJ'));

});

parcelRegister("bYRjt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fw7V6").then(()=>parcelRequire('i9jxi'));

});

parcelRegister("dpqxt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a4RKN").then(()=>parcelRequire('h1EZl'));

});

parcelRegister("N63Bs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eXFWt").then(()=>parcelRequire('aODNk'));

});

parcelRegister("5fIxD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("75MCK").then(()=>parcelRequire('jMU2i'));

});

parcelRegister("gbHoL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hIwr2").then(()=>parcelRequire('5MSIM'));

});

parcelRegister("7X1ii", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iWeBb").then(()=>parcelRequire('gpWU0'));

});

parcelRegister("7nyun", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2O1qZ").then(()=>parcelRequire('8OzWn'));

});

parcelRegister("4yL7Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kHnKX").then(()=>parcelRequire('5vzS0'));

});

parcelRegister("bdaiZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gNlSc").then(()=>parcelRequire('cVx2G'));

});

parcelRegister("eM6nk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b9hfp").then(()=>parcelRequire('VWiaO'));

});

parcelRegister("7YchU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("URW0T").then(()=>parcelRequire('7Fd1Q'));

});

parcelRegister("8JNEu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k83kj").then(()=>parcelRequire('eb9nd'));

});

parcelRegister("5h6BA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lrRX2").then(()=>parcelRequire('kFocM'));

});

parcelRegister("bIYtw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dXOww").then(()=>parcelRequire('iV9ic'));

});

parcelRegister("YgyGF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jnglG").then(()=>parcelRequire('8j94t'));

});

parcelRegister("3T5gN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fjLiG").then(()=>parcelRequire('3VcrW'));

});

parcelRegister("diRNc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fimAn").then(()=>parcelRequire('aZ48z'));

});

parcelRegister("6u0pl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cvEEa").then(()=>parcelRequire('18yi9'));

});

parcelRegister("dyiem", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iyhVO").then(()=>parcelRequire('2RJCb'));

});

parcelRegister("3vdDc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iNlJb").then(()=>parcelRequire('f4L1m'));

});

parcelRegister("9Xha4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1EKPP").then(()=>parcelRequire('ehDbX'));

});

parcelRegister("evWZ4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d8UBr").then(()=>parcelRequire('dibEG'));

});

parcelRegister("7yX5f", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8MI0T").then(()=>parcelRequire('69jI6'));

});

parcelRegister("hAHke", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("42qC0").then(()=>parcelRequire('8tYSU'));

});

parcelRegister("2XiSl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5hYqZ").then(()=>parcelRequire('1z5OZ'));

});

parcelRegister("h2nQQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5UdrT").then(()=>parcelRequire('baIRU'));

});

parcelRegister("7OHI6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2vy0F").then(()=>parcelRequire('4wyvN'));

});

parcelRegister("5w7S3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6bNXW").then(()=>parcelRequire('i7NRh'));

});

parcelRegister("lUmLU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7xKrK").then(()=>parcelRequire('hjaLa'));

});

parcelRegister("1GX0I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8gq5t").then(()=>parcelRequire('lEohv'));

});


parcelRegister("dR9dm", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $45e90682c7e1cac5$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Xqe3 = parcelRequire("8Xqe3");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $45e90682c7e1cac5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $45e90682c7e1cac5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("3GAYt")));
        case 'da':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("goHym")));
        case 'de':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("7zLMo")));
        case 'en-GB':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("ffGBQ")));
        case 'en-US':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("k1TIC")));
        case 'en-XA':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("4hppc")));
        case 'en-XB':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("iteyX")));
        case 'en-ZZ':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("7XhQw")));
        case 'en':
            return $45e90682c7e1cac5$var$importHelper(await Promise.resolve((parcelRequire("8Xqe3"))));
        case 'es':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("bt6sX")));
        case 'et':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("pzdiN")));
        case 'fi':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("cpItu")));
        case 'fr':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("2Q9jh")));
        case 'hr':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("jvNor")));
        case 'hu':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("2DCOJ")));
        case 'it':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("6xX3o")));
        case 'ja':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("95YCc")));
        case 'ko':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("ehMwi")));
        case 'nb':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("kFPAY")));
        case 'nl':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("h19om")));
        case 'pl':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("fMVD4")));
        case 'pt-BR':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("kKZh6")));
        case 'ro':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("68fVd")));
        case 'ru':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("eSwqF")));
        case 'sl':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("4q6Dx")));
        case 'sr-RS':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("3StMx")));
        case 'sr-YR':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("i0mDF")));
        case 'sr':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("gPclj")));
        case 'sv':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("ktApi")));
        case 'th':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("46iav")));
        case 'tr':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("cEJgy")));
        case 'uk':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("4ZPLv")));
        case 'vi':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("ip5F2")));
        case 'zh-CN':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("d0CvW")));
        case 'zh-TW':
            return $45e90682c7e1cac5$var$importHelper(await (parcelRequire("3C7tG")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Xqe3));
    }
};

});
parcelRegister("8Xqe3", function(module, exports) {
module.exports = JSON.parse("{\"acrabats.rovo-dev-spotlight.explore-rovo-dev.description\":[{\"type\":0,\"value\":\"Get started on this work item using Rovo Dev to generate code. It's work is only visible to you.\"}],\"acrabats.rovo-dev-spotlight.explore-rovo-dev.heading\":[{\"type\":0,\"value\":\"Start coding with Rovo Dev in Jira\"}],\"acrabats.rovo-dev-spotlight.navigation.back\":[{\"type\":0,\"value\":\"Back\"}],\"acrabats.rovo-dev-spotlight.navigation.next\":[{\"type\":0,\"value\":\"Next\"}],\"acrabats.rovo-dev-spotlight.navigation.progress\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}],\"acrabats.rovo-dev-spotlight.navigation.read-more\":[{\"type\":0,\"value\":\"Read more\"}],\"acrabats.rovo-dev-spotlight.understand-rovo-dev.description\":[{\"type\":0,\"value\":\"Once the agent has finished, you're in control of approving the work and sharing with your team.\"}],\"acrabats.rovo-dev-spotlight.understand-rovo-dev.heading\":[{\"type\":0,\"value\":\"You review and approve\"}],\"devai-acrabats.ai-planner-plan-created.message-template.notification-drawer.message.no-translate\":[{\"type\":1,\"value\":\"actorName\"},{\"type\":0,\"value\":\" updated your page\"}],\"devai-acrabats.blocks.header.alt_text.atlassian\":[{\"type\":0,\"value\":\"Atlassian\"}],\"devai-acrabats.components.email..footer.img.alt\":[{\"type\":0,\"value\":\"Atlassian Logo\"}],\"devai-acrabats.components.email..footer.text\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Cloud\"}],\"devai-acrabats.components.email.footer.note.no-org-name\":[{\"type\":0,\"value\":\"You received this because you're an organization admin\"}],\"devai-acrabats.components.email.footer.note.org-name\":[{\"type\":0,\"value\":\"You received this because you're an organization admin for \"},{\"type\":1,\"value\":\"orgName\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message-template.email.subject\":[{\"type\":0,\"value\":\"Rovo Dev is coming to the terminal\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fifth-paragraph\":[{\"type\":0,\"value\":\"Learn more about how RovoDev CLI capabilities and its data use and controls \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fifth-paragraph.link\":[{\"type\":0,\"value\":\"here\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev CLI brings powerful Rovo Dev capabilities, along with your team's Jira and Confluence\\n\\t\\t\\t\\t\\tknowledge, to your terminal.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fourth-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev users will receive instructions soon for how to install Rovo Dev CLI and use it in your team's workflow.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.heading\":[{\"type\":0,\"value\":\"Rovo Dev CLI has been enabled for your site\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Developers can collaborate with AI to generate and ship code, turn work items into features,\\n\\t\\t\\t\\t\\task questions in natural language, and more. And all without switching contexts.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.third-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev CLI enables users to connect to third-party data sources via \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.third-paragraph.link\":[{\"type\":0,\"value\":\"Model Context Protocol\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Rovo Dev is now ready to use in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-1\":[{\"type\":0,\"value\":\"Natural language insights into repositories, files, and features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-2\":[{\"type\":0,\"value\":\"AI-powered code generation and shipping.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-3\":[{\"type\":0,\"value\":\"Collaboration with AI to turn work items into features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-4\":[{\"type\":0,\"value\":\"Connecting to third-party data sources via Model Context Protocol.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"We've enabled access to Rovo Dev CLI for your site (\"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\") as part of the Rovo Dev Agents beta.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.first-paragraph.link\":[{\"type\":1,\"value\":\"siteName\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.heading\":[{\"type\":0,\"value\":\"Your team can now use Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Once your team \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\", they can access Rovo Dev features like:\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.second-paragraph.link\":[{\"type\":0,\"value\":\"installs the agent in their terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.third-paragraph.link\":[{\"type\":0,\"value\":\"manage access for your site\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.read-more-button\":[{\"type\":0,\"value\":\"Read more about Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.test-message.email.body.third-paragraph\":[{\"type\":0,\"value\":\"If you don't want your team to be able to access Rovo Dev CLI, \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Rovo Dev is now ready to use in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-1\":[{\"type\":0,\"value\":\"Natural language insights into repositories, files, and features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-2\":[{\"type\":0,\"value\":\"AI-powered code generation and implementation.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-3\":[{\"type\":0,\"value\":\"Automated test creation to improve coverage metrics.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-4\":[{\"type\":0,\"value\":\"Dynamic documentation writing reflecting repository features and changes.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"We've enabled access to Rovo Dev CLI as part of the Rovo Dev Agents beta.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.heading\":[{\"type\":0,\"value\":\"You can now use Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.img.alt\":[{\"type\":0,\"value\":\"Rovo Dev CLI Screenshot\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1\":[{\"type\":0,\"value\":\"Install ACLI (or update to the latest version if you already have ACLI installed) using instructions for your OS:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-1\":[{\"type\":0,\"value\":\"macOS\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-2\":[{\"type\":0,\"value\":\"Linux\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-3\":[{\"type\":0,\"value\":\"Windows\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-2\":[{\"type\":0,\"value\":\"Generate an unscoped API token from your  \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-2.link\":[{\"type\":0,\"value\":\"Atlassian profile\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-3\":[{\"type\":0,\"value\":\"In your terminal, run:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-3.code\":[{\"type\":0,\"value\":\"acli rovodev auth login\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-4\":[{\"type\":0,\"value\":\"Run this command to open Rovo Dev in interactive mode:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-4.code\":[{\"type\":0,\"value\":\"acli rovodev run\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Once you \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\", you can access Rovo Dev features like:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.second-paragraph.link\":[{\"type\":0,\"value\":\"install the agent in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.read-more-button\":[{\"type\":0,\"value\":\"Read more about Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.test-message.email.body.sub-header\":[{\"type\":0,\"value\":\"How do I get started?\"}],\"jiraRovoDev.survey.question\":[{\"type\":0,\"value\":\"Rovo Dev in Jira is valuable to my work.\"}],\"jiraRovoDev.survey.score.neutral\":[{\"type\":0,\"value\":\"Neutral\"}],\"jiraRovoDev.survey.score.stronglyAgree\":[{\"type\":0,\"value\":\"Strongly agree\"}],\"jiraRovoDev.survey.score.stronglyDisagree\":[{\"type\":0,\"value\":\"Strongly disagree\"}],\"jiraRovoDev.survey.statement\":[{\"type\":0,\"value\":\"To what extent do you agree or disagree with the statement?\"}]}");

});

parcelRegister("3GAYt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iN1dE").then(()=>parcelRequire('lHRgO'));

});

parcelRegister("goHym", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bhFS9").then(()=>parcelRequire('iUybo'));

});

parcelRegister("7zLMo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dzWnf").then(()=>parcelRequire('clqwV'));

});

parcelRegister("ffGBQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4AP2T").then(()=>parcelRequire('8hdrl'));

});

parcelRegister("k1TIC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jOMqI").then(()=>parcelRequire('lrtAK'));

});

parcelRegister("4hppc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fSo68").then(()=>parcelRequire('blsMT'));

});

parcelRegister("iteyX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hQnDm").then(()=>parcelRequire('7lBzz'));

});

parcelRegister("7XhQw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("69bRK").then(()=>parcelRequire('4KGH8'));

});

parcelRegister("bt6sX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c03dj").then(()=>parcelRequire('27Wd7'));

});

parcelRegister("pzdiN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("elEUM").then(()=>parcelRequire('4yvvs'));

});

parcelRegister("cpItu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j1X6A").then(()=>parcelRequire('hWdrT'));

});

parcelRegister("2Q9jh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eY8Rd").then(()=>parcelRequire('8X5mM'));

});

parcelRegister("jvNor", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9wnfI").then(()=>parcelRequire('EN2mb'));

});

parcelRegister("2DCOJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cwPEA").then(()=>parcelRequire('4lZZR'));

});

parcelRegister("6xX3o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ePvXs").then(()=>parcelRequire('a7NrT'));

});

parcelRegister("95YCc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eewGk").then(()=>parcelRequire('Hhesn'));

});

parcelRegister("ehMwi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hvRS6").then(()=>parcelRequire('iOTFW'));

});

parcelRegister("kFPAY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fpGBL").then(()=>parcelRequire('12k14'));

});

parcelRegister("h19om", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gHZPO").then(()=>parcelRequire('2gNZw'));

});

parcelRegister("fMVD4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("andeQ").then(()=>parcelRequire('8Wgs9'));

});

parcelRegister("kKZh6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bpdia").then(()=>parcelRequire('hNoP4'));

});

parcelRegister("68fVd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3Ori0").then(()=>parcelRequire('41ckM'));

});

parcelRegister("eSwqF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hYdoZ").then(()=>parcelRequire('4PcJC'));

});

parcelRegister("4q6Dx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iGkRn").then(()=>parcelRequire('2hBM9'));

});

parcelRegister("3StMx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lPttt").then(()=>parcelRequire('ifGPX'));

});

parcelRegister("i0mDF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eiKAb").then(()=>parcelRequire('31Kih'));

});

parcelRegister("gPclj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8gCJH").then(()=>parcelRequire('hMdGi'));

});

parcelRegister("ktApi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("35dtj").then(()=>parcelRequire('7MoGw'));

});

parcelRegister("46iav", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("sZeaX").then(()=>parcelRequire('i9YOq'));

});

parcelRegister("cEJgy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("oHiMu").then(()=>parcelRequire('7ubtK'));

});

parcelRegister("4ZPLv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("84asV").then(()=>parcelRequire('aNpP3'));

});

parcelRegister("ip5F2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gjipf").then(()=>parcelRequire('eSxWQ'));

});

parcelRegister("d0CvW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j8kMs").then(()=>parcelRequire('mOHEY'));

});

parcelRegister("3C7tG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("efhGY").then(()=>parcelRequire('dwOYF'));

});


parcelRegister("yk4js", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $50116610fb5a8f38$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4vmLp = parcelRequire("4vmLp");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $50116610fb5a8f38$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $50116610fb5a8f38$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("2qo1G")));
        case 'da':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("g63IT")));
        case 'de':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("ibgq9")));
        case 'en-GB':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("3init")));
        case 'en-US':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("2FD6R")));
        case 'en-XA':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("jWmdy")));
        case 'en-XB':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("2Bzxz")));
        case 'en-ZZ':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("lFf9B")));
        case 'en':
            return $50116610fb5a8f38$var$importHelper(await Promise.resolve((parcelRequire("4vmLp"))));
        case 'es':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("4cFgt")));
        case 'et':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("gDZ2r")));
        case 'fi':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("9zyqv")));
        case 'fr':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("893Dt")));
        case 'hr':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("j4nj9")));
        case 'hu':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("d9Srv")));
        case 'it':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("jDv9R")));
        case 'ja':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("3wpub")));
        case 'ko':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("fQrsO")));
        case 'nb':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("l9Cr4")));
        case 'nl':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("jNKpp")));
        case 'pl':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("fkdKZ")));
        case 'pt-BR':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("a6wpY")));
        case 'ro':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("65iT6")));
        case 'ru':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("asnB9")));
        case 'sl':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("DJ0Cm")));
        case 'sr-RS':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("6izqZ")));
        case 'sr-YR':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("aSCDG")));
        case 'sr':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("4hFQm")));
        case 'sv':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("5Fab3")));
        case 'th':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("iwDeh")));
        case 'tr':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("6p4Ls")));
        case 'uk':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("kNw7y")));
        case 'vi':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("bHlEH")));
        case 'zh-CN':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("1ub20")));
        case 'zh-TW':
            return $50116610fb5a8f38$var$importHelper(await (parcelRequire("bTITh")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4vmLp));
    }
};

});
parcelRegister("4vmLp", function(module, exports) {
module.exports = JSON.parse("{\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.closing\":[{\"type\":0,\"value\":\"Launch your space today to give your team a single, self-service entry point for HR help.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact\":[{\"type\":0,\"value\":\"Please \"},{\"type\":1,\"value\":\"contactUsLink\"},{\"type\":0,\"value\":\" with any questions, we're always happy to help.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact-us-link\":[{\"type\":0,\"value\":\"contact us\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.cta\":[{\"type\":0,\"value\":\"Go to your space\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.greeting\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.heading\":[{\"type\":0,\"value\":\"Bring your HR team together in Jira Service Management\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.intro\":[{\"type\":0,\"value\":\"You recently started an HR service space, but it looks like your team hasn't moved in yet. When you're ready, Jira Service Management can help you centralize requests and track onboarding in one place.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.signoff\":[{\"type\":0,\"value\":\"Cheers,\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-1\":[{\"children\":[{\"type\":0,\"value\":\"Add team members\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" as agents to handle requests\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-2\":[{\"children\":[{\"type\":0,\"value\":\"Set up request types\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" like \\\"New hire onboarding\\\"\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-3\":[{\"children\":[{\"type\":0,\"value\":\"Publish your portal\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" so employees can find help\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.steps-heading\":[{\"type\":0,\"value\":\"Get started in three steps:\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.team-name\":[{\"type\":0,\"value\":\"The Atlassians\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.subject\":[{\"type\":0,\"value\":\"Quick check-in on your HR service space\"}]}");

});

parcelRegister("2qo1G", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("llzLP").then(()=>parcelRequire('66IaD'));

});

parcelRegister("g63IT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("huf90").then(()=>parcelRequire('5KlYk'));

});

parcelRegister("ibgq9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1lnJB").then(()=>parcelRequire('3mp7t'));

});

parcelRegister("3init", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8XGM4").then(()=>parcelRequire('2XTrW'));

});

parcelRegister("2FD6R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e0naS").then(()=>parcelRequire('akz75'));

});

parcelRegister("jWmdy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5UpHX").then(()=>parcelRequire('cvMxv'));

});

parcelRegister("2Bzxz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dDGic").then(()=>parcelRequire('iVMo8'));

});

parcelRegister("lFf9B", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6x5lw").then(()=>parcelRequire('fIJ0M'));

});

parcelRegister("4cFgt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6RjeS").then(()=>parcelRequire('3GGEM'));

});

parcelRegister("gDZ2r", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bnOCp").then(()=>parcelRequire('8ME0O'));

});

parcelRegister("9zyqv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9yvEW").then(()=>parcelRequire('icNN0'));

});

parcelRegister("893Dt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ROcG").then(()=>parcelRequire('c4QIn'));

});

parcelRegister("j4nj9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5cTMk").then(()=>parcelRequire('9MYdP'));

});

parcelRegister("d9Srv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iYmZk").then(()=>parcelRequire('f8tIa'));

});

parcelRegister("jDv9R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("38rv6").then(()=>parcelRequire('cxwYD'));

});

parcelRegister("3wpub", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dXpUT").then(()=>parcelRequire('3SuAO'));

});

parcelRegister("fQrsO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dKmBQ").then(()=>parcelRequire('2zd3n'));

});

parcelRegister("l9Cr4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("apI4Z").then(()=>parcelRequire('80wk0'));

});

parcelRegister("jNKpp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fYH5o").then(()=>parcelRequire('g0uTp'));

});

parcelRegister("fkdKZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2dv9i").then(()=>parcelRequire('fSUhr'));

});

parcelRegister("a6wpY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("blA2E").then(()=>parcelRequire('9EX1W'));

});

parcelRegister("65iT6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("tVEh4").then(()=>parcelRequire('0VnFo'));

});

parcelRegister("asnB9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aQIZC").then(()=>parcelRequire('hbEzT'));

});

parcelRegister("DJ0Cm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("QxJ5X").then(()=>parcelRequire('86BQK'));

});

parcelRegister("6izqZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e3KVB").then(()=>parcelRequire('5lUf2'));

});

parcelRegister("aSCDG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9ttMN").then(()=>parcelRequire('6sDEy'));

});

parcelRegister("4hFQm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9LOF8").then(()=>parcelRequire('2mS4r'));

});

parcelRegister("5Fab3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3tceE").then(()=>parcelRequire('lyaWz'));

});

parcelRegister("iwDeh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iAf4s").then(()=>parcelRequire('4FWwY'));

});

parcelRegister("6p4Ls", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dIcuu").then(()=>parcelRequire('aebb8'));

});

parcelRegister("kNw7y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4fHFF").then(()=>parcelRequire('3mrmo'));

});

parcelRegister("bHlEH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6E5iL").then(()=>parcelRequire('h7nRW'));

});

parcelRegister("1ub20", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1J2lB").then(()=>parcelRequire('3z3vW'));

});

parcelRegister("bTITh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eRYIL").then(()=>parcelRequire('3jmsu'));

});


parcelRegister("fjm92", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $1479a1c5c19c0aee$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5anMR = parcelRequire("5anMR");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1479a1c5c19c0aee$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1479a1c5c19c0aee$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("4gdBR")));
        case 'da':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("dEtSi")));
        case 'de':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("iF8MG")));
        case 'en-GB':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("9d1KE")));
        case 'en-US':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("9S716")));
        case 'en-XA':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("XThrl")));
        case 'en-XB':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("gxnee")));
        case 'en-ZZ':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("iAfqN")));
        case 'en':
            return $1479a1c5c19c0aee$var$importHelper(await Promise.resolve((parcelRequire("5anMR"))));
        case 'es':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("97LXI")));
        case 'et':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("ciDXf")));
        case 'fi':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("7FW9v")));
        case 'fr':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("79bZ6")));
        case 'hr':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("2TbHX")));
        case 'hu':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("QU6jH")));
        case 'it':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("TQcCm")));
        case 'ja':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("bfKpe")));
        case 'ko':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("l5ylz")));
        case 'nb':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("l7Fct")));
        case 'nl':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("cGErb")));
        case 'pl':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("3Vmbl")));
        case 'pt-BR':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("eV80S")));
        case 'ro':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("lmwjS")));
        case 'ru':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("bay2O")));
        case 'sl':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("lFPHi")));
        case 'sr-RS':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("bbGwr")));
        case 'sr-YR':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("5gC11")));
        case 'sr':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("3Zo7A")));
        case 'sv':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("1UCsV")));
        case 'th':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("9wQc8")));
        case 'tr':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("3M1yV")));
        case 'uk':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("iw53T")));
        case 'vi':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("5164o")));
        case 'zh-CN':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("2MnxH")));
        case 'zh-TW':
            return $1479a1c5c19c0aee$var$importHelper(await (parcelRequire("kjFdE")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5anMR));
    }
};

});
parcelRegister("5anMR", function(module, exports) {
module.exports = JSON.parse('{"post-office.jsm-phantom.issue-view.playbook.spotlight-close-button":[{"type":0,"value":"Close"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-first-line":[{"type":0,"value":"Follow step-by-step guidance and run automate actions to resolve work faster."}],"post-office.jsm-phantom.issue-view.playbook.spotlight-heading":[{"type":0,"value":"Resolve work items faster with playbooks"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-learn-more":[{"type":0,"value":"Learn more about playbooks"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-second-line":[{"type":0,"value":"No playbook yet? Share your runbooks with project admin to turn them into actionable playbooks."}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-close-button":[{"type":0,"value":"Close"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-first-line":[{"type":0,"value":"Create reusable playbooks from runbooks, SOPs, and how-tos to give your team step-by-step guidance and automated actions to resolve work items faster, right in context."}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-heading":[{"type":0,"value":"Turn your team\u2019s knowledge into playbooks"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-learn-more":[{"type":0,"value":"Learn more about playbooks"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight.create-playbook":[{"type":0,"value":"Create playbook"}]}');

});

parcelRegister("4gdBR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gAzXJ").then(()=>parcelRequire('4D1x9'));

});

parcelRegister("dEtSi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("78Mpw").then(()=>parcelRequire('jezIP'));

});

parcelRegister("iF8MG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Lrz99").then(()=>parcelRequire('bHEXh'));

});

parcelRegister("9d1KE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4oeDy").then(()=>parcelRequire('gBRKI'));

});

parcelRegister("9S716", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3tow9").then(()=>parcelRequire('jCfX1'));

});

parcelRegister("XThrl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("23P8i").then(()=>parcelRequire('8zoNn'));

});

parcelRegister("gxnee", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("golD4").then(()=>parcelRequire('jCMiX'));

});

parcelRegister("iAfqN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hjVql").then(()=>parcelRequire('2218N'));

});

parcelRegister("97LXI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bDMT7").then(()=>parcelRequire('28JeX'));

});

parcelRegister("ciDXf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cytIG").then(()=>parcelRequire('f8OYO'));

});

parcelRegister("7FW9v", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ci9EK").then(()=>parcelRequire('kjM3H'));

});

parcelRegister("79bZ6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6rTA4").then(()=>parcelRequire('54XRC'));

});

parcelRegister("2TbHX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("isatN").then(()=>parcelRequire('hyojw'));

});

parcelRegister("QU6jH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("17Ask").then(()=>parcelRequire('kyUYI'));

});

parcelRegister("TQcCm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d1AWf").then(()=>parcelRequire('7zNna'));

});

parcelRegister("bfKpe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6CfTa").then(()=>parcelRequire('3pFjm'));

});

parcelRegister("l5ylz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g5ri1").then(()=>parcelRequire('6naAd'));

});

parcelRegister("l7Fct", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jN1jB").then(()=>parcelRequire('hakTw'));

});

parcelRegister("cGErb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("juAen").then(()=>parcelRequire('b06OY'));

});

parcelRegister("3Vmbl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9rljc").then(()=>parcelRequire('5M259'));

});

parcelRegister("eV80S", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4nvtG").then(()=>parcelRequire('aX9WD'));

});

parcelRegister("lmwjS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2nBTE").then(()=>parcelRequire('3PkK9'));

});

parcelRegister("bay2O", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("73YhP").then(()=>parcelRequire('18RF0'));

});

parcelRegister("lFPHi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cTi8E").then(()=>parcelRequire('giMlB'));

});

parcelRegister("bbGwr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lfJjT").then(()=>parcelRequire('hBAqe'));

});

parcelRegister("5gC11", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6nouE").then(()=>parcelRequire('XrTHz'));

});

parcelRegister("3Zo7A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dCLNf").then(()=>parcelRequire('20H5s'));

});

parcelRegister("1UCsV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("KIFgY").then(()=>parcelRequire('a3Z4q'));

});

parcelRegister("9wQc8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("352bq").then(()=>parcelRequire('60uix'));

});

parcelRegister("3M1yV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1XZrW").then(()=>parcelRequire('jJQ49'));

});

parcelRegister("iw53T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cNPWN").then(()=>parcelRequire('iR7Dc'));

});

parcelRegister("5164o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ijeB2").then(()=>parcelRequire('gR9dL'));

});

parcelRegister("2MnxH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8hQwX").then(()=>parcelRequire('aJNgl'));

});

parcelRegister("kjFdE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jvT3b").then(()=>parcelRequire('aIaOO'));

});


parcelRegister("3Tbrz", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $a6fd1841045a219a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fxDUZ = parcelRequire("fxDUZ");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a6fd1841045a219a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a6fd1841045a219a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("3nwMW")));
        case 'da':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("lf5B3")));
        case 'de':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("dMPMB")));
        case 'en-GB':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("j00Fr")));
        case 'en-US':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("4H1BJ")));
        case 'en-XA':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("iz04y")));
        case 'en-XB':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("bZiOU")));
        case 'en-ZZ':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("8zF3y")));
        case 'en':
            return $a6fd1841045a219a$var$importHelper(await Promise.resolve((parcelRequire("fxDUZ"))));
        case 'es':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("egWPp")));
        case 'et':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("1Nsrm")));
        case 'fi':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("hhU60")));
        case 'fr':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("kfvV1")));
        case 'hr':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("1TNgm")));
        case 'hu':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("6Fpr1")));
        case 'it':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("fil8V")));
        case 'ja':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("5qfUY")));
        case 'ko':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("fyRDd")));
        case 'nb':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("c2Zvp")));
        case 'nl':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("hKS0V")));
        case 'pl':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("74pH8")));
        case 'pt-BR':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("iYH6r")));
        case 'ro':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("aldcq")));
        case 'ru':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("1tYz7")));
        case 'sl':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("f2VDB")));
        case 'sr-RS':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("4bH82")));
        case 'sr-YR':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("j5XeF")));
        case 'sr':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("lLCdx")));
        case 'sv':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("3Z5sm")));
        case 'th':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("beNSc")));
        case 'tr':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("gA61g")));
        case 'uk':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("dlNT4")));
        case 'vi':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("Br2lZ")));
        case 'zh-CN':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("5HCD4")));
        case 'zh-TW':
            return $a6fd1841045a219a$var$importHelper(await (parcelRequire("lGjYX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fxDUZ));
    }
};

});
parcelRegister("fxDUZ", function(module, exports) {
module.exports = JSON.parse('{"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"jsm-project-summary-onboarding.changeLayout":[{"type":0,"value":"Change the layout and order of charts"}],"jsm-project-summary-onboarding.closeButton":[{"type":0,"value":"Close"}],"jsm-project-summary-onboarding.description":[{"type":0,"value":"You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."}],"jsm-project-summary-onboarding.editFilters":[{"type":0,"value":"Edit filters"}],"jsm-project-summary-onboarding.heading":[{"type":0,"value":"Edit your space summary"}],"jsm-project-summary-onboarding.hideAddCharts":[{"type":0,"value":"Hide or add charts"}],"jsm-project-summary-onboarding.moreAboutFeature":[{"type":0,"value":"More about space summary"}],"jsm-project-summary-onboarding.okButton":[{"type":0,"value":"Got it"}],"jsm-project-summary-onboarding.whatsNewTitle":[{"type":0,"value":"What\u2019s new?"}]}');

});

parcelRegister("3nwMW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("arfgN").then(()=>parcelRequire('2b3H4'));

});

parcelRegister("lf5B3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2krZ4").then(()=>parcelRequire('2ndX2'));

});

parcelRegister("dMPMB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3U225").then(()=>parcelRequire('8VCwG'));

});

parcelRegister("j00Fr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5CqJV").then(()=>parcelRequire('hCaJQ'));

});

parcelRegister("4H1BJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2RVSZ").then(()=>parcelRequire('eQcWM'));

});

parcelRegister("iz04y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ke3vm").then(()=>parcelRequire('iLD4j'));

});

parcelRegister("bZiOU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eZxX9").then(()=>parcelRequire('8TG0V'));

});

parcelRegister("8zF3y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ssDbr").then(()=>parcelRequire('9tXjb'));

});

parcelRegister("egWPp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fhpLr").then(()=>parcelRequire('8CG5L'));

});

parcelRegister("1Nsrm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b6kjZ").then(()=>parcelRequire('cCbFJ'));

});

parcelRegister("hhU60", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hpKeE").then(()=>parcelRequire('5V887'));

});

parcelRegister("kfvV1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bC3qd").then(()=>parcelRequire('kLMd1'));

});

parcelRegister("1TNgm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8qqS3").then(()=>parcelRequire('ghLDV'));

});

parcelRegister("6Fpr1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9mIWB").then(()=>parcelRequire('l8Ti2'));

});

parcelRegister("fil8V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bLiq3").then(()=>parcelRequire('dOx8n'));

});

parcelRegister("5qfUY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("qpw94").then(()=>parcelRequire('hMNqG'));

});

parcelRegister("fyRDd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4WJds").then(()=>parcelRequire('cznXC'));

});

parcelRegister("c2Zvp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kbVRx").then(()=>parcelRequire('7x8nT'));

});

parcelRegister("hKS0V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9VSOf").then(()=>parcelRequire('kRbqj'));

});

parcelRegister("74pH8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("299fT").then(()=>parcelRequire('1rnZ6'));

});

parcelRegister("iYH6r", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4T32g").then(()=>parcelRequire('9gBSI'));

});

parcelRegister("aldcq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7jSpH").then(()=>parcelRequire('iutjf'));

});

parcelRegister("1tYz7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eTPo8").then(()=>parcelRequire('qQoyR'));

});

parcelRegister("f2VDB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2AD8r").then(()=>parcelRequire('kNAxJ'));

});

parcelRegister("4bH82", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3UGpG").then(()=>parcelRequire('9Of25'));

});

parcelRegister("j5XeF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7v313").then(()=>parcelRequire('eadkp'));

});

parcelRegister("lLCdx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aYxIu").then(()=>parcelRequire('608Xa'));

});

parcelRegister("3Z5sm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("80okZ").then(()=>parcelRequire('cfgl9'));

});

parcelRegister("beNSc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8JwPq").then(()=>parcelRequire('8rBdx'));

});

parcelRegister("gA61g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dDSZr").then(()=>parcelRequire('iheI3'));

});

parcelRegister("dlNT4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cJpLg").then(()=>parcelRequire('kwnTH'));

});

parcelRegister("Br2lZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j5Xcr").then(()=>parcelRequire('l2x2S'));

});

parcelRegister("5HCD4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8pWSg").then(()=>parcelRequire('L3nn7'));

});

parcelRegister("lGjYX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3WYtL").then(()=>parcelRequire('aeJyd'));

});


parcelRegister("fVSH4", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $f29b64b3afe19574$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aJrN5 = parcelRequire("aJrN5");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f29b64b3afe19574$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $f29b64b3afe19574$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("8EUX4")));
        case 'da':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("cj7iU")));
        case 'de':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("aE4bt")));
        case 'en-GB':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("9vlwC")));
        case 'en-US':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("7DlFb")));
        case 'en-XA':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("1oEng")));
        case 'en-XB':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("6cB2m")));
        case 'en-ZZ':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("9MtY2")));
        case 'en':
            return $f29b64b3afe19574$var$importHelper(await Promise.resolve((parcelRequire("aJrN5"))));
        case 'es':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("iI75n")));
        case 'et':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("64N7J")));
        case 'fi':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("bWISh")));
        case 'fr':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("kDroI")));
        case 'hr':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("2h0Gq")));
        case 'hu':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("eKWR4")));
        case 'it':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("3Owsk")));
        case 'ja':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("2Di5s")));
        case 'ko':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("bx2cN")));
        case 'nb':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("5kV7T")));
        case 'nl':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("baRtE")));
        case 'pl':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("ibLX2")));
        case 'pt-BR':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("kA0Id")));
        case 'ro':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("8iE9z")));
        case 'ru':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("l2J9f")));
        case 'sl':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("f2F3a")));
        case 'sr-RS':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("lFIhC")));
        case 'sr-YR':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("dYEaf")));
        case 'sr':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("61AbU")));
        case 'sv':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("fQKEn")));
        case 'th':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("9PPzy")));
        case 'tr':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("aXWrk")));
        case 'uk':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("8B19H")));
        case 'vi':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("8FOBz")));
        case 'zh-CN':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("jOxfD")));
        case 'zh-TW':
            return $f29b64b3afe19574$var$importHelper(await (parcelRequire("iQkZh")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aJrN5));
    }
};

});
parcelRegister("aJrN5", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("8EUX4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a7a1E").then(()=>parcelRequire('l54bq'));

});

parcelRegister("cj7iU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("71wVG").then(()=>parcelRequire('fOkQj'));

});

parcelRegister("aE4bt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lEECo").then(()=>parcelRequire('54EGl'));

});

parcelRegister("9vlwC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i06cL").then(()=>parcelRequire('enffH'));

});

parcelRegister("7DlFb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3NZG9").then(()=>parcelRequire('7kckd'));

});

parcelRegister("1oEng", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eDZAe").then(()=>parcelRequire('eaKsT'));

});

parcelRegister("6cB2m", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Q1qR").then(()=>parcelRequire('9nfFd'));

});

parcelRegister("9MtY2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fuxfS").then(()=>parcelRequire('baJ6C'));

});

parcelRegister("iI75n", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hTnb5").then(()=>parcelRequire('3T1b2'));

});

parcelRegister("64N7J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3a1O5").then(()=>parcelRequire('6emnQ'));

});

parcelRegister("bWISh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3fpVG").then(()=>parcelRequire('hvsiO'));

});

parcelRegister("kDroI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c53aH").then(()=>parcelRequire('aqO6f'));

});

parcelRegister("2h0Gq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("70O6Q").then(()=>parcelRequire('4j8Hv'));

});

parcelRegister("eKWR4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ogfH").then(()=>parcelRequire('keFZt'));

});

parcelRegister("3Owsk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jE6kw").then(()=>parcelRequire('bIB79'));

});

parcelRegister("2Di5s", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2cgWY").then(()=>parcelRequire('hfB8M'));

});

parcelRegister("bx2cN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4pDyO").then(()=>parcelRequire('byWwM'));

});

parcelRegister("5kV7T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9ZsMB").then(()=>parcelRequire('eCoZM'));

});

parcelRegister("baRtE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5CZ7F").then(()=>parcelRequire('jFTYy'));

});

parcelRegister("ibLX2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aRK3L").then(()=>parcelRequire('3crbB'));

});

parcelRegister("kA0Id", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2wGW6").then(()=>parcelRequire('jxGOF'));

});

parcelRegister("8iE9z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fSqWu").then(()=>parcelRequire('bmf88'));

});

parcelRegister("l2J9f", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6p8xE").then(()=>parcelRequire('8YiZx'));

});

parcelRegister("f2F3a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lWlUH").then(()=>parcelRequire('6AYFe'));

});

parcelRegister("lFIhC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9ZIKz").then(()=>parcelRequire('7s2Pr'));

});

parcelRegister("dYEaf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hS8qp").then(()=>parcelRequire('gY4Ih'));

});

parcelRegister("61AbU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6e5Pa").then(()=>parcelRequire('ko8dM'));

});

parcelRegister("fQKEn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("125ZE").then(()=>parcelRequire('kzBxX'));

});

parcelRegister("9PPzy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g6kv3").then(()=>parcelRequire('8HvJD'));

});

parcelRegister("aXWrk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hGcpL").then(()=>parcelRequire('bvz2K'));

});

parcelRegister("8B19H", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6liHv").then(()=>parcelRequire('9sUAI'));

});

parcelRegister("8FOBz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hhwIF").then(()=>parcelRequire('lnMVr'));

});

parcelRegister("jOxfD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kLAeu").then(()=>parcelRequire('gMUjM'));

});

parcelRegister("iQkZh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j6442").then(()=>parcelRequire('2RnF6'));

});


parcelRegister("3J6RP", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $a25871dbaacb8169$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8TJg5 = parcelRequire("8TJg5");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a25871dbaacb8169$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a25871dbaacb8169$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("8KVzb")));
        case 'da':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("81cOL")));
        case 'de':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("k2PfG")));
        case 'en-GB':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("btOvV")));
        case 'en-US':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("3BfeH")));
        case 'en-XA':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("lLtRD")));
        case 'en-XB':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("71kTn")));
        case 'en-ZZ':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("jYCQO")));
        case 'en':
            return $a25871dbaacb8169$var$importHelper(await Promise.resolve((parcelRequire("8TJg5"))));
        case 'es':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("icpTh")));
        case 'et':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("iFztF")));
        case 'fi':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("9PMGe")));
        case 'fr':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("f3D2Y")));
        case 'hr':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("gyDJ1")));
        case 'hu':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("9vFBn")));
        case 'it':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("ERbzZ")));
        case 'ja':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("cMtVn")));
        case 'ko':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("3TyD9")));
        case 'nb':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("3o8QT")));
        case 'nl':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("hFcBC")));
        case 'pl':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("eajWd")));
        case 'pt-BR':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("f9YZw")));
        case 'ro':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("3QcPt")));
        case 'ru':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("fblpw")));
        case 'sl':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("46pvZ")));
        case 'sr-RS':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("cZvTB")));
        case 'sr-YR':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("8BDzQ")));
        case 'sr':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("k04Dt")));
        case 'sv':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("7KaF8")));
        case 'th':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("49Qqh")));
        case 'tr':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("1yPqF")));
        case 'uk':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("dVvwl")));
        case 'vi':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("jVAXM")));
        case 'zh-CN':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("6eGt1")));
        case 'zh-TW':
            return $a25871dbaacb8169$var$importHelper(await (parcelRequire("14TDi")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8TJg5));
    }
};

});
parcelRegister("8TJg5", function(module, exports) {
module.exports = JSON.parse('{"mercury.mercury-default-mentioned-in-comment.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"article"},{"type":0,"value":" "},{"type":1,"value":"typeName"}],"mercury.mercury-default-mentioned-in-status-update.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" mentioned you in "},{"type":1,"value":"article"},{"type":0,"value":" "},{"type":1,"value":"typeName"},{"type":0,"value":" update"}],"mercury.mercury-default-owner-updated.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" changed the owner of "},{"type":1,"value":"article"},{"type":0,"value":" "},{"type":1,"value":"typeName"}],"mercury.mercury-default-watcher-added.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" added you as a follower of "},{"type":1,"value":"article"},{"type":0,"value":" "},{"type":1,"value":"typeName"}],"mercury.mercury-groups-configure-permissions.message-template.email.configurePermissions":[{"type":0,"value":"Manage permissions"}],"mercury.mercury-groups-configure-permissions.message-template.email.footerText":[{"type":0,"value":"You received this email because you\u2019re a Focus app admin for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"mercury.mercury-groups-configure-permissions.message-template.email.footerTextRedacted":[{"type":0,"value":"You received this email because you\u2019re a Focus app admin for your organization."}],"mercury.mercury-groups-configure-permissions.message-template.email.heading":[{"type":0,"value":"Review permissions for Focus user groups"}],"mercury.mercury-groups-configure-permissions.message-template.email.introduction":[{"type":0,"value":"Some user groups in your organization require your attention. This happens when:"}],"mercury.mercury-groups-configure-permissions.message-template.email.introductionItem1":[{"type":0,"value":"1. A new group has been added to Focus, or"}],"mercury.mercury-groups-configure-permissions.message-template.email.introductionItem2":[{"type":0,"value":"2. An existing group\'s role for the Focus app has changed in Atlassian Administration."}],"mercury.mercury-groups-configure-permissions.message-template.email.learnMore":[{"type":0,"value":"Learn more about group permissions"}],"mercury.mercury-groups-configure-permissions.message-template.email.subject.no-translate":[{"type":0,"value":"Action needed: review permissions in the Focus app"}],"mercury.mercury-groups-configure-permissions.message-template.email.whatToDoNext":[{"type":0,"value":"Please review and enable permissions for these groups so impacted users can start using Focus."}],"mercury.mercury-monthly-digest.email.arrow-icon.alt":[{"type":0,"value":"arrow-icon"}],"mercury.mercury-monthly-digest.email.arrow-right-icon.alt":[{"type":0,"value":"arrow-right-icon"}],"mercury.mercury-monthly-digest.email.calendar-icon.alt":[{"type":0,"value":"calendar-icon"}],"mercury.mercury-monthly-digest.email.catch.up.link":[{"type":0,"value":"Jump into Atlassian Focus"}],"mercury.mercury-monthly-digest.email.catch.up.text":[{"type":0,"value":"Want to catch up on previous updates? "},{"type":1,"value":"link"}],"mercury.mercury-monthly-digest.email.date-changed":[{"type":0,"value":"Date Changed"}],"mercury.mercury-monthly-digest.email.focus-area-icon.alt":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-monthly-digest.email.footer.atlassian-logo.alt":[{"type":0,"value":"Atlassian footer"}],"mercury.mercury-monthly-digest.email.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Focus"}],"mercury.mercury-monthly-digest.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"mercury.mercury-monthly-digest.email.for":[{"type":0,"value":"for"}],"mercury.mercury-monthly-digest.email.header.logoAltText":[{"type":0,"value":"Focus Logo"}],"mercury.mercury-monthly-digest.email.no-target-date.alt":[{"type":0,"value":"No target date set"}],"mercury.mercury-monthly-digest.email.status-changed":[{"type":0,"value":"Status changed"}],"mercury.mercury-monthly-digest.email.total-following.sub-header":[{"type":0,"value":"You\'re following "},{"type":1,"value":"total"},{"type":0,"value":" active focus areas, here\'s the breakdown."}],"mercury.mercury-monthly-digest.email.view-update":[{"type":0,"value":"View Update"}],"mercury.mercury-monthly-digest.message-template.email.subject.no-translate":[{"type":1,"value":"name"},{"type":0,"value":", here are your monthly focus area updates"}],"mercury.mercury-re-engage-empty-focus-area.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.body.multiple.no-translate":[{"type":0,"value":"Your focus areas are off to a great start, but they\'re missing a few key pieces to unlock their full value. Complete setup in just a few minutes:"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.body.single.no-translate":[{"type":0,"value":"Your focus area is off to a great start, but it\'s missing a few key pieces to unlock its full value. Complete setup in just a few minutes:"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.cta.multiple.no-translate":[{"type":0,"value":"View Your Focus Areas"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.cta.single.no-translate":[{"type":0,"value":"View Focus Area"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.add-context.description.no-translate":[{"type":0,"value":"Use the About section to describe what success looks like and why "},{"type":1,"value":"focusAreaName"},{"type":0,"value":" matters to your team."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.add-context.title.no-translate":[{"type":0,"value":"Add more context"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.bring-in-team.description.no-translate":[{"type":0,"value":"Invite teammates as followers so they\'re automatically notified of important updates and milestones."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.bring-in-team.title.no-translate":[{"type":0,"value":"Bring in your team"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.connect-work-goals.description.no-translate":[{"type":0,"value":"Link your Goals and work from Jira Align, Jira Software, and Atlassian Projects to get strategic insights on execution."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.connect-work-goals.title.no-translate":[{"type":0,"value":"Connect work & goals"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.focus-area-icon.alt.no-translate":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.atlassian-logo-alt.no-translate":[{"type":0,"value":"Atlassian"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.sent-by.no-translate":[{"type":0,"value":"This email was sent to you by Atlassian Focus"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.unsubscribe.no-translate":[{"type":0,"value":"unsubscribe"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.greeting.no-translate":[{"type":0,"value":"\uD83D\uDC4B Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.more-link.no-translate":[{"type":0,"value":"+ "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.pre-header.no-translate":[{"type":0,"value":"Connect work, add context, and bring your team in."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.body.no-translate":[{"type":0,"value":"Complete setup to help your team stay aligned on strategy."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.button.no-translate":[{"type":0,"value":"Go to Focus"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.heading.no-translate":[{"type":0,"value":"Ready to jump back into Focus?"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.multiple.no-translate":[{"type":1,"value":"focusAreaName"},{"type":0,"value":" and others are empty \u2014 let\'s get started"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.redacted.multiple.no-translate":[{"type":0,"value":"Your focus areas are empty \u2014 let\'s get started"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.redacted.single.no-translate":[{"type":0,"value":"Your focus area is empty \u2014 let\'s get started"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.single.no-translate":[{"type":1,"value":"focusAreaName"},{"type":0,"value":" is empty \u2014 let\'s get started"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.three-ways-heading.multiple.no-translate":[{"type":0,"value":"3 ways to bring your focus areas to life:"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.three-ways-heading.no-translate":[{"type":0,"value":"3 ways to bring your focus area to life:"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.title.multiple.no-translate":[{"type":0,"value":"Let\'s get your focus areas set up for success"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.title.single.no-translate":[{"type":0,"value":"Let\'s get your focus area set up for success"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.view-focus-area-button.no-translate":[{"type":0,"value":"View Focus Area"}],"mercury.mercury-re-engage-pending-status-update.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.body.multiple.no-translate":[{"type":0,"value":"It\'s been a while since your focus areas were updated. Sharing regular updates keeps everyone aligned and helps your team understand progress."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.body.single.no-translate":[{"type":0,"value":"It\'s been a while since your focus area was updated. Sharing regular updates keeps everyone aligned and helps your team understand progress."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature-highlights.heading.no-translate":[{"type":0,"value":"Now it\'s even easier to write updates"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature-icon.alt.no-translate":[{"type":0,"value":"Feature icon"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.ai-summary.description.no-translate":[{"type":0,"value":"Need help drafting an update? Use Rovo to **summarize** focus areas and quickly surface key risks, highlights, challenges, and more."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.ai-summary.title.no-translate":[{"type":0,"value":"AI Summary"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.inline-looms.description.no-translate":[{"type":0,"value":"Record a **Loom** directly in the update composer to walk teammates through key details and add a personal touch."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.inline-looms.title.no-translate":[{"type":0,"value":"In-line Looms"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.update-notifications.description.no-translate":[{"type":0,"value":"Set up **automations** to send a notification via Slack, Microsoft Teams, or email whenever you post an update."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.update-notifications.title.no-translate":[{"type":0,"value":"Update Notifications"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.focus-area-icon.alt.no-translate":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.focus-area-illustration.alt.no-translate":[{"type":0,"value":"Focus area update workflow illustration"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.atlassian-logo-alt.no-translate":[{"type":0,"value":"Atlassian"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.sent-by.no-translate":[{"type":0,"value":"This email was sent to you by Atlassian Focus"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.unsubscribe.no-translate":[{"type":0,"value":"unsubscribe"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.greeting.no-translate":[{"type":0,"value":"\uD83D\uDC4B Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"mercury.mercury-re-engage-pending-status-update.message-template.email.last-update-text.no-translate":[{"type":0,"value":"Last updated "},{"type":1,"value":"relativeDate"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.more-link.no-translate":[{"type":0,"value":"+ "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.post-update-button.no-translate":[{"type":0,"value":"Post Update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.pre-header.no-translate":[{"type":0,"value":"Keep your team aligned with your latest progress."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.body.no-translate":[{"type":0,"value":"Update your team and keep momentum going"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.button.no-translate":[{"type":0,"value":"Go to Focus"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.heading.no-translate":[{"type":0,"value":"Ready to jump back into Focus?"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.subject.multiple.no-translate":[{"type":1,"value":"focusAreaName"},{"type":0,"value":" and others are waiting for an update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.subject.redacted.multiple.no-translate":[{"type":0,"value":"Your focus areas are waiting for an update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.subject.redacted.single.no-translate":[{"type":0,"value":"Your focus area is waiting for an update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.subject.single.no-translate":[{"type":1,"value":"focusAreaName"},{"type":0,"value":" is waiting for an update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.title.multiple.no-translate":[{"type":0,"value":"Share what\'s new with your focus areas"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.title.single.no-translate":[{"type":0,"value":"Share what\'s new with your focus area"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.custom-fields.description.no-translate":[{"type":0,"value":"Create custom fields (text, number, and select) for Focus areas to capture the data that matters most."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.custom-fields.title.no-translate":[{"type":0,"value":"Custom Fields"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.focus-area-permissions.description.no-translate":[{"type":0,"value":"Control who can edit each Focus area to maintain clear ownership and precise access."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.focus-area-permissions.title.no-translate":[{"type":0,"value":"Focus Area Permissions"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.work-linking-automations.description.no-translate":[{"type":0,"value":"Automatically keep Jira work linked to the right Focus area based on custom field values in work items."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.work-linking-automations.title.no-translate":[{"type":0,"value":"Work Linking Automations"}],"mercury.mercury-re-engage-whats-new.feature-highlights.heading.no-translate":[{"type":0,"value":"Feature highlights"}],"mercury.mercury-re-engage-whats-new.feature-highlights.icon.alt.no-translate":[{"type":0,"value":"Feature icon"}],"mercury.mercury-re-engage-whats-new.feature-highlights.learn-more":[{"type":0,"value":"Learn more"}],"mercury.mercury-re-engage-whats-new.feature-highlights.subheading.no-translate":[{"type":0,"value":"See what\'s new and improved in Focus."}],"mercury.mercury-re-engage-whats-new.focus-area-summary.heading.no-translate":[{"type":0,"value":"Your team has created "},{"type":1,"value":"noOfFocusAreas"},{"type":0,"value":" new focus areas \u2014 follow to get notified of progress."}],"mercury.mercury-re-engage-whats-new.focus-area-summary.more-link.no-translate":[{"type":0,"value":"+ "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"mercury.mercury-re-engage-whats-new.focus-area-summary.owned-heading.no-translate":[{"type":0,"value":"Focus areas you own"}],"mercury.mercury-re-engage-whats-new.focus-area-summary.recently-created-heading.no-translate":[{"type":0,"value":"Focus areas your team has created"}],"mercury.mercury-re-engage-whats-new.focus-area-summary.view-all.no-translate":[{"type":0,"value":"View all Focus Areas"}],"mercury.mercury-re-engage-whats-new.focus-area-summary.watched-heading.no-translate":[{"type":0,"value":"Focus areas you follow"}],"mercury.mercury-re-engage-whats-new.focus-area.created-by.no-translate":[{"type":1,"value":"relativeDate"},{"type":0,"value":" \xb7 created by "},{"type":1,"value":"userName"}],"mercury.mercury-re-engage-whats-new.focus-area.created-date.no-translate":[{"type":1,"value":"relativeDate"}],"mercury.mercury-re-engage-whats-new.focus-area.created.days-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" day ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" days ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.hours-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" hour ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" hours ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.minutes-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" minute ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" minutes ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.months-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" month ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" months ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.seconds-ago.no-translate":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"just now"}]},"=1":{"value":[{"type":7},{"type":0,"value":" second ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" seconds ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.weeks-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" week ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" weeks ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.icon.alt-text":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-re-engage-whats-new.focus-area.status-date.no-translate":[{"type":1,"value":"status"},{"type":0,"value":" \u2022 "},{"type":1,"value":"date"}],"mercury.mercury-re-engage-whats-new.focus-area.status.at-risk.no-translate":[{"type":0,"value":"At Risk"}],"mercury.mercury-re-engage-whats-new.focus-area.status.completed.no-translate":[{"type":0,"value":"Completed"}],"mercury.mercury-re-engage-whats-new.focus-area.status.off-track.no-translate":[{"type":0,"value":"Off Track"}],"mercury.mercury-re-engage-whats-new.focus-area.status.on-track.no-translate":[{"type":0,"value":"On Track"}],"mercury.mercury-re-engage-whats-new.focus-area.status.paused.no-translate":[{"type":0,"value":"Paused"}],"mercury.mercury-re-engage-whats-new.focus-area.status.pending.no-translate":[{"type":0,"value":"Pending"}],"mercury.mercury-re-engage-whats-new.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"mercury.mercury-re-engage-whats-new.follow-button.no-translate":[{"type":0,"value":"Follow"}],"mercury.mercury-re-engage-whats-new.innovation-spotlight.cta-text.no-translate":[{"type":0,"value":"Read the Blog"}],"mercury.mercury-re-engage-whats-new.innovation-spotlight.description.no-translate":[{"type":0,"value":"Want to learn more? Check out everything that\'s shipped in Strategy Collection since Team \'25 Europe."}],"mercury.mercury-re-engage-whats-new.innovation-spotlight.heading.no-translate":[{"type":0,"value":"See the full Innovation Spotlight"}],"mercury.mercury-re-engage-whats-new.message-template.email.banner.alt.no-translate":[{"type":0,"value":"Strategy Collection"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.atlassian-logo-alt.no-translate":[{"type":0,"value":"Atlassian"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.sent-by.no-translate":[{"type":0,"value":"This email was sent to you by Atlassian Focus"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"mercury.mercury-re-engage-whats-new.message-template.email.header.greeting.no-translate":[{"type":0,"value":"\uD83D\uDC4B Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"mercury.mercury-re-engage-whats-new.message-template.email.header.no-translate":[{"type":0,"value":"Welcome to your Focus snapshot"}],"mercury.mercury-re-engage-whats-new.message-template.email.pre-header.no-translate":[{"type":0,"value":"Catch up on your Focus areas and explore what\'s new."}],"mercury.mercury-re-engage-whats-new.message-template.email.subject.no-translate":[{"type":0,"value":"Your Focus Snapshot"}],"mercury.mercury-re-engage-whats-new.test-message.email.header.sub-text.no-translate":[{"type":0,"value":"Your bi-monthly update on the Focus areas you care about \u2014 plus what\'s new."}],"mercury.mercury-re-engage-whats-new.view-focus-area-button.no-translate":[{"type":0,"value":"View Focus Area"}],"mercury.mercury-risk-assigned-organization.notification-drawer.message.title.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" assigned "},{"type":1,"value":"organizationName"},{"type":0,"value":" to a risk"}],"mercury.mercury-risk-assigned-organization.notification-drawer.path.status.no-translate":[{"type":0,"value":"Risk \u2022 "},{"type":1,"value":"status"}],"mercury.mercury-risk-assigned-owner.notification-drawer.message.title.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" made you the owner of a risk"}],"mercury.mercury-risk-assigned-owner.notification-drawer.path.status.no-translate":[{"type":0,"value":"Risk \u2022 "},{"type":1,"value":"status"}],"mercury.mercury-risk-assigned-submitter.notification-drawer.message.title.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" made you the submitter of a risk"}],"mercury.mercury-risk-assigned-submitter.notification-drawer.path.status.no-translate":[{"type":0,"value":"Risk \u2022 "},{"type":1,"value":"status"}],"mercury.mercury-risk-ownership-updated.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated your page"}],"mercury.mercury-risk-updated-date.notification-drawer.message.title.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated the target date"}],"mercury.mercury-risk-updated-date.notification-drawer.path.status.no-translate":[{"type":0,"value":"Risk \u2022 "},{"type":1,"value":"status"}]}');

});

parcelRegister("8KVzb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ikmmY").then(()=>parcelRequire('6koAL'));

});

parcelRegister("81cOL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9w7aV").then(()=>parcelRequire('1w62x'));

});

parcelRegister("k2PfG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8z7ux").then(()=>parcelRequire('7g7D8'));

});

parcelRegister("btOvV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("59YPM").then(()=>parcelRequire('aQVre'));

});

parcelRegister("3BfeH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5h3F0").then(()=>parcelRequire('j3E2z'));

});

parcelRegister("lLtRD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c660P").then(()=>parcelRequire('eSADZ'));

});

parcelRegister("71kTn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5ySkR").then(()=>parcelRequire('ceDbk'));

});

parcelRegister("jYCQO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cj2pv").then(()=>parcelRequire('5FyN4'));

});

parcelRegister("icpTh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bp3ll").then(()=>parcelRequire('coM2C'));

});

parcelRegister("iFztF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gk7Gf").then(()=>parcelRequire('bgPCj'));

});

parcelRegister("9PMGe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k88Bs").then(()=>parcelRequire('jLx3h'));

});

parcelRegister("f3D2Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1XGw8").then(()=>parcelRequire('9wvCn'));

});

parcelRegister("gyDJ1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2MJ1b").then(()=>parcelRequire('iXD27'));

});

parcelRegister("9vFBn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dU1d9").then(()=>parcelRequire('cmb4j'));

});

parcelRegister("ERbzZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("12UkO").then(()=>parcelRequire('dCMNg'));

});

parcelRegister("cMtVn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2WBrG").then(()=>parcelRequire('caFUN'));

});

parcelRegister("3TyD9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fbTZG").then(()=>parcelRequire('1LIvd'));

});

parcelRegister("3o8QT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bB4F8").then(()=>parcelRequire('57YXi'));

});

parcelRegister("hFcBC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j6I3o").then(()=>parcelRequire('3RjEx'));

});

parcelRegister("eajWd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7OM3l").then(()=>parcelRequire('9hFc7'));

});

parcelRegister("f9YZw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4XK1y").then(()=>parcelRequire('k3Jq1'));

});

parcelRegister("3QcPt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ivOUc").then(()=>parcelRequire('i9ybF'));

});

parcelRegister("fblpw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kGsUj").then(()=>parcelRequire('1mAxk'));

});

parcelRegister("46pvZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cCWnA").then(()=>parcelRequire('lirde'));

});

parcelRegister("cZvTB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("80DcS").then(()=>parcelRequire('jNvPP'));

});

parcelRegister("8BDzQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4VDzA").then(()=>parcelRequire('gabNi'));

});

parcelRegister("k04Dt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4Yzvn").then(()=>parcelRequire('c3Oyn'));

});

parcelRegister("7KaF8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b18un").then(()=>parcelRequire('ko2I3'));

});

parcelRegister("49Qqh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4aI6o").then(()=>parcelRequire('koW0S'));

});

parcelRegister("1yPqF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f0h4R").then(()=>parcelRequire('cqcfc'));

});

parcelRegister("dVvwl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fplG5").then(()=>parcelRequire('cvO1I'));

});

parcelRegister("jVAXM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3BJae").then(()=>parcelRequire('bye4f'));

});

parcelRegister("6eGt1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bDnhK").then(()=>parcelRequire('eUSeh'));

});

parcelRegister("14TDi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("48z34").then(()=>parcelRequire('8lCrz'));

});


parcelRegister("28RSh", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $17e4420a5920451f$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $htRX1 = parcelRequire("htRX1");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $17e4420a5920451f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $17e4420a5920451f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("5IfP4")));
        case 'da':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("2bDYn")));
        case 'de':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("ccKtf")));
        case 'en-GB':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("1Qdxx")));
        case 'en-US':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("czxc6")));
        case 'en-XA':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("gchjx")));
        case 'en-XB':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("9aDTk")));
        case 'en-ZZ':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("1SZ66")));
        case 'en':
            return $17e4420a5920451f$var$importHelper(await Promise.resolve((parcelRequire("htRX1"))));
        case 'es':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("skCfR")));
        case 'et':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("eyU1h")));
        case 'fi':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("3RBQv")));
        case 'fr':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("d4nQZ")));
        case 'hr':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("jBzHD")));
        case 'hu':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("5tgCQ")));
        case 'it':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("a3aSq")));
        case 'ja':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("c7KC8")));
        case 'ko':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("hgchV")));
        case 'nb':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("ej0qb")));
        case 'nl':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("5OyXa")));
        case 'pl':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("fMaQF")));
        case 'pt-BR':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("eZTey")));
        case 'ro':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("cIRux")));
        case 'ru':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("bLnDH")));
        case 'sl':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("jwRaP")));
        case 'sr-RS':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("77Zfi")));
        case 'sr-YR':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("hVXB2")));
        case 'sr':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("4P677")));
        case 'sv':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("l6w7j")));
        case 'th':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("kFYSX")));
        case 'tr':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("laOQj")));
        case 'uk':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("1dNVK")));
        case 'vi':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("dJEfv")));
        case 'zh-CN':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("1T26O")));
        case 'zh-TW':
            return $17e4420a5920451f$var$importHelper(await (parcelRequire("hT3tV")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($htRX1));
    }
};

});
parcelRegister("htRX1", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.message-template.notification-drawer.message.no-translate\":[{\"type\":1,\"value\":\"actorName\"},{\"type\":0,\"value\":\" updated your page\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.browser-push-body.no-translate\":[{\"type\":0,\"value\":\"You are a lovely\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("5IfP4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h6XgS").then(()=>parcelRequire('5Q5HM'));

});

parcelRegister("2bDYn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gujQ6").then(()=>parcelRequire('h1mVt'));

});

parcelRegister("ccKtf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jlXNu").then(()=>parcelRequire('aV4R1'));

});

parcelRegister("1Qdxx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1pEl7").then(()=>parcelRequire('fycIu'));

});

parcelRegister("czxc6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lhh4x").then(()=>parcelRequire('2WXTd'));

});

parcelRegister("gchjx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jy7Oa").then(()=>parcelRequire('fETqn'));

});

parcelRegister("9aDTk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g5F2A").then(()=>parcelRequire('4qWJN'));

});

parcelRegister("1SZ66", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5WcBh").then(()=>parcelRequire('cD3ZL'));

});

parcelRegister("skCfR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8QWfY").then(()=>parcelRequire('fq1XW'));

});

parcelRegister("eyU1h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cJHpB").then(()=>parcelRequire('iEDRU'));

});

parcelRegister("3RBQv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1zJkZ").then(()=>parcelRequire('cnd6S'));

});

parcelRegister("d4nQZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4kvNL").then(()=>parcelRequire('cY2bv'));

});

parcelRegister("jBzHD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cd9aO").then(()=>parcelRequire('fNu8R'));

});

parcelRegister("5tgCQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Keq4M").then(()=>parcelRequire('ctiUk'));

});

parcelRegister("a3aSq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("71ouw").then(()=>parcelRequire('9o62X'));

});

parcelRegister("c7KC8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hU1ZO").then(()=>parcelRequire('gzSLp'));

});

parcelRegister("hgchV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dtJDh").then(()=>parcelRequire('1Emlb'));

});

parcelRegister("ej0qb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3rJEo").then(()=>parcelRequire('jasbJ'));

});

parcelRegister("5OyXa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("39rhw").then(()=>parcelRequire('89vbr'));

});

parcelRegister("fMaQF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2SDAo").then(()=>parcelRequire('cawzX'));

});

parcelRegister("eZTey", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dzwhC").then(()=>parcelRequire('5qbZB'));

});

parcelRegister("cIRux", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eO3ry").then(()=>parcelRequire('fBYqv'));

});

parcelRegister("bLnDH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jdKdH").then(()=>parcelRequire('5NzFX'));

});

parcelRegister("jwRaP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8PXPI").then(()=>parcelRequire('hwd8N'));

});

parcelRegister("77Zfi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7BDKs").then(()=>parcelRequire('jsqB8'));

});

parcelRegister("hVXB2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dW6ZN").then(()=>parcelRequire('4ncI1'));

});

parcelRegister("4P677", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dcUqE").then(()=>parcelRequire('4hcT2'));

});

parcelRegister("l6w7j", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("42B5l").then(()=>parcelRequire('fpjxl'));

});

parcelRegister("kFYSX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9AqmY").then(()=>parcelRequire('jyUKF'));

});

parcelRegister("laOQj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g7dyG").then(()=>parcelRequire('6SIJT'));

});

parcelRegister("1dNVK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2NuI2").then(()=>parcelRequire('6aVE4'));

});

parcelRegister("dJEfv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2GQcV").then(()=>parcelRequire('2qjOf'));

});

parcelRegister("1T26O", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("luv1x").then(()=>parcelRequire('7wL9R'));

});

parcelRegister("hT3tV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jQqdX").then(()=>parcelRequire('3VqDR'));

});


parcelRegister("gqumX", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $e227c66a51313384$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bAbKH = parcelRequire("bAbKH");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e227c66a51313384$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e227c66a51313384$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("fZKpx")));
        case 'da':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("g7y7Z")));
        case 'de':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("5lvZi")));
        case 'en-GB':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("ji9z4")));
        case 'en-US':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("6Qs4V")));
        case 'en-XA':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("bbcif")));
        case 'en-XB':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("buEom")));
        case 'en-ZZ':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("ajcdN")));
        case 'en':
            return $e227c66a51313384$var$importHelper(await Promise.resolve((parcelRequire("bAbKH"))));
        case 'es':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("47n8L")));
        case 'et':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("a7xW1")));
        case 'fi':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("4Yk6U")));
        case 'fr':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("362g9")));
        case 'hr':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("9RnIg")));
        case 'hu':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("4VJGl")));
        case 'it':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("aFKxo")));
        case 'ja':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("iXAIa")));
        case 'ko':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("jzCIx")));
        case 'nb':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("cjANX")));
        case 'nl':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("jRagO")));
        case 'pl':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("bKkc0")));
        case 'pt-BR':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("l42Fa")));
        case 'ro':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("3kh0M")));
        case 'ru':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("5yE4D")));
        case 'sl':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("3JHwv")));
        case 'sr-RS':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("1EKn9")));
        case 'sr-YR':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("7nXdU")));
        case 'sr':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("hrX47")));
        case 'sv':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("lQgvO")));
        case 'th':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("j4vdU")));
        case 'tr':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("8v9Oc")));
        case 'uk':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("5CsCr")));
        case 'vi':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("jYASY")));
        case 'zh-CN':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("16JvG")));
        case 'zh-TW':
            return $e227c66a51313384$var$importHelper(await (parcelRequire("5e6pR")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bAbKH));
    }
};

});
parcelRegister("bAbKH", function(module, exports) {
module.exports = JSON.parse('{"jira-twg-cli-cta.cta-description":[{"type":0,"value":"Ground agents in your org\'s work. Get 44% better answers with 48% fewer tokens."}],"jira-twg-cli-cta.cta-link":[{"type":0,"value":"Learn More"}],"jira-twg-cli-cta.cta-title":[{"type":0,"value":"Give agents more context"}],"jira-twg-cli-cta.why-am-i-seeing-this-reason":[{"type":0,"value":"You have indicated interest in using coding agents"}],"navx-smartlink-full-picture-auth-nudge.connect-button":[{"type":0,"value":"Connect"}],"navx-smartlink-full-picture-auth-nudge.connect-error-button":[{"type":0,"value":"Try again"}],"navx-smartlink-full-picture-auth-nudge.connect-permanent-error-label":[{"type":0,"value":"Failed to connect"}],"navx-smartlink-full-picture-auth-nudge.connected-button":[{"type":0,"value":"Connected"}],"navx-smartlink-full-picture-auth-nudge.connecting-label":[{"type":0,"value":"Connecting"}],"navx-smartlink-full-picture-auth-nudge.description":[{"type":0,"value":"Connect to preview what\'s inside. Your teammates have connected this app."}],"navx-smartlink-full-picture-auth-nudge.description-success":[{"type":0,"value":"Links now display as synced previews"}],"navx-smartlink-full-picture-auth-nudge.description-with-org-stat":[{"type":0,"value":"Connect to preview what\'s inside. "},{"children":[{"type":1,"value":"percent"},{"type":0,"value":"%"}],"type":8,"value":"b"},{"type":0,"value":" of your organization has connected this app."}],"navx-smartlink-full-picture-auth-nudge.dismiss-button":[{"type":0,"value":"Dismiss"}],"navx-smartlink-full-picture-auth-nudge.dont-show-again-button":[{"type":0,"value":"Don\'t show this again"}],"navx-smartlink-full-picture-auth-nudge.reload-to-see-previews":[{"type":0,"value":"Reload to see previews"}],"navx-smartlink-full-picture-auth-nudge.title":[{"type":0,"value":"See what\'s behind these "},{"type":1,"value":"providerName"},{"type":0,"value":" links"}],"navx-smartlink-full-picture-auth-nudge.title-success":[{"type":1,"value":"providerName"},{"type":0,"value":" connected"}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-cta-button":[{"type":0,"value":"Get extension"}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-description-compact":[{"type":0,"value":"Install the Chrome extension for instant, trusted answers anywhere you browse."}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-description-wide":[{"type":0,"value":"Download the Chrome extension to use Rovo in your browser. Get instant answers from trusted sources"}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-title":[{"type":0,"value":"Use Rovo everywhere"}],"post-office.rovo-insights-full-page-chat-spotlight.body":[{"type":0,"value":"See weekly follow-ups just for you, team trends, company news, and more."}],"post-office.rovo-insights-full-page-chat-spotlight.got-it-button":[{"type":0,"value":"Got it"}],"post-office.rovo-insights-full-page-chat-spotlight.headline":[{"type":0,"value":"Start your week with insights"}],"post-office.rovo-insights-full-page-chat-spotlight.image-alt":[{"type":0,"value":"Insights spotlight banner"}],"rovo-button-onboarding-spotlight.copy-version-a.bodyText":[{"type":0,"value":"Connect the dots, simplify writing, and move projects forward."}],"rovo-button-onboarding-spotlight.copy-version-a.headlineText":[{"type":0,"value":"Your AI teammate is here"}],"rovo-button-onboarding-spotlight.getStartedButtonLabel":[{"type":0,"value":"Get started"}],"rovo-expansion-onboarding-checklist.ask-rovo-find":[{"type":0,"value":"Search for related work across your tools"}],"rovo-expansion-onboarding-checklist.ask-rovo-find-description":[{"type":0,"value":"Rovo searches across Jira, Confluence, and connected tools to find the work that unblocks you."}],"rovo-expansion-onboarding-checklist.automate-work":[{"type":0,"value":"Automate repetitive work with Rovo-powered flows"}],"rovo-expansion-onboarding-checklist.automate-work-description":[{"type":0,"value":"Get Rovo to automatically update key work item details like fields and labels, so you don\'t have to."}],"rovo-expansion-onboarding-checklist.browse-agents":[{"type":0,"value":"Browse agents to handle specialized work"}],"rovo-expansion-onboarding-checklist.browse-agents-description":[{"type":0,"value":"Build or use Rovo agents that know your team\'s context, can answer questions, write content, or take action."}],"rovo-expansion-onboarding-checklist.connect-work-tools":[{"type":0,"value":"Connect Rovo to "},{"type":1,"value":"appName"}],"rovo-expansion-onboarding-checklist.connect-work-tools-description":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" so Rovo can search and summarize work across your tools."}],"rovo-expansion-onboarding-checklist.deep-research":[{"type":0,"value":"Use deep research for complex work"}],"rovo-expansion-onboarding-checklist.deep-research-description":[{"type":0,"value":"Run deep research with Rovo to explore a complex issue and get a research-backed plan to move forward."}],"rovo-expansion-onboarding-checklist.deep-research-prompt":[{"type":0,"value":"Gather and synthesize customer feedback on my site from various channels (emails, calls, surveys, support tickets) to identify common pain points and areas for product enhancement over the past year."}],"rovo-expansion-onboarding-checklist.dismiss-button":[{"type":0,"value":"Dismiss"}],"rovo-expansion-onboarding-checklist.heading":[{"type":0,"value":"Get started working with your AI teammate"}],"rovo-expansion-onboarding-checklist.install-extension":[{"type":0,"value":"Install the Chrome Extension"}],"rovo-expansion-onboarding-checklist.install-extension-description":[{"type":0,"value":"Access Rovo from everywhere you work on the web."}],"rovo-expansion-onboarding-checklist.next-card":[{"type":0,"value":"Next tip"}],"rovo-expansion-onboarding-checklist.oauth-error-cancelled":[{"type":0,"value":"You cancelled the connection to "},{"type":1,"value":"appName"},{"type":0,"value":". Please try again."}],"rovo-expansion-onboarding-checklist.oauth-error-generic":[{"type":0,"value":"Something went wrong connecting "},{"type":1,"value":"appName"},{"type":0,"value":". Please try again."}],"rovo-expansion-onboarding-checklist.oauth-error-message-title":[{"type":0,"value":"Error connecting "},{"type":1,"value":"appName"},{"type":0,"value":". Please try again."}],"rovo-expansion-onboarding-checklist.options-menu-title":[{"type":0,"value":"Options"}],"rovo-expansion-onboarding-checklist.previous-card":[{"type":0,"value":"Previous tip"}],"rovo-expansion-onboarding-checklist.prompt-gallery":[{"type":0,"value":"Explore the prompt gallery"}],"rovo-expansion-onboarding-checklist.prompt-gallery-description":[{"type":0,"value":"See a gallery of tested Rovo prompts and use cases you can reuse instead of starting from scratch."}],"rovo-expansion-onboarding-checklist.subheading":[{"type":1,"value":"totalSteps"},{"type":0,"value":" easy steps to become a Rovo Pro"}],"rovo-expansion-onboarding-checklist.title.updated":[{"type":1,"value":"totalSteps"},{"type":0,"value":" Quick tips to power up your work with AI"}],"rovo-expansion-onboarding-checklist.try-it":[{"type":0,"value":"Try it"}],"rovo-expansion-onboarding-checklist.write-status-update":[{"type":0,"value":"Use Rovo to write your status update"}],"rovo-expansion-onboarding-checklist.write-status-update-description":[{"type":0,"value":"Convert your latest Jira activity into one clear, shareable status update"}],"rovo-expansion-onboarding-checklist.write-status-update-prompt":[{"type":0,"value":"Write an update about my week"}],"rovo-expansion.base-3p-rovo-email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo branded header"}],"rovo-expansion.base-3p-rovo-email.title":[{"type":0,"value":"Atlassian Rovo"}],"rovo-expansion.email.body.app-connect-card.add-connectors-button":[{"type":0,"value":"Add connectors"}],"rovo-expansion.email.body.app-connect-card.adobe.alt":[{"type":0,"value":"Adobe Sign logo"}],"rovo-expansion.email.body.app-connect-card.adobe.body":[{"type":0,"value":"Find the Adobe Sign agreements your team needs with ease"}],"rovo-expansion.email.body.app-connect-card.adobe.heading":[{"type":0,"value":"Adobe Sign"}],"rovo-expansion.email.body.app-connect-card.aha.alt":[{"type":0,"value":"Aha! logo"}],"rovo-expansion.email.body.app-connect-card.aha.body":[{"type":0,"value":"Quickly locate Aha! features you need"}],"rovo-expansion.email.body.app-connect-card.aha.heading":[{"type":0,"value":"Aha"}],"rovo-expansion.email.body.app-connect-card.airtable.alt":[{"type":0,"value":"Airtable logo"}],"rovo-expansion.email.body.app-connect-card.airtable.body":[{"type":0,"value":"Bring your data and records and make them searchable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.airtable.heading":[{"type":0,"value":"Airtable"}],"rovo-expansion.email.body.app-connect-card.asana.alt":[{"type":0,"value":"Asana logo"}],"rovo-expansion.email.body.app-connect-card.asana.body":[{"type":0,"value":"Locate your team\'s work by searching Asana\'s tasks and subtasks"}],"rovo-expansion.email.body.app-connect-card.asana.heading":[{"type":0,"value":"Asana"}],"rovo-expansion.email.body.app-connect-card.azure.alt":[{"type":0,"value":"Azure DevOps logo"}],"rovo-expansion.email.body.app-connect-card.azure.body":[{"type":0,"value":"Quickly retrieve your Azure DevOps repositories"}],"rovo-expansion.email.body.app-connect-card.azure.heading":[{"type":0,"value":"Azure DevOps"}],"rovo-expansion.email.body.app-connect-card.box.alt":[{"type":0,"value":"Box logo"}],"rovo-expansion.email.body.app-connect-card.box.body":[{"type":0,"value":"Search all your documents, spreadsheets, and presentations alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.box.heading":[{"type":0,"value":"Box"}],"rovo-expansion.email.body.app-connect-card.connect-button":[{"type":0,"value":"Connect"}],"rovo-expansion.email.body.app-connect-card.docusign.alt":[{"type":0,"value":"DocuSign logo"}],"rovo-expansion.email.body.app-connect-card.docusign.body":[{"type":0,"value":"Make your important envelopes findable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.docusign.heading":[{"type":0,"value":"DocuSign"}],"rovo-expansion.email.body.app-connect-card.dropbox.alt":[{"type":0,"value":"Dropbox logo"}],"rovo-expansion.email.body.app-connect-card.dropbox.body":[{"type":0,"value":"Bring in your documents, spreadsheets, and presentations "}],"rovo-expansion.email.body.app-connect-card.dropbox.heading":[{"type":0,"value":"Dropbox"}],"rovo-expansion.email.body.app-connect-card.gear.alt":[{"type":0,"value":"Add connectors icon"}],"rovo-expansion.email.body.app-connect-card.gear.body":[{"type":0,"value":"Add or remove your connected apps at anytime."}],"rovo-expansion.email.body.app-connect-card.gear.heading":[{"type":0,"value":"You\u2019re always in control"}],"rovo-expansion.email.body.app-connect-card.github.alt":[{"type":0,"value":"GitHub logo"}],"rovo-expansion.email.body.app-connect-card.github.body":[{"type":0,"value":"Integrate your development workflow and search across your PRs, issues, commits, and repos"}],"rovo-expansion.email.body.app-connect-card.github.heading":[{"type":0,"value":"GitHub"}],"rovo-expansion.email.body.app-connect-card.gitlab.alt":[{"type":0,"value":"GitLab logo"}],"rovo-expansion.email.body.app-connect-card.gitlab.body":[{"type":0,"value":"Find your Gitlab repositories easily"}],"rovo-expansion.email.body.app-connect-card.gitlab.heading":[{"type":0,"value":"GitLab"}],"rovo-expansion.email.body.app-connect-card.google-drive.alt":[{"type":0,"value":"Google Drive logo"}],"rovo-expansion.email.body.app-connect-card.google-drive.body":[{"type":0,"value":"Get insights and answers from docs and integrate your files into a unified search"}],"rovo-expansion.email.body.app-connect-card.google-drive.heading":[{"type":0,"value":"Google Drive"}],"rovo-expansion.email.body.app-connect-card.lucid.alt":[{"type":0,"value":"Lucid logo"}],"rovo-expansion.email.body.app-connect-card.lucid.body":[{"type":0,"value":"Make your documents and visual collaboration searchable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.lucid.heading":[{"type":0,"value":"Lucid"}],"rovo-expansion.email.body.app-connect-card.miro.alt":[{"type":0,"value":"Miro logo"}],"rovo-expansion.email.body.app-connect-card.miro.body":[{"type":0,"value":"Make all your brainstorming and planning boards searchable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.miro.heading":[{"type":0,"value":"Miro"}],"rovo-expansion.email.body.app-connect-card.ms-teams.alt":[{"type":0,"value":"Microsoft Teams"}],"rovo-expansion.email.body.app-connect-card.ms-teams.body":[{"type":0,"value":"Make all your messages part of your company knowledge"}],"rovo-expansion.email.body.app-connect-card.ms-teams.heading":[{"type":0,"value":"Microsoft Teams"}],"rovo-expansion.email.body.app-connect-card.notion.alt":[{"type":0,"value":"Notion logo"}],"rovo-expansion.email.body.app-connect-card.notion.body":[{"type":0,"value":"Add your pages and make them searchable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.notion.heading":[{"type":0,"value":"Notion"}],"rovo-expansion.email.body.app-connect-card.onedrive.alt":[{"type":0,"value":"OneDrive logo"}],"rovo-expansion.email.body.app-connect-card.onedrive.body":[{"type":0,"value":"Search across documents, spreadsheets, and presentations"}],"rovo-expansion.email.body.app-connect-card.onedrive.heading":[{"type":0,"value":"OneDrive"}],"rovo-expansion.email.body.app-connect-card.sharepoint.alt":[{"type":0,"value":"Sharepoint logo"}],"rovo-expansion.email.body.app-connect-card.sharepoint.body":[{"type":0,"value":"Get answers from your SharePoint documents and bring your files alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.sharepoint.heading":[{"type":0,"value":"Sharepoint"}],"rovo-expansion.email.body.app-connect-card.slack.alt":[{"type":0,"value":"Slack logo"}],"rovo-expansion.email.body.app-connect-card.slack.body":[{"type":0,"value":"Make every thread and channel part of your company knowledge"}],"rovo-expansion.email.body.app-connect-card.slack.heading":[{"type":0,"value":"Slack"}],"rovo-expansion.email.body.app-connect-card.smartsheet.alt":[{"type":0,"value":"Smartsheet logo"}],"rovo-expansion.email.body.app-connect-card.smartsheet.body":[{"type":0,"value":"Access your Smartsheet sheets"}],"rovo-expansion.email.body.app-connect-card.smartsheet.heading":[{"type":0,"value":"Smartsheet"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.default.introduction":[{"type":0,"value":"Now that you\u2019ve connected "},{"type":1,"value":"connected3PApp"},{"type":0,"value":", you\u2019ll find answers that include your team\u2019s content and more. Try using these prompts to get started:"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.default.prompt-1":[{"type":0,"value":"What content is in my "},{"type":1,"value":"connected3PApp"},{"type":0,"value":" account?"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.default.prompt-2":[{"type":0,"value":"Show me the latest updates from "},{"type":1,"value":"connected3PApp"},{"type":0,"value":"."}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.default.prompt-3":[{"type":0,"value":"Find my "},{"type":1,"value":"connected3PApp"},{"type":0,"value":" contributions."}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.github.introduction":[{"type":0,"value":"Now that you\u2019ve connected "},{"type":1,"value":"connected3PApp"},{"type":0,"value":", you\u2019ll find answers that include your PRs, commits, and more. Try using these prompts to get started:"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.github.prompt-1":[{"type":0,"value":"Find GitHub PRs I created or was tagged in over the past 30 days"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.github.prompt-2":[{"type":0,"value":"Show all PRs that mention me in GitHub"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.github.prompt-3":[{"type":0,"value":"Find the most recent PRs and commits I\u2019ve worked on in GitHub"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.google-drive.full-connector-prompt-1":[{"type":0,"value":"Find all Google Docs I\'ve seen from Jira and Confluence"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.google-drive.full-connector-prompt-2":[{"type":0,"value":"Summarize my latest project from Google Drive in a couple of sentences"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.google-drive.full-connector-prompt-3":[{"type":0,"value":"Find all Google Drive content I\u2019ve worked on from the last 30 days"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.google-drive.introduction":[{"type":0,"value":"Now that you\u2019ve connected your app, you\u2019ll find answers that include Docs, Sheets, and more. Try using these prompts to get started:"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.header-link-prompt":[{"type":0,"value":"In a few words, what is Rovo and how can I use it?"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.heading-1":[{"type":0,"value":"Your Chat just got more powerful"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.prompt.link":[{"type":0,"value":"Try prompt"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.slack.introduction":[{"type":0,"value":"Now that you\u2019ve connected "},{"type":1,"value":"connected3PApp"},{"type":0,"value":", you\u2019ll find answers that are grounded in the conversations of your messages and channels. Try using these prompts to get started:"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.slack.prompt-1":[{"type":0,"value":"Find the latest conversations from Slack"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.slack.prompt-2":[{"type":0,"value":"Summarize the latest activity from all Slack channels in a couple of sentences"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.slack.prompt-3":[{"type":0,"value":"Show all messages that mention me in Slack"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.title":[{"type":0,"value":"Try 3 prompts to instantly improve your search with "},{"type":1,"value":"connected3PApp"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.github-description":[{"type":0,"value":"Your Search just got more powerful. Find your code from one place."}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.github-link":[{"type":0,"value":"Find related commits"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.github-search-query":[{"type":0,"value":"PRs and commits related to "},{"type":1,"value":"pageId"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.google-drive-description":[{"type":0,"value":"Your Search just got more powerful. Find your recent documents, spreadsheets, and slides from one place."}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.google-drive-link":[{"type":0,"value":"Find related Docs"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.google-drive-search-query":[{"type":0,"value":"Docs related to "},{"type":1,"value":"pageId"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.title":[{"type":1,"value":"connected3PApp"},{"type":0,"value":" is now connected"}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.know-more.heading":[{"type":0,"value":"Want to know more?"}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.know-more.subheading":[{"type":0,"value":"Learn about managing connectors, your data, and permissions."}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.recommended-for-you.heading":[{"type":0,"value":"Recommended for you"}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.recommended-for-you.subheading":[{"type":0,"value":"Connect the apps your team is already using."}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.heading":[{"type":0,"value":"Get better results by connecting your apps with Rovo"}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.subheading.gear-variant":[{"type":0,"value":"Smarter search and chat starts with connected apps. App permissions are always respected."}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.subheading.text-variant":[{"type":0,"value":"Smarter search and chat starts with connected apps. Rovo respects existing app permissions, and "},{"children":[{"type":0,"value":"you can add or remove connectors at any time."}],"type":8,"value":"a"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.add-connectors-button":[{"type":0,"value":"Add connectors"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.alt":[{"type":0,"value":"Adobe Sign logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.body":[{"type":0,"value":"Find the Adobe Sign agreements your team needs with ease"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.heading":[{"type":0,"value":"Adobe Sign"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.alt":[{"type":0,"value":"Aha! logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.body":[{"type":0,"value":"Quickly locate Aha! features you need"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.heading":[{"type":0,"value":"Aha"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.alt":[{"type":0,"value":"Airtable logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.body":[{"type":0,"value":"Bring your data and records and make them searchable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.heading":[{"type":0,"value":"Airtable"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.alt":[{"type":0,"value":"Asana logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.body":[{"type":0,"value":"Locate your team\'s work by searching Asana\'s tasks and subtasks"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.heading":[{"type":0,"value":"Asana"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.alt":[{"type":0,"value":"Azure DevOps logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.body":[{"type":0,"value":"Quickly retrieve your Azure DevOps repositories"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.heading":[{"type":0,"value":"Azure DevOps"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.alt":[{"type":0,"value":"Box logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.body":[{"type":0,"value":"Search all your documents, spreadsheets, and presentations alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.heading":[{"type":0,"value":"Box"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.connect-banner.description":[{"type":0,"value":"Banner image showing Rovo app connectors"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.connect-button":[{"type":0,"value":"Connect"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.alt":[{"type":0,"value":"DocuSign logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.body":[{"type":0,"value":"Make your important envelopes findable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.heading":[{"type":0,"value":"DocuSign"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.alt":[{"type":0,"value":"Dropbox logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.body":[{"type":0,"value":"Bring in your documents, spreadsheets, and presentations "}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.heading":[{"type":0,"value":"Dropbox"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.contact-us":[{"type":0,"value":"Contact us"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.facebook-title":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.separator":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.x-title":[{"type":0,"value":"X"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.alt":[{"type":0,"value":"Add connectors icon"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.body":[{"type":0,"value":"Add or remove your connected apps at anytime."}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.heading":[{"type":0,"value":"You\u2019re always in control"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.alt":[{"type":0,"value":"GitHub logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.body":[{"type":0,"value":"Integrate your development workflow and search across your PRs, issues, commits, and repos"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.heading":[{"type":0,"value":"GitHub"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.alt":[{"type":0,"value":"GitLab logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.body":[{"type":0,"value":"Find your Gitlab repositories easily"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.heading":[{"type":0,"value":"GitLab"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.alt":[{"type":0,"value":"Google Drive logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.body":[{"type":0,"value":"Get insights and answers from docs and integrate your files into a unified search"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.heading":[{"type":0,"value":"Google Drive"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.alt":[{"type":0,"value":"Lucid logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.body":[{"type":0,"value":"Make your documents and visual collaboration searchable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.heading":[{"type":0,"value":"Lucid"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.alt":[{"type":0,"value":"Miro logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.body":[{"type":0,"value":"Make all your brainstorming and planning boards searchable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.heading":[{"type":0,"value":"Miro"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.alt":[{"type":0,"value":"Monday logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.body":[{"type":0,"value":"Centralize your Monday boards seamlessly"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.heading":[{"type":0,"value":"Monday"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.alt":[{"type":0,"value":"Microsoft Teams"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.body":[{"type":0,"value":"Make all your messages part of your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.heading":[{"type":0,"value":"Microsoft Teams"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.alt":[{"type":0,"value":"Notion logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.body":[{"type":0,"value":"Add your pages and make them searchable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.heading":[{"type":0,"value":"Notion"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.alt":[{"type":0,"value":"OneDrive logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.body":[{"type":0,"value":"Search across documents, spreadsheets, and presentations"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.heading":[{"type":0,"value":"OneDrive"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.alt":[{"type":0,"value":"Slack logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.body":[{"type":0,"value":"Make every thread and channel part of your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.heading":[{"type":0,"value":"Slack"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.alt":[{"type":0,"value":"Smartsheet logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.body":[{"type":0,"value":"Access your Smartsheet sheets"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.heading":[{"type":0,"value":"Smartsheet"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.subject":[{"type":0,"value":"Connect the apps your team depends on"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.banner.description":[{"type":0,"value":"Decorative banner image"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.description":[{"type":0,"value":"Turn scattered files into accessible knowledge, without compromising on security and permissions"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.headline":[{"type":0,"value":"Expand organizational knowledge"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.icon.description":[{"type":0,"value":"Flow state icon"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.heading":[{"type":0,"value":"Finish connecting "},{"type":1,"value":"appName"},{"type":0,"value":" to give your team a more intuitive way to search"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.heading-subtext":[{"type":0,"value":"Centralize the search for your team\u2019s files so they\u2019ll always have the knowledge and context they need."}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.description":[{"type":0,"value":"Getting rich, contextual results in search and chat"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.headline":[{"type":0,"value":"Find better answers instantly"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.icon.description":[{"type":0,"value":"Page search icon"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.description":[{"type":0,"value":"Reducing context switching to focus on the work that matters"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.headline":[{"type":0,"value":"Stay concentrated in their workflow"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.icon.description":[{"type":0,"value":"Platform icon"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.rovo.heading-after-connecting":[{"type":0,"value":"With your help, they\u2019ll be able to:"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.subject":[{"type":0,"value":"Unblock your team\u2019s work: finish connecting "},{"type":1,"value":"appName"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.banner.description":[{"type":0,"value":"Banner image showing Rovo app connectors"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.flow-state.description":[{"type":0,"value":"Connect related work across tools, teams, and projects so knowledge never stays siloed"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.flow-state.icon.description":[{"type":0,"value":"Flow state icon"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.page-search.description":[{"type":0,"value":"Get richer answers in Search and Chat, not just links"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.page-search.icon.description":[{"type":0,"value":"Page search icon"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.platform.description":[{"type":0,"value":"Find content across your entire workspace from a single search"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.platform.icon.description":[{"type":0,"value":"Platform icon"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.rovo.heading-after-connecting":[{"type":0,"value":"After connecting your app, you\u2019ll be able to:"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading-subtext.more-than-one-app":[{"type":0,"value":"Your admin just added the following apps. Finish connecting your account to find contextual results that include all your work in a single search."}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading-subtext.one-app":[{"type":0,"value":"Your admin just added "},{"type":1,"value":"appName"},{"type":0,"value":". Finish connecting your account to find contextual results that include all your work in a single search."}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.one-app":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" to get more in-depth answers"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.three-or-more-apps":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" and other apps to get more in-depth answers "}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.two-apps":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" and "},{"type":1,"value":"appName2"},{"type":0,"value":" to get more in-depth answers"}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.body.header.v4":[{"type":1,"value":"userName"},{"type":0,"value":", stay on top of work with instant context and speed"}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.body.intro.v3":[{"type":0,"value":"Spend less time on busywork and more time on what matters. Try these "},{"type":1,"value":"count"},{"type":0,"value":" prompts designed with your week in mind."}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.body.prompt.link.v2":[{"type":0,"value":"Try prompt"}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.subject.variant-two.v2":[{"type":1,"value":"userName"},{"type":0,"value":", these "},{"type":1,"value":"promptCount"},{"type":0,"value":" prompts were made just for you"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.01-body":[{"type":0,"value":"Less background activity. Tighter behavior on third-party pages. Updated documentation that explains what runs, when, and why \u2014 ready to hand to reviewers. Privacy review doesn\u2019t have to be the slowest part of your rollout anymore."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.01-heading":[{"type":0,"value":"Privacy features your security team will love"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.02-body":[{"type":0,"value":"Enable, disable, or lock individual capabilities \u2014 site by site, feature by feature. Manage in-page reading features with one consistent policy surface. No more all-or-nothing deployments."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.02-heading":[{"type":0,"value":"Granular deployment you can tailor site by site"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.03-body":[{"type":0,"value":"Give Rovo the ability to read and analyze web page content to provide smarter, more relevant answers. It only accesses what you can see, and never stores page data."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.03-heading":[{"type":0,"value":"Grounded answers with page context"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.04-body":[{"type":0,"value":"Take control of the new tab experience. Activate the Rovo New Tab Page to leverage company-wide announcements and custom branding, or set a custom URL like your own intranet. Give your users the flexibility they want with the alignment your organization needs. Full choice, full control."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.04-heading":[{"type":0,"value":"A New Tab Page built for your team"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.actions-heading":[{"type":0,"value":"Get started"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.greeting-introduction":[{"type":0,"value":"You\u2019ve been telling us what the Rovo browser extension needs before it\u2019s ready for broad rollout. We\u2019ve shipped a wave of upgrades to make it safer, more controllable, and easier to deploy on your terms."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.header-image.atlassian-icon-alt.no-translate":[{"type":0,"value":"Atlassian Rovo"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.improvements-heading":[{"type":0,"value":"Here\'s what you get"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.install-button":[{"type":0,"value":"Download the extension"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.instructions-link":[{"type":0,"value":"Or learn how to roll out the Rovo extension across your org"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.personal-greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.sign-off":[{"type":0,"value":"Have questions about the Rovo browser extension or just keen to learn more? Reach out to us at "},{"type":1,"value":"rovoExtEmail"},{"type":0,"value":" \u2013 we\u2019re happy to help!"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.subject":[{"type":0,"value":"Rovo browser extension: new admin upgrades, ready to roll out"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.summary-1":[{"type":0,"value":"Less risk, more choice. A direct line to every user. A new tab that finally looks like it belongs to your company."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.summary-2":[{"type":0,"value":"If you\u2019ve been waiting for the right moment to roll out the Rovo browser extension across your org, this is it."}],"rovo-expansion.rovo-extension-download-end-users-i18n.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-download-end-users-i18n.email.body.hello.subtext":[{"type":0,"value":"Love using Rovo? Take it to the next level with the Rovo browser extension."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.description":[{"type":0,"value":"Chat that knows your context. Ask questions about what\u2019s open. Get context, fast."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.heading":[{"type":0,"value":"Chat that knows your context"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.subtext":[{"type":0,"value":"Ask questions about whatever tab is open. Get context, fast."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.description":[{"type":0,"value":"Create what you need, fast. Instant work items across Jira, Confluence, Loom, and Agents. Make teamwork easy."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.heading":[{"type":0,"value":"Create what you need, fast"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.subtext":[{"type":0,"value":"Instant work items across Jira, Confluence, Loom, and Agents. Make teamwork easy."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.download-extension":[{"type":0,"value":"Download the extension"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.extension-screenshot.description":[{"type":0,"value":"Demo of the extension in action"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.contact-us":[{"type":0,"value":"Contact us"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.facebook-aria":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.facebook-title":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.linkedin-aria":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.separator-1":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.separator-2":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.unsubscribe.full":[{"type":0,"value":"to opt out of future emails like this"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.unsubscribe.short":[{"type":0,"value":"Unsubscribe"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.x-aria":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.x-title":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.four-icon.description":[{"type":0,"value":"Four icon"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.description":[{"type":0,"value":"Instant answers. Chat with your company\u2019s knowledge base, right from any browser tab."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.heading":[{"type":0,"value":"Instant answers"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.subtext":[{"type":0,"value":"Chat with your "},{"children":[{"type":0,"value":"company\u2019s knowledge"}],"type":8,"value":"strong"},{"type":0,"value":" base, right from any browser tab."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.one-icon.description":[{"type":0,"value":"One icon"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.three-icon.description":[{"type":0,"value":"Three icon"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.try-it-today":[{"type":0,"value":"Try it today."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.two-icon.description":[{"type":0,"value":"Two icon"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.description":[{"type":0,"value":"Your work in one click. Pick up where you left off. Rovo\'s new tab page keeps your recent work ready after that last unexpected interruption."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.heading":[{"type":0,"value":"Your work in one click"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.subtext":[{"type":0,"value":"Pick up where you left off. Rovo\'s new tab page keeps your recent work ready after that last unexpected interruption."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.subject":[{"type":0,"value":"\uD83D\uDE80 Try out the Rovo browser extension \u2013 Available now"}],"rovo-expansion.rovo-extension-download-end-users.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-download-end-users.email.body.hello.subtext":[{"type":0,"value":"Love using Rovo? Take it to the next level with the Rovo browser extension."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.download-extension":[{"type":0,"value":"Download the extension"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.extension-screenshot.description":[{"type":0,"value":"Demo of the extension in action"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.make-rovo-your-own":[{"type":0,"value":"Here\u2019s what you get"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.rovo-extension-features.description":[{"type":0,"value":"Rovo extension features: Chat with your company\u2019s knowledge base, right from any browser tab. Ask questions about what\u2019s open. Get context that connects back to your projects. Pick up where you left off. Rovo\u2019s new tab page keeps your recent work ready after that last unexpected interruption. Create what you need, fast. Instantly create work items across Jira, Confluence, and Loom. Make teamwork easy."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.try-it-today":[{"type":0,"value":"Try it today."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.subject":[{"type":0,"value":"\uD83D\uDE80 Try out the Rovo browser extension \u2013 Available now"}],"rovo-expansion.rovo-extension-download-org-admins-usage.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-download-org-admins-usage.email.body.hello.subtext":[{"type":0,"value":"Companies are using "},{"children":[{"type":0,"value":"AI 400% as often"}],"type":8,"value":"span"},{"type":0,"value":" with the Rovo browser extension. Scale your org\u2019s AI adoption fast."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.download-extension":[{"type":0,"value":"Install the extension across your company"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.extension-screenshot.description":[{"type":0,"value":"Demo of the extension in action"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.contact-us":[{"type":0,"value":"Contact us"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-aria":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-title":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-aria":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-1":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-2":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.full":[{"type":0,"value":"to opt out of future emails like this"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.short":[{"type":0,"value":"Unsubscribe"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-aria":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-title":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.make-rovo-your-own":[{"type":0,"value":"Make Rovo your own"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.ready-to-roll-out":[{"type":0,"value":"Ready to roll out?"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.rovo-features.description":[{"type":0,"value":"Customize the experience: add your company\u2019s logo, colors, and background to the new tab page. Push your announcements: Company-wide updates and news to every user\u2019s new tab. Users stay in control of their browsing experience by customizing or opting out in their extension settings."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.vitafleet-spotlight.description":[{"type":0,"value":"Rovo extension with company branding and annoucements."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.why-rovo.description":[{"type":0,"value":"Rovo is Atlassian\u2019s AI. It is designed for teamwork, connecting knowledge, people, and action to move work forward. Today Rovo includes Enterprise Search, Chat, Studio, Agents, and Skills and can be connected to 50+ 3rd party tools."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.your-team-will-thank-you":[{"type":0,"value":"Your team will thank you."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.subject":[{"type":0,"value":"\uD83D\uDE80 Get the Rovo extension ready for your whole team"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.body-base.no-translate":[{"type":0,"value":"Rovo has generated new insights based on your recent activity"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.body-categories.no-translate":[{"type":1,"value":"formattedCategories"},{"type":0,"value":" you need to see"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.message-fallback.no-translate":[{"type":0,"value":"Your Rovo insights are ready"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.message-plural.no-translate":[{"type":1,"value":"insightCount"},{"type":0,"value":" Rovo insights for you"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.message-singular.no-translate":[{"type":1,"value":"insightCount"},{"type":0,"value":" Rovo insight for you"}],"rovo-extension-gdocs-definitions-install-cta-flag.flag-description":[{"type":0,"value":"Define company jargon in Google Docs, with the Rovo browser extension."}],"rovo-extension-gdocs-definitions-install-cta-flag.flag-dismiss-button-label":[{"type":0,"value":"Dismiss"}],"rovo-extension-gdocs-definitions-install-cta-flag.flag-download":[{"type":0,"value":"Download extension"}],"rovo-extension-gdocs-definitions-install-cta-flag.flag-title":[{"type":0,"value":"Get definitions in your Gdocs"}],"rovo-extension-install-cta-left-nav.chrome-icon-alt":[{"type":0,"value":"Google Chrome Icon"}],"rovo-extension-install-cta-left-nav.description.copy-version-b":[{"type":0,"value":"Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab."}],"rovo-extension-install-cta-left-nav.description.copy-version-c":[{"type":0,"value":"50K+ workers use it to chat with AI that understands their company."}],"rovo-extension-install-cta-left-nav.description.jira-rovo":[{"type":0,"value":"Manage work items, get instant insights, and act on Jira from any tab in your browser."}],"rovo-extension-install-cta-left-nav.description.jira-take-anywhere":[{"type":0,"value":"Manage work items, get instant insights, and act on Jira from any tab in your browser."}],"rovo-extension-install-cta-left-nav.dismiss-label":[{"type":0,"value":"Dismiss message"}],"rovo-extension-install-cta-left-nav.heading.copy-version-b":[{"type":0,"value":"Get answers for work, anywhere"}],"rovo-extension-install-cta-left-nav.heading.copy-version-c":[{"type":0,"value":"Unlock Rovo in every tab"}],"rovo-extension-install-cta-left-nav.heading.jira-rovo":[{"type":0,"value":"Jira. Anywhere."}],"rovo-extension-install-cta-left-nav.heading.jira-take-anywhere":[{"type":0,"value":"Jira. Anywhere."}],"rovo-extension-install-cta-left-nav.jira-icon-alt":[{"type":0,"value":"Jira Icon"}],"rovo-extension-install-cta-left-nav.jira-link":[{"type":0,"value":"Get the browser extension"}],"rovo-extension-install-cta-left-nav.jira-rovo-link":[{"type":0,"value":"Get the Rovo extension"}],"rovo-extension-install-cta-left-nav.link":[{"type":0,"value":"Get the browser extension"}],"rovo-extension-install-cta-left-nav.rovo-icon-alt":[{"type":0,"value":"Rovo Icon"}],"rovo-growth-3p-end-user-cta-flag.common.error.action":[{"type":0,"value":"Try again"}],"rovo-growth-3p-end-user-cta-flag.common.first-error.description":[{"type":0,"value":"Try again or ask your admin for help."}],"rovo-growth-3p-end-user-cta-flag.common.first-error.title":[{"type":0,"value":"We\'re having trouble connecting "},{"type":1,"value":"product"}],"rovo-growth-3p-end-user-cta-flag.common.second-error.description":[{"type":0,"value":"Try using the "},{"type":1,"value":"product"},{"type":0,"value":" Smart Link to connect your account, or ask your admin for help."}],"rovo-growth-3p-end-user-cta-flag.common.second-error.title":[{"type":0,"value":"We couldn\'t connect your app"}],"rovo-growth-3p-end-user-cta-flag.common.success.title":[{"type":0,"value":"Successfully connected to "},{"type":1,"value":"product"},{"type":0,"value":"."}],"rovo-growth-3p-smartlink-admin-paste-nudge.action.connect":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"rovo-growth-3p-smartlink-admin-paste-nudge.action.learn-more":[{"type":0,"value":"Learn more"}],"rovo-growth-3p-smartlink-admin-paste-nudge.description.generic":[{"type":0,"value":"Help your team find better answers with shared "},{"type":1,"value":"appName"},{"type":0,"value":" content from across your organization."}],"rovo-growth-3p-smartlink-admin-paste-nudge.description.github":[{"type":0,"value":"Help your team find answers faster. Connect GitHub to see PR previews, repository details, and GitHub content across Rovo."}],"rovo-growth-3p-smartlink-admin-paste-nudge.description.gitlab":[{"type":0,"value":"Help your team find answers faster. Connect GitLab to see PR previews, repository details, and GitLab content across Rovo."}],"rovo-growth-3p-smartlink-admin-paste-nudge.title":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" for your team"}],"rovo-growth-3p-smartlink-paste-nudge.connect-button-text":[{"type":0,"value":"Connect "},{"type":1,"value":"product"}],"rovo-growth-3p-smartlink-paste-nudge.description":[{"type":0,"value":"Make this Smart Link and other files searchable by connecting your account."}],"rovo-growth-3p-smartlink-paste-nudge.flag-title.high-percentage":[{"type":0,"value":"90% of your team shares content from "},{"type":1,"value":"product"}],"rovo-growth-3p-smartlink-paste-nudge.flag-title.low-percentage":[{"type":0,"value":"Your team shares content from "},{"type":1,"value":"product"}],"rovo-growth-3p-smartlink-paste-nudge.flag-title.medium-percentage":[{"type":1,"value":"percent"},{"type":0,"value":"% of your team shares content from "},{"type":1,"value":"product"}],"rovo-growth-3p-smartlink-paste-nudge.success.description":[{"type":0,"value":"Shared links now display rich previews."}],"rovo-growth-3p-smartlink-paste-nudge.success.title":[{"type":1,"value":"product"},{"type":0,"value":" is connected"}],"rovo-growth-nudge-end-user-highly-connected-apps.action.connect":[{"type":0,"value":"Connect "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.action.connect.variant2":[{"type":0,"value":"Connect now"}],"rovo-growth-nudge-end-user-highly-connected-apps.action.dont-show-again":[{"type":0,"value":"Don\'t show "},{"type":1,"value":"app"},{"type":0,"value":" again"}],"rovo-growth-nudge-end-user-highly-connected-apps.description.high-percentage.variant2":[{"type":0,"value":"90% of your team works with shared content. Connect for a smarter Search and Chat that includes work you\u2019ve seen. "}],"rovo-growth-nudge-end-user-highly-connected-apps.description.medium-high-percentage.variant1":[{"type":0,"value":"Connect your account to search smarter and get more in-depth summaries in Chat."}],"rovo-growth-nudge-end-user-highly-connected-apps.description.medium-high-percentage.variant2":[{"type":1,"value":"percent"},{"type":0,"value":"% of your team works with shared content. Connect for a smarter Search and Chat that includes work you\u2019ve seen. "}],"rovo-growth-nudge-end-user-highly-connected-apps.description.variant1":[{"type":0,"value":"Get better summaries in Search and Chat from work that was shared with you."}],"rovo-growth-nudge-end-user-highly-connected-apps.description.variant2":[{"type":0,"value":"Get better summaries in Search and Chat that includes files from work you\u2019ve seen. "}],"rovo-growth-nudge-end-user-highly-connected-apps.error.action":[{"type":0,"value":"Try again"}],"rovo-growth-nudge-end-user-highly-connected-apps.first-error.description":[{"type":0,"value":"Try again or ask your admin for help."}],"rovo-growth-nudge-end-user-highly-connected-apps.first-error.title":[{"type":0,"value":"We\'re having trouble connecting "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.second-error.description":[{"type":0,"value":"Try using the "},{"type":1,"value":"product"},{"type":0,"value":" Smart Link to connect your account, or ask your admin for help."}],"rovo-growth-nudge-end-user-highly-connected-apps.second-error.title":[{"type":0,"value":"We couldn\'t connect your app"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.high-percentage.variant1":[{"type":0,"value":"90% of your team has connected apps like "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.low-percentage.variant1":[{"type":0,"value":"Your team connected "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.low-percentage.variant2":[{"type":0,"value":"Your team is using "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.medium-percentage.variant1":[{"type":1,"value":"percent"},{"type":0,"value":"% of your team has connected apps like "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.medium-percentage.variant2":[{"type":0,"value":"Connect "},{"type":1,"value":"product"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.chat-prompt":[{"type":0,"value":"Hi Rovo, list three things you can do right now for me based on my recent work"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.cta-link-text":[{"type":0,"value":"Try Rovo now"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.description.v1":[{"type":0,"value":"Rovo connects your tools and knowledge so work gets done for you."}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.heading.v1":[{"type":0,"value":"Unlock your AI teammate"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-1":[{"type":0,"value":"your existing Atlassian products"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-2":[{"type":0,"value":"your organization having AI enabled"}],"rovo-non-mau-chat-cta-left-nav.chat-prompt":[{"type":0,"value":"Hi Rovo, list three things you can do right now for me based on my recent work"}],"rovo-non-mau-chat-cta-left-nav.cta-link-text":[{"type":0,"value":"Try Rovo now"}],"rovo-non-mau-chat-cta-left-nav.description.v1":[{"type":0,"value":"Rovo connects your tools and knowledge so work gets done for you."}],"rovo-non-mau-chat-cta-left-nav.heading.v1":[{"type":0,"value":"Unlock your AI teammate"}],"rovo-non-mau-chat-cta-left-nav.why-am-i-seeing-this.reason-1":[{"type":0,"value":"your existing Atlassian products"}],"rovo-non-mau-chat-cta-left-nav.why-am-i-seeing-this.reason-2":[{"type":0,"value":"your organization having AI enabled"}],"rovo.search.inline-3p.banner-image-alt":[{"type":0,"value":"Illustration showing "},{"type":1,"value":"connectorName"},{"type":0,"value":" integration with Atlassian search"}],"rovo.search.inline-3p.connect":[{"type":0,"value":"Connect "},{"type":1,"value":"connectorName"}],"rovo.search.inline-3p.connect-later":[{"type":0,"value":"Connect later"}],"rovo.search.inline-3p.dismiss":[{"type":0,"value":"Dismiss"}],"rovo.search.inline-3p.full-connector.admin-blessed.body":[{"type":0,"value":"Finish connecting your account to unlock search results with context from all your files."}],"rovo.search.inline-3p.full-connector.admin-blessed.heading":[{"type":0,"value":"Your admin added "},{"type":1,"value":"connectorName"}],"rovo.search.inline-3p.full-connector.fomo.body-v2":[{"type":0,"value":"Join your team in a smarter search. Connect your account to find answers hidden in your team\'s work."}],"rovo.search.inline-3p.full-connector.fomo.heading":[{"type":0,"value":"Your team is getting results you might be missing"}],"rovo.search.inline-3p.full-connector.search-in-one-place.body":[{"type":0,"value":"Connect your account to see missing results, including files and docs you already have access to."}],"rovo.search.inline-3p.full-connector.search-in-one-place.heading":[{"type":0,"value":"See richer search results in every search"}],"rovo.search.inline-3p.smart-link-connector.fomo.body-v2":[{"type":0,"value":"Most of your team\'s Smart Links don\'t appear in search. Connect "},{"type":1,"value":"connectorName"},{"type":0,"value":" to expand your search."}],"rovo.search.inline-3p.smart-link-connector.fomo.heading":[{"type":0,"value":"Your team is getting results you might be missing"}],"rovo.search.inline-3p.smart-link-connector.recency-1.body-v2":[{"type":0,"value":"Connect your account to find work you\'ve seen and its related content."}],"rovo.search.inline-3p.smart-link-connector.recency-1.heading":[{"type":0,"value":"Missing that recent "},{"type":1,"value":"connectorName"},{"type":0,"value":" result?"}],"rovo.search.inline-3p.smart-link-connector.recency-2.body":[{"type":0,"value":"Connect your account to find "},{"type":1,"value":"connectorName"},{"type":0,"value":" links you\'ve seen before."}],"rovo.search.inline-3p.smart-link-connector.recency-2.heading":[{"type":0,"value":"See richer results in every search"}],"rovo.search.inline-3p.smart-link-connector.social-proof-high.body":[{"type":1,"value":"teamUsagePercentage"},{"type":0,"value":"% of your team works with shared content. Connect your account so work shared via Smart Links shows up in Search."}],"rovo.search.inline-3p.smart-link-connector.social-proof-high.heading-v2":[{"type":0,"value":"Find missing results from your team\'s content"}],"rovo.search.inline-3p.smart-link-connector.social-proof-low.body":[{"type":0,"value":"Connect your account to search across "},{"type":1,"value":"connectorName"},{"type":0,"value":" files shared by your team via Smart Links."}],"rovo.search.inline-3p.smart-link-connector.social-proof-low.heading":[{"type":0,"value":"Find what\'s hidden in your team\'s shared links"}],"rovo.search.inline-authorization-fail":[{"type":0,"value":"Failed to connect to "},{"type":1,"value":"product"},{"type":0,"value":"."}],"rovo.search.inline.authorization-success":[{"type":0,"value":"Account connected to "},{"type":1,"value":"product"},{"type":0,"value":"."}],"rovo.search.quick-find-3p.connect":[{"type":0,"value":"Connect "},{"type":1,"value":"connectorName"}],"rovo.search.quick-find-3p.connect-later":[{"type":0,"value":"Connect later"}],"rovo.search.quick-find-3p.dismiss":[{"type":0,"value":"Dismiss"}],"rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.body":[{"type":0,"value":"Connect to see missing results"}],"rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.heading-v2":[{"type":0,"value":"Your admin added "},{"type":1,"value":"connectorName"},{"type":0,"value":". "}],"rovo.search.quick-find-3p.full-connector.social-proof-high.heading-v2":[{"type":1,"value":"teamConnectAppPercentage"},{"type":0,"value":"% of your team have connected apps"}],"rovo.search.quick-find-3p.smart-link-connector.social-proof-high.heading-v3":[{"type":1,"value":"teamConnectAppPercentage"},{"type":0,"value":"% of your team have connected apps"}],"rovo.search.quick-find-3p.smart-link-connector.social-proof-low.body":[{"type":0,"value":"Connect your account to see missing results"}],"rovo.search.quick-find-3p.smart-link-connector.social-proof-low.heading-v2":[{"type":1,"value":"connectorName"},{"type":0,"value":" is now available!"}],"rovo.search.quick-find-authorization-fail":[{"type":0,"value":"Failed to connect to "},{"type":1,"value":"product"},{"type":0,"value":"."}],"rovo.search.quick-find.authorization-success":[{"type":0,"value":"Account connected to "},{"type":1,"value":"product"},{"type":0,"value":"."}]}');

});

parcelRegister("fZKpx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("30j1D").then(()=>parcelRequire('heCqP'));

});

parcelRegister("g7y7Z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ltsyM").then(()=>parcelRequire('eEYjV'));

});

parcelRegister("5lvZi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gT2gp").then(()=>parcelRequire('gt8Fj'));

});

parcelRegister("ji9z4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fhNEr").then(()=>parcelRequire('iD6EH'));

});

parcelRegister("6Qs4V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fDHhX").then(()=>parcelRequire('4Uxac'));

});

parcelRegister("bbcif", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9szPv").then(()=>parcelRequire('bazvu'));

});

parcelRegister("buEom", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("32pd9").then(()=>parcelRequire('1vBFE'));

});

parcelRegister("ajcdN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5EdFs").then(()=>parcelRequire('kLs6S'));

});

parcelRegister("47n8L", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2tGOo").then(()=>parcelRequire('37fvq'));

});

parcelRegister("a7xW1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jX4yb").then(()=>parcelRequire('99sgH'));

});

parcelRegister("4Yk6U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2LHKu").then(()=>parcelRequire('7v7is'));

});

parcelRegister("362g9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5vvjD").then(()=>parcelRequire('2UpiL'));

});

parcelRegister("9RnIg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7eqyJ").then(()=>parcelRequire('17AMm'));

});

parcelRegister("4VJGl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1or3e").then(()=>parcelRequire('elULZ'));

});

parcelRegister("aFKxo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fVOUj").then(()=>parcelRequire('4E3L9'));

});

parcelRegister("iXAIa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cMrVJ").then(()=>parcelRequire('f6f01'));

});

parcelRegister("jzCIx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Xj6v").then(()=>parcelRequire('lPbLC'));

});

parcelRegister("cjANX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k7MNY").then(()=>parcelRequire('aKC5U'));

});

parcelRegister("jRagO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gvbiJ").then(()=>parcelRequire('dd7XN'));

});

parcelRegister("bKkc0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("etWtP").then(()=>parcelRequire('3uEiW'));

});

parcelRegister("l42Fa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2GWHA").then(()=>parcelRequire('iV17n'));

});

parcelRegister("3kh0M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ciRWd").then(()=>parcelRequire('ium1m'));

});

parcelRegister("5yE4D", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j6cW4").then(()=>parcelRequire('iCVXV'));

});

parcelRegister("3JHwv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("blOpO").then(()=>parcelRequire('EAdu3'));

});

parcelRegister("1EKn9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fgPQt").then(()=>parcelRequire('lqs9r'));

});

parcelRegister("7nXdU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2h9Ou").then(()=>parcelRequire('3qpyQ'));

});

parcelRegister("hrX47", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b6xhS").then(()=>parcelRequire('9JkrO'));

});

parcelRegister("lQgvO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6VQkx").then(()=>parcelRequire('aIWic'));

});

parcelRegister("j4vdU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k1DNi").then(()=>parcelRequire('amBCY'));

});

parcelRegister("8v9Oc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kmaqE").then(()=>parcelRequire('6oNQn'));

});

parcelRegister("5CsCr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dWiyY").then(()=>parcelRequire('e0uqR'));

});

parcelRegister("jYASY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e85vn").then(()=>parcelRequire('gB6mA'));

});

parcelRegister("16JvG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eW57h").then(()=>parcelRequire('atulo'));

});

parcelRegister("5e6pR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gqrzN").then(()=>parcelRequire('kbZbm'));

});


parcelRegister("2AnZW", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $b4d0fdbdfacfe4f3$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $eVRDG = parcelRequire("eVRDG");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b4d0fdbdfacfe4f3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b4d0fdbdfacfe4f3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("6RUjk")));
        case 'da':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("dDEsQ")));
        case 'de':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("iMVv6")));
        case 'en-GB':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("8z9QI")));
        case 'en-US':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("9rboO")));
        case 'en-XA':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("epf51")));
        case 'en-XB':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("jwjvf")));
        case 'en-ZZ':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("eQJ91")));
        case 'en':
            return $b4d0fdbdfacfe4f3$var$importHelper(await Promise.resolve((parcelRequire("eVRDG"))));
        case 'es':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("i2ri1")));
        case 'et':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("9hiLI")));
        case 'fi':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("jR2Wy")));
        case 'fr':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("cTkRM")));
        case 'hr':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("4RJdu")));
        case 'hu':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("iIAZm")));
        case 'it':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("ahLS0")));
        case 'ja':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("1oP5V")));
        case 'ko':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("3uEuB")));
        case 'nb':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("lmdP3")));
        case 'nl':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("4aevu")));
        case 'pl':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("hg7sN")));
        case 'pt-BR':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("1pTIW")));
        case 'ro':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("5AHSV")));
        case 'ru':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("8wgXB")));
        case 'sl':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("7UjYg")));
        case 'sr-RS':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("dBIkz")));
        case 'sr-YR':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("039PZ")));
        case 'sr':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("lBPXk")));
        case 'sv':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("5B53g")));
        case 'th':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("crIoR")));
        case 'tr':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("aUMsm")));
        case 'uk':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("5n8PJ")));
        case 'vi':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("hWoVu")));
        case 'zh-CN':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("8Y6RM")));
        case 'zh-TW':
            return $b4d0fdbdfacfe4f3$var$importHelper(await (parcelRequire("9mxl7")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eVRDG));
    }
};

});
parcelRegister("eVRDG", function(module, exports) {
module.exports = JSON.parse('{"admin-hub.ci-test.message-template-template-hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"ci-generation.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ci-generation.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ci-generation.email.body.img.alt":[{"type":0,"value":"This is the alt text for the image"}],"ci-generation.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ci-generation.email.body.signoff":[{"type":0,"value":"Regards,"}],"ci-generation.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ci-generation.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"post-office.test-message-digest-email-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-email-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-digest-local-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-local-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-microsoft-teams.sample-hello-message":[{"type":0,"value":"Hello, this is test message from Post Office: "},{"type":1,"value":"text"}],"post-office.test-message.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"},{"type":0,"value":"."}],"post-office.test-messages.test-message-config-sets.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-lifecycle-email-recipients.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-lifecycle.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a redacted test mobile push notification from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.greeting.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate":[{"type":0,"value":"Hello, this is a redacted mobile push notification test from post office."}],"post-office.test-messages.test-message-no-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-slack-experiment-exposure.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-slack-notification.sample-hello-message":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"product-store-personal-use-case.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}],"test-message.test-message-email-onboarding-test.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-message.test-message-email-onboarding-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-message.test-message-email-onboarding-test.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-message.test-message-email-onboarding-test.test-message.email.body.no-translate":[{"type":0,"value":"This is an test onboarding message for "},{"type":1,"value":"team"},{"type":0,"value":" team from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-message.test-message-email-onboarding-test.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-message.test-message-email-onboarding-test.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-message.test-message-email-onboarding-test.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.app-switcher-discovery-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-discovery-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.app-switcher-upgrade-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-upgrade-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.in-app-example.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.in-app-notification-comment-rollup.second-comment":[{"type":1,"value":"actor"},{"type":0,"value":" commented on a page"}],"test-messages.in-app-notification-mention-rollup.first-comment":[{"type":1,"value":"reactor"},{"type":0,"value":" mentioned you in a comment"}],"test-messages.in-app-notification-reaction-rollup.many-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"otherActorsCount"},{"type":0,"value":" others reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.one-actor":[{"type":1,"value":"actor1Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.two-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"actor2Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification.email-onboarding.body":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":", This is an onboarding test message for "},{"type":1,"value":"team"},{"type":0,"value":" team."}],"test-messages.in-app-notification.email-onboarding.title":[{"type":0,"value":"Welcome!"}],"test-messages.in-app-notification.title":[{"type":0,"value":"Test Notification "},{"type":1,"value":"title"}],"test-messages.jira-navigation-topbar-edition-awareness.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.redacted-email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate":[{"type":0,"value":"Post Office Redacted Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-client-generation.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-client-generation.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-client-generation.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-client-generation.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-client-generation.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-config-sets.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-config-sets.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-config-sets.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-config-sets.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-config-sets.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-config-sets.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-config-sets.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"Click here to visit Atlassian"}],"test-messages.test-message-config-sets.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-content-diffing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-content-diffing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-delivery-control.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-delivery-control.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.body.no-translate":[{"type":1,"value":"body"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.title.no-translate":[{"type":0,"value":"Template Notification "},{"type":1,"value":"title"}],"test-messages.test-message-delivery-control.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-delivery-control.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-delivery-control.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-delivery-control.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-delivery-control.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-local.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-local.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-local.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-local.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-cdn.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-cdn.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-cdn.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-cdn.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-cdn.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate":[{"type":0,"value":"Click me!"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-high-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-log-dropping.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-log-dropping.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-log-dropping.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-log-dropping.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-log-dropping.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-log-dropping.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-log-dropping.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-low-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-low-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-low-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-low-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-low-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-low-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-low-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-mfc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-mfc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate":[{"type":0,"value":"This is a redacted test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-grouped-recipients.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-grouped-recipients.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-grouped-recipients.test-message.email.body.hello":[{"type":0,"value":"Hello"}],"test-messages.test-message-grouped-recipients.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-grouped-recipients.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-comment-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-mention-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-reaction-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-lifecycle-email-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle-email-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-lifecycle.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Kind Regards,"}],"test-messages.test-message-lifecycle.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.heading.no-translate":[{"type":0,"value":"Origin Tracing \u2014 Tracked Link Test ("},{"type":1,"value":"env"},{"type":0,"value":")"}],"test-messages.test-message-link-tracking.email.intro.no-translate":[{"type":0,"value":"This email tests Post Office tracked links. Tracked links go through the Post Office redirect service; plain links do not. Click each link and inspect the redirect URL to verify origin tracing."}],"test-messages.test-message-link-tracking.email.tracked-link-atl-origin.no-translate":[{"type":0,"value":"TrackedLink with atlOrigin param"}],"test-messages.test-message-link-tracking.email.tracked-link-atlassian.no-translate":[{"type":0,"value":"TrackedLink to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.tracked-link-external.no-translate":[{"type":0,"value":"TrackedLink to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.tracked-link-pdf.no-translate":[{"type":0,"value":"TrackedLink to PDF"}],"test-messages.test-message-link-tracking.email.tracked-link-tenanted.no-translate":[{"type":0,"value":"TrackedLink to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.tracked-section.no-translate":[{"type":0,"value":"Tracked links"}],"test-messages.test-message-link-tracking.email.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.untracked-link-atl-origin.no-translate":[{"type":0,"value":"Plain link with atlOrigin param"}],"test-messages.test-message-link-tracking.email.untracked-link-atlassian.no-translate":[{"type":0,"value":"Plain link to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.untracked-link-external.no-translate":[{"type":0,"value":"Plain link to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.untracked-link-pdf.no-translate":[{"type":0,"value":"Plain link to PDF"}],"test-messages.test-message-link-tracking.email.untracked-link-tenanted.no-translate":[{"type":0,"value":"Plain link to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.untracked-section.no-translate":[{"type":0,"value":"Plain (untracked) links"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-marketing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-marketing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-marketing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-marketing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-message-failures.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-message-failures.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-nd-ni-influents-mapper.influents.message-main.no-translate":[{"type":0,"value":"Main line ("},{"type":1,"value":"text"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.action.no-translate":[{"type":0,"value":"Open ("},{"type":1,"value":"emoji"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.entity.no-translate":[{"type":0,"value":"Entity for "},{"type":1,"value":"team"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.path.no-translate":[{"type":0,"value":"Path ("},{"type":1,"value":"team"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.title.no-translate":[{"type":0,"value":"Team "},{"type":1,"value":"teamName"},{"type":0,"value":" update"}],"test-messages.test-message-no-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-no-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-no-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-no-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-no-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-no-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-no-tracking.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"This is a TrackedLink that isn\'t being tracked!"}],"test-messages.test-message-no-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-notifications-platform.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated your page"}],"test-messages.test-message-persona-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-persona-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-persona-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-persona-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-persona-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-persona-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate":[{"type":1,"value":"greeting"}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi,"}],"test-messages.test-message-raw-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-transform-metadata.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message.app.img.alt.large":[{"type":0,"value":"test image 2"}],"test-messages.test-message.app.img.alt.plant":[{"type":0,"value":"test image 1"}],"test-messages.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message.redacted-email.body":[{"type":0,"value":"This is the redacted version of the test email message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.redacted-email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.redacted-email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.redacted-email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.redacted-email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"wac-global-nav-product-recommendation.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}]}');

});

parcelRegister("6RUjk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8VyZW").then(()=>parcelRequire('fk5vy'));

});

parcelRegister("dDEsQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fpCVc").then(()=>parcelRequire('kPPHo'));

});

parcelRegister("iMVv6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("zKjQM").then(()=>parcelRequire('eUOi7'));

});

parcelRegister("8z9QI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f9PWz").then(()=>parcelRequire('laz4p'));

});

parcelRegister("9rboO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Lt1nQ").then(()=>parcelRequire('akk69'));

});

parcelRegister("epf51", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("01XB5").then(()=>parcelRequire('iArFN'));

});

parcelRegister("jwjvf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iiBtN").then(()=>parcelRequire('cXHYa'));

});

parcelRegister("eQJ91", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iTR30").then(()=>parcelRequire('bllm0'));

});

parcelRegister("i2ri1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8XGOi").then(()=>parcelRequire('aEI7c'));

});

parcelRegister("9hiLI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eBxhN").then(()=>parcelRequire('dKwDF'));

});

parcelRegister("jR2Wy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("du33e").then(()=>parcelRequire('i6R2Z'));

});

parcelRegister("cTkRM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ZBO0").then(()=>parcelRequire('9uHAX'));

});

parcelRegister("4RJdu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("47c7V").then(()=>parcelRequire('eDFXQ'));

});

parcelRegister("iIAZm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("714l3").then(()=>parcelRequire('9ZWh7'));

});

parcelRegister("ahLS0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ejPly").then(()=>parcelRequire('6BGCY'));

});

parcelRegister("1oP5V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aNJRs").then(()=>parcelRequire('bPQxm'));

});

parcelRegister("3uEuB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bDJYo").then(()=>parcelRequire('1H034'));

});

parcelRegister("lmdP3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9u3KY").then(()=>parcelRequire('d0uY6'));

});

parcelRegister("4aevu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gG87O").then(()=>parcelRequire('bniIt'));

});

parcelRegister("hg7sN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ePFLN").then(()=>parcelRequire('eYzTl'));

});

parcelRegister("1pTIW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("NPkjv").then(()=>parcelRequire('7iiVU'));

});

parcelRegister("5AHSV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jb59P").then(()=>parcelRequire('iVmtd'));

});

parcelRegister("8wgXB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("50c1C").then(()=>parcelRequire('f56Fy'));

});

parcelRegister("7UjYg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1xvEC").then(()=>parcelRequire('eZfJ3'));

});

parcelRegister("dBIkz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a6DNo").then(()=>parcelRequire('iCtsS'));

});

parcelRegister("039PZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aqdX8").then(()=>parcelRequire('jInoA'));

});

parcelRegister("lBPXk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k6tEe").then(()=>parcelRequire('fjRZr'));

});

parcelRegister("5B53g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gGIoQ").then(()=>parcelRequire('6R3RO'));

});

parcelRegister("crIoR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("WTVnu").then(()=>parcelRequire('4ry7B'));

});

parcelRegister("aUMsm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lF24G").then(()=>parcelRequire('7KQ3I'));

});

parcelRegister("5n8PJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jtTs5").then(()=>parcelRequire('7q8h2'));

});

parcelRegister("hWoVu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6tYH2").then(()=>parcelRequire('36KzP'));

});

parcelRegister("8Y6RM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7AYMz").then(()=>parcelRequire('jWKIk'));

});

parcelRegister("9mxl7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5xRWN").then(()=>parcelRequire('h3A0e'));

});


parcelRegister("lBMYS", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $a43a8533ea92e15b$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $i3lDY = parcelRequire("i3lDY");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a43a8533ea92e15b$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a43a8533ea92e15b$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("eqln5")));
        case 'da':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("6hAk5")));
        case 'de':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("7DOi3")));
        case 'en-GB':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("1xuIU")));
        case 'en-US':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("8qFeD")));
        case 'en-XA':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("7Zv3q")));
        case 'en-XB':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("cicXn")));
        case 'en-ZZ':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("9m59N")));
        case 'en':
            return $a43a8533ea92e15b$var$importHelper(await Promise.resolve((parcelRequire("i3lDY"))));
        case 'es':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("Yhf2R")));
        case 'et':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("1vBdo")));
        case 'fi':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("d49pL")));
        case 'fr':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("j2u06")));
        case 'hr':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("iwA9g")));
        case 'hu':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("f7RFW")));
        case 'it':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("ikbxx")));
        case 'ja':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("46ady")));
        case 'ko':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("i2XDT")));
        case 'nb':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("dmhQO")));
        case 'nl':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("ffThq")));
        case 'pl':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("bGZZc")));
        case 'pt-BR':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("jU4R7")));
        case 'ro':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("6Y44A")));
        case 'ru':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("eoT9N")));
        case 'sl':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("38Brv")));
        case 'sr-RS':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("dMiwB")));
        case 'sr-YR':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("cUPjf")));
        case 'sr':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("27rp0")));
        case 'sv':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("A5Pnm")));
        case 'th':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("gAnZs")));
        case 'tr':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("layGt")));
        case 'uk':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("9wjL5")));
        case 'vi':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("g8O80")));
        case 'zh-CN':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("7VU5p")));
        case 'zh-TW':
            return $a43a8533ea92e15b$var$importHelper(await (parcelRequire("bvds6")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($i3lDY));
    }
};

});
parcelRegister("i3lDY", function(module, exports) {
module.exports = JSON.parse("{\"confluence-integrations.project-pages-revamp-onboarding-spotlight.body\":[{\"type\":0,\"value\":\"Pages is now Docs. Access pages, live docs, and more, all from your space.\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.done-button\":[{\"type\":0,\"value\":\"Done\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.heading\":[{\"type\":0,\"value\":\"One place for all your project docs\"}]}");

});

parcelRegister("eqln5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ppny").then(()=>parcelRequire('k4VBO'));

});

parcelRegister("6hAk5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("28no5").then(()=>parcelRequire('6tdJw'));

});

parcelRegister("7DOi3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("agY6Q").then(()=>parcelRequire('kLkA7'));

});

parcelRegister("1xuIU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9eQZQ").then(()=>parcelRequire('8v9Kq'));

});

parcelRegister("8qFeD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9HzTE").then(()=>parcelRequire('97bPL'));

});

parcelRegister("7Zv3q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("616KP").then(()=>parcelRequire('kDsnu'));

});

parcelRegister("cicXn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5gvqv").then(()=>parcelRequire('88J6E'));

});

parcelRegister("9m59N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gF2Zo").then(()=>parcelRequire('7tAHq'));

});

parcelRegister("Yhf2R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dZ9EP").then(()=>parcelRequire('c3wpK'));

});

parcelRegister("1vBdo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7pdXB").then(()=>parcelRequire('UbHHv'));

});

parcelRegister("d49pL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("flozM").then(()=>parcelRequire('4rmZS'));

});

parcelRegister("j2u06", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2uJkS").then(()=>parcelRequire('axZVc'));

});

parcelRegister("iwA9g", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lUxIJ").then(()=>parcelRequire('4lj0g'));

});

parcelRegister("f7RFW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("SuCmh").then(()=>parcelRequire('es3hN'));

});

parcelRegister("ikbxx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3GFVH").then(()=>parcelRequire('a3jIq'));

});

parcelRegister("46ady", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j5FyT").then(()=>parcelRequire('fE4XT'));

});

parcelRegister("i2XDT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3T0L7").then(()=>parcelRequire('iip0L'));

});

parcelRegister("dmhQO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ibm59").then(()=>parcelRequire('ad4So'));

});

parcelRegister("ffThq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("16Lk9").then(()=>parcelRequire('6AHLj'));

});

parcelRegister("bGZZc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4G2Ml").then(()=>parcelRequire('jPHcY'));

});

parcelRegister("jU4R7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kj0kN").then(()=>parcelRequire('6X8M4'));

});

parcelRegister("6Y44A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hiryA").then(()=>parcelRequire('qQuUE'));

});

parcelRegister("eoT9N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bVF6j").then(()=>parcelRequire('fo43n'));

});

parcelRegister("38Brv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("OnGER").then(()=>parcelRequire('69h5d'));

});

parcelRegister("dMiwB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lkYsf").then(()=>parcelRequire('15VVX'));

});

parcelRegister("cUPjf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iBIXc").then(()=>parcelRequire('lQggx'));

});

parcelRegister("27rp0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lV0oV").then(()=>parcelRequire('5JjYC'));

});

parcelRegister("A5Pnm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9IXYc").then(()=>parcelRequire('adn0c'));

});

parcelRegister("gAnZs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8htx0").then(()=>parcelRequire('atMC1'));

});

parcelRegister("layGt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kFFuN").then(()=>parcelRequire('9vzjo'));

});

parcelRegister("9wjL5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1vHjk").then(()=>parcelRequire('8FSXs'));

});

parcelRegister("g8O80", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jxCsl").then(()=>parcelRequire('g0pHo'));

});

parcelRegister("7VU5p", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gjVib").then(()=>parcelRequire('4aGvU'));

});

parcelRegister("bvds6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fnyiQ").then(()=>parcelRequire('aQF2i'));

});


parcelRegister("9ZkjY", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $f75554bdd96dddb5$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3mBuK = parcelRequire("3mBuK");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f75554bdd96dddb5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $f75554bdd96dddb5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("WMANg")));
        case 'da':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("3PZ2A")));
        case 'de':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("7Snaf")));
        case 'en-GB':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("9zhcJ")));
        case 'en-US':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("k4TD0")));
        case 'en-XA':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("hISUB")));
        case 'en-XB':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("cSuaH")));
        case 'en-ZZ':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("c0u8M")));
        case 'en':
            return $f75554bdd96dddb5$var$importHelper(await Promise.resolve((parcelRequire("3mBuK"))));
        case 'es':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("gR6Xa")));
        case 'et':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("aysxe")));
        case 'fi':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("hrG33")));
        case 'fr':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("72xn1")));
        case 'hr':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("71uPU")));
        case 'hu':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("e7IyB")));
        case 'it':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("hXNSd")));
        case 'ja':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("8Ttzr")));
        case 'ko':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("63Mn2")));
        case 'nb':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("jlDLW")));
        case 'nl':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("xo376")));
        case 'pl':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("7LQfg")));
        case 'pt-BR':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("5dtGt")));
        case 'ro':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("eYdvw")));
        case 'ru':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("2Mgfu")));
        case 'sl':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("lj7EH")));
        case 'sr-RS':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("7hiqq")));
        case 'sr-YR':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("dyuOd")));
        case 'sr':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("j4SM6")));
        case 'sv':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("fp6um")));
        case 'th':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("co5Lg")));
        case 'tr':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("cZQAN")));
        case 'uk':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("8eBAj")));
        case 'vi':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("7HYNx")));
        case 'zh-CN':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("6kLe8")));
        case 'zh-TW':
            return $f75554bdd96dddb5$var$importHelper(await (parcelRequire("7dUpP")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3mBuK));
    }
};

});
parcelRegister("3mBuK", function(module, exports) {
module.exports = JSON.parse("{\"rovo-agents.scenario-onboarding.backButton\":[{\"type\":0,\"value\":\"Back\"}],\"rovo-agents.scenario-onboarding.doneButton\":[{\"type\":0,\"value\":\"Done\"}],\"rovo-agents.scenario-onboarding.gettingStarted\":[{\"type\":0,\"value\":\"Getting started with your agent\"}],\"rovo-agents.scenario-onboarding.nextButton\":[{\"type\":0,\"value\":\"Next\"}],\"rovo-agents.scenario-onboarding.startTour\":[{\"type\":0,\"value\":\"Start Tour\"}],\"rovo-agents.scenario-onboarding.step1Body\":[{\"type\":0,\"value\":\"Scenarios allow you to instruct your agent to do things differently depending on the situation.\"}],\"rovo-agents.scenario-onboarding.step1Headline\":[{\"type\":0,\"value\":\"Tune your agent to each situation\"}],\"rovo-agents.scenario-onboarding.step2Body\":[{\"type\":0,\"value\":\"Unlike scenarios, behavior is the instructions your agent always follows, no matter the situation.\"}],\"rovo-agents.scenario-onboarding.step2Headline\":[{\"type\":0,\"value\":\"Set your agent's traits and goals\"}],\"rovo-agents.scenario-onboarding.step3Body\":[{\"type\":0,\"value\":\"You can add knowledge to your agent's scenarios so it has the right information to answer prompts in each situation.\"}],\"rovo-agents.scenario-onboarding.step3Headline\":[{\"type\":0,\"value\":\"See what your agent knows\"}],\"rovo-agents.scenario-onboarding.step4Body\":[{\"type\":0,\"value\":\"You can add skills to your agent's scenarios so it can connect and take action across apps.\"}],\"rovo-agents.scenario-onboarding.step4Headline\":[{\"type\":0,\"value\":\"See what your agent can do\"}],\"rovo-agents.scenario-onboarding.stepIndicator\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");

});

parcelRegister("WMANg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hq4Jx").then(()=>parcelRequire('f2Xmr'));

});

parcelRegister("3PZ2A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gTaQz").then(()=>parcelRequire('89sna'));

});

parcelRegister("7Snaf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8XGwz").then(()=>parcelRequire('n2kjm'));

});

parcelRegister("9zhcJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fpQbX").then(()=>parcelRequire('71UNb'));

});

parcelRegister("k4TD0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aw9aF").then(()=>parcelRequire('jDGGR'));

});

parcelRegister("hISUB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bBaVi").then(()=>parcelRequire('3vqij'));

});

parcelRegister("cSuaH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("egKOS").then(()=>parcelRequire('jZ6aB'));

});

parcelRegister("c0u8M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("zfI4Y").then(()=>parcelRequire('8NJqz'));

});

parcelRegister("gR6Xa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cjNnh").then(()=>parcelRequire('7tTGY'));

});

parcelRegister("aysxe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kUYEL").then(()=>parcelRequire('2IoKy'));

});

parcelRegister("hrG33", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jWyW2").then(()=>parcelRequire('2eO9Z'));

});

parcelRegister("72xn1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aKHjn").then(()=>parcelRequire('3CeTY'));

});

parcelRegister("71uPU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1pc0H").then(()=>parcelRequire('c2RkU'));

});

parcelRegister("e7IyB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8wGs8").then(()=>parcelRequire('6lIR6'));

});

parcelRegister("hXNSd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fqvBt").then(()=>parcelRequire('czsAU'));

});

parcelRegister("8Ttzr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("77Znx").then(()=>parcelRequire('lxK1q'));

});

parcelRegister("63Mn2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("20fmX").then(()=>parcelRequire('gp7R7'));

});

parcelRegister("jlDLW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aA3pS").then(()=>parcelRequire('1Cckg'));

});

parcelRegister("xo376", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("68WN4").then(()=>parcelRequire('g0FdJ'));

});

parcelRegister("7LQfg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i5Egp").then(()=>parcelRequire('dtAo9'));

});

parcelRegister("5dtGt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2fLQd").then(()=>parcelRequire('iYaAG'));

});

parcelRegister("eYdvw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("au7Kk").then(()=>parcelRequire('e9iEC'));

});

parcelRegister("2Mgfu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cTojl").then(()=>parcelRequire('dX6fs'));

});

parcelRegister("lj7EH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hPc3o").then(()=>parcelRequire('k4MBs'));

});

parcelRegister("7hiqq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dBBDf").then(()=>parcelRequire('2H1x2'));

});

parcelRegister("dyuOd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1nZzF").then(()=>parcelRequire('7E3PA'));

});

parcelRegister("j4SM6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cfzZi").then(()=>parcelRequire('11lao'));

});

parcelRegister("fp6um", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ijQHY").then(()=>parcelRequire('4wuwD'));

});

parcelRegister("co5Lg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lWLs1").then(()=>parcelRequire('k65g5'));

});

parcelRegister("cZQAN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4WfRX").then(()=>parcelRequire('3QV9q'));

});

parcelRegister("8eBAj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aJbpc").then(()=>parcelRequire('2iSq5'));

});

parcelRegister("7HYNx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gAul8").then(()=>parcelRequire('eP5UR'));

});

parcelRegister("6kLe8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ibqGh").then(()=>parcelRequire('8VTE9'));

});

parcelRegister("7dUpP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fxj2T").then(()=>parcelRequire('7UZQz'));

});


parcelRegister("lyTFG", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $4fb435f8ba99bd3d$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2OVSU = parcelRequire("2OVSU");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4fb435f8ba99bd3d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4fb435f8ba99bd3d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("aTWXx")));
        case 'da':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("8CP6Y")));
        case 'de':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("iDHhH")));
        case 'en-GB':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("9X8jj")));
        case 'en-US':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("6xhUi")));
        case 'en-XA':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("kyxec")));
        case 'en-XB':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("cmYxB")));
        case 'en-ZZ':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("ajohg")));
        case 'en':
            return $4fb435f8ba99bd3d$var$importHelper(await Promise.resolve((parcelRequire("2OVSU"))));
        case 'es':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("kxXJf")));
        case 'et':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("jyciU")));
        case 'fi':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("3xHmV")));
        case 'fr':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("8dt9I")));
        case 'hr':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("cI5O6")));
        case 'hu':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("iczPM")));
        case 'it':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("ftDqP")));
        case 'ja':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("fooR6")));
        case 'ko':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("hpEsf")));
        case 'nb':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("kW3Cl")));
        case 'nl':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("1tSTn")));
        case 'pl':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("2yQkB")));
        case 'pt-BR':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("azems")));
        case 'ro':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("cU8PE")));
        case 'ru':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("4wsM9")));
        case 'sl':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("jbn3k")));
        case 'sr-RS':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("glc0f")));
        case 'sr-YR':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("aU1Id")));
        case 'sr':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("owiaX")));
        case 'sv':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("fIdzk")));
        case 'th':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("kBlRm")));
        case 'tr':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("gU2w6")));
        case 'uk':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("bxxBg")));
        case 'vi':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("4kulo")));
        case 'zh-CN':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("lEj7S")));
        case 'zh-TW':
            return $4fb435f8ba99bd3d$var$importHelper(await (parcelRequire("5AVYR")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2OVSU));
    }
};

});
parcelRegister("2OVSU", function(module, exports) {
module.exports = JSON.parse('{"post-office.rovo-chat-button.main-heading.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat-button.onboarding-heading":[{"type":0,"value":"Chat with Rovo AI"}],"post-office.rovo-chat-button.onboarding-input-placeholder-1":[{"type":0,"value":"Pick a conversation starter or ask Rovo anything"}],"post-office.rovo-chat-button.onboarding-input-placeholder-2":[{"type":0,"value":"Write a prompt"}],"post-office.rovo-chat-button.send-prompt":[{"type":0,"value":"Send prompt"}],"post-office.rovo-chat-recommended-spaces-spotlight.main-heading.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat-spaces-spotlight.main-heading.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.3p-connector-nudge.connect-button":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"post-office.rovo-chat.3p-connector-nudge.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.3p-connector-nudge.heading":[{"type":0,"value":"Your admin has added "},{"type":1,"value":"appName"}],"post-office.rovo-chat.3p-connector-nudge.logo-alt":[{"type":1,"value":"appName"},{"type":0,"value":" logo"}],"post-office.rovo-chat.3p-connector-nudge.subtitle":[{"type":0,"value":"Connect your account to see more results"}],"post-office.rovo-chat.browse-prompt-gallery-spotlight.body":[{"type":0,"value":"Explore a library of Rovo prompts you can plug into your everyday work, or create your own."}],"post-office.rovo-chat.browse-prompt-gallery-spotlight.headline":[{"type":0,"value":"Browse prompt library"}],"post-office.rovo-chat.long-running-task-fullpage-banner.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-fullpage-banner.cta-button":[{"type":0,"value":"Get a team summary"}],"post-office.rovo-chat.long-running-task-fullpage-banner.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.long-running-task-fullpage-banner.headline":[{"type":0,"value":"Meet Max. It handles everything."}],"post-office.rovo-chat.long-running-task-fullpage-banner.max-label":[{"type":0,"value":"Max"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta":[{"type":0,"value":"Awaiting user response"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta-timestamp":[{"type":0,"value":"1 minute ago"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-title":[{"type":0,"value":"Implement new authentication system"}],"post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-meta":[{"type":0,"value":"Just now"}],"post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-title":[{"type":0,"value":"New Policy Presentation"}],"post-office.rovo-chat.long-running-task-spotlight.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-spotlight.headline":[{"type":0,"value":"Say hi to Max"}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.headline":[{"type":0,"value":"Meet Max. It handles everything."}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.try-max-button":[{"type":0,"value":"Try Max"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.action":[{"type":0,"value":"See how"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.body":[{"type":0,"value":"Rovo now remembers facts and details from your chats to make responses more personalized and helpful"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.headline":[{"type":0,"value":"A more personalized Rovo"}],"post-office.rovo-chat.web-search-spotlight.body":[{"type":0,"value":"We\'re running an experiment to improve Rovo. For some users, web search is now on by default\u2014you can turn it off any time."}],"post-office.rovo-chat.web-search-spotlight.dismiss":[{"type":0,"value":"Turn off default web search"}],"post-office.rovo-chat.web-search-spotlight.headline":[{"type":0,"value":"Web search is now on by default"}],"rovo-chat.rovo-chat-scheduled-chat-recurring-chat-complete.message-template.notification-drawer.message":[{"type":0,"value":"Rovo has completed your scheduled query"}],"rovo-chat.rovo-chat-task-awaiting-user.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"Rovo is awaiting your response"}],"rovo-chat.rovo-chat-task-complete.message-template.notification-drawer.message":[{"type":0,"value":"Rovo has completed your task"}],"rovo-chat.rovo-chat-task-plan-generated.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"Rovo has generated your plan"}]}');

});

parcelRegister("aTWXx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jjyQW").then(()=>parcelRequire('6pU3L'));

});

parcelRegister("8CP6Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1Ro6Z").then(()=>parcelRequire('2Fgc7'));

});

parcelRegister("iDHhH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8UcF9").then(()=>parcelRequire('95Gxi'));

});

parcelRegister("9X8jj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c7NTF").then(()=>parcelRequire('f4dvw'));

});

parcelRegister("6xhUi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b9ADv").then(()=>parcelRequire('jkgPb'));

});

parcelRegister("kyxec", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k3Unk").then(()=>parcelRequire('8e6fm'));

});

parcelRegister("cmYxB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aMS1B").then(()=>parcelRequire('uZzD8'));

});

parcelRegister("ajohg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("izQgL").then(()=>parcelRequire('7YvuT'));

});

parcelRegister("kxXJf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iwd6X").then(()=>parcelRequire('flnJN'));

});

parcelRegister("jyciU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k7vVn").then(()=>parcelRequire('dZZhU'));

});

parcelRegister("3xHmV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5uK2X").then(()=>parcelRequire('k3vsn'));

});

parcelRegister("8dt9I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jmOUK").then(()=>parcelRequire('aEumF'));

});

parcelRegister("cI5O6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5GMaZ").then(()=>parcelRequire('huNY0'));

});

parcelRegister("iczPM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dU12Y").then(()=>parcelRequire('3feYD'));

});

parcelRegister("ftDqP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("03T0U").then(()=>parcelRequire('4II1n'));

});

parcelRegister("fooR6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("qGJlq").then(()=>parcelRequire('e7ePO'));

});

parcelRegister("hpEsf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jWSRw").then(()=>parcelRequire('107D7'));

});

parcelRegister("kW3Cl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("61DSb").then(()=>parcelRequire('1yS8H'));

});

parcelRegister("1tSTn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4ME4w").then(()=>parcelRequire('akxmS'));

});

parcelRegister("2yQkB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9yGGw").then(()=>parcelRequire('9Bm6U'));

});

parcelRegister("azems", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lzJdW").then(()=>parcelRequire('hnyJ3'));

});

parcelRegister("cU8PE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6wm5Y").then(()=>parcelRequire('lOHcL'));

});

parcelRegister("4wsM9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6QHaM").then(()=>parcelRequire('iHJAe'));

});

parcelRegister("jbn3k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jNIxl").then(()=>parcelRequire('51heu'));

});

parcelRegister("glc0f", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iQ5TN").then(()=>parcelRequire('gzEPv'));

});

parcelRegister("aU1Id", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bbPqP").then(()=>parcelRequire('4Gp3B'));

});

parcelRegister("owiaX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ajVaD").then(()=>parcelRequire('323Sr'));

});

parcelRegister("fIdzk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dHSea").then(()=>parcelRequire('7t3fj'));

});

parcelRegister("kBlRm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1NXK7").then(()=>parcelRequire('9M1U6'));

});

parcelRegister("gU2w6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("25Fpe").then(()=>parcelRequire('7j8Aw'));

});

parcelRegister("bxxBg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("31OvZ").then(()=>parcelRequire('mksMo'));

});

parcelRegister("4kulo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i5CpV").then(()=>parcelRequire('i9K9c'));

});

parcelRegister("lEj7S", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8zmOf").then(()=>parcelRequire('6mW1y'));

});

parcelRegister("5AVYR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e71VN").then(()=>parcelRequire('cq12a'));

});


parcelRegister("1WFMp", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $c2a24e7e7b30f4a8$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4sm3H = parcelRequire("4sm3H");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c2a24e7e7b30f4a8$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $c2a24e7e7b30f4a8$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("hUnmF")));
        case 'da':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("4Ekln")));
        case 'de':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("6G8I1")));
        case 'en-GB':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("7bsNu")));
        case 'en-US':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("53ZYG")));
        case 'en-XA':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("iNjnQ")));
        case 'en-XB':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("fSqjP")));
        case 'en-ZZ':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("8XYi4")));
        case 'en':
            return $c2a24e7e7b30f4a8$var$importHelper(await Promise.resolve((parcelRequire("4sm3H"))));
        case 'es':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("jqRuM")));
        case 'et':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("6l9vd")));
        case 'fi':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("3K2o6")));
        case 'fr':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("1C6da")));
        case 'hr':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("55uMe")));
        case 'hu':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("jMAeyR")));
        case 'it':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("bBtEL")));
        case 'ja':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("3fy37")));
        case 'ko':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("hNSwS")));
        case 'nb':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("6TF3A")));
        case 'nl':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("62Ud9")));
        case 'pl':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("bD0Oy")));
        case 'pt-BR':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("3lKQM")));
        case 'ro':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("iNhpq")));
        case 'ru':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("6RZJZ")));
        case 'sl':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("c0bZ6")));
        case 'sr-RS':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("gBKZS")));
        case 'sr-YR':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("kGafK")));
        case 'sr':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("dbSg0")));
        case 'sv':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("4LLcZ")));
        case 'th':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("gkmYX")));
        case 'tr':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("3debv")));
        case 'uk':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("hY6Cc")));
        case 'vi':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("2s26a")));
        case 'zh-CN':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("3SLaB")));
        case 'zh-TW':
            return $c2a24e7e7b30f4a8$var$importHelper(await (parcelRequire("42KJe")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4sm3H));
    }
};

});
parcelRegister("4sm3H", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("hUnmF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1SQI0").then(()=>parcelRequire('5xc30'));

});

parcelRegister("4Ekln", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4aem3").then(()=>parcelRequire('5k70D'));

});

parcelRegister("6G8I1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j30D4").then(()=>parcelRequire('czPix'));

});

parcelRegister("7bsNu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lzLhf").then(()=>parcelRequire('4lq4o'));

});

parcelRegister("53ZYG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iZIHr").then(()=>parcelRequire('3tDFV'));

});

parcelRegister("iNjnQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cHjFw").then(()=>parcelRequire('iFB89'));

});

parcelRegister("fSqjP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4edeX").then(()=>parcelRequire('hg2FR'));

});

parcelRegister("8XYi4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3bu15").then(()=>parcelRequire('4ngPA'));

});

parcelRegister("jqRuM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bZUMd").then(()=>parcelRequire('dHpcK'));

});

parcelRegister("6l9vd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4kRwk").then(()=>parcelRequire('lW4Pc'));

});

parcelRegister("3K2o6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ifWqX").then(()=>parcelRequire('joi71'));

});

parcelRegister("1C6da", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lOipX").then(()=>parcelRequire('3DNtn'));

});

parcelRegister("55uMe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7mrdN").then(()=>parcelRequire('4WRBy'));

});

parcelRegister("jMAeyR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9v4f6").then(()=>parcelRequire('2EkQi'));

});

parcelRegister("bBtEL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("75pfr").then(()=>parcelRequire('1InjD'));

});

parcelRegister("3fy37", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bx6lb").then(()=>parcelRequire('kVDmA'));

});

parcelRegister("hNSwS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bfNwg").then(()=>parcelRequire('48Ez4'));

});

parcelRegister("6TF3A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8eUlB").then(()=>parcelRequire('85JNz'));

});

parcelRegister("62Ud9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("53ojj").then(()=>parcelRequire('Expiz'));

});

parcelRegister("bD0Oy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("enBQv").then(()=>parcelRequire('a92cX'));

});

parcelRegister("3lKQM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8aypd").then(()=>parcelRequire('3RIOw'));

});

parcelRegister("iNhpq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("79qKs").then(()=>parcelRequire('1aw01'));

});

parcelRegister("6RZJZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e23Av").then(()=>parcelRequire('dI7Ba'));

});

parcelRegister("c0bZ6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7DQ41").then(()=>parcelRequire('5DAxg'));

});

parcelRegister("gBKZS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a6gkc").then(()=>parcelRequire('lmrrt'));

});

parcelRegister("kGafK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("efoSQ").then(()=>parcelRequire('cOGFQ'));

});

parcelRegister("dbSg0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("garSM").then(()=>parcelRequire('6k1gz'));

});

parcelRegister("4LLcZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lYqSG").then(()=>parcelRequire('4ymX3'));

});

parcelRegister("gkmYX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cME9P").then(()=>parcelRequire('8zCu3'));

});

parcelRegister("3debv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ldnz").then(()=>parcelRequire('1u8nt'));

});

parcelRegister("hY6Cc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3eJ8q").then(()=>parcelRequire('7uzM4'));

});

parcelRegister("2s26a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ewhQl").then(()=>parcelRequire('ecMWO'));

});

parcelRegister("3SLaB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g50c2").then(()=>parcelRequire('bzF85'));

});

parcelRegister("42KJe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4sFQV").then(()=>parcelRequire('iZEXW'));

});


parcelRegister("8zbRV", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $a184fd754d4e2b9a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bu8kB = parcelRequire("bu8kB");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a184fd754d4e2b9a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a184fd754d4e2b9a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("fTdtB")));
        case 'da':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("k32XE")));
        case 'de':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("5DP1k")));
        case 'en-GB':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("8qeHP")));
        case 'en-US':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("9NkTS")));
        case 'en-XA':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("5qztB")));
        case 'en-XB':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("5ciy5")));
        case 'en-ZZ':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("8jcyM")));
        case 'en':
            return $a184fd754d4e2b9a$var$importHelper(await Promise.resolve((parcelRequire("bu8kB"))));
        case 'es':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("heiND")));
        case 'et':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("4iN12")));
        case 'fi':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("kS732")));
        case 'fr':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("7r4Id")));
        case 'hr':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("3vlxU")));
        case 'hu':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("3Qc6f")));
        case 'it':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("45g7c")));
        case 'ja':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("9poNp")));
        case 'ko':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("6dJtk")));
        case 'nb':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("9qSZz")));
        case 'nl':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("1hreQ")));
        case 'pl':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("4QXL3")));
        case 'pt-BR':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("gox8l")));
        case 'ro':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("egAte")));
        case 'ru':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("5TkW4")));
        case 'sl':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("caLJF")));
        case 'sr-RS':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("hbe2Q")));
        case 'sr-YR':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("jfzMx")));
        case 'sr':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("dkRm0")));
        case 'sv':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("1LbXs")));
        case 'th':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("fy3Rm")));
        case 'tr':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("fBjr3")));
        case 'uk':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("5JOdt")));
        case 'vi':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("4ym4e")));
        case 'zh-CN':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("2rNPh")));
        case 'zh-TW':
            return $a184fd754d4e2b9a$var$importHelper(await (parcelRequire("7gfim")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bu8kB));
    }
};

});
parcelRegister("bu8kB", function(module, exports) {
module.exports = JSON.parse("{\"shared-user-preferences-onboarding.modal.alternative-text\":[{\"type\":0,\"value\":\"Alternatively, you can choose light or dark mode from the \"},{\"children\":[{\"type\":0,\"value\":\"Appearance\"}],\"type\":8,\"value\":\"appearanceSettings\"},{\"type\":0,\"value\":\" settings in your profile menu.\"}],\"shared-user-preferences-onboarding.modal.button.accept\":[{\"type\":0,\"value\":\"Okay\"}],\"shared-user-preferences-onboarding.modal.button.choose-theme\":[{\"type\":0,\"value\":\"Choose mode\"}],\"shared-user-preferences-onboarding.modal.button.close\":[{\"type\":0,\"value\":\"Close modal\"}],\"shared-user-preferences-onboarding.modal.description\":[{\"type\":0,\"value\":\"All supported apps will now match your system's display mode by default.\"}],\"shared-user-preferences-onboarding.modal.feature.consistent\":[{\"type\":0,\"value\":\"Consistent look and feel\"}],\"shared-user-preferences-onboarding.modal.feature.override\":[{\"type\":0,\"value\":\"Choose display mode for individual apps\"}],\"shared-user-preferences-onboarding.modal.feature.set-once\":[{\"type\":0,\"value\":\"Only set your display mode once\"}],\"shared-user-preferences-onboarding.modal.title\":[{\"type\":0,\"value\":\"Your display mode is now synced\"}]}");

});

parcelRegister("fTdtB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ytjx").then(()=>parcelRequire('1YPdp'));

});

parcelRegister("k32XE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9eL3d").then(()=>parcelRequire('8Rk96'));

});

parcelRegister("5DP1k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lFvEE").then(()=>parcelRequire('bHuZk'));

});

parcelRegister("8qeHP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ii3Zo").then(()=>parcelRequire('l2YUU'));

});

parcelRegister("9NkTS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gxtNI").then(()=>parcelRequire('7gkqt'));

});

parcelRegister("5qztB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cPwFY").then(()=>parcelRequire('fJkH9'));

});

parcelRegister("5ciy5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2SQFS").then(()=>parcelRequire('45Sak'));

});

parcelRegister("8jcyM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fCrS8").then(()=>parcelRequire('bbUrF'));

});

parcelRegister("heiND", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jlfwe").then(()=>parcelRequire('4alc9'));

});

parcelRegister("4iN12", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6nWZg").then(()=>parcelRequire('axlyI'));

});

parcelRegister("kS732", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kB82c").then(()=>parcelRequire('f55KU'));

});

parcelRegister("7r4Id", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2eu7S").then(()=>parcelRequire('1s3O3'));

});

parcelRegister("3vlxU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a1DRB").then(()=>parcelRequire('j7YpF'));

});

parcelRegister("3Qc6f", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("35dPQ").then(()=>parcelRequire('9qC1e'));

});

parcelRegister("45g7c", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jyvlC").then(()=>parcelRequire('f5a4u'));

});

parcelRegister("9poNp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j3hWD").then(()=>parcelRequire('5LEui'));

});

parcelRegister("6dJtk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e4YCq").then(()=>parcelRequire('jxo6A'));

});

parcelRegister("9qSZz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("09QB2").then(()=>parcelRequire('9aY13'));

});

parcelRegister("1hreQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3H8YI").then(()=>parcelRequire('7KTd6'));

});

parcelRegister("4QXL3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3bmkl").then(()=>parcelRequire('9786p'));

});

parcelRegister("gox8l", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("nNYDx").then(()=>parcelRequire('jjRWQ'));

});

parcelRegister("egAte", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aPfB5").then(()=>parcelRequire('39Cdq'));

});

parcelRegister("5TkW4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("crIJf").then(()=>parcelRequire('jJ7yU'));

});

parcelRegister("caLJF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kAafG").then(()=>parcelRequire('d1ecP'));

});

parcelRegister("hbe2Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fpPFp").then(()=>parcelRequire('l4pq4'));

});

parcelRegister("jfzMx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cSorv").then(()=>parcelRequire('czGH2'));

});

parcelRegister("dkRm0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8wkus").then(()=>parcelRequire('aQYsM'));

});

parcelRegister("1LbXs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("uRlfd").then(()=>parcelRequire('aMLvN'));

});

parcelRegister("fy3Rm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5NZwe").then(()=>parcelRequire('2ZCgE'));

});

parcelRegister("fBjr3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6kefi").then(()=>parcelRequire('9zSD5'));

});

parcelRegister("5JOdt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8gYZw").then(()=>parcelRequire('ifhYE'));

});

parcelRegister("4ym4e", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dmTmt").then(()=>parcelRequire('aNExr'));

});

parcelRegister("2rNPh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j5ACX").then(()=>parcelRequire('1ciuO'));

});

parcelRegister("7gfim", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ggkdQ").then(()=>parcelRequire('6vcA9'));

});


parcelRegister("iWdVz", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $fed047bc949bfb66$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2OfaM = parcelRequire("2OfaM");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fed047bc949bfb66$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $fed047bc949bfb66$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("ye6F0")));
        case 'da':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("9C9ye")));
        case 'de':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("aPw3K")));
        case 'en-GB':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("brMHM")));
        case 'en-US':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("5MJdZ")));
        case 'en-XA':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("3HddB")));
        case 'en-XB':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("5xrUm")));
        case 'en-ZZ':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("jTeJ7")));
        case 'en':
            return $fed047bc949bfb66$var$importHelper(await Promise.resolve((parcelRequire("2OfaM"))));
        case 'es':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("iYU23")));
        case 'et':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("5LpWG")));
        case 'fi':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("g7zNr")));
        case 'fr':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("8tOzh")));
        case 'hr':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("WfdLo")));
        case 'hu':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("1sal2")));
        case 'it':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("8uaGV")));
        case 'ja':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("5pP8h")));
        case 'ko':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("dKmSe")));
        case 'nb':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("j2Zyo")));
        case 'nl':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("e9PL5")));
        case 'pl':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("lu6Cu")));
        case 'pt-BR':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("eCxRK")));
        case 'ro':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("bcCLk")));
        case 'ru':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("8gICA")));
        case 'sl':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("2hPGE")));
        case 'sr-RS':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("6BEiW")));
        case 'sr-YR':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("l4FjY")));
        case 'sr':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("cdaQ7")));
        case 'sv':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("79vHA")));
        case 'th':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("jIMc7")));
        case 'tr':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("fQYJb")));
        case 'uk':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("l9ymM")));
        case 'vi':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("gR9oy")));
        case 'zh-CN':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("3HIKQ")));
        case 'zh-TW':
            return $fed047bc949bfb66$var$importHelper(await (parcelRequire("fIrSX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2OfaM));
    }
};

});
parcelRegister("2OfaM", function(module, exports) {
module.exports = JSON.parse('{"jsm-nebula-kb-suggested-topic.multiple.button.primary":[{"type":0,"value":"View suggestions"}],"jsm-nebula-kb-suggested-topic.notification.subtitle":[{"type":0,"value":"These suggestions are for "},{"type":1,"value":"projectName"}],"jsm-nebula-kb-suggested-topic.notification.title":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new article suggestion for your knowledge base"}]},"other":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new article suggestions for your knowledge base"}]}},"pluralType":"cardinal","type":6,"value":"numSuggestions"}],"jsm-nebula-kb-suggested-topic.notification.title.legacy":[{"type":0,"value":"You have "},{"type":1,"value":"numSuggestions"},{"type":0,"value":" new article suggestions for your knowledge base"}],"jsm-nebula-kb-suggested-topic.single.button.primary":[{"type":0,"value":"View suggestion"}],"jsm-nebula-kb-suggested-topic.singletopic.notification.subtitle":[{"type":0,"value":"This suggestion is for "},{"type":1,"value":"projectName"}],"jsm-nebula-kb-suggested-topic.singletopic.notification.title":[{"type":0,"value":"You have a new article suggestion for your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.add-knowledge-from-third-party-apps":[{"type":0,"value":"Add knowledge from third-party apps"}],"jsm-nebula.jsm-kb-activation-reminder.boost-agent-productivity":[{"type":0,"value":"Boost agent productivity"}],"jsm-nebula.jsm-kb-activation-reminder.create-or-link-articles":[{"type":0,"value":"Create or link articles."}],"jsm-nebula.jsm-kb-activation-reminder.empower-customers-with-instant-access":[{"type":0,"value":"Empower customers with instant access to helpful articles"}],"jsm-nebula.jsm-kb-activation-reminder.get-started-button-label":[{"type":0,"value":"Get started"}],"jsm-nebula.jsm-kb-activation-reminder.getting-started-is-easy":[{"type":0,"value":"Getting started is easy"}],"jsm-nebula.jsm-kb-activation-reminder.greeting-message":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-nebula.jsm-kb-activation-reminder.header.text":[{"type":0,"value":"Say goodbye to knowledge silos"}],"jsm-nebula.jsm-kb-activation-reminder.how-to-set-up-your-knowledge-base":[{"type":0,"value":"How to set up your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.illustration.alt":[{"type":0,"value":"KnowledgeBase Illustration"}],"jsm-nebula.jsm-kb-activation-reminder.improve-ai-powered-suggestions":[{"type":0,"value":"Improve AI-powered suggestions"}],"jsm-nebula.jsm-kb-activation-reminder.improve-knowledge-base-health-by-closing-knowledge-gaps":[{"type":0,"value":"Improve knowledge base health by closing knowledge gaps."}],"jsm-nebula.jsm-kb-activation-reminder.knowledge-base-benefit":[{"type":0,"value":"By setting up a knowledge base, you can provide instant answers to your customers, reduce repetitive requests, and help your team resolve requests faster."}],"jsm-nebula.jsm-kb-activation-reminder.knowledge-base-help":[{"type":0,"value":"Adding knowledge to your Jira Service Management project helps:"}],"jsm-nebula.jsm-kb-activation-reminder.message-template.email.subject":[{"type":0,"value":"[Jira Service Management] Set up your knowledge base today"}],"jsm-nebula.jsm-kb-activation-reminder.need-help-explore-these-resources":[{"type":0,"value":"Need help? Explore these resources"}],"jsm-nebula.jsm-kb-activation-reminder.privacy-policy":[{"type":0,"value":"Privacy policy"}],"jsm-nebula.jsm-kb-activation-reminder.project-notice":[{"type":0,"value":"We noticed your Jira Service Management project, "},{"children":[{"type":1,"value":"project"}],"type":8,"value":"b"},{"type":0,"value":", doesn\'t have a knowledge base yet."}],"jsm-nebula.jsm-kb-activation-reminder.sent-to-you-by-atlassian-jira-service-management":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management  \u2022"}],"jsm-nebula.jsm-kb-activation-reminder.share-them-with-your-team-and-customers":[{"type":0,"value":"Share them with your team and customers."}],"jsm-nebula.jsm-kb-activation-reminder.start-building-your-knowledge-base":[{"type":0,"value":"Start building your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.stay-notified-and-comment-on-the-go-with-jira-mobile-app":[{"type":0,"value":"Stay notified and comment on the go with Jira Mobile App"}],"jsm-nebula.jsm-kb-activation-reminder.subheading":[{"type":0,"value":"Set up knowledge base to keep requests and knowledge within Jira Service Management."}],"jsm-nebula.jsm-kb-activation-reminder.surface-instant-answers-deflect-requests-and-keep-everything-in-one-place":[{"type":0,"value":"Surface instant answers, deflect requests, and keep everything in one place"}],"jsm-nebula.jsm-kb-activation-reminder.tips-for-writing-effective-knowledge-articles":[{"type":0,"value":"Tips for writing effective knowledge articles"}],"jsm-nebula.jsm-kb-activation-reminder.to-build-your-knowledge-base":[{"type":0,"value":"To build your knowledge base, all you need to do is:"}],"jsm-nebula.jsm-kb-activation-reminder.to-customize-email-or-unsubscribe":[{"type":0,"value":"To customize the email or unsubscribe, "}],"jsm-nebula.jsm-kb-activation-reminder.update-your-notification-settings":[{"type":0,"value":"update your notification settings."}],"jsm-nebula.jsm-kb-activation-reminder.why-set-up-knowledge-base":[{"type":0,"value":"Why set up a knowledge base?"}],"jsm-nebula.solcom-create-space-spotlight.action":[{"type":0,"value":"Get started"}],"jsm-nebula.solcom-create-space-spotlight.body":[{"type":0,"value":"Tell Rovo what you need in plain language and it\'ll build the space for you."}],"jsm-nebula.solcom-create-space-spotlight.headline":[{"type":0,"value":"Support teams faster with Rovo"}]}');

});

parcelRegister("ye6F0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cst0H").then(()=>parcelRequire('5fNn2'));

});

parcelRegister("9C9ye", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("26vsZ").then(()=>parcelRequire('8rQoP'));

});

parcelRegister("aPw3K", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hZu9A").then(()=>parcelRequire('8v86J'));

});

parcelRegister("brMHM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lqVVr").then(()=>parcelRequire('frlON'));

});

parcelRegister("5MJdZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b1Tzt").then(()=>parcelRequire('h5yGJ'));

});

parcelRegister("3HddB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l0S1J").then(()=>parcelRequire('7DKOc'));

});

parcelRegister("5xrUm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9kih1").then(()=>parcelRequire('9Xc5n'));

});

parcelRegister("jTeJ7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aIkdK").then(()=>parcelRequire('7QMW5'));

});

parcelRegister("iYU23", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iihi8").then(()=>parcelRequire('iS5Zz'));

});

parcelRegister("5LpWG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7nNti").then(()=>parcelRequire('kNtFw'));

});

parcelRegister("g7zNr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8T3SD").then(()=>parcelRequire('h0rKN'));

});

parcelRegister("8tOzh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cT6Yi").then(()=>parcelRequire('3pm1U'));

});

parcelRegister("WfdLo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5Kjcw").then(()=>parcelRequire('akJJH'));

});

parcelRegister("1sal2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7TOpb").then(()=>parcelRequire('3rPX8'));

});

parcelRegister("8uaGV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3l2ms").then(()=>parcelRequire('jb8uB'));

});

parcelRegister("5pP8h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fAwqE").then(()=>parcelRequire('gdqLD'));

});

parcelRegister("dKmSe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fxz7p").then(()=>parcelRequire('j7Piu'));

});

parcelRegister("j2Zyo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("245zI").then(()=>parcelRequire('1vtzi'));

});

parcelRegister("e9PL5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2tkBi").then(()=>parcelRequire('1WnJm'));

});

parcelRegister("lu6Cu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kP79E").then(()=>parcelRequire('ieVmM'));

});

parcelRegister("eCxRK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ckuAp").then(()=>parcelRequire('ki3Sc'));

});

parcelRegister("bcCLk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("knGRT").then(()=>parcelRequire('2ZtJt'));

});

parcelRegister("8gICA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dG9qH").then(()=>parcelRequire('34AUV'));

});

parcelRegister("2hPGE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("izkCa").then(()=>parcelRequire('2IMMI'));

});

parcelRegister("6BEiW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d0Rju").then(()=>parcelRequire('bLBCX'));

});

parcelRegister("l4FjY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Q898").then(()=>parcelRequire('dercI'));

});

parcelRegister("cdaQ7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("awrty").then(()=>parcelRequire('dbpnQ'));

});

parcelRegister("79vHA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b6Wp0").then(()=>parcelRequire('b2H8Y'));

});

parcelRegister("jIMc7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hAugp").then(()=>parcelRequire('6f6hJ'));

});

parcelRegister("fQYJb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("oNyax").then(()=>parcelRequire('1kn5h'));

});

parcelRegister("l9ymM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8QKIi").then(()=>parcelRequire('hTkGA'));

});

parcelRegister("gR9oy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("pV8bY").then(()=>parcelRequire('lLhMo'));

});

parcelRegister("3HIKQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ioYeN").then(()=>parcelRequire('pJ5c6'));

});

parcelRegister("fIrSX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5qCW2").then(()=>parcelRequire('hfBNj'));

});


parcelRegister("3ozRQ", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $a1db28a5bb3bc470$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $lC215 = parcelRequire("lC215");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a1db28a5bb3bc470$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a1db28a5bb3bc470$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("fQFz1")));
        case 'da':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("37lV4")));
        case 'de':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("hflAM")));
        case 'en-GB':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("bh1FY")));
        case 'en-US':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("1I62A")));
        case 'en-XA':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("fAM4o")));
        case 'en-XB':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("faD3Y")));
        case 'en-ZZ':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("iutdP")));
        case 'en':
            return $a1db28a5bb3bc470$var$importHelper(await Promise.resolve((parcelRequire("lC215"))));
        case 'es':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("a95rx")));
        case 'et':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("6jYQH")));
        case 'fi':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("8JYWf")));
        case 'fr':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("caaJk")));
        case 'hr':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("9IXWt")));
        case 'hu':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("fN3AC")));
        case 'it':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("eaXzh")));
        case 'ja':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("2S1Om")));
        case 'ko':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("gpo57")));
        case 'nb':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("aw8vM")));
        case 'nl':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("jUUm9")));
        case 'pl':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("kx2bl")));
        case 'pt-BR':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("6HGjq")));
        case 'ro':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("cgk2s")));
        case 'ru':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("bnWO7")));
        case 'sl':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("g9VxV")));
        case 'sr-RS':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("9g5nu")));
        case 'sr-YR':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("6waeI")));
        case 'sr':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("8iZnS")));
        case 'sv':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("4RgTX")));
        case 'th':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("fzlTD")));
        case 'tr':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("9Sy4J")));
        case 'uk':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("2D7Kf")));
        case 'vi':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("fg96n")));
        case 'zh-CN':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("hS2MK")));
        case 'zh-TW':
            return $a1db28a5bb3bc470$var$importHelper(await (parcelRequire("gdjCt")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lC215));
    }
};

});
parcelRegister("lC215", function(module, exports) {
module.exports = JSON.parse('{"post-office.stakeholder-comms-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"stakeholder-comms-confirm-add-subscriber-email.email-events-list.no-translate":[{"type":0,"value":"You will now receive emails whenever:"}],"stakeholder-comms-confirm-add-subscriber-email.endpoint-info.no-translate":[{"type":0,"value":"View Status page"}],"stakeholder-comms-confirm-add-subscriber-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-confirm-add-subscriber-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-confirm-add-subscriber-email.list-item.incident-resolved.no-translate":[{"type":0,"value":"An incident is resolved"}],"stakeholder-comms-confirm-add-subscriber-email.list-item.service-outage.no-translate":[{"type":0,"value":"A service outage or degradation occurs"}],"stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Added as subscriber to status page updates"}],"stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-with-page-name.no-translate":[{"type":0,"value":"Added as subscriber to "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status updates"}],"stakeholder-comms-confirm-add-subscriber-email.title-message.email.title.no-translate":[{"type":0,"value":"You have been added as a subscriber"}],"stakeholder-comms-confirm-add-subscriber-email.webhook-added.no-translate":[{"type":0,"value":"The admin has successfully added you as a subscriber to "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page."}],"stakeholder-comms-webhook-notification-confirmation-email.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-notification-confirmation-email.endpoint-info.no-translate":[{"type":0,"value":"The endpoint "},{"type":1,"value":"webhookEndpointUrl"},{"type":0,"value":" is now set to receive updates. "}],"stakeholder-comms-webhook-notification-confirmation-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-notification-confirmation-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-notification-confirmation-email.greeting.no-translate":[{"type":0,"value":"Hi there,"}],"stakeholder-comms-webhook-notification-confirmation-email.title-message.email.title.no-translate":[{"type":0,"value":"Webhook subscription activated"}],"stakeholder-comms-webhook-notification-confirmation-email.webhook-added.no-translate":[{"type":0,"value":"We\'ve added your webhook subscription for "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page."}],"stakeholder-comms-webhook-notification-delivery-failure.deactivation-reason.no-translate":[{"type":0,"value":" has been deactivated because we couldn\'t deliver notifications to it. This endpoint was previously reachable, but it\'s now returning errors or is unreachable."}],"stakeholder-comms-webhook-notification-delivery-failure.endpoint-deactivated.no-translate":[{"type":0,"value":"Your endpoint "},{"type":1,"value":"webhookEndpointUrl"}],"stakeholder-comms-webhook-notification-delivery-failure.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-notification-delivery-failure.footer-message-url.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-notification-delivery-failure.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-notification-delivery-failure.resubscribe-message.no-translate":[{"type":0,"value":"To continue receiving updates, resubscribe to your endpoint."}],"stakeholder-comms-webhook-notification-delivery-failure.title-message.email.title.no-translate":[{"type":0,"value":"Webhook subscription deactivated"}],"stakeholder-comms-webhook-validation-failure.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-validation-failure.endpoint-unreachable.no-translate":[{"type":0,"value":"The endpoint "},{"type":1,"value":"webhookEndpointUrl"},{"type":0,"value":" could not be reached or did not respond."}],"stakeholder-comms-webhook-validation-failure.footer-message-url.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-validation-failure.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-validation-failure.title-message.email.title.no-translate":[{"type":0,"value":"Endpoint validation failed"}],"stakeholder-comms-webhook-validation-failure.webhook-validation-error.no-translate":[{"type":0,"value":"We couldn\'t notify your webhook for "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page updates."}],"status-page.create-component-details.spotlight.got-it":[{"type":0,"value":"Ok, got it"}],"status-page.create-component.spotlight.action":[{"type":0,"value":"Dismiss"}],"status-page.create-component.spotlight.primary-action":[{"type":0,"value":"Next"}],"status-page.create-component.spotlight.step1.body":[{"type":0,"value":"Customize each component and link it to a service"}],"status-page.create-component.spotlight.step1.heading":[{"type":0,"value":"Add component"}],"status-page.create-component.spotlight.step2.body":[{"type":0,"value":"Organize your components by adding them to specific groups."}],"status-page.create-component.spotlight.step2.heading":[{"type":0,"value":"Group components"}],"status-page.create-component.spotlight.step3.body":[{"type":0,"value":"Add multiple components and groups for better structure and clarity."}],"status-page.create-component.spotlight.step3.heading":[{"type":0,"value":"Manage and organize"}],"status-page.details.actions.spotlight.body":[{"type":0,"value":"Easily manage your status page, edit details and post updates to keep your audience informed."}],"status-page.details.actions.spotlight.got-it":[{"type":0,"value":"Ok, got it"}],"status-page.details.actions.spotlight.heading":[{"type":0,"value":"Update and manage"}],"status-page.details.tabs.spotlight.action":[{"type":0,"value":"Dismiss"}],"status-page.details.tabs.spotlight.body":[{"type":0,"value":"Review your status page, target audience, and post real-time incident updates, all from a single place."}],"status-page.details.tabs.spotlight.body.line1":[{"type":0,"value":"Review your status page, target"}],"status-page.details.tabs.spotlight.body.line2":[{"type":0,"value":"audience, and post real-time incident"}],"status-page.details.tabs.spotlight.body.line3":[{"type":0,"value":"updates, all from a single place."}],"status-page.details.tabs.spotlight.heading":[{"type":0,"value":"All at a glance"}],"status-page.details.tabs.spotlight.primary-action":[{"type":0,"value":"Next"}],"statuspage.actions-spotlight.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"statuspage.appearance-spotlight.action":[{"type":0,"value":"Ok, got it"}],"statuspage.appearance-spotlight.body":[{"type":0,"value":"Customize with additional flexibility and advanced styling."}],"statuspage.appearance-spotlight.heading":[{"type":0,"value":"Switch to CSS view"}],"statuspage.confirm-incident-notifications.button.verify-email.no-translate":[{"type":0,"value":"Confirm subscription"}],"statuspage.confirm-incident-notifications.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.confirm-incident-notifications.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.confirm-incident-notifications.list-item.incident-resolved.no-translate":[{"type":0,"value":"An incident is resolved"}],"statuspage.confirm-incident-notifications.list-item.scheduled-maintenance.no-translate":[{"type":0,"value":"Scheduled maintenance is announced"}],"statuspage.confirm-incident-notifications.list-item.service-outage.no-translate":[{"type":0,"value":"A service outage or degradation occurs"}],"statuspage.confirm-incident-notifications.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Confirm your email to subscribe to status page updates"}],"statuspage.confirm-incident-notifications.message-template.email.subject-with-page-name.no-translate":[{"type":0,"value":"Confirm your email to subscribe to "},{"type":1,"value":"pageName"},{"type":0,"value":" status updates"}],"statuspage.confirm-incident-notifications.test-message.email.body-hello.no-translate":[{"type":0,"value":"Hi there,"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Please confirm your email address to start receiving incident and maintenance notifications."},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Once confirmed, you\u2019ll receive emails whenever:"}],"statuspage.confirm-incident-notifications.title-message.email.title.no-translate":[{"type":0,"value":"Confirm your subscription"}],"statuspage.create-component-spotlight.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"statuspage.edit-spotlight.action":[{"type":0,"value":"Done"}],"statuspage.edit-spotlight.body":[{"type":0,"value":"Customize your status page to match your brand. Add the components you need and personalize the look and feel with brand new colours and themes."}],"statuspage.edit-spotlight.heading":[{"type":0,"value":"Status page created! Set it up in a few simple steps."}],"statuspage.navigation-spotlight.action":[{"type":0,"value":"About status pages"}],"statuspage.navigation-spotlight.body":[{"type":0,"value":"Post real-time updates and customize your status pages directly from here, without switching platforms."}],"statuspage.navigation-spotlight.heading":[{"type":0,"value":"Create and manage status pages"}],"statuspage.stakeholder-comms-archive-email.title.no-translate":[{"type":0,"value":"Your status page is archived and will be deleted in 60 days."}],"statuspage.stakeholder-comms-archive-page-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-archive-page-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-archive-page-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Details of the status page"}],"statuspage.stakeholder-comms-archive-page-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Atlassian Logo"}],"statuspage.stakeholder-comms-archive-page-email.message-template.email.subject.no-translate":[{"type":0,"value":"Status page archived"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Archived on"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"archivedOn"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"URL"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"pageUrl"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time-title.no-translate":[{"type":0,"value":"Permanent deletion date"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time.no-translate":[{"type":1,"value":"deletionDate"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'ve received your request to archive the status page. This status page will be automatically deleted in 60 days"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"If you wish to restore it, you can do so within the next 60 days"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-page-restored-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-page-restored-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-page-restored-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Details of the status page"}],"statuspage.stakeholder-comms-page-restored-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Atlassian Logo"}],"statuspage.stakeholder-comms-page-restored-email.message-template.email.subject.no-translate":[{"type":0,"value":"Status page restored"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Archived on"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"archivedOn"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"URL"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"pageUrl"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'ve received your request to restore the status page. You can now edit the page and post any updates as needed."}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"You can publish the page when you\'re ready to make it accessible to all subscribers."}],"statuspage.stakeholder-comms-page-restored-email.title.no-translate":[{"type":0,"value":"Your status page has been restored"}],"statuspage.stakeholder-comms-sender-test.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-sender-test.footer-message.email.body":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-sender-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-sender-test.test-message.email.body.no-translate":[{"type":0,"value":"Thanks for subscribing to pageName status updates. You\'re almost done - we just need to confirm your subscription."}],"statuspage.stakeholder-comms-sender-test.test-message.email.link-body.no-translate":[{"type":0,"value":"In order to activate your subscription, please click the following link:"}],"statuspage.stakeholder-comms-sender-test.title-message.email.title":[{"type":0,"value":"Confirm your subscription."}],"statuspage.stakeholder-comms-subscriber-incident-status-email.affected-components.and-more.no-translate":[{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.button.view-status-page.no-translate":[{"type":0,"value":"View Status page"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-unsubscribe-url.email.email.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Incident details"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Status page Incident: "},{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-with-page-name.no-translate":[{"type":1,"value":"pageName"},{"type":0,"value":" Incident: "},{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components-title.no-translate":[{"type":0,"value":"Affected components"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components.no-translate":[{"type":1,"value":"affectedComponentsString"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Details"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"incidentDescription"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"Status"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"incidentStatus"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time-title.no-translate":[{"type":0,"value":"Time posted"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time.no-translate":[{"type":1,"value":"timePosted"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'re investigating issues reported on the "},{"type":1,"value":"pageNameText"},{"type":0,"value":"status page. Here are the details:"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"You received this email because you subscribed to incident updates for "},{"type":1,"value":"pageNameText"},{"type":0,"value":"."}],"statuspage.stakeholder-comms-subscriber-incident-status-email.title-message.email.title.no-translate":[{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-user-added-verify-email.button.verify-email":[{"type":0,"value":"Verify your email"}],"statuspage.stakeholder-comms-user-added-verify-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-user-added-verify-email.footer-message.email.body":[{"type":0,"value":"This email was sent by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-user-added-verify-email.message-template.email.subject.no-translate":[{"type":0,"value":"[Action required] Verify your email to join "},{"type":1,"value":"siteName"},{"type":0,"value":"\'s site as a stakeholder on "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message1.email.body":[{"type":0,"value":"Know about disruptions that affect operations"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message2.email.body":[{"type":0,"value":"Make better decisions as you\u2019re always informed"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message3.email.body":[{"type":0,"value":"Get notified about the health and status of key services"}],"statuspage.stakeholder-comms-user-added-verify-email.table-title-message.email.title":[{"type":0,"value":"Stay in the loop always"}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body1.no-translate":[{"type":1,"value":"adminName"},{"type":0,"value":" has invited you to join their Jira Service Management site, "},{"type":1,"value":"siteName"},{"type":0,"value":", as a stakeholder."}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body2.no-translate":[{"type":0,"value":"Once you verify your email, you\'ll start receiving important notifications about incidents and changes directly to your inbox."}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body3.no-translate":[{"type":0,"value":"To receive updates on incidents communications, verify your email now!"}],"statuspage.stakeholder-comms-user-added-verify-email.title-message.email.title":[{"type":0,"value":"You\u2019ve been invited to join "},{"type":1,"value":"siteName"},{"type":0,"value":" as a stakeholder"}],"statuspage.stakeholder-comms-webhook-notification-confirmation-email.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription is active"}],"statuspage.stakeholder-comms-webhook-notification-delivery-failure.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription is deactivated"}],"statuspage.stakeholder-comms-webhook-validation-failure.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription could not be activated"}]}');

});

parcelRegister("fQFz1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eN53q").then(()=>parcelRequire('a0XIg'));

});

parcelRegister("37lV4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fq9c3").then(()=>parcelRequire('jgYon'));

});

parcelRegister("hflAM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eHREz").then(()=>parcelRequire('a0SUL'));

});

parcelRegister("bh1FY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5o206").then(()=>parcelRequire('8Nnmf'));

});

parcelRegister("1I62A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8SBGG").then(()=>parcelRequire('jngHJ'));

});

parcelRegister("fAM4o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2HHtD").then(()=>parcelRequire('lahVn'));

});

parcelRegister("faD3Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bMYiO").then(()=>parcelRequire('f4IMa'));

});

parcelRegister("iutdP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dn3tx").then(()=>parcelRequire('hYQS4'));

});

parcelRegister("a95rx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fQL16").then(()=>parcelRequire('8nK7x'));

});

parcelRegister("6jYQH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8ROAY").then(()=>parcelRequire('jj1wq'));

});

parcelRegister("8JYWf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eQvEx").then(()=>parcelRequire('4wVIW'));

});

parcelRegister("caaJk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bvytk").then(()=>parcelRequire('brFyw'));

});

parcelRegister("9IXWt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1v82I").then(()=>parcelRequire('voIcf'));

});

parcelRegister("fN3AC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("45O97").then(()=>parcelRequire('e0krN'));

});

parcelRegister("eaXzh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("izg48").then(()=>parcelRequire('cBmHj'));

});

parcelRegister("2S1Om", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("il9Zc").then(()=>parcelRequire('9p9pJ'));

});

parcelRegister("gpo57", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cwqkg").then(()=>parcelRequire('cted8'));

});

parcelRegister("aw8vM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("XsZTw").then(()=>parcelRequire('ciQIq'));

});

parcelRegister("jUUm9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eKkFE").then(()=>parcelRequire('hhXBf'));

});

parcelRegister("kx2bl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("drMBC").then(()=>parcelRequire('1f5tg'));

});

parcelRegister("6HGjq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kqAWl").then(()=>parcelRequire('kecln'));

});

parcelRegister("cgk2s", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d5kJI").then(()=>parcelRequire('aQLym'));

});

parcelRegister("bnWO7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Ya85d").then(()=>parcelRequire('kNMIG'));

});

parcelRegister("g9VxV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("htohZ").then(()=>parcelRequire('89rYo'));

});

parcelRegister("9g5nu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7m1gR").then(()=>parcelRequire('aOp0Y'));

});

parcelRegister("6waeI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lNZdb").then(()=>parcelRequire('b8pAU'));

});

parcelRegister("8iZnS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("biHAl").then(()=>parcelRequire('j9xVh'));

});

parcelRegister("4RgTX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6Z8gw").then(()=>parcelRequire('dydYE'));

});

parcelRegister("fzlTD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jHua4").then(()=>parcelRequire('aB1U0'));

});

parcelRegister("9Sy4J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dPN3p").then(()=>parcelRequire('9uuaz'));

});

parcelRegister("2D7Kf", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("17brd").then(()=>parcelRequire('azjoI'));

});

parcelRegister("fg96n", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eRfj0").then(()=>parcelRequire('lk5iw'));

});

parcelRegister("hS2MK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Jt8S").then(()=>parcelRequire('5EWXZ'));

});

parcelRegister("gdjCt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cxeZn").then(()=>parcelRequire('eieNH'));

});


parcelRegister("a7zI3", function(module, exports) {
$parcel$export(module.exports, "messagesLoader", () => $4739ced94566412d$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aspfZ = parcelRequire("aspfZ");

var $eVacJ = parcelRequire("eVacJ");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4739ced94566412d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4739ced94566412d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eVacJ.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("kahfh")));
        case 'da':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("10V1Y")));
        case 'de':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("29n8B")));
        case 'en-GB':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("aurgx")));
        case 'en-US':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("4QqJK")));
        case 'en-XA':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("db1d8")));
        case 'en-XB':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("9qlmY")));
        case 'en-ZZ':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("8ZV7P")));
        case 'en':
            return $4739ced94566412d$var$importHelper(await Promise.resolve((parcelRequire("aspfZ"))));
        case 'es':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("jO82t")));
        case 'et':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("8Dq3l")));
        case 'fi':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("21wSJ")));
        case 'fr':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("4kNRm")));
        case 'hr':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("eHKH1")));
        case 'hu':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("d5YoW")));
        case 'it':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("cy1dd")));
        case 'ja':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("6kmBd")));
        case 'ko':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("2WOuG")));
        case 'nb':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("bUAbR")));
        case 'nl':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("HcZBj")));
        case 'pl':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("8VPqC")));
        case 'pt-BR':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("e0E1a")));
        case 'ro':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("fz88U")));
        case 'ru':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("oc92H")));
        case 'sl':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("hoEIC")));
        case 'sr-RS':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("ic5ZZ")));
        case 'sr-YR':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("k35Yz")));
        case 'sr':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("jVoQ4")));
        case 'sv':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("bEUTw")));
        case 'th':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("9cvF7")));
        case 'tr':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("dKrHQ")));
        case 'uk':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("9kJNA")));
        case 'vi':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("1yctR")));
        case 'zh-CN':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("34CzE")));
        case 'zh-TW':
            return $4739ced94566412d$var$importHelper(await (parcelRequire("5ZKlW")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aspfZ));
    }
};

});
parcelRegister("aspfZ", function(module, exports) {
module.exports = JSON.parse("{\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.cta-link\":[{\"type\":0,\"value\":\"Go to space\"}],\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.description\":[{\"type\":0,\"value\":\"Your work has been imported and your new space is set up.\"}],\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.header\":[{\"type\":0,\"value\":\"Your space is ready\"}]}");

});

parcelRegister("kahfh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fxKjK").then(()=>parcelRequire('9taVz'));

});

parcelRegister("10V1Y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4JwIe").then(()=>parcelRequire('kf8Tc'));

});

parcelRegister("29n8B", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5rm8A").then(()=>parcelRequire('3Ee7g'));

});

parcelRegister("aurgx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8hmbH").then(()=>parcelRequire('6pzTz'));

});

parcelRegister("4QqJK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bGcPO").then(()=>parcelRequire('asNwT'));

});

parcelRegister("db1d8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3vtgt").then(()=>parcelRequire('6fJQS'));

});

parcelRegister("9qlmY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g1c09").then(()=>parcelRequire('8329w'));

});

parcelRegister("8ZV7P", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8EDc6").then(()=>parcelRequire('718Rv'));

});

parcelRegister("jO82t", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9O5mV").then(()=>parcelRequire('d5Yq2'));

});

parcelRegister("8Dq3l", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gnqdS").then(()=>parcelRequire('b59CE'));

});

parcelRegister("21wSJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iFseA").then(()=>parcelRequire('28n07'));

});

parcelRegister("4kNRm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lwj68").then(()=>parcelRequire('k4VpT'));

});

parcelRegister("eHKH1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dafKJ").then(()=>parcelRequire('lFuW7'));

});

parcelRegister("d5YoW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6KQ7E").then(()=>parcelRequire('1vno6'));

});

parcelRegister("cy1dd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("nMnce").then(()=>parcelRequire('gQIcV'));

});

parcelRegister("6kmBd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2tVjs").then(()=>parcelRequire('2be1K'));

});

parcelRegister("2WOuG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iC6c0").then(()=>parcelRequire('2Z0KH'));

});

parcelRegister("bUAbR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hodvZ").then(()=>parcelRequire('k7Spp'));

});

parcelRegister("HcZBj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bBfkH").then(()=>parcelRequire('OdbEE'));

});

parcelRegister("8VPqC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8ntam").then(()=>parcelRequire('1VY3t'));

});

parcelRegister("e0E1a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j0ZER").then(()=>parcelRequire('csfqV'));

});

parcelRegister("fz88U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lQ6LS").then(()=>parcelRequire('3UJ12'));

});

parcelRegister("oc92H", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dAbwK").then(()=>parcelRequire('gdcqp'));

});

parcelRegister("hoEIC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3PUxk").then(()=>parcelRequire('hwcLZ'));

});

parcelRegister("ic5ZZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3m2Tk").then(()=>parcelRequire('5U31i'));

});

parcelRegister("k35Yz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1GemK").then(()=>parcelRequire('fkOvd'));

});

parcelRegister("jVoQ4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hhnd9").then(()=>parcelRequire('NRfOU'));

});

parcelRegister("bEUTw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kQIr1").then(()=>parcelRequire('2uKn5'));

});

parcelRegister("9cvF7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jA1zw").then(()=>parcelRequire('d827U'));

});

parcelRegister("dKrHQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("14Cyt").then(()=>parcelRequire('awLxy'));

});

parcelRegister("9kJNA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k22Q0").then(()=>parcelRequire('5otBy'));

});

parcelRegister("1yctR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("GW0zX").then(()=>parcelRequire('9op8O'));

});

parcelRegister("34CzE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6hKe4").then(()=>parcelRequire('kQ3Un'));

});

parcelRegister("5ZKlW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kPoac").then(()=>parcelRequire('2czX7'));

});



parcelRegister("7k8gw", function(module, exports) {
$parcel$export(module.exports, "ScreenSpaceFlagsPlacement", () => $e395ca1022c8234a$export$f6564e60882bdf90);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4LDqh = parcelRequire("4LDqh");

var $iISCq = parcelRequire("iISCq");
var $lHZq9 = parcelRequire("lHZq9");

var $eAA3f = parcelRequire("eAA3f");

var $1Pg8F = parcelRequire("1Pg8F");

var $8VhoU = parcelRequire("8VhoU");

var $8Lj0H = parcelRequire("8Lj0H");

var $au27J = parcelRequire("au27J");

var $2amfq = parcelRequire("2amfq");

var $kr02N = parcelRequire("kr02N");

var $ho3a8 = parcelRequire("ho3a8");

var $6ub4E = parcelRequire("6ub4E");
const $e395ca1022c8234a$export$f6564e60882bdf90 = ({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const injectedMessageTemplates = (0, $au27J.useInjectedMessageTemplates)();
    // https://switcheroo.atlassian.com/ui/gates/3088e603-a723-449e-a763-b42e9db2a626/key/post-office_enable_ssf_injected_messages
    const isInjectedMessagesEnabled = (0, $4LDqh.default).checkGate('post-office_enable_ssf_injected_messages');
    const injectedMessageRenderer = (0, $euxye.useMemo)(()=>injectedMessageTemplates ? (0, $eAA3f.asMessageRenderer)(injectedMessageTemplates, 'screen-space-flags').MessageRenderer : (0, $ho3a8.MessageRenderer), [
        injectedMessageTemplates
    ]);
    const MessageRenderer = isInjectedMessagesEnabled ? injectedMessageRenderer : (0, $ho3a8.MessageRenderer);
    const isEPExternalMessageSSREnabled = (0, $4LDqh.default).checkGate('post-office_enabled_ep_external_message_ssr');
    const [localMessageState, setLocalMessageState] = (0, $euxye.useState)(()=>{
        const messages = preloadedInitialData?.messages?.length ? preloadedInitialData.messages : undefined;
        const triggeredMessages = preloadedInitialData?.triggeredMessages?.length ? preloadedInitialData.triggeredMessages : undefined;
        return {
            messages: messages,
            triggeredMessages: triggeredMessages
        };
    });
    // Dismissals are stored locally to keep the local state relatively immutable,
    // except unless explicitly refreshed from the server.
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $euxye.useState)([]);
    const filterByDismissed = (0, $euxye.useCallback)((list)=>list?.filter((msg)=>!dismissedMessageInstanceIds.includes(msg.messageInstanceId)), [
        dismissedMessageInstanceIds
    ]);
    // Filter the messages at runtime to ensure they are always accurate and
    // so we don't need to manage the dismissed messages in the state.
    const { filteredMessages: filteredMessages, filteredTriggeredMessages: filteredTriggeredMessages } = (0, $euxye.useMemo)(()=>({
            filteredMessages: filterByDismissed(localMessageState.messages),
            filteredTriggeredMessages: filterByDismissed(localMessageState.triggeredMessages)
        }), [
        localMessageState.messages,
        localMessageState.triggeredMessages,
        filterByDismissed
    ]);
    (0, $1Pg8F.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $lHZq9.useMessagePlacementHooks)();
    const handleDismiss = (0, $euxye.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        if (messageInstanceId) // dismiss the current message instance
        setDismissedMessageInstanceIds((current)=>[
                ...current,
                messageInstanceId
            ]);
        else // eslint-disable-next-line no-console
        console.error(`A valid messageInstanceId is required to dismiss a message: ${messageInstanceId}`);
    }, []);
    const onDismissed = (0, $euxye.useCallback)((messageInstanceId)=>{
        handleDismiss({
            messageInstanceId: messageInstanceId
        });
    }, [
        handleDismiss
    ]);
    (0, $euxye.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $euxye.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $euxye.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    (0, $euxye.useEffect)(()=>{
        // update the preloaded initial data with the accurate filtered messages
        if (typeof setPreloadedInitialData === 'function') {
            if (isEPExternalMessageSSREnabled) setPreloadedInitialData({
                messages: filteredMessages ?? [],
                triggeredMessages: filteredTriggeredMessages ?? []
            });
            else setPreloadedInitialData({
                messages: filteredMessages ?? [],
                triggeredMessages: filteredTriggeredMessages ?? []
            });
        }
    }, [
        filteredMessages,
        filteredTriggeredMessages,
        isEPExternalMessageSSREnabled,
        setPreloadedInitialData
    ]);
    const activeScopes = (0, $iISCq.usePostOfficeContextScope)({
        scopes: $2amfq.scopes,
        treatIntersectionAsSame: true
    });
    const searchParams = (0, $6ub4E.usePostOfficeSearchParams)();
    const messagesState = (0, $8VhoU.usePlacementApi)('/update-messages', {
        queryParams: {
            ...searchParams,
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: (0, $4LDqh.default).checkGate('post-office-ssf-enable-continuous-auto-refetch') ? !!activeScopes.updateKey && !filteredMessages?.length : !!activeScopes.updateKey && typeof filteredMessages === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $euxye.useEffect)(()=>{
        const data = messagesState?.data;
        if (!data) return;
        setLocalMessageState((prev)=>{
            const messages = data.messages ?? [];
            let selectedMessages = [];
            if (messages.length > 0) {
                let selectedMessage;
                // New experiments in the screen-space-flags placement must be added to the EXPERIMENTAL_MESSAGES list
                for (const message of messages){
                    const experimentalMessage = (0, $8Lj0H.EXPERIMENTAL_MESSAGES).find((p)=>p.messageTemplateId === message.messageTemplateId);
                    if (experimentalMessage) {
                        const cohort = (0, $4LDqh.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                            fireExperimentExposure: true
                        });
                        if (experimentalMessage?.statsigAAExperiment) (0, $4LDqh.default).getExperimentValue(experimentalMessage.statsigAAExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                            fireExperimentExposure: true
                        });
                        if (experimentalMessage.statsigTestCohorts.includes(cohort)) {
                            selectedMessage = message;
                            break;
                        }
                    } else {
                        selectedMessage = message;
                        break;
                    }
                }
                selectedMessages = selectedMessage ? [
                    selectedMessage
                ] : [];
            }
            const triggeredMessages = data.triggeredMessages ?? [];
            return {
                ...prev,
                messages: selectedMessages,
                triggeredMessages: triggeredMessages
            };
        });
    }, [
        messagesState.data
    ]);
    const messageToRender = filteredMessages?.[0];
    const content = (0, $4LDqh.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $kr02N.SuppressIfModalIsPresent), {
        children: [
            messageToRender ? /*#__PURE__*/ (0, $euxye.createElement)(MessageRenderer, {
                ...messageToRender,
                key: messageToRender.messageInstanceId,
                id: messageToRender.messageInstanceId,
                messageInstanceId: messageToRender.messageInstanceId,
                onDismissed: onDismissed,
                SuspenseBoundary: (0, $eAA3f.MaybeSuspenseBoundary),
                jiraFlagsService: jiraFlagsService,
                onError: reportUnexpectedError,
                reportExpectedError: reportExpectedError
            }) : null,
            filteredTriggeredMessages?.map((msg)=>/*#__PURE__*/ (0, $euxye.createElement)(MessageRenderer, {
                    ...msg,
                    key: msg.messageInstanceId,
                    id: msg.messageInstanceId,
                    messageInstanceId: msg.messageInstanceId,
                    onDismissed: onDismissed,
                    SuspenseBoundary: (0, $eAA3f.MaybeSuspenseBoundary),
                    jiraFlagsService: jiraFlagsService,
                    onError: reportUnexpectedError,
                    reportExpectedError: reportExpectedError
                }))
        ]
    }) : null;
    return content;
};
$e395ca1022c8234a$export$f6564e60882bdf90.displayName = "ScreenSpaceFlagsPlacement";

});
parcelRegister("eAA3f", function(module, exports) {
$parcel$export(module.exports, "MaybeSuspenseBoundary", () => $a842046d1afc715b$export$9750eb54d7c7e789);
$parcel$export(module.exports, "asMessageRenderer", () => $a842046d1afc715b$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $8hetP = parcelRequire("8hetP");
var $bDiVY = parcelRequire("bDiVY");

var $jnJcP = parcelRequire("jnJcP");

var $lK7pY = parcelRequire("lK7pY");

var $1wNxv = parcelRequire("1wNxv");

var $b18n5 = parcelRequire("b18n5");

var $8opyJ = parcelRequire("8opyJ");

var $4uj2Z = parcelRequire("4uj2Z");

var $3qNLG = parcelRequire("3qNLG");

var $gwHtt = parcelRequire("gwHtt");

var $2bKWE = parcelRequire("2bKWE");

var $5R7RH = parcelRequire("5R7RH");

var $3oVpu = parcelRequire("3oVpu");

var $8KzDp = parcelRequire("8KzDp");

var $euxye = parcelRequire("euxye");

var $4zOdN = parcelRequire("4zOdN");

var $140JV = parcelRequire("140JV");
const $a842046d1afc715b$var$STABLE_EMPTY_OBJECT = {};
const $a842046d1afc715b$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
        ...props,
        children: children
    });
};
$a842046d1afc715b$export$9750eb54d7c7e789.displayName = "MaybeSuspenseBoundary";
const $a842046d1afc715b$export$7b7e5a348ef9a7c1 = (messageComponents, placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $euxye.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, SuspenseBoundary: SuspenseBoundary = (0, $euxye.Suspense), ...data })=>{
            const isUFOEnabled = (0, $4LDqh.default).checkGate('enable_ufo_tracking_in_post_office');
            /// https://switcheroo.atlassian.com/ui/gates/e8049c84-32d5-4452-a52f-5b92940a1b55/key/post-office_enable-i18n-migration-pull
            const isI18nMigrationInAppEnabled = (0, $4LDqh.default).checkGate('post-office_enable-i18n-migration-pull');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $euxye.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $8hetP.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5R7RH.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $euxye.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $jnJcP.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $jnJcP.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $euxye.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bDiVY.UFOv2).UFOLoadHold, {
                        name: (0, $bDiVY.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = (0, $2bKWE.isClientTriggeredMessage)(triggerType);
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $3qNLG.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $euxye.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId
                ]);
                // MaybeChoreographerWrapper sits at the top so it can claim its slot while the
                // lazy chunk is loading; it no-ops for client-triggered messages, which handle
                // their own choreography via MaybeTriggeredMessageValidator below.
                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $140JV.MaybeChoreographerWrapper), {
                    ChoreographerWrapper: (0, $4zOdN.ChoreographerWrapper),
                    enabled: !waitForTrigger,
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8opyJ.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lK7pY.MessageContextProvider), {
                            value: messageContextValue,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8KzDp.RecommendationProvider), {
                                value: recommendationSession ?? $a842046d1afc715b$var$STABLE_EMPTY_OBJECT,
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4uj2Z.MaybeTriggeredMessageValidator), {
                                        waitForTrigger: waitForTrigger,
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $b18n5.MessageAnalyticsContextProvider), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1wNxv.MaybeI18nProvider), {
                                                messageTemplateId: messageTemplateId,
                                                placementId: placementId,
                                                isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled,
                                                children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $gwHtt.MaybeManualMessageViewedEvent), {
                                                    isManual: !!waitForTrigger,
                                                    children: [
                                                        !waitForTrigger && messageSuccessComponent,
                                                        /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                                                            onError: onError,
                                                            messageInstanceId: messageInstanceId,
                                                            ...componentProps,
                                                            waitForTrigger: waitForTrigger
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $3oVpu.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};

});
parcelRegister("8hetP", function(module, exports) {
$parcel$export(module.exports, "UFOv1", () => $65e473c96862cf6a$export$96236906ebaa7f87);

var $kLThb = parcelRequire("kLThb");

var $jgaLx = parcelRequire("jgaLx");
const $65e473c96862cf6a$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $kLThb.MessagePerformanceTracker,
    PlacementPerformanceTracker: $jgaLx.PlacementPerformanceTracker
};

});
parcelRegister("kLThb", function(module, exports) {
$parcel$export(module.exports, "MessagePerformanceTracker", () => $fd272eee7f4067a7$export$ae5c73c7c4f454e6);

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $fCCR5 = parcelRequire("fCCR5");
class $fd272eee7f4067a7$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $jkqqC.UFOExperience)((0, $fCCR5.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $ipvkO.ExperienceTypes).Load,
            platform: {
                component: (0, $fCCR5.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $jkqqC.UFOExperience)(`${(0, $fCCR5.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $ipvkO.ExperienceTypes).Load,
            platform: {
                component: (0, $fCCR5.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("fCCR5", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceNames", () => $0916b98ef4bcbeaf$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $0916b98ef4bcbeaf$export$6d482cfa20c9d220);
const $0916b98ef4bcbeaf$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $0916b98ef4bcbeaf$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("jgaLx", function(module, exports) {
$parcel$export(module.exports, "PlacementPerformanceTracker", () => $8d6a37b9c22cc2a6$export$8b48c2105ba0b35a);

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $fCCR5 = parcelRequire("fCCR5");
const $8d6a37b9c22cc2a6$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $8d6a37b9c22cc2a6$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $ipvkO.ExperienceTypes).Load,
    platform: {
        component: (0, $fCCR5.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$8d6a37b9c22cc2a6$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$8d6a37b9c22cc2a6$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$8d6a37b9c22cc2a6$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$8d6a37b9c22cc2a6$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$8d6a37b9c22cc2a6$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$8d6a37b9c22cc2a6$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$8d6a37b9c22cc2a6$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$8d6a37b9c22cc2a6$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $8d6a37b9c22cc2a6$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$8d6a37b9c22cc2a6$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$8d6a37b9c22cc2a6$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$8d6a37b9c22cc2a6$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $8d6a37b9c22cc2a6$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $8d6a37b9c22cc2a6$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$8d6a37b9c22cc2a6$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $8d6a37b9c22cc2a6$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $jkqqC.UFOExperience)((0, $fCCR5.UFOExperienceNames).PLACEMENT, $8d6a37b9c22cc2a6$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $jkqqC.UFOExperience)(`${(0, $fCCR5.UFOExperienceNames).PLACEMENT}.${placementId}`, $8d6a37b9c22cc2a6$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("4zOdN", function(module, exports) {
$parcel$export(module.exports, "ChoreographerWrapper", () => $dd793e8ecf263d18$export$8db7ba034addcd65);

var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $fGrpH = parcelRequire("fGrpH");

var $iMsV9 = parcelRequire("iMsV9");

var $euxye = parcelRequire("euxye");
const $dd793e8ecf263d18$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    return null;
};
$dd793e8ecf263d18$var$ChoreographedComponent.displayName = "ChoreographedComponent";
const $dd793e8ecf263d18$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $iMsV9.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $4LDqh.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $4LDqh.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $4LDqh.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $e79Pd.jsx)($dd793e8ecf263d18$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$dd793e8ecf263d18$export$8db7ba034addcd65.displayName = "ChoreographerWrapper";

});


parcelRegister("1Pg8F", function(module, exports) {
$parcel$export(module.exports, "useInitialData", () => $2fce33bdf48abb9b$export$5523c5f3222291d0);

var $euxye = parcelRequire("euxye");

var $7OO9v = parcelRequire("7OO9v");
const $2fce33bdf48abb9b$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $euxye.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $7OO9v.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});
parcelRegister("7OO9v", function(module, exports) {
$parcel$export(module.exports, "AlreadyRunningError", () => $011d63ff0b93910b$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $011d63ff0b93910b$export$c1cf1cf4c5d51937);

var $fGrpH = parcelRequire("fGrpH");

var $74oEx = parcelRequire("74oEx");

var $euxye = parcelRequire("euxye");

var $6owpJ = parcelRequire("6owpJ");
class $011d63ff0b93910b$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $011d63ff0b93910b$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $euxye.useState)((0, $6owpJ.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $euxye.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $6owpJ.assertResponseIsOk)(res)) {
                const data = await res.json();
                setState((0, $6owpJ.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $011d63ff0b93910b$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $6owpJ.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("6owpJ", function(module, exports) {
$parcel$export(module.exports, "assertResponseIsOk", () => $20445d2ab6ca3dfd$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $20445d2ab6ca3dfd$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $20445d2ab6ca3dfd$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $20445d2ab6ca3dfd$export$24a6b176bdc41ce5);
const $20445d2ab6ca3dfd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $20445d2ab6ca3dfd$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($20445d2ab6ca3dfd$export$18a0019e5439b209(res));
};
const $20445d2ab6ca3dfd$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $20445d2ab6ca3dfd$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $20445d2ab6ca3dfd$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("8VhoU", function(module, exports) {
$parcel$export(module.exports, "usePlacementApi", () => $8c1985def07f9892$export$201bbce8187a6e3c);

var $4LDqh = parcelRequire("4LDqh");

var $j142y = parcelRequire("j142y");

var $hDw0T = parcelRequire("hDw0T");

var $fslfv = parcelRequire("fslfv");

var $dxmBN = parcelRequire("dxmBN");

var $7AUSS = parcelRequire("7AUSS");

var $7BZpb = parcelRequire("7BZpb");

var $euxye = parcelRequire("euxye");
// https://switcheroo.atlassian.com/ui/gates/746a161c-d307-4db3-a966-8fe63c551fea/key/post-office_skip_rest_for_graphql_subscription
const $8c1985def07f9892$var$SKIP_REST_FETCH_GATE = 'post-office_skip_rest_for_graphql_subscription';
const $8c1985def07f9892$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $fslfv.usePlacementContext)();
    const context = (0, $j142y.usePostOfficeContext)();
    const fetcher = (0, $hDw0T.usePlacementFetchingContext)();
    const { subscription: subscription } = (0, $7BZpb.useSubscriptionConfig)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found. Ensure this hook is used as a child of PlacementProvider.')
            });
        // Prefer the explicit prop when provided; fall back to the Switcheroo gate
        // so existing callers that have not yet migrated continue to work unchanged.
        const isClientFetch = config?.useClientFetch !== undefined ? config.useClientFetch : (0, $4LDqh.default).checkGate('post-office-use-placement-with-client');
        if (isClientFetch) return (0, $7AUSS.createUsePlacementWithClient)(placementId, fetcher);
        return (0, $dxmBN.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher,
        config?.useClientFetch
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...queryParams,
        ...context
    };
    const apiDependencies = (0, $euxye.useMemo)(()=>{
        return [
            config?.autoRefetch?.updateKey
        ];
    }, [
        config?.autoRefetch?.updateKey
    ]);
    // disable REST fetch for initialMessages for subscription based placements if the gate is enabled
    const isSubscriptionBasedFetchDisabled = subscription?.enabled === true && (0, $4LDqh.default).checkGate($8c1985def07f9892$var$SKIP_REST_FETCH_GATE);
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: isSubscriptionBasedFetchDisabled ? false : config?.autoRefetch?.isEnabled,
        deps: apiDependencies
    });
};

});
parcelRegister("dxmBN", function(module, exports) {
$parcel$export(module.exports, "createUsePlacement", () => $bd0f76ade78d93cc$export$ee1d67e435d25cb5);

var $dIjXF = parcelRequire("dIjXF");

var $euxye = parcelRequire("euxye");

var $7OO9v = parcelRequire("7OO9v");
const $bd0f76ade78d93cc$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $euxye.useRef)();
        const isRunningPromise = (0, $euxye.useRef)(false);
        (0, $euxye.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $euxye.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $7OO9v.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $dIjXF.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            config?.deps,
            path
        ]);
        return (0, $7OO9v.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};

});
parcelRegister("dIjXF", function(module, exports) {
$parcel$export(module.exports, "fetchPlacementData", () => $4660b94f19492460$export$ce743d02f83ee521);
const $4660b94f19492460$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $4660b94f19492460$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $4660b94f19492460$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$4660b94f19492460$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $4660b94f19492460$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($4660b94f19492460$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$4660b94f19492460$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};

});


parcelRegister("7AUSS", function(module, exports) {
$parcel$export(module.exports, "createUsePlacementWithClient", () => $81b45763367a3abb$export$7a2a7b6f48ac7d1);

var $zhCFd = parcelRequire("zhCFd");

var $fGrpH = parcelRequire("fGrpH");

var $74oEx = parcelRequire("74oEx");
const $81b45763367a3abb$export$7a2a7b6f48ac7d1 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
        const analyticsSubjectId = placementId;
        const analyticsAttributes = {
            path: path
        };
        const { data: data, error: error } = (0, $zhCFd.useFetchPlacementData)(config?.isEnabled === false ? null : placementId, path, context, fetcher, requestOptions, {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            onSuccess: ()=>{
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            },
            onError: (error)=>{
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: error?.name ?? 'unknown',
                        errorMessage: error?.message ?? 'unknown'
                    }
                });
            }
        });
        if (data) return {
            isLoading: false,
            error: undefined,
            data: data
        };
        if (error) return {
            isLoading: false,
            error: error,
            data: undefined
        };
        return {
            isLoading: true,
            error: undefined,
            data: undefined
        };
    };
};

});
parcelRegister("zhCFd", function(module, exports) {
$parcel$export(module.exports, "useFetchPlacementData", () => $dfcf15d0f0d3b749$export$ef70136078f15deb);

var $f4ymX = parcelRequire("f4ymX");
const $dfcf15d0f0d3b749$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $dfcf15d0f0d3b749$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $dfcf15d0f0d3b749$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$dfcf15d0f0d3b749$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $dfcf15d0f0d3b749$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $dfcf15d0f0d3b749$export$ef70136078f15deb = (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($dfcf15d0f0d3b749$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$dfcf15d0f0d3b749$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $f4ymX.default)(placementId ? url : null, (url)=>fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...$dfcf15d0f0d3b749$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};

});



parcelRegister("8Lj0H", function(module, exports) {
$parcel$export(module.exports, "EXPERIMENTAL_MESSAGES", () => $ac635fc6e072d22c$export$963cdca6c7580c53);
const $ac635fc6e072d22c$export$963cdca6c7580c53 = [
    {
        messageTemplateId: 'confluence-3p-connector-nudge',
        statsigExperiment: 'post-office_3p_user_authentication_nudge',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ]
    },
    {
        messageTemplateId: 'confluence-auto-provisioning-edition-parity-trial-dialog',
        // https://switcheroo.atlassian.com/ui/gates/d0ba1046-934a-4af7-8294-e6ca8b846ab3/key/confluence_autoprovisioning_edition_parity
        statsigExperiment: 'confluence_autoprovisioning_edition_parity',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ]
    },
    {
        messageTemplateId: 'confluence-ai-audio-player-spotlight-tour',
        // https://switcheroo.atlassian.com/ui/gates/e9b0503b-0486-48e3-a511-123e409058f4/key/confluence_audio_v3_changeboarding
        statsigExperiment: 'confluence_audio_v3_changeboarding',
        statsigParameterName: 'isEnabled',
        statsigTestCohorts: [
            'true'
        ]
    },
    {
        messageTemplateId: 'rovo-growth-nudge-end-user-highly-connected-apps',
        // https://switcheroo.atlassian.com/ui/gates/f36896ce-14dc-4a48-9888-dd0df3c671e0/key/rovo_nudge_end_user_highly_connected_apps_exp
        statsigExperiment: 'rovo_nudge_end_user_highly_connected_apps_exp',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variant1',
            'variant2'
        ]
    },
    {
        messageTemplateId: 'commerce-subscription-auto-upgrade-ccp',
        // https://switcheroo.atlassian.com/ui/gates/3b39fad7-0834-4007-9b28-73367d7231fd/key/auto-upgrades_w_pde_legal_update_ab_test,
        statsigExperiment: 'auto-upgrades_w_pde_legal_update_ab_test',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ]
    }
];

});

parcelRegister("au27J", function(module, exports) {
$parcel$export(module.exports, "useInjectedMessageTemplates", () => $aa906e927c91b947$export$60075266d0d5c9c4);

var $euxye = parcelRequire("euxye");
const $aa906e927c91b947$export$86fac4eb228cc5e9 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $aa906e927c91b947$export$60075266d0d5c9c4 = ()=>(0, $euxye.useContext)($aa906e927c91b947$export$86fac4eb228cc5e9);

});

parcelRegister("kr02N", function(module, exports) {
$parcel$export(module.exports, "SuppressIfModalIsPresent", () => $d71790096e6772da$export$32c78d11bbf53e24);

var $e79Pd = parcelRequire("e79Pd");

var $4LDqh = parcelRequire("4LDqh");

var $fGrpH = parcelRequire("fGrpH");

var $euxye = parcelRequire("euxye");
const $d71790096e6772da$export$32c78d11bbf53e24 = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fGrpH.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $euxye.useState)(true);
    const handleVisibilityChange = (0, $euxye.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $euxye.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $4LDqh.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$d71790096e6772da$export$32c78d11bbf53e24.displayName = "SuppressIfModalIsPresent";

});

parcelRegister("ho3a8", function(module, exports) {
$parcel$export(module.exports, "MessageRenderer", () => $ed5b5291255b1ba7$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $euxye = parcelRequire("euxye");

var $eAA3f = parcelRequire("eAA3f");














































































































































const $ed5b5291255b1ba7$export$e30378e28ad3e6ab = {
    'admin-hub-app-access-settings-access-message-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("2LFIL"))),
    'adminhub-platform-usage-m5-spotlight-tour': (0, $euxye.lazy)(()=>(parcelRequire("hKm66"))),
    'adminhub-portfolio-insights-nav-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("dEx1h"))),
    'adminhub-rovo-bookmarks-onboarding-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("aMJu4"))),
    'adminhub-rovo-chat-button-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("dDu0y"))),
    'adminhub-rovo-chat-toggle-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("79mWw"))),
    'adminhub-system-health-dashboard-app-status-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("b8Fk6"))),
    'adminhub-system-health-dashboard-app-status-spotlight-v2': (0, $euxye.lazy)(()=>(parcelRequire("cNF7k"))),
    'adminhub-system-health-dashboard-status-hub-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("jgpqh"))),
    'adminhub-theme-darkmode': (0, $euxye.lazy)(()=>(parcelRequire("aOdYJ"))),
    'adminhub-unit-create-ga-spotlight-tour': (0, $euxye.lazy)(()=>(parcelRequire("e22Ok"))),
    'adminhub-urm-rank-ra-using-ml-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("8urbC"))),
    'adminhub-user-requests-count-message-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("4KJac"))),
    'assets-deeplinking-modal': (0, $euxye.lazy)(()=>(parcelRequire("2RcCi"))),
    'assets-osc-onboarding-object-graph-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("dfIBs"))),
    'cases': (0, $euxye.lazy)(()=>(parcelRequire("k1Un1"))),
    'cases-request-types-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("jLZMs"))),
    'cc-changeboarding-block-menu-primary': (0, $euxye.lazy)(()=>(parcelRequire("gZ7mt"))),
    'cc-changeboarding-block-menu-primary-new': (0, $euxye.lazy)(()=>(parcelRequire("94v3A"))),
    'cc-changeboarding-block-menu-templates': (0, $euxye.lazy)(()=>(parcelRequire("2lLRO"))),
    'cc-changeboarding-block-menu-transform': (0, $euxye.lazy)(()=>(parcelRequire("3APUy"))),
    'cc-changeboarding-synced-blocks': (0, $euxye.lazy)(()=>(parcelRequire("i8aPo"))),
    'cc-editor-table-cell-menu-changes': (0, $euxye.lazy)(()=>(parcelRequire("flN8S"))),
    'commerce-subscription-auto-upgrade-ccp': (0, $euxye.lazy)(()=>(parcelRequire("9pNk5"))),
    'commerce-subscription-auto-upgrade-no-payment-method-ccp': (0, $euxye.lazy)(()=>(parcelRequire("dcTqE"))),
    'confluence-3p-connector-nudge': (0, $euxye.lazy)(()=>(parcelRequire("ersfL"))),
    'confluence-ai-audio-player-spotlight-tour': (0, $euxye.lazy)(()=>(parcelRequire("aAkrG"))),
    'confluence-auto-provisioning-edition-parity-trial-dialog': (0, $euxye.lazy)(()=>(parcelRequire("fs9Ff"))),
    'confluence-commented-on-page-nudge': (0, $euxye.lazy)(()=>(parcelRequire("1QFpi"))),
    'confluence-continue-reading-nudge': (0, $euxye.lazy)(()=>(parcelRequire("5CJbP"))),
    'confluence-editor-smart-links-draggable-changeboard': (0, $euxye.lazy)(()=>(parcelRequire("e2JKU"))),
    'confluence-fast-and-snappy-survey': (0, $euxye.lazy)(()=>(parcelRequire("julaN"))),
    'confluence-founding-admin-connect-tools-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("5j9zE"))),
    'confluence-inline-reactions-mau-nudge': (0, $euxye.lazy)(()=>(parcelRequire("14SDs"))),
    'confluence-inline-reactions-mcu-nudge': (0, $euxye.lazy)(()=>(parcelRequire("ko2co"))),
    'confluence-inline-reactions-nudge': (0, $euxye.lazy)(()=>(parcelRequire("kIJlo"))),
    'confluence-lovability-survey': (0, $euxye.lazy)(()=>(parcelRequire("jy6Gn"))),
    'confluence-maui-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("6ras6"))),
    'confluence-maui-changeboarding-remix-tour': (0, $euxye.lazy)(()=>(parcelRequire("84Wzo"))),
    'confluence-maui-slides-create-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("etuBt"))),
    'confluence-maui-slides-edit-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("8qd77"))),
    'confluence-maui-slides-modal': (0, $euxye.lazy)(()=>(parcelRequire("fx4kg"))),
    'confluence-maui-slides-toolbar-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("eBcZ2"))),
    'confluence-mentioned-in-comment-nudge': (0, $euxye.lazy)(()=>(parcelRequire("knWnn"))),
    'confluence-mentioned-on-page-nudge': (0, $euxye.lazy)(()=>(parcelRequire("hW18s"))),
    'confluence-nudge-for-jira': (0, $euxye.lazy)(()=>(parcelRequire("5azU9"))),
    'confluence-object-sidebar-remix-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("4ooJL"))),
    'confluence-ootb-daily-brief-agent-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("k4l5O"))),
    'cpq-user-feedback': (0, $euxye.lazy)(()=>(parcelRequire("aoiHO"))),
    'edition-benefits-modal': (0, $euxye.lazy)(()=>(parcelRequire("3UUYF"))),
    'encryption-policy-page-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("fZSsP"))),
    'end-of-trial-extension': (0, $euxye.lazy)(()=>(parcelRequire("2I4Gh"))),
    'ep-migration-external-messages': (0, $euxye.lazy)(()=>(parcelRequire("e42E6"))),
    'ep-migration-inapp-1736': (0, $euxye.lazy)(()=>(parcelRequire("h8j2t"))),
    'ep-migration-inapp-1737': (0, $euxye.lazy)(()=>(parcelRequire("2OX9i"))),
    'ep-migration-inapp-2055': (0, $euxye.lazy)(()=>(parcelRequire("kRXDa"))),
    'ep-migration-inapp-2271': (0, $euxye.lazy)(()=>(parcelRequire("b3s08"))),
    'ep-migration-inapp-3273': (0, $euxye.lazy)(()=>(parcelRequire("z8AuJ"))),
    'ep-migration-inapp-3280': (0, $euxye.lazy)(()=>(parcelRequire("iRQna"))),
    'ep-migration-inapp-3282': (0, $euxye.lazy)(()=>(parcelRequire("6dmyO"))),
    'ep-migration-inapp-715': (0, $euxye.lazy)(()=>(parcelRequire("7v49T"))),
    'ep-migration-jira-ops-team-heartbeats': (0, $euxye.lazy)(()=>(parcelRequire("6kIYe"))),
    'example-generated-spotlight-template': (0, $euxye.lazy)(()=>(parcelRequire("6pFX4"))),
    'jira-assets-schemas-display-name': (0, $euxye.lazy)(()=>(parcelRequire("ids57"))),
    'jira-board-inline-editing-onboarding': (0, $euxye.lazy)(()=>(parcelRequire("6D2SA"))),
    'jira-business-saved-views-admin-changeboarding-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("b1i3G"))),
    'jira-business-saved-views-user-changeboarding-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("1VWGK"))),
    'jira-filter-refinement': (0, $euxye.lazy)(()=>(parcelRequire("5YWe9"))),
    'jira-filter-refinement-board-and-backlog': (0, $euxye.lazy)(()=>(parcelRequire("eBeHN"))),
    'jira-filter-refinement-standalone-release-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("fuxGw"))),
    'jira-forms-conditional-fields-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("hYpP3"))),
    'jira-forms-public-forms-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("9duLT"))),
    'jira-forms-public-forms-changeboarding-flag': (0, $euxye.lazy)(()=>(parcelRequire("jekP9"))),
    'jira-fps-to-gnin-cta-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("1trmN"))),
    'jira-glance-panel-navigation-arrows': (0, $euxye.lazy)(()=>(parcelRequire("a6kwN"))),
    'jira-gnin-to-fps-cta-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("1QhGt"))),
    'jira-hamonisation-software-timeline': (0, $euxye.lazy)(()=>(parcelRequire("2kUTp"))),
    'jira-in-context-config-sidebar-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("bhmk2"))),
    'jira-issueview-description-title-final': (0, $euxye.lazy)(()=>(parcelRequire("dJoeW"))),
    'jira-issueview-status': (0, $euxye.lazy)(()=>(parcelRequire("6d0MA"))),
    'jira-list-conditional-formatting': (0, $euxye.lazy)(()=>(parcelRequire("5CNnH"))),
    'jira-manual-trial-awareness-modal': (0, $euxye.lazy)(()=>(parcelRequire("1Zz3C"))),
    'jira-messaging-research-recruitment': (0, $euxye.lazy)(()=>(parcelRequire("jbWgu"))),
    'jira-onboarding-hub-welcome-modal': (0, $euxye.lazy)(()=>(parcelRequire("dF8mR"))),
    'jira-ops-group-customisation': (0, $euxye.lazy)(()=>(parcelRequire("joXpY"))),
    'jira-ops-unified-view-revamp': (0, $euxye.lazy)(()=>(parcelRequire("5AS7H"))),
    'jira-plans-efa-change-boarding': (0, $euxye.lazy)(()=>(parcelRequire("eEPLs"))),
    'jira-pre-dunning-confirm-plan-modal': (0, $euxye.lazy)(()=>(parcelRequire("9v2aS"))),
    'jira-project-term-refresh-changeboarding-flag': (0, $euxye.lazy)(()=>(parcelRequire("e3Fnr"))),
    'jira-quick-find-intent-detection-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("jGJY8"))),
    'jira-rovo-dev-survey': (0, $euxye.lazy)(()=>(parcelRequire("95wzO"))),
    'jira-rovo-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("8DcRc"))),
    'jira-screen-modal': (0, $euxye.lazy)(()=>(parcelRequire("139pj"))),
    'jira-setup-user-interviews-signup': (0, $euxye.lazy)(()=>(parcelRequire("1N0io"))),
    'jira-side-nav-mature-example-project-space-setup': (0, $euxye.lazy)(()=>(parcelRequire("b8Hdm"))),
    'jira-software-cmp-currency-field-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("2Ul8V"))),
    'jira-software-timeline-hide-top-level-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("3Zui5"))),
    'jira-software-timeline-hierarchy-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("8Jkgt"))),
    'jira-space-settings-playbooks-navigation-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("kN6pL"))),
    'jira-sprints-auto-managed-feature-discovery': (0, $euxye.lazy)(()=>(parcelRequire("lsY2M"))),
    'jira-timeline-10k-issues-message': (0, $euxye.lazy)(()=>(parcelRequire("asiX4"))),
    'jira-timeline-feedback-collector-changeboarding': (0, $euxye.lazy)(()=>(parcelRequire("5R2g7"))),
    'jira-twcg-810-personalised-rt-upgrade-free-customers': (0, $euxye.lazy)(()=>(parcelRequire("9bgdS"))),
    'jira-work-item-view-native-projects-field': (0, $euxye.lazy)(()=>(parcelRequire("lNNjt"))),
    'jsm-edition-awareness-button-popup': (0, $euxye.lazy)(()=>(parcelRequire("eZdV2"))),
    'jsm-project-summary-onboarding': (0, $euxye.lazy)(()=>(parcelRequire("h1oLK"))),
    'marketing-screen-space-flag-contentful-usecase': (0, $euxye.lazy)(()=>(parcelRequire("bK7Hc"))),
    'mercury-edit-hierarchy-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("c3uQs"))),
    'message-template-template': (0, $euxye.lazy)(()=>(parcelRequire("gojMk"))),
    'navx-smartlink-full-picture-auth-nudge': (0, $euxye.lazy)(()=>(parcelRequire("3TEHx"))),
    'plan-calendar-create-item-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("7UXxe"))),
    'post-office-gold-1': (0, $euxye.lazy)(()=>(parcelRequire("kFm8c"))),
    'project-pages-revamp-onboarding-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("hlX7I"))),
    'ptr-changeboarding-space-navigation-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("5vfZK"))),
    'rovo-3p-celebrate-nudge': (0, $euxye.lazy)(()=>(parcelRequire("46sZB"))),
    'rovo-3rd-party-integration-admin-nudge': (0, $euxye.lazy)(()=>(parcelRequire("eaERn"))),
    'rovo-agents-scenario-onboarding': (0, $euxye.lazy)(()=>(parcelRequire("7UZEp"))),
    'rovo-button-onboarding-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("eJfzR"))),
    'rovo-chat-inline-memory-saved-message': (0, $euxye.lazy)(()=>(parcelRequire("4CcSA"))),
    'rovo-chat-memory-settings-onboarding-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("4SkOy"))),
    'rovo-chat-welcome-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("4TkgP"))),
    'rovo-extension-gdocs-definitions-install-cta-flag': (0, $euxye.lazy)(()=>(parcelRequire("dPKaA"))),
    'rovo-growth-3p-smartlink-admin-paste-nudge': (0, $euxye.lazy)(()=>(parcelRequire("9Q6UV"))),
    'rovo-growth-3p-smartlink-paste-nudge': (0, $euxye.lazy)(()=>(parcelRequire("csGAU"))),
    'rovo-growth-nudge-end-user-highly-connected-apps': (0, $euxye.lazy)(()=>(parcelRequire("cVSQT"))),
    'shared-user-preferences-onboarding': (0, $euxye.lazy)(()=>(parcelRequire("9pAb0"))),
    'solcom-create-space-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("iFTMv"))),
    'starburst-screen-space-flags-twc-welcome-modal': (0, $euxye.lazy)(()=>(parcelRequire("bFNWi"))),
    'statuspage-navigation-spotlight': (0, $euxye.lazy)(()=>(parcelRequire("lijB7"))),
    'statuspage-navigation-spotlight-v2': (0, $euxye.lazy)(()=>(parcelRequire("buMQ2"))),
    'team-wolverine-jira-migration-success': (0, $euxye.lazy)(()=>(parcelRequire("iKy2S"))),
    'test-message-config-sets': (0, $euxye.lazy)(()=>(parcelRequire("3c7I0"))),
    'test-message-dynamic-config-sets': (0, $euxye.lazy)(()=>(parcelRequire("jvriJ"))),
    'test-message-inapp': (0, $euxye.lazy)(()=>(parcelRequire("gdAAg"))),
    'test-message-inapp-ep-modal': (0, $euxye.lazy)(()=>(parcelRequire("laAWF"))),
    'test-message-inapp-implicit-pendo': (0, $euxye.lazy)(()=>(parcelRequire("9qH1U"))),
    'test-message-tap-ingestion-trigger-subscription': (0, $euxye.lazy)(()=>(parcelRequire("3T5qH"))),
    'test-screen-space-flags-message': (0, $euxye.lazy)(()=>(parcelRequire("38wOF"))),
    'test-simple-ipm-spotlight-page-load': (0, $euxye.lazy)(()=>(parcelRequire("kUQ6C"))),
    'twc-conf-sample-page-tour': (0, $euxye.lazy)(()=>(parcelRequire("4MbAR"))),
    'twc-project-pages-confluence-tour': (0, $euxye.lazy)(()=>(parcelRequire("9xc3U"))),
    'twc-xflow-modal-v2': (0, $euxye.lazy)(()=>(parcelRequire("1XbAc")))
};
const $ed5b5291255b1ba7$var$messageRenderer = (0, $eAA3f.asMessageRenderer)($ed5b5291255b1ba7$export$e30378e28ad3e6ab, 'screen-space-flags');
const $ed5b5291255b1ba7$export$bce4e5106d86e473 = $ed5b5291255b1ba7$var$messageRenderer.initializeMessageRenderer;
const $ed5b5291255b1ba7$export$2df1250b8f917a59 = $ed5b5291255b1ba7$var$messageRenderer.MessageRenderer;

});
parcelRegister("2LFIL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("XQo8U").then(()=>parcelRequire('jSz6y'));

});

parcelRegister("hKm66", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("58vxn").then(()=>parcelRequire('hQAji'));

});

parcelRegister("dEx1h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cmlOC").then(()=>parcelRequire('3xtWD'));

});

parcelRegister("aMJu4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("36hw4").then(()=>parcelRequire('eQiYt'));

});

parcelRegister("dDu0y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9NuHD").then(()=>parcelRequire('dqxyY'));

});

parcelRegister("79mWw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("84iPv").then(()=>parcelRequire('18cGy'));

});

parcelRegister("b8Fk6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4ue5q").then(()=>parcelRequire('iR31l'));

});

parcelRegister("cNF7k", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fHlCO").then(()=>parcelRequire('lOelZ'));

});

parcelRegister("jgpqh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ctMbG").then(()=>parcelRequire('3Licm'));

});

parcelRegister("aOdYJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gM57Q").then(()=>parcelRequire('3RMJr'));

});

parcelRegister("e22Ok", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6kXiF").then(()=>parcelRequire('ccRqk'));

});

parcelRegister("8urbC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lOR1n").then(()=>parcelRequire('jlRHC'));

});

parcelRegister("4KJac", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1OmYh").then(()=>parcelRequire('hdU4l'));

});

parcelRegister("2RcCi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("72TcZ").then(()=>parcelRequire('bg4qs'));

});

parcelRegister("dfIBs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h17zs").then(()=>parcelRequire('bXjmo'));

});

parcelRegister("k1Un1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4cjRQ").then(()=>parcelRequire('hbvZM'));

});

parcelRegister("jLZMs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1UtoW").then(()=>parcelRequire('9SZbf'));

});

parcelRegister("gZ7mt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fkqig").then(()=>parcelRequire('4sfja'));

});

parcelRegister("94v3A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9v6v2").then(()=>parcelRequire('jJSyq'));

});

parcelRegister("2lLRO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2W2uI").then(()=>parcelRequire('esYr0'));

});

parcelRegister("3APUy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("76DU7").then(()=>parcelRequire('kkpUO'));

});

parcelRegister("i8aPo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7OZqm").then(()=>parcelRequire('3iUAs'));

});

parcelRegister("flN8S", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aWFSq").then(()=>parcelRequire('5aO7u'));

});

parcelRegister("9pNk5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("91xRZ").then(()=>parcelRequire('kSTRY'));

});

parcelRegister("dcTqE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7KJS3").then(()=>parcelRequire('8L6O0'));

});

parcelRegister("ersfL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2opjf").then(()=>parcelRequire('1n6Tv'));

});

parcelRegister("aAkrG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2JkmG").then(()=>parcelRequire('a6grx'));

});

parcelRegister("fs9Ff", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hBlbT").then(()=>parcelRequire('fMBK6'));

});

parcelRegister("1QFpi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iJHpb").then(()=>parcelRequire('fIct9'));

});

parcelRegister("5CJbP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2ZRim").then(()=>parcelRequire('d9DSx'));

});

parcelRegister("e2JKU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7toaW").then(()=>parcelRequire('8MczM'));

});

parcelRegister("julaN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d8rc5").then(()=>parcelRequire('f9CEA'));

});

parcelRegister("5j9zE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lketh").then(()=>parcelRequire('aukRK'));

});

parcelRegister("14SDs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2RMRK").then(()=>parcelRequire('gDXlj'));

});

parcelRegister("ko2co", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kXlAE").then(()=>parcelRequire('cRxjS'));

});

parcelRegister("kIJlo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("vJKBw").then(()=>parcelRequire('iN0TD'));

});

parcelRegister("jy6Gn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ib5Lg").then(()=>parcelRequire('f0AO8'));

});

parcelRegister("6ras6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fLQb1").then(()=>parcelRequire('1WccE'));

});

parcelRegister("84Wzo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kP7EA").then(()=>parcelRequire('c4ZJd'));

});

parcelRegister("etuBt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Bg5pC").then(()=>parcelRequire('5eaqT'));

});

parcelRegister("8qd77", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4WUO7").then(()=>parcelRequire('e3Fek'));

});

parcelRegister("fx4kg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8PkUi").then(()=>parcelRequire('l4ihX'));

});

parcelRegister("eBcZ2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jwmWQ").then(()=>parcelRequire('3JQUg'));

});

parcelRegister("knWnn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("faq55").then(()=>parcelRequire('176pb'));

});

parcelRegister("hW18s", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hAswH").then(()=>parcelRequire('kgit6'));

});

parcelRegister("5azU9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fgHqm").then(()=>parcelRequire('9Mfub'));

});

parcelRegister("4ooJL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bDdUv").then(()=>parcelRequire('5FJm2'));

});

parcelRegister("k4l5O", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aFj2p").then(()=>parcelRequire('7tHOB'));

});

parcelRegister("aoiHO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gSYtn").then(()=>parcelRequire('dc853'));

});

parcelRegister("3UUYF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2xkU4").then(()=>parcelRequire('1xqvM'));

});

parcelRegister("fZSsP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lAhHM").then(()=>parcelRequire('8DRsr'));

});

parcelRegister("2I4Gh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7HLb4").then(()=>parcelRequire('lotpq'));

});

parcelRegister("e42E6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aSAfa").then(()=>parcelRequire('lH1WL'));

});

parcelRegister("h8j2t", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("86qVO").then(()=>parcelRequire('7flDn'));

});

parcelRegister("2OX9i", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("03DTB").then(()=>parcelRequire('86gvQ'));

});

parcelRegister("kRXDa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4logq").then(()=>parcelRequire('7r7DM'));

});

parcelRegister("b3s08", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l2zcJ").then(()=>parcelRequire('7VtFv'));

});

parcelRegister("z8AuJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8iBUd").then(()=>parcelRequire('gzSLN'));

});

parcelRegister("iRQna", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7yTfw").then(()=>parcelRequire('a7XdG'));

});

parcelRegister("6dmyO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gqNom").then(()=>parcelRequire('dXNPM'));

});

parcelRegister("7v49T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cLjn1").then(()=>parcelRequire('lyCCX'));

});

parcelRegister("6kIYe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lsKWZ").then(()=>parcelRequire('7tNNP'));

});

parcelRegister("6pFX4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8fzA1").then(()=>parcelRequire('gpjHm'));

});

parcelRegister("ids57", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5we92").then(()=>parcelRequire('gPCrS'));

});

parcelRegister("6D2SA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("91sYd").then(()=>parcelRequire('csKMg'));

});

parcelRegister("b1i3G", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("Axvpq").then(()=>parcelRequire('h29fM'));

});

parcelRegister("1VWGK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8pNiN").then(()=>parcelRequire('65nrT'));

});

parcelRegister("5YWe9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kCZxo").then(()=>parcelRequire('hjXSk'));

});

parcelRegister("eBeHN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l60KG").then(()=>parcelRequire('3wKur'));

});

parcelRegister("fuxGw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("13LD8").then(()=>parcelRequire('71Upa'));

});

parcelRegister("hYpP3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jL46e").then(()=>parcelRequire('4WFmP'));

});

parcelRegister("9duLT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gPyfG").then(()=>parcelRequire('hKL46'));

});

parcelRegister("jekP9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4j4Cm").then(()=>parcelRequire('8QDt4'));

});

parcelRegister("1trmN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lSP6C").then(()=>parcelRequire('2GxrK'));

});

parcelRegister("a6kwN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eRHU2").then(()=>parcelRequire('6Mcj2'));

});

parcelRegister("1QhGt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1NzrP").then(()=>parcelRequire('8Dd1D'));

});

parcelRegister("2kUTp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ib2zR").then(()=>parcelRequire('bkycp'));

});

parcelRegister("bhmk2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jGOZ9").then(()=>parcelRequire('1jFSV'));

});

parcelRegister("dJoeW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kAjjy").then(()=>parcelRequire('fzddg'));

});

parcelRegister("6d0MA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d2lcE").then(()=>parcelRequire('1BNWg'));

});

parcelRegister("5CNnH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f8LPb").then(()=>parcelRequire('aRT8r'));

});

parcelRegister("1Zz3C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lDINp").then(()=>parcelRequire('cFe6w'));

});

parcelRegister("jbWgu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1XYGH").then(()=>parcelRequire('lV4cu'));

});

parcelRegister("dF8mR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("02MlI")
]).then(()=>parcelRequire('kL8Pv'));

});

parcelRegister("joXpY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kRayy").then(()=>parcelRequire('dmb0C'));

});

parcelRegister("5AS7H", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("emUwt").then(()=>parcelRequire('1PBLv'));

});

parcelRegister("eEPLs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("63y11").then(()=>parcelRequire('jJB5f'));

});

parcelRegister("9v2aS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iWzko").then(()=>parcelRequire('31yJ5'));

});

parcelRegister("e3Fnr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3nZvS").then(()=>parcelRequire('98Jc0'));

});

parcelRegister("jGJY8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("QI8ml").then(()=>parcelRequire('ctmAh'));

});

parcelRegister("95wzO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5fNqK").then(()=>parcelRequire('hqxDX'));

});

parcelRegister("8DcRc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hVr0L").then(()=>parcelRequire('3m9qs'));

});

parcelRegister("139pj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cSMAl").then(()=>parcelRequire('hp7wV'));

});

parcelRegister("1N0io", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a0DsY").then(()=>parcelRequire('3x0R8'));

});

parcelRegister("b8Hdm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3SGXi").then(()=>parcelRequire('jQt7Q'));

});

parcelRegister("2Ul8V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f3BKj").then(()=>parcelRequire('eNoPm'));

});

parcelRegister("3Zui5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hG736").then(()=>parcelRequire('hf4j6'));

});

parcelRegister("8Jkgt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Owt9").then(()=>parcelRequire('lBYoY'));

});

parcelRegister("kN6pL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5PmUO").then(()=>parcelRequire('9WQpC'));

});

parcelRegister("lsY2M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9RrN7").then(()=>parcelRequire('29FGd'));

});

parcelRegister("asiX4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jEyEe").then(()=>parcelRequire('fn3IO'));

});

parcelRegister("5R2g7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4Lol2").then(()=>parcelRequire('eT3c6'));

});

parcelRegister("9bgdS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aWtxi").then(()=>parcelRequire('3MIzd'));

});

parcelRegister("lNNjt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("47iQK").then(()=>parcelRequire('5eThQ'));

});

parcelRegister("eZdV2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lyqgW").then(()=>parcelRequire('igWRZ'));

});

parcelRegister("h1oLK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dkOGb").then(()=>parcelRequire('kSMbZ'));

});

parcelRegister("bK7Hc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6vtRe").then(()=>parcelRequire('asnrw'));

});

parcelRegister("c3uQs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fx2UR").then(()=>parcelRequire('lRJPI'));

});

parcelRegister("gojMk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8yBqA").then(()=>parcelRequire('a1KVy'));

});

parcelRegister("3TEHx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gRTc0").then(()=>parcelRequire('i2YoV'));

});

parcelRegister("7UXxe", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2smId").then(()=>parcelRequire('gMxbn'));

});

parcelRegister("kFm8c", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fjDMw").then(()=>parcelRequire('6iGpw'));

});

parcelRegister("hlX7I", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i6bEu").then(()=>parcelRequire('6FGKP'));

});

parcelRegister("5vfZK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("epDfK").then(()=>parcelRequire('dQZ52'));

});

parcelRegister("46sZB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("vE19n").then(()=>parcelRequire('8HRiz'));

});

parcelRegister("eaERn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("foJkv").then(()=>parcelRequire('9XPKw'));

});

parcelRegister("7UZEp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eczJ8").then(()=>parcelRequire('bo9bG'));

});

parcelRegister("eJfzR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hlS6q").then(()=>parcelRequire('1GXwg'));

});

parcelRegister("4CcSA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Uu0N").then(()=>parcelRequire('l0gsV'));

});

parcelRegister("4SkOy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l7wb0").then(()=>parcelRequire('2z8gH'));

});

parcelRegister("4TkgP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fmGRQ").then(()=>parcelRequire('cN27d'));

});

parcelRegister("dPKaA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ih5vN").then(()=>parcelRequire('6I1k9'));

});

parcelRegister("9Q6UV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ynTB").then(()=>parcelRequire('izB4F'));

});

parcelRegister("csGAU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6KZRN").then(()=>parcelRequire('9HSSy'));

});

parcelRegister("cVSQT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1THRx").then(()=>parcelRequire('9VAyJ'));

});

parcelRegister("9pAb0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1TWhK").then(()=>parcelRequire('4Id3X'));

});

parcelRegister("iFTMv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k1yqG").then(()=>parcelRequire('dG8n7'));

});

parcelRegister("bFNWi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hJwVO").then(()=>parcelRequire('d5omi'));

});

parcelRegister("lijB7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ebFeB").then(()=>parcelRequire('lOUoO'));

});

parcelRegister("buMQ2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("60Kko").then(()=>parcelRequire('8qzGi'));

});

parcelRegister("iKy2S", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("93AJe").then(()=>parcelRequire('6mVMv'));

});

parcelRegister("3c7I0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7AeZE").then(()=>parcelRequire('fWV0o'));

});

parcelRegister("jvriJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fge90").then(()=>parcelRequire('gQOqI'));

});

parcelRegister("gdAAg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6CneV").then(()=>parcelRequire('1K6fV'));

});

parcelRegister("laAWF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("coTFY").then(()=>parcelRequire('lDbqc'));

});

parcelRegister("9qH1U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7NHlT").then(()=>parcelRequire('jjO3y'));

});

parcelRegister("3T5qH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eROSF").then(()=>parcelRequire('jxVsw'));

});

parcelRegister("38wOF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("IVvLs").then(()=>parcelRequire('lrhH1'));

});

parcelRegister("kUQ6C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6yVfy").then(()=>parcelRequire('eSzxJ'));

});

parcelRegister("4MbAR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kq81D").then(()=>parcelRequire('32Pd4'));

});

parcelRegister("9xc3U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cyscp").then(()=>parcelRequire('gwCc3'));

});

parcelRegister("1XbAc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9wUuz").then(()=>parcelRequire('aV8tq'));

});


parcelRegister("6ub4E", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeSearchParams", () => $ffdc098e57e0b8e4$export$e343914da553b968);

var $hCvtI = parcelRequire("hCvtI");
const $ffdc098e57e0b8e4$export$e343914da553b968 = ()=>{
    const route = (0, $hCvtI.usePostOfficeRoute)();
    let result = {};
    if (route?.searchParams) result = Object.fromEntries(route.searchParams);
    if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') result = {
        ...result,
        pathname: window.location.pathname
    };
    return result;
};

});



parcelRegister("czLPq", function(module, exports) {
$parcel$export(module.exports, "default", () => $aac6e8595770463a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $khHng = parcelRequire("khHng");

var $jklGt = parcelRequire("jklGt");

var $7Cbbq = parcelRequire("7Cbbq");

var $62BGq = parcelRequire("62BGq");

var $euxye = parcelRequire("euxye");

var $7ofLU = parcelRequire("7ofLU");

const $aac6e8595770463a$var$STABLE_OBJECT = {};
const $aac6e8595770463a$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $euxye.useMemo)(()=>(0, $7Cbbq.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $khHng.useStableObject)(placementProps ?? $aac6e8595770463a$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $62BGq.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jklGt.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $7ofLU.default), {
                    analyticsChannel: (0, $e01cf78cfd79ace5$export$85183a312807388d),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
$aac6e8595770463a$var$Placement.displayName = "Placement";
const $aac6e8595770463a$var$PlacementMemoized = /*#__PURE__*/ (0, $euxye.memo)($aac6e8595770463a$var$Placement);
var $aac6e8595770463a$export$2e2bcd8739ae039 = $aac6e8595770463a$var$PlacementMemoized;

});
parcelRegister("jklGt", function(module, exports) {
$parcel$export(module.exports, "default", () => $c36145c7207d868c$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $5ySJg = parcelRequire("5ySJg");

var $3YKjt = parcelRequire("3YKjt");
var $j142y = parcelRequire("j142y");
var $hCvtI = parcelRequire("hCvtI");
var $khHng = parcelRequire("khHng");

var $8hetP = parcelRequire("8hetP");

var $hDw0T = parcelRequire("hDw0T");

var $euxye = parcelRequire("euxye");

var $siTdT = parcelRequire("siTdT");


var $3MAu1 = parcelRequire("3MAu1");

var $1SfuJ = parcelRequire("1SfuJ");

var $qqoKJ = parcelRequire("qqoKJ");

var $4FR7Y = parcelRequire("4FR7Y");

var $egspI = parcelRequire("egspI");
const $c36145c7207d868c$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $hDw0T.usePlacementFetchingContext)();
    const arePlacementsGloballyDisabled = (0, $3YKjt.isPostOfficePlacementsGloballyDisabled)(context);
    return (0, $euxye.useMemo)(()=>arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $3MAu1.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        arePlacementsGloballyDisabled,
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $c36145c7207d868c$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $c36145c7207d868c$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $c36145c7207d868c$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $siTdT.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $siTdT.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $c36145c7207d868c$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $hCvtI.usePostOfficeRoute)();
    const context = (0, $j142y.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $1SfuJ.useBuildBasePath)();
    const stableContextWithRoute = (0, $khHng.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $euxye.useMemo)(()=>isUFOEnabled ? new (0, $8hetP.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $euxye.useContext)((0, $qqoKJ.default));
    const ufoV2InteractionContext = (0, $euxye.useContext)((0, $4FR7Y.default));
    const stableUfoV2Interaction = (0, $khHng.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $euxye.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    if ((0, $egspI.fg)('post-office_enable_ufo-v2-add-error')) $c36145c7207d868c$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($c36145c7207d868c$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($c36145c7207d868c$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($c36145c7207d868c$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($c36145c7207d868c$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $c36145c7207d868c$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $euxye.useMemo)(()=>({
            source: (0, $9c67d9a5fe0b8a03$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5ySJg.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext,
        children: children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: componentOnEvent
        })
    });
};
$c36145c7207d868c$var$Placement.displayName = "Placement";
var $c36145c7207d868c$export$2e2bcd8739ae039 = $c36145c7207d868c$var$Placement;

});
const $9c67d9a5fe0b8a03$export$85183a312807388d = 'postOffice';
const $9c67d9a5fe0b8a03$export$f7109619a5e9e0d6 = 'post-office-frontend';

parcelRegister("1SfuJ", function(module, exports) {
$parcel$export(module.exports, "useBuildBasePath", () => $0857609d3be2ffc3$export$83d6c58b7ab7ae67);

var $2yTew = parcelRequire("2yTew");
var $fgdQf = parcelRequire("fgdQf");

var $euxye = parcelRequire("euxye");
const $0857609d3be2ffc3$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $fgdQf.usePostOfficeEnvironment)();
    return (0, $euxye.useMemo)(()=>(0, $2yTew.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});


parcelRegister("7ofLU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cc3fdd223bc4acb$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $kTviw = parcelRequire("kTviw");

var $euxye = parcelRequire("euxye");
class $9cc3fdd223bc4acb$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
$9cc3fdd223bc4acb$var$ErrorBoundary.displayName = "ErrorBoundary";
const $9cc3fdd223bc4acb$var$ErrorBoundaryWithAnalytics = (0, $kTviw.default)()($9cc3fdd223bc4acb$var$ErrorBoundary);
var $9cc3fdd223bc4acb$export$2e2bcd8739ae039 = $9cc3fdd223bc4acb$var$ErrorBoundaryWithAnalytics;

});

const $e01cf78cfd79ace5$export$85183a312807388d = 'postOffice';


parcelRegister("lDSFV", function(module, exports) {
$parcel$export(module.exports, "ScreenSpaceFlagPlacementPreviewSwitcher", () => $6199a88adbae2ef4$export$46db7cd62b063064);

var $e79Pd = parcelRequire("e79Pd");

var $hCvtI = parcelRequire("hCvtI");

var $4EfSr = parcelRequire("4EfSr");

var $5fkf9 = parcelRequire("5fkf9");

var $7igeQ = parcelRequire("7igeQ");

var $czLPq = parcelRequire("czLPq");
const $6199a88adbae2ef4$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $7igeQ.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4EfSr.PlacementPreviewProvider), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $czLPq.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
$6199a88adbae2ef4$export$16e97e6603eadea.displayName = "PlacementPreview";
const $6199a88adbae2ef4$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $hCvtI.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const localeForPreview = searchParams?.get('locale');
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId,
                localeForPreview: localeForPreview
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $e79Pd.jsx)($6199a88adbae2ef4$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $5fkf9.ScreenSpaceFlagsPlacementComponent),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$6199a88adbae2ef4$export$46db7cd62b063064.displayName = "ScreenSpaceFlagPlacementPreviewSwitcher";

});
parcelRegister("4EfSr", function(module, exports) {
$parcel$export(module.exports, "PlacementPreviewProvider", () => $af6e6744fa0cca15$export$52e362b70e115c68);

var $fnBO4 = parcelRequire("fnBO4");
const $af6e6744fa0cca15$export$52e362b70e115c68 = (0, $fnBO4.PlacementPreviewProvider);
const $af6e6744fa0cca15$export$c05392ff95b4319d = (0, $fnBO4.createPreviewFetch);

});
parcelRegister("fnBO4", function(module, exports) {
$parcel$export(module.exports, "PlacementPreviewProvider", () => $8c1296c450c49113$export$52e362b70e115c68);
$parcel$export(module.exports, "createPreviewFetch", () => $8c1296c450c49113$export$c05392ff95b4319d);

var $euxye = parcelRequire("euxye");

var $hDw0T = parcelRequire("hDw0T");
const $8c1296c450c49113$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $8c1296c450c49113$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $8c1296c450c49113$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $euxye.useMemo)(()=>{
        if (returnOverride) return $8c1296c450c49113$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $8c1296c450c49113$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hDw0T.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
$8c1296c450c49113$export$52e362b70e115c68.displayName = "PlacementPreviewProvider";
const $8c1296c450c49113$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $8c1296c450c49113$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($8c1296c450c49113$export$e5ffd38dcf6e5c53, $8c1296c450c49113$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $8c1296c450c49113$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $8c1296c450c49113$var$stringifyPayload(payload)
        });
    };
const $8c1296c450c49113$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $8c1296c450c49113$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($8c1296c450c49113$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $8c1296c450c49113$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};

});


parcelRegister("7igeQ", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $54f6cf7418b65168$export$e926676385687eaf);

var $euxye = parcelRequire("euxye");
'use client';
const $54f6cf7418b65168$export$b16d9fb1a22de840 = (0, $euxye.createContext)(null);
const $54f6cf7418b65168$var$initialState = {
    didCatch: false,
    error: null
};
class $54f6cf7418b65168$export$e926676385687eaf extends (0, $euxye.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $54f6cf7418b65168$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($54f6cf7418b65168$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $54f6cf7418b65168$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($54f6cf7418b65168$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $euxye.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $euxye.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $euxye.createElement)($54f6cf7418b65168$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $54f6cf7418b65168$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $54f6cf7418b65168$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $54f6cf7418b65168$export$c052f6604b7d51fe() {
    const context = (0, $euxye.useContext)($54f6cf7418b65168$export$b16d9fb1a22de840);
    $54f6cf7418b65168$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $euxye.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $euxye.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $54f6cf7418b65168$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $euxye.forwardRef)((props, ref)=>(0, $euxye.createElement)($54f6cf7418b65168$export$e926676385687eaf, errorBoundaryProps, (0, $euxye.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});


/* eslint-disable jira/filename-case */ const $4a7259f4b0dbf3a6$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';

parcelRegister("jfW0Y", function(module, exports) {
$parcel$export(module.exports, "isRestrictedFromPostOfficeSynthetic", () => $eb880df5408721b4$export$9c1a9b8d86d81805);
/* eslint-disable jira/filename-case */ 
var $1hZ79 = parcelRequire("1hZ79");

var $i860n = parcelRequire("i860n");
const $eb880df5408721b4$export$9c1a9b8d86d81805 = ()=>{
    if ((0, $1hZ79.isSynthetic)()) // permanent gate containing a segment of Post Office Pollinator accounts
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/segments/segment%3Apost-office-pollinator-accounts
    return !(0, $i860n.fg)('post-office-is-post-office-synthetic');
    return false;
};

});


parcelRegister("7jSss", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelsProvider", () => $136fde521e1ea95d$export$65ae37e9c61321f9);
$parcel$export(module.exports, "usePreviewPanelStateChanged", () => $136fde521e1ea95d$export$5e98dc0fae8a152c);

var $euxye = parcelRequire("euxye");

var $1uH7N = parcelRequire("1uH7N");

var $f99M0 = parcelRequire("f99M0");

var $75YsU = parcelRequire("75YsU");

var $f2wVS = parcelRequire("f2wVS");
var $2ffUK = parcelRequire("2ffUK");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $kt86l = parcelRequire("kt86l");

var $bbaOA = parcelRequire("bbaOA");

var $h0TMG = parcelRequire("h0TMG");

var $jn0ly = parcelRequire("jn0ly");

var $l0gQX = parcelRequire("l0gQX");

var $5IRCU = parcelRequire("5IRCU");

var $jCByN = parcelRequire("jCByN");


var $29eRG = parcelRequire("29eRG");

var $XssJM = parcelRequire("XssJM");


var $aWliK = parcelRequire("aWliK");

var $fKsee = parcelRequire("fKsee");

var $52FsB = parcelRequire("52FsB");

var $5MzDM = parcelRequire("5MzDM");

var $8mbs3 = parcelRequire("8mbs3");

var $4yHnQ = parcelRequire("4yHnQ");

var $cArDJ = parcelRequire("cArDJ");

var $5ppLt = parcelRequire("5ppLt");
const $136fde521e1ea95d$var$MaybePreviewPanelsNavigationProvider = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('jivtech-1920-back-navigation-gpp') || (0, $2700E.expVal)('nin_issue_preview_panel_navigation', 'isEnabled', false), (0, $jCByN.PreviewPanelsNavigationProvider), (0, $euxye.Fragment));
const $136fde521e1ea95d$var$MaybeJiraPreviewPanelsNavigationProvider = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('jivtech-1920-back-navigation-gpp') || (0, $2700E.expVal)('nin_issue_preview_panel_navigation', 'isEnabled', false), (0, $5MzDM.JiraPreviewPanelsNavigationProvider), (0, $euxye.Fragment));
const $136fde521e1ea95d$var$LIST_VIEW_ROUTES = [
    'software-list',
    'classic-business-list',
    'software-list-classic',
    'legacy-gin',
    'global-issue-navigator',
    'issue-navigator'
];
const $136fde521e1ea95d$var$LIST_VIEW_ROUTES_NEW = [
    'software-list',
    'classic-business-list',
    'software-list-classic',
    'legacy-gin',
    'global-issue-navigator',
    'issue-navigator',
    'issue-navigator-core',
    'issue-navigator-classic',
    'software-issue-navigator',
    'servicedesk-issues',
    'jsm-list-nin',
    'jwm-list-nin'
];
const $136fde521e1ea95d$var$parentProduct = 'jira-software';
const $136fde521e1ea95d$export$eed91152c097781f = (0, $f2wVS.createRouterSelector)(({ route: route, location: location })=>{
    if (!route.supportsPreviewPanel) return null;
    // Some routes (e.g. NIN) intermittently add/remove a trailing slash from the pathname,
    // which would cause the panel to close unexpectedly. Strip it for a stable key.
    const pathname = (0, $i860n.fg)('nin_glance_panel_technical_changes') ? location.pathname.replace(/\/$/, '') : location.pathname;
    return `${route.name}:${pathname}`;
});
const $136fde521e1ea95d$export$2033ad2ecdab8ea3 = (0, $f2wVS.createRouterSelector)(({ route: route })=>{
    if ((0, $i860n.fg)('nin_add_list_routes_to_preview_panels_provider')) return route?.name ? !$136fde521e1ea95d$var$LIST_VIEW_ROUTES_NEW.includes(route.name) : true;
    return route?.name ? !$136fde521e1ea95d$var$LIST_VIEW_ROUTES.includes(route.name) : true;
});
const $136fde521e1ea95d$var$isJiraIssueAri = (ari)=>ari.startsWith('ari:cloud:jira:') && ari.includes(':issue/');
const $136fde521e1ea95d$var$JiraPreviewPanelsProviderOld = ({ children: children, navigation: navigation, subscribe: subscribe })=>{
    (0, $1uH7N.di)(window);
    const cloudId = (0, $kt86l.useCloudId)();
    const { close: close } = (0, $l0gQX.usePreviewPanelsActions)();
    const enabledRoute = $136fde521e1ea95d$export$eed91152c097781f();
    const isIssueEmbed = enabledRoute?.split(':')[0] === 'issue-embed';
    let SUPPORT_PANEL_TYPES_MILESTONE_ONE = [];
    const { data: project } = (0, $XssJM.useProject)();
    const projectType = (0, $f99M0.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $f99M0.SERVICE_DESK_PROJECT) || projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT);
    SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('townsquare-project');
    SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('jira-issue');
    SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('identity-team');
    /**
	 * Update Jira Preview Panel integration for different products
	 * (Confluence, Goals, Team, Project) behind different FGs.
	 * This is to have ability to control different product integrations using FG.
	 * So, that we should be able to turn specific product ON/OFF individually.
	 */ SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('townsquare-goal');
    SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('confluence-page');
    if ((0, $i860n.fg)('jira-preview-panel-assets-integration')) SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('cmdb-object');
    if (!(0, $i860n.fg)('jira_preview_panel_m_1_rollout') || isJSMOrJPDProject) SUPPORT_PANEL_TYPES_MILESTONE_ONE = [];
    let supportedObjects = SUPPORT_PANEL_TYPES_MILESTONE_ONE;
    // If the route is an issue embed, we can get the supported objects from the URL search params.
    // This allows us to support custom objects in the preview panel for the host application.
    if (isIssueEmbed && typeof window !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        supportedObjects = urlSearchParams.get('previewPanels')?.split(',')?.map((0, $h0TMG.asGlobalObjectType));
    }
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $bbaOA.useGlobalObjectPreviewPanels)('jira', cloudId, {
        supportedObjects: supportedObjects,
        enabled: enabledRoute !== null
    });
    (0, $bbaOA.usePreviewPanelIFrameCommunication)(openPreviewPanel);
    (0, $8mbs3.useEmbeddedConfluencePanelCommunication)({
        closePreviewPanel: close
    });
    (0, $euxye.useEffect)(()=>()=>{
            // automatically close the preview panel when the route changes
            close();
        }, [
        enabledRoute,
        close
    ]);
    const value = (0, $euxye.useMemo)(()=>({
            subscribe: subscribe,
            openPreviewPanel: openPreviewPanel,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            navigation: navigation,
            closePreviewPanel: close
        }), [
        subscribe,
        openPreviewPanel,
        isPreviewPanelAvailable,
        close,
        navigation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $52FsB.JiraPreviewPanelsContext).Provider, {
        value: value
    }, children);
};
$136fde521e1ea95d$var$JiraPreviewPanelsProviderOld.displayName = "JiraPreviewPanelsProviderOld";
const $136fde521e1ea95d$var$JiraPreviewPanelsProviderNew = ({ children: children, navigation: navigation, subscribe: subscribe })=>{
    (0, $1uH7N.di)(window);
    const cloudId = (0, $kt86l.useCloudId)();
    const { close: close } = (0, $l0gQX.usePreviewPanelsActions)();
    const enabledRoute = $136fde521e1ea95d$export$eed91152c097781f();
    const isIssueEmbed = enabledRoute?.split(':')[0] === 'issue-embed';
    const currentPanel = (0, $5IRCU.useCurrentPreviewPanel)();
    let SUPPORT_PANEL_TYPES_MILESTONE_ONE = [];
    const { data: project } = (0, $XssJM.useProject)();
    const projectType = (0, $f99M0.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $f99M0.SERVICE_DESK_PROJECT) || projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT);
    SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('townsquare-project');
    SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('jira-issue');
    SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('identity-team');
    /**
	 * Update Jira Preview Panel integration for different products
	 * (Confluence, Goals, Team, Project) behind different FGs.
	 * This is to have ability to control different product integrations using FG.
	 * So, that we should be able to turn specific product ON/OFF individually.
	 */ SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('townsquare-goal');
    SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('confluence-page');
    if ((0, $i860n.fg)('jira-preview-panel-assets-integration')) SUPPORT_PANEL_TYPES_MILESTONE_ONE.push('cmdb-object');
    if (!(0, $i860n.fg)('jira_preview_panel_m_1_rollout') || isJSMOrJPDProject) SUPPORT_PANEL_TYPES_MILESTONE_ONE = [];
    let supportedObjects = SUPPORT_PANEL_TYPES_MILESTONE_ONE;
    // If the route is an issue embed, we can get the supported objects from the URL search params.
    // This allows us to support custom objects in the preview panel for the host application.
    if (isIssueEmbed && typeof window !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        supportedObjects = urlSearchParams.get('previewPanels')?.split(',')?.map((0, $h0TMG.asGlobalObjectType));
    }
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPlatformPreviewPanel } = (0, $bbaOA.useGlobalObjectPreviewPanels)('jira', cloudId, {
        supportedObjects: supportedObjects,
        enabled: enabledRoute !== null
    });
    const isNativeIssuePanelOpen = currentPanel != null && (0, $fKsee.isNativeIssueViewPreviewPanel)(currentPanel);
    const openPreviewPanel = (0, $euxye.useCallback)((props)=>{
        if (isNativeIssuePanelOpen && $136fde521e1ea95d$var$isJiraIssueAri(props.ari) && currentPanel?.onSamePanelTypeNavigate) {
            const didHandleSamePanelTypeNavigate = currentPanel.onSamePanelTypeNavigate({
                ari: props.ari,
                url: props.url
            });
            if (didHandleSamePanelTypeNavigate) return;
        }
        openPlatformPreviewPanel(props);
    }, [
        isNativeIssuePanelOpen,
        currentPanel,
        openPlatformPreviewPanel
    ]);
    (0, $bbaOA.usePreviewPanelIFrameCommunication)(openPreviewPanel);
    (0, $8mbs3.useEmbeddedConfluencePanelCommunication)({
        closePreviewPanel: close
    });
    (0, $euxye.useEffect)(()=>()=>{
            // automatically close the preview panel when the route changes
            close();
        }, [
        enabledRoute,
        close
    ]);
    const value = (0, $euxye.useMemo)(()=>({
            subscribe: subscribe,
            openPreviewPanel: openPreviewPanel,
            navigation: navigation,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            closePreviewPanel: close
        }), [
        subscribe,
        openPreviewPanel,
        isPreviewPanelAvailable,
        close,
        navigation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $52FsB.JiraPreviewPanelsContext).Provider, {
        value: value
    }, children);
};
$136fde521e1ea95d$var$JiraPreviewPanelsProviderNew.displayName = "JiraPreviewPanelsProviderNew";
const $136fde521e1ea95d$var$JiraPreviewPanelsProvider = (0, $aWliK.componentWithCondition)((0, $75YsU.isWorkItemModernizationGatesEnabled), $136fde521e1ea95d$var$JiraPreviewPanelsProviderNew, $136fde521e1ea95d$var$JiraPreviewPanelsProviderOld);
const $136fde521e1ea95d$export$65ae37e9c61321f9 = ({ children: children })=>{
    const subscribers = (0, $euxye.useRef)(new Set());
    const { closeRightSidebar: closeRightSidebar } = (0, $29eRG.useRightSidebarController)();
    const [, setSelectedIssue] = (0, $2ffUK.useQueryParam)('selectedIssue');
    const isNotListView = $136fde521e1ea95d$export$2033ad2ecdab8ea3();
    const isNotListViewRef = (0, $euxye.useRef)(isNotListView);
    isNotListViewRef.current = isNotListView;
    const notifySubscribers = (0, $euxye.useCallback)((event)=>{
        subscribers.current.forEach((callback)=>callback(event));
    }, []);
    const handlePreviewPanelOpen = (0, $euxye.useCallback)((panel)=>{
        // Close Rovo Chat when a preview panel opens
        closeRightSidebar((0, $2de0ca8181f03e7e$export$dffb4ed44e20ea9a));
        // Close Help Panel when a preview panel opens
        closeRightSidebar((0, $2b56b53c34bc2033$export$e99efa3985fa3c26));
        // Close legacy Embedded Confluence Side Panel when a preview panel opens
        globalThis.window?.postMessage({
            type: 'CLOSE_EMBEDDED_CONFLUENCE_PANEL'
        }, '*');
        notifySubscribers({
            action: 'open',
            panel: panel
        });
        if (!(0, $fKsee.isNativeIssueViewPreviewPanel)(panel) && isNotListViewRef.current && !(0, $i860n.fg)('jivtech-1920-back-navigation-gpp')) setSelectedIssue?.(undefined);
    }, [
        closeRightSidebar,
        notifySubscribers,
        setSelectedIssue
    ]);
    const handlePreviewPanelClose = (0, $euxye.useCallback)((panel)=>{
        notifySubscribers({
            action: 'close',
            panel: panel
        });
    }, [
        notifySubscribers
    ]);
    const subscribe = (0, $euxye.useCallback)((callback)=>{
        subscribers.current.add(callback);
        return ()=>{
            subscribers.current.delete(callback);
        };
    }, []);
    const initialPanelNavigationRef = (0, $cArDJ.useInitialPanelNavigationRef)();
    const initialPanel = (0, $4yHnQ.useInitialPanel)(initialPanelNavigationRef);
    const initialPanelWidth = (0, $5ppLt.useInitialPanelWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jn0ly.PreviewPanelsProvider), {
        onPreviewPanelOpen: handlePreviewPanelOpen,
        onPreviewPanelClose: handlePreviewPanelClose,
        parentProduct: $136fde521e1ea95d$var$parentProduct,
        ...(0, $i860n.fg)('nin_glance_panel_technical_changes') && {
            initialPanel: initialPanel
        },
        ...(0, $i860n.fg)('nin_glance_panel_initial_width_ssr') && {
            initialWidth: initialPanelWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($136fde521e1ea95d$var$MaybePreviewPanelsNavigationProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($136fde521e1ea95d$var$JiraPreviewPanelsProvider, {
        navigation: initialPanelNavigationRef,
        subscribe: subscribe
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($136fde521e1ea95d$var$MaybeJiraPreviewPanelsNavigationProvider, null, children))));
};
$136fde521e1ea95d$export$65ae37e9c61321f9.displayName = "PreviewPanelsProvider";
const $136fde521e1ea95d$export$5e98dc0fae8a152c = (callback)=>{
    const { subscribe: subscribe } = (0, $euxye.useContext)((0, $52FsB.JiraPreviewPanelsContext)) ?? {};
    (0, $euxye.useEffect)(()=>{
        if (!subscribe) return;
        const unsubscribe = subscribe(callback);
        return ()=>unsubscribe();
    }, [
        subscribe,
        callback
    ]);
};

});
parcelRegister("bbaOA", function(module, exports) {
$parcel$export(module.exports, "useGlobalObjectPreviewPanels", () => $09f946398b9ffe7d$export$70bcacea0b970dee);
$parcel$export(module.exports, "usePreviewPanelIFrameCommunication", () => $09f946398b9ffe7d$export$3cfc2fe60a8f0a1c);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $n67Vb = parcelRequire("n67Vb");

var $4LDqh = parcelRequire("4LDqh");

var $bzQbK = parcelRequire("bzQbK");

var $3SFM2 = parcelRequire("3SFM2");

var $f75WD = parcelRequire("f75WD");

var $faDlH = parcelRequire("faDlH");

var $8pn4B = parcelRequire("8pn4B");

var $4Olij = parcelRequire("4Olij");

var $f8arg = parcelRequire("f8arg");

var $8ikZc = parcelRequire("8ikZc");

var $eYjNM = parcelRequire("eYjNM");

var $egspI = parcelRequire("egspI");

var $6fsuc = parcelRequire("6fsuc");

var $2mXfp = parcelRequire("2mXfp");

var $50XJb = parcelRequire("50XJb");

var $6PxvK = parcelRequire("6PxvK");

var $l0gQX = parcelRequire("l0gQX");

var $6THxV = parcelRequire("6THxV");

var $89kOy = parcelRequire("89kOy");

var $cxpqA = parcelRequire("cxpqA");

var $dqOOP = parcelRequire("dqOOP");

var $f0bXQ = parcelRequire("f0bXQ");

var $jVtj7 = parcelRequire("jVtj7");

var $3cXD8 = parcelRequire("3cXD8");

var $YTtNs = parcelRequire("YTtNs");

var $h0TMG = parcelRequire("h0TMG");
const $09f946398b9ffe7d$var$getGlobalObjectType = (ari)=>{
    const parsedAri = (0, $6fsuc.AnyAri).parse(ari);
    return `${parsedAri.resourceOwner}-${parsedAri.resourceType}`;
};
const $09f946398b9ffe7d$export$70bcacea0b970dee = (product, cloudId, options)=>{
    const { enabled: enabled = true, activityTabSlot: activityTabSlot, supportedObjects: supportedObjects = (0, $f0bXQ.ALL_SUPPORTED_OBJECTS), analyticsAttributes: analyticsAttributes, rootSourceScreen: rootSourceScreen, environmentProvider: environmentProviderOverride } = options ?? {};
    const defaultEnvironmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const environmentProvider = environmentProviderOverride ?? defaultEnvironmentProvider;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { open: open } = (0, $l0gQX.usePreviewPanelsActions)();
    const enableDiscoverPreviewPanelsExp = (0, $4LDqh.default).getExperimentValue('townsquare_enable_discover_preview_panels_exp', 'cohort', 'control', {
        fireExperimentExposure: false
    });
    const isPreviewPanelAvailable = (0, $euxye.useCallback)(({ ari: ari })=>{
        const panelType = $09f946398b9ffe7d$var$getGlobalObjectType(ari);
        const panelEnabled = enabled && supportedObjects.includes(panelType);
        if (panelType === 'confluence-blogpost') return panelEnabled && enableDiscoverPreviewPanelsExp !== 'control';
        return panelEnabled;
    }, [
        enabled,
        supportedObjects,
        enableDiscoverPreviewPanelsExp
    ]);
    const openPreviewPanel = (0, $euxye.useCallback)(({ url: url, ari: ari, name: name, parentProduct: parentProduct, panelData: panelData, onOpen: onOpen })=>{
        const globalObjectType = $09f946398b9ffe7d$var$getGlobalObjectType(ari);
        if (!isPreviewPanelAvailable({
            ari: ari
        })) throw new Error(`Preview panel for ${globalObjectType} with ARI ${ari} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $h0TMG.isInIframe)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari,
                    name: name,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        let panelContent;
        let panelProduct;
        switch(globalObjectType){
            case 'jira-issue':
                const JiraIcon = product === 'jira' ? (0, (/*@__PURE__*/$parcel$interopDefault($8ikZc))) : (0, (/*@__PURE__*/$parcel$interopDefault($eYjNM)));
                const title = formatMessage((0, $jVtj7.default).workItem);
                panelContent = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $YTtNs.IFramePreviewPanel), {
                    name: title,
                    url: url,
                    iframeUrl: // Availability check only — this decides whether the embed URL carries the
                    // rootSourceScreen, NOT whether the user is accessing the Capacity
                    // planning experience. We therefore read the GA experiment WITHOUT
                    // firing a Statsig exposure (fireExperimentExposure: false); exposure is
                    // fired at the point the user actually opens the Capacity experience,
                    // keeping the GA experiment's population clean.
                    //
                    // The OR still short-circuits: when the legacy EAP gate is ON the
                    // experiment is never read at all. EAP customers remain unconditionally
                    // enabled.
                    (0, $egspI.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $4LDqh.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? (0, $h0TMG.buildIssueViewEmbedUrl)(url, supportedObjects, rootSourceScreen) : (0, $h0TMG.buildIssueViewEmbedUrl)(url, supportedObjects),
                    icon: /*#__PURE__*/ (0, $e79Pd.jsx)(JiraIcon, {
                        label: ""
                    }),
                    panelType: "jira-work-item",
                    product: "jira",
                    parentProduct: parentProduct,
                    ari: ari,
                    ...(0, $egspI.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $4LDqh.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? {
                        analyticsAttributes: analyticsAttributes
                    } : {}
                });
                panelProduct = 'jira';
                break;
            case 'identity-team':
                {
                    const teamEntryPointReference = (0, $n67Vb.loadEntryPoint)(environmentProvider, (0, $dqOOP.default), {
                        cloudId: cloudId
                    });
                    const teamPanel = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3cXD8.EntryPointPreviewPanel), {
                        entryPoint: (0, $dqOOP.default),
                        preloadedEntryPointReference: teamEntryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            ari: ari,
                            cloudId: cloudId,
                            openPreviewPanel: openPreviewPanel
                        },
                        globalObject: {
                            name: formatMessage((0, $jVtj7.default).team),
                            url: url,
                            icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Olij))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? teamPanel : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxpqA.AtlassianRelayEnvironmentProvider), {
                        children: teamPanel
                    });
                    panelProduct = 'people';
                    break;
                }
            case 'townsquare-goal':
                {
                    const entryPointReference = (0, $n67Vb.loadEntryPoint)(environmentProvider, (0, $50XJb.default), {
                        ari: ari
                    });
                    const goalPanel = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3cXD8.EntryPointPreviewPanel), {
                        entryPoint: (0, $50XJb.default),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $89kOy.getDefaultSelectedTab)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $jVtj7.default).goal),
                            url: url,
                            icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3SFM2))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? goalPanel : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxpqA.AtlassianRelayEnvironmentProvider), {
                        children: goalPanel
                    });
                    panelProduct = 'townsquare';
                    break;
                }
            case 'townsquare-project':
                {
                    const entryPointReference = (0, $n67Vb.loadEntryPoint)(environmentProvider, (0, $6THxV.default), {
                        ari: ari
                    });
                    const projectPanel = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3cXD8.EntryPointPreviewPanel), {
                        entryPoint: (0, $6THxV.default),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $89kOy.getDefaultSelectedTab)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $jVtj7.default).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($faDlH))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? projectPanel : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxpqA.AtlassianRelayEnvironmentProvider), {
                        children: projectPanel
                    });
                    panelProduct = 'townsquare';
                    break;
                }
            case 'confluence-blogpost':
            case 'confluence-page':
                {
                    const isBlogPost = globalObjectType === 'confluence-blogpost';
                    // Fall through if blogpost experiment is not enabled and we are trying to render a blogpost preview panel
                    if (isBlogPost && enableDiscoverPreviewPanelsExp === 'control') return;
                    const urlObj = new URL(url);
                    urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $f0bXQ.ALL_SUPPORTED_OBJECTS).join(',')));
                    const formattedUrl = urlObj.toString();
                    const entryPointReference = (0, $n67Vb.loadEntryPoint)(environmentProvider, (0, $2mXfp.confluencePagePreviewPanelEntryPoint), {});
                    panelContent = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3cXD8.EntryPointPreviewPanel), {
                        entryPoint: (0, $2mXfp.confluencePagePreviewPanelEntryPoint),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: formattedUrl,
                            parentProduct: product,
                            contentType: isBlogPost ? 'blogpost' : 'page',
                            panelData: panelData,
                            cloudId: cloudId
                        },
                        globalObject: {
                            name: formatMessage(isBlogPost ? (0, $jVtj7.default).blogPost : (0, $jVtj7.default).page),
                            url: formattedUrl,
                            icon: isBlogPost ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8pn4B))), {
                                label: ""
                            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f75WD))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $n67Vb.loadEntryPoint)(environmentProvider, (0, $2mXfp.confluencePagePreviewPanelEntryPoint), {});
                    panelContent = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3cXD8.EntryPointPreviewPanel), {
                        entryPoint: (0, $2mXfp.confluencePagePreviewPanelEntryPoint),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $jVtj7.default).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8arg))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'cmdb-object':
                {
                    const assetsEntryPointReference = (0, $n67Vb.loadEntryPoint)(environmentProvider, (0, $6PxvK.default), {
                        cloudId: cloudId
                    });
                    panelContent = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3cXD8.EntryPointPreviewPanel), {
                        entryPoint: (0, $6PxvK.default),
                        preloadedEntryPointReference: assetsEntryPointReference,
                        runtimeProps: {
                            activityTabSlot: activityTabSlot,
                            url: url,
                            parentProduct: product,
                            ari: ari,
                            cloudId: cloudId,
                            openPreviewPanel: openPreviewPanel
                        },
                        // These are fallback properties
                        globalObject: {
                            name: formatMessage((0, $jVtj7.default).object),
                            url: url,
                            icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bzQbK))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'assetsPreviewPanel';
                    break;
                }
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari,
                type: globalObjectType,
                content: ()=>panelContent,
                product: panelProduct
            },
            ...(0, $egspI.fg)('jivtech-1920-back-navigation-gpp') ? {
                onOpen: onOpen
            } : {}
        });
    }, [
        isPreviewPanelAvailable,
        enableDiscoverPreviewPanelsExp,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        environmentProviderOverride,
        product,
        cloudId,
        activityTabSlot,
        analyticsAttributes,
        rootSourceScreen
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
};
const $09f946398b9ffe7d$var$isAllowedOrigin = (origin)=>{
    return origin === window.location.origin;
};
const $09f946398b9ffe7d$export$3cfc2fe60a8f0a1c = (openPreviewPanel)=>{
    // Listen for messages from iframes to open panels
    (0, $euxye.useEffect)(()=>{
        const handleMessage = (event)=>{
            // Validate origin FIRST - reject messages from untrusted origins
            // Protected by feature flag: vuln-fix-adding-origin-validation-for-iframe-pp
            if (!$09f946398b9ffe7d$var$isAllowedOrigin(event.origin) && (0, $egspI.fg)('vuln-fix-adding-origin-validation-for-iframe-pp')) return;
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            const { payload: payload } = event.data;
            if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                url: payload.url,
                ari: payload.ari,
                name: payload.name,
                panelData: payload.panelData
            });
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openPreviewPanel
    ]);
};

});
parcelRegister("bzQbK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86db7221be2575c0$var$_react = $86db7221be2575c0$var$_interopRequireDefault((parcelRequire("euxye")));

var $86db7221be2575c0$var$_baseNew = $86db7221be2575c0$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $86db7221be2575c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86db7221be2575c0$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $86db7221be2575c0$var$_react.default.createElement($86db7221be2575c0$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$86db7221be2575c0$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $86db7221be2575c0$var$_default = module.exports.default = $86db7221be2575c0$var$AssetsObjectIcon;

});

parcelRegister("f75WD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b00c1ef2dcc5a547$var$_react = $b00c1ef2dcc5a547$var$_interopRequireDefault((parcelRequire("euxye")));

var $b00c1ef2dcc5a547$var$_baseNew = $b00c1ef2dcc5a547$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $b00c1ef2dcc5a547$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b00c1ef2dcc5a547$var$PageIcon = (props)=>/*#__PURE__*/ $b00c1ef2dcc5a547$var$_react.default.createElement($b00c1ef2dcc5a547$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$b00c1ef2dcc5a547$var$PageIcon.displayName = 'PageIcon';
var $b00c1ef2dcc5a547$var$_default = module.exports.default = $b00c1ef2dcc5a547$var$PageIcon;

});

parcelRegister("8pn4B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b5ace82dd4a8965510da799b9153030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61f28e5e68150d60$var$_react = $61f28e5e68150d60$var$_interopRequireDefault((parcelRequire("euxye")));

var $61f28e5e68150d60$var$_baseNew = $61f28e5e68150d60$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $61f28e5e68150d60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61f28e5e68150d60$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $61f28e5e68150d60$var$_react.default.createElement($61f28e5e68150d60$var$_baseNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$61f28e5e68150d60$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $61f28e5e68150d60$var$_default = module.exports.default = $61f28e5e68150d60$var$QuotationMarkIcon;

});

parcelRegister("f8arg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63bc83d2df21e8aa09401170cfaa4b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b03fb34c2e0556fe$var$_react = $b03fb34c2e0556fe$var$_interopRequireDefault((parcelRequire("euxye")));

var $b03fb34c2e0556fe$var$_baseNew = $b03fb34c2e0556fe$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $b03fb34c2e0556fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b03fb34c2e0556fe$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $b03fb34c2e0556fe$var$_react.default.createElement($b03fb34c2e0556fe$var$_baseNew.default, Object.assign({
        name: "WhiteboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.177c-.714.282-1.28.817-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.168 8.61.782c.943-.372 2.248-.49 3.09.375.346.356.536.777.548 1.236.011.437-.14.827-.323 1.144-.228.394-.557.761-.876 1.074 1.466-.136 2.717.239 3.421 1.134.827 1.05.644 2.464-.256 3.697l-1.212-.884c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.757-2.524-.512-.521.09-.935.138-1.236.13a1.4 1.4 0 0 1-.537-.11.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.495 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.181.102-.178.124-.292.123-.354-.002-.04-.01-.113-.124-.23-.2-.204-.716-.321-1.464-.026M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$b03fb34c2e0556fe$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $b03fb34c2e0556fe$var$_default = module.exports.default = $b03fb34c2e0556fe$var$WhiteboardIcon;

});

parcelRegister("8ikZc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60a04891e754a221$var$_react = $60a04891e754a221$var$_interopRequireDefault((parcelRequire("euxye")));

var $60a04891e754a221$var$_baseNew = $60a04891e754a221$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $60a04891e754a221$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60a04891e754a221$var$WorkItemIcon = (props)=>/*#__PURE__*/ $60a04891e754a221$var$_react.default.createElement($60a04891e754a221$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$60a04891e754a221$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $60a04891e754a221$var$_default = module.exports.default = $60a04891e754a221$var$WorkItemIcon;

});

parcelRegister("2mXfp", function(module, exports) {
$parcel$export(module.exports, "confluencePagePreviewPanelEntryPoint", () => $2cfea2f3833fb061$export$a50c261b4b52f403);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $2cfea2f3833fb061$export$a50c261b4b52f403 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8WaKC")), {
        moduleId: "d73b44f1",
        priority: "interaction",
        moduleId: 'confluence-preview-panel-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8WaKC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9B7m5").then(()=>parcelRequire('dRi0Q'));

});


parcelRegister("50XJb", function(module, exports) {
$parcel$export(module.exports, "default", () => $7724e89a7ae22c22$export$2e2bcd8739ae039);

var $VoOhq = parcelRequire("VoOhq");

var $9vjEd = parcelRequire("9vjEd");

var $dp4uQ = parcelRequire("dp4uQ");

var $8KAcR = parcelRequire("8KAcR");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $9Ufna = parcelRequire("9Ufna");
const $7724e89a7ae22c22$var$fetchPolicy = 'network-only';

const $7724e89a7ae22c22$var$atlasGoalEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dBttT")), {
        moduleId: "ba76ccc1",
        moduleName: "GoalPanel",
        priority: "interaction",
        moduleId: 'atlas-goal-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $VoOhq.default)('townsquare-goal-panel-opened');
        const siteId = (0, $8KAcR.getSiteId)('goal', ari);
        const queryContext = siteId ? (0, $9vjEd.createPlatformSiteAri)(siteId) : null;
        const capabilitiesContainerId = siteId ? (0, $dp4uQ.getSiteAri)(siteId) : '';
        return {
            queries: {
                queryReference: {
                    parameters: $9Ufna.default,
                    variables: {
                        ari: ari,
                        queryContext: queryContext,
                        capabilitiesContainerId: capabilitiesContainerId
                    },
                    options: {
                        fetchPolicy: $7724e89a7ae22c22$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $7724e89a7ae22c22$export$2e2bcd8739ae039 = $7724e89a7ae22c22$var$atlasGoalEntryPoint;

});
parcelRegister("9vjEd", function(module, exports) {
$parcel$export(module.exports, "createPlatformSiteAri", () => $700d4eae66d4d538$export$e1144f7c498cb0b0);

var $9xzYB = parcelRequire("9xzYB");
const $700d4eae66d4d538$export$e1144f7c498cb0b0 = (siteId)=>{
    if (!siteId) return null;
    try {
        return (0, $9xzYB.PlatformSiteAri).create({
            siteId: siteId
        }).toString();
    } catch  {
        return null;
    }
};

});

parcelRegister("dp4uQ", function(module, exports) {
$parcel$export(module.exports, "getSiteAri", () => $be309ff3bcfb4b6d$export$792aeacb7990bc6);

var $aP88y = parcelRequire("aP88y");
const $be309ff3bcfb4b6d$export$792aeacb7990bc6 = (containerId)=>{
    // we wrap in a try/catch incase there are any issues with creating the site ari
    try {
        return (0, $aP88y.TownsquareSiteAri).create({
            siteId: containerId
        }).toString();
    } catch  {
        return '';
    }
};

});
parcelRegister("aP88y", function(module, exports) {
$parcel$export(module.exports, "TownsquareSiteAri", () => $7e14fa9c7b6019db$export$87ae3de5f1f7725a);

var $5QNgX = parcelRequire("5QNgX");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/townsquare/site/manifest.ts
var $7e14fa9c7b6019db$var$townsquareSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5QNgX.TownsquareSiteAriResourceOwner),
    resourceType: (0, $5QNgX.TownsquareSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/townsquare/site/index.ts
var $7e14fa9c7b6019db$export$87ae3de5f1f7725a = class _TownsquareSiteAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7e14fa9c7b6019db$var$townsquareSiteAriStaticOpts.qualifier,
            platformQualifier: $7e14fa9c7b6019db$var$townsquareSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $7e14fa9c7b6019db$var$townsquareSiteAriStaticOpts.resourceOwner,
            resourceType: $7e14fa9c7b6019db$var$townsquareSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $7e14fa9c7b6019db$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $7e14fa9c7b6019db$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("5QNgX", function(module, exports) {
$parcel$export(module.exports, "TownsquareSiteAriResourceOwner", () => $4428078fc8d0b704$export$9ee8c46ef1f3e6a8);
$parcel$export(module.exports, "TownsquareSiteAriResourceType", () => $4428078fc8d0b704$export$44737bde24f3bac1);
// src/townsquare/site/types.ts
var $4428078fc8d0b704$export$9ee8c46ef1f3e6a8 = "townsquare", $4428078fc8d0b704$export$44737bde24f3bac1 = "site";

});



parcelRegister("8KAcR", function(module, exports) {
$parcel$export(module.exports, "getSiteId", () => $616d05008c026ea8$export$3ae2d1e732b25194);

var $l0Grs = parcelRequire("l0Grs");
var $jh9go = parcelRequire("jh9go");
var $aP88y = parcelRequire("aP88y");
function $616d05008c026ea8$export$3ae2d1e732b25194(entity, ari) {
    try {
        if (entity === 'goal') return (0, $l0Grs.TownsquareGoalAri).parse(ari).siteId;
        if (entity === 'project') return (0, $jh9go.TownsquareProjectAri).parse(ari).siteId;
        if (entity === 'site') return (0, $aP88y.TownsquareSiteAri).parse(ari).siteId;
    } catch (error) {
        //TODO: send error metrics/monitoring https://product-fabric.atlassian.net/browse/TC-13492
        //We try to extract the siteId manually: ari:cloud:townsquare:${siteId}:{entity}/{uuid}
        if (entity === 'goal' || entity === 'project') return ari.split(':')[3] ?? '';
    }
    return '';
}

});
parcelRegister("l0Grs", function(module, exports) {
$parcel$export(module.exports, "TownsquareGoalAri", () => $f4ba8524d6192aba$export$e45ea1bd9a289a4f);

var $ePFYu = parcelRequire("ePFYu");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/townsquare/goal/manifest.ts
var $f4ba8524d6192aba$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ePFYu.TownsquareGoalAriResourceOwner),
    resourceType: (0, $ePFYu.TownsquareGoalAriResourceType),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $f4ba8524d6192aba$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f4ba8524d6192aba$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $f4ba8524d6192aba$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f4ba8524d6192aba$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $f4ba8524d6192aba$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $f4ba8524d6192aba$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $f4ba8524d6192aba$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
};

});
parcelRegister("ePFYu", function(module, exports) {
$parcel$export(module.exports, "TownsquareGoalAriResourceOwner", () => $acc6635fed416b01$export$947838268868cc57);
$parcel$export(module.exports, "TownsquareGoalAriResourceType", () => $acc6635fed416b01$export$935b9c2af9d62e80);
// src/townsquare/goal/types.ts
var $acc6635fed416b01$export$947838268868cc57 = "townsquare", $acc6635fed416b01$export$935b9c2af9d62e80 = "goal";

});


parcelRegister("jh9go", function(module, exports) {
$parcel$export(module.exports, "TownsquareProjectAri", () => $e086ca5cb357a8f3$export$41215e8d01921e7d);

var $lnbxJ = parcelRequire("lnbxJ");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/townsquare/project/manifest.ts
var $e086ca5cb357a8f3$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lnbxJ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $lnbxJ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $e086ca5cb357a8f3$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e086ca5cb357a8f3$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $e086ca5cb357a8f3$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e086ca5cb357a8f3$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $e086ca5cb357a8f3$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $e086ca5cb357a8f3$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $e086ca5cb357a8f3$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
};

});
parcelRegister("lnbxJ", function(module, exports) {
$parcel$export(module.exports, "TownsquareProjectAriResourceOwner", () => $f8f4b32bb51e777a$export$a258bc824c789b17);
$parcel$export(module.exports, "TownsquareProjectAriResourceType", () => $f8f4b32bb51e777a$export$aa8900dadffaa32a);
// src/townsquare/project/types.ts
var $f8f4b32bb51e777a$export$a258bc824c789b17 = "townsquare", $f8f4b32bb51e777a$export$aa8900dadffaa32a = "project";

});



parcelRegister("9Ufna", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a0fb0e58a27169f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a5bf5a5687b60f8980051fed10f7060>>
 * @relayHash 341117f678f7ae65fb32a94ff1ddb7ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9e7733c483466c5fab2a8b104a0a471580d7e4e3128573447e85a62621b596c
const $7a0fb0e58a27169f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ari"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "capabilitiesContainerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryContext"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "goalId",
            "variableName": "ari"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "url"
    }, v9 = {
        "kind": "Variable",
        "name": "queryContext",
        "variableName": "queryContext"
    }, v10 = [
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "canCreateGoal"
    }, v13 = {
        "kind": "ScalarField",
        "name": "canEditMetrics"
    }, v14 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedGoals"
    }, v15 = {
        "kind": "ScalarField",
        "name": "canCreateUpdates"
    }, v16 = {
        "kind": "ScalarField",
        "name": "canAddLinkedProjects"
    }, v17 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v18 = [
        v7 /*: any*/ ,
        v3 /*: any*/ 
    ], v19 = [
        v3 /*: any*/ 
    ], v20 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "value"
    }, v23 = [
        v22 /*: any*/ 
    ], v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "messageId"
            },
            {
                "kind": "ScalarField",
                "name": "defaultValue"
            }
        ],
        "type": "TownsquareLocalizationField"
    }, v25 = {
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v23 /*: any*/ ,
                "type": "TownsquareGoalTypeCustomName"
            },
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "TownsquareGoalTypeIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v27 = {
        "kind": "LinkedField",
        "name": "namePlural",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v23 /*: any*/ ,
                "type": "TownsquareGoalTypeCustomNamePlural"
            },
            v24 /*: any*/ 
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "kind"
    }, v29 = {
        "kind": "ScalarField",
        "name": "score"
    }, v30 = [
        v22 /*: any*/ ,
        v29 /*: any*/ 
    ], v31 = {
        "kind": "ScalarField",
        "name": "scoringMode"
    }, v32 = {
        "kind": "ScalarField",
        "name": "isArchived"
    }, v33 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v34 = {
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "accessLevel"
    }, v36 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v37 = {
        "kind": "ScalarField",
        "name": "end"
    }, v38 = {
        "kind": "ScalarField",
        "name": "start"
    }, v39 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v40 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            v38 /*: any*/ ,
            v37 /*: any*/ 
        ]
    }, v41 = [
        v40 /*: any*/ 
    ], v42 = [
        v22 /*: any*/ ,
        v3 /*: any*/ 
    ], v43 = {
        "kind": "ScalarField",
        "name": "variance"
    }, v44 = {
        "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
        "kind": "LinkedField",
        "name": "latestValue",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricValue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v42 /*: any*/ 
            },
            v43 /*: any*/ 
        ]
    }, v45 = {
        "kind": "ScalarField",
        "name": "type"
    }, v46 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v47 = {
        "kind": "ScalarField",
        "name": "archived"
    }, v48 = {
        "kind": "ScalarField",
        "name": "externalEntityId"
    }, v49 = {
        "kind": "ScalarField",
        "name": "source"
    }, v50 = {
        "kind": "ScalarField",
        "name": "time"
    }, v51 = {
        "kind": "Literal",
        "name": "first",
        "value": 100
    }, v52 = [
        v51 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "sort",
            "value": [
                "TIME_ASC"
            ]
        }
    ], v53 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v54 = {
        "concreteType": "TownsquareGoalState",
        "kind": "LinkedField",
        "name": "newState",
        "plural": false,
        "selections": v30 /*: any*/ 
    }, v55 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v56 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v57 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v58 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v57 /*: any*/ 
        ]
    }, v59 = {
        "args": v52 /*: any*/ ,
        "concreteType": "TownsquareMetricValueConnection",
        "kind": "LinkedField",
        "name": "values",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v22 /*: any*/ ,
                            v50 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "origin",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareGoalUpdate",
                                                "kind": "LinkedField",
                                                "name": "goalUpdate",
                                                "plural": false,
                                                "selections": [
                                                    v53 /*: any*/ ,
                                                    {
                                                        "concreteType": "TownsquareGoal",
                                                        "kind": "LinkedField",
                                                        "name": "goal",
                                                        "plural": false,
                                                        "selections": v19 /*: any*/ 
                                                    },
                                                    v54 /*: any*/ ,
                                                    v3 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "TownsquareFromGoalUpdate"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v53 /*: any*/ 
                                        ],
                                        "type": "TownsquareFromMetricCreation"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "updateDate"
                                            }
                                        ],
                                        "type": "TownsquareFromMetricUpdate"
                                    }
                                ]
                            },
                            v3 /*: any*/ ,
                            v11 /*: any*/ 
                        ]
                    },
                    v55 /*: any*/ 
                ]
            },
            v58 /*: any*/ 
        ],
        "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
    }, v60 = {
        "args": v52 /*: any*/ ,
        "filters": [
            "sort"
        ],
        "handle": "connection",
        "key": "SuccessMeasureChart_values",
        "kind": "LinkedHandle",
        "name": "values"
    }, v61 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "snapshotValue",
        "plural": false,
        "selections": v42 /*: any*/ 
    }, v62 = {
        "kind": "ScalarField",
        "name": "startValue"
    }, v63 = {
        "kind": "ScalarField",
        "name": "targetValue"
    }, v64 = [
        v50 /*: any*/ ,
        v3 /*: any*/ 
    ], v65 = {
        "args": v52 /*: any*/ ,
        "concreteType": "TownsquareMetricTargetToMetricValueConnection",
        "kind": "LinkedField",
        "name": "metricValues",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricTargetToMetricValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v64 /*: any*/ 
                    },
                    {
                        "concreteType": "TownsquareMetricTargetPeriod",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriod",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "date",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareTargetDateRange",
                                        "kind": "LinkedField",
                                        "name": "dateRange",
                                        "plural": false,
                                        "selections": [
                                            v37 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v22 /*: any*/ 
                        ]
                    },
                    v43 /*: any*/ 
                ]
            }
        ],
        "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
    }, v66 = {
        "kind": "ScalarField",
        "name": "percentage"
    }, v67 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v66 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v68 = {
        "concreteType": "TownsquareGoalType",
        "kind": "LinkedField",
        "name": "goalType",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v3 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v69 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "latestValue",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v70 = {
        "concreteType": "TownsquareMetricTargetConnection",
        "kind": "LinkedField",
        "name": "metricTargets",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "concreteType": "TownsquareMetric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    v46 /*: any*/ ,
                                    v47 /*: any*/ ,
                                    v48 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v69 /*: any*/ 
                                ]
                            },
                            v61 /*: any*/ ,
                            v62 /*: any*/ ,
                            v63 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v71 = {
        "concreteType": "TownsquareStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v30 /*: any*/ 
    }, v72 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "targetDate",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v73 = [
        v11 /*: any*/ ,
        v33 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v74 = {
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v73 /*: any*/ 
    }, v75 = {
        "kind": "ScalarField",
        "name": "label"
    }, v76 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v77 = {
        "kind": "ScalarField",
        "name": "description"
    }, v78 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isTownsquareHighlight"
    }, v79 = [
        v11 /*: any*/ ,
        v5 /*: any*/ ,
        v4 /*: any*/ ,
        v33 /*: any*/ ,
        v3 /*: any*/ 
    ], v80 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v81 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v82 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v83 = [
        v53 /*: any*/ ,
        {
            "concreteType": "TownsquareGoalState",
            "kind": "LinkedField",
            "name": "newState",
            "plural": false,
            "selections": [
                v22 /*: any*/ ,
                v29 /*: any*/ ,
                v75 /*: any*/ 
            ]
        },
        v76 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": v73 /*: any*/ 
        },
        {
            "concreteType": "TownsquareUpdateNoteConnection",
            "kind": "LinkedField",
            "name": "updateNotes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareUpdateNoteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "TownsquareUpdateNote",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v76 /*: any*/ ,
                                v77 /*: any*/ ,
                                v47 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v3 /*: any*/ ,
                                v76 /*: any*/ ,
                                v77 /*: any*/ ,
                                v78 /*: any*/ ,
                                v80 /*: any*/ ,
                                v81 /*: any*/ ,
                                v53 /*: any*/ ,
                                v82 /*: any*/ 
                            ]
                        }
                    ]
                },
                v21 /*: any*/ 
            ]
        },
        v3 /*: any*/ 
    ], v84 = {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "latestUserUpdate",
        "plural": false,
        "selections": v83 /*: any*/ 
    }, v85 = {
        "kind": "ScalarField",
        "name": "missedUpdate"
    }, v86 = {
        "kind": "ScalarField",
        "name": "updateType"
    }, v87 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v88 = [
        {
            "concreteType": "TownsquareGoalUpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v85 /*: any*/ ,
                        v86 /*: any*/ ,
                        v76 /*: any*/ ,
                        v87 /*: any*/ ,
                        v53 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ]
        }
    ], v89 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 30
            }
        ],
        "concreteType": "TownsquareGoalUpdateConnection",
        "kind": "LinkedField",
        "name": "updates",
        "plural": false,
        "selections": v88 /*: any*/ ,
        "storageKey": "updates(first:30)"
    }, v90 = {
        "kind": "Literal",
        "name": "first",
        "value": 200
    }, v91 = [
        v90 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "tql",
            "value": "archived = false"
        }
    ], v92 = {
        "concreteType": "TownsquareIconURIs",
        "kind": "LinkedField",
        "name": "iconUrl",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "dark"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "light"
                    }
                ]
            }
        ]
    }, v93 = {
        "concreteType": "TownsquareProjectState",
        "kind": "LinkedField",
        "name": "state",
        "plural": false,
        "selections": v23 /*: any*/ 
    }, v94 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "dueDate",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v95 = [
        v11 /*: any*/ ,
        v3 /*: any*/ 
    ], v96 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": v95 /*: any*/ 
        }
    ], v97 = {
        "concreteType": "TownsquareContributorConnection",
        "kind": "LinkedField",
        "name": "contributors",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareContributorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareContributor",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "userContributor",
                                "plural": false,
                                "selections": v95 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareTeamContributor",
                                "kind": "LinkedField",
                                "name": "teamContributor",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareUserConnection",
                                        "kind": "LinkedField",
                                        "name": "contributingMembers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareUserEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v96 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v98 = {
        "args": v91 /*: any*/ ,
        "filters": [
            "tql"
        ],
        "handle": "connection",
        "key": "GoalContentProjects_projects",
        "kind": "LinkedHandle",
        "name": "projects"
    }, v99 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v100 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v66 /*: any*/ 
        ]
    }, v101 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v102 = {
        "args": v101 /*: any*/ ,
        "concreteType": "TownsquareGoalUpdateConnection",
        "kind": "LinkedField",
        "name": "updates",
        "plural": false,
        "selections": v88 /*: any*/ ,
        "storageKey": "updates(first:10)"
    }, v103 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v77 /*: any*/ 
    ], v104 = [
        v51 /*: any*/ 
    ], v105 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v106 = [
        v75 /*: any*/ ,
        v40 /*: any*/ 
    ], v107 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v33 /*: any*/ ,
                                    v5 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v87 /*: any*/ ,
                            v53 /*: any*/ 
                        ]
                    }
                ]
            },
            v21 /*: any*/ 
        ]
    }, v108 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v76 /*: any*/ ,
                v77 /*: any*/ ,
                v80 /*: any*/ ,
                v81 /*: any*/ ,
                v53 /*: any*/ ,
                v82 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v109 = [
        v90 /*: any*/ ,
        v9 /*: any*/ 
    ], v110 = [
        {
            "concreteType": "TownsquareHighlightEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": v96 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v6 /*: any*/ ,
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goals_byId",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            v7 /*: any*/ ,
                            v8 /*: any*/ ,
                            {
                                "args": v10 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "GoalFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalPanelTitleField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalType"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalMetrics"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ParentGoal"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "SubGoals"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalActions"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTeams"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalCustomFields"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalUpdateComposerCreate"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "ari"
                        },
                        {
                            "kind": "Variable",
                            "name": "capabilitiesContainerId",
                            "variableName": "capabilitiesContainerId"
                        },
                        v9 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "GoalPanelTabs"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goals_byId",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedFocusAreas"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedFocusAreas"
                                },
                                {
                                    "concreteType": "TownsquareGoalAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareFocusAppCapabilities",
                                            "kind": "LinkedField",
                                            "name": "focus",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewFocusAreas"
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditMetadata"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageOwnership"
                                },
                                v13 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedGoals"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStartDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canArchiveGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditCustomFields"
                                },
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnGoal"
                                },
                                {
                                    "concreteType": "TownsquareGoalAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canWatchGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedProjects"
                                },
                                v16 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddJiraAlignItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveJiraAlignItems"
                                }
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v4 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v18 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v18 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                }
                            ]
                        },
                        v4 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ ,
                                v3 /*: any*/ ,
                                v26 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "state"
                                        },
                                        v3 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                },
                                v28 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                v22 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareCompletionGoalState",
                                    "kind": "LinkedField",
                                    "name": "atCompletionState",
                                    "plural": false,
                                    "selections": v30 /*: any*/ 
                                }
                            ]
                        },
                        v31 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                        },
                        v32 /*: any*/ ,
                        v34 /*: any*/ ,
                        v35 /*: any*/ ,
                        v36 /*: any*/ ,
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                                v39 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareMetricTarget",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricTargetPeriods",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "date",
                                                                            "plural": false,
                                                                            "selections": v41 /*: any*/ 
                                                                        },
                                                                        v22 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v44 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetric",
                                                    "kind": "LinkedField",
                                                    "name": "metric",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v48 /*: any*/ ,
                                                        v49 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareMetricValue",
                                                            "kind": "LinkedField",
                                                            "name": "latestValue",
                                                            "plural": false,
                                                            "selections": [
                                                                v50 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ]
                                                        },
                                                        v21 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v60 /*: any*/ 
                                                    ]
                                                },
                                                v61 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                v65 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v67 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v67 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v68 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                v70 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v71 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                },
                                                v47 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                v84 /*: any*/ ,
                                                v89 /*: any*/ ,
                                                {
                                                    "args": v91 /*: any*/ ,
                                                    "concreteType": "TownsquareProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "projects",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProjectEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v92 /*: any*/ ,
                                                                        v93 /*: any*/ ,
                                                                        v94 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v97 /*: any*/ 
                                                                    ]
                                                                },
                                                                v55 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        v58 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ],
                                                    "storageKey": "projects(first:200,tql:\"archived = false\")"
                                                },
                                                v98 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "args": v99 /*: any*/ ,
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v100 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                v71 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetricTargetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricTargets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTarget",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v45 /*: any*/ ,
                                                                                v46 /*: any*/ ,
                                                                                v47 /*: any*/ ,
                                                                                v48 /*: any*/ ,
                                                                                v49 /*: any*/ ,
                                                                                v69 /*: any*/ ,
                                                                                v59 /*: any*/ ,
                                                                                v60 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v61 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "metricTargetPeriods",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareMetricTargetPeriod",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareTargetDate",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "date",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v39 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v44 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v8 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                v84 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v102 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "successMeasures(first:50)"
                        },
                        {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v3 /*: any*/ ,
                                v67 /*: any*/ ,
                                v70 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": v23 /*: any*/ 
                                },
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "goalType",
                                    "plural": false,
                                    "selections": [
                                        v26 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareGoalCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v77 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v57 /*: any*/ ,
                                        v56 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareSlackConnectionConnection",
                            "kind": "LinkedField",
                            "name": "slackChannels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareSlackConnectionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareSlackConnection",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareSlackChannel",
                                                    "kind": "LinkedField",
                                                    "name": "channel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "numMembers"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
                            "kind": "LinkedField",
                            "name": "msteamsChannels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v53 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalTeamConnection",
                            "kind": "LinkedField",
                            "name": "teams",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalTeamEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canRemove"
                                        },
                                        {
                                            "concreteType": "TeamV2",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "smallAvatarImageUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVerified"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "profileUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v103 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v103 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v103 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v104 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isUser"
                                                                                },
                                                                                v4 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v55 /*: any*/ 
                                                                    ]
                                                                },
                                                                v58 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v104 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v77 /*: any*/ ,
                                                                        {
                                                                            "args": v104 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v3 /*: any*/ ,
                                                                                                v22 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v104 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v55 /*: any*/ 
                                                                    ]
                                                                },
                                                                v58 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v104 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v47 /*: any*/ ,
                        {
                            "args": v105 /*: any*/ ,
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v76 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v76 /*: any*/ ,
                                                                        v77 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v47 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                v85 /*: any*/ ,
                                                v86 /*: any*/ ,
                                                v54 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v76 /*: any*/ ,
                                                                        v77 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v78 /*: any*/ ,
                                                                        v80 /*: any*/ ,
                                                                        v81 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v82 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricUpdate",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalMetricUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v45 /*: any*/ ,
                                                                                v46 /*: any*/ ,
                                                                                v47 /*: any*/ ,
                                                                                v49 /*: any*/ ,
                                                                                v69 /*: any*/ ,
                                                                                {
                                                                                    "args": [
                                                                                        v51 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "sort",
                                                                                            "value": [
                                                                                                "TIME_DESC"
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "TownsquareMetricValueConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareMetricValueEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareMetricValue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v50 /*: any*/ ,
                                                                                                        v3 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "TownsquareMetricValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "newValue",
                                                                            "plural": false,
                                                                            "selections": v42 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newStartValue"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newTargetValue"
                                                                        },
                                                                        {
                                                                            "concreteType": "TownsquareMetricValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "oldValue",
                                                                            "plural": false,
                                                                            "selections": v42 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoal",
                                                    "kind": "LinkedField",
                                                    "name": "goal",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "metricTargets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTargetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetricTarget",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareMetric",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "metric",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v3 /*: any*/ ,
                                                                                        v47 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "metricTargetPeriods",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "TownsquareTargetDate",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "date",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "TownsquareTargetDateRange",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "dateRange",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ ,
                                                        v31 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareGoalType",
                                                            "kind": "LinkedField",
                                                            "name": "goalType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalType",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalProgress",
                                                            "kind": "LinkedField",
                                                            "name": "progress",
                                                            "plural": false,
                                                            "selections": [
                                                                v45 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v99 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "successMeasures",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v47 /*: any*/ ,
                                                                                v67 /*: any*/ ,
                                                                                v70 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v72 /*: any*/ ,
                                                                                v74 /*: any*/ ,
                                                                                v84 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareGoalType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "goalType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v3 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v71 /*: any*/ ,
                                                                                v102 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "successMeasures(first:50)"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "subGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v47 /*: any*/ ,
                                                                                v67 /*: any*/ ,
                                                                                v68 /*: any*/ ,
                                                                                v70 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v72 /*: any*/ ,
                                                                                v74 /*: any*/ ,
                                                                                v84 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v71 /*: any*/ ,
                                                                                v89 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v101 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalUpdateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "updates",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoalUpdate",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v76 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "updateNotes",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareUpdateNote",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v76 /*: any*/ ,
                                                                                                        v77 /*: any*/ ,
                                                                                                        v3 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "updates(first:10)"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v106 /*: any*/ 
                                                },
                                                {
                                                    "args": v99 /*: any*/ ,
                                                    "concreteType": "TownsquareGoalBundledUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "bundledUpdates",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoalProgress",
                                                                            "kind": "LinkedField",
                                                                            "name": "progress",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v66 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": v83 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "nodeMissingReason"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "goal",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        v70 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v72 /*: any*/ ,
                                                                        v74 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "bundledUpdates(first:50)"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                v87 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "viewers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v19 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v19 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                v107 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v30 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v106 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v55 /*: any*/ 
                                    ]
                                },
                                v58 /*: any*/ ,
                                v21 /*: any*/ 
                            ],
                            "storageKey": "updates(first:20)"
                        },
                        {
                            "args": v105 /*: any*/ ,
                            "handle": "connection",
                            "key": "UpdatesList__updates",
                            "kind": "LinkedHandle",
                            "name": "updates"
                        },
                        {
                            "concreteType": "TownsquareGoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                                v53 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        },
                        v77 /*: any*/ ,
                        v107 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "latestUpdateDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isWatching"
                        },
                        {
                            "args": v91 /*: any*/ ,
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v55 /*: any*/ ,
                                        {
                                            "concreteType": "TownsquareProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v93 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v97 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareProjectUpdate",
                                                    "kind": "LinkedField",
                                                    "name": "latestUserUpdate",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProjectPhaseDetails",
                                                            "kind": "LinkedField",
                                                            "name": "newPhase",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "_id",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                v32 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v92 /*: any*/ ,
                                                v94 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v58 /*: any*/ ,
                                v21 /*: any*/ 
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                        },
                        v98 /*: any*/ ,
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "args": v109 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "workItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v55 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                v58 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "args": v109 /*: any*/ ,
                            "filters": [
                                "queryContext"
                            ],
                            "handle": "connection",
                            "key": "GoalContentJira_workItems",
                            "kind": "LinkedHandle",
                            "name": "workItems"
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectUrl"
                                                        }
                                                    ],
                                                    "type": "JiraAlignAggProject"
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v95 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "alias": "learningsHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "LEARNING"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v110 /*: any*/ ,
                            "storageKey": "highlights(type:\"LEARNING\")"
                        },
                        {
                            "alias": "risksHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "RISK"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v110 /*: any*/ ,
                            "storageKey": "highlights(type:\"RISK\")"
                        },
                        {
                            "alias": "decisionsHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DECISION"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v110 /*: any*/ ,
                            "storageKey": "highlights(type:\"DECISION\")"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "updateStreak_extension"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "capabilitiesContainerId"
                        }
                    ],
                    "concreteType": "TownsquareProjectAppCapabilities",
                    "kind": "LinkedField",
                    "name": "projects_capabilities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canCreateProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f9e7733c483466c5fab2a8b104a0a471580d7e4e3128573447e85a62621b596c",
            "metadata": {},
            "name": "GoalPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7a0fb0e58a27169f$var$node.hash = "37cb59172c08685bfd671c0530663aa3";
var $7a0fb0e58a27169f$export$2e2bcd8739ae039 = $7a0fb0e58a27169f$var$node;

});

parcelRegister("dBttT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("j9dGY")
]).then(()=>parcelRequire('cbyNo'));

});


parcelRegister("6PxvK", function(module, exports) {
$parcel$export(module.exports, "default", () => $6111ef255c5306a9$export$2e2bcd8739ae039);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $6111ef255c5306a9$var$objectPreviewPanelEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("indV6")), {
        moduleId: "bb3d75a4",
        priority: "interaction",
        moduleId: 'object-preview-panel-entrypoint'
    }),
    getPreloadProps: ({})=>({})
});
var $6111ef255c5306a9$export$2e2bcd8739ae039 = $6111ef255c5306a9$var$objectPreviewPanelEntryPoint;

});
parcelRegister("indV6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("bcg7y")
]).then(()=>parcelRequire('dgYqM'));

});


parcelRegister("6THxV", function(module, exports) {
$parcel$export(module.exports, "default", () => $b10e36d0bf393382$export$2e2bcd8739ae039);

var $4LDqh = parcelRequire("4LDqh");

var $VoOhq = parcelRequire("VoOhq");

var $9vjEd = parcelRequire("9vjEd");

var $dp4uQ = parcelRequire("dp4uQ");

var $8KAcR = parcelRequire("8KAcR");

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $a3HIl = parcelRequire("a3HIl");
const $b10e36d0bf393382$var$fetchPolicy = 'network-only';

const $b10e36d0bf393382$var$atlasProjectEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("82Msk")), {
        moduleId: "db5db9ea",
        moduleName: "ProjectPanel",
        priority: "interaction",
        moduleId: 'atlas-project-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $VoOhq.default)('townsquare-project-panel-opened');
        // check for M0 or greater
        const isProjectNativeIntegrationEnabled = (0, $4LDqh.default).getExperimentValue('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 0;
        const siteId = (0, $8KAcR.getSiteId)('project', ari);
        const queryContext = siteId ? (0, $9vjEd.createPlatformSiteAri)(siteId) : null;
        const capabilitiesContainerId = siteId ? (0, $dp4uQ.getSiteAri)(siteId) : '';
        return {
            queries: {
                queryReference: {
                    parameters: $a3HIl.default,
                    variables: {
                        ari: ari,
                        isProjectNativeIntegrationEnabled: isProjectNativeIntegrationEnabled,
                        queryContext: queryContext,
                        capabilitiesContainerId: capabilitiesContainerId
                    },
                    options: {
                        fetchPolicy: $b10e36d0bf393382$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $b10e36d0bf393382$export$2e2bcd8739ae039 = $b10e36d0bf393382$var$atlasProjectEntryPoint;

});
parcelRegister("a3HIl", function(module, exports) {
$parcel$export(module.exports, "default", () => $e954ef2ab89fa50b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<821111bb1380ff1cf41f63e5657f493f>>
 * @relayHash 9cebb135f31cf73ed46d9cfdd270ff98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae6b6d5da9488284997125b86a1f0c930055757c4e8394b4a9f5fa22a5e81c62
const $e954ef2ab89fa50b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ari"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "capabilitiesContainerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isProjectNativeIntegrationEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryContext"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "ari"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "url"
    }, v10 = [
        v4 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "canEditMembers"
    }, v12 = {
        "kind": "Variable",
        "name": "queryContext",
        "variableName": "queryContext"
    }, v13 = [
        v12 /*: any*/ 
    ], v14 = [
        {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "capabilitiesContainerId"
        }
    ], v15 = {
        "args": v14 /*: any*/ ,
        "concreteType": "TownsquareGoalAppCapabilities",
        "kind": "LinkedField",
        "name": "goals_capabilities",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canCreateGoal"
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = [
        v16 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v18 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isUser"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v20 = {
        "kind": "ScalarField",
        "name": "count"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "canEditMetadata"
    }, v23 = {
        "kind": "ScalarField",
        "name": "canCreateUpdates"
    }, v24 = {
        "kind": "ScalarField",
        "name": "dark"
    }, v25 = {
        "kind": "ScalarField",
        "name": "light"
    }, v26 = {
        "kind": "ScalarField",
        "name": "description"
    }, v27 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v28 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v29 = {
        "kind": "ScalarField",
        "name": "key"
    }, v30 = {
        "kind": "ScalarField",
        "name": "value"
    }, v31 = [
        v30 /*: any*/ 
    ], v32 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "start"
            },
            {
                "kind": "ScalarField",
                "name": "end"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v34 = [
        {
            "concreteType": "TownsquareLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v9 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        v21 /*: any*/ 
    ], v35 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v36 = [
        v29 /*: any*/ ,
        v4 /*: any*/ 
    ], v37 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v38 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v39 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "AppUser"
    }, v40 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "CustomerUser"
    }, v41 = [
        {
            "concreteType": "TownsquareHighlightEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ], v42 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v43 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v16 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v42 /*: any*/ ,
                            v38 /*: any*/ 
                        ]
                    }
                ]
            },
            v21 /*: any*/ 
        ]
    }, v44 = [
        {
            "kind": "ScalarField",
            "name": "label"
        },
        v32 /*: any*/ 
    ], v45 = [
        {
            "alias": "projectValue",
            "kind": "ScalarField",
            "name": "value"
        }
    ], v46 = [
        v16 /*: any*/ ,
        v6 /*: any*/ ,
        v5 /*: any*/ ,
        v7 /*: any*/ ,
        v4 /*: any*/ 
    ], v47 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v46 /*: any*/ 
    }, v48 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v46 /*: any*/ 
    }, v49 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v50 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v33 /*: any*/ ,
                v26 /*: any*/ ,
                v47 /*: any*/ ,
                v48 /*: any*/ ,
                v38 /*: any*/ ,
                v49 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v51 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v26 /*: any*/ 
    ], v52 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v53 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v54 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v55 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedWorkItems"
    }, v56 = {
        "kind": "ScalarField",
        "name": "canAddLinkedWorkItems"
    }, v57 = {
        "kind": "ScalarField",
        "name": "webUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v8 /*: any*/ ,
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "projects_byId",
                        "plural": false,
                        "selections": [
                            v4 /*: any*/ ,
                            v9 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": v10 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareContributorConnection",
                                "kind": "LinkedField",
                                "name": "contributors",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareContributorEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareContributor",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "userContributor",
                                                        "plural": false,
                                                        "selections": v10 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v11 /*: any*/ ,
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v13 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "ProjectJiraWork"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelHeader"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectLinks"
                            },
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectWorkTracked"
                                    }
                                ]
                            },
                            {
                                "args": v13 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "ProjectFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "RelatedProjects"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributesTo"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributors"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectActionsContent"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelTabs"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectCustomFields"
                            }
                        ]
                    },
                    "action": "THROW"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "capabilitiesContainerId",
                            "variableName": "capabilitiesContainerId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ProjectActionsContent_Capabilities"
                },
                v15 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "projects_byId",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v17 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareContributorConnection",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareContributorEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareContributor",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "userContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTeamContributor",
                                                    "kind": "LinkedField",
                                                    "name": "teamContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributingMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v19 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TeamV2",
                                                            "kind": "LinkedField",
                                                            "name": "team",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "smallAvatarImageUrl"
                                                                },
                                                                {
                                                                    "concreteType": "TeamMemberConnectionV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "members",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TeamMemberEdgeV2",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TeamMemberV2",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "member",
                                                                                            "plural": false,
                                                                                            "selections": v17 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "profileUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "permission"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isVerified"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                v22 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageOwnership"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedFocusAreas"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedFocusAreas"
                                },
                                {
                                    "concreteType": "TownsquareProjectAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareFocusAppCapabilities",
                                            "kind": "LinkedField",
                                            "name": "focus",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewFocusAreas"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStartDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddContributors"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveContributors"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageAccess"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canArchiveProject"
                                },
                                v23 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnProject"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditCustomFields"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareWorkspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "roundedSquare",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        v29 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isArchived"
                        },
                        {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": v31 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "dueDate",
                            "plural": false,
                            "selections": [
                                v32 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                                v33 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUpdateNoteConnection",
                                    "kind": "LinkedField",
                                    "name": "updateNotes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v33 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareLinkConnection",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": v34 /*: any*/ 
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v36 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v36 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v37 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        v38 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectDependencyConnection",
                            "kind": "LinkedField",
                            "name": "dependencies",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectDependencyEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectDependency",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "linkType"
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "incomingProject",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "outgoingProject",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareIconURIs",
                                                            "kind": "LinkedField",
                                                            "name": "iconUrl",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareThemeURIs",
                                                                    "kind": "LinkedField",
                                                                    "name": "square",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddRelatedProjects"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveRelatedProjects"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedGoals"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedGoals"
                                },
                                v22 /*: any*/ ,
                                v23 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "goals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": v31 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalTypeIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectAccessConnection",
                            "kind": "LinkedField",
                            "name": "access",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectAccessEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "role"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v10 /*: any*/ ,
                                                    "type": "User",
                                                    "abstractKey": "__isUser"
                                                },
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v10 /*: any*/ ,
                                                    "type": "AtlassianAccountUser"
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrivate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessLevel"
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "learningsHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "LEARNING"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v41 /*: any*/ ,
                            "storageKey": "highlights(type:\"LEARNING\")"
                        },
                        {
                            "alias": "risksHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "RISK"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v41 /*: any*/ ,
                            "storageKey": "highlights(type:\"RISK\")"
                        },
                        {
                            "alias": "decisionsHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DECISION"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v41 /*: any*/ ,
                            "storageKey": "highlights(type:\"DECISION\")"
                        },
                        {
                            "concreteType": "TownsquareProjectDescription",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "what"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "why"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "measurement"
                                }
                            ]
                        },
                        v43 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "missedUpdate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updateType"
                                                },
                                                v33 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v44 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "newState",
                                                    "plural": false,
                                                    "selections": v45 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v38 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "viewers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        v39 /*: any*/ ,
                                                                        v40 /*: any*/ 
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v45 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v44 /*: any*/ 
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "archived"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isTownsquareHighlight"
                                                                        },
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v49 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                v43 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v50 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v50 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v50 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v51 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v51 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v51 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v52 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v53 /*: any*/ 
                                                                    ]
                                                                },
                                                                v54 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v52 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "args": v52 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v4 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v52 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v53 /*: any*/ 
                                                                    ]
                                                                },
                                                                v54 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v52 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v55 /*: any*/ ,
                                        v56 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        },
                                        v12 /*: any*/ 
                                    ],
                                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedJiraWorkItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                v57 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "permission",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasProjectPermission",
                                                                    "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                                                                },
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v5 /*: any*/ ,
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeId"
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        v37 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "workTrackingLinks",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "WORK_TRACKING"
                                        }
                                    ],
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v34 /*: any*/ ,
                                    "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
                                },
                                {
                                    "concreteType": "TownsquareFusionDetails",
                                    "kind": "LinkedField",
                                    "name": "fusion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "synced"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v57 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v56 /*: any*/ ,
                                        v55 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v21 /*: any*/ 
                    ]
                },
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "TownsquareProjectAppCapabilities",
                    "kind": "LinkedField",
                    "name": "projects_capabilities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canCreateProject"
                        }
                    ]
                },
                v15 /*: any*/ 
            ]
        },
        "params": {
            "id": "ae6b6d5da9488284997125b86a1f0c930055757c4e8394b4a9f5fa22a5e81c62",
            "metadata": {},
            "name": "ProjectPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e954ef2ab89fa50b$var$node.hash = "5c377c61bc980ca79c45313dbee8c2df";
var $e954ef2ab89fa50b$export$2e2bcd8739ae039 = $e954ef2ab89fa50b$var$node;

});

parcelRegister("82Msk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("1R97J")
]).then(()=>parcelRequire('cT2dJ'));

});


parcelRegister("89kOy", function(module, exports) {
$parcel$export(module.exports, "getDefaultSelectedTab", () => $0ad5a03ea341222f$export$68d1d951742105ed);
/*
 * Get the default tab from the url
 * Post T25 EU task: Support other URL routing (jira/jira-align/highlights, ect)
 * TODO: https://product-fabric.atlassian.net/browse/TC-14119
 */ function $0ad5a03ea341222f$export$68d1d951742105ed(url) {
    // About | Updates | {other tabs}
    if (url.includes('updates')) return 'updates';
    return 'about';
}

});

parcelRegister("dqOOP", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb96687cf554150a$export$2e2bcd8739ae039);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $bu6Od = parcelRequire("bu6Od");
const $eb96687cf554150a$var$fetchPolicy = 'network-only';

const $eb96687cf554150a$var$teamPreviewPanelEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dnJ8y")), {
        moduleId: "bc41c2d8",
        priority: "interaction",
        moduleId: 'team-preview-panel-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    parameters: $bu6Od.default,
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $eb96687cf554150a$var$fetchPolicy
                    }
                }
            }
        })
});
var $eb96687cf554150a$export$2e2bcd8739ae039 = $eb96687cf554150a$var$teamPreviewPanelEntryPoint;

});
parcelRegister("bu6Od", function(module, exports) {
$parcel$export(module.exports, "default", () => $8024e8afea8c3b11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9fb35c2d4439f6873526cfe4dbb0bdbc>>
 * @relayHash 91adf951953bfe64ddb250042a4a0511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527
const $8024e8afea8c3b11$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "orgId"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ]
        },
        "params": {
            "id": "1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527",
            "metadata": {},
            "name": "teamPreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8024e8afea8c3b11$var$node.hash = "6b8a5c1e76dd69e5d8daea6919628199";
var $8024e8afea8c3b11$export$2e2bcd8739ae039 = $8024e8afea8c3b11$var$node;

});

parcelRegister("dnJ8y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("eAoL3"),
    $4cvLQ("15ZAZ"),
    $4cvLQ("21W1z")
]).then(()=>parcelRequire('inkXN'));

});


parcelRegister("f0bXQ", function(module, exports) {
$parcel$export(module.exports, "ALL_SUPPORTED_OBJECTS", () => $d1f2801972fbe1be$export$cec6f7cb9c99f251);
const $d1f2801972fbe1be$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-blogpost',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project',
    'cmdb-object'
];

});

parcelRegister("jVtj7", function(module, exports) {
$parcel$export(module.exports, "default", () => $242caa1378c37c1b$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $242caa1378c37c1b$var$_default_1 = (0, $7eNDO.defineMessages)({
    workItem: {
        id: 'navigation.preview-panel-global-objects.workItem',
        defaultMessage: 'Jira work item',
        description: 'Title for the work item preview panel'
    },
    project: {
        id: 'navigation.preview-panel-global-objects.project',
        defaultMessage: 'Project',
        description: 'Title for the project preview panel'
    },
    goal: {
        id: 'navigation.preview-panel-global-objects.goal',
        defaultMessage: 'Goal',
        description: 'Title for the goal preview panel'
    },
    team: {
        id: 'navigation.preview-panel-global-objects.team',
        defaultMessage: 'Team',
        description: 'Title for the team preview panel'
    },
    blogPost: {
        id: 'navigation.preview-panel-global-objects.blogPost',
        defaultMessage: 'Confluence Blog Post',
        description: 'Title for the Confluence blog post preview panel'
    },
    page: {
        id: 'navigation.preview-panel-global-objects.page',
        defaultMessage: 'Confluence Page',
        description: 'Title for the Confluence page preview panel'
    },
    whiteboard: {
        id: 'navigation.preview-panel-global-objects.whiteboard',
        defaultMessage: 'Confluence Whiteboard',
        description: 'Title for the Confluence whiteboard preview panel'
    },
    object: {
        id: 'navigation.preview-panel-global-objects.object',
        defaultMessage: 'Assets Object',
        description: 'Title for the object preview panel'
    },
    loomVideo: {
        id: 'navigation.preview-panel-global-objects.loomVideo',
        defaultMessage: 'Loom Video',
        description: 'Title for the Loom video preview panel'
    },
    loomVideoIcon: {
        id: 'navigation.preview-panel-global-objects.loomVideoIcon',
        defaultMessage: 'Loom Video Icon',
        description: 'Icon for the Loom video preview panel'
    }
});
var $242caa1378c37c1b$export$2e2bcd8739ae039 = $242caa1378c37c1b$var$_default_1;

});

parcelRegister("3cXD8", function(module, exports) {
$parcel$export(module.exports, "EntryPointPreviewPanel", () => $596d55bbb3800c21$export$2ace74dd551e05c1);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gAEFP = parcelRequire("gAEFP");

var $f6Pvu = parcelRequire("f6Pvu");

var $54TxT = parcelRequire("54TxT");
const $596d55bbb3800c21$var$emptyEntryPointProps = {};
const $596d55bbb3800c21$export$2ace74dd551e05c1 = ({ entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: runtimeProps = $596d55bbb3800c21$var$emptyEntryPointProps, globalObject: globalObject })=>{
    const id = (0, $euxye.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gAEFP.InternalEntryPointContainer), {
        id: id,
        entryPointReference: preloadedEntryPointReference,
        fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $54TxT.FallbackPreviewPanel), {
            ...globalObject
        }),
        errorFallback: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6Pvu.ErrorFallbackPreviewPanel), {
                ...globalObject
            }),
        runtimeProps: runtimeProps
    });
};
$596d55bbb3800c21$export$2ace74dd551e05c1.displayName = "EntryPointPreviewPanel";

});
parcelRegister("f6Pvu", function(module, exports) {
$parcel$export(module.exports, "ErrorFallbackPreviewPanel", () => $342d0a97ee375660$export$9f31ac9d4b42e91c);
/* ErrorFallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $j26jU = parcelRequire("j26jU");

var $hzWaA = parcelRequire("hzWaA");

var $i7atl = parcelRequire("i7atl");
var $7XjBe = parcelRequire("7XjBe");
var $8ycpq = parcelRequire("8ycpq");
var $3opOC = parcelRequire("3opOC");

var $l0gQX = parcelRequire("l0gQX");

var $39MxW = parcelRequire("39MxW");

var $IKC7G = parcelRequire("IKC7G");
const $342d0a97ee375660$var$styles = {
    body: "_bozgxncg _y4tixncg _1q511ejb _85i51ejb"
};
const $342d0a97ee375660$export$9f31ac9d4b42e91c = /*#__PURE__*/ (0, $euxye.memo)(({ url: url, name: name, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { close: close } = (0, $l0gQX.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $i7atl.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8ycpq.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3opOC.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7XjBe.PreviewPanelBody), {
                styles: $342d0a97ee375660$var$styles.body,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j26jU.default), {
                    header: formatMessage((0, $IKC7G.messages).errorHeader),
                    description: formatMessage((0, $IKC7G.messages).errorDescription, {
                        link: (chunks)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                                href: "https://status.atlassian.com/",
                                children: chunks
                            })
                    }),
                    headingLevel: 2,
                    imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($39MxW)))
                })
            })
        ]
    });
});

});
parcelRegister("i7atl", function(module, exports) {
$parcel$export(module.exports, "PreviewPanel", () => $59acf583d06b8c81$export$9520f072db304aa0);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $3PC9r = parcelRequire("3PC9r");

var $kEMW4 = parcelRequire("kEMW4");
const $59acf583d06b8c81$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $59acf583d06b8c81$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    if ((0, $egspI.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kEMW4.PanelContainer), {
        testId: testId,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
        xcss: $59acf583d06b8c81$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
$59acf583d06b8c81$export$9520f072db304aa0.displayName = "PreviewPanel";

});
parcelRegister("kEMW4", function(module, exports) {
$parcel$export(module.exports, "PanelContainer", () => $cbeefdcbf7146394$export$7c4d2b536147788a);
/* panel-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $g68Oe = parcelRequire("g68Oe");
const $cbeefdcbf7146394$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon _1e0c1txw _2lx21bp4 _kqswh2mm",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _1tkeidpf"
};
function $cbeefdcbf7146394$export$7c4d2b536147788a({ children: children, testId: testId, isFocusLockEnabled: isFocusLockEnabled = false }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g68Oe.PanelFocusLock), {
        isFocusLockEnabled: isFocusLockEnabled,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
            as: "section",
            testId: testId,
            xcss: $cbeefdcbf7146394$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $cbeefdcbf7146394$var$styles.content,
                children: children
            })
        })
    });
}
$cbeefdcbf7146394$export$7c4d2b536147788a.displayName = "PanelContainer";

});
parcelRegister("g68Oe", function(module, exports) {
$parcel$export(module.exports, "PanelFocusLock", () => $54902b60caa8d5e2$export$85d112ac7df5c04f);
/* panel-focus-lock.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $g6TgS = parcelRequire("g6TgS");

var $u9iDa = parcelRequire("u9iDa");
// display: contents makes the wrapper div layout-transparent — it disappears from the
// box model so PanelContainer's own height/flex styles work exactly as if this wrapper
// were not there. This avoids breaking resize and full-height layouts.
const $54902b60caa8d5e2$var$contentsStyle = {
    display: 'contents'
};
const $54902b60caa8d5e2$var$containerStyles = null;
/**
 * Module-level count of currently-mounted PanelFocusLock instances.
 *
 * Used to suppress the return-focus restore when one panel is replaced by
 * another (e.g. Jira admin sidebar swaps Sidebar A → Sidebar B by changing
 * the Provider component, which unmounts/remounts PanelFocusLock). Without
 * this guard, the unmounting panel's queued double-rAF restore would fire
 * AFTER the new panel's autofocus, snapping focus back to the original
 * trigger while a replacement panel is on screen.
 *
 * The counter is decremented synchronously on cleanup BEFORE the new
 * instance's mount effect runs, then re-checked inside the deferred restore.
 * If another instance has mounted by the time the double-rAF fires, the
 * restore is skipped.
 */ let $54902b60caa8d5e2$var$panelFocusLockMountCount = 0;
/**
 * Module-level handoff for the "previously focused" element across an
 * unmount → mount swap.
 *
 * When one PanelFocusLock unmounts and is immediately replaced by another
 * because a button INSIDE the unmounting panel triggered the swap (e.g.
 * Sidebar A's footer "Add spaces" button opens Sidebar B), the replacement's
 * mount effect sees `document.activeElement === document.body` because the
 * previously-focused element lived inside the panel that just unmounted.
 * Without a handoff, the replacement would capture `body` as its "previously
 * focused" snapshot and on close would restore focus to nothing / blur.
 *
 * The unmounting instance writes its own previously-focused snapshot here,
 * and the next mounting instance reads + clears it. The handoff is used
 * ONLY when the replacement's `document.activeElement` is `body` (or null) —
 * meaning focus disappeared because it lived inside the unmounting panel.
 * If `document.activeElement` is a real element (e.g. the user clicked a
 * different page-level trigger to open this panel), that element wins
 * because it's a more accurate "where focus came from" signal than the
 * previous panel's snapshot. Cleared either by the next mount or by the
 * deferred restore when no replacement appears, so a stale value can't leak
 * across unrelated open cycles.
 */ let $54902b60caa8d5e2$var$pendingPreviouslyFocused = null;
/**
 * Selector for all focusable elements inside a container, in LTR tab order.
 */ const $54902b60caa8d5e2$var$FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'details > summary',
    'audio[controls]',
    'video[controls]'
].join(', ');
function $54902b60caa8d5e2$export$85d112ac7df5c04f({ children: children, isFocusLockEnabled: isFocusLockEnabled = false }) {
    const containerRef = (0, $euxye.useRef)(null);
    // Capture the element that was focused before the panel opened so we can
    // restore focus to it when the panel closes — regardless of which close
    // path is taken (X button, footer Close, programmatic close, etc.).
    const previouslyFocusedRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        // Determine the element focus should return to when this panel closes.
        //
        // Default: use the element that was focused at the moment we mount —
        // this is the natural "page trigger" the user just clicked.
        //
        // Edge case (handoff): when one panel unmounts and is immediately
        // replaced by another because a button INSIDE the previous panel
        // triggered the swap (e.g. Sidebar A's footer "Add spaces" button
        // opens Sidebar B), focus has nowhere to go: the trigger button just
        // unmounted with the previous panel, so `document.activeElement`
        // falls back to `body`. In that specific case we adopt the previous
        // panel's snapshot via the module-level handoff slot — it's typically
        // the original page-level trigger that opened the chain.
        //
        // Edge case (StrictMode): in development, React double-invokes
        // effects (setup → cleanup → setup). The second setup runs AFTER
        // Effect 2 below has already moved focus to our own first focusable,
        // so `document.activeElement` is inside our own container — but the
        // DOM was never actually unmounted, so the focused element is still
        // attached. We treat this case the same as body: the user never
        // "came from" our own input, so we should fall back to the handoff
        // (which was just set by Pass 1's cleanup). Without this guard,
        // `previouslyFocused` would be set to our own first focusable, and
        // on close `focus()` would target an element that is by then detached.
        //
        // Always clear the handoff slot regardless of whether we used it, so
        // a stale value can't leak forward into an unrelated future mount.
        const doc = (0, $u9iDa.getDocument)();
        const handoff = $54902b60caa8d5e2$var$pendingPreviouslyFocused;
        $54902b60caa8d5e2$var$pendingPreviouslyFocused = null;
        const activeElement = doc?.activeElement ?? null;
        const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
        const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
        const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
        const handoffIsAttached = !!handoff && !!doc?.body?.contains(handoff);
        previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? handoff : activeElement;
        $54902b60caa8d5e2$var$panelFocusLockMountCount += 1;
        return ()=>{
            $54902b60caa8d5e2$var$panelFocusLockMountCount -= 1;
            // Hand our snapshot off in case a replacement instance is about to
            // mount in the same commit — it will consume this and use it as its
            // own return-focus target, preserving the original trigger across the
            // swap. The slot is cleared either by the next mount or by the
            // deferred restore below if no replacement appears.
            $54902b60caa8d5e2$var$pendingPreviouslyFocused = previouslyFocusedRef.current;
            // Capture the target locally so it survives even if something else
            // mutates the ref between now and when the deferred callback fires.
            const toFocus = previouslyFocusedRef.current;
            // Restore focus on unmount (panel close). Two chained `setTimeout(0)`
            // ensure this fires after react-focus-lock's own deactivation logic
            // when the lock is active, and after React has finished applying any
            // commit that mounted a replacement panel.
            //
            // We use setTimeout rather than requestAnimationFrame here because
            // the latter is unreliable under jsdom + the React 18 concurrent
            // scheduler in unit tests: rAF callbacks scheduled inside a passive
            // effect cleanup don't always flush even when `jest.runAllTimers`
            // is called inside an `act` block (the scheduler uses MessageChannel,
            // which fake timers don't drive). setTimeout(0) flushes reliably with
            // both fake and real timers.
            setTimeout(()=>{
                setTimeout(()=>{
                    // Skip restore if another PanelFocusLock instance has mounted in
                    // the meantime — e.g. a sidebar swap where the consumer unmounts
                    // the current panel and mounts a replacement. The new instance's
                    // autofocus already moved focus into the replacement; restoring
                    // here would yank focus back to this panel's previously-focused
                    // element (typically the original page trigger) and visibly steal
                    // focus away from the replacement panel.
                    if ($54902b60caa8d5e2$var$panelFocusLockMountCount > 0) return;
                    // We're the last one out — clear the handoff so a future,
                    // unrelated panel open doesn't inherit a stale snapshot.
                    $54902b60caa8d5e2$var$pendingPreviouslyFocused = null;
                    toFocus?.focus();
                }, 0);
            }, 0);
        };
    }, []);
    // When the lock is NOT enabled, handle auto-focus ourselves — do NOT use
    // react-focus-lock even in disabled mode as it causes layout recalculations
    // that causes animation jank when the panel is inside a CSS transform animation
    // (e.g. SlideIn from @atlaskit/motion).
    (0, $euxye.useEffect)(()=>{
        if (isFocusLockEnabled) return;
        const container = containerRef.current;
        if (!container) return;
        // Focus synchronously in useEffect (post-paint) with preventScroll to avoid
        // the browser calling scrollIntoView on a mid-animation element.
        const firstFocusable = container.querySelector($54902b60caa8d5e2$var$FOCUSABLE_SELECTOR);
        if (firstFocusable) firstFocusable.focus({
            preventScroll: true
        });
    }, [
        isFocusLockEnabled
    ]);
    // When the lock IS enabled, use react-focus-lock for both autoFocus and the trap.
    if (isFocusLockEnabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g6TgS.default), {
        autoFocus: true,
        returnFocus: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        lockProps: {
            style: $54902b60caa8d5e2$var$contentsStyle
        },
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            ref: containerRef,
            style: $54902b60caa8d5e2$var$contentsStyle,
            children: children
        })
    });
    // Default (no lock): plain wrapper div, auto-focus handled by useEffect above.
    // We deliberately avoid react-focus-lock here to prevent animation jank.
    // height: 100% ensures PanelContainer's own height: 100% resolves correctly.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: containerRef,
        className: (0, $4jQY2.default)([
            "_4t3i1osq"
        ]),
        children: children
    });
}
$54902b60caa8d5e2$export$85d112ac7df5c04f.displayName = "PanelFocusLock";

});



parcelRegister("7XjBe", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelBody", () => $736f1c436d54306c$export$cda5e69749e7aeee);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");

var $7O8M3 = parcelRequire("7O8M3");

var $btL4U = parcelRequire("btL4U");
const $736f1c436d54306c$var$panelSystemStyles = {
    fillParent: "_4t3i1osq _1e0c1txw _2lx21bp4"
};
const $736f1c436d54306c$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles })=>{
    const bodyRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    // Availability check only — this decides whether to decorate the preview-panel
                    // "viewed" track event with analyticsAttributes, NOT whether the user is
                    // accessing the Capacity planning experience. We therefore read the GA
                    // experiment WITHOUT firing a Statsig exposure (fireExperimentExposure: false);
                    // exposure is fired at the point the user actually opens the Capacity
                    // experience, keeping the GA experiment's population clean.
                    //
                    // The OR (now 3-way) still short-circuits: when either the legacy EAP gate or
                    // the `add-trigger-point-key-attribute-to-preview-panel` gate is ON, the GA
                    // experiment is never read at all. EAP customers remain unconditionally enabled.
                    ...(0, $egspI.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $egspI.fg)('add-trigger-point-key-attribute-to-preview-panel') || (0, $4LDqh.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = (0, $egspI.fg)('ads-panel-system-gpp') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: (0, $1MNmN.cx)($736f1c436d54306c$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
        ref: bodyRef,
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: (0, $1MNmN.cx)(!!consumerStyles && consumerStyles),
        ref: bodyRef,
        children: children
    });
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ if ((0, $egspI.fg)('ads-panel-system-gpp')) {
        const wrappedBody = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7O8M3.PanelBody), {
            spacing: "none",
            children: panelBodyContent
        });
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $btL4U.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes,
            children: wrappedBody
        });
    }
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $btL4U.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes,
        children: panelBodyContent
    });
};
$736f1c436d54306c$export$cda5e69749e7aeee.displayName = "PreviewPanelBody";

});
parcelRegister("7O8M3", function(module, exports) {
$parcel$export(module.exports, "PanelBody", () => $7c85aeb4d295435e$export$3ac6fba5a6f84a87);
/* panel-body.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $ihEDU = parcelRequire("ihEDU");
const $7c85aeb4d295435e$var$styles = {
    body: "_16jlkb7n _1i4qfg65 _kqswh2mm",
    defaultSpacing: "_1rjcze3t _bozg1ejb _y4ti1ejb"
};
function $7c85aeb4d295435e$export$3ac6fba5a6f84a87({ children: children, spacing: spacing = 'default', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        testId: testId,
        xcss: (0, $1MNmN.cx)($7c85aeb4d295435e$var$styles.body, spacing === 'default' && $7c85aeb4d295435e$var$styles.defaultSpacing),
        children: children
    });
}
$7c85aeb4d295435e$export$3ac6fba5a6f84a87.displayName = "PanelBody";

});

parcelRegister("btL4U", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelSniffer", () => $4fbdb5a3d30f83ed$export$93a96f69a5c679de);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");
const $4fbdb5a3d30f83ed$export$93a96f69a5c679de = ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $euxye.useRef)(false);
    const isValidContentSizeMessage = (0, $euxye.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $euxye.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                // Availability check only — this decides whether to decorate the overflow
                // operational event with analyticsAttributes, NOT whether the user is
                // accessing the Capacity planning experience. We therefore read the GA
                // experiment WITHOUT firing a Statsig exposure
                // (fireExperimentExposure: false); exposure is fired at the point the user
                // actually opens the Capacity experience, keeping the GA experiment's
                // population clean.
                //
                // The OR still short-circuits: when the legacy EAP gate is ON the experiment
                // is never read at all. EAP customers remain unconditionally enabled.
                ...(0, $egspI.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $4LDqh.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $euxye.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth = bodyElement.clientWidth;
            const scrollWidth = bodyElement.scrollWidth;
            if (scrollWidth > clientWidth) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth,
                scrollWidth: scrollWidth
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $euxye.useEffect)(()=>{
        const handleMessage = (event)=>{
            const contentSizePayload = event.data;
            if (!isValidContentSizeMessage(event, contentSizePayload)) return;
            const panelIframe = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe?.clientWidth ?? 0;
            const clientWidth = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth !== 'number' || contentSizePayload.width <= clientWidth) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth,
                scrollWidth: contentSizePayload.width
            });
        };
        return (0, $glbdM.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$4fbdb5a3d30f83ed$export$93a96f69a5c679de.displayName = "PreviewPanelSniffer";

});


parcelRegister("8ycpq", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelHeader", () => $448f4cf34b706a2e$export$426d4171de44bac0);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $5ZMSQ = parcelRequire("5ZMSQ");

var $1YIbA = parcelRequire("1YIbA");

var $m9iwH = parcelRequire("m9iwH");

var $6JMJ2 = parcelRequire("6JMJ2");

var $i68tN = parcelRequire("i68tN");

var $a1Bqx = parcelRequire("a1Bqx");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $defJG = parcelRequire("defJG");

var $4BPK5 = parcelRequire("4BPK5");
var $lWUiG = parcelRequire("lWUiG");
var $eb9Iw = parcelRequire("eb9Iw");
var $hgExa = parcelRequire("hgExa");

var $303ZP = parcelRequire("303ZP");

var $cuOll = parcelRequire("cuOll");
const $448f4cf34b706a2e$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $448f4cf34b706a2e$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n",
    titleRegion: "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4 _16jlkb7n _1ul9idpf"
};
const $448f4cf34b706a2e$export$426d4171de44bac0 = ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const enableCrossMAUUsage = (0, $egspI.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $5ZMSQ.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($448f4cf34b706a2e$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $448f4cf34b706a2e$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    const onPanelNavigateBack = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-navigate-back',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onNavigateBack?.();
    };
    if ((0, $egspI.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $hgExa.PanelHeader), {
        testId: testId,
        children: [
            onNavigateBack && (0, $egspI.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4BPK5.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6JMJ2))),
                label: formatMessage((0, $303ZP.default).previewPanelNavigateBackLabel),
                onClick: onPanelNavigateBack,
                testId: testId && `${testId}.navigate-back-button`,
                appearance: "default"
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $448f4cf34b706a2e$var$styles.titleRegion,
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $eb9Iw.PanelActionGroup), {
                children: [
                    url && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4BPK5.PanelAction), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))),
                        label: formatMessage((0, $303ZP.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`,
                        appearance: "subtle"
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lWUiG.PanelActionClose), {
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        label: formatMessage((0, $303ZP.default).previewPanelCloseButtonLabel)
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
        xcss: $448f4cf34b706a2e$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            onNavigateBack && (0, $egspI.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6JMJ2))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $303ZP.default).previewPanelNavigateBackLabel),
                onClick: onPanelNavigateBack,
                testId: testId && `${testId}.navigate-back-button`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
                xcss: $448f4cf34b706a2e$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cuOll.PreviewPanelNewTabLink), {
                        label: formatMessage((0, $303ZP.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $303ZP.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
$448f4cf34b706a2e$export$426d4171de44bac0.displayName = "PreviewPanelHeader";

});
parcelRegister("4BPK5", function(module, exports) {
$parcel$export(module.exports, "PanelAction", () => $5d05435c7a5f3ec3$export$2a18e3520151503);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iOfms = parcelRequire("iOfms");
var $m9iwH = parcelRequire("m9iwH");

var $9MWap = parcelRequire("9MWap");
const $5d05435c7a5f3ec3$export$2a18e3520151503 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(({ children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHaspopup, 'aria-expanded': ariaExpanded, icon: icon, label: label, appearance: appearance = 'subtle', spacing: spacing = 'default' }, ref)=>{
    if (icon) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (href) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.default), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        appearance: appearance,
        children: children
    });
});

});

parcelRegister("lWUiG", function(module, exports) {
$parcel$export(module.exports, "PanelActionClose", () => $18f4e0ca1eda1f6a$export$75d0a5a5f71a1ab1);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $i68tN = parcelRequire("i68tN");

var $4BPK5 = parcelRequire("4BPK5");
const $18f4e0ca1eda1f6a$export$75d0a5a5f71a1ab1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(({ onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label }, ref)=>{
    const handleClick = async (event, analyticsEvent)=>{
        if (onBeforeClose) {
            const canClose = await onBeforeClose();
            if (!canClose) return;
        }
        if (onClick) onClick(event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4BPK5.PanelAction), {
        ref: ref,
        onClick: handleClick,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
        label: label || 'Close panel',
        spacing: "compact",
        appearance: "subtle"
    });
});

});

parcelRegister("eb9Iw", function(module, exports) {
$parcel$export(module.exports, "PanelActionGroup", () => $d699c13af98db985$export$9546bd4ca18522f9);
/* panel-action-group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
const $d699c13af98db985$var$styles = {
    group: "_zulpu2gc _1e0c1txw _4cvr1h6o"
};
function $d699c13af98db985$export$9546bd4ca18522f9({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        testId: testId,
        xcss: $d699c13af98db985$var$styles.group,
        children: children
    });
}
$d699c13af98db985$export$9546bd4ca18522f9.displayName = "PanelActionGroup";

});

parcelRegister("hgExa", function(module, exports) {
$parcel$export(module.exports, "PanelHeader", () => $3218463a8fe62e93$export$968713404ca1c9aa);
/* panel-header.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
const $3218463a8fe62e93$var$styles = {
    header: "_4t3i1k7u _1e0c1txw _4cvr1h6o _bozgv47k _y4tiv47k _1q51pxbi _85i5pxbi",
    headerContent: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
};
function $3218463a8fe62e93$export$968713404ca1c9aa({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        as: "header",
        testId: testId,
        xcss: $3218463a8fe62e93$var$styles.header,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.default), {
            xcss: $3218463a8fe62e93$var$styles.headerContent,
            children: children
        })
    });
}
$3218463a8fe62e93$export$968713404ca1c9aa.displayName = "PanelHeader";

});

parcelRegister("303ZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f98bcf7a9fb0c19d$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $f98bcf7a9fb0c19d$var$_default_1 = (0, $7eNDO.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: 'navigation.preview-panel.preview-panel-header.close-button-label',
        defaultMessage: 'Close',
        description: 'Label for the close button in the preview panel'
    },
    previewPanelExpandActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label',
        defaultMessage: 'Expand',
        description: 'Label for the expand action in the preview panel'
    },
    previewPanelNewTabActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label',
        defaultMessage: 'Open in new tab',
        description: 'Label for the open in new tab action in the preview panel'
    },
    previewPanelMoreDropdownActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label',
        defaultMessage: 'More',
        description: 'Label for the more dropdown action in the preview panel'
    },
    previewPanelOpenInNewWindowLabel: {
        id: 'navigation.preview-panel.preview-panel-header.open-in-new-window-label',
        defaultMessage: 'Open in new window',
        description: 'Label for the open in new window button in the preview panel header'
    },
    previewPanelNavigateBackLabel: {
        id: 'navigation.preview-panel.preview-panel-header.navigate-back-label',
        defaultMessage: 'Go back to previous panel',
        description: 'Label for the back button in the preview panel header'
    }
});
var $f98bcf7a9fb0c19d$export$2e2bcd8739ae039 = $f98bcf7a9fb0c19d$var$_default_1;

});

parcelRegister("cuOll", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelNewTabLink", () => $5abfa86ca61c9104$export$d05dda6f1d91eaad);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $a1Bqx = parcelRequire("a1Bqx");

var $303ZP = parcelRequire("303ZP");

var $gyBJ0 = parcelRequire("gyBJ0");
const $5abfa86ca61c9104$export$d05dda6f1d91eaad = ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gyBJ0.PreviewPanelAction), {
        label: label || formatMessage((0, $303ZP.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
$5abfa86ca61c9104$export$d05dda6f1d91eaad.displayName = "PreviewPanelNewTabLink";

});
parcelRegister("gyBJ0", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelAction", () => $df31c14cc2f739bb$export$a37cb5f447b2cf16);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");
var $lMezl = parcelRequire("lMezl");

var $egspI = parcelRequire("egspI");

var $4BPK5 = parcelRequire("4BPK5");
const $df31c14cc2f739bb$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    if ((0, $egspI.fg)('ads-panel-system-gpp')) {
        if (analyticsContext || href) return href ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lMezl.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4BPK5.PanelAction), {
            ref: ref,
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            appearance: "subtle"
        });
    }
    return href ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lMezl.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});

});



parcelRegister("3opOC", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelTitle", () => $90f0ee29a9b65227$export$92a58681483f4529);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $defJG = parcelRequire("defJG");
var $8Sdzy = parcelRequire("8Sdzy");

var $kGp0m = parcelRequire("kGp0m");
const $90f0ee29a9b65227$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    if ((0, $egspI.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kGp0m.PanelTitle), {
        icon: icon,
        children: title
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
$90f0ee29a9b65227$export$92a58681483f4529.displayName = "PreviewPanelTitle";

});
parcelRegister("kGp0m", function(module, exports) {
$parcel$export(module.exports, "PanelTitle", () => $202afebe60bf4a79$export$86de09faaa70680d);
/* panel-title.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2iotI = parcelRequire("2iotI");

var $ihEDU = parcelRequire("ihEDU");
const $202afebe60bf4a79$var$styles = {
    title: "_1e0c1txw _4cvr1h6o _16jlkb7n",
    titleText: "_bozg1b66",
    icon: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s"
};
function $202afebe60bf4a79$export$86de09faaa70680d({ children: children, icon: icon, testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        testId: testId,
        xcss: $202afebe60bf4a79$var$styles.title,
        children: [
            icon && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $202afebe60bf4a79$var$styles.icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $202afebe60bf4a79$var$styles.titleText
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                    size: "small",
                    as: "h2",
                    children: children
                })
            })
        ]
    });
}
$202afebe60bf4a79$export$86de09faaa70680d.displayName = "PanelTitle";

});


parcelRegister("39MxW", function(module, exports) {
module.exports = new URL("ErrorGeneric.d6dc5451.svg", import.meta.url).toString();

});

parcelRegister("IKC7G", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2dbf13baa11f0efc$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $2dbf13baa11f0efc$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    errorHeader: {
        id: 'navigation.preview-panel-global-objects.panels.error-header',
        defaultMessage: "Can\u2019t load details",
        description: 'Header for the preview panel error state'
    },
    errorDescription: {
        id: 'navigation.preview-panel-global-objects.panels.error-description',
        defaultMessage: "We\u2019ve got all hands on deck working to get you back up and running. For more information, <link>check our status page</link>.",
        description: 'Description for the preview panel error state'
    }
});

});


parcelRegister("54TxT", function(module, exports) {
$parcel$export(module.exports, "FallbackPreviewPanel", () => $7b2891cc7821ec2e$export$97ea7ee86eec0667);
/* FallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");

var $i7atl = parcelRequire("i7atl");
var $7XjBe = parcelRequire("7XjBe");
var $8ycpq = parcelRequire("8ycpq");
var $3opOC = parcelRequire("3opOC");

var $l0gQX = parcelRequire("l0gQX");

var $jCByN = parcelRequire("jCByN");
const $7b2891cc7821ec2e$var$styles = {
    body: "_zulppxbi _1e0c1txw _2lx21bp4 _16jlkb7n _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    skeleton: "_2rko12b0 _1e0c1txw _bfhkizff _4t3igktf",
    skeletonRow1: "_1bsb1osq",
    skeletonRow2: "_1bsb1nrf",
    skeletonRow3: "_1bsb1w8u",
    skeletonRow4: "_1bsbhwvj"
};
const $7b2891cc7821ec2e$export$97ea7ee86eec0667 = /*#__PURE__*/ (0, $euxye.memo)(({ url: url, name: name, icon: icon })=>{
    const { close: close } = (0, $l0gQX.usePreviewPanelsActions)();
    const { canNavigateBack: canNavigateBack, navigateBack: navigateBack } = (0, $jCByN.usePreviewPanelsNavigation)();
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $i7atl.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8ycpq.PreviewPanelHeader), {
                onClose: close,
                onNavigateBack: canNavigateBack && (0, $egspI.fg)('jivtech-1920-back-navigation-gpp') ? navigateBack : undefined,
                url: url,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3opOC.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $7XjBe.PreviewPanelBody), {
                styles: $7b2891cc7821ec2e$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $7b2891cc7821ec2e$var$styles.skeleton,
                            $7b2891cc7821ec2e$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $7b2891cc7821ec2e$var$styles.skeleton,
                            $7b2891cc7821ec2e$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $7b2891cc7821ec2e$var$styles.skeleton,
                            $7b2891cc7821ec2e$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $7b2891cc7821ec2e$var$styles.skeleton,
                            $7b2891cc7821ec2e$var$styles.skeletonRow4
                        ])
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $7b2891cc7821ec2e$var$styles.skeleton,
                            $7b2891cc7821ec2e$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $7b2891cc7821ec2e$var$styles.skeleton,
                            $7b2891cc7821ec2e$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $7b2891cc7821ec2e$var$styles.skeleton,
                            $7b2891cc7821ec2e$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            $7b2891cc7821ec2e$var$styles.skeleton,
                            $7b2891cc7821ec2e$var$styles.skeletonRow4
                        ])
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("jCByN", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelsNavigationProvider", () => $7ba4c9911deeef6c$export$b66db24661d592b6);
$parcel$export(module.exports, "usePreviewPanelsNavigation", () => $7ba4c9911deeef6c$export$fdc48f5600cae5d);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5IRCU = parcelRequire("5IRCU");

var $l0gQX = parcelRequire("l0gQX");
const $7ba4c9911deeef6c$var$noop = ()=>{};
const $7ba4c9911deeef6c$var$PreviewPanelsNavigationContext = /*#__PURE__*/ (0, $euxye.createContext)({
    history: [],
    canNavigateBack: false,
    clearHistory: $7ba4c9911deeef6c$var$noop,
    onPanelOpen: $7ba4c9911deeef6c$var$noop,
    navigateBack: $7ba4c9911deeef6c$var$noop
});
const $7ba4c9911deeef6c$export$b66db24661d592b6 = ({ children: children, setHistory: setHistory })=>{
    const [panelHistory, setPanelHistory] = (0, $euxye.useState)([]);
    /**
	 * Tracks the panel we're navigating away from during `navigateBack` so the next `onPanelOpen` triggered by re-opening the popped panel can be ignored.
	 * A ref is required because `onPanelOpen` can be called synchronously within the same tick (`PreviewPanelsProvider` calls the `onOpen` callback before committing/re-rendering).
	 */ const navigateBackFromPanelRef = (0, $euxye.useRef)(null);
    const currentPanel = (0, $5IRCU.useCurrentPreviewPanel)();
    const { open: openPreviewPanel } = (0, $l0gQX.usePreviewPanelsActions)();
    const addHistoryItem = (0, $euxye.useCallback)((panel)=>{
        const updatedPanelHistory = [
            ...panelHistory,
            panel
        ];
        setPanelHistory(updatedPanelHistory);
        setHistory?.(updatedPanelHistory);
    }, [
        panelHistory,
        setHistory
    ]);
    const removeLastHistoryItem = (0, $euxye.useCallback)(()=>{
        const previousItem = panelHistory.at(-1);
        if (previousItem == null) return null;
        const updatedPanelHistory = panelHistory.slice(0, -1);
        setPanelHistory(updatedPanelHistory);
        setHistory?.(updatedPanelHistory);
        return previousItem;
    }, [
        panelHistory,
        setHistory
    ]);
    const clearHistory = (0, $euxye.useCallback)(()=>{
        setPanelHistory([]);
        setHistory?.([]);
    }, [
        setHistory
    ]);
    const onPanelOpen = (0, $euxye.useCallback)(()=>{
        if (currentPanel != null && navigateBackFromPanelRef.current?.id !== currentPanel.id) addHistoryItem(currentPanel);
        navigateBackFromPanelRef.current = null;
    }, [
        currentPanel,
        addHistoryItem
    ]);
    const navigateBack = (0, $euxye.useCallback)(()=>{
        if (currentPanel == null) return;
        const panelToOpen = removeLastHistoryItem();
        if (panelToOpen == null) return;
        navigateBackFromPanelRef.current = currentPanel;
        const open = ()=>openPreviewPanel({
                panel: panelToOpen
            });
        if (panelToOpen.onNavigateBack != null) panelToOpen.onNavigateBack(currentPanel, open);
        else open();
    }, [
        currentPanel,
        openPreviewPanel,
        removeLastHistoryItem
    ]);
    const canNavigateBack = panelHistory.length > 0;
    (0, $euxye.useEffect)(()=>{
        // Ensure history is empty when preview panel is closed
        if (canNavigateBack && currentPanel == null) {
            clearHistory();
            navigateBackFromPanelRef.current = null;
        }
    }, [
        canNavigateBack,
        currentPanel,
        clearHistory
    ]);
    const context = (0, $euxye.useMemo)(()=>({
            history: panelHistory,
            canNavigateBack: canNavigateBack,
            clearHistory: clearHistory,
            onPanelOpen: onPanelOpen,
            navigateBack: navigateBack
        }), [
        canNavigateBack,
        panelHistory,
        clearHistory,
        onPanelOpen,
        navigateBack
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($7ba4c9911deeef6c$var$PreviewPanelsNavigationContext.Provider, {
        value: context,
        children: children
    });
};
$7ba4c9911deeef6c$export$b66db24661d592b6.displayName = "PreviewPanelsNavigationProvider";
const $7ba4c9911deeef6c$export$fdc48f5600cae5d = ()=>(0, $euxye.useContext)($7ba4c9911deeef6c$var$PreviewPanelsNavigationContext);

});



parcelRegister("YTtNs", function(module, exports) {
$parcel$export(module.exports, "IFramePreviewPanel", () => $fd82f03b07b7add0$export$83f0623b6f97b032);
/* IFramePreviewPanel.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $gL9hl = parcelRequire("gL9hl");
var $hIipg = parcelRequire("hIipg");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $4C7HL = parcelRequire("4C7HL");

var $i7atl = parcelRequire("i7atl");
var $7XjBe = parcelRequire("7XjBe");
var $8ycpq = parcelRequire("8ycpq");
var $3opOC = parcelRequire("3opOC");

var $l0gQX = parcelRequire("l0gQX");

var $jCByN = parcelRequire("jCByN");

var $h0TMG = parcelRequire("h0TMG");
const $fd82f03b07b7add0$var$styles = {
    iframe: "_19itglyw _1bsb1osq _4t3i1osq",
    body: "_1e0c1txw _16jlkb7n _18m91wug"
};
const $fd82f03b07b7add0$export$6c67178058384ea6 = (ari)=>{
    if (!ari || typeof ari !== 'string' || !ari.startsWith('ari:cloud:jira:')) return undefined;
    const parts = ari.split(':');
    if (parts.length !== 5) return undefined;
    const cloudId = parts[3];
    if (!cloudId) return undefined;
    return cloudId;
};
const $fd82f03b07b7add0$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $euxye.memo)(({ url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari, analyticsAttributes: analyticsAttributes })=>{
    const { close: close } = (0, $l0gQX.usePreviewPanelsActions)();
    const { canNavigateBack: canNavigateBack, navigateBack: navigateBack } = (0, $jCByN.usePreviewPanelsNavigation)();
    const [analyticsClient, setAnalyticsClient] = (0, $euxye.useState)();
    const cloudId = ari ?? $fd82f03b07b7add0$export$6c67178058384ea6(ari);
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    (0, $euxye.useEffect)(()=>{
        setAnalyticsClient(()=>{
            let analyticsClient = new (0, $gL9hl.default)({
                product: product,
                env: (0, $h0TMG.getAnalyticsEnv)(window.location.hostname),
                origin: (0, $hIipg.originType).WEB
            });
            if (cloudId) analyticsClient?.setTenantInfo((0, $hIipg.tenantType).CLOUD_ID, cloudId);
            return analyticsClient;
        });
    }, [
        product,
        cloudId
    ]); // Create iframe URL with theme parameter
    const iframeSrc = (0, $euxye.useMemo)(()=>{
        if (!iframeUrl || !colorMode) return iframeUrl;
        const url = new URL(iframeUrl, window.location.origin);
        url.searchParams.set('themeMode', colorMode);
        return url.toString();
    }, [
        iframeUrl,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $i7atl.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8ycpq.PreviewPanelHeader), {
                onClose: close,
                onNavigateBack: canNavigateBack && (0, $egspI.fg)('jivtech-1920-back-navigation-gpp') ? navigateBack : undefined,
                url: url,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3opOC.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7XjBe.PreviewPanelBody), {
                styles: $fd82f03b07b7add0$var$styles.body,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsClient: analyticsClient,
                ...(0, $egspI.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $4LDqh.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? {
                    analyticsAttributes: analyticsAttributes
                } : {},
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("iframe", {
                    src: iframeSrc,
                    title: name,
                    className: (0, $4jQY2.default)([
                        $fd82f03b07b7add0$var$styles.iframe
                    ])
                })
            })
        ]
    });
});

});
parcelRegister("h0TMG", function(module, exports) {
$parcel$export(module.exports, "isInIframe", () => $11c5a1f535d37299$export$9f140ed41af5108c);
$parcel$export(module.exports, "asGlobalObjectType", () => $11c5a1f535d37299$export$5b60458e6ab1ba54);
$parcel$export(module.exports, "buildIssueViewEmbedUrl", () => $11c5a1f535d37299$export$4e691bca3211cc2f);
$parcel$export(module.exports, "getAnalyticsEnv", () => $11c5a1f535d37299$export$4acedbb0ac692186);

var $hIipg = parcelRequire("hIipg");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $f0bXQ = parcelRequire("f0bXQ");
const $11c5a1f535d37299$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $11c5a1f535d37299$export$5b60458e6ab1ba54 = (value)=>{
    if (!(0, $f0bXQ.ALL_SUPPORTED_OBJECTS).includes(value)) throw new Error(`Unsupported global object type: ${value}`);
    return value;
};
const $11c5a1f535d37299$export$4e691bca3211cc2f = (url, supportedObjects, rootSourceScreen)=>{
    try {
        const urlObj = new URL(url);
        if ((0, $egspI.fg)('pol-21166-fix-404-on-jpd-preview')) {
            if ($11c5a1f535d37299$var$isJpdObject(urlObj)) return $11c5a1f535d37299$var$buildJpdEmbedUrl(urlObj);
        }
        // Ensure there's no trailing slash before appending '/embed'
        urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/embed';
        // Add previewPanels to existing search params
        urlObj.searchParams.set('previewPanels', supportedObjects.join(','));
        // Availability check only — this decides whether to append the previewRootSourceScreen
        // URL param, NOT whether the user is accessing the Capacity planning experience. We
        // therefore read the GA experiment WITHOUT firing a Statsig exposure
        // (fireExperimentExposure: false); exposure is fired at the point the user actually
        // opens the Capacity experience, keeping the GA experiment's population clean.
        //
        // The OR still short-circuits: when the legacy EAP gate is ON the experiment is never
        // read at all. EAP customers remain unconditionally enabled.
        if (rootSourceScreen && ((0, $egspI.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $4LDqh.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
            fireExperimentExposure: false
        }))) urlObj.searchParams.set('previewRootSourceScreen', rootSourceScreen);
        // Return the full URL as a string
        return urlObj.toString();
    } catch  {
        // Fallback for invalid URLs.
        //
        // Availability check only (same semantics as the happy path above): this decides
        // whether to append previewRootSource, NOT whether the user is accessing the Capacity
        // planning experience. We read the GA experiment WITHOUT firing a Statsig exposure
        // (fireExperimentExposure: false). The OR still short-circuits when the legacy EAP gate
        // is ON, preserving a clean GA-experiment population.
        if ((0, $egspI.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $4LDqh.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
            fireExperimentExposure: false
        })) {
            const encodedRootSource = rootSourceScreen ? `&previewRootSource=${encodeURIComponent(rootSourceScreen)}` : '';
            return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}${encodedRootSource}`;
        } else return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`;
    }
};
const $11c5a1f535d37299$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost') || hostname.includes('jira-dev')) return (0, $hIipg.envType).DEV;
    return (0, $hIipg.envType).PROD;
};
const $11c5a1f535d37299$var$isJpdObject = (urlObj)=>{
    return urlObj.pathname.includes('/jira/polaris/projects/');
};
const $11c5a1f535d37299$var$buildJpdEmbedUrl = (urlObj)=>{
    const ideaKey = urlObj.searchParams.get('selectedIssue');
    urlObj.searchParams.delete('selectedIssue');
    urlObj.pathname = `/browse/${ideaKey}/embed`;
    return urlObj.toString();
};

});



// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $2de0ca8181f03e7e$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $2de0ca8181f03e7e$export$64aee74ba59709e5 = 439; // px
const $2de0ca8181f03e7e$export$1c07393c5bb1bc27 = 439; // px
const $2de0ca8181f03e7e$export$aa3478deee7adbeb = 350; // px
const $2de0ca8181f03e7e$export$21e515a86cd1733b = 'Chat';
const $2de0ca8181f03e7e$export$e942bf04e23ff966 = 'Rovo';

/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $2b56b53c34bc2033$export$c43c7444da662fa1 = '1';
const $2b56b53c34bc2033$export$e99efa3985fa3c26 = 'helpPanel';
const $2b56b53c34bc2033$export$23aa6670f346c214 = 368;

parcelRegister("fKsee", function(module, exports) {
$parcel$export(module.exports, "isNativeIssueViewPreviewPanel", () => $0202b5ea207d159b$export$51d6de34c4c87b23);
const $0202b5ea207d159b$export$51d6de34c4c87b23 = (panel)=>{
    return panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
};

});

parcelRegister("52FsB", function(module, exports) {
$parcel$export(module.exports, "JiraPreviewPanelsContext", () => $5aca180de26aa26f$export$3698338ef935e74e);
/**
 * JiraPreviewPanelsContext — the React context for the Jira Preview Panels system.
 *
 * Kept in its own dedicated file so that both the lightweight hook file
 */ 
var $euxye = parcelRequire("euxye");
const $5aca180de26aa26f$export$3698338ef935e74e = /*#__PURE__*/ (0, $euxye.createContext)(null);

});

parcelRegister("5MzDM", function(module, exports) {
$parcel$export(module.exports, "JiraPreviewPanelsNavigationProvider", () => $0a66614eb2c074f8$export$655df495226ad470);

var $euxye = parcelRequire("euxye");

var $jCByN = parcelRequire("jCByN");

var $f2wVS = parcelRequire("f2wVS");

var $fKsee = parcelRequire("fKsee");

var $52FsB = parcelRequire("52FsB");

var $2s1Bd = parcelRequire("2s1Bd");
const $0a66614eb2c074f8$export$655df495226ad470 = ({ children: children })=>{
    const { navigation: navigation, subscribe: subscribe } = (0, $euxye.useContext)((0, $52FsB.JiraPreviewPanelsContext)) || {};
    const { history: panelHistory, clearHistory: clearHistory, navigateBack: navigateBack, onPanelOpen: onPanelOpen } = (0, $jCByN.usePreviewPanelsNavigation)();
    // Tracks browser `popstate` so we either navigate back or add the panel to history
    const didPopstateTriggerRef = (0, $euxye.useRef)(false);
    // Determines whether panel navigation history will be tracked or cleared
    const didClickInsidePanelRef = (0, $euxye.useRef)(false);
    const didClickInsideIssueAppRef = (0, $euxye.useRef)(false);
    // URL-agnostic signal: lets consumers tell a browser back/forward apart from in-app
    // navigation so they can close their own panel on back-out using their own URL param.
    const getIsBrowserPopstateTriggered = (0, $euxye.useCallback)(()=>didPopstateTriggerRef.current, []);
    const markPreviewPanelClick = (0, $euxye.useCallback)(()=>{
        didClickInsidePanelRef.current = true;
    }, []);
    const markIssuePreviewPanelClick = (0, $euxye.useCallback)(()=>{
        didClickInsideIssueAppRef.current = true;
    }, []);
    (0, $euxye.useEffect)(()=>{
        const unsubscribeRouteListener = (0, $f2wVS.addRouteListener)((state)=>{
            if (!state.route.supportsPreviewPanel) return;
            didPopstateTriggerRef.current = state.action === 'POP';
        });
        return ()=>{
            didPopstateTriggerRef.current = false;
            unsubscribeRouteListener();
        };
    }, []);
    /**
	 * Preview Panel navigation history in Jira is handled globally for the following reasons:
	 * - Consumers might call `usePreviewPanelsActions().open` inside a `useEffect`,
	 *   causing unintentional behaviour on re-render if `onPanelOpen` becomes a dependency
	 * - Browser back/forward handling is decoupled from consumers of `useIssuePreviewPanel`
	 * - Limit recording navigation history to `open` events triggered inside Preview Panels
	 */ (0, $euxye.useEffect)(()=>{
        const handleOpenEvent = (panelToOpen)=>{
            const panelHistoryIndex = panelHistory.findIndex((panelHistoryItem)=>panelHistoryItem.id === panelToOpen.id);
            const shouldNavigateBack = didPopstateTriggerRef.current && panelHistoryIndex > -1 && panelHistoryIndex === panelHistory.length - 1;
            if (shouldNavigateBack) // If browser back/forward is triggered and the next panel opened was the last history item, remove it from history instead
            navigateBack();
            else if (!didClickInsidePanelRef.current) // Reset navigation history if event was triggered outside of the current panel
            clearHistory();
            else if (!(0, $fKsee.isNativeIssueViewPreviewPanel)(panelToOpen) || // Excludes any navigation handling in the Issue Preview Panel header
            didClickInsideIssueAppRef.current) {
                // Record navigation history only if the event triggered inside the current panel
                // is from a non-issue panel OR the issue app wrapper
                onPanelOpen();
                if (navigation) {
                    navigation.onNavigateAway.current?.(panelToOpen);
                    // Discard so we can handle the next panel's `onNavigateAway`
                    navigation.onNavigateAway.current = undefined;
                }
            }
        };
        const unsubscribePreviewPanelListener = subscribe?.((event)=>{
            if (event.action === 'open') {
                handleOpenEvent(event.panel);
                // Clear refs only after `open` events since `close` can also trigger in the same tick
                didPopstateTriggerRef.current = false;
                didClickInsidePanelRef.current = false;
                didClickInsideIssueAppRef.current = false;
            }
        });
        return ()=>unsubscribePreviewPanelListener?.();
    }, [
        navigation,
        panelHistory,
        clearHistory,
        navigateBack,
        onPanelOpen,
        subscribe
    ]);
    const setPreviewPanelNavigation = (0, $euxye.useCallback)((listeners)=>{
        if (navigation == null) return;
        if (listeners.onNavigatePrevious) navigation.onNavigatePrevious.current = listeners.onNavigatePrevious;
        if (listeners.onNavigateNext) navigation.onNavigateNext.current = listeners.onNavigateNext;
        if (listeners.onNavigateAway) navigation.onNavigateAway.current = listeners.onNavigateAway;
    }, [
        navigation
    ]);
    const context = (0, $euxye.useMemo)(()=>({
            getIsBrowserPopstateTriggered: getIsBrowserPopstateTriggered,
            setPreviewPanelNavigation: setPreviewPanelNavigation,
            markPreviewPanelClick: markPreviewPanelClick,
            markIssuePreviewPanelClick: markIssuePreviewPanelClick
        }), [
        getIsBrowserPopstateTriggered,
        setPreviewPanelNavigation,
        markPreviewPanelClick,
        markIssuePreviewPanelClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2s1Bd.JiraPreviewPanelsNavigationContext).Provider, {
        value: context
    }, children);
};
$0a66614eb2c074f8$export$655df495226ad470.displayName = "JiraPreviewPanelsNavigationProvider";

});
parcelRegister("2s1Bd", function(module, exports) {
$parcel$export(module.exports, "defaultContext", () => $15906f65b354ab1c$export$2fba198b5b2e37fa);
$parcel$export(module.exports, "JiraPreviewPanelsNavigationContext", () => $15906f65b354ab1c$export$cd48473e8e80ded6);

var $euxye = parcelRequire("euxye");
const $15906f65b354ab1c$export$2fba198b5b2e37fa = {
    getIsBrowserPopstateTriggered: ()=>false,
    setPreviewPanelNavigation: ()=>null,
    markPreviewPanelClick: ()=>null,
    markIssuePreviewPanelClick: ()=>null
};
const $15906f65b354ab1c$export$cd48473e8e80ded6 = /*#__PURE__*/ (0, $euxye.createContext)($15906f65b354ab1c$export$2fba198b5b2e37fa);

});


parcelRegister("8mbs3", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedConfluencePanelCommunication", () => $17b2ba383ab4ad6b$export$67032c58b985836f);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");
const $17b2ba383ab4ad6b$export$67032c58b985836f = ({ closePreviewPanel: closePreviewPanel })=>{
    // Listen for messages from the legacy embedded Confluence panel to close the active preview panel
    (0, $euxye.useEffect)(()=>{
        const handleMessage = (event)=>{
            /*
			 * CLOSE_PREVIEW_PANEL is sent by the legacy embedded Confluence panel when it is opened
			 * to signal that any active preview panel should be closed.
			 * Search for "CLOSE_PREVIEW_PANEL" in to find where message is sent.

			*/ if (event.data?.type === 'CLOSE_PREVIEW_PANEL') closePreviewPanel();
        };
        if ((0, $i860n.fg)('jira_preview_panel_m_1_rollout')) globalThis.window.addEventListener('message', handleMessage);
        return ()=>{
            globalThis.window.removeEventListener('message', handleMessage);
        };
    }, [
        closePreviewPanel
    ]);
};

});

parcelRegister("4yHnQ", function(module, exports) {
$parcel$export(module.exports, "useInitialPanel", () => $c2a052dd3463d2f3$export$6f25f1d5cc262b02);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $fcq2N = parcelRequire("fcq2N");

var $jM84B = parcelRequire("jM84B");

var $75YsU = parcelRequire("75YsU");

var $btoiF = parcelRequire("btoiF");


var $2ffUK = parcelRequire("2ffUK");

var $dsVXF = parcelRequire("dsVXF");


var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $6XpMv = parcelRequire("6XpMv");
const $c2a052dd3463d2f3$export$6f25f1d5cc262b02 = (issueNavigationRef)=>{
    const [selectedIssue, setSelectedIssue] = (0, $2ffUK.useQueryParam)('selectedIssue');
    const previewPanelEntrypoint = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$a9102b57dfd6b2a3)) || null;
    const onClose = (0, $euxye.useCallback)(()=>{
        setSelectedIssue(undefined);
    }, [
        setSelectedIssue
    ]);
    const onIssueKeyChange = (0, $euxye.useCallback)(({ toIssueKey: toIssueKey })=>{
        toIssueKey && setSelectedIssue(toIssueKey);
    }, [
        setSelectedIssue
    ]);
    const [, { setDetailViewAsModal: setDetailViewAsModal }] = (0, $6XpMv.useIssueContextActions)();
    return (0, $euxye.useMemo)(()=>{
        if ((0, $75YsU.isWorkItemModernizationGatesEnabled)()) return undefined;
        const issueNavigation = issueNavigationRef && (0, $2700E.expVal)('nin_issue_preview_panel_navigation', 'isEnabled', false) ? {
            onNavigateNext: ()=>issueNavigationRef.onNavigateNext.current?.(),
            onNavigatePrevious: ()=>issueNavigationRef.onNavigatePrevious.current?.()
        } : undefined;
        if (selectedIssue && previewPanelEntrypoint && (0, $2700E.expVal)('nin_glance_panel', 'isEnabled', false)) {
            let isModeSwitchEnabled = false;
            let onSwitchToModal = (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)));
            if ((0, $2700E.expVal)('nin_glance_modal', 'isEnabled', false)) {
                isModeSwitchEnabled = true;
                onSwitchToModal = ()=>setDetailViewAsModal();
            }
            const entryPointProps = {
                issueKey: selectedIssue,
                navigation: issueNavigation,
                onClose: onClose,
                isModeSwitchEnabled: isModeSwitchEnabled,
                analyticsSource: (0, $1771eb0e641090af$export$14a8072f422804fd),
                onIssueKeyChange: onIssueKeyChange,
                onSwitchToModal: onSwitchToModal
            };
            return {
                id: `jira-issue/${selectedIssue}`,
                type: 'jira-issue',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
                        name: "issue-preview-panel",
                        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jM84B.IssueViewSkeleton), null),
                        entryPointReference: previewPanelEntrypoint
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
                        entryPointReference: previewPanelEntrypoint,
                        props: entryPointProps
                    }))),
                product: 'jira',
                ...(0, $i860n.fg)('jivtech-1920-back-navigation-gpp') && {
                    onNavigateBack: ()=>{
                        onIssueKeyChange({
                            toIssueKey: selectedIssue
                        });
                    }
                }
            };
        }
    }, [
        issueNavigationRef,
        selectedIssue,
        previewPanelEntrypoint,
        onClose,
        onIssueKeyChange,
        setDetailViewAsModal
    ]);
};

});
parcelRegister("6XpMv", function(module, exports) {
$parcel$export(module.exports, "useChildIssuesLimit", () => $1680fccf0236236f$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $1680fccf0236236f$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $1680fccf0236236f$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $1680fccf0236236f$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $1680fccf0236236f$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $1680fccf0236236f$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $1680fccf0236236f$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $1680fccf0236236f$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $1680fccf0236236f$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $1680fccf0236236f$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $1680fccf0236236f$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $1680fccf0236236f$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $1680fccf0236236f$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $1680fccf0236236f$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $1680fccf0236236f$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useBoardId", () => $1680fccf0236236f$export$b49754504c41149f);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $1680fccf0236236f$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $1680fccf0236236f$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $1680fccf0236236f$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $1680fccf0236236f$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $1680fccf0236236f$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $1680fccf0236236f$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsWorkItemView", () => $1680fccf0236236f$export$e9188a42ca959c7a);
$parcel$export(module.exports, "useIsAiEnabledForIssue", () => $1680fccf0236236f$export$db5174c7538abe4b);
$parcel$export(module.exports, "useIsJiraIssue", () => $1680fccf0236236f$export$cf5fc815f761fb4b);
$parcel$export(module.exports, "useIsJSMIssue", () => $1680fccf0236236f$export$906136dae8d6bc4b);
$parcel$export(module.exports, "useShouldUseRelayIssueComments", () => $1680fccf0236236f$export$48cf678fcbd4605);
$parcel$export(module.exports, "useShouldUseRelayIssueAllActivity", () => $1680fccf0236236f$export$9db14d7d93db3988);
$parcel$export(module.exports, "useShouldUseRelayHistory", () => $1680fccf0236236f$export$887abe8a82ba54f9);

var $e7boj = parcelRequire("e7boj");

var $7tjnB = parcelRequire("7tjnB");

var $f99M0 = parcelRequire("f99M0");

var $8xla3 = parcelRequire("8xla3");


var $2HuOR = parcelRequire("2HuOR");

var $eaLDc = parcelRequire("eaLDc");

var $5rZe5 = parcelRequire("5rZe5");

var $i860n = parcelRequire("i860n");

var $kEYxQ = parcelRequire("kEYxQ");
const $1680fccf0236236f$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $kEYxQ.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $1680fccf0236236f$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $kEYxQ.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $1680fccf0236236f$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $1680fccf0236236f$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $1680fccf0236236f$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $kEYxQ.useIssueContextStoreIsModal)();
    return isModal;
};
const $1680fccf0236236f$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $kEYxQ.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $1680fccf0236236f$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $kEYxQ.useIssueContextStoreIssueId)();
    return issueId;
};
const $1680fccf0236236f$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $kEYxQ.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $1680fccf0236236f$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $kEYxQ.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $1680fccf0236236f$export$f87be37f8e8be65 = ()=>{
    const $ = (0, $e7boj.c)(2);
    const [issueKey] = (0, $kEYxQ.useIssueContextStoreIssueKey)();
    let t0;
    if ($[0] !== issueKey) {
        t0 = issueKey.split("-");
        $[0] = issueKey;
        $[1] = t0;
    } else t0 = $[1];
    return t0[0];
};
const $1680fccf0236236f$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $kEYxQ.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $1680fccf0236236f$export$d6ec1293313f49ac = ()=>{
    const $ = (0, $e7boj.c)(14);
    const [, t0] = (0, $kEYxQ.useIssueContextStoreActions)() || [
        null,
        {}
    ];
    const { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView } = t0;
    let t1;
    if ($[0] !== getBackButtonUrl || $[1] !== getChildIssuesLimit || $[2] !== getIsLoadedWithPage || $[3] !== getIsSpaEnabled || $[4] !== getIssueKey || $[5] !== getMaxTokenLength || $[6] !== mergeIssueContext || $[7] !== resetDetailView || $[8] !== setDetailViewAsModal || $[9] !== setDetailViewAsSidebar || $[10] !== setIssueContext) {
        t1 = {
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        };
        $[0] = getBackButtonUrl;
        $[1] = getChildIssuesLimit;
        $[2] = getIsLoadedWithPage;
        $[3] = getIsSpaEnabled;
        $[4] = getIssueKey;
        $[5] = getMaxTokenLength;
        $[6] = mergeIssueContext;
        $[7] = resetDetailView;
        $[8] = setDetailViewAsModal;
        $[9] = setDetailViewAsSidebar;
        $[10] = setIssueContext;
        $[11] = t1;
    } else t1 = $[11];
    const actions = t1;
    let t2;
    if ($[12] !== actions) {
        t2 = [
            undefined,
            actions
        ];
        $[12] = actions;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};
const $1680fccf0236236f$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $kEYxQ.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $1680fccf0236236f$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $kEYxQ.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $1680fccf0236236f$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $kEYxQ.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $1680fccf0236236f$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $kEYxQ.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $1680fccf0236236f$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $kEYxQ.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $1680fccf0236236f$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $kEYxQ.useIssueContextStoreViewMode)();
    return viewMode;
};
const $1680fccf0236236f$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $kEYxQ.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $1680fccf0236236f$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $kEYxQ.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $1680fccf0236236f$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $kEYxQ.useIssueContextStoreBoardId)();
    return boardId;
};
const $1680fccf0236236f$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $kEYxQ.useIssueContextStoreBoardType)();
    return boardType;
};
const $1680fccf0236236f$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $kEYxQ.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $1680fccf0236236f$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $kEYxQ.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $1680fccf0236236f$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $kEYxQ.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $1680fccf0236236f$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $kEYxQ.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $1680fccf0236236f$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $kEYxQ.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $1680fccf0236236f$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $5rZe5.useLicensedProducts)();
    const licenseStates = (0, $eaLDc.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7tjnB.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $2HuOR.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $1680fccf0236236f$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $1680fccf0236236f$export$aad3917152559b87();
    return analyticsSource === (0, $1771eb0e641090af$export$b19f949fb9713614);
};
const $1680fccf0236236f$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $1680fccf0236236f$export$aad3917152559b87();
    return analyticsSource === (0, $1771eb0e641090af$export$a5132300c5214280);
};
const $1680fccf0236236f$export$e9188a42ca959c7a = ()=>{
    const analyticsSource = $1680fccf0236236f$export$aad3917152559b87();
    return analyticsSource === (0, $1771eb0e641090af$export$36d32bfbadaf29fb);
};
const $1680fccf0236236f$export$db5174c7538abe4b = ()=>{
    const [isAiEnabledForIssue] = (0, $kEYxQ.useIssueContextIsAiEnabledForIssue)();
    return isAiEnabledForIssue;
};
const $1680fccf0236236f$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $1680fccf0236236f$export$22108eca27445997();
    const projectKey = (0, $8xla3.useProjectKey)(issueKey);
    const projectType = (0, $8xla3.useProjectType)(projectKey);
    return [
        (0, $f99M0.SOFTWARE_PROJECT),
        (0, $f99M0.CORE_PROJECT)
    ].some((type)=>type === projectType);
};
const $1680fccf0236236f$export$906136dae8d6bc4b = ()=>{
    const issueKey = $1680fccf0236236f$export$22108eca27445997();
    const projectKey = (0, $8xla3.useProjectKey)(issueKey);
    const projectType = (0, $8xla3.useProjectType)(projectKey);
    return projectType === (0, $f99M0.SERVICE_DESK_PROJECT);
};
const $1680fccf0236236f$export$48cf678fcbd4605 = ()=>{
    const $ = (0, $e7boj.c)(3);
    const isJiraIssue = $1680fccf0236236f$export$cf5fc815f761fb4b();
    const isJSMIssue = $1680fccf0236236f$export$906136dae8d6bc4b();
    let t0;
    if ($[0] !== isJSMIssue || $[1] !== isJiraIssue) {
        t0 = isJiraIssue || isJSMIssue && (0, $i860n.fg)("migrate-to-graphql-from-rest-jsm-comments");
        $[0] = isJSMIssue;
        $[1] = isJiraIssue;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $1680fccf0236236f$export$9db14d7d93db3988 = ()=>{
    const $ = (0, $e7boj.c)(2);
    const isJiraIssue = $1680fccf0236236f$export$cf5fc815f761fb4b();
    let t0;
    if ($[0] !== isJiraIssue) {
        t0 = isJiraIssue || (0, $i860n.fg)("migrate-all-activity-for-jsm");
        $[0] = isJiraIssue;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $1680fccf0236236f$export$887abe8a82ba54f9 = ()=>{
    const $ = (0, $e7boj.c)(3);
    const isJiraIssue = $1680fccf0236236f$export$cf5fc815f761fb4b();
    const isJSMIssue = $1680fccf0236236f$export$906136dae8d6bc4b();
    let t0;
    if ($[0] !== isJSMIssue || $[1] !== isJiraIssue) {
        t0 = isJiraIssue || isJSMIssue && (0, $i860n.fg)("jsm-history-tab-relay-onboarding");
        $[0] = isJSMIssue;
        $[1] = isJiraIssue;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};

});
parcelRegister("eaLDc", function(module, exports) {
$parcel$export(module.exports, "useLicenseStates", () => $47f5f942a4ef6d2f$export$268651a63abe408a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $47f5f942a4ef6d2f$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("kEYxQ", function(module, exports) {
$parcel$export(module.exports, "useIssueContextStore", () => $6713ca000b294162$export$f6e0a3ee03299fbc);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $6713ca000b294162$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $6713ca000b294162$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $6713ca000b294162$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $6713ca000b294162$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $6713ca000b294162$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $6713ca000b294162$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $6713ca000b294162$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $6713ca000b294162$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $6713ca000b294162$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $6713ca000b294162$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $6713ca000b294162$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $6713ca000b294162$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $6713ca000b294162$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $6713ca000b294162$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $6713ca000b294162$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $6713ca000b294162$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $6713ca000b294162$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $6713ca000b294162$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $6713ca000b294162$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $6713ca000b294162$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $6713ca000b294162$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $6713ca000b294162$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $6713ca000b294162$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", () => $6713ca000b294162$export$455ae7fd9d68b157);
$parcel$export(module.exports, "useIssueContextHasRedactions", () => $6713ca000b294162$export$213535cc46c00e50);
$parcel$export(module.exports, "useIssueTypeName", () => $6713ca000b294162$export$ec3ac562fe41f8db);
$parcel$export(module.exports, "useIssueHierarchyLevel", () => $6713ca000b294162$export$c998d5da56eeedf0);
$parcel$export(module.exports, "IssueContextContainer", () => $6713ca000b294162$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $6713ca000b294162$export$965360ae27fcae98);

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $lYqXI = parcelRequire("lYqXI");

var $6E9IL = parcelRequire("6E9IL");

var $fPgZd = parcelRequire("fPgZd");
const $6713ca000b294162$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: '',
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fPgZd.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false,
    isAiEnabledForIssue: false,
    hasRedactions: false,
    issueHierarchyLevel: undefined,
    issueType: undefined
};
const $6713ca000b294162$export$6f57813fe9f31bf9 = (0, $5QDqc.createStore)({
    name: 'issue-context',
    initialState: $6713ca000b294162$export$d4c72bab9d6cc13a,
    actions: $lYqXI.actions
});
const $6713ca000b294162$var$getIssueContext = (state)=>state;
const $6713ca000b294162$var$getIsModal = (state)=>state.isModal;
const $6713ca000b294162$var$getIssueKey = (state)=>state.issueKey;
const $6713ca000b294162$var$getIsArchived = (state)=>state.isArchived;
const $6713ca000b294162$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $6713ca000b294162$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $6713ca000b294162$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $6713ca000b294162$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $6713ca000b294162$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $6713ca000b294162$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $6713ca000b294162$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $6713ca000b294162$var$getIsLoading = (state)=>state.isLoading;
const $6713ca000b294162$var$getViewMode = (state)=>state.viewMode;
const $6713ca000b294162$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $6713ca000b294162$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $6713ca000b294162$var$getBoardId = (state)=>state.boardId;
const $6713ca000b294162$var$getBoardType = (state)=>state.boardType;
const $6713ca000b294162$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $6713ca000b294162$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $6713ca000b294162$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $6713ca000b294162$var$getRapidViewId = (state)=>state.rapidViewId;
const $6713ca000b294162$var$getViewScreenId = (state)=>state.viewScreenId;
const $6713ca000b294162$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $6713ca000b294162$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
const $6713ca000b294162$var$getHasRedactions = (state)=>Boolean(state.hasRedactions);
const $6713ca000b294162$var$getIssueTypeName = (state)=>state.issueType;
const $6713ca000b294162$var$getIssueHierarchyLevel = (state)=>state.issueHierarchyLevel;
const $6713ca000b294162$export$f6e0a3ee03299fbc = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIssueContext
});
const $6713ca000b294162$export$abdbea56d86b4aac = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: (0, $6E9IL.getChildIssuesLimit)
});
const $6713ca000b294162$export$326ff2b963d51c5c = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: (0, $6E9IL.getChildIssuesIssueLimitUrls)
});
const $6713ca000b294162$export$44bcaaabb74e402b = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIssueKey
});
const $6713ca000b294162$export$332dcee0cf9f4e45 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIssueId
});
const $6713ca000b294162$export$c940355b1fc6e1c4 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIsArchived
});
const $6713ca000b294162$export$b9eebaa1da421997 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIsClassifyEditEnabled
});
const $6713ca000b294162$export$daa47fd600e43a32 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIsModal
});
const $6713ca000b294162$export$ba2e9546ab5ba6f = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getViewScreenId
});
const $6713ca000b294162$export$74d38d6c437efc1b = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getAnalyticsSource
});
const $6713ca000b294162$export$2092528ee170d9e7 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getRapidViewMap
});
const $6713ca000b294162$export$57898374e6239a5a = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getMaxTokenLength
});
const $6713ca000b294162$export$ff0264ec4c015dc1 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIsLoadedWithPage
});
const $6713ca000b294162$export$6c8b81f6dca8c23d = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getEstimationStatistic
});
const $6713ca000b294162$export$fe7085456138f0fc = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIsLoading
});
const $6713ca000b294162$export$c339e36468c12443 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getViewMode
});
const $6713ca000b294162$export$ef3bfa2642bb98cd = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getBackButtonUrl
});
const $6713ca000b294162$export$8accd063c74cd455 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIssueNavigatorData
});
const $6713ca000b294162$export$e7edffc2a20027e7 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getBoardId
});
const $6713ca000b294162$export$48aaa3a6bc2085d7 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getBoardType
});
const $6713ca000b294162$export$4a4b96bcf5166327 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIsSpaEnabled
});
const $6713ca000b294162$export$bbd8ba0180545556 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getLoginRedirectUrl
});
const $6713ca000b294162$export$aaa89627762c7d00 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getOnIssueKeyChange
});
const $6713ca000b294162$export$796589b0ec52848a = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getRapidViewId
});
const $6713ca000b294162$export$7e70ee570119a0a7 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIsAiOptInEnabled
});
const $6713ca000b294162$export$455ae7fd9d68b157 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getisAiEnabledForIssue
});
const $6713ca000b294162$export$213535cc46c00e50 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getHasRedactions
});
const $6713ca000b294162$export$ec3ac562fe41f8db = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIssueTypeName
});
const $6713ca000b294162$export$c998d5da56eeedf0 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: $6713ca000b294162$var$getIssueHierarchyLevel
});
const $6713ca000b294162$export$93db6a8f3342dddf = (0, $dB6ay.createContainer)($6713ca000b294162$export$6f57813fe9f31bf9);
const $6713ca000b294162$export$965360ae27fcae98 = (0, $3h1FP.createHook)($6713ca000b294162$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("lYqXI", function(module, exports) {
$parcel$export(module.exports, "actions", () => $2de0e9b9add83d2e$export$e324594224ef24da);

var $dlc9a = parcelRequire("dlc9a");

var $6E9IL = parcelRequire("6E9IL");

var $fPgZd = parcelRequire("fPgZd");
const $2de0e9b9add83d2e$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        const currentState = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || currentState.viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || currentState.viewMode
        });
    };
const $2de0e9b9add83d2e$var$mergeIssueContext = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $2de0e9b9add83d2e$var$getChildIssuesLimit = ()=>({ getState: getState })=>(0, $6E9IL.getChildIssuesLimit)(getState());
const $2de0e9b9add83d2e$var$getMaxTokenLength = ()=>({ getState: getState })=>getState().maxTokenLength;
const $2de0e9b9add83d2e$var$getIsLoadedWithPage = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $2de0e9b9add83d2e$var$getBackButtonUrl = ()=>({ getState: getState })=>getState().backButtonUrl;
const $2de0e9b9add83d2e$var$getIsSpaEnabled = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $2de0e9b9add83d2e$var$getIssueKey = ()=>({ getState: getState })=>getState().issueKey;
const $2de0e9b9add83d2e$var$getIsArchived = ()=>({ getState: getState })=>getState().isArchived;
const $2de0e9b9add83d2e$var$setDetailViewAsModal = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $dlc9a.localStorage).set((0, $dlc9a.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $2de0e9b9add83d2e$var$setDetailViewAsSidebar = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $dlc9a.localStorage).set((0, $dlc9a.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $2de0e9b9add83d2e$var$resetDetailView = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $fPgZd.getViewModeFromLocalStorage)()
        });
    };
/**
 * a special action to "sync" stores
 * @deprecated internal use only
 */ const $2de0e9b9add83d2e$var$internalSyncStore = (issueContext)=>({ setState: setState })=>{
        setState(issueContext);
    };
const $2de0e9b9add83d2e$export$e324594224ef24da = {
    internalSyncStore: $2de0e9b9add83d2e$var$internalSyncStore,
    setIssueContext: $2de0e9b9add83d2e$export$784a03c4b74da53e,
    mergeIssueContext: $2de0e9b9add83d2e$var$mergeIssueContext,
    getChildIssuesLimit: $2de0e9b9add83d2e$var$getChildIssuesLimit,
    getMaxTokenLength: $2de0e9b9add83d2e$var$getMaxTokenLength,
    getIsLoadedWithPage: $2de0e9b9add83d2e$var$getIsLoadedWithPage,
    getBackButtonUrl: $2de0e9b9add83d2e$var$getBackButtonUrl,
    getIsSpaEnabled: $2de0e9b9add83d2e$var$getIsSpaEnabled,
    getIssueKey: $2de0e9b9add83d2e$var$getIssueKey,
    getIsArchived: $2de0e9b9add83d2e$var$getIsArchived,
    setDetailViewAsModal: $2de0e9b9add83d2e$var$setDetailViewAsModal,
    setDetailViewAsSidebar: $2de0e9b9add83d2e$var$setDetailViewAsSidebar,
    resetDetailView: $2de0e9b9add83d2e$var$resetDetailView
};

});
parcelRegister("6E9IL", function(module, exports) {
$parcel$export(module.exports, "getChildIssuesLimit", () => $70c22e9f9bcd27a5$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $70c22e9f9bcd27a5$export$8f43520910e8128c);

var $6CfY5 = parcelRequire("6CfY5");

var $dlc9a = parcelRequire("dlc9a");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $70c22e9f9bcd27a5$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $70c22e9f9bcd27a5$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $6CfY5.default).safeErrorWithoutCustomerData(`${(0, $dlc9a.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $70c22e9f9bcd27a5$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $70c22e9f9bcd27a5$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $70c22e9f9bcd27a5$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $70c22e9f9bcd27a5$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});





parcelRegister("cArDJ", function(module, exports) {
$parcel$export(module.exports, "useInitialPanelNavigationRef", () => $24a015a85cabdb01$export$2beb8874d86dacaa);

var $euxye = parcelRequire("euxye");
const $24a015a85cabdb01$export$2beb8874d86dacaa = ()=>{
    const onNavigateAway = (0, $euxye.useRef)();
    const onNavigateNext = (0, $euxye.useRef)();
    const onNavigatePrevious = (0, $euxye.useRef)();
    return (0, $euxye.useMemo)(()=>({
            onNavigateAway: onNavigateAway,
            onNavigateNext: onNavigateNext,
            onNavigatePrevious: onNavigatePrevious
        }), []);
};

});

parcelRegister("5ppLt", function(module, exports) {
$parcel$export(module.exports, "useInitialPanelWidth", () => $203a30943e5cb29c$export$652844d3b656b976);

var $9x1z1 = parcelRequire("9x1z1");

var $n67Vb = parcelRequire("n67Vb");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $kt86l = parcelRequire("kt86l");
const $203a30943e5cb29c$var$useInitialPanelWidthEnabled = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const data = (0, $n67Vb.useLazyLoadQuery)((0, $9x1z1.default), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-only'
    });
    return data?.jira?.navigationUIState?.previewPanel?.width ?? undefined;
};
const $203a30943e5cb29c$var$useInitialPanelWidthDisabled = ()=>undefined;
const $203a30943e5cb29c$export$652844d3b656b976 = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('nin_glance_panel_initial_width_ssr'), $203a30943e5cb29c$var$useInitialPanelWidthEnabled, $203a30943e5cb29c$var$useInitialPanelWidthDisabled);

});
parcelRegister("9x1z1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ec2e07c17299534$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<19a0ef1f24246acb0ffba3ceaeb98e14>>
 * @relayHash 1fea2e36fac266dc2dc7a6d3d65c9e35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7d98ac95ac4a7c4ae0f21bffb6fe71f329f5c2279ce216c5fd1504050e4982bd
const $2ec2e07c17299534$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "concreteType": "JiraPreviewPanelState",
        "kind": "LinkedField",
        "name": "previewPanel",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInitialPanelWidthQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInitialPanelWidthQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7d98ac95ac4a7c4ae0f21bffb6fe71f329f5c2279ce216c5fd1504050e4982bd",
            "metadata": {},
            "name": "useInitialPanelWidthQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2ec2e07c17299534$var$node.hash = "ba9bf484c92aac9d2100b373e85f3f01";
var $2ec2e07c17299534$export$2e2bcd8739ae039 = $2ec2e07c17299534$var$node;

});



parcelRegister("AmkAi", function(module, exports) {
$parcel$export(module.exports, "default", () => $35baf3f8a25a89e3$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $bb0CA = parcelRequire("bb0CA");

var $kFevg = parcelRequire("kFevg");

var $a0JCq = parcelRequire("a0JCq");

var $lHxCo = parcelRequire("lHxCo");
const $35baf3f8a25a89e3$var$getViewModeWithSidebarDefault = ()=>{
    const viewMode = (0, $kFevg.getViewModeFromLocalStorage)();
    return viewMode === 'DEFAULT' ? 'SIDEBAR' : viewMode;
};
const $35baf3f8a25a89e3$var$IssuePreviewViewModeProvider = /*#__PURE__*/ (0, $euxye.memo)(({ children: children })=>{
    const ssrSafeCall = (0, $bb0CA.useSsrSafeCallback)();
    const [viewMode, setViewMode] = (0, $euxye.useState)(()=>ssrSafeCall($35baf3f8a25a89e3$var$getViewModeWithSidebarDefault, 'SIDEBAR'));
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
        setViewMode($35baf3f8a25a89e3$var$getViewModeWithSidebarDefault());
    }, []);
    const actions = (0, $euxye.useMemo)(()=>({
            setDetailViewAsModal: (willSave = true)=>{
                if (willSave) (0, $kFevg.setViewModeInLocalStorage)('MODAL');
                setViewMode('MODAL');
            },
            setDetailViewAsSidebar: (willSave = true)=>{
                if (willSave) (0, $kFevg.setViewModeInLocalStorage)('SIDEBAR');
                setViewMode('SIDEBAR');
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a0JCq.viewModeActionsContext).Provider, {
        value: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lHxCo.viewModeStateContext).Provider, {
        value: viewMode
    }, children));
});
$35baf3f8a25a89e3$var$IssuePreviewViewModeProvider.displayName = 'IssuePreviewViewModeProvider';
var $35baf3f8a25a89e3$export$2e2bcd8739ae039 = $35baf3f8a25a89e3$var$IssuePreviewViewModeProvider;

});
parcelRegister("bb0CA", function(module, exports) {
$parcel$export(module.exports, "useSsrSafeCallback", () => $cad6a4f12a9acc53$export$dcf7e7853987bee1);

var $euxye = parcelRequire("euxye");

var $b9Jox = parcelRequire("b9Jox");
function $cad6a4f12a9acc53$export$dcf7e7853987bee1() {
    const isClientReady = (0, $b9Jox.useIsClientReady)();
    return (0, $euxye.useCallback)((callback, defaultValue)=>{
        if (!isClientReady) return defaultValue;
        return callback();
    }, [
        isClientReady
    ]);
}

});

parcelRegister("kFevg", function(module, exports) {
$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $a8629e36bceabdd9$export$cae7c4c591dcc261);
$parcel$export(module.exports, "setViewModeInLocalStorage", () => $a8629e36bceabdd9$export$3b0c6f0ee314728a);

var $iXN50 = parcelRequire("iXN50");
// The storage key and provider are private to this package. Reads and writes of the issue
// preview-mode preference go exclusively through getViewModeFromLocalStorage and
// setViewModeInLocalStorage, so the key string lives in exactly one place and cannot drift between
// the React context package and the @jira/issue__context-service that also persists this preference.
const $a8629e36bceabdd9$var$localStorage = (0, $iXN50.createLocalStorageProvider)('jira_issue_view');
const $a8629e36bceabdd9$var$VIEW_MODE_STORAGE_KEY = 'view-mode';
const $a8629e36bceabdd9$export$cae7c4c591dcc261 = ()=>{
    const stored = $a8629e36bceabdd9$var$localStorage.get($a8629e36bceabdd9$var$VIEW_MODE_STORAGE_KEY);
    if (stored === 'MODAL' || stored === 'SIDEBAR') return stored;
    return 'DEFAULT';
};
const $a8629e36bceabdd9$export$3b0c6f0ee314728a = (viewMode)=>{
    // @browser-storage setter
    $a8629e36bceabdd9$var$localStorage.set($a8629e36bceabdd9$var$VIEW_MODE_STORAGE_KEY, viewMode);
};

});

parcelRegister("a0JCq", function(module, exports) {
$parcel$export(module.exports, "viewModeActionsContext", () => $21ce0d32d1b911ea$export$e55d41494678c164);

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");
const $21ce0d32d1b911ea$export$e55d41494678c164 = /*#__PURE__*/ (0, $euxye.createContext)({
    setDetailViewAsModal: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    setDetailViewAsSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});

});

parcelRegister("lHxCo", function(module, exports) {
$parcel$export(module.exports, "viewModeStateContext", () => $5d8527255f2ad6ad$export$1d5a2142c7aa8b62);

var $euxye = parcelRequire("euxye");
const $5d8527255f2ad6ad$export$1d5a2142c7aa8b62 = /*#__PURE__*/ (0, $euxye.createContext)('DEFAULT');

});


parcelRegister("i1x6r", function(module, exports) {
$parcel$export(module.exports, "UserPreferencesContainer", () => $069eebbe1d25013c$export$aa278641ded1adf);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $iGu4q = parcelRequire("iGu4q");

var $aRS3g = parcelRequire("aRS3g");
const $069eebbe1d25013c$export$be74e04eaea4530 = (0, $iGu4q.createSubscriber)((0, $aRS3g.default), {
    displayName: 'UserPreferencesSubscriber'
});
const $069eebbe1d25013c$export$aa278641ded1adf = (0, $dB6ay.createContainer)((0, $aRS3g.default));

});
parcelRegister("aRS3g", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb67df248a399744$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5QDqc = parcelRequire("5QDqc");

var $122vk = parcelRequire("122vk");
const $bb67df248a399744$var$initialState = {
    'issue-view-experiment': {
        data: {
            value: false
        },
        loading: false,
        error: null
    }
};
// @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services-user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services-user-preferences/src/actions/index")>>'.
const $bb67df248a399744$var$ExportedComponent = (0, $5QDqc.createStore)({
    name: 'user-preference',
    initialState: $bb67df248a399744$var$initialState,
    actions: $122vk
});
var $bb67df248a399744$export$2e2bcd8739ae039 = $bb67df248a399744$var$ExportedComponent;

});
parcelRegister("122vk", function(module, exports) {
$parcel$export(module.exports, "fetch", () => (parcelRequire("faHwJ")).default);
$parcel$export(module.exports, "fetchIssueCreate", () => (parcelRequire("39gYL")).default);
$parcel$export(module.exports, "updateExperiment", () => (parcelRequire("lD0B3")).default);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $faHwJ = parcelRequire("faHwJ");

var $39gYL = parcelRequire("39gYL");

var $lD0B3 = parcelRequire("lD0B3");

});
parcelRegister("faHwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $afd1cf471cbbec44$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $2FtuY = parcelRequire("2FtuY");
/**
 * Initiates data retrieval for a user preference, ensuring no duplicate requests are made.
 * Updates the application state with retrieved data or an error, accordingly.
 */ const $afd1cf471cbbec44$var$fetchData = (preferenceKey)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
        setState({
            [preferenceKey]: {
                data: currentState.data,
                loading: true,
                error: null
            }
        });
        try {
            const data = await (0, $2FtuY.default)({
                preferenceKey: preferenceKey
            });
            setState({
                [preferenceKey]: {
                    data: data,
                    loading: false,
                    error: null
                }
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                [preferenceKey]: {
                    data: getState().data,
                    loading: false,
                    error: err
                }
            });
        }
    };
var $afd1cf471cbbec44$export$2e2bcd8739ae039 = $afd1cf471cbbec44$var$fetchData;

});
parcelRegister("2FtuY", function(module, exports) {
$parcel$export(module.exports, "default", () => $255d0c9614f47e5a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5SG0n = parcelRequire("5SG0n");
const $255d0c9614f47e5a$var$getData = async ({ preferenceKey: preferenceKey })=>{
    try {
        const result = await (0, $5SG0n.fetchData)(preferenceKey);
        return {
            value: result
        };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.statusCode === 404) return {
            value: undefined
        };
        throw e;
    }
};
var $255d0c9614f47e5a$export$2e2bcd8739ae039 = $255d0c9614f47e5a$var$getData;

});
parcelRegister("5SG0n", function(module, exports) {
$parcel$export(module.exports, "fetchData", () => $a5ba5e2e04765560$export$8134c072fddab6a5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $a5ba5e2e04765560$export$8134c072fddab6a5 = (key)=>{
    const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
    return (0, $h2wCv.performGetRequest)(requestUrl);
};

});



parcelRegister("39gYL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5eb943fd5ce51261$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $faHwJ = parcelRequire("faHwJ");
const $5eb943fd5ce51261$var$fetchIssueCreate = ()=>(0, $faHwJ.default)('issue-create');
var $5eb943fd5ce51261$export$2e2bcd8739ae039 = $5eb943fd5ce51261$var$fetchIssueCreate;

});

parcelRegister("lD0B3", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6a15cd5087bcc39$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f6a15cd5087bcc39$var$updateExperiment = (experimentKey, value)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
        setState({
            [experimentKey]: {
                data: {
                    value: value
                },
                loading: false,
                error: null
            }
        });
    };
var $f6a15cd5087bcc39$export$2e2bcd8739ae039 = $f6a15cd5087bcc39$var$updateExperiment;

});




parcelRegister("l7ocq", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $ad7df3d8d16ea0d4$export$e926676385687eaf);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $cCE2Z = parcelRequire("cCE2Z");
const $ad7df3d8d16ea0d4$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: id
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: id,
        packageName: "jiraEntry",
        fallback: "page",
        withExperienceTracker: withExperienceTracker
    }, children);
};
$ad7df3d8d16ea0d4$export$e926676385687eaf.displayName = "ErrorBoundary";

});

parcelRegister("9CVb0", function(module, exports) {
$parcel$export(module.exports, "IntlProviders", () => $4805c206d3e94964$export$c9d8cd4516cc55a8);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $978hs = parcelRequire("978hs");

var $8ByCr = parcelRequire("8ByCr");

var $gIMgJ = parcelRequire("gIMgJ");
const $4805c206d3e94964$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8ByCr.IntlProvider), {
        messages: messages,
        locale: (0, $978hs.standardizeLocale)(locale),
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($gIMgJ?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        }
    }, children);
$4805c206d3e94964$export$c9d8cd4516cc55a8.displayName = "IntlProviders";

});
parcelRegister("8ByCr", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $fbab5fb96bc4669e$export$480518999dfc4151);
// eslint-disable-next-line jira/filename-case, jira/restricted/react-component-props

var $euxye = parcelRequire("euxye");

var $5KKyn = parcelRequire("5KKyn");
const $fbab5fb96bc4669e$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5KKyn.default), {
        ...props,
        defaultLocale: props.locale
    }, children);
$fbab5fb96bc4669e$export$480518999dfc4151.displayName = "IntlProvider";

});


parcelRegister("h8EvR", function(module, exports) {
$parcel$export(module.exports, "MetricsContainers", () => $dc896a5abce6d769$export$2d1617bc0040e5d9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $6Tr1c = parcelRequire("6Tr1c");

var $h3795 = parcelRequire("h3795");

var $aZMdt = parcelRequire("aZMdt");

var $9ejh3 = parcelRequire("9ejh3");
const $dc896a5abce6d769$export$2d1617bc0040e5d9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: (0, $h3795.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Tr1c.ExperienceTrackerProvider), null, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "metrics-containers-subproduct-updater",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ejh3.SubProductForAnalyticsUpdater), null)), children));
$dc896a5abce6d769$export$2d1617bc0040e5d9.displayName = "MetricsContainers";

});
parcelRegister("6Tr1c", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerProvider", () => $ad1e06b40f93cef7$export$6f49c95a810d59fa);

var $euxye = parcelRequire("euxye");

var $3QaCr = parcelRequire("3QaCr");

var $6Zzi4 = parcelRequire("6Zzi4");

var $hqy3Z = parcelRequire("hqy3Z");
// eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
const $ad1e06b40f93cef7$var$useUnmount = (callback)=>(0, $euxye.useEffect)(()=>callback, [
        callback
    ]);
const $ad1e06b40f93cef7$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $euxye.useState)(new (0, $6Zzi4.ExperienceTracker)());
    const [cleanupSliSub] = (0, $euxye.useState)(()=>experienceTracker.subscribe((0, $hqy3Z.sliSubscriber)));
    const cleanup = (0, $euxye.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $ad1e06b40f93cef7$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3QaCr.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};
$ad1e06b40f93cef7$export$6f49c95a810d59fa.displayName = "ExperienceTrackerProvider";

});
parcelRegister("hqy3Z", function(module, exports) {
$parcel$export(module.exports, "sliSubscriber", () => $1ed18236d30324f4$export$db0b99fe17114899);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $6Kdw4 = parcelRequire("6Kdw4");

const $1ed18236d30324f4$var$transformApplication = (application)=>{
    switch(application){
        case 0, $hJL79.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $hJL79.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $hJL79.JIRA_CORE:
            return 'jira-core';
        case 0, $hJL79.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $hJL79.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $1ed18236d30324f4$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $d8LhJ.FREE_EDITION:
            return 'jedi';
        case 0, $d8LhJ.STANDARD_EDITION:
            return 'standard';
        case 0, $d8LhJ.PREMIUM_EDITION:
            return 'premium';
        case 0, $d8LhJ.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $1ed18236d30324f4$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $1ed18236d30324f4$var$transformApplication(application),
            edition: $1ed18236d30324f4$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $1ed18236d30324f4$var$reportSli = (experienceDescription)=>{
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $1ed18236d30324f4$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $1ed18236d30324f4$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $a196702bd494009a$export$627ef4c1ed2d7a9a:
            $1ed18236d30324f4$var$reportSli({
                experience: name,
                action: (0, $a196702bd494009a$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $a196702bd494009a$export$b48b3d1872522384:
            $1ed18236d30324f4$var$reportSli({
                experience: name,
                action: (0, $a196702bd494009a$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $a196702bd494009a$export$aeeb00d0845d24d8:
            $1ed18236d30324f4$var$reportSli({
                experience: name,
                action: (0, $a196702bd494009a$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});


parcelRegister("9ejh3", function(module, exports) {
$parcel$export(module.exports, "SubProductForAnalyticsUpdater", () => $0fe2dd15b4c3bec7$export$2f8fd5150032da73);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $41zzZ = parcelRequire("41zzZ");

var $gtB5i = parcelRequire("gtB5i");
const $0fe2dd15b4c3bec7$export$2f8fd5150032da73 = ()=>{
    const subProduct = (0, $gtB5i.useSubProductForAnalytics)();
    (0, $euxye.useEffect)(()=>{
        (0, $41zzZ.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};
$0fe2dd15b4c3bec7$export$2f8fd5150032da73.displayName = "SubProductForAnalyticsUpdater";

});


parcelRegister("ilauN", function(module, exports) {
$parcel$export(module.exports, "NavigationContainers", () => $30b43d4f46643db5$export$36f9ed697cae18ae);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eHS8i = parcelRequire("eHS8i");
const $30b43d4f46643db5$var$ServerContainers = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
$30b43d4f46643db5$var$ServerContainers.displayName = "ServerContainers";
const $30b43d4f46643db5$export$36f9ed697cae18ae = ({ children: children })=>{
    const Containers = !false ? (0, $eHS8i.ClientOnlyNavigationContainers) : $30b43d4f46643db5$var$ServerContainers;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Containers, null, children);
};
$30b43d4f46643db5$export$36f9ed697cae18ae.displayName = "NavigationContainers";

});
parcelRegister("eHS8i", function(module, exports) {
$parcel$export(module.exports, "ClientOnlyNavigationContainers", () => $1052300dbe11110a$export$68d7c1e44acfd599);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dtBIL = parcelRequire("dtBIL");
const $1052300dbe11110a$export$68d7c1e44acfd599 = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dtBIL.Provider), null, children);
    return null;
};
$1052300dbe11110a$export$68d7c1e44acfd599.displayName = "ClientOnlyNavigationContainers";

});
parcelRegister("dtBIL", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $b0c45abcea464343$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $b0c45abcea464343$export$b3bffd4bb7da6b8f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $l28YB = parcelRequire("l28YB");

var $7UpaU = parcelRequire("7UpaU");

var $6WtXO = parcelRequire("6WtXO");
const $b0c45abcea464343$var$Context = (0, $7UpaU.default)('ItemManagers');
const $b0c45abcea464343$export$275138de3066e8b3 = 30000;
class $b0c45abcea464343$export$2881499e37b75b9a extends (0, $euxye.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b0c45abcea464343$var$Context.Provider, {
            value: this.manager
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            managers: {}
        }, this.getManager = (managerKey)=>{
            const { managers: managers } = this.state;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const manager = managers[managerKey];
            if (manager) return manager;
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject)=>{
                const message = `Timeout. "${(0, $6WtXO.fromManagerKey)(managerKey)}" wasn't registered after ${$b0c45abcea464343$export$275138de3066e8b3}ms`;
                const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $b0c45abcea464343$export$275138de3066e8b3);
                const { pendingManagers: pendingManagers } = this;
                pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                pendingManagers[managerKey].push((methods)=>{
                    clearTimeout(rejectTimeoutId);
                    resolve(methods);
                });
            });
        }, this.registerManager = (managerKey, methods)=>{
            this.setState((previousState)=>{
                if (methods == null) return {
                    managers: (0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(previousState.managers, managerKey)
                };
                const managerResolvers = this.pendingManagers[managerKey];
                if (managerResolvers && managerResolvers.length) {
                    managerResolvers.forEach((resolve)=>resolve(methods));
                    managerResolvers.length = 0;
                }
                return {
                    managers: {
                        ...previousState.managers,
                        [managerKey]: Promise.resolve(methods)
                    }
                };
            });
        }, this.pendingManagers = {}, this.manager = {
            getManager: this.getManager,
            registerManager: this.registerManager
        };
    }
}
$b0c45abcea464343$export$2881499e37b75b9a.displayName = "Provider";
const $b0c45abcea464343$export$b3bffd4bb7da6b8f = $b0c45abcea464343$var$Context.Consumer;

});
parcelRegister("7UpaU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b4b828f48922148$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $9b4b828f48922148$var$createSafeContext = (name)=>{
    const contextObjName = name || '';
    const defaultGetter = ()=>{
        throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
    };
    const Context = /*#__PURE__*/ (0, $euxye.createContext)(defaultGetter);
    const ContextConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Context.Consumer, null, (getValue)=>{
            const value = getValue();
            return props.children(value);
        });
    const ContextProvider = ({ value: value, children: children })=>{
        const getValue = ()=>value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Context.Provider, {
            value: getValue
        }, children);
    };
    ContextProvider.displayName = `${contextObjName}SafeProvider`;
    ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
    // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
    return {
        Provider: ContextProvider,
        Consumer: ContextConsumer
    };
};
var $9b4b828f48922148$export$2e2bcd8739ae039 = $9b4b828f48922148$var$createSafeContext;

});

parcelRegister("6WtXO", function(module, exports) {
$parcel$export(module.exports, "fromManagerKey", () => $4a6d582ff21996df$export$fef172a673b3ef47);
/* eslint-disable jira/filename-case */ const $4a6d582ff21996df$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
const $4a6d582ff21996df$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);

});




parcelRegister("jz0sK", function(module, exports) {
$parcel$export(module.exports, "PageConfigContainers", () => $b842d0c3d898f148$export$9c661932489b4130);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eg2ws = parcelRequire("eg2ws");

var $6bEm8 = parcelRequire("6bEm8");

var $f2wVS = parcelRequire("f2wVS");

var $ea1FV = parcelRequire("ea1FV");

var $hbXn4 = parcelRequire("hbXn4");
const $b842d0c3d898f148$var$useRouterRoute = (0, $f2wVS.createRouterSelector)((state)=>state.route);
const $b842d0c3d898f148$export$9c661932489b4130 = ({ children: children })=>{
    const { PageConfigContainerOverride: PageConfigContainerOverride } = $b842d0c3d898f148$var$useRouterRoute();
    if (PageConfigContainerOverride !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(PageConfigContainerOverride, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eg2ws.ThemeContainer), {
        isGlobal: true,
        getMeta: (0, $6bEm8.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ea1FV.DocumentTitleContainer), {
        titleSuffix: (0, $hbXn4.ripTitleTemplateFromMeta)((0, $6bEm8.default))
    }, children));
};
$b842d0c3d898f148$export$9c661932489b4130.displayName = "PageConfigContainers";

});
parcelRegister("eg2ws", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $ac2c5b716a1024a4$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $ac2c5b716a1024a4$export$11eb671888ed6e7d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

var $LrCL6 = parcelRequire("LrCL6");
const $ac2c5b716a1024a4$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $ac2c5b716a1024a4$var$Store = (0, $5QDqc.createStore)({
    name: 'theme',
    initialState: $ac2c5b716a1024a4$var$initialState,
    actions: $LrCL6
});
const $ac2c5b716a1024a4$export$74e6aa5aeff5e82e = (0, $iGu4q.createSubscriber)($ac2c5b716a1024a4$var$Store);
const $ac2c5b716a1024a4$export$93d4e7f90805808f = (0, $3h1FP.createHook)($ac2c5b716a1024a4$var$Store);
const $ac2c5b716a1024a4$export$11eb671888ed6e7d = (0, $dB6ay.createContainer)($ac2c5b716a1024a4$var$Store, {
    onInit: $LrCL6.bootstrap
});

});
parcelRegister("LrCL6", function(module, exports) {
$parcel$export(module.exports, "bootstrap", () => $b53f12bad2003500$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $b53f12bad2003500$export$722fbec263ad908a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $b53f12bad2003500$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== '#FFFFFF' || ajsHighlightColor !== '#0052CC');
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || "var(--ds-background-inverse-subtle, #00000029)",
            highlightColor: ajsHighlightColor || "var(--ds-text-brand, #1868DB)"
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $b53f12bad2003500$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("ea1FV", function(module, exports) {
$parcel$export(module.exports, "useDocumentTitleActions", () => $8daae4c1af226692$export$57c0fda036e12d67);
$parcel$export(module.exports, "useDocumentTitle", () => $8daae4c1af226692$export$4b208edda918084f);
$parcel$export(module.exports, "DocumentTitleContainer", () => $8daae4c1af226692$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleHelper", () => $8daae4c1af226692$export$573bf8d2ae7d60dc);

var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

var $7bdGA = parcelRequire("7bdGA");
const $8daae4c1af226692$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $8daae4c1af226692$var$Store = (0, $5QDqc.createStore)({
    name: 'document-title',
    initialState: $8daae4c1af226692$var$initialState,
    actions: $7bdGA.actions
});
const $8daae4c1af226692$export$57c0fda036e12d67 = (0, $3h1FP.createActionsHook)($8daae4c1af226692$var$Store);
const $8daae4c1af226692$export$4b208edda918084f = (0, $3h1FP.createHook)($8daae4c1af226692$var$Store);
const $8daae4c1af226692$export$1aad43993172f16f = (0, $dB6ay.createContainer)($8daae4c1af226692$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $8daae4c1af226692$export$b88d5abf3e0bec8c = (0, $iGu4q.createSubscriber)($8daae4c1af226692$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
const $8daae4c1af226692$export$573bf8d2ae7d60dc = ({ title: title })=>{
    const { addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle, updateTitle: updateTitle } = $8daae4c1af226692$export$57c0fda036e12d67();
    const identifierRef = (0, $euxye.useRef)(Symbol(title));
    const onUpdate = (0, $euxye.useCallback)(()=>{
        updateTitle(title, identifierRef.current);
    }, [
        updateTitle,
        title
    ]);
    (0, $euxye.useEffect)(()=>{
        const titleRef = identifierRef.current;
        addDocumentTitle(titleRef, title);
        return ()=>{
            removeDocumentTitle(titleRef);
            onUpdate();
        };
    }, [
        addDocumentTitle,
        onUpdate,
        removeDocumentTitle,
        title
    ]);
    (0, $euxye.useEffect)(()=>{
        onUpdate();
    }, [
        onUpdate
    ]);
    return null;
};
$8daae4c1af226692$export$573bf8d2ae7d60dc.displayName = "DocumentTitleHelper";

});
parcelRegister("7bdGA", function(module, exports) {
$parcel$export(module.exports, "actions", () => $650062ac723d0f65$export$e324594224ef24da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $2GCCO = parcelRequire("2GCCO");

var $dJF1L = parcelRequire("dJF1L");

var $3L9cz = parcelRequire("3L9cz");

var $6frz2 = parcelRequire("6frz2");
const $650062ac723d0f65$export$e324594224ef24da = {
    setTitle: $2GCCO.setTitle,
    addDocumentTitle: $dJF1L.addDocumentTitle,
    removeDocumentTitle: $3L9cz.removeDocumentTitle,
    updateTitle: $6frz2.updateTitle
};

});
parcelRegister("2GCCO", function(module, exports) {
$parcel$export(module.exports, "setTitle", () => $d913ec0f5a929bc4$export$420a7f2fd9cad6f6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $hbXn4 = parcelRequire("hbXn4");
const $d913ec0f5a929bc4$export$420a7f2fd9cad6f6 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $hbXn4.createTitleFromTemplate)(title, titleTemplate);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("hbXn4", function(module, exports) {
$parcel$export(module.exports, "createTitleFromTemplate", () => $62d055953ba4383e$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $62d055953ba4383e$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $62d055953ba4383e$export$7f8be70a0bed1bae);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $62d055953ba4383e$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $62d055953ba4383e$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $62d055953ba4383e$export$7f8be70a0bed1bae = (symbol, contextArray)=>{
    const lastDocumentTitle = contextArray[contextArray.length - 1];
    if (typeof lastDocumentTitle === 'object' && lastDocumentTitle.symbol === symbol) return true;
    return false;
};

});


parcelRegister("dJF1L", function(module, exports) {
$parcel$export(module.exports, "addDocumentTitle", () => $601b03b277d8f199$export$a0c188c0ea474bb8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $601b03b277d8f199$export$a0c188c0ea474bb8 = (symbol, title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        title ? contextArray.push({
            title: title,
            symbol: symbol
        }) : contextArray.push(symbol);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("3L9cz", function(module, exports) {
$parcel$export(module.exports, "removeDocumentTitle", () => $d8fab201a770c1a2$export$e844009b77f80a72);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d8fab201a770c1a2$export$e844009b77f80a72 = (titleSymbol)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: contextArray.filter((titleContext)=>typeof titleContext === 'object' && titleContext.symbol !== titleSymbol)
        });
    };

});

parcelRegister("6frz2", function(module, exports) {
$parcel$export(module.exports, "updateTitle", () => $1f708d515380e665$export$bf6f7165e46e2479);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $hbXn4 = parcelRequire("hbXn4");
const $1f708d515380e665$var$generateTitle = (title, titleSuffix)=>{
    const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
    const newTitle = (0, $hbXn4.createTitleFromTemplate)(title, titleTemplate);
    return newTitle;
};
const $1f708d515380e665$export$bf6f7165e46e2479 = (title, context)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const contextItem = state.contextArray.find((item)=>{
            if (typeof item === 'object') return item.symbol === context;
            return false;
        });
        // If there is no contextItem, it means that the component has been unmounted
        // And we'll just use the last used title from the contextArray
        if (!contextItem && state.contextArray.length) {
            const lastContextItem = state.contextArray[state.contextArray.length - 1];
            let newTitle = '';
            // This will always be an object but we have to check it to make TS happy
            if (typeof lastContextItem === 'object') newTitle = $1f708d515380e665$var$generateTitle(lastContextItem.title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
            return;
        }
        if ((0, $hbXn4.checkDocumentTitle)(context, state.contextArray)) {
            const newTitle = $1f708d515380e665$var$generateTitle(title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
        }
    };

});




parcelRegister("oeNBe", function(module, exports) {
$parcel$export(module.exports, "UiManagers", () => $40c75fb7bb390da3$export$41286c339a88ca24);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1nf63 = parcelRequire("1nf63");

var $1qwil = parcelRequire("1qwil");

var $cCWbm = parcelRequire("cCWbm");
const $40c75fb7bb390da3$var$Filler = ()=>null;
const $40c75fb7bb390da3$var$Nest = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
$40c75fb7bb390da3$var$Nest.displayName = "Nest";
const $40c75fb7bb390da3$var$ClientManagerServerVersion = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($40c75fb7bb390da3$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($40c75fb7bb390da3$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($40c75fb7bb390da3$var$Filler, {
        for: "SpotLightMaanger"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($40c75fb7bb390da3$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($40c75fb7bb390da3$var$Nest, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($40c75fb7bb390da3$var$Filler, {
        for: "ModalContextProvider"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($40c75fb7bb390da3$var$Filler, {
        for: "FlagsProvider"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($40c75fb7bb390da3$var$Filler, {
        for: "CrossFlowProvider"
    }));
$40c75fb7bb390da3$var$ClientManagerServerVersion.displayName = "ClientManagerServerVersion";
const $40c75fb7bb390da3$export$41286c339a88ca24 = ({ children: children })=>{
    const ClientUiManagers = !false ? (0, $cCWbm.ClientUiManagers) : $40c75fb7bb390da3$var$ClientManagerServerVersion;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1qwil.LayoutManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1nf63.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ClientUiManagers, null, children)));
};
$40c75fb7bb390da3$export$41286c339a88ca24.displayName = "UiManagers";

});
parcelRegister("1nf63", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbManager", () => $6204c3fb23910b2c$export$cd5073909dd92c28);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kbjx7 = parcelRequire("kbjx7");
const $6204c3fb23910b2c$export$cd5073909dd92c28 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kbjx7.BreadcrumbContainer), null, children);
$6204c3fb23910b2c$export$cd5073909dd92c28.displayName = "BreadcrumbManager";

});
parcelRegister("kbjx7", function(module, exports) {
$parcel$export(module.exports, "useBreadcrumbs", () => $3af23f41fec61303$export$8cefe241bd876ca0);
$parcel$export(module.exports, "BreadcrumbActions", () => $3af23f41fec61303$export$9862c338ec0a6884);
$parcel$export(module.exports, "BreadcrumbContainer", () => $3af23f41fec61303$export$c7432936d9c50db7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");
const $3af23f41fec61303$var$initialState = {
    trail: []
};
const $3af23f41fec61303$export$e324594224ef24da = {
    pushBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
            const { trail: trail } = getState();
            if (breadcrumb.id && !trail.some((item)=>item.id === breadcrumb.id)) setState({
                trail: [
                    ...trail,
                    breadcrumb
                ]
            });
        },
    popBreadcrumb: ()=>({ setState: setState, getState: getState })=>{
            setState({
                trail: getState().trail.slice(0, -1)
            });
        },
    updateBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
            const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
            setState({
                trail: newTrail
            });
        }
};
const $3af23f41fec61303$var$Store = (0, $5QDqc.createStore)({
    initialState: $3af23f41fec61303$var$initialState,
    actions: $3af23f41fec61303$export$e324594224ef24da,
    name: 'BreadcrumbSweetState'
});
const $3af23f41fec61303$var$_BreadcrumbSubscriber = (0, $iGu4q.createSubscriber)($3af23f41fec61303$var$Store);
const $3af23f41fec61303$export$8cefe241bd876ca0 = (0, $3h1FP.createHook)($3af23f41fec61303$var$Store);
const $3af23f41fec61303$export$9862c338ec0a6884 = (0, $iGu4q.createSubscriber)($3af23f41fec61303$var$Store, {
    selector: null
});
const $3af23f41fec61303$export$c7432936d9c50db7 = (0, $dB6ay.createContainer)($3af23f41fec61303$var$Store);

});


parcelRegister("1qwil", function(module, exports) {
$parcel$export(module.exports, "LayoutManager", () => $8d6ee5a3899956d3$export$4a04ad01c410b415);

var $2tave = parcelRequire("2tave");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $i4Cir = parcelRequire("i4Cir");

var $f2wVS = parcelRequire("f2wVS");
var $k6ufm = parcelRequire("k6ufm");

var $dB6ay = parcelRequire("dB6ay");

var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");

var $fXLAN = parcelRequire("fXLAN");

var $cvA2R = parcelRequire("cvA2R");

var $a8EUd = parcelRequire("a8EUd");

var $4bMsU = parcelRequire("4bMsU");

var $7Sa0x = parcelRequire("7Sa0x");

var $9O6SX = parcelRequire("9O6SX");
const $8d6ee5a3899956d3$var$LayoutContainer = (0, $dB6ay.createContainer)((0, $7Sa0x.layoutStore), {
    displayName: 'JiraLayoutContainer',
    onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
            dispatch((0, $4bMsU.actions).setIsChromeless(isChromeless));
            dispatch((0, $4bMsU.actions).setLeftSidebarState(leftSidebar));
            dispatch((0, $4bMsU.actions).setRightSidebarState(rightSidebar));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
            dispatch((0, $4bMsU.actions).setIsChromeless(isChromeless));
        }
});
const $8d6ee5a3899956d3$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
    stackState: []
};
const $8d6ee5a3899956d3$export$c88b74884f5222ba = (0, $f2wVS.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
const $8d6ee5a3899956d3$export$4a04ad01c410b415 = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('navx-global-side-nav'), $8d6ee5a3899956d3$var$LayoutManagerGSN, $8d6ee5a3899956d3$var$LayoutManagerNav4);
function $8d6ee5a3899956d3$var$LayoutManagerNewContent({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth }) {
    const isChromeless = $8d6ee5a3899956d3$export$c88b74884f5222ba();
    const leftSidebar = (0, $euxye.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed ?? false,
            width: leftSidebarWidth ?? (0, $7Sa0x.DEFAULT_LEFT_SIDEBAR_WIDTH),
            isFlyoutOpen: false,
            hasUserPreference: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d6ee5a3899956d3$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $8d6ee5a3899956d3$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
}
$8d6ee5a3899956d3$var$LayoutManagerNewContent.displayName = "LayoutManagerNewContent";
function $8d6ee5a3899956d3$var$LayoutManagerGSN({ children: children }) {
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const isChromeless = $8d6ee5a3899956d3$export$c88b74884f5222ba();
    // Both scenarios should use the default LayoutContainer
    if (isAnonymous || isChromeless) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d6ee5a3899956d3$var$LayoutManagerNewContent, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4-ignore.gsn-layout-manager"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d6ee5a3899956d3$var$LayoutManagerNavPlat, null, children));
}
$8d6ee5a3899956d3$var$LayoutManagerGSN.displayName = "LayoutManagerGSN";
function $8d6ee5a3899956d3$var$LayoutManagerNavPlat({ children: children }) {
    const { data: data } = (0, $fXLAN.useSuspenseResource)((0, $9O6SX.navPlatformRootStateResource));
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d6ee5a3899956d3$var$LayoutManagerNavPlatWithQuery, {
        queryReference: data
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d6ee5a3899956d3$var$LayoutManagerNewContent, null, children);
}
$8d6ee5a3899956d3$var$LayoutManagerNavPlat.displayName = "LayoutManagerNavPlat";
function $8d6ee5a3899956d3$var$LayoutManagerNavPlatWithQuery({ children: children, queryReference: queryReference }) {
    const data = (0, $n67Vb.usePreloadedQuery)((0, $2tave.default), queryReference);
    let defaultCollapsed = false;
    let defaultWidth;
    if (data?.navPlatSidebarData?.properties?.nodes?.length) data?.navPlatSidebarData.properties.nodes.forEach((item)=>{
        if (item?.key === 'defaultCollapsed') defaultCollapsed = item?.value === 'true';
        else if (item?.key === 'defaultWidth') defaultWidth = item?.value === '' ? undefined : Number(item?.value);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d6ee5a3899956d3$var$LayoutManagerNewContent, {
        isLeftSidebarCollapsed: defaultCollapsed,
        leftSidebarWidth: defaultWidth
    }, children);
}
$8d6ee5a3899956d3$var$LayoutManagerNavPlatWithQuery.displayName = "LayoutManagerNavPlatWithQuery";
function $8d6ee5a3899956d3$var$LayoutManagerNav4({ children: children }) {
    const { data: data } = (0, $k6ufm.useResource)((0, $i4Cir.navigationUiStateResource));
    const isChromeless = $8d6ee5a3899956d3$export$c88b74884f5222ba();
    const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
    const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $7Sa0x.DEFAULT_LEFT_SIDEBAR_WIDTH);
    const leftSidebar = (0, $euxye.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed,
            width: leftSidebarWidth,
            isFlyoutOpen: false,
            hasUserPreference: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d6ee5a3899956d3$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $8d6ee5a3899956d3$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
}
$8d6ee5a3899956d3$var$LayoutManagerNav4.displayName = "LayoutManagerNav4";

});
parcelRegister("fXLAN", function(module, exports) {
$parcel$export(module.exports, "useSuspenseResource", () => $6b70002939ed793e$export$2ce6acaf161df9d3);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ldgHZ = parcelRequire("ldgHZ");

var $k6ufm = parcelRequire("k6ufm");
const $6b70002939ed793e$var$useSuspenseResourceConfigurable = ({ resource: resource, routerContext: routerContext, throwErrors: throwErrors })=>{
    const state = (0, $k6ufm.useResourceBase)(resource, {
        routerContext: routerContext
    });
    // The extra state.error == null check is required because in SSR timeouts are represented with loading=true and error=<something>
    if (state.loading && ((0, $ldgHZ.isStreamingEnabled)() ? state.error == null : true)) {
        if (state.promise == null) throw new Error(`Failed to throw promise for suspense in loading state of resource "${resource.type}" because promise is not defined`);
        throw state.promise;
    }
    if (state.error != null && throwErrors) throw state.error;
    // Throw if we are in the "default" state (resource wasn't defined on the route or was cleared)
    if (state.promise == null && state.error == null) {
        // eslint-disable-next-line jira/jira-ssr/no-server-variable
        if (false) // We don't want to lazily kick off fetching mid-way through SSR
        throw new Error([
            `Tried to access resource "${resource.type}" in SSR, which has not started loading.`,
            "Ensure that this resource is declared in the route's `resources` property."
        ].join('\n'));
        else {
            // This can occur if either:
            // - The resource wasn't defined on the route (not optimal) or was cleared
            // - When transitioning between routes and this is called just before state is set, in rare conditions
            // 		-> https://atlassian-2y.sentry.io/issues/7083415435/events/e254cb24a80742b4b063e8bb001f7eb5/?project=5988809
            // So we kick off fetching here -> throw a resolved promise -> re-render suspends on the "real" loading promise
            state.refresh();
            throw Promise.resolve();
        }
    }
    return (0, $euxye.useMemo)(()=>{
        const { data: data, error: error, key: key, expiresAt: expiresAt, accessedAt: accessedAt, update: update, refresh: refresh } = state;
        const result = {
            key: key,
            data: data,
            expiresAt: expiresAt,
            accessedAt: accessedAt,
            update: update,
            refresh: refresh
        };
        if (!throwErrors) result.error = error;
        return result;
    }, [
        state,
        throwErrors
    ]);
};
const $6b70002939ed793e$export$2ce6acaf161df9d3 = (resource, { routerContext: routerContext } = {})=>$6b70002939ed793e$var$useSuspenseResourceConfigurable({
        resource: resource,
        routerContext: routerContext,
        throwErrors: true
    });
const $6b70002939ed793e$export$80651c4d7b4389c8 = (resource, { routerContext: routerContext } = {})=>$6b70002939ed793e$var$useSuspenseResourceConfigurable({
        resource: resource,
        routerContext: routerContext,
        throwErrors: false
    });

});

parcelRegister("cvA2R", function(module, exports) {
$parcel$export(module.exports, "useIsAnonymous", () => $b4da11aa5fafa77c$export$bf7b5d502f6d6d3b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $b4da11aa5fafa77c$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});


parcelRegister("cCWbm", function(module, exports) {
$parcel$export(module.exports, "ClientUiManagers", () => $d8c6c124c6148d5e$export$d1db6ae5bf84e489);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5u9Wt = parcelRequire("5u9Wt");

var $jyUW8 = parcelRequire("jyUW8");

var $6xxcW = parcelRequire("6xxcW");

var $5WjEJ = parcelRequire("5WjEJ");

var $ip3FN = parcelRequire("ip3FN");

var $iQPOZ = parcelRequire("iQPOZ");

var $72IzE = parcelRequire("72IzE");

var $kWzqm = parcelRequire("kWzqm");
const $d8c6c124c6148d5e$export$d1db6ae5bf84e489 = ({ children: children })=>{
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5WjEJ.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kWzqm.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5u9Wt.ProjectCreateDrawerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ip3FN.FavoriteChangeProvider), {
        onShowFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jyUW8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6xxcW.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72IzE.ModalContextProvider), null, children)))))));
};
$d8c6c124c6148d5e$export$d1db6ae5bf84e489.displayName = "ClientUiManagers";

});
parcelRegister("5u9Wt", function(module, exports) {
$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $3f888852c69c02f4$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $3f888852c69c02f4$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $3f888852c69c02f4$export$8172ff4ed0f75a1e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $lDKXD = parcelRequire("lDKXD");

var $5QcPS = parcelRequire("5QcPS");

var $55BnK = parcelRequire("55BnK");

var $aBk88 = parcelRequire("aBk88");
// oxlint-disable-next-line typescript/consistent-type-assertions
const $3f888852c69c02f4$var$Context = /*#__PURE__*/ (0, $euxye.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        closeAndRun: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        setOnCloseCallback: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        setOnCreatedCallback: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        clearOnCreatedCallback: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    }
});
class $3f888852c69c02f4$export$839a70d8fbc9d356 extends (0, $euxye.Component) {
    // Resets the drawer back to its closed/default state. Shared by `close` and
    // `closeAndRun` so the reset behaviour cannot drift between them.
    resetDrawerState() {
        this.setState({
            isOpen: false,
            isOnboarding: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined
        });
    }
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId, isOnboarding: isOnboarding } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3f888852c69c02f4$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    isOnboarding: isOnboarding,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    closeAndRun: this.closeAndRun,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback,
                    setOnCreatedCallback: this.setOnCreatedCallback,
                    clearOnCreatedCallback: this.clearOnCreatedCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            isOnboarding: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            onCreatedCallback: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
        }, this.onSuccess = (project)=>{
            if (project) {
                if (project.requiresReload && typeof window !== 'undefined') window.location.href = project.returnUrl;
                else this.props.setLocation(project.returnUrl);
                this.close(true);
                this.state.onCreatedCallback(project);
            } else this.close(false);
        }, // Callback that is called once when the drawer is closed.
        //
        // Returns the PREVIOUSLY registered callback so the caller can restore it
        // on unmount and avoid clobbering a host's registration with `noop`.
        // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.setOnCloseCallback = (callback)=>{
            const previousCallback = this.state.onCloseCallback;
            this.setState({
                onCloseCallback: callback
            });
            return previousCallback;
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
            });
        }, // Callback that is called once when a project is successfully created.
        // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.setOnCreatedCallback = (callback)=>{
            this.setState({
                onCreatedCallback: callback
            });
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.clearOnCreatedCallback = ()=>{
            this.setState({
                onCreatedCallback: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
            });
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.resetDrawerState();
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        }, // Closes the drawer and runs `callback` exactly once for THIS close. The
        // callback is supplied by value (not read from state), so it always runs —
        // no reliance on `setState` having committed. The persisted
        // `onCloseCallback` is intentionally NOT invoked here.
        // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.closeAndRun = (callback)=>{
            this.resetDrawerState();
            callback();
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming, jira/react-no-unneeded-arrow-function-properties
        this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isOnboarding: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        }, this.onCreateStarted = (projectKey, templateKey)=>{
            if ((0, $5QcPS.getIsJsmBlankProjectTemplate)(templateKey)) (0, $lDKXD.LazyComponent).preload();
            (0, $aBk88.clearResourcesAssociatedWithProjectKey)(projectKey);
        };
    }
}
$3f888852c69c02f4$export$839a70d8fbc9d356.displayName = "ProviderInternal";
const $3f888852c69c02f4$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $55BnK.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3f888852c69c02f4$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
$3f888852c69c02f4$export$9a1c5dbd93c42bca.displayName = "ProjectCreateDrawerProvider";
const $3f888852c69c02f4$export$9a8662cd60931de1 = $3f888852c69c02f4$var$Context.Consumer;
const $3f888852c69c02f4$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $euxye.useContext)($3f888852c69c02f4$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("lDKXD", function(module, exports) {
$parcel$export(module.exports, "LazyComponent", () => $08b9d6d4f58c05a6$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $08b9d6d4f58c05a6$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $08b9d6d4f58c05a6$export$ff317c5d87147a19);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $bOtBg = parcelRequire("bOtBg");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $08b9d6d4f58c05a6$export$31f1740ae531af94 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("9v6J3")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ProjectBuilder.tsx"
});
const $08b9d6d4f58c05a6$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bOtBg.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($08b9d6d4f58c05a6$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
$08b9d6d4f58c05a6$export$54a4eade9eae9473.displayName = "AsyncProjectBuilderDrawer";
const $08b9d6d4f58c05a6$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("9v6J3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("5qC72"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("eAoL3"),
    $4cvLQ("15ZAZ"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("37mlH")
]).then(()=>parcelRequire('eSC9J'));

});


parcelRegister("5QcPS", function(module, exports) {
$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "AGENTIC_DEVELOPMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$878321e40126163f);
$parcel$export(module.exports, "AGENTIC_DEVELOPMENT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$41800d9ff2b74ac5);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $8b0c6878c1d6b82c$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_ASSET_MANAGEMENT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$3f04ba85e6c31cc);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $8b0c6878c1d6b82c$export$df7d1440e0a80c03);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $8b0c6878c1d6b82c$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $8b0c6878c1d6b82c$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $8b0c6878c1d6b82c$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $8b0c6878c1d6b82c$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$b0928b02ffab3875);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$f3c5f5a180797f04);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$2bc7db2da3df8313);
$parcel$export(module.exports, "DEVELOPMENT_REQUESTS_KEY", () => $8b0c6878c1d6b82c$export$7757b7af2cfeaf40);
$parcel$export(module.exports, "DEVELOPMENT_REQUESTS_COMPANY_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$39dcce6358d45bde);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $8b0c6878c1d6b82c$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$7c567eb725bd36f);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_BLANK_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$b0eec2c6558182ca);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_ROADMAP_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$f9776303073903dd);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PRIORITIZE_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$b7c4ca557ac2074e);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_BLUEPRINTS_KEY", () => $8b0c6878c1d6b82c$export$c08af08a98ed8545);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PORTFOLIO_ROADMAP_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$3e0c026ef9261553);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_OPPORTUNITY_SOLUTION_TEAM_MANAGED_KEY", () => $8b0c6878c1d6b82c$export$17a44d941c0ac63a);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_VIEW_PREVIEW_RICE_KEY", () => $8b0c6878c1d6b82c$export$d46f8c4a94e948e2);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_VIEW_PREVIEW_MOSCOW_KEY", () => $8b0c6878c1d6b82c$export$1c9b046bccbb3d41);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_VIEW_PREVIEW_LEADERSHIP_KEY", () => $8b0c6878c1d6b82c$export$83b5ff1274a6f8da);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_VIEW_PREVIEW_TRIAGE_KEY", () => $8b0c6878c1d6b82c$export$3c9c3ddf0b189f2f);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_VIEW_PREVIEW_DELIVERY_KEY", () => $8b0c6878c1d6b82c$export$3877b9ec8885bc0d);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_VIEW_PREVIEW_PLANNING_KEY", () => $8b0c6878c1d6b82c$export$fbb20cc5f3b9e76e);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_VIEW_PREVIEW_CROSS_TEAM_KEY", () => $8b0c6878c1d6b82c$export$734e6243a1bbc154);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_VIEW_PREVIEW_INTAKE_KEY", () => $8b0c6878c1d6b82c$export$67277c93482a2114);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $8b0c6878c1d6b82c$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $8b0c6878c1d6b82c$export$a062badd78c9993);
/* eslint-disable jira/filename-case */ // Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $8b0c6878c1d6b82c$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $8b0c6878c1d6b82c$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $8b0c6878c1d6b82c$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $8b0c6878c1d6b82c$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $8b0c6878c1d6b82c$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $8b0c6878c1d6b82c$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $8b0c6878c1d6b82c$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $8b0c6878c1d6b82c$export$878321e40126163f = 'com.pyxis.greenhopper.jira:gh-simplified-agility-agentic-development';
const $8b0c6878c1d6b82c$export$41800d9ff2b74ac5 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-agentic-development-classic';
const $8b0c6878c1d6b82c$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $8b0c6878c1d6b82c$export$7d9a4e0ef5194fe1 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $8b0c6878c1d6b82c$export$477ca3550da12e43 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $8b0c6878c1d6b82c$export$7c0307155b744916 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $8b0c6878c1d6b82c$export$b5ab111fb8825075 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $8b0c6878c1d6b82c$export$14139f0ec41d437e = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $8b0c6878c1d6b82c$export$ebf7af45376deb8b = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $8b0c6878c1d6b82c$export$7b6945581ccdab4a = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $8b0c6878c1d6b82c$export$310a9ac5c28d65f6 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $8b0c6878c1d6b82c$export$136d17feb2f4285d = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $8b0c6878c1d6b82c$export$e288f4758e94a8cc = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $8b0c6878c1d6b82c$export$4e9ac1417ba54bba = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $8b0c6878c1d6b82c$export$560c9f6765bf9af4 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $8b0c6878c1d6b82c$export$14d4c6dbbb62a127 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $8b0c6878c1d6b82c$export$1367ee12532c525f = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $8b0c6878c1d6b82c$export$278632cc7ed9a312 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $8b0c6878c1d6b82c$export$594d0d4f5ecbf4c7 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $8b0c6878c1d6b82c$export$dda85c7a8278e495 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $8b0c6878c1d6b82c$export$b92c431651f9ee91 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $8b0c6878c1d6b82c$export$d72d75d9d0e071fc = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $8b0c6878c1d6b82c$export$753322ed1c32ff89 = `${$8b0c6878c1d6b82c$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $8b0c6878c1d6b82c$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $8b0c6878c1d6b82c$export$3f04ba85e6c31cc = 'com.atlassian.servicedesk:simplified-it-asset-management';
const $8b0c6878c1d6b82c$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $8b0c6878c1d6b82c$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $8b0c6878c1d6b82c$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $8b0c6878c1d6b82c$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $8b0c6878c1d6b82c$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $8b0c6878c1d6b82c$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $8b0c6878c1d6b82c$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $8b0c6878c1d6b82c$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $8b0c6878c1d6b82c$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $8b0c6878c1d6b82c$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $8b0c6878c1d6b82c$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $8b0c6878c1d6b82c$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $8b0c6878c1d6b82c$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $8b0c6878c1d6b82c$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $8b0c6878c1d6b82c$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $8b0c6878c1d6b82c$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $8b0c6878c1d6b82c$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $8b0c6878c1d6b82c$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $8b0c6878c1d6b82c$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $8b0c6878c1d6b82c$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $8b0c6878c1d6b82c$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $8b0c6878c1d6b82c$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $8b0c6878c1d6b82c$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $8b0c6878c1d6b82c$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $8b0c6878c1d6b82c$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $8b0c6878c1d6b82c$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $8b0c6878c1d6b82c$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $8b0c6878c1d6b82c$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $8b0c6878c1d6b82c$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $8b0c6878c1d6b82c$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $8b0c6878c1d6b82c$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $8b0c6878c1d6b82c$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $8b0c6878c1d6b82c$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $8b0c6878c1d6b82c$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $8b0c6878c1d6b82c$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $8b0c6878c1d6b82c$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $8b0c6878c1d6b82c$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $8b0c6878c1d6b82c$export$7757b7af2cfeaf40 = 'jsm.development-requests';
const $8b0c6878c1d6b82c$export$39dcce6358d45bde = 'com.atlassian.servicedesk:simplified-development-requests-service-desk';
const $8b0c6878c1d6b82c$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $8b0c6878c1d6b82c$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $8b0c6878c1d6b82c$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $8b0c6878c1d6b82c$export$f9776303073903dd = 'jira.polaris:roadmap';
const $8b0c6878c1d6b82c$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $8b0c6878c1d6b82c$export$c08af08a98ed8545 = 'jira.polaris:blueprints';
const $8b0c6878c1d6b82c$export$3e0c026ef9261553 = 'jira.polaris:portfolio-roadmap';
const $8b0c6878c1d6b82c$export$17a44d941c0ac63a = 'jira.polaris:opportunity-solution';
const $8b0c6878c1d6b82c$export$d46f8c4a94e948e2 = 'jira.polaris:view-preview-rice';
const $8b0c6878c1d6b82c$export$1c9b046bccbb3d41 = 'jira.polaris:view-preview-moscow';
const $8b0c6878c1d6b82c$export$83b5ff1274a6f8da = 'jira.polaris:view-preview-leadership';
const $8b0c6878c1d6b82c$export$3c9c3ddf0b189f2f = 'jira.polaris:view-preview-triage';
const $8b0c6878c1d6b82c$export$3877b9ec8885bc0d = 'jira.polaris:view-preview-delivery';
const $8b0c6878c1d6b82c$export$fbb20cc5f3b9e76e = 'jira.polaris:view-preview-planning';
const $8b0c6878c1d6b82c$export$734e6243a1bbc154 = 'jira.polaris:view-preview-cross-team';
const $8b0c6878c1d6b82c$export$67277c93482a2114 = 'jira.polaris:view-preview-intake';
const $8b0c6878c1d6b82c$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $8b0c6878c1d6b82c$export$e8df553a3f519284 || T4JTemplateKey === $8b0c6878c1d6b82c$export$8eecdf6acea9494 || T4JTemplateKey === $8b0c6878c1d6b82c$export$9e38ad41d19608ee;
const $8b0c6878c1d6b82c$export$a062badd78c9993 = {
    [$8b0c6878c1d6b82c$export$e82092c4fb277f9b]: $8b0c6878c1d6b82c$export$b0928b02ffab3875,
    [$8b0c6878c1d6b82c$export$fd75f6abc7861439]: $8b0c6878c1d6b82c$export$b0928b02ffab3875,
    [$8b0c6878c1d6b82c$export$5eddf3b31dd1858f]: $8b0c6878c1d6b82c$export$50478ee5ecbf7a4d,
    [$8b0c6878c1d6b82c$export$fb658bddae7f81bb]: $8b0c6878c1d6b82c$export$50478ee5ecbf7a4d
};

});

parcelRegister("aBk88", function(module, exports) {
$parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", () => $6ae059035cbebcac$export$c0c81c1828c7638c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $bYonX = parcelRequire("bYonX");
const $6ae059035cbebcac$export$c0c81c1828c7638c = (projectKey)=>{
    try {
        const { storeState: storeState } = (0, $bYonX.getResourceStore)();
        const prevState = storeState.getState();
        storeState.setState({
            ...prevState,
            data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                // This will not clear resources that are keyed with project key as a subset of the key,
                // e.g. `projectKey-${projectKey}` or similar, so those resources may still have stale data.
                const { [projectKey]: _, ...rest } = value;
                return [
                    resourceType,
                    rest
                ];
            }))
        });
    } catch (e) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'clearResourcesAssociatedWithProjectKey',
                packageName: 'jiraProjectCreateDrawerContext',
                teamName: 'helix'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
        });
    }
};

});


parcelRegister("5WjEJ", function(module, exports) {
$parcel$export(module.exports, "CrossFlowProvider", () => $f81099962d7dcbad$export$d900e4062895cd7c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6HxXT = parcelRequire("6HxXT");

var $6Kdw4 = parcelRequire("6Kdw4");

var $kt86l = parcelRequire("kt86l");

var $gQJGQ = parcelRequire("gQJGQ");

var $7xTPs = parcelRequire("7xTPs");

var $gpiyU = parcelRequire("gpiyU");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $f81099962d7dcbad$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
        // Replace with lodash/noop
        // oxlint-disable-next-line no-empty-function
        sendUIEvent: ()=>{},
        // Replace with lodash/noop
        // oxlint-disable-next-line no-empty-function
        sendOperationalEvent: ()=>{},
        // Replace with lodash/noop
        // oxlint-disable-next-line no-empty-function
        sendTrackEvent: ()=>{},
        // Replace with lodash/noop
        // oxlint-disable-next-line no-empty-function
        sendScreenEvent: ()=>{}
    }) : (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $f81099962d7dcbad$export$d900e4062895cd7c = ({ children: children })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const locale = (0, $gQJGQ.useLocale)();
    const analyticsClient = (0, $euxye.useMemo)(()=>$f81099962d7dcbad$var$getAnalyticsInstance(), []);
    const plugins = (0, $euxye.useMemo)(()=>[
            (0, $7xTPs.getContainersPlugin),
            (0, $gpiyU.getUsersPlugin)
        ], []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6HxXT.default), {
        cloudId: cloudId,
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
        analyticsClient: analyticsClient,
        locale: locale,
        plugins: plugins
    }, children);
};
$f81099962d7dcbad$export$d900e4062895cd7c.displayName = "CrossFlowProvider";

});
parcelRegister("6HxXT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ad79bd22b290585$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $hK9lB = parcelRequire("hK9lB");
parcelRequire("8oFkF");
var $3UOZs = parcelRequire("3UOZs");
var $kwlPT = parcelRequire("kwlPT");parcelRequire("lfqQU");
var $9oYNa = parcelRequire("9oYNa");
const $6ad79bd22b290585$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hK9lB.CrossFlowProvider), {
        ...props,
        originProduct: "jira"
    });
};
$6ad79bd22b290585$var$JiraProvider.displayName = "JiraProvider";
var $6ad79bd22b290585$export$2e2bcd8739ae039 = $6ad79bd22b290585$var$JiraProvider;

});
parcelRegister("hK9lB", function(module, exports) {
$parcel$export(module.exports, "CrossFlowProvider", () => $5d86712540f8b6ad$export$d900e4062895cd7c);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
parcelRequire("8oFkF");
var $kwlPT = parcelRequire("kwlPT");
var $3UOZs = parcelRequire("3UOZs");

var $3CpXJ = parcelRequire("3CpXJ");

var $5sdkG = parcelRequire("5sdkG");

var $cD1FO = parcelRequire("cD1FO");

var $1oD3C = parcelRequire("1oD3C");

var $glSMF = parcelRequire("glSMF");

var $8f3oi = parcelRequire("8f3oi");

var $kLApe = parcelRequire("kLApe");

var $fqIie = parcelRequire("fqIie");

const $5d86712540f8b6ad$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("bvZXQ")));
const $5d86712540f8b6ad$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $euxye.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $euxye.useState)(false);
        const fireEvent = (0, $euxye.useMemo)(()=>(0, $5sdkG.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $euxye.useState)();
        const onAnalyticsEvent = (0, $euxye.useCallback)((payload)=>{
            const gasV3Event = (0, $cD1FO.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $kLApe.enrichWithRequestOptions)((0, $8f3oi.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $euxye.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
                        action: (0, $fqIie.uiInitialized),
                        actionSubject: (0, $fqIie.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $fqIie.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $euxye.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $kLApe.enrichWithRequestOptions)({
                    eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
                    action: (0, $fqIie.openInvoked),
                    actionSubject: (0, $fqIie.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $fqIie.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $3UOZs.Journeys).GET_STARTED && redirectToWac) {
                (0, $1oD3C.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $euxye.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $3CpXJ.default)();
        return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $kwlPT.BaseCrossFlowApiProvider), {
            onOpen: onOpen,
            children: [
                children,
                requestOptions && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $glSMF.ErrorBoundary), {
                    onAnalyticsEvent: onAnalyticsEvent,
                    onError: onError,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)(IntegrationView, {
                            ...baseProviderProps,
                            ...requestOptions,
                            onAnalyticsEvent: onAnalyticsEvent,
                            originProduct: originProduct,
                            theme: colorMode,
                            onClose: onClose,
                            onHandShake: onHandShake,
                            plugins: plugins,
                            env: env,
                            redirectToWac: redirectToWac,
                            zIndex: requestOptions.zIndex ?? 1000
                        })
                    })
                })
            ]
        });
    };
const $5d86712540f8b6ad$export$d900e4062895cd7c = $5d86712540f8b6ad$export$79d79d8dd8574306($5d86712540f8b6ad$var$IntegrationView);

});
parcelRegister("8oFkF", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("kwlPT")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("kwlPT")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("kwlPT")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("3UOZs")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("3UOZs")).Reasons);

var $kwlPT = parcelRequire("kwlPT");

var $3UOZs = parcelRequire("3UOZs");

});
parcelRegister("kwlPT", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => $96d5cd3970c9d8cd$export$c0ddec072762f62a);
$parcel$export(module.exports, "useCrossFlow", () => $96d5cd3970c9d8cd$export$6e7a10fe635a0dfc);
$parcel$export(module.exports, "withCrossFlow", () => $96d5cd3970c9d8cd$export$655b6c19a0daddb8);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9BXlH = parcelRequire("9BXlH");

var $af6Ai = parcelRequire("af6Ai");

var $3UOZs = parcelRequire("3UOZs");
const $96d5cd3970c9d8cd$var$LATEST_VERSION = (0, $af6Ai.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $96d5cd3970c9d8cd$var$CrossFlowContext = /*#__PURE__*/ (0, $euxye.createContext)(()=>({
        isEnabled: false,
        reason: (0, $3UOZs.Reasons).NO_PROVIDER
    }));
const $96d5cd3970c9d8cd$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $af6Ai.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $9BXlH.createAPIv0)(onOpen),
                    apiV1: (0, $af6Ai.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $3UOZs.Reasons).NO_API_SUPPORT
                };
        }
    };
const $96d5cd3970c9d8cd$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $euxye.useMemo)(()=>$96d5cd3970c9d8cd$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($96d5cd3970c9d8cd$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
$96d5cd3970c9d8cd$export$c0ddec072762f62a.displayName = "BaseCrossFlowApiProvider";
const $96d5cd3970c9d8cd$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $euxye.useContext)($96d5cd3970c9d8cd$var$CrossFlowContext);
    return (0, $euxye.useMemo)(()=>negotiateApi($96d5cd3970c9d8cd$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $96d5cd3970c9d8cd$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $96d5cd3970c9d8cd$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $e79Pd.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}

});
parcelRegister("9BXlH", function(module, exports) {
$parcel$export(module.exports, "createAPIv0", () => $e96cfaaa803c6d5c$export$9ff7368ac93fcf2d);
const $e96cfaaa803c6d5c$export$a4ad2735b021c132 = 0;
const $e96cfaaa803c6d5c$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("af6Ai", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $b8b79b75fb4d2b95$export$a4ad2735b021c132);
$parcel$export(module.exports, "createAPIv1", () => $b8b79b75fb4d2b95$export$8fd5792fc468459f);
const $b8b79b75fb4d2b95$export$a4ad2735b021c132 = 1;
const $b8b79b75fb4d2b95$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("3UOZs", function(module, exports) {
$parcel$export(module.exports, "Journeys", () => $11200aef9e0544bc$export$3411873bfd520bb6);
$parcel$export(module.exports, "Reasons", () => $11200aef9e0544bc$export$da2d4f2f250d6f84);
const $11200aef9e0544bc$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $11200aef9e0544bc$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};

});



parcelRegister("5sdkG", function(module, exports) {
$parcel$export(module.exports, "analyticsWrapper", () => $32df1dc21c62150a$export$91b4dd3bfc301325);

const $32df1dc21c62150a$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $6d4033511f75ada1$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});

parcelRegister("cD1FO", function(module, exports) {
$parcel$export(module.exports, "transformEvent", () => $b66a54e94dd997cf$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $b66a54e94dd997cf$var$GROWTH_TAG = 'growth';
const $b66a54e94dd997cf$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $b66a54e94dd997cf$var$getSources = (context)=>$b66a54e94dd997cf$var$extractFromEventContext([
        'source'
    ], context);
const $b66a54e94dd997cf$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $b66a54e94dd997cf$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $b66a54e94dd997cf$var$last = (values)=>values[values.length - 1];
const $b66a54e94dd997cf$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $b66a54e94dd997cf$var$getSources(context);
    const source = $b66a54e94dd997cf$var$last(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = $b66a54e94dd997cf$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $b66a54e94dd997cf$var$last($b66a54e94dd997cf$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($b66a54e94dd997cf$var$GROWTH_TAG);
    switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("1oD3C", function(module, exports) {
$parcel$export(module.exports, "setProductSignUpLocation", () => $afaa0f6a09dc276e$export$2827e2473cb9a346);
parcelRequire("lfqQU");
var $9oYNa = parcelRequire("9oYNa");


var $2XSe9 = parcelRequire("2XSe9");
const $afaa0f6a09dc276e$var$utmCampaignMap = {
    'atlassian-switcher': (0, $2XSe9.UtmCampaign)['atlassian-switcher']
};
const $afaa0f6a09dc276e$var$isBundledProduct = (productKey)=>{
    return [
        (0, $9oYNa.Targets).JIRA_SOFTWARE,
        (0, $9oYNa.Targets).JIRA_SERVICE_DESK,
        (0, $9oYNa.Targets).JIRA_CORE,
        (0, $9oYNa.Targets).CONFLUENCE
    ].includes(productKey);
};
const $afaa0f6a09dc276e$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $9oYNa.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $9oYNa.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $9oYNa.Targets).JIRA_CORE]: 'jira-core',
        [(0, $9oYNa.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $afaa0f6a09dc276e$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $9oYNa.Targets).OPSGENIE
    ].includes(productKey);
};
const $afaa0f6a09dc276e$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $9oYNa.Targets).OPSGENIE]: (0, $1d8fa3bc55e67fca$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $afaa0f6a09dc276e$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($afaa0f6a09dc276e$var$utmCampaignMap[sourceComponent]);
};
const $afaa0f6a09dc276e$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $afaa0f6a09dc276e$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$afaa0f6a09dc276e$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $afaa0f6a09dc276e$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $1d8fa3bc55e67fca$export$c37558e5c67d2b01) : (0, $1d8fa3bc55e67fca$export$f199baf8dfc7621e);
    const utmParams = $afaa0f6a09dc276e$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $1d8fa3bc55e67fca$export$2a45a00073911255);
    if ($afaa0f6a09dc276e$var$isBundledProduct(productKey)) {
        path = (0, $1d8fa3bc55e67fca$export$e6c04a1dd86d1c14);
        bundleParams = $afaa0f6a09dc276e$var$getBundleSignUpParams(productKey);
    } else if ($afaa0f6a09dc276e$var$isProductWithCustomSignUpPath(productKey)) path = $afaa0f6a09dc276e$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $afaa0f6a09dc276e$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $afaa0f6a09dc276e$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
parcelRegister("lfqQU", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("5aazj")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("9oYNa")).Targets);

var $5aazj = parcelRequire("5aazj");

var $9oYNa = parcelRequire("9oYNa");

});
parcelRegister("5aazj", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => $54fe11fef4e38b48$export$a5e53d1dcbd6eb61);
class $54fe11fef4e38b48$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}

});

parcelRegister("9oYNa", function(module, exports) {
$parcel$export(module.exports, "Targets", () => $ac1b87781a2a98e8$export$59a8eb9cff113544);
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $ac1b87781a2a98e8$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};

});


const $1d8fa3bc55e67fca$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $1d8fa3bc55e67fca$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $1d8fa3bc55e67fca$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $1d8fa3bc55e67fca$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $1d8fa3bc55e67fca$export$2a45a00073911255 = '/software';

parcelRegister("2XSe9", function(module, exports) {
$parcel$export(module.exports, "UtmCampaign", () => $b62ccbae639e3dff$export$fc604aa353a97e10);
var $b62ccbae639e3dff$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});

});


parcelRegister("glSMF", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $a4be28338a1d2d7a$export$e926676385687eaf);

var $euxye = parcelRequire("euxye");

var $fqIie = parcelRequire("fqIie");
const $a4be28338a1d2d7a$var$name = "platform-pkg";
const $a4be28338a1d2d7a$var$version = "0.0.0-use.local";
const $a4be28338a1d2d7a$var$payload = {
    eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
    action: (0, $fqIie.errorBoundaryAction),
    actionSubject: (0, $fqIie.errorBoundaryActionSubject)
};
const $a4be28338a1d2d7a$var$context = [
    {
        source: $fqIie.source
    },
    {
        packageName: $a4be28338a1d2d7a$var$name,
        packageVersion: $a4be28338a1d2d7a$var$version
    }
];
class $a4be28338a1d2d7a$export$e926676385687eaf extends (0, $euxye.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $a4be28338a1d2d7a$var$payload,
            context: $a4be28338a1d2d7a$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
$a4be28338a1d2d7a$export$e926676385687eaf.displayName = "ErrorBoundary";

});
parcelRegister("fqIie", function(module, exports) {
$parcel$export(module.exports, "source", () => $35eb3c290de29677$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $35eb3c290de29677$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $35eb3c290de29677$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $35eb3c290de29677$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $35eb3c290de29677$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $35eb3c290de29677$export$e67cdcb8867a3bd0);

const $35eb3c290de29677$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $35eb3c290de29677$export$9d8252a268f4fa72 = 'errorCaught';
const $35eb3c290de29677$export$1045419caf49b395 = 'errorBoundary';
const $35eb3c290de29677$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $35eb3c290de29677$export$e5c2c058fa8068a6 = 'uiInitialized';
const $35eb3c290de29677$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("8f3oi", function(module, exports) {
$parcel$export(module.exports, "enrichWithPackageDetails", () => $5e5325cc94de88e3$export$59518efab336a8b5);
const $5e5325cc94de88e3$var$version = "0.0.0-use.local";
const $5e5325cc94de88e3$export$84f9cf7ef89d4c26 = {
    version: $5e5325cc94de88e3$var$version
};
const $5e5325cc94de88e3$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $5e5325cc94de88e3$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("kLApe", function(module, exports) {
$parcel$export(module.exports, "enrichWithRequestOptions", () => $f8ecb922222b40da$export$a5a156dc5df42f0);
const $f8ecb922222b40da$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("bvZXQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("heU8e").then(()=>parcelRequire('hgTiD'));

});



parcelRegister("7xTPs", function(module, exports) {
$parcel$export(module.exports, "getContainersPlugin", () => $32af87fe3151095a$export$81d1d40061d190bc);
/* eslint-disable jira/filename-case */ 
var $hfX7K = parcelRequire("hfX7K");
parcelRequire("5IYTB");
var $l8uL7 = parcelRequire("l8uL7");

var $2HuOR = parcelRequire("2HuOR");
const $32af87fe3151095a$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $hfX7K.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $hfX7K.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $32af87fe3151095a$export$81d1d40061d190bc = (0, $l8uL7.createGetContainersPlugin)($32af87fe3151095a$var$getCloudId);

});
parcelRegister("hfX7K", function(module, exports) {
$parcel$export(module.exports, "PluginTypes", () => $6410af15c8a3c9ea$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $6410af15c8a3c9ea$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $6410af15c8a3c9ea$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $6410af15c8a3c9ea$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $6410af15c8a3c9ea$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $6410af15c8a3c9ea$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $6410af15c8a3c9ea$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});

parcelRegister("5IYTB", function(module, exports) {
$parcel$export(module.exports, "createGetContainersPlugin", () => (parcelRequire("l8uL7")).createGetContainersPlugin);
$parcel$export(module.exports, "createGetUsersPlugin", () => (parcelRequire("l8uL7")).createGetUsersPlugin);

var $l8uL7 = parcelRequire("l8uL7");

var $hfX7K = parcelRequire("hfX7K");

});
parcelRegister("l8uL7", function(module, exports) {
$parcel$export(module.exports, "createGetContainersPlugin", () => $6096ac701712d85f$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $6096ac701712d85f$export$8feb7eae83cf8cd5);

var $hfX7K = parcelRequire("hfX7K");
const $6096ac701712d85f$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $hfX7K.PluginTypes).GetContainers,
        fetch
    ];
};
const $6096ac701712d85f$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $hfX7K.PluginTypes).GetUsers,
        fetch
    ];
};
const $6096ac701712d85f$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $hfX7K.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $6096ac701712d85f$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $hfX7K.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});



parcelRegister("gpiyU", function(module, exports) {
$parcel$export(module.exports, "getUsersPlugin", () => $87d82d8f112b200b$export$7c44908d2777db01);
/* eslint-disable jira/filename-case */ 
var $hfX7K = parcelRequire("hfX7K");
parcelRequire("5IYTB");
var $l8uL7 = parcelRequire("l8uL7");
const $87d82d8f112b200b$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $hfX7K.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $87d82d8f112b200b$export$7c44908d2777db01 = (0, $l8uL7.createGetUsersPlugin)($87d82d8f112b200b$var$getUsers);

});


parcelRegister("ip3FN", function(module, exports) {
$parcel$export(module.exports, "FavoriteChangeContext", () => $140d045ccd323cb8$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $140d045ccd323cb8$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $140d045ccd323cb8$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $140d045ccd323cb8$export$cfa169f3278459e8);

var $6UZpS = parcelRequire("6UZpS");

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $n67Vb = parcelRequire("n67Vb");

var $lIGkE = parcelRequire("lIGkE");

var $hFtK7 = parcelRequire("hFtK7");

var $2zU0a = parcelRequire("2zU0a");

var $aJ81Y = parcelRequire("aJ81Y");

var $kt86l = parcelRequire("kt86l");

var $dp0Rz = parcelRequire("dp0Rz");

var $etOwP = parcelRequire("etOwP");

var $7V240 = parcelRequire("7V240");

var $970ZW = parcelRequire("970ZW");

var $4wDTh = parcelRequire("4wDTh");

var $5t2qS = parcelRequire("5t2qS");
const $140d045ccd323cb8$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // oxlint-disable-next-line typescript/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $140d045ccd323cb8$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // oxlint-disable-next-line typescript/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $140d045ccd323cb8$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {},
        jpd_collections: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
};
const $140d045ccd323cb8$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $euxye.createContext)($140d045ccd323cb8$export$b212ddc707077772);
// supports project types only for now
const $140d045ccd323cb8$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const cloudId = (0, $kt86l.useCloudId)();
    const commitUpdate = (0, $euxye.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $970ZW.PROJECTS_ITEM_TYPE)) (0, $lIGkE.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $2zU0a.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $dp0Rz.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $140d045ccd323cb8$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $140d045ccd323cb8$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $euxye.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {},
        jpd_collections: {}
    });
    const onChangeStart = (0, $euxye.useCallback)((item)=>{
        setItems($140d045ccd323cb8$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $euxye.useCallback)((item, analyticsEvent)=>{
        setItems($140d045ccd323cb8$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $euxye.useCallback)((item, analyticsId, error)=>{
        setItems($140d045ccd323cb8$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $5t2qS.errorFlag)());
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $euxye.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $4wDTh.default)(item);
                const typename = (0, $etOwP.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7V240.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $n67Vb.useMutation)((0, $6UZpS.default));
    const changeFavoriteMutation = (0, $euxye.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $dp0Rz.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $etOwP.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7V240.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    // eslint-disable-next-line jira/relay/mutation-variables-from-relay-data
                    entityId: payload.id,
                    isFavourite: payload.value,
                    // eslint-disable-next-line jira/relay/mutation-variables-from-relay-data
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $euxye.useCallback)((item)=>{
        setItems($140d045ccd323cb8$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $euxye.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $etOwP.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7V240.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $euxye.useCallback)(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $dp0Rz.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $etOwP.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7V240.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $euxye.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($140d045ccd323cb8$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
$140d045ccd323cb8$export$b06b5ce59fd5e408.displayName = "FavoriteChangeProvider";
const $140d045ccd323cb8$export$f227cdfbb355444a = $140d045ccd323cb8$export$a5d258b9665ce94b.Consumer;
const $140d045ccd323cb8$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($140d045ccd323cb8$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $140d045ccd323cb8$export$cfa169f3278459e8 = ()=>(0, $euxye.useContext)($140d045ccd323cb8$export$a5d258b9665ce94b);

});
parcelRegister("6UZpS", function(module, exports) {
$parcel$export(module.exports, "default", () => $cced1456bd87fef4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<77e486078cc74b00e2d44e57ec3d5a9b>>
 * @relayHash 2cc6fed42463066ce74de984705c8901
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e5acb1b69d72b5f8949c4a0d1b6fd803239e4dc65235c8616787431e319d66f
const $cced1456bd87fef4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavoriteChangeConsumerMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavoriteChangeConsumerMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9e5acb1b69d72b5f8949c4a0d1b6fd803239e4dc65235c8616787431e319d66f",
            "metadata": {},
            "name": "FavoriteChangeConsumerMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$cced1456bd87fef4$var$node.hash = "7a3ceb525a45608774dd6c925108a05f";
var $cced1456bd87fef4$export$2e2bcd8739ae039 = $cced1456bd87fef4$var$node;

});

parcelRegister("etOwP", function(module, exports) {
$parcel$export(module.exports, "favoriteTypeToTypename", () => $13b6ba5014fe4c04$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $13b6ba5014fe4c04$export$717886a1047f1287);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lC5kV = parcelRequire("lC5kV");

var $6nh3o = parcelRequire("6nh3o");

var $b1yRO = parcelRequire("b1yRO");

var $1zTEC = parcelRequire("1zTEC");

var $bqyE0 = parcelRequire("bqyE0");

var $i8BNs = parcelRequire("i8BNs");

var $kIMpt = parcelRequire("kIMpt");

var $i860n = parcelRequire("i860n");
function $13b6ba5014fe4c04$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $13b6ba5014fe4c04$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $13b6ba5014fe4c04$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $13b6ba5014fe4c04$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        case 'jpd_collections':
            return (0, $i860n.fg)('jpd-enable-roadmaps-recents-fe') ? 'JiraProductDiscoveryCollection' : undefined;
        default:
            return undefined;
    }
};
const $13b6ba5014fe4c04$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $i8BNs.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $1zTEC.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $b1yRO.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $bqyE0.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $6nh3o.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $lC5kV.JiraServicedeskQueueAri).parse(ari).queueId;
        case 'JiraProductDiscoveryCollection':
            return (0, $kIMpt.JiraProductDiscoveryCollectionAri).parse(ari).collectionId;
        default:
            $13b6ba5014fe4c04$var$assertUnreachable(typename);
    }
};
const $13b6ba5014fe4c04$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        case 'JiraProductDiscoveryCollection':
            return 'jpd_collections';
        default:
            $13b6ba5014fe4c04$var$assertUnreachable(typename);
    }
};
const $13b6ba5014fe4c04$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $13b6ba5014fe4c04$var$favoriteAriToId(typename, id),
        type: $13b6ba5014fe4c04$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $13b6ba5014fe4c04$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $13b6ba5014fe4c04$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("b1yRO", function(module, exports) {
$parcel$export(module.exports, "JiraDashboardAri", () => $806ad58a0fe211f6$export$b7d4016f0f5da5b8);

var $1GcWT = parcelRequire("1GcWT");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/dashboard/manifest.ts
var $806ad58a0fe211f6$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1GcWT.JiraDashboardAriResourceOwner),
    resourceType: (0, $1GcWT.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $806ad58a0fe211f6$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $806ad58a0fe211f6$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $806ad58a0fe211f6$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $806ad58a0fe211f6$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $806ad58a0fe211f6$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $806ad58a0fe211f6$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $806ad58a0fe211f6$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("1GcWT", function(module, exports) {
$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $1393c20c935f5954$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $1393c20c935f5954$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $1393c20c935f5954$export$62c1deae25c41d24 = "jira", $1393c20c935f5954$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("bqyE0", function(module, exports) {
$parcel$export(module.exports, "JiraPlanAri", () => $851cff0f882f688f$export$6d2eb3641569f26);

var $jrEun = parcelRequire("jrEun");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/plan/manifest.ts
var $851cff0f882f688f$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jrEun.JiraPlanAriResourceOwner),
    resourceType: (0, $jrEun.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $851cff0f882f688f$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $851cff0f882f688f$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $851cff0f882f688f$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $851cff0f882f688f$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $851cff0f882f688f$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $851cff0f882f688f$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $851cff0f882f688f$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("jrEun", function(module, exports) {
$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $e27ff232790b44bc$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $e27ff232790b44bc$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $e27ff232790b44bc$export$bfd26af3c5e1b90d = "jira", $e27ff232790b44bc$export$d6abe08eb30f433d = "plan";

});


parcelRegister("kIMpt", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryCollectionAri", () => $f15d77e8fbbb1cde$export$25993e758662f27c);

var $gsxOn = parcelRequire("gsxOn");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira-product-discovery/collection/manifest.ts
var $f15d77e8fbbb1cde$var$jiraProductDiscoveryCollectionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $gsxOn.JiraProductDiscoveryCollectionAriResourceOwner),
    resourceType: (0, $gsxOn.JiraProductDiscoveryCollectionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{collectionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        collectionId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira-product-discovery/collection/index.ts
var $f15d77e8fbbb1cde$export$25993e758662f27c = class _JiraProductDiscoveryCollectionAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._collectionId = opts.resourceIdSegmentValues.collectionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get collectionId() {
        return this._collectionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f15d77e8fbbb1cde$var$jiraProductDiscoveryCollectionAriStaticOpts.qualifier,
            platformQualifier: $f15d77e8fbbb1cde$var$jiraProductDiscoveryCollectionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f15d77e8fbbb1cde$var$jiraProductDiscoveryCollectionAriStaticOpts.resourceOwner,
            resourceType: $f15d77e8fbbb1cde$var$jiraProductDiscoveryCollectionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.collectionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                collectionId: opts.collectionId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $f15d77e8fbbb1cde$var$jiraProductDiscoveryCollectionAriStaticOpts);
        return new _JiraProductDiscoveryCollectionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $f15d77e8fbbb1cde$var$jiraProductDiscoveryCollectionAriStaticOpts);
        return new _JiraProductDiscoveryCollectionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            collectionId: this.collectionId
        };
    }
};

});
parcelRegister("gsxOn", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryCollectionAriResourceOwner", () => $bfb97d222de3babe$export$e8d650aad7e5fc50);
$parcel$export(module.exports, "JiraProductDiscoveryCollectionAriResourceType", () => $bfb97d222de3babe$export$20e6090397efd8fc);
// src/jira-product-discovery/collection/types.ts
var $bfb97d222de3babe$export$e8d650aad7e5fc50 = "jira-product-discovery", $bfb97d222de3babe$export$20e6090397efd8fc = "collection";

});



parcelRegister("7V240", function(module, exports) {
$parcel$export(module.exports, "publishFavorite", () => $4fb6b75fddc80437$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $4fb6b75fddc80437$export$eb04bf805f6b8fb2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $4fb6b75fddc80437$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
$4fb6b75fddc80437$var$FavoritePubSub.displayName = "FavoritePubSub";
// Singleton to emit and listen to events
const $4fb6b75fddc80437$var$favoritePubSub = new $4fb6b75fddc80437$var$FavoritePubSub();
const $4fb6b75fddc80437$export$229a24253fb568e1 = $4fb6b75fddc80437$var$favoritePubSub.publish;
const $4fb6b75fddc80437$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $euxye.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$4fb6b75fddc80437$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("970ZW", function(module, exports) {
$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $19161c6b298c2185$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $19161c6b298c2185$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $19161c6b298c2185$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $19161c6b298c2185$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $19161c6b298c2185$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $19161c6b298c2185$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $19161c6b298c2185$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "JPD_COLLECTIONS_ITEM_TYPE", () => $19161c6b298c2185$export$6dbb593829817d6d);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $19161c6b298c2185$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $19161c6b298c2185$export$2d63a9c2e78633c8);
/* eslint-disable jira/filename-case */ const $19161c6b298c2185$export$aade82542e73ffc8 = 'boards';
const $19161c6b298c2185$export$a448ebfa10cebc74 = 'filters';
const $19161c6b298c2185$export$f8099f229527572c = 'dashboards';
const $19161c6b298c2185$export$8e58083dcbb878d = 'issues';
const $19161c6b298c2185$export$2fd44a6cb58b66cb = 'plans';
const $19161c6b298c2185$export$8e2cd98172988d7e = 'projects';
const $19161c6b298c2185$export$6b0c8e47d2c7f1d9 = 'queues';
const $19161c6b298c2185$export$6dbb593829817d6d = 'jpd_collections';
const $19161c6b298c2185$export$9c8cfad65800ddfb = [
    $19161c6b298c2185$export$aade82542e73ffc8,
    $19161c6b298c2185$export$f8099f229527572c,
    $19161c6b298c2185$export$a448ebfa10cebc74,
    $19161c6b298c2185$export$8e58083dcbb878d,
    $19161c6b298c2185$export$2fd44a6cb58b66cb,
    $19161c6b298c2185$export$8e2cd98172988d7e,
    $19161c6b298c2185$export$6b0c8e47d2c7f1d9,
    $19161c6b298c2185$export$6dbb593829817d6d
];
const $19161c6b298c2185$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue',
    'JiraProductDiscoveryCollection'
];

});

parcelRegister("4wDTh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9ffde6a929877e6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $9RIiH = parcelRequire("9RIiH");
const $d9ffde6a929877e6$var$updateFavorite1 = async (request)=>(0, $9RIiH.updateFavorite)(request);
var $d9ffde6a929877e6$export$2e2bcd8739ae039 = $d9ffde6a929877e6$var$updateFavorite1;

});
parcelRegister("9RIiH", function(module, exports) {
$parcel$export(module.exports, "updateFavorite", () => $1e28cdfccae8acaa$export$8c2f00130cc945dc);
/* eslint-disable jira/filename-case */ 
var $h2wCv = parcelRequire("h2wCv");
const $1e28cdfccae8acaa$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $h2wCv.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $h2wCv.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("5t2qS", function(module, exports) {
$parcel$export(module.exports, "errorFlag", () => $75cf441a7a6659ea$export$b9a7f1ebeaa76953);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line no-restricted-imports

var $7eNDO = parcelRequire("7eNDO");
const $75cf441a7a6659ea$var$messages = (0, $7eNDO.defineMessages)({
    title: {
        id: "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        defaultMessage: "Something\u2019s gone wrong"
    },
    description: {
        id: "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        defaultMessage: "You cannot star items right now due to an error."
    }
});
const $75cf441a7a6659ea$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...$75cf441a7a6659ea$var$messages
    });

});


parcelRegister("72IzE", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $08a56e03c9af09f7$export$7c9538f5f3c365e9);

var $euxye = parcelRequire("euxye");

var $9imxF = parcelRequire("9imxF");

var $b5Dgx = parcelRequire("b5Dgx");
const $08a56e03c9af09f7$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $euxye.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $euxye.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
$08a56e03c9af09f7$var$RenderModal.displayName = "RenderModal";
function $08a56e03c9af09f7$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $euxye.useRef)(1);
    const [modals, setModals] = (0, $euxye.useState)([]);
    const modalContext = (0, $euxye.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b5Dgx.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, modals.map((modal)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($08a56e03c9af09f7$var$RenderModal, {
            key: modal.key,
            modal: modal
        });
    })));
}
$08a56e03c9af09f7$export$7c9538f5f3c365e9.displayName = "ModalContextProvider";

});
parcelRegister("b5Dgx", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $be587d49087fe790$export$ab57792b9b6974a6);

var $euxye = parcelRequire("euxye");
const $be587d49087fe790$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $euxye.createContext)({
    // Replace with lodash/noop
    // oxlint-disable-next-line no-empty-function
    openModal: ()=>{}
});

});




parcelRegister("flKp5", function(module, exports) {
$parcel$export(module.exports, "LinkingProviders", () => $2c094ec6cde052b9$export$a7964d2bf9ff001);

var $euxye = parcelRequire("euxye");

var $f2wVS = parcelRequire("f2wVS");
var $2ffUK = parcelRequire("2ffUK");

var $ioHOl = parcelRequire("ioHOl");

var $2b39L = parcelRequire("2b39L");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $jc8Oy = parcelRequire("jc8Oy");

var $kt86l = parcelRequire("kt86l");

var $6bGyp = parcelRequire("6bGyp");

var $6xQiM = parcelRequire("6xQiM");

var $75YsU = parcelRequire("75YsU");

var $aWliK = parcelRequire("aWliK");

var $6ZLJT = parcelRequire("6ZLJT");

var $gJ83e = parcelRequire("gJ83e");
// A Jira work item smart card resolves to an ARI of the form
// `ari:cloud:jira:{cloudId}:issue/{id}` (resourceOwner `jira`, resourceType `issue`).
const $2c094ec6cde052b9$var$JIRA_ISSUE_ARI_REGEX = /^ari:cloud:jira:[^:]*:issue\//;
const $2c094ec6cde052b9$var$BROWSE_URL_ISSUE_KEY_REGEX = /\/browse\/([A-Za-z][A-Za-z0-9_]*-\d+)/;
const $2c094ec6cde052b9$var$getJiraIssueKeyFromSmartCard = (ari, url)=>{
    if (!$2c094ec6cde052b9$var$JIRA_ISSUE_ARI_REGEX.test(ari)) return undefined;
    try {
        const match = new URL(url).pathname.match($2c094ec6cde052b9$var$BROWSE_URL_ISSUE_KEY_REGEX);
        return match?.[1];
    } catch  {
        return undefined;
    }
};
const $2c094ec6cde052b9$var$isNativePreviewPanelOnWorkItemViewEnabled = ()=>[
        (0, $i860n.fg)('migrate-iframe-to-native-preview-on-wiv'),
        (0, $i860n.fg)('jira-glance-panel'),
        (0, $i860n.fg)('jira_preview_panel_m_1_rollout')
    ].every(Boolean);
const $2c094ec6cde052b9$var$LinkingProvidersOld = ({ children: children })=>{
    const { data: data } = (0, $2b39L.useProjectContext)();
    const cloudId = (0, $kt86l.useCloudId)();
    // Short term: Fire jira_aa_test_fy27h1 exposure for Jira FY27H1 Holdout
    // This is needed due to crossover units exposed by confluence_web affecting jira_web
    // see: https://atlassian.slack.com/archives/C04PR2YE4UC/p1781650989840319?thread_ts=1781401144.742829&cid=C04PR2YE4UC
    // do not remove - ping #twc-holdout-working-group to discuss
    if (data?.projectType === 'software' || data?.projectType === 'business') (0, $2700E.expVal)('jira_aa_test_fy27h1', 'isEnabled', false);
    const product = $2c094ec6cde052b9$var$getProductForSmartCardProvider(data);
    const atlassianIntelligenceProps = (0, $euxye.useMemo)(()=>{
        if (!(0, $i860n.fg)('jira-cc-ai-snippet-gate') || !data?.isAIEnabled) return {};
        return {
            renderers: {
                snippet: (0, $gJ83e.SyncJiraSnippetRenderer)
            }
        };
    }, [
        data?.isAIEnabled
    ]);
    const useRovoEntitlementResourceGated = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $i860n.fg)('platform_sl_3p_auth_rovo_entitlement'), (0, $6bGyp.useRovoEntitlementResource), ()=>undefined);
    const rovoEntitlement = useRovoEntitlementResourceGated();
    const rovoOptions = (0, $euxye.useMemo)(()=>rovoEntitlement?.data ? {
            isRovoEnabled: Boolean(rovoEntitlement.data.isRovoEnabled),
            isRovoLLMEnabled: Boolean(rovoEntitlement.data.isRovoLLMEnabled)
        } : undefined, [
        rovoEntitlement
    ]);
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $i860n.fg)('jira-glance-panel') && (0, $i860n.fg)('jira_preview_panel_m_1_rollout')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const smartCardProviderProps = (0, $jc8Oy.useGlobalObjectPreviewPanels)();
        const open = smartCardProviderProps.openPreviewPanel;
        // Create a wrapper function that updates the preview panel URL
        // This is used for custom domains to update to the correct content URL and avoid CSP issues
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const openPreviewPanelWithModifiedURL = (0, $euxye.useMemo)(()=>(props)=>open({
                    ...props,
                    url: (0, $6xQiM.getCorrectContentURL)(cloudId, props.url, props.ari),
                    ari: props.ari
                }), [
            open,
            cloudId
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioHOl.SmartCardProvider), {
            ...smartCardProviderProps,
            openPreviewPanel: openPreviewPanelWithModifiedURL,
            product: product,
            isAdminHubAIEnabled: data?.isAIEnabled ?? false,
            rovoOptions: rovoOptions,
            ...atlassianIntelligenceProps,
            xpcProduct: "jira",
            xpcSubProduct: product
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioHOl.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: data?.isAIEnabled ?? false,
        rovoOptions: rovoOptions,
        ...atlassianIntelligenceProps
    }, children);
};
$2c094ec6cde052b9$var$LinkingProvidersOld.displayName = "LinkingProvidersOld";
const $2c094ec6cde052b9$var$LinkingProvidersNew = ({ children: children })=>{
    const { data: data } = (0, $2b39L.useProjectContext)();
    const cloudId = (0, $kt86l.useCloudId)();
    // Short term: Fire jira_aa_test_fy27h1 exposure for Jira FY27H1 Holdout
    // This is needed due to crossover units exposed by confluence_web affecting jira_web
    // see: https://atlassian.slack.com/archives/C04PR2YE4UC/p1781650989840319?thread_ts=1781401144.742829&cid=C04PR2YE4UC
    // do not remove - ping #twc-holdout-working-group to discuss
    if (data?.projectType === 'software' || data?.projectType === 'business') (0, $2700E.expVal)('jira_aa_test_fy27h1', 'isEnabled', false);
    const product = $2c094ec6cde052b9$var$getProductForSmartCardProvider(data);
    const atlassianIntelligenceProps = (0, $euxye.useMemo)(()=>{
        if (!(0, $i860n.fg)('jira-cc-ai-snippet-gate') || !data?.isAIEnabled) return {};
        return {
            renderers: {
                snippet: (0, $gJ83e.SyncJiraSnippetRenderer)
            }
        };
    }, [
        data?.isAIEnabled
    ]);
    const useRovoEntitlementResourceGated = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $i860n.fg)('platform_sl_3p_auth_rovo_entitlement'), (0, $6bGyp.useRovoEntitlementResource), ()=>undefined);
    const rovoEntitlement = useRovoEntitlementResourceGated();
    const rovoOptions = (0, $euxye.useMemo)(()=>rovoEntitlement?.data ? {
            isRovoEnabled: Boolean(rovoEntitlement.data.isRovoEnabled),
            isRovoLLMEnabled: Boolean(rovoEntitlement.data.isRovoLLMEnabled)
        } : undefined, [
        rovoEntitlement
    ]);
    const smartCardProviderProps = (0, $jc8Oy.useGlobalObjectPreviewPanels)();
    const isWorkItemRoute = (0, $f2wVS.useIsActiveRoute)('work-item');
    const [, setSelectedIssue] = (0, $2ffUK.useQueryParam)('selectedIssue');
    const open = smartCardProviderProps.openPreviewPanel;
    const isFullScreenNewWorkItemView = isWorkItemRoute && (0, $75YsU.isWorkItemModernizationGatesEnabled)();
    const isOpeningNativePreviewPanelForJiraSmartCard = isFullScreenNewWorkItemView && (0, $i860n.fg)('opening_native_preview_panel_for_jira_smart_card');
    // Create a wrapper function that updates the preview panel URL
    // This is used for custom domains to update to the correct content URL and avoid CSP issues
    const openPreviewPanelWithModifiedURL = (0, $euxye.useMemo)(()=>(props)=>{
            if (isOpeningNativePreviewPanelForJiraSmartCard) {
                const issueKey = $2c094ec6cde052b9$var$getJiraIssueKeyFromSmartCard(props.ari, props.url);
                if (issueKey) {
                    setSelectedIssue(issueKey);
                    return;
                }
            }
            open({
                ...props,
                url: (0, $6xQiM.getCorrectContentURL)(cloudId, props.url, props.ari),
                ari: props.ari
            });
        }, [
        isOpeningNativePreviewPanelForJiraSmartCard,
        open,
        cloudId,
        setSelectedIssue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioHOl.SmartCardProvider), {
        ...smartCardProviderProps,
        openPreviewPanel: openPreviewPanelWithModifiedURL,
        product: product,
        isAdminHubAIEnabled: data?.isAIEnabled ?? false,
        rovoOptions: rovoOptions,
        ...atlassianIntelligenceProps,
        xpcProduct: "jira",
        xpcSubProduct: product
    }, children);
};
$2c094ec6cde052b9$var$LinkingProvidersNew.displayName = "LinkingProvidersNew";
const $2c094ec6cde052b9$export$a7964d2bf9ff001 = (0, $aWliK.componentWithCondition)($2c094ec6cde052b9$var$isNativePreviewPanelOnWorkItemViewEnabled, $2c094ec6cde052b9$var$LinkingProvidersNew, $2c094ec6cde052b9$var$LinkingProvidersOld);
const $2c094ec6cde052b9$var$getProductForSmartCardProvider = (project)=>{
    switch(project?.projectType){
        case 'software':
            return 'JSW';
        case 'business':
            return 'JWM';
        case 'service_desk':
            return 'JSM';
        case 'product_discovery':
            return 'JPD';
        default:
            return undefined;
    }
};

});
parcelRegister("ioHOl", function(module, exports) {
$parcel$export(module.exports, "SMART_CARD_EXTERNAL_AUTH_EVENT", () => $cb33494b0926e1c9$export$97eec7ea3e925862);
$parcel$export(module.exports, "SmartCardProvider", () => $cb33494b0926e1c9$export$497ecb0280204df4);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $13ZYC = parcelRequire("13ZYC");

var $6Fltw = parcelRequire("6Fltw");

var $7OyAf = parcelRequire("7OyAf");
var $gIYPk = parcelRequire("gIYPk");
var $kXeX5 = parcelRequire("kXeX5");

var $1cYfV = parcelRequire("1cYfV");

var $10jQT = parcelRequire("10jQT");

var $4AmqH = parcelRequire("4AmqH");

var $egspI = parcelRequire("egspI");

var $b3YHz = parcelRequire("b3YHz");
const $cb33494b0926e1c9$export$97eec7ea3e925862 = 'atlaskit-smart-card:external-auth-completed';
/**
 * Whether the error represents a URL the resolver does not support. This is an expected,
 * benign outcome (not a real failure) and must not be surfaced as an errored card.
 */ const $cb33494b0926e1c9$var$isUnsupportedError = (error)=>error.type === 'UnsupportedError' || error.type === 'ResolveUnsupportedError' || error.type === 'SearchUnsupportedError';
function $cb33494b0926e1c9$export$497ecb0280204df4({ storeOptions: storeOptions, bridgeProduct: bridgeProduct, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct }) {
    const parentContext = (0, $euxye.useContext)((0, $4AmqH.SmartCardContext));
    const defaultInitialState = (0, $euxye.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $euxye.useMemo)(()=>{
        return (0, $13ZYC.createStore)((0, $10jQT.cardReducer), initialState);
    }, [
        initialState
    ]);
    const client = (0, $euxye.useMemo)(()=>{
        const c = customClient || new (0, $b3YHz.default)();
        if (product && c.setProduct) c.setProduct(product);
        return c;
    }, [
        customClient,
        product
    ]);
    // Listen for external auth completion events and re-resolve any matching unauthorized cards in this store.
    // Used as guardrail killswitch for synchronized-post-office-and-smartcard-auth-exp in Post Office
    (0, $euxye.useEffect)(()=>{
        if (typeof window === 'undefined' || !(0, $egspI.fg)('navx-smartcard-auth-event-listener-killswitch-fg')) return;
        const handler = (event)=>{
            const detail = event.detail;
            if (!detail?.extensionKeys?.length) return;
            const targetKeys = new Set(detail.extensionKeys);
            const state = store.getState();
            for (const url of Object.keys(state)){
                const cardState = state[url];
                if (!cardState || cardState.status !== 'unauthorized') continue;
                const cardExtensionKey = cardState.details?.meta?.key;
                if (!cardExtensionKey || !targetKeys.has(cardExtensionKey)) continue;
                // Fetch fresh data from ORS and dispatch new payload data
                client.fetchData(url, true).then((response)=>{
                    store.dispatch((0, $7OyAf.cardAction)((0, $7OyAf.ACTION_RELOADING), {
                        url: url
                    }, response, undefined, undefined, true));
                }, (err)=>{
                    // "Unsupported URL" is a benign, expected resolver outcome (ORS does not
                    // support this link), surfaced as a fatal APIError. Turning it into an
                    // errored card state causes non-flexible SmartLinks to re-throw it to their
                    // error boundary and report it to Sentry. Leave the card in its prior
                    // unauthorized state instead.
                    if (err instanceof (0, $gIYPk.APIError) && $cb33494b0926e1c9$var$isUnsupportedError(err) && (0, $egspI.fg)('platform_lp_navx_5358_dont_throw_error')) return;
                    store.dispatch((0, $7OyAf.cardAction)((0, $7OyAf.ACTION_ERROR), {
                        url: url
                    }, undefined, err, undefined, true));
                });
            }
        };
        window.addEventListener($cb33494b0926e1c9$export$97eec7ea3e925862, handler);
        return ()=>{
            window.removeEventListener($cb33494b0926e1c9$export$97eec7ea3e925862, handler);
        };
    }, [
        store,
        client
    ]);
    const providerValue = (0, $euxye.useMemo)(()=>{
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        _platform)=>{
            const cardState = (0, $kXeX5.getUrl)(store, url);
            return cardState.details ? (0, $1cYfV.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            bridgeProduct: bridgeProduct,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
    }, [
        customAuthFlow,
        bridgeProduct,
        client,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        store,
        xpcProduct,
        xpcSubProduct
    ]);
    const value = (0, $euxye.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4AmqH.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
$cb33494b0926e1c9$export$497ecb0280204df4.displayName = "SmartCardProvider";
var $cb33494b0926e1c9$export$2e2bcd8739ae039 = $cb33494b0926e1c9$export$497ecb0280204df4;

});
parcelRegister("7OyAf", function(module, exports) {
$parcel$export(module.exports, "ACTION_PENDING", () => $20ff064b740eb6ef$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $20ff064b740eb6ef$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $20ff064b740eb6ef$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $20ff064b740eb6ef$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $20ff064b740eb6ef$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $20ff064b740eb6ef$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $20ff064b740eb6ef$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $20ff064b740eb6ef$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $20ff064b740eb6ef$export$6e470aad5ba8952e = 'pending';
const $20ff064b740eb6ef$export$9a6a932a0a39498e = 'resolving';
const $20ff064b740eb6ef$export$63ec8bc7a8a75482 = 'resolved';
const $20ff064b740eb6ef$export$b8cfaa842c9ab487 = 'reloading';
const $20ff064b740eb6ef$export$6d8ed3f9433dd372 = 'errored';
const $20ff064b740eb6ef$export$cfbbb7126bc8a0c6 = 'fallback';
const $20ff064b740eb6ef$export$76b5c1aca20759c6 = 'preload';
const $20ff064b740eb6ef$export$2c5edb971b673330 = 'metadata';
const $20ff064b740eb6ef$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("gIYPk", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $4f7f56c4e8b06f80$export$3e5b797e39668f84);
$parcel$export(module.exports, "InvalidUrlError", () => $4f7f56c4e8b06f80$export$19fa02dd69bd4efd);
$parcel$export(module.exports, "NetworkError", () => $4f7f56c4e8b06f80$export$bae979e68e4dc802);
class $4f7f56c4e8b06f80$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
class $4f7f56c4e8b06f80$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
class $4f7f56c4e8b06f80$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}

});

parcelRegister("kXeX5", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $3a6eca12f23cd844$export$94df0e59ebebf4a7);
const $3a6eca12f23cd844$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("1cYfV", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $c4d1e4fe5ea9141c$export$67f3d92c824fd850);
$parcel$export(module.exports, "extractType", () => $c4d1e4fe5ea9141c$export$2e9ae379995d99e3);
$parcel$export(module.exports, "extractAri", () => $c4d1e4fe5ea9141c$export$be18a6294fd426ec);
$parcel$export(module.exports, "extractLink", () => $c4d1e4fe5ea9141c$export$63f54cf4c5883620);
$parcel$export(module.exports, "extractTitle", () => $c4d1e4fe5ea9141c$export$b05803156e5015b6);
$parcel$export(module.exports, "extractProvider", () => $c4d1e4fe5ea9141c$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $c4d1e4fe5ea9141c$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $c4d1e4fe5ea9141c$export$38df542ff03a4183);
$parcel$export(module.exports, "extractPersonFromJsonLd", () => $c4d1e4fe5ea9141c$export$c471ae5fddcf1392);
$parcel$export(module.exports, "extractMembers", () => $c4d1e4fe5ea9141c$export$6281d080d62a0719);
$parcel$export(module.exports, "extractPersonAssignedTo", () => $c4d1e4fe5ea9141c$export$38a0979ebf273662);
$parcel$export(module.exports, "extractPersonCreatedBy", () => $c4d1e4fe5ea9141c$export$a66235cba0c9d11a);
$parcel$export(module.exports, "extractPersonOwnedBy", () => $c4d1e4fe5ea9141c$export$19ee667f3f7a6ec3);
$parcel$export(module.exports, "extractPersonUpdatedBy", () => $c4d1e4fe5ea9141c$export$8a2d1ed7e6f336f0);
$parcel$export(module.exports, "extractImage", () => $c4d1e4fe5ea9141c$export$4c753a1297cb9805);
$parcel$export(module.exports, "extractPreview", () => $c4d1e4fe5ea9141c$export$4b0d98b1b7f6d115);
$parcel$export(module.exports, "extractEntity", () => $c4d1e4fe5ea9141c$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $c4d1e4fe5ea9141c$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityProvider", () => $c4d1e4fe5ea9141c$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $c4d1e4fe5ea9141c$export$19346520e937a99f);
$parcel$export(module.exports, "extractSmartLinkTitle", () => $c4d1e4fe5ea9141c$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $c4d1e4fe5ea9141c$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $c4d1e4fe5ea9141c$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $c4d1e4fe5ea9141c$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $c4d1e4fe5ea9141c$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $c4d1e4fe5ea9141c$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $c4d1e4fe5ea9141c$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $c4d1e4fe5ea9141c$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $c4d1e4fe5ea9141c$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $c4d1e4fe5ea9141c$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $c4d1e4fe5ea9141c$export$96ed4c1b14ac210a);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $gPjPG = parcelRequire("gPjPG");

var $l5Fg2 = parcelRequire("l5Fg2");

var $eprc4 = parcelRequire("eprc4");

var $egspI = parcelRequire("egspI");

var $cua4f = parcelRequire("cua4f");

var $1DtGB = parcelRequire("1DtGB");
function $c4d1e4fe5ea9141c$export$ab527c45f467d3f7(options) {
    const { defaultExtractorFunction: defaultExtractorFunction, extractorPrioritiesByType: extractorPrioritiesByType, extractorFunctionsByType: extractorFunctionsByType, json: json } = options;
    if (json) {
        const type = json['@type'];
        if (type && Array.isArray(type)) {
            let highestPriority = 0;
            let highestPriorityExtractorFunction = defaultExtractorFunction;
            for (let t of type)if (extractorPrioritiesByType[t] > highestPriority) {
                highestPriority = extractorPrioritiesByType[t];
                highestPriorityExtractorFunction = extractorFunctionsByType[t];
            }
            return highestPriorityExtractorFunction(json);
        }
        if (type && extractorFunctionsByType[type]) return extractorFunctionsByType[type](json);
    }
    return defaultExtractorFunction(json);
}
const $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
const $c4d1e4fe5ea9141c$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(icon);
    else {
        if (icon.url) return $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(icon.url);
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
const $c4d1e4fe5ea9141c$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(url);
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = $c4d1e4fe5ea9141c$export$efdbd45f3e77a161(jsonLd);
    const type = $c4d1e4fe5ea9141c$export$2e9ae379995d99e3(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
const $c4d1e4fe5ea9141c$export$3185b99040f72cfd = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $c4d1e4fe5ea9141c$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && $c4d1e4fe5ea9141c$export$67f3d92c824fd850(context.icon),
                type: $c4d1e4fe5ea9141c$export$2e9ae379995d99e3(context)
            };
        }
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return (0, $egspI.fg)('platform_sl_google_rebrand') ? (0, $cua4f.rebrandProvider)({
                text: generator.name
            }) : {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return (0, $egspI.fg)('platform_sl_google_rebrand') ? (0, $cua4f.rebrandProvider)({
                text: generator.name,
                icon: $c4d1e4fe5ea9141c$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $egspI.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $c4d1e4fe5ea9141c$var$extractProviderImage(generator.image)
            }) : {
                text: generator.name,
                icon: $c4d1e4fe5ea9141c$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $egspI.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $c4d1e4fe5ea9141c$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $1DtGB.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l5Fg2.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $egspI.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $1DtGB.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $egspI.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return $c4d1e4fe5ea9141c$export$67f3d92c824fd850(icon);
    return undefined;
};
const $c4d1e4fe5ea9141c$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$38df542ff03a4183 = (id)=>{
    return id === (0, $1DtGB.CONFLUENCE_GENERATOR_ID);
};
const $c4d1e4fe5ea9141c$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
const $c4d1e4fe5ea9141c$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
const $c4d1e4fe5ea9141c$export$601b23e9cf369aed = (jsonLd)=>{
    if (jsonLd['atlassian:dateViewed']) return jsonLd['atlassian:dateViewed'];
    return undefined;
};
const $c4d1e4fe5ea9141c$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && $c4d1e4fe5ea9141c$export$67f3d92c824fd850(person.icon)
        };
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>$c4d1e4fe5ea9141c$export$c471ae5fddcf1392(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = $c4d1e4fe5ea9141c$export$c471ae5fddcf1392(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return $c4d1e4fe5ea9141c$export$c471ae5fddcf1392(assignedTo);
    return undefined;
};
const $c4d1e4fe5ea9141c$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map($c4d1e4fe5ea9141c$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $c4d1e4fe5ea9141c$export$c471ae5fddcf1392(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map($c4d1e4fe5ea9141c$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $c4d1e4fe5ea9141c$export$c471ae5fddcf1392(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return $c4d1e4fe5ea9141c$export$c471ae5fddcf1392(updatedBy);
    return undefined;
};
const $c4d1e4fe5ea9141c$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
const $c4d1e4fe5ea9141c$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = $c4d1e4fe5ea9141c$export$3e8ad908070b68b2(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: $c4d1e4fe5ea9141c$export$396ba4ef2e37dc65(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
const $c4d1e4fe5ea9141c$export$8beff7405d020ddf = (response)=>response?.entityData;
const $c4d1e4fe5ea9141c$export$c7168210b81d9383 = (response)=>Boolean($c4d1e4fe5ea9141c$export$8beff7405d020ddf(response));
const $c4d1e4fe5ea9141c$var$extractEntityEmbedUrl = (response)=>{
    const entity = $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $c4d1e4fe5ea9141c$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    if ((0, $egspI.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entityIcon = $c4d1e4fe5ea9141c$export$19346520e937a99f(response);
        if (entityIcon) return (0, $egspI.fg)('platform_sl_google_rebrand') ? (0, $cua4f.rebrandProvider)({
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        }) : {
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        };
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $1DtGB.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l5Fg2.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $egspI.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $1DtGB.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.JiraIcon), {
                appearance: "brand",
                ...(0, $egspI.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return (0, $egspI.fg)('platform_sl_google_rebrand') ? (0, $cua4f.rebrandProvider)({
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $egspI.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    }) : {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $egspI.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    };
};
const $c4d1e4fe5ea9141c$export$19346520e937a99f = (response)=>{
    if ((0, $egspI.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entity = $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response);
        if (!entity) return undefined;
        if (!(0, $gPjPG.isBaseEntity)(entity)) return undefined;
        if ((0, $gPjPG.isDesignEntity)(entity) && entity.iconUrl) return {
            url: entity.iconUrl,
            label: entity.type
        };
        if ((0, $gPjPG.isDocumentEntity)(entity) && entity.type.iconUrl) return {
            url: entity.type.iconUrl,
            label: entity.type.category
        };
        // When JSON-LD is deprecated, we can change this to returning entity provider icon.
        // For now code upstream will return better result when this method returns undefined.
        return undefined;
    } else {
        const entity = $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response);
        let url;
        if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
        return {
            url: url,
            label: entity?.displayName
        };
    }
};
const $c4d1e4fe5ea9141c$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) return $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response)?.displayName;
    return $c4d1e4fe5ea9141c$export$b05803156e5015b6(response?.data, removeTextHighlightingFromTitle);
};
const $c4d1e4fe5ea9141c$export$7ba9b12c6a1b73de = (response)=>{
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) return $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response)?.url;
    return $c4d1e4fe5ea9141c$export$63f54cf4c5883620(response?.data);
};
const $c4d1e4fe5ea9141c$export$16b02be3e2bb31ad = (response)=>{
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) return $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response)?.ari || $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response)?.thirdPartyAri;
    const data = response?.data;
    return $c4d1e4fe5ea9141c$export$be18a6294fd426ec(data);
};
const $c4d1e4fe5ea9141c$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $c4d1e4fe5ea9141c$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return $c4d1e4fe5ea9141c$export$4b0d98b1b7f6d115(response?.data, 'web', iframeUrlType);
};
const $c4d1e4fe5ea9141c$export$ff753ed519e96e9e = (response)=>{
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) return $c4d1e4fe5ea9141c$export$ad879f2c9d5100a0(response);
    return response?.data && $c4d1e4fe5ea9141c$export$a832871718466647(response?.data);
};
const $c4d1e4fe5ea9141c$export$7a685df468cbf38f = (response)=>{
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) return $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response)?.createdAt;
    return response?.data && $c4d1e4fe5ea9141c$export$e1226a5e0bbbf862(response.data);
};
const $c4d1e4fe5ea9141c$export$75047940e157fd1f = (response)=>{
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) return $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response)?.lastUpdatedAt;
    return response?.data && $c4d1e4fe5ea9141c$export$7fc2f5e6f9d22ae7(response.data);
};
const $c4d1e4fe5ea9141c$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) return $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response)?.createdBy?.displayName;
    const persons = $c4d1e4fe5ea9141c$export$a66235cba0c9d11a(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $c4d1e4fe5ea9141c$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) {
        const entity = $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return $c4d1e4fe5ea9141c$export$a66235cba0c9d11a(response.data);
};
const $c4d1e4fe5ea9141c$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) return $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response)?.lastUpdatedBy?.displayName;
    const person = $c4d1e4fe5ea9141c$export$8a2d1ed7e6f336f0(response.data);
    return person ? person.name : undefined;
};
const $c4d1e4fe5ea9141c$export$96ed4c1b14ac210a = (response)=>{
    if ($c4d1e4fe5ea9141c$export$c7168210b81d9383(response)) {
        const entity = $c4d1e4fe5ea9141c$export$8beff7405d020ddf(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};

});
parcelRegister("gPjPG", function(module, exports) {
$parcel$export(module.exports, "isBaseEntity", () => $040dca11356fc5d7$export$12af7c5462954d1e);
$parcel$export(module.exports, "isDesignEntity", () => $040dca11356fc5d7$export$8dc9be81b5b6266b);
$parcel$export(module.exports, "isDocumentEntity", () => $040dca11356fc5d7$export$32c06ee7e0e9b79e);
const $040dca11356fc5d7$var$DESIGN_TYPES = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $040dca11356fc5d7$var$DESIGN_STATUSES = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $040dca11356fc5d7$var$REMOTE_LINK_TYPES = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $040dca11356fc5d7$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $040dca11356fc5d7$var$WORK_ITEM_SUB_TYPES = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $040dca11356fc5d7$var$DOCUMENT_CATEGORIES = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $040dca11356fc5d7$var$isOneOf = (values, value)=>typeof value === 'string' && values.includes(value);
const $040dca11356fc5d7$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $040dca11356fc5d7$var$asRecord = (value)=>value;
const $040dca11356fc5d7$export$12af7c5462954d1e = (value)=>$040dca11356fc5d7$var$isObject(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';
const $040dca11356fc5d7$export$8dc9be81b5b6266b = (value)=>$040dca11356fc5d7$export$12af7c5462954d1e(value) && $040dca11356fc5d7$var$isOneOf($040dca11356fc5d7$var$DESIGN_STATUSES, $040dca11356fc5d7$var$asRecord(value).status) && $040dca11356fc5d7$var$isOneOf($040dca11356fc5d7$var$DESIGN_TYPES, $040dca11356fc5d7$var$asRecord(value).type);
const $040dca11356fc5d7$export$f16c4076686c1f5b = (value)=>{
    if (!$040dca11356fc5d7$export$12af7c5462954d1e(value)) return false;
    const entity = $040dca11356fc5d7$var$asRecord(value);
    const remoteLink = entity['atlassian:remote-link'];
    return $040dca11356fc5d7$var$isObject(remoteLink) && $040dca11356fc5d7$var$isOneOf($040dca11356fc5d7$var$REMOTE_LINK_TYPES, remoteLink.type);
};
const $040dca11356fc5d7$export$791f1b4852e2a184 = (value)=>$040dca11356fc5d7$export$12af7c5462954d1e(value) && $040dca11356fc5d7$var$isObject($040dca11356fc5d7$var$asRecord(value)['atlassian:project']);
const $040dca11356fc5d7$export$162dad7a1238d377 = (value)=>{
    if (!$040dca11356fc5d7$export$12af7c5462954d1e(value)) return false;
    const entity = $040dca11356fc5d7$var$asRecord(value);
    const workItem = entity['atlassian:work-item'];
    return $040dca11356fc5d7$var$isObject(workItem) && typeof workItem.status === 'string' && $040dca11356fc5d7$var$isOneOf($040dca11356fc5d7$var$WORK_ITEM_SUB_TYPES, workItem.subtype) && typeof workItem.team === 'string';
};
const $040dca11356fc5d7$export$32c06ee7e0e9b79e = (value)=>{
    if (!$040dca11356fc5d7$export$12af7c5462954d1e(value)) return false;
    const entityType = $040dca11356fc5d7$var$asRecord(value).type;
    return $040dca11356fc5d7$var$isObject(entityType) && (entityType.category === undefined || $040dca11356fc5d7$var$isOneOf($040dca11356fc5d7$var$DOCUMENT_CATEGORIES, entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ($040dca11356fc5d7$var$isOneOf($040dca11356fc5d7$var$DOCUMENT_CATEGORIES, entityType.category) || typeof entityType.iconUrl === 'string');
};
const $040dca11356fc5d7$export$33e8c1bbf9148b0e = (value)=>$040dca11356fc5d7$export$12af7c5462954d1e(value) && ('attachments' in value || 'commentCount' in value || 'hidden' in value || 'isPinned' in value || 'lastActive' in value || 'reactions' in value);
const $040dca11356fc5d7$export$6c20afe8743cb761 = (value)=>$040dca11356fc5d7$export$12af7c5462954d1e(value) && ('isArchived' in value || 'lastActive' in value || 'memberCount' in value || 'members' in value || 'membershipType' in value || 'topic' in value || 'workspace' in value);
const $040dca11356fc5d7$export$fe785532d894f833 = (value)=>$040dca11356fc5d7$export$12af7c5462954d1e(value) && !$040dca11356fc5d7$export$8dc9be81b5b6266b(value) && !$040dca11356fc5d7$export$f16c4076686c1f5b(value) && !$040dca11356fc5d7$export$791f1b4852e2a184(value) && !$040dca11356fc5d7$export$162dad7a1238d377(value) && !$040dca11356fc5d7$export$32c06ee7e0e9b79e(value) && !$040dca11356fc5d7$export$33e8c1bbf9148b0e(value) && !$040dca11356fc5d7$export$6c20afe8743cb761(value);
const $040dca11356fc5d7$export$47565ffe58e56845 = (value)=>$040dca11356fc5d7$export$12af7c5462954d1e(value) && ($040dca11356fc5d7$export$8dc9be81b5b6266b(value) || $040dca11356fc5d7$export$f16c4076686c1f5b(value) || $040dca11356fc5d7$export$791f1b4852e2a184(value) || $040dca11356fc5d7$export$162dad7a1238d377(value) || $040dca11356fc5d7$export$32c06ee7e0e9b79e(value) || $040dca11356fc5d7$export$33e8c1bbf9148b0e(value) || $040dca11356fc5d7$export$6c20afe8743cb761(value) || $040dca11356fc5d7$export$fe785532d894f833(value));

});

parcelRegister("l5Fg2", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $3c56e54f2820e137$export$68f3db7f6af48bcb);

var $61kjS = parcelRequire("61kjS");

var $aNy7U = parcelRequire("aNy7U");

var $4Hmjm = parcelRequire("4Hmjm");
const $3c56e54f2820e137$export$68f3db7f6af48bcb = (0, $aNy7U.createFeatureFlaggedComponent)((0, $4Hmjm.ConfluenceIcon), (0, $61kjS.ConfluenceIcon));

});

parcelRegister("cua4f", function(module, exports) {
$parcel$export(module.exports, "rebrandProvider", () => $fa5665b5bcd925fa$export$df1b15aebbcf717e);

var $egspI = parcelRequire("egspI");
const $fa5665b5bcd925fa$var$GOOGLE_DRIVE = 'Google Drive';
const $fa5665b5bcd925fa$export$df1b15aebbcf717e = (provider)=>{
    switch(provider?.text){
        case 'Google':
            return {
                ...provider,
                ...(0, $egspI.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: $fa5665b5bcd925fa$var$GOOGLE_DRIVE
                } : undefined,
                text: $fa5665b5bcd925fa$var$GOOGLE_DRIVE
            };
        default:
            return provider;
    }
};

});

parcelRegister("1DtGB", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $efe00f470a07960f$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $efe00f470a07960f$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $efe00f470a07960f$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $efe00f470a07960f$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $efe00f470a07960f$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $efe00f470a07960f$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $efe00f470a07960f$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $efe00f470a07960f$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $efe00f470a07960f$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $efe00f470a07960f$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $efe00f470a07960f$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $efe00f470a07960f$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "SmartLinkSize", () => $efe00f470a07960f$export$51f13ced115cbdae);
$parcel$export(module.exports, "IconType", () => $efe00f470a07960f$export$13ff1290a9e22e77);
const $efe00f470a07960f$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $efe00f470a07960f$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $efe00f470a07960f$export$84a73a0383f58180 = 'JiraTask';
const $efe00f470a07960f$export$c6c83963a9378a67 = 'JiraSubTask';
const $efe00f470a07960f$export$58af3c426c111a6d = 'JiraStory';
const $efe00f470a07960f$export$ac9898a63417219e = 'JiraBug';
const $efe00f470a07960f$export$54db5e3fb12e39cd = 'JiraEpic';
const $efe00f470a07960f$export$2f54a5a217202c85 = 'JiraIncident';
const $efe00f470a07960f$export$d097371052bfc411 = 'JiraServiceRequest';
const $efe00f470a07960f$export$efd9452ad16c6676 = 'JiraChange';
const $efe00f470a07960f$export$2e7e70abb5d81f67 = 'JiraProblem';
const $efe00f470a07960f$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $efe00f470a07960f$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $efe00f470a07960f$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});

});


parcelRegister("10jQT", function(module, exports) {
$parcel$export(module.exports, "cardReducer", () => $89903eda443f90b6$export$3c7c3113a97b6492);

var $7OyAf = parcelRequire("7OyAf");
var $eCo2D = parcelRequire("eCo2D");
const $89903eda443f90b6$var$isCardAction = (action)=>{
    return [
        (0, $7OyAf.ACTION_PENDING),
        (0, $7OyAf.ACTION_RESOLVING),
        (0, $7OyAf.ACTION_RESOLVED),
        (0, $7OyAf.ACTION_RELOADING),
        (0, $7OyAf.ACTION_ERROR),
        (0, $7OyAf.ACTION_ERROR_FALLBACK),
        (0, $7OyAf.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $89903eda443f90b6$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $eCo2D.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $89903eda443f90b6$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $7OyAf.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $7OyAf.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $7OyAf.ACTION_RESOLVED:
            return $89903eda443f90b6$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $7OyAf.ACTION_RELOADING:
            return $89903eda443f90b6$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $7OyAf.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $7OyAf.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $7OyAf.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $89903eda443f90b6$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$89903eda443f90b6$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $89903eda443f90b6$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("eCo2D", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $353f4e816e72998e$export$b70265791d2079d4);
const $353f4e816e72998e$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $353f4e816e72998e$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $353f4e816e72998e$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("4AmqH", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $8d8fe738b6d50113$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $8d8fe738b6d50113$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $8d8fe738b6d50113$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $8d8fe738b6d50113$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $8d8fe738b6d50113$export$2a29ca11e08dc129);
$parcel$export(module.exports, "default", () => $8d8fe738b6d50113$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

const $8d8fe738b6d50113$export$156b523e63b4f63a = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
function $8d8fe738b6d50113$export$e1d190b530cf0ee9() {
    const context = (0, $euxye.useContext)($8d8fe738b6d50113$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $8d8fe738b6d50113$export$10e9cca30e50f657 = ()=>$8d8fe738b6d50113$var$useContextMemoized($8d8fe738b6d50113$export$156b523e63b4f63a);
const $8d8fe738b6d50113$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $8d8fe738b6d50113$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$8d8fe738b6d50113$export$797e3658f090919c.displayName = "EditorSmartCardProviderValueGuard";
function $8d8fe738b6d50113$var$useContextMemoized(reactContext) {
    const value = (0, $euxye.useContext)(reactContext);
    const context = (0, $euxye.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $8d8fe738b6d50113$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $8d8fe738b6d50113$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
$8d8fe738b6d50113$export$2a29ca11e08dc129.displayName = "EditorSmartCardProvider";
var $8d8fe738b6d50113$export$2e2bcd8739ae039 = $8d8fe738b6d50113$export$156b523e63b4f63a;

});

parcelRegister("b3YHz", function(module, exports) {
$parcel$export(module.exports, "default", () => $81a9532454d40705$export$2e2bcd8739ae039);

var $4Vswo = parcelRequire("4Vswo");

var $6eCkI = parcelRequire("6eCkI");

var $470b4 = parcelRequire("470b4");

var $gIYPk = parcelRequire("gIYPk");
var $faWFN = parcelRequire("faWFN");
var $eCo2D = parcelRequire("eCo2D");
var $i7VPV = parcelRequire("i7VPV");

var $2isEU = parcelRequire("2isEU");

var $lN2R9 = parcelRequire("lN2R9");

var $gpG7K = parcelRequire("gpG7K");

var $egspI = parcelRequire("egspI");
const $81a9532454d40705$var$MAX_BATCH_SIZE = 50;
const $81a9532454d40705$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $81a9532454d40705$var$URL_RESPONSE_CACHE_SIZE = 100;
const $81a9532454d40705$export$d6a66073b5d79eb3 = new (0, $lN2R9.LRUMap)($81a9532454d40705$var$URL_RESPONSE_CACHE_SIZE);
class $81a9532454d40705$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($gpG7K)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $i7VPV.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $i7VPV.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $2isEU.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $i7VPV.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $i7VPV.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $2isEU.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $faWFN.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    /**
	 * Set custom headers to be sent with each request to the resolver.
	 *
	 * @param headers - Object containing headers to be sent with each request.
	 */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($470b4)))({
            limit: 1,
            interval: $81a9532454d40705$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($4Vswo)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $81a9532454d40705$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($470b4)))({
            limit: 1,
            interval: $81a9532454d40705$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($4Vswo)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $81a9532454d40705$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $gIYPk.InvalidUrlError)(error);
        }
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        const loader = this.getLoader(hostname);
        const isInlineOptEnabled = appearance !== undefined && (0, $egspI.fg)('platform_smartlink_inline_resolve_optimization');
        // Include appearance in cache key when feature flag is enabled and appearance is specified
        const cacheKey = isInlineOptEnabled ? `${url}|${appearance}` : url;
        let responsePromise;
        responsePromise = $81a9532454d40705$export$d6a66073b5d79eb3.get(cacheKey);
        if (!responsePromise || force) {
            if ((0, $egspI.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    // Pass appearance to ORS when feature flag is enabled
                    ...isInlineOptEnabled ? {
                        appearance: appearance
                    } : {}
                });
            } else responsePromise = loader.load(url);
            $81a9532454d40705$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $81a9532454d40705$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $2isEU.isSuccessfulResponse)(response) || (0, $eCo2D.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $81a9532454d40705$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $2isEU.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($6eCkI)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $2isEU.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $2isEU.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
	 * Fetch data from URL
	 * @param url - The URL to fetch data for
	 * @param force - Whether to force a fresh fetch, bypassing cache
	 * @param appearance - Card appearance hint for ORS to optimize response payload.
	 *                     When 'inline', ORS returns minimal data (title, status).
	 *                     When 'block' or 'embed', ORS returns full data including summary.
	 */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($6eCkI)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $2isEU.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $i7VPV.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $i7VPV.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $2isEU.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $i7VPV.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $gIYPk.NetworkError)) return new (0, $gIYPk.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $gIYPk.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $gIYPk.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $gIYPk.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $gIYPk.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $gIYPk.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("4Vswo", function(module, exports) {

var $gIMgJ = parcelRequire("gIMgJ");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $39629c1402a24fc0$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $39629c1402a24fc0$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $39629c1402a24fc0$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $39629c1402a24fc0$var$getValidCacheKeyFn(options);
        this._cacheMap = $39629c1402a24fc0$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $39629c1402a24fc0$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $39629c1402a24fc0$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$39629c1402a24fc0$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $39629c1402a24fc0$var$enqueuePostPromiseJob = typeof $gIMgJ === 'object' && typeof $gIMgJ.nextTick === 'function' ? function(fn) {
    if (!$39629c1402a24fc0$var$resolvedPromise) $39629c1402a24fc0$var$resolvedPromise = Promise.resolve();
    $39629c1402a24fc0$var$resolvedPromise.then(function() {
        $gIMgJ.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $39629c1402a24fc0$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $39629c1402a24fc0$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $39629c1402a24fc0$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $39629c1402a24fc0$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $39629c1402a24fc0$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $39629c1402a24fc0$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $39629c1402a24fc0$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$39629c1402a24fc0$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $39629c1402a24fc0$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $39629c1402a24fc0$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $39629c1402a24fc0$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $39629c1402a24fc0$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $39629c1402a24fc0$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $39629c1402a24fc0$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $39629c1402a24fc0$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $39629c1402a24fc0$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $39629c1402a24fc0$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $39629c1402a24fc0$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $39629c1402a24fc0$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $39629c1402a24fc0$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $39629c1402a24fc0$var$DataLoader;

});

parcelRegister("6eCkI", function(module, exports) {
// Packages

var $9pQTq = parcelRequire("9pQTq");
function $48a1c9081173767c$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $9pQTq.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $48a1c9081173767c$var$retry;

});
parcelRegister("9pQTq", function(module, exports) {

module.exports = (parcelRequire("9c0wB"));

});
parcelRegister("9c0wB", function(module, exports) {

var $93sN8 = parcelRequire("93sN8");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $93sN8(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("93sN8", function(module, exports) {
function $697aba46fa8f6c98$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $697aba46fa8f6c98$var$RetryOperation;
$697aba46fa8f6c98$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$697aba46fa8f6c98$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$697aba46fa8f6c98$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$697aba46fa8f6c98$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$697aba46fa8f6c98$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$697aba46fa8f6c98$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$697aba46fa8f6c98$var$RetryOperation.prototype.start = $697aba46fa8f6c98$var$RetryOperation.prototype.try;
$697aba46fa8f6c98$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$697aba46fa8f6c98$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$697aba46fa8f6c98$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("470b4", function(module, exports) {
'use strict';
class $2fe7f4221e31e063$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $2fe7f4221e31e063$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $2fe7f4221e31e063$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $2fe7f4221e31e063$var$pThrottle;
module.exports.AbortError = $2fe7f4221e31e063$var$AbortError;

});

parcelRegister("faWFN", function(module, exports) {
$parcel$export(module.exports, "getBaseUrl", () => $9d80b1884648bde9$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $9d80b1884648bde9$export$dc37652c1696f231);
const $9d80b1884648bde9$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $9d80b1884648bde9$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $9d80b1884648bde9$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $9d80b1884648bde9$export$e2b040f052407032 = {
    dev: $9d80b1884648bde9$var$devBaseUrl,
    development: $9d80b1884648bde9$var$devBaseUrl,
    stg: $9d80b1884648bde9$var$stgBaseUrl,
    staging: $9d80b1884648bde9$var$stgBaseUrl,
    prd: $9d80b1884648bde9$var$prodBaseUrl,
    prod: $9d80b1884648bde9$var$prodBaseUrl,
    production: $9d80b1884648bde9$var$prodBaseUrl
};
const $9d80b1884648bde9$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $9d80b1884648bde9$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $9d80b1884648bde9$export$e2b040f052407032 ? $9d80b1884648bde9$export$e2b040f052407032[envKey] : $9d80b1884648bde9$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $9d80b1884648bde9$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $9d80b1884648bde9$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $9d80b1884648bde9$export$2e2bcd8739ae039 = $9d80b1884648bde9$export$e2b040f052407032;

});

parcelRegister("i7VPV", function(module, exports) {
$parcel$export(module.exports, "request", () => $82c1dd23813f80d8$export$b5fe3f66a567bec0);

var $gIYPk = parcelRequire("gIYPk");
const $82c1dd23813f80d8$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $82c1dd23813f80d8$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $82c1dd23813f80d8$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $gIYPk.NetworkError)(error);
        throw error;
    }
}

});

parcelRegister("2isEU", function(module, exports) {
$parcel$export(module.exports, "isSuccessfulResponse", () => $448540df41bc6e15$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $448540df41bc6e15$export$bea7bee8a87e7c52);
const $448540df41bc6e15$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $448540df41bc6e15$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("lN2R9", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("jc8Oy", function(module, exports) {
$parcel$export(module.exports, "useGlobalObjectPreviewPanels", () => $440dcd3ccdc3c32d$export$70bcacea0b970dee);
/**
 * useGlobalObjectPreviewPanels — lightweight hook for opening/closing
 * Jira preview panels from any component.
 *
 * Imports only from JiraPreviewPanelsContext.tsx (no heavy transitive deps).
 * Hook consumers can import from this file instead of PreviewPanelsProvider.tsx
 * to avoid pulling in the @atlassian/preview-panel-global-objects subtree.
 */ 
var $euxye = parcelRequire("euxye");

var $52FsB = parcelRequire("52FsB");
const $440dcd3ccdc3c32d$var$parentProduct = 'jira-software';
const $440dcd3ccdc3c32d$export$70bcacea0b970dee = ()=>{
    const context = (0, $euxye.useContext)((0, $52FsB.JiraPreviewPanelsContext));
    if (!context) throw new Error('useGlobalObjectPreviewPanels must be used within a PreviewPanelsProvider');
    const { openPreviewPanel: openGlobalPreviewPanel, isPreviewPanelAvailable: isPreviewPanelAvailable } = context;
    const openPreviewPanel = (0, $euxye.useCallback)((props)=>{
        openGlobalPreviewPanel({
            ...props,
            parentProduct: $440dcd3ccdc3c32d$var$parentProduct
        });
    }, [
        openGlobalPreviewPanel
    ]);
    return {
        openPreviewPanel: openPreviewPanel,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        closePreviewPanel: context.closePreviewPanel
    };
};

});

parcelRegister("6xQiM", function(module, exports) {
$parcel$export(module.exports, "getCorrectContentURL", () => $20fe0d8a3b3ca045$export$193bb0d0d16ee7a7);

var $757GM = parcelRequire("757GM");
const $20fe0d8a3b3ca045$var$ATLASSIAN_DOMAINS = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $20fe0d8a3b3ca045$export$97f4c254b641e719 = (hostname)=>!$20fe0d8a3b3ca045$var$ATLASSIAN_DOMAINS.some((domain)=>hostname.endsWith(domain));
const $20fe0d8a3b3ca045$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};
const $20fe0d8a3b3ca045$export$280e79c794cf814e = (url)=>$20fe0d8a3b3ca045$var$isValidUrl(url) ? new URL(url)?.hostname : '';
const $20fe0d8a3b3ca045$export$33c8f371dcc1b989 = (ari)=>{
    if (!ari || typeof ari !== 'string') return null;
    try {
        const parsedAri = (0, $757GM.ConfluencePageAri).parse(ari);
        return parsedAri && parsedAri.cloudId ? parsedAri.cloudId : null;
    } catch (err) {
        return null;
    }
};
const $20fe0d8a3b3ca045$export$193bb0d0d16ee7a7 = (parentCloudId, url, ari)=>{
    const parentHost = $20fe0d8a3b3ca045$export$280e79c794cf814e(window?.location?.href) || '';
    const contentHost = $20fe0d8a3b3ca045$export$280e79c794cf814e(url);
    if (parentHost === contentHost) return url;
    const cloudId = $20fe0d8a3b3ca045$export$33c8f371dcc1b989(ari);
    if (!cloudId || !parentCloudId || parentCloudId !== cloudId || !$20fe0d8a3b3ca045$export$97f4c254b641e719(parentHost)) return url;
    // Swap the URL hostname to use the parent's hostname
    try {
        const urlObj = new URL(url);
        urlObj.hostname = parentHost;
        return urlObj.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        return url;
    }
};

});
parcelRegister("757GM", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAri", () => $527ef6eb87a459ff$export$3f931dd15d96caff);

var $1xcrd = parcelRequire("1xcrd");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/confluence/page/manifest.ts
var $527ef6eb87a459ff$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1xcrd.ConfluencePageAriResourceOwner),
    resourceType: (0, $1xcrd.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $527ef6eb87a459ff$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $527ef6eb87a459ff$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $527ef6eb87a459ff$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $527ef6eb87a459ff$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $527ef6eb87a459ff$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $527ef6eb87a459ff$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $527ef6eb87a459ff$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("1xcrd", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAriResourceOwner", () => $11e2857451d7b1cd$export$da53e4f7db4c6a71);
$parcel$export(module.exports, "ConfluencePageAriResourceType", () => $11e2857451d7b1cd$export$636fc622562a2c5b);
// src/confluence/page/types.ts
var $11e2857451d7b1cd$export$da53e4f7db4c6a71 = "confluence", $11e2857451d7b1cd$export$636fc622562a2c5b = "page";

});



parcelRegister("gJ83e", function(module, exports) {
$parcel$export(module.exports, "SyncJiraSnippetRenderer", () => $c371ca45146cab12$export$93c5487484c8640c);

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $l1vE2 = parcelRequire("l1vE2");

var $7vMl7 = parcelRequire("7vMl7");
const $c371ca45146cab12$export$93c5487484c8640c = (props)=>{
    const runtimeProps = (0, $euxye.useMemo)(()=>({
            contentId: props.contentId,
            contentType: props.contentType,
            cloudId: props.cloudId,
            fallbackText: props.fallbackText,
            fallbackComponent: props.fallbackComponent,
            isHidden: props.isHidden,
            maxLines: props.maxLines,
            showFooter: props.showFooter
        }), [
        props.contentId,
        props.contentType,
        props.cloudId,
        props.fallbackText,
        props.fallbackComponent,
        props.isHidden,
        props.maxLines,
        props.showFooter
    ]);
    if ((0, $l1vE2.isFedRamp)() || !(0, $2700E.expVal)('jira-cc-ai-snippet-experiment', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7vMl7.AISnippet), runtimeProps);
};
$c371ca45146cab12$export$93c5487484c8640c.displayName = "SyncJiraSnippetRenderer";
var $c371ca45146cab12$export$2e2bcd8739ae039 = $c371ca45146cab12$export$93c5487484c8640c;

});
parcelRegister("7vMl7", function(module, exports) {
$parcel$export(module.exports, "AISnippet", () => $94a79eb57d955169$export$1b2af18ca4bb327b);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $26DNu = parcelRequire("26DNu");

var $n67Vb = parcelRequire("n67Vb");

var $1MNmN = parcelRequire("1MNmN");

var $4LDqh = parcelRequire("4LDqh");

var $6xxcW = parcelRequire("6xxcW");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");

var $6u2Sn = parcelRequire("6u2Sn");
var $iK8G7 = parcelRequire("iK8G7");

var $9uVUk = parcelRequire("9uVUk");
var $hIym3 = parcelRequire("hIym3");

var $cxpqA = parcelRequire("cxpqA");

var $ipvkO = parcelRequire("ipvkO");
var $9ImnN = parcelRequire("9ImnN");

var $34Jk9 = parcelRequire("34Jk9");

var $61Cev = parcelRequire("61Cev");

var $gVvPO = parcelRequire("gVvPO");
const $94a79eb57d955169$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $94a79eb57d955169$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $94a79eb57d955169$var$DEFAULT_MAX_LINES = 4;
const $94a79eb57d955169$var$styles = {
    container: "_11c8wadc"
};
const $94a79eb57d955169$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $94a79eb57d955169$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $94a79eb57d955169$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    });
const $94a79eb57d955169$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6u2Sn.AIEventsInstrumentationProvider), {
        config: $94a79eb57d955169$var$getAnalyticsConfig(props),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($94a79eb57d955169$export$ac90160f7ae1e32f, {
            ...props
        })
    });
};
$94a79eb57d955169$export$1b2af18ca4bb327b.displayName = "AISnippet";
const $94a79eb57d955169$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $94a79eb57d955169$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $n67Vb.useQueryLoader)((0, $gVvPO.default));
    const isLoadingRef = (0, $euxye.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $iK8G7.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $9ImnN.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $ipvkO.ExperienceTypes).Load,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $94a79eb57d955169$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $egspI.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $4LDqh.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $euxye.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        };
    // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $euxye.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $26DNu.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $34Jk9.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        },
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
            xcss: (0, $1MNmN.cx)($94a79eb57d955169$var$styles.container),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hIym3.AIStreamLoading), {}),
                children: queryRef ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $61Cev.AISnippetLoader), {
                    queryRef: queryRef,
                    fallbackText: fallbackText,
                    contentId: contentId,
                    source: source,
                    isHidden: isHidden,
                    maxLines: maxLines,
                    showFooter: showFooter,
                    showAwareness: showAwareness
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hIym3.AIStreamLoading), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6xxcW.FlagsProvider), {
        children: isEnabledForJira ? content : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9uVUk.AIFeedbackPropertiesProvider), {
            entrypointId: $94a79eb57d955169$var$SNIPPET_ENTRYPOINT_ID,
            userId: userId,
            displayName: displayName,
            children: content
        })
    });
};
$94a79eb57d955169$export$ac90160f7ae1e32f.displayName = "AISnippetWithAnalytics";
const $94a79eb57d955169$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxpqA.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($94a79eb57d955169$export$1b2af18ca4bb327b, {
            ...props
        })
    });
};
$94a79eb57d955169$export$c9a07cebec67e951.displayName = "AISnippetWithRelayEnvironment";

});
parcelRegister("26DNu", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("euxye")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("6u2Sn", function(module, exports) {
$parcel$export(module.exports, "AIEventsInstrumentationProvider", () => $bf9477edad85277c$export$b5d4bc85dfbaa4f8);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $6TBsE = parcelRequire("6TBsE");

var $dadCo = parcelRequire("dadCo");

var $bLGtO = parcelRequire("bLGtO");
const $bf9477edad85277c$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $bf9477edad85277c$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $bLGtO.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $euxye.useMemo)(()=>{
        $bf9477edad85277c$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $dadCo.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6TBsE.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
$bf9477edad85277c$export$b5d4bc85dfbaa4f8.displayName = "AIEventsInstrumentationProvider";

});

parcelRegister("9uVUk", function(module, exports) {
$parcel$export(module.exports, "AIFeedbackPropertiesProvider", () => $bf554ecf530b3587$export$e9e654940dee103b);
$parcel$export(module.exports, "useAIFeedbackProperties", () => $bf554ecf530b3587$export$ff3deb4415ee32e3);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");
const $bf554ecf530b3587$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $bf554ecf530b3587$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $bf554ecf530b3587$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $bf554ecf530b3587$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $1YIbA.default)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $euxye.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($bf554ecf530b3587$export$f906c21bacdb2d8e.Provider, {
        value: contextValue,
        children: children
    });
};
$bf554ecf530b3587$export$e9e654940dee103b.displayName = "AIFeedbackPropertiesProvider";
const $bf554ecf530b3587$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $euxye.useContext)($bf554ecf530b3587$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};

});

parcelRegister("hIym3", function(module, exports) {
$parcel$export(module.exports, "AIStreamLoading", () => $c63f65628be26286$export$47a62cbf3ee79fef);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $c69sa = parcelRequire("c69sa");
var $2BUXh = parcelRequire("2BUXh");
var $fbAgj = parcelRequire("fbAgj");

var $gmLFD = parcelRequire("gmLFD");
const $c63f65628be26286$var$styles = (0, $fbAgj.xcss)({
    color: 'color.text.subtle'
});
const $c63f65628be26286$var$i18n = (0, $7eNDO.defineMessages)({
    generatingSummaryText: {
        id: 'ai-stream-loading.title',
        defaultMessage: 'AI is working...',
        description: 'Text for loading state of streaming'
    },
    generatingSummaryAnimationAlt: {
        id: 'ai-stream-loading.generation-animation',
        defaultMessage: 'Generating',
        description: 'Alt text of the generation animation'
    }
});
const $c63f65628be26286$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const title = titleMessage ?? $c63f65628be26286$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.default), {
        padding: padding,
        xcss: $c63f65628be26286$var$styles,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2BUXh.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gmLFD.GeneratingStreamAnimation), {
                    alt: formatMessage($c63f65628be26286$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                    ...title
                })
            ]
        })
    });
};
$c63f65628be26286$export$47a62cbf3ee79fef.displayName = "AIStreamLoading";

});
parcelRegister("gmLFD", function(module, exports) {
$parcel$export(module.exports, "GeneratingStreamAnimation", () => $fcdcfa0a24d6cdb7$export$3709887a1be0e305);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");
const $fcdcfa0a24d6cdb7$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
$fcdcfa0a24d6cdb7$export$3709887a1be0e305.displayName = "GeneratingStreamAnimation";

});


parcelRegister("9ImnN", function(module, exports) {
$parcel$export(module.exports, "useUFOExperience", () => $2e1879a22f7cbdc9$export$fade2d05a6320d49);
/* eslint-disable perfectionist/sort-object-types */ 
var $euxye = parcelRequire("euxye");

var $jkqqC = parcelRequire("jkqqC");
const $2e1879a22f7cbdc9$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $euxye.useRef)(new (0, $jkqqC.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $euxye.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $euxye.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $euxye.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $euxye.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $euxye.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $euxye.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $euxye.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $euxye.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});

parcelRegister("34Jk9", function(module, exports) {
$parcel$export(module.exports, "AISnippetContent", () => $540e8e442d99d332$export$3cf37822a11d3ff3);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $cjRbH = parcelRequire("cjRbH");

var $4LDqh = parcelRequire("4LDqh");

var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $iK8G7 = parcelRequire("iK8G7");

var $kauLH = parcelRequire("kauLH");
var $5vjTI = parcelRequire("5vjTI");
var $6se8o = parcelRequire("6se8o");

var $dHnrU = parcelRequire("dHnrU");
const $540e8e442d99d332$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $540e8e442d99d332$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $540e8e442d99d332$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $euxye.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $dHnrU.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $iK8G7.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $euxye.useRef)(text);
    const isExperimentEnabled = (0, $4LDqh.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $4LDqh.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $euxye.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $euxye.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $euxye.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $540e8e442d99d332$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
        space: "space.100",
        ref: ref,
        children: [
            showAwareness && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kauLH.AIAwareness), {}),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                size: "small",
                maxLines: maxLines,
                children: renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cjRbH.default), {
                    options: {
                        disableParsingRawHTML: true
                    },
                    children: $540e8e442d99d332$var$sanitizeMarkdown(text || '')
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cjRbH.default), {
                    children: text || ''
                }) : text || ''
            }),
            showFooter && text && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5vjTI.AIDisclaimer), {}),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6se8o.AIFeedbackComponent), {
                        contentId: contentId,
                        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
                        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
                    })
                ]
            })
        ]
    });
};
$540e8e442d99d332$export$3cf37822a11d3ff3.displayName = "AISnippetContent";

});
parcelRegister("cjRbH", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f80845d297d4a59$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $8f80845d297d4a59$var$t() {
    return $8f80845d297d4a59$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $8f80845d297d4a59$var$t.apply(this, arguments);
}
const $8f80845d297d4a59$var$n = [
    "children",
    "options"
], $8f80845d297d4a59$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $8f80845d297d4a59$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($8f80845d297d4a59$var$i || ($8f80845d297d4a59$var$i = {}));
const $8f80845d297d4a59$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $8f80845d297d4a59$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $8f80845d297d4a59$var$o = [
    "style",
    "script"
], $8f80845d297d4a59$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $8f80845d297d4a59$var$s = /mailto:/i, $8f80845d297d4a59$var$d = /\n{2,}$/, $8f80845d297d4a59$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $8f80845d297d4a59$var$u = /^ *> ?/gm, $8f80845d297d4a59$var$f = /^ {2,}\n/, $8f80845d297d4a59$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $8f80845d297d4a59$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $8f80845d297d4a59$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $8f80845d297d4a59$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $8f80845d297d4a59$var$k = /^(?:\n *)*\n/, $8f80845d297d4a59$var$x = /\r\n?/g, $8f80845d297d4a59$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $8f80845d297d4a59$var$v = /^\[\^([^\]]+)]/, $8f80845d297d4a59$var$S = /\f/g, $8f80845d297d4a59$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $8f80845d297d4a59$var$C = /^\s*?\[(x|\s)\]/, $8f80845d297d4a59$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $8f80845d297d4a59$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $8f80845d297d4a59$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $8f80845d297d4a59$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $8f80845d297d4a59$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $8f80845d297d4a59$var$T = /^<!--[\s\S]*?(?:-->)/, $8f80845d297d4a59$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $8f80845d297d4a59$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $8f80845d297d4a59$var$M = /^\{.*\}$/, $8f80845d297d4a59$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $8f80845d297d4a59$var$I = /^<([^ >]+@[^ >]+)>/, $8f80845d297d4a59$var$U = /^<([^ >]+:\/[^ >]+)>/, $8f80845d297d4a59$var$D = /-([a-z])?/gi, $8f80845d297d4a59$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $8f80845d297d4a59$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $8f80845d297d4a59$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $8f80845d297d4a59$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $8f80845d297d4a59$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $8f80845d297d4a59$var$_ = /\t/g, $8f80845d297d4a59$var$G = /(^ *\||\| *$)/g, $8f80845d297d4a59$var$W = /^ *:-+: *$/, $8f80845d297d4a59$var$Z = /^ *:-+ *$/, $8f80845d297d4a59$var$q = /^ *-+: *$/, $8f80845d297d4a59$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $8f80845d297d4a59$var$V = new RegExp(`^([*_])\\1${$8f80845d297d4a59$var$Q}\\1\\1(?!\\1)`), $8f80845d297d4a59$var$X = new RegExp(`^([*_])${$8f80845d297d4a59$var$Q}\\1(?!\\1|\\w)`), $8f80845d297d4a59$var$J = new RegExp(`^==${$8f80845d297d4a59$var$Q}==`), $8f80845d297d4a59$var$K = new RegExp(`^~~${$8f80845d297d4a59$var$Q}~~`), $8f80845d297d4a59$var$Y = /^\\([^0-9A-Za-z\s])/, $8f80845d297d4a59$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $8f80845d297d4a59$var$te = /^\n+/, $8f80845d297d4a59$var$ne = /^([ \t]*)/, $8f80845d297d4a59$var$re = /\\([^\\])/g, $8f80845d297d4a59$var$ie = / *\n+$/, $8f80845d297d4a59$var$le = /(?:^|\n)( *)$/, $8f80845d297d4a59$var$ae = "(?:\\d+\\.)", $8f80845d297d4a59$var$oe = "(?:[*+-])";
function $8f80845d297d4a59$var$ce(e) {
    return "( *)(" + (1 === e ? $8f80845d297d4a59$var$ae : $8f80845d297d4a59$var$oe) + ") +";
}
const $8f80845d297d4a59$var$se = $8f80845d297d4a59$var$ce(1), $8f80845d297d4a59$var$de = $8f80845d297d4a59$var$ce(2);
function $8f80845d297d4a59$var$pe(e) {
    return new RegExp("^" + (1 === e ? $8f80845d297d4a59$var$se : $8f80845d297d4a59$var$de));
}
const $8f80845d297d4a59$var$ue = $8f80845d297d4a59$var$pe(1), $8f80845d297d4a59$var$fe = $8f80845d297d4a59$var$pe(2);
function $8f80845d297d4a59$var$he(e) {
    return new RegExp("^" + (1 === e ? $8f80845d297d4a59$var$se : $8f80845d297d4a59$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $8f80845d297d4a59$var$ae : $8f80845d297d4a59$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $8f80845d297d4a59$var$me = $8f80845d297d4a59$var$he(1), $8f80845d297d4a59$var$ge = $8f80845d297d4a59$var$he(2);
function $8f80845d297d4a59$var$ye(e) {
    const t = 1 === e ? $8f80845d297d4a59$var$ae : $8f80845d297d4a59$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $8f80845d297d4a59$var$ke = $8f80845d297d4a59$var$ye(1), $8f80845d297d4a59$var$xe = $8f80845d297d4a59$var$ye(2);
function $8f80845d297d4a59$var$be(e, t) {
    const n = 1 === t, i = n ? $8f80845d297d4a59$var$ke : $8f80845d297d4a59$var$xe, l = n ? $8f80845d297d4a59$var$me : $8f80845d297d4a59$var$ge, a = n ? $8f80845d297d4a59$var$ue : $8f80845d297d4a59$var$fe;
    return {
        match (e, t) {
            const n = $8f80845d297d4a59$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($8f80845d297d4a59$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($8f80845d297d4a59$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($8f80845d297d4a59$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $8f80845d297d4a59$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $8f80845d297d4a59$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $8f80845d297d4a59$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $8f80845d297d4a59$var$Ee = [
    $8f80845d297d4a59$var$p,
    $8f80845d297d4a59$var$m,
    $8f80845d297d4a59$var$g,
    $8f80845d297d4a59$var$$,
    $8f80845d297d4a59$var$z,
    $8f80845d297d4a59$var$w,
    $8f80845d297d4a59$var$T,
    $8f80845d297d4a59$var$j,
    $8f80845d297d4a59$var$me,
    $8f80845d297d4a59$var$ke,
    $8f80845d297d4a59$var$ge,
    $8f80845d297d4a59$var$xe
], $8f80845d297d4a59$var$Ce = [
    ...$8f80845d297d4a59$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $8f80845d297d4a59$var$L,
    $8f80845d297d4a59$var$B
];
function $8f80845d297d4a59$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $8f80845d297d4a59$var$we(e) {
    return $8f80845d297d4a59$var$q.test(e) ? "right" : $8f80845d297d4a59$var$W.test(e) ? "center" : $8f80845d297d4a59$var$Z.test(e) ? "left" : null;
}
function $8f80845d297d4a59$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $8f80845d297d4a59$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $8f80845d297d4a59$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $8f80845d297d4a59$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $8f80845d297d4a59$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $8f80845d297d4a59$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $8f80845d297d4a59$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($8f80845d297d4a59$var$G, "").split("|").map($8f80845d297d4a59$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $8f80845d297d4a59$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $8f80845d297d4a59$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $8f80845d297d4a59$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $8f80845d297d4a59$export$e0aa44767d8750d5.paragraph
    };
}
function $8f80845d297d4a59$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $8f80845d297d4a59$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $8f80845d297d4a59$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $8f80845d297d4a59$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $8f80845d297d4a59$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $8f80845d297d4a59$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$8f80845d297d4a59$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $8f80845d297d4a59$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $8f80845d297d4a59$var$Ue(e) {
    return e.replace($8f80845d297d4a59$var$re, "$1");
}
function $8f80845d297d4a59$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $8f80845d297d4a59$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $8f80845d297d4a59$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $8f80845d297d4a59$var$He = (e, t, n)=>({
        children: $8f80845d297d4a59$var$De(t, e[1], n)
    });
function $8f80845d297d4a59$var$Fe() {
    return {};
}
function $8f80845d297d4a59$var$Pe() {
    return null;
}
function $8f80845d297d4a59$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $8f80845d297d4a59$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $8f80845d297d4a59$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $8f80845d297d4a59$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $8f80845d297d4a59$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $8f80845d297d4a59$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $8f80845d297d4a59$var$t({}, n, l, {
            className: $8f80845d297d4a59$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($8f80845d297d4a59$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $8f80845d297d4a59$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($8f80845d297d4a59$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $euxye.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($8f80845d297d4a59$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($8f80845d297d4a59$var$O) && (e = e.replace($8f80845d297d4a59$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $8f80845d297d4a59$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($8f80845d297d4a59$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($8f80845d297d4a59$var$L.test(p) || $8f80845d297d4a59$var$B.test(p)) && (n[d] = $euxye.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$8f80845d297d4a59$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $8f80845d297d4a59$export$3e2338ea76b578c9, i.slugify = i.slugify || $8f80845d297d4a59$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $8f80845d297d4a59$var$t({}, $8f80845d297d4a59$var$a, i.namedCodesToUnicode) : $8f80845d297d4a59$var$a, i.createElement = i.createElement || $euxye.createElement;
    const Z = [], q = {}, Q = {
        [$8f80845d297d4a59$export$e0aa44767d8750d5.blockQuote]: {
            match: $8f80845d297d4a59$var$Be($8f80845d297d4a59$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($8f80845d297d4a59$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.breakLine]: {
            match: $8f80845d297d4a59$var$Me($8f80845d297d4a59$var$f),
            order: 1,
            parse: $8f80845d297d4a59$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.breakThematic]: {
            match: $8f80845d297d4a59$var$Be($8f80845d297d4a59$var$h),
            order: 1,
            parse: $8f80845d297d4a59$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.codeBlock]: {
            match: $8f80845d297d4a59$var$Be($8f80845d297d4a59$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $8f80845d297d4a59$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.codeFenced]: {
            match: $8f80845d297d4a59$var$Be($8f80845d297d4a59$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $8f80845d297d4a59$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.codeInline]: {
            match: $8f80845d297d4a59$var$Oe($8f80845d297d4a59$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.footnote]: {
            match: $8f80845d297d4a59$var$Be($8f80845d297d4a59$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $8f80845d297d4a59$var$Pe
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.footnoteReference]: {
            match: $8f80845d297d4a59$var$Te($8f80845d297d4a59$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $8f80845d297d4a59$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.gfmTask]: {
            match: $8f80845d297d4a59$var$Te($8f80845d297d4a59$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.heading]: {
            match: $8f80845d297d4a59$var$Be(i.enforceAtxHeadings ? $8f80845d297d4a59$var$w : $8f80845d297d4a59$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $8f80845d297d4a59$var$De(t, e[2], n),
                    id: i.slugify(e[2], $8f80845d297d4a59$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.headingSetext]: {
            match: $8f80845d297d4a59$var$Be($8f80845d297d4a59$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $8f80845d297d4a59$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $8f80845d297d4a59$export$e0aa44767d8750d5.heading
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.htmlBlock]: {
            match: $8f80845d297d4a59$var$Me($8f80845d297d4a59$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($8f80845d297d4a59$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $8f80845d297d4a59$var$Ce.some((e)=>e.test(c)) ? $8f80845d297d4a59$var$Ne : $8f80845d297d4a59$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $8f80845d297d4a59$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $8f80845d297d4a59$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $8f80845d297d4a59$var$Me($8f80845d297d4a59$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $8f80845d297d4a59$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.htmlComment]: {
            match: $8f80845d297d4a59$var$Me($8f80845d297d4a59$var$T),
            order: 1,
            parse: ()=>({}),
            render: $8f80845d297d4a59$var$Pe
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.image]: {
            match: $8f80845d297d4a59$var$Oe($8f80845d297d4a59$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $8f80845d297d4a59$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.link]: {
            match: $8f80845d297d4a59$var$Te($8f80845d297d4a59$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $8f80845d297d4a59$var$je(t, e[1], n),
                    target: $8f80845d297d4a59$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $8f80845d297d4a59$var$Te($8f80845d297d4a59$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $8f80845d297d4a59$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $8f80845d297d4a59$export$e0aa44767d8750d5.link
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $8f80845d297d4a59$var$Te($8f80845d297d4a59$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $8f80845d297d4a59$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $8f80845d297d4a59$export$e0aa44767d8750d5.link
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $8f80845d297d4a59$var$Te($8f80845d297d4a59$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $8f80845d297d4a59$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $8f80845d297d4a59$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $8f80845d297d4a59$export$e0aa44767d8750d5.link
                };
            }
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.orderedList]: $8f80845d297d4a59$var$be(d, 1),
        [$8f80845d297d4a59$export$e0aa44767d8750d5.unorderedList]: $8f80845d297d4a59$var$be(d, 2),
        [$8f80845d297d4a59$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $8f80845d297d4a59$var$Be($8f80845d297d4a59$var$k),
            order: 3,
            parse: $8f80845d297d4a59$var$Fe,
            render: ()=>"\n"
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.paragraph]: {
            match: $8f80845d297d4a59$var$Re,
            order: 3,
            parse: $8f80845d297d4a59$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.ref]: {
            match: $8f80845d297d4a59$var$Te($8f80845d297d4a59$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $8f80845d297d4a59$var$Pe
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.refImage]: {
            match: $8f80845d297d4a59$var$Oe($8f80845d297d4a59$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.refLink]: {
            match: $8f80845d297d4a59$var$Te($8f80845d297d4a59$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.table]: {
            match: $8f80845d297d4a59$var$Be($8f80845d297d4a59$var$j),
            order: 1,
            parse: $8f80845d297d4a59$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $8f80845d297d4a59$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $8f80845d297d4a59$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.text]: {
            match: $8f80845d297d4a59$var$Me($8f80845d297d4a59$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($8f80845d297d4a59$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.textBolded]: {
            match: $8f80845d297d4a59$var$Oe($8f80845d297d4a59$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.textEmphasized]: {
            match: $8f80845d297d4a59$var$Oe($8f80845d297d4a59$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.textEscaped]: {
            match: $8f80845d297d4a59$var$Oe($8f80845d297d4a59$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $8f80845d297d4a59$export$e0aa44767d8750d5.text
                })
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.textMarked]: {
            match: $8f80845d297d4a59$var$Oe($8f80845d297d4a59$var$J),
            order: 3,
            parse: $8f80845d297d4a59$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$8f80845d297d4a59$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $8f80845d297d4a59$var$Oe($8f80845d297d4a59$var$K),
            order: 3,
            parse: $8f80845d297d4a59$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$8f80845d297d4a59$export$e0aa44767d8750d5.htmlBlock], delete Q[$8f80845d297d4a59$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($8f80845d297d4a59$var$x, "\n").replace($8f80845d297d4a59$var$S, "").replace($8f80845d297d4a59$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $8f80845d297d4a59$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $8f80845d297d4a59$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $8f80845d297d4a59$var$n);
    return $euxye.cloneElement($8f80845d297d4a59$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("kauLH", function(module, exports) {
$parcel$export(module.exports, "AIAwareness", () => $8e4d21a9533be95e$export$fde99ed387d90f1);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1MNmN = parcelRequire("1MNmN");

var $eprc4 = parcelRequire("eprc4");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $8Sdzy = parcelRequire("8Sdzy");

var $eAoiR = parcelRequire("eAoiR");
const $8e4d21a9533be95e$var$styles = {
    text: "_4bfu18uv _1hmsglyw _ajmmnqa1"
};
const $8e4d21a9533be95e$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $eAoiR.i18n).rovoAwarenessMessage,
        define: (0, $eAoiR.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: (0, $1MNmN.cx)($8e4d21a9533be95e$var$styles.text),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.RovoIcon), {
                    size: "xxsmall",
                    appearance: "brand",
                    shouldUseNewLogoDesign: true
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                    color: "color.text.subtlest",
                    children: formatMessage(message)
                })
            ]
        })
    });
};
$8e4d21a9533be95e$export$fde99ed387d90f1.displayName = "AIAwareness";

});
parcelRegister("eAoiR", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $6cb581f3bb1905b3$export$a7357cdd1f0b0168);

var $7eNDO = parcelRequire("7eNDO");
const $6cb581f3bb1905b3$export$a7357cdd1f0b0168 = (0, $7eNDO.defineMessages)({
    rovoAwarenessMessage: {
        id: 'ai-awareness.rovoAwarenessMessage',
        defaultMessage: 'Summary by Rovo',
        description: 'Attribution label displayed near AI-generated summaries to indicate the content was created by Rovo.'
    },
    rovoAwarenessDefineMessage: {
        id: 'ai-awareness-define.message',
        defaultMessage: 'Definition by Rovo',
        description: 'Attribution label displayed near AI-generated definitions to indicate the content was provided by Rovo.'
    }
});

});


parcelRegister("5vjTI", function(module, exports) {
$parcel$export(module.exports, "AIDisclaimer", () => $2ace030d3513c13b$export$e0542ba0c737fe5c);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1MNmN = parcelRequire("1MNmN");

var $hzWaA = parcelRequire("hzWaA");

var $ihEDU = parcelRequire("ihEDU");
var $8Sdzy = parcelRequire("8Sdzy");

var $ganaq = parcelRequire("ganaq");
const $2ace030d3513c13b$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $2ace030d3513c13b$var$styles = {
    text: "_4bfu18uv _1hmsglyw _ajmmnqa1"
};
const $2ace030d3513c13b$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const disclaimerContent = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
        size: "small",
        color: "color.text.subtlest",
        children: formatMessage((0, $ganaq.i18n).disclaimerMessage)
    });
    if (withLink) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
        appearance: "subtle",
        href: $2ace030d3513c13b$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick,
        children: disclaimerContent
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: (0, $1MNmN.cx)($2ace030d3513c13b$var$styles.text),
        children: disclaimerContent
    });
};
$2ace030d3513c13b$export$e0542ba0c737fe5c.displayName = "AIDisclaimer";

});
parcelRegister("ganaq", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $a22d6e8fe563f184$export$a7357cdd1f0b0168);

var $7eNDO = parcelRequire("7eNDO");
const $a22d6e8fe563f184$export$a7357cdd1f0b0168 = (0, $7eNDO.defineMessages)({
    disclaimerMessage: {
        id: 'ai-disclaimer.disclaimerMessage',
        defaultMessage: 'Uses AI. Verify results.',
        description: 'The disclaimer text that can be applied to the footer of various ai features throughout Atlassian'
    }
});

});


parcelRegister("6se8o", function(module, exports) {
$parcel$export(module.exports, "AIFeedbackComponent", () => $c01a6054731fc4af$export$f9f34317e5bc3551);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $4qNCE = parcelRequire("4qNCE");

var $cfBod = parcelRequire("cfBod");

var $6xxcW = parcelRequire("6xxcW");

var $8Qvei = parcelRequire("8Qvei");

var $hzWaA = parcelRequire("hzWaA");

var $egspI = parcelRequire("egspI");

var $c69sa = parcelRequire("c69sa");
var $2BUXh = parcelRequire("2BUXh");
var $fbAgj = parcelRequire("fbAgj");

var $hZDXn = parcelRequire("hZDXn");

var $9uVUk = parcelRequire("9uVUk");

var $42MYZ = parcelRequire("42MYZ");
const $c01a6054731fc4af$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $c01a6054731fc4af$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $c01a6054731fc4af$var$i18n = (0, $7eNDO.defineMessages)({
    flagTitle: {
        id: 'quick-summary.feedback.flag.title',
        defaultMessage: 'Thanks!',
        description: 'Title of the success notification that appears after users submit AI feedback.'
    },
    flagDescription: {
        id: 'quick-summary.feedback.flag.description',
        defaultMessage: 'We appreciate you taking the time to send this feedback.',
        description: 'Description text in the feedback success notification expressing gratitude for user feedback.'
    },
    likeTooltip: {
        id: 'quick-summary.like.tooltip',
        defaultMessage: 'Helpful',
        description: 'Tooltip for the thumbs-up button that rates AI responses as good or helpful.'
    },
    dislikeTooltip: {
        id: 'quick-summary.dislike.tooltip',
        defaultMessage: 'Not helpful',
        description: 'Tooltip for the thumbs-down button that rates AI responses as bad or unhelpful.'
    },
    feedbackTitle: {
        id: 'quick-summary.feedback.title',
        defaultMessage: 'Help us improve Atlassian Intelligence',
        description: 'Label text for the summary section of the report feedback collector'
    },
    feedbackSummaryTitle: {
        id: 'quick-summary.feedback.summary.title',
        defaultMessage: 'Tell us about your experience',
        description: 'Title text for the summary section of the report feedback collector'
    },
    feedbackSummaryPlaceholder: {
        id: 'quick-summary.feedback.summary.placeholder',
        defaultMessage: 'What did Atlassian Intelligence do well? What could be improved?',
        description: 'Description text for the summary section of the report feedback collector'
    },
    canContactText: {
        id: 'quick-summary.feedback.can-contact.label',
        defaultMessage: 'Atlassian can contact me about this feedback. See our {privacyPolicyLink}.',
        description: "Text next to first checkbox. {privacyPolicyLink} will be substituted with a link whose text reads 'privacy policy'"
    },
    privacyPolicyLink: {
        id: 'quick-summary.feedback.privacy-policy.link',
        defaultMessage: 'privacy policy',
        description: 'The text of the link that will direct users to the privacy policy site.'
    },
    improveAtlassianText: {
        id: 'quick-summary.feedback.improve-atlassian',
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}.",
        description: "Text next to second checkbox. {researchGroupLink} will be substituted with a message which reads as 'Atlassian Research Group'"
    },
    improveAtlassianTextAppify: {
        id: 'quick-summary.feedback.improve-atlassian-appify',
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}.",
        description: "Text next to second checkbox. {researchGroupLink} will be substituted with a message which reads as 'Atlassian Research Group'"
    },
    researchGroupLink: {
        id: 'quick-summary.feedback.research-group.link',
        defaultMessage: 'Atlassian Research Group',
        description: 'The text of the link that will direct users to the research group site.'
    }
});
const $c01a6054731fc4af$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            ...$c01a6054731fc4af$var$i18n.privacyPolicyLink
        })
    });
$c01a6054731fc4af$var$PrivacyPolicyLink.displayName = "PrivacyPolicyLink";
const $c01a6054731fc4af$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            ...$c01a6054731fc4af$var$i18n.researchGroupLink
        })
    });
$c01a6054731fc4af$var$ResearchGroupLink.displayName = "ResearchGroupLink";
const $c01a6054731fc4af$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        ...$c01a6054731fc4af$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, $e79Pd.jsx)($c01a6054731fc4af$var$PrivacyPolicyLink, {
                link: $c01a6054731fc4af$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
$c01a6054731fc4af$var$CanContactLabel.displayName = "CanContactLabel";
const $c01a6054731fc4af$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        ...(0, $egspI.fg)('product-terminology-refresh') ? $c01a6054731fc4af$var$i18n.improveAtlassianTextAppify : $c01a6054731fc4af$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, $e79Pd.jsx)($c01a6054731fc4af$var$ResearchGroupLink, {
                link: $c01a6054731fc4af$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
$c01a6054731fc4af$var$EnrolLabel.displayName = "EnrolLabel";
const $c01a6054731fc4af$var$DislikeIconWrapperXCSS = (0, $fbAgj.xcss)({
    transform: 'rotate(180deg)'
});
const $c01a6054731fc4af$var$ButtonWrapperXCSS = (0, $fbAgj.xcss)({
    height: '24px',
    width: '24px'
});
const $c01a6054731fc4af$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $6xxcW.useFlags)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $euxye.useState)(false);
    const feedbackCollectorProperties = (0, $9uVUk.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $euxye.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $euxye.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $euxye.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($c01a6054731fc4af$var$i18n.flagTitle),
            description: formatMessage($c01a6054731fc4af$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation(),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2BUXh.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($c01a6054731fc4af$var$i18n.likeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.default), {
                        xcss: $c01a6054731fc4af$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($c01a6054731fc4af$var$i18n.likeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $42MYZ.ThumbIcon), {
                                isSelected: hasGoodFeedbackBeenSubmitted
                            }),
                            onClick: handleLikeClicked,
                            testId: "feedback-like-button",
                            isDisabled: hasGoodFeedbackBeenSubmitted
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($c01a6054731fc4af$var$i18n.dislikeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.default), {
                        xcss: $c01a6054731fc4af$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($c01a6054731fc4af$var$i18n.dislikeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.default), {
                                xcss: $c01a6054731fc4af$var$DislikeIconWrapperXCSS,
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $42MYZ.ThumbIcon), {
                                    isSelected: hasBadFeedbackBeenSubmitted
                                })
                            }),
                            onClick: handleDislikeClicked,
                            testId: "feedback-dislike-button",
                            isDisabled: hasBadFeedbackBeenSubmitted
                        })
                    })
                }),
                isFeedbackOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cfBod.default), {
                    locale: feedbackCollectorProperties.locale,
                    onSubmit: onFeedbackSubmit,
                    onClose: ()=>setIsFeedbackOpen(false),
                    atlassianAccountId: feedbackCollectorProperties.userId,
                    name: feedbackCollectorProperties.displayName,
                    entrypointId: feedbackCollectorProperties.entrypointId,
                    summaryPlaceholder: formatMessage($c01a6054731fc4af$var$i18n.feedbackSummaryPlaceholder),
                    additionalFields: [
                        {
                            id: feedbackCollectorProperties.feedbackContextId,
                            value: feedbackContextString
                        }
                    ],
                    feedbackTitle: formatMessage($c01a6054731fc4af$var$i18n.feedbackTitle),
                    showTypeField: false,
                    customTextAreaLabel: formatMessage($c01a6054731fc4af$var$i18n.feedbackSummaryTitle),
                    canBeContactedLabel: /*#__PURE__*/ (0, $e79Pd.jsx)($c01a6054731fc4af$var$CanContactLabel, {}),
                    enrolInResearchLabel: /*#__PURE__*/ (0, $e79Pd.jsx)($c01a6054731fc4af$var$EnrolLabel, {})
                })
            ]
        })
    });
};
$c01a6054731fc4af$export$f9f34317e5bc3551.displayName = "AIFeedbackComponent";

});
parcelRegister("cfBod", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $184403b077541489$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("SR9xW")).default);
$parcel$export(module.exports, "FeedbackForm", () => (parcelRequire("iujuv")).default);
$parcel$export(module.exports, "FeedbackButton", () => (parcelRequire("d3ckT")).default);

var $d3ckT = parcelRequire("d3ckT");

var $88p1R = parcelRequire("88p1R");

var $SR9xW = parcelRequire("SR9xW");

var $iujuv = parcelRequire("iujuv");
var $184403b077541489$export$2e2bcd8739ae039 = (0, $88p1R.default);

});
parcelRegister("d3ckT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dd589bf41d9ed8a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $iOfms = parcelRequire("iOfms");

var $8RTvC = parcelRequire("8RTvC");

var $ifZDc = parcelRequire("ifZDc");

var $Hd4VB = parcelRequire("Hd4VB");

var $88p1R = parcelRequire("88p1R");

var $SR9xW = parcelRequire("SR9xW");

var $jyPme = parcelRequire("jyPme");
/*
 * Standard feedback button with "Give Feedback" as the text and speaker icon on the left of the text
 * */ const $6dd589bf41d9ed8a$var$FeedbackButton = (props)=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $euxye.useState)(false);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { entrypointId: entrypointId, atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails, locale: locale } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
                onClick: ()=>setIsOpen(true),
                iconBefore: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ifZDc))), {
                        color: "currentColor",
                        ...iconProps
                    }),
                children: formatMessage((0, $Hd4VB.messages).giveFeedback)
            }),
            isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $88p1R.default), {
                locale: locale,
                onClose: ()=>setIsOpen(false),
                onSubmit: ()=>setDisplayFlag(true),
                atlassianAccountId: atlassianAccountId,
                entrypointId: entrypointId,
                shouldGetEntitlementDetails: shouldGetEntitlementDetails
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8RTvC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: displayFlag && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $SR9xW.default), {})
            })
        ]
    });
};
$6dd589bf41d9ed8a$var$FeedbackButton.displayName = "FeedbackButton";
const $6dd589bf41d9ed8a$var$FeedbackButtonWithIntl = (props)=>{
    const { locale: locale } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jyPme.IntlProviderWithResolvedMessages), {
        locale: locale,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($6dd589bf41d9ed8a$var$FeedbackButton, {
            ...props
        })
    });
};
$6dd589bf41d9ed8a$var$FeedbackButtonWithIntl.displayName = "FeedbackButtonWithIntl";
var $6dd589bf41d9ed8a$export$2e2bcd8739ae039 = $6dd589bf41d9ed8a$var$FeedbackButtonWithIntl;

});
parcelRegister("ifZDc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0442f8372c8ab0b117b1651de731ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4a96f67e1f40ace$var$_react = $d4a96f67e1f40ace$var$_interopRequireDefault((parcelRequire("euxye")));

var $d4a96f67e1f40ace$var$_baseNew = $d4a96f67e1f40ace$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $d4a96f67e1f40ace$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4a96f67e1f40ace$var$FeedbackIcon = (props)=>/*#__PURE__*/ $d4a96f67e1f40ace$var$_react.default.createElement($d4a96f67e1f40ace$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$d4a96f67e1f40ace$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $d4a96f67e1f40ace$var$_default = module.exports.default = $d4a96f67e1f40ace$var$FeedbackIcon;

});

parcelRegister("Hd4VB", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e4b99a7b0350df82$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $e4b99a7b0350df82$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    feedbackTitle: {
        id: 'feedback-collector.feedback-title',
        defaultMessage: 'Share your thoughts',
        description: 'The title shown at the top of the feedback form encouraging users to leave feedback'
    },
    enrolInResearchLabel: {
        id: 'feedback-collector.enrol-in-research.label',
        defaultMessage: "I'd like to participate in product research",
        description: 'The checkbox label letting users enrol themselves in future product research interviews'
    },
    canBeContactedLabel: {
        id: 'feedback-collector.can-be-contacted.label',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    canBeContactedLabelWithoutLink: {
        id: 'feedback-collector.can-be-contacted.label-without-link',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    privacyPolicy: {
        id: 'feedback-collector.privacy-policy',
        defaultMessage: 'Atlassian Privacy Policy',
        description: 'The text content for the Privacy Policy link'
    },
    summaryPlaceholder: {
        id: 'feedback-collector.summary-placeholder',
        defaultMessage: "Let us know what's on your mind",
        description: 'The textarea label listing feedback categories (bug, suggestions, questions, comments)'
    },
    formCommentLabel: {
        id: 'feedback-collector.form.comment.label',
        defaultMessage: "Let us know what's on your mind",
        description: 'The textarea label where users can write their comment'
    },
    submitButtonLabel: {
        id: 'feedback-collector.submit-button.label',
        defaultMessage: 'Send feedback',
        description: "The text is shown on a primary submit button at the bottom of the feedback collector form. When clicked, it submits the user's feedback to Atlassian."
    },
    cancelButtonLabel: {
        id: 'feedback-collector.cancel-button.label',
        defaultMessage: 'Cancel',
        description: 'The button to cancel feedback submission'
    },
    giveFeedback: {
        id: 'proforma-form-builder.give-feedback',
        defaultMessage: 'Give feedback',
        description: 'The button that allows users to give feedback'
    },
    formBugLabel: {
        id: 'feedback-collector.form.bug.label',
        defaultMessage: 'Describe the bug or issue',
        description: 'The textarea label where users can describe the bug or issue they have'
    },
    formSuggestionLabel: {
        id: 'feedback-collector.form.suggestion.label',
        defaultMessage: "Let us know what you'd like to improve",
        description: 'The textarea label where users can write their suggestion'
    },
    formQuestionLabel: {
        id: 'feedback-collector.form.question.label',
        defaultMessage: 'What would you like to know?',
        description: 'The textarea label where users can write their question'
    },
    formEmptyLabel: {
        id: 'feedback-collector.form.empty.label',
        defaultMessage: 'Select an option',
        description: 'The text is shown as the default empty/placeholder option in the feedback type drop-down list when no option has been selected yet.'
    },
    formNotRelevantLabel: {
        id: 'feedback-collector.form.not-relevant.label',
        defaultMessage: "Wasn't relevant",
        description: 'The textarea label where users can write their not relevant feedback'
    },
    formNotAccurateLabel: {
        id: 'feedback-collector.form.not-accurate.label',
        defaultMessage: "Wasn't accurate",
        description: 'The textarea label where users can write their not accurate feedback'
    },
    formTooSlowLabel: {
        id: 'feedback-collector.form.too-slow.label',
        defaultMessage: 'Too slow',
        description: 'The textarea label where users can write their too slow feedback'
    },
    formUnhelpfulLinksLabel: {
        id: 'feedback-collector.form.unhelpful-links.label',
        defaultMessage: 'Unhelpful links',
        description: 'The textarea label where users can write their unhelpful links feedback'
    },
    formOtherLabel: {
        id: 'feedback-collector.form.other.label',
        defaultMessage: 'Other',
        description: 'The textarea label where users can write their other feedback'
    },
    selectionOptionQuestionLabel: {
        id: 'feedback-collector.option.question.label',
        defaultMessage: 'Ask a question',
        description: 'The feedback dropdown list option to ask a question'
    },
    selectionOptionCommentLabel: {
        id: 'feedback-collector.option.comment.label',
        defaultMessage: 'Leave a comment',
        description: 'The feedback dropdown list option to leave a comment'
    },
    selectionOptionBugLabel: {
        id: 'feedback-collector.option.bug.label',
        defaultMessage: 'Report a bug',
        description: 'The feedback dropdown list option to report a bug'
    },
    selectionOptionSuggestionLabel: {
        id: 'feedback-collector.option.suggestion.label',
        defaultMessage: 'Suggest an improvement',
        description: 'The feedback dropdown list option to suggest an improvement'
    },
    selectionOptionDefaultLabel: {
        id: 'feedback-collector.option.default.label',
        defaultMessage: 'Select feedback',
        description: 'The text is shown as the visible label of the feedback type drop-down selector in the feedback collector form, prompting the user to choose a feedback category.'
    },
    selectionOptionDefaultPlaceholder: {
        id: 'feedback-collector.option.default.placeholder',
        defaultMessage: 'Choose one',
        description: 'The text is shown as the placeholder inside the feedback type drop-down selector before the user makes a selection, prompting them to pick one of the available feedback categories.'
    },
    feedbackIconLabel: {
        id: 'proforma-form-builder.feedback-icon-label',
        defaultMessage: 'Feedback',
        description: 'Accessibility text used for the feedback icon'
    },
    feedbackSuccessFlagDescription: {
        id: 'feedback-collector.success-flag.description',
        defaultMessage: 'Your valuable feedback helps us continually improve our products.',
        description: 'Description shown when feedback is successfully submitted'
    },
    feedbackSuccessFlagTitle: {
        id: 'feedback-collector.success-flag.title',
        defaultMessage: 'Thanks!',
        description: 'Button to dismiss successflag flag after submitting feedback'
    },
    feedbackIsAnonymousTitle: {
        id: 'feedback-collector.anonymous.title',
        defaultMessage: 'Anonymous feedback',
        description: 'Section message title for anonymous feedback'
    },
    feedbackIsAnonymous: {
        id: 'feedback-collector.anonymous',
        defaultMessage: 'This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback',
        description: 'The text is shown as an informational notice in the feedback collector form when the user is submitting feedback anonymously, informing them that Atlassian will not be able to follow up with them directly.'
    },
    requiredFieldsSummary: {
        id: 'feedback-collector.required.fields.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    defaultCustomTextAreaLabel: {
        id: 'feedback-collector.default.custom.textarea.label',
        defaultMessage: "What's on your mind?",
        description: 'The textarea label where users can write their suggestion for custom feedback collector'
    },
    canBeContactedLabelAppify: {
        id: 'feedback-collector.can-be-contacted.label-appify',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: 'feedback-collector.can-be-contacted.label-appify-without-link',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: 'feedback-collector.success-flag.description-appify',
        defaultMessage: 'Your valuable feedback helps us continually improve our apps.',
        description: 'Description shown when feedback is successfully submitted'
    },
    validationErrorTypeRequired: {
        id: 'feedback-collector.validation.type.required',
        defaultMessage: 'Please select a feedback type',
        description: 'Error message when feedback type is not selected'
    },
    validationErrorDescriptionRequired: {
        id: 'feedback-collector.validation.description.required',
        defaultMessage: 'Please provide a description',
        description: 'Error message when description is not provided'
    },
    optInOptionsLegend: {
        id: 'feedback-collector.opt-in.options.legend',
        defaultMessage: 'Atlassian opt-in options',
        description: 'Legend for the opt-in options on the feedback form'
    }
});

});

parcelRegister("88p1R", function(module, exports) {
$parcel$export(module.exports, "default", () => $33b714c211ae48bc$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $3oBOI = parcelRequire("3oBOI");

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $4qdjw = parcelRequire("4qdjw");

var $5qSkI = parcelRequire("5qSkI");

var $iujuv = parcelRequire("iujuv");
const $33b714c211ae48bc$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $33b714c211ae48bc$var$singleLineTruncatedText = (text, length = $33b714c211ae48bc$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $5qSkI.default)(singleLineText, length);
};
class $33b714c211ae48bc$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    static{
        this.defaultProps = {
            locale: 'en',
            url: '/gateway/api',
            shouldGetEntitlementDetails: true,
            canBeContactedFieldId: 'customfield_10043',
            canBeContactedAgreeValue: [
                {
                    id: '10109'
                }
            ],
            canBeContactedDeclineValue: [
                {
                    id: '10111'
                }
            ],
            additionalFields: [],
            customerNameFieldId: 'customfield_10045',
            customerNameDefaultValue: 'unknown',
            descriptionFieldId: 'description',
            descriptionDefaultValue: '',
            enrollInResearchFieldId: 'customfield_10044',
            enrollInResearchAgreeValue: [
                {
                    id: '10110'
                }
            ],
            enrollInResearchDeclineValue: [
                {
                    id: '10112'
                }
            ],
            summaryFieldId: 'summary',
            summaryDefaultValue: '',
            summaryTruncateLength: 100,
            timeoutOnSubmit: 700,
            typeFieldId: 'customfield_10042',
            typeBugDefaultValue: {
                id: '10105'
            },
            typeCommentDefaultValue: {
                id: '10106'
            },
            typeSuggestionDefaultValue: {
                id: '10107'
            },
            typeQuestionDefaultValue: {
                id: '10108'
            },
            typeEmptyDefaultValue: {
                id: 'empty'
            },
            showTypeField: true,
            showDefaultTextFields: true,
            anonymousFeedback: false,
            onClose: ()=>{},
            onSubmit: ()=>{}
        };
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $33b714c211ae48bc$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $33b714c211ae48bc$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $4qdjw.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $4qdjw.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $33b714c211ae48bc$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iujuv.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $egspI.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args), this.state = {
            anonymousFeedback: true
        }, this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $4qdjw.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $3oBOI.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$33b714c211ae48bc$export$2e2bcd8739ae039.displayName = "FeedbackCollector";

});
parcelRegister("4qdjw", function(module, exports) {
$parcel$export(module.exports, "isApiGatewayUrl", () => $ba23489aa5aa8b00$export$f0f6fc934288a17c);
const $ba23489aa5aa8b00$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);

});

parcelRegister("5qSkI", function(module, exports) {
$parcel$export(module.exports, "default", () => $11315ede3fd659ae$export$2e2bcd8739ae039);
function $11315ede3fd659ae$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("iujuv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d652966e839193e$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $4qNCE = parcelRequire("4qNCE");

var $apqVV = parcelRequire("apqVV");

var $fWb5q = parcelRequire("fWb5q");
var $hO3zy = parcelRequire("hO3zy");
var $1W2Av = parcelRequire("1W2Av");
var $4WUcS = parcelRequire("4WUcS");
var $ej7cp = parcelRequire("ej7cp");
var $dIqcw = parcelRequire("dIqcw");

var $hzWaA = parcelRequire("hzWaA");

var $7tY81 = parcelRequire("7tY81");
var $2v3yi = parcelRequire("2v3yi");
var $4vluQ = parcelRequire("4vluQ");
var $gpyJM = parcelRequire("gpyJM");
var $dNPnD = parcelRequire("dNPnD");

var $egspI = parcelRequire("egspI");

var $aybNy = parcelRequire("aybNy");

var $baIdH = parcelRequire("baIdH");

var $baT4v = parcelRequire("baT4v");

var $Hd4VB = parcelRequire("Hd4VB");

var $jyPme = parcelRequire("jyPme");
const $2d652966e839193e$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        children: children
    });
};
$2d652966e839193e$var$LinkWrapper.displayName = "LinkWrapper";
const $2d652966e839193e$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $euxye.useState)(false);
    const [description, setDescription] = (0, $euxye.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $euxye.useState)(false);
    const [type, setType] = (0, $euxye.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $euxye.useState)(false);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $Hd4VB.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $Hd4VB.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $Hd4VB.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $Hd4VB.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $Hd4VB.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $Hd4VB.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $Hd4VB.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $Hd4VB.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $Hd4VB.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $Hd4VB.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $Hd4VB.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $Hd4VB.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $Hd4VB.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $Hd4VB.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $Hd4VB.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $Hd4VB.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $Hd4VB.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $euxye.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $Hd4VB.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $Hd4VB.messages).canBeContactedLabelAppify;
    };
    const renderContactLabel = ()=>{
        if ((0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $Hd4VB.messages).canBeContactedLabelWithoutLink;
        return (0, $Hd4VB.messages).canBeContactedLabel;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $e79Pd.jsxs)("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        },
        children: [
            formatMessage((0, $Hd4VB.messages).requiredFieldsSummary),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dIqcw.default), {})
        ]
    });
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $e79Pd.jsx)("p", {
        children: formatMessage((0, $Hd4VB.messages).feedbackIsAnonymous)
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7tY81.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true,
        children: (0, $egspI.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $fWb5q.default), {
            onSubmit: async ()=>{
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gpyJM.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dNPnD.default), {
                        children: feedbackTitle || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                            ...(0, $Hd4VB.messages).feedbackTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2v3yi.default), {
                    children: [
                        (0, $egspI.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                        feedbackTitleDetails,
                        customContent,
                        showTypeField ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                            name: "topic",
                            id: "topic",
                            label: selectLabel || formatMessage((0, $Hd4VB.messages).selectionOptionDefaultLabel),
                            isRequired: true,
                            validate: validateType,
                            children: ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $baIdH.default), {
                                            ...restProps,
                                            value: selectOptions.find((opt)=>opt.value === type) ?? null,
                                            onChange: (option)=>{
                                                if (!option || option instanceof Array) return;
                                                setType(option.value);
                                                restProps.onChange?.(option.value);
                                            },
                                            menuPosition: "fixed",
                                            options: selectOptions,
                                            // @ts-ignore
                                            ref: focusRef,
                                            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                            inputId: id,
                                            isInvalid: !!error
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ej7cp.MessageWrapper), {
                                            children: error && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hO3zy.ErrorMessage), {
                                                children: error
                                            })
                                        })
                                    ]
                                })
                        }) : null,
                        showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                    label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $Hd4VB.messages).defaultCustomTextAreaLabel),
                                    isRequired: true,
                                    name: "description",
                                    id: "description",
                                    validate: validateDescription,
                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $baT4v.default), {
                                                    ...fieldProps,
                                                    name: "foo",
                                                    minimumRows: 6,
                                                    placeholder: summaryPlaceholder || undefined,
                                                    onChange: (e)=>{
                                                        setDescription(e.target.value);
                                                        fieldProps.onChange(e.target.value);
                                                    },
                                                    value: description
                                                }),
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ej7cp.MessageWrapper), {
                                                    children: error && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hO3zy.ErrorMessage), {
                                                        children: error
                                                    })
                                                })
                                            ]
                                        })
                                }),
                                !anonymousFeedback && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $4WUcS.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)("legend", {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                ...(0, $Hd4VB.messages).optInOptionsLegend
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                            name: "can-be-contacted",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apqVV.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: canBeContactedLabel || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                                ...(0, $egspI.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                ...!(0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                    values: {
                                                                        a: (chunks)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                target: "_blank",
                                                                                children: chunks
                                                                            })
                                                                    }
                                                                }
                                                            }),
                                                            onChange: (event)=>setCanBeContacted(event.target.checked)
                                                        }),
                                                        canBeContactedLabel && canBeContactedLink && (0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $e79Pd.jsx)($2d652966e839193e$var$LinkWrapper, {
                                                            children: canBeContactedLink
                                                        }),
                                                        !canBeContactedLabel && (0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $e79Pd.jsx)($2d652966e839193e$var$LinkWrapper, {
                                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                target: "_blank",
                                                                children: formatMessage((0, $Hd4VB.messages).privacyPolicy)
                                                            })
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                            name: "enroll-in-research-group",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apqVV.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: enrolInResearchLabel || formatMessage((0, $Hd4VB.messages).enrolInResearchLabel),
                                                            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                        }),
                                                        enrolInResearchLabel && enrolInResearchLink && (0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $e79Pd.jsx)($2d652966e839193e$var$LinkWrapper, {
                                                            children: enrolInResearchLink
                                                        })
                                                    ]
                                                })
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                        name: 'anonymousFeedback',
                                        children: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $aybNy.default), {
                                                title: formatMessage((0, $Hd4VB.messages).feedbackIsAnonymousTitle),
                                                appearance: 'information',
                                                children: feedbackIsAnonymous
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $4vluQ.default), {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
                            appearance: "subtle",
                            onClick: handleCancel,
                            children: cancelButtonLabel || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                ...(0, $Hd4VB.messages).cancelButtonLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
                            appearance: "primary",
                            type: "submit",
                            isDisabled: isSubmitting || isDisabled,
                            testId: "feedbackCollectorSubmitBtn",
                            children: submitButtonLabel || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                ...(0, $Hd4VB.messages).submitButtonLabel
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fWb5q.default), {
            onSubmit: async ()=>{
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $e79Pd.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gpyJM.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dNPnD.default), {
                                children: feedbackTitle || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                    ...(0, $Hd4VB.messages).feedbackTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2v3yi.default), {
                            children: [
                                (0, $egspI.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                                feedbackTitleDetails,
                                customContent,
                                showTypeField ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                    name: "topic",
                                    id: "topic",
                                    label: selectLabel || formatMessage((0, $Hd4VB.messages).selectionOptionDefaultLabel),
                                    isRequired: true,
                                    validate: validateType,
                                    children: ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $baIdH.default), {
                                                    ...restProps,
                                                    value: selectOptions.find((opt)=>opt.value === type) ?? null,
                                                    onChange: (option)=>{
                                                        if (!option || option instanceof Array) return;
                                                        setType(option.value);
                                                        restProps.onChange?.(option.value);
                                                    },
                                                    menuPosition: "fixed",
                                                    options: selectOptions,
                                                    // @ts-ignore
                                                    ref: focusRef,
                                                    placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                                    inputId: id,
                                                    isInvalid: !!error
                                                }),
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ej7cp.MessageWrapper), {
                                                    children: error && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hO3zy.ErrorMessage), {
                                                        children: error
                                                    })
                                                })
                                            ]
                                        })
                                }) : null,
                                showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $Hd4VB.messages).defaultCustomTextAreaLabel),
                                            isRequired: true,
                                            name: "description",
                                            id: "description",
                                            validate: validateDescription,
                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $baT4v.default), {
                                                            ...fieldProps,
                                                            name: "foo",
                                                            minimumRows: 6,
                                                            placeholder: summaryPlaceholder || undefined,
                                                            onChange: (e)=>{
                                                                setDescription(e.target.value);
                                                                fieldProps.onChange(e.target.value);
                                                            },
                                                            value: description
                                                        }),
                                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ej7cp.MessageWrapper), {
                                                            children: error && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hO3zy.ErrorMessage), {
                                                                children: error
                                                            })
                                                        })
                                                    ]
                                                })
                                        }),
                                        !anonymousFeedback && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $4WUcS.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $e79Pd.jsx)("legend", {
                                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                        ...(0, $Hd4VB.messages).optInOptionsLegend
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                                    name: "can-be-contacted",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apqVV.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: canBeContactedLabel || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                                        ...(0, $egspI.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                        ...!(0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                            values: {
                                                                                a: (chunks)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                        target: "_blank",
                                                                                        children: chunks
                                                                                    })
                                                                            }
                                                                        }
                                                                    }),
                                                                    onChange: (event)=>setCanBeContacted(event.target.checked)
                                                                }),
                                                                canBeContactedLabel && canBeContactedLink && (0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $e79Pd.jsx)($2d652966e839193e$var$LinkWrapper, {
                                                                    children: canBeContactedLink
                                                                }),
                                                                !canBeContactedLabel && (0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $e79Pd.jsx)($2d652966e839193e$var$LinkWrapper, {
                                                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                        target: "_blank",
                                                                        children: formatMessage((0, $Hd4VB.messages).privacyPolicy)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                                    name: "enroll-in-research-group",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apqVV.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: enrolInResearchLabel || formatMessage((0, $Hd4VB.messages).enrolInResearchLabel),
                                                                    onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                                }),
                                                                enrolInResearchLabel && enrolInResearchLink && (0, $egspI.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $e79Pd.jsx)($2d652966e839193e$var$LinkWrapper, {
                                                                    children: enrolInResearchLink
                                                                })
                                                            ]
                                                        })
                                                })
                                            ]
                                        }) || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1W2Av.default), {
                                                name: 'anonymousFeedback',
                                                children: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $aybNy.default), {
                                                        title: formatMessage((0, $Hd4VB.messages).feedbackIsAnonymousTitle),
                                                        appearance: 'information',
                                                        children: feedbackIsAnonymous
                                                    })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $4vluQ.default), {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
                                    appearance: "subtle",
                                    onClick: handleCancel,
                                    children: cancelButtonLabel || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...(0, $Hd4VB.messages).cancelButtonLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isDisabled: isSubmitting || isDisabled,
                                    testId: "feedbackCollectorSubmitBtn",
                                    children: submitButtonLabel || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                        ...(0, $Hd4VB.messages).submitButtonLabel
                                    })
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
$2d652966e839193e$var$FeedbackForm.displayName = "FeedbackForm";
const $2d652966e839193e$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jyPme.IntlProviderWithResolvedMessages), {
        locale: locale,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($2d652966e839193e$var$FeedbackForm, {
            ...props
        })
    });
};
$2d652966e839193e$var$FeedbackFormWithIntl.displayName = "FeedbackFormWithIntl";
var $2d652966e839193e$export$2e2bcd8739ae039 = $2d652966e839193e$var$FeedbackFormWithIntl;

});
parcelRegister("4WUcS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3081a380b086cb9$export$2e2bcd8739ae039);
/* fieldset.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8yPS1 = parcelRequire("8yPS1");
const $c3081a380b086cb9$var$fieldSetStyles = null;
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */ const $c3081a380b086cb9$var$Fieldset = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("fieldset", {
        className: (0, $4jQY2.default)([
            "_1pfhu2gc"
        ]),
        children: [
            legend && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8yPS1.Legend), {
                children: legend
            }),
            children
        ]
    });
};
$c3081a380b086cb9$var$Fieldset.displayName = "Fieldset";
var $c3081a380b086cb9$export$2e2bcd8739ae039 = $c3081a380b086cb9$var$Fieldset;

});
parcelRegister("8yPS1", function(module, exports) {
$parcel$export(module.exports, "Legend", () => $2b8c1cd66c074865$export$ed247974535929c7);
/* legend.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $2b8c1cd66c074865$var$fieldsetLabelStyles = null;
const $2b8c1cd66c074865$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("legend", {
        className: (0, $4jQY2.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};
$2b8c1cd66c074865$export$ed247974535929c7.displayName = "Legend";

});


parcelRegister("baT4v", function(module, exports) {
$parcel$export(module.exports, "default", () => $767d8e99e99ef781$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
var $8w7Yz = parcelRequire("8w7Yz");

var $euxye = parcelRequire("euxye");

var $aZBDA = parcelRequire("aZBDA");

var $egspI = parcelRequire("egspI");
const $767d8e99e99ef781$var$packageName = "platform-pkg";
const $767d8e99e99ef781$var$packageVersion = "0.0.0-use.local";
const $767d8e99e99ef781$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $767d8e99e99ef781$var$packageName,
    packageVersion: $767d8e99e99ef781$var$packageVersion
};
const $767d8e99e99ef781$var$lineHeightBase = 20;
const $767d8e99e99ef781$var$lineHeightCompact = 16;
const $767d8e99e99ef781$var$compactVerticalPadding = 2;
const $767d8e99e99ef781$var$verticalPadding = 6;
const $767d8e99e99ef781$var$transitionDuration = '0.2s';
const $767d8e99e99ef781$var$borderWidth = 2;
const $767d8e99e99ef781$var$baseStyles = null;
const $767d8e99e99ef781$var$baseStylesT26Shape = null;
const $767d8e99e99ef781$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u3acm _jomr18uv _7ehinruj"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $767d8e99e99ef781$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $767d8e99e99ef781$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $767d8e99e99ef781$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $767d8e99e99ef781$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $767d8e99e99ef781$var$InnerTextArea = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const ourRef = (0, $euxye.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $euxye.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $euxye.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $767d8e99e99ef781$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$767d8e99e99ef781$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$767d8e99e99ef781$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $euxye.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $767d8e99e99ef781$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $egspI.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $767d8e99e99ef781$var$appearanceStyles[appearance],
            $767d8e99e99ef781$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $767d8e99e99ef781$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $8w7Yz.default)($767d8e99e99ef781$var$lineHeightCompact * minimumRows + $767d8e99e99ef781$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $8w7Yz.default)($767d8e99e99ef781$var$lineHeightBase * minimumRows + $767d8e99e99ef781$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $767d8e99e99ef781$var$TextArea = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)($767d8e99e99ef781$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$767d8e99e99ef781$var$TextArea.displayName = 'TextArea';
var $767d8e99e99ef781$export$2e2bcd8739ae039 = $767d8e99e99ef781$var$TextArea;

});

parcelRegister("jyPme", function(module, exports) {
$parcel$export(module.exports, "IntlProviderWithResolvedMessages", () => $49e8564af07b7b61$export$f793de1293176fe6);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5KKyn = parcelRequire("5KKyn");

var $kn6Hs = parcelRequire("kn6Hs");
const $49e8564af07b7b61$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $euxye.useState)();
    (0, $euxye.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $kn6Hs.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale,
        children: children
    });
};
$49e8564af07b7b61$export$f793de1293176fe6.displayName = "IntlProviderWithResolvedMessages";

});
parcelRegister("kn6Hs", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $93af1414a5ff7a2e$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ const $93af1414a5ff7a2e$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});




parcelRegister("SR9xW", function(module, exports) {
$parcel$export(module.exports, "default", () => $da1c14a0a693e5ff$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $63XI1 = parcelRequire("63XI1");

var $8Qvei = parcelRequire("8Qvei");

var $egspI = parcelRequire("egspI");

var $Hd4VB = parcelRequire("Hd4VB");

var $jyPme = parcelRequire("jyPme");
const $da1c14a0a693e5ff$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $63XI1.default), {
        icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $egspI.fg)('product-terminology-refresh') ? (0, $Hd4VB.messages).feedbackSuccessFlagDescriptionAppify : (0, $Hd4VB.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $Hd4VB.messages).feedbackSuccessFlagTitle)
    });
};
$da1c14a0a693e5ff$var$FeedbackFlag.displayName = "FeedbackFlag";
const $da1c14a0a693e5ff$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $jyPme.IntlProviderWithResolvedMessages), {
        locale: props.locale,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($da1c14a0a693e5ff$var$FeedbackFlag, {
            ...props
        })
    });
$da1c14a0a693e5ff$var$FeedbackFlagWithIntl.displayName = "FeedbackFlagWithIntl";
var $da1c14a0a693e5ff$export$2e2bcd8739ae039 = $da1c14a0a693e5ff$var$FeedbackFlagWithIntl;

});



parcelRegister("42MYZ", function(module, exports) {
$parcel$export(module.exports, "ThumbIcon", () => $3788b157690845d4$export$ec2ba0e929740f73);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $cIXw8 = parcelRequire("cIXw8");
const $3788b157690845d4$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIXw8))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
$3788b157690845d4$export$ec2ba0e929740f73.displayName = "ThumbIcon";

});
parcelRegister("cIXw8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bf82c15bca1a56d27012abd5cecbc7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9437c30261f89335$var$_react = $9437c30261f89335$var$_interopRequireDefault((parcelRequire("euxye")));

var $9437c30261f89335$var$_baseNew = $9437c30261f89335$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $9437c30261f89335$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9437c30261f89335$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $9437c30261f89335$var$_react.default.createElement($9437c30261f89335$var$_baseNew.default, Object.assign({
        name: "ThumbsUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$9437c30261f89335$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $9437c30261f89335$var$_default = module.exports.default = $9437c30261f89335$var$ThumbsUpIcon;

});



parcelRegister("dHnrU", function(module, exports) {
$parcel$export(module.exports, "usePopupDwellTime", () => $f646761c68429ec8$export$15dda63faa44a0df);

var $euxye = parcelRequire("euxye");

var $1MhXP = parcelRequire("1MhXP");
const $f646761c68429ec8$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $1MhXP.useOnScreen)(ref);
    const dwellTimeRef = (0, $euxye.useRef)(0);
    (0, $euxye.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};

});
parcelRegister("1MhXP", function(module, exports) {
$parcel$export(module.exports, "useOnScreen", () => $7e356d7b156f875f$export$edb9b52ab3f1abbb);

var $euxye = parcelRequire("euxye");
const $7e356d7b156f875f$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};

});



parcelRegister("61Cev", function(module, exports) {
$parcel$export(module.exports, "AISnippetLoader", () => $54b24da23ac2a7e5$export$f50b64530422ea99);

var $e79Pd = parcelRequire("e79Pd");

var $gVvPO = parcelRequire("gVvPO");
parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $egspI = parcelRequire("egspI");

var $9uVUk = parcelRequire("9uVUk");

var $34Jk9 = parcelRequire("34Jk9");
const $54b24da23ac2a7e5$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $54b24da23ac2a7e5$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $n67Vb.usePreloadedQuery)((0, $gVvPO.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $34Jk9.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $egspI.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9uVUk.AIFeedbackPropertiesProvider), {
        entrypointId: $54b24da23ac2a7e5$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name,
        children: content
    });
    return content;
};
$54b24da23ac2a7e5$export$f50b64530422ea99.displayName = "AISnippetLoader";

});
parcelRegister("gVvPO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d4a2cdfc8d73bdd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $8d4a2cdfc8d73bdd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8d4a2cdfc8d73bdd$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $8d4a2cdfc8d73bdd$export$2e2bcd8739ae039 = $8d4a2cdfc8d73bdd$var$node;

});







parcelRegister("1bhIG", function(module, exports) {
$parcel$export(module.exports, "JiraSpaPageContainer", () => $85f2a17361fb732e$export$802ae4178431f591);

var $6IHMU = parcelRequire("6IHMU");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $l7jID = parcelRequire("l7jID");

var $kb8yj = parcelRequire("kb8yj");

var $gsEo7 = parcelRequire("gsEo7");

var $dFT3J = parcelRequire("dFT3J");

var $hIRki = parcelRequire("hIRki");

var $h8QGu = parcelRequire("h8QGu");

var $eChBu = parcelRequire("eChBu");

var $bGess = parcelRequire("bGess");

var $gDdYI = parcelRequire("gDdYI");

var $9XO6I = parcelRequire("9XO6I");

var $5NkRe = parcelRequire("5NkRe");

var $cJ4JH = parcelRequire("cJ4JH");

var $lnVHd = parcelRequire("lnVHd");

var $6MMSf = parcelRequire("6MMSf");

var $aZMdt = parcelRequire("aZMdt");

var $ePtEH = parcelRequire("ePtEH");

var $57TEW = parcelRequire("57TEW");

var $i860n = parcelRequire("i860n");

var $jepRN = parcelRequire("jepRN");

var $f2wVS = parcelRequire("f2wVS");

var $eaylF = parcelRequire("eaylF");

var $esaVU = parcelRequire("esaVU");

var $jxXMl = parcelRequire("jxXMl");

var $c2hVV = parcelRequire("c2hVV");

var $euJ2W = parcelRequire("euJ2W");

var $a8EUd = parcelRequire("a8EUd");

var $jWGbu = parcelRequire("jWGbu");

var $juoEc = parcelRequire("juoEc");

var $5snaZ = parcelRequire("5snaZ");

var $tEZUz = parcelRequire("tEZUz");

var $72Dhb = parcelRequire("72Dhb");

var $hR4Oj = parcelRequire("hR4Oj");

var $cbY0l = parcelRequire("cbY0l");

var $bTil3 = parcelRequire("bTil3");

var $bMM3e = parcelRequire("bMM3e");

var $gboyS = parcelRequire("gboyS");

var $jbw5i = parcelRequire("jbw5i");


const $85f2a17361fb732e$var$SidebarEntry = (parcelRequire("fO9BM")).default;
const $85f2a17361fb732e$var$MaybeUFOSegment = (0, $jepRN.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "page-container-v2-main-wrapper"
    }, children), (0, $euxye.Fragment));
const $85f2a17361fb732e$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themed: "_11q3ne5i"
}; /**
    * These test IDs are used in pollinator tests. Do not change lightly.
    */ 
const $85f2a17361fb732e$var$ROOT_TEST_ID = 'page-layout.root';
const $85f2a17361fb732e$var$MAIN_TEST_ID = 'page-layout.main'; /**
                                          * The default page chrome for a Jira application.
                                          * We currently use an islands architecture, where each section of the layout
                                          * is relatively independent of one-another, and render a skeleton for each piece
                                          * of the page layout when it is loading.
                                          *
                                          * To achieve this, each section must suspend independent of each-other.
                                          * Be sure that each component rendered here has its own suspense boundary.
                                          *
                                          * @note
                                          * If there is no suspense boundary above this component and the preloaded query call suspends,
                                          * the user won't see the intended layout skeleton. They will most likely see a blank page, or
                                          * whatever generic placeholder has been configured in that higher boundary.
                                          */ 
const $85f2a17361fb732e$var$DefaultLayout = ({ children: children, queryReference: queryReference })=>{
    const [isChromeless] = (0, $9XO6I.useIsChromeless)();
    const [isFullscreen] = (0, $5NkRe.useIsFullscreen)();
    const showBanner = !isChromeless && !isFullscreen && (!(0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') || !(0, $i860n.fg)('jpx-870-stable-ui-for-criterion'));
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen && (!(0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') || !(0, $i860n.fg)('jpx-870-stable-ui-for-criterion'));
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    const data = (0, $n67Vb.usePreloadedQuery)((0, $6IHMU.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hR4Oj.JiraPageLayout), {
        testId: $85f2a17361fb732e$var$ROOT_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lnVHd.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c2hVV.IntegrationsWhichRequireNavigationRoot), null)), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "banner_skeleton",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jWGbu.BannerContent), {
        bannerFragment: data
    }))), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kb8yj.TopNavEntry), null))), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($85f2a17361fb732e$var$SidebarEntry, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($85f2a17361fb732e$var$MainWrapper, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gsEo7.HorizontalNavEntry), null), children), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5snaZ.RightSidebar), null)), (0, $i860n.fg)('jira-glance-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "preview-panel",
        packageName: "jiraPageContainerV2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $euJ2W.PreviewPanel), null)), (0, $i860n.fg)('ads-panel-system-jira-admin') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "dst-panel",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72Dhb.RightAdsPanel), null)), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cJ4JH.LayoutRemoteStateUpdater), null)));
};
$85f2a17361fb732e$var$DefaultLayout.displayName = "DefaultLayout";
function $85f2a17361fb732e$var$MainWrapper(props) {
    const { hasTheming: hasTheming } = (0, $ePtEH.useProjectTheme)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $eChBu.useJsmGracePeriodBanner)();
    const currentRoute = $85f2a17361fb732e$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $eaylF.isSystemNavPath)(currentRoute.path) || (0, $esaVU.isIssuesNavPath)(currentRoute.path);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.Main), {
        testId: $85f2a17361fb732e$var$MAIN_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($85f2a17361fb732e$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-vc": "page-container-v2-main-wrapper",
        style: hasTheming ? {
            // must be an inline style due to firefox bug with blob URLs: see https://atlassian.slack.com/archives/C02785CLSTW/p1770156142296829
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            background: (0, $dFT3J.Tokens).ELEVATION_SURFACE
        } : undefined,
        className: (0, $4jQY2.default)([
            $85f2a17361fb732e$var$mainWrapperStyles.root,
            hasTheming && $85f2a17361fb732e$var$mainWrapperStyles.themed
        ])
    }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bGess.JSMGracePeriodBannerAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jxXMl.JiraTopBannerPlacement), null), props.children)));
}
$85f2a17361fb732e$var$MainWrapper.displayName = "MainWrapper";
const $85f2a17361fb732e$var$useRouterRoute = (0, $f2wVS.createRouterSelector)((state)=>state.route);
const $85f2a17361fb732e$var$Layout = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $85f2a17361fb732e$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($85f2a17361fb732e$var$DefaultLayout, props);
};
$85f2a17361fb732e$var$Layout.displayName = "Layout";
const $85f2a17361fb732e$var$Passthrough = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
$85f2a17361fb732e$var$Passthrough.displayName = "Passthrough";
const $85f2a17361fb732e$var$WholePagePlaceholder = (0, $jepRN.componentWithFG)('jpx-463-spa-deprioritise-whole-page-container', (0, $a8EUd.default), $85f2a17361fb732e$var$Passthrough);
const $85f2a17361fb732e$var$JustLayoutPlaceholder = (0, $jepRN.componentWithFG)('jpx-463-spa-deprioritise-just-layout', (0, $a8EUd.default), $85f2a17361fb732e$var$Passthrough);
const $85f2a17361fb732e$export$802ae4178431f591 = (props)=>{
    const layout = (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') ? (0, $57TEW.getSharedLayout)() : (0, $57TEW.sharedLayout); // Here, we wrap the entire page structure in a suspense boundary. This might appear overly defensive,
    // but it's to change how React progressive hydration chooses its component render order.
    //
    // If we were to wrap only the component that is most likely to suspend - the Layout component -
    // that would cause React to lower the render priority of that part of the page... meaning everything else renders before it.
    // If SSR achieves VC100, that's not a problem... but since many of our app's routes still have client-bound rendering,
    // it lengthens the time until discovering and starting those things, meaning we lengthen the time until VC90 / VC100.
    //
    // We need to do what we can to prioritise rendering Layout, but the best we can do in React to make it important
    // is to make everything around it less important. At the same time, we need to ensure the user doesn't see a broken page
    // if something does suspend. Wrapping the whole contents is the best compromise; everything inside the boundary has
    // an equal (lowest) priority.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($85f2a17361fb732e$var$WholePagePlaceholder, {
        name: "spa_page_container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jbw5i.JiraPageContainerFallback), {
            reason: "spa_page_container_fallback"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $tEZUz.RedirectEntrypointContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cbY0l.GlobalThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceType: (0, $46f069e6c968f461$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bTil3.ProjectThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($85f2a17361fb732e$var$JustLayoutPlaceholder, {
        name: "spa_layout",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jbw5i.JiraPageContainerFallback), {
            reason: "spa_layout_fallback"
        })
    }, props?.queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($85f2a17361fb732e$var$Layout, {
        queryReference: props.queryReference
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jbw5i.JiraPageContainerFallback), {
        reason: "spa_no_query_reference"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "global_components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $juoEc.GlobalComponents), {
        sharedGlobalComponents: layout.globalComponents
    })), (0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "bottom_right_corner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gboyS.JiraSpaGlobalBottomRightCorner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "telemetry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bMM3e.PageContainerSuccessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l7jID.HydrationStatsReporter), null))));
};
$85f2a17361fb732e$export$802ae4178431f591.displayName = "JiraSpaPageContainer";

});
parcelRegister("l7jID", function(module, exports) {
$parcel$export(module.exports, "HydrationStatsReporter", () => $369c988ca52c47c2$export$9fda4732f2f0c3db);
$parcel$export(module.exports, "getReactHydrationStats", () => $369c988ca52c47c2$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "enableHydrationStatReporting", () => $369c988ca52c47c2$export$6e74f32ea46916a6);
$parcel$export(module.exports, "addErrorForHydrationStats", () => $369c988ca52c47c2$export$14e23415a0e3da58);
$parcel$export(module.exports, "classifyAsHydrationError", () => $369c988ca52c47c2$export$e577dd64062c400a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dgncT = parcelRequire("dgncT");

var $TTcqD = parcelRequire("TTcqD");

var $9H8Hj = parcelRequire("9H8Hj");

var $4pJvR = parcelRequire("4pJvR");

var $5XU1N = parcelRequire("5XU1N");

var $fEmTm = parcelRequire("fEmTm");

var $f2wVS = parcelRequire("f2wVS");

var $7JeLK = parcelRequire("7JeLK");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $96Rot = parcelRequire("96Rot");

var $hhdbQ = parcelRequire("hhdbQ");
const $369c988ca52c47c2$var$HYDRATION_STATS = {
    enabled: false,
    hasFatalError: false,
    warningCount: 0,
    minErrorComponentDepth: null,
    maxErrorComponentDepth: null,
    reporters: null
};
const $369c988ca52c47c2$var$useRouteName = (0, $f2wVS.createRouterSelector)((state)=>state.route.name);
const $369c988ca52c47c2$var$inRange = (min, max, value)=>Math.max(min, Math.min(max, value));
const $369c988ca52c47c2$var$getQualityMetrics = ({ componentMountWorkCount: componentMountWorkCount, componentUpdateWorkCount: componentUpdateWorkCount, totalCommitCount: totalCommitCount, priorityInterruptedWorkCount: priorityInterruptedWorkCount })=>({
        // render factor as simple number of total "attempts" to render something
        renderFactor: $369c988ca52c47c2$var$inRange(0, 10, 10 * Math.round(componentUpdateWorkCount / componentMountWorkCount)),
        // restart factor as proportion of work started and work done
        restartFactor: $369c988ca52c47c2$var$inRange(0, 10, Math.round(10 * priorityInterruptedWorkCount / componentMountWorkCount)),
        // complexity raising every 50 commits (100 is "norm")
        complexityFactor: $369c988ca52c47c2$var$inRange(0, 10, Math.round(totalCommitCount / 50))
    });
const $369c988ca52c47c2$var$ReportMetrics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const initialRouteName = $369c988ca52c47c2$var$useRouteName();
    // Using state here because we want to capture the route name on initial render, and not have it change when the effect runs
    const [routeName] = (0, $euxye.useState)(initialRouteName);
    const isHydrateMode = (0, $TTcqD.useIsHydrateRenderMode)();
    (0, $euxye.useEffect)(()=>{
        const metrics = (0, $dgncT.getATLReactMetrics)();
        if (!metrics) return;
        // https://data-portal.internal.atlassian.com/analytics/registry/94211
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'reactMetric mount', {
            routeName: routeName,
            hydration: isHydrateMode,
            ...metrics
        });
        if ((0, $i860n.fg)('jfp_magma_jira-report-render-quality')) // data-portal.internal.atlassian.com/analytics/registry/102068
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'reactMetric quality', {
            routeName: routeName,
            ...$369c988ca52c47c2$var$getQualityMetrics(metrics)
        });
        // and disable them 🤫
        (0, $dgncT.disableATLReactMetrics)();
    }, [
        createAnalyticsEvent,
        routeName,
        isHydrateMode
    ]);
    return null;
};
$369c988ca52c47c2$var$ReportMetrics.displayName = "ReportMetrics";
const $369c988ca52c47c2$export$3490e4a4711228dd = (routeName)=>{
    const { reporters: reporters } = $369c988ca52c47c2$var$HYDRATION_STATS;
    if (!reporters || !(0, $i860n.fg)('jfp_magma_jira-report-hydration-mismatch')) return;
    const rootReport = reporters.root?.();
    if (!rootReport?.removed) return;
    const sharedStats = {
        routeName: routeName,
        nodesRemoved: rootReport.removed,
        boundariesRemoved: rootReport.failedBoundaries
    };
    const diff = (0, $hhdbQ.hydrationDiffer)(rootReport);
    if (!diff) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('react-hydration-mismatch', 'difference cannot be detected', {
            ...sharedStats
        });
        return;
    }
    const { liveAnchor: liveAnchor, serverNode: serverNode, clientNode: clientNode, kind: kind } = diff;
    const trace = liveAnchor && (0, $4pJvR.unwrapFiberToOwnershipTrace)(liveAnchor, serverNode, clientNode);
    if (!trace) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('react-hydration-mismatch', `trace for ${kind} cannot be expanded`, {
            ...sharedStats,
            kind: kind
        });
        return;
    }
    (0, $6CfY5.default).safeErrorWithoutCustomerData('react-hydration-mismatch', `${kind} -> ${trace.cause}`, {
        ...sharedStats,
        kind: kind,
        domPath: trace.domPath,
        location: trace.summary.join('\n')
    });
};
const $369c988ca52c47c2$var$ReportHydration = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const initialRouteName = $369c988ca52c47c2$var$useRouteName();
    // Using state here because we want to capture the route name on initial render, and not have it change when the effect runs
    const [routeName] = (0, $euxye.useState)(initialRouteName);
    const reported = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        // disable lanes alternation after hydration is complete
        (0, $dgncT.getATLReact)().__ATL_SYNC_HYDRATION_PRIORITY = false;
    }, []);
    (0, $euxye.useEffect)(()=>{
        if (!$369c988ca52c47c2$var$HYDRATION_STATS.enabled || reported.current) return;
        reported.current = true;
        const { hasFatalError: hasFatalError, warningCount: warningCount, minErrorComponentDepth: minErrorComponentDepth, maxErrorComponentDepth: maxErrorComponentDepth, reporters: reporters } = $369c988ca52c47c2$var$HYDRATION_STATS;
        const successful = !hasFatalError;
        const hydrationPreservationReport = reporters ? (()=>{
            const preservation = (0, $96Rot.getRegionPreservationMetrics)(reporters);
            const TOPNAV_KEY = 'page-layout.top-nav';
            const SIDEBAR_KEY = 'page-layout.sidebar';
            const MAIN_KEY = 'page-layout.main';
            // track only top regions
            const topNav = preservation[TOPNAV_KEY] ?? undefined;
            const sideBar = preservation[SIDEBAR_KEY] ?? undefined;
            const main = preservation[MAIN_KEY] ?? undefined;
            return {
                topNavPreservation: topNav,
                sideBarPreservation: sideBar,
                mainPreservation: main,
                topNavUnmounted: reporters[TOPNAV_KEY]?.().unmounted ?? 0,
                sidebarUnmounted: reporters[SIDEBAR_KEY]?.().unmounted ?? 0,
                mainUnmounted: reporters[MAIN_KEY]?.().unmounted ?? 0,
                topNavRemoved: reporters[TOPNAV_KEY]?.().removed ?? 0,
                sidebarRemoved: reporters[SIDEBAR_KEY]?.().removed ?? 0,
                mainRemoved: reporters[MAIN_KEY]?.().removed ?? 0,
                topNavAdded: reporters[TOPNAV_KEY]?.().added ?? 0,
                sidebarAdded: reporters[SIDEBAR_KEY]?.().added ?? 0,
                mainAdded: reporters[MAIN_KEY]?.().added ?? 0
            };
        })() : undefined;
        // data-portal.internal.atlassian.com/analytics/registry/87189
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), successful ? 'reactHydrate success' : 'reactHydrate failure', {
            warningCount: $369c988ca52c47c2$export$3bf82299f486a7ff(warningCount),
            timedOut: (0, $5XU1N.getIsGlobalTimedOut)(),
            routeName: routeName
        });
        const paretoBuckets = {
            topNavPreservationBucket: $369c988ca52c47c2$export$93f638fae88f8ed5(hydrationPreservationReport?.topNavPreservation ?? 1),
            sideBarPreservationBucket: $369c988ca52c47c2$export$93f638fae88f8ed5(hydrationPreservationReport?.sideBarPreservation ?? 1),
            mainPreservationBucket: $369c988ca52c47c2$export$93f638fae88f8ed5(hydrationPreservationReport?.mainPreservation ?? 1)
        };
        // https://data-portal.internal.atlassian.com/analytics/registry/93805
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'reactHydrate status', {
            successful: successful,
            routeName: routeName,
            ...paretoBuckets,
            ...hydrationPreservationReport
        });
        $369c988ca52c47c2$export$3490e4a4711228dd(routeName);
        if ((0, $i860n.fg)('jfp-magma-hydration-report-to-splunk')) // When cleaning up, replace with @atlassian/jira-coinflip depending on the desired rate, or remove
        // completely if no longer needed and the analytics event above can be used instead
        (0, $6CfY5.default).safeInfoWithoutCustomerData('react-hydration-reporting', successful ? 'Hydration success' : 'Hydration failure', {
            warningCount: warningCount,
            routeName: routeName,
            minErrorComponentDepth: minErrorComponentDepth,
            maxErrorComponentDepth: maxErrorComponentDepth,
            ...hydrationPreservationReport
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    return null;
};
$369c988ca52c47c2$var$ReportHydration.displayName = "ReportHydration";
const $369c988ca52c47c2$export$9fda4732f2f0c3db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9H8Hj.RenderAfterGlobalHydrationCompletion), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($369c988ca52c47c2$var$ReportHydration, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7JeLK.BackgroundPriority), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($369c988ca52c47c2$var$ReportMetrics, null)));
$369c988ca52c47c2$export$9fda4732f2f0c3db.displayName = "HydrationStatsReporter";
const $369c988ca52c47c2$export$2d8f8d64dc343d7b = ()=>{
    if (!$369c988ca52c47c2$var$HYDRATION_STATS.enabled) return undefined;
    return {
        successful: !$369c988ca52c47c2$var$HYDRATION_STATS.hasFatalError,
        warningCount: $369c988ca52c47c2$var$HYDRATION_STATS.warningCount,
        minWarningComponentDepth: $369c988ca52c47c2$var$HYDRATION_STATS.minErrorComponentDepth ?? undefined,
        maxWarningComponentDepth: $369c988ca52c47c2$var$HYDRATION_STATS.maxErrorComponentDepth ?? undefined,
        preservationRatio: $369c988ca52c47c2$var$HYDRATION_STATS.reporters?.root?.().preservationRatio
    };
};
const $369c988ca52c47c2$export$3bf82299f486a7ff = (warningCount)=>{
    if (warningCount <= 9) return warningCount.toString();
    return '10+';
};
const $369c988ca52c47c2$export$93f638fae88f8ed5 = (value)=>{
    const clamped = Math.max(0, Math.min(100, Math.round(value)));
    // 0-79: coarser buckets (20-point)
    if (clamped < 20) return 10;
    if (clamped < 40) return 30;
    if (clamped < 60) return 50;
    if (clamped < 80) return 70;
    // 80-89: 5-point buckets
    if (clamped < 85) return 80;
    if (clamped < 90) return 85;
    // 90-97: 2-point buckets
    if (clamped < 92) return 90;
    if (clamped < 94) return 92;
    if (clamped < 96) return 94;
    if (clamped < 98) return 96;
    // 98-100: 1-point buckets (critical zone)
    if (clamped < 99) return 98;
    if (clamped < 100) return 99;
    return 100;
};
const $369c988ca52c47c2$export$6e74f32ea46916a6 = (rootContainer)=>{
    $369c988ca52c47c2$var$HYDRATION_STATS.enabled = true;
    try {
        $369c988ca52c47c2$var$HYDRATION_STATS.reporters = (0, $96Rot.setupRegionReporters)(rootContainer, (0, $i860n.fg)('jfp_magma_jira-report-hydration-mismatch'));
    } catch (error) {
        (0, $fEmTm.captureException)('content-preservation', new Error('Content preservation failed to capture initial state', {
            cause: error
        }));
    }
};
const $369c988ca52c47c2$export$14e23415a0e3da58 = (error, errorInfo)=>{
    switch($369c988ca52c47c2$export$e577dd64062c400a(error)){
        case $369c988ca52c47c2$var$HYDRATION_FATAL_ERROR:
            $369c988ca52c47c2$var$HYDRATION_STATS.hasFatalError = true;
            $369c988ca52c47c2$var$recordComponentDepthStats(errorInfo);
            break;
        case $369c988ca52c47c2$var$HYDRATION_WARNING:
            $369c988ca52c47c2$var$HYDRATION_STATS.warningCount++;
            $369c988ca52c47c2$var$recordComponentDepthStats(errorInfo);
            break;
        default:
            break;
    }
};
const $369c988ca52c47c2$var$HYDRATION_FATAL_ERROR = 'fatal';
const $369c988ca52c47c2$var$HYDRATION_WARNING = 'warning';
const $369c988ca52c47c2$export$e577dd64062c400a = ({ message: message })=>{
    if ($369c988ca52c47c2$var$PROD_FATAL_MESSAGES.some((fatal)=>message.includes(fatal))) return $369c988ca52c47c2$var$HYDRATION_FATAL_ERROR;
    if ($369c988ca52c47c2$var$PROD_WARNING_MESSAGES.some((warning)=>message.includes(warning))) return $369c988ca52c47c2$var$HYDRATION_WARNING;
    return null;
};
// We ignore 419 "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."
// because we *expect* these to happen when we throw to a suspense boundary e.g. due to timeout
const $369c988ca52c47c2$var$PROD_FATAL_MESSAGES = [
    407,
    421,
    422,
    423,
    424
].map((code)=>`Minified React error #${code}`);
const $369c988ca52c47c2$var$PROD_WARNING_MESSAGES = [
    418,
    425
].map((code)=>`Minified React error #${code}`);
const $369c988ca52c47c2$var$DEV_FATAL_MESSAGES = [
    'to client rendering'
];
const $369c988ca52c47c2$var$DEV_WARNING_MESSAGES = [
    'Hydration failed because the initial UI does not match what was rendered on the server',
    'Text content does not match server-rendered HTML'
];
const $369c988ca52c47c2$var$recordComponentDepthStats = ({ componentStack: componentStack })=>{
    if (!componentStack) return;
    // Number of components = number of lines after the error message
    const componentStackDepth = componentStack.match(/\n/g)?.length ?? 1;
    $369c988ca52c47c2$var$HYDRATION_STATS.minErrorComponentDepth = Math.min(componentStackDepth, $369c988ca52c47c2$var$HYDRATION_STATS.minErrorComponentDepth ?? Number.MAX_SAFE_INTEGER);
    $369c988ca52c47c2$var$HYDRATION_STATS.maxErrorComponentDepth = Math.max(componentStackDepth, $369c988ca52c47c2$var$HYDRATION_STATS.maxErrorComponentDepth ?? 0);
};

});
parcelRegister("dgncT", function(module, exports) {
$parcel$export(module.exports, "getATLReact", () => $150b8fd86b23d1e1$export$c066f7d9144b3981);
$parcel$export(module.exports, "getATLReactMetrics", () => $150b8fd86b23d1e1$export$413076bd797d8f9c);
$parcel$export(module.exports, "initATLReactMetrics", () => $150b8fd86b23d1e1$export$34ca9c2ee9b8231c);
$parcel$export(module.exports, "disableATLReactMetrics", () => $150b8fd86b23d1e1$export$8b93fc25e4e95969);
/* eslint-disable jira/filename-case */ // oxlint-disable-next-line typescript/consistent-type-assertions
const $150b8fd86b23d1e1$var$atlReactGlobal = globalThis;
const $150b8fd86b23d1e1$export$c066f7d9144b3981 = ()=>$150b8fd86b23d1e1$var$atlReactGlobal;
function $150b8fd86b23d1e1$export$413076bd797d8f9c() {
    return $150b8fd86b23d1e1$var$atlReactGlobal.__ATL_REACT_METRICS ? {
        ...$150b8fd86b23d1e1$var$atlReactGlobal.__ATL_REACT_METRICS
    } : undefined;
}
function $150b8fd86b23d1e1$export$34ca9c2ee9b8231c() {
    const metrics = {
        mountWorkCount: 0,
        updateWorkCount: 0,
        commitWorkCount: 0,
        interruptedWorkCount: 0,
        priorityInterruptedWorkCount: 0,
        externalStoreRestartCount: 0,
        componentWorkCount: 0,
        componentMountWorkCount: 0,
        componentUpdateWorkCount: 0,
        componentRenderWithHooksCount: 0,
        finishClassComponentCount: 0,
        domWorkCount: 0,
        totalTickCount: 0,
        totalCommitCount: 0,
        contextUpdateCount: 0,
        legacyContextUpdateCount: 0
    };
    $150b8fd86b23d1e1$var$atlReactGlobal.__ATL_REACT_METRICS = metrics;
    return metrics;
}
function $150b8fd86b23d1e1$export$8b93fc25e4e95969() {
    delete $150b8fd86b23d1e1$var$atlReactGlobal.__ATL_REACT_METRICS;
}

});

parcelRegister("9H8Hj", function(module, exports) {
$parcel$export(module.exports, "RenderAfterGlobalHydrationCompletion", () => $1bb9a0015bd32a64$export$4fd2e2a42709b3f5);

var $5XU1N = parcelRequire("5XU1N");
const $1bb9a0015bd32a64$export$4fd2e2a42709b3f5 = ({ children: children })=>{
    const isCompleted = (0, $5XU1N.useIsGlobalHydrationComplete)();
    if (!isCompleted) return null;
    return children;
};
$1bb9a0015bd32a64$export$4fd2e2a42709b3f5.displayName = "RenderAfterGlobalHydrationCompletion";

});

parcelRegister("4pJvR", function(module, exports) {
$parcel$export(module.exports, "unwrapFiberToOwnershipTrace", () => $4f6b938a1780935a$export$a5132157ca950bb3);

var $1bCtZ = parcelRequire("1bCtZ");
const $4f6b938a1780935a$var$OWNER_PREFIX = 'OwnerMark___';
/**
 * extension point -> add ComponentNames to be ignored, like StyledComponents
 */ const $4f6b938a1780935a$var$EXCLUDE_LIST = new Set([
    // emotion
    'StyleCacheProvider',
    'EmotionCssPropInternal',
    // UFO
    'UFOSegment',
    'JiraUFOSegmentWrapper'
]);
const $4f6b938a1780935a$var$parseOwnershipMarker = (displayName)=>{
    if (!displayName.startsWith($4f6b938a1780935a$var$OWNER_PREFIX)) return null;
    const parts = displayName.slice($4f6b938a1780935a$var$OWNER_PREFIX.length).split('___');
    if (parts.length !== 4) return null;
    return `${parts[0]}:${parts[1]}`;
};
const $4f6b938a1780935a$var$getSafeDomAnchor = (element)=>{
    if (element.dataset.testid) return `testid:${element.dataset.testid}`;
    return null;
};
const $4f6b938a1780935a$export$a5132157ca950bb3 = (element, mismatchServerNode, mismatchClientNode)=>{
    const fiber = (0, $1bCtZ.getReactFiberForElement)(element);
    if (!fiber) return null;
    let ownershipMarker = null;
    let renderParent = null;
    for (const stackFiber of (0, $1bCtZ.getReturnStack)(fiber)){
        const displayName = (0, $1bCtZ.getFiberDisplayName)(stackFiber);
        if (!displayName) continue;
        if (ownershipMarker === null) ownershipMarker = $4f6b938a1780935a$var$parseOwnershipMarker(displayName);
        if (renderParent === null && // reduces pickup to a "meaningful name"
        displayName.length > 5 && // removes "known" noise
        !$4f6b938a1780935a$var$EXCLUDE_LIST.has(displayName) && !displayName.startsWith($4f6b938a1780935a$var$OWNER_PREFIX)) renderParent = `react:${displayName}`;
        if (ownershipMarker !== null && renderParent !== null) break;
    }
    let domAnchor = null;
    const pathSegments = [];
    for(let el = element; el; el = el.parentElement){
        domAnchor = $4f6b938a1780935a$var$getSafeDomAnchor(el);
        if (domAnchor) break;
        // Compute sibling index among element siblings
        const siblingIndex = el.parentElement ? Array.from(el.parentElement.children).indexOf(el) : 0;
        pathSegments.push(`${el.tagName.toLowerCase()}:${siblingIndex}`);
    }
    const cause = `${mismatchServerNode?.nodeName.toLowerCase() ?? 'null'}|${mismatchClientNode?.nodeName.toLowerCase() ?? 'null'}`;
    return {
        ownershipMarker: ownershipMarker,
        domAnchor: domAnchor,
        domPath: pathSegments.length > 0 ? pathSegments.reverse().join('->') : null,
        renderParent: renderParent,
        cause: cause,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        summary: [
            ownershipMarker,
            domAnchor,
            renderParent,
            cause
        ].filter(Boolean)
    };
};

});
parcelRegister("1bCtZ", function(module, exports) {
$parcel$export(module.exports, "getReactFiberForElement", () => $a6dfa409b7bbdb6c$export$48f10a3ff8cfaad4);
$parcel$export(module.exports, "getReturnStack", () => $a6dfa409b7bbdb6c$export$aec6e1809d1a5ad0);
$parcel$export(module.exports, "getFiberDisplayName", () => $a6dfa409b7bbdb6c$export$aeab93315a8e217c);
const $a6dfa409b7bbdb6c$var$isReactFiberInterestingProperties = (value)=>{
    return Boolean(value && typeof value === 'object' && 'return' in value);
};
const $a6dfa409b7bbdb6c$export$48f10a3ff8cfaad4 = (element)=>{
    const fiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber'));
    if (!fiberKey) return null;
    const fiber = Reflect.get(element, fiberKey);
    return $a6dfa409b7bbdb6c$var$isReactFiberInterestingProperties(fiber) ? fiber : null;
};
const $a6dfa409b7bbdb6c$export$aec6e1809d1a5ad0 = (fiber)=>{
    let next = fiber;
    const result = [];
    while(next){
        result.push(next);
        next = next.return;
    }
    return result;
};
const $a6dfa409b7bbdb6c$export$2afab28e2abfaa9b = (candidate)=>{
    if (typeof candidate === 'string') return candidate;
    if (typeof candidate === 'function') // @ts-expect-error TS2339: Property displayName does not exist on type Function
    return candidate.displayName ?? candidate.name ?? null;
    if (!candidate || typeof candidate !== 'object') return null;
    const maybeDisplayName = 'displayName' in candidate ? candidate.displayName : undefined;
    if (typeof maybeDisplayName === 'string' && maybeDisplayName.length > 0) return maybeDisplayName;
    const maybeName = 'name' in candidate ? candidate.name : undefined;
    if (typeof maybeName === 'string' && maybeName.length > 0) return maybeName;
    const maybeRender = 'render' in candidate ? candidate.render : undefined;
    if (typeof maybeRender === 'function') // @ts-expect-error TS2339: Property displayName does not exist on type Function
    return maybeRender.displayName ?? maybeRender.name ?? null;
    return null;
};
const $a6dfa409b7bbdb6c$export$aeab93315a8e217c = (fiber)=>{
    return $a6dfa409b7bbdb6c$export$2afab28e2abfaa9b(fiber.elementType) ?? $a6dfa409b7bbdb6c$export$2afab28e2abfaa9b(fiber.type);
};
const $a6dfa409b7bbdb6c$export$1a1b4512ffa6e8e6 = null;

});


parcelRegister("7JeLK", function(module, exports) {
$parcel$export(module.exports, "BackgroundPriority", () => $419b8588f5ef9617$export$ae957da140356154);
$parcel$export(module.exports, "renderInBackgroundPriority", () => $419b8588f5ef9617$export$92ab163f92594a98);

var $euxye = parcelRequire("euxye");

var $5dfRu = parcelRequire("5dfRu");
const $419b8588f5ef9617$export$ae957da140356154 = ({ children: children, forceRender: forceRender })=>{
    const tier = (0, $5dfRu.useCurrentPriority)();
    if (!forceRender && tier < (0, $5dfRu.loadingPriority).background) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$419b8588f5ef9617$export$ae957da140356154.displayName = "BackgroundPriority";
const $419b8588f5ef9617$export$92ab163f92594a98 = (Component, bypassCondition)=>{
    const wrappedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($419b8588f5ef9617$export$ae957da140356154, {
            forceRender: bypassCondition ? bypassCondition() : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, null));
    wrappedComponent.displayName = `BackgroundPriority(${Component.displayName || Component.name})`;
    return wrappedComponent;
};

});
parcelRegister("5dfRu", function(module, exports) {
$parcel$export(module.exports, "useCurrentPriority", () => $76dcb30860d81647$export$ea2f0151c2177b4c);
$parcel$export(module.exports, "loadingPriority", () => $76dcb30860d81647$export$9d1e6d89fa244199);
$parcel$export(module.exports, "PriorityManager", () => $76dcb30860d81647$export$7099b16a7996ef6c);

var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $4FR7Y = parcelRequire("4FR7Y");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $62Xqf = parcelRequire("62Xqf");
const $76dcb30860d81647$var$store = (0, $5QDqc.createStore)({
    name: 'priority-manager',
    initialState: {
        tier: 1
    },
    actions: {
        setTier: (tier)=>({ setState: setState, getState: getState })=>setState({
                    tier: Math.max(getState().tier, tier)
                })
    }
});
const $76dcb30860d81647$export$5761757a15d758a = (0, $3h1FP.createActionsHook)($76dcb30860d81647$var$store);
const $76dcb30860d81647$export$ea2f0151c2177b4c = (0, $3h1FP.createStateHook)($76dcb30860d81647$var$store, {
    selector: (state)=>state.tier
});
const $76dcb30860d81647$export$9d1e6d89fa244199 = {
    // tier 0 - "early scripts" is outside of this component reach and responsibility
    /**
	 * Tier 1 - initial loading phase, everything is critical
	 */ critical: 1,
    /**
	 * Tier 2 - app is ready, but some work is still in progress
	 * This is the phase where we can start loading non-critical resources
	 */ nonCritical: 2,
    /**
	 * Tier 3 - background phase, all work is done, we can load background resources
	 * This is the phase where we can start loading background resources
	 */ background: 3
};
function $76dcb30860d81647$export$7099b16a7996ef6c() {
    const isReady = (0, $62Xqf.useSpaStatePageReady)();
    const { setTier: setTier } = $76dcb30860d81647$export$5761757a15d758a();
    const interactionContext = (0, $4FR7Y.useInteractionContext)();
    const { addCustomData: addCustomData } = interactionContext ?? {};
    (0, $euxye.useEffect)(()=>{
        if (isReady) {
            performance.mark('priority:non-critical-phase');
            setTier($76dcb30860d81647$export$9d1e6d89fa244199.nonCritical);
            const tm = setTimeout(()=>{
                if ((0, $i860n.fg)('hot_301836_bg_task_timeout_info')) addCustomData?.({
                    bgTaskTimeout: performance.now()
                });
                setTier($76dcb30860d81647$export$9d1e6d89fa244199.background);
            }, (0, $2700E.expVal)('hot_301836_dynamic_bg_task_timeout', 'value', 5000));
            return ()=>{
                clearTimeout(tm);
            };
        }
    }, [
        isReady,
        setTier,
        addCustomData
    ]);
    (0, $euxye.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            const onPageReady = ()=>{
                performance.mark('priority:background-phase');
                setTier($76dcb30860d81647$export$9d1e6d89fa244199.background);
            };
            window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
            return ()=>{
                window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
            };
        }
    }, [
        setTier
    ]);
    return null;
}
$76dcb30860d81647$export$7099b16a7996ef6c.displayName = "PriorityManager";

});


parcelRegister("96Rot", function(module, exports) {
$parcel$export(module.exports, "getRegionPreservationMetrics", () => $e051cc0b7d8a6aaf$export$3bf2a7352cebbb06);
$parcel$export(module.exports, "setupRegionReporters", () => $e051cc0b7d8a6aaf$export$41c8620b712b0b87);
/* eslint-disable jira/filename-case */ 
var $eCIK4 = parcelRequire("eCIK4");
const $e051cc0b7d8a6aaf$export$3bf2a7352cebbb06 = (report = {})=>{
    return Object.entries(report || {}).reduce((acc, [regionName, reporter])=>{
        const outcome = reporter();
        // report in 100% basis for easier reading in analytics tools
        acc[regionName] = 100 * outcome.preservationRatio;
        return acc;
    }, {});
};
const $e051cc0b7d8a6aaf$export$41c8620b712b0b87 = (rootContainer, captureHydrationState = false)=>{
    const regions = rootContainer.querySelectorAll('[data-layout-slot]');
    if (!regions) return {};
    const reporters = Array.from(regions).reduce((acc, region)=>{
        const regionName = region.getAttribute('data-testid');
        if (!regionName) return acc;
        // extension point - track hydration mistakes per region
        acc[regionName] = (0, $eCIK4.captureDocumentState)(region);
        return acc;
    }, {});
    reporters.root = (0, $eCIK4.captureDocumentState)(rootContainer, {
        captureBoundaryData: captureHydrationState
    });
    return reporters;
};

});
parcelRegister("eCIK4", function(module, exports) {
$parcel$export(module.exports, "captureDocumentState", () => $8249452d8e372ab1$export$1b24ed83c93b6dbc);
/* eslint-disable jira/filename-case */ /**
 * Boundary tracking data exposed for composition with other trackers.
 */ const $8249452d8e372ab1$var$allRemoved = (nodes)=>nodes.every((n)=>!n.parentNode);
const $8249452d8e372ab1$var$buildChildrenByParent = (nodes, parents)=>{
    const childrenByParent = new Map();
    for (const node of nodes){
        const parent = parents.get(node) ?? null;
        if (parent) {
            const existingChildren = childrenByParent.get(parent);
            if (existingChildren) existingChildren.push(node);
            else childrenByParent.set(parent, [
                node
            ]);
        }
    }
    return childrenByParent;
};
function $8249452d8e372ab1$export$1b24ed83c93b6dbc(container, { captureBoundaryData: captureBoundaryData = false } = {}) {
    const originalParents = new Map();
    const nodeToBoundary = new Map();
    const boundaries = new Map();
    const nestedMarkersByMarker = captureBoundaryData ? new Map() : undefined;
    const capturedParentByMarker = captureBoundaryData ? new Map() : undefined;
    const capturedSiblingIndexByMarker = captureBoundaryData ? new Map() : undefined;
    function collectAllNodes(root, captureOriginalState = false) {
        const out = [];
        const documentNode = // oxlint-disable-next-line typescript/consistent-type-assertions
        root.nodeType === Node.DOCUMENT_NODE ? root : root.ownerDocument;
        if (!documentNode) return out;
        const walker = documentNode.createTreeWalker(root, NodeFilter.SHOW_ALL);
        const stack = [];
        const boundaryTracker = [];
        while(walker.nextNode()){
            const node = walker.currentNode;
            // special handling for comments to detect start and end of failed suspense blocks
            if (node.nodeType === Node.COMMENT_NODE) {
                const commentContent = node.nodeValue?.trim() ?? '';
                // Detect start of suspense block
                if (commentContent === '$!' || commentContent === '$') {
                    stack.push(commentContent);
                    if (captureOriginalState) {
                        boundaries.set(node, []);
                        if (captureBoundaryData && nestedMarkersByMarker && capturedParentByMarker && capturedSiblingIndexByMarker) {
                            const outerMarker = boundaryTracker.length > 0 ? boundaryTracker[boundaryTracker.length - 1] : null;
                            nestedMarkersByMarker.set(node, []);
                            if (outerMarker) nestedMarkersByMarker.get(outerMarker)?.push(node);
                            capturedParentByMarker.set(node, node.parentNode);
                            if (node.parentNode) capturedSiblingIndexByMarker.set(node, Array.from(node.parentNode.childNodes).findIndex((childNode)=>childNode === node));
                        }
                    }
                    boundaryTracker.push(node);
                }
                // Detect end of suspense block
                if (commentContent === '/$') {
                    stack.pop();
                    boundaryTracker.pop();
                }
                continue;
            }
            if (stack.includes('$!')) continue;
            // ignore "text" nodes
            if (node.nodeType === Node.TEXT_NODE) continue;
            // ignore "template" nodes (part of failed suspense and testing harness)
            if (node instanceof HTMLTemplateElement) continue;
            out.push(node);
            if (captureOriginalState) {
                originalParents.set(node, node.parentNode);
                // connect node to the current "boundary"
                const currentBoundary = boundaryTracker[boundaryTracker.length - 1];
                if (currentBoundary) {
                    nodeToBoundary.set(node, currentBoundary);
                    if (node.parentNode === currentBoundary.parentNode) boundaries.get(currentBoundary)?.push(node);
                }
            }
        }
        if (stack.length > 0) throw new Error('Mismatched suspense comments, found more start than end');
        return out;
    }
    // Capture pre-hydration snapshot
    const originalNodes = collectAllNodes(container, true);
    const originalSet = new Set(originalNodes);
    const originalChildrenByParent = captureBoundaryData ? $8249452d8e372ab1$var$buildChildrenByParent(originalNodes, originalParents) : undefined;
    let lastResult;
    return ()=>{
        // snapshots will be erased after run to prevent memory leaks
        // store and return lastResult
        if (lastResult) return lastResult;
        const currentNodes = collectAllNodes(container);
        const currentSet = new Set(currentNodes);
        const removedNodes = [];
        const unmountedNodes = [];
        const failedBoundaryMarkers = new Set();
        for (const n of originalSet)if (!currentSet.has(n)) {
            // check if this node was unmounted as part of a failed suspense boundary
            const boundaryId = nodeToBoundary.get(n);
            const boundaryElements = boundaryId && boundaries.get(boundaryId);
            if (boundaryId && (!boundaryElements || $8249452d8e372ab1$var$allRemoved(boundaryElements))) {
                // it was removed as part of hydration mismatch
                removedNodes.push(n);
                failedBoundaryMarkers.add(boundaryId);
            } else // it was preserved during hydration and removed later for some other reason.
            unmountedNodes.push(n);
        }
        const addedNodes = [];
        for (const n of currentSet)if (!originalSet.has(n)) addedNodes.push(n);
        const findPreservedParents = (affectedNodes)=>new Map(affectedNodes.flatMap((node)=>{
                const parent = originalParents.get(node) ?? null;
                if (!parent || !container.contains(parent)) // we do not report any "inner" node focusing on the "edge"
                return [];
                return [
                    [
                        node,
                        parent
                    ]
                ];
            }));
        const topLevelRemovedNodes = findPreservedParents(removedNodes);
        const topLevelUnmountedNodes = findPreservedParents(unmountedNodes);
        const original = originalSet.size;
        const removed = removedNodes.length;
        const unmounted = unmountedNodes.length;
        const added = addedNodes.length;
        const preserved = original - removed;
        const boundaryData = captureBoundaryData && nestedMarkersByMarker && capturedParentByMarker && capturedSiblingIndexByMarker && originalChildrenByParent ? {
            failedBoundaryMarkers: failedBoundaryMarkers,
            nestedMarkersByMarker: nestedMarkersByMarker,
            capturedParentByMarker: capturedParentByMarker,
            capturedSiblingIndexByMarker: capturedSiblingIndexByMarker,
            capturedTopLevelChildrenByMarker: new Map([
                ...failedBoundaryMarkers
            ].map((marker)=>[
                    marker,
                    boundaries.get(marker) ?? []
                ])),
            capturedSlotIndexByMarker: new Map([
                ...failedBoundaryMarkers
            ].map((marker)=>{
                const origChildren = boundaries.get(marker) ?? [];
                const firstOriginalNode = origChildren[0] ?? null;
                if (!firstOriginalNode) return [
                    marker,
                    -1
                ];
                const parent = capturedParentByMarker.get(marker) ?? null;
                if (!parent) return [
                    marker,
                    -1
                ];
                const parentOrigChildren = originalChildrenByParent.get(parent) ?? [];
                return [
                    marker,
                    parentOrigChildren.indexOf(firstOriginalNode)
                ];
            }))
        } : undefined;
        // clear transient snapshot state
        originalParents.clear();
        nodeToBoundary.clear();
        boundaries.clear();
        originalChildrenByParent?.clear();
        originalNodes.length = 0;
        originalSet.clear();
        lastResult = {
            original: original,
            preserved: preserved,
            removed: removed,
            unmounted: unmounted,
            added: added,
            failedBoundaries: failedBoundaryMarkers.size,
            preservationRatio: preserved / original,
            removedNodes: topLevelRemovedNodes,
            unmountedNodes: topLevelUnmountedNodes,
            boundaryData: boundaryData
        };
        return lastResult;
    };
}

});


parcelRegister("hhdbQ", function(module, exports) {
$parcel$export(module.exports, "hydrationDiffer", () => $031ca73a8e6c4249$export$df033797a0806ce9);

var $1bCtZ = parcelRequire("1bCtZ");
// React Fiber tag for SuspenseComponent.
const $031ca73a8e6c4249$var$SUSPENSE_FIBER_TAG = 13;
/**
 * Walk fiber parents from the element under `node` until the first Suspense fiber.
 * Returns null if none. The result is only meaningful relative to a starting point.
 */ const $031ca73a8e6c4249$var$findEnclosingSuspenseFiber = (node)=>{
    const el = node instanceof Element ? node : node.parentElement;
    if (!el) return null;
    let fiber = (0, $1bCtZ.getReactFiberForElement)(el);
    while(fiber){
        if (fiber.tag === $031ca73a8e6c4249$var$SUSPENSE_FIBER_TAG) return fiber;
        fiber = fiber.return;
    }
    return null;
};
const $031ca73a8e6c4249$var$PLACEHOLDER = {
    kind: 'placeholder',
    first: null
};
/**
 * When SSR opens with a Suspense placeholder, React inserts a zero-width text node on the
 * client side. Drop those leading text slots so the two lists align by slot index.
 */ const $031ca73a8e6c4249$var$alignLeadingPlaceholder = (ssr, csr)=>{
    if (ssr[0]?.kind !== 'placeholder') return;
    while(csr[0]?.kind === 'node' && csr[0].first.nodeType === Node.TEXT_NODE)csr.shift();
};
/**
 * SSR-side: build child slots from the captured (detached) DOM.
 * Nested Suspense regions are still bracketed by `$` / `$!` / `/$` comment markers and are
 * collapsed into a single placeholder slot.
 */ const $031ca73a8e6c4249$var$getSsrChildSlots = (node)=>{
    const slots = [];
    let suspenseDepth = 0;
    // Track whether the current top-level Suspense region had any real DOM nodes between
    // its `$…/$` markers. An empty Suspense boundary (renders nothing) leaves no live DOM
    // on the CSR side, so we must skip the placeholder slot to keep SSR/CSR aligned.
    let regionHadContent = false;
    for (const child of Array.from(node.childNodes)){
        if (child.nodeType === Node.COMMENT_NODE) {
            const v = child.nodeValue;
            if (v === '$' || v === '$!') {
                if (suspenseDepth === 0) regionHadContent = false;
                suspenseDepth += 1;
            } else if (v === '/$' && --suspenseDepth === 0 && regionHadContent) slots.push($031ca73a8e6c4249$var$PLACEHOLDER);
            continue;
        }
        if (suspenseDepth === 0) slots.push({
            kind: 'node',
            first: child
        });
        else regionHadContent = true;
    }
    return slots;
};
/**
 * CSR-side: build child slots from the live DOM.
 * After successful rehydration there are no `$` / `/$` markers around healed nested Suspense
 * subtrees, so we use React fiber ownership: any child under a different nearest Suspense
 * boundary is folded into a single placeholder slot.
 */ const $031ca73a8e6c4249$var$getCsrChildSlots = (node)=>{
    const parentBoundary = $031ca73a8e6c4249$var$findEnclosingSuspenseFiber(node);
    const slots = [];
    // Track the boundary fiber of the previous slot so we only collapse adjacent children
    // belonging to the SAME nested Suspense boundary. Sibling boundaries each emit their
    // own placeholder to stay aligned with the SSR `$…/$` markers.
    let prevNestedBoundary = null;
    for (const child of Array.from(node.childNodes)){
        if (child.nodeType === Node.COMMENT_NODE) continue;
        const childBoundary = $031ca73a8e6c4249$var$findEnclosingSuspenseFiber(child);
        const isNested = childBoundary !== null && childBoundary !== parentBoundary;
        if (isNested && childBoundary === prevNestedBoundary) continue;
        slots.push(isNested ? $031ca73a8e6c4249$var$PLACEHOLDER : {
            kind: 'node',
            first: child
        });
        prevNestedBoundary = isNested ? childBoundary : null;
    }
    return slots;
};
/**
 * Filter children for slot-index alignment against the pre-hydration snapshot.
 * Must exclude text nodes (unlike getFilteredChildren) because the slot index
 * captured in preservationTracker counts only element children — text nodes
 * shift indices and would misalign the boundary content window.
 */ const $031ca73a8e6c4249$var$getSlotFilteredChildren = (node)=>Array.from(node.childNodes).filter((child)=>child.nodeType !== Node.COMMENT_NODE && child.nodeType !== Node.TEXT_NODE && !(child instanceof HTMLTemplateElement));
const $031ca73a8e6c4249$export$5bf2ea18a7b75f2e = (orig, curr)=>{
    if (orig.nodeType !== curr.nodeType || orig.nodeName !== curr.nodeName || orig.nodeType === Node.TEXT_NODE && orig.textContent !== curr.textContent) return {
        server: orig,
        client: curr,
        liveClientParent: curr.parentNode ?? curr
    };
    const origSlots = $031ca73a8e6c4249$var$getSsrChildSlots(orig);
    const currSlots = $031ca73a8e6c4249$var$getCsrChildSlots(curr);
    $031ca73a8e6c4249$var$alignLeadingPlaceholder(origSlots, currSlots);
    let serverSlotIndex = 0;
    let clientSlotIndex = 0;
    while(serverSlotIndex < origSlots.length || clientSlotIndex < currSlots.length){
        const origSlot = origSlots[serverSlotIndex];
        const currSlot = currSlots[clientSlotIndex];
        if (!origSlot) return {
            server: null,
            client: currSlot?.first ?? null,
            liveClientParent: curr
        };
        if (!currSlot) return {
            server: origSlot.first ?? null,
            client: null,
            liveClientParent: curr
        };
        if (origSlot.kind === 'placeholder' || currSlot.kind === 'placeholder') {
            if (origSlot.kind !== currSlot.kind) return {
                server: origSlot.first,
                client: currSlot.first,
                liveClientParent: curr
            };
            serverSlotIndex += 1;
            clientSlotIndex += 1;
            continue;
        }
        const origKid = origSlot.first;
        const currKid = currSlot.first;
        if (!origKid) return {
            server: null,
            client: currKid ?? null,
            liveClientParent: curr
        };
        if (!currKid) return {
            server: origKid,
            client: null,
            liveClientParent: curr
        };
        const inner = $031ca73a8e6c4249$export$5bf2ea18a7b75f2e(origKid, currKid);
        if (inner) // Inner frame already set the deepest live parent; keep it.
        return inner;
        serverSlotIndex += 1;
        clientSlotIndex += 1;
    }
    return null;
};
/**
 * Returns the outermost failed boundary markers — those not nested inside another failed marker.
 */ const $031ca73a8e6c4249$var$getOutermostFailedMarkers = (boundaryData)=>{
    const { failedBoundaryMarkers: failedBoundaryMarkers, nestedMarkersByMarker: nestedMarkersByMarker } = boundaryData;
    const nested = new Set();
    for (const marker of failedBoundaryMarkers){
        for (const child of nestedMarkersByMarker.get(marker) ?? [])if (failedBoundaryMarkers.has(child)) nested.add(child);
    }
    return [
        ...failedBoundaryMarkers
    ].filter((m)=>!nested.has(m));
};
const $031ca73a8e6c4249$var$toLiveAnchor = (node, fallback)=>node instanceof HTMLElement ? node : node?.parentElement ?? fallback;
const $031ca73a8e6c4249$export$df033797a0806ce9 = (stats)=>{
    const { boundaryData: boundaryData } = stats;
    if (!boundaryData) return null;
    const outermostMarkers = $031ca73a8e6c4249$var$getOutermostFailedMarkers(boundaryData);
    if (outermostMarkers.length === 0) return null;
    // When multiple outermost boundaries share the same parent they are adjacent siblings —
    // slot reconstruction is ambiguous in that case, so bail out.
    // (When each boundary has a distinct parent we still only process the first one below.)
    if (outermostMarkers.length > 1) {
        const parents = new Set(outermostMarkers.map((m)=>boundaryData.capturedParentByMarker.get(m)));
        if (parents.size < outermostMarkers.length) // two or more boundaries share the same parent — adjacent siblings, unsupported
        return null;
    }
    const marker = outermostMarkers[0];
    const parent = boundaryData.capturedParentByMarker.get(marker) ?? null;
    if (!parent) return null;
    const origChildren = boundaryData.capturedTopLevelChildrenByMarker.get(marker) ?? [];
    if (origChildren.length === 0) return null;
    const slotIndex = boundaryData.capturedSlotIndexByMarker.get(marker) ?? -1;
    if (slotIndex < 0) return null;
    // Current filtered element children of the preserved parent
    const currentFilteredChildren = $031ca73a8e6c4249$var$getSlotFilteredChildren(parent);
    // Slice the current children at the same slot range as the original boundary content.
    // Use all remaining current children from slotIndex so extra client-side nodes are visible.
    const currChildren = currentFilteredChildren.slice(slotIndex);
    const parentAnchor = parent instanceof HTMLElement ? parent : null;
    const len = Math.max(origChildren.length, currChildren.length);
    for(let i = 0; i < len; i++){
        const orig = origChildren[i];
        const curr = currChildren[i];
        // Best fallback: the previous live sibling, or the parent as last resort
        const prevSibling = i > 0 ? currChildren[i - 1] : null;
        const bestFallback = $031ca73a8e6c4249$var$toLiveAnchor(prevSibling ?? null, parentAnchor);
        if (!orig) return {
            kind: 'extra',
            serverNode: null,
            clientNode: curr ?? null,
            liveAnchor: $031ca73a8e6c4249$var$toLiveAnchor(curr ?? null, bestFallback)
        };
        if (!curr) return {
            kind: 'missing',
            serverNode: orig,
            clientNode: null,
            liveAnchor: bestFallback
        };
        const mismatch = $031ca73a8e6c4249$export$5bf2ea18a7b75f2e(orig, curr);
        if (mismatch) return {
            kind: 'difference',
            serverNode: mismatch.server,
            clientNode: mismatch.client,
            liveAnchor: $031ca73a8e6c4249$var$toLiveAnchor(mismatch.client ?? mismatch.liveClientParent, bestFallback)
        };
    }
    return null;
};

});


parcelRegister("kb8yj", function(module, exports) {
$parcel$export(module.exports, "TopNavEntry", () => $fc4d738f4da0d9ec$export$194fc621d194b861);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $1stXX = parcelRequire("1stXX");

var $kWCfK = parcelRequire("kWCfK");

var $8vVbH = parcelRequire("8vVbH");


var $fLawW = parcelRequire("fLawW");

var $6MMSf = parcelRequire("6MMSf");

var $a8EUd = parcelRequire("a8EUd");

var $bzSUP = parcelRequire("bzSUP");

var $ejH7R = parcelRequire("ejH7R");
const $fc4d738f4da0d9ec$var$LegacyPageNavigationStyles = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: 24px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $8d2c01fb745e4772$export$d60454526e2281af)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $8d2c01fb745e4772$export$d60454526e2281af)}); } /* admin project dir hack */
                `
        }
    });
$fc4d738f4da0d9ec$var$LegacyPageNavigationStyles.displayName = "LegacyPageNavigationStyles";
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $fc4d738f4da0d9ec$var$TEST_ID = 'page-layout.top-nav';
function $fc4d738f4da0d9ec$export$194fc621d194b861() {
    const { shouldRender: shouldRender } = (0, $fLawW.useTopNavState)();
    const theme = (0, $1stXX.useNav4Theme)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fc4d738f4da0d9ec$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.TopNavigation), {
        testId: $fc4d738f4da0d9ec$var$TEST_ID,
        theme: theme
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8vVbH.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.PlaceholderWithNativeSuspense), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kWCfK.JiraAtlassianNavigationSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.ReportSSRFailOnUse), {
            pageId: "navigation",
            fallbackId: "TopNav",
            displayErrorInStaging: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ejH7R.AsyncAtlassianNavigation), null)))));
}
$fc4d738f4da0d9ec$export$194fc621d194b861.displayName = "TopNavEntry";

});
parcelRegister("1stXX", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $6e62798c43abb2d9$export$93d4e7f90805808f);
$parcel$export(module.exports, "useNav4Theme", () => $6e62798c43abb2d9$export$b761e7abf0bdf352);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7Zyu5 = parcelRequire("7Zyu5");

var $aej1R = parcelRequire("aej1R");

var $4C7HL = parcelRequire("4C7HL");

var $bgHVp = parcelRequire("bgHVp");

var $eg2ws = parcelRequire("eg2ws");

var $90fvu = parcelRequire("90fvu");

var $hGMDz = parcelRequire("hGMDz");
const $6e62798c43abb2d9$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $6e62798c43abb2d9$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($6e62798c43abb2d9$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $bgHVp.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $hGMDz.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $6e62798c43abb2d9$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $7Zyu5.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $6e62798c43abb2d9$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $eg2ws.useTheme)();
    const isDarkMode = $6e62798c43abb2d9$var$useIsDarkThemeResolver();
    const bg = (0, $euxye.useMemo)(()=>$6e62798c43abb2d9$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $euxye.useEffect)(()=>{
        (0, $90fvu.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $aej1R.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};
const $6e62798c43abb2d9$export$b761e7abf0bdf352 = ()=>{
    /**
   * The colors chosen by the site admin in the site settings
   */ const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $eg2ws.useTheme)();
    /**
   * Whether the user is currently using dark mode,
   * or their configured preference if this is SSR.
   */ const isDarkMode = $6e62798c43abb2d9$var$useIsDarkThemeResolver();
    /**
   * The adjusted background color.
   *
   * When the user is in dark mode, the lightness of the background color is capped.
   */ const bg = (0, $euxye.useMemo)(()=>$6e62798c43abb2d9$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    /**
   * Creates / updates a theme-color meta tag:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color
   *
   * Some browsers will use this to change the color of their UI.
   */ (0, $euxye.useEffect)(()=>{
        (0, $90fvu.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return {
        backgroundColor: bg,
        highlightColor: highlightColor
    };
};

});
parcelRegister("90fvu", function(module, exports) {
$parcel$export(module.exports, "addThemeColor", () => $4435e0960e6775f8$export$7b20d133831b2b0f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $4435e0960e6775f8$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`); // oxlint-disable-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $4435e0960e6775f8$var$getHead = ()=>document.head || document.querySelector('head');
const $4435e0960e6775f8$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $4435e0960e6775f8$var$getMetaNode('theme-color');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $4435e0960e6775f8$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("hGMDz", function(module, exports) {
$parcel$export(module.exports, "capLightness", () => $f1f397bbe65c4823$export$8b5544bab97b10dd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $f1f397bbe65c4823$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $f1f397bbe65c4823$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $f1f397bbe65c4823$var$rgbFromHex = (input)=>{
    const fullHex = $f1f397bbe65c4823$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $f1f397bbe65c4823$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $f1f397bbe65c4823$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $f1f397bbe65c4823$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $f1f397bbe65c4823$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $f1f397bbe65c4823$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $f1f397bbe65c4823$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $f1f397bbe65c4823$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $f1f397bbe65c4823$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $f1f397bbe65c4823$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $f1f397bbe65c4823$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $f1f397bbe65c4823$var$rgbToLch = (rgb)=>$f1f397bbe65c4823$var$labToLch($f1f397bbe65c4823$var$xyzToLab($f1f397bbe65c4823$var$rgbToXyz(rgb)));
const $f1f397bbe65c4823$var$lchToRgb = (lch)=>$f1f397bbe65c4823$var$xyzToRgb($f1f397bbe65c4823$var$labToXyz($f1f397bbe65c4823$var$lchToLab(lch)));
const $f1f397bbe65c4823$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $f1f397bbe65c4823$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $f1f397bbe65c4823$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $f1f397bbe65c4823$var$clamp(capPercent, 0, 100);
    return $f1f397bbe65c4823$var$rgbToHex($f1f397bbe65c4823$var$lchToRgb(lch));
};

});


parcelRegister("kWCfK", function(module, exports) {
$parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", () => $c3188893f75d8770$export$38e532bc6b824200);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1stXX = parcelRequire("1stXX");

var $3Fes0 = parcelRequire("3Fes0");

var $2D2gW = parcelRequire("2D2gW");
const $c3188893f75d8770$export$38e532bc6b824200 = ()=>{
    const theme = (0, $1stXX.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3Fes0.NavigationSkeleton), {
        theme: theme
    }));
};
$c3188893f75d8770$export$38e532bc6b824200.displayName = "JiraAtlassianNavigationSkeleton";

});
parcelRegister("3Fes0", function(module, exports) {
$parcel$export(module.exports, "NavigationSkeleton", () => $546f21b4f618d1d2$export$ad5e8e6ace98cc2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");


var $dQBft = parcelRequire("dQBft");
var $aCRoy = parcelRequire("aCRoy");

var $klWNq = parcelRequire("klWNq");

var $l16ha = parcelRequire("l16ha");

var $4aNVh = parcelRequire("4aNVh");

var $e1rfQ = parcelRequire("e1rfQ");

var $cgsmC = parcelRequire("cgsmC");
function $546f21b4f618d1d2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $546f21b4f618d1d2$var$containerStyles = /*#__PURE__*/ (0, $hStPE.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $3bbd74a2110c6dfd$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $546f21b4f618d1d2$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $546f21b4f618d1d2$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $546f21b4f618d1d2$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, $dQBft.defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $aCRoy.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $546f21b4f618d1d2$var$containerStyles,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $546f21b4f618d1d2$var$leftStyles
    }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $klWNq.IconButtonSkeleton), {
        marginLeft: 0,
        marginRight: 5,
        size: 26
    }), /*#__PURE__*/ (0, $hStPE.jsx)((0, $4aNVh.ProductHomeSkeleton), {
        showSiteName: showSiteName
    }), /*#__PURE__*/ (0, $hStPE.jsx)((0, $l16ha.PrimaryItemsContainerSkeleton), {
        count: primaryItemsCount
    })), /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $546f21b4f618d1d2$var$rightStyles
    }, shouldShowSearch && /*#__PURE__*/ (0, $hStPE.jsx)((0, $cgsmC.SearchSkeleton), null), Array.from({
        length: secondaryItemsCount
    }, (_, index)=>/*#__PURE__*/ (0, $hStPE.jsx)((0, $klWNq.IconButtonSkeleton), {
            key: index,
            marginLeft: 0,
            marginRight: 4,
            size: 26
        })), /*#__PURE__*/ (0, $hStPE.jsx)((0, $e1rfQ.ProfileSkeleton), null))));
};
$546f21b4f618d1d2$export$ad5e8e6ace98cc2.displayName = "NavigationSkeleton";

});
/**
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $3bbd74a2110c6dfd$export$30fa7cc5f2690a43 = 56;
const $3bbd74a2110c6dfd$export$4033a111ca79977d = 1280;
const $3bbd74a2110c6dfd$export$24ec62cee78b7042 = 1130;
const $3bbd74a2110c6dfd$export$d8bde68ac946124f = '--ds--ans--fbc';
const $3bbd74a2110c6dfd$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $3bbd74a2110c6dfd$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $3bbd74a2110c6dfd$export$d81606c1fc5119bc = '--ds--ans--c';
const $3bbd74a2110c6dfd$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("aCRoy", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $eb6353f5667b8ba0$export$d8964aec282183a3);

var $iutmg = parcelRequire("iutmg");
const $eb6353f5667b8ba0$export$d8964aec282183a3 = (0, $iutmg.ThemeContext).Provider;

});

parcelRegister("klWNq", function(module, exports) {
$parcel$export(module.exports, "IconButtonSkeleton", () => $cc3bd37fb968631f$export$7a24471cb6f25433);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $g4X1T = parcelRequire("g4X1T");
function $cc3bd37fb968631f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc3bd37fb968631f$var$buttonHeight = "var(--ds-space-400, 32px)";
const $cc3bd37fb968631f$var$skeletonStyles = {
    name: "1shcc5h",
    styles: "border-radius:var(--ds-radius-full, 50%);opacity:0.15"
};
const $cc3bd37fb968631f$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
    const theme = (0, $g4X1T.useTheme)();
    const dynamicStyles = {
        marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
        marginRight: typeof marginRight === 'number' ? marginRight : 0,
        width: typeof size === 'number' ? size : $cc3bd37fb968631f$var$buttonHeight,
        height: typeof size === 'number' ? size : $cc3bd37fb968631f$var$buttonHeight,
        ...theme.mode.skeleton
    };
    return /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: $cc3bd37fb968631f$var$skeletonStyles
    });
};
$cc3bd37fb968631f$export$7a24471cb6f25433.displayName = "IconButtonSkeleton";

});

parcelRegister("l16ha", function(module, exports) {
$parcel$export(module.exports, "PrimaryItemsContainerSkeleton", () => $c554d687ffc16945$export$fdfc48d2117b79a8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $jZdQw = parcelRequire("jZdQw");
function $c554d687ffc16945$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c554d687ffc16945$var$primaryButtonSkeletonStyles = {
    name: "yn5kop",
    styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
};
const $c554d687ffc16945$export$fdfc48d2117b79a8 = /*#__PURE__*/ (0, $euxye.memo)(({ count: count })=>/*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, $hStPE.jsx)((0, $jZdQw.PrimaryButtonSkeleton), {
            key: index,
            css: $c554d687ffc16945$var$primaryButtonSkeletonStyles
        }))));

});
parcelRegister("jZdQw", function(module, exports) {
$parcel$export(module.exports, "PrimaryButtonSkeleton", () => $379baaf6eee55ebb$export$4bc51fe36728414d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $g4X1T = parcelRequire("g4X1T");
const $379baaf6eee55ebb$var$paddingAll = 4;
const $379baaf6eee55ebb$var$buttonHeight = 32;
const $379baaf6eee55ebb$var$skeletonStyles = /*#__PURE__*/ (0, $hStPE.css)({
    display: 'inline-flex',
    width: '68px',
    height: `${$379baaf6eee55ebb$var$buttonHeight - $379baaf6eee55ebb$var$paddingAll * 2.5}px`,
    borderRadius: "var(--ds-radius-small, 4px)",
    opacity: 0.15
});
const $379baaf6eee55ebb$export$4bc51fe36728414d = (props)=>{
    const theme = (0, $g4X1T.useTheme)();
    return /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $379baaf6eee55ebb$var$skeletonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    });
};
$379baaf6eee55ebb$export$4bc51fe36728414d.displayName = "PrimaryButtonSkeleton";

});


parcelRegister("4aNVh", function(module, exports) {
$parcel$export(module.exports, "ProductHomeSkeleton", () => $fb9c7fb87c8653c1$export$3e79e535d76cce4b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");


var $g4X1T = parcelRequire("g4X1T");

var $diUAX = parcelRequire("diUAX");
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $fb9c7fb87c8653c1$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
const $fb9c7fb87c8653c1$var$productHomeButtonStyles = /*#__PURE__*/ (0, $hStPE.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:active': {
        backgroundColor: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus': {
        backgroundColor: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        boxShadow: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
        color: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: 0
    },
    '&:hover': {
        backgroundColor: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $3bbd74a2110c6dfd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $3bbd74a2110c6dfd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $fb9c7fb87c8653c1$var$productLogoStyles = /*#__PURE__*/ (0, $hStPE.css)({
    display: 'flex',
    width: 120,
    maxWidth: 120,
    height: 24,
    maxHeight: 28,
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $3bbd74a2110c6dfd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $fb9c7fb87c8653c1$var$productIconStyles = /*#__PURE__*/ (0, $hStPE.css)({
    display: 'flex',
    width: 28,
    height: 28,
    borderRadius: "var(--ds-radius-full, 50%)",
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $3bbd74a2110c6dfd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $fb9c7fb87c8653c1$var$siteTitleStyles = /*#__PURE__*/ (0, $hStPE.css)({
    display: 'flex',
    width: "var(--ds-space-500, 40px)",
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        width: '100%',
        height: 14,
        backgroundColor: `var(${$fb9c7fb87c8653c1$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
        borderRadius: "var(--ds-radius-small, 4px)",
        content: '""'
    }
});
const $fb9c7fb87c8653c1$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
    const theme = (0, $g4X1T.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const productHomeButtonDynamicStyles = (0, $diUAX.stripEmptyProperties)({
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$fb9c7fb87c8653c1$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$fb9c7fb87c8653c1$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    });
    const siteTitleDynamicStyles = {
        borderRight: theme.mode.productHome.borderRight,
        opacity: theme.mode.skeleton.opacity,
        [$fb9c7fb87c8653c1$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    };
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), null, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $fb9c7fb87c8653c1$var$productHomeButtonStyles
    }, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $fb9c7fb87c8653c1$var$productLogoStyles
    }), /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $fb9c7fb87c8653c1$var$productIconStyles
    })), showSiteName && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: siteTitleDynamicStyles,
        css: $fb9c7fb87c8653c1$var$siteTitleStyles
    }));
};
$fb9c7fb87c8653c1$export$3e79e535d76cce4b.displayName = "ProductHomeSkeleton";

});
parcelRegister("diUAX", function(module, exports) {
$parcel$export(module.exports, "stripEmptyProperties", () => $276df01c4a81bf87$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $276df01c4a81bf87$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});


parcelRegister("e1rfQ", function(module, exports) {
$parcel$export(module.exports, "ProfileSkeleton", () => $2175c3a60981a3ec$export$2bab43fd33adda3b);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $klWNq = parcelRequire("klWNq");
const $2175c3a60981a3ec$export$2bab43fd33adda3b = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $klWNq.IconButtonSkeleton), {
        marginLeft: 6,
        marginRight: 6,
        size: 26
    });
$2175c3a60981a3ec$export$2bab43fd33adda3b.displayName = "ProfileSkeleton";

});

parcelRegister("cgsmC", function(module, exports) {
$parcel$export(module.exports, "SearchSkeleton", () => $9863976cd97fa283$export$d8fbade3e5bbb8e0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");


var $g4X1T = parcelRequire("g4X1T");

var $klWNq = parcelRequire("klWNq");
const $9863976cd97fa283$var$searchInputContainerStyles = /*#__PURE__*/ (0, $hStPE.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: "var(--ds-space-250, 20px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $3bbd74a2110c6dfd$export$24ec62cee78b7042) - 1}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $9863976cd97fa283$var$searchInputSkeletonStyles = /*#__PURE__*/ (0, $hStPE.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderRadius: "var(--ds-radius-large, 6px)",
    opacity: 0.15
});
const $9863976cd97fa283$var$searchIconStyles = /*#__PURE__*/ (0, $hStPE.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $3bbd74a2110c6dfd$export$24ec62cee78b7042}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $9863976cd97fa283$export$d8fbade3e5bbb8e0 = ()=>{
    const theme = (0, $g4X1T.useTheme)();
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), null, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $9863976cd97fa283$var$searchInputContainerStyles
    }, /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $9863976cd97fa283$var$searchInputSkeletonStyles
    })), /*#__PURE__*/ (0, $hStPE.jsx)((0, $klWNq.IconButtonSkeleton), {
        css: $9863976cd97fa283$var$searchIconStyles,
        marginRight: 5,
        size: 26
    }));
};
$9863976cd97fa283$export$d8fbade3e5bbb8e0.displayName = "SearchSkeleton";

});



parcelRegister("8vVbH", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigationStart", () => $ee97e7460ae14a82$export$831e6a6e875b5ef8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");


var $OPiBr = parcelRequire("OPiBr");

var $2yVPv = parcelRequire("2yVPv");

var $bc9Gj = parcelRequire("bc9Gj");
const $ee97e7460ae14a82$export$831e6a6e875b5ef8 = ()=>{
    const [{ location: location }] = (0, $bc9Gj.useRouter)();
    const { setAppStartWithAppId: setAppStartWithAppId } = (0, $OPiBr.useSpaStateActions)();
    (0, $2yVPv.usePageId)();
    const startRef = (0, $euxye.useRef)({
        location: location,
        startTime: Date.now()
    });
    (0, $euxye.useMemo)(()=>{
        if (location !== startRef.current.location) startRef.current = {
            location: location,
            startTime: Date.now()
        };
    }, [
        location
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        setAppStartWithAppId((0, $70e36d23224a09de$export$3a54edb6ba4daa82), startRef.current.startTime);
    }, [
        location,
        setAppStartWithAppId
    ]);
    return null;
};
$ee97e7460ae14a82$export$831e6a6e875b5ef8.displayName = "AtlassianNavigationStart";

});

/* eslint-disable jira/filename-case */ // We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @jira/design-system__navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $8d2c01fb745e4772$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $8d2c01fb745e4772$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $8d2c01fb745e4772$export$638757b621fbf475 = `${$8d2c01fb745e4772$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$8d2c01fb745e4772$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $8d2c01fb745e4772$export$d60454526e2281af = `(${$8d2c01fb745e4772$export$638757b621fbf475})`;

parcelRegister("fLawW", function(module, exports) {
$parcel$export(module.exports, "useTopNavState", () => $6a3cf0c0225783aa$export$bccbd45ab793bd09);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $7Sa0x = parcelRequire("7Sa0x");
const $6a3cf0c0225783aa$var$useTopNav = (0, $3h1FP.createHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>({
            ...state.topNavigation,
            shouldRender: !state.isChromeless
        })
});
const $6a3cf0c0225783aa$export$bccbd45ab793bd09 = ()=>{
    const [state] = $6a3cf0c0225783aa$var$useTopNav();
    return state;
};

});

parcelRegister("6MMSf", function(module, exports) {
$parcel$export(module.exports, "PageLayout", () => $7e6937361162ca5e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $7e6937361162ca5e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $7e6937361162ca5e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "Main", () => $7e6937361162ca5e$export$861edd1ccea2f746);
$parcel$export(module.exports, "RightSidebar", () => $7e6937361162ca5e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $7e6937361162ca5e$export$364a989a35814102);
$parcel$export(module.exports, "usePageLayoutResize", () => $7e6937361162ca5e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $7e6937361162ca5e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $7e6937361162ca5e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $7e6937361162ca5e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $7e6937361162ca5e$export$d697087c06fd5e25);
/* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $eRc9j = parcelRequire("eRc9j");

var $5Km63 = parcelRequire("5Km63");

var $jFgvQ = parcelRequire("jFgvQ");

var $kLUS0 = parcelRequire("kLUS0");

var $17vVh = parcelRequire("17vVh");

var $kYJqR = parcelRequire("kYJqR");

var $7GI4h = parcelRequire("7GI4h");

var $av7P9 = parcelRequire("av7P9");


var $jndX2 = parcelRequire("jndX2");

var $i860n = parcelRequire("i860n");
function $7e6937361162ca5e$export$6d1402fb58384e4f({ testId: testId, children: children, defaultSideNavCollapsed: defaultSideNavCollapsed, isSideNavShortcutEnabled: isSideNavShortcutEnabled }) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    if ((0, $i860n.fg)('navx-ribbon-rollout')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jndX2.GlobalRoot), {
        app: "jira",
        appLabel: "Jira",
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: testId,
        defaultSideNavCollapsed: isFhsEnabled ? defaultSideNavCollapsed : undefined,
        isSideNavShortcutEnabled: isSideNavShortcutEnabled,
        isRibbonEnabled: true,
        TopNavSlot: null
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $17vVh.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: testId,
        defaultSideNavCollapsed: isFhsEnabled ? defaultSideNavCollapsed : undefined,
        isSideNavShortcutEnabled: isSideNavShortcutEnabled
    }, children);
}
$7e6937361162ca5e$export$6d1402fb58384e4f.displayName = "PageLayout";
function $7e6937361162ca5e$export$3b4e64e77073e307({ height: height, testId: testId, id: id, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Km63.Banner), {
        height: height,
        testId: testId,
        id: id
    }, children);
}
$7e6937361162ca5e$export$3b4e64e77073e307.displayName = "Banner";
function $7e6937361162ca5e$export$8a421bddecb2bf5b({ height: height, testId: testId, theme: theme, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7GI4h.TopNav), {
        height: height,
        testId: testId,
        customTheme: theme
    }, children);
}
$7e6937361162ca5e$export$8a421bddecb2bf5b.displayName = "TopNavigation";
function $7e6937361162ca5e$export$43ae342508cf8cc9({ width: width, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNav), {
        defaultWidth: width,
        testId: testId
    }, children);
}
$7e6937361162ca5e$export$43ae342508cf8cc9.displayName = "LeftSidebarWithoutResize";
function $7e6937361162ca5e$export$3cabf771c4f2de({ collapsedState: collapsedState, width: width, testId: testId, children: children }) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNav), {
        defaultCollapsed: isFhsEnabled ? undefined : collapsedState === 'collapsed',
        defaultWidth: width,
        testId: testId
    }, children);
}
$7e6937361162ca5e$export$3cabf771c4f2de.displayName = "LeftSidebar";
function $7e6937361162ca5e$export$861edd1ccea2f746({ testId: testId, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jFgvQ.Main), {
        testId: testId
    }, children);
}
$7e6937361162ca5e$export$861edd1ccea2f746.displayName = "Main";
function $7e6937361162ca5e$export$84d58c19c21f637f({ width: width, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eRc9j.Aside), {
        defaultWidth: width,
        testId: testId
    }, children);
}
$7e6937361162ca5e$export$84d58c19c21f637f.displayName = "RightSidebar";
function $7e6937361162ca5e$export$364a989a35814102({ width: width, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kLUS0.Panel), {
        defaultWidth: width,
        testId: testId
    }, children);
}
$7e6937361162ca5e$export$364a989a35814102.displayName = "RightPanel";
// A mock value is needed to match the signature of the hook
const $7e6937361162ca5e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
};
const $7e6937361162ca5e$export$10c7104037a7af62 = ()=>$7e6937361162ca5e$var$mockPageLayoutResize;
const $7e6937361162ca5e$export$991ef8098f87814a = (0, $7c8e8130cce4c6fa$export$ed7cc0d417ee89e);
const $7e6937361162ca5e$export$7eaf986ecb4d5cac = (0, $7c8e8130cce4c6fa$export$f963aecf2d4465bd);
const $7e6937361162ca5e$export$e95b388ca8c92019 = (0, $7c8e8130cce4c6fa$export$f897e1ed9f8ed251);
const $7e6937361162ca5e$export$2ab8b83eed76656c = (0, $7c8e8130cce4c6fa$export$750459958906793);
const $7e6937361162ca5e$export$ac017575d43f5da = (0, $7c8e8130cce4c6fa$export$b44ab66843c05a69);
const $7e6937361162ca5e$export$d697087c06fd5e25 = (0, $7c8e8130cce4c6fa$export$aeff86a16f13529);

});
/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $7c8e8130cce4c6fa$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $7c8e8130cce4c6fa$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $7c8e8130cce4c6fa$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $7c8e8130cce4c6fa$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $7c8e8130cce4c6fa$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $7c8e8130cce4c6fa$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';


parcelRegister("ejH7R", function(module, exports) {
$parcel$export(module.exports, "AsyncAtlassianNavigation", () => $683b45a2224c4245$export$932edb7b1b20d079);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $TTcqD = parcelRequire("TTcqD");

var $kWCfK = parcelRequire("kWCfK");

var $gCmql = parcelRequire("gCmql");

var $lhWE3 = parcelRequire("lhWE3");


var $btoiF = parcelRequire("btoiF");

var $dsVXF = parcelRequire("dsVXF");

var $iLktG = parcelRequire("iLktG");

var $4Onaa = parcelRequire("4Onaa");

var $bzSUP = parcelRequire("bzSUP");

var $53DCS = parcelRequire("53DCS");
const $683b45a2224c4245$export$932edb7b1b20d079 = ()=>{
    const topNavEntryPointReference = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$bec6dca2e63de4ae));
    (0, $euxye.useState)(()=>{
        if (!false && topNavEntryPointReference) (0, $53DCS.topNavEntryPoint).root// @ts-expect-error - TS2339 - We're using JSResourceReference from @atlassian/react-async.
        .onComplete(()=>{
            (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $lhWE3.JS_EVAL_START))) {
                (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return undefined;
    });
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    const isPageHydrating = (0, $TTcqD.useIsHydrateRenderMode)();
    return topNavEntryPointReference ? // There is already a Placeholder in parent
    // remove this one when EntryPointPlaceholder merges with Placeholder
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kWCfK.JiraAtlassianNavigationSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.ReportSSRFailOnUse), {
            pageId: "navigation",
            fallbackId: "TopNavEntryPoint",
            displayErrorInStaging: true
        })),
        entryPointReference: topNavEntryPointReference,
        isSSRPlaceholderEnabled: !isPageHydrating ? currentRoute.entryPointOptions?.isSSRPlaceholderEnabled : undefined
    }, topNavEntryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
        entryPointReference: topNavEntryPointReference,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        props: {}
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gCmql.TopNavigation), null);
};
$683b45a2224c4245$export$932edb7b1b20d079.displayName = "AsyncAtlassianNavigation";

});
parcelRegister("gCmql", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "TopNavigation", () => $be774702eb2b517b$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "TopNavContent", () => $be774702eb2b517b$export$b2b29f12a28e3baa);
$parcel$export(module.exports, "default", () => $be774702eb2b517b$export$2e2bcd8739ae039);

var $izdWD = parcelRequire("izdWD");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $beOCh = parcelRequire("beOCh");

var $1stXX = parcelRequire("1stXX");

var $7I1eK = parcelRequire("7I1eK");
var $eLpG2 = parcelRequire("eLpG2");
var $2pWfK = parcelRequire("2pWfK");

var $kYJqR = parcelRequire("kYJqR");

var $av7P9 = parcelRequire("av7P9");

var $9Y5Vz = parcelRequire("9Y5Vz");

var $bgHVp = parcelRequire("bgHVp");

var $7Odw0 = parcelRequire("7Odw0");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $bs9jJ = parcelRequire("bs9jJ");

var $kt86l = parcelRequire("kt86l");

var $kmiSB = parcelRequire("kmiSB");

var $bjVy2 = parcelRequire("bjVy2");

var $7lFpk = parcelRequire("7lFpk");

var $i3WUK = parcelRequire("i3WUK");

var $kvdDU = parcelRequire("kvdDU");

var $gDdYI = parcelRequire("gDdYI");

var $a5nxD = parcelRequire("a5nxD");

var $aZMdt = parcelRequire("aZMdt");
var $aJ81Y = parcelRequire("aJ81Y");


var $htsFl = parcelRequire("htsFl");

var $cvA2R = parcelRequire("cvA2R");




var $c9cNX = parcelRequire("c9cNX");

var $bQpVj = parcelRequire("bQpVj");

var $2KMaX = parcelRequire("2KMaX");

var $1IUl9 = parcelRequire("1IUl9");

var $ei93K = parcelRequire("ei93K");

var $dB6nz = parcelRequire("dB6nz");

var $eSXIF = parcelRequire("eSXIF");

var $6OO20 = parcelRequire("6OO20");

var $5UJCz = parcelRequire("5UJCz");

var $8dSY2 = parcelRequire("8dSY2");

var $dERcp = parcelRequire("dERcp");

var $4cgti = parcelRequire("4cgti");

var $jrLL2 = parcelRequire("jrLL2");

var $jTo9C = parcelRequire("jTo9C");
const $be774702eb2b517b$var$sideNavToggleButtonCollapseLabel = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.side-nav-toggle-button-collapse-label",
    defaultMessage: "Collapse sidebar"
});
const $be774702eb2b517b$var$sideNavToggleButtonExpandLabel = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.side-nav-toggle-button-expand-label",
    defaultMessage: "Expand sidebar"
});
const $be774702eb2b517b$var$sideNavToggleButtonCollapseLabelWithShortcut = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.side-nav-toggle-button-collapse-label-with-shortcut",
    defaultMessage: "Collapse sidebar ["
});
const $be774702eb2b517b$var$sideNavToggleButtonExpandLabelWithShortcut = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.side-nav-toggle-button-expand-label-with-shortcut",
    defaultMessage: "Expand sidebar ["
});
function $be774702eb2b517b$var$HelpComponent({ QueryFragment: QueryFragment }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8dSY2.HelpButton), {
        QueryFragment: QueryFragment
    });
}
$be774702eb2b517b$var$HelpComponent.displayName = "HelpComponent";


const $be774702eb2b517b$var$Create = (parcelRequire("fgFqH")).default; // Feature gate off no-op: return the raw ref, preserving original behaviour
function $be774702eb2b517b$var$useQueryReferencePassthrough(current) {
    return current;
}
const $be774702eb2b517b$var$useStableQueryReference = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('tako-5534_topnav_project_suspense_fix'), (0, $jTo9C.useReadyQueryReference), $be774702eb2b517b$var$useQueryReferencePassthrough); // ============================================================================
function $be774702eb2b517b$export$8a421bddecb2bf5b() {
    const { queryReference: queryReference } = (0, $htsFl.useRelayResource)((0, $1IUl9.topNav4UIStateResource)); // Keep rendering the previous ref while a new one is in flight so route
    // changes (e.g. project navigation) don't flash the parent skeleton.
    const stableQueryReference = $be774702eb2b517b$var$useStableQueryReference(queryReference);
    if (!stableQueryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($be774702eb2b517b$var$TopNavBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($be774702eb2b517b$export$b2b29f12a28e3baa, {
        queryReference: stableQueryReference
    }));
} // ============================================================================
$be774702eb2b517b$export$8a421bddecb2bf5b.displayName = "TopNavigation";
function $be774702eb2b517b$export$b2b29f12a28e3baa({ queryReference: queryReference }) {
    const data = (0, $n67Vb.usePreloadedQuery)((0, $izdWD.default), queryReference);
    const theme = (0, $1stXX.useTheme)();
    const cloudId = (0, $kt86l.useCloudId)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const isMobileExperience = (0, $7Odw0.isSupportedUserAgent)();
    const setCustomThemeData = (0, $kmiSB.useSetCustomThemeData)(); // Set custom theme data for background and highlight colors
    const customThemeData = (0, $euxye.useMemo)(()=>({
            hasCustomBGColor: !!theme?.mode.navigation.backgroundColor,
            hasCustomHighlightColor: $be774702eb2b517b$var$getHasCustomHighlightColor(theme),
            cloudId: cloudId
        }), [
        cloudId,
        theme
    ]);
    (0, $euxye.useEffect)(()=>{
        setCustomThemeData(customThemeData);
    }, [
        setCustomThemeData,
        customThemeData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bjVy2.CustomThemeAnalytics), null, isMobileExperience && !(0, $i860n.fg)('jira_use_full_navigation_on_mobile') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($be774702eb2b517b$var$TopNavMobile, {
        data: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($be774702eb2b517b$var$TopNavDesktop, {
        data: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5UJCz.NavigationRouterListener), null), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kvdDU.default), null)));
}
$be774702eb2b517b$export$b2b29f12a28e3baa.displayName = "TopNavContent";
function $be774702eb2b517b$var$TopNavDesktop({ data: data }) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const siteTitleData = (0, $ei93K.useSiteTitle)();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const setCustomThemeData = (0, $kmiSB.useSetCustomThemeData)(); // Set custom theme data for site title
    const desktopSiteTitleData = (0, $euxye.useMemo)(()=>({
            hasCustomSiteTitle: !!siteTitle,
            customSiteTitleLength: siteTitle?.length || undefined
        }), [
        siteTitle
    ]);
    (0, $euxye.useEffect)(()=>{
        setCustomThemeData(desktopSiteTitleData);
    }, [
        setCustomThemeData,
        desktopSiteTitleData
    ]);
    const attributes = (0, $euxye.useMemo)(()=>({
            navigationLayer: (0, $fad9173ee481d7de$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $192a2eeaa0a1dbf6$export$793ed84f5e13fedc),
            navState: (0, $3b258ee19859baa5$export$2bd315ece9f68967)
        }), []);
    const onClickSideNavToggleButton = (0, $euxye.useCallback)((_, analyticsEvent, _attributes)=>{
        const payload = (0, $c9cNX.getSideNavToggleButtonAnalyticEventPayload)(_attributes?.isSideNavVisible);
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, payload);
    }, []);
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $2KMaX.useLeftSidebarState)();
    const defaultCollapsed = (0, $euxye.useMemo)(()=>{
        if ((0, $i860n.fg)('navx-global-side-nav')) return isLeftSidebarCollapsed ?? (0, $bQpVj.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
        return data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $bQpVj.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
    }, [
        data?.jira?.navigationUIState?.isLeftSidebarCollapsed,
        isLeftSidebarCollapsed
    ]);
    const sideNavToggleButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYJqR.SideNavToggleButton), {
        defaultCollapsed: isFhsEnabled ? undefined : defaultCollapsed,
        onClick: onClickSideNavToggleButton,
        collapseLabel: isFhsEnabled ? formatMessage($be774702eb2b517b$var$sideNavToggleButtonCollapseLabel) : formatMessage($be774702eb2b517b$var$sideNavToggleButtonCollapseLabelWithShortcut),
        expandLabel: isFhsEnabled ? formatMessage($be774702eb2b517b$var$sideNavToggleButtonExpandLabel) : formatMessage($be774702eb2b517b$var$sideNavToggleButtonExpandLabelWithShortcut)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2pWfK.TopNavStart), {
        sideNavToggleButton: sideNavToggleButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i3WUK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jrLL2.ProductHomeWithQuery), {
        queryReference: data
    }), siteTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Y5Vz.CustomTitle), null, siteTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eLpG2.TopNavMiddle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6OO20.Search), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($be774702eb2b517b$var$Create, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7I1eK.TopNavEnd), null, (0, $i860n.fg)('jsm_gp_awareness_pill') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $beOCh.AsyncGPAwarenessPill), {
        analyticsOrigin: "navBar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7lFpk.EditionAwareness), {
        editionAwarenessQueryFragment: data
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dERcp.ConversationAssistant), null), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dB6nz.Nav4NotificationsData), {
        queryReference: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($be774702eb2b517b$var$HelpComponent, {
        QueryFragment: isAnonymous ? null : data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eSXIF.Settings), {
        settingsActionQueryFragment: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4cgti.ProfileNew), {
        queryReference: data
    })));
}
$be774702eb2b517b$var$TopNavDesktop.displayName = "TopNavDesktop";
function $be774702eb2b517b$var$TopNavMobile({ data: data }) {
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const siteTitleDataHook = (0, $ei93K.useSiteTitle)();
    const siteTitle = siteTitleDataHook.shouldShow && siteTitleDataHook.value || undefined;
    const setCustomThemeData = (0, $kmiSB.useSetCustomThemeData)(); // Set custom theme data for site title
    const mobileSiteTitleData = (0, $euxye.useMemo)(()=>({
            hasCustomSiteTitle: !!siteTitle,
            customSiteTitleLength: siteTitle?.length || undefined
        }), [
        siteTitle
    ]);
    (0, $euxye.useEffect)(()=>{
        setCustomThemeData(mobileSiteTitleData);
    }, [
        setCustomThemeData,
        mobileSiteTitleData
    ]);
    const attributes = (0, $euxye.useMemo)(()=>({
            navigationLayer: (0, $fad9173ee481d7de$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $192a2eeaa0a1dbf6$export$793ed84f5e13fedc),
            navState: (0, $3b258ee19859baa5$export$2bd315ece9f68967)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2pWfK.TopNavStart), {
        sideNavToggleButton: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jrLL2.ProductHomeWithQuery), {
        queryReference: data
    }), siteTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9Y5Vz.CustomTitle), null, siteTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eLpG2.TopNavMiddle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6OO20.Search), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($be774702eb2b517b$var$Create, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7I1eK.TopNavEnd), null, (0, $i860n.fg)('jsm_gp_awareness_pill') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $beOCh.AsyncGPAwarenessPill), {
        analyticsOrigin: "navBar"
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dB6nz.Nav4NotificationsData), {
        queryReference: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4cgti.ProfileNew), {
        queryReference: data
    })));
}
$be774702eb2b517b$var$TopNavMobile.displayName = "TopNavMobile";
function $be774702eb2b517b$var$TopNavBoundary({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "atlaskit-atlassian-navigation-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a5nxD.JiraHoldoutCustomData), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "AtlaskitAtlassianNavigationNav4",
        packageName: (0, $5f6e091542d432a9$export$b8b9d90f9e5bd72b),
        teamName: (0, $5f6e091542d432a9$export$d57b6b390e78d90f),
        fallback: "flag"
    }, children));
} // ============================================================================
$be774702eb2b517b$var$TopNavBoundary.displayName = "TopNavBoundary";
// UTILITIES
// ============================================================================
/**
 * Check if the theme has a custom highlight color
 */ function $be774702eb2b517b$var$getHasCustomHighlightColor(theme) {
    if (!theme) return false; // Default create button background color in Nav4 is #0052CC
    // #0052CC is a legacy brand blue. In the non-legacy tokens, the general replacement is:
    //   • Token name: color.link
    //   • CSS variable: var(--ds-link)
    //   • Current hex in atlassian-light: #0C66E4
    // If the create button background color is different from this value, we consider it as a custom highlight color
    const tokenHighlightColor = (0, $bgHVp.default)('color.link');
    return theme.mode.create.default.backgroundColor !== tokenHighlightColor && // Failsafe check in case the token value is not what we expect
    theme.mode.create.default.backgroundColor !== '#0052CC';
}
var $be774702eb2b517b$export$2e2bcd8739ae039 = $be774702eb2b517b$export$8a421bddecb2bf5b;

});
parcelRegister("beOCh", function(module, exports) {
$parcel$export(module.exports, "AsyncGPAwarenessPill", () => $182171bb0595564a$export$1d8a1090b9b8aef0);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $bs9jJ = parcelRequire("bs9jJ");

var $ccEzE = parcelRequire("ccEzE");

var $d8LhJ = parcelRequire("d8LhJ");

var $i860n = parcelRequire("i860n");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $182171bb0595564a$var$LazyGPAwarenessPill = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("cDXK8")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/jsm-grace-period-banner/src/GpAwarenessPill.tsx"
});
const $182171bb0595564a$export$1d8a1090b9b8aef0 = (props)=>{
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    // Gate before rendering the lazy component to avoid loading unused code and unnecessary TTAI hold.
    if ((!isSiteAdmin || appEditions.serviceDesk !== (0, $d8LhJ.STANDARD_EDITION)) && (0, $i860n.fg)('perf-jsm-issue-view-ttai-horizontal-project-nav')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($182171bb0595564a$var$LazyGPAwarenessPill, props));
};
$182171bb0595564a$export$1d8a1090b9b8aef0.displayName = "AsyncGPAwarenessPill";

});
parcelRegister("cDXK8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fhMKD").then(()=>parcelRequire('8l9E8'));

});


parcelRegister("kmiSB", function(module, exports) {
$parcel$export(module.exports, "useCustomThemeData", () => $2154531a78d1e4f8$export$2ba58a45723c145b);
$parcel$export(module.exports, "useSetCustomThemeData", () => $2154531a78d1e4f8$export$2f61df8f2cb63ab2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $2154531a78d1e4f8$var$initialState = {};
const $2154531a78d1e4f8$var$store = (0, $5QDqc.createStore)({
    name: 'navigation-custom-theme-context',
    initialState: $2154531a78d1e4f8$var$initialState,
    actions: {
        update: (customThemeData)=>({ setState: setState })=>{
                setState(customThemeData);
            }
    }
});
const $2154531a78d1e4f8$export$2ba58a45723c145b = (0, $3h1FP.createStateHook)($2154531a78d1e4f8$var$store);
const $2154531a78d1e4f8$var$useCustomThemeContextActions = (0, $3h1FP.createActionsHook)($2154531a78d1e4f8$var$store);
const $2154531a78d1e4f8$export$2f61df8f2cb63ab2 = ()=>$2154531a78d1e4f8$var$useCustomThemeContextActions().update;

});

parcelRegister("bjVy2", function(module, exports) {
$parcel$export(module.exports, "CustomThemeAnalytics", () => $f1ac451086cc9c63$export$d7c6d40454148f57);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $kmiSB = parcelRequire("kmiSB");
function $f1ac451086cc9c63$export$d7c6d40454148f57({ children: children }) {
    const customThemeData = (0, $kmiSB.useCustomThemeData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        // Fire analytics only when all setters have finished
        const isThemeEvaluated = [
            'hasCustomBGColor',
            'hasCustomHighlightColor',
            'hasCustomLogo',
            'hasCustomSiteTitle'
        ].every((key)=>key in customThemeData);
        if (isThemeEvaluated) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'topNav',
            actionSubjectId: 'customTheme',
            attributes: {
                ...customThemeData
            },
            eventType: 'ui'
        }).fire('navigation');
    }, [
        customThemeData,
        createAnalyticsEvent
    ]);
    return children;
}
$f1ac451086cc9c63$export$d7c6d40454148f57.displayName = "CustomThemeAnalytics";

});

parcelRegister("7lFpk", function(module, exports) {
$parcel$export(module.exports, "EditionAwareness", () => $2e469dfefe58da04$export$a55b02efe3d62583);

var $7v04I = parcelRequire("7v04I");

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $h8QGu = parcelRequire("h8QGu");

var $f99M0 = parcelRequire("f99M0");

var $n67Vb = parcelRequire("n67Vb");

var $41FAq = parcelRequire("41FAq");

var $j1TMp = parcelRequire("j1TMp");

var $fbMby = parcelRequire("fbMby");

var $lQrcN = parcelRequire("lQrcN");

var $eCQdn = parcelRequire("eCQdn");

var $iQPOZ = parcelRequire("iQPOZ");

var $g3pW6 = parcelRequire("g3pW6");

var $aZMdt = parcelRequire("aZMdt");
var $inMxE = parcelRequire("inMxE");

var $lnVHd = parcelRequire("lnVHd");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $k5P9q = parcelRequire("k5P9q");

var $fNgVF = parcelRequire("fNgVF");

var $bs9jJ = parcelRequire("bs9jJ");

var $h1pEM = parcelRequire("h1pEM");

var $gDdYI = parcelRequire("gDdYI");

var $l1vE2 = parcelRequire("l1vE2");

var $2700E = parcelRequire("2700E");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");

var $kFgCO = parcelRequire("kFgCO");

var $2ffUK = parcelRequire("2ffUK");

var $5jCuE = parcelRequire("5jCuE");
const $2e469dfefe58da04$var$useCurrentUserGated = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $i860n.fg)('asf-944-account-sync'), (0, $kFgCO.useCurrentUser), ()=>({
        data: {
            user: null
        }
    }));
const $2e469dfefe58da04$var$EditionAwarenessPlatformInner = (props)=>{
    const { isDismissed: isDismissed, handleDismiss: handleDismiss } = (0, $lQrcN.useIsEditionAwarenessPillDismissed)(props.product);
    const { isEligibleForUpsellEa: isEligibleForUpsellEa } = (0, $eCQdn.useIsEligibleForUpsellEa)({
        product: props.product,
        edition: props.edition,
        isSiteAdmin: Boolean(props.userRoles?.includes('SITE_ADMIN'))
    });
    return isEligibleForUpsellEa ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fbMby.EditionAwarenessUpsell), (({ product: product, cloudId: cloudId, edition: edition, userRoles: userRoles, originalProjectTypeWasCore: originalProjectTypeWasCore })=>({
            product: product,
            cloudId: cloudId,
            edition: edition,
            userRoles: userRoles,
            originalProjectTypeWasCore: originalProjectTypeWasCore,
            hasDismissedButton: isDismissed,
            onDismissButton: handleDismiss
        }))(props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j1TMp.EditionAwareness), props);
};
$2e469dfefe58da04$var$EditionAwarenessPlatformInner.displayName = "EditionAwarenessPlatformInner";
const $2e469dfefe58da04$var$EditionAwarenessPlatform = ({ editionAwarenessQueryFragment: editionAwarenessQueryFragment })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const orgId = (0, $h1pEM.useOrgId)();
    const accountId = (0, $3GN2r.useAccountId)();
    const environment = (0, $k5P9q.useEnvironment)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const isJiraAdmin = (0, $fNgVF.useIsAdmin)();
    const isEditionAwarenessDisabled = (0, $i860n.fg)('aem_edition_awareness') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-edition-awareness') : (0, $l1vE2.isFedRamp)();
    const { data: currentUserData } = $2e469dfefe58da04$var$useCurrentUserGated();
    const projectQueryData = (0, $n67Vb.useFragment)((0, $7v04I.default), editionAwarenessQueryFragment);
    const projectTypeFromQuery = projectQueryData?.jira_projectByIdOrKey?.projectType;
    const { product: product, edition: edition, currentRoute: currentRoute, originalProjectTypeWasCore: originalProjectTypeWasCore } = (0, $5jCuE.useProductAndEdition)(projectTypeFromQuery ? (0, $f99M0.convertToProjectType)(projectTypeFromQuery) : undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // Planned to be expanded as we add new actions
    const getAction = (0, $euxye.useCallback)(async ()=>null, []);
    const userRoles = (0, $euxye.useMemo)(()=>{
        const roles = [];
        if (isSiteAdmin) roles.push('SITE_ADMIN');
        if (isJiraAdmin) roles.push('JIRA_ADMIN');
        return roles;
    }, [
        isSiteAdmin,
        isJiraAdmin
    ]);
    const [siteTraits, setSiteTraits] = (0, $euxye.useState)(()=>{
        // Calculate which editions need to fetch traits
        const supportedJiraProducts = [
            'jira-service-management',
            'jira-product-discovery'
        ];
        const shouldFetchTraits = !isEditionAwarenessDisabled && (edition === 'free' || edition === 'standard' && (product === 'jira' || product && supportedJiraProducts.includes(product) && (0, $i860n.fg)('standard-to-premium-ea-refactor')));
        if (shouldFetchTraits) return undefined;
        return [];
    });
    (0, $euxye.useEffect)(()=>{
        if (siteTraits === undefined) (0, $g3pW6.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        }).then((traits)=>{
            setSiteTraits(traits);
        }).catch((e)=>{
            setSiteTraits([]);
            const event = createAnalyticsEvent({});
            (0, $hFtK7.fireErrorAnalytics)({
                event: event,
                meta: {
                    id: 'editionAwarenessGrowthCohortTrait',
                    packageName: 'edition-awareness',
                    teamName: 'growth-tako'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        edition,
        siteTraits
    ]);
    // We need to wait for the siteType to be set before rendering the button
    const canRender = siteTraits !== undefined;
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagsService)();
    const handleShowFlag = (0, $euxye.useCallback)((flag)=>{
        const { appearance: appearance, id: id, ...flagArgs } = flag;
        const type = !appearance || appearance === 'normal' ? 'info' : appearance;
        showFlag({
            ...flagArgs,
            // Assumes that when we're showing flags from edition awareness they are transactional
            messageType: 'transactional',
            messageId: id,
            type: type
        });
    }, [
        showFlag
    ]);
    const [isStarVariantConfig] = (0, $2700E.UNSAFE_noExposureExp)('jsmgrowth466_star');
    const isStarVariant = isStarVariantConfig.get('isEnabled', false);
    const [showEditionBenefitsModal, setShowEditionBenefitsModal] = (0, $2ffUK.useQueryParam)('showEditionBenefitsModal');
    const shouldAutoOpen = showEditionBenefitsModal === 'true';
    const resetAutoOpen = (0, $euxye.useCallback)(()=>{
        setShowEditionBenefitsModal(undefined);
    }, [
        setShowEditionBenefitsModal
    ]);
    const editionAwarenessProps = (0, $euxye.useMemo)(()=>{
        if (!product || !edition) return null;
        if (!accountId) // We don't render when the customer is not logged in
        return null;
        return {
            edition: edition,
            cloudId: cloudId,
            orgId: orgId,
            product: product,
            environment: environment,
            userRoles: userRoles,
            siteTraits: siteTraits,
            canRender: canRender,
            getAction: getAction,
            showFlag: handleShowFlag,
            hideFlag: dismissFlag,
            currentRoute: currentRoute,
            originalProjectTypeWasCore: originalProjectTypeWasCore,
            // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
            userEmail: currentUserData?.user?.emailAddress ?? null,
            ...isStarVariant ? {
                shouldAutoOpen: shouldAutoOpen,
                onAutoOpen: resetAutoOpen
            } : {}
        };
    }, [
        accountId,
        canRender,
        cloudId,
        orgId,
        edition,
        environment,
        userRoles,
        product,
        siteTraits,
        getAction,
        handleShowFlag,
        dismissFlag,
        currentRoute,
        originalProjectTypeWasCore,
        currentUserData,
        shouldAutoOpen,
        resetAutoOpen,
        isStarVariant
    ]);
    const stableAnalyticsAttributes = (0, $euxye.useMemo)(()=>({
            isSiteAdmin: isSiteAdmin,
            product: product,
            edition: edition
        }), [
        isSiteAdmin,
        product,
        edition
    ]);
    if (!editionAwarenessProps) return null;
    if (isEditionAwarenessDisabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: (0, $i860n.fg)('navx-4728-jira-stability-fixes') ? stableAnalyticsAttributes : {
            isSiteAdmin: isSiteAdmin,
            product: product,
            edition: edition
        }
    }, edition === 'premium' && product === 'jira' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j1TMp.EditionAwareness), editionAwarenessProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2e469dfefe58da04$var$EditionAwarenessPlatformInner, editionAwarenessProps));
};
$2e469dfefe58da04$var$EditionAwarenessPlatform.displayName = "EditionAwarenessPlatform";
const $2e469dfefe58da04$export$a55b02efe3d62583 = ({ editionAwarenessQueryFragment: editionAwarenessQueryFragment })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lnVHd.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "EditionAwareness",
        packageName: "jiraNavigationAppsSidebarEditionAwareness",
        fallback: "unmount",
        teamName: "growth-tako"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2e469dfefe58da04$var$EditionAwarenessPlatform, {
        editionAwarenessQueryFragment: editionAwarenessQueryFragment
    }))));
};
$2e469dfefe58da04$export$a55b02efe3d62583.displayName = "EditionAwareness";

});
parcelRegister("7v04I", function(module, exports) {
$parcel$export(module.exports, "default", () => $871a2bfb8470a9e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a6298afd19fd5ac0c7897afd9f1f096>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $871a2bfb8470a9e6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "projectIdOrKey"
        },
        {
            "kind": "RootArgument",
            "name": "shouldFetchProjectTypeForSettingsAndEA"
        }
    ],
    "kind": "Fragment",
    "name": "EditionAwareness_query",
    "selections": [
        {
            "condition": "shouldFetchProjectTypeForSettingsAndEA",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "idOrKey",
                            "variableName": "projectIdOrKey"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "projectType"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$871a2bfb8470a9e6$var$node.hash = "cb12d32f3acd06fa4956f0b0bc163456";
var $871a2bfb8470a9e6$export$2e2bcd8739ae039 = $871a2bfb8470a9e6$var$node;

});

parcelRegister("lQrcN", function(module, exports) {
$parcel$export(module.exports, "useIsEditionAwarenessPillDismissed", () => $63ff9cc85760ac76$export$7cb865d6d91f9a4d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $gCvj1 = parcelRequire("gCvj1");
const $63ff9cc85760ac76$export$7cb865d6d91f9a4d = (product)=>{
    const [hasFetched, setHasFetched] = (0, $euxye.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $euxye.useState)(true);
    const canDismiss = product === 'jira-product-discovery' ? (0, $i860n.fg)('upsell_edition_awareness_jpd_fg') : (0, $i860n.fg)('edition_awareness_upsell_jira_ab_fg');
    (0, $euxye.useEffect)(()=>{
        if (canDismiss) (0, $gCvj1.fetchEditionAwarenessPillDismissed)().then((result)=>{
            // if result is undefined, it means the call failed and we can't be certain if the user dismissed the pill or not
            if (result !== undefined) {
                setIsDismissed(!!result);
                setHasFetched(true);
            }
        });
    }, [
        canDismiss
    ]);
    const handleDismiss = (0, $euxye.useCallback)(()=>{
        if (canDismiss) {
            setIsDismissed(true);
            (0, $gCvj1.setEditionAwarenessPillDismissed)(true);
        }
    }, [
        canDismiss
    ]);
    return {
        hasFetched: hasFetched,
        isDismissed: isDismissed,
        handleDismiss: handleDismiss
    };
};

});
parcelRegister("gCvj1", function(module, exports) {
$parcel$export(module.exports, "setEditionAwarenessPillDismissed", () => $d525a4b5a9b7745c$export$b0b754c480c139ac);
$parcel$export(module.exports, "fetchEditionAwarenessPillDismissed", () => $d525a4b5a9b7745c$export$1eb6cd4dd0048115);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $fNXFu = parcelRequire("fNXFu");

const $d525a4b5a9b7745c$export$b0b754c480c139ac = async (value)=>{
    try {
        await (0, $fNXFu.userPreferenceAPI).set((0, $871dfefee2f46b5c$export$83e119fb36bc846a), value);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'setEditionAwarenessPillDismissed',
                packageName: (0, $871dfefee2f46b5c$export$52483b87432059f1)
            }
        });
    }
};
const $d525a4b5a9b7745c$export$1eb6cd4dd0048115 = async ()=>{
    try {
        return await (0, $fNXFu.userPreferenceAPI).get((0, $871dfefee2f46b5c$export$83e119fb36bc846a));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode === 404) return null;
        (0, $hFtK7.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'fetchEditionAwarenessPillDismissed',
                packageName: (0, $871dfefee2f46b5c$export$52483b87432059f1)
            }
        });
        return undefined;
    }
};

});
/* eslint-disable jira/filename-case */ const $871dfefee2f46b5c$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $871dfefee2f46b5c$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';



parcelRegister("eCQdn", function(module, exports) {
$parcel$export(module.exports, "useIsEligibleForUpsellEa", () => $a163fcd020b6a855$export$d937ac4841c15ef7);
/* eslint-disable jira/filename-case, jira/ff/unsafe-no-exposure, jira/naming/disallow-filenames */ 

var $eQUOE = parcelRequire("eQUOE");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $54zD2 = parcelRequire("54zD2");
const $a163fcd020b6a855$export$d937ac4841c15ef7 = ({ product: product, edition: edition, isSiteAdmin: isSiteAdmin })=>{
    const isJpd = product === (0, $eb8cfa569eede1a9$export$202f50ee62667e32);
    const [expConfig] = isJpd ? (0, $2700E.UNSAFE_noExposureExp)('edition_awareness_upsell_jpd') : (0, $2700E.UNSAFE_noExposureExp)('edition_awareness_upsell_jira_ab');
    const passesFeatureGate = isJpd ? (0, $i860n.fg)('upsell_edition_awareness_jpd_fg') : (0, $i860n.fg)('edition_awareness_upsell_jira_ab_fg');
    const productEntitlementDetails = (0, $eQUOE.useProductEntitlementDetails)();
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const enrolled = cohort !== 'not-enrolled';
    // Trial State logic
    let productKey;
    switch(product){
        case 'jira':
            productKey = (0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d);
            break;
        case 'jira-service-management':
            productKey = (0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61);
            break;
        case 0, $eb8cfa569eede1a9$export$202f50ee62667e32:
            productKey = (0, $eb8cfa569eede1a9$export$202f50ee62667e32);
            break;
        default:
    }
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const trialDaysLeft = (0, $54zD2.getTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime);
    const isInTrial = !entitlementDetails ? undefined : !!trialDaysLeft && trialDaysLeft > 0;
    // Check if site is in pre-dunning period
    // If firstPredunningEndTime exists and current time is before it, site is in pre-dunning
    // If firstPredunningEndTime doesn't exist, site is not in pre-dunning
    const isInPreDunning = !entitlementDetails ? undefined : entitlementDetails.firstPredunningEndTime !== undefined && Date.now() <= entitlementDetails.firstPredunningEndTime;
    const isEligibleForUpsellEa = edition === 'standard' && enrolled && isInTrial === false && isInPreDunning === false && isSiteAdmin && passesFeatureGate;
    return {
        isEligibleForUpsellEa: isEligibleForUpsellEa,
        cohort: cohort
    };
};

});
parcelRegister("eQUOE", function(module, exports) {
$parcel$export(module.exports, "useProductEntitlementDetails", () => $4989c6c1b50045d3$export$e02d6385b5d47f5d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $4989c6c1b50045d3$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});


parcelRegister("kFgCO", function(module, exports) {
$parcel$export(module.exports, "useCurrentUser", () => $7462eff2514e4892$export$3901076af3749fa9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jFwZ0 = parcelRequire("jFwZ0");

var $978hs = parcelRequire("978hs");

var $eijVy = parcelRequire("eijVy");
function $7462eff2514e4892$export$3901076af3749fa9() {
    const { data: data, error: error, loading: loading, refresh: refresh } = (0, $jFwZ0.useCurrentUserResource)();
    const { atlassianAccountId: accountId, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin, locale: locale = (0, $978hs.defaultLocale), siteAdminStatus: siteAdminStatus, userFullname: userFullname = '' } = (0, $eijVy.useTenantContext)();
    (0, $euxye.useEffect)(()=>{
        // load on client if not loaded as a resource
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $euxye.useMemo)(()=>{
        if (isAnonymous) return {
            data: {
                user: {
                    accountId: accountId,
                    isAdmin: isAdmin,
                    isAnonymous: isAnonymous,
                    isSiteAdmin: isSiteAdmin,
                    locale: locale,
                    siteAdminStatus: siteAdminStatus,
                    userFullname: userFullname ?? ''
                }
            },
            loading: false,
            error: null
        };
        return {
            data: {
                user: {
                    accountId: data?.accountId ?? accountId ?? '',
                    active: data?.active || false,
                    applicationRoles: data?.applicationRoles,
                    avatarUrls: data?.avatarUrls ?? {
                        '16x16': '',
                        '24x24': '',
                        '32x32': '',
                        '48x48': ''
                    },
                    displayName: data?.displayName ?? '',
                    emailAddress: data?.emailAddress,
                    expand: data?.expand,
                    groups: data?.groups,
                    isAdmin: isAdmin,
                    isAnonymous: isAnonymous,
                    isSiteAdmin: isSiteAdmin,
                    key: data?.key,
                    locale: data?.locale ?? locale,
                    name: data?.name,
                    self: data?.self,
                    siteAdminStatus: siteAdminStatus,
                    userFullname: userFullname ?? '',
                    timeZone: data?.timeZone
                }
            },
            loading: loading,
            error: error
        };
    }, [
        accountId,
        data,
        error,
        isAdmin,
        isAnonymous,
        isSiteAdmin,
        loading,
        locale,
        siteAdminStatus,
        userFullname
    ]);
}

});

parcelRegister("5jCuE", function(module, exports) {
$parcel$export(module.exports, "useProductAndEdition", () => $5dcb7fcb615e30b9$export$b0f1c0403c557678);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $d8LhJ = parcelRequire("d8LhJ");

var $f99M0 = parcelRequire("f99M0");

var $eTmRw = parcelRequire("eTmRw");

var $XssJM = parcelRequire("XssJM");

var $7EMaG = parcelRequire("7EMaG");

var $ccEzE = parcelRequire("ccEzE");

var $f2wVS = parcelRequire("f2wVS");
const $5dcb7fcb615e30b9$export$8aab08255f8e5ef0 = {
    FREE_EDITION: 'free',
    STANDARD_EDITION: 'standard',
    PREMIUM_EDITION: 'premium'
};
const $5dcb7fcb615e30b9$export$7e5a22794fbe56f2 = {
    [(0, $f99M0.SOFTWARE_PROJECT)]: 'jira',
    [(0, $f99M0.CORE_PROJECT)]: 'jira',
    [(0, $f99M0.PRODUCT_DISCOVERY_PROJECT)]: 'jira-product-discovery',
    [(0, $f99M0.SERVICE_DESK_PROJECT)]: 'jira-service-management',
    [(0, $f99M0.CUSTOMER_SERVICE_PROJECT)]: 'jira-customer-service'
};
const $5dcb7fcb615e30b9$export$b0f1c0403c557678 = (projectTypeFromQuery)=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const { loading: loading, data: project } = (0, $XssJM.useProject)();
    const siteHasOnlyJira = (0, $eTmRw.useSiteHasOnlyJira)();
    const isOpsRoute = (0, $f2wVS.useIsActiveRoute)((0, $7EMaG.operationsConverter).routes);
    const projectType = (0, $euxye.useMemo)(()=>{
        if (projectTypeFromQuery) return projectTypeFromQuery;
        if (loading) return;
        const type = (0, $f99M0.toProjectType)(project?.type);
        // Unsafe exposure as we have further eligibility checks in Platform and can only fire exposure there
        const [jsmgrowth466Star] = (0, $2700E.UNSAFE_noExposureExp)('jsmgrowth466_star');
        if (type) return type;
        // Ops/EOC routes are part of JSM — show edition-awareness as JSM when STAR experiment is enabled
        if (isOpsRoute && jsmgrowth466Star.get('cohort', 'not-enrolled') !== 'not-enrolled') return 0, $f99M0.SERVICE_DESK_PROJECT;
        if (siteHasOnlyJira) return 0, $f99M0.SOFTWARE_PROJECT;
    }, [
        projectTypeFromQuery,
        loading,
        project?.type,
        isOpsRoute,
        siteHasOnlyJira
    ]);
    const applicationEdition = (0, $euxye.useMemo)(()=>{
        if (!projectType) return;
        if (siteHasOnlyJira) return (0, $d8LhJ.getEditionForProject)((0, $f99M0.SOFTWARE_PROJECT), appEditions);
        return (0, $d8LhJ.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType,
        siteHasOnlyJira
    ]);
    const { product: product, edition: edition, originalProjectTypeWasCore: originalProjectTypeWasCore } = (0, $euxye.useMemo)(()=>{
        if (!projectType || !applicationEdition) // We don't have a product or edition, so return nothing
        return {};
        // Unsafe exposure as we have further eligibility checks in Platform and can only fire exposure there
        const [twcg1563Config] = (0, $2700E.UNSAFE_noExposureExp)('twcg-1563-remove-jira-only-restriction');
        if (projectType === (0, $f99M0.CORE_PROJECT) && !siteHasOnlyJira) {
            // FOR VARIATION:
            // JWM always maps to Jira
            // FOR CONTROL:
            // We are supporting only JWM implicit licensing when the parent license is JSW
            // Do not show on core products if site does not have only Jira
            // Cohorting and exposures are performed in Platform
            if (twcg1563Config.get('cohort', 'not-enrolled') !== 'not-enrolled') return {
                originalProjectTypeWasCore: true,
                product: $5dcb7fcb615e30b9$export$7e5a22794fbe56f2[projectType],
                edition: $5dcb7fcb615e30b9$export$8aab08255f8e5ef0[applicationEdition]
            };
            return {};
        }
        return {
            product: $5dcb7fcb615e30b9$export$7e5a22794fbe56f2[projectType],
            edition: $5dcb7fcb615e30b9$export$8aab08255f8e5ef0[applicationEdition]
        };
    }, [
        applicationEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition,
        currentRoute: isOpsRoute ? 'ops' : undefined,
        originalProjectTypeWasCore: originalProjectTypeWasCore
    };
};

});
parcelRegister("eTmRw", function(module, exports) {
$parcel$export(module.exports, "useSiteHasOnlyJira", () => $9fdb3ec065bcb5af$export$8ce0db5ac54a6136);
// eslint-disable-next-line jira/filename-case


var $fdzBQ = parcelRequire("fdzBQ");

var $eijVy = parcelRequire("eijVy");
function $9fdb3ec065bcb5af$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $eijVy.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $fdzBQ.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});
parcelRegister("fdzBQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bba86970dd2da973$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
const $bba86970dd2da973$var$getExplicitlyLicensedProducts = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $eb8cfa569eede1a9$export$db515c8cec1e6f79] && result.push((0, $eb8cfa569eede1a9$export$db515c8cec1e6f79));
    licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61] && result.push((0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d] && result.push((0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d));
    licensedProducts[0, $eb8cfa569eede1a9$export$202f50ee62667e32] && result.push((0, $eb8cfa569eede1a9$export$202f50ee62667e32));
    return result;
};
var $bba86970dd2da973$export$2e2bcd8739ae039 = $bba86970dd2da973$var$getExplicitlyLicensedProducts;

});




parcelRegister("i3WUK", function(module, exports) {
$parcel$export(module.exports, "default", () => $944b84b16adc49b2$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");


var $hNR1X = parcelRequire("hNR1X");

var $6dQTb = parcelRequire("6dQTb");
function $944b84b16adc49b2$var$AppSwitcher() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hNR1X.TopLevelErrorBoundary), {
        id: (0, $5bdb53f12f87b5a8$export$cb2f616a76599e00)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6dQTb.AppSwitcherTrigger), null));
}
$944b84b16adc49b2$var$AppSwitcher.displayName = "AppSwitcher";
var $944b84b16adc49b2$export$2e2bcd8739ae039 = $944b84b16adc49b2$var$AppSwitcher;

});
const $5bdb53f12f87b5a8$export$cb2f616a76599e00 = 'APP_SWITCHER';

parcelRegister("hNR1X", function(module, exports) {
$parcel$export(module.exports, "TopLevelErrorBoundary", () => $5811c2519283e490$export$b70f1d8bd509b358);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

const $5811c2519283e490$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $euxye.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: `${(0, $b503a2fee96b7946$export$4766f0c4b6fe35dc)}.${id}`,
        packageName: (0, $b503a2fee96b7946$export$b8b9d90f9e5bd72b),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};
$5811c2519283e490$export$b70f1d8bd509b358.displayName = "TopLevelErrorBoundary";

});
/* eslint-disable jira/filename-case */ const $b503a2fee96b7946$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__atlassian-navigation';
const $b503a2fee96b7946$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $b503a2fee96b7946$export$9934c8d98fd9e572 = 'atlassianSwitcher';


parcelRegister("6dQTb", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherTrigger", () => $12cfc005d30aee42$export$dc8723dff0e69fcb);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");


var $bveRQ = parcelRequire("bveRQ");


var $33SHe = parcelRequire("33SHe");

var $6ouZy = parcelRequire("6ouZy");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $cVI8i = parcelRequire("cVI8i");

var $8xPPl = parcelRequire("8xPPl");

var $kt86l = parcelRequire("kt86l");

var $4P1nN = parcelRequire("4P1nN");

var $gvR6d = parcelRequire("gvR6d");

var $49p2r = parcelRequire("49p2r");
function $12cfc005d30aee42$export$dc8723dff0e69fcb() {
    const [isOpen, { on: openMenu, off: closeMenu }] = (0, $33SHe.useTopMenus)((0, $5bdb53f12f87b5a8$export$cb2f616a76599e00));
    const cloudId = (0, $kt86l.useCloudId)();
    const triggerAnalytics = (0, $bveRQ.useNavigationItemAnalytics)({
        navigationItemId: (0, $b503a2fee96b7946$export$9934c8d98fd9e572)
    });
    const onOpen = (0, $euxye.useCallback)(()=>{
        (0, $8xPPl.setSwitcherRenderStartMark)();
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            isOpen: isOpen,
            onClose: closeMenu,
            onOpen: onOpen
        }), [
        isOpen,
        closeMenu,
        onOpen
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $4P1nN.AppSwitcherIntegrationEntrypoint), entryPointParams);
    const entrypointRef = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cVI8i.default), {
        cloudId: cloudId,
        product: "jira"
    }, !isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gvR6d.AppSwitcherPlaceholderButton), {
        onOpen: onOpen,
        ref: entrypointRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "app-switcher-content",
        packageName: "jira-navigation-apps-topnav4-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $49p2r.AppSwitcherPlaceholderWithLoadingPopup), null),
        errorFallback: "flag",
        runtimeProps: entryPointParams
    }));
}
$12cfc005d30aee42$export$dc8723dff0e69fcb.displayName = "AppSwitcherTrigger";

});
parcelRegister("bveRQ", function(module, exports) {
$parcel$export(module.exports, "useNavigationItemAnalytics", () => $5ece63df635484d3$export$444d136efe970fd3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fTB7r = parcelRequire("fTB7r");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
function $5ece63df635484d3$export$444d136efe970fd3({ navigationItemId: navigationItemId }) {
    const { isVisible: isVisible } = (0, $fTB7r.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return (0, $euxye.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
}

});

parcelRegister("33SHe", function(module, exports) {
$parcel$export(module.exports, "useTopMenus", () => $801105b625781a21$export$6591d6b6c4546423);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $k7wxE = parcelRequire("k7wxE");

var $6gakV = parcelRequire("6gakV");
const { SwitchContainer: $801105b625781a21$var$SwitchContainer, useSwitch: $801105b625781a21$var$useSwitch } = (0, $6gakV.createSwitchController)('atlassian-navigation-top-menus');
const $801105b625781a21$export$45ccf7b2695bac19 = $801105b625781a21$var$SwitchContainer;
const $801105b625781a21$var$useTopMenusBase = $801105b625781a21$var$useSwitch;
const $801105b625781a21$export$6591d6b6c4546423 = (props)=>{
    const switcher = $801105b625781a21$var$useTopMenusBase(props);
    const [{ isOpen: isCommandPaletteOpen }] = (0, $k7wxE.useCommandPaletteIsOpen)();
    const [isSwitchOpen, { off: off }] = switcher;
    (0, $euxye.useEffect)(()=>{
        if (isSwitchOpen && isCommandPaletteOpen) off();
    }, [
        isCommandPaletteOpen,
        isSwitchOpen,
        off
    ]);
    return switcher;
};

});
parcelRegister("k7wxE", function(module, exports) {
$parcel$export(module.exports, "useCommandPalette", () => $449131628dff5b1b$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $449131628dff5b1b$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $449131628dff5b1b$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $449131628dff5b1b$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $449131628dff5b1b$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $449131628dff5b1b$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $449131628dff5b1b$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $449131628dff5b1b$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $449131628dff5b1b$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $449131628dff5b1b$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $449131628dff5b1b$export$bbc05723eb144e03);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");
var $3K7NP = parcelRequire("3K7NP");
var $5QDqc = parcelRequire("5QDqc");

var $eKHJH = parcelRequire("eKHJH");

var $6dImF = parcelRequire("6dImF");
const $449131628dff5b1b$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $449131628dff5b1b$var$store = (0, $5QDqc.createStore)({
    initialState: $449131628dff5b1b$var$initialState,
    actions: $6dImF.actions,
    name: 'commandPalette'
});
const $449131628dff5b1b$export$6b58f9610017fbb7 = (0, $3h1FP.createHook)($449131628dff5b1b$var$store);
const $449131628dff5b1b$export$72aa7bc7c6a83c36 = (0, $3h1FP.createActionsHook)($449131628dff5b1b$var$store);
const $449131628dff5b1b$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $449131628dff5b1b$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $449131628dff5b1b$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $eKHJH.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $eKHJH.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $eKHJH.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $449131628dff5b1b$export$1f90c8f89f98110e = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: $449131628dff5b1b$export$56f06313122d0aac
});
const $449131628dff5b1b$export$cc979be9b69236df = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $449131628dff5b1b$export$a18633b655403b12 = (0, $3h1FP.createStateHook)($449131628dff5b1b$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $449131628dff5b1b$export$af8fd8cd4b048315 = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $449131628dff5b1b$export$4372697329bd9cbe = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $449131628dff5b1b$export$7422170a403e909 = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $449131628dff5b1b$export$282aa48e4a3afada = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $449131628dff5b1b$export$96819dfb22ad05d3 = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $449131628dff5b1b$export$a40e8ae3e53feab0 = (0, $3K7NP.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $eKHJH.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $449131628dff5b1b$export$f893891deedab3c6 = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: $449131628dff5b1b$export$a40e8ae3e53feab0
});
const $449131628dff5b1b$export$bbc05723eb144e03 = (0, $3h1FP.createHook)($449131628dff5b1b$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("eKHJH", function(module, exports) {
$parcel$export(module.exports, "getRegistryData", () => $3177d6d0d6ed5b28$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $3177d6d0d6ed5b28$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $3177d6d0d6ed5b28$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $3177d6d0d6ed5b28$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $3177d6d0d6ed5b28$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $3177d6d0d6ed5b28$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $3177d6d0d6ed5b28$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $3177d6d0d6ed5b28$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $3177d6d0d6ed5b28$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $3177d6d0d6ed5b28$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $3177d6d0d6ed5b28$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $3177d6d0d6ed5b28$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $3177d6d0d6ed5b28$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $3177d6d0d6ed5b28$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $3177d6d0d6ed5b28$export$c3d20e8c1e93a572);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $8DKOs = parcelRequire("8DKOs");

var $1aDnU = parcelRequire("1aDnU");

var $4Bn2R = parcelRequire("4Bn2R");

var $jm5aK = parcelRequire("jm5aK");
const $3177d6d0d6ed5b28$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $3177d6d0d6ed5b28$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$3177d6d0d6ed5b28$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $3177d6d0d6ed5b28$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $3177d6d0d6ed5b28$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $3177d6d0d6ed5b28$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $4Bn2R.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $4Bn2R.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $4Bn2R.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $3177d6d0d6ed5b28$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $3177d6d0d6ed5b28$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $3177d6d0d6ed5b28$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $3177d6d0d6ed5b28$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $3177d6d0d6ed5b28$export$389b0273703d5c48(sections)
    };
};
const $3177d6d0d6ed5b28$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $3177d6d0d6ed5b28$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$3177d6d0d6ed5b28$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$3177d6d0d6ed5b28$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$3177d6d0d6ed5b28$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $3177d6d0d6ed5b28$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $3177d6d0d6ed5b28$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $3177d6d0d6ed5b28$export$daa5beabdf8d9fc3 = (event)=>(0, $1aDnU.isMacOs)() ? event.metaKey : event.ctrlKey;
const $3177d6d0d6ed5b28$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jm5aK.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jm5aK.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jm5aK.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $3177d6d0d6ed5b28$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $3177d6d0d6ed5b28$export$fa1c95a5ffa92036 = (str)=>(0, $8DKOs.createHash)().update(str).digest('hex');
const $3177d6d0d6ed5b28$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $3177d6d0d6ed5b28$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $3177d6d0d6ed5b28$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $3177d6d0d6ed5b28$export$c3d20e8c1e93a572 = ()=>{
    const $ = (0, $e7boj.c)(3);
    const timeoutRef = (0, $euxye.useRef)();
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>()=>{
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $euxye.useEffect)(t0, t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        const setTimeoutAutoClear = (...t3)=>{
            const args = t3;
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(...args);
        };
        t2 = {
            setTimeoutAutoClear: setTimeoutAutoClear
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};

});
parcelRegister("1aDnU", function(module, exports) {
$parcel$export(module.exports, "isMacOs", () => $859c5cd30d000dc1$export$c5e71f489eb3970b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $859c5cd30d000dc1$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);

});

parcelRegister("4Bn2R", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $ef49b6326e4e7cc8$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $ef49b6326e4e7cc8$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $ef49b6326e4e7cc8$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $ef49b6326e4e7cc8$export$894e19fc96687503);
/* eslint-disable jira/filename-case */ // EVENT TYPES
const $ef49b6326e4e7cc8$export$a1562d08625f5d7e = 'UI';
const $ef49b6326e4e7cc8$export$947dac6c72b26f81 = 'TRACK';
const $ef49b6326e4e7cc8$export$f1d537d508d2945a = 'SCREEN';
const $ef49b6326e4e7cc8$export$12346a674644c156 = 'OPERATIONAL';
var $ef49b6326e4e7cc8$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $ef49b6326e4e7cc8$export$894e19fc96687503 = 250;

});

parcelRegister("jm5aK", function(module, exports) {
$parcel$export(module.exports, "CommandActionType", () => $3172b55e0d065464$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $3172b55e0d065464$export$904b2a0e38a1bef3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ var $3172b55e0d065464$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $3172b55e0d065464$export$3e448fd53031e13c = Object.values($3172b55e0d065464$export$f041b1b117ab382f);
const $3172b55e0d065464$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("6dImF", function(module, exports) {
$parcel$export(module.exports, "actions", () => $cd94d55e9376af1d$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ 
var $9O1Qa = parcelRequire("9O1Qa");

var $7TA2J = parcelRequire("7TA2J");

var $1aDnU = parcelRequire("1aDnU");

var $hFtK7 = parcelRequire("hFtK7");

var $d7U1K = parcelRequire("d7U1K");

var $VoOhq = parcelRequire("VoOhq");

var $4Bn2R = parcelRequire("4Bn2R");

var $jm5aK = parcelRequire("jm5aK");

var $eKHJH = parcelRequire("eKHJH");

var $hrOs2 = parcelRequire("hrOs2");

var $bGhdT = parcelRequire("bGhdT");

var $5nvGI = parcelRequire("5nvGI");
const $cd94d55e9376af1d$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $cd94d55e9376af1d$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        if (!getState().isOpen) (0, $VoOhq.default)('command-palette-opened');
        setState({
            commandPaletteSessionId: (0, $7TA2J.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $cd94d55e9376af1d$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$cd94d55e9376af1d$var$rootCommands
        });
    };
const $cd94d55e9376af1d$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $7TA2J.v4)() : '',
            ...!isOpen ? $cd94d55e9376af1d$var$rootCommands : {}
        });
    };
const $cd94d55e9376af1d$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $cd94d55e9376af1d$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $cd94d55e9376af1d$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $cd94d55e9376af1d$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $cd94d55e9376af1d$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $cd94d55e9376af1d$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $cd94d55e9376af1d$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jm5aK.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $4Bn2R.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $cd94d55e9376af1d$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $cd94d55e9376af1d$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $cd94d55e9376af1d$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $eKHJH.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $cd94d55e9376af1d$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $VoOhq.default)('command-palette-executed');
                    const performContext = {
                        search: onClosePendingCommandAction.context?.search
                    };
                    onClosePendingCommandAction.perform(performContext);
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $4Bn2R.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $hFtK7.fireErrorAnalytics)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $d7U1K.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $cd94d55e9376af1d$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $hrOs2.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $eKHJH.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        (0, $5nvGI.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $eKHJH.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $4Bn2R.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $eKHJH.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jm5aK.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $VoOhq.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $bGhdT.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jm5aK.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $4Bn2R.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $4Bn2R.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $1aDnU.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $VoOhq.default)('command-palette-executed');
                const performContext = {
                    search: currentState.search
                };
                currentCommandAction.perform(performContext);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $4Bn2R.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $hFtK7.fireErrorAnalytics)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $d7U1K.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent,
                    context: {
                        search: currentState.search
                    }
                }
            });
        }
    };
const $cd94d55e9376af1d$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $cd94d55e9376af1d$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $cd94d55e9376af1d$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $cd94d55e9376af1d$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $cd94d55e9376af1d$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $cd94d55e9376af1d$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $cd94d55e9376af1d$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $cd94d55e9376af1d$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $cd94d55e9376af1d$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // oxlint-disable-next-line typescript/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($9O1Qa)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $cd94d55e9376af1d$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $cd94d55e9376af1d$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $cd94d55e9376af1d$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $cd94d55e9376af1d$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $cd94d55e9376af1d$export$e324594224ef24da = {
    open: $cd94d55e9376af1d$var$open,
    toggle: $cd94d55e9376af1d$var$toggle,
    close: $cd94d55e9376af1d$var$close,
    addCommands: $cd94d55e9376af1d$var$addCommands,
    removeCommands: $cd94d55e9376af1d$var$removeCommands,
    handleSearch: $cd94d55e9376af1d$var$handleSearch,
    forceFocusSearch: $cd94d55e9376af1d$var$forceFocusSearch,
    setActiveIndex: $cd94d55e9376af1d$var$setActiveIndex,
    executeCommand: $cd94d55e9376af1d$var$executeCommand,
    goBackLevel: $cd94d55e9376af1d$var$goBackLevel,
    setChildCommands: $cd94d55e9376af1d$var$setChildCommands,
    setLoadingList: $cd94d55e9376af1d$var$setLoadingList,
    setFocusInput: $cd94d55e9376af1d$var$setFocusInput,
    registerSections: $cd94d55e9376af1d$var$registerSections,
    unregisterSections: $cd94d55e9376af1d$var$unregisterSections,
    markAsLoaded: $cd94d55e9376af1d$var$markAsLoaded,
    getAnalyticsAttributes: $cd94d55e9376af1d$var$getAnalyticsAttributes,
    setIsDisabled: $cd94d55e9376af1d$var$setIsDisabled,
    setRegistry: $cd94d55e9376af1d$var$setRegistry,
    updateActiveRegistry: $cd94d55e9376af1d$var$updateActiveRegistry,
    removeCommandsById: $cd94d55e9376af1d$var$removeCommandsById,
    removeFromActiveRegistry: $cd94d55e9376af1d$var$removeFromActiveRegistry,
    performDialogCloseCommand: $cd94d55e9376af1d$var$performDialogCloseCommand,
    setAnalytics: $cd94d55e9376af1d$var$setAnalytics,
    setFallbackOverride: $cd94d55e9376af1d$var$setFallbackOverride,
    setHasPopupOverlay: $cd94d55e9376af1d$var$setHasPopupOverlay,
    forceSearchValue: $cd94d55e9376af1d$var$forceSearchValue,
    resetShouldForceSearchValue: $cd94d55e9376af1d$var$resetShouldForceSearchValue
};

});
parcelRegister("hrOs2", function(module, exports) {
$parcel$export(module.exports, "getActiveCommandList", () => $032f0c3742a08dd3$export$639b7f41b0b47a01);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jm5aK = parcelRequire("jm5aK");
const $032f0c3742a08dd3$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jm5aK.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jm5aK.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("bGhdT", function(module, exports) {
$parcel$export(module.exports, "isSearchableChildrenAction", () => $99ad3cb9cf4cb791$export$d75616d77443fe4e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jm5aK = parcelRequire("jm5aK");
const $99ad3cb9cf4cb791$export$d75616d77443fe4e = (action)=>action?.type === (0, $jm5aK.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("5nvGI", function(module, exports) {
$parcel$export(module.exports, "setEventAttribute", () => $ceb96377e70ed3ca$export$7c0a9f4caaf7cfce);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jeezQ = parcelRequire("jeezQ");

var $cDMQE = parcelRequire("cDMQE");
const $ceb96377e70ed3ca$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $ceb96377e70ed3ca$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $ceb96377e70ed3ca$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $jeezQ.getUpdateAnalyticsFlowHelper)().setAttributes((0, $cDMQE.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("jeezQ", function(module, exports) {
$parcel$export(module.exports, "eventFlowManager", () => $da5cccb6c617f104$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $da5cccb6c617f104$export$f3b2b77402b2631f);

var $7TA2J = parcelRequire("7TA2J");

var $6CfY5 = parcelRequire("6CfY5");

var $aJ81Y = parcelRequire("aJ81Y");

var $52Nv7 = parcelRequire("52Nv7");

var $avTgz = parcelRequire("avTgz");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $da5cccb6c617f104$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $7TA2J.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
$da5cccb6c617f104$var$EventFlowManager.displayName = "EventFlowManager";
const $da5cccb6c617f104$export$87846400a9b428fc = new $da5cccb6c617f104$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $da5cccb6c617f104$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $da5cccb6c617f104$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const fieldType = fieldTypeValue && (0, $52Nv7.FIELD_TYPE_MAP)[fieldTypeValue] ? (0, $52Nv7.FIELD_TYPE_MAP)[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $52Nv7.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $da5cccb6c617f104$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $da5cccb6c617f104$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $avTgz.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $da5cccb6c617f104$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes,
                assigneeId: assigneeId
            });
            const sessionid = $da5cccb6c617f104$export$87846400a9b428fc.push(fieldKey);
            const attributes = $da5cccb6c617f104$var$concatAttributes(fieldKey, sessionid, params.attributes);
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $aJ81Y.fireUIAnalytics)(params.analytics, `${(0, $52Nv7.START_ACTION_SUBJECT)} ${(0, $52Nv7.START_ACTION)}`, (0, $52Nv7.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $da5cccb6c617f104$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $avTgz.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $da5cccb6c617f104$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $52Nv7.UNKNOWN_FIELD_IDS).includes(fieldKey);
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $da5cccb6c617f104$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $da5cccb6c617f104$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $da5cccb6c617f104$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $aJ81Y.fireTrackAnalytics)(params.analytics, `${(0, $52Nv7.END_ACTION_SUBJECT)} ${(0, $52Nv7.END_ACTION)}`, (0, $52Nv7.END_ACTION_SUBJECT_ID), {
                ...attributes,
                is_new_1event: true
            });
        } catch (e) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $da5cccb6c617f104$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        const currentAttributes = $da5cccb6c617f104$export$87846400a9b428fc.extraAttributes.get(fieldKey);
        $da5cccb6c617f104$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
            ...currentAttributes,
            ...attributes
        });
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $avTgz.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $da5cccb6c617f104$export$87846400a9b428fc.pull(fieldKey);
        $da5cccb6c617f104$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $da5cccb6c617f104$export$87846400a9b428fc.reset();
    }
};
const $da5cccb6c617f104$export$f3b2b77402b2631f = ()=>$da5cccb6c617f104$var$updateAnalyticsFlowHelper;

});
parcelRegister("52Nv7", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $2dff96ea81131edf$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $2dff96ea81131edf$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $2dff96ea81131edf$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $2dff96ea81131edf$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $2dff96ea81131edf$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $2dff96ea81131edf$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $2dff96ea81131edf$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $2dff96ea81131edf$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $2dff96ea81131edf$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $2dff96ea81131edf$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $2dff96ea81131edf$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $2dff96ea81131edf$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $2dff96ea81131edf$export$7d9dd31e187cb2db);
$parcel$export(module.exports, "ATTACHMENT_TYPE_MAP", () => $2dff96ea81131edf$export$97a5a13ea6cccc3);

var $cDMQE = parcelRequire("cDMQE");
const $2dff96ea81131edf$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $2dff96ea81131edf$export$c0a4673e0c78e972 = 'clicked';
const $2dff96ea81131edf$export$34a5ae354a38cc7e = 'item';
const $2dff96ea81131edf$export$bc373f59492dc6e2 = 'issue';
const $2dff96ea81131edf$export$b19686c1fe99f85a = 'updated';
const $2dff96ea81131edf$export$4ce67e80878d47ed = 'issue';
const $2dff96ea81131edf$export$e3d957ccc2d46469 = 'ended';
const $2dff96ea81131edf$export$3b3e3ac6d7f6e219 = 'add';
const $2dff96ea81131edf$export$6137e1b2fcde2333 = 'remove';
const $2dff96ea81131edf$export$6d8c364f9d389764 = 'unknown';
const $2dff96ea81131edf$export$7d1d20ff891eeb26 = [
    $2dff96ea81131edf$export$6d8c364f9d389764
];
const $2dff96ea81131edf$export$d8ccf495ccc97a69 = {
    [(0, $cDMQE.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $cDMQE.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $cDMQE.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $cDMQE.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $cDMQE.COMPONENTS_TYPE)]: 'components',
    [(0, $cDMQE.DATE_CF_TYPE)]: 'date',
    [(0, $cDMQE.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $cDMQE.DESCRIPTION_TYPE)]: 'richText',
    [(0, $cDMQE.DUE_DATE_TYPE)]: 'date',
    [(0, $cDMQE.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $cDMQE.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $cDMQE.GOALS_CF_TYPE)]: 'goals',
    [(0, $cDMQE.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $cDMQE.ISSUE_TYPE)]: 'issuetype',
    [(0, $cDMQE.LABELS_CF_TYPE)]: 'labels',
    [(0, $cDMQE.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $cDMQE.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $cDMQE.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $cDMQE.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $cDMQE.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $cDMQE.NUMBER_CF_TYPE)]: 'float',
    [(0, $cDMQE.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $cDMQE.PARENT_TYPE)]: 'parent',
    [(0, $cDMQE.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $cDMQE.PRIORITY_TYPE)]: 'priority',
    [(0, $cDMQE.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $cDMQE.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $cDMQE.RANK_CF_TYPE)]: 'rank',
    [(0, $cDMQE.START_DATE_TYPE)]: 'date',
    [(0, $cDMQE.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $cDMQE.SPRINT_TYPE)]: 'sprint',
    [(0, $cDMQE.STATUS_TYPE)]: 'status',
    [(0, $cDMQE.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $cDMQE.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $cDMQE.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $cDMQE.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $cDMQE.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $cDMQE.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $cDMQE.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $cDMQE.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $cDMQE.URL_CF_TYPE)]: 'url',
    [(0, $cDMQE.USER_CF_TYPE)]: 'singleUser',
    [(0, $cDMQE.VERSION_CF_TYPE)]: 'version',
    [(0, $cDMQE.VOTES_TYPE)]: 'votes',
    [(0, $cDMQE.WATCHES_TYPE)]: 'watchers'
};
const $2dff96ea81131edf$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};
const $2dff96ea81131edf$export$97a5a13ea6cccc3 = {
    ATTACHMENT: 'attachment',
    RESOURCES: 'resources'
};

});

parcelRegister("avTgz", function(module, exports) {
$parcel$export(module.exports, "getActionTaken", () => $f5826602049969a4$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $f5826602049969a4$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $f5826602049969a4$export$4cb0aa9574634a48);

var $52Nv7 = parcelRequire("52Nv7");
const $f5826602049969a4$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $52Nv7.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $52Nv7.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $f5826602049969a4$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $f5826602049969a4$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});





parcelRegister("6gakV", function(module, exports) {
$parcel$export(module.exports, "createSwitchController", () => $1a58610342a2ace3$export$1856548326159ec8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $1a58610342a2ace3$export$1856548326159ec8 = (name, activeByDefault)=>{
    const actions = {
        on: (active)=>({ setState: setState })=>setState({
                    active: active
                }),
        off: (active)=>({ setState: setState, getState: getState })=>{
                if (getState().active === active || active === undefined) setState({
                    active: undefined
                });
            },
        toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                if (getState().active === active) dispatch(actions.off(active));
                else dispatch(actions.on(active));
            }
    };
    const initialState = {
        active: activeByDefault
    };
    const store = (0, $5QDqc.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    const SwitchContainer = (0, $dB6ay.createContainer)(store);
    const selector = (state, key)=>state.active === key;
    const useSwitchInternal = (0, $3h1FP.createHook)(store, {
        selector: selector
    });
    const useSwitch = (active)=>{
        const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
        const on = (0, $euxye.useCallback)(()=>onSwitch(active), [
            onSwitch,
            active
        ]);
        const off = (0, $euxye.useCallback)(()=>offSwitch(active), [
            active,
            offSwitch
        ]);
        const toggle = (0, $euxye.useCallback)(()=>toggleSwitch(active), [
            toggleSwitch,
            active
        ]);
        return [
            isActive,
            {
                on: on,
                off: off,
                toggle: toggle
            }
        ];
    };
    return {
        SwitchContainer: SwitchContainer,
        useSwitch: useSwitch
    };
};

});


parcelRegister("6ouZy", function(module, exports) {
$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $aa90944626057af4$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $aa90944626057af4$export$5f13515bd3a35325);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $5RbDk = parcelRequire("5RbDk");
const $aa90944626057af4$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $euxye.useRef)(null);
    const isMounted = (0, $euxye.useRef)(true);
    (0, $euxye.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $euxye.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $aa90944626057af4$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $5RbDk.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $5RbDk.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $aa90944626057af4$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("5RbDk", function(module, exports) {
$parcel$export(module.exports, "modifyListeners", () => $7e3b6b168bd3d40d$export$15257a36a7e3f9d6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ function $7e3b6b168bd3d40d$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("4P1nN", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherIntegrationEntrypoint", () => $a810b1b903821d5d$export$7b5dbeab5e41f2a4);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $a810b1b903821d5d$export$7b5dbeab5e41f2a4 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("kefXS")), {
        moduleId: "f7171693",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>({
            extraProps: params
        })
});

});
parcelRegister("kefXS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("37k8P").then(()=>parcelRequire('2VAvi'));

});


parcelRegister("gvR6d", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherPlaceholderButton", () => $f2d826e5cbf2d4d3$export$46b00316abad4d7b);

var $euxye = parcelRequire("euxye");

var $ik1Zc = parcelRequire("ik1Zc");

var $4eeMq = parcelRequire("4eeMq");

var $hT5UW = parcelRequire("hT5UW");

var $6HijD = parcelRequire("6HijD");

var $jDRSV = parcelRequire("jDRSV");

var $jepRN = parcelRequire("jepRN");

var $i860n = parcelRequire("i860n");
const $f2d826e5cbf2d4d3$export$46b00316abad4d7b = /*#__PURE__*/ (0, $euxye.forwardRef)($f2d826e5cbf2d4d3$var$AppSwitcherPlaceholderButtonWithRef);
function $f2d826e5cbf2d4d3$var$AppSwitcherPlaceholderButtonWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f2d826e5cbf2d4d3$var$AppSwitcherLightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6HijD.AppSwitcher), {
        ref: ref,
        onClick: onOpen,
        onMouseEnter: onMouseEnter,
        label: (0, $jDRSV.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true,
        interactionName: "jira_app_switcher"
    }));
}
$f2d826e5cbf2d4d3$var$AppSwitcherPlaceholderButtonWithRef.displayName = "AppSwitcherPlaceholderButtonWithRef";
const $f2d826e5cbf2d4d3$var$AppSwitcherLightWrapper = (0, $jepRN.componentWithFG)('app_switcher_spotlight_gate', $f2d826e5cbf2d4d3$var$SpotLightWrapper, (0, $euxye.Fragment));
function $f2d826e5cbf2d4d3$var$SpotLightWrapper(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4eeMq.SpotlightManager), null, (0, $i860n.fg)('app-switcher-confluence-ap-ads-spotlight-target') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: "app-switcher-confluence-ap-ads-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hT5UW.SpotlightTarget), {
        name: "app-switcher-spotlight"
    }, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hT5UW.SpotlightTarget), {
        name: "app-switcher-spotlight"
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ik1Zc.EngagementSpotlight), {
        isMigrated: true,
        engagementId: "app-switcher-spotlight"
    }));
}
$f2d826e5cbf2d4d3$var$SpotLightWrapper.displayName = "SpotLightWrapper";

});

parcelRegister("49p2r", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherPlaceholderWithLoadingPopup", () => $98e6fbb04662b0db$export$35c8740d616fd043);

var $euxye = parcelRequire("euxye");

var $3NRLa = parcelRequire("3NRLa");

var $kcJbW = parcelRequire("kcJbW");

var $6Elhl = parcelRequire("6Elhl");

var $fbAgj = parcelRequire("fbAgj");

var $6HijD = parcelRequire("6HijD");

var $gNzvf = parcelRequire("gNzvf");

var $jDRSV = parcelRequire("jDRSV");
function $98e6fbb04662b0db$export$35c8740d616fd043() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNzvf.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($98e6fbb04662b0db$var$SkeletonContent, null),
        isOpen: true,
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-apps-topnav4-app-switcher.ui.trigger.popup.loading.popup",
        messageType: "transactional",
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: $98e6fbb04662b0db$var$Trigger
    });
}
$98e6fbb04662b0db$export$35c8740d616fd043.displayName = "AppSwitcherPlaceholderWithLoadingPopup";
function $98e6fbb04662b0db$var$Trigger(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6HijD.AppSwitcher), {
        ...triggerProps,
        label: (0, $jDRSV.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true,
        interactionName: "jira_app_switcher"
    });
}
$98e6fbb04662b0db$var$Trigger.displayName = "Trigger";
function $98e6fbb04662b0db$var$SkeletonContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kcJbW.default), {
        xcss: $98e6fbb04662b0db$var$containerStyles,
        rowGap: "space.200",
        columnGap: "space.150",
        templateColumns: "32px 1fr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($98e6fbb04662b0db$var$SkeletonItems, null));
}
$98e6fbb04662b0db$var$SkeletonContent.displayName = "SkeletonContent";
function $98e6fbb04662b0db$var$SkeletonItems() {
    return Array.from({
        length: 5
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $euxye.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "32px",
            height: "32px",
            isShimmering: true,
            borderRadius: "var(--ds-radius-large, 8px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            width: "100%",
            height: "10px",
            isShimmering: true
        }))));
}
$98e6fbb04662b0db$var$SkeletonItems.displayName = "SkeletonItems";
const $98e6fbb04662b0db$var$containerStyles = (0, $fbAgj.xcss)({
    width: '250px',
    padding: 'space.200'
});

});
parcelRegister("gNzvf", function(module, exports) {
$parcel$export(module.exports, "JiraPopup", () => $20b80bbb8cdbc242$export$2da4be1e3f9adef3);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1CdDx = parcelRequire("1CdDx");

var $gu6Rp = parcelRequire("gu6Rp");

var $f7DgA = parcelRequire("f7DgA");
const $20b80bbb8cdbc242$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $gu6Rp.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f7DgA.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1CdDx.Popup), rest);
};
$20b80bbb8cdbc242$export$2da4be1e3f9adef3.displayName = "JiraPopup";

});
parcelRegister("f7DgA", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPopup", () => $69725200433e5c01$export$8ecc19d18d3df807);
/* eslint-disable jira/filename-case */ 
var $1CdDx = parcelRequire("1CdDx");

var $aAuB6 = parcelRequire("aAuB6");
const $69725200433e5c01$export$8ecc19d18d3df807 = (0, $aAuB6.withChoreographedToggle)((0, $1CdDx.Popup), 'isOpen', 'content');

});





parcelRegister("kvdDU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4923d8b86dcb316$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $bs9jJ = parcelRequire("bs9jJ");

var $i860n = parcelRequire("i860n");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f4923d8b86dcb316$var$LazyCustomThemeAdminFlag = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("djWJr")), {
    ssr: false,
    moduleId: "./src/packages/theme/custom-theme-admin-flag/src/useCustomThemeAdminFlag.tsx"
});
const $f4923d8b86dcb316$var$AsyncCustomThemeAdminFlag = ()=>{
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    // Guard before rendering so non-admin users do not download this chunk and trigger unnecessary UFO holds.
    if (!isSiteAdmin && (0, $i860n.fg)('perf-jsm-issue-view-ttai-custom-theme-admin-flag')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async.jira.custom-theme-admin-flag",
        packageName: "customThemeAdminFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "custom-theme-admin-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f4923d8b86dcb316$var$LazyCustomThemeAdminFlag, null)));
};
$f4923d8b86dcb316$var$AsyncCustomThemeAdminFlag.displayName = "AsyncCustomThemeAdminFlag";
var $f4923d8b86dcb316$export$2e2bcd8739ae039 = $f4923d8b86dcb316$var$AsyncCustomThemeAdminFlag;

});
parcelRegister("djWJr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h4Pqu").then(()=>parcelRequire('aUBm9'));

});


/* eslint-disable jira/filename-case */ const $5f6e091542d432a9$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $5f6e091542d432a9$export$d57b6b390e78d90f = 'jira-cosmos';
const $5f6e091542d432a9$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $5f6e091542d432a9$export$eed606b4351295d7 = 'login';
const $5f6e091542d432a9$export$35e541d26a145a7c = 'logout';

/* eslint-disable jira/filename-case */ const $3b258ee19859baa5$export$d2aa6c54a5925f01 = 'v3';
const $3b258ee19859baa5$export$2bd315ece9f68967 = 'v4';

/* eslint-disable jira/filename-case */ const $192a2eeaa0a1dbf6$export$2ee9e5a3556c1e43 = 'sidebar';
const $192a2eeaa0a1dbf6$export$793ed84f5e13fedc = 'top';
const $192a2eeaa0a1dbf6$export$f1c9dd0f5207dd5e = 'tab';
const $192a2eeaa0a1dbf6$export$b83d0ee9325a2d0a = 'projectTitle';

/* eslint-disable jira/filename-case */ // TopNav or sidebar
const $fad9173ee481d7de$export$17ff3f7e02c6ac22 = 'global';
const $fad9173ee481d7de$export$33d8c916a600c5e9 = 'container';

parcelRegister("c9cNX", function(module, exports) {
$parcel$export(module.exports, "getSideNavToggleButtonAnalyticEventPayload", () => $d719a0533da66e3f$export$7165a1ebf1926b86);
$parcel$export(module.exports, "MENU_ID_ANALYTIC_EVENT_IDS", () => $d719a0533da66e3f$export$d70e7a5f39328991);
/* eslint-disable jira/filename-case */ 
var $5IkoH = parcelRequire("5IkoH");





var $bOwox = parcelRequire("bOwox");
const $d719a0533da66e3f$var$SIDEBAR_TOGGLE = 'sidebarToggle';
const $d719a0533da66e3f$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE = 'collapse';
const $d719a0533da66e3f$var$SIDEBAR_TOGGLE_ACTION_EXPAND = 'expand';
const $d719a0533da66e3f$var$CLICKED = 'clicked';
const $d719a0533da66e3f$export$7165a1ebf1926b86 = (isSideNavVisible)=>{
    const toggleAction = isSideNavVisible ? $d719a0533da66e3f$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE : $d719a0533da66e3f$var$SIDEBAR_TOGGLE_ACTION_EXPAND;
    const payload = {
        action: $d719a0533da66e3f$var$CLICKED,
        actionSubject: (0, $6b2913942bd90807$export$6dd9406e478a1fe2),
        actionSubjectId: $d719a0533da66e3f$var$SIDEBAR_TOGGLE,
        attributes: {
            navigationLayer: (0, $fad9173ee481d7de$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $192a2eeaa0a1dbf6$export$793ed84f5e13fedc),
            navState: (0, $3b258ee19859baa5$export$2bd315ece9f68967),
            toggleAction: toggleAction
        }
    };
    return payload;
};
const $d719a0533da66e3f$export$d70e7a5f39328991 = {
    [(0, $5IkoH.MENU_ID_APPS)]: 'appsNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_ASSETS)]: 'assetsNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_DASHBOARDS)]: 'dashboardsNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_FILTERS)]: 'filtersNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_GOALS)]: 'goalsNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_OPERATIONS)]: 'operationsNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_ITAM)]: 'itamNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_PLANS)]: 'plansNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_PROJECTS)]: 'projectsNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_RECENT)]: 'recentNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_STARRED)]: 'starredNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_TEAMS)]: 'teamsNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_ROADMAPS)]: 'roadmapsNavigationMenuItem',
    [(0, $5IkoH.MENU_ID_CUSTOMER_SERVICE)]: 'customerServiceMenuItem',
    [(0, $5IkoH.MENU_ID_CUSTOMER_SERVICE_ANALYTICS)]: 'customerServiceAnalyticsMenuItem',
    [(0, $5IkoH.MENU_ID_CUSTOMERS)]: 'customerServiceCustomersMenuItem',
    [(0, $5IkoH.MENU_ID_GLOBAL_APP_ASSETS)]: (0, $bOwox.GLOBAL_APP_SHORTCUT_ASSETS),
    [(0, $5IkoH.MENU_ID_GLOBAL_APP_GOALS)]: (0, $bOwox.GLOBAL_APP_SHORTCUT_GOALS),
    [(0, $5IkoH.MENU_ID_GLOBAL_APP_CONFLUENCE)]: (0, $bOwox.GLOBAL_APP_SHORTCUT_CONFLUENCE),
    [(0, $5IkoH.MENU_ID_GLOBAL_APP_LOOM)]: (0, $bOwox.GLOBAL_APP_SHORTCUT_LOOM),
    [(0, $5IkoH.MENU_ID_GLOBAL_APP_TEAMS)]: (0, $bOwox.GLOBAL_APP_SHORTCUT_TEAMS),
    [(0, $5IkoH.MENU_ID_GLOBAL_APP_PROJECTS)]: (0, $bOwox.GLOBAL_APP_SHORTCUT_PROJECTS),
    [(0, $5IkoH.MENU_ID_GLOBAL_APP_OPSGENIE)]: (0, $bOwox.GLOBAL_APP_SHORTCUT_OPSGENIE)
};

});
/* eslint-disable jira/filename-case */ const $6b2913942bd90807$export$6dd9406e478a1fe2 = 'navigationItem';
const $6b2913942bd90807$export$b887e88d8d0739f6 = 'button';
const $6b2913942bd90807$export$64fed82162bd367 = 'dropdownItem';
const $6b2913942bd90807$export$b0a8b257f1f878a2 = 'searchInput';

parcelRegister("bOwox", function(module, exports) {
$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $c56f94691ff44e61$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $c56f94691ff44e61$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $c56f94691ff44e61$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $c56f94691ff44e61$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $c56f94691ff44e61$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $c56f94691ff44e61$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $c56f94691ff44e61$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $c56f94691ff44e61$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $c56f94691ff44e61$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $c56f94691ff44e61$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $c56f94691ff44e61$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $c56f94691ff44e61$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $c56f94691ff44e61$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $c56f94691ff44e61$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $c56f94691ff44e61$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $c56f94691ff44e61$export$340dfb7166bc7df6);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_CONFLUENCE", () => $c56f94691ff44e61$export$68f5347447985678);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_LOOM", () => $c56f94691ff44e61$export$1d6ac45ce8d48696);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_TEAMS", () => $c56f94691ff44e61$export$73432842fefef2ac);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_PROJECTS", () => $c56f94691ff44e61$export$3023d22f41447712);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_OPSGENIE", () => $c56f94691ff44e61$export$3cc2573a8cf93a99);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $c56f94691ff44e61$export$1a73d7f5e6997c6d);
/* eslint-disable jira/filename-case */ 
var $5IkoH = parcelRequire("5IkoH");
const $c56f94691ff44e61$export$ed5276b2863990a4 = 'recent';
const $c56f94691ff44e61$export$73b9e2753c0313a = 'starred';
const $c56f94691ff44e61$export$a01a58e0d3083eac = 'yourApps';
const $c56f94691ff44e61$export$a7cdcfc40ede2092 = 'yourWork';
const $c56f94691ff44e61$export$31b95a89c6fecef5 = 'apps';
const $c56f94691ff44e61$export$b8d778ecbc8de386 = 'plans';
const $c56f94691ff44e61$export$31111a67d393221 = 'projects';
const $c56f94691ff44e61$export$15cffe8e769011f4 = 'filters';
const $c56f94691ff44e61$export$573d88e8f19dee53 = 'dashboards';
const $c56f94691ff44e61$export$4d8d544db40ea55b = 'operations';
const $c56f94691ff44e61$export$ee4743a74ca6b2b4 = 'teams';
const $c56f94691ff44e61$export$935694b184853c59 = 'assets';
const $c56f94691ff44e61$export$e96256061a3d08aa = 'itam';
const $c56f94691ff44e61$export$b0aa6b1b7598bca0 = 'more';
const $c56f94691ff44e61$export$60a8edfaff189e32 = 'customiseSidebar';
const $c56f94691ff44e61$export$61feca79c347b0c7 = 'goals';
const $c56f94691ff44e61$export$1e1623e43a47b758 = 'roadmaps';
const $c56f94691ff44e61$export$c15d65fa4cb522d = 'customerServiceCustomers';
const $c56f94691ff44e61$export$99cd56faa69bbbb6 = 'customerService';
const $c56f94691ff44e61$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $c56f94691ff44e61$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $c56f94691ff44e61$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $c56f94691ff44e61$export$68f5347447985678 = 'confluenceGlobalAppShortcut';
const $c56f94691ff44e61$export$1d6ac45ce8d48696 = 'loomGlobalAppShortcut';
const $c56f94691ff44e61$export$73432842fefef2ac = 'teamsGlobalAppShortcut';
const $c56f94691ff44e61$export$3023d22f41447712 = 'projectsGlobalAppShortcut';
const $c56f94691ff44e61$export$3cc2573a8cf93a99 = 'opsgenieGlobalAppShortcut';
const $c56f94691ff44e61$export$1a73d7f5e6997c6d = {
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).APPS]: $c56f94691ff44e61$export$31b95a89c6fecef5,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).ASSETS]: $c56f94691ff44e61$export$935694b184853c59,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).DASHBOARDS]: $c56f94691ff44e61$export$573d88e8f19dee53,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).FILTERS]: $c56f94691ff44e61$export$15cffe8e769011f4,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).OPERATIONS]: $c56f94691ff44e61$export$4d8d544db40ea55b,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).ITAM]: $c56f94691ff44e61$export$e96256061a3d08aa,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).PLANS]: $c56f94691ff44e61$export$b8d778ecbc8de386,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).PROJECTS]: $c56f94691ff44e61$export$31111a67d393221,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).RECENT]: $c56f94691ff44e61$export$ed5276b2863990a4,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).STARRED]: $c56f94691ff44e61$export$73b9e2753c0313a,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).TEAMS]: $c56f94691ff44e61$export$ee4743a74ca6b2b4,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).GOALS]: $c56f94691ff44e61$export$61feca79c347b0c7,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).ROADMAPS]: $c56f94691ff44e61$export$1e1623e43a47b758,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).CUSTOMERS]: $c56f94691ff44e61$export$99cd56faa69bbbb6,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $c56f94691ff44e61$export$99cd56faa69bbbb6,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $c56f94691ff44e61$export$f780439bdf7412c6,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $c56f94691ff44e61$export$340dfb7166bc7df6,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $c56f94691ff44e61$export$be1ee97c6c39a7a0,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE]: $c56f94691ff44e61$export$68f5347447985678,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM]: $c56f94691ff44e61$export$1d6ac45ce8d48696,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS]: $c56f94691ff44e61$export$73432842fefef2ac,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS]: $c56f94691ff44e61$export$3023d22f41447712,
    [(0, $5IkoH.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE]: $c56f94691ff44e61$export$3cc2573a8cf93a99
};

});


parcelRegister("bQpVj", function(module, exports) {
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $6db9ac048e29dbb5$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $6db9ac048e29dbb5$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM", () => $6db9ac048e29dbb5$export$9a6cc3b78524c807);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $6db9ac048e29dbb5$export$5034ad0032cd499d);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM", () => $6db9ac048e29dbb5$export$9c99028e1421f69f);
$parcel$export(module.exports, "SPACES_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM", () => $6db9ac048e29dbb5$export$e0063c8eec18df81);
$parcel$export(module.exports, "SPACES_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM", () => $6db9ac048e29dbb5$export$dbe1165a572764fa);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $6db9ac048e29dbb5$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $6db9ac048e29dbb5$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $6db9ac048e29dbb5$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITHOUT_PROJECT_TERM", () => $6db9ac048e29dbb5$export$4da83c858d129f7f);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITH_PROJECT_TERM", () => $6db9ac048e29dbb5$export$a9a6fdcb59a8001e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $b47ZF = parcelRequire("b47ZF");

var $fOxy5 = parcelRequire("fOxy5");

var $9iQvp = parcelRequire("9iQvp");

var $jcIfU = parcelRequire("jcIfU");

var $3xiQi = parcelRequire("3xiQi");

var $2AOCd = parcelRequire("2AOCd");

var $8A8fZ = parcelRequire("8A8fZ");

var $3SFM2 = parcelRequire("3SFM2");

var $cqJ3S = parcelRequire("cqJ3S");

var $lWRvF = parcelRequire("lWRvF");

var $eprc4 = parcelRequire("eprc4");

var $faDlH = parcelRequire("faDlH");

var $3Ihgk = parcelRequire("3Ihgk");

var $alDF5 = parcelRequire("alDF5");

var $cXTqc = parcelRequire("cXTqc");

var $4Olij = parcelRequire("4Olij");

var $lxN43 = parcelRequire("lxN43");

var $atP3J = parcelRequire("atP3J");

var $fgD0F = parcelRequire("fgD0F");

var $7eNDO = parcelRequire("7eNDO");

var $5IkoH = parcelRequire("5IkoH");

var $6GljB = parcelRequire("6GljB");
const $6db9ac048e29dbb5$var$projects = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.projects",
    defaultMessage: "Projects"
});
const $6db9ac048e29dbb5$var$filters = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.filters",
    defaultMessage: "Filters"
});
const $6db9ac048e29dbb5$var$dashboards = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.dashboards",
    defaultMessage: "Dashboards"
});
const $6db9ac048e29dbb5$var$teams = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.teams",
    defaultMessage: "Teams"
});
const $6db9ac048e29dbb5$var$assets = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.assets",
    defaultMessage: "Assets"
});
const $6db9ac048e29dbb5$var$plans = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.plans",
    defaultMessage: "Plans"
});
const $6db9ac048e29dbb5$var$apps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.apps",
    defaultMessage: "Apps"
});
const $6db9ac048e29dbb5$var$operations = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.operations",
    defaultMessage: "Operations"
});
const $6db9ac048e29dbb5$var$goals = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.goals",
    defaultMessage: "Goals"
});
const $6db9ac048e29dbb5$var$recent = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.recent",
    defaultMessage: "Recent"
});
const $6db9ac048e29dbb5$var$starred = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.starred",
    defaultMessage: "Starred"
});
const $6db9ac048e29dbb5$var$roadmaps = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.roadmaps",
    defaultMessage: "Roadmaps"
});
const $6db9ac048e29dbb5$var$customerHubs = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.customer-hubs",
    defaultMessage: "Customer experiences"
});
const $6db9ac048e29dbb5$var$customerServiceAnalytics = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
    defaultMessage: "Customer service overview"
});
const $6db9ac048e29dbb5$var$customers = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.customer-s",
    defaultMessage: "Customers"
});
const $6db9ac048e29dbb5$var$forYou = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.forYou",
    defaultMessage: "For you"
});
const $6db9ac048e29dbb5$var$confluence = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.confluence",
    defaultMessage: "Confluence"
});
const $6db9ac048e29dbb5$var$loom = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.loom",
    defaultMessage: "Loom"
});
const $6db9ac048e29dbb5$var$opsgenie = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.opsgenie",
    defaultMessage: "Opsgenie"
});
const $6db9ac048e29dbb5$var$projectsGalaxia = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.projects-galaxia",
    defaultMessage: "Spaces"
});
const $6db9ac048e29dbb5$var$itamNonFinal = (0, $7eNDO.defineMessage)({
    id: "navigation-apps-sidebar-nav4-common.common.itam-non-final",
    defaultMessage: "Hardware"
});
const $6db9ac048e29dbb5$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $6db9ac048e29dbb5$export$d57b6b390e78d90f = 'jira-cosmos';
const $6db9ac048e29dbb5$export$421b92818c76ee2d = Object.values((0, $5IkoH.CONFIGURABLE_MENU_ID));
const $6db9ac048e29dbb5$export$f5a7bd7eb586e4e8 = $6db9ac048e29dbb5$export$421b92818c76ee2d;
const $6db9ac048e29dbb5$export$c52c93cc28495ab0 = Object.values((0, $5IkoH.GLOBAL_APP_MENU_ID));
const $6db9ac048e29dbb5$export$de634ec0f98ab74b = $6db9ac048e29dbb5$export$c52c93cc28495ab0;
const $6db9ac048e29dbb5$export$9a6cc3b78524c807 = {
    [(0, $6GljB.L1_MENU_ID).APPS]: {
        message: $6db9ac048e29dbb5$var$apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fOxy5)))
    },
    [(0, $6GljB.L1_MENU_ID).GOALS]: {
        message: $6db9ac048e29dbb5$var$goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3SFM2)))
    },
    [(0, $6GljB.L1_MENU_ID).ROADMAPS]: {
        message: $6db9ac048e29dbb5$var$roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($b47ZF)))
    },
    [(0, $6GljB.L1_MENU_ID).PLANS]: {
        message: $6db9ac048e29dbb5$var$plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($alDF5)))
    },
    [(0, $6GljB.L1_MENU_ID).PROJECTS]: {
        message: $6db9ac048e29dbb5$var$projectsGalaxia,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($faDlH)))
    },
    [(0, $6GljB.L1_MENU_ID).FILTERS]: {
        message: $6db9ac048e29dbb5$var$filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ)))
    },
    [(0, $6GljB.L1_MENU_ID).DASHBOARDS]: {
        message: $6db9ac048e29dbb5$var$dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2AOCd)))
    },
    [(0, $6GljB.L1_MENU_ID).OPERATIONS]: {
        message: $6db9ac048e29dbb5$var$operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fgD0F)))
    },
    [(0, $6GljB.L1_MENU_ID).ASSETS]: {
        message: $6db9ac048e29dbb5$var$assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9iQvp)))
    },
    [(0, $6GljB.L1_MENU_ID).TEAMS]: {
        message: $6db9ac048e29dbb5$var$teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Olij)))
    },
    [(0, $6GljB.L1_MENU_ID).RECENT]: {
        message: $6db9ac048e29dbb5$var$recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3xiQi)))
    },
    [(0, $6GljB.L1_MENU_ID).STARRED]: {
        message: $6db9ac048e29dbb5$var$starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cXTqc)))
    },
    [(0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: $6db9ac048e29dbb5$var$customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cqJ3S)))
    },
    [(0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: $6db9ac048e29dbb5$var$customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($atP3J)))
    },
    [(0, $6GljB.L1_MENU_ID).CUSTOMERS]: {
        message: $6db9ac048e29dbb5$var$customers,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lWRvF)))
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: $6db9ac048e29dbb5$var$assets,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.AssetsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: $6db9ac048e29dbb5$var$goals,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.GoalsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    // App Shortcuts for Platform Component
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: $6db9ac048e29dbb5$var$confluence,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.ConfluenceIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: $6db9ac048e29dbb5$var$loom,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.LoomIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: $6db9ac048e29dbb5$var$projects,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.ProjectsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: $6db9ac048e29dbb5$var$teams,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.TeamsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: $6db9ac048e29dbb5$var$opsgenie,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.OpsgenieIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "small"
            })
    },
    [(0, $6GljB.L1_MENU_ID).ITAM]: {
        message: $6db9ac048e29dbb5$var$itamNonFinal,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jcIfU)))
    }
};
const $6db9ac048e29dbb5$export$5034ad0032cd499d = {
    message: $6db9ac048e29dbb5$var$forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lxN43)))
};
const $6db9ac048e29dbb5$export$9c99028e1421f69f = {
    [(0, $6GljB.L1_MENU_ID).APPS]: {
        message: $6db9ac048e29dbb5$var$apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fOxy5)))
    },
    [(0, $6GljB.L1_MENU_ID).GOALS]: {
        message: $6db9ac048e29dbb5$var$goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3SFM2)))
    },
    [(0, $6GljB.L1_MENU_ID).ROADMAPS]: {
        message: $6db9ac048e29dbb5$var$roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($b47ZF)))
    },
    [(0, $6GljB.L1_MENU_ID).PLANS]: {
        message: $6db9ac048e29dbb5$var$plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($alDF5)))
    },
    [(0, $6GljB.L1_MENU_ID).PROJECTS]: {
        message: $6db9ac048e29dbb5$var$projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($faDlH)))
    },
    [(0, $6GljB.L1_MENU_ID).FILTERS]: {
        message: $6db9ac048e29dbb5$var$filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8A8fZ)))
    },
    [(0, $6GljB.L1_MENU_ID).DASHBOARDS]: {
        message: $6db9ac048e29dbb5$var$dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2AOCd)))
    },
    [(0, $6GljB.L1_MENU_ID).OPERATIONS]: {
        message: $6db9ac048e29dbb5$var$operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fgD0F)))
    },
    [(0, $6GljB.L1_MENU_ID).ASSETS]: {
        message: $6db9ac048e29dbb5$var$assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9iQvp)))
    },
    [(0, $6GljB.L1_MENU_ID).TEAMS]: {
        message: $6db9ac048e29dbb5$var$teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Olij)))
    },
    [(0, $6GljB.L1_MENU_ID).RECENT]: {
        message: $6db9ac048e29dbb5$var$recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3xiQi)))
    },
    [(0, $6GljB.L1_MENU_ID).STARRED]: {
        message: $6db9ac048e29dbb5$var$starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cXTqc)))
    },
    [(0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: $6db9ac048e29dbb5$var$customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cqJ3S)))
    },
    [(0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: $6db9ac048e29dbb5$var$customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($atP3J)))
    },
    [(0, $6GljB.L1_MENU_ID).CUSTOMERS]: {
        message: $6db9ac048e29dbb5$var$customers,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lWRvF)))
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: $6db9ac048e29dbb5$var$assets,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.AssetsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: $6db9ac048e29dbb5$var$goals,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.GoalsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    // App Shortcuts for Platform Component
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: $6db9ac048e29dbb5$var$confluence,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.ConfluenceIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: $6db9ac048e29dbb5$var$loom,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.LoomIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: $6db9ac048e29dbb5$var$projects,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.ProjectsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: $6db9ac048e29dbb5$var$teams,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.TeamsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: $6db9ac048e29dbb5$var$opsgenie,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.OpsgenieIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "small"
            })
    },
    [(0, $6GljB.L1_MENU_ID).ITAM]: {
        message: $6db9ac048e29dbb5$var$itamNonFinal,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jcIfU)))
    }
};
const $6db9ac048e29dbb5$export$e0063c8eec18df81 = {
    message: $6db9ac048e29dbb5$var$projects,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Ihgk)))
};
const $6db9ac048e29dbb5$export$dbe1165a572764fa = {
    message: $6db9ac048e29dbb5$var$projectsGalaxia,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Ihgk)))
};
const $6db9ac048e29dbb5$export$9fcc53f3b36e0949 = 240; // in pixels
const $6db9ac048e29dbb5$export$6621cd553335536a = 320; // in pixels
const $6db9ac048e29dbb5$export$2eb8dda9e83d33ff = false;
const $6db9ac048e29dbb5$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $6db9ac048e29dbb5$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $6db9ac048e29dbb5$export$89de709e88232646 = 25;
const $6db9ac048e29dbb5$export$b66ae8c18ec95bc6 = $6db9ac048e29dbb5$var$forYou;
const $6db9ac048e29dbb5$export$4da83c858d129f7f = {
    [(0, $6GljB.L1_MENU_ID).APPS]: $6db9ac048e29dbb5$var$apps,
    [(0, $6GljB.L1_MENU_ID).GOALS]: $6db9ac048e29dbb5$var$goals,
    [(0, $6GljB.L1_MENU_ID).ROADMAPS]: $6db9ac048e29dbb5$var$roadmaps,
    [(0, $6GljB.L1_MENU_ID).PLANS]: $6db9ac048e29dbb5$var$plans,
    [(0, $6GljB.L1_MENU_ID).PROJECTS]: $6db9ac048e29dbb5$var$projectsGalaxia,
    [(0, $6GljB.L1_MENU_ID).FILTERS]: $6db9ac048e29dbb5$var$filters,
    [(0, $6GljB.L1_MENU_ID).DASHBOARDS]: $6db9ac048e29dbb5$var$dashboards,
    [(0, $6GljB.L1_MENU_ID).OPERATIONS]: $6db9ac048e29dbb5$var$operations,
    [(0, $6GljB.L1_MENU_ID).ASSETS]: $6db9ac048e29dbb5$var$assets,
    [(0, $6GljB.L1_MENU_ID).TEAMS]: $6db9ac048e29dbb5$var$teams,
    [(0, $6GljB.L1_MENU_ID).RECENT]: $6db9ac048e29dbb5$var$recent,
    [(0, $6GljB.L1_MENU_ID).STARRED]: $6db9ac048e29dbb5$var$starred,
    [(0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE]: $6db9ac048e29dbb5$var$customerHubs,
    [(0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $6db9ac048e29dbb5$var$customerServiceAnalytics,
    [(0, $6GljB.L1_MENU_ID).CUSTOMERS]: $6db9ac048e29dbb5$var$customers,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS]: $6db9ac048e29dbb5$var$assets,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS]: $6db9ac048e29dbb5$var$goals,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: $6db9ac048e29dbb5$var$confluence,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM]: $6db9ac048e29dbb5$var$loom,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS]: $6db9ac048e29dbb5$var$projects,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS]: $6db9ac048e29dbb5$var$teams,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: $6db9ac048e29dbb5$var$opsgenie,
    [(0, $6GljB.L1_MENU_ID).ITAM]: $6db9ac048e29dbb5$var$itamNonFinal
};
const $6db9ac048e29dbb5$export$a9a6fdcb59a8001e = {
    [(0, $6GljB.L1_MENU_ID).APPS]: $6db9ac048e29dbb5$var$apps,
    [(0, $6GljB.L1_MENU_ID).GOALS]: $6db9ac048e29dbb5$var$goals,
    [(0, $6GljB.L1_MENU_ID).ROADMAPS]: $6db9ac048e29dbb5$var$roadmaps,
    [(0, $6GljB.L1_MENU_ID).PLANS]: $6db9ac048e29dbb5$var$plans,
    [(0, $6GljB.L1_MENU_ID).PROJECTS]: $6db9ac048e29dbb5$var$projects,
    [(0, $6GljB.L1_MENU_ID).FILTERS]: $6db9ac048e29dbb5$var$filters,
    [(0, $6GljB.L1_MENU_ID).DASHBOARDS]: $6db9ac048e29dbb5$var$dashboards,
    [(0, $6GljB.L1_MENU_ID).OPERATIONS]: $6db9ac048e29dbb5$var$operations,
    [(0, $6GljB.L1_MENU_ID).ASSETS]: $6db9ac048e29dbb5$var$assets,
    [(0, $6GljB.L1_MENU_ID).TEAMS]: $6db9ac048e29dbb5$var$teams,
    [(0, $6GljB.L1_MENU_ID).RECENT]: $6db9ac048e29dbb5$var$recent,
    [(0, $6GljB.L1_MENU_ID).STARRED]: $6db9ac048e29dbb5$var$starred,
    [(0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE]: $6db9ac048e29dbb5$var$customerHubs,
    [(0, $6GljB.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $6db9ac048e29dbb5$var$customerServiceAnalytics,
    [(0, $6GljB.L1_MENU_ID).CUSTOMERS]: $6db9ac048e29dbb5$var$customers,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_ASSETS]: $6db9ac048e29dbb5$var$assets,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_GOALS]: $6db9ac048e29dbb5$var$goals,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: $6db9ac048e29dbb5$var$confluence,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_LOOM]: $6db9ac048e29dbb5$var$loom,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_PROJECTS]: $6db9ac048e29dbb5$var$projects,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_TEAMS]: $6db9ac048e29dbb5$var$teams,
    [(0, $6GljB.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: $6db9ac048e29dbb5$var$opsgenie,
    [(0, $6GljB.L1_MENU_ID).ITAM]: $6db9ac048e29dbb5$var$itamNonFinal
};

});
parcelRegister("6GljB", function(module, exports) {
$parcel$export(module.exports, "L1_MENU_ID", () => $0cc2d56435dcc409$export$918aea3cf024d90b);
/* eslint-disable jira/filename-case */ 
var $5IkoH = parcelRequire("5IkoH");
const $0cc2d56435dcc409$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $0cc2d56435dcc409$export$bb47524d7f3cb1f8 = {
    ...(0, $5IkoH.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $0cc2d56435dcc409$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $5IkoH.CONFIGURABLE_MENU_ID),
    ...$0cc2d56435dcc409$var$OPERATIONS_MENU_ID
};

});


parcelRegister("2KMaX", function(module, exports) {
$parcel$export(module.exports, "useLeftSidebarState", () => $d4412a78e439851e$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $d4412a78e439851e$export$900f29014a48fb23);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6MMSf = parcelRequire("6MMSf");

var $3h1FP = parcelRequire("3h1FP");

var $7Sa0x = parcelRequire("7Sa0x");
const $d4412a78e439851e$var$useSweetStateLeftSidebarState = (0, $3h1FP.createHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $d4412a78e439851e$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $d4412a78e439851e$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $d4412a78e439851e$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $6MMSf.usePageLayoutResize)();
    return (0, $euxye.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});

parcelRegister("ei93K", function(module, exports) {
$parcel$export(module.exports, "useSiteTitle", () => $b7ce2e82268d8eab$export$3e157e0d79928990);

var $euxye = parcelRequire("euxye");

var $6bEm8 = parcelRequire("6bEm8");
const $b7ce2e82268d8eab$export$3e157e0d79928990 = ()=>(0, $euxye.useMemo)(()=>({
            shouldShow: (0, $6bEm8.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $6bEm8.default)('ajs-app-title')
        }), []);

});

parcelRegister("dB6nz", function(module, exports) {
$parcel$export(module.exports, "Nav4NotificationsData", () => $a883d2fb4c7cd005$export$4be76e93f368ccd9);

var $bYNB8 = parcelRequire("bYNB8");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $4Kt0R = parcelRequire("4Kt0R");

var $82NV6 = parcelRequire("82NV6");
const $a883d2fb4c7cd005$export$4be76e93f368ccd9 = (props)=>{
    const { queryReference: queryReference } = props;
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const fragmentData = (0, $n67Vb.useFragment)((0, $bYNB8.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "nav4-notifications-error-boundary",
        packageName: (0, $4Kt0R.PACKAGE_NAME),
        teamName: (0, $4Kt0R.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $82NV6.Nav4Notifications), {
        fragmentData: fragmentData
    }));
};
$a883d2fb4c7cd005$export$4be76e93f368ccd9.displayName = "Nav4NotificationsData";

});
parcelRegister("bYNB8", function(module, exports) {
$parcel$export(module.exports, "default", () => $db51ba0ae42e830e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa2e1b057e7ee75def51a410db635109>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db51ba0ae42e830e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collabContextRoutingAri"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4NotificationsData",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collabContextRoutingAri",
                    "variableName": "collabContextRoutingAri"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Nav4Notifications"
        }
    ],
    "type": "Query"
};
$db51ba0ae42e830e$var$node.hash = "97f15f8dddc143257dc6ead12a729936";
var $db51ba0ae42e830e$export$2e2bcd8739ae039 = $db51ba0ae42e830e$var$node;

});

parcelRegister("4Kt0R", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $36a87e92cf1443ab$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $36a87e92cf1443ab$export$d57b6b390e78d90f);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $36a87e92cf1443ab$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $36a87e92cf1443ab$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $36a87e92cf1443ab$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $36a87e92cf1443ab$export$286c2faa2103eb9c);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $36a87e92cf1443ab$export$69cbedccc0df48);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $36a87e92cf1443ab$export$cc578bc72d7a7308);
/* eslint-disable jira/filename-case */ const $36a87e92cf1443ab$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__atlassian-navigation';
const $36a87e92cf1443ab$export$d57b6b390e78d90f = 'navigation';
const $36a87e92cf1443ab$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $36a87e92cf1443ab$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    ROADMAPS: 'roadmaps',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    CONVERSATION_ASSISTANT: 'conversationAssistant',
    ROVO_DEMAND_TESTS: 'rovoDemandTests'
};
const $36a87e92cf1443ab$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $36a87e92cf1443ab$export$6037915bf3452cf3 = 'profile-spotlight';
const $36a87e92cf1443ab$export$286c2faa2103eb9c = 'help-spotlight';
const $36a87e92cf1443ab$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $36a87e92cf1443ab$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;

});

parcelRegister("82NV6", function(module, exports) {
$parcel$export(module.exports, "Nav4Notifications", () => $d717a679de9c42b2$export$c50c32b171c62438);

var $5hDbk = parcelRequire("5hDbk");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");


var $4Kt0R = parcelRequire("4Kt0R");

var $hZtRR = parcelRequire("hZtRR");

var $1CdDx = parcelRequire("1CdDx");

var $u9iDa = parcelRequire("u9iDa");

var $7Odw0 = parcelRequire("7Odw0");

var $ajncg = parcelRequire("ajncg");

var $a8EUd = parcelRequire("a8EUd");

var $33SHe = parcelRequire("33SHe");

var $dtDO2 = parcelRequire("dtDO2");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $l8G1z = parcelRequire("l8G1z");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $kt86l = parcelRequire("kt86l");

var $9xzYB = parcelRequire("9xzYB");

var $7UpgX = parcelRequire("7UpgX");

var $44F7e = parcelRequire("44F7e");

var $geKMY = parcelRequire("geKMY");

var $bMTk4 = parcelRequire("bMTk4");


var $48h3z = parcelRequire("48h3z");
const $d717a679de9c42b2$var$tooltip = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.notifications.tooltip",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Notifications"
});
const $d717a679de9c42b2$var$label = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.notifications.label",
    defaultMessage: "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
});
const $d717a679de9c42b2$var$overNineNotifications = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.notifications.over-nine-notifications",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Over 9 Notifications"
}); // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences

const $d717a679de9c42b2$var$LazyMenu = (0, $l8G1z.lazy)(()=>(parcelRequire("lhdMk")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $d717a679de9c42b2$export$c50c32b171c62438 = (props)=>{
    const { fragmentData: fragmentData } = props;
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const cloudId = (0, $kt86l.useCloudId)();
    const collabContextRoutingAri = (0, $euxye.useMemo)(()=>(0, $i860n.fg)('post-office_enable_routing_workspace_id_prop') ? (0, $9xzYB.PlatformSiteAri).create({
            siteId: cloudId
        }).toString() : undefined, [
        cloudId
    ]);
    const [_queryRef, loadQuery] = (0, $n67Vb.useQueryLoader)((0, $44F7e.default));
    const [data] = (0, $n67Vb.useRefetchableFragment)((0, $5hDbk.default), fragmentData);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)(); // Check for new notifications every 5 minutes. This is currently done through polling because
    // Relay subscriptions are not yet supported server side. This polling will need to be replaced with
    // a subscription in the future (when notifications are migrated to Post Office).
    (0, $geKMY.usePolling)((0, $euxye.useCallback)(()=>{
        if ((0, $u9iDa.getDocument)()?.hidden) return;
        (0, $n67Vb.fetchQuery)(environment, (0, $44F7e.default), {
            collabContextRoutingAri: collabContextRoutingAri
        }).subscribe({
            complete: ()=>{
                loadQuery({
                    collabContextRoutingAri: collabContextRoutingAri
                }, {
                    fetchPolicy: 'store-and-network'
                });
            },
            error: (error)=>{
                (0, $6CfY5.default).safeErrorWithoutCustomerData(`${(0, $4Kt0R.PACKAGE_NAME)}.Nav4Notifications`, 'Error fetching notification', error);
            }
        });
    }, [
        environment,
        loadQuery,
        collabContextRoutingAri
    ]), 300000);
    const fetchedNotificationsCount = data.notifications?.unseenNotificationCount ?? 0; // Initialise the state to false on page load, but use an effect to update it if the unseen notification
    // count changes (i.e. as a result of polling) to ensure the badge is shown when there are new notifications.
    const [isNotificationCleared, setIsNotificationCleared] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if (fetchedNotificationsCount > 0) setIsNotificationCleared(false);
    }, [
        fetchedNotificationsCount
    ]); // If notifications have been cleared, force the badge to be 0. This crudely addresses a race condition where
    // opening the menu (which resets the unseen notification count) does not complete before a refetch completes.
    const notificationsCount = isNotificationCleared ? 0 : fetchedNotificationsCount;
    const testIdPrefix = (0, $ajncg.testIdGenerate)('secondary-actions', 'notifications');
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = (0, $33SHe.useTopMenus)((0, $863aeee714b20c92$export$2ce650757fdac12a));
    const content = (0, $euxye.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d717a679de9c42b2$var$NotificationContentFrame, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d717a679de9c42b2$var$LazyMenu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), [
        testIdPrefix
    ]);
    const triggerAnalytics = (0, $7UpgX.useNavigationItemAnalytics)({
        navigationItemId: (0, $4Kt0R.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = (0, $dtDO2.useExperienceStart)({
        experience: (0, $4Kt0R.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $4Kt0R.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $euxye.useCallback)(()=>{
        if (isMenuOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics(); // Always set isNotificationCleared to true when the menu trigger is clicked
        // that there are no unseen notifications).
        setIsNotificationCleared(true); // PLEASE NOTE: Refetching the notifications does not occur here because for some reason
    // it blocks the popup from being closed.
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    (0, $48h3z.useRegisterNotificationsInCommandPalette)(onClick);
    const badge = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bMTk4.Nav4NotificationsBadge), {
            count: notificationsCount
        }), [
        notificationsCount
    ]);
    const notificationsLabel = notificationsCount < (0, $8dfb0c8c68d6c8c9$export$14c62ba6f49b806f) ? formatMessage($d717a679de9c42b2$var$label, {
        count: notificationsCount
    }) : formatMessage($d717a679de9c42b2$var$overNineNotifications);
    const trigger = (0, $euxye.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
            "data-testid": (0, $ajncg.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": "atlassian-navigation-notifications"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZtRR.Notification), {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage($d717a679de9c42b2$var$tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), [
        badge,
        formatMessage,
        isMenuOpen,
        notificationsLabel,
        onClick,
        openMenu,
        testIdPrefix
    ]); // ENGHEALTH-39740: we need to wrap both the popup and trigger as 'listitem' since popup has role 'dialog' which cannot be a direct child of a 'list' parent
    // Any questions on this, reach out to dseong
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1CdDx.default), {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $7Odw0.isSupportedUserAgent)() ? true : undefined,
        autoFocus: false
    }));
};
$d717a679de9c42b2$export$c50c32b171c62438.displayName = "Nav4Notifications";
const $d717a679de9c42b2$var$notificationContentFrameStyles = null;
const $d717a679de9c42b2$var$NotificationContentFrame = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_1bsb1xd4 _4t3i1vpj _1e0c1txw _g7111w2c"
        ])
    }, children);
};
$d717a679de9c42b2$var$NotificationContentFrame.displayName = "NotificationContentFrame";

});
parcelRegister("5hDbk", function(module, exports) {
$parcel$export(module.exports, "default", () => $92a9da851d097a40$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2587aed00fa8e0009b3be6125c628d6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $44F7e = parcelRequire("44F7e");
const $92a9da851d097a40$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collabContextRoutingAri"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $44F7e.default)
        }
    },
    "name": "Nav4Notifications",
    "selections": [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "collabContextRoutingAri",
                            "variableName": "collabContextRoutingAri"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ],
    "type": "Query"
};
$92a9da851d097a40$var$node.hash = "b6d1ac4e3d580a2134a764b9b2657a38";
var $92a9da851d097a40$export$2e2bcd8739ae039 = $92a9da851d097a40$var$node;

});
parcelRegister("44F7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $1705e48fb208b950$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8944108feab3d7e069dc3fd2b7dc265f>>
 * @relayHash 79975a19922cf3d9fe18033074168487
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f3b4a09a7e4266768d98a555e0cad4773688c2aea1b8b19bc7c70ae5741160a
const $1705e48fb208b950$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collabContextRoutingAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "collabContextRoutingAri",
            "variableName": "collabContextRoutingAri"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4NotificationsRefetchableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "Nav4Notifications"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4NotificationsRefetchableQuery",
            "selections": [
                {
                    "concreteType": "InfluentsNotificationQuery",
                    "kind": "LinkedField",
                    "name": "notifications",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "unseenNotificationCount"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9f3b4a09a7e4266768d98a555e0cad4773688c2aea1b8b19bc7c70ae5741160a",
            "metadata": {},
            "name": "Nav4NotificationsRefetchableQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1705e48fb208b950$var$node.hash = "b6d1ac4e3d580a2134a764b9b2657a38";
var $1705e48fb208b950$export$2e2bcd8739ae039 = $1705e48fb208b950$var$node;

});


const $863aeee714b20c92$export$2ce650757fdac12a = 'NOTIFICATIONS';

parcelRegister("hZtRR", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $1ca6db946cf84ded$export$14834abbfce3b8cd);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $38wW7 = parcelRequire("38wW7");

var $2700E = parcelRequire("2700E");
const $1ca6db946cf84ded$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $38wW7.Notifications), {
        isListItem: false,
        badge: badge,
        label: label,
        onClick: onClick,
        isSelected: isSelected,
        // oxlint-disable-next-line typescript/consistent-type-assertions -- PLEASE FIX - ENABLING FLAT LINT CONFIG
        ref: ref,
        ...(0, $2700E.expVal)('jracloud-98425-notification-btn-expand-state', 'isEnabled', false) ? {
            'aria-haspopup': 'dialog',
            'aria-expanded': isSelected
        } : {}
    });
});

});

parcelRegister("ajncg", function(module, exports) {
$parcel$export(module.exports, "testIdConcat", () => $a216dd3ff2f33f60$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $a216dd3ff2f33f60$export$3b86b974ae586844);
/* eslint-disable jira/filename-case */ const $a216dd3ff2f33f60$var$PREFIX = 'atlassian-navigation-';
const $a216dd3ff2f33f60$var$SEPARATOR = '--';
const $a216dd3ff2f33f60$var$isValid = (value)=>value != null && value !== '';
const $a216dd3ff2f33f60$export$794609946480f79c = (id, ...items)=>[
        id,
        ...items
    ].filter(Boolean).join($a216dd3ff2f33f60$var$SEPARATOR).toLowerCase();
const $a216dd3ff2f33f60$export$3b86b974ae586844 = (first, ...rest)=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    $a216dd3ff2f33f60$export$794609946480f79c($a216dd3ff2f33f60$var$PREFIX + ($a216dd3ff2f33f60$var$isValid(first) ? `-${first}` : ''), ...rest);

});

parcelRegister("7UpgX", function(module, exports) {
$parcel$export(module.exports, "useNavigationItemAnalytics", () => $4fd3e66faf6e168e$export$444d136efe970fd3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fTB7r = parcelRequire("fTB7r");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $4fd3e66faf6e168e$export$444d136efe970fd3 = ({ navigationItemId: navigationItemId })=>{
    const { isVisible: isVisible } = (0, $fTB7r.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return (0, $euxye.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
};

});

parcelRegister("geKMY", function(module, exports) {
$parcel$export(module.exports, "usePolling", () => $ce8ab83ee070a590$export$a11f73e3adecd502);

var $euxye = parcelRequire("euxye");
const $ce8ab83ee070a590$export$a11f73e3adecd502 = (callback, delay)=>{
    const callbackRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $euxye.useEffect)(()=>{
        const tick = ()=>{
            if (callbackRef.current) callbackRef.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
};

});

parcelRegister("bMTk4", function(module, exports) {
$parcel$export(module.exports, "Nav4NotificationsBadge", () => $871bcb65b7f7ebb7$export$c4129d57a4559409);

var $euxye = parcelRequire("euxye");

var $hHPrd = parcelRequire("hHPrd");
const $871bcb65b7f7ebb7$export$c4129d57a4559409 = (props)=>{
    const { count: count } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hHPrd.Nav4NotificationsIndicator), {
        count: count
    });
};
$871bcb65b7f7ebb7$export$c4129d57a4559409.displayName = "Nav4NotificationsBadge";

});
parcelRegister("hHPrd", function(module, exports) {
$parcel$export(module.exports, "Nav4NotificationsIndicator", () => $c1de28dc7076f6f3$export$6891e3964002ac9);

var $euxye = parcelRequire("euxye");

var $htkxY = parcelRequire("htkxY");
const $c1de28dc7076f6f3$var$MAX_NOTIFICATIONS_COUNT = 9;
const $c1de28dc7076f6f3$export$6891e3964002ac9 = (props)=>{
    const { appearance: appearance = 'dangerBold', count: count, max: max = $c1de28dc7076f6f3$var$MAX_NOTIFICATIONS_COUNT } = props;
    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-test-selector": "NotificationIndicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $htkxY.default), {
        testId: "atlassian-navigation.ui.notifications.notification-indicator-badge",
        max: max,
        appearance: appearance
    }, count)) : null;
};
$c1de28dc7076f6f3$export$6891e3964002ac9.displayName = "Nav4NotificationsIndicator";

});


/* eslint-disable jira/filename-case */ const $8dfb0c8c68d6c8c9$export$14c62ba6f49b806f = 9;

parcelRegister("48h3z", function(module, exports) {
$parcel$export(module.exports, "useRegisterNotificationsInCommandPalette", () => $b0c7e1981cf18491$export$1859b18f10ade54c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2OHo9 = parcelRequire("2OHo9");

var $kcHzF = parcelRequire("kcHzF");

var $952N1 = parcelRequire("952N1");

var $lKjDV = parcelRequire("lKjDV");

var $cHkYK = parcelRequire("cHkYK");

var $8JXMa = parcelRequire("8JXMa");

var $jm5aK = parcelRequire("jm5aK");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

const $b0c7e1981cf18491$var$checkNotifications = (0, $7eNDO.defineMessage)({
    id: "atlassian-navigation.notifications.command-palette.check-notifications",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Check notifications"
});
const $b0c7e1981cf18491$export$1859b18f10ade54c = (onClick)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { getKeywords: getKeywords } = (0, $lKjDV.useCommandKeywords)();
    const commands = (0, $euxye.useMemo)(()=>[
            {
                id: (0, $71a8d80581e45c48$export$e0226a83abddbd07),
                name: formatMessage($b0c7e1981cf18491$var$checkNotifications),
                primaryAction: {
                    type: (0, $jm5aK.CommandActionType).PERFORM,
                    perform: onClick
                },
                keywords: getKeywords('checkNotificationsSynonyms'),
                section: (0, $kcHzF.COMMAND_PALETTE_SECTIONS).quickActions,
                priority: (0, $952N1.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OHo9))), {
                            spacing: "spacious",
                            label: "",
                            "aria-hidden": true
                        })
                },
                analytics: {
                    action: 'checkNotifications'
                }
            }
        ], [
        formatMessage,
        getKeywords,
        onClick
    ]);
    (0, $8JXMa.useRegisterCommands)((0, $cHkYK.COMMAND_PALETTE_REGISTRY_IDS).CHECK_NOTIFICATIONS, commands);
};

});
parcelRegister("kcHzF", function(module, exports) {
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $94eba9bc58d622dc$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $94eba9bc58d622dc$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $94eba9bc58d622dc$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $94eba9bc58d622dc$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $94eba9bc58d622dc$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $94eba9bc58d622dc$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $94eba9bc58d622dc$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $94eba9bc58d622dc$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $94eba9bc58d622dc$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $94eba9bc58d622dc$export$5e5a87aac5d9771f);
/* eslint-disable jira/filename-case */ // TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $94eba9bc58d622dc$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $94eba9bc58d622dc$export$156ebd2354e25466 = 'issueActions';
const $94eba9bc58d622dc$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $94eba9bc58d622dc$export$9f646ab88e1d2b14 = 'commandPalette';
var $94eba9bc58d622dc$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $94eba9bc58d622dc$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $94eba9bc58d622dc$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $94eba9bc58d622dc$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $94eba9bc58d622dc$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewMyIssues"] = 0] = "viewMyIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 1] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 2] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 3] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 4] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 5] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 6] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $94eba9bc58d622dc$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("952N1", function(module, exports) {
$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $94dad4302278290c$export$5ea2dca0a260365d);
/* eslint-disable jira/filename-case */ // TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $94dad4302278290c$export$5ea2dca0a260365d = /*#__PURE__*/ function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["askRovo"] = 0] = "askRovo";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 1] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 2] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 3] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 4] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 5] = "checkNotifications";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openFilterPopup"] = 6] = "openFilterPopup";
    return COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY;
}({});

});

parcelRegister("lKjDV", function(module, exports) {
$parcel$export(module.exports, "useCommandKeywords", () => $ad2e311642c2fe51$export$4d8fe3ef6385358);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");
const $ad2e311642c2fe51$var$messages = {
    searchYourIssuesSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms',
        defaultMessage: 'Find my ideas tickets requests tasks work',
        description: 'Synonym words for the command "Search your issues" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Search your issues" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    changeStatusSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.change-status-synonyms',
        defaultMessage: 'Move through workflow  Progress Done Complete transition',
        description: 'Synonym words for the command "Change status" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Change status" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    assignToMeSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms',
        defaultMessage: 'self',
        description: 'Synonym words for the command "Assign to me" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Assign to me" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    assignIssueSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms',
        defaultMessage: 'Choose person Give work Pick assignee Select ticket idea',
        description: 'Synonym words for the command "Assign issue" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Assign issue" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    startWatchingIssueSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms',
        defaultMessage: 'Follow work Track Unwatch Unfollow',
        description: 'Synonym words for the command "Start watching issue" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Start watching issue" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    backlogSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.backlog-synonyms',
        defaultMessage: 'Inventory Go',
        description: 'Synonym words for the command "Backlog" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Backlog" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    boardSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.board-synonyms',
        defaultMessage: 'Boards Sprint Kanban Swimlanes Do Go',
        description: 'Synonym words for the command "Board" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Board" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    reportsSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.reports-synonyms',
        defaultMessage: 'Summary Insights Burndown Go',
        description: 'Synonym words for the command "Reports" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Reports" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    timelineSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.timeline-synonyms',
        defaultMessage: 'Plan Work calendar Schedule Overview Delivery Go Roadmap',
        description: 'Synonym words for the command "Timeline" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Timeline" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.quick-search-synonyms',
        defaultMessage: 'Search products across Atlassian Go to',
        description: 'Synonym words for the command "Quick search" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Quick search" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    pageSearchSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.page-search-synonyms',
        defaultMessage: 'Control f Command cmd cntrl Go find ctrl',
        description: 'Synonym words for the command "Page search" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Page search" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    createIssueSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.create-issue-synonyms',
        defaultMessage: 'work Start idea New ticket task',
        description: 'Synonym words for the command "Create issue" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Create issue" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    switchDarkThemeSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms',
        defaultMessage: 'light Darkmode lightmode Change Appearance Colours colors nightmode daymode',
        description: 'Synonym words for the command "Switch to dark theme" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Switch to dark theme" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    matchSystemThemeSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms',
        defaultMessage: 'Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode',
        description: 'Synonym words for the command "Match system theme" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Match system theme" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    copyCurrentPageUrlSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms',
        defaultMessage: 'link website address',
        description: 'Synonym words for the command "Copy current page URL" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Copy current page URL" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    getHelpSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.get-help-synonyms',
        defaultMessage: 'In-product Support Documentation Questions Answers',
        description: 'Synonym words for the command "Get help" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Get help" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewKeyboardShortcutsSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms',
        defaultMessage: 'Hotkeys Show See',
        description: 'Synonym words for the command "View keyboard shortcuts" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View keyboard shortcuts" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    editDescriptionSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.edit-description-synonyms',
        defaultMessage: 'Completion criteria Info Information Details Add Write',
        description: 'Synonym words for the command "Edit description" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Edit description" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    addAttachmentSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms',
        defaultMessage: 'Attach Upload Document Media',
        description: 'Synonym words for the command "Add attachment" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Add attachment" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    addCommentSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.add-comment-synonyms',
        defaultMessage: 'Write Message',
        description: 'Synonym words for the command "Add comment" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Add comment" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    logWorkSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.log-work-synonyms',
        defaultMessage: 'Track Record hours Time spent',
        description: 'Synonym words for the command "Log work" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Log work" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    addRemoveFlagSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms',
        defaultMessage: 'Unflag Mark Unmark Star Unstar',
        description: 'Synonym words for the command "Add/Remove flag" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Add/Remove flag" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    cloneIssueSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms',
        defaultMessage: 'Copy Duplicate Task Idea Request',
        description: 'Synonym words for the command "Clone issue" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Clone issue" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    linkConfluencePageSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms',
        defaultMessage: 'Relate Add Connect',
        description: 'Synonym words for the command "Link Confluence page" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Link Confluence page" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    addAUrlSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms',
        defaultMessage: 'Connect Weblink Link Website Domain',
        description: 'Synonym words for the command "Add a URL" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Add a URL" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    goToIssuesSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms',
        defaultMessage: 'Advanced issue search Project Filter JQL search list View all',
        description: 'Synonym words for the command "Go to issues" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Go to issues" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    goToPersonalSettingsSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms',
        defaultMessage: 'Preferences Notifications Theme Jira labs',
        description: 'Synonym words for the command "Go to personal settings" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Go to personal settings" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    goToAccountSettingsSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms',
        defaultMessage: 'Preferences Privacy Profile Your details Personal information',
        description: 'Synonym words for the command "Go to account settings" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Go to account settings" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewAllIssuesSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms',
        defaultMessage: 'Site issues JQL View all',
        description: 'Synonym words for the command "View all issues" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View all issues" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewAllProjectsSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms',
        defaultMessage: 'List Go',
        description: 'Synonym words for the command "View all projects" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View all projects" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewAllPlansSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms',
        defaultMessage: 'List Go',
        description: 'Synonym words for the command "View all plans" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View all plans" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewAllBoardsSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms',
        defaultMessage: 'List Go',
        description: 'Synonym words for the command "View all boards" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View all boards" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewAllFiltersSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms',
        defaultMessage: 'List Go',
        description: 'Synonym words for the command "View all filters" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View all filters" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewAllDashboardsSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms',
        defaultMessage: 'List Go',
        description: 'Synonym words for the command "View all dashboards" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View all dashboards" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    checkNotificationsSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms',
        defaultMessage: 'window See Updates',
        description: 'Synonym words for the command "Check notifications" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Check notifications" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    goToUserManagementSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms',
        defaultMessage: 'Permissions',
        description: 'Synonym words for the command "Go to user management" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Go to user managagement" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    goToIssuesSynonymsIssueTermRefresh: {
        id: 'command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh',
        defaultMessage: 'Advanced work item search Project Filter JQL search list View all',
        description: 'Synonym words for the command "Go to work items" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Go to work items" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewAllIssuesSynonymsIssueTermRefresh: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms-issue-term-refresh',
        defaultMessage: 'Site work items JQL View all',
        description: 'Synonym words for the command "View all work items" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View all work items" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    goToIssuesSynonymsIssueTermRefreshGalaxia: {
        id: 'command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh-galaxia',
        defaultMessage: 'Advanced work item search Space Filter JQL search list View all',
        description: 'Synonym words for the command "Go to work items" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Go to work items" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewMyOpenIssuesSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-my-open-issues-synonyms',
        defaultMessage: 'Issues assigned in-progress',
        description: 'Synonym words for the command "View my open work items" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View my open work items" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    },
    viewIssuesReportedByMeSynonyms: {
        id: 'command-palette-integration.controllers.use-command-keywords.view-issues-reported-by-me-synonyms',
        defaultMessage: 'Issues created',
        description: 'Synonym words for the command "View work items reported by me" in the command palette. It is not expected a translation of this string, but a list of synonyms of "View work items reported by me" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository'
    }
};
const $ad2e311642c2fe51$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getKeywords = (0, $euxye.useCallback)((keywordGroup)=>$ad2e311642c2fe51$var$messages[keywordGroup] ? formatMessage($ad2e311642c2fe51$var$messages[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});

parcelRegister("cHkYK", function(module, exports) {
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $7c72015a7a999686$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $7c72015a7a999686$export$96f61eb1261e42c3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Documentation for contributing to command palette: go/compal
const $7c72015a7a999686$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    ASK_ROVO: 'ASK_ROVO',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $7c72015a7a999686$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $7c72015a7a999686$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $7c72015a7a999686$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    ASK_ROVO: {
        registryId: $7c72015a7a999686$export$689de18177335e39.ASK_ROVO,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $7c72015a7a999686$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $7c72015a7a999686$export$689de18177335e39.COPY_URL,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $7c72015a7a999686$export$689de18177335e39.DESCRIPTION,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $7c72015a7a999686$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $7c72015a7a999686$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $7c72015a7a999686$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $7c72015a7a999686$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $7c72015a7a999686$export$689de18177335e39.LOG_WORK,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $7c72015a7a999686$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $7c72015a7a999686$export$689de18177335e39.PARENT,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $7c72015a7a999686$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $7c72015a7a999686$export$689de18177335e39.QUICK_ADD,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $7c72015a7a999686$export$689de18177335e39.QUICK_SEARCH,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $7c72015a7a999686$export$689de18177335e39.SHORTCUTS,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $7c72015a7a999686$export$689de18177335e39.STATUS,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $7c72015a7a999686$export$689de18177335e39.STORY_POINTS,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $7c72015a7a999686$export$689de18177335e39.THEME_MODE,
        teamName: $7c72015a7a999686$var$teams.Deliveroo
    }
};

});

parcelRegister("8JXMa", function(module, exports) {
$parcel$export(module.exports, "useRegisterCommands", () => $56ef09b52805d615$export$3f626f8a5dbc29e4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $g9pCh = parcelRequire("g9pCh");
const $56ef09b52805d615$export$3f626f8a5dbc29e4 = (0, $g9pCh.useRegisterCommandsWithRegistry);

});
parcelRegister("g9pCh", function(module, exports) {
$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $ce15d680c148b6cf$export$8a824ae164ff968d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $6OFDk = parcelRequire("6OFDk");

var $guJvr = parcelRequire("guJvr");
function $ce15d680c148b6cf$export$8a824ae164ff968d(registrationId, commands, dependencies = (0, $i860n.fg)('jfp_magma_jira-stable-defaultprops') ? (0, $6OFDk.defaultProps).emptyArray : []) {
    const subscribe = (0, $guJvr.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $euxye.useRef)(commands);
    (0, $euxye.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $euxye.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("6OFDk", function(module, exports) {
$parcel$export(module.exports, "defaultProps", () => $9df83057432d9c07$export$9c21a3269931e1e6);
/**
 * Freezes the given value in non-production environments to catch accidental
 * mutation of shared default values during development and testing.
 */ const $9df83057432d9c07$var$freezeInDev = (value)=>{
    return value;
};
const $9df83057432d9c07$var$defaultPropsResolvedPromise = Promise.resolve();
const $9df83057432d9c07$var$EMPTY_ARRAY = $9df83057432d9c07$var$freezeInDev([]);
const $9df83057432d9c07$var$EMPTY_OBJECT = $9df83057432d9c07$var$freezeInDev({});
const $9df83057432d9c07$var$NOOP = $9df83057432d9c07$var$freezeInDev(()=>undefined);
const $9df83057432d9c07$var$RETURN_NULL = $9df83057432d9c07$var$freezeInDev(()=>null);
const $9df83057432d9c07$var$RETURN_RESOLVED_PROMISE = $9df83057432d9c07$var$freezeInDev(()=>$9df83057432d9c07$var$defaultPropsResolvedPromise);
const $9df83057432d9c07$export$9c21a3269931e1e6 = $9df83057432d9c07$var$freezeInDev({
    emptyArray: $9df83057432d9c07$var$EMPTY_ARRAY,
    emptyObject: $9df83057432d9c07$var$EMPTY_OBJECT,
    noop: $9df83057432d9c07$var$NOOP,
    returnNull: $9df83057432d9c07$var$RETURN_NULL,
    returnResolvedPromise: $9df83057432d9c07$var$RETURN_RESOLVED_PROMISE
});

});

parcelRegister("guJvr", function(module, exports) {
$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $8096e66927e76b70$export$880fc01e31710b27);

var $e7boj = parcelRequire("e7boj");

var $k7wxE = parcelRequire("k7wxE");
function $8096e66927e76b70$export$880fc01e31710b27() {
    const $ = (0, $e7boj.c)(5);
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $k7wxE.useActionsCommandPalette)();
    let t0;
    if ($[0] !== addCommands || $[1] !== removeCommands || $[2] !== removeFromActiveRegistry || $[3] !== updateActiveRegistry) {
        t0 = (registrationId, commands)=>{
            updateActiveRegistry(registrationId, commands);
            addCommands(commands);
            return ()=>{
                removeCommands(commands);
                removeFromActiveRegistry(registrationId, commands);
            };
        };
        $[0] = addCommands;
        $[1] = removeCommands;
        $[2] = removeFromActiveRegistry;
        $[3] = updateActiveRegistry;
        $[4] = t0;
    } else t0 = $[4];
    const subscribe = t0;
    return subscribe;
}

});



/* eslint-disable jira/filename-case */ const $71a8d80581e45c48$export$e0226a83abddbd07 = 'check-notifications';


parcelRegister("lhdMk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("eYLN5")
]).then(()=>parcelRequire('dvlft'));

});



parcelRegister("eSXIF", function(module, exports) {
$parcel$export(module.exports, "Settings", () => $c4a9bb5209bf6510$export$c72f6eaae7b9adff);

var $49Wtf = parcelRequire("49Wtf");

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");


var $n67Vb = parcelRequire("n67Vb");

var $4Kt0R = parcelRequire("4Kt0R");

var $8Iuxc = parcelRequire("8Iuxc");

var $jH3wn = parcelRequire("jH3wn");

var $50EiR = parcelRequire("50EiR");

var $eslhe = parcelRequire("eslhe");

var $g36LP = parcelRequire("g36LP");

var $fbmzj = parcelRequire("fbmzj");

var $dtDO2 = parcelRequire("dtDO2");

var $fNgVF = parcelRequire("fNgVF");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $33SHe = parcelRequire("33SHe");

var $ajncg = parcelRequire("ajncg");

var $gNzvf = parcelRequire("gNzvf");

var $cvA2R = parcelRequire("cvA2R");

var $jreC0 = parcelRequire("jreC0");

var $6ouZy = parcelRequire("6ouZy");

var $7nEKi = parcelRequire("7nEKi");

var $kt86l = parcelRequire("kt86l");

var $ccEzE = parcelRequire("ccEzE");

var $7UpgX = parcelRequire("7UpgX");

var $7OOfr = parcelRequire("7OOfr");
const $c4a9bb5209bf6510$var$SettingsPopupContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, appearance: appearance, isReferenceHidden: isReferenceHidden, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        ...htmlAttributes,
        ref: ref,
        role: "dialog",
        "aria-modal": "true"
    }, children));
$c4a9bb5209bf6510$var$SettingsPopupContainer.displayName = 'SettingsPopupContainer';
const $c4a9bb5209bf6510$var$settings = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Settings",
    id: "atlassian-navigation.settings.menu.settings"
});
const $c4a9bb5209bf6510$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $euxye.memo)(({ settingsActionQueryFragment: settingsActionQueryFragment })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eslhe.TopLevelErrorBoundary), {
        id: (0, $4Kt0R.NAVIGATION_ITEM_ID).SETTINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c4a9bb5209bf6510$var$SettingsContainer, {
        settingsActionQueryFragment: settingsActionQueryFragment
    }));
});
function $c4a9bb5209bf6510$var$SettingsContainer({ settingsActionQueryFragment: settingsActionQueryFragment }) {
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    if (isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c4a9bb5209bf6510$var$SettingsInner, {
        settingsActionQueryFragment: settingsActionQueryFragment
    });
}
$c4a9bb5209bf6510$var$SettingsContainer.displayName = "SettingsContainer";
function $c4a9bb5209bf6510$var$SettingsInner({ settingsActionQueryFragment: settingsActionQueryFragment }) {
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const cloudId = (0, $kt86l.useCloudId)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [isOpen, { toggle: toggleMenu, off: closeMenu }] = (0, $33SHe.useTopMenus)((0, $57a8d3ee2467d6bc$export$1b6b909295618bea));
    const triggerAnalytics = (0, $7UpgX.useNavigationItemAnalytics)({
        navigationItemId: (0, $4Kt0R.NAVIGATION_ITEM_ID).SETTINGS
    });
    (0, $dtDO2.useExperienceStart)({
        experience: (0, $4Kt0R.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $4Kt0R.NAVIGATION_ITEM_ID).SETTINGS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $euxye.useCallback)(()=>{
        toggleMenu();
        triggerAnalytics({
            shownCommandPalettePrompt: isAdmin
        });
    }, [
        isAdmin,
        toggleMenu,
        triggerAnalytics
    ]);
    const testIdPrefix = (0, $ajncg.testIdGenerate)('secondary-actions', 'settings');
    const id = (0, $euxye.useId)();
    const titleId = `top-navigation-settings-header-${id}-title`;
    const settingsMenuQueryData = (0, $n67Vb.useFragment)((0, $49Wtf.default), settingsActionQueryFragment);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            isAdmin: isAdmin,
            appEditions: appEditions
        }), [
        cloudId,
        isAdmin,
        appEditions
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $7OOfr.settingsMenuEntryPoint), entryPointParams);
    const triggerRef = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const Trigger = (0, $euxye.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
            "data-testid": (0, $ajncg.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": "atlassian-navigation-settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fbmzj.Settings), {
            ...triggerProps,
            ref: (element)=>{
                triggerRef(element);
                // oxlint-disable-next-line typescript/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            isSelected: isOpen,
            isListItem: !(0, $i860n.fg)('platform_navx_enghealth57224_settings_a11y'),
            interactionName: "nav4-topNav-settings",
            label: formatMessage($c4a9bb5209bf6510$var$settings)
        })), [
        formatMessage,
        isOpen,
        onClick,
        testIdPrefix,
        triggerRef
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gNzvf.JiraPopup), {
        titleId: titleId,
        isOpen: isOpen,
        ...(0, $i860n.fg)('platform_navx_enghealth57224_settings_a11y') ? {
            popupComponent: $c4a9bb5209bf6510$var$SettingsPopupContainer
        } : {},
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
                id: "nav4-topNav-settings",
                entryPointReferenceSubject: entryPointReferenceSubject,
                packageName: (0, $4Kt0R.PACKAGE_NAME),
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Iuxc.MenuLayout), {
                    isWide: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
                    isScrollable: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jH3wn.MenuSkeletonContent), {
                    testIdPrefix: testIdPrefix
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g36LP.default), {
                    hasSeparator: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $50EiR.MenuSkeletonFooter), {
                    testIdPrefix: testIdPrefix
                }))),
                runtimeProps: {
                    testIdPrefix: testIdPrefix,
                    titleId: titleId,
                    topNavSettingsMenuProjectQueryFragment: settingsMenuQueryData
                }
            }),
        onClose: closeMenu,
        placement: "bottom-end",
        messageId: "atlassian-navigation.ui.settings.popup",
        messageType: "transactional",
        trigger: Trigger,
        label: formatMessage($c4a9bb5209bf6510$var$settings),
        shouldRenderToParent: true
    });
}
$c4a9bb5209bf6510$var$SettingsInner.displayName = "SettingsInner";

});
parcelRegister("49Wtf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2443b65e36d750d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f22bb1e2454483f08c45527f2917f681>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2443b65e36d750d6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SettingsAction_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TopNavSettingsMenu_project_query"
        }
    ],
    "type": "Query"
};
$2443b65e36d750d6$var$node.hash = "968d87a4d8579fe1f70986799a86ffd8";
var $2443b65e36d750d6$export$2e2bcd8739ae039 = $2443b65e36d750d6$var$node;

});

parcelRegister("8Iuxc", function(module, exports) {
$parcel$export(module.exports, "MenuLayout", () => $7bf24a2ca200b40c$export$dc2a07138b27c65b);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
var $8w7Yz = parcelRequire("8w7Yz");

var $72ldR = parcelRequire("72ldR");
const $7bf24a2ca200b40c$export$dc2a07138b27c65b = ({ children: children, isWide: isWide = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7bf24a2ca200b40c$var$Wrapper, {
        isWide: isWide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72ldR.default), {
        maxHeight: $7bf24a2ca200b40c$var$maxHeight
    }, children));
$7bf24a2ca200b40c$export$dc2a07138b27c65b.displayName = "MenuLayout";
const $7bf24a2ca200b40c$var$starStyles = null;
const $7bf24a2ca200b40c$var$maxHeight = 'calc(100vh - 200px)';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bf24a2ca200b40c$var$Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWide: isWide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dx5ss8": (0, $8w7Yz.default)(__cmplp.isWide ? '320px' : '234px')
        },
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1ul9t9uy _p12f1c3h _107nidpf _js70kb7n _nqzgkb7n _ziy7kb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jH3wn", function(module, exports) {
$parcel$export(module.exports, "MenuSkeletonContent", () => $577394f7cfac1e21$export$8db7a6d33c26b25f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $jPTMp = parcelRequire("jPTMp");

var $kENFC = parcelRequire("kENFC");

var $ajncg = parcelRequire("ajncg");
const $577394f7cfac1e21$export$8db7a6d33c26b25f = ({ testIdPrefix: testIdPrefix })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": (0, $ajncg.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jPTMp.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true,
        width: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        hasIcon: true,
        width: "50%"
    }));
$577394f7cfac1e21$export$8db7a6d33c26b25f.displayName = "MenuSkeletonContent";

});

parcelRegister("50EiR", function(module, exports) {
$parcel$export(module.exports, "MenuSkeletonFooter", () => $df3be739e2d1ca63$export$efa6bae06cf20a1);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kENFC = parcelRequire("kENFC");

var $ajncg = parcelRequire("ajncg");
const $df3be739e2d1ca63$export$efa6bae06cf20a1 = ({ testIdPrefix: testIdPrefix, numItems: numItems = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": (0, $ajncg.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        width: "50%"
    }), numItems >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kENFC.default), {
        width: "50%"
    }));
$df3be739e2d1ca63$export$efa6bae06cf20a1.displayName = "MenuSkeletonFooter";

});

parcelRegister("eslhe", function(module, exports) {
$parcel$export(module.exports, "TopLevelErrorBoundary", () => $c1f2a304ccf3f48c$export$b70f1d8bd509b358);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $4Kt0R = parcelRequire("4Kt0R");
const $c1f2a304ccf3f48c$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $euxye.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: `${(0, $4Kt0R.TOP_LEVEL_ERROR_BOUNDARY_ID)}.${id}`,
        packageName: (0, $4Kt0R.PACKAGE_NAME),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};
$c1f2a304ccf3f48c$export$b70f1d8bd509b358.displayName = "TopLevelErrorBoundary";

});

parcelRegister("7OOfr", function(module, exports) {
$parcel$export(module.exports, "settingsMenuEntryPoint", () => $d0f43b62df58314d$export$61e5d93bdc8bc226);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i860n = parcelRequire("i860n");

var $9S9IG = parcelRequire("9S9IG");

const $d0f43b62df58314d$export$61e5d93bdc8bc226 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("brcoc")), {
        moduleId: "73f97a8e",
        moduleName: "TopNavSettingsMenu",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, isAdmin: isAdmin, appEditions: appEditions })=>({
            queries: {
                topNavSettingsMenuQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $9S9IG.default),
                    variables: {
                        cloudId: cloudId,
                        // We can skip the permission check when:
                        // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                        // 2. Upsell is enabled (because upsell is only available to admins), or
                        // 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone)
                        skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' || !(0, $i860n.fg)('jira-onboarding-hub-gate')
                    }
                }
            }
        })
});

});
parcelRegister("9S9IG", function(module, exports) {
$parcel$export(module.exports, "default", () => $2db1b077a8484afc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcec2c6bda8c196228fc3e64daf3d315>>
 * @relayHash e5264ff2e1e93ecc4488b878cd9f6dc0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8879c403b31c51a48f95a1d8bc606857a6f4a3f73b124a3961adc1061bd4f1a8

var $lIGkE = parcelRequire("lIGkE");
const $2db1b077a8484afc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        }
    ], v1 = [
        {
            "condition": "skipDelegatedAdminCheck",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canManageCustomOnboarding",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "MANAGE_CUSTOM_ONBOARDING"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "hasGlobalPermission"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopNavSettingsMenuQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopNavSettingsMenuQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "8879c403b31c51a48f95a1d8bc606857a6f4a3f73b124a3961adc1061bd4f1a8",
            "metadata": {},
            "name": "TopNavSettingsMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2db1b077a8484afc$var$node.hash = "96f23bf06df8dcc622aad2cac544e460";
(0, $lIGkE.PreloadableQueryRegistry).set($2db1b077a8484afc$var$node.params.id, $2db1b077a8484afc$var$node);
var $2db1b077a8484afc$export$2e2bcd8739ae039 = $2db1b077a8484afc$var$node;

});

parcelRegister("brcoc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lSauj").then(()=>parcelRequire('4diCv'));

});



parcelRegister("6OO20", function(module, exports) {
$parcel$export(module.exports, "Search", () => $9fd01b265f1c388d$export$4b85d3515bd863a5);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");


var $4Kt0R = parcelRequire("4Kt0R");

var $jYEcG = parcelRequire("jYEcG");

var $fbAgj = parcelRequire("fbAgj");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $7Tg4F = parcelRequire("7Tg4F");

var $33SHe = parcelRequire("33SHe");

var $gDdYI = parcelRequire("gDdYI");

var $2ffUK = parcelRequire("2ffUK");
var $55BnK = parcelRequire("55BnK");

var $asU2f = parcelRequire("asU2f");

var $bKHMk = parcelRequire("bKHMk");

var $5TyEJ = parcelRequire("5TyEJ");

var $9ioV8 = parcelRequire("9ioV8");
const $9fd01b265f1c388d$var$interactiveSearchSkeletonPlaceholderMessage = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Search",
    id: "atlassian-navigation.search.interactive-search-skeleton-placeholder"
});
const $9fd01b265f1c388d$export$8f0d616c2469c6b6 = ({ setShowRealExperience: setShowRealExperience, injectValue: injectValue, useTopMenus: useTopMenus = (0, $33SHe.useTopMenus) })=>{
    const [_, { on: openMenu }] = useTopMenus((0, $eb044bb12d0b1d65$export$c1b33b1e65f8bd62));
    const { push: push } = (0, $55BnK.useRouterActions)();
    const onClick = (0, $euxye.useCallback)(()=>{
        (0, $5TyEJ.searchLoadOnIntentMetricStartFromSkeleton)();
        setShowRealExperience?.(true);
        openMenu();
    }, [
        setShowRealExperience,
        openMenu
    ]);
    const onMouseOver = (0, $euxye.useCallback)(()=>{
        setShowRealExperience?.(true);
    }, [
        setShowRealExperience
    ]);
    const onEnter = (0, $euxye.useCallback)((e)=>{
        const target = e.target;
        if (target instanceof HTMLInputElement) {
            target.blur();
            const url = (0, $9ioV8.buildJiraAdvancedSearchUrl)({
                query: target.value,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                siteUrl: window.location.origin
            });
            push(url.href);
        }
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.default), {
        inputMode: "search",
        onClick: onClick,
        onMouseOver: onMouseOver,
        onFocus: onClick,
        xcss: $9fd01b265f1c388d$var$quickFindSkeletonStyle,
        testId: "atlassian-navigation.ui.search.quickfind-skeleton-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7Tg4F.QuickFindSkeleton), {
        onEnter: onEnter,
        isNav4Enabled: true,
        injectValue: injectValue
    }));
};
$9fd01b265f1c388d$export$8f0d616c2469c6b6.displayName = "QuickFindSkeleton";
const $9fd01b265f1c388d$var$LoadingSkeletonInteractive = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bKHMk.SkeletonInteractive), {
        placeholder: formatMessage($9fd01b265f1c388d$var$interactiveSearchSkeletonPlaceholderMessage)
    });
};
$9fd01b265f1c388d$var$LoadingSkeletonInteractive.displayName = "LoadingSkeletonInteractive";
const $9fd01b265f1c388d$var$SearchDialogMetricStart = ()=>{
    (0, $euxye.useEffect)(()=>{
        (0, $asU2f.searchDialogMetric).startFromPageLoad();
        (0, $asU2f.searchDialogMetric).mark((0, $asU2f.SEARCH_DIALOG_DOWNLOAD_START_MARK));
    }, []);
    return null;
};
$9fd01b265f1c388d$var$SearchDialogMetricStart.displayName = "SearchDialogMetricStart";
const $9fd01b265f1c388d$var$SearchDialogMetricEnd = ()=>{
    (0, $euxye.useEffect)(()=>{
        (0, $asU2f.searchDialogMetric).mark((0, $asU2f.SEARCH_DIALOG_DOWNLOAD_END_MARK));
    }, []);
    return null;
};
$9fd01b265f1c388d$var$SearchDialogMetricEnd.displayName = "SearchDialogMetricEnd";

const $9fd01b265f1c388d$export$964f3f99df662c38 = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("9UCXN")).then((m)=>m.Search), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/search/main.tsx"
});
const $9fd01b265f1c388d$export$d8beef0361e69378 = (props)=>{
    const [injectValue] = (0, $2ffUK.useQueryParam)('text');
    const isRovoEnabled = (0, $9ioV8.useRovoSearchEnabled)();
    const loadingSkeleton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$export$e455d67f280c301f, {
        useTopMenus: props.useTopMenus
    });
    const skeleton = isRovoEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$export$8f0d616c2469c6b6, {
        useTopMenus: props.useTopMenus,
        injectValue: injectValue
    }) : loadingSkeleton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "search",
        packageName: (0, $4Kt0R.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$var$SearchDialogMetricStart, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "lazy-search",
        fallback: skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$export$964f3f99df662c38, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$var$SearchDialogMetricEnd, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5TyEJ.SearchLoadOnIntentMetricEnd), null)));
};
$9fd01b265f1c388d$export$d8beef0361e69378.displayName = "SearchInner";
const $9fd01b265f1c388d$var$loadingSkeletonExpandableWrapperStyle = {
    width: '100%'
}; // only for nav4
const $9fd01b265f1c388d$export$e455d67f280c301f = ({ setShowRealExperience: setShowRealExperience, useTopMenus: useTopMenus = (0, $33SHe.useTopMenus) })=>{
    const [_, { on: openMenu }] = useTopMenus((0, $eb044bb12d0b1d65$export$c1b33b1e65f8bd62));
    const onClick = (0, $euxye.useCallback)(()=>{
        (0, $5TyEJ.searchLoadOnIntentMetricStartFromSkeleton)();
        setShowRealExperience?.(true);
        openMenu();
    }, [
        setShowRealExperience,
        openMenu
    ]);
    const onMouseOver = (0, $euxye.useCallback)(()=>{
        setShowRealExperience?.(true);
    }, [
        setShowRealExperience
    ]);
    return(// This is being suppressed as it is a light wrapper around the loading skeleton interactive component which is used as an intent sensor to pre-warm the search dialog.
    // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "atlassian-navigation.ui.search.loading-skeleton-expandable",
        onClick: onClick,
        onKeyDown: onClick,
        onMouseOver: onMouseOver,
        onFocus: onClick,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: $9fd01b265f1c388d$var$loadingSkeletonExpandableWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$var$LoadingSkeletonInteractive, null)));
};
$9fd01b265f1c388d$export$e455d67f280c301f.displayName = "LoadingSkeletonExpandable";
const $9fd01b265f1c388d$export$49f3879f38fced1b = (props)=>{
    const [injectValue] = (0, $2ffUK.useQueryParam)('text');
    const { useTopMenus: useTopMenus = (0, $33SHe.useTopMenus) } = props;
    const [isSearchMenuOpen] = useTopMenus((0, $eb044bb12d0b1d65$export$c1b33b1e65f8bd62));
    const [showRealExperience, setShowRealExperience] = (0, $euxye.useState)(isSearchMenuOpen);
    const isRovoEnabled = (0, $9ioV8.useRovoSearchEnabled)();
    (0, $euxye.useEffect)(()=>{
        if (isSearchMenuOpen) setShowRealExperience(true);
    }, [
        isSearchMenuOpen,
        setShowRealExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "atlassian-navigation-search"
    }, showRealExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "atlassian-navigation-search-experience"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$export$d8beef0361e69378, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "atlassian-navigation-search-loading-skeleton-expandable"
    }, isRovoEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$export$8f0d616c2469c6b6, {
        useTopMenus: useTopMenus,
        setShowRealExperience: setShowRealExperience,
        injectValue: injectValue
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9fd01b265f1c388d$export$e455d67f280c301f, {
        useTopMenus: useTopMenus,
        setShowRealExperience: setShowRealExperience
    })));
};
$9fd01b265f1c388d$export$49f3879f38fced1b.displayName = "SearchLoadOnIntent";
const $9fd01b265f1c388d$export$4b85d3515bd863a5 = $9fd01b265f1c388d$export$49f3879f38fced1b;
const $9fd01b265f1c388d$var$quickFindSkeletonStyle = (0, $fbAgj.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.0'
});

});
const $eb044bb12d0b1d65$export$c1b33b1e65f8bd62 = 'SEARCH';

parcelRegister("asU2f", function(module, exports) {
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_START_MARK", () => $51e435e43b4163f8$export$8cd6a987249a6f33);
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_END_MARK", () => $51e435e43b4163f8$export$80ab6637ae730993);
$parcel$export(module.exports, "searchDialogMetric", () => $51e435e43b4163f8$export$46d64d80a1040e9b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvGCa = parcelRequire("jvGCa");
const $51e435e43b4163f8$var$SEARCH_DIALOG_METRIC_KEY = 'search-dialog';
const $51e435e43b4163f8$export$8cd6a987249a6f33 = 'download-start';
const $51e435e43b4163f8$export$80ab6637ae730993 = 'download-end';
const $51e435e43b4163f8$export$46d64d80a1040e9b = (0, $jvGCa.metrics).pageSegmentLoad({
    key: $51e435e43b4163f8$var$SEARCH_DIALOG_METRIC_KEY,
    timings: [
        {
            key: 'download',
            startMark: $51e435e43b4163f8$export$8cd6a987249a6f33,
            endMark: $51e435e43b4163f8$export$80ab6637ae730993
        }
    ]
});

});

parcelRegister("bKHMk", function(module, exports) {
$parcel$export(module.exports, "SkeletonInteractive", () => $fbb724a80d80a03f$export$f6cad695c873cb36);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $793DL = parcelRequire("793DL");

var $3Nrnr = parcelRequire("3Nrnr");

var $1stXX = parcelRequire("1stXX");
const $fbb724a80d80a03f$export$f6cad695c873cb36 = ({ useTheme: useTheme = (0, $1stXX.useTheme), placeholder: placeholder })=>{
    /**
	 * The nav3 custom theme object
	 */ useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $793DL.useLegacySearchTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3Nrnr.ProductSearchInputSkeletonInteractive), {
        shouldFillContainer: true,
        theme: newTheme,
        placeholder: placeholder || '',
        stickySearchEnabled: true
    });
};
$fbb724a80d80a03f$export$f6cad695c873cb36.displayName = "SkeletonInteractive";

});

parcelRegister("5TyEJ", function(module, exports) {
$parcel$export(module.exports, "searchLoadOnIntentMetricStartFromSkeleton", () => $6e3476e5e3ef7e3a$export$a9b73ef5805d7ce);
$parcel$export(module.exports, "SearchLoadOnIntentMetricEnd", () => $6e3476e5e3ef7e3a$export$c802bd101ecfea1);
$parcel$export(module.exports, "searchLoadOnIntentMetricFromSearchFire", () => $6e3476e5e3ef7e3a$export$5c176f125966323d);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
// eslint-disable-next-line no-restricted-properties, jira/jira-ssr/no-unchecked-globals-usage
const $6e3476e5e3ef7e3a$var$getNow = ()=>window?.performance?.now?.();
class $6e3476e5e3ef7e3a$var$SearchLoadOnIntentMetric {
    start(isStartFromSkeleton, startTime = $6e3476e5e3ef7e3a$var$getNow()) {
        if (this.startTime !== null) return;
        this.isStartFromSkeleton = isStartFromSkeleton;
        this.startTime = startTime;
    }
    stop(analyticsEvent, endTime = $6e3476e5e3ef7e3a$var$getNow()) {
        if (this.startTime === null || this.stopTime !== null || this.hasFired) return;
        this.stopTime = endTime;
        (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'searchDialog firstOpen', {
            startTime: Math.round(this.startTime),
            duration: Math.round((this.stopTime || 0) - (this.startTime || 0)),
            isStartFromSkeleton: this.isStartFromSkeleton
        });
        this.hasFired = true;
    }
    constructor(){
        this.hasFired = false;
        this.startTime = null;
        this.stopTime = null;
        this.isStartFromSkeleton = false;
    }
}
$6e3476e5e3ef7e3a$var$SearchLoadOnIntentMetric.displayName = "SearchLoadOnIntentMetric";
let $6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric = new $6e3476e5e3ef7e3a$var$SearchLoadOnIntentMetric();
const $6e3476e5e3ef7e3a$export$b2204437a87141a9 = ()=>$6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric;
const $6e3476e5e3ef7e3a$export$69e5d67124dcdbcb = ()=>{
    $6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric = new $6e3476e5e3ef7e3a$var$SearchLoadOnIntentMetric();
};
const $6e3476e5e3ef7e3a$export$a9b73ef5805d7ce = (startTime)=>{
    $6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric.start(true, startTime);
};
const $6e3476e5e3ef7e3a$export$c802bd101ecfea1 = ({ endTime: endTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        $6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric.stop(createAnalyticsEvent({}), endTime);
    }, [
        createAnalyticsEvent,
        endTime
    ]);
    return null;
};
$6e3476e5e3ef7e3a$export$c802bd101ecfea1.displayName = "SearchLoadOnIntentMetricEnd";
const $6e3476e5e3ef7e3a$export$5c176f125966323d = (analyticsEvent, now = $6e3476e5e3ef7e3a$var$getNow())=>{
    if ($6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric.hasFired || $6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric.startTime !== null) return;
    $6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric.start(false, now);
    $6e3476e5e3ef7e3a$var$searchLoadOnIntentMetric.stop(analyticsEvent, now);
};

});

parcelRegister("9ioV8", function(module, exports) {
$parcel$export(module.exports, "buildJiraAdvancedSearchUrl", () => $7fc38dbb5d2ddfc1$export$b5c6d8d10f4438a4);
$parcel$export(module.exports, "useRovoSearchEnabled", () => $7fc38dbb5d2ddfc1$export$bbc70c8d5b9d7ad2);
$parcel$export(module.exports, "generateSearchUrl", () => $7fc38dbb5d2ddfc1$export$8233bb098a93ad26);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $6bGyp = parcelRequire("6bGyp");

var $i860n = parcelRequire("i860n");

var $ccEzE = parcelRequire("ccEzE");

var $cvA2R = parcelRequire("cvA2R");
const $7fc38dbb5d2ddfc1$var$ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
const $7fc38dbb5d2ddfc1$export$e43472a3ada71740 = (query)=>/^[A-Z0-9]{2,}-\d+$/i.test(query.trim());
const $7fc38dbb5d2ddfc1$var$buildJiraSearchUrl = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $7fc38dbb5d2ddfc1$var$buildSmartQueryAdvancedSearchUrl = (query)=>`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;
const $7fc38dbb5d2ddfc1$var$buildJQLAdvancedIssueUrl = (jql)=>`/issues/?jql=${jql}`;
const $7fc38dbb5d2ddfc1$var$buildTextAdvancedIssueUrl = (text)=>{
    // the text has a value at this stage
    const jql = $7fc38dbb5d2ddfc1$export$e43472a3ada71740(text) && (0, $i860n.fg)('rovo_search_update_work_items_link') ? `issuekey ~ "${encodeURIComponent(text)}*"` : `textfields ~ "${encodeURIComponent(text)}*"`;
    return `/issues/?jql=${jql}`;
};
const $7fc38dbb5d2ddfc1$export$772e48b507423c7c = ({ query: query, jql: jql, issueKeyLookup: issueKeyLookup = true })=>{
    const trimmedQuery = query.trim();
    if (!trimmedQuery) // If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
    return query === '' ? $7fc38dbb5d2ddfc1$var$ISSUE_NAVIGATOR_URL : $7fc38dbb5d2ddfc1$var$buildSmartQueryAdvancedSearchUrl(query);
    if (jql) // if JQL is provided, we build the work items URL with JQL
    return $7fc38dbb5d2ddfc1$var$buildJQLAdvancedIssueUrl(jql);
    if (issueKeyLookup) // we navigate to the search page to handle the single work item page in case the query is a work item key
    return $7fc38dbb5d2ddfc1$var$buildJiraSearchUrl(trimmedQuery);
    return $7fc38dbb5d2ddfc1$var$buildTextAdvancedIssueUrl(trimmedQuery);
};
const $7fc38dbb5d2ddfc1$export$b5c6d8d10f4438a4 = ({ query: query, jql: jql, siteUrl: siteUrl, issueKeyLookup: issueKeyLookup })=>{
    return new URL($7fc38dbb5d2ddfc1$export$772e48b507423c7c({
        query: query,
        jql: jql,
        issueKeyLookup: issueKeyLookup
    }), siteUrl);
};
const $7fc38dbb5d2ddfc1$export$bbc70c8d5b9d7ad2 = ()=>{
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    const rovoEntitlement = (0, $6bGyp.useRovoEntitlementResource)();
    // Return false for anonymous users
    if (isAnonymous) return false;
    /**
	 * Check if JSW or JSM has valid edition (standard or premium)
	 *
	 * We do this as Rovo in Jira is tied to content being indexed by the Search Platform,
	 * which is only done for tenants which have standard, premium and enterprise editions
	 * of Jira Software OR Jira Service Management.
	 * Ref:
	 * - https://bitbucket.org/atlassian/xpsearch-content/src/a0344602bf66ed47e3b71414fe873651988cff84/xpsearch-content-indexer/src/main/java/io/atlassian/xpsearch/content/indexer/service/event/tenant/ContentReindexingTenantLifecycleHandler.java#lines-178
	 * - https://bitbucket.org/atlassian/xpsearch-content/src/a0344602bf66ed47e3b71414fe873651988cff84/xpsearch-content-indexer/src/main/java/io/atlassian/xpsearch/content/indexer/service/event/tenant/ContentReindexingTenantLifecycleHandler.java#lines-346:354
	 *
	 * Note that we only check for STANDARD_EDITION and PREMIUM_EDITION as enterprise
	 * edition gets mapped to PREMIUM_EDITION. This was confirmed by checking the TCS record for Hello
	 * - XPSearchTransformer: jira-software.ondemand is enterprise
	 * - JiraBifrostTransformer: productEditions['jira-software'] is 'p', i.e. premium
	 * https://snoopr.prod.atl-paas.net/ts?zone=prod&entity_type=CLOUD&key-type=AUTO_GUESS&s=a436116f-02ce-4520-8fbb-7301462a1674
	 */ const isValidEdition = (edition)=>edition === (0, $d8LhJ.STANDARD_EDITION) || edition === (0, $d8LhJ.PREMIUM_EDITION);
    const hasValidJSWEdition = isValidEdition(appEditions?.software);
    const hasValidJSMEdition = isValidEdition(appEditions?.serviceDesk);
    // Return false if neither JSW nor JSM has a valid edition
    if (!hasValidJSWEdition && !hasValidJSMEdition) return false;
    return rovoEntitlement?.data?.isRovoEnabled && (0, $i860n.fg)('rovo_search_jira_enabled');
};
const $7fc38dbb5d2ddfc1$var$buildRovoSearchUrl = (siteUrl, queryString)=>{
    const url = new URL('/jira/rovo-search', siteUrl || '');
    url.searchParams.append('text', queryString || '');
    return url;
};
const $7fc38dbb5d2ddfc1$export$8233bb098a93ad26 = (urlQueryParams, isSecondaryLink, origin, search, issueKeyLookup)=>{
    const { jql: jql = '', text: queryString = '', ...rest } = urlQueryParams;
    // Suppress warning of `window` usage. This code is never run on the server so this usage is safe
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const siteOrigin = origin ?? window.location.origin;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const siteSearch = search ?? window.location.search;
    const url = isSecondaryLink ? $7fc38dbb5d2ddfc1$export$b5c6d8d10f4438a4({
        query: queryString?.toString() || '',
        siteUrl: siteOrigin,
        jql: jql?.toString() || '',
        issueKeyLookup: issueKeyLookup
    }) : $7fc38dbb5d2ddfc1$var$buildRovoSearchUrl(siteOrigin, queryString?.toString());
    // Default - Set search params for rovo search link only
    if (!isSecondaryLink) {
        const searchParams = new URLSearchParams(siteSearch);
        Object.entries(urlQueryParams).forEach(([key, value])=>{
            if (value !== undefined && value !== null) searchParams.set(key, String(value));
        });
        url.search = searchParams.toString();
    } else // while navigating to NIN we need to a few query parameters to preserve the context of the session.
    Object.entries(rest).forEach(([key, value])=>{
        if (value !== undefined && value !== null) url.searchParams.set(key, String(value));
    });
    return url.href;
};

});

parcelRegister("9UCXN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("fi7J0")
]).then(()=>parcelRequire('8DuIQ'));

});


parcelRegister("5UJCz", function(module, exports) {
$parcel$export(module.exports, "NavigationRouterListener", () => $2dc38cb53798c8a4$export$85575e1c48f0a517);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bc9Gj = parcelRequire("bc9Gj");

var $jEnmK = parcelRequire("jEnmK");
const $2dc38cb53798c8a4$export$85575e1c48f0a517 = ()=>{
    const [{ route: route, location: location, match: match }] = (0, $bc9Gj.useRouter)();
    const onEnd = (0, $jEnmK.useAtlassianNavigationEnd)();
    (0, $euxye.useLayoutEffect)(()=>{
        onEnd();
    }, [
        route,
        match,
        location,
        onEnd
    ]);
    return null;
};
$2dc38cb53798c8a4$export$85575e1c48f0a517.displayName = "NavigationRouterListener";

});
parcelRegister("jEnmK", function(module, exports) {
$parcel$export(module.exports, "useAtlassianNavigationEnd", () => $ab4f8ccda64e76b8$export$4b9602c0fdb8b1bb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");


var $OPiBr = parcelRequire("OPiBr");
const $ab4f8ccda64e76b8$export$4b9602c0fdb8b1bb = ()=>{
    const { setAppReadyWithAppId: setAppReadyWithAppId } = (0, $OPiBr.useSpaStateActions)();
    return (0, $euxye.useCallback)(()=>{
        setAppReadyWithAppId((0, $70e36d23224a09de$export$3a54edb6ba4daa82));
    }, [
        setAppReadyWithAppId
    ]);
};

});


parcelRegister("8dSY2", function(module, exports) {
$parcel$export(module.exports, "HelpButton", () => $4cb7c2ee839e4e10$export$78bddedbcf2939ac);

var $475Eb = parcelRequire("475Eb");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $ik1Zc = parcelRequire("ik1Zc");

var $4eeMq = parcelRequire("4eeMq");

var $hT5UW = parcelRequire("hT5UW");


var $aTRDI = parcelRequire("aTRDI");

var $4Kt0R = parcelRequire("4Kt0R");

var $eslhe = parcelRequire("eslhe");

var $1U1HH = parcelRequire("1U1HH");

var $2b39L = parcelRequire("2b39L");

var $cvA2R = parcelRequire("cvA2R");

var $33SjG = parcelRequire("33SjG");

var $ajncg = parcelRequire("ajncg");

var $29eRG = parcelRequire("29eRG");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $33SHe = parcelRequire("33SHe");


var $esHVv = parcelRequire("esHVv");

var $lB9M9 = parcelRequire("lB9M9");

var $i860n = parcelRequire("i860n");

var $4yRYr = parcelRequire("4yRYr");

var $7UpgX = parcelRequire("7UpgX");

var $8vIOu = parcelRequire("8vIOu");
const $4cb7c2ee839e4e10$var$tooltip = (0, $7eNDO.defineMessage)({
    defaultMessage: "Help",
    id: "atlassian-navigation.help.tooltip"
});
const $4cb7c2ee839e4e10$var$label = (0, $7eNDO.defineMessage)({
    defaultMessage: "Help",
    id: "atlassian-navigation.help.label"
});
function $4cb7c2ee839e4e10$export$70a45859468ee32a({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4eeMq.SpotlightManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4cb7c2ee839e4e10$var$SpotlightTarget, {
        name: (0, $4Kt0R.HELP_SPOTLIGHT_KEY)
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ik1Zc.EngagementSpotlight), {
        isMigrated: true,
        name: (0, $4Kt0R.HELP_SPOTLIGHT_KEY)
    }));
}
$4cb7c2ee839e4e10$export$70a45859468ee32a.displayName = "SpotlightTargetComponent";
function $4cb7c2ee839e4e10$var$SpotlightTarget({ children: children, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hT5UW.SpotlightTarget), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": `ak-spotlight-target-${props.name}`
    }, children));
}
$4cb7c2ee839e4e10$var$SpotlightTarget.displayName = "SpotlightTarget";
const $4cb7c2ee839e4e10$var$getReleaseNotesNotifications = (jsonValue)=>{
    if (!jsonValue) return null;
    try {
        const parsed = JSON.parse(jsonValue);
        return parsed?.helpPanelMenu?.releaseNotesNotifications ?? null;
    } catch  {
        return null;
    }
};
const $4cb7c2ee839e4e10$var$HelpButtonCore = ({ relayInitialValue: relayInitialValue })=>{
    const { releaseNotesNotifications: releaseNotesNotifications, setReleaseNotesNotifications: setReleaseNotesNotifications } = (0, $4yRYr.useHelpButtonState)(relayInitialValue);
    const isProjectSimplified = (0, $2b39L.useIsSimplifiedProject)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $33SHe.useTopMenus)((0, $1056e2b7e19aa4e0$export$f4208f01301e1342));
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const [topMenusValue, { off: closeAllMenus }] = (0, $33SHe.useTopMenus)();
    const [, { setNavigationData: setNavigationData }] = (0, $esHVv.useHelpPanelActions)();
    const helpButtonRef = (0, $euxye.useRef)(null);
    const attributes = (0, $euxye.useMemo)(()=>({
            helpPanelVersion: (0, $2b56b53c34bc2033$export$c43c7444da662fa1),
            helpPanelType: 'inProductHelp',
            nextGenProject: isProjectSimplified
        }), [
        isProjectSimplified
    ]);
    const triggerAnalytics = (0, $7UpgX.useNavigationItemAnalytics)({
        navigationItemId: (0, $4Kt0R.NAVIGATION_ITEM_ID).HELP
    });
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $29eRG.useRightSidebarController)();
    const currentRightSidebarState = (0, $29eRG.useActiveRightSidebarState)();
    const isHelpPanelOpenedPreviously = (0, $33SjG.usePrevious)(currentRightSidebarState);
    const testIdPrefix = (0, $ajncg.testIdGenerate)('secondary-actions', 'help');
    const { state: panelState, manager: manager } = (0, $lB9M9.usePanelManager)();
    const onClick = (0, $euxye.useCallback)(()=>{
        if ((0, $i860n.fg)('ads-panel-system-jira-admin')) {
            if (panelState.activePanels[0]) {
                const currentPanelInstanceId = panelState.activePanels[0].instanceId;
                manager.closePanel(currentPanelInstanceId);
            }
        }
        if (currentRightSidebarState && currentRightSidebarState.panelId === (0, $2b56b53c34bc2033$export$e99efa3985fa3c26) && !currentRightSidebarState.isCollapsed) closeCurrentRightSidebar();
        else openRightSidebar((0, $2b56b53c34bc2033$export$e99efa3985fa3c26), (0, $2b56b53c34bc2033$export$23aa6670f346c214), false, true);
        closeAllMenus();
        setNavigationData({
            articleId: {
                id: '',
                type: (0, $1U1HH.ARTICLE_TYPE).HELP_ARTICLE
            },
            history: []
        });
        // Shows if the help panel is currently open or closed
        const isPanelOpen = currentRightSidebarState?.panelId === (0, $2b56b53c34bc2033$export$e99efa3985fa3c26) && !currentRightSidebarState?.isCollapsed;
        triggerAnalytics({
            ...attributes,
            isOpened: !isPanelOpen
        });
    }, [
        currentRightSidebarState,
        closeAllMenus,
        setNavigationData,
        triggerAnalytics,
        attributes,
        panelState.activePanels,
        manager,
        closeCurrentRightSidebar,
        openRightSidebar
    ]);
    const badge = (0, $euxye.useCallback)(()=>{
        if (isAnonymous) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8vIOu.Badge), {
            releaseNotesNotifications: releaseNotesNotifications ?? 0
        });
    }, [
        isAnonymous,
        releaseNotesNotifications
    ]);
    // Mirror the same logic as the original Help component: when the help panel is open and
    // there are unread notifications, tell the hook to clear them. The hook handles the REST PUT.
    const shouldRestoreNotificationsCount = currentRightSidebarState?.isCollapsed === false && releaseNotesNotifications !== 0;
    (0, $euxye.useEffect)(()=>{
        if (shouldRestoreNotificationsCount) setReleaseNotesNotifications(0);
    }, [
        setReleaseNotesNotifications,
        shouldRestoreNotificationsCount
    ]);
    (0, $euxye.useEffect)(()=>{
        if (currentRightSidebarState?.panelId === (0, $2b56b53c34bc2033$export$e99efa3985fa3c26) && !currentRightSidebarState?.isCollapsed) openMenu();
        else {
            closeMenu();
            if (isHelpPanelOpenedPreviously?.panelId === (0, $2b56b53c34bc2033$export$e99efa3985fa3c26) && !currentRightSidebarState) requestAnimationFrame(()=>helpButtonRef.current?.focus());
        }
    }, [
        closeMenu,
        currentRightSidebarState,
        isHelpPanelOpenedPreviously,
        openMenu,
        topMenusValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": (0, $ajncg.testIdConcat)(testIdPrefix, 'menu-trigger'),
        "data-vc": "atlassian-navigation-help"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4cb7c2ee839e4e10$export$70a45859468ee32a, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aTRDI.Help), {
        "aria-expanded": false,
        "aria-haspopup": false,
        isSelected: isMenuOpen,
        badge: badge,
        onClick: onClick,
        tooltip: formatMessage($4cb7c2ee839e4e10$var$tooltip),
        label: formatMessage($4cb7c2ee839e4e10$var$label),
        ref: helpButtonRef
    })));
};
$4cb7c2ee839e4e10$var$HelpButtonCore.displayName = "HelpButtonCore";
const $4cb7c2ee839e4e10$var$HelpButtonAnonymous = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4cb7c2ee839e4e10$var$HelpButtonCore, {
        relayInitialValue: undefined
    });
$4cb7c2ee839e4e10$var$HelpButtonAnonymous.displayName = "HelpButtonAnonymous";
const $4cb7c2ee839e4e10$var$HelpButtonLoggedIn = ({ QueryFragment: QueryFragment })=>{
    const queryData = (0, $n67Vb.useFragment)((0, $475Eb.default), QueryFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4cb7c2ee839e4e10$var$HelpButtonCore, {
        relayInitialValue: $4cb7c2ee839e4e10$var$getReleaseNotesNotifications(queryData?.jira?.jsonUserProperty?.jsonValue)
    });
};
$4cb7c2ee839e4e10$var$HelpButtonLoggedIn.displayName = "HelpButtonLoggedIn";
function $4cb7c2ee839e4e10$export$78bddedbcf2939ac({ QueryFragment: QueryFragment }) {
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eslhe.TopLevelErrorBoundary), {
        id: (0, $4Kt0R.NAVIGATION_ITEM_ID).HELP
    }, isAnonymous || !QueryFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4cb7c2ee839e4e10$var$HelpButtonAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4cb7c2ee839e4e10$var$HelpButtonLoggedIn, {
        QueryFragment: QueryFragment
    }));
}
$4cb7c2ee839e4e10$export$78bddedbcf2939ac.displayName = "HelpButton";

});
parcelRegister("475Eb", function(module, exports) {
$parcel$export(module.exports, "default", () => $bab6e0a334f63912$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44e96551102ce719916679439850d7e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bab6e0a334f63912$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "HelpButton_query",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "propertyKey",
                            "value": "help_button_ui_state"
                        }
                    ],
                    "concreteType": "JiraEntityPropertyJSON",
                    "kind": "LinkedField",
                    "name": "jsonUserProperty",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jsonValue"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$bab6e0a334f63912$var$node.hash = "b16f7c262a9e67dafab211133bb8bc5e";
var $bab6e0a334f63912$export$2e2bcd8739ae039 = $bab6e0a334f63912$var$node;

});

const $1056e2b7e19aa4e0$export$f4208f01301e1342 = 'HELP';

parcelRegister("aTRDI", function(module, exports) {
$parcel$export(module.exports, "Help", () => $085122638160b11e$export$1be7516c0280bee8);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hXMfa = parcelRequire("hXMfa");
const $085122638160b11e$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hXMfa.Help), {
        badge: badge,
        label: label,
        onClick: onClick,
        isSelected: isSelected,
        ref: ref
    });
});

});

parcelRegister("esHVv", function(module, exports) {
$parcel$export(module.exports, "useHelpPanel", () => $636c762fddf3106b$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $636c762fddf3106b$export$c61f56f4797e22db);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $iGu4q = parcelRequire("iGu4q");

var $86Ihh = parcelRequire("86Ihh");
const $636c762fddf3106b$export$3fe94d66377a53b8 = (0, $3h1FP.createHook)((0, $86Ihh.default));
const $636c762fddf3106b$export$c61f56f4797e22db = (0, $3h1FP.createHook)((0, $86Ihh.default), {
    selector: null
});
const $636c762fddf3106b$export$513717a84f55db1a = (0, $iGu4q.createSubscriber)((0, $86Ihh.default), {
    displayName: 'HelpPanelSubscriber'
});
const $636c762fddf3106b$export$5f4de38bd79f4446 = (0, $iGu4q.createSubscriber)((0, $86Ihh.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("86Ihh", function(module, exports) {
$parcel$export(module.exports, "default", () => $67086ca75292725d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $cBnIS = parcelRequire("cBnIS");

var $5QDqc = parcelRequire("5QDqc");

var $9Bz3y = parcelRequire("9Bz3y");
let $67086ca75292725d$var$iphStorage;
const $67086ca75292725d$var$createStorage = ()=>{
    if ($67086ca75292725d$var$iphStorage) return $67086ca75292725d$var$iphStorage;
    $67086ca75292725d$var$iphStorage = (0, $cBnIS.createSessionStorageProvider)('iph');
    return $67086ca75292725d$var$iphStorage;
};
const $67086ca75292725d$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $67086ca75292725d$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
const $67086ca75292725d$var$ExportedComponent = (0, $5QDqc.createStore)({
    name: 'help-panel',
    initialState: $67086ca75292725d$var$initialState,
    actions: $9Bz3y
});
var $67086ca75292725d$export$2e2bcd8739ae039 = $67086ca75292725d$var$ExportedComponent;

});
parcelRegister("9Bz3y", function(module, exports) {
$parcel$export(module.exports, "setNavigationData", () => $8e0bf5353297d269$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $8e0bf5353297d269$export$cdabe01d01a8da1e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cBnIS = parcelRequire("cBnIS");
const $8e0bf5353297d269$var$iphStorage = (0, $cBnIS.createSessionStorageProvider)('iph');
const $8e0bf5353297d269$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        // @browser-storage setter
        $8e0bf5353297d269$var$iphStorage.set('history', []);
    };
const $8e0bf5353297d269$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("4yRYr", function(module, exports) {
$parcel$export(module.exports, "useHelpButtonState", () => $e0052d33f19531a2$export$e3d3de46b23d1ede);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $3GN2r = parcelRequire("3GN2r");

var $eBwkE = parcelRequire("eBwkE");
const $e0052d33f19531a2$export$53f45136e435c2fd = 'help_button_ui_state';
const $e0052d33f19531a2$export$e3d3de46b23d1ede = (relayInitialValue)=>{
    const [releaseNotesNotifications, setReleaseNotesNotifications] = (0, $euxye.useState)(null);
    // Derive the initial notification value from the pre-parsed Relay value.
    // We normalise null → undefined so that the sentinel-value branch in updateData()
    // fires (mapping undefined → 100), matching the existing behaviour when the server
    // returns no releaseNotesNotifications value.
    const userReleaseNotesNotifications = relayInitialValue ?? undefined;
    const accountId = (0, $3GN2r.useAccountId)();
    const updateData = (0, $euxye.useCallback)(()=>{
        const newReleaseNotesNotificationsValue = userReleaseNotesNotifications !== undefined ? userReleaseNotesNotifications : 100;
        if (releaseNotesNotifications !== null) {
            if (newReleaseNotesNotificationsValue !== releaseNotesNotifications) {
                const remoteData = {
                    helpPanelMenu: {
                        releaseNotesNotifications: releaseNotesNotifications
                    }
                };
                (0, $eBwkE.updateHelpButtonState)(accountId, remoteData);
            }
        } else setReleaseNotesNotifications(newReleaseNotesNotificationsValue);
    }, [
        accountId,
        releaseNotesNotifications,
        userReleaseNotesNotifications
    ]);
    (0, $euxye.useEffect)(()=>{
        updateData();
    }, [
        updateData
    ]);
    return {
        releaseNotesNotifications: releaseNotesNotifications,
        setReleaseNotesNotifications: setReleaseNotesNotifications
    };
};

});
parcelRegister("eBwkE", function(module, exports) {
$parcel$export(module.exports, "updateHelpButtonState", () => $1b35af9b4ea0c44a$export$c70764abdc0ffd52);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

const $1b35af9b4ea0c44a$export$c70764abdc0ffd52 = async (accountId, data)=>{
    if (accountId !== null) try {
        await (0, $kM0go.setUserProperties)(accountId, (0, $a250aea31dc76f65$export$53f45136e435c2fd), JSON.stringify(data));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: e,
            meta: {
                id: 'updateServerHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
};

});
/* eslint-disable jira/filename-case */ const $a250aea31dc76f65$export$53f45136e435c2fd = 'help_button_ui_state';



parcelRegister("8vIOu", function(module, exports) {
$parcel$export(module.exports, "Badge", () => $4c360ca6c664b708$export$37acb3580601e69a);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $lnVHd = parcelRequire("lnVHd");

var $9IVAj = parcelRequire("9IVAj");
const $4c360ca6c664b708$export$37acb3580601e69a = ({ releaseNotesNotifications: releaseNotesNotifications = 0 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lnVHd.RenderOnClient), null, releaseNotesNotifications > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9IVAj.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, releaseNotesNotifications) : null);
};
$4c360ca6c664b708$export$37acb3580601e69a.displayName = "Badge";

});
parcelRegister("9IVAj", function(module, exports) {
$parcel$export(module.exports, "LazyNotifications", () => $5bdd7b7039f6ae95$export$eebecbd0322becdd);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $4Kt0R = parcelRequire("4Kt0R");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5bdd7b7039f6ae95$var$Notifications = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("4XR1f")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/badge/src/index.tsx"
});
const $5bdd7b7039f6ae95$export$eebecbd0322becdd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "help.atlaskit-badge",
        packageName: (0, $4Kt0R.PACKAGE_NAME),
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "lazy-notification-badge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5bdd7b7039f6ae95$var$Notifications, props)));
$5bdd7b7039f6ae95$export$eebecbd0322becdd.displayName = "LazyNotifications";

});
parcelRegister("4XR1f", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("da1jp").then(()=>parcelRequire('ineMx'));

});




parcelRegister("dERcp", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistant", () => $bd548de2e7e4227e$export$9777b121d71c4de1);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6bGyp = parcelRequire("6bGyp");

var $4Kt0R = parcelRequire("4Kt0R");

var $eslhe = parcelRequire("eslhe");

var $ihEDU = parcelRequire("ihEDU");

var $3XwjJ = parcelRequire("3XwjJ");

var $6ecZV = parcelRequire("6ecZV");

var $bgVXr = parcelRequire("bgVXr");

var $kEMEj = parcelRequire("kEMEj");

var $PLKZi = parcelRequire("PLKZi");

var $33SHe = parcelRequire("33SHe");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $kt86l = parcelRequire("kt86l");

var $ezKom = parcelRequire("ezKom");

var $2700E = parcelRequire("2700E");

var $Bq7bE = parcelRequire("Bq7bE");

var $i860n = parcelRequire("i860n");

var $lB9M9 = parcelRequire("lB9M9");
const $bd548de2e7e4227e$var$AssistantButton = (0, $PLKZi.ConversationAssistantButtonNav4);
const $bd548de2e7e4227e$var$ConversationAssistantButton = ()=>{
    const [_topMenusValue, { off: closeAllMenus }] = (0, $33SHe.useTopMenus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const cloudId = (0, $kt86l.useCloudId)();
    const { isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, mode: mode } = (0, $Bq7bE.useRovoExperienceAPIStore)();
    const sidebarApi = (0, $ezKom.useConversationAssistantSidebarApi)({
        isMinimised: false,
        toTop: true
    });
    const { state: panelState, manager: manager } = (0, $lB9M9.usePanelManager)();
    const isActive = sidebarApi.isSidebarOpen();
    const onButtonClick = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: true
        });
        if ((0, $i860n.fg)('ads-panel-system-jira-admin')) {
            if (panelState.activePanels[0]) {
                const currentPanelInstanceId = panelState.activePanels[0].instanceId;
                manager.closePanel(currentPanelInstanceId);
            }
        }
        toggleConversationAssistantUIMode({
            targetMode: (0, $6ecZV.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
        closeAllMenus();
    }, [
        closeAllMenus,
        createAnalyticsEvent,
        toggleConversationAssistantUIMode,
        sidebarApi,
        panelState.activePanels,
        manager
    ]);
    const buttonRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        as: "span",
        testId: "atlassian-navigation.ui.conversation-assistant.app-navigation-ai-mate",
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bd548de2e7e4227e$var$AssistantButton, {
        onClick: onButtonClick,
        isActive: isActive,
        siteId: cloudId,
        productKey: "jira",
        enableOnboardingSpotlight: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3XwjJ.ChatContextSubscriber), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bgVXr.ChatOpenerSubscriber), {
        onTriggerOpeningChat: (_conversationId, openChatMode, source)=>{
            if (source === 'input-prompt-box' && (0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false) || source === 'ai-mate' && (0, $i860n.fg)('add_source_for_mini_rovo_trigger')) {
                if (isMiniModalAvailable) openConversationAssistantUIMode({
                    targetMode: (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL,
                    sidebarApi: sidebarApi
                });
                else openConversationAssistantUIMode({
                    targetMode: (0, $6ecZV.ConversationAssistantUIModes).SIDEBAR,
                    sidebarApi: sidebarApi
                });
                return;
            }
            const resolvedMode = openChatMode ?? mode;
            openConversationAssistantUIMode({
                targetMode: resolvedMode === 'mini-modal' && isMiniModalAvailable ? (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL : (0, $6ecZV.ConversationAssistantUIModes).SIDEBAR,
                sidebarApi: sidebarApi
            });
        }
    }));
};
$bd548de2e7e4227e$var$ConversationAssistantButton.displayName = "ConversationAssistantButton";
const $bd548de2e7e4227e$export$9777b121d71c4de1 = ()=>{
    const { data: data } = (0, $6bGyp.useRovoEntitlementResource)();
    const shouldShowConversationAssistantButton = data?.isRovoLLMEnabled ?? false;
    const buttonRender = shouldShowConversationAssistantButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bd548de2e7e4227e$var$ConversationAssistantButton, null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eslhe.TopLevelErrorBoundary), {
        id: (0, $4Kt0R.NAVIGATION_ITEM_ID).CONVERSATION_ASSISTANT
    }, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kEMEj.RovoEntitlementSetter), {
        isRovoEnabled: shouldShowConversationAssistantButton
    }));
};
$bd548de2e7e4227e$export$9777b121d71c4de1.displayName = "ConversationAssistant";

});
parcelRegister("ezKom", function(module, exports) {
$parcel$export(module.exports, "useConversationAssistantSidebarApi", () => $2996537acac72906$export$b7bc690143f733fd);

var $euxye = parcelRequire("euxye");

var $29eRG = parcelRequire("29eRG");

const $2996537acac72906$export$b7bc690143f733fd = ({ width: width = (0, $2de0ca8181f03e7e$export$64aee74ba59709e5), isMinimised: isMinimised, toTop: toTop })=>{
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $29eRG.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $29eRG.useActiveRightSidebarState)() || {};
    const isActive = panelId === (0, $2de0ca8181f03e7e$export$dffb4ed44e20ea9a) && !isCollapsed;
    const isOtherPanelActive = panelId !== (0, $2de0ca8181f03e7e$export$dffb4ed44e20ea9a) && !isCollapsed;
    const openSidebar = (0, $euxye.useCallback)((newWidth)=>{
        isOtherPanelActive && closeCurrentRightSidebar();
        openRightSidebar((0, $2de0ca8181f03e7e$export$dffb4ed44e20ea9a), newWidth ?? width, isMinimised, toTop);
    }, [
        closeCurrentRightSidebar,
        isOtherPanelActive,
        openRightSidebar,
        width,
        isMinimised,
        toTop
    ]);
    const closeSidebar = (0, $euxye.useCallback)(()=>{
        closeRightSidebar((0, $2de0ca8181f03e7e$export$dffb4ed44e20ea9a));
    }, [
        closeRightSidebar
    ]);
    return (0, $euxye.useMemo)(()=>({
            isSidebarOpen: ()=>isActive,
            openSidebar: openSidebar,
            closeSidebar: closeSidebar
        }), [
        isActive,
        openSidebar,
        closeSidebar
    ]);
};

});


parcelRegister("4cgti", function(module, exports) {
$parcel$export(module.exports, "ProfileNew", () => $3eb432aae2e07cfa$export$f69e8c1d657487);

var $3ZvRo = parcelRequire("3ZvRo");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $hExZX = parcelRequire("hExZX");

var $fL9yy = parcelRequire("fL9yy");

var $cvA2R = parcelRequire("cvA2R");

var $ajncg = parcelRequire("ajncg");

var $dQnZC = parcelRequire("dQnZC");

var $k5P9q = parcelRequire("k5P9q");

var $82r89 = parcelRequire("82r89");

var $huIFY = parcelRequire("huIFY");

var $duVNo = parcelRequire("duVNo");

var $h1pEM = parcelRequire("h1pEM");


var $9mBes = parcelRequire("9mBes");
function $3eb432aae2e07cfa$export$f69e8c1d657487({ queryReference: queryReference }) {
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hExZX.NavigationAnalyticsContext), {
        data: (0, $82r89.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $huIFY.AccountMenuIntlProvider), null, isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3eb432aae2e07cfa$var$ProfileAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3eb432aae2e07cfa$var$ProfileLoggedIn, {
        queryReference: queryReference
    })));
}
$3eb432aae2e07cfa$export$f69e8c1d657487.displayName = "ProfileNew";
function $3eb432aae2e07cfa$var$ProfileLoggedIn({ queryReference: queryReference }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $3ZvRo.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9mBes.AccountMenu), {
        testId: (0, $ajncg.testIdGenerate)('secondary-actions', 'profile'),
        picture: data?.user?.picture,
        email: data?.user?.email ?? '',
        accountMenuTriggerQueryFragment: data
    });
}
$3eb432aae2e07cfa$var$ProfileLoggedIn.displayName = "ProfileLoggedIn";
function $3eb432aae2e07cfa$var$ProfileAnonymous() {
    const environment = (0, $k5P9q.useEnvironment)();
    const identityEnv = (0, $dQnZC.getIdentityEnv)(environment);
    const orgId = (0, $h1pEM.useOrgId)();
    const links = (0, $fL9yy.useAccountLinks)({
        email: '',
        identityEnvironment: identityEnv,
        // The following application is for Org controlled Social Login Customization
        // https://hello.atlassian.net/wiki/spaces/CloudSecurity/blog/2025/05/22/5335913476/Login+Customisations+is+Live#%3Aknowledge-base%3A--Using-Advanced-Cobranding-For-Frontend
        application: 'admin--jira-atlas-75650',
        continueUrl: (0, $dQnZC.getContinueUrl)({
            type: (0, $5f6e091542d432a9$export$eed606b4351295d7)
        }),
        isLoggedOut: true,
        logInLinkCustomParameters: {
            // orgId query param is required for Social Login Customization to work
            orgId: orgId || ''
        }
    });
    return links?.logInLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $duVNo.AccountMenuLoggedOutStateNav4), {
        testId: (0, $ajncg.testIdGenerate)('secondary-actions', 'profile'),
        logInLink: links.logInLink
    });
}
$3eb432aae2e07cfa$var$ProfileAnonymous.displayName = "ProfileAnonymous";

});
parcelRegister("3ZvRo", function(module, exports) {
$parcel$export(module.exports, "default", () => $07a0488ac7fb9241$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d3bba305f1f51d8c85c7226ceea197af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $07a0488ac7fb9241$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "atlassianAccountId"
        }
    ],
    "kind": "Fragment",
    "name": "ProfileNew",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "atlassianAccountId"
                }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "email"
                        }
                    ],
                    "type": "AtlassianAccountUser"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "AccountMenu_triggerQuery"
        }
    ],
    "type": "Query"
};
$07a0488ac7fb9241$var$node.hash = "c7d68b20b1812fe91c21fb91fd572c86";
var $07a0488ac7fb9241$export$2e2bcd8739ae039 = $07a0488ac7fb9241$var$node;

});

parcelRegister("dQnZC", function(module, exports) {
$parcel$export(module.exports, "getContinueUrl", () => $b1bb622095c51dc7$export$8c0854445d46e88e);
$parcel$export(module.exports, "getIdentityEnv", () => $b1bb622095c51dc7$export$b3f2b8c6cd294d68);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $1MzVa = parcelRequire("1MzVa");

var $giXDo = parcelRequire("giXDo");

const $b1bb622095c51dc7$export$38b2d434cce3ea22 = ()=>false ? null : window;
const $b1bb622095c51dc7$export$8c0854445d46e88e = ({ type: type })=>{
    const { href: href = '', protocol: protocol = '', host: host = '' } = (0, $giXDo.default)() ?? {};
    if (type === (0, $5f6e091542d432a9$export$eed606b4351295d7)) return href;
    if (type === (0, $5f6e091542d432a9$export$35e541d26a145a7c)) return protocol && host ? `${protocol}//${host}` : '';
    return '';
};
const $b1bb622095c51dc7$var$resolveIdentityEnv = (env)=>{
    switch(env){
        case 'local':
            return 'staging';
        case 'dev':
            return 'staging';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        default:
            return 'prod';
    }
};
const $b1bb622095c51dc7$export$b3f2b8c6cd294d68 = (env)=>{
    const resolvedEnvironment = $b1bb622095c51dc7$var$resolveIdentityEnv(env);
    const urlForDomain = (0, $1MzVa.getUrlForDomainInContext)('id', resolvedEnvironment);
    if (urlForDomain === undefined) return resolvedEnvironment;
    return {
        baseUrl: urlForDomain
    };
};

});
parcelRegister("giXDo", function(module, exports) {
$parcel$export(module.exports, "default", () => $27b02534bf966c4e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Wrap window.location so that it's testable.
 */ const $27b02534bf966c4e$var$getLocation = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};
var $27b02534bf966c4e$export$2e2bcd8739ae039 = $27b02534bf966c4e$var$getLocation;

});


parcelRegister("9mBes", function(module, exports) {
$parcel$export(module.exports, "AccountMenu", () => $49109a45cd0cf694$export$ff20d75d5eda4388);

var $7sXfy = parcelRequire("7sXfy");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $kGBiZ = parcelRequire("kGBiZ");

var $n67Vb = parcelRequire("n67Vb");

var $j3BMh = parcelRequire("j3BMh");

var $f99M0 = parcelRequire("f99M0");

var $gjGX4 = parcelRequire("gjGX4");

var $hRvCC = parcelRequire("hRvCC");

var $1CdDx = parcelRequire("1CdDx");

var $abhF2 = parcelRequire("abhF2");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $6ZLJT = parcelRequire("6ZLJT");

var $b9Jox = parcelRequire("b9Jox");

var $jyCdG = parcelRequire("jyCdG");

var $8odHE = parcelRequire("8odHE");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $6ouZy = parcelRequire("6ouZy");

var $1btt6 = parcelRequire("1btt6");

var $2700E = parcelRequire("2700E");

var $41FAq = parcelRequire("41FAq");

var $i860n = parcelRequire("i860n");

var $fsrz2 = parcelRequire("fsrz2");

var $3GN2r = parcelRequire("3GN2r");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
function $49109a45cd0cf694$var$menuReducer(state, action) {
    switch(action.type){
        case 'TOGGLE':
            if (state.isOpen) return {
                ...state,
                isOpen: false
            };
            return {
                isOpen: true,
                jsmStatusFetchKey: state.jsmStatusFetchKey + 1
            };
        case 'CLOSE':
            return {
                ...state,
                isOpen: false
            };
        default:
            return state;
    }
}
const $49109a45cd0cf694$var$useAccountMenuStateWithUseState = ()=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const handleTriggerClick = (0, $euxye.useCallback)(()=>{
        setIsOpen((currentIsOpen)=>!currentIsOpen);
    }, []);
    const handleClose = (0, $euxye.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return {
        isOpen: isOpen,
        jsmStatusFetchKey: 0,
        handleTriggerClick: handleTriggerClick,
        handleClose: handleClose
    };
};
const $49109a45cd0cf694$var$useAccountMenuStateWithReducer = ()=>{
    const [{ isOpen: isOpen, jsmStatusFetchKey: jsmStatusFetchKey }, dispatch] = (0, $euxye.useReducer)($49109a45cd0cf694$var$menuReducer, {
        isOpen: false,
        jsmStatusFetchKey: -1
    });
    const handleTriggerClick = (0, $euxye.useCallback)(()=>{
        dispatch({
            type: 'TOGGLE'
        });
    }, []);
    const handleClose = (0, $euxye.useCallback)(()=>{
        dispatch({
            type: 'CLOSE'
        });
    }, []);
    return {
        isOpen: isOpen,
        jsmStatusFetchKey: jsmStatusFetchKey,
        handleTriggerClick: handleTriggerClick,
        handleClose: handleClose
    };
};
const $49109a45cd0cf694$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $49109a45cd0cf694$var$useAccountMenuState = (0, $6ZLJT.functionWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control UI/API access when the parent feature is off.
    $49109a45cd0cf694$var$isWorkforceAemEnabled() && (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false), $49109a45cd0cf694$var$useAccountMenuStateWithReducer, $49109a45cd0cf694$var$useAccountMenuStateWithUseState);
const $49109a45cd0cf694$export$ff20d75d5eda4388 = /*#__PURE__*/ (0, $euxye.memo)(({ testId: testId, picture: picture, email: email, accountMenuTriggerQueryFragment: accountMenuTriggerQueryFragment })=>{
    const { isOpen: isOpen, jsmStatusFetchKey: jsmStatusFetchKey, handleTriggerClick: handleTriggerClick, handleClose: handleClose } = $49109a45cd0cf694$var$useAccountMenuState();
    const atlassianAccountId = (0, $3GN2r.useAccountId)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            atlassianAccountId: atlassianAccountId ?? '',
            jiraOnboardingHubGateEnabled: (0, $i860n.fg)('jira-onboarding-hub-gate') ?? false
        }), [
        atlassianAccountId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $1btt6.Nav4ProfileMenuEntryPoint), entryPointParams);
    const triggerRef = (0, $6ouZy.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $euxye.useMemo)(()=>({
            onClosePopup: handleClose,
            testId: testId,
            accountId: (0, $i860n.fg)('shared-user-preferences') ? atlassianAccountId : undefined,
            jsmStatusFetchKey: jsmStatusFetchKey
        }), [
        testId,
        atlassianAccountId,
        jsmStatusFetchKey,
        handleClose
    ]);
    const TriggerInternal = (0, $euxye.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($49109a45cd0cf694$var$Trigger, {
            triggerRef: triggerRef,
            onTriggerClick: handleTriggerClick,
            testId: testId,
            picture: picture,
            email: email,
            isOpen: isOpen,
            triggerProps: triggerProps,
            accountMenuTriggerQueryFragment: accountMenuTriggerQueryFragment
        });
    }, [
        triggerRef,
        handleTriggerClick,
        testId,
        picture,
        email,
        isOpen,
        accountMenuTriggerQueryFragment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1CdDx.default), {
        isOpen: isOpen,
        onClose: handleClose,
        testId: testId,
        placement: "bottom",
        trigger: TriggerInternal,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "atlassian-navigation-profile-menu",
                packageName: "atlassian-navigation-profile-menu",
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
                    xcss: $49109a45cd0cf694$var$Nav4AccountMenuContentSkeletonStyles,
                    padding: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), null)),
                runtimeProps: runtimeProps
            }),
        shouldRenderToParent: (0, $i860n.fg)('set-should-render-to-parent-to-true-theme-switcher')
    });
});
const $49109a45cd0cf694$var$AccountMenuTrigger = (0, $fsrz2.memoWithCondition)(()=>(0, $i860n.fg)('jfp-magma-stability-fixes-nav-misc'), (0, $8odHE.AccountMenuTriggerNav4));
function $49109a45cd0cf694$var$Trigger({ triggerRef: triggerRef, onTriggerClick: onTriggerClick, testId: testId, picture: picture, email: email, isOpen: isOpen, triggerProps: triggerProps, accountMenuTriggerQueryFragment: accountMenuTriggerQueryFragment }) {
    const ref = (0, $euxye.useCallback)((element)=>{
        triggerRef(element);
        // oxlint-disable-next-line typescript/consistent-type-assertions
        triggerProps.ref(element);
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        triggerRef,
        triggerProps.ref
    ]);
    const trigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($49109a45cd0cf694$var$AccountMenuTrigger, {
        ref: ref,
        onClick: onTriggerClick,
        testId: testId && `${testId}--trigger`,
        picture: picture,
        trustPicture: true,
        email: email,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        "aria-controls": testId && `${testId}--content`,
        "data-ds--level": triggerProps['data-ds--level']
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget') || // eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control UI/API access when the parent feature is off.
    $49109a45cd0cf694$var$isWorkforceAemEnabled() && (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($49109a45cd0cf694$var$TriggerContent, {
        trigger: trigger,
        accountMenuTriggerQueryFragment: accountMenuTriggerQueryFragment
    }) : trigger);
}
$49109a45cd0cf694$var$Trigger.displayName = "Trigger";
function $49109a45cd0cf694$var$TriggerContent({ trigger: trigger, accountMenuTriggerQueryFragment: accountMenuTriggerQueryFragment }) {
    const queryData = (0, $n67Vb.useFragment)((0, $7sXfy.default), accountMenuTriggerQueryFragment);
    const projectType = queryData.jira_projectByIdOrKey?.projectType;
    const showCsmTrigger = (0, $kGBiZ.useIsEligibleForLiveConversationsActivityStatusSsr)(projectType ? (0, $f99M0.convertToProjectType)(projectType) : undefined);
    if (showCsmTrigger) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jyCdG.default), {
        name: "account-menu-trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "TriggerWithLiveConversationsStatus",
        packageName: "atlassian-navigation-profile-menu",
        teamName: "boysenberry",
        fallback: ()=>trigger,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($49109a45cd0cf694$var$TriggerWithLiveConversationsStatus, {
        trigger: trigger,
        queryFragment: queryData.csmLiveChat
    })));
    if (// eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control UI/API access when the parent feature is off.
    $49109a45cd0cf694$var$isWorkforceAemEnabled() && (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($49109a45cd0cf694$var$JsmTriggerContent, {
        trigger: trigger
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, trigger);
}
$49109a45cd0cf694$var$TriggerContent.displayName = "TriggerContent";
function $49109a45cd0cf694$var$JsmTriggerContent({ trigger: trigger }) {
    const isClientReady = (0, $b9Jox.useIsClientReady)();
    const showJsmTrigger = (0, $hRvCC.useIsEligibleForWorkforceAvailabilityBadge)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handleMouseEnter = (0, $euxye.useCallback)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'jsmProfileMenuTrigger'
        }), 'profileMenu', {
            source: 'profileMenu'
        });
    }, [
        createAnalyticsEvent
    ]);
    if (!showJsmTrigger) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, trigger);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jyCdG.default), {
        name: "account-menu-trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $49109a45cd0cf694$var$statusIndicatorWrapperStyles,
        onMouseEnter: handleMouseEnter
    }, trigger, isClientReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gjGX4.AsyncWorkforceAvailabilityStatusIndicator), null)));
}
$49109a45cd0cf694$var$JsmTriggerContent.displayName = "JsmTriggerContent";
function $49109a45cd0cf694$var$TriggerWithLiveConversationsStatus({ trigger: trigger, queryFragment: queryFragment }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $49109a45cd0cf694$var$statusIndicatorWrapperStyles
    }, trigger, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j3BMh.LiveConversationsActivityStatusIndicator), {
        queryFragment: queryFragment
    }));
}
$49109a45cd0cf694$var$TriggerWithLiveConversationsStatus.displayName = "TriggerWithLiveConversationsStatus";
// These styles are defined to ensure that the initial popup for the AccountMenu content is the same width when
// displaying the skeleton loader as when displaying the actual content.
const $49109a45cd0cf694$var$Nav4AccountMenuContentSkeletonStyles = (0, $fbAgj.xcss)({
    width: '304px',
    height: '307px'
});
const $49109a45cd0cf694$var$statusIndicatorWrapperStyles = (0, $fbAgj.xcss)({
    position: 'relative',
    display: 'inline-block'
});

});
parcelRegister("7sXfy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1efde930c1dca267$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a23584e33d737e3b69a3a2eda5c127e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1efde930c1dca267$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "projectIdOrKey"
        },
        {
            "kind": "RootArgument",
            "name": "shouldFetchCSMLiveChatAgent"
        },
        {
            "kind": "RootArgument",
            "name": "shouldFetchProjectType"
        }
    ],
    "kind": "Fragment",
    "name": "AccountMenu_triggerQuery",
    "selections": [
        {
            "condition": "shouldFetchProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "idOrKey",
                            "variableName": "projectIdOrKey"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "projectType"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldFetchCSMLiveChatAgent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "LiveConversationsActivityStatusIndicator_query"
                            }
                        ],
                        "type": "Query"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "csmLiveChat"
                }
            ]
        }
    ],
    "type": "Query"
};
$1efde930c1dca267$var$node.hash = "6aca099e259b04156271c6c33466a5f6";
var $1efde930c1dca267$export$2e2bcd8739ae039 = $1efde930c1dca267$var$node;

});

parcelRegister("kGBiZ", function(module, exports) {
$parcel$export(module.exports, "useIsEligibleForLiveConversationsActivityStatusSsr", () => $9fb31df078d3aaa8$export$f6f72c4f1058bb2);
$parcel$export(module.exports, "useIsEligibleForLiveConversationsActivityStatus", () => $9fb31df078d3aaa8$export$5281e02906ecd77f);

var $e7boj = parcelRequire("e7boj");

var $f99M0 = parcelRequire("f99M0");

var $d8LhJ = parcelRequire("d8LhJ");

var $2b39L = parcelRequire("2b39L");

var $ccEzE = parcelRequire("ccEzE");

var $1KydW = parcelRequire("1KydW");

var $f2wVS = parcelRequire("f2wVS");

var $i860n = parcelRequire("i860n");
const $9fb31df078d3aaa8$var$useIsCSMRoute = (0, $f2wVS.createRouterSelector)((state)=>[
        '/jira/customer-service-management',
        '/jira/helpcenter',
        // note: remove when cleaning csm_appification_standalone_navigation
        '/jira/customer-service' // note: remove when cleaning csm_appification_standalone_navigation
    ].some((prefix)=>state.match.path.startsWith(prefix)));
const $9fb31df078d3aaa8$export$f6f72c4f1058bb2 = (projectType)=>{
    const $ = (0, $e7boj.c)(5);
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $1KydW.useApplicationPermissions)();
    const { customerService: customerServiceEdition } = (0, $ccEzE.useAppEditions)();
    const isCSMProjectRoute = projectType === (0, $f99M0.CUSTOMER_SERVICE_PROJECT);
    const isCSMRoute = $9fb31df078d3aaa8$var$useIsCSMRoute();
    let t0;
    if ($[0] !== customerServiceEdition || $[1] !== hasCustomerServiceAccess || $[2] !== isCSMProjectRoute || $[3] !== isCSMRoute) {
        t0 = hasCustomerServiceAccess && customerServiceEdition === (0, $d8LhJ.PREMIUM_EDITION) && (isCSMProjectRoute || isCSMRoute) && (0, $i860n.fg)("csm-omni-channel-live-chat-in-widget");
        $[0] = customerServiceEdition;
        $[1] = hasCustomerServiceAccess;
        $[2] = isCSMProjectRoute;
        $[3] = isCSMRoute;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
const $9fb31df078d3aaa8$export$5281e02906ecd77f = ()=>{
    const { data: projectContextData } = (0, $2b39L.useProjectContext)();
    return $9fb31df078d3aaa8$export$f6f72c4f1058bb2(projectContextData?.projectType);
};

});

parcelRegister("j3BMh", function(module, exports) {
$parcel$export(module.exports, "LiveConversationsActivityStatusIndicator", () => $ae61055993ef7cb7$export$a6dad4b01f7b4601);

var $e7boj = parcelRequire("e7boj");

var $1KazU = parcelRequire("1KazU");

var $3Rqj1 = parcelRequire("3Rqj1");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $i860n = parcelRequire("i860n");

var $h8QGu = parcelRequire("h8QGu");

var $gFeyR = parcelRequire("gFeyR");

var $ihEDU = parcelRequire("ihEDU");

var $fB86C = parcelRequire("fB86C");

var $dp0Rz = parcelRequire("dp0Rz");

var $a8EUd = parcelRequire("a8EUd");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $1ugVh = parcelRequire("1ugVh");

var $8C2sT = parcelRequire("8C2sT");
const $ae61055993ef7cb7$var$styles = {
    presenceWrapper: "_kqswstnw _4t3i1crf _1bsb1crf _94n5v77o _1xi2v77o"
};
const $ae61055993ef7cb7$var$Inner = (t0)=>{
    const $ = (0, $e7boj.c)(10);
    const { queryFragment: queryFragment } = t0;
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const queryData = (0, $n67Vb.useFragment)((0, $3Rqj1.default), queryFragment);
    const agentId = queryData?.csm_liveChatAgent?.__typename === "CustomerServiceLiveChatAgent" ? queryData.csm_liveChatAgent.id : null;
    let t1;
    let t2;
    if ($[0] !== agentId || $[1] !== environment) {
        t1 = ()=>{
            if (typeof globalThis.BroadcastChannel === "undefined" || !agentId) return;
            const channel = new BroadcastChannel("jira-csm-live-conversations");
            channel.onmessage = (event)=>{
                if (event.data === "TWILIO_CLIENT_INITIALIZED") {
                    channel.close();
                    (0, $n67Vb.commitLocalUpdate)(environment, (store)=>{
                        const storeKey = (0, $dp0Rz.default)({
                            id: agentId
                        }, "CustomerServiceLiveChatAgent");
                        const record = storeKey ? store.get(storeKey) : null;
                        if (record) record.setValue("available", "liveChatActivity");
                    });
                }
            };
            return ()=>{
                channel.close();
            };
        };
        t2 = [
            agentId,
            environment
        ];
        $[0] = agentId;
        $[1] = environment;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $euxye.useEffect)(t1, t2);
    if (queryData?.csm_liveChatAgent?.__typename === "QueryError" && (0, $i860n.fg)("berry-1567-status-indicator-query")) {
        let t3;
        if ($[4] !== queryData.csm_liveChatAgent) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gFeyR.ThrowOnQueryError), {
                operationName: "LiveConversationsActivityStatusIndicator",
                errorRef: queryData.csm_liveChatAgent
            });
            $[4] = queryData.csm_liveChatAgent;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    if (queryData?.csm_liveChatAgent?.__typename !== "CustomerServiceLiveChatAgent") {
        if ((0, $i860n.fg)("berry-1567-status-indicator-query")) return null;
        const t3 = queryData?.csm_liveChatAgent?.__typename === "QueryError" ? queryData?.csm_liveChatAgent : undefined;
        let t4;
        if ($[6] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gFeyR.ThrowOnQueryError), {
                operationName: "LiveConversationsActivityStatusIndicator",
                errorRef: t3
            });
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    if (!queryData.csm_liveChatAgent.liveChatActivitiesBySpace?.edges?.length) return null;
    let t3;
    if ($[8] !== queryData.csm_liveChatAgent) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
            xcss: $ae61055993ef7cb7$var$styles.presenceWrapper
        }, queryData.csm_liveChatAgent.liveChatActivity === "available" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "twilio-activity-status-inner",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8C2sT.ActivityStatusIndicatorPresence), {
                agentFragment: queryData.csm_liveChatAgent,
                workerActivity: queryData.csm_liveChatAgent.liveChatActivity
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1ugVh.AsyncTwilioActivityStatusIndicator), {
            agentFragment: queryData.csm_liveChatAgent
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fB86C.default), {
            presence: "offline"
        }));
        $[8] = queryData.csm_liveChatAgent;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};
$ae61055993ef7cb7$var$Inner.displayName = "Inner";
const $ae61055993ef7cb7$var$InnerWithLoader = ()=>{
    const $ = (0, $e7boj.c)(5);
    const accountId = (0, $3GN2r.useAccountId)();
    const cloudId = (0, $kt86l.useCloudId)();
    const t0 = accountId ?? "";
    let t1;
    if ($[0] !== cloudId || $[1] !== t0) {
        t1 = {
            atlassianAccountId: t0,
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const data = (0, $n67Vb.useLazyLoadQuery)((0, $1KazU.default), t1);
    let t2;
    if ($[3] !== data) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae61055993ef7cb7$var$Inner, {
            queryFragment: data
        });
        $[3] = data;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
$ae61055993ef7cb7$var$InnerWithLoader.displayName = "InnerWithLoader";
const $ae61055993ef7cb7$export$a6dad4b01f7b4601 = (t0)=>{
    const $ = (0, $e7boj.c)(3);
    const { queryFragment: queryFragment } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
            xcss: $ae61055993ef7cb7$var$styles.presenceWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fB86C.default), {
            presence: "offline"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== queryFragment) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "LiveConversationsActivityStatusIndicator",
            packageName: "jiraCustomerServiceLiveConversationsActivityStatus",
            teamName: "boysenberry",
            fallback: "unmount",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "twilio-activity-status",
            fallback: t1
        }, queryFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae61055993ef7cb7$var$Inner, {
            queryFragment: queryFragment
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ae61055993ef7cb7$var$InnerWithLoader, null)));
        $[1] = queryFragment;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
$ae61055993ef7cb7$export$a6dad4b01f7b4601.displayName = "LiveConversationsActivityStatusIndicator";

});
parcelRegister("1KazU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1399ca6a6e4ac86c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3cf365a19705454c2b854155e4f95305>>
 * @relayHash ecdd2aeaf20c000ab01207e92301330e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32e7a430ac1c69a0aa9f347c6d41dc06565faf5b1a45e45620100feb28b548d7
const $1399ca6a6e4ac86c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LiveConversationsActivityStatusIndicatorQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "LiveConversationsActivityStatusIndicator_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LiveConversationsActivityStatusIndicatorQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "atlassianAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "csm_liveChatAgent",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "liveChatActivity"
                                },
                                {
                                    "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                                    "kind": "LinkedField",
                                    "name": "liveChatActivitiesBySpace",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceSpaceLiveChatActivity",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "activityStatus"
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "CustomerServiceLiveChatAgent"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "identifier"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "32e7a430ac1c69a0aa9f347c6d41dc06565faf5b1a45e45620100feb28b548d7",
            "metadata": {},
            "name": "LiveConversationsActivityStatusIndicatorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1399ca6a6e4ac86c$var$node.hash = "efe950b928b22c116a6e322a0c828642";
var $1399ca6a6e4ac86c$export$2e2bcd8739ae039 = $1399ca6a6e4ac86c$var$node;

});

parcelRegister("3Rqj1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d4d187267b53126$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<758380b694f86cd537d65b1e31a0a30c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9d4d187267b53126$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "atlassianAccountId"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "LiveConversationsActivityStatusIndicator_query",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "atlassianAccountId"
                    },
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "LinkedField",
                "name": "csm_liveChatAgent",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "liveChatActivity"
                            },
                            {
                                "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                                "kind": "LinkedField",
                                "name": "liveChatActivitiesBySpace",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "CustomerServiceLiveChatAgent"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ThrowOnQueryError"
                            }
                        ],
                        "type": "QueryError"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "ActivityStatusIndicatorPresence_agent"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$9d4d187267b53126$var$node.hash = "6014f2b52557cb485c0e67a61e16f9cf";
var $9d4d187267b53126$export$2e2bcd8739ae039 = $9d4d187267b53126$var$node;

});

parcelRegister("gFeyR", function(module, exports) {
$parcel$export(module.exports, "ThrowOnQueryError", () => $3f0ea60d579fc581$export$492fe7d3c1990b95);

var $4zfIi = parcelRequire("4zfIi");

var $n67Vb = parcelRequire("n67Vb");
const $3f0ea60d579fc581$export$492fe7d3c1990b95 = ({ operationName: operationName, errorRef: errorRef })=>{
    if (!errorRef) throw new Error(`${operationName}: unexpected typename returned`);
    const { identifier: identifier, message: message, extensions: extensions } = (0, $n67Vb.useFragment)((0, $4zfIi.default), errorRef);
    throw new Error(`${operationName}: QueryError; ${JSON.stringify({
        identifier: identifier,
        message: message,
        extensions: extensions
    })}`);
};
$3f0ea60d579fc581$export$492fe7d3c1990b95.displayName = "ThrowOnQueryError";

});
parcelRegister("4zfIi", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c242b56de845517$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<397cae42da5db66a8907b0661882230e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9c242b56de845517$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThrowOnQueryError",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "identifier"
        },
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ]
        }
    ],
    "type": "QueryError"
};
$9c242b56de845517$var$node.hash = "4b77c5110c5924963681d8cf535568f2";
var $9c242b56de845517$export$2e2bcd8739ae039 = $9c242b56de845517$var$node;

});


parcelRegister("1ugVh", function(module, exports) {
$parcel$export(module.exports, "AsyncTwilioActivityStatusIndicator", () => $212c6c8e3031847c$export$fca1af51f7d10652);

var $l8G1z = parcelRequire("l8G1z");

const $212c6c8e3031847c$export$fca1af51f7d10652 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazy)(()=>(parcelRequire("o48de")).then(({ TwilioActivityStatusIndicator: TwilioActivityStatusIndicator })=>TwilioActivityStatusIndicator), {
    ssr: false,
    moduleId: "./src/packages/customer-service/live-conversations-activity-status/src/TwilioActivityStatusIndicator.tsx"
});

});
parcelRegister("o48de", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("5qC72"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("fvJRP")
]).then(()=>parcelRequire('eATcB'));

});


parcelRegister("8C2sT", function(module, exports) {
$parcel$export(module.exports, "ActivityStatusIndicatorPresence", () => $a47651d338c262e4$export$1f56ae99ae4b4483);

var $e7boj = parcelRequire("e7boj");

var $e5xny = parcelRequire("e5xny");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $fB86C = parcelRequire("fB86C");

var $a70Av = parcelRequire("a70Av");

var $6ELpl = parcelRequire("6ELpl");
const $a47651d338c262e4$export$1f56ae99ae4b4483 = (t0)=>{
    const $ = (0, $e7boj.c)(4);
    const { availableSpacesCount: availableSpacesCount, agentFragment: agentFragment, workerActivity: workerActivity } = t0;
    const agentData = (0, $n67Vb.useFragment)((0, $e5xny.default), agentFragment);
    if (workerActivity?.toLowerCase() === "offline") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fB86C.default), {
                presence: "offline"
            });
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    const edges = agentData.liveChatActivitiesBySpace?.edges ?? [];
    const graphqlAvailableCount = edges.filter($a47651d338c262e4$var$_temp).length;
    const status = (0, $a70Av.getGlobalPresenceStatus)(availableSpacesCount ?? graphqlAvailableCount, edges.length);
    if (status === "offline") {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fB86C.default), {
                presence: "offline"
            });
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (status === "mixed") {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fB86C.default), null, (0, $6ELpl.MixedStatusIcon));
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fB86C.default), {
            presence: "online"
        });
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
$a47651d338c262e4$export$1f56ae99ae4b4483.displayName = "ActivityStatusIndicatorPresence";
function $a47651d338c262e4$var$_temp(edge) {
    return edge?.node?.activityStatus === "available";
}

});
parcelRegister("e5xny", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c93e33ccdd6e293$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<141a18e18519e803bef83ce2b35d5efd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c93e33ccdd6e293$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ActivityStatusIndicatorPresence_agent",
    "selections": [
        {
            "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
            "kind": "LinkedField",
            "name": "liveChatActivitiesBySpace",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "CustomerServiceSpaceLiveChatActivity",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "activityStatus"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "CustomerServiceLiveChatAgent"
};
$5c93e33ccdd6e293$var$node.hash = "4bd38e5c35b0d146a1cf602bd64dc716";
var $5c93e33ccdd6e293$export$2e2bcd8739ae039 = $5c93e33ccdd6e293$var$node;

});

parcelRegister("a70Av", function(module, exports) {
$parcel$export(module.exports, "getGlobalPresenceStatus", () => $1440794c6ff23c2c$export$30490e6b558867cf);
const $1440794c6ff23c2c$export$30490e6b558867cf = (availableSpacesCount, totalSpaces)=>{
    if (availableSpacesCount === 0) return 'offline';
    if (availableSpacesCount < totalSpaces) return 'mixed';
    return 'online';
};

});

parcelRegister("6ELpl", function(module, exports) {
$parcel$export(module.exports, "MixedStatusIcon", () => $ede1f81a6137ea53$export$86eaa63d549d124b);

var $euxye = parcelRequire("euxye");
const $ede1f81a6137ea53$export$86eaa63d549d124b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
    height: "100%",
    version: "1.1",
    viewBox: "0 0 8 8",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("circle", {
    fill: "var(--ds-background-neutral-bold, #292A2E)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,2 A2,2 0 0,0 4,6 Z"
}));

});



parcelRegister("gjGX4", function(module, exports) {
$parcel$export(module.exports, "AsyncWorkforceAvailabilityStatusIndicator", () => $26c77312bc125ff5$export$a37a08e50369a820);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $l8G1z = parcelRequire("l8G1z");

var $a8EUd = parcelRequire("a8EUd");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $26c77312bc125ff5$var$LazyWorkforceAvailabilityStatusIndicatorWithQuery = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("bA7hm")).then((m)=>m.WorkforceAvailabilityStatusIndicatorWithQuery), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/workforce-availability-global-menu/src/WorkforceAvailabilityStatusIndicatorWithQuery.tsx"
});
const $26c77312bc125ff5$export$a37a08e50369a820 = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            id: "async.workforce-availability-indicator",
            packageName: "jiraServicedeskWorkforceAvailabilityGlobalMenu",
            teamName: "JSD SHIELD",
            fallback: $26c77312bc125ff5$var$_temp,
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: "jsm-workforce-availability-indicator",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($26c77312bc125ff5$var$LazyWorkforceAvailabilityStatusIndicatorWithQuery, null)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$26c77312bc125ff5$export$a37a08e50369a820.displayName = "AsyncWorkforceAvailabilityStatusIndicator";
function $26c77312bc125ff5$var$_temp() {
    return null;
}

});
parcelRegister("bA7hm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("itYlZ").then(()=>parcelRequire('gGXX4'));

});


parcelRegister("hRvCC", function(module, exports) {
$parcel$export(module.exports, "useIsEligibleForWorkforceAvailabilityBadge", () => $453a4e75b2078bad$export$9b0002b0beb8926e);

var $e7boj = parcelRequire("e7boj");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $41FAq = parcelRequire("41FAq");

var $6ZLJT = parcelRequire("6ZLJT");

var $1KydW = parcelRequire("1KydW");

var $3Scai = parcelRequire("3Scai");

var $8fJum = parcelRequire("8fJum");

var $66z9k = parcelRequire("66z9k");
const $453a4e75b2078bad$var$isWorkforceAemEnabled = ()=>(0, $i860n.fg)('jsm_workforce_use_aem') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-workforce') : true;
const $453a4e75b2078bad$var$useIsEligibleForWorkforceAvailabilityBadgeEnabled = ()=>{
    const $ = (0, $e7boj.c)(5);
    const isJsmOnly = (0, $3Scai.useIsJsmOnly)();
    const isJsmRoute = (0, $8fJum.useIsJsmRoute)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $1KydW.useApplicationPermissions)();
    const isWorkforceOrLiveChatEnabled = (0, $66z9k.useIsWorkforceOrLiveChatEnabled)();
    let t0;
    if ($[0] !== hasServiceDeskAccess || $[1] !== isJsmOnly || $[2] !== isJsmRoute || $[3] !== isWorkforceOrLiveChatEnabled) {
        t0 = isJsmOnly && isJsmRoute && hasServiceDeskAccess && isWorkforceOrLiveChatEnabled && (0, $2700E.expVal)("jsm_workforce_optimization_status_control", "isEnabled", false);
        $[0] = hasServiceDeskAccess;
        $[1] = isJsmOnly;
        $[2] = isJsmRoute;
        $[3] = isWorkforceOrLiveChatEnabled;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
const $453a4e75b2078bad$export$9b0002b0beb8926e = (0, $6ZLJT.functionWithCondition)(()=>$453a4e75b2078bad$var$isWorkforceAemEnabled() && (0, $i860n.fg)('jsm_workforce_optimization_main'), $453a4e75b2078bad$var$useIsEligibleForWorkforceAvailabilityBadgeEnabled, ()=>false);

});
parcelRegister("3Scai", function(module, exports) {
$parcel$export(module.exports, "useIsJsmOnly", () => $cf0ca48da423897e$export$8f4b678dd4e42cdd);

var $1KydW = parcelRequire("1KydW");
const $cf0ca48da423897e$export$8f4b678dd4e42cdd = ()=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $1KydW.useApplicationPermissions)();
    return hasServiceDeskAccess && !hasCustomerServiceAccess;
};

});

parcelRegister("8fJum", function(module, exports) {
$parcel$export(module.exports, "useIsJsmRoute", () => $bb0b3ee0c6fb73e7$export$7903c56cc0ae7337);

var $f2wVS = parcelRequire("f2wVS");
const $bb0b3ee0c6fb73e7$var$useRouteGroup = (0, $f2wVS.createRouterSelector)((state)=>state.route?.group ?? '');
const $bb0b3ee0c6fb73e7$export$7903c56cc0ae7337 = ()=>{
    return $bb0b3ee0c6fb73e7$var$useRouteGroup() === "servicedesk";
};

});

parcelRegister("66z9k", function(module, exports) {
$parcel$export(module.exports, "useIsWorkforceOrLiveChatEnabled", () => $9399608ff5c093a7$export$d2cfef772c840acf);

var $dk0Ly = parcelRequire("dk0Ly");

var $k6ufm = parcelRequire("k6ufm");
const $9399608ff5c093a7$export$d2cfef772c840acf = ()=>{
    const { data: data } = (0, $k6ufm.useResource)((0, $dk0Ly.jsmFeaturesEnabledResource));
    return !!data?.isLiveChatEnabled || !!data?.isWorkforceOptimizationEnabled && !!data?.isWorkforceOptimizationOnboardingFinished;
};

});


parcelRegister("jyCdG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb5006c4358fb868$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $4FR7Y = parcelRequire("4FR7Y");

var $jnOWT = parcelRequire("jnOWT");

var $gQRLr = parcelRequire("gQRLr");
const $fb5006c4358fb868$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $fb5006c4358fb868$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $fb5006c4358fb868$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $fb5006c4358fb868$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $4FR7Y.useInteractionContext)();
    const rllProfilerContext = (0, $euxye.useContext)((0, $gQRLr.ProfilerContext));
    const relayProfilerContext = (0, $euxye.useContext)((0, $n67Vb.ProfilerContext));
    const newRllProfilerContext = (0, $euxye.useMemo)(()=>({
            current: $fb5006c4358fb868$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $euxye.useMemo)(()=>$fb5006c4358fb868$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $fb5006c4358fb868$var$flowRight([
        $fb5006c4358fb868$var$renderContextProviderIfNonNull((0, $n67Vb.ProfilerContext), newRelayProfilerContext),
        $fb5006c4358fb868$var$renderContextProviderIfNonNull((0, $gQRLr.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children));
}
$fb5006c4358fb868$var$JiraUFOLabelWrapper.displayName = "JiraUFOLabelWrapper";
function $fb5006c4358fb868$export$2e2bcd8739ae039({ name: name, children: children }) {
    const nameWithUnderscores = name.replaceAll('/', '_');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jnOWT.default), {
        name: nameWithUnderscores
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fb5006c4358fb868$var$JiraUFOLabelWrapper, null, children));
}
$fb5006c4358fb868$export$2e2bcd8739ae039.displayName = "UFOLabel";

});

parcelRegister("1btt6", function(module, exports) {
$parcel$export(module.exports, "Nav4ProfileMenuEntryPoint", () => $ab05f853c6825384$export$e30a856958207b6);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $xFkIE = parcelRequire("xFkIE");

const $ab05f853c6825384$export$e30a856958207b6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dkE3z")), {
        moduleId: "d110fb34",
        moduleName: "AccountMenuContentContainer",
        priority: "interaction"
    }),
    getPreloadProps: ({ atlassianAccountId: atlassianAccountId, jiraOnboardingHubGateEnabled: jiraOnboardingHubGateEnabled })=>({
            queries: {
                AccountMenuContentContainerQuery: {
                    parameters: $xFkIE.default,
                    variables: {
                        atlassianAccountId: atlassianAccountId ?? '',
                        jiraOnboardingHubGateEnabled: jiraOnboardingHubGateEnabled ?? false
                    }
                }
            }
        })
});

});
parcelRegister("xFkIE", function(module, exports) {
$parcel$export(module.exports, "default", () => $de3c5f2f89fe0cff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b9d71e7f3be3e3256c97597d3727795>>
 * @relayHash 5298e24274edcdd24f1530eced4576dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 863414cde0dcb622159a058828c6866ddc05b90a43abef3314df98010134368a
const $de3c5f2f89fe0cff$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "863414cde0dcb622159a058828c6866ddc05b90a43abef3314df98010134368a",
        "metadata": {},
        "name": "AccountMenuContentContainerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $de3c5f2f89fe0cff$export$2e2bcd8739ae039 = $de3c5f2f89fe0cff$var$node;

});

parcelRegister("dkE3z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("5qC72"),
    $4cvLQ("2szmp")
]).then(()=>parcelRequire('1fwYt'));

});


parcelRegister("fsrz2", function(module, exports) {
$parcel$export(module.exports, "memoWithCondition", () => $c5a28b9ac8fc7b27$export$26f85cb52df6fa94);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $aWliK = parcelRequire("aWliK");
const $c5a28b9ac8fc7b27$export$26f85cb52df6fa94 = (condition, Component, propsAreEqual)=>{
    return (0, $aWliK.componentWithCondition)(condition, /*#__PURE__*/ (0, $euxye.memo)(Component, propsAreEqual), Component);
};

});



parcelRegister("jrLL2", function(module, exports) {
$parcel$export(module.exports, "ProductHomeWithQuery", () => $051b664a0325a98c$export$9709ea4eeb3079fc);

var $7yRs1 = parcelRequire("7yRs1");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $3NRLa = parcelRequire("3NRLa");


var $a8EUd = parcelRequire("a8EUd");

var $xHUqL = parcelRequire("xHUqL");
const $051b664a0325a98c$export$9709ea4eeb3079fc = ({ queryReference: queryReference })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "Nav4TopNavProductHomeRelay",
        packageName: (0, $5f6e091542d432a9$export$b8b9d90f9e5bd72b),
        teamName: (0, $5f6e091542d432a9$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "nav4-top-nav-product-home-relay",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3NRLa.default), {
            isShimmering: true,
            width: "100px",
            height: "20px"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($051b664a0325a98c$var$Content, {
        queryReference: queryReference
    })));
$051b664a0325a98c$export$9709ea4eeb3079fc.displayName = "ProductHomeWithQuery";
function $051b664a0325a98c$var$Content({ queryReference: queryReference }) {
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $7yRs1.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    queryReference);
    const issueProjectType = data?.jira?.jiraProjectByKey?.projectType ?? data?.jira?.issueByKey?.projectField?.project?.projectType;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $xHUqL.ProductHome), {
        projectType: issueProjectType
    });
}
$051b664a0325a98c$var$Content.displayName = "Content";

});
parcelRegister("7yRs1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ccbf7e1b9ffecf2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09568aff1222bd48dd87dd37261b4203>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ccbf7e1b9ffecf2$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "issueKey"
            },
            {
                "kind": "RootArgument",
                "name": "projectKey"
            },
            {
                "kind": "RootArgument",
                "name": "shouldCheckProjectType"
            },
            {
                "kind": "RootArgument",
                "name": "shouldCheckProjectTypeForIssue"
            }
        ],
        "kind": "Fragment",
        "name": "ProductHomeWithQuery",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "shouldCheckProjectTypeForIssue",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "key",
                                        "variableName": "issueKey"
                                    }
                                ],
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectField",
                                        "kind": "LinkedField",
                                        "name": "projectField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": v1 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "shouldCheckProjectType",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "key",
                                        "variableName": "projectKey"
                                    }
                                ],
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": v1 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$5ccbf7e1b9ffecf2$var$node.hash = "e010d0e7151a1ababcc9337fa39a44da";
var $5ccbf7e1b9ffecf2$export$2e2bcd8739ae039 = $5ccbf7e1b9ffecf2$var$node;

});

parcelRegister("xHUqL", function(module, exports) {
$parcel$export(module.exports, "ProductHome", () => $bb130aec305627b5$export$32d61f70e04b6020);
/* main.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4Kt0R = parcelRequire("4Kt0R");

var $eslhe = parcelRequire("eslhe");

var $ihEDU = parcelRequire("ihEDU");

var $3QxIB = parcelRequire("3QxIB");
var $jTfIv = parcelRequire("jTfIv");

var $av7P9 = parcelRequire("av7P9");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $ajncg = parcelRequire("ajncg");

var $gWmMH = parcelRequire("gWmMH");

var $55BnK = parcelRequire("55BnK");

var $1KydW = parcelRequire("1KydW");

var $kmiSB = parcelRequire("kmiSB");

var $kv9wl = parcelRequire("kv9wl");

var $7UpgX = parcelRequire("7UpgX");

var $5v5hQ = parcelRequire("5v5hQ");

var $hmJOD = parcelRequire("hmJOD");
const $bb130aec305627b5$var$customLogoAltText = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Jira homepage",
    id: "atlassian-navigation.product-home.custom-logo-alt-text"
});
const $bb130aec305627b5$var$customIconAltText = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Custom Jira icon",
    id: "atlassian-navigation.product-home.custom-icon-alt-text"
});
const $bb130aec305627b5$var$HOME_URL = '/jira';
const $bb130aec305627b5$var$CreateCustomLogoComponent = (props)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bb130aec305627b5$var$CustomImgNav4, props);
$bb130aec305627b5$var$CreateCustomLogoComponent.displayName = "CreateCustomLogoComponent";
const $bb130aec305627b5$export$32d61f70e04b6020 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eslhe.TopLevelErrorBoundary), {
        id: (0, $4Kt0R.NAVIGATION_ITEM_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bb130aec305627b5$var$ProductHomeContent, props));
$bb130aec305627b5$export$32d61f70e04b6020.displayName = "ProductHome";
const $bb130aec305627b5$var$styles = {
    logoContainer: "_1e0c1bgi"
};
function $bb130aec305627b5$var$ProductHomeContent({ projectType: projectType }) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const testIdPrefix = (0, $ajncg.testIdGenerate)('product-home-');
    const logoUrl = (0, $kv9wl.useCustomLogo)();
    const iconUrl = (0, $kv9wl.useCustomIcon)();
    const productName = (0, $gWmMH.useProductName)();
    const triggerAnalytics = (0, $7UpgX.useNavigationItemAnalytics)({
        navigationItemId: (0, $4Kt0R.NAVIGATION_ITEM_ID).LOGO
    }); // See: https://hello.jira.atlassian.cloud/browse/NAVX-1993
    const setCustomThemeData = (0, $kmiSB.useSetCustomThemeData)();
    (0, $euxye.useEffect)(()=>{
        setCustomThemeData({
            hasCustomLogo: !!logoUrl
        });
    }, [
        logoUrl,
        setCustomThemeData
    ]);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const navigateToHome = (0, $euxye.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push($bb130aec305627b5$var$HOME_URL);
    }, [
        triggerAnalytics,
        push
    ]);
    const { icon: ProductIcon, name: logoName } = (0, $euxye.useMemo)(()=>(0, $hmJOD.getProductIcon)(productName, testIdPrefix), [
        productName,
        testIdPrefix
    ]);
    const Logo = (0, $euxye.useMemo)(()=>$bb130aec305627b5$var$CreateCustomLogoComponent({
            alt: formatMessage($bb130aec305627b5$var$customLogoAltText),
            src: logoUrl || '',
            testId: `${testIdPrefix}-logo`
        }), [
        logoUrl,
        formatMessage,
        testIdPrefix
    ]);
    const Icon = (0, $euxye.useMemo)(()=>logoUrl && iconUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bb130aec305627b5$var$CustomImgNav4, {
                alt: formatMessage($bb130aec305627b5$var$customIconAltText),
                src: iconUrl,
                testId: `${testIdPrefix}-icon`
            }) : ProductIcon, [
        logoUrl,
        iconUrl,
        ProductIcon,
        testIdPrefix,
        formatMessage
    ]);
    const label = (0, $hmJOD.getLogoLabel)(formatMessage, productName);
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $1KydW.useApplicationPermissions)(); // check if the user has access to JSM and CSM only
    const isJSMAndCSMOnlyAccessible = hasServiceDeskAccess && hasCustomerServiceAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess;
    if (!logoUrl && isJSMAndCSMOnlyAccessible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        testId: `${testIdPrefix}-container`,
        xcss: isFhsEnabled && $bb130aec305627b5$var$styles.logoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5v5hQ.JSMAndCSMLogo), {
        navigateToHome: navigateToHome,
        testIdPrefix: testIdPrefix,
        homeURL: $bb130aec305627b5$var$HOME_URL,
        projectType: projectType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        testId: `${testIdPrefix}-container`,
        xcss: isFhsEnabled && $bb130aec305627b5$var$styles.logoContainer
    }, !logoUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3QxIB.AppLogo), {
        name: logoName,
        label: label,
        icon: Icon,
        href: $bb130aec305627b5$var$HOME_URL,
        onClick: navigateToHome
    }) : // Render custom logo component if logoUrl is present (even if the icon is not custom)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jTfIv.CustomLogo), {
        label: label,
        icon: Icon,
        logo: Logo,
        href: $bb130aec305627b5$var$HOME_URL,
        onClick: navigateToHome
    }));
}
$bb130aec305627b5$var$ProductHomeContent.displayName = "ProductHomeContent";
function $bb130aec305627b5$var$CustomImgNav4({ alt: alt, src: src, testId: testId }) {
    // See: https://hello.jira.atlassian.cloud/browse/NAVX-1993
    const setCustomThemeData = (0, $kmiSB.useSetCustomThemeData)();
    const handleLoad = (0, $euxye.useCallback)((e)=>{
        // Image loaded
        setCustomThemeData({
            customLogoSize: {
                width: e.currentTarget.naturalWidth,
                height: e.currentTarget.naturalHeight
            }
        });
    }, [
        setCustomThemeData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("img", {
        src: src,
        alt: alt,
        "data-testid": testId,
        onLoad: handleLoad
    });
}
$bb130aec305627b5$var$CustomImgNav4.displayName = "CustomImgNav4";

});
parcelRegister("kv9wl", function(module, exports) {
$parcel$export(module.exports, "useCustomLogo", () => $40dc940f812d728d$export$9891fb86d6b41647);
$parcel$export(module.exports, "useCustomIcon", () => $40dc940f812d728d$export$9e69c21df0138642);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6bEm8 = parcelRequire("6bEm8");
const $40dc940f812d728d$export$9891fb86d6b41647 = ()=>(0, $euxye.useMemo)(()=>(0, $6bEm8.default)('ajs-lf-top-adg3-logourl'), []);
const $40dc940f812d728d$export$9e69c21df0138642 = ()=>(0, $euxye.useMemo)(()=>(0, $6bEm8.default)('ajs-fspage-favicon'), []);

});

parcelRegister("5v5hQ", function(module, exports) {
$parcel$export(module.exports, "JSMAndCSMLogo", () => $8556f2f5c9d836f8$export$273e17850dfc6e0c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3QxIB = parcelRequire("3QxIB");

var $f2wVS = parcelRequire("f2wVS");

var $1YIbA = parcelRequire("1YIbA");

var $2ONXd = parcelRequire("2ONXd");

var $3F5Fd = parcelRequire("3F5Fd");

var $hmJOD = parcelRequire("hmJOD");
const $8556f2f5c9d836f8$export$89f90ea8776fdb88 = (0, $f2wVS.createRouterSelector)((state)=>state.route.group);
function $8556f2f5c9d836f8$export$273e17850dfc6e0c({ navigateToHome: navigateToHome, testIdPrefix: testIdPrefix, homeURL: homeURL, projectType: projectType }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const routeGroup = $8556f2f5c9d836f8$export$89f90ea8776fdb88();
    const { label: label, icon: icon, name: name } = (0, $euxye.useMemo)(()=>{
        const selectedProductName = projectType ? $8556f2f5c9d836f8$var$getProductNameByProjectType(projectType) : $8556f2f5c9d836f8$var$getProductNameByRouteGroup(routeGroup);
        return {
            label: (0, $hmJOD.getLogoLabel)(formatMessage, selectedProductName),
            ...(0, $hmJOD.getProductIcon)(selectedProductName, testIdPrefix)
        };
    }, [
        formatMessage,
        projectType,
        routeGroup,
        testIdPrefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3QxIB.AppLogo), {
        label: label,
        icon: icon,
        name: name,
        href: homeURL,
        onClick: navigateToHome
    });
}
$8556f2f5c9d836f8$export$273e17850dfc6e0c.displayName = "JSMAndCSMLogo";
const $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP = {
    CUSTOMER_SERVICE: 'customer-service',
    SERVICE_DESK: 'serviceDesk',
    DEFAULT: 'jira'
};
function $8556f2f5c9d836f8$var$getProductNameByProjectType(projectType) {
    switch(projectType){
        case 'CUSTOMER_SERVICE':
            return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.CUSTOMER_SERVICE;
        case 'SERVICE_DESK':
            return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.SERVICE_DESK;
        default:
            return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.DEFAULT;
    }
}
function $8556f2f5c9d836f8$var$getProductNameByRouteGroup(routeGroup) {
    switch(routeGroup){
        case 'directories':
            {
                // There are two routes that can be used to navigate to the projects directory:
                // 1. projectsDirectoryRoute
                //    This is the route users land on when they directly navigate to the projects directory
                //    e.g. /jira/projects?page=1&sortKey=name&sortOrder=ASC&types=customer_service
                //    Note the query param is named "types" for the project types
                // 2. projectsDirectoryLegacyPathRedirectRoute
                //    This route is from the app switcher that uses a legacy path with a redirect
                //    e.g. /secure/BrowseProjects.jspa?selectedProjectType=customer_service
                //    Note the query param is named "selectedProjectType" for the project types
                // We need to check both routes and query params to determine the product name.
                const routerState = (0, $f2wVS.getRouterState)();
                if (routerState.route.name === (0, $2ONXd.projectsDirectoryRoute).name || routerState.route.name === (0, $3F5Fd.projectsDirectoryLegacyPathRedirectRoute).name) {
                    const projectTypes = routerState.query?.types || routerState.query?.selectedProjectType;
                    const typesArray = projectTypes?.split(',')?.filter(Boolean) ?? [];
                    if (typesArray.includes('customer_service')) return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.CUSTOMER_SERVICE;
                    if (typesArray.includes('service_desk')) return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.SERVICE_DESK;
                }
                return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.DEFAULT;
            }
        case 'customer-service':
            return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.CUSTOMER_SERVICE;
        case 'servicedesk':
            return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.SERVICE_DESK;
        default:
            return $8556f2f5c9d836f8$var$PRODUCT_NAME_MAP.DEFAULT;
    }
}

});
parcelRegister("hmJOD", function(module, exports) {
$parcel$export(module.exports, "getProductIcon", () => $b999daca087b8fc3$export$22a9451e3bf2233f);
$parcel$export(module.exports, "getLogoLabel", () => $b999daca087b8fc3$export$20e08d839e9f9688);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $7eNDO = parcelRequire("7eNDO");
const $b999daca087b8fc3$var$jiraLogoLabel = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Go to your Jira homepage",
    id: "atlassian-navigation.product-home.jira-logo-label"
});
const $b999daca087b8fc3$var$jsmLogoLabel = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Go to your Jira Service Management homepage",
    id: "atlassian-navigation.product-home.jsm-logo-label"
});
const $b999daca087b8fc3$var$jpdLogoLabel = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Go to your Jira Product Discovery homepage",
    id: "atlassian-navigation.product-home.jpd-logo-label"
});
const $b999daca087b8fc3$var$csmLogoLabel = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Go to your Customer Service Management homepage",
    id: "atlassian-navigation.product-home.csm-logo-label"
});
const $b999daca087b8fc3$export$6d49a893c897b0cc = {
    jira: {
        icon: (0, $eprc4.JiraIcon),
        name: 'Jira'
    },
    serviceDesk: {
        icon: (0, $eprc4.JiraServiceManagementIcon),
        name: 'Jira Service Management'
    },
    'product-discovery': {
        icon: (0, $eprc4.JiraProductDiscoveryIcon),
        name: 'Jira Product Discovery'
    },
    'customer-service': {
        icon: (0, $eprc4.CustomerServiceManagementIcon),
        name: 'Customer Service Management'
    }
};
function $b999daca087b8fc3$export$22a9451e3bf2233f(productName, testIdPrefix, label) {
    const productKey = productName === 'core' || productName === 'software' ? 'jira' : productName;
    const { icon: NewIconComponent, name: logoName } = $b999daca087b8fc3$export$6d49a893c897b0cc[productKey];
    const createComponent = (Component, type, shouldUseNewLogoDesign)=>(props)=>{
            const additionalProps = {};
            // Nav v3 sets a testId, Nav v4 sets a label
            if (testIdPrefix) additionalProps.testId = `${testIdPrefix}-${type}`;
            if (label) additionalProps.label = label;
            additionalProps.shouldUseNewLogoDesign = shouldUseNewLogoDesign;
            // Casting required due to complexities of the different component prop types
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
                ...props,
                ...additionalProps
            });
        };
    const newIcon = createComponent(NewIconComponent, 'icon', true);
    return {
        icon: newIcon,
        name: logoName
    };
}
function $b999daca087b8fc3$export$20e08d839e9f9688(formatMessage, productName) {
    let label = '';
    if (productName === 'serviceDesk') label = formatMessage($b999daca087b8fc3$var$jsmLogoLabel);
    else if (productName === 'product-discovery') label = formatMessage($b999daca087b8fc3$var$jpdLogoLabel);
    else if (productName === 'customer-service') label = formatMessage($b999daca087b8fc3$var$csmLogoLabel);
    else label = formatMessage($b999daca087b8fc3$var$jiraLogoLabel);
    return label;
}

});




parcelRegister("jTo9C", function(module, exports) {
$parcel$export(module.exports, "useReadyQueryReference", () => $eb71503e9d104cd3$export$92e863e8bacdf5d5);

var $euxye = parcelRequire("euxye");
function $eb71503e9d104cd3$export$92e863e8bacdf5d5(current) {
    const [readyRef, setReadyRef] = (0, $euxye.useState)(current);
    // No source means data is already in store, set the state with the current ref
    if (current && !current.source && current !== readyRef) setReadyRef(current);
    (0, $euxye.useEffect)(()=>{
        // Do nothing if there's no candidate, or if it's already the one we're rendering
        if (!current?.source || current === readyRef) return;
        // Promote on error too so the consumer's error boundary surfaces it.
        const promote = ()=>setReadyRef(current);
        const subscription = current.source.subscribe({
            complete: promote,
            error: promote
        });
        return ()=>subscription.unsubscribe();
    }, [
        current,
        readyRef
    ]);
    return readyRef;
}

});

parcelRegister("fgFqH", function(module, exports) {


module.exports = (parcelRequire("gZgW8"))('navx_onboarding_universal_create_in_jira', function() {
    return parcelRequire('bXGQx');
}, function() {
    return parcelRequire('jwLDz');
}, {
    l: (parcelRequire("7BmPo")),
    i: [
        "27fFF",
        "hJyTq"
    ]
});

});
parcelRegister("7BmPo", function(module, exports) {
"use strict";
module.exports = function loadJSBundle(bundle) {
    // Don't insert the same script twice (e.g. if it was already in the HTML)
    let existingScripts = document.getElementsByTagName('script');
    let isCurrentBundle = function(script) {
        return script.src === bundle;
    };
    if ([].concat(existingScripts).some(isCurrentBundle)) return;
    // Request using XHR because it's synchronous and we can't use promises here
    // This has extremely poor performance because we're idle during this fetch, so we only use this so that the app won't crash
    const xhr = new XMLHttpRequest();
    xhr.open('GET', bundle, false);
    try {
        xhr.send();
        if (xhr.status === 200) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = xhr.responseText;
            // Execute the script synchronously
            document.head.appendChild(script);
        } else throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Status: ${xhr.status}`);
    } catch (e) {
        throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Error: ${e.message}`);
    }
};

});





parcelRegister("gsEo7", function(module, exports) {
$parcel$export(module.exports, "HorizontalNavEntry", () => $e52681725971b1d9$export$4a7d912fe47d3ec);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $EWLmr = parcelRequire("EWLmr");

var $gekJR = parcelRequire("gekJR");

var $btoiF = parcelRequire("btoiF");


var $gDdYI = parcelRequire("gDdYI");

var $dsVXF = parcelRequire("dsVXF");

var $6yDzo = parcelRequire("6yDzo");

var $bzSUP = parcelRequire("bzSUP");
const $e52681725971b1d9$var$NavErrorBoundaryFallback = ()=>// null = equivalent of "unmount"
    // We should do more graceful degradation.
    // Let's review this after dogfooding:
    // Tracked https://hello.jira.atlassian.cloud/browse/SEA-3059
    null;
const $e52681725971b1d9$var$entrypointContainerProps = {};
const $e52681725971b1d9$export$4a7d912fe47d3ec = ()=>{
    const HorizontalNavComponent = (0, $EWLmr.useHorizontalNavComponent)();
    // Consume the horizontal nav entry point if defined, otherwise fallback to the old horizontal nav component
    const horizontalNavEntryPointReference = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$948d4d345566aed3));
    const horizontalNavFallback = ()=>{
        const Fallback = horizontalNavEntryPointReference?.extraProps?.fallback || (0, $6yDzo.HorizontalNavSkeleton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.ReportSSRFailOnUse), {
            pageId: "navigation",
            fallbackId: "horizontal-nav-through-entry-point",
            displayErrorInStaging: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Fallback, null));
    };
    if (horizontalNavEntryPointReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "horizontal-nav-through-entry-point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "horizontal-nav-through-entry-point",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
        name: "horizontal-nav-through-entry-point",
        fallback: horizontalNavFallback(),
        entryPointReference: horizontalNavEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
        entryPointReference: horizontalNavEntryPointReference,
        props: $e52681725971b1d9$var$entrypointContainerProps
    })))));
    return HorizontalNavComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gekJR.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $e52681725971b1d9$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(HorizontalNavComponent, null));
};
$e52681725971b1d9$export$4a7d912fe47d3ec.displayName = "HorizontalNavEntry";

});
parcelRegister("EWLmr", function(module, exports) {
$parcel$export(module.exports, "useHorizontalNavComponent", () => $b28e85a93d4ddec9$export$205771a0e64e4c7c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $bfBRs = parcelRequire("bfBRs");

var $75Njg = parcelRequire("75Njg");

var $4Onaa = parcelRequire("4Onaa");

var $2b39L = parcelRequire("2b39L");

var $f2wVS = parcelRequire("f2wVS");

const $b28e85a93d4ddec9$export$965942f8308cd740 = (0, $f2wVS.createRouterSelector)((state)=>(0, $bfBRs.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
const $b28e85a93d4ddec9$export$205771a0e64e4c7c = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const { data: projectData } = (0, $2b39L.useProjectContext)();
    const hasBoardSettingsPageQueryParam = $b28e85a93d4ddec9$export$965942f8308cd740();
    if (!route.navigation?.horizontal) return null;
    // Board settings pages should not show the horizontal nav.
    // This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
    // as the board settings pages. This code should be removed once the board settings pages have
    // their own dedicated route names.
    if (route.group === 'classic-software' && hasBoardSettingsPageQueryParam) return null;
    if (route.navigation.horizontal === (0, $156b0b89ff564e71$export$9ab1d1d726b36319)) switch(projectData?.projectType){
        case 0, $f99M0.CORE_PROJECT:
            return 0, $75Njg.AsyncHorizontalNavJira;
        case 0, $f99M0.SOFTWARE_PROJECT:
            return 0, $75Njg.AsyncHorizontalNavJira;
        default:
            return null;
    }
    return route.navigation.horizontal;
};

});
parcelRegister("bfBRs", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", () => $f8307758d0a1ddfd$export$128e24da52662cdd);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", () => $f8307758d0a1ddfd$export$efdecbe4c9f1cd2c);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION", () => $f8307758d0a1ddfd$export$1154ed64d0d99951);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", () => $f8307758d0a1ddfd$export$7cadd2a48a9ff918);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", () => $f8307758d0a1ddfd$export$a546b6d48878ce6f);
$parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", () => $f8307758d0a1ddfd$export$8cc83ae2b6885e0);
$parcel$export(module.exports, "boardSettingsQueryConfigParamValues", () => $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3);
$parcel$export(module.exports, "SETTINGS_CONFIG", () => $f8307758d0a1ddfd$export$2a56ee2f9c41b5a7);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $f8307758d0a1ddfd$export$b893894941c14e43);
$parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", () => $f8307758d0a1ddfd$export$d14d5a7c294329c5);
$parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", () => $f8307758d0a1ddfd$export$1e63b013f0e45de0);
$parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", () => $f8307758d0a1ddfd$export$68030ac1ea4abd4c);
$parcel$export(module.exports, "BACKLOG_FEATURE_KEY", () => $f8307758d0a1ddfd$export$e1671d3447ddd5ad);
$parcel$export(module.exports, "SPRINTS_FEATURE_KEY", () => $f8307758d0a1ddfd$export$46efc2c8d8106cff);
/* eslint-disable jira/filename-case */ const $f8307758d0a1ddfd$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
const $f8307758d0a1ddfd$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
const $f8307758d0a1ddfd$export$1154ed64d0d99951 = 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
const $f8307758d0a1ddfd$export$7cadd2a48a9ff918 = `${$f8307758d0a1ddfd$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
const $f8307758d0a1ddfd$export$a546b6d48878ce6f = 'Epic';
const $f8307758d0a1ddfd$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
    'cardColors',
    'cardLayout',
    'columns',
    'default',
    'estimation',
    'filter',
    'swimlanes',
    'time',
    'timelineConfig',
    'quickFilters',
    'dateFields'
];
const $f8307758d0a1ddfd$export$8cc83ae2b6885e0 = new Set($f8307758d0a1ddfd$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
const $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3 = Object.fromEntries($f8307758d0a1ddfd$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
        key,
        key
    ]));
const $f8307758d0a1ddfd$export$2a56ee2f9c41b5a7 = {
    default: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    filter: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    columns: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.columns,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    swimlanes: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.swimlanes,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    quickFilters: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.quickFilters,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardColors: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.cardColors,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardLayout: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.cardLayout,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    estimation: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.estimation,
        userLocatedBoardAllowed: true,
        kanbanAllowed: false,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    time: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.time,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    timelineConfig: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.timelineConfig,
        userLocatedBoardAllowed: false,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    dateFields: {
        configQuery: $f8307758d0a1ddfd$export$a9ebdab56bd9c0c3.dateFields,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled })=>isCalendarEnabled,
        jswAllowed: false
    }
};
const $f8307758d0a1ddfd$export$773ca4f5fb67778b = 60000;
const $f8307758d0a1ddfd$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $f8307758d0a1ddfd$export$d14d5a7c294329c5 = // oxlint-disable-next-line typescript/consistent-type-assertions
'ADMINISTER_PARENT_PROJECT';
const $f8307758d0a1ddfd$export$1e63b013f0e45de0 = // oxlint-disable-next-line typescript/consistent-type-assertions
'USER_PICKER';
const $f8307758d0a1ddfd$export$68030ac1ea4abd4c = 'ADMINISTER';
const $f8307758d0a1ddfd$export$e1671d3447ddd5ad = 'BACKLOG';
const $f8307758d0a1ddfd$export$46efc2c8d8106cff = 'SPRINTS';
const $f8307758d0a1ddfd$export$a1046f102eae498 = 'ENABLED';

});


parcelRegister("gekJR", function(module, exports) {
$parcel$export(module.exports, "NavErrorBoundary", () => $ce66eb3b9fe5f22d$export$afc779e659fd533f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $h8QGu = parcelRequire("h8QGu");
const $ce66eb3b9fe5f22d$export$1d1321d2b374d697 = ()=>{
    const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
    const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
    return buildKey ? re.test(buildKey) : false;
};
function $ce66eb3b9fe5f22d$var$inferNavRevision() {
    // This is brittle since we have several FFs https://hello.atlassian.net/wiki/spaces/SEA/pages/3841892327/Jira+Nav+v4+Feature+Flags
    // if possible, try to pass the revision explicitly as a prop
    return 'v4';
}
function $ce66eb3b9fe5f22d$var$getExtraAttributes(_error) {
    const attributes = {
        rev: $ce66eb3b9fe5f22d$var$inferNavRevision()
    };
    return attributes;
}
function $ce66eb3b9fe5f22d$var$getAnalyticsPayload(error, meta, navRevision) {
    const payload = {
        error: error,
        meta: {
            // intentionally fixed metas
            // so that we generate a unique event signature
            // so that we can register it in the analytics portal: https://data-portal.internal.atlassian.com/analytics/registry/67955
            // so that we get the attributes to show up in Splunk: https://splunk.paas-inf.net/en-GB/app/search/2024_sea2744_jira_nav_v4_container_navigation
            id: 'logic',
            packageName: 'JiraNav'
        },
        attributes: {
            ...$ce66eb3b9fe5f22d$var$getExtraAttributes(error),
            // forward the original meta as attributes to identify the location
            pkg: meta.packageName,
            id: meta.id,
            // if explicitly passed, override the rev
            ...navRevision && {
                rev: navRevision
            }
        },
        skipSentry: true
    };
    return payload;
}
const $ce66eb3b9fe5f22d$export$5ac21f1e947e70d6 = (props)=>{
    const { id: id, packageName: packageName, navRevision: navRevision } = props;
    const onError = (0, $euxye.useMemo)(()=>{
        const meta = {
            id: id,
            packageName: packageName
        };
        const _onError = (...args)=>{
            if ($ce66eb3b9fe5f22d$export$1d1321d2b374d697()) // this is a local test environment, don't send anything
            return;
            const [_, error] = args;
            (0, $hFtK7.fireErrorAnalytics)($ce66eb3b9fe5f22d$var$getAnalyticsPayload(error, meta, navRevision));
        };
        return _onError;
    }, [
        id,
        packageName,
        navRevision
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        ...props,
        onError: onError
    });
};
$ce66eb3b9fe5f22d$export$5ac21f1e947e70d6.displayName = "JSErrorBoundaryWithExtraReporting";
const $ce66eb3b9fe5f22d$export$afc779e659fd533f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ce66eb3b9fe5f22d$export$5ac21f1e947e70d6, props);
$ce66eb3b9fe5f22d$export$afc779e659fd533f.displayName = "NavErrorBoundary";

});


parcelRegister("dFT3J", function(module, exports) {
$parcel$export(module.exports, "Variables", () => $d1a57d0873f30904$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $d1a57d0873f30904$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $d1a57d0873f30904$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $d1a57d0873f30904$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $d1a57d0873f30904$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $d1a57d0873f30904$export$b124f62a6aab972);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $d1a57d0873f30904$export$4c351ec1dc290344);
$parcel$export(module.exports, "ADAPTIVE_IMAGE_BACKGROUND_CONFIG", () => $d1a57d0873f30904$export$c8033614bd64480d);
$parcel$export(module.exports, "ADAPTIVE_COLOR_BACKGROUND_CONFIGS", () => $d1a57d0873f30904$export$4b188262dd47f902);
$parcel$export(module.exports, "ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS", () => $d1a57d0873f30904$export$8a6c8dd4a86d3f7d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $d1a57d0873f30904$export$cab9d853866386f2);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $d1a57d0873f30904$export$8e357501548afe78);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $d1a57d0873f30904$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $d1a57d0873f30904$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $d1a57d0873f30904$export$1c0b806722927549);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $d1a57d0873f30904$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $d1a57d0873f30904$export$3efe68325dd9dc02);
/* eslint-disable jira/filename-case */ // This doesn't use @jira/design-system__navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout


const $d1a57d0873f30904$export$9e0962e0cb41695d = '#FFAB00';
const $d1a57d0873f30904$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--project-backdrop-filter',
    // Delete when business projects are migrated to the new theming
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: '--project-color-background-neutral-subtle-hovered-contrast',
    COLOR_BACKGROUND_ACCENT_SELECTED: '--project-color-background-accent-selected',
    COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--project-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--project-background-selected',
    COLOR_BORDER: '--project-color-border',
    COLOR_BORDER_INPUT: '--project-color-border-input',
    COLOR_BORDER_INVERSE: '--project-color-border-inverse',
    COLOR_BORDER_SELECTED: '--project-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
    COLOR_ELEVATION_SURFACE_SUNKEN: '--project-color-elevation-surface-sunken',
    COLOR_ICON_DANGER: '--project-color-icon-danger',
    COLOR_ICON_INFORMATION: '--project-color-icon-information',
    COLOR_ICON_SUCCESS: '--project-color-icon-success',
    COLOR_ICON_WARNING: '--project-color-icon-warning',
    COLOR_LINK: '--project-color-link',
    COLOR_LINK_PRESSED: '--project-color-link-pressed',
    COLOR_SKELETON: '--project-skeleton',
    COLOR_TEXT: '--project-color-text',
    COLOR_TEXT_ACCENT_SELECTED: '--project-text-accent-selected',
    COLOR_TEXT_DISABLED: '--project-color-text-disabled',
    COLOR_TEXT_INVERSE: '--project-color-text-inverse',
    COLOR_TEXT_SELECTED: '--project-color-text-selected',
    COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
    CONTENT_HEIGHT: '--project-content-height',
    CONTENT_WIDTH: '--project-content-width',
    ELEVATION_SURFACE: '--project-elevation-surface',
    ELEVATION_SURFACE_BLEND_MODE: '--project-elevation-surface-blend-mode',
    ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
    ELEVATION_SURFACE_SWIMLANE: '--project-elevation-surface-swimlane',
    WRAPPER_BACKGROUND: '--project-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
    WRAPPER_HEIGHT: '--project-wrapper-height',
    WRAPPER_PADDING: '--project-wrapper-padding',
    WRAPPER_WIDTH: '--project-wrapper-width'
};
const $d1a57d0873f30904$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--project-backdrop-filter)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: 'var(--project-color-background-neutral-subtle-hovered-contrast)',
    COLOR_BACKGROUND_ACCENT_SELECTED: 'var(--project-color-background-accent-selected)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
    COLOR_BORDER: 'var(--project-color-border)',
    COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
    COLOR_ELEVATION_SURFACE_SUNKEN: 'var(--project-color-elevation-surface-sunken)',
    COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
    COLOR_LINK: 'var(--project-color-link)',
    COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
    COLOR_SKELETON: 'var(--project-skeleton)',
    COLOR_TEXT: 'var(--project-color-text)',
    COLOR_TEXT_ACCENT_SELECTED: 'var(--project-text-accent-selected)',
    COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--project-content-height)',
    CONTENT_WIDTH: 'var(--project-content-width)',
    ELEVATION_SURFACE: 'var(--project-elevation-surface)',
    ELEVATION_SURFACE_BLEND_MODE: 'var(--project-elevation-surface-blend-mode)',
    ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
    ELEVATION_SURFACE_SWIMLANE: 'var(--project-elevation-surface-swimlane)',
    WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
    WRAPPER_PADDING: 'var(--project-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--project-wrapper-width)'
};
const $d1a57d0873f30904$export$8a6e9b3370a0f87a = {
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.accent.selected': '#8FB8F6',
    // B700
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.elevation.surface': "var(--ds-surface, #FFFFFF)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'color.elevation.surface.swimlane': "var(--ds-surface, #FFFFFF)",
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.skeleton': "var(--ds-background-neutral, #0515240F)",
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.selected': "var(--ds-text, #292A2E)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent',
    'elevation.surface.blend.mode': 'darken'
};
const $d1a57d0873f30904$export$f286efa6bd1e8f9d = {
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-neutral, #0515240F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.text.selected': "var(--ds-text-inverse, #FFFFFF)"
};
const $d1a57d0873f30904$export$97cb21c6432e07e8 = {
    'color.background.neutral.subtle.hovered.contrast': 'rgba(255, 255, 255, 0.08)',
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': '#FFFFFF',
    // N0
    'color.icon.danger': '#FFFFFF',
    // N0
    'color.icon.information': '#FFFFFF',
    // N0
    'color.icon.success': '#FFFFFF',
    // N0
    'color.icon.warning': '#FFFFFF',
    // N0
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': '#FFFFFF',
    // N0
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $d1a57d0873f30904$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $d1a57d0873f30904$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #6B6E76)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
            'color.link': "var(--ds-text-accent-blue-bolder, #123263)",
            'color.link.pressed': "var(--ds-text-accent-blue, #1558BC)",
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #6B6E76)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': '#FFFFFF',
            // N0
            'color.icon.information': '#FFFFFF',
            // N0
            'color.icon.success': '#FFFFFF',
            // N0
            'color.icon.warning': '#FFFFFF',
            // N0
            'color.link': "var(--ds-text-accent-blue-bolder, #123263)",
            'color.link.pressed': "var(--ds-text-accent-blue, #1558BC)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': '#FFFFFF',
            // N0
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        }
    }
};
const $d1a57d0873f30904$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $d1a57d0873f30904$export$8a6e9b3370a0f87a,
        dark: {
            ...$d1a57d0873f30904$export$8a6e9b3370a0f87a,
            'color.text.accent.selected': "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $d1a57d0873f30904$var$ADAPTIVE_CONFIG_BASE = {
    'color.elevation.surface': "var(--ds-surface-hovered, #F0F1F2)",
    'color.background.input': "var(--ds-background-neutral, #0515240F)",
    'color.link': "var(--ds-text, #292A2E)",
    'color.link.pressed': "var(--ds-text, #292A2E)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'color.background.selected': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F0F1F2)",
    'color.border.selected': "var(--ds-border-bold, #7D818A)",
    'color.text.selected': "var(--ds-text, #292A2E)",
    'color.text': "var(--ds-text, #292A2E)",
    'color.background.brand.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.elevation.surface.swimlane': "var(--ds-surface-hovered, #F0F1F2)"
};
const $d1a57d0873f30904$export$2ccb37bafb938d85 = ({ name: name, overrides: overrides })=>{
    const adaptiveColorTheme = {
        ...$d1a57d0873f30904$var$ADAPTIVE_CONFIG_BASE,
        ...overrides
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: adaptiveColorTheme,
            dark: adaptiveColorTheme
        }
    };
};
const $d1a57d0873f30904$export$18621b73983ebf62 = ({ name: name, overridesAllThemes: overridesAllThemes, overridesLightTheme: overridesLightTheme, overridesDarkTheme: overridesDarkTheme })=>{
    const adaptiveGradientTheme = {
        'elevation.surface': "var(--ds-surface, #FFFFFF)",
        ...$d1a57d0873f30904$var$ADAPTIVE_CONFIG_BASE,
        ...overridesAllThemes
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: {
                ...adaptiveGradientTheme,
                ...overridesLightTheme
            },
            dark: {
                ...adaptiveGradientTheme,
                ...overridesDarkTheme
            }
        }
    };
};
const $d1a57d0873f30904$export$c8033614bd64480d = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            ...$d1a57d0873f30904$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'normal',
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        },
        dark: {
            ...$d1a57d0873f30904$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'darken',
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        }
    }
};
const $d1a57d0873f30904$export$dbb791a784a1373b = $d1a57d0873f30904$export$2ccb37bafb938d85({
    name: 'adaptive-gray',
    overrides: {
        'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DDDEE1)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-gray-subtlest, #F0F1F2)"
    }
});
const $d1a57d0873f30904$export$e013fca1233b4f7f = $d1a57d0873f30904$export$2ccb37bafb938d85({
    name: 'adaptive-purple',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        'color.link': "var(--ds-text-accent-purple, #803FA5)",
        'color.link.pressed': "var(--ds-text-accent-purple, #803FA5)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #EED7FC)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    }
});
const $d1a57d0873f30904$export$81ad18a6866e27ad = $d1a57d0873f30904$export$2ccb37bafb938d85({
    name: 'adaptive-blue',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        'color.link': "var(--ds-text-accent-blue, #1558BC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #1558BC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    }
});
const $d1a57d0873f30904$export$e41eaa7177d56baf = $d1a57d0873f30904$export$2ccb37bafb938d85({
    name: 'adaptive-teal',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    }
});
const $d1a57d0873f30904$export$31b6c9185eea93be = $d1a57d0873f30904$export$2ccb37bafb938d85({
    name: 'adaptive-green',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    }
});
const $d1a57d0873f30904$export$3214417ed3fa0b58 = $d1a57d0873f30904$export$2ccb37bafb938d85({
    name: 'adaptive-magenta',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
});
// Gradients
const $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_GRAY_META = $d1a57d0873f30904$export$18621b73983ebf62({
    name: 'adaptive-gradient-gray',
    overridesAllThemes: {},
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #F8F8F8 0%, #B7B9BE 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #292A2E 0%, #6B6E76 100%)'
    }
});
const $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_PURPLE_META = $d1a57d0873f30904$export$18621b73983ebf62({
    name: 'adaptive-gradient-purple',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #1558BC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #1558BC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #CFE1FD 0%, #EED7FC 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #123263 0%, #48245D 100%)'
    }
});
const $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_BLUE_META = $d1a57d0873f30904$export$18621b73983ebf62({
    name: 'adaptive-gradient-blue',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #1558BC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #1558BC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E9F2FE 0%, #669DF1 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C2B42 0%, #1868DB 100%)'
    }
});
const $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_TEAL_META = $d1a57d0873f30904$export$18621b73983ebf62({
    name: 'adaptive-gradient-teal',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E7F9FF 0%, #6CC3E0 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1E3137 0%, #227D9B 100%)'
    }
});
const $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_GREEN_META = $d1a57d0873f30904$export$18621b73983ebf62({
    name: 'adaptive-gradient-green',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #DCFFF1 0%, #4BCE97 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C3329 0%, #1F845A 100%)'
    }
});
const $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_MAGENTA_META = $d1a57d0873f30904$export$18621b73983ebf62({
    name: 'adaptive-gradient-magenta',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
        'color.elevation.surface.swimlane': "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #FDD0EC 28.5%, #FD9891 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #50253F 28.5%, #AE2E24 100%)'
    }
});
const $d1a57d0873f30904$export$4b188262dd47f902 = [
    $d1a57d0873f30904$export$dbb791a784a1373b,
    $d1a57d0873f30904$export$e013fca1233b4f7f,
    $d1a57d0873f30904$export$81ad18a6866e27ad,
    $d1a57d0873f30904$export$e41eaa7177d56baf,
    $d1a57d0873f30904$export$31b6c9185eea93be,
    $d1a57d0873f30904$export$3214417ed3fa0b58
];
const $d1a57d0873f30904$export$8a6c8dd4a86d3f7d = [
    $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_GRAY_META,
    $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_PURPLE_META,
    $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_BLUE_META,
    $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_TEAL_META,
    $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_GREEN_META,
    $d1a57d0873f30904$var$ADAPTIVE_GRADIENT_MAGENTA_META
];
const $d1a57d0873f30904$export$cab9d853866386f2 = $d1a57d0873f30904$export$4c351ec1dc290344;
const $d1a57d0873f30904$export$8e357501548afe78 = 24;
const $d1a57d0873f30904$export$baaf8255c30ea280 = 104;
const $d1a57d0873f30904$export$d9035bc768f8226d = `${$d1a57d0873f30904$export$baaf8255c30ea280}px`;
const $d1a57d0873f30904$export$4810531e30462f89 = `calc(100vh - ${(0, $8d2c01fb745e4772$export$d60454526e2281af)} - ${$d1a57d0873f30904$export$d9035bc768f8226d})`;
const $d1a57d0873f30904$export$1c0b806722927549 = `calc(100vh - ${(0, $8d2c01fb745e4772$export$d60454526e2281af)} - ${$d1a57d0873f30904$export$d9035bc768f8226d} - ${$d1a57d0873f30904$export$8e357501548afe78 * 2}px)`;
const $d1a57d0873f30904$export$77cdace62a821419 = `calc(100vw - ${(0, $7c8e8130cce4c6fa$export$f963aecf2d4465bd)} - ${(0, $7c8e8130cce4c6fa$export$f897e1ed9f8ed251)} - ${(0, $7c8e8130cce4c6fa$export$750459958906793)} - ${(0, $7c8e8130cce4c6fa$export$b44ab66843c05a69)}) !important`;
const $d1a57d0873f30904$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $7c8e8130cce4c6fa$export$f963aecf2d4465bd)} - ${(0, $7c8e8130cce4c6fa$export$f897e1ed9f8ed251)} - ${(0, $7c8e8130cce4c6fa$export$750459958906793)} - ${(0, $7c8e8130cce4c6fa$export$b44ab66843c05a69)} - ${$d1a57d0873f30904$export$8e357501548afe78 * 2}px) !important`;
const $d1a57d0873f30904$export$689a64196408e5c2 = 82;

});

parcelRegister("eChBu", function(module, exports) {
$parcel$export(module.exports, "useJsmGracePeriodBanner", () => $b73effd876559006$export$cb2cdbdc1bcc9ace);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $i860n = parcelRequire("i860n");

var $4Onaa = parcelRequire("4Onaa");

var $2b39L = parcelRequire("2b39L");

var $5CnnC = parcelRequire("5CnnC");
const $b73effd876559006$export$cb2cdbdc1bcc9ace = ()=>{
    const currentRoute = (0, $4Onaa.useCurrentRoute)();
    const { data: project } = (0, $2b39L.useProjectContext)();
    const isServiceProject = project?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $euxye.useMemo)(()=>(0, $5CnnC.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    return (0, $euxye.useMemo)(()=>({
            isEnabled: isInJsmBoundary && (0, $i860n.fg)('jsm_gp_announcements_banner')
        }), [
        isInJsmBoundary
    ]);
};

});
parcelRegister("5CnnC", function(module, exports) {
$parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", () => $6c5e190911ccb277$export$c28a66ae6d31a34b);
const $6c5e190911ccb277$var$jsmGlobalSettingsPages = [
    '/jira/settings/products/jira-service-management-configuration',
    '/jira/settings/products/jira-service-management-email-requests',
    '/jira/settings/products/servicedesk/customer-access',
    '/jira/settings/products/servicedesk/authentication',
    '/jira/settings/products/servicedesk/organizations',
    '/jira/settings/products/jira-service-management-incident-management-tools',
    '/jira/settings/products/jira-service-management-compliance',
    '/jira/settings/products/servicedesk/feature-usage'
];
const $6c5e190911ccb277$var$eocGlobalSettingsPages = [
    '/jira/settings/products/ops/roles',
    '/jira/settings/products/ops/role-assignment',
    '/jira/settings/products/ops/role-based-notifications',
    '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    '/jira/settings/products/ops/integrations',
    '/jira/settings/products/ops/heartbeats',
    '/jira/settings/products/ops/syncs',
    '/jira/settings/products/ops/policies',
    '/jira/settings/products/ops/maintenance',
    '/jira/settings/products/ops/escalation-policies',
    '/jira/settings/products/ops/incoming-call',
    '/jira/settings/products/ops/jira-service-management-audit-logs',
    '/jira/settings/products/ops/reports'
];
const $6c5e190911ccb277$var$isJsmGlobalSettingsPage = (route)=>$6c5e190911ccb277$var$jsmGlobalSettingsPages.includes(route);
const $6c5e190911ccb277$var$isEocGlobalSettingsPage = (route)=>$6c5e190911ccb277$var$eocGlobalSettingsPages.includes(route);
const $6c5e190911ccb277$export$c28a66ae6d31a34b = (route)=>$6c5e190911ccb277$var$isJsmGlobalSettingsPage(route) || $6c5e190911ccb277$var$isEocGlobalSettingsPage(route);

});


parcelRegister("bGess", function(module, exports) {
$parcel$export(module.exports, "JSMGracePeriodBannerAsync", () => $fa068cc7fbe8b861$export$5f656c66df6dad60);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $6x5Yw = parcelRequire("6x5Yw");

var $i860n = parcelRequire("i860n");

var $3GN2r = parcelRequire("3GN2r");

var $bs9jJ = parcelRequire("bs9jJ");

var $ccEzE = parcelRequire("ccEzE");

var $d8LhJ = parcelRequire("d8LhJ");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fa068cc7fbe8b861$var$JSMGracePeriodBannerLazy = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("8zqVa")).then((module)=>module.JSMGracePeriodBanner), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/jsm-grace-period-banner/src/JSMGracePeriodBanner.tsx"
});
const $fa068cc7fbe8b861$var$JSMGracePeriodBannerAsyncInner = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async.jsm-grace-period-banner",
        teamName: "Sequoia",
        fallback: "unmount"
    }, (0, $i860n.fg)('jsm-queues-ttai-batch-1') ? // FLASH-961: Replace Placeholder (which creates a UFO hold blocking TTAI) with
    // LazySuspense (no UFO hold). The banner is non-critical — it only shows for
    // tenants in a billing grace period. All JSM users on JSM pages incur the hold
    // when jsm_gp_announcements_banner gate is ON, even if they never see the banner.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6x5Yw.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fa068cc7fbe8b861$var$JSMGracePeriodBannerLazy, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-jsm-grace-period-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fa068cc7fbe8b861$var$JSMGracePeriodBannerLazy, null)));
};
$fa068cc7fbe8b861$var$JSMGracePeriodBannerAsyncInner.displayName = "JSMGracePeriodBannerAsyncInner";
const $fa068cc7fbe8b861$var$JSMGracePeriodBannerAsyncGated = ()=>{
    const accountId = (0, $3GN2r.useAccountId)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    // The banner is only shown to Standard JSM site admins (see `getGpEndDateData`,
    // which returns no data for anyone else). Hoisting that eligibility check here
    // lets us skip downloading the banner chunk and running its hooks/resources for
    // ineligible users, instead of loading everything just to render `null`.
    if (appEditions.serviceDesk !== (0, $d8LhJ.STANDARD_EDITION) || !accountId || !isSiteAdmin) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fa068cc7fbe8b861$var$JSMGracePeriodBannerAsyncInner, null);
};
$fa068cc7fbe8b861$var$JSMGracePeriodBannerAsyncGated.displayName = "JSMGracePeriodBannerAsyncGated";
const $fa068cc7fbe8b861$export$5f656c66df6dad60 = ()=>{
    if ((0, $i860n.fg)('perf-jsm-issue-view-ttai-grace-period')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fa068cc7fbe8b861$var$JSMGracePeriodBannerAsyncGated, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fa068cc7fbe8b861$var$JSMGracePeriodBannerAsyncInner, null);
};
$fa068cc7fbe8b861$export$5f656c66df6dad60.displayName = "JSMGracePeriodBannerAsync";

});
parcelRegister("8zqVa", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hLmdy").then(()=>parcelRequire('4rHpP'));

});


parcelRegister("9XO6I", function(module, exports) {
$parcel$export(module.exports, "useIsChromeless", () => $90d0a46a7a0d08f3$export$c88b74884f5222ba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $7Sa0x = parcelRequire("7Sa0x");
const $90d0a46a7a0d08f3$export$c88b74884f5222ba = (0, $3h1FP.createHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>state.isChromeless
});

});

parcelRegister("5NkRe", function(module, exports) {
$parcel$export(module.exports, "useFullscreenActions", () => $5063db9206544644$export$17ea373d8dd3fabf);
$parcel$export(module.exports, "useIsFullscreen", () => $5063db9206544644$export$d397eccea5f37b0a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $7Sa0x = parcelRequire("7Sa0x");
const $5063db9206544644$export$e32cfa62975978e6 = (0, $3h1FP.createStateHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>state.isFullscreen
});
const $5063db9206544644$export$17ea373d8dd3fabf = (0, $3h1FP.createActionsHook)((0, $7Sa0x.layoutStore));
const $5063db9206544644$export$d397eccea5f37b0a = (0, $3h1FP.createHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});

parcelRegister("cJ4JH", function(module, exports) {
$parcel$export(module.exports, "LayoutRemoteStateUpdater", () => $319cfcd25554c924$export$b9f3a70460995c32);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $3GN2r = parcelRequire("3GN2r");

var $i860n = parcelRequire("i860n");

var $2KMaX = parcelRequire("2KMaX");

var $29eRG = parcelRequire("29eRG");

var $htOkX = parcelRequire("htOkX");

var $35IUs = parcelRequire("35IUs");
const $319cfcd25554c924$export$b9f3a70460995c32 = ()=>{
    const accountId = (0, $3GN2r.useAccountId)();
    const leftSidebar = (0, $2KMaX.useLeftSidebarState)();
    const rightSidebar = (0, $29eRG.useRightSidebarState)();
    const previewPanel = (0, $htOkX.usePreviewPanelState)();
    const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
    const leftSidebarWidth = leftSidebar.width;
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $euxye.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $euxye.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $euxye.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $euxye.useState)();
    const [localPreviewPanelState, setLocalPreviewPanelState] = (0, $euxye.useState)();
    // Original version (with feature gate disabled) - maintains existing behavior
    const sideBarChangedOld = (0, $euxye.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState, externalPreviewPanelState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(externalPreviewPanelState, localPreviewPanelState)) {
            setLocalPreviewPanelState(externalPreviewPanelState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState,
        localPreviewPanelState
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!accountId) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(leftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebar);
            setLocalPreviewPanelState(previewPanel);
            return;
        }
        // When using the fixed version, ensure all values are defined before proceeding
        if (leftSidebarWidth === undefined || isLeftSidebarCollapsed === undefined || rightSidebar === undefined || previewPanel === undefined || localLeftSidebarWidthState === undefined || localLeftSidebarCollapsedState === undefined || localRightSidebarState === undefined || localPreviewPanelState === undefined) return;
        // TypeScript now knows these values are defined
        const hasChanges = $319cfcd25554c924$var$isSidebarChanged({
            externalLeftSidebarWidth: leftSidebarWidth,
            externalIsLeftSidebarCollapsed: isLeftSidebarCollapsed,
            externalRightSidebarState: rightSidebar,
            externalPreviewPanelState: previewPanel,
            currentLocalLeftSidebarWidth: localLeftSidebarWidthState,
            currentLocalLeftSidebarCollapsed: localLeftSidebarCollapsedState,
            currentLocalRightSidebarState: localRightSidebarState,
            currentLocalPreviewPanelState: localPreviewPanelState
        });
        if (!hasChanges) return;
        // Update local state separately when using fixed version to prevent callback recreation
        // Only update each piece of state if it actually changed (preserves original granular behavior)
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(leftSidebarWidth, localLeftSidebarWidthState)) setLocalLeftSidebarWidthState(leftSidebarWidth);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(isLeftSidebarCollapsed, localLeftSidebarCollapsedState)) setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(rightSidebar, localRightSidebarState)) setLocalRightSidebarState(rightSidebar);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(previewPanel, localPreviewPanelState)) setLocalPreviewPanelState(previewPanel);
        (0, $35IUs.setRemoteLayoutState)({
            accountId: accountId,
            state: {
                rightSidebar: rightSidebar,
                leftSidebar: {
                    isCollapsed: isLeftSidebarCollapsed,
                    width: leftSidebarWidth
                },
                ...(0, $i860n.fg)('jira-glance-panel') && {
                    previewPanel: previewPanel
                }
            }
        });
    }, [
        accountId,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        rightSidebar,
        initialLoad,
        previewPanel,
        sideBarChangedOld,
        localLeftSidebarWidthState,
        localLeftSidebarCollapsedState,
        localRightSidebarState,
        localPreviewPanelState
    ]);
    return null;
};
$319cfcd25554c924$export$b9f3a70460995c32.displayName = "LayoutRemoteStateUpdater";
// Pure comparison function - moved outside component for better performance
const $319cfcd25554c924$var$isSidebarChanged = (args)=>{
    const { externalLeftSidebarWidth: externalLeftSidebarWidth, externalIsLeftSidebarCollapsed: externalIsLeftSidebarCollapsed, externalRightSidebarState: externalRightSidebarState, externalPreviewPanelState: externalPreviewPanelState, currentLocalLeftSidebarWidth: currentLocalLeftSidebarWidth, currentLocalLeftSidebarCollapsed: currentLocalLeftSidebarCollapsed, currentLocalRightSidebarState: currentLocalRightSidebarState, currentLocalPreviewPanelState: currentLocalPreviewPanelState } = args;
    // Only compare, don't modify state to prevent infinite loops
    return !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(externalLeftSidebarWidth, currentLocalLeftSidebarWidth) || !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(externalIsLeftSidebarCollapsed, currentLocalLeftSidebarCollapsed) || !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(externalRightSidebarState, currentLocalRightSidebarState) || !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(externalPreviewPanelState, currentLocalPreviewPanelState);
};

});
parcelRegister("htOkX", function(module, exports) {
$parcel$export(module.exports, "usePreviewPanelState", () => $b7ae546092f236c7$export$69e98a9119b24908);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $7Sa0x = parcelRequire("7Sa0x");
const $b7ae546092f236c7$export$69e98a9119b24908 = (0, $3h1FP.createStateHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>({
            ...state.content.previewPanel
        })
});

});

parcelRegister("35IUs", function(module, exports) {
$parcel$export(module.exports, "setRemoteLayoutState", () => $9c79a285d8eea3f9$export$ad53b565e6cd4261);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable import/order */ 
var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

async function $9c79a285d8eea3f9$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
    try {
        await (0, $kM0go.setUserProperties)(accountId, (0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8), JSON.stringify(state));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: e,
            meta: {
                id: 'updateServerLayoutState',
                packageName: 'jiraLayoutController',
                teamName: 'jfp-team'
            }
        });
    }
}

});


parcelRegister("ePtEH", function(module, exports) {
$parcel$export(module.exports, "useProjectTheme", () => $64304a5eba01d1b4$export$18084206b9430153);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f2wVS = parcelRequire("f2wVS");
const $64304a5eba01d1b4$export$7bf98640231e1ffa = (0, $f2wVS.createRouterSelector)((state)=>state.route.supportsProjectTheme);
const $64304a5eba01d1b4$export$18084206b9430153 = ()=>{
    const supportsProjectTheme = $64304a5eba01d1b4$export$7bf98640231e1ffa();
    const hasTheming = Boolean(supportsProjectTheme);
    return {
        isInset: supportsProjectTheme === 'contoured',
        hasTheming: hasTheming
    };
};

});

parcelRegister("57TEW", function(module, exports) {
$parcel$export(module.exports, "sharedLayout", () => $afe7542435d804be$export$5f4dc7c98070d93e);
$parcel$export(module.exports, "getSharedLayout", () => $afe7542435d804be$export$4091a20e70d7bd73);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $rZCjF = parcelRequire("rZCjF");

var $f99M0 = parcelRequire("f99M0");

var $kiCU2 = parcelRequire("kiCU2");

var $f2wVS = parcelRequire("f2wVS");

var $6ZLJT = parcelRequire("6ZLJT");

var $hIRki = parcelRequire("hIRki");

var $5NMxV = parcelRequire("5NMxV");

var $9WXaO = parcelRequire("9WXaO");

var $eetaH = parcelRequire("eetaH");

var $4S96j = parcelRequire("4S96j");

var $lg2s9 = parcelRequire("lg2s9");

var $dex1f = parcelRequire("dex1f");

var $JFocG = parcelRequire("JFocG");

var $ioHRB = parcelRequire("ioHRB");

var $9lndY = parcelRequire("9lndY");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $lCfDe = parcelRequire("lCfDe");

var $jepRN = parcelRequire("jepRN");

var $5dfRu = parcelRequire("5dfRu");

var $7JeLK = parcelRequire("7JeLK");

var $i860n = parcelRequire("i860n");

var $2rzpb = parcelRequire("2rzpb");

var $er0A5 = parcelRequire("er0A5");

var $XssJM = parcelRequire("XssJM");

var $7oKHF = parcelRequire("7oKHF");

var $i3Mi7 = parcelRequire("i3Mi7");

var $aPKip = parcelRequire("aPKip");

var $f8jMS = parcelRequire("f8jMS");

var $QhQu4 = parcelRequire("QhQu4");

var $kt86l = parcelRequire("kt86l");

var $l8G1z = parcelRequire("l8G1z");

var $8dwaf = parcelRequire("8dwaf");

var $1Bs8E = parcelRequire("1Bs8E");

var $oouzK = parcelRequire("oouzK");

var $gFlGn = parcelRequire("gFlGn");

var $Y2Big = parcelRequire("Y2Big");

var $l8vBy = parcelRequire("l8vBy");

var $c2hVV = parcelRequire("c2hVV");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $afe7542435d804be$var$Global = (0, $l8G1z.lazy)(()=>(parcelRequire("jtFTj")), {
    moduleId: "./src/packages/platform/layouts-jira-shared-layout/src/ui/global/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $afe7542435d804be$var$Navigation = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("gbfjL")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-jira-shared-layout/src/ui/navigation/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $afe7542435d804be$var$Trackers = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("7si8q")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-jira-shared-layout/src/ui/trackers/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $afe7542435d804be$var$RemoteActions = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("eHwfl")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-jira-shared-layout/src/ui/remote-actions/index.tsx"
});

// No need for a whole chunk for a single component
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $afe7542435d804be$var$AfterPaintIssuePreEval = (0, $l8G1z.lazyAfterPaint)(/* eslint-disable-next-line jira/import/webpack-magic-comment-entries */ ()=>(parcelRequire("2d39V")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-jira-shared-layout/src/ui/after-paint-issue-preeval/AfterPaintIssuePreEval.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $afe7542435d804be$var$AsyncBrowserStorageControlsInit = (0, $l8G1z.lazy)(()=>(parcelRequire("l7BEG")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
    moduleId: "./src/packages/platform/layouts-jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
});
const $afe7542435d804be$var$runtimeProps = {};
const $afe7542435d804be$export$bb0d8fff645668ce = ()=>{
    const cloudID = (0, $kt86l.useCloudId)();
    const { data: project } = (0, $XssJM.useProject)();
    const projectType = (0, $f99M0.toProjectType)(project?.type) || null;
    const productKey = (0, $f99M0.projectTypeToCanonicalId)(projectType);
    const deferEditionModalEntryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudID,
            productKey: productKey
        }), [
        cloudID,
        productKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $9lndY.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
    const onComplete = (0, $euxye.useCallback)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, $i860n.fg)('ttai_fix_defer_edition_modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioHRB.AsyncDeferEditionEPCheckWrapperNew), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $afe7542435d804be$var$runtimeProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioHRB.AsyncDeferEditionEPCheckWrapper), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $afe7542435d804be$var$runtimeProps
    })));
};
$afe7542435d804be$export$bb0d8fff645668ce.displayName = "DeferEditionModalEntryPoint";
const $afe7542435d804be$var$AgentPresenceHeartbeatInBackground = (0, $7JeLK.renderInBackgroundPriority)((0, $lg2s9.AgentPresenceHeartbeatLazy));
const $afe7542435d804be$var$ConditionalAgentPresenceHeartbeat = (0, $jepRN.componentWithFG)('jsm_wfo_agent_presence', $afe7542435d804be$var$AgentPresenceHeartbeatInBackground, ()=>null);
const $afe7542435d804be$var$RemoteActionsInBackground = (0, $7JeLK.renderInBackgroundPriority)($afe7542435d804be$var$RemoteActions);
const $afe7542435d804be$var$ConditionalRemoteActions = (0, $jepRN.componentWithFG)('ttai_fix_remoteactions_and_browserstoragecontrols', $afe7542435d804be$var$RemoteActionsInBackground, $afe7542435d804be$var$RemoteActions);
const $afe7542435d804be$var$MaybeAsyncBrowserStorageControlsInit = ()=>{
    if (// @ts-expect-error - __hasStorageControlsBeenInit is set on globalThis by the early entry script.
    globalThis?.__hasStorageControlsBeenInit && (0, $i860n.fg)('jfp-magma-early-script-refactor')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($afe7542435d804be$var$AsyncBrowserStorageControlsInit, null);
};
$afe7542435d804be$var$MaybeAsyncBrowserStorageControlsInit.displayName = "MaybeAsyncBrowserStorageControlsInit";
$afe7542435d804be$export$bb0d8fff645668ce.displayName = 'DeferEditionModal';
$afe7542435d804be$var$ConditionalAgentPresenceHeartbeat.displayName = 'ConditionalAgentPresenceHeartbeat';
$afe7542435d804be$var$ConditionalRemoteActions.displayName = 'Lazy(ui/remote-actions/index.tsx)';
const $afe7542435d804be$var$clientOnlyGlobalComponents = [
    (0, $5dfRu.PriorityManager),
    (0, $7oKHF.MatchedRouteListener),
    (0, $i3Mi7.PreviousRouterStateListener),
    (0, $Y2Big.LoadingPhaseManager),
    (0, $dex1f.default),
    (0, $gFlGn.BreadcrumbAdapter),
    (0, $aPKip.default),
    (0, $5NMxV.PageDwellAnalyticsListener),
    (0, $er0A5.ImperativeAPI),
    (0, $l8vBy.TrackClicksBeforeTTI),
    (0, $9WXaO.default),
    (0, $eetaH.AsyncUpflowIframeComponent),
    (0, $4S96j.JiraHeritageLoader),
    $afe7542435d804be$var$MaybeAsyncBrowserStorageControlsInit,
    (0, $8dwaf.CrossJoinNudges),
    (0, $lCfDe.default),
    $afe7542435d804be$var$ConditionalRemoteActions,
    $afe7542435d804be$export$bb0d8fff645668ce,
    (0, $f8jMS.AsyncRecommendPremiumToStandardModalWrapper),
    (0, $1Bs8E.AsyncSSRFailureDisplay),
    // Integrations - Issue View Modal, Create Project Drawer & Create dashboard modal
    (0, $c2hVV.Integrations),
    $afe7542435d804be$var$ConditionalAgentPresenceHeartbeat
];
const $afe7542435d804be$var$getSharedGlobalComponents = (components)=>{
    if (false) return [];
    return components;
};
const $afe7542435d804be$var$sharedGlobalComponents = [
    ...$afe7542435d804be$var$getSharedGlobalComponents($afe7542435d804be$var$clientOnlyGlobalComponents),
    $afe7542435d804be$var$Global,
    $afe7542435d804be$var$Navigation,
    $afe7542435d804be$var$Trackers,
    (0, $7JeLK.renderInBackgroundPriority)($afe7542435d804be$var$AfterPaintIssuePreEval),
    (0, $rZCjF.AiRovoCurrentRouteConfigurationProviderWithBoundary)
];
const $afe7542435d804be$var$useRouteIssueKey = (0, $f2wVS.createRouterSelector)(({ match: match })=>typeof match?.params?.issueKey === 'string' ? match.params.issueKey : undefined);
const $afe7542435d804be$var$useNoIssueKey = ()=>undefined;
const $afe7542435d804be$var$useSafeEmbeddedConfluencePanelIssueKey = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('remove-issue-context-mirror-on-wiv'), $afe7542435d804be$var$useRouteIssueKey, $afe7542435d804be$var$useNoIssueKey);
/**
 * Layout-level adapter for the embedded Confluence side-panel.
 *
 * The shared layout owns the right-sidebar slot, so the panel is mounted
 * **outside** any IssueView / WorkItemView provider tree. Instead of relying on
 * IssueContextContainer being mirrored up via an `IssueContextRepeater`, we
 * resolve the current `issueKey` from the route here and hand it to the panel
 * as a prop. The panel then scopes its sweet-state container by this value
 * without touching `useIssueKey()`.
 *
 * Route params used here are the same `:issueKey` segment used by every Jira
 * issue/work-item route definition (see router-routes/*).
 */ const $afe7542435d804be$var$SafeEmbeddedConfluencePanelInLayout = ()=>{
    const issueKey = $afe7542435d804be$var$useSafeEmbeddedConfluencePanelIssueKey();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kiCU2.SafeEmbeddedConfluencePanel), {
        issueKey: issueKey
    });
};
$afe7542435d804be$var$SafeEmbeddedConfluencePanelInLayout.displayName = "SafeEmbeddedConfluencePanelInLayout";
const $afe7542435d804be$export$5f4dc7c98070d93e = (0, $QhQu4.createLayout)({
    rightSidebars: [
        (0, $2rzpb.SafeHelpPanel),
        (0, $JFocG.SafeConversationAssistantPanel),
        $afe7542435d804be$var$SafeEmbeddedConfluencePanelInLayout
    ],
    globalComponents: $afe7542435d804be$var$sharedGlobalComponents,
    preloadComponents: [
        $afe7542435d804be$var$RemoteActions,
        (0, $oouzK.JiraCommandPaletteLazy),
        $afe7542435d804be$var$AsyncBrowserStorageControlsInit
    ]
});
// "minimal" here means the client-only global components that are required
// to be rendered when the app is in "stable-ui" mode. When not included these cause the following issues:
// LoadingPhaseManager: UFO events are not fired.
// CacheRegistry: feature-gate/experiment overrides are not persisted in local dev.
const $afe7542435d804be$var$minimalClientOnlyGlobalComponents = [
    (0, $Y2Big.LoadingPhaseManager),
    (0, $dex1f.default)
];
const $afe7542435d804be$var$minimalGlobalComponents = $afe7542435d804be$var$getSharedGlobalComponents($afe7542435d804be$var$minimalClientOnlyGlobalComponents);
const $afe7542435d804be$var$minimalLayout = (0, $QhQu4.createLayout)({
    rightSidebars: [],
    globalComponents: $afe7542435d804be$var$minimalGlobalComponents,
    preloadComponents: []
});
const $afe7542435d804be$export$4091a20e70d7bd73 = ()=>{
    if ((0, $i860n.fg)('jpx-870-stable-ui-for-criterion')) {
        if ((0, $hIRki.isStableUIEnabledForTests)()) return $afe7542435d804be$var$minimalLayout;
    }
    return $afe7542435d804be$export$5f4dc7c98070d93e;
};

});
parcelRegister("rZCjF", function(module, exports) {
$parcel$export(module.exports, "AiRovoCurrentRouteConfigurationProviderWithBoundary", () => $a385404d66127a30$export$6d32a7294394ca5f);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $kt86l = parcelRequire("kt86l");

var $40jii = parcelRequire("40jii");

var $i860n = parcelRequire("i860n");

var $glMzj = parcelRequire("glMzj");

var $gtB5i = parcelRequire("gtB5i");
/**
 * SPICE-1518 - Rovo for Jira Onboarding Experiment
 *
 * This prefetch determines if users are eligible for onboarding actions, or if they should instead get the default experience after their first two weeks.
 */ const $a385404d66127a30$var$SiteTraitPrefetcher = ()=>{
    (0, $gtB5i.useSubProduct)();
    const cloudId = (0, $kt86l.useCloudId)();
    const { fetchTraits: fetchTraits } = (0, $40jii.useTraitsActions)();
    (0, $euxye.useEffect)(()=>{
        fetchTraits([
            'SITE'
        ], {
            cloudId: cloudId
        });
    }, [
        cloudId,
        fetchTraits
    ]);
    return null;
};
$a385404d66127a30$var$SiteTraitPrefetcher.displayName = "SiteTraitPrefetcher";
const $a385404d66127a30$export$6d32a7294394ca5f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "rovo-current-route-configuration-provider",
        packageName: "ai-rovo-actions-route-provider",
        teamName: "reverie"
    }, (0, $i860n.fg)('jfind-rovo-for-jira-onboarding-gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a385404d66127a30$var$SiteTraitPrefetcher, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "rovo-current-route-configuration-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $glMzj.AiRovoCurrentRouteConfigurationProvider), null)));
};
$a385404d66127a30$export$6d32a7294394ca5f.displayName = "AiRovoCurrentRouteConfigurationProviderWithBoundary";

});
parcelRegister("40jii", function(module, exports) {
$parcel$export(module.exports, "useTraits", () => $3c3bc366ddecd78e$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $3c3bc366ddecd78e$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $3c3bc366ddecd78e$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $3c3bc366ddecd78e$export$e653f602b87eec56);

var $h2wCv = parcelRequire("h2wCv");

var $3h1FP = parcelRequire("3h1FP");
var $3K7NP = parcelRequire("3K7NP");
var $5QDqc = parcelRequire("5QDqc");

var $g3pW6 = parcelRequire("g3pW6");

var $kTLO3 = parcelRequire("kTLO3");

var $jLhrF = parcelRequire("jLhrF");

var $5NYfn = parcelRequire("5NYfn");
const $3c3bc366ddecd78e$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $3c3bc366ddecd78e$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $5NYfn.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $jLhrF.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $jLhrF.SITE) && cloudId) fetchedTraits = {
                    attributes: await (0, $g3pW6.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $jLhrF.SITE_USER) && cloudId && accountId) fetchedTraits = {
                    attributes: await (0, $kTLO3.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $h2wCv.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $3c3bc366ddecd78e$var$actions = {
    fetchTraits: $3c3bc366ddecd78e$var$fetchTraits,
    addTrait: $3c3bc366ddecd78e$var$addTrait
};
const $3c3bc366ddecd78e$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $3c3bc366ddecd78e$export$5b11e13f463f4eb = (0, $5QDqc.createStore)({
    initialState: $3c3bc366ddecd78e$var$initialState,
    actions: $3c3bc366ddecd78e$var$actions,
    name: 'TraitsStore'
});
const $3c3bc366ddecd78e$export$243330301a7ccf01 = (0, $3h1FP.createHook)($3c3bc366ddecd78e$export$5b11e13f463f4eb);
const $3c3bc366ddecd78e$export$87f1d888def9d5a0 = (0, $3h1FP.createActionsHook)($3c3bc366ddecd78e$export$5b11e13f463f4eb);
const $3c3bc366ddecd78e$var$defaultSelector = (traitsType, selector)=>(0, $3K7NP.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $5NYfn.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $5NYfn.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $5NYfn.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $5NYfn.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $5NYfn.getTraitValue)(state, name) : null
        }), selector);
const $3c3bc366ddecd78e$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $3h1FP.createHook)($3c3bc366ddecd78e$export$5b11e13f463f4eb, {
        selector: $3c3bc366ddecd78e$var$defaultSelector(traitsType, selector)
    });
const $3c3bc366ddecd78e$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("jLhrF", function(module, exports) {
$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $43d47fac1a972811$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $43d47fac1a972811$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $43d47fac1a972811$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $43d47fac1a972811$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $43d47fac1a972811$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $43d47fac1a972811$export$ff5c5bd50c21e9a4);
/* eslint-disable jira/filename-case */ const $43d47fac1a972811$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $43d47fac1a972811$export$1f4740cb59ea887e = 'SITE';
const $43d47fac1a972811$export$2b629adc0b711448 = 'SITE_USER';
const $43d47fac1a972811$export$c7bc89c720838974 = 'ORG';
const $43d47fac1a972811$export$872e93425a929c06 = 'ORG_USER';
const $43d47fac1a972811$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $43d47fac1a972811$export$ab3e7784d2a104d4 = [
    $43d47fac1a972811$export$eac8289d83d13c9e,
    $43d47fac1a972811$export$1f4740cb59ea887e,
    $43d47fac1a972811$export$2b629adc0b711448,
    $43d47fac1a972811$export$c7bc89c720838974,
    $43d47fac1a972811$export$872e93425a929c06
];

});

parcelRegister("5NYfn", function(module, exports) {
$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $99e70d55f9b848a9$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $99e70d55f9b848a9$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $99e70d55f9b848a9$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $99e70d55f9b848a9$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $99e70d55f9b848a9$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $99e70d55f9b848a9$export$da1e8ce191f01409);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jLhrF = parcelRequire("jLhrF");
const $99e70d55f9b848a9$export$e320a062b20fddc3 = (traitsData)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $99e70d55f9b848a9$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $jLhrF.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $jLhrF.SITE:
            return `site/${cloudId}`;
        case 0, $jLhrF.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $jLhrF.ORG:
            return `org/${orgId}`;
        case 0, $jLhrF.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $99e70d55f9b848a9$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $99e70d55f9b848a9$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $99e70d55f9b848a9$export$252a469687875173(traitsData, traitName) {
    return $99e70d55f9b848a9$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $99e70d55f9b848a9$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $99e70d55f9b848a9$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $99e70d55f9b848a9$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$99e70d55f9b848a9$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $99e70d55f9b848a9$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $99e70d55f9b848a9$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $99e70d55f9b848a9$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $99e70d55f9b848a9$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("glMzj", function(module, exports) {
$parcel$export(module.exports, "AiRovoCurrentRouteConfigurationProvider", () => $c13b576a86d5b526$export$aa2be06b613a2bcf);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $Bq7bE = parcelRequire("Bq7bE");


var $29eRG = parcelRequire("29eRG");

var $cKzEF = parcelRequire("cKzEF");
const $c13b576a86d5b526$var$entryPointParams = {};
const $c13b576a86d5b526$export$aa2be06b613a2bcf = ()=>{
    const { resetConfiguration: resetConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const configuration = (0, $cKzEF.useAiRovoActiveConfiguration)();
    (0, $euxye.useEffect)(()=>{
        if (!configuration?.entrypoint) resetConfiguration();
    }, [
        resetConfiguration,
        configuration
    ]);
    if (!configuration) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c13b576a86d5b526$var$RovoEntryPointContainer, {
        entrypoint: configuration.entrypoint
    }), configuration.nudges && configuration.nudges());
};
$c13b576a86d5b526$export$aa2be06b613a2bcf.displayName = "AiRovoCurrentRouteConfigurationProvider";
const $c13b576a86d5b526$var$RovoEntryPointContainer = ({ entrypoint: entrypoint })=>{
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)(entrypoint, $c13b576a86d5b526$var$entryPointParams);
    const { setConfiguration: setConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const runtimeProps = (0, $euxye.useMemo)(()=>({
            setConfiguration: setConfiguration
        }), [
        setConfiguration
    ]);
    const { mode: mode } = (0, $Bq7bE.useRovoExperienceAPIStore)();
    // TODO this shouldn't be needed since mode should be set to 'sidebar' when the sidebar is open,
    // but it isn't working right now. We should fix this in the rovo experience api store.
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $29eRG.useActiveRightSidebarState)() || {};
    const isActive = panelId === (0, $2de0ca8181f03e7e$export$dffb4ed44e20ea9a) && !isCollapsed;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (mode === 'mini-modal' || mode === 'sidebar' || isActive) entryPointActions.load();
    }, [
        entryPointActions,
        mode,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.rovo.current-route-configuration",
        packageName: "jiraAiRovoActionsRouteProvider",
        runtimeProps: runtimeProps
    });
};
$c13b576a86d5b526$var$RovoEntryPointContainer.displayName = "RovoEntryPointContainer";

});
parcelRegister("bWZpq", function(module, exports) {
$parcel$export(module.exports, "useAiRovoCurrentRouteConfigurationStoreActions", () => $f5b4899a62c53c00$export$9dbea1cf0c57eec9);
$parcel$export(module.exports, "useAiRovoCurrentRouteConfigurationStore", () => $f5b4899a62c53c00$export$fe720c8ec7da3856);
$parcel$export(module.exports, "useAiRovoCurrentRouteNudges", () => $f5b4899a62c53c00$export$8784310698c8e5ea);

var $3h1FP = parcelRequire("3h1FP");

var $5QDqc = parcelRequire("5QDqc");
const $f5b4899a62c53c00$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $f5b4899a62c53c00$var$initialState = {
    configuration: $f5b4899a62c53c00$var$noopConfiguration
};
const $f5b4899a62c53c00$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $f5b4899a62c53c00$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $f5b4899a62c53c00$export$89f578e0312f4574 = (0, $5QDqc.createStore)({
    initialState: $f5b4899a62c53c00$var$initialState,
    actions: $f5b4899a62c53c00$var$actions
});
const $f5b4899a62c53c00$export$9dbea1cf0c57eec9 = (0, $3h1FP.createActionsHook)($f5b4899a62c53c00$export$89f578e0312f4574);
const $f5b4899a62c53c00$export$fe720c8ec7da3856 = (0, $3h1FP.createSelectorHook)($f5b4899a62c53c00$export$89f578e0312f4574);
const $f5b4899a62c53c00$var$selectCurrentRouteNudges = (state)=>state.configuration?.nudges;
const $f5b4899a62c53c00$export$8784310698c8e5ea = ()=>$f5b4899a62c53c00$export$fe720c8ec7da3856($f5b4899a62c53c00$var$selectCurrentRouteNudges);

});

parcelRegister("cKzEF", function(module, exports) {
$parcel$export(module.exports, "useAiRovoActiveConfiguration", () => $b3d3be5505a48408$export$9e6d4fc03eb3d2f1);

var $euxye = parcelRequire("euxye");

var $hSC0O = parcelRequire("hSC0O");

var $1nQzh = parcelRequire("1nQzh");

var $kOCy5 = parcelRequire("kOCy5");

var $iS5GV = parcelRequire("iS5GV");

var $jjL4e = parcelRequire("jjL4e");

var $kKl8x = parcelRequire("kKl8x");

var $UNfHf = parcelRequire("UNfHf");

var $grjK4 = parcelRequire("grjK4");

var $lK74a = parcelRequire("lK74a");

var $8Gfxh = parcelRequire("8Gfxh");

var $gx7ui = parcelRequire("gx7ui");

var $fCZr8 = parcelRequire("fCZr8");

var $8pm7V = parcelRequire("8pm7V");

var $8GlKZ = parcelRequire("8GlKZ");

var $3H4yQ = parcelRequire("3H4yQ");

var $gAcCO = parcelRequire("gAcCO");

var $iWZ4s = parcelRequire("iWZ4s");

var $gP0xD = parcelRequire("gP0xD");

var $cJCzP = parcelRequire("cJCzP");

var $vH5rG = parcelRequire("vH5rG");

var $kaeuE = parcelRequire("kaeuE");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $f2wVS = parcelRequire("f2wVS");

var $efR5m = parcelRequire("efR5m");

var $aCvsO = parcelRequire("aCvsO");

var $2oVIP = parcelRequire("2oVIP");

var $cVIWH = parcelRequire("cVIWH");

var $iJO1d = parcelRequire("iJO1d");

var $fh0ov = parcelRequire("fh0ov");

var $RovSv = parcelRequire("RovSv");

var $jo2lD = parcelRequire("jo2lD");

var $hY2b0 = parcelRequire("hY2b0");

var $jG2Pz = parcelRequire("jG2Pz");

var $9FAc3 = parcelRequire("9FAc3");

var $gRkE6 = parcelRequire("gRkE6");

var $ernnh = parcelRequire("ernnh");

var $g1wUi = parcelRequire("g1wUi");

var $3qMhu = parcelRequire("3qMhu");
const $b3d3be5505a48408$export$62040963369eb126 = {
    'software-backlog': {
        entrypoint: (0, $hSC0O.softwareBacklogConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cVIWH.AiRovoProjectScopedNudgeSubscriptionProvider), {
                sourceId: "nudges-software-backlog"
            }))
    },
    'software-boards': {
        entrypoint: (0, $hSC0O.softwareBacklogConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cVIWH.AiRovoProjectScopedNudgeSubscriptionProvider), {
                sourceId: "nudges-software-boards"
            }))
    },
    'software-version-detail': {
        entrypoint: (0, $1nQzh.softwareVersionDetailConfigProviderEntrypoint)
    },
    'project-versions': {
        entrypoint: (0, $kOCy5.projectVersionsConfigProviderEntrypoint)
    },
    issue: {
        entrypoint: (0, $iS5GV.issueConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2oVIP.AiRovoIssueViewNudgesProvider), null))
    },
    'software-plan-timeline': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'software-plan-calendar': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'software-plan-increment': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'software-plan-increments': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'software-plan-releases': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'software-plan-dependencies': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'plan-settings-features': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'plan-settings-issue-sources': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'plan-settings-program-boards': {
        entrypoint: (0, $jjL4e.planTimelineConfigProviderEntrypoint)
    },
    'project-settings-software-access': {
        entrypoint: (0, $UNfHf.permissionsConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iJO1d.AiRovoPermissionsNudgesProvider), null))
    },
    'legacy-project-settings-people': {
        entrypoint: (0, $UNfHf.permissionsConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iJO1d.AiRovoPermissionsNudgesProvider), null))
    },
    'legacy-project-settings-permissions': {
        entrypoint: (0, $lK74a.spacePermissionConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $RovSv.AiRovoSpacePermissionNudgesProvider), null))
    },
    'servicedesk-getting-started-sla': {
        entrypoint: (0, $kaeuE.slaGsConfigProviderEntrypoint)
    },
    'servicedesk-getting-started-sla-edit': {
        entrypoint: (0, $kaeuE.slaGsConfigProviderEntrypoint)
    },
    'servicedesk-getting-started-sla-new': {
        entrypoint: (0, $kaeuE.slaGsConfigProviderEntrypoint)
    },
    'servicedesk-getting-started-sla-view': {
        entrypoint: (0, $kaeuE.slaGsConfigProviderEntrypoint)
    },
    'servicedesk-getting-started-queues': {
        entrypoint: (0, $vH5rG.queuesConfigProviderEntrypoint)
    },
    'servicedesk-getting-started-queue-create': {
        entrypoint: (0, $vH5rG.queuesConfigProviderEntrypoint)
    },
    'servicedesk-getting-started-queue-edit': {
        entrypoint: (0, $vH5rG.queuesConfigProviderEntrypoint)
    },
    'servicedesk-getting-started-request-types': {
        entrypoint: (0, $cJCzP.requestTypesConfigProviderEntrypoint)
    },
    'servicedesk-getting-started-request-form': {
        entrypoint: (0, $cJCzP.requestTypesConfigProviderEntrypoint)
    },
    'servicedesk-sla-settings': {
        entrypoint: (0, $grjK4.slaConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fh0ov.AiRovoSlaNudgesProvider), null))
    },
    'global-settings-issues-types-view': {
        entrypoint: (0, $kKl8x.globalWorkTypesSettingsConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jo2lD.AiRovoNavigationNudgesProvider), null))
    },
    'project-settings-software-details': {
        entrypoint: (0, $8Gfxh.projectSettingsDetailsConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hY2b0.AiRovoProjectSettingDetailNudgesProvider), null))
    },
    'project-settings-core-details': {
        entrypoint: (0, $8Gfxh.projectSettingsDetailsConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hY2b0.AiRovoProjectSettingDetailNudgesProvider), null))
    },
    'software-list': {
        entrypoint: (0, $gx7ui.listConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jG2Pz.AiRovoAiSpaceCreationNudgesProvider), null))
    },
    'software-list-classic': {
        entrypoint: (0, $gx7ui.listConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jG2Pz.AiRovoAiSpaceCreationNudgesProvider), null))
    },
    'eoc-global-alerts': {
        entrypoint: (0, $iS5GV.issueConfigProviderEntrypoint)
    },
    'eoc-global-alert-detail': {
        entrypoint: (0, $iS5GV.issueConfigProviderEntrypoint)
    },
    'eoc-global-group-detail': {
        entrypoint: (0, $iS5GV.issueConfigProviderEntrypoint)
    },
    'jira-rovo-search': {
        entrypoint: (0, $3H4yQ.jiraRovoSearchConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9FAc3.AiRovoJiraRovoSearchNudgesProvider), null)
    },
    'jira-rovo-search-new': {
        entrypoint: (0, $3H4yQ.jiraRovoSearchConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9FAc3.AiRovoJiraRovoSearchNudgesProvider), null)
    },
    'servicedesk-schedules': {
        entrypoint: (0, $gAcCO.schedulesRovoConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gRkE6.AiRovoSchedulesNudgesProvider), null)
    },
    'servicedesk-availability': {
        entrypoint: (0, $iWZ4s.availabilityRovoConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ernnh.AiRovoAvailabilityNudgesProvider), null)
    },
    'servicedesk-capacity': {
        entrypoint: (0, $gP0xD.capacityRovoConfigProviderEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g1wUi.AiRovoCapacityNudgesProvider), null)
    }
};
const $b3d3be5505a48408$export$5312c8388b3449dd = {
    ...$b3d3be5505a48408$export$62040963369eb126,
    'software-backlog': {
        entrypoint: (0, $8GlKZ.onboardingConfigProviderBacklogEntrypoint)
    },
    'software-boards': {
        entrypoint: (0, $8pm7V.onboardingConfigProviderBoardEntrypoint)
    },
    'software-list': {
        entrypoint: (0, $fCZr8.onboardingConfigProviderListEntrypoint),
        nudges: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aCvsO.AiRovoFomoNudgeProviderDeferring), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jG2Pz.AiRovoAiSpaceCreationNudgesProvider), null))
    }
};
const $b3d3be5505a48408$var$isOpsPracticeQueuePath = (pathname)=>Boolean(pathname && /\/section\/(incidents|changes|problems|post-incident-reviews)(\/|$)/.test(pathname));
const $b3d3be5505a48408$var$getConfiguration = (routerState, isJiraOnboardingVariantEnabled)=>{
    let configurationKey = routerState.route.name;
    /**
	 * Issue view has special case handling because it can be either a standalone issue view or an embed.
	 * Handling the query parameter in case embded is not set.
	 */ if (routerState.route.name === 'issue' || routerState.route.name === 'issue-embed' || routerState.location.search.includes('selectedIssue=') || routerState.route.name === 'servicedesk-practice-custom-and-issue' && $b3d3be5505a48408$var$isOpsPracticeQueuePath(routerState.location.pathname)) configurationKey = 'issue';
    const routeToConfigProvider = isJiraOnboardingVariantEnabled ? $b3d3be5505a48408$export$5312c8388b3449dd : $b3d3be5505a48408$export$62040963369eb126;
    if (configurationKey in routeToConfigProvider && routeToConfigProvider[configurationKey]) return routeToConfigProvider[configurationKey] ?? null;
    return null;
};
const $b3d3be5505a48408$var$useIsFirstTwoWeeksWithGate = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfind-rovo-for-jira-onboarding-gate'), (0, $efR5m.useIsFirstTwoWeeks), ()=>false);
const $b3d3be5505a48408$var$useIsRovoForJiraOnboardingEnabledWithGate = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfind-rovo-for-jira-onboarding-gate'), (0, $3qMhu.useIsRovoForJiraOnboardingEnabled), (_isFirstTwoWeeks)=>false);
const $b3d3be5505a48408$export$9e6d4fc03eb3d2f1 = ()=>{
    const isFirstTwoWeeks = $b3d3be5505a48408$var$useIsFirstTwoWeeksWithGate();
    const isRovoForJiraOnboardingEligible = $b3d3be5505a48408$var$useIsRovoForJiraOnboardingEnabledWithGate(isFirstTwoWeeks);
    const [configuration, setConfiguration] = (0, $euxye.useState)(()=>{
        // return early to avoid setting the configuration before the trait information is received
        // isFirstTwoWeeks will always be false outside of experiment cohorts
        if (isFirstTwoWeeks === null && (0, $i860n.fg)('jfind-rovo-for-jira-onboarding-gate')) return null;
        return $b3d3be5505a48408$var$getConfiguration((0, $f2wVS.getRouterState)(), isRovoForJiraOnboardingEligible);
    });
    (0, $euxye.useEffect)(()=>{
        if ((0, $i860n.fg)('jfind-rovo-for-jira-onboarding-gate')) {
            // Still loading traits — don't set configuration or register listener yet
            if (isFirstTwoWeeks === null) return;
            // Always set configuration for the current page once traits have settled
            setConfiguration($b3d3be5505a48408$var$getConfiguration((0, $f2wVS.getRouterState)(), isRovoForJiraOnboardingEligible));
        }
        const unsubscribe = (0, $f2wVS.addRouteListener)((route)=>{
            setConfiguration($b3d3be5505a48408$var$getConfiguration(route, isRovoForJiraOnboardingEligible));
        });
        return ()=>unsubscribe();
    }, [
        isRovoForJiraOnboardingEligible,
        isFirstTwoWeeks
    ]);
    return configuration;
};

});
parcelRegister("hSC0O", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogConfigProviderEntrypoint", () => $40dbd9a0764d6a8f$export$58058f0aad5fa200);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $40dbd9a0764d6a8f$export$58058f0aad5fa200 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("awM4G")), {
        moduleId: "ea498b12",
        moduleName: "SoftwareBacklogConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("awM4G", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5CaMO").then(()=>parcelRequire('kKd8N'));

});


parcelRegister("1nQzh", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailConfigProviderEntrypoint", () => $c9494521b2d5af03$export$9928528a76670b31);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $c9494521b2d5af03$export$9928528a76670b31 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("aW0cK")), {
        moduleId: "5678fe42",
        moduleName: "SoftwareVersionDetailConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aW0cK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7n8JZ").then(()=>parcelRequire('i87vQ'));

});


parcelRegister("kOCy5", function(module, exports) {
$parcel$export(module.exports, "projectVersionsConfigProviderEntrypoint", () => $9f968e6ec8811029$export$b714206f307b4f46);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $9f968e6ec8811029$export$b714206f307b4f46 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("76hEG")), {
        moduleId: "f22de705",
        moduleName: "ProjectVersionsConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("76hEG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eGVoh").then(()=>parcelRequire('hvStN'));

});


parcelRegister("iS5GV", function(module, exports) {
$parcel$export(module.exports, "issueConfigProviderEntrypoint", () => $269a5cf6e69a7646$export$95bb315e7380f48d);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $269a5cf6e69a7646$export$95bb315e7380f48d = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("4Rtt7")), {
        moduleId: "6d4e7817",
        moduleName: "IssueConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4Rtt7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1KLrS").then(()=>parcelRequire('8vlCS'));

});


parcelRegister("jjL4e", function(module, exports) {
$parcel$export(module.exports, "planTimelineConfigProviderEntrypoint", () => $22eb132270b05fd2$export$e5b98c2a5d0fe07b);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $22eb132270b05fd2$export$e5b98c2a5d0fe07b = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("lBhWg")), {
        moduleId: "58b48914",
        moduleName: "PlanTimelineConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lBhWg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gfcPl").then(()=>parcelRequire('3Nloy'));

});


parcelRegister("kKl8x", function(module, exports) {
$parcel$export(module.exports, "globalWorkTypesSettingsConfigProviderEntrypoint", () => $37adbf319c56f45d$export$32257141d7130a81);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $37adbf319c56f45d$export$32257141d7130a81 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("gU9pP")), {
        moduleId: "98c0b6cc",
        moduleName: "GlobalWorkTypesSettingsConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gU9pP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("a2tiY").then(()=>parcelRequire('b2I8q'));

});


parcelRegister("UNfHf", function(module, exports) {
$parcel$export(module.exports, "permissionsConfigProviderEntrypoint", () => $1b497fa1967866de$export$1ff2f1f2ed62d665);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $1b497fa1967866de$export$1ff2f1f2ed62d665 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("7JtAL"))), {
        moduleId: "a375d254",
        moduleName: "PermissionsConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7JtAL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "whoCanAccessSpaceWhatRolesPrompt", () => $c1c670f1fe06f9f5$export$e585a4e6449aabc7);
$parcel$export(module.exports, "whyUserCannotViewEditWorkItemsPrompt", () => $c1c670f1fe06f9f5$export$47e534c7deef1fb0);
$parcel$export(module.exports, "whoHasSpaceAdminOrManageSprintsPermissionsPrompt", () => $c1c670f1fe06f9f5$export$e8a1a99a16e57681);
$parcel$export(module.exports, "PermissionsConfigProvider", () => $c1c670f1fe06f9f5$export$8135c81a642b3989);
$parcel$export(module.exports, "PermissionsConfigProviderEntry", () => $c1c670f1fe06f9f5$export$a5cd88983b4c5996);
$parcel$export(module.exports, "default", () => $c1c670f1fe06f9f5$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/no-export-define-message */ 
var $euxye = parcelRequire("euxye");

var $kJM81 = parcelRequire("kJM81");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $50DkA = parcelRequire("50DkA");

var $aN5aG = parcelRequire("aN5aG");
const $c1c670f1fe06f9f5$export$e585a4e6449aabc7 = (0, $7eNDO.defineMessage)({
    defaultMessage: "Who can access this space and what roles do they have?",
    id: "ai-rovo.permissions.who-can-access-space-what-roles"
});
const $c1c670f1fe06f9f5$export$47e534c7deef1fb0 = (0, $7eNDO.defineMessage)({
    defaultMessage: "Why can't a user view or edit work items in this space?",
    id: "ai-rovo.permissions.why-user-cannot-view-edit-work-items"
});
const $c1c670f1fe06f9f5$export$e8a1a99a16e57681 = (0, $7eNDO.defineMessage)({
    defaultMessage: "Who has space admin or sprint management permissions?",
    id: "ai-rovo.permissions.who-has-space-admin-sprint-management-permissions"
});
const $c1c670f1fe06f9f5$export$8135c81a642b3989 = ({ setConfiguration: setConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { formatExplicitPermissionsSkillPrompt: formatExplicitPermissionsSkillPrompt } = (0, $aN5aG.useExplicitPermissionsSkillPrompt)();
    const config = (0, $euxye.useMemo)(()=>{
        return {
            getActions: async ()=>{
                const actions = [
                    {
                        action: {
                            id: 'who-can-access-space-what-roles',
                            title: formatMessage($c1c670f1fe06f9f5$export$e585a4e6449aabc7),
                            staticPrompt: formatExplicitPermissionsSkillPrompt($c1c670f1fe06f9f5$export$e585a4e6449aabc7),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                                    label: "",
                                    color: "var(--ds-icon, #292A2E)"
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    },
                    {
                        action: {
                            id: 'why-user-cannot-view-edit-work-items',
                            title: formatMessage($c1c670f1fe06f9f5$export$47e534c7deef1fb0),
                            staticPrompt: formatExplicitPermissionsSkillPrompt($c1c670f1fe06f9f5$export$47e534c7deef1fb0),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                                    label: "",
                                    color: "var(--ds-icon, #292A2E)"
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    },
                    {
                        action: {
                            id: 'who-has-space-admin-sprint-management-permissions',
                            title: formatMessage($c1c670f1fe06f9f5$export$e8a1a99a16e57681),
                            staticPrompt: formatExplicitPermissionsSkillPrompt($c1c670f1fe06f9f5$export$e8a1a99a16e57681),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                                    label: "",
                                    color: "var(--ds-icon, #292A2E)"
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    }
                ];
                return Promise.all(actions.map(async ({ action: action, entryPointActions: entryPointActions })=>{
                    await entryPointActions?.load();
                    return action;
                }));
            },
            tags: {
                skillRegistryTags: [
                    'jira-permissions'
                ]
            }
        };
    }, [
        formatMessage,
        formatExplicitPermissionsSkillPrompt
    ]);
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};
$c1c670f1fe06f9f5$export$8135c81a642b3989.displayName = "PermissionsConfigProvider";
const $c1c670f1fe06f9f5$export$a5cd88983b4c5996 = ({ props: { setConfiguration: setConfiguration } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c1c670f1fe06f9f5$export$8135c81a642b3989, {
        setConfiguration: setConfiguration
    });
$c1c670f1fe06f9f5$export$a5cd88983b4c5996.displayName = "PermissionsConfigProviderEntry";
var $c1c670f1fe06f9f5$export$2e2bcd8739ae039 = $c1c670f1fe06f9f5$export$a5cd88983b4c5996;

});
parcelRegister("kJM81", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbcf1d1b12cba221f9c450106ed39371>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f18d57ebdda5b260$var$_react = $f18d57ebdda5b260$var$_interopRequireDefault((parcelRequire("euxye")));

var $f18d57ebdda5b260$var$_baseNew = $f18d57ebdda5b260$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $f18d57ebdda5b260$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f18d57ebdda5b260$var$AiChatIcon = (props)=>/*#__PURE__*/ $f18d57ebdda5b260$var$_react.default.createElement($f18d57ebdda5b260$var$_baseNew.default, Object.assign({
        name: "AiChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$f18d57ebdda5b260$var$AiChatIcon.displayName = 'AiChatIcon';
var $f18d57ebdda5b260$var$_default = module.exports.default = $f18d57ebdda5b260$var$AiChatIcon;

});

parcelRegister("aN5aG", function(module, exports) {
$parcel$export(module.exports, "useExplicitPermissionsSkillPrompt", () => $50600ff9a50f62e0$export$d7965dda6df79c42);

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");
const $50600ff9a50f62e0$export$d7965dda6df79c42 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const formatExplicitPermissionsSkillPrompt = (0, $euxye.useCallback)((message)=>{
        return `/manage-jira-permissions ${formatMessage(message)}`;
    }, [
        formatMessage
    ]);
    return {
        formatExplicitPermissionsSkillPrompt: formatExplicitPermissionsSkillPrompt
    };
};

});



parcelRegister("grjK4", function(module, exports) {
$parcel$export(module.exports, "slaConfigProviderEntrypoint", () => $86ec96df4dee3bf4$export$b90328b21d3610fd);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $86ec96df4dee3bf4$export$b90328b21d3610fd = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("8exkr"))), {
        moduleId: "7275c7c2",
        moduleName: "SlaConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8exkr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "createServicedeskSlaPrompt", () => $65c98f03fe2998be$export$8725ee41d9adb4e);
$parcel$export(module.exports, "updateServicedeskSlaPrompt", () => $65c98f03fe2998be$export$d8fb0ab73c904c7f);
$parcel$export(module.exports, "getServicedeskSlaPrompt", () => $65c98f03fe2998be$export$2280388f155f5bc2);
$parcel$export(module.exports, "useSlaConfig", () => $65c98f03fe2998be$export$1e44f2e27ae155f8);
$parcel$export(module.exports, "SlaConfigProvider", () => $65c98f03fe2998be$export$bedf7a38ee804b7f);
$parcel$export(module.exports, "SlaConfigProviderEntry", () => $65c98f03fe2998be$export$ff39c9c674215325);
$parcel$export(module.exports, "default", () => $65c98f03fe2998be$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/no-export-define-message */ 
var $euxye = parcelRequire("euxye");

var $jRVsm = parcelRequire("jRVsm");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $50DkA = parcelRequire("50DkA");

var $86fWu = parcelRequire("86fWu");
const $65c98f03fe2998be$export$8725ee41d9adb4e = (0, $7eNDO.defineMessage)({
    defaultMessage: "Add SLA",
    id: "ai-rovo.permissions.create-servicedesk-sla"
});
const $65c98f03fe2998be$export$d8fb0ab73c904c7f = (0, $7eNDO.defineMessage)({
    defaultMessage: "Modify SLA",
    id: "ai-rovo.permissions.update-servicedesk-sla"
});
const $65c98f03fe2998be$export$2280388f155f5bc2 = (0, $7eNDO.defineMessage)({
    defaultMessage: "Explain SLAs in this space",
    id: "ai-rovo.permissions.get-servicedesk-sla"
});
const $65c98f03fe2998be$export$1e44f2e27ae155f8 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { formatCreateSlaSkillPrompt: formatCreateSlaSkillPrompt, formatEditSlaSkillPrompt: formatEditSlaSkillPrompt, formatGetAllSlaSkillPrompt: formatGetAllSlaSkillPrompt } = (0, $86fWu.useServicedeskSlaSkillPrompt)();
    return (0, $euxye.useMemo)(()=>({
            getActions: async ()=>{
                if (!(0, $i860n.fg)('jmb-4989_add_sla_operations_in_rovo')) return [];
                const actions = [
                    {
                        action: {
                            id: 'create-servicedesk-sla',
                            title: formatMessage($65c98f03fe2998be$export$8725ee41d9adb4e),
                            staticPrompt: formatCreateSlaSkillPrompt($65c98f03fe2998be$export$8725ee41d9adb4e),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                    label: ""
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    },
                    {
                        action: {
                            id: 'update-servicedesk-sla',
                            title: formatMessage($65c98f03fe2998be$export$d8fb0ab73c904c7f),
                            staticPrompt: formatEditSlaSkillPrompt($65c98f03fe2998be$export$d8fb0ab73c904c7f),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                    label: ""
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    },
                    {
                        action: {
                            id: 'get-servicedesk-sla',
                            title: formatMessage($65c98f03fe2998be$export$2280388f155f5bc2),
                            staticPrompt: formatGetAllSlaSkillPrompt($65c98f03fe2998be$export$2280388f155f5bc2),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                    label: ""
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    }
                ];
                return Promise.all(actions.map(async ({ action: action, entryPointActions: entryPointActions })=>{
                    await entryPointActions?.load();
                    return action;
                }));
            },
            tags: (0, $i860n.fg)('jmb-4989_add_sla_operations_in_rovo') ? {
                skillRegistryTags: [
                    'manage-sla'
                ]
            } : {
                skillRegistryTags: []
            }
        }), [
        formatMessage,
        formatCreateSlaSkillPrompt,
        formatEditSlaSkillPrompt,
        formatGetAllSlaSkillPrompt
    ]);
};
const $65c98f03fe2998be$export$bedf7a38ee804b7f = ({ setConfiguration: setConfiguration })=>{
    const config = $65c98f03fe2998be$export$1e44f2e27ae155f8();
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};
$65c98f03fe2998be$export$bedf7a38ee804b7f.displayName = "SlaConfigProvider";
const $65c98f03fe2998be$export$ff39c9c674215325 = ({ props: { setConfiguration: setConfiguration } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($65c98f03fe2998be$export$bedf7a38ee804b7f, {
        setConfiguration: setConfiguration
    });
$65c98f03fe2998be$export$ff39c9c674215325.displayName = "SlaConfigProviderEntry";
var $65c98f03fe2998be$export$2e2bcd8739ae039 = $65c98f03fe2998be$export$ff39c9c674215325;

});
parcelRegister("86fWu", function(module, exports) {
$parcel$export(module.exports, "useServicedeskSlaSkillPrompt", () => $1336a144cc1ec3ff$export$a188ab810114ee78);

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");
const $1336a144cc1ec3ff$export$a188ab810114ee78 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const formatCreateSlaSkillPrompt = (0, $euxye.useCallback)((message)=>{
        return `/manage-sla ${formatMessage(message)}`;
    }, [
        formatMessage
    ]);
    const formatEditSlaSkillPrompt = (0, $euxye.useCallback)((message)=>{
        return `/manage-sla ${formatMessage(message)}`;
    }, [
        formatMessage
    ]);
    const formatGetAllSlaSkillPrompt = (0, $euxye.useCallback)((message)=>{
        return `/manage-sla ${formatMessage(message)}`;
    }, [
        formatMessage
    ]);
    return {
        formatCreateSlaSkillPrompt: formatCreateSlaSkillPrompt,
        formatEditSlaSkillPrompt: formatEditSlaSkillPrompt,
        formatGetAllSlaSkillPrompt: formatGetAllSlaSkillPrompt
    };
};

});



parcelRegister("lK74a", function(module, exports) {
$parcel$export(module.exports, "spacePermissionConfigProviderEntrypoint", () => $462ec56b03fcabc7$export$8c82a1ebbc54193e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $462ec56b03fcabc7$export$8c82a1ebbc54193e = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("1V1EO"))), {
        moduleId: "9a1e8ce2",
        moduleName: "SpacePermissionConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1V1EO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "whoCanBrowsePrompt", () => $4833b5e32e60765c$export$34926867290655a6);
$parcel$export(module.exports, "whoCanCreateWorkItemsPrompt", () => $4833b5e32e60765c$export$6ac9d08a00127135);
$parcel$export(module.exports, "whoHasAdministerSpacesPermissionPrompt", () => $4833b5e32e60765c$export$a8f033d5c4dee924);
$parcel$export(module.exports, "SpacePermissionConfigProvider", () => $4833b5e32e60765c$export$cf71e07da27b6360);
$parcel$export(module.exports, "SpacePermissionConfigProviderEntry", () => $4833b5e32e60765c$export$cae0976a760cbd4);
$parcel$export(module.exports, "default", () => $4833b5e32e60765c$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/no-export-define-message */ 
var $euxye = parcelRequire("euxye");

var $kJM81 = parcelRequire("kJM81");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $50DkA = parcelRequire("50DkA");

var $aN5aG = parcelRequire("aN5aG");
const $4833b5e32e60765c$export$34926867290655a6 = (0, $7eNDO.defineMessage)({
    defaultMessage: "Who can browse this space?",
    id: "ai-rovo.permissions.who-can-browse"
});
const $4833b5e32e60765c$export$6ac9d08a00127135 = (0, $7eNDO.defineMessage)({
    defaultMessage: "Who can create work items in this space?",
    id: "ai-rovo.permissions.who-can-create-work-items"
});
const $4833b5e32e60765c$export$a8f033d5c4dee924 = (0, $7eNDO.defineMessage)({
    defaultMessage: "Which users, groups or roles have the Administer Spaces permission in this space?",
    id: "ai-rovo.permissions.who-has-administer-spaces-permission"
});
const $4833b5e32e60765c$export$cf71e07da27b6360 = ({ setConfiguration: setConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { formatExplicitPermissionsSkillPrompt: formatExplicitPermissionsSkillPrompt } = (0, $aN5aG.useExplicitPermissionsSkillPrompt)();
    const config = (0, $euxye.useMemo)(()=>{
        return {
            getActions: async ()=>{
                const actions = [
                    {
                        action: {
                            id: 'who-can-browse-space',
                            title: formatMessage($4833b5e32e60765c$export$34926867290655a6),
                            staticPrompt: formatExplicitPermissionsSkillPrompt($4833b5e32e60765c$export$34926867290655a6),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                                    label: "",
                                    color: "var(--ds-icon, #292A2E)"
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    },
                    {
                        action: {
                            id: 'who-can-create-work-items',
                            title: formatMessage($4833b5e32e60765c$export$6ac9d08a00127135),
                            staticPrompt: formatExplicitPermissionsSkillPrompt($4833b5e32e60765c$export$6ac9d08a00127135),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                                    label: "",
                                    color: "var(--ds-icon, #292A2E)"
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    },
                    {
                        action: {
                            id: 'who-has-administer-spaces-permission',
                            title: formatMessage($4833b5e32e60765c$export$a8f033d5c4dee924),
                            staticPrompt: formatExplicitPermissionsSkillPrompt($4833b5e32e60765c$export$a8f033d5c4dee924),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                                    label: "",
                                    color: "var(--ds-icon, #292A2E)"
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    }
                ];
                return Promise.all(actions.map(async ({ action: action, entryPointActions: entryPointActions })=>{
                    await entryPointActions?.load();
                    return action;
                }));
            },
            tags: {
                skillRegistryTags: [
                    'jira-permissions'
                ]
            }
        };
    }, [
        formatMessage,
        formatExplicitPermissionsSkillPrompt
    ]);
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};
$4833b5e32e60765c$export$cf71e07da27b6360.displayName = "SpacePermissionConfigProvider";
const $4833b5e32e60765c$export$cae0976a760cbd4 = ({ props: { setConfiguration: setConfiguration } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4833b5e32e60765c$export$cf71e07da27b6360, {
        setConfiguration: setConfiguration
    });
$4833b5e32e60765c$export$cae0976a760cbd4.displayName = "SpacePermissionConfigProviderEntry";
var $4833b5e32e60765c$export$2e2bcd8739ae039 = $4833b5e32e60765c$export$cae0976a760cbd4;

});


parcelRegister("8Gfxh", function(module, exports) {
$parcel$export(module.exports, "projectSettingsDetailsConfigProviderEntrypoint", () => $31c283d0ad8f9c14$export$fb337e76d874c3d9);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $31c283d0ad8f9c14$export$fb337e76d874c3d9 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("kJ0n5")), {
        moduleId: "d3ff209a",
        moduleName: "ProjectSettingsDetailsConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kJ0n5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dlcXR").then(()=>parcelRequire('edryX'));

});


parcelRegister("gx7ui", function(module, exports) {
$parcel$export(module.exports, "listConfigProviderEntrypoint", () => $af6f1b2681043b4b$export$4fc17dcdea118744);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $af6f1b2681043b4b$export$4fc17dcdea118744 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8BMiL")), {
        moduleId: "1525feff",
        moduleName: "ListConfigProvider",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8BMiL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cjZPe").then(()=>parcelRequire('GlmPU'));

});


parcelRegister("fCZr8", function(module, exports) {
$parcel$export(module.exports, "onboardingConfigProviderListEntrypoint", () => $acc6c27938d91284$export$9c0d7ae20cf06c6f);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $acc6c27938d91284$export$9c0d7ae20cf06c6f = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("jxPem")), {
        moduleId: "dd85821f",
        moduleName: "OnboardingConfigProviderListEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jxPem", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("84A3l").then(()=>parcelRequire('iIKuj'));

});


parcelRegister("8pm7V", function(module, exports) {
$parcel$export(module.exports, "onboardingConfigProviderBoardEntrypoint", () => $d1ba21e5734a79e1$export$758675243657887e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $d1ba21e5734a79e1$export$758675243657887e = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("4hL8U")), {
        moduleId: "657e5ac7",
        moduleName: "OnboardingConfigProviderBoardEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4hL8U", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9B0Gg").then(()=>parcelRequire('cGsqs'));

});


parcelRegister("8GlKZ", function(module, exports) {
$parcel$export(module.exports, "onboardingConfigProviderBacklogEntrypoint", () => $ee7375025ebcd16c$export$a774e6a6648c3adb);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ee7375025ebcd16c$export$a774e6a6648c3adb = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("dW5J4")), {
        moduleId: "d9451c2c",
        moduleName: "OnboardingConfigProviderBacklogEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dW5J4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4xRXh").then(()=>parcelRequire('6Wn1p'));

});


parcelRegister("3H4yQ", function(module, exports) {
$parcel$export(module.exports, "jiraRovoSearchConfigProviderEntrypoint", () => $0eb7b54e5fa36a60$export$104814ab1d49bf2b);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $0eb7b54e5fa36a60$export$104814ab1d49bf2b = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8JtlB")), {
        moduleId: "8d084341",
        moduleName: "JiraRovoSearchConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8JtlB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("diovB").then(()=>parcelRequire('dMWbz'));

});


parcelRegister("gAcCO", function(module, exports) {
$parcel$export(module.exports, "schedulesRovoConfigProviderEntrypoint", () => $4f66bf75fc6353ea$export$1789446414849421);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $4f66bf75fc6353ea$export$1789446414849421 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("k98ta"))), {
        moduleId: "1b254d81",
        moduleName: "SchedulesRovoConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("k98ta", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "useSchedulesRovoConfig", () => $38142d356bbf6740$export$b1ae79d7f53da994);
$parcel$export(module.exports, "SchedulesRovoConfigProvider", () => $38142d356bbf6740$export$a50be0a11a8e0c8b);
$parcel$export(module.exports, "SchedulesRovoConfigProviderEntry", () => $38142d356bbf6740$export$949a4f1c1e121b73);
$parcel$export(module.exports, "default", () => $38142d356bbf6740$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jRVsm = parcelRequire("jRVsm");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");

var $50DkA = parcelRequire("50DkA");

var $hS241 = parcelRequire("hS241");
const $38142d356bbf6740$var$explainSchedulesPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "Explain the schedules for this week",
    id: "servicedesk-schedules.rovo.explain-schedules"
});
const $38142d356bbf6740$var$findCoverageGapsPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "Scan schedules and list coverage gaps",
    id: "servicedesk-schedules.rovo.find-coverage-gaps"
});
const $38142d356bbf6740$var$viewMyShiftsPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "Show my shifts for the visible date range and flag any conflicting shifts",
    id: "servicedesk-schedules.rovo.view-my-shifts"
});
const $38142d356bbf6740$var$deleteMyShiftPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "Delete my shift for ",
    id: "servicedesk-schedules.rovo.delete-my-shift"
});
const $38142d356bbf6740$export$b1ae79d7f53da994 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { formatWfmSkillPrompt: formatWfmSkillPrompt } = (0, $hS241.useWfmSkillPrompt)();
    return (0, $euxye.useMemo)(()=>({
            getActions: async ()=>{
                if (!(0, $2700E.expVal)('jsm-workforce-skill-experiment', 'isEnabled', false)) return [];
                const actions = [
                    {
                        action: {
                            id: 'wfm-explain-schedules',
                            title: formatMessage($38142d356bbf6740$var$explainSchedulesPrompt),
                            staticPrompt: formatWfmSkillPrompt($38142d356bbf6740$var$explainSchedulesPrompt),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                    label: ""
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    }
                ];
                actions.push({
                    action: {
                        id: 'wfm-find-coverage-gaps',
                        title: formatMessage($38142d356bbf6740$var$findCoverageGapsPrompt),
                        staticPrompt: formatWfmSkillPrompt($38142d356bbf6740$var$findCoverageGapsPrompt),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                label: ""
                            }),
                        handleType: (0, $50DkA.HandleActionType).Skill
                    }
                });
                actions.push({
                    action: {
                        id: 'wfm-view-my-shifts',
                        title: formatMessage($38142d356bbf6740$var$viewMyShiftsPrompt),
                        staticPrompt: formatWfmSkillPrompt($38142d356bbf6740$var$viewMyShiftsPrompt),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                label: ""
                            }),
                        handleType: (0, $50DkA.HandleActionType).Skill
                    }
                });
                actions.push({
                    action: {
                        id: 'wfm-delete-my-shift',
                        title: formatMessage($38142d356bbf6740$var$deleteMyShiftPrompt),
                        // Write action: pre-fill the chat input (not auto-send) so the user can
                        // complete the prompt with the specific date range / team before sending.
                        dynamicPrompt: formatWfmSkillPrompt($38142d356bbf6740$var$deleteMyShiftPrompt),
                        encodeDynamicPromptAsSkill: true,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                label: ""
                            }),
                        handleType: (0, $50DkA.HandleActionType).Chat
                    }
                });
                return Promise.all(actions.map(async ({ action: action, entryPointActions: entryPointActions })=>{
                    await entryPointActions?.load();
                    return action;
                }));
            },
            tags: (0, $2700E.expVal)('jsm-workforce-skill-experiment', 'isEnabled', false) ? {
                skillRegistryTags: [
                    'manage-workforce'
                ]
            } : {
                skillRegistryTags: []
            }
        }), [
        formatMessage,
        formatWfmSkillPrompt
    ]);
};
const $38142d356bbf6740$export$a50be0a11a8e0c8b = ({ setConfiguration: setConfiguration })=>{
    const config = $38142d356bbf6740$export$b1ae79d7f53da994();
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};
$38142d356bbf6740$export$a50be0a11a8e0c8b.displayName = "SchedulesRovoConfigProvider";
const $38142d356bbf6740$export$949a4f1c1e121b73 = ({ props: { setConfiguration: setConfiguration } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($38142d356bbf6740$export$a50be0a11a8e0c8b, {
        setConfiguration: setConfiguration
    });
$38142d356bbf6740$export$949a4f1c1e121b73.displayName = "SchedulesRovoConfigProviderEntry";
var $38142d356bbf6740$export$2e2bcd8739ae039 = $38142d356bbf6740$export$949a4f1c1e121b73;

});
parcelRegister("hS241", function(module, exports) {
$parcel$export(module.exports, "useWfmSkillPrompt", () => $a2fe9d2e6aff69fa$export$f3976dae1e5369a4);

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");
const $a2fe9d2e6aff69fa$var$WFM_SKILL_COMMAND = '/manage-workforce';
const $a2fe9d2e6aff69fa$export$f3976dae1e5369a4 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const formatWfmSkillPrompt = (0, $euxye.useCallback)((message)=>{
        return `${$a2fe9d2e6aff69fa$var$WFM_SKILL_COMMAND} ${formatMessage(message)}`;
    }, [
        formatMessage
    ]);
    return {
        formatWfmSkillPrompt: formatWfmSkillPrompt
    };
};

});



parcelRegister("iWZ4s", function(module, exports) {
$parcel$export(module.exports, "availabilityRovoConfigProviderEntrypoint", () => $7f2b9aef7bb272b4$export$e95c939bc5313799);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $7f2b9aef7bb272b4$export$e95c939bc5313799 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("a1Lmx"))), {
        moduleId: "c6cc1377",
        moduleName: "AvailabilityRovoConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("a1Lmx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "useAvailabilityRovoConfig", () => $8d1f3ac3a1bae7cb$export$8d4bb89bd64867b2);
$parcel$export(module.exports, "AvailabilityRovoConfigProvider", () => $8d1f3ac3a1bae7cb$export$cc4ebf94d1d62a8b);
$parcel$export(module.exports, "AvailabilityRovoConfigProviderEntry", () => $8d1f3ac3a1bae7cb$export$a96047cf41105935);
$parcel$export(module.exports, "default", () => $8d1f3ac3a1bae7cb$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jRVsm = parcelRequire("jRVsm");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");

var $50DkA = parcelRequire("50DkA");

var $2gLDn = parcelRequire("2gLDn");

var $hS241 = parcelRequire("hS241");
const $8d1f3ac3a1bae7cb$var$viewMyStatusPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "Show my current availability status",
    id: "servicedesk-availability.rovo.view-my-status"
});
const $8d1f3ac3a1bae7cb$var$listUnavailableAgentsPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "List agents who are currently unavailable",
    id: "servicedesk-availability.rovo.list-unavailable-agents"
});
const $8d1f3ac3a1bae7cb$var$updateMyStatusPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "Update my availability status to ",
    id: "servicedesk-availability.rovo.update-my-status"
});
const $8d1f3ac3a1bae7cb$export$8d4bb89bd64867b2 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { formatWfmSkillPrompt: formatWfmSkillPrompt } = (0, $hS241.useWfmSkillPrompt)();
    const isProjectAdmin = (0, $2gLDn.useIsProjectAdmin)();
    return (0, $euxye.useMemo)(()=>({
            getActions: async ()=>{
                if (!(0, $2700E.expVal)('jsm-workforce-skill-experiment', 'isEnabled', false)) return [];
                const actions = [];
                actions.push({
                    action: {
                        id: 'wfm-view-my-status',
                        title: formatMessage($8d1f3ac3a1bae7cb$var$viewMyStatusPrompt),
                        staticPrompt: formatWfmSkillPrompt($8d1f3ac3a1bae7cb$var$viewMyStatusPrompt),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                label: ""
                            }),
                        handleType: (0, $50DkA.HandleActionType).Skill
                    }
                });
                if (isProjectAdmin) actions.push({
                    action: {
                        id: 'wfm-list-unavailable-agents',
                        title: formatMessage($8d1f3ac3a1bae7cb$var$listUnavailableAgentsPrompt),
                        staticPrompt: formatWfmSkillPrompt($8d1f3ac3a1bae7cb$var$listUnavailableAgentsPrompt),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                label: ""
                            }),
                        handleType: (0, $50DkA.HandleActionType).Skill
                    }
                });
                actions.push({
                    action: {
                        id: 'wfm-update-my-status',
                        title: formatMessage($8d1f3ac3a1bae7cb$var$updateMyStatusPrompt),
                        // Write action: pre-fill the chat input (not auto-send) so the user can
                        // complete the prompt with the desired status before sending.
                        dynamicPrompt: formatWfmSkillPrompt($8d1f3ac3a1bae7cb$var$updateMyStatusPrompt),
                        encodeDynamicPromptAsSkill: true,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                label: ""
                            }),
                        handleType: (0, $50DkA.HandleActionType).Chat
                    }
                });
                return Promise.all(actions.map(async ({ action: action, entryPointActions: entryPointActions })=>{
                    await entryPointActions?.load();
                    return action;
                }));
            },
            tags: (0, $2700E.expVal)('jsm-workforce-skill-experiment', 'isEnabled', false) ? {
                skillRegistryTags: [
                    'manage-workforce'
                ]
            } : {
                skillRegistryTags: []
            }
        }), [
        formatMessage,
        formatWfmSkillPrompt,
        isProjectAdmin
    ]);
};
const $8d1f3ac3a1bae7cb$export$cc4ebf94d1d62a8b = ({ setConfiguration: setConfiguration })=>{
    const config = $8d1f3ac3a1bae7cb$export$8d4bb89bd64867b2();
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};
$8d1f3ac3a1bae7cb$export$cc4ebf94d1d62a8b.displayName = "AvailabilityRovoConfigProvider";
const $8d1f3ac3a1bae7cb$export$a96047cf41105935 = ({ props: { setConfiguration: setConfiguration } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8d1f3ac3a1bae7cb$export$cc4ebf94d1d62a8b, {
        setConfiguration: setConfiguration
    });
$8d1f3ac3a1bae7cb$export$a96047cf41105935.displayName = "AvailabilityRovoConfigProviderEntry";
var $8d1f3ac3a1bae7cb$export$2e2bcd8739ae039 = $8d1f3ac3a1bae7cb$export$a96047cf41105935;

});
parcelRegister("2gLDn", function(module, exports) {
$parcel$export(module.exports, "useIsProjectAdmin", () => $45fef8ea0dab9969$export$9facd8d31b938a25);

var $fNgVF = parcelRequire("fNgVF");

var $2b39L = parcelRequire("2b39L");
const $45fef8ea0dab9969$export$9facd8d31b938a25 = ()=>{
    const isJiraAdmin = (0, $fNgVF.useIsAdmin)();
    const projectContext = (0, $2b39L.useProjectContext)();
    return isJiraAdmin || projectContext?.data?.isProjectAdmin || false;
};

});



parcelRegister("gP0xD", function(module, exports) {
$parcel$export(module.exports, "capacityRovoConfigProviderEntrypoint", () => $877181239f3204b8$export$8bf7ef1b1f950080);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $877181239f3204b8$export$8bf7ef1b1f950080 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("8CoVD"))), {
        moduleId: "299d3954",
        moduleName: "CapacityRovoConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8CoVD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "useCapacityRovoConfig", () => $1ae540efa8d1f5c1$export$821adc37e7c8e08a);
$parcel$export(module.exports, "CapacityRovoConfigProvider", () => $1ae540efa8d1f5c1$export$8cafc2960b4b4f3a);
$parcel$export(module.exports, "CapacityRovoConfigProviderEntry", () => $1ae540efa8d1f5c1$export$efc5e5e011a4258e);
$parcel$export(module.exports, "default", () => $1ae540efa8d1f5c1$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $jRVsm = parcelRequire("jRVsm");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");

var $50DkA = parcelRequire("50DkA");

var $ZMGpu = parcelRequire("ZMGpu");

var $hS241 = parcelRequire("hS241");
const $1ae540efa8d1f5c1$var$listOverloadedAgentsPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "List agents who are overloaded",
    id: "servicedesk-capacity.rovo.list-overloaded-agents"
});
const $1ae540efa8d1f5c1$var$listIdleAgentsPrompt = (0, $7eNDO.defineMessage)({
    defaultMessage: "List agents who are idle",
    id: "servicedesk-capacity.rovo.list-idle-agents"
});
const $1ae540efa8d1f5c1$export$821adc37e7c8e08a = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { formatWfmSkillPrompt: formatWfmSkillPrompt } = (0, $hS241.useWfmSkillPrompt)();
    const isProjectAdmin = (0, $ZMGpu.useIsProjectAdmin)();
    return (0, $euxye.useMemo)(()=>({
            getActions: async ()=>{
                if (!(0, $2700E.expVal)('jsm-workforce-skill-experiment', 'isEnabled', false)) return [];
                const actions = [];
                if (isProjectAdmin) {
                    actions.push({
                        action: {
                            id: 'wfm-list-overloaded-agents',
                            title: formatMessage($1ae540efa8d1f5c1$var$listOverloadedAgentsPrompt),
                            staticPrompt: formatWfmSkillPrompt($1ae540efa8d1f5c1$var$listOverloadedAgentsPrompt),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                    label: ""
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    });
                    actions.push({
                        action: {
                            id: 'wfm-list-idle-agents',
                            title: formatMessage($1ae540efa8d1f5c1$var$listIdleAgentsPrompt),
                            staticPrompt: formatWfmSkillPrompt($1ae540efa8d1f5c1$var$listIdleAgentsPrompt),
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                                    label: ""
                                }),
                            handleType: (0, $50DkA.HandleActionType).Skill
                        }
                    });
                }
                return Promise.all(actions.map(async ({ action: action, entryPointActions: entryPointActions })=>{
                    await entryPointActions?.load();
                    return action;
                }));
            },
            tags: (0, $2700E.expVal)('jsm-workforce-skill-experiment', 'isEnabled', false) ? {
                skillRegistryTags: [
                    'manage-workforce'
                ]
            } : {
                skillRegistryTags: []
            }
        }), [
        formatMessage,
        formatWfmSkillPrompt,
        isProjectAdmin
    ]);
};
const $1ae540efa8d1f5c1$export$8cafc2960b4b4f3a = ({ setConfiguration: setConfiguration })=>{
    const config = $1ae540efa8d1f5c1$export$821adc37e7c8e08a();
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};
$1ae540efa8d1f5c1$export$8cafc2960b4b4f3a.displayName = "CapacityRovoConfigProvider";
const $1ae540efa8d1f5c1$export$efc5e5e011a4258e = ({ props: { setConfiguration: setConfiguration } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1ae540efa8d1f5c1$export$8cafc2960b4b4f3a, {
        setConfiguration: setConfiguration
    });
$1ae540efa8d1f5c1$export$efc5e5e011a4258e.displayName = "CapacityRovoConfigProviderEntry";
var $1ae540efa8d1f5c1$export$2e2bcd8739ae039 = $1ae540efa8d1f5c1$export$efc5e5e011a4258e;

});
parcelRegister("ZMGpu", function(module, exports) {
$parcel$export(module.exports, "useIsProjectAdmin", () => $65b1548e2fc3ba5e$export$9facd8d31b938a25);

var $fNgVF = parcelRequire("fNgVF");

var $2b39L = parcelRequire("2b39L");
const $65b1548e2fc3ba5e$export$9facd8d31b938a25 = ()=>{
    const isJiraAdmin = (0, $fNgVF.useIsAdmin)();
    const projectContext = (0, $2b39L.useProjectContext)();
    return isJiraAdmin || projectContext?.data?.isProjectAdmin || false;
};

});



parcelRegister("cJCzP", function(module, exports) {
$parcel$export(module.exports, "requestTypesConfigProviderEntrypoint", () => $663a1bb5dc44965d$export$e0fcf9c371712cf6);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $663a1bb5dc44965d$export$e0fcf9c371712cf6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8FqyB")), {
        moduleId: "86c5985c",
        moduleName: "RequestTypesConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8FqyB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8UAgn").then(()=>parcelRequire('6nZVV'));

});


parcelRegister("vH5rG", function(module, exports) {
$parcel$export(module.exports, "queuesConfigProviderEntrypoint", () => $57b162b64f2d59b4$export$54b1ff8238c84363);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $57b162b64f2d59b4$export$54b1ff8238c84363 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8A8jc")), {
        moduleId: "072f3205",
        moduleName: "QueuesConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8A8jc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6tWaB").then(()=>parcelRequire('2FVk4'));

});


parcelRegister("kaeuE", function(module, exports) {
$parcel$export(module.exports, "slaGsConfigProviderEntrypoint", () => $de46bdd40ce3e36e$export$6fc5ba62e2d11dea);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $de46bdd40ce3e36e$export$6fc5ba62e2d11dea = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("7Jka4")), {
        moduleId: "81340f6a",
        moduleName: "SlaConfigProviderEntry",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7Jka4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1gBx8").then(()=>parcelRequire('8weBp'));

});


parcelRegister("efR5m", function(module, exports) {
$parcel$export(module.exports, "useIsFirstTwoWeeks", () => $4340eae028b42825$export$eb02351f99866e25);

var $euxye = parcelRequire("euxye");

var $kt86l = parcelRequire("kt86l");

var $40jii = parcelRequire("40jii");
const $4340eae028b42825$var$JSW_ACTIVATION_DATE_TRAIT = 'jira-software.ondemand.activationDate';
const $4340eae028b42825$var$TWO_WEEKS_IN_MS = 1209600000;
const $4340eae028b42825$export$a9ae06738aa8e2cb = (site)=>{
    if (!site.loaded) return false;
    const activationDate = site.attributes?.find((t)=>t.name === $4340eae028b42825$var$JSW_ACTIVATION_DATE_TRAIT)?.value;
    if (!activationDate || typeof activationDate !== 'string') return false;
    const activation = new Date(activationDate);
    if (Number.isNaN(activation.getTime())) return false;
    const twoWeeksAfterActivation = new Date(activation.getTime() + $4340eae028b42825$var$TWO_WEEKS_IN_MS);
    return new Date() <= twoWeeksAfterActivation;
};
const $4340eae028b42825$export$eb02351f99866e25 = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { fetchTraits: fetchTraits } = (0, $40jii.useTraitsActions)();
    const [traitState] = (0, $40jii.useTraits)();
    const isSiteLoaded = traitState.SITE.loaded;
    (0, $euxye.useEffect)(()=>{
        fetchTraits([
            'SITE'
        ], {
            cloudId: cloudId
        });
    }, [
        cloudId,
        fetchTraits
    ]);
    if (!isSiteLoaded) return null;
    return $4340eae028b42825$export$a9ae06738aa8e2cb(traitState.SITE);
};

});

parcelRegister("aCvsO", function(module, exports) {
$parcel$export(module.exports, "AiRovoFomoNudgeProviderDeferring", () => $8aff95160deb907d$export$7cb055581cefebbf);

var $euxye = parcelRequire("euxye");

var $4fPPi = parcelRequire("4fPPi");

var $2700E = parcelRequire("2700E");

var $1YIbA = parcelRequire("1YIbA");

var $hFtK7 = parcelRequire("hFtK7");

var $bWZpq = parcelRequire("bWZpq");

var $jepRN = parcelRequire("jepRN");


var $ggPTE = parcelRequire("ggPTE");

var $dRjpK = parcelRequire("dRjpK");

var $gnyTi = parcelRequire("gnyTi");

var $1Fqw0 = parcelRequire("1Fqw0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $cD7wY = parcelRequire("cD7wY");

var $cO03t = parcelRequire("cO03t");

var $jCv3W = parcelRequire("jCv3W");
/** localStorage key for the FOMO nudge "shown once" guard. Registered in atlassian-cookies (ENDS_WITH pattern). */ const $8aff95160deb907d$var$FOMO_NUDGE_DISMISSED_KEY = 'rovo.fomo.nudge.dismissed';
/** How long to suppress the FOMO nudge after the user clicks or dismisses it (14 days). */ const $8aff95160deb907d$var$FOMO_NUDGE_SUPPRESSION_DURATION_MS = 1209600000;
/**
 * Jira localStorage-backed FomoNudgeStorage adapter.
 *
 * Uses AtlBrowserStorageLocal (from @atlassian/browser-storage-controls) so
 * the key is subject to the browser-storage consent registry. Errors are
 * reported via fireErrorAnalytics per Jira convention.
 */ const $8aff95160deb907d$var$jiraFomoNudgeMarkShown = ()=>{
    // @browser-storage setter
    (0, $4fPPi.AtlBrowserStorageLocal).setItem($8aff95160deb907d$var$FOMO_NUDGE_DISMISSED_KEY, String(Date.now())).then((result)=>{
        if (result && (result.status === 'ERROR' || result.status === 'FAILED' || result.status === 'BLOCKED')) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'aiRovoFomoNudge.markShown',
                packageName: 'jiraAiRovoActionsRouteProvider',
                teamName: 'Crocs'
            },
            error: 'error' in result ? result.error : new Error('Failed to persist FOMO nudge dismissal'),
            attributes: {
                operation: 'AtlBrowserStorageLocal.setItem',
                status: result.status
            }
        });
    });
};
const $8aff95160deb907d$var$jiraFomoNudgeHasBeenShown = ()=>{
    try {
        const dismissedAt = (0, $4fPPi.AtlBrowserStorageLocal).getItem($8aff95160deb907d$var$FOMO_NUDGE_DISMISSED_KEY);
        return !!dismissedAt && Date.now() - Number(dismissedAt) < $8aff95160deb907d$var$FOMO_NUDGE_SUPPRESSION_DURATION_MS;
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'aiRovoFomoNudge.hasBeenShown',
                packageName: 'jiraAiRovoActionsRouteProvider',
                teamName: 'Crocs'
            },
            error: error instanceof Error ? error : new Error('Failed to read FOMO nudge dismissal state'),
            attributes: {
                operation: 'AtlBrowserStorageLocal.getItem'
            }
        });
        return false;
    }
};
const $8aff95160deb907d$export$ef05a83fb168c656 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const hasTrackedQualificationRef = (0, $euxye.useRef)(false);
    // Cookie consent check — the hook reads the `rovo_fomo_nudge_cookie_policy_check`
    // killswitch internally. When the killswitch is on, the nudge only shows for
    // users who have consented to Functional storage. When the killswitch is off,
    // canShowFromCookiePreference is `true` immediately (legacy behavior, no network/storage check).
    // Runs before any TAP / Relay fetch so non-consenting users incur no extra
    // network requests.
    const canShowFromCookiePreference = (0, $1Fqw0.useCanShowFomoNudge)();
    // Read suppression once per render. The adapter's own try/catch +
    // fireErrorAnalytics already handles localStorage exceptions, so no extra
    // wrapper is needed here. Used to short-circuit the trait + Relay fetches
    // below so users inside the 14-day suppression window incur no network
    // requests.
    const suppressed = $8aff95160deb907d$var$jiraFomoNudgeHasBeenShown();
    const { collaboratorAaids: topCollaboratorAAIDs, isRovoChatMau: isRovoChatMau, loaded: traitsLoaded } = (0, $jCv3W.useTopRovoChatCollaboratorsTraitResource)(undefined, canShowFromCookiePreference === true && !suppressed);
    const collaboratorAccountIds = (0, $euxye.useMemo)(()=>(0, $cO03t.parseTopCollaboratorAccountIds)(topCollaboratorAAIDs), [
        topCollaboratorAAIDs
    ]);
    const { collaborators: collaborators, isReady: isReady, error: collaboratorError } = (0, $gnyTi.useFomoCollaboratorsBatched)(collaboratorAccountIds, {
        enabled: canShowFromCookiePreference === true && !suppressed && traitsLoaded && isRovoChatMau === false && collaboratorAccountIds.length > 0 && (0, $2700E.expVal)('rovo_button_collab_teammates_fomo_nudge', 'isEnabled', false)
    });
    (0, $euxye.useEffect)(()=>{
        // Bail unless: cookie consent granted, suppression window has passed, trait
        // resource has resolved, collaborator fetch ready, the user is not a Rovo
        // Chat MAU, and the user is in the experiment treatment group.
        //
        // The explicit `expVal` check here is a safety backstop: the collaborator
        // fetch's `enabled` flag already includes the same `expVal` guard, but we
        // do NOT rely on `useFomoCollaboratorsBatched` keeping `isReady === false`
        // when `enabled === false`. That contract is undocumented and out of this
        // package's control, so we re-check `expVal` here to guarantee that no
        // `traitResolved` / `collaboratorResolution failed` analytics — nor any
        // nudge mount — can ever escape to out-of-treatment users.
        if (canShowFromCookiePreference !== true || suppressed || !traitsLoaded || !isReady || isRovoChatMau !== false || !(0, $2700E.expVal)('rovo_button_collab_teammates_fomo_nudge', 'isEnabled', false)) return;
        if (!hasTrackedQualificationRef.current) {
            hasTrackedQualificationRef.current = true;
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'fomoNudge traitResolved', {
                traitName: (0, $jCv3W.TOP_ROVO_CHAT_COLLABORATORS_TRAIT),
                aaidCount: collaboratorAccountIds.length
            });
            const zeroResolved = collaboratorAccountIds.length > 0 && collaborators.length === 0;
            if (collaboratorError || zeroResolved) {
                let errorMessage;
                if (collaboratorError instanceof Error) errorMessage = collaboratorError.message;
                else if (collaboratorError) errorMessage = String(collaboratorError);
                else errorMessage = 'no collaborators resolved';
                (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fomoNudgeCollaboratorResolution failed', {
                    operation: 'fetchUsersByAaids',
                    requestedAaidCount: collaboratorAccountIds.length,
                    errorMessage: errorMessage
                });
                if (collaboratorError) (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'aiRovoFomoNudge.collaboratorResolution',
                        packageName: 'jiraAiRovoActionsRouteProvider',
                        teamName: 'crocs'
                    },
                    error: collaboratorError instanceof Error ? collaboratorError : new Error(String(collaboratorError)),
                    attributes: {
                        operation: 'fetchUsersByAaids'
                    }
                });
            }
        }
        if (collaborators.length === 0) return;
        const action = (0, $dRjpK.createFomoNudgeAction)({
            collaborators: collaborators,
            title: formatMessage((0, $ggPTE.messages).fomoNudgeTitle),
            description: formatMessage((0, $ggPTE.messages).fomoNudgeDescription),
            onAccept: $8aff95160deb907d$var$jiraFomoNudgeMarkShown,
            onDismiss: $8aff95160deb907d$var$jiraFomoNudgeMarkShown
        });
        // NOTE: route-scoped — this provider is mounted inside each Rovo-capable
        // route's `nudges: () => ...` slot in jiraRouteToConfigProvider, so unmount
        // on route change cleans up automatically. On routes that also mount another
        // nudge provider (e.g. AiRovoIssueViewNudgesProvider), the deferring
        // wrapper around this component yields when a non-self nudge is already in
        // the store. The route map MUST render this provider FIRST in the Fragment
        // so the sibling becomes the last writer; see DeferIfNudgePresent.
        updateConfiguration({
            nudges: [
                action
            ]
        });
    }, [
        canShowFromCookiePreference,
        suppressed,
        updateConfiguration,
        formatMessage,
        collaborators,
        isReady,
        createAnalyticsEvent,
        collaboratorAccountIds,
        topCollaboratorAAIDs,
        collaboratorError,
        traitsLoaded,
        isRovoChatMau
    ]);
    return null;
};
$8aff95160deb907d$export$ef05a83fb168c656.displayName = "AiRovoFomoNudgeProvider";
/** FOMO pre-wrapped to yield when another nudge is already in the store. */ const $8aff95160deb907d$var$AiRovoFomoNudgeProviderDeferringInner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cD7wY.DeferIfNudgePresent), {
        ownNudgeIds: [
            (0, $71cf770a102d4b7d$export$2f71d683d556ec71)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8aff95160deb907d$export$ef05a83fb168c656, null));
$8aff95160deb907d$var$AiRovoFomoNudgeProviderDeferringInner.displayName = "AiRovoFomoNudgeProviderDeferringInner";
const $8aff95160deb907d$export$7cb055581cefebbf = (0, $jepRN.componentWithFG)(// skillswitch gate controlled by is_rovo_chat_mau
'rovo_button_collab_teammates_fomo_nudge_enabled', $8aff95160deb907d$var$AiRovoFomoNudgeProviderDeferringInner, ()=>null);

});
/**
 * Public identifiers + content for the FOMO ("teammates using Rovo") nudge.
 *
 * Source of truth: FOMO Nudge doc (Confluence page 7094179434).
 * Consumed by both the Confluence hook (page-rovo-config-common) and the Jira
 * sibling provider (ai-rovo/actions-route-provider).
 *
 * NOTE: Statsig gate / experiment identifiers are intentionally NOT exported
 * from this package. Both `fg()` (Confluence) and `expVal()` (Jira) require
 * string literals for static analysis — consuming a variable breaks the
 * tooling. Each product uses the strings inline:
 *   gate:       'rovo_button_collab_teammates_fomo_nudge_enabled'
 *   experiment: 'rovo_button_collab_teammates_fomo_nudge' / 'isEnabled'
 */ /** Stable id used for analytics, store de-duping, and nudgeContext matching. */ const $71cf770a102d4b7d$export$2f71d683d556ec71 = 'rovo-collab-teammates-fomo-nudge';
const $71cf770a102d4b7d$export$1362ba0e5605958a = 'Based on my work, give me 3 ways Rovo can help me this week.';
const $71cf770a102d4b7d$export$774fe05d25c075a9 = 'rovo-collab-teammates-fomo-nudge:dismissed';

parcelRegister("ggPTE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9cff39d1e8930c18$export$defe85febe8b728c);
/**
 * Centralized i18n message descriptors for the FOMO nudge.
 *
 * Both products consume defineMessages output via formatMessage:
 *   - Confluence: `react-intl`
 *   - Jira: `@atlassian/jira-intl`
 *
 * Keeping copy here ensures parity across products. Phase 1 is an empty
 * placeholder so the file exists without pulling in `react-intl` yet.
 */ 
var $7eNDO = parcelRequire("7eNDO");
const $9cff39d1e8930c18$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    fomoNudgeTitle: {
        id: "rovo-fomo-nudge.title",
        defaultMessage: "Your teammates are chatting with Rovo"
    },
    fomoNudgeDescription: {
        id: "rovo-fomo-nudge.description",
        defaultMessage: "Try chat today to get quick answers and draft work fast."
    },
    fomoNudgeIconLabel: {
        id: "rovo-fomo-nudge.icon-label",
        defaultMessage: "Avatars of your collaborators using Rovo"
    }
});

});

parcelRegister("dRjpK", function(module, exports) {
$parcel$export(module.exports, "createFomoNudgeAction", () => $04a54d0117c848cb$export$b3c17769b94f96dc);
/**
 * Pure factory that returns a fully-formed ConversationAction object for the
 * FOMO ("teammates using Rovo") nudge.
 *
 * Why a factory (not a hook) at this layer?
 *   - Confluence consumes nudges as objects inside a `NudgeEntry[]`
 *     (declarative, via `useViewPageNudgeConfig`).
 *   - Jira consumes nudges by calling
 *     `updateConfiguration({ nudges: [...] })` imperatively
 *     (via `useAiRovoCurrentRouteConfigurationStoreActions`).
 *   Both surfaces can call a pure builder; only the surrounding glue differs.
 *
 * Eligibility (experiment treatment, non-Rovo-MAU TAP trait, "show once"
 * guard, launch-date scheduling via Statsig) lives in the product hooks /
 * Statsig config. This builder assumes "we've decided to show the nudge".
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $50DkA = parcelRequire("50DkA");


var $inXzV = parcelRequire("inXzV");

var $fLkdI = parcelRequire("fLkdI");
function $04a54d0117c848cb$export$b3c17769b94f96dc(ctx) {
    return {
        id: (0, $71cf770a102d4b7d$export$2f71d683d556ec71),
        title: ctx.title,
        description: ctx.description,
        icon: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $fLkdI.FomoNudgeIcon), {
                collaborators: ctx.collaborators
            }),
        handleType: (0, $50DkA.HandleActionType).Chat,
        type: 'convo-starter-action',
        staticPrompt: (0, $71cf770a102d4b7d$export$1362ba0e5605958a),
        starterType: 'static',
        secondaryTitle: ctx.description,
        customContent: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $inXzV.FomoNudgeContent), {
                collaborators: ctx.collaborators,
                title: ctx.title,
                description: ctx.description
            }),
        // ChatAction.onClick is intentionally omitted: triggerAction early-returns
        // when onClick is defined, preventing HandleActionType.Chat from opening chat.
        // Side-effects (storage, analytics, …) flow through ctx.onAccept (click-through)
        // and ctx.onDismiss (X button), each invoked by main.tsx after triggerAction.
        // Kept separate so consumers can fire distinct analytics events per outcome;
        // pass the same function to both to collapse behavior.
        nudgeContext: {
            id: (0, $71cf770a102d4b7d$export$2f71d683d556ec71),
            selfEligible: true,
            onAccept: ctx.onAccept,
            onDismiss: ctx.onDismiss
        }
    };
}

});
parcelRegister("inXzV", function(module, exports) {
$parcel$export(module.exports, "FomoNudgeContent", () => $a503315287cf1131$export$876f92013f22097a);
/* FomoNudgeContent.tsx generated by @compiled/babel-plugin v0.38.1 */ /**
 * Custom nudge content for the FOMO ("teammates using Rovo") nudge.
 *
 * Rendered via the `customContent` slot on the ConversationAction — this
 * replaces the standard icon+title layout inside the nudge pill while keeping
 * the outer pill container, dismiss button, animation, and analytics intact.
 *
 * Layout:
 *   title [👤👤👤]
 *   description (always visible)
 *
 * Both title and description are always visible (no hover required).
 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $fLkdI = parcelRequire("fLkdI");
const $a503315287cf1131$var$styles = {
    wrapper: "_y3gn1e5h _ca0q1b66 _n3td12x7 _19bvu2gc _u5f3utpp _80omtlke"
};
function $a503315287cf1131$export$876f92013f22097a({ collaborators: collaborators, title: title, description: description }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $a503315287cf1131$var$styles.wrapper
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
                    space: "space.100",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                            color: "color.text.inverse",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fLkdI.FomoNudgeIcon), {
                            collaborators: collaborators
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                    size: "small",
                    color: "color.text.inverse",
                    children: description
                })
            ]
        })
    });
}
$a503315287cf1131$export$876f92013f22097a.displayName = "FomoNudgeContent";

});
parcelRegister("fLkdI", function(module, exports) {
$parcel$export(module.exports, "FomoNudgeIcon", () => $d8ac3b2267f6d142$export$66e4706d4e7dd953);
/**
 * Avatar-stack icon rendered inline as the FOMO nudge's leading visual.
 *
 * Per the FOMO Nudge doc § "Custom Rovo Nudge UI":
 *   - shows up to 3 collaborator avatars who are Rovo Chat MAU
 *   - When collaborators is empty (Phase 2/3) or avatarUrl is null, AvatarGroup
 *     renders the default generic user avatar automatically (ADS fallback).
 *   - Phase 4: real collaborators supplied via TWG / AGG
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1qX9F = parcelRequire("1qX9F");
/** Shown when no real collaborator data is available yet (Phase 2 / Phase 3). */ const $d8ac3b2267f6d142$var$PLACEHOLDER_AVATARS = [
    {
        name: ''
    },
    {
        name: ''
    },
    {
        name: ''
    }
];
function $d8ac3b2267f6d142$export$66e4706d4e7dd953({ collaborators: collaborators }) {
    const data = collaborators.length > 0 ? collaborators.map((c)=>({
            name: c.displayName ?? '',
            src: c.avatarUrl ?? undefined
        })) : $d8ac3b2267f6d142$var$PLACEHOLDER_AVATARS;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1qX9F.default), {
        size: "small",
        maxCount: 3,
        data: data
    });
}
$d8ac3b2267f6d142$export$66e4706d4e7dd953.displayName = "FomoNudgeIcon";

});
parcelRegister("1qX9F", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5ef4528210000de$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $8z2GW = parcelRequire("8z2GW");


var $2oRWW = parcelRequire("2oRWW");

var $8xAgn = parcelRequire("8xAgn");

var $gUxVT = parcelRequire("gUxVT");

var $g36LP = parcelRequire("g36LP");

var $p9mZs = parcelRequire("p9mZs");

var $egspI = parcelRequire("egspI");

var $1CdDx = parcelRequire("1CdDx");

var $hZDXn = parcelRequire("hZDXn");

var $Ro65p = parcelRequire("Ro65p");

var $4nptA = parcelRequire("4nptA");

var $18imJ = parcelRequire("18imJ");

var $2B9F0 = parcelRequire("2B9F0");

var $eZVgc = parcelRequire("eZVgc");

var $gsyDy = parcelRequire("gsyDy");

var $fr54R = parcelRequire("fr54R");

var $1dEEK = parcelRequire("1dEEK");

var $jhCIk = parcelRequire("jhCIk");
const $a5ef4528210000de$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $a5ef4528210000de$var$AvatarGroup = ({ appearance: appearance = 'stack', moreIndicatorAppearance: moreIndicatorAppearance, avatar: avatar = (0, $8z2GW.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $euxye.useState)(false);
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const onClose = (0, $euxye.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $euxye.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $8xAgn.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $18imJ.getOverrides)(overrides);
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow.
    // Skipped when top-layer is enabled — DropdownMenu/top-layer handles
    // ArrowDown-to-open and arrow key navigation internally.
    (0, $euxye.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Top-layer path: ArrowDown-to-open is handled by the menu's
        // own focus management, so skip the parent's ArrowDown handler.
        if ((0, $egspI.fg)('platform-dst-top-layer')) return 0, $2oRWW.default;
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $2oRWW.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $2oRWW.default;
        (0, $glbdM.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $48dedd10700aff3c$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $glbdM.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $48dedd10700aff3c$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>moreIndicatorOverrides.render((0, $fr54R.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props,
                ...(0, $egspI.fg)('jira-ai-agent-stack') && {
                    appearance: moreIndicatorAppearance
                }
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $egspI.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4nptA.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        const avatarComponent = avatar && (0, $egspI.fg)('platform-avatar-group-pass-avatar-to-item') ? avatar : undefined;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1CdDx.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $eZVgc.default), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gsyDy.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g36LP.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $Ro65p.default), {
                                    avatar: avatarData,
                                    avatarComponent: avatarComponent,
                                    onAvatarClick: onAvatarClick,
                                    avatarOverrides: avatarOverrides,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>(0, $egspI.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: renderMoreButton({
                        ...triggerProps,
                        ...bindFocus,
                        onClick: handleTriggerClicked
                    })
                }) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $a5ef4528210000de$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const groupId = (0, $gUxVT.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $1dEEK.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = avatarOverrides.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                if ((0, $egspI.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                        content: avatarData.name,
                        testId: testId && `${testId}--tooltip-${idx}`,
                        position: tooltipPosition,
                        children: finalAvatar
                    }) : finalAvatar
                }, (0, $jhCIk.composeUniqueKey)(avatarData, idx));
                else return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $jhCIk.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    }) : /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2B9F0.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = avatarOverrides.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                if ((0, $egspI.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                        content: avatarData.name,
                        testId: testId && `${testId}--tooltip-${idx}`,
                        position: tooltipPosition,
                        children: finalAvatar
                    }) : finalAvatar
                }, (0, $jhCIk.composeUniqueKey)(avatarData, idx));
                else return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $jhCIk.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    });
};
$a5ef4528210000de$var$AvatarGroup.displayName = "AvatarGroup";
var $a5ef4528210000de$export$2e2bcd8739ae039 = $a5ef4528210000de$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $48dedd10700aff3c$export$390330c10ff2b9a1 = 'ArrowUp';
const $48dedd10700aff3c$export$a80636c6f41931fe = 'ArrowDown';
const $48dedd10700aff3c$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $48dedd10700aff3c$export$c40f9845adc73fb5 = 'ArrowRight';
const $48dedd10700aff3c$export$4af703091671bc = 'Home';
const $48dedd10700aff3c$export$e2bc30913faa5db7 = 'End';
const $48dedd10700aff3c$export$10f6869ed0a7d75b = 'Tab';
const $48dedd10700aff3c$export$8152f929a25a0ff4 = 'Enter';
const $48dedd10700aff3c$export$e51a3576c045c8d5 = 'Space';
const $48dedd10700aff3c$export$2bb790b9008907b4 = 'Escape';

parcelRegister("Ro65p", function(module, exports) {
$parcel$export(module.exports, "default", () => $880ea9bd536fd0a9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $8z2GW = parcelRequire("8z2GW");

var $ljVHR = parcelRequire("ljVHR");

var $ceqcm = parcelRequire("ceqcm");
var $3HgHS = parcelRequire("3HgHS");
var $cSR11 = parcelRequire("cSR11");

var $egspI = parcelRequire("egspI");

var $gbHFR = parcelRequire("gbHFR");
const $880ea9bd536fd0a9$var$AvatarGroupItem = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $gbHFR.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            role: role,
            ...props,
            children: children
        });
    };
    const AvatarComponent = (0, $egspI.fg)('platform-avatar-group-pass-avatar-to-item') ? avatarComponent ?? (0, $8z2GW.default) : (0, $8z2GW.default);
    const AvatarIcon = avatarOverrides && (0, $egspI.fg)('platform-avatar-group-pass-avatar-to-item') ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: 'transparent',
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: '',
        presence: presence,
        size: 'small',
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, $e79Pd.jsx)(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cSR11.default), {
        ref: (0, $ljVHR.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ceqcm.default), {
        ref: (0, $ljVHR.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        children: name
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3HgHS.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$880ea9bd536fd0a9$export$2e2bcd8739ae039 = $880ea9bd536fd0a9$var$AvatarGroupItem;

});
parcelRegister("gbHFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a7e1995da3d77e5$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $euxye = parcelRequire("euxye");

var $ahSNl = parcelRequire("ahSNl");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $4a7e1995da3d77e5$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $euxye.useContext)((0, $ahSNl.FocusManagerContext));
    const itemRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $4a7e1995da3d77e5$export$2e2bcd8739ae039 = $4a7e1995da3d77e5$var$useRegisterItemWithFocusManager;

});
parcelRegister("ahSNl", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $6140269c3c1980c6$export$f18c1d4fc7326096);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $6140269c3c1980c6$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $euxye.createContext)({
    menuItemRefs: [],
    registerRef: (0, $2oRWW.default)
});

});



parcelRegister("4nptA", function(module, exports) {
$parcel$export(module.exports, "MoreDropdownTopLayer", () => $fc07f3c103c0ad43$export$36ea40361987a72d);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");


var $72ldR = parcelRequire("72ldR");
var $g36LP = parcelRequire("g36LP");

var $gD1FN = parcelRequire("gD1FN");

var $gkWVj = parcelRequire("gkWVj");

var $Yce2Z = parcelRequire("Yce2Z");

var $j0Y0H = parcelRequire("j0Y0H");

var $fEJPe = parcelRequire("fEJPe");

var $lEgz2 = parcelRequire("lEgz2");

var $kUmcP = parcelRequire("kUmcP");

var $Ro65p = parcelRequire("Ro65p");
const $fc07f3c103c0ad43$var$topLayerPlacement = (0, $gkWVj.fromLegacyPlacement)({
    legacy: 'bottom-end'
});
function $fc07f3c103c0ad43$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                    ...props
                }, index),
            ...overrides?.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                    ...props
                }, index),
            ...overrides?.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                    ...props
                }),
            ...overrides?.MoreIndicator
        }
    };
}
function $fc07f3c103c0ad43$export$36ea40361987a72d({ isOpen: isOpen, onClose: onClose, isTriggeredUsingKeyboard: _isTriggeredUsingKeyboard, data: data, max: max, overrides: overrides, onAvatarClick: onAvatarClick, testId: testId, labelId: labelId, renderMoreButton: renderMoreButton, handleTriggerClicked: handleTriggerClicked, bindFocus: _bindFocus }) {
    const handleOnClose = (0, $euxye.useCallback)(({ reason: _reason })=>{
        onClose();
    }, [
        onClose
    ]);
    const triggerRef = (0, $euxye.useRef)(null);
    const popoverRef = (0, $euxye.useRef)(null);
    const menuRef = (0, $euxye.useRef)(null);
    const overflowMenuTestId = testId ? `${testId}--overflow-menu` : undefined;
    const popoverId = (0, $kUmcP.usePopoverId)();
    (0, $fEJPe.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: $fc07f3c103c0ad43$var$topLayerPlacement,
        isOpen: isOpen
    });
    // Arrow key navigation inside the open menu
    (0, $lEgz2.useArrowNavigation)({
        containerRef: menuRef,
        onClose: onClose,
        isEnabled: isOpen
    });
    // ArrowDown-to-open: when the trigger is focused and the menu is closed,
    // pressing ArrowDown opens the menu (WAI-ARIA menu button pattern).
    //
    // Bind the keydown listener directly to the trigger element via its ref so
    // that opening the menu does not trigger a focus-driven re-render of the
    // host component, which would unmount and remount the menu items and drop
    // menuitem focus.
    (0, $euxye.useEffect)(()=>{
        const trigger = triggerRef.current;
        if (!trigger || isOpen) return;
        return (0, $glbdM.bind)(trigger, {
            type: 'keydown',
            listener: function openOnArrowDown(event) {
                if (event.key === (0, $48dedd10700aff3c$export$a80636c6f41931fe)) {
                    // Prevent page scroll when opening the menu via ArrowDown.
                    event.preventDefault();
                    handleTriggerClicked(event);
                }
            }
        });
    }, [
        isOpen,
        handleTriggerClicked
    ]);
    const triggerAria = (0, $gD1FN.getAriaForTrigger)({
        role: 'menu',
        isOpen: isOpen,
        popoverId: popoverId
    });
    const setTriggerRef = (0, $euxye.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            renderMoreButton({
                ref: setTriggerRef,
                ...triggerAria,
                onClick: handleTriggerClicked
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "menu",
                label: "avatar group",
                isOpen: isOpen,
                onClose: handleOnClose,
                animate: true,
                placement: $fc07f3c103c0ad43$var$topLayerPlacement,
                testId: overflowMenuTestId ? `${overflowMenuTestId}--content` : undefined,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j0Y0H.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        ref: menuRef,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $72ldR.default), {
                            minWidth: 250,
                            maxHeight: 300,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g36LP.default), {
                                titleId: labelId,
                                testId: testId ? `${testId}--section` : undefined,
                                children: data.slice(max).map((avatar, index)=>$fc07f3c103c0ad43$var$getOverrides(overrides).AvatarGroupItem.render((0, $Ro65p.default), {
                                        avatar: avatar,
                                        onAvatarClick: onAvatarClick,
                                        testId: testId ? `${testId}--avatar-group-item-${index + max}` : undefined,
                                        index: index + max,
                                        role: 'menuitem'
                                    }, index + max))
                            })
                        })
                    })
                })
            })
        ]
    });
}
$fc07f3c103c0ad43$export$36ea40361987a72d.displayName = "MoreDropdownTopLayer";

});

parcelRegister("18imJ", function(module, exports) {
$parcel$export(module.exports, "getOverrides", () => $94154d4149d8c3bd$export$f525cc57d37ca574);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jhCIk = parcelRequire("jhCIk");
function $94154d4149d8c3bd$export$f525cc57d37ca574(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $euxye.createElement)(Component, {
                    ...props,
                    key: (0, $jhCIk.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, $euxye.createElement)(Component, {
                    ...props,
                    key: (0, $jhCIk.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}

});
parcelRegister("jhCIk", function(module, exports) {
$parcel$export(module.exports, "composeUniqueKey", () => $f9161df54510e483$export$b067756944994c79);
const $f9161df54510e483$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("2B9F0", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5766d9c1b8da4da$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8L2z6 = parcelRequire("8L2z6");

var $egspI = parcelRequire("egspI");
const $c5766d9c1b8da4da$var$gutter = "var(--ds-space-negative-050, -4px)";
const $c5766d9c1b8da4da$var$listStyles = null;
const $c5766d9c1b8da4da$var$listStylesFlagged = null;
const $c5766d9c1b8da4da$var$listItemStyles = null;
const $c5766d9c1b8da4da$var$Grid = ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $e79Pd.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $egspI.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]),
        children: (0, $egspI.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
            exitThenEnter: true,
            children: (0, $euxye.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                    className: (0, $4jQY2.default)([
                        "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                    ]),
                    children: child
                }))
        }) : (0, $euxye.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                className: (0, $4jQY2.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
$c5766d9c1b8da4da$var$Grid.displayName = "Grid";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c5766d9c1b8da4da$export$2e2bcd8739ae039 = $c5766d9c1b8da4da$var$Grid;

});

parcelRegister("eZVgc", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc353618fbf9e9fc$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $4o18D = parcelRequire("4o18D");

var $ahSNl = parcelRequire("ahSNl");
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Focus manager__
 *
 * A focus manager {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $fc353618fbf9e9fc$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $euxye.useRef)([]);
    const registerRef = (0, $euxye.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $euxye.useEffect)(()=>{
        (0, $glbdM.bind)(window, {
            type: 'keydown',
            listener: (0, $4o18D.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $glbdM.bind)(window, {
                type: 'keydown',
                listener: (0, $4o18D.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ahSNl.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
$fc353618fbf9e9fc$var$FocusManager.displayName = "FocusManager";
var $fc353618fbf9e9fc$export$2e2bcd8739ae039 = $fc353618fbf9e9fc$var$FocusManager;

});
parcelRegister("4o18D", function(module, exports) {
$parcel$export(module.exports, "default", () => $3221dfda06d73e66$export$2e2bcd8739ae039);

const $3221dfda06d73e66$var$actionMap = {
    [(0, $48dedd10700aff3c$export$a80636c6f41931fe)]: 'next',
    [(0, $48dedd10700aff3c$export$390330c10ff2b9a1)]: 'prev',
    [(0, $48dedd10700aff3c$export$4af703091671bc)]: 'first',
    [(0, $48dedd10700aff3c$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $3221dfda06d73e66$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $3221dfda06d73e66$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $3221dfda06d73e66$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $3221dfda06d73e66$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $3221dfda06d73e66$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $3221dfda06d73e66$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $3221dfda06d73e66$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $3221dfda06d73e66$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("gsyDy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a953b3f1665b1d3a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $72ldR = parcelRequire("72ldR");

var $ahSNl = parcelRequire("ahSNl");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $a953b3f1665b1d3a$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $euxye.useContext)((0, $ahSNl.FocusManagerContext));
    (0, $euxye.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $72ldR.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
$a953b3f1665b1d3a$var$PopupAvatarGroup.displayName = "PopupAvatarGroup";
var $a953b3f1665b1d3a$export$2e2bcd8739ae039 = $a953b3f1665b1d3a$var$PopupAvatarGroup;

});

parcelRegister("fr54R", function(module, exports) {
$parcel$export(module.exports, "default", () => $b33d2bdd76cd7659$export$2e2bcd8739ae039);
/* more-indicator.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");
const $b33d2bdd76cd7659$var$boxShadowCssVar = '--avatar-box-shadow';
const $b33d2bdd76cd7659$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh18uv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _jlxit94y",
    circle: "_2rko1qll",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon",
    hexagon: "_mkrz1k6g"
};
const $b33d2bdd76cd7659$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $b33d2bdd76cd7659$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $b33d2bdd76cd7659$var$fontMap = {
    small: "_11c8wadc",
    medium: "_11c8wadc",
    large: "_11c8wadc",
    xlarge: "_11c81d4k",
    xxlarge: "_11c81d4k"
};
const $b33d2bdd76cd7659$var$MAX_DISPLAY_COUNT = 99;
const $b33d2bdd76cd7659$var$MoreIndicator = /*#__PURE__*/ (0, $euxye.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $b33d2bdd76cd7659$var$MAX_DISPLAY_COUNT ? $b33d2bdd76cd7659$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$b33d2bdd76cd7659$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $4jQY2.default)([
            $b33d2bdd76cd7659$var$styles.root,
            $b33d2bdd76cd7659$var$borderRadiusMap[size],
            appearance === 'circle' && $b33d2bdd76cd7659$var$styles.circle,
            appearance === 'hexagon' && (0, $egspI.fg)('jira-ai-agent-stack') && $b33d2bdd76cd7659$var$styles.hexagon,
            $b33d2bdd76cd7659$var$widthHeightMap[size],
            $b33d2bdd76cd7659$var$fontMap[size],
            isActive && $b33d2bdd76cd7659$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$b33d2bdd76cd7659$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b33d2bdd76cd7659$export$2e2bcd8739ae039 = $b33d2bdd76cd7659$var$MoreIndicator;

});

parcelRegister("1dEEK", function(module, exports) {
$parcel$export(module.exports, "default", () => $71977e3c166a67d2$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8L2z6 = parcelRequire("8L2z6");

var $egspI = parcelRequire("egspI");
const $71977e3c166a67d2$var$listStyles = null;
const $71977e3c166a67d2$var$listSmallStyles = null;
const $71977e3c166a67d2$var$listItemStyles = null;
const $71977e3c166a67d2$var$listItemSmallStyles = null;
const $71977e3c166a67d2$var$Stack = ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $e79Pd.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $egspI.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ]),
        children: (0, $egspI.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
            exitThenEnter: true,
            children: (0, $euxye.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                    className: (0, $4jQY2.default)([
                        "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                        size === 'small' && (0, $egspI.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                    ]),
                    children: child
                }))
        }) : (0, $euxye.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                className: (0, $4jQY2.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === 'small' && (0, $egspI.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                ]),
                children: child
            }))
    });
$71977e3c166a67d2$var$Stack.displayName = "Stack";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$71977e3c166a67d2$export$2e2bcd8739ae039 = $71977e3c166a67d2$var$Stack;

});





parcelRegister("gnyTi", function(module, exports) {
$parcel$export(module.exports, "useFomoCollaboratorsBatched", () => $ab7cedfbec26523f$export$21f6c38d03063951);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $jbWUS = parcelRequire("jbWUS");
const $ab7cedfbec26523f$var$MAX_AAIDS = 3;
function $ab7cedfbec26523f$export$21f6c38d03063951(aaids, { enabled: enabled = true } = {}) {
    const environment = (0, $n67Vb.useRelayEnvironment)();
    const capped = aaids.slice(0, $ab7cedfbec26523f$var$MAX_AAIDS);
    const isNoop = !enabled || capped.length === 0;
    const key = isNoop ? '__noop__' : JSON.stringify(capped);
    const [state, setState] = (0, $euxye.useState)({
        collaborators: [],
        error: null,
        key: isNoop ? key : null
    });
    (0, $euxye.useEffect)(()=>{
        if (isNoop) {
            setState({
                collaborators: [],
                error: null,
                key: key
            });
            return;
        }
        let cancelled = false;
        (0, $jbWUS.fetchUsersByAaids)(environment, capped).then(({ collaborators: collaborators, error: error })=>{
            if (cancelled) return;
            setState({
                collaborators: collaborators,
                error: error,
                key: key
            });
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        key,
        isNoop,
        environment
    ]);
    const loaded = state.key === key;
    return {
        collaborators: loaded ? state.collaborators : [],
        isReady: loaded,
        error: loaded ? state.error : null
    };
}

});
parcelRegister("jbWUS", function(module, exports) {
$parcel$export(module.exports, "fetchUsersByAaids", () => $594ad0bb4c48e91f$export$eec092fef118af9);

var $hU9O4 = parcelRequire("hU9O4");

var $n67Vb = parcelRequire("n67Vb");
async function $594ad0bb4c48e91f$export$eec092fef118af9(environment, aaids) {
    if (aaids.length === 0) return {
        collaborators: [],
        error: null
    };
    try {
        const data = await (0, $n67Vb.fetchQuery)(environment, (0, $hU9O4.default), {
            accountIds: aaids
        }).toPromise();
        const users = data?.users ?? [];
        const byAaid = new Map();
        for (const u of users)// Skip records missing name or picture — we can't render an avatar without both.
        if (u?.accountId && u.name && u.picture) byAaid.set(u.accountId, {
            accountId: u.accountId,
            displayName: u.name,
            avatarUrl: u.picture
        });
        // Preserve input order.
        const collaborators = aaids.map((a)=>byAaid.get(a)).filter((c)=>!!c);
        return {
            collaborators: collaborators,
            error: null
        };
    } catch (error) {
        return {
            collaborators: [],
            error: error
        };
    }
}

});
parcelRegister("hU9O4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba022a51b48b2cdc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f84adf570fb691b6495d19f38b7c4902>>
 * @relayHash 0ad556ff820d35bb17d0e31ce5d0b047
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1d19e41603d4aaa8be4d60bdde37b87fbf00da84f06435309642e8e6c5710aa
const $ba022a51b48b2cdc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersByAaidsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersByAaidsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a1d19e41603d4aaa8be4d60bdde37b87fbf00da84f06435309642e8e6c5710aa",
            "metadata": {},
            "name": "fetchUsersByAaidsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ba022a51b48b2cdc$var$node.hash = "8a3ac08d21378d56d25c36c21e4e0285";
var $ba022a51b48b2cdc$export$2e2bcd8739ae039 = $ba022a51b48b2cdc$var$node;

});



parcelRegister("1Fqw0", function(module, exports) {
$parcel$export(module.exports, "useCanShowFomoNudge", () => $638b9b2b59c1dd04$export$f2c87e8746c4282b);

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $iJMvD = parcelRequire("iJMvD");
function $638b9b2b59c1dd04$export$f2c87e8746c4282b({ enabled: enabled = true } = {}) {
    const cookieConsentEnforced = enabled ? (0, $egspI.fg)('rovo_fomo_nudge_cookie_policy_check') : false;
    // When the gate is off, short-circuit: legacy behavior, always allow.
    const [canShow, setCanShow] = (0, $euxye.useState)(enabled ? cookieConsentEnforced ? null : true : false);
    (0, $euxye.useEffect)(()=>{
        if (!enabled) {
            setCanShow(false);
            return;
        }
        if (!cookieConsentEnforced) {
            setCanShow(true);
            return;
        }
        let isMounted = true;
        setCanShow(null);
        (0, $iJMvD.canShowFomoNudge)().then((result)=>{
            if (isMounted) setCanShow(result);
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        enabled,
        cookieConsentEnforced
    ]);
    return canShow;
}

});
parcelRegister("iJMvD", function(module, exports) {
$parcel$export(module.exports, "canShowFomoNudge", () => $b68a41b049465702$export$54ea2450140fa4c6);

var $eTDvj = parcelRequire("eTDvj");
var $5MrbU = parcelRequire("5MrbU");
async function $b68a41b049465702$export$54ea2450140fa4c6() {
    try {
        const prefs = await (0, $eTDvj.getPreferences)();
        return Boolean(prefs?.[(0, $5MrbU.PreferenceCategory).Functional]);
    } catch  {
        return false;
    }
}

});


parcelRegister("cD7wY", function(module, exports) {
$parcel$export(module.exports, "DeferIfNudgePresent", () => $8d80cffbc266322b$export$2e31cdc9f2df82d5);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");
const $8d80cffbc266322b$export$2e31cdc9f2df82d5 = ({ children: children, ownNudgeIds: ownNudgeIds = [] })=>{
    const currentNudges = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStore)((state)=>state.configuration?.nudges);
    const hasOtherNudge = currentNudges?.some((nudge)=>!ownNudgeIds.includes(nudge.id));
    if (hasOtherNudge) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$8d80cffbc266322b$export$2e31cdc9f2df82d5.displayName = "DeferIfNudgePresent";

});

parcelRegister("cO03t", function(module, exports) {
$parcel$export(module.exports, "normalizeTopCollaboratorAccountIds", () => $a3230e22708655c0$export$51d51cecfa886097);
$parcel$export(module.exports, "parseTopCollaboratorAccountIds", () => $a3230e22708655c0$export$5d85ecb3e897b3c0);
const $a3230e22708655c0$var$MAX_COLLABORATORS = 3;
const $a3230e22708655c0$export$51d51cecfa886097 = (accountIds)=>accountIds.map((accountId)=>accountId.trim()).filter(Boolean).slice(0, $a3230e22708655c0$var$MAX_COLLABORATORS);
const $a3230e22708655c0$export$5d85ecb3e897b3c0 = (csv)=>$a3230e22708655c0$export$51d51cecfa886097(csv ? csv.split(',') : []);

});

parcelRegister("jCv3W", function(module, exports) {
$parcel$export(module.exports, "TOP_ROVO_CHAT_COLLABORATORS_TRAIT", () => $ad65284b27612d71$export$3b8284cd77d8b570);
$parcel$export(module.exports, "useTopRovoChatCollaboratorsTraitResource", () => $ad65284b27612d71$export$4f0d495ae859652d);

var $euxye = parcelRequire("euxye");

var $40jii = parcelRequire("40jii");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $cO03t = parcelRequire("cO03t");
const $ad65284b27612d71$export$3b8284cd77d8b570 = 'rovo_chat_top_collaborators_per_site';
const $ad65284b27612d71$export$e90c6f262048878a = 'is_rovo_chat_mau';
const $ad65284b27612d71$export$7fbcce4ec9f87ed0 = (traitValue)=>{
    if (typeof traitValue !== 'string' || traitValue.trim() === '') return '';
    return (0, $cO03t.normalizeTopCollaboratorAccountIds)(traitValue.split(',')).join(',');
};
const $ad65284b27612d71$var$getTraitValue = (attributes, traitName)=>attributes?.find((trait)=>trait.name === traitName)?.value;
const $ad65284b27612d71$export$4f0d495ae859652d = (traitName = $ad65284b27612d71$export$3b8284cd77d8b570, enabled = true)=>{
    const accountId = (0, $3GN2r.useAccountId)();
    const cloudId = (0, $kt86l.useCloudId)();
    const { fetchTraits: fetchTraits } = (0, $40jii.useTraitsActions)();
    const [traitsState] = (0, $40jii.useTraits)();
    const accountTraits = traitsState.ATLASSIAN_ACCOUNT;
    const siteUserTraits = traitsState.SITE_USER;
    (0, $euxye.useEffect)(()=>{
        if (!enabled) return;
        fetchTraits([
            'SITE_USER',
            'ATLASSIAN_ACCOUNT'
        ], {
            cloudId: cloudId,
            accountId: accountId
        });
    }, [
        fetchTraits,
        cloudId,
        accountId,
        enabled
    ]);
    if (!siteUserTraits.loaded || !accountTraits.loaded) return {
        collaboratorAaids: '',
        isRovoChatMau: null,
        loaded: false
    };
    const collaboratorAaids = $ad65284b27612d71$export$7fbcce4ec9f87ed0($ad65284b27612d71$var$getTraitValue(siteUserTraits.attributes, traitName));
    // Missing trait → treat as `false` (not MAU → allow nudge).
    const rawMauValue = $ad65284b27612d71$var$getTraitValue(accountTraits.attributes, $ad65284b27612d71$export$e90c6f262048878a);
    const isRovoChatMau = rawMauValue != null && String(rawMauValue).toLowerCase() === 'true';
    return {
        collaboratorAaids: collaboratorAaids,
        isRovoChatMau: isRovoChatMau,
        loaded: true
    };
};

});


parcelRegister("2oVIP", function(module, exports) {
$parcel$export(module.exports, "AiRovoIssueViewNudgesProvider", () => $7c8185af54f8c2c2$export$c3f013efb90a1104);
// import { useEffect } from 'react';
// import { useAiRovoCurrentRouteConfigurationStoreActions } from '@jira/ai-rovo_actions-store/src/aiRovoCurrentRouteConfigurationStore.tsx';
// import { usePublish } from '@atlaskit/rovo-triggers';
/**
 * Example of a nudge for the issue view route.
 */ const $7c8185af54f8c2c2$export$c3f013efb90a1104 = ()=>{
    // const { updateConfiguration } = useAiRovoCurrentRouteConfigurationStoreActions();
    // const publish = usePublish('ai-mate');
    /**
	 * 	useEffect(() => {
		updateConfiguration({
			nudges: [
				{
					id: 'issue-view-rovo-nudge',
					title: 'Add a comment',
					description: 'Add a comment to the issue',
					icon: <CommentIcon label="Add a comment" size="medium" />,
					nudgeIcon: () => <CommentIcon label="Add a comment" size="medium" />,
					onClick: () => {
						publish({
							type: 'chat-new',
							product: 'jira',
							source: 'issue-view-rovo-nudge',
							data: {
								name: 'Add a comment',
								dialogues: [],
								prompt: 'Add a comment to the issue',
							},
						});
					},
					sourceId: 'jira-ai-rovo-button',
					status: 'beta',
				},
			],
		});
	}, [updateConfiguration, publish]);
	 */ return null;
};

});

parcelRegister("cVIWH", function(module, exports) {
$parcel$export(module.exports, "AiRovoProjectScopedNudgeSubscriptionProvider", () => $bbdf018da925a5d9$export$43d637fd45ed873f);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");

var $5LkGi = parcelRequire("5LkGi");

var $h8QGu = parcelRequire("h8QGu");

var $u9iDa = parcelRequire("u9iDa");

var $eYjNM = parcelRequire("eYjNM");

var $9ll9z = parcelRequire("9ll9z");

var $gDdYI = parcelRequire("gDdYI");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2b39L = parcelRequire("2b39L");

var $50DkA = parcelRequire("50DkA");
const $bbdf018da925a5d9$var$nudgeTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "You have {numberOfSuggestions} work item updates",
    id: "ai-rovo.actions-software-backlog.nudge-title.nonfinal"
});
const $bbdf018da925a5d9$var$nudgeDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We have identified {numberOfSuggestions} work item updates",
    id: "ai-rovo.actions-software-backlog.nudge-description.nonfinal"
});
const $bbdf018da925a5d9$var$nudgeIconLabelMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Work items icon",
    id: "ai-rovo.actions-software-backlog.nudge-icon-label.nonfinal"
});
const $bbdf018da925a5d9$export$43d637fd45ed873f = ({ sourceId: sourceId })=>{
    const { data: projectData, error: error, loading: loading } = (0, $2b39L.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const publish = (0, $9ll9z.usePublish)('ai-mate');
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const lastReceivedNudgeRef = (0, $euxye.useRef)(null);
    const applyNudge = (0, $euxye.useCallback)((metadata)=>{
        const { channelConversationId: channelConversationId, numberOfSuggestions: numberOfSuggestions } = metadata;
        const iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eYjNM))), {
            size: "medium",
            label: formatMessage($bbdf018da925a5d9$var$nudgeIconLabelMessage)
        });
        updateConfiguration({
            nudges: [
                {
                    id: `issue-update-suggestions-rovo-nudge-${channelConversationId}`,
                    title: formatMessage($bbdf018da925a5d9$var$nudgeTitleMessage, {
                        numberOfSuggestions: numberOfSuggestions
                    }),
                    description: formatMessage($bbdf018da925a5d9$var$nudgeDescriptionMessage, {
                        numberOfSuggestions: numberOfSuggestions
                    }),
                    icon: ()=>iconNode,
                    onClick: ()=>{
                        publish({
                            type: 'chat-open',
                            product: 'jira',
                            data: {
                                channelId: channelConversationId
                            },
                            openChatMode: 'mini-modal',
                            source: sourceId
                        });
                    },
                    type: 'ai-action',
                    handleType: (0, $50DkA.HandleActionType).Base
                }
            ]
        });
    }, [
        formatMessage,
        publish,
        sourceId,
        updateConfiguration
    ]);
    (0, $euxye.useEffect)(()=>{
        const doc = (0, $u9iDa.getDocument)();
        if (!doc) return;
        const isTabVisible = ()=>doc.visibilityState === 'visible';
        const isTabActive = ()=>isTabVisible() && doc.hasFocus();
        const applyPendingNudge = ()=>{
            const pending = lastReceivedNudgeRef.current;
            if (pending) {
                applyNudge(pending);
                lastReceivedNudgeRef.current = null;
            }
        };
        const onVisibilityChange = ()=>{
            if (isTabActive()) applyPendingNudge();
        };
        const onWindowFocus = ()=>{
            if (isTabVisible()) applyPendingNudge();
        };
        doc.addEventListener('visibilitychange', onVisibilityChange);
        const win = typeof globalThis.window !== 'undefined' ? globalThis.window : null;
        if (win) win.addEventListener('focus', onWindowFocus);
        return ()=>{
            doc.removeEventListener('visibilitychange', onVisibilityChange);
            if (win) win.removeEventListener('focus', onWindowFocus);
        };
    }, [
        applyNudge
    ]);
    const handleEventReceived = (0, $euxye.useCallback)((nudgeMetadata)=>{
        lastReceivedNudgeRef.current = nudgeMetadata;
        const doc = (0, $u9iDa.getDocument)();
        if (doc?.visibilityState === 'visible' && doc.hasFocus()) {
            applyNudge(nudgeMetadata);
            lastReceivedNudgeRef.current = null;
        }
    }, [
        applyNudge
    ]);
    if (!(0, $i860n.fg)('jira-ai-proactive-loom-updates-suggestions') || (0, $i860n.fg)('post-office_update-work-rovo-nudge')) return null;
    if (loading || error || !projectData?.projectId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "rovo-issue-update-suggestions-subscription",
        packageName: "@jira/ai-rovo_actions-route-provider",
        teamName: "reverie",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "rovo-issue-update-suggestions-subscription"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5LkGi.IssueUpdateSuggestionsSubscription), {
        appId: sourceId,
        projectId: String(projectData.projectId),
        onEventReceived: handleEventReceived
    })));
};
$bbdf018da925a5d9$export$43d637fd45ed873f.displayName = "AiRovoProjectScopedNudgeSubscriptionProvider";

});
parcelRegister("5LkGi", function(module, exports) {
$parcel$export(module.exports, "IssueUpdateSuggestionsSubscription", () => $42dec099330dabfe$export$13e0ec4c1bd4725);

var $9qOiv = parcelRequire("9qOiv");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $2NSbF = parcelRequire("2NSbF");

var $i8BNs = parcelRequire("i8BNs");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $6CfY5 = parcelRequire("6CfY5");

var $bfG4v = parcelRequire("bfG4v");

var $ewkI4 = parcelRequire("ewkI4");
const $42dec099330dabfe$export$13e0ec4c1bd4725 = /*#__PURE__*/ (0, $euxye.memo)(({ appId: appId, projectId: projectId, onEventReceived: onEventReceived, onError: onError })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const accountId = (0, $3GN2r.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handleOnEventReceived = (0, $euxye.useCallback)((response)=>{
        const maybeUserAri = response?.jira_onIssueUpdateSuggestions?.userAri;
        const sourceAri = response?.jira_onIssueUpdateSuggestions?.sourceAri;
        const targetAri = response?.jira_onIssueUpdateSuggestions?.targetAri;
        const issuesCount = response?.jira_onIssueUpdateSuggestions?.suggestions?.issuesCount ?? 0;
        const fieldsCount = response?.jira_onIssueUpdateSuggestions?.suggestions?.fieldsCount ?? 0;
        const channelConversationId = response?.jira_onIssueUpdateSuggestions?.rovo?.channelConversationId;
        const actionMessageId = response?.jira_onIssueUpdateSuggestions?.rovo?.actionMessageId;
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueUpdateSuggestionsSubscriptionEvent received', {
            appId: appId,
            userAri: maybeUserAri,
            sourceAri: sourceAri,
            targetAri: targetAri,
            channelConversationId: channelConversationId,
            actionMessageId: actionMessageId,
            issuesCount: issuesCount,
            fieldsCount: fieldsCount
        });
        const isUserMatch = accountId && maybeUserAri && (0, $2NSbF.IdentityUserAri).check(maybeUserAri) && (0, $2NSbF.IdentityUserAri).parse(maybeUserAri).userId === accountId;
        if (channelConversationId && fieldsCount > 0 && isUserMatch) onEventReceived({
            channelConversationId: channelConversationId,
            numberOfSuggestions: fieldsCount
        });
    }, [
        accountId,
        appId,
        createAnalyticsEvent,
        onEventReceived
    ]);
    const handleOnError = (0, $euxye.useCallback)((error)=>{
        (0, $6CfY5.default).safeErrorWithoutCustomerData(`IssueUpdateSuggestionsSubscription: ${appId}`, error.message, error);
        if (!(0, $ewkI4.isClientNetworkError)(error) && !(0, $bfG4v.isWebSocketError)(error)) {
            (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueUpdateSuggestionsSubscriptionEvent failed', {
                appId: appId,
                errorMessage: error.message
            });
            onError?.(error);
        }
    }, [
        appId,
        createAnalyticsEvent,
        onError
    ]);
    const variables = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            projectAri: (0, $i8BNs.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        }), [
        cloudId,
        projectId
    ]);
    (0, $n67Vb.useSubscription)((0, $euxye.useMemo)(()=>({
            subscription: (0, $9qOiv.default),
            variables: variables,
            onNext: handleOnEventReceived,
            onError: handleOnError
        }), [
        handleOnError,
        handleOnEventReceived,
        variables
    ]));
    return null;
});

});
parcelRegister("9qOiv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4a6636f9727f33c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1141377722825598a18a8a7d75c5b4df>>
 * @relayHash aae0b2e79c40fd5e3f91557622298c6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f0675a4c080aae13f3e048f743c8a13986f4ab80c458e624f0b061895f10e740
const $e4a6636f9727f33c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectAri",
                    "variableName": "projectAri"
                }
            ],
            "concreteType": "JiraIssueUpdatesSuggestion",
            "kind": "LinkedField",
            "name": "jira_onIssueUpdateSuggestions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "userAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "sourceAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "targetAri"
                },
                {
                    "concreteType": "JiraRovoConversationMetadata",
                    "kind": "LinkedField",
                    "name": "rovo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "channelConversationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "actionMessageId"
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueUpdatesSuggestionMetadata",
                    "kind": "LinkedField",
                    "name": "suggestions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issuesCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fieldsCount"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueUpdateSuggestionsSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueUpdateSuggestionsSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "f0675a4c080aae13f3e048f743c8a13986f4ab80c458e624f0b061895f10e740",
            "metadata": {},
            "name": "IssueUpdateSuggestionsSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$e4a6636f9727f33c$var$node.hash = "6e02c936e50cad924c6ba9c62597bba4";
var $e4a6636f9727f33c$export$2e2bcd8739ae039 = $e4a6636f9727f33c$var$node;

});

parcelRegister("bfG4v", function(module, exports) {
$parcel$export(module.exports, "isWebSocketError", () => $c7ff140581131b14$export$c5dd7d9cf499c24d);
const $c7ff140581131b14$export$e6b01bb650e7336b = [
    'closeevent: ping timeout',
    'event: error',
    'event: close',
    'event: disconnect',
    'connection closed',
    'transport error',
    'websocket is closed before the connection is established',
    'closeevent: 1000',
    'closeevent: 1001',
    'closeevent: 1006',
    'closeevent: abnormal closure'
];
const $c7ff140581131b14$export$c5dd7d9cf499c24d = (error)=>$c7ff140581131b14$export$e6b01bb650e7336b.some((wsError)=>error?.message?.toLowerCase()?.includes?.(wsError) ?? false);

});

parcelRegister("ewkI4", function(module, exports) {
$parcel$export(module.exports, "isClientNetworkError", () => $170f7d6074b69084$export$dc0d2c5fff67f524);
const $170f7d6074b69084$export$c748438cec453c9f = [
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $170f7d6074b69084$export$dc0d2c5fff67f524 = (error)=>Boolean(error?.message) && $170f7d6074b69084$export$c748438cec453c9f.includes(error.message);

});



parcelRegister("iJO1d", function(module, exports) {
$parcel$export(module.exports, "AiRovoPermissionsNudgesProvider", () => $c8e2abfcfae60a88$export$11f506d17a9fb51e);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");

var $7JtAL = parcelRequire("7JtAL");

var $aN5aG = parcelRequire("aN5aG");

var $kJM81 = parcelRequire("kJM81");

var $1YIbA = parcelRequire("1YIbA");

var $50DkA = parcelRequire("50DkA");

var $fxuX9 = parcelRequire("fxuX9");
const $c8e2abfcfae60a88$export$11f506d17a9fb51e = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const { formatExplicitPermissionsSkillPrompt: formatExplicitPermissionsSkillPrompt } = (0, $aN5aG.useExplicitPermissionsSkillPrompt)();
    const nudges = (0, $euxye.useMemo)(()=>[
            {
                id: 'ai-rovo.permissions-nudge.who-can-access-space-what-roles',
                title: formatMessage((0, $7JtAL.whoCanAccessSpaceWhatRolesPrompt)),
                description: formatMessage((0, $7JtAL.whoCanAccessSpaceWhatRolesPrompt)),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                        label: formatMessage((0, $7JtAL.whoCanAccessSpaceWhatRolesPrompt)),
                        size: "medium"
                    }),
                type: 'skill-action',
                handleType: (0, $50DkA.HandleActionType).Skill,
                staticPrompt: formatExplicitPermissionsSkillPrompt((0, $7JtAL.whoCanAccessSpaceWhatRolesPrompt))
            },
            {
                id: 'ai-rovo.permissions-nudge.why-user-cannot-view-edit-work-items',
                title: formatMessage((0, $7JtAL.whyUserCannotViewEditWorkItemsPrompt)),
                description: formatMessage((0, $7JtAL.whyUserCannotViewEditWorkItemsPrompt)),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                        label: formatMessage((0, $7JtAL.whyUserCannotViewEditWorkItemsPrompt)),
                        size: "medium"
                    }),
                type: 'skill-action',
                handleType: (0, $50DkA.HandleActionType).Skill,
                staticPrompt: formatExplicitPermissionsSkillPrompt((0, $7JtAL.whyUserCannotViewEditWorkItemsPrompt))
            },
            {
                id: 'ai-rovo.permissions-nudge.who-has-space-admin-sprint-management-permissions',
                title: formatMessage((0, $7JtAL.whoHasSpaceAdminOrManageSprintsPermissionsPrompt)),
                description: formatMessage((0, $7JtAL.whoHasSpaceAdminOrManageSprintsPermissionsPrompt)),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                        label: formatMessage((0, $7JtAL.whoHasSpaceAdminOrManageSprintsPermissionsPrompt)),
                        size: "medium"
                    }),
                type: 'skill-action',
                handleType: (0, $50DkA.HandleActionType).Skill,
                staticPrompt: formatExplicitPermissionsSkillPrompt((0, $7JtAL.whoHasSpaceAdminOrManageSprintsPermissionsPrompt))
            }
        ], [
        formatMessage,
        formatExplicitPermissionsSkillPrompt
    ]);
    const randomNudge = (0, $fxuX9.useRandomNudge)(nudges);
    (0, $euxye.useEffect)(()=>{
        if (randomNudge) updateConfiguration({
            nudges: [
                randomNudge
            ]
        });
    }, [
        randomNudge,
        updateConfiguration
    ]);
    return null;
};
$c8e2abfcfae60a88$export$11f506d17a9fb51e.displayName = "AiRovoPermissionsNudgesProvider";

});
parcelRegister("fxuX9", function(module, exports) {
$parcel$export(module.exports, "useRandomNudge", () => $8eccbdad54b078e2$export$e361eff6d0763c25);

var $5qM2l = parcelRequire("5qM2l");
const $8eccbdad54b078e2$export$e361eff6d0763c25 = (nudges)=>{
    const randomIndex = (0, $5qM2l.useRandomNumber)(nudges.length - 1);
    if (nudges.length === 0) return undefined;
    if (randomIndex > nudges.length - 1) return nudges[0];
    return nudges[randomIndex];
};

});
parcelRegister("5qM2l", function(module, exports) {
$parcel$export(module.exports, "useRandomNumber", () => $6ee486bb1202693c$export$5c24b43a40935117);

var $euxye = parcelRequire("euxye");
const $6ee486bb1202693c$export$5c24b43a40935117 = (max, options)=>{
    const [number] = (0, $euxye.useState)(()=>{
        const rng = options?.randomFn ?? Math.random;
        if (max < 0) return 0;
        return Math.floor(rng() * (max + 1));
    });
    return number;
};

});



parcelRegister("fh0ov", function(module, exports) {
$parcel$export(module.exports, "AiRovoSlaNudgesProvider", () => $984a2721f1049354$export$c18115c8b9271475);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");

var $8exkr = parcelRequire("8exkr");
const $984a2721f1049354$export$c18115c8b9271475 = ()=>{
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const slaConfig = (0, $8exkr.useSlaConfig)();
    (0, $euxye.useEffect)(()=>{
        updateConfiguration({
            nudges: [],
            getActions: slaConfig.getActions,
            tags: slaConfig.tags
        });
    }, [
        slaConfig,
        updateConfiguration
    ]);
    return null;
};
$984a2721f1049354$export$c18115c8b9271475.displayName = "AiRovoSlaNudgesProvider";

});

parcelRegister("RovSv", function(module, exports) {
$parcel$export(module.exports, "AiRovoSpacePermissionNudgesProvider", () => $3eaea52f9c0f8e7e$export$3a64321cd107ab4e);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");

var $1V1EO = parcelRequire("1V1EO");

var $aN5aG = parcelRequire("aN5aG");

var $kJM81 = parcelRequire("kJM81");

var $1YIbA = parcelRequire("1YIbA");

var $50DkA = parcelRequire("50DkA");

var $fxuX9 = parcelRequire("fxuX9");
const $3eaea52f9c0f8e7e$export$3a64321cd107ab4e = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const { formatExplicitPermissionsSkillPrompt: formatExplicitPermissionsSkillPrompt } = (0, $aN5aG.useExplicitPermissionsSkillPrompt)();
    const nudges = (0, $euxye.useMemo)(()=>[
            {
                id: 'ai-rovo.space-permissions-nudge.who-can-browse',
                title: formatMessage((0, $1V1EO.whoCanBrowsePrompt)),
                description: formatMessage((0, $1V1EO.whoCanBrowsePrompt)),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                        label: formatMessage((0, $1V1EO.whoCanBrowsePrompt)),
                        size: "medium"
                    }),
                type: 'skill-action',
                handleType: (0, $50DkA.HandleActionType).Skill,
                staticPrompt: formatExplicitPermissionsSkillPrompt((0, $1V1EO.whoCanBrowsePrompt))
            },
            {
                id: 'ai-rovo.space-permissions-nudge.who-can-create-work-items',
                title: formatMessage((0, $1V1EO.whoCanCreateWorkItemsPrompt)),
                description: formatMessage((0, $1V1EO.whoCanCreateWorkItemsPrompt)),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                        label: formatMessage((0, $1V1EO.whoCanCreateWorkItemsPrompt)),
                        size: "medium"
                    }),
                type: 'skill-action',
                handleType: (0, $50DkA.HandleActionType).Skill,
                staticPrompt: formatExplicitPermissionsSkillPrompt((0, $1V1EO.whoCanCreateWorkItemsPrompt))
            },
            {
                id: 'ai-rovo.space-permissions-nudge.who-has-administer-spaces-permission',
                title: formatMessage((0, $1V1EO.whoHasAdministerSpacesPermissionPrompt)),
                description: formatMessage((0, $1V1EO.whoHasAdministerSpacesPermissionPrompt)),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                        label: formatMessage((0, $1V1EO.whoHasAdministerSpacesPermissionPrompt)),
                        size: "medium"
                    }),
                type: 'skill-action',
                handleType: (0, $50DkA.HandleActionType).Skill,
                staticPrompt: formatExplicitPermissionsSkillPrompt((0, $1V1EO.whoHasAdministerSpacesPermissionPrompt))
            }
        ], [
        formatMessage,
        formatExplicitPermissionsSkillPrompt
    ]);
    const randomNudge = (0, $fxuX9.useRandomNudge)(nudges);
    (0, $euxye.useEffect)(()=>{
        if (randomNudge) updateConfiguration({
            nudges: [
                randomNudge
            ]
        });
    }, [
        randomNudge,
        updateConfiguration
    ]);
    return null;
};
$3eaea52f9c0f8e7e$export$3a64321cd107ab4e.displayName = "AiRovoSpacePermissionNudgesProvider";

});

parcelRegister("jo2lD", function(module, exports) {
$parcel$export(module.exports, "AiRovoNavigationNudgesProvider", () => $223c9678faabcb7b$export$e4d81b8c5ee25c69);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");

var $d8LhJ = parcelRequire("d8LhJ");

var $kJM81 = parcelRequire("kJM81");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $50DkA = parcelRequire("50DkA");

var $ccEzE = parcelRequire("ccEzE");
const $223c9678faabcb7b$var$findJiraSettingsTitle = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.navigation-nudge.find-jira-settings-title",
    defaultMessage: "Find Jira settings"
});
const $223c9678faabcb7b$var$findJiraSettingsDescription = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.navigation-nudge.find-jira-settings-description",
    defaultMessage: "Learn how the find-jira-settings Rovo Skill can help you"
});
const $223c9678faabcb7b$var$findJiraSettingsPrompt = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.navigation-nudge.find-jira-settings-prompt",
    defaultMessage: "This is my first time using the 'find-jira-settings' Rovo Skill. How can it help me?"
});
const $223c9678faabcb7b$var$isNudgeEnabledForApplicationEdition = (appEditions)=>{
    return appEditions.software === (0, $d8LhJ.STANDARD_EDITION) || appEditions.core === (0, $d8LhJ.STANDARD_EDITION) || appEditions.software === (0, $d8LhJ.FREE_EDITION) || appEditions.core === (0, $d8LhJ.FREE_EDITION);
};
const $223c9678faabcb7b$export$e4d81b8c5ee25c69 = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    (0, $euxye.useEffect)(()=>{
        if (!$223c9678faabcb7b$var$isNudgeEnabledForApplicationEdition(appEditions)) return;
        updateConfiguration({
            nudges: [
                {
                    id: 'ai-rovo.navigation-nudge.find-jira-settings',
                    title: formatMessage($223c9678faabcb7b$var$findJiraSettingsTitle),
                    description: formatMessage($223c9678faabcb7b$var$findJiraSettingsDescription),
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                            label: formatMessage($223c9678faabcb7b$var$findJiraSettingsTitle),
                            size: "medium"
                        }),
                    type: 'skill-action',
                    handleType: (0, $50DkA.HandleActionType).Skill,
                    staticPrompt: `/find-jira-settings ${formatMessage($223c9678faabcb7b$var$findJiraSettingsPrompt)}`
                }
            ]
        });
    }, [
        appEditions,
        formatMessage,
        updateConfiguration
    ]);
    return null;
};
$223c9678faabcb7b$export$e4d81b8c5ee25c69.displayName = "AiRovoNavigationNudgesProvider";

});

parcelRegister("hY2b0", function(module, exports) {
$parcel$export(module.exports, "AiRovoProjectSettingDetailNudgesProvider", () => $35b55a66544b2c47$export$8ee10775c33b4f94);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");

var $d8LhJ = parcelRequire("d8LhJ");

var $kJM81 = parcelRequire("kJM81");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $50DkA = parcelRequire("50DkA");

var $ccEzE = parcelRequire("ccEzE");
const $35b55a66544b2c47$var$findJiraSettingsTitle = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.project-setting-detail-nudge.find-jira-settings-title",
    defaultMessage: "Find Jira settings"
});
const $35b55a66544b2c47$var$findJiraSettingsDescription = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.project-setting-detail-nudge.find-jira-settings-description",
    defaultMessage: "Learn how the find-jira-settings Rovo Skill can help you"
});
const $35b55a66544b2c47$var$findJiraSettingsPrompt = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.project-setting-detail-nudge.find-jira-settings-prompt",
    defaultMessage: "This is my first time using the 'find-jira-settings' Rovo Skill. How can it help me?"
});
const $35b55a66544b2c47$var$isNudgeEnabledForApplicationEdition = (appEditions)=>{
    return appEditions.software === (0, $d8LhJ.STANDARD_EDITION) || appEditions.core === (0, $d8LhJ.STANDARD_EDITION) || appEditions.software === (0, $d8LhJ.FREE_EDITION) || appEditions.core === (0, $d8LhJ.FREE_EDITION);
};
const $35b55a66544b2c47$export$8ee10775c33b4f94 = ()=>{
    const appEditions = (0, $ccEzE.useAppEditions)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    (0, $euxye.useEffect)(()=>{
        if (!$35b55a66544b2c47$var$isNudgeEnabledForApplicationEdition(appEditions)) return;
        updateConfiguration({
            nudges: [
                {
                    id: 'ai-rovo.project-setting-detail-nudge.find-jira-settings',
                    title: formatMessage($35b55a66544b2c47$var$findJiraSettingsTitle),
                    description: formatMessage($35b55a66544b2c47$var$findJiraSettingsDescription),
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                            label: formatMessage($35b55a66544b2c47$var$findJiraSettingsTitle),
                            size: "medium"
                        }),
                    type: 'skill-action',
                    handleType: (0, $50DkA.HandleActionType).Skill,
                    staticPrompt: `/find-jira-settings ${formatMessage($35b55a66544b2c47$var$findJiraSettingsPrompt)}`
                }
            ]
        });
    }, [
        appEditions,
        formatMessage,
        updateConfiguration
    ]);
    return null;
};
$35b55a66544b2c47$export$8ee10775c33b4f94.displayName = "AiRovoProjectSettingDetailNudgesProvider";

});

parcelRegister("jG2Pz", function(module, exports) {
$parcel$export(module.exports, "AiRovoAiSpaceCreationNudgesProvider", () => $88f6d27e0203fba9$export$7754f8c38028a8b1);

var $euxye = parcelRequire("euxye");

var $bWZpq = parcelRequire("bWZpq");

var $kZlsx = parcelRequire("kZlsx");

var $atkNk = parcelRequire("atkNk");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $50DkA = parcelRequire("50DkA");

var $i860n = parcelRequire("i860n");

var $ezKom = parcelRequire("ezKom");

var $Bq7bE = parcelRequire("Bq7bE");

var $2mxRb = parcelRequire("2mxRb");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7eRMc = parcelRequire("7eRMc");
const $88f6d27e0203fba9$var$nudgeTitle = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.ai-space-creation-nudge.title",
    defaultMessage: "Suggest work items"
});
const $88f6d27e0203fba9$var$nudgeSecondaryDescription = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.ai-space-creation-nudge.secondary-description",
    defaultMessage: "Tailored to your new space"
});
const $88f6d27e0203fba9$var$inputBeforePrompt = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.ai-space-creation-nudge.input-before-prompt",
    defaultMessage: "based on the prompt used to create this space:"
});
const $88f6d27e0203fba9$var$genericFallbackPrompt = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.ai-space-creation-nudge.generic-fallback-prompt",
    defaultMessage: "for my Jira Space"
});
const $88f6d27e0203fba9$var$NUDGE_ID = 'ai-rovo.ai-space-creation-nudge';
const $88f6d27e0203fba9$var$CREATE_WORK_ITEMS_SKILL_COMMAND = '/create-work-items';
const $88f6d27e0203fba9$var$CREATE_WORK_ITEMS_SKILL_SLUG = $88f6d27e0203fba9$var$CREATE_WORK_ITEMS_SKILL_COMMAND.slice(1);
const $88f6d27e0203fba9$var$ROVO_SKILL_COMBINED_EXTENSION_KEY = 'skill:skillTag';
const $88f6d27e0203fba9$var$ROVO_SKILL_EXTENSION_TYPE = 'com.atlassian.rovo.skill';
const $88f6d27e0203fba9$var$createSkillNode = (slug)=>({
        type: 'inlineExtension',
        attrs: {
            extensionKey: $88f6d27e0203fba9$var$ROVO_SKILL_COMBINED_EXTENSION_KEY,
            extensionType: $88f6d27e0203fba9$var$ROVO_SKILL_EXTENSION_TYPE,
            parameters: {
                slug: slug
            }
        }
    });
/**
 * Builds an ADF document seeding the chat input with `introText` followed by the user's saved
 * prompt, preserving rich nodes.
 */ const $88f6d27e0203fba9$var$buildNudgePromptAdf = (introText, body)=>{
    if (!body || !body.content?.length) {
        const fallbackParagraph = {
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: introText
                }
            ]
        };
        return {
            version: 1,
            type: 'doc',
            content: [
                fallbackParagraph
            ]
        };
    }
    const introNode = {
        type: 'text',
        text: `${introText} `
    };
    const [firstBlock, ...restBlocks] = body.content;
    if (firstBlock.type === 'paragraph') {
        const mergedParagraph = {
            ...firstBlock,
            content: [
                introNode,
                ...firstBlock.content ?? []
            ]
        };
        return {
            version: 1,
            type: 'doc',
            content: [
                mergedParagraph,
                ...restBlocks
            ]
        };
    }
    const introParagraph = {
        type: 'paragraph',
        content: [
            introNode
        ]
    };
    return {
        version: 1,
        type: 'doc',
        content: [
            introParagraph,
            ...body.content
        ]
    };
};
const $88f6d27e0203fba9$var$prependCreateWorkItemsSkillCommandToAdf = (body)=>{
    const prefix = [
        $88f6d27e0203fba9$var$createSkillNode($88f6d27e0203fba9$var$CREATE_WORK_ITEMS_SKILL_SLUG),
        {
            type: 'text',
            text: ' '
        }
    ];
    const [firstBlock, ...restBlocks] = body.content ?? [];
    if (firstBlock?.type === 'paragraph') {
        const paragraph = {
            ...firstBlock,
            content: [
                ...prefix,
                ...firstBlock.content ?? []
            ]
        };
        return {
            ...body,
            version: 1,
            type: 'doc',
            content: [
                paragraph,
                ...restBlocks
            ]
        };
    }
    return {
        ...body,
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: prefix
            },
            ...body.content ?? []
        ]
    };
};
const $88f6d27e0203fba9$export$7754f8c38028a8b1 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const [submittedPrompt] = (0, $kZlsx.useAiSpaceCreationSubmittedPrompt)();
    const [uploadedFiles] = (0, $kZlsx.useAiSpaceCreationUploadedFiles)();
    const { clearSubmittedPrompt: clearSubmittedPrompt } = (0, $kZlsx.useAiSpaceCreationSubmittedPromptActions)();
    const [nudgePending] = (0, $kZlsx.useAiSpaceCreationNudgePending)();
    const [singleInstrumentationId] = (0, $kZlsx.useAiSpaceCreationSingleInstrumentationId)();
    const sidebarApi = (0, $ezKom.useConversationAssistantSidebarApi)({});
    const { mode: mode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $Bq7bE.useRovoExperienceAPIStore)();
    const platformNudges = (0, $2mxRb.useAINudges)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const recoveryRef = (0, $euxye.useRef)(null);
    const hasStoredPrompt = submittedPrompt != null;
    const prompt = hasStoredPrompt ? `${formatMessage($88f6d27e0203fba9$var$inputBeforePrompt)} ${(0, $7eRMc.extractTextFromAdfDoc)(submittedPrompt)}` : formatMessage($88f6d27e0203fba9$var$genericFallbackPrompt);
    const promptAdf = (0, $euxye.useMemo)(()=>{
        if (!(0, $i860n.fg)('rovo_insert_prompt_adf')) return undefined;
        const promptBodyAdf = hasStoredPrompt ? $88f6d27e0203fba9$var$buildNudgePromptAdf(formatMessage($88f6d27e0203fba9$var$inputBeforePrompt), submittedPrompt) : $88f6d27e0203fba9$var$buildNudgePromptAdf(formatMessage($88f6d27e0203fba9$var$genericFallbackPrompt), null);
        return $88f6d27e0203fba9$var$prependCreateWorkItemsSkillCommandToAdf(promptBodyAdf);
    }, [
        formatMessage,
        hasStoredPrompt,
        submittedPrompt
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!nudgePending) return;
        // Rovo chat is currently open - close it so the nudge can render
        if (mode !== undefined) {
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'chat closed', $88f6d27e0203fba9$var$NUDGE_ID, {
                previousMode: mode
            });
            toggleConversationAssistantUIMode({
                sidebarApi: sidebarApi
            });
        }
        const nudge = {
            id: singleInstrumentationId ? `${$88f6d27e0203fba9$var$NUDGE_ID}:${singleInstrumentationId}` : $88f6d27e0203fba9$var$NUDGE_ID,
            title: formatMessage($88f6d27e0203fba9$var$nudgeTitle),
            secondaryTitle: formatMessage($88f6d27e0203fba9$var$nudgeSecondaryDescription),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($atkNk))), {
                    label: formatMessage($88f6d27e0203fba9$var$nudgeTitle),
                    size: "medium"
                }),
            handleType: (0, $50DkA.HandleActionType).Chat,
            dynamicPrompt: `${$88f6d27e0203fba9$var$CREATE_WORK_ITEMS_SKILL_COMMAND} ${prompt}`,
            dynamicPromptAdf: promptAdf,
            uploadedFiles: uploadedFiles.length > 0 ? uploadedFiles : undefined,
            nudgeContext: {
                id: $88f6d27e0203fba9$var$NUDGE_ID,
                selfEligible: true,
                ...singleInstrumentationId ? {
                    analyticsAttributes: {
                        singleInstrumentationID: singleInstrumentationId
                    }
                } : {}
            },
            encodeDynamicPromptAsSkill: true
        };
        recoveryRef.current = {
            nudge: nudge,
            confirmed: false
        };
        updateConfiguration({
            nudges: [
                nudge
            ]
        });
        clearSubmittedPrompt();
    }, [
        nudgePending,
        clearSubmittedPrompt,
        formatMessage,
        updateConfiguration,
        uploadedFiles,
        prompt,
        promptAdf,
        mode,
        sidebarApi,
        toggleConversationAssistantUIMode,
        createAnalyticsEvent,
        singleInstrumentationId
    ]);
    // Re-push once if the platform drops our nudge (e.g. chat-close / remount race).
    (0, $euxye.useEffect)(()=>{
        const state = recoveryRef.current;
        if (!state) return;
        const stillRegistered = platformNudges?.some((n)=>n.id === state.nudge.id) ?? false;
        if (stillRegistered) {
            state.confirmed = true;
            return;
        }
        if (!state.confirmed) return;
        recoveryRef.current = null;
        updateConfiguration({
            nudges: [
                state.nudge
            ]
        });
    }, [
        platformNudges,
        updateConfiguration
    ]);
    return null;
};
$88f6d27e0203fba9$export$7754f8c38028a8b1.displayName = "AiRovoAiSpaceCreationNudgesProvider";

});
parcelRegister("kZlsx", function(module, exports) {
$parcel$export(module.exports, "useAiSpaceCreationSubmittedPrompt", () => $77a65a4beae85513$export$906e89529e2919fc);
$parcel$export(module.exports, "useAiSpaceCreationUploadedFiles", () => $77a65a4beae85513$export$fb9f7286c7141107);
$parcel$export(module.exports, "useAiSpaceCreationNudgePending", () => $77a65a4beae85513$export$83ec8e9501709a65);
$parcel$export(module.exports, "useAiSpaceCreationSingleInstrumentationId", () => $77a65a4beae85513$export$a0c0aa32f0de5590);
$parcel$export(module.exports, "useAiSpaceCreationSubmittedPromptActions", () => $77a65a4beae85513$export$55d5def9628e10ed);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $77a65a4beae85513$var$initialState = {
    submittedPrompt: null,
    uploadedFiles: [],
    nudgePending: false,
    singleInstrumentationId: null
};
const $77a65a4beae85513$var$actions = {
    setSubmittedPrompt: (submittedPrompt)=>({ setState: setState })=>{
            setState({
                submittedPrompt: submittedPrompt
            });
        },
    setSubmittedUploadedFiles: (uploadedFiles)=>({ setState: setState })=>{
            setState({
                uploadedFiles: uploadedFiles
            });
        },
    setNudgePending: (nudgePending)=>({ setState: setState })=>{
            setState({
                nudgePending: nudgePending
            });
        },
    setSingleInstrumentationId: (singleInstrumentationId)=>({ setState: setState })=>{
            setState({
                singleInstrumentationId: singleInstrumentationId
            });
        },
    clearSubmittedPrompt: ()=>({ setState: setState })=>{
            setState({
                submittedPrompt: null,
                uploadedFiles: [],
                nudgePending: false,
                singleInstrumentationId: null
            });
        }
};
const $77a65a4beae85513$export$61738ed2208c8d11 = (0, $5QDqc.createStore)({
    name: 'aiSpaceCreationSubmittedPromptStore',
    initialState: $77a65a4beae85513$var$initialState,
    actions: $77a65a4beae85513$var$actions
});
const $77a65a4beae85513$export$906e89529e2919fc = (0, $3h1FP.createHook)($77a65a4beae85513$export$61738ed2208c8d11, {
    selector: ({ submittedPrompt: submittedPrompt })=>submittedPrompt
});
const $77a65a4beae85513$export$fb9f7286c7141107 = (0, $3h1FP.createHook)($77a65a4beae85513$export$61738ed2208c8d11, {
    selector: ({ uploadedFiles: uploadedFiles })=>uploadedFiles
});
const $77a65a4beae85513$export$83ec8e9501709a65 = (0, $3h1FP.createHook)($77a65a4beae85513$export$61738ed2208c8d11, {
    selector: ({ nudgePending: nudgePending })=>nudgePending
});
const $77a65a4beae85513$export$a0c0aa32f0de5590 = (0, $3h1FP.createHook)($77a65a4beae85513$export$61738ed2208c8d11, {
    selector: ({ singleInstrumentationId: singleInstrumentationId })=>singleInstrumentationId
});
const $77a65a4beae85513$export$55d5def9628e10ed = (0, $3h1FP.createActionsHook)($77a65a4beae85513$export$61738ed2208c8d11);

});

parcelRegister("atkNk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79fcbe32a9d8d3ca$var$_react = $79fcbe32a9d8d3ca$var$_interopRequireDefault((parcelRequire("euxye")));

var $79fcbe32a9d8d3ca$var$_baseNew = $79fcbe32a9d8d3ca$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $79fcbe32a9d8d3ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79fcbe32a9d8d3ca$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $79fcbe32a9d8d3ca$var$_react.default.createElement($79fcbe32a9d8d3ca$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$79fcbe32a9d8d3ca$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $79fcbe32a9d8d3ca$var$_default = module.exports.default = $79fcbe32a9d8d3ca$var$AiGenerativeTextIcon;

});

parcelRegister("2mxRb", function(module, exports) {
$parcel$export(module.exports, "useAINudges", () => $0df1f9892f594153$export$b854997b7299d67f);
$parcel$export(module.exports, "useIsNudgeVisible", () => $0df1f9892f594153$export$17170223ff11d032);

var $3h1FP = parcelRequire("3h1FP");

var $jvHCQ = parcelRequire("jvHCQ");
const $0df1f9892f594153$export$b854997b7299d67f = (0, $3h1FP.createStateHook)((0, $jvHCQ.AISmartButtonStore), {
    selector: (state)=>state.nudges
});
const $0df1f9892f594153$export$9af0fbebebbfec35 = (0, $3h1FP.createStateHook)((0, $jvHCQ.AISmartButtonStore), {
    selector: (state)=>state.buttonClickedTimestamp
});
const $0df1f9892f594153$export$2d43c7fdbd36cd6c = (0, $3h1FP.createStateHook)((0, $jvHCQ.AISmartButtonStore), {
    selector: (state)=>state.dailyBriefUnread
});
const $0df1f9892f594153$export$17170223ff11d032 = (0, $3h1FP.createStateHook)((0, $jvHCQ.AISmartButtonStore), {
    selector: (state)=>state.isNudgeVisible
});

});

parcelRegister("7eRMc", function(module, exports) {
$parcel$export(module.exports, "extractTextFromAdfDoc", () => $3721fb9035258469$export$a75ee0b46e58952f);
const $3721fb9035258469$var$hasKey = (obj, key)=>key in obj;
const $3721fb9035258469$var$collectText = (node)=>{
    if (!node || typeof node !== 'object') return '';
    const ownText = $3721fb9035258469$var$hasKey(node, 'text') && typeof node.text === 'string' ? node.text : '';
    const childrenText = $3721fb9035258469$var$hasKey(node, 'content') && Array.isArray(node.content) ? node.content.map($3721fb9035258469$var$collectText).join(' ') : '';
    return [
        ownText,
        childrenText
    ].filter(Boolean).join(' ').trim();
};
const $3721fb9035258469$export$a75ee0b46e58952f = (doc)=>{
    if (!doc) return '';
    return $3721fb9035258469$var$collectText(doc).replace(/\s+/g, ' ').trim();
};

});


parcelRegister("9FAc3", function(module, exports) {
$parcel$export(module.exports, "AiRovoJiraRovoSearchNudgesProvider", () => $b5e3b75d308cfac2$export$937ce50a850224bd);

var $euxye = parcelRequire("euxye");

var $bcqL7 = parcelRequire("bcqL7");

var $9ll9z = parcelRequire("9ll9z");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aWliK = parcelRequire("aWliK");

var $kFgCO = parcelRequire("kFgCO");

var $2700E = parcelRequire("2700E");

var $50DkA = parcelRequire("50DkA");

var $bWZpq = parcelRequire("bWZpq");
const $b5e3b75d308cfac2$var$searchAssistanceGreetingTitle = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.actions-route-provider.jira-rovo-search.assistance-greeting-title",
    defaultMessage: "Can I help you find something{name, select, undefined {} other {, {name}}}?"
});
const $b5e3b75d308cfac2$var$searchAssistanceNudgeSubheaderLabel = (0, $7eNDO.defineMessage)({
    id: "ai-rovo.actions-route-provider.jira-rovo-search.assistance-nudge-subheader",
    defaultMessage: "Search across your work to find what you need"
});
const $b5e3b75d308cfac2$export$937ce50a850224bd = (0, $aWliK.componentWithCondition)(()=>(0, $2700E.expVal)('jira_fsj_rovo_button_nudge', 'isEnabled', false), ()=>{
    const publishRovo = (0, $9ll9z.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { data: currentUser } = (0, $kFgCO.useCurrentUser)();
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    // Get user display name, preferring displayName over userFullname
    const user = currentUser?.user;
    const fullDisplayName = (user && 'displayName' in user ? user.displayName : null) || user?.userFullname || 'there';
    // Extract first name from display name (split by space and take first part)
    const firstName = (0, $euxye.useMemo)(()=>fullDisplayName === 'there' ? 'there' : fullDisplayName.split(' ')[0], [
        fullDisplayName
    ]);
    const title = formatMessage($b5e3b75d308cfac2$var$searchAssistanceGreetingTitle, {
        name: firstName || undefined
    });
    (0, $euxye.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const openSearchChat = ()=>{
                publishRovo({
                    type: 'chat-new',
                    source: 'advanced-search-jira',
                    openChat: true,
                    openChatMode: 'mini-modal',
                    data: {
                        dialogues: []
                    }
                });
            };
            const baseQueryStartersNudge = {
                id: 'nudge-to-query-starters-ai-action',
                title: title,
                secondaryTitle: formatMessage($b5e3b75d308cfac2$var$searchAssistanceNudgeSubheaderLabel),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcqL7))), {
                        label: "",
                        color: "currentColor"
                    }),
                handleType: (0, $50DkA.HandleActionType).Base,
                type: 'ai-action',
                nudgeContext: {
                    id: 'nudge-to-query-starters'
                },
                onClick: openSearchChat
            };
            updateConfiguration({
                nudges: [
                    {
                        ...baseQueryStartersNudge
                    }
                ]
            });
        }, 20000);
        return ()=>clearTimeout(timeoutId);
    }, [
        updateConfiguration,
        publishRovo,
        title,
        formatMessage
    ]);
    return null;
}, ()=>null);

});
parcelRegister("bcqL7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df727533991c4aac2a7e523738f16a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8275927b92cae0d1$var$_react = $8275927b92cae0d1$var$_interopRequireDefault((parcelRequire("euxye")));

var $8275927b92cae0d1$var$_baseNew = $8275927b92cae0d1$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $8275927b92cae0d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8275927b92cae0d1$var$AiSearchIcon = (props)=>/*#__PURE__*/ $8275927b92cae0d1$var$_react.default.createElement($8275927b92cae0d1$var$_baseNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$8275927b92cae0d1$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $8275927b92cae0d1$var$_default = module.exports.default = $8275927b92cae0d1$var$AiSearchIcon;

});


parcelRegister("gRkE6", function(module, exports) {
$parcel$export(module.exports, "AiRovoSchedulesNudgesProvider", () => $086850db448404ee$export$af2ed9a9f45789e3);

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $bWZpq = parcelRequire("bWZpq");

var $k98ta = parcelRequire("k98ta");
const $086850db448404ee$export$af2ed9a9f45789e3 = ()=>{
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const schedulesConfig = (0, $k98ta.useSchedulesRovoConfig)();
    (0, $euxye.useEffect)(()=>{
        if (!(0, $2700E.expVal)('jsm-workforce-skill-experiment', 'isEnabled', false)) return;
        updateConfiguration({
            // nudges to be added in a follow-up
            nudges: [],
            getActions: schedulesConfig.getActions,
            tags: schedulesConfig.tags
        });
    }, [
        schedulesConfig,
        updateConfiguration
    ]);
    return null;
};
$086850db448404ee$export$af2ed9a9f45789e3.displayName = "AiRovoSchedulesNudgesProvider";

});

parcelRegister("ernnh", function(module, exports) {
$parcel$export(module.exports, "AiRovoAvailabilityNudgesProvider", () => $f9a797af4443dec4$export$fa63b4ada9c48e58);

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $bWZpq = parcelRequire("bWZpq");

var $a1Lmx = parcelRequire("a1Lmx");
const $f9a797af4443dec4$export$fa63b4ada9c48e58 = ()=>{
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const availabilityConfig = (0, $a1Lmx.useAvailabilityRovoConfig)();
    (0, $euxye.useEffect)(()=>{
        if (!(0, $2700E.expVal)('jsm-workforce-skill-experiment', 'isEnabled', false)) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        updateConfiguration({
            // nudges to be added in a follow-up
            nudges: [],
            getActions: availabilityConfig.getActions,
            tags: availabilityConfig.tags
        });
    }, [
        availabilityConfig,
        updateConfiguration
    ]);
    return null;
};
$f9a797af4443dec4$export$fa63b4ada9c48e58.displayName = "AiRovoAvailabilityNudgesProvider";

});

parcelRegister("g1wUi", function(module, exports) {
$parcel$export(module.exports, "AiRovoCapacityNudgesProvider", () => $82b9c3a9f2f6c0f4$export$43534401640171d6);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $bWZpq = parcelRequire("bWZpq");

var $8CoVD = parcelRequire("8CoVD");
const $82b9c3a9f2f6c0f4$export$43534401640171d6 = ()=>{
    const { updateConfiguration: updateConfiguration } = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStoreActions)();
    const capacityConfig = (0, $8CoVD.useCapacityRovoConfig)();
    (0, $euxye.useEffect)(()=>{
        if (!(0, $i860n.fg)('jsm-workforce-skill')) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        updateConfiguration({
            // nudges to be added in a follow-up
            nudges: [],
            getActions: capacityConfig.getActions,
            tags: capacityConfig.tags
        });
    }, [
        capacityConfig,
        updateConfiguration
    ]);
    return null;
};
$82b9c3a9f2f6c0f4$export$43534401640171d6.displayName = "AiRovoCapacityNudgesProvider";

});

parcelRegister("3qMhu", function(module, exports) {
$parcel$export(module.exports, "useIsRovoForJiraOnboardingEnabled", () => $f4a2e827b2b0a52d$export$bd6fdc98fdef73a0);

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $i1J78 = parcelRequire("i1J78");

var $juYyi = parcelRequire("juYyi");

var $hP8lC = parcelRequire("hP8lC");
const $f4a2e827b2b0a52d$export$bd6fdc98fdef73a0 = (isFirstTwoWeeks)=>{
    const shouldShowRovoButton = (0, $i1J78.useShouldShowRovoButton)();
    const isAvailableForRoute = (0, $juYyi.useIsGlobalRovoButtonAvailableForRoute)();
    const isRovoOnboardingTargetRoute = (0, $hP8lC.useIsRovoOnboardingTargetRoute)();
    const isEnabled = isFirstTwoWeeks === true && shouldShowRovoButton && isAvailableForRoute && isRovoOnboardingTargetRoute && (0, $2700E.expVal)('jfind-rovo-for-jira-onboarding', 'isEnabled', false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        if (isEnabled) (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'exposed',
            actionSubject: 'feature'
        }), 'feature exposed', {
            flagKey: 'jfind-rovo-for-jira-onboarding',
            isEnabled: isEnabled
        });
    }, [
        isEnabled,
        createAnalyticsEvent
    ]);
    return isEnabled;
};

});
parcelRegister("i1J78", function(module, exports) {
$parcel$export(module.exports, "useShouldShowRovoButton", () => $2f54eee7b29c02f0$export$55826ddfbfb8d684);

var $7tjnB = parcelRequire("7tjnB");

var $6bGyp = parcelRequire("6bGyp");

var $eaLDc = parcelRequire("eaLDc");

var $1KydW = parcelRequire("1KydW");

var $2b39L = parcelRequire("2b39L");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");
const $2f54eee7b29c02f0$export$55826ddfbfb8d684 = ()=>{
    const { data: rovoEntitlementData } = (0, $6bGyp.useRovoEntitlementResource)();
    const isRovoLLMEnabled = rovoEntitlementData?.isRovoLLMEnabled ?? false;
    const licenseState = (0, $eaLDc.useLicenseStates)();
    const { hasSoftwareAccess: hasSoftwareAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess, hasServiceDeskAccess: hasServiceDeskAccess } = (0, $1KydW.useApplicationPermissions)();
    const { data: projectContextData } = (0, $2b39L.useProjectContext)();
    const projectType = projectContextData?.projectType;
    const softwareAccessEnabled = licenseState.software === (0, $7tjnB.LICENSE_STATE_ACTIVE) && hasSoftwareAccess;
    const isProductDiscoveryEnabled = licenseState.productDiscovery === (0, $7tjnB.LICENSE_STATE_ACTIVE) && hasProductDiscoveryAccess;
    const isServiceDeskEnabled = licenseState.serviceDesk === (0, $7tjnB.LICENSE_STATE_ACTIVE) && hasServiceDeskAccess && (0, $i860n.fg)('jsm_asap_ai_rovo_button');
    if (!isRovoLLMEnabled || ((0, $i860n.fg)('jpd-aifc-streaming') ? !softwareAccessEnabled && !isProductDiscoveryEnabled && !isServiceDeskEnabled : !softwareAccessEnabled)) return false;
    // Exclude service desk, customer service, and product discovery project pages
    if ((0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false)) return !((0, $i860n.fg)('jpd-aifc-streaming') ? projectType === 'customer_service' : projectType === 'customer_service' || projectType === 'product_discovery');
    if (projectType === 'customer_service' || projectType === 'product_discovery' && !(0, $i860n.fg)('jpd-aifc-streaming')) return false;
    return true;
};

});

parcelRegister("juYyi", function(module, exports) {
$parcel$export(module.exports, "useIsGlobalRovoButtonAvailableForRoute", () => $e8285dc9dd0f8672$export$41d029260a414439);

var $f2wVS = parcelRequire("f2wVS");

var $2700E = parcelRequire("2700E");
/**
 * Controls whether specific route groups can see the Rovo button.
 * Consult with the team in #global-rovo-button-roll-out in Slack if you have any questions.
 *
 * Add your route groups here to control visibility using an experiment, feature gate, or static false.
 * Returning false will disable the Rovo button for the route group.
 *
 * This is a copy of `@jira/ai-rovo__button/src/useIsGlobalRovoButtonAvailableForRoute.tsx` kept here
 * so that L2 packages (e.g. actions-route-provider) can consume it without depending on the L3
 * `@jira/ai-rovo__button` package. RouteName/RouteGroup type imports (from the L4
 * `@jira/platform__routing-route-name-types` package) are replaced with `string` — they are
 * type-only and not needed at runtime.
 *
 * When updating this file, keep it in sync with the original.
 * Tracked in: TODO — replace usages in @jira/ai-rovo__button with an import from here.
 */ const $e8285dc9dd0f8672$var$blacklistedJiraRouteGroups = {
    polaris: ()=>false,
    servicedesk: ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'project-settings-servicedesk': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'customer-service': ()=>false,
    'helpcenter-settings': ()=>false
};
/*
 * Controls whether specific routes can see the Rovo button.
 * Consult with the team in #global-rovo-button-roll-out in Slack if you have any questions.
 *
 * Add your routes here to control it using an experiment, feature gate, or static false value.
 * Returning false will disable the Rovo button for the route.
 */ const $e8285dc9dd0f8672$var$blacklistedJiraRoutes = {
    // 2/3p experiences
    'connect-general': ()=>false,
    'forge-spa-global': ()=>false,
    // JSM (additional routes not associated with servicedesk route group)
    'servicedesk-archived-work-items': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'jsm-list-nin': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'servicedesk-issues': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'forge-spa-servicedesk-queue': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    // CSM help center (additional routes not associated with helpcenter-settings route group)
    'helpcenter-settings-customer-access': ()=>false
};
const $e8285dc9dd0f8672$export$41d029260a414439 = (0, $f2wVS.createRouterSelector)((state)=>{
    const routeName = state.route.name;
    const routeGroup = state.route.group;
    // Group-level blacklisting takes precedence
    if (routeGroup && $e8285dc9dd0f8672$var$blacklistedJiraRouteGroups[routeGroup]) return $e8285dc9dd0f8672$var$blacklistedJiraRouteGroups[routeGroup]() ?? false;
    // Exclude embedded routes
    if (routeName.endsWith('-embed')) return false;
    // Exclude individual blacklisted routes
    if ($e8285dc9dd0f8672$var$blacklistedJiraRoutes[routeName]) return $e8285dc9dd0f8672$var$blacklistedJiraRoutes[routeName]() ?? false;
    return true;
});

});

parcelRegister("hP8lC", function(module, exports) {
$parcel$export(module.exports, "useIsRovoOnboardingTargetRoute", () => $4d396b3c7073ff15$export$e7e1ca93d5468c5e);

var $f2wVS = parcelRequire("f2wVS");

var $gtB5i = parcelRequire("gtB5i");
const $4d396b3c7073ff15$var$ROVO_ONBOARDING_TARGET_ROUTES = new Set([
    'software-boards',
    'software-backlog',
    'software-list'
]);
const $4d396b3c7073ff15$export$764aa36d9913dec9 = (0, $f2wVS.createRouterSelector)((state)=>$4d396b3c7073ff15$var$ROVO_ONBOARDING_TARGET_ROUTES.has(state.route.name));
const $4d396b3c7073ff15$export$e7e1ca93d5468c5e = ()=>{
    const isTargetRouteName = $4d396b3c7073ff15$export$764aa36d9913dec9();
    const subProduct = (0, $gtB5i.useSubProduct)();
    return isTargetRouteName && subProduct === 'software';
};

});





parcelRegister("kiCU2", function(module, exports) {
$parcel$export(module.exports, "SafeEmbeddedConfluencePanel", () => $1ece63a7937e821f$export$2d901a489872dd0d);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $5IsfY = parcelRequire("5IsfY");

var $f27UT = parcelRequire("f27UT");

var $29eRG = parcelRequire("29eRG");

var $jepRN = parcelRequire("jepRN");

var $86QNU = parcelRequire("86QNU");
const $1ece63a7937e821f$var$DELAY = 310;
const $1ece63a7937e821f$var$PanelInLayout = ()=>{
    const $ = (0, $e7boj.c)(13);
    const rightSidebarCurrentState = (0, $29eRG.useActiveRightSidebarState)();
    const [t0] = (0, $f27UT.useEmbeddedConfluenceSidePanel)();
    const { panel: isOpen } = t0;
    const [localPanelId, setLocalPanelId] = (0, $euxye.useState)();
    const prevPanelIdRef = (0, $euxye.useRef)();
    const delayRef = (0, $euxye.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, $86QNU.useEmbeddedPanelEntryPoint)();
    let t1;
    if ($[0] !== entryPointActions || $[1] !== isOpen) {
        t1 = ()=>{
            if (isOpen) entryPointActions?.load();
        };
        $[0] = entryPointActions;
        $[1] = isOpen;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== entryPointActions || $[4] !== isOpen || $[5] !== localPanelId) {
        t2 = [
            isOpen,
            entryPointActions,
            localPanelId
        ];
        $[3] = entryPointActions;
        $[4] = isOpen;
        $[5] = localPanelId;
        $[6] = t2;
    } else t2 = $[6];
    (0, $euxye.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[7] !== panelId || $[8] !== rightSidebarCurrentState) {
        t3 = ()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, $5IsfY.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, $1ece63a7937e821f$var$DELAY);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        };
        t4 = [
            panelId,
            rightSidebarCurrentState
        ];
        $[7] = panelId;
        $[8] = rightSidebarCurrentState;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $euxye.useEffect)(t3, t4);
    if (localPanelId !== (0, $5IsfY.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
    let t5;
    if ($[11] !== entryPoint) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
            xcss: $1ece63a7937e821f$var$panelStyles
        }, entryPoint);
        $[11] = entryPoint;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
$1ece63a7937e821f$var$PanelInLayout.displayName = "PanelInLayout";
/**
 * Gate-on variant: scopes the panel's store by the route-derived `issueKey`
 * passed from the layout, so the panel can live outside the issue-view tree.
 */ const $1ece63a7937e821f$var$SafeEmbeddedConfluencePanelWithIssueKey = (t0)=>{
    const $ = (0, $e7boj.c)(3);
    const { issueKey: issueKey } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1ece63a7937e821f$var$PanelInLayout, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== issueKey) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-embedded-confluence-panel",
            packageName: "jiraIssueCreateConfluenceContent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f27UT.EmbeddedConfluenceSidepanelContainerWithIssueKey), {
            issueKey: issueKey
        }, t1));
        $[1] = issueKey;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
$1ece63a7937e821f$var$SafeEmbeddedConfluencePanelWithIssueKey.displayName = "SafeEmbeddedConfluencePanelWithIssueKey";
/**
 * Gate-off variant: pre-migration behaviour — the container scopes itself via
 * `useIssueKey()`, which relies on the IssueContext being mirrored up to the
 * global store for layout-level consumers.
 */ const $1ece63a7937e821f$var$SafeEmbeddedConfluencePanelLegacy = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-embedded-confluence-panel",
            packageName: "jiraIssueCreateConfluenceContent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f27UT.EmbeddedConfluenceSidepanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($1ece63a7937e821f$var$PanelInLayout, null)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$1ece63a7937e821f$var$SafeEmbeddedConfluencePanelLegacy.displayName = "SafeEmbeddedConfluencePanelLegacy";
const $1ece63a7937e821f$export$2d901a489872dd0d = (0, $jepRN.componentWithFG)('remove-issue-context-mirror-on-wiv', $1ece63a7937e821f$var$SafeEmbeddedConfluencePanelWithIssueKey, $1ece63a7937e821f$var$SafeEmbeddedConfluencePanelLegacy);
const $1ece63a7937e821f$var$panelStyles = (0, $fbAgj.xcss)({
    padding: 'space.100',
    height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
});

});
parcelRegister("5IsfY", function(module, exports) {
$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $a0f5331695ac6e1c$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $a0f5331695ac6e1c$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $a0f5331695ac6e1c$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $a0f5331695ac6e1c$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $a0f5331695ac6e1c$export$8d0c4a26241944b8);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", () => $a0f5331695ac6e1c$export$a497288e64e9a343);
/* eslint-disable jira/filename-case */ const $a0f5331695ac6e1c$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $a0f5331695ac6e1c$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $a0f5331695ac6e1c$export$e34c4c923d934e7a = 'user-confluence-access';
const $a0f5331695ac6e1c$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $a0f5331695ac6e1c$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
const $a0f5331695ac6e1c$export$a497288e64e9a343 = 'embedded-confluence-panel-container';

});

parcelRegister("f27UT", function(module, exports) {
$parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", () => $d5022bdf43e6e7f7$export$a5c1c168018f0f16);
$parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainerWithIssueKey", () => $d5022bdf43e6e7f7$export$b41fa1b6f72dee7a);
$parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", () => $d5022bdf43e6e7f7$export$518aeea31a00450e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6XpMv = parcelRequire("6XpMv");

var $29eRG = parcelRequire("29eRG");

var $i860n = parcelRequire("i860n");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $5IsfY = parcelRequire("5IsfY");

var $8hYlh = parcelRequire("8hYlh");

var $dSs35 = parcelRequire("dSs35");

var $1Orf1 = parcelRequire("1Orf1");
/**
 * Container for {@link useEmbeddedConfluenceSidePanel}. Any component that uses this hook
 * must be wrapped in this container.
 */ const $d5022bdf43e6e7f7$var$Container = (0, $dB6ay.createContainer)();
const $d5022bdf43e6e7f7$var$DefaultStore = (0, $5QDqc.createStore)({
    actions: $8hYlh.actions,
    containedBy: $d5022bdf43e6e7f7$var$Container,
    initialState: $8hYlh.initialState,
    name: (0, $5IsfY.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $d5022bdf43e6e7f7$export$a5c1c168018f0f16 = ({ children: children })=>{
    const issueKey = (0, $6XpMv.useIssueKey)();
    /*
	In order for each usage of the store to manage the same state irregardless of
	their location in the component tree, we need to wrap components in a container
	with the same scope value. This is why we use the issueKey in the scope value.
	see https://atlassian.github.io/react-sweet-state/#/advanced/container?id=scoped-data-sharing
	for more information about scoped data sharing.

	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d5022bdf43e6e7f7$var$Container, {
        scope: `embedded-confluence-sidepanel-${issueKey}`
    }, children);
};
$d5022bdf43e6e7f7$export$a5c1c168018f0f16.displayName = "EmbeddedConfluenceSidepanelContainer";
const $d5022bdf43e6e7f7$export$b41fa1b6f72dee7a = ({ children: children, issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d5022bdf43e6e7f7$var$Container, {
        scope: `embedded-confluence-sidepanel-${issueKey}`
    }, children);
$d5022bdf43e6e7f7$export$b41fa1b6f72dee7a.displayName = "EmbeddedConfluenceSidepanelContainerWithIssueKey";
const $d5022bdf43e6e7f7$var$useDefaultStoreHook = (0, $3h1FP.createHook)($d5022bdf43e6e7f7$var$DefaultStore);
const $d5022bdf43e6e7f7$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
    const [state, { closeSidePanel: closeSidePanelAction, openSidePanel: openSidePanelAction, setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceData: setDeferredSpaceData, toggleExpandedState: toggleExpandedState, setIsDraftState: setIsDraftState, setConfluenceData: setConfluenceData }] = $d5022bdf43e6e7f7$var$useDefaultStoreHook();
    const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, $29eRG.useRightSidebarController)();
    // Captured from the writer's issue context (this hook is consumed inside the
    // issue/work-item provider tree). Behind `remove-issue-context-mirror-on-wiv`,
    // persisting it on open lets the layout-mounted panel reader report the correct
    // analytics surface without reading the issue-context store, which is empty for
    // layout-level consumers once the mirror is gone. (Read is inert when the gate
    // is off — nothing is stored.)
    const analyticsSource = (0, $6XpMv.useAnalyticsSource)();
    const openSidePanel = (0, $euxye.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
        const { initialWidth: initialWidth, displayType: displayType } = (0, $1Orf1.getDisplayInformation)();
        const shouldOpenPanel = displayType === (0, $dSs35.DisplayTypes).PANEL;
        if (shouldOpenPanel) {
            openSidePanelAction({
                contentId: contentId,
                contentType: contentType,
                embeddedConfluenceSource: embeddedConfluenceSource,
                analyticsSource: (0, $i860n.fg)('remove-issue-context-mirror-on-wiv') ? analyticsSource : undefined,
                data: data,
                displayType: displayType,
                initialWidth: initialWidth,
                hostname: hostname,
                isDraft: isDraft,
                isLive: isLive,
                mode: mode,
                onLinkPage: onLinkPage,
                onPublish: onPublish,
                shouldOpenModal: !shouldOpenPanel,
                url: url,
                title: title
            });
            openRightSidebar((0, $5IsfY.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
        } else openInModal();
    }, [
        analyticsSource,
        embeddedConfluenceSource,
        openRightSidebar,
        openSidePanelAction
    ]);
    const closeSidePanel = (0, $euxye.useCallback)(()=>{
        closeRightSidebar((0, $5IsfY.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
        closeSidePanelAction();
    }, [
        closeRightSidebar,
        closeSidePanelAction
    ]);
    return [
        state,
        {
            openSidePanel: openSidePanel,
            closeSidePanel: closeSidePanel,
            setDeferredSpaceData: setDeferredSpaceData,
            setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection,
            toggleExpandedState: toggleExpandedState,
            setIsDraftState: setIsDraftState,
            setConfluenceData: setConfluenceData
        }
    ];
};

});
parcelRegister("8hYlh", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $1754b1d83c8b68b4$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $1754b1d83c8b68b4$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ 
var $hxvOV = parcelRequire("hxvOV");

var $lgqbf = parcelRequire("lgqbf");

var $dSs35 = parcelRequire("dSs35");
const $1754b1d83c8b68b4$export$d4c72bab9d6cc13a = {
    confluenceData: {
        contentId: '',
        contentUrl: '',
        contentData: null,
        mode: (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        isDraft: false,
        isLive: false
    },
    contentActions: {},
    contentType: (0, $dSs35.ConfluenceContentTypes).PAGE,
    embeddedConfluenceSource: '',
    analyticsSource: undefined,
    displayType: (0, $dSs35.DisplayTypes).PANEL,
    panel: {
        initialWidth: 0,
        isOpen: false,
        isLoading: false,
        isExpanded: false
    },
    modal: {
        isOpen: false
    }
};
const $1754b1d83c8b68b4$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, analyticsSource: analyticsSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, isExpanded: isExpanded, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
        setState({
            confluenceData: {
                contentId: contentId,
                contentUrl: url,
                contentData: data,
                hostname: hostname,
                mode: mode,
                isDraft: isDraft,
                isLive: isLive,
                title: title,
                spaceKey: (0, $lgqbf.parseUrl)(url)?.spaceKey
            },
            contentActions: {
                onLinkPage: onLinkPage,
                onPublish: onPublish
            },
            embeddedConfluenceSource: embeddedConfluenceSource,
            analyticsSource: analyticsSource,
            contentType: contentType,
            displayType: displayType,
            panel: {
                initialWidth: initialWidth,
                isOpen: !shouldOpenModal,
                isExpanded: isExpanded
            },
            modal: {
                isOpen: shouldOpenModal
            }
        });
    };
const $1754b1d83c8b68b4$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
        setState($1754b1d83c8b68b4$export$d4c72bab9d6cc13a);
    };
const $1754b1d83c8b68b4$export$473e6cac57a0d506 = (deferredSpaceName, deferredSpaceKey)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                deferredSpaceName: deferredSpaceName,
                spaceKey: deferredSpaceKey || confluenceData.spaceKey
            },
            ...prevState
        });
    };
const $1754b1d83c8b68b4$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        setState({
            ...prevState,
            isDeferSpaceSelection: isDeferSpaceSelection,
            panel: {
                ...panel,
                isLoading: isLoading
            }
        });
    };
const $1754b1d83c8b68b4$export$b29d56f843007f2b = ()=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        const isCurrentlyExpanded = panel.isExpanded;
        setState({
            panel: {
                ...panel,
                isExpanded: !isCurrentlyExpanded
            },
            ...prevState
        });
    };
const $1754b1d83c8b68b4$export$5d0561abb73760f = ({ newIsDraftState: newIsDraftState })=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                isDraft: newIsDraftState
            },
            ...prevState
        });
    };
const $1754b1d83c8b68b4$export$1a8782a287467f35 = (newData)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...newData
            },
            ...prevState
        });
    };
const $1754b1d83c8b68b4$export$e324594224ef24da = {
    closeSidePanel: $1754b1d83c8b68b4$export$e81b26ab493ca52a,
    openSidePanel: $1754b1d83c8b68b4$export$aa5d06fef96639ba,
    setDeferredSpaceData: $1754b1d83c8b68b4$export$473e6cac57a0d506,
    setIsDraftState: $1754b1d83c8b68b4$export$5d0561abb73760f,
    setIsLoadingForDeferSpaceSelection: $1754b1d83c8b68b4$export$db9852cd4946540a,
    toggleExpandedState: $1754b1d83c8b68b4$export$b29d56f843007f2b,
    setConfluenceData: $1754b1d83c8b68b4$export$1a8782a287467f35
};

});
parcelRegister("hxvOV", function(module, exports) {
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $5e38d5a274f92cd0$export$816ef638e478449a);
var $5e38d5a274f92cd0$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});

parcelRegister("lgqbf", function(module, exports) {
$parcel$export(module.exports, "parsePageProps", () => $e1083fd4d3729c31$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $e1083fd4d3729c31$export$7a5253c0f62e0150);
parcelRequire("csRwP");
var $grVE5 = parcelRequire("grVE5");

var $fCKGX = parcelRequire("fCKGX");

var $58PKU = parcelRequire("58PKU");

var $hxvOV = parcelRequire("hxvOV");

var $4PB3A = parcelRequire("4PB3A");
function $e1083fd4d3729c31$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $e1083fd4d3729c31$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $e1083fd4d3729c31$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $fCKGX.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    const previewPanels = $e1083fd4d3729c31$var$parseQueryParam(parsedProps.query, 'previewPanels');
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $4PB3A.VIEW_PAGE).name:
        case (0, $4PB3A.VIEW_BLOG).name:
        case (0, $4PB3A.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $4PB3A.EDIT_PAGE_EMBED).name:
        case (0, $4PB3A.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $4PB3A.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $4PB3A.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        previewPanels: previewPanels,
        ...passThroughProps
    };
}
function $e1083fd4d3729c31$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $e1083fd4d3729c31$var$findAndMatchRoute((0, $4PB3A.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $4PB3A.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $e1083fd4d3729c31$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $e1083fd4d3729c31$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $e1083fd4d3729c31$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $e1083fd4d3729c31$var$matchUrl(pattern, url) {
    if (!$e1083fd4d3729c31$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $grVE5.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $grVE5.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $e1083fd4d3729c31$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $58PKU.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}
function $e1083fd4d3729c31$var$parseQueryParam(query, keyName) {
    for (const [key, value] of Object.entries(query)){
        if (key === keyName) return Array.isArray(value) ? value.join(',') : value;
    }
    return undefined;
}

});
parcelRegister("csRwP", function(module, exports) {
$parcel$export(module.exports, "matchPath", () => (parcelRequire("grVE5")).matchPath);
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $euxye = parcelRequire("euxye");

var $grVE5 = parcelRequire("grVE5");
function $91319f3aa484a0cc$var$_extends() {
    $91319f3aa484a0cc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $91319f3aa484a0cc$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $91319f3aa484a0cc$export$3add0d5dce533e2e = /*#__PURE__*/ $euxye.createContext(null);
const $91319f3aa484a0cc$export$145dfa71566a64dc = /*#__PURE__*/ $euxye.createContext(null);
const $91319f3aa484a0cc$var$AwaitContext = /*#__PURE__*/ $euxye.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $91319f3aa484a0cc$export$26749e8557646306 = /*#__PURE__*/ $euxye.createContext(null);
const $91319f3aa484a0cc$export$c7914228fb69b0f5 = /*#__PURE__*/ $euxye.createContext(null);
const $91319f3aa484a0cc$export$9072aa6dd1f93057 = /*#__PURE__*/ $euxye.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $91319f3aa484a0cc$var$RouteErrorContext = /*#__PURE__*/ $euxye.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $91319f3aa484a0cc$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$91319f3aa484a0cc$export$9c954a9d03d32f4a() && (0, $grVE5.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $euxye.useContext($91319f3aa484a0cc$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $91319f3aa484a0cc$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $grVE5.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $91319f3aa484a0cc$export$9c954a9d03d32f4a() {
    return $euxye.useContext($91319f3aa484a0cc$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $91319f3aa484a0cc$export$45d76561a5302f2b() {
    !$91319f3aa484a0cc$export$9c954a9d03d32f4a() && (0, $grVE5.UNSAFE_invariant)(false);
    return $euxye.useContext($91319f3aa484a0cc$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $91319f3aa484a0cc$export$1b3f31771c5d07c() {
    return $euxye.useContext($91319f3aa484a0cc$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $91319f3aa484a0cc$export$6c330e8992e8a295(pattern) {
    !$91319f3aa484a0cc$export$9c954a9d03d32f4a() && (0, $grVE5.UNSAFE_invariant)(false);
    let { pathname: pathname } = $91319f3aa484a0cc$export$45d76561a5302f2b();
    return $euxye.useMemo(()=>(0, $grVE5.matchPath)(pattern, (0, $grVE5.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $91319f3aa484a0cc$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $91319f3aa484a0cc$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $euxye.useContext($91319f3aa484a0cc$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $euxye.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $91319f3aa484a0cc$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $euxye.useContext($91319f3aa484a0cc$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $91319f3aa484a0cc$var$useNavigateStable() : $91319f3aa484a0cc$var$useNavigateUnstable();
}
function $91319f3aa484a0cc$var$useNavigateUnstable() {
    !$91319f3aa484a0cc$export$9c954a9d03d32f4a() && (0, $grVE5.UNSAFE_invariant)(false);
    let dataRouterContext = $euxye.useContext($91319f3aa484a0cc$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $euxye.useContext($91319f3aa484a0cc$export$26749e8557646306);
    let { matches: matches } = $euxye.useContext($91319f3aa484a0cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $91319f3aa484a0cc$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $grVE5.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $euxye.useRef(false);
    $91319f3aa484a0cc$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $euxye.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $grVE5.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $grVE5.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $91319f3aa484a0cc$var$OutletContext = /*#__PURE__*/ $euxye.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $91319f3aa484a0cc$export$4138103a3ae699cc() {
    return $euxye.useContext($91319f3aa484a0cc$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $91319f3aa484a0cc$export$a3be3530d8e40d0b(context) {
    let outlet = $euxye.useContext($91319f3aa484a0cc$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $91319f3aa484a0cc$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $euxye.useContext($91319f3aa484a0cc$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $91319f3aa484a0cc$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $euxye.useContext($91319f3aa484a0cc$export$26749e8557646306);
    let { matches: matches } = $euxye.useContext($91319f3aa484a0cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $91319f3aa484a0cc$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $grVE5.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $euxye.useMemo(()=>(0, $grVE5.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $91319f3aa484a0cc$export$5d3fca4a98652595(routes, locationArg) {
    return $91319f3aa484a0cc$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $91319f3aa484a0cc$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$91319f3aa484a0cc$export$9c954a9d03d32f4a() && (0, $grVE5.UNSAFE_invariant)(false);
    let { navigator: navigator } = $euxye.useContext($91319f3aa484a0cc$export$26749e8557646306);
    let { matches: parentMatches } = $euxye.useContext($91319f3aa484a0cc$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $91319f3aa484a0cc$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $grVE5.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $grVE5.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $grVE5.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $91319f3aa484a0cc$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $grVE5.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $grVE5.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $91319f3aa484a0cc$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $grVE5.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $91319f3aa484a0cc$var$DefaultErrorComponent() {
    let error = $91319f3aa484a0cc$export$ed527bf60f6e05f2();
    let message = (0, $grVE5.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $euxye.createElement($euxye.Fragment, null, /*#__PURE__*/ $euxye.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $euxye.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $euxye.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $91319f3aa484a0cc$var$defaultErrorElement = /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$DefaultErrorComponent, null);
class $91319f3aa484a0cc$var$RenderErrorBoundary extends $euxye.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $91319f3aa484a0cc$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $euxye.useContext($91319f3aa484a0cc$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $91319f3aa484a0cc$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $grVE5.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $91319f3aa484a0cc$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $91319f3aa484a0cc$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $euxye.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $91319f3aa484a0cc$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($91319f3aa484a0cc$var$DataRouterHook || {});
var $91319f3aa484a0cc$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($91319f3aa484a0cc$var$DataRouterStateHook || {});
function $91319f3aa484a0cc$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $91319f3aa484a0cc$var$useDataRouterContext(hookName) {
    let ctx = $euxye.useContext($91319f3aa484a0cc$export$3add0d5dce533e2e);
    !ctx && (0, $grVE5.UNSAFE_invariant)(false);
    return ctx;
}
function $91319f3aa484a0cc$var$useDataRouterState(hookName) {
    let state = $euxye.useContext($91319f3aa484a0cc$export$145dfa71566a64dc);
    !state && (0, $grVE5.UNSAFE_invariant)(false);
    return state;
}
function $91319f3aa484a0cc$var$useRouteContext(hookName) {
    let route = $euxye.useContext($91319f3aa484a0cc$export$9072aa6dd1f93057);
    !route && (0, $grVE5.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $91319f3aa484a0cc$var$useCurrentRouteId(hookName) {
    let route = $91319f3aa484a0cc$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $grVE5.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $91319f3aa484a0cc$export$5fc8298006ad9e58() {
    return $91319f3aa484a0cc$var$useCurrentRouteId($91319f3aa484a0cc$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $91319f3aa484a0cc$export$d0fd4b7106de2769() {
    let state = $91319f3aa484a0cc$var$useDataRouterState($91319f3aa484a0cc$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $91319f3aa484a0cc$export$600dc272ed516c15() {
    let dataRouterContext = $91319f3aa484a0cc$var$useDataRouterContext($91319f3aa484a0cc$var$DataRouterHook.UseRevalidator);
    let state = $91319f3aa484a0cc$var$useDataRouterState($91319f3aa484a0cc$var$DataRouterStateHook.UseRevalidator);
    return $euxye.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $91319f3aa484a0cc$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $91319f3aa484a0cc$var$useDataRouterState($91319f3aa484a0cc$var$DataRouterStateHook.UseMatches);
    return $euxye.useMemo(()=>matches.map((m)=>(0, $grVE5.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $91319f3aa484a0cc$export$1448a5050d252c4d() {
    let state = $91319f3aa484a0cc$var$useDataRouterState($91319f3aa484a0cc$var$DataRouterStateHook.UseLoaderData);
    let routeId = $91319f3aa484a0cc$var$useCurrentRouteId($91319f3aa484a0cc$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $91319f3aa484a0cc$export$fd5d37484eab868d(routeId) {
    let state = $91319f3aa484a0cc$var$useDataRouterState($91319f3aa484a0cc$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $91319f3aa484a0cc$export$fdc00f3f26066d5e() {
    let state = $91319f3aa484a0cc$var$useDataRouterState($91319f3aa484a0cc$var$DataRouterStateHook.UseActionData);
    let routeId = $91319f3aa484a0cc$var$useCurrentRouteId($91319f3aa484a0cc$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $91319f3aa484a0cc$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $euxye.useContext($91319f3aa484a0cc$var$RouteErrorContext);
    let state = $91319f3aa484a0cc$var$useDataRouterState($91319f3aa484a0cc$var$DataRouterStateHook.UseRouteError);
    let routeId = $91319f3aa484a0cc$var$useCurrentRouteId($91319f3aa484a0cc$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $91319f3aa484a0cc$export$78a72ddb39bdd145() {
    let value = $euxye.useContext($91319f3aa484a0cc$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $91319f3aa484a0cc$export$17f53340677d5831() {
    let value = $euxye.useContext($91319f3aa484a0cc$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $91319f3aa484a0cc$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $91319f3aa484a0cc$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $91319f3aa484a0cc$var$useDataRouterContext($91319f3aa484a0cc$var$DataRouterHook.UseBlocker);
    let state = $91319f3aa484a0cc$var$useDataRouterState($91319f3aa484a0cc$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $euxye.useState("");
    let blockerFunction = $euxye.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $91319f3aa484a0cc$var$_extends({}, currentLocation, {
                pathname: (0, $grVE5.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $91319f3aa484a0cc$var$_extends({}, nextLocation, {
                pathname: (0, $grVE5.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $euxye.useEffect(()=>{
        let key = String(++$91319f3aa484a0cc$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $euxye.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $grVE5.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $91319f3aa484a0cc$var$useNavigateStable() {
    let { router: router } = $91319f3aa484a0cc$var$useDataRouterContext($91319f3aa484a0cc$var$DataRouterHook.UseNavigateStable);
    let id = $91319f3aa484a0cc$var$useCurrentRouteId($91319f3aa484a0cc$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $euxye.useRef(false);
    $91319f3aa484a0cc$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $euxye.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $91319f3aa484a0cc$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $91319f3aa484a0cc$var$alreadyWarned$1 = {};
function $91319f3aa484a0cc$var$warningOnce(key, cond, message) {
    if (!cond && !$91319f3aa484a0cc$var$alreadyWarned$1[key]) $91319f3aa484a0cc$var$alreadyWarned$1[key] = true;
}
const $91319f3aa484a0cc$var$alreadyWarned = {};
function $91319f3aa484a0cc$var$warnOnce(key, message) {
    if (!$91319f3aa484a0cc$var$alreadyWarned[message]) {
        $91319f3aa484a0cc$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $91319f3aa484a0cc$var$logDeprecation = (flag, msg, link)=>$91319f3aa484a0cc$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $91319f3aa484a0cc$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $91319f3aa484a0cc$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $91319f3aa484a0cc$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $91319f3aa484a0cc$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $91319f3aa484a0cc$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $91319f3aa484a0cc$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $91319f3aa484a0cc$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $91319f3aa484a0cc$var$START_TRANSITION = "startTransition";
const $91319f3aa484a0cc$var$startTransitionImpl = $euxye[$91319f3aa484a0cc$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $91319f3aa484a0cc$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $euxye.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $euxye.useCallback((newState)=>{
        if (v7_startTransition && $91319f3aa484a0cc$var$startTransitionImpl) $91319f3aa484a0cc$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $euxye.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $euxye.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $euxye.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $euxye.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $euxye.useEffect(()=>$91319f3aa484a0cc$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $euxye.createElement($euxye.Fragment, null, /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $91319f3aa484a0cc$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $91319f3aa484a0cc$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $91319f3aa484a0cc$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $euxye.useRef();
    if (historyRef.current == null) historyRef.current = (0, $grVE5.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $euxye.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $euxye.useCallback((newState)=>{
        v7_startTransition && $91319f3aa484a0cc$var$startTransitionImpl ? $91319f3aa484a0cc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $euxye.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $euxye.useEffect(()=>$91319f3aa484a0cc$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $91319f3aa484a0cc$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$91319f3aa484a0cc$export$9c954a9d03d32f4a() && (0, $grVE5.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $euxye.useContext($91319f3aa484a0cc$export$26749e8557646306);
    let { matches: matches } = $euxye.useContext($91319f3aa484a0cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $91319f3aa484a0cc$export$45d76561a5302f2b();
    let navigate = $91319f3aa484a0cc$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $grVE5.resolveTo)(to, (0, $grVE5.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $euxye.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $91319f3aa484a0cc$export$910ae8079b2c2852(props) {
    return $91319f3aa484a0cc$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $91319f3aa484a0cc$export$e7b0ac011bb776c6(_props) {
    (0, $grVE5.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $91319f3aa484a0cc$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $grVE5.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$91319f3aa484a0cc$export$9c954a9d03d32f4a() && (0, $grVE5.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $euxye.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $91319f3aa484a0cc$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $grVE5.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $euxye.useMemo(()=>{
        let trailingPathname = (0, $grVE5.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $91319f3aa484a0cc$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $91319f3aa484a0cc$export$5d3fca4a98652595($91319f3aa484a0cc$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $91319f3aa484a0cc$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$ResolveAwait, null, children));
}
var $91319f3aa484a0cc$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($91319f3aa484a0cc$var$AwaitRenderStatus || {});
const $91319f3aa484a0cc$var$neverSettledPromise = new Promise(()=>{});
class $91319f3aa484a0cc$var$AwaitErrorBoundary extends $euxye.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $91319f3aa484a0cc$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $91319f3aa484a0cc$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $91319f3aa484a0cc$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $91319f3aa484a0cc$var$AwaitRenderStatus.error : "_data" in promise ? $91319f3aa484a0cc$var$AwaitRenderStatus.success : $91319f3aa484a0cc$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $91319f3aa484a0cc$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $91319f3aa484a0cc$var$AwaitRenderStatus.error && promise._error instanceof (0, $grVE5.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $91319f3aa484a0cc$var$neverSettledPromise;
        if (status === $91319f3aa484a0cc$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $91319f3aa484a0cc$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $91319f3aa484a0cc$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $euxye.createElement($91319f3aa484a0cc$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $91319f3aa484a0cc$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $91319f3aa484a0cc$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $euxye.createElement($euxye.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $91319f3aa484a0cc$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $euxye.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $euxye.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $euxye.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $91319f3aa484a0cc$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $91319f3aa484a0cc$export$e7b0ac011bb776c6) && (0, $grVE5.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $grVE5.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $91319f3aa484a0cc$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $91319f3aa484a0cc$export$daf73786167a7f72(matches) {
    return $91319f3aa484a0cc$var$_renderMatches(matches);
}
function $91319f3aa484a0cc$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $euxye.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $euxye.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $euxye.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $91319f3aa484a0cc$export$f30f7e456d254e83(routes, opts) {
    return (0, $grVE5.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $91319f3aa484a0cc$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $grVE5.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $91319f3aa484a0cc$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("grVE5", function(module, exports) {
$parcel$export(module.exports, "Action", () => $bf9be22ddd484810$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $bf9be22ddd484810$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $bf9be22ddd484810$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $bf9be22ddd484810$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "UNSAFE_invariant", () => $bf9be22ddd484810$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $bf9be22ddd484810$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $bf9be22ddd484810$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $bf9be22ddd484810$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $bf9be22ddd484810$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $bf9be22ddd484810$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $bf9be22ddd484810$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $bf9be22ddd484810$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $bf9be22ddd484810$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $bf9be22ddd484810$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "isRouteErrorResponse", () => $bf9be22ddd484810$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $bf9be22ddd484810$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $bf9be22ddd484810$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $bf9be22ddd484810$var$_extends() {
    $bf9be22ddd484810$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bf9be22ddd484810$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $bf9be22ddd484810$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($bf9be22ddd484810$export$e19cd5f9376f8cee || ($bf9be22ddd484810$export$e19cd5f9376f8cee = {}));
const $bf9be22ddd484810$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $bf9be22ddd484810$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $bf9be22ddd484810$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $bf9be22ddd484810$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $bf9be22ddd484810$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $bf9be22ddd484810$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $bf9be22ddd484810$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $bf9be22ddd484810$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $bf9be22ddd484810$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $bf9be22ddd484810$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $bf9be22ddd484810$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $bf9be22ddd484810$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $bf9be22ddd484810$export$fe53371bee54353d(to);
    }
    return $bf9be22ddd484810$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $bf9be22ddd484810$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $bf9be22ddd484810$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $bf9be22ddd484810$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $bf9be22ddd484810$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $bf9be22ddd484810$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $bf9be22ddd484810$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $bf9be22ddd484810$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $bf9be22ddd484810$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $bf9be22ddd484810$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $bf9be22ddd484810$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $bf9be22ddd484810$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $bf9be22ddd484810$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $bf9be22ddd484810$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $bf9be22ddd484810$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $bf9be22ddd484810$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $bf9be22ddd484810$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $bf9be22ddd484810$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $bf9be22ddd484810$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($bf9be22ddd484810$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $bf9be22ddd484810$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $bf9be22ddd484810$export$e19cd5f9376f8cee.Push;
        let location = $bf9be22ddd484810$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $bf9be22ddd484810$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $bf9be22ddd484810$export$e19cd5f9376f8cee.Replace;
        let location = $bf9be22ddd484810$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $bf9be22ddd484810$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $bf9be22ddd484810$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $bf9be22ddd484810$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($bf9be22ddd484810$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($bf9be22ddd484810$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $bf9be22ddd484810$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($bf9be22ddd484810$var$ResultType || ($bf9be22ddd484810$var$ResultType = {}));
const $bf9be22ddd484810$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $bf9be22ddd484810$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $bf9be22ddd484810$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $bf9be22ddd484810$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $bf9be22ddd484810$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($bf9be22ddd484810$var$isIndexRoute(route)) {
            let indexRoute = $bf9be22ddd484810$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $bf9be22ddd484810$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $bf9be22ddd484810$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $bf9be22ddd484810$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $bf9be22ddd484810$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $bf9be22ddd484810$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $bf9be22ddd484810$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $bf9be22ddd484810$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $bf9be22ddd484810$var$flattenRoutes(routes);
    $bf9be22ddd484810$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $bf9be22ddd484810$export$30d21fd6d7295f52(pathname);
        matches = $bf9be22ddd484810$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $bf9be22ddd484810$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $bf9be22ddd484810$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $bf9be22ddd484810$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $bf9be22ddd484810$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $bf9be22ddd484810$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $bf9be22ddd484810$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $bf9be22ddd484810$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $bf9be22ddd484810$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $bf9be22ddd484810$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $bf9be22ddd484810$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $bf9be22ddd484810$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $bf9be22ddd484810$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $bf9be22ddd484810$var$paramRe = /^:[\w-]+$/;
const $bf9be22ddd484810$var$dynamicSegmentValue = 3;
const $bf9be22ddd484810$var$indexRouteValue = 2;
const $bf9be22ddd484810$var$emptySegmentValue = 1;
const $bf9be22ddd484810$var$staticSegmentValue = 10;
const $bf9be22ddd484810$var$splatPenalty = -2;
const $bf9be22ddd484810$var$isSplat = (s)=>s === "*";
function $bf9be22ddd484810$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($bf9be22ddd484810$var$isSplat)) initialScore += $bf9be22ddd484810$var$splatPenalty;
    if (index) initialScore += $bf9be22ddd484810$var$indexRouteValue;
    return segments.filter((s)=>!$bf9be22ddd484810$var$isSplat(s)).reduce((score, segment)=>score + ($bf9be22ddd484810$var$paramRe.test(segment) ? $bf9be22ddd484810$var$dynamicSegmentValue : segment === "" ? $bf9be22ddd484810$var$emptySegmentValue : $bf9be22ddd484810$var$staticSegmentValue), initialScore);
}
function $bf9be22ddd484810$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $bf9be22ddd484810$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $bf9be22ddd484810$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $bf9be22ddd484810$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $bf9be22ddd484810$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $bf9be22ddd484810$export$a5c6d149b50c1d86($bf9be22ddd484810$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $bf9be22ddd484810$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $bf9be22ddd484810$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $bf9be22ddd484810$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $bf9be22ddd484810$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $bf9be22ddd484810$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $bf9be22ddd484810$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $bf9be22ddd484810$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $bf9be22ddd484810$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $bf9be22ddd484810$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $bf9be22ddd484810$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $bf9be22ddd484810$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $bf9be22ddd484810$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $bf9be22ddd484810$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $bf9be22ddd484810$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $bf9be22ddd484810$var$normalizeSearch(search),
        hash: $bf9be22ddd484810$var$normalizeHash(hash)
    };
}
function $bf9be22ddd484810$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $bf9be22ddd484810$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $bf9be22ddd484810$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $bf9be22ddd484810$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $bf9be22ddd484810$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $bf9be22ddd484810$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $bf9be22ddd484810$export$8ccf933b0513f8d0(toArg);
    else {
        to = $bf9be22ddd484810$var$_extends({}, toArg);
        $bf9be22ddd484810$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $bf9be22ddd484810$var$getInvalidPathError("?", "pathname", "search", to));
        $bf9be22ddd484810$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $bf9be22ddd484810$var$getInvalidPathError("#", "pathname", "hash", to));
        $bf9be22ddd484810$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $bf9be22ddd484810$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $bf9be22ddd484810$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $bf9be22ddd484810$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $bf9be22ddd484810$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $bf9be22ddd484810$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $bf9be22ddd484810$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $bf9be22ddd484810$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $bf9be22ddd484810$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $bf9be22ddd484810$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $bf9be22ddd484810$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $bf9be22ddd484810$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $bf9be22ddd484810$export$4051a07651545597(data, init) {
    return new $bf9be22ddd484810$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $bf9be22ddd484810$export$42a99a7a4bc0e76a extends Error {
}
class $bf9be22ddd484810$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $bf9be22ddd484810$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $bf9be22ddd484810$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $bf9be22ddd484810$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $bf9be22ddd484810$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $bf9be22ddd484810$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $bf9be22ddd484810$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $bf9be22ddd484810$var$unwrapTrackedPromise(value) {
    if (!$bf9be22ddd484810$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $bf9be22ddd484810$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $bf9be22ddd484810$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $bf9be22ddd484810$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $bf9be22ddd484810$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $bf9be22ddd484810$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $bf9be22ddd484810$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $bf9be22ddd484810$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $bf9be22ddd484810$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $bf9be22ddd484810$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $bf9be22ddd484810$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $bf9be22ddd484810$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $bf9be22ddd484810$var$validMutationMethods = new Set($bf9be22ddd484810$var$validMutationMethodsArr);
const $bf9be22ddd484810$var$validRequestMethodsArr = [
    "get",
    ...$bf9be22ddd484810$var$validMutationMethodsArr
];
const $bf9be22ddd484810$var$validRequestMethods = new Set($bf9be22ddd484810$var$validRequestMethodsArr);
const $bf9be22ddd484810$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $bf9be22ddd484810$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $bf9be22ddd484810$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $bf9be22ddd484810$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $bf9be22ddd484810$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $bf9be22ddd484810$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $bf9be22ddd484810$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $bf9be22ddd484810$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $bf9be22ddd484810$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $bf9be22ddd484810$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $bf9be22ddd484810$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $bf9be22ddd484810$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $bf9be22ddd484810$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $bf9be22ddd484810$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $bf9be22ddd484810$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $bf9be22ddd484810$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $bf9be22ddd484810$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$bf9be22ddd484810$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$bf9be22ddd484810$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $bf9be22ddd484810$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $bf9be22ddd484810$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $bf9be22ddd484810$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $bf9be22ddd484810$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $bf9be22ddd484810$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$bf9be22ddd484810$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($bf9be22ddd484810$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $bf9be22ddd484810$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $bf9be22ddd484810$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $bf9be22ddd484810$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $bf9be22ddd484810$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $bf9be22ddd484810$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $bf9be22ddd484810$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $bf9be22ddd484810$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $bf9be22ddd484810$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $bf9be22ddd484810$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($bf9be22ddd484810$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $bf9be22ddd484810$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $bf9be22ddd484810$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $bf9be22ddd484810$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $bf9be22ddd484810$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $bf9be22ddd484810$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $bf9be22ddd484810$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $bf9be22ddd484810$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $bf9be22ddd484810$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $bf9be22ddd484810$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $bf9be22ddd484810$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $bf9be22ddd484810$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $bf9be22ddd484810$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $bf9be22ddd484810$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $bf9be22ddd484810$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $bf9be22ddd484810$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $bf9be22ddd484810$var$findNearestBoundary(matches).route.id,
            {
                type: $bf9be22ddd484810$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $bf9be22ddd484810$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($bf9be22ddd484810$var$isErrorResult(result) && $bf9be22ddd484810$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $bf9be22ddd484810$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $bf9be22ddd484810$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $bf9be22ddd484810$var$_extends({
            matches: updatedMatches || matches
        }, $bf9be22ddd484810$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $bf9be22ddd484810$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $bf9be22ddd484810$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $bf9be22ddd484810$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $bf9be22ddd484810$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $bf9be22ddd484810$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $bf9be22ddd484810$var$ResultType.error,
            error: $bf9be22ddd484810$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($bf9be22ddd484810$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $bf9be22ddd484810$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($bf9be22ddd484810$var$isDeferredResult(result)) throw $bf9be22ddd484810$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($bf9be22ddd484810$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $bf9be22ddd484810$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $bf9be22ddd484810$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $bf9be22ddd484810$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $bf9be22ddd484810$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($bf9be22ddd484810$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $bf9be22ddd484810$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $bf9be22ddd484810$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $bf9be22ddd484810$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $bf9be22ddd484810$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $bf9be22ddd484810$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $bf9be22ddd484810$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $bf9be22ddd484810$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $bf9be22ddd484810$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $bf9be22ddd484810$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $bf9be22ddd484810$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$bf9be22ddd484810$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $bf9be22ddd484810$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $bf9be22ddd484810$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $bf9be22ddd484810$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $bf9be22ddd484810$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $bf9be22ddd484810$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $bf9be22ddd484810$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $bf9be22ddd484810$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $bf9be22ddd484810$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $bf9be22ddd484810$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $bf9be22ddd484810$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $bf9be22ddd484810$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $bf9be22ddd484810$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($bf9be22ddd484810$var$isRedirectResult(actionResult) || $bf9be22ddd484810$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $bf9be22ddd484810$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($bf9be22ddd484810$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $bf9be22ddd484810$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $bf9be22ddd484810$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($bf9be22ddd484810$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($bf9be22ddd484810$var$isDeferredResult(actionResult)) throw $bf9be22ddd484810$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $bf9be22ddd484810$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $bf9be22ddd484810$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $bf9be22ddd484810$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $bf9be22ddd484810$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $bf9be22ddd484810$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $bf9be22ddd484810$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $bf9be22ddd484810$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $bf9be22ddd484810$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $bf9be22ddd484810$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $bf9be22ddd484810$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $bf9be22ddd484810$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $bf9be22ddd484810$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $bf9be22ddd484810$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $bf9be22ddd484810$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $bf9be22ddd484810$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $bf9be22ddd484810$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($bf9be22ddd484810$var$isDeferredResult(result)) result = await $bf9be22ddd484810$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $bf9be22ddd484810$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($bf9be22ddd484810$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $bf9be22ddd484810$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($bf9be22ddd484810$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $bf9be22ddd484810$export$3e9cee6b33872309(!$bf9be22ddd484810$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $bf9be22ddd484810$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $bf9be22ddd484810$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $bf9be22ddd484810$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $bf9be22ddd484810$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($bf9be22ddd484810$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $bf9be22ddd484810$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $bf9be22ddd484810$export$e19cd5f9376f8cee.Replace : $bf9be22ddd484810$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $bf9be22ddd484810$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($bf9be22ddd484810$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $bf9be22ddd484810$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $bf9be22ddd484810$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $bf9be22ddd484810$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $bf9be22ddd484810$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $bf9be22ddd484810$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($bf9be22ddd484810$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $bf9be22ddd484810$var$ResultType.redirect,
                response: $bf9be22ddd484810$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $bf9be22ddd484810$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $bf9be22ddd484810$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $bf9be22ddd484810$var$ResultType.error,
                    error: $bf9be22ddd484810$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $bf9be22ddd484810$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $bf9be22ddd484810$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $bf9be22ddd484810$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $bf9be22ddd484810$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $bf9be22ddd484810$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $bf9be22ddd484810$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $bf9be22ddd484810$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $bf9be22ddd484810$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $bf9be22ddd484810$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $bf9be22ddd484810$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $bf9be22ddd484810$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $bf9be22ddd484810$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $bf9be22ddd484810$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $bf9be22ddd484810$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$bf9be22ddd484810$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $bf9be22ddd484810$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $bf9be22ddd484810$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $bf9be22ddd484810$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $bf9be22ddd484810$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $bf9be22ddd484810$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $bf9be22ddd484810$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $bf9be22ddd484810$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $bf9be22ddd484810$export$4d0306f8f6a4585b = Symbol("deferred");
function $bf9be22ddd484810$export$3336b097a6fbc59a(routes, opts) {
    $bf9be22ddd484810$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $bf9be22ddd484810$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $bf9be22ddd484810$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $bf9be22ddd484810$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $bf9be22ddd484810$var$createLocation("", $bf9be22ddd484810$export$fe53371bee54353d(url), null, "default");
        let matches = $bf9be22ddd484810$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$bf9be22ddd484810$var$isValidMethod(method) && method !== "HEAD") {
            let error = $bf9be22ddd484810$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $bf9be22ddd484810$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $bf9be22ddd484810$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $bf9be22ddd484810$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($bf9be22ddd484810$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $bf9be22ddd484810$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $bf9be22ddd484810$var$createLocation("", $bf9be22ddd484810$export$fe53371bee54353d(url), null, "default");
        let matches = $bf9be22ddd484810$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$bf9be22ddd484810$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $bf9be22ddd484810$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $bf9be22ddd484810$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $bf9be22ddd484810$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $bf9be22ddd484810$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $bf9be22ddd484810$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($bf9be22ddd484810$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$bf9be22ddd484810$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $bf9be22ddd484810$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($bf9be22ddd484810$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $bf9be22ddd484810$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $bf9be22ddd484810$var$isResponse(result) ? result : $bf9be22ddd484810$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($bf9be22ddd484810$var$isDataStrategyResult(e) && $bf9be22ddd484810$var$isResponse(e.result)) {
                if (e.type === $bf9be22ddd484810$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($bf9be22ddd484810$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $bf9be22ddd484810$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $bf9be22ddd484810$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $bf9be22ddd484810$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($bf9be22ddd484810$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($bf9be22ddd484810$var$isDeferredResult(result)) {
            let error = $bf9be22ddd484810$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $bf9be22ddd484810$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($bf9be22ddd484810$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($bf9be22ddd484810$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $bf9be22ddd484810$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $bf9be22ddd484810$var$_extends({}, context, {
                statusCode: $bf9be22ddd484810$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $bf9be22ddd484810$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $bf9be22ddd484810$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $bf9be22ddd484810$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $bf9be22ddd484810$var$isErrorResult(pendingActionResult[1]) ? $bf9be22ddd484810$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $bf9be22ddd484810$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $bf9be22ddd484810$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $bf9be22ddd484810$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $bf9be22ddd484810$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $bf9be22ddd484810$var$callDataStrategyImpl(dataStrategy || $bf9be22ddd484810$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($bf9be22ddd484810$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $bf9be22ddd484810$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($bf9be22ddd484810$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $bf9be22ddd484810$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $bf9be22ddd484810$export$fec11da027c70692(routes, context, error) {
    let newContext = $bf9be22ddd484810$var$_extends({}, context, {
        statusCode: $bf9be22ddd484810$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $bf9be22ddd484810$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $bf9be22ddd484810$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $bf9be22ddd484810$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $bf9be22ddd484810$export$cae722b0cc860f13(to ? to : ".", $bf9be22ddd484810$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $bf9be22ddd484810$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $bf9be22ddd484810$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $bf9be22ddd484810$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $bf9be22ddd484810$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $bf9be22ddd484810$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$bf9be22ddd484810$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$bf9be22ddd484810$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $bf9be22ddd484810$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $bf9be22ddd484810$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $bf9be22ddd484810$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$bf9be22ddd484810$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$bf9be22ddd484810$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $bf9be22ddd484810$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $bf9be22ddd484810$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $bf9be22ddd484810$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $bf9be22ddd484810$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $bf9be22ddd484810$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($bf9be22ddd484810$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $bf9be22ddd484810$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $bf9be22ddd484810$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $bf9be22ddd484810$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $bf9be22ddd484810$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $bf9be22ddd484810$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $bf9be22ddd484810$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $bf9be22ddd484810$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $bf9be22ddd484810$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $bf9be22ddd484810$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $bf9be22ddd484810$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($bf9be22ddd484810$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $bf9be22ddd484810$var$shouldRevalidateLoader(match, $bf9be22ddd484810$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $bf9be22ddd484810$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $bf9be22ddd484810$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $bf9be22ddd484810$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $bf9be22ddd484810$var$shouldRevalidateLoader(fetcherMatch, $bf9be22ddd484810$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $bf9be22ddd484810$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $bf9be22ddd484810$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $bf9be22ddd484810$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $bf9be22ddd484810$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $bf9be22ddd484810$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $bf9be22ddd484810$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$bf9be22ddd484810$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $bf9be22ddd484810$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $bf9be22ddd484810$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$bf9be22ddd484810$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $bf9be22ddd484810$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $bf9be22ddd484810$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $bf9be22ddd484810$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$bf9be22ddd484810$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $bf9be22ddd484810$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $bf9be22ddd484810$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $bf9be22ddd484810$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $bf9be22ddd484810$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $bf9be22ddd484810$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $bf9be22ddd484810$var$ResultType.data,
                result: undefined
            });
        };
        return $bf9be22ddd484810$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $bf9be22ddd484810$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $bf9be22ddd484810$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $bf9be22ddd484810$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $bf9be22ddd484810$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $bf9be22ddd484810$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $bf9be22ddd484810$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $bf9be22ddd484810$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($bf9be22ddd484810$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $bf9be22ddd484810$var$ResultType.error,
                error: e
            };
        }
        if (type === $bf9be22ddd484810$var$ResultType.error) return {
            type: $bf9be22ddd484810$var$ResultType.error,
            error: new $bf9be22ddd484810$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $bf9be22ddd484810$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $bf9be22ddd484810$var$ResultType.error) {
        if ($bf9be22ddd484810$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $bf9be22ddd484810$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $bf9be22ddd484810$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $bf9be22ddd484810$var$ResultType.error,
            error: result,
            statusCode: $bf9be22ddd484810$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($bf9be22ddd484810$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $bf9be22ddd484810$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($bf9be22ddd484810$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $bf9be22ddd484810$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $bf9be22ddd484810$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $bf9be22ddd484810$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $bf9be22ddd484810$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$bf9be22ddd484810$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $bf9be22ddd484810$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $bf9be22ddd484810$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($bf9be22ddd484810$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $bf9be22ddd484810$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $bf9be22ddd484810$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($bf9be22ddd484810$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $bf9be22ddd484810$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $bf9be22ddd484810$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $bf9be22ddd484810$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $bf9be22ddd484810$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $bf9be22ddd484810$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $bf9be22ddd484810$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $bf9be22ddd484810$export$3e9cee6b33872309(!$bf9be22ddd484810$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($bf9be22ddd484810$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $bf9be22ddd484810$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $bf9be22ddd484810$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($bf9be22ddd484810$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $bf9be22ddd484810$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $bf9be22ddd484810$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $bf9be22ddd484810$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($bf9be22ddd484810$var$isErrorResult(result)) {
            let boundaryMatch = $bf9be22ddd484810$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $bf9be22ddd484810$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($bf9be22ddd484810$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $bf9be22ddd484810$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($bf9be22ddd484810$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $bf9be22ddd484810$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $bf9be22ddd484810$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $bf9be22ddd484810$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $bf9be22ddd484810$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $bf9be22ddd484810$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $bf9be22ddd484810$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $bf9be22ddd484810$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $bf9be22ddd484810$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $bf9be22ddd484810$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $bf9be22ddd484810$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $bf9be22ddd484810$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($bf9be22ddd484810$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $bf9be22ddd484810$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $bf9be22ddd484810$export$8ccf933b0513f8d0(path) : path;
    return $bf9be22ddd484810$export$fe53371bee54353d($bf9be22ddd484810$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $bf9be22ddd484810$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $bf9be22ddd484810$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $bf9be22ddd484810$var$ResultType.data || result.type === $bf9be22ddd484810$var$ResultType.error);
}
function $bf9be22ddd484810$var$isRedirectDataStrategyResultResult(result) {
    return $bf9be22ddd484810$var$isResponse(result.result) && $bf9be22ddd484810$var$redirectStatusCodes.has(result.result.status);
}
function $bf9be22ddd484810$var$isDeferredResult(result) {
    return result.type === $bf9be22ddd484810$var$ResultType.deferred;
}
function $bf9be22ddd484810$var$isErrorResult(result) {
    return result.type === $bf9be22ddd484810$var$ResultType.error;
}
function $bf9be22ddd484810$var$isRedirectResult(result) {
    return (result && result.type) === $bf9be22ddd484810$var$ResultType.redirect;
}
function $bf9be22ddd484810$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $bf9be22ddd484810$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $bf9be22ddd484810$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $bf9be22ddd484810$var$isRedirectResponse(result) {
    if (!$bf9be22ddd484810$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $bf9be22ddd484810$var$isValidMethod(method) {
    return $bf9be22ddd484810$var$validRequestMethods.has(method.toLowerCase());
}
function $bf9be22ddd484810$var$isMutationMethod(method) {
    return $bf9be22ddd484810$var$validMutationMethods.has(method.toLowerCase());
}
async function $bf9be22ddd484810$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$bf9be22ddd484810$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($bf9be22ddd484810$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $bf9be22ddd484810$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $bf9be22ddd484810$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($bf9be22ddd484810$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $bf9be22ddd484810$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $bf9be22ddd484810$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $bf9be22ddd484810$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $bf9be22ddd484810$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $bf9be22ddd484810$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $bf9be22ddd484810$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $bf9be22ddd484810$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $bf9be22ddd484810$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $bf9be22ddd484810$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $bf9be22ddd484810$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $bf9be22ddd484810$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $bf9be22ddd484810$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $bf9be22ddd484810$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $bf9be22ddd484810$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $bf9be22ddd484810$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $bf9be22ddd484810$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $bf9be22ddd484810$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $bf9be22ddd484810$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($bf9be22ddd484810$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $bf9be22ddd484810$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($bf9be22ddd484810$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $bf9be22ddd484810$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("58PKU", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $406dae5b21bbdc6e$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $406dae5b21bbdc6e$export$3207c60940c4a9b0);

var $hxvOV = parcelRequire("hxvOV");

var $cpg7m = parcelRequire("cpg7m");
var $406dae5b21bbdc6e$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $406dae5b21bbdc6e$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $406dae5b21bbdc6e$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $406dae5b21bbdc6e$var$pageAllowedFeatures = {
    [(0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $406dae5b21bbdc6e$export$a3fda3dcee62e1cc.edit,
    [(0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $406dae5b21bbdc6e$export$a3fda3dcee62e1cc.view
};
const $406dae5b21bbdc6e$var$blogPostAllowedFeatures = {
    [(0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $406dae5b21bbdc6e$export$a3fda3dcee62e1cc.edit,
    [(0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $406dae5b21bbdc6e$export$a3fda3dcee62e1cc.view
};
const $406dae5b21bbdc6e$var$whiteboardAllowedFeatures = {
    [(0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $406dae5b21bbdc6e$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $406dae5b21bbdc6e$export$a3fda3dcee62e1cc.whiteboard
};
const $406dae5b21bbdc6e$var$contentTypeAllowedFeatures = {
    [(0, $cpg7m.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $406dae5b21bbdc6e$var$pageAllowedFeatures,
    [(0, $cpg7m.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $406dae5b21bbdc6e$var$blogPostAllowedFeatures,
    [(0, $cpg7m.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $406dae5b21bbdc6e$var$whiteboardAllowedFeatures
};
const $406dae5b21bbdc6e$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$406dae5b21bbdc6e$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("cpg7m", function(module, exports) {
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $d34d775ad32f9122$export$942a5fac9b8c9dc2);
var $d34d775ad32f9122$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});


parcelRegister("4PB3A", function(module, exports) {
$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $20fd829fa7f4612b$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $20fd829fa7f4612b$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $20fd829fa7f4612b$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $20fd829fa7f4612b$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $20fd829fa7f4612b$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "WHITEBOARD", () => $20fd829fa7f4612b$export$fbefbcc1445e8d74);
$parcel$export(module.exports, "namedRoutes", () => $20fd829fa7f4612b$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $20fd829fa7f4612b$export$5c59aa0922e65f1a);
const $20fd829fa7f4612b$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $20fd829fa7f4612b$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $20fd829fa7f4612b$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $20fd829fa7f4612b$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $20fd829fa7f4612b$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $20fd829fa7f4612b$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $20fd829fa7f4612b$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $20fd829fa7f4612b$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $20fd829fa7f4612b$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $20fd829fa7f4612b$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $20fd829fa7f4612b$export$65b723bb995d4fb6,
    VIEW_PAGE: $20fd829fa7f4612b$export$9257b5b55c8e2555,
    VIEW_BLOG: $20fd829fa7f4612b$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $20fd829fa7f4612b$export$bd2c9bb170b3681d,
    WHITEBOARD: $20fd829fa7f4612b$export$fbefbcc1445e8d74
};
const $20fd829fa7f4612b$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("dSs35", function(module, exports) {
$parcel$export(module.exports, "ConfluenceContentTypes", () => $10e37bd9e0699dfa$export$b39616d00ee96d40);
$parcel$export(module.exports, "DisplayTypes", () => $10e37bd9e0699dfa$export$c294d3f3727c1a0);
/* eslint-disable jira/filename-case */ const $10e37bd9e0699dfa$export$b39616d00ee96d40 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};
const $10e37bd9e0699dfa$export$c294d3f3727c1a0 = {
    MODAL: 'modal',
    PANEL: 'panel'
};

});


parcelRegister("1Orf1", function(module, exports) {
$parcel$export(module.exports, "getDisplayInformation", () => $1fe17a047e6921f7$export$ee79869f97207574);
$parcel$export(module.exports, "convertUrlByContentState", () => $1fe17a047e6921f7$export$d41c9cdfa202e9a7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hxvOV = parcelRequire("hxvOV");

var $dSs35 = parcelRequire("dSs35");
const $1fe17a047e6921f7$export$37e31995727dc8d7 = 0.5;
const $1fe17a047e6921f7$export$ee79869f97207574 = ()=>{
    /*
	We set the screen width to 50% of the screen width if the screen
	width is larger than 1024px because we want the Embedded Confluence in the side panel to
	take up half the screen width. The max of the side panel is 50% of the screen width and
	we are not able to set it wider. Jira Issue details panel will be forced down around 1875px
	screen width.
	If the screen width is less than 1024px, we'll set the panel width to 0 because we will be
	opening the EmbeddedContentModal instead and set displayType to Modal.
	This also assumes that we are currently on the full page version of a Jira Issue.
	*/ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) return {
        initialWidth: screenWidth * $1fe17a047e6921f7$export$37e31995727dc8d7,
        displayType: (0, $dSs35.DisplayTypes).PANEL
    };
    return {
        initialWidth: 0,
        displayType: (0, $dSs35.DisplayTypes).MODAL
    };
};
const $1fe17a047e6921f7$export$d41c9cdfa202e9a7 = ({ mode: mode, isDraft: isDraft, contentUrl: contentUrl, spaceKey: spaceKey })=>{
    // update spaceKey
    let newUrl = contentUrl.replace(/\/spaces\/.*?\/pages\//, `/spaces/${spaceKey}/pages/`);
    if (!isDraft) {
        // remove `draftShareId={id}` and the preceding `&` if it exists
        newUrl = newUrl.replace(/[&]*draftShareId=[^&]*/, '');
        if (mode === (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) {
            if (!newUrl.includes('edit-embed')) newUrl = newUrl.replace('/pages/', '/pages/edit-embed/');
        } else if (mode === (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) // Replaces /pages/edit-v2/ or /pages/edit-embed/ with /pages/
        newUrl = newUrl.replace(/\/pages\/edit[^/]*\//, '/pages/');
    }
    return newUrl;
};

});


parcelRegister("86QNU", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedPanelEntryPoint", () => $610f970767aad1ff$export$75ef2f025ecbf1de);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable eslint-comments/no-restricted-disable */ 
var $euxye = parcelRequire("euxye");

var $4C7HL = parcelRequire("4C7HL");

var $hxvOV = parcelRequire("hxvOV");
var $lgqbf = parcelRequire("lgqbf");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $f27UT = parcelRequire("f27UT");

var $1Orf1 = parcelRequire("1Orf1");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $1YIbA = parcelRequire("1YIbA");

var $dw2o9 = parcelRequire("dw2o9");

var $aqMLs = parcelRequire("aqMLs");

var $6QbXd = parcelRequire("6QbXd");

var $eNCei = parcelRequire("eNCei");

var $1Vxc3 = parcelRequire("1Vxc3");

var $g5W8n = parcelRequire("g5W8n");

var $agppF = parcelRequire("agppF");

var $aJowe = parcelRequire("aJowe");

var $gpbOt = parcelRequire("gpbOt");
const $610f970767aad1ff$var$entryPointParams = {};
const $610f970767aad1ff$export$12346a674644c156 = 'operational';
const $610f970767aad1ff$export$b81d6f4511cb89a5 = (action, eventName, params)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, setConfluenceData: setConfluenceData, contentUrl: contentUrl, embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel, isOpen: isOpen, mode: mode, havePublishedRef: havePublishedRef } = params;
    fireAnalyticsEvent({
        action: action,
        eventName: eventName,
        embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
        eventType: $610f970767aad1ff$export$12346a674644c156
    });
    if (isOpen) {
        if (eventName === 'edit-page/close') setConfluenceData({
            contentUrl: contentUrl,
            mode: (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
        });
        if (eventName === 'edit-page/load' && action === 'taskSuccess') {
            if (havePublishedRef.current && (0, $2700E.expValEquals)('cc_jira_cppp_publish_fix', 'isEnabled', true, false)) {
                havePublishedRef.current = false;
                return;
            }
            if (mode === (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) setConfluenceData({
                contentUrl: contentUrl,
                mode: (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
            });
        }
        if (eventName === 'edit-page/publish' && action === 'taskSuccess') {
            if ((0, $2700E.expValEquals)('cc_jira_cppp_publish_fix', 'isEnabled', true, false)) havePublishedRef.current = true;
            if (mode === (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) setConfluenceData({
                isDraft: false,
                contentUrl: contentUrl,
                mode: (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
        }
    }
};
const $610f970767aad1ff$export$75ef2f025ecbf1de = ()=>{
    const { locale: locale } = (0, $1YIbA.default)();
    const [state, actions] = (0, $f27UT.useEmbeddedConfluenceSidePanel)();
    const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen, isExpanded: isExpanded }, embeddedConfluenceSource: embeddedConfluenceSource, analyticsSource: analyticsSource } = state;
    const isPageDraft = isDraft && contentType === (0, $aqMLs.CONTENT_TYPE).PAGE;
    const parentProduct = (0, $aJowe.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $eNCei.embeddedPanelEntrypoint), $610f970767aad1ff$var$entryPointParams);
    const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
    // The panel is mounted in the shared layout, outside the issue/work-item
    // provider tree. Once the issue-context mirror is removed the analytics source
    // is empty here, so behind `remove-issue-context-mirror-on-wiv` we use the
    // source captured from the writer at open time.
    const fireAnalyticsEvent = (0, $agppF.useEmbeddedPageTracking)((0, $i860n.fg)('remove-issue-context-mirror-on-wiv') ? analyticsSource : undefined);
    const themeState = (0, $4C7HL.default)();
    const havePublishedRef = (0, $euxye.useRef)(false);
    /*
  	If the user is on a custom domain, we need to update the
  	hostname to reflect the parentProduct's hostname. By providing the hostname
  	prop we will force EP to use the parentProduct's hostname instead of the content's hostname
  	when on a custom domain (see EP code here https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/confluence/embedded-confluence-common/src/page/parsePageProps.ts#75).
  */ const contentHostname = (0, $1Vxc3.setHostnameForContent)(contentUrl, hostname);
    const onContentAction = (0, $euxye.useCallback)((action, eventName)=>{
        $610f970767aad1ff$export$b81d6f4511cb89a5(action, eventName, {
            fireAnalyticsEvent: fireAnalyticsEvent,
            setConfluenceData: actions.setConfluenceData,
            contentUrl: contentUrl,
            embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel,
            isOpen: isOpen,
            mode: mode,
            havePublishedRef: havePublishedRef
        });
    }, [
        actions,
        contentUrl,
        fireAnalyticsEvent,
        embeddedConfluenceSourceForPanel,
        isOpen,
        mode
    ]);
    const onClose = (0, $euxye.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeEmbeddedConfluencePanel',
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
        entryPointActions.unload();
        actions.closeSidePanel();
    }, [
        actions,
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSourceForPanel
    ]);
    const editAllowedFeatures = (0, $euxye.useMemo)(()=>[
            ...isDeferSpaceSelection ? [
                'publish-modal'
            ] : [],
            'template-browser'
        ], [
        isDeferSpaceSelection
    ]);
    const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
    const resolvedEditAllowedFeatures = (0, $euxye.useMemo)(()=>{
        if (shouldApplyEditFeatures) return editAllowedFeatures;
        return undefined;
    }, [
        shouldApplyEditFeatures,
        editAllowedFeatures
    ]);
    const shouldOpenPanel = isOpen && contentUrl;
    const { entryPointActions: epDraftModalActions, entryPointReferenceSubject: epDraftModalSubject } = (0, $jreC0.useEntryPoint)((0, $6QbXd.draftEmbeddedPageModalEntrypoint), {});
    const { entryPointActions: epModalActions, entryPointReferenceSubject: epModalSubject } = (0, $jreC0.useEntryPoint)((0, $dw2o9.embeddedConfluencePageModalEntrypoint), {});
    const { entryPointActions: whiteboardModalActions, entryPointReferenceSubject: whiteboardModalSubject } = (0, $jreC0.useEntryPoint)((0, $gpbOt.embeddedWhiteboardModalEntrypoint), {});
    const { openContinueDraftModal: openContinueDraftModal, handleEmbeddedContentAction: handleDraftContentAction, epMode: epMode } = (0, $g5W8n.useEmbeddedPageDraft)({
        url: contentUrl,
        isLive: isLive,
        embeddedConfluenceSource: embeddedConfluenceSource,
        onEmbeddedContentAction: onContentAction,
        onClose: onClose,
        linkConfluencePage: onLinkPage
    });
    const handleOnModalClose = (0, $euxye.useCallback)(()=>{
        actions.closeSidePanel();
        if (contentType === 'whiteboard') whiteboardModalActions.unload();
        else if (contentType === 'page') isPageDraft ? epDraftModalActions.unload() : epModalActions.unload();
    }, [
        actions,
        isPageDraft,
        epDraftModalActions,
        epModalActions,
        whiteboardModalActions,
        contentType
    ]);
    const runtimeProps = (0, $euxye.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isLive: isLive,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            onClose: onClose,
            onContentAction: onContentAction,
            parentProduct: parentProduct,
            spaceKey: (0, $lgqbf.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: (0, $1Orf1.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $lgqbf.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId,
            contentType: contentType,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                edit: resolvedEditAllowedFeatures
            },
            linkConfluencePage: onLinkPage
        }), [
        actions.setDeferredSpaceData,
        contentId,
        contentUrl,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        isDraft,
        isLive,
        locale,
        title,
        mode,
        epMode,
        onClose,
        onContentAction,
        onLinkPage,
        parentProduct,
        resolvedEditAllowedFeatures,
        themeState,
        isPageDraft,
        contentType
    ]);
    const whiteboardModalRuntimeProps = (0, $euxye.useMemo)(()=>({
            isOpen: true,
            locale: locale,
            hasFooterLogo: false,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            enableContract: true,
            onClose: onClose,
            onEmbeddedContentAction: onContentAction,
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            spaceKey: (0, $lgqbf.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: contentUrl,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId || (0, $lgqbf.parseUrl)(contentUrl)?.contentId || '',
            contentType: contentType
        }), [
        contentId,
        contentType,
        contentUrl,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        locale,
        title,
        onClose,
        onContentAction,
        parentProduct,
        themeState,
        actions.toggleExpandedState
    ]);
    const epModalRuntimeProps = (0, $euxye.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isOpen: true,
            enableContract: true,
            onClose: ()=>{
                isPageDraft ? openContinueDraftModal() : handleOnModalClose();
            },
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            url: (0, $1Orf1.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $lgqbf.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            isLive: isLive,
            embeddedConfluenceSource: embeddedConfluenceSource,
            spaceKey: (0, $lgqbf.parseUrl)(contentUrl)?.spaceKey,
            contentId: (0, $lgqbf.parseUrl)(contentUrl)?.contentId,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                edit: resolvedEditAllowedFeatures
            },
            linkConfluencePage: onLinkPage,
            themeState: themeState,
            onPageAction: isPageDraft ? handleDraftContentAction : onContentAction,
            navigationPolicy: undefined,
            hostname: contentHostname,
            isFullScreenEmbedView: true
        }), [
        locale,
        isDraft,
        actions.toggleExpandedState,
        actions.setDeferredSpaceData,
        parentProduct,
        isPageDraft,
        mode,
        epMode,
        contentUrl,
        isLive,
        embeddedConfluenceSource,
        resolvedEditAllowedFeatures,
        themeState,
        handleDraftContentAction,
        onContentAction,
        contentHostname,
        openContinueDraftModal,
        handleOnModalClose,
        onLinkPage
    ]);
    const setEntrypointActions = ()=>{
        if (!isExpanded) return entryPointActions;
        if (contentType === 'whiteboard') return whiteboardModalActions;
        if (contentType === 'page') return isDraft ? epDraftModalActions : epModalActions;
    };
    const setExpandedEntryPointData = ()=>{
        if (contentType === 'page') {
            if (isDraft) return {
                id: 'epDraftModalEntrypointContainer',
                entryPointReferenceSubject: epDraftModalSubject,
                runtimeProps: epModalRuntimeProps
            };
            return {
                id: 'epModalEntrypointContainer',
                entryPointReferenceSubject: epModalSubject,
                runtimeProps: epModalRuntimeProps
            };
        }
        if (contentType === 'whiteboard') return {
            id: 'embeddedWhiteboardModalEntrypointContainer',
            entryPointReferenceSubject: whiteboardModalSubject,
            runtimeProps: whiteboardModalRuntimeProps
        };
    };
    const entryPointData = setExpandedEntryPointData();
    const expandedEntryPointContainer = ()=>{
        if (contentType === 'page') {
            if (isDraft) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
                entryPointReferenceSubject: epDraftModalSubject,
                id: "epDraftModalEntrypointContainer",
                packageName: "@jira/issue__create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: epModalRuntimeProps
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
                entryPointReferenceSubject: epModalSubject,
                id: "epModalEntrypointContainer",
                packageName: "@jira/issue__create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: epModalRuntimeProps
            });
        }
        if (contentType === 'whiteboard') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            entryPointReferenceSubject: whiteboardModalSubject,
            id: "embeddedWhiteboardModalEntrypointContainer",
            packageName: "@jira/issue__create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: whiteboardModalRuntimeProps
        });
        return null;
    };
    return shouldOpenPanel && entryPointData ? {
        entryPointActions: setEntrypointActions(),
        entryPoint: isExpanded ? expandedEntryPointContainer() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epPanelEntrypointContainer",
            packageName: "@jira/issue__create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        ref: undefined,
        entryPoint: null
    };
};

});
parcelRegister("dw2o9", function(module, exports) {
$parcel$export(module.exports, "embeddedConfluencePageModalEntrypoint", () => $40107b6afcc37573$export$2798102ac94287d0);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $40107b6afcc37573$export$2798102ac94287d0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("f3oUE")), {
        moduleId: "74209e48",
        moduleName: "EmbeddedPageModalEmbeddedPageModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f3oUE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("64DJ5").then(()=>parcelRequire('5vQE0'));

});


parcelRegister("aqMLs", function(module, exports) {
$parcel$export(module.exports, "LINK_CREATE_DRAFT_STATUS", () => $51d99bdbab089651$export$b86d51ea0323efca);
$parcel$export(module.exports, "CONTENT_TYPE", () => $51d99bdbab089651$export$a982aaff75f1c348);
$parcel$export(module.exports, "CONTENT_TYPE_TO_ENTITY_KEYS", () => $51d99bdbab089651$export$de75e0e058bd457c);

var $grS97 = parcelRequire("grS97");
const $51d99bdbab089651$export$b86d51ea0323efca = 'draft';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// oxlint-disable-next-line no-unused-vars
const $51d99bdbab089651$var$LINK_CREATE_PUBLISH_STATUS = 'current';
const $51d99bdbab089651$export$a982aaff75f1c348 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $51d99bdbab089651$export$de75e0e058bd457c = {
    [$51d99bdbab089651$export$a982aaff75f1c348.PAGE]: (0, $grS97.entityKeys).confluencePage,
    [$51d99bdbab089651$export$a982aaff75f1c348.WHITEBOARD]: (0, $grS97.entityKeys).confluenceWhiteboard
};

});
parcelRegister("grS97", function(module, exports) {
$parcel$export(module.exports, "entityKeys", () => $9f9d217cb45d2c4a$export$be0551febfd6121e);
$parcel$export(module.exports, "ContentTypes", () => $9f9d217cb45d2c4a$export$b9e669a853ca2f38);
$parcel$export(module.exports, "Fields", () => $9f9d217cb45d2c4a$export$833b3e5a19fb8939);
$parcel$export(module.exports, "testIds", () => $9f9d217cb45d2c4a$export$800daf5fbbe96aff);
$parcel$export(module.exports, "CONFLUENCE_EVENT_NAME", () => $9f9d217cb45d2c4a$export$c312550dc4e28902);
const $9f9d217cb45d2c4a$export$be0551febfd6121e = {
    confluencePage: 'confluence-page',
    confluenceWhiteboard: 'confluence-whiteboard'
};
const $9f9d217cb45d2c4a$export$b9e669a853ca2f38 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
var $9f9d217cb45d2c4a$export$833b3e5a19fb8939 = /*#__PURE__*/ function(Fields) {
    Fields["Title"] = "title";
    Fields["Site"] = "site";
    Fields["SpacePage"] = "space_or_page";
    return Fields;
}({});
const $9f9d217cb45d2c4a$export$800daf5fbbe96aff = {
    form: 'link-create-confluence-form',
    title: 'link-create-confluence-title',
    site: 'link-create-confluence-site-picker',
    space: 'link-create-confluence-space-picker',
    error: 'link-create-confluence-form-error'
};
const $9f9d217cb45d2c4a$export$c312550dc4e28902 = {
    EDIT_PAGE: 'edit-page',
    EDIT_PAGE_LOAD: 'edit-page/load',
    EDIT_PAGE_PUBLISH: 'edit-page/publish',
    EDIT_PAGE_CLOSE: 'edit-page/close'
};

});


parcelRegister("6QbXd", function(module, exports) {
$parcel$export(module.exports, "draftEmbeddedPageModalEntrypoint", () => $a2a5c72c852d9994$export$11fd8fc5a8657f8);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $a2a5c72c852d9994$export$11fd8fc5a8657f8 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("4l9uY")), {
        moduleId: "e54a073c",
        moduleName: "DraftEmbeddedPageModalDraftEmbeddedPageModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4l9uY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gxgo0").then(()=>parcelRequire('5ZtmV'));

});


parcelRegister("eNCei", function(module, exports) {
$parcel$export(module.exports, "embeddedPanelEntrypoint", () => $ce388426c67724de$export$32561f984de7bece);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ce388426c67724de$export$32561f984de7bece = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("5dwud")), {
        moduleId: "5c935227",
        moduleName: "EmbeddedPanel",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5dwud", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cn2jy").then(()=>parcelRequire('8tFz6'));

});


parcelRegister("1Vxc3", function(module, exports) {
$parcel$export(module.exports, "createActivePageUrl", () => $7b9081653572d06f$export$83c6318baef117fe);
$parcel$export(module.exports, "getURLFromConfluencePageResponse", () => $7b9081653572d06f$export$e87b28852220b5cd);
$parcel$export(module.exports, "setHostnameForContent", () => $7b9081653572d06f$export$8ccd4cc378896990);
$parcel$export(module.exports, "constructUrlIfCustomDomain", () => $7b9081653572d06f$export$a63ef4c6a1286e2a);
$parcel$export(module.exports, "createLinkCreatePayload", () => $7b9081653572d06f$export$af98278c506da0f4);

var $1uH7N = parcelRequire("1uH7N");

var $5UNC5 = parcelRequire("5UNC5");

var $54n6h = parcelRequire("54n6h");
const $7b9081653572d06f$export$f31b9480a5e4fdcf = (uri)=>{
    if (!uri || uri === '') return '';
    const matches = uri.match(/draftShareId=([^&])*/g);
    return matches ? matches[0].split('=')[1] : '';
};
const $7b9081653572d06f$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
    if (!(url && spaceId && spaceKey)) return '';
    return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};
const $7b9081653572d06f$export$83c6318baef117fe = (createPayload)=>{
    const { data: data, url: url } = createPayload;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const links = data?.links;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const spaceKey = data?.spaceKey;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const spaceId = data?.spaceId;
    const linkableUrl = $7b9081653572d06f$export$be3b1ed3560ef0e6({
        url: url,
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    if (data?.subType === 'live') return `${linkableUrl}`;
    return `${linkableUrl}?draftShareId=${$7b9081653572d06f$export$f31b9480a5e4fdcf(links?.editui)}`;
};
const $7b9081653572d06f$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
const $7b9081653572d06f$var$isUrlCustomDomain = (parentHost, url)=>{
    const hostname = (0, $5UNC5.getHostnameFromUrl)(url);
    return (0, $54n6h.isCustomDomain)(parentHost) || hostname && (0, $54n6h.isCustomDomain)(hostname);
};
const $7b9081653572d06f$var$_diWindow = ()=>{
    (0, $1uH7N.di)(window);
    return window;
};
const $7b9081653572d06f$export$8ccd4cc378896990 = (url, hostname)=>{
    const parentHost = $7b9081653572d06f$var$_diWindow()?.location?.origin || '';
    const contentHost = hostname ?? (0, $5UNC5.getHostnameFromUrl)(url);
    return $7b9081653572d06f$var$isUrlCustomDomain(parentHost, url) ? (0, $5UNC5.getHostnameFromUrl)(parentHost) : contentHost;
};
const $7b9081653572d06f$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
    const currentHostname = $7b9081653572d06f$var$_diWindow()?.location?.origin || '';
    const hostnameFromUrl = (0, $5UNC5.getHostnameFromUrl)(originalDomain);
    const systemHostName = (0, $5UNC5.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    /*
  	If content is not on the same tenant, and custom domain is enabled, we need to update the hostname
  	to reflect the parentProduct's hostname
  */ if (systemHostName !== hostnameFromUrl && $7b9081653572d06f$var$isUrlCustomDomain(currentHostname, originalDomain)) return $7b9081653572d06f$export$e87b28852220b5cd({
        id: id,
        spaceKey: spaceKey,
        hostname: currentHostname
    });
    return originalUrl;
};
const $7b9081653572d06f$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
        url: url,
        ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
        objectId: createResponse.id,
        objectType: 'page',
        data: {
            spaceId: space.spaceId,
            spaceKey: space.spaceKey,
            spaceName: space.spaceName,
            status: createResponse.status,
            subType: createResponse.subtype,
            links: createResponse._links
        }
    });

});
parcelRegister("5UNC5", function(module, exports) {
$parcel$export(module.exports, "getHostnameFromUrl", () => $7d353fec1c65232e$export$280e79c794cf814e);

var $1JdnJ = parcelRequire("1JdnJ");
const $7d353fec1c65232e$export$280e79c794cf814e = (url)=>(0, $1JdnJ.isValidUrl)(url) ? new URL(url)?.hostname : '';

});
parcelRegister("1JdnJ", function(module, exports) {
$parcel$export(module.exports, "isValidUrl", () => $1beb694ac9db7b12$export$bef94a5618bf18bf);
const $1beb694ac9db7b12$export$bef94a5618bf18bf = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});


parcelRegister("54n6h", function(module, exports) {
$parcel$export(module.exports, "isCustomDomain", () => $9753cf66ac38abb2$export$97f4c254b641e719);
const $9753cf66ac38abb2$var$atlassianDomains = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $9753cf66ac38abb2$export$97f4c254b641e719 = (hostname)=>!$9753cf66ac38abb2$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));

});


parcelRegister("g5W8n", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedPageDraft", () => $98e92b876198f9ca$export$8df6d110f6d46988);
/* eslint-disable jira/i18n/no-export-define-message */ /* eslint-disable jira/choreographer/message-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $hxvOV = parcelRequire("hxvOV");

var $f27UT = parcelRequire("f27UT");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $acwzf = parcelRequire("acwzf");
var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $inMxE = parcelRequire("inMxE");


var $iIciE = parcelRequire("iIciE");

var $agppF = parcelRequire("agppF");
const $98e92b876198f9ca$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    publishPageSuccessTitle: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-title",
        defaultMessage: "Published!"
    },
    publishPageSuccessDescription: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-description",
        defaultMessage: "Successfully published page"
    },
    deferSpacePublishPageSuccessDescription: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.defer-space-publish-page-success-description",
        defaultMessage: "Your page was successfully published in the {spaceName} space"
    },
    publishPageFailedTitle: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-title",
        defaultMessage: "Something went wrong"
    },
    publishPageFailedDescription: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-description",
        defaultMessage: "We are unable to publish your page at this time"
    },
    linkPageFailedTitle: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-title",
        defaultMessage: "Something went wrong."
    },
    linkPageFailedDescription: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-description",
        defaultMessage: "We are unable to link your page at this time"
    },
    publishAndLinkPageSuccessTitle: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-title",
        defaultMessage: "Published!"
    },
    publishAndLinkPageSuccessDescription: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description",
        defaultMessage: "Your page has been published and linked to your Jira issue."
    },
    publishAndLinkPageSuccessDescriptionIssueTermRefresh: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description-issue-term-refresh",
        defaultMessage: "Your page has been published and linked to your Jira work item."
    },
    linkLiveDocSuccessTitle: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-title",
        defaultMessage: "Live doc created"
    },
    linkLiveDocSuccessDescription: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description",
        defaultMessage: "A live doc was created and linked to your Jira issue."
    },
    linkLiveDocSuccessDescriptionIssueTermRefresh: {
        id: "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description-issue-term-refresh",
        defaultMessage: "A live doc was created and linked to your Jira work item."
    }
});
const $98e92b876198f9ca$export$f0ebd8c41d592251 = 'success';
const $98e92b876198f9ca$export$12346a674644c156 = 'operational';
const $98e92b876198f9ca$export$8df6d110f6d46988 = ({ isLive: isLive, embeddedConfluenceSource: embeddedConfluenceSource, onClose: onClose, url: url, onEmbeddedContentAction: onEmbeddedContentAction, linkConfluencePage: linkConfluencePage })=>{
    const [{ panel: { isOpen: isOpen }, analyticsSource: analyticsSource }, actions] = (0, $f27UT.useEmbeddedConfluenceSidePanel)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [isContinueDraftOpen, setIsContinueDraftOpen] = (0, $euxye.useState)(false);
    const [isPublished, setIsPublished] = (0, $euxye.useState)(false);
    const [epMode, setEpMode] = (0, $euxye.useState)(isLive ? (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagService)();
    // This hook runs in the layout-mounted panel, outside the issue/work-item
    // provider tree. Once the issue-context mirror is removed the analytics source
    // is empty here, so behind `remove-issue-context-mirror-on-wiv` we use the
    // source captured from the writer at open time so events like deleteDraftPage
    // keep reporting jiraIssueSurfaceArea.
    const fireAnalyticsEvent = (0, $agppF.useEmbeddedPageTracking)((0, $i860n.fg)('remove-issue-context-mirror-on-wiv') ? analyticsSource : undefined);
    const handledLiveDocUrls = (0, $euxye.useRef)(new Set());
    const havePublishedRef = (0, $euxye.useRef)(false);
    const openContinueDraftModal = (0, $euxye.useCallback)(()=>{
        if (!isPublished) {
            setIsContinueDraftOpen(true);
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: isLive ? 'closeLiveDoc' : 'closeUnpublishedDraft',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
        } else onClose && onClose();
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        isLive,
        isPublished,
        onClose
    ]);
    const closeContinueDraftModal = ()=>{
        setIsContinueDraftOpen(false);
    };
    const closeAll = ()=>{
        closeContinueDraftModal();
        onClose && onClose();
    };
    const handleEmbeddedContentAction = (0, $euxye.useCallback)((action, name)=>{
        const linkingSuccessDescriptionMessage = ()=>{
            if ((0, $i860n.fg)('jira-issue-terminology-refresh-m3')) return isLive ? $98e92b876198f9ca$export$defe85febe8b728c.linkLiveDocSuccessDescriptionIssueTermRefresh : $98e92b876198f9ca$export$defe85febe8b728c.publishAndLinkPageSuccessDescriptionIssueTermRefresh;
            return isLive ? $98e92b876198f9ca$export$defe85febe8b728c.linkLiveDocSuccessDescription : $98e92b876198f9ca$export$defe85febe8b728c.publishAndLinkPageSuccessDescription;
        };
        if (name === 'edit-page/close') {
            if (isPublished) {
                setEpMode((0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
                });
            } else openContinueDraftModal();
        }
        if (name === 'edit-page/load' && action === 'taskSuccess') {
            if (havePublishedRef.current && (0, $2700E.expValEquals)('cc_jira_cppp_publish_fix', 'isEnabled', true, false)) havePublishedRef.current = false;
            else if (epMode === (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) {
                setEpMode((0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
                });
            }
        }
        if (name === 'edit-page/publish' && action === 'taskSuccess') {
            if ((0, $2700E.expValEquals)('cc_jira_cppp_publish_fix', 'isEnabled', true, false)) havePublishedRef.current = true;
            if (isOpen) actions.setConfluenceData({
                contentUrl: url,
                isDraft: false,
                mode: (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
            fireAnalyticsEvent({
                action: $98e92b876198f9ca$export$f0ebd8c41d592251,
                eventName: isLive ? 'createLiveDoc' : 'publishDraftPage',
                embeddedConfluenceSource: embeddedConfluenceSource,
                eventType: $98e92b876198f9ca$export$12346a674644c156
            });
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            if (isPublished && !isLive) showFlag({
                key: (0, $acwzf.toFlagId)((0, $b941c22a81c50980$export$e80a06e24863c775)),
                type: 'success',
                title: formatMessage($98e92b876198f9ca$export$defe85febe8b728c.publishPageSuccessTitle),
                description: formatMessage($98e92b876198f9ca$export$defe85febe8b728c.publishPageSuccessDescription),
                messageId: 'issue-create-confluence-content.show-flag.success.publish-draft-success-flag.use-embedded-page-draft',
                messageType: 'transactional'
            });
            else {
                setIsPublished(true);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    isDraft: false
                });
                // TODO this is a temporary solution, remove when https://hello.atlassian.net/jira/software/projects/CBT/boards/4465?selectedIssue=CBT-2895 is complete
                setTimeout(()=>{
                    try {
                        if (linkConfluencePage) {
                            // oxlint-disable-next-line typescript/no-non-null-assertion
                            linkConfluencePage((0, $iIciE.convertToViewPageUrl)(url), analyticsEvent);
                            fireAnalyticsEvent({
                                action: $98e92b876198f9ca$export$f0ebd8c41d592251,
                                eventName: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                embeddedConfluenceSource: embeddedConfluenceSource,
                                eventType: $98e92b876198f9ca$export$12346a674644c156
                            });
                            showFlag({
                                key: (0, $acwzf.toFlagId)((0, $b941c22a81c50980$export$26c0043b48580bae)),
                                type: 'success',
                                title: formatMessage(isLive ? $98e92b876198f9ca$export$defe85febe8b728c.linkLiveDocSuccessTitle : $98e92b876198f9ca$export$defe85febe8b728c.publishAndLinkPageSuccessTitle),
                                description: formatMessage(linkingSuccessDescriptionMessage()),
                                messageId: 'issue-create-confluence-content.show-flag.success.link-page-success-flag.use-embedded-page-draft',
                                messageType: 'transactional'
                            });
                        }
                    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $hFtK7.fireErrorAnalytics)({
                            meta: {
                                id: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                teamName: 'confluence-better-together'
                            },
                            attributes: {
                                embeddedConfluenceSource: embeddedConfluenceSource
                            },
                            error: error
                        });
                        showFlag({
                            key: (0, $acwzf.toFlagId)((0, $b941c22a81c50980$export$4164631cfaaf3681)),
                            type: 'error',
                            title: formatMessage($98e92b876198f9ca$export$defe85febe8b728c.linkPageFailedTitle),
                            description: formatMessage($98e92b876198f9ca$export$defe85febe8b728c.linkPageFailedDescription),
                            messageId: 'issue-create-confluence-content.show-flag.error.link-page-failed-flag.use-embedded-page-draft',
                            messageType: 'transactional'
                        });
                    }
                }, 3500);
            }
        }
        if (name === 'edit-page/publish' && action === 'taskFail') (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: isLive ? 'createLiveDoc' : 'publishDraftPage',
                teamName: 'confluence-better-together'
            },
            attributes: {
                embeddedConfluenceSource: embeddedConfluenceSource
            },
            error: new Error(`Error publishing draft page: {name: ${name}, action: ${action}}`)
        });
        onEmbeddedContentAction && onEmbeddedContentAction(action, name);
    }, [
        createAnalyticsEvent,
        embeddedConfluenceSource,
        epMode,
        fireAnalyticsEvent,
        formatMessage,
        isPublished,
        linkConfluencePage,
        onEmbeddedContentAction,
        openContinueDraftModal,
        showFlag,
        url,
        actions,
        isOpen,
        isLive
    ]);
    // This is a little weird, but to avoid duplicating the code above, if the page is live and state local state is !isPublished,
    // we simulate the action of publishing from inside the ep modal. This in turn displays the view page, link the page to the issue
    // and show the flag about the page being published and linked.
    (0, $euxye.useEffect)(()=>{
        if (isLive && embeddedConfluenceSource?.endsWith('Panel') && !handledLiveDocUrls.current.has(url)) {
            handledLiveDocUrls.current.add(url);
            if (handledLiveDocUrls.current.has(url)) handleEmbeddedContentAction('taskSuccess', 'edit-page/publish');
            else handleEmbeddedContentAction('taskFail', 'edit-page/publish');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLive,
        url
    ]);
    // in the case that the user creates a live doc and then wants to create a page, we must ensure we open the draft for the page in edit mode
    (0, $euxye.useEffect)(()=>{
        setEpMode(isLive ? (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $hxvOV.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    }, [
        isLive
    ]);
    return {
        isContinueDraftOpen: isContinueDraftOpen,
        openContinueDraftModal: openContinueDraftModal,
        closeContinueDraftModal: closeContinueDraftModal,
        closeAll: closeAll,
        handleEmbeddedContentAction: handleEmbeddedContentAction,
        fireAnalyticsEvent: fireAnalyticsEvent,
        epMode: epMode
    };
};

});
// eslint-disable-next-line jira/filename-case
const $b941c22a81c50980$export$e80a06e24863c775 = 'publishDraftSuccess';
const $b941c22a81c50980$export$26c0043b48580bae = 'linkPageSuccess';
const $b941c22a81c50980$export$4164631cfaaf3681 = 'linkPageFailed';

parcelRegister("iIciE", function(module, exports) {
$parcel$export(module.exports, "convertToViewPageUrl", () => $63c64eaae9b1b949$export$fbd50b21ccd324a6);
const $63c64eaae9b1b949$export$fbd50b21ccd324a6 = (url)=>// oxlint-disable-next-line typescript/no-non-null-assertion
    url.split('/').filter((part)=>part !== 'edit-v2').join('/');

});

parcelRegister("agppF", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedPageTracking", () => $1c80e92cf95065e1$export$9fcd107e4ed1de75);

var $e7boj = parcelRequire("e7boj");

var $6XpMv = parcelRequire("6XpMv");

var $inMxE = parcelRequire("inMxE");

var $eijVy = parcelRequire("eijVy");

var $jWzaQ = parcelRequire("jWzaQ");

var $eKUuk = parcelRequire("eKUuk");
const $1c80e92cf95065e1$export$9fcd107e4ed1de75 = (sourceOverride)=>{
    const $ = (0, $e7boj.c)(6);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const tenantContext = (0, $eijVy.useTenantContext)();
    const contextSource = (0, $6XpMv.useAnalyticsSource)();
    const source = sourceOverride ?? contextSource;
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== source || $[2] !== tenantContext?.appEditions || $[3] !== tenantContext?.isSiteAdmin || $[4] !== tenantContext?.productEntitlementDetails) {
        t0 = (t1)=>{
            const { eventName: eventName, action: action, actionSubject: actionSubject, contentType: contentType, projectType: projectType, embeddedConfluenceSource: t2, eventType: t3, flow: flow, userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, isLivePage: isLivePage, linkObjectType: linkObjectType, confluenceContentId: confluenceContentId } = t1;
            const embeddedConfluenceSource = t2 === undefined ? "jiraIssueView" : t2;
            const eventType = t3 === undefined ? "ui" : t3;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject ?? `${eventName}`
            });
            const attributes = {
                parentProduct: (0, $eKUuk.getParentProduct)(projectType),
                tenantEditions: tenantContext?.appEditions,
                productEntitlementDetails: tenantContext?.productEntitlementDetails,
                embeddedConfluenceSource: embeddedConfluenceSource,
                flow: flow,
                jiraIssueSurfaceArea: source,
                userHasConfluenceAccess: userHasConfluenceAccess,
                tenantHasConfluence: tenantHasConfluence,
                crossJoinStatus: crossJoinStatus,
                originProduct: originProduct,
                requestedProduct: requestedProduct,
                isLivePage: isLivePage,
                isSiteAdmin: tenantContext?.isSiteAdmin,
                linkObjectType: linkObjectType,
                confluenceContentId: confluenceContentId,
                contentType: contentType
            };
            (0, $jWzaQ.fireEmbeddedConfluenceAnalytics)({
                analyticsEvent: analyticsEvent,
                attributes: attributes,
                eventType: eventType,
                eventName: `${actionSubject ?? eventName} ${action}`
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = tenantContext?.appEditions;
        $[3] = tenantContext?.isSiteAdmin;
        $[4] = tenantContext?.productEntitlementDetails;
        $[5] = t0;
    } else t0 = $[5];
    const trackEmbeddedConfluence = t0;
    return trackEmbeddedConfluence;
};

});
parcelRegister("jWzaQ", function(module, exports) {
$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $8a14127dfc36ec10$export$864bc2da9014e8e9);

var $aJ81Y = parcelRequire("aJ81Y");
const $8a14127dfc36ec10$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});

parcelRegister("eKUuk", function(module, exports) {
$parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", () => $08c6c8454a87a280$export$b4e6d6efc113ca5);
$parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", () => $08c6c8454a87a280$export$bf1e31028b579014);
$parcel$export(module.exports, "ACCESS_DENIED_STATUSES", () => $08c6c8454a87a280$export$2fe5bb2d968b01fc);
$parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", () => $08c6c8454a87a280$export$56360b096b4b4439);
$parcel$export(module.exports, "getParentProduct", () => $08c6c8454a87a280$export$e873edb2560a07ef);

var $f99M0 = parcelRequire("f99M0");
const $08c6c8454a87a280$export$b4e6d6efc113ca5 = {
    ACCESS_GRANTED: 'ACCESS_GRANTED',
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
const $08c6c8454a87a280$export$bf1e31028b579014 = [
    $08c6c8454a87a280$export$b4e6d6efc113ca5.ACCESS_EXISTS,
    $08c6c8454a87a280$export$b4e6d6efc113ca5.ACCESS_GRANTED,
    $08c6c8454a87a280$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
];
const $08c6c8454a87a280$export$2fe5bb2d968b01fc = [
    $08c6c8454a87a280$export$b4e6d6efc113ca5.FORBIDDEN,
    $08c6c8454a87a280$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
];
const $08c6c8454a87a280$export$56360b096b4b4439 = 'licence-exceeded';
const $08c6c8454a87a280$export$e873edb2560a07ef = (projectType)=>{
    switch(projectType){
        case 0, $f99M0.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $f99M0.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $f99M0.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};

});



parcelRegister("aJowe", function(module, exports) {
$parcel$export(module.exports, "useParentProduct", () => $64c6385daefb4e87$export$1b09c6e3737c8eb7);

var $e7boj = parcelRequire("e7boj");

var $2b39L = parcelRequire("2b39L");

var $eKUuk = parcelRequire("eKUuk");
const $64c6385daefb4e87$export$1b09c6e3737c8eb7 = ()=>{
    const $ = (0, $e7boj.c)(2);
    const { data: data } = (0, $2b39L.useProjectContext)();
    const projectType = data?.projectType;
    let t0;
    if ($[0] !== projectType) {
        t0 = (0, $eKUuk.getParentProduct)(projectType);
        $[0] = projectType;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};

});

parcelRegister("gpbOt", function(module, exports) {
$parcel$export(module.exports, "embeddedWhiteboardModalEntrypoint", () => $7d4bccacd5fb8092$export$652b3f11839af9e6);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $7d4bccacd5fb8092$export$652b3f11839af9e6 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("6z42b")), {
        moduleId: "bd30b193",
        moduleName: "EmbeddedWhiteboardModalEmbeddedWhiteboardModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6z42b", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kn089").then(()=>parcelRequire('e2WQ8'));

});




parcelRegister("5NMxV", function(module, exports) {
$parcel$export(module.exports, "PageDwellAnalyticsListener", () => $a87dc59454d69696$export$6cf89f098b551dad);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $2KMaX = parcelRequire("2KMaX");

var $4Onaa = parcelRequire("4Onaa");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $2b39L = parcelRequire("2b39L");

var $62Xqf = parcelRequire("62Xqf");

var $hmGi9 = parcelRequire("hmGi9");

var $i860n = parcelRequire("i860n");

var $e2YLP = parcelRequire("e2YLP");
const $a87dc59454d69696$var$WAIT_DURATION = 5000;
/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */ const $a87dc59454d69696$export$6cf89f098b551dad = ()=>{
    const [hasFired, setHasFired] = (0, $euxye.useState)(false);
    const route = (0, $4Onaa.useCurrentRoute)();
    const routeName = route.name;
    const isReady = (0, $62Xqf.useSpaStatePageReady)();
    const isVisible = (0, $hmGi9.usePageVisibility)();
    const interval = (0, $euxye.useRef)(null);
    const { data: projectData } = (0, $2b39L.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $2KMaX.useLeftSidebarState)();
    (0, $euxye.useEffect)(()=>{
        setHasFired(false);
    }, [
        routeName
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isReady) {
            interval.current = null;
            return;
        }
        // If the page is visible, set the analytics event to run after the specified duration
        if (isVisible && !hasFired) interval.current = setTimeout(()=>{
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                containerId: projectData?.projectId,
                containerType: projectData?.projectType,
                isLeftSidebarCollapsed: isLeftSidebarCollapsed,
                ...(0, $i860n.fg)('jira-page-dwell-custom-attributes') ? (0, $e2YLP.getPageDwellAttributes)() : {}
            });
            setHasFired(true);
        }, $a87dc59454d69696$var$WAIT_DURATION);
        return ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            interval.current = clearTimeout(interval.current);
        };
    }, [
        createAnalyticsEvent,
        hasFired,
        isReady,
        isVisible,
        routeName,
        projectData?.projectId,
        projectData?.projectType,
        isLeftSidebarCollapsed
    ]);
    return null;
};
$a87dc59454d69696$export$6cf89f098b551dad.displayName = "PageDwellAnalyticsListener";

});
parcelRegister("hmGi9", function(module, exports) {
$parcel$export(module.exports, "usePageVisibility", () => $9b9fd13a89aed2cd$export$6c98eb2f12f4ec61);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $76MCm = parcelRequire("76MCm");
const $9b9fd13a89aed2cd$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $euxye.useState)((0, $76MCm.isPageVisible)());
    (0, $euxye.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $76MCm.isPageVisible)());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("76MCm", function(module, exports) {
$parcel$export(module.exports, "supportedVisiblityEvent", () => $64a136959d8f140b$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $64a136959d8f140b$export$ae4f9b990bc70f70);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $64a136959d8f140b$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $64a136959d8f140b$var$supportedHiddenKey = Object.keys($64a136959d8f140b$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $64a136959d8f140b$export$f7132cb36c80dad = $64a136959d8f140b$var$visibilityMap[$64a136959d8f140b$var$supportedHiddenKey];
const $64a136959d8f140b$export$ae4f9b990bc70f70 = ()=>// @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
    typeof document !== 'undefined' && !document[$64a136959d8f140b$var$supportedHiddenKey];

});


parcelRegister("e2YLP", function(module, exports) {
$parcel$export(module.exports, "getPageDwellAttributes", () => $ad783267533abd4d$export$2156c5b51ba49abe);
$parcel$export(module.exports, "useDwellTime", () => $ad783267533abd4d$export$48af03d6a81f6cb6);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $gXtG2 = parcelRequire("gXtG2");
const $ad783267533abd4d$var$attributesList = [];
// Clear the shared attributes list before each test to prevent test pollution
// and ensure each test starts with a clean state
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $ad783267533abd4d$var$attributesList.length = 0;
});
const $ad783267533abd4d$var$setPageDwellAttributes = (newAttributes, lastAttributes)=>{
    let lastAttributesIndex = -1;
    if (lastAttributes) lastAttributesIndex = $ad783267533abd4d$var$attributesList.findIndex((object)=>object === lastAttributes);
    if (lastAttributesIndex !== -1) $ad783267533abd4d$var$attributesList[lastAttributesIndex] = newAttributes;
    else $ad783267533abd4d$var$attributesList.push(newAttributes);
};
const $ad783267533abd4d$var$clearPageDwellAttributes = (clearAttributes)=>{
    const index = $ad783267533abd4d$var$attributesList.findIndex((object)=>object === clearAttributes);
    if (index !== -1) $ad783267533abd4d$var$attributesList.splice(index, 1);
};
const $ad783267533abd4d$export$2156c5b51ba49abe = ()=>{
    const result = {};
    $ad783267533abd4d$var$attributesList.forEach((object)=>{
        Object.assign(result, object);
    });
    return result;
};
const $ad783267533abd4d$export$48af03d6a81f6cb6 = (attributes)=>{
    const prevAttributes = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!(0, $i860n.fg)('jira-page-dwell-custom-attributes')) return;
        $ad783267533abd4d$var$setPageDwellAttributes(attributes, prevAttributes.current);
        prevAttributes.current = attributes;
        return ()=>{
            if (prevAttributes.current) $ad783267533abd4d$var$clearPageDwellAttributes(prevAttributes.current);
        };
    }, [
        attributes
    ]);
};

});


parcelRegister("9WXaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $141107f18f43d9df$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $21iIq = parcelRequire("21iIq");

var $edf7u = parcelRequire("edf7u");

var $aqPkH = parcelRequire("aqPkH");

var $gNbXR = parcelRequire("gNbXR");
var $k6ufm = parcelRequire("k6ufm");
var $bc9Gj = parcelRequire("bc9Gj");
/**
 * Ensures users are redirected to the correct project URL when there's a mismatch in the project key.
 * It preserves query parameters during redirection and logs the event for analytics.
 */ const $141107f18f43d9df$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $aqPkH.FireOperationalAnalytics), Redirect: Redirect = (0, $gNbXR.Redirect), useResource: useResource = (0, $k6ufm.useResource), useRouter: useRouter = (0, $bc9Gj.useRouter) })=>{
    const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
    const projectKey = params.projectKey ?? query.projectKey;
    const { data: projectContext } = useResource((0, $edf7u.projectContextResource));
    if (!projectKey || !projectContext?.projectKey) return null;
    if (projectKey === projectContext.projectKey) return null;
    const search = {
        ...query,
        ...query.projectKey ? {
            projectKey: projectContext.projectKey
        } : {}
    };
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const queryString = (0, $21iIq.qs).stringify(search, Object.entries(search).length > 0);
    // Just a slight risk mitigation - only do the string replace if the match param is there
    const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
    const to = `${path}${queryString}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(FireOperationalAnalytics, {
        eventName: "ProjectKeyRedirect loaded",
        componentName: "ProjectKeyRedirect",
        attributes: {
            location: location,
            projectContext: projectContext
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Redirect, {
        to: to
    }));
};
$141107f18f43d9df$var$ProjectKeyRedirect.displayName = "ProjectKeyRedirect";
var $141107f18f43d9df$export$2e2bcd8739ae039 = $141107f18f43d9df$var$ProjectKeyRedirect;

});

parcelRegister("eetaH", function(module, exports) {
$parcel$export(module.exports, "AsyncUpflowIframeComponent", () => $9af0bfa0eb913b50$export$7f34679273a30171);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $jreC0 = parcelRequire("jreC0");

var $7nEKi = parcelRequire("7nEKi");

var $4Cd1Z = parcelRequire("4Cd1Z");

var $damsL = parcelRequire("damsL");
const $9af0bfa0eb913b50$var$entryPointParams = {};
const $9af0bfa0eb913b50$var$props = {};
const $9af0bfa0eb913b50$export$7f34679273a30171 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $4Cd1Z.upflowIframeComponentEntrypoint), $9af0bfa0eb913b50$var$entryPointParams);
    const [{ renderUpflowModal: renderUpflowModal }] = (0, $damsL.useUpflowModal)();
    // Violating react-entrypoint/no-load-in-hooks so we can experiment faster: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $euxye.useEffect)(()=>{
        if (renderUpflowModal) entryPointActions.load();
    }, [
        entryPointActions,
        renderUpflowModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        id: "issue-onboarding-modal-lazy",
        packageName: "AsyncUpflowIframeComponent",
        placeholderName: "async-upflow-iframe-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $9af0bfa0eb913b50$var$props
    });
};
$9af0bfa0eb913b50$export$7f34679273a30171.displayName = "AsyncUpflowIframeComponent";

});
parcelRegister("4Cd1Z", function(module, exports) {
$parcel$export(module.exports, "upflowIframeComponentEntrypoint", () => $e94da5876b2a615e$export$92c53bb1afc6d332);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $e94da5876b2a615e$export$92c53bb1afc6d332 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("gmqFG")), {
        moduleId: "96fd3917",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gmqFG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5VgAm").then(()=>parcelRequire('58Ebg'));

});


parcelRegister("damsL", function(module, exports) {
$parcel$export(module.exports, "useUpflowModal", () => $5bca0634d43d07f6$export$7025cc2729b71e44);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

const $5bca0634d43d07f6$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // oxlint-disable-next-line no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $d8LhJ.FREE_EDITION)
};
const $5bca0634d43d07f6$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $5bca0634d43d07f6$var$Store = (0, $5QDqc.createStore)({
    name: (0, $bf77772cbdd43a89$export$675a4427bf3750a2),
    initialState: $5bca0634d43d07f6$var$initialState,
    actions: $5bca0634d43d07f6$var$actions
});
const $5bca0634d43d07f6$export$6d73384be122c2dd = (0, $iGu4q.createSubscriber)($5bca0634d43d07f6$var$Store);
const $5bca0634d43d07f6$export$e672be732bd57171 = (0, $dB6ay.createContainer)($5bca0634d43d07f6$var$Store);
const $5bca0634d43d07f6$export$7025cc2729b71e44 = (0, $3h1FP.createHook)($5bca0634d43d07f6$var$Store);

});
/* eslint-disable jira/filename-case */ const $bf77772cbdd43a89$export$675a4427bf3750a2 = 'upflow-modal-store';



parcelRegister("4S96j", function(module, exports) {
$parcel$export(module.exports, "JiraHeritageLoader", () => $6b5b9993edcb0bc5$export$9499deca9933db5b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $erQjo = parcelRequire("erQjo");

var $6Z3wy = parcelRequire("6Z3wy");

var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");

var $4Onaa = parcelRequire("4Onaa");

var $62Xqf = parcelRequire("62Xqf");

var $emmOr = parcelRequire("emmOr");

var $hS55U = parcelRequire("hS55U");

var $bLUqZ = parcelRequire("bLUqZ");
const $6b5b9993edcb0bc5$var$JiraHeritageLoaderOld = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const isReady = (0, $62Xqf.useSpaStatePageReady)();
    const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $euxye.useState)(false);
    (0, $bLUqZ.useWrmStatsEffects)();
    /* eslint-disable jira/wrm/no-load-bridge */ const loadJiraHeritageDependencies = (0, $euxye.useCallback)(()=>{
        setHasHeritageDownloaded(true);
        (0, $emmOr.asyncWrmRequire)([
            ...(0, $6Z3wy.jiraSuperBatchDependencies),
            ...(0, $hS55U.getJiraHeritageDependencies)()
        ]).then(()=>(0, $erQjo.waitForHeritage)()?.resolve?.());
    }, []);
    (0, $euxye.useEffect)(()=>{
        if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
    }, [
        hasHeritageDownloaded,
        isReady,
        loadJiraHeritageDependencies,
        route
    ]);
    return null;
};
$6b5b9993edcb0bc5$var$JiraHeritageLoaderOld.displayName = "JiraHeritageLoaderOld";
const $6b5b9993edcb0bc5$var$JiraHeritageLoaderNew = (0, $euxye.Fragment);
const $6b5b9993edcb0bc5$export$9499deca9933db5b = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('no-wrm-heritage-loader'), $6b5b9993edcb0bc5$var$JiraHeritageLoaderNew, $6b5b9993edcb0bc5$var$JiraHeritageLoaderOld);
$6b5b9993edcb0bc5$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';

});
parcelRegister("hS55U", function(module, exports) {
$parcel$export(module.exports, "getJiraHeritageDependencies", () => $05e58ce67ae11c13$export$e8f6d7acd5817fa2);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
const $05e58ce67ae11c13$export$e8f6d7acd5817fa2 = ()=>[
        // superbatch resources
        // analytics
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        // dependencies from HeaderFooterRendering
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        // . dialog
        'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
        // overrides for AUI, styles and bridge apis
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!jira.webresources:global-static',
        // browser metrics
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        // repository shortcuts from navigation
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
        // issue view resources
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
        // create board dialog
        'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
        // old analytics library
        'wrc!com.atlassian.analytics.analytics-client:js-events',
        // frontend cache
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
        // impersonation flag (logged as someone)
        'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
        // flag displayed when there are too many emails on the instance
        'wrc!jira.webresources:spam-protection-flags',
        // in-product announcements (displayed e.g. if there is an incident)
        ...(0, $i860n.fg)('jfp-magma-remove-pas-resource') ? [] : [
            'wrc!com.atlassian.pas:pas-everypage-static'
        ],
        // Bento resources
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
        'wrc!com.atlassian.auiplugin:dialog2',
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
        'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
    ];

});

parcelRegister("bLUqZ", function(module, exports) {
$parcel$export(module.exports, "useWrmStatsEffects", () => $1f20e4836c3deb6c$export$7ff53723d9d2886d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $62Xqf = parcelRequire("62Xqf");

var $eNr3t = parcelRequire("eNr3t");
const $1f20e4836c3deb6c$export$7ff53723d9d2886d = ()=>{
    const isReady = (0, $62Xqf.useSpaStatePageReady)();
    const [{ transitionsCount: transitionsCount }] = (0, $eNr3t.useSpaStateTransition)();
    (0, $euxye.useEffect)(()=>{
        if (isReady && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        !window.__WRM_INTERNAL_STATS__.isPageInteractive) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
    }, [
        isReady
    ]);
    (0, $euxye.useEffect)(()=>{
        if (transitionsCount > 0) // clear stats on transition
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ = {};
    }, [
        transitionsCount
    ]);
};

});


parcelRegister("lg2s9", function(module, exports) {
$parcel$export(module.exports, "AgentPresenceHeartbeatLazy", () => $44f538c8ea74aac3$export$3789cc687b03919);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $l8G1z = parcelRequire("l8G1z");

var $aZMdt = parcelRequire("aZMdt");

const $44f538c8ea74aac3$export$f2775d647186a91e = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazy)(()=>(parcelRequire("iCurs")).then((module)=>module.AgentPresenceHeartbeat), {
    moduleId: "./src/packages/servicedesk/agent-presence-heartbeat/src/AgentPresenceHeartbeat.tsx"
});
const $44f538c8ea74aac3$export$3789cc687b03919 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "agentPresenceHeartbeat"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "agentPresenceHeartbeat",
        packageName: "jiraServicedeskAgentPresenceHeartbeat",
        teamName: "jsd-shield",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($44f538c8ea74aac3$export$f2775d647186a91e, null)));
$44f538c8ea74aac3$export$3789cc687b03919.displayName = "AgentPresenceHeartbeatLazy";

});
parcelRegister("iCurs", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aBq6G").then(()=>parcelRequire('2UgUu'));

});


parcelRegister("dex1f", function(module, exports) {
$parcel$export(module.exports, "default", () => $c27485e10f721489$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $3GN2r = parcelRequire("3GN2r");

var $kkHVL = parcelRequire("kkHVL");
const $c27485e10f721489$var$CacheRegistry = ()=>{
    const accountIdLoggedInUser = (0, $3GN2r.useAccountId)();
    (0, $euxye.useEffect)(()=>{
        (0, $kkHVL.default).set(accountIdLoggedInUser ?? 'anonymous');
    }, [
        accountIdLoggedInUser
    ]);
    return null;
};
$c27485e10f721489$var$CacheRegistry.displayName = "CacheRegistry";
var $c27485e10f721489$export$2e2bcd8739ae039 = $c27485e10f721489$var$CacheRegistry;

});
parcelRegister("kkHVL", function(module, exports) {
$parcel$export(module.exports, "CACHE_PREFIX", () => $06324cf65c88a5c5$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $06324cf65c88a5c5$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $06324cf65c88a5c5$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iXN50 = parcelRequire("iXN50");
let $06324cf65c88a5c5$var$resolveCachePromise;
const $06324cf65c88a5c5$var$cachePromise = new Promise((resolve)=>{
    $06324cf65c88a5c5$var$resolveCachePromise = resolve;
});
const $06324cf65c88a5c5$export$27be962d708928a = '__scope_key__';
const $06324cf65c88a5c5$export$69ca515e4489d790 = 'cache_prefix';
const $06324cf65c88a5c5$var$TIMEOUT = 10000;
const $06324cf65c88a5c5$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $iXN50.createLocalStorageProvider)($06324cf65c88a5c5$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$06324cf65c88a5c5$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $06324cf65c88a5c5$export$653cd03438bb0386 = ()=>$06324cf65c88a5c5$var$promiseWithMaxExecutionTime($06324cf65c88a5c5$var$TIMEOUT, $06324cf65c88a5c5$var$cachePromise);
const $06324cf65c88a5c5$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $iXN50.createLocalStorageProvider)($06324cf65c88a5c5$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($06324cf65c88a5c5$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            // @browser-storage setter
            storage.set($06324cf65c88a5c5$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $06324cf65c88a5c5$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $06324cf65c88a5c5$export$2e2bcd8739ae039 = $06324cf65c88a5c5$var$config;

});


parcelRegister("JFocG", function(module, exports) {
$parcel$export(module.exports, "SafeConversationAssistantPanel", () => $e87e8d6eb0d97310$export$453401d0b697d2db);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $8GASP = parcelRequire("8GASP");

var $4MYRQ = parcelRequire("4MYRQ");


var $29eRG = parcelRequire("29eRG");

var $inMxE = parcelRequire("inMxE");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $Bq7bE = parcelRequire("Bq7bE");

var $6ecZV = parcelRequire("6ecZV");

var $d3sjB = parcelRequire("d3sjB");

var $ezKom = parcelRequire("ezKom");
const $e87e8d6eb0d97310$var$panelSplitter = (0, $7eNDO.defineMessage)({
    id: "platform-conversation-assistant.panelSplitter.label",
    defaultMessage: "Resize panel"
});
const $e87e8d6eb0d97310$var$PanelInLayout = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const rightSidebarCurrentState = (0, $29eRG.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $euxye.useState)();
    const prevPanelIdRef = (0, $euxye.useRef)();
    const delayRef = (0, $euxye.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $Bq7bE.useRovoExperienceAPIStore)();
    const sidebarApi = (0, $ezKom.useConversationAssistantSidebarApi)({});
    const toggleSidebar = (0, $euxye.useCallback)(()=>{
        toggleConversationAssistantUIMode({
            targetMode: (0, $6ecZV.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const handleResizeComplete = (0, $euxye.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel',
            tags: [
                'atlaskit',
                'aiMate'
            ]
        }).fire((0, $8GASP.FabricChannel).aiMate);
    }, [
        createAnalyticsEvent
    ]);
    /**
   * This use effect is used to add (when is necessary) a delay
   * in the panelId => localPanelId syncing
   */ (0, $euxye.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $2de0ca8181f03e7e$export$dffb4ed44e20ea9a)) {
            /**
       * The right-sidebar is showing the conversation assistant...
       */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
         * and is open, not collapsed and we want to show a panel
         * with an ID !== CONVERSATION_ASSISTANT_CONTAINER_ID
         */ setLocalPanelId(panelId);
            else /**
         * and we want to close it
         */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
                createAnalyticsEvent({
                    action: 'closed',
                    actionSubject: 'aiMatePanel',
                    source: 'AIMate',
                    tags: [
                        'atlaskit',
                        'aiMate'
                    ]
                }).fire((0, $8GASP.FabricChannel).aiMate);
            }, 310);
        } else /**
       * If the right sidebar is not showing the conversation assistant,
       * we just keep localPanelId in sync with panelId
       */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        createAnalyticsEvent,
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $2de0ca8181f03e7e$export$dffb4ed44e20ea9a)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4MYRQ.PanelSplitter), {
        label: formatMessage($e87e8d6eb0d97310$var$panelSplitter),
        onResizeEnd: handleResizeComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d3sjB.JiraConversationAssistant), {
        onClosePanel: toggleSidebar
    }));
};
$e87e8d6eb0d97310$var$PanelInLayout.displayName = "PanelInLayout";
const $e87e8d6eb0d97310$export$453401d0b697d2db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-conversation-assistant-panel",
        packageName: "jiraConversationAssistant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e87e8d6eb0d97310$var$PanelInLayout, null));
$e87e8d6eb0d97310$export$453401d0b697d2db.displayName = "SafeConversationAssistantPanel";

});
parcelRegister("d3sjB", function(module, exports) {
$parcel$export(module.exports, "JiraConversationAssistant", () => $74b2d47cf540e9de$export$da8473714271a41d);
/* JiraConversationAssistant.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $kuCeB = parcelRequire("kuCeB");

var $ihEDU = parcelRequire("ihEDU");

var $1FS2F = parcelRequire("1FS2F");

var $6ecZV = parcelRequire("6ecZV");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $6zTYs = parcelRequire("6zTYs");

var $h3LJR = parcelRequire("h3LJR");

var $kt86l = parcelRequire("kt86l");

var $Bq7bE = parcelRequire("Bq7bE");

var $2700E = parcelRequire("2700E");

var $55BnK = parcelRequire("55BnK");

var $f2wVS = parcelRequire("f2wVS");

var $8g8zR = parcelRequire("8g8zR");

var $ezKom = parcelRequire("ezKom");
const $74b2d47cf540e9de$var$getProductFromPath = (pathname, search)=>{
    if (/\/servicedesk\//.test(pathname) || /[?&]types=service_desk/.test(search)) return 'jsm';
    if (pathname.includes('/jira/polaris')) return 'jpd';
    return 'jira';
};
const $74b2d47cf540e9de$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
const $74b2d47cf540e9de$var$ASAN_CLOUD_ID = '7a4256fd-889b-4c18-8d43-536cdd3c89ca';
const $74b2d47cf540e9de$var$ASAN_SUPPORT_COPILOT_AGENT_ID = '770177bc-1c7b-4b90-beb7-8e9dc2f890d7';
const $74b2d47cf540e9de$var$ASAN_OVERRIDE_CONFIG = {
    agentsConfig: {
        filter: [
            $74b2d47cf540e9de$var$ASAN_SUPPORT_COPILOT_AGENT_ID
        ],
        defaultAgentId: $74b2d47cf540e9de$var$ASAN_SUPPORT_COPILOT_AGENT_ID
    }
};
const $74b2d47cf540e9de$export$da8473714271a41d = ({ onClosePanel: onClosePanel, storeInitializerOnly: storeInitializerOnly = false, children: children, skipRelayProvider: skipRelayProvider = false })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable } = (0, $Bq7bE.useRovoExperienceAPIStore)();
    const sidebarApi = (0, $ezKom.useConversationAssistantSidebarApi)({});
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const configuration = (0, $kuCeB.useAiRovoCurrentRouteConfiguration)();
    const isSyntheticTenant = (0, $6bEm8.default)('ajs-is-synthetic') === 'true' || (0, $i860n.fg)('is_synthetic_tenant');
    const handleDeepLinkClick = (0, $euxye.useCallback)((url)=>{
        const urlObj = new URL(url);
        push(urlObj.pathname + urlObj.search + urlObj.hash);
    }, [
        push
    ]);
    const activeCompatibleEditor = (0, $8g8zR.useActiveCompatibleEditor)();
    const { pathname: pathname, search: search } = (0, $f2wVS.getRouterState)().location;
    const product = (0, $i860n.fg)('jsm_jpd_product_attribution') ? $74b2d47cf540e9de$var$getProductFromPath(pathname, search) : 'jira';
    const config = (0, $euxye.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            activationId: activationId,
            product: product,
            orgId: orgId,
            experienceId: 'ai-mate',
            assistanceServiceConfig: {
                // TODO: type `AssistanceServiceConfig` should be decoupled from headers to prevent the need for other required keys which shouldn't need to be defined here (`product` and `experienceId`)
                headers: isSyntheticTenant ? {
                    [$74b2d47cf540e9de$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                } : // oxlint-disable-next-line typescript/consistent-type-assertions
                {},
                // Rename to `urlPrefix` in the package; baseUrl is a deprecated concept
                baseUrl: '/gateway/api/assist'
            },
            ...activeCompatibleEditor?.editorId && activeCompatibleEditor?.containerAri && (0, $2700E.expVal)('jira_maui_remix', 'isEnabled', false) ? {
                smartCreationContext: {
                    editor: {
                        containerAri: activeCompatibleEditor.containerAri,
                        editorId: activeCompatibleEditor.editorId
                    }
                }
            } : {},
            ...(0, $2700E.expVal)('prevent_abort_jira_rovo_chat', 'isEnabled', false) ? {
                preventAbortRequestsOnStandaloneChatClose: true,
                preventAbortRequestsOnStagingModalClose: true
            } : {}
        }), [
        cloudId,
        activationId,
        orgId,
        isSyntheticTenant,
        activeCompatibleEditor,
        product
    ]);
    const modeConfig = (0, $euxye.useMemo)(()=>({
            mode: (0, $6ecZV.ConversationAssistantUIModes).SIDEBAR,
            isMiniModalAvailable: isMiniModalAvailable,
            isSidebarAvailable: isSidebarAvailable,
            isFullScreenModalAvailable: // asx_full_screen_modal_mode is a temporary kill switch for the full screen modal mode
            // eslint-disable-next-line jira/ff/no-preconditioning
            isFullScreenModalAvailable && (0, $i860n.fg)('asx_full_screen_modal_mode') && (0, $2700E.expVal)('ai_agent_sessions_experience', 'isEnabled', false),
            switchToMode: (mode)=>{
                toggleConversationAssistantUIMode({
                    targetMode: mode,
                    sidebarApi: sidebarApi
                });
            }
        }), [
        isMiniModalAvailable,
        isSidebarAvailable,
        isFullScreenModalAvailable,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const useStoreInitializerWrapper = (0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false) && storeInitializerOnly;
    const handleCloseChat = (0, $euxye.useCallback)(()=>{
        onClosePanel();
        toggleConversationAssistantUIMode({
            targetMode: undefined,
            sidebarApi: sidebarApi
        });
    }, [
        onClosePanel,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    // ROVOFE-76 - No resize wrapper for nav4 as it uses PanelSplitter now
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: useStoreInitializerWrapper ? $74b2d47cf540e9de$var$styles.storeInitializerWrapper : $74b2d47cf540e9de$var$styles.conversationAssistantWrapperNav4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1FS2F.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: handleCloseChat,
        uiConfig: {
            customHandlers: {
                handleDeepLinkClick: handleDeepLinkClick
            },
            isSplitLayout: (0, $2700E.expVal)('ai_agent_sessions_experience', 'isEnabled', false) ? true : undefined
        },
        config: config,
        isNav4Enabled: true,
        modeConfig: modeConfig,
        ...configuration,
        overridingChildren: children ?? null,
        ...(0, $i860n.fg)('ai_agent_sessions_warming_cache') ? {
            skipRelayProvider: skipRelayProvider
        } : {},
        ...cloudId === $74b2d47cf540e9de$var$ASAN_CLOUD_ID && (0, $i860n.fg)('asan-rovo-restrict-agents') ? $74b2d47cf540e9de$var$ASAN_OVERRIDE_CONFIG : {}
    }));
};
$74b2d47cf540e9de$export$da8473714271a41d.displayName = "JiraConversationAssistant";
const $74b2d47cf540e9de$var$styles = {
    conversationAssistantWrapperNav4: "_1bsb1osq _4t3i1osq",
    storeInitializerWrapper: "_1bsbidpf _4t3iidpf"
};

});
parcelRegister("kuCeB", function(module, exports) {
$parcel$export(module.exports, "useAiRovoCurrentRouteConfiguration", () => $adc95dc99b5b4092$export$bdd203042abc94ea);

var $bWZpq = parcelRequire("bWZpq");
const $adc95dc99b5b4092$export$bdd203042abc94ea = ()=>{
    const configuration = (0, $bWZpq.useAiRovoCurrentRouteConfigurationStore)((state)=>state.configuration);
    return configuration;
};

});

parcelRegister("1FS2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c540081837af08b$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $1xwC9 = parcelRequire("1xwC9");

var $egspI = parcelRequire("egspI");

var $2D2gW = parcelRequire("2D2gW");

var $clmWr = parcelRequire("clmWr");
const $8c540081837af08b$var$conversationAssistantLazy = (0, $euxye.lazy)(()=>(0, $clmWr.importConversationAssistant)().then((module)=>({
            default: module.ConversationAssistant
        })));
const $8c540081837af08b$var$createLoadingComponent = ()=>{
    return (0, $2D2gW.default)({
        name: 'LoadingConversationAssistantBundle'
    });
};
const $8c540081837af08b$var$conversationAssistantLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($1xwC9)))({
    loader: ()=>(0, $clmWr.importConversationAssistant)().then((m)=>m.ConversationAssistant),
    loading: $8c540081837af08b$var$createLoadingComponent
});
const $8c540081837af08b$var$AsyncConversationAssistant = Object.assign((props)=>{
    if ((0, $egspI.fg)('aimate_conversation_assistant_async_loading')) return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $euxye.Suspense), {
        fallback: $8c540081837af08b$var$createLoadingComponent()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8c540081837af08b$var$conversationAssistantLazy, props));
    if (props.useChildrenAsLoadingFallback && props.overridingChildren && (0, $egspI.fg)('ai_agent_sessions_warming_cache')) return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $euxye.Suspense), {
        fallback: props.overridingChildren
    }, (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8c540081837af08b$var$conversationAssistantLazy, props));
    return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8c540081837af08b$var$conversationAssistantLoadable, props);
}, {
    preload: ()=>{
        // React.lazy has no preload API, so warm the shared chunk directly on the R19
        // lazy path; keep react-loadable's preload (which also marks it loaded) otherwise.
        if ((0, $egspI.fg)('aimate_conversation_assistant_async_loading')) (0, $clmWr.importConversationAssistant)();
        else $8c540081837af08b$var$conversationAssistantLoadable.preload();
    }
});
var $8c540081837af08b$export$2e2bcd8739ae039 = $8c540081837af08b$var$AsyncConversationAssistant;

});
parcelRegister("clmWr", function(module, exports) {
$parcel$export(module.exports, "importConversationAssistant", () => $83d536bd1dd332a1$export$24a887167476720c);
// Single-source dynamic import factory for the conversation-assistant chunk.
// Mirrors the chunk-name used by the live lazy()/loadable() boundaries so preload
// and the live boundaries share the same chunk identity.

const $83d536bd1dd332a1$export$24a887167476720c = ()=>(parcelRequire("bd1G4"));

});
parcelRegister("bd1G4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gCScl"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("hGO33")
]).then(()=>parcelRequire('kICbn'));

});



parcelRegister("8g8zR", function(module, exports) {
$parcel$export(module.exports, "registerCompatibleEditor", () => $866166748f16e9d8$export$b29b54d63350e7fd);
$parcel$export(module.exports, "useActiveCompatibleEditor", () => $866166748f16e9d8$export$24d8a5ce8e49c98a);

var $euxye = parcelRequire("euxye");

var $gXtG2 = parcelRequire("gXtG2");
let $866166748f16e9d8$var$compatibleEditors = [];
const $866166748f16e9d8$var$listeners = new Set();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $866166748f16e9d8$var$listeners.clear();
});
const $866166748f16e9d8$var$emit = ()=>{
    for (const listener of $866166748f16e9d8$var$listeners)listener();
};
const $866166748f16e9d8$var$subscribe = (listener)=>{
    $866166748f16e9d8$var$listeners.add(listener);
    return ()=>{
        $866166748f16e9d8$var$listeners.delete(listener);
    };
};
const $866166748f16e9d8$export$8489bc8c3b0abac9 = ()=>$866166748f16e9d8$var$compatibleEditors[$866166748f16e9d8$var$compatibleEditors.length - 1]?.editorId;
const $866166748f16e9d8$export$b29b54d63350e7fd = (editorId, containerAri)=>{
    $866166748f16e9d8$var$compatibleEditors = [
        ...$866166748f16e9d8$var$compatibleEditors.filter((e)=>e.editorId !== editorId),
        {
            editorId: editorId,
            containerAri: containerAri
        }
    ];
    $866166748f16e9d8$var$emit();
    return ()=>{
        $866166748f16e9d8$var$compatibleEditors = $866166748f16e9d8$var$compatibleEditors.filter((e)=>e.editorId !== editorId);
        $866166748f16e9d8$var$emit();
    };
};
const $866166748f16e9d8$export$24d8a5ce8e49c98a = ()=>{
    const getActive = ()=>$866166748f16e9d8$var$compatibleEditors[$866166748f16e9d8$var$compatibleEditors.length - 1];
    const [activeEditor, setActiveEditor] = (0, $euxye.useState)(getActive);
    (0, $euxye.useEffect)(()=>{
        return $866166748f16e9d8$var$subscribe(()=>{
            setActiveEditor(getActive());
        });
    }, []);
    return activeEditor;
};
const $866166748f16e9d8$export$1bc50531ad6643c7 = ()=>{
    $866166748f16e9d8$var$compatibleEditors = [];
    $866166748f16e9d8$var$emit();
};

});



parcelRegister("ioHRB", function(module, exports) {
$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", () => $8af0f146462d5070$export$4fa5b26bccc7e3df);
$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapperNew", () => $8af0f146462d5070$export$9dd7f739574d97aa);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dCJKF = parcelRequire("dCJKF");

var $cCE2Z = parcelRequire("cCE2Z");

var $l8G1z = parcelRequire("l8G1z");


// We are using an async here in addition to the jiraDeferEditionModalEntryPoint in ./entrypoint.tsx since
// we want to avoid unnecessarily preloading the expensive graphql query on each page load. Instead
// we load an async component that checks engagement-platform first if we are to show the modal or not.
const $8af0f146462d5070$var$importDeferEditionEPCheck = ()=>(parcelRequire("3ODYp")).then(({ EPCheck: EPCheck })=>EPCheck);
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8af0f146462d5070$var$AsyncDeferEditionEPCheck = (0, $l8G1z.lazyAfterPaint)(()=>$8af0f146462d5070$var$importDeferEditionEPCheck(), {
    ssr: false
});
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8af0f146462d5070$var$AsyncDeferEditionEPCheckNew = (0, $l8G1z.lazy)(()=>$8af0f146462d5070$var$importDeferEditionEPCheck(), {
    ssr: false
});
const $8af0f146462d5070$export$4fa5b26bccc7e3df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $496051e94c0866dd$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
        teamName: (0, $496051e94c0866dd$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $496051e94c0866dd$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8af0f146462d5070$var$AsyncDeferEditionEPCheck, props)));
$8af0f146462d5070$export$4fa5b26bccc7e3df.displayName = "AsyncDeferEditionEPCheckWrapper";
const $8af0f146462d5070$export$9dd7f739574d97aa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $496051e94c0866dd$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
        teamName: (0, $496051e94c0866dd$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $496051e94c0866dd$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8af0f146462d5070$var$AsyncDeferEditionEPCheckNew, props)));
$8af0f146462d5070$export$9dd7f739574d97aa.displayName = "AsyncDeferEditionEPCheckWrapperNew";

});
/* eslint-disable jira/filename-case */ const $496051e94c0866dd$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $496051e94c0866dd$export$d57b6b390e78d90f = 'transmuters-growth';
const $496051e94c0866dd$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $496051e94c0866dd$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $496051e94c0866dd$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $496051e94c0866dd$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $496051e94c0866dd$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $496051e94c0866dd$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $496051e94c0866dd$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $496051e94c0866dd$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
const $496051e94c0866dd$export$d62ac9eaaf8c4436 = 'COLLECTION';

parcelRegister("3ODYp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("74Cdc").then(()=>parcelRequire('jubQl'));

});


parcelRegister("9lndY", function(module, exports) {
$parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", () => $8b9c7ef36acf866d$export$51f384a783f47807);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $gqsnC = parcelRequire("gqsnC");

const $8b9c7ef36acf866d$export$51f384a783f47807 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("i9Qw7")), {
        moduleId: "d8076fb2",
        moduleName: "DeferEditionModalComponent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
            queries: {
                deferEditionModal: {
                    parameters: (0, $gqsnC.default),
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey
                    }
                }
            }
        })
});

});
parcelRegister("gqsnC", function(module, exports) {
$parcel$export(module.exports, "default", () => $122439d13e1ea4de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f567895aadbe7f8b1d30709e9c475a0e>>
 * @relayHash a4dd0c5be1663f90e5d0685708221148
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 505d092e7c0d41f6265f966da6c27d5fee5ef75761ae3944457163e71824dad0
const $122439d13e1ea4de$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "505d092e7c0d41f6265f966da6c27d5fee5ef75761ae3944457163e71824dad0",
        "metadata": {},
        "name": "DeferEditionModalComponentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $122439d13e1ea4de$export$2e2bcd8739ae039 = $122439d13e1ea4de$var$node;

});

parcelRegister("i9Qw7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7htkz").then(()=>parcelRequire('bonOZ'));

});


parcelRegister("2rzpb", function(module, exports) {
$parcel$export(module.exports, "SafeHelpPanel", () => $eb35fcea944313e9$export$cd2ada2fb14048fc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $kM0go = parcelRequire("kM0go");


var $esHVv = parcelRequire("esHVv");


var $8hzbm = parcelRequire("8hzbm");

var $b5zH6 = parcelRequire("b5zH6");

var $29eRG = parcelRequire("29eRG");

var $3GN2r = parcelRequire("3GN2r");
const $eb35fcea944313e9$var$HelpPanel = ()=>{
    const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $esHVv.useHelpPanel)();
    const { closeRightSidebar: closeRightSidebar } = (0, $29eRG.useRightSidebarController)();
    const rightSidebarCurrentState = (0, $29eRG.useActiveRightSidebarState)();
    const accountId = (0, $3GN2r.useAccountId)();
    (0, $euxye.useEffect)(()=>{
        const restoreReleaseNotesNotifications = async ()=>{
            if (accountId) try {
                // @ts-expect-error - Property 'helpPanel' does not exist on type 'unknown'.
                const { helpPanel: userPropertiesHelpPanelValue } = await (0, $kM0go.getUserProperty)(accountId, (0, $b1ff302ba1c22750$export$783d7c02e3a0cbf));
                setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
            } catch (err) {
                /* getUserProperty throws if not found */ setReleaseNotesNotifications(0);
            }
            else setReleaseNotesNotifications(0);
        };
        restoreReleaseNotesNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8hzbm.RemoteStateUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b5zH6.LazyHelpPanel), {
        isOpen: !rightSidebarCurrentState?.isCollapsed,
        navigationData: navigationData,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        releaseNotesNotificationsSetter: setReleaseNotesNotifications,
        hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
        onCloseHelpPanel: closeRightSidebar
    }));
};
$eb35fcea944313e9$var$HelpPanel.displayName = "HelpPanel";
const $eb35fcea944313e9$var$HelpPanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $29eRG.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $euxye.useState)();
    const prevPanelIdRef = (0, $euxye.useRef)();
    const delayRef = (0, $euxye.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $euxye.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $2b56b53c34bc2033$export$e99efa3985fa3c26)) {
            /**
			 * The right-sidebar is showing the help-panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== HELP_PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the help-panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $2b56b53c34bc2033$export$e99efa3985fa3c26)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($eb35fcea944313e9$var$HelpPanel, null);
};
$eb35fcea944313e9$var$HelpPanelInLayout.displayName = "HelpPanelInLayout";
const $eb35fcea944313e9$export$cd2ada2fb14048fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-help-panel",
        packageName: "@jira/platform__help-panel-right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($eb35fcea944313e9$var$HelpPanelInLayout, null));
$eb35fcea944313e9$export$cd2ada2fb14048fc.displayName = "SafeHelpPanel";

});
/* eslint-disable jira/filename-case */ const $b1ff302ba1c22750$export$783d7c02e3a0cbf = 'help_panel_ui_state';

parcelRegister("8hzbm", function(module, exports) {
$parcel$export(module.exports, "RemoteStateUpdater", () => $50762153db3c7a3b$export$3db011870dd4330f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4B6hN = parcelRequire("4B6hN");

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

var $3GN2r = parcelRequire("3GN2r");

var $esHVv = parcelRequire("esHVv");

const $50762153db3c7a3b$var$DEBOUNCE_TIME = 1000;
const $50762153db3c7a3b$export$3db011870dd4330f = ()=>{
    // right-sidebar
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $esHVv.useHelpPanel)();
    const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $euxye.useState)(releaseNotesNotifications);
    const accountId = (0, $3GN2r.useAccountId)();
    const [debouncedUpdateData] = (0, $4B6hN.default)(async (newReleaseNotesNotifications)=>{
        const remoteData = {
            helpPanel: {
                releaseNotesNotifications: newReleaseNotesNotifications
            }
        };
        if (accountId) try {
            await (0, $kM0go.setUserProperties)(accountId, (0, $b1ff302ba1c22750$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'updateServerHelpPanelState',
                    packageName: 'jiraHelpPanelServices',
                    teamName: 'self-help-experiences'
                }
            });
        }
    }, $50762153db3c7a3b$var$DEBOUNCE_TIME);
    (0, $euxye.useEffect)(()=>{
        if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setReleaseNotesNotificationsTemp(releaseNotesNotifications);
            debouncedUpdateData(releaseNotesNotifications);
        }
    }, [
        debouncedUpdateData,
        releaseNotesNotifications,
        releaseNotesNotificationsTemp
    ]);
    return null;
};
$50762153db3c7a3b$export$3db011870dd4330f.displayName = "RemoteStateUpdater";

});

parcelRegister("b5zH6", function(module, exports) {
$parcel$export(module.exports, "LazyHelpPanel", () => $bc03b9c954f305f8$export$51c79455aef7d178);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dCJKF = parcelRequire("dCJKF");

var $cCE2Z = parcelRequire("cCE2Z");

var $a8EUd = parcelRequire("a8EUd");

var $kFgCO = parcelRequire("kFgCO");

var $aZMdt = parcelRequire("aZMdt");

var $aoLsE = parcelRequire("aoLsE");

var $3wVoa = parcelRequire("3wVoa");

var $hGrw1 = parcelRequire("hGrw1");

var $bsUP2 = parcelRequire("bsUP2");
const $bc03b9c954f305f8$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
    const user = (0, $kFgCO.useCurrentUser)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "help-panel",
        packageName: "jiraHelpPanel",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3wVoa.default), {
                loadingArticle: articleId.id !== ''
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
        id: "root",
        packageName: "jiraHelpPanel",
        teamName: "self-help-experiences"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hGrw1.SearchContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        tags: [
            'iph'
        ],
        sourceName: "jiraHelpPanel",
        sourceType: (0, $46f069e6c968f461$export$9d2de6eebf7462b5),
        attributes: {
            searchService: 'help-aggregator',
            routeGroup: routeGroup,
            routeName: routeName,
            userId: user?.data?.user?.accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aoLsE.LazyWait), {
        until: hasBeenRendered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-lazy-help-panel",
        fallback: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3wVoa.default), {
            loadingArticle: articleId.id !== ''
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bsUP2.AsyncLazyHelpPanel), {
        navigationData: {
            articleId: articleId,
            history: history
        },
        releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        isOpen: isOpen,
        onCloseHelpPanel: onCloseHelpPanel,
        routeGroup: routeGroup,
        routeName: routeName
    })))))));
};
$bc03b9c954f305f8$export$51c79455aef7d178.displayName = "LazyHelpPanel";

});
parcelRegister("3wVoa", function(module, exports) {
$parcel$export(module.exports, "default", () => $76740792e0e954e6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
var $8w7Yz = parcelRequire("8w7Yz");

var $2ZeFA = parcelRequire("2ZeFA");
const $76740792e0e954e6$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2ZeFA.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        role: "img",
        "aria-label": "help panel loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-250, 20px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "90%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "70%"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2ZeFA.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-500, 40px)",
        marginTop: "var(--ds-space-100, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadignArticleList, {
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($76740792e0e954e6$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })))));
$76740792e0e954e6$var$HelpPanelLoading.displayName = "HelpPanelLoading";
var $76740792e0e954e6$export$2e2bcd8739ae039 = $76740792e0e954e6$var$HelpPanelLoading;
/**
 * Header
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76740792e0e954e6$var$LoadingContent = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $76740792e0e954e6$var$HeaderLoading = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_n7zlqrmb _4t3ixncg _bfhk15s3 _1bah1yb4 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $76740792e0e954e6$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76740792e0e954e6$var$LoadingRectangle = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_l7mdyr": (0, $8w7Yz.default)(__cmplp.contentHeight),
            "--_1fj4wta": (0, $8w7Yz.default)(__cmplp.marginTop),
            "--_7n1eiw": (0, $8w7Yz.default)(__cmplp.contentWidth)
        },
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_2rkolb4i _kqswh2mm _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk7qp0 _1itk1s10 _12vemgnk",
            __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
            __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
            __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $76740792e0e954e6$var$LoadignArticleList = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1bsb1osq _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _vchhusvi",
            __cmplp.className
        ])
    });
});
const $76740792e0e954e6$var$LoadignArticleListItem = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1ule _1bsb1osq _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2ZeFA", function(module, exports) {
$parcel$export(module.exports, "HelpPanelContainer", () => $f756c2d7a1fa4a3d$export$37cd645d7678f7d4);
$parcel$export(module.exports, "HelpPanelContainerV2", () => $f756c2d7a1fa4a3d$export$1df7e3ebfc4c9b06);
$parcel$export(module.exports, "HelpPanelSectionMessageContainer", () => $f756c2d7a1fa4a3d$export$9f6251c714594f23);
$parcel$export(module.exports, "HelpPanelContentContainer", () => $f756c2d7a1fa4a3d$export$1cdb922eed7271d1);
/* styled.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $f756c2d7a1fa4a3d$export$37cd645d7678f7d4 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _vchhusvi _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
            __cmplp.className
        ])
    });
});
const $f756c2d7a1fa4a3d$export$1df7e3ebfc4c9b06 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = $f756c2d7a1fa4a3d$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_4t3i1i8v _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $f756c2d7a1fa4a3d$export$9f6251c714594f23 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_kqswh2mm _ca0qpxbi _u5f3pxbi _n3tdidpf _19bvpxbi _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $f756c2d7a1fa4a3d$export$1cdb922eed7271d1 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hGrw1", function(module, exports) {
$parcel$export(module.exports, "useSearchContext", () => $fd108eadb8337290$export$67b98b1b880a048b);
$parcel$export(module.exports, "SearchContextProvider", () => $fd108eadb8337290$export$6bd70292443463a4);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7zbCZ = parcelRequire("7zbCZ");
const $fd108eadb8337290$var$dest = (0, $7zbCZ.createCtx)();
const $fd108eadb8337290$export$67b98b1b880a048b = $fd108eadb8337290$var$dest[0];
const $fd108eadb8337290$export$70af50e847ce290a = $fd108eadb8337290$var$dest[1];
const $fd108eadb8337290$export$6bd70292443463a4 = ({ children: children })=>{
    const [searchContext, setSearchContext] = (0, $euxye.useState)({});
    const addClickedArticleIds = (0, $euxye.useCallback)((query, clickedArticleId)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    clickedArticleIds: prev[query]?.clickedArticleIds ? [
                        ...prev[query].clickedArticleIds,
                        clickedArticleId
                    ] : [
                        clickedArticleId
                    ]
                }
            }));
    }, []);
    const addFetchedArticleIds = (0, $euxye.useCallback)((query, fetchedArticles)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    fetchedArticleIds: fetchedArticles
                }
            }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fd108eadb8337290$export$70af50e847ce290a, {
        value: {
            searchContext: searchContext,
            addClickedArticleIds: addClickedArticleIds,
            addFetchedArticleIds: addFetchedArticleIds
        }
    }, children);
};
$fd108eadb8337290$export$6bd70292443463a4.displayName = "SearchContextProvider";

});
parcelRegister("7zbCZ", function(module, exports) {
$parcel$export(module.exports, "createCtx", () => $fcf2ea948fbf8a26$export$d653a1a643c9a98c);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
function $fcf2ea948fbf8a26$export$d653a1a643c9a98c() {
    const ctx = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
    function useCtx() {
        const c = (0, $euxye.useContext)(ctx);
        if (!c) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [
        useCtx,
        ctx.Provider
    ];
}

});


parcelRegister("bsUP2", function(module, exports) {
$parcel$export(module.exports, "AsyncLazyHelpPanel", () => $26fd60c99a259feb$export$7ff46d33d0f13518);
/* eslint-disable jira/filename-case */ 
var $l8G1z = parcelRequire("l8G1z");

const $26fd60c99a259feb$export$7ff46d33d0f13518 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyForPaint)(()=>(parcelRequire("dGJuH")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/help-panel/src/ui/index.tsx"
});

});
parcelRegister("dGJuH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2tbQS").then(()=>parcelRequire('hkf1v'));

});




parcelRegister("er0A5", function(module, exports) {
$parcel$export(module.exports, "ImperativeAPI", () => $bbb705b71569af1a$export$e2ad0ff52e7f8c84);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dtBIL = parcelRequire("dtBIL");

var $8gG0S = parcelRequire("8gG0S");
const $bbb705b71569af1a$export$e2ad0ff52e7f8c84 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dtBIL.Consumer), null, ({ getManager: getManager })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8gG0S.ImperativeAPI), {
            getItemManager: getManager
        }));
$bbb705b71569af1a$export$e2ad0ff52e7f8c84.displayName = "ImperativeAPI";

});
parcelRegister("8gG0S", function(module, exports) {
$parcel$export(module.exports, "ImperativeAPI", () => $60a21beede8320af$export$e2ad0ff52e7f8c84);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $8IotF = parcelRequire("8IotF");

var $6CfY5 = parcelRequire("6CfY5");

var $381kX = parcelRequire("381kX");

var $kQAtd = parcelRequire("kQAtd");

var $2KMaX = parcelRequire("2KMaX");

var $8ANUF = parcelRequire("8ANUF");

var $lOWTN = parcelRequire("lOWTN");

var $6WtXO = parcelRequire("6WtXO");

var $55BnK = parcelRequire("55BnK");

var $gmynf = parcelRequire("gmynf");
const $60a21beede8320af$var$ERROR_LOCATION = 'legacy.imperative-api';
const $60a21beede8320af$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $2KMaX.useLeftSidebarController)();
    const { refresh: refresh } = (0, $8ANUF.useProjectSidebarNavigation)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const sidebarState = (0, $2KMaX.useLeftSidebarState)();
    const sidebarRef = (0, $euxye.useRef)(sidebarState);
    const refreshSidebarRef = (0, $euxye.useRef)(refresh);
    const imperativeAPIRef = (0, $euxye.useRef)({
        viewIds: $gmynf.viewIds,
        itemIds: $gmynf.itemIds,
        expand: expandLeftSidebar,
        collapse: collapseLeftSidebar,
        isCollapsed: ()=>sidebarRef.current.isCollapsed,
        onCollapse: ()=>undefined,
        onCollapseStart: ()=>undefined,
        onCollapseEnd: ()=>undefined,
        onExpand: ()=>undefined,
        onExpandStart: ()=>undefined,
        onExpandEnd: ()=>undefined,
        onItemClick: ()=>undefined,
        setView: ()=>undefined,
        updateActiveView: ()=>undefined,
        setProjectRootView: ()=>undefined,
        getActiveViewItems: ()=>[],
        isInProjectContext: ()=>false,
        updateContext: ()=>undefined,
        updateData: ()=>{
            refreshSidebarRef.current();
        },
        getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                (0, $6CfY5.default).safeErrorWithoutCustomerData($60a21beede8320af$var$ERROR_LOCATION, `There was a problem getting "${(0, $6WtXO.fromManagerKey)(itemManagerKey)}" item manager`, e);
                throw e;
            }),
        createBoard: ()=>{
            (0, $kQAtd.default)();
        },
        modalOpen: ()=>undefined,
        modalClose: ()=>undefined,
        navigate: (url)=>push(url)
    });
    sidebarRef.current = sidebarState;
    refreshSidebarRef.current = refresh;
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $8IotF.loadBridgeWeak)({
            name: 'jira/navigation/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(imperativeAPIRef.current);
        });
        (0, $381kX.provideNavigationApi)({
            navigate: push
        });
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lOWTN.NavigationUIContainer), {
        isGlobal: true
    });
};
$60a21beede8320af$export$e2ad0ff52e7f8c84.displayName = "ImperativeAPI";

});
parcelRegister("381kX", function(module, exports) {
$parcel$export(module.exports, "provideNavigationApi", () => $55ac41ad7c33a220$export$26d28e8849b2805f);
$parcel$export(module.exports, "isInIframe", () => $55ac41ad7c33a220$export$9f140ed41af5108c);
$parcel$export(module.exports, "canSpaTransition", () => $55ac41ad7c33a220$export$59e771495885068f);
$parcel$export(module.exports, "getContainerApi", () => $55ac41ad7c33a220$export$91ed870fd8df2bcb);
$parcel$export(module.exports, "getNavigationApi", () => $55ac41ad7c33a220$export$da4e5a44286a0dd0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Old AMD key: `ac/spa-context`
// TODO: we will improve the type later when we know the code better.
let $55ac41ad7c33a220$var$containerApi = null;
let $55ac41ad7c33a220$var$navigationApi = null;
const $55ac41ad7c33a220$export$3927fb5df700a968 = (api)=>{
    $55ac41ad7c33a220$var$containerApi = api;
};
const $55ac41ad7c33a220$export$26d28e8849b2805f = (api)=>{
    $55ac41ad7c33a220$var$navigationApi = api;
};
const $55ac41ad7c33a220$export$9f140ed41af5108c = ()=>$55ac41ad7c33a220$var$containerApi !== null;
const $55ac41ad7c33a220$export$59e771495885068f = ()=>$55ac41ad7c33a220$var$navigationApi !== null;
const $55ac41ad7c33a220$export$91ed870fd8df2bcb = ()=>$55ac41ad7c33a220$var$containerApi;
const $55ac41ad7c33a220$export$da4e5a44286a0dd0 = ()=>$55ac41ad7c33a220$var$navigationApi;
const $55ac41ad7c33a220$export$6ba42130b045ede1 = ()=>{
    $55ac41ad7c33a220$var$containerApi = null;
    $55ac41ad7c33a220$var$navigationApi = null;
};

});

parcelRegister("kQAtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $7728b78255ddd0de$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/wrm/no-load-bridge

var $9dWMe = parcelRequire("9dWMe");
const $7728b78255ddd0de$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
const $7728b78255ddd0de$var$createBoardLegacy = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $9dWMe.loadBridgeStrict)({
        name: $7728b78255ddd0de$var$amdModuleName,
        wrmKeys: [
            'wrc!com.pyxis.greenhopper.jira:gh-create-board'
        ]
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};
var $7728b78255ddd0de$export$2e2bcd8739ae039 = $7728b78255ddd0de$var$createBoardLegacy;

});

parcelRegister("lOWTN", function(module, exports) {
$parcel$export(module.exports, "NavigationUISubscriber", () => $a6a9770414bdaa9c$export$d3dc1c18cfde5ddd);
$parcel$export(module.exports, "NavigationUIContainer", () => $a6a9770414bdaa9c$export$339ec9ca159ad81f);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $iGu4q = parcelRequire("iGu4q");

var $83oEW = parcelRequire("83oEW");
const $a6a9770414bdaa9c$export$d3dc1c18cfde5ddd = (0, $iGu4q.createSubscriber)((0, $83oEW.default), {
    displayName: 'NavigationUISubscriber',
    selector: null
});
const $a6a9770414bdaa9c$export$339ec9ca159ad81f = (0, $dB6ay.createContainer)((0, $83oEW.default));

});
parcelRegister("83oEW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccdae6a110ec5677$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5QDqc = parcelRequire("5QDqc");

var $gpmaz = parcelRequire("gpmaz");
const $ccdae6a110ec5677$var$initialState = {
    collapseStart: new Set(),
    collapseEnd: new Set(),
    expandStart: new Set(),
    expandEnd: new Set()
};
const $ccdae6a110ec5677$var$ExportedComponent = (0, $5QDqc.createStore)({
    name: 'navigation-ui',
    initialState: $ccdae6a110ec5677$var$initialState,
    actions: $gpmaz.default
});
var $ccdae6a110ec5677$export$2e2bcd8739ae039 = $ccdae6a110ec5677$var$ExportedComponent;

});
parcelRegister("gpmaz", function(module, exports) {
$parcel$export(module.exports, "default", () => $94ce3e8f9b552ece$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import/no-wildcard-imports

var $8PL3t = parcelRequire("8PL3t");
var $8pV3E = parcelRequire("8pV3E");
var $3C4ie = parcelRequire("3C4ie");
var $9Twx8 = parcelRequire("9Twx8");
const $94ce3e8f9b552ece$var$actions = {
    collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($8PL3t.default('collapseStart', cb)),
    collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($3C4ie.default('collapseStart', cb)),
    collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($8pV3E.default('collapseStart')),
    collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($9Twx8.default('collapseStart')),
    collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($8PL3t.default('collapseEnd', cb)),
    collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($3C4ie.default('collapseEnd', cb)),
    collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($8pV3E.default('collapseEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    collapseEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($9Twx8.default('collapseEnd', cb)),
    expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($8PL3t.default('expandStart', cb)),
    expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($3C4ie.default('expandStart', cb)),
    expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($8pV3E.default('expandStart')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandStartRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($9Twx8.default('expandStart', cb)),
    expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($8PL3t.default('expandEnd', cb)),
    expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($3C4ie.default('expandEnd', cb)),
    expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($8pV3E.default('expandEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($9Twx8.default('expandEnd', cb)),
    clearAll: ()=>({ dispatch: dispatch })=>{
            dispatch($94ce3e8f9b552ece$var$actions.collapseStartClear());
            dispatch($94ce3e8f9b552ece$var$actions.collapseEndClear());
            dispatch($94ce3e8f9b552ece$var$actions.expandStartClear());
            dispatch($94ce3e8f9b552ece$var$actions.expandEndClear());
        }
};
var $94ce3e8f9b552ece$export$2e2bcd8739ae039 = $94ce3e8f9b552ece$var$actions;

});
parcelRegister("8PL3t", function(module, exports) {
$parcel$export(module.exports, "default", () => $66d88925cad3d37d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3C4ie = parcelRequire("3C4ie");
const $66d88925cad3d37d$var$add = (key, callback)=>// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set(getState()[key]).add(callback)
        });
        return ()=>dispatch((0, $3C4ie.default)(key, callback));
    };
var $66d88925cad3d37d$export$2e2bcd8739ae039 = $66d88925cad3d37d$var$add;

});
parcelRegister("3C4ie", function(module, exports) {
$parcel$export(module.exports, "default", () => $73660acec98f7d71$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $73660acec98f7d71$var$remove = (key, callback)=>({ setState: setState, getState: getState })=>{
        if (!getState()[key]) return;
        const slice = new Set(getState()[key]);
        slice.delete(callback);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: slice
        });
    };
var $73660acec98f7d71$export$2e2bcd8739ae039 = $73660acec98f7d71$var$remove;

});


parcelRegister("8pV3E", function(module, exports) {
$parcel$export(module.exports, "default", () => $95eb99d6e3db17b6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $95eb99d6e3db17b6$var$clear = (key)=>({ setState: setState })=>// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set()
        });
var $95eb99d6e3db17b6$export$2e2bcd8739ae039 = $95eb99d6e3db17b6$var$clear;

});

parcelRegister("9Twx8", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e0f518e1641ce3d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0e0f518e1641ce3d$var$run = (key, ...args)=>({ getState: getState })=>// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
        (getState()[key] || new Set()).forEach((cb)=>cb(...args));
var $0e0f518e1641ce3d$export$2e2bcd8739ae039 = $0e0f518e1641ce3d$var$run;

});




parcelRegister("gmynf", function(module, exports) {
$parcel$export(module.exports, "itemIds", () => $42e617ad94ff787b$export$443ec49e59de3663);
$parcel$export(module.exports, "viewIds", () => $42e617ad94ff787b$export$8ee2fd038785d9dc);
/* eslint-disable jira/filename-case */ 
var $bhya5 = parcelRequire("bhya5");
const $42e617ad94ff787b$var$ROOT = 'root/index';
const $42e617ad94ff787b$var$ISSUES = 'root/issues';
const $42e617ad94ff787b$var$DASHBOARDS = 'root/dashboards';
const $42e617ad94ff787b$var$PORTFOLIO = 'root/portfolio';
const $42e617ad94ff787b$var$WORK_SCRUM = 'work-scrum';
const $42e617ad94ff787b$var$PLAN_SCRUM = 'plan-scrum';
const $42e617ad94ff787b$var$WORK_KANBAN = 'work-kanban';
const $42e617ad94ff787b$var$PLAN_KANBAN = 'plan-kanban';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
const $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
const $42e617ad94ff787b$var$AGILITY = 'project/agility/index';
const $42e617ad94ff787b$var$BUSINESS = 'project/business/index';
const $42e617ad94ff787b$var$OPS = 'project/ops/index';
const $42e617ad94ff787b$var$SOFTWARE = 'project/software/index';
const $42e617ad94ff787b$var$SOFTWARE_ISSUES = 'project/software/issues';
const $42e617ad94ff787b$var$SOFTWARE_REPORTS = 'project/software/reports';
const $42e617ad94ff787b$var$USER = 'user/index';
const $42e617ad94ff787b$var$USER_REPORTS = 'user/reports';
const $42e617ad94ff787b$var$rootProjectViewIds = {
    AGILITY: $42e617ad94ff787b$var$AGILITY,
    SERVICE_DESK: $bhya5.SERVICE_DESK,
    OPS: $42e617ad94ff787b$var$OPS,
    BUSINESS: $42e617ad94ff787b$var$BUSINESS,
    SOFTWARE: $42e617ad94ff787b$var$SOFTWARE
};
const $42e617ad94ff787b$var$rootViewIds = {
    ROOT: $42e617ad94ff787b$var$ROOT,
    ISSUES: $42e617ad94ff787b$var$ISSUES,
    DASHBOARDS: $42e617ad94ff787b$var$DASHBOARDS,
    PORTFOLIO: $42e617ad94ff787b$var$PORTFOLIO
};
const $42e617ad94ff787b$export$443ec49e59de3663 = {
    WORK_SCRUM: $42e617ad94ff787b$var$WORK_SCRUM,
    PLAN_SCRUM: $42e617ad94ff787b$var$PLAN_SCRUM,
    WORK_KANBAN: $42e617ad94ff787b$var$WORK_KANBAN,
    PLAN_KANBAN: $42e617ad94ff787b$var$PLAN_KANBAN,
    PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $42e617ad94ff787b$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
    ...(0, $bhya5.SERVICE_DESK_ITEMS)
};
const $42e617ad94ff787b$export$8ee2fd038785d9dc = {
    ...$42e617ad94ff787b$var$rootViewIds,
    ...$42e617ad94ff787b$var$rootProjectViewIds,
    SOFTWARE_ISSUES: $42e617ad94ff787b$var$SOFTWARE_ISSUES,
    SOFTWARE_REPORTS: $42e617ad94ff787b$var$SOFTWARE_REPORTS,
    SERVICE_DESK_ISSUES: $bhya5.SERVICE_DESK_ISSUES,
    SERVICE_DESK_QUEUES: $bhya5.SERVICE_DESK_QUEUES,
    SERVICE_DESK_REPORTS: $bhya5.SERVICE_DESK_REPORTS,
    SERVICE_DESK_SETTINGS: $bhya5.SERVICE_DESK_SETTINGS,
    SERVICE_DESK_LANGUAGES: $bhya5.SERVICE_DESK_LANGUAGES,
    SERVICE_DESK_LEGACY_TICKET_TYPES: $bhya5.SERVICE_DESK_LEGACY_TICKET_TYPES,
    SERVICE_DESK_TRANSLATIONS: $bhya5.SERVICE_DESK_TRANSLATIONS,
    SERVICE_DESK_AUTOMATION_SUB_NAV: $bhya5.SERVICE_DESK_AUTOMATION_SUB_NAV,
    SERVICE_DESK_KNOWLEDGE_HUB: $bhya5.SERVICE_DESK_KNOWLEDGE_HUB,
    USER: $42e617ad94ff787b$var$USER,
    USER_REPORTS: $42e617ad94ff787b$var$USER_REPORTS
};

});
parcelRegister("bhya5", function(module, exports) {
$parcel$export(module.exports, "REPORTS_IDS", () => $13f5043390e0f44b$export$1f70a76cb421b107);
$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $13f5043390e0f44b$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "PRACTICES_IDS", () => $13f5043390e0f44b$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $13f5043390e0f44b$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $13f5043390e0f44b$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "SERVICE_DESK", () => $13f5043390e0f44b$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $13f5043390e0f44b$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $13f5043390e0f44b$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $13f5043390e0f44b$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $13f5043390e0f44b$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $13f5043390e0f44b$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $13f5043390e0f44b$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $13f5043390e0f44b$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $13f5043390e0f44b$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $13f5043390e0f44b$export$9a6deaa9c1af559f);
/* eslint-disable jira/filename-case */ const $13f5043390e0f44b$var$HOME_QUEUES = 'queues';
const $13f5043390e0f44b$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $13f5043390e0f44b$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $13f5043390e0f44b$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $13f5043390e0f44b$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $13f5043390e0f44b$var$HOME_INCIDENTS = 'incidents';
const $13f5043390e0f44b$var$HOME_CHANGES = 'changes';
const $13f5043390e0f44b$var$HOME_PROBLEMS = 'problems';
const $13f5043390e0f44b$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $13f5043390e0f44b$var$HOME_CUSTOMERS = 'customers';
const $13f5043390e0f44b$var$HOME_REPORTS = 'reports';
const $13f5043390e0f44b$var$HOME_RAISE_REQUEST = 'raise-request';
const $13f5043390e0f44b$var$HOME_ISSUES = 'issues';
const $13f5043390e0f44b$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $13f5043390e0f44b$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $13f5043390e0f44b$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $13f5043390e0f44b$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $13f5043390e0f44b$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $13f5043390e0f44b$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $13f5043390e0f44b$var$HOME_INVITE_TEAM = 'invite-team';
const $13f5043390e0f44b$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $13f5043390e0f44b$var$HOME_SERVICES = 'services';
const $13f5043390e0f44b$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $13f5043390e0f44b$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $13f5043390e0f44b$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $13f5043390e0f44b$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $13f5043390e0f44b$export$9afbea2cbd37e16d = {
    QUEUES: $13f5043390e0f44b$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $13f5043390e0f44b$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $13f5043390e0f44b$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $13f5043390e0f44b$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $13f5043390e0f44b$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $13f5043390e0f44b$var$HOME_INCIDENTS,
    CHANGES: $13f5043390e0f44b$var$HOME_CHANGES,
    PROBLEMS: $13f5043390e0f44b$var$HOME_PROBLEMS,
    CUSTOMERS: $13f5043390e0f44b$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $13f5043390e0f44b$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $13f5043390e0f44b$var$HOME_REPORTS,
    RAISE_REQUEST: $13f5043390e0f44b$var$HOME_RAISE_REQUEST,
    ISSUES: $13f5043390e0f44b$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $13f5043390e0f44b$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $13f5043390e0f44b$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $13f5043390e0f44b$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $13f5043390e0f44b$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $13f5043390e0f44b$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $13f5043390e0f44b$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $13f5043390e0f44b$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $13f5043390e0f44b$var$HOME_GIVE_FEEDBACK,
    SERVICES: $13f5043390e0f44b$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $13f5043390e0f44b$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $13f5043390e0f44b$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $13f5043390e0f44b$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $13f5043390e0f44b$var$KNOWLEDGE_BASE_IDS = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $13f5043390e0f44b$var$SETTINGS_IDS = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $13f5043390e0f44b$var$QUEUES_IDS = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $13f5043390e0f44b$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $13f5043390e0f44b$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $13f5043390e0f44b$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $13f5043390e0f44b$var$KNOWLEDGE_BASE_IDS,
        SETTINGS: $13f5043390e0f44b$var$SETTINGS_IDS,
        QUEUES: $13f5043390e0f44b$var$QUEUES_IDS,
        REPORTS: $13f5043390e0f44b$export$1f70a76cb421b107
    }
};
const $13f5043390e0f44b$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $13f5043390e0f44b$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $13f5043390e0f44b$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $13f5043390e0f44b$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $13f5043390e0f44b$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $13f5043390e0f44b$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $13f5043390e0f44b$export$707771f2f7e60575 = 'project/service-desk/reports';
const $13f5043390e0f44b$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $13f5043390e0f44b$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $13f5043390e0f44b$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $13f5043390e0f44b$export$d70ba5c124463035 = 'project/service-desk/translations';
const $13f5043390e0f44b$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});




parcelRegister("7oKHF", function(module, exports) {
$parcel$export(module.exports, "MatchedRouteListener", () => $fb7f99e8847b1142$export$c6d9204abc182c3b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $41zzZ = parcelRequire("41zzZ");

var $bc9Gj = parcelRequire("bc9Gj");
const $fb7f99e8847b1142$export$c6d9204abc182c3b = ()=>{
    const [{ route: route, match: match }] = (0, $bc9Gj.useRouter)();
    (0, $euxye.useMemo)(()=>(0, $41zzZ.setMatchedRoute)(route, match), [
        route,
        match
    ]);
    return null;
};
$fb7f99e8847b1142$export$c6d9204abc182c3b.displayName = "MatchedRouteListener";

});

parcelRegister("i3Mi7", function(module, exports) {
$parcel$export(module.exports, "PreviousRouterStateListener", () => $f69469a1e8b95ef7$export$49e28489f2124002);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $33SjG = parcelRequire("33SjG");

var $41zzZ = parcelRequire("41zzZ");

var $45DC3 = parcelRequire("45DC3");
const $f69469a1e8b95ef7$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
    const previousRouterState = (0, $33SjG.usePrevious)(routerState);
    (0, $euxye.useEffect)(()=>{
        (0, $41zzZ.setPreviousRouterState)(previousRouterState ?? null);
    }, [
        previousRouterState
    ]);
    return null;
};
$f69469a1e8b95ef7$export$3fd5ddd6b8e9a200.displayName = "PreviousRouterStateUpdate";
const $f69469a1e8b95ef7$export$49e28489f2124002 = /*#__PURE__*/ (0, $euxye.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $45DC3.RouterSubscriber), null, (routerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f69469a1e8b95ef7$export$3fd5ddd6b8e9a200, {
            routerState: routerState
        })));
$f69469a1e8b95ef7$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';

});

parcelRegister("aPKip", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbaa40358452b04e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bS1iz = parcelRequire("bS1iz");

var $buovh = parcelRequire("buovh");

var $2KJMF = parcelRequire("2KJMF");

var $aZMdt = parcelRequire("aZMdt");
var $aqPkH = parcelRequire("aqPkH");

var $eSI87 = parcelRequire("eSI87");
var $45DC3 = parcelRequire("45DC3");

var $2700E = parcelRequire("2700E");

var $fBoKr = parcelRequire("fBoKr");
/**
 * Defines the component for the `querystring-notifier` module.
 */ const $cbaa40358452b04e$var$QueryStringNotifier = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceType: (0, $46f069e6c968f461$export$1171103ea9083ffa),
        sourceName: "querystringNotifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2KJMF.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $45DC3.RouterSubscriber), null, ({ location: { search: search } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eSI87.RouterActions), null, ({ replace: replace })=>{
                const { showFlag: showFlag, ...query } = (0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).parse(search);
                if (!showFlag) return null;
                const notificationMessages = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fBoKr.notificationMessagesWithoutProjectTerm) : (0, $fBoKr.notificationMessagesWithProjectTerm);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, notificationMessages[showFlag] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireOperationalAnalytics), {
                    eventName: "querystringNotification shown",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireOperationalAnalytics), {
                    eventName: "querystringNotification notFound",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $buovh.default), {
                    op: ()=>{
                        if (notificationMessages[showFlag]) flagService.showFlag(notificationMessages[showFlag]);
                        replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify(query)}`);
                    }
                }));
            }))));
$cbaa40358452b04e$var$QueryStringNotifier.displayName = "QueryStringNotifier";
var $cbaa40358452b04e$export$2e2bcd8739ae039 = $cbaa40358452b04e$var$QueryStringNotifier;

});
parcelRegister("2KJMF", function(module, exports) {
$parcel$export(module.exports, "default", () => $0121e42bfde8de7c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $iQPOZ = parcelRequire("iQPOZ");
const $0121e42bfde8de7c$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, props.children((0, $iQPOZ.flagService)));
$0121e42bfde8de7c$var$FlagServiceSubscriber.displayName = "FlagServiceSubscriber";
var $0121e42bfde8de7c$export$2e2bcd8739ae039 = $0121e42bfde8de7c$var$FlagServiceSubscriber;

});

parcelRegister("fBoKr", function(module, exports) {
$parcel$export(module.exports, "notificationMessagesWithProjectTerm", () => $a1a19ac9370cd38e$export$29d79c6c9f4a7eec);
$parcel$export(module.exports, "notificationMessagesWithoutProjectTerm", () => $a1a19ac9370cd38e$export$c8ca2015225638f9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $acwzf = parcelRequire("acwzf");

var $7eNDO = parcelRequire("7eNDO");
const $a1a19ac9370cd38e$var$boardNotFound = (0, $7eNDO.defineMessage)({
    id: "query-string-notifier.common.board-not-found",
    defaultMessage: "Board not found"
});
const $a1a19ac9370cd38e$var$boardNotFoundDescription = (0, $7eNDO.defineMessage)({
    id: "query-string-notifier.common.board-not-found-description",
    defaultMessage: "You tried to access a board that doesn't exist or that you don't have permission to see."
});
const $a1a19ac9370cd38e$var$projectNotFound = (0, $7eNDO.defineMessage)({
    id: "query-string-notifier.common.project-not-found",
    defaultMessage: "Project not found"
});
const $a1a19ac9370cd38e$var$projectNotFoundDescription = (0, $7eNDO.defineMessage)({
    id: "query-string-notifier.common.project-not-found-description",
    defaultMessage: "You tried to access a project that doesn't exist or that you don't have permission to see."
});
const $a1a19ac9370cd38e$var$projectNotFoundDescriptionGalaxia = (0, $7eNDO.defineMessage)({
    id: "query-string-notifier.common.project-not-found-description-galaxia",
    defaultMessage: "You tried to access a space that doesn't exist or that you don't have permission to see."
});
const $a1a19ac9370cd38e$var$projectNotFoundGalaxia = (0, $7eNDO.defineMessage)({
    id: "query-string-notifier.common.project-not-found-galaxia",
    defaultMessage: "Space not found."
});
const $a1a19ac9370cd38e$export$29d79c6c9f4a7eec = {
    'jsw.board-not-found': {
        id: (0, $acwzf.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: $a1a19ac9370cd38e$var$boardNotFound,
        description: $a1a19ac9370cd38e$var$boardNotFoundDescription,
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found',
        messageType: 'transactional'
    },
    'jsw.project-not-found': {
        id: (0, $acwzf.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: $a1a19ac9370cd38e$var$projectNotFound,
        description: $a1a19ac9370cd38e$var$projectNotFoundDescription,
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found',
        messageType: 'transactional'
    }
};
const $a1a19ac9370cd38e$export$c8ca2015225638f9 = {
    'jsw.board-not-found': {
        id: (0, $acwzf.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: $a1a19ac9370cd38e$var$boardNotFound,
        description: $a1a19ac9370cd38e$var$boardNotFoundDescription,
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found.1',
        messageType: 'transactional'
    },
    'jsw.project-not-found': {
        id: (0, $acwzf.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: $a1a19ac9370cd38e$var$projectNotFoundGalaxia,
        description: $a1a19ac9370cd38e$var$projectNotFoundDescriptionGalaxia,
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found.1',
        messageType: 'transactional'
    }
};

});


parcelRegister("f8jMS", function(module, exports) {
$parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", () => $5fe6a800c5873f09$export$2a43717c77dd3a56);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dCJKF = parcelRequire("dCJKF");

var $cCE2Z = parcelRequire("cCE2Z");

var $l8G1z = parcelRequire("l8G1z");


var $XssJM = parcelRequire("XssJM");

var $ccEzE = parcelRequire("ccEzE");

var $bo20t = parcelRequire("bo20t");

var $jepRN = parcelRequire("jepRN");

const $5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalComponent = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("klXDr")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
    moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
});
const $5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalWrapperWithCondition = ()=>{
    const { data: project } = (0, $XssJM.useProject)();
    const appEditions = (0, $ccEzE.useAppEditions)();
    // Gate early to avoid loading the async modal for ineligible project/edition combinations.
    if (!(0, $bo20t.isProjectTypeAndEditionSupported)(appEditions, project?.type)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $ef71719dcb6e0771$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
        teamName: (0, $ef71719dcb6e0771$export$d57b6b390e78d90f),
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $ef71719dcb6e0771$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalComponent, null)));
};
$5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalWrapperWithCondition.displayName = "AsyncRecommendPremiumToStandardModalWrapperWithCondition";
const $5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalWrapperInternal = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $ef71719dcb6e0771$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
        teamName: (0, $ef71719dcb6e0771$export$d57b6b390e78d90f),
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $ef71719dcb6e0771$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalComponent, null)));
};
$5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalWrapperInternal.displayName = "AsyncRecommendPremiumToStandardModalWrapperInternal";
const $5fe6a800c5873f09$export$2a43717c77dd3a56 = (0, $jepRN.componentWithFG)('perf-async-recommend-premium-to-standard-modal', $5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalWrapperWithCondition, $5fe6a800c5873f09$var$AsyncRecommendPremiumToStandardModalWrapperInternal);

});
/* eslint-disable jira/filename-case */ const $ef71719dcb6e0771$export$b8b9d90f9e5bd72b = '@jira/growth__recommend-premium-to-standard-modal';
const $ef71719dcb6e0771$export$d57b6b390e78d90f = 'growth-tako';
const $ef71719dcb6e0771$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
const $ef71719dcb6e0771$export$c7e6a6b283196232 = '/gateway/api';

parcelRegister("bo20t", function(module, exports) {
$parcel$export(module.exports, "isProjectTypeAndEditionSupported", () => $86c49470ebebd92d$export$c9a5a2a3868318aa);
$parcel$export(module.exports, "getDaysToShowModalDynamicConfig", () => $86c49470ebebd92d$export$d13251fe573e557a);
$parcel$export(module.exports, "getMessageIdForDaysLeft", () => $86c49470ebebd92d$export$c83eb5e66173424a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $d8LhJ = parcelRequire("d8LhJ");

var $4LDqh = parcelRequire("4LDqh");
const $86c49470ebebd92d$export$c9a5a2a3868318aa = (applicationEditions, project)=>{
    const projectType = (0, $f99M0.toProjectType)(project);
    if (!projectType || projectType !== (0, $f99M0.SOFTWARE_PROJECT)) return false;
    return applicationEditions.software === (0, $d8LhJ.PREMIUM_EDITION);
};
const $86c49470ebebd92d$export$4148e83683358d1b = ()=>{
    // Firing exposure to add analytics
    const config = (0, $4LDqh.default).getExperiment('rec_premium_to_standard_days_modal_shown');
    return config.get('value', {});
};
const $86c49470ebebd92d$export$d13251fe573e557a = ()=>{
    const daysConfig = $86c49470ebebd92d$export$4148e83683358d1b();
    const validDays = [
        daysConfig.days_left_for_message_1,
        daysConfig.days_left_for_message_2,
        daysConfig.days_left_for_message_3
    ].filter((day)=>typeof day === 'number');
    // fall back to hard coded days if dynamic config does not return a value
    if (validDays.length === 0) return [
        5,
        3,
        1
    ];
    return validDays;
};
const $86c49470ebebd92d$export$c83eb5e66173424a = (daysLeft)=>{
    const daysConfig = $86c49470ebebd92d$export$4148e83683358d1b();
    if (daysLeft === daysConfig.days_left_for_message_1) return 'prj-grace-period-recc-standard-msg-1';
    if (daysLeft === daysConfig.days_left_for_message_2) return 'prj-grace-period-recc-standard-msg-2';
    if (daysLeft === daysConfig.days_left_for_message_3) return 'prj-grace-period-recc-standard-msg-3';
    return undefined;
};

});

parcelRegister("klXDr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1qo1C").then(()=>parcelRequire('24EeN'));

});


parcelRegister("8dwaf", function(module, exports) {
$parcel$export(module.exports, "CrossJoinNudges", () => $bb5c41022b7c1d52$export$40390e43fcc876d);

var $euxye = parcelRequire("euxye");

var $7TA2J = parcelRequire("7TA2J");

var $h8QGu = parcelRequire("h8QGu");

var $ksy2F = parcelRequire("ksy2F");

var $gtB5i = parcelRequire("gtB5i");

var $kt86l = parcelRequire("kt86l");

var $gITsA = parcelRequire("gITsA");

var $hWDrM = parcelRequire("hWDrM");

var $5XNkF = parcelRequire("5XNkF");

var $8rTGi = parcelRequire("8rTGi");

var $18Dnt = parcelRequire("18Dnt");

var $jau28 = parcelRequire("jau28");
const $bb5c41022b7c1d52$export$40390e43fcc876d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "JiraCrossJoinNudges",
        teamName: "groot",
        packageName: "jiraCrossJoinNudges"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($bb5c41022b7c1d52$var$CrossJoinNudgesWithoutErrorBoundary, null));
};
$bb5c41022b7c1d52$export$40390e43fcc876d.displayName = "CrossJoinNudges";
const $bb5c41022b7c1d52$var$useCrossJoinNudges = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const subProduct = (0, $gtB5i.useSubProduct)();
    const getMSRNudgeRecommendations = (0, $ksy2F.useMSRNudgeRecommendations)({
        product: 'jira',
        sessionId: (0, $7TA2J.v4)(),
        cloudId: cloudId,
        subProduct: subProduct || ''
    });
    const getJpdCrossJoinNudgeEligibility = (0, $gITsA.useJpdCrossJoinNudgeEligibility)({
        getMSRNudgeRecommendations: getMSRNudgeRecommendations
    });
    const getLoomCrossJoinNudgeEligibility = (0, $jau28.useLoomCrossJoinNudgeEligibility)();
    const getConfluenceCrossJoinNudgeEligibility = (0, $hWDrM.useConfluenceCrossJoinNudgeEligibility)({
        getMSRNudgeRecommendations: getMSRNudgeRecommendations
    });
    const showJpdNudge = (0, $5XNkF.useJpdCrossJoinNudge)();
    const showLoomNudge = (0, $8rTGi.useLoomCrossJoinNudge)();
    const showConfluenceNudge = (0, $18Dnt.useConfluenceCrossJoinNudge)();
    (0, $euxye.useEffect)(()=>{
        async function executeNudges() {
            const loomEligibilityResult = await getLoomCrossJoinNudgeEligibility();
            if (loomEligibilityResult.isEligible) {
                showLoomNudge();
                return;
            }
            const jpdEligibilityResult = await getJpdCrossJoinNudgeEligibility();
            if (jpdEligibilityResult.isEligible) {
                showJpdNudge(jpdEligibilityResult.data);
                return;
            }
            const confluenceEligibilityResult = await getConfluenceCrossJoinNudgeEligibility();
            if (confluenceEligibilityResult.isEligible) showConfluenceNudge(confluenceEligibilityResult.data);
        }
        executeNudges();
    }, [
        getConfluenceCrossJoinNudgeEligibility,
        getJpdCrossJoinNudgeEligibility,
        getLoomCrossJoinNudgeEligibility,
        showConfluenceNudge,
        showJpdNudge,
        showLoomNudge
    ]);
};
const $bb5c41022b7c1d52$var$CrossJoinNudgesWithoutErrorBoundary = ()=>{
    $bb5c41022b7c1d52$var$useCrossJoinNudges();
    return null;
};
$bb5c41022b7c1d52$var$CrossJoinNudgesWithoutErrorBoundary.displayName = "CrossJoinNudgesWithoutErrorBoundary";
var $bb5c41022b7c1d52$export$2e2bcd8739ae039 = $bb5c41022b7c1d52$export$40390e43fcc876d;

});
parcelRegister("ksy2F", function(module, exports) {
$parcel$export(module.exports, "useMSRNudgeRecommendations", () => $bd8ef1e7566dc52e$export$e87e269d0f71e3a3);

var $euxye = parcelRequire("euxye");

var $bIIp7 = parcelRequire("bIIp7");
const $bd8ef1e7566dc52e$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudgeFlags';
class $bd8ef1e7566dc52e$export$f6f4711ce6617505 extends Error {
    constructor(message, options){
        super(message);
        this.name = 'RecommendationError';
        this.options = options;
    }
}
function $bd8ef1e7566dc52e$export$e87e269d0f71e3a3({ product: product, sessionId: sessionId, cloudId: cloudId, subProduct: subProduct }) {
    const contextResolver = (0, $euxye.useCallback)(()=>({
            product: product,
            useCase: $bd8ef1e7566dc52e$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        product,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $bIIp7.default)({
        contextResolver: contextResolver
    });
    return (0, $euxye.useCallback)(async ()=>{
        try {
            const result = await getRecommendations({
                first: 4,
                config: {
                    cacheConfig: {
                        ttl: 86400
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            const recommendedEntities = (data ?? []).map((e)=>e.entityId);
            return recommendedEntities;
        } catch (error) {
            let cause;
            if (error instanceof Error) cause = error;
            else if (error && error.reason) cause = new Error(error.reason);
            else cause = new Error(String(error));
            throw new $bd8ef1e7566dc52e$export$f6f4711ce6617505('Get MSR nudge recommendations error', {
                cause: cause
            });
        }
    }, [
        getRecommendations
    ]);
}

});
parcelRegister("bIIp7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c66a0fd17a4141d$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");


var $kluho = parcelRequire("kluho");

var $031oW = parcelRequire("031oW");

var $2FM91 = parcelRequire("2FM91");

var $1RuWv = parcelRequire("1RuWv");
const $3c66a0fd17a4141d$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
	 * Fetch recommendations for a given context
	 */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $031oW.default)(endpoint);
        const requester = new (0, $1RuWv.default)(new (0, $2FM91.RecommendationsRequestBroker)());
        const context = (0, $kluho.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $06d48a9860e9e367$export$14b7e2c312f27acd),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $3c66a0fd17a4141d$export$2e2bcd8739ae039 = $3c66a0fd17a4141d$var$useRecommendations;

});
// Events
const $06d48a9860e9e367$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $06d48a9860e9e367$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $06d48a9860e9e367$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $06d48a9860e9e367$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $06d48a9860e9e367$export$14b7e2c312f27acd = 'atlassian-growth-recos';

parcelRegister("kluho", function(module, exports) {
$parcel$export(module.exports, "getContext", () => $bbf1859d2867a8e4$export$31553aaa555c1514);
function $bbf1859d2867a8e4$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $bbf1859d2867a8e4$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}

});

parcelRegister("031oW", function(module, exports) {
$parcel$export(module.exports, "default", () => $865c57b8275f878d$export$2e2bcd8739ae039);

var $2IbIt = parcelRequire("2IbIt");
class $865c57b8275f878d$export$2e2bcd8739ae039 extends (0, $2IbIt.default) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $865c57b8275f878d$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
$865c57b8275f878d$export$2e2bcd8739ae039.displayName = "RecommendationsRequestMaker";
const $865c57b8275f878d$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;

});
parcelRegister("2IbIt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddcb5d7765c97b4f$export$2e2bcd8739ae039);

var $kluho = parcelRequire("kluho");
class $ddcb5d7765c97b4f$export$2e2bcd8739ae039 {
    constructor(endpoint){
        this.endpoint = endpoint;
    }
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $kluho.getContext)(contextResolver);
    }
}

});


parcelRegister("2FM91", function(module, exports) {
$parcel$export(module.exports, "RecommendationsRequestBroker", () => $adcfe276cf930fc5$export$7f19312509e0d2c0);

var $8do6p = parcelRequire("8do6p");
class $adcfe276cf930fc5$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $8do6p.RecommendationSuccessResultCreator)(response, result);
    }
}

});
parcelRegister("8do6p", function(module, exports) {
$parcel$export(module.exports, "RecommendationSuccessResultCreator", () => $6078b8fa575baac6$export$c02f0b31b3b527a3);

var $lVOrO = parcelRequire("lVOrO");
class $6078b8fa575baac6$export$c02f0b31b3b527a3 extends (0, $lVOrO.QuerySuccessResultCreator) {
    constructor(response, data){
        super(response, data), this.response = response;
    }
    makeQueryResult() {
        return new (0, $lVOrO.GraphQlQueryResult)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
}

});
parcelRegister("lVOrO", function(module, exports) {
$parcel$export(module.exports, "GraphQlQueryResult", () => $10e748858cf8e4f0$export$d0a1abfd57dc5018);
$parcel$export(module.exports, "NonOkQueryResultCreator", () => $10e748858cf8e4f0$export$ad7cb7f4450dd7c4);
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", () => $10e748858cf8e4f0$export$553722ecbbe27276);
$parcel$export(module.exports, "MissingQueryDataResultCreator", () => $10e748858cf8e4f0$export$ff264bfdc9a404eb);
$parcel$export(module.exports, "QuerySuccessResultCreator", () => $10e748858cf8e4f0$export$6b16771e962990ff);
class $10e748858cf8e4f0$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $10e748858cf8e4f0$var$QueryResultCreator {
}
class $10e748858cf8e4f0$export$ad7cb7f4450dd7c4 extends $10e748858cf8e4f0$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $10e748858cf8e4f0$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
}
class $10e748858cf8e4f0$export$553722ecbbe27276 extends $10e748858cf8e4f0$var$QueryResultCreator {
    constructor(errors){
        super(), this.errors = errors;
    }
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $10e748858cf8e4f0$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
}
class $10e748858cf8e4f0$export$ff264bfdc9a404eb extends $10e748858cf8e4f0$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $10e748858cf8e4f0$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
}
class $10e748858cf8e4f0$export$6b16771e962990ff extends $10e748858cf8e4f0$var$QueryResultCreator {
    constructor(response, data){
        super(), this.response = response, this.data = data;
    }
}

});



parcelRegister("1RuWv", function(module, exports) {
$parcel$export(module.exports, "default", () => $afcd417002be9b19$export$2e2bcd8739ae039);

var $lVOrO = parcelRequire("lVOrO");

var $ik1Co = parcelRequire("ik1Co");
class $afcd417002be9b19$export$2e2bcd8739ae039 {
    constructor(broker){
        this.broker = broker;
    }
    /**
	 * Fetches the response by the given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The query result
	 */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $lVOrO.NonOkQueryResultCreator)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $lVOrO.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $lVOrO.MissingQueryDataResultCreator)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
	 * Fetches the response by tha given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The response from the request
	 */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $ik1Co.default).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
}

});
parcelRegister("ik1Co", function(module, exports) {
$parcel$export(module.exports, "default", () => $0432b08e710a22ec$export$2e2bcd8739ae039);

var $iQ9qk = parcelRequire("iQ9qk");

var $1EnuT = parcelRequire("1EnuT");
class $0432b08e710a22ec$export$2e2bcd8739ae039 {
    /**
	 * Returns the cache provider based on the given cache configuration
	 *
	 * @param cacheConfig The cache configuration to use
	 * @returns The cache provider
	 */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $1EnuT.default)(cacheConfig);
        return new (0, $iQ9qk.default)();
    }
}

});
parcelRegister("iQ9qk", function(module, exports) {
$parcel$export(module.exports, "default", () => $20ccdf8670c11349$export$2e2bcd8739ae039);
class $20ccdf8670c11349$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}

});

parcelRegister("1EnuT", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a6cbf0b6affaf26$export$2e2bcd8739ae039);

var $jxxwS = parcelRequire("jxxwS");

var $2q0kH = parcelRequire("2q0kH");
class $4a6cbf0b6affaf26$export$2e2bcd8739ae039 {
    /**
	 * Initialise the WebCacheStorage
	 * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
	 * @param onError a callback when any error occurs
	 */ constructor(cacheProviderConfig){
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $jxxwS.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $2q0kH.default)(this.cacheConfig);
    }
    /**
	 * Get cached response
	 */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Put response in cache
	 */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Delete cached response
	 */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
	 * Check if the cached response is expired
	 */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
	 * Compose the URL and the use case as the search params to cache the response
	 */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
	 * Get the key to store the response
	 * Interally, it hashes the request body to get a unique key
	 */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
}

});
parcelRegister("jxxwS", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c7241d0ba5777e5$export$2e2bcd8739ae039);
const $7c7241d0ba5777e5$var$DEFAULT_TTL = 60;
class $7c7241d0ba5777e5$export$2e2bcd8739ae039 {
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $7c7241d0ba5777e5$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
}

});

parcelRegister("2q0kH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c11f97a0e18a71d4$export$2e2bcd8739ae039);
class $c11f97a0e18a71d4$export$2e2bcd8739ae039 {
    /**
	 * Initialise the ExpiryStorage
	 */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
    /**
	 * Set the expiry date of the cached response
	 */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Get the expiry date of the cached response
	 */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Initialise the IndexedDB
	 */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
	 * Get the object store from the IndexedDB
	 */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
}

});






parcelRegister("gITsA", function(module, exports) {
$parcel$export(module.exports, "useJpdCrossJoinNudgeEligibility", () => $7f16facfde838468$export$cf17b7d2f952c993);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $5rZe5 = parcelRequire("5rZe5");

var $f2wVS = parcelRequire("f2wVS");

var $d1jAR = parcelRequire("d1jAR");

var $eeOhg = parcelRequire("eeOhg");

var $cGdse = parcelRequire("cGdse");

var $bwtKg = parcelRequire("bwtKg");

var $hgxiY = parcelRequire("hgxiY");

var $fRc93 = parcelRequire("fRc93");

var $88mpo = parcelRequire("88mpo");

var $3nBZF = parcelRequire("3nBZF");


var $7k33z = parcelRequire("7k33z");
const $7f16facfde838468$export$cf17b7d2f952c993 = ({ getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const userId = (0, $3GN2r.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const licensedProducts = (0, $5rZe5.useLicensedProducts)();
    const isJpdRoute = (0, $f2wVS.useIsActiveRoute)('polaris-ideas');
    const fetchIsRequestAccessCapable = (0, $bwtKg.useFetchIsRequestAccessCapable)('crossJoinNudgesJiraToJpd');
    const { getVisitedCount: getVisitedCount } = (0, $eeOhg.useSnooze)('crossJoinNudgesJiraToJpd');
    const { getNudgeState: getNudgeState } = (0, $3nBZF.useNudgeStateJiraToJpd)();
    return (0, $euxye.useCallback)(async ()=>{
        try {
            if ((0, $eeOhg.getOrUpdateFeatureVisited)('crossJoinNudgesJiraToJpd', 7)) return {
                isEligible: false,
                ineligibleReason: 'feature_visited_too_recently'
            };
            if (isJpdRoute) return {
                isEligible: false,
                ineligibleReason: 'jpd_route'
            };
            const featureVisitedCount = await getVisitedCount();
            if (featureVisitedCount >= (0, $0ef25b7cd0c5e2a4$export$a4b45159adbcc3d7)) return {
                isEligible: false,
                ineligibleReason: 'nudge_seen_too_many_times'
            };
            if (await getNudgeState() === 'DISMISSED') return {
                isEligible: false,
                ineligibleReason: 'nudge_already_dismissed'
            };
            if (!licensedProducts['jira-product-discovery']) return {
                isEligible: false,
                ineligibleReason: 'no_jpd_licence'
            };
            if (await (0, $fRc93.isSiteOptedOut)(cloudId)) {
                (0, $d1jAR.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd');
                return {
                    isEligible: false,
                    ineligibleReason: 'site_is_opted_out'
                };
            }
            if (!await (0, $hgxiY.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
                isEligible: false,
                ineligibleReason: 'new_site_less_than_7_days_old'
            };
            if (await (0, $88mpo.isNewActiveUser)(cloudId, userId)) return {
                isEligible: false,
                ineligibleReason: 'new_active_user'
            };
            if (await (0, $cGdse.hasProductAccess)('jira-product-discovery', cloudId)) return {
                isEligible: false,
                ineligibleReason: 'already_have_access'
            };
            if (!await fetchIsRequestAccessCapable('jira-product-discovery', cloudId)) return {
                isEligible: false,
                ineligibleReason: 'not_eligible_for_request_access'
            };
            if (await (0, $7k33z.isExcludedForNav4Placement)(cloudId, userId, createAnalyticsEvent, 'jira_productDiscovery')) return {
                isEligible: false,
                ineligibleReason: 'excluded_for_nav4_placement_experiment'
            };
            const recommendations = await getMSRNudgeRecommendations();
            if (!recommendations.includes('cjn-jira-jpd')) {
                (0, $d1jAR.fireMsrNotRecommendedAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd', 'cjn-jira-jpd');
                return {
                    isEligible: false,
                    ineligibleReason: 'msr_nudge_not_recommended'
                };
            }
            return {
                isEligible: true,
                data: {
                    featureVisitedCount: featureVisitedCount
                }
            };
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                ineligibleReason: 'unexpected error'
            };
        }
    }, [
        isJpdRoute,
        getVisitedCount,
        getNudgeState,
        cloudId,
        userId,
        licensedProducts,
        createAnalyticsEvent,
        fetchIsRequestAccessCapable,
        getMSRNudgeRecommendations
    ]);
};

});
parcelRegister("d1jAR", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $e7bfb556a64fc507$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "fireSiteOptedOutAnalytics", () => $e7bfb556a64fc507$export$b6a30d1aef42926f);
$parcel$export(module.exports, "fireMsrNotRecommendedAnalytics", () => $e7bfb556a64fc507$export$e19a7f6320c04dee);
$parcel$export(module.exports, "fireCjnNav4PlacementExposed", () => $e7bfb556a64fc507$export$7e4e3fe5853ceb64);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $aJ81Y = parcelRequire("aJ81Y");
const $e7bfb556a64fc507$export$a27c21aa3ed8f0f1 = (id, error, attributes = {})=>(0, $hFtK7.fireErrorAnalytics)({
        meta: {
            id: id,
            packageName: 'jiraCrossJoinNudges',
            teamName: 'puma'
        },
        attributes: attributes,
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
const $e7bfb556a64fc507$export$b6a30d1aef42926f = (createAnalyticsEvent, integration)=>{
    (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
        flagKey: 'NON_CONTEXTUAL_CJNS',
        ineligibilityReason: 'SITE_OPTED_OUT',
        integration: integration
    });
};
const $e7bfb556a64fc507$export$e19a7f6320c04dee = (createAnalyticsEvent, integration, nudgeId)=>{
    (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
        flagKey: 'NON_CONTEXTUAL_CJNS',
        ineligibilityReason: 'MSR_NOT_RECOMMENDED',
        integration: integration,
        nudgeId: nudgeId
    });
};
const $e7bfb556a64fc507$export$7e4e3fe5853ceb64 = (createAnalyticsEvent, actionSubject, flagKey, cohort, targetProduct)=>{
    (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), `${actionSubject} exposed`, {
        flagKey: flagKey,
        cohort: cohort,
        targetProduct: targetProduct
    });
};

});

parcelRegister("eeOhg", function(module, exports) {
$parcel$export(module.exports, "cjnEligibilityCacheHandler", () => $f5b08225f9bfa690$export$beb12117dd89482e);
$parcel$export(module.exports, "withEligibilityCache", () => $f5b08225f9bfa690$export$86938f072bd79cac);
$parcel$export(module.exports, "getOrUpdateFeatureVisited", () => $f5b08225f9bfa690$export$fd94e26348dead8f);
$parcel$export(module.exports, "getFeatureVisited", () => $f5b08225f9bfa690$export$ee4ac5fe77f8084a);
$parcel$export(module.exports, "snoozeFeatureFor30Days", () => $f5b08225f9bfa690$export$788659dbff920e5f);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $f5b08225f9bfa690$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $f5b08225f9bfa690$export$41554dcbb74e65ef);
$parcel$export(module.exports, "useSnooze", () => $f5b08225f9bfa690$export$26ba987533188b38);
$parcel$export(module.exports, "setHasSeenNudgeInLast7Days", () => $f5b08225f9bfa690$export$d172f6d49154a44b);
$parcel$export(module.exports, "getHasSeenNudgeInLast7Days", () => $f5b08225f9bfa690$export$f03b4069dddacff6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $iXN50 = parcelRequire("iXN50");

var $3GN2r = parcelRequire("3GN2r");

var $6bBlI = parcelRequire("6bBlI");

var $i860n = parcelRequire("i860n");

var $lz704 = parcelRequire("lz704");
const $f5b08225f9bfa690$var$VISITED_COUNT_KEY = 'CROSS_JOIN_NUDGE_CONFLUENCE_VISITED_COUNT';
const $f5b08225f9bfa690$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $f5b08225f9bfa690$export$9e1407fde36d61e4 = (0, $iXN50.createLocalStorageProvider)('cross-join-nudge-visited');
const $f5b08225f9bfa690$var$visitedKeys = {
    crossJoinNudgesConfluence: 'cross.join.nudges.confluence.visited',
    crossJoinNudgesJiraToJpd: 'cross.join.nudges.jpd.visited',
    crossJoinNudgesJiraToLoom: 'cross.join.nudges.loom.visited',
    crossJoinNudgesYourWork: 'cross.join.nudges.your.work',
    crossJoinNudgesMsr: 'cross.join.nudges.msr'
};
const $f5b08225f9bfa690$export$ab87107a670964ea = (0, $6bBlI.default)({
    size: 30,
    cacheKey: 'cjn-eligibility-cache',
    storageType: (0, $7456460209a6b9cd$export$2670cb7d5d4f7184)
});
const $f5b08225f9bfa690$export$beb12117dd89482e = {
    get: (key)=>$f5b08225f9bfa690$export$ab87107a670964ea.get(key),
    set: (key, value)=>$f5b08225f9bfa690$export$ab87107a670964ea.set(key, value),
    remove: (key)=>$f5b08225f9bfa690$export$ab87107a670964ea.remove(key)
};
function $f5b08225f9bfa690$export$86938f072bd79cac(key, eligibilityCheck, daysToLive) {
    return async (...args)=>{
        try {
            const cachedValue = await $f5b08225f9bfa690$export$beb12117dd89482e.get(key);
            if (cachedValue !== null && cachedValue !== undefined) {
                if (!cachedValue.ttl || cachedValue.ttl > Date.now()) return cachedValue.value;
            }
        } catch (e) {
        // cache get fail, do nothing
        }
        const result = await eligibilityCheck(...args);
        try {
            const ttlTimestamp = daysToLive !== undefined ? new Date().getTime() + $f5b08225f9bfa690$var$ONE_DAY_IN_MILLISECONDS * daysToLive : undefined;
            await $f5b08225f9bfa690$export$beb12117dd89482e.set(key, {
                value: result,
                ttl: ttlTimestamp
            });
        } catch (e) {
        // cache set fail, do nothing
        }
        return result;
    };
}
const $f5b08225f9bfa690$export$6515f7b9b46b3e7a = async ()=>{
    await $f5b08225f9bfa690$export$ab87107a670964ea.set('local_storage_enabled', {
        value: true
    });
    const value = await $f5b08225f9bfa690$export$ab87107a670964ea.get('local_storage_enabled');
    return value?.value === true;
};
const $f5b08225f9bfa690$export$fd94e26348dead8f = (keyName, snoozeForDays)=>{
    try {
        if ($f5b08225f9bfa690$export$ee4ac5fe77f8084a(keyName)) return true;
        $f5b08225f9bfa690$export$7c52d8e39da481c4(keyName, snoozeForDays);
        // A small cohort of users have local storage completely disabled.
        // This code detects that and always returns visited=true for those users
        if (!$f5b08225f9bfa690$export$ee4ac5fe77f8084a(keyName)) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinNudges'
                }
            });
            return true;
        }
        return false;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $f5b08225f9bfa690$export$fcf4f05929d7c90b = (keyName)=>{
    const key = $f5b08225f9bfa690$var$visitedKeys[keyName];
    $f5b08225f9bfa690$export$9e1407fde36d61e4.remove(key);
};
const $f5b08225f9bfa690$export$7c52d8e39da481c4 = (keyName, numOfDaysSnoozed)=>{
    const key = $f5b08225f9bfa690$var$visitedKeys[keyName];
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $f5b08225f9bfa690$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    // @browser-storage setter
    $f5b08225f9bfa690$export$9e1407fde36d61e4.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $f5b08225f9bfa690$export$7a91674e4b755c4b = (keyName)=>{
    $f5b08225f9bfa690$export$7c52d8e39da481c4(keyName, 7);
};
const $f5b08225f9bfa690$export$788659dbff920e5f = (keyName)=>{
    $f5b08225f9bfa690$export$7c52d8e39da481c4(keyName, 30);
};
const $f5b08225f9bfa690$export$ee4ac5fe77f8084a = (keyName)=>{
    const key = $f5b08225f9bfa690$var$visitedKeys[keyName];
    const snoozeUntilTimestampString = $f5b08225f9bfa690$export$9e1407fde36d61e4.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $f5b08225f9bfa690$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $f5b08225f9bfa690$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $lz704.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    if ((0, $i860n.fg)('PUMA-1625-fix-cjn-value-sentry-errors')) return Number.isFinite(visitedCount.value) ? visitedCount.value : 0;
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $f5b08225f9bfa690$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $f5b08225f9bfa690$var$VISITED_COUNT_KEY)=>{
    await (0, $lz704.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};
const $f5b08225f9bfa690$export$1577cce2b8cadf = (keyName)=>{
    const key = $f5b08225f9bfa690$var$visitedKeys[keyName];
    return `${key}.count`;
};
const $f5b08225f9bfa690$export$26ba987533188b38 = (keyName)=>{
    const accountId = (0, $3GN2r.useAccountId)() || '';
    const countKey = $f5b08225f9bfa690$export$1577cce2b8cadf(keyName);
    return (0, $euxye.useMemo)(()=>({
            snoozeFor7Days: ()=>$f5b08225f9bfa690$export$7a91674e4b755c4b(keyName),
            snoozeFor30Days: ()=>$f5b08225f9bfa690$export$788659dbff920e5f(keyName),
            getVisitedCount: ()=>$f5b08225f9bfa690$export$64c6861c3bbd89a2(accountId, countKey),
            increaseVisitedCount: (incrementedCount)=>$f5b08225f9bfa690$export$41554dcbb74e65ef(accountId, incrementedCount, countKey),
            isVisited: ()=>$f5b08225f9bfa690$export$ee4ac5fe77f8084a(keyName)
        }), [
        accountId,
        countKey,
        keyName
    ]);
};
const $f5b08225f9bfa690$export$d172f6d49154a44b = async ()=>{
    const DAYS_TO_CHECK = 7;
    try {
        // overwrite the key even if it exists
        await $f5b08225f9bfa690$export$beb12117dd89482e.set('has_seen_nudge_in_last_7_days', {
            value: true,
            ttl: $f5b08225f9bfa690$var$ONE_DAY_IN_MILLISECONDS * DAYS_TO_CHECK + Date.now()
        });
    } catch (e) {
    // cache set fail, do nothing
    }
};
const $f5b08225f9bfa690$export$f03b4069dddacff6 = async ()=>{
    try {
        const result = await $f5b08225f9bfa690$export$beb12117dd89482e.get('has_seen_nudge_in_last_7_days');
        if (result?.ttl && result.ttl > Date.now()) return true;
    } catch (e) {
    // cache get fail, return false
    }
    return false;
};

});
parcelRegister("6bBlI", function(module, exports) {
$parcel$export(module.exports, "default", () => $28c67491ffb208f8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $b4Ar8 = parcelRequire("b4Ar8");
const $28c67491ffb208f8$var$pNothing = ()=>Promise.resolve();
const $28c67491ffb208f8$var$createEntry = (config)=>{
    if (!false) {
        const Cache = (0, $b4Ar8.default)(config);
        const getAll = ()=>Cache.then((cache)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // oxlint-disable-next-line no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $28c67491ffb208f8$var$pNothing,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $28c67491ffb208f8$var$pNothing,
        update: $28c67491ffb208f8$var$pNothing,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $28c67491ffb208f8$var$pNothing
    };
};
var $28c67491ffb208f8$export$2e2bcd8739ae039 = $28c67491ffb208f8$var$createEntry;

});
parcelRegister("b4Ar8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3125581624e1f496$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iXN50 = parcelRequire("iXN50");

var $cBnIS = parcelRequire("cBnIS");

var $6CfY5 = parcelRequire("6CfY5");


var $kkHVL = parcelRequire("kkHVL");
const $3125581624e1f496$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3125581624e1f496$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $kkHVL.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $7456460209a6b9cd$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3125581624e1f496$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $7456460209a6b9cd$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            // @browser-storage setter
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $7456460209a6b9cd$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3125581624e1f496$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $7456460209a6b9cd$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $7456460209a6b9cd$export$2670cb7d5d4f7184)) storage = (0, $iXN50.createLocalStorageProvider)((0, $kkHVL.CACHE_PREFIX));
        else storage = (0, $cBnIS.createSessionStorageProvider)((0, $kkHVL.CACHE_PREFIX));
        // eslint-disable-next-line jira/web-storage/no-pass-browser-storage-provider
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $7456460209a6b9cd$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $7456460209a6b9cd$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $7456460209a6b9cd$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $7456460209a6b9cd$export$bf340b99118a1511)) delete storedContent[firstEntry];
            }
        }
        // @browser-storage setter
        props.storageType !== (0, $7456460209a6b9cd$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $7456460209a6b9cd$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $7456460209a6b9cd$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $6CfY5.default).safeWarnWithoutCustomerData((0, $7456460209a6b9cd$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $7456460209a6b9cd$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $7456460209a6b9cd$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $7456460209a6b9cd$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $7456460209a6b9cd$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $7456460209a6b9cd$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        // @browser-storage setter
        props.storageType !== (0, $7456460209a6b9cd$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $7456460209a6b9cd$export$9eb68924983e00fb), entries);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $7456460209a6b9cd$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            // @browser-storage setter
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $7456460209a6b9cd$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $7456460209a6b9cd$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $kkHVL.default).scopes.current !== (0, $kkHVL.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $3125581624e1f496$var$cacheMap = {};
const $3125581624e1f496$var$getCache = async (props)=>{
    await (0, $kkHVL.scopeGuard)().catch((error)=>{
        (0, $6CfY5.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3125581624e1f496$var$cacheMap[cacheKey] = $3125581624e1f496$var$cacheMap[cacheKey] || new $3125581624e1f496$export$94affb487e701bf2(props);
    return $3125581624e1f496$var$cacheMap[cacheKey];
};
const $3125581624e1f496$export$710d301bf26d9700 = ()=>{
    Object.values($3125581624e1f496$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3125581624e1f496$export$2e2bcd8739ae039 = $3125581624e1f496$var$getCache;

});
/* eslint-disable jira/filename-case */ const $7456460209a6b9cd$export$7271276960377470 = 'common-cache';
const $7456460209a6b9cd$export$a61768fefd33fcb1 = 'capacity exceeded';
const $7456460209a6b9cd$export$6c4d37c7f376a1de = 'clear';
const $7456460209a6b9cd$export$e271b26eefe41db8 = 'update';
const $7456460209a6b9cd$export$4bd2facc4a3e6aa1 = 'delete';
const $7456460209a6b9cd$export$26d12233004a7a60 = 'delete stale entry';
const $7456460209a6b9cd$export$1bb358554aac31c1 = 'get';
const $7456460209a6b9cd$export$61f74127e2b53cbe = 'hydrate';
const $7456460209a6b9cd$export$5e8f180ef0142226 = 'set';
const $7456460209a6b9cd$export$9eb68924983e00fb = 'get entries';
const $7456460209a6b9cd$export$bf340b99118a1511 = 'memory';
const $7456460209a6b9cd$export$2670cb7d5d4f7184 = 'local';
const $7456460209a6b9cd$export$b796061ff0c82e1a = 'session';



parcelRegister("lz704", function(module, exports) {
$parcel$export(module.exports, "setUserProperty", () => $006f4f4e3e499c67$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $006f4f4e3e499c67$export$b3126db2ef6e34ed);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");
const $006f4f4e3e499c67$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $006f4f4e3e499c67$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $006f4f4e3e499c67$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $h2wCv.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinNudges'
            },
            error: error
        });
    }
};
const $006f4f4e3e499c67$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $006f4f4e3e499c67$var$getUserUrl(accountId, propertyKey);
    if ((0, $i860n.fg)('PUMA-1625-fix-cjn-value-sentry-errors')) {
        let response;
        try {
            response = await (0, $h2wCv.performGetRequest)(url);
        } catch (_ignoredError) {
            response = null;
        }
        return response ?? {
            key: propertyKey,
            value: defaultValue
        };
    }
    try {
        const response = await (0, $h2wCv.performGetRequest)(url);
        return response;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("cGdse", function(module, exports) {
$parcel$export(module.exports, "hasProductAccess", () => $8d38cb9e057df01f$export$61073fd69a83a1e3);
$parcel$export(module.exports, "fetchCachedAccessCheck", () => $8d38cb9e057df01f$export$cd2f9bc003d00b45);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iXN50 = parcelRequire("iXN50");

var $4fhEY = parcelRequire("4fhEY");

var $aJ81Y = parcelRequire("aJ81Y");
const $8d38cb9e057df01f$var$URL = '/gateway/api/permissions/permitted';
const $8d38cb9e057df01f$export$61073fd69a83a1e3 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await (0, $4fhEY.default)($8d38cb9e057df01f$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
// Purposefully set this to 7 days as it's unlikely user can be kicked out of Confluence when they already have access
const $8d38cb9e057df01f$var$PERMISSION_CACHE_KEY_EXPIRY_MS = 604800000;
const $8d38cb9e057df01f$var$crossJoinApiCache = (0, $iXN50.createLocalExpirableStorageProvider)('cross-join-nudge-conf-perms-api-cache');
const $8d38cb9e057df01f$export$cd2f9bc003d00b45 = async (createAnalyticsEvent, product, cloudId, touchpoint)=>{
    const cacheKey = `cross.join.${product}.cache.key`;
    let permissionResponse = $8d38cb9e057df01f$var$crossJoinApiCache.get(cacheKey);
    if (permissionResponse === undefined) {
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheMiss', {
            touchpoint: touchpoint,
            product: product
        });
        try {
            permissionResponse = await $8d38cb9e057df01f$export$61073fd69a83a1e3(product, cloudId);
        } catch (err) {
            // No PII from identity exception so fire operational analytics consistently
            (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck fetchError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        try {
            // @browser-storage setter
            $8d38cb9e057df01f$var$crossJoinApiCache.set(cacheKey, permissionResponse, Date.now() + $8d38cb9e057df01f$var$PERMISSION_CACHE_KEY_EXPIRY_MS);
        } catch (err) {
            (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck setError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                skipSentry: true
            });
            return permissionResponse;
        }
        return permissionResponse;
    }
    (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheHit', {
        touchpoint: touchpoint,
        product: product
    });
    return permissionResponse;
};

});

parcelRegister("bwtKg", function(module, exports) {
$parcel$export(module.exports, "useFetchIsRequestAccessCapable", () => $a227b92e5bdc2943$export$813dbb94f23efb3);
$parcel$export(module.exports, "fetchCachedIsConfluenceRACapable", () => $a227b92e5bdc2943$export$f5767c68446c14cb);
$parcel$export(module.exports, "resetRACapableCache", () => $a227b92e5bdc2943$export$5191fc85eb825b4b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $iXN50 = parcelRequire("iXN50");

var $75sVW = parcelRequire("75sVW");

var $4fhEY = parcelRequire("4fhEY");

var $aJ81Y = parcelRequire("aJ81Y");

var $2700E = parcelRequire("2700E");

var $6ZLJT = parcelRequire("6ZLJT");

var $7ctb6 = parcelRequire("7ctb6");

var $g1zht = parcelRequire("g1zht");
const $a227b92e5bdc2943$export$c75518284e8dee24 = async (product, cloudId, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    try {
        const response = await (0, $4fhEY.default)(URL, {
            credentials: 'include'
        });
        const requestCapabilities = response.results[resource];
        return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
    } catch (err) {
        if (createAnalyticsEvent) (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
            err: err,
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
        if (product === 'loom' && err instanceof (0, $75sVW.default)) return false;
        throw err;
    }
};
const $a227b92e5bdc2943$var$useFetchAccessRequestsCapabilities = (integration)=>{
    const capabilitiesService = (0, $g1zht.useService)((0, $7ctb6.fetchAccessRequestsCapabilities), {
        fireErrorAnalyticsFlags: {
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        }
    });
    return (0, $euxye.useCallback)(async (product, cloudId)=>{
        const { error: error, result: result } = await capabilitiesService({
            cloudId: cloudId,
            product: product,
            integration: integration,
            touchpoint: 'Crossjoin Nudge'
        });
        if (error) // Already reported via the fireErrorAnalyticsFlags override above. Don't rethrow —
        // callers would report it again in their own catch, double-firing error analytics.
        return false;
        return result === 'DIRECT_ACCESS' || result === 'REQUEST_ACCESS';
    }, [
        capabilitiesService,
        integration
    ]);
};
const $a227b92e5bdc2943$export$813dbb94f23efb3 = (0, $6ZLJT.functionWithCondition)(()=>(0, $2700E.expVal)('expansion_services_in_cjn_jpd_and_loom', 'isEnabled', false), (integration)=>$a227b92e5bdc2943$var$useFetchAccessRequestsCapabilities(integration), ()=>$a227b92e5bdc2943$export$c75518284e8dee24);
const $a227b92e5bdc2943$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY = 'cross.join.confluence-capabilities.cache.key';
// This is set to 1 day only as capabilties has many more states e.g PENDING_REQUEST_EXISTS, APPROVED_REQUEST_EXISTS etc
// We expect capabilities to change more often than product access
const $a227b92e5bdc2943$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS = 86400000;
const $a227b92e5bdc2943$var$crossJoinApiCache = (0, $iXN50.createLocalExpirableStorageProvider)('cross-join-nudge-conf-capabilities-api-cache');
const $a227b92e5bdc2943$export$f5767c68446c14cb = async (createAnalyticsEvent, cloudId, touchpoint)=>{
    let isRACapable = $a227b92e5bdc2943$var$crossJoinApiCache.get($a227b92e5bdc2943$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
    if (isRACapable === undefined) {
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheMiss', {
            touchpoint: touchpoint
        });
        try {
            isRACapable = await $a227b92e5bdc2943$export$c75518284e8dee24('confluence', cloudId);
        } catch (err) {
            (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
                touchpoint: touchpoint,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        $a227b92e5bdc2943$export$a901680cf5ecfb6c(createAnalyticsEvent, isRACapable, touchpoint);
        return isRACapable;
    }
    (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheHit', {
        touchpoint: touchpoint
    });
    return isRACapable;
};
const $a227b92e5bdc2943$export$a901680cf5ecfb6c = (createAnalyticsEvent, value, touchpoint)=>{
    try {
        // @browser-storage setter
        $a227b92e5bdc2943$var$crossJoinApiCache.set($a227b92e5bdc2943$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY, value, Date.now() + $a227b92e5bdc2943$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS);
    } catch (err) {
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck setError', {
            touchpoint: touchpoint,
            err: err,
            skipSentry: true
        });
    }
};
const $a227b92e5bdc2943$export$5191fc85eb825b4b = ()=>{
    $a227b92e5bdc2943$var$crossJoinApiCache.remove($a227b92e5bdc2943$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
};

});
parcelRegister("7ctb6", function(module, exports) {
$parcel$export(module.exports, "fetchAccessRequestsCapabilities", () => $640a52cbdc634b7e$export$bf3c7ce8c1124ff);
/**
 * This file defines the fetchAccessRequestsCapabilities() service.
 * https://hello.atlassian.net/wiki/spaces/ETRUST/pages/626729299/API+Guide+-+v1+access-requests+capabilities
 */ 
var $egspI = parcelRequire("egspI");

var $6fsuc = parcelRequire("6fsuc");

var $bMztW = parcelRequire("bMztW");

var $3EXjU = parcelRequire("3EXjU");

var $emhPv = parcelRequire("emhPv");

var $bztZG = parcelRequire("bztZG");
const $640a52cbdc634b7e$export$142e3ccf43b34609 = (accessMode, verificationStatus)=>{
    switch(accessMode){
        case 'ACCESS_EXISTS':
            return 'ACCESS_EXISTS';
        case 'DIRECT_ACCESS':
            return verificationStatus === 'REQUIRED' ? 'VERIFICATION_REQUIRED' : 'CAN_JOIN';
        case 'REQUEST_ACCESS':
            return verificationStatus === 'REQUIRED' ? 'VERIFICATION_REQUIRED' : 'CAN_REQUEST';
        default:
            return 'CANNOT_REQUEST_ACCESS';
    }
};
// Dependencies
const $640a52cbdc634b7e$var$dependencies = {
    fetchJSON: $emhPv.fetchJSON,
    createAnalyticsEvent: $3EXjU.createAnalyticsEvent,
    getCurrentCloudId: $3EXjU.getCurrentCloudId,
    getCurrentProduct: $3EXjU.getCurrentProduct,
    getCurrentUserId: $3EXjU.getCurrentUserId,
    getStargateURL: $3EXjU.getStargateURL
};
const $640a52cbdc634b7e$export$bf3c7ce8c1124ff = Object.assign($640a52cbdc634b7e$var$fetchAccessRequestsCapabilitiesImpl, {
    dependencies: $640a52cbdc634b7e$var$dependencies
});
async function $640a52cbdc634b7e$var$fetchAccessRequestsCapabilitiesImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    const role = input.role ?? 'product/member';
    let result;
    const resource = (0, $6fsuc.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString();
    try {
        const url = deps.getStargateURL(`/invitations/v1/access-requests/capabilities?resource=${resource}`);
        const response = await deps.fetchJSON({
            url: url
        });
        result = $640a52cbdc634b7e$var$mapAccessRequestsCapabilitiesResponse(response.data, {
            ...input,
            resource: resource,
            userId: userId,
            role: role,
            traceId: response.traceId
        });
    } catch (error) {
        result = {
            error: (0, $bMztW.toError)(error),
            ...input,
            resource: resource,
            userId: userId,
            role: role,
            result: null,
            capability: null
        };
    }
    $640a52cbdc634b7e$var$fireAccessRequestsCapabilitiesAnalytics(result, context);
    return result;
}
function $640a52cbdc634b7e$var$fireAccessRequestsCapabilitiesAnalytics(result, context) {
    const { error: error, result: accessMode, product: product, integration: integration, role: role, userId: userId, touchpoint: touchpoint, traceId: traceId, getAdditionalAttributes: getAdditionalAttributes } = result;
    const targetTenantId = result.cloudId ?? context.dependencies().getCurrentCloudId();
    const baseAttributes = {
        ...getAdditionalAttributes?.(result) ?? {},
        actorAaid: userId,
        integration: integration,
        roleName: role,
        sourceProduct: context.dependencies().getCurrentProduct(),
        sourceTenantId: context.dependencies().getCurrentCloudId(),
        targetProduct: product,
        targetTenantId: targetTenantId,
        touchpoint: touchpoint,
        ...traceId ? {
            traceId: traceId
        } : {},
        userAaid: userId
    };
    if (error) {
        $640a52cbdc634b7e$var$fireAccessRequestsCapabilitiesFailed(baseAttributes, context, error);
        return;
    }
    $640a52cbdc634b7e$var$fireAccessRequestsCapabilitiesSucceeded({
        ...baseAttributes,
        accessMode: accessMode
    }, context);
    return;
}
function $640a52cbdc634b7e$var$fireAccessRequestsCapabilitiesSucceeded(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'fetchAccessRequestsCapabilities',
            action: 'succeeded',
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $640a52cbdc634b7e$var$fireAccessRequestsCapabilitiesFailed(attributes, context, error) {
    if ((0, $egspI.fg)('expansion-services-invite-capabilities')) {
        (0, $bztZG.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'fetchAccessRequestsCapabilities'
            },
            attributes: attributes
        }, context);
        return;
    }
    const fireErrorAnalytics = context.dependencies().fireErrorAnalytics;
    if (fireErrorAnalytics) {
        fireErrorAnalytics({
            error: error,
            meta: {
                id: 'fetchAccessRequestsCapabilities'
            },
            attributes: attributes
        });
        return;
    }
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'fetchAccessRequestsCapabilities',
            action: 'failed',
            source: attributes.touchpoint,
            attributes: {
                ...attributes,
                message: error.message
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $640a52cbdc634b7e$var$mapAccessRequestsCapabilitiesResponse(response, input) {
    const result = response.resultsV2[input.resource]?.find(({ role: role })=>role === input.role)?.accessMode;
    if (!result) return {
        error: new Error(`No access request capability found for the given resource: ${input.resource} and role: ${input.role}`),
        result: null,
        capability: null,
        ...input
    };
    return {
        error: null,
        result: result,
        capability: $640a52cbdc634b7e$export$142e3ccf43b34609(result, response.verificationStatus),
        ...input
    };
}

});
parcelRegister("bMztW", function(module, exports) {
$parcel$export(module.exports, "isServiceWithDeps", () => $d1025a2ab357e58d$export$4094c5185600bd73);
$parcel$export(module.exports, "unimplementedAbstractService", () => $d1025a2ab357e58d$export$6e9f7b680f09bab1);
$parcel$export(module.exports, "toError", () => $d1025a2ab357e58d$export$cc3b967c039ed3e7);
const $d1025a2ab357e58d$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $d1025a2ab357e58d$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $d1025a2ab357e58d$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};

});

parcelRegister("3EXjU", function(module, exports) {
$parcel$export(module.exports, "getStargateURL", () => $3389a84614ebbdc7$export$c7904a8284e43beb);
$parcel$export(module.exports, "getCurrentCloudId", () => $3389a84614ebbdc7$export$ddb1688281a3443e);
$parcel$export(module.exports, "getCurrentUserId", () => $3389a84614ebbdc7$export$5ebc6cb2748e1881);
$parcel$export(module.exports, "getCurrentProduct", () => $3389a84614ebbdc7$export$d01408ed6f850a64);
$parcel$export(module.exports, "createAnalyticsEvent", () => $3389a84614ebbdc7$export$a48841c0475a8073);
$parcel$export(module.exports, "getErrorDetails", () => $3389a84614ebbdc7$export$33e83b6fee5d732d);
$parcel$export(module.exports, "isAcceptableFailure", () => $3389a84614ebbdc7$export$678d91a98f79a24d);
$parcel$export(module.exports, "isAcceptableFailureForUserInvite", () => $3389a84614ebbdc7$export$1c4c1f7e2d529330);
$parcel$export(module.exports, "shouldReportFailedInvite", () => $3389a84614ebbdc7$export$90cda429f609d666);
$parcel$export(module.exports, "EnablementTouchpoint", () => $3389a84614ebbdc7$export$ba588e0ff1c8ed38);
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $bMztW = parcelRequire("bMztW");
const $3389a84614ebbdc7$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $3389a84614ebbdc7$export$ddb1688281a3443e = (0, $bMztW.unimplementedAbstractService)('getCurrentCloudId');
const $3389a84614ebbdc7$export$7a2d3e6a9f4c0016 = (0, $bMztW.unimplementedAbstractService)('getCurrentOrgId');
const $3389a84614ebbdc7$export$5ebc6cb2748e1881 = (0, $bMztW.unimplementedAbstractService)('getCurrentUserId');
const $3389a84614ebbdc7$export$d01408ed6f850a64 = (0, $bMztW.unimplementedAbstractService)('getCurrentProduct');
const $3389a84614ebbdc7$export$a48841c0475a8073 = (0, $bMztW.unimplementedAbstractService)('createAnalyticsEvent');
class $3389a84614ebbdc7$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) super(responseJson.message);
        else super(`Received error response during action ${action}: ${response.statusText}`);
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
$3389a84614ebbdc7$export$26e841bcf1aeb894.displayName = "FetchError";
const $3389a84614ebbdc7$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: $3389a84614ebbdc7$var$getErrorStatus(err)
    });
const $3389a84614ebbdc7$var$getErrorStatus = (error)=>{
    if (!error) return undefined;
    const e = error;
    return e.statusCode ?? e.status ?? e.responseCode ?? e.response?.status;
};
const $3389a84614ebbdc7$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $3389a84614ebbdc7$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $3389a84614ebbdc7$export$1f2663aaa83f036d = 'Failed to fetch';
const $3389a84614ebbdc7$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $3389a84614ebbdc7$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $3389a84614ebbdc7$export$6827a0909c1bf12f = [
    $3389a84614ebbdc7$export$1f2663aaa83f036d,
    $3389a84614ebbdc7$export$65e55894e6e38a89,
    $3389a84614ebbdc7$export$f25400ad927aa79c
];
const $3389a84614ebbdc7$export$e1b6bb1617649e83 = (errorMessage)=>$3389a84614ebbdc7$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $3389a84614ebbdc7$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $3389a84614ebbdc7$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $3389a84614ebbdc7$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $3389a84614ebbdc7$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $3389a84614ebbdc7$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $3389a84614ebbdc7$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $3389a84614ebbdc7$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $3389a84614ebbdc7$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $3389a84614ebbdc7$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (_ignoredError) {
        return false;
    }
};
const $3389a84614ebbdc7$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $3389a84614ebbdc7$export$80a3c1a1eb6f063 || errorMessage === $3389a84614ebbdc7$export$e089e1d2018847da;
const $3389a84614ebbdc7$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $3389a84614ebbdc7$export$678d91a98f79a24d(message, status) || status === 400 && ($3389a84614ebbdc7$export$cb3290253184cb70(message, $3389a84614ebbdc7$export$c53f16dd5442ef61) || $3389a84614ebbdc7$export$cb3290253184cb70(message, $3389a84614ebbdc7$export$e27975535396141b)) || status === 412 && $3389a84614ebbdc7$export$395f41a02d6a8be0(key, message);
};
const $3389a84614ebbdc7$export$9de493bcd9b1d977 = 'bad-request';
const $3389a84614ebbdc7$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $3389a84614ebbdc7$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $3389a84614ebbdc7$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $3389a84614ebbdc7$export$e5254cb9f7678ab9) return false;
    return true;
};
const $3389a84614ebbdc7$export$ba588e0ff1c8ed38 = {
    CROSSJOIN_NUDGE: 'Crossjoin Nudge',
    DIRECT_ACCESS_JOIN: 'Direct Access - Join',
    DIRECT_ACCESS_AUTOJOIN: 'Direct Access - AutoJoin',
    DIRECT_ACCESS_INVITE_LINKS: 'Direct Access - Invite Links',
    REQUEST_ACCESS: 'Request Access Screen',
    ASSIGNS: 'Assigns',
    CORE_INVITES: 'Core Invites',
    MENTIONS: 'Mentions',
    NAV4_TEAMS_ADD: 'Nav4 Teams Add',
    PEOPLE_DIRECTORY: 'People Directory',
    PROMPT_INVITE_ON_LINK_INSERT: 'Prompt invite on link insert',
    SHARE_DIALOG: 'Share Dialog',
    SPACES: 'Spaces',
    TEAMS_MENU: 'Teams Menu',
    USER_INVITE_DRAWER: 'User Invite Drawer',
    UNKNOWN: 'unknown'
};

});

parcelRegister("emhPv", function(module, exports) {
$parcel$export(module.exports, "fetchJSON", () => $218af1f1c0fccc0a$export$81bec6e38e8b706b);

var $bMztW = parcelRequire("bMztW");
const $218af1f1c0fccc0a$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $bMztW.unimplementedAbstractService)('fetchJSON');

});

parcelRegister("bztZG", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $8c595266d2538140$export$a27c21aa3ed8f0f1);
/**
 * This file defines the fireErrorAnalytics() service.
 */ 
var $3EXjU = parcelRequire("3EXjU");
const $8c595266d2538140$var$fireErrorAnalyticsDependencies = {
    createAnalyticsEvent: $3EXjU.createAnalyticsEvent
};
const $8c595266d2538140$export$a27c21aa3ed8f0f1 = Object.assign($8c595266d2538140$var$fireErrorAnalyticsImpl, {
    dependencies: $8c595266d2538140$var$fireErrorAnalyticsDependencies
});
// Still allows an async override of fireErrorAnalytics, but the default implementation is synchronous.
function $8c595266d2538140$var$fireErrorAnalyticsImpl(input, context) {
    const touchpoint = input.attributes?.touchpoint;
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: input.meta.id,
            action: 'failed',
            ...touchpoint ? {
                source: touchpoint
            } : {},
            attributes: {
                ...input.attributes,
                ...input.error && {
                    message: input.error.message
                }
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
}

});


parcelRegister("g1zht", function(module, exports) {
$parcel$export(module.exports, "useService", () => $d70c2b844a8ebc07$export$6de4685a6c88b4e9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $kt86l = parcelRequire("kt86l");

var $3GN2r = parcelRequire("3GN2r");

var $XodBj = parcelRequire("XodBj");

var $6f7D4 = parcelRequire("6f7D4");

var $j4mL0 = parcelRequire("j4mL0");

var $b2gOf = parcelRequire("b2gOf");
const $d70c2b844a8ebc07$var$useEnvironmentDeps = ()=>{
    // Use product's hooks to build a bag of dependencies
    // that the product environment will provide to the services.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6f7D4.useAnalyticsEvents)();
    const cloudId = (0, $kt86l.useCloudId)();
    const product = (0, $b2gOf.useJiraCurrentProduct)();
    const atlassianAccountId = (0, $3GN2r.useAccountId)();
    return (0, $euxye.useMemo)(()=>({
            createAnalyticsEvent: createAnalyticsEvent,
            fetchJSON: (0, $j4mL0.jiraFetchJson),
            getCurrentCloudId: ()=>cloudId,
            getCurrentProduct: ()=>product,
            getCurrentUserId: ()=>atlassianAccountId,
            fireErrorAnalytics: (0, $hFtK7.fireErrorAnalytics)
        }), [
        createAnalyticsEvent,
        cloudId,
        product,
        atlassianAccountId
    ]);
};
const $d70c2b844a8ebc07$var$useStableFireErrorAnalyticsFlags = (flags)=>{
    const [stableFlags, setStableFlags] = (0, $euxye.useState)(flags);
    if (flags !== stableFlags && (flags?.sendToPrivacyUnsafeSplunk !== stableFlags?.sendToPrivacyUnsafeSplunk || flags?.skipSentry !== stableFlags?.skipSentry)) setStableFlags(flags);
    return stableFlags;
};
const $d70c2b844a8ebc07$export$6de4685a6c88b4e9 = (service, providedDeps)=>{
    const environmentDeps = $d70c2b844a8ebc07$var$useEnvironmentDeps();
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const { fireErrorAnalyticsFlags: fireErrorAnalyticsFlags, ...restProvidedDeps } = providedDeps ?? {};
    const stableFireErrorAnalyticsFlags = $d70c2b844a8ebc07$var$useStableFireErrorAnalyticsFlags(fireErrorAnalyticsFlags);
    const fireErrorAnalyticsOverride = (0, $euxye.useMemo)(()=>stableFireErrorAnalyticsFlags && ((payload)=>(0, $hFtK7.fireErrorAnalytics)({
                ...payload,
                ...stableFireErrorAnalyticsFlags
            })), [
        stableFireErrorAnalyticsFlags
    ]);
    const deps = {
        ...environmentDeps,
        ...restProvidedDeps,
        ...fireErrorAnalyticsOverride && {
            fireErrorAnalytics: fireErrorAnalyticsOverride
        }
    };
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $XodBj.useService)(service, deps);
};

});
parcelRegister("XodBj", function(module, exports) {
$parcel$export(module.exports, "useService", () => $2fc90b10bf0de886$export$6de4685a6c88b4e9);

var $euxye = parcelRequire("euxye");

var $PJ2FB = parcelRequire("PJ2FB");
const $2fc90b10bf0de886$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $euxye.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$2fc90b10bf0de886$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $PJ2FB.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $2fc90b10bf0de886$var$DIFFERENT = false;
const $2fc90b10bf0de886$var$EQUAL = true;
const $2fc90b10bf0de886$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $2fc90b10bf0de886$var$EQUAL;
    if (!prevObject || !nextObject) return $2fc90b10bf0de886$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $2fc90b10bf0de886$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $2fc90b10bf0de886$var$DIFFERENT;
        }
        return $2fc90b10bf0de886$var$EQUAL;
    }
};

});
parcelRegister("PJ2FB", function(module, exports) {
$parcel$export(module.exports, "resolveService", () => $3e66976519034aa9$export$388f24d19a29b0a2);

var $bMztW = parcelRequire("bMztW");
function $3e66976519034aa9$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $bMztW.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $3e66976519034aa9$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $3e66976519034aa9$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $3e66976519034aa9$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }

});


parcelRegister("6f7D4", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $c7dbd1afe631e9b8$export$5bf35293e545f20c);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $c7dbd1afe631e9b8$var$AnalyticsWebClientTypeToJiraEventType = {
    sendTrackEvent: 'TRACK',
    sendUIEvent: 'UI',
    sendScreenEvent: 'SCREEN',
    sendOperationalEvent: 'OPERATIONAL'
};
const $c7dbd1afe631e9b8$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEventNotFireable } = (0, $inMxE.useAnalyticsEvents)();
    return (0, $euxye.useMemo)(()=>{
        const createAnalyticsEvent = (payload)=>{
            const event = createAnalyticsEventNotFireable(payload);
            // event.fire() coming from `createAnalyticsEvent` does not actually send the event in Jira,
            // so we need to patch it here, ensuring it goes throught the analytics bridge correctly
            event.fire = ()=>{
                const awcType = payload.type;
                const jiraBridgeEventType = $c7dbd1afe631e9b8$var$AnalyticsWebClientTypeToJiraEventType[awcType];
                if (!jiraBridgeEventType) return;
                (0, $aJ81Y.fireAnalytics)(event, jiraBridgeEventType, payload.data);
            };
            return event;
        };
        return {
            createAnalyticsEvent: createAnalyticsEvent
        };
    }, [
        createAnalyticsEventNotFireable
    ]);
};

});

parcelRegister("j4mL0", function(module, exports) {
$parcel$export(module.exports, "jiraFetchJson", () => $fd53260683daca36$export$a1dfe802bc656913);
/* eslint-disable jira/filename-case */ 
var $eRSGV = parcelRequire("eRSGV");

var $3b6iI = parcelRequire("3b6iI");

var $75sVW = parcelRequire("75sVW");

var $jVTHL = parcelRequire("jVTHL");

var $5cVSt = parcelRequire("5cVSt");

var $ff8AH = parcelRequire("ff8AH");
const $fd53260683daca36$export$a1dfe802bc656913 = async (input)=>{
    const { url: url, ...options } = input;
    // Apply all jira-fetch semantics: reroutable URL, observability headers, default options
    const reroutableUrl = (0, $jVTHL.getReroutableURL)(url);
    const mergedOptions = (0, $eRSGV.merge)((0, $ff8AH.defaultOptions), options);
    const finalOptions = (0, $5cVSt.applyObservabilityHeaders)(reroutableUrl, mergedOptions);
    const response = await fetch(reroutableUrl, finalOptions);
    if (!response.ok) {
        const traceId = (0, $3b6iI.getTraceId)(response);
        if (traceId !== undefined) throw new (0, $75sVW.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
        else throw new (0, $75sVW.default)(response.status, undefined, undefined, response);
    }
    // Parse JSON and extract traceId from response headers
    const data = await response.json();
    const traceId = (0, $3b6iI.getTraceId)(response);
    return traceId === undefined ? {
        data: data
    } : {
        data: data,
        traceId: traceId
    };
};

});
parcelRegister("3b6iI", function(module, exports) {
$parcel$export(module.exports, "getTraceId", () => $2862fb551f10e8d2$export$e88cb5bfb57ce9c4);
/**
 * Shared utility to extract trace ID from HTTP response headers.
 * Checks headers in order: 'atl-traceid', 'x-trace-id'
 * Returns undefined for missing or empty trace IDs.
 */ const $2862fb551f10e8d2$export$e88cb5bfb57ce9c4 = (response)=>{
    const TRACE_ID_HEADERS = [
        'atl-traceid',
        'x-trace-id'
    ];
    const traceIdHeader = TRACE_ID_HEADERS.find((header)=>response.headers.has(header));
    if (traceIdHeader === undefined) return undefined;
    const value = response.headers.get(traceIdHeader);
    // Normalize empty strings to undefined
    return value && value.length > 0 ? value : undefined;
};

});


parcelRegister("b2gOf", function(module, exports) {
$parcel$export(module.exports, "useJiraCurrentProduct", () => $b0809863bf59ddd4$export$47a383c930365f5d);
// eslint-disable-next-line jira/filename-case

var $gWmMH = parcelRequire("gWmMH");
const $b0809863bf59ddd4$export$47a383c930365f5d = ()=>{
    const productName = (0, $gWmMH.useProductName)();
    switch(productName){
        case 'core':
            return 'jira-core';
        case 'jira':
            return 'jira-software';
        case 'serviceDesk':
            return 'jira-servicedesk';
        case 'product-discovery':
            return 'jira-product-discovery';
        default:
            return 'jira-core';
    }
};

});



parcelRegister("hgxiY", function(module, exports) {
$parcel$export(module.exports, "isSite7DaysOld", () => $934e8d48ab9e809e$export$23b7746c9e6ae406);
$parcel$export(module.exports, "isLoomSite7DaysOld", () => $934e8d48ab9e809e$export$e7b898c6b427cf14);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $g3pW6 = parcelRequire("g3pW6");
const $934e8d48ab9e809e$var$ACTIVATION_TRAITS = {
    confluence: 'confluence.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate',
    loom: 'loom.activationDate'
};
const $934e8d48ab9e809e$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const siteTraits = await (0, $g3pW6.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    return $934e8d48ab9e809e$var$findAndCheckActivationDate(product, siteTraits);
};
const $934e8d48ab9e809e$var$findAndCheckActivationDate = (product, traits)=>{
    const traitName = $934e8d48ab9e809e$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const activationTrait = traits.find((trait)=>trait.name === traitName);
    if (activationTrait?.value) {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const oneWeekLaterActivation = new Date(activationTrait?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};
const $934e8d48ab9e809e$export$e7b898c6b427cf14 = async (cloudId)=>{
    const siteTraits = await (0, $g3pW6.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    return $934e8d48ab9e809e$var$findAndCheckLoomActivationDate(siteTraits);
};
// The loom.activationDate trait is registered on 23rd Aug 2025, any values that are not found within this trait means the site is older than 7 days
// The trait is registered when a new loom site is provisioned
// See https://data-portal.internal.atlassian.com/targeting/traits/63974e01-9d13-4587-8b23-235087258799
const $934e8d48ab9e809e$var$findAndCheckLoomActivationDate = (traits)=>{
    const traitName = $934e8d48ab9e809e$var$ACTIVATION_TRAITS.loom;
    if (!traitName) throw Error('Unknown activation trait key for loom site');
    const activationTrait = traits.find((trait)=>trait.name === traitName);
    if (activationTrait?.value) {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const oneWeekLaterActivation = new Date(activationTrait?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return true;
};

});

parcelRegister("fRc93", function(module, exports) {
$parcel$export(module.exports, "isSiteOptedOut", () => $9e3a0fbc5d31f1fc$export$3475487c10c1ac17);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $g3pW6 = parcelRequire("g3pW6");
const $9e3a0fbc5d31f1fc$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await (0, $g3pW6.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};

});

parcelRegister("88mpo", function(module, exports) {
$parcel$export(module.exports, "isNewActiveUser", () => $cdbc5841f571277c$export$b4712e67f435e1dc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $kTLO3 = parcelRequire("kTLO3");
const $cdbc5841f571277c$export$b4712e67f435e1dc = async (cloudId, userId, newActiveDays = 14)=>{
    const userTraits = await (0, $kTLO3.memoizedFetchSiteUserPersonalization)({
        cloudId: cloudId,
        userId: userId
    });
    return $cdbc5841f571277c$var$findAndCheckActiveDate(userTraits, newActiveDays);
};
const $cdbc5841f571277c$var$findAndCheckActiveDate = (traits, newActiveDays)=>{
    const traitName = 'jira_first_active';
    const firstActiveTrait = traits.find((trait)=>trait.name === traitName);
    if (firstActiveTrait?.value) {
        const oneWeekActive = new Date(firstActiveTrait?.value.toString());
        oneWeekActive.setDate(oneWeekActive.getDate() + newActiveDays);
        const today = new Date();
        return today <= oneWeekActive;
    }
    return true;
};

});

parcelRegister("3nBZF", function(module, exports) {
$parcel$export(module.exports, "useNudgeStateV2a", () => $442a365c4210884b$export$1721ab60f4854021);
$parcel$export(module.exports, "useNudgeStateYourWork", () => $442a365c4210884b$export$766742495b6411cb);
$parcel$export(module.exports, "useNudgeStateJiraToJpd", () => $442a365c4210884b$export$13bdd3f195e673d5);
$parcel$export(module.exports, "useNudgeStateJiraToLoom", () => $442a365c4210884b$export$8536e84a1114567e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $3GN2r = parcelRequire("3GN2r");

var $lz704 = parcelRequire("lz704");
const $442a365c4210884b$var$getNudgeState = async (key, accountId)=>{
    if (!accountId) return 'NONE';
    const nudgeState = await (0, $lz704.getUserProperty)({
        accountId: accountId,
        propertyKey: key,
        defaultValue: 'NONE'
    });
    return nudgeState.value;
};
const $442a365c4210884b$var$setNudgeDismissState = async (key, accountId)=>{
    if (!accountId) return;
    await (0, $lz704.setUserProperty)({
        accountId: accountId,
        propertyKey: key,
        propertyValue: 'DISMISSED'
    });
};
const $442a365c4210884b$var$useNudgeState = (key)=>{
    const accountId = (0, $3GN2r.useAccountId)();
    return (0, $euxye.useMemo)(()=>({
            getNudgeState: ()=>$442a365c4210884b$var$getNudgeState(key, accountId),
            setNudgeDismissed: ()=>$442a365c4210884b$var$setNudgeDismissState(key, accountId)
        }), [
        accountId,
        key
    ]);
};
const $442a365c4210884b$export$1721ab60f4854021 = ()=>$442a365c4210884b$var$useNudgeState('CROSS_JOIN_NUDGES_CONFLUENCE_V2A');
const $442a365c4210884b$export$766742495b6411cb = ()=>$442a365c4210884b$var$useNudgeState('CROSS_JOIN_NUDGES_YOUR_WORK');
const $442a365c4210884b$export$13bdd3f195e673d5 = ()=>$442a365c4210884b$var$useNudgeState('CROSS_JOIN_NUDGES_JIRA_TO_JPD');
const $442a365c4210884b$export$8536e84a1114567e = ()=>$442a365c4210884b$var$useNudgeState('CROSS_JOIN_NUDGES_JIRA_TO_LOOM');

});

/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $0ef25b7cd0c5e2a4$export$a4b45159adbcc3d7 = 3;

parcelRegister("7k33z", function(module, exports) {
$parcel$export(module.exports, "isExcludedForNav4Placement", () => $a2e5cb1dfc28e72e$export$2128eba48e7e6e2b);

var $2700E = parcelRequire("2700E");

var $d1jAR = parcelRequire("d1jAR");

var $y6gLX = parcelRequire("y6gLX");
const $a2e5cb1dfc28e72e$var$CJN_NAV4_EXPERIMENT_START_DATE = new Date('2026-06-30');
const $a2e5cb1dfc28e72e$export$2128eba48e7e6e2b = async (cloudId, userId, createAnalyticsEvent, targetProduct)=>{
    if (!await (0, $y6gLX.jiraUserIsActiveAfterDate)(cloudId, userId, $a2e5cb1dfc28e72e$var$CJN_NAV4_EXPERIMENT_START_DATE)) return false;
    if ([
        'control',
        'variation'
    ].includes((0, $2700E.expVal)('puma_expt_cjn-nav4-jira', 'cohort', 'not-enrolled'))) (0, $d1jAR.fireCjnNav4PlacementExposed)(createAnalyticsEvent, 'crossJoinNudgesNav4Placement', 'puma_expt_cjn-nav4-jira', (0, $2700E.expVal)('puma_expt_cjn-nav4-jira', 'cohort', 'not-enrolled'), targetProduct);
    return (0, $2700E.expValEquals)('puma_expt_cjn-nav4-jira', 'cohort', 'variation') ?? false;
};

});
parcelRegister("y6gLX", function(module, exports) {
$parcel$export(module.exports, "jiraUserIsActiveAfterDate", () => $91df018e81173bb1$export$4fa69bb4f6191224);

var $kTLO3 = parcelRequire("kTLO3");
const $91df018e81173bb1$export$4fa69bb4f6191224 = async (cloudId, userId, fromDate)=>{
    const userTraits = await (0, $kTLO3.memoizedFetchSiteUserPersonalization)({
        cloudId: cloudId,
        userId: userId
    });
    const firstActiveTrait = userTraits.find((trait)=>trait.name === 'jira_first_active');
    if (!firstActiveTrait?.value) // Trait absent — cannot verify post-experiment eligibility, exclude.
    return false;
    return new Date(firstActiveTrait.value.toString()) >= fromDate;
};

});



parcelRegister("hWDrM", function(module, exports) {
$parcel$export(module.exports, "useConfluenceCrossJoinNudgeEligibility", () => $27750d2248e17c28$export$a3f7303bbd08ef0d);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $5rZe5 = parcelRequire("5rZe5");

var $f2wVS = parcelRequire("f2wVS");

var $d1jAR = parcelRequire("d1jAR");

var $eeOhg = parcelRequire("eeOhg");

var $3nBZF = parcelRequire("3nBZF");

var $cGdse = parcelRequire("cGdse");

var $bwtKg = parcelRequire("bwtKg");

var $hgxiY = parcelRequire("hgxiY");

var $fRc93 = parcelRequire("fRc93");

var $88mpo = parcelRequire("88mpo");


var $iB4gl = parcelRequire("iB4gl");

var $51i0j = parcelRequire("51i0j");

var $7k33z = parcelRequire("7k33z");
const $27750d2248e17c28$export$a3f7303bbd08ef0d = ({ getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { getNudgeState: getNudgeStateV2a } = (0, $3nBZF.useNudgeStateV2a)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const userId = (0, $3GN2r.useAccountId)() || '';
    const licensedProducts = (0, $5rZe5.useLicensedProducts)();
    const isYourWorkRoute = (0, $f2wVS.useIsActiveRoute)('your-work');
    const withOverrides = (0, $iB4gl.useOverrides)('cjn_conf_overrides');
    const fetchIsRequestAccessCapable = (0, $bwtKg.useFetchIsRequestAccessCapable)('crossJoinNudgesConfluence');
    return (0, $euxye.useCallback)(async ()=>{
        try {
            const cachedIsSiteOptedOut = (0, $eeOhg.withEligibilityCache)('site_is_opted_out', (0, $fRc93.isSiteOptedOut), 0.2);
            const cachedHasProductAccess = (0, $eeOhg.withEligibilityCache)('user_already_has_confluence', (0, $cGdse.hasProductAccess), 0.2);
            const cachedUserCanRequestAccess = (0, $eeOhg.withEligibilityCache)('user_cannot_request_confluence_access', fetchIsRequestAccessCapable, 0.2);
            if (withOverrides('is_your_work_route', isYourWorkRoute)) return {
                isEligible: false,
                ineligibleReason: 'is_your_work_route'
            };
            if (withOverrides('site_has_no_licensed_confluence', !licensedProducts.confluence)) return {
                isEligible: false,
                ineligibleReason: 'site_has_no_licensed_confluence'
            };
            if (withOverrides('feature_visited_too_recently', (0, $eeOhg.getOrUpdateFeatureVisited)('crossJoinNudgesConfluence', 7))) return {
                isEligible: false,
                ineligibleReason: 'feature_visited_too_recently'
            };
            // I moved this to the top as most of the users have already seen all their nudges
            // and thus preventing calling other APIs unnecessarily
            const featureVisitedCount = await (0, $eeOhg.getFeatureVisitedCount)(userId);
            if (withOverrides('nudge_seen_too_many_times', featureVisitedCount >= (0, $0ef25b7cd0c5e2a4$export$a4b45159adbcc3d7))) return {
                isEligible: false,
                ineligibleReason: 'nudge_seen_too_many_times'
            };
            if (withOverrides('site_is_opted_out', await cachedIsSiteOptedOut(cloudId))) {
                (0, $d1jAR.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return {
                    isEligible: false,
                    ineligibleReason: 'site_is_opted_out'
                };
            }
            const userHasProductAccess = await cachedHasProductAccess('confluence', cloudId);
            if (withOverrides('user_already_has_confluence', userHasProductAccess)) return {
                isEligible: false,
                ineligibleReason: 'user_already_has_confluence'
            };
            const userCanRequestAccessToConfluence = await cachedUserCanRequestAccess('confluence', cloudId);
            if (withOverrides('user_cannot_request_confluence_access', !userCanRequestAccessToConfluence)) return {
                isEligible: false,
                ineligibleReason: 'user_cannot_request_confluence_access'
            };
            if (withOverrides('confluence_is_too_new', !await (0, $hgxiY.isSite7DaysOld)('confluence', cloudId))) return {
                isEligible: false,
                ineligibleReason: 'confluence_is_too_new'
            };
            if (withOverrides('user_is_too_new', await (0, $88mpo.isNewActiveUser)(cloudId, userId))) return {
                isEligible: false,
                ineligibleReason: 'user_is_too_new'
            };
            // Since V2A Rollout to 100%, all nudge will use V2A Logic
            if (withOverrides('nudge_already_dismissed', await getNudgeStateV2a() === 'DISMISSED')) return {
                isEligible: false,
                ineligibleReason: 'nudge_already_dismissed'
            };
            await (0, $51i0j.isExcludedForNav4PlacementAA)(cloudId, userId, createAnalyticsEvent);
            if (await (0, $7k33z.isExcludedForNav4Placement)(cloudId, userId, createAnalyticsEvent, 'confluence')) return {
                isEligible: false,
                ineligibleReason: 'excluded_for_nav4_placement_experiment'
            };
            const recommendations = await getMSRNudgeRecommendations();
            if (!recommendations.includes('cjn-jira-conf-v2')) {
                (0, $d1jAR.fireMsrNotRecommendedAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence', 'cjn-jira-conf-v2');
                return {
                    isEligible: false,
                    ineligibleReason: 'msr_nudge_not_recommended'
                };
            }
            return {
                isEligible: true,
                data: {
                    featureVisitedCount: featureVisitedCount
                }
            };
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $d1jAR.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                ineligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        fetchIsRequestAccessCapable,
        getNudgeStateV2a,
        isYourWorkRoute,
        licensedProducts.confluence,
        userId,
        withOverrides,
        getMSRNudgeRecommendations
    ]);
};

});
parcelRegister("iB4gl", function(module, exports) {
$parcel$export(module.exports, "useOverrides", () => $e10bd6704d5bdc56$export$ab0d8295b09da679);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2ffUK = parcelRequire("2ffUK");
const $e10bd6704d5bdc56$export$ab0d8295b09da679 = (queryKey)=>{
    const [value] = (0, $2ffUK.useQueryParam)(queryKey);
    let overrides = {};
    if (value) overrides = JSON.parse(value);
    return $e10bd6704d5bdc56$export$583909077c804932(overrides);
};
function $e10bd6704d5bdc56$export$583909077c804932(overrides) {
    return (key, val)=>{
        if (Object.prototype.hasOwnProperty.call(overrides, key)) {
            const overrideVal = overrides[key];
            if (typeof overrideVal === 'boolean') return overrideVal;
        }
        return val;
    };
}

});

parcelRegister("51i0j", function(module, exports) {
$parcel$export(module.exports, "isExcludedForNav4PlacementAA", () => $f55b52829f376258$export$f152162765308e8c);

var $2700E = parcelRequire("2700E");

var $d1jAR = parcelRequire("d1jAR");

var $y6gLX = parcelRequire("y6gLX");
const $f55b52829f376258$var$CJN_NAV4_AA_EXPERIMENT_START_DATE = new Date('2026-05-01');
const $f55b52829f376258$export$f152162765308e8c = async (cloudId, userId, createAnalyticsEvent)=>{
    if (!await (0, $y6gLX.jiraUserIsActiveAfterDate)(cloudId, userId, $f55b52829f376258$var$CJN_NAV4_AA_EXPERIMENT_START_DATE)) return false;
    if ([
        'control',
        'variation'
    ].includes((0, $2700E.expVal)('puma_expt_cjn-nav4-jira-aa', 'cohort', 'not-enrolled'))) (0, $d1jAR.fireCjnNav4PlacementExposed)(createAnalyticsEvent, 'crossJoinNudgesNav4PlacementAa', 'puma_expt_cjn-nav4-jira-aa', (0, $2700E.expVal)('puma_expt_cjn-nav4-jira-aa', 'cohort', 'not-enrolled'), 'confluence');
    // Never excluded for AA test
    return false;
};

});


parcelRegister("5XNkF", function(module, exports) {
$parcel$export(module.exports, "useJpdCrossJoinNudge", () => $8e7296f17eed1cd3$export$b59148260d6e0135);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $55BnK = parcelRequire("55BnK");

var $5GEx8 = parcelRequire("5GEx8");

var $2700E = parcelRequire("2700E");

var $ffDvJ = parcelRequire("ffDvJ");

var $d1jAR = parcelRequire("d1jAR");

var $eeOhg = parcelRequire("eeOhg");

var $d0Zrc = parcelRequire("d0Zrc");

var $3nBZF = parcelRequire("3nBZF");

var $9QKV7 = parcelRequire("9QKV7");

var $4DmVX = parcelRequire("4DmVX");

var $4z0sI = parcelRequire("4z0sI");
const $8e7296f17eed1cd3$var$MAX_NUMBER_OF_JPD_COLLABORATORS = 10;
const $8e7296f17eed1cd3$export$b59148260d6e0135 = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const userId = (0, $3GN2r.useAccountId)() || '';
    const currentProduct = (0, $5GEx8.useCurrentProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $d0Zrc.useFilteredUsersFromCollaborationGraph)(cloudId, 'jira-product-discovery', $8e7296f17eed1cd3$var$MAX_NUMBER_OF_JPD_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $4DmVX.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $4z0sI.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $9QKV7.useRequestAccessErrorFlag)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const { snoozeFor30Days: snoozeFor30Days, increaseVisitedCount: increaseVisitedCount } = (0, $eeOhg.useSnooze)('crossJoinNudgesJiraToJpd');
    const { setNudgeDismissed: setNudgeDismissed } = (0, $3nBZF.useNudgeStateJiraToJpd)();
    const requestAccessService = (0, $ffDvJ.useRequestAccessService)();
    return (0, $euxye.useCallback)(async ({ featureVisitedCount: featureVisitedCount })=>{
        try {
            const startTimestamp = Date.now();
            const collaboratorsOnJpd = await getFilteredCollaborators();
            const onSubmit = async ()=>{
                try {
                    let accessStatus;
                    if (requestAccessService) {
                        const serviceResult = await requestAccessService({
                            product: 'jira-product-discovery',
                            integration: 'crossJoinNudgesJiraToJpd',
                            touchpoint: 'Crossjoin Nudge'
                        });
                        if (serviceResult.error) {
                            (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', serviceResult.error, {
                                cloudId: cloudId
                            });
                            throw serviceResult.error;
                        }
                        accessStatus = serviceResult.result;
                    } else accessStatus = await (0, $ffDvJ.requestAccess)('jira-product-discovery', currentProduct, cloudId, userId, 'crossJoinNudgesJiraToJpd', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/jira/projects');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('jira-product-discovery');
                } catch  {
                    showErrorFlag('jira-product-discovery');
                }
            };
            const runPostDisplaySideEffects = ()=>Promise.all([
                    increaseVisitedCount(featureVisitedCount + 1),
                    (0, $eeOhg.cjnEligibilityCacheHandler).set('has_seen_jpd', {
                        value: true
                    }),
                    (0, $eeOhg.setHasSeenNudgeInLast7Days)()
                ]);
            const promptFlagArgs = {
                users: collaboratorsOnJpd,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissed,
                snoozeFor30Days: snoozeFor30Days,
                integration: 'crossJoinNudgesJiraToJpd',
                featureVisitedCount: featureVisitedCount,
                messageParser: (0, $4DmVX.getJPDCJNMessageStrings),
                eventAttributes: (0, $4DmVX.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnJpd,
                    featureVisitedCount: featureVisitedCount,
                    startTimestamp: startTimestamp
                })
            };
            if ((0, $2700E.expVal)('twcg-1920-fix-orcherstrator-block-handling', 'isEnabled', false)) {
                const onDisplayed = ()=>{
                    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                    runPostDisplaySideEffects().catch((error)=>{
                        (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                            cloudId: cloudId
                        });
                    });
                };
                showRequestAccessPromptFlag({
                    ...promptFlagArgs,
                    onDisplayed: onDisplayed
                });
            } else {
                showRequestAccessPromptFlag(promptFlagArgs);
                await runPostDisplaySideEffects();
            }
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        currentProduct,
        createAnalyticsEvent,
        getFilteredCollaborators,
        increaseVisitedCount,
        push,
        requestAccessService,
        setNudgeDismissed,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        snoozeFor30Days,
        userId
    ]);
};

});
parcelRegister("5GEx8", function(module, exports) {
$parcel$export(module.exports, "isConfluenceLink", () => $c72def4e6ae56f73$export$313baaa1c3261c49);
$parcel$export(module.exports, "getAllLinks", () => $c72def4e6ae56f73$export$776644da31ab517e);
$parcel$export(module.exports, "getAllProductLinks", () => $c72def4e6ae56f73$export$577f918d7821fd77);
$parcel$export(module.exports, "generateId", () => $c72def4e6ae56f73$export$567fc7097e064344);
$parcel$export(module.exports, "clampString", () => $c72def4e6ae56f73$export$96ce25bdd1856c70);
$parcel$export(module.exports, "getProductDisplayName", () => $c72def4e6ae56f73$export$44fea6589b7ddc92);
$parcel$export(module.exports, "useCurrentProduct", () => $c72def4e6ae56f73$export$495654df2a5da4a0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $e0DQG = parcelRequire("e0DQG");

var $6fsuc = parcelRequire("6fsuc");

var $2b39L = parcelRequire("2b39L");

var $gXtG2 = parcelRequire("gXtG2");
const $c72def4e6ae56f73$export$69caceff42c0da80 = {
    [(0, $eb8cfa569eede1a9$export$c811f21c9ad05dc2)]: 'Confluence'
};
const $c72def4e6ae56f73$export$fadb677f87088e11 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d;
        case 'service_desk':
            return 0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61;
        case 'business':
            return 0, $eb8cfa569eede1a9$export$db515c8cec1e6f79;
        case 'product_discovery':
            return 0, $eb8cfa569eede1a9$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $c72def4e6ae56f73$var$getProductFromSubproduct = (subproduct)=>{
    switch(subproduct){
        case 'software':
        case 'jira_software':
            return 0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d;
        case 'servicedesk':
        case 'jira_service_management':
            return 0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61;
        case 'core':
        case 'jira_work_management':
            return 0, $eb8cfa569eede1a9$export$db515c8cec1e6f79;
        case 'polaris':
        case 'jira_product_discovery':
            return 0, $eb8cfa569eede1a9$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $c72def4e6ae56f73$export$313baaa1c3261c49 = (url, cloudName)=>{
    if (!url || !cloudName) return false;
    const regex = new RegExp(`^https?://${cloudName}.atlassian.net/wiki(?!/external)`);
    return regex.test(url);
};
const $c72def4e6ae56f73$export$776644da31ab517e = (doc)=>{
    const links = new Set();
    const handleLink = (link)=>{
        link && links.add(link);
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>handleLink(node.attrs?.url);
    (0, $e0DQG.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
const $c72def4e6ae56f73$var$getSmartLinkData = (cloudId, details)=>{
    if (!details) return;
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const { name: name } = details.data;
    const { tenantId: tenantId, subproduct: subproduct } = details.meta;
    let { product: product } = details.meta;
    if (tenantId !== cloudId) return;
    product = product === 'jira' ? $c72def4e6ae56f73$var$getProductFromSubproduct(subproduct) : product;
    if (!Object.keys($c72def4e6ae56f73$export$69caceff42c0da80).includes(product)) return;
    return {
        name: name,
        tenantId: tenantId,
        product: product
    };
};
const $c72def4e6ae56f73$export$577f918d7821fd77 = (doc, store, cloudId, cloudName)=>{
    const links = {};
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>{
        // Check URL is on the ADF node
        const { url: url } = node?.attrs;
        if (!url) return;
        // Check URL is in the Smart Links Store
        const details = store.getState()[url]?.details;
        const data = $c72def4e6ae56f73$var$getSmartLinkData(cloudId, details);
        if (data) links[url] = data;
    };
    const handleRawConfluenceLink = (url)=>{
        if ($c72def4e6ae56f73$export$313baaa1c3261c49(url, cloudName)) links[url] = {
            tenantId: cloudId,
            product: (0, $eb8cfa569eede1a9$export$c811f21c9ad05dc2)
        };
    };
    (0, $e0DQG.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleRawConfluenceLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
let $c72def4e6ae56f73$var$id = 0;
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $c72def4e6ae56f73$var$id = 0;
});
const $c72def4e6ae56f73$export$567fc7097e064344 = ()=>{
    $c72def4e6ae56f73$var$id += 1;
    return String($c72def4e6ae56f73$var$id);
};
const $c72def4e6ae56f73$export$96ce25bdd1856c70 = (string, maxLength)=>{
    if (string.length > maxLength) return string.slice(0, maxLength).concat('...');
    return string;
};
const $c72def4e6ae56f73$export$44fea6589b7ddc92 = (product)=>$c72def4e6ae56f73$export$69caceff42c0da80[product];
const $c72def4e6ae56f73$export$792aeacb7990bc6 = (tenantId, product)=>(0, $6fsuc.AnyAri).create({
        resourceOwner: product,
        resourceType: 'site',
        resourceId: tenantId
    }).toString();
const $c72def4e6ae56f73$export$495654df2a5da4a0 = ()=>{
    const { data: data } = (0, $2b39L.useProjectContext)();
    return $c72def4e6ae56f73$export$fadb677f87088e11(data?.projectType) || (0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d);
};

});
parcelRegister("e0DQG", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $a834bed4dfbe6098$export$df3f009e3d155b20);
function $a834bed4dfbe6098$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $a834bed4dfbe6098$export$df3f009e3d155b20(adf, visitors) {
    if (!$a834bed4dfbe6098$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $a834bed4dfbe6098$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $a834bed4dfbe6098$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $a834bed4dfbe6098$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("ffDvJ", function(module, exports) {
$parcel$export(module.exports, "requestAccess", () => $a84c96c79b7600bf$export$cd9e5995821603e1);
$parcel$export(module.exports, "useRequestAccessService", () => $a84c96c79b7600bf$export$1c1d3bfbd79d853f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");

var $aJ81Y = parcelRequire("aJ81Y");

var $2700E = parcelRequire("2700E");

var $6ZLJT = parcelRequire("6ZLJT");

var $kSTWB = parcelRequire("kSTWB");

var $g1zht = parcelRequire("g1zht");

var $d1jAR = parcelRequire("d1jAR");
const $a84c96c79b7600bf$var$URL = '/gateway/api/invitations/v1/access-requests/request';
const $a84c96c79b7600bf$export$cd9e5995821603e1 = async (product, sourceProduct, cloudId, userId, integration, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    try {
        const response = await (0, $4fhEY.default)($a84c96c79b7600bf$var$URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                metadata: {
                    touchpoint: 'Crossjoin Nudge',
                    sourceProduct: sourceProduct
                }
            })
        });
        const { results: results } = response;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration
        };
        (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
        return result;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $d1jAR.fireErrorAnalytics)(integration, error);
        throw new Error(`${integration} request access error`);
    }
};
const $a84c96c79b7600bf$export$1c1d3bfbd79d853f = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $2700E.expVal)('expansion_services_in_cjn_jpd_and_loom', 'isEnabled', false), ()=>(0, $g1zht.useService)((0, $kSTWB.requestAccess)), ()=>null);

});
parcelRegister("kSTWB", function(module, exports) {
$parcel$export(module.exports, "requestAccess", () => $d9feab882fdf4853$export$cd9e5995821603e1);
/**
 * This file defines the requestAccess() service.
 */ 
var $egspI = parcelRequire("egspI");

var $6fsuc = parcelRequire("6fsuc");

var $bMztW = parcelRequire("bMztW");

var $3EXjU = parcelRequire("3EXjU");

var $emhPv = parcelRequire("emhPv");

var $bztZG = parcelRequire("bztZG");
// Dependencies - generally common to all RA's/joins:
const $d9feab882fdf4853$var$dependencies = {
    fetchJSON: $emhPv.fetchJSON,
    createAnalyticsEvent: $3EXjU.createAnalyticsEvent,
    fireErrorAnalytics: $bztZG.fireErrorAnalytics,
    getStargateURL: $3EXjU.getStargateURL,
    getCurrentUserId: $3EXjU.getCurrentUserId,
    getCurrentCloudId: $3EXjU.getCurrentCloudId,
    getCurrentProduct: $3EXjU.getCurrentProduct
};
const $d9feab882fdf4853$export$cd9e5995821603e1 = Object.assign($d9feab882fdf4853$var$requestAccessImpl, {
    dependencies: $d9feab882fdf4853$var$dependencies
});
async function $d9feab882fdf4853$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = (0, $6fsuc.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString();
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const fetchResponse = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...input.note ? {
                    note: input.note
                } : {},
                metadata: {
                    sourceProduct: deps.getCurrentProduct(),
                    ...input.touchpoint ? {
                        touchpoint: input.touchpoint
                    } : {}
                }
            })
        });
        const flagEnabled = (0, $egspI.fg)('expansion-services-trace-id');
        const gatedTraceId = fetchResponse.traceId && flagEnabled ? fetchResponse.traceId : undefined;
        result = $d9feab882fdf4853$var$mapRequestAccessResponse(fetchResponse.data, {
            resource: resource,
            userId: userId,
            ...input,
            traceId: gatedTraceId
        });
    } catch (error) {
        result = {
            error: (0, $bMztW.toError)(error),
            ...input,
            result: null,
            action: null,
            resource: resource,
            userId: userId
        };
    }
    $d9feab882fdf4853$var$fireRequestAccessAnalytics(result, context, input.getAdditionalAttributes);
    return result;
}
function $d9feab882fdf4853$var$mapStatusToAction(status) {
    if (status === 'ACCESS_GRANTED') return 'joined';
    if (status === 'PENDING_REQUEST_CREATED') return 'requested';
    return null;
}
function $d9feab882fdf4853$var$mapRequestAccessResponse(response, input) {
    const result = response.results[input.resource];
    return {
        error: null,
        result: result,
        action: $d9feab882fdf4853$var$mapStatusToAction(result),
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $d9feab882fdf4853$var$fireRequestAccessAnalytics(requestAccessResult, context, getAdditionalAttributes) {
    const { error: error, product: product, result: result, traceId: traceId, integration: integration, touchpoint: touchpoint, cloudId: cloudId } = requestAccessResult;
    const currentUserId = context.dependencies().getCurrentUserId();
    const baseAttributes = {
        userAaid: currentUserId,
        actorAaid: currentUserId,
        roleName: 'product/member',
        sourceProduct: context.dependencies().getCurrentProduct(),
        sourceTenantId: context.dependencies().getCurrentCloudId(),
        targetProduct: product,
        targetTenantId: cloudId ?? context.dependencies().getCurrentCloudId(),
        integration: integration,
        ...traceId ? {
            traceId: traceId
        } : {}
    };
    // touchpoint is deliberately excluded from product.joined / productAccess.requested's
    // nested `attributes`. Will consolidate when 'expansion-services-invite-capabilities' is
    // cleaned up.
    if (error) {
        if ((0, $egspI.fg)('expansion-services-invite-capabilities')) context.dependencies().fireErrorAnalytics({
            error: error,
            meta: {
                id: 'requestAccess'
            },
            attributes: {
                ...getAdditionalAttributes?.(requestAccessResult) ?? {},
                ...baseAttributes,
                ...touchpoint ? {
                    touchpoint: touchpoint
                } : {}
            }
        });
        return;
    }
    if ((0, $egspI.fg)('expansion-services-invite-capabilities')) $d9feab882fdf4853$var$fireRequestAccessSucceeded({
        ...getAdditionalAttributes?.(requestAccessResult) ?? {},
        ...baseAttributes,
        ...touchpoint ? {
            touchpoint: touchpoint
        } : {}
    }, context);
    const attributes = {
        ...baseAttributes,
        inviteStatus: result
    };
    if (result === 'ACCESS_GRANTED') {
        $d9feab882fdf4853$var$fireProductJoined(attributes, context, touchpoint);
        return;
    }
    if (!(0, $egspI.fg)('expansion-services-invite-capabilities') || result === 'PENDING_REQUEST_CREATED') {
        $d9feab882fdf4853$var$fireProductAccessRequested(attributes, context, touchpoint);
        return;
    }
}
function $d9feab882fdf4853$var$fireProductAccessRequested(attributes, context, touchpoint) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: attributes.targetProduct,
            source: touchpoint ?? (0, $3EXjU.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $d9feab882fdf4853$var$fireProductJoined(attributes, context, touchpoint) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSubjectId: attributes.targetProduct,
            source: touchpoint ?? (0, $3EXjU.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $d9feab882fdf4853$var$fireRequestAccessSucceeded(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'requestAccess',
            action: 'succeeded',
            source: attributes.touchpoint ?? (0, $3EXjU.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}

});


parcelRegister("d0Zrc", function(module, exports) {
$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $6d4e8c4afe14e2d0$export$b05786e1a14be004);
$parcel$export(module.exports, "useFilteredUsersFromCollaborationGraph", () => $6d4e8c4afe14e2d0$export$4509f086e4a8422);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $eijVy = parcelRequire("eijVy");

var $6HRhJ = parcelRequire("6HRhJ");
const $6d4e8c4afe14e2d0$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $6d4e8c4afe14e2d0$export$b05786e1a14be004 = (cloudId)=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $eijVy.useTenantContext)();
    return (0, $euxye.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $6d4e8c4afe14e2d0$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $h2wCv.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined && en.userProfile?.account_type !== 'app' && en.userProfile?.account_status !== 'deactivated' && en.userProfile?.account_status !== 'deleted').map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};
const $6d4e8c4afe14e2d0$export$4509f086e4a8422 = (cloudId, targetProduct, maxCollaborators)=>{
    const getCollaborators = $6d4e8c4afe14e2d0$export$b05786e1a14be004(cloudId);
    return (0, $euxye.useCallback)(async ()=>{
        const collaborators = await getCollaborators();
        let collaboratorsOnTargetProduct;
        if (targetProduct === 'confluence') collaboratorsOnTargetProduct = await (0, $6HRhJ.getConfluenceUsers)(collaborators, cloudId);
        else collaboratorsOnTargetProduct = await (0, $6HRhJ.getUsersWithProductAccess)(cloudId, targetProduct, collaborators);
        return collaboratorsOnTargetProduct.slice(0, maxCollaborators);
    }, [
        cloudId,
        getCollaborators,
        targetProduct,
        maxCollaborators
    ]);
};

});
parcelRegister("6HRhJ", function(module, exports) {
$parcel$export(module.exports, "getConfluenceUsers", () => $6418394763907771$export$71bcfe5bb11155f7);
$parcel$export(module.exports, "getUsersWithProductAccess", () => $6418394763907771$export$a68fadaa3a8b5e25);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");

var $i860n = parcelRequire("i860n");

var $lCetP = parcelRequire("lCetP");
const $6418394763907771$var$URL = '/gateway/api/growth/cross-join-nudges-confluence/get-permitted-confluence-users';
const $6418394763907771$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        if (!collaborators || collaborators.length === 0) return [];
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $4fhEY.default)($6418394763907771$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $6418394763907771$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        if ((0, $lCetP.isClientFetchError)(error) && (0, $i860n.fg)('puma-1635-ignore-failed-fetch-in-get-confluence-us')) return [];
        throw new Error('Get Confluence users error');
    }
};
const $6418394763907771$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};
const $6418394763907771$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $6418394763907771$export$a68fadaa3a8b5e25 = async (cloudId, product, collaborators)=>{
    const accountIds = collaborators.map((u)=>u.id);
    const lackingAccess = await (0, $4fhEY.default)($6418394763907771$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });
    return collaborators.filter((c)=>!lackingAccess.includes(c.id));
};

});


parcelRegister("9QKV7", function(module, exports) {
$parcel$export(module.exports, "useRequestAccessErrorFlag", () => $0338b2047c68dcb5$export$d8e2d94eec4efe85);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hzWaA = parcelRequire("hzWaA");

var $d7Utd = parcelRequire("d7Utd");
var $3mYdc = parcelRequire("3mYdc");
var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $iCxPr = parcelRequire("iCxPr");

var $l4PXU = parcelRequire("l4PXU");
const $0338b2047c68dcb5$var$title = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.request-access-error-flag.title",
    defaultMessage: "We couldn't add you to {productDisplayName}"
});
const $0338b2047c68dcb5$var$description = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.request-access-error-flag.description",
    defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
});
const $0338b2047c68dcb5$var$action = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.request-access-error-flag.action",
    defaultMessage: "contact support"
});
const $0338b2047c68dcb5$export$d8e2d94eec4efe85 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagService)();
    return (0, $euxye.useCallback)((product)=>{
        const id = `error-${(0, $l4PXU.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $d7Utd.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0338b2047c68dcb5$export$e1d0d64874873c8b, {
                    ...props,
                    id: id,
                    product: product,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $0338b2047c68dcb5$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $0338b2047c68dcb5$export$e1d0d64874873c8b = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage($0338b2047c68dcb5$var$title, {
            productDisplayName: (0, $iCxPr.ProductDisplayNames)[props.product]
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("p", null, formatMessage($0338b2047c68dcb5$var$description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
            href: $0338b2047c68dcb5$var$JIRA_SUPPORT_LINK
        }, formatMessage($0338b2047c68dcb5$var$action)), "."))
    });
};
$0338b2047c68dcb5$export$e1d0d64874873c8b.displayName = "RequestAccessErrorFlag";

});
parcelRegister("iCxPr", function(module, exports) {
$parcel$export(module.exports, "ProductDisplayNames", () => $c3a436a8594b7a97$export$46d857911d19ac95);
/* eslint-disable jira/filename-case */ const $c3a436a8594b7a97$export$46d857911d19ac95 = {
    confluence: 'Confluence',
    'jira-product-discovery': 'Jira Product Discovery',
    loom: 'Loom'
};

});

parcelRegister("l4PXU", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $81c0cef1806ea8c7$export$567fc7097e064344);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gXtG2 = parcelRequire("gXtG2");
let $81c0cef1806ea8c7$var$id = 0;
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $81c0cef1806ea8c7$var$id = 0;
});
const $81c0cef1806ea8c7$export$567fc7097e064344 = ()=>{
    $81c0cef1806ea8c7$var$id += 1;
    return String($81c0cef1806ea8c7$var$id);
};
function $81c0cef1806ea8c7$export$e86e19342bc4850e(operation, ms) {
    const startTime = Date.now();
    const timeoutPromise = new Promise((resolve)=>{
        setTimeout(()=>{
            resolve({
                timedOut: true,
                result: null,
                elapsedMs: Date.now() - startTime
            });
        }, ms);
    });
    const operationPromise = operation().then((result)=>({
            timedOut: false,
            result: result,
            elapsedMs: Date.now() - startTime
        }));
    return Promise.race([
        operationPromise,
        timeoutPromise
    ]);
}

});


parcelRegister("4DmVX", function(module, exports) {
$parcel$export(module.exports, "useRequestAccessPromptFlag", () => $e0b0d9fcbc99e9fc$export$233a6a0aca8c9091);
$parcel$export(module.exports, "getAnalyticsAttributes", () => $e0b0d9fcbc99e9fc$export$e748b6351ba5f204);
$parcel$export(module.exports, "getContextualBanditAnalyticsAttributes", () => $e0b0d9fcbc99e9fc$export$53c813e9a54d378a);
$parcel$export(module.exports, "getContextualBanditCJNMessageParser", () => $e0b0d9fcbc99e9fc$export$7e2ad46880c00991);
$parcel$export(module.exports, "getJPDCJNMessageStrings", () => $e0b0d9fcbc99e9fc$export$77b0d0ed99f701d0);
$parcel$export(module.exports, "getLoomCJNMessageStrings", () => $e0b0d9fcbc99e9fc$export$6c15cf35e6ded22d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $d7Utd = parcelRequire("d7Utd");
var $iQPOZ = parcelRequire("iQPOZ");

var $2700E = parcelRequire("2700E");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $bdpXg = parcelRequire("bdpXg");

var $l4PXU = parcelRequire("l4PXU");

var $6llij = parcelRequire("6llij");
const $e0b0d9fcbc99e9fc$var$titleMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title",
    defaultMessage: "Your team is now using Confluence"
});
const $e0b0d9fcbc99e9fc$var$descriptionMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description",
    defaultMessage: "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
});
const $e0b0d9fcbc99e9fc$var$joinButtonMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button",
    defaultMessage: "Join your team"
});
const $e0b0d9fcbc99e9fc$var$remindMeLaterButtonMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button",
    defaultMessage: "Remind me later"
});
const $e0b0d9fcbc99e9fc$var$notInterestedButtonMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.not-interested-button",
    defaultMessage: "Not interested"
});
const $e0b0d9fcbc99e9fc$var$urgencyTitleMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.urgency-title",
    defaultMessage: "{viewCount, select, 0 {Your team is now using Confluence} 1 {Your team is working in Confluence} other {Your team is waiting for you in Confluence}}"
});
const $e0b0d9fcbc99e9fc$var$titleJpdNudgeMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-jpd-nudge",
    defaultMessage: "Join your team in using Jira Product Discovery"
});
const $e0b0d9fcbc99e9fc$var$descriptionJpdNudgeMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-jpd-nudge",
    defaultMessage: "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
});
const $e0b0d9fcbc99e9fc$var$titleLoomNudgeMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-loom-nudge",
    defaultMessage: "Join your team on Loom"
});
const $e0b0d9fcbc99e9fc$var$descriptionLoomNudgeMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge",
    defaultMessage: "Use Loom videos to record your screen, demos, and reviews."
});
const $e0b0d9fcbc99e9fc$var$descriptionLoomNudgeWithOneCollaboratorMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-one-collaborators",
    defaultMessage: "{collaboratorOne} is using Loom videos to record their screen, demos, and reviews."
});
const $e0b0d9fcbc99e9fc$var$descriptionLoomNudgeWithTwoCollaboratorsMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-two-collaborators",
    defaultMessage: "{collaboratorOne} and {collaboratorTwo} are using Loom videos to record their screen, demos, and reviews."
});
const $e0b0d9fcbc99e9fc$var$descriptionLoomNudgeWithMoreThanTwoCollaboratorsMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-more-than-two-collaborators",
    defaultMessage: "{collaboratorOne} and {collaboratorCount} others are using Loom videos to record their screen, demos, and reviews."
});
const $e0b0d9fcbc99e9fc$var$getStartedButtonMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.get-started-button",
    defaultMessage: "Get started"
});
const $e0b0d9fcbc99e9fc$var$doNotShowAgainButtonMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.do-not-show-again-button",
    defaultMessage: "Don't show again"
});
const $e0b0d9fcbc99e9fc$var$messages = {
    title: $e0b0d9fcbc99e9fc$var$titleMessage,
    description: $e0b0d9fcbc99e9fc$var$descriptionMessage,
    joinButton: $e0b0d9fcbc99e9fc$var$joinButtonMessage,
    remindMeLaterButton: $e0b0d9fcbc99e9fc$var$remindMeLaterButtonMessage,
    notInterestedButton: $e0b0d9fcbc99e9fc$var$notInterestedButtonMessage,
    urgencyTitle: $e0b0d9fcbc99e9fc$var$urgencyTitleMessage,
    titleJpdNudge: $e0b0d9fcbc99e9fc$var$titleJpdNudgeMessage,
    descriptionJpdNudge: $e0b0d9fcbc99e9fc$var$descriptionJpdNudgeMessage,
    titleLoomNudge: $e0b0d9fcbc99e9fc$var$titleLoomNudgeMessage,
    descriptionLoomNudge: $e0b0d9fcbc99e9fc$var$descriptionLoomNudgeMessage,
    descriptionLoomNudgeWithOneCollaborator: $e0b0d9fcbc99e9fc$var$descriptionLoomNudgeWithOneCollaboratorMessage,
    descriptionLoomNudgeWithTwoCollaborators: $e0b0d9fcbc99e9fc$var$descriptionLoomNudgeWithTwoCollaboratorsMessage,
    descriptionLoomNudgeWithMoreThanTwoCollaborators: $e0b0d9fcbc99e9fc$var$descriptionLoomNudgeWithMoreThanTwoCollaboratorsMessage,
    getStartedButton: $e0b0d9fcbc99e9fc$var$getStartedButtonMessage,
    doNotShowAgainButton: $e0b0d9fcbc99e9fc$var$doNotShowAgainButtonMessage
};
const $e0b0d9fcbc99e9fc$export$233a6a0aca8c9091 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return (0, $euxye.useCallback)(({ users: users, onOptout: onOptout, onSubmit: onSubmit, snoozeFor30Days: snoozeFor30Days, snoozeFor7Days: snoozeFor7Days, integration: integration, eventAttributes: eventAttributes, messageParser: messageParser, featureVisitedCount: featureVisitedCount = 0, onDisplayed: onDisplayed })=>{
        const id = `request-access-${(0, $l4PXU.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $d7Utd.dismissFlag)(id));
        const submit = async ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', integration, eventAttributes);
            dismissTheFlag();
            await onSubmit();
        };
        const dismissAndOptout = ()=>{
            dismissTheFlag();
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'flag optedOut', integration, eventAttributes);
            onOptout();
        };
        const dismissAndSnooze = ()=>{
            dismissTheFlag();
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', integration, {
                ...eventAttributes,
                snoozeDays: 30
            });
            snoozeFor30Days();
        };
        const dismiss = ()=>{
            const isFirstVisit = featureVisitedCount === 0;
            // Snooze for 7 days if dismissFor7Days is enabled and snoozeFor7Days function is provided
            if (isFirstVisit) {
                if (snoozeFor7Days) {
                    dismissTheFlag();
                    (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', integration, {
                        ...eventAttributes,
                        snoozeDays: 7
                    });
                    snoozeFor7Days();
                } else {
                    dismissTheFlag();
                    (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', integration, eventAttributes);
                }
            } else dismissAndSnooze();
        };
        const cjnMessages = messageParser(formatMessage);
        const avatarOrientation = integration === 'crossJoinNudgesJiraToJpd' || integration === 'crossJoinNudgesJiraToLoom' ? 'horizontal' : 'vertical';
        if (!(0, $2700E.expVal)('twcg-1920-fix-orcherstrator-block-handling', 'isEnabled', false)) (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', integration, eventAttributes);
        const handleDisplayed = ()=>{
            (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', integration, eventAttributes);
            onDisplayed?.();
        };
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6llij.RequestAccessPromptFlag), {
                    ...props,
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    onSnoozeAndDismiss: dismissAndSnooze,
                    onOptoutAndDismiss: dismissAndOptout,
                    onSubmit: submit,
                    avatarOrientation: avatarOrientation,
                    messages: cjnMessages,
                    featureVisitedCount: featureVisitedCount,
                    ...(0, $2700E.expVal)('twcg-1920-fix-orcherstrator-block-handling', 'isEnabled', false) && {
                        onDisplayed: handleDisplayed
                    }
                })
        });
    }, [
        formatMessage,
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
function $e0b0d9fcbc99e9fc$export$af59011edc35e856(timestampInMs) {
    const currentTime = Date.now();
    return ((currentTime - timestampInMs) / 1000).toFixed(3);
}
const $e0b0d9fcbc99e9fc$export$e748b6351ba5f204 = ({ users: users, userId: userId, sessionId: sessionId, featureVisitedCount: featureVisitedCount, startTimestamp: startTimestamp, snoozeDays: snoozeDays })=>{
    return {
        collaborators: users.length,
        userId: userId,
        sessionId: sessionId,
        featureVisitedCount: featureVisitedCount,
        eligibilityLatencySeconds: $e0b0d9fcbc99e9fc$export$af59011edc35e856(startTimestamp),
        snoozeDays: snoozeDays
    };
};
const $e0b0d9fcbc99e9fc$export$53c813e9a54d378a = ({ entityId: entityId, isContextualBandit: isContextualBandit, ...args })=>{
    return {
        ...$e0b0d9fcbc99e9fc$export$e748b6351ba5f204(args),
        isContextualBandit: isContextualBandit,
        entityId: entityId
    };
};
const $e0b0d9fcbc99e9fc$export$7e2ad46880c00991 = ({ isContextualBandit: isContextualBandit, entityId: entityId, featureVisitedCount: featureVisitedCount })=>{
    return (formatMessage)=>{
        const dynamicMessages = (0, $bdpXg.getDynamicMessages)(isContextualBandit, entityId) || $e0b0d9fcbc99e9fc$var$messages;
        const infoFlagTitle = isContextualBandit ? formatMessage($e0b0d9fcbc99e9fc$var$messages.title) : formatMessage($e0b0d9fcbc99e9fc$var$messages.urgencyTitle, {
            viewCount: featureVisitedCount
        });
        return {
            title: infoFlagTitle,
            description: formatMessage(dynamicMessages.description),
            joinButton: formatMessage(dynamicMessages.joinButton),
            remindMeLaterButton: formatMessage($e0b0d9fcbc99e9fc$var$messages.remindMeLaterButton),
            notInterestedButton: formatMessage($e0b0d9fcbc99e9fc$var$messages.notInterestedButton)
        };
    };
};
const $e0b0d9fcbc99e9fc$export$77b0d0ed99f701d0 = (formatMessage)=>{
    return {
        title: formatMessage($e0b0d9fcbc99e9fc$var$messages.titleJpdNudge),
        description: formatMessage($e0b0d9fcbc99e9fc$var$messages.descriptionJpdNudge),
        joinButton: formatMessage($e0b0d9fcbc99e9fc$var$messages.getStartedButton),
        remindMeLaterButton: formatMessage($e0b0d9fcbc99e9fc$var$messages.remindMeLaterButton),
        notInterestedButton: formatMessage($e0b0d9fcbc99e9fc$var$messages.doNotShowAgainButton)
    };
};
const $e0b0d9fcbc99e9fc$export$6c15cf35e6ded22d = ({ collaborators: collaborators })=>{
    return (formatMessage)=>{
        const getDescription = ()=>{
            if (collaborators.length === 0) return formatMessage($e0b0d9fcbc99e9fc$var$messages.descriptionLoomNudge);
            const [first, second] = collaborators;
            let description;
            if (collaborators.length === 1) description = formatMessage($e0b0d9fcbc99e9fc$var$messages.descriptionLoomNudgeWithOneCollaborator, {
                collaboratorOne: first.name
            });
            else if (collaborators.length === 2) description = formatMessage($e0b0d9fcbc99e9fc$var$messages.descriptionLoomNudgeWithTwoCollaborators, {
                collaboratorOne: first.name,
                collaboratorTwo: second.name
            });
            else description = formatMessage($e0b0d9fcbc99e9fc$var$messages.descriptionLoomNudgeWithMoreThanTwoCollaborators, {
                collaboratorOne: first.name,
                collaboratorCount: collaborators.length - 1
            });
            return description;
        };
        return {
            title: formatMessage($e0b0d9fcbc99e9fc$var$messages.titleLoomNudge),
            description: getDescription(),
            joinButton: formatMessage($e0b0d9fcbc99e9fc$var$messages.getStartedButton),
            remindMeLaterButton: formatMessage($e0b0d9fcbc99e9fc$var$messages.remindMeLaterButton),
            notInterestedButton: formatMessage($e0b0d9fcbc99e9fc$var$messages.notInterestedButton)
        };
    };
};

});
parcelRegister("bdpXg", function(module, exports) {
$parcel$export(module.exports, "EntityList", () => $202e9441dbb589df$export$8bb466c13870163e);
$parcel$export(module.exports, "getDynamicMessages", () => $202e9441dbb589df$export$b916a1b5c615f6eb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
const $202e9441dbb589df$var$titleMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title",
    defaultMessage: "Your team is now using Confluence"
});
const $202e9441dbb589df$var$titleNudgeCandidate01Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01",
    defaultMessage: "Join your teammates in Confluence"
});
const $202e9441dbb589df$var$titleNudgeCandidate02Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02",
    defaultMessage: "Collaborate together in Confluence"
});
const $202e9441dbb589df$var$titleNudgeCandidate03Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03",
    defaultMessage: "Your team is working in Confluence"
});
const $202e9441dbb589df$var$titleNudgeCandidate04Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04",
    defaultMessage: "Unify your projects in Confluence"
});
const $202e9441dbb589df$var$titleNudgeCandidate05Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05",
    defaultMessage: "Bring projects together in Confluence"
});
const $202e9441dbb589df$var$titleNudgeCandidate06Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06",
    defaultMessage: "Create a single source of truth"
});
const $202e9441dbb589df$var$titleNudgeCandidate07Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07",
    defaultMessage: "Create a single source of truth"
});
const $202e9441dbb589df$var$descriptionMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description",
    defaultMessage: "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate01Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01",
    defaultMessage: "Create a single source of truth for project decisions and software documentation."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate02Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02",
    defaultMessage: "Capture, consolidate, and share team knowledge, in one centralized place."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate03Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03",
    defaultMessage: "Create project pages to build a shared understanding for better decision-making."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate04Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04",
    defaultMessage: "Organize project information and sync it to Jira tasks to track and hit your goals faster."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate05Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05",
    defaultMessage: "Capture information in project pages and sync to Jira tasks to track your milestones."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate06Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06",
    defaultMessage: "Consolidate information in one place and sync to Jira tasks for automatic updates."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate07Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07",
    defaultMessage: "Join your team in Confluence to consolidate project information in one place."
});
const $202e9441dbb589df$var$joinButtonMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button",
    defaultMessage: "Join your team"
});
const $202e9441dbb589df$var$joinButtonNudgeCandidate01Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01",
    defaultMessage: "Join your team"
});
const $202e9441dbb589df$var$joinButtonNudgeCandidate02Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02",
    defaultMessage: "Join your team"
});
const $202e9441dbb589df$var$joinButtonNudgeCandidate03Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03",
    defaultMessage: "Join your team"
});
const $202e9441dbb589df$var$joinButtonNudgeCandidate04Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04",
    defaultMessage: "Join Confluence"
});
const $202e9441dbb589df$var$joinButtonNudgeCandidate05Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05",
    defaultMessage: "Join Confluence"
});
const $202e9441dbb589df$var$joinButtonNudgeCandidate06Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06",
    defaultMessage: "Join Confluence"
});
const $202e9441dbb589df$var$joinButtonNudgeCandidate07Message = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07",
    defaultMessage: "Join Confluence"
});
const $202e9441dbb589df$var$titleNudgeCandidate04GalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04-galaxia",
    defaultMessage: "Unify your Jira spaces in Confluence"
});
const $202e9441dbb589df$var$titleNudgeCandidate05GalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05-galaxia",
    defaultMessage: "Bring Jira spaces together in Confluence"
});
const $202e9441dbb589df$var$descriptionGalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-galaxia",
    defaultMessage: "Organize team knowledge, capture ideas, and share requirements for your Jira spaces."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate01GalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01-galaxia",
    defaultMessage: "Create a single source of truth for decisions and documentation."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate03GalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03-galaxia",
    defaultMessage: "Create pages to build a shared understanding for better decision-making."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate04GalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04-galaxia",
    defaultMessage: "Organize information and sync it to Jira work items to track and hit your goals faster."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate05GalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05-galaxia",
    defaultMessage: "Capture information in pages and sync to Jira work items to track your milestones."
});
const $202e9441dbb589df$var$descriptionNudgeCandidate07GalaxiaMessage = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07-galaxia",
    defaultMessage: "Join your team in Confluence to consolidate information in one place."
});
const $202e9441dbb589df$var$messages = {
    title: $202e9441dbb589df$var$titleMessage,
    titleNudgeCandidate01: $202e9441dbb589df$var$titleNudgeCandidate01Message,
    titleNudgeCandidate02: $202e9441dbb589df$var$titleNudgeCandidate02Message,
    titleNudgeCandidate03: $202e9441dbb589df$var$titleNudgeCandidate03Message,
    titleNudgeCandidate04: $202e9441dbb589df$var$titleNudgeCandidate04Message,
    titleNudgeCandidate05: $202e9441dbb589df$var$titleNudgeCandidate05Message,
    titleNudgeCandidate06: $202e9441dbb589df$var$titleNudgeCandidate06Message,
    titleNudgeCandidate07: $202e9441dbb589df$var$titleNudgeCandidate07Message,
    description: $202e9441dbb589df$var$descriptionMessage,
    descriptionNudgeCandidate01: $202e9441dbb589df$var$descriptionNudgeCandidate01Message,
    descriptionNudgeCandidate02: $202e9441dbb589df$var$descriptionNudgeCandidate02Message,
    descriptionNudgeCandidate03: $202e9441dbb589df$var$descriptionNudgeCandidate03Message,
    descriptionNudgeCandidate04: $202e9441dbb589df$var$descriptionNudgeCandidate04Message,
    descriptionNudgeCandidate05: $202e9441dbb589df$var$descriptionNudgeCandidate05Message,
    descriptionNudgeCandidate06: $202e9441dbb589df$var$descriptionNudgeCandidate06Message,
    descriptionNudgeCandidate07: $202e9441dbb589df$var$descriptionNudgeCandidate07Message,
    joinButton: $202e9441dbb589df$var$joinButtonMessage,
    joinButtonNudgeCandidate01: $202e9441dbb589df$var$joinButtonNudgeCandidate01Message,
    joinButtonNudgeCandidate02: $202e9441dbb589df$var$joinButtonNudgeCandidate02Message,
    joinButtonNudgeCandidate03: $202e9441dbb589df$var$joinButtonNudgeCandidate03Message,
    joinButtonNudgeCandidate04: $202e9441dbb589df$var$joinButtonNudgeCandidate04Message,
    joinButtonNudgeCandidate05: $202e9441dbb589df$var$joinButtonNudgeCandidate05Message,
    joinButtonNudgeCandidate06: $202e9441dbb589df$var$joinButtonNudgeCandidate06Message,
    joinButtonNudgeCandidate07: $202e9441dbb589df$var$joinButtonNudgeCandidate07Message,
    titleNudgeCandidate04Galaxia: $202e9441dbb589df$var$titleNudgeCandidate04GalaxiaMessage,
    titleNudgeCandidate05Galaxia: $202e9441dbb589df$var$titleNudgeCandidate05GalaxiaMessage,
    descriptionGalaxia: $202e9441dbb589df$var$descriptionGalaxiaMessage,
    descriptionNudgeCandidate01Galaxia: $202e9441dbb589df$var$descriptionNudgeCandidate01GalaxiaMessage,
    descriptionNudgeCandidate03Galaxia: $202e9441dbb589df$var$descriptionNudgeCandidate03GalaxiaMessage,
    descriptionNudgeCandidate04Galaxia: $202e9441dbb589df$var$descriptionNudgeCandidate04GalaxiaMessage,
    descriptionNudgeCandidate05Galaxia: $202e9441dbb589df$var$descriptionNudgeCandidate05GalaxiaMessage,
    descriptionNudgeCandidate07Galaxia: $202e9441dbb589df$var$descriptionNudgeCandidate07GalaxiaMessage
};
const $202e9441dbb589df$export$8bb466c13870163e = [
    'nudgeCandidate01',
    'nudgeCandidate02',
    'nudgeCandidate03',
    'nudgeCandidate04',
    'nudgeCandidate05',
    'nudgeCandidate06',
    'nudgeCandidate07'
];
const $202e9441dbb589df$var$messageVariantsKeyMap = {
    default: {
        title: 'title',
        description: 'description',
        joinButton: 'joinButton'
    },
    nudgeCandidate01: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04: {
        title: 'titleNudgeCandidate04',
        description: 'descriptionNudgeCandidate04',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05: {
        title: 'titleNudgeCandidate05',
        description: 'descriptionNudgeCandidate05',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07',
        joinButton: 'joinButtonNudgeCandidate07'
    },
    defaultGalaxia: {
        title: 'title',
        description: 'descriptionGalaxia',
        joinButton: 'joinButton'
    },
    nudgeCandidate01Galaxia: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01Galaxia',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02Galaxia: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03Galaxia: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03Galaxia',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04Galaxia: {
        title: 'titleNudgeCandidate04Galaxia',
        description: 'descriptionNudgeCandidate04Galaxia',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05Galaxia: {
        title: 'titleNudgeCandidate05Galaxia',
        description: 'descriptionNudgeCandidate05Galaxia',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06Galaxia: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07Galaxia: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07Galaxia',
        joinButton: 'joinButtonNudgeCandidate07'
    }
};
const $202e9441dbb589df$export$b916a1b5c615f6eb = (isContextualBandit, entityId)=>{
    // Handle case when entityId is unexpected
    if (!(entityId in $202e9441dbb589df$var$messageVariantsKeyMap)) return undefined;
    // If v2B is not enabled we just passthrough default message keys
    const usedEntityId = isContextualBandit ? entityId : 'default';
    // if experiment is enabled and usedEntityIdGalaxia exists then use it
    // else use the usedEntityId
    const entityIdToUse = (0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? `${usedEntityId}Galaxia` : usedEntityId;
    const titleKey = $202e9441dbb589df$var$messageVariantsKeyMap[entityIdToUse].title;
    const descriptionKey = $202e9441dbb589df$var$messageVariantsKeyMap[entityIdToUse].description;
    const joinButtonKey = $202e9441dbb589df$var$messageVariantsKeyMap[entityIdToUse].joinButton;
    return {
        title: $202e9441dbb589df$var$messages[titleKey],
        description: $202e9441dbb589df$var$messages[descriptionKey],
        joinButton: $202e9441dbb589df$var$messages[joinButtonKey]
    };
};

});

parcelRegister("6llij", function(module, exports) {
$parcel$export(module.exports, "RequestAccessPromptFlag", () => $84234ff3c457fe5a$export$9b8813c3601640da);
/* flag-common.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $bgJDP = parcelRequire("bgJDP");

var $2BUXh = parcelRequire("2BUXh");

var $5BP41 = parcelRequire("5BP41");

var $jYEcG = parcelRequire("jYEcG");

var $fbAgj = parcelRequire("fbAgj");

var $3mYdc = parcelRequire("3mYdc");

var $bePnD = parcelRequire("bePnD");

var $d8aYw = parcelRequire("d8aYw");
const $84234ff3c457fe5a$export$9b8813c3601640da = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptoutAndDismiss: onOptoutAndDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, messages: messages, avatarOrientation: avatarOrientation, featureVisitedCount: featureVisitedCount, onDisplayed: onDisplayed, ...props })=>{
    const handleOnSubmit = (0, $euxye.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const handleMessageDisposition = (0, $euxye.useCallback)((status)=>{
        if (status === 'started') onDisplayed?.();
    }, [
        onDisplayed
    ]);
    const customFlagFooterProps = (0, $euxye.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, $bePnD.noop)
                }
            ],
            linkComponent: ()=>{
                let secondETA = null;
                if (featureVisitedCount === 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.default), {
                    xcss: $84234ff3c457fe5a$var$linkButtonStyles,
                    onClick: onSnoozeAndDismiss
                }, messages.remindMeLaterButton);
                else if (featureVisitedCount > 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.default), {
                    xcss: $84234ff3c457fe5a$var$linkButtonStyles,
                    onClick: onOptoutAndDismiss
                }, messages.notInterestedButton);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jYEcG.default), {
                    xcss: $84234ff3c457fe5a$var$linkButtonStyles,
                    onClick: handleOnSubmit
                }, messages.joinButton), !!secondETA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
                    className: (0, $4jQY2.default)([
                        "_1kt95qml _fntnutpp _eid3utpp"
                    ])
                }), secondETA);
            }
        }), [
        featureVisitedCount,
        handleOnSubmit,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $euxye.useMemo)(()=>{
        return users.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d8aYw.FlagCompatibleAvatarGroup), {
            alignment: avatarOrientation,
            maxAvatarCount: 2,
            tooltipPosition: "bottom",
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            size: "small",
            boundariesElement: "scrollParent"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bgJDP))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #357DE8)",
            label: ""
        });
    }, [
        users,
        avatarOrientation
    ]);
    const FLAG_MESSAGE_TYPE = 'marketing';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: messages.title,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("p", {
            className: (0, $4jQY2.default)([
                "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0ccj1k _sudp1e54 _otyru2gc"
            ])
        }, messages.description)),
        icon: customIcon,
        messageType: FLAG_MESSAGE_TYPE,
        messageId: "cross-join-nudges.ui.request-access-prompt-flag.info-flag.request-access-prompt-flag",
        ...onDisplayed && {
            onMessageDisposition: handleMessageDisposition
        }
    });
};
$84234ff3c457fe5a$export$9b8813c3601640da.displayName = "RequestAccessPromptFlag";
const $84234ff3c457fe5a$var$linkButtonStyles = (0, $fbAgj.xcss)({
    maxWidth: '150',
    maxHeight: '3lh',
    overflow: 'hidden',
    color: 'color.link',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: '0',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    cursor: 'pointer',
    padding: '0',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $84234ff3c457fe5a$var$linkButtonSeparatorStyles = null;
const $84234ff3c457fe5a$var$mainContentContainerStyles = null;

});
parcelRegister("bePnD", function(module, exports) {
$parcel$export(module.exports, "noop", () => $3959811bf5f9b62e$export$8793edee2d425525);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Replace with lodash/noop
// oxlint-disable-next-line no-empty-function
const $3959811bf5f9b62e$export$8793edee2d425525 = ()=>{};

});

parcelRegister("d8aYw", function(module, exports) {
$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $384918496fcbf7f7$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jduYm = parcelRequire("jduYm");

var $1qX9F = parcelRequire("1qX9F");

var $bePnD = parcelRequire("bePnD");
const $384918496fcbf7f7$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $384918496fcbf7f7$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $384918496fcbf7f7$export$29beada2d5f93289 = ({ alignment: alignment, maxAvatarCount: maxAvatarCount, tooltipPosition: tooltipPosition, data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $euxye.useMemo)(()=>$384918496fcbf7f7$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1qX9F.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        /* oxlint-disable-next-line typescript/ban-ts-comment */ // @ts-ignore
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, $bePnD.noop),
        ...props
    });
    if (alignment === 'vertical') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($384918496fcbf7f7$var$VerticalAvatarGroupContainer, null, avatarGroup);
    return avatarGroup;
};
$384918496fcbf7f7$export$29beada2d5f93289.displayName = "FlagCompatibleAvatarGroup";
const $384918496fcbf7f7$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount })=>{
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $384918496fcbf7f7$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $384918496fcbf7f7$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $384918496fcbf7f7$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $384918496fcbf7f7$var$OVERFLOW_USER_MARKER
    });
const $384918496fcbf7f7$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jduYm.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($384918496fcbf7f7$var$AvatarOverflowCountContainer, null, `+${Math.min(overflowCount, $384918496fcbf7f7$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $384918496fcbf7f7$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb1osq _4t3i1osq _1e0c11p5 _bfhki8nm _syazi7uo _y3gn1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $384918496fcbf7f7$var$VerticalAvatarGroupContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_ogvv1bp4 _3mc9idpf _1hlaidpf _1qu0x0bf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("4z0sI", function(module, exports) {
$parcel$export(module.exports, "useRequestAccessSuccessFlag", () => $c03694363e03c568$export$184b02cbba392fc0);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $d7Utd = parcelRequire("d7Utd");
var $3mYdc = parcelRequire("3mYdc");
var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $l4PXU = parcelRequire("l4PXU");
const $c03694363e03c568$var$title = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.request-access-success-flag.title",
    defaultMessage: "A request was sent to your admins"
});
const $c03694363e03c568$var$description = (0, $7eNDO.defineMessage)({
    id: "cross-join-nudges.request-access-success-flag.description",
    defaultMessage: "You'll receive an email once they've reviewed it."
});
const $c03694363e03c568$export$184b02cbba392fc0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $iQPOZ.useFlagService)();
    return (0, $euxye.useCallback)(()=>{
        const id = `success-${(0, $l4PXU.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $d7Utd.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c03694363e03c568$export$567128fc1024c9cf, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $c03694363e03c568$export$567128fc1024c9cf = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.SuccessFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage($c03694363e03c568$var$title),
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("p", null, formatMessage($c03694363e03c568$var$description))
    });
};
$c03694363e03c568$export$567128fc1024c9cf.displayName = "RequestAccessSuccessFlag";

});


parcelRegister("8rTGi", function(module, exports) {
$parcel$export(module.exports, "useLoomCrossJoinNudge", () => $24fd1d64a0788bed$export$8614cf5ece273d5b);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $75sVW = parcelRequire("75sVW");

var $lCetP = parcelRequire("lCetP");

var $inMxE = parcelRequire("inMxE");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $5GEx8 = parcelRequire("5GEx8");

var $ffDvJ = parcelRequire("ffDvJ");

var $d1jAR = parcelRequire("d1jAR");

var $eeOhg = parcelRequire("eeOhg");

var $d0Zrc = parcelRequire("d0Zrc");

var $3nBZF = parcelRequire("3nBZF");

var $9QKV7 = parcelRequire("9QKV7");

var $4DmVX = parcelRequire("4DmVX");

var $4z0sI = parcelRequire("4z0sI");

const $24fd1d64a0788bed$var$MAX_NUMBER_OF_LOOM_COLLABORATORS = 10;
const $24fd1d64a0788bed$var$openLoomInANewTab = ()=>{
    if (typeof globalThis === 'undefined') return;
    const newTab = globalThis.window?.open('https://www.loom.com/spaces', '_blank');
    if (newTab) newTab.focus();
};
const $24fd1d64a0788bed$export$8614cf5ece273d5b = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const userId = (0, $3GN2r.useAccountId)() || '';
    const currentProduct = (0, $5GEx8.useCurrentProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $d0Zrc.useFilteredUsersFromCollaborationGraph)(cloudId, 'loom', $24fd1d64a0788bed$var$MAX_NUMBER_OF_LOOM_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $4DmVX.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $4z0sI.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $9QKV7.useRequestAccessErrorFlag)();
    const { snoozeFor7Days: snoozeFor7Days, snoozeFor30Days: snoozeFor30Days, getVisitedCount: getVisitedCount, increaseVisitedCount: increaseVisitedCount } = (0, $eeOhg.useSnooze)('crossJoinNudgesJiraToLoom');
    const { getNudgeState: getNudgeState, setNudgeDismissed: setNudgeDismissed } = (0, $3nBZF.useNudgeStateJiraToLoom)();
    const requestAccessService = (0, $ffDvJ.useRequestAccessService)();
    return (0, $euxye.useCallback)(async ()=>{
        try {
            const startTimestamp = Date.now();
            const onSubmit = async ()=>{
                try {
                    let accessStatus;
                    if (requestAccessService) {
                        const serviceResult = await requestAccessService({
                            product: 'loom',
                            integration: 'crossJoinNudgesJiraToLoom',
                            touchpoint: 'Crossjoin Nudge'
                        });
                        if (serviceResult.error) {
                            (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesJiraToLoom', serviceResult.error, {
                                cloudId: cloudId
                            });
                            throw serviceResult.error;
                        }
                        accessStatus = serviceResult.result;
                    } else accessStatus = await (0, $ffDvJ.requestAccess)('loom', currentProduct, cloudId, userId, 'crossJoinNudgesJiraToLoom', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') // This is an exception as the eligibilty check fails when user has access to loom
                    $24fd1d64a0788bed$var$openLoomInANewTab();
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('loom');
                } catch  {
                    showErrorFlag('loom');
                }
            };
            const isUserOptOut = await getNudgeState() === 'DISMISSED';
            const featureVisitedCount = await getVisitedCount();
            if (isUserOptOut || featureVisitedCount >= (0, $0ef25b7cd0c5e2a4$export$a4b45159adbcc3d7)) return;
            // These snooze functions are for the case when user does not interact with the nudge
            if (featureVisitedCount === 0) snoozeFor7Days();
            else if (featureVisitedCount > 0) snoozeFor30Days();
            const collaboratorsOnLoom = await getFilteredCollaborators();
            const onDisplayed = ()=>{
                // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                increaseVisitedCount(featureVisitedCount + 1).catch((error)=>{
                    if (!$24fd1d64a0788bed$var$isErrorIgnoredForSLO(error)) (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesJiraToLoom', error, {
                        cloudId: cloudId,
                        jiraToLoomCrossJoinNudgesErrorType: 'nudgeViewedFailed'
                    });
                });
            };
            const promptFlagArgs = {
                users: collaboratorsOnLoom,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissed,
                snoozeFor7Days: snoozeFor7Days,
                snoozeFor30Days: snoozeFor30Days,
                integration: 'crossJoinNudgesJiraToLoom',
                featureVisitedCount: featureVisitedCount,
                messageParser: (0, $4DmVX.getLoomCJNMessageStrings)({
                    collaborators: collaboratorsOnLoom
                }),
                eventAttributes: (0, $4DmVX.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnLoom,
                    featureVisitedCount: featureVisitedCount,
                    startTimestamp: startTimestamp
                })
            };
            if ((0, $2700E.expVal)('twcg-1920-fix-orcherstrator-block-handling', 'isEnabled', false)) showRequestAccessPromptFlag({
                ...promptFlagArgs,
                onDisplayed: onDisplayed
            });
            else {
                showRequestAccessPromptFlag(promptFlagArgs);
                increaseVisitedCount(featureVisitedCount + 1);
            }
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!$24fd1d64a0788bed$var$isErrorIgnoredForSLO(error)) (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesJiraToLoom', error, {
                cloudId: cloudId,
                jiraToLoomCrossJoinNudgesErrorType: 'nudgeViewedFailed'
            });
        }
    }, [
        cloudId,
        currentProduct,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeState,
        getVisitedCount,
        increaseVisitedCount,
        requestAccessService,
        setNudgeDismissed,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        snoozeFor7Days,
        snoozeFor30Days,
        userId
    ]);
};
const $24fd1d64a0788bed$var$isErrorIgnoredForSLO = (error)=>{
    const status = (0, $75sVW.isFetchError)(error) ? error.statusCode : null;
    return (0, $lCetP.isClientFetchError)(error) || status === 401 || status === 403;
};

});

parcelRegister("18Dnt", function(module, exports) {
$parcel$export(module.exports, "useConfluenceCrossJoinNudge", () => $e2b45f2e3cced9e1$export$83876d794dc56d4f);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7TA2J = parcelRequire("7TA2J");

var $2700E = parcelRequire("2700E");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $55BnK = parcelRequire("55BnK");

var $g1zht = parcelRequire("g1zht");

var $kSTWB = parcelRequire("kSTWB");

var $d1jAR = parcelRequire("d1jAR");

var $eeOhg = parcelRequire("eeOhg");

var $d0Zrc = parcelRequire("d0Zrc");

var $3nBZF = parcelRequire("3nBZF");

var $iAJZO = parcelRequire("iAJZO");

var $9QKV7 = parcelRequire("9QKV7");

var $4DmVX = parcelRequire("4DmVX");

var $4z0sI = parcelRequire("4z0sI");
const $e2b45f2e3cced9e1$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $e2b45f2e3cced9e1$export$83876d794dc56d4f = ()=>{
    const sessionId = (0, $euxye.useRef)((0, $7TA2J.v4)());
    const getNudgeRecommendations = (0, $iAJZO.useNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const cloudId = (0, $kt86l.useCloudId)();
    const getFilteredCollaborators = (0, $d0Zrc.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $e2b45f2e3cced9e1$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $4DmVX.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $4z0sI.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $9QKV7.useRequestAccessErrorFlag)();
    const { setNudgeDismissed: setNudgeDismissedV2a } = (0, $3nBZF.useNudgeStateV2a)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const userId = (0, $3GN2r.useAccountId)() || '';
    const requestAccessService = (0, $g1zht.useService)((0, $kSTWB.requestAccess));
    return (0, $euxye.useCallback)(async ({ featureVisitedCount: featureVisitedCount })=>{
        const startTimestamp = Date.now();
        try {
            // oxlint-disable-next-line no-inner-declarations
            async function onSubmit() {
                try {
                    const serviceResult = await requestAccessService({
                        product: 'confluence',
                        integration: 'crossJoinNudgesConfluence',
                        touchpoint: 'Crossjoin Nudge'
                    });
                    if (serviceResult.error) {
                        (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesConfluence', serviceResult.error);
                        throw serviceResult.error;
                    }
                    const accessStatus = serviceResult.result;
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('confluence');
                } catch  {
                    showErrorFlag('confluence');
                }
            }
            const collaborators = await getFilteredCollaborators();
            const hasNoCollaborators = collaborators.length === 0;
            const entityId = hasNoCollaborators ? await getNudgeRecommendations() : undefined;
            const runPostDisplaySideEffects = ()=>Promise.all([
                    (0, $eeOhg.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1),
                    (0, $eeOhg.cjnEligibilityCacheHandler).set('has_seen_conf', {
                        value: true
                    }),
                    (0, $eeOhg.setHasSeenNudgeInLast7Days)()
                ]);
            const fireSucceededOperationalAnalytics = ()=>{
                (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
            };
            const promptFlagArgs = {
                users: collaborators,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissedV2a,
                snoozeFor30Days: ()=>(0, $eeOhg.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                integration: 'crossJoinNudgesConfluence',
                featureVisitedCount: featureVisitedCount,
                messageParser: (0, $4DmVX.getContextualBanditCJNMessageParser)({
                    isContextualBandit: hasNoCollaborators,
                    entityId: entityId || 'default',
                    featureVisitedCount: featureVisitedCount
                }),
                eventAttributes: (0, $4DmVX.getContextualBanditAnalyticsAttributes)({
                    users: collaborators,
                    userId: userId,
                    entityId: entityId || 'default',
                    sessionId: sessionId.current,
                    isContextualBandit: hasNoCollaborators,
                    featureVisitedCount: featureVisitedCount,
                    startTimestamp: startTimestamp
                })
            };
            if ((0, $2700E.expVal)('twcg-1920-fix-orcherstrator-block-handling', 'isEnabled', false)) {
                const onDisplayed = ()=>{
                    runPostDisplaySideEffects().then(fireSucceededOperationalAnalytics)// oxlint-disable-next-line @typescript-eslint/no-explicit-any
                    .catch((error)=>{
                        (0, $d1jAR.fireErrorAnalytics)('useCrossJoinNudges', error, {
                            cloudId: cloudId
                        });
                    });
                };
                showRequestAccessPromptFlag({
                    ...promptFlagArgs,
                    onDisplayed: onDisplayed
                });
            } else {
                showRequestAccessPromptFlag(promptFlagArgs);
                await runPostDisplaySideEffects();
                fireSucceededOperationalAnalytics();
            }
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $d1jAR.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeRecommendations,
        push,
        requestAccessService,
        setNudgeDismissedV2a,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        userId
    ]);
};

});
parcelRegister("iAJZO", function(module, exports) {
$parcel$export(module.exports, "useNudgeRecommendations", () => $5dae7d66b06e6fc5$export$20e6812ba5f3fc39);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $bIIp7 = parcelRequire("bIIp7");

var $gtB5i = parcelRequire("gtB5i");

var $kt86l = parcelRequire("kt86l");

var $bdpXg = parcelRequire("bdpXg");
const $5dae7d66b06e6fc5$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudge';
function $5dae7d66b06e6fc5$export$20e6812ba5f3fc39({ sessionId: sessionId }) {
    const cloudId = (0, $kt86l.useCloudId)();
    const subProduct = (0, $gtB5i.useSubProduct)();
    const contextResolver = (0, $euxye.useCallback)(()=>({
            product: 'jira',
            useCase: $5dae7d66b06e6fc5$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // oxlint-disable-next-line typescript/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $bIIp7.default)({
        contextResolver: contextResolver
    });
    return (0, $euxye.useCallback)(async ()=>{
        try {
            const result = await getRecommendations(1, $5dae7d66b06e6fc5$var$asEntityIdList((0, $bdpXg.EntityList)));
            const { response: { data: data } = {} } = result;
            // This type assertion is necessary because useRecommendations don't support generic entityId
            const recommendedEntityId = // oxlint-disable-next-line typescript/consistent-type-assertions
            data && data.length > 0 && data[0].entityId || undefined;
            return recommendedEntityId;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'recommendationFetchFailed',
                    packageName: 'jiraCrossJoinNudges',
                    teamName: 'groot-growth'
                },
                error: error
            });
            throw new Error('Get nudge recommendations error');
        }
    }, [
        getRecommendations
    ]);
}
const $5dae7d66b06e6fc5$var$asEntityIdList = (entities)=>entities.map((entity)=>({
            entityId: entity
        }));

});


parcelRegister("jau28", function(module, exports) {
$parcel$export(module.exports, "useLoomCrossJoinNudgeEligibility", () => $db54fa4e0fa2cd9d$export$6caa1b1b8b98e855);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $kt86l = parcelRequire("kt86l");

var $d1jAR = parcelRequire("d1jAR");

var $gpmzl = parcelRequire("gpmzl");
const $db54fa4e0fa2cd9d$export$93d9fa9d1d3cd3fe = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const eventIsFiredRef = (0, $euxye.useRef)(false);
    return (0, $euxye.useCallback)(({ cohort: cohort, flagKey: flagKey })=>{
        if (eventIsFiredRef.current) return;
        if (cohort === 'not-enrolled') return;
        (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'crossJoinNudgesJiraToLoomFeature exposed', {
            flagKey: flagKey,
            cohort: cohort
        });
        eventIsFiredRef.current = true;
    }, [
        createAnalyticsEvent
    ]);
};
const $db54fa4e0fa2cd9d$export$6caa1b1b8b98e855 = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const checkLoomCrossJoinNudgeEligibility = (0, $gpmzl.useCheckLoomCrossJoinNudgeEligibility)();
    return (0, $euxye.useCallback)(async ()=>{
        try {
            const eligibilityResponse = await checkLoomCrossJoinNudgeEligibility();
            if (!eligibilityResponse.eligible) {
                if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $d1jAR.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToLoom');
                return {
                    isEligible: false,
                    ineligibleReason: eligibilityResponse.ineligibilityReason
                };
            }
            return {
                isEligible: true,
                data: {}
            };
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $d1jAR.fireErrorAnalytics)('crossJoinNudgesJiraToLoom', error, {
                cloudId: cloudId,
                jiraToLoomCrossJoinNudgesErrorType: 'eligibilityCheckFailed'
            });
            return {
                isEligible: false,
                ineligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        checkLoomCrossJoinNudgeEligibility
    ]);
};

});
parcelRegister("gpmzl", function(module, exports) {
$parcel$export(module.exports, "useCheckLoomCrossJoinNudgeEligibility", () => $8bb0f9f66937fd5b$export$3ff9ff4e66b3e110);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kt86l = parcelRequire("kt86l");

var $5rZe5 = parcelRequire("5rZe5");

var $3GN2r = parcelRequire("3GN2r");

var $inMxE = parcelRequire("inMxE");

var $cGdse = parcelRequire("cGdse");

var $bwtKg = parcelRequire("bwtKg");

var $hgxiY = parcelRequire("hgxiY");

var $fRc93 = parcelRequire("fRc93");

var $88mpo = parcelRequire("88mpo");

var $eeOhg = parcelRequire("eeOhg");

var $7k33z = parcelRequire("7k33z");
const $8bb0f9f66937fd5b$export$3ff9ff4e66b3e110 = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const userId = (0, $3GN2r.useAccountId)() || '';
    const licensedProducts = (0, $5rZe5.useLicensedProducts)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fetchIsRequestAccessCapable = (0, $bwtKg.useFetchIsRequestAccessCapable)('crossJoinNudgesJiraToLoom');
    return (0, $euxye.useCallback)(async ()=>{
        const cachedIsSiteOptedOut = (0, $eeOhg.withEligibilityCache)('site_is_opted_out', (0, $fRc93.isSiteOptedOut), 0.2);
        const cachedIsSite7DaysOld = (0, $eeOhg.withEligibilityCache)('loom_site_is_more_than_7_days_old', (0, $hgxiY.isLoomSite7DaysOld), 1);
        const cachedIsNewActiveUser = (0, $eeOhg.withEligibilityCache)('user_is_too_new_for_loom', (0, $88mpo.isNewActiveUser), 1);
        const cachedHasProductAccess = (0, $eeOhg.withEligibilityCache)('user_already_has_loom_access', (0, $cGdse.hasProductAccess), 0.2);
        const cachedIsRequestAccessCapable = (0, $eeOhg.withEligibilityCache)('user_can_request_loom_access', fetchIsRequestAccessCapable, 0.2);
        // if the snooze is still active, return false
        if (await (0, $eeOhg.getHasSeenNudgeInLast7Days)()) return {
            eligible: false,
            ineligibilityReason: 'RECENTLY_SEEN_CROSS_JOIN_NUDGE'
        };
        if ((0, $eeOhg.getFeatureVisited)('crossJoinNudgesJiraToLoom')) return {
            eligible: false,
            ineligibilityReason: 'STILL_ON_SNOOZE'
        };
        if (!licensedProducts.loom) return {
            eligible: false,
            ineligibilityReason: 'NO_LOOM_LICENCE'
        };
        if (await cachedIsSiteOptedOut(cloudId)) return {
            eligible: false,
            ineligibilityReason: 'SITE_OPTED_OUT'
        };
        if (!await cachedIsSite7DaysOld(cloudId)) return {
            eligible: false,
            ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
        };
        if (await cachedIsNewActiveUser(cloudId, userId, 14)) return {
            eligible: false,
            ineligibilityReason: 'NEW_ACTIVE_USER'
        };
        // has access to loom on this site
        if (await cachedHasProductAccess('loom', cloudId)) return {
            eligible: false,
            ineligibilityReason: 'ALREADY_HAVE_ACCESS'
        };
        if (!await cachedIsRequestAccessCapable('loom', cloudId, createAnalyticsEvent)) return {
            eligible: false,
            ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
        };
        if (await (0, $7k33z.isExcludedForNav4Placement)(cloudId, userId, createAnalyticsEvent, 'loom')) return {
            eligible: false,
            ineligibilityReason: 'EXCLUDED_FOR_NAV4_PLACEMENT_EXPERIMENT'
        };
        return {
            eligible: true
        };
    }, [
        cloudId,
        createAnalyticsEvent,
        fetchIsRequestAccessCapable,
        licensedProducts.loom,
        userId
    ]);
};

});



parcelRegister("1Bs8E", function(module, exports) {
$parcel$export(module.exports, "AsyncSSRFailureDisplay", () => $6f47c17130b52461$export$ce3da1faaf6198d1);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $jreC0 = parcelRequire("jreC0");

var $7nEKi = parcelRequire("7nEKi");

var $k5P9q = parcelRequire("k5P9q");

var $eTOYl = parcelRequire("eTOYl");
const $6f47c17130b52461$var$EMPTY_OBJECT = {};
const $6f47c17130b52461$var$LoadEntryPoint = ()=>{
    const hasLoadedEntryPoint = (0, $euxye.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $eTOYl.ssrFailureDisplayEntryPoint), $6f47c17130b52461$var$EMPTY_OBJECT);
    // Docs say to do this not in an effect :/ https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138515/Deprecated+Tutorial+How+to+render+your+EntryPoint+for+async+components#Option-3%3A-Using-useRef-without-user-interaction
    // And they have eslint rules to enforce it
    if (!hasLoadedEntryPoint.current) {
        hasLoadedEntryPoint.current = true;
        entryPointActions.load();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        id: "ssr-failure-display",
        packageName: "@jira/ssr__rendering-guard",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $6f47c17130b52461$var$EMPTY_OBJECT
    });
};
$6f47c17130b52461$var$LoadEntryPoint.displayName = "LoadEntryPoint";
const $6f47c17130b52461$export$ce3da1faaf6198d1 = ()=>{
    const isStagingOrDevOrLocal = (0, $k5P9q.useIsStagingOrDevOrLocal)();
    if (isStagingOrDevOrLocal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6f47c17130b52461$var$LoadEntryPoint, null);
    return null;
};
$6f47c17130b52461$export$ce3da1faaf6198d1.displayName = "AsyncSSRFailureDisplay";
$6f47c17130b52461$export$ce3da1faaf6198d1.displayName = 'AsyncSSRFailureDisplay';

});
parcelRegister("eTOYl", function(module, exports) {
$parcel$export(module.exports, "ssrFailureDisplayEntryPoint", () => $44da89b476d4625c$export$3e34e661c7d77f3e);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $44da89b476d4625c$export$3e34e661c7d77f3e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("hLGmK")), {
        moduleId: "3b05423d",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hLGmK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("j04Vy").then(()=>parcelRequire('iR8kc'));

});



parcelRegister("oouzK", function(module, exports) {
$parcel$export(module.exports, "JiraCommandPaletteLazy", () => $3527708029545d0b$export$56184680501f8042);
$parcel$export(module.exports, "AsyncJiraCommandPalette", () => $3527708029545d0b$export$bc973e46f49f4513);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $iSqJS = parcelRequire("iSqJS");

var $k7wxE = parcelRequire("k7wxE");

var $9JkP4 = parcelRequire("9JkP4");

var $dlavO = parcelRequire("dlavO");

var $a8EUd = parcelRequire("a8EUd");

var $kPvQe = parcelRequire("kPvQe");

var $gDdYI = parcelRequire("gDdYI");

var $l8G1z = parcelRequire("l8G1z");

var $VBxmP = parcelRequire("VBxmP");

const $3527708029545d0b$export$56184680501f8042 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazy)(()=>(parcelRequire("egjbq")).then((module)=>module.CommandPaletteIntegration), {
    moduleId: "./src/packages/compal/command-palette-jira-integration/src/ui/index.tsx"
});
const $3527708029545d0b$var$InternalAsyncCommandPalette = (props)=>{
    const [initialised, setInitialised] = (0, $euxye.useState)(false);
    const [{ isOpen: isOpen }] = (0, $k7wxE.useCommandPaletteIsOpen)();
    const { keyMap: commandPaletteKeyMap } = (0, $iSqJS.useCommandPaletteShortcut)();
    const [{ hasLoaded: hasLoaded }] = (0, $kPvQe.default)();
    (0, $euxye.useEffect)(()=>{
        if (!initialised && (isOpen || hasLoaded)) setInitialised(true);
    }, [
        initialised,
        isOpen,
        hasLoaded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "command-palette"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dlavO.default), {
        keyMap: commandPaletteKeyMap
    }), initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "jira-command-palette",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3527708029545d0b$export$56184680501f8042, props)));
};
$3527708029545d0b$var$InternalAsyncCommandPalette.displayName = "InternalAsyncCommandPalette";
const $3527708029545d0b$export$bc973e46f49f4513 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $VBxmP.JiraCommandPaletteErrorBoundary), {
        id: "jira-command-palette-integration-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9JkP4.CommandPaletteWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($3527708029545d0b$var$InternalAsyncCommandPalette, props)));
$3527708029545d0b$export$bc973e46f49f4513.displayName = "AsyncJiraCommandPalette";

});
parcelRegister("iSqJS", function(module, exports) {
$parcel$export(module.exports, "useCommandPaletteShortcut", () => $3ccce571f5f5f5ef$export$819c83c949ab2a6b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $k7wxE = parcelRequire("k7wxE");

var $65dLw = parcelRequire("65dLw");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $kcHzF = parcelRequire("kcHzF");
const $3ccce571f5f5f5ef$export$819c83c949ab2a6b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [{ isLoaded: isLoaded }, { open: open }] = (0, $k7wxE.useCommandPaletteIsLoaded)();
    return (0, $euxye.useMemo)(()=>({
            keyMap: {
                [`${(0, $65dLw.getShortcutModifierKey)()}+k`]: {
                    callback: (ev)=>{
                        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent((0, $kcHzF.COMMAND_PALETTE_PRESSED_ANALYTICS)), (0, $kcHzF.COMMAND_PALETTE_ID), {
                            key: 'k',
                            isLoaded: isLoaded
                        });
                        ev?.preventDefault();
                        open();
                    }
                }
            }
        }), [
        createAnalyticsEvent,
        isLoaded,
        open
    ]);
};

});
parcelRegister("65dLw", function(module, exports) {
$parcel$export(module.exports, "getShortcutModifierKey", () => $961f269e8c68276e$export$fe66dae91c68619b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $1aDnU = parcelRequire("1aDnU");
const $961f269e8c68276e$export$fe66dae91c68619b = ()=>(0, $1aDnU.isMacOs)() ? 'meta' : 'ctrl';

});


parcelRegister("9JkP4", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteWrapper", () => $558452b4588da928$export$c6aee8a02c2936db);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $aZMdt = parcelRequire("aZMdt");

var $k7wxE = parcelRequire("k7wxE");
const $558452b4588da928$export$c6aee8a02c2936db = (t0)=>{
    const $ = (0, $e7boj.c)(3);
    const { children: children } = t0;
    const [analyticsAttributes] = (0, $k7wxE.useCommandPaletteAnalyticsAttributes)();
    let t1;
    if ($[0] !== analyticsAttributes || $[1] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
            sourceName: "commandPalette",
            sourceType: (0, $46f069e6c968f461$export$1171103ea9083ffa),
            attributes: analyticsAttributes
        }, children);
        $[0] = analyticsAttributes;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
$558452b4588da928$export$c6aee8a02c2936db.displayName = "CommandPaletteWrapper";

});

parcelRegister("dlavO", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef9a985a5014d5e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $7Cd1x = parcelRequire("7Cd1x");

var $gXtG2 = parcelRequire("gXtG2");

var $fIeBi = parcelRequire("fIeBi");

var $5WzUs = parcelRequire("5WzUs");

var $b6U1A = parcelRequire("b6U1A");

var $6e24n = parcelRequire("6e24n");

var $k6sZT = parcelRequire("k6sZT");

var $fMNb9 = parcelRequire("fMNb9");
let $4ef9a985a5014d5e$var$shortcutsCount = 0;
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $4ef9a985a5014d5e$var$shortcutsCount = 0;
});
let $4ef9a985a5014d5e$var$subscription = null;
const $4ef9a985a5014d5e$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $euxye.useContext)((0, $k6sZT.ShortcutRegistryContext)) || (0, $6e24n.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const addKeyMap = (0, $euxye.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $fMNb9.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $euxye.useEffect)(()=>{
        $4ef9a985a5014d5e$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $4ef9a985a5014d5e$var$shortcutsCount -= 1;
            if ($4ef9a985a5014d5e$var$subscription && $4ef9a985a5014d5e$var$shortcutsCount === 0) {
                $4ef9a985a5014d5e$var$subscription.unsubscribe();
                $4ef9a985a5014d5e$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $euxye.useEffect)(()=>{
        $4ef9a985a5014d5e$var$subscription = $4ef9a985a5014d5e$var$subscription || // oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $b6U1A.default)().subscribe((0, $5WzUs.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
const $4ef9a985a5014d5e$var$Shortcuts = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $fIeBi.useKeyboardShortcutsToggle), ...unstableProps })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $7Cd1x.useShallowStableReference)(unstableProps, true);
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4ef9a985a5014d5e$var$ShortcutsSubscriber, props) : null;
};
$4ef9a985a5014d5e$var$Shortcuts.displayName = "Shortcuts";
var $4ef9a985a5014d5e$export$2e2bcd8739ae039 = $4ef9a985a5014d5e$var$Shortcuts;

});
parcelRegister("fIeBi", function(module, exports) {
$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e891629056e95128$export$a33a81f1fc5458ad);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $6bEm8 = parcelRequire("6bEm8");

var $aJ81Y = parcelRequire("aJ81Y");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $e891629056e95128$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e891629056e95128$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e891629056e95128$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $h2wCv.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e891629056e95128$var$Store = (0, $5QDqc.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6bEm8.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e891629056e95128$export$b62f67be35e65859
    }
});
const $e891629056e95128$export$a33a81f1fc5458ad = (0, $3h1FP.createHook)($e891629056e95128$var$Store);

});

parcelRegister("5WzUs", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc5484aa544a1605$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $b6U1A = parcelRequire("b6U1A");

var $6e24n = parcelRequire("6e24n");
const $cc5484aa544a1605$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
/**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ const $cc5484aa544a1605$var$handler = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $6e24n.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $b6U1A.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($cc5484aa544a1605$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $b6U1A.flush)();
    }
};
var $cc5484aa544a1605$export$2e2bcd8739ae039 = $cc5484aa544a1605$var$handler;

});
parcelRegister("b6U1A", function(module, exports) {
$parcel$export(module.exports, "flush", () => $5d94250357ccb551$export$4909b86c8034bf73);
$parcel$export(module.exports, "default", () => $5d94250357ccb551$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ /**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $dmX0B = parcelRequire("dmX0B");

var $6jnNj = parcelRequire("6jnNj");
parcelRequire("1bnyb");
parcelRequire("lPpxH");
parcelRequire("lOt3P");
parcelRequire("8DGZ7");
parcelRequire("21M0S");
parcelRequire("hcUL1");
parcelRequire("7JUoj");
parcelRequire("7RTpP");

var $3Y3t6 = parcelRequire("3Y3t6");

var $ftDF4 = parcelRequire("ftDF4");
const $5d94250357ccb551$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $5d94250357ccb551$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $5d94250357ccb551$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$5d94250357ccb551$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $5d94250357ccb551$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$5d94250357ccb551$var$isEditable(e.target) && !$5d94250357ccb551$var$ignoredKeys[e.key]);
let $5d94250357ccb551$var$key$;
const $5d94250357ccb551$var$flush$ = new (0, $6jnNj.Subject)();
const $5d94250357ccb551$var$createSequences = ()=>{
    if (!$5d94250357ccb551$var$key$) {
        $5d94250357ccb551$var$key$ = false ? new (0, $6jnNj.Subject)() : (0, $dmX0B.Observable).fromEvent(document, 'keydown').filter($5d94250357ccb551$var$isRelevantKeyEvent).filter((0, $ftDF4.isLegacyAuiBlanketClosed)).map((0, $3Y3t6.toKeyWithModifiers));
        const sequence$ = $5d94250357ccb551$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $5d94250357ccb551$var$key$ = $5d94250357ccb551$var$key$.debounceTime(1000).startWith(null).merge($5d94250357ccb551$var$flush$).switchMapTo(sequence$);
    }
    return $5d94250357ccb551$var$key$;
};
const $5d94250357ccb551$export$4909b86c8034bf73 = ()=>{
    $5d94250357ccb551$var$flush$.next();
};
var $5d94250357ccb551$export$2e2bcd8739ae039 = $5d94250357ccb551$var$createSequences;

});
parcelRegister("3Y3t6", function(module, exports) {
$parcel$export(module.exports, "toKeyWithModifiers", () => $046f98cc7909dd6d$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $046f98cc7909dd6d$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $046f98cc7909dd6d$export$4add9e50cb49d130);
/* eslint-disable jira/filename-case */ /**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+alt+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is now supported in modern browsers by using event.code
 * to extract the base character when alt modifies the character output.
 * On Mac, alt changes the character input (e.g. 'alt+z' displays 'Ω'),
 * but we extract the base character 'z' for consistent keyboard shortcuts.
 * For older browsers without event.code support, alt shortcuts will still
 * have the original limitation where modified characters are used.
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $046f98cc7909dd6d$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
// Base modifiers with alt support
const $046f98cc7909dd6d$var$baseModifiers = [
    {
        name: 'ctrl',
        test: (e)=>e.ctrlKey
    },
    {
        name: 'alt',
        test: (e)=>e.altKey
    },
    {
        name: 'shift',
        test: (e)=>e.shiftKey && $046f98cc7909dd6d$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $046f98cc7909dd6d$var$toKey = (e)=>{
    if ($046f98cc7909dd6d$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Handle alt-modified characters by using the base character
    // On Mac, alt+z produces 'ω' but we want 'z' for consistent shortcuts
    if (e.altKey && e.code && e.code.startsWith('Key')) {
        // Extract the base character from the code (e.g., 'KeyZ' -> 'z')
        const baseChar = e.code.substring(3).toLowerCase();
        return e.shiftKey ? baseChar.toUpperCase() : baseChar;
    }
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $046f98cc7909dd6d$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $046f98cc7909dd6d$var$baseModifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($046f98cc7909dd6d$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $046f98cc7909dd6d$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $046f98cc7909dd6d$var$singleShortcutEntry = `(ctrl\\+)?(alt\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$046f98cc7909dd6d$var$orSpecialChars}))))?(meta\\+)?(${$046f98cc7909dd6d$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $046f98cc7909dd6d$var$shortcutRegex = RegExp(`^${$046f98cc7909dd6d$var$singleShortcutEntry}( ${$046f98cc7909dd6d$var$singleShortcutEntry})*$`);
const $046f98cc7909dd6d$export$8e231506c5580162 = (shortcut)=>$046f98cc7909dd6d$var$shortcutRegex.test(shortcut);
const $046f98cc7909dd6d$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});

parcelRegister("ftDF4", function(module, exports) {
$parcel$export(module.exports, "isLegacyAuiBlanketClosed", () => $36c391305dafe53e$export$25d1b8252b4c49b7);
/**
 * Finding all `aui-blanket` elements on the page and check if they are all hidden.
 */ const $36c391305dafe53e$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};

});


parcelRegister("6e24n", function(module, exports) {
$parcel$export(module.exports, "ShortcutRegistry", () => $994c16f425c5e2b8$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $994c16f425c5e2b8$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/filename-case, jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $cZa0l = parcelRequire("cZa0l");

var $6Tcej = parcelRequire("6Tcej");

var $WqSvO = parcelRequire("WqSvO");

var $eqGWQ = parcelRequire("eqGWQ");

var $3Y3t6 = parcelRequire("3Y3t6");
const $994c16f425c5e2b8$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($cZa0l)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($cZa0l)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $3Y3t6.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($cZa0l)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $3Y3t6.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $3Y3t6.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $994c16f425c5e2b8$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // oxlint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $994c16f425c5e2b8$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($eqGWQ)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($eqGWQ)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$994c16f425c5e2b8$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
$994c16f425c5e2b8$export$ca1c75b575abf5ff.displayName = "ShortcutRegistry";
const $994c16f425c5e2b8$export$1dd4c61d1ce1fa15 = new $994c16f425c5e2b8$export$ca1c75b575abf5ff();

});
parcelRegister("eqGWQ", function(module, exports) {

var $citK5 = parcelRequire("citK5");

var $9Yp2o = parcelRequire("9Yp2o");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $a814cefb1d234ac1$var$pull = $citK5($9Yp2o);
module.exports = $a814cefb1d234ac1$var$pull;

});
parcelRegister("9Yp2o", function(module, exports) {

var $h3ZJf = parcelRequire("h3ZJf");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $742d2393234718a6$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $h3ZJf(array, values) : array;
}
module.exports = $742d2393234718a6$var$pullAll;

});
parcelRegister("h3ZJf", function(module, exports) {

var $bTATB = parcelRequire("bTATB");

var $a2PxD = parcelRequire("a2PxD");

var $2cvam = parcelRequire("2cvam");

var $8UK9T = parcelRequire("8UK9T");

var $iM6Ha = parcelRequire("iM6Ha");
/** Used for built-in method references. */ var $c6c2998cd84e397a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $c6c2998cd84e397a$var$splice = $c6c2998cd84e397a$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $c6c2998cd84e397a$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2cvam : $a2PxD, index = -1, length = values.length, seen = array;
    if (array === values) values = $iM6Ha(values);
    if (iteratee) seen = $bTATB(array, $8UK9T(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $c6c2998cd84e397a$var$splice.call(seen, fromIndex, 1);
            $c6c2998cd84e397a$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $c6c2998cd84e397a$var$basePullAll;

});
parcelRegister("2cvam", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $19a4e0b23e6f1578$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $19a4e0b23e6f1578$var$baseIndexOfWith;

});






parcelRegister("k6sZT", function(module, exports) {
$parcel$export(module.exports, "ShortcutRegistryContext", () => $b037bf5a4183f76c$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $b037bf5a4183f76c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $6e24n = parcelRequire("6e24n");
const $b037bf5a4183f76c$export$ebbb59327adb551a = /*#__PURE__*/ (0, $euxye.createContext)((0, $6e24n.rootRegistry));
const $b037bf5a4183f76c$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $euxye.useMemo)(()=>new (0, $6e24n.ShortcutRegistry)(), []);
    const parentRegistry = (0, $euxye.useContext)($b037bf5a4183f76c$export$ebbb59327adb551a) || (0, $6e24n.rootRegistry);
    (0, $euxye.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b037bf5a4183f76c$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
$b037bf5a4183f76c$var$ShortcutScope.displayName = "ShortcutScope";
const $b037bf5a4183f76c$var$ExportedComponent = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children) : $b037bf5a4183f76c$var$ShortcutScope;
var $b037bf5a4183f76c$export$2e2bcd8739ae039 = $b037bf5a4183f76c$var$ExportedComponent;

});

parcelRegister("fMNb9", function(module, exports) {
$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $9f03e63cb3d76400$export$77477772a9b904da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");

var $aJ81Y = parcelRequire("aJ81Y");
const $9f03e63cb3d76400$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent) (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $9f03e63cb3d76400$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $9f03e63cb3d76400$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("VBxmP", function(module, exports) {
$parcel$export(module.exports, "JiraCommandPaletteErrorBoundary", () => $d144205c66518961$export$4c089b36a27ad393);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $k7wxE = parcelRequire("k7wxE");
const $d144205c66518961$export$4c089b36a27ad393 = ({ id: id, children: children })=>{
    const [data] = (0, $k7wxE.useCommandPaletteRegistryCurrentAttribution)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: id,
        packageName: "jiraCommandPaletteIntegration",
        fallback: "unmount",
        teamName: data?.registryData?.teamName || 'deliveroo',
        attributes: data?.analyticsAttributes
    }, children);
};
$d144205c66518961$export$4c089b36a27ad393.displayName = "JiraCommandPaletteErrorBoundary";

});

parcelRegister("egjbq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("4ejcC")
]).then(()=>parcelRequire('4pav7'));

});


parcelRegister("gFlGn", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbAdapter", () => $5a2bf97203afb46d$export$2255367d5c9162b3);

var $euxye = parcelRequire("euxye");

var $edtAT = parcelRequire("edtAT");
function $5a2bf97203afb46d$export$2255367d5c9162b3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $edtAT.default), null);
}
$5a2bf97203afb46d$export$2255367d5c9162b3.displayName = "BreadcrumbAdapter";

});
parcelRegister("edtAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac4be035aabc943f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $klDKD = parcelRequire("klDKD");

var $hI3Sw = parcelRequire("hI3Sw");

var $j4uo7 = parcelRequire("j4uo7");

var $aYf9E = parcelRequire("aYf9E");

var $4q7Tg = parcelRequire("4q7Tg");

var $03yul = parcelRequire("03yul");
// eslint-disable-next-line camelcase
const $ac4be035aabc943f$var$defaultExport = (0, $klDKD.default)((0, $hI3Sw.default), {
    LegacyApiBridge: // @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
    $j4uo7.default,
    LegacyBreadcrumbConnector: $aYf9E.default,
    LegacyBreadcrumbState: // @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
    $03yul.default,
    LegacyBreadcrumbRenderer: $4q7Tg.default
});
var $ac4be035aabc943f$export$2e2bcd8739ae039 = $ac4be035aabc943f$var$defaultExport;

});
parcelRegister("klDKD", function(module, exports) {
$parcel$export(module.exports, "getDisplayName", () => $faa4930c1c79cc2f$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $faa4930c1c79cc2f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $faa4930c1c79cc2f$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $faa4930c1c79cc2f$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// oxlint-disable-next-line typescript/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$faa4930c1c79cc2f$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $faa4930c1c79cc2f$export$2e2bcd8739ae039 = $faa4930c1c79cc2f$var$withInjectedProps;

});

parcelRegister("hI3Sw", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bbcee4ca381e9b3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $bx8kK = parcelRequire("bx8kK");

var $cCE2Z = parcelRequire("cCE2Z");

const $7bbcee4ca381e9b3$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(LegacyApiBridge, {
            onInsertItem: api.insertItem,
            onRemoveItem: api.removeItem,
            onSetRenderTarget: api.setTargetElement
        }), // Only activate the breadcrumb connector if there is a breadcrumb render target
        state.targetElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
            id: "legacy-breadcrumb-adapter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(LegacyBreadcrumbConnector, {
            legacyTrail: state.trail
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(LegacyBreadcrumbRenderer, {
            targetElement: state.targetElement
        }))));
$7bbcee4ca381e9b3$var$LegacyBreadcrumbAdapter.displayName = "LegacyBreadcrumbAdapter";
const $7bbcee4ca381e9b3$var$ExportedComponent = (0, $bx8kK.AnalyticsSource)('legacyBreadcrumbs', (0, $46f069e6c968f461$export$f636b5b56f1d624a))($7bbcee4ca381e9b3$var$LegacyBreadcrumbAdapter);
var $7bbcee4ca381e9b3$export$2e2bcd8739ae039 = $7bbcee4ca381e9b3$var$ExportedComponent;

});

parcelRegister("j4uo7", function(module, exports) {
$parcel$export(module.exports, "default", () => $18bc03ce663e84da$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3iQH5 = parcelRequire("3iQH5");

var $klDKD = parcelRequire("klDKD");

var $cKJZo = parcelRequire("cKJZo");
const $18bc03ce663e84da$var$analyticsEvents = {
    onInsertItemFired: (analyticsEvent)=>(0, $3iQH5.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'insertItem'
            }
        }),
    onRemoveItemFired: (analyticsEvent)=>(0, $3iQH5.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'removeItem'
            }
        }),
    onSetRenderTargetFired: (analyticsEvent)=>(0, $3iQH5.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'render'
            }
        }),
    onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $3iQH5.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'onBreadCrumbsUpdate'
            }
        })
};
const $18bc03ce663e84da$var$LegacyAPIBridgeConnected = (0, $klDKD.default)((0, $cKJZo.default), $18bc03ce663e84da$var$analyticsEvents);
var $18bc03ce663e84da$export$2e2bcd8739ae039 = $18bc03ce663e84da$var$LegacyAPIBridgeConnected;

});
parcelRegister("3iQH5", function(module, exports) {
$parcel$export(module.exports, "fireOperationalAnalytics", () => $d45fd4967f7bfba1$export$79f423cc3fd39762);
/* eslint-disable jira/filename-case */ 
var $dAmGh = parcelRequire("dAmGh");

var $hFtK7 = parcelRequire("hFtK7");

var $7iRBQ = parcelRequire("7iRBQ");

var $g6Mb9 = parcelRequire("g6Mb9");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $d45fd4967f7bfba1$var$isNotUndefined = (a)=>a !== undefined;
const $d45fd4967f7bfba1$var$mapPayload = (payload)=>{
    const context = (0, $g6Mb9.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $d45fd4967f7bfba1$var$isNotUndefined);
};
const $d45fd4967f7bfba1$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$d45fd4967f7bfba1$var$mapPayload(payload),
            analyticsType: (0, $7iRBQ.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $hFtK7.fireErrorAnalytics)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});

parcelRegister("cKJZo", function(module, exports) {
$parcel$export(module.exports, "default", () => $318496c3a1bad28e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $dmX0B = parcelRequire("dmX0B");
parcelRequire("kmrto");

var $lpTWz = parcelRequire("lpTWz");

var $l1hAF = parcelRequire("l1hAF");
// eslint-disable-next-line jira/react/no-class-components
class $318496c3a1bad28e$var$LegacyApiBridge extends (0, $euxye.Component) {
    componentDidMount() {
        const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
        (0, $l1hAF.default)({
            insertItem: onInsertItem,
            removeItem: onRemoveItem,
            render: onSetRenderTarget,
            onBreadCrumbsUpdate: onBreadCrumbsUpdate
        });
    }
    /* eslint-enable jira/react-no-unneeded-arrow-function-properties */ render() {
        return null;
    }
    constructor(...args){
        super(...args), /* eslint-disable jira/react-no-unneeded-arrow-function-properties */ this.onInsertItem = (item)=>{
            const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
            onInsertItemFired();
            onInsertItem(item);
        }, this.onRemoveItem = (itemId)=>{
            const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
            onRemoveItemFired();
            onRemoveItem(itemId);
        }, this.onSetRenderTarget = (element)=>{
            const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
            onSetRenderTargetFired();
            onSetRenderTarget(element);
        }, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBreadCrumbsUpdate = ()=>{
            const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
            onOnBreadCrumbsUpdateFired();
            return (0, $dmX0B.Observable).empty();
        };
    }
}
$318496c3a1bad28e$var$LegacyApiBridge.displayName = "LegacyApiBridge";
// @ts-expect-error - TS2719: two unrelated types with the same name (iso-decl artefact)
const $318496c3a1bad28e$var$defaultExport = (0, $lpTWz.default)('legacyApiBridge', {
    onInsertItemFired: 'apiMethodCalled',
    onRemoveItemFired: 'apiMethodCalled',
    onSetRenderTargetFired: 'apiMethodCalled',
    onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
})($318496c3a1bad28e$var$LegacyApiBridge);
var $318496c3a1bad28e$export$2e2bcd8739ae039 = $318496c3a1bad28e$var$defaultExport;

});
parcelRegister("l1hAF", function(module, exports) {
$parcel$export(module.exports, "default", () => $858ee636caada457$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/wrm/no-load-bridge

var $9dWMe = parcelRequire("9dWMe");
var $8IotF = parcelRequire("8IotF");
var $erQjo = parcelRequire("erQjo");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");
const $858ee636caada457$var$registerBridge = (legacyAPI)=>{
    if ((0, $i860n.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $erQjo.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $9dWMe.loadBridgeStrict)({
            name: 'jira/globalnavigator/breadcrumbs/bridge',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:breadcrumbs'
            ]
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(legacyAPI);
        }).catch((err)=>(0, $6CfY5.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString())));
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $8IotF.loadBridgeWeak)({
        name: 'jira/globalnavigator/breadcrumbs/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(legacyAPI);
    }).catch((err)=>(0, $6CfY5.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
};
var $858ee636caada457$export$2e2bcd8739ae039 = $858ee636caada457$var$registerBridge;

});



parcelRegister("aYf9E", function(module, exports) {
$parcel$export(module.exports, "default", () => $dace850a27712777$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $klDKD = parcelRequire("klDKD");

var $82q58 = parcelRequire("82q58");

var $cZcJ7 = parcelRequire("cZcJ7");

var $i2Tou = parcelRequire("i2Tou");

var $j1ZyB = parcelRequire("j1ZyB");

var $loaj8 = parcelRequire("loaj8");

var $6siCv = parcelRequire("6siCv");
const $dace850a27712777$var$ExportedComponent = (0, $klDKD.default)((0, $loaj8.default), {
    Breadcrumb: $82q58.default,
    ProjectBreadcrumb: $i2Tou.default,
    BoardBreadcrumb: // @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
    $cZcJ7.default,
    UserBreadcrumb: $j1ZyB.default,
    ContextProvider: $6siCv.default
});
var $dace850a27712777$export$2e2bcd8739ae039 = $dace850a27712777$var$ExportedComponent;

});
parcelRegister("82q58", function(module, exports) {
$parcel$export(module.exports, "default", () => $eacc8ef6e59af512$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $eIPDz = parcelRequire("eIPDz");

var $kbjx7 = parcelRequire("kbjx7");
// eslint-disable-next-line jira/react/no-class-components
class $eacc8ef6e59af512$var$BreadcrumbOps extends (0, $euxye.Component) {
    constructor(props){
        super(props);
        const { face: face } = props;
        if (face === 'server') this.onPushBreadcrumb();
    }
    componentDidMount() {
        const { face: face } = this.props;
        if (face === 'client') this.onPushBreadcrumb();
    }
    componentDidUpdate(prevProps) {
        const { breadcrumb: prevBreadcrumb } = prevProps;
        const { api: api, breadcrumb: breadcrumb, id: id } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
            id: id,
            ...breadcrumb
        });
    }
    componentWillUnmount() {
        const { api: api } = this.props;
        api.popBreadcrumb();
    }
    onPushBreadcrumb() {
        const { api: api, breadcrumb: breadcrumb, id: id } = this.props;
        api.pushBreadcrumb({
            id: id,
            ...breadcrumb
        });
    }
    render() {
        return null;
    }
}
$eacc8ef6e59af512$var$BreadcrumbOps.displayName = "BreadcrumbOps";
const $eacc8ef6e59af512$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children = null })=>{
    const face = (0, $eIPDz.useFaceId)();
    const id = (0, $euxye.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kbjx7.BreadcrumbActions), null, (_state, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($eacc8ef6e59af512$var$BreadcrumbOps, {
            api: actions,
            breadcrumb: breadcrumb,
            face: face,
            id: id
        }), children));
};
$eacc8ef6e59af512$var$Breadcrumb.displayName = "Breadcrumb";
var $eacc8ef6e59af512$export$2e2bcd8739ae039 = $eacc8ef6e59af512$var$Breadcrumb;

});
parcelRegister("eIPDz", function(module, exports) {
$parcel$export(module.exports, "useFaceId", () => $c99c0f94dc302abe$export$6236088eff4ec763);

var $euxye = parcelRequire("euxye");
const $c99c0f94dc302abe$export$6236088eff4ec763 = ()=>{
    const id = (0, $euxye.useId)();
    return id[1] === "R" ? "server" : "client";
};

});


parcelRegister("cZcJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcd1b6850106ae92$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $82q58 = parcelRequire("82q58");

var $Of84J = parcelRequire("Of84J");
const $bcd1b6850106ae92$var$BoardBreadcrumb = ({ children: children = null, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject = false, projectId: projectId })=>{
    const breadcrumb = {
        href: (0, $Of84J.createBoardUrl)(boardId),
        text: boardName,
        type: 'boardName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToSubProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $82q58.default), {
        breadcrumb: breadcrumb
    }, children);
};
$bcd1b6850106ae92$var$BoardBreadcrumb.displayName = "BoardBreadcrumb";
var $bcd1b6850106ae92$export$2e2bcd8739ae039 = $bcd1b6850106ae92$var$BoardBreadcrumb;

});
parcelRegister("Of84J", function(module, exports) {
$parcel$export(module.exports, "createProjectUrl", () => $d699b36cf555441c$export$1bdb1f038c5a2a90);
$parcel$export(module.exports, "createProjectSettingsUrl", () => $d699b36cf555441c$export$c435fcb42a65af32);
$parcel$export(module.exports, "createBoardUrl", () => $d699b36cf555441c$export$7037e05c8c7af6dc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3Sl5Y = parcelRequire("3Sl5Y");
const $d699b36cf555441c$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $d699b36cf555441c$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
    if (isSimplified) return (0, $3Sl5Y.getNextgenSettingsUrl)(projectType, projectKey);
    return `/projects/${projectKey}/settings`;
};
const $d699b36cf555441c$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;

});


parcelRegister("i2Tou", function(module, exports) {
$parcel$export(module.exports, "default", () => $3918f29c61429a9e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jG1Iz = parcelRequire("jG1Iz");

var $iiv1n = parcelRequire("iiv1n");
const $3918f29c61429a9e$var$ExportedComponent = (0, $jG1Iz.injectIntlV2)((0, $iiv1n.default));
var $3918f29c61429a9e$export$2e2bcd8739ae039 = $3918f29c61429a9e$var$ExportedComponent;

});
parcelRegister("iiv1n", function(module, exports) {
$parcel$export(module.exports, "default", () => $6084dbfe3492902d$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");

var $82q58 = parcelRequire("82q58");

var $Of84J = parcelRequire("Of84J");
const $6084dbfe3492902d$var$projectsTitle = (0, $7eNDO.defineMessage)({
    id: "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
    defaultMessage: "Projects"
});
const $6084dbfe3492902d$var$projectsTitleGalaxia = (0, $7eNDO.defineMessage)({
    id: "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title-galaxia",
    defaultMessage: "Spaces"
});
const $6084dbfe3492902d$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject = false, children: children = null, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
    const ProjectsBreadcrumb = {
        href: '/jira/projects',
        text: formatMessage((0, $2700E.expVal)('project-terminology-refresh', 'isEnabled', false) ? $6084dbfe3492902d$var$projectsTitleGalaxia : $6084dbfe3492902d$var$projectsTitle),
        type: 'projectsDirectory',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProjectsList'
        }
    };
    if (projectKey != null && projectName != null) {
        const breadcrumb = {
            href: (0, $Of84J.createProjectUrl)(projectKey),
            text: projectName,
            type: 'projectName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        const ProjectNameBreadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $82q58.default), {
            breadcrumb: breadcrumb
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $82q58.default), {
            breadcrumb: ProjectsBreadcrumb
        }, ProjectNameBreadcrumb);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $82q58.default), {
        breadcrumb: ProjectsBreadcrumb
    }, children);
};
$6084dbfe3492902d$var$ProjectBreadcrumb.displayName = "ProjectBreadcrumb";
var $6084dbfe3492902d$export$2e2bcd8739ae039 = $6084dbfe3492902d$var$ProjectBreadcrumb;

});


parcelRegister("j1ZyB", function(module, exports) {
$parcel$export(module.exports, "default", () => $12edde511ffd38ae$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $82q58 = parcelRequire("82q58");
const $12edde511ffd38ae$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
    const breadcrumb = {
        href: profileUrl,
        text: name,
        type: 'userName'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $82q58.default), {
        breadcrumb: breadcrumb
    }, children);
};
$12edde511ffd38ae$var$UserBreadcrumb.displayName = "UserBreadcrumb";
var $12edde511ffd38ae$export$2e2bcd8739ae039 = $12edde511ffd38ae$var$UserBreadcrumb;

});

parcelRegister("loaj8", function(module, exports) {
$parcel$export(module.exports, "default", () => $d94dc1b3e72a4374$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
const $d94dc1b3e72a4374$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
        ...legacyCrumb,
        legacyId: id,
        type: 'legacy'
    });
const $d94dc1b3e72a4374$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ContextProvider, null, ({ data: data })=>{
        if (!data) return children;
        const boardBreadcrumb = data.scope ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(BoardBreadcrumb, {
            boardId: data.scope.id,
            boardName: data.scope.name || 'Board'
        }, children) : children;
        return data.contextType === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(UserBreadcrumb, {
            profileUrl: data.user.profileUrl,
            name: data.user.name
        }, boardBreadcrumb) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ProjectBreadcrumb, {
            projectKey: data.project.key,
            projectName: data.project.name,
            projectId: data.project.id,
            isSimplifiedProject: data.project.isSimplified
        }, boardBreadcrumb);
    });
$d94dc1b3e72a4374$var$ContextBreadcrumbs.displayName = "ContextBreadcrumbs";
const $d94dc1b3e72a4374$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
    const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Breadcrumb, {
            breadcrumb: currentCrumb
        }, accumulatedCrumbs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d94dc1b3e72a4374$var$ContextBreadcrumbs, {
        BoardBreadcrumb: BoardBreadcrumb,
        ProjectBreadcrumb: ProjectBreadcrumb,
        UserBreadcrumb: UserBreadcrumb,
        ContextProvider: ContextProvider
    }, legacyTrail.map($d94dc1b3e72a4374$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
};
$d94dc1b3e72a4374$var$LegacyBreadcrumbConnector.displayName = "LegacyBreadcrumbConnector";
var $d94dc1b3e72a4374$export$2e2bcd8739ae039 = $d94dc1b3e72a4374$var$LegacyBreadcrumbConnector;

});

parcelRegister("6siCv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc24dbc2039bc519$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $l28YB = parcelRequire("l28YB");

var $gapGE = parcelRequire("gapGE");

var $cZjb4 = parcelRequire("cZjb4");
var $2ffUK = parcelRequire("2ffUK");
const $bc24dbc2039bc519$export$9f27bc3417b4524d = ({ children: children })=>{
    const [boardId] = (0, $cZjb4.usePathParam)('boardId');
    const [rapidView] = (0, $2ffUK.useQueryParam)('rapidView');
    const [{ data: ctxData, loading: loading, error: error }] = (0, $gapGE.useContainerContext)();
    /* Don't provide scope data if boardId does not exist in the URL as
	 * we don't want to show the board breadcrumb in this case since it
	 * indicates that we aren't in a scope context even though one may
	 * exist. */ const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(ctxData, 'scope');
    // @ts-expect-error - TS2322 - Type 'Pick<ProjectContext | UserContext, "contextType"> | null' is not assignable to type 'ContainerContext | null'. | TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return children({
        data: data,
        loading: loading,
        error: error
    });
};
$bc24dbc2039bc519$export$9f27bc3417b4524d.displayName = "ContextProvider";
var $bc24dbc2039bc519$export$2e2bcd8739ae039 = $bc24dbc2039bc519$export$9f27bc3417b4524d;

});


parcelRegister("4q7Tg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8913c55fb1ae6a06$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $6CfY5 = parcelRequire("6CfY5");

var $7u2Sp = parcelRequire("7u2Sp");
const $8913c55fb1ae6a06$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
class $8913c55fb1ae6a06$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    componentDidCatch(error) {
        /*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */ const { targetElement: targetElement } = this.props;
        const targetId = targetElement ? targetElement.id : 'not-found';
        (0, $6CfY5.default).safeErrorWithoutCustomerData($8913c55fb1ae6a06$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
    }
    render() {
        const { targetElement: targetElement } = this.props;
        return /*#__PURE__*/ (0, $85XPu.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7u2Sp.default), null), targetElement);
    }
}
$8913c55fb1ae6a06$export$2e2bcd8739ae039.displayName = "LegacyBreadcrumbRenderer";

});
parcelRegister("7u2Sp", function(module, exports) {
$parcel$export(module.exports, "default", () => $251cbffc33528e6c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3iQH5 = parcelRequire("3iQH5");

var $klDKD = parcelRequire("klDKD");

var $eijVy = parcelRequire("eijVy");

var $eErqA = parcelRequire("eErqA");
const $251cbffc33528e6c$var$fireAnalytics = (analyticsEvent)=>(0, $3iQH5.fireOperationalAnalytics)(analyticsEvent, {
        name: 'breadcrumbRendererMounted'
    });
const $251cbffc33528e6c$var$ExportedComponent = (0, $klDKD.default)((0, $eErqA.default), {
    onMount: $251cbffc33528e6c$var$fireAnalytics,
    TenantContextSubscriber: $eijVy.TenantContextSubscriber
});
var $251cbffc33528e6c$export$2e2bcd8739ae039 = $251cbffc33528e6c$var$ExportedComponent;

});
parcelRegister("eErqA", function(module, exports) {
$parcel$export(module.exports, "EmptyBreadcrumbs", () => $76699cf9e724ec17$export$6d55062fb7016a8f);
$parcel$export(module.exports, "default", () => $76699cf9e724ec17$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.38.1 */ // eslint-disable-next-line jira/filename-case

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $lpTWz = parcelRequire("lpTWz");

var $7UeAv = parcelRequire("7UeAv");

var $kbjx7 = parcelRequire("kbjx7");
// Adapt to prop type from breadcrumbs app
const $76699cf9e724ec17$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
            ...crumb,
            target: crumb.target || '_self'
        }));
const $76699cf9e724ec17$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
    const [{ trail: trail }] = (0, $kbjx7.useBreadcrumbs)();
    const items = (0, $euxye.useMemo)(()=>$76699cf9e724ec17$var$mapTrailToBreadcrumbItems(trail), [
        trail
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $euxye.useEffect)(onMount, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_1tke1tcg"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7UeAv.default), {
        isVisible: true,
        items: items
    }));
};
$76699cf9e724ec17$var$BreadcrumbRenderer.displayName = "BreadcrumbRenderer";
const $76699cf9e724ec17$export$6d55062fb7016a8f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_1tke1tcg"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7UeAv.default), {
        isVisible: true,
        items: []
    }));
};
$76699cf9e724ec17$export$6d55062fb7016a8f.displayName = "EmptyBreadcrumbs";
// @ts-expect-error - TS2322: value not assignable to declared type (iso-decl artefact)
const $76699cf9e724ec17$var$defaultExport = (0, $lpTWz.default)('breadcrumbsRenderer', {
    onMount: 'mounted'
})($76699cf9e724ec17$var$BreadcrumbRenderer);
var $76699cf9e724ec17$export$2e2bcd8739ae039 = $76699cf9e724ec17$var$defaultExport;
const $76699cf9e724ec17$var$breadcrumbsWrapperStyles = null;

});
parcelRegister("7UeAv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f5d42842f17302a$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4aWLY = parcelRequire("4aWLY");

var $2PCKm = parcelRequire("2PCKm");
function $3f5d42842f17302a$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4aWLY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2PCKm.default), {
        isVisible: isVisible,
        items: items
    }));
}
$3f5d42842f17302a$export$2e2bcd8739ae039.displayName = "BreadcrumbNavApp";

});
parcelRegister("2PCKm", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0fc112b5a42adf8$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/filename-case, jira/restricted/react-component-props

var $euxye = parcelRequire("euxye");

var $6jLTU = parcelRequire("6jLTU");

var $fcq2N = parcelRequire("fcq2N");

var $1aFF7 = parcelRequire("1aFF7");

var $jooSv = parcelRequire("jooSv");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $jpPNt = parcelRequire("jpPNt");

var $hwwAp = parcelRequire("hwwAp");
const $c0fc112b5a42adf8$var$breadcrumbsLabel = (0, $7eNDO.defineMessage)({
    id: "navigation-apps.breadcrumbs.aria-label",
    // eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
    defaultMessage: "Empty Breadcrumbs item"
});
const $c0fc112b5a42adf8$export$67abef37aa2929b0 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), {
        ...props,
        ref: ref,
        type: "a"
    }, props.children));
function $c0fc112b5a42adf8$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const totalItems = items.length;
    return isVisible ? // onExpand is required prop in atlaskit's breadcrumbitem component
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1aFF7.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(items) ? // This is needed in order to render an empty breadcrumb for SSR, to avoid visual jumping when javascript kicks in.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jooSv.default), {
        text: "",
        "aria-label": formatMessage($c0fc112b5a42adf8$var$breadcrumbsLabel)
    }) : items.map((breadcrumb, index)=>{
        const breadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hwwAp.default), {
            key: index,
            index: index,
            ariaCurrent: index + 1 === totalItems ? 'page' : undefined,
            hasSeparator: true,
            text: breadcrumb.text,
            target: __SPA__ ? undefined : breadcrumb.target,
            href: breadcrumb.href,
            component: __SPA__ ? $c0fc112b5a42adf8$export$67abef37aa2929b0 : undefined,
            legacyId: breadcrumb.legacyId,
            type: breadcrumb.type,
            analyticsAttributes: breadcrumb.analyticsAttributes,
            analyticsFields: breadcrumb.analyticsFields
        });
        return breadcrumbItem;
    }))) : null;
}
$c0fc112b5a42adf8$export$2e2bcd8739ae039.displayName = "Breadcrumbs";

});
parcelRegister("hwwAp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ce56f4d10bad5e5$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $jooSv = parcelRequire("jooSv");

var $iXqc0 = parcelRequire("iXqc0");
class $8ce56f4d10bad5e5$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            href: undefined,
            legacyId: undefined,
            type: 'unspecified',
            analyticsAttributes: {},
            analyticsFields: {},
            ariaCurrent: undefined
        };
    }
    render() {
        const { index: index, text: text, target: target, href: href, component: component, ariaCurrent: ariaCurrent } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jooSv.default), {
            key: index,
            text: text,
            // @ts-expect-error - TS2322 - Type '(event: Event, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'.
            onClick: this.onBreadCrumbClick,
            target: target,
            href: href,
            component: component,
            "aria-current": ariaCurrent
        });
    }
    constructor(...args){
        super(...args), this.onBreadCrumbClick = (event, analyticsEvent)=>{
            const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
            (0, $iXqc0.fireUiAnalytics)(analyticsEvent, {
                name: '',
                attributes: {
                    legacyId: legacyId,
                    // change this depth value to be zero based, once Jira home crumb is added
                    depth: index + 1,
                    type: type,
                    ...analyticsAttributes
                },
                ...analyticsFields
            });
        };
    }
}
$8ce56f4d10bad5e5$export$2e2bcd8739ae039.displayName = "BreadcrumbItem";

});
parcelRegister("iXqc0", function(module, exports) {
$parcel$export(module.exports, "fireUiAnalytics", () => $ca22d15700d77ae1$export$4909253b5bf1eed7);
/* eslint-disable jira/filename-case */ 
var $dAmGh = parcelRequire("dAmGh");

var $7iRBQ = parcelRequire("7iRBQ");

var $g6Mb9 = parcelRequire("g6Mb9");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $ca22d15700d77ae1$var$isNotUndefined = (a)=>a !== undefined;
const $ca22d15700d77ae1$var$mapPayload = (payload)=>{
    const context = (0, $g6Mb9.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $ca22d15700d77ae1$var$isNotUndefined);
};
const $ca22d15700d77ae1$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$ca22d15700d77ae1$var$mapPayload(payload),
        analyticsType: (0, $7iRBQ.UI_EVENT_TYPE)
    }).fire();
};

});







parcelRegister("03yul", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1801e9e3b349503$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $f1801e9e3b349503$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
const $f1801e9e3b349503$var$defaultInitialState = {
    trail: [],
    targetElement: null
};
class $f1801e9e3b349503$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            initialState: $f1801e9e3b349503$var$defaultInitialState
        };
    }
    constructor(props){
        super(props), this.onInsertItem = (item)=>{
            this.setState((state)=>({
                    trail: [
                        ...state.trail,
                        item
                    ].sort($f1801e9e3b349503$var$compareBreadcrumbs)
                }));
        }, this.onRemoveItem = (id)=>{
            this.setState((state)=>({
                    trail: state.trail.filter((b)=>b.id !== id)
                }));
        }, /* eslint-disable react/no-unused-state */ this.onTargetSet = (targetElement)=>{
            this.setState({
                targetElement: targetElement
            });
        }, /* eslint-enable react/no-unused-state */ this.api = {
            setTargetElement: this.onTargetSet,
            insertItem: this.onInsertItem,
            removeItem: this.onRemoveItem
        };
        this.state = props.initialState;
    }
    render() {
        const { children: children } = this.props;
        return children({
            state: this.state,
            api: this.api
        });
    }
}
$f1801e9e3b349503$export$2e2bcd8739ae039.displayName = "LegacyBreadcrumbState";

});



parcelRegister("Y2Big", function(module, exports) {
$parcel$export(module.exports, "LoadingPhaseManager", () => $5b4109cd989091fb$export$6e4bfef9e80c7eb0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $kPvQe = parcelRequire("kPvQe");

var $2OUOK = parcelRequire("2OUOK");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $5b4109cd989091fb$export$6e4bfef9e80c7eb0 = ()=>{
    const [{ hasLoaded: hasLoaded }] = (0, $kPvQe.default)();
    const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $2OUOK.useLazyPhase)();
    (0, $euxye.useEffect)(()=>{
        if (hasLoaded) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else resetPhase();
    }, [
        hasLoaded,
        resetPhase,
        startNextPhase
    ]);
    return null;
};
$5b4109cd989091fb$export$6e4bfef9e80c7eb0.displayName = "LoadingPhaseManager";

});

parcelRegister("l8vBy", function(module, exports) {
$parcel$export(module.exports, "TrackClicksBeforeTTI", () => $91f6f3cee065e004$export$2846c12b8c092470);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $62Xqf = parcelRequire("62Xqf");

var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");
const $91f6f3cee065e004$var$cleanUrl = (pathname)=>{
    let url = pathname.replace(/\/$/, '');
    // /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(url)) url = 'browse';
    // replaces any occurrence of two or more capital letters,
    // or one capital letter followed by a number and also
    // two or more capital letters followed by a dash and any amount of numbers
    // (should catch all project and issue keys)
    if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
    return url;
};
/**
 * Handles the collection and processing of user interactions that occur before the page becomes fully interactive. This enhances the understanding of user behavior during the initial loading phase.
 */ const $91f6f3cee065e004$export$2846c12b8c092470 = ()=>{
    const isReady = (0, $62Xqf.useSpaStatePageReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        if (!isReady) return;
        try {
            const sessionStorageItems = (0, $i860n.fg)('jfp-vulcan-browser-storage-migration') ? (0, $4fPPi.AtlBrowserStorageSession).getItem('clicks-before-tti') : sessionStorage.getItem('clicks-before-tti');
            if (sessionStorageItems == null || sessionStorageItems === '') return;
            const items = JSON.parse(sessionStorageItems);
            items.forEach((item)=>{
                // oxlint-disable-next-line @typescript-eslint/no-explicit-any
                let extras = {
                    elementId: item.dataId,
                    currentUrl: $91f6f3cee065e004$var$cleanUrl(item.currentUrl),
                    bundleId: item.bundleId,
                    time: item.time
                };
                if (item.redirectUrl !== '') extras = {
                    ...extras,
                    redirectUrl: $91f6f3cee065e004$var$cleanUrl(item.redirectUrl)
                };
                (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'clicked'
                }), 'nonInteractiveElement clicked', '', extras);
            });
            if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) (0, $4fPPi.AtlBrowserStorageSession).removeItem('clicks-before-tti');
            else // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
            sessionStorage.removeItem('clicks-before-tti');
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        createAnalyticsEvent,
        isReady
    ]);
    return null;
};
$91f6f3cee065e004$export$2846c12b8c092470.displayName = "TrackClicksBeforeTTI";

});

parcelRegister("c2hVV", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $91bc018024f5b331$export$99d02219d259eb94);
$parcel$export(module.exports, "IntegrationsWhichRequireNavigationRoot", () => $91bc018024f5b331$export$26605c981d761e9d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $39fXO = parcelRequire("39fXO");

var $5DFsu = parcelRequire("5DFsu");

var $8D23v = parcelRequire("8D23v");

var $bIvch = parcelRequire("bIvch");
function $91bc018024f5b331$export$99d02219d259eb94() {
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5DFsu.IssueViewModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bIvch.Projects), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $39fXO.Dashboards), null));
    return null;
}
$91bc018024f5b331$export$99d02219d259eb94.displayName = "Integrations";
$91bc018024f5b331$export$99d02219d259eb94.displayName = 'Integrations'; // This is needed to pass the test.tsx's uniqueness-test. Without it, the component appears as 'ComponentWithCondition[]', which already exists in the list.
function $91bc018024f5b331$export$26605c981d761e9d() {
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8D23v.KeyboardShortcuts), null);
    return null;
}
$91bc018024f5b331$export$26605c981d761e9d.displayName = "IntegrationsWhichRequireNavigationRoot";

});
parcelRegister("39fXO", function(module, exports) {
$parcel$export(module.exports, "Dashboards", () => $63cc96081245e1f1$export$dd47e695f88fad71);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4Kt0R = parcelRequire("4Kt0R");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $2qjhu = parcelRequire("2qjhu");

var $4Onaa = parcelRequire("4Onaa");

var $gRWK8 = parcelRequire("gRWK8");

var $cvA2R = parcelRequire("cvA2R");

var $881dx = parcelRequire("881dx");
var $55BnK = parcelRequire("55BnK");
const $63cc96081245e1f1$var$styles = (0, $fbAgj.xcss)({
    position: 'absolute'
});
const $63cc96081245e1f1$export$dd47e695f88fad71 = ()=>{
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const [isOpen, { off: modalClose }] = (0, $gRWK8.useSwitchModals)((0, $4Kt0R.MODAL_ID).DASHBOARD_CREATE);
    const { path: path } = (0, $4Onaa.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $55BnK.useRouterActions)();
    const onSuccess = (0, $euxye.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
    (_, { id: id })=>{
        path && push((0, $881dx.generatePath)(path, {
            dashboardId: id
        }));
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    if (isAnonymous) return null;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $63cc96081245e1f1$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2qjhu.default), {
        onSuccess: onSuccess,
        onCancel: modalClose
    })) : null;
};
$63cc96081245e1f1$export$dd47e695f88fad71.displayName = "Dashboards";

});
parcelRegister("2qjhu", function(module, exports) {
$parcel$export(module.exports, "default", () => $8778aff1eeaa104a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/react-component-props

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8778aff1eeaa104a$var$AsyncCreateDashboardModal = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("jcHaM")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories-dashboards-directory-v2-create-dashboard-modal/src/index.tsx"
});
const $8778aff1eeaa104a$var$AsyncCreateDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "create-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8778aff1eeaa104a$var$AsyncCreateDashboardModal, props));
$8778aff1eeaa104a$var$AsyncCreateDashboardModalContainer.displayName = "AsyncCreateDashboardModalContainer";
var $8778aff1eeaa104a$export$2e2bcd8739ae039 = $8778aff1eeaa104a$var$AsyncCreateDashboardModalContainer;

});
parcelRegister("jcHaM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k6unB").then(()=>parcelRequire('lKEs4'));

});


parcelRegister("gRWK8", function(module, exports) {
$parcel$export(module.exports, "useSwitchModals", () => $9c09a03e952e3b10$export$5ed4b99cbad4ebd6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6gakV = parcelRequire("6gakV");
const $9c09a03e952e3b10$var$dest = (0, $6gakV.createSwitchController)('jira-switch-modals');
const $9c09a03e952e3b10$var$useSwitch = $9c09a03e952e3b10$var$dest.useSwitch;
const $9c09a03e952e3b10$export$5ed4b99cbad4ebd6 = $9c09a03e952e3b10$var$useSwitch;

});


parcelRegister("5DFsu", function(module, exports) {
$parcel$export(module.exports, "IssueViewModal", () => $a02b047b99ab8e9e$export$e6a284da53c503a6);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6mhIw = parcelRequire("6mhIw");

var $dhMWL = parcelRequire("dhMWL");

var $8pFud = parcelRequire("8pFud");

var $75YsU = parcelRequire("75YsU");

var $aWliK = parcelRequire("aWliK");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $a02b047b99ab8e9e$export$4c54777ebb1a3ba7 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazy)(()=>(parcelRequire("f4Efe")), {
    moduleId: "./src/packages/issue/issue-view/src/IssueModal.tsx"
});
// Switch between IssueAppSelectorModal (WIV) and ClassicIssueViewModal based on experiment
const $a02b047b99ab8e9e$var$IssueViewModalInner = (0, $aWliK.componentWithCondition)((0, $75YsU.isWorkItemModernizationGatesEnabled), (0, $dhMWL.IssueAppSelectorModal), $a02b047b99ab8e9e$export$4c54777ebb1a3ba7);
const $a02b047b99ab8e9e$export$e6a284da53c503a6 = ()=>{
    const [{ isModalOpen: isModalOpen, issueKey: issueKey, onClose: onClose, packageName: packageName, analyticsSource: analyticsSource }] = (0, $6mhIw.useTriggerIssueViewModal)();
    return isModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8pFud.ModalBoundary), {
        packageName: packageName,
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a02b047b99ab8e9e$var$IssueViewModalInner, {
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'AnalyticsSource'.
        analyticsSource: analyticsSource,
        issueKey: issueKey,
        onClose: onClose
    }))) : null;
};
$a02b047b99ab8e9e$export$e6a284da53c503a6.displayName = "IssueViewModal";

});
parcelRegister("6mhIw", function(module, exports) {
$parcel$export(module.exports, "useTriggerIssueViewModal", () => $fb848cc7f20d7835$export$fb8fdfbeb70f910c);

var $fcq2N = parcelRequire("fcq2N");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $fb848cc7f20d7835$var$initialState = {
    isModalOpen: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    issueKey: '',
    packageName: '',
    analyticsSource: '',
    issueCreateSessionId: undefined
};
const $fb848cc7f20d7835$export$e324594224ef24da = {
    openIssueViewModal: (nextState)=>({ setState: setState })=>{
            setState({
                ...$fb848cc7f20d7835$var$initialState,
                ...nextState,
                isModalOpen: true
            });
        },
    closeIssueViewModal: ()=>({ setState: setState })=>{
            setState({
                ...$fb848cc7f20d7835$var$initialState,
                isModalOpen: false
            });
        },
    setIssueCreateSessionId: (issueCreateSessionId)=>({ setState: setState })=>{
            setState({
                issueCreateSessionId: issueCreateSessionId
            });
        }
};
const $fb848cc7f20d7835$var$store = (0, $5QDqc.createStore)({
    name: 'issue-view.controllers.open-issue-view-modal',
    initialState: $fb848cc7f20d7835$var$initialState,
    actions: $fb848cc7f20d7835$export$e324594224ef24da
});
const $fb848cc7f20d7835$export$fb8fdfbeb70f910c = (0, $3h1FP.createHook)($fb848cc7f20d7835$var$store);

});

parcelRegister("dhMWL", function(module, exports) {
$parcel$export(module.exports, "IssueAppSelectorModal", () => $fc1b728f887c9b89$export$abdb9e2c453d707a);

var $e7boj = parcelRequire("e7boj");

var $8AfmX = parcelRequire("8AfmX");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $f99M0 = parcelRequire("f99M0");

var $40YhB = parcelRequire("40YhB");

var $adMfn = parcelRequire("adMfn");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $i860n = parcelRequire("i860n");

var $kt86l = parcelRequire("kt86l");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fc1b728f887c9b89$var$JiraWorkItemApp = (0, $l8G1z.lazy)(()=>(parcelRequire("8dmdz")), {
    moduleId: "./src/packages/work-item/work-item-query-wrapper/src/WorkItemLazyQueryWrapper.tsx"
});

const $fc1b728f887c9b89$export$5d6166a43a4314e8 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazy)(()=>(parcelRequire("f4Efe")), {
    moduleId: "./src/packages/issue/issue-view/src/IssueModal.tsx"
});

const $fc1b728f887c9b89$export$697763ae66f11a21 = (0, $l8G1z.lazy)(()=>(parcelRequire("7x1L3")), {
    moduleId: "./src/packages/work-item/work-item-modal/src/WorkItemModal.tsx"
});
function $fc1b728f887c9b89$var$WorkItemModal(props) {
    const $ = (0, $e7boj.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fc1b728f887c9b89$export$697763ae66f11a21, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}
$fc1b728f887c9b89$var$WorkItemModal.displayName = "WorkItemModal";
const $fc1b728f887c9b89$var$IssueAppSelectorModalWithQuery = ({ cloudId: cloudId, onIssueKeyChange: onIssueKeyChange, ...props })=>{
    const [issueKey, setIssueKey] = (0, $euxye.useState)(props.issueKey);
    const [, startTransition] = (0, $euxye.useTransition)();
    const data = (0, $n67Vb.useLazyLoadQuery)((0, $8AfmX.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        includeAgenticWorkItemData: (0, $i860n.fg)('enable_work_item_for_quadratic_release')
    });
    const project = data?.jira?.issueByKey?.projectField?.project;
    const projectType = project?.projectType ? (0, $f99M0.convertToProjectType)(project.projectType) : undefined;
    const workItemUserPreference = data?.jira?.userPreferences?.isIssueViewWivEnabled ?? true;
    const shouldShowWiv = (0, $adMfn.shouldShowWorkItemView)({
        cloudId: cloudId,
        issueKey: issueKey,
        isIssueViewWivEnabled: workItemUserPreference,
        projectType: projectType,
        isCreatedFromAgenticTemplate: project?.isCreatedFromAgenticTemplate,
        isAgenticWorkItemViewEnabled: project?.isAgenticWorkItemViewEnabled
    });
    const handleIssueKeyChange = (0, $euxye.useCallback)((params)=>{
        // Prevent modal from closing and reopening when switching between work items
        startTransition(()=>{
            setIssueKey(params.toIssueKey);
            onIssueKeyChange?.(params);
        });
    }, [
        onIssueKeyChange
    ]);
    const renderContent = ()=>{
        if (shouldShowWiv) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fc1b728f887c9b89$var$WorkItemModal, {
            ...props,
            issueKey: issueKey,
            onIssueKeyChange: handleIssueKeyChange,
            workItemContent: $fc1b728f887c9b89$var$JiraWorkItemApp
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fc1b728f887c9b89$export$5d6166a43a4314e8, {
            ...props,
            issueKey: issueKey,
            onIssueKeyChange: handleIssueKeyChange
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "issue-app-selector-modal.lazy-issue-or-work-item",
        fallback: null
    }, renderContent());
};
$fc1b728f887c9b89$var$IssueAppSelectorModalWithQuery.displayName = "IssueAppSelectorModalWithQuery";
const $fc1b728f887c9b89$export$abdb9e2c453d707a = (props)=>{
    const $ = (0, $e7boj.c)(4);
    const cloudId = (0, $kt86l.useCloudId)();
    if (!cloudId) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
                "data-testid": "issue-app-selector.awaiting-cloud-id-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $40YhB.WorkItemViewSkeleton), {
                isModalView: true
            }));
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== cloudId || $[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fc1b728f887c9b89$var$IssueAppSelectorModalWithQuery, {
            ...props,
            cloudId: cloudId
        });
        $[1] = cloudId;
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
$fc1b728f887c9b89$export$abdb9e2c453d707a.displayName = "IssueAppSelectorModal";

});
parcelRegister("8AfmX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d55ed0fd7b7b304$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c1240f21547de2742ed98bb1738e9793>>
 * @relayHash b6d092ac62b5c43f31e4b164c044058e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed0d251d1e4b99e177b175d1efcc76779a6fc750213e2a245189de018e51a2ec
const $8d55ed0fd7b7b304$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeAgenticWorkItemData"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v6 = {
        "condition": "includeAgenticWorkItemData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCreatedFromAgenticTemplate"
            },
            {
                "kind": "ScalarField",
                "name": "isAgenticWorkItemViewEnabled"
            }
        ]
    }, v7 = {
        "args": [
            v3 /*: any*/ 
        ],
        "concreteType": "JiraUserPreferences",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isIssueViewWivEnabled"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueAppSelectorModalProjectTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "IssueAppSelectorModalProjectTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ed0d251d1e4b99e177b175d1efcc76779a6fc750213e2a245189de018e51a2ec",
            "metadata": {},
            "name": "IssueAppSelectorModalProjectTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8d55ed0fd7b7b304$var$node.hash = "409226f0291e2a736bcc2d1bb49dff35";
var $8d55ed0fd7b7b304$export$2e2bcd8739ae039 = $8d55ed0fd7b7b304$var$node;

});

parcelRegister("8dmdz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr_wiv', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    (parcelRequire("gZgW8"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $4cvLQ("cPzMo")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("k6s83")
        ]);
    }),
    $4cvLQ("5qC72"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("gCScl"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("8kXx5")
]).then(()=>parcelRequire('6qkf6'));

});

parcelRegister("7x1L3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lUJ9X").then(()=>parcelRequire('Xv29e'));

});


parcelRegister("8pFud", function(module, exports) {
$parcel$export(module.exports, "ModalBoundary", () => $5e610bd5345f6d3e$export$c3f500e812fb1bb3);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dQkkK = parcelRequire("dQkkK");

var $8xoxE = parcelRequire("8xoxE");

var $cCE2Z = parcelRequire("cCE2Z");

var $a8EUd = parcelRequire("a8EUd");
const $5e610bd5345f6d3e$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, teamName: teamName, onError: onError })=>{
    const renderErrorState = (0, $euxye.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8xoxE.ErrorFlagRenderer), {
            id: id,
            error: args.error,
            packageName: packageName,
            teamName: teamName
        }), [
        id,
        packageName,
        teamName
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        render: renderErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: id,
        fallback: fallback
    }, children));
};
$5e610bd5345f6d3e$export$c3f500e812fb1bb3.displayName = "ModalBoundary";

});


parcelRegister("8D23v", function(module, exports) {
$parcel$export(module.exports, "KeyboardShortcuts", () => $68389c85f3939f86$export$5176144edf2bef2b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");


var $eSXdz = parcelRequire("eSXdz");

var $bpQLU = parcelRequire("bpQLU");


var $i860n = parcelRequire("i860n");


var $jhEPy = parcelRequire("jhEPy");

var $29eRG = parcelRequire("29eRG");

var $33SHe = parcelRequire("33SHe");

var $1OTgk = parcelRequire("1OTgk");

var $9Oo0T = parcelRequire("9Oo0T");

var $7JeLK = parcelRequire("7JeLK");

var $a8EUd = parcelRequire("a8EUd");

var $f2wVS = parcelRequire("f2wVS");
// Retaining the old name to avoid breaking any dashboards that may break due to this refactor
const $68389c85f3939f86$var$PACKAGE_NAME = '@jira/navigation-apps__atlassian-navigation';
const $68389c85f3939f86$var$SERVICEDESK_QUEUES_CUSTOM_VIEW_ROUTE = 'servicedesk-queues-custom-view';
const $68389c85f3939f86$export$6492f29607845b67 = (0, $f2wVS.createRouterSelector)((state)=>state.route.name);
const $68389c85f3939f86$var$KeyboardShortcuts = ()=>{
    const routeName = $68389c85f3939f86$export$6492f29607845b67();
    const [, { on: on }] = (0, $33SHe.useTopMenus)((0, $eb044bb12d0b1d65$export$c1b33b1e65f8bd62));
    const [, { off: closeAllMenus }] = (0, $33SHe.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $29eRG.useRightSidebarController)();
    const rightSidebarState = (0, $29eRG.useActiveRightSidebarState)();
    const [{ isInitialLoad: isInitialLoad }, actions] = (0, $eSXdz.useIsInitialLoadLegacyIssueCreate)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $9Oo0T.useTriggerIssueCreateModal)();
    const isInitialLoadRef = (0, $euxye.useRef)(false);
    isInitialLoadRef.current = isInitialLoad;
    const openSearch = (0, $euxye.useCallback)(()=>requestAnimationFrame(()=>{
            on();
        }), [
        on
    ]);
    const openIssueCreate = (0, $euxye.useCallback)(()=>{
        if ((0, $i860n.fg)('render_modern_global_issue_create_modal_experience')) openIssueCreateModal({
            triggerPointKey: (0, $1OTgk.GENERIC_KEYBOARD_SHORTCUT)
        });
        else {
            (0, $bpQLU.default)({
                isInitialLoad: isInitialLoadRef.current,
                triggerSource: (0, $42000e90ec1a6081$export$7e22286cafe320a7)
            });
            if (isInitialLoadRef.current) actions.clearInitialLoaded();
        }
    }, [
        actions,
        openIssueCreateModal
    ]);
    const toggleHelpPanel = (0, $euxye.useCallback)(()=>{
        closeAllMenus();
        if (!rightSidebarState?.isCollapsed && rightSidebarState?.panelId === (0, $2b56b53c34bc2033$export$e99efa3985fa3c26)) closeCurrentRightSidebar();
        else openRightSidebar((0, $2b56b53c34bc2033$export$e99efa3985fa3c26), (0, $2b56b53c34bc2033$export$23aa6670f346c214));
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        rightSidebarState?.isCollapsed,
        rightSidebarState?.panelId
    ]);
    const shortcuts = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "lazy-shortcuts",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jhEPy.KeyboardShortcuts), {
        showIssueCreate: openIssueCreate,
        showSearch: openSearch,
        toggleHelpPanel: toggleHelpPanel,
        shouldUseHelpShortcut: true
    }));
    const shouldDeferShortcuts = routeName === $68389c85f3939f86$var$SERVICEDESK_QUEUES_CUSTOM_VIEW_ROUTE && (0, $i860n.fg)('jsm-queues-ttai-batch-1');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts",
        packageName: $68389c85f3939f86$var$PACKAGE_NAME,
        fallback: "unmount"
    }, shouldDeferShortcuts ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7JeLK.BackgroundPriority), null, shortcuts) : shortcuts);
};
$68389c85f3939f86$var$KeyboardShortcuts.displayName = "KeyboardShortcuts";
const $68389c85f3939f86$var$DummyComponent = ()=>null;
// https://jplat.atlassian.net/browse/JFP-3418
// This component currently crashes the page during Hot Module Replacement. So
// we're disabling this component when HMR is enabled (i.e. the --hmr flag is
// present). This a temporary measure until we find a proper fix. This will not
// affect regular development or the customer experience.
const $68389c85f3939f86$export$5176144edf2bef2b = $68389c85f3939f86$var$KeyboardShortcuts;

});
parcelRegister("eSXdz", function(module, exports) {
$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $23a9ee8e621761df$export$8a73e89ffc4b9342);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $23a9ee8e621761df$var$initialState = {
    isInitialLoad: true
};
const $23a9ee8e621761df$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $23a9ee8e621761df$var$store = (0, $5QDqc.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $23a9ee8e621761df$var$initialState,
    actions: $23a9ee8e621761df$export$e324594224ef24da
});
const $23a9ee8e621761df$export$8a73e89ffc4b9342 = (0, $3h1FP.createHook)($23a9ee8e621761df$var$store);

});

parcelRegister("bpQLU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6f84d10acb8badf$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/wrm/no-load-bridge

var $8wV9L = parcelRequire("8wV9L");

var $i860n = parcelRequire("i860n");

var $88rm3 = parcelRequire("88rm3");
const $d6f84d10acb8badf$var$onCreateClick = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $88rm3.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $8wV9L.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $i860n.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api?.showCreateDialog({});
        (0, $88rm3.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};
var $d6f84d10acb8badf$export$2e2bcd8739ae039 = $d6f84d10acb8badf$var$onCreateClick;

});
parcelRegister("8wV9L", function(module, exports) {
$parcel$export(module.exports, "loadBridge", () => $027eb0ac044c2f18$export$df8409da353bde5a);
/* eslint-disable jira/filename-case */ 
var $1fD9L = parcelRequire("1fD9L");
var $bAzzc = parcelRequire("bAzzc");
var $9wvOm = parcelRequire("9wvOm");
var $9dWMe = parcelRequire("9dWMe");

var $9dWMe = parcelRequire("9dWMe");
var $8IotF = parcelRequire("8IotF");
var $erQjo = parcelRequire("erQjo");
var $3i0O3 = parcelRequire("3i0O3");
var $UC9tJ = parcelRequire("UC9tJ");
const $027eb0ac044c2f18$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $1fD9L.MAX_RETRIES), timeout: timeout = (0, $1fD9L.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $9dWMe.loadBridgeStrict)({
        name: name,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $bAzzc.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $9wvOm.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});

parcelRegister("88rm3", function(module, exports) {
$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $8bfa555f49653eee$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $8bfa555f49653eee$export$b5c5d408bb7fd104);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hWSCW = parcelRequire("hWSCW");

var $fCMl0 = parcelRequire("fCMl0");
const $8bfa555f49653eee$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $fCMl0.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $fCMl0.legacyIssueCreateTransitionInteraction).start();
        (0, $fCMl0.legacyIssueCreateCombinedInteraction).start();
    }
};
const $8bfa555f49653eee$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $hWSCW.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $fCMl0.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $fCMl0.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $fCMl0.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("hWSCW", function(module, exports) {
$parcel$export(module.exports, "apiReady", () => $34bbeb50fc95c2eb$export$330fb1a04c974aad);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/wrm/no-load-bridge

var $8wV9L = parcelRequire("8wV9L");
let $34bbeb50fc95c2eb$var$currentBridge;
const $34bbeb50fc95c2eb$export$330fb1a04c974aad = async ()=>{
    if ($34bbeb50fc95c2eb$var$currentBridge) return $34bbeb50fc95c2eb$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $8wV9L.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $34bbeb50fc95c2eb$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("fCMl0", function(module, exports) {
$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $48f0ac295f595fe6$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $48f0ac295f595fe6$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $48f0ac295f595fe6$export$52353a8848646ccd);
/* eslint-disable jira/filename-case */ 
var $jvGCa = parcelRequire("jvGCa");
const $48f0ac295f595fe6$export$2bc24132dfd54487 = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $48f0ac295f595fe6$export$ba0054dee3105c90 = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $48f0ac295f595fe6$export$52353a8848646ccd = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



/* eslint-disable jira/filename-case */ const $42000e90ec1a6081$export$d983e94cf86f65d = 'global-create-button';
const $42000e90ec1a6081$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("jhEPy", function(module, exports) {
$parcel$export(module.exports, "KeyboardShortcuts", () => $5007c95966243449$export$5176144edf2bef2b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $l8G1z = parcelRequire("l8G1z");

const $5007c95966243449$export$5176144edf2bef2b = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("cCnTR")), {
    ssr: false,
    moduleId: "./src/packages/platform/keyboard-shortcuts/src/view/index.tsx"
});

});
parcelRegister("cCnTR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("7URds")
]).then(()=>parcelRequire('kBFKV'));

});


parcelRegister("1OTgk", function(module, exports) {
$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $cd15ee075658be2b$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $cd15ee075658be2b$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $cd15ee075658be2b$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $cd15ee075658be2b$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $cd15ee075658be2b$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $cd15ee075658be2b$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $cd15ee075658be2b$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $cd15ee075658be2b$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $cd15ee075658be2b$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $cd15ee075658be2b$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $cd15ee075658be2b$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $cd15ee075658be2b$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $cd15ee075658be2b$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $cd15ee075658be2b$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_OPS_XFLOW_ONBOARDING_CREATE", () => $cd15ee075658be2b$export$3ce1e5f0e10cb8ea);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $cd15ee075658be2b$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $cd15ee075658be2b$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $cd15ee075658be2b$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $cd15ee075658be2b$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $cd15ee075658be2b$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $cd15ee075658be2b$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $cd15ee075658be2b$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $cd15ee075658be2b$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $cd15ee075658be2b$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $cd15ee075658be2b$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $cd15ee075658be2b$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_BACKLOG_TRIGGER", () => $cd15ee075658be2b$export$dba86c91ec4fdbf0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $cd15ee075658be2b$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $cd15ee075658be2b$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $cd15ee075658be2b$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $cd15ee075658be2b$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $cd15ee075658be2b$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $cd15ee075658be2b$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $cd15ee075658be2b$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $cd15ee075658be2b$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $cd15ee075658be2b$export$145eb8935a34e85e);
$parcel$export(module.exports, "BOARD_CREATE", () => $cd15ee075658be2b$export$1daadfb71bec9061);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $cd15ee075658be2b$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $cd15ee075658be2b$export$ab926dced0f69c1e);
$parcel$export(module.exports, "UC_ATLASSIAN_HOME_CREATE_ISSUE", () => $cd15ee075658be2b$export$d3df6a0ce4e0bc8b);
$parcel$export(module.exports, "JIRA_ISSUE_TABLE_TRIGGER", () => $cd15ee075658be2b$export$99b5cdc74c6071b4);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $cd15ee075658be2b$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $cd15ee075658be2b$export$7a8328e1f8bd992b);
/* eslint-disable jira/filename-case */ const $cd15ee075658be2b$export$a05673a22505d5ee = 'forge-open-issue-create';
const $cd15ee075658be2b$export$c78d329777576aa0 = 'global-create-button';
const $cd15ee075658be2b$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $cd15ee075658be2b$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $cd15ee075658be2b$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $cd15ee075658be2b$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $cd15ee075658be2b$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $cd15ee075658be2b$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $cd15ee075658be2b$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $cd15ee075658be2b$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $cd15ee075658be2b$export$9bc326812a93707 = 'jsw-security-create-issue';
const $cd15ee075658be2b$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $cd15ee075658be2b$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $cd15ee075658be2b$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $cd15ee075658be2b$export$3ce1e5f0e10cb8ea = 'jsm-ops-xflow-onboarding-create';
const $cd15ee075658be2b$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $cd15ee075658be2b$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $cd15ee075658be2b$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $cd15ee075658be2b$export$235b856f54db8916 = 'jwm-board-create-issue';
const $cd15ee075658be2b$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $cd15ee075658be2b$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $cd15ee075658be2b$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $cd15ee075658be2b$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $cd15ee075658be2b$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $cd15ee075658be2b$export$aa348159181703a0 = 'software-create-issue-dialog';
const $cd15ee075658be2b$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $cd15ee075658be2b$export$718822a309bffada = 'create-linked-issue-command-palette';
const $cd15ee075658be2b$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $cd15ee075658be2b$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $cd15ee075658be2b$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $cd15ee075658be2b$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $cd15ee075658be2b$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $cd15ee075658be2b$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $cd15ee075658be2b$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $cd15ee075658be2b$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $cd15ee075658be2b$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $cd15ee075658be2b$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $cd15ee075658be2b$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $cd15ee075658be2b$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $cd15ee075658be2b$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $cd15ee075658be2b$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $cd15ee075658be2b$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $cd15ee075658be2b$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $cd15ee075658be2b$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $cd15ee075658be2b$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $cd15ee075658be2b$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $cd15ee075658be2b$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $cd15ee075658be2b$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $cd15ee075658be2b$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $cd15ee075658be2b$export$145eb8935a34e85e = 'jwm-inline-create';
const $cd15ee075658be2b$export$1daadfb71bec9061 = 'board-create';
const $cd15ee075658be2b$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $cd15ee075658be2b$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $cd15ee075658be2b$export$220cd7b39e0b57a = 'jira-issue-comment';
const $cd15ee075658be2b$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $cd15ee075658be2b$export$d3df6a0ce4e0bc8b = 'uc-atlassian-home-create-issue';
const $cd15ee075658be2b$export$99b5cdc74c6071b4 = 'jira-issue-table-trigger';
const $cd15ee075658be2b$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $cd15ee075658be2b$export$7a8328e1f8bd992b = [
    $cd15ee075658be2b$export$7e9cfd1f59e60910,
    $cd15ee075658be2b$export$708499dcd016e5e9,
    $cd15ee075658be2b$export$e1c8789144c4c810,
    $cd15ee075658be2b$export$c5afabb7a17e802
];

});

parcelRegister("9Oo0T", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $dcd926d39f5bb8db$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "noopActions", () => $dcd926d39f5bb8db$export$6b9306855551af21);
$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $dcd926d39f5bb8db$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $dcd926d39f5bb8db$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $dcd926d39f5bb8db$export$558a195c5bfe3787);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $7TA2J = parcelRequire("7TA2J");

var $VoOhq = parcelRequire("VoOhq");

var $jaJSD = parcelRequire("jaJSD");

var $7IK6V = parcelRequire("7IK6V");

var $4BBh0 = parcelRequire("4BBh0");
var $inMxE = parcelRequire("inMxE");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

var $i860n = parcelRequire("i860n");

var $14CWj = parcelRequire("14CWj");

var $cIX5T = parcelRequire("cIX5T");

var $2700E = parcelRequire("2700E");

var $1OTgk = parcelRequire("1OTgk");

var $jwOsd = parcelRequire("jwOsd");

var $kTMHb = parcelRequire("kTMHb");

var $k2847 = parcelRequire("k2847");
const $dcd926d39f5bb8db$var$traceModernisedGicPress = (isSubsequentLoad)=>{
    if ((0, $i860n.fg)('nike_united_fix_ufo_error')) return;
    if (isSubsequentLoad) (0, $VoOhq.default)('global-issue.create-modal-modernised-subsequent');
    else (0, $VoOhq.default)('global-issue.create-modal-modernised');
};
const $dcd926d39f5bb8db$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $7IK6V.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $1OTgk.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null,
    // reference to the element to focus when the modal is closed
    returnFocusRef: undefined,
    // when true, indicates the user was redirected from the modern modal to the old modal (e.g., for unsupported project types)
    isRedirectedFromModernModal: false,
    // when true, a transition between old and new modal is in progress
    isTransitioningBetweenOldAndNewModal: false,
    shouldUseLegacyCreateExperience: false,
    // controls whether GIC creates an issue on submit or fires onSaveEditsWithoutIssueCreation.
    submitBehaviour: (0, $kTMHb.ISSUE_CREATE_SUBMIT_BEHAVIOUR).CREATE_ISSUE,
    // called with the full form field payload when submitBehaviour is 'saveEditsWithoutIssueCreation' and the user clicks the submit button. No issue is created in this case.
    onSaveEditsWithoutIssueCreation: undefined
};
const $dcd926d39f5bb8db$export$e324594224ef24da = {
    restoreState: (stateToRestore, isTransitioningBetweenExistingAndNewModal)=>({ setState: setState, getState: getState })=>{
            // During modal transitions (switchToModernModal / triggerFallbackToOldModal),
            // skip restore entirely to prevent stale draft data from overwriting the transition state.
            if (isTransitioningBetweenExistingAndNewModal && (0, $i860n.fg)('create_work_item_modernization')) return;
            // If the user just discarded the existing GIC (wasModalRetriggered was reset to false),
            // skip restoring stale IndexedDB state that still has wasModalRetriggered: true.
            // This prevents the discard modal and docked view from reopening after discard.
            const currentState = getState();
            if (!currentState.wasModalRetriggered && stateToRestore.wasModalRetriggered && (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false)) return;
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) {
                const isModernisedTrigger = Boolean(stateToRestore.triggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(stateToRestore.triggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(isSubsequentLoad, isModernisedTrigger);
                if (isModernisedTrigger) $dcd926d39f5bb8db$var$traceModernisedGicPress(isSubsequentLoad);
            }
            // Don't let stale persisted state close a modal that was just opened.
            // The openIssueCreateModal action sets isModalOpen inside a setTimeout(0),
            // and restoreState from IndexedDB can race and overwrite it.
            if (isModalOpen && !stateToRestore.isModalOpen && (0, $i860n.fg)('bug-fix_gic_restore_state_race_condition')) return;
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                const isModernisedTrigger = Boolean(nextState?.triggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(nextState.triggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad, isModernisedTrigger);
                if (isModernisedTrigger) $dcd926d39f5bb8db$var$traceModernisedGicPress(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts && !(0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false);
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $k2847.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $k2847.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $dcd926d39f5bb8db$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                /*
				 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
				 * so that we can store the reference of this
				 * and use that to re-focus the button whenever the modal is closed
				 */ let triggerButton;
                const handleButtonClick = (event)=>{
                    // oxlint-disable-next-line typescript/consistent-type-assertions
                    const triggerButtonTarget = event.target;
                    triggerButton = triggerButtonTarget?.closest('button');
                    triggerButton?.focus();
                };
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.addEventListener('click', handleButtonClick);
                setTimeout(()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.removeEventListener('click', handleButtonClick);
                }, 0);
                setTimeout(()=>{
                    setState({
                        ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                        ...isDiscoverabilityPushEnabled && {
                            minimizableModalView: nextModalView,
                            persistentModalView: currentState.persistentModalView,
                            ...(0, $k2847.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                        },
                        inProgressIssueID: (0, $7TA2J.v4)(),
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: currentState.isModalOpen,
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey,
                        ...nextState,
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
                        triggerButtonRef: triggerButton || document.activeElement
                    });
                }, 0);
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $k2847.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $jaJSD.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    triggerFallbackToOldModal: (project, options)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                isTransitioningBetweenOldAndNewModal: true,
                ...options?.forceLegacyCreateExperience && {
                    shouldUseLegacyCreateExperience: true
                },
                payload: options?.forceLegacyCreateExperience ? {
                    ...currentState.payload,
                    project: {
                        projectId: project.value,
                        projectType: project.projectType
                    }
                } : {
                    project: {
                        projectId: project.value,
                        projectType: project.projectType
                    }
                }
            });
        },
    /**
	 * Switches from the old modal to the modern modal by closing and reopening.
	 * Uses a single setState to avoid intermediate renders where payload is cleared.
	 * Publishes MODAL_CLOSED to clean up the old in-progress issue from IndexedDB
	 * so stale draft data isn't restored after the transition.
	 */ switchToModernModal: (project)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            // Clean up the old in-progress issue from IndexedDB before switching
            const { publish: publish } = (0, $cIX5T.getGICLifeCycleEvents)();
            publish((0, $14CWj.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, {
                inProgressIssueID: currentState.inProgressIssueID ?? '',
                createdIssues: []
            });
            (0, $k2847.startGlobalIssueCreateMetrics)(true, true);
            $dcd926d39f5bb8db$var$traceModernisedGicPress(true);
            // Reset to initial state but immediately set the new modal state in a single setState
            // to avoid intermediate renders where payload is cleared
            setState({
                ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                isModalOpen: true,
                isSubsequentLoad: true,
                isTransitioningBetweenOldAndNewModal: true,
                shouldInitFetchConfig: true,
                triggerPointKey: currentState.triggerPointKey,
                payload: {
                    project: {
                        projectId: project.value,
                        projectType: project.projectType,
                        isSimplified: project.isSimplified
                    }
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                const nextTriggerPointKey = currentState.openIssueCreateModalNextState?.triggerPointKey ?? currentState.triggerPointKey;
                const isModernisedTrigger = Boolean(nextTriggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(nextTriggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad, isModernisedTrigger);
                if (isModernisedTrigger) $dcd926d39f5bb8db$var$traceModernisedGicPress(currentState.isSubsequentLoad);
                setState({
                    ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $dcd926d39f5bb8db$export$6b9306855551af21 = {
    restoreState: (_stateToRestore, _isTransitioningBetweenExistingAndNewModal)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    openIssueCreateModal: (_nextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    closeIssueCreateModal: (_hasIssueCreated)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    triggerFallbackToOldModal: (_project, _options)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    switchToModernModal: (_project)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    clearSectionMessage: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setDisplayOnlyRequiredFields: (_nextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setMinimizableModalView: (_minimizableModalView)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    resetWasModalRetriggered: (_applyNextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    resetShouldInitFetchConfig: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setCallbackPayload: (_callbackPayload)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setShouldPushMiniModalDiscoverability: (_shouldPushMiniModalDiscoverability)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    dismissModalSpotlight: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setPersistentModalView: (_persistentModalView)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    removeAlertFromAlertsToBeLinked: (_alertId)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setSessionId: (_sessionId)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))()
};
const $dcd926d39f5bb8db$var$store = (0, $5QDqc.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
    actions: $dcd926d39f5bb8db$export$e324594224ef24da
});
const $dcd926d39f5bb8db$var$useTriggerIssueCreateModalState = (0, $3h1FP.createStateHook)($dcd926d39f5bb8db$var$store);
const $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions = (0, $3h1FP.createActionsHook)($dcd926d39f5bb8db$var$store);
const $dcd926d39f5bb8db$export$71e0eb7b8a91a156 = ()=>{
    const createState = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalState();
    const createActions = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $euxye.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {},
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $4BBh0.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $dcd926d39f5bb8db$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $jwOsd.useSitePickerContext)();
    return (0, $euxye.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {},
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {}
        };
        (0, $4BBh0.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $dcd926d39f5bb8db$export$4c674fe824b8f278 = (0, $iGu4q.createSubscriber)($dcd926d39f5bb8db$var$store);
function $dcd926d39f5bb8db$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $dcd926d39f5bb8db$export$71e0eb7b8a91a156();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: true,
            ...props
        });
    };
}

});
parcelRegister("jaJSD", function(module, exports) {
$parcel$export(module.exports, "CreateIssueUFOExperience", () => $b158ee0e69f56076$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $b158ee0e69f56076$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $b158ee0e69f56076$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $b158ee0e69f56076$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $b158ee0e69f56076$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $b158ee0e69f56076$export$b2d8f8edec75f571);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");
const $b158ee0e69f56076$export$cd75c112ac11a83b = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $b158ee0e69f56076$export$7d25d25bed94d6e2 = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $b158ee0e69f56076$export$fda88e8e14acb615 = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $b158ee0e69f56076$export$e890e797a25e655c = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
});
const $b158ee0e69f56076$export$70208657c8d471a7 = new (0, $jkqqC.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $b158ee0e69f56076$export$b2d8f8edec75f571 = new (0, $jkqqC.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("7IK6V", function(module, exports) {
$parcel$export(module.exports, "REQUIRED", () => $e122ec4cdc64cb82$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $e122ec4cdc64cb82$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $e122ec4cdc64cb82$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $e122ec4cdc64cb82$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $e122ec4cdc64cb82$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $e122ec4cdc64cb82$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $e122ec4cdc64cb82$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $e122ec4cdc64cb82$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $e122ec4cdc64cb82$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $e122ec4cdc64cb82$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $e122ec4cdc64cb82$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $e122ec4cdc64cb82$export$8170252f0ea43511);
$parcel$export(module.exports, "SUPPORTED_MODERNISED_PROJECT_TYPES", () => $e122ec4cdc64cb82$export$91032066c893b7fc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $e122ec4cdc64cb82$export$17bcab948893a9ba = 'worklog';
const $e122ec4cdc64cb82$export$b1c05b34d317c074 = 'REQUIRED';
const $e122ec4cdc64cb82$export$f10b32dfda12e96e = 'unknown';
const $e122ec4cdc64cb82$export$e5e4b8c32e68dd0b = 'networkError';
const $e122ec4cdc64cb82$export$2d06efb8146cd043 = 'graphQLError';
const $e122ec4cdc64cb82$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $e122ec4cdc64cb82$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $e122ec4cdc64cb82$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $e122ec4cdc64cb82$export$aac4661200ba4104 = 'worklog_startDate';
const $e122ec4cdc64cb82$export$a23c32d5cf54cba0 = 'worklog_description';
const $e122ec4cdc64cb82$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $e122ec4cdc64cb82$export$63fd567c1d0aca19 = [
    ...$e122ec4cdc64cb82$export$74ab3898ae683660,
    $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f,
    $e122ec4cdc64cb82$export$cf70f9220e6a2f50,
    $e122ec4cdc64cb82$export$aac4661200ba4104,
    $e122ec4cdc64cb82$export$a23c32d5cf54cba0
];
const $e122ec4cdc64cb82$export$983715bb9b0f9b2c = {
    [$e122ec4cdc64cb82$export$17bcab948893a9ba]: $e122ec4cdc64cb82$export$63fd567c1d0aca19
};
const $e122ec4cdc64cb82$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $e122ec4cdc64cb82$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $e122ec4cdc64cb82$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $e122ec4cdc64cb82$export$8170252f0ea43511 = 'QuickCreateIssue';
const $e122ec4cdc64cb82$export$91032066c893b7fc = [
    'business',
    'software'
];

});

parcelRegister("4BBh0", function(module, exports) {
$parcel$export(module.exports, "fireTrackAnalyticsDeferred", () => $5a3d746c864ddc29$export$b6c00a2e59d74c5e);
$parcel$export(module.exports, "fireOperationalAnalyticsDeferred", () => $5a3d746c864ddc29$export$6bb7ef8f82969e8f);
$parcel$export(module.exports, "fireScreenAnalyticsDeferred", () => $5a3d746c864ddc29$export$59b89d5a711a4fa);
$parcel$export(module.exports, "MountEvent", () => $5a3d746c864ddc29$export$2c6963927dbc68f1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // code-reaper-ignore-file -- Analytics implementations for the browser.

var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");

var $io5i2 = parcelRequire("io5i2");

var $klSsw = parcelRequire("klSsw");

var $aJ81Y = parcelRequire("aJ81Y");

var $7RK6D = parcelRequire("7RK6D");

var $inMxE = parcelRequire("inMxE");


var $aZMdt = parcelRequire("aZMdt");

var $7gXAV = parcelRequire("7gXAV");

var $aqPkH = parcelRequire("aqPkH");
const $5a3d746c864ddc29$export$b6c00a2e59d74c5e = (event, ...rest)=>{
    if (false) return;
    return (0, $aJ81Y.fireTrackAnalyticsDeferred)(event, ...rest);
};
const $5a3d746c864ddc29$export$6bb7ef8f82969e8f = (event, ...rest)=>{
    if (false) return;
    return (0, $aJ81Y.fireOperationalAnalyticsDeferred)(event, ...rest);
};
const $5a3d746c864ddc29$export$59b89d5a711a4fa = (...args)=>{
    if (false) return;
    return (0, $aJ81Y.fireScreenAnalyticsDeferred)(...args);
};
const $5a3d746c864ddc29$export$2c6963927dbc68f1 = (props)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klSsw.MountEvent), {
        onMount: props.onMount
    });
    // Note: This is a workaround to avoid type errors. The type of the props is not the same as the type of the BrowserMountEvent.
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $io5i2.MountEvent), props);
};
$5a3d746c864ddc29$export$2c6963927dbc68f1.displayName = "MountEvent";
// Preserve the original displayName so snapshot tests that serialise the element tree continue to match.
$5a3d746c864ddc29$export$2c6963927dbc68f1.displayName = (0, $io5i2.MountEvent).displayName;

});
parcelRegister("io5i2", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $76dc62e6035fa733$export$2c6963927dbc68f1);
/* eslint-disable jira/filename-case */ /**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $euxye = parcelRequire("euxye");

var $kTviw = parcelRequire("kTviw");
// eslint-disable-next-line jira/react/no-class-components
class $76dc62e6035fa733$var$MountEventComponent extends (0, $euxye.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
$76dc62e6035fa733$var$MountEventComponent.displayName = "MountEventComponent";
const $76dc62e6035fa733$export$2c6963927dbc68f1 = (0, $kTviw.default)()($76dc62e6035fa733$var$MountEventComponent);

});

parcelRegister("klSsw", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $ef629069b3a57875$export$5bf35293e545f20c);
$parcel$export(module.exports, "MountEvent", () => $ef629069b3a57875$export$2c6963927dbc68f1);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aZMdt = parcelRequire("aZMdt");

const $ef629069b3a57875$var$AnalyticsContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, props.children);
$ef629069b3a57875$var$AnalyticsContext.displayName = "AnalyticsContext";
const $ef629069b3a57875$export$198470770171c65 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const data = (0, $aZMdt.extractContextualData)(props);
    // @ts-expect-error - TS2741 - Property 'children' is missing in type 'Dictionary<string | string[] | { [containerName: string]: Container; } | { [key: string]: any; } | undefined>' but required in type 'AnalyticsContextData'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ef629069b3a57875$var$AnalyticsContext, {
        data: data
    }, props.children);
});
const $ef629069b3a57875$export$64eb47d7b94ba089 = ()=>null;
const $ef629069b3a57875$export$5a67e7291fd4569e = (_props)=>null;
const $ef629069b3a57875$export$5f0d7aae8dfa8b86 = (_props)=>null;
const $ef629069b3a57875$export$b71c3ada5d4ec5da = (_props)=>null;
const $ef629069b3a57875$export$2ccf161b817b43b = (_props)=>null;
const $ef629069b3a57875$export$34ac71ce24cddec2 = (_event, _type, _payload = {})=>undefined;
const $ef629069b3a57875$export$79f423cc3fd39762 = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$6bb7ef8f82969e8f = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$6f46fb37ad7d962b = (_event, _attributes)=>undefined;
const $ef629069b3a57875$export$59b89d5a711a4fa = (_event, _attributes)=>undefined;
const $ef629069b3a57875$export$13990ad4625571ed = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$b6c00a2e59d74c5e = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$5d00cd31b1bf8e94 = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$ee2085e97a04e027 = (_event)=>({
        type: undefined,
        payload: {}
    });
class $ef629069b3a57875$var$UIAnalyticsEventServer {
    constructor(){
        this.payload = {};
        this.context = [];
        this.handlers = [];
        this.hasFired = false;
        // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
        this.clone = ()=>new $ef629069b3a57875$var$UIAnalyticsEventServer();
        // Replace with lodash/noop
        // oxlint-disable-next-line no-empty-function
        this.fire = (_channel)=>{};
        // @ts-expect-error TS2416: Property 'update' in type 'UIAnalyticsEventServer' is not assignable to the same property in base type 'UIAnalyticsEvent'. Type 'UIAnalyticsEventServer' is not assignable to type 'this'. 'UIAnalyticsEventServer' is assignable to the constraint of type 'this', but 'this' could be instantiated with a different subtype of constraint 'UIAnalyticsEventServer'.
        this.update = ()=>new $ef629069b3a57875$var$UIAnalyticsEventServer();
    }
}
$ef629069b3a57875$var$UIAnalyticsEventServer.displayName = "UIAnalyticsEventServer";
const $ef629069b3a57875$var$createAnalyticsEvent = (_payload)=>// @ts-expect-error - Type 'UIAnalyticsEventServer' is not assignable to type 'UIAnalyticsEvent'.
    new $ef629069b3a57875$var$UIAnalyticsEventServer();
const $ef629069b3a57875$export$5bf35293e545f20c = ()=>(0, $euxye.useMemo)(()=>({
            createAnalyticsEvent: $ef629069b3a57875$var$createAnalyticsEvent
        }), []);
const $ef629069b3a57875$var$withAnalyticsEvents = ()=>(WrappedComponent)=>{
        // @ts-expect-error: Argument of type '(props: Config, ref: ForwardedRef<unknown>) => Element' is not assignable to parameter of type 'ForwardRefRenderFunction<unknown, PropsWithoutRef<Config>>'.
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>// @ts-expect-error Spread types may only be created from object types.ts(2698)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
                ...props,
                ref: ref,
                createAnalyticsEvent: $ef629069b3a57875$var$createAnalyticsEvent
            }));
        WithAnalyticsEvents.displayName = 'WithAnalyticsEvents('.concat(WrappedComponent.displayName != null ? WrappedComponent.displayName : WrappedComponent.name || '', ')');
        // @ts-expect-error: Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'AbstractComponent<Config, any>'.
        return WithAnalyticsEvents;
    };
const $ef629069b3a57875$export$3e9ef96ba97ea9dc = (_componentName, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
_eventActions)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>$ef629069b3a57875$var$withAnalyticsEvents()(component);
const $ef629069b3a57875$var$MountEventComponent = ({ onMount: onMount })=>{
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    (0, $euxye.useLayoutEffect)(()=>onMount(new $ef629069b3a57875$var$UIAnalyticsEventServer()), [
        onMount
    ]);
    return null;
};
$ef629069b3a57875$var$MountEventComponent.displayName = "MountEventComponent";
const $ef629069b3a57875$export$2c6963927dbc68f1 = $ef629069b3a57875$var$withAnalyticsEvents()($ef629069b3a57875$var$MountEventComponent);

});

parcelRegister("7gXAV", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEventToProps", () => $e8dd120ad8ac5edf$export$3e9ef96ba97ea9dc);
/* eslint-disable jira/filename-case */ 
var $kTviw = parcelRequire("kTviw");
const $e8dd120ad8ac5edf$export$871de8747c9eaa88 = (props, componentName)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $e8dd120ad8ac5edf$export$3e9ef96ba97ea9dc = (componentName, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
eventActions)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $kTviw.default)($e8dd120ad8ac5edf$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});


parcelRegister("14CWj", function(module, exports) {
$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $e4153b0c47dc0bdb$export$876003a5b887f37e);
/* eslint-disable jira/filename-case */ const $e4153b0c47dc0bdb$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CREATE_FORM_FIELD_FOCUS: 'CREATE_FORM_FIELD_FOCUS',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("cIX5T", function(module, exports) {
$parcel$export(module.exports, "getGICLifeCycleEvents", () => $8858188c1840e961$export$28a4bbe8d482a171);
$parcel$export(module.exports, "useGICLifeCycleEvents", () => $8858188c1840e961$export$e3ff72f196296fcc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bJ1QP = parcelRequire("bJ1QP");
const $8858188c1840e961$var$GICLifeCycleEventsService = new (0, $bJ1QP.PubSubHub)();
const $8858188c1840e961$export$28a4bbe8d482a171 = ()=>({
        ...$8858188c1840e961$var$GICLifeCycleEventsService
    });
const $8858188c1840e961$export$e3ff72f196296fcc = ()=>({
        ...$8858188c1840e961$var$GICLifeCycleEventsService
    });

});
parcelRegister("bJ1QP", function(module, exports) {
$parcel$export(module.exports, "PubSubHub", () => $e4a83e67f7372a4a$export$e3607828f8f2c01e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $e4a83e67f7372a4a$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}
$e4a83e67f7372a4a$export$e3607828f8f2c01e.displayName = "PubSubHub";

});


parcelRegister("jwOsd", function(module, exports) {
$parcel$export(module.exports, "useSitePickerContext", () => $466537c9aa0efbb5$export$f8b5aae013e4cf77);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $466537c9aa0efbb5$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $466537c9aa0efbb5$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $466537c9aa0efbb5$export$6f57813fe9f31bf9 = (0, $5QDqc.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $466537c9aa0efbb5$export$d4c72bab9d6cc13a,
    actions: $466537c9aa0efbb5$export$e324594224ef24da
});
const $466537c9aa0efbb5$export$f8b5aae013e4cf77 = (0, $3h1FP.createHook)($466537c9aa0efbb5$export$6f57813fe9f31bf9);

});

parcelRegister("kTMHb", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CREATE_SUBMIT_BEHAVIOUR", () => $1081e3ae83892313$export$d7147f8e1d7be0e2);
/* eslint-disable jira/filename-case */ const $1081e3ae83892313$export$d7147f8e1d7be0e2 = {
    CREATE_ISSUE: 'createIssue',
    SAVE_EDITS_WITHOUT_ISSUE_CREATION: 'saveEditsWithoutIssueCreation'
};

});

parcelRegister("k2847", function(module, exports) {
$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $340b537aa60cae02$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $340b537aa60cae02$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $340b537aa60cae02$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $340b537aa60cae02$export$720579602bb055a2);
$parcel$export(module.exports, "shouldTriggerModernisedIssueCreate", () => $340b537aa60cae02$export$68a6f9b6b3dd1f1e);
$parcel$export(module.exports, "shouldForceExpandedIssueCreateModal", () => $340b537aa60cae02$export$5a45eebd3613eefc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $VoOhq = parcelRequire("VoOhq");

var $jaJSD = parcelRequire("jaJSD");

var $6GOOT = parcelRequire("6GOOT");

var $eJ8Fl = parcelRequire("eJ8Fl");

var $2700E = parcelRequire("2700E");

var $1OTgk = parcelRequire("1OTgk");

var $i860n = parcelRequire("i860n");
const $340b537aa60cae02$export$550b19803bc962ec = (isSubsequentLoad, isModernisedTrigger = false)=>{
    (0, $jaJSD.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $6GOOT.globalIssueCreateModalLoadSubsequent) : (0, $6GOOT.globalIssueCreateModalLoad);
    if (isSubsequentLoad) {
        if (!(isModernisedTrigger && (0, $i860n.fg)('nike_united_fix_ufo_error'))) (0, $VoOhq.default)('global-issue.create-modal-subsequent');
    } else if (!(isModernisedTrigger && (0, $i860n.fg)('nike_united_fix_ufo_error'))) (0, $VoOhq.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $eJ8Fl.startGlobalIssueCreateTTIWithAdjustments)();
};
const $340b537aa60cae02$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $340b537aa60cae02$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $340b537aa60cae02$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};
const $340b537aa60cae02$export$11ffbb568e7def20 = [
    (0, $1OTgk.GENERIC_KEYBOARD_SHORTCUT),
    (0, $1OTgk.GENERIC_GLOBAL_CREATE_BUTTON),
    (0, $1OTgk.ISSUE_VIEW_CREATE_LINKED_ISSUE),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_SUBTASK),
    (0, $1OTgk.CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW)
];
const $340b537aa60cae02$var$TRIGGER_POINTS_USING_MODERNISED_MODAL_GA = [
    (0, $1OTgk.JIRA_ISSUE_TABLE_TRIGGER),
    (0, $1OTgk.JWM_INLINE_CREATE),
    (0, $1OTgk.BOARD_CREATE),
    (0, $1OTgk.JSW_ADAPTED_GLOBAL_ISSUE_CREATE),
    (0, $1OTgk.JSW_ROADMAP_CREATE_ISSUE),
    (0, $1OTgk.JSW_CREATE_EPIC_ISSUE),
    (0, $1OTgk.CREATE_SUBTASK_NIN_TRIGGER),
    (0, $1OTgk.UC_ATLASSIAN_HOME_CREATE_ISSUE)
];
const $340b537aa60cae02$export$84ac0b8f99923a16 = [
    (0, $1OTgk.ISSUE_VIEW_CREATE_LINKED_ISSUE),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_SUBTASK)
];
const $340b537aa60cae02$export$68a6f9b6b3dd1f1e = (triggerPointKey)=>{
    return (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false) && ($340b537aa60cae02$export$11ffbb568e7def20.includes(triggerPointKey) || $340b537aa60cae02$var$TRIGGER_POINTS_USING_MODERNISED_MODAL_GA.includes(triggerPointKey) && (0, $i860n.fg)('include_trigger_points_for_create_modernization'));
};
const $340b537aa60cae02$export$5a45eebd3613eefc = (triggerPointKey)=>{
    return (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false) && $340b537aa60cae02$export$84ac0b8f99923a16.includes(triggerPointKey);
};

});
parcelRegister("6GOOT", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $99ad8571c112a80a$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $99ad8571c112a80a$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $99ad8571c112a80a$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $99ad8571c112a80a$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $99ad8571c112a80a$export$c1592e4d8d98963e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvGCa = parcelRequire("jvGCa");
const $99ad8571c112a80a$export$5a01a7fa84b239c8 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $99ad8571c112a80a$export$c50ad3c31b6fcfc6 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $99ad8571c112a80a$export$4b2382574525bb0f = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $99ad8571c112a80a$export$7839bdaa2f6a2385 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $99ad8571c112a80a$export$c1592e4d8d98963e = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("eJ8Fl", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $ce28ce5101a62053$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $ce28ce5101a62053$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $ce28ce5101a62053$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $ce28ce5101a62053$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $ce28ce5101a62053$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $ce28ce5101a62053$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $ce28ce5101a62053$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $ce28ce5101a62053$export$d86f4868694f2aa7);
/* eslint-disable jira/filename-case */ /**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @jira/issue-create__use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @jira/issue-create__use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $jvGCa = parcelRequire("jvGCa");
const $ce28ce5101a62053$export$9f3d6f17e1da7874 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $ce28ce5101a62053$export$457c9fb71ad5b3a9 = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.start();
};
const $ce28ce5101a62053$export$ef664dac649a716c = ()=>$ce28ce5101a62053$export$9f3d6f17e1da7874.mark('gic-tti');
const $ce28ce5101a62053$export$30ca4c461fab486c = (customData)=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $ce28ce5101a62053$export$27f2445288b528c = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.cancel();
};
const $ce28ce5101a62053$export$7a2709fc1e33401a = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $ce28ce5101a62053$export$cf3893335c93e33b = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $ce28ce5101a62053$export$d86f4868694f2aa7 = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});




parcelRegister("bIvch", function(module, exports) {
$parcel$export(module.exports, "Projects", () => $63324212e64cb5b6$export$ca6fbb51b35e375c);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5u9Wt = parcelRequire("5u9Wt");

var $4Kt0R = parcelRequire("4Kt0R");

var $kg1ox = parcelRequire("kg1ox");

var $gRWK8 = parcelRequire("gRWK8");
const $63324212e64cb5b6$export$90cfe4f15bb50f58 = ({ open: open, close: close, setOnCloseCallback: setOnCloseCallback })=>{
    const [{ canCreateClassicProject: canCreateClassicProject }] = (0, $kg1ox.useCreateProjectPermission)();
    (0, $euxye.useEffect)(()=>{
        open && // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        open({
            source: 'navigationNext',
            isNextGen: !canCreateClassicProject
        });
        setOnCloseCallback && setOnCloseCallback(close);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    return null;
};
$63324212e64cb5b6$export$90cfe4f15bb50f58.displayName = "ProjectCreateDrawerOpener";
const $63324212e64cb5b6$export$ca6fbb51b35e375c = ()=>{
    const [isProjectCreateDrawerOpen, { off: closeProjectCreateDrawer }] = (0, $gRWK8.useSwitchModals)((0, $4Kt0R.MODAL_ID).PROJECT_CREATE);
    if (!isProjectCreateDrawerOpen) return null;
    // ProjectCreateDrawerProvider is in page container/navigaiton
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5u9Wt.ProjectCreateDrawerConsumer), null, ({ methods: { open: open, setOnCloseCallback: setOnCloseCallback } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($63324212e64cb5b6$export$90cfe4f15bb50f58, {
            open: open,
            close: closeProjectCreateDrawer,
            setOnCloseCallback: setOnCloseCallback
        }));
};
$63324212e64cb5b6$export$ca6fbb51b35e375c.displayName = "Projects";

});
parcelRegister("kg1ox", function(module, exports) {
$parcel$export(module.exports, "useCreateProjectPermission", () => $c708bd44a0c0f3c7$export$c92733e8f8c1640f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $hBQGi = parcelRequire("hBQGi");
const $c708bd44a0c0f3c7$var$Store = (0, $5QDqc.createStore)({
    name: 'create-project-permissions',
    initialState: {
        canCreateProject: false,
        shouldDisplayCreateProject: false,
        canCreateClassicProject: false,
        canCreateNextGenProject: false,
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $hBQGi.actions
});
const $c708bd44a0c0f3c7$export$5a47fbae725b8f2 = // oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
(0, $dB6ay.createContainer)($c708bd44a0c0f3c7$var$Store);
const $c708bd44a0c0f3c7$export$c92733e8f8c1640f = (0, $3h1FP.createHook)($c708bd44a0c0f3c7$var$Store);
const $c708bd44a0c0f3c7$export$d2b8d6f60fe99e2a = (0, $3h1FP.createHook)($c708bd44a0c0f3c7$var$Store, {
    selector: null
});

});
parcelRegister("hBQGi", function(module, exports) {
$parcel$export(module.exports, "actions", () => $ae878b06c8d6a5c0$export$e324594224ef24da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");
const $ae878b06c8d6a5c0$export$963556ef97965f0b = async ()=>{
    const url = '/rest/internal/2/projectpermissions';
    const result = await (0, $4fhEY.default)(url);
    return result;
};
const $ae878b06c8d6a5c0$var$handleFetch = ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            const result = await $ae878b06c8d6a5c0$export$963556ef97965f0b();
            setState({
                ...result,
                isFetching: false,
                fetchError: null,
                hasFetchedOnce: true,
                hasSuccessOnce: true
            });
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                canCreateProject: false,
                canCreateClassicProject: false,
                canCreateNextGenProject: false,
                isFetching: false,
                fetchError: error,
                hasFetchedOnce: true
            });
        }
    };
const $ae878b06c8d6a5c0$export$e324594224ef24da = {
    fetchCreateProjectPermission: ()=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($ae878b06c8d6a5c0$var$handleFetch());
            setState({
                isFetching: true,
                promise: // @ts-expect-error - TS2322 - Type 'Promise<void>' is not assignable to type 'Promise<undefined>'.
                promise
            });
        }
};

});




parcelRegister("jtFTj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("uaMaD").then(()=>parcelRequire('lzO0d'));

});

parcelRegister("gbfjL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f866F").then(()=>parcelRequire('dGAt7'));

});

parcelRegister("7si8q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eVaIe").then(()=>parcelRequire('gTaYo'));

});

parcelRegister("eHwfl", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7o3A9").then(()=>parcelRequire('5XcNi'));

});

parcelRegister("2d39V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ht2ju").then(()=>parcelRequire('99xwW'));

});

parcelRegister("l7BEG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3z80A").then(()=>parcelRequire('6Rqeb'));

});


parcelRegister("eaylF", function(module, exports) {
$parcel$export(module.exports, "getSystemNavigationPaths", () => $b3cd5194a477639c$export$76c5f80c8d9bdb0e);
$parcel$export(module.exports, "isSystemNavPath", () => $b3cd5194a477639c$export$3e53a29d6e499ec4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $i860n = parcelRequire("i860n");
const $b3cd5194a477639c$var$SYSTEM_NAVIGATION_PATHS = {
    generalConfiguration: '/jira/settings/system/general-configuration',
    darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
    issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
    globalAutomation: '/jira/settings/automation',
    // troubleshooting
    troubleshootingAuditLog: '/auditing/view',
    troubleshootingAuditLogV2: '/jira/settings/system/audit-logs',
    troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
    troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
    troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
    troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
    troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
    troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
    troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
    // security
    securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
    securityGlobalPermissions: '/secure/admin/GlobalPermissions!default.jspa',
    // user interface
    userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
    userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
    userInterfacesLookAndFeel: '/jira/settings/system/ui/look-and-feel',
    userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
    userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
    // import and export
    importSectionBackupManager: '/secure/admin/CloudExport.jspa',
    importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
    importSectionExternalImportNew: '/jira/settings/system/external-import',
    importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
    importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
    // mail
    mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
    mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
    mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
    mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
    // admin
    adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
    adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
    // shared
    sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
    sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
    // advanced
    advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
    advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
    advancedSectionWebHooks: '/plugins/servlet/webhooks',
    advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
    advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
};
const $b3cd5194a477639c$var$getSystemNavigationPathsInternal = ()=>{
    return {
        ...$b3cd5194a477639c$var$SYSTEM_NAVIGATION_PATHS,
        securityGlobalPermissions: (0, $i860n.fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : $b3cd5194a477639c$var$SYSTEM_NAVIGATION_PATHS.securityGlobalPermissions,
        troubleshootingAuditLog: (0, $i860n.fg)('jira_frontend_eal_admin_audit_log') ? $b3cd5194a477639c$var$SYSTEM_NAVIGATION_PATHS.troubleshootingAuditLogV2 : $b3cd5194a477639c$var$SYSTEM_NAVIGATION_PATHS.troubleshootingAuditLog
    };
};
const $b3cd5194a477639c$export$76c5f80c8d9bdb0e = (0, $emCaV.default)($b3cd5194a477639c$var$getSystemNavigationPathsInternal);
const $b3cd5194a477639c$var$getSystemNavPaths = ()=>{
    return [
        '/jira/settings/system/general-configuration',
        '/secure/admin/SiteDarkFeatures',
        '/secure/admin/ViewGlobalCollectors',
        '/jira/settings/automation',
        '/auditing/view',
        '/jira/settings/system/audit-logs',
        '/secure/project/ViewProjectRoles',
        '/secure/admin/global-permissions',
        '/secure/admin/GlobalPermissions',
        '/secure/admin/ViewUserDefaultSettings',
        '/secure/admin/EditDefaultDashboard',
        '/secure/admin/LookAndFeel',
        '/jira/settings/system/ui/announcement-banner',
        '/secure/admin/CloudExport',
        '/jira/settings/system/external-import',
        '/secure/admin/CloudImport',
        '/secure/admin/GlobalMailSettings',
        '/secure/admin/global-mail-settings',
        '/secure/admin/OutgoingMailServers',
        '/secure/admin/IncomingMailServers',
        '/secure/admin/SendBulkMail',
        '/secure/admin/PermissionHelperAdmin',
        '/jira/settings/system/notification-logs',
        '/secure/admin/filters/ViewSharedFilters',
        '/secure/admin/dashboards/ViewSharedDashboards',
        '/secure/admin/ViewAttachmentSettings',
        '/secure/admin/ListEventTypes',
        '/plugins/servlet/webhooks',
        '/secure/GHLexoRankManage'
    ];
};
const $b3cd5194a477639c$export$3e53a29d6e499ec4 = (path)=>{
    const paths = $b3cd5194a477639c$var$getSystemNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("esaVU", function(module, exports) {
$parcel$export(module.exports, "getIssuesNavigationPaths", () => $fc3139b703ff01a0$export$a33a4d7b083ee85);
$parcel$export(module.exports, "isIssuesNavPath", () => $fc3139b703ff01a0$export$f38c22a081278057);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $fc3139b703ff01a0$export$a33a4d7b083ee85 = ()=>({
        // Features
        newIssueSearchTransition: '/jira/settings/issues/new-issue-search-transition',
        timeTrackingItem: '/secure/admin/TimeTrackingAdmin.jspa',
        issueLinkingItem: '/secure/admin/ViewLinkTypes!default.jspa',
        // IssueTypes
        issueTypesHierarchyItem: '/jira/settings/issues/issue-hierarchy',
        issueTypesItem: '/jira/settings/issues/issue-types',
        issueTypeSchemesItem: '/jira/settings/issues/issue-type-schemes',
        issueTypesSubTasksItem: '/secure/admin/subtasks/ManageSubTasks.jspa',
        // Workflows
        workflowsItem: '/jira/settings/issues/workflows',
        workflowSchemesItem: '/secure/admin/ViewWorkflowSchemes.jspa',
        // Screens
        screensItem: '/jira/settings/issues/screens',
        screenSchemesItem: '/jira/settings/issues/screen-schemes',
        screensIssueTypeScreenSchemesMenu: '/jira/settings/issues/issue-type-screen-schemes',
        // Fields
        fieldsManagement: '/jira/settings/issues/fields',
        customFieldsItem: '/secure/admin/ViewCustomFields.jspa',
        fieldConfigurationsItem: '/secure/admin/ViewFieldLayouts.jspa',
        fieldConfigurationSchemes: '/secure/admin/ViewFieldLayoutSchemes.jspa',
        fieldSchemes: '/jira/settings/issues/field-schemes',
        // Priorities
        prioritiesItem: '/jira/settings/issues/priorities',
        prioritySchemesItem: '/jira/settings/issues/priority-schemes',
        // Forms
        dataConnectionsItem: '/jira/settings/forms/data-connections',
        // IssueAttributes
        statusesItem: '/secure/admin/ViewStatuses.jspa',
        resolutionsItem: '/secure/admin/ViewResolutions.jspa',
        issueSecuritySchemesItem: '/secure/admin/ViewIssueSecuritySchemes.jspa',
        notificationSchemesItem: '/secure/admin/ViewNotificationSchemes.jspa',
        permissionSchemesItem: '/secure/admin/ViewPermissionSchemes.jspa'
    });
const $fc3139b703ff01a0$var$getIssuesNavPaths = ()=>{
    return [
        '/jira/settings/issues/new-issue-search-transition',
        '/secure/admin/TimeTrackingAdmin',
        '/secure/admin/ViewLinkTypes',
        '/jira/settings/issues/issue-hierarchy',
        '/jira/settings/issues/issue-types',
        '/jira/settings/issues/issue-type-schemes',
        '/secure/admin/subtasks/ManageSubTasks',
        '/jira/settings/issues/workflows',
        '/secure/admin/ViewWorkflowSchemes',
        '/jira/settings/issues/screens',
        '/jira/settings/issues/screen-schemes',
        '/jira/settings/issues/issue-type-screen-schemes',
        '/jira/settings/issues/fields',
        '/jira/settings/issues/field-schemes',
        '/secure/admin/ViewCustomFields',
        '/secure/admin/ViewFieldLayouts',
        '/secure/admin/ViewFieldLayoutSchemes',
        '/jira/settings/issues/priorities',
        '/jira/settings/issues/priority-schemes',
        '/secure/admin/ViewStatuses',
        '/secure/admin/ViewResolutions',
        '/secure/admin/ViewIssueSecuritySchemes',
        '/secure/admin/ViewNotificationSchemes',
        '/secure/admin/ViewPermissionSchemes'
    ];
};
const $fc3139b703ff01a0$export$f38c22a081278057 = (path)=>{
    const paths = $fc3139b703ff01a0$var$getIssuesNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("jxXMl", function(module, exports) {
$parcel$export(module.exports, "JiraTopBannerPlacement", () => $160415cabf42522e$export$2a9156f5c2a2410e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ilUGT = parcelRequire("ilUGT");

var $h8QGu = parcelRequire("h8QGu");

var $35eqr = parcelRequire("35eqr");

var $i860n = parcelRequire("i860n");

var $kWzqm = parcelRequire("kWzqm");

var $bxVe8 = parcelRequire("bxVe8");

var $k11SN = parcelRequire("k11SN");

var $czLPq = parcelRequire("czLPq");
const $160415cabf42522e$var$PLACEMENT_ID = 'jira-top-banner';
const $160415cabf42522e$var$TopBannerPlacement = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "topBannerPlacement",
        packageName: "top-banner-placement",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kWzqm.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-testid": "top-banner-placement.jira-top-banner-placement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bxVe8.PlacementFetchProvider), {
        resource: (0, $35eqr.postOfficeJiraTopBannerResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $czLPq.default), {
        placementId: $160415cabf42522e$var$PLACEMENT_ID,
        // Post Office and Jira uses different versions of react-error-boundary - https://atlassian.slack.com/archives/CL6HC337Z/p1741218999095929
        // oxlint-disable-next-line typescript/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $ilUGT.default)
    })))));
};
$160415cabf42522e$var$TopBannerPlacement.displayName = "TopBannerPlacement";
const $160415cabf42522e$export$2a9156f5c2a2410e = /*#__PURE__*/ (0, $euxye.memo)(()=>{
    if (!(0, $k11SN.default)('killswitch_post_office_in_jira') && (0, $i860n.fg)('jira-issue-term-refresh-banner')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($160415cabf42522e$var$TopBannerPlacement, null);
    return null;
});

});
parcelRegister("ilUGT", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d21bb3ffdaf749d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $lHZq9 = parcelRequire("lHZq9");

var $7Cbbq = parcelRequire("7Cbbq");

var $1Pg8F = parcelRequire("1Pg8F");

var $euxye = parcelRequire("euxye");

var $6PXON = parcelRequire("6PXON");


var $fuhiX = parcelRequire("fuhiX");
const $2d21bb3ffdaf749d$export$a4ee24848b29490b = (0, $fuhiX.withJiraTopBannerIntlProvider)((0, $7Cbbq.createPlacementComponent)((0, $22162b3f81dcfc6c$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
    const { data: data, isLoading: isLoading } = (0, $1Pg8F.useInitialData)(initialData);
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents, @typescript-eslint/no-unsafe-assignment
    const [{ message: message, status: status }, setMessageState] = (0, $euxye.useState)({
        message: undefined,
        status: 'loading'
    });
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $lHZq9.useMessagePlacementHooks)();
    const handleDismiss = (0, $euxye.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
    }, []);
    (0, $euxye.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss,
        handleDismiss
    ]);
    (0, $euxye.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked,
        handleDismiss
    ]);
    (0, $euxye.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze,
        handleDismiss
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isLoading) {
            const newMessage = data?.messages[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
        }
    }, [
        data,
        isLoading
    ]);
    if (isLoading || status === 'loading') return null;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return message && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6PXON.MessageRenderer), {
        ...message,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        messageInstanceId: message.messageInstanceId
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
var $2d21bb3ffdaf749d$export$2e2bcd8739ae039 = $2d21bb3ffdaf749d$export$a4ee24848b29490b;

});
parcelRegister("6PXON", function(module, exports) {
$parcel$export(module.exports, "MessageRenderer", () => $6d9c61e070fee08c$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $eAA3f = parcelRequire("eAA3f");

var $eh6HP = parcelRequire("eh6HP");

var $jfh9i = parcelRequire("jfh9i");
const $6d9c61e070fee08c$export$e30378e28ad3e6ab = {
    'jira-ipm-issue-to-work-top-banner': (0, $eh6HP.default),
    'message-template-template': (0, $jfh9i.default)
};
const $6d9c61e070fee08c$var$messageRenderer = (0, $eAA3f.asMessageRenderer)($6d9c61e070fee08c$export$e30378e28ad3e6ab, 'jira-top-banner');
const $6d9c61e070fee08c$export$bce4e5106d86e473 = $6d9c61e070fee08c$var$messageRenderer.initializeMessageRenderer;
const $6d9c61e070fee08c$export$2df1250b8f917a59 = $6d9c61e070fee08c$var$messageRenderer.MessageRenderer;

});
parcelRegister("eh6HP", function(module, exports) {
$parcel$export(module.exports, "default", () => $362ddf93e1e01673$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $kRoBF = parcelRequire("kRoBF");

var $jeB6w = parcelRequire("jeB6w");
const $362ddf93e1e01673$export$b3890eb0ae9dca99 = (0, $jeB6w.createRender)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $kRoBF.TopBannerMessage), {}));
var $362ddf93e1e01673$export$2e2bcd8739ae039 = $362ddf93e1e01673$export$b3890eb0ae9dca99;

});
parcelRegister("kRoBF", function(module, exports) {
$parcel$export(module.exports, "TopBannerMessage", () => $cfc05b7f3914cedb$export$71f678cc6412ce95);
/* top-banner-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $i68tN = parcelRequire("i68tN");

var $9MWap = parcelRequire("9MWap");
var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $6mEZn = parcelRequire("6mEZn");
var $8Sdzy = parcelRequire("8Sdzy");

var $iKPvC = parcelRequire("iKPvC");

var $kdOoc = parcelRequire("kdOoc");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");
const $cfc05b7f3914cedb$var$styles = {
    pressable: "_4bfu18uv _1hms8stv _ajmmnqa1 _syaz15cr _80omtlke _9oik18uv _1bnx8stv _jf4cnqa1 _30l315cr _1nrm18uv _c2waglyw _1iohnqa1",
    onClickBackgroundColor: "_bfhk1aqn"
};
const $cfc05b7f3914cedb$var$ComingSoonMessage = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        id: "post-office.placement.jira-top-banner.primary-message",
        description: "Coming soon message for the Jira top banner",
        defaultMessage: "As we roll out 'work' as the new term for items tracked in Jira, you may still see 'issue' in some areas."
    });
$cfc05b7f3914cedb$var$ComingSoonMessage.displayName = "ComingSoonMessage";
const $cfc05b7f3914cedb$var$ReadMoreLink = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.default), {
        href: "https://community.atlassian.com/t5/Jira-articles/It-s-here-Work-is-the-new-collective-term-for-all-items-you/ba-p/2954892",
        rel: "noopener noreferrer",
        target: "_blank",
        xcss: $cfc05b7f3914cedb$var$styles.pressable,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            id: "st-office.placement.jira-top-banner.primary-cta-text",
            description: "Read more link for the Jira top banner",
            defaultMessage: "Read about this terminology change"
        })
    });
$cfc05b7f3914cedb$var$ReadMoreLink.displayName = "ReadMoreLink";
const $cfc05b7f3914cedb$export$71f678cc6412ce95 = ()=>{
    const { messageDismissed: messageDismissed } = (0, $kdOoc.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $iKPvC.useMessageInstanceEvent)();
    const onClickDismiss = (0, $euxye.useCallback)(()=>{
        messageDismissed();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
    }, [
        messageDismissed,
        messageInstanceClicked
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        backgroundColor: "color.background.neutral.bold",
        padding: "space.200",
        testId: "jira-top-banner",
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8Sdzy.default), {
                    color: "color.text.inverse",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)($cfc05b7f3914cedb$var$ComingSoonMessage, {}),
                        "\xa0",
                        /*#__PURE__*/ (0, $e79Pd.jsx)($cfc05b7f3914cedb$var$ReadMoreLink, {})
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
                    xcss: $cfc05b7f3914cedb$var$styles.onClickBackgroundColor,
                    onClick: onClickDismiss,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
                        color: "var(--ds-text-inverse, #FFFFFF)",
                        label: "Dismiss"
                    })
                })
            ]
        })
    });
};
$cfc05b7f3914cedb$export$71f678cc6412ce95.displayName = "TopBannerMessage";

});

parcelRegister("jeB6w", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $f2c9031ac7ee4e44$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Pipe type variance issue with AnyPlacementPipe constraint (JiraTopBanner uses Record<string, never> for PlacementContext)
const $f2c9031ac7ee4e44$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $f2c9031ac7ee4e44$export$78c758434c34d601 = $f2c9031ac7ee4e44$var$clientPipeline.createRender;
const $f2c9031ac7ee4e44$export$2859a83e4d6da57d = $f2c9031ac7ee4e44$var$clientPipeline.createValidate;
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Pipe type variance issue with AnyPlacementPipe constraint (JiraTopBanner uses Record<string, never> for PlacementContext)
const $f2c9031ac7ee4e44$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $f2c9031ac7ee4e44$export$c905bc718befd59b = $f2c9031ac7ee4e44$var$serverPipeline.createHydrate;
const $f2c9031ac7ee4e44$export$1f41223e5b0a6622 = $f2c9031ac7ee4e44$var$serverPipeline.createHydrateExample;
const $f2c9031ac7ee4e44$export$88fe13b4d13f8423 = $f2c9031ac7ee4e44$var$serverPipeline.createTransformMetadata;

});
parcelRegister("k8v9N", function(module, exports) {
$parcel$export(module.exports, "createServerPipeline", () => $5ac4405859994226$export$b8fedcd4634de5cd);
$parcel$export(module.exports, "createClientPipeline", () => $5ac4405859994226$export$7d57dbe7f7617174);

var $e79Pd = parcelRequire("e79Pd");

var $6JBQt = parcelRequire("6JBQt");
const $5ac4405859994226$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            if (rendered === null) return null;
            return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6JBQt.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $5ac4405859994226$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $5ac4405859994226$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $5ac4405859994226$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $5ac4405859994226$export$803c53721d530406 = ()=>(hydrateExample, config)=>$5ac4405859994226$var$exampleHydrator(hydrateExample, config);
const $5ac4405859994226$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $5ac4405859994226$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $5ac4405859994226$export$62864968b8b09cdf(),
        createHydrateExample: $5ac4405859994226$export$803c53721d530406(),
        createTransformMetadata: $5ac4405859994226$export$b4a84c754a962eee()
    });
const $5ac4405859994226$export$7d57dbe7f7617174 = ()=>({
        createValidate: $5ac4405859994226$var$initializeValidate(),
        createRender: $5ac4405859994226$export$7693b71d48f1bf7e()
    });

});



parcelRegister("jfh9i", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a5fb9c921391a41$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $kRoBF = parcelRequire("kRoBF");
parcelRequire("euxye");

var $fYLAV = parcelRequire("fYLAV");
const $7a5fb9c921391a41$export$b3890eb0ae9dca99 = (0, $fYLAV.createRender)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $kRoBF.TopBannerMessage), {}));
var $7a5fb9c921391a41$export$2e2bcd8739ae039 = $7a5fb9c921391a41$export$b3890eb0ae9dca99;

});
parcelRegister("fYLAV", function(module, exports) {
$parcel$export(module.exports, "createRender", () => $6fddef671318eaba$export$78c758434c34d601);

var $k8v9N = parcelRequire("k8v9N");
const $6fddef671318eaba$var$clientPipeline = (0, $k8v9N.createClientPipeline)();
const $6fddef671318eaba$export$78c758434c34d601 = $6fddef671318eaba$var$clientPipeline.createRender;
const $6fddef671318eaba$export$2859a83e4d6da57d = $6fddef671318eaba$var$clientPipeline.createValidate;
const $6fddef671318eaba$var$serverPipeline = (0, $k8v9N.createServerPipeline)();
const $6fddef671318eaba$export$c905bc718befd59b = $6fddef671318eaba$var$serverPipeline.createHydrate;
const $6fddef671318eaba$export$1f41223e5b0a6622 = $6fddef671318eaba$var$serverPipeline.createHydrateExample;
const $6fddef671318eaba$export$88fe13b4d13f8423 = $6fddef671318eaba$var$serverPipeline.createTransformMetadata;

});



/* GeneratedContentHash: 90a7d45c313eaf24d28f3e71b65ecf55df9e4f5806226e92484289f49713e5bf */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $22162b3f81dcfc6c$export$a5cfae247d8360ef = 'jira-top-banner';

parcelRegister("fuhiX", function(module, exports) {
$parcel$export(module.exports, "withJiraTopBannerIntlProvider", () => $5a9a621b1d0a3f2d$export$2a49ebed7015cea4);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $icNTy = parcelRequire("icNTy");

var $8cuyX = parcelRequire("8cuyX");

var $28RSh = parcelRequire("28RSh");
const $5a9a621b1d0a3f2d$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $8cuyX.messagesLoader)(locale),
        (0, $28RSh.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $5a9a621b1d0a3f2d$export$2a49ebed7015cea4 = (Component)=>{
    return (0, $icNTy.withIntlProvider)({
        messagesLoader: $5a9a621b1d0a3f2d$export$d5a462ce7bd04520
    }, Component);
};

});


parcelRegister("bxVe8", function(module, exports) {
$parcel$export(module.exports, "PlacementFetchProvider", () => $d9813fbd6047384a$export$9be10e5cc29463c9);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $hDw0T = parcelRequire("hDw0T");

var $cr9yX = parcelRequire("cr9yX");
const $d9813fbd6047384a$export$9be10e5cc29463c9 = ({ children: children, resource: resource })=>{
    const fetch = (0, $cr9yX.usePlacementSSRFetch)(resource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hDw0T.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
$d9813fbd6047384a$export$9be10e5cc29463c9.displayName = "PlacementFetchProvider";

});


parcelRegister("euJ2W", function(module, exports) {
$parcel$export(module.exports, "PreviewPanel", () => $97a0791f2d784e6f$export$9520f072db304aa0);

var $3rR8c = parcelRequire("3rR8c");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");

var $4MYRQ = parcelRequire("4MYRQ");

var $6MMSf = parcelRequire("6MMSf");

var $5IRCU = parcelRequire("5IRCU");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $htsFl = parcelRequire("htsFl");

var $fjAPO = parcelRequire("fjAPO");

var $7Sa0x = parcelRequire("7Sa0x");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");

var $a8EUd = parcelRequire("a8EUd");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $2sD7o = parcelRequire("2sD7o");
const $97a0791f2d784e6f$var$previewPanelSplitterLabel = (0, $7eNDO.defineMessage)({
    id: "page-container-v2.common.preview-panel.preview-panel-splitter-label",
    defaultMessage: "Resize preview panel"
});
const $97a0791f2d784e6f$var$styles = {
    clickCapture: "_1e0c1bgi"
};
const $97a0791f2d784e6f$var$MaybeMarkPreviewPanelClick = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jivtech-1920-back-navigation-gpp'), ({ children: children })=>{
    const { markPreviewPanelClick: markPreviewPanelClick } = (0, $2sD7o.useIssuePreviewPanelsNavigation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        onClickCapture: markPreviewPanelClick,
        className: (0, $4jQY2.default)([
            $97a0791f2d784e6f$var$styles.clickCapture
        ])
    }, children);
}, ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children));
const $97a0791f2d784e6f$var$PreviewPanelInternal = ({ queryReference: queryReference })=>{
    const panel = (0, $5IRCU.useCurrentPreviewPanel)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [, { setPreviewPanelState: setPreviewPanelState }] = (0, $7Sa0x.useLayoutStoreActions)();
    const [useLocalWidth, setUseLocalWidth] = (0, $euxye.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const onResizeEnd = (0, $euxye.useCallback)(({ initialWidth: initialWidth, finalWidth: finalWidth })=>{
        panel?.setWidth?.(finalWidth);
        setPreviewPanelState({
            width: finalWidth
        });
        setUseLocalWidth(true);
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'preview-panel resized', {
            panelId: panel?.id,
            panelType: panel?.type,
            initialWidth: initialWidth,
            finalWidth: finalWidth
        });
    }, [
        panel,
        setPreviewPanelState,
        createAnalyticsEvent
    ]);
    const data = (0, $n67Vb.usePreloadedQuery)((0, $3rR8c.default), queryReference);
    (0, $euxye.useLayoutEffect)(()=>{
        const widthFromQuery = data?.jira?.navigationUIState?.previewPanel?.width ?? null;
        if (panel && !useLocalWidth && widthFromQuery != null) panel.setWidth?.(widthFromQuery);
    }, [
        panel,
        useLocalWidth,
        data?.jira?.navigationUIState?.previewPanel?.width
    ]);
    if (panel === null) return null;
    const { content: PanelContent } = panel;
    const previewPanelWidth = useLocalWidth ? panel?.width : data?.jira?.navigationUIState?.previewPanel?.width ?? panel?.width;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.RightPanel), {
        width: previewPanelWidth,
        testId: "preview-panels.preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($97a0791f2d784e6f$var$MaybeMarkPreviewPanelClick, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(PanelContent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4MYRQ.PanelSplitter), {
        label: formatMessage($97a0791f2d784e6f$var$previewPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "preview-panels.panel-splitter"
    }));
};
$97a0791f2d784e6f$var$PreviewPanelInternal.displayName = "PreviewPanelInternal";
const $97a0791f2d784e6f$var$PreviewPanelWithoutWidthPersistance = ()=>{
    const panel = (0, $5IRCU.useCurrentPreviewPanel)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const onResizeEnd = (0, $euxye.useCallback)(({ initialWidth: initialWidth, finalWidth: finalWidth })=>{
        panel?.setWidth?.(finalWidth);
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'preview-panel resized', {
            panelId: panel?.id,
            panelType: panel?.type,
            initialWidth: initialWidth,
            finalWidth: finalWidth
        });
    }, [
        panel,
        createAnalyticsEvent
    ]);
    if (panel === null) return null;
    const { content: PanelContent } = panel;
    const previewPanelWidth = panel?.width;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.RightPanel), {
        width: previewPanelWidth,
        testId: "preview-panels.preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(PanelContent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4MYRQ.PanelSplitter), {
        label: formatMessage($97a0791f2d784e6f$var$previewPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "preview-panels.panel-splitter"
    }));
};
$97a0791f2d784e6f$var$PreviewPanelWithoutWidthPersistance.displayName = "PreviewPanelWithoutWidthPersistance";
const $97a0791f2d784e6f$var$PreviewPanelFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($97a0791f2d784e6f$var$PreviewPanelWithoutWidthPersistance, null);
$97a0791f2d784e6f$var$PreviewPanelFallback.displayName = "PreviewPanelFallback";
const $97a0791f2d784e6f$export$9520f072db304aa0 = ()=>{
    const { queryReference: queryReference } = (0, $htsFl.useRelayResource)((0, $fjAPO.previewPanelStateResource));
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "preview-panel-width-query",
        packageName: "preview-panels",
        teamName: "Gryffindor",
        fallback: $97a0791f2d784e6f$var$PreviewPanelFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "preview-panel-width-query",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($97a0791f2d784e6f$var$PreviewPanelFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($97a0791f2d784e6f$var$PreviewPanelInternal, {
        queryReference: queryReference
    })));
};
$97a0791f2d784e6f$export$9520f072db304aa0.displayName = "PreviewPanel";

});
parcelRegister("2sD7o", function(module, exports) {
$parcel$export(module.exports, "useIssuePreviewPanelsNavigation", () => $f692e37a2249e19b$export$6ca2ef627a7293f);

var $euxye = parcelRequire("euxye");

var $6ZLJT = parcelRequire("6ZLJT");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $2s1Bd = parcelRequire("2s1Bd");
const $f692e37a2249e19b$export$6ca2ef627a7293f = (0, $6ZLJT.functionWithCondition)(()=>(0, $2700E.expVal)('nin_issue_preview_panel_navigation', 'isEnabled', false) || (0, $i860n.fg)('jivtech-1920-back-navigation-gpp'), ()=>(0, $euxye.useContext)((0, $2s1Bd.JiraPreviewPanelsNavigationContext)), ()=>(0, $2s1Bd.defaultContext));

});


parcelRegister("jWGbu", function(module, exports) {
$parcel$export(module.exports, "BannerContent", () => $90b0ce6fa7ac12e1$export$1c91e5dc5ea848c6);

var $empzH = parcelRequire("empzH");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");


var $8FgPK = parcelRequire("8FgPK");

var $i860n = parcelRequire("i860n");


var $8ijR4 = parcelRequire("8ijR4");

var $6MMSf = parcelRequire("6MMSf");

var $fEfLP = parcelRequire("fEfLP");


var $hzoSY = parcelRequire("hzoSY");


var $lwMyB = parcelRequire("lwMyB");


var $2e9Ky = parcelRequire("2e9Ky");

var $dPucF = parcelRequire("dPucF");

var $dgeAW = parcelRequire("dgeAW");

var $gDdYI = parcelRequire("gDdYI");


var $eG4LB = parcelRequire("eG4LB");

var $blU2f = parcelRequire("blU2f");

/**
 * This ID is used in pollinator tests and by JPD. Do not change lightly.
 */ const $90b0ce6fa7ac12e1$var$BANNER_ID = 'page-layout.banner';
const $90b0ce6fa7ac12e1$export$1c91e5dc5ea848c6 = ({ bannerFragment: bannerFragment })=>{
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $n67Vb.useFragment)((0, $empzH.default), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    bannerFragment);
    const banner = (0, $fEfLP.useBanner)();
    const bannerName = banner.name;
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.Banner), {
        height: banner.height,
        testId: $90b0ce6fa7ac12e1$var$BANNER_ID,
        id: $90b0ce6fa7ac12e1$var$BANNER_ID
    }, bannerName === (0, $019eb0ef26b17dd6$export$3c5e605ca7ade9f2) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzoSY.BannerAnnouncementAsync), {
        jiraQueryFragment: data?.jira
    }), bannerName === (0, $3869667d2322ccce$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8ijR4.IPBlocklistingBannerAsync), null), bannerName === (0, $dPucF.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dgeAW.ReturnToMobileBanner), null), bannerName === (0, $d71e39b6af21097e$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8FgPK.CookieConsentBannerAsync), null), bannerName === (0, $6afe4b018443206a$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lwMyB.BannerTransitionAsync), null), bannerName === (0, $e6f7a78aa9b2d70b$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2e9Ky.MailExpiryBannerAsync), null), bannerName === (0, $0573d7bb0155dab9$export$41956b146268af93) && (0, $i860n.fg)('jpd-view-templates-feedback-banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eG4LB.AsyncJpdBlueprintsFeedbackBanner), null), bannerName === (0, $ccb97c5e77224008$export$7b746a9f691e0529) && (0, $i860n.fg)('eoc_consolidation_cohort_3_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $blU2f.Cohort3BannerAsync), null))) : null;
};
$90b0ce6fa7ac12e1$export$1c91e5dc5ea848c6.displayName = "BannerContent";

});
parcelRegister("empzH", function(module, exports) {
$parcel$export(module.exports, "default", () => $120ea441818491a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3342d94111e312f5e870a13b4a24c460>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $120ea441818491a9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "BannerContent",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "BannerV2BannerAnnouncement"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$120ea441818491a9$var$node.hash = "fa7672939076a19bf4033b74dbae7c18";
var $120ea441818491a9$export$2e2bcd8739ae039 = $120ea441818491a9$var$node;

});

const $d71e39b6af21097e$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $d71e39b6af21097e$export$ed7cc0d417ee89e = 105;
const $d71e39b6af21097e$export$ff6e18f7d82b549c = 320;

parcelRegister("8FgPK", function(module, exports) {
$parcel$export(module.exports, "CookieConsentBannerAsync", () => $34b60dcfc4a7cd5d$export$f110a9cbbbd3fa3a);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $34b60dcfc4a7cd5d$var$LazyForPaintCookieConsentBanner = (0, $l8G1z.lazyForPaint)(()=>// chunk name is async-cc-banner to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("3wsLh")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    ssr: true,
    moduleId: "./src/packages/platform/banners-cookie-consent/src/CookieConsentBanner.tsx"
});
const $34b60dcfc4a7cd5d$export$f110a9cbbbd3fa3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $34b60dcfc4a7cd5d$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async-cookie-consent-banner",
        packageName: "jiraCookieConsentBanner",
        teamName: "Magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-cookie-consent-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($34b60dcfc4a7cd5d$var$LazyForPaintCookieConsentBanner, null))));
$34b60dcfc4a7cd5d$export$f110a9cbbbd3fa3a.displayName = "CookieConsentBannerAsync";
const $34b60dcfc4a7cd5d$var$boxStyles = (0, $fbAgj.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    height: '100%'
});

});
parcelRegister("3wsLh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cZut1").then(()=>parcelRequire('c79Rx'));

});


/* eslint-disable jira/filename-case */ const $3869667d2322ccce$export$86047f02632f9f5b = 56;
const $3869667d2322ccce$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';

parcelRegister("8ijR4", function(module, exports) {
$parcel$export(module.exports, "IPBlocklistingBannerAsync", () => $308478a5ae7685c8$export$fafc306b802ab39d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $308478a5ae7685c8$var$IPBlocklistingBannerComp = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("19ocB")).then((m)=>m.IPBlocklistingBanner), {
    ssr: false,
    moduleId: "./src/packages/platform/ip-block-listing-banner/src/main.tsx"
});
const $308478a5ae7685c8$export$fafc306b802ab39d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-ip-block-listing-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($308478a5ae7685c8$var$IPBlocklistingBannerComp, null));
$308478a5ae7685c8$export$fafc306b802ab39d.displayName = "IPBlocklistingBannerAsync";

});
parcelRegister("19ocB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4AC3v").then(()=>parcelRequire('8gtTT'));

});


parcelRegister("fEfLP", function(module, exports) {
$parcel$export(module.exports, "useBanner", () => $02bd32ea2d12e74b$export$de40f69ba30f2376);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8l0oU = parcelRequire("8l0oU");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");

var $8LqGG = parcelRequire("8LqGG");

var $9XO6I = parcelRequire("9XO6I");

var $96bil = parcelRequire("96bil");

var $hf1pS = parcelRequire("hf1pS");

var $jaNoM = parcelRequire("jaNoM");

var $hzCuS = parcelRequire("hzCuS");

var $fPDD0 = parcelRequire("fPDD0");

var $jQb8I = parcelRequire("jQb8I");
const $02bd32ea2d12e74b$var$noBanner = {
    name: null,
    height: 0,
    isEnabled: false
};
const $02bd32ea2d12e74b$var$useJpdBannerFeedback = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jpd-view-templates-sample-project'), ()=>(0, $fPDD0.useBannerJpdBlueprintsFeedback)(), ()=>$02bd32ea2d12e74b$var$noBanner);
const $02bd32ea2d12e74b$var$useCohort3CustomersBannerConditional = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $i860n.fg)('eoc_consolidation_cohort_3_banner'), (0, $hf1pS.useCohort3CustomersBanner), ()=>undefined);
const $02bd32ea2d12e74b$export$de40f69ba30f2376 = ({ ignoreChromeless: ignoreChromeless = false } = {})=>{
    const [isChromeless] = (0, $9XO6I.useIsChromeless)();
    const announcement = (0, $96bil.useBannerAnnouncement)();
    const transition = (0, $jaNoM.useBannerEocTransition)();
    const returnToMobile = (0, $jQb8I.useBannerReturnToMobile)();
    const IPBlocklisting = (0, $8LqGG.useBannerIPBlocklisting)();
    const cohort3CustomersBanner = $02bd32ea2d12e74b$var$useCohort3CustomersBannerConditional();
    const cookieConsent = (0, $8l0oU.useBannerCookieConsent)();
    // we have added this check to return banner data for assets routes as all the routes in assets are chromeless
    // but we want to show the announcement banner in assets routes
    const isChromelessCheck = ignoreChromeless ? false : isChromeless;
    const mailExpiry = (0, $hzCuS.useBannerMailExpiry)();
    const jpdBlueprintsFeedback = $02bd32ea2d12e74b$var$useJpdBannerFeedback();
    return (0, $euxye.useMemo)(()=>{
        // cookie consent banner has the highest priority
        if (cookieConsent?.isEnabled) return cookieConsent;
        if (isChromelessCheck) return $02bd32ea2d12e74b$var$noBanner;
        if (IPBlocklisting.isEnabled) return IPBlocklisting;
        if (returnToMobile.isEnabled) return returnToMobile;
        if (announcement.isEnabled) return announcement;
        if (transition?.isEnabled) return transition;
        if (mailExpiry?.isEnabled) return mailExpiry;
        if (jpdBlueprintsFeedback.isEnabled) return jpdBlueprintsFeedback;
        if (cohort3CustomersBanner?.isEnabled) return cohort3CustomersBanner;
        return $02bd32ea2d12e74b$var$noBanner;
    }, [
        cookieConsent,
        IPBlocklisting,
        returnToMobile,
        announcement,
        transition,
        mailExpiry,
        jpdBlueprintsFeedback,
        cohort3CustomersBanner,
        isChromelessCheck
    ]);
};

});
parcelRegister("8l0oU", function(module, exports) {
$parcel$export(module.exports, "useBannerCookieConsent", () => $ad0e23aa915c2d6f$export$c7a51b5ee06f5794);

var $euxye = parcelRequire("euxye");

var $hDZQt = parcelRequire("hDZQt");

var $g5tlc = parcelRequire("g5tlc");

var $i860n = parcelRequire("i860n");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $b9Jox = parcelRequire("b9Jox");

var $gXrrn = parcelRequire("gXrrn");


var $gVh34 = parcelRequire("gVh34");
const $ad0e23aa915c2d6f$var$getCookieSSR = (name)=>{
    return (0, $gXrrn.getCookie)(name, true);
};
const $ad0e23aa915c2d6f$export$5503c67b1001ec45 = (data, isClientReady)=>{
    try {
        /**
		 * If we are using the cookie data to verify if we show the banner, and we don't use ATLASSIAN_SHOW_BANNER_COOKIE_KEY
		 * we end up in a situation where the banner is shown,
		 * then the client renders ConsentBanner from '@atlassian/browser-storage-controls'
		 * which then checks that cookie and if it's false
		 * and then we dismiss the banner anyway
		 *
		 * This is because the cookie consent logic does not set the 'fallback' cookie when we prefetch the data
		 * Because of this, shouldRenderBannerPrefetched will always end up returning true if we prefetch
		 *
		 * If we look at the getShowBanner code platform/packages/policy-platform/browser-storage-controls/src/ui/consent-banner/use-banner-visibility/index.ts
		 * We can see that it will use this show banner cookie to determine if the banner should be shown
		 * as long as we aren't in localConsentMode (which we aren't since we do not pass localConsentMode=true to ConsentBanner
		 * in jira/src/packages/platform/banners-cookie-consent/src/ui/banner/CookieConsentBanner.tsx)
		 *
		 * So we can use the ATLASSIAN_SHOW_BANNER_COOKIE_KEY to determine if the banner should be shown instead if it is set
		 */ if (data?.shouldShowBanner !== undefined) return data.shouldShowBanner;
        if ((0, $i860n.fg)('fedramp-jira-banner-fix')) return data === null || (0, $g5tlc.shouldRenderBannerPrefetched)(data, {
            isSSR: !isClientReady,
            getCookie: $ad0e23aa915c2d6f$var$getCookieSSR
        });
        return data && (0, $g5tlc.shouldRenderBannerPrefetched)(data, {
            isSSR: !isClientReady,
            getCookie: $ad0e23aa915c2d6f$var$getCookieSSR
        });
    } catch (e) {
        return true;
    }
};
const $ad0e23aa915c2d6f$export$c7a51b5ee06f5794 = ()=>{
    const isClientReady = (0, $b9Jox.useIsClientReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [{ isDismissed: isDismissed, height: height, hasInit: hasInit }, { onShow: onShow, init: init }] = (0, $gVh34.useCookieConsentBannerSettings)();
    const { data: data, loading: loading, error: error } = (0, $hDZQt.useConsentBannerUserPreferencesResource)();
    const isIframe = (0, $gVh34.useIsInIframe)();
    // This is the initial state of the banner esp in ssr land
    const [initialShouldShow] = (0, $euxye.useState)(()=>{
        if (loading) return false;
        if (error) return true;
        return Boolean($ad0e23aa915c2d6f$export$5503c67b1001ec45(data, isClientReady) && !isIframe);
    });
    const shouldShow = (0, $euxye.useMemo)(()=>hasInit ? !isDismissed : initialShouldShow, [
        hasInit,
        initialShouldShow,
        isDismissed
    ]);
    (0, $euxye.useEffect)(()=>{
        if (hasInit || loading) return;
        // Now that we're in the client render, let's re-verify if we should show the banner
        // Eg to verify if we are in an iframe
        const shouldRender = Boolean(error || $ad0e23aa915c2d6f$export$5503c67b1001ec45(data, true) && !isIframe);
        init(!shouldRender);
        // We should verify how often we end up having a mismatch between the initial render (probably ssr) and init render (client)
        if (!(0, $i860n.fg)('killswitch-analytics-ssr-cookie-consent-banner')) {
            if (initialShouldShow !== shouldRender) (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'cookieConsentBanner showBannerMismatch', {
                isInIframe: isIframe,
                initialShouldShow: initialShouldShow,
                initShouldShow: shouldRender
            });
        }
    }, [
        createAnalyticsEvent,
        data,
        error,
        hasInit,
        init,
        initialShouldShow,
        isIframe,
        loading,
        onShow
    ]);
    return (0, $euxye.useMemo)(()=>({
            isEnabled: shouldShow,
            name: (0, $d71e39b6af21097e$export$41956b146268af93),
            height: height
        }), [
        shouldShow,
        height
    ]);
};

});
parcelRegister("g5tlc", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $cedb5dc5b9299895$export$6406464aa126433e);

var $egspI = parcelRequire("egspI");

var $i8BPS = parcelRequire("i8BPS");

var $5bfto = parcelRequire("5bfto");

var $dh9AH = parcelRequire("dh9AH");

var $6e2YE = parcelRequire("6e2YE");
const $cedb5dc5b9299895$export$6406464aa126433e = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, $egspI.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $dh9AH.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $6e2YE.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, $5bfto.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $i8BPS.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $6e2YE.getBannerVisibility)(consentPrefsData, ssrOptions);
};

});

parcelRegister("gVh34", function(module, exports) {
$parcel$export(module.exports, "useIsInIframe", () => $d0487a6c36ea3557$export$91479fa739bfba00);
$parcel$export(module.exports, "useCookieConsentBannerSettings", () => $d0487a6c36ea3557$export$ae97931560f092a4);
$parcel$export(module.exports, "useCookieConsentBannerSettingsActions", () => $d0487a6c36ea3557$export$ecbab4dc5f9ad844);

var $1uH7N = parcelRequire("1uH7N");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $b9Jox = parcelRequire("b9Jox");

const $d0487a6c36ea3557$export$9f140ed41af5108c = ()=>{
    (0, $1uH7N.di)(window);
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
function $d0487a6c36ea3557$export$91479fa739bfba00() {
    (0, $1uH7N.di)(window);
    const isClientRender = (0, $b9Jox.useIsClientReady)();
    if (!isClientRender) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
}
const $d0487a6c36ea3557$export$d4c72bab9d6cc13a = {
    get isDismissed () {
        return true;
    },
    get height () {
        return 0, $d71e39b6af21097e$export$ed7cc0d417ee89e;
    },
    hasInit: false
};
const $d0487a6c36ea3557$export$e324594224ef24da = {
    onShow: ()=>({ setState: setState })=>{
            setState({
                isDismissed: false
            });
        },
    onDismiss: ()=>({ setState: setState })=>{
            setState({
                isDismissed: true
            });
        },
    setHeight: (height)=>({ setState: setState })=>{
            setState({
                height: height
            });
        },
    init: (isDismissed)=>({ setState: setState })=>{
            setState({
                isDismissed: isDismissed,
                hasInit: true
            });
        }
};
const $d0487a6c36ea3557$var$Store = (0, $5QDqc.createStore)({
    name: 'cookie-consent-banner',
    initialState: $d0487a6c36ea3557$export$d4c72bab9d6cc13a,
    actions: $d0487a6c36ea3557$export$e324594224ef24da
});
const $d0487a6c36ea3557$export$ae97931560f092a4 = (0, $3h1FP.createHook)($d0487a6c36ea3557$var$Store);
const $d0487a6c36ea3557$export$ecbab4dc5f9ad844 = (0, $3h1FP.createActionsHook)($d0487a6c36ea3557$var$Store);

});


parcelRegister("8LqGG", function(module, exports) {
$parcel$export(module.exports, "useBannerIPBlocklisting", () => $fbcda1051ebb4e7e$export$564412c1d9cd4ccc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $9dWMe = parcelRequire("9dWMe");
var $8IotF = parcelRequire("8IotF");
var $erQjo = parcelRequire("erQjo");

var $i860n = parcelRequire("i860n");

const $fbcda1051ebb4e7e$export$564412c1d9cd4ccc = ()=>{
    const [shouldShowBanner, setBannerState] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if ((0, $i860n.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $erQjo.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $9dWMe.loadBridgeStrict)({
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-atlaskit-plugin:ipblocklisting'
                ],
                name: 'jira/global-components/ipblocklisting/bridge'
            }).then((bridge)=>{
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                bridge({
                    showIPBlocklistBanner: ()=>setBannerState(true),
                    hideIPBlocklistBanner: ()=>setBannerState(false)
                });
            }));
        else // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $8IotF.loadBridgeWeak)({
            name: 'jira/global-components/ipblocklisting/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge({
                showIPBlocklistBanner: ()=>setBannerState(true),
                hideIPBlocklistBanner: ()=>setBannerState(false)
            });
        });
    }, []);
    return (0, $euxye.useMemo)(()=>({
            isEnabled: shouldShowBanner,
            name: (0, $3869667d2322ccce$export$41956b146268af93),
            height: (0, $3869667d2322ccce$export$86047f02632f9f5b)
        }), [
        shouldShowBanner
    ]);
};

});

parcelRegister("96bil", function(module, exports) {
$parcel$export(module.exports, "useBannerAnnouncement", () => $374c71106a9a417d$export$1e775b1ab04f2888);

var $euxye = parcelRequire("euxye");

var $iV0kf = parcelRequire("iV0kf");

var $cvA2R = parcelRequire("cvA2R");

const $374c71106a9a417d$export$1e775b1ab04f2888 = ()=>{
    const { data: data } = (0, $iV0kf.useAnnouncementBannerSettingsV4Resource)();
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    return (0, $euxye.useMemo)(()=>({
            isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
            name: (0, $019eb0ef26b17dd6$export$3c5e605ca7ade9f2),
            height: (0, $019eb0ef26b17dd6$export$809d2b099693a9a8)
        }), [
        data?.isDismissed,
        data?.isEnabled,
        data?.visibility,
        isAnonymous
    ]);
};

});
/* eslint-disable jira/filename-case */ const $019eb0ef26b17dd6$export$809d2b099693a9a8 = 64;
const $019eb0ef26b17dd6$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';


parcelRegister("hf1pS", function(module, exports) {
$parcel$export(module.exports, "useCohort3CustomersBanner", () => $bbf92f0ed0918483$export$9dd28ddfa301aa73);

var $euxye = parcelRequire("euxye");

var $bs9jJ = parcelRequire("bs9jJ");

var $fNgVF = parcelRequire("fNgVF");

var $3GN2r = parcelRequire("3GN2r");


var $lKstw = parcelRequire("lKstw");
const $bbf92f0ed0918483$export$9dd28ddfa301aa73 = ()=>{
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const accountId = (0, $3GN2r.useAccountId)();
    const { isDismissed: isDismissed, height: height } = (0, $lKstw.useCohort3CustomerBannerState)();
    const { fetchBannerVisibility: fetchBannerVisibility } = (0, $lKstw.useCohort3CustomerBannerActions)();
    (0, $euxye.useEffect)(()=>{
        if (!accountId) return;
        fetchBannerVisibility(accountId);
    }, [
        accountId,
        fetchBannerVisibility
    ]);
    return (0, $euxye.useMemo)(()=>({
            isEnabled: Boolean((isAdmin || isSiteAdmin) && !isDismissed),
            name: (0, $ccb97c5e77224008$export$7b746a9f691e0529),
            height: height
        }), [
        isAdmin,
        isSiteAdmin,
        isDismissed,
        height
    ]);
};

});
const $ccb97c5e77224008$export$7b746a9f691e0529 = 'EOC-COHORT3-CONSOLIDATION-BANNER';
const $ccb97c5e77224008$export$ed7cc0d417ee89e = 50;

parcelRegister("lKstw", function(module, exports) {
$parcel$export(module.exports, "useCohort3CustomerBannerState", () => $5270bd670e569c01$export$5c26fb28abd3eaaf);
$parcel$export(module.exports, "useCohort3CustomerBannerActions", () => $5270bd670e569c01$export$1935eaf1458de3aa);
/* eslint-disable jira/restricted/@atlassian/react-sweet-state */ 
var $hFtK7 = parcelRequire("hFtK7");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

const $5270bd670e569c01$export$d4c72bab9d6cc13a = {
    isDismissed: false,
    height: (0, $ccb97c5e77224008$export$ed7cc0d417ee89e),
    isLoading: true
};
const $5270bd670e569c01$export$e324594224ef24da = {
    onDismiss: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) {
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'onDismiss',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: new Error('Account id is not available'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            try {
                await (0, $kM0go.setUserProperties)(accountId, (0, $ccb97c5e77224008$export$7b746a9f691e0529), 'true');
                setState({
                    isDismissed: true
                });
            } catch (error) {
                setState({
                    isDismissed: true
                });
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'useCohort3CustomersBanner',
                        packageName: 'Cohort3CustomerBanner',
                        teamName: 'alexstrasza'
                    },
                    error: error instanceof Error ? error : new Error(String(error)),
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        },
    fetchBannerVisibility: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) {
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'fetchBannerVisibility',
                        packageName: 'Cohort3CustomerBanner',
                        teamName: 'alexstrasza'
                    },
                    error: new Error('Account id is not available'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            try {
                const value = await (0, $kM0go.getUserProperty)(accountId, (0, $ccb97c5e77224008$export$7b746a9f691e0529));
                setState({
                    isDismissed: Boolean(value),
                    isLoading: false
                });
            } catch (error) {
                if (error instanceof (0, $75sVW.default) && (error.statusCode === 404 || error.statusCode === 403)) setState({
                    isLoading: false,
                    isDismissed: false
                });
            }
        }
};
const $5270bd670e569c01$var$Store = (0, $5QDqc.createStore)({
    name: 'Cohort3CustomerBannerStore',
    initialState: $5270bd670e569c01$export$d4c72bab9d6cc13a,
    actions: $5270bd670e569c01$export$e324594224ef24da
});
const $5270bd670e569c01$export$5c26fb28abd3eaaf = (0, $3h1FP.createStateHook)($5270bd670e569c01$var$Store);
const $5270bd670e569c01$export$1935eaf1458de3aa = (0, $3h1FP.createActionsHook)($5270bd670e569c01$var$Store);

});


parcelRegister("jaNoM", function(module, exports) {
$parcel$export(module.exports, "useBannerEocTransition", () => $5383ff4e4b4852de$export$b6539a8209f95b48);

var $euxye = parcelRequire("euxye");

var $7m1ar = parcelRequire("7m1ar");

var $1I36S = parcelRequire("1I36S");

var $6HvWM = parcelRequire("6HvWM");

var $fNgVF = parcelRequire("fNgVF");

var $bs9jJ = parcelRequire("bs9jJ");

const $5383ff4e4b4852de$export$b6539a8209f95b48 = ()=>{
    const { data: data, error: error } = (0, $7m1ar.useOgConsolidationUserState)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const isSiteAdmin = (0, $bs9jJ.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $6HvWM.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && (!data.isTransitionBannerDismissed || (0, $1I36S.shouldRenderBenefitModal)({
        bannerDismissedAt: data.transitionBannerDismissedAt,
        isDismissed: data.isBenefitModalDismissed
    })));
    return (0, $euxye.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $6afe4b018443206a$export$41956b146268af93),
            height: data && (0, $1I36S.shouldRenderBenefitModal)({
                bannerDismissedAt: data.transitionBannerDismissedAt
            }) ? 0 : (0, $6afe4b018443206a$export$809d2b099693a9a8)
        }), [
        data,
        isEnabled
    ]);
};

});
parcelRegister("7m1ar", function(module, exports) {
$parcel$export(module.exports, "useOgConsolidationUserState", () => $2293d01ab841bcce$export$c35632c02599163f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $5hdVX = parcelRequire("5hdVX");

var $eDOWT = parcelRequire("eDOWT");

var $kM0go = parcelRequire("kM0go");

var $iQPOZ = parcelRequire("iQPOZ");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $eijVy = parcelRequire("eijVy");

var $k6ufm = parcelRequire("k6ufm");
const $2293d01ab841bcce$var$errorFlagTitle = (0, $7eNDO.defineMessage)({
    id: "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
    defaultMessage: "Something went wrong while updating user properties."
});
const $2293d01ab841bcce$export$c35632c02599163f = ()=>{
    const errorRef = (0, $euxye.useRef)();
    const loadingRef = (0, $euxye.useRef)(false);
    const { showFlag: showFlag } = (0, $iQPOZ.useFlagsService)();
    const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $k6ufm.useResource)((0, $eDOWT.consolidationUserStateResource));
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [userPropertiesError, setUserPropertiesError] = (0, $euxye.useState)();
    errorRef.current = userPropertiesError || transitionResourceError;
    const { atlassianAccountId: accountId } = (0, $eijVy.useTenantContext)();
    const update = (0, $euxye.useCallback)(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (newState)=>{
        if (errorRef.current) // If there is an error on resource or update, we don't want to update the state
        return Promise.reject(errorRef.current);
        // oxlint-disable-next-line typescript/consistent-type-assertions
        let updatedData = {};
        updateTransitionResource((oldState)=>{
            updatedData = {
                ...oldState,
                ...newState
            };
            return updatedData;
        });
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $kM0go.setUserProperties)(accountId, (0, $5hdVX.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: formatMessage($2293d01ab841bcce$var$errorFlagTitle),
                    // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
                    messageId: 'eoc-changeboarding.controllers.use-og-consolidation-user-state.show-flag.error.jira-modal',
                    messageType: 'transactional'
                });
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
        return Promise.resolve();
    }, [
        updateTransitionResource,
        accountId,
        formatMessage,
        showFlag
    ]);
    const reopenTransitionLozenge = (0, $euxye.useCallback)(()=>{
        update({
            isTransitionHomeHidden: false
        });
    }, [
        update
    ]);
    return {
        data: data,
        update: update,
        error: errorRef.current,
        reopenTransitionLozenge: reopenTransitionLozenge
    };
};

});

parcelRegister("1I36S", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBenefitModal", () => $86d0d38a5ae67017$export$25a52eb2dc74e2f9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $86d0d38a5ae67017$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
    if (!bannerDismissedAt || isDismissed) return false;
    return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};

});

const $6afe4b018443206a$export$809d2b099693a9a8 = 48;
const $6afe4b018443206a$export$41956b146268af93 = 'EOC_TRANSITION';


parcelRegister("hzCuS", function(module, exports) {
$parcel$export(module.exports, "useBannerMailExpiry", () => $2205366a0c8a4a67$export$3906461ac9b87d2);

var $euxye = parcelRequire("euxye");

var $2VqX7 = parcelRequire("2VqX7");


var $e2eC7 = parcelRequire("e2eC7");
const $2205366a0c8a4a67$export$3906461ac9b87d2 = ()=>{
    const { responseStatus: responseStatus, state: state } = (0, $2VqX7.useIncomingMailExpiryStatus)();
    const { onStateFetch: onStateFetch } = (0, $e2eC7.useBannerActions)();
    const { isBannerShown: isBannerShown } = (0, $e2eC7.useBannerState)();
    (0, $euxye.useEffect)(()=>{
        if (responseStatus === 'error') {
            onStateFetch((0, $2VqX7.DEFAULT_RESPONSE));
            return;
        }
        if (responseStatus === 'success') onStateFetch(state);
    }, [
        onStateFetch,
        responseStatus,
        state
    ]);
    return (0, $euxye.useMemo)(()=>({
            isEnabled: isBannerShown,
            name: (0, $e6f7a78aa9b2d70b$export$41956b146268af93),
            height: (0, $e6f7a78aa9b2d70b$export$809d2b099693a9a8)
        }), [
        isBannerShown
    ]);
};

});
const $e6f7a78aa9b2d70b$export$809d2b099693a9a8 = 48;
const $e6f7a78aa9b2d70b$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';

parcelRegister("e2eC7", function(module, exports) {
$parcel$export(module.exports, "useBannerActions", () => $ed6e1277ba354b03$export$664f3e2467f0f5af);
$parcel$export(module.exports, "useBannerState", () => $ed6e1277ba354b03$export$fa4ffa872ee90bd0);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $ed6e1277ba354b03$export$d4c72bab9d6cc13a = {
    isBannerShown: false,
    isAdmin: false,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $ed6e1277ba354b03$export$e324594224ef24da = {
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: false
            });
        },
    onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
        'GMAIL_OAUTH'
    ] })=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: showBanner && isAdmin,
                isAdmin: isAdmin,
                OauthTypes: OauthTypes
            });
        }
};
const $ed6e1277ba354b03$var$Store = (0, $5QDqc.createStore)({
    name: 'mail-expiry-banner',
    initialState: $ed6e1277ba354b03$export$d4c72bab9d6cc13a,
    actions: $ed6e1277ba354b03$export$e324594224ef24da
});
const $ed6e1277ba354b03$export$664f3e2467f0f5af = (0, $3h1FP.createActionsHook)($ed6e1277ba354b03$var$Store);
const $ed6e1277ba354b03$export$fa4ffa872ee90bd0 = (0, $3h1FP.createStateHook)($ed6e1277ba354b03$var$Store);

});


parcelRegister("fPDD0", function(module, exports) {
$parcel$export(module.exports, "useBannerJpdBlueprintsFeedback", () => $939932dac54049bd$export$c8506c2c91f4725a);

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $i860n = parcelRequire("i860n");

var $2b39L = parcelRequire("2b39L");

var $3GN2r = parcelRequire("3GN2r");

var $hYI7R = parcelRequire("hYI7R");


var $h40eh = parcelRequire("h40eh");

var $IwCo1 = parcelRequire("IwCo1");
const $939932dac54049bd$export$c8506c2c91f4725a = ()=>{
    const hasPolarisInPath = (0, $IwCo1.useHasPolarisInPath)();
    const { data: project } = (0, $2b39L.useProjectContext)();
    const accountId = (0, $3GN2r.useAccountId)();
    const { isDismissed: isDismissed, height: height, shouldShow: shouldShow, isLoading: isLoading } = (0, $h40eh.useJpdBlueprintsFeedbackBannerState)();
    const { fetchBannerVisibility: fetchBannerVisibility } = (0, $h40eh.useJpdBlueprintsFeedbackBannerActions)();
    const isDiscoveryProject = project?.projectType === (0, $f99M0.PRODUCT_DISCOVERY_PROJECT);
    const isInJpdBoundary = (0, $euxye.useMemo)(()=>hasPolarisInPath || isDiscoveryProject, [
        isDiscoveryProject,
        hasPolarisInPath
    ]);
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        if (!(0, $i860n.fg)('jpd-view-templates-feedback-banner')) return;
        if (!accountId) return;
        // Fetch only if we are in JPD boundary
        if (isInJpdBoundary) fetchBannerVisibility(accountId, project?.projectId);
    }, [
        accountId,
        fetchBannerVisibility,
        project,
        isInJpdBoundary
    ]);
    return (0, $euxye.useMemo)(()=>({
            isEnabled: isInJpdBoundary && shouldShow && !isDismissed && !isLoading && (0, $i860n.fg)('jpd-view-templates-feedback-banner'),
            name: (0, $0573d7bb0155dab9$export$41956b146268af93),
            height: height
        }), [
        isInJpdBoundary,
        shouldShow,
        isDismissed,
        height,
        isLoading
    ]);
};

});
const $0573d7bb0155dab9$export$41956b146268af93 = 'polaris.blueprints-feedback-banner';
const $0573d7bb0155dab9$export$ed7cc0d417ee89e = 48;
const $0573d7bb0155dab9$export$ff6e18f7d82b549c = 320;
const $0573d7bb0155dab9$export$a07dab5608229ea3 = 'jira.polaris.blueprints-feedback-banner';
const $0573d7bb0155dab9$export$b8b9d90f9e5bd72b = 'jiraPolarisComponentBlueprintsFeedbackBanner';

parcelRegister("h40eh", function(module, exports) {
$parcel$export(module.exports, "useJpdBlueprintsFeedbackBannerState", () => $627a212b9e8ea8bc$export$19a6160e3b75cbb4);
$parcel$export(module.exports, "useJpdBlueprintsFeedbackBannerActions", () => $627a212b9e8ea8bc$export$dcb98dcb6a6fffba);

var $hFtK7 = parcelRequire("hFtK7");

var $fHdnx = parcelRequire("fHdnx");

var $frkDQ = parcelRequire("frkDQ");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $kM0go = parcelRequire("kM0go");

var $ifsAO = parcelRequire("ifsAO");

var $7Pr7y = parcelRequire("7Pr7y");

var $lCetP = parcelRequire("lCetP");

var $75sVW = parcelRequire("75sVW");

function $627a212b9e8ea8bc$var$getError(error) {
    if (error instanceof Error) return error;
    return new (0, $7Pr7y.UnknownError)('Retrieved non-standard error', error);
}
const $627a212b9e8ea8bc$export$d4c72bab9d6cc13a = {
    isDismissed: false,
    height: (0, $0573d7bb0155dab9$export$ed7cc0d417ee89e),
    shouldShow: false,
    isLoading: true
};
const $627a212b9e8ea8bc$export$e324594224ef24da = {
    onDismiss: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) return;
            // Update UI immediately - optimistic dismissal
            setState({
                isDismissed: true
            });
            try {
                await (0, $kM0go.setUserProperties)(accountId, (0, $0573d7bb0155dab9$export$41956b146268af93), 'false');
            } catch (error) {
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.jpd-blueprints-feedback.banner-dismissed', $627a212b9e8ea8bc$var$getError(error)));
            }
        },
    fetchBannerVisibility: (accountId, projectId)=>async ({ setState: setState, getState: getState })=>{
            if (!accountId) return;
            // Don't show the banner if projectId is not provided
            if (!projectId) {
                setState({
                    shouldShow: false
                });
                return;
            }
            try {
                const onboardingInformation = await (0, $frkDQ.getOnboardingInformation)(String(projectId));
                // Show the banner only for BLUEPRINTS project
                if (onboardingInformation.initialProjectTemplate !== (0, $fHdnx.ProjectTemplateEnum).BLUEPRINTS) {
                    setState({
                        shouldShow: false,
                        isLoading: false
                    });
                    return;
                }
                const shouldShow = await (0, $kM0go.getUserProperty)(accountId, (0, $0573d7bb0155dab9$export$41956b146268af93));
                setState({
                    shouldShow: shouldShow,
                    isLoading: false
                });
            } catch (error) {
                const { isDismissed: isDismissed } = getState();
                // Show the banner only if it has not been dismissed
                setState({
                    shouldShow: !isDismissed,
                    isLoading: false
                });
                if (error instanceof (0, $75sVW.default) && error.statusCode === 404 || (0, $lCetP.isClientFetchError)(error)) return;
                (0, $hFtK7.fireErrorAnalytics)((0, $ifsAO.createErrorAnalytics)('polaris.jpd-blueprints-feedback.banner-dismissed', $627a212b9e8ea8bc$var$getError(error)));
            }
        }
};
const $627a212b9e8ea8bc$var$Store = (0, $5QDqc.createStore)({
    name: 'PolarisBlueprintsFeedbackBanner',
    initialState: $627a212b9e8ea8bc$export$d4c72bab9d6cc13a,
    actions: $627a212b9e8ea8bc$export$e324594224ef24da
});
const $627a212b9e8ea8bc$export$19a6160e3b75cbb4 = (0, $3h1FP.createStateHook)($627a212b9e8ea8bc$var$Store);
const $627a212b9e8ea8bc$export$dcb98dcb6a6fffba = (0, $3h1FP.createActionsHook)($627a212b9e8ea8bc$var$Store);

});
parcelRegister("fHdnx", function(module, exports) {
$parcel$export(module.exports, "ProjectOnboardingStatusEnum", () => $2a0736498c2766fb$export$d589b6154fdcf1ba);
$parcel$export(module.exports, "ProjectTemplateEnum", () => $2a0736498c2766fb$export$58f839397dbcfc56);
/* eslint-disable jira/filename-case */ const $2a0736498c2766fb$export$d589b6154fdcf1ba = {
    UNKNOWN: 'UNKNOWN',
    TASK_CREATION_FAILED: 'TASK_CREATION_FAILED',
    QUEUEING_FAILED: 'QUEUEING_FAILED',
    QUEUED: 'QUEUED',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE',
    FAILED: 'FAILED'
};
const $2a0736498c2766fb$export$58f839397dbcfc56 = {
    DISCOVERY: 'jira.polaris:discovery',
    BLANK: 'jira.polaris:blank-project',
    ROADMAP: 'jira.polaris:roadmap',
    PRIORITIZATION: 'jira.polaris:prioritization',
    PORTFOLIO_MANAGEMENT: 'jira.polaris:portfolio',
    BLUEPRINTS: 'jira.polaris:blueprints',
    FROM_EXISTING_PROJECT: 'jira:template-generated-from-existing-project',
    PORTFOLIO_ROADMAP: 'jira.polaris:portfolio-roadmap',
    OPPORTUNITY_SOLUTION: 'jira.polaris:opportunity-solution'
};

});

parcelRegister("frkDQ", function(module, exports) {
$parcel$export(module.exports, "getOnboardingInformation", () => $e4d609254b491c60$export$4a5126f584ac4502);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");
const $e4d609254b491c60$export$4a5126f584ac4502 = (projectId)=>(0, $4fhEY.default)(`/rest/polaris/project-template/onboarding-information/${projectId}?operation=getJpdOnboardingInformation`);

});

parcelRegister("7Pr7y", function(module, exports) {
$parcel$export(module.exports, "UnknownError", () => $c3b6c2d5a46aca42$export$ff4405149dbd0c5c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2KgJI = parcelRequire("2KgJI");
class $c3b6c2d5a46aca42$export$ff4405149dbd0c5c extends (0, $2KgJI.default) {
    constructor(message, details){
        super(message), this.name = 'UnknownError';
        this.details = details;
    }
}
$c3b6c2d5a46aca42$export$ff4405149dbd0c5c.displayName = "UnknownError";

});


parcelRegister("IwCo1", function(module, exports) {
$parcel$export(module.exports, "useHasPolarisInPath", () => $2325bef662fd72f5$export$b9f1d0d4eba42cdb);

var $f2wVS = parcelRequire("f2wVS");
const $2325bef662fd72f5$export$b9f1d0d4eba42cdb = (0, $f2wVS.createRouterSelector)(({ location: location })=>{
    return location.pathname.includes('/jira/polaris');
});

});


parcelRegister("jQb8I", function(module, exports) {
$parcel$export(module.exports, "useBannerReturnToMobileState", () => $6eafa130a5c4a850$export$571311559507e90);
$parcel$export(module.exports, "useBannerReturnToMobile", () => $6eafa130a5c4a850$export$a898dd7b7ec9917a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7Odw0 = parcelRequire("7Odw0");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $dPucF = parcelRequire("dPucF");
const $6eafa130a5c4a850$var$initialState = ()=>({
        // reads FG early
        isEnabled: (0, $7Odw0.shouldShowReturnToMobileBanner)()
    });
const $6eafa130a5c4a850$var$actions = {
    disable: ()=>({ setState: setState })=>{
            setState({
                isEnabled: false
            });
        }
};
const $6eafa130a5c4a850$var$store = (0, $5QDqc.createStore)({
    initialState: $6eafa130a5c4a850$var$initialState,
    actions: $6eafa130a5c4a850$var$actions
});
const $6eafa130a5c4a850$export$571311559507e90 = (0, $3h1FP.createHook)($6eafa130a5c4a850$var$store);
const $6eafa130a5c4a850$export$a898dd7b7ec9917a = ()=>{
    const [{ isEnabled: isEnabled }] = $6eafa130a5c4a850$export$571311559507e90();
    return (0, $euxye.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $dPucF.BANNER_NAME),
            height: (0, $dPucF.mobileBannerHeight)
        }), [
        isEnabled
    ]);
};

});
parcelRegister("dPucF", function(module, exports) {
$parcel$export(module.exports, "mobileBannerHeight", () => $cb576045a36f84dc$export$aa875602f5712b77);
$parcel$export(module.exports, "BANNER_NAME", () => $cb576045a36f84dc$export$41956b146268af93);
$parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", () => $cb576045a36f84dc$export$698c82a2c8445300);
/* eslint-disable jira/filename-case */ const $cb576045a36f84dc$export$aa875602f5712b77 = 48;
const $cb576045a36f84dc$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
const $cb576045a36f84dc$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');

});



parcelRegister("hzoSY", function(module, exports) {
$parcel$export(module.exports, "BannerAnnouncementAsync", () => $f0903ab1f70294d9$export$aa03f7909e0828ec);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $f0903ab1f70294d9$var$BannerAnnouncement = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("7wBcV")).then((module)=>module.BannerAnnouncement), // eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
{
    ssr: true,
    moduleId: "./src/packages/platform/banners-announcement/src/BannerV2BannerAnnouncement.tsx"
});
const $f0903ab1f70294d9$export$aa03f7909e0828ec = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-platform-ui-banners-announcement",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f0903ab1f70294d9$var$BannerAnnouncement, props));
$f0903ab1f70294d9$export$aa03f7909e0828ec.displayName = "BannerAnnouncementAsync";

});
parcelRegister("7wBcV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("d6QYx")
]).then(()=>parcelRequire('7fxwv'));

});


parcelRegister("lwMyB", function(module, exports) {
$parcel$export(module.exports, "BannerTransitionAsync", () => $14c846d343239e3a$export$8bf182764b9d2eb8);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $14c846d343239e3a$var$BannerTransition = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("5e3BT")).then((module)=>module.BannerTransition), {
    ssr: true,
    moduleId: "./src/packages/platform/banners-eoc-transition/src/BannerTransition.tsx"
});
const $14c846d343239e3a$export$8bf182764b9d2eb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-banner-eoc-transition",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($14c846d343239e3a$var$BannerTransition, null));
$14c846d343239e3a$export$8bf182764b9d2eb8.displayName = "BannerTransitionAsync";

});
parcelRegister("5e3BT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("52ryS").then(()=>parcelRequire('eYt59'));

});


parcelRegister("2e9Ky", function(module, exports) {
$parcel$export(module.exports, "MailExpiryBannerAsync", () => $f4a46a0299d64f15$export$11a26ffa2d1b48ed);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $f4a46a0299d64f15$var$LazyMailExpiryBanner = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("2mrIu")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
    ssr: true,
    moduleId: "./src/packages/platform/banners-mail-expiry-reminder/src/MailExpiryReminder.tsx"
});
const $f4a46a0299d64f15$export$11a26ffa2d1b48ed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async-mail-expiry-banner",
        packageName: "jiraPlatformUiMailExpiryReminder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-mail-expiry-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f4a46a0299d64f15$var$LazyMailExpiryBanner, null)));
$f4a46a0299d64f15$export$11a26ffa2d1b48ed.displayName = "MailExpiryBannerAsync";

});
parcelRegister("2mrIu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("FrsZW").then(()=>parcelRequire('2DxTP'));

});


parcelRegister("dgeAW", function(module, exports) {
$parcel$export(module.exports, "ReturnToMobileBanner", () => $c06c4cfb42966aa0$export$81c4f1e869d5a87);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $c06c4cfb42966aa0$var$LazyReturnToMobileBanner = (0, $l8G1z.lazy)(()=>(parcelRequire("cHMYd")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
    ssr: true,
    moduleId: "./src/packages/platform/return-to-mobile-banner/src/ReturnToMobileBanner.tsx"
});
const $c06c4cfb42966aa0$export$81c4f1e869d5a87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-return-to-mobile-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c06c4cfb42966aa0$var$LazyReturnToMobileBanner, null));
$c06c4cfb42966aa0$export$81c4f1e869d5a87.displayName = "ReturnToMobileBanner";

});
parcelRegister("cHMYd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4lOtr").then(()=>parcelRequire('jhRtE'));

});


parcelRegister("eG4LB", function(module, exports) {
$parcel$export(module.exports, "AsyncJpdBlueprintsFeedbackBanner", () => $4a4b0384a408be92$export$c5e759eda8f8f2da);

var $euxye = parcelRequire("euxye");

var $7nEKi = parcelRequire("7nEKi");

var $jreC0 = parcelRequire("jreC0");

var $d948C = parcelRequire("d948C");

const $4a4b0384a408be92$var$useEntrypoint = ()=>{
    const entryPointParams = (0, $euxye.useMemo)(()=>{
        return {};
    }, []);
    const hasLoadedEntrypoint = (0, $euxye.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $jreC0.useEntryPoint)((0, $d948C.jpdBlueprintsFeedbackBannerEntryPoint), entryPointParams);
    if (!hasLoadedEntrypoint.current) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};
const $4a4b0384a408be92$export$c5e759eda8f8f2da = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $4a4b0384a408be92$var$useEntrypoint();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7nEKi.JiraEntryPointContainer), {
        id: (0, $0573d7bb0155dab9$export$a07dab5608229ea3),
        packageName: (0, $0573d7bb0155dab9$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {}
    });
};
$4a4b0384a408be92$export$c5e759eda8f8f2da.displayName = "AsyncJpdBlueprintsFeedbackBanner";

});
parcelRegister("d948C", function(module, exports) {
$parcel$export(module.exports, "jpdBlueprintsFeedbackBannerEntryPoint", () => $0d08e74b48ef6f7a$export$5774847a04bf514);
/* eslint-disable eslint-comments/no-restricted-disable */ 
var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $0d08e74b48ef6f7a$export$5774847a04bf514 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("l0YJW")), {
        moduleId: "fe24e54f",
        moduleName: "BannerJpdBlueprintsFeedbackBannerEntryPoint",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("l0YJW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ayfz9").then(()=>parcelRequire('2qEeb'));

});



parcelRegister("blU2f", function(module, exports) {
$parcel$export(module.exports, "Cohort3BannerAsync", () => $befb2ec9fb0adeb0$export$c596c0a1bde2cc92);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $befb2ec9fb0adeb0$var$Cohort3Banner = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("5uzPO")).then((module)=>module.Cohort3CustomerBanner), // eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
{
    moduleId: "./src/packages/platform/banners-eoc-cohort3-customers-banner/src/Cohort3CustomerBannerInner.tsx"
});
const $befb2ec9fb0adeb0$export$c596c0a1bde2cc92 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-banner-eoc-cohort3-customers",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($befb2ec9fb0adeb0$var$Cohort3Banner, null));
$befb2ec9fb0adeb0$export$c596c0a1bde2cc92.displayName = "Cohort3BannerAsync";

});
parcelRegister("5uzPO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("94IgU").then(()=>parcelRequire('fZNlI'));

});



parcelRegister("juoEc", function(module, exports) {
$parcel$export(module.exports, "GlobalComponents", () => $0d6e37809612732d$export$461c2ed3163c74ff);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $dQkkK = parcelRequire("dQkkK");

var $lnVHd = parcelRequire("lnVHd");


var $4Onaa = parcelRequire("4Onaa");

var $QhQu4 = parcelRequire("QhQu4");

var $iLktG = parcelRequire("iLktG");

var $gDdYI = parcelRequire("gDdYI");
const $0d6e37809612732d$var$routeComponents = [];
const $0d6e37809612732d$var$RouteGlobalComponents = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, $QhQu4.renderGlobalComponents)(route.layout?.globalComponents || $0d6e37809612732d$var$routeComponents));
};
$0d6e37809612732d$var$RouteGlobalComponents.displayName = "RouteGlobalComponents";
// This component is necessary to ensure that the error boundary picks up errors in the renderGlobalComponents function
const $0d6e37809612732d$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, $QhQu4.renderGlobalComponents)(sharedGlobalComponents));
$0d6e37809612732d$var$SharedGlobalComponents.displayName = "SharedGlobalComponents";
const $0d6e37809612732d$export$461c2ed3163c74ff = /*#__PURE__*/ (0, $euxye.memo)(({ sharedGlobalComponents: sharedGlobalComponents })=>{
    const globalComponentsPerformanceTiming = (0, $euxye.useCallback)(()=>{
        (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)((0, $e6ec049ffa8f915a$export$fb9876ab4228d985), (0, $e6ec049ffa8f915a$export$c20831be6f780cb5), (0, $e6ec049ffa8f915a$export$398df1bca49f9884), true, true);
    }, []);
    /**
	 * !!! DO NOT ADD INDIVIDUAL COMPONENTS TO THIS FILE !!!
	 *
	 * They should be defined as part of the `sharedGlobalComponents` constant, or defined on the route
	 * definition `layout` key.
	 *
	 * @see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/jira/src/packages/platform/layouts-jira-shared-layout/README.md
	 * @see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/jira/src/packages/platform/ui/layouts/README.md
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$c20831be6f780cb5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lnVHd.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "shared-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0d6e37809612732d$var$SharedGlobalComponents, {
        sharedGlobalComponents: sharedGlobalComponents
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "route-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "route-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0d6e37809612732d$var$RouteGlobalComponents, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$398df1bca49f9884),
        onSet: globalComponentsPerformanceTiming
    }));
});

});

parcelRegister("5snaZ", function(module, exports) {
$parcel$export(module.exports, "RightSidebar", () => $f1acc2f162895b38$export$84d58c19c21f637f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");


var $btoiF = parcelRequire("btoiF");

var $dsVXF = parcelRequire("dsVXF");

var $29eRG = parcelRequire("29eRG");

var $6MMSf = parcelRequire("6MMSf");

var $4Onaa = parcelRequire("4Onaa");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $QhQu4 = parcelRequire("QhQu4");

var $57TEW = parcelRequire("57TEW");

var $gDdYI = parcelRequire("gDdYI");

var $bzSUP = parcelRequire("bzSUP");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $f1acc2f162895b38$var$TEST_ID = 'page-layout.aside';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $f1acc2f162895b38$var$routeComponents = [];
const $f1acc2f162895b38$var$SharedRightSidebars = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, $QhQu4.renderGlobalComponents)((0, $57TEW.sharedLayout).rightSidebars));
$f1acc2f162895b38$var$SharedRightSidebars.displayName = "SharedRightSidebars";
const $f1acc2f162895b38$var$RightSidebarRouteComponents = ()=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, $QhQu4.renderGlobalComponents)(route.layout?.rightSidebars || $f1acc2f162895b38$var$routeComponents));
};
$f1acc2f162895b38$var$RightSidebarRouteComponents.displayName = "RightSidebarRouteComponents";
const $f1acc2f162895b38$export$fb85bbdbfb3e6869 = ()=>null;
const $f1acc2f162895b38$var$RightSidebarThroughEntrypoint = ()=>{
    const rightSideBarEntryPointReference = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$7bf43119a6b49ddb));
    if (!rightSideBarEntryPointReference) return null;
    const RightSideBarFallback = rightSideBarEntryPointReference?.extraProps?.fallback || $f1acc2f162895b38$export$fb85bbdbfb3e6869;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "right-sidebar-through-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-through-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
        name: "right-sidebar-through-entrypoint",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(RightSideBarFallback, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.ReportSSRFailOnUse), {
            pageId: "navigation",
            fallbackId: "RightSidebar",
            displayErrorInStaging: true
        })),
        entryPointReference: rightSideBarEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
        entryPointReference: rightSideBarEntryPointReference,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        props: {}
    }))));
};
$f1acc2f162895b38$var$RightSidebarThroughEntrypoint.displayName = "RightSidebarThroughEntrypoint";
const $f1acc2f162895b38$export$84d58c19c21f637f = ()=>{
    const lastPanelIdRef = (0, $euxye.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $29eRG.useActiveRightSidebarState)();
    (0, $euxye.useEffect)(()=>{
        (0, $aJ81Y.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.RightPanel), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
        testId: $f1acc2f162895b38$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f1acc2f162895b38$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f1acc2f162895b38$var$RightSidebarRouteComponents, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f1acc2f162895b38$var$RightSidebarThroughEntrypoint, null))));
};
$f1acc2f162895b38$export$84d58c19c21f637f.displayName = "RightSidebar";

});

parcelRegister("tEZUz", function(module, exports) {
$parcel$export(module.exports, "RedirectEntrypointContainer", () => $cf98397d4a90190b$export$1646bc91d273e9d3);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $h8QGu = parcelRequire("h8QGu");


var $btoiF = parcelRequire("btoiF");

var $dsVXF = parcelRequire("dsVXF");

var $gDdYI = parcelRequire("gDdYI");
const $cf98397d4a90190b$export$1646bc91d273e9d3 = ()=>{
    const redirectEntrypointRef = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$5ef29550cd5a8266));
    if (!redirectEntrypointRef) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "redirect-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "redirect-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
        name: "redirect-entrypoint",
        fallback: null,
        entryPointReference: redirectEntrypointRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
        entryPointReference: redirectEntrypointRef,
        props: {}
    }))));
};
$cf98397d4a90190b$export$1646bc91d273e9d3.displayName = "RedirectEntrypointContainer";

});

parcelRegister("72Dhb", function(module, exports) {
$parcel$export(module.exports, "RightAdsPanel", () => $008e389c120bf63e$export$d689ae172115ad34);

var $euxye = parcelRequire("euxye");

var $6MMSf = parcelRequire("6MMSf");

var $3n4KE = parcelRequire("3n4KE");
var $j8sj1 = parcelRequire("j8sj1");
var $lB9M9 = parcelRequire("lB9M9");
const $008e389c120bf63e$export$d689ae172115ad34 = ()=>{
    const { state: state } = (0, $lB9M9.usePanelManager)();
    return state.activePanels.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.RightPanel), {
        testId: "page-container-v2.common.ui.right-ads-panel.dst-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j8sj1.PanelsRenderer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3n4KE.PanelRouter), null))) : null;
};
$008e389c120bf63e$export$d689ae172115ad34.displayName = "RightAdsPanel";

});
parcelRegister("3n4KE", function(module, exports) {
$parcel$export(module.exports, "PanelRouter", () => $db63c56515aff087$export$4f89031e4f2ac8db);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8Sdzy = parcelRequire("8Sdzy");

var $gAEFP = parcelRequire("gAEFP");

var $kWKM8 = parcelRequire("kWKM8");

var $dedzN = parcelRequire("dedzN");
function $db63c56515aff087$var$isEntryPointPanel(panel) {
    return typeof panel === 'object' && panel !== null && 'entryPointReference' in panel;
}
function $db63c56515aff087$export$4f89031e4f2ac8db({ wrapper: wrapper, fallback: fallback = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kWKM8.PanelSkeleton), {}), errorFallback: errorFallback = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
        as: "p",
        children: "Error loading panel"
    }) }) {
    const { panel: panel } = (0, $dedzN.usePanel)();
    const { params: params, instanceId: instanceId } = panel;
    let contentToRender = null;
    if ($db63c56515aff087$var$isEntryPointPanel(panel) && panel.entryPointReference) contentToRender = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gAEFP.InternalEntryPointContainer), {
        id: instanceId,
        entryPointReference: panel.entryPointReference,
        fallback: fallback,
        errorFallback: errorFallback,
        // @ts-expect-error - runtimeProps type is inferred from entryPointReference, but we're using dynamic params from panel state
        runtimeProps: params || {}
    });
    else if ('panelContent' in panel && panel.panelContent) contentToRender = panel.panelContent;
    else return null;
    // If a wrapper is provided, wrap the content
    if (wrapper) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: wrapper({
            children: contentToRender
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: contentToRender
    });
}
$db63c56515aff087$export$4f89031e4f2ac8db.displayName = "PanelRouter";

});
parcelRegister("kWKM8", function(module, exports) {
$parcel$export(module.exports, "PanelSkeleton", () => $edcf981f12176f35$export$7f4e90770af00c8a);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $kEMW4 = parcelRequire("kEMW4");

var $dRxWN = parcelRequire("dRxWN");

var $cPM36 = parcelRequire("cPM36");

var $9OCDl = parcelRequire("9OCDl");

var $hJjfq = parcelRequire("hJjfq");
function $edcf981f12176f35$export$7f4e90770af00c8a() {
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $kEMW4.PanelContainer), {
        testId: "panel-container-skeleton",
        "aria-label": "Loading",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9OCDl.PanelHeaderSkeleton), {
                shouldShowIcon: true,
                actionsCount: 1
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $dRxWN.PanelContent), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hJjfq.PanelSubheaderSkeleton), {}),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cPM36.PanelBodySkeleton), {})
                ]
            })
        ]
    });
}
$edcf981f12176f35$export$7f4e90770af00c8a.displayName = "PanelSkeleton";

});
parcelRegister("dRxWN", function(module, exports) {
$parcel$export(module.exports, "PanelContent", () => $ce45261c819efb11$export$d30ae7d97aafb468);
/* panel-content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
const $ce45261c819efb11$var$styles = {
    content: "_1reo1wug _18m91wug _1e0c1txw _2lx21bp4 _16jlkb7n _1tkeidpf"
};
function $ce45261c819efb11$export$d30ae7d97aafb468({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        testId: testId,
        xcss: $ce45261c819efb11$var$styles.content,
        children: children
    });
}
$ce45261c819efb11$export$d30ae7d97aafb468.displayName = "PanelContent";

});

parcelRegister("cPM36", function(module, exports) {
$parcel$export(module.exports, "PanelBodySkeleton", () => $776b1c50a00059ae$export$4986b35fc23c4f9);
/* panel-body-skeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");

var $3NRLa = parcelRequire("3NRLa");

var $7O8M3 = parcelRequire("7O8M3");
const $776b1c50a00059ae$var$styles = {
    skeletonRow: "_1e0c1txw _4cvr1h6o _4t3i1k92 _1bsb1osq"
};
const $776b1c50a00059ae$var$SkeletonRow = ({ width: width })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $776b1c50a00059ae$var$styles.skeletonRow,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
            width: width,
            height: "0.625rem",
            borderRadius: "var(--ds-radius-full, 9999px)"
        })
    });
};
$776b1c50a00059ae$var$SkeletonRow.displayName = "SkeletonRow";
function $776b1c50a00059ae$export$4986b35fc23c4f9() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7O8M3.PanelBody), {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)($776b1c50a00059ae$var$SkeletonRow, {
                    width: "75%"
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)($776b1c50a00059ae$var$SkeletonRow, {
                    width: "90%"
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)($776b1c50a00059ae$var$SkeletonRow, {
                    width: "80%"
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)($776b1c50a00059ae$var$SkeletonRow, {
                    width: "85%"
                })
            ]
        })
    });
}
$776b1c50a00059ae$export$4986b35fc23c4f9.displayName = "PanelBodySkeleton";

});

parcelRegister("9OCDl", function(module, exports) {
$parcel$export(module.exports, "PanelHeaderSkeleton", () => $f5b2af96f58eb849$export$d7eab9fd01507d88);
/* panel-header-skeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $3NRLa = parcelRequire("3NRLa");

var $eb9Iw = parcelRequire("eb9Iw");

var $hgExa = parcelRequire("hgExa");
const $f5b2af96f58eb849$var$styles = {
    title: "_zulp1b66 _1e0c1txw _4cvr1h6o _16jlkb7n",
    icon: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s"
};
function $f5b2af96f58eb849$export$d7eab9fd01507d88({ shouldShowIcon: shouldShowIcon, actionsCount: actionsCount }) {
    const showActions = actionsCount !== undefined && actionsCount > 0;
    const ActionSkeletons = showActions ? Array.from({
        length: actionsCount
    }, (_, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
            width: "1rem",
            height: "1rem",
            borderRadius: "var(--ds-radius-tile, 25%)"
        }, index)) : [];
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $hgExa.PanelHeader), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                xcss: $f5b2af96f58eb849$var$styles.title,
                children: [
                    shouldShowIcon && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                        xcss: $f5b2af96f58eb849$var$styles.icon,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                            width: "1rem",
                            height: "1rem",
                            borderRadius: "var(--ds-radius-tile, 25%)"
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                        width: 120,
                        height: "0.75rem",
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    })
                ]
            }),
            showActions && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eb9Iw.PanelActionGroup), {
                children: ActionSkeletons
            })
        ]
    });
}
$f5b2af96f58eb849$export$d7eab9fd01507d88.displayName = "PanelHeaderSkeleton";

});

parcelRegister("hJjfq", function(module, exports) {
$parcel$export(module.exports, "PanelSubheaderSkeleton", () => $6817b812d4a4bf6f$export$20987bd96e0b3d3c);
/* panel-subheader-skeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $3NRLa = parcelRequire("3NRLa");
const $6817b812d4a4bf6f$var$styles = {
    subheader: "_zulputpp _1e0c1txw _4t3i8pqr _4cvr1h6o _85i5pxbi _bozg1ejb _y4ti1ejb",
    icon: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s"
};
function $6817b812d4a4bf6f$export$20987bd96e0b3d3c({ shouldShowIcon: shouldShowIcon }) {
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        xcss: $6817b812d4a4bf6f$var$styles.subheader,
        children: [
            shouldShowIcon && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $6817b812d4a4bf6f$var$styles.icon,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                    width: "1.5rem",
                    height: "1.5rem",
                    borderRadius: "var(--ds-radius-tile, 25%)"
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                width: 120,
                height: "0.9375rem",
                borderRadius: "var(--ds-radius-full, 9999px)"
            })
        ]
    });
}
$6817b812d4a4bf6f$export$20987bd96e0b3d3c.displayName = "PanelSubheaderSkeleton";

});


parcelRegister("dedzN", function(module, exports) {
$parcel$export(module.exports, "PanelContext", () => $aee0663e39b03808$export$f34532ac99e32150);
$parcel$export(module.exports, "usePanel", () => $aee0663e39b03808$export$9168a42f32e3d071);

var $euxye = parcelRequire("euxye");

var $lRV6k = parcelRequire("lRV6k");
const $aee0663e39b03808$export$f34532ac99e32150 = /*#__PURE__*/ (0, $euxye.createContext)(null);
function $aee0663e39b03808$export$66ae79795fa7462d() {
    const panel = (0, $euxye.useContext)($aee0663e39b03808$export$f34532ac99e32150);
    if (!panel) throw new Error("useCurrentPanel must be used within a PanelsRenderer with PanelContext.Provider. Make sure your component is a child of a panel context provider.");
    return panel;
}
function $aee0663e39b03808$export$73990069b76b7b23() {
    const panel = $aee0663e39b03808$export$66ae79795fa7462d();
    const manager = (0, $lRV6k.usePanelActionsInternal)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(()=>{
        manager.closePanel(panel.instanceId);
    }, [
        manager,
        panel.instanceId
    ]);
}
function $aee0663e39b03808$export$9168a42f32e3d071() {
    const panel = $aee0663e39b03808$export$66ae79795fa7462d();
    const closePanel = $aee0663e39b03808$export$73990069b76b7b23();
    return {
        panel: panel,
        closePanel: closePanel
    };
}

});


parcelRegister("j8sj1", function(module, exports) {
$parcel$export(module.exports, "PanelsRenderer", () => $1aeeb9c9ed63c66e$export$612204afd4e28045);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gTGvd = parcelRequire("gTGvd");

var $dedzN = parcelRequire("dedzN");
function $1aeeb9c9ed63c66e$export$612204afd4e28045({ children: children }) {
    const state = (0, $gTGvd.usePanelStateInternal)();
    // If there are no panels, render nothing
    if (state.activePanels.length === 0) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: state.activePanels.map((panel)=>{
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dedzN.PanelContext).Provider, {
                value: panel,
                children: children
            }, panel.instanceId);
        })
    });
}
$1aeeb9c9ed63c66e$export$612204afd4e28045.displayName = "PanelsRenderer";

});


parcelRegister("hR4Oj", function(module, exports) {
$parcel$export(module.exports, "JiraPageLayout", () => $6220cb7fa39c03e2$export$9f8e98a8a88e6943);

var $euxye = parcelRequire("euxye");

var $dFaXk = parcelRequire("dFaXk");

var $2700E = parcelRequire("2700E");

var $aWliK = parcelRequire("aWliK");

var $2KMaX = parcelRequire("2KMaX");

var $6MMSf = parcelRequire("6MMSf");
// Used when full height sidebar is enabled
const $6220cb7fa39c03e2$var$PageLayoutWithFHSChanges = ({ children: children, ...props })=>{
    const { isCollapsed: isCollapsed } = (0, $2KMaX.useLeftSidebarState)();
    const [defaultSideNavCollapsed] = (0, $euxye.useState)(isCollapsed);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dFaXk.IsFhsEnabledProvider), {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.PageLayout), {
        ...props,
        defaultSideNavCollapsed: defaultSideNavCollapsed,
        isSideNavShortcutEnabled: true
    }, children));
};
$6220cb7fa39c03e2$var$PageLayoutWithFHSChanges.displayName = "PageLayoutWithFHSChanges";
const $6220cb7fa39c03e2$var$PageLayoutWithoutFhsChanges = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dFaXk.IsFhsEnabledProvider), {
        value: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.PageLayout), props, children));
$6220cb7fa39c03e2$var$PageLayoutWithoutFhsChanges.displayName = "PageLayoutWithoutFhsChanges";
const $6220cb7fa39c03e2$export$9f8e98a8a88e6943 = (0, $aWliK.componentWithCondition)(()=>(0, $2700E.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false), $6220cb7fa39c03e2$var$PageLayoutWithFHSChanges, $6220cb7fa39c03e2$var$PageLayoutWithoutFhsChanges);

});
parcelRegister("dFaXk", function(module, exports) {
$parcel$export(module.exports, "IsFhsEnabledProvider", () => $81fc0c4bdae8ef6d$export$797f6437373337da);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $zzw4R = parcelRequire("zzw4R");

var $ltR6m = parcelRequire("ltR6m");
const $81fc0c4bdae8ef6d$export$797f6437373337da = ({ children: children, value: value })=>{
    const isCustomIsFhsEnabled = (0, $euxye.useContext)((0, $zzw4R.IsCustomIsFhsEnabledContext));
    if (isCustomIsFhsEnabled) throw new Error('A custom value for IsFhsEnabledContext has already been provided');
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $zzw4R.IsCustomIsFhsEnabledContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ltR6m.IsFhsEnabledContext).Provider, {
            value: value,
            children: children
        })
    });
};
$81fc0c4bdae8ef6d$export$797f6437373337da.displayName = "IsFhsEnabledProvider";

});
parcelRegister("zzw4R", function(module, exports) {
$parcel$export(module.exports, "IsCustomIsFhsEnabledContext", () => $3f4fe736344b750a$export$79cc7820899d3234);

var $euxye = parcelRequire("euxye");
const $3f4fe736344b750a$export$79cc7820899d3234 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});



parcelRegister("cbY0l", function(module, exports) {
$parcel$export(module.exports, "GlobalThemeSetter", () => $0a8a8084ed5af7c2$export$c8947eb2c95eab56);

var $euxye = parcelRequire("euxye");

var $4C7HL = parcelRequire("4C7HL");

var $e3Hh1 = parcelRequire("e3Hh1");

var $u9iDa = parcelRequire("u9iDa");

var $6Kdw4 = parcelRequire("6Kdw4");

var $7Zyu5 = parcelRequire("7Zyu5");

var $k6ufm = parcelRequire("k6ufm");

var $fngNu = parcelRequire("fngNu");

var $fg6Qq = parcelRequire("fg6Qq");
var $hgR5s = parcelRequire("hgR5s");
const $0a8a8084ed5af7c2$var$getDarkThemeMediaMatchQuery = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.matchMedia?.('(prefers-color-scheme: dark)');
function $0a8a8084ed5af7c2$var$setThemeCookieWhenIdle(theme) {
    if (!false) // this is an optimization to ensure that we don't get a white "flash" when dark mode is on, allowing
    // SSR to flush an <html> tag with the theme set.
    return (0, $fngNu.callWhenIdle)(()=>{
        if (!theme) (0, $fg6Qq.deleteCookie)('jira_theme');
        else (0, $hgR5s.setCookie)('jira_theme', theme, {
            expires: 30,
            secure: true,
            sameSite: 'strict'
        });
    }, 1000);
}
const $0a8a8084ed5af7c2$export$c8947eb2c95eab56 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)((0, $7Zyu5.themePreferenceResource));
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $euxye.useState)(()=>{
        if (loading || error || !data) // actually that's a misconfiguration and should never happen
        // but we still need to check (and it did happen in the past)
        return false;
        if (false) // let's make SSR behavior more explicit - no, styles are not in the head, render them
        return false;
        // check if the theme styles are already in the <head />.
        return Boolean((0, $u9iDa.getDocument)()?.head.querySelector('style[data-theme]'));
    });
    (0, $euxye.useEffect)(()=>{
        if (loading || error || !data) return undefined;
        const darkThemeMediaMatchQuery = $0a8a8084ed5af7c2$var$getDarkThemeMediaMatchQuery();
        let cleanupIdleCallback;
        // Combine the themes 'dark', 'light' and 'auto' after @atlaskit/tokens@1.0.0
        // https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/27634
        if (data?.theme === 'auto') {
            const token = darkThemeMediaMatchQuery?.matches ? 'dark' : 'light';
            $0a8a8084ed5af7c2$var$setThemeWithToken(token, colorMode);
            cleanupIdleCallback = $0a8a8084ed5af7c2$var$setThemeCookieWhenIdle(token);
            const handler = (e)=>{
                const tokenValue = e.matches ? 'dark' : 'light';
                $0a8a8084ed5af7c2$var$setThemeWithToken(tokenValue, colorMode);
                cleanupIdleCallback?.();
                cleanupIdleCallback = $0a8a8084ed5af7c2$var$setThemeCookieWhenIdle(tokenValue);
            };
            darkThemeMediaMatchQuery?.addEventListener('change', handler);
            return ()=>{
                darkThemeMediaMatchQuery?.removeEventListener('change', handler);
                cleanupIdleCallback?.();
            };
        }
        if (data?.theme === 'dark' || data?.theme === 'light') {
            $0a8a8084ed5af7c2$var$setThemeWithToken(data?.theme, colorMode);
            cleanupIdleCallback = $0a8a8084ed5af7c2$var$setThemeCookieWhenIdle(data?.theme);
        }
        if (!data?.theme) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-theme');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-color-mode');
            cleanupIdleCallback = $0a8a8084ed5af7c2$var$setThemeCookieWhenIdle(null);
        }
        return cleanupIdleCallback;
    }, [
        data,
        loading,
        error,
        colorMode
    ]);
    (0, $euxye.useEffect)(()=>{
        if (loading || error || !data) return;
        (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            if (data?.theme) client.setUIViewedAttributes({
                theme: data.theme
            });
            else client.removeUIViewedAttribute('theme');
        });
    }, [
        data,
        loading,
        error
    ]);
    (0, $euxye.useEffect)(()=>{
        const darkThemeMediaMatchQuery = $0a8a8084ed5af7c2$var$getDarkThemeMediaMatchQuery();
        (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            client.setUIViewedAttributes({
                OStheme: darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
            });
        });
    }, []);
    // @atlaskit/tokens expects the theme styles to be in the <head /> but they're
    // initially rendered in the "jira-ssr" container in the <body /> and then moved to the
    // <head />. The following prevents the styles from being re-rendered in the <body />.
    (0, $euxye.useEffect)(()=>{
        // this useEffect will be executed after the "move script" right below regardless of the SSR presence or absence
        // safe to say - setIsThemeStylesInHead wil be always true after the first render
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head.querySelector('style[data-theme]')) // eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
        setIsThemeStylesInHead(true);
    }, []);
    if (!data?.theme || !data?.attrs || !data?.styles) return null;
    const ssrAutoScript = (0, $e3Hh1.default)(data.theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("style", {
            key: theme.id,
            ...theme.attrs,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: theme.css
            }
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: Object.entries(data.attrs).map(([key, val])=>{
                if (key === 'data-color-mode' && ssrAutoScript) return '';
                return `document.documentElement.setAttribute("${key}", "${val}");`;
            }).join('\n')
        }
    }), ssrAutoScript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrAutoScript
        }
    }) : null);
};
$0a8a8084ed5af7c2$export$c8947eb2c95eab56.displayName = "GlobalThemeSetter";

async function $0a8a8084ed5af7c2$var$setThemeWithToken(newTheme, currentTheme) {
    if (newTheme !== currentTheme) {
        const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("kSR5a"));
        loadThemeTokens(newTheme);
    }
}

});
parcelRegister("e3Hh1", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb53507c683d0e7b$export$2e2bcd8739ae039);

var $egspI = parcelRequire("egspI");

var $6er1G = parcelRequire("6er1G");

var $cDku3 = parcelRequire("cDku3");
/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ const $bb53507c683d0e7b$var$getSSRAutoScript = (colorMode, // TODO: This should be marked as required once safe to roll out.
contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $cDku3.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $6er1G.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $egspI.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $cDku3.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $6er1G.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $bb53507c683d0e7b$export$2e2bcd8739ae039 = $bb53507c683d0e7b$var$getSSRAutoScript;

});

parcelRegister("kSR5a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lxFg2").then(()=>parcelRequire('52Y8a'));

});


parcelRegister("bTil3", function(module, exports) {
$parcel$export(module.exports, "ProjectThemeSetter", () => $ea734e37a185f793$export$fd1b0084c5bb04a9);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $dIXu8 = parcelRequire("dIXu8");

var $h8QGu = parcelRequire("h8QGu");

var $f2wVS = parcelRequire("f2wVS");

var $a8EUd = parcelRequire("a8EUd");

var $htsFl = parcelRequire("htsFl");

var $gZWlI = parcelRequire("gZWlI");

var $j0ZQK = parcelRequire("j0ZQK");
const $ea734e37a185f793$export$7bf98640231e1ffa = (0, $f2wVS.createRouterSelector)((state)=>state.route.supportsProjectTheme);
const $ea734e37a185f793$export$fd1b0084c5bb04a9 = ()=>{
    const supportsProjectTheme = $ea734e37a185f793$export$7bf98640231e1ffa();
    const { queryReference: queryReference } = (0, $htsFl.useRelayResource)((0, $gZWlI.projectThemeResource));
    if (!queryReference || supportsProjectTheme == null) /* The resource is available only for routes enabled for theming.
		We still need to set the default token color by using ThemeTokenSetter for all other routes.
		This can be removed once theming is enabled for all pages. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j0ZQK.ThemeTokensSetter), {
        themeSetting: null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "projectThemeSetter",
        packageName: "jiraPageContainerV2",
        teamName: "wanjel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "project-theme-setter-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dIXu8.ThemeSetter), {
        queryReference: queryReference
    })));
};
$ea734e37a185f793$export$fd1b0084c5bb04a9.displayName = "ProjectThemeSetter";

});
parcelRegister("dIXu8", function(module, exports) {
$parcel$export(module.exports, "ThemeSetter", () => $5b5eb245ab9cd4b2$export$ce1303eaa27a0d3a);

var $e7boj = parcelRequire("e7boj");

var $b3idK = parcelRequire("b3idK");

var $5mxNm = parcelRequire("5mxNm");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $dFT3J = parcelRequire("dFT3J");

var $f99M0 = parcelRequire("f99M0");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $j0ZQK = parcelRequire("j0ZQK");

var $6AUBF = parcelRequire("6AUBF");
const $5b5eb245ab9cd4b2$export$28580a1170c06a39 = {
    type: 'color',
    value: (0, $dFT3J.NO_BACKGROUND_CONFIG).name
};
const $5b5eb245ab9cd4b2$export$ce1303eaa27a0d3a = (t0)=>{
    const $ = (0, $e7boj.c)(43);
    const { queryReference: queryReference } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const data = (0, $n67Vb.usePreloadedQuery)((0, $5mxNm.default), queryReference);
    const backgroundData = (0, $n67Vb.useFragment)((0, $b3idK.default), data.jira_projectByIdOrKey?.background ?? null);
    const projectId = data.jira_projectByIdOrKey?.projectId;
    const isProjectAdmin = data.jira_projectByIdOrKey?.canEditProjectConfig?.canPerform;
    const dominantColorPersister = data.jira_projectByIdOrKey?.DominantColorPersister_project;
    let t1;
    if ($[0] !== data.jira.mediaClientId || $[1] !== data.jira.mediaExternalEndpointUrl) {
        t1 = data.jira.mediaClientId && data.jira.mediaExternalEndpointUrl ? {
            clientId: data.jira.mediaClientId,
            externalEndpointUrl: data.jira.mediaExternalEndpointUrl
        } : null;
        $[0] = data.jira.mediaClientId;
        $[1] = data.jira.mediaExternalEndpointUrl;
        $[2] = t1;
    } else t1 = $[2];
    const media = t1;
    let t2;
    bb0: {
        let themeSetting = null;
        if (!backgroundData) {
            t2 = null;
            break bb0;
        }
        bb1: switch(backgroundData.__typename){
            case "JiraColorBackground":
                {
                    const t3 = backgroundData.colorValue;
                    let t4;
                    if ($[3] !== t3) {
                        t4 = {
                            type: "color",
                            value: t3
                        };
                        $[3] = t3;
                        $[4] = t4;
                    } else t4 = $[4];
                    themeSetting = t4;
                    break bb1;
                }
            case "JiraGradientBackground":
                {
                    const t3 = backgroundData.gradientValue;
                    let t4;
                    if ($[5] !== t3) {
                        t4 = {
                            type: "color",
                            value: t3
                        };
                        $[5] = t3;
                        $[6] = t4;
                    } else t4 = $[6];
                    themeSetting = t4;
                    break bb1;
                }
            case "JiraMediaBackground":
                if (backgroundData.customBackground != null) {
                    const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText, dominantColor: dominantColor, brightness: brightness } = backgroundData.customBackground;
                    let t3;
                    if ($[7] !== altText || $[8] !== brightness || $[9] !== dominantColor || $[10] !== id || $[11] !== mediaApiFileId || $[12] !== mediaReadToken || $[13] !== sourceIdentifier || $[14] !== sourceType) {
                        t3 = {
                            type: "image",
                            value: "image",
                            id: id,
                            mediaApiFileId: mediaApiFileId,
                            mediaReadToken: mediaReadToken,
                            sourceType: sourceType,
                            sourceIdentifier: sourceIdentifier,
                            altText: altText,
                            dominantColor: dominantColor,
                            brightness: brightness
                        };
                        $[7] = altText;
                        $[8] = brightness;
                        $[9] = dominantColor;
                        $[10] = id;
                        $[11] = mediaApiFileId;
                        $[12] = mediaReadToken;
                        $[13] = sourceIdentifier;
                        $[14] = sourceType;
                        $[15] = t3;
                    } else t3 = $[15];
                    themeSetting = t3;
                }
                break bb1;
            default:
                themeSetting = null;
        }
        let t3;
        if ($[16] !== projectId || $[17] !== themeSetting) {
            t3 = themeSetting ? {
                themeSetting: themeSetting,
                entityId: `project/${projectId}`
            } : null;
            $[16] = projectId;
            $[17] = themeSetting;
            $[18] = t3;
        } else t3 = $[18];
        t2 = t3;
    }
    const projectTheme = t2;
    const sourceType_0 = projectTheme?.themeSetting?.type === "image" ? projectTheme.themeSetting.sourceType : undefined;
    let t3;
    if ($[19] !== createAnalyticsEvent || $[20] !== data.jira_projectByIdOrKey?.projectType || $[21] !== projectId || $[22] !== projectTheme?.themeSetting?.value || $[23] !== sourceType_0) {
        t3 = ()=>{
            if (projectId) {
                if (data.jira_projectByIdOrKey?.projectType === (0, $f99M0.JIRA_PROJECT_TYPE_CORE_PROJECT) || data.jira_projectByIdOrKey?.projectType === (0, $f99M0.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT)) {
                    const theme = sourceType_0 === "UNSPLASH" ? "unsplash-image" : projectTheme?.themeSetting?.value;
                    (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), "theme evaluated", {
                        theme: theme,
                        projectId: projectId
                    });
                }
            }
        };
        $[19] = createAnalyticsEvent;
        $[20] = data.jira_projectByIdOrKey?.projectType;
        $[21] = projectId;
        $[22] = projectTheme?.themeSetting?.value;
        $[23] = sourceType_0;
        $[24] = t3;
    } else t3 = $[24];
    const t4 = projectTheme?.themeSetting?.value;
    const t5 = data.jira_projectByIdOrKey?.projectType;
    let t6;
    if ($[25] !== createAnalyticsEvent || $[26] !== projectId || $[27] !== sourceType_0 || $[28] !== t4 || $[29] !== t5) {
        t6 = [
            t4,
            sourceType_0,
            t5,
            createAnalyticsEvent,
            projectId
        ];
        $[25] = createAnalyticsEvent;
        $[26] = projectId;
        $[27] = sourceType_0;
        $[28] = t4;
        $[29] = t5;
        $[30] = t6;
    } else t6 = $[30];
    (0, $euxye.useEffect)(t3, t6);
    let t7;
    if ($[31] !== dominantColorPersister || $[32] !== isProjectAdmin || $[33] !== media || $[34] !== projectId || $[35] !== projectTheme) {
        t7 = projectId && isProjectAdmin && projectTheme?.themeSetting?.type === "image" && !projectTheme.themeSetting.dominantColor && media && dominantColorPersister && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6AUBF.DominantColorPersister), {
            themeSetting: projectTheme.themeSetting,
            media: media,
            projectFragment: dominantColorPersister
        });
        $[31] = dominantColorPersister;
        $[32] = isProjectAdmin;
        $[33] = media;
        $[34] = projectId;
        $[35] = projectTheme;
        $[36] = t7;
    } else t7 = $[36];
    const t8 = projectTheme?.themeSetting || null;
    let t9;
    if ($[37] !== media || $[38] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j0ZQK.ThemeTokensSetter), {
            media: media,
            themeSetting: t8
        });
        $[37] = media;
        $[38] = t8;
        $[39] = t9;
    } else t9 = $[39];
    let t10;
    if ($[40] !== t7 || $[41] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t7, t9);
        $[40] = t7;
        $[41] = t9;
        $[42] = t10;
    } else t10 = $[42];
    return t10;
};
$5b5eb245ab9cd4b2$export$ce1303eaa27a0d3a.displayName = "ThemeSetter";

});
parcelRegister("b3idK", function(module, exports) {
$parcel$export(module.exports, "default", () => $473670c5be8d18cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0059c367431a33a75de83f8ef6e2083d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $473670c5be8d18cf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThemeSetterBackground",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorValue"
                }
            ],
            "type": "JiraColorBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "gradientValue"
                }
            ],
            "type": "JiraGradientBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCustomBackground",
                    "kind": "LinkedField",
                    "name": "customBackground",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "mediaApiFileId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "durationInSeconds",
                                    "value": 900
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "mediaReadToken",
                            "storageKey": "mediaReadToken(durationInSeconds:900)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceIdentifier"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "altText"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "dominantColor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "brightness"
                        }
                    ]
                }
            ],
            "type": "JiraMediaBackground"
        }
    ],
    "type": "JiraActiveBackgroundDetailsResult",
    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
};
$473670c5be8d18cf$var$node.hash = "3c41e5a508924f980b8234232721902b";
var $473670c5be8d18cf$export$2e2bcd8739ae039 = $473670c5be8d18cf$var$node;

});

parcelRegister("j0ZQK", function(module, exports) {
$parcel$export(module.exports, "ThemeTokensSetter", () => $7b5c466595f299f6$export$41f41c7ff10d45cd);

var $euxye = parcelRequire("euxye");

var $6Fltw = parcelRequire("6Fltw");

var $dFT3J = parcelRequire("dFT3J");

var $b0DyI = parcelRequire("b0DyI");


var $8mTjv = parcelRequire("8mTjv");

var $80HZN = parcelRequire("80HZN");
const $7b5c466595f299f6$var$DEFAULT_DOMINANT_COLOR = '#FFFFFF';
/**
 * Will merge multiple themes together, with the last theme taking precedence.
 * The first argument is the base theme, and the rest are partial themes that
 * will be merged into the base theme.
 */ function $7b5c466595f299f6$var$mergeThemes(theme, ...partialThemes) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, theme, ...partialThemes);
}
const $7b5c466595f299f6$var$buildHorizontalNavVariables = ({ theme: theme, elevationSurface: elevationSurface })=>{
    return `${0, $14b2c96bfbb9c37b$export$539c074adec2188a}: ${theme['color.link']};
${0, $14b2c96bfbb9c37b$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $14b2c96bfbb9c37b$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $14b2c96bfbb9c37b$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $14b2c96bfbb9c37b$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $14b2c96bfbb9c37b$export$88e550ed188132a7}: ${elevationSurface};
${0, $14b2c96bfbb9c37b$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $14b2c96bfbb9c37b$export$4cd72d361867c565}: ${theme['color.border']};
${0, $14b2c96bfbb9c37b$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
};
const $7b5c466595f299f6$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode, themeSetting)=>{
    const applicationColorMode = isDarkMode ? 'dark' : 'light';
    const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $dFT3J.HIGH_BRIGHTNESS_THEME) : (0, $dFT3J.LOW_BRIGHTNESS_THEME);
    const isGradientConfig = (0, $b0DyI.themeManager).isGradientTheme(config.name);
    /**
   * The base theme and the custom theme get merged here, with the custom theme taking precedence.
   * If you want to override configurations globally, then you should make modifications to the
   * BASE_THEME, while if you want to customize a specific theme, then you should make modifications
   * in the theme's themselves.
   */ const theme = $7b5c466595f299f6$var$mergeThemes(// the base theme for the application
    (0, $dFT3J.BASE_THEME), brightnessOverrides, // gradient specific overrides
    isGradientConfig ? (0, $dFT3J.GRADIENT_THEME) : {}, // The custom background configuration
    config.theme[applicationColorMode]);
    let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
    let colorElevationSurface = theme['color.elevation.surface'];
    if (backgroundImageUrl) {
        let dominantColor = themeSetting?.type === 'image' && themeSetting.dominantColor ? themeSetting.dominantColor : undefined;
        let isUsingFallbackColor = false;
        if (themeSetting?.type === 'image' && !dominantColor) {
            dominantColor = $7b5c466595f299f6$var$DEFAULT_DOMINANT_COLOR;
            isUsingFallbackColor = true;
        }
        if (themeSetting?.type === 'image' && !!dominantColor) {
            const adjustedColor = (0, $80HZN.getAdjustedColor)({
                dominantColor: dominantColor,
                isDarkMode: isDarkMode
            });
            if (adjustedColor) {
                const gradient = isUsingFallbackColor ? `linear-gradient(hsl(${adjustedColor} / 0.6) 0px, hsl(${adjustedColor} / 0.5) 130px, hsl(${adjustedColor} / 0.35) 230px, hsl(${adjustedColor} / 0.2) 310px, hsl(${adjustedColor} / 0.1) 380px, hsl(${adjustedColor} / 0.05) 440px, hsl(${adjustedColor} / 0) 500px)` : `linear-gradient(hsl(${adjustedColor} / 0.9) 0px, hsl(${adjustedColor} / 0.85) 130px, hsl(${adjustedColor} / 0.7) 230px, hsl(${adjustedColor} / 0.5) 310px, hsl(${adjustedColor} / 0.3) 380px, hsl(${adjustedColor} / 0.15) 440px, hsl(${adjustedColor} / 0) 500px)`;
                elevationSurface = `${gradient}, url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
                colorElevationSurface = `hsl(${adjustedColor} / 1)`;
            }
        } else // in dark mode, the image will be darkened by blending with a black transparent background
        elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
    } else if (applicationColorMode === 'dark') {
        if ((0, $dFT3J.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig) /**
       * Add a gradient to the elevation surface for any themes in dark mode. This could be done in the
       * meta configuration but it's easier to do bulk edits here.
       */ elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #FFFFFF)"} 400px)`;
    }
    // Wrapper configuration
    const withWrapper = config.name !== (0, $dFT3J.DEFAULT_BACKGROUND_CONFIG).name;
    const wrapperBackground = withWrapper ? "var(--ds-surface, #FFFFFF)" : 'unset';
    const wrapperBorderRadius = withWrapper ? "var(--ds-radius-large, 8px)" : '0';
    const businessWrapperHeight = (0, $dFT3J.BUSINESS_WRAPPER_HEIGHT);
    const wrapperHeight = withWrapper ? (0, $dFT3J.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : businessWrapperHeight;
    const wrapperPadding = withWrapper ? `${0, $dFT3J.BUSINESS_WRAPPER_PADDING}px` : '0';
    const wrapperWidth = withWrapper ? (0, $dFT3J.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $dFT3J.BUSINESS_WRAPPER_WIDTH);
    return `
${(0, $dFT3J.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST}: ${theme['color.background.neutral.subtle.hovered.contrast']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_ACCENT_SELECTED}: ${theme['color.background.accent.selected']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $dFT3J.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $dFT3J.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $dFT3J.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $dFT3J.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $dFT3J.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $dFT3J.Variables).COLOR_ELEVATION_SURFACE}: ${colorElevationSurface};
${(0, $dFT3J.Variables).COLOR_ELEVATION_SURFACE_SUNKEN}: ${theme['color.elevation.surface.sunken']};
${(0, $dFT3J.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $dFT3J.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $dFT3J.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $dFT3J.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $dFT3J.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $dFT3J.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $dFT3J.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $dFT3J.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $dFT3J.Variables).COLOR_TEXT_ACCENT_SELECTED}: ${theme['color.text.accent.selected']};
${(0, $dFT3J.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $dFT3J.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $dFT3J.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $dFT3J.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $dFT3J.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $dFT3J.Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, $dFT3J.Variables).CONTENT_WIDTH}: ${0, $dFT3J.BUSINESS_WRAPPER_WIDTH};
${(0, $dFT3J.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $dFT3J.Variables).ELEVATION_SURFACE_BLEND_MODE}: ${theme['elevation.surface.blend.mode']};
${(0, $dFT3J.Variables).ELEVATION_SURFACE_CONTRAST}: 'transparent';
${(0, $dFT3J.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $dFT3J.Variables).ELEVATION_SURFACE_SWIMLANE}: ${theme['color.elevation.surface.swimlane']};
${(0, $dFT3J.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $dFT3J.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $dFT3J.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $dFT3J.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $dFT3J.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$7b5c466595f299f6$var$buildHorizontalNavVariables({
        theme: theme,
        elevationSurface: elevationSurface
    })}`;
};
const $7b5c466595f299f6$export$41f41c7ff10d45cd = /*#__PURE__*/ (0, $euxye.memo)(({ themeSetting: themeSetting, media: media })=>{
    const backgroundConfig = (0, $b0DyI.themeManager).get({
        themeSetting: themeSetting,
        enableImages: true
    });
    const backgroundImageUrl = (0, $8mTjv.useBackgroundImageUrl)(themeSetting, media);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `:root{ ${$7b5c466595f299f6$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false, themeSetting)} }
        [data-color-mode=dark]{ ${$7b5c466595f299f6$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true, themeSetting)} }`
        }
    }));
});

});
parcelRegister("b0DyI", function(module, exports) {
$parcel$export(module.exports, "themeManager", () => $a8969bfad5e671f9$export$aba92a7f3273f617);
$parcel$export(module.exports, "getBackgroundConfigs", () => $a8969bfad5e671f9$export$224c78c119a97f91);

var $dFT3J = parcelRequire("dFT3J");
const $a8969bfad5e671f9$var$ALL_COLOR_BACKGROUND_CONFIGS = [
    ...(0, $dFT3J.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
    (0, $dFT3J.NO_BACKGROUND_CONFIG)
];
const $a8969bfad5e671f9$var$ALL_GRADIENT_BACKGROUND_CONFIGS = (0, $dFT3J.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS);
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $a8969bfad5e671f9$var$ThemeManager {
    init() {
        $a8969bfad5e671f9$var$ALL_GRADIENT_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        $a8969bfad5e671f9$var$ALL_COLOR_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages }) {
        if (!themeSetting) return 0, $dFT3J.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return 0, $dFT3J.ADAPTIVE_IMAGE_BACKGROUND_CONFIG;
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $dFT3J.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $dFT3J.DEFAULT_BACKGROUND_CONFIG);
        return 0, $dFT3J.DEFAULT_BACKGROUND_CONFIG;
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
$a8969bfad5e671f9$var$ThemeManager.displayName = "ThemeManager";
const $a8969bfad5e671f9$export$aba92a7f3273f617 = new $a8969bfad5e671f9$var$ThemeManager();
$a8969bfad5e671f9$export$aba92a7f3273f617.init();
function $a8969bfad5e671f9$export$224c78c119a97f91() {
    return {
        backgroundColorConfigs: (0, $dFT3J.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $dFT3J.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
    };
}

});

const $14b2c96bfbb9c37b$export$d1b9ea3245b6a5de = 3;
const $14b2c96bfbb9c37b$export$d07bba395c9390f1 = 32;
const $14b2c96bfbb9c37b$export$29911ec08ab2ca2d = 5;
const $14b2c96bfbb9c37b$export$b61e6f89a9db76de = 4;
const $14b2c96bfbb9c37b$export$7fd2e391116c6ef5 = 9;
const $14b2c96bfbb9c37b$export$e1633e494d305bfb = 'MORE';
const $14b2c96bfbb9c37b$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $14b2c96bfbb9c37b$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $14b2c96bfbb9c37b$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $14b2c96bfbb9c37b$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $14b2c96bfbb9c37b$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $14b2c96bfbb9c37b$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $14b2c96bfbb9c37b$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $14b2c96bfbb9c37b$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $14b2c96bfbb9c37b$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $14b2c96bfbb9c37b$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $14b2c96bfbb9c37b$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("8mTjv", function(module, exports) {
$parcel$export(module.exports, "useBackgroundImageUrl", () => $e9bab3b607472a71$export$16f28a2a10ece447);

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $3dWIl = parcelRequire("3dWIl");

var $lCetP = parcelRequire("lCetP");

var $kWDSA = parcelRequire("kWDSA");
const $e9bab3b607472a71$export$16f28a2a10ece447 = (themeSetting, media)=>{
    const lowResUrl = (0, $euxye.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $3dWIl.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $euxye.useState)(lowResUrl);
    const previousThemeId = (0, $euxye.useRef)(null);
    const abortControllerRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (themeSetting?.type !== 'image') {
            previousThemeId.current = null;
            setImageUrl(null);
            return;
        }
        if (previousThemeId.current !== themeSetting.id && media) {
            if (abortControllerRef.current) abortControllerRef.current.abort();
            abortControllerRef.current = new AbortController();
            previousThemeId.current = themeSetting.id;
            setImageUrl(lowResUrl);
            // build a new URL to the /binary path
            const binaryUrl = (0, $3dWIl.generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            // send a request to fetch the image with the binary URL with bearer token authentication
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                },
                signal: abortControllerRef.current?.signal
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $kWDSA.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }).catch((error)=>{
                if (error.name === 'AbortError') return;
                // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
                if (!(0, $lCetP.isClientFetchError)(error)) (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraProjectThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});
parcelRegister("3dWIl", function(module, exports) {
$parcel$export(module.exports, "generateMediaImageUrl", () => $a41995c9e7a18e73$export$fe2402bbc6ac3125);
function $a41995c9e7a18e73$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}

});

parcelRegister("kWDSA", function(module, exports) {
$parcel$export(module.exports, "unsplashTracker", () => $9d1ba0e1c7b6ca13$export$1869e04dbed4c16c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bvvEj = parcelRequire("bvvEj");

var $eVMQF = parcelRequire("eVMQF");
const $9d1ba0e1c7b6ca13$var$APP_ID = '7066';
const $9d1ba0e1c7b6ca13$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$9d1ba0e1c7b6ca13$var$APP_ID}`;
const $9d1ba0e1c7b6ca13$var$MAX_URL_LENGTH = 2083; // the maximum length of a URL in most browsers
const $9d1ba0e1c7b6ca13$var$ID_LENGTH = 12; // the length of an unsplash image id
const $9d1ba0e1c7b6ca13$export$28219189b23a0628 = Math.floor($9d1ba0e1c7b6ca13$var$MAX_URL_LENGTH / $9d1ba0e1c7b6ca13$var$ID_LENGTH);
/**
 * This class is responsible for tracking unsplash images that are displayed in the app.
 * This is needed for legal reasons to comply with the Unsplash API terms of service.
 * It will track the image when it is displayed and then track it again every 10 minutes.
 */ class $9d1ba0e1c7b6ca13$var$UnsplashTracker {
    /**
	 * Send a request to the Unsplash API to track the image views.
	 * This will send a request for all the images in the queue.
	 * If the request fails, the images will be added back to the queue.
	 */ send() {
        if (this.queue.size === 0) return;
        const imageIds = Array.from(this.queue);
        this.queue.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($bvvEj)))(imageIds, $9d1ba0e1c7b6ca13$export$28219189b23a0628).forEach((chunkIds)=>{
            const url = `${$9d1ba0e1c7b6ca13$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
            const now = new Date();
            imageIds.forEach((imageId)=>{
                this.trackedImages.set(imageId, now);
            });
            const handleFailure = ()=>{
                // if the request fails, add the image ids back to the queue
                imageIds.forEach((imageId)=>{
                    this.queue.add(imageId);
                    this.trackedImages.delete(imageId);
                });
            };
            fetch(url).then((response)=>{
                if (!response.ok) handleFailure();
            }).catch(()=>handleFailure());
        });
    }
    /**
	 * Track an image view. This will add the image to the queue to be tracked.
	 * If the image was tracked less than 10 minutes ago, it will not be added to the queue.
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns void
	 */ trackImage(sourceIdentifier) {
        const imageId = sourceIdentifier.split('-').pop(); // photo-1696144706485-ff7825ec8481 -> ff7825ec8481
        if (!imageId) return;
        const lastTracked = this.trackedImages.get(imageId);
        if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
        this.queue.add(imageId);
        this.sendDebounced();
    }
    /**
	 * Track an image view while it is in the viewport. This will track the image when it is displayed
	 * and then track it again every 10 minutes.
	 * @param element The element that contains the image
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns A function to stop tracking the image
	 */ trackWhileInViewport(element, sourceIdentifier) {
        let trackIntervalId = null;
        const observer = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && !trackIntervalId) {
                $9d1ba0e1c7b6ca13$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                trackIntervalId = window.setInterval(()=>{
                    $9d1ba0e1c7b6ca13$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                }, this.trackingInterval + 10); // extra 10ms to ensure the interval is always greater than 10 minutes
            } else if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        };
    }
    static getInstance() {
        if (!$9d1ba0e1c7b6ca13$var$UnsplashTracker.instance) $9d1ba0e1c7b6ca13$var$UnsplashTracker.instance = new $9d1ba0e1c7b6ca13$var$UnsplashTracker();
        return $9d1ba0e1c7b6ca13$var$UnsplashTracker.instance;
    }
    constructor(){
        this.trackedImages = new Map();
        this.trackingInterval = 600000; // 10 minutes
        this.queue = new Set();
        this.sendDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))(this.send, 1000);
    }
}
$9d1ba0e1c7b6ca13$var$UnsplashTracker.displayName = "UnsplashTracker";
const $9d1ba0e1c7b6ca13$export$1869e04dbed4c16c = $9d1ba0e1c7b6ca13$var$UnsplashTracker.getInstance();

});
parcelRegister("bvvEj", function(module, exports) {

var $g2svi = parcelRequire("g2svi");

var $4qbYM = parcelRequire("4qbYM");

var $4NLnC = parcelRequire("4NLnC");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02297851d8c9930c$var$nativeCeil = Math.ceil, $02297851d8c9930c$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $02297851d8c9930c$var$chunk(array, size, guard) {
    if (guard ? $4qbYM(array, size, guard) : size === undefined) size = 1;
    else size = $02297851d8c9930c$var$nativeMax($4NLnC(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($02297851d8c9930c$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $g2svi(array, index, index += size);
    return result;
}
module.exports = $02297851d8c9930c$var$chunk;

});



parcelRegister("80HZN", function(module, exports) {
$parcel$export(module.exports, "getAdjustedColor", () => $987e8f7e92184a78$export$e7544aa016cb7a22);
/**
 * Converts a hex color string to HSL (Hue, Saturation, Lightness) values
 * Reference: W3C CSS Color Module Level 4
 * https://www.w3.org/TR/css-color-4/#rgb-to-hsl
 *
 * The conversion process:
 * 1. Convert hex to RGB (base 16 to decimal, normalized to [0,1])
 * 2. Find the minimum and maximum RGB values to determine lightness
 * 3. Calculate saturation based on lightness
 * 4. Calculate hue based on which RGB component is the maximum
 */ function $987e8f7e92184a78$var$hexToHSL(hexProp) {
    let hex = hexProp.replace(/^#/, '');
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    const r = parseInt(hex.slice(0, 2), 16) / 255;
    const g = parseInt(hex.slice(2, 4), 16) / 255;
    const b = parseInt(hex.slice(4, 6), 16) / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h;
    let s;
    const l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
            default:
                h = (r - g) / d + 4;
                break;
        }
        h *= 60;
    }
    return {
        h: Math.round(h),
        s: Math.round(s * 100),
        l: Math.round(l * 100)
    };
}
function $987e8f7e92184a78$export$e7544aa016cb7a22({ dominantColor: dominantColor, isDarkMode: isDarkMode }) {
    // Convert the hex to HSL
    const { h: h, s: s, l: l } = $987e8f7e92184a78$var$hexToHSL(dominantColor);
    if (isDarkMode) // Dont need much adjustment for dark mode - just darken it
    return `${h} ${s}% ${Math.min(l, 26)}%`;
    const LIGHTNESS_TARGET = 75;
    const HIGH_LIGHTNESS_THRESHOLD = 70;
    if (l > HIGH_LIGHTNESS_THRESHOLD || l > 53 && s > 60) // Text already readable
    return `${h} ${s}% ${Math.max(l, 64)}%`;
    let saturation = s;
    // Cap over-saturated blues
    if (h >= 200 && h <= 220 && s > 65) saturation = 65;
    return `${h} ${saturation}% ${LIGHTNESS_TARGET}%`;
}

});


parcelRegister("6AUBF", function(module, exports) {
$parcel$export(module.exports, "DominantColorPersister", () => $457402db923f2cf4$export$17621776abf3a64d);

var $e7boj = parcelRequire("e7boj");

var $fxZpw = parcelRequire("fxZpw");

var $lH9hV = parcelRequire("lH9hV");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $3dWIl = parcelRequire("3dWIl");

var $hFtK7 = parcelRequire("hFtK7");

var $fMgNj = parcelRequire("fMgNj");

var $kt86l = parcelRequire("kt86l");

var $9TRdR = parcelRequire("9TRdR");
const $457402db923f2cf4$var$callWhenIdle = (callback)=>{
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') {
        const id = requestIdleCallback(callback);
        return ()=>cancelIdleCallback(id);
    }
    const id = setTimeout(callback, 0);
    return ()=>clearTimeout(id);
};
const $457402db923f2cf4$export$17621776abf3a64d = (t0)=>{
    const $ = (0, $e7boj.c)(19);
    const { themeSetting: themeSetting, media: media, projectFragment: projectFragment } = t0;
    const computedForRef = (0, $euxye.useRef)(null);
    const cloudId = (0, $kt86l.useCloudId)();
    const project = (0, $n67Vb.useFragment)((0, $lH9hV.default), projectFragment);
    const [commitMutation] = (0, $n67Vb.useMutation)((0, $fxZpw.default));
    const onError = $457402db923f2cf4$var$_temp;
    let t1;
    if ($[0] !== cloudId || $[1] !== commitMutation || $[2] !== media || $[3] !== project.projectId || $[4] !== themeSetting.altText || $[5] !== themeSetting.brightness || $[6] !== themeSetting.id || $[7] !== themeSetting.mediaApiFileId || $[8] !== themeSetting.mediaReadToken || $[9] !== themeSetting.sourceIdentifier || $[10] !== themeSetting.sourceType) {
        t1 = ()=>{
            if (computedForRef.current === themeSetting.mediaApiFileId) return;
            let cancelled = false;
            const cancelIdle = $457402db923f2cf4$var$callWhenIdle(()=>{
                computedForRef.current = themeSetting.mediaApiFileId;
                const url = (0, $3dWIl.generateMediaImageUrl)({
                    mediaApiFileId: themeSetting.mediaApiFileId,
                    mediaClientId: media.clientId,
                    mediaExternalEndpointUrl: media.externalEndpointUrl,
                    mediaEndpoint: "image",
                    token: themeSetting.mediaReadToken,
                    width: 206
                });
                (0, $9TRdR.getDominantColor)(url, (0, $9TRdR.SELECT_CUSTOM_IMAGE)).then((color)=>{
                    if (cancelled) return;
                    commitMutation({
                        variables: {
                            entityId: `ari:cloud:jira:${cloudId}:project/${project.projectId}`,
                            backgroundType: "CUSTOM",
                            backgroundValue: themeSetting.id,
                            dominantColor: color
                        },
                        optimisticResponse: {
                            jira_updateProjectBackground: {
                                success: true,
                                errors: null,
                                project: {
                                    id: project.projectId,
                                    background: {
                                        __typename: "JiraMediaBackground",
                                        customBackground: {
                                            id: themeSetting.id,
                                            dominantColor: color,
                                            mediaApiFileId: themeSetting.mediaApiFileId,
                                            mediaReadToken: themeSetting.mediaReadToken,
                                            sourceIdentifier: themeSetting.sourceIdentifier,
                                            sourceType: themeSetting.sourceType,
                                            altText: themeSetting.altText,
                                            brightness: themeSetting.brightness
                                        }
                                    }
                                }
                            }
                        },
                        onCompleted: (response)=>{
                            const { errors: errors } = response?.jira_updateProjectBackground ?? {};
                            const error_0 = errors?.find($457402db923f2cf4$var$_temp2);
                            if (error_0) onError(new (0, $fMgNj.MutationError)(error_0));
                        },
                        onError: onError
                    });
                }).catch((error_1)=>onError(error_1));
            });
            return ()=>{
                cancelled = true;
                cancelIdle();
            };
        };
        $[0] = cloudId;
        $[1] = commitMutation;
        $[2] = media;
        $[3] = project.projectId;
        $[4] = themeSetting.altText;
        $[5] = themeSetting.brightness;
        $[6] = themeSetting.id;
        $[7] = themeSetting.mediaApiFileId;
        $[8] = themeSetting.mediaReadToken;
        $[9] = themeSetting.sourceIdentifier;
        $[10] = themeSetting.sourceType;
        $[11] = t1;
    } else t1 = $[11];
    const t2 = project.canEditProjectConfig?.canPerform;
    let t3;
    if ($[12] !== cloudId || $[13] !== commitMutation || $[14] !== media || $[15] !== project.projectId || $[16] !== t2 || $[17] !== themeSetting) {
        t3 = [
            themeSetting,
            media,
            cloudId,
            commitMutation,
            project.projectId,
            t2
        ];
        $[12] = cloudId;
        $[13] = commitMutation;
        $[14] = media;
        $[15] = project.projectId;
        $[16] = t2;
        $[17] = themeSetting;
        $[18] = t3;
    } else t3 = $[18];
    (0, $euxye.useEffect)(t1, t3);
    return null;
};
$457402db923f2cf4$export$17621776abf3a64d.displayName = "DominantColorPersister";
function $457402db923f2cf4$var$_temp(error) {
    (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            id: "persistDominantColor",
            packageName: "jiraProjectThemeSetter",
            teamName: "Wanjel"
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
}
function $457402db923f2cf4$var$_temp2(e) {
    return e.message;
}

});
parcelRegister("fxZpw", function(module, exports) {
$parcel$export(module.exports, "default", () => $94d8147ff4475865$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<922c292bff06370043898ba5f31d4cc6>>
 * @relayHash 5b5900af74febfaa4c38e8a87d66f1ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e337f9a844dc439e68d0e4f4034d804d0b86dd187da4d8a42b5c6182bf329cce
const $94d8147ff4475865$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "backgroundType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "backgroundValue"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dominantColor"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityId"
    }, v4 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "backgroundType",
                    "variableName": "backgroundType"
                },
                {
                    "kind": "Variable",
                    "name": "backgroundValue",
                    "variableName": "backgroundValue"
                },
                {
                    "kind": "Variable",
                    "name": "dominantColor",
                    "variableName": "dominantColor"
                },
                {
                    "kind": "Variable",
                    "name": "entityId",
                    "variableName": "entityId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "success"
    }, v6 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DominantColorPersisterMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProjectUpdateBackgroundMutationPayload",
                    "kind": "LinkedField",
                    "name": "jira_updateProjectBackground",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "background",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ThemeSetterBackground"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "DominantColorPersisterMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProjectUpdateBackgroundMutationPayload",
                    "kind": "LinkedField",
                    "name": "jira_updateProjectBackground",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "background",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "colorValue"
                                                }
                                            ],
                                            "type": "JiraColorBackground"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gradientValue"
                                                }
                                            ],
                                            "type": "JiraGradientBackground"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCustomBackground",
                                                    "kind": "LinkedField",
                                                    "name": "customBackground",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mediaApiFileId"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "durationInSeconds",
                                                                    "value": 900
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "mediaReadToken",
                                                            "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "sourceType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "sourceIdentifier"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "altText"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dominantColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "brightness"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraMediaBackground"
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e337f9a844dc439e68d0e4f4034d804d0b86dd187da4d8a42b5c6182bf329cce",
            "metadata": {},
            "name": "DominantColorPersisterMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$94d8147ff4475865$var$node.hash = "43258b1a684094bbd26b433d985eb573";
var $94d8147ff4475865$export$2e2bcd8739ae039 = $94d8147ff4475865$var$node;

});

parcelRegister("lH9hV", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef64fb16ccbbf97$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e1c15f16e679a99e76e5943d5b443018>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ef64fb16ccbbf97$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DominantColorPersister_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "canEditProjectConfig",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EDIT_PROJECT_CONFIG"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        "action": "THROW"
                    }
                ],
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
            },
            "action": "THROW"
        }
    ],
    "type": "JiraProject"
};
$4ef64fb16ccbbf97$var$node.hash = "2ba43559df1c04b5fbcfbc5b3682e35a";
var $4ef64fb16ccbbf97$export$2e2bcd8739ae039 = $4ef64fb16ccbbf97$var$node;

});

parcelRegister("fMgNj", function(module, exports) {
$parcel$export(module.exports, "MutationError", () => $ec4474232ed626cf$export$10c788363424e94e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $ec4474232ed626cf$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}
$ec4474232ed626cf$export$10c788363424e94e.displayName = "MutationError";

});

parcelRegister("9TRdR", function(module, exports) {
$parcel$export(module.exports, "SELECT_UNSPLASH_IMAGE", () => $fb2edc1b584499c2$export$c1d9d781dc0b9a7);
$parcel$export(module.exports, "SELECT_CUSTOM_IMAGE", () => $fb2edc1b584499c2$export$94f44c932e8636b1);
$parcel$export(module.exports, "getDominantColor", () => $fb2edc1b584499c2$export$b7c5f385fc0498e2);
$parcel$export(module.exports, "getDominantColorByMediaFile", () => $fb2edc1b584499c2$export$a3f53656b8df989f);

var $aMTZF = parcelRequire("aMTZF");
const $fb2edc1b584499c2$var$SAMPLE_POINTS = 60;
const $fb2edc1b584499c2$export$c1d9d781dc0b9a7 = 'SELECT_UNSPLASH_IMAGE';
const $fb2edc1b584499c2$export$94f44c932e8636b1 = 'SELECT_CUSTOM_IMAGE';
const $fb2edc1b584499c2$export$d1dbbd8b6d22bf9c = 'UPLOAD_CUSTOM_IMAGE';
const $fb2edc1b584499c2$export$34d09c4a771c46ef = (r, g, b)=>{
    const toHex = (n)=>{
        const hex = n.toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
const $fb2edc1b584499c2$export$b7c5f385fc0498e2 = (imageUrl, userAction)=>{
    (0, $aMTZF.themingGetDominantColorExperience).start();
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                (0, $aMTZF.themingGetDominantColorExperience).abort();
                return reject(new Error('Failed to load canvas'));
            }
            canvas.width = img.width;
            // Only use the top third of the image
            canvas.height = img.height / 3;
            ctx.drawImage(img, 0, 0, img.width, img.height);
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            const totalPixels = imageData.width * imageData.height;
            const step = Math.max(1, Math.floor(totalPixels / $fb2edc1b584499c2$var$SAMPLE_POINTS));
            let r = 0;
            let g = 0;
            let b = 0;
            let count = 0;
            for(let i = 0; i < data.length; i += 4 * step){
                r += data[i];
                g += data[i + 1];
                b += data[i + 2];
                count++;
            }
            r = Math.floor(r / count);
            g = Math.floor(g / count);
            b = Math.floor(b / count);
            const hex = $fb2edc1b584499c2$export$34d09c4a771c46ef(r, g, b);
            (0, $aMTZF.themingGetDominantColorExperience).success({
                metadata: {
                    userAction: userAction
                }
            });
            resolve(hex);
        };
        img.onerror = ()=>{
            (0, $aMTZF.themingGetDominantColorExperience).abort();
            reject(new Error('Failed to load image'));
        };
        img.src = imageUrl;
    });
};
const $fb2edc1b584499c2$export$a3f53656b8df989f = async (file)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = async (event)=>{
            if (!event.target?.result || typeof event.target.result !== 'string') {
                reject(new Error('Failed to read file data'));
                return;
            }
            const dominantColor = await $fb2edc1b584499c2$export$b7c5f385fc0498e2(event.target.result, $fb2edc1b584499c2$export$d1dbbd8b6d22bf9c);
            resolve(dominantColor);
        };
        reader.onerror = ()=>{
            reject(new Error('Failed to read file'));
        };
        // Read the file as a data URL
        reader.readAsDataURL(file);
    });
};

});
parcelRegister("aMTZF", function(module, exports) {
$parcel$export(module.exports, "themingGetDominantColorExperience", () => $9ae89aa860f5f07a$export$3ba82e1ebb21fc10);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");
const $9ae89aa860f5f07a$export$3ba82e1ebb21fc10 = new (0, $jkqqC.UFOExperience)('jira-theming.get-dominant-color', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});

});





parcelRegister("bMM3e", function(module, exports) {
$parcel$export(module.exports, "PageContainerSuccessTracker", () => $d29e19085cf93fee$export$495692882694bf09);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $jnHs7 = parcelRequire("jnHs7");

var $lTQTl = parcelRequire("lTQTl");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
/**
 * PageContainerSuccessTracker is a copy of the old NavigationSuccessTracker component from this path:
 * jira/src/packages/navigation-apps/atlassian-navigation/src/controllers/navigation-success-tracker/main.tsx
 * Which used to mount on every page. But now it doesn't we aren't getting page container success events.
 *
 * So we are mounting ExperienceSuccessTracker here just so the parent event fires and our SLO works again.
 * See this thread for more info: https://atlassian.slack.com/archives/C075QTJBJ6S/p1752445800976529
 *
 * Not sure if ExperienceSuccess is explicitly required here, but it was in the old component, so we are keeping it for now.
 */ function $d29e19085cf93fee$var$PageContainerSuccessTrackerInner() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "pageContainerSuccessTracker",
        packageName: "jiraPageContainerV2",
        teamName: "jfp-magma",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jnHs7.ExperienceSuccessTracker), {
        location: "pageContainer",
        parentProviders: null,
        failureEventAttributes: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lTQTl.ExperienceSuccess), {
        experience: "pageContainer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d29e19085cf93fee$var$StaticFallbackKillswitchSuccessTracker, null));
}
$d29e19085cf93fee$var$PageContainerSuccessTrackerInner.displayName = "PageContainerSuccessTrackerInner";
/**
 * Emits an event so that we know SSR static fallback or killswitch'd route rendering
 * has reached as far as React rendering, and not crashed at some earlier point.
 */ const $d29e19085cf93fee$var$StaticFallbackKillswitchSuccessTracker = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.__SSR_FALLBACK__ === true) (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'staticFallback rendered');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.__SSR_RENDER_KILLSWITCH__ === true) (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'renderKillswitch rendered');
        }
    }, [
        createAnalyticsEvent
    ]);
    return null;
};
$d29e19085cf93fee$var$StaticFallbackKillswitchSuccessTracker.displayName = "StaticFallbackKillswitchSuccessTracker";
const $d29e19085cf93fee$export$495692882694bf09 = /*#__PURE__*/ (0, $euxye.memo)($d29e19085cf93fee$var$PageContainerSuccessTrackerInner);

});

parcelRegister("gboyS", function(module, exports) {
$parcel$export(module.exports, "JiraSpaGlobalBottomRightCorner", () => $3ace7e042d17c904$export$5d8be27b06ebf6e9);

var $euxye = parcelRequire("euxye");

var $c7yku = parcelRequire("c7yku");

var $39CDX = parcelRequire("39CDX");

var $a8EUd = parcelRequire("a8EUd");

var $gDdYI = parcelRequire("gDdYI");
function $3ace7e042d17c904$export$5d8be27b06ebf6e9() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "global-bottom-right-corner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.PlaceholderWithNativeSuspense), {
        name: "global-right-bottom-corner-container",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $39CDX.GlobalBottomRightCornerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $39CDX.BottomRightInlineItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c7yku.GlobalAiRovoButtonWithBoundary), null)))));
}
$3ace7e042d17c904$export$5d8be27b06ebf6e9.displayName = "JiraSpaGlobalBottomRightCorner";

});
parcelRegister("c7yku", function(module, exports) {
$parcel$export(module.exports, "GlobalAiRovoButtonWithBoundary", () => $4804834eadaa09be$export$1548f340e8b33131);

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $gDdYI = parcelRequire("gDdYI");

var $1FGM6 = parcelRequire("1FGM6");
const $4804834eadaa09be$export$1548f340e8b33131 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "global-ai-rovo-button",
        packageName: "ai-rovo-button",
        teamName: "reverie"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "rovo-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1FGM6.GlobalAiRovoButton), null)));
};
$4804834eadaa09be$export$1548f340e8b33131.displayName = "GlobalAiRovoButtonWithBoundary";

});
parcelRegister("1FGM6", function(module, exports) {
$parcel$export(module.exports, "GlobalAiRovoButton", () => $c8c5ba39774d98cc$export$c202888b376a61ca);
/* GlobalAiRovoButton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $erUce = parcelRequire("erUce");

var $ihEDU = parcelRequire("ihEDU");

var $Bq7bE = parcelRequire("Bq7bE");

var $fDtTT = parcelRequire("fDtTT");

var $lnBYw = parcelRequire("lnBYw");

var $jz6Si = parcelRequire("jz6Si");
const $c8c5ba39774d98cc$export$c202888b376a61ca = ()=>{
    const isRovoAvailableForRoute = (0, $lnBYw.useIsGlobalRovoButtonAvailableForRoute)();
    const showRovoButton = (0, $jz6Si.useShouldShowRovoButton)();
    const [isIssueViewModalOpen] = (0, $erUce.useIsIssueViewModalOpen)();
    const { mode: rovoMode } = (0, $Bq7bE.useRovoExperienceAPIStore)();
    const shouldShowPlaceholder = isIssueViewModalOpen && rovoMode !== 'sidebar';
    if (!isRovoAvailableForRoute || !showRovoButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, shouldShowPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        "aria-hidden": true,
        xcss: $c8c5ba39774d98cc$var$styles.placeholder
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fDtTT.AiRovoButtonWrapperRefresh), null));
};
$c8c5ba39774d98cc$export$c202888b376a61ca.displayName = "GlobalAiRovoButton";
const $c8c5ba39774d98cc$var$styles = {
    placeholder: "_1bsbckbl _4t3ickbl"
};

});
parcelRegister("erUce", function(module, exports) {
$parcel$export(module.exports, "useIsIssueViewModalOpen", () => $f674a38d3a0a7ce6$export$6f1df53f7eda54fd);
$parcel$export(module.exports, "useIssueViewModalOpenActions", () => $f674a38d3a0a7ce6$export$473771ce62e0b251);
$parcel$export(module.exports, "useIsIssueViewModalReady", () => $f674a38d3a0a7ce6$export$53b0a2b3d7217c01);
$parcel$export(module.exports, "useIssueViewModalReadyActions", () => $f674a38d3a0a7ce6$export$8891e66b542b848c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $f674a38d3a0a7ce6$var$openActions = {
    setOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        }
};
const $f674a38d3a0a7ce6$var$openStore = (0, $5QDqc.createStore)({
    name: 'IssueViewModalOpenState',
    initialState: {
        isOpen: false
    },
    actions: $f674a38d3a0a7ce6$var$openActions
});
const $f674a38d3a0a7ce6$export$6f1df53f7eda54fd = (0, $3h1FP.createHook)($f674a38d3a0a7ce6$var$openStore, {
    selector: (state)=>state.isOpen
});
const $f674a38d3a0a7ce6$export$473771ce62e0b251 = (0, $3h1FP.createActionsHook)($f674a38d3a0a7ce6$var$openStore);
const $f674a38d3a0a7ce6$var$readyActions = {
    setReady: (isReady)=>({ setState: setState })=>{
            setState({
                isReady: isReady
            });
        }
};
const $f674a38d3a0a7ce6$var$readyStore = (0, $5QDqc.createStore)({
    name: 'IssueViewModalReadyState',
    initialState: {
        isReady: false
    },
    actions: $f674a38d3a0a7ce6$var$readyActions
});
const $f674a38d3a0a7ce6$export$53b0a2b3d7217c01 = (0, $3h1FP.createHook)($f674a38d3a0a7ce6$var$readyStore, {
    selector: (state)=>state.isReady
});
const $f674a38d3a0a7ce6$export$8891e66b542b848c = (0, $3h1FP.createActionsHook)($f674a38d3a0a7ce6$var$readyStore);

});

parcelRegister("fDtTT", function(module, exports) {
$parcel$export(module.exports, "AiRovoButtonWrapperRefresh", () => $9fbc41dffa4c1b01$export$777dceacf2f74fc1);

var $euxye = parcelRequire("euxye");

var $kuCeB = parcelRequire("kuCeB");

var $6zTYs = parcelRequire("6zTYs");

var $9A7N7 = parcelRequire("9A7N7");

var $kt86l = parcelRequire("kt86l");

var $ezKom = parcelRequire("ezKom");

var $jvHCQ = parcelRequire("jvHCQ");

var $2700E = parcelRequire("2700E");
const $9fbc41dffa4c1b01$export$777dceacf2f74fc1 = ()=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    const configuration = (0, $kuCeB.useAiRovoCurrentRouteConfiguration)();
    const sidebarApi = (0, $ezKom.useConversationAssistantSidebarApi)({});
    const { setNudges: setNudges } = (0, $jvHCQ.useAISmartButtonActions)();
    (0, $euxye.useEffect)(()=>{
        setNudges(configuration.nudges ?? []);
    }, [
        configuration.nudges,
        setNudges
    ]);
    // Match to logic in platform/packages/insights-ai-platform/ai-smart-button/src/ui/ai-mini-modal/main.tsx
    // and jira/src/packages/ai-rovo/button/src/AiRovoButtonWrapperRefresh.tsx
    const conversationAssistantConfig = (0, $euxye.useMemo)(()=>(0, $2700E.expVal)('prevent_abort_jira_rovo_chat', 'isEnabled', false) ? {
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'jira',
            orgId: orgId,
            assistanceServiceConfig: {
                headers: {
                    'x-issynthetic-traffic': 'false',
                    'X-Cloudid': cloudId
                },
                baseUrl: '/gateway/api/assist'
            },
            preventAbortRequestsOnStagingModalClose: true,
            preventAbortRequestsOnStandaloneChatClose: true
        } : undefined, [
        cloudId,
        orgId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9A7N7.AISmartButton), {
        product: "jira",
        cloudId: cloudId,
        orgId: orgId,
        isNav4Enabled: true,
        sidebarApi: sidebarApi,
        productPage: "jira",
        getActions: configuration.getActions,
        tags: configuration.tags,
        uiConfig: configuration.uiConfig,
        prioritizeCustomActionResults: configuration.prioritizeCustomActionResults,
        conversationAssistantConfig: conversationAssistantConfig
    });
};
$9fbc41dffa4c1b01$export$777dceacf2f74fc1.displayName = "AiRovoButtonWrapperRefresh";

});
parcelRegister("9A7N7", function(module, exports) {
$parcel$export(module.exports, "AISmartButton", () => $65baca85c092e892$export$2b989c5e58d6ba9);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $1MNmN = parcelRequire("1MNmN");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");

var $4lHIr = parcelRequire("4lHIr");

var $2mxRb = parcelRequire("2mxRb");

var $44CdP = parcelRequire("44CdP");

var $6ecZV = parcelRequire("6ecZV");

var $Bq7bE = parcelRequire("Bq7bE");

var $fryZM = parcelRequire("fryZM");

var $3XXVo = parcelRequire("3XXVo");

var $6PntU = parcelRequire("6PntU");

var $bd7Bg = parcelRequire("bd7Bg");

var $aB8k7 = parcelRequire("aB8k7");

var $ketY1 = parcelRequire("ketY1");

var $kCheS = parcelRequire("kCheS");

var $k6QiC = parcelRequire("k6QiC");

var $g8OYC = parcelRequire("g8OYC");
const $65baca85c092e892$var$ANIMATION_DURATION = 150;
const $65baca85c092e892$var$styles = {
    wrapper: "_kqswh2mm",
    animatedMiniModalBefore: "_v564gsou _8hrz1x0m _3um015vq _tzy42wxo _t9ec1u4m _kdam1pry _m6k413u5 _sedt6rww",
    animatedMiniModalAfter: "_tzy4kb7n _t9ec1h7a _3um0ewfl _kdam1ogz"
};
const $65baca85c092e892$export$2b989c5e58d6ba9 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ isDisabled: isDisabled = false, ...contextProps }, forwardedRef)=>{
    const { product: product, sidebarApi: sidebarApi, productPage: productPage, analyticsAttributes: analyticsAttributes } = contextProps;
    const hoverTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useRef(null);
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $aB8k7.useRovoButtonEventsInstrumentation)();
    const { setButtonClickedTimestamp: setButtonClickedTimestamp } = (0, $4lHIr.useSourceAnalyticActions)();
    const { mode: mode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable, setOpenWithChatHistory: setOpenWithChatHistory } = (0, $Bq7bE.useRovoExperienceAPIStore)();
    const prevModeRef = (0, $euxye.useRef)(mode);
    const isFullScreenModalEnabled = product === 'jira' && (0, $egspI.fg)('agent_session_experience_fg') && (0, $4LDqh.default).getExperimentValue('ai_agent_sessions_experience', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    const isFullScreenModalExperience = mode === (0, $6ecZV.ConversationAssistantUIModes).FULL_SCREEN_MODAL && isFullScreenModalEnabled;
    const [rovoButtonCanRender, setRovoButtonCanRender] = (0, $euxye.useState)(mode !== (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL && !isFullScreenModalExperience);
    const [hasStartedPreloading, setHasStartedPreloading] = (0, $euxye.useState)(false);
    // Ref to the button wrapper. Used by the proximity handler below to
    // measure the button's screen-space center for distance calculations.
    const proximityWrapperRef = (0, $euxye.useRef)(null);
    // Ref mirror of `rovoButtonCanRender` so the proximity handler — which
    // runs from inside a useEffect that doesn't re-subscribe on render —
    // can see the current visibility state without consuming the animation
    // budget while the button is hidden (mini-modal mode). Updated by a
    // tiny sync-effect below.
    const canRenderRef = (0, $euxye.useRef)(rovoButtonCanRender);
    // Mouse-proximity animation enablement (TREX-1527). Read from the
    // `rovo_button_mouse_tracking_animation` Statsig experiment on every
    // render — FeatureGates dedupes exposure logging per session, so this
    // is safe and naturally handles the case where the SDK hadn't fully
    // initialised when AISmartButton first rendered (the next render
    // picks up the live value). Matches the pattern used by
    // `isUnreadIndicatorEnabled` in AISmartButtonUI.
    //
    // When false (control / not bucketed / Statsig unreachable), the
    // animated logo is never rendered — AIButton falls back to the
    // existing static RovoColorLogo. This gates the *visual*; the trigger
    // logic is gated separately inside the effect below.
    const proximityAnimationEnabled = (0, $4LDqh.default).getExperimentValue('rovo_button_mouse_tracking_animation', 'isEnabled', false);
    // Mouse-proximity animation key (TREX-1527). Bumped each time the
    // cursor crosses INTO the proximity radius, which remounts the
    // animated Rovo SVG and restarts its 2.5s SMIL color-cycle.
    // Starts at `undefined` so that on first mount AIButton renders the
    // static fallback. The proximity handler sets it to 0 on the FIRST
    // in-radius cross, which triggers the animated logo's first SMIL run,
    // and bumps it on every subsequent entry while `repeatable = true`.
    const [proximityAnimationKey, setProximityAnimationKey] = (0, $euxye.useState)(undefined);
    // Refs that survive proximity-effect re-runs (TREX-1606).
    //
    // Previously these were closure-scoped `let` variables INSIDE the
    // proximity effect. Any time the effect tore down and re-ran they
    // silently reset to `false`, which produced two visible bugs:
    //
    //   1. `wasInRadius` losing its `true` state caused the edge-detector
    //      (`isInRadius && !wasInRadius`) to miss the next entry into the
    //      radius — the user had to physically move OUT and back IN
    //      before the animation would fire again.
    //   2. `proximityHasFired` losing its `true` state caused the
    //      `repeatable=false` mode to fire more than once per page, and
    //      could also cause "first-fire per session" tracking to lie.
    //
    // Promoting to refs means the values persist for the lifetime of the
    // component instance, independent of how many times the effect
    // re-binds its listener. The route-change reset effect below
    // explicitly clears them when the user navigates.
    const proximityHasFiredRef = (0, $euxye.useRef)(false);
    const wasInRadiusRef = (0, $euxye.useRef)(false);
    // Ref mirror of `proximityAnimationEnabled` (TREX-1606).
    //
    // The proximity effect previously had `proximityAnimationEnabled` in
    // its dep array. Because the gate value is read fresh on every render
    // via `FeatureGates.getExperimentValue`, the value can flip
    // `false → true` shortly after mount (when the Statsig SDK finishes
    // initialising and returns the bucketed value instead of the default
    // `false` fallback). That dep-array flip caused the effect to tear
    // down and re-run, blowing away the per-session proximity state.
    //
    // We now mirror the value into a ref and read it inside the effect.
    // The effect itself runs exactly once per mount with an empty dep
    // array, which is the behaviour the original comment claimed but the
    // original dep array did not deliver.
    const proximityAnimationEnabledRef = (0, $euxye.useRef)(proximityAnimationEnabled);
    // Keep `canRenderRef` in sync with `rovoButtonCanRender` so the
    // long-lived proximity effect (which only subscribes once on mount)
    // can read the current value without re-running.
    (0, $euxye.useEffect)(()=>{
        canRenderRef.current = rovoButtonCanRender;
    }, [
        rovoButtonCanRender
    ]);
    // Keep `proximityAnimationEnabledRef` in sync with the latest gate
    // value. Lets the proximity effect early-bail without re-running when
    // the gate is off.
    (0, $euxye.useEffect)(()=>{
        proximityAnimationEnabledRef.current = proximityAnimationEnabled;
    }, [
        proximityAnimationEnabled
    ]);
    // Reset per-page proximity state when the user navigates between
    // pages (TREX-1606). `productPage` is a stable identifier for the
    // current page surface — when it changes, the user has moved to a
    // new page, so:
    //   - `proximityHasFiredRef` is reset so `repeatable=false` users
    //     can see the animation again on the new page (matches the
    //     "once per page" intent in the effect comment).
    //   - `wasInRadiusRef` is reset so the next mousemove correctly
    //     re-evaluates whether the cursor is in the radius for the
    //     newly-positioned button.
    //   - `proximityAnimationKey` is reset so the AISmartButtonUI
    //     re-renders with the static fallback at first, then transitions
    //     to the animated logo on the next radius entry — preserving the
    //     "static at rest" UX on every fresh page.
    (0, $euxye.useEffect)(()=>{
        proximityHasFiredRef.current = false;
        wasInRadiusRef.current = false;
        setProximityAnimationKey(undefined);
    }, [
        productPage
    ]);
    // Proximity animation suppression while a nudge is visible (TREX-1601).
    //
    // `AIProactiveNudge` publishes its visibility into the shared
    // `AISmartButtonStore`; we subscribe via `useIsNudgeVisible` and
    // mirror it into a ref so the mount-once proximity effect can read
    // the current value on every mousemove without re-binding its
    // listener. Mirrors the `canRenderRef` pattern just above.
    //
    // Suppressing the animation while a nudge is on screen avoids two
    // visual effects (the nudge bubble and the color-cycle on the
    // button itself) competing for the same surface, which is jarring
    // and dilutes the impact of both.
    const isNudgeVisible = (0, $2mxRb.useIsNudgeVisible)();
    const isNudgeVisibleRef = (0, $euxye.useRef)(isNudgeVisible);
    (0, $euxye.useEffect)(()=>{
        isNudgeVisibleRef.current = isNudgeVisible;
    }, [
        isNudgeVisible
    ]);
    (0, $3XXVo.useDebugNudgeTriggers)();
    (0, $euxye.useEffect)(()=>{
        setIsMiniModalAvailable(true);
        if (isFullScreenModalEnabled) setIsFullScreenModalAvailable?.(true);
        if (!(0, $bd7Bg.isBrowser)()) return;
        // Start preloading when mouse is within the bottom-right box (300px from bottom, 300px from right)
        const handleMouseMove = (event)=>{
            if ((0, $bd7Bg.isBrowser)() && !hasStartedPreloading) {
                const viewportHeight = window.innerHeight;
                const viewportWidth = window.innerWidth;
                const mouseX = event.clientX;
                const mouseY = event.clientY;
                const distanceFromBottom = viewportHeight - mouseY;
                const distanceFromRight = viewportWidth - mouseX;
                if (distanceFromBottom <= 300 && distanceFromRight <= 300) {
                    (0, $kCheS.preloadAIMiniModal)();
                    setHasStartedPreloading(true);
                }
            }
        };
        const unbind = (0, $glbdM.bindAll)(window, [
            {
                type: 'mousemove',
                listener: handleMouseMove
            }
        ]);
        return ()=>{
            setIsMiniModalAvailable(false);
            if (isFullScreenModalEnabled) setIsFullScreenModalAvailable?.(false);
            (0, $bd7Bg.isBrowser)() && unbind();
        };
    }, [
        setIsMiniModalAvailable,
        setIsFullScreenModalAvailable,
        hasStartedPreloading,
        isFullScreenModalEnabled
    ]);
    // --- Mouse-proximity animation (TREX-1527, hardened in TREX-1606) ---
    // This effect is intentionally mount-once / unmount-once: the dep
    // array is empty. All values that can change between renders
    // (the enabled gate, the render-eligibility flag, the per-trigger
    // state) are read through refs that are kept in sync above so the
    // effect never has to tear down and re-run. Previously this effect
    // depended on `proximityAnimationEnabled`, which flipped from `false`
    // (Statsig SDK not yet initialised) to `true` (bucketed value
    // resolved) shortly after mount and silently reset the per-page
    // proximity state — see TREX-1606 for the full investigation.
    //
    // IMPORTANT: the listener is registered unconditionally. The
    // "is the experiment enabled?" check is deliberately inside
    // `updateProximity` rather than at the top of the effect. Gating
    // the registration here would mean a user whose Statsig SDK
    // resolves AFTER mount (i.e. `proximityAnimationEnabled` was
    // `false` at the moment the effect ran but became `true` shortly
    // after) never gets a listener at all — because the mount-once
    // effect doesn't re-run. Bailing inside the handler is virtually
    // free (a ref read + early return on each mousemove for
    // non-bucketed users) and is consistent with how `canRenderRef` is
    // already handled.
    //
    // The Statsig param reads (`PROXIMITY_RADIUS_PX`, `PROXIMITY_REPEAT`)
    // remain inside the effect closure so they capture the value at
    // mount time. This is intentional: mid-session experiment-param
    // changes should NOT silently change the radius or repeat behaviour
    // for a user already on a page — they take effect on the next mount.
    (0, $euxye.useEffect)(()=>{
        if (!(0, $bd7Bg.isBrowser)()) return;
        // Tunable from Switcheroo without redeploying:
        //   proximityRadiusPx (number)  — radius around the button in pixels.
        //   repeatable        (boolean) — true: replay on every entry into radius.
        //                                  false: play once per page mount.
        const PROXIMITY_RADIUS_PX = (0, $4LDqh.default).getExperimentValue('rovo_button_mouse_tracking_animation', 'proximityRadiusPx', 150);
        const PROXIMITY_REPEAT = (0, $4LDqh.default).getExperimentValue('rovo_button_mouse_tracking_animation', 'repeatable', false);
        let lastMouseX = -1;
        let lastMouseY = -1;
        let rafId;
        const updateProximity = ()=>{
            rafId = undefined;
            // Bail if the experiment isn't enabled for this user. Read
            // fresh each frame via the ref so users whose Statsig SDK
            // resolves after mount still get the animation once the
            // flag flips `true`. See effect header for the full
            // rationale.
            if (!proximityAnimationEnabledRef.current) return;
            // Don't measure or fire while the button is not actually
            // being rendered (e.g. mini-modal mode). Prevents the
            // once-per-page animation budget from being consumed
            // invisibly.
            if (!canRenderRef.current) return;
            // Suppress the animation while a nudge bubble is on screen
            // (TREX-1601). Skipping the entry — rather than queuing it
            // to fire after the nudge dismisses — is deliberate: the
            // animation is meant to react to live cursor approach, not
            // to replay a stale gesture once the screen is clear. The
            // suppression behaviour ships as part of the same
            // experiment as the proximity animation itself.
            //
            // We reach this line only when `proximityAnimationEnabledRef`
            // (read via `getExperimentValue`) is true, so the user is
            // already bucketed into the experiment — no separate gate
            // check is needed for the decision. We still call `fg(...)`
            // for its exposure-tracking side effect to satisfy the
            // `@atlaskit/platform/no-preconditioning` ESLint rule and
            // keep Statsig's exposure metric attributable to the
            // suppression code path. Calling `fg(...)` for side effect
            // (rather than using its return value as the gate) avoids
            // the publisher/consumer SDK mismatch we hit in TREX-1601
            // local testing — see ai-proactive-nudge/main.tsx for the
            // matching publisher fix.
            if (isNudgeVisibleRef.current) {
                (0, $egspI.fg)('rovo_button_mouse_tracking_animation');
                return;
            }
            const el = proximityWrapperRef.current;
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            const dx = lastMouseX - centerX;
            const dy = lastMouseY - centerY;
            const distance = Math.hypot(dx, dy);
            const isInRadius = distance <= PROXIMITY_RADIUS_PX;
            // Detect "entered the radius" → mount (first entry) or remount
            // (subsequent entries when repeatable=true) the animated Rovo
            // SVG by setting/bumping the React key. This is the only place
            // we touch React state from the mousemove handler.
            //
            // Respect `prefers-reduced-motion: reduce` (WCAG 2.3.3): users
            // who have requested reduced motion should not see the
            // color-cycle animation even when bucketed into the test
            // cohort. We bail BEFORE mutating React state so the static
            // RovoColorLogo fallback continues to render. Re-evaluated
            // per-trigger (cheap) so that if the user changes their OS
            // setting mid-session it takes effect on the next entry.
            if (isInRadius && !wasInRadiusRef.current) {
                const prefersReducedMotion = typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                if (!prefersReducedMotion && (PROXIMITY_REPEAT || !proximityHasFiredRef.current)) {
                    setProximityAnimationKey((k)=>k === undefined ? 0 : k + 1);
                    proximityHasFiredRef.current = true;
                }
            }
            wasInRadiusRef.current = isInRadius;
        };
        const handleProximityMouseMove = (event)=>{
            lastMouseX = event.clientX;
            lastMouseY = event.clientY;
            // Only schedule a new rAF if one isn't already pending. Track the
            // rAF ID so we can cancel it in the cleanup — without this, a
            // pending rAF would still fire after unmount and call
            // setProximityAnimationKey on an unmounted component (a React
            // warning in dev, a potential no-op state update in prod that
            // breaks React StrictMode double-invocation invariants).
            if (rafId === undefined) rafId = requestAnimationFrame(updateProximity);
        };
        const unbind = (0, $glbdM.bindAll)(window, [
            {
                type: 'mousemove',
                listener: handleProximityMouseMove
            }
        ]);
        return ()=>{
            if (rafId !== undefined) cancelAnimationFrame(rafId);
            unbind();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See header comment: effect deliberately runs once per mount and reads
    // proximityAnimationEnabledRef / canRenderRef / wasInRadiusRef /
    // proximityHasFiredRef / proximityWrapperRef through refs that
    // are kept in sync above (or, in the case of proximityWrapperRef,
    // attached to the rendered wrapper element via ref={...}).
    }, []);
    (0, $euxye.useEffect)(()=>{
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'rendered',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                version: 'refresh',
                legacy: false
            },
            product: product
        });
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage,
        analyticsAttributes
    ]);
    (0, $euxye.useEffect)(()=>{
        // Wait for the closing animation of modal to complete before showing the rovo button.
        // The timer must be cleared on cleanup; otherwise rapid mode transitions
        // (e.g. undefined → sidebar → mini-modal) leave stale timers that fire after
        // ANIMATION_DURATION and incorrectly set rovoButtonCanRender to true,
        // unmounting the AIMiniModal even though mode is still 'mini-modal'.
        if (mode !== (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL && !isFullScreenModalExperience) {
            const timerId = setTimeout(()=>{
                setRovoButtonCanRender(true);
            }, $65baca85c092e892$var$ANIMATION_DURATION);
            return ()=>{
                clearTimeout(timerId);
            };
        }
        setRovoButtonCanRender(false);
    }, [
        mode,
        setRovoButtonCanRender,
        isFullScreenModalExperience
    ]);
    (0, $euxye.useEffect)(()=>{
        if (mode === undefined && (prevModeRef.current === (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL || prevModeRef.current === (0, $6ecZV.ConversationAssistantUIModes).SIDEBAR || prevModeRef.current === (0, $6ecZV.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $egspI.fg)('agent_session_experience_fg'))) // AISmartButtonUI is unmounted while mini-modal, sidebar, or full-screen-modal is open, so the hook
        // cannot watch mode internally. Mark cache stale here so the button remounts with
        // stale data visible while the background re-fetch completes.
        (0, $6PntU.markUnreadCacheStale)();
        prevModeRef.current = mode;
    }, [
        mode
    ]);
    const onAISmartButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((e)=>{
        // Set timestamp immediately on click
        setButtonClickedTimestamp(Date.now());
        // Plain button opens the default (suggestions) view — ensure a prior pill
        // click can never leak its open-with-chat-history intent into this open.
        setOpenWithChatHistory?.(false);
        toggleConversationAssistantUIMode({
            targetMode: (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL,
            sidebarApi: sidebarApi
        });
        const selectionAttributes = {};
        if ((0, $egspI.fg)('platform_editor_ai_aifc_streaming')) {
            const counts = (0, $g8OYC.selectionCountsInMainEditor)(e.currentTarget);
            if (counts != null) {
                selectionAttributes.totalSelectedWords = counts.words;
                selectionAttributes.totalSelectedChars = counts.chars;
            }
        }
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'clicked',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                ...selectionAttributes,
                version: 'refresh'
            },
            product: product
        });
        setRovoButtonCanRender(false);
    }, [
        product,
        productPage,
        analyticsAttributes,
        fireRovoButtonUIEvent,
        toggleConversationAssistantUIMode,
        sidebarApi,
        setButtonClickedTimestamp,
        setOpenWithChatHistory
    ]);
    const onChatHistoryClick = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(()=>{
        setOpenWithChatHistory?.(true);
        openConversationAssistantUIMode({
            targetMode: (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL,
            sidebarApi: sidebarApi
        });
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'clicked',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                version: 'refresh',
                openedWithChatHistory: true
            },
            product: product
        });
        setRovoButtonCanRender(false);
    }, [
        product,
        productPage,
        analyticsAttributes,
        fireRovoButtonUIEvent,
        openConversationAssistantUIMode,
        sidebarApi,
        setOpenWithChatHistory
    ]);
    const onAISmartButtonEnter = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(()=>{
        hoverTimerRef.current = setTimeout(()=>{
            fireRovoButtonUIEvent({
                source: productPage,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiSmartButton',
                attributes: {
                    product: product,
                    productPage: productPage,
                    ...analyticsAttributes,
                    version: 'refresh'
                },
                product: product
            });
        }, 1000);
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage,
        analyticsAttributes
    ]);
    const onAISmartButtonLeave = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $fryZM.AISmartButtonProvider), {
                ...contextProps,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                        xcss: $65baca85c092e892$var$styles.wrapper,
                        ref: proximityWrapperRef,
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                                xcss: (0, $1MNmN.cx)($65baca85c092e892$var$styles.animatedMiniModalBefore, mode === (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL && $65baca85c092e892$var$styles.animatedMiniModalAfter),
                                children: !sidebarApi.isSidebarOpen() && !rovoButtonCanRender && !isFullScreenModalExperience && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kCheS.AIMiniModal), {})
                            }),
                            !sidebarApi.isSidebarOpen() && rovoButtonCanRender && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k6QiC.AISmartButtonUI), {
                                ref: forwardedRef,
                                onClick: onAISmartButtonClick,
                                onChatHistoryClick: onChatHistoryClick,
                                isDisabled: isDisabled,
                                onMouseEnter: onAISmartButtonEnter,
                                onMouseLeave: onAISmartButtonLeave,
                                proximityAnimationKey: proximityAnimationKey
                            })
                        ]
                    }),
                    !sidebarApi.isSidebarOpen() && isFullScreenModalExperience && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ketY1.AIFullScreenModal), {})
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $44CdP.OnboardingEnablement), {
                product: product
            })
        ]
    });
});

});
parcelRegister("4lHIr", function(module, exports) {
$parcel$export(module.exports, "useSourceAnalyticActions", () => $d2f8a16ed3070098$export$cb9c0d3b5896f957);

var $euxye = parcelRequire("euxye");

var $9h1OP = parcelRequire("9h1OP");

var $jvHCQ = parcelRequire("jvHCQ");
const $d2f8a16ed3070098$export$cb9c0d3b5896f957 = ()=>{
    const { setButtonClickedTimestamp: setButtonClickedTimestamp } = (0, $jvHCQ.useAISmartButtonActions)();
    const conversationActionsStoreActions = (0, $9h1OP.useConversationActionsStoreActions)();
    return (0, $euxye.useMemo)(()=>({
            /**
			 * Set the button clicked timestamp for the source.
			 */ setButtonClickedTimestamp: (buttonClickedTimestamp)=>{
                setButtonClickedTimestamp(buttonClickedTimestamp);
                conversationActionsStoreActions.setButtonClickedTimestamp(buttonClickedTimestamp);
            }
        }), [
        setButtonClickedTimestamp,
        conversationActionsStoreActions
    ]);
};

});
parcelRegister("9h1OP", function(module, exports) {
$parcel$export(module.exports, "useConversationActionsStore", () => $96266be8127cce55$export$83a8985e8d377ba1);
$parcel$export(module.exports, "useConversationActionsStoreActions", () => $96266be8127cce55$export$74d7aed167e24a67);
$parcel$export(module.exports, "useConversationActionsStoreState", () => $96266be8127cce55$export$d6ed3fb83640b335);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $96266be8127cce55$var$store = (0, $5QDqc.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
		 * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
		 * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
		 */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
		 * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
		 */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $96266be8127cce55$export$83a8985e8d377ba1 = (0, $3h1FP.createHook)($96266be8127cce55$var$store);
const $96266be8127cce55$export$74d7aed167e24a67 = (0, $3h1FP.createActionsHook)($96266be8127cce55$var$store);
const $96266be8127cce55$export$d6ed3fb83640b335 = (0, $3h1FP.createStateHook)($96266be8127cce55$var$store);
const $96266be8127cce55$export$4be353558b8b8a37 = (0, $3h1FP.createStateHook)($96266be8127cce55$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});

});


parcelRegister("44CdP", function(module, exports) {
$parcel$export(module.exports, "OnboardingEnablement", () => $97bf8d57f8ae7812$export$20c376cddbc7272c);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $9ll9z = parcelRequire("9ll9z");

var $kEMEj = parcelRequire("kEMEj");

var $dpopV = parcelRequire("dpopV");

var $5jUvu = parcelRequire("5jUvu");

var $50DkA = parcelRequire("50DkA");

var $7Isdl = parcelRequire("7Isdl");

var $7pYVa = parcelRequire("7pYVa");

var $1Q5DT = parcelRequire("1Q5DT");
// If productionized - will consider relocating logic to conversion-assistant-onboarding -- tracking ticket: https://hello.jira.atlassian.cloud/browse/MOOG-146
const $97bf8d57f8ae7812$var$ELIGIBLE_PAGES = [
    (0, $50DkA.PageContextType).JIRA_FOR_YOU,
    (0, $50DkA.PageContextType).JIRA_ISSUE_VIEW,
    (0, $50DkA.PageContextType).JIRA_PROJECT,
    (0, $50DkA.PageContextType).CONFLUENCE_PAGE_VIEW,
    (0, $50DkA.PageContextType).CONFLUENCE_BLOG_VIEW
];
const $97bf8d57f8ae7812$var$ELIGIBLE_PRODUCTS = [
    'jira',
    'confluence'
];
const $97bf8d57f8ae7812$var$DWELL_TIME_MS = 5000;
const $97bf8d57f8ae7812$export$20c376cddbc7272c = ({ product: product })=>{
    if ((0, $7Isdl.isBrowser)() && ((0, $egspI.fg)('rovo_onboarding_modal_jira_chat_filter_fg') || (0, $egspI.fg)('rovo_onboarding_modal_confluence_chat_fg'))) return /*#__PURE__*/ (0, $e79Pd.jsx)($97bf8d57f8ae7812$var$OnboardingEnablementInner, {
        product: product
    });
    return null;
};
$97bf8d57f8ae7812$export$20c376cddbc7272c.displayName = "OnboardingEnablement";
const $97bf8d57f8ae7812$var$OnboardingEnablementInner = ({ product: product })=>{
    $97bf8d57f8ae7812$var$useOnboardingEnablement({
        product: product
    });
    return null;
};
$97bf8d57f8ae7812$var$OnboardingEnablementInner.displayName = "OnboardingEnablementInner";
function $97bf8d57f8ae7812$var$useOnboardingEnablement({ product: product }) {
    const pageContextType = (0, $5jUvu.usePageContextType)();
    const { isRovoEnabled: isRovoEnabled } = (0, $kEMEj.useRovoEntitlement)();
    const { mounted: isChatOpen, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen } = (0, $dpopV.useUIStore)();
    const publish = (0, $9ll9z.usePublish)('ai-mate');
    const hasOpenedChatRef = (0, $euxye.useRef)(false);
    const routeDwellTimerRef = (0, $euxye.useRef)(null);
    const [hasDwelled, setHasDwelled] = (0, $euxye.useState)(false);
    const [passesHoldout] = (0, $euxye.useState)((0, $7pYVa.passesOnboardingHoldout));
    const isFeatureGateEnabled = (0, $euxye.useMemo)(()=>{
        if (product === 'jira') return (0, $egspI.fg)('rovo_onboarding_modal_jira_chat_filter_fg');
        else if (product === 'confluence') return (0, $egspI.fg)('rovo_onboarding_modal_confluence_chat_fg');
        return false; // default case, shouldn't ever be reached
    }, [
        product
    ]);
    const isEligiblePage = $97bf8d57f8ae7812$var$ELIGIBLE_PAGES.includes(pageContextType);
    const isEligibleProduct = $97bf8d57f8ae7812$var$ELIGIBLE_PRODUCTS.includes(product);
    // Track if chat has been opened
    (0, $euxye.useEffect)(()=>{
        if (isChatOpen && !hasOpenedChatRef.current) hasOpenedChatRef.current = true;
    }, [
        isChatOpen
    ]);
    // Dwell timer effect - only runs when basic eligibility is met
    (0, $euxye.useEffect)(()=>{
        const shouldSkipTimer = hasOpenedChatRef.current || !isEligiblePage || !isEligibleProduct || !passesHoldout || !isFeatureGateEnabled || !isRovoEnabled;
        if (shouldSkipTimer) return;
        // Reset dwell status when route changes
        setHasDwelled(false);
        // Clear any existing timer
        if (routeDwellTimerRef.current) {
            clearTimeout(routeDwellTimerRef.current);
            routeDwellTimerRef.current = null;
        }
        // Start new timer for current route
        routeDwellTimerRef.current = setTimeout(()=>{
            setHasDwelled(true);
            routeDwellTimerRef.current = null;
        }, $97bf8d57f8ae7812$var$DWELL_TIME_MS);
        // Cleanup on unmount or route change
        return ()=>{
            if (routeDwellTimerRef.current) {
                clearTimeout(routeDwellTimerRef.current);
                routeDwellTimerRef.current = null;
            }
        };
    }, [
        pageContextType,
        isRovoEnabled,
        isFeatureGateEnabled,
        isEligiblePage,
        isEligibleProduct,
        passesHoldout
    ]);
    const isEligible = (0, $euxye.useMemo)(()=>isRovoEnabled && isEligiblePage && isEligibleProduct && isFeatureGateEnabled && hasDwelled && !isChatOpen && passesHoldout, [
        isRovoEnabled,
        isFeatureGateEnabled,
        isEligiblePage,
        isEligibleProduct,
        hasDwelled,
        isChatOpen,
        passesHoldout
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isEligible && !hasOpenedChatRef.current) {
            hasOpenedChatRef.current = true;
            publish({
                type: 'chat-draft',
                product: product,
                source: 'ai-mate-onboarding',
                openChat: true,
                openChatMode: 'mini-modal'
            });
            (0, $1Q5DT.recordOnboardingExposureForHoldout)();
            setIsChatOnboardingMiniModalOpen(true);
        }
    }, [
        isEligible,
        product,
        setIsChatOnboardingMiniModalOpen,
        publish
    ]);
}

});
parcelRegister("dpopV", function(module, exports) {
$parcel$export(module.exports, "useEmptyChatLaunchSelector", () => $ef7265e9ae1e74e9$export$13a6c73a57f1d6a6);
$parcel$export(module.exports, "useActiveTabSelector", () => $ef7265e9ae1e74e9$export$81a40d215ef1c1de);
$parcel$export(module.exports, "useSelectedSpaceSelector", () => $ef7265e9ae1e74e9$export$5f449dc44751be0a);
$parcel$export(module.exports, "useChatHeaderUISelector", () => $ef7265e9ae1e74e9$export$78ce19c6cc1eeb16);
$parcel$export(module.exports, "useConversationHeaderSelector", () => $ef7265e9ae1e74e9$export$f4c4584d8302c703);
$parcel$export(module.exports, "useChatInputUISelector", () => $ef7265e9ae1e74e9$export$357ffd05205e0c5d);
$parcel$export(module.exports, "useSideNavUISelector", () => $ef7265e9ae1e74e9$export$9e369d8095358b77);
$parcel$export(module.exports, "useRootUISelector", () => $ef7265e9ae1e74e9$export$8f5523dfac6ff4fa);
$parcel$export(module.exports, "useUIStore", () => $ef7265e9ae1e74e9$export$5b2ba9b8ea3b0771);
$parcel$export(module.exports, "useUIStoreActions", () => $ef7265e9ae1e74e9$export$cd2fc25ddd3752d4);
$parcel$export(module.exports, "useUIStoreSubscription", () => $ef7265e9ae1e74e9$export$f0adc1af32e51b);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $4LDqh = parcelRequire("4LDqh");

var $ltYnt = parcelRequire("ltYnt");
const $ef7265e9ae1e74e9$export$6fdb848aa0eff3d1 = {
    isActive: false
};
const $ef7265e9ae1e74e9$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchInteractionSource: undefined,
    emptyChatLaunchInvokedFrom: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    selectedSpace: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $ltYnt.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined,
    smartLink3PPostAuth: $ef7265e9ae1e74e9$export$6fdb848aa0eff3d1
};
const $ef7265e9ae1e74e9$var$store = (0, $5QDqc.createStore)({
    name: 'uiStore',
    initialState: $ef7265e9ae1e74e9$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$ef7265e9ae1e74e9$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setSmartLink3PPostAuth: (payload)=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: payload
                });
            },
        clearSmartLink3PPostAuth: ()=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: $ef7265e9ae1e74e9$export$6fdb848aa0eff3d1
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchInteractionSource: payload.interactionSource,
                    emptyChatLaunchInvokedFrom: payload.invokedFrom,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $ef7265e9ae1e74e9$var$useStore = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store);
const $ef7265e9ae1e74e9$export$13a6c73a57f1d6a6 = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            interactionSource: state.emptyChatLaunchInteractionSource,
            invokedFrom: state.emptyChatLaunchInvokedFrom,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId
        })
});
const $ef7265e9ae1e74e9$export$81a40d215ef1c1de = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $ef7265e9ae1e74e9$export$5f449dc44751be0a = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace
        })
});
const $ef7265e9ae1e74e9$export$78ce19c6cc1eeb16 = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            isAgentSelectorMenuOpen: state.isAgentSelectorMenuOpen,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            selectedSpace: state.selectedSpace
        })
});
const $ef7265e9ae1e74e9$export$1bd034c20714e002 = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu
        })
});
const $ef7265e9ae1e74e9$export$762e860bb8461339 = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            mounted: state.mounted
        })
});
const $ef7265e9ae1e74e9$export$d3b1853c9cb98102 = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen
        })
});
const $ef7265e9ae1e74e9$export$f4c4584d8302c703 = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            conversationHeader: state.conversationHeader
        })
});
const $ef7265e9ae1e74e9$export$1e3791eaae70097a = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $ef7265e9ae1e74e9$export$357ffd05205e0c5d = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $ef7265e9ae1e74e9$export$9e369d8095358b77 = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace
        })
});
const $ef7265e9ae1e74e9$export$8f5523dfac6ff4fa = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $ef7265e9ae1e74e9$export$5b2ba9b8ea3b0771 = ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth }] = $ef7265e9ae1e74e9$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        smartLink3PPostAuth: smartLink3PPostAuth,
        setSmartLink3PPostAuth: setSmartLink3PPostAuth,
        clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $ef7265e9ae1e74e9$export$cd2fc25ddd3752d4 = (0, $3h1FP.createActionsHook)($ef7265e9ae1e74e9$var$store);
const $ef7265e9ae1e74e9$var$isRenderStabilizationEnabled = ()=>(0, $4LDqh.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false);
const $ef7265e9ae1e74e9$export$f0adc1af32e51b = (0, $3h1FP.createHook)($ef7265e9ae1e74e9$var$store, {
    selector: (state)=>$ef7265e9ae1e74e9$var$isRenderStabilizationEnabled() ? null : state
});

});
parcelRegister("ltYnt", function(module, exports) {
$parcel$export(module.exports, "EMPTY_CONVERSATION_ID", () => $f0bbfb303e18a6c7$export$a08ae3ac6db36809);
$parcel$export(module.exports, "createChatStore", () => $f0bbfb303e18a6c7$export$8572e013e9dc20c3);

var $5QDqc = parcelRequire("5QDqc");

var $cSkSS = parcelRequire("cSkSS");
const $f0bbfb303e18a6c7$export$a08ae3ac6db36809 = 'EMPTY_CONVERSATION_ID';
const $f0bbfb303e18a6c7$var$initialState = {
    conversations: {
        EMPTY_CONVERSATION_ID: {
            id: $f0bbfb303e18a6c7$export$a08ae3ac6db36809,
            messages: [],
            name: '',
            status: (0, $cSkSS.CHAT_STORE_STATUS).idle,
            traces: [],
            timeCreated: new Date().toISOString()
        }
    },
    currentConversationId: $f0bbfb303e18a6c7$export$a08ae3ac6db36809,
    isConversationsInitialized: false,
    conversationPagination: {
        ...(0, $cSkSS.DEFAULT_CONVERSATION_PAGINATION)
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $f0bbfb303e18a6c7$var$store;
const $f0bbfb303e18a6c7$export$8572e013e9dc20c3 = (actions)=>{
    if (!$f0bbfb303e18a6c7$var$store) $f0bbfb303e18a6c7$var$store = (0, $5QDqc.createStore)({
        name: 'ConversationAssistantStore',
        initialState: $f0bbfb303e18a6c7$var$initialState,
        actions: actions
    });
    // The module-level `store` is typed as `any` because its action type T is
    // not known at declaration time. The cast here is safe: `createChatStore` is
    // always called with the same concrete actions object.
    return $f0bbfb303e18a6c7$var$store;
};

});
parcelRegister("cSkSS", function(module, exports) {
$parcel$export(module.exports, "StoreActionLoggableName", () => $d1eafba2d4e7d105$export$69799355b7de2229);
$parcel$export(module.exports, "DEFAULT_CONVERSATION_PAGINATION", () => $d1eafba2d4e7d105$export$61e8a5ac076d12b3);
$parcel$export(module.exports, "isAnswerNowAvailable", () => $d1eafba2d4e7d105$export$8ec4190061b584d5);
$parcel$export(module.exports, "AnswerNowStatusType", () => $d1eafba2d4e7d105$export$fe950e85847f6d5d);
$parcel$export(module.exports, "CHAT_STORE_STATUS", () => $d1eafba2d4e7d105$export$817d6b1b984afeb7);
$parcel$export(module.exports, "isTerminalTaskState", () => $d1eafba2d4e7d105$export$e87901ebf76c08a1);
$parcel$export(module.exports, "isStoreHuman", () => $d1eafba2d4e7d105$export$75e97486ff2b4c62);
$parcel$export(module.exports, "isStoreAssistant", () => $d1eafba2d4e7d105$export$d99f52ae2a325014);
$parcel$export(module.exports, "isStoreError", () => $d1eafba2d4e7d105$export$9e2d714e96946d26);
$parcel$export(module.exports, "isStoreMessage", () => $d1eafba2d4e7d105$export$f2b8d80523e7041);
$parcel$export(module.exports, "isStoreFollowUp", () => $d1eafba2d4e7d105$export$7c65a4fb7b6131a1);
$parcel$export(module.exports, "isStoreGuardBlock", () => $d1eafba2d4e7d105$export$533a80cec0f4f28f);
$parcel$export(module.exports, "isStoreUsageHint", () => $d1eafba2d4e7d105$export$155f16100a67670d);
$parcel$export(module.exports, "getActionInvocationStatus", () => $d1eafba2d4e7d105$export$3070678f252266e3);
var $d1eafba2d4e7d105$export$69799355b7de2229 = /*#__PURE__*/ function(StoreActionLoggableName) {
    StoreActionLoggableName["addStoreChatItem"] = "addStoreChatItem";
    StoreActionLoggableName["addHumanMessage"] = "addHumanMessage";
    StoreActionLoggableName["addAssistantMessage"] = "addAssistantMessage";
    StoreActionLoggableName["clearFollowUpMessages"] = "clearFollowUpMessages";
    StoreActionLoggableName["sendMessage"] = "sendMessage";
    StoreActionLoggableName["sendMessageConfirmedTools"] = "sendMessageConfirmedTools";
    StoreActionLoggableName["removeMessage"] = "removeMessage";
    StoreActionLoggableName["truncateFromLastHumanMessage"] = "truncateFromLastHumanMessage";
    StoreActionLoggableName["fetchConversation"] = "fetchConversation";
    StoreActionLoggableName["prefetchConversationMessages"] = "prefetchConversationMessages";
    StoreActionLoggableName["reconnectToInProgressStream"] = "reconnectToInProgressStream";
    StoreActionLoggableName["abortRequests"] = "abortRequests";
    StoreActionLoggableName["answerNow"] = "answerNow";
    StoreActionLoggableName["addErrorMessage"] = "addErrorMessage";
    StoreActionLoggableName["fetchConversationChannelsData"] = "fetchConversationChannelsData";
    StoreActionLoggableName["loadMoreConversationChannelsData"] = "loadMoreConversationChannelsData";
    StoreActionLoggableName["hydrateConversation"] = "hydrateConversation";
    StoreActionLoggableName["addAgentMessage"] = "addAgentMessage";
    StoreActionLoggableName["handleChatOpenPubsubAction"] = "handleChatOpenPubsubAction";
    StoreActionLoggableName["createConversationOptimistically"] = "createConversationOptimistically";
    StoreActionLoggableName["createSeededConversation"] = "createSeededConversation";
    StoreActionLoggableName["updateActionInvocationStatus"] = "updateActionInvocationStatus";
    StoreActionLoggableName["updateActionData"] = "updateActionData";
    StoreActionLoggableName["resolveConversationAction"] = "resolveConversationAction";
    StoreActionLoggableName["bulkResolveConversationActions"] = "bulkResolveConversationActions";
    StoreActionLoggableName["bulkResolveConversationUIActions"] = "bulkResolveConversationUIActions";
    StoreActionLoggableName["setSelectedConversation"] = "setSelectedConversation";
    StoreActionLoggableName["warmConversationCache"] = "warmConversationCache";
    StoreActionLoggableName["hasConversationMessages"] = "hasConversationMessages";
    StoreActionLoggableName["stopTask"] = "stopTask";
    return StoreActionLoggableName;
}({});
const $d1eafba2d4e7d105$export$61e8a5ac076d12b3 = {
    nextCursor: null,
    hasMore: false,
    isLoadingMore: false,
    loadMoreError: null,
    isConversationListMounted: false
};
const $d1eafba2d4e7d105$export$8ec4190061b584d5 = (status)=>status?.type === 'AVAILABLE';
const $d1eafba2d4e7d105$export$fe950e85847f6d5d = {
    AVAILABLE: 'AVAILABLE',
    SWITCHING: 'SWITCHING',
    SWITCHING_REQUESTED: 'SWITCHING_REQUESTED',
    SWITCHED: 'SWITCHED',
    ERRORED: 'ERRORED'
};
var $d1eafba2d4e7d105$export$817d6b1b984afeb7 = /*#__PURE__*/ function(CHAT_STORE_STATUS) {
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["idle"] = 0] = "idle";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["loadingChat"] = 1] = "loadingChat";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["awaitingResponse"] = 2] = "awaitingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["typingResponse"] = 3] = "typingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["deactivatedAgentError"] = 4] = "deactivatedAgentError";
    return CHAT_STORE_STATUS;
}({});
const $d1eafba2d4e7d105$var$TERMINAL_TASK_STATES = [
    'Completed',
    'Failed',
    'Cancelled'
];
const $d1eafba2d4e7d105$export$e87901ebf76c08a1 = (state)=>$d1eafba2d4e7d105$var$TERMINAL_TASK_STATES.includes(state);
const $d1eafba2d4e7d105$export$75e97486ff2b4c62 = (message)=>'type' in message && message.type === 'HUMAN';
const $d1eafba2d4e7d105$export$d99f52ae2a325014 = (message)=>'type' in message && message.type === 'ASSISTANT';
const $d1eafba2d4e7d105$export$9e2d714e96946d26 = (message)=>'type' in message && message.type === 'ERROR';
const $d1eafba2d4e7d105$export$f2b8d80523e7041 = (message)=>$d1eafba2d4e7d105$export$75e97486ff2b4c62(message) || $d1eafba2d4e7d105$export$d99f52ae2a325014(message);
const $d1eafba2d4e7d105$export$61c7dbb423a56ae7 = (message)=>'type' in message && message.type === 'MEMORY_UPDATE';
const $d1eafba2d4e7d105$export$7c65a4fb7b6131a1 = (message)=>'type' in message && message.type === 'FOLLOW_UP';
const $d1eafba2d4e7d105$export$2e85f4812cb59241 = (message)=>'type' in message && message.type === 'LIVE_CHAT';
const $d1eafba2d4e7d105$export$20f0f8aded5b11e5 = (message)=>'type' in message && message.type === 'TWILIO_LIVE_CHAT_AGENT';
const $d1eafba2d4e7d105$export$908578fde1b22b55 = (message)=>$d1eafba2d4e7d105$export$75e97486ff2b4c62(message) && message.source === 'TWILIO_LIVE_CHAT';
const $d1eafba2d4e7d105$export$3db8a80b25c44828 = (message)=>$d1eafba2d4e7d105$export$20f0f8aded5b11e5(message) || $d1eafba2d4e7d105$export$908578fde1b22b55(message);
const $d1eafba2d4e7d105$export$d15e7fe0f58ee5d0 = (message)=>message.type === 'ACTION_PREPARE';
const $d1eafba2d4e7d105$export$533a80cec0f4f28f = (message)=>message.type === 'GUARD_BLOCK';
const $d1eafba2d4e7d105$export$155f16100a67670d = (message)=>'type' in message && message.type === 'USAGE_HINT';
const $d1eafba2d4e7d105$export$3070678f252266e3 = (invocationId, invokedActions)=>invokedActions && invokedActions[invocationId] || 'idle';

});



parcelRegister("5jUvu", function(module, exports) {
$parcel$export(module.exports, "usePageContextType", () => $a8f7be4686f634e9$export$bc4bf2ff8e40b690);
$parcel$export(module.exports, "useRovoConversationStarters", () => $a8f7be4686f634e9$export$65b45f3b39cd6930);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $4LDqh = parcelRequire("4LDqh");

var $9Ydtn = parcelRequire("9Ydtn");

var $kJM81 = parcelRequire("kJM81");

var $iueV3 = parcelRequire("iueV3");

var $atP3J = parcelRequire("atP3J");

var $46mPk = parcelRequire("46mPk");

var $cjcbW = parcelRequire("cjcbW");

var $dIGJy = parcelRequire("dIGJy");

var $eAQb7 = parcelRequire("eAQb7");

var $gBaKj = parcelRequire("gBaKj");

var $egspI = parcelRequire("egspI");

var $50DkA = parcelRequire("50DkA");

var $iJh2F = parcelRequire("iJh2F");

var $e97fB = parcelRequire("e97fB");

var $8fXqJ = parcelRequire("8fXqJ");
const $a8f7be4686f634e9$export$c6a4ebf596b0c08a = {
    [(0, $50DkA.PageContextType).BITBUCKET_CREATE_PULL_REQUEST]: [
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).bitbucketCreatePullRequestsPrompt1
        }
    ],
    [(0, $50DkA.PageContextType).BITBUCKET_PULL_REQUEST]: [
        {
            labelType: 'summarize-information',
            message: (0, $8fXqJ.default).bitbucketPullRequestsPrompt1
        },
        {
            labelType: 'summarize-code',
            message: (0, $8fXqJ.default).bitbucketPullRequestsPrompt4
        },
        {
            labelType: 'analyze-content',
            message: (0, $8fXqJ.default).bitbucketPullRequestsPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).bitbucketPullRequestsPrompt5
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).bitbucketPullRequestsPrompt6
        }
    ],
    [(0, $50DkA.PageContextType).BITBUCKET_REPOSITORY_SOURCE]: [
        {
            labelType: 'summarize-code',
            message: (0, $8fXqJ.default).bitbucketRepositorySourcePrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).bitbucketRepositorySourcePrompt4
        },
        {
            labelType: 'code-search',
            message: (0, $8fXqJ.default).bitbucketRepositorySourcePrompt5
        }
    ],
    [(0, $50DkA.PageContextType).BITBUCKET_PIPELINES]: [
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).bitbucketPipelinePrompt1
        }
    ],
    [(0, $50DkA.PageContextType).BITBUCKET]: [
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).bitbucketPrompt5
        },
        {
            labelType: 'check-status',
            message: (0, $8fXqJ.default).bitbucketPrompt6
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).bitbucketPrompt7
        }
    ],
    [(0, $50DkA.PageContextType).CONFLUENCE_HOME]: [
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).confluenceHomePrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).confluenceHomePrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluenceHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).confluenceHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).confluenceHomePrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).confluenceHomePrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).confluenceHomePrompt9
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).confluenceHomePrompt10
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).confluenceHomePrompt11
        }
    ],
    [(0, $50DkA.PageContextType).CONFLUENCE_PAGE_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).confluencePageViewPrompt6
        }
    ],
    [(0, $50DkA.PageContextType).CONFLUENCE_BLOG_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).confluencePageViewPrompt6
        }
    ],
    [(0, $50DkA.PageContextType).CONFLUENCE_WHITEBOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluenceWhiteboardPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).confluenceWhiteboardPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).confluenceWhiteboardPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).confluenceWhiteboardPrompt4
        }
    ],
    [(0, $50DkA.PageContextType).CONFLUENCE_PAGE_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).confluencePageEditPrompt4
        }
    ],
    [(0, $50DkA.PageContextType).CONFLUENCE_BLOG_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).confluencePageEditPrompt4
        }
    ],
    [(0, $50DkA.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY]: [],
    [(0, $50DkA.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY]: [],
    [(0, $50DkA.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS]: [],
    [(0, $50DkA.PageContextType).JIRA_HOME]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).jiraHomePrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).jiraHomePrompt4
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).jiraHomePrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).jiraHomePrompt6
        }
    ],
    [(0, $50DkA.PageContextType).JIRA_FOR_YOU]: [
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).unknownPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).JIRA_ISSUE_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).jiraIssueViewPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).jiraIssueViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).jiraIssueViewPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).jiraIssueViewPrompt4
        }
    ],
    [(0, $50DkA.PageContextType).JIRA_PROJECT]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).jiraProjectPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).jiraProjectPrompt2
        },
        {
            labelType: 'measure-productivity',
            message: (0, $8fXqJ.default).jiraProjectPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).jiraProjectPrompt4
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).jiraProjectPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).jiraProjectPrompt6
        },
        {
            labelType: 'measure-productivity',
            message: (0, $8fXqJ.default).jiraProjectPrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).jiraProjectPrompt8
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).jiraProjectPrompt9
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).jiraProjectPrompt10
        },
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).jiraProjectPrompt11
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).jiraProjectPrompt12
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).jiraProjectPrompt13
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).jiraProjectPrompt14
        }
    ],
    [(0, $50DkA.PageContextType).JIRA_BOARD]: [
        {
            labelType: 'automation-rule',
            message: (0, $8fXqJ.default).jiraBoardPrompt1
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).jiraBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).jiraBoardPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).jiraBoardPrompt4
        }
    ],
    [(0, $50DkA.PageContextType).JSM_INCIDENT_VIEW]: [
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).jsmIncidentViewPrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).jsmIncidentViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).jsmIncidentViewPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).JSM_INCIDENT_LIST_VIEW]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).jsmIncidentListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).jsmIncidentListViewPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).jsmIncidentListViewPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).JSM_ALERT_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).jsmAlertViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).jsmAlertViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).jsmAlertViewPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).JSM_ALERT_LIST_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).jsmAlertListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).jsmAlertListViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).jsmAlertListViewPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).jsmAlertGroupDetailViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).jsmAlertGroupDetailViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).jsmAlertGroupDetailViewPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).ATLAS_HOME]: [
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).atlasHomePrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $8fXqJ.default).atlasHomePrompt2
        },
        {
            labelType: 'get-answers',
            message: (0, $8fXqJ.default).atlasHomePrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).atlasHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).atlasHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).atlasHomePrompt6
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).confluenceHomePrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).confluenceHomePrompt5
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).confluenceHomePrompt11
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $8fXqJ.default).confluenceHomePrompt10
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $8fXqJ.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).jiraHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).atlasHomePrompt7
        }
    ],
    [(0, $50DkA.PageContextType).ATLAS_HOME_MAIN]: [],
    [(0, $50DkA.PageContextType).ATLAS_HOME_DISCOVER]: [],
    [(0, $50DkA.PageContextType).ATLAS_HOME_RECENTS]: [],
    [(0, $50DkA.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS]: [],
    [(0, $50DkA.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST]: [],
    [(0, $50DkA.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST]: [],
    [(0, $50DkA.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST]: [],
    [(0, $50DkA.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST]: [],
    [(0, $50DkA.PageContextType).FOCUS]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).focusPrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $8fXqJ.default).focusPrompt2
        }
    ],
    [(0, $50DkA.PageContextType).FOCUS_FOR_YOU]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).focusForYouPrompt1
        }
    ],
    [(0, $50DkA.PageContextType).FOCUS_FOCUS_AREA_PAGE]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).focusAreaPrompt1
        }
    ],
    [(0, $50DkA.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).focusAreaGoalPrompt1
        }
    ],
    [(0, $50DkA.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).focusAreaWorkPrompt1
        }
    ],
    [(0, $50DkA.PageContextType).FOCUS_FOCUS_AREA_FUNDS_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).focusAreaPrompt1
        },
        {
            labelType: 'analyze-content',
            message: (0, $8fXqJ.default).focusAreaFundsPrompt1
        }
    ],
    [(0, $50DkA.PageContextType).SAC]: [
        {
            labelType: 'manage-settings',
            message: (0, $8fXqJ.default).sacPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).sacPrompt2
        },
        {
            labelType: 'automation-rule',
            message: (0, $8fXqJ.default).sacPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).TRELLO_BOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).trelloBoardPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).trelloBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).trelloBoardPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).TRELLO_CARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $8fXqJ.default).trelloCardPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).trelloCardPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $8fXqJ.default).trelloCardPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).UNKNOWN]: [
        {
            labelType: 'find-information',
            message: (0, $8fXqJ.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $8fXqJ.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $8fXqJ.default).unknownPrompt3
        }
    ],
    [(0, $50DkA.PageContextType).ADMIN_HUB]: []
};
const $a8f7be4686f634e9$export$a905239756c1fbae = (location)=>{
    const jsmIncidentViewPatterns = [
        // Single incident view (with issue key at the end)
        [
            (0, $50DkA.PageContextType).JSM_INCIDENT_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+\/[A-Z]+-\d+/
        ]
    ];
    const jsmOpsPatterns = (0, $egspI.fg)('rovo_ops_conversation_starters_enabled') ? [
        // Incident list view (without issue key at the end)
        [
            (0, $50DkA.PageContextType).JSM_INCIDENT_LIST_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+$/
        ],
        // Single alert view (has / after alerts)
        [
            (0, $50DkA.PageContextType).JSM_ALERT_VIEW,
            /\/jira\/ops\/alerts\//
        ],
        // Alert list view (has ? after alerts)
        [
            (0, $50DkA.PageContextType).JSM_ALERT_LIST_VIEW,
            /\/jira\/ops\/alerts\?/
        ],
        // Alert group detail view
        [
            (0, $50DkA.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW,
            /\/jira\/ops\/group-detail\//
        ]
    ] : [];
    const jiraBoardPattern = /\/jira\/.+\/projects\/[^\/]+\/boards\/[^\/?]+/;
    // Jira board contextual starters are gated by a targeting feature gate plus an experiment.
    // Unlike most patterns below, we test the board route before adding it to urlPatterns so
    // getExperimentValue is only read on board pages and non-board pages do not log exposures.
    const jiraBoardPatterns = [];
    if (jiraBoardPattern.test(location) && (0, $egspI.fg)('jira_boards_rovo_contextual_actions_experiment_eligibility')) {
        const actionsVariant = (0, $4LDqh.default).getExperimentValue('jira_boards_rovo_actions_exp_targeted', 'actions_variant', 'control_static_actions');
        if (actionsVariant === 'contextual_actions_only') jiraBoardPatterns.push([
            (0, $50DkA.PageContextType).JIRA_BOARD,
            jiraBoardPattern
        ]);
    }
    const urlPatterns = [
        [
            (0, $50DkA.PageContextType).BITBUCKET_REPOSITORY_SOURCE,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/src\//
        ],
        [
            (0, $50DkA.PageContextType).BITBUCKET_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/\d+/
        ],
        [
            (0, $50DkA.PageContextType).BITBUCKET_CREATE_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/new/
        ],
        [
            (0, $50DkA.PageContextType).BITBUCKET_PIPELINES,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pipelines\/results\/[^\/]+\/steps\//
        ],
        [
            (0, $50DkA.PageContextType).BITBUCKET,
            /bitbucket\.org\/.*/
        ],
        [
            (0, $50DkA.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/?$/
        ],
        [
            (0, $50DkA.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/home$/
        ],
        [
            (0, $50DkA.PageContextType).CONFLUENCE_BLOG_EDIT,
            /\/wiki\/spaces\/[^\/]+\/blog\/edit-v2\//
        ],
        [
            (0, $50DkA.PageContextType).CONFLUENCE_BLOG_VIEW,
            /\/wiki\/spaces\/[^\/]+\/blog\//
        ],
        [
            (0, $50DkA.PageContextType).CONFLUENCE_PAGE_EDIT,
            /\/wiki\/spaces\/[^\/]+\/pages\/edit-v2\//
        ],
        [
            (0, $50DkA.PageContextType).CONFLUENCE_PAGE_VIEW,
            /\/wiki\/spaces\/[^\/]+\/pages\//
        ],
        [
            (0, $50DkA.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        [
            (0, $50DkA.PageContextType).JIRA_ISSUE_VIEW,
            /\/browse\/[^\/]+$/
        ],
        [
            (0, $50DkA.PageContextType).JIRA_ISSUE_VIEW,
            /\/jira\/.+\/projects\/[^/]+\/[^?]+\?(?:.*&)?selectedIssue=/
        ],
        ...jsmIncidentViewPatterns,
        ...jsmOpsPatterns,
        [
            (0, $50DkA.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            (0, $50DkA.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        [
            (0, $50DkA.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS,
            /\/jira\/software\/projects\/[^\/]+\/settings\/access/
        ],
        ...jiraBoardPatterns,
        [
            (0, $50DkA.PageContextType).JIRA_PROJECT,
            /\/jira\/.+\/projects\//
        ],
        [
            (0, $50DkA.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $50DkA.PageContextType).JIRA_FOR_YOU,
            /\/jira\/for-you$/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            (0, $50DkA.PageContextType).ATLAS_HOME_DISCOVER,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*discover+/
        ],
        [
            (0, $50DkA.PageContextType).ATLAS_HOME_RECENTS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*recents+/
        ],
        [
            (0, $50DkA.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*notifications+/
        ],
        [
            (0, $50DkA.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/projects+/
        ],
        [
            (0, $50DkA.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/goals+/
        ],
        [
            (0, $50DkA.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/team+/
        ],
        [
            (0, $50DkA.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/tag+/
        ],
        [
            (0, $50DkA.PageContextType).ATLAS_HOME_MAIN,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*\?cloudId=[^\/]+/
        ],
        [
            (0, $50DkA.PageContextType).ATLAS_HOME,
            /\/(home|team)\./
        ],
        [
            (0, $50DkA.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW,
            /\/focus\/focus-area\/.*\/goals/
        ],
        [
            (0, $50DkA.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW,
            /\/focus\/focus-area\/.*\/work/
        ],
        ...(0, $egspI.fg)('rovo_chat_focus_analyze_funds') ? [
            [
                (0, $50DkA.PageContextType).FOCUS_FOCUS_AREA_FUNDS_VIEW,
                /\/focus\/focus-area\/.*\/funds/
            ]
        ] : [],
        [
            (0, $50DkA.PageContextType).FOCUS_FOCUS_AREA_PAGE,
            /\/focus\/focus-area\/.*/
        ],
        [
            (0, $50DkA.PageContextType).FOCUS_FOR_YOU,
            /\/focus\/for-you(?:\/.*)?$/
        ],
        [
            (0, $50DkA.PageContextType).FOCUS,
            /\/focus\/.*/
        ],
        [
            (0, $50DkA.PageContextType).SAC,
            /support\.atlassian\.com/
        ],
        // Trello: card view first (more specific), then board. Prod: trello.com, Staging: trellis.coffee (and *.atlassian.com)
        [
            (0, $50DkA.PageContextType).TRELLO_CARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/c\//
        ],
        [
            (0, $50DkA.PageContextType).TRELLO_BOARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/b\//
        ],
        // admin hub: admin.atlassian.com (production) or admin.stg.atlassian.com (staging)
        [
            (0, $50DkA.PageContextType).ADMIN_HUB,
            /admin(\.stg)?\.atlassian\.com/
        ]
    ];
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return (0, $50DkA.PageContextType).UNKNOWN;
};
const $a8f7be4686f634e9$export$bc4bf2ff8e40b690 = ()=>{
    const location = (0, $iJh2F.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $euxye.useState)($a8f7be4686f634e9$export$a905239756c1fbae(location));
    (0, $euxye.useEffect)(()=>{
        setPageContextType($a8f7be4686f634e9$export$a905239756c1fbae(location));
    }, [
        location
    ]);
    return pageContextType;
};
const $a8f7be4686f634e9$var$shuffleStarters = (arr)=>{
    const copiedArr = [
        ...arr
    ];
    // Shuffle array using Fisher-Yates algorithm
    for(let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [copiedArr[i], copiedArr[j]] = [
            copiedArr[j],
            copiedArr[i]
        ];
    }
    return copiedArr;
};
const $a8f7be4686f634e9$export$82bea1a28fda43c1 = (starters, num)=>{
    // Return the first `num` items
    return $a8f7be4686f634e9$var$shuffleStarters(starters).slice(0, num);
};
const $a8f7be4686f634e9$var$getIconAndLabelForStarter = (labelType)=>{
    switch(labelType){
        case 'be-productive':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($atP3J))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).beProductiveLabel
            };
        case 'stay-up-to-date':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($atP3J))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).stayUpToDateLabel
            };
        case 'summarize-content':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cjcbW))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).summarizeContentLabel
            };
        case 'rephrase-content':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cjcbW))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).rephraseContentLabel
            };
        case 'draft-content':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cjcbW))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).draftContentLabel
            };
        case 'find-information':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).findInformationLabel
            };
        case 'find-people':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).findPeopleLabel
            };
        case 'code-search':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).codeSearchLabel
            };
        case 'measure-productivity':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($atP3J))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).measureProductivityLabel
            };
        case 'get-answers':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).getAnswersLabel
            };
        case 'check-status':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46mPk))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).checkStatusLabel
            };
        case 'summarize-information':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iueV3))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).summarizeInformationLabel
            };
        case 'analyze-content':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iueV3))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).analyzeContentLabel
            };
        case 'summarize-code':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Ydtn))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).summarizeCodeLabel
            };
        case 'manage-settings':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dIGJy))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).manageSettingsLabel
            };
        case 'automation-rule':
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gBaKj))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).automationRuleLabel
            };
        default:
            return {
                icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($atP3J))), {
                    label: ""
                }),
                label: (0, $8fXqJ.default).beProductiveLabel
            };
    }
};
// default to fetching 3 dynamic starters
const $a8f7be4686f634e9$var$DYNAMIC_STARTERS_COUNT = 3;
const $a8f7be4686f634e9$export$65b45f3b39cd6930 = ({ numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const pageContextType = $a8f7be4686f634e9$export$bc4bf2ff8e40b690();
    const location = (0, $iJh2F.useWindowLocation)();
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $e97fB.useFetchConvoStarters)({
        contentUrl: location,
        pageContextType: pageContextType,
        showConvoStarters: dynamicStartersConfig?.enabled && !!assistanceServiceParams,
        // hacky workaround for consumers that don't need dynamic starters (and therfore don't pass in assistanceServiceParams)
        assistanceServiceParams: assistanceServiceParams || {
            touchpointSource: '',
            product: '',
            experienceId: '',
            siteId: ''
        }
    });
    const staticStarters = (0, $euxye.useMemo)(()=>{
        const contextualStarters = $a8f7be4686f634e9$export$c6a4ebf596b0c08a[pageContextType].map((starter)=>{
            return {
                labelType: starter.labelType,
                message: formatMessage(starter.message),
                type: 'static'
            };
        });
        return contextualStarters;
    }, [
        pageContextType,
        formatMessage
    ]);
    const groupedStarters = (0, $euxye.useMemo)(()=>staticStarters.reduce((acc, starter)=>{
            if (!starter.labelType) return acc;
            acc[starter.labelType] = [
                ...acc[starter.labelType] || [],
                starter
            ];
            return acc;
        }, {}), [
        staticStarters
    ]);
    // Use this to get conversation starter actions that are not nested (e.g. for Sidebar)
    const conversationStarterActions = (0, $euxye.useMemo)(()=>Object.entries(groupedStarters).map(([, starters])=>{
            // If there is only one starter in the group, return as a single chat action, otherwise return one of the nested items to use as a starter
            if (starters.length === 1) {
                const starter = starters[0];
                const starterHasPlaceholder = starter.message.includes('`');
                return {
                    id: 'convo-starter',
                    title: starter.message,
                    icon: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $50DkA.HandleActionType).Chat,
                    children: [],
                    ...starterHasPlaceholder ? {
                        dynamicPrompt: starter.message
                    } : {
                        staticPrompt: starter.message
                    },
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            } else {
                //Grab a random starter from the group to use
                const randomIndex = Math.floor(Math.random() * starters.length);
                const randomStarter = starters[randomIndex];
                const randomStarterHasPlaceholder = randomStarter.message.includes('`');
                return {
                    id: `convo-starter`,
                    title: randomStarter.message,
                    icon: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $50DkA.HandleActionType).Chat,
                    ...randomStarterHasPlaceholder ? {
                        dynamicPrompt: randomStarter.message
                    } : {
                        staticPrompt: randomStarter.message
                    },
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            }
        }), [
        groupedStarters
    ]);
    // Use this to get conversation starter actions that are nested (e.g. for Full Screen)
    const nestedConversationStarterActions = (0, $euxye.useMemo)(()=>Object.entries(groupedStarters).map(([, starters])=>{
            const { icon: icon, label: label } = $a8f7be4686f634e9$var$getIconAndLabelForStarter(starters[0].labelType);
            return {
                id: 'convo-starter',
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: ()=>{},
                children: starters.map((starter)=>{
                    const starterHasPlaceholder = starter.message.includes('`');
                    return {
                        id: 'convo-starter',
                        title: starter.message,
                        icon: ()=>icon,
                        onClick: ()=>{},
                        type: 'convo-starter-action',
                        handleType: (0, $50DkA.HandleActionType).Chat,
                        ...starterHasPlaceholder ? {
                            dynamicPrompt: starter.message
                        } : {
                            staticPrompt: starter.message
                        },
                        starterType: 'static'
                    };
                }),
                handleType: (0, $50DkA.HandleActionType).Nested,
                type: 'convo-starter-action'
            };
        }), [
        groupedStarters,
        formatMessage
    ]);
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    // dynamic starter actions are not included in nested use case
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    const randomizedConversationStarterActions = (0, $euxye.useMemo)(()=>{
        if (!dynamicStartersConfig?.enabled) return $a8f7be4686f634e9$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
        if (isDynamicStarterActionsLoading) return [];
        if (dynamicStarterActions.length >= numStartersToReturn) return dynamicStarterActions.slice(0, numStartersToReturn);
        // prioritizes dynamic starters, and then randomizes the static starters
        return [
            ...dynamicStarterActions,
            ...$a8f7be4686f634e9$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
        ];
    }, [
        conversationStarterActions,
        numStartersToReturn,
        dynamicStarterActions,
        isDynamicStarterActionsLoading,
        dynamicStartersConfig?.enabled
    ]);
    const randomizedNestedConversationStarterActions = (0, $euxye.useMemo)(()=>{
        return $a8f7be4686f634e9$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
    }, [
        nestedConversationStarterActions,
        numNestedStartersToReturn
    ]);
    return {
        conversationStarterActions: randomizedConversationStarterActions,
        nestedConversationStarterActions: randomizedNestedConversationStarterActions,
        getRandomStarters: $a8f7be4686f634e9$export$82bea1a28fda43c1,
        isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
        numDynamicStarterActionsLoading: Math.min($a8f7be4686f634e9$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn)
    };
};

});
parcelRegister("9Ydtn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f828166ff0e4b26e4ba3197fe41c41b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74242b13ef5c1ec5$var$_react = $74242b13ef5c1ec5$var$_interopRequireDefault((parcelRequire("euxye")));

var $74242b13ef5c1ec5$var$_baseNew = $74242b13ef5c1ec5$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $74242b13ef5c1ec5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74242b13ef5c1ec5$var$AtomIcon = (props)=>/*#__PURE__*/ $74242b13ef5c1ec5$var$_react.default.createElement($74242b13ef5c1ec5$var$_baseNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$74242b13ef5c1ec5$var$AtomIcon.displayName = 'AtomIcon';
var $74242b13ef5c1ec5$var$_default = module.exports.default = $74242b13ef5c1ec5$var$AtomIcon;

});

parcelRegister("iueV3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95423e512da4efab75a02d0a150e041a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d75699ff4e5f52f0$var$_react = $d75699ff4e5f52f0$var$_interopRequireDefault((parcelRequire("euxye")));

var $d75699ff4e5f52f0$var$_baseNew = $d75699ff4e5f52f0$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $d75699ff4e5f52f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d75699ff4e5f52f0$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $d75699ff4e5f52f0$var$_react.default.createElement($d75699ff4e5f52f0$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextSummaryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 12.5V14H1v-1.5zm3.5-5.25v1.5H1v-1.5zM15 2v1.5H1V2zm-2.5 7a.75.75 0 0 1 .71.49l.61 1.69 1.69.62a.75.75 0 0 1 .49.7l-.01.12a.75.75 0 0 1-.48.59l-1.69.61-.61 1.69a.75.75 0 0 1-.59.48l-.12.01a.75.75 0 0 1-.7-.49l-.61-1.69-1.69-.61a.75.75 0 0 1-.48-.59L9 12.5a.75.75 0 0 1 .49-.7l1.69-.61.62-1.69a.75.75 0 0 1 .59-.48z"/>`
    }, props));
$d75699ff4e5f52f0$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $d75699ff4e5f52f0$var$_default = module.exports.default = $d75699ff4e5f52f0$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("46mPk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c02a973e1b80a41efb48b80326ffc315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fc96dec0c1e5121$var$_react = $2fc96dec0c1e5121$var$_interopRequireDefault((parcelRequire("euxye")));

var $2fc96dec0c1e5121$var$_baseNew = $2fc96dec0c1e5121$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $2fc96dec0c1e5121$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fc96dec0c1e5121$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $2fc96dec0c1e5121$var$_react.default.createElement($2fc96dec0c1e5121$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$2fc96dec0c1e5121$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $2fc96dec0c1e5121$var$_default = module.exports.default = $2fc96dec0c1e5121$var$CloudArrowUpIcon;

});

parcelRegister("cjcbW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77c848e3098666bf0b9d860f7c0fa130>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f60b76018063e9b$var$_react = $8f60b76018063e9b$var$_interopRequireDefault((parcelRequire("euxye")));

var $8f60b76018063e9b$var$_baseNew = $8f60b76018063e9b$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $8f60b76018063e9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EditBulk".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing multiple objects in bulk.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f60b76018063e9b$var$EditBulkIcon = (props)=>/*#__PURE__*/ $8f60b76018063e9b$var$_react.default.createElement($8f60b76018063e9b$var$_baseNew.default, Object.assign({
        name: "EditBulkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 1 4.25zm1.5.75v1h1v-1zm9.836.104a2 2 0 0 1 2.828 0l.232.232a2 2 0 0 1 0 2.828l-4.848 4.849a2 2 0 0 1-1.022.547l-2.129.425a.75.75 0 0 1-.882-.882l.425-2.129a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.708 0L13.061 4l.939.94.336-.336a.5.5 0 0 0 0-.708zM12.939 6 12 5.06 8.548 8.514a.5.5 0 0 0-.137.255l-.205 1.026 1.026-.205a.5.5 0 0 0 .255-.137zM1 6.75A.75.75 0 0 1 1.75 6h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 1 9.25zm1.5.75v1h1v-1zM1 11.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75zm1.5.75v1h1v-1z" clip-rule="evenodd"/>`
    }, props));
$8f60b76018063e9b$var$EditBulkIcon.displayName = 'EditBulkIcon';
var $8f60b76018063e9b$var$_default = module.exports.default = $8f60b76018063e9b$var$EditBulkIcon;

});

parcelRegister("dIGJy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57e36493b019d12297a87aa4bfc67ec1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fd088737151c7d1$var$_react = $9fd088737151c7d1$var$_interopRequireDefault((parcelRequire("euxye")));

var $9fd088737151c7d1$var$_baseNew = $9fd088737151c7d1$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $9fd088737151c7d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fd088737151c7d1$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $9fd088737151c7d1$var$_react.default.createElement($9fd088737151c7d1$var$_baseNew.default, Object.assign({
        name: "PersonAddedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m4.95 6.99-3.83 4.5a.75.75 0 0 1-1.14 0l-1.92-2.25 1.14-.97 1.35 1.58 3.26-3.83z"/>`
    }, props));
$9fd088737151c7d1$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $9fd088737151c7d1$var$_default = module.exports.default = $9fd088737151c7d1$var$PersonAddedIcon;

});

parcelRegister("iJh2F", function(module, exports) {
$parcel$export(module.exports, "useWindowLocation", () => $48fa5187d898f023$export$6fa751d66e55d2e1);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");
const $48fa5187d898f023$export$46133998910543ac = (0, $euxye.createContext)(null);
const $48fa5187d898f023$export$6fa751d66e55d2e1 = (usePathname)=>{
    const [location, setLocation] = (0, $euxye.useState)(usePathname ? window.location.pathname : window.location.href);
    // For easier mocking
    const contextValue = (0, $euxye.useContext)($48fa5187d898f023$export$46133998910543ac);
    const handleLocationChange = (0, $euxye.useCallback)(()=>{
        const newValue = usePathname ? window.location.pathname : window.location.href;
        if (newValue !== location) setLocation(newValue);
    }, [
        location,
        setLocation,
        usePathname
    ]);
    (0, $euxye.useEffect)(()=>{
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $glbdM.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return contextValue ?? location;
};

});

parcelRegister("e97fB", function(module, exports) {
$parcel$export(module.exports, "useFetchConvoStarters", () => $1b2609b3a060c869$export$460b2fd9dae847fd);
// adapted from: platform/packages/insights-ai-platform/ai-smart-button/src/ui/ai-actions/hooks/useFetchConvoStarters.ts

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kJM81 = parcelRequire("kJM81");

var $jSoCT = parcelRequire("jSoCT");

var $5oGA6 = parcelRequire("5oGA6");

var $fZQSX = parcelRequire("fZQSX");

var $PkUAZ = parcelRequire("PkUAZ");

var $50DkA = parcelRequire("50DkA");

var $8x8Vq = parcelRequire("8x8Vq");

var $3Ruyd = parcelRequire("3Ruyd");
const $1b2609b3a060c869$var$mapToConversationActionNew = (starterObject)=>{
    return {
        id: 'convo-starter',
        title: starterObject.starter,
        icon: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                label: ""
            }),
        staticPrompt: starterObject.starter,
        handleType: (0, $50DkA.HandleActionType).Chat,
        starterType: 'dynamic',
        jtbdCategory: starterObject.jtbd_category,
        agent: undefined,
        type: 'convo-starter-action'
    };
};
const $1b2609b3a060c869$export$460b2fd9dae847fd = (0, $PkUAZ.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId }, contentUrl: contentUrl, pageContextType: pageContextType, showConvoStarters: showConvoStarters = false })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $5oGA6.useAnalytics)();
    const timingRef = (0, $euxye.useRef)(null);
    const contentAri = (0, $euxye.useMemo)(()=>(0, $3Ruyd.getContentAri)(siteId, contentUrl, pageContextType), [
        siteId,
        contentUrl,
        pageContextType
    ]);
    // TODO ASIMO-2398: experiment cleanup
    const urlDebugInfo = (0, $euxye.useMemo)(()=>{
        try {
            const url = new URL(contentUrl);
            return {
                pathSegmentCount: url.pathname.split('/').filter(Boolean).length,
                hasQueryParams: url.search.length > 0,
                protocol: url.protocol
            };
        } catch  {
            return {
                pathSegmentCount: 0,
                hasQueryParams: false,
                protocol: 'invalid'
            };
        }
    }, [
        contentUrl
    ]);
    const isPageContextTypeSupported = (0, $8x8Vq.isPageContextTypeSupportedForDynamicStarters)(pageContextType);
    const isEligibleContext = isPageContextTypeSupported && contentAri !== null;
    const isFeatureEnabled = showConvoStarters && isEligibleContext;
    // TODO ASIMO-2398: experiment cleanup
    (0, $euxye.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'called',
            actionSubject: 'useFetchConvoStarters',
            attributes: {
                showConvoStarters: showConvoStarters,
                isPageContextTypeSupported: isPageContextTypeSupported,
                isEligibleContext: isEligibleContext,
                isFeatureEnabled: isFeatureEnabled,
                pageContextType: String(pageContextType),
                hasContentAri: contentAri !== null,
                contentAri: contentAri,
                urlStructure: urlDebugInfo
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { data: convoStarters, isFetching: isLoading, error: fetchError } = (0, $fZQSX.useQuery)({
        enabled: isFeatureEnabled,
        queryKey: [
            'dynamicConvoStarters',
            contentAri ?? contentUrl
        ],
        queryFn: async ()=>{
            // Custom performance tracking for dynamic starters experiment to analyze on Statsig.
            // Confluence ui taskSuccess events aren't sent to Statsig.
            timingRef.current = {
                startTime: performance.now(),
                sent: false,
                pageContextType: String(pageContextType)
            };
            experienceTracker.start({
                id: (0, $jSoCT.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                name: (0, $jSoCT.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'started',
                actionSubject: 'fetchConvoStarters',
                attributes: {
                    pageContextType: timingRef.current.pageContextType
                }
            });
            const response = await assistanceService.getDynamicConvoStartersNew({
                ai_feature_input: {
                    // safe to assert: query is disabled (enabled condition) when contentAri is null
                    documents: [
                        {
                            ari: contentAri
                        }
                    ]
                }
            });
            // Since we only request one document, we should get exactly one result
            const result = response?.ai_feature_output?.results?.[0];
            if (!result) throw new Error('Expected one result in API response but received none');
            if (result.error) {
                const errorType = result.error.error_type;
                // expected failures (HYDRATION_ERROR) are silently filtered
                if (errorType === 'HYDRATION_ERROR') return [];
                throw new Error(`[${errorType}] ${result.error.message}`);
            }
            if (!result.convo_starters.length) return [];
            return result.convo_starters.map((starter)=>$1b2609b3a060c869$var$mapToConversationActionNew(starter));
        },
        onSuccess: (data)=>{
            experienceTracker.succeed({
                name: (0, $jSoCT.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'succeeded',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        startersCount: data?.length ?? 0,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        },
        onError: (error)=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'failed',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        errorMessage: error.message,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
            experienceTracker.fail({
                name: (0, $jSoCT.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                error: error
            });
        }
    });
    // Track cancellations when component unmounts during fetch
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'cancelled',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        };
    }, [
        sendAnalyticsEvent
    ]);
    return (0, $euxye.useMemo)(()=>({
            convoStarters: convoStarters ?? [],
            isLoading: isLoading,
            error: fetchError ?? undefined
        }), [
        convoStarters,
        isLoading,
        fetchError
    ]);
});

});
parcelRegister("8x8Vq", function(module, exports) {
$parcel$export(module.exports, "isPageContextTypeSupportedForDynamicStarters", () => $96806024d77e935e$export$c2a686cb0530eec8);

var $50DkA = parcelRequire("50DkA");
const $96806024d77e935e$var$supportedPageContextTypes = [
    (0, $50DkA.PageContextType).CONFLUENCE_PAGE_VIEW,
    (0, $50DkA.PageContextType).CONFLUENCE_PAGE_EDIT
];
const $96806024d77e935e$export$c2a686cb0530eec8 = (pageContextType)=>{
    return $96806024d77e935e$var$supportedPageContextTypes.includes(pageContextType);
};

});

parcelRegister("3Ruyd", function(module, exports) {
$parcel$export(module.exports, "getContentAri", () => $667d84ba30aef70b$export$3bb5b6748490a3c9);

var $50DkA = parcelRequire("50DkA");
const $667d84ba30aef70b$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $667d84ba30aef70b$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($667d84ba30aef70b$export$10c6f1bef31d587c.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
const $667d84ba30aef70b$export$ee833111bcbf78d7 = (url, pageContextType)=>{
    if (pageContextType === (0, $50DkA.PageContextType).CONFLUENCE_PAGE_EDIT || pageContextType === (0, $50DkA.PageContextType).CONFLUENCE_BLOG_EDIT) {
        // Match: /pages/edit-v2/{resourceId} or /blog/edit-v2/{resourceId}
        const match = url.match(/\/(?:pages|blog)\/edit-v2\/(\d+)/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $50DkA.PageContextType).CONFLUENCE_PAGE_VIEW) {
        // Page pattern: /pages/{resourceId}/
        const match = url.match(/\/pages\/(\d+)(?:\/|$|[?#])/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $50DkA.PageContextType).CONFLUENCE_BLOG_VIEW) {
        // Blog pattern: /blog/{year}/{month}/{day}/{resourceId}/
        const match = url.match(/\/blog\/\d{4}\/\d{2}\/\d{2}\/(\d+)/);
        return match ? match[1] : null;
    }
    return null;
};
const $667d84ba30aef70b$export$3bb5b6748490a3c9 = (siteId, contentUrl, pageContextType)=>{
    const resourceId = $667d84ba30aef70b$export$ee833111bcbf78d7(contentUrl, pageContextType);
    if (!resourceId) return null;
    const isBlogPost = /\/spaces\/[^\/]+\/blog\//.test(contentUrl);
    const resourceType = isBlogPost ? 'blogpost' : 'page';
    return $667d84ba30aef70b$export$6a2f2c83863e9bfe({
        siteId: siteId,
        resourceType: resourceType,
        activationId: '',
        resourceId: resourceId
    });
};

});


parcelRegister("8fXqJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f843e87e3d591eee$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $f843e87e3d591eee$var$_default_1 = (0, $7eNDO.defineMessages)({
    // Conversation starter labels
    beProductiveLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.be-productive',
        defaultMessage: 'Be productive',
        description: 'Label for the "Be productive" conversation starter tile'
    },
    stayUpToDateLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.stay-up-to-date',
        defaultMessage: 'Stay up-to-date',
        description: 'Label for the "Stay up-to-date" conversation starter tile'
    },
    summarizeContentLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.summarize-content',
        defaultMessage: 'Summarize content',
        description: 'Label for the "Summarize content" conversation starter tile'
    },
    rephraseContentLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.rephrase-content',
        defaultMessage: 'Rephrase content',
        description: 'Label for the "Rephrase content" conversation starter tile'
    },
    draftContentLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.draft-content',
        defaultMessage: 'Draft content',
        description: 'Label for the "Draft content" conversation starter tile'
    },
    findInformationLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.find-information',
        defaultMessage: 'Find information',
        description: 'Label for the "Find information" conversation starter tile'
    },
    findPeopleLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.find-people',
        defaultMessage: 'Find people',
        description: 'Label for the "Find people" conversation starter tile'
    },
    codeSearchLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.code-search',
        defaultMessage: 'Code search',
        description: 'Label for the "Code search" conversation starter tile'
    },
    measureProductivityLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.measure-productivity',
        defaultMessage: 'Measure productivity',
        description: 'Label for the "Measure productivity" conversation starter tile'
    },
    getAnswersLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.get-answers',
        defaultMessage: 'Get answers',
        description: 'Label for the "Get answers" conversation starter tile'
    },
    checkStatusLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.check-status',
        defaultMessage: 'Check status',
        description: 'Label for the "Check status" conversation starter tile'
    },
    summarizeInformationLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.summarize-information',
        defaultMessage: 'Summarize information',
        description: 'Label for the "Summarize information" conversation starter tile'
    },
    analyzeContentLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.analyze-content',
        defaultMessage: 'Analyze content',
        description: 'Label for the "Analyze content" conversation starter tile'
    },
    summarizeCodeLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.summarize-code',
        defaultMessage: 'Summarize code',
        description: 'Label for the "Summarize code" conversation starter tile'
    },
    automationRuleLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.automation-rule',
        defaultMessage: 'Automation rule',
        description: 'Label for the "Automation rule" conversation starter tile'
    },
    manageSettingsLabel: {
        id: 'rovo-conversation-actions.conversation-starters.label.manage-settings',
        defaultMessage: 'Manage settings',
        description: 'Label for the "Manage settings" conversation starter tile'
    },
    // BITBUCKET_CREATE_PULL_REQUESTS
    bitbucketCreatePullRequestsPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-create-pull-requests.starter-1',
        defaultMessage: 'Suggest reviewers for this pull request',
        description: 'The first prompt option in the empty state of the chat history when viewing Bitbucket Create Pull Requests'
    },
    // BITBUCKET_PULL_REQUESTS
    bitbucketPullRequestsPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-1',
        defaultMessage: 'Summarize this pull request',
        description: 'The first prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests'
    },
    bitbucketPullRequestsPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-2',
        defaultMessage: 'Explain the code changes to me.',
        description: 'The second prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests'
    },
    bitbucketPullRequestsPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-3',
        defaultMessage: 'Summarize the comments on this pull request',
        description: 'The third prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests'
    },
    bitbucketPullRequestsPrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-4',
        defaultMessage: 'Explain the code changes',
        description: 'The forth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests'
    },
    bitbucketPullRequestsPrompt5: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-5-1',
        defaultMessage: 'Summarize the build logs',
        description: 'The fifth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests'
    },
    bitbucketPullRequestsPrompt6: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-6',
        defaultMessage: 'Suggest reviewers for this pull request',
        description: 'The sixth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests'
    },
    // BITBUCKET_REPOSITORY_SOURCE
    bitbucketRepositorySourcePrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-1',
        defaultMessage: 'Explain this file',
        description: 'The first prompt option in the empty state of the chat history when viewing Bitbucket Repository Source'
    },
    bitbucketRepositorySourcePrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-2',
        defaultMessage: 'What are the pull requests authored by `person`?',
        description: 'The second prompt option in the empty state of the chat history when viewing Bitbucket Repository Source'
    },
    bitbucketRepositorySourcePrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-3',
        defaultMessage: ' What APIs or modules do these files interact with?',
        description: 'The third prompt option in the empty state of the chat history when viewing Bitbucket Repository Source'
    },
    bitbucketRepositorySourcePrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-4',
        defaultMessage: 'Find pull requests authored by `person`',
        description: 'The forth prompt option in the empty state of the chat history when viewing Bitbucket Repository Source'
    },
    bitbucketRepositorySourcePrompt5: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-5',
        defaultMessage: 'Find APIs that these files interact with',
        description: 'The fifth prompt option in the empty state of the chat history when viewing Bitbucket Repository Source'
    },
    // BITBUCKET_PIPELINES
    bitbucketPipelinePrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-1-1',
        defaultMessage: 'Summarize the build logs',
        description: 'The first prompt option in the empty state of the chat history when viewing Bitbucket pipelines'
    },
    bitbucketPipelinePrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-2',
        defaultMessage: 'What is the status of the `build`?',
        description: 'The second prompt option in the empty state of the chat history when viewing Bitbucket pipelines'
    },
    // BITBUCKET_HOME
    bitbucketPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-1',
        defaultMessage: 'What are the pull requests authored by `person`?',
        description: 'The first prompt option in the empty state of the chat history when viewing any page on Bitbucket'
    },
    bitbucketPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-2',
        defaultMessage: 'What are the open PRs for the current Jira sprint?',
        description: 'The second prompt option in the empty state of the chat history when viewing any page on Bitbucket'
    },
    bitbucketPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-3',
        defaultMessage: 'Has `Jira work item` been deployed?',
        description: 'The third prompt option in the empty state of the chat history when viewing any page on Bitbucket'
    },
    bitbucketPrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-4',
        defaultMessage: 'Who are the reviewers on this `Pull request`?',
        description: 'The fourth prompt option in the empty state of the chat history when viewing any page on Bitbucket'
    },
    bitbucketPrompt5: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-5',
        defaultMessage: 'Find pull requests authored by `person`',
        description: 'The fifth prompt option in the empty state of the chat history when viewing any page on Bitbucket'
    },
    bitbucketPrompt6: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-6',
        defaultMessage: 'Check deployment status of `Jira work item`',
        description: 'The sixth prompt option in the empty state of the chat history when viewing any page on Bitbucket'
    },
    bitbucketPrompt7: {
        id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-7',
        defaultMessage: 'Find reviewers of `pull request`',
        description: 'The seventh prompt option in the empty state of the chat history when viewing any page on Bitbucket'
    },
    // CONFLUENCE_HOME
    confluenceHomePrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-1',
        defaultMessage: "Is there any new activity on pages I've written?",
        description: 'The first prompt option in the empty state of the chat history when viewing Confluence Home'
    },
    confluenceHomePrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-2',
        defaultMessage: 'Are there any new comments mentioning me?',
        description: 'The second prompt option in the empty state of the chat history when viewing Confluence Home'
    },
    confluenceHomePrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-3',
        defaultMessage: 'Summarize the most recently published pages in this space.',
        description: 'The third prompt option in the empty state of the chat history when viewing Confluence Home'
    },
    confluenceHomePrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-4',
        defaultMessage: 'Summarize my contributions to pages from last week.',
        description: 'The fourth prompt option in the empty state of the chat history when viewing Confluence'
    },
    confluenceHomePrompt5: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-5',
        defaultMessage: 'Can you take this `page` and write it in a less technical way?',
        description: 'The fifth prompt option in the empty state of the chat history when viewing Confluence'
    },
    confluenceHomePrompt6: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-6',
        defaultMessage: 'Create a game plan template for project management.',
        description: 'The sixth prompt option in the empty state of the chat history when viewing Confluence'
    },
    confluenceHomePrompt7: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-7',
        defaultMessage: 'What research do we have on common customer problems?',
        description: 'The seventh prompt option in the empty state of the chat history when viewing Confluence'
    },
    confluenceHomePrompt8: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-8',
        defaultMessage: 'Has anyone on my team published any new pages this week?',
        description: 'The eighth prompt option in the empty state of the chat history when viewing Confluence'
    },
    confluenceHomePrompt9: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-9',
        defaultMessage: 'Has `person` published any new pages this week?',
        description: 'The ninth prompt option in the empty state of the chat history when viewing Confluence'
    },
    confluenceHomePrompt10: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-10',
        defaultMessage: "Has `person` commented on any pages that I've published?",
        description: 'The tenth prompt option in the empty state of the chat history when viewing Confluence'
    },
    confluenceHomePrompt11: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-11',
        defaultMessage: 'What are the key takeaways from `page`?',
        description: 'The eleventh prompt option in the empty state of the chat history when viewing Confluence'
    },
    confluenceHomePrompt12: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-12',
        defaultMessage: 'What should I work on next?',
        description: 'The twelfth prompt option in the empty state of the chat history when viewing Confluence'
    },
    // CONFLUENCE_PAGE_VIEW & CONFLUENCE_BLOG_VIEW
    confluencePageViewPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-1',
        defaultMessage: "Summarize what I'm looking at.",
        description: 'The first prompt option in the empty state of the chat history when viewing a Confluence page'
    },
    confluencePageViewPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-2',
        defaultMessage: 'Summarize the comments on this page.',
        description: 'The second prompt option in the empty state of the chat history when viewing a Confluence page'
    },
    confluencePageViewPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-3',
        defaultMessage: "Explain this page to me like I'm a beginner.",
        description: 'The third prompt option in the empty state of the chat history when viewing a Confluence page'
    },
    confluencePageViewPrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-4',
        defaultMessage: 'Who wrote this page and what team are they on?',
        description: 'The fourth prompt option in the empty state of the chat history when viewing a Confluence page'
    },
    confluencePageViewPrompt5: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-5',
        defaultMessage: 'Has anything on this page changed in the last week?',
        description: 'The fifth prompt option in the empty state of the chat history when viewing a Confluence page'
    },
    confluencePageViewPrompt6: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-6',
        defaultMessage: 'What should I work on next?',
        description: 'The sixth prompt option in the empty state of the chat history when viewing a Confluence page'
    },
    // CONFLUENCE_PAGE_EDIT & CONFLUENCE_BLOG_EDIT
    confluencePageEditPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-1',
        defaultMessage: 'Can you improve the writing on this page?',
        description: 'The first prompt option in the empty state of the chat history when editing a Confluence page'
    },
    confluencePageEditPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-2',
        defaultMessage: 'Write an executive summary for this page.',
        description: 'The second prompt option in the empty state of the chat history when editing a Confluence page'
    },
    confluencePageEditPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-3',
        defaultMessage: 'Give me links to some other relevant pages.',
        description: 'The third prompt option in the empty state of the chat history when editing a Confluence page'
    },
    confluencePageEditPrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-4',
        defaultMessage: 'What should I work on next?',
        description: 'The fourth prompt option in the empty state of the chat history when editing a Confluence page'
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-1',
        defaultMessage: "Summarize what I'm looking at.",
        description: 'The first prompt option in the empty state of the chat history when viewing a Confluence whiteboard'
    },
    confluenceWhiteboardPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-2',
        defaultMessage: 'Highlight any patterns or trends visible here.',
        description: 'The second prompt displayed in the empty state of the chat history when viewing a confluence whiteboard.'
    },
    confluenceWhiteboardPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-3',
        defaultMessage: 'Identify any key action items or decisions captured in this whiteboard.',
        description: 'The third prompt displayed in the empty state of the chat history when viewing a confluence whiteboard.'
    },
    confluenceWhiteboardPrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-4',
        defaultMessage: 'What should I work on next?',
        description: 'The fourth prompt option in the empty state of the chat history when viewing a Confluence whiteboard'
    },
    // JIRA_HOME
    jiraHomePrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-1',
        defaultMessage: 'Find Jira issues that have been updated this week.',
        description: 'The first prompt option in the empty state of the chat history when viewing Jira Home'
    },
    jiraHomePrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-2',
        defaultMessage: 'What Jira issues are the highest priority?',
        description: 'The second prompt option in the empty state of the chat history when viewing Jira Home'
    },
    jiraHomePrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-3',
        defaultMessage: 'What Jira issues have comments mentioning me?',
        description: 'The third prompt option in the empty state of the chat history when viewing Jira Home'
    },
    jiraHomePrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-4',
        defaultMessage: 'Summarize the comments on `Jira issue`.',
        description: 'The fourth prompt option in the empty state of the chat history when viewing Jira Home'
    },
    jiraHomePrompt5: {
        id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-5',
        defaultMessage: 'Create a description template for user stories.',
        description: 'The fifth prompt option in the empty state of the chat history when viewing Jira Home'
    },
    jiraHomePrompt6: {
        id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-6',
        defaultMessage: 'What should I work on next?',
        description: 'The sixth prompt option in the empty state of the chat history when viewing Jira Home'
    },
    // JIRA_ISSUE_VIEW
    jiraIssueViewPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-1',
        defaultMessage: 'Are there any similar Jira issues to this one?',
        description: 'The first prompt option in the empty state of the chat history when viewing a Jira issue'
    },
    jiraIssueViewPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-2',
        defaultMessage: 'How could I improve the description?',
        description: 'The second prompt option in the empty state of the chat history when viewing a Jira issue'
    },
    jiraIssueViewPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-3',
        defaultMessage: 'What labels could I add to this issue?',
        description: 'The third prompt option in the empty state of the chat history when viewing a Jira issue'
    },
    jiraIssueViewPrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-4',
        defaultMessage: 'What should I work on next?',
        description: 'The fourth prompt option in the empty state of the chat history when viewing a Jira issue'
    },
    // JIRA_PROJECT
    jiraProjectPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-1',
        defaultMessage: "What work hasn\u2019t been picked up in a while?",
        description: 'The first prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-2',
        defaultMessage: 'Are any Jira issues blocked?',
        description: 'The second prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-3',
        defaultMessage: "List Jira issues that are currently \u201CIn Progress\u201D and group them by assignee.",
        description: 'The third prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-4',
        defaultMessage: 'How many issues are assigned to `person`?',
        description: 'The fourth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt5: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-5',
        defaultMessage: 'Has `person` commented on any Jira issues in this sprint?',
        description: 'The fifth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt6: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-6',
        defaultMessage: 'What Jira issues are unassigned?',
        description: 'The sixth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt7: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-7',
        defaultMessage: 'What Jira issues have been open the longest?',
        description: 'The seventh prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt8: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-8',
        defaultMessage: 'Who has the most tasks?',
        description: 'The eighth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt9: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-9',
        defaultMessage: 'Find and group similar Jira issues.',
        description: 'The ninth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt10: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-10',
        defaultMessage: 'Are there any Jira issues not connected to a parent issue?',
        description: 'The tenth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt11: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-11',
        defaultMessage: 'Take `Jira issue` description and align it to best-practice.',
        description: 'The eleventh prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt12: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-12',
        defaultMessage: 'Summarize the comments on `Jira issue`.',
        description: 'The twelfth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt13: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-13',
        defaultMessage: 'Create a description template for user stories.',
        description: 'The thirteenth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    jiraProjectPrompt14: {
        id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-14',
        defaultMessage: 'What should I work on next?',
        description: 'The fourteenth prompt option in the empty state of the chat history when viewing a Jira project'
    },
    // JIRA_BOARD
    jiraBoardPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-1',
        defaultMessage: 'Update status for work items in this board.',
        description: 'The first prompt option in the empty state of the chat history when viewing a Jira board'
    },
    jiraBoardPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-2',
        defaultMessage: 'Update assignee for work items in this board.',
        description: 'The second prompt option in the empty state of the chat history when viewing a Jira board'
    },
    jiraBoardPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-3',
        defaultMessage: 'Update work items in this board.',
        description: 'The third prompt option in the empty state of the chat history when viewing a Jira board'
    },
    jiraBoardPrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-4',
        defaultMessage: 'What are the risks for this active sprint?',
        description: 'The fourth prompt option in the empty state of the chat history when viewing a Jira board'
    },
    // JSM_INCIDENT_VIEW
    jsmIncidentViewPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-1',
        defaultMessage: 'Find people who can help resolve this incident',
        description: 'The first prompt option in the empty state of the chat history when viewing a JSM incident'
    },
    jsmIncidentViewPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-2',
        defaultMessage: 'Are there any ongoing incidents?',
        description: 'The second prompt option in the empty state of the chat history when viewing a JSM incident'
    },
    jsmIncidentViewPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-3',
        defaultMessage: 'Create a post-incident review (PIR)',
        description: 'The third prompt option in the empty state of the chat history when viewing a JSM incident'
    },
    // JSM_INCIDENT_LIST_VIEW
    jsmIncidentListViewPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-1',
        defaultMessage: 'Are there any ongoing incidents?',
        description: 'The first prompt option in the empty state of the chat history when viewing JSM incident list'
    },
    jsmIncidentListViewPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-2',
        defaultMessage: 'Get me the open high priority incidents',
        description: 'The second prompt option in the empty state of the chat history when viewing JSM incident list'
    },
    jsmIncidentListViewPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-3',
        defaultMessage: 'Are there any open alerts?',
        description: 'The third prompt option in the empty state of the chat history when viewing JSM incident list'
    },
    // JSM_ALERT_VIEW (Alert details page)
    jsmAlertViewPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-1',
        defaultMessage: 'Find open alerts',
        description: 'The first prompt option in the empty state of the chat history when viewing JSM alert details'
    },
    jsmAlertViewPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-2',
        defaultMessage: 'Investigate this alert',
        description: 'The second prompt option in the empty state of the chat history when viewing JSM alert details'
    },
    jsmAlertViewPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-3',
        defaultMessage: 'Are there any ongoing incidents?',
        description: 'The third prompt option in the empty state of the chat history when viewing JSM alert details'
    },
    // JSM_ALERT_LIST_VIEW (Alert list page)
    jsmAlertListViewPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-1',
        defaultMessage: 'Find open alerts',
        description: 'The first prompt option in the empty state of the chat history when viewing JSM alert list'
    },
    jsmAlertListViewPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-2',
        defaultMessage: 'Find recently closed alerts',
        description: 'The second prompt option in the empty state of the chat history when viewing JSM alert list'
    },
    jsmAlertListViewPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-3',
        defaultMessage: 'Are there any ongoing incidents?',
        description: 'The third prompt option in the empty state of the chat history when viewing JSM alert list'
    },
    // JSM_ALERT_GROUP_DETAIL_VIEW (Alert group details page)
    jsmAlertGroupDetailViewPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-1',
        defaultMessage: 'Find open alerts',
        description: 'The first prompt option in the empty state of the chat history when viewing JSM alert group details'
    },
    jsmAlertGroupDetailViewPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-2',
        defaultMessage: 'Find recently closed alerts',
        description: 'The second prompt option in the empty state of the chat history when viewing JSM alert group details'
    },
    jsmAlertGroupDetailViewPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-3',
        defaultMessage: 'Are there any ongoing incidents?',
        description: 'The third prompt option in the empty state of the chat history when viewing JSM alert group details'
    },
    // ATLAS HOME
    atlasHomePrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-1',
        defaultMessage: 'What Confluence pages have I contributed to recently?',
        description: 'The first prompt option in the empty state of the chat history when viewing Atlas Home'
    },
    atlasHomePrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-2',
        defaultMessage: 'Find all Jira tickets that are assigned to me.',
        description: 'The second prompt option in the empty state of the chat history when viewing Atlas Home'
    },
    atlasHomePrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-3',
        defaultMessage: 'What is our travel policy?',
        description: 'The third prompt option in the empty state of the chat history when viewing Atlas Home'
    },
    atlasHomePrompt4: {
        id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-4',
        defaultMessage: 'Draft a Confluence page for a marketing campaign.',
        description: 'The fourth prompt option in the empty state of the chat history when viewing Atlas Home'
    },
    atlasHomePrompt5: {
        id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-5',
        defaultMessage: 'How can I create a project timeline?',
        description: 'The fifth prompt option in the empty state of the chat history when viewing Atlas Home'
    },
    atlasHomePrompt6: {
        id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-6',
        defaultMessage: 'Write a follow up email to potential clients.',
        description: 'The sixth prompt option in the empty state of the chat history when viewing Atlas Home'
    },
    atlasHomePrompt7: {
        id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-7',
        defaultMessage: 'What should I work on next?',
        description: 'The seventh prompt option in the empty state of the chat history when viewing Atlas Home'
    },
    // FOCUS
    focusPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.focus.starter-1',
        defaultMessage: 'Summarize my focus areas.',
        description: 'The first prompt option in the empty state of the chat history when viewing Focus'
    },
    focusPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.focus.starter-2',
        defaultMessage: 'Identify gaps and highlight risks.',
        description: 'The second prompt option in the empty state of the chat history when viewing Focus'
    },
    // FOCUS_FOCUS_AREA_PAGE
    focusAreaPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.focus-area.starter-1',
        defaultMessage: 'Summarize this focus area.',
        description: 'The first prompt option when viewing a specific focus area page in Focus'
    },
    // FOCUS_FOCUS_AREA_GOAL_VIEW
    focusAreaGoalPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.focus-area-goal.starter-1',
        defaultMessage: 'Summarize the goals linked to this focus area.',
        description: 'The first prompt option when viewing the goal view of a specific focus area in Focus'
    },
    // FOCUS_FOCUS_AREA_WORK_VIEW
    focusAreaWorkPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.focus-area-work.starter-1',
        defaultMessage: 'Summarize the work linked to this focus area.',
        description: 'The first prompt option when viewing the work view of a specific focus area in Focus'
    },
    // FOCUS_FOCUS_AREA_FUNDS_VIEW
    focusAreaFundsPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.focus-area-funds.starter-1',
        defaultMessage: 'Analyze the funds linked to this focus area.',
        description: 'The first prompt option when viewing the funds view of a specific focus area in Focus'
    },
    // FOCUS_FOR_YOU
    focusForYouPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.focus-for-you.starter-1',
        defaultMessage: 'Summarize my focus areas.',
        description: 'The first prompt option when viewing For You page in Focus'
    },
    // SAC
    sacPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.sac.starter-1',
        defaultMessage: 'How do I manage settings?',
        description: 'The first prompt option in the empty state of the chat history when viewing SAC'
    },
    sacPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.sac.starter-2',
        defaultMessage: 'How do I find information?',
        description: 'The second prompt option in the empty state of the chat history when viewing SAC'
    },
    sacPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.sac.starter-3',
        defaultMessage: 'How do I create an automation rule?',
        description: 'The third prompt option in the empty state of the chat history when viewing SAC'
    },
    // TRELLO_BOARD (board/universal rovo button)
    trelloBoardPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-1',
        defaultMessage: 'Summarize this board.',
        description: 'The first prompt option in the empty state of the chat history when viewing a Trello board'
    },
    trelloBoardPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-2',
        defaultMessage: 'Suggest ways to organize this board.',
        description: 'The second prompt option in the empty state of the chat history when viewing a Trello board'
    },
    trelloBoardPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-3',
        defaultMessage: 'What should my top 3 priorities be today?',
        description: 'The third prompt option in the empty state of the chat history when viewing a Trello board'
    },
    // TRELLO_CARD (cardback)
    trelloCardPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-1',
        defaultMessage: 'Summarize this card.',
        description: 'The first prompt option in the empty state of the chat history when viewing a Trello card'
    },
    trelloCardPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-2',
        defaultMessage: 'Find work related to this card.',
        description: 'The second prompt option in the empty state of the chat history when viewing a Trello card'
    },
    trelloCardPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-3',
        defaultMessage: "Suggest improvements for this card's description.",
        description: 'The third prompt option in the empty state of the chat history when viewing a Trello card'
    },
    // UNKNOWN
    unknownPrompt1: {
        id: 'rovo-conversation-actions.conversation-starters.unknown.starter-1',
        defaultMessage: 'Are any of my work items overdue?',
        description: 'The first suggestion displayed in the empty state of the chat history'
    },
    unknownPrompt2: {
        id: 'rovo-conversation-actions.conversation-starters.unknown.starter-2',
        defaultMessage: 'What should I work on next?',
        description: 'The second suggestion displayed in the empty state of the chat history'
    },
    unknownPrompt3: {
        id: 'rovo-conversation-actions.conversation-starters.unknown.starter-3',
        defaultMessage: 'Write an update about my week.',
        description: 'The third suggestion displayed in the empty state of the chat history'
    }
});
var $f843e87e3d591eee$export$2e2bcd8739ae039 = $f843e87e3d591eee$var$_default_1;

});


parcelRegister("7Isdl", function(module, exports) {
$parcel$export(module.exports, "isBrowser", () => $8960dcf3f4206273$export$4e09c449d6c407f7);
/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */ const $8960dcf3f4206273$export$4e09c449d6c407f7 = ()=>{
    try {
        return typeof window !== 'undefined';
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};

});

parcelRegister("7pYVa", function(module, exports) {
$parcel$export(module.exports, "passesOnboardingHoldout", () => $9f7f595e9c01ec2f$export$89871c89a47e5ed3);

var $4fPPi = parcelRequire("4fPPi");

var $fhh5H = parcelRequire("fhh5H");

var $93Jjp = parcelRequire("93Jjp");
function $9f7f595e9c01ec2f$export$89871c89a47e5ed3() {
    try {
        const raw = (0, $4fPPi.AtlBrowserStorageLocal).getItem((0, $fhh5H.LS_ONBOARDING_HOLDOUT_KEY));
        if (raw === null) return true;
        const state = (0, $93Jjp.parseState)(raw);
        if (state === null) return false;
        if (state.onboardingCompleted || state.exposureCount >= (0, $fhh5H.MAX_ONBOARDING_EXPOSURES)) return false;
        return Date.now() - state.lastSeenAt >= (0, $fhh5H.HOLDOUT_MS);
    } catch  {
        return false;
    }
}

});
parcelRegister("fhh5H", function(module, exports) {
$parcel$export(module.exports, "LS_ONBOARDING_HOLDOUT_KEY", () => $ec89911afb1b7493$export$124df12a015901ba);
$parcel$export(module.exports, "MAX_ONBOARDING_EXPOSURES", () => $ec89911afb1b7493$export$a478a0028a108fe6);
$parcel$export(module.exports, "HOLDOUT_MS", () => $ec89911afb1b7493$export$af9030d6dd88ec25);
/**
 * Onboarding holdout feature: gate onboarding behind a 24h cooldown, a max of 3 exposures,
 * and don't-show-again-after-completion. This module defines the holdout tunables
 * (cooldown, exposure cap, storage key) and the persisted state shape. State is read/written
 * via the get/persist helpers using AtlBrowserStorageLocal; if productionized, consider a more
 * permanent source (e.g. backend or user preferences).
 */ 
var $aTYqF = parcelRequire("aTYqF");
const $ec89911afb1b7493$export$124df12a015901ba = 'rovoOnboardingHoldout';
const $ec89911afb1b7493$export$a478a0028a108fe6 = 3;
const $ec89911afb1b7493$export$af9030d6dd88ec25 = 24 * (0, $aTYqF.SECONDS_IN_HR) * (0, $aTYqF.MS_IN_SECOND);

});
parcelRegister("aTYqF", function(module, exports) {
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_ENTRYPOINT_ID", () => $aa9ed775c5c0de06$export$4b225aae27e9366b);
$parcel$export(module.exports, "MS_IN_SECOND", () => $aa9ed775c5c0de06$export$c87b1e2e3344192f);
$parcel$export(module.exports, "SECONDS_IN_HR", () => $aa9ed775c5c0de06$export$cd6b7e688e614eeb);
$parcel$export(module.exports, "LS_CHAT_LOAD_PREFERENCE_KEY", () => $aa9ed775c5c0de06$export$a0d33d6e93abfb90);
$parcel$export(module.exports, "AI_MATE_EXPERIENCE_ID", () => $aa9ed775c5c0de06$export$e8114853eca81277);
$parcel$export(module.exports, "SHORTER_TIMEOUT_BEFORE_NEW_CHAT", () => $aa9ed775c5c0de06$export$501af059da333e01);
$parcel$export(module.exports, "LS_LAST_MESSAGE_SENT_AT", () => $aa9ed775c5c0de06$export$f8d883b8f9181b19);
$parcel$export(module.exports, "MINI_MODAL_GREETING_HEIGHT", () => $aa9ed775c5c0de06$export$85d90d98449e85fd);
$parcel$export(module.exports, "MINI_MODAL_EXPANDED_HEIGHT", () => $aa9ed775c5c0de06$export$cad0f6e78cd99203);
$parcel$export(module.exports, "SPLIT_LAYOUT_INITIAL_WIDTH", () => $aa9ed775c5c0de06$export$73f6568f4f3fdeda);
$parcel$export(module.exports, "SPLIT_LAYOUT_MIN_WIDTH", () => $aa9ed775c5c0de06$export$2c094f7f70c376e3);
$parcel$export(module.exports, "SPLIT_LAYOUT_ADJACENT_MIN_WIDTH", () => $aa9ed775c5c0de06$export$2e9abc2f500a1704);
const $aa9ed775c5c0de06$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $aa9ed775c5c0de06$export$c87b1e2e3344192f = 1000;
const $aa9ed775c5c0de06$export$c4e7b6208a0b853e = 60;
const $aa9ed775c5c0de06$export$cd6b7e688e614eeb = $aa9ed775c5c0de06$export$c4e7b6208a0b853e * 60;
const $aa9ed775c5c0de06$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $aa9ed775c5c0de06$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $aa9ed775c5c0de06$export$e8114853eca81277 = 'ai-mate';
const $aa9ed775c5c0de06$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $aa9ed775c5c0de06$export$1ea9613e3e37d315 = 30 * $aa9ed775c5c0de06$export$c4e7b6208a0b853e * $aa9ed775c5c0de06$export$c87b1e2e3344192f;
const $aa9ed775c5c0de06$export$501af059da333e01 = 5 * $aa9ed775c5c0de06$export$c4e7b6208a0b853e * $aa9ed775c5c0de06$export$c87b1e2e3344192f;
const $aa9ed775c5c0de06$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $aa9ed775c5c0de06$export$85d90d98449e85fd = 140;
const $aa9ed775c5c0de06$export$cad0f6e78cd99203 = '600px';
const $aa9ed775c5c0de06$export$73f6568f4f3fdeda = 380;
const $aa9ed775c5c0de06$export$2c094f7f70c376e3 = 480;
const $aa9ed775c5c0de06$export$2e9abc2f500a1704 = 280;

});


parcelRegister("93Jjp", function(module, exports) {
$parcel$export(module.exports, "parseState", () => $999263ea28a8a92c$export$adb402f717f36848);

var $fhh5H = parcelRequire("fhh5H");
function $999263ea28a8a92c$export$adb402f717f36848(raw) {
    if (raw === null) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed.lastSeenAt === 'number' && typeof parsed.exposureCount === 'number') return {
        lastSeenAt: parsed.lastSeenAt,
        exposureCount: Math.min(Math.max(0, Math.floor(parsed.exposureCount)), (0, $fhh5H.MAX_ONBOARDING_EXPOSURES)),
        onboardingCompleted: parsed.onboardingCompleted === true
    };
    return null;
}

});


parcelRegister("1Q5DT", function(module, exports) {
$parcel$export(module.exports, "recordOnboardingExposureForHoldout", () => $a3def7b300cfbb57$export$47e4355399c5e75);

var $fhh5H = parcelRequire("fhh5H");

var $hfjqy = parcelRequire("hfjqy");

var $bG55z = parcelRequire("bG55z");

var $9C5V1 = parcelRequire("9C5V1");
function $a3def7b300cfbb57$export$47e4355399c5e75() {
    const state = (0, $bG55z.getOnboardingHoldoutState)() ?? (0, $hfjqy.DEFAULT_HOLDOUT_STATE);
    if (state.onboardingCompleted || state.exposureCount >= (0, $fhh5H.MAX_ONBOARDING_EXPOSURES)) return;
    (0, $9C5V1.persistState)({
        ...state,
        lastSeenAt: Date.now(),
        exposureCount: state.exposureCount + 1
    });
}

});
parcelRegister("hfjqy", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_HOLDOUT_STATE", () => $72c0aa39ef9fae24$export$cb9fc4c34a0afb34);
const $72c0aa39ef9fae24$export$cb9fc4c34a0afb34 = {
    lastSeenAt: 0,
    exposureCount: 0,
    onboardingCompleted: false
};

});

parcelRegister("bG55z", function(module, exports) {
$parcel$export(module.exports, "getOnboardingHoldoutState", () => $5bfaecb36cd86d43$export$70098a1ba52d021f);

var $4fPPi = parcelRequire("4fPPi");

var $fhh5H = parcelRequire("fhh5H");

var $93Jjp = parcelRequire("93Jjp");
function $5bfaecb36cd86d43$export$70098a1ba52d021f() {
    try {
        return (0, $93Jjp.parseState)((0, $4fPPi.AtlBrowserStorageLocal).getItem((0, $fhh5H.LS_ONBOARDING_HOLDOUT_KEY)));
    } catch  {
        return null;
    }
}

});

parcelRegister("9C5V1", function(module, exports) {
$parcel$export(module.exports, "persistState", () => $956bd983d2ae3366$export$9f127573fd964184);

var $4fPPi = parcelRequire("4fPPi");

var $fhh5H = parcelRequire("fhh5H");
function $956bd983d2ae3366$export$9f127573fd964184(state) {
    try {
        (0, $4fPPi.AtlBrowserStorageLocal).setItem((0, $fhh5H.LS_ONBOARDING_HOLDOUT_KEY), JSON.stringify(state));
    } catch  {
    // AtlBrowserStorageLocal may be full or unavailable (e.g. private browsing in Safari)
    }
}

});



parcelRegister("fryZM", function(module, exports) {
$parcel$export(module.exports, "AISmartButtonProvider", () => $6af21f3e2d8638dd$export$f3b20af08af21b9b);
$parcel$export(module.exports, "useAISmartButtonContext", () => $6af21f3e2d8638dd$export$9b0f174637261634);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $6af21f3e2d8638dd$var$AISmartButtonContext = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $6af21f3e2d8638dd$export$f3b20af08af21b9b = ({ children: children, ...props })=>{
    // We have to use Object.values to compare prop values instead of the props object reference,
    // which changes on every render due to the rest operator. Otherwise, the useMemo would be ineffective
    // since it compares object references, not their contents.
    const contextValue = (0, $euxye.useMemo)(()=>props, // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(props));
    return /*#__PURE__*/ (0, $e79Pd.jsx)($6af21f3e2d8638dd$var$AISmartButtonContext.Provider, {
        value: contextValue,
        children: children
    });
};
$6af21f3e2d8638dd$export$f3b20af08af21b9b.displayName = "AISmartButtonProvider";
const $6af21f3e2d8638dd$export$9b0f174637261634 = ()=>{
    const context = (0, $euxye.useContext)($6af21f3e2d8638dd$var$AISmartButtonContext);
    if (!context) throw new Error('useAISmartButtonContext must be used within an AISmartButtonProvider');
    return context;
};

});

parcelRegister("3XXVo", function(module, exports) {
$parcel$export(module.exports, "useDebugNudgeTriggers", () => $c10662824fa39487$export$a8ab20a5170c41b3);

var $euxye = parcelRequire("euxye");

var $bd7Bg = parcelRequire("bd7Bg");

var $4YuQ5 = parcelRequire("4YuQ5");
const $c10662824fa39487$export$a8ab20a5170c41b3 = ()=>{
    (0, $euxye.useEffect)(()=>{
        if (!(0, $bd7Bg.isBrowser)()) return;
        if (!window?.AIX_DEBUG_NUDGE_TRIGGERS) window.AIX_DEBUG_NUDGE_TRIGGERS = new (0, $4YuQ5.DebugTriggers)();
        return ()=>{
            if (window.AIX_DEBUG_NUDGE_TRIGGERS) delete window.AIX_DEBUG_NUDGE_TRIGGERS;
        };
    }, []);
};

});
parcelRegister("bd7Bg", function(module, exports) {
$parcel$export(module.exports, "isBrowser", () => $834337ad81438b64$export$4e09c449d6c407f7);
/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */ const $834337ad81438b64$export$4e09c449d6c407f7 = ()=>{
    try {
        return typeof window !== 'undefined';
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};

});

parcelRegister("4YuQ5", function(module, exports) {
$parcel$export(module.exports, "DebugTriggers", () => $721de0febfb6d191$export$f4380d3820d95f34);
class $721de0febfb6d191$export$f4380d3820d95f34 {
    get hasTriggers() {
        return Boolean(this.triggerQueue.length);
    }
    addTrigger(featureId, featureName, featureDescription) {
        this.triggerQueue.push({
            nudge_id: crypto.randomUUID(),
            feature_details: {
                feature_id: featureId,
                feature_name: featureName || 'Debug Nudge',
                feature_description: featureDescription || 'A nudge added for debugging'
            },
            cta: {
                cta_action: 'ACTION'
            }
        });
    }
    addConvoStarter(convoStarterLabel) {
        this.triggerQueue.push({
            cta: {
                cta_action: 'CHAT',
                cta_label: convoStarterLabel || 'Debug Convo Starter'
            },
            nudge_id: crypto.randomUUID(),
            feature_details: {
                feature_id: 'convo-starter',
                feature_name: 'Debug Convo Starter',
                feature_description: 'A conversation starter for debugging'
            }
        });
    }
    clear() {
        this.triggerQueue = [];
    }
    useNextTrigger() {
        return this.triggerQueue.shift();
    }
    constructor(){
        this.triggerQueue = [];
    }
}

});


parcelRegister("6PntU", function(module, exports) {
$parcel$export(module.exports, "markUnreadCacheStale", () => $b8a73e3eb53328e9$export$5ea316be7514c402);
$parcel$export(module.exports, "useUnreadConversationStatus", () => $b8a73e3eb53328e9$export$e34a0a17cdc941c7);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $PkUAZ = parcelRequire("PkUAZ");

var $fryZM = parcelRequire("fryZM");

var $bd7Bg = parcelRequire("bd7Bg");

var $gP2Nd = parcelRequire("gP2Nd");
const $b8a73e3eb53328e9$var$LOOK_BACK_PERIOD_MS = 129600000;
const $b8a73e3eb53328e9$var$CACHE_TTL_MS = 300000;
const $b8a73e3eb53328e9$var$CACHE_KEY = 'rovo-button-unread-status-v1';
function $b8a73e3eb53328e9$var$readCache() {
    if (!(0, $bd7Bg.isBrowser)()) return null;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = sessionStorage.getItem($b8a73e3eb53328e9$var$CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        // Entries older than TTL are fully expired — discard them
        if (Date.now() - parsed.cachedAt >= $b8a73e3eb53328e9$var$CACHE_TTL_MS) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            sessionStorage.removeItem($b8a73e3eb53328e9$var$CACHE_KEY);
            return null;
        }
        const { cachedAt: _cachedAt, stale: stale, ...result } = parsed;
        // Migrate cache entries written before unreadCount / inProgressCount were added
        const data = {
            ...result,
            unreadCount: result.unreadCount ?? (result.hasUnread ? 1 : 0),
            inProgressCount: result.inProgressCount ?? 0
        };
        return {
            data: data,
            isStale: stale === true
        };
    } catch  {
        return null;
    }
}
function $b8a73e3eb53328e9$var$writeCache(result) {
    if (!(0, $bd7Bg.isBrowser)()) return;
    try {
        const toStore = {
            ...result,
            cachedAt: Date.now()
        };
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        sessionStorage.setItem($b8a73e3eb53328e9$var$CACHE_KEY, JSON.stringify(toStore));
    } catch  {
    // sessionStorage may be unavailable (private browsing quota, etc.) — fail silently
    }
}
function $b8a73e3eb53328e9$export$5ea316be7514c402() {
    if (!(0, $bd7Bg.isBrowser)()) return;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = sessionStorage.getItem($b8a73e3eb53328e9$var$CACHE_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        sessionStorage.setItem($b8a73e3eb53328e9$var$CACHE_KEY, JSON.stringify({
            ...parsed,
            stale: true
        }));
    } catch  {
    // sessionStorage may be unavailable — fail silently
    }
}
const $b8a73e3eb53328e9$var$NO_UNREAD = {
    hasUnread: false,
    unreadCount: 0,
    inProgressCount: 0,
    mostRecentUnread: null
};
function $b8a73e3eb53328e9$export$e34a0a17cdc941c7({ enabled: enabled, mode: mode }) {
    const [status, setStatus] = (0, $euxye.useState)(()=>enabled ? $b8a73e3eb53328e9$var$readCache()?.data ?? $b8a73e3eb53328e9$var$NO_UNREAD : $b8a73e3eb53328e9$var$NO_UNREAD);
    const { conversationAssistantConfig: conversationAssistantConfig, product: product } = (0, $fryZM.useAISmartButtonContext)();
    const baseUrl = conversationAssistantConfig?.assistanceServiceConfig?.baseUrl;
    const headers = conversationAssistantConfig?.assistanceServiceConfig?.headers;
    const assistanceService = (0, $euxye.useMemo)(()=>new (0, $PkUAZ.AssistanceServiceImpl)({
            product: product,
            experienceId: 'ai-mate',
            baseUrl: baseUrl,
            headers: headers
        }), [
        product,
        baseUrl,
        headers
    ]);
    const fetchAndUpdateRef = (0, $euxye.useRef)(async ()=>{});
    const isFetchingRef = (0, $euxye.useRef)(false);
    const prevModeRef = (0, $euxye.useRef)(mode);
    (0, $euxye.useEffect)(()=>{
        if (!enabled) {
            // Reset the in-flight guard so the next enable can fetch immediately.
            // Without this, a fetch that was in-flight when enabled flipped to false
            // would leave isFetchingRef stuck as true, blocking the next fetch.
            isFetchingRef.current = false;
            setStatus($b8a73e3eb53328e9$var$NO_UNREAD);
            return;
        }
        let cancelled = false;
        const fetchAndUpdate = async ()=>{
            if (isFetchingRef.current) return;
            isFetchingRef.current = true;
            try {
                const cacheResult = $b8a73e3eb53328e9$var$readCache();
                if (cacheResult) {
                    if (!cancelled) setStatus((prev)=>{
                        if (prev.hasUnread === cacheResult.data.hasUnread && prev.unreadCount === cacheResult.data.unreadCount && prev.inProgressCount === cacheResult.data.inProgressCount) return prev;
                        return cacheResult.data;
                    });
                    if (!cacheResult.isStale) return;
                // stale — fall through to background re-fetch
                }
                const { items: channels } = await assistanceService.getConversationChannels();
                if (cancelled) return;
                const inProgressCount = channels.filter((channel)=>channel.last_agent_message_status === 'IN_PROGRESS').length;
                const now = Date.now();
                const recentUnread = channels.filter((channel)=>{
                    // readStatus === false is the explicit unread signal; null means a legacy/old
                    // conversation with no read-tracking — exclude it to avoid false positives.
                    const isUnread = channel.readStatus === false;
                    // Only show indicator for completed agent responses — exclude IN_PROGRESS (streaming),
                    // FAILED, CANCELLED, and legacy channels without this field.
                    const hasSuccessfulAgentMessage = channel.last_agent_message_status === 'SUCCESSFUL';
                    const timestamp = channel.last_message_timestamp;
                    const isRecent = !!timestamp && now - new Date(timestamp).getTime() < $b8a73e3eb53328e9$var$LOOK_BACK_PERIOD_MS;
                    return isUnread && hasSuccessfulAgentMessage && isRecent;
                }).sort((a, b)=>{
                    const aTime = a.last_message_timestamp ? new Date(a.last_message_timestamp).getTime() : 0;
                    const bTime = b.last_message_timestamp ? new Date(b.last_message_timestamp).getTime() : 0;
                    return bTime - aTime;
                });
                const result = recentUnread.length > 0 ? {
                    hasUnread: true,
                    unreadCount: recentUnread.length,
                    inProgressCount: inProgressCount,
                    mostRecentUnread: {
                        id: String(recentUnread[0].id),
                        name: recentUnread[0].name ?? null,
                        completedAt: recentUnread[0].last_message_timestamp ?? null
                    }
                } : {
                    hasUnread: false,
                    unreadCount: 0,
                    inProgressCount: inProgressCount,
                    mostRecentUnread: null
                };
                $b8a73e3eb53328e9$var$writeCache(result);
                setStatus(result);
            } catch  {
            // Fail silently — keep the current displayed status rather than forcing NO_UNREAD.
            // If stale data was being shown, it continues to show — better UX than a false negative.
            } finally{
                isFetchingRef.current = false;
            }
        };
        fetchAndUpdateRef.current = fetchAndUpdate;
        // Defer the initial fetch until after paint/idle (post-vc90 safe)
        const cancelPostPaint = (0, $gP2Nd.schedulePostPaint)(()=>{
            fetchAndUpdate();
        });
        // Refresh on window focus once the cache has expired
        const unbindFocus = (0, $bd7Bg.isBrowser)() ? (0, $glbdM.bindAll)(window, [
            {
                type: 'focus',
                listener: ()=>{
                    fetchAndUpdate();
                }
            }
        ]) : null;
        return ()=>{
            cancelled = true;
            cancelPostPaint();
            unbindFocus?.();
        };
    }, [
        assistanceService,
        enabled
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!enabled) {
            prevModeRef.current = mode;
            return;
        }
        if (mode === undefined && prevModeRef.current !== undefined) {
            // User closed the sidebar — mark cache stale and re-fetch in the background
            $b8a73e3eb53328e9$export$5ea316be7514c402();
            fetchAndUpdateRef.current();
        }
        prevModeRef.current = mode;
    }, [
        mode,
        enabled
    ]);
    return status;
}

});
parcelRegister("gP2Nd", function(module, exports) {
$parcel$export(module.exports, "schedulePostPaint", () => $7b6267894ef2a0ff$export$9c28ad8c8fd2ff2f);
/**
 * Schedules a callback to run after the browser has painted and is idle.
 *
 * Prefers `requestIdleCallback` when available (all modern browsers except Safari < 16.4),
 * which fires during genuine browser idle time — safe for work that must not impact vc90.
 *
 * Falls back to `requestAnimationFrame` which fires after the next paint — still non-blocking
 * and render-safe, just without the "idle" guarantee.
 *
 * Returns a cleanup function that cancels the scheduled callback, suitable for use as a
 * `useEffect` return value to prevent work firing after component unmount.
 *
 * NOTE: `react-ufo` has an internal `scheduleIdleCallback` utility but it is not a public
 * export and is not intended for reuse outside the UFO package. This utility follows the same
 * pattern already used in `platform/packages/navigation/global-side-navigation`.
 */ function $7b6267894ef2a0ff$export$9c28ad8c8fd2ff2f(callback) {
    if (typeof requestIdleCallback !== 'undefined') {
        const id = requestIdleCallback(callback);
        return ()=>cancelIdleCallback(id);
    }
    const id = requestAnimationFrame(callback);
    return ()=>cancelAnimationFrame(id);
}

});


parcelRegister("aB8k7", function(module, exports) {
$parcel$export(module.exports, "useRovoButtonEventsInstrumentation", () => $5732b7c00d41b6e4$export$8a94e432ef80d839);

var $euxye = parcelRequire("euxye");

var $bHcfq = parcelRequire("bHcfq");

var $inMxE = parcelRequire("inMxE");
const $5732b7c00d41b6e4$var$ANALYTICS_CHANNEL = (0, $bHcfq.FabricChannel).aiMate;
const $5732b7c00d41b6e4$export$8a94e432ef80d839 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireEventWithOptionalChannel = (0, $euxye.useCallback)((event, product)=>{
        const analyticsEvent = createAnalyticsEvent(event);
        if (product === 'confluence') {
            analyticsEvent.fire();
            return;
        }
        // it goes thru the aiMate analytics listener to avoid validation per product listener
        // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
        analyticsEvent.fire($5732b7c00d41b6e4$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const createEventPayload = (0, $euxye.useCallback)((payload)=>{
        if (payload.product === 'confluence') // confluence event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
        return {
            type: 'sendUIEvent',
            data: payload
        };
        if (payload.product === 'jira') // jira event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
        // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
        return {
            actionSubject: payload.actionSubject,
            action: payload.action,
            actionSubjectId: payload.actionSubjectId,
            attributes: payload.attributes
        };
        // for any other product type we should use the default event shape
        // also if there is a custom event channel, we also should use the default event shape
        return {
            eventType: 'ui',
            ...payload
        };
    }, []);
    const fireRovoButtonUIEvent = (0, $euxye.useCallback)((eventData)=>{
        // Only fire the event if product is defined
        if (!eventData.product) return;
        const event = createEventPayload(eventData);
        fireEventWithOptionalChannel(event, eventData.product);
    }, [
        fireEventWithOptionalChannel,
        createEventPayload
    ]);
    return {
        fireRovoButtonUIEvent: fireRovoButtonUIEvent
    };
};

});

parcelRegister("ketY1", function(module, exports) {
$parcel$export(module.exports, "AIFullScreenModal", () => $3590f65fe6b580d2$export$6b0f0aea468bfe6e);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

const $3590f65fe6b580d2$var$AsyncFullScreenModal = /*#__PURE__*/ (0, $euxye.lazy)(()=>(parcelRequire("52crA")).then((module)=>({
            default: module.AIFullScreenModal
        })));
const $3590f65fe6b580d2$export$6b0f0aea468bfe6e = ()=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($3590f65fe6b580d2$var$AsyncFullScreenModal, {})
    });
};
$3590f65fe6b580d2$export$6b0f0aea468bfe6e.displayName = "AIFullScreenModal";

});
parcelRegister("52crA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iqj9e")
]).then(()=>parcelRequire('gBAfQ'));

});


parcelRegister("kCheS", function(module, exports) {
$parcel$export(module.exports, "preloadAIMiniModal", () => $dbcb3138b66e1ce7$export$1f1f17d801cbb952);
$parcel$export(module.exports, "AIMiniModal", () => $dbcb3138b66e1ce7$export$f36d8da28b18d2c1);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $lTIAv = parcelRequire("lTIAv");

var $ihEDU = parcelRequire("ihEDU");

var $38OHo = parcelRequire("38OHo");

var $fryZM = parcelRequire("fryZM");

const $dbcb3138b66e1ce7$var$LazyAIMiniModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("78cZw")).then((module)=>({
            default: module.AIMiniModal
        })));

const $dbcb3138b66e1ce7$export$1f1f17d801cbb952 = ()=>{
    (parcelRequire("78cZw")).then((module)=>({
            default: module.AIMiniModal
        }));
};
const $dbcb3138b66e1ce7$export$f36d8da28b18d2c1 = ()=>{
    const context = (0, $fryZM.useAISmartButtonContext)();
    const mousetrapRef = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useRef(null);
    const setContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((node)=>{
        mousetrapRef.current?.reset();
        if (!node) return;
        mousetrapRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($lTIAv)))(node);
    }, []);
    const suppressKeyPress = (event)=>{
        mousetrapRef.current?.bind(event.key.toLocaleLowerCase(), (e)=>e.stopPropagation());
    };
    const miniModal = (0, $euxye.useMemo)(()=>{
        // 48px = nav header height, 8px = object sidebar bottom padding, 16px = AI smart button bottom margin, 8px = extra margin so it doesn't align with nav header
        const defaultTopOffset = 80;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
            fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $38OHo.MiniModalLoadingFallbackComponent), {
                topOffset: context.topOffset || defaultTopOffset,
                isNav4Enabled: context.isNav4Enabled
            }),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($dbcb3138b66e1ce7$var$LazyAIMiniModal, {})
        });
    }, [
        context
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        ref: setContainerRef,
        onKeyDown: suppressKeyPress,
        testId: "ai-smart-button-mini-modal-wrapper",
        children: context.overrideMiniModalWrapper ? context.overrideMiniModalWrapper(miniModal) : miniModal
    });
};
$dbcb3138b66e1ce7$export$f36d8da28b18d2c1.displayName = "AIMiniModal";

});
parcelRegister("lTIAv", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.1
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("38OHo", function(module, exports) {
$parcel$export(module.exports, "MiniModalLoadingFallbackComponent", () => $ae4ea4dfda04708e$export$a33efecb32878e39);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $eTW5y = parcelRequire("eTW5y");

var $iAkPV = parcelRequire("iAkPV");
const $ae4ea4dfda04708e$var$styles = {
    miniModalMainContainer: "_2rko12b0 _1bsb1kdj _bfhkhp5a _16qs130s _1e0c1txw _4cvr1h6o _1bah1h6o",
    rovoIcon: "_1bsbckbl _4t3ickbl"
};
const $ae4ea4dfda04708e$export$a33efecb32878e39 = ({ topOffset: topOffset, isNav4Enabled: isNav4Enabled })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iAkPV.MainWrapper), {
        mode: "mini-modal",
        isNav4Enabled: isNav4Enabled,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
            testId: "conversation-assistant-mini-modal-main-container",
            xcss: $ae4ea4dfda04708e$var$styles.miniModalMainContainer,
            style: {
                height: `min(320px, calc(100vh - ${topOffset}px))`
            },
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $ae4ea4dfda04708e$var$styles.rovoIcon,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eTW5y.LazyAnimatedRovoIcon), {
                    alt: "",
                    testId: "rovo-loading-animation"
                })
            })
        })
    });
};
$ae4ea4dfda04708e$export$a33efecb32878e39.displayName = "MiniModalLoadingFallbackComponent";

});
parcelRegister("eTW5y", function(module, exports) {
$parcel$export(module.exports, "LazyAnimatedRovoIcon", () => $b2ca66a027387381$export$7ea4e54699cd5224);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $8muUC = parcelRequire("8muUC");

const $b2ca66a027387381$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("h66gX")));
const $b2ca66a027387381$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8muUC.default), {
        interactionName: "rovo-conversation-assistant-animated-icon",
        fallback: null,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($b2ca66a027387381$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});

});
parcelRegister("8muUC", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dc163ae69469b59$export$2e2bcd8739ae039);

var $69u9Y = parcelRequire("69u9Y");
var $6dc163ae69469b59$export$2e2bcd8739ae039 = (0, $69u9Y.default);

});
parcelRegister("69u9Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $2789775a71270fea$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2D2gW = parcelRequire("2D2gW");
const $2789775a71270fea$var$Suspense = ({ children: children, fallback: fallback, interactionName: interactionName })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
        fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2D2gW.default), {
            name: interactionName,
            children: fallback
        }),
        children: children
    });
};
$2789775a71270fea$var$Suspense.displayName = "Suspense";
var $2789775a71270fea$export$2e2bcd8739ae039 = $2789775a71270fea$var$Suspense;

});


parcelRegister("h66gX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i52Bs").then(()=>parcelRequire('tpYIu'));

});


parcelRegister("iAkPV", function(module, exports) {
$parcel$export(module.exports, "MainWrapper", () => $e877e3005916782a$export$6661021c36f0a701);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");

var $5PG2M = parcelRequire("5PG2M");

var $j0CBQ = parcelRequire("j0CBQ");

var $4n9ba = parcelRequire("4n9ba");

var $6ecZV = parcelRequire("6ecZV");

var $96VnL = parcelRequire("96VnL");

var $bmUIE = parcelRequire("bmUIE");
const $e877e3005916782a$var$styles = {
    wrapper: "_vchhusvi _1bsb1ina _19pkpxbi _4t3inau3 _bfhkvuon _1e0c1txw _2lx21bp4 _ae4v1fhb _4cvr1fhb",
    wrapperNav4: "_vchhusvi _1bsb1osq _4t3i1osq _bfhkvuon _1e0c1txw _2lx21bp4 _ae4v1fhb _4cvr1fhb",
    wrapperHeight: "_1tke1edt",
    externalEmbed: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq",
    fullscreenDebug: "_1r04ze3t _kqsw1n9t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4t3in7od _1bsbn7od",
    withExternalStagingArea: "_1bsb1osq"
};
const $e877e3005916782a$var$stylesBorder = {
    borderNavV3: "_1h6d1l7x _189ee4h9 _1dqonqa1 _13li1mok _qrwq1mok",
    borderNavV4: "",
    borderFullScreenDebug: "_2rko1mok _1dqonqa1 _1h6d1w55 _189e1mok",
    borderExternalEmbed: "",
    borderStagingArea: "_2rkopb1k _16qst7xp"
};
const $e877e3005916782a$var$miniModalWrapperStyles = null;
// When rendered inside a full-screen MaximisedModal, the modal already provides
// width/height/border-radius/shadow. The wrapper should fill the modal body
// without the sidebar-mode top margin or border-radius.
const $e877e3005916782a$var$fullScreenModalWrapperStyles = null;
const $e877e3005916782a$export$6661021c36f0a701 = ({ testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode })=>{
    const isMiniModal = mode === (0, $6ecZV.ConversationAssistantUIModes).MINI_MODAL;
    const isFullScreenModal = mode === (0, $6ecZV.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $egspI.fg)('agent_session_experience_fg');
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isSplitLayout: isSplitLayout, splitLayoutInitialWidth: splitLayoutInitialWidth, splitLayoutMinWidth: splitLayoutMinWidth, splitLayoutAdjacentMinWidth: splitLayoutAdjacentMinWidth, splitLayoutStorageKey: splitLayoutStorageKey } = (0, $4n9ba.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $j0CBQ.useStagingAreaState)();
    // Flipped by the header toggle (rendered inside `children`) via `SplitViewContext`.
    const [isSplitViewOpen, setSplitViewOpen] = (0, $euxye.useState)(false);
    // Show the right pane for the legacy full-screen split layout, or when the
    // user opened it via the header toggle.
    const isRightPanelVisible = !!fullScreen && !!isSplitLayout || isSplitViewOpen;
    const isSplitLayoutEnabled = isSplitLayout && (0, $egspI.fg)('agent_session_experience_fg');
    const renderInnerChildren = ()=>{
        if (isSplitLayoutEnabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bmUIE.SplitViewContext).Provider, {
            value: {
                isSplitViewOpen: isSplitViewOpen,
                setSplitViewOpen: setSplitViewOpen
            },
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $96VnL.SplitLayout), {
                initialWidth: splitLayoutInitialWidth,
                minWidth: splitLayoutMinWidth,
                adjacentMinWidth: splitLayoutAdjacentMinWidth,
                storageKey: splitLayoutStorageKey,
                isRightPanelVisible: isRightPanelVisible,
                children: children
            })
        });
        return children;
    };
    const shouldShowStagingArea = stagingAreaMode === 'inline';
    // Purely for FE team testing fullscreen where branch deploys are accessible
    // The use of localStorage and a private FF should make this safe, and it's our
    // best bet to improve dev velocity at the moment. Once Atlas has local consumption
    // we can remove this
    const fullscreenDebugEnabled = // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $egspI.fg)('rovo_chat_show_local_frontend_components');
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5PG2M.default), {
        zIndex: 500,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            "data-testid": testId,
            "data-rovo-chat-panel": "true",
            className: (0, $4jQY2.default)([
                shouldUseWrapperNav4Styles ? $e877e3005916782a$var$styles.wrapperNav4 : $e877e3005916782a$var$styles.wrapper,
                isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec1ku8 _6fl4ptdj" : $e877e3005916782a$var$styles.wrapperHeight,
                externalEmbed && $e877e3005916782a$var$styles.externalEmbed,
                $e877e3005916782a$var$styles.fullscreenDebug,
                $e877e3005916782a$var$stylesBorder.borderFullScreenDebug
            ]),
            children: renderInnerChildren()
        })
    });
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return 'borderStagingArea';
        if (externalEmbed) return 'borderExternalEmbed';
        if (fullscreenDebugEnabled) // this is not possible because if condition above, but adding it here for completeness
        return 'borderFullScreenDebug';
        if (shouldUseWrapperNav4Styles) return 'borderNavV4';
        return 'borderNavV3';
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $4jQY2.default)([
            shouldUseWrapperNav4Styles ? $e877e3005916782a$var$styles.wrapperNav4 : $e877e3005916782a$var$styles.wrapper,
            isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec1ku8 _6fl4ptdj" : $e877e3005916782a$var$styles.wrapperHeight,
            externalEmbed && $e877e3005916782a$var$styles.externalEmbed,
            $e877e3005916782a$var$stylesBorder[getBorderStyle()],
            fullScreen && shouldShowStagingArea && $e877e3005916782a$var$styles.withExternalStagingArea,
            isFullScreenModal && "_2rko12b0 _189ee4h9 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq"
        ]),
        children: renderInnerChildren()
    });
};
$e877e3005916782a$export$6661021c36f0a701.displayName = "MainWrapper";

});
parcelRegister("j0CBQ", function(module, exports) {
$parcel$export(module.exports, "useMessageIdSelectedForPreview", () => $6020688130706043$export$a2795b51ce92008f);
$parcel$export(module.exports, "useStagingArea", () => $6020688130706043$export$916334da9df8d04);
$parcel$export(module.exports, "useStagingAreaActions", () => $6020688130706043$export$8f9a13b17bec42d5);
$parcel$export(module.exports, "useStagingAreaState", () => $6020688130706043$export$5a57f796673aabea);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $6020688130706043$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtype: undefined,
    dynamicUiSource: undefined,
    interactionSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $6020688130706043$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    setUserSelectedDynamicUiSubtype: (userSelectedDynamicUiSubtype)=>({ setState: setState })=>{
            setState({
                userSelectedDynamicUiSubtype: userSelectedDynamicUiSubtype
            });
        },
    setInteractionSource: (interactionSource)=>({ setState: setState })=>{
            setState({
                interactionSource: interactionSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                userSelectedDynamicUiSubtype: undefined,
                dynamicUiSource: undefined,
                interactionSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $6020688130706043$var$store = (0, $5QDqc.createStore)({
    initialState: $6020688130706043$var$initialState,
    actions: $6020688130706043$var$actions
});
const $6020688130706043$export$a2795b51ce92008f = (0, $3h1FP.createHook)($6020688130706043$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $6020688130706043$export$916334da9df8d04 = (0, $3h1FP.createHook)($6020688130706043$var$store);
const $6020688130706043$export$8f9a13b17bec42d5 = (0, $3h1FP.createActionsHook)($6020688130706043$var$store);
const $6020688130706043$export$5a57f796673aabea = (0, $3h1FP.createStateHook)($6020688130706043$var$store);

});

parcelRegister("4n9ba", function(module, exports) {
$parcel$export(module.exports, "useUIConfig", () => $0d6f1444e6398975$export$e83755c3ab7a4493);

var $euxye = parcelRequire("euxye");

var $jSuQE = parcelRequire("jSuQE");
const $0d6f1444e6398975$export$e83755c3ab7a4493 = ()=>(0, $euxye.useContext)((0, $jSuQE.uiConfig));

});
parcelRegister("jSuQE", function(module, exports) {
$parcel$export(module.exports, "uiConfig", () => $bdda83f14bb1e94a$export$c85ba824665b708f);

var $euxye = parcelRequire("euxye");

var $Btpys = parcelRequire("Btpys");
const $bdda83f14bb1e94a$export$c85ba824665b708f = (0, $euxye.createContext)((0, $Btpys.initialState));

});
parcelRegister("Btpys", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $c785a8d7cbcc7703$export$d4c72bab9d6cc13a);

var $aTYqF = parcelRequire("aTYqF");
const $c785a8d7cbcc7703$export$d4c72bab9d6cc13a = {
    fullScreen: false,
    externalEmbed: false,
    isSplitLayout: false,
    splitLayoutInitialWidth: (0, $aTYqF.SPLIT_LAYOUT_INITIAL_WIDTH),
    splitLayoutMinWidth: (0, $aTYqF.SPLIT_LAYOUT_MIN_WIDTH),
    splitLayoutAdjacentMinWidth: (0, $aTYqF.SPLIT_LAYOUT_ADJACENT_MIN_WIDTH),
    splitLayoutStorageKey: 'conversation-assistant.split-layout.right-width',
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    enableSkills: true,
    enableAutoSuggest: true,
    enableMiniModalResize: true,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true,
        maxModeButton: true,
        shouldShowConversationActions: true,
        shouldShowContextBanner: true
    }
};

});



parcelRegister("96VnL", function(module, exports) {
$parcel$export(module.exports, "SplitLayout", () => $38b8e0b0259b26ca$export$581077d6f0ab5bc7);
/* SplitLayout.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $glbdM = parcelRequire("glbdM");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $u9iDa = parcelRequire("u9iDa");

var $8L2z6 = parcelRequire("8L2z6");

var $5kyyj = parcelRequire("5kyyj");

var $6mEZn = parcelRequire("6mEZn");

var $dJ3o8 = parcelRequire("dJ3o8");

var $5wVh6 = parcelRequire("5wVh6");
const $38b8e0b0259b26ca$var$messages = (0, $7eNDO.defineMessages)({
    resizeSidePanelAriaLabel: {
        id: 'ai-mate.conversation-assistant.split-layout.resize-side-panel-aria-label',
        defaultMessage: 'Resize side panel',
        description: 'Aria label for the draggable handle that resizes the side panel of the conversation assistant split layout'
    }
});
const $38b8e0b0259b26ca$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _vchhusvi _1wpz1fhb _4t3i1osq _1bsb1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx2vrvc _4cvr1fhb",
    leftPane: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1wpz1fhb _4t3i1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx21bp4 _4cvr1fhb",
    rightPanel: "_16jlidpf _1o9zidpf _i0dl1wug _1reo15vq _18m915vq _1wpz1fhb _4t3i1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx21bp4 _4cvr1fhb _t6vde4h9 _1p3lnqa1 _5wra1l7x",
    resizeHandle: "_19itglyw _v5642hjt _1bsb1y44 _1wpz1fhb _kqswh2mm _80om11mm _bfhk18uv _qc5o2hjt _aetrb3bt _18postnw _19do1ssb _15l2idpf _1x88idpf _z0aiyh40 _1hfk18uv _clh3zr6s _4tpu1856",
    resizeHandleDragging: "_1hfk1856"
};
const $38b8e0b0259b26ca$var$isBrowser = typeof window !== 'undefined';
const $38b8e0b0259b26ca$var$readPersistedWidth = (storageKey)=>{
    if (!storageKey || !$38b8e0b0259b26ca$var$isBrowser) return null;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = window.localStorage.getItem(storageKey);
        if (raw == null) return null;
        const parsed = Number.parseFloat(raw);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    } catch  {
        return null;
    }
};
const $38b8e0b0259b26ca$var$writePersistedWidth = (storageKey, width)=>{
    if (!storageKey || !$38b8e0b0259b26ca$var$isBrowser) return;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.setItem(storageKey, String(Math.round(width)));
    } catch  {
    // Best-effort persistence; ignore quota / disabled-storage errors.
    }
};
const $38b8e0b0259b26ca$export$581077d6f0ab5bc7 = ({ initialWidth: initialWidth = 380, minWidth: minWidth = 480, adjacentMinWidth: adjacentMinWidth = 280, storageKey: storageKey, children: children, isRightPanelVisible: isRightPanelVisible = true })=>{
    const containerRef = (0, $euxye.useRef)(null);
    // Lazy initializer so we only touch `localStorage` once on mount. The
    // persisted value (if any) wins over the explicit `initialWidth` prop.
    const [rightWidth, setRightWidth] = (0, $euxye.useState)(()=>{
        const persisted = $38b8e0b0259b26ca$var$readPersistedWidth(storageKey);
        const seed = persisted ?? initialWidth;
        return Math.max(seed, adjacentMinWidth);
    });
    const [isDragging, setIsDragging] = (0, $euxye.useState)(false);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    // Latest width is mirrored to a ref so the `mouseup` handler can persist
    // without being recreated (and re-binding listeners) on every drag tick.
    const rightWidthRef = (0, $euxye.useRef)(rightWidth);
    (0, $euxye.useEffect)(()=>{
        rightWidthRef.current = rightWidth;
    }, [
        rightWidth
    ]);
    const handleMouseDown = (0, $euxye.useCallback)((e)=>{
        e.preventDefault();
        setIsDragging(true);
    }, []);
    const handleMouseMove = (0, $euxye.useCallback)((e)=>{
        if (!isDragging || !containerRef.current) return;
        const rect = containerRef.current.getBoundingClientRect();
        const proposed = rect.right - e.clientX;
        const maxRight = Math.max(adjacentMinWidth, rect.width - minWidth);
        setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
    }, [
        isDragging,
        minWidth,
        adjacentMinWidth
    ]);
    const handleMouseUp = (0, $euxye.useCallback)(()=>{
        setIsDragging(false);
        // Persist the resting width once per drag (not on every mousemove tick).
        $38b8e0b0259b26ca$var$writePersistedWidth(storageKey, rightWidthRef.current);
    }, [
        storageKey
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isDragging) return;
        const doc = (0, $u9iDa.getDocument)();
        if (!doc) return;
        const unbindMouseMove = (0, $glbdM.bind)(doc, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const unbindMouseUp = (0, $glbdM.bind)(doc, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            unbindMouseMove();
            unbindMouseUp();
        };
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    const rightStyle = {
        width: `${rightWidth}px`,
        pointerEvents: isDragging ? 'none' : undefined
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": "conversation-assistant-split-layout",
        ref: containerRef,
        className: (0, $4jQY2.default)([
            $38b8e0b0259b26ca$var$styles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                "data-testid": "conversation-assistant-split-layout-left",
                className: (0, $4jQY2.default)([
                    $38b8e0b0259b26ca$var$styles.leftPane
                ]),
                children: children
            }),
            isRightPanelVisible && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
                xcss: (0, $9S1b6.cx)($38b8e0b0259b26ca$var$styles.resizeHandle, isDragging && $38b8e0b0259b26ca$var$styles.resizeHandleDragging),
                "data-dragging": isDragging,
                testId: "conversation-assistant-split-layout-resize-handle",
                onMouseDown: handleMouseDown,
                "aria-label": formatMessage($38b8e0b0259b26ca$var$messages.resizeSidePanelAriaLabel)
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
                appear: true,
                children: isRightPanelVisible && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5kyyj.default), {
                    enterFrom: "right",
                    fade: "inout",
                    duration: "medium",
                    children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required to forward the motion animation class from @atlaskit/motion's SlideIn render prop
                            className: (0, $4jQY2.default)([
                                $38b8e0b0259b26ca$var$styles.rightPanel,
                                className
                            ]),
                            ref: ref,
                            "data-testid": "conversation-assistant-split-layout-right",
                            style: rightStyle,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                                fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5wVh6.SessionRightPanelSkeleton), {}),
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dJ3o8.SessionRightPanelLazy), {})
                            })
                        })
                })
            })
        ]
    });
};
$38b8e0b0259b26ca$export$581077d6f0ab5bc7.displayName = "SplitLayout";

});
parcelRegister("dJ3o8", function(module, exports) {
$parcel$export(module.exports, "SessionRightPanelLazy", () => $6786825a59df5cbc$export$a0bce28b49dab85d);

var $euxye = parcelRequire("euxye");

const $6786825a59df5cbc$export$a0bce28b49dab85d = /*#__PURE__*/ (0, $euxye.lazy)(()=>(parcelRequire("38HAF")).then((module)=>({
            default: module.SessionRightPanel
        })));

});
parcelRegister("38HAF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("ay8Nt"),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("6kl9c")
]).then(()=>parcelRequire('88wd4'));

});


parcelRegister("5wVh6", function(module, exports) {
$parcel$export(module.exports, "SessionRightPanelSkeleton", () => $7a8b563c9eacf82e$export$659bc7cd6c22a575);
/* SessionRightPanelSkeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $2iotI = parcelRequire("2iotI");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");

var $3NRLa = parcelRequire("3NRLa");

var $fnU7S = parcelRequire("fnU7S");
const $7a8b563c9eacf82e$var$styles = {
    root: "_4t3i1osq _1bsb1osq _vchhusvi _18m91wug",
    content: "_zulpv47k _2rkopb1k _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _19pkv47k _otyrv47k _18u0v47k _2hwxv47k _ca0qv47k _u5f3utpp _n3tdv47k _19bvutpp",
    section: "_zulputpp _1e0c1txw _2lx21bp4",
    pillsContainer: "_zulp1b66 _1e0c1txw _1n261g80",
    pill: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c116y _4cvr1h6o _ca0q1b66 _n3td1b66 _19bvu2gc _u5f3u2gc _bfhk1w7a",
    artefactRow: "_2rkopb1k _zulputpp _189ee4h9 _1dqonqa1 _1h6d1l7x _bozgutpp _y4tiutpp _1tkevbgk _1e0c1txw _4cvr1h6o"
};
const $7a8b563c9eacf82e$var$PILL_CONTENT_WIDTHS = [
    120,
    88,
    162,
    65,
    128
];
const $7a8b563c9eacf82e$export$659bc7cd6c22a575 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $7a8b563c9eacf82e$var$styles.root,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
            xcss: $7a8b563c9eacf82e$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                    xcss: $7a8b563c9eacf82e$var$styles.section,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                            size: "xsmall",
                            children: formatMessage((0, $fnU7S.default).attachmentsHeading)
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                            xcss: $7a8b563c9eacf82e$var$styles.pillsContainer,
                            children: $7a8b563c9eacf82e$var$PILL_CONTENT_WIDTHS.map((width)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                                    xcss: $7a8b563c9eacf82e$var$styles.pill,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                                        width: width,
                                        height: 14,
                                        isShimmering: true
                                    })
                                }, width))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                    xcss: $7a8b563c9eacf82e$var$styles.section,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                            size: "xsmall",
                            children: formatMessage((0, $fnU7S.default).outputHeading)
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
                            space: "space.050",
                            children: [
                                150,
                                120,
                                160
                            ].map((titleWidth)=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                                    xcss: $7a8b563c9eacf82e$var$styles.artefactRow,
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                                            width: 32,
                                            height: 32,
                                            borderRadius: "var(--ds-radius-small, 4px)",
                                            isShimmering: true
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
                                            space: "space.025",
                                            children: [
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                                                    width: titleWidth,
                                                    height: 14,
                                                    isShimmering: true
                                                }),
                                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                                                    width: 100,
                                                    height: 12,
                                                    isShimmering: true
                                                })
                                            ]
                                        })
                                    ]
                                }, titleWidth))
                        })
                    ]
                })
            ]
        })
    });
};
$7a8b563c9eacf82e$export$659bc7cd6c22a575.displayName = "SessionRightPanelSkeleton";

});
parcelRegister("fnU7S", function(module, exports) {
$parcel$export(module.exports, "default", () => $abb5792326fc36e2$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $abb5792326fc36e2$var$messages = (0, $7eNDO.defineMessages)({
    attachmentsHeading: {
        id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.attachments-heading-non-final',
        defaultMessage: 'Attachments',
        description: 'Heading for the list of sources used to generate the chat result.'
    },
    outputHeading: {
        id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.output-heading-non-final',
        defaultMessage: 'Output',
        description: 'Heading for the list of output artefacts produced by the chat result.'
    }
});
var $abb5792326fc36e2$export$2e2bcd8739ae039 = $abb5792326fc36e2$var$messages;

});



parcelRegister("bmUIE", function(module, exports) {
$parcel$export(module.exports, "SplitViewContext", () => $2320372e28679af1$export$9dcf8f238ea334c6);
$parcel$export(module.exports, "useSplitView", () => $2320372e28679af1$export$b97fe97a2a407fce);
/* eslint-disable @atlaskit/platform/one-value-export-per-file */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");
const $2320372e28679af1$export$9dcf8f238ea334c6 = /*#__PURE__*/ (0, $euxye.createContext)({
    isSplitViewOpen: false,
    setSplitViewOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
});
const $2320372e28679af1$export$b97fe97a2a407fce = ()=>(0, $euxye.useContext)($2320372e28679af1$export$9dcf8f238ea334c6);

});



parcelRegister("78cZw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("bzxP6")
]).then(()=>parcelRequire('gkzaC'));

});


parcelRegister("k6QiC", function(module, exports) {
$parcel$export(module.exports, "AISmartButtonUI", () => $014ea90965a8ee7c$export$21695acdb18697b9);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $u9iDa = parcelRequire("u9iDa");

var $4LDqh = parcelRequire("4LDqh");

var $8L2z6 = parcelRequire("8L2z6");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $6mEZn = parcelRequire("6mEZn");

var $hZDXn = parcelRequire("hZDXn");

var $50DkA = parcelRequire("50DkA");

var $Bq7bE = parcelRequire("Bq7bE");

var $fryZM = parcelRequire("fryZM");

var $21hJM = parcelRequire("21hJM");

var $6PntU = parcelRequire("6PntU");

var $bd7Bg = parcelRequire("bd7Bg");

var $g99K9 = parcelRequire("g99K9");

var $3pbcl = parcelRequire("3pbcl");

var $5SEPK = parcelRequire("5SEPK");

var $fOkTC = parcelRequire("fOkTC");
const $014ea90965a8ee7c$var$i18n = (0, $7eNDO.defineMessages)({
    tooltipLabel: {
        id: 'ai-smart-button.tooltip.label.v2',
        defaultMessage: 'Ask Rovo AI',
        description: 'Label for the AI smart button tooltip'
    },
    tooltipUnreadSuffix: {
        id: 'ai-smart-button.tooltip.unread-suffix.v2',
        defaultMessage: '{count, plural, one {# unread chat} other {# unread chats}}',
        description: 'Suffix appended to the tooltip when there are unread conversations, e.g. "3 unread chats"'
    },
    tooltipInProgress: {
        id: 'ai-smart-button.tooltip.in-progress.v2',
        defaultMessage: '{count, plural, one {# task in progress} other {# tasks in progress}}',
        description: 'Second line of the tooltip shown when there are in-progress tasks, e.g. "1 task in progress"'
    }
});
const $014ea90965a8ee7c$var$styles = {
    buttonWrapper: "_kqswh2mm",
    tooltipContent: "_y3gn1e5h",
    tooltipInProgressLine: "_zg8l1m30",
    pillStyle: "_2rko1tm3 _v564s58n _1e0c116y _4cvr1h6o _1bahh9n0 _kqswh2mm _bfhk1aqn _16qs5pg2 _t9ec1h7a _8hrzf6xe _m6k41e03 _oegyhkll _e7u7hkll _sk46z12g _1y60z12g _1llw1mwg _1q8w1mwg",
    expandPill: "_1reo15vq _18m915vq _v564dsx9 _1e0c11p5 _yv0e63bf _sedtglyw",
    expandPillClip: "_v564s58n _o5721jsr _1ul9idpf _t9ecxwn4 _m6k41e03 _sedtglyw",
    expandPillInteractive: "_19itglyw _11c8wadc _r06hglyw _80omtlke _bfhk18uv _syaz15cr _16l4q80t",
    expandPillInner: "_11c8wadc _1e0c1txw _2lx21bp4 _1bah1h6o _4cvresu3 _o5721q9c _syaz15cr",
    expandedPillContent: "_syaz15cr _1e0c1txw _4cvr1h6o _1bahv2br _bozgutpp"
};

const $014ea90965a8ee7c$export$21695acdb18697b9 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ onClick: onClick, isDisabled: isDisabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, proximityAnimationKey: proximityAnimationKey, onChatHistoryClick: onChatHistoryClick }, ref)=>{
    const { sidebarApi: sidebarApi, analyticsAttributes: analyticsAttributes, product: product, productPage: productPage, getActions: getActions, onAnchorElementReady: onAnchorElementReady } = (0, $fryZM.useAISmartButtonContext)();
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const isUnreadIndicatorEnabled = (0, $4LDqh.default).getExperimentValue('rovo_button_unread_indicator', 'isEnabled', false);
    const isDailyBriefEnabled = (0, $egspI.fg)('rovo_button_daily_brief_nudge');
    const { hasUnread: hasUnread, unreadCount: unreadCount, inProgressCount: inProgressCount } = (0, $6PntU.useUnreadConversationStatus)({
        enabled: isUnreadIndicatorEnabled
    });
    const { mostRecentUnread: mostRecentUnread } = (0, $6PntU.useUnreadConversationStatus)({
        enabled: isDailyBriefEnabled
    });
    (0, $21hJM.useDailyBriefSync)({
        enabled: isDailyBriefEnabled,
        mostRecentUnread: mostRecentUnread
    });
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $Bq7bE.useRovoExperienceAPIStore)();
    const [canShowNudge, setCanShowNudge] = (0, $euxye.useState)(false);
    const [spotlightRendered, setSpotlightRendered] = (0, $euxye.useState)(false);
    const [hasActiveNudge, setHasActiveNudge] = (0, $euxye.useState)(false);
    const nudgeCounterRef = (0, $euxye.useRef)(0);
    const handleActiveNudgeChange = (0, $euxye.useCallback)((active)=>{
        setHasActiveNudge((prev)=>{
            if (active && !prev) nudgeCounterRef.current += 1;
            return active;
        });
    }, []);
    const [isHovering, setIsHovering] = (0, $euxye.useState)(false);
    const [actionShortcuts, setActionShortcuts] = (0, $euxye.useState)([]);
    const placementElementRef = (0, $euxye.useRef)(null);
    const notifiedSpotlightAnchorIdRef = (0, $euxye.useRef)();
    const hoverTimeoutRef = (0, $euxye.useRef)();
    const onboardingSpotlightElementId = (0, $euxye.useMemo)(()=>{
        const isLiveOrEditPage = analyticsAttributes?.pageMode === 'live' || analyticsAttributes?.pageMode === 'edit';
        const isPageOrBlogpost = productPage === 'page' || productPage === 'blogpost';
        if (isPageOrBlogpost && isLiveOrEditPage) return `rovo-button-onboarding-spotlight-live-or-edit`;
        return `rovo-button-onboarding-spotlight`;
    }, [
        productPage,
        analyticsAttributes
    ]);
    (0, $euxye.useEffect)(()=>{
        const placementElement = placementElementRef.current;
        if (!placementElement?.isConnected || placementElement.id !== onboardingSpotlightElementId || notifiedSpotlightAnchorIdRef.current === onboardingSpotlightElementId) return;
        notifiedSpotlightAnchorIdRef.current = onboardingSpotlightElementId;
        onAnchorElementReady?.(onboardingSpotlightElementId);
    }, [
        onAnchorElementReady,
        onboardingSpotlightElementId
    ]);
    // Fetch action shortcuts when experiment is enabled
    const slaOperationsEnabled = (0, $egspI.fg)('jmb-4989_add_sla_operations_in_rovo');
    (0, $euxye.useEffect)(()=>{
        const shouldFetch = getActions && product === 'jira' && slaOperationsEnabled;
        if (shouldFetch) getActions().then((actions)=>{
            // Filter to only get actions that can be used as shortcuts (Base, Chat, or Skill e.g. Jira SLA when feature-flagged)
            const shortcuts = actions.filter((action)=>action.handleType === (0, $50DkA.HandleActionType).Base || action.handleType === (0, $50DkA.HandleActionType).Chat || slaOperationsEnabled && action.handleType === (0, $50DkA.HandleActionType).Skill);
            const slicedShortcuts = shortcuts.slice(0, 3);
            setActionShortcuts(slicedShortcuts);
        }).catch(()=>{
            setActionShortcuts([]);
        });
    }, [
        getActions,
        product,
        slaOperationsEnabled
    ]);
    // Handle "Get Started" button click from spotlight
    const handleGetStartedClick = (0, $euxye.useCallback)(()=>{
        if (sidebarApi) toggleConversationAssistantUIMode({
            targetMode: 'mini-modal',
            sidebarApi: sidebarApi
        });
    }, [
        sidebarApi,
        toggleConversationAssistantUIMode
    ]);
    // Set up event listeners for spotlight communication
    (0, $euxye.useEffect)(()=>{
        if (!(0, $bd7Bg.isBrowser)() || !placementElementRef.current || !(0, $egspI.fg)('cc_ai_growth_welcome_from_rovo_gate')) return;
        const doc = (0, $u9iDa.getDocument)();
        if (!doc) return;
        // Listen for spotlight rendered event
        const handleSpotlightRendered = (event)=>{
            const customEvent = event;
            if (customEvent.detail?.elementId === onboardingSpotlightElementId) setSpotlightRendered(true);
        };
        // Listen for "Get Started" button click event
        const handleGetStartedEvent = (event)=>{
            const customEvent = event;
            if (customEvent.detail?.elementId === onboardingSpotlightElementId) handleGetStartedClick();
        };
        const unbind = (0, $glbdM.bindAll)(doc, [
            {
                type: 'rovo-button-onboarding-spotlight-rendered',
                listener: handleSpotlightRendered
            },
            {
                type: 'rovo-button-onboarding-spotlight-get-started-click',
                listener: handleGetStartedEvent
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        handleGetStartedClick,
        onboardingSpotlightElementId
    ]);
    (0, $euxye.useEffect)(()=>{
        if (spotlightRendered) return;
        if (!(0, $egspI.fg)('cc_ai_growth_welcome_from_rovo_gate') && !canShowNudge) {
            setCanShowNudge(true);
            return;
        }
        // Give spotlight time to render (if it will) since it needs to run decisions logic
        const timeout = setTimeout(()=>{
            if (!spotlightRendered && !canShowNudge) setCanShowNudge(true);
        }, 1000);
        return ()=>clearTimeout(timeout);
    }, [
        spotlightRendered,
        canShowNudge
    ]);
    /* eslint-disable @atlaskit/platform/no-preconditioning -- intentional gate + experiment layering */ const nudgeOrPlacement = (0, $euxye.useMemo)(()=>{
        return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
            children: [
                (0, $egspI.fg)('cc_ai_growth_welcome_from_rovo_gate') && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    id: onboardingSpotlightElementId,
                    ref: placementElementRef
                }),
                canShowNudge && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5SEPK.AIProactiveNudge), {
                    onActiveNudgeChange: handleActiveNudgeChange
                })
            ]
        });
    }, [
        canShowNudge,
        handleActiveNudgeChange,
        onboardingSpotlightElementId
    ]);
    /* eslint-enable @atlaskit/platform/no-preconditioning */ const handleButtonMouseEnter = (0, $euxye.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(true);
        }, 250);
        (parcelRequire("f8Ffp")).then((m)=>m.preloadChatOnIntent()).catch(()=>{});
        onMouseEnter();
    }, [
        onMouseEnter
    ]);
    const handleButtonMouseLeave = (0, $euxye.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(false);
            onMouseLeave();
        }, 1000);
    }, [
        onMouseLeave
    ]);
    const handleActionBoxMouseEnter = (0, $euxye.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        setIsHovering(true);
    }, []);
    const handleActionBoxMouseLeave = (0, $euxye.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(false);
        }, 1000);
    }, []);
    const canShowActionShortcuts = (0, $euxye.useMemo)(()=>{
        const jiraWithShortcuts = slaOperationsEnabled && product === 'jira' && actionShortcuts.length > 0;
        return actionShortcuts.length > 0 && !hasActiveNudge && !spotlightRendered && jiraWithShortcuts;
    }, [
        actionShortcuts.length,
        hasActiveNudge,
        spotlightRendered,
        product,
        slaOperationsEnabled
    ]);
    const actionShortcutsRendering = (0, $euxye.useMemo)(()=>{
        if (!isHovering || !canShowActionShortcuts) return null;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g99K9.AIActionShortcutMenu), {
            actionShortcuts: actionShortcuts,
            onMouseEnter: handleActionBoxMouseEnter,
            onMouseLeave: handleActionBoxMouseLeave
        });
    }, [
        isHovering,
        canShowActionShortcuts,
        actionShortcuts,
        handleActionBoxMouseEnter,
        handleActionBoxMouseLeave
    ]);
    // Shared label node reused by BOTH the popover tooltip (gate OFF) and the
    // inline expand label (gate ON) so the text/logic stays identical.
    const labelContent = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        xcss: $014ea90965a8ee7c$var$styles.tooltipContent,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                children: hasUnread ? `${formatMessage($014ea90965a8ee7c$var$i18n.tooltipUnreadSuffix, {
                    count: unreadCount
                })}` : formatMessage($014ea90965a8ee7c$var$i18n.tooltipLabel)
            }),
            inProgressCount > 0 && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $014ea90965a8ee7c$var$styles.tooltipInProgressLine,
                children: formatMessage($014ea90965a8ee7c$var$i18n.tooltipInProgress, {
                    count: inProgressCount
                })
            })
        ]
    });
    // Gate-ON path: the visible inline label is aria-hidden, so provide an
    // SR-only text node carrying the SAME unread/in-progress information the
    // old tooltip announced.
    const accessibleLabelText = [
        hasUnread ? `${formatMessage($014ea90965a8ee7c$var$i18n.tooltipUnreadSuffix, {
            count: unreadCount
        })}` : formatMessage($014ea90965a8ee7c$var$i18n.tooltipLabel),
        inProgressCount > 0 ? formatMessage($014ea90965a8ee7c$var$i18n.tooltipInProgress, {
            count: inProgressCount
        }) : null
    ].filter(Boolean).join('. ');
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $014ea90965a8ee7c$var$styles.buttonWrapper,
        children: [
            nudgeOrPlacement,
            isUnreadIndicatorEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)($014ea90965a8ee7c$var$RovoButtonExpander, {
                expandedContent: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                    xcss: $014ea90965a8ee7c$var$styles.expandedPillContent,
                    children: hasUnread ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
                        testId: "rovo-button-expanded-click",
                        xcss: $014ea90965a8ee7c$var$styles.expandPillInteractive,
                        "data-rovo-expand-pill": true,
                        "aria-label": accessibleLabelText,
                        onClick: ()=>{
                            onChatHistoryClick?.();
                        },
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                            xcss: $014ea90965a8ee7c$var$styles.expandPillInner,
                            children: labelContent
                        })
                    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                        xcss: $014ea90965a8ee7c$var$styles.expandPillInner,
                        children: labelContent
                    })
                }),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3pbcl.AIButton), {
                    onClick: onClick,
                    isDisabled: isDisabled,
                    hasUnread: hasUnread,
                    onMouseEnter: handleButtonMouseEnter,
                    onMouseLeave: handleButtonMouseLeave,
                    ref: ref,
                    proximityAnimationKey: proximityAnimationKey,
                    isExpandable: true
                })
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                position: "left",
                content: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                    xcss: $014ea90965a8ee7c$var$styles.tooltipContent,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                            children: hasUnread ? `${formatMessage($014ea90965a8ee7c$var$i18n.tooltipLabel)} \u{2022} ${formatMessage($014ea90965a8ee7c$var$i18n.tooltipUnreadSuffix, {
                                count: unreadCount
                            })}` : formatMessage($014ea90965a8ee7c$var$i18n.tooltipLabel)
                        }),
                        inProgressCount > 0 && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                            xcss: $014ea90965a8ee7c$var$styles.tooltipInProgressLine,
                            children: formatMessage($014ea90965a8ee7c$var$i18n.tooltipInProgress, {
                                count: inProgressCount
                            })
                        })
                    ]
                }),
                hideTooltipOnClick: true,
                ignoreTooltipPointerEvents: true,
                canAppear: ()=>{
                    // If control or not on editor surface, always show tooltip when no active nudge
                    // If treatment and on editor surface, show tooltip only when shortcuts cannot be shown
                    return !hasActiveNudge && !canShowActionShortcuts;
                },
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3pbcl.AIButton), {
                    onClick: onClick,
                    isDisabled: isDisabled,
                    hasUnread: hasUnread,
                    onMouseEnter: handleButtonMouseEnter,
                    onMouseLeave: handleButtonMouseLeave,
                    ref: ref,
                    proximityAnimationKey: proximityAnimationKey
                })
            }),
            hasActiveNudge && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
            (0, $4LDqh.default).getExperimentValue('rovo_button_nudge_glow_up_exp', 'isEnabled', false) && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fOkTC.GlowAnimation), {}, nudgeCounterRef.current),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
                appear: true,
                children: actionShortcutsRendering
            })
        ]
    });
});
function $014ea90965a8ee7c$var$RovoButtonExpander({ children: children, expandedContent: expandedContent }) {
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        xcss: $014ea90965a8ee7c$var$styles.pillStyle,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $014ea90965a8ee7c$var$styles.expandPill,
                "data-expandable-pill": true,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                    xcss: $014ea90965a8ee7c$var$styles.expandPillClip,
                    "data-expandable-pill-clip": true,
                    children: expandedContent
                })
            }),
            children
        ]
    });
}
$014ea90965a8ee7c$var$RovoButtonExpander.displayName = "RovoButtonExpander";

});
parcelRegister("21hJM", function(module, exports) {
$parcel$export(module.exports, "useDailyBriefSync", () => $18fb575857d37df6$export$187304f0ff940bd0);

var $euxye = parcelRequire("euxye");

var $jvHCQ = parcelRequire("jvHCQ");
const $18fb575857d37df6$var$DAILY_BRIEF_NAME_PREFIXES = [
    'daily brief:',
    'get-daily-brief',
    '/get-daily-brief'
];
function $18fb575857d37df6$var$toDailyBriefUnread(mostRecentUnread) {
    const lowerName = mostRecentUnread?.name?.toLowerCase() ?? '';
    const isDailyBrief = $18fb575857d37df6$var$DAILY_BRIEF_NAME_PREFIXES.some((prefix)=>lowerName.startsWith(prefix));
    if (!isDailyBrief || !mostRecentUnread) return null;
    return {
        conversationId: mostRecentUnread.id,
        name: mostRecentUnread.name,
        completedAt: mostRecentUnread.completedAt ?? null
    };
}
function $18fb575857d37df6$export$187304f0ff940bd0({ enabled: enabled, mostRecentUnread: mostRecentUnread }) {
    const { setDailyBriefUnread: setDailyBriefUnread } = (0, $jvHCQ.useAISmartButtonActions)();
    (0, $euxye.useEffect)(()=>{
        if (!enabled) return;
        setDailyBriefUnread($18fb575857d37df6$var$toDailyBriefUnread(mostRecentUnread));
    }, [
        mostRecentUnread,
        enabled,
        setDailyBriefUnread
    ]);
}

});

parcelRegister("g99K9", function(module, exports) {
$parcel$export(module.exports, "AIActionShortcutMenu", () => $810ab16acda1d78a$export$fa41c7e6bc1d5bc2);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $eCdE8 = parcelRequire("eCdE8");
var $8L2z6 = parcelRequire("8L2z6");

var $fryZM = parcelRequire("fryZM");

var $aB8k7 = parcelRequire("aB8k7");

var $aZPrE = parcelRequire("aZPrE");
const $810ab16acda1d78a$var$styles = {
    actionsWrapperStyles: "_zulp1b66 _kqswstnw _1xi21osq _2hwxu2gc _94n5ze3t _1e0c1txw _2lx21bp4 _4cvresu3"
};
const $810ab16acda1d78a$export$fa41c7e6bc1d5bc2 = ({ actionShortcuts: actionShortcuts, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const { product: product, analyticsAttributes: analyticsAttributes } = (0, $fryZM.useAISmartButtonContext)();
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $aB8k7.useRovoButtonEventsInstrumentation)();
    const { isExiting: isExiting } = (0, $8L2z6.useExitingPersistence)();
    (0, $euxye.useEffect)(()=>{
        fireRovoButtonUIEvent({
            source: analyticsAttributes?.productPage ?? product,
            action: 'rendered',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoActionShortcutMenu',
            attributes: {
                ...analyticsAttributes,
                version: 'refresh',
                actionIdsRendered: actionShortcuts.map((action)=>action.id)
            },
            product: product
        });
    }, [
        actionShortcuts,
        analyticsAttributes,
        product,
        fireRovoButtonUIEvent
    ]);
    return(// Suspense needed here to avoid rendering empty menu when action shortcuts are loading (since they are lazy loaded)
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
            duration: "large",
            entranceDirection: "right",
            exitDirection: "right",
            children: (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    ref: props.ref,
                    className: (0, $4jQY2.default)([
                        $810ab16acda1d78a$var$styles.actionsWrapperStyles,
                        props.className
                    ]),
                    style: {
                        ...props.style,
                        // Prevent hover events during exit animation to avoid flicker.
                        // ExitingPersistence keeps elements mounted while exiting, so without this,
                        // the exiting menu can re-trigger hover handlers and cause flickering.
                        pointerEvents: isExiting ? 'none' : undefined
                    },
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onFocus: onMouseEnter,
                    onBlur: (e)=>{
                        if (!e.currentTarget.contains(e.relatedTarget)) // Only call onMouseLeave if focus is moving outside the container
                        onMouseLeave();
                    },
                    children: actionShortcuts.map((action)=>{
                        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aZPrE.AIActionShortcut), {
                            action: action
                        }, action.id);
                    })
                })
        })
    }));
};
$810ab16acda1d78a$export$fa41c7e6bc1d5bc2.displayName = "AIActionShortcutMenu";

});
parcelRegister("aZPrE", function(module, exports) {
$parcel$export(module.exports, "AIActionShortcut", () => $c2de07906816fba3$export$2966057c342a8370);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

// Lazy load to avoid loading useRovoActionTrigger when action shortcuts are not needed
const $c2de07906816fba3$var$LazyAIActionShortcut = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("j8QbY")).then((module)=>({
            default: module.AIActionShortcut
        })));
const $c2de07906816fba3$export$2966057c342a8370 = ({ action: action })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($c2de07906816fba3$var$LazyAIActionShortcut, {
        action: action
    });
};
$c2de07906816fba3$export$2966057c342a8370.displayName = "AIActionShortcut";

});
parcelRegister("j8QbY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("ajgyT")
]).then(()=>parcelRequire('a6KaS'));

});



parcelRegister("3pbcl", function(module, exports) {
$parcel$export(module.exports, "AIButton", () => $e52c384200a53655$export$a51986b9c6d9ac89);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $ihEDU = parcelRequire("ihEDU");
var $6mEZn = parcelRequire("6mEZn");

var $4C7HL = parcelRequire("4C7HL");

var $apUrw = parcelRequire("apUrw");

var $jGa7D = parcelRequire("jGa7D");

var $dIDk7 = parcelRequire("dIDk7");

var $6rlTt = parcelRequire("6rlTt");
const $e52c384200a53655$var$atlaskitCssStyles = {
    pressableStyles: "_2rko1tm3 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _4t3ickbl _1bsbckbl _bfhk18uv",
    boxStyles: "_2rko1tm3 _v564s58n _1bsbckbl _4t3ickbl _1o9zidpf _kqswh2mm _bfhk1aqn _16qs5pg2 _m6k41e03 _o7ksf4ca _1llw1mwg _d0altlke _1q8wws4j",
    boxStyleNoHovers: "_2rko1tm3 _v564s58n _1bsbckbl _4t3ickbl _1o9zidpf _kqswh2mm _bfhk1aqn _m6k41e03",
    logoWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o",
    unreadDot: "_2rko1rr0 _19it3rty _kqswstnw _154iud5o _1xi2utpp _1bsbud5o _4t3iud5o _bfhkvbh5 _lcxvglyw"
};
const $e52c384200a53655$export$a51986b9c6d9ac89 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ onClick: onClick, isDisabled: isDisabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasUnread: hasUnread, proximityAnimationKey: proximityAnimationKey, isExpandable: isExpandable }, ref)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        xcss: isExpandable ? $e52c384200a53655$var$atlaskitCssStyles.boxStyleNoHovers : $e52c384200a53655$var$atlaskitCssStyles.boxStyles,
        "data-spotlight-target": "rovo-ai-button",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $6mEZn.default), {
                testId: "platform-ai-button",
                xcss: $e52c384200a53655$var$atlaskitCssStyles.pressableStyles,
                onClick: onClick,
                isDisabled: isDisabled,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onFocus: onMouseEnter,
                onBlur: onMouseLeave,
                ref: ref,
                interactionName: "rovo-button-click",
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                        children: formatMessage((0, $6rlTt.default).rovoButton)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                        xcss: $e52c384200a53655$var$atlaskitCssStyles.logoWrapper,
                        children: proximityAnimationKey !== undefined ? // `key` on the call site is the idiomatic React way to trigger
                        // the SMIL animation replay: changing the key remounts the SVG,
                        // browsers restart SMIL on insertion. RovoAnimatedLogo doesn't
                        // need to know about this mechanism.
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jGa7D.RovoAnimatedLogo), {
                            colorMode: colorMode === 'dark' ? 'dark' : 'light'
                        }, proximityAnimationKey) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dIDk7.RovoColorLogo), {
                            colorMode: colorMode === 'dark' ? 'dark' : 'light'
                        })
                    })
                ]
            }),
            hasUnread && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $e52c384200a53655$var$atlaskitCssStyles.unreadDot,
                testId: "ai-button-unread-dot",
                "aria-hidden": "true"
            })
        ]
    });
});

});
parcelRegister("jGa7D", function(module, exports) {
$parcel$export(module.exports, "RovoAnimatedLogo", () => $19383180aab906e1$export$268fd18f9ecce2c4);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage -- Brand asset colors are intentionally static and not sourced from theme tokens. */ /**
 * Rovo animated logo (TREX-1527).
 *
 * Plays a 2.5s SMIL color-cycle animation on mount and freezes at the canonical
 * "rest" layout (saffron top-right, blue top-left). To re-trigger the animation,
 * give the component a new React `key` at the call site — browsers restart SMIL
 * when the SVG is re-inserted into the DOM:
 *
 *   <RovoAnimatedLogo key={proximityAnimationKey} colorMode={...} />
 *
 * The mouse-proximity handler in `AISmartButton` bumps the key counter each time
 * the cursor enters the proximity radius, which replays the animation cycle.
 *
 * Asset source: `rovo-animation-{light,dark}.svg`, generated from
 * `client/src/components/icons/RovoGlyph.tsx` (variant="full").
 *
 * Note on palette mapping: the LIGHT / DARK constants below are theme-keyed
 * (i.e. LIGHT is used in light mode, DARK is used in dark mode), and the
 * hex values are intentionally kept in sync with the existing static
 * `RovoColorLogo` component. Keeping the two components on the same
 * palette is important — when the proximity animation starts and React
 * swaps `RovoColorLogo` out for `RovoAnimatedLogo`, any mismatch would
 * appear as a one-frame color flash to the user.
 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $dIDk7 = parcelRequire("dIDk7");
/**
 * Returns true if the user has requested reduced motion via their OS / browser
 * settings (CSS `prefers-reduced-motion: reduce`). Subscribes to live changes
 * so a user flipping the setting mid-session sees the update.
 *
 * The proximity-trigger code in `AISmartButton` already guards against
 * `prefers-reduced-motion` before bumping the React key. This hook is a
 * defense-in-depth check so that any other call site that mounts
 * `RovoAnimatedLogo` directly (tests, Storybook, future reuse) also respects
 * the user's preference.
 */ const $19383180aab906e1$var$useReducedMotion = ()=>{
    const [reduced, setReduced] = (0, $euxye.useState)(()=>{
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    });
    (0, $euxye.useEffect)(()=>{
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        const unbind = (0, $glbdM.bind)(mq, {
            type: 'change',
            listener: (e)=>setReduced(e.matches)
        });
        return unbind;
    }, []);
    return reduced;
};
const $19383180aab906e1$var$SVG_SIZE = 24;
// Light-mode palette — kept in sync with RovoColorLogo's `light` entry.
const $19383180aab906e1$var$LIGHT = {
    blue: '#357DE8',
    green: '#82B536',
    purple: '#BF63F3',
    yellow: '#FCA700'
};
// Dark-mode palette — kept in sync with RovoColorLogo's `dark` entry.
const $19383180aab906e1$var$DARK = {
    blue: '#1868DB',
    green: '#6A9A23',
    purple: '#AF59E0',
    yellow: '#FCA700'
};
const $19383180aab906e1$export$268fd18f9ecce2c4 = ({ colorMode: colorMode })=>{
    // Hook calls — must all run in the same order every render (Rules of
    // Hooks). Any conditional bailout below MUST come AFTER all hooks.
    const prefersReducedMotion = $19383180aab906e1$var$useReducedMotion();
    // useId() guarantees per-instance unique SVG <defs> IDs so multiple
    // concurrent renders of this component don't cross-reference each other's
    // masks / gradients (which would silently mis-render).
    const uid = (0, $euxye.useId)();
    // WCAG 2.3.3: never render the SMIL color-cycle animation for users who
    // have requested reduced motion. Fall back to the existing static
    // RovoColorLogo, which matches the look of the animation's frozen "rest"
    // frame. This is intentionally a defense-in-depth check; the
    // proximity-trigger code in AISmartButton already guards too.
    if (prefersReducedMotion) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dIDk7.RovoColorLogo), {
        colorMode: colorMode
    });
    // Theme-keyed palette selection. Stay in sync with RovoColorLogo so the
    // two components show identical colors at rest (no flash on swap).
    const c = colorMode === 'dark' ? $19383180aab906e1$var$DARK : $19383180aab906e1$var$LIGHT;
    const ID_CLIP = `rg-clip-${uid}`;
    const ID_MASK_LEFT = `rg-mask-left-${uid}`;
    const ID_MASK_RIGHT = `rg-mask-right-${uid}`;
    const ID_GRAD_LEFT = `rg-grad-left-${uid}`;
    const ID_GRAD_RIGHT = `rg-grad-right-${uid}`;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: $19383180aab906e1$var$SVG_SIZE,
        height: $19383180aab906e1$var$SVG_SIZE,
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("clipPath", {
                        id: ID_CLIP,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                            width: "16",
                            height: "16"
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsxs)("mask", {
                        id: ID_MASK_LEFT,
                        maskUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                                width: "16",
                                height: "16",
                                fill: "black"
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                                fill: "white",
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M7.53088 10.4476L2.73535 13.2163L1.78016 12.6651C1.21921 12.3417 0.87207 11.7418 0.87207 11.0954V4.91065C0.87207 4.26171 1.21717 3.66436 1.77979 3.34113L5.80879 1.0166C5.79985 1.04169 5.79134 1.06695 5.78324 1.09236C5.70866 1.3238 5.66912 1.56833 5.66912 1.81827V8.00303C5.66912 8.85259 6.12167 9.63627 6.85915 10.0601L7.53088 10.4476Z"
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                                fill: "white",
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M7.53088 10.4475L2.73535 13.2162L7.13997 15.7575C7.69088 16.075 8.36884 16.0807 8.92424 15.7743C8.9343 15.7665 8.945 15.7593 8.95634 15.7528C9.35211 15.5246 9.64153 15.1587 9.77761 14.7361C9.83299 14.5613 9.86226 14.3767 9.86226 14.1877V11.792L7.53088 10.4475Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsxs)("mask", {
                        id: ID_MASK_RIGHT,
                        maskUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                                width: "16",
                                height: "16",
                                fill: "black"
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                                fill: "white",
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M14.318 3.33493L13.2907 2.74219L8.49512 5.5109L9.23931 5.94007C9.97691 6.36392 10.4291 7.14744 10.4291 7.99708V14.1818C10.4291 14.4321 10.3895 14.677 10.3147 14.9087C10.3067 14.9338 10.2983 14.9587 10.2895 14.9835L14.3185 12.659C14.8811 12.3357 15.2262 11.7384 15.2262 11.0895V4.90471C15.2262 4.25833 14.879 3.65833 14.318 3.33493Z"
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                                fill: "white",
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M8.49356 5.51082L6.23438 4.20796V1.81225C6.23438 1.62347 6.26358 1.43906 6.31885 1.26449C6.45471 0.841993 6.74369 0.476235 7.13903 0.247911L7.14023 0.247219C7.15156 0.240681 7.16234 0.233429 7.1724 0.225631C7.72783 -0.0807372 8.40575 -0.0751089 8.95668 0.242516L13.2891 2.74211L8.49356 5.51082Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsxs)("linearGradient", {
                        id: ID_GRAD_LEFT,
                        x1: "0",
                        y1: "-33.19",
                        x2: "27.7",
                        y2: "14.81",
                        gradientUnits: "userSpaceOnUse",
                        spreadMethod: "repeat",
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "0%",
                                stopColor: c.purple
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "24.999%",
                                stopColor: c.purple
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "25%",
                                stopColor: c.yellow
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "49.999%",
                                stopColor: c.yellow
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "50%",
                                stopColor: c.blue
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "74.999%",
                                stopColor: c.blue
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "75%",
                                stopColor: c.green
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "99.999%",
                                stopColor: c.green
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsxs)("linearGradient", {
                        id: ID_GRAD_RIGHT,
                        x1: "0",
                        y1: "-37.57",
                        x2: "27.7",
                        y2: "10.43",
                        gradientUnits: "userSpaceOnUse",
                        spreadMethod: "repeat",
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "0%",
                                stopColor: c.green
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "24.999%",
                                stopColor: c.green
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "25%",
                                stopColor: c.blue
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "49.999%",
                                stopColor: c.blue
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "50%",
                                stopColor: c.yellow
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "74.999%",
                                stopColor: c.yellow
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "75%",
                                stopColor: c.purple
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("stop", {
                                offset: "99.999%",
                                stopColor: c.purple
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("g", {
                clipPath: `url(#${ID_CLIP})`,
                children: /*#__PURE__*/ (0, $e79Pd.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)("g", {
                            mask: `url(#${ID_MASK_LEFT})`,
                            children: /*#__PURE__*/ (0, $e79Pd.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                                        x: "0",
                                        y: "-63.985208333",
                                        width: "16",
                                        height: "191.955625",
                                        fill: `url(#${ID_GRAD_LEFT})`
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsx)("animateTransform", {
                                        attributeName: "transform",
                                        type: "translate",
                                        values: "0 0; 0 -63.985208333",
                                        keyTimes: "0; 1",
                                        keySplines: "0.4 0 0 1",
                                        calcMode: "spline",
                                        dur: "2.5s",
                                        begin: "0s",
                                        repeatCount: "1",
                                        fill: "freeze"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)("g", {
                            mask: `url(#${ID_MASK_RIGHT})`,
                            children: /*#__PURE__*/ (0, $e79Pd.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                                        x: "0",
                                        y: "-63.985208333",
                                        width: "16",
                                        height: "191.955625",
                                        fill: `url(#${ID_GRAD_RIGHT})`
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsx)("animateTransform", {
                                        attributeName: "transform",
                                        type: "translate",
                                        values: "0 0; 0 63.985208333",
                                        keyTimes: "0; 1",
                                        keySplines: "0.4 0 0 1",
                                        calcMode: "spline",
                                        dur: "2.5s",
                                        begin: "0s",
                                        repeatCount: "1",
                                        fill: "freeze"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$19383180aab906e1$export$268fd18f9ecce2c4.displayName = "RovoAnimatedLogo";

});
parcelRegister("dIDk7", function(module, exports) {
$parcel$export(module.exports, "RovoColorLogo", () => $46914c7e61765708$export$a6319ea655f8cd28);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage -- Brand asset colors are intentionally static and not sourced from theme tokens. */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");
const $46914c7e61765708$var$COLORS = {
    light: {
        blue: '#357DE8',
        green: '#82B536',
        purple: '#BF63F3',
        yellow: '#FCA700'
    },
    dark: {
        blue: '#1868DB',
        green: '#6A9A23',
        purple: '#AF59E0',
        yellow: '#FCA700'
    }
};
const $46914c7e61765708$export$a6319ea655f8cd28 = ({ colorMode: colorMode })=>{
    const colors = $46914c7e61765708$var$COLORS[colorMode] ?? $46914c7e61765708$var$COLORS.light;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.2961 15.6713L4.10278 19.8244L2.66999 18.9977C1.82857 18.5126 1.30786 17.6127 1.30786 16.6431V7.36597C1.30786 6.39257 1.82552 5.49654 2.66944 5.01169L8.71294 1.5249C8.69954 1.56253 8.68676 1.60042 8.67462 1.63854C8.56274 1.9857 8.50344 2.35249 8.50344 2.7274V12.0045C8.50344 13.2789 9.18226 14.4544 10.2885 15.0902L11.2961 15.6713Z",
                fill: colors.blue
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.2961 15.6714L4.10278 19.8244L10.7097 23.6363C11.5361 24.1127 12.553 24.1212 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.2871 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7932 21.5652 14.7932 21.2817V17.6881L11.2961 15.6714Z",
                fill: colors.green
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.4773 5.0024L19.9362 4.11328L12.7429 8.26635L13.8592 8.9101C14.9656 9.54588 15.644 10.7212 15.644 11.9956V21.2728C15.644 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4345 22.4753L21.478 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35706C22.8395 6.3875 22.3187 5.4875 21.4773 5.0024Z",
                fill: colors.purple
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.7406 8.26623L9.35181 6.31195V2.71837C9.35181 2.43521 9.39561 2.15859 9.47851 1.89674C9.68231 1.26299 10.1158 0.714353 10.7088 0.371866L10.7106 0.370829C10.7276 0.361021 10.7438 0.350143 10.7588 0.338447C11.592 -0.121106 12.6089 -0.112663 13.4353 0.363774L19.9339 4.11316L12.7406 8.26623Z",
                fill: colors.yellow
            })
        ]
    });
};
$46914c7e61765708$export$a6319ea655f8cd28.displayName = "RovoColorLogo";

});


parcelRegister("6rlTt", function(module, exports) {
$parcel$export(module.exports, "default", () => $a84f9d628d7d217b$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $a84f9d628d7d217b$var$message = (0, $7eNDO.defineMessages)({
    rovoButton: {
        id: 'ai-smart-button.ai-button.button-label',
        defaultMessage: 'Open Rovo Chat',
        description: 'The visually-hidden accessible label for the button that opens Rovo Chat. Must describe the action, not the element type.'
    }
});
var $a84f9d628d7d217b$export$2e2bcd8739ae039 = $a84f9d628d7d217b$var$message;

});


parcelRegister("5SEPK", function(module, exports) {
$parcel$export(module.exports, "AIProactiveNudge", () => $b18c60b7faae089d$export$50a342ac0fc7ff57);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $egspI = parcelRequire("egspI");

var $c8kME = parcelRequire("c8kME");

var $2mxRb = parcelRequire("2mxRb");

var $9h1OP = parcelRequire("9h1OP");

var $2q2Sm = parcelRequire("2q2Sm");

var $fryZM = parcelRequire("fryZM");

var $fZnSr = parcelRequire("fZnSr");

var $bd7Bg = parcelRequire("bd7Bg");

var $390NS = parcelRequire("390NS");


var $5pdIw = parcelRequire("5pdIw");

var $9MO3R = parcelRequire("9MO3R");

var $5Se8C = parcelRequire("5Se8C");
const $b18c60b7faae089d$var$messages = (0, $7eNDO.defineMessages)({
    convoStarterSubheader: {
        id: 'ai-smart-button.convo-starter.nudge.subheader',
        defaultMessage: 'Open Rovo chat with this page-specific starter',
        description: 'Subheader text shown on hover for conversation starter nudges'
    }
});

// Lazy load to avoid loading useRovoActionTrigger when there's no active nudge
const $b18c60b7faae089d$var$LazyAIProactiveNudge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("csP2Q")).then((module)=>({
            default: module.AIProactiveNudge
        })));
const $b18c60b7faae089d$export$50a342ac0fc7ff57 = ({ onActiveNudgeChange: onActiveNudgeChange })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { product: product, pageMode: pageMode, isLiveViewMode: isLiveViewMode } = (0, $fryZM.useAISmartButtonContext)();
    const isLiveDoc = pageMode === 'live';
    const [triggerId] = (0, $euxye.useState)(()=>crypto.randomUUID());
    const selectedNudges = (0, $2mxRb.useAINudges)();
    const shouldTrigger = Boolean(selectedNudges?.length);
    const hasPageCatchupNudge = selectedNudges?.some((nudge)=>nudge.nudgeContext?.id === 'content-catchup') ?? false;
    const pageUrl = (0, $bd7Bg.isBrowser)() ? `${window.location.origin}${window.location.pathname}` : '';
    const { recommendations: recommendations, loading: loading, error: error } = (0, $5pdIw.useFetchNudgeRecommendations)(triggerId, shouldTrigger, pageUrl, product, hasPageCatchupNudge, isLiveDoc, isLiveViewMode);
    const { acceptedNudges: acceptedNudges, dismissedNudges: dismissedNudges, addAcceptedNudge: addAcceptedNudge, addDismissedNudge: addDismissedNudge } = (0, $5Se8C.useNudgeSessionState)();
    const { isSuppressed: isSuppressed, addSuppressedNudge: addSuppressedNudge, addOtsSuppressedNudge: addOtsSuppressedNudge } = (0, $fZnSr.useNudgeSuppression)();
    const { setConvoStarterActionPrompt: setConvoStarterActionPrompt } = (0, $9h1OP.useConversationActionsStoreActions)();
    // Hold the active nudge for the page load. Resets on navigation.
    const [activeNudge, setActiveNudge] = (0, $euxye.useState)(null);
    const [isExitingForReplacement, setIsExitingForReplacement] = (0, $euxye.useState)(false);
    const [replacementNudgeSequence, setReplacementNudgeSequence] = (0, $euxye.useState)(0);
    // Keep transition refs outside the effect dependencies so clearing the active nudge
    // does not immediately re-pin the next resolved nudge on the experiment-off path.
    const activeNudgeForPageRef = (0, $euxye.useRef)(null);
    const pendingReplacementNudgeRef = (0, $euxye.useRef)(null);
    const prevPageUrlRef = (0, $euxye.useRef)(pageUrl);
    const isRecommendationSurface = (0, $euxye.useMemo)(()=>(0, $390NS.isNudgeRecommendationSurface)({
            product: product,
            pageUrl: pageUrl,
            isLiveDoc: isLiveDoc,
            isLiveViewMode: isLiveViewMode
        }), [
        product,
        pageUrl,
        isLiveDoc,
        isLiveViewMode
    ]);
    // FE-driven nudges the user has not already dismissed, accepted, or had suppressed for this session.
    const availableNudges = (0, $euxye.useMemo)(()=>selectedNudges.filter((nudge)=>!dismissedNudges.includes(nudge.id) && !acceptedNudges.includes(nudge.id) && !isSuppressed(nudge.id, nudge.nudgeContext?.suppressionKey)), [
        selectedNudges,
        dismissedNudges,
        acceptedNudges,
        isSuppressed
    ]);
    // Fallback FE nudge (self-eligible) used when the BE produces no winner.
    const feFallback = (0, $euxye.useMemo)(()=>availableNudges.find((nudge)=>nudge.nudgeContext?.selfEligible) ?? null, [
        availableNudges
    ]);
    const resolvedNudge = (0, $euxye.useMemo)(()=>{
        // Non-recommendation surfaces (search, Jira, live doc edit) skip the BE call and show the
        // first available registered nudge.
        if (!isRecommendationSurface) return availableNudges[0] ?? null;
        // Wait for BE recommendations before resolving so BE-driven nudges can win when eligible.
        if (loading || !selectedNudges?.length) return null;
        // On BE error or empty recommendations, fall back to FE self-eligible.
        if (error || !recommendations?.length) return feFallback;
        // TODO: dismiss/accept nudge by its nudgeContext.id so we only need to check recommendations
        const availableRecommendations = recommendations.filter((recommendation)=>{
            const id = recommendation.feature_details.feature_id;
            const suppressionKey = recommendation.context?.context_id ?? undefined;
            return !dismissedNudges.includes(id) && !acceptedNudges.includes(id) && !isSuppressed(id, suppressionKey);
        });
        // If every BE recommendation was filtered out, fall back to FE self-eligible.
        if (!availableRecommendations.length) return feFallback;
        // If no BE recommendation matched a registered FE placeholder, fall back to FE self-eligible.
        const nudge = (0, $9MO3R.findActiveNudge)(availableRecommendations, availableNudges) ?? null;
        if (!nudge) return feFallback;
        if (nudge.id === (0, $6f80cf3f4644f716$export$9ccb14fef330e4ca)) return {
            ...nudge,
            secondaryTitle: formatMessage($b18c60b7faae089d$var$messages.convoStarterSubheader)
        };
        return nudge;
    }, [
        acceptedNudges,
        availableNudges,
        dismissedNudges,
        error,
        feFallback,
        formatMessage,
        isRecommendationSurface,
        isSuppressed,
        loading,
        recommendations,
        selectedNudges
    ]);
    const shouldWaitForRecommendations = loading && isRecommendationSurface;
    const hasActiveNudge = activeNudge !== null;
    const isAgentMentionsExperimentEnabled = (0, $c8kME.expVal)('platform_editor_agent_mentions', 'isEnabled', false);
    const shouldReplaceActiveNudgeAfterExit = isAgentMentionsExperimentEnabled && Boolean(activeNudge && resolvedNudge && resolvedNudge !== activeNudge);
    const setActiveNudgeForPage = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((nextNudge)=>{
        activeNudgeForPageRef.current = nextNudge;
        setActiveNudge(nextNudge);
    }, []);
    const handleReplacementExitComplete = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(()=>{
        const nextNudge = pendingReplacementNudgeRef.current;
        pendingReplacementNudgeRef.current = null;
        setIsExitingForReplacement(false);
        setActiveNudgeForPage(nextNudge);
        if (nextNudge) setReplacementNudgeSequence((current)=>current + 1);
    }, [
        setActiveNudgeForPage
    ]);
    // Set the active nudge once BE finishes loading (or immediately on non-recommendation surfaces).
    // Reset on page navigation. Clear when the active nudge is dismissed/accepted/suppressed.
    (0, $euxye.useEffect)(()=>{
        let activeNudgeForPage = activeNudgeForPageRef.current;
        // Reset on navigation — fall through so the new page's nudge can be pinned in this same effect run.
        if (prevPageUrlRef.current !== pageUrl) {
            prevPageUrlRef.current = pageUrl;
            pendingReplacementNudgeRef.current = null;
            setIsExitingForReplacement(false);
            setActiveNudgeForPage(null);
            activeNudgeForPage = null;
        }
        // On non-recommendation surfaces, pin immediately (no BE call to wait for).
        // On recommendation surfaces, wait for BE to finish loading.
        if (shouldWaitForRecommendations) return;
        if (!isAgentMentionsExperimentEnabled) {
            setActiveNudge((prev)=>{
                if (prev === null) return resolvedNudge;
                if (resolvedNudge === null || resolvedNudge.id !== prev.id) return null;
                return prev;
            });
            return;
        }
        if (activeNudgeForPage === null) {
            setActiveNudgeForPage(resolvedNudge);
            return;
        }
        if (resolvedNudge === null) {
            pendingReplacementNudgeRef.current = null;
            setIsExitingForReplacement(false);
            setActiveNudgeForPage(null);
            return;
        }
        // Intentionally compare object identity rather than id. Agent mention nudges can
        // reuse the same action id while representing a new mention instance/context,
        // so a new object should be allowed to exit and refire.
        if (resolvedNudge === activeNudgeForPage && !isExitingForReplacement) return;
        if (shouldReplaceActiveNudgeAfterExit) {
            pendingReplacementNudgeRef.current = resolvedNudge;
            setIsExitingForReplacement(true);
            return;
        }
        if (resolvedNudge.id !== activeNudgeForPage.id) // Active nudge was dismissed/accepted/suppressed (anti-spam: don't replace mid-page).
        setActiveNudgeForPage(null);
    }, [
        pageUrl,
        shouldWaitForRecommendations,
        resolvedNudge,
        isExitingForReplacement,
        isAgentMentionsExperimentEnabled,
        shouldReplaceActiveNudgeAfterExit,
        setActiveNudgeForPage
    ]);
    // Notify parent about active nudge state
    (0, $euxye.useEffect)(()=>{
        onActiveNudgeChange?.(Boolean(activeNudge));
    }, [
        activeNudge,
        onActiveNudgeChange
    ]);
    // Sync the active nudge convo starter prompt into the shared store so the actions panel
    // can find the matching starter and pin it at position 0.
    (0, $euxye.useEffect)(()=>{
        if (activeNudge?.id === (0, $6f80cf3f4644f716$export$9ccb14fef330e4ca) && (0, $2q2Sm.isChatAction)(activeNudge) && (0, $egspI.fg)('aix_convo_starter_nudge_enabled')) setConvoStarterActionPrompt(activeNudge.staticPrompt);
        else setConvoStarterActionPrompt(undefined);
        return ()=>{
            setConvoStarterActionPrompt(undefined);
        };
    }, [
        activeNudge,
        setConvoStarterActionPrompt
    ]);
    // Early exit if no nudge to show
    if (!hasActiveNudge) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($b18c60b7faae089d$var$LazyAIProactiveNudge, {
            activeNudge: activeNudge,
            addAcceptedNudge: addAcceptedNudge,
            addDismissedNudge: addDismissedNudge,
            addSuppressedNudge: addSuppressedNudge,
            addOtsSuppressedNudge: addOtsSuppressedNudge,
            isExitingForReplacement: isExitingForReplacement,
            onReplacementExitComplete: handleReplacementExitComplete
        }, `${activeNudge.id}:${replacementNudgeSequence}`)
    });
};
$b18c60b7faae089d$export$50a342ac0fc7ff57.displayName = "AIProactiveNudge";

});
parcelRegister("c8kME", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $2719a31bba81db63$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValNoExposure", () => $2719a31bba81db63$export$94f132839aec533f);

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $hbvZL = parcelRequire("hbvZL");

var $bzstt = parcelRequire("bzstt");

var $djzuo = parcelRequire("djzuo");
function $2719a31bba81db63$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $bzstt.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $djzuo._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $djzuo._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $djzuo._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $4LDqh.default).initializeCompleted()) return defaultValue;
    if (!(0, $djzuo._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $djzuo._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    const resolvedExperimentKey = !(0, $bzstt.disallowsProductKeys).includes(experimentName) && (0, $egspI.fg)('platform_editor_experiments_use_product_keys') ? experimentKey : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $4LDqh.default).getExperimentValue(resolvedExperimentKey, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $4LDqh.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting_expval', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $hbvZL.addFeatureFlagAccessed)(`${resolvedExperimentKey}:${experimentParam}`, experimentValue);
    return experimentValue;
}
function $2719a31bba81db63$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $2719a31bba81db63$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
} /**
 * Use to check a any param value for an experiment without firing an exposure event
 *
 * **Note**: this will return the default value when the experiment;
 * - is not being served to the client (ie. pre start)
 * - or is not configured in experiments-config
 *
 * @example
 * ```ts
 * const delay = expParamEqualsNoExposure('experiment-name', 'param-name', defaultValue)
 * await new Promise(res => setTimeout(res, delay)
 * ```
 */ 
function $2719a31bba81db63$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $2719a31bba81db63$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}

});
parcelRegister("bzstt", function(module, exports) {
$parcel$export(module.exports, "disallowsProductKeys", () => $6bb81e68681268a8$export$5c897d5297c5b7fd);
$parcel$export(module.exports, "editorExperimentsConfig", () => $6bb81e68681268a8$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $Koon0 = parcelRequire("Koon0");
const $6bb81e68681268a8$export$5c897d5297c5b7fd = [
    'platform_editor_block_menu',
    'platform_editor_blocks',
    'platform_editor_controls',
    'platform_editor_preview_panel_linking_exp',
    'platform_synced_block',
    'smart_link_confluence_short_link_analytics',
    'platform_editor_static_css',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc',
    'platform_editor_ignore_metadata_connection_errors',
    'comment_on_bodied_extensions'
];
const $6bb81e68681268a8$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-06-25
    platform_editor_first_node_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_first_node_fix',
            confluence: 'platform_editor_first_node_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    remix_button_right_margin_hover: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_button_right_margin_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-02-11
    ai_speech_to_text_in_editor: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'ai_speech_to_text_in_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 05-03-2026
    platform_editor_ai_headingautocomplete: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_headingautocomplete'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-10
    confluence_max_width_content_appearance: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_content_appearance'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-15
    confluence_max_width_breakout_extension_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_breakout_extension_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-14
    platform_editor_dom_node_count: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dom_node_count'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    'agent-managed_blocks_mvp': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'agent-managed_blocks_mvp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    'agent-managed-blocks-stop-block-template': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'agent-managed-blocks-stop-block-template'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-7
    platform_editor_table_sticky_header_patch_10: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_10'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_editor_table_col_insert: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_col_insert',
            jira: 'platform_editor_table_col_insert'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_media_reliability_observability: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_reliability_observability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_react19_migration: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_react19_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05 - gates DOM mutation observer for experience tracking (toolbar + block menu)
    platform_editor_experience_tracking_observer: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking_observer',
            jira: 'platform_editor_experience_tracking_observer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_editor_ssr_streaming: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_ssr_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-03-02
    platform_editor_inline_card_dispatch_guard: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_inline_card_dispatch_guard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_profile_cards: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduced_profile_cards',
            jira: 'platform_editor_reduced_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-25
    platform_editor_plus_menu_aria_label: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_plus_menu_aria_label',
            jira: 'platform_editor_plus_menu_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-02
    platform_editor_layout_keywords: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_keywords',
            jira: 'platform_editor_layout_keywords'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_display_mode_in_to_dom: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_display_mode_in_to_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-12
    platform_editor_confluence_base_preset: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_confluence_base_preset'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_renderer_shadow_observer_cleanup: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_renderer_shadow_observer_cleanup',
            confluence: 'platform_editor_renderer_shadow_observer_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-17
    platform_editor_aifc_sync_block_stream_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_sync_block_stream_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-17-03
    platform_editor_media_name_fallback: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    platform_editor_media_name_fallback_viewer_card: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback_viewer_card'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27
    platform_editor_table_excerpts_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_excerpts_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30 (QS-9895)
    linking_platform_track_non_primary_3p_clicks: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'linking_platform_track_non_primary_3p_clicks',
            jira: 'linking_platform_track_non_primary_3p_clicks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_comment_editor_border_radius: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_editor_border_radius'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    platform_editor_perf_lint_cleanup: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_perf_lint_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_native_embeds: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_embeds'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_synced_block_use_new_source_nodeview: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block_use_new_source_nodeview',
            jira: 'platform_synced_block_use_new_source_nodeview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-08
    platform_editor_table_toolbar_perf_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_toolbar_perf_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_abort_ufo_on_user_interaction: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_abort_ufo_on_user_interaction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_flex_based_centering: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flex_based_centering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-29 — Inline rovo action on resolved inline smart links
    platform_sl_3p_auth_inline_tailored_cta: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_inline_tailored_cta',
            jira: 'platform_sl_3p_auth_inline_tailored_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16 — Use link-extractors inline icon extraction for Confluence 1P/3P connection byline
    confluence_1p_and_3p_connection_byline_experiment: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_1p_and_3p_connection_byline_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-23
    platform_editor_to_use_pmr_for_collab_edit_none_ic: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_to_use_pmr_for_collab_edit_none_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-16
    platform_editor_inline_media_replacement: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_inline_media_replacement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-08
    platform_editor_add_image_editing: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_image_editing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-30
    platform_editor_table_sticky_header_patch_9: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_9'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-25
    platform_editor_expand_paste_in_comment_editor: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_expand_paste_in_comment_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_ai_fix_insert_after_selection: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_fix_insert_after_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-07
    platform_editor_ai_move_node: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_move_node'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27 - AI create-page expand collapse fix
    platform_editor_aifc_expand_collapses_oncreate_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_expand_collapses_oncreate_fix',
            jira: 'platform_editor_aifc_expand_collapses_oncreate_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_nested_drag_handle_icon: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_drag_handle_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-23
    collab_bypass_out_of_sync_period_experiment: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'collab_bypass_out_of_sync_period_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-16
    platform_editor_ignore_metadata_connection_errors: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_collab_provider_suppress_metadata_errors'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    platform_editor_table_a11y_eslint_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_a11y_eslint_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-29
    platform_editor_renderer_toolbar_updates: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_toolbar_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_comment_rovoinlinechat_improvement: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_rovoinlinechat_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-02
    cc_fd_cwr_quick_insert: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_cwr_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'slot-four',
            'slot-two'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-05 - A11Y-10416
    editor_a11y_role_textbox: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_role_textbox'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-28
    platform_editor_smartlink_local_cache: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smartlink_local_cache'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    platform_rovo_page_comment_selector_full_width: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_page_comment_selector_full_width'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-12
    platform_editor_bodiedextension_layoutshift_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_bodiedextension_layoutshift_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_fix_advanced_codeblocks_crlf_patch: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_advanced_codeblocks_crlf_patch',
            jira: 'platform_editor_fix_advanced_codeblocks_crlf_patch'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    'editor-image-generation-styles-and-aspect-ratios': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-image-generation-styles-and-aspect-ratios'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    confluence_advanced_header_image_generation_exp: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_advanced_header_image_generation_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-17
    cc_page_experiences_premium_macros_img_generation: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_premium_macros_img_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-02
    aifc_page_create_with_rovo_include_infographics: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc_page_create_with_rovo_include_infographics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    'cc-maui-ai-edit-loading-experiment': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-ai-edit-loading-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-07
    'cc-maui-overlay-by-localid': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-overlay-by-localid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_expand_icon: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_expand_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_mentions: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_flexible_list_indentation: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_indentation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_flexible_list_schema: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_schema'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    confluence_ai_generated_emojis: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ai_generated_emojis'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    platform_editor_early_exit_return_draft: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_early_exit_return_draft'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-02
    platform_editor_discarded_unified_analytic_events: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_discarded_unified_analytic_events',
            jira: 'platform_editor_discarded_unified_analytic_events'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_appearance_shared_state: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_appearance_shared_state'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added for space shortcut plugin: when on, space shortcut is not added if AI opt-in is not enabled
    platform_editor_ai_aifc_space_shortcut_patch: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_aifc_space_shortcut_patch'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-02
    platform_editor_ai_smartlink_toolbar_v2_exp: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_smartlink_toolbar_v2_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_a11y_scrollable_region: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_scrollable_region'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    cc_drag_and_drop_smart_link_from_content_to_tree: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_drag_and_drop_smart_link_from_content_to_tree'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_small_font_size: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_small_font_size',
            jira: 'platform_editor_small_font_size'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-24
    platform_editor_diff_granular_extended: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_granular_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_auto_convert: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_auto_convert'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-13
    platform_editor_editor_centre_content_on_find: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_centre_content_on_find'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    platform_editor_close_expand_find: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_close_expand_find'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_table_ref_optimisation: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_ref_optimisation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-13
    platform_editor_misaligned_ai_screens_firefox_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_misaligned_ai_screens_firefox_fix',
            jira: 'platform_editor_misaligned_ai_screens_firefox_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_stricter_panelcolor_typecheck: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stricter_panelcolor_typecheck'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-14
    platform_editor_ai_multi_format_streaming: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_multi_format_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_expand_content_a11y: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_expand_content_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_layout_column_resize_handle: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21
    platform_editor_layout_typeahead_reorder: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_typeahead_reorder',
            jira: 'platform_editor_layout_typeahead_reorder'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-14
    improve_3p_smart_link_resolve_rate: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'improve_3p_smart_link_resolve_rate'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    platform_editor_drag_handle_keyboard_a11y: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_keyboard_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    show_mentions_in_suggest_reply: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'show_mentions_in_suggest_reply'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-10
    platform_editor_static_css: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_renderer_static_css: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-12
    platform_editor_media_reliability_enhancements: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_reliability_enhancements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_close_cell_menu_on_move_exp: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_close_cell_menu_on_move_exp',
            jira: 'platform_editor_table_close_cell_menu_on_move_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-16
    cc_dnd_smart_link_changeboard_platform_css: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_dnd_smart_link_changeboard_platform_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-22
    platform_editor_ai_screen_layout_refactor: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_screen_layout_refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    work_item_modernization: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'work_item_modernization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21
    platform_editor_fix_a11y_tab_focus_insertion_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_tab_focus_insertion_menu',
            jira: 'platform_editor_fix_a11y_tab_focus_insertion_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-22
    platform_editor_korean_characters_split: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_korean_characters_split'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    platform_editor_ai_fix_error_discard_screen: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_fix_error_discard_screen'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    editor_synced_block_perf: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_synced_block_perf'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_ai_template_localids: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_template_localids'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-20
    platform_editor_ai_tablecell_localids: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_tablecell_localids'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-05
    fix_copy_paste_external_media_renderer_to_editor: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'fix_copy_paste_external_media_renderer_to_editor',
            jira: 'fix_copy_paste_external_media_renderer_to_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_insert_menu_ai: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_insert_menu_ai',
            jira: 'platform_editor_insert_menu_ai'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $Koon0.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-04
    platform_editor_show_diff_fix_missing_attrs: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_show_diff_fix_missing_attrs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-06
    'jira-smart-replies-v2': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-smart-replies-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_table_in_panel_paste_fallback: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_in_panel_paste_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-20
    platform_editor_default_toolbar_state: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_default_toolbar_state'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_ai_improve_formatting_toolbar: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_improve_formatting_toolbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    'a11y-fixes-week4-may-2026': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week4-may-2026',
            jira: 'a11y-fixes-week4-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-26
    'a11y-fixes-week1-june-2026': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week1-june-2026',
            jira: 'a11y-fixes-week1-june-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    // Gates UI tweaks to the 3p-in-CWR ghost icons (inner icon opacity and the
    // "connect apps" tooltip copy) in the Rovo chat sources pill. When off the
    // existing ghost-icon styling and tooltip are used.
    confluence_3p_in_cwr_ghost_icons_ui_tweaks: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons_ui_tweaks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-25
    platform_editor_fix_selection_text_color_change: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_selection_text_color_change',
            jira: 'platform_editor_fix_selection_text_color_change'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    cc_ai_insert_to_page_rovo_chat_experiment: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_ai_insert_to_page_rovo_chat_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_menu_radius_update: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_menu_radius_update',
            jira: 'platform_editor_menu_radius_update'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_smarts_heading_autocomplete_migration: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_smarts_heading_autocomplete_migration'
        },
        param: 'useCcSmarts',
        defaultValue: false
    }),
    // Added 2026-06-24 — HUBS-850 — gates the --ak-editor-extension-block-spacing block-margin hook
    platform_editor_extension_block_spacing: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_extension_block_spacing',
            jira: 'platform_editor_extension_block_spacing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-02
    platform_editor_media_download_fallback_name: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_download_fallback_name'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    platform_editor_lovability_color_schema_change: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_color_schema_change',
            jira: 'platform_editor_lovability_color_schema_change'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $Koon0.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("Koon0", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $d3b16620e10969f1$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $d3b16620e10969f1$export$fb89e8a786694d1);

var $9B0dH = parcelRequire("9B0dH");
function $d3b16620e10969f1$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $9B0dH.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $d3b16620e10969f1$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $9B0dH.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("9B0dH", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $cd281af29424729f$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $cd281af29424729f$export$a9a18ae5ba42aeab);

var $gIMgJ = parcelRequire("gIMgJ");
function $cd281af29424729f$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $cd281af29424729f$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($cd281af29424729f$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $cd281af29424729f$var$IS_TESTING_ENV = typeof $gIMgJ !== 'undefined' && ($gIMgJ?.env?.NODE_ENV === 'test' || $gIMgJ?.env?.JEST_WORKER_ID !== undefined);

});



parcelRegister("djzuo", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $df480f4481daeefe$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $df480f4481daeefe$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $df480f4481daeefe$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $df480f4481daeefe$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $bzstt = parcelRequire("bzstt");

var $b5hzF = parcelRequire("b5hzF");
let $df480f4481daeefe$export$e5d73bf4f8e2ae96 = {};
let $df480f4481daeefe$export$4e849416bb5c5b52 = {};
let $df480f4481daeefe$export$cf7305fc65acbf0d;
function $df480f4481daeefe$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $bzstt.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $df480f4481daeefe$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !options?.disableTestOverrides) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $bzstt.editorExperimentsConfig)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $b5hzF.testMultivariateOverrides)[key] ?? (0, $b5hzF.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $df480f4481daeefe$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $df480f4481daeefe$export$cf7305fc65acbf0d = product;
    $df480f4481daeefe$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("b5hzF", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $e3e86bd5422ac116$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $e3e86bd5422ac116$export$54960937bb713f97);
const $e3e86bd5422ac116$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    cc_fd_cwr_quick_insert: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control'
};
const $e3e86bd5422ac116$export$54960937bb713f97 = {
    'cc-maui-ai-edit-loading-experiment': true,
    social_proof_3p_unauth_block_exp: false,
    linking_platform_track_non_primary_3p_clicks: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_fit_to_content_auto_convert: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    platform_editor_core_static_css: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — AND-gated with
    // `platform_editor_ai_xstate_migration` (see `isNewAifcExperienceEnabled`
    // in `editor-plugin-ai/src/ui/utils/new-aifc-experience-enabled.ts`).
    // (afm-ai-pr-review-bot #2) The previous comment incorrectly referenced
    // `platform_editor_ai_replace_doc` as the AND partner; the unrelated
    // `platform_editor_ai_replace_doc: false` override has been removed since
    // it does not gate this feature.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    'editor-image-generation-styles-and-aspect-ratios': false,
    confluence_advanced_header_image_generation_exp: false,
    platform_use_unicode_emojis: false,
    confluence_ai_generated_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};

});



parcelRegister("2q2Sm", function(module, exports) {
$parcel$export(module.exports, "isChatAction", () => $89475281c9869950$export$f50ba6ebca86afae);
$parcel$export(module.exports, "isNestedAction", () => $89475281c9869950$export$e0faf22bf5023c5e);
$parcel$export(module.exports, "isSkillAction", () => $89475281c9869950$export$ce07703e397785f3);

var $50DkA = parcelRequire("50DkA");
function $89475281c9869950$export$f50ba6ebca86afae(action) {
    return action.handleType === (0, $50DkA.HandleActionType).Chat;
}
function $89475281c9869950$export$e0faf22bf5023c5e(action) {
    return action.handleType === (0, $50DkA.HandleActionType).Nested;
}
function $89475281c9869950$export$ce07703e397785f3(action) {
    return action.handleType === (0, $50DkA.HandleActionType).Skill;
}
function $89475281c9869950$export$38d6fa0daaae0008(action) {
    return action.handleType === (0, $50DkA.HandleActionType).Skill && 'dynamicPrompt' in action && (0, $50DkA.LEGACY_DYNAMIC_SKILL_IDS).has(action.id);
}
function $89475281c9869950$export$426fd22b878fe58d(action) {
    return $89475281c9869950$export$f50ba6ebca86afae(action) || $89475281c9869950$export$e0faf22bf5023c5e(action) || $89475281c9869950$export$ce07703e397785f3(action);
}

});

parcelRegister("fZnSr", function(module, exports) {
$parcel$export(module.exports, "useNudgeSuppression", () => $44f7d99f19d21ccd$export$634f47956d1161e8);
/**
 * Platform hook for nudge suppression. Wired internally by `ai-proactive-nudge` — do not call directly.
 *
 * Suppression key is read from `nudge.nudgeContext.suppressionKey` (set by the consumer).
 */ 
var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $f7pgS = parcelRequire("f7pgS");

var $bVBtb = parcelRequire("bVBtb");

var $lMuM8 = parcelRequire("lMuM8");
const $44f7d99f19d21ccd$export$634f47956d1161e8 = ()=>{
    const isSuppressed = (0, $euxye.useCallback)((id, suppressionKey)=>{
        if (!(0, $egspI.fg)('rovo_button_nudge_suppression')) return false;
        const key = (0, $bVBtb.getSuppressionKey)(id, suppressionKey);
        if (key === null) return false;
        return (0, $lMuM8.isKeySuppressed)(key) || (0, $lMuM8.isOtsKeySuppressed)(key);
    }, []);
    const addSuppressedNudge = (0, $euxye.useCallback)((id, suppressionKey)=>{
        if (!(0, $egspI.fg)('rovo_button_nudge_suppression')) return;
        const key = (0, $bVBtb.getSuppressionKey)(id, suppressionKey);
        if (key === null) return;
        (0, $lMuM8.writeSuppression)(key);
    }, []);
    const addOtsSuppressedNudge = (0, $euxye.useCallback)((id, suppressionKey)=>{
        if (!(0, $egspI.fg)('rovo_button_nudge_suppression')) return;
        const key = (0, $bVBtb.getSuppressionKey)(id, suppressionKey);
        if (key === null) return;
        (0, $lMuM8.writeOtsSuppression)(key);
    }, []);
    // Expose debug API on window for QA.
    (0, $euxye.useEffect)(()=>{
        if (!(0, $egspI.fg)('rovo_button_nudge_suppression')) return;
        (0, $f7pgS.registerSuppressionDebugAPI)();
        return ()=>{
            (0, $f7pgS.unregisterSuppressionDebugAPI)();
        };
    }, []);
    return {
        isSuppressed: isSuppressed,
        addSuppressedNudge: addSuppressedNudge,
        addOtsSuppressedNudge: addOtsSuppressedNudge
    };
};

});
parcelRegister("f7pgS", function(module, exports) {
$parcel$export(module.exports, "registerSuppressionDebugAPI", () => $b49e8592c7896d16$export$4ec21f37bfe88c35);
$parcel$export(module.exports, "unregisterSuppressionDebugAPI", () => $b49e8592c7896d16$export$3ab59d0b121ec1ad);
/**
 * Debug API exposed on `window.ROVO_NUDGE_SUPPRESSION` for inspecting nudge suppression state.
 *
 * Usage:
 *   window.ROVO_NUDGE_SUPPRESSION.list()
 *   window.ROVO_NUDGE_SUPPRESSION.isSuppressed('nudge-id', 'optional-key')
 *   window.ROVO_NUDGE_SUPPRESSION.clearAll()
 *   window.ROVO_NUDGE_SUPPRESSION.clearNudge('nudge-id')
 *   window.ROVO_NUDGE_SUPPRESSION.showAllowlist()
 */ 
var $bd7Bg = parcelRequire("bd7Bg");

var $bVBtb = parcelRequire("bVBtb");

var $lMuM8 = parcelRequire("lMuM8");
const $b49e8592c7896d16$export$4ec21f37bfe88c35 = ()=>{
    if (!(0, $bd7Bg.isBrowser)()) return;
    window.ROVO_NUDGE_SUPPRESSION = {
        list: ()=>{
            const now = Date.now();
            const entries = (0, $lMuM8.readSuppressionMap)();
            return Array.from(entries.entries()).filter(([, expiresAt])=>expiresAt > now).map(([key, expiresAt])=>({
                    key: key,
                    expiresAt: expiresAt,
                    expiresAtISO: new Date(expiresAt).toISOString()
                }));
        },
        isSuppressed: (nudgeId, keyPart)=>{
            const fullKey = keyPart ? `${nudgeId}:${keyPart}` : nudgeId;
            const entries = (0, $lMuM8.readSuppressionMap)();
            const expiresAt = entries.get(fullKey);
            return expiresAt !== undefined && expiresAt > Date.now();
        },
        clearAll: ()=>{
            (0, $lMuM8.clearAllSuppression)();
        },
        clearNudge: (nudgeId)=>{
            const entries = (0, $lMuM8.readSuppressionMap)();
            Array.from(entries.keys()).filter((key)=>key === nudgeId || key.startsWith(`${nudgeId}:`)).forEach((key)=>(0, $lMuM8.clearSuppression)(key));
        },
        showAllowlist: ()=>{
            // eslint-disable-next-line no-console
            console.table(Array.from((0, $bVBtb.SUPPRESSION_ALLOWLIST)).map((id)=>({
                    id: id
                })));
        }
    };
};
const $b49e8592c7896d16$export$3ab59d0b121ec1ad = ()=>{
    if (!(0, $bd7Bg.isBrowser)()) return;
    if (window.ROVO_NUDGE_SUPPRESSION) delete window.ROVO_NUDGE_SUPPRESSION;
};

});
parcelRegister("bVBtb", function(module, exports) {
$parcel$export(module.exports, "SUPPRESSION_ALLOWLIST", () => $5874fa99b4ede897$export$aaaa1dfd99a5fa76);
$parcel$export(module.exports, "getSuppressionKey", () => $5874fa99b4ede897$export$a85e93c9055442da);

const $5874fa99b4ede897$export$aaaa1dfd99a5fa76 = new Set([
    (0, $6f80cf3f4644f716$export$560e3a8567843c82),
    (0, $6f80cf3f4644f716$export$9ccb14fef330e4ca),
    (0, $6f80cf3f4644f716$export$5aed500badbb741e)
]);
const $5874fa99b4ede897$export$a85e93c9055442da = (id, suppressionKey, allowlist = $5874fa99b4ede897$export$aaaa1dfd99a5fa76)=>{
    if (!allowlist.has(id)) return null;
    return suppressionKey ? `${id}:${suppressionKey}` : id;
};

});
const $6f80cf3f4644f716$export$9ccb14fef330e4ca = 'convo-starter';
const $6f80cf3f4644f716$export$117ec3655363b13c = 'summarize-changes-ai-action';
const $6f80cf3f4644f716$export$560e3a8567843c82 = 'daily-brief-nudge';
const $6f80cf3f4644f716$export$7728198680150ac4 = 'jira-board-catch-up-rovo-nudge';
const $6f80cf3f4644f716$export$1ef7a1ab75cdd715 = 'similar-work-items-nudge';
const $6f80cf3f4644f716$export$5aed500badbb741e = 'audio-briefing-ai-action';
const $6f80cf3f4644f716$export$6ca839f71899d7e4 = 'ai-rovo.ai-space-creation-nudge';
const $6f80cf3f4644f716$export$f504b0b55c2bc409 = 'rovo-insights-nudge';
const $6f80cf3f4644f716$export$a0e6743ad4a2d6a8 = 'action-items-nudge-ai-action';
const $6f80cf3f4644f716$export$2f71d683d556ec71 = 'rovo-collab-teammates-fomo-nudge';


parcelRegister("lMuM8", function(module, exports) {
$parcel$export(module.exports, "readSuppressionMap", () => $d9e02e7382e87b82$export$589c6f1e710012ab);
$parcel$export(module.exports, "writeSuppression", () => $d9e02e7382e87b82$export$c7717ac3db4d7c5e);
$parcel$export(module.exports, "isKeySuppressed", () => $d9e02e7382e87b82$export$836b363c9c8b0260);
$parcel$export(module.exports, "clearSuppression", () => $d9e02e7382e87b82$export$a42fc9133d653f82);
$parcel$export(module.exports, "clearAllSuppression", () => $d9e02e7382e87b82$export$6ff673702fe4ede7);
$parcel$export(module.exports, "writeOtsSuppression", () => $d9e02e7382e87b82$export$f2eb0568d964142);
$parcel$export(module.exports, "isOtsKeySuppressed", () => $d9e02e7382e87b82$export$f283fabd519e7f50);

var $4fPPi = parcelRequire("4fPPi");

var $bd7Bg = parcelRequire("bd7Bg");
/**
 * Browser-session-storage-backed store tracking which nudges have already been shown.
 * Entries expire after 7 days; capped at 500 to prevent unbounded growth.
 *
 * Two separate sessionStorage keys are used:
 *   - `rovo-button-nudges-suppression` (STRICTLY_NECESSARY): tracks nudges suppressed via
 *     explicit user interaction (click, dismiss, auto-dismiss timer). Written with
 *     `setStrictlyNecessaryItem` so it is always available regardless of consent.
 *   - `rovo-button-nudges-ots` (Functional): tracks nudges suppressed via OTS
 *     (opportunity-to-see — 5 second passive view). Written with `setItem` so it is
 *     consent-gated.
 */ const $d9e02e7382e87b82$var$STORAGE_KEY = 'rovo-button-nudges-suppression';
const $d9e02e7382e87b82$var$OTS_STORAGE_KEY = 'rovo-button-nudges-ots';
// Bounded growth constraints.
const $d9e02e7382e87b82$var$MAX_ENTRIES = 500;
const $d9e02e7382e87b82$var$MAX_AGE_MS = 604800000;
/**
 * Drop expired entries and, if still over the cap, drop the oldest by expiry.
 * Returns a new map (pure).
 */ const $d9e02e7382e87b82$var$pruneEntries = (map, now = Date.now())=>{
    // 1. Drop expired entries.
    const fresh = new Map();
    for (const [key, expiresAt] of map)if (expiresAt > now) fresh.set(key, expiresAt);
    // 2. If still over cap, drop oldest entries by expiry.
    if (fresh.size <= $d9e02e7382e87b82$var$MAX_ENTRIES) return fresh;
    const sorted = Array.from(fresh.entries()).sort((a, b)=>a[1] - b[1]);
    return new Map(sorted.slice(sorted.length - $d9e02e7382e87b82$var$MAX_ENTRIES));
};
/** Parse a sessionStorage value as a SuppressionMap. Returns an empty Map on miss/corrupt. */ const $d9e02e7382e87b82$var$parseFromStorage = (storageKey)=>{
    try {
        const raw = (0, $4fPPi.AtlBrowserStorageSession).getItem(storageKey);
        if (!raw) return new Map();
        const arr = JSON.parse(raw);
        if (Array.isArray(arr) && arr.every((e)=>Array.isArray(e) && typeof e[0] === 'string' && typeof e[1] === 'number')) return new Map(arr);
    } catch  {
    // Corrupt JSON — start fresh.
    }
    return new Map();
};
// ---------------------------------------------------------------------------
// Suppression store — STRICTLY_NECESSARY (click, dismiss, auto-dismiss timer)
// ---------------------------------------------------------------------------
/** In-memory cache for the suppression store. Prevents JSON.parse on every render. */ let $d9e02e7382e87b82$var$memoryCache = null;
/** Best-effort write of a suppression map to sessionStorage. Memory cache is always source of truth. */ const $d9e02e7382e87b82$var$writeToStorage = (map)=>{
    try {
        (0, $4fPPi.AtlBrowserStorageSession).setStrictlyNecessaryItem($d9e02e7382e87b82$var$STORAGE_KEY, JSON.stringify(Array.from(map.entries())));
    } catch  {
    // Best-effort. Memory cache is always source of truth.
    }
};
const $d9e02e7382e87b82$export$589c6f1e710012ab = ()=>{
    if (!(0, $bd7Bg.isBrowser)()) return new Map();
    if ($d9e02e7382e87b82$var$memoryCache) // Defensive copy so callers cannot mutate the cache.
    return new Map($d9e02e7382e87b82$var$memoryCache);
    const parsed = $d9e02e7382e87b82$var$parseFromStorage($d9e02e7382e87b82$var$STORAGE_KEY);
    $d9e02e7382e87b82$var$memoryCache = parsed;
    return new Map(parsed);
};
const $d9e02e7382e87b82$export$c7717ac3db4d7c5e = (suppressionKey)=>{
    if (!(0, $bd7Bg.isBrowser)()) return;
    const current = $d9e02e7382e87b82$export$589c6f1e710012ab();
    // Guard against silently refreshing TTL on an already-suppressed key.
    if (current.has(suppressionKey)) return;
    const next = new Map(current);
    next.set(suppressionKey, Date.now() + $d9e02e7382e87b82$var$MAX_AGE_MS);
    const pruned = $d9e02e7382e87b82$var$pruneEntries(next);
    $d9e02e7382e87b82$var$memoryCache = pruned;
    $d9e02e7382e87b82$var$writeToStorage(pruned);
};
const $d9e02e7382e87b82$export$836b363c9c8b0260 = (suppressionKey)=>{
    const expiresAt = $d9e02e7382e87b82$export$589c6f1e710012ab().get(suppressionKey);
    return expiresAt !== undefined && expiresAt > Date.now();
};
const $d9e02e7382e87b82$export$a42fc9133d653f82 = (suppressionKey)=>{
    if (!(0, $bd7Bg.isBrowser)()) return;
    const next = new Map($d9e02e7382e87b82$export$589c6f1e710012ab());
    next.delete(suppressionKey);
    $d9e02e7382e87b82$var$memoryCache = next;
    $d9e02e7382e87b82$var$writeToStorage(next);
    const nextOts = new Map($d9e02e7382e87b82$export$50c9b6d7d14b4832());
    nextOts.delete(suppressionKey);
    $d9e02e7382e87b82$var$otsMemoryCache = nextOts;
    $d9e02e7382e87b82$var$writeOtsToStorage(nextOts);
};
const $d9e02e7382e87b82$export$6ff673702fe4ede7 = ()=>{
    if (!(0, $bd7Bg.isBrowser)()) return;
    $d9e02e7382e87b82$var$memoryCache = new Map();
    $d9e02e7382e87b82$var$otsMemoryCache = new Map();
    try {
        (0, $4fPPi.AtlBrowserStorageSession).removeItem($d9e02e7382e87b82$var$STORAGE_KEY);
    } catch  {
    // Best-effort.
    }
    try {
        (0, $4fPPi.AtlBrowserStorageSession).removeItem($d9e02e7382e87b82$var$OTS_STORAGE_KEY);
    } catch  {
    // Best-effort.
    }
};
// ---------------------------------------------------------------------------
// OTS store — Functional / consent-gated (5-second passive view)
// ---------------------------------------------------------------------------
/** In-memory cache for the OTS store. Prevents JSON.parse on every render. */ let $d9e02e7382e87b82$var$otsMemoryCache = null;
/** Best-effort write of the OTS map to sessionStorage. Memory cache is always source of truth. */ const $d9e02e7382e87b82$var$writeOtsToStorage = (map)=>{
    try {
        (0, $4fPPi.AtlBrowserStorageSession).setItem($d9e02e7382e87b82$var$OTS_STORAGE_KEY, JSON.stringify(Array.from(map.entries())));
    } catch  {
    // Best-effort. Memory cache is always source of truth.
    }
};
const $d9e02e7382e87b82$export$50c9b6d7d14b4832 = ()=>{
    if (!(0, $bd7Bg.isBrowser)()) return new Map();
    if ($d9e02e7382e87b82$var$otsMemoryCache) // Defensive copy so callers cannot mutate the cache.
    return new Map($d9e02e7382e87b82$var$otsMemoryCache);
    const parsed = $d9e02e7382e87b82$var$parseFromStorage($d9e02e7382e87b82$var$OTS_STORAGE_KEY);
    $d9e02e7382e87b82$var$otsMemoryCache = parsed;
    return new Map(parsed);
};
const $d9e02e7382e87b82$export$f2eb0568d964142 = (suppressionKey)=>{
    if (!(0, $bd7Bg.isBrowser)()) return;
    const current = $d9e02e7382e87b82$export$50c9b6d7d14b4832();
    // Guard against silently refreshing TTL on an already-recorded key.
    if (current.has(suppressionKey)) return;
    const next = new Map(current);
    next.set(suppressionKey, Date.now() + $d9e02e7382e87b82$var$MAX_AGE_MS);
    const pruned = $d9e02e7382e87b82$var$pruneEntries(next);
    $d9e02e7382e87b82$var$otsMemoryCache = pruned;
    $d9e02e7382e87b82$var$writeOtsToStorage(pruned);
};
const $d9e02e7382e87b82$export$f283fabd519e7f50 = (suppressionKey)=>{
    const expiresAt = $d9e02e7382e87b82$export$50c9b6d7d14b4832().get(suppressionKey);
    return expiresAt !== undefined && expiresAt > Date.now();
};

});



parcelRegister("390NS", function(module, exports) {
$parcel$export(module.exports, "isNudgeRecommendationSurface", () => $59a9ae2c8937d267$export$cbdc338e17cb49af);
/**
 * Determines whether the current surface uses the nudge recommendation pipeline.
 *
 * Surfaces that return `true` will trigger a call to the `/proactive` API to fetch
 * nudge recommendations — which handles eligibility checking, content generation,
 * and ranking of registered nudges.
 *
 * Surfaces that return `false` bypass the recommendation pipeline entirely and
 * display registered nudges directly based on consumer-defined eligibility.
 */ const $59a9ae2c8937d267$export$cbdc338e17cb49af = ({ product: product, pageUrl: pageUrl, isLiveDoc: isLiveDoc, isLiveViewMode: isLiveViewMode })=>{
    if (product !== 'confluence') return false;
    if (pageUrl.includes('/wiki/search')) return false;
    if (isLiveDoc && !isLiveViewMode) return false;
    return true;
};

});

parcelRegister("5pdIw", function(module, exports) {
$parcel$export(module.exports, "useFetchNudgeRecommendations", () => $c4188bb1c24dc0e8$export$dbee8b6a491a53c);

var $euxye = parcelRequire("euxye");

var $4LDqh = parcelRequire("4LDqh");

var $390NS = parcelRequire("390NS");

var $3ZlTb = parcelRequire("3ZlTb");
const $c4188bb1c24dc0e8$var$DEFAULT_NUDGE_RECOMMENDATION_CACHE_TTL_MS = 600000;
const $c4188bb1c24dc0e8$var$getNudgeRecommendationCacheTTL = ()=>(0, $4LDqh.default).getExperimentValue('page_catchup_cache_ttl', 'value', $c4188bb1c24dc0e8$var$DEFAULT_NUDGE_RECOMMENDATION_CACHE_TTL_MS);
const $c4188bb1c24dc0e8$var$isPageCatchupCacheTTLExperimentEnabled = (hasPageCatchupNudge)=>{
    if (!hasPageCatchupNudge) return false;
    return (0, $4LDqh.default).getExperimentValue('add_cache_ttl_for_page_catchup_nudge_experiment', 'isEnabled', false);
};
const $c4188bb1c24dc0e8$export$dbee8b6a491a53c = (triggerId, shouldTrigger, pageUrl, product, hasPageCatchupNudge = false, isLiveDoc = false, isLiveViewMode = false)=>{
    const [error, setError] = (0, $euxye.useState)();
    const [loading, setLoading] = (0, $euxye.useState)(true);
    const [recommendations, setRecommendations] = (0, $euxye.useState)(undefined);
    const [previousRequestCache, setPreviousRequestCache] = (0, $euxye.useState)({});
    const makeNudgeRecommendationsRequest = (0, $euxye.useCallback)(async ()=>{
        const isSamePageRequest = pageUrl === previousRequestCache.pageUrl;
        const isDuplicateRequestWithinCacheTTL = isSamePageRequest && typeof previousRequestCache.cachedAt === 'number' && Date.now() - previousRequestCache.cachedAt < $c4188bb1c24dc0e8$var$getNudgeRecommendationCacheTTL();
        const shouldSkipDuplicatePageRequest = $c4188bb1c24dc0e8$var$isPageCatchupCacheTTLExperimentEnabled(hasPageCatchupNudge) ? isDuplicateRequestWithinCacheTTL : isSamePageRequest;
        if (!(0, $390NS.isNudgeRecommendationSurface)({
            product: product,
            pageUrl: pageUrl,
            isLiveDoc: isLiveDoc,
            isLiveViewMode: isLiveViewMode
        })) {
            setLoading(false);
            return;
        }
        if (!product || // invalid request parameter
        !shouldTrigger || // unsupported, no nudges to recommend
        shouldSkipDuplicatePageRequest // prevent duplicate page requests
        ) {
            setLoading(false);
            return;
        }
        // Begin new request under valid conditions
        if (!loading && product && shouldTrigger && !shouldSkipDuplicatePageRequest) {
            setLoading(true);
            setError(undefined);
            setRecommendations(undefined);
            return;
        }
        try {
            const response = await (0, $3ZlTb.fetchNudgeRecommendations)({
                triggerId: triggerId,
                pageUrl: pageUrl,
                product: product
            });
            setRecommendations(response?.triggers.flatMap((trigger)=>trigger.recommendations.map((recommendation)=>recommendation.recommendation_details)));
            setError(undefined);
        } catch (error) {
            setRecommendations(undefined);
            setError(error);
        } finally{
            setPreviousRequestCache({
                pageUrl: pageUrl,
                cachedAt: Date.now()
            });
            setLoading(false);
        }
    }, [
        loading,
        pageUrl,
        previousRequestCache,
        product,
        shouldTrigger,
        triggerId,
        hasPageCatchupNudge,
        isLiveDoc,
        isLiveViewMode
    ]);
    (0, $euxye.useEffect)(()=>{
        makeNudgeRecommendationsRequest();
    }, [
        loading,
        makeNudgeRecommendationsRequest
    ]);
    return (0, $euxye.useMemo)(()=>({
            recommendations: loading ? undefined : recommendations,
            loading: loading,
            error: error
        }), [
        loading,
        error,
        recommendations
    ]);
};

});
parcelRegister("3ZlTb", function(module, exports) {
$parcel$export(module.exports, "fetchNudgeRecommendations", () => $29547d38a001bce1$export$921bdedcb199d207);

var $bd7Bg = parcelRequire("bd7Bg");
// TODO: Extract and use factory pattern for different trigger types.
const $29547d38a001bce1$var$ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_PAGE_LOAD';
const $29547d38a001bce1$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';
const $29547d38a001bce1$export$921bdedcb199d207 = async ({ triggerId: triggerId, pageUrl: pageUrl, product: product })=>{
    if ((0, $bd7Bg.isBrowser)() && window.AIX_DEBUG_NUDGE_TRIGGERS?.hasTriggers) return {
        triggers: [
            {
                recommendations: [
                    {
                        recommendation_details: window.AIX_DEBUG_NUDGE_TRIGGERS?.useNextTrigger()
                    }
                ]
            }
        ]
    };
    const request = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_details: {
                        page_url: pageUrl
                    },
                    trigger_type: $29547d38a001bce1$var$ROVO_BUTTON_TRIGGER_TYPE
                }
            ]
        }
    };
    const response = await fetch($29547d38a001bce1$var$CONVO_AI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': product,
            'X-Experience-Id': 'proactive-ai-rovo-button'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Error fetching agent recommendations and convo starters, status code: ${response.status}`);
    // Allow error to raise if response is not valid JSON
    // Allow undefined to be returned if ai_feature_output is not present
    return (await response.json())?.ai_feature_output;
};

});


parcelRegister("9MO3R", function(module, exports) {
$parcel$export(module.exports, "findActiveNudge", () => $56d6bb3e59b47aab$export$6c62f9c964ed3ae0);

var $bVVh7 = parcelRequire("bVVh7");
const $56d6bb3e59b47aab$export$6c62f9c964ed3ae0 = (recommendations, availableNudges)=>{
    for (const recommendation of recommendations){
        // Primary match: nudge registered with id matching the BE feature_id
        const matchedNudge = availableNudges.find((nudge)=>nudge.id === recommendation.feature_details.feature_id);
        // Fallback match: nudge registered with nudgeContext.id matching the BE feature_id.
        // This exists because some nudge types use nudgeContext.id instead of id for matching —
        // a data model inconsistency that should be unified.
        const matchedNudgeByContextId = availableNudges.find((action)=>action.nudgeContext?.id === recommendation.feature_details.feature_id);
        if (matchedNudge) {
            const enriched = (0, $bVVh7.enrichNudge)({
                ...matchedNudge,
                recommendationNudgeId: recommendation.nudge_id
            }, recommendation);
            if (enriched) return enriched;
        }
        if (matchedNudgeByContextId) {
            const enriched = (0, $bVVh7.enrichNudge)({
                ...matchedNudgeByContextId,
                recommendationNudgeId: recommendation.nudge_id
            }, recommendation);
            if (enriched) return enriched;
        }
    }
    return undefined;
};

});
parcelRegister("bVVh7", function(module, exports) {
$parcel$export(module.exports, "enrichNudge", () => $b7da503e0634c4ea$export$17110c9fdd9f02a6);

var $cpVe5 = parcelRequire("cpVe5");
const $b7da503e0634c4ea$export$17110c9fdd9f02a6 = (nudge, recommendation)=>{
    if (nudge.type === 'convo-starter-action') {
        const enriched = (0, $cpVe5.enrichConversationStarterNudge)(recommendation);
        if (!enriched) return undefined;
        return {
            ...enriched,
            recommendationNudgeId: nudge.recommendationNudgeId
        };
    }
    return nudge;
};

});
parcelRegister("cpVe5", function(module, exports) {
$parcel$export(module.exports, "enrichConversationStarterNudge", () => $fe00b188ca594604$export$ff61339971a5979d);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $kJM81 = parcelRequire("kJM81");

var $50DkA = parcelRequire("50DkA");

const $fe00b188ca594604$export$ff61339971a5979d = (recommendation)=>{
    const label = recommendation.cta.cta_label;
    const contextId = recommendation.context?.context_id;
    if (!label || !contextId) return undefined;
    return {
        id: (0, $6f80cf3f4644f716$export$9ccb14fef330e4ca),
        title: label,
        icon: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kJM81))), {
                label: ""
            }),
        type: 'convo-starter-action',
        staticPrompt: label,
        starterType: 'static',
        handleType: (0, $50DkA.HandleActionType).Chat,
        nudgeContext: {
            id: (0, $6f80cf3f4644f716$export$9ccb14fef330e4ca),
            suppressionKey: contextId
        }
    };
};

});



parcelRegister("5Se8C", function(module, exports) {
$parcel$export(module.exports, "useNudgeSessionState", () => $b44948558e1b3a4f$export$2bad233bdabe73c4);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $jvHCQ = parcelRequire("jvHCQ");

var $bd7Bg = parcelRequire("bd7Bg");
/**
 * The state only resets when:
 * - Location Changes: User navigates to a different page
 * - Page Refresh: Browser refreshes the page (global variables reset)
 * What Doesn't Reset the State
 * - Component Re-renders: State persists
 * - Component Unmount/Remount: State persists (this is what you want)
 * - Button Disappears/Reappears: State persists
 */ let $b44948558e1b3a4f$var$globalAcceptedNudges = [];
let $b44948558e1b3a4f$var$globalDismissedNudges = [];
const $b44948558e1b3a4f$export$2dd8f6b7dbe1b931 = ()=>{
    $b44948558e1b3a4f$var$globalAcceptedNudges = [];
    $b44948558e1b3a4f$var$globalDismissedNudges = [];
};
const $b44948558e1b3a4f$export$2bad233bdabe73c4 = ()=>{
    const { setNudges: setNudges } = (0, $jvHCQ.useAISmartButtonActions)();
    const [location, setLocation] = (0, $euxye.useState)((0, $bd7Bg.isBrowser)() ? window.location.pathname : undefined);
    const [acceptedNudges, setAcceptedNudges] = (0, $euxye.useState)($b44948558e1b3a4f$var$globalAcceptedNudges);
    const [dismissedNudges, setDismissedNudges] = (0, $euxye.useState)($b44948558e1b3a4f$var$globalDismissedNudges);
    // Helper functions
    const addAcceptedNudge = (0, $euxye.useCallback)((id)=>{
        setAcceptedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $b44948558e1b3a4f$var$globalAcceptedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const addDismissedNudge = (0, $euxye.useCallback)((id)=>{
        setDismissedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $b44948558e1b3a4f$var$globalDismissedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const clearState = (0, $euxye.useCallback)(()=>{
        setNudges([]);
        setAcceptedNudges([]);
        setDismissedNudges([]);
        $b44948558e1b3a4f$var$globalAcceptedNudges = [];
        $b44948558e1b3a4f$var$globalDismissedNudges = [];
    }, [
        setNudges
    ]);
    const handleLocationChange = (0, $euxye.useCallback)(()=>{
        if (!(0, $bd7Bg.isBrowser)()) return;
        if (location !== window.location.pathname) {
            setLocation(window.location.pathname);
            clearState();
        }
    }, [
        clearState,
        location,
        setLocation
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!(0, $bd7Bg.isBrowser)()) return;
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $glbdM.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            if (!(0, $bd7Bg.isBrowser)()) return;
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return {
        acceptedNudges: acceptedNudges,
        dismissedNudges: dismissedNudges,
        addAcceptedNudge: addAcceptedNudge,
        addDismissedNudge: addDismissedNudge,
        clearState: clearState
    };
};

});

parcelRegister("csP2Q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("jpX5h")
]).then(()=>parcelRequire('3ULu5'));

});


parcelRegister("fOkTC", function(module, exports) {
$parcel$export(module.exports, "GlowAnimation", () => $5f0aa49039d62294$export$c18249cbd1532738);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $6Zl63 = parcelRequire("6Zl63");

var $bg5Lv = parcelRequire("bg5Lv");
const $5f0aa49039d62294$var$styles = {
    glowOverlay: "_2rko1tm3 _1reo15vq _18m915vq _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe _1bsbckbl _4t3ickbl _lcxvglyw _1pbykb7n _1lmqglyw"
};
function $5f0aa49039d62294$export$c18249cbd1532738() {
    const [visible, setVisible] = (0, $euxye.useState)(true);
    if (!visible) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        style: {
            opacity: 0.6
        },
        "aria-hidden": "true",
        className: (0, $4jQY2.default)([
            $5f0aa49039d62294$var$styles.glowOverlay
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Zl63))), {
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($bg5Lv))),
            loop: false,
            onComplete: ()=>setVisible(false)
        })
    });
}
$5f0aa49039d62294$export$c18249cbd1532738.displayName = "GlowAnimation";

});
parcelRegister("6Zl63", function(module, exports) {


(function(global, factory) {
    factory(module.exports, (parcelRequire("g1LNX")), (parcelRequire("euxye")));
})(module.exports, function(exports1, lottie, React) {
    'use strict';
    function _interopDefaultLegacy(e) {
        return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
        };
    }
    var lottie__default = /*#__PURE__*/ _interopDefaultLegacy(lottie);
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    function _iterableToArrayLimit(arr, i) {
        var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
        if (null != _i) {
            var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
            try {
                if (_x = (_i = _i.call(arr)).next, 0 === i) {
                    if (Object(_i) !== _i) return;
                    _n = !1;
                } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
            } catch (err) {
                _d = !0, _e = err;
            } finally{
                try {
                    if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    var _excluded$1 = [
        "animationData",
        "loop",
        "autoplay",
        "initialSegment",
        "onComplete",
        "onLoopComplete",
        "onEnterFrame",
        "onSegmentStart",
        "onConfigReady",
        "onDataReady",
        "onDataFailed",
        "onLoadedImages",
        "onDOMLoaded",
        "onDestroy",
        "lottieRef",
        "renderer",
        "name",
        "assetsPath",
        "rendererSettings"
    ];
    var useLottie = function useLottie(props, style) {
        var animationData = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy;
        props.lottieRef;
        props.renderer;
        props.name;
        props.assetsPath;
        props.rendererSettings;
        var rest = _objectWithoutProperties(props, _excluded$1);
        var _useState = React.useState(false), _useState2 = _slicedToArray(_useState, 2), animationLoaded = _useState2[0], setAnimationLoaded = _useState2[1];
        var animationInstanceRef = React.useRef();
        var animationContainer = React.useRef(null);
        /*
          ======================================
              INTERACTION METHODS
          ======================================
       */ /**
     * Play
     */ var play = function play() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.play();
        };
        /**
     * Stop
     */ var stop = function stop() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.stop();
        };
        /**
     * Pause
     */ var pause = function pause() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.pause();
        };
        /**
     * Set animation speed
     * @param speed
     */ var setSpeed = function setSpeed(speed) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSpeed(speed);
        };
        /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */ var goToAndPlay = function goToAndPlay(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndPlay(value, isFrame);
        };
        /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */ var goToAndStop = function goToAndStop(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndStop(value, isFrame);
        };
        /**
     * Set animation direction
     * @param direction
     */ var setDirection = function setDirection(direction) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setDirection(direction);
        };
        /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */ var playSegments = function playSegments(segments, forceFlag) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.playSegments(segments, forceFlag);
        };
        /**
     * Set sub frames
     * @param useSubFrames
     */ var setSubframe = function setSubframe(useSubFrames) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSubframe(useSubFrames);
        };
        /**
     * Get animation duration
     * @param inFrames
     */ var getDuration = function getDuration(inFrames) {
            var _a;
            return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
        };
        /**
     * Destroy animation
     */ var destroy = function destroy() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Removing the reference to the animation so separate cleanups are skipped.
            // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
            animationInstanceRef.current = undefined;
        };
        /*
          ======================================
              LOTTIE
          ======================================
       */ /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */ var loadAnimation = function loadAnimation() {
            var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _a;
            // Return if the container ref is null
            if (!animationContainer.current) return;
            // Destroy any previous instance
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Build the animation configuration
            var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
                container: animationContainer.current
            });
            // Save the animation instance
            animationInstanceRef.current = lottie__default["default"].loadAnimation(config);
            setAnimationLoaded(!!animationInstanceRef.current);
            // Return a function that will clean up
            return function() {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
                animationInstanceRef.current = undefined;
            };
        };
        /**
     * (Re)Initialize when animation data changed
     */ React.useEffect(function() {
            var onUnmount = loadAnimation();
            // Clean up on unmount
            return function() {
                return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            animationData,
            loop
        ]);
        // Update the autoplay state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            animationInstanceRef.current.autoplay = !!autoplay;
        }, [
            autoplay
        ]);
        // Update the initial segment state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            // When null should reset to default animation length
            if (!initialSegment) {
                animationInstanceRef.current.resetSegments(true);
                return;
            }
            // If it's not a valid segment, do nothing
            if (!Array.isArray(initialSegment) || !initialSegment.length) return;
            // If the current position it's not in the new segment
            // set the current position to start
            if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) animationInstanceRef.current.currentRawFrame = initialSegment[0];
            // Update the segment
            animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
        }, [
            initialSegment
        ]);
        /*
          ======================================
              EVENTS
          ======================================
       */ /**
     * Reinitialize listener on change
     */ React.useEffect(function() {
            var partialListeners = [
                {
                    name: "complete",
                    handler: onComplete
                },
                {
                    name: "loopComplete",
                    handler: onLoopComplete
                },
                {
                    name: "enterFrame",
                    handler: onEnterFrame
                },
                {
                    name: "segmentStart",
                    handler: onSegmentStart
                },
                {
                    name: "config_ready",
                    handler: onConfigReady
                },
                {
                    name: "data_ready",
                    handler: onDataReady
                },
                {
                    name: "data_failed",
                    handler: onDataFailed
                },
                {
                    name: "loaded_images",
                    handler: onLoadedImages
                },
                {
                    name: "DOMLoaded",
                    handler: onDOMLoaded
                },
                {
                    name: "destroy",
                    handler: onDestroy
                }
            ];
            var listeners = partialListeners.filter(function(listener) {
                return listener.handler != null;
            });
            if (!listeners.length) return;
            var deregisterList = listeners.map(/**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */ function(listener) {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.addEventListener(listener.name, listener.handler);
                // Return a function to deregister this listener
                return function() {
                    var _a;
                    (_a = animationInstanceRef.current) === null || _a === void 0 || _a.removeEventListener(listener.name, listener.handler);
                };
            });
            // Deregister listeners on unmount
            return function() {
                deregisterList.forEach(function(deregister) {
                    return deregister();
                });
            };
        }, [
            onComplete,
            onLoopComplete,
            onEnterFrame,
            onSegmentStart,
            onConfigReady,
            onDataReady,
            onDataFailed,
            onLoadedImages,
            onDOMLoaded,
            onDestroy
        ]);
        /**
     * Build the animation view
     */ var View = /*#__PURE__*/ React__default["default"].createElement("div", _objectSpread2({
            style: style,
            ref: animationContainer
        }, rest));
        return {
            View: View,
            play: play,
            stop: stop,
            pause: pause,
            setSpeed: setSpeed,
            goToAndStop: goToAndStop,
            goToAndPlay: goToAndPlay,
            setDirection: setDirection,
            playSegments: playSegments,
            setSubframe: setSubframe,
            getDuration: getDuration,
            destroy: destroy,
            animationContainerRef: animationContainer,
            animationLoaded: animationLoaded,
            animationItem: animationInstanceRef.current
        };
    };
    // helpers
    function getContainerVisibility(container) {
        var _container$getBoundin = container.getBoundingClientRect(), top = _container$getBoundin.top, height = _container$getBoundin.height;
        var current = window.innerHeight - top;
        var max = window.innerHeight + height;
        return current / max;
    }
    function getContainerCursorPosition(container, cursorX, cursorY) {
        var _container$getBoundin2 = container.getBoundingClientRect(), top = _container$getBoundin2.top, left = _container$getBoundin2.left, width = _container$getBoundin2.width, height = _container$getBoundin2.height;
        var x = (cursorX - left) / width;
        var y = (cursorY - top) / height;
        return {
            x: x,
            y: y
        };
    }
    var useInitInteractivity = function useInitInteractivity(_ref) {
        var wrapperRef = _ref.wrapperRef, animationItem = _ref.animationItem, mode = _ref.mode, actions = _ref.actions;
        React.useEffect(function() {
            var wrapper = wrapperRef.current;
            if (!wrapper || !animationItem || !actions.length) return;
            animationItem.stop();
            var scrollModeHandler = function scrollModeHandler() {
                var assignedSegment = null;
                var scrollHandler = function scrollHandler() {
                    var currentPercent = getContainerVisibility(wrapper);
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref2) {
                        var visibility = _ref2.visibility;
                        return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    if (action.type === "seek" && action.visibility && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
                        //! goToAndStop must be relative to the start of the current segment
                        animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
                    }
                    if (action.type === "loop") {
                        // Loop: Loop a given frames
                        if (assignedSegment === null) {
                            // if not playing any segments currently. play those segments and save to state
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        } else {
                            // if playing any segments currently.
                            //check if segments in state are equal to the frames selected by action
                            if (assignedSegment !== action.frames) {
                                // if they are not equal. new segments are to be loaded
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            } else if (animationItem.isPaused) {
                                // if they are equal the play method must be called only if lottie is paused
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            }
                        }
                    }
                    if (action.type === "play" && animationItem.isPaused) {
                        // Play: Reset segments and continue playing full animation from current position
                        animationItem.resetSegments(true);
                        animationItem.play();
                    }
                    if (action.type === "stop") // Stop: Stop playback
                    animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
                };
                document.addEventListener("scroll", scrollHandler);
                return function() {
                    document.removeEventListener("scroll", scrollHandler);
                };
            };
            var cursorModeHandler = function cursorModeHandler() {
                var handleCursor = function handleCursor(_x, _y) {
                    var x = _x;
                    var y = _y;
                    // Resolve cursor position if cursor is inside container
                    if (x !== -1 && y !== -1) {
                        // Get container cursor position
                        var pos = getContainerCursorPosition(wrapper, x, y);
                        // Use the resolved position
                        x = pos.x;
                        y = pos.y;
                    }
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref3) {
                        var position = _ref3.position;
                        if (position && Array.isArray(position.x) && Array.isArray(position.y)) return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
                        if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) return x === position.x && y === position.y;
                        return false;
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    // Process action types:
                    if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
                        var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
                        animationItem.playSegments(action.frames, true);
                        animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
                    }
                    if (action.type === "loop") animationItem.playSegments(action.frames, true);
                    if (action.type === "play") {
                        // Play: Reset segments and continue playing full animation from current position
                        if (animationItem.isPaused) animationItem.resetSegments(false);
                        animationItem.playSegments(action.frames);
                    }
                    if (action.type === "stop") animationItem.goToAndStop(action.frames[0], true);
                };
                var mouseMoveHandler = function mouseMoveHandler(ev) {
                    handleCursor(ev.clientX, ev.clientY);
                };
                var mouseOutHandler = function mouseOutHandler() {
                    handleCursor(-1, -1);
                };
                wrapper.addEventListener("mousemove", mouseMoveHandler);
                wrapper.addEventListener("mouseout", mouseOutHandler);
                return function() {
                    wrapper.removeEventListener("mousemove", mouseMoveHandler);
                    wrapper.removeEventListener("mouseout", mouseOutHandler);
                };
            };
            switch(mode){
                case "scroll":
                    return scrollModeHandler();
                case "cursor":
                    return cursorModeHandler();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            mode,
            animationItem
        ]);
    };
    var useLottieInteractivity = function useLottieInteractivity(_ref4) {
        var actions = _ref4.actions, mode = _ref4.mode, lottieObj = _ref4.lottieObj;
        var animationItem = lottieObj.animationItem, View = lottieObj.View, animationContainerRef = lottieObj.animationContainerRef;
        useInitInteractivity({
            actions: actions,
            animationItem: animationItem,
            mode: mode,
            wrapperRef: animationContainerRef
        });
        return View;
    };
    var _excluded = [
        "style",
        "interactivity"
    ];
    var Lottie = function Lottie(props) {
        var _a, _b, _c;
        var style = props.style, interactivity = props.interactivity, lottieProps = _objectWithoutProperties(props, _excluded);
        /**
     * Initialize the 'useLottie' hook
     */ var _useLottie = useLottie(lottieProps, style), View = _useLottie.View, play = _useLottie.play, stop = _useLottie.stop, pause = _useLottie.pause, setSpeed = _useLottie.setSpeed, goToAndStop = _useLottie.goToAndStop, goToAndPlay = _useLottie.goToAndPlay, setDirection = _useLottie.setDirection, playSegments = _useLottie.playSegments, setSubframe = _useLottie.setSubframe, getDuration = _useLottie.getDuration, destroy = _useLottie.destroy, animationContainerRef = _useLottie.animationContainerRef, animationLoaded = _useLottie.animationLoaded, animationItem = _useLottie.animationItem;
        /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */ React.useEffect(function() {
            if (props.lottieRef) props.lottieRef.current = {
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndPlay: goToAndPlay,
                goToAndStop: goToAndStop,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            (_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current
        ]);
        return useLottieInteractivity({
            lottieObj: {
                View: View,
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndStop: goToAndStop,
                goToAndPlay: goToAndPlay,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            },
            actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
            mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
        });
    };
    Object.defineProperty(exports1, 'LottiePlayer', {
        enumerable: true,
        get: function() {
            return lottie__default["default"];
        }
    });
    exports1["default"] = Lottie;
    exports1.useLottie = useLottie;
    exports1.useLottieInteractivity = useLottieInteractivity;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});
parcelRegister("g1LNX", function(module, exports) {
typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$6 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$6(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$5 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$5(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return 'canvas';
         // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return '';
    }
    function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$4 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$4(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        if (!params.path) this.trigger('destroy');
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_play');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_pause');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === 'multidimensional') newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === 'unidimensional') {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray('float32', len);
        this.pv = createTypedArray('float32', len);
        this.vel = createTypedArray('float32', len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray('float32', arrLen);
        this.pv = createTypedArray('float32', arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray('float32', arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.12.2';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span'); // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span'); // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px'; // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        } // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: 'transformEFfect'
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS('g');
                gg.setAttribute('id', this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = '';
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = '_';
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + '_';
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return '_' + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = '__lottie_element_luma_buffer';
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS('svg');
            var fil = createNS('filter');
            var matrix = createNS('feColorMatrix');
            fil.setAttribute('id', id);
            matrix.setAttribute('type', 'matrix');
            matrix.setAttribute('color-interpolation-filters', 'sRGB');
            matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute('id', id + '_svg');
            if (featureSupport.svgLumaHidden) _svg.style.display = 'none';
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag('canvas');
                lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = 'url(#' + id + ')';
                lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = 'url(#' + id + ')';
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== 'n') hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== 'n') {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: 'source-in',
        2: 'source-out',
        3: 'source-in',
        4: 'source-out'
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext('2d');
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = 'destination-over';
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = 'source-over';
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === 'fl' || data.ty === 'st') {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
        } else if (data.ty === 'gf' || data.ty === 'gs') {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === 'st' || data.ty === 'gs') {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, 'canvas', this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === 'st' || type === 'gs') {
                    renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== 'st' && type !== 'gs') ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === 'st' || type === 'gs') {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === 'm') ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === 'c') ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === 'st' || type === 'gs') {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== 'st' && type !== 'gs') // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === 'tr') {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') this.renderPath(items[i], data[i]);
            else if (items[i].ty === 'fl') this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'st') this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gf' || items[i].ty === 'gs') this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gr') this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: 'm',
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: 'm',
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: 'z'
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = 'canvas';
        this.values = {
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,0)',
            sWidth: 0,
            fValue: ''
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = 'rgba(0,0,0,0)';
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = 'source-over';
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag('canvas');
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = '100%';
            containerStyle.height = '100%';
            var origin = '0px 0px 0px';
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle['-webkit-transform'] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext('2d');
            if (this.renderConfig.className) this.animationItem.container.setAttribute('class', this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute('id', this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(' ');
            var fillType = par[1] || 'meet';
            var pos = par[0] || 'xMidYMid';
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === 'none') {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num; // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = 'none';
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = 'block';
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray('float32', 16);
        this.fillStyle = '';
        this.strokeStyle = '';
        this.lineWidth = '';
        this.lineCap = '';
        this.lineJoin = '';
        this.miterLimit = '';
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = '';
        this.appliedFillStyle = ''; //
        this.currentStrokeStyle = '';
        this.appliedStrokeStyle = ''; //
        this.currentLineWidth = '';
        this.appliedLineWidth = ''; //
        this.currentLineCap = '';
        this.appliedLineCap = ''; //
        this.currentLineJoin = '';
        this.appliedLineJoin = ''; //
        this.appliedMiterLimit = '';
        this.currentMiterLimit = '';
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            className: config && config.className || '',
            id: config && config.id || '',
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = 'canvas';
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || 'div');
            if (this.data.hasMask) {
                this.svgElement = createNS('svg');
                this.layerElement = createNS('g');
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS('rect');
            rect.setAttribute('width', this.data.sw);
            rect.setAttribute('height', this.data.sh);
            rect.setAttribute('fill', this.data.sc);
            this.svgElement.setAttribute('width', this.data.sw);
            this.svgElement.setAttribute('height', this.data.sh);
        } else {
            rect = createTag('div');
            rect.style.width = this.data.sw + 'px';
            rect.style.height = this.data.sh + 'px';
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS('g');
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS('svg');
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute('width', size.w);
            cont.setAttribute('height', size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute('width', tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute('height', tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = 'svg';
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = 'svg';
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute('width', this.compW);
            this.svgElement.setAttribute('height', this.compH);
            var g = createNS('g');
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = 'html';
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + 'px';
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + 'px';
            innerElemStyle.lineHeight = documentData.finalSize + 'px';
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = '';
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS('path');
                    tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
                    tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
                    tSpan.setAttribute('stroke-miterlimit', '4');
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag('div');
                        tParent.style.lineHeight = 0;
                        tCont = createNS('svg');
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag('span');
                    styleDiv(tParent);
                    tSpan = createTag('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute('d', shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute('width', boundingBox.width + 2);
                        tCont.setAttribute('height', boundingBox.height + 2);
                        tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute('width', 1);
                        tCont.setAttribute('height', 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent); //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            } //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = 'block';
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
                svgStyle = this.svgElement.style;
                var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute('transform', renderedLetter.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute('stroke-width', renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute('stroke', renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute('fill', renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute('width', boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute('height', boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === '3d') {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + 'px';
                var origin = '0px 0px 0px';
                var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === '3d') {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + 'px';
                            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS('image');
            this.imageElem.setAttribute('width', this.assetData.w + 'px');
            this.imageElem.setAttribute('height', this.assetData.h + 'px');
            this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute('width', this.assetData.w);
            this.baseElement.setAttribute('height', this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = 'anonymous';
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute('id', this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag('div');
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag('div');
        styleDiv(container);
        if (type === '3d') {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + 'px';
            style.height = this.globalData.compSize.h + 'px';
            var center = '50% 50%';
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = '';
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== '3d') {
                currentContainer = '3d';
                lastThreeDContainerData = this.createThreeDContainer(i, '3d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== '2d') {
                currentContainer = '2d';
                lastThreeDContainerData = this.createThreeDContainer(i, '2d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag('div');
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + 'px';
        style.height = animData.h + 'px';
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = 'flat';
        style.mozTransformStyle = 'flat';
        style.webkitTransformStyle = 'flat';
        if (this.renderConfig.className) resizerElem.setAttribute('class', this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = 'hidden';
        var svg = createNS('svg');
        svg.setAttribute('width', '1');
        svg.setAttribute('height', '1');
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS('defs');
        svg.appendChild(defs);
        this.data = animData; // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = 'none';
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = 'block';
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag('div');
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute('width', this.data.w);
            this.svgElement.setAttribute('height', this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, '_name', {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng; // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                     // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
        }
        math['seed' + rngname] = seedrandom; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = []; // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            } // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == 'object') {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == 'string' ? obj : obj + '\0';
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + '', smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: 'shape'
    };
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var ExpressionManager = function() {
        'use strict';
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === 'string') a = parseInt(a, 10);
                if (tOfB === 'string') b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === 'string') a = parseInt(a, 10);
            if (typeof b === 'string') b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === 'number' || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray('float32', len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray('float32', len);
                var arr = createTypedArray('float32', len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf('random') !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, 'value', {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray('float32', lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle += 1;
                } // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray('float32', lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray('float32', lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === 'number') {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === 'number') throw new Error('The property has no keyframe at index ' + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return '';
            }
            function substr(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return '';
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') return value;
                if (this.propType === 'textSelector') {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface('ADBE Transform Group');
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer('ADBE Root Vectors Group');
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, 'maskPath', {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, 'velocity', {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = '';
                if ('s' in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ('e' in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === 'unidimensional' ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, 'unidimensional');
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    completeProperty(expressionValue, property, 'unidimensional');
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray('float32', len);
            var arrValue = createTypedArray('float32', len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, 'multidimensional');
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === 'unidimensional') return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case 'scale':
                    case 'Scale':
                    case 'ADBE Scale':
                    case 6:
                        return _thisFunction.scale;
                    case 'rotation':
                    case 'Rotation':
                    case 'ADBE Rotation':
                    case 'ADBE Rotate Z':
                    case 10:
                        return _thisFunction.rotation;
                    case 'ADBE Rotate X':
                        return _thisFunction.xRotation;
                    case 'ADBE Rotate Y':
                        return _thisFunction.yRotation;
                    case 'position':
                    case 'Position':
                    case 'ADBE Position':
                    case 2:
                        return _thisFunction.position;
                    case 'ADBE Position_0':
                        return _thisFunction.xPosition;
                    case 'ADBE Position_1':
                        return _thisFunction.yPosition;
                    case 'ADBE Position_2':
                        return _thisFunction.zPosition;
                    case 'anchorPoint':
                    case 'AnchorPoint':
                    case 'Anchor Point':
                    case 'ADBE AnchorPoint':
                    case 1:
                        return _thisFunction.anchorPoint;
                    case 'opacity':
                    case 'Opacity':
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, 'rotation', {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, 'zRotation', {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, 'xRotation', {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, 'yRotation', {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, 'scale', {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, 'position', {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, 'xPosition', {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, 'yPosition', {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, 'zPosition', {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, 'anchorPoint', {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, 'opacity', {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, 'skew', {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, 'skewAxis', {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, 'orientation', {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Root Vectors Group':
                    case 'Contents':
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case 'Transform':
                    case 'transform':
                    case 'ADBE Transform Group':
                        return transformInterface;
                    case 4:
                    case 'ADBE Effect Parade':
                    case 'effects':
                    case 'Effects':
                        return _thisLayerFunction.effect;
                    case 'ADBE Text Properties':
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, 'rotation'),
                scale: getDescriptor(transformInterface, 'scale'),
                position: getDescriptor(transformInterface, 'position'),
                opacity: getDescriptor(transformInterface, 'opacity'),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, 'numProperties', {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === 'ADBE Color Control') Object.defineProperty(groupInterface, 'color', {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface('', propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === 'gr') arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'fl') arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'st') arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tm') arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tr') ;
                else if (shapes[i].ty === 'el') arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sr') arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sh') arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rc') arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rd') arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rp') arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'gf') arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === 'number') return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function get() {
                    return shape.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Start Point' || val === 'start point') return interfaceFunction.startPoint;
                if (val === 'End Point' || val === 'end point') return interfaceFunction.endPoint;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return 'a';
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                if (val === 'Stroke Width' || val === 'stroke width') return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === 'End' || val === 'end') return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === 'Anchor Point') return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === 'Opacity') return interfaceFunction.opacity;
                if (shape.p.ix === value || value === 'Position') return interfaceFunction.position;
                if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') return interfaceFunction.rotation;
                if (shape.s.ix === value || value === 'Scale') return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === 'Skew') return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === 'Round Corners 1') return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === 'Copies') return interfaceFunction.copies;
                if (shape.o.ix === value || value === 'Offset') return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === 'number') {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = 'Contents';
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Text Document':
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, 'sourceText', {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, 'style', {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof1(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof1(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = '';
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = '';
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                return '';
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === 'Outline') return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = 'Outline';
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === 'Data') return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = 'Data';
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001; // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray('float32', v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === 'continue') {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === 'continue') {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray('float32', this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix; /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === 'i' || prop === 'o') arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices('v', time);
            },
            inTangents: function inTangents(time) {
                return this.vertices('i', time);
            },
            outTangents: function outTangents(time) {
                return this.vertices('o', time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === 'tangent' ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'tangent');
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'normal');
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS('feMerge');
            feMerge.setAttribute('result', resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS('feMergeNode');
                feMergeNode.setAttribute('in', ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute('result', id + '_tint_1');
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id + '_tint_2');
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + '_tint_1',
            id + '_tint_2'
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
            this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS('g');
        groupPath.setAttribute('fill', 'none');
        groupPath.setAttribute('stroke-linecap', 'round');
        groupPath.setAttribute('stroke-dashoffset', 1);
        for(i; i < len; i += 1){
            path = createNS('path');
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS('mask');
            var id = createElementID();
            mask.setAttribute('id', id);
            mask.setAttribute('mask-type', 'alpha');
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS('g');
            g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute('stroke', '#fff');
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute('mask');
            groupPath.setAttribute('stroke', '#fff');
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute('d', mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = '0 0 0 ' + l * s + ' ';
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
                    dasharrayValue += '0 ' + l * 10 + ' 0 0';
                } else dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute('stroke-dasharray', dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS('feComponentTransfer');
        feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
        feComponentTransfer.setAttribute('result', id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS('feFuncR');
        feFuncR.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS('feFuncG');
        feFuncG.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS('feFuncB');
        feFuncB.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
            var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
            var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
            this.feFuncR.setAttribute('tableValues', tableR);
            this.feFuncG.setAttribute('tableValues', tableG);
            this.feFuncB.setAttribute('tableValues', tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS('feComponentTransfer'); // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
         // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
         // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
         // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS('feComponentTransfer');
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            feComponentTransfer.setAttribute('result', id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(' ');
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute('tableValues', val);
                this.feFuncGComposed.setAttribute('tableValues', val);
                this.feFuncBComposed.setAttribute('tableValues', val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute('tableValues', val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute('tableValues', val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute('tableValues', val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute('tableValues', val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute('x', filterSize.x || globalFilterSize.x);
        filter.setAttribute('y', filterSize.y || globalFilterSize.y);
        filter.setAttribute('width', filterSize.width || globalFilterSize.width);
        filter.setAttribute('height', filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
        feGaussianBlur.setAttribute('stdDeviation', '0');
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS('feOffset');
        feOffset.setAttribute('dx', '25');
        feOffset.setAttribute('dy', '0');
        feOffset.setAttribute('in', id + '_drop_shadow_1');
        feOffset.setAttribute('result', id + '_drop_shadow_2');
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS('feFlood');
        feFlood.setAttribute('flood-color', '#00ff00');
        feFlood.setAttribute('flood-opacity', '1');
        feFlood.setAttribute('result', id + '_drop_shadow_3');
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS('feComposite');
        feComposite.setAttribute('in', id + '_drop_shadow_3');
        feComposite.setAttribute('in2', id + '_drop_shadow_2');
        feComposite.setAttribute('operator', 'in');
        feComposite.setAttribute('result', id + '_drop_shadow_4');
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + '_drop_shadow_4',
            source
        ]);
        filter.appendChild(feMerge); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute('dx', x);
                this.feOffset.setAttribute('dy', y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS('g');
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS('use');
        useElem.setAttribute('href', '#' + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS('mask');
            masker.setAttribute('id', mask.layerId);
            masker.setAttribute('mask-type', 'alpha');
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS('symbol');
            symbol.setAttribute('id', symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS('use');
            useElem.setAttribute('href', '#' + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute('x', '-100%');
        filter.setAttribute('y', '-100%');
        filter.setAttribute('width', '300%');
        filter.setAttribute('height', '300%');
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('result', id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer('canvas', CanvasRenderer);
    registerRenderer('html', HybridRenderer);
    registerRenderer('svg', SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});


parcelRegister("bg5Lv", function(module, exports) {
module.exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":0,\"op\":120,\"w\":48,\"h\":48,\"nm\":\"rovo-glow-blobs\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"purple\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":3,\"s\":[1.2874993780736568],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[4.896948147169498],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":8,\"s\":[10.431107503111988],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":10,\"s\":[17.46759259259259],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":13,\"s\":[25.558390264173763],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":15,\"s\":[34.23115530061469],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":18,\"s\":[42.99217779477908],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":20,\"s\":[51.330839533235775],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":23,\"s\":[58.72531011667109],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":25,\"s\":[64.64917647038668],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":28,\"s\":[68.57865444133563],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":30,\"s\":[70],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":33,\"s\":[69.9550855222125],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":35,\"s\":[69.8211105880176],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":38,\"s\":[69.60036754568426],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":40,\"s\":[69.2966333698683],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":43,\"s\":[68.91510503652898],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":45,\"s\":[68.46231060122938],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":48,\"s\":[67.94599750229578],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":50,\"s\":[67.375],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":53,\"s\":[66.75908801991672],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":55,\"s\":[66.10879998678824],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":58,\"s\":[65.43526250915527],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":60,\"s\":[64.75],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":63,\"s\":[64.06473749084472],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":65,\"s\":[63.391200013211765],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":68,\"s\":[62.74091198008328],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":70,\"s\":[62.125],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":73,\"s\":[61.55400249770422],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":75,\"s\":[61.037689398770624],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":78,\"s\":[60.584894963471015],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":80,\"s\":[60.2033666301317],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":83,\"s\":[59.89963245431574],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":85,\"s\":[59.6788894119824],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":88,\"s\":[59.54491447778749],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":90,\"s\":[59.5],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":93,\"s\":[58.373313151256944],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":95,\"s\":[55.25823093702075],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":98,\"s\":[50.540314883328904],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":100,\"s\":[44.59508639269013],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":103,\"s\":[37.79543794596167],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":105,\"s\":[30.518844699385312],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":108,\"s\":[23.15399399508549],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":110,\"s\":[16.10648148148149],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":113,\"s\":[9.803267496888012],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":115,\"s\":[4.695644445423094],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":118,\"s\":[1.2605330293337578],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":120,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[18,21.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[19.044209537760413,20.67878402655563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[20.07055236082017,19.81173331571765],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[21.061467458920717,18.913683345540363],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[22,18],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[22.870091432069763,17.08631665445964],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[23.65685424949238,16.188266684282354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[24.34682672232988,15.321215973444373],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[24.928203230275507,14.500000000000002],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[25.391036260090296,13.738669996938956],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[25.727406610312546,13.050252531694168],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[25.931558890990484,12.446526617961354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[26,11.93782217350893],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[25.931558890990484,11.532843272420994],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[25.727406610312546,11.238519215976522],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[25.391036260090296,11.059885970383329],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[24.92820323027551,11],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[24.34682672232988,11.059885970383329],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[23.65685424949238,11.23851921597652],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[22.870091432069767,11.53284327242099],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[22,11.93782217350893],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[21.06146745892072,12.446526617961354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[20.07055236082017,13.050252531694166],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[19.044209537760413,13.738669996938954],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[18,14.499999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[16.955790462239587,15.321215973444374],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[15.929447639179838,16.18826668428235],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[14.938532541079285,17.086316654459637],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[14,18],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[13.129908567930237,18.91368334554036],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[12.34314575050762,19.811733315717643],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[11.65317327767012,20.678784026555626],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[11.071796769724491,21.499999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[10.608963739909708,22.26133000306104],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[10.272593389687454,22.94974746830583],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[10.068441109009516,23.553473382038646],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[10,24.06217782649107],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[10.068441109009516,24.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[10.272593389687453,24.761480784023476],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[10.608963739909708,24.940114029616673],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[11.071796769724491,25],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[11.65317327767012,24.940114029616673],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[12.34314575050762,24.76148078402348],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[13.129908567930231,24.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[13.999999999999996,24.062177826491073],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[14.938532541079276,23.55347338203865],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[15.929447639179834,22.949747468305834],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[16.955790462239587,22.261330003061047],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[18,21.5]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[100.65263096110029,100.65263096110029],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[101.2940952255126,101.2940952255126],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[101.91341716182544,101.91341716182544],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[102.5,102.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[103.0438071450436,103.0438071450436],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[103.53553390593274,103.53553390593274],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[103.96676670145617,103.96676670145617],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[104.3301270189222,104.3301270189222],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[104.61939766255644,104.61939766255644],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[104.82962913144532,104.82962913144532],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[104.95722430686904,104.95722430686904],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[105,105],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[104.95722430686904,104.95722430686904],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[104.82962913144532,104.82962913144532],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[104.61939766255644,104.61939766255644],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[104.3301270189222,104.3301270189222],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[103.96676670145617,103.96676670145617],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[103.53553390593274,103.53553390593274],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[103.0438071450436,103.0438071450436],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[102.5,102.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[101.91341716182544,101.91341716182544],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[101.2940952255126,101.2940952255126],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[100.65263096110029,100.65263096110029],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[99.34736903889974,99.34736903889974],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[98.7059047744874,98.7059047744874],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[98.08658283817456,98.08658283817456],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[97.5,97.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[96.9561928549564,96.9561928549564],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[96.46446609406726,96.46446609406726],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[96.03323329854383,96.03323329854383],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[95.6698729810778,95.6698729810778],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[95.38060233744356,95.38060233744356],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[95.17037086855466,95.17037086855466],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[95.04277569313096,95.04277569313096],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[95,95],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[95.04277569313096,95.04277569313096],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[95.17037086855466,95.17037086855466],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[95.38060233744356,95.38060233744356],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[95.6698729810778,95.6698729810778],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[96.03323329854383,96.03323329854383],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[96.46446609406726,96.46446609406726],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[96.95619285495638,96.95619285495638],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[97.5,97.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[98.08658283817456,98.08658283817456],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[98.7059047744874,98.7059047744874],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[99.34736903889974,99.34736903889974],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[100,100]}]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"nm\":\"g\",\"it\":[{\"ty\":\"el\",\"nm\":\"e\",\"p\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[30,30]}},{\"ty\":\"fl\",\"nm\":\"f\",\"c\":{\"a\":0,\"k\":[0.6588235294117647,0.3333333333333333,0.9686274509803922,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}]}],\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"v\":{\"a\":0,\"k\":24}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"v\":{\"a\":0,\"k\":1}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"v\":{\"a\":0,\"k\":0}}]}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"blue\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":3,\"s\":[1.291197294746325],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[4.876395025194881],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":8,\"s\":[10.305883134968807],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":10,\"s\":[17.11111111111111],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":13,\"s\":[24.810459398998983],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":15,\"s\":[32.91566642006545],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":18,\"s\":[40.9385495216629],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":20,\"s\":[48.39764870276516],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":23,\"s\":[54.82442731031012],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":25,\"s\":[59.76868385821613],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":28,\"s\":[62.80286296913591],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":30,\"s\":[63.525000000000006],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":33,\"s\":[62.9442829902072],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":35,\"s\":[62.33115427325748],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":38,\"s\":[61.69610465148926],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":40,\"s\":[61.05],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":43,\"s\":[60.40389534851075],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":45,\"s\":[59.768845726742526],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":48,\"s\":[59.15571700979281],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":50,\"s\":[58.57500000000001],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":53,\"s\":[58.03663092640684],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":55,\"s\":[57.54982143312659],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":58,\"s\":[57.12290096555839],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":60,\"s\":[56.76317425126703],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":63,\"s\":[56.476796314069134],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":65,\"s\":[56.26866715986911],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":68,\"s\":[56.14234793619964],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":70,\"s\":[56.10000000000001],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":73,\"s\":[56.14234793619964],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":75,\"s\":[56.26866715986911],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":78,\"s\":[56.476796314069134],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":80,\"s\":[56.76317425126703],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":83,\"s\":[57.12290096555839],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":85,\"s\":[57.54982143312659],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":88,\"s\":[58.03663092640684],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":90,\"s\":[58.575],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":93,\"s\":[57.99177350381308],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":95,\"s\":[55.341523821057905],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":98,\"s\":[50.96578670030595],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":100,\"s\":[45.22222222222221],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":103,\"s\":[38.48865787864898],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":105,\"s\":[31.16557713662874],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":108,\"s\":[23.676958300714503],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":110,\"s\":[16.469444444444456],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":113,\"s\":[10.009901417748932],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":115,\"s\":[4.78149470865729],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":118,\"s\":[1.2784845874832338],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":120,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[37,10],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[36.94011402961667,10.068441109009516],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[36.76148078402347,10.272593389687454],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[36.46715672757901,10.608963739909704],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[36.06217782649107,11.07179676972449],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[35.553473382038646,11.65317327767012],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[34.94974746830583,12.34314575050762],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[34.26133000306105,13.129908567930231],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[33.5,13.999999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[32.67878402655563,14.938532541079278],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[31.811733315717643,15.929447639179834],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[30.91368334554036,16.955790462239587],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[30,18],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[29.08631665445964,19.04420953776041],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[28.18826668428235,20.07055236082016],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[27.32121597344437,21.06146745892072],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[26.5,21.999999999999993],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[25.738669996938956,22.870091432069763],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[25.05025253169417,23.65685424949238],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[24.446526617961354,24.34682672232988],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[23.937822173508927,24.92820323027551],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[23.53284327242099,25.391036260090292],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[23.238519215976524,25.727406610312546],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[23.059885970383327,25.931558890990484],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[23,26],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[23.059885970383327,25.931558890990484],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[23.23851921597652,25.72740661031255],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[23.53284327242099,25.391036260090296],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[23.93782217350893,24.928203230275507],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[24.446526617961354,24.346826722329883],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[25.050252531694166,23.656854249492383],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[25.738669996938953,22.870091432069767],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[26.499999999999996,22.000000000000004],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[27.321215973444367,21.061467458920724],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[28.18826668428235,20.07055236082017],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[29.086316654459637,19.044209537760413],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[30,18.000000000000004],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[30.91368334554036,16.95579046223959],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[31.811733315717643,15.929447639179838],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[32.67878402655563,14.93853254107928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[33.5,13.999999999999991],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[34.26133000306105,13.129908567930237],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[34.94974746830583,12.343145750507627],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[35.553473382038646,11.65317327767012],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[36.062177826491066,11.07179676972449],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[36.46715672757901,10.608963739909708],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[36.76148078402347,10.272593389687454],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[36.94011402961667,10.068441109009518],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[37,10]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[106,106],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[105.94866916824286,105.94866916824286],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[105.7955549577344,105.7955549577344],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[105.54327719506772,105.54327719506772],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[105.19615242270665,105.19615242270665],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[104.7601200417474,104.7601200417474],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[104.24264068711928,104.24264068711928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[103.65256857405232,103.65256857405232],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[103,103],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[102.29610059419056,102.29610059419056],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[101.55291427061512,101.55291427061512],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[100.78315715332032,100.78315715332032],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[99.21684284667968,99.21684284667968],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[98.44708572938488,98.44708572938488],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[97.70389940580944,97.70389940580944],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[97,97],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[96.34743142594768,96.34743142594768],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[95.75735931288072,95.75735931288072],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[95.2398799582526,95.2398799582526],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[94.80384757729335,94.80384757729335],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[94.45672280493228,94.45672280493228],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[94.2044450422656,94.2044450422656],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[94.05133083175714,94.05133083175714],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[94,94],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[94.05133083175714,94.05133083175714],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[94.2044450422656,94.2044450422656],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[94.45672280493228,94.45672280493228],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[94.80384757729335,94.80384757729335],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[95.2398799582526,95.2398799582526],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[95.75735931288072,95.75735931288072],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[96.34743142594768,96.34743142594768],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[97,97],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[97.70389940580944,97.70389940580944],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[98.44708572938488,98.44708572938488],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[99.21684284667968,99.21684284667968],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[100.78315715332032,100.78315715332032],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[101.55291427061512,101.55291427061512],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[102.29610059419056,102.29610059419056],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[103,103],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[103.65256857405232,103.65256857405232],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[104.24264068711928,104.24264068711928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[104.7601200417474,104.7601200417474],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[105.19615242270665,105.19615242270665],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[105.5432771950677,105.5432771950677],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[105.7955549577344,105.7955549577344],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[105.94866916824286,105.94866916824286],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[106,106]}]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"nm\":\"g\",\"it\":[{\"ty\":\"el\",\"nm\":\"e\",\"p\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[26,26]}},{\"ty\":\"fl\",\"nm\":\"f\",\"c\":{\"a\":0,\"k\":[0.2196078431372549,0.7411764705882353,0.9725490196078432,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}]}],\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"v\":{\"a\":0,\"k\":24}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"v\":{\"a\":0,\"k\":1}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"v\":{\"a\":0,\"k\":0}}]}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"pink\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":3,\"s\":[1.219124671633796],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[4.580855932758827],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":8,\"s\":[9.632193722840231],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":10,\"s\":[15.91256025530309],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":13,\"s\":[22.960306985549924],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":15,\"s\":[30.319023266258725],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":18,\"s\":[37.54330926805094],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":20,\"s\":[44.2037037037037],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":23,\"s\":[49.89049702916991],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":25,\"s\":[54.2162116293766],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":28,\"s\":[56.816590201815146],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":30,\"s\":[57.35],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":33,\"s\":[56.74305320617676],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":35,\"s\":[56.14649144027328],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":38,\"s\":[55.570522039502336],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":40,\"s\":[55.025],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":43,\"s\":[54.51925935510945],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":45,\"s\":[54.06195346748256],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":48,\"s\":[53.66090696764576],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":50,\"s\":[53.322981872402366],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":53,\"s\":[53.05396017382253],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":55,\"s\":[52.85844490775583],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":58,\"s\":[52.73978139461178],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":60,\"s\":[52.7],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":63,\"s\":[52.73978139461178],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":65,\"s\":[52.85844490775583],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":68,\"s\":[53.05396017382253],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":70,\"s\":[53.322981872402366],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":73,\"s\":[53.66090696764576],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":75,\"s\":[54.06195346748256],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":78,\"s\":[54.51925935510945],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":80,\"s\":[55.025],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":83,\"s\":[55.570522039502336],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":85,\"s\":[56.14649144027328],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":88,\"s\":[56.74305320617676],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":90,\"s\":[57.35],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":93,\"s\":[56.81659020181513],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":95,\"s\":[54.2162116293766],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":98,\"s\":[49.89049702916991],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":100,\"s\":[44.20370370370369],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":103,\"s\":[37.54330926805095],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":105,\"s\":[30.319023266258725],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":108,\"s\":[22.96030698554991],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":110,\"s\":[15.912560255303102],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":113,\"s\":[9.632193722840231],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":115,\"s\":[4.580855932758827],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":118,\"s\":[1.2191246716338031],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":120,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[22,30],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[20.95579046223959,29.08631665445964],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[19.92944763917983,28.18826668428235],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[18.938532541079283,27.32121597344437],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[18.000000000000004,26.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[17.129908567930237,25.738669996938956],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[16.34314575050762,25.05025253169417],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[15.65317327767012,24.446526617961354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[15.071796769724491,23.93782217350893],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[14.608963739909708,23.53284327242099],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[14.272593389687454,23.238519215976524],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[14.068441109009516,23.059885970383327],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[14,23],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[14.068441109009516,23.059885970383327],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[14.272593389687453,23.238519215976524],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[14.608963739909708,23.53284327242099],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[15.071796769724488,23.937822173508927],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[15.65317327767012,24.446526617961354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[16.343145750507617,25.050252531694166],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[17.129908567930233,25.738669996938953],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[18.000000000000004,26.500000000000004],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[18.938532541079276,27.321215973444367],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[19.92944763917983,28.18826668428235],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[20.955790462239587,29.086316654459637],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[21.999999999999996,30],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[23.044209537760416,30.913683345540363],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[24.07055236082016,31.811733315717643],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[25.06146745892072,32.67878402655563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[26,33.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[26.870091432069763,34.26133000306105],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[27.65685424949238,34.94974746830583],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[28.34682672232988,35.553473382038646],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[28.928203230275507,36.062177826491066],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[29.391036260090292,36.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[29.727406610312546,36.76148078402347],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[29.931558890990484,36.94011402961667],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[30,37],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[29.931558890990484,36.94011402961667],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[29.72740661031255,36.76148078402347],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[29.391036260090296,36.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[28.928203230275507,36.06217782649107],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[28.346826722329883,35.553473382038646],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[27.656854249492387,34.94974746830583],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[26.870091432069767,34.26133000306105],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[26,33.50000000000001],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[25.061467458920724,32.67878402655563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[24.07055236082017,31.81173331571765],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[23.044209537760423,30.913683345540363],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[22,30]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[99.08631665445964,99.08631665445964],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[98.18826668428235,98.18826668428235],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[97.32121597344438,97.32121597344438],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[96.5,96.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[95.73866999693897,95.73866999693897],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[95.05025253169416,95.05025253169416],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[94.44652661796135,94.44652661796135],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[93.93782217350892,93.93782217350892],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[93.532843272421,93.532843272421],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[93.23851921597652,93.23851921597652],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[93.05988597038332,93.05988597038332],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[93,93],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[93.05988597038332,93.05988597038332],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[93.23851921597652,93.23851921597652],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[93.532843272421,93.532843272421],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[93.93782217350892,93.93782217350892],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[94.44652661796135,94.44652661796135],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[95.05025253169416,95.05025253169416],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[95.73866999693897,95.73866999693897],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[96.5,96.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[97.32121597344435,97.32121597344435],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[98.18826668428235,98.18826668428235],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[99.08631665445964,99.08631665445964],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[100.91368334554036,100.91368334554036],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[101.81173331571765,101.81173331571765],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[102.67878402655565,102.67878402655565],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[103.5,103.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[104.26133000306103,104.26133000306103],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[104.94974746830584,104.94974746830584],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[105.55347338203865,105.55347338203865],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[106.06217782649108,106.06217782649108],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[106.467156727579,106.467156727579],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[106.76148078402348,106.76148078402348],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[106.94011402961668,106.94011402961668],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[107,107],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[106.94011402961668,106.94011402961668],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[106.76148078402348,106.76148078402348],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[106.467156727579,106.467156727579],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[106.06217782649108,106.06217782649108],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[105.55347338203865,105.55347338203865],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[104.94974746830584,104.94974746830584],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[104.26133000306103,104.26133000306103],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[103.5,103.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[102.67878402655565,102.67878402655565],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[101.81173331571765,101.81173331571765],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[100.91368334554036,100.91368334554036],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[100,100]}]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"nm\":\"g\",\"it\":[{\"ty\":\"el\",\"nm\":\"e\",\"p\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[22,22]}},{\"ty\":\"fl\",\"nm\":\"f\",\"c\":{\"a\":0,\"k\":[0.9568627450980391,0.4470588235294118,0.7137254901960784,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}]}],\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"v\":{\"a\":0,\"k\":22}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"v\":{\"a\":0,\"k\":1}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"v\":{\"a\":0,\"k\":0}}]}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"yellow\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":3,\"s\":[1.1176984198337483],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[4.17685508896791],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":8,\"s\":[8.73794824320537],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":10,\"s\":[14.367967806728076],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":13,\"s\":[20.645574876823115],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":15,\"s\":[27.165244961462506],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":18,\"s\":[33.54019187714127],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":20,\"s\":[39.40392680354496],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":23,\"s\":[44.41037006297262],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":25,\"s\":[48.23249946247958],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":28,\"s\":[50.559586117779496],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":30,\"s\":[51.09313415252774],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":33,\"s\":[50.65565759573217],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":35,\"s\":[50.26941506766217],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":38,\"s\":[49.9410152850597],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":40,\"s\":[49.67607725925468],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":43,\"s\":[49.47913415332336],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":45,\"s\":[49.35355571841115],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":48,\"s\":[49.30149063635633],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":50,\"s\":[49.32382975514801],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":53,\"s\":[49.42019084627011],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":55,\"s\":[49.588925144737175],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":58,\"s\":[49.82714555992045],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":60,\"s\":[50.130776074468976],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":63,\"s\":[50.49462148609655],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":65,\"s\":[50.91245629893321],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":68,\"s\":[51.37713124348562],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":70,\"s\":[51.880695602620264],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":73,\"s\":[52.41453325053794],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":75,\"s\":[52.969510077075],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":78,\"s\":[53.53613027486075],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":80,\"s\":[54.10469881521429],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":83,\"s\":[54.665487332773175],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":85,\"s\":[55.20890058052205],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":88,\"s\":[55.72564060712929],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":90,\"s\":[56.20686584747225],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":93,\"s\":[55.52981251899867],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":95,\"s\":[52.80609715957206],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":98,\"s\":[48.39664335323088],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":100,\"s\":[42.68438721536689],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":103,\"s\":[36.07111885573926],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":105,\"s\":[28.973222140794423],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":108,\"s\":[21.816568915722435],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":110,\"s\":[15.03085895236904],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":113,\"s\":[9.043720180270295],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":115,\"s\":[4.274894433723172],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":118,\"s\":[1.1308316267145349],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":120,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[27.535533905932738,20.464466094067262],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[27.966766701456176,20.956192854956395],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[28.33012701892219,21.499999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[28.61939766255643,22.08658283817455],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[28.82962913144534,22.705904774487397],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[28.95722430686905,23.347369038899743],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[29,24],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[28.95722430686905,24.652630961100257],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[28.82962913144534,25.294095225512603],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[28.61939766255643,25.91341716182545],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[28.33012701892219,26.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[27.966766701456176,27.0438071450436],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[27.535533905932738,27.535533905932738],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[27.043807145043605,27.966766701456173],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[26.5,28.330127018922195],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[25.91341716182545,28.61939766255643],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[25.294095225512606,28.82962913144534],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[24.652630961100257,28.95722430686905],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[24,29],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[23.347369038899743,28.95722430686905],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[22.705904774487397,28.829629131445344],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[22.08658283817455,28.61939766255643],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[21.5,28.330127018922195],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[20.9561928549564,27.966766701456176],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[20.464466094067262,27.535533905932738],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[20.033233298543827,27.043807145043605],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[19.66987298107781,26.500000000000004],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[19.38060233744357,25.913417161825453],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[19.17037086855466,25.294095225512603],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[19.04277569313095,24.652630961100265],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[19,24],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[19.04277569313095,23.347369038899743],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[19.170370868554656,22.7059047744874],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[19.38060233744357,22.08658283817455],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[19.66987298107781,21.499999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[20.033233298543824,20.9561928549564],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[20.464466094067262,20.464466094067262],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[20.956192854956395,20.033233298543827],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[21.499999999999996,19.669872981077805],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[22.086582838174554,19.380602337443563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[22.705904774487397,19.17037086855466],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[23.347369038899743,19.04277569313095],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[24,19],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[24.652630961100257,19.04277569313095],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[25.294095225512603,19.170370868554656],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[25.913417161825446,19.380602337443563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[26.5,19.669872981077805],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[27.0438071450436,20.033233298543824],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[27.535533905932738,20.464466094067262]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[105.65685424949238,105.65685424949238],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[106.3468267223299,106.3468267223299],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[106.9282032302755,106.9282032302755],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[107.3910362600903,107.3910362600903],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[107.72740661031254,107.72740661031254],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[107.93155889099047,107.93155889099047],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[108,108],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[107.93155889099047,107.93155889099047],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[107.72740661031254,107.72740661031254],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[107.3910362600903,107.3910362600903],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[106.9282032302755,106.9282032302755],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[106.3468267223299,106.3468267223299],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[105.65685424949238,105.65685424949238],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[104.87009143206976,104.87009143206976],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[104,104],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[103.0614674589207,103.0614674589207],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[102.07055236082016,102.07055236082016],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[101.0442095377604,101.0442095377604],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[98.9557904622396,98.9557904622396],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[97.92944763917984,97.92944763917984],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[96.93853254107928,96.93853254107928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[96,96],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[95.12990856793024,95.12990856793024],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[94.34314575050762,94.34314575050762],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[93.65317327767012,93.65317327767012],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[93.07179676972449,93.07179676972449],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[92.60896373990973,92.60896373990973],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[92.27259338968746,92.27259338968746],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[92.06844110900953,92.06844110900953],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[92,92],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[92.06844110900953,92.06844110900953],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[92.27259338968746,92.27259338968746],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[92.6089637399097,92.6089637399097],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[93.07179676972449,93.07179676972449],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[93.65317327767012,93.65317327767012],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[94.34314575050762,94.34314575050762],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[95.12990856793024,95.12990856793024],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[96,96],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[96.93853254107928,96.93853254107928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[97.92944763917984,97.92944763917984],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[98.9557904622396,98.9557904622396],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[101.0442095377604,101.0442095377604],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[102.07055236082016,102.07055236082016],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[103.0614674589207,103.0614674589207],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[104,104],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[104.87009143206976,104.87009143206976],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[105.65685424949238,105.65685424949238]}]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"nm\":\"g\",\"it\":[{\"ty\":\"el\",\"nm\":\"e\",\"p\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[18,18]}},{\"ty\":\"fl\",\"nm\":\"f\",\"c\":{\"a\":0,\"k\":[0.9803921568627452,0.8,0.08235294117647059,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}]}],\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"v\":{\"a\":0,\"k\":16}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"v\":{\"a\":0,\"k\":1}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"v\":{\"a\":0,\"k\":0}}]}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0}],\"meta\":{\"g\":\"replit\",\"a\":\"rovo\",\"k\":\"glow,liquid,blobs\",\"d\":\"Liquid glow blobs, fade in/out\"}}");

});


parcelRegister("f8Ffp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1wKSV").then(()=>parcelRequire('5Gtph'));

});


parcelRegister("g8OYC", function(module, exports) {
$parcel$export(module.exports, "selectionCountsInMainEditor", () => $f841b519779cbb65$export$f18468c773f95821);
function $f841b519779cbb65$var$safeIsPointInRange(range, node, offset) {
    try {
        return range.isPointInRange(node, offset);
    } catch  {
        // some node types can throw, treat as "outside"
        return false;
    }
}
function $f841b519779cbb65$var$fullyInside(r, container) {
    return $f841b519779cbb65$var$safeIsPointInRange(container, r.startContainer, r.startOffset) && $f841b519779cbb65$var$safeIsPointInRange(container, r.endContainer, r.endOffset);
}
/**
 * Find the "main" ProseMirror for a given sidebar container:
 * Walk up from the sidebar to the nearest .ak-editor-content-area. Return its direct
 * child .ProseMirror (even if other editors exist deeper in the subtree).
 */ function $f841b519779cbb65$var$getMainProseMirrorForSidebar(sidebar) {
    const sidebarEl = typeof sidebar === 'string' && typeof document !== 'undefined' ? document.querySelector(sidebar) : sidebar;
    if (!sidebarEl) return null;
    const contentArea = sidebarEl.closest('.ak-editor-content-area');
    if (!contentArea) return null;
    for (const child of Array.from(contentArea.children)){
        if (child instanceof HTMLElement && child.classList.contains('ProseMirror')) return child;
    }
    return null;
}
function $f841b519779cbb65$var$countWords(text) {
    const t = text.trim();
    if (!t) return 0;
    try {
        const Segmenter = Intl?.Segmenter;
        if (Segmenter) {
            const seg = new Segmenter(undefined, {
                granularity: 'word'
            });
            let c = 0;
            for (const { isWordLike: isWordLike } of seg.segment(t))if (isWordLike) c++;
            return c;
        }
    } catch  {}
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return t.split(/\s+/u).filter(Boolean).length;
}
function $f841b519779cbb65$export$f18468c773f95821(sidebar) {
    try {
        const editor = $f841b519779cbb65$var$getMainProseMirrorForSidebar(sidebar);
        if (!editor) return null;
        const doc = editor.ownerDocument ?? (typeof document !== 'undefined' ? document : null);
        if (!doc) return null;
        const sel = doc.getSelection?.();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null;
        // range covering just the editor's contents to test containment
        const container = doc.createRange();
        container.selectNodeContents(editor);
        // snapshot rangeCount up-front to avoid races if selection changes
        const rangeCount = sel.rangeCount;
        // require every selection range to be fully inside
        let text = '';
        for(let i = 0; i < rangeCount; i++){
            const r = sel.getRangeAt(i);
            if (!$f841b519779cbb65$var$fullyInside(r, container)) return null;
            const part = r.toString();
            text += text ? `\n${part}` : part;
        }
        return {
            text: text,
            words: $f841b519779cbb65$var$countWords(text),
            chars: text.length
        };
    } catch (err) {
        return null;
    }
}

});



parcelRegister("lnBYw", function(module, exports) {
$parcel$export(module.exports, "useIsGlobalRovoButtonAvailableForRoute", () => $885950430a61a456$export$41d029260a414439);

var $f2wVS = parcelRequire("f2wVS");

var $2700E = parcelRequire("2700E");
/*
 * Controls whether specific route groups can see the Rovo button.
 * Consult with the team in #global-rovo-button-roll-out in Slack if you have any questions.
 *
 * Add your routes groups here to control it using an experiment, feature gate, or static false value
 * Returning false will disable the Rovo button for the route group
 */ const $885950430a61a456$var$blacklistedJiraRouteGroups = {
    polaris: ()=>false,
    servicedesk: ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'project-settings-servicedesk': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'customer-service': ()=>false,
    'helpcenter-settings': ()=>false
};
/*
 * Controls whether specific routes can see the Rovo button.
 * Consult with the team in #global-rovo-button-roll-out in Slack if you have any questions.
 *
 * Add your routes here to control it using an experiment, feature gate, or static false value
 * Returning false will disable the Rovo button for the route
 */ const $885950430a61a456$var$blacklistedJiraRoutes = {
    // 2/3p experiences
    'connect-general': ()=>false,
    'forge-spa-global': ()=>false,
    // JSM (additional routes not associated with servicedesk route group)
    'servicedesk-archived-work-items': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'jsm-list-nin': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'servicedesk-issues': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    'forge-spa-servicedesk-queue': ()=>(0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false),
    // CSM help center (additional routes not associated with helpcenter-settings route group)
    'helpcenter-settings-customer-access': ()=>false
};
const $885950430a61a456$export$41d029260a414439 = (0, $f2wVS.createRouterSelector)((state)=>{
    const routeName = state.route.name;
    const routeGroup = state.route.group;
    // Group-level blacklisting takes precedence
    if (routeGroup && $885950430a61a456$var$blacklistedJiraRouteGroups[routeGroup]) return $885950430a61a456$var$blacklistedJiraRouteGroups[routeGroup]() ?? false;
    // Exclude embedded routes
    if (routeName.endsWith('-embed')) return false;
    // Exclude individual blacklisted routes
    if ($885950430a61a456$var$blacklistedJiraRoutes[routeName]) return $885950430a61a456$var$blacklistedJiraRoutes[routeName]() ?? false;
    return true;
});

});

parcelRegister("jz6Si", function(module, exports) {
$parcel$export(module.exports, "useShouldShowRovoButton", () => $e75de09808cbec2f$export$55826ddfbfb8d684);

var $7tjnB = parcelRequire("7tjnB");

var $6bGyp = parcelRequire("6bGyp");

var $eaLDc = parcelRequire("eaLDc");

var $1KydW = parcelRequire("1KydW");

var $2b39L = parcelRequire("2b39L");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");
const $e75de09808cbec2f$export$55826ddfbfb8d684 = ()=>{
    const { data: rovoEntitlementData } = (0, $6bGyp.useRovoEntitlementResource)();
    const isRovoLLMEnabled = rovoEntitlementData?.isRovoLLMEnabled ?? false;
    const licenseState = (0, $eaLDc.useLicenseStates)();
    const { hasSoftwareAccess: hasSoftwareAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess, hasServiceDeskAccess: hasServiceDeskAccess } = (0, $1KydW.useApplicationPermissions)();
    const { data: projectContextData } = (0, $2b39L.useProjectContext)();
    const projectType = projectContextData?.projectType;
    const softwareAccessEnabled = licenseState.software === (0, $7tjnB.LICENSE_STATE_ACTIVE) && hasSoftwareAccess;
    const isProductDiscoveryEnabled = licenseState.productDiscovery === (0, $7tjnB.LICENSE_STATE_ACTIVE) && hasProductDiscoveryAccess;
    const isServiceDeskEnabled = licenseState.serviceDesk === (0, $7tjnB.LICENSE_STATE_ACTIVE) && hasServiceDeskAccess && (0, $i860n.fg)('jsm_asap_ai_rovo_button');
    if (!isRovoLLMEnabled || ((0, $i860n.fg)('jpd-aifc-streaming') ? !softwareAccessEnabled && !isProductDiscoveryEnabled && !isServiceDeskEnabled : !softwareAccessEnabled)) return false;
    // Exclude service desk, customer service, and product discovery project pages
    if ((0, $2700E.expVal)('jira_free_gen_editor', 'isEnabled', false)) return !((0, $i860n.fg)('jpd-aifc-streaming') ? projectType === 'customer_service' : projectType === 'customer_service' || projectType === 'product_discovery');
    if (projectType === 'customer_service' || projectType === 'product_discovery' && !(0, $i860n.fg)('jpd-aifc-streaming')) return false;
    return true;
};

});



parcelRegister("39CDX", function(module, exports) {
$parcel$export(module.exports, "GlobalBottomRightCornerContainer", () => $f1b29e7438dab36d$export$715c8d5890c054bb);
$parcel$export(module.exports, "BottomRightInlineItem", () => $f1b29e7438dab36d$export$7ba175363df0bea9);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $cCE2Z = parcelRequire("cCE2Z");

var $ihEDU = parcelRequire("ihEDU");

var $gDdYI = parcelRequire("gDdYI");

var $5IRCU = parcelRequire("5IRCU");

var $i860n = parcelRequire("i860n");

var $lB9M9 = parcelRequire("lB9M9");

var $jgjw0 = parcelRequire("jgjw0");

var $29eRG = parcelRequire("29eRG");

var $7Sa0x = parcelRequire("7Sa0x");
function $f1b29e7438dab36d$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset, children: children }) {
    const [{ width: width }] = (0, $7Sa0x.useDetailPanelWidth)();
    const rightSidebar = (0, $29eRG.useActiveRightSidebarState)();
    const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $jgjw0.useBottomRightCornerActions)();
    const { state: panelState } = (0, $lB9M9.usePanelManager)();
    // Currently the ADS panel has a fixed width, but this will be updated to be dynamic
    const adsPanelWidth = 364;
    const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
    const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
    const rightSidebarOffset = isSidebarOpen ? rightSidebarWidth : 0;
    let distanceFromRightSidebar = width + rightOffset + rightSidebarOffset;
    /**
   * Preview panel also opens inside RightPanel and is resizable. And it has default width of 400px,
   * which is more than width of RightSidebar (386px)
   */ // Preview panel takes precedence over sidebar when open
    if ((0, $i860n.fg)('jira-glance-panel')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const panel = (0, $5IRCU.useCurrentPreviewPanel)();
        if (panel) distanceFromRightSidebar = panel.width + rightOffset;
    }
    if ((0, $i860n.fg)('ads-panel-system-jira-admin')) {
        if (panelState.activePanels.length) distanceFromRightSidebar = adsPanelWidth + rightOffset;
    }
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f1b29e7438dab36d$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${distanceFromRightSidebar}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f1b29e7438dab36d$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${distanceFromRightSidebar}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    });
}
$f1b29e7438dab36d$export$e112b78171de7a6.displayName = "ContainerWithRef";
const $f1b29e7438dab36d$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "bottom-right-corner-container",
        packageName: "jira-bottom-right-corner-controller"
    }, children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f1b29e7438dab36d$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f1b29e7438dab36d$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }));
$f1b29e7438dab36d$export$715c8d5890c054bb.displayName = "GlobalBottomRightCornerContainer";
const $f1b29e7438dab36d$export$1e86e3484191597c = ({ children: children })=>{
    const container = (0, $jgjw0.useBottomRightCornerContainer)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "global-bottom-right-corner"
    }, container && children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f1b29e7438dab36d$export$715c8d5890c054bb, null));
};
$f1b29e7438dab36d$export$1e86e3484191597c.displayName = "GlobalBottomRightCornerContainerProvider";
const $f1b29e7438dab36d$export$7ba175363df0bea9 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $f1b29e7438dab36d$var$styles.inlineInteractiveChild
    }, children);
};
$f1b29e7438dab36d$export$7ba175363df0bea9.displayName = "BottomRightInlineItem";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1b29e7438dab36d$var$StyledContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1reoewfl _18m9ewfl _kqsw1n9t _1e0c1txw _1pbyfjpv _4cvresu3 _lcxvglyw",
            __cmplp.className
        ])
    });
});
$f1b29e7438dab36d$var$StyledContainer.displayName = 'StyledContainer';
const $f1b29e7438dab36d$var$styles = {
    inlineInteractiveChild: "_lcxv1wug _18u0pxbi"
};

});
parcelRegister("jgjw0", function(module, exports) {
$parcel$export(module.exports, "useBottomRightCornerContainer", () => $38d2520faefd8483$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $38d2520faefd8483$export$de496fd0e0151c81);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $7Sa0x = parcelRequire("7Sa0x");
const $38d2520faefd8483$export$84542488b6b6c309 = (0, $3h1FP.createStateHook)((0, $7Sa0x.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $38d2520faefd8483$export$de496fd0e0151c81 = (0, $3h1FP.createActionsHook)((0, $7Sa0x.layoutStore));

});



parcelRegister("jbw5i", function(module, exports) {
$parcel$export(module.exports, "JiraPageContainerFallback", () => $10bc445f28c549e4$export$cf05adf51ba99ce2);

var $euxye = parcelRequire("euxye");

var $2XXtG = parcelRequire("2XXtG");

var $ihEDU = parcelRequire("ihEDU");

var $8Sdzy = parcelRequire("8Sdzy");

var $2D2gW = parcelRequire("2D2gW");

var $eprc4 = parcelRequire("eprc4");

var $k5P9q = parcelRequire("k5P9q");
const $10bc445f28c549e4$export$cf05adf51ba99ce2 = (props)=>{
    const isNotProd = (0, $k5P9q.useIsStagingOrDevOrLocal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "jira-spa"
    }), isNotProd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        padding: "space.1000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.JiraIcon), {
        label: "Loading Jira...",
        testId: "page-container-v2.common.ui.page-container.placeholder"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("samp", null, "(This logo and message only appears in non-production instances)")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("samp", null, "The Jira page container suspended. This should not happen normally; something likely went wrong prefetching the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("kbd", null, "JiraSpaPageContainer"), " query. Current reason for rendering this placeholder is: ", props.reason || 'unknown')))));
};
$10bc445f28c549e4$export$cf05adf51ba99ce2.displayName = "JiraPageContainerFallback";

});

parcelRegister("fO9BM", function(module, exports) {


module.exports = (parcelRequire("gZgW8"))('navx-global-side-nav', function() {
    return parcelRequire('5HvxH');
}, function() {
    return parcelRequire('4giVI');
}, {
    l: (parcelRequire("7BmPo")),
    i: [
        "7FBcr",
        "4Smn9",
        "hc93Z",
        "54wGu",
        "4Smn9",
        "hc93Z"
    ]
});

});



parcelRegister("3cRSz", function(module, exports) {
$parcel$export(module.exports, "JiraSpaPageContainerOld", () => $382d6db5065d3021$export$b6d2acf82fe12b99);
/* JiraSpaPageContainerOld.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $l7jID = parcelRequire("l7jID");

var $kb8yj = parcelRequire("kb8yj");

var $gsEo7 = parcelRequire("gsEo7");

var $dFT3J = parcelRequire("dFT3J");

var $hIRki = parcelRequire("hIRki");

var $h8QGu = parcelRequire("h8QGu");

var $eChBu = parcelRequire("eChBu");

var $bGess = parcelRequire("bGess");

var $gDdYI = parcelRequire("gDdYI");

var $dQkkK = parcelRequire("dQkkK");

var $9XO6I = parcelRequire("9XO6I");

var $5NkRe = parcelRequire("5NkRe");

var $cJ4JH = parcelRequire("cJ4JH");

var $lnVHd = parcelRequire("lnVHd");

var $6MMSf = parcelRequire("6MMSf");


var $aZMdt = parcelRequire("aZMdt");

var $ePtEH = parcelRequire("ePtEH");

var $57TEW = parcelRequire("57TEW");

var $iLktG = parcelRequire("iLktG");

var $i860n = parcelRequire("i860n");

var $jepRN = parcelRequire("jepRN");

var $f2wVS = parcelRequire("f2wVS");

var $eaylF = parcelRequire("eaylF");

var $esaVU = parcelRequire("esaVU");

var $jxXMl = parcelRequire("jxXMl");

var $c2hVV = parcelRequire("c2hVV");

var $euJ2W = parcelRequire("euJ2W");

var $4Rqt0 = parcelRequire("4Rqt0");

var $juoEc = parcelRequire("juoEc");

var $1JfCO = parcelRequire("1JfCO");

var $5snaZ = parcelRequire("5snaZ");

var $tEZUz = parcelRequire("tEZUz");

var $72Dhb = parcelRequire("72Dhb");

var $hR4Oj = parcelRequire("hR4Oj");

var $cbY0l = parcelRequire("cbY0l");

var $bTil3 = parcelRequire("bTil3");

var $bMM3e = parcelRequire("bMM3e");

var $gboyS = parcelRequire("gboyS");


const $382d6db5065d3021$var$SidebarEntry = (parcelRequire("fO9BM")).default;
const $382d6db5065d3021$var$MaybeUFOSegment = (0, $jepRN.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "page-container-v2-main-wrapper"
    }, children), (0, $euxye.Fragment));
const $382d6db5065d3021$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themed: "_11q3ne5i"
};
/**
 * These test IDs are used in pollinator tests. Do not change lightly.
 */ const $382d6db5065d3021$var$ROOT_TEST_ID = 'page-layout.root';
const $382d6db5065d3021$var$MAIN_TEST_ID = 'page-layout.main';
const $382d6db5065d3021$var$DefaultLayout = ({ children: children })=>{
    const [isChromeless] = (0, $9XO6I.useIsChromeless)();
    const [isFullscreen] = (0, $5NkRe.useIsFullscreen)();
    const showBanner = !isChromeless && !isFullscreen && (!(0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') || !(0, $i860n.fg)('jpx-870-stable-ui-for-criterion'));
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen && (!(0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') || !(0, $i860n.fg)('jpx-870-stable-ui-for-criterion'));
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hR4Oj.JiraPageLayout), {
        testId: $382d6db5065d3021$var$ROOT_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lnVHd.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c2hVV.IntegrationsWhichRequireNavigationRoot), null)), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4Rqt0.Banner), null)), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kb8yj.TopNavEntry), null))), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($382d6db5065d3021$var$SidebarEntry, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($382d6db5065d3021$var$MainWrapper, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gsEo7.HorizontalNavEntry), null), children), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5snaZ.RightSidebar), null)), (0, $i860n.fg)('ads-panel-system-jira-admin') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "dst-panel",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72Dhb.RightAdsPanel), null)), (0, $i860n.fg)('jira-glance-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        fallback: "unmount",
        id: "preview-panel",
        packageName: "jiraPageContainerV2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $euJ2W.PreviewPanel), null)), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cJ4JH.LayoutRemoteStateUpdater), null)));
};
$382d6db5065d3021$var$DefaultLayout.displayName = "DefaultLayout";
function $382d6db5065d3021$var$MainWrapper(props) {
    const { hasTheming: hasTheming } = (0, $ePtEH.useProjectTheme)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $eChBu.useJsmGracePeriodBanner)();
    const currentRoute = $382d6db5065d3021$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $eaylF.isSystemNavPath)(currentRoute.path) || (0, $esaVU.isIssuesNavPath)(currentRoute.path);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.Main), {
        testId: $382d6db5065d3021$var$MAIN_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($382d6db5065d3021$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "data-vc": "page-container-v2-main-wrapper",
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: hasTheming ? {
            // must be an inline style due to firefox bug with blob URLs: see https://atlassian.slack.com/archives/C02785CLSTW/p1770156142296829
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            background: (0, $dFT3J.Tokens).ELEVATION_SURFACE
        } : undefined,
        className: (0, $4jQY2.default)([
            $382d6db5065d3021$var$mainWrapperStyles.root,
            hasTheming && $382d6db5065d3021$var$mainWrapperStyles.themed
        ])
    }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bGess.JSMGracePeriodBannerAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jxXMl.JiraTopBannerPlacement), null), props.children)));
}
$382d6db5065d3021$var$MainWrapper.displayName = "MainWrapper";
const $382d6db5065d3021$var$useRouterRoute = (0, $f2wVS.createRouterSelector)((state)=>state.route);
const $382d6db5065d3021$var$Layout = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $382d6db5065d3021$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($382d6db5065d3021$var$DefaultLayout, props);
};
$382d6db5065d3021$var$Layout.displayName = "Layout";
const $382d6db5065d3021$export$b6d2acf82fe12b99 = (props)=>{
    const { id: id, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent } = props;
    const pageContainerPerformanceTiming = (0, $euxye.useCallback)(()=>{
        (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)((0, $e6ec049ffa8f915a$export$898b6208220685b0), (0, $e6ec049ffa8f915a$export$e2bc63118050de32), (0, $e6ec049ffa8f915a$export$59f83d43fe209319), true, false);
    }, []);
    const layout = (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') ? (0, $57TEW.getSharedLayout)() : (0, $57TEW.sharedLayout);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1JfCO.GlobalContainers), {
        id: id,
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $tEZUz.RedirectEntrypointContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cbY0l.GlobalThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: (0, $e6ec049ffa8f915a$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceType: (0, $46f069e6c968f461$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bTil3.ProjectThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($382d6db5065d3021$var$Layout, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $juoEc.GlobalComponents), {
        sharedGlobalComponents: layout.globalComponents
    }), (0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gboyS.JiraSpaGlobalBottomRightCorner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bMM3e.PageContainerSuccessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l7jID.HydrationStatsReporter), null))));
};
$382d6db5065d3021$export$b6d2acf82fe12b99.displayName = "JiraSpaPageContainerOld";

});
parcelRegister("4Rqt0", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $ecd63a1d879eb9bf$export$3b4e64e77073e307);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $i2Xs4 = parcelRequire("i2Xs4");
function $ecd63a1d879eb9bf$export$3b4e64e77073e307() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $i2Xs4.Banner), null);
}
$ecd63a1d879eb9bf$export$3b4e64e77073e307.displayName = "Banner";

});
parcelRegister("i2Xs4", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $b6a9f926952bc82a$export$3b4e64e77073e307);
/* main.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");


var $8FgPK = parcelRequire("8FgPK");

var $i860n = parcelRequire("i860n");


var $8ijR4 = parcelRequire("8ijR4");

var $6MMSf = parcelRequire("6MMSf");

var $fEfLP = parcelRequire("fEfLP");


var $hzoSY = parcelRequire("hzoSY");


var $lwMyB = parcelRequire("lwMyB");


var $2e9Ky = parcelRequire("2e9Ky");

var $dPucF = parcelRequire("dPucF");

var $dgeAW = parcelRequire("dgeAW");

var $gDdYI = parcelRequire("gDdYI");


var $eG4LB = parcelRequire("eG4LB");

var $blU2f = parcelRequire("blU2f");

/**
 * This ID is used in pollinator tests and by JPD. Do not change lightly.
 */ const $b6a9f926952bc82a$var$BANNER_ID = 'page-layout.banner';
const $b6a9f926952bc82a$export$3b4e64e77073e307 = ()=>{
    const banner = (0, $fEfLP.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6MMSf.Banner), {
        height: banner.height,
        testId: $b6a9f926952bc82a$var$BANNER_ID,
        id: $b6a9f926952bc82a$var$BANNER_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b6a9f926952bc82a$var$BannerContent, {
        bannerName: banner.name
    }))) : null;
};
$b6a9f926952bc82a$export$3b4e64e77073e307.displayName = "Banner";
/*
 * ALL COMPONENTS MUST BE PACKAGES THAT ARE LOCATED IN:
 * jira/src/packages/platform/ui/banners
 *
 * Create new packages in this workspace. There is a ratchet rule that depends on this.
 *
 * Please make sure that entryFsSsrLiftImportToModule is set to true for any async banners
 */ const $b6a9f926952bc82a$var$BannerContent = ({ bannerName: bannerName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, bannerName === (0, $019eb0ef26b17dd6$export$3c5e605ca7ade9f2) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzoSY.BannerAnnouncementAsync), null), bannerName === (0, $3869667d2322ccce$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8ijR4.IPBlocklistingBannerAsync), null), bannerName === (0, $dPucF.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dgeAW.ReturnToMobileBanner), null), bannerName === (0, $d71e39b6af21097e$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8FgPK.CookieConsentBannerAsync), null), bannerName === (0, $6afe4b018443206a$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lwMyB.BannerTransitionAsync), null), bannerName === (0, $e6f7a78aa9b2d70b$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2e9Ky.MailExpiryBannerAsync), null), bannerName === (0, $0573d7bb0155dab9$export$41956b146268af93) && (0, $i860n.fg)('jpd-view-templates-feedback-banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eG4LB.AsyncJpdBlueprintsFeedbackBanner), null), bannerName === (0, $ccb97c5e77224008$export$7b746a9f691e0529) && (0, $i860n.fg)('eoc_consolidation_cohort_3_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $blU2f.Cohort3BannerAsync), null));
$b6a9f926952bc82a$var$BannerContent.displayName = "BannerContent";

});




parcelRegister("8SFjS", function(module, exports) {
$parcel$export(module.exports, "Content", () => $67e6dfbfdce419a5$export$7c6e2c02157bb7d2);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ePtEH = parcelRequire("ePtEH");

var $3GmNv = parcelRequire("3GmNv");

var $7RqDz = parcelRequire("7RqDz");

var $ixsIR = parcelRequire("ixsIR");

var $f2wVS = parcelRequire("f2wVS");
const $67e6dfbfdce419a5$var$SPA_TRACE_KEY = 'spa';
const $67e6dfbfdce419a5$var$DefaultLayoutContent = (props)=>{
    const { isInset: isInset, hasTheming: hasTheming } = (0, $ePtEH.useProjectTheme)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RqDz.RenderTracerMark), {
        traceKey: $67e6dfbfdce419a5$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ixsIR.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RqDz.RenderTracerMark), {
        traceKey: $67e6dfbfdce419a5$var$SPA_TRACE_KEY,
        type: "end"
    }));
    if (hasTheming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3GmNv.ThemedContentLayout), {
        appearance: isInset ? 'inset' : 'default'
    }, renderContent);
    return renderContent;
};
$67e6dfbfdce419a5$var$DefaultLayoutContent.displayName = "DefaultLayoutContent";
const $67e6dfbfdce419a5$var$useRouterRoute = (0, $f2wVS.createRouterSelector)((state)=>state.route);
const $67e6dfbfdce419a5$export$7c6e2c02157bb7d2 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $67e6dfbfdce419a5$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RqDz.RenderTracerMark), {
        traceKey: $67e6dfbfdce419a5$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ixsIR.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7RqDz.RenderTracerMark), {
        traceKey: $67e6dfbfdce419a5$var$SPA_TRACE_KEY,
        type: "end"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($67e6dfbfdce419a5$var$DefaultLayoutContent, props);
};
$67e6dfbfdce419a5$export$7c6e2c02157bb7d2.displayName = "Content";

});
parcelRegister("3GmNv", function(module, exports) {
$parcel$export(module.exports, "ThemedContentLayout", () => $079046790e47a751$export$c2c3c7c0b13a1f9d);
$parcel$export(module.exports, "ProjectThemeWrapper", () => $079046790e47a751$export$65c56727ada4372d);
/* ProjectThemeWrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8nwDe = parcelRequire("8nwDe");

var $iiQSM = parcelRequire("iiQSM");
const $079046790e47a751$var$styles = {
    root: "_kqswh2mm",
    fullHeight: "_1tkeidpf _4t3i1osq",
    insetRoot: "_1yt4y9h4",
    insetContainer: "_2rko1gnp _bfhkp043"
};
const $079046790e47a751$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>{
    const isInset = appearance === 'inset';
    // When in inset mode, wrap content with ThemeTokensReset to reset
    // --project-* tokens to Atlaskit defaults. This allows ThemedButton
    // to be used everywhere without isThemed/isInset checks.
    const content = isInset ? /*#__PURE__*/ $euxye.createElement((0, $8nwDe.ThemeTokensReset), null, children) : children;
    return /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $079046790e47a751$var$styles.root,
            $079046790e47a751$var$styles.fullHeight,
            isInset && $079046790e47a751$var$styles.insetRoot
        ])
    }, /*#__PURE__*/ $euxye.createElement("div", {
        className: (0, $4jQY2.default)([
            $079046790e47a751$var$styles.fullHeight,
            isInset && $079046790e47a751$var$styles.insetContainer
        ])
    }, content));
};
$079046790e47a751$export$c2c3c7c0b13a1f9d.displayName = "ThemedContentLayout";
const $079046790e47a751$export$65c56727ada4372d = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
    if (withWhiteBackground) return /*#__PURE__*/ $euxye.createElement((0, $iiQSM.OuterWrapperWithBackground), null, /*#__PURE__*/ $euxye.createElement((0, $iiQSM.InnerWrapperWithBackground), null, children));
    return /*#__PURE__*/ $euxye.createElement((0, $iiQSM.OuterWrapper), null, /*#__PURE__*/ $euxye.createElement((0, $iiQSM.InnerWrapper), null, children));
};
$079046790e47a751$export$65c56727ada4372d.displayName = "ProjectThemeWrapper";

});
parcelRegister("8nwDe", function(module, exports) {
$parcel$export(module.exports, "ThemeTokensReset", () => $cd33ea77421f6111$export$60ae33e52837c5a0);
/* ThemeTokensReset.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");
const $cd33ea77421f6111$export$60ae33e52837c5a0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            "_4im21dpa _zlh41ymo _1s2f1856 _u456hf2y _izsbg6ey _1y5q187o _1j8c1j9a _jgpri8nm _sf7oplhp _2zsb1gdz _ob7x1dpa _1938fcek _1izo15s3 _kn491l7x _1sa0rsbi _9vjpveue _1ivoq98m _15jyvuon _ndl8hfxm _vnqds4qr _77o9yhbg _epg34pcx _1chtervl _dg2413af _1xfw12zz _1nwfi8nm _15ahi7uo _1cbh1yd3 _bm7j1gmx _1h9215cr _6h9q6x5g _1nzwazsu _1bgk1rpy _isbxvuon _4t3i1osq _1e0c1txw _2lx21bp4 _1tkeidpf"
        ])
    }, children);
$cd33ea77421f6111$export$60ae33e52837c5a0.displayName = "ThemeTokensReset";
/**
 * These styles reset all --project-* CSS variables back to their default
 * Atlaskit token values. When ThemedButton reads these variables, it will
 * get the standard Atlaskit styling instead of the project theme.
 *
 * Layout properties ensure the component fills available space and doesn't
 * collapse when used in flex containers.
 *
 * Note: These token values are inlined directly (not imported from BASE_THEME)
 * to comply with Compiled's requirement that styles cannot be imported from
 * other files.
 *
 * IMPORTANT: If changing this file, make sure to update the BASE_THEME constant in the project-theme-tokens package.
 */ const $cd33ea77421f6111$var$resetStyles = null;

});

parcelRegister("iiQSM", function(module, exports) {
$parcel$export(module.exports, "OuterWrapper", () => $980cff328966ae89$export$edaaad985a878983);
$parcel$export(module.exports, "OuterWrapperWithBackground", () => $980cff328966ae89$export$69c6ec128d3729c9);
$parcel$export(module.exports, "InnerWrapper", () => $980cff328966ae89$export$f185744748c379a7);
$parcel$export(module.exports, "InnerWrapperWithBackground", () => $980cff328966ae89$export$2e149d12a18af14b);
/* styled.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $980cff328966ae89$export$edaaad985a878983 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_kqswh2mm _154i1l8a",
            __cmplp.className
        ])
    });
});
const $980cff328966ae89$export$69c6ec128d3729c9 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = $980cff328966ae89$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1yt4y9h4",
            __cmplp.className
        ])
    });
});
const $980cff328966ae89$export$f185744748c379a7 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_iu1g1fl4 _fok81wug _q7c11wug _2d3f3q3i _japi1o48",
            __cmplp.className
        ])
    });
});
const $980cff328966ae89$export$2e149d12a18af14b = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = $980cff328966ae89$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $euxye.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_2rko1gnp _bfhkp043 _2d3f15y4 _japizntk",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ixsIR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8c932406beedeaa$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dQkkK = parcelRequire("dQkkK");

var $iLktG = parcelRequire("iLktG");

var $3H2O1 = parcelRequire("3H2O1");
const $e8c932406beedeaa$var$onSpaShellReady = ()=>{
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
};
const $e8c932406beedeaa$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dQkkK.default), {
        metricKey: "JIRA_SPA_SHELL_READY",
        onSet: $e8c932406beedeaa$var$onSpaShellReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3H2O1.default), {
        initRoute: initRoute,
        routes: routes
    }));
$e8c932406beedeaa$var$Spa.displayName = "Spa";
var $e8c932406beedeaa$export$2e2bcd8739ae039 = $e8c932406beedeaa$var$Spa;

});
parcelRegister("3H2O1", function(module, exports) {
$parcel$export(module.exports, "default", () => $da6552e69a9a21ae$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $dmS7i = parcelRequire("dmS7i");

var $h64Ew = parcelRequire("h64Ew");

var $h8QGu = parcelRequire("h8QGu");

var $gi67c = parcelRequire("gi67c");

var $kwlAe = parcelRequire("kwlAe");

var $6DfNt = parcelRequire("6DfNt");

var $6xuJS = parcelRequire("6xuJS");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $a8EUd = parcelRequire("a8EUd");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $iLktG = parcelRequire("iLktG");

var $OPiBr = parcelRequire("OPiBr");

var $aLH0u = parcelRequire("aLH0u");

var $gDdYI = parcelRequire("gDdYI");

var $f2wVS = parcelRequire("f2wVS");
var $fJ5g0 = parcelRequire("fJ5g0");
var $55BnK = parcelRequire("55BnK");

var $lBfxo = parcelRequire("lBfxo");

var $ehOO1 = parcelRequire("ehOO1");

var $iYYeq = parcelRequire("iYYeq");


var $8AO0r = parcelRequire("8AO0r");

var $lCetP = parcelRequire("lCetP");

var $i4Hc9 = parcelRequire("i4Hc9");

var $AihDC = parcelRequire("AihDC");

var $8s8ml = parcelRequire("8s8ml");
const $da6552e69a9a21ae$var$REMOTE_ACTIONS_OFF = 'OFF';
const $da6552e69a9a21ae$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $da6552e69a9a21ae$var$useRouterLocation = (0, $f2wVS.createRouterSelector)((state)=>state.location);
const $da6552e69a9a21ae$var$useRouterAction = (0, $f2wVS.createRouterSelector)((state)=>state.action);
const $da6552e69a9a21ae$var$useRouterQuery = (0, $f2wVS.createRouterSelector)((state)=>state.query);
const $da6552e69a9a21ae$var$useRouterRoute = (0, $f2wVS.createRouterSelector)((state)=>state.route);
const $da6552e69a9a21ae$var$useRouterMatch = (0, $f2wVS.createRouterSelector)((state)=>state.match);
const $da6552e69a9a21ae$var$useRouterRoutes = (0, $f2wVS.createRouterSelector)((state)=>state.routes);
const $da6552e69a9a21ae$var$useIsLazyRoutes = (0, $f2wVS.createRouterSelector)((state)=>state.isLazyRoutes);
let $da6552e69a9a21ae$var$hasPendingForceReloadAction = false;
const $da6552e69a9a21ae$var$getRemoteActionsRolloutStage = ()=>(0, $i860n.fg)('remote_actions_-_killswitch_-_temporary') ? $da6552e69a9a21ae$var$REMOTE_ACTIONS_PERFORM : $da6552e69a9a21ae$var$REMOTE_ACTIONS_OFF;
const $da6552e69a9a21ae$export$88fe66870dd8f843 = (value)=>{
    $da6552e69a9a21ae$var$hasPendingForceReloadAction = value;
};
const $da6552e69a9a21ae$export$39e8f9fc07dd3395 = ()=>$da6552e69a9a21ae$var$hasPendingForceReloadAction;
const $da6552e69a9a21ae$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'transitionBlocker',
        actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        currentRouteName: currentRoute?.route.name || '',
        targetRouteName: targetRoute?.route.name || '',
        remoteActionsRolloutStage: $da6552e69a9a21ae$var$getRemoteActionsRolloutStage(),
        attempts: attempts,
        lastAttemptedAt: lastAttemptedAt
    });
const $da6552e69a9a21ae$var$fireStaleTabReloadAnalytics = (analyticsEvent, currentRoute, targetRoute)=>(0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'staleTabReload performed', {
        currentRouteName: currentRoute?.route.name ?? 'unknown',
        targetRouteName: targetRoute?.route.name ?? 'unknown'
    });
const $da6552e69a9a21ae$var$updateSentryBreadcrumb = (route, nextRoute)=>{
    const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
    const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
    (0, $dmS7i.addBreadcrumb)({
        type: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
};
const $da6552e69a9a21ae$export$ef0074adc0f6b96d = (search)=>{
    const searchParams = new URLSearchParams(search);
    if (!searchParams.has('ignoreStickyVersion')) searchParams.append('ignoreStickyVersion', 'true');
    return `?${searchParams}`;
};
const $da6552e69a9a21ae$var$RegisterRouterBlocks = ({ routes: routesOriginal, initRoute: initRoute, route: route, match: match })=>{
    const isLazyRoutes = $da6552e69a9a21ae$var$useIsLazyRoutes();
    const routerRoutes = $da6552e69a9a21ae$var$useRouterRoutes();
    const routes = (0, $euxye.useMemo)(()=>{
        return isLazyRoutes ? routerRoutes : routesOriginal;
    }, [
        isLazyRoutes,
        routerRoutes,
        routesOriginal
    ]);
    const checkShouldResetPage = (0, $euxye.useMemo)(()=>(0, $aLH0u.createCheckShouldResetPage)(), []);
    const currentMatchObjectRef = (0, $euxye.useRef)(initRoute);
    const { registerBlock: registerBlock } = (0, $55BnK.useRouterActions)();
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $lBfxo.useShouldPerformAction)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
		 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
            route: route,
            match: match
        };
    }, [
        match,
        route
    ]);
    const { resetCurrentPage: resetCurrentPage } = (0, $OPiBr.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $euxye.useCallback)((nextLocation, nextAction)=>{
        const nextMatch = (0, $fJ5g0.default)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $AihDC.default)(currentMatchObjectRef.current, nextMatch);
        // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        if (isLazyRoutes && !canDo && routes.length <= 3) (0, $6CfY5.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
            route: nextMatch?.route.name
        });
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $h64Ew.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $da6552e69a9a21ae$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $da6552e69a9a21ae$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $da6552e69a9a21ae$var$hasPendingForceReloadAction === false) {
                $da6552e69a9a21ae$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $da6552e69a9a21ae$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $h64Ew.createPath)({
                        ...nextLocation,
                        search: $da6552e69a9a21ae$export$ef0074adc0f6b96d(nextLocation.search)
                    }));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $da6552e69a9a21ae$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        // Force a full reload on navigation for tabs older than 7 days. Reuses the remote-actions
        // pending-reload guard above so the two paths can't both fire for one transition.
        if ((0, $i860n.fg)('jira_stale_tab_reload_on_navigation')) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && $da6552e69a9a21ae$var$hasPendingForceReloadAction === false && (0, $i4Hc9.isTabTooOld)()) {
                $da6552e69a9a21ae$var$hasPendingForceReloadAction = true;
                if (createAnalyticsEvent !== null) $da6552e69a9a21ae$var$fireStaleTabReloadAnalytics(createAnalyticsEvent({}), currentMatch, nextMatch);
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location[windowAction]((0, $h64Ew.createPath)({
                    ...nextLocation,
                    search: $da6552e69a9a21ae$export$ef0074adc0f6b96d(nextLocation.search)
                }));
                // Block the SPA transition - the full page reload above replaces it.
                return false;
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent,
        isLazyRoutes
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $euxye.useCallback)((nextLocation, nextAction)=>{
        const nextMatchObject = (0, $fJ5g0.default)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $gi67c.default)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $ehOO1.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $gi67c.default)(route);
                (0, $kwlAe.default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $da6552e69a9a21ae$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    return null;
};
$da6552e69a9a21ae$var$RegisterRouterBlocks.displayName = "RegisterRouterBlocks";
const $da6552e69a9a21ae$var$SpaRouteComponent = /*#__PURE__*/ (0, $euxye.memo)(({ location: location, action: action, query: query, route: route, match: match })=>{
    const { component: RouteComponent, isStrictModeEnabled: isStrictModeEnabled, skeleton: skeleton } = route;
    const Skeleton = skeleton || (0, $6DfNt.default);
    if (RouteComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($da6552e69a9a21ae$var$ConditionalStrictMode, {
        isEnabled: isStrictModeEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.PlaceholderWithNativeSuspense), {
        name: "route-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    })));
});
const $da6552e69a9a21ae$var$SpaRouteEntryPointContainer = /*#__PURE__*/ (0, $euxye.memo)(({ location: location, action: action, query: query, route: route, match: match })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8s8ml.RouteEntryPointContainer), {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    });
});
const $da6552e69a9a21ae$var$sendRouteExperienceFailEvent = (experienceName, location, error)=>{
    if ((0, $lCetP.isWebCrawlerUserAgentWithAppleBot)()) return;
    if (error && (0, $lCetP.isClientFetchError)(error)) return;
    const isAbortable = Boolean(error && (0, $lCetP.isHttpClientErrorResponse)(error));
    const errorStack = (0, $8AO0r.truncateStackTrace)(error?.stack);
    const userAgent = globalThis.navigator?.userAgent ?? 'unknown';
    const isWebDriver = globalThis.navigator?.webdriver;
    (0, $iYYeq.default)({
        experience: experienceName,
        analyticsSource: `${experienceName}Route`,
        action: isAbortable ? (0, $a196702bd494009a$export$aeeb00d0845d24d8) : (0, $a196702bd494009a$export$b48b3d1872522384),
        wasExperienceSuccesful: false,
        application: null,
        edition: null,
        additionalAttributes: {
            errorMessage: error?.message ?? 'Unknown error',
            location: location,
            ...errorStack !== undefined && {
                errorStack: errorStack
            },
            userAgent: userAgent,
            ...isWebDriver !== undefined && {
                isWebDriver: isWebDriver
            }
        }
    });
};
const $da6552e69a9a21ae$var$SpaChild = ({ location: location, action: action, query: query, route: route, match: match })=>{
    const reporting = route.meta?.reporting;
    const experienceName = reporting?.experienceName;
    let onError = reporting?.onError;
    if (experienceName != null && (0, $i860n.fg)('jira_route_error_boundary_experience_event')) onError = (errorLocation, error)=>$da6552e69a9a21ae$var$sendRouteExperienceFailEvent(experienceName, errorLocation, error);
    const { experienceName: _experienceName, onError: _onError, ...errorBoundaryReporting } = reporting ?? {};
    const entryPoint = (0, $euxye.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDdYI.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: (0, $euxye.useMemo)(()=>({
                routeGroup: route.group ?? '',
                isSSR: false
            }), [
            route.group
        ]),
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...errorBoundaryReporting,
        onError: onError
    }, entryPoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($da6552e69a9a21ae$var$SpaRouteEntryPointContainer, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($da6552e69a9a21ae$var$SpaRouteComponent, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    })));
};
$da6552e69a9a21ae$var$SpaChild.displayName = "SpaChild";
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $da6552e69a9a21ae$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $euxye.useMemo)(()=>{
        (0, $6xuJS.setMark)('jira-spa/view.start');
    }, []);
    (0, $euxye.useEffect)(()=>{
        (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const location = $da6552e69a9a21ae$var$useRouterLocation();
    const action = $da6552e69a9a21ae$var$useRouterAction();
    const query = $da6552e69a9a21ae$var$useRouterQuery();
    const route = $da6552e69a9a21ae$var$useRouterRoute();
    const match = $da6552e69a9a21ae$var$useRouterMatch();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($da6552e69a9a21ae$var$RegisterRouterBlocks, {
        routes: routes,
        initRoute: initRoute,
        route: route,
        match: match
    }), !(route && match) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($da6552e69a9a21ae$var$SpaChild, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    }));
};
$da6552e69a9a21ae$var$Spa.displayName = "Spa";
function $da6552e69a9a21ae$var$ConditionalStrictMode(props) {
    // Default to true
    const { isEnabled: isEnabled = true, children: children } = props;
    // This flag just gives us a kill switch
    if (isEnabled && (0, $i860n.fg)('jfp-jira-incremental-strict-mode')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $euxye.StrictMode), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
}
$da6552e69a9a21ae$var$ConditionalStrictMode.displayName = "ConditionalStrictMode";
var $da6552e69a9a21ae$export$2e2bcd8739ae039 = $da6552e69a9a21ae$var$Spa;

});
parcelRegister("h64Ew", function(module, exports) {
$parcel$export(module.exports, "addLeadingSlash", () => $c7269b2040a8f677$export$5b4913142e03bca8, (v) => $c7269b2040a8f677$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $c7269b2040a8f677$export$10497c7ce66fcb84, (v) => $c7269b2040a8f677$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $c7269b2040a8f677$export$b69e3301ce081aa3, (v) => $c7269b2040a8f677$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $c7269b2040a8f677$export$d95b4586d238a081, (v) => $c7269b2040a8f677$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $c7269b2040a8f677$export$8ccf933b0513f8d0, (v) => $c7269b2040a8f677$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $c7269b2040a8f677$export$fe53371bee54353d, (v) => $c7269b2040a8f677$export$fe53371bee54353d = v);
var $c7269b2040a8f677$export$1e511d4a378977f5;
var $c7269b2040a8f677$export$5b4913142e03bca8;
var $c7269b2040a8f677$export$79c5b1569e3be9e6;
var $c7269b2040a8f677$export$10497c7ce66fcb84;
var $c7269b2040a8f677$export$b69e3301ce081aa3;
var $c7269b2040a8f677$export$d95b4586d238a081;
var $c7269b2040a8f677$export$8ccf933b0513f8d0;
var $c7269b2040a8f677$export$fe53371bee54353d;
'use strict';
$c7269b2040a8f677$export$1e511d4a378977f5 = true;
var $c7269b2040a8f677$var$addLeadingSlash = $c7269b2040a8f677$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $c7269b2040a8f677$var$stripLeadingSlash = $c7269b2040a8f677$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $c7269b2040a8f677$var$hasBasename = $c7269b2040a8f677$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $c7269b2040a8f677$var$stripBasename = $c7269b2040a8f677$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $c7269b2040a8f677$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $c7269b2040a8f677$var$stripTrailingSlash = $c7269b2040a8f677$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $c7269b2040a8f677$var$parsePath = $c7269b2040a8f677$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $c7269b2040a8f677$var$createPath = $c7269b2040a8f677$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});

parcelRegister("kwlAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $b64b85a63f8505ad$export$2e2bcd8739ae039);

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");

var $7VWGN = parcelRequire("7VWGN");
function $b64b85a63f8505ad$var$traceUFORedirect(fromUfoName, nextUfoName, nextRouteName, time) {
    (0, $7VWGN.default).current = nextUfoName;
    const interactionId = (0, $qqoKJ.DefaultInteractionID).current;
    if (interactionId) (0, $siTdT.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
}
var $b64b85a63f8505ad$export$2e2bcd8739ae039 = $b64b85a63f8505ad$var$traceUFORedirect;

});

parcelRegister("aLH0u", function(module, exports) {
$parcel$export(module.exports, "createCheckShouldResetPage", () => $294e8bbc26395c9d$export$ffb8c03de895ae3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bxhpq = parcelRequire("bxhpq");

var $i860n = parcelRequire("i860n");

var $f7hYg = parcelRequire("f7hYg");
const $294e8bbc26395c9d$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === 'issue-navigator';
const $294e8bbc26395c9d$var$isReplaceActionAndJPD = (action, route)=>action === 'REPLACE' && route.name === 'polaris-ideas';
/**
 * Detects an internal PUSH navigation within the global issue-navigator route
 * where the `filter` query param changed (e.g. sidebar filter click while
 * already on /issues). Targets only the global NIN routes that received the
 * `query: ['filter?']` addition. When the feature gate is OFF this suppresses
 * the SPA transition, preserving pre-existing behaviour.
 * Remove when treat_sidebar_filter_changes_as_spa_transitions is fully rolled out.
 */ const $294e8bbc26395c9d$var$isInternalFilterPushOnGlobalNIN = (action, currentRoute, nextRoute, currentMatch, nextMatch)=>action === 'PUSH' && currentRoute.name === 'global-issue-navigator' && nextRoute.name === currentRoute.name && currentMatch.query.filter !== nextMatch.query.filter;
const $294e8bbc26395c9d$export$ffb8c03de895ae3 = ()=>{
    let rapidBoardPaths = [];
    return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
        let shouldReset = true;
        if ($294e8bbc26395c9d$var$isReplaceActionAndPIN(action, nextRoute) || $294e8bbc26395c9d$var$isReplaceActionAndJPD(action, nextRoute) || !(0, $i860n.fg)('treat_sidebar_filter_changes_as_spa_transitions') && $294e8bbc26395c9d$var$isInternalFilterPushOnGlobalNIN(action, currentRoute, nextRoute, currentMatch, nextMatch) || currentRoute.isRedirect === true) shouldReset = false;
        else {
            const cleanMatch = (0, $f7hYg.getApdexMatchObject)(currentMatch, currentRoute);
            const cleanNextMatch = (0, $f7hYg.getApdexMatchObject)(nextMatch, nextRoute);
            shouldReset = !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(cleanMatch, cleanNextMatch) && shouldReset;
            if (shouldReset) {
                // RapidboardPaths is being persisted here.
                // resetDone boolean is calculated in the util function.
                const [paths, resetBoolean] = (0, $f7hYg.calcRapidBoardResetStateV2)(rapidBoardPaths, !!nextMatch.query.useStoredSettings, nextRoute.name);
                rapidBoardPaths = paths;
                if ((0, $f7hYg.isValidRoute)(nextRoute) || nextRoute.group === 'classic-software') shouldReset = !resetBoolean;
            }
        }
        return shouldReset;
    };
};

});
parcelRegister("f7hYg", function(module, exports) {
$parcel$export(module.exports, "calcRapidBoardResetState", () => $e60900dd4335933d$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $e60900dd4335933d$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $e60900dd4335933d$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $e60900dd4335933d$export$9f3e656a7f6a3adc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $e60900dd4335933d$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [
                'browse-project-redirect'
            ];
            resetDone = true;
            break;
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-backlog':
        case 'rapidboard-report':
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf('browse-project-redirect') > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $e60900dd4335933d$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $e60900dd4335933d$export$dbd9185166d0d04c = (boardPaths, useStoredSettings, routeName)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-board':
        case 'rapidboard-report':
            // use search to navigate to board
            if (rapidBoardPaths.includes('browse-project-redirect') || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes('browse-project-redirect')) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $e60900dd4335933d$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $e60900dd4335933d$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 'issue':
        case 'issue-embed':
        case 'issue-navigator':
        case 'issue-navigator-classic':
        case 'issue-navigator-core':
        case 'servicedesk-issues':
            return true;
        default:
            return false;
    }
};

});


parcelRegister("lBfxo", function(module, exports) {
$parcel$export(module.exports, "useShouldPerformAction", () => $320a8fd2232122f6$export$1bfa74483a8ca772);

var $euxye = parcelRequire("euxye");

var $iG7Wc = parcelRequire("iG7Wc");

var $9MGmq = parcelRequire("9MGmq");
const $320a8fd2232122f6$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
    const metas = (0, $iG7Wc.useMeta)();
    const remoteActions = (0, $iG7Wc.useRemoteActionsData)();
    const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $iG7Wc.useRemoteActionsStoreActions)();
    const [actionToPerform, setActionToPerform] = (0, $euxye.useState)();
    const [shouldPerformAction, setShouldPerformAction] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        // Check whether or not the action (actionName) should be performed:
        // - when the remote actions available list changes
        // - when the metas for the actions change
        const matchedAction = Object.values(remoteActions).find((action)=>{
            if (action.name !== actionName) return false;
            return true;
        });
        if (!matchedAction) return;
        setActionToPerform(matchedAction);
        setShouldPerformAction((0, $9MGmq.computeShouldPerformAction)(matchedAction, metas));
    }, [
        actionName,
        remoteActions,
        metas
    ]);
    const performActionMemoized = (0, $euxye.useCallback)((onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    }, [
        actionToPerform,
        shouldPerformAction,
        metas,
        saveActionPerformedAttempt,
        setShouldPerformAction
    ]);
    return {
        shouldPerformAction: shouldPerformAction,
        performAction: performActionMemoized
    };
};

});
parcelRegister("iG7Wc", function(module, exports) {
$parcel$export(module.exports, "RemoteActionsContainer", () => $775a2d8692c25ed4$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $775a2d8692c25ed4$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $775a2d8692c25ed4$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $775a2d8692c25ed4$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionLastUpdatedAt", () => $775a2d8692c25ed4$export$1d013261a2e6e0f9);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $775a2d8692c25ed4$export$3fd21eaf97df4718);

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");
var $6s4F0 = parcelRequire("6s4F0");

var $3wsa9 = parcelRequire("3wsa9");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $6s4F0.default))) (0, $6s4F0.default).devtools = false;
const $775a2d8692c25ed4$var$Store = (0, $5QDqc.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $3wsa9.actions,
    name: 'remoteActionsStore'
});
const $775a2d8692c25ed4$export$28c2e4c663a86266 = (0, $dB6ay.createContainer)($775a2d8692c25ed4$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $3wsa9.actions).initStore());
        }
});
const $775a2d8692c25ed4$export$333357b3de3e67a0 = (selector)=>(0, $3h1FP.createHook)($775a2d8692c25ed4$var$Store, {
        selector: selector
    })();
const $775a2d8692c25ed4$export$3cc006661ae2a759 = (0, $3h1FP.createStateHook)($775a2d8692c25ed4$var$Store, {
    selector: (state)=>state.remoteActions
});
const $775a2d8692c25ed4$export$3fb9275d3845bd5a = (0, $3h1FP.createStateHook)($775a2d8692c25ed4$var$Store, {
    selector: (state)=>state.meta
});
const $775a2d8692c25ed4$export$1d013261a2e6e0f9 = (0, $3h1FP.createStateHook)($775a2d8692c25ed4$var$Store, {
    selector: (state)=>state.lastUpdatedAt
});
const $775a2d8692c25ed4$export$3fd21eaf97df4718 = (0, $3h1FP.createActionsHook)($775a2d8692c25ed4$var$Store);

});
parcelRegister("3wsa9", function(module, exports) {
$parcel$export(module.exports, "actions", () => $732a1ce23a43c74c$export$e324594224ef24da);
// eslint-disable-next-line import/order

var $egEG4 = parcelRequire("egEG4");

var $er2gw = parcelRequire("er2gw");

var $fNkrX = parcelRequire("fNkrX");

var $daxjb = parcelRequire("daxjb");
const $732a1ce23a43c74c$export$e324594224ef24da = {
    processRemoteActions: $fNkrX.processRemoteActions,
    saveActionPerformedAttempt: $daxjb.saveActionPerformedAttempt,
    initStore: $er2gw.initStore,
    clearActionId: $egEG4.clearActionId
};

});
parcelRegister("egEG4", function(module, exports) {
$parcel$export(module.exports, "clearActionId", () => $8e5eaf4fd26da441$export$8d8b492eefa9efba);

var $jVVGE = parcelRequire("jVVGE");
const $8e5eaf4fd26da441$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $jVVGE.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("jVVGE", function(module, exports) {
$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $6642d045c05fd29a$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $6642d045c05fd29a$export$7228aaade919a8b6);
const $6642d045c05fd29a$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $6642d045c05fd29a$export$a221266a05084986 = (product)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return JSON.parse(localStorage.getItem(`${$6642d045c05fd29a$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $6642d045c05fd29a$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${$6642d045c05fd29a$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("er2gw", function(module, exports) {
$parcel$export(module.exports, "initStore", () => $d5fff532bac36cd6$export$41f27b3823a442c6);

var $jVVGE = parcelRequire("jVVGE");
const $d5fff532bac36cd6$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $jVVGE.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("fNkrX", function(module, exports) {
$parcel$export(module.exports, "processRemoteActions", () => $f26a38eccd3948cc$export$15e69d1dd38ccaa3);

var $db5XW = parcelRequire("db5XW");
const $f26a38eccd3948cc$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $db5XW.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $db5XW.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            // only keep the meta for the remote actions that are still present. This is to avoid
            // keeping stale meta which would otherwise grow indefinitely.
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: remoteActionsResponse.lastUpdatedAt
        });
    };

});
parcelRegister("db5XW", function(module, exports) {
$parcel$export(module.exports, "isActionConditionSatisfied", () => $192071afb41b60ba$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $192071afb41b60ba$export$c7cc93192d09a3d7);

var $kTzZP = parcelRequire("kTzZP");
const $192071afb41b60ba$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $192071afb41b60ba$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $192071afb41b60ba$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $192071afb41b60ba$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $kTzZP.ConditionType).buildRange:
            return $192071afb41b60ba$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $kTzZP.ConditionType).featureFlag:
            return $192071afb41b60ba$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $kTzZP.ConditionType).featureGate:
            return $192071afb41b60ba$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $192071afb41b60ba$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("kTzZP", function(module, exports) {
$parcel$export(module.exports, "ConditionType", () => $7b04d0b2ea3e1c4f$export$748d1c753cdf4bfd);
var $7b04d0b2ea3e1c4f$export$748d1c753cdf4bfd = /*#__PURE__*/ function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
    return ConditionType;
}({});

});



parcelRegister("daxjb", function(module, exports) {
$parcel$export(module.exports, "saveActionPerformedAttempt", () => $1b428726ccb725c8$export$e3144a2e886e0e77);

var $jVVGE = parcelRequire("jVVGE");
const $1b428726ccb725c8$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $jVVGE.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("9MGmq", function(module, exports) {
$parcel$export(module.exports, "computeShouldPerformAction", () => $96e61666a2f57579$export$6e0db227c9674096);

const $96e61666a2f57579$export$50dbcb44bba3aa5c = 60;
const $96e61666a2f57579$export$b21f5a6e7051e2c2 = (actionMetas)=>{
    const now = Date.now();
    const timeDiff = now - actionMetas.lastPerformAttemptedAt;
    return timeDiff > $96e61666a2f57579$export$50dbcb44bba3aa5c * 1000;
};
const $96e61666a2f57579$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $4e74041b4972d847$export$f2c0b74311ada874);
const $96e61666a2f57579$export$6e0db227c9674096 = (action, metas)=>{
    const actionMetas = metas[action.id];
    if (!actionMetas) // No meta, we have not attempted to perform this action yet.
    return true;
    if (!$96e61666a2f57579$export$6c7cf2cb7d75fad3(actionMetas)) // TODO: send a "cancelled analytics event ?"
    return false;
    if (!$96e61666a2f57579$export$b21f5a6e7051e2c2(actionMetas)) return false;
    // All the conditions are satisfied, we can perform the action.
    return true;
};

});
const $4e74041b4972d847$export$f2b2f5ef0b498d26 = 5000;
const $4e74041b4972d847$export$f2c0b74311ada874 = 3;
const $4e74041b4972d847$export$af2ff676951003fe = 60000;
const $4e74041b4972d847$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';



parcelRegister("i4Hc9", function(module, exports) {
$parcel$export(module.exports, "isTabTooOld", () => $3c765b6ab73d99ed$export$f52fd31bd658c81e);

var $2HuOR = parcelRequire("2HuOR");
const $3c765b6ab73d99ed$var$ONE_DAY_IN_MS = 86400000;
const $3c765b6ab73d99ed$var$MAX_TAB_AGE_PROD_IN_MS = 7 * $3c765b6ab73d99ed$var$ONE_DAY_IN_MS;
// Shorter threshold in non-prod so the behaviour can be soaked without waiting a week.
const $3c765b6ab73d99ed$var$MAX_TAB_AGE_NON_PROD_IN_MS = $3c765b6ab73d99ed$var$ONE_DAY_IN_MS;
const $3c765b6ab73d99ed$var$getMaxTabAge = ()=>{
    const env = (0, $2HuOR.getEnvironment)();
    const isNonProd = env === 'staging' || env === 'dev' || env === 'local';
    return isNonProd ? $3c765b6ab73d99ed$var$MAX_TAB_AGE_NON_PROD_IN_MS : $3c765b6ab73d99ed$var$MAX_TAB_AGE_PROD_IN_MS;
};
const $3c765b6ab73d99ed$export$f52fd31bd658c81e = ()=>{
    const tabAge = globalThis.performance?.now();
    if (typeof tabAge !== 'number') return false;
    return tabAge > $3c765b6ab73d99ed$var$getMaxTabAge();
};

});

parcelRegister("AihDC", function(module, exports) {
$parcel$export(module.exports, "default", () => $254af9760ee1f055$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bxhpq = parcelRequire("bxhpq");
/**
 * Determines the feasibility of transitioning between routes in a SPA, considering initial loads,
 * user agent constraints, and predefined route conditions. Ensures seamless navigation by
 * evaluating route matches and permissions.
 */ const $254af9760ee1f055$var$transitionValidator = (currentMatch, nextMatch)=>{
    // if we load SPA on a redirect route, we transition immediately skipping the checks
    if (!currentMatch) return true;
    // if next route missing (should not happen as we have a catch all route) or mobile, trigger reload
    if (!nextMatch) return false;
    // If we are still on same route and same match params, skip transition checks
    const isSameRoute = currentMatch.route === nextMatch.route;
    const isSameMatch = (0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(currentMatch.match, nextMatch.match);
    if (isSameRoute && isSameMatch) return true;
    // check we can transition into next route
    // @ts-expect-error - TS2339 - Property 'canTransitionIn' does not exist on type 'Route'.
    const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
    if (canDoNext) return true;
    return false;
};
var $254af9760ee1f055$export$2e2bcd8739ae039 = $254af9760ee1f055$var$transitionValidator;

});

parcelRegister("8s8ml", function(module, exports) {
$parcel$export(module.exports, "RouteEntryPointContainer", () => $45ada12af664ae36$export$3e4cdfb894377bc9);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $TTcqD = parcelRequire("TTcqD");

var $6CfY5 = parcelRequire("6CfY5");


var $btoiF = parcelRequire("btoiF");

var $dsVXF = parcelRequire("dsVXF");

var $E85Qr = parcelRequire("E85Qr");

var $bzSUP = parcelRequire("bzSUP");

var $f99wD = parcelRequire("f99wD");
const $45ada12af664ae36$var$LOCATION = 'route-entry-point-container';
const $45ada12af664ae36$export$fb85bbdbfb3e6869 = ()=>null;
const $45ada12af664ae36$var$EMPTY_OBJECT = {};
const $45ada12af664ae36$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
    const entryPointReference = (0, $btoiF.usePageLayoutEntryPoint)((0, $b666e36d39b806ff$export$900ddb492c628f48));
    // in order to show a spinner while page loading -> `route.skeleton=Spinner`
    const Skeleton = (0, $euxye.useMemo)(()=>route.skeleton || $45ada12af664ae36$export$fb85bbdbfb3e6869, [
        route.skeleton
    ]);
    (0, $euxye.useEffect)(()=>{
        if (route.isRedirect) (0, $6CfY5.default).safeWarnWithoutCustomerData($45ada12af664ae36$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const pageId = (0, $euxye.useMemo)(()=>{
        let _pageId = route.name;
        if (route.pageId) {
            if (typeof route.pageId === 'function') _pageId = route.pageId({
                route: route,
                action: action,
                location: location,
                match: match,
                query: query
            });
            else _pageId = route.pageId;
        }
        return _pageId;
    }, [
        action,
        location,
        match,
        query,
        route
    ]);
    const isPageHydrating = (0, $TTcqD.useIsHydrateRenderMode)();
    if (!entryPointReference) return null;
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, route.bifrost?.bifrostGroup !== 'shell-only' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "RouteEntryPointContainer",
        ignoreWhenCircuitOpen: true,
        displayErrorInStaging: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Skeleton, null));
    const page = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        props: $45ada12af664ae36$var$EMPTY_OBJECT
    }));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Skeleton, null),
        name: "route_entry_point_redirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        props: $45ada12af664ae36$var$EMPTY_OBJECT
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $E85Qr.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dsVXF.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: fallback,
        name: "route_entry_point",
        isSSRPlaceholderEnabled: !isPageHydrating ? route?.entryPointOptions?.isSSRPlaceholderEnabled : undefined
    }, page)));
};
$45ada12af664ae36$export$3e4cdfb894377bc9.displayName = "RouteEntryPointContainer";

});




parcelRegister("1jGfn", function(module, exports) {
$parcel$export(module.exports, "ReadinessTracker", () => $e624ff8021fe0658$export$9be3fbb5a9e49bfe);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $9H8Hj = parcelRequire("9H8Hj");

var $TTcqD = parcelRequire("TTcqD");

var $7JeLK = parcelRequire("7JeLK");

var $kPvQe = parcelRequire("kPvQe");
const $e624ff8021fe0658$var$setReadyStatus = (status)=>{
    if (typeof window !== 'undefined' && window.__JIRA_READY_STATUS) window.__JIRA_READY_STATUS = Object.assign(window.__JIRA_READY_STATUS, status);
};
const $e624ff8021fe0658$var$ReportApplicationReady = ()=>{
    (0, $euxye.useEffect)(()=>{
        $e624ff8021fe0658$var$setReadyStatus({
            readyForInteractions: true
        });
    }, []);
    return null;
};
$e624ff8021fe0658$var$ReportApplicationReady.displayName = "ReportApplicationReady";
const $e624ff8021fe0658$export$9be3fbb5a9e49bfe = ()=>{
    (0, $euxye.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            window.__JIRA_READY_STATUS = {
                started: true,
                loaded: false,
                onhold: true
            };
            $e624ff8021fe0658$var$setReadyStatus({
                readyForInteractions: false
            });
        }
    }, []);
    (0, $euxye.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            const onPageReady = ()=>{
                window.__JIRA_READY_STATUS.onhold = false;
            };
            window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
            return ()=>{
                window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
            };
        }
    }, []);
    const [{ hasLoaded: hasLoaded }] = (0, $kPvQe.default)();
    (0, $euxye.useEffect)(()=>{
        if (hasLoaded) {
            if (typeof window !== 'undefined') // we track "loaded" status as jira "loading end"
            window.__JIRA_READY_STATUS.loaded = true;
        }
    }, [
        hasLoaded
    ]);
    const ReadynessEvent = (0, $TTcqD.useIsHydrateRenderMode)() ? (0, $9H8Hj.RenderAfterGlobalHydrationCompletion) : (0, $7JeLK.BackgroundPriority);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ReadynessEvent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($e624ff8021fe0658$var$ReportApplicationReady, null));
};
$e624ff8021fe0658$export$9be3fbb5a9e49bfe.displayName = "ReadinessTracker";

});

parcelRegister("78Q6r", function(module, exports) {
$parcel$export(module.exports, "HotfixTesting", () => $bad0d2834f676f72$export$30590c55b29cd5b5);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
const $bad0d2834f676f72$export$30590c55b29cd5b5 = ()=>{
    (0, $euxye.useEffect)(()=>{
        // we will increase this number to test HOTFIX process
        const hotfixNumber = 'hot-0000';
        // eslint-disable-next-line no-console
        console.log('magma-hotfix-testing is enabled. HOTFIX number: ', hotfixNumber);
    }, []);
    return null;
};
$bad0d2834f676f72$export$30590c55b29cd5b5.displayName = "HotfixTesting";

});

parcelRegister("92ZVP", function(module, exports) {
$parcel$export(module.exports, "HydrationAdvisory", () => $8686531092fe2a09$export$9a6142f4ca734093);
/* eslint-disable @atlaskit/design-system/no-html-button */ /* eslint-disable jira/react/no-style-attribute, @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $euxye = parcelRequire("euxye");

var $TTcqD = parcelRequire("TTcqD");

var $5XU1N = parcelRequire("5XU1N");
// I promise I am being a good developer and not cheating the VC system. This component is strictly for development use
// only and cannot affect VC for customers.
const $8686531092fe2a09$var$attrKey = 'vc-nvs';
const $8686531092fe2a09$var$IGNORE_VC_ATTRIBUTE = {
    [`data-${$8686531092fe2a09$var$attrKey}`]: true
};
const $8686531092fe2a09$export$9a6142f4ca734093 = ()=>{
    const [isAdvisoryVisible, setIsAdvisoryVisible] = (0, $euxye.useState)(true);
    const [hasRecoverableErrors, setHasRecoverableErrors] = (0, $euxye.useState)(false);
    const [errorsWereDetected, setErrorsWereDetected] = (0, $euxye.useState)(false);
    const [isToastVisible, setIsToastVisible] = (0, $euxye.useState)(false);
    const isHydrateRenderMode = (0, $TTcqD.useIsHydrateRenderMode)();
    const isGlobalHydrationComplete = (0, $5XU1N.useIsGlobalHydrationComplete)();
    (0, $euxye.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setIsAdvisoryVisible(false);
        }, 5000);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    (0, $euxye.useEffect)(()=>{
        if (!isGlobalHydrationComplete) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const hasErrors = Boolean(window.__HYDRATION_RECOVERABLE_ERRORS__?.length);
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setHasRecoverableErrors(hasErrors);
        if (hasErrors) setErrorsWereDetected(true);
    }, [
        isGlobalHydrationComplete
    ]);
    if (!isHydrateRenderMode) return null;
    const dotColor = errorsWereDetected ? 'red' : 'aqua';
    const handleErrorBadgeClick = ()=>{
        // eslint-disable-next-line no-console, jira/jira-ssr/no-unchecked-globals-usage
        console.log('__HYDRATION_RECOVERABLE_ERRORS__: ', window.__HYDRATION_RECOVERABLE_ERRORS__);
        setIsToastVisible(true);
        setTimeout(()=>setIsToastVisible(false), 3000);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        ...$8686531092fe2a09$var$IGNORE_VC_ATTRIBUTE,
        style: {
            position: 'absolute',
            left: 8,
            top: 12,
            display: 'flex',
            alignItems: 'center',
            // By giving this element a height of 0 and no pointer events, we ensure that it doesn't interfere with the page.
            // To make is visible again, we then set the overflow to "visible".
            height: 0,
            overflow: 'visible',
            pointerEvents: 'none',
            zIndex: 99999999
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        style: {
            backgroundColor: dotColor,
            borderRadius: '50%',
            width: 8,
            height: 8,
            zIndex: 20
        }
    }), isAdvisoryVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        style: {
            backgroundColor: 'midnightblue',
            color: 'aqua',
            height: '1.5em',
            marginLeft: -12,
            paddingLeft: 16,
            paddingRight: 8,
            borderRadius: 4,
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("samp", null, "Rendered with React hydration \uD83D\uDEB0 go/jira-hydration")), hasRecoverableErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        style: {
            backgroundColor: 'darkred',
            color: 'lightyellow',
            height: '1.5em',
            marginLeft: 8,
            paddingLeft: 8,
            paddingRight: 8,
            borderRadius: 4,
            zIndex: 10,
            pointerEvents: 'all',
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("button", {
        type: "button",
        onClick: handleErrorBadgeClick,
        style: {
            background: 'none',
            border: 'none',
            color: 'lightyellow',
            cursor: 'pointer',
            font: 'inherit',
            padding: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("samp", null, "\u26A0\uFE0F Hydration errors detected, click here to reveal in console. go/jira-debug-ssr-hydration-failures")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("button", {
        type: "button",
        onClick: ()=>setHasRecoverableErrors(false),
        style: {
            background: 'none',
            border: 'none',
            color: 'lightyellow',
            cursor: 'pointer',
            padding: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("samp", null, "X"))), isToastVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        style: {
            backgroundColor: 'darkred',
            color: 'lightyellow',
            height: '1.5em',
            marginLeft: 8,
            paddingLeft: 8,
            paddingRight: 8,
            borderRadius: 4,
            zIndex: 10,
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("samp", null, "Errors logged to console \uD83D\uDD0D")));
};
$8686531092fe2a09$export$9a6142f4ca734093.displayName = "HydrationAdvisory";

});

parcelRegister("fJ0xd", function(module, exports) {
$parcel$export(module.exports, "StreamingAdvisory", () => $c9dc21a50f81ecb7$export$bf6beb7b7a0c3e95);
/* StreamingAdvisory.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $979J2 = parcelRequire("979J2");

var $k5P9q = parcelRequire("k5P9q");
// I promise I am being a good developer and not cheating the VC system. This component is strictly for development use
// only and cannot affect VC for customers.
const $c9dc21a50f81ecb7$var$attrKey = 'vc-nvs';
const $c9dc21a50f81ecb7$var$IGNORE_VC_ATTRIBUTE = {
    [`data-${$c9dc21a50f81ecb7$var$attrKey}`]: true
};
const $c9dc21a50f81ecb7$var$advisoryStyles = {
    wrapper: "_1reoewfl _18m9ewfl _kqswstnw _1ltvftgi _154i1crf _1e0c1txw _4cvr1h6o _4t3iidpf _lcxvglyw _1pbyzr3l",
    dot: "_2rko1rr0 _bfhk8dm2 _1bsbftgi _4t3iftgi _1pby1rya",
    label: "_2rko12b0 _bfhk1o1y _syaz8dm2 _4t3i1q5e _18u0xmi2 _19bvpxbi _u5f3u2gc _1pbyzo7u"
};
const $c9dc21a50f81ecb7$export$bf6beb7b7a0c3e95 = ()=>{
    const [isAdvisoryVisible, setIsAdvisoryVisible] = (0, $euxye.useState)(true);
    const isStreamingAdvisoryEnabled = (0, $979J2.useIsStreamingAdvisoryEnabled)();
    const isNonProd = (0, $k5P9q.useIsStagingOrDevOrLocal)();
    (0, $euxye.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setIsAdvisoryVisible(false);
        }, 5000);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    if (!isStreamingAdvisoryEnabled || !isNonProd) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        ...$c9dc21a50f81ecb7$var$IGNORE_VC_ATTRIBUTE,
        className: (0, $4jQY2.default)([
            $c9dc21a50f81ecb7$var$advisoryStyles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            $c9dc21a50f81ecb7$var$advisoryStyles.dot
        ])
    }), isAdvisoryVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        className: (0, $4jQY2.default)([
            $c9dc21a50f81ecb7$var$advisoryStyles.label
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("samp", null, "Server Side Streaming Enabled \uD83D\uDD34 go/jira-streaming")));
};
$c9dc21a50f81ecb7$export$bf6beb7b7a0c3e95.displayName = "StreamingAdvisory";

});


parcelRegister("b3oW6", function(module, exports) {
$parcel$export(module.exports, "StrictMode", () => $7165b90451d2d91f$export$5f8d39834fd61797);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");
const $7165b90451d2d91f$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $i860n.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).StrictMode, null, children);
};
$7165b90451d2d91f$export$5f8d39834fd61797.displayName = "StrictMode";

});

parcelRegister("lFOLo", function(module, exports) {
$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $96fd18521dfe2a87$export$a580704a2f3cfca);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eMmmd = parcelRequire("eMmmd");

var $jpPNt = parcelRequire("jpPNt");

var $i860n = parcelRequire("i860n");
const $96fd18521dfe2a87$export$a580704a2f3cfca = /*#__PURE__*/ (0, $euxye.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    const isEmbedMode = (0, $eMmmd.useIsEmbedMode)();
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), {
        ref: ref,
        href: (0, $i860n.fg)('jira-remove-default-character-for-undefined-hrefs') ? href : href || '#',
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});

});
parcelRegister("eMmmd", function(module, exports) {
$parcel$export(module.exports, "useIsEmbedMode", () => $87ce5ae4f0fdde2a$export$1b3c1ba6ee047da9);

var $euxye = parcelRequire("euxye");

var $3CqKW = parcelRequire("3CqKW");
const $87ce5ae4f0fdde2a$export$1b3c1ba6ee047da9 = ()=>{
    return (0, $euxye.useContext)((0, $3CqKW.EmbedModeContext));
};

});


parcelRegister("3Z2Qh", function(module, exports) {
$parcel$export(module.exports, "SpaRouter", () => $1100ffeb9fa75080$export$1029be09aa822f4a);

var $euxye = parcelRequire("euxye");

var $8ne6A = parcelRequire("8ne6A");
const $1100ffeb9fa75080$export$1029be09aa822f4a = ({ routerProps: routerProps, before: before, children: children, after: after })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8ne6A.Router), routerProps, before, children, after);
$1100ffeb9fa75080$export$1029be09aa822f4a.displayName = "SpaRouter";

});
parcelRegister("8ne6A", function(module, exports) {
$parcel$export(module.exports, "Router", () => $89f56c251895bdf8$export$55185c17a0fcbe46);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dR379 = parcelRequire("dR379");

var $9cDER = parcelRequire("9cDER");
const $89f56c251895bdf8$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $9cDER.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dR379.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};
$89f56c251895bdf8$export$55185c17a0fcbe46.displayName = "Router";

});
parcelRegister("9cDER", function(module, exports) {
$parcel$export(module.exports, "usePlugins", () => $2403592aa26c874d$export$c41e96fd89bc6106);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bI4rf = parcelRequire("bI4rf");

var $aI7em = parcelRequire("aI7em");

var $eijVy = parcelRequire("eijVy");

var $hM8aL = parcelRequire("hM8aL");
const $2403592aa26c874d$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $euxye.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $hM8aL.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $bI4rf.createEntryPointsPlugin)({
            environment: (0, $aI7em.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("bI4rf", function(module, exports) {
$parcel$export(module.exports, "createEntryPointsPlugin", () => $1c0afdbdcbb8293a$export$33586718f82f356f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $n67Vb = parcelRequire("n67Vb");

var $5banw = parcelRequire("5banw");

var $69eDJ = parcelRequire("69eDJ");

var $a2zOP = parcelRequire("a2zOP");

var $3nTxb = parcelRequire("3nTxb");

var $9Elv0 = parcelRequire("9Elv0");
const $1c0afdbdcbb8293a$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams, noRootQueries: noRootQueries = false })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $69eDJ.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefetched right before being loaded
                if (prefetchingRoute && (0, $5banw.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $5banw.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else {
                    const entryPointParamsWithContext = {
                        context: context,
                        ...entryPointParams
                    };
                    if (false && noRootQueries) {
                        // we can reassign here because SSR has a fresh context for every request
                        const previousGetPreloadProps = entryPoint.getPreloadProps;
                        const getPreloadProps = (params)=>{
                            const preloadProps = previousGetPreloadProps(params);
                            // @ts-expect-error The operand of a 'delete' operator cannot be a read-only property.ts(2704)
                            delete preloadProps.queries;
                            return preloadProps;
                        };
                        // @ts-expect-error Cannot assign to 'getPreloadProps' because it is a read-only property.ts(2540)
                        entryPoint.getPreloadProps = getPreloadProps;
                    }
                    const loadEntryPointsWithContext = ()=>(0, $n67Vb.loadEntryPoint)({
                            getEnvironment: ()=>environment
                        }, // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        entryPoint, entryPointParamsWithContext);
                    entryPointReference = false ? (0, $9Elv0.default)(entryPoint, entryPointParamsWithContext, loadEntryPointsWithContext) : loadEntryPointsWithContext();
                }
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $69eDJ.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $69eDJ.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $5banw.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $5banw.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $n67Vb.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, // oxlint-disable-next-line typescript/consistent-type-assertions
                entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $69eDJ.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $5banw.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $69eDJ.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $69eDJ.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $a2zOP.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        },
        getStats: async ()=>{
            const lastLoadedRoute = (0, $69eDJ.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $3nTxb.getEntryPointStats)(entryPointReference);
            return [];
        }
    });

});
parcelRegister("5banw", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $fcd3e27631fd8251$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $fcd3e27631fd8251$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $fcd3e27631fd8251$export$5997e70fc4543270);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $fcd3e27631fd8251$export$37d3126be6549b13 = 10000;
const $fcd3e27631fd8251$export$b65d7ba7fbf150f1 = ()=>$fcd3e27631fd8251$export$37d3126be6549b13 + Date.now();
const $fcd3e27631fd8251$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $fcd3e27631fd8251$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $fcd3e27631fd8251$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $fcd3e27631fd8251$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $fcd3e27631fd8251$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("a2zOP", function(module, exports) {
$parcel$export(module.exports, "waitForEntryPoint", () => $8df42773236d6d88$export$944f853f194e5dd5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5SJ3N = parcelRequire("5SJ3N");
const $8df42773236d6d88$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $5SJ3N.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $8df42773236d6d88$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});

parcelRegister("3nTxb", function(module, exports) {
$parcel$export(module.exports, "getEntryPointStats", () => $d26d0a3f3186f214$export$ee016802bdebb378);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5SJ3N = parcelRequire("5SJ3N");
const $d26d0a3f3186f214$export$14ba46fa7bd4c0a9 = ()=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    new Promise((resolve)=>setTimeout(resolve, 0));
const $d26d0a3f3186f214$export$982a0a12103fb99f = async (promise)=>{
    if (!promise) return 'resolved';
    try {
        if (await Promise.race([
            promise,
            Promise.resolve('timeout')
        ]) === 'timeout') return 'pending';
        return 'resolved';
    } catch (e) {
        return 'rejected';
    }
};
const $d26d0a3f3186f214$var$getEntrypointQueryState = async (queryId)=>{
    const queryPromise = (0, $5SJ3N.QueryPromisesMap).get(queryId);
    return {
        queryId: queryId,
        status: await $d26d0a3f3186f214$export$982a0a12103fb99f(queryPromise)
    };
};
const $d26d0a3f3186f214$export$ee016802bdebb378 = (entryPointConfig)=>{
    const result = [];
    const analyseEntrypoint = ({ queries: queries, entryPoints: entryPoints })=>{
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) result.push($d26d0a3f3186f214$var$getEntrypointQueryState(String(queries[key].id)));
        });
        if (entryPoints) Object.entries(entryPoints).forEach(([, entryPoint])=>{
            analyseEntrypoint(entryPoint);
        });
    };
    analyseEntrypoint(entryPointConfig);
    return Promise.all(result);
};

});

parcelRegister("9Elv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a2e2140daf3bfbb$export$2e2bcd8739ae039);

var $b3tU7 = parcelRequire("b3tU7");

var $8gHzK = parcelRequire("8gHzK");

var $23nGH = parcelRequire("23nGH");

const $0a2e2140daf3bfbb$var$DummyAsyncModule = (0, $b3tU7.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("23nGH"))), {
    moduleId: "a510115a",
    moduleName: "ReactFragment",
    priority: "userVisible",
    // using a real async import to make the js-resource transformers/babel-plugins happy
    entryFsSsrLiftImportToModule: true
});
$0a2e2140daf3bfbb$var$DummyAsyncModule.getModuleIfRequired = ()=>(0, $23nGH.default); // prevent attempts to fetch the module async at all
/**
 * Run a given loadEntryPoint function without loading the entrypoint modules, then load them right afterwards.
 *
 * This is to prevent triggering the loading of entrypoints modules inline with the data fetching.
 * When JS modules are inline-required (such as in SSR when async modules are converted to inline-requires)
 * this leads to inline-evaluating all dependencies for large component modules before kicking off the data for them.
 * This causes a measurable performance hit (~20-80ms in many cases) before we even kick off critical data fetches.
 *
 * Deferring the module loading until after the data fetching allows the module execution to occur in the less critical
 * idle time while waiting for data fetches to return.
 */ function $0a2e2140daf3bfbb$var$loadEntryPointDataThenModules(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
entryPoint, entryPointParams, loadEntryPointCallback) {
    const originalModulesByEntrypointRef = new Map();
    (0, $8gHzK.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
        originalModulesByEntrypointRef.set(loopingEntryPoint, loopingEntryPoint.root);
        // eslint-disable-next-line no-param-reassign
        loopingEntryPoint.root = $0a2e2140daf3bfbb$var$DummyAsyncModule;
    });
    try {
        return loadEntryPointCallback();
    } finally{
        (0, $8gHzK.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
            const originalModule = originalModulesByEntrypointRef.get(loopingEntryPoint);
            if (!originalModule) throw new Error('Original module not found for entrypoint');
            // eslint-disable-next-line no-param-reassign
            loopingEntryPoint.root = originalModule;
        });
        // Kicks off the loading of the original modules as they would have, but after the data fetches have been started
        // Without this, entrypoints may have trouble rendering
        // Wrap it in a promise to prevent it from affecting timers that start synchronously after this function
        Promise.resolve().then(()=>originalModulesByEntrypointRef.forEach((entryPointModule)=>{
                const jsModule = entryPointModule.getModuleIfRequired();
                if (jsModule != null) return;
                entryPointModule.load();
            }));
    }
}
var $0a2e2140daf3bfbb$export$2e2bcd8739ae039 = $0a2e2140daf3bfbb$var$loadEntryPointDataThenModules;

});
parcelRegister("8gHzK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b648c0a015e31293$export$2e2bcd8739ae039);
/**
 * Recursively run through all nested entrypoints with a given callback
 */ function $b648c0a015e31293$var$forAllEntryPoints(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
entryPoint, entryPointParams, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    callback(entryPoint);
    const preloadProps = entryPoint.getPreloadProps(entryPointParams);
    const entryPoints = preloadProps.entryPoints;
    if (!entryPoints) return;
    Object.values(entryPoints).forEach(({ entryPoint: nestedEntryPoint, entryPointParams: nestedParams })=>{
        if (nestedEntryPoint) $b648c0a015e31293$var$forAllEntryPoints(nestedEntryPoint, nestedParams, callback);
    });
}
var $b648c0a015e31293$export$2e2bcd8739ae039 = $b648c0a015e31293$var$forAllEntryPoints;

});

parcelRegister("23nGH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1cc81fbc357f5ee3$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $1cc81fbc357f5ee3$var$ReactFragment = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
$1cc81fbc357f5ee3$var$ReactFragment.displayName = "ReactFragment";
var $1cc81fbc357f5ee3$export$2e2bcd8739ae039 = $1cc81fbc357f5ee3$var$ReactFragment;

});



parcelRegister("hM8aL", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => $273d9c029e146c66$export$23ed892c481a96fe);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bYonX = parcelRequire("bYonX");

var $ekivV = parcelRequire("ekivV");
const $273d9c029e146c66$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $273d9c029e146c66$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $bYonX.getResourceStore)().actions;
    const nextResources = (0, $ekivV.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $273d9c029e146c66$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $bYonX.getResourceStore)().actions;
    const nextResources = (0, $ekivV.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $273d9c029e146c66$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout, abortSignal: abortSignal, onlyGetCritical: onlyGetCritical })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $bYonX.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $273d9c029e146c66$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $273d9c029e146c66$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $273d9c029e146c66$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $bYonX.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout,
                abortSignal: abortSignal,
                onlyGetCritical: onlyGetCritical
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $bYonX.getResourceStore)().actions;
            const nextResources = (0, $ekivV.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $bYonX.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("ekivV", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $30236f8b2f95a6c0$export$7cbbc763e2f3d65d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8JUHb = parcelRequire("8JUHb");

var $5sk5x = parcelRequire("5sk5x");
const $30236f8b2f95a6c0$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $5sk5x.routeHasResources)(nextRoute)) return [];
    if ((0, $5sk5x.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $8JUHb.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $8JUHb.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("8JUHb", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $90221f3be83f58aa$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $90221f3be83f58aa$export$cd7fbe7e979df558);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $90221f3be83f58aa$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $90221f3be83f58aa$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$90221f3be83f58aa$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("5sk5x", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $989fd0f28e4f2c5d$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $989fd0f28e4f2c5d$export$221027ff1aa38f82);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $989fd0f28e4f2c5d$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $989fd0f28e4f2c5d$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});






parcelRegister("fGV3I", function(module, exports) {
$parcel$export(module.exports, "addInitialPageLoadTimings", () => $17a57ba8ac318db8$export$ce440b3d0fa0d5ed);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");

var $iLktG = parcelRequire("iLktG");

var $8okEr = parcelRequire("8okEr");
const $17a57ba8ac318db8$export$ce440b3d0fa0d5ed = ()=>{
    if (false) return;
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig-gate-values:start', 'ssr.spa.statsig-gate-values:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'statsig-parse:start', 'statsig-parse:end');
    // In legacy SSR, parsing happens inline with processing the flush. In modern SSR or static fallback scenarios for legacy SSR, the parse will be timed seperately.
    // What we want to avoid is confusing people with a "parse timer" in legacy SSR breakdown charts that doesn't overlap with the "statsig" timer (without this timer entry that would happen and it would have a very low volume, but it would distract people during perf-investigations)
    // This will make the statsig-parse timer fully overlap with "statsig" when the parsing happens inline, and will start at a different time otherwise
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'ssr.spa.statsig:start', 'ssr.spa.statsig:start');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-common', 'ssr.spa.inline-assets:start', 'ssr.spa.inline-assets:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-route', 'ssr.spa.async-inline-assets:start', 'ssr.spa.async-inline-assets:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
    if ((0, $i860n.fg)('jira-fix-aborting-interaction-detection')) (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/init-ufo-scripts', 'early-flush/init-ufo-scripts.start', 'early-flush/init-ufo-scripts.end', true, true);
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/waiting-for-ssr', 'ssr.spa.await-render-spa-app:start', 'ssr.spa.await-render-spa-app:end');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
    (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if ((0, $i860n.fg)('jfp-magma-script-fetch-priority')) (0, $iLktG.setInitialPageLoadTimingFromPerformanceMarks)('language-pack.eval', 'language-pack:eval-start', 'language-pack:eval-end');
    (0, $8okEr.observePreloadedBundlesProgress)();
};

});
parcelRegister("8okEr", function(module, exports) {
$parcel$export(module.exports, "observePreloadedBundlesProgress", () => $ca1c875556284162$export$2169bfe6cd4f4439);
/* eslint-disable jira/filename-case */ 
var $9dSZE = parcelRequire("9dSZE");

var $i860n = parcelRequire("i860n");
let $ca1c875556284162$var$po = null;
let $ca1c875556284162$var$timeout = null;
let $ca1c875556284162$var$started = false;
const $ca1c875556284162$export$2169bfe6cd4f4439 = ()=>{
    if (false || $ca1c875556284162$var$started || !globalThis.PerformanceObserver) return;
    $ca1c875556284162$var$started = true;
    const expectedEntries = new Set(Array.from(globalThis.document?.querySelectorAll?.('link[rel=modulepreload]') || []).map((el)=>el.getAttribute('href')).filter((url)=>url?.includes('jira-frontend-bifrost') || ((0, $i860n.fg)('jfp_update_cdn_allowlist') ? url?.includes('jira-fe') : false)));
    /* eslint-disable @typescript-eslint/consistent-type-assertions */ const loadedResources = Array.from(globalThis.performance?.getEntriesByType('resource')).filter(({ name: name })=>{
        if (expectedEntries.has(name)) {
            expectedEntries.delete(name);
            return true;
        }
        return false;
    });
    if (expectedEntries.size > 0) {
        $ca1c875556284162$var$timeout = setTimeout(()=>{
            $ca1c875556284162$var$po?.disconnect();
        }, 30000);
        $ca1c875556284162$var$po = new PerformanceObserver((entry)=>{
            entry.getEntries().forEach((e)=>{
                if (expectedEntries.has(e.name)) {
                    expectedEntries.delete(e.name);
                    loadedResources.push(e);
                }
                if (expectedEntries.size === 0) {
                    $ca1c875556284162$var$timeout !== null && clearTimeout($ca1c875556284162$var$timeout);
                    $ca1c875556284162$var$po?.disconnect();
                    $ca1c875556284162$var$processCapturedData(loadedResources);
                }
            });
        });
    } else $ca1c875556284162$var$processCapturedData(loadedResources);
/* eslint-enable @typescript-eslint/consistent-type-assertions */ };
const $ca1c875556284162$var$determineMinAndMax = (agg, entry)=>{
    if (agg.min === null || entry.startTime < agg.min) // eslint-disable-next-line no-param-reassign
    agg.min = entry.startTime;
    if (agg.max === null || entry.responseEnd > agg.max) // eslint-disable-next-line no-param-reassign
    agg.max = entry.responseEnd;
};
const $ca1c875556284162$var$processCapturedData = (loadedResources)=>{
    const { all: all, common: common, route: route } = loadedResources.reduce((agg, entry)=>{
        $ca1c875556284162$var$determineMinAndMax(agg.all, entry);
        if ($ca1c875556284162$var$isCommon(entry)) $ca1c875556284162$var$determineMinAndMax(agg.common, entry);
        else $ca1c875556284162$var$determineMinAndMax(agg.route, entry);
        return agg;
    }, {
        all: {
            max: null,
            min: null
        },
        common: {
            max: null,
            min: null
        },
        route: {
            max: null,
            min: null
        }
    });
    if (all.max === null || all.min === null) return;
    $ca1c875556284162$var$setTimings('preloading-bundles', all);
    $ca1c875556284162$var$setTimings('preloading-bundles/common', common);
    $ca1c875556284162$var$setTimings('preloading-bundles/route', route);
};
const $ca1c875556284162$var$isCommon = (entry)=>{
    const url = entry.name;
    const hasJiraSpa = url.includes('jira-spa');
    const isSharedWithoutNav = url.includes('/shared') && !url.includes('atlassian-navigation');
    const isNavWithVendor = url.includes('atlassian-navigation') && url.includes('vendor');
    return (hasJiraSpa || isSharedWithoutNav || isNavWithVendor) && url.endsWith('.js');
};
const $ca1c875556284162$var$setTimings = (label, { min: min, max: max })=>{
    if (max === null || min === null) return;
    const startMark = `${label}-start`;
    const stopMark = `${label}-end`;
    performance.mark(startMark, {
        startTime: min
    });
    performance.mark(stopMark, {
        startTime: max
    });
    (0, $9dSZE.addTimingFromPerformanceMark)(label, startMark, stopMark, true, true);
};

});


parcelRegister("9RXSf", function(module, exports) {
$parcel$export(module.exports, "setPrefetchStartMark", () => $7f2de7c5f8f6024c$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $7f2de7c5f8f6024c$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $7f2de7c5f8f6024c$export$d6b0928f07bafe57);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gXtG2 = parcelRequire("gXtG2");
const $7f2de7c5f8f6024c$var$prefetchTiming = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $7f2de7c5f8f6024c$var$prefetchTiming.clear();
});
const $7f2de7c5f8f6024c$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$7f2de7c5f8f6024c$var$prefetchTiming.has(currentMatch)) $7f2de7c5f8f6024c$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $7f2de7c5f8f6024c$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $7f2de7c5f8f6024c$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $7f2de7c5f8f6024c$export$d6b0928f07bafe57 = (match)=>{
    if (!$7f2de7c5f8f6024c$var$prefetchTiming || !$7f2de7c5f8f6024c$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($7f2de7c5f8f6024c$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $7f2de7c5f8f6024c$var$prefetchTiming.has(mark)) $7f2de7c5f8f6024c$var$prefetchTiming.delete(mark);
    });
};

});

parcelRegister("5kLXK", function(module, exports) {
$parcel$export(module.exports, "default", () => $0baeefb2a68610a6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");

var $kY9Lm = parcelRequire("kY9Lm");
var $fJ5g0 = parcelRequire("fJ5g0");
const $0baeefb2a68610a6$var$LOCATION = 'spa.create-spa-history';
const $0baeefb2a68610a6$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
        const matchedRoute = (0, $fJ5g0.default)(currentRoutes, history.location.pathname, history.location.search);
        // This should never be the case as in SPA we have a default route
        // Replace with lodash/noop
        // oxlint-disable-next-line no-empty-function
        if (!matchedRoute) return ()=>{};
        if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
        // returns an "unregister" block
        return ()=>{
            const idx = routeBlockFns.indexOf(blockFn);
            if (idx !== -1) routeBlockFns.splice(idx, 1);
        };
    };
const $0baeefb2a68610a6$var$createSpaHistory = (initialRoutes)=>{
    const routeBlockFns = [];
    // oxlint-disable-next-line typescript/consistent-type-assertions
    let blockArgs = [];
    let nextMatchedRoute;
    const currentRoutes = initialRoutes;
    const history = (0, $kY9Lm.createBrowserHistory)({
        /* We abuse this api to allow us to run as many blockers as we want, allowing the transition
		 * to resume only when all return true or bail out as soon as the first one returns false */ getUserConfirmation: (__, done)=>{
            const matchedRoute = (0, $fJ5g0.default)(currentRoutes, history.location.pathname, history.location.search);
            // This should never be the case as in SPA we have a default route
            if (!matchedRoute || !nextMatchedRoute) return done(true);
            // we execute the blockers in reverse order, so the last registered is the first to run
            // They are executed synchronously until one returns false or a promise
            // If a promise is returned we execute all remaining blockers as chained promises
            let sync = true;
            for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                const result = routeBlockFns[i](...blockArgs);
                if (result instanceof Promise) {
                    sync = false;
                    routeBlockFns.slice(0, i + 1).reverse().reduce(// oxlint-disable-next-line no-loop-func
                    (promise, blocker)=>promise.then((res)=>res === false ? Promise.resolve(false) : blocker(...blockArgs)), Promise.resolve(result)).then((res)=>{
                        routeBlockFns.length = 0;
                        done(res);
                    }).catch((err)=>{
                        (0, $6CfY5.default).safeErrorWithoutCustomerData($0baeefb2a68610a6$var$LOCATION, 'Error with getUserConfirmation', err);
                        done(true);
                    });
                    break;
                }
                if (result === false) {
                    done(false);
                    return;
                }
            }
            if (sync) {
                routeBlockFns.length = 0;
                done(true);
            }
        }
    });
    // For lazy loaded route maps we need to keep track of the current routes here
    // as they will be changing. When we "match" for the route blocking code we need
    // to ensure we match against the current routes, not the routes at the time the function
    // was created.
    history.refreshRoutes = (newRoutes)=>{
        // Replace currentRoutes in place as it's captured in a closure above..
        currentRoutes.length = 0;
        currentRoutes.push(...newRoutes);
    };
    /* We set the main "blocker", that is also used enable next location access in getUserConfirmation
	 * (going around getUserConfirmation API limitations) */ history.block((location, action)=>{
        blockArgs = [
            location,
            action
        ];
        nextMatchedRoute = (0, $fJ5g0.default)(currentRoutes, location.pathname, location.search);
        // Must return a string or getUserConfirmation is not called
        return '';
    });
    // @ts-expect-error - we're using a custom blocker
    history.block = $0baeefb2a68610a6$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
    return history;
};
/**
 * Monkey patches the push/replace methods of the react router history object to
 * perform a full page refresh instead of history push/replace when a route is not valid
 * (i.e. legacy pages). This is required to fix the browser back button not working correctly
 * after redirecting to a legacy page.
 * JSPA-900
 */ const $0baeefb2a68610a6$var$createSpaHistory1 = (routes)=>$0baeefb2a68610a6$var$createSpaHistory(routes);
var $0baeefb2a68610a6$export$2e2bcd8739ae039 = $0baeefb2a68610a6$var$createSpaHistory1;

});

parcelRegister("6FMwd", function(module, exports) {
$parcel$export(module.exports, "getSpaRouterContext", () => $a03b7ddcb3c6e652$export$1f61c5e3f6410afa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $a03b7ddcb3c6e652$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("cPAVv", function(module, exports) {
$parcel$export(module.exports, "default", () => $344aa3e6287b1bb4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $l7jID = parcelRequire("l7jID");

var $6bEm8 = parcelRequire("6bEm8");

var $cUQPk = parcelRequire("cUQPk");

var $siTdT = parcelRequire("siTdT");

var $8swbq = parcelRequire("8swbq");

var $5MNwZ = parcelRequire("5MNwZ");

var $bPWQO = parcelRequire("bPWQO");

var $9LXZM = parcelRequire("9LXZM");

var $i860n = parcelRequire("i860n");

var $7sGEC = parcelRequire("7sGEC");

var $4VJn4 = parcelRequire("4VJn4");

var $gQRLr = parcelRequire("gQRLr");

var $2700E = parcelRequire("2700E");

var $eLaJ5 = parcelRequire("eLaJ5");

var $lFkCC = parcelRequire("lFkCC");

var $aYvm6 = parcelRequire("aYvm6");
const $344aa3e6287b1bb4$var$FALLBACK_UFO_CONFIG = {
    autoGeneratedRate: 1000,
    enabled: true,
    removeUFOPrefixList: [
        'project-versions',
        'filters-directory'
    ],
    removePageSegmentsUFOPrefixes: true,
    doNotAbortActivePressInteractionOnTransition: [
        'jsm-create-cmp-request-type-from-template',
        'jsm-create-tmp-request-type-from-template'
    ],
    killswitch: [
        'jira.fe.load.UNKNOWN'
    ],
    awaitForSegments: {
        'global-issue.create-modal': [
            'issue-view-details'
        ],
        'global-issue.create-modal-subsequent': [
            'issue-view-details'
        ]
    },
    removeAllUFOPrefix: true,
    rates: {
        'issue-view-activity-button-worklog': 1,
        'issue-view-activity-button-history': 1,
        'issue-view-activity-button-comments': 1,
        'arj-toggle-view-mode': 1,
        unknown: 1000,
        'issue-view-activity-button-forge-app': 1,
        'view-mode': 1,
        'backlog.issue-view-opened': 5,
        'create-web-link-inline-field-type-tracing': 1000,
        'issue-view-activity-button-connect-app': 1,
        'single-line-text-field-type-tracing': 100,
        'issue-view-activity-button-all': 1,
        'backlog.card-hover': 1,
        'board.card-drag': 1,
        'child-issue-inline-create-type-tracing': 100,
        'show-insights-button': 100,
        'board.issue-view-opened': 5,
        'issue-view-activity-button-jsd-comments': 1,
        'backlog.card-list-toggle': 5,
        'issue-view-activity-button-approvals': 1,
        'work-item-activity-button-forge-app': 1,
        'work-item-activity-button-connect-app': 1
    },
    kind: {
        generic: 0,
        hover: 0,
        legacy: 1,
        page_load: 1,
        press: 1,
        transition: 1,
        typing: 0
    },
    awaitBM3TTI: [
        'jwm_project_pages',
        'software-plan-dependencies',
        'advanced-roadmaps.page-plan.dependencies-tab.load-time',
        'servicedesk-cmdb-object-type-configuration',
        'service-management.insight-cmdb-object-type-configuration',
        'project-components-view',
        'project-components',
        'project-settings-components',
        'people-index',
        'people-profiles',
        'rapidboard-report',
        'classic-report',
        'project-settings-servicedesk-ticket-type-fields',
        'project-settings.issue-type.jsm-cmp-customer-view',
        'project-settings.issue-type.jsm-cmp-agent-view',
        'archived-project-direct-link',
        'project-archived',
        'servicedesk-queues-new',
        'service-management.queues.new',
        'project-settings-software-boards-insights',
        'board-settings-apps.insights-settings-page.page.load',
        'admin-oauth-credentials',
        'admin.oauth-credentials',
        'polaris-ideas',
        'project-settings-software-boards-csm',
        'jira.fe.page-load.software.next-gen.boards.column-status-mapping.page.load',
        'project-settings-servicedesk-language',
        'service-management.languages',
        'project-settings-servicedesk-language-key',
        'service-management.translations',
        'marketplace-index',
        'embedded-marketplace',
        'project-settings-servicedesk-portal-settings',
        'service-management.portal-settings',
        'service-management.portal-settings.portal-groups',
        'project-settings-servicedesk-automation-create',
        'service-management.automation.create-rule',
        'servicedesk-customers-v2',
        'jsm-customers-component-load',
        'archived-project-direct-link',
        'project-archived',
        'project-settings-software-boards-csm',
        'software.next-gen.boards.column-status-mapping.page.load',
        'jira-connect',
        'knowledge-hub-category',
        'service-management.knowledge.category',
        'servicedesk-queues-landing',
        'servicedesk-practice-landing',
        'servicedesk-practice-custom-and-issue',
        'servicedesk-practice-custom-issue',
        'servicedesk-practice-custom-view',
        'servicedesk-queues-custom-and-issue',
        'servicedesk-queues-custom-issue',
        'servicedesk-queues-custom-view'
    ],
    rules: [],
    capability: {
        feature_flag_access: 1,
        react_profiler: 1
    },
    typingMethod: 'timeout',
    removeInteractionsUFOPrefixes: true,
    doNotAbortActivePressInteraction: [],
    ufoNameOverrides: {
        'global-issue-navigator': {
            'global-issue-navigator': 'global-issue-navigator-jfe',
            'new-issue-navigator': 'global-new-issue-navigator'
        },
        'global-issue-navigator-jfe': {
            'global-issue-navigator-jfe': 'global-issue-navigator-jfe',
            'new-issue-navigator': 'global-new-issue-navigator'
        },
        'global-settings-migrations-focus-page': {
            'admin.c2c-migrations.choose-destination': 'admin.c2c-migrations.choose-destination',
            'admin.c2c-migrations.choose-projects': 'admin.c2c-migrations.choose-projects',
            'admin.c2c-migrations.preflight-checks': 'admin.c2c-migrations.preflight-checks',
            'admin.c2c-migrations.review': 'admin.c2c-migrations.review'
        },
        'polaris-ideas': {
            'project-settings.details': 'project-settings-details-polaris-ideas'
        },
        'project-settings-servicedesk-portal-settings': {
            'service-management.portal-settings': 'service-management.portal-settings',
            'service-management.portal-settings.portal-groups': 'service-management.portal-settings.portal-groups'
        },
        'project-settings-servicedesk-ticket-type-fields': {
            'project-settings.issue-type.jsm-cmp-agent-view': 'project-settings.issue-type.jsm-cmp-agent-view',
            'project-settings.issue-type.jsm-cmp-customer-view': 'project-settings.issue-type.jsm-cmp-customer-view'
        },
        'servicedesk-practice-custom-and-issue': {
            'service-management.queues.issue': 'servicedesk-practice-custom-issue',
            'service-management.queues.view': 'servicedesk-practice-custom-view'
        },
        'servicedesk-queues-custom-and-issue': {
            'service-management.queues.issue': 'servicedesk-queues-custom-issue',
            'service-management.queues.view': 'servicedesk-queues-custom-view'
        }
    },
    enableCompleteUsingDoubleRAF: true
};
const $344aa3e6287b1bb4$var$STRINGIFIED_FALLBACK_UFO_CONFIG = JSON.stringify($344aa3e6287b1bb4$var$FALLBACK_UFO_CONFIG);
const $344aa3e6287b1bb4$var$getUFOConfigFromStatsig = ()=>{
    try {
        // eslint-disable-next-line jira/ff/inline-expVal-params
        return JSON.parse((0, $2700E.expVal)('ufo_config', 'value', $344aa3e6287b1bb4$var$STRINGIFIED_FALLBACK_UFO_CONFIG));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to get UFO config from Statsig dynamic config:', error);
        // TODO: AFO-2949: Change the fallback to be `{}` once we have a stable config in Statsig when deprecating the FF 'ufo-use-statsig-config-jira'
        return $344aa3e6287b1bb4$var$FALLBACK_UFO_CONFIG;
    }
};
function $344aa3e6287b1bb4$var$getAdditionalJiraFields(interaction) {
    try {
        return {
            jira: (0, $4VJn4.getJiraCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
}

function $344aa3e6287b1bb4$var$loadJiraAnalyticsWebClient() {
    return Promise.resolve((parcelRequire("6Kdw4")));
}
function $344aa3e6287b1bb4$export$2e2bcd8739ae039() {
    const ufoConfigFromFF = (0, $i860n.fg)('ufo-use-statsig-config-jira') ? $344aa3e6287b1bb4$var$getUFOConfigFromStatsig() : $344aa3e6287b1bb4$var$FALLBACK_UFO_CONFIG;
    (0, $7sGEC.retrieveAndSetPageLoadTrace)((0, $6bEm8.default));
    (0, $5MNwZ.configure)((0, $lFkCC.jiraResourceTimingsConfig));
    (0, $bPWQO.startResourceTimingBuffer)();
    if (!(0, $i860n.fg)('jira-disable-ufo-bundle-eval-timings')) (0, $cUQPk.configure)((0, $eLaJ5.jiraBundleEvalTimingsConfig));
    (0, $9LXZM.configure)((0, $aYvm6.jiraSsrConfig));
    (0, $gQRLr.GlobalReactLooselyLazyProfiler).current = (0, $siTdT.ModuleLoadingProfiler);
    const perfPushExperienceRates = {
        'issue-view': 1,
        'issue-view-software': 1,
        'issue-view-serviceDesk': 1,
        'issue-view-embed': 1,
        'new-issue-navigator': 1,
        'classic-board': 1,
        'classic-backlog': 1,
        'next-gen-board': 1,
        'software-plan-timeline': 1,
        'next-gen-roadmap': 1,
        'classic-roadmap': 1,
        'next-gen-backlog': 1,
        'jwm.list-view': 1,
        'jwm.summary-view': 1,
        dashboard: 1,
        'global-new-issue-navigator': 1,
        'global-issue-navigator-jfe': 1,
        'issue-navigator': 1,
        'jwm.jwm-board-base': 1,
        'jwm.jwm-board-with-filters': 1,
        'jwm.jwm-board-with-issue-view': 1,
        'jira-board': 1,
        'jira-board-with-issue-view': 1,
        'servicedesk-queues-landing': 1,
        'servicedesk-practice-landing': 1,
        'servicedesk-practice-custom-issue': 1,
        'servicedesk-practice-custom-view': 1,
        'servicedesk-queues-custom-issue': 1,
        'servicedesk-queues-custom-view': 1,
        ...(0, $i860n.fg)('jira_list_nin_merge') ? {
            'software-list-nin': 1,
            'classic-list-nin': 1,
            'jwm-list-nin': 1,
            'jsm-list-nin': 1
        } : {
            'software-issue-navigator': 1,
            'issue-navigator-classic': 1,
            'issue-navigator-core': 1,
            'servicedesk-issues': 1
        },
        'assets-app-schemas-page': 1,
        'assets-schema': 1,
        'assets-object-view-page': 1,
        'work-item': 1
    };
    const ssrWhitelist = [
        'global-new-issue-navigator',
        'global-issue-navigator-jfe',
        'issue-view',
        'issue-view-software',
        'issue-view-serviceDesk',
        'issue-view-embed',
        'classic-board',
        'classic-backlog',
        'next-gen-backlog',
        ...(0, $i860n.fg)('jira_list_nin_merge') ? [
            'software-list-nin',
            'classic-list-nin',
            'jwm-list-nin',
            'jsm-list-nin'
        ] : [
            'software-issue-navigator',
            'issue-navigator-classic',
            'issue-navigator-core',
            'servicedesk-issues'
        ],
        'work-item'
    ];
    const doNotAbortActivePressInteractionsOnTransitionList = [
        'case-management-settings-create-case-note',
        'case-management-settings-duplicate-case-note'
    ];
    const assetsConfig = {
        classification: {
            all: true,
            allAtlassian: ({ entry: entry })=>{
                const isAtlassian = entry.name.includes('atl-paas.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js');
                return isAtlassian;
            },
            preloaded: ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
                return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
            }
        }
    };
    (0, $8swbq.init)($344aa3e6287b1bb4$var$loadJiraAnalyticsWebClient(), {
        ...ufoConfigFromFF,
        ...(0, $i860n.fg)('jsm-case-management-settings') ? {
            doNotAbortActivePressInteractionOnTransition: [
                ...ufoConfigFromFF.doNotAbortActivePressInteractionOnTransition ?? [],
                ...doNotAbortActivePressInteractionsOnTransitionList
            ]
        } : {},
        enableSegmentHighlighting: false,
        enableAdditionalPerformanceMarks: false,
        product: 'jira',
        region: (0, $6bEm8.default)('ajs-region') || 'unknown',
        additionalPayloadData: $344aa3e6287b1bb4$var$getAdditionalJiraFields,
        postInteractionLog: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        experimentalInteractionMetrics: {
            enabled: false,
            rates: perfPushExperienceRates
        },
        extraInteractionMetrics: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        manuallyTrackReactProfilerMounts: true,
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: (0, $i860n.fg)('uip_vc_devtools'),
            selectorConfig: {
                id: true,
                role: false,
                className: true,
                testId: false
            },
            ssrWhitelist: ssrWhitelist,
            ssrEnablePageLayoutPlaceholder: true,
            stopVCAtInteractionFinish: false,
            includeSSRInV3: true,
            includeSSRRatio: true,
            enabledVCRevisions: {
                all: (0, $i860n.fg)('ufo_disable_ttvc_v4') ? [] : [
                    'fy26.04'
                ]
            },
            trackLayoutShiftOffenders: true
        },
        enableBetterPageVisibilityApi: true,
        assetsConfig: assetsConfig,
        getReactHydrationStats: $l7jID.getReactHydrationStats
    });
}

});
parcelRegister("cUQPk", function(module, exports) {
$parcel$export(module.exports, "configure", () => $d7ef8f92c9895efb$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $d7ef8f92c9895efb$export$2eda1519e91a4386);

var $ldCFE = parcelRequire("ldCFE");
let $d7ef8f92c9895efb$var$config = null;
function $d7ef8f92c9895efb$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $d7ef8f92c9895efb$var$config = bundleEvalTimingConfiguration;
}
function $d7ef8f92c9895efb$var$getPerformanceObject() {
    return (window ?? {}).performance;
}
function $d7ef8f92c9895efb$export$2eda1519e91a4386(interactionStartTime) {
    if ($d7ef8f92c9895efb$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $d7ef8f92c9895efb$var$config;
    const performance = $d7ef8f92c9895efb$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $ldCFE.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $ldCFE.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("ldCFE", function(module, exports) {
$parcel$export(module.exports, "roundEpsilon", () => $61f9c3f8bb829dbb$export$56014375de40214b);
function $61f9c3f8bb829dbb$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("8swbq", function(module, exports) {
$parcel$export(module.exports, "init", () => $286cc108495e287e$export$2cd8252107eb640b);

var $he2vg = parcelRequire("he2vg");

var $egspI = parcelRequire("egspI");

var $c0jNd = parcelRequire("c0jNd");

var $gmMRH = parcelRequire("gmMRH");

var $1yDnt = parcelRequire("1yDnt");

var $7Ri80 = parcelRequire("7Ri80");

var $fPWhX = parcelRequire("fPWhX");

var $siTdT = parcelRequire("siTdT");

var $fOkhU = parcelRequire("fOkhU");

var $U6RKd = parcelRequire("U6RKd");

var $kKbVr = parcelRequire("kKbVr");

var $77Rn6 = parcelRequire("77Rn6");
let $286cc108495e287e$var$initialized = false;
function $286cc108495e287e$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $77Rn6.default)(onIdle);
    }
    (0, $siTdT.sinkInteractionHandler)(sinkFn);
}
function $286cc108495e287e$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $siTdT.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $77Rn6.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $286cc108495e287e$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $kKbVr.sinkTerminalErrorHandler)((errorData, context)=>{
        (0, $77Rn6.default)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $286cc108495e287e$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $siTdT.interactionExtraMetrics).sinkHandler((interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult)=>{
        (0, $77Rn6.default)(async ()=>{
            const payload = await createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $286cc108495e287e$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $77Rn6.default)(onIdle);
    }
    (0, $1yDnt.sinkExtraSearchPageInteractionHandler)(sinkFn);
}




function $286cc108495e287e$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($286cc108495e287e$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $gmMRH.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $gmMRH.isUFOEnabled)()) {
        $286cc108495e287e$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $U6RKd.initialisePressureObserver)();
    (0, $U6RKd.initialiseMemoryObserver)();
    if ((0, $egspI.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $7Ri80.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $7Ri80.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $he2vg.context).setGlobalContextManager(contextManager);
    }
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $gmMRH.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $siTdT.postInteractionLog).initializeVCObserver(vcOptions);
        if ((0, $gmMRH.isInteractionExtraMetricsEnabled)()) (0, $siTdT.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $fPWhX.setupHiddenTimingCapture)();
    (0, $c0jNd.startLighthouseObserver)();
    (0, $fPWhX.setupThrottleDetection)();
    $286cc108495e287e$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $fOkhU.getPerformanceObserver)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    const extraInteractionMetricsPayloadPackagePromise = (0, $gmMRH.isInteractionExtraMetricsEnabled)() ? (parcelRequire("dEWAL")) : Promise.resolve(undefined);
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("hCRvh")),
        (parcelRequire("7OYkE")),
        extraInteractionMetricsPayloadPackagePromise,
        (parcelRequire("nIo97"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createInteractionExtraMetricsPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $286cc108495e287e$var$sinkInteraction(instance, payloadPackage);
            if (config?.terminalErrors?.enabled) $286cc108495e287e$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $286cc108495e287e$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if ((0, $gmMRH.isInteractionExtraMetricsEnabled)() && createInteractionExtraMetricsPayloadPackage) $286cc108495e287e$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $286cc108495e287e$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $286cc108495e287e$var$sinkInteraction(awc, payloadPackage);
            if (config?.terminalErrors?.enabled) $286cc108495e287e$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $286cc108495e287e$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if ((0, $gmMRH.isInteractionExtraMetricsEnabled)() && createInteractionExtraMetricsPayloadPackage) $286cc108495e287e$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $286cc108495e287e$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}

});
parcelRegister("c0jNd", function(module, exports) {
$parcel$export(module.exports, "startLighthouseObserver", () => $b6a11944df2b212d$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $b6a11944df2b212d$export$b46cecdf698e4bb5);

var $g5O3V = parcelRequire("g5O3V");

var $488aA = parcelRequire("488aA");

var $d0ibI = parcelRequire("d0ibI");

var $fScba = parcelRequire("fScba");

var $4uNCh = parcelRequire("4uNCh");
function $b6a11944df2b212d$export$5ecf2aafafee3e0() {
    (0, $4uNCh.startLSObserver)();
    (0, $4uNCh.startLTObserver)();
}
function $b6a11944df2b212d$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $d0ibI.getTBT)(start, stop, (0, $fScba.EntriesBuffer)[(0, $488aA.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $g5O3V.getCLS)(start, stop, (0, $fScba.EntriesBuffer)[(0, $488aA.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("g5O3V", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $986dcaacb8078dbb$export$fc6227831ee7c7);
function $986dcaacb8078dbb$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $986dcaacb8078dbb$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        const allSourcesHaveSameRects = entry?.sources?.every(({ previousRect: previousRect, currentRect: currentRect })=>$986dcaacb8078dbb$var$isSameRects(previousRect, currentRect));
        return isWithinObservationWindow && !allSourcesHaveSameRects;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("488aA", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $772469005e678315$export$a4def92db6fc8e17);
const $772469005e678315$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("d0ibI", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $3908b54bf9f7900b$export$2d6e933b35bd3407);
const $3908b54bf9f7900b$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $3908b54bf9f7900b$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $3908b54bf9f7900b$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $3908b54bf9f7900b$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $3908b54bf9f7900b$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("fScba", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $6b794d013ca4dcba$export$f7dc16cbd16f7bbe);

var $488aA = parcelRequire("488aA");
class $6b794d013ca4dcba$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $6b794d013ca4dcba$export$f7dc16cbd16f7bbe = {
    [(0, $488aA.PerformanceObserverEntryTypes).LongTask]: new $6b794d013ca4dcba$export$2c6e86519c9e8188(),
    [(0, $488aA.PerformanceObserverEntryTypes).LayoutShift]: new $6b794d013ca4dcba$export$2c6e86519c9e8188()
};

});

parcelRegister("4uNCh", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $faebc7b0f3b056c1$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $faebc7b0f3b056c1$export$54fb8b6aaf70ec9c);

var $488aA = parcelRequire("488aA");

var $fScba = parcelRequire("fScba");
let $faebc7b0f3b056c1$var$pe = null;
function $faebc7b0f3b056c1$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($faebc7b0f3b056c1$var$pe !== null) return $faebc7b0f3b056c1$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $488aA.PerformanceObserverEntryTypes).LayoutShift) (0, $fScba.EntriesBuffer)[(0, $488aA.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $488aA.PerformanceObserverEntryTypes).LongTask) (0, $fScba.EntriesBuffer)[(0, $488aA.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $faebc7b0f3b056c1$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $faebc7b0f3b056c1$var$pe;
}
function $faebc7b0f3b056c1$export$768ccc3ab7bac3ea() {
    $faebc7b0f3b056c1$var$getObserver()?.observe({
        type: (0, $488aA.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $faebc7b0f3b056c1$export$54fb8b6aaf70ec9c() {
    $faebc7b0f3b056c1$var$getObserver()?.observe({
        type: (0, $488aA.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("fOkhU", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserver", () => $70ea871dd23ace73$export$17afbba0f16b4b19);

var $gmMRH = parcelRequire("gmMRH");

var $siTdT = parcelRequire("siTdT");

var $3MrYi = parcelRequire("3MrYi");
let $70ea871dd23ace73$var$performanceEventObserver;
const $70ea871dd23ace73$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
/**
 * Resolve the SelectorConfig for the performance-observer code path.
 *
 * In FedRAMP Moderate environments (when `getSelectorConfig()` returns the
 * forced all-`false` config) we honour that override; otherwise we fall back
 * to the historical default that enables every selector.
 */ function $70ea871dd23ace73$var$resolveSelectorConfig() {
    return (0, $gmMRH.getSelectorConfig)() ?? $70ea871dd23ace73$var$DEFAULT_SELECTOR_CONFIG;
}
function $70ea871dd23ace73$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $70ea871dd23ace73$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $70ea871dd23ace73$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($70ea871dd23ace73$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $70ea871dd23ace73$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $70ea871dd23ace73$export$17afbba0f16b4b19 = ()=>{
    $70ea871dd23ace73$var$performanceEventObserver = $70ea871dd23ace73$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $70ea871dd23ace73$export$e6be05b411ce21a6(entry);
    });
    return $70ea871dd23ace73$var$performanceEventObserver;
};
const $70ea871dd23ace73$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $siTdT.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $70ea871dd23ace73$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $3MrYi.default)($70ea871dd23ace73$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};

});
parcelRegister("3MrYi", function(module, exports) {
$parcel$export(module.exports, "default", () => $a09ad4a1a621250e$export$2e2bcd8739ae039);
const $a09ad4a1a621250e$var$nameCache = new WeakMap();
function $a09ad4a1a621250e$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $a09ad4a1a621250e$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $a09ad4a1a621250e$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $a09ad4a1a621250e$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $a09ad4a1a621250e$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $a09ad4a1a621250e$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $a09ad4a1a621250e$var$getAttributeSelector(currentElement, 'data-testid') || $a09ad4a1a621250e$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $a09ad4a1a621250e$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($a09ad4a1a621250e$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $a09ad4a1a621250e$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$a09ad4a1a621250e$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $a09ad4a1a621250e$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $a09ad4a1a621250e$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $a09ad4a1a621250e$var$getUniqueSelector(selectorConfig, element);
    $a09ad4a1a621250e$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $a09ad4a1a621250e$export$2e2bcd8739ae039 = $a09ad4a1a621250e$var$getElementName;

});


parcelRegister("U6RKd", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $6d4777c4a18067f9$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $6d4777c4a18067f9$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $6d4777c4a18067f9$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $6d4777c4a18067f9$export$a3271f53e91faab7);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $6d4777c4a18067f9$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $6d4777c4a18067f9$var$pressureRecordBuffer = [];
let $6d4777c4a18067f9$var$pressureObserver = null;
let $6d4777c4a18067f9$var$memoryRecordBuffer = [];
let $6d4777c4a18067f9$var$memoryInterval;
function $6d4777c4a18067f9$export$6c1060bed5fea050() {
    $6d4777c4a18067f9$var$pressureRecordBuffer.length = 0;
}
function $6d4777c4a18067f9$export$aa672c7221b183b0() {
    $6d4777c4a18067f9$var$memoryRecordBuffer.length = 0;
}
function $6d4777c4a18067f9$export$ec86686c1d2e65bc(filter) {
    $6d4777c4a18067f9$var$pressureRecordBuffer = $6d4777c4a18067f9$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $6d4777c4a18067f9$export$c0142ac82f5d0c28(filter) {
    $6d4777c4a18067f9$var$memoryRecordBuffer = $6d4777c4a18067f9$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $6d4777c4a18067f9$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $6d4777c4a18067f9$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $6d4777c4a18067f9$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $6d4777c4a18067f9$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $6d4777c4a18067f9$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $6d4777c4a18067f9$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $6d4777c4a18067f9$var$convertBytesToMegabytes($6d4777c4a18067f9$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            avgTotalJSHeapSizeInMB: $6d4777c4a18067f9$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $6d4777c4a18067f9$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $6d4777c4a18067f9$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $6d4777c4a18067f9$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $6d4777c4a18067f9$var$pressureObserver = new PressureObserver((records)=>{
                if ($6d4777c4a18067f9$var$pressureRecordBuffer.length + records.length <= $6d4777c4a18067f9$var$BUFFER_MAX_LENGTH) $6d4777c4a18067f9$var$pressureRecordBuffer.push(...records);
            });
            $6d4777c4a18067f9$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $6d4777c4a18067f9$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $6d4777c4a18067f9$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($6d4777c4a18067f9$var$memoryRecordBuffer.length <= $6d4777c4a18067f9$var$BUFFER_MAX_LENGTH) $6d4777c4a18067f9$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $6d4777c4a18067f9$export$10899ada382f2ae3() {
    clearInterval($6d4777c4a18067f9$var$memoryInterval);
}
function $6d4777c4a18067f9$export$b9fdd785f0fc1d40() {
    $6d4777c4a18067f9$var$pressureObserver?.disconnect();
}

});

parcelRegister("77Rn6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6a4c5e57dd3978f$export$2e2bcd8739ae039);

var $g8xyD = parcelRequire("g8xyD");

var $egspI = parcelRequire("egspI");
function $a6a4c5e57dd3978f$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $egspI.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $g8xyD.unstable_scheduleCallback)((0, $g8xyD.unstable_IdlePriority), work);
}
var $a6a4c5e57dd3978f$export$2e2bcd8739ae039 = $a6a4c5e57dd3978f$var$scheduleIdleCallback;

});

parcelRegister("dEWAL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2VYPD").then(()=>parcelRequire('apSGf'));

});

parcelRegister("hCRvh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aDwHW").then(()=>parcelRequire('h0zGh'));

});

parcelRegister("7OYkE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("giHtR").then(()=>parcelRequire('3PhiM'));

});

parcelRegister("nIo97", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("drION").then(()=>parcelRequire('gr7yZ'));

});


parcelRegister("5MNwZ", function(module, exports) {
$parcel$export(module.exports, "configure", () => $ff9c8b0e5715b665$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $ff9c8b0e5715b665$export$44487a86467333c3);

var $gmMRH = parcelRequire("gmMRH");
const $ff9c8b0e5715b665$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $ff9c8b0e5715b665$var$getAllowedParams() {
    const config = (0, $gmMRH.getConfig)();
    return config?.allowedResourcesParams || $ff9c8b0e5715b665$var$defaultAllowedParams;
}
function $ff9c8b0e5715b665$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $ff9c8b0e5715b665$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch  {
        return urlString;
    }
}
let $ff9c8b0e5715b665$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $ff9c8b0e5715b665$var$handleQueryParams(url);
    }
};
function $ff9c8b0e5715b665$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $ff9c8b0e5715b665$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $ff9c8b0e5715b665$var$config = newConfig;
}
function $ff9c8b0e5715b665$export$44487a86467333c3() {
    return $ff9c8b0e5715b665$var$config;
}

});

parcelRegister("bPWQO", function(module, exports) {
$parcel$export(module.exports, "startResourceTimingBuffer", () => $c898eb90c7809d66$export$a311cb1baa7d2d62);

var $eizWJ = parcelRequire("eizWJ");
function $c898eb90c7809d66$export$a311cb1baa7d2d62() {
    (0, $eizWJ.resourceTimingBuffer).start();
}

});
parcelRegister("eizWJ", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $11fbc429088d377b$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $11fbc429088d377b$export$4138a729ef1db028);

var $ldCFE = parcelRequire("ldCFE");
const $11fbc429088d377b$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $11fbc429088d377b$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $11fbc429088d377b$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $ldCFE.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $ldCFE.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $ldCFE.roundEpsilon)(entry.startTime),
            duration: (0, $ldCFE.roundEpsilon)(entry.duration),
            fetchStart: (0, $ldCFE.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $ldCFE.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $ldCFE.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $ldCFE.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $ldCFE.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $ldCFE.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $11fbc429088d377b$var$getPerformanceObject();
        const PerformanceObserver = $11fbc429088d377b$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($11fbc429088d377b$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $11fbc429088d377b$export$bea963256235a63e.timings = resources.map((resource)=>$11fbc429088d377b$export$bea963256235a63e.transformResource(resource));
        $11fbc429088d377b$export$bea963256235a63e.observer = new PerformanceObserver($11fbc429088d377b$export$bea963256235a63e.addTimings);
        $11fbc429088d377b$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($11fbc429088d377b$export$bea963256235a63e.observer) {
            $11fbc429088d377b$export$bea963256235a63e.observer.disconnect();
            $11fbc429088d377b$export$bea963256235a63e.observer = null;
        }
        $11fbc429088d377b$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$11fbc429088d377b$export$bea963256235a63e.transformResource(entry));
        const overflow = $11fbc429088d377b$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $11fbc429088d377b$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $11fbc429088d377b$export$bea963256235a63e.maxSize;
            $11fbc429088d377b$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $11fbc429088d377b$export$bea963256235a63e.timings.push(...entries);
    }
};
function $11fbc429088d377b$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $11fbc429088d377b$export$4138a729ef1db028(startTime, endTime) {
    const performance = $11fbc429088d377b$var$getPerformanceObject();
    const PerformanceObserver = $11fbc429088d377b$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$11fbc429088d377b$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$11fbc429088d377b$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $11fbc429088d377b$export$bea963256235a63e.timings.filter((timing)=>$11fbc429088d377b$var$isValidTiming(timing, startTime, endTime));
}

});


parcelRegister("9LXZM", function(module, exports) {
$parcel$export(module.exports, "configure", () => $f153fcd441cac7c0$export$8d21e34596265fa2);
$parcel$export(module.exports, "getEdgeTimingsIncludingCloudfront", () => $f153fcd441cac7c0$export$5300d1b82e594615);
$parcel$export(module.exports, "getSSRTimings", () => $f153fcd441cac7c0$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $f153fcd441cac7c0$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $f153fcd441cac7c0$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $f153fcd441cac7c0$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $f153fcd441cac7c0$export$1c4a9b5e6e22393d);
$parcel$export(module.exports, "getSSRSuccessBreakdown", () => $f153fcd441cac7c0$export$eb7c400973493903);
const $f153fcd441cac7c0$var$NESTED_METRIC_SEPARATOR = '/';
function $f153fcd441cac7c0$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $f153fcd441cac7c0$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $f153fcd441cac7c0$var$SSR_PREFIX = 'ssr';
function $f153fcd441cac7c0$var$mapKey(key) {
    if (key === 'total') return $f153fcd441cac7c0$var$SSR_PREFIX;
    return `${$f153fcd441cac7c0$var$SSR_PREFIX}${$f153fcd441cac7c0$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $f153fcd441cac7c0$var$config;
function $f153fcd441cac7c0$export$8d21e34596265fa2(ssrConfig) {
    $f153fcd441cac7c0$var$config = ssrConfig;
}
function $f153fcd441cac7c0$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return performance.getEntriesByType('navigation')?.[0];
}
function $f153fcd441cac7c0$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($f153fcd441cac7c0$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $f153fcd441cac7c0$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $f153fcd441cac7c0$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $f153fcd441cac7c0$export$5300d1b82e594615() {
    const serverTimingsByName = $f153fcd441cac7c0$var$getServerTimingsByName();
    const edgeTotalDuration = serverTimingsByName['cdn-downstream-fbl']?.duration ?? serverTimingsByName['atl-edge']?.duration;
    if (!edgeTotalDuration) return null;
    const edgeOffset = $f153fcd441cac7c0$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (serverTimingsByName['cdn-upstream-dns']?.duration || 0) + (serverTimingsByName['cdn-upstream-connect']?.duration || 0);
    const cfUpstreamDuration = (serverTimingsByName['cdn-upstream-fbl']?.duration || 0) - cfInternalDuration;
    const cfDownstreamDuration = (serverTimingsByName['cdn-downstream-fbl']?.duration || 0) - (serverTimingsByName['cdn-upstream-fbl']?.duration || 0);
    const atlEdgeDuration = serverTimingsByName['atl-edge']?.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: serverTimingsByName['cdn-downstream-fbl']?.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: serverTimingsByName['atl-edge-internal']?.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $f153fcd441cac7c0$export$bf7408e83532dcd0() {
    const defaultSSRTimings = $f153fcd441cac7c0$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof $f153fcd441cac7c0$var$config?.getTimings === 'function') configTimings = $f153fcd441cac7c0$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($f153fcd441cac7c0$var$filterEntry(entry[1])) acc[$f153fcd441cac7c0$var$mapKey(entry[0])] = $f153fcd441cac7c0$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $f153fcd441cac7c0$export$c7ad864055e75537() {
    return !!$f153fcd441cac7c0$var$config?.getDoneMark();
}
function $f153fcd441cac7c0$export$5eade9354185583d() {
    return $f153fcd441cac7c0$var$config?.getSsrPhaseSuccess?.();
}
function $f153fcd441cac7c0$export$3def7672244bab0c() {
    return $f153fcd441cac7c0$var$config?.getDoneMark() ?? undefined;
}
function $f153fcd441cac7c0$export$1c4a9b5e6e22393d() {
    if (!$f153fcd441cac7c0$var$config?.getFeatureFlags) return undefined;
    try {
        return $f153fcd441cac7c0$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
function $f153fcd441cac7c0$export$eb7c400973493903() {
    if (!$f153fcd441cac7c0$var$config?.getSsrSuccessBreakdown) return undefined;
    try {
        return $f153fcd441cac7c0$var$config.getSsrSuccessBreakdown() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}

});

parcelRegister("7sGEC", function(module, exports) {
$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $2d67bbadfc5ae751$export$1a71d2bbe236de99);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $anDmR = parcelRequire("anDmR");
let $2d67bbadfc5ae751$var$alreadySet = false;
const $2d67bbadfc5ae751$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $2d67bbadfc5ae751$var$alreadySet) return;
    $2d67bbadfc5ae751$var$alreadySet = true;
    const traceId = getMeta('X-B3-TraceId');
    // Only set active trace if a valid trace ID exists
    if (!traceId) return;
    const spanId = traceId.substring(traceId.length - 16); // set root span ID by convention
    (0, $anDmR.setActiveTrace)(traceId, spanId, 'page_load');
};

});

parcelRegister("4VJn4", function(module, exports) {
$parcel$export(module.exports, "getJiraCustomData", () => $07abd57fbeb4f94c$export$abf5e20822fa925);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $bMqRl = parcelRequire("bMqRl");

var $b7o89 = parcelRequire("b7o89");

var $3iQow = parcelRequire("3iQow");

var $5IsT1 = parcelRequire("5IsT1");

var $4wNfa = parcelRequire("4wNfa");

var $8NM4G = parcelRequire("8NM4G");

var $dxZG0 = parcelRequire("dxZG0");

var $amr7h = parcelRequire("amr7h");

var $33KhO = parcelRequire("33KhO");

var $c8A57 = parcelRequire("c8A57");

var $jVxz3 = parcelRequire("jVxz3");

var $iGN6O = parcelRequire("iGN6O");

var $cZaFA = parcelRequire("cZaFA");

var $9KeZ8 = parcelRequire("9KeZ8");

function $07abd57fbeb4f94c$export$abf5e20822fa925(interaction) {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const shard = (0, $6bEm8.default)('ajs-shard');
    if (shard !== null && shard !== '') customData.shard = shard;
    customData['jira:productEditions'] = (0, $bMqRl.getProductEditions)();
    customData['network:assetEncoding'] = (0, $b7o89.getAssetEncoding)();
    customData['stickyVersions:state'] = (0, $cZaFA.getStickyVersionsState)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const buildVariant = window.BUILD_VARIANT;
    if (buildVariant) customData['app:buildVariant'] = buildVariant;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const bundlerVersion = window.BUNDLER_VERSION;
    if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
    customData.httpProtocol = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = apdex?.[0]?.stopTime ?? end;
    customData.memory = (0, $dxZG0.getMemoryUsageReport)({
        start: start,
        stop: stop
    });
    const lightHouseMetrics = (0, $4wNfa.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $8NM4G.getMarks)({
            start: start
        }),
        ...(0, $amr7h.getPageSizeMetrics)(),
        ...(0, $amr7h.getExtraNavigationTimings)(),
        ...(0, $amr7h.getPopInfo)(),
        ...(0, $jVxz3.getServerDurationMetrics)(),
        ...(0, $c8A57.getRouterResourceMetrics)(),
        ...(0, $9KeZ8.getWRMStats)(),
        ...(0, $amr7h.getPageSizeInfo)({
            start: start,
            stop: stop
        }),
        ...(0, $3iQow.getCacheHitRatio)({
            start: start
        }),
        ...(0, $5IsT1.getCHRInfo)({
            start: start
        }),
        ...(0, $iGN6O.getSSRStateInformation)(),
        ...(0, $i860n.fg)('jfp_gpu_renderer_telemetry') && (0, $33KhO.getGpuState)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:web': window.BUILD_KEY,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:ssr': window.SSR_BUILD_KEY,
        'app:framework:name': 'react',
        'app:framework:version': (0, $euxye.version)
    };
    return customData;
}

});
parcelRegister("b7o89", function(module, exports) {
$parcel$export(module.exports, "getAssetEncoding", () => $717f69c346af8b3e$export$fd12d8f45e126585);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ function $717f69c346af8b3e$export$fd12d8f45e126585() {
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
}

});

parcelRegister("3iQow", function(module, exports) {
$parcel$export(module.exports, "getCacheHitRatio", () => $0314602709d82848$export$e8a9322c3d9da8a6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fDxFn = parcelRequire("fDxFn");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $0314602709d82848$var$cacheableTypes = [
    'script',
    'link'
];
const $0314602709d82848$var$CACHE_NETWORK = 'network';
const $0314602709d82848$var$CACHE_MEMORY = 'memory';
const $0314602709d82848$var$CACHE_DISK = 'disk';
const $0314602709d82848$var$calculateTransferType = (type, duration, size)=>{
    if (!$0314602709d82848$var$cacheableTypes.includes(type)) return $0314602709d82848$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $0314602709d82848$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $0314602709d82848$var$CACHE_DISK;
    if (size === undefined) return null;
    return $0314602709d82848$var$CACHE_NETWORK;
};
const $0314602709d82848$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        for (const entry of (0, $fDxFn.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $0314602709d82848$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("5IsT1", function(module, exports) {
$parcel$export(module.exports, "getCHRInfo", () => $15dae51370feebe3$export$9e005e111be93521);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6xuJS = parcelRequire("6xuJS");

var $fDxFn = parcelRequire("fDxFn");

var $hjvw8 = parcelRequire("hjvw8");
const $15dae51370feebe3$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
const $15dae51370feebe3$export$1faf7d001841a41c = ()=>(0, $6xuJS.getMark)($15dae51370feebe3$var$SPA_SSR_RENDERED)?.startTime || null;
const $15dae51370feebe3$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = $15dae51370feebe3$export$1faf7d001841a41c();
    const reporter = new (0, $hjvw8.CHRReporter)(ssrMark);
    try {
        // oxlint-disable-next-line typescript/consistent-type-assertions
        for (const entry of (0, $fDxFn.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("hjvw8", function(module, exports) {
$parcel$export(module.exports, "CHRReporter", () => $e07bf69cb804684e$export$7d0d4cfb6455ffa5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7h7B5 = parcelRequire("7h7B5");
class $e07bf69cb804684e$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $7h7B5.CHRSummary)();
        this.all = new (0, $7h7B5.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    isPreloaded(item) {
        const isPreloadedByLink = item.initiatorType === 'link';
        const isPreloadedByPreloadModule = item.initiatorType === 'other' && item.name?.endsWith('.js');
        const isBeforeSSR = this.ssrMark === null || item.startTime < this.ssrMark;
        return (isPreloadedByLink || isPreloadedByPreloadModule) && isBeforeSSR;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (this.isPreloaded(item)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $e07bf69cb804684e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $7h7B5.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $e07bf69cb804684e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $7h7B5.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $e07bf69cb804684e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $7h7B5.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $e07bf69cb804684e$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $7h7B5.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $7h7B5.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $e07bf69cb804684e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $7h7B5.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $e07bf69cb804684e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $7h7B5.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $e07bf69cb804684e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $7h7B5.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $e07bf69cb804684e$export$7d0d4cfb6455ffa5.round((summary.size[(0, $7h7B5.CHRSummary).MEMORY_KEY] + summary.size[(0, $7h7B5.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}
$e07bf69cb804684e$export$7d0d4cfb6455ffa5.displayName = "CHRReporter";

});
parcelRegister("7h7B5", function(module, exports) {
$parcel$export(module.exports, "CHRSummary", () => $a441ba2d4fb94ba0$export$783d6618ee601ba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lQY81 = parcelRequire("lQY81");
const $a441ba2d4fb94ba0$var$calculateTransferType = (name, type, duration, size)=>{
    if (!(0, $lQY81.cacheableTypes).includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    if ((size === undefined || size === 0) && duration === 0) return $a441ba2d4fb94ba0$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $a441ba2d4fb94ba0$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $a441ba2d4fb94ba0$export$783d6618ee601ba.NETWORK_KEY;
};
class $a441ba2d4fb94ba0$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $a441ba2d4fb94ba0$var$calculateTransferType(item.name, item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$a441ba2d4fb94ba0$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$a441ba2d4fb94ba0$export$783d6618ee601ba.DISK_KEY]: 0,
            [$a441ba2d4fb94ba0$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$a441ba2d4fb94ba0$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$a441ba2d4fb94ba0$export$783d6618ee601ba.DISK_KEY]: 0,
            [$a441ba2d4fb94ba0$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}
$a441ba2d4fb94ba0$export$783d6618ee601ba.displayName = "CHRSummary";

});
parcelRegister("lQY81", function(module, exports) {
$parcel$export(module.exports, "cacheableTypes", () => $077e60731a4c25e7$export$5e1aa91d6932ddaa);
/* eslint-disable jira/filename-case */ /* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $077e60731a4c25e7$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});




parcelRegister("4wNfa", function(module, exports) {
$parcel$export(module.exports, "getLighthouseMetrics", () => $c0a757449e1c1a0a$export$b46cecdf698e4bb5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ll8ln = parcelRequire("ll8ln");

var $3GsAk = parcelRequire("3GsAk");

var $hbMWH = parcelRequire("hbMWH");

var $7oVxk = parcelRequire("7oVxk");

var $hf9Y4 = parcelRequire("hf9Y4");
function $c0a757449e1c1a0a$export$5ecf2aafafee3e0() {
    (0, $hf9Y4.startLSObserver)();
    (0, $hf9Y4.startLTObserver)();
}
const $c0a757449e1c1a0a$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $hbMWH.getTBT)(start, stop, (0, $7oVxk.EntriesBuffer)[(0, $3GsAk.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $ll8ln.getCLS)(start, stop, (0, $7oVxk.EntriesBuffer)[(0, $3GsAk.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("ll8ln", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $b2494b48ac335731$export$fc6227831ee7c7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $b2494b48ac335731$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // oxlint-disable-next-line typescript/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("3GsAk", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $0f29b14fc4e730ee$export$a4def92db6fc8e17);
/* eslint-disable jira/filename-case */ const $0f29b14fc4e730ee$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("hbMWH", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $536aab303ba1cfad$export$2d6e933b35bd3407);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $536aab303ba1cfad$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $536aab303ba1cfad$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $536aab303ba1cfad$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $536aab303ba1cfad$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $536aab303ba1cfad$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("7oVxk", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $9acaf6d9a7e516c2$export$f7dc16cbd16f7bbe);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3GsAk = parcelRequire("3GsAk");
class $9acaf6d9a7e516c2$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
$9acaf6d9a7e516c2$export$2c6e86519c9e8188.displayName = "BufferWithMaxLength";
const $9acaf6d9a7e516c2$export$f7dc16cbd16f7bbe = {
    [(0, $3GsAk.PerformanceObserverEntryTypes).LongTask]: new $9acaf6d9a7e516c2$export$2c6e86519c9e8188(),
    [(0, $3GsAk.PerformanceObserverEntryTypes).LayoutShift]: new $9acaf6d9a7e516c2$export$2c6e86519c9e8188()
};

});

parcelRegister("hf9Y4", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $ac0a22b80e0bc1da$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $ac0a22b80e0bc1da$export$54fb8b6aaf70ec9c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3GsAk = parcelRequire("3GsAk");

var $7oVxk = parcelRequire("7oVxk");
let $ac0a22b80e0bc1da$var$pe = null;
const $ac0a22b80e0bc1da$var$getObserver = ()=>{
    if ($ac0a22b80e0bc1da$var$pe !== null) return $ac0a22b80e0bc1da$var$pe;
    $ac0a22b80e0bc1da$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $3GsAk.PerformanceObserverEntryTypes).LayoutShift) (0, $7oVxk.EntriesBuffer)[(0, $3GsAk.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $3GsAk.PerformanceObserverEntryTypes).LongTask) (0, $7oVxk.EntriesBuffer)[(0, $3GsAk.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $ac0a22b80e0bc1da$var$pe;
};
const $ac0a22b80e0bc1da$export$768ccc3ab7bac3ea = ()=>{
    $ac0a22b80e0bc1da$var$getObserver().observe({
        type: (0, $3GsAk.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $ac0a22b80e0bc1da$export$54fb8b6aaf70ec9c = ()=>{
    $ac0a22b80e0bc1da$var$getObserver().observe({
        type: (0, $3GsAk.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("8NM4G", function(module, exports) {
$parcel$export(module.exports, "getMarks", () => $75ed13ff4f390457$export$9d952633c9c2237b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $a622V = parcelRequire("a622V");

var $lhWE3 = parcelRequire("lhWE3");
const $75ed13ff4f390457$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $a622V.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $lhWE3.JS_EVAL_START)) && !item.name.endsWith((0, $lhWE3.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};

});

parcelRegister("dxZG0", function(module, exports) {
$parcel$export(module.exports, "getMemoryUsageReport", () => $a3955aa27ac5dbed$export$e5bd2d61c7c80651);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */ const $a3955aa27ac5dbed$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const sessionTime = Math.round(stop - start);
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("amr7h", function(module, exports) {
$parcel$export(module.exports, "getPageSizeMetrics", () => $9904d4a9e2886a72$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $9904d4a9e2886a72$export$b37a70af06e58097);
$parcel$export(module.exports, "getPopInfo", () => $9904d4a9e2886a72$export$e590d0a3e226abd8);
$parcel$export(module.exports, "getPageSizeInfo", () => $9904d4a9e2886a72$export$b72e035af6568be7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fDxFn = parcelRequire("fDxFn");
// Helper function to safely access globalThis.bifrostPayloadStats
const $9904d4a9e2886a72$var$getBifrostPayloadStats = ()=>{
    // @ts-expect-error - globalThis.bifrostPayloadStats is not in standard TypeScript definitions
    return globalThis.bifrostPayloadStats;
};
const $9904d4a9e2886a72$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $9904d4a9e2886a72$export$b37a70af06e58097 = ()=>{
    if (!(0, $fDxFn.default)) return {};
    const navigation = (0, $fDxFn.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $9904d4a9e2886a72$export$e590d0a3e226abd8 = ()=>{
    if (!(0, $fDxFn.default)) return {};
    const navigation = (0, $fDxFn.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        atlEdgePop: // @ts-expect-error - TS2339 - Property 'serverTiming' does not exist on type 'PerformanceEntry'.
        navigation.serverTiming?.find((entry)=>entry?.name === 'atl-edge-pop')?.description ?? undefined,
        cfPop: // @ts-expect-error - TS2339 - Property 'serverTiming' does not exist on type 'PerformanceEntry'.
        navigation.serverTiming?.find((entry)=>entry?.name === 'cdn-pop')?.description ?? undefined
    };
};
const $9904d4a9e2886a72$var$assetsTypes = [
    'script',
    'link'
];
const $9904d4a9e2886a72$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $9904d4a9e2886a72$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // oxlint-disable-next-line typescript/consistent-type-assertions
    for (const entry of (0, $fDxFn.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($9904d4a9e2886a72$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    const bifrostStats = $9904d4a9e2886a72$var$getBifrostPayloadStats();
    if (bifrostStats) {
        const sizeSplit = {};
        returnValue['size:split'] = sizeSplit;
        const labelsToCheck = [
            'preHtml',
            'serverToClientEvents',
            'featureFlags',
            'wrmResources',
            'serverPerfTrace',
            'preloadAssets',
            'preloadTags',
            'statsigGateValues',
            'earlyFeatureFlags',
            'inlineScripts',
            'contextualPreload',
            'contextualState',
            'earlyEntryScript',
            'inlineCss',
            'langPackPreloads',
            'langPackScripts',
            'externalScripts',
            'metaTags',
            'lazyPreloads',
            'spaHtml'
        ];
        labelsToCheck.forEach((label)=>{
            const value = bifrostStats[label];
            if (typeof value === 'number') sizeSplit[label] = value;
        });
    }
    return returnValue;
};

});

parcelRegister("33KhO", function(module, exports) {
$parcel$export(module.exports, "getGpuState", () => $75474d91bd734111$export$8a8cdb5cfcde66d1);

var $u9iDa = parcelRequire("u9iDa");
// Substrings indicating software rendering (no real GPU acceleration).
const $75474d91bd734111$var$SOFTWARE_MARKERS = [
    'swiftshader',
    'llvmpipe',
    'softpipe',
    'software',
    'microsoft basic render'
];
// Substrings indicating a virtual GPU / hypervisor / remote display (VDI tell).
const $75474d91bd734111$var$VIRTUAL_MARKERS = [
    'vmware',
    'virtualbox',
    'parallels',
    'qemu',
    'virgl',
    'microsoft remote display',
    'microsoft hyper-v',
    'citrix',
    'red hat virtio'
];
const $75474d91bd734111$var$classifyRenderer = (renderer)=>{
    const r = renderer.toLowerCase();
    if (!r) return 'unknown';
    if ($75474d91bd734111$var$VIRTUAL_MARKERS.some((m)=>r.includes(m))) return 'virtual';
    if ($75474d91bd734111$var$SOFTWARE_MARKERS.some((m)=>r.includes(m))) return 'software';
    return 'hardware';
};
const $75474d91bd734111$export$8a8cdb5cfcde66d1 = ()=>{
    const state = {
        'gpu:renderer': '',
        'gpu:vendor': '',
        'gpu:class': 'unknown',
        'gpu:unmasked': false,
        'gpu:webglAvailable': false
    };
    try {
        const doc = (0, $u9iDa.getDocument)();
        if (!doc) return state;
        const canvas = doc.createElement('canvas');
        // `getContext` returns the precise context type per overload, so no type
        // assertion is needed: WebGL2RenderingContext | WebGLRenderingContext.
        const gl = canvas.getContext('webgl2') ?? canvas.getContext('webgl');
        if (!gl) // No WebGL at all — a (weak) VM / locked-down signal.
        return state;
        state['gpu:webglAvailable'] = true;
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        let renderer = '';
        let vendor = '';
        if (debugInfo) {
            renderer = String(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) ?? '');
            vendor = String(gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) ?? '');
            state['gpu:unmasked'] = true;
        } else {
            // Privacy masking blocked the unmasked read; fall back to generic.
            renderer = String(gl.getParameter(gl.RENDERER) ?? '');
            vendor = String(gl.getParameter(gl.VENDOR) ?? '');
            state['gpu:unmasked'] = false;
        }
        state['gpu:renderer'] = renderer.slice(0, 256);
        state['gpu:vendor'] = vendor.slice(0, 128);
        state['gpu:class'] = $75474d91bd734111$var$classifyRenderer(renderer);
        const loseContext = gl.getExtension('WEBGL_lose_context');
        if (loseContext) loseContext.loseContext();
    } catch  {
    // Never let telemetry break a page load; keep the default 'unknown' state.
    }
    return state;
};

});

parcelRegister("c8A57", function(module, exports) {
$parcel$export(module.exports, "getRouterResourceMetrics", () => $ce3b791f685e5dd7$export$e703af446a67c7f4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $ce3b791f685e5dd7$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("jVxz3", function(module, exports) {
$parcel$export(module.exports, "getServerDurationMetrics", () => $475f6d7b52355a08$export$efd8b60b870e5282);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $475f6d7b52355a08$export$efd8b60b870e5282 = ()=>{
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // oxlint-disable-next-line typescript/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("iGN6O", function(module, exports) {
$parcel$export(module.exports, "getSSRStateInformation", () => $8b64350371d92de8$export$9a46186893ad76bd);
/* eslint-disable jira/filename-case */ 
var $6xuJS = parcelRequire("6xuJS");

var $1j6ST = parcelRequire("1j6ST");

var $i860n = parcelRequire("i860n");
const $8b64350371d92de8$var$getState = ()=>{
    // @ts-expect-error -- __SSR_FALLBACK__ is set by static fallback. not in global typings.
    if (globalThis.__SSR_FALLBACK__) return 'static-fallback';
    if ((0, $6xuJS.getMark)('ssr.spa.state')?.startTime) return 'success';
    if ((0, $6xuJS.getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
    return 'static-fallback';
};
const $8b64350371d92de8$export$9a46186893ad76bd = ()=>{
    return {
        'ssr:state': $8b64350371d92de8$var$getState(),
        ...(0, $i860n.fg)('nin_ssr_resource_timeout_info') && {
            'ssr:resourceTimeout': (0, $1j6ST.getSsrResourceTimeout)()
        }
    };
};

});

parcelRegister("cZaFA", function(module, exports) {
$parcel$export(module.exports, "getStickyVersionsState", () => $4769998df94e117d$export$4ace2d93f0a81ca0);
/* eslint-disable jira/filename-case */ const $4769998df94e117d$export$4ace2d93f0a81ca0 = ()=>{
    const stickyVersionState = globalThis.STICKY_VERSION_STATE ?? 'na';
    return stickyVersionState;
};

});

parcelRegister("9KeZ8", function(module, exports) {
$parcel$export(module.exports, "getWRMStats", () => $003b1b1bfe684062$export$d2d916ddd03b82bc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $003b1b1bfe684062$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("eLaJ5", function(module, exports) {
$parcel$export(module.exports, "jiraBundleEvalTimingsConfig", () => $b96611fde04478e8$export$791b8c0cbd574ea9);
/* eslint-disable jira/filename-case */ 
var $lhWE3 = parcelRequire("lhWE3");
const $b96611fde04478e8$export$791b8c0cbd574ea9 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $lhWE3.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $lhWE3.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $lhWE3.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $lhWE3.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("lFkCC", function(module, exports) {
$parcel$export(module.exports, "jiraResourceTimingsConfig", () => $fa8c3d200d134971$export$8fa71550bcdc2104);

var $21iIq = parcelRequire("21iIq");

var $i860n = parcelRequire("i860n");

var $1awbE = parcelRequire("1awbE");

var $59zD6 = parcelRequire("59zD6");
const $fa8c3d200d134971$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $fa8c3d200d134971$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $1awbE.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $fa8c3d200d134971$var$getFileName = (url)=>$fa8c3d200d134971$var$isWRMResource(url) ? $fa8c3d200d134971$var$getWRMAssetName(url) : (0, $1awbE.sanitiseAssetName)(false)(url);
// Original replacement chain, kept untouched for the feature-gate-off path.
const $fa8c3d200d134971$var$normalizePathLegacy = (pathname)=>pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/gi, '<uuid>').replace(/\/\d+$/i, '/<id>');
// Consolidated replacement chain (see JIV-22404). All the segment-specific project-key
// replacements from the legacy chain above (project/agent/servicedesk/browse/automation/
// pagination/permissions/async/dialog/itsm) plus every segment discovered via UGC audits
// of production timings:resource URLs (projectlandingpage/epicIssueTypeIds/
// connectprojectconfig/roles) are collapsed into a single alternation instead of one
// `.replace()` per segment. Likewise, the mid-path and end-of-path issue-key
// replacements are collapsed into one pattern. This also fixes a pre-existing bug where
// the /user/ hex/colon character class could partially match literal path words that
// start with a hex-like letter (e.g. /user/assignable -> /user/<user-id>ssignable).
const $fa8c3d200d134971$var$normalizePathOptimized = (pathname)=>pathname// Project/space key character class allows `_` and a leading digit: real keys
    // can contain underscores (e.g. BASE_TS, AMB_2339) or start with a digit (e.g.
    // 2LV, 3DPLUS). `_` counts as a \w character, so without it in the class the
    // trailing `\b` boundary check never succeeds and the whole match silently
    // fails, leaking the raw key. The `(?=[A-Z0-9_]*[A-Z])` lookahead requires at
    // least one letter somewhere in the value so a purely-numeric segment (a plain
    // id, not a key) is never swallowed here - see the servicedesk-direct pattern
    // below for why that distinction matters.
    .replace(/\/(project|agent|servicedesk|browse|automation|pagination|permissions|async|dialog|itsm|projectlandingpage|epicIssueTypeIds|connectprojectconfig|roles|kb|knowledge|createmeta|space)(-config|-data|s)?\/(?=[A-Z0-9_]*[A-Z])[A-Z0-9_]+\b/g, '/$1$2/<project-key>')// Bare project key directly under /servicedesk/<id>/ with no "project" segment
    // name in between, e.g. /rest/servicedesk/2/CTECH/settings/feedback. The
    // lookahead above is what stops the numeric <id> here from being consumed as
    // the "project key" by the main alternation before this pattern gets to run.
    .replace(/\/servicedesk\/(\d+)\/(?=[A-Z0-9_]*[A-Z])[A-Z0-9_]+\b/g, '/servicedesk/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>')// Three-part test-management keys, e.g. MP-TC-4567 (Xray-style "<project>-TC-<id>").
    // Must run before the two-part issue-key replacement below: it wouldn't match this
    // shape anyway (the middle segment isn't purely digits), but keeping this first
    // avoids relying on that and keeps the "more specific pattern first" convention.
    .replace(/\/(\w+)-[A-Z]+-(\d+)(\/|$)/g, '/<issue-key>$3')// Issue key anywhere in the path, whether mid-path (trailing slash) or the final
    // segment. The numeric part may have a single leading letter for test-management
    // keys like APCONV-T2207 (test case) or SAP-R257 (test run).
    .replace(/\/(\w+)-([A-Z]?\d+)(\/|$)/g, '/<issue-key>$3')// Bare project key under /request/ once dash-number issue keys are already
    // resolved above, e.g. /rest/servicedeskapi/request/INFRA
    .replace(/\/request\/(?=[A-Z0-9_]*[A-Z])[A-Z0-9_]+\b/g, '/request/<project-key>').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+(?![a-z])/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/gi, '<uuid>').replace(/\/\d+$/i, '/<id>').replace(/\/noeyeball\/.*$/g, '/<noeyeball-stuff>').replace(/\/issue\/[A-Z0-9\-_]+/g, '/issue/<issue-key>')// Colon-delimited project ids, e.g.
    // /universal_avatar/type/issuetype/owner/project:10275
    .replace(/project:\d+/g, 'project:<id>').replace(/<project-key>.*?(\/|$)/g, '<project-key>/').replace(/\/(analyticscontext|addons|board|properties|field|rule)\/.*?(\/|$)/g, '/$1/<value>/')// Slash-wrapped numeric/decimal ids. Uses a lookahead for the trailing slash
    // instead of consuming it, so consecutive numeric segments (e.g.
    // /dashboards/2/10101/gadget) each get their own match instead of the second
    // segment losing its leading slash to the first match.
    .replace(/\/[\d.]+(?=\/)/g, '/<id>')// Numeric filenames with an extension, e.g. /rest/dashboards/<id>/29830.json
    // (the trailing-id replacement above only matches when the digits are the very
    // last characters, so a ".json" suffix defeats it).
    .replace(/\/\d+\.(\w+)$/, '/<id>.$1')// Property/setting keys with a numeric id suffix baked in, e.g.
    // userProperties/viewSwitching-modifiedView-3238 or
    // upload-user-collection-1964945121. Runs last so plain PROJECT-123 shaped
    // segments are already resolved by the issue-key replacement above.
    .replace(/-\d{2,}(\/|$)/g, '-<id>$1');
const $fa8c3d200d134971$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(url, true);
    /**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */ const { operation: operation, operationName: operationName } = parsedUrl.query;
    let operationNameOverride = operation ?? operationName;
    // Normalize pathname with same replacements to match against restUrlsToTrack
    const normalizedPath = (0, $i860n.fg)('jiv_22404_sanitise_extra_url_patterns') ? $fa8c3d200d134971$var$normalizePathOptimized(parsedUrl.pathname) : $fa8c3d200d134971$var$normalizePathLegacy(parsedUrl.pathname);
    // Inject synthetic operation names for tracked endpoints when none provided.
    if (!operationNameOverride) {
        for (const { api: api, operationName: opName } of (0, $59zD6.restUrlsToTrack))if (normalizedPath.includes(api)) {
            operationNameOverride = opName;
            break;
        }
    }
    if (operationNameOverride) return `/${operationNameOverride}?operation=${operationNameOverride}`;
    return normalizedPath;
};
const $fa8c3d200d134971$export$8fa71550bcdc2104 = {
    sanitiseEndpoints: $fa8c3d200d134971$var$sanitiseEndpoints,
    mapResources: $fa8c3d200d134971$var$getFileName,
    hasTimingHeaders: (url)=>url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || ((0, $i860n.fg)('jfp_update_cdn_allowlist') ? url.includes('jira-fe') : false) || $fa8c3d200d134971$var$isWRMResource(url),
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});
parcelRegister("59zD6", function(module, exports) {
$parcel$export(module.exports, "restUrlsToTrack", () => $80406a8789d0b8b3$export$e4443aca46b063af);
const $80406a8789d0b8b3$export$e4443aca46b063af = [
    {
        api: '/rest/api/3/issue/<id>/comment',
        operationName: 'rest_api_3_issue_<issueid>_comment',
        source: 'src/packages/issue/ai-agent-sessions/src/ui/refinement-session/index.tsx'
    },
    {
        api: '/rest/api/3/issue/<id>/comment',
        operationName: 'rest_api_3_issue_<issueid>_comment',
        source: 'src/packages/issue/ai-agent-sessions/src/ui/refinement-session/index.tsx'
    },
    {
        api: '/gateway/api/assist/ai/v2/',
        operationName: 'gateway_api_assist_ai_v2_<request.ai_feature_path>',
        source: 'src/packages/issue/ai-assistance-service-client/src/services/ai-features-client/index.tsx'
    },
    {
        api: '/gateway/api/assist/ai/v2/ai-feature/jirasimilarissues',
        operationName: 'gateway_api_assist_ai_v2_ai_feature_jirasimilarissues',
        source: 'src/packages/issue/ai-related-issues/src/services/use-fetch-related-issues/index.tsx'
    },
    {
        api: '/gateway/api/graphql',
        operationName: 'gateway_api_graphql',
        source: 'src/packages/issue/ai-related-3p-resources-package/src/services/use-ai-related-3p-resources.tsx'
    },
    {
        api: '/rest/api/3/issue/<id>/remotelink',
        operationName: 'rest_api_3_issue_<issueid>_remotelink',
        source: 'src/packages/issue/ai-related-3p-resources-package/src/services/utils.tsx'
    },
    {
        api: '/rest/api/2/issue',
        operationName: 'rest_api_2_issue',
        source: 'src/packages/issue/ai-work-breakdown/src/services/use-bulk-create-issue/utils.tsx'
    },
    {
        api: '/rest/api/3/user/assignable/search?issueKey=<issue-key>&recommend=true&query=',
        operationName: 'rest_api_3_user_assignable_search',
        source: 'src/packages/issue/assignee/src/assignee-view.tsx'
    },
    {
        api: '/rest/api/2/attachment/<uuid>',
        operationName: 'rest_api_2_attachment_<attachmentid>',
        source: 'src/packages/issue/attachments-store/src/common/utils.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>/remotelink?globalId=<uuid>',
        operationName: 'rest_api_2_issue_<issuekey>_remotelink',
        source: 'src/packages/issue/attachments-store/src/common/utils.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>/remotelink/<uuid>',
        operationName: 'rest_api_3_issue_<issuekey>_remotelink_<unlinkingremotelinkid>',
        source: 'src/packages/issue/attachments-store/src/common/utils.tsx'
    },
    {
        api: '/rest/confluenceIssueLink/1/confluence?issueId=<id>',
        operationName: 'rest_confluenceissuelink_1_confluence',
        source: 'src/packages/issue/attachments-store/src/common/utils.tsx'
    },
    {
        api: '/rest/api/3/issue/<id>/remotelink',
        operationName: 'rest_api_3_issue_<issueid>_remotelink',
        source: 'src/packages/issue/attachments-store/src/common/utils.tsx'
    },
    {
        api: '/gateway/api/graphql',
        operationName: 'gateway_api_graphql',
        source: 'src/packages/issue/attachments-store/src/common/utils.tsx'
    },
    {
        api: '/gateway/api/object-resolver/providers?operation=AttachmentsRemoteProviders',
        operationName: 'gateway_api_object_resolver_providers',
        source: 'src/packages/issue/issue-attachments-view/src/add-resources/search-resources/index.tsx'
    },
    {
        api: '/gateway/api/object-resolver/resolve?operation=AttachmentsResolveLink',
        operationName: 'gateway_api_object_resolver_resolve',
        source: 'src/packages/issue/issue-attachments-view/src/add-resources/search-resources/index.tsx'
    },
    {
        api: '/rest/api/3/attachment/content/<uuid>',
        operationName: 'rest_api_3_attachment_content_<item.identifier.attachmentid>',
        source: 'src/packages/issue/issue-attachments-view/src/grid-view/ui/components/media-card/MediaCardActions.tsx'
    },
    {
        api: '/rest/api/3/attachment/content/<uuid>',
        operationName: 'rest_api_3_attachment_content_<item.identifier.attachmentid>',
        source: 'src/packages/issue/issue-attachments-view/src/grid-view/ui/components/media-card/MediaCardActions.tsx'
    },
    {
        api: '/rest/api/latest/attachment/abuse-classification/<id>',
        operationName: 'rest_api_latest_attachment_abuse_classification_<issueid>',
        source: 'src/packages/issue/issue-attachments-view/src/heading/meatballs/download-all-item/index.tsx'
    },
    {
        api: '/rest/api/latest/attachment/abuse-classification/<id>',
        operationName: 'rest_api_latest_attachment_abuse_classification_<issueid>',
        source: 'src/packages/issue/issue-attachments-view/src/heading/meatballs/download-all-item-with-links/index.tsx'
    },
    {
        api: '/rest/internal/2/issue/<issue-key>/clone',
        operationName: 'rest_internal_2_issue_<issuekey>_clone',
        source: 'src/packages/issue/clone-issue/src/services/clone/index.tsx'
    },
    {
        api: '/rest/internal/3/forge/field/value',
        operationName: 'rest_internal_3_forge_field_value',
        source: 'src/packages/issue/ecosystem-issue-view/src/executeValueFunction.tsx'
    },
    {
        api: '/rest/api/3/task/<uuid>',
        operationName: 'rest_api_3_task_<taskid>',
        source: 'src/packages/issue/clone-issue/src/services/clone/index.tsx'
    },
    {
        api: '/rest/api/3/issue/<id>?fields=key',
        operationName: 'rest_api_3_issue_<issueid>',
        source: 'src/packages/issue/clone-issue/src/services/clone/index.tsx'
    },
    {
        api: '/rest/internal/2/issue/<issue-key>/clone/meta',
        operationName: 'rest_internal_2_issue_<issuekey>_clone_meta',
        source: 'src/packages/issue/clone-issue/src/services/clone-meta/main.tsx'
    },
    {
        api: '/wiki/rest/api/content',
        operationName: 'wiki_rest_api_content',
        source: 'src/packages/issue/content-placeholder-template/src/services/confluence-create-blank-draft.tsx'
    },
    {
        api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/create-dialog/1.0/content/blueprint/<uuid>/instance',
        operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_create_dialog_1_0_content_blueprint_<blueprintmodulecompletekey>_instance',
        source: 'src/packages/issue/content-placeholder-template/src/services/confluence-create-draft.tsx'
    },
    {
        api: '/gateway/api/tap-delivery/api/v3/personalization/site/<uuid>',
        operationName: 'gateway_api_tap-delivery_api_v3_personalization_site<cloudid>',
        source: 'src/packages/issue/content-placeholder-template/src/services/fetch-personalization-site-traits.tsx'
    },
    {
        api: '/gateway/api/gcg/api/v1/generate/team_growth/dynamic_placeholder_title',
        operationName: 'gateway_api_gcg_api_v1_generate_team_growth_dynamic_placeholder_title',
        source: 'src/packages/issue/content-placeholder-template/src/services/template-text-api.tsx'
    },
    {
        api: '/gateway/api/bxp/signup/product/end-user-activate-eligible-check',
        operationName: 'gateway_api_bxp_signup_product_end_user_activate_eligible_check',
        source: 'src/packages/issue/content-placeholder-template/src/services/user-product-permission.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/context-fields/components/index.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/context-fields/components/index.tsx'
    },
    {
        api: '/rest/servicedesk/1/servicedesk/request/<id>/request-types?query=',
        operationName: 'rest_servicedesk_1_servicedesk_request_<issueid>_request_types',
        source: 'src/packages/issue/context-fields/customer-request-type/index.tsx'
    },
    {
        api: '/rest/api/2/groups/picker',
        operationName: 'rest_api_2_groups_picker',
        source: 'src/packages/issue/context-fields/group-picker/rest/fetch.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/context-fields/labels/index.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/context-fields/labels/index.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/context-fields/multi-select-with-relay-edit-view/index.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/context-fields/multi-select-with-relay-edit-view/index.tsx'
    },
    {
        api: '/rest/api/3/user/recommend',
        operationName: 'rest_api_3_user_recommend',
        source: 'src/packages/issue/context-fields/multi-user/index.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/context-fields/single-select-with-relay-edit-view/index.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/context-fields/single-select-with-relay-edit-view/index.tsx'
    },
    {
        api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/api/content/<uuid>?status=draft',
        operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_api_content_<pageid>',
        source: 'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx'
    },
    {
        api: '/gateway/api/invitations/v1/access-requests/capabilities',
        operationName: '<conf_request_access_capabilities_url>',
        source: 'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx'
    },
    {
        api: '/gateway/api/invitations/v1/access-requests/request',
        operationName: '<conf_direct_join_api>',
        source: 'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx'
    },
    {
        api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/api/user/current?expand=operations',
        operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_api_user_current',
        source: 'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx'
    },
    {
        api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/api/user/current?expand=personalSpace',
        operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_api_user_current',
        source: 'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx'
    },
    {
        api: '/gateway/api/ex/confluence/<uuid>/wiki/api/v2/pages',
        operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_api_v2_pages',
        source: 'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx'
    },
    {
        api: '/gateway/api/permissions/permitted',
        operationName: 'gateway_api_permissions_permitted',
        source: 'src/packages/issue/create-confluence-content/src/services/permissions/index.tsx'
    },
    {
        api: '/gateway/api/ex/confluence',
        operationName: 'gateway_api_ex_confluence',
        source: 'src/packages/issue/create-confluence-content/src/ui/background-provisioning-editor/provisioning-api.tsx'
    },
    {
        api: '/gateway/api/xflow/provision/cloud',
        operationName: 'gateway_api_xflow_provision_cloud',
        source: 'src/packages/issue/create-confluence-content/src/ui/background-provisioning-editor/provisioning-api.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>',
        operationName: 'rest_api_3_issue_<issuekey>',
        source: 'src/packages/issue/description-field/src/description/view.tsx'
    },
    {
        api: '/rest/api/2/issue/<id>/properties/<id>',
        operationName: 'rest_api_2_issue_<issueid>_properties_<last_viewed_issue_property_key>',
        source: 'src/packages/issue/design-section/src/services/set-last-viewed-issue-property/index.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>',
        operationName: 'rest_api_3_issue_<issuekey>',
        source: 'src/packages/issue/ecosystem-issue-view/src/forge/custom-field/formatter-value/index.tsx'
    },
    {
        api: '/rest/internal/latest/project-access/access-requested',
        operationName: 'rest_internal_latest_project_access_access_requested',
        source: 'src/packages/issue/issue-view-errors/src/services/request-access-service.tsx'
    },
    {
        api: '/rest/api/3/task/<uuid>',
        operationName: 'rest_api_3_task_<taskid>',
        source: 'src/packages/issue/export-excel-dialog/src/ui/task-poll-manager.tsx'
    },
    {
        api: '/rest/issues/latest/export/<uuid>',
        operationName: 'rest_issues_latest_export_<taskid>',
        source: 'src/packages/issue/export-excel-dialog/src/ui/utils.tsx'
    },
    {
        api: '/rest/api/3/user',
        operationName: 'rest_api_3_user',
        source: 'src/packages/issue/issue-view-feedback-button/src/view/feedback-button/button.tsx'
    },
    {
        api: '/rest/assetinternalapi/latest/field/<id>/config',
        operationName: 'rest_assetinternalapi_latest_field_<customfieldid>_config',
        source: 'src/packages/issue/field-assets/src/ui/edit/utils.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>?fields=assignee',
        operationName: 'rest_api_3_issue_<issuekey>',
        source: 'src/packages/issue/field-assignee/src/services/use-assignee-field/index.tsx'
    },
    {
        api: '/rest/internal/2/userteam/mention/search',
        operationName: 'rest_internal_2_userteam_mention_search',
        source: 'src/packages/issue/field-text-area-editview-full/src/ui/text-area/utils/use-text-area-mention-provider/text-area-mention-provider/index.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>/',
        operationName: 'rest_api_3_issue_<issuekey>',
        source: 'src/packages/issue/field-service-entity/src/common/ui/collapsible-field/use-collapsible-field/index.tsx'
    },
    {
        api: '/rest/servicedesk/cmdb/latest/object/<uuid>',
        operationName: 'rest_servicedesk_cmdb_latest_object_<workspaceandobjectid>',
        source: 'src/packages/issue/field-service-entity/src/services/fetch-object-details/fetch-object-details/index.tsx'
    },
    {
        api: '/rest/service-registry-api/service?query=',
        operationName: 'rest_service_registry_api_service',
        source: 'src/packages/issue/field-service-entity/src/services/resolve-field-values-by-id/index.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>/transitions?sortByOpsBarAndStatus=true',
        operationName: 'rest_api_2_issue_<issuekey>_transitions',
        source: 'src/packages/issue/field-status/src/services/status-transitions-service/index.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>?fields=creator,created',
        operationName: 'rest_api_3_issue_<issuekey>',
        source: 'src/packages/issue/history/src/services/issue-history/history-item-generator/index.tsx'
    },
    {
        api: '/rest/api/3/issue/picker?currentIssueKey=<issue-key>&currentProjectId=<id>&showSubTasks=true&showSubTaskParent=true',
        operationName: 'rest_api_3_issue_picker',
        source: 'src/packages/issue/picker/src/services/options/main.tsx'
    },
    {
        api: '/rest/greenhopper/1.0/xboard/work/media?issueIds=<id>',
        operationName: 'rest_greenhopper_1_0_xboard_work_media',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/card-cover-fetch-epic.tsx'
    },
    {
        api: '/rest/greenhopper/1.0/xboard/work/additionalBoardData?rapidViewId=<id>',
        operationName: 'rest_greenhopper_1_0_xboard_work_additionalboarddata',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/card-cover-fetch-epic.tsx'
    },
    {
        api: "/rest/api/2/issue/<issue-key>/comment/<uuid>` : ''}",
        operationName: 'rest_api_2_issue_<issuekey>_comment_<commentid>',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/comment-delete-epic.tsx'
    },
    {
        api: '/rest/internal/issue/<id>/comment/<uuid>/pin',
        operationName: 'rest_internal_issue_<issueid>_comment_<commentid>_pin',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/comment-save-epic.tsx'
    },
    {
        api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/recentlyviewed/1.0/recent',
        operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_recentlyviewed_1_0_recent',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/fetch-recently-visited-confluence-pages-stargate.tsx'
    },
    {
        api: '/rest/internal/2/project/<project-key>/hasValidatorsOnSubtasks',
        operationName: 'rest_internal_2_project_<projectkey>_hasvalidatorsonsubtasks',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/project-validator-server.tsx'
    },
    {
        api: '/rest/internal/2/issue/<issue-key>/history',
        operationName: 'rest_internal_2_issue_<issuekey>_history',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/recently-viewed-issue-epic.tsx'
    },
    {
        api: '/rest/api/3/issue/<id>/remotelink',
        operationName: 'rest_api_3_issue_<issueid>_remotelink',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/web-links-server.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>/remotelink/<id>',
        operationName: 'rest_api_3_issue_<issuekey>_remotelink_<id>',
        source: 'src/packages/issue/issue-view-app-provider/src/epics/web-links-server.tsx'
    },
    {
        api: '/rest/api/2/attachment/upload/issue/<issue-key>/credentials',
        operationName: 'rest_api_2_attachment_upload_issue_<issuekey>_credentials',
        source: 'src/packages/issue/issue-view-common-media/src/upload-context/upload-context-server.tsx'
    },
    {
        api: '/rest/api/3/mypreferences',
        operationName: 'rest_api_3_mypreferences',
        source: 'src/packages/issue/issue-view-layout-group/src/services/group-preferences/user-preferences/use-group-user-preferences.tsx'
    },
    {
        api: '/rest/api/3/mypreferences',
        operationName: 'rest_api_3_mypreferences',
        source: 'src/packages/issue/issue-view-product-templates-services/src/services/context/visible-hidden/hide-empty-fields/user-preferences/index.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>?deleteSubtasks=true',
        operationName: 'rest_api_3_issue_<issuekey>',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-delete-server.tsx'
    },
    {
        api: '/rest/internal/simplified/1.0/projects/<id>/issues//children',
        operationName: 'rest_internal_simplified_1_0_projects_<projectid>_issues_<parentid>_children',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-parent-server.tsx'
    },
    {
        api: '/rest/internal/simplified/1.0/projects/<id>/issues/delete-parents',
        operationName: 'rest_internal_simplified_1_0_projects_<projectid>_issues_delete_parents',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-parent-server.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/2/search/jql',
        operationName: 'rest_api_2_search_jql',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/2/search/jql',
        operationName: 'rest_api_2_search_jql',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>?fields=issuelinks',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>',
        operationName: 'rest_api_2_issue_<issuekey>',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/2/issueLinkType',
        operationName: 'rest_api_2_issuelinktype',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/2/issue/picker?currentIssueKey=<issue-key>&showSubTasks=true&showSubTaskParent=true',
        operationName: 'rest_api_2_issue_picker',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/2/issue/createmeta?projectKeys=<project-key>&expand=projects.issuetypes.fields',
        operationName: 'rest_api_2_issue_createmeta',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/2/issueLink',
        operationName: 'rest_api_2_issuelink',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/remoteJiraIssueLink/1/remoteJira/<issue-key>/createIssueLink',
        operationName: 'rest_remotejiraissuelink_1_remotejira_<currentissueidorkey>_createissuelink',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/confluenceIssueLink/1/confluence/applink',
        operationName: 'rest_confluenceissuelink_1_confluence_applink',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/issueLinkAppLink/1/appLink/info?type=com.atlassian.applinks.api.application.jira.JiraApplicationType&issueIdOrKey=<issue-key>',
        operationName: 'rest_issuelinkapplink_1_applink_info',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/remoteJiraIssueLink/1/remoteJira/picker?showSubTasks=true&showSubTaskParent=true',
        operationName: 'rest_remotejiraissuelink_1_remotejira_picker',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/remoteJiraIssueLink/1/remoteJira/picker',
        operationName: 'rest_remotejiraissuelink_1_remotejira_picker',
        source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>/remotelink',
        operationName: 'rest_api_3_issue_<issuekey>_remotelink',
        source: 'src/packages/issue/issue-view-services/src/issue/remote-issue-link-delete-server.tsx'
    },
    {
        api: '/rest/servicedesk/lingo-integration/1/request-language/<id>',
        operationName: 'rest_servicedesk_lingo_integration_1_request_language_<issueid>',
        source: 'src/packages/issue/issue-view-services/src/issue/request-language-server.tsx'
    },
    {
        api: '/rest/internal/2/userteam/mention/search',
        operationName: 'rest_internal_2_userteam_mention_search',
        source: 'src/packages/issue/issue-view-services/src/mentions/issue-user-team-mention-provider-next.tsx'
    },
    {
        api: '/rest/internal/2/userteam/mention/search',
        operationName: 'rest_internal_2_userteam_mention_search',
        source: 'src/packages/issue/issue-view-services/src/mentions/issue-user-team-mention-provider.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>/properties/<id>',
        operationName: 'rest_api_2_issue_<issuekey>_properties_<addonmodulekey>',
        source: 'src/packages/issue/issue-view-store/src/ecosystem/ecosystem-extension-add-server.tsx'
    },
    {
        api: '/rest/api/2/issue/<issue-key>/properties/<id>',
        operationName: 'rest_api_2_issue_<issuekey>_properties_<extensionid>',
        source: 'src/packages/issue/issue-view-store/src/ecosystem/forge/forge-extension-server.tsx'
    },
    {
        api: '/rest/internal/simplified/1.0/projects/<id>/issues/delete-parents',
        operationName: 'rest_internal_simplified_1_0_projects_<projectid>_issues_delete_parents',
        source: 'src/packages/issue/parent-services/src/services/rest/delete/team-managed/index.tsx'
    },
    {
        api: '/rest/internal/simplified/1.0/projects/<id>/issues//children',
        operationName: 'rest_internal_simplified_1_0_projects_<projectid>_issues_<parentid>_children',
        source: 'src/packages/issue/parent-services/src/services/rest/set/team-managed/index.tsx'
    },
    {
        api: '/gateway/api/assist/api/ai/v2/ai-feature/proactive/jira',
        operationName: 'gateway_api_assist_api_ai_v2_ai_feature_proactive_jira',
        source: 'src/packages/issue/smart-request-summary-state/src/controllers/state/actions/index.tsx'
    },
    {
        api: '/gateway/api/assist/api/ai/v2/ai-feature/proactive/jira/dismiss',
        operationName: 'gateway_api_assist_api_ai_v2_ai_feature_proactive_jira_dismiss',
        source: 'src/packages/issue/smart-request-summary-state/src/controllers/state/actions/index.tsx'
    },
    {
        api: '/gateway/api/assist/api/ai/v2/ai-feature/jira/comment-summary/followups',
        operationName: 'gateway_api_assist_api_ai_v2_ai_feature_jira_comment_summary_followups',
        source: 'src/packages/issue/smart-request-summary-state/src/services/follow-ups/index.tsx'
    },
    {
        api: '/gateway/api/post-office/api/v1/placements/screen-space-flags/update-messages',
        operationName: 'gateway_api_post-office_api_v1_placements_screen-space-flags_update-messages',
        source: 'src/packages/post-office/post-office-provider/src/screen-space-flags-placement.tsx'
    },
    {
        api: '/rest/greenhopper/3/xboard/issue/flag/flag',
        operationName: 'rest_greenhopper_3_xboard_issue_flag_flag',
        source: 'src/packages/issue/status/src/flagged-field-popup/services/save-flag-with-comment.tsx'
    },
    {
        api: '/rest/api/3/issue/<issue-key>',
        operationName: 'rest_api_3_issue_<issuekey>',
        source: 'src/packages/issue/switching-multiline-field/src/view.tsx'
    },
    {
        api: '/gateway/api/third-party-configuration/connected-data-sources/<uuid>',
        operationName: 'gateway_api_third_party_configuration_connected_data_sources_<cloudid>',
        source: 'src/packages/issue/third-party-connected-data-sources/src/services/fetch-third-party-connectors/index.tsx'
    },
    {
        api: '/rest/servicedesk/1/servicedesk/sla/issue/<issue-key>',
        operationName: 'rest_servicedesk_1_servicedesk_sla_issue_<issuekey>',
        source: 'src/packages/router-resources/jsm-issue-view/src/services/index.tsx'
    },
    {
        api: '/rest/gira/1/?',
        operationName: 'rest_gira_1',
        source: 'src/packages/router-resources/offering-catalogue-features/src/controllers/get-data/index.tsx'
    },
    {
        api: '/rest/api/3/project/<project-key>/properties/<id>',
        operationName: 'rest_api_3_project_<projectidorkey>_properties_<entitykey>',
        source: 'src/packages/router-resources/project-global-components/src/services/get-data/index.tsx'
    },
    {
        api: '/rest/api/3/project/<project-key>',
        operationName: 'rest_api_3_project_<projectkey>',
        source: 'src/packages/router-resources/project-global-components/src/services/get-data/index.tsx'
    }
];

});


parcelRegister("aYvm6", function(module, exports) {
$parcel$export(module.exports, "jiraSsrConfig", () => $0fa0f0fc1341377c$export$7bcf91e323db67dd);
/* eslint-disable jira/filename-case */ 
var $hBj11 = parcelRequire("hBj11");

var $9LXZM = parcelRequire("9LXZM");

var $6xuJS = parcelRequire("6xuJS");

var $fDxFn = parcelRequire("fDxFn");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");


var $76Nlu = parcelRequire("76Nlu");

/** given a timings object, add a timer that starts at the earliest start time and ends at the latest end time */ function $0fa0f0fc1341377c$var$insertTotalTiming(/**
	 * key of the total timing that will be inserted to the given timings object
	 */ key, timings) {
    const timingValues = timings && Object.values(timings);
    if (!timingValues || !timingValues.length) return timings;
    // oxlint-disable-next-line no-shadow
    const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
    const endTime = timingValues.reduce(// oxlint-disable-next-line no-shadow
    (max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
    const duration = endTime - startTime;
    // eslint-disable-next-line no-param-reassign
    timings[key] = {
        startTime: startTime,
        duration: duration
    };
    return timings;
}
/**
 * Apply key and startTimOffset overrides to a timings object
 */ function $0fa0f0fc1341377c$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
    return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
        const startTime = value.startTime + startTimeOffsetMs;
        return [
            [
                prefix,
                key
            ].filter(Boolean).join('/'),
            {
                ...value,
                startTime: startTime
            }
        ];
    }));
}
function $0fa0f0fc1341377c$var$getTesseractTimings() {
    if (!globalThis.SPA_STATE) return null;
    const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
    const detailRelayFetch = globalThis.SPA_STATE['ssr/relay_fetch'];
    const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
    const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($hBj11)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) {
            // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
            const totalKey = '';
            timings[totalKey] = {
                startTime: 0,
                duration: highLevelMetrics.data.ssrTotal
            };
        }
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRequestTrace?.data || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    if (detailRelayFetch) {
        const relayFetchTimings = Object.fromEntries(Object.entries(detailRelayFetch ?? {}).map(([key, value])=>[
                `relay/${key}`,
                value
            ]));
        $0fa0f0fc1341377c$var$insertTotalTiming('relay', relayFetchTimings);
        Object.assign(timings, relayFetchTimings);
    }
    let timingsWithContext = timings;
    // If there's a server-timing for tesseract, that represents the pre-work before script execution starts, referred to as contextGlobalsSetup
    const serverTimingsByName = $0fa0f0fc1341377c$var$getServerTimingsByName();
    // This will become available when EDGE-8510 is complete
    const contextGlobalsSetup = serverTimingsByName.tesseract?.duration;
    if (contextGlobalsSetup != null) {
        timingsWithContext = $0fa0f0fc1341377c$var$applyTimingOverrides(timings, {
            startTimeOffsetMs: contextGlobalsSetup
        });
        timingsWithContext && Object.assign(timingsWithContext, {
            contextGlobalsSetup: {
                startTime: 0,
                duration: contextGlobalsSetup
            }
        });
    }
    return $0fa0f0fc1341377c$var$insertTotalTiming('', timingsWithContext); // while there is already a 'ssrTotal', it seems to exclude some timings, so we'll take the end to end as the actual total time
}
// add early-flush/ prefix to timing keys which are early flush timings
const $0fa0f0fc1341377c$var$jiraFeGatewayEarlyFlushKeys = new Set([
    'metatags',
    'feature-flags',
    'statsig',
    'inline-assets',
    'async-inline-assets',
    'css-assets',
    'priority-assets',
    'early-route-flush'
]);
// and filter out these keys since they are not UFO visualisation friendly
const $0fa0f0fc1341377c$var$jiraFeGatewayFilteredKeys = [
    'early-common-flush',
    'prerender-total',
    'resolve-assets'
];
function $0fa0f0fc1341377c$var$getJiraFeGatewayTimings() {
    const rawTimings = globalThis._JFGTimings;
    if (!rawTimings) return null;
    const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$0fa0f0fc1341377c$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
            $0fa0f0fc1341377c$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
    return $0fa0f0fc1341377c$var$insertTotalTiming(// there's no end to end timer so we calculate one
    '', jiraFeGatewayTimings);
}
function $0fa0f0fc1341377c$var$getLegacyMonolithTimingDuration(timingMetricKey) {
    /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */ const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
    return Number(inputElementWithTimingValue?.value ?? 0);
}
function $0fa0f0fc1341377c$var$getLegacyJiraMonolithTimings() {
    const duration = $0fa0f0fc1341377c$var$getLegacyMonolithTimingDuration('jira.request.server.time');
    if (!duration) // if we don't have this, fallback to no jira timings, we might be going through bifrost instead
    return null;
    const timings = {
        // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
        '': {
            startTime: 0,
            duration: duration
        },
        'flush-head': {
            startTime: 0,
            duration: $0fa0f0fc1341377c$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
        }
    };
    return timings;
}
const $0fa0f0fc1341377c$var$monolithTimerRenames = {
    'jira-request-server-time': ''
};
function $0fa0f0fc1341377c$var$getJiraMonolithTimings() {
    if (!globalThis._monolithTimings) return $0fa0f0fc1341377c$var$getLegacyJiraMonolithTimings();
    return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
            $0fa0f0fc1341377c$var$monolithTimerRenames[name] ?? name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
}
function $0fa0f0fc1341377c$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
    if (jiraBeTimings || !tesseractTimings) return null;
    const serverTimingsByName = $0fa0f0fc1341377c$var$getServerTimingsByName();
    // This will become available when EDGE-8510 is complete
    const bifrostInternal = serverTimingsByName.bifrost;
    const bifrostInternalDuration = bifrostInternal?.duration ?? 0;
    const timings = {
        ...bifrostInternal && {
            internal: {
                startTime: 0,
                duration: bifrostInternalDuration
            }
        },
        tesseract: {
            startTime: bifrostInternalDuration,
            duration: tesseractTimings[''].duration
        }
    };
    return $0fa0f0fc1341377c$var$insertTotalTiming('', timings);
}
/**
 * Get the offset required to align the ending of the timerToShift with the ending of the referenceTimer
 * But if the referenceTimer is smaller than the timerToShift (it shouldn't be, this is for timerToShifts that in practice are triggered within the reference timer)
 * then at least align the start times
 */ function $0fa0f0fc1341377c$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
    if (!referenceTimer || !timerToShift) return null;
    if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
    return referenceTimer.startTime - timerToShift.startTime;
}
function $0fa0f0fc1341377c$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
    // Push back the start of jfg so it's ending aligns with either the full monolith time or if we have the more specific timer for fetching jfg, use that
    const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
    return $0fa0f0fc1341377c$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
}
/**
 * Get the offset required to align the ending of the tesseract timer with either
 * the ending of the jira-fe-gateway/fetch-tesseract timer or the bifrost-gateway timer
 */ function $0fa0f0fc1341377c$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
    const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
    const jiraBeTesseractOffest = $0fa0f0fc1341377c$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
    const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
    const bifrostOffset = $0fa0f0fc1341377c$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
    return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
}
function $0fa0f0fc1341377c$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return (0, $fDxFn.default).getEntriesByType('navigation')?.[0];
}
function $0fa0f0fc1341377c$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($0fa0f0fc1341377c$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
function $0fa0f0fc1341377c$export$6d488733a547304() {
    const jiraBeTimings = $0fa0f0fc1341377c$var$getJiraMonolithTimings();
    const jiraFeGatewayTimings = $0fa0f0fc1341377c$var$getJiraFeGatewayTimings();
    const tesseractTimings = $0fa0f0fc1341377c$var$getTesseractTimings();
    const bifrostGatewayTimings = $0fa0f0fc1341377c$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
    const edgeTimings = (0, $9LXZM.getEdgeTimingsIncludingCloudfront)();
    const edgeTime = (edgeTimings?.['edge/atl-edge/internal']?.duration ?? 0) + (edgeTimings?.['edge/atl-edge/internal']?.startTime ?? 0);
    const finalJiraBeTimings = $0fa0f0fc1341377c$var$applyTimingOverrides(jiraBeTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'jira-monolith'
    });
    const finalBifrostGatewayTimings = $0fa0f0fc1341377c$var$applyTimingOverrides(bifrostGatewayTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'bifrost-gateway'
    });
    const jfgOffset = $0fa0f0fc1341377c$var$getJfgOffset({
        jiraFeGatewayTimings: jiraFeGatewayTimings,
        jiraBeTimings: finalJiraBeTimings
    });
    const finalJfgTimings = $0fa0f0fc1341377c$var$applyTimingOverrides(jiraFeGatewayTimings, {
        startTimeOffsetMs: jfgOffset,
        prefix: 'jira-fe-gateway'
    });
    const tesseractOffset = $0fa0f0fc1341377c$var$getTesseractOffset({
        tesseractTimings: tesseractTimings,
        jiraFeGatewayTimings: finalJfgTimings,
        bifrostGatewayTimings: finalBifrostGatewayTimings
    });
    const finalTesseractTimings = $0fa0f0fc1341377c$var$applyTimingOverrides(tesseractTimings, {
        startTimeOffsetMs: tesseractOffset,
        prefix: 'tesseract'
    });
    const timings = {
        ...finalJiraBeTimings,
        ...finalJfgTimings,
        ...finalBifrostGatewayTimings,
        ...finalTesseractTimings
    };
    $0fa0f0fc1341377c$var$insertTotalTiming('total', timings); // UFO treats 'total' as a special key for ssr timings that translates to 'ssr'
    return Object.keys(timings).length ? timings : null;
}
const $0fa0f0fc1341377c$var$SSR_FF_META_TAG = 'spa-service-flags';
const $0fa0f0fc1341377c$var$EARLY_FLUSH_END_MARK = 'ssr.spa.early-common-flush:end';
let $0fa0f0fc1341377c$var$ffCache;
let $0fa0f0fc1341377c$var$ffCacheInitialiser = ()=>{
    try {
        const metaTagValue = (0, $6bEm8.default)($0fa0f0fc1341377c$var$SSR_FF_META_TAG);
        if (metaTagValue === null) return null;
        $0fa0f0fc1341377c$var$ffCache = JSON.parse(metaTagValue) || null;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        $0fa0f0fc1341377c$var$ffCache = null;
    }
    $0fa0f0fc1341377c$var$ffCacheInitialiser = null;
};
function $0fa0f0fc1341377c$var$getFeatureFlags() {
    if ($0fa0f0fc1341377c$var$ffCacheInitialiser != null) $0fa0f0fc1341377c$var$ffCacheInitialiser();
    return $0fa0f0fc1341377c$var$ffCache;
}
function $0fa0f0fc1341377c$var$isAnyRouteResourceFetchErrors() {
    return Object.values(globalThis.SPA_STATE?.['ssr/detail_request_trace']?.data ?? {}).some((timing)=>timing?.failureReason);
}
// Names of the route resources that recorded a `failureReason`. Keyed by a
// bounded, closed set of resource-type names (no PII).
function $0fa0f0fc1341377c$var$getFailedRouteResources() {
    return Object.entries(globalThis.SPA_STATE?.['ssr/detail_request_trace']?.data ?? {}).filter(([, timing])=>timing?.failureReason).map(([resourceName])=>resourceName);
}
function $0fa0f0fc1341377c$var$isAnyReactRenderErrors() {
    return !!globalThis.SPA_STATE?.['ssr/render_errors']?.count;
}
function $0fa0f0fc1341377c$var$isAnyEntryPointFetchErrors() {
    return !!globalThis.SPA_STATE?.['ssr/entry_point_status']?.match(/error|timeout/);
}
function $0fa0f0fc1341377c$var$isEarlyFlushSuccessful() {
    return !!(0, $fDxFn.default)?.getEntriesByName($0fa0f0fc1341377c$var$EARLY_FLUSH_END_MARK);
}
function $0fa0f0fc1341377c$var$getDoneMark() {
    return (0, $6xuJS.getMark)((0, $07aa4ba62fd6dab4$export$135c96ab5afee429))?.startTime || null;
}
const $0fa0f0fc1341377c$var$isCircuitBreakerOpen = ()=>globalThis.SPA_STATE?.['ssr/circuit_breaker_open'] === true;
const $0fa0f0fc1341377c$var$wasFetchAborted = ()=>globalThis.SPA_STATE?.['ssr/fetch_aborted'] === true;
/**
 * The renderer's services/html commits 'failed' when hasFailedSSR() reports a
 * top-level Suspense fallback was rendered for the page (i.e. the renderer
 * finished but emitted placeholder content for resources that didn't return).
 */ const $0fa0f0fc1341377c$var$wasSuspenseFallbackEmitted = ()=>globalThis.SPA_STATE?.['ssr/render_status'] === 'failed';
/**
 * The static fallback bypasses the renderer entirely, so SPA_STATE is empty.
 * The renderer always commits `ssr/render_status` — checking its absence is
 * fail-safe against any future fallback path that forgets to advertise itself.
 */ const $0fa0f0fc1341377c$var$wasStaticFallbackServed = ()=>!globalThis.SPA_STATE || globalThis.SPA_STATE['ssr/render_status'] === undefined;
const $0fa0f0fc1341377c$var$getFailedResources = ()=>globalThis.SPA_STATE?.['ssr/failed_resources'] ?? [];
const $0fa0f0fc1341377c$var$getFailedResourceCount = ()=>globalThis.SPA_STATE?.['ssr/failed_resource_count'] ?? 0;
/**
 * Client-side breakdown built from `globalThis.SPA_STATE` and `performance`
 * entries. Both `getSsrSuccessBreakdown` (UFO breakdown payload) and
 * `getSsrPhaseSuccess().done` (UFO `'ssr:success'` boolean) derive from this so
 * they cannot drift. The success verdict itself is computed by the shared,
 * type-driven `computeSsrSuccess` (`@jira/ssr__ssr-success`), which the SSR
 * renderer also uses, so server and client agree on the formula by construction.
 * The `SsrSuccessBreakdown` type is owned by `@atlaskit/react-ufo/ssr`.
 */ const $0fa0f0fc1341377c$var$buildBreakdown = ()=>{
    const failedResourceCount = $0fa0f0fc1341377c$var$getFailedResourceCount();
    const failedRouteResources = $0fa0f0fc1341377c$var$getFailedRouteResources();
    return {
        servedStaticFallback: $0fa0f0fc1341377c$var$wasStaticFallbackServed(),
        // The SPA never reached the SPA_SSR_RENDERED mark — a failure the other
        // reason flags cannot otherwise attribute.
        notRendered: !$0fa0f0fc1341377c$var$getDoneMark(),
        hadRuntimeError: $0fa0f0fc1341377c$var$isAnyReactRenderErrors(),
        circuitBreakerOpen: $0fa0f0fc1341377c$var$isCircuitBreakerOpen(),
        hadFailedResources: failedResourceCount > 0,
        fetchAborted: $0fa0f0fc1341377c$var$wasFetchAborted(),
        emittedSuspenseFallback: $0fa0f0fc1341377c$var$wasSuspenseFallbackEmitted(),
        // Note: deliberately does NOT call isEarlyFlushSuccessful(), which has a
        // historical bug (returns truthy for an empty array). Fixing the helper
        // would change the legacy gate-off `done` branch, which is out of scope
        // for this PR; read the performance entry directly here.
        hadEarlyFlushFailure: ((0, $fDxFn.default)?.getEntriesByName($0fa0f0fc1341377c$var$EARLY_FLUSH_END_MARK)?.length ?? 0) === 0,
        hadRouteResourceFailure: $0fa0f0fc1341377c$var$isAnyRouteResourceFetchErrors(),
        failedResources: $0fa0f0fc1341377c$var$getFailedResources(),
        failedResourceCount: failedResourceCount,
        failedRouteResources: failedRouteResources.slice(0, (0, $64e52cb3429aad81$export$a632425565d461f8)),
        failedRouteResourceCount: failedRouteResources.length
    };
};
// SPA_STATE is inlined once into the HTML and never mutated after load, so the
// breakdown is constant per page. Memoize keyed on SPA_STATE identity so the two
// UFO callers (getSsrSuccessBreakdown, getSsrPhaseSuccess) share one traversal.
let $0fa0f0fc1341377c$var$cachedBreakdownKey;
let $0fa0f0fc1341377c$var$cachedBreakdownValue;
const $0fa0f0fc1341377c$var$getCachedBreakdown = ()=>{
    const key = globalThis.SPA_STATE;
    if ($0fa0f0fc1341377c$var$cachedBreakdownValue === undefined || $0fa0f0fc1341377c$var$cachedBreakdownKey !== key) {
        $0fa0f0fc1341377c$var$cachedBreakdownKey = key;
        $0fa0f0fc1341377c$var$cachedBreakdownValue = $0fa0f0fc1341377c$var$buildBreakdown();
    }
    return $0fa0f0fc1341377c$var$cachedBreakdownValue;
};
const $0fa0f0fc1341377c$var$getSsrSuccessBreakdown = ()=>{
    if (!(0, $i860n.fg)('jfp-magma-ssr-success-breakdown')) return undefined;
    return $0fa0f0fc1341377c$var$getCachedBreakdown();
};
const $0fa0f0fc1341377c$export$7bcf91e323db67dd = {
    getDoneMark: $0fa0f0fc1341377c$var$getDoneMark,
    getSsrPhaseSuccess: ()=>{
        const prefetch = !!globalThis.SPA_STATE && !$0fa0f0fc1341377c$var$isAnyEntryPointFetchErrors() && !$0fa0f0fc1341377c$var$isAnyRouteResourceFetchErrors();
        const earlyFlush = $0fa0f0fc1341377c$var$isEarlyFlushSuccessful();
        const render = !$0fa0f0fc1341377c$var$isAnyReactRenderErrors();
        // New definition (both gates on) vs legacy (either gate off). The new
        // branch needs no separate done-mark check: a missing SPA_SSR_RENDERED
        // mark is the `notRendered` reason in the breakdown, so computeSsrSuccess
        // already returns false for it. The legacy branch keeps getDoneMark()
        // because it does not read the breakdown.
        // The gates can't be preconditioned in Statsig: the new definition only
        // works once the breakdown is emitted (gate-on), so both must be read
        // together right here.
        const done = // eslint-disable-next-line jira/ff/no-preconditioning -- see comment above
        (0, $i860n.fg)('jfp-magma-ssr-success-breakdown') && (0, $i860n.fg)('jfp-magma-redefine-ssr-success') ? (0, $76Nlu.computeSsrSuccess)($0fa0f0fc1341377c$var$getCachedBreakdown()) : !!$0fa0f0fc1341377c$var$getDoneMark() && render && earlyFlush && prefetch;
        return {
            prefetch: prefetch,
            earlyFlush: earlyFlush,
            done: done
        };
    },
    getTimings: $0fa0f0fc1341377c$export$6d488733a547304,
    getFeatureFlags: $0fa0f0fc1341377c$var$getFeatureFlags,
    getSsrSuccessBreakdown: $0fa0f0fc1341377c$var$getSsrSuccessBreakdown
};

});
parcelRegister("76Nlu", function(module, exports) {
$parcel$export(module.exports, "computeSsrSuccess", () => $6462fdd69fa68e75$export$2af388d1419e74f3);

var $1ZojF = parcelRequire("1ZojF");
const $6462fdd69fa68e75$export$2af388d1419e74f3 = (breakdown)=>!(0, $1ZojF.ssrFailureReasons).some((reason)=>breakdown[reason]);

});
parcelRegister("1ZojF", function(module, exports) {
$parcel$export(module.exports, "ssrFailureReasons", () => $ecd19952716fe70b$export$90e64d5fc63f23f8);
/**
 * Identity helper that enforces exhaustiveness on its argument: the generic
 * constraint rejects any reason that is not an `SsrFailureReason` (typo / extra),
 * and the conditional return type collapses the parameter to `never` — failing
 * the call — unless every `SsrFailureReason` is present (omission). Adding a new
 * boolean flag to `SsrSuccessBreakdown` (owned by `@atlaskit/react-ufo`)
 * therefore breaks the build until the reason is listed below.
 */ const $ecd19952716fe70b$var$defineReasons = (reasons)=>reasons;
const $ecd19952716fe70b$export$90e64d5fc63f23f8 = $ecd19952716fe70b$var$defineReasons([
    'servedStaticFallback',
    'notRendered',
    'hadRuntimeError',
    'circuitBreakerOpen',
    'hadFailedResources',
    'fetchAborted',
    'emittedSuspenseFallback',
    'hadEarlyFlushFailure',
    'hadRouteResourceFailure'
]);

});


/**
 * Max number of failed-resource names kept in the `failedResources` and
 * `failedRouteResources` evidence arrays of `SsrSuccessBreakdown`. Shared by the
 * SSR renderer (both the `ssr/failed_resources` commit in getState and the
 * breakdown builder) and the client UFO builder so every list caps identically;
 * the companion `*Count` fields always carry the true (uncapped) total.
 */ const $64e52cb3429aad81$export$a632425565d461f8 = 5;



parcelRegister("h8wQT", function(module, exports) {
$parcel$export(module.exports, "getClientReceiver", () => $0d2baa25f3e0e979$export$60624ad9eb1ec31a);

var $hfZ0x = parcelRequire("hfZ0x");

var $biDt5 = parcelRequire("biDt5");
const $0d2baa25f3e0e979$var$SERVER_STREAM_ENDED = 'SERVER_HTTP_RESPONSE_ENDED';
let $0d2baa25f3e0e979$var$receiver;
function $0d2baa25f3e0e979$export$60624ad9eb1ec31a() {
    // special-case: if server, bail early and do nothing
    if (typeof window === 'undefined' || !globalThis.document) return;
    if (!$0d2baa25f3e0e979$var$receiver) {
        const dispatcher = (0, $hfZ0x.getClientDispatcher)();
        const sink = dispatcher.ingest.bind(dispatcher);
        $0d2baa25f3e0e979$var$receiver = new (0, $biDt5.ClientReceiver)(globalThis.document, sink);
        $0d2baa25f3e0e979$var$receiver.fulfilled().then(()=>{
            sink({
                id: (0, $hfZ0x.CLIENT_DISPATCHER_MODULE),
                name: '_abort',
                args: [
                    {
                        reason: $0d2baa25f3e0e979$var$SERVER_STREAM_ENDED
                    }
                ]
            });
        });
    }
    return $0d2baa25f3e0e979$var$receiver;
}

});
parcelRegister("biDt5", function(module, exports) {
$parcel$export(module.exports, "ClientReceiver", () => $05298d83095aff5f$export$c5eb37f83f5ef9db);
const $05298d83095aff5f$var$ELEMENT_SELECTOR = 'script[data-clientjs]';
/**
 * We need to wait for slightly longer than 0ms. Waiting 4ms is enough
 * to guarantee the browser has processed any pending layout operations
 * that may yield further DOM content.
 */ const $05298d83095aff5f$var$DOM_RENDER_MS = 4;
class $05298d83095aff5f$export$c5eb37f83f5ef9db {
    constructor(doc, onEvent){
        this._doc = doc;
        this._onEvent = onEvent;
        // consume any instructions that arrived before we initialised
        this._doc.querySelectorAll($05298d83095aff5f$var$ELEMENT_SELECTOR).forEach((el)=>this.handleServerToClientElement(el));
        // Bail early if DOM is already ready, otherwise observe for new instructions until it is.
        this._fulfilled = this._doc.readyState === 'complete' ? Promise.resolve() : new Promise((resolve)=>{
            this.observe(resolve);
        });
    }
    observe(resolve) {
        // observe the document for changes
        const observer = new MutationObserver((mutations)=>this.handleMutation(mutations));
        observer.observe(this._doc.body, {
            attributes: false,
            childList: true,
            subtree: false
        });
        // only keep trying until DOM ready, then give up.
        this._doc.addEventListener('DOMContentLoaded', ()=>{
            setTimeout(()=>{
                observer.disconnect();
                resolve();
            }, $05298d83095aff5f$var$DOM_RENDER_MS + 1);
        }, {
            once: true
        });
    }
    handleMutation(mutations) {
        for (const mutation of mutations){
            if (mutation.type === 'childList') for (const node of mutation.addedNodes){
                if (node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement) {
                    if (node.matches($05298d83095aff5f$var$ELEMENT_SELECTOR)) setTimeout(()=>this.handleServerToClientElement(node), $05298d83095aff5f$var$DOM_RENDER_MS);
                }
            }
        }
    }
    handleServerToClientElement(el) {
        const events = el.textContent?.trim().split('\n');
        if (!events) return;
        for (const event of events){
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const payload = JSON.parse(event);
            this._onEvent(payload);
        }
    }
    fulfilled() {
        return this._fulfilled;
    }
}

});


parcelRegister("7jsro", function(module, exports) {
$parcel$export(module.exports, "AtlaspackMetricsConnector", () => $f986aaf1b28437e6$export$a0da2371f93e56de);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $i860n = parcelRequire("i860n");

var $6Kdw4 = parcelRequire("6Kdw4");

var $i873r = parcelRequire("i873r");
function $f986aaf1b28437e6$export$2e97bdb0a62c1cbf() {
    if (!(0, $i860n.fg)('atlaspack_runtime_metrics')) return ()=>{
    /**/ };
    const fn = async (event)=>{
        try {
            if (event.detail === undefined || !event.detail.action) return;
            const { action: action, attributes: attributes = {} } = event.detail;
            // Get client or wait for it to initialize
            const analyticsWebClient = await (0, $6Kdw4.getAnalyticsWebClientPromise)();
            const analyticsClient = analyticsWebClient.getInstance();
            // Fire event
            analyticsClient.sendOperationalEvent({
                source: 'devinfra-app-framework',
                actionSubject: 'atlaspack',
                action: action,
                attributes: {
                    ...attributes,
                    ...(0, $i873r.pageContext)()
                }
            });
        } catch (error) {
        // Suppress
        }
    };
    globalThis.addEventListener('atlaspack:analytics', fn);
    return ()=>globalThis.removeEventListener('atlaspack:analytics', fn);
}
function $f986aaf1b28437e6$var$AtlaspackMetricsConnectorInner() {
    (0, $euxye.useEffect)($f986aaf1b28437e6$export$2e97bdb0a62c1cbf, [
        globalThis
    ]);
    return null;
}
$f986aaf1b28437e6$var$AtlaspackMetricsConnectorInner.displayName = "AtlaspackMetricsConnectorInner";
function $f986aaf1b28437e6$export$a0da2371f93e56de() {
    if (!(0, $i860n.fg)('atlaspack_runtime_metrics')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "atlaspack_runtime_metrics",
        packageName: "@jira/platform__app-framework-atlaspack-global-metrics",
        fallback: "unmount",
        teamName: "devinfra-app-framework"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f986aaf1b28437e6$var$AtlaspackMetricsConnectorInner, null));
}
$f986aaf1b28437e6$export$a0da2371f93e56de.displayName = "AtlaspackMetricsConnector";

});
parcelRegister("i873r", function(module, exports) {
$parcel$export(module.exports, "pageContext", () => $08790b52e45ad3cd$export$bb8fabbb9eed884a);

var $41zzZ = parcelRequire("41zzZ");
function $08790b52e45ad3cd$export$bb8fabbb9eed884a() {
    return {
        routeName: $08790b52e45ad3cd$var$getSafe(()=>(0, $41zzZ.getUserLocation)()),
        userLocation: $08790b52e45ad3cd$var$getSafe(()=>(0, $41zzZ.getRouteName)()),
        // oxlint-disable-next-line typescript/ban-ts-comment
        // @ts-expect-error
        bundlerVersion: $08790b52e45ad3cd$var$getSafe(()=>globalThis.BUNDLER_VERSION),
        buildVariant: $08790b52e45ad3cd$var$getSafe(()=>globalThis.BUILD_VARIANT)
    };
}
function $08790b52e45ad3cd$var$getSafe(fn) {
    try {
        return fn();
    } catch (error) {
        return 'unknown';
    }
}

});


parcelRegister("76Y3S", function(module, exports) {
$parcel$export(module.exports, "initEntryPointConfig", () => $93b3bc539009c605$export$93a6801f9db838c4);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gDdYI = parcelRequire("gDdYI");

var $a8EUd = parcelRequire("a8EUd");

var $dzfUQ = parcelRequire("dzfUQ");

var $8xoxE = parcelRequire("8xoxE");
const $93b3bc539009c605$var$ModalOnError = ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8xoxE.ErrorFlagRenderer), {
        id: "",
        error: error
    });
};
$93b3bc539009c605$var$ModalOnError.displayName = "ModalOnError";
function $93b3bc539009c605$export$93a6801f9db838c4() {
    (0, $dzfUQ.initEntryPointConfig)({
        PlaceholderComponent: ({ name: name, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
                name: name || '',
                ...props
            }),
        UFOSegmentComponent: (0, $gDdYI.default),
        ModalOnError: $93b3bc539009c605$var$ModalOnError
    });
}

});

parcelRegister("hOqkw", function(module, exports) {
$parcel$export(module.exports, "default", () => $df530b87e84e2ad8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $l28YB = parcelRequire("l28YB");

var $glqvt = parcelRequire("glqvt");

var $6bEm8 = parcelRequire("6bEm8");

var $l0Kxm = parcelRequire("l0Kxm");

var $qpL8u = parcelRequire("qpL8u");

const $df530b87e84e2ad8$var$renderEngagementMessages = ()=>{
    (parcelRequire("4oQaN"));
};

const $df530b87e84e2ad8$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("dQ6mx"));
};

const $df530b87e84e2ad8$var$renderHeartbeat = ()=>{
    (parcelRequire("jNdkm"));
};

const $df530b87e84e2ad8$var$loadUpFlowAPI = ()=>(parcelRequire("hGobK"));

const $df530b87e84e2ad8$var$installConnectModules = ()=>(parcelRequire("8yNAF"));
const $df530b87e84e2ad8$var$markSafeForAnalytics = (str)=>str || null;
const $df530b87e84e2ad8$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $6bEm8.default)('ajs-search-session-id');
    const containerId = (0, $6bEm8.default)('ajs-search-container-id');
    const objectId = (0, $6bEm8.default)('ajs-search-object-id');
    const objectType = (0, $6bEm8.default)('ajs-search-content-type');
    (0, $glqvt.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $qpL8u.default)('search-dwell-time', $df530b87e84e2ad8$var$markSafeForAnalytics(searchSessionId), {
        containerId: $df530b87e84e2ad8$var$markSafeForAnalytics(containerId),
        objectId: $df530b87e84e2ad8$var$markSafeForAnalytics(objectId),
        objectType: $df530b87e84e2ad8$var$markSafeForAnalytics(objectType),
        actionSubject: $df530b87e84e2ad8$var$markSafeForAnalytics(objectType),
        source: $df530b87e84e2ad8$var$markSafeForAnalytics(objectType)
    });
};
const $df530b87e84e2ad8$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $l0Kxm.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $df530b87e84e2ad8$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $df530b87e84e2ad8$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $df530b87e84e2ad8$var$renderProfileCardNextLegacy();
    if (args.connectModules) $df530b87e84e2ad8$var$installConnectModules();
    $df530b87e84e2ad8$var$renderEngagementMessages();
    if (args.heartbeat) $df530b87e84e2ad8$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $df530b87e84e2ad8$var$renderSearchDwellTimeComponent();
};
const $df530b87e84e2ad8$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($df530b87e84e2ad8$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $df530b87e84e2ad8$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $df530b87e84e2ad8$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: true,
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
const $df530b87e84e2ad8$var$globalCore = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$df530b87e84e2ad8$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $df530b87e84e2ad8$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$df530b87e84e2ad8$var$defaultArgs,
            ...args
        };
        $df530b87e84e2ad8$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))({
            ...$df530b87e84e2ad8$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $df530b87e84e2ad8$var$installLowPriorityApps(installArgs);
    }
};
var $df530b87e84e2ad8$export$2e2bcd8739ae039 = $df530b87e84e2ad8$var$globalCore;

});
parcelRegister("l0Kxm", function(module, exports) {
$parcel$export(module.exports, "renderFlags", () => $c095eb607bfa2ece$export$b6228dc14c5adf51);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $6CfY5 = parcelRequire("6CfY5");

var $j4o2W = parcelRequire("j4o2W");

var $bafqJ = parcelRequire("bafqJ");

var $b3oW6 = parcelRequire("b3oW6");

var $l8G1z = parcelRequire("l8G1z");
const $c095eb607bfa2ece$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $6CfY5.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $c095eb607bfa2ece$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $c095eb607bfa2ece$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c095eb607bfa2ece$var$Flags = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gA1xy")), {
    ssr: false,
    moduleId: "./src/packages/platform/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c095eb607bfa2ece$var$AfterPaintFlags = (0, $l8G1z.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("gA1xy")), {
    ssr: false,
    moduleId: "./src/packages/platform/flag-app/src/main.tsx"
});
const $c095eb607bfa2ece$export$b6228dc14c5adf51 = ()=>(0, $85XPu.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b3oW6.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j4o2W.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c095eb607bfa2ece$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c095eb607bfa2ece$var$Flags, null)))), $c095eb607bfa2ece$var$getContainer());

});
parcelRegister("j4o2W", function(module, exports) {
$parcel$export(module.exports, "JiraContextContainer", () => $4208828f37a11f38$export$6f7845cc5e693f16);

var $euxye = parcelRequire("euxye");

var $978hs = parcelRequire("978hs");

var $8w5ez = parcelRequire("8w5ez");

var $lPmfV = parcelRequire("lPmfV");

var $6Tr1c = parcelRequire("6Tr1c");

var $6bEm8 = parcelRequire("6bEm8");

var $8ByCr = parcelRequire("8ByCr");

var $72IzE = parcelRequire("72IzE");

var $h3795 = parcelRequire("h3795");

var $aZMdt = parcelRequire("aZMdt");

var $55cpN = parcelRequire("55cpN");

var $6zTYs = parcelRequire("6zTYs");

var $eijVy = parcelRequire("eijVy");

var $ixtp6 = parcelRequire("ixtp6");
const $4208828f37a11f38$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: (0, $h3795.routeAnalyticsAttributes)
    }, children);
$4208828f37a11f38$var$ContextualAnalyticsDataFeatureFlagged.displayName = "ContextualAnalyticsDataFeatureFlagged";

const $4208828f37a11f38$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // oxlint-disable-next-line typescript/no-require-imports, typescript/no-var-requires
        messages: (parcelRequire("cK8QE"))
    };
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4208828f37a11f38$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eijVy.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $6bEm8.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eijVy.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8ByCr.IntlProvider), {
            messages: state.messages,
            locale: (0, $978hs.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8w5ez.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lPmfV.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Tr1c.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55cpN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72IzE.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ixtp6.LoadingPhaseManager), null));
};
$4208828f37a11f38$export$6f7845cc5e693f16.displayName = "JiraContextContainer";

});
parcelRegister("ixtp6", function(module, exports) {
$parcel$export(module.exports, "LoadingPhaseManager", () => $aca98d45a5fca3e2$export$6e4bfef9e80c7eb0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $2OUOK = parcelRequire("2OUOK");
const $aca98d45a5fca3e2$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $2OUOK.useLazyPhase)();
    (0, $euxye.useEffect)(()=>{
        /**
		 * Only start next phase if we are not in the SPA, because there is a second
		 * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
		 * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
		 * bundles too early.
		 */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
		 * So for now we start the "after paint" phase a few seconds after mounting.
		 */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};
$aca98d45a5fca3e2$export$6e4bfef9e80c7eb0.displayName = "LoadingPhaseManager";

});


parcelRegister("gA1xy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("30XWp").then(()=>parcelRequire('7Natd'));

});


parcelRegister("qpL8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $99f0d5538b9426e8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $9ObL1 = parcelRequire("9ObL1");

var $b3oW6 = parcelRequire("b3oW6");
const $99f0d5538b9426e8$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $99f0d5538b9426e8$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $85XPu.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b3oW6.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ObL1.default), {
        sessionId: sessionId,
        data: data
    })), $99f0d5538b9426e8$var$getPlaceholder(placeholder));
};
var $99f0d5538b9426e8$export$2e2bcd8739ae039 = $99f0d5538b9426e8$var$renderDwellTimeComponent;

});

parcelRegister("4oQaN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("8LqMl")
]).then(()=>parcelRequire('9yBjx'));

});

parcelRegister("dQ6mx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("5qC72"),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("9GhR0")
]).then(()=>parcelRequire('55cld'));

});

parcelRegister("jNdkm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eW3ny").then(()=>parcelRequire('8JpbK'));

});

parcelRegister("hGobK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("9ACBj")
]).then(()=>parcelRequire('iBuex'));

});

parcelRegister("8yNAF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6cbjx").then(()=>parcelRequire('lpchM'));

});


parcelRegister("diXNS", function(module, exports) {
$parcel$export(module.exports, "reportUnreportedStatsigInitialisationError", () => $93d26d9872bd149d$export$3e2ed5f27f1cf2f1);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $h3795 = parcelRequire("h3795");

var $eiBCS = parcelRequire("eiBCS");
const $93d26d9872bd149d$export$3e2ed5f27f1cf2f1 = ()=>{
    if (0, $eiBCS.unreportedStatsigInitialisationError) (0, $hFtK7.fireErrorAnalytics)({
        error: (0, $eiBCS.unreportedStatsigInitialisationError),
        meta: {
            id: 'statsig-init-failure',
            teamName: 'uip-app-framework'
        },
        attributes: (0, $h3795.routeAnalyticsAttributes),
        skipSentry: false
    });
};

});

parcelRegister("37BCc", function(module, exports) {
$parcel$export(module.exports, "getIsSsrHydrationEnabled", () => $a39e107a2eb6edc5$export$d230742083bd05c4);
$parcel$export(module.exports, "getIsServerStreamingEnabled", () => $a39e107a2eb6edc5$export$6404c9565856d2f);
$parcel$export(module.exports, "renderReactApp", () => $a39e107a2eb6edc5$export$10e38d679c5a165c);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $iiabj = parcelRequire("iiabj");

var $l7jID = parcelRequire("l7jID");

var $dgncT = parcelRequire("dgncT");

var $TTcqD = parcelRequire("TTcqD");

var $ldgHZ = parcelRequire("ldgHZ");

var $i860n = parcelRequire("i860n");
parcelRequire("qXQCT");

var $7gnyB = parcelRequire("7gnyB");

var $6kmYA = parcelRequire("6kmYA");
const $a39e107a2eb6edc5$export$d230742083bd05c4 = ()=>{
    // We want only 1 source of truth for `clientShouldHydrate` (coming from the server), except:
    // - We keep fg('jfp-magma-force-react-hydrate-root') here for local dev convenience.
    // - Disable hydration when running on localhost:3443 (yarn start), because the front end will
    // 		almost always mismatch the server content from staging.
    if ((0, $i860n.fg)('jfp-magma-force-react-hydrate-root')) return true;
    // Defined in JiraParcelServer
    if (typeof window !== 'undefined' && window.location.host === 'localhost:3443') return false;
    if (typeof window !== 'undefined' && window.SPA_STATE?.clientShouldHydrate) return true;
    return false;
};
const $a39e107a2eb6edc5$export$6404c9565856d2f = ()=>{
    if (typeof window !== 'undefined' && window.SPA_STATE?.serverIsStreaming) return true;
    return false;
};
const $a39e107a2eb6edc5$var$hasAltFlag = (flagName)=>{
    try {
        if (typeof window !== 'undefined') {
            const altFlags = new URLSearchParams(window.location.search).get('alt-flags');
            return altFlags?.includes(flagName) ?? false;
        }
    } catch (e) {
    // ignore any error for alt-flags
    }
    return false;
};
const $a39e107a2eb6edc5$export$10e38d679c5a165c = (children, { isSsrHydrationEnabled: isSsrHydrationEnabled, isServerStreamingEnabled: isServerStreamingEnabled, container: container })=>{
    (0, $dgncT.initATLReactMetrics)();
    if ((0, $i860n.fg)('jfp-magma-ssr-hydration-debugger')) // eslint-disable-next-line no-console
    console.warn('\uD83D\uDC4BHey "jfp-magma-ssr-hydration-debugger" was replaced by ?alt-flags=hydration-debugger"');
    if (isServerStreamingEnabled) // With M1 of streaming, the client does not need to know that we're streaming, as we're practically returning the same output as with M1 streaming disabled.
    // We still need to enable the Streaming Advisory to ensure we render the Advisory on the client.
    // But it also ensures the client render tree is in sync with the SSR tree.
    (0, $ldgHZ.enableStreamingAdvisory)();
    if (isSsrHydrationEnabled) {
        (0, $TTcqD.setIsHydrationRenderMode)();
        $a39e107a2eb6edc5$var$activateReactPatches();
        if ($a39e107a2eb6edc5$var$hasAltFlag('hydration-debugger')) {
            (0, $6kmYA.installHydrationDebugger)(container);
            (0, $6kmYA.installSPADebuggingTools)();
        }
        (0, $l7jID.enableHydrationStatReporting)(container);
        // We wrap hydrateRoot in startTransition, in order to prevent state updates during hydration from breaking hydration. Instead deferring them to post-hydration.
        (0, $euxye.startTransition)(()=>{
            (0, $iiabj.hydrateRoot)(container, children, (0, $7gnyB.hydrationOptions));
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__HYDRATION_RECOVERABLE_ERRORS__ = window.__HYDRATION_RECOVERABLE_ERRORS__ ?? [];
    } else {
        if ($a39e107a2eb6edc5$var$hasAltFlag('hydration-debugger')) (0, $6kmYA.installSPADebuggingTools)();
        // If the route is not enabled for hydration but concurrent mode is enabled for this environment, render in concurrent mode
        const root = (0, $iiabj.createRoot)(container);
        root.render(children);
    }
};
const $a39e107a2eb6edc5$var$activateReactPatches = ()=>{
    const atl = (0, $dgncT.getATLReact)();
    atl.__ATL_SKIP_HAS_CONTEXT_CHANGED = true;
    atl.__ATL_CAPTURE_HYDRATION_ERROR_DETAILS = true;
    atl.__ATL_SYNC_HYDRATION_PRIORITY = (0, $i860n.fg)('jfp_magma_jira-react-hydration-lanes');
};

});
parcelRegister("iiabj", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $d511ce41cfb731e4$export$882461b6382ed46c, (v) => $d511ce41cfb731e4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $d511ce41cfb731e4$export$757ceba2d55c277e, (v) => $d511ce41cfb731e4$export$757ceba2d55c277e = v);
var $d511ce41cfb731e4$export$882461b6382ed46c;
var $d511ce41cfb731e4$export$757ceba2d55c277e;
'use strict';

var $85XPu = parcelRequire("85XPu");
var $d511ce41cfb731e4$var$i;
$d511ce41cfb731e4$export$882461b6382ed46c = $85XPu.createRoot;
$d511ce41cfb731e4$export$757ceba2d55c277e = $85XPu.hydrateRoot;

});

parcelRegister("qXQCT", function(module, exports) {
/* eslint-disable jira/filename-case */ function $2f459907013f4d20$export$ba5adf6be0dee098(injectPoint) {
    const windowWithHydrationHooks = injectPoint;
    windowWithHydrationHooks.__HYDRATION_ERRORS__ = [];
    windowWithHydrationHooks.__ATL_HYDRATION_HOOK = {
        report (...args) {
            windowWithHydrationHooks.__HYDRATION_ERRORS__?.push(args);
        }
    };
}

});

parcelRegister("7gnyB", function(module, exports) {
$parcel$export(module.exports, "hydrationOptions", () => $8044ed052118e48f$export$db3ef87a6e82f2be);

var $l7jID = parcelRequire("l7jID");

var $6t4Ql = parcelRequire("6t4Ql");

var $i860n = parcelRequire("i860n");

var $6CfY5 = parcelRequire("6CfY5");

var $f2wVS = parcelRequire("f2wVS");

var $fEmTm = parcelRequire("fEmTm");

var $gXtG2 = parcelRequire("gXtG2");
const $8044ed052118e48f$var$location = 'react-hydrate-root';
const $8044ed052118e48f$var$hydrationErrorFiltering = {
    logWarnings: true
};
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $8044ed052118e48f$var$hydrationErrorFiltering.logWarnings = true;
});
const $8044ed052118e48f$export$db3ef87a6e82f2be = {
    onRecoverableError: (untypedError, errorInfo)=>{
        if (errorInfo.digest === 'ignore') // the server has told us to ignore this error
        return;
        const error = $8044ed052118e48f$var$toTypedError(untypedError);
        const ownershipMetadata = $8044ed052118e48f$var$extractOwnershipMetadata(errorInfo);
        const routeMetadata = $8044ed052118e48f$var$getRouteMetadata();
        const hydrationErrorType = (0, $l7jID.classifyAsHydrationError)(error);
        if (hydrationErrorType !== 'warning' || $8044ed052118e48f$var$hydrationErrorFiltering.logWarnings) {
            // When cleaning up, replace with @atlassian/jira-coinflip depending on the desired rate
            if ((0, $i860n.fg)('jfp-magma-hydration-report-to-splunk')) $8044ed052118e48f$var$logToSplunk(error, errorInfo, {
                ...ownershipMetadata,
                ...routeMetadata
            });
            // When cleaning up, replace with @atlassian/jira-coinflip depending on the desired rate
            if ((0, $i860n.fg)('jfp-magma-hydration-report-to-sentry')) // Not passing in routeMetadata here because it's already implicitly captured in Sentry as userLocation
            (0, $fEmTm.captureException)($8044ed052118e48f$var$location, error, {
                ...errorInfo,
                ...ownershipMetadata
            });
            $8044ed052118e48f$var$hydrationErrorFiltering.logWarnings = hydrationErrorType !== 'warning';
        }
        (0, $l7jID.addErrorForHydrationStats)(error, errorInfo);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__HYDRATION_RECOVERABLE_ERRORS__ = window.__HYDRATION_RECOVERABLE_ERRORS__ ?? [];
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__HYDRATION_RECOVERABLE_ERRORS__.push({
            error: error,
            errorInfo: errorInfo,
            ownershipMetadata: ownershipMetadata,
            routeMetadata: routeMetadata,
            hydrationErrorType: hydrationErrorType
        });
    }
};
const $8044ed052118e48f$var$toTypedError = (untypedError)=>{
    if (untypedError instanceof Error) return untypedError;
    try {
        return new Error(`Unknown error occurred during hydration: ${JSON.stringify(untypedError)}`);
    } catch (e) {
        return new Error(String(untypedError));
    }
};
const $8044ed052118e48f$var$extractOwnershipMetadata = ({ componentStack: componentStack })=>{
    if (!componentStack) return {};
    const ownershipStack = (0, $6t4Ql.extractOwnershipStack)(componentStack);
    const result = {
        ownershipStack: JSON.stringify(ownershipStack)
    };
    const teamName = (0, $6t4Ql.getOwningTeam)(ownershipStack);
    if (teamName) result.teamName = teamName;
    const packageName = (0, $6t4Ql.getContainingPackageName)(ownershipStack);
    if (packageName) result.packageName = packageName;
    return result;
};
const $8044ed052118e48f$var$getRouteMetadata = ()=>{
    const routerState = (0, $f2wVS.getRouterState)();
    if (routerState?.route?.name) return {
        routeName: routerState.route.name
    };
    return {};
};
const $8044ed052118e48f$var$logToSplunk = (error, errorInfo, metadata)=>{
    const { componentStack: componentStack, digest: digest } = errorInfo;
    const event = {
        digest: digest,
        ...metadata
    };
    if (componentStack) {
        const lines = componentStack.trim().split('\n').map((line)=>line.trim());
        if (lines.length > 25) event.shortenedComponentStack = [
            ...lines.slice(0, 20),
            '...',
            ...lines.slice(-5)
        ].join('\n');
        else event.shortenedComponentStack = componentStack;
    }
    (0, $6CfY5.default).safeErrorWithoutCustomerData($8044ed052118e48f$var$location, `onRecoverableError: ${error.message}`, event);
};

});

parcelRegister("6kmYA", function(module, exports) {
$parcel$export(module.exports, "installSPADebuggingTools", () => $b9a8c2c9b81f2abe$export$83a6f982d57f7a94);
$parcel$export(module.exports, "installHydrationDebugger", () => $b9a8c2c9b81f2abe$export$4cf246e54510c01e);
/* eslint-disable jira/filename-case, no-console, jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/platform/no-direct-document-usage */ 
var $eCIK4 = parcelRequire("eCIK4");

var $TTcqD = parcelRequire("TTcqD");

var $kUkw0 = parcelRequire("kUkw0");

var $fngNu = parcelRequire("fngNu");

var $bmGm2 = parcelRequire("bmGm2");
const $b9a8c2c9b81f2abe$var$LOG_PREFIX = 'HYDRATION_DEBUGGER: ';
const $b9a8c2c9b81f2abe$var$highlight = (overlayContainer, target, colour, printReport)=>{
    if (overlayContainer.contains(target)) // Avoid infinite loop
    return;
    const { display: display } = window.getComputedStyle(target);
    let visibleTarget;
    if (display === 'contents') {
        const firstChild = [
            ...target.children
        ][0];
        if (firstChild instanceof HTMLElement) visibleTarget = firstChild;
        else visibleTarget = undefined;
    } else visibleTarget = target;
    if (!visibleTarget) return;
    const highlightElement = document.createElement('div');
    highlightElement.classList.add('hydration-overlay-target', colour);
    const { top: top, left: left, width: width, height: height } = visibleTarget.getBoundingClientRect();
    const { scrollY: scrollY, scrollX: scrollX } = window;
    Object.assign(highlightElement.style, {
        top: `${scrollY + top}px`,
        left: `${scrollX + left}px`,
        width: `${width}px`,
        height: `${height}px`,
        border: `1px solid ${colour}`
    });
    highlightElement.addEventListener('click', ()=>{
        printReport();
        highlightElement.remove();
    });
    overlayContainer.appendChild(highlightElement);
};
const $b9a8c2c9b81f2abe$var$addElementIgnores = [
    (element)=>element.dataset.testid === 'page-layout.root--skip-links-container',
    (element)=>document.querySelector('[data-testid="page-layout.root--skip-links-container"]')?.contains(element) ?? false,
    (element)=>element.tagName === 'STYLE'
];
const $b9a8c2c9b81f2abe$var$removeElementIgnores = [
    (element)=>element.nodeType === Node.COMMENT_NODE,
    (element)=>element.tagName === 'TEMPLATE'
];
const $b9a8c2c9b81f2abe$var$createOverlayContainer = ()=>{
    const overlayContainer = document.createElement('div');
    overlayContainer.setAttribute('id', 'hydration-debugger-overlay');
    const overlayStyles = document.createElement('style');
    overlayStyles.innerHTML = `
		.hydration-overlay-target {
			position: absolute;
			z-index: 1000;
			background-color: rgba(0, 0, 0, 0.1);
			cursor: crosshair;
		}
		.hydration-overlay-target.red:hover {
			background-color: red;
		}
		.hydration-overlay-target.orange:hover {
			background-color: orange;
		}
	`;
    overlayContainer.appendChild(overlayStyles);
    return overlayContainer;
};
const $b9a8c2c9b81f2abe$var$runOnHydrationCompletion = (onCompleted)=>{
    if ((0, $TTcqD.getIsHydrationInProgress)()) (0, $fngNu.callWhenIdle)(()=>$b9a8c2c9b81f2abe$var$runOnHydrationCompletion(onCompleted));
    else onCompleted();
};
const $b9a8c2c9b81f2abe$var$IGNORE_CHANGED_ATTRIBUTE_NAMES = [
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace'
];
const $b9a8c2c9b81f2abe$var$highlightChangesReportedByReact = (overlayContainer)=>{
    if (!window.__HYDRATION_ERRORS__) return;
    for (const err of window.__HYDRATION_ERRORS__){
        const [errorType, errorDetails] = err;
        const target = errorDetails.domElement;
        const debugArgs = [];
        if (target) {
            debugArgs.push(target);
            const fiber = (0, $bmGm2.getReactFiber)(target);
            const parentFiber = target.parentElement && (0, $bmGm2.getReactFiber)(target.parentElement);
            if (fiber) debugArgs.push('\n\t--> fiber:', fiber, 'debug info:', (0, $bmGm2.createFiberDebugObject)(fiber));
            else if (parentFiber) debugArgs.push('\n\t--> parent fiber:', parentFiber, 'debug info:', (0, $bmGm2.createFiberDebugObject)(parentFiber));
        }
        const report = (message, ...args)=>{
            console.log(`${$b9a8c2c9b81f2abe$var$LOG_PREFIX}${message}`, ...args);
        };
        const reportAttributeChange = (printReport)=>{
            printReport();
            $b9a8c2c9b81f2abe$var$highlight(overlayContainer, target, 'orange', printReport);
        };
        switch(errorType){
            case 'warnForPropDifference':
                {
                    const { serverValue: serverValue, clientValue: clientValue, propKey: propKey } = errorDetails;
                    if (!$b9a8c2c9b81f2abe$var$IGNORE_CHANGED_ATTRIBUTE_NAMES.includes(propKey)) reportAttributeChange(()=>report(`attribute "${propKey}" changed from serverValue=${JSON.stringify(serverValue)} to clientValue=${JSON.stringify(clientValue)} on element: `, ...debugArgs));
                    break;
                }
            case 'warnForExtraAttributes':
                for (const attributeName of errorDetails.attributeNames)if (!$b9a8c2c9b81f2abe$var$IGNORE_CHANGED_ATTRIBUTE_NAMES.includes(attributeName)) reportAttributeChange(()=>report(`attribute "${attributeName}" added to element: `, ...debugArgs));
                break;
            default:
                report(errorType, errorDetails);
                continue;
        }
    }
};
const $b9a8c2c9b81f2abe$export$83a6f982d57f7a94 = ()=>{
    // Expose for testing if debugger is active
    // @ts-expect-error TS2339: Property &#39;getPlaceholderMountTracker&#39; does not exist on type &#39;Window
    window.getPlaceholderMountTracker = (0, $kUkw0.getPlaceholderMountTracker);
};
const $b9a8c2c9b81f2abe$export$4cf246e54510c01e = (rootContainer)=>{
    const overlayContainer = $b9a8c2c9b81f2abe$var$createOverlayContainer();
    document.querySelector('body')?.appendChild(overlayContainer);
    const collectChangesAfterHydrationComplete = (0, $eCIK4.captureDocumentState)(rootContainer);
    const ssrHtml = rootContainer.outerHTML;
    $b9a8c2c9b81f2abe$var$runOnHydrationCompletion(()=>{
        const hydrationOutcomeStats = collectChangesAfterHydrationComplete();
        const outcomeFromErrors = [];
        if (window.__HYDRATION_RECOVERABLE_ERRORS__) outcomeFromErrors.push('\nHydration failure, errors reported to hydrateRoot#onRecoverableError:\n', window.__HYDRATION_RECOVERABLE_ERRORS__);
        else outcomeFromErrors.push('\nHydration success\n');
        console.log('====================================================================\n', `${$b9a8c2c9b81f2abe$var$LOG_PREFIX}\nOverall hydration stats:\n`, hydrationOutcomeStats, ...outcomeFromErrors, '\nInitial SSR HTML:\n', {
            get printSsrHtmlToConsole () {
                console.log($b9a8c2c9b81f2abe$var$LOG_PREFIX, ssrHtml);
                return 'SSR HTML printed to console';
            }
        }, '\n====================================================================');
        $b9a8c2c9b81f2abe$var$highlightChangesReportedByReact(overlayContainer);
    });
    let reportCount = 0;
    const callback = (mutations, observer)=>{
        if (reportCount > 100) {
            observer.disconnect();
            console.error(`${$b9a8c2c9b81f2abe$var$LOG_PREFIX}too many mutations, MutationObserver disconnected`);
            return;
        }
        // Unregister ourselves once hydration has completed across the whole page
        if (!(0, $TTcqD.getIsHydrationInProgress)()) // Disconnect and let this execution finish
        observer.disconnect();
        const report = (message, ...args)=>{
            console.log(`${$b9a8c2c9b81f2abe$var$LOG_PREFIX}${message}`, ...args);
            reportCount += 1;
        };
        for (const mutation of mutations)if (mutation.type === 'childList') {
            for (const added of mutation.addedNodes)if (added instanceof HTMLElement && $b9a8c2c9b81f2abe$var$addElementIgnores.every((predicate)=>!predicate(added))) report('element:', added, 'was added to parent:', mutation.target);
            for (const removed of mutation.removedNodes){
                const { target: target } = mutation;
                if (removed instanceof HTMLElement && target instanceof HTMLElement && $b9a8c2c9b81f2abe$var$removeElementIgnores.every((predicate)=>!predicate(removed))) {
                    const fiberDebugArgs = [];
                    const fiber = (0, $bmGm2.getReactFiber)(target);
                    if (fiber) fiberDebugArgs.push('\n\t--> removed at parent fiber:', fiber, 'debug info:', (0, $bmGm2.createFiberDebugObject)(fiber));
                    const printReport = ()=>report('element:', removed, 'was removed from parent:', target, ...fiberDebugArgs);
                    printReport();
                    $b9a8c2c9b81f2abe$var$highlight(overlayContainer, target, 'red', printReport);
                }
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(rootContainer, {
        subtree: true,
        childList: true
    });
};

});
parcelRegister("bmGm2", function(module, exports) {
$parcel$export(module.exports, "getReactFiber", () => $0f53cafe6e479448$export$1163150d62a90f1d);
$parcel$export(module.exports, "createFiberDebugObject", () => $0f53cafe6e479448$export$a4b64a7ba99ee084);
/* eslint-disable jira/filename-case, @typescript-eslint/consistent-type-assertions */ const $0f53cafe6e479448$export$1163150d62a90f1d = (element)=>{
    const fiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber'));
    if (!fiberKey) return null;
    return element[fiberKey] ?? null;
};
const $0f53cafe6e479448$var$getReturnStack = (fiber)=>{
    let next = fiber;
    const result = [];
    do {
        result.push(next);
        next = next.return;
    }while (next);
    return result;
};
const $0f53cafe6e479448$export$a4b64a7ba99ee084 = (fiber)=>{
    return {
        get renderStack () {
            return $0f53cafe6e479448$var$getReturnStack(fiber).map(({ _debugSource: _debugSource, elementType: elementType })=>{
                let sourceLocation;
                if (_debugSource) {
                    const { fileName: fileName, lineNumber: lineNumber, columnNumber: columnNumber } = _debugSource;
                    sourceLocation = `${fileName}:${lineNumber}:${columnNumber}`;
                } else sourceLocation = '(unknown source location)';
                return [
                    sourceLocation,
                    elementType
                ];
            });
        }
    };
};

});



parcelRegister("k1Xkv", function(module, exports) {
$parcel$export(module.exports, "initPlatformFeatureFlagsWithMetrics", () => $131105987376efae$export$8393a654105ebe54);
$parcel$export(module.exports, "verifyPlatformFeatureFlags", () => $131105987376efae$export$6fc20df9cca15b94);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $egspI = parcelRequire("egspI");

var $4yT7h = parcelRequire("4yT7h");

var $6Kdw4 = parcelRequire("6Kdw4");

var $fy2Lt = parcelRequire("fy2Lt");

var $i860n = parcelRequire("i860n");
const $131105987376efae$export$8393a654105ebe54 = async ()=>{
    (0, $fy2Lt.initPlatformFeatureFlags)((0, $4yT7h.visualRefreshResolverOverride));
    const analyticsClient = await (0, $6Kdw4.getAnalyticsWebClientPromise)();
    analyticsClient.getInstance().sendOperationalEvent({
        action: 'initialised',
        actionSubject: 'platformFeatureGates',
        source: 'jiraSpaEntrypoint'
    });
};
const $131105987376efae$export$6fc20df9cca15b94 = ()=>{
    if ((0, $i860n.fg)('jfp-magma-always-on-fg-test') !== true || (0, $egspI.fg)('jfp-magma-always-on-fg-test') !== true) (0, $hFtK7.fireErrorAnalytics)({
        error: new Error('Always on feature flag mismatch'),
        meta: {
            id: 'init-platform-feature-flags-always-on-mismatch',
            packageName: 'jira-entry',
            teamName: 'JFP - Nike'
        }
    });
    if ((0, $i860n.fg)('jfp-magma-always-off-fg-test') !== false || (0, $egspI.fg)('jfp-magma-always-off-fg-test') !== false) (0, $hFtK7.fireErrorAnalytics)({
        error: new Error('Always off feature flag mismatch'),
        meta: {
            id: 'init-platform-feature-flags-always-off-mismatch',
            packageName: 'jira-entry',
            teamName: 'JFP - Nike'
        }
    });
};

});
parcelRegister("4yT7h", function(module, exports) {
$parcel$export(module.exports, "visualRefreshResolverOverride", () => $e0f517953b143f18$export$73a94df81a7c0f2c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $e0f517953b143f18$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh'
];
const $e0f517953b143f18$export$73a94df81a7c0f2c = [
    (flagKey)=>$e0f517953b143f18$var$visualRefreshPlatformFlags.includes(flagKey),
    ()=>true
];

});

parcelRegister("fy2Lt", function(module, exports) {
$parcel$export(module.exports, "initPlatformFeatureFlags", () => $93776aad67dd2395$export$2d291317456ada16);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $egspI = parcelRequire("egspI");

var $i860n = parcelRequire("i860n");
const $93776aad67dd2395$export$2d291317456ada16 = ([isOverride, resolver])=>{
    (0, $egspI.setBooleanFeatureFlagResolver)((flagKey)=>// disable existence check as platform feature >flags< might not be gates
        (0, $i860n.withoutFeatureExistenceCheck)(()=>isOverride(flagKey) ? resolver(flagKey) : (0, $i860n.fg)(flagKey)));
};

});



parcelRegister("d0GZJ", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $3MtiC = parcelRequire("3MtiC");
module.exports = Object.assign({}, $3MtiC, {
    themed: (propsToValues)=>(props)=>{
            const vals = typeof propsToValues === 'function' ? propsToValues(props) : propsToValues;
            return vals.light;
        }
});
if ($3MtiC.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

$parcel$global.rwr("hy8Nn", () => { /* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/entry/add-jira-vendor-imports
parcelRequire("lzmuA");
parcelRequire("2IWJd");

var $6xuJS = parcelRequire("6xuJS");

var $cGZ2T = parcelRequire("cGZ2T");

var $77BpO = parcelRequire("77BpO");
(0, $6xuJS.setMark)('JIRA_SPA_ENTRY_LOADED');
(0, $77BpO.startJiraSpa)((0, $cGZ2T.getSpaRoutes));
 }, ["5qC72","elvlF","a36Wj","ay8Nt","f15cT","iDHjd","4Smn9","hc93Z","iZe2c","gCScl","15ZAZ","eAoL3","1aRRK","faPKS","hqTBH"].concat([...(globalThis.__MCOND && globalThis.__MCOND('navx_onboarding_universal_create_in_jira') ? ["27fFF"] : ["hJyTq"]),...(globalThis.__MCOND && globalThis.__MCOND('navx-global-side-nav') ? ["7FBcr","4Smn9","hc93Z","7FBcr","4Smn9","hc93Z"] : ["54wGu","4Smn9","hc93Z","54wGu","4Smn9","hc93Z"])]));
/* eslint-disable jira/filename-case */ // error types
const $2e5f0c6757041651$export$6c8cb487d6ffc522 = 'QueryError';
const $2e5f0c6757041651$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $2e5f0c6757041651$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $2e5f0c6757041651$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $2e5f0c6757041651$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $2e5f0c6757041651$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $2e5f0c6757041651$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $2e5f0c6757041651$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $2e5f0c6757041651$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $2e5f0c6757041651$export$7b20493af2e93ea0 = 'CASE_MANAGEMENT';
const $2e5f0c6757041651$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $2e5f0c6757041651$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $2e5f0c6757041651$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


$parcel$global.rlb("hy8Nn")
//# sourceMappingURL=jira-spa.b3165dcd.js.map
